// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5DEId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "store", ()=>store);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _vega = require("vega");
var _vegaLite = require("vega-lite");
var _monacoJs = require("./utils/monaco.js");
var _monacoJsDefault = parcelHelpers.interopDefault(_monacoJs);
var _appShellJs = require("./components/app-shell.js");
var _appShellJsDefault = parcelHelpers.interopDefault(_appShellJs);
var _configureStoreJs = require("./store/configure-store.js");
var _configureStoreJsDefault = parcelHelpers.interopDefault(_configureStoreJs);
if (typeof window !== 'undefined') {
    const w = window;
    w.VEGA_DEBUG = w.VEGA_DEBUG ?? {};
    w.VEGA_DEBUG = {};
    w.VEGA_DEBUG.vega = _vega;
    w.VEGA_DEBUG.vegaLite = _vegaLite;
    w.VEGA_DEBUG.VEGA_VERSION = _vega.version;
    w.VEGA_DEBUG.VEGA_LITE_VERSION = _vegaLite.version;
}
(0, _monacoJsDefault.default)();
const store = (0, _configureStoreJsDefault.default)();
// Now that redux and react-router have been configured, we can render the
// React application to the DOM!
_reactDom.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
    store: store,
    children: /*#__PURE__*/ _react.createElement((0, _reactRouterDom.HashRouter), {}, /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appShellJsDefault.default), {}))
}), document.getElementById('root'));
/* tslint:disable */ console.log('%cWelcome to the Vega-Editor!', 'font-size: 16px; font-weight: bold;');
console.log('You can access the Vega view with VEGA_DEBUG. Learn more at https://vega.github.io/vega/docs/api/debugging/.'); /* tslint:enable */ 

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-dom":"82aNB","react-redux":"dwYd3","react-router-dom":"b9X5n","vega":"jxCvh","vega-lite":"eTD5L","./utils/monaco.js":"lSYby","./components/app-shell.js":"cQ16f","./store/configure-store.js":"jQ5lq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"84Frb"}],"84Frb":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
require("ea59cf80247f96ff");
var f = require("3fd2a064dc1f3641"), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: m.current
    };
}
exports.jsx = q;
exports.jsxs = q;

},{"ea59cf80247f96ff":"3ALpK","3fd2a064dc1f3641":"bmhQu"}],"3ALpK":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7cX1V"}],"7cX1V":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = require("f790cf940e488cc5"), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element");
    p = w("react.portal");
    exports.Fragment = w("react.fragment");
    exports.StrictMode = w("react.strict_mode");
    exports.Profiler = w("react.profiler");
    q = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    exports.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, B = {};
function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
var F = E.prototype = new D;
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
    current: null
}, H = Object.prototype.hasOwnProperty, I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: G.current
    };
}
function K(a, b) {
    return {
        $$typeof: n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === n;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var M = /\/+/g;
function N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case n:
                case p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a) {
        return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + N(k, g);
        h += O(k, b, c, f, d);
    }
    else if (f = y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var R = {
    current: null
};
function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
}
var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: P,
    forEach: function(a, b, c) {
        P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!L(a)) throw Error(z(143));
        return a;
    }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: q,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: t,
        render: a
    };
};
exports.isValidElement = L;
exports.lazy = function(a) {
    return {
        $$typeof: v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: Q
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return S().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return S().useRef(a);
};
exports.useState = function(a) {
    return S().useState(a);
};
exports.version = "17.0.2";

},{"f790cf940e488cc5":"3ALpK"}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"cfGqX"}],"cfGqX":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), m = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = m({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = m({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        r.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    m(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = m({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = m({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = m({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = m({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = m({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = m({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = m({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return m({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = m({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = m({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new aa.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = m({}, e, {
                    value: void 0
                });
                d = m({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = m({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

},{"5393afc8c463ef07":"bmhQu","dc13beaf0535b548":"3ALpK","ece50e903283a22f":"dHubo"}],"dHubo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"cUjz3"}],"cUjz3":[function(require,module,exports,__globalThis) {
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f, g, h, k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null, u = null, w = function() {
        if (null !== t) try {
            var a = exports.unstable_now();
            t(!0, a);
            t = null;
        } catch (b) {
            throw setTimeout(w, 0), b;
        }
    };
    f = function(a) {
        null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
    };
    g = function(a, b) {
        u = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
        return !1;
    };
    k = exports.unstable_forceFrameRate = function() {};
} else {
    var x = window.setTimeout, y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A = !1, B = null, C = -1, D = 5, E = 0;
    exports.unstable_shouldYield = function() {
        return exports.unstable_now() >= E;
    };
    k = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var F = new MessageChannel, G = F.port2;
    F.port1.onmessage = function() {
        if (null !== B) {
            var a = exports.unstable_now();
            E = a + D;
            try {
                B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
            } catch (b) {
                throw G.postMessage(null), b;
            }
        } else A = !1;
    };
    f = function(a) {
        B = a;
        A || (A = !0, G.postMessage(null));
    };
    g = function(a, b) {
        C = x(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        y(C);
        C = -1;
    };
}
function H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = !1, R = !1, S = !1;
function T(a) {
    for(var b = J(M); null !== b;){
        if (null === b.callback) K(M);
        else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
        else break;
        b = J(M);
    }
}
function U(a) {
    S = !1;
    T(a);
    if (!R) {
        if (null !== J(L)) R = !0, f(V);
        else {
            var b = J(M);
            null !== b && g(U, b.startTime - a);
        }
    }
}
function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;
    try {
        T(b);
        for(O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());){
            var d = O.callback;
            if ("function" === typeof d) {
                O.callback = null;
                P = O.priorityLevel;
                var e = d(O.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? O.callback = e : O === J(L) && K(L);
                T(b);
            } else K(L);
            O = J(L);
        }
        if (null !== O) var m = !0;
        else {
            var n = J(M);
            null !== n && g(U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        O = null, P = c, Q = !1;
    }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    R || Q || (R = !0, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return P;
};
exports.unstable_getFirstCallbackNode = function() {
    return J(L);
};
exports.unstable_next = function(a) {
    switch(P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = P;
    }
    var c = P;
    P = b;
    try {
        return a();
    } finally{
        P = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = P;
    P = a;
    try {
        return b();
    } finally{
        P = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, f(V)));
    return a;
};
exports.unstable_wrapCallback = function(a) {
    var b = P;
    return function() {
        var c = P;
        P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            P = c;
        }
    };
};

},{}],"dwYd3":[function(require,module,exports,__globalThis) {
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>(0, _reactBatchedUpdates.unstable_batchedUpdates));
var _shim = require("use-sync-external-store/shim");
var _withSelector = require("use-sync-external-store/shim/with-selector");
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch");
var _useSelector = require("./hooks/useSelector");
var _connect = require("./components/connect");
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
(0, _useSelector.initializeUseSelector)((0, _withSelector.useSyncExternalStoreWithSelector));
(0, _connect.initializeConnect)((0, _shim.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"use-sync-external-store/shim":"6U7cH","use-sync-external-store/shim/with-selector":"j1vWm","./utils/reactBatchedUpdates":"9RVff","./utils/batch":"bxp2J","./hooks/useSelector":"esxfb","./components/connect":"8imI1","./exports":"aXg5M","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6U7cH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"8qQTW"}],"8qQTW":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"bmhQu"}],"j1vWm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("646f3adc157912dd");

},{"646f3adc157912dd":"hRy5D"}],"hRy5D":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var h = require("2c99ce9e3cb5debf"), n = require("969be431eae4eb00");
function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if (q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = r(a, c[0], c[1]);
    u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    w(d);
    return d;
};

},{"2c99ce9e3cb5debf":"bmhQu","969be431eae4eb00":"6U7cH"}],"9RVff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>(0, _reactDom.unstable_batchedUpdates));
var _reactDom = require("react-dom");

},{"react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"bxp2J":[function(require,module,exports,__globalThis) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", ()=>setBatch);
parcelHelpers.export(exports, "getBatch", ()=>getBatch);
function defaultNoopBatch(callback) {
    callback();
}
let batch = defaultNoopBatch; // Allow injecting another batching function later
const setBatch = (newBatch)=>batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const getBatch = ()=>batch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esxfb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeUseSelector", ()=>initializeUseSelector);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _context = require("../components/Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
let useSyncExternalStoreWithSelector = (0, _useSyncExternalStore.notInitialized);
const initializeUseSelector = (fn)=>{
    useSyncExternalStoreWithSelector = fn;
};
const refEquality = (a, b)=>a === b;
function createSelectorHook(context = (0, _context.ReactReduxContext)) {
    const useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : (0, _useReduxContext.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn = refEquality, stabilityCheck, noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store, subscription, getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, _react.useRef)(true);
        const wrappedSelector = (0, _react.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
const useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"bmhQu","./useReduxContext":"dzzCk","../components/Context":"8Guqp","../utils/useSyncExternalStore":"fVJrl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dzzCk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createReduxContextHook", ()=>createReduxContextHook);
parcelHelpers.export(exports, "useReduxContext", ()=>useReduxContext);
var _react = require("react");
var _context = require("../components/Context");
function createReduxContextHook(context = (0, _context.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, _react.useContext)(context);
        return contextValue;
    };
}
const useReduxContext = /*#__PURE__*/ createReduxContextHook();

},{"react":"bmhQu","../components/Context":"8Guqp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Guqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
var _react = require("react");
const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _gT$ContextKey;
    if (!_react.createContext) return {};
    const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
    let realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
const ReactReduxContext = /*#__PURE__*/ getContext();
exports.default = ReactReduxContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fVJrl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notInitialized", ()=>notInitialized);
const notInitialized = ()=>{
    throw new Error('uSES not initialized!');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8imI1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeConnect", ()=>initializeConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */ var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactIs = require("react-is");
var _selectorFactory = require("../connect/selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _mapDispatchToProps = require("../connect/mapDispatchToProps");
var _mapStateToProps = require("../connect/mapStateToProps");
var _mergeProps = require("../connect/mergeProps");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _context = require("./Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
const _excluded = [
    "reactReduxForwardedRef"
];
let useSyncExternalStore = (0, _useSyncExternalStore.notInitialized);
const initializeConnect = (fn)=>{
    useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const EMPTY_ARRAY = [
    null,
    0
];
const NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const initStateUpdates = ()=>EMPTY_ARRAY;
function strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = (0, _shallowEqualDefault.default), areStatePropsEqual = (0, _shallowEqualDefault.default), areMergedPropsEqual = (0, _shallowEqualDefault.default), // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = (0, _context.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, _mapStateToProps.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, _mapDispatchToProps.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, _mergeProps.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = _react.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef } = props, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = _react.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, _reactIs.isContextConsumer)(/*#__PURE__*/ _react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = _react.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = _react.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, _selectorFactoryDefault.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = _react.useMemo(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = _react.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = _react.useRef();
            const lastWrapperProps = _react.useRef(wrapperProps);
            const childPropsFromStoreUpdate = _react.useRef();
            const renderIsScheduled = _react.useRef(false);
            const isProcessingDispatch = _react.useRef(false);
            const isMounted = _react.useRef(false);
            const latestSubscriptionCallbackError = _react.useRef();
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = _react.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = _react.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = _react.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                _react.createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = _react.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = _react.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ _react.createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
exports.default = connect;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","hoist-non-react-statics":"ldTzE","react":"bmhQu","react-is":"9B5cV","../connect/selectorFactory":"4NnTj","../connect/mapDispatchToProps":"883jb","../connect/mapStateToProps":"5kbSW","../connect/mergeProps":"3W0Tf","../utils/Subscription":"eDs6x","../utils/useIsomorphicLayoutEffect":"36R9V","../utils/shallowEqual":"hOxgP","../utils/warning":"deYG9","./Context":"8Guqp","../utils/useSyncExternalStore":"fVJrl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"85Hd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ds1mq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ldTzE":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"m2UGx"}],"m2UGx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"aEfEd"}],"aEfEd":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"9B5cV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c09df6e873313925");

},{"c09df6e873313925":"mcIig"}],"mcIig":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"4NnTj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
const _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref) {
    let { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _ref, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","./verifySubselectors":"cXGZ6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cXGZ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, _warningDefault.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, 'mapStateToProps');
    verify(mapDispatchToProps, 'mapDispatchToProps');
    verify(mergeProps, 'mergeProps');
}

},{"../utils/warning":"deYG9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"deYG9":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"883jb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToPropsFactory", ()=>mapDispatchToPropsFactory);
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)((dispatch)=>(0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, _invalidArgFactory.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

},{"../utils/bindActionCreators":"9Q91U","./wrapMapToProps":"fFbQG","./invalidArgFactory":"drRfo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Q91U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fFbQG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"e7vK7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e7vK7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

},{"./isPlainObject":"43cR4","./warning":"deYG9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"43cR4":[function(require,module,exports,__globalThis) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"drRfo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidArgFactory", ()=>createInvalidArgFactory);
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5kbSW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToPropsFactory", ()=>mapStateToPropsFactory);
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, _invalidArgFactory.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

},{"./wrapMapToProps":"fFbQG","./invalidArgFactory":"drRfo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3W0Tf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "mergePropsFactory", ()=>mergePropsFactory);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
var _invalidArgFactory = require("./invalidArgFactory");
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : (0, _invalidArgFactory.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

},{"@babel/runtime/helpers/esm/extends":"85Hd3","../utils/verifyPlainObject":"e7vK7","./invalidArgFactory":"drRfo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eDs6x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", ()=>createSubscription);
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    const batch = (0, _batch.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

},{"./batch":"bxp2J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"36R9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect = canUseDOM ? _react.useLayoutEffect : _react.useEffect;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hOxgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aXg5M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "ReactReduxContext", ()=>(0, _context.ReactReduxContext));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
parcelHelpers.export(exports, "useDispatch", ()=>(0, _useDispatch.useDispatch));
parcelHelpers.export(exports, "createDispatchHook", ()=>(0, _useDispatch.createDispatchHook));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "createSelectorHook", ()=>(0, _useSelector.createSelectorHook));
parcelHelpers.export(exports, "useStore", ()=>(0, _useStore.useStore));
parcelHelpers.export(exports, "createStoreHook", ()=>(0, _useStore.createStoreHook));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connect = require("./components/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _context = require("./components/Context");
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./components/Provider":"59LZH","./components/connect":"8imI1","./components/Context":"8Guqp","./hooks/useDispatch":"9HUR1","./hooks/useSelector":"esxfb","./hooks/useStore":"aMit3","./utils/shallowEqual":"hOxgP","./types":"chB5X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"59LZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider({ store, context, children, serverState, stabilityCheck = 'once', noopCheck = 'once' }) {
    const contextValue = _react.useMemo(()=>{
        const subscription = (0, _subscription.createSubscription)(store);
        return {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck,
            noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = _react.useMemo(()=>store.getState(), [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, _context.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"bmhQu","./Context":"8Guqp","../utils/Subscription":"eDs6x","../utils/useIsomorphicLayoutEffect":"36R9V","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9HUR1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context = (0, _context.ReactReduxContext)) {
    const useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"8Guqp","./useStore":"aMit3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMit3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context = (0, _context.ReactReduxContext)) {
    const useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : (0, _useReduxContext.createReduxContextHook)(context);
    return function useStore() {
        const { store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const useStore = /*#__PURE__*/ createStoreHook();

},{"../components/Context":"8Guqp","./useReduxContext":"dzzCk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"chB5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b9X5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"ditZI","@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","history":"buZIi","prop-types":"gLXGb","tiny-warning":"hu9ef","@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","tiny-invariant":"eQQrt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ditZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","prop-types":"gLXGb","history":"kzOgV","tiny-warning":"hu9ef","tiny-invariant":"eQQrt","@babel/runtime/helpers/esm/extends":"85Hd3","path-to-regexp":"h4pLf","react-is":"m2UGx","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","hoist-non-react-statics":"ldTzE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJ1FM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9xLGZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9xLGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gLXGb":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"cW0bY"}],"cW0bY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"6JNoQ"}],"6JNoQ":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"kzOgV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"85Hd3","resolve-pathname":"4Rnhm","value-equal":"a3ABJ","tiny-warning":"hu9ef","tiny-invariant":"eQQrt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Rnhm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3ABJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hu9ef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eQQrt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4pLf":[function(require,module,exports,__globalThis) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"6pWHT"}],"6pWHT":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"buZIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"85Hd3","resolve-pathname":"4Rnhm","value-equal":"a3ABJ","tiny-warning":"hu9ef","tiny-invariant":"eQQrt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jxCvh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dataflow", ()=>(0, _vegaDataflow.Dataflow));
parcelHelpers.export(exports, "EventStream", ()=>(0, _vegaDataflow.EventStream));
parcelHelpers.export(exports, "MultiPulse", ()=>(0, _vegaDataflow.MultiPulse));
parcelHelpers.export(exports, "Operator", ()=>(0, _vegaDataflow.Operator));
parcelHelpers.export(exports, "Parameters", ()=>(0, _vegaDataflow.Parameters));
parcelHelpers.export(exports, "Pulse", ()=>(0, _vegaDataflow.Pulse));
parcelHelpers.export(exports, "Transform", ()=>(0, _vegaDataflow.Transform));
parcelHelpers.export(exports, "changeset", ()=>(0, _vegaDataflow.changeset));
parcelHelpers.export(exports, "definition", ()=>(0, _vegaDataflow.definition));
parcelHelpers.export(exports, "ingest", ()=>(0, _vegaDataflow.ingest));
parcelHelpers.export(exports, "isTuple", ()=>(0, _vegaDataflow.isTuple));
parcelHelpers.export(exports, "transform", ()=>(0, _vegaDataflow.transform));
parcelHelpers.export(exports, "transforms", ()=>(0, _vegaDataflow.transforms));
parcelHelpers.export(exports, "tupleid", ()=>(0, _vegaDataflow.tupleid));
parcelHelpers.export(exports, "interpolate", ()=>(0, _vegaScale.interpolate));
parcelHelpers.export(exports, "interpolateColors", ()=>(0, _vegaScale.interpolateColors));
parcelHelpers.export(exports, "interpolateRange", ()=>(0, _vegaScale.interpolateRange));
parcelHelpers.export(exports, "quantizeInterpolator", ()=>(0, _vegaScale.quantizeInterpolator));
parcelHelpers.export(exports, "scale", ()=>(0, _vegaScale.scale));
parcelHelpers.export(exports, "scheme", ()=>(0, _vegaScale.scheme));
parcelHelpers.export(exports, "projection", ()=>(0, _vegaProjection.projection));
parcelHelpers.export(exports, "View", ()=>(0, _vegaView.View));
parcelHelpers.export(exports, "defaultLocale", ()=>(0, _vegaFormat.defaultLocale));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _vegaFormat.numberFormatDefaultLocale));
parcelHelpers.export(exports, "locale", ()=>(0, _vegaFormat.locale));
parcelHelpers.export(exports, "resetDefaultLocale", ()=>(0, _vegaFormat.resetDefaultLocale));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _vegaFormat.timeFormatDefaultLocale));
parcelHelpers.export(exports, "expressionFunction", ()=>(0, _vegaFunctions.expressionFunction));
parcelHelpers.export(exports, "parse", ()=>(0, _vegaParser.parse));
parcelHelpers.export(exports, "runtimeContext", ()=>(0, _vegaRuntime.context));
parcelHelpers.export(exports, "codegenExpression", ()=>(0, _vegaExpression.codegenExpression));
parcelHelpers.export(exports, "parseExpression", ()=>(0, _vegaExpression.parseExpression));
parcelHelpers.export(exports, "parseSelector", ()=>(0, _vegaEventSelector.parseSelector));
parcelHelpers.export(exports, "version", ()=>version);
var _vegaUtil = require("vega-util");
parcelHelpers.exportAll(_vegaUtil, exports);
var _vegaDataflow = require("vega-dataflow");
var _vegaTransforms = require("vega-transforms");
var _vegaViewTransforms = require("vega-view-transforms");
var _vegaEncode = require("vega-encode");
var _vegaGeo = require("vega-geo");
var _vegaForce = require("vega-force");
var _vegaHierarchy = require("vega-hierarchy");
var _vegaLabel = require("vega-label");
var _vegaRegression = require("vega-regression");
var _vegaVoronoi = require("vega-voronoi");
var _vegaWordcloud = require("vega-wordcloud");
var _vegaCrossfilter = require("vega-crossfilter");
var _vegaStatistics = require("vega-statistics");
parcelHelpers.exportAll(_vegaStatistics, exports);
var _vegaTime = require("vega-time");
parcelHelpers.exportAll(_vegaTime, exports);
var _vegaLoader = require("vega-loader");
parcelHelpers.exportAll(_vegaLoader, exports);
var _vegaScenegraph = require("vega-scenegraph");
parcelHelpers.exportAll(_vegaScenegraph, exports);
var _vegaScale = require("vega-scale");
var _vegaProjection = require("vega-projection");
var _vegaView = require("vega-view");
var _vegaFormat = require("vega-format");
var _vegaFunctions = require("vega-functions");
var _vegaParser = require("vega-parser");
var _vegaRuntime = require("vega-runtime");
var _vegaExpression = require("vega-expression");
var _vegaEventSelector = require("vega-event-selector");
var version$1 = "6.1.2";
// -- Transforms -----
(0, _vegaUtil.extend)((0, _vegaDataflow.transforms), _vegaTransforms, _vegaViewTransforms, _vegaEncode, _vegaGeo, _vegaForce, _vegaLabel, _vegaHierarchy, _vegaRegression, _vegaVoronoi, _vegaWordcloud, _vegaCrossfilter);
const version = version$1;

},{"vega-util":"kncZn","vega-dataflow":"eoU45","vega-transforms":"jf17R","vega-view-transforms":"6M7us","vega-encode":"gaxHC","vega-geo":"eXHJh","vega-force":"gvunA","vega-hierarchy":"i90iv","vega-label":"527mi","vega-regression":"3UzsD","vega-voronoi":"02vkO","vega-wordcloud":"6hmHB","vega-crossfilter":"9Y9pC","vega-statistics":"6sdPC","vega-time":"c8K2C","vega-loader":"btcyl","vega-scenegraph":"fdlnS","vega-scale":"fMau0","vega-projection":"d411C","vega-view":"1x0KD","vega-format":"er6y3","vega-functions":"l0VB3","vega-parser":"3c3BX","vega-runtime":"89vAE","vega-expression":"4bIBh","vega-event-selector":"4BhtH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kncZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Debug", ()=>Debug);
parcelHelpers.export(exports, "Error", ()=>Error$1);
parcelHelpers.export(exports, "Info", ()=>Info);
parcelHelpers.export(exports, "None", ()=>None);
parcelHelpers.export(exports, "Warn", ()=>Warn);
parcelHelpers.export(exports, "accessor", ()=>accessor);
parcelHelpers.export(exports, "accessorFields", ()=>accessorFields);
parcelHelpers.export(exports, "accessorName", ()=>accessorName);
parcelHelpers.export(exports, "array", ()=>array);
parcelHelpers.export(exports, "ascending", ()=>ascending);
parcelHelpers.export(exports, "clampRange", ()=>clampRange);
parcelHelpers.export(exports, "compare", ()=>compare);
parcelHelpers.export(exports, "constant", ()=>constant);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "extent", ()=>extent);
parcelHelpers.export(exports, "extentIndex", ()=>extentIndex);
parcelHelpers.export(exports, "falsy", ()=>falsy);
parcelHelpers.export(exports, "fastmap", ()=>fastmap);
parcelHelpers.export(exports, "field", ()=>field);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "hasOwnProperty", ()=>has);
parcelHelpers.export(exports, "id", ()=>id);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "inherits", ()=>inherits);
parcelHelpers.export(exports, "inrange", ()=>inrange);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "key", ()=>key);
parcelHelpers.export(exports, "lerp", ()=>lerp);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "lruCache", ()=>lruCache);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
parcelHelpers.export(exports, "one", ()=>one);
parcelHelpers.export(exports, "pad", ()=>pad);
parcelHelpers.export(exports, "panLinear", ()=>panLinear);
parcelHelpers.export(exports, "panLog", ()=>panLog);
parcelHelpers.export(exports, "panPow", ()=>panPow);
parcelHelpers.export(exports, "panSymlog", ()=>panSymlog);
parcelHelpers.export(exports, "peek", ()=>peek);
parcelHelpers.export(exports, "quarter", ()=>quarter);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "span", ()=>span);
parcelHelpers.export(exports, "splitAccessPath", ()=>splitAccessPath);
parcelHelpers.export(exports, "stringValue", ()=>$);
parcelHelpers.export(exports, "toBoolean", ()=>toBoolean);
parcelHelpers.export(exports, "toDate", ()=>toDate);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toSet", ()=>toSet);
parcelHelpers.export(exports, "toString", ()=>toString);
parcelHelpers.export(exports, "truncate", ()=>truncate);
parcelHelpers.export(exports, "truthy", ()=>truthy);
parcelHelpers.export(exports, "utcquarter", ()=>utcquarter);
parcelHelpers.export(exports, "visitArray", ()=>visitArray);
parcelHelpers.export(exports, "writeConfig", ()=>writeConfig);
parcelHelpers.export(exports, "zero", ()=>zero);
parcelHelpers.export(exports, "zoomLinear", ()=>zoomLinear);
parcelHelpers.export(exports, "zoomLog", ()=>zoomLog);
parcelHelpers.export(exports, "zoomPow", ()=>zoomPow);
parcelHelpers.export(exports, "zoomSymlog", ()=>zoomSymlog);
function accessor(fn, fields, name) {
    fn.fields = fields || [];
    fn.fname = name;
    return fn;
}
function accessorName(fn) {
    return fn == null ? null : fn.fname;
}
function accessorFields(fn) {
    return fn == null ? null : fn.fields;
}
function getter(path) {
    return path.length === 1 ? get1(path[0]) : getN(path);
}
const get1 = (field)=>function(obj) {
        return obj[field];
    };
const getN = (path)=>{
    const len = path.length;
    return function(obj) {
        for(let i = 0; i < len; ++i)obj = obj[path[i]];
        return obj;
    };
};
function error(message) {
    throw Error(message);
}
function splitAccessPath(p) {
    const path = [], n = p.length;
    let q = null, b = 0, s = '', i, j, c;
    p = p + '';
    function push() {
        path.push(s + p.substring(i, j));
        s = '';
        i = j + 1;
    }
    for(i = j = 0; j < n; ++j){
        c = p[j];
        if (c === '\\') {
            s += p.substring(i, j++);
            i = j;
        } else if (c === q) {
            push();
            q = null;
            b = -1;
        } else if (q) continue;
        else if (i === b && c === '"') {
            i = j + 1;
            q = c;
        } else if (i === b && c === "'") {
            i = j + 1;
            q = c;
        } else if (c === '.' && !b) {
            if (j > i) push();
            else i = j + 1;
        } else if (c === '[') {
            if (j > i) push();
            b = i = j + 1;
        } else if (c === ']') {
            if (!b) error('Access path missing open bracket: ' + p);
            if (b > 0) push();
            b = 0;
            i = j + 1;
        }
    }
    if (b) error('Access path missing closing bracket: ' + p);
    if (q) error('Access path missing closing quote: ' + p);
    if (j > i) {
        j++;
        push();
    }
    return path;
}
function field(field, name, opt) {
    const path = splitAccessPath(field);
    field = path.length === 1 ? path[0] : field;
    return accessor((opt && opt.get || getter)(path), [
        field
    ], name || field);
}
const id = field('id');
const identity = accessor((_)=>_, [], 'identity');
const zero = accessor(()=>0, [], 'zero');
const one = accessor(()=>1, [], 'one');
const truthy = accessor(()=>true, [], 'true');
const falsy = accessor(()=>false, [], 'false');
function log$1(method, level, input) {
    const args = [
        level
    ].concat([].slice.call(input));
    console[method].apply(console, args); // eslint-disable-line no-console
}
const None = 0;
const Error$1 = 1;
const Warn = 2;
const Info = 3;
const Debug = 4;
function logger(_, method) {
    let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : log$1;
    let level = _ || None;
    return {
        level (_) {
            if (arguments.length) {
                level = +_;
                return this;
            } else return level;
        },
        error () {
            if (level >= Error$1) handler(method || 'error', 'ERROR', arguments);
            return this;
        },
        warn () {
            if (level >= Warn) handler(method || 'warn', 'WARN', arguments);
            return this;
        },
        info () {
            if (level >= Info) handler(method || 'log', 'INFO', arguments);
            return this;
        },
        debug () {
            if (level >= Debug) handler(method || 'log', 'DEBUG', arguments);
            return this;
        }
    };
}
var isArray = Array.isArray;
function isObject(_) {
    return _ === Object(_);
}
const isLegalKey = (key)=>key !== '__proto__';
function mergeConfig() {
    for(var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++)configs[_key] = arguments[_key];
    return configs.reduce((out, source)=>{
        for(const key in source)if (key === 'signals') // for signals, we merge the signals arrays
        // source signals take precedence over
        // existing signals with the same name
        out.signals = mergeNamed(out.signals, source.signals);
        else {
            // otherwise, merge objects subject to recursion constraints
            // for legend block, recurse for the layout entry only
            // for style block, recurse for all properties
            // otherwise, no recursion: objects overwrite, no merging
            const r = key === 'legend' ? {
                layout: 1
            } : key === 'style' ? true : null;
            writeConfig(out, key, source[key], r);
        }
        return out;
    }, {});
}
function writeConfig(output, key, value, recurse) {
    if (!isLegalKey(key)) return;
    let k, o;
    if (isObject(value) && !isArray(value)) {
        o = isObject(output[key]) ? output[key] : output[key] = {};
        for(k in value){
            if (recurse && (recurse === true || recurse[k])) writeConfig(o, k, value[k]);
            else if (isLegalKey(k)) o[k] = value[k];
        }
    } else output[key] = value;
}
function mergeNamed(a, b) {
    if (a == null) return b;
    const map = {}, out = [];
    function add(_) {
        if (!map[_.name]) {
            map[_.name] = 1;
            out.push(_);
        }
    }
    b.forEach(add);
    a.forEach(add);
    return out;
}
function peek(array) {
    return array[array.length - 1];
}
function toNumber(_) {
    return _ == null || _ === '' ? null : +_;
}
const exp = (sign)=>(x)=>sign * Math.exp(x);
const log = (sign)=>(x)=>Math.log(sign * x);
const symlog = (c)=>(x)=>Math.sign(x) * Math.log1p(Math.abs(x / c));
const symexp = (c)=>(x)=>Math.sign(x) * Math.expm1(Math.abs(x)) * c;
const pow = (exponent)=>(x)=>x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
function pan(domain, delta, lift, ground) {
    const d0 = lift(domain[0]), d1 = lift(peek(domain)), dd = (d1 - d0) * delta;
    return [
        ground(d0 - dd),
        ground(d1 - dd)
    ];
}
function panLinear(domain, delta) {
    return pan(domain, delta, toNumber, identity);
}
function panLog(domain, delta) {
    var sign = Math.sign(domain[0]);
    return pan(domain, delta, log(sign), exp(sign));
}
function panPow(domain, delta, exponent) {
    return pan(domain, delta, pow(exponent), pow(1 / exponent));
}
function panSymlog(domain, delta, constant) {
    return pan(domain, delta, symlog(constant), symexp(constant));
}
function zoom(domain, anchor, scale, lift, ground) {
    const d0 = lift(domain[0]), d1 = lift(peek(domain)), da = anchor != null ? lift(anchor) : (d0 + d1) / 2;
    return [
        ground(da + (d0 - da) * scale),
        ground(da + (d1 - da) * scale)
    ];
}
function zoomLinear(domain, anchor, scale) {
    return zoom(domain, anchor, scale, toNumber, identity);
}
function zoomLog(domain, anchor, scale) {
    const sign = Math.sign(domain[0]);
    return zoom(domain, anchor, scale, log(sign), exp(sign));
}
function zoomPow(domain, anchor, scale, exponent) {
    return zoom(domain, anchor, scale, pow(exponent), pow(1 / exponent));
}
function zoomSymlog(domain, anchor, scale, constant) {
    return zoom(domain, anchor, scale, symlog(constant), symexp(constant));
}
function quarter(date) {
    return 1 + ~~(new Date(date).getMonth() / 3);
}
function utcquarter(date) {
    return 1 + ~~(new Date(date).getUTCMonth() / 3);
}
function array(_) {
    return _ != null ? isArray(_) ? _ : [
        _
    ] : [];
}
/**
 * Span-preserving range clamp. If the span of the input range is less
 * than (max - min) and an endpoint exceeds either the min or max value,
 * the range is translated such that the span is preserved and one
 * endpoint touches the boundary of the min/max range.
 * If the span exceeds (max - min), the range [min, max] is returned.
 */ function clampRange(range, min, max) {
    let lo = range[0], hi = range[1], span;
    if (hi < lo) {
        span = hi;
        hi = lo;
        lo = span;
    }
    span = hi - lo;
    return span >= max - min ? [
        min,
        max
    ] : [
        lo = Math.min(Math.max(lo, min), max - span),
        lo + span
    ];
}
function isFunction(_) {
    return typeof _ === 'function';
}
const DESCENDING = 'descending';
function compare(fields, orders, opt) {
    opt = opt || {};
    orders = array(orders) || [];
    const ord = [], get = [], fmap = {}, gen = opt.comparator || comparator;
    array(fields).forEach((f, i)=>{
        if (f == null) return;
        ord.push(orders[i] === DESCENDING ? -1 : 1);
        get.push(f = isFunction(f) ? f : field(f, null, opt));
        (accessorFields(f) || []).forEach((_)=>fmap[_] = 1);
    });
    return get.length === 0 ? null : accessor(gen(get, ord), Object.keys(fmap));
}
const ascending = (u, v)=>(u < v || u == null) && v != null ? -1 : (u > v || v == null) && u != null ? 1 : (v = v instanceof Date ? +v : v, u = u instanceof Date ? +u : u) !== u && v === v ? -1 : v !== v && u === u ? 1 : 0;
const comparator = (fields, orders)=>fields.length === 1 ? compare1(fields[0], orders[0]) : compareN(fields, orders, fields.length);
const compare1 = (field, order)=>function(a, b) {
        return ascending(field(a), field(b)) * order;
    };
const compareN = (fields, orders, n)=>{
    orders.push(0); // pad zero for convenient lookup
    return function(a, b) {
        let f, c = 0, i = -1;
        while(c === 0 && ++i < n){
            f = fields[i];
            c = ascending(f(a), f(b));
        }
        return c * orders[i];
    };
};
function constant(_) {
    return isFunction(_) ? _ : ()=>_;
}
function debounce(delay, handler) {
    let tid;
    return (e)=>{
        if (tid) clearTimeout(tid);
        tid = setTimeout(()=>(handler(e), tid = null), delay);
    };
}
function extend(_) {
    for(let x, k, i = 1, len = arguments.length; i < len; ++i){
        x = arguments[i];
        for(k in x)_[k] = x[k];
    }
    return _;
}
/**
 * Return an array with minimum and maximum values, in the
 * form [min, max]. Ignores null, undefined, and NaN values.
 */ function extent(array, f) {
    let i = 0, n, v, min, max;
    if (array && (n = array.length)) {
        if (f == null) {
            // find first valid value
            for(v = array[i]; i < n && (v == null || v !== v); v = array[++i]);
            min = max = v;
            // visit all other values
            for(; i < n; ++i){
                v = array[i];
                // skip null/undefined; NaN will fail all comparisons
                if (v != null) {
                    if (v < min) min = v;
                    if (v > max) max = v;
                }
            }
        } else {
            // find first valid value
            for(v = f(array[i]); i < n && (v == null || v !== v); v = f(array[++i]));
            min = max = v;
            // visit all other values
            for(; i < n; ++i){
                v = f(array[i]);
                // skip null/undefined; NaN will fail all comparisons
                if (v != null) {
                    if (v < min) min = v;
                    if (v > max) max = v;
                }
            }
        }
    }
    return [
        min,
        max
    ];
}
function extentIndex(array, f) {
    const n = array.length;
    let i = -1, a, b, c, u, v;
    if (f == null) {
        while(++i < n){
            b = array[i];
            if (b != null && b >= b) {
                a = c = b;
                break;
            }
        }
        if (i === n) return [
            -1,
            -1
        ];
        u = v = i;
        while(++i < n){
            b = array[i];
            if (b != null) {
                if (a > b) {
                    a = b;
                    u = i;
                }
                if (c < b) {
                    c = b;
                    v = i;
                }
            }
        }
    } else {
        while(++i < n){
            b = f(array[i], i, array);
            if (b != null && b >= b) {
                a = c = b;
                break;
            }
        }
        if (i === n) return [
            -1,
            -1
        ];
        u = v = i;
        while(++i < n){
            b = f(array[i], i, array);
            if (b != null) {
                if (a > b) {
                    a = b;
                    u = i;
                }
                if (c < b) {
                    c = b;
                    v = i;
                }
            }
        }
    }
    return [
        u,
        v
    ];
}
function has(object, property) {
    return Object.hasOwn(object, property);
}
const NULL = {};
function fastmap(input) {
    let obj = {}, test;
    function has$1(key) {
        return has(obj, key) && obj[key] !== NULL;
    }
    const map = {
        size: 0,
        empty: 0,
        object: obj,
        has: has$1,
        get (key) {
            return has$1(key) ? obj[key] : undefined;
        },
        set (key, value) {
            if (!has$1(key)) {
                ++map.size;
                if (obj[key] === NULL) --map.empty;
            }
            obj[key] = value;
            return this;
        },
        delete (key) {
            if (has$1(key)) {
                --map.size;
                ++map.empty;
                obj[key] = NULL;
            }
            return this;
        },
        clear () {
            map.size = map.empty = 0;
            map.object = obj = {};
        },
        test (_) {
            if (arguments.length) {
                test = _;
                return map;
            } else return test;
        },
        clean () {
            const next = {};
            let size = 0;
            for(const key in obj){
                const value = obj[key];
                if (value !== NULL && (!test || !test(value))) {
                    next[key] = value;
                    ++size;
                }
            }
            map.size = size;
            map.empty = 0;
            map.object = obj = next;
        }
    };
    if (input) Object.keys(input).forEach((key)=>{
        map.set(key, input[key]);
    });
    return map;
}
function flush(range, value, threshold, left, right, center) {
    if (!threshold && threshold !== 0) return center;
    const t = +threshold;
    let a = range[0], b = peek(range), l;
    // swap endpoints if range is reversed
    if (b < a) {
        l = a;
        a = b;
        b = l;
    }
    // compare value to endpoints
    l = Math.abs(value - a);
    const r = Math.abs(b - value);
    // adjust if value is within threshold distance of endpoint
    return l < r && l <= t ? left : r <= t ? right : center;
}
function inherits(child, parent, members) {
    const proto = child.prototype = Object.create(parent.prototype);
    Object.defineProperty(proto, 'constructor', {
        value: child,
        writable: true,
        enumerable: true,
        configurable: true
    });
    return extend(proto, members);
}
/**
 * Predicate that returns true if the value lies within the span
 * of the given range. The left and right flags control the use
 * of inclusive (true) or exclusive (false) comparisons.
 */ function inrange(value, range, left, right) {
    let r0 = range[0], r1 = range[range.length - 1], t;
    if (r0 > r1) {
        t = r0;
        r0 = r1;
        r1 = t;
    }
    left = left === undefined || left;
    right = right === undefined || right;
    return (left ? r0 <= value : r0 < value) && (right ? value <= r1 : value < r1);
}
function isBoolean(_) {
    return typeof _ === 'boolean';
}
function isDate(_) {
    return Object.prototype.toString.call(_) === '[object Date]';
}
function isIterable(_) {
    return _ && isFunction(_[Symbol.iterator]);
}
function isNumber(_) {
    return typeof _ === 'number';
}
function isRegExp(_) {
    return Object.prototype.toString.call(_) === '[object RegExp]';
}
function isString(_) {
    return typeof _ === 'string';
}
function key(fields, flat, opt) {
    if (fields) fields = flat ? array(fields).map((f)=>f.replace(/\\(.)/g, '$1')) : array(fields);
    const len = fields && fields.length, gen = opt && opt.get || getter, map = (f)=>gen(flat ? [
            f
        ] : splitAccessPath(f));
    let fn;
    if (!len) fn = function() {
        return '';
    };
    else if (len === 1) {
        const get = map(fields[0]);
        fn = function(_) {
            return '' + get(_);
        };
    } else {
        const get = fields.map(map);
        fn = function(_) {
            let s = '' + get[0](_), i = 0;
            while(++i < len)s += '|' + get[i](_);
            return s;
        };
    }
    return accessor(fn, fields, 'key');
}
function lerp(array, frac) {
    const lo = array[0], hi = peek(array), f = +frac;
    return !f ? lo : f === 1 ? hi : lo + f * (hi - lo);
}
const DEFAULT_MAX_SIZE = 10000;
// adapted from https://github.com/dominictarr/hashlru/ (MIT License)
function lruCache(maxsize) {
    maxsize = +maxsize || DEFAULT_MAX_SIZE;
    let curr, prev, size;
    const clear = ()=>{
        curr = {};
        prev = {};
        size = 0;
    };
    const update = (key, value)=>{
        if (++size > maxsize) {
            prev = curr;
            curr = {};
            size = 1;
        }
        return curr[key] = value;
    };
    clear();
    return {
        clear,
        has: (key)=>has(curr, key) || has(prev, key),
        get: (key)=>has(curr, key) ? curr[key] : has(prev, key) ? update(key, prev[key]) : undefined,
        set: (key, value)=>has(curr, key) ? curr[key] = value : update(key, value)
    };
}
function merge(compare, array0, array1, output) {
    const n0 = array0.length, n1 = array1.length;
    if (!n1) return array0;
    if (!n0) return array1;
    const merged = output || new array0.constructor(n0 + n1);
    let i0 = 0, i1 = 0, i = 0;
    for(; i0 < n0 && i1 < n1; ++i)merged[i] = compare(array0[i0], array1[i1]) > 0 ? array1[i1++] : array0[i0++];
    for(; i0 < n0; ++i0, ++i)merged[i] = array0[i0];
    for(; i1 < n1; ++i1, ++i)merged[i] = array1[i1];
    return merged;
}
function repeat(str, reps) {
    let s = '';
    while(--reps >= 0)s += str;
    return s;
}
function pad(str, length, padchar, align) {
    const c = padchar || ' ', s = str + '', n = length - s.length;
    return n <= 0 ? s : align === 'left' ? repeat(c, n) + s : align === 'center' ? repeat(c, ~~(n / 2)) + s + repeat(c, Math.ceil(n / 2)) : s + repeat(c, n);
}
/**
 * Return the numerical span of an array: the difference between
 * the last and first values.
 */ function span(array) {
    return array && peek(array) - array[0] || 0;
}
function $(x) {
    return isArray(x) ? '[' + x.map($) + ']' : isObject(x) || isString(x) ? // Output valid JSON and JS source strings.
    // See http://timelessrepo.com/json-isnt-a-javascript-subset
    JSON.stringify(x).replace('\u2028', '\\u2028').replace('\u2029', '\\u2029') : x;
}
function toBoolean(_) {
    return _ == null || _ === '' ? null : !_ || _ === 'false' || _ === '0' ? false : !!_;
}
const defaultParser = (_)=>isNumber(_) ? _ : isDate(_) ? _ : Date.parse(_);
function toDate(_, parser) {
    parser = parser || defaultParser;
    return _ == null || _ === '' ? null : parser(_);
}
function toString(_) {
    return _ == null || _ === '' ? null : _ + '';
}
function toSet(_) {
    const s = {}, n = _.length;
    for(let i = 0; i < n; ++i)s[_[i]] = true;
    return s;
}
function truncate(str, length, align, ellipsis) {
    const e = ellipsis != null ? ellipsis : '\u2026', s = str + '', n = s.length, l = Math.max(0, length - e.length);
    return n <= length ? s : align === 'left' ? e + s.slice(n - l) : align === 'center' ? s.slice(0, Math.ceil(l / 2)) + e + s.slice(n - ~~(l / 2)) : s.slice(0, l) + e;
}
function visitArray(array, filter, visitor) {
    if (array) {
        if (filter) {
            const n = array.length;
            for(let i = 0; i < n; ++i){
                const t = filter(array[i]);
                if (t) visitor(t, i, array);
            }
        } else array.forEach(visitor);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eoU45":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dataflow", ()=>Dataflow);
parcelHelpers.export(exports, "EventStream", ()=>EventStream);
parcelHelpers.export(exports, "MultiPulse", ()=>MultiPulse);
parcelHelpers.export(exports, "Operator", ()=>Operator);
parcelHelpers.export(exports, "Parameters", ()=>Parameters);
parcelHelpers.export(exports, "Pulse", ()=>Pulse);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "UniqueList", ()=>UniqueList);
parcelHelpers.export(exports, "asyncCallback", ()=>asyncCallback);
parcelHelpers.export(exports, "changeset", ()=>changeset);
parcelHelpers.export(exports, "definition", ()=>definition);
parcelHelpers.export(exports, "derive", ()=>derive);
parcelHelpers.export(exports, "ingest", ()=>ingest$1);
parcelHelpers.export(exports, "isChangeSet", ()=>isChangeSet);
parcelHelpers.export(exports, "isTuple", ()=>isTuple);
parcelHelpers.export(exports, "rederive", ()=>rederive);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "stableCompare", ()=>stableCompare);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "transforms", ()=>transforms);
parcelHelpers.export(exports, "tupleid", ()=>tupleid);
var _vegaUtil = require("vega-util");
var _vegaLoader = require("vega-loader");
var _vegaFormat = require("vega-format");
function UniqueList(idFunc) {
    const $ = idFunc || (0, _vegaUtil.identity), list = [], ids = {};
    list.add = (_)=>{
        const id = $(_);
        if (!ids[id]) {
            ids[id] = 1;
            list.push(_);
        }
        return list;
    };
    list.remove = (_)=>{
        const id = $(_);
        if (ids[id]) {
            ids[id] = 0;
            const idx = list.indexOf(_);
            if (idx >= 0) list.splice(idx, 1);
        }
        return list;
    };
    return list;
}
/**
 * Invoke and await a potentially async callback function. If
 * an error occurs, trap it and route to Dataflow.error.
 * @param {Dataflow} df - The dataflow instance
 * @param {function} callback - A callback function to invoke
 *   and then await. The dataflow will be passed as the single
 *   argument to the function.
 */ async function asyncCallback(df, callback) {
    try {
        await callback(df);
    } catch (err) {
        df.error(err);
    }
}
const TUPLE_ID_KEY = Symbol('vega_id');
let TUPLE_ID = 1;
/**
 * Checks if an input value is a registered tuple.
 * @param {*} t - The value to check.
 * @return {boolean} True if the input is a tuple, false otherwise.
 */ function isTuple(t) {
    return !!(t && tupleid(t));
}
/**
 * Returns the id of a tuple.
 * @param {object} t - The input tuple.
 * @return {*} the tuple id.
 */ function tupleid(t) {
    return t[TUPLE_ID_KEY];
}
/**
 * Sets the id of a tuple.
 * @param {object} t - The input tuple.
 * @param {*} id - The id value to set.
 * @return {object} the input tuple.
 */ function setid(t, id) {
    t[TUPLE_ID_KEY] = id;
    return t;
}
/**
 * Ingest an object or value as a data tuple.
 * If the input value is an object, an id field will be added to it. For
 * efficiency, the input object is modified directly. A copy is not made.
 * If the input value is a literal, it will be wrapped in a new object
 * instance, with the value accessible as the 'data' property.
 * @param datum - The value to ingest.
 * @return {object} The ingested data tuple.
 */ function ingest$1(datum) {
    const t = datum === Object(datum) ? datum : {
        data: datum
    };
    return tupleid(t) ? t : setid(t, TUPLE_ID++);
}
/**
 * Given a source tuple, return a derived copy.
 * @param {object} t - The source tuple.
 * @return {object} The derived tuple.
 */ function derive(t) {
    return rederive(t, ingest$1({}));
}
/**
 * Rederive a derived tuple by copying values from the source tuple.
 * @param {object} t - The source tuple.
 * @param {object} d - The derived tuple.
 * @return {object} The derived tuple.
 */ function rederive(t, d) {
    for(const k in t)d[k] = t[k];
    return d;
}
/**
 * Replace an existing tuple with a new tuple.
 * @param {object} t - The existing data tuple.
 * @param {object} d - The new tuple that replaces the old.
 * @return {object} The new tuple.
 */ function replace(t, d) {
    return setid(d, tupleid(t));
}
/**
 * Generate an augmented comparator function that provides stable
 * sorting by tuple id when the given comparator produces ties.
 * @param {function} cmp - The comparator to augment.
 * @param {function} [f] - Optional tuple accessor function.
 * @return {function} An augmented comparator function.
 */ function stableCompare(cmp, f) {
    return !cmp ? null : f ? (a, b)=>cmp(a, b) || tupleid(f(a)) - tupleid(f(b)) : (a, b)=>cmp(a, b) || tupleid(a) - tupleid(b);
}
function isChangeSet(v) {
    return v && v.constructor === changeset;
}
function changeset() {
    const add = [], // insert tuples
    rem = [], // remove tuples
    mod = [], // modify tuples
    remp = [], // remove by predicate
    modp = []; // modify by predicate
    let clean = null, reflow = false;
    return {
        constructor: changeset,
        insert (t) {
            const d = (0, _vegaUtil.array)(t), n = d.length;
            for(let i = 0; i < n; ++i)add.push(d[i]);
            return this;
        },
        remove (t) {
            const a = (0, _vegaUtil.isFunction)(t) ? remp : rem, d = (0, _vegaUtil.array)(t), n = d.length;
            for(let i = 0; i < n; ++i)a.push(d[i]);
            return this;
        },
        modify (t, field, value) {
            const m = {
                field: field,
                value: (0, _vegaUtil.constant)(value)
            };
            if ((0, _vegaUtil.isFunction)(t)) {
                m.filter = t;
                modp.push(m);
            } else {
                m.tuple = t;
                mod.push(m);
            }
            return this;
        },
        encode (t, set) {
            if ((0, _vegaUtil.isFunction)(t)) modp.push({
                filter: t,
                field: set
            });
            else mod.push({
                tuple: t,
                field: set
            });
            return this;
        },
        clean (value) {
            clean = value;
            return this;
        },
        reflow () {
            reflow = true;
            return this;
        },
        pulse (pulse, tuples) {
            const cur = {}, out = {};
            let i, n, m, f, t, id;
            // build lookup table of current tuples
            for(i = 0, n = tuples.length; i < n; ++i)cur[tupleid(tuples[i])] = 1;
            // process individual tuples to remove
            for(i = 0, n = rem.length; i < n; ++i){
                t = rem[i];
                cur[tupleid(t)] = -1;
            }
            // process predicate-based removals
            for(i = 0, n = remp.length; i < n; ++i){
                f = remp[i];
                tuples.forEach((t)=>{
                    if (f(t)) cur[tupleid(t)] = -1;
                });
            }
            // process all add tuples
            for(i = 0, n = add.length; i < n; ++i){
                t = add[i];
                id = tupleid(t);
                if (cur[id]) // tuple already resides in dataset
                // if flagged for both add and remove, cancel
                cur[id] = 1;
                else // tuple does not reside in dataset, add
                pulse.add.push(ingest$1(add[i]));
            }
            // populate pulse rem list
            for(i = 0, n = tuples.length; i < n; ++i){
                t = tuples[i];
                if (cur[tupleid(t)] < 0) pulse.rem.push(t);
            }
            // modify helper method
            function modify(t, f, v) {
                if (v) t[f] = v(t);
                else pulse.encode = f;
                if (!reflow) out[tupleid(t)] = t;
            }
            // process individual tuples to modify
            for(i = 0, n = mod.length; i < n; ++i){
                m = mod[i];
                t = m.tuple;
                f = m.field;
                id = cur[tupleid(t)];
                if (id > 0) {
                    modify(t, f, m.value);
                    pulse.modifies(f);
                }
            }
            // process predicate-based modifications
            for(i = 0, n = modp.length; i < n; ++i){
                m = modp[i];
                f = m.filter;
                tuples.forEach((t)=>{
                    if (f(t) && cur[tupleid(t)] > 0) modify(t, m.field, m.value);
                });
                pulse.modifies(m.field);
            }
            // upon reflow request, populate mod with all non-removed tuples
            // otherwise, populate mod with modified tuples only
            if (reflow) pulse.mod = rem.length || remp.length ? tuples.filter((t)=>cur[tupleid(t)] > 0) : tuples.slice();
            else for(id in out)pulse.mod.push(out[id]);
            // set pulse garbage collection request
            if (clean || clean == null && (rem.length || remp.length)) pulse.clean(true);
            return pulse;
        }
    };
}
const CACHE = '_:mod:_';
/**
 * Hash that tracks modifications to assigned values.
 * Callers *must* use the set method to update values.
 */ function Parameters() {
    Object.defineProperty(this, CACHE, {
        writable: true,
        value: {}
    });
}
Parameters.prototype = {
    /**
   * Set a parameter value. If the parameter value changes, the parameter
   * will be recorded as modified.
   * @param {string} name - The parameter name.
   * @param {number} index - The index into an array-value parameter. Ignored if
   *   the argument is undefined, null or less than zero.
   * @param {*} value - The parameter value to set.
   * @param {boolean} [force=false] - If true, records the parameter as modified
   *   even if the value is unchanged.
   * @return {Parameters} - This parameter object.
   */ set (name, index, value, force) {
        const o = this, v = o[name], mod = o[CACHE];
        if (index != null && index >= 0) {
            if (v[index] !== value || force) {
                v[index] = value;
                mod[index + ':' + name] = -1;
                mod[name] = -1;
            }
        } else if (v !== value || force) {
            o[name] = value;
            mod[name] = (0, _vegaUtil.isArray)(value) ? 1 + value.length : -1;
        }
        return o;
    },
    /**
   * Tests if one or more parameters has been modified. If invoked with no
   * arguments, returns true if any parameter value has changed. If the first
   * argument is array, returns trues if any parameter name in the array has
   * changed. Otherwise, tests if the given name and optional array index has
   * changed.
   * @param {string} name - The parameter name to test.
   * @param {number} [index=undefined] - The parameter array index to test.
   * @return {boolean} - Returns true if a queried parameter was modified.
   */ modified (name, index) {
        const mod = this[CACHE];
        if (!arguments.length) {
            for(const k in mod){
                if (mod[k]) return true;
            }
            return false;
        } else if ((0, _vegaUtil.isArray)(name)) {
            for(let k = 0; k < name.length; ++k){
                if (mod[name[k]]) return true;
            }
            return false;
        }
        return index != null && index >= 0 ? index + 1 < mod[name] || !!mod[index + ':' + name] : !!mod[name];
    },
    /**
   * Clears the modification records. After calling this method,
   * all parameters are considered unmodified.
   */ clear () {
        this[CACHE] = {};
        return this;
    }
};
let OP_ID = 0;
const PULSE = 'pulse', NO_PARAMS = new Parameters();
// Boolean Flags
const SKIP$1 = 1, MODIFIED = 2;
/**
 * An Operator is a processing node in a dataflow graph.
 * Each operator stores a value and an optional value update function.
 * Operators can accept a hash of named parameters. Parameter values can
 * either be direct (JavaScript literals, arrays, objects) or indirect
 * (other operators whose values will be pulled dynamically). Operators
 * included as parameters will have this operator added as a dependency.
 * @constructor
 * @param {*} [init] - The initial value for this operator.
 * @param {function(object, Pulse)} [update] - An update function. Upon
 *   evaluation of this operator, the update function will be invoked and the
 *   return value will be used as the new value of this operator.
 * @param {object} [params] - The parameters for this operator.
 * @param {boolean} [react=true] - Flag indicating if this operator should
 *   listen for changes to upstream operators included as parameters.
 * @see parameters
 */ function Operator(init, update, params, react) {
    this.id = ++OP_ID;
    this.value = init;
    this.stamp = -1;
    this.rank = -1;
    this.qrank = -1;
    this.flags = 0;
    if (update) this._update = update;
    if (params) this.parameters(params, react);
}
function flag(bit) {
    return function(state) {
        const f = this.flags;
        if (arguments.length === 0) return !!(f & bit);
        this.flags = state ? f | bit : f & ~bit;
        return this;
    };
}
Operator.prototype = {
    /**
   * Returns a list of target operators dependent on this operator.
   * If this list does not exist, it is created and then returned.
   * @return {UniqueList}
   */ targets () {
        return this._targets || (this._targets = UniqueList((0, _vegaUtil.id)));
    },
    /**
   * Sets the value of this operator.
   * @param {*} value - the value to set.
   * @return {Number} Returns 1 if the operator value has changed
   *   according to strict equality, returns 0 otherwise.
   */ set (value) {
        if (this.value !== value) {
            this.value = value;
            return 1;
        } else return 0;
    },
    /**
   * Indicates that operator evaluation should be skipped on the next pulse.
   * This operator will still propagate incoming pulses, but its update function
   * will not be invoked. The skip flag is reset after every pulse, so calling
   * this method will affect processing of the next pulse only.
   */ skip: flag(SKIP$1),
    /**
   * Indicates that this operator's value has been modified on its most recent
   * pulse. Normally modification is checked via strict equality; however, in
   * some cases it is more efficient to update the internal state of an object.
   * In those cases, the modified flag can be used to trigger propagation. Once
   * set, the modification flag persists across pulses until unset. The flag can
   * be used with the last timestamp to test if a modification is recent.
   */ modified: flag(MODIFIED),
    /**
   * Sets the parameters for this operator. The parameter values are analyzed for
   * operator instances. If found, this operator will be added as a dependency
   * of the parameterizing operator. Operator values are dynamically marshalled
   * from each operator parameter prior to evaluation. If a parameter value is
   * an array, the array will also be searched for Operator instances. However,
   * the search does not recurse into sub-arrays or object properties.
   * @param {object} params - A hash of operator parameters.
   * @param {boolean} [react=true] - A flag indicating if this operator should
   *   automatically update (react) when parameter values change. In other words,
   *   this flag determines if the operator registers itself as a listener on
   *   any upstream operators included in the parameters.
   * @param {boolean} [initonly=false] - A flag indicating if this operator
   *   should calculate an update only upon its initial evaluation, then
   *   deregister dependencies and suppress all future update invocations.
   * @return {Operator[]} - An array of upstream dependencies.
   */ parameters (params, react, initonly) {
        react = react !== false;
        const argval = this._argval = this._argval || new Parameters(), argops = this._argops = this._argops || [], deps = [];
        let name, value, n, i;
        const add = (name, index, value)=>{
            if (value instanceof Operator) {
                if (value !== this) {
                    if (react) value.targets().add(this);
                    deps.push(value);
                }
                argops.push({
                    op: value,
                    name: name,
                    index: index
                });
            } else argval.set(name, index, value);
        };
        for(name in params){
            value = params[name];
            if (name === PULSE) {
                (0, _vegaUtil.array)(value).forEach((op)=>{
                    if (!(op instanceof Operator)) (0, _vegaUtil.error)('Pulse parameters must be operator instances.');
                    else if (op !== this) {
                        op.targets().add(this);
                        deps.push(op);
                    }
                });
                this.source = value;
            } else if ((0, _vegaUtil.isArray)(value)) {
                argval.set(name, -1, Array(n = value.length));
                for(i = 0; i < n; ++i)add(name, i, value[i]);
            } else add(name, -1, value);
        }
        this.marshall().clear(); // initialize values
        if (initonly) argops.initonly = true;
        return deps;
    },
    /**
   * Internal method for marshalling parameter values.
   * Visits each operator dependency to pull the latest value.
   * @return {Parameters} A Parameters object to pass to the update function.
   */ marshall (stamp) {
        const argval = this._argval || NO_PARAMS, argops = this._argops;
        let item, i, op, mod;
        if (argops) {
            const n = argops.length;
            for(i = 0; i < n; ++i){
                item = argops[i];
                op = item.op;
                mod = op.modified() && op.stamp === stamp;
                argval.set(item.name, item.index, op.value, mod);
            }
            if (argops.initonly) {
                for(i = 0; i < n; ++i){
                    item = argops[i];
                    item.op.targets().remove(this);
                }
                this._argops = null;
                this._update = null;
            }
        }
        return argval;
    },
    /**
   * Detach this operator from the dataflow.
   * Unregisters listeners on upstream dependencies.
   */ detach () {
        const argops = this._argops;
        let i, n, item, op;
        if (argops) for(i = 0, n = argops.length; i < n; ++i){
            item = argops[i];
            op = item.op;
            if (op._targets) op._targets.remove(this);
        }
        // remove references to the source and pulse object,
        // if present, to prevent memory leaks of old data.
        this.pulse = null;
        this.source = null;
    },
    /**
   * Delegate method to perform operator processing.
   * Subclasses can override this method to perform custom processing.
   * By default, it marshalls parameters and calls the update function
   * if that function is defined. If the update function does not
   * change the operator value then StopPropagation is returned.
   * If no update function is defined, this method does nothing.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return The output pulse or StopPropagation. A falsy return value
   *   (including undefined) will let the input pulse pass through.
   */ evaluate (pulse) {
        const update = this._update;
        if (update) {
            const params = this.marshall(pulse.stamp), v = update.call(this, params, pulse);
            params.clear();
            if (v !== this.value) this.value = v;
            else if (!this.modified()) return pulse.StopPropagation;
        }
    },
    /**
   * Run this operator for the current pulse. If this operator has already
   * been run at (or after) the pulse timestamp, returns StopPropagation.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */ run (pulse) {
        if (pulse.stamp < this.stamp) return pulse.StopPropagation;
        let rv;
        if (this.skip()) {
            this.skip(false);
            rv = 0;
        } else rv = this.evaluate(pulse);
        return this.pulse = rv || pulse;
    }
};
/**
 * Add an operator to the dataflow graph. This function accepts a
 * variety of input argument types. The basic signature supports an
 * initial value, update function and parameters. If the first parameter
 * is an Operator instance, it will be added directly. If it is a
 * constructor for an Operator subclass, a new instance will be instantiated.
 * Otherwise, if the first parameter is a function instance, it will be used
 * as the update function and a null initial value is assumed.
 * @param {*} init - One of: the operator to add, the initial value of
 *   the operator, an operator class to instantiate, or an update function.
 * @param {function} [update] - The operator update function.
 * @param {object} [params] - The operator parameters.
 * @param {boolean} [react=true] - Flag indicating if this operator should
 *   listen for changes to upstream operators included as parameters.
 * @return {Operator} - The added operator.
 */ function add(init, update, params, react) {
    let shift = 1, op;
    if (init instanceof Operator) op = init;
    else if (init && init.prototype instanceof Operator) op = new init();
    else if ((0, _vegaUtil.isFunction)(init)) op = new Operator(null, init);
    else {
        shift = 0;
        op = new Operator(init, update);
    }
    this.rank(op);
    if (shift) {
        react = params;
        params = update;
    }
    if (params) this.connect(op, op.parameters(params, react));
    this.touch(op);
    return op;
}
/**
 * Connect a target operator as a dependent of source operators.
 * If necessary, this method will rerank the target operator and its
 * dependents to ensure propagation proceeds in a topologically sorted order.
 * @param {Operator} target - The target operator.
 * @param {Array<Operator>} - The source operators that should propagate
 *   to the target operator.
 */ function connect(target, sources) {
    const targetRank = target.rank, n = sources.length;
    for(let i = 0; i < n; ++i)if (targetRank < sources[i].rank) {
        this.rerank(target);
        return;
    }
}
let STREAM_ID = 0;
/**
 * Models an event stream.
 * @constructor
 * @param {function(Object, number): boolean} [filter] - Filter predicate.
 *   Events pass through when truthy, events are suppressed when falsy.
 * @param {function(Object): *} [apply] - Applied to input events to produce
 *   new event values.
 * @param {function(Object)} [receive] - Event callback function to invoke
 *   upon receipt of a new event. Use to override standard event processing.
 */ function EventStream(filter, apply, receive) {
    this.id = ++STREAM_ID;
    this.value = null;
    if (receive) this.receive = receive;
    if (filter) this._filter = filter;
    if (apply) this._apply = apply;
}
/**
 * Creates a new event stream instance with the provided
 * (optional) filter, apply and receive functions.
 * @param {function(Object, number): boolean} [filter] - Filter predicate.
 *   Events pass through when truthy, events are suppressed when falsy.
 * @param {function(Object): *} [apply] - Applied to input events to produce
 *   new event values.
 * @see EventStream
 */ function stream(filter, apply, receive) {
    return new EventStream(filter, apply, receive);
}
EventStream.prototype = {
    _filter: (0, _vegaUtil.truthy),
    _apply: (0, _vegaUtil.identity),
    targets () {
        return this._targets || (this._targets = UniqueList((0, _vegaUtil.id)));
    },
    consume (_) {
        if (!arguments.length) return !!this._consume;
        this._consume = !!_;
        return this;
    },
    receive (evt) {
        if (this._filter(evt)) {
            const val = this.value = this._apply(evt), trg = this._targets, n = trg ? trg.length : 0;
            for(let i = 0; i < n; ++i)trg[i].receive(val);
            if (this._consume) {
                evt.preventDefault();
                evt.stopPropagation();
            }
        }
    },
    filter (filter) {
        const s = stream(filter);
        this.targets().add(s);
        return s;
    },
    apply (apply) {
        const s = stream(null, apply);
        this.targets().add(s);
        return s;
    },
    merge () {
        const s = stream();
        this.targets().add(s);
        for(let i = 0, n = arguments.length; i < n; ++i)arguments[i].targets().add(s);
        return s;
    },
    throttle (pause) {
        let t = -1;
        return this.filter(()=>{
            const now = Date.now();
            if (now - t > pause) {
                t = now;
                return 1;
            } else return 0;
        });
    },
    debounce (delay) {
        const s = stream();
        this.targets().add(stream(null, null, (0, _vegaUtil.debounce)(delay, (e)=>{
            const df = e.dataflow;
            s.receive(e);
            if (df && df.run) df.run();
        })));
        return s;
    },
    between (a, b) {
        let active = false;
        a.targets().add(stream(null, null, ()=>active = true));
        b.targets().add(stream(null, null, ()=>active = false));
        return this.filter(()=>active);
    },
    detach () {
        // ensures compatibility with operators (#2753)
        // remove references to other streams and filter functions that may
        // be bound to subcontexts that need to be garbage collected.
        this._filter = (0, _vegaUtil.truthy);
        this._targets = null;
    }
};
/**
 * Create a new event stream from an event source.
 * @param {object} source - The event source to monitor. The input must
 *  support the addEventListener method.
 * @param {string} type - The event type.
 * @param {function(object): boolean} [filter] - Event filter function.
 * @param {function(object): *} [apply] - Event application function.
 *   If provided, this function will be invoked and the result will be
 *   used as the downstream event value.
 * @return {EventStream}
 */ function events(source, type, filter, apply) {
    const df = this, s = stream(filter, apply), send = function(e) {
        e.dataflow = df;
        try {
            s.receive(e);
        } catch (error) {
            df.error(error);
        } finally{
            df.run();
        }
    };
    let sources;
    if (typeof source === 'string' && typeof document !== 'undefined') sources = document.querySelectorAll(source);
    else sources = (0, _vegaUtil.array)(source);
    const n = sources.length;
    for(let i = 0; i < n; ++i)sources[i].addEventListener(type, send);
    return s;
}
function parse(data, format) {
    const locale = this.locale();
    return (0, _vegaLoader.read)(data, format, locale.timeParse, locale.utcParse);
}
/**
 * Ingests new data into the dataflow. First parses the data using the
 * vega-loader read method, then pulses a changeset to the target operator.
 * @param {Operator} target - The Operator to target with ingested data,
 *   typically a Collect transform instance.
 * @param {*} data - The input data, prior to parsing. For JSON this may
 *   be a string or an object. For CSV, TSV, etc should be a string.
 * @param {object} format - The data format description for parsing
 *   loaded data. This object is passed to the vega-loader read method.
 * @returns {Dataflow}
 */ function ingest(target, data, format) {
    data = this.parse(data, format);
    return this.pulse(target, this.changeset().insert(data));
}
/**
 * Request data from an external source, parse it, and return a Promise.
 * @param {string} url - The URL from which to load the data. This string
 *   is passed to the vega-loader load method.
 * @param {object} [format] - The data format description for parsing
 *   loaded data. This object is passed to the vega-loader read method.
 * @return {Promise} A Promise that resolves upon completion of the request.
 *   The resolved object contains the following properties:
 *   - data: an array of parsed data (or null upon error)
 *   - status: a code for success (0), load fail (-1), or parse fail (-2)
 */ async function request(url, format) {
    const df = this;
    let status = 0, data;
    try {
        data = await df.loader().load(url, {
            context: 'dataflow',
            response: (0, _vegaLoader.responseType)(format && format.type)
        });
        try {
            data = df.parse(data, format);
        } catch (err) {
            status = -2;
            df.warn('Data ingestion failed', url, err);
        }
    } catch (err) {
        status = -1;
        df.warn('Loading failed', url, err);
    }
    return {
        data,
        status
    };
}
async function preload(target, url, format) {
    const df = this, pending = df._pending || loadPending(df);
    pending.requests += 1;
    const res = await df.request(url, format);
    df.pulse(target, df.changeset().remove((0, _vegaUtil.truthy)).insert(res.data || []));
    pending.done();
    return res;
}
function loadPending(df) {
    let accept;
    const pending = new Promise((a)=>accept = a);
    pending.requests = 0;
    pending.done = ()=>{
        if (--pending.requests === 0) {
            df._pending = null;
            accept(df);
        }
    };
    return df._pending = pending;
}
const SKIP = {
    skip: true
};
/**
 * Perform operator updates in response to events. Applies an
 * update function to compute a new operator value. If the update function
 * returns a {@link ChangeSet}, the operator will be pulsed with those tuple
 * changes. Otherwise, the operator value will be updated to the return value.
 * @param {EventStream|Operator} source - The event source to react to.
 *   This argument can be either an EventStream or an Operator.
 * @param {Operator|function(object):Operator} target - The operator to update.
 *   This argument can either be an Operator instance or (if the source
 *   argument is an EventStream), a function that accepts an event object as
 *   input and returns an Operator to target.
 * @param {function(Parameters,Event): *} [update] - Optional update function
 *   to compute the new operator value, or a literal value to set. Update
 *   functions expect to receive a parameter object and event as arguments.
 *   This function can either return a new operator value or (if the source
 *   argument is an EventStream) a {@link ChangeSet} instance to pulse
 *   the target operator with tuple changes.
 * @param {object} [params] - The update function parameters.
 * @param {object} [options] - Additional options hash. If not overridden,
 *   updated operators will be skipped by default.
 * @param {boolean} [options.skip] - If true, the operator will
 *  be skipped: it will not be evaluated, but its dependents will be.
 * @param {boolean} [options.force] - If true, the operator will
 *   be re-evaluated even if its value has not changed.
 * @return {Dataflow}
 */ function on(source, target, update, params, options) {
    const fn = source instanceof Operator ? onOperator : onStream;
    fn(this, source, target, update, params, options);
    return this;
}
function onStream(df, stream, target, update, params, options) {
    const opt = (0, _vegaUtil.extend)({}, options, SKIP);
    let func, op;
    if (!(0, _vegaUtil.isFunction)(target)) target = (0, _vegaUtil.constant)(target);
    if (update === undefined) func = (e)=>df.touch(target(e));
    else if ((0, _vegaUtil.isFunction)(update)) {
        op = new Operator(null, update, params, false);
        func = (e)=>{
            op.evaluate(e);
            const t = target(e), v = op.value;
            isChangeSet(v) ? df.pulse(t, v, options) : df.update(t, v, opt);
        };
    } else func = (e)=>df.update(target(e), update, opt);
    stream.apply(func);
}
function onOperator(df, source, target, update, params, options) {
    if (update === undefined) source.targets().add(target);
    else {
        const opt = options || {}, op = new Operator(null, updater(target, update), params, false);
        op.modified(opt.force);
        op.rank = source.rank; // immediately follow source
        source.targets().add(op); // add dependency
        if (target) {
            op.skip(true); // skip first invocation
            op.value = target.value; // initialize value
            op.targets().add(target); // chain dependencies
            df.connect(target, [
                op
            ]); // rerank as needed, #1672
        }
    }
}
function updater(target, update) {
    update = (0, _vegaUtil.isFunction)(update) ? update : (0, _vegaUtil.constant)(update);
    return target ? function(_, pulse) {
        const value = update(_, pulse);
        if (!target.skip()) target.skip(value !== this.value).value = value;
        return value;
    } : update;
}
/**
 * Assigns a rank to an operator. Ranks are assigned in increasing order
 * by incrementing an internal rank counter.
 * @param {Operator} op - The operator to assign a rank.
 */ function rank(op) {
    op.rank = ++this._rank;
}
/**
 * Re-ranks an operator and all downstream target dependencies. This
 * is necessary when upstream dependencies of higher rank are added to
 * a target operator.
 * @param {Operator} op - The operator to re-rank.
 */ function rerank(op) {
    const queue = [
        op
    ];
    let cur, list, i;
    while(queue.length){
        this.rank(cur = queue.pop());
        if (list = cur._targets) for(i = list.length; --i >= 0;){
            queue.push(cur = list[i]);
            if (cur === op) (0, _vegaUtil.error)('Cycle detected in dataflow graph.');
        }
    }
}
/**
 * Sentinel value indicating pulse propagation should stop.
 */ const StopPropagation = {};
// Pulse visit type flags
const ADD = 1, REM = 2, MOD = 4, ADD_REM = ADD | REM, ADD_MOD = ADD | MOD, ALL = ADD | REM | MOD, REFLOW = 8, SOURCE = 16, NO_SOURCE = 32, NO_FIELDS = 64;
/**
 * A Pulse enables inter-operator communication during a run of the
 * dataflow graph. In addition to the current timestamp, a pulse may also
 * contain a change-set of added, removed or modified data tuples, as well as
 * a pointer to a full backing data source. Tuple change sets may not
 * be fully materialized; for example, to prevent needless array creation
 * a change set may include larger arrays and corresponding filter functions.
 * The pulse provides a {@link visit} method to enable proper and efficient
 * iteration over requested data tuples.
 *
 * In addition, each pulse can track modification flags for data tuple fields.
 * Responsible transform operators should call the {@link modifies} method to
 * indicate changes to data fields. The {@link modified} method enables
 * querying of this modification state.
 *
 * @constructor
 * @param {Dataflow} dataflow - The backing dataflow instance.
 * @param {number} stamp - The current propagation timestamp.
 * @param {string} [encode] - An optional encoding set name, which is then
 *   accessible as Pulse.encode. Operators can respond to (or ignore) this
 *   setting as appropriate. This parameter can be used in conjunction with
 *   the Encode transform in the vega-encode module.
 */ function Pulse(dataflow, stamp, encode) {
    this.dataflow = dataflow;
    this.stamp = stamp == null ? -1 : stamp;
    this.add = [];
    this.rem = [];
    this.mod = [];
    this.fields = null;
    this.encode = encode || null;
}
function materialize(data, filter) {
    const out = [];
    (0, _vegaUtil.visitArray)(data, filter, (_)=>out.push(_));
    return out;
}
function filter(pulse, flags) {
    const map = {};
    pulse.visit(flags, (t)=>{
        map[tupleid(t)] = 1;
    });
    return (t)=>map[tupleid(t)] ? null : t;
}
function addFilter(a, b) {
    return a ? (t, i)=>a(t, i) && b(t, i) : b;
}
Pulse.prototype = {
    /**
   * Sentinel value indicating pulse propagation should stop.
   */ StopPropagation,
    /**
   * Boolean flag indicating ADD (added) tuples.
   */ ADD,
    /**
   * Boolean flag indicating REM (removed) tuples.
   */ REM,
    /**
   * Boolean flag indicating MOD (modified) tuples.
   */ MOD,
    /**
   * Boolean flag indicating ADD (added) and REM (removed) tuples.
   */ ADD_REM,
    /**
   * Boolean flag indicating ADD (added) and MOD (modified) tuples.
   */ ADD_MOD,
    /**
   * Boolean flag indicating ADD, REM and MOD tuples.
   */ ALL,
    /**
   * Boolean flag indicating all tuples in a data source
   * except for the ADD, REM and MOD tuples.
   */ REFLOW,
    /**
   * Boolean flag indicating a 'pass-through' to a
   * backing data source, ignoring ADD, REM and MOD tuples.
   */ SOURCE,
    /**
   * Boolean flag indicating that source data should be
   * suppressed when creating a forked pulse.
   */ NO_SOURCE,
    /**
   * Boolean flag indicating that field modifications should be
   * suppressed when creating a forked pulse.
   */ NO_FIELDS,
    /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created.
   * @return {Pulse} - The forked pulse instance.
   * @see init
   */ fork (flags) {
        return new Pulse(this.dataflow).init(this, flags);
    },
    /**
   * Creates a copy of this pulse with new materialized array
   * instances for the ADD, REM, MOD, and SOURCE arrays.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse} - The cloned pulse instance.
   * @see init
   */ clone () {
        const p = this.fork(ALL);
        p.add = p.add.slice();
        p.rem = p.rem.slice();
        p.mod = p.mod.slice();
        if (p.source) p.source = p.source.slice();
        return p.materialize(ALL | SOURCE);
    },
    /**
   * Returns a pulse that adds all tuples from a backing source. This is
   * useful for cases where operators are added to a dataflow after an
   * upstream data pipeline has already been processed, ensuring that
   * new operators can observe all tuples within a stream.
   * @return {Pulse} - A pulse instance with all source tuples included
   *   in the add array. If the current pulse already has all source
   *   tuples in its add array, it is returned directly. If the current
   *   pulse does not have a backing source, it is returned directly.
   */ addAll () {
        let p = this;
        const reuse = !p.source || p.add === p.rem // special case for indexed set (e.g., crossfilter)
         || !p.rem.length && p.source.length === p.add.length;
        if (reuse) return p;
        else {
            p = new Pulse(this.dataflow).init(this);
            p.add = p.source;
            p.rem = []; // new operators can ignore rem #2769
            return p;
        }
    },
    /**
   * Initialize this pulse based on the values of another pulse. This method
   * is used internally by {@link fork} to initialize a new forked tuple.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {Pulse} src - The source pulse to copy from.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created. By default, source data arrays are copied
   *   to the new pulse. Use the NO_SOURCE flag to enforce a null source.
   * @return {Pulse} - Returns this Pulse instance.
   */ init (src, flags) {
        const p = this;
        p.stamp = src.stamp;
        p.encode = src.encode;
        if (src.fields && !(flags & NO_FIELDS)) p.fields = src.fields;
        if (flags & ADD) {
            p.addF = src.addF;
            p.add = src.add;
        } else {
            p.addF = null;
            p.add = [];
        }
        if (flags & REM) {
            p.remF = src.remF;
            p.rem = src.rem;
        } else {
            p.remF = null;
            p.rem = [];
        }
        if (flags & MOD) {
            p.modF = src.modF;
            p.mod = src.mod;
        } else {
            p.modF = null;
            p.mod = [];
        }
        if (flags & NO_SOURCE) {
            p.srcF = null;
            p.source = null;
        } else {
            p.srcF = src.srcF;
            p.source = src.source;
            if (src.cleans) p.cleans = src.cleans;
        }
        return p;
    },
    /**
   * Schedules a function to run after pulse propagation completes.
   * @param {function} func - The function to run.
   */ runAfter (func) {
        this.dataflow.runAfter(func);
    },
    /**
   * Indicates if tuples have been added, removed or modified.
   * @param {number} [flags] - The tuple types (ADD, REM or MOD) to query.
   *   Defaults to ALL, returning true if any tuple type has changed.
   * @return {boolean} - Returns true if one or more queried tuple types have
   *   changed, false otherwise.
   */ changed (flags) {
        const f = flags || ALL;
        return f & ADD && this.add.length || f & REM && this.rem.length || f & MOD && this.mod.length;
    },
    /**
   * Forces a "reflow" of tuple values, such that all tuples in the backing
   * source are added to the MOD set, unless already present in the ADD set.
   * @param {boolean} [fork=false] - If true, returns a forked copy of this
   *   pulse, and invokes reflow on that derived pulse.
   * @return {Pulse} - The reflowed pulse instance.
   */ reflow (fork) {
        if (fork) return this.fork(ALL).reflow();
        const len = this.add.length, src = this.source && this.source.length;
        if (src && src !== len) {
            this.mod = this.source;
            if (len) this.filter(MOD, filter(this, ADD));
        }
        return this;
    },
    /**
   * Get/set metadata to pulse requesting garbage collection
   * to reclaim currently unused resources.
   */ clean (value) {
        if (arguments.length) {
            this.cleans = !!value;
            return this;
        } else return this.cleans;
    },
    /**
   * Marks one or more data field names as modified to assist dependency
   * tracking and incremental processing by transform operators.
   * @param {string|Array<string>} _ - The field(s) to mark as modified.
   * @return {Pulse} - This pulse instance.
   */ modifies (_) {
        const hash = this.fields || (this.fields = {});
        if ((0, _vegaUtil.isArray)(_)) _.forEach((f)=>hash[f] = true);
        else hash[_] = true;
        return this;
    },
    /**
   * Checks if one or more data fields have been modified during this pulse
   * propagation timestamp.
   * @param {string|Array<string>} _ - The field(s) to check for modified.
   * @param {boolean} nomod - If true, will check the modified flag even if
   *   no mod tuples exist. If false (default), mod tuples must be present.
   * @return {boolean} - Returns true if any of the provided fields has been
   *   marked as modified, false otherwise.
   */ modified (_, nomod) {
        const fields = this.fields;
        return !((nomod || this.mod.length) && fields) ? false : !arguments.length ? !!fields : (0, _vegaUtil.isArray)(_) ? _.some((f)=>fields[f]) : fields[_];
    },
    /**
   * Adds a filter function to one more tuple sets. Filters are applied to
   * backing tuple arrays, to determine the actual set of tuples considered
   * added, removed or modified. They can be used to delay materialization of
   * a tuple set in order to avoid expensive array copies. In addition, the
   * filter functions can serve as value transformers: unlike standard predicate
   * function (which return boolean values), Pulse filters should return the
   * actual tuple value to process. If a tuple set is already filtered, the
   * new filter function will be appended into a conjuntive ('and') query.
   * @param {number} flags - Flags indicating the tuple set(s) to filter.
   * @param {function(*):object} filter - Filter function that will be applied
   *   to the tuple set array, and should return a data tuple if the value
   *   should be included in the tuple set, and falsy (or null) otherwise.
   * @return {Pulse} - Returns this pulse instance.
   */ filter (flags, filter) {
        const p = this;
        if (flags & ADD) p.addF = addFilter(p.addF, filter);
        if (flags & REM) p.remF = addFilter(p.remF, filter);
        if (flags & MOD) p.modF = addFilter(p.modF, filter);
        if (flags & SOURCE) p.srcF = addFilter(p.srcF, filter);
        return p;
    },
    /**
   * Materialize one or more tuple sets in this pulse. If the tuple set(s) have
   * a registered filter function, it will be applied and the tuple set(s) will
   * be replaced with materialized tuple arrays.
   * @param {number} flags - Flags indicating the tuple set(s) to materialize.
   * @return {Pulse} - Returns this pulse instance.
   */ materialize (flags) {
        flags = flags || ALL;
        const p = this;
        if (flags & ADD && p.addF) {
            p.add = materialize(p.add, p.addF);
            p.addF = null;
        }
        if (flags & REM && p.remF) {
            p.rem = materialize(p.rem, p.remF);
            p.remF = null;
        }
        if (flags & MOD && p.modF) {
            p.mod = materialize(p.mod, p.modF);
            p.modF = null;
        }
        if (flags & SOURCE && p.srcF) {
            p.source = p.source.filter(p.srcF);
            p.srcF = null;
        }
        return p;
    },
    /**
   * Visit one or more tuple sets in this pulse.
   * @param {number} flags - Flags indicating the tuple set(s) to visit.
   *   Legal values are ADD, REM, MOD and SOURCE (if a backing data source
   *   has been set).
   * @param {function(object):*} - Visitor function invoked per-tuple.
   * @return {Pulse} - Returns this pulse instance.
   */ visit (flags, visitor) {
        const p = this, v = visitor;
        if (flags & SOURCE) {
            (0, _vegaUtil.visitArray)(p.source, p.srcF, v);
            return p;
        }
        if (flags & ADD) (0, _vegaUtil.visitArray)(p.add, p.addF, v);
        if (flags & REM) (0, _vegaUtil.visitArray)(p.rem, p.remF, v);
        if (flags & MOD) (0, _vegaUtil.visitArray)(p.mod, p.modF, v);
        const src = p.source;
        if (flags & REFLOW && src) {
            const sum = p.add.length + p.mod.length;
            if (sum === src.length) ;
            else if (sum) (0, _vegaUtil.visitArray)(src, filter(p, ADD_MOD), v);
            else // if no add/rem/mod tuples, visit source
            (0, _vegaUtil.visitArray)(src, p.srcF, v);
        }
        return p;
    }
};
/**
 * Represents a set of multiple pulses. Used as input for operators
 * that accept multiple pulses at a time. Contained pulses are
 * accessible via the public "pulses" array property. This pulse doe
 * not carry added, removed or modified tuples directly. However,
 * the visit method can be used to traverse all such tuples contained
 * in sub-pulses with a timestamp matching this parent multi-pulse.
 * @constructor
 * @param {Dataflow} dataflow - The backing dataflow instance.
 * @param {number} stamp - The timestamp.
 * @param {Array<Pulse>} pulses - The sub-pulses for this multi-pulse.
 */ function MultiPulse(dataflow, stamp, pulses, encode) {
    const p = this;
    let c = 0;
    this.dataflow = dataflow;
    this.stamp = stamp;
    this.fields = null;
    this.encode = encode || null;
    this.pulses = pulses;
    for (const pulse of pulses){
        if (pulse.stamp !== stamp) continue;
        if (pulse.fields) {
            const hash = p.fields || (p.fields = {});
            for(const f in pulse.fields)hash[f] = 1;
        }
        if (pulse.changed(p.ADD)) c |= p.ADD;
        if (pulse.changed(p.REM)) c |= p.REM;
        if (pulse.changed(p.MOD)) c |= p.MOD;
    }
    this.changes = c;
}
(0, _vegaUtil.inherits)(MultiPulse, Pulse, {
    /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse}
   */ fork (flags) {
        const p = new Pulse(this.dataflow).init(this, flags & this.NO_FIELDS);
        if (flags !== undefined) {
            if (flags & p.ADD) this.visit(p.ADD, (t)=>p.add.push(t));
            if (flags & p.REM) this.visit(p.REM, (t)=>p.rem.push(t));
            if (flags & p.MOD) this.visit(p.MOD, (t)=>p.mod.push(t));
        }
        return p;
    },
    changed (flags) {
        return this.changes & flags;
    },
    modified (_) {
        const p = this, fields = p.fields;
        return !(fields && p.changes & p.MOD) ? 0 : (0, _vegaUtil.isArray)(_) ? _.some((f)=>fields[f]) : fields[_];
    },
    filter () {
        (0, _vegaUtil.error)('MultiPulse does not support filtering.');
    },
    materialize () {
        (0, _vegaUtil.error)('MultiPulse does not support materialization.');
    },
    visit (flags, visitor) {
        const p = this, pulses = p.pulses, n = pulses.length;
        let i = 0;
        if (flags & p.SOURCE) for(; i < n; ++i)pulses[i].visit(flags, visitor);
        else {
            for(; i < n; ++i)if (pulses[i].stamp === p.stamp) pulses[i].visit(flags, visitor);
        }
        return p;
    }
});
/**
 * Evaluates the dataflow and returns a Promise that resolves when pulse
 * propagation completes. This method will increment the current timestamp
 * and process all updated, pulsed and touched operators. When invoked for
 * the first time, all registered operators will be processed. This method
 * should not be invoked by third-party clients, use {@link runAsync} or
 * {@link run} instead.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode package.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Promise} - A promise that resolves to this dataflow after
 *   evaluation completes.
 */ async function evaluate(encode, prerun, postrun) {
    const df = this, async = [];
    // if the pulse value is set, this is a re-entrant call
    if (df._pulse) return reentrant(df);
    // wait for pending datasets to load
    if (df._pending) await df._pending;
    // invoke prerun function, if provided
    if (prerun) await asyncCallback(df, prerun);
    // exit early if there are no updates
    if (!df._touched.length) {
        df.debug('Dataflow invoked, but nothing to do.');
        return df;
    }
    // increment timestamp clock
    const stamp = ++df._clock;
    // set the current pulse
    df._pulse = new Pulse(df, stamp, encode);
    // initialize priority queue, reset touched operators
    df._touched.forEach((op)=>df._enqueue(op, true));
    df._touched = UniqueList((0, _vegaUtil.id));
    let count = 0, op, next, error;
    try {
        while(df._heap.size() > 0){
            // dequeue operator with highest priority
            op = df._heap.pop();
            // re-queue if rank changed
            if (op.rank !== op.qrank) {
                df._enqueue(op, true);
                continue;
            }
            // otherwise, evaluate the operator
            next = op.run(df._getPulse(op, encode));
            if (next.then) // await if operator returns a promise directly
            next = await next;
            else if (next.async) {
                // queue parallel asynchronous execution
                async.push(next.async);
                next = StopPropagation;
            }
            // propagate evaluation, enqueue dependent operators
            if (next !== StopPropagation) {
                if (op._targets) op._targets.forEach((op)=>df._enqueue(op));
            }
            // increment visit counter
            ++count;
        }
    } catch (err) {
        df._heap.clear();
        error = err;
    }
    // reset pulse map
    df._input = {};
    df._pulse = null;
    df.debug(`Pulse ${stamp}: ${count} operators`);
    if (error) {
        df._postrun = [];
        df.error(error);
    }
    // invoke callbacks queued via runAfter
    if (df._postrun.length) {
        const pr = df._postrun.sort((a, b)=>b.priority - a.priority);
        df._postrun = [];
        for(let i = 0; i < pr.length; ++i)await asyncCallback(df, pr[i].callback);
    }
    // invoke postrun function, if provided
    if (postrun) await asyncCallback(df, postrun);
    // handle non-blocking asynchronous callbacks
    if (async.length) Promise.all(async).then((cb)=>df.runAsync(null, ()=>{
            cb.forEach((f)=>{
                try {
                    f(df);
                } catch (err) {
                    df.error(err);
                }
            });
        }));
    return df;
}
/**
 * Queues dataflow evaluation to run once any other queued evaluations have
 * completed and returns a Promise that resolves when the queued pulse
 * propagation completes. If provided, a callback function will be invoked
 * immediately before evaluation commences. This method will ensure a
 * separate evaluation is invoked for each time it is called.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode package.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Promise} - A promise that resolves to this dataflow after
 *   evaluation completes.
 */ async function runAsync(encode, prerun, postrun) {
    // await previously queued functions
    while(this._running)await this._running;
    // run dataflow, manage running promise
    const clear = ()=>this._running = null;
    (this._running = this.evaluate(encode, prerun, postrun)).then(clear, clear);
    return this._running;
}
/**
 * Requests dataflow evaluation and the immediately returns this dataflow
 * instance. If there are pending data loading or other asynchronous
 * operations, the dataflow will evaluate asynchronously after this method
 * has been invoked. To track when dataflow evaluation completes, use the
 * {@link runAsync} method instead. This method will raise an error if
 * invoked while the dataflow is already in the midst of evaluation.
 * @param {string} [encode] - The name of an encoding set to invoke during
 *   propagation. This value is added to generated Pulse instances;
 *   operators can then respond to (or ignore) this setting as appropriate.
 *   This parameter can be used in conjunction with the Encode transform in
 *   the vega-encode module.
 * @param {function} [prerun] - An optional callback function to invoke
 *   immediately before dataflow evaluation commences.
 * @param {function} [postrun] - An optional callback function to invoke
 *   after dataflow evaluation completes. The callback will be invoked
 *   after those registered via {@link runAfter}.
 * @return {Dataflow} - This dataflow instance.
 */ function run(encode, prerun, postrun) {
    return this._pulse ? reentrant(this) : (this.evaluate(encode, prerun, postrun), this);
}
/**
 * Schedules a callback function to be invoked after the current pulse
 * propagation completes. If no propagation is currently occurring,
 * the function is invoked immediately. Callbacks scheduled via runAfter
 * are invoked immediately upon completion of the current cycle, before
 * any request queued via runAsync. This method is primarily intended for
 * internal use. Third-party callers using runAfter to schedule a callback
 * that invokes {@link run} or {@link runAsync} should not use this method,
 * but instead use {@link runAsync} with prerun or postrun arguments.
 * @param {function(Dataflow)} callback - The callback function to run.
 *   The callback will be invoked with this Dataflow instance as its
 *   sole argument.
 * @param {boolean} enqueue - A boolean flag indicating that the
 *   callback should be queued up to run after the next propagation
 *   cycle, suppressing immediate invocation when propagation is not
 *   currently occurring.
 * @param {number} [priority] - A priority value used to sort registered
 *   callbacks to determine execution order. This argument is intended
 *   for internal Vega use only.
 */ function runAfter(callback, enqueue, priority) {
    if (this._pulse || enqueue) // pulse propagation is currently running, queue to run after
    this._postrun.push({
        priority: priority || 0,
        callback: callback
    });
    else // pulse propagation already complete, invoke immediately
    try {
        callback(this);
    } catch (err) {
        this.error(err);
    }
}
/**
 * Raise an error for re-entrant dataflow evaluation.
 */ function reentrant(df) {
    df.error('Dataflow already running. Use runAsync() to chain invocations.');
    return df;
}
/**
 * Enqueue an operator into the priority queue for evaluation. The operator
 * will be enqueued if it has no registered pulse for the current cycle, or if
 * the force argument is true. Upon enqueue, this method also sets the
 * operator's qrank to the current rank value.
 * @param {Operator} op - The operator to enqueue.
 * @param {boolean} [force] - A flag indicating if the operator should be
 *   forceably added to the queue, even if it has already been previously
 *   enqueued during the current pulse propagation. This is useful when the
 *   dataflow graph is dynamically modified and the operator rank changes.
 */ function enqueue(op, force) {
    const q = op.stamp < this._clock;
    if (q) op.stamp = this._clock;
    if (q || force) {
        op.qrank = op.rank;
        this._heap.push(op);
    }
}
/**
 * Provide a correct pulse for evaluating an operator. If the operator has an
 * explicit source operator, we will try to pull the pulse(s) from it.
 * If there is an array of source operators, we build a multi-pulse.
 * Otherwise, we return a current pulse with correct source data.
 * If the pulse is the pulse map has an explicit target set, we use that.
 * Else if the pulse on the upstream source operator is current, we use that.
 * Else we use the pulse from the pulse map, but copy the source tuple array.
 * @param {Operator} op - The operator for which to get an input pulse.
 * @param {string} [encode] - An (optional) encoding set name with which to
 *   annotate the returned pulse. See {@link run} for more information.
 */ function getPulse(op, encode) {
    const s = op.source, stamp = this._clock;
    return s && (0, _vegaUtil.isArray)(s) ? new MultiPulse(this, stamp, s.map((_)=>_.pulse), encode) : this._input[op.id] || singlePulse(this._pulse, s && s.pulse);
}
function singlePulse(p, s) {
    if (s && s.stamp === p.stamp) return s;
    p = p.fork();
    if (s && s !== StopPropagation) p.source = s.source;
    return p;
}
const NO_OPT = {
    skip: false,
    force: false
};
/**
 * Touches an operator, scheduling it to be evaluated. If invoked outside of
 * a pulse propagation, the operator will be evaluated the next time this
 * dataflow is run. If invoked in the midst of pulse propagation, the operator
 * will be queued for evaluation if and only if the operator has not yet been
 * evaluated on the current propagation timestamp.
 * @param {Operator} op - The operator to touch.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */ function touch(op, options) {
    const opt = options || NO_OPT;
    if (this._pulse) // if in midst of propagation, add to priority queue
    this._enqueue(op);
    else // otherwise, queue for next propagation
    this._touched.add(op);
    if (opt.skip) op.skip(true);
    return this;
}
/**
 * Updates the value of the given operator.
 * @param {Operator} op - The operator to update.
 * @param {*} value - The value to set.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.force] - If true, the operator will
 *   be re-evaluated even if its value has not changed.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */ function update(op, value, options) {
    const opt = options || NO_OPT;
    if (op.set(value) || opt.force) this.touch(op, opt);
    return this;
}
/**
 * Pulses an operator with a changeset of tuples. If invoked outside of
 * a pulse propagation, the pulse will be applied the next time this
 * dataflow is run. If invoked in the midst of pulse propagation, the pulse
 * will be added to the set of active pulses and will be applied if and
 * only if the target operator has not yet been evaluated on the current
 * propagation timestamp.
 * @param {Operator} op - The operator to pulse.
 * @param {ChangeSet} value - The tuple changeset to apply.
 * @param {object} [options] - Additional options hash.
 * @param {boolean} [options.skip] - If true, the operator will
 *   be skipped: it will not be evaluated, but its dependents will be.
 * @return {Dataflow}
 */ function pulse(op, changeset, options) {
    this.touch(op, options || NO_OPT);
    const p = new Pulse(this, this._clock + (this._pulse ? 0 : 1)), t = op.pulse && op.pulse.source || [];
    p.target = op;
    this._input[op.id] = changeset.pulse(p, t);
    return this;
}
function Heap(cmp) {
    let nodes = [];
    return {
        clear: ()=>nodes = [],
        size: ()=>nodes.length,
        peek: ()=>nodes[0],
        push: (x)=>{
            nodes.push(x);
            return siftdown(nodes, 0, nodes.length - 1, cmp);
        },
        pop: ()=>{
            const last = nodes.pop();
            let item;
            if (nodes.length) {
                item = nodes[0];
                nodes[0] = last;
                siftup(nodes, 0, cmp);
            } else item = last;
            return item;
        }
    };
}
function siftdown(array, start, idx, cmp) {
    let parent, pidx;
    const item = array[idx];
    while(idx > start){
        pidx = idx - 1 >> 1;
        parent = array[pidx];
        if (cmp(item, parent) < 0) {
            array[idx] = parent;
            idx = pidx;
            continue;
        }
        break;
    }
    return array[idx] = item;
}
function siftup(array, idx, cmp) {
    const start = idx, end = array.length, item = array[idx];
    let cidx = (idx << 1) + 1, ridx;
    while(cidx < end){
        ridx = cidx + 1;
        if (ridx < end && cmp(array[cidx], array[ridx]) >= 0) cidx = ridx;
        array[idx] = array[cidx];
        idx = cidx;
        cidx = (idx << 1) + 1;
    }
    array[idx] = item;
    return siftdown(array, start, idx, cmp);
}
/**
 * A dataflow graph for reactive processing of data streams.
 * @constructor
 */ function Dataflow() {
    this.logger((0, _vegaUtil.logger)());
    this.logLevel((0, _vegaUtil.Error));
    this._clock = 0;
    this._rank = 0;
    this._locale = (0, _vegaFormat.defaultLocale)();
    try {
        this._loader = (0, _vegaLoader.loader)();
    } catch (e) {
    // do nothing if loader module is unavailable
    }
    this._touched = UniqueList((0, _vegaUtil.id));
    this._input = {};
    this._pulse = null;
    this._heap = Heap((a, b)=>a.qrank - b.qrank);
    this._postrun = [];
}
function logMethod(method) {
    return function() {
        return this._log[method].apply(this, arguments);
    };
}
Dataflow.prototype = {
    /**
   * The current timestamp of this dataflow. This value reflects the
   * timestamp of the previous dataflow run. The dataflow is initialized
   * with a stamp value of 0. The initial run of the dataflow will have
   * a timestap of 1, and so on. This value will match the
   * {@link Pulse.stamp} property.
   * @return {number} - The current timestamp value.
   */ stamp () {
        return this._clock;
    },
    /**
   * Gets or sets the loader instance to use for data file loading. A
   * loader object must provide a "load" method for loading files and a
   * "sanitize" method for checking URL/filename validity. Both methods
   * should accept a URI and options hash as arguments, and return a Promise
   * that resolves to the loaded file contents (load) or a hash containing
   * sanitized URI data with the sanitized url assigned to the "href" property
   * (sanitize).
   * @param {object} _ - The loader instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current loader instance. Otherwise returns this Dataflow instance.
   */ loader (_) {
        if (arguments.length) {
            this._loader = _;
            return this;
        } else return this._loader;
    },
    /**
   * Gets or sets the locale instance to use for formatting and parsing
   * string values. The locale object should be provided by the
   * vega-format library, and include methods such as format, timeFormat,
   * utcFormat, timeParse, and utcParse.
   * @param {object} _ - The locale instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current locale instance. Otherwise returns this Dataflow instance.
   */ locale (_) {
        if (arguments.length) {
            this._locale = _;
            return this;
        } else return this._locale;
    },
    /**
   * Get or set the logger instance used to log messages. If no arguments are
   * provided, returns the current logger instance. Otherwise, sets the logger
   * and return this Dataflow instance. Provided loggers must support the full
   * API of logger objects generated by the vega-util logger method. Note that
   * by default the log level of the new logger will be used; use the logLevel
   * method to adjust the log level as needed.
   */ logger (logger) {
        if (arguments.length) {
            this._log = logger;
            return this;
        } else return this._log;
    },
    /**
   * Logs an error message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit error messages.
   */ error: logMethod('error'),
    /**
   * Logs a warning message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit warning messages.
   */ warn: logMethod('warn'),
    /**
   * Logs a information message. By default, logged messages are written to
   * console output. The message will only be logged if the current log level is
   * high enough to permit information messages.
   */ info: logMethod('info'),
    /**
   * Logs a debug message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit debug messages.
   */ debug: logMethod('debug'),
    /**
   * Get or set the current log level. If an argument is provided, it
   * will be used as the new log level.
   * @param {number} [level] - Should be one of None, Warn, Info
   * @return {number} - The current log level.
   */ logLevel: logMethod('level'),
    /**
   * Empty entry threshold for garbage cleaning. Map data structures will
   * perform cleaning once the number of empty entries exceeds this value.
   */ cleanThreshold: 1e4,
    // OPERATOR REGISTRATION
    add,
    connect,
    rank,
    rerank,
    // OPERATOR UPDATES
    pulse,
    touch,
    update,
    changeset,
    // DATA LOADING
    ingest,
    parse,
    preload,
    request,
    // EVENT HANDLING
    events,
    on,
    // PULSE PROPAGATION
    evaluate,
    run,
    runAsync,
    runAfter,
    _enqueue: enqueue,
    _getPulse: getPulse
};
/**
 * Abstract class for operators that process data tuples.
 * Subclasses must provide a {@link transform} method for operator processing.
 * @constructor
 * @param {*} [init] - The initial value for this operator.
 * @param {object} [params] - The parameters for this operator.
 * @param {Operator} [source] - The operator from which to receive pulses.
 */ function Transform(init, params) {
    Operator.call(this, init, null, params);
}
(0, _vegaUtil.inherits)(Transform, Operator, {
    /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */ run (pulse) {
        if (pulse.stamp < this.stamp) return pulse.StopPropagation;
        let rv;
        if (this.skip()) this.skip(false);
        else rv = this.evaluate(pulse);
        rv = rv || pulse;
        if (rv.then) rv = rv.then((_)=>this.pulse = _);
        else if (rv !== pulse.StopPropagation) this.pulse = rv;
        return rv;
    },
    /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Marshalls parameter values and then invokes {@link transform}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
       value (including undefined) will let the input pulse pass through.
  */ evaluate (pulse) {
        const params = this.marshall(pulse.stamp), out = this.transform(params, pulse);
        params.clear();
        return out;
    },
    /**
   * Process incoming pulses.
   * Subclasses should override this method to implement transforms.
   * @param {Parameters} _ - The operator parameter values.
   * @param {Pulse} pulse - The current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
   *   value (including undefined) will let the input pulse pass through.
   */ transform () {}
});
const transforms = {};
function definition(type) {
    const t = transform(type);
    return t && t.Definition || null;
}
function transform(type) {
    type = type && type.toLowerCase();
    return (0, _vegaUtil.hasOwnProperty)(transforms, type) ? transforms[type] : null;
}

},{"vega-util":"kncZn","vega-loader":"btcyl","vega-format":"er6y3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"btcyl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formats", ()=>formats);
parcelHelpers.export(exports, "inferType", ()=>inferType);
parcelHelpers.export(exports, "inferTypes", ()=>inferTypes);
parcelHelpers.export(exports, "loader", ()=>loader);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "responseType", ()=>responseType);
parcelHelpers.export(exports, "typeParsers", ()=>typeParsers);
var _vegaUtil = require("vega-util");
var _d3Dsv = require("d3-dsv");
var _topojsonClient = require("topojson-client");
var _vegaFormat = require("vega-format");
var Buffer = require("a8648f2b61a45853").Buffer;
// Matches absolute URLs with optional protocol
//   https://...    file://...    //...
const protocol_re = /^(data:|([A-Za-z]+:)?\/\/)/;
// Matches allowed URIs. From https://github.com/cure53/DOMPurify/blob/master/src/regexp.js with added file://
const allowed_re = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape
const whitespace_re = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g; // eslint-disable-line no-control-regex
// Special treatment in node.js for the file: protocol
const fileProtocol = 'file://';
/**
 * Factory for a loader constructor that provides methods for requesting
 * files from either the network or disk, and for sanitizing request URIs.
 * @param {function} fetch - The Fetch API for HTTP network requests.
 *   If null or undefined, HTTP loading will be disabled.
 * @param {object} fs - The file system interface for file loading.
 *   If null or undefined, local file loading will be disabled.
 * @return {function} A loader constructor with the following signature:
 *   param {object} [options] - Optional default loading options to use.
 *   return {object} - A new loader instance.
 */ function loaderFactory(fetch1, fs) {
    return (options)=>({
            options: options || {},
            sanitize: sanitize,
            load: load,
            fileAccess: false,
            file: fileLoader(),
            http: httpLoader(fetch1)
        });
}
/**
 * Load an external resource, typically either from the web or from the local
 * filesystem. This function uses {@link sanitize} to first sanitize the uri,
 * then calls either {@link http} (for web requests) or {@link file} (for
 * filesystem loading).
 * @param {string} uri - The resource indicator (e.g., URL or filename).
 * @param {object} [options] - Optional loading options. These options will
 *   override any existing default options.
 * @return {Promise} - A promise that resolves to the loaded content.
 */ async function load(uri, options) {
    const opt = await this.sanitize(uri, options), url = opt.href;
    return opt.localFile ? this.file(url) : this.http(url, options);
}
/**
 * URI sanitizer function.
 * @param {string} uri - The uri (url or filename) to check.
 * @param {object} options - An options hash.
 * @return {Promise} - A promise that resolves to an object containing
 *  sanitized uri data, or rejects it the input uri is deemed invalid.
 *  The properties of the resolved object are assumed to be
 *  valid attributes for an HTML 'a' tag. The sanitized uri *must* be
 *  provided by the 'href' property of the returned object.
 */ async function sanitize(uri, options) {
    options = (0, _vegaUtil.extend)({}, this.options, options);
    const fileAccess = this.fileAccess, result = {
        href: null
    };
    let isFile, loadFile, base;
    const isAllowed = allowed_re.test(uri.replace(whitespace_re, ''));
    if (uri == null || typeof uri !== 'string' || !isAllowed) (0, _vegaUtil.error)('Sanitize failure, invalid URI: ' + (0, _vegaUtil.stringValue)(uri));
    const hasProtocol = protocol_re.test(uri);
    // if relative url (no protocol/host), prepend baseURL
    if ((base = options.baseURL) && !hasProtocol) {
        // Ensure that there is a slash between the baseURL (e.g. hostname) and url
        if (!uri.startsWith('/') && !base.endsWith('/')) uri = '/' + uri;
        uri = base + uri;
    }
    // should we load from file system?
    loadFile = (isFile = uri.startsWith(fileProtocol)) || options.mode === 'file' || options.mode !== 'http' && !hasProtocol && fileAccess;
    if (isFile) // strip file protocol
    uri = uri.slice(fileProtocol.length);
    else if (uri.startsWith('//')) {
        if (options.defaultProtocol === 'file') {
            // if is file, strip protocol and set loadFile flag
            uri = uri.slice(2);
            loadFile = true;
        } else // if relative protocol (starts with '//'), prepend default protocol
        uri = (options.defaultProtocol || 'http') + ':' + uri;
    }
    // set non-enumerable mode flag to indicate local file load
    Object.defineProperty(result, 'localFile', {
        value: !!loadFile
    });
    // set uri
    result.href = uri;
    // set default result target, if specified
    if (options.target) result.target = options.target + '';
    // set default result rel, if specified (#1542)
    if (options.rel) result.rel = options.rel + '';
    // provide control over cross-origin image handling (#2238)
    // https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
    if (options.context === 'image' && options.crossOrigin) result.crossOrigin = options.crossOrigin + '';
    // return
    return result;
}
/**
 * File system loader factory.
 * @param {object} fs - The file system interface.
 * @return {function} - A file loader with the following signature:
 *   param {string} filename - The file system path to load.
 *   param {string} filename - The file system path to load.
 *   return {Promise} A promise that resolves to the file contents.
 */ function fileLoader(fs) {
    return fileReject;
}
/**
 * Default file system loader that simply rejects.
 */ async function fileReject() {
    (0, _vegaUtil.error)('No file system access.');
}
/**
 * HTTP request handler factory.
 * @param {function} fetch - The Fetch API method.
 * @return {function} - An http loader with the following signature:
 *   param {string} url - The url to request.
 *   param {object} options - An options hash.
 *   return {Promise} - A promise that resolves to the file contents.
 */ function httpLoader(fetch1) {
    return fetch1 ? async function(url, options) {
        const opt = (0, _vegaUtil.extend)({}, this.options.http, options), type = options && options.response, response = await fetch1(url, opt);
        return !response.ok ? (0, _vegaUtil.error)(response.status + '' + response.statusText) : (0, _vegaUtil.isFunction)(response[type]) ? response[type]() : response.text();
    } : httpReject;
}
/**
 * Default http request handler that simply rejects.
 */ async function httpReject() {
    (0, _vegaUtil.error)('No HTTP fetch method available.');
}
const isValid = (_)=>_ != null && _ === _;
const isBoolean = (_)=>_ === 'true' || _ === 'false' || _ === true || _ === false;
const isDate = (_)=>!Number.isNaN(Date.parse(_));
const isNumber = (_)=>!Number.isNaN(+_) && !(_ instanceof Date);
const isInteger = (_)=>isNumber(_) && Number.isInteger(+_);
const typeParsers = {
    boolean: (0, _vegaUtil.toBoolean),
    integer: (0, _vegaUtil.toNumber),
    number: (0, _vegaUtil.toNumber),
    date: (0, _vegaUtil.toDate),
    string: (0, _vegaUtil.toString),
    unknown: (0, _vegaUtil.identity)
};
const typeTests = [
    isBoolean,
    isInteger,
    isNumber,
    isDate
];
const typeList = [
    'boolean',
    'integer',
    'number',
    'date'
];
function inferType(values, field) {
    if (!values || !values.length) return 'unknown';
    const n = values.length, m = typeTests.length, a = typeTests.map((_, i)=>i + 1);
    for(let i = 0, t = 0, j, value; i < n; ++i){
        value = field ? values[i][field] : values[i];
        for(j = 0; j < m; ++j)if (a[j] && isValid(value) && !typeTests[j](value)) {
            a[j] = 0;
            ++t;
            if (t === typeTests.length) return 'string';
        }
    }
    return typeList[a.reduce((u, v)=>u === 0 ? v : u, 0) - 1];
}
function inferTypes(data, fields) {
    return fields.reduce((types, field)=>{
        types[field] = inferType(data, field);
        return types;
    }, {});
}
function delimitedFormat(delimiter) {
    const parse = function(data, format) {
        const delim = {
            delimiter: delimiter
        };
        return dsv(data, format ? (0, _vegaUtil.extend)(format, delim) : delim);
    };
    parse.responseType = 'text';
    return parse;
}
function dsv(data, format) {
    if (format.header) data = format.header.map((0, _vegaUtil.stringValue)).join(format.delimiter) + '\n' + data;
    return (0, _d3Dsv.dsvFormat)(format.delimiter).parse(data + '');
}
dsv.responseType = 'text';
function isBuffer(_) {
    return typeof Buffer === 'function' && (0, _vegaUtil.isFunction)(Buffer.isBuffer) ? Buffer.isBuffer(_) : false;
}
function json(data, format) {
    const prop = format && format.property ? (0, _vegaUtil.field)(format.property) : (0, _vegaUtil.identity);
    return (0, _vegaUtil.isObject)(data) && !isBuffer(data) ? parseJSON(prop(data), format) : prop(JSON.parse(data));
}
json.responseType = 'json';
function parseJSON(data, format) {
    if (!(0, _vegaUtil.isArray)(data) && (0, _vegaUtil.isIterable)(data)) data = [
        ...data
    ];
    return format && format.copy ? JSON.parse(JSON.stringify(data)) : data;
}
const filters = {
    interior: (a, b)=>a !== b,
    exterior: (a, b)=>a === b
};
function topojson(data, format) {
    let method, object, property, filter;
    data = json(data, format);
    if (format && format.feature) {
        method = (0, _topojsonClient.feature);
        property = format.feature;
    } else if (format && format.mesh) {
        method = (0, _topojsonClient.mesh);
        property = format.mesh;
        filter = filters[format.filter];
    } else (0, _vegaUtil.error)('Missing TopoJSON feature or mesh parameter.');
    object = (object = data.objects[property]) ? method(data, object, filter) : (0, _vegaUtil.error)('Invalid TopoJSON object: ' + property);
    return object && object.features || [
        object
    ];
}
topojson.responseType = 'json';
const format = {
    dsv: dsv,
    csv: delimitedFormat(','),
    tsv: delimitedFormat('\t'),
    json: json,
    topojson: topojson
};
function formats(name, reader) {
    if (arguments.length > 1) {
        format[name] = reader;
        return this;
    } else return (0, _vegaUtil.hasOwnProperty)(format, name) ? format[name] : null;
}
function responseType(type) {
    const f = formats(type);
    return f && f.responseType || 'text';
}
function read(data, schema, timeParser, utcParser) {
    schema = schema || {};
    const reader = formats(schema.type || 'json');
    if (!reader) (0, _vegaUtil.error)('Unknown data format type: ' + schema.type);
    data = reader(data, schema);
    if (schema.parse) parse(data, schema.parse, timeParser, utcParser);
    if ((0, _vegaUtil.hasOwnProperty)(data, 'columns')) delete data.columns;
    return data;
}
function parse(data, types, timeParser, utcParser) {
    if (!data.length) return; // early exit for empty data
    const locale = (0, _vegaFormat.timeFormatDefaultLocale)();
    timeParser = timeParser || locale.timeParse;
    utcParser = utcParser || locale.utcParse;
    let fields = data.columns || Object.keys(data[0]), datum, field, i, j, n, m;
    if (types === 'auto') types = inferTypes(data, fields);
    fields = Object.keys(types);
    const parsers = fields.map((field)=>{
        const type = types[field];
        let parts, pattern;
        if (type && (type.startsWith('date:') || type.startsWith('utc:'))) {
            parts = type.split(/:(.+)?/, 2); // split on first :
            pattern = parts[1];
            if (pattern[0] === '\'' && pattern[pattern.length - 1] === '\'' || pattern[0] === '"' && pattern[pattern.length - 1] === '"') pattern = pattern.slice(1, -1);
            const parse = parts[0] === 'utc' ? utcParser : timeParser;
            return parse(pattern);
        }
        if (!typeParsers[type]) throw Error('Illegal format pattern: ' + field + ':' + type);
        return typeParsers[type];
    });
    for(i = 0, n = data.length, m = fields.length; i < n; ++i){
        datum = data[i];
        for(j = 0; j < m; ++j){
            field = fields[j];
            datum[field] = parsers[j](datum[field]);
        }
    }
}
const loader = loaderFactory(typeof fetch !== 'undefined' && fetch);

},{"a8648f2b61a45853":"cjdyz","vega-util":"kncZn","d3-dsv":"3pPXN","topojson-client":"6Ko3V","vega-format":"er6y3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cjdyz":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"bICrG","aceacb6a4531a9d2":"7IMNJ"}],"bICrG":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7IMNJ":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"3pPXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsvFormat", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csvParse", ()=>(0, _csvJs.csvParse));
parcelHelpers.export(exports, "csvParseRows", ()=>(0, _csvJs.csvParseRows));
parcelHelpers.export(exports, "csvFormat", ()=>(0, _csvJs.csvFormat));
parcelHelpers.export(exports, "csvFormatBody", ()=>(0, _csvJs.csvFormatBody));
parcelHelpers.export(exports, "csvFormatRows", ()=>(0, _csvJs.csvFormatRows));
parcelHelpers.export(exports, "csvFormatRow", ()=>(0, _csvJs.csvFormatRow));
parcelHelpers.export(exports, "csvFormatValue", ()=>(0, _csvJs.csvFormatValue));
parcelHelpers.export(exports, "tsvParse", ()=>(0, _tsvJs.tsvParse));
parcelHelpers.export(exports, "tsvParseRows", ()=>(0, _tsvJs.tsvParseRows));
parcelHelpers.export(exports, "tsvFormat", ()=>(0, _tsvJs.tsvFormat));
parcelHelpers.export(exports, "tsvFormatBody", ()=>(0, _tsvJs.tsvFormatBody));
parcelHelpers.export(exports, "tsvFormatRows", ()=>(0, _tsvJs.tsvFormatRows));
parcelHelpers.export(exports, "tsvFormatRow", ()=>(0, _tsvJs.tsvFormatRow));
parcelHelpers.export(exports, "tsvFormatValue", ()=>(0, _tsvJs.tsvFormatValue));
parcelHelpers.export(exports, "autoType", ()=>(0, _autoTypeJsDefault.default));
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _csvJs = require("./csv.js");
var _tsvJs = require("./tsv.js");
var _autoTypeJs = require("./autoType.js");
var _autoTypeJsDefault = parcelHelpers.interopDefault(_autoTypeJs);

},{"./dsv.js":"aCvUx","./csv.js":false,"./tsv.js":false,"./autoType.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aCvUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    });
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year) {
    return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Ko3V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bbox", ()=>(0, _bboxJsDefault.default));
parcelHelpers.export(exports, "feature", ()=>(0, _featureJsDefault.default));
parcelHelpers.export(exports, "mesh", ()=>(0, _meshJsDefault.default));
parcelHelpers.export(exports, "meshArcs", ()=>(0, _meshJs.meshArcs));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "mergeArcs", ()=>(0, _mergeJs.mergeArcs));
parcelHelpers.export(exports, "neighbors", ()=>(0, _neighborsJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "transform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "untransform", ()=>(0, _untransformJsDefault.default));
var _bboxJs = require("./bbox.js");
var _bboxJsDefault = parcelHelpers.interopDefault(_bboxJs);
var _featureJs = require("./feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _meshJs = require("./mesh.js");
var _meshJsDefault = parcelHelpers.interopDefault(_meshJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _neighborsJs = require("./neighbors.js");
var _neighborsJsDefault = parcelHelpers.interopDefault(_neighborsJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);
var _untransformJs = require("./untransform.js");
var _untransformJsDefault = parcelHelpers.interopDefault(_untransformJs);

},{"./bbox.js":"esQNU","./feature.js":"egYRo","./mesh.js":"f6wHU","./merge.js":"6tAuc","./neighbors.js":"7yQ4S","./quantize.js":"2X5kn","./transform.js":"9uBap","./untransform.js":"5acwS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esQNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology) {
        var t = (0, _transformJsDefault.default)(topology.transform), key, x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
        function bboxPoint(p) {
            p = t(p);
            if (p[0] < x0) x0 = p[0];
            if (p[0] > x1) x1 = p[0];
            if (p[1] < y0) y0 = p[1];
            if (p[1] > y1) y1 = p[1];
        }
        function bboxGeometry(o) {
            switch(o.type){
                case "GeometryCollection":
                    o.geometries.forEach(bboxGeometry);
                    break;
                case "Point":
                    bboxPoint(o.coordinates);
                    break;
                case "MultiPoint":
                    o.coordinates.forEach(bboxPoint);
                    break;
            }
        }
        topology.arcs.forEach(function(arc) {
            var i = -1, n = arc.length, p;
            while(++i < n){
                p = t(arc[i], i);
                if (p[0] < x0) x0 = p[0];
                if (p[0] > x1) x1 = p[0];
                if (p[1] < y0) y0 = p[1];
                if (p[1] > y1) y1 = p[1];
            }
        });
        for(key in topology.objects)bboxGeometry(topology.objects[key]);
        return [
            x0,
            y0,
            x1,
            y1
        ];
    });
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./transform.js":"9uBap","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9uBap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transform) {
        if (transform == null) return 0, _identityJsDefault.default;
        var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
        return function(input, i) {
            if (!i) x0 = y0 = 0;
            var j = 2, n = input.length, output = new Array(n);
            output[0] = (x0 += input[0]) * kx + dx;
            output[1] = (y0 += input[1]) * ky + dy;
            while(j < n)output[j] = input[j], ++j;
            return output;
        };
    });
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);

},{"./identity.js":"981JG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"981JG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"egYRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology, o) {
        if (typeof o === "string") o = topology.objects[o];
        return o.type === "GeometryCollection" ? {
            type: "FeatureCollection",
            features: o.geometries.map(function(o) {
                return feature(topology, o);
            })
        } : feature(topology, o);
    });
parcelHelpers.export(exports, "object", ()=>object);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);
function feature(topology, o) {
    var id = o.id, bbox = o.bbox, properties = o.properties == null ? {} : o.properties, geometry = object(topology, o);
    return id == null && bbox == null ? {
        type: "Feature",
        properties: properties,
        geometry: geometry
    } : bbox == null ? {
        type: "Feature",
        id: id,
        properties: properties,
        geometry: geometry
    } : {
        type: "Feature",
        id: id,
        bbox: bbox,
        properties: properties,
        geometry: geometry
    };
}
function object(topology, o) {
    var transformPoint = (0, _transformJsDefault.default)(topology.transform), arcs = topology.arcs;
    function arc(i, points) {
        if (points.length) points.pop();
        for(var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k)points.push(transformPoint(a[k], k));
        if (i < 0) (0, _reverseJsDefault.default)(points, n);
    }
    function point(p) {
        return transformPoint(p);
    }
    function line(arcs) {
        var points = [];
        for(var i = 0, n = arcs.length; i < n; ++i)arc(arcs[i], points);
        if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
        return points;
    }
    function ring(arcs) {
        var points = line(arcs);
        while(points.length < 4)points.push(points[0]); // This may happen if an arc has only two points.
        return points;
    }
    function polygon(arcs) {
        return arcs.map(ring);
    }
    function geometry(o) {
        var type = o.type, coordinates;
        switch(type){
            case "GeometryCollection":
                return {
                    type: type,
                    geometries: o.geometries.map(geometry)
                };
            case "Point":
                coordinates = point(o.coordinates);
                break;
            case "MultiPoint":
                coordinates = o.coordinates.map(point);
                break;
            case "LineString":
                coordinates = line(o.arcs);
                break;
            case "MultiLineString":
                coordinates = o.arcs.map(line);
                break;
            case "Polygon":
                coordinates = polygon(o.arcs);
                break;
            case "MultiPolygon":
                coordinates = o.arcs.map(polygon);
                break;
            default:
                return null;
        }
        return {
            type: type,
            coordinates: coordinates
        };
    }
    return geometry(o);
}

},{"./reverse.js":"8Sqq2","./transform.js":"9uBap","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Sqq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, n) {
        var t, j = array.length, i = j - n;
        while(i < --j)t = array[i], array[i++] = array[j], array[j] = t;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f6wHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology) {
        return (0, _featureJs.object)(topology, meshArcs.apply(this, arguments));
    });
parcelHelpers.export(exports, "meshArcs", ()=>meshArcs);
var _featureJs = require("./feature.js");
var _stitchJs = require("./stitch.js");
var _stitchJsDefault = parcelHelpers.interopDefault(_stitchJs);
function meshArcs(topology, object, filter) {
    var arcs, i, n;
    if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
    else for(i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i)arcs[i] = i;
    return {
        type: "MultiLineString",
        arcs: (0, _stitchJsDefault.default)(topology, arcs)
    };
}
function extractArcs(topology, object, filter) {
    var arcs = [], geomsByArc = [], geom;
    function extract0(i) {
        var j = i < 0 ? ~i : i;
        (geomsByArc[j] || (geomsByArc[j] = [])).push({
            i: i,
            g: geom
        });
    }
    function extract1(arcs) {
        arcs.forEach(extract0);
    }
    function extract2(arcs) {
        arcs.forEach(extract1);
    }
    function extract3(arcs) {
        arcs.forEach(extract2);
    }
    function geometry(o) {
        switch(geom = o, o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "LineString":
                extract1(o.arcs);
                break;
            case "MultiLineString":
            case "Polygon":
                extract2(o.arcs);
                break;
            case "MultiPolygon":
                extract3(o.arcs);
                break;
        }
    }
    geometry(object);
    geomsByArc.forEach(filter == null ? function(geoms) {
        arcs.push(geoms[0].i);
    } : function(geoms) {
        if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i);
    });
    return arcs;
}

},{"./feature.js":"egYRo","./stitch.js":"iLYKs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iLYKs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology, arcs) {
        var stitchedArcs = {}, fragmentByStart = {}, fragmentByEnd = {}, fragments = [], emptyIndex = -1;
        // Stitch empty arcs first, since they may be subsumed by other arcs.
        arcs.forEach(function(i, j) {
            var arc = topology.arcs[i < 0 ? ~i : i], t;
            if (arc.length < 3 && !arc[1][0] && !arc[1][1]) t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
        });
        arcs.forEach(function(i) {
            var e = ends(i), start = e[0], end = e[1], f, g;
            if (f = fragmentByEnd[start]) {
                delete fragmentByEnd[f.end];
                f.push(i);
                f.end = end;
                if (g = fragmentByStart[end]) {
                    delete fragmentByStart[g.start];
                    var fg = g === f ? f : f.concat(g);
                    fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
                } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
            } else if (f = fragmentByStart[end]) {
                delete fragmentByStart[f.start];
                f.unshift(i);
                f.start = start;
                if (g = fragmentByEnd[start]) {
                    delete fragmentByEnd[g.end];
                    var gf = g === f ? f : g.concat(f);
                    fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
                } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
            } else {
                f = [
                    i
                ];
                fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
            }
        });
        function ends(i) {
            var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
            if (topology.transform) p1 = [
                0,
                0
            ], arc.forEach(function(dp) {
                p1[0] += dp[0], p1[1] += dp[1];
            });
            else p1 = arc[arc.length - 1];
            return i < 0 ? [
                p1,
                p0
            ] : [
                p0,
                p1
            ];
        }
        function flush(fragmentByEnd, fragmentByStart) {
            for(var k in fragmentByEnd){
                var f = fragmentByEnd[k];
                delete fragmentByStart[f.start];
                delete f.start;
                delete f.end;
                f.forEach(function(i) {
                    stitchedArcs[i < 0 ? ~i : i] = 1;
                });
                fragments.push(f);
            }
        }
        flush(fragmentByEnd, fragmentByStart);
        flush(fragmentByStart, fragmentByEnd);
        arcs.forEach(function(i) {
            if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([
                i
            ]);
        });
        return fragments;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6tAuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology) {
        return (0, _featureJs.object)(topology, mergeArcs.apply(this, arguments));
    });
parcelHelpers.export(exports, "mergeArcs", ()=>mergeArcs);
var _featureJs = require("./feature.js");
var _stitchJs = require("./stitch.js");
var _stitchJsDefault = parcelHelpers.interopDefault(_stitchJs);
function planarRingArea(ring) {
    var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
    while(++i < n)a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
    return Math.abs(area); // Note: doubled area!
}
function mergeArcs(topology, objects) {
    var polygonsByArc = {}, polygons = [], groups = [];
    objects.forEach(geometry);
    function geometry(o) {
        switch(o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "Polygon":
                extract(o.arcs);
                break;
            case "MultiPolygon":
                o.arcs.forEach(extract);
                break;
        }
    }
    function extract(polygon) {
        polygon.forEach(function(ring) {
            ring.forEach(function(arc) {
                (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
            });
        });
        polygons.push(polygon);
    }
    function area(ring) {
        return planarRingArea((0, _featureJs.object)(topology, {
            type: "Polygon",
            arcs: [
                ring
            ]
        }).coordinates[0]);
    }
    polygons.forEach(function(polygon) {
        if (!polygon._) {
            var group = [], neighbors = [
                polygon
            ];
            polygon._ = 1;
            groups.push(group);
            while(polygon = neighbors.pop()){
                group.push(polygon);
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
                            if (!polygon._) {
                                polygon._ = 1;
                                neighbors.push(polygon);
                            }
                        });
                    });
                });
            }
        }
    });
    polygons.forEach(function(polygon) {
        delete polygon._;
    });
    return {
        type: "MultiPolygon",
        arcs: groups.map(function(polygons) {
            var arcs = [], n;
            // Extract the exterior (unique) arcs.
            polygons.forEach(function(polygon) {
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) arcs.push(arc);
                    });
                });
            });
            // Stitch the arcs into one or more rings.
            arcs = (0, _stitchJsDefault.default)(topology, arcs);
            // If more than one ring is returned,
            // at most one of these rings can be the exterior;
            // choose the one with the greatest absolute area.
            if ((n = arcs.length) > 1) {
                for(var i = 1, k = area(arcs[0]), ki, t; i < n; ++i)if ((ki = area(arcs[i])) > k) t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
            }
            return arcs;
        }).filter(function(arcs) {
            return arcs.length > 0;
        })
    };
}

},{"./feature.js":"egYRo","./stitch.js":"iLYKs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yQ4S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(objects) {
        var indexesByArc = {}, neighbors = objects.map(function() {
            return [];
        });
        function line(arcs, i) {
            arcs.forEach(function(a) {
                if (a < 0) a = ~a;
                var o = indexesByArc[a];
                if (o) o.push(i);
                else indexesByArc[a] = [
                    i
                ];
            });
        }
        function polygon(arcs, i) {
            arcs.forEach(function(arc) {
                line(arc, i);
            });
        }
        function geometry(o, i) {
            if (o.type === "GeometryCollection") o.geometries.forEach(function(o) {
                geometry(o, i);
            });
            else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
        }
        var geometryType = {
            LineString: line,
            MultiLineString: polygon,
            Polygon: polygon,
            MultiPolygon: function(arcs, i) {
                arcs.forEach(function(arc) {
                    polygon(arc, i);
                });
            }
        };
        objects.forEach(geometry);
        for(var i in indexesByArc){
            for(var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j)for(var k = j + 1; k < m; ++k){
                var ij = indexes[j], ik = indexes[k], n;
                if ((n = neighbors[ij])[i = (0, _bisectJsDefault.default)(n, ik)] !== ik) n.splice(i, 0, ik);
                if ((n = neighbors[ik])[i = (0, _bisectJsDefault.default)(n, ij)] !== ij) n.splice(i, 0, ij);
            }
        }
        return neighbors;
    });
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);

},{"./bisect.js":"8J1aa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8J1aa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, x) {
        var lo = 0, hi = a.length;
        while(lo < hi){
            var mid = lo + hi >>> 1;
            if (a[mid] < x) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2X5kn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(topology, transform) {
        if (topology.transform) throw new Error("already quantized");
        if (!transform || !transform.scale) {
            if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be \u22652");
            box = topology.bbox || (0, _bboxJsDefault.default)(topology);
            var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
            transform = {
                scale: [
                    x1 - x0 ? (x1 - x0) / (n - 1) : 1,
                    y1 - y0 ? (y1 - y0) / (n - 1) : 1
                ],
                translate: [
                    x0,
                    y0
                ]
            };
        } else box = topology.bbox;
        var t = (0, _untransformJsDefault.default)(transform), box, key, inputs = topology.objects, outputs = {};
        function quantizePoint(point) {
            return t(point);
        }
        function quantizeGeometry(input) {
            var output;
            switch(input.type){
                case "GeometryCollection":
                    output = {
                        type: "GeometryCollection",
                        geometries: input.geometries.map(quantizeGeometry)
                    };
                    break;
                case "Point":
                    output = {
                        type: "Point",
                        coordinates: quantizePoint(input.coordinates)
                    };
                    break;
                case "MultiPoint":
                    output = {
                        type: "MultiPoint",
                        coordinates: input.coordinates.map(quantizePoint)
                    };
                    break;
                default:
                    return input;
            }
            if (input.id != null) output.id = input.id;
            if (input.bbox != null) output.bbox = input.bbox;
            if (input.properties != null) output.properties = input.properties;
            return output;
        }
        function quantizeArc(input) {
            var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
            output[0] = t(input[0], 0);
            while(++i < n)if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
            if (j === 1) output[j++] = [
                0,
                0
            ]; // an arc must have at least two points
            output.length = j;
            return output;
        }
        for(key in inputs)outputs[key] = quantizeGeometry(inputs[key]);
        return {
            type: "Topology",
            bbox: box,
            transform: transform,
            objects: outputs,
            arcs: topology.arcs.map(quantizeArc)
        };
    });
var _bboxJs = require("./bbox.js");
var _bboxJsDefault = parcelHelpers.interopDefault(_bboxJs);
var _untransformJs = require("./untransform.js");
var _untransformJsDefault = parcelHelpers.interopDefault(_untransformJs);

},{"./bbox.js":"esQNU","./untransform.js":"5acwS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5acwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transform) {
        if (transform == null) return 0, _identityJsDefault.default;
        var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
        return function(input, i) {
            if (!i) x0 = y0 = 0;
            var j = 2, n = input.length, output = new Array(n), x1 = Math.round((input[0] - dx) / kx), y1 = Math.round((input[1] - dy) / ky);
            output[0] = x1 - x0, x0 = x1;
            output[1] = y1 - y0, y0 = y1;
            while(j < n)output[j] = input[j], ++j;
            return output;
        };
    });
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);

},{"./identity.js":"981JG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"er6y3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLocale", ()=>defaultLocale);
parcelHelpers.export(exports, "locale", ()=>locale);
parcelHelpers.export(exports, "numberFormatDefaultLocale", ()=>numberFormatDefaultLocale);
parcelHelpers.export(exports, "numberFormatLocale", ()=>numberFormatLocale);
parcelHelpers.export(exports, "resetDefaultLocale", ()=>resetDefaultLocale);
parcelHelpers.export(exports, "resetNumberFormatDefaultLocale", ()=>resetNumberFormatDefaultLocale);
parcelHelpers.export(exports, "resetTimeFormatDefaultLocale", ()=>resetTimeFormatDefaultLocale);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>timeFormatDefaultLocale);
parcelHelpers.export(exports, "timeFormatLocale", ()=>timeFormatLocale);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _vegaTime = require("vega-time");
var _vegaUtil = require("vega-util");
var _d3TimeFormat = require("d3-time-format");
function memoize(method) {
    const cache = {};
    return (spec)=>cache[spec] || (cache[spec] = method(spec));
}
function trimZeroes(numberFormat, decimalChar) {
    return (x)=>{
        const str = numberFormat(x), dec = str.indexOf(decimalChar);
        if (dec < 0) return str;
        let idx = rightmostDigit(str, dec);
        const end = idx < str.length ? str.slice(idx) : '';
        while(--idx > dec)if (str[idx] !== '0') {
            ++idx;
            break;
        }
        return str.slice(0, idx) + end;
    };
}
function rightmostDigit(str, dec) {
    let i = str.lastIndexOf('e'), c;
    if (i > 0) return i;
    for(i = str.length; --i > dec;){
        c = str.charCodeAt(i);
        if (c >= 48 && c <= 57) return i + 1; // is digit
    }
}
function numberLocale(locale) {
    const format = memoize(locale.format), formatPrefix = locale.formatPrefix;
    return {
        format,
        formatPrefix,
        formatFloat (spec) {
            const s = (0, _d3Format.formatSpecifier)(spec || ',');
            if (s.precision == null) {
                s.precision = 12;
                switch(s.type){
                    case '%':
                        s.precision -= 2;
                        break;
                    case 'e':
                        s.precision -= 1;
                        break;
                }
                return trimZeroes(format(s), // number format
                format('.1f')(1)[1] // decimal point character
                );
            } else return format(s);
        },
        formatSpan (start, stop, count, specifier) {
            specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ',f' : specifier);
            const step = (0, _d3Array.tickStep)(start, stop, count), value = Math.max(Math.abs(start), Math.abs(stop));
            let precision;
            if (specifier.precision == null) switch(specifier.type){
                case 's':
                    if (!isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
                    return formatPrefix(specifier, value);
                case '':
                case 'e':
                case 'g':
                case 'p':
                case 'r':
                    if (!isNaN(precision = (0, _d3Format.precisionRound)(step, value))) specifier.precision = precision - (specifier.type === 'e');
                    break;
                case 'f':
                case '%':
                    if (!isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === '%') * 2;
                    break;
            }
            return format(specifier);
        }
    };
}
let defaultNumberLocale;
resetNumberFormatDefaultLocale();
function resetNumberFormatDefaultLocale() {
    return defaultNumberLocale = numberLocale({
        format: (0, _d3Format.format),
        formatPrefix: (0, _d3Format.formatPrefix)
    });
}
function numberFormatLocale(definition) {
    return numberLocale((0, _d3Format.formatLocale)(definition));
}
function numberFormatDefaultLocale(definition) {
    return arguments.length ? defaultNumberLocale = numberFormatLocale(definition) : defaultNumberLocale;
}
function timeMultiFormat(format, interval, spec) {
    spec = spec || {};
    if (!(0, _vegaUtil.isObject)(spec)) (0, _vegaUtil.error)(`Invalid time multi-format specifier: ${spec}`);
    const second = interval((0, _vegaTime.SECONDS)), minute = interval((0, _vegaTime.MINUTES)), hour = interval((0, _vegaTime.HOURS)), day = interval((0, _vegaTime.DATE)), week = interval((0, _vegaTime.WEEK)), month = interval((0, _vegaTime.MONTH)), quarter = interval((0, _vegaTime.QUARTER)), year = interval((0, _vegaTime.YEAR)), L = format(spec[0, _vegaTime.MILLISECONDS] || '.%L'), S = format(spec[0, _vegaTime.SECONDS] || ':%S'), M = format(spec[0, _vegaTime.MINUTES] || '%I:%M'), H = format(spec[0, _vegaTime.HOURS] || '%I %p'), d = format(spec[0, _vegaTime.DATE] || spec[0, _vegaTime.DAY] || '%a %d'), w = format(spec[0, _vegaTime.WEEK] || '%b %d'), m = format(spec[0, _vegaTime.MONTH] || '%B'), q = format(spec[0, _vegaTime.QUARTER] || '%B'), y = format(spec[0, _vegaTime.YEAR] || '%Y');
    return (date)=>(second(date) < date ? L : minute(date) < date ? S : hour(date) < date ? M : day(date) < date ? H : month(date) < date ? week(date) < date ? d : w : year(date) < date ? quarter(date) < date ? m : q : y)(date);
}
function timeLocale(locale) {
    const timeFormat = memoize(locale.format), utcFormat = memoize(locale.utcFormat);
    return {
        timeFormat: (spec)=>(0, _vegaUtil.isString)(spec) ? timeFormat(spec) : timeMultiFormat(timeFormat, (0, _vegaTime.timeInterval), spec),
        utcFormat: (spec)=>(0, _vegaUtil.isString)(spec) ? utcFormat(spec) : timeMultiFormat(utcFormat, (0, _vegaTime.utcInterval), spec),
        timeParse: memoize(locale.parse),
        utcParse: memoize(locale.utcParse)
    };
}
let defaultTimeLocale;
resetTimeFormatDefaultLocale();
function resetTimeFormatDefaultLocale() {
    return defaultTimeLocale = timeLocale({
        format: (0, _d3TimeFormat.timeFormat),
        parse: (0, _d3TimeFormat.timeParse),
        utcFormat: (0, _d3TimeFormat.utcFormat),
        utcParse: (0, _d3TimeFormat.utcParse)
    });
}
function timeFormatLocale(definition) {
    return timeLocale((0, _d3TimeFormat.timeFormatLocale)(definition));
}
function timeFormatDefaultLocale(definition) {
    return arguments.length ? defaultTimeLocale = timeFormatLocale(definition) : defaultTimeLocale;
}
const createLocale = (number, time)=>(0, _vegaUtil.extend)({}, number, time);
function locale(numberSpec, timeSpec) {
    const number = numberSpec ? numberFormatLocale(numberSpec) : numberFormatDefaultLocale();
    const time = timeSpec ? timeFormatLocale(timeSpec) : timeFormatDefaultLocale();
    return createLocale(number, time);
}
function defaultLocale(numberSpec, timeSpec) {
    const args = arguments.length;
    if (args && args !== 2) (0, _vegaUtil.error)('defaultLocale expects either zero or two arguments.');
    return args ? createLocale(numberFormatDefaultLocale(numberSpec), timeFormatDefaultLocale(timeSpec)) : createLocale(numberFormatDefaultLocale(), timeFormatDefaultLocale());
}
function resetDefaultLocale() {
    resetNumberFormatDefaultLocale();
    resetTimeFormatDefaultLocale();
    return defaultLocale();
}

},{"d3-array":"4pSqo","d3-format":"9IytR","vega-time":"c8K2C","vega-util":"kncZn","d3-time-format":"l85y1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pSqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "blur", ()=>(0, _blurJs.blur));
parcelHelpers.export(exports, "blur2", ()=>(0, _blurJs.blur2));
parcelHelpers.export(exports, "blurImage", ()=>(0, _blurJs.blurImage));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "flatGroup", ()=>(0, _groupJs.flatGroup));
parcelHelpers.export(exports, "flatRollup", ()=>(0, _groupJs.flatRollup));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "medianIndex", ()=>(0, _medianJs.medianIndex));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "mode", ()=>(0, _modeJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileIndex", ()=>(0, _quantileJs.quantileIndex));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "rank", ()=>(0, _rankJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _blurJs = require("./blur.js");
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _modeJs = require("./mode.js");
var _modeJsDefault = parcelHelpers.interopDefault(_modeJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _rankJs = require("./rank.js");
var _rankJsDefault = parcelHelpers.interopDefault(_rankJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"80NTU","./ascending.js":"grXWP","./bisector.js":"2pLFs","./blur.js":"9jCwi","./count.js":"agXtf","./cross.js":"8IaWn","./cumsum.js":"lOdNE","./descending.js":"2Vb2b","./deviation.js":"bPVzr","./extent.js":"brRYD","./fsum.js":"2G8br","./group.js":"eL2qj","./groupSort.js":"4fyHL","./bin.js":"fSROM","./threshold/freedmanDiaconis.js":"5695x","./threshold/scott.js":"gaOXY","./threshold/sturges.js":"e0V2b","./max.js":"aVqVJ","./maxIndex.js":"4eSGa","./mean.js":"gXbZT","./median.js":"dqpfK","./merge.js":"fe3e6","./min.js":"76icn","./minIndex.js":"9PbIB","./mode.js":"bwUgW","./nice.js":"kOVv9","./pairs.js":"bugvm","./permute.js":"3Vyjb","./quantile.js":"tnk8R","./quickselect.js":"dxirM","./range.js":"fkSdr","./rank.js":"8xCIw","./least.js":"bnIXz","./leastIndex.js":"iCueW","./greatest.js":"9Y64F","./greatestIndex.js":"jmfa3","./scan.js":"7QZf1","./shuffle.js":"itv30","./sum.js":"ktqNc","./ticks.js":"9j7q7","./transpose.js":"am3vK","./variance.js":"dexTn","./zip.js":"g92aw","./every.js":"drHSk","./some.js":"eSYok","./filter.js":"iXS2l","./map.js":"4slZj","./reduce.js":"hNpZ3","./reverse.js":"jBJ8J","./sort.js":"3eB6g","./difference.js":"kmDRW","./disjoint.js":"cePzP","./intersection.js":"1O8YC","./subset.js":"7OjXO","./superset.js":"eVs3r","./union.js":"92REI","internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80NTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"grXWP","./bisector.js":"2pLFs","./number.js":"6GQY1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"grXWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ascending);
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2pLFs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bisector);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"grXWP","./descending.js":"2Vb2b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Vb2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>descending);
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6GQY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
parcelHelpers.export(exports, "numbers", ()=>numbers);
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9jCwi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blur", ()=>blur);
parcelHelpers.export(exports, "blur2", ()=>blur2);
parcelHelpers.export(exports, "blurImage", ()=>blurImage);
function blur(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const blur2 = Blur2(blurf);
const blurImage = Blur2(blurfImage);
function Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width, height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        } else if (blurx) {
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
        } else if (blury) {
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function blurfImage(radius) {
    const blur = blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"agXtf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8IaWn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lOdNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bPVzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"dexTn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dexTn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"brRYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extent);
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2G8br":[function(require,module,exports,__globalThis) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eL2qj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "flatGroup", ()=>flatGroup);
parcelHelpers.export(exports, "flatRollup", ()=>flatRollup);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"3QR3P","./identity.js":"cehw1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3QR3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cehw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4fyHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"grXWP","./group.js":"eL2qj","./sort.js":"3eB6g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eB6g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
parcelHelpers.export(exports, "compareDefined", ()=>compareDefined);
parcelHelpers.export(exports, "ascendingDefined", ()=>ascendingDefined);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = (0, _ascendingJsDefault.default)) {
    if (compare === (0, _ascendingJsDefault.default)) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"./ascending.js":"grXWP","./permute.js":"3Vyjb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Vyjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>permute);
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSROM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bin);
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
function bin() {
    var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
            tz = (0, _ticksJsDefault.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                    const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.isArray(_) ? (0, _arrayJs.slice).call(_) : _), histogram) : threshold;
    };
    return histogram;
}

},{"./array.js":"3TdMz","./bisect.js":"80NTU","./constant.js":"lBtZM","./extent.js":"brRYD","./identity.js":"cehw1","./nice.js":"kOVv9","./ticks.js":"9j7q7","./threshold/sturges.js":"e0V2b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3TdMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lBtZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constant);
function constant(x) {
    return ()=>x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kOVv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"9j7q7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9j7q7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ticks);
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e0V2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdSturges);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
function thresholdSturges(values) {
    return Math.max(1, Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1);
}

},{"../count.js":"agXtf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5695x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdFreedmanDiaconis);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function thresholdFreedmanDiaconis(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

},{"../count.js":"agXtf","../quantile.js":"tnk8R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"tnk8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
parcelHelpers.export(exports, "quantileIndex", ()=>quantileIndex);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _sortJs = require("./sort.js");
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function quantileIndex(values, p, valueof = (0, _numberJsDefault.default)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, _numberJsDefault.default)(valueof(values[i], i, values)));
    if (p <= 0) return (0, _minIndexJsDefault.default)(numbers);
    if (p >= 1) return (0, _maxIndexJsDefault.default)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, _quickselectJsDefault.default)(index, i, 0, j, (i, j)=>(0, _sortJs.ascendingDefined)(numbers[i], numbers[j]));
    i = (0, _greatestJsDefault.default)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}

},{"./max.js":"aVqVJ","./maxIndex.js":"4eSGa","./min.js":"76icn","./minIndex.js":"9PbIB","./quickselect.js":"dxirM","./number.js":"6GQY1","./sort.js":"3eB6g","./greatest.js":"9Y64F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aVqVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4eSGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76icn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9PbIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dxirM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _sortJs = require("./sort.js");
function quickselect(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, _sortJs.ascendingDefined) : (0, _sortJs.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./sort.js":"3eB6g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Y64F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"grXWP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gaOXY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdScott);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
function thresholdScott(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _deviationJsDefault.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

},{"../count.js":"agXtf","../deviation.js":"bPVzr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gXbZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dqpfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>median);
parcelHelpers.export(exports, "medianIndex", ()=>medianIndex);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function median(values, valueof) {
    return (0, _quantileJsDefault.default)(values, 0.5, valueof);
}
function medianIndex(values, valueof) {
    return (0, _quantileJs.quantileIndex)(values, 0.5, valueof);
}

},{"./quantile.js":"tnk8R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fe3e6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwUgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mode);
var _internmap = require("internmap");
function mode(values, valueof) {
    const counts = new (0, _internmap.InternMap)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bugvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fkSdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>range);
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8xCIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rank);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _sortJs = require("./sort.js");
function rank(values, valueof = (0, _ascendingJsDefault.default)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, _ascendingJsDefault.default);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, _ascendingJsDefault.default) ? (i, j)=>(0, _sortJs.ascendingDefined)(V[i], V[j]) : (0, _sortJs.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"./ascending.js":"grXWP","./sort.js":"3eB6g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnIXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"grXWP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iCueW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"grXWP","./minIndex.js":"9PbIB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jmfa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"grXWP","./maxIndex.js":"4eSGa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QZf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"iCueW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"itv30":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ktqNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"am3vK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transpose);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"./min.js":"76icn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g92aw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>zip);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
function zip() {
    return (0, _transposeJsDefault.default)(arguments);
}

},{"./transpose.js":"am3vK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"drHSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eSYok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iXS2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4slZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hNpZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBJ8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kmDRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
var _internmap = require("internmap");
function difference(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cePzP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
var _internmap = require("internmap");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, _internmap.InternSet)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1O8YC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _internmap = require("internmap");
function intersection(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof (0, _internmap.InternSet) ? values : new (0, _internmap.InternSet)(values);
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7OjXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"eVs3r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVs3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92REI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
var _internmap = require("internmap");
function union(...others) {
    const set = new (0, _internmap.InternSet)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9IytR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"fNAkW","./locale.js":"5rSKU","./formatSpecifier.js":"4Dwks","./precisionFixed.js":"amWFt","./precisionPrefix.js":"3cedQ","./precisionRound.js":"ay474","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fNAkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"5rSKU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5rSKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"8V9SR","./formatGroup.js":"1TWks","./formatNumerals.js":"26t5o","./formatSpecifier.js":"4Dwks","./formatTrim.js":"k0jrv","./formatTypes.js":"eHFBL","./formatPrefixAuto.js":"6I2tL","./identity.js":"dgEFq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8V9SR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"aVkiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aVkiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1TWks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"26t5o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Dwks":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k0jrv":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eHFBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, _formatDecimalJsDefault.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRoundedJsDefault.default)(x * 100, p),
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"./formatDecimal.js":"aVkiP","./formatPrefixAuto.js":"6I2tL","./formatRounded.js":"g2k00","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6I2tL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"aVkiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2k00":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"aVkiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dgEFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"amWFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"8V9SR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cedQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"8V9SR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ay474":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"8V9SR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c8K2C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE", ()=>DATE);
parcelHelpers.export(exports, "DAY", ()=>DAY);
parcelHelpers.export(exports, "DAYOFYEAR", ()=>DAYOFYEAR);
parcelHelpers.export(exports, "HOURS", ()=>HOURS);
parcelHelpers.export(exports, "MILLISECONDS", ()=>MILLISECONDS);
parcelHelpers.export(exports, "MINUTES", ()=>MINUTES);
parcelHelpers.export(exports, "MONTH", ()=>MONTH);
parcelHelpers.export(exports, "QUARTER", ()=>QUARTER);
parcelHelpers.export(exports, "SECONDS", ()=>SECONDS);
parcelHelpers.export(exports, "TIME_UNITS", ()=>TIME_UNITS);
parcelHelpers.export(exports, "WEEK", ()=>WEEK);
parcelHelpers.export(exports, "YEAR", ()=>YEAR);
parcelHelpers.export(exports, "dayofyear", ()=>dayofyear);
parcelHelpers.export(exports, "timeBin", ()=>bin);
parcelHelpers.export(exports, "timeFloor", ()=>timeFloor);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "timeOffset", ()=>timeOffset);
parcelHelpers.export(exports, "timeSequence", ()=>timeSequence);
parcelHelpers.export(exports, "timeUnitSpecifier", ()=>timeUnitSpecifier);
parcelHelpers.export(exports, "timeUnits", ()=>timeUnits);
parcelHelpers.export(exports, "utcFloor", ()=>utcFloor);
parcelHelpers.export(exports, "utcInterval", ()=>utcInterval);
parcelHelpers.export(exports, "utcOffset", ()=>utcOffset);
parcelHelpers.export(exports, "utcSequence", ()=>utcSequence);
parcelHelpers.export(exports, "utcdayofyear", ()=>utcdayofyear);
parcelHelpers.export(exports, "utcweek", ()=>utcweek);
parcelHelpers.export(exports, "week", ()=>week);
var _vegaUtil = require("vega-util");
var _d3Time = require("d3-time");
var _d3Array = require("d3-array");
const YEAR = 'year';
const QUARTER = 'quarter';
const MONTH = 'month';
const WEEK = 'week';
const DATE = 'date';
const DAY = 'day';
const DAYOFYEAR = 'dayofyear';
const HOURS = 'hours';
const MINUTES = 'minutes';
const SECONDS = 'seconds';
const MILLISECONDS = 'milliseconds';
const TIME_UNITS = [
    YEAR,
    QUARTER,
    MONTH,
    WEEK,
    DATE,
    DAY,
    DAYOFYEAR,
    HOURS,
    MINUTES,
    SECONDS,
    MILLISECONDS
];
const UNITS = TIME_UNITS.reduce((o, u, i)=>(o[u] = 1 + i, o), {});
function timeUnits(units) {
    const u = (0, _vegaUtil.array)(units).slice(), m = {};
    // check validity
    if (!u.length) (0, _vegaUtil.error)('Missing time unit.');
    u.forEach((unit)=>{
        if ((0, _vegaUtil.hasOwnProperty)(UNITS, unit)) m[unit] = 1;
        else (0, _vegaUtil.error)(`Invalid time unit: ${unit}.`);
    });
    const numTypes = (m[WEEK] || m[DAY] ? 1 : 0) + (m[QUARTER] || m[MONTH] || m[DATE] ? 1 : 0) + (m[DAYOFYEAR] ? 1 : 0);
    if (numTypes > 1) (0, _vegaUtil.error)(`Incompatible time units: ${units}`);
    // ensure proper sort order
    u.sort((a, b)=>UNITS[a] - UNITS[b]);
    return u;
}
const defaultSpecifiers = {
    [YEAR]: '%Y ',
    [QUARTER]: 'Q%q ',
    [MONTH]: '%b ',
    [DATE]: '%d ',
    [WEEK]: 'W%U ',
    [DAY]: '%a ',
    [DAYOFYEAR]: '%j ',
    [HOURS]: '%H:00',
    [MINUTES]: '00:%M',
    [SECONDS]: ':%S',
    [MILLISECONDS]: '.%L',
    [`${YEAR}-${MONTH}`]: '%Y-%m ',
    [`${YEAR}-${MONTH}-${DATE}`]: '%Y-%m-%d ',
    [`${HOURS}-${MINUTES}`]: '%H:%M'
};
function timeUnitSpecifier(units, specifiers) {
    const s = (0, _vegaUtil.extend)({}, defaultSpecifiers, specifiers), u = timeUnits(units), n = u.length;
    let fmt = '', start = 0, end, key;
    for(start = 0; start < n;)for(end = u.length; end > start; --end){
        key = u.slice(start, end).join('-');
        if (s[key] != null) {
            fmt += s[key];
            start = end;
            break;
        }
    }
    return fmt.trim();
}
const t0 = new Date();
function localYear(y) {
    t0.setFullYear(y);
    t0.setMonth(0);
    t0.setDate(1);
    t0.setHours(0, 0, 0, 0);
    return t0;
}
function dayofyear(d) {
    return localDayOfYear(new Date(d));
}
function week(d) {
    return localWeekNum(new Date(d));
}
function localDayOfYear(d) {
    return (0, _d3Time.timeDay).count(localYear(d.getFullYear()) - 1, d);
}
function localWeekNum(d) {
    return (0, _d3Time.timeWeek).count(localYear(d.getFullYear()) - 1, d);
}
function localFirst(y) {
    return localYear(y).getDay();
}
function localDate(y, m, d, H, M, S, L) {
    if (0 <= y && y < 100) {
        const date = new Date(-1, m, d, H, M, S, L);
        date.setFullYear(y);
        return date;
    }
    return new Date(y, m, d, H, M, S, L);
}
function utcdayofyear(d) {
    return utcDayOfYear(new Date(d));
}
function utcweek(d) {
    return utcWeekNum(new Date(d));
}
function utcDayOfYear(d) {
    const y = Date.UTC(d.getUTCFullYear(), 0, 1);
    return (0, _d3Time.utcDay).count(y - 1, d);
}
function utcWeekNum(d) {
    const y = Date.UTC(d.getUTCFullYear(), 0, 1);
    return (0, _d3Time.utcWeek).count(y - 1, d);
}
function utcFirst(y) {
    t0.setTime(Date.UTC(y, 0, 1));
    return t0.getUTCDay();
}
function utcDate(y, m, d, H, M, S, L) {
    if (0 <= y && y < 100) {
        const date = new Date(Date.UTC(-1, m, d, H, M, S, L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(y, m, d, H, M, S, L));
}
function floor(units, step, get, inv, newDate) {
    const s = step || 1, b = (0, _vegaUtil.peek)(units), _ = (unit, p, key)=>{
        key = key || unit;
        return getUnit(get[key], inv[key], unit === b && s, p);
    };
    const t = new Date(), u = (0, _vegaUtil.toSet)(units), y = u[YEAR] ? _(YEAR) : (0, _vegaUtil.constant)(2012), m = u[MONTH] ? _(MONTH) : u[QUARTER] ? _(QUARTER) : (0, _vegaUtil.zero), d = u[WEEK] && u[DAY] ? _(DAY, 1, WEEK + DAY) : u[WEEK] ? _(WEEK, 1) : u[DAY] ? _(DAY, 1) : u[DATE] ? _(DATE, 1) : u[DAYOFYEAR] ? _(DAYOFYEAR, 1) : (0, _vegaUtil.one), H = u[HOURS] ? _(HOURS) : (0, _vegaUtil.zero), M = u[MINUTES] ? _(MINUTES) : (0, _vegaUtil.zero), S = u[SECONDS] ? _(SECONDS) : (0, _vegaUtil.zero), L = u[MILLISECONDS] ? _(MILLISECONDS) : (0, _vegaUtil.zero);
    return function(v) {
        t.setTime(+v);
        const year = y(t);
        return newDate(year, m(t), d(t, year), H(t), M(t), S(t), L(t));
    };
}
function getUnit(f, inv, step, phase) {
    const u = step <= 1 ? f : phase ? (d, y)=>phase + step * Math.floor((f(d, y) - phase) / step) : (d, y)=>step * Math.floor(f(d, y) / step);
    return inv ? (d, y)=>inv(u(d, y), y) : u;
}
// returns the day of the year based on week number, day of week,
// and the day of the week for the first day of the year
function weekday(week, day, firstDay) {
    return day + week * 7 - (firstDay + 6) % 7;
}
// -- LOCAL TIME --
const localGet = {
    [YEAR]: (d)=>d.getFullYear(),
    [QUARTER]: (d)=>Math.floor(d.getMonth() / 3),
    [MONTH]: (d)=>d.getMonth(),
    [DATE]: (d)=>d.getDate(),
    [HOURS]: (d)=>d.getHours(),
    [MINUTES]: (d)=>d.getMinutes(),
    [SECONDS]: (d)=>d.getSeconds(),
    [MILLISECONDS]: (d)=>d.getMilliseconds(),
    [DAYOFYEAR]: (d)=>localDayOfYear(d),
    [WEEK]: (d)=>localWeekNum(d),
    [WEEK + DAY]: (d, y)=>weekday(localWeekNum(d), d.getDay(), localFirst(y)),
    [DAY]: (d, y)=>weekday(1, d.getDay(), localFirst(y))
};
const localInv = {
    [QUARTER]: (q)=>3 * q,
    [WEEK]: (w, y)=>weekday(w, 0, localFirst(y))
};
function timeFloor(units, step) {
    return floor(units, step || 1, localGet, localInv, localDate);
}
// -- UTC TIME --
const utcGet = {
    [YEAR]: (d)=>d.getUTCFullYear(),
    [QUARTER]: (d)=>Math.floor(d.getUTCMonth() / 3),
    [MONTH]: (d)=>d.getUTCMonth(),
    [DATE]: (d)=>d.getUTCDate(),
    [HOURS]: (d)=>d.getUTCHours(),
    [MINUTES]: (d)=>d.getUTCMinutes(),
    [SECONDS]: (d)=>d.getUTCSeconds(),
    [MILLISECONDS]: (d)=>d.getUTCMilliseconds(),
    [DAYOFYEAR]: (d)=>utcDayOfYear(d),
    [WEEK]: (d)=>utcWeekNum(d),
    [DAY]: (d, y)=>weekday(1, d.getUTCDay(), utcFirst(y)),
    [WEEK + DAY]: (d, y)=>weekday(utcWeekNum(d), d.getUTCDay(), utcFirst(y))
};
const utcInv = {
    [QUARTER]: (q)=>3 * q,
    [WEEK]: (w, y)=>weekday(w, 0, utcFirst(y))
};
function utcFloor(units, step) {
    return floor(units, step || 1, utcGet, utcInv, utcDate);
}
const timeIntervals = {
    [YEAR]: (0, _d3Time.timeYear),
    [QUARTER]: (0, _d3Time.timeMonth).every(3),
    [MONTH]: (0, _d3Time.timeMonth),
    [WEEK]: (0, _d3Time.timeWeek),
    [DATE]: (0, _d3Time.timeDay),
    [DAY]: (0, _d3Time.timeDay),
    [DAYOFYEAR]: (0, _d3Time.timeDay),
    [HOURS]: (0, _d3Time.timeHour),
    [MINUTES]: (0, _d3Time.timeMinute),
    [SECONDS]: (0, _d3Time.timeSecond),
    [MILLISECONDS]: (0, _d3Time.timeMillisecond)
};
const utcIntervals = {
    [YEAR]: (0, _d3Time.utcYear),
    [QUARTER]: (0, _d3Time.utcMonth).every(3),
    [MONTH]: (0, _d3Time.utcMonth),
    [WEEK]: (0, _d3Time.utcWeek),
    [DATE]: (0, _d3Time.utcDay),
    [DAY]: (0, _d3Time.utcDay),
    [DAYOFYEAR]: (0, _d3Time.utcDay),
    [HOURS]: (0, _d3Time.utcHour),
    [MINUTES]: (0, _d3Time.utcMinute),
    [SECONDS]: (0, _d3Time.utcSecond),
    [MILLISECONDS]: (0, _d3Time.utcMillisecond)
};
function timeInterval(unit) {
    return timeIntervals[unit];
}
function utcInterval(unit) {
    return utcIntervals[unit];
}
function offset(ival, date, step) {
    return ival ? ival.offset(date, step) : undefined;
}
function timeOffset(unit, date, step) {
    return offset(timeInterval(unit), date, step);
}
function utcOffset(unit, date, step) {
    return offset(utcInterval(unit), date, step);
}
function sequence(ival, start, stop, step) {
    return ival ? ival.range(start, stop, step) : undefined;
}
function timeSequence(unit, start, stop, step) {
    return sequence(timeInterval(unit), start, stop, step);
}
function utcSequence(unit, start, stop, step) {
    return sequence(utcInterval(unit), start, stop, step);
}
const durationSecond = 1000, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365;
const Milli = [
    YEAR,
    MONTH,
    DATE,
    HOURS,
    MINUTES,
    SECONDS,
    MILLISECONDS
], Seconds = Milli.slice(0, -1), Minutes = Seconds.slice(0, -1), Hours = Minutes.slice(0, -1), Day = Hours.slice(0, -1), Week = [
    YEAR,
    WEEK
], Month = [
    YEAR,
    MONTH
], Year = [
    YEAR
];
const intervals = [
    [
        Seconds,
        1,
        durationSecond
    ],
    [
        Seconds,
        5,
        5 * durationSecond
    ],
    [
        Seconds,
        15,
        15 * durationSecond
    ],
    [
        Seconds,
        30,
        30 * durationSecond
    ],
    [
        Minutes,
        1,
        durationMinute
    ],
    [
        Minutes,
        5,
        5 * durationMinute
    ],
    [
        Minutes,
        15,
        15 * durationMinute
    ],
    [
        Minutes,
        30,
        30 * durationMinute
    ],
    [
        Hours,
        1,
        durationHour
    ],
    [
        Hours,
        3,
        3 * durationHour
    ],
    [
        Hours,
        6,
        6 * durationHour
    ],
    [
        Hours,
        12,
        12 * durationHour
    ],
    [
        Day,
        1,
        durationDay
    ],
    [
        Week,
        1,
        durationWeek
    ],
    [
        Month,
        1,
        durationMonth
    ],
    [
        Month,
        3,
        3 * durationMonth
    ],
    [
        Year,
        1,
        durationYear
    ]
];
function bin(opt) {
    const ext = opt.extent, max = opt.maxbins || 40, target = Math.abs((0, _vegaUtil.span)(ext)) / max;
    let i = (0, _d3Array.bisector)((i)=>i[2]).right(intervals, target), units, step;
    if (i === intervals.length) units = Year, step = (0, _d3Array.tickStep)(ext[0] / durationYear, ext[1] / durationYear, max);
    else if (i) {
        i = intervals[target / intervals[i - 1][2] < intervals[i][2] / target ? i - 1 : i];
        units = i[0];
        step = i[1];
    } else {
        units = Milli;
        step = Math.max((0, _d3Array.tickStep)(ext[0], ext[1], max), 1);
    }
    return {
        units,
        step
    };
}

},{"vega-util":"kncZn","d3-time":"5UzaV","d3-array":"4pSqo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5UzaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJs.timeInterval));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJs.timeMinute));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.timeMinutes));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _minuteJs.utcMinute));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _minuteJs.utcMinutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJs.timeHour));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.timeHours));
parcelHelpers.export(exports, "utcHour", ()=>(0, _hourJs.utcHour));
parcelHelpers.export(exports, "utcHours", ()=>(0, _hourJs.utcHours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJs.timeDay));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.timeDays));
parcelHelpers.export(exports, "utcDay", ()=>(0, _dayJs.utcDay));
parcelHelpers.export(exports, "utcDays", ()=>(0, _dayJs.utcDays));
parcelHelpers.export(exports, "unixDay", ()=>(0, _dayJs.unixDay));
parcelHelpers.export(exports, "unixDays", ()=>(0, _dayJs.unixDays));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.timeMonday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.timeMondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.timeTuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.timeTuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.timeWednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.timeWednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.timeThursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.timeThursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.timeFriday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.timeFridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.timeSaturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.timeSaturdays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _weekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _weekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _weekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _weekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _weekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _weekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _weekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _weekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _weekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _weekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _weekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _weekJs.utcSaturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJs.timeMonth));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.timeMonths));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _monthJs.utcMonth));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _monthJs.utcMonths));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJs.timeYear));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.timeYears));
parcelHelpers.export(exports, "utcYear", ()=>(0, _yearJs.utcYear));
parcelHelpers.export(exports, "utcYears", ()=>(0, _yearJs.utcYears));
parcelHelpers.export(exports, "utcTicks", ()=>(0, _ticksJs.utcTicks));
parcelHelpers.export(exports, "utcTickInterval", ()=>(0, _ticksJs.utcTickInterval));
parcelHelpers.export(exports, "timeTicks", ()=>(0, _ticksJs.timeTicks));
parcelHelpers.export(exports, "timeTickInterval", ()=>(0, _ticksJs.timeTickInterval));
var _intervalJs = require("./interval.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
var _ticksJs = require("./ticks.js");

},{"./interval.js":false,"./millisecond.js":"5ZpfR","./second.js":"fAm1a","./minute.js":"dTJQZ","./hour.js":"iD1qs","./day.js":"ckWH7","./week.js":"k6n3C","./month.js":"84iEq","./year.js":"lOZjL","./ticks.js":"6WIS9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8b01o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
const t0 = new Date, t1 = new Date;
function timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return timeInterval((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ZpfR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecond", ()=>millisecond);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
const millisecond = (0, _intervalJs.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const milliseconds = millisecond.range;

},{"./interval.js":"8b01o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fAm1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "second", ()=>second);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const second = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const seconds = second.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Rr4E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
parcelHelpers.export(exports, "durationMonth", ()=>durationMonth);
parcelHelpers.export(exports, "durationYear", ()=>durationYear);
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dTJQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMinute", ()=>timeMinute);
parcelHelpers.export(exports, "timeMinutes", ()=>timeMinutes);
parcelHelpers.export(exports, "utcMinute", ()=>utcMinute);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const timeMinutes = timeMinute.range;
const utcMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const utcMinutes = utcMinute.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iD1qs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeHour", ()=>timeHour);
parcelHelpers.export(exports, "timeHours", ()=>timeHours);
parcelHelpers.export(exports, "utcHour", ()=>utcHour);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getHours();
});
const timeHours = timeHour.range;
const utcHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const utcHours = utcHour.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ckWH7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDay", ()=>timeDay);
parcelHelpers.export(exports, "timeDays", ()=>timeDays);
parcelHelpers.export(exports, "utcDay", ()=>utcDay);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
parcelHelpers.export(exports, "unixDay", ()=>unixDay);
parcelHelpers.export(exports, "unixDays", ()=>unixDays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeDay = (0, _intervalJs.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay), (date)=>date.getDate() - 1);
const timeDays = timeDay.range;
const utcDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const utcDays = utcDay.range;
const unixDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return Math.floor(date / (0, _durationJs.durationDay));
});
const unixDays = unixDay.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6n3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeSunday", ()=>timeSunday);
parcelHelpers.export(exports, "timeMonday", ()=>timeMonday);
parcelHelpers.export(exports, "timeTuesday", ()=>timeTuesday);
parcelHelpers.export(exports, "timeWednesday", ()=>timeWednesday);
parcelHelpers.export(exports, "timeThursday", ()=>timeThursday);
parcelHelpers.export(exports, "timeFriday", ()=>timeFriday);
parcelHelpers.export(exports, "timeSaturday", ()=>timeSaturday);
parcelHelpers.export(exports, "timeSundays", ()=>timeSundays);
parcelHelpers.export(exports, "timeMondays", ()=>timeMondays);
parcelHelpers.export(exports, "timeTuesdays", ()=>timeTuesdays);
parcelHelpers.export(exports, "timeWednesdays", ()=>timeWednesdays);
parcelHelpers.export(exports, "timeThursdays", ()=>timeThursdays);
parcelHelpers.export(exports, "timeFridays", ()=>timeFridays);
parcelHelpers.export(exports, "timeSaturdays", ()=>timeSaturdays);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
function timeWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
const timeSundays = timeSunday.range;
const timeMondays = timeMonday.range;
const timeTuesdays = timeTuesday.range;
const timeWednesdays = timeWednesday.range;
const timeThursdays = timeThursday.range;
const timeFridays = timeFriday.range;
const timeSaturdays = timeSaturday.range;
function utcWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
const utcSundays = utcSunday.range;
const utcMondays = utcMonday.range;
const utcTuesdays = utcTuesday.range;
const utcWednesdays = utcWednesday.range;
const utcThursdays = utcThursday.range;
const utcFridays = utcFriday.range;
const utcSaturdays = utcSaturday.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"84iEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMonth", ()=>timeMonth);
parcelHelpers.export(exports, "timeMonths", ()=>timeMonths);
parcelHelpers.export(exports, "utcMonth", ()=>utcMonth);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
const timeMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const timeMonths = timeMonth.range;
const utcMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const utcMonths = utcMonth.range;

},{"./interval.js":"8b01o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lOZjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeYear", ()=>timeYear);
parcelHelpers.export(exports, "timeYears", ()=>timeYears);
parcelHelpers.export(exports, "utcYear", ()=>utcYear);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
const timeYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
timeYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const timeYears = timeYear.range;
const utcYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const utcYears = utcYear.range;

},{"./interval.js":"8b01o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6WIS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", ()=>utcTicks);
parcelHelpers.export(exports, "utcTickInterval", ()=>utcTickInterval);
parcelHelpers.export(exports, "timeTicks", ()=>timeTicks);
parcelHelpers.export(exports, "timeTickInterval", ()=>timeTickInterval);
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, _secondJs.second),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _d3Array.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJs.millisecond).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker((0, _yearJs.utcYear), (0, _monthJs.utcMonth), (0, _weekJs.utcSunday), (0, _dayJs.unixDay), (0, _hourJs.utcHour), (0, _minuteJs.utcMinute));
const [timeTicks, timeTickInterval] = ticker((0, _yearJs.timeYear), (0, _monthJs.timeMonth), (0, _weekJs.timeSunday), (0, _dayJs.timeDay), (0, _hourJs.timeHour), (0, _minuteJs.timeMinute));

},{"d3-array":"4pSqo","./duration.js":"8Rr4E","./millisecond.js":"5ZpfR","./second.js":"fAm1a","./minute.js":"dTJQZ","./hour.js":"iD1qs","./day.js":"ckWH7","./week.js":"k6n3C","./month.js":"84iEq","./year.js":"lOZjL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l85y1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"3sFOd","./locale.js":"hYi04","./isoFormat.js":false,"./isoParse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3sFOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"hYi04","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYi04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"5UzaV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jf17R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aggregate", ()=>Aggregate);
parcelHelpers.export(exports, "bin", ()=>Bin);
parcelHelpers.export(exports, "collect", ()=>Collect);
parcelHelpers.export(exports, "compare", ()=>Compare);
parcelHelpers.export(exports, "countpattern", ()=>CountPattern);
parcelHelpers.export(exports, "cross", ()=>Cross);
parcelHelpers.export(exports, "density", ()=>Density);
parcelHelpers.export(exports, "dotbin", ()=>DotBin);
parcelHelpers.export(exports, "expression", ()=>Expression);
parcelHelpers.export(exports, "extent", ()=>Extent);
parcelHelpers.export(exports, "facet", ()=>Facet);
parcelHelpers.export(exports, "field", ()=>Field);
parcelHelpers.export(exports, "filter", ()=>Filter);
parcelHelpers.export(exports, "flatten", ()=>Flatten);
parcelHelpers.export(exports, "fold", ()=>Fold);
parcelHelpers.export(exports, "formula", ()=>Formula);
parcelHelpers.export(exports, "generate", ()=>Generate);
parcelHelpers.export(exports, "impute", ()=>Impute);
parcelHelpers.export(exports, "joinaggregate", ()=>JoinAggregate);
parcelHelpers.export(exports, "kde", ()=>KDE);
parcelHelpers.export(exports, "key", ()=>Key);
parcelHelpers.export(exports, "load", ()=>Load);
parcelHelpers.export(exports, "lookup", ()=>Lookup);
parcelHelpers.export(exports, "multiextent", ()=>MultiExtent);
parcelHelpers.export(exports, "multivalues", ()=>MultiValues);
parcelHelpers.export(exports, "params", ()=>Params);
parcelHelpers.export(exports, "pivot", ()=>Pivot);
parcelHelpers.export(exports, "prefacet", ()=>PreFacet);
parcelHelpers.export(exports, "project", ()=>Project);
parcelHelpers.export(exports, "proxy", ()=>Proxy);
parcelHelpers.export(exports, "quantile", ()=>Quantile);
parcelHelpers.export(exports, "relay", ()=>Relay);
parcelHelpers.export(exports, "sample", ()=>Sample);
parcelHelpers.export(exports, "sequence", ()=>Sequence);
parcelHelpers.export(exports, "sieve", ()=>Sieve);
parcelHelpers.export(exports, "subflow", ()=>Subflow);
parcelHelpers.export(exports, "timeunit", ()=>TimeUnit);
parcelHelpers.export(exports, "tupleindex", ()=>TupleIndex);
parcelHelpers.export(exports, "values", ()=>Values);
parcelHelpers.export(exports, "window", ()=>Window);
var _vegaUtil = require("vega-util");
var _vegaDataflow = require("vega-dataflow");
var _vegaStatistics = require("vega-statistics");
var _d3Array = require("d3-array");
var _vegaTime = require("vega-time");
function multikey(f) {
    return (x)=>{
        const n = f.length;
        let i = 1, k = String(f[0](x));
        for(; i < n; ++i)k += '|' + f[i](x);
        return k;
    };
}
function groupkey(fields) {
    return !fields || !fields.length ? function() {
        return '';
    } : fields.length === 1 ? fields[0] : multikey(fields);
}
function measureName(op, field, as) {
    return as || op + (!field ? '' : '_' + field);
}
const noop = ()=>{};
const base_op = {
    init: noop,
    add: noop,
    rem: noop,
    idx: 0
};
const AggregateOps = {
    values: {
        init: (m)=>m.cell.store = true,
        value: (m)=>m.cell.data.values(),
        idx: -1
    },
    count: {
        value: (m)=>m.cell.num
    },
    __count__: {
        value: (m)=>m.missing + m.valid
    },
    missing: {
        value: (m)=>m.missing
    },
    valid: {
        value: (m)=>m.valid
    },
    sum: {
        init: (m)=>m.sum = 0,
        value: (m)=>m.valid ? m.sum : undefined,
        add: (m, v)=>m.sum += +v,
        rem: (m, v)=>m.sum -= v
    },
    product: {
        init: (m)=>m.product = 1,
        value: (m)=>m.valid ? m.product : undefined,
        add: (m, v)=>m.product *= v,
        rem: (m, v)=>m.product /= v
    },
    mean: {
        init: (m)=>m.mean = 0,
        value: (m)=>m.valid ? m.mean : undefined,
        add: (m, v)=>(m.mean_d = v - m.mean, m.mean += m.mean_d / m.valid),
        rem: (m, v)=>(m.mean_d = v - m.mean, m.mean -= m.valid ? m.mean_d / m.valid : m.mean)
    },
    average: {
        value: (m)=>m.valid ? m.mean : undefined,
        req: [
            'mean'
        ],
        idx: 1
    },
    variance: {
        init: (m)=>m.dev = 0,
        value: (m)=>m.valid > 1 ? m.dev / (m.valid - 1) : undefined,
        add: (m, v)=>m.dev += m.mean_d * (v - m.mean),
        rem: (m, v)=>m.dev -= m.mean_d * (v - m.mean),
        req: [
            'mean'
        ],
        idx: 1
    },
    variancep: {
        value: (m)=>m.valid > 1 ? m.dev / m.valid : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    stdev: {
        value: (m)=>m.valid > 1 ? Math.sqrt(m.dev / (m.valid - 1)) : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    stdevp: {
        value: (m)=>m.valid > 1 ? Math.sqrt(m.dev / m.valid) : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    stderr: {
        value: (m)=>m.valid > 1 ? Math.sqrt(m.dev / (m.valid * (m.valid - 1))) : undefined,
        req: [
            'variance'
        ],
        idx: 2
    },
    distinct: {
        value: (m)=>m.cell.data.distinct(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    ci0: {
        value: (m)=>m.cell.data.ci0(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    ci1: {
        value: (m)=>m.cell.data.ci1(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    median: {
        value: (m)=>m.cell.data.q2(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    q1: {
        value: (m)=>m.cell.data.q1(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    q3: {
        value: (m)=>m.cell.data.q3(m.get),
        req: [
            'values'
        ],
        idx: 3
    },
    min: {
        init: (m)=>m.min = undefined,
        value: (m)=>m.min = Number.isNaN(m.min) ? m.cell.data.min(m.get) : m.min,
        add: (m, v)=>{
            if (v < m.min || m.min === undefined) m.min = v;
        },
        rem: (m, v)=>{
            if (v <= m.min) m.min = NaN;
        },
        req: [
            'values'
        ],
        idx: 4
    },
    max: {
        init: (m)=>m.max = undefined,
        value: (m)=>m.max = Number.isNaN(m.max) ? m.cell.data.max(m.get) : m.max,
        add: (m, v)=>{
            if (v > m.max || m.max === undefined) m.max = v;
        },
        rem: (m, v)=>{
            if (v >= m.max) m.max = NaN;
        },
        req: [
            'values'
        ],
        idx: 4
    },
    argmin: {
        init: (m)=>m.argmin = undefined,
        value: (m)=>m.argmin || m.cell.data.argmin(m.get),
        add: (m, v, t)=>{
            if (v < m.min) m.argmin = t;
        },
        rem: (m, v)=>{
            if (v <= m.min) m.argmin = undefined;
        },
        req: [
            'min',
            'values'
        ],
        idx: 3
    },
    argmax: {
        init: (m)=>m.argmax = undefined,
        value: (m)=>m.argmax || m.cell.data.argmax(m.get),
        add: (m, v, t)=>{
            if (v > m.max) m.argmax = t;
        },
        rem: (m, v)=>{
            if (v >= m.max) m.argmax = undefined;
        },
        req: [
            'max',
            'values'
        ],
        idx: 3
    },
    exponential: {
        init: (m, r)=>{
            m.exp = 0;
            m.exp_r = r;
        },
        value: (m)=>m.valid ? m.exp * (1 - m.exp_r) / (1 - m.exp_r ** m.valid) : undefined,
        add: (m, v)=>m.exp = m.exp_r * m.exp + v,
        rem: (m, v)=>m.exp = (m.exp - v / m.exp_r ** (m.valid - 1)) / m.exp_r
    },
    exponentialb: {
        value: (m)=>m.valid ? m.exp * (1 - m.exp_r) : undefined,
        req: [
            'exponential'
        ],
        idx: 1
    }
};
const ValidAggregateOps = Object.keys(AggregateOps).filter((d)=>d !== '__count__');
function measure(key, value) {
    return (out, aggregate_param)=>(0, _vegaUtil.extend)({
            name: key,
            aggregate_param: aggregate_param,
            out: out || key
        }, base_op, value);
}
[
    ...ValidAggregateOps,
    '__count__'
].forEach((key)=>{
    AggregateOps[key] = measure(key, AggregateOps[key]);
});
function createMeasure(op, param, name) {
    return AggregateOps[op](name, param);
}
function compareIndex(a, b) {
    return a.idx - b.idx;
}
function resolve(agg) {
    const map = {};
    agg.forEach((a)=>map[a.name] = a);
    const getreqs = (a)=>{
        if (!a.req) return;
        a.req.forEach((key)=>{
            if (!map[key]) getreqs(map[key] = AggregateOps[key]());
        });
    };
    agg.forEach(getreqs);
    return Object.values(map).sort(compareIndex);
}
function init() {
    this.valid = 0;
    this.missing = 0;
    this._ops.forEach((op)=>op.aggregate_param == null ? op.init(this) : op.init(this, op.aggregate_param));
}
function add(v, t) {
    if (v == null || v === '') {
        ++this.missing;
        return;
    }
    if (v !== v) return;
    ++this.valid;
    this._ops.forEach((op)=>op.add(this, v, t));
}
function rem(v, t) {
    if (v == null || v === '') {
        --this.missing;
        return;
    }
    if (v !== v) return;
    --this.valid;
    this._ops.forEach((op)=>op.rem(this, v, t));
}
function set(t) {
    this._out.forEach((op)=>t[op.out] = op.value(this));
    return t;
}
function compileMeasures(agg, field) {
    const get = field || (0, _vegaUtil.identity), ops = resolve(agg), out = agg.slice().sort(compareIndex);
    function ctr(cell) {
        this._ops = ops;
        this._out = out;
        this.cell = cell;
        this.init();
    }
    ctr.prototype.init = init;
    ctr.prototype.add = add;
    ctr.prototype.rem = rem;
    ctr.prototype.set = set;
    ctr.prototype.get = get;
    ctr.fields = agg.map((op)=>op.out);
    return ctr;
}
function TupleStore(key) {
    this._key = key ? (0, _vegaUtil.field)(key) : (0, _vegaDataflow.tupleid);
    this.reset();
}
const prototype$1 = TupleStore.prototype;
prototype$1.reset = function() {
    this._add = [];
    this._rem = [];
    this._ext = null;
    this._get = null;
    this._q = null;
};
prototype$1.add = function(v) {
    this._add.push(v);
};
prototype$1.rem = function(v) {
    this._rem.push(v);
};
prototype$1.values = function() {
    this._get = null;
    if (this._rem.length === 0) return this._add;
    const a = this._add, r = this._rem, k = this._key, n = a.length, m = r.length, x = Array(n - m), map = {};
    let i, j, v;
    // use unique key field to clear removed values
    for(i = 0; i < m; ++i)map[k(r[i])] = 1;
    for(i = 0, j = 0; i < n; ++i)if (map[k(v = a[i])]) map[k(v)] = 0;
    else x[j++] = v;
    this._rem = [];
    return this._add = x;
};
// memoizing statistics methods
prototype$1.distinct = function(get) {
    const v = this.values(), map = {};
    let n = v.length, count = 0, s;
    while(--n >= 0){
        s = get(v[n]) + '';
        if (!(0, _vegaUtil.hasOwnProperty)(map, s)) {
            map[s] = 1;
            ++count;
        }
    }
    return count;
};
prototype$1.extent = function(get) {
    if (this._get !== get || !this._ext) {
        const v = this.values(), i = (0, _vegaUtil.extentIndex)(v, get);
        this._ext = [
            v[i[0]],
            v[i[1]]
        ];
        this._get = get;
    }
    return this._ext;
};
prototype$1.argmin = function(get) {
    return this.extent(get)[0] || {};
};
prototype$1.argmax = function(get) {
    return this.extent(get)[1] || {};
};
prototype$1.min = function(get) {
    const m = this.extent(get)[0];
    return m != null ? get(m) : undefined;
};
prototype$1.max = function(get) {
    const m = this.extent(get)[1];
    return m != null ? get(m) : undefined;
};
prototype$1.quartile = function(get) {
    if (this._get !== get || !this._q) {
        this._q = (0, _vegaStatistics.quartiles)(this.values(), get);
        this._get = get;
    }
    return this._q;
};
prototype$1.q1 = function(get) {
    return this.quartile(get)[0];
};
prototype$1.q2 = function(get) {
    return this.quartile(get)[1];
};
prototype$1.q3 = function(get) {
    return this.quartile(get)[2];
};
prototype$1.ci = function(get) {
    if (this._get !== get || !this._ci) {
        this._ci = (0, _vegaStatistics.bootstrapCI)(this.values(), 1000, 0.05, get);
        this._get = get;
    }
    return this._ci;
};
prototype$1.ci0 = function(get) {
    return this.ci(get)[0];
};
prototype$1.ci1 = function(get) {
    return this.ci(get)[1];
};
/**
 * Group-by aggregation operator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {Array<function(object): *>} [params.fields] - An array of accessors to aggregate.
 * @param {Array<string>} [params.ops] - An array of strings indicating aggregation operations.
 * @param {Array<number>} [params.aggregate_params] - An optional array of parameters for aggregation operations.
 * @param {Array<string>} [params.as] - An array of output field names for aggregated values.
 * @param {boolean} [params.cross=false] - A flag indicating that the full
 *   cross-product of groupby values should be generated, including empty cells.
 *   If true, the drop parameter is ignored and empty cells are retained.
 * @param {boolean} [params.drop=true] - A flag indicating if empty cells should be removed.
 */ function Aggregate(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this._adds = []; // array of added output tuples
    this._mods = []; // array of modified output tuples
    this._alen = 0; // number of active added tuples
    this._mlen = 0; // number of active modified tuples
    this._drop = true; // should empty aggregation cells be removed
    this._cross = false; // produce full cross-product of group-by values
    this._dims = []; // group-by dimension accessors
    this._dnames = []; // group-by dimension names
    this._measures = []; // collection of aggregation monoids
    this._countOnly = false; // flag indicating only count aggregation
    this._counts = null; // collection of count fields
    this._prev = null; // previous aggregation cells
    this._inputs = null; // array of dependent input tuple field names
    this._outputs = null; // array of output tuple field names
}
Aggregate.Definition = {
    'type': 'Aggregate',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'ops',
            'type': 'enum',
            'array': true,
            'values': ValidAggregateOps
        },
        {
            'name': 'aggregate_params',
            'type': 'number',
            'null': true,
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'null': true,
            'array': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        },
        {
            'name': 'drop',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'cross',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'key',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(Aggregate, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const aggr = this, out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), mod = _.modified();
        aggr.stamp = out.stamp;
        if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
            aggr._prev = aggr.value;
            aggr.value = mod ? aggr.init(_) : Object.create(null);
            pulse.visit(pulse.SOURCE, (t)=>aggr.add(t));
        } else {
            aggr.value = aggr.value || aggr.init(_);
            pulse.visit(pulse.REM, (t)=>aggr.rem(t));
            pulse.visit(pulse.ADD, (t)=>aggr.add(t));
        }
        // Indicate output fields and return aggregate tuples.
        out.modifies(aggr._outputs);
        // Should empty cells be dropped?
        aggr._drop = _.drop !== false;
        // If domain cross-product requested, generate empty cells as needed
        // and ensure that empty cells are not dropped
        if (_.cross && aggr._dims.length > 1) {
            aggr._drop = false;
            aggr.cross();
        }
        if (pulse.clean() && aggr._drop) out.clean(true).runAfter(()=>this.clean());
        return aggr.changes(out);
    },
    cross () {
        const aggr = this, curr = aggr.value, dims = aggr._dnames, vals = dims.map(()=>({})), n = dims.length;
        // collect all group-by domain values
        function collect(cells) {
            let key, i, t, v;
            for(key in cells){
                t = cells[key].tuple;
                for(i = 0; i < n; ++i)vals[i][v = t[dims[i]]] = v;
            }
        }
        collect(aggr._prev);
        collect(curr);
        // iterate over key cross-product, create cells as needed
        function generate(base, tuple, index) {
            const name = dims[index], v = vals[index++];
            for(const k in v){
                const key = base ? base + '|' + k : k;
                tuple[name] = v[k];
                if (index < n) generate(key, tuple, index);
                else if (!curr[key]) aggr.cell(key, tuple);
            }
        }
        generate('', {}, 0);
    },
    init (_) {
        // initialize input and output fields
        const inputs = this._inputs = [], outputs = this._outputs = [], inputMap = {};
        function inputVisit(get) {
            const fields = (0, _vegaUtil.array)((0, _vegaUtil.accessorFields)(get)), n = fields.length;
            let i = 0, f;
            for(; i < n; ++i)if (!inputMap[f = fields[i]]) {
                inputMap[f] = 1;
                inputs.push(f);
            }
        }
        // initialize group-by dimensions
        this._dims = (0, _vegaUtil.array)(_.groupby);
        this._dnames = this._dims.map((d)=>{
            const dname = (0, _vegaUtil.accessorName)(d);
            inputVisit(d);
            outputs.push(dname);
            return dname;
        });
        this.cellkey = _.key ? _.key : groupkey(this._dims);
        // initialize aggregate measures
        this._countOnly = true;
        this._counts = [];
        this._measures = [];
        const fields = _.fields || [
            null
        ], ops = _.ops || [
            'count'
        ], aggregate_params = _.aggregate_params || [
            null
        ], as = _.as || [], n = fields.length, map = {};
        let field, op, aggregate_param, m, mname, outname, i;
        if (n !== ops.length) (0, _vegaUtil.error)('Unmatched number of fields and aggregate ops.');
        for(i = 0; i < n; ++i){
            field = fields[i];
            op = ops[i];
            aggregate_param = aggregate_params[i] || null;
            if (field == null && op !== 'count') (0, _vegaUtil.error)('Null aggregate field specified.');
            mname = (0, _vegaUtil.accessorName)(field);
            outname = measureName(op, mname, as[i]);
            outputs.push(outname);
            if (op === 'count') {
                this._counts.push(outname);
                continue;
            }
            m = map[mname];
            if (!m) {
                inputVisit(field);
                m = map[mname] = [];
                m.field = field;
                this._measures.push(m);
            }
            if (op !== 'count') this._countOnly = false;
            m.push(createMeasure(op, aggregate_param, outname));
        }
        this._measures = this._measures.map((m)=>compileMeasures(m, m.field));
        return Object.create(null); // aggregation cells (this.value)
    },
    // -- Cell Management -----
    cellkey: groupkey(),
    cell (key, t) {
        let cell = this.value[key];
        if (!cell) {
            cell = this.value[key] = this.newcell(key, t);
            this._adds[this._alen++] = cell;
        } else if (cell.num === 0 && this._drop && cell.stamp < this.stamp) {
            cell.stamp = this.stamp;
            this._adds[this._alen++] = cell;
        } else if (cell.stamp < this.stamp) {
            cell.stamp = this.stamp;
            this._mods[this._mlen++] = cell;
        }
        return cell;
    },
    newcell (key, t) {
        const cell = {
            key: key,
            num: 0,
            agg: null,
            tuple: this.newtuple(t, this._prev && this._prev[key]),
            stamp: this.stamp,
            store: false
        };
        if (!this._countOnly) {
            const measures = this._measures, n = measures.length;
            cell.agg = Array(n);
            for(let i = 0; i < n; ++i)cell.agg[i] = new measures[i](cell);
        }
        if (cell.store) cell.data = new TupleStore();
        return cell;
    },
    newtuple (t, p) {
        const names = this._dnames, dims = this._dims, n = dims.length, x = {};
        for(let i = 0; i < n; ++i)x[names[i]] = dims[i](t);
        return p ? (0, _vegaDataflow.replace)(p.tuple, x) : (0, _vegaDataflow.ingest)(x);
    },
    clean () {
        const cells = this.value;
        for(const key in cells)if (cells[key].num === 0) delete cells[key];
    },
    // -- Process Tuples -----
    add (t) {
        const key = this.cellkey(t), cell = this.cell(key, t);
        cell.num += 1;
        if (this._countOnly) return;
        if (cell.store) cell.data.add(t);
        const agg = cell.agg;
        for(let i = 0, n = agg.length; i < n; ++i)agg[i].add(agg[i].get(t), t);
    },
    rem (t) {
        const key = this.cellkey(t), cell = this.cell(key, t);
        cell.num -= 1;
        if (this._countOnly) return;
        if (cell.store) cell.data.rem(t);
        const agg = cell.agg;
        for(let i = 0, n = agg.length; i < n; ++i)agg[i].rem(agg[i].get(t), t);
    },
    celltuple (cell) {
        const tuple = cell.tuple, counts = this._counts;
        // consolidate stored values
        if (cell.store) cell.data.values();
        // update tuple properties
        for(let i = 0, n = counts.length; i < n; ++i)tuple[counts[i]] = cell.num;
        if (!this._countOnly) {
            const agg = cell.agg;
            for(let i = 0, n = agg.length; i < n; ++i)agg[i].set(tuple);
        }
        return tuple;
    },
    changes (out) {
        const adds = this._adds, mods = this._mods, prev = this._prev, drop = this._drop, add = out.add, rem = out.rem, mod = out.mod;
        let cell, key, i, n;
        if (prev) for(key in prev){
            cell = prev[key];
            if (!drop || cell.num) rem.push(cell.tuple);
        }
        for(i = 0, n = this._alen; i < n; ++i){
            add.push(this.celltuple(adds[i]));
            adds[i] = null; // for garbage collection
        }
        for(i = 0, n = this._mlen; i < n; ++i){
            cell = mods[i];
            (cell.num === 0 && drop ? rem : mod).push(this.celltuple(cell));
            mods[i] = null; // for garbage collection
        }
        this._alen = this._mlen = 0; // reset list of active cells
        this._prev = null;
        return out;
    }
});
// epsilon bias to offset floating point error (#1737)
const EPSILON$1 = 1e-14;
/**
 * Generates a binning function for discretizing data.
 * @constructor
 * @param {object} params - The parameters for this operator. The
 *   provided values should be valid options for the {@link bin} function.
 * @param {function(object): *} params.field - The data field to bin.
 */ function Bin(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Bin.Definition = {
    'type': 'Bin',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'interval',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'anchor',
            'type': 'number'
        },
        {
            'name': 'maxbins',
            'type': 'number',
            'default': 20
        },
        {
            'name': 'base',
            'type': 'number',
            'default': 10
        },
        {
            'name': 'divide',
            'type': 'number',
            'array': true,
            'default': [
                5,
                2
            ]
        },
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2,
            'required': true
        },
        {
            'name': 'span',
            'type': 'number'
        },
        {
            'name': 'step',
            'type': 'number'
        },
        {
            'name': 'steps',
            'type': 'number',
            'array': true
        },
        {
            'name': 'minstep',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'nice',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'name',
            'type': 'string'
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'bin0',
                'bin1'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Bin, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const band = _.interval !== false, bins = this._bins(_), start = bins.start, step = bins.step, as = _.as || [
            'bin0',
            'bin1'
        ], b0 = as[0], b1 = as[1];
        let flag;
        if (_.modified()) {
            pulse = pulse.reflow(true);
            flag = pulse.SOURCE;
        } else flag = pulse.modified((0, _vegaUtil.accessorFields)(_.field)) ? pulse.ADD_MOD : pulse.ADD;
        pulse.visit(flag, band ? (t)=>{
            const v = bins(t);
            // minimum bin value (inclusive)
            t[b0] = v;
            // maximum bin value (exclusive)
            // use convoluted math for better floating point agreement
            // see https://github.com/vega/vega/issues/830
            // infinite values propagate through this formula! #2227
            t[b1] = v == null ? null : start + step * (1 + (v - start) / step);
        } : (t)=>t[b0] = bins(t));
        return pulse.modifies(band ? as : b0);
    },
    _bins (_) {
        if (this.value && !_.modified()) return this.value;
        const field = _.field, bins = (0, _vegaStatistics.bin)(_), step = bins.step;
        let start = bins.start, stop = start + Math.ceil((bins.stop - start) / step) * step, a, d;
        if ((a = _.anchor) != null) {
            d = a - (start + step * Math.floor((a - start) / step));
            start += d;
            stop += d;
        }
        const f = function(t) {
            let v = (0, _vegaUtil.toNumber)(field(t));
            return v == null ? null : v < start ? -Infinity : v > stop ? Infinity : (v = Math.max(start, Math.min(v, stop - step)), start + step * Math.floor(EPSILON$1 + (v - start) / step));
        };
        f.start = start;
        f.stop = bins.stop;
        f.step = step;
        return this.value = (0, _vegaUtil.accessor)(f, (0, _vegaUtil.accessorFields)(field), _.name || 'bin_' + (0, _vegaUtil.accessorName)(field));
    }
});
function SortedList(idFunc, source, input) {
    const $ = idFunc;
    let data = source || [], add = input || [], rem = {}, cnt = 0;
    return {
        add: (t)=>add.push(t),
        remove: (t)=>rem[$(t)] = ++cnt,
        size: ()=>data.length,
        data: (compare, resort)=>{
            if (cnt) {
                data = data.filter((t)=>!rem[$(t)]);
                rem = {};
                cnt = 0;
            }
            if (resort && compare) data.sort(compare);
            if (add.length) {
                data = compare ? (0, _vegaUtil.merge)(compare, data, add.sort(compare)) : data.concat(add);
                add = [];
            }
            return data;
        }
    };
}
/**
 * Collects all data tuples that pass through this operator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for additionally sorting the collected tuples.
 */ function Collect(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Collect.Definition = {
    'type': 'Collect',
    'metadata': {
        'source': true
    },
    'params': [
        {
            'name': 'sort',
            'type': 'compare'
        }
    ]
};
(0, _vegaUtil.inherits)(Collect, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.ALL), list = SortedList((0, _vegaDataflow.tupleid), this.value, out.materialize(out.ADD).add), sort = _.sort, mod = pulse.changed() || sort && (_.modified('sort') || pulse.modified(sort.fields));
        out.visit(out.REM, list.remove);
        this.modified(mod);
        this.value = out.source = list.data((0, _vegaDataflow.stableCompare)(sort), mod);
        // propagate tree root if defined
        if (pulse.source && pulse.source.root) this.value.root = pulse.source.root;
        return out;
    }
});
/**
 * Generates a comparator function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<string|function>} params.fields - The fields to compare.
 * @param {Array<string>} [params.orders] - The sort orders.
 *   Each entry should be one of "ascending" (default) or "descending".
 */ function Compare(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$5, params);
}
(0, _vegaUtil.inherits)(Compare, (0, _vegaDataflow.Operator));
function update$5(_) {
    return this.value && !_.modified() ? this.value : (0, _vegaUtil.compare)(_.fields, _.orders);
}
/**
 * Count regexp-defined pattern occurrences in a text field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - An accessor for the text field.
 * @param {string} [params.pattern] - RegExp string defining the text pattern.
 * @param {string} [params.case] - One of 'lower', 'upper' or null (mixed) case.
 * @param {string} [params.stopwords] - RegExp string of words to ignore.
 */ function CountPattern(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
CountPattern.Definition = {
    'type': 'CountPattern',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'case',
            'type': 'enum',
            'values': [
                'upper',
                'lower',
                'mixed'
            ],
            'default': 'mixed'
        },
        {
            'name': 'pattern',
            'type': 'string',
            'default': '[\\w"]+'
        },
        {
            'name': 'stopwords',
            'type': 'string',
            'default': ''
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'text',
                'count'
            ]
        }
    ]
};
function tokenize(text, tcase, match) {
    switch(tcase){
        case 'upper':
            text = text.toUpperCase();
            break;
        case 'lower':
            text = text.toLowerCase();
            break;
    }
    return text.match(match);
}
(0, _vegaUtil.inherits)(CountPattern, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const process = (update)=>(tuple)=>{
                var tokens = tokenize(get(tuple), _.case, match) || [], t;
                for(var i = 0, n = tokens.length; i < n; ++i)if (!stop.test(t = tokens[i])) update(t);
            };
        const init = this._parameterCheck(_, pulse), counts = this._counts, match = this._match, stop = this._stop, get = _.field, as = _.as || [
            'text',
            'count'
        ], add = process((t)=>counts[t] = 1 + (counts[t] || 0)), rem = process((t)=>counts[t] -= 1);
        if (init) pulse.visit(pulse.SOURCE, add);
        else {
            pulse.visit(pulse.ADD, add);
            pulse.visit(pulse.REM, rem);
        }
        return this._finish(pulse, as); // generate output tuples
    },
    _parameterCheck (_, pulse) {
        let init = false;
        if (_.modified('stopwords') || !this._stop) {
            this._stop = new RegExp('^' + (_.stopwords || '') + '$', 'i');
            init = true;
        }
        if (_.modified('pattern') || !this._match) {
            this._match = new RegExp(_.pattern || '[\\w\']+', 'g');
            init = true;
        }
        if (_.modified('field') || pulse.modified(_.field.fields)) init = true;
        if (init) this._counts = {};
        return init;
    },
    _finish (pulse, as) {
        const counts = this._counts, tuples = this._tuples || (this._tuples = {}), text = as[0], count = as[1], out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        let w, t, c;
        for(w in counts){
            t = tuples[w];
            c = counts[w] || 0;
            if (!t && c) {
                tuples[w] = t = (0, _vegaDataflow.ingest)({});
                t[text] = w;
                t[count] = c;
                out.add.push(t);
            } else if (c === 0) {
                if (t) out.rem.push(t);
                counts[w] = null;
                tuples[w] = null;
            } else if (t[count] !== c) {
                t[count] = c;
                out.mod.push(t);
            }
        }
        return out.modifies(as);
    }
});
/**
 * Perform a cross-product of a tuple stream with itself.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object):boolean} [params.filter] - An optional filter
 *   function for selectively including tuples in the cross product.
 * @param {Array<string>} [params.as] - The names of the output fields.
 */ function Cross(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Cross.Definition = {
    'type': 'Cross',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'filter',
            'type': 'expr'
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'a',
                'b'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Cross, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), as = _.as || [
            'a',
            'b'
        ], a = as[0], b = as[1], reset = !this.value || pulse.changed(pulse.ADD_REM) || _.modified('as') || _.modified('filter');
        let data = this.value;
        if (reset) {
            if (data) out.rem = data;
            data = pulse.materialize(pulse.SOURCE).source;
            out.add = this.value = cross(data, a, b, _.filter || (0, _vegaUtil.truthy));
        } else out.mod = data;
        out.source = this.value;
        return out.modifies(as);
    }
});
function cross(input, a, b, filter) {
    var data = [], t = {}, n = input.length, i = 0, j, left;
    for(; i < n; ++i){
        t[a] = left = input[i];
        for(j = 0; j < n; ++j){
            t[b] = input[j];
            if (filter(t)) {
                data.push((0, _vegaDataflow.ingest)(t));
                t = {};
                t[a] = left;
            }
        }
    }
    return data;
}
const Distributions = {
    kde: (0, _vegaStatistics.randomKDE),
    mixture: (0, _vegaStatistics.randomMixture),
    normal: (0, _vegaStatistics.randomNormal),
    lognormal: (0, _vegaStatistics.randomLogNormal),
    uniform: (0, _vegaStatistics.randomUniform)
};
const DISTRIBUTIONS = 'distributions', FUNCTION = 'function', FIELD = 'field';
/**
 * Parse a parameter object for a probability distribution.
 * @param {object} def - The distribution parameter object.
 * @param {function():Array<object>} - A method for requesting
 *   source data. Used for distributions (such as KDE) that
 *   require sample data points. This method will only be
 *   invoked if the 'from' parameter for a target data source
 *   is not provided. Typically this method returns backing
 *   source data for a Pulse object.
 * @return {object} - The output distribution object.
 */ function parse(def, data) {
    const func = def[FUNCTION];
    if (!(0, _vegaUtil.hasOwnProperty)(Distributions, func)) (0, _vegaUtil.error)('Unknown distribution function: ' + func);
    const d = Distributions[func]();
    for(const name in def){
        // if data field, extract values
        if (name === FIELD) d.data((def.from || data()).map(def[name]));
        else if (name === DISTRIBUTIONS) d[name](def[name].map((_)=>parse(_, data)));
        else if (typeof d[name] === FUNCTION) d[name](def[name]);
    }
    return d;
}
/**
 * Grid sample points for a probability density. Given a distribution and
 * a sampling extent, will generate points suitable for plotting either
 * PDF (probability density function) or CDF (cumulative distribution
 * function) curves.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.distribution - The probability distribution. This
 *   is an object parameter dependent on the distribution type.
 * @param {string} [params.method='pdf'] - The distribution method to sample.
 *   One of 'pdf' or 'cdf'.
 * @param {Array<number>} [params.extent] - The [min, max] extent over which
 *   to sample the distribution. This argument is required in most cases, but
 *   can be omitted if the distribution (e.g., 'kde') supports a 'data' method
 *   that returns numerical sample points from which the extent can be deduced.
 * @param {number} [params.minsteps=25] - The minimum number of curve samples
 *   for plotting the density.
 * @param {number} [params.maxsteps=200] - The maximum number of curve samples
 *   for plotting the density.
 * @param {number} [params.steps] - The exact number of curve samples for
 *   plotting the density. If specified, overrides both minsteps and maxsteps
 *   to set an exact number of uniform samples. Useful in conjunction with
 *   a fixed extent to ensure consistent sample points for stacked densities.
 */ function Density(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const distributions = [
    {
        'key': {
            'function': 'normal'
        },
        'params': [
            {
                'name': 'mean',
                'type': 'number',
                'default': 0
            },
            {
                'name': 'stdev',
                'type': 'number',
                'default': 1
            }
        ]
    },
    {
        'key': {
            'function': 'lognormal'
        },
        'params': [
            {
                'name': 'mean',
                'type': 'number',
                'default': 0
            },
            {
                'name': 'stdev',
                'type': 'number',
                'default': 1
            }
        ]
    },
    {
        'key': {
            'function': 'uniform'
        },
        'params': [
            {
                'name': 'min',
                'type': 'number',
                'default': 0
            },
            {
                'name': 'max',
                'type': 'number',
                'default': 1
            }
        ]
    },
    {
        'key': {
            'function': 'kde'
        },
        'params': [
            {
                'name': 'field',
                'type': 'field',
                'required': true
            },
            {
                'name': 'from',
                'type': 'data'
            },
            {
                'name': 'bandwidth',
                'type': 'number',
                'default': 0
            }
        ]
    }
];
const mixture = {
    'key': {
        'function': 'mixture'
    },
    'params': [
        {
            'name': 'distributions',
            'type': 'param',
            'array': true,
            'params': distributions
        },
        {
            'name': 'weights',
            'type': 'number',
            'array': true
        }
    ]
};
Density.Definition = {
    'type': 'Density',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'steps',
            'type': 'number'
        },
        {
            'name': 'minsteps',
            'type': 'number',
            'default': 25
        },
        {
            'name': 'maxsteps',
            'type': 'number',
            'default': 200
        },
        {
            'name': 'method',
            'type': 'string',
            'default': 'pdf',
            'values': [
                'pdf',
                'cdf'
            ]
        },
        {
            'name': 'distribution',
            'type': 'param',
            'params': distributions.concat(mixture)
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'default': [
                'value',
                'density'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Density, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const dist = parse(_.distribution, source(pulse)), minsteps = _.steps || _.minsteps || 25, maxsteps = _.steps || _.maxsteps || 200;
            let method = _.method || 'pdf';
            if (method !== 'pdf' && method !== 'cdf') (0, _vegaUtil.error)('Invalid density method: ' + method);
            if (!_.extent && !dist.data) (0, _vegaUtil.error)('Missing density extent parameter.');
            method = dist[method];
            const as = _.as || [
                'value',
                'density'
            ], domain = _.extent || (0, _vegaUtil.extent)(dist.data()), values = (0, _vegaStatistics.sampleCurve)(method, domain, minsteps, maxsteps).map((v)=>{
                const tuple = {};
                tuple[as[0]] = v[0];
                tuple[as[1]] = v[1];
                return (0, _vegaDataflow.ingest)(tuple);
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});
function source(pulse) {
    return ()=>pulse.materialize(pulse.SOURCE).source;
}
// use either provided alias or accessor field name
function fieldNames(fields, as) {
    if (!fields) return null;
    return fields.map((f, i)=>as[i] || (0, _vegaUtil.accessorName)(f));
}
function partition$1(data, groupby, field) {
    const groups = [], get = (f)=>f(t);
    let map, i, n, t, k, g;
    // partition data points into groups
    if (groupby == null) groups.push(data.map(field));
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            g.dims = k;
            groups.push(g);
        }
        g.push(field(t));
    }
    return groups;
}
const Output = 'bin';
/**
 * Dot density binning for dot plot construction.
 * Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
 * https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to bin.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {number} [params.step] - The step size (bin width) within which dots should be
 *   stacked. Defaults to 1/30 of the extent of the data *field*.
 * @param {boolean} [params.smooth=false] - A boolean flag indicating if dot density
 *   stacks should be smoothed to reduce variance.
 */ function DotBin(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
DotBin.Definition = {
    'type': 'DotBin',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'step',
            'type': 'number'
        },
        {
            'name': 'smooth',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'default': Output
        }
    ]
};
const autostep = (data, field)=>(0, _vegaUtil.span)((0, _vegaUtil.extent)(data, field)) / 30;
(0, _vegaUtil.inherits)(DotBin, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !(_.modified() || pulse.changed())) return pulse; // early exit
        const source = pulse.materialize(pulse.SOURCE).source, groups = partition$1(pulse.source, _.groupby, (0, _vegaUtil.identity)), smooth = _.smooth || false, field = _.field, step = _.step || autostep(source, field), sort = (0, _vegaDataflow.stableCompare)((a, b)=>field(a) - field(b)), as = _.as || Output, n = groups.length;
        // compute dotplot bins per group
        let min = Infinity, max = -Infinity, i = 0, j;
        for(; i < n; ++i){
            const g = groups[i].sort(sort);
            j = -1;
            for (const v of (0, _vegaStatistics.dotbin)(g, step, smooth, field)){
                if (v < min) min = v;
                if (v > max) max = v;
                g[++j][as] = v;
            }
        }
        this.value = {
            start: min,
            stop: max,
            step: step
        };
        return pulse.reflow(true).modifies(as);
    }
});
/**
 * Wraps an expression function with access to external parameters.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function} params.expr - The expression function. The
 *  function should accept both a datum and a parameter object.
 *  This operator's value will be a new function that wraps the
 *  expression function with access to this operator's parameters.
 */ function Expression(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$4, params);
    this.modified(true);
}
(0, _vegaUtil.inherits)(Expression, (0, _vegaDataflow.Operator));
function update$4(_) {
    const expr = _.expr;
    return this.value && !_.modified('expr') ? this.value : (0, _vegaUtil.accessor)((datum)=>expr(datum, _), (0, _vegaUtil.accessorFields)(expr), (0, _vegaUtil.accessorName)(expr));
}
/**
 * Computes extents (min/max) for a data field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The field over which to compute extends.
 */ function Extent(params) {
    (0, _vegaDataflow.Transform).call(this, [
        undefined,
        undefined
    ], params);
}
Extent.Definition = {
    'type': 'Extent',
    'metadata': {},
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Extent, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const extent = this.value, field = _.field, mod = pulse.changed() || pulse.modified(field.fields) || _.modified('field');
        let min = extent[0], max = extent[1];
        if (mod || min == null) {
            min = Infinity;
            max = -Infinity;
        }
        pulse.visit(mod ? pulse.SOURCE : pulse.ADD, (t)=>{
            const v = (0, _vegaUtil.toNumber)(field(t));
            if (v != null) {
                // NaNs will fail all comparisons!
                if (v < min) min = v;
                if (v > max) max = v;
            }
        });
        if (!Number.isFinite(min) || !Number.isFinite(max)) {
            let name = (0, _vegaUtil.accessorName)(field);
            if (name) name = ` for field "${name}"`;
            pulse.dataflow.warn(`Infinite extent${name}: [${min}, ${max}]`);
            min = max = undefined;
        }
        this.value = [
            min,
            max
        ];
    }
});
/**
 * Provides a bridge between a parent transform and a target subflow that
 * consumes only a subset of the tuples that pass through the parent.
 * @constructor
 * @param {Pulse} pulse - A pulse to use as the value of this operator.
 * @param {Transform} parent - The parent transform (typically a Facet instance).
 */ function Subflow(pulse, parent) {
    (0, _vegaDataflow.Operator).call(this, pulse);
    this.parent = parent;
    this.count = 0;
}
(0, _vegaUtil.inherits)(Subflow, (0, _vegaDataflow.Operator), {
    /**
   * Routes pulses from this subflow to a target transform.
   * @param {Transform} target - A transform that receives the subflow of tuples.
   */ connect (target) {
        this.detachSubflow = target.detachSubflow;
        this.targets().add(target);
        return target.source = this;
    },
    /**
   * Add an 'add' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being added.
   */ add (t) {
        this.count += 1;
        this.value.add.push(t);
    },
    /**
   * Add a 'rem' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being removed.
   */ rem (t) {
        this.count -= 1;
        this.value.rem.push(t);
    },
    /**
   * Add a 'mod' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being modified.
   */ mod (t) {
        this.value.mod.push(t);
    },
    /**
   * Re-initialize this operator's pulse value.
   * @param {Pulse} pulse - The pulse to copy from.
   * @see Pulse.init
   */ init (pulse) {
        this.value.init(pulse, pulse.NO_SOURCE);
    },
    /**
   * Evaluate this operator. This method overrides the
   * default behavior to simply return the contained pulse value.
   * @return {Pulse}
   */ evaluate () {
        // assert: this.value.stamp === pulse.stamp
        return this.value;
    }
});
/**
 * Facets a dataflow into a set of subflows based on a key.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Dataflow, string): Operator} params.subflow - A function
 *   that generates a subflow of operators and returns its root operator.
 * @param {function(object): *} params.key - The key field to facet by.
 */ function Facet(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
    this._keys = (0, _vegaUtil.fastmap)(); // cache previously calculated key values
    // keep track of active subflows, use as targets array for listeners
    // this allows us to limit propagation to only updated subflows
    const a = this._targets = [];
    a.active = 0;
    a.forEach = (f)=>{
        for(let i = 0, n = a.active; i < n; ++i)f(a[i], i, a);
    };
}
(0, _vegaUtil.inherits)(Facet, (0, _vegaDataflow.Transform), {
    activate (flow) {
        this._targets[this._targets.active++] = flow;
    },
    // parent argument provided by PreFacet subclass
    subflow (key, flow, pulse, parent) {
        const flows = this.value;
        let sf = (0, _vegaUtil.hasOwnProperty)(flows, key) && flows[key], df, p;
        if (!sf) {
            p = parent || (p = this._group[key]) && p.tuple;
            df = pulse.dataflow;
            sf = new Subflow(pulse.fork(pulse.NO_SOURCE), this);
            df.add(sf).connect(flow(df, key, p));
            flows[key] = sf;
            this.activate(sf);
        } else if (sf.value.stamp < pulse.stamp) {
            sf.init(pulse);
            this.activate(sf);
        }
        return sf;
    },
    clean () {
        const flows = this.value;
        let detached = 0;
        for(const key in flows)if (flows[key].count === 0) {
            const detach = flows[key].detachSubflow;
            if (detach) detach();
            delete flows[key];
            ++detached;
        }
        // remove inactive targets from the active targets array
        if (detached) {
            const active = this._targets.filter((sf)=>sf && sf.count > 0);
            this.initTargets(active);
        }
    },
    initTargets (act) {
        const a = this._targets, n = a.length, m = act ? act.length : 0;
        let i = 0;
        for(; i < m; ++i)a[i] = act[i];
        for(; i < n && a[i] != null; ++i)a[i] = null; // ensure old flows can be garbage collected
        a.active = m;
    },
    transform (_, pulse) {
        const df = pulse.dataflow, key = _.key, flow = _.subflow, cache = this._keys, rekey = _.modified('key'), subflow = (key)=>this.subflow(key, flow, pulse);
        this._group = _.group || {};
        this.initTargets(); // reset list of active subflows
        pulse.visit(pulse.REM, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t), k = cache.get(id);
            if (k !== undefined) {
                cache.delete(id);
                subflow(k).rem(t);
            }
        });
        pulse.visit(pulse.ADD, (t)=>{
            const k = key(t);
            cache.set((0, _vegaDataflow.tupleid)(t), k);
            subflow(k).add(t);
        });
        if (rekey || pulse.modified(key.fields)) pulse.visit(pulse.MOD, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t), k0 = cache.get(id), k1 = key(t);
            if (k0 === k1) subflow(k1).mod(t);
            else {
                cache.set(id, k1);
                subflow(k0).rem(t);
                subflow(k1).add(t);
            }
        });
        else if (pulse.changed(pulse.MOD)) pulse.visit(pulse.MOD, (t)=>{
            subflow(cache.get((0, _vegaDataflow.tupleid)(t))).mod(t);
        });
        if (rekey) pulse.visit(pulse.REFLOW, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t), k0 = cache.get(id), k1 = key(t);
            if (k0 !== k1) {
                cache.set(id, k1);
                subflow(k0).rem(t);
                subflow(k1).add(t);
            }
        });
        if (pulse.clean()) df.runAfter(()=>{
            this.clean();
            cache.clean();
        });
        else if (cache.empty > df.cleanThreshold) df.runAfter(cache.clean);
        return pulse;
    }
});
/**
 * Generates one or more field accessor functions.
 * If the 'name' parameter is an array, an array of field accessors
 * will be created and the 'as' parameter will be ignored.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.name - The field name(s) to access.
 * @param {string} params.as - The accessor function name.
 */ function Field(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$3, params);
}
(0, _vegaUtil.inherits)(Field, (0, _vegaDataflow.Operator));
function update$3(_) {
    return this.value && !_.modified() ? this.value : (0, _vegaUtil.isArray)(_.name) ? (0, _vegaUtil.array)(_.name).map((f)=>(0, _vegaUtil.field)(f)) : (0, _vegaUtil.field)(_.name, _.as);
}
/**
 * Filters data tuples according to a predicate function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.expr - The predicate expression function
 *   that determines a tuple's filter status. Truthy values pass the filter.
 */ function Filter(params) {
    (0, _vegaDataflow.Transform).call(this, (0, _vegaUtil.fastmap)(), params);
}
Filter.Definition = {
    'type': 'Filter',
    'metadata': {
        'changes': true
    },
    'params': [
        {
            'name': 'expr',
            'type': 'expr',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Filter, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const df = pulse.dataflow, cache = this.value, // cache ids of filtered tuples
        output = pulse.fork(), add = output.add, rem = output.rem, mod = output.mod, test = _.expr;
        let isMod = true;
        pulse.visit(pulse.REM, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t);
            if (!cache.has(id)) rem.push(t);
            else cache.delete(id);
        });
        pulse.visit(pulse.ADD, (t)=>{
            if (test(t, _)) add.push(t);
            else cache.set((0, _vegaDataflow.tupleid)(t), 1);
        });
        function revisit(t) {
            const id = (0, _vegaDataflow.tupleid)(t), b = test(t, _), s = cache.get(id);
            if (b && s) {
                cache.delete(id);
                add.push(t);
            } else if (!b && !s) {
                cache.set(id, 1);
                rem.push(t);
            } else if (isMod && b && !s) mod.push(t);
        }
        pulse.visit(pulse.MOD, revisit);
        if (_.modified()) {
            isMod = false;
            pulse.visit(pulse.REFLOW, revisit);
        }
        if (cache.empty > df.cleanThreshold) df.runAfter(cache.clean);
        return output;
    }
});
/**
 * Flattens array-typed field values into new data objects.
 * If multiple fields are specified, they are treated as parallel arrays,
 * with output values included for each matching index (or null if missing).
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.fields - An array of field
 *   accessors for the tuple fields that should be flattened.
 * @param {string} [params.index] - Optional output field name for index
 *   value. If unspecified, no index field is included in the output.
 * @param {Array<string>} [params.as] - Output field names for flattened
 *   array fields. Any unspecified fields will use the field name provided
 *   by the fields accessors.
 */ function Flatten(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Flatten.Definition = {
    'type': 'Flatten',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'index',
            'type': 'string'
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Flatten, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), fields = _.fields, as = fieldNames(fields, _.as || []), index = _.index || null, m = as.length;
        // remove any previous results
        out.rem = this.value;
        // generate flattened tuples
        pulse.visit(pulse.SOURCE, (t)=>{
            const arrays = fields.map((f)=>f(t)), maxlen = arrays.reduce((l, a)=>Math.max(l, a.length), 0);
            let i = 0, j, d, v;
            for(; i < maxlen; ++i){
                d = (0, _vegaDataflow.derive)(t);
                for(j = 0; j < m; ++j)d[as[j]] = (v = arrays[j][i]) == null ? null : v;
                if (index) d[index] = i;
                out.add.push(d);
            }
        });
        this.value = out.source = out.add;
        if (index) out.modifies(index);
        return out.modifies(as);
    }
});
/**
 * Folds one more tuple fields into multiple tuples in which the field
 * name and values are available under new 'key' and 'value' fields.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.fields - An array of field accessors
 *   for the tuple fields that should be folded.
 * @param {Array<string>} [params.as] - Output field names for folded key
 *   and value fields, defaults to ['key', 'value'].
 */ function Fold(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Fold.Definition = {
    'type': 'Fold',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'key',
                'value'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Fold, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), fields = _.fields, fnames = fields.map((0, _vegaUtil.accessorName)), as = _.as || [
            'key',
            'value'
        ], k = as[0], v = as[1], n = fields.length;
        out.rem = this.value;
        pulse.visit(pulse.SOURCE, (t)=>{
            for(let i = 0, d; i < n; ++i){
                d = (0, _vegaDataflow.derive)(t);
                d[k] = fnames[i];
                d[v] = fields[i](t);
                out.add.push(d);
            }
        });
        this.value = out.source = out.add;
        return out.modifies(as);
    }
});
/**
 * Invokes a function for each data tuple and saves the results as a new field.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.expr - The formula function to invoke for each tuple.
 * @param {string} params.as - The field name under which to save the result.
 * @param {boolean} [params.initonly=false] - If true, the formula is applied to
 *   added tuples only, and does not update in response to modifications.
 */ function Formula(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Formula.Definition = {
    'type': 'Formula',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'expr',
            'type': 'expr',
            'required': true
        },
        {
            'name': 'as',
            'type': 'string',
            'required': true
        },
        {
            'name': 'initonly',
            'type': 'boolean'
        }
    ]
};
(0, _vegaUtil.inherits)(Formula, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const func = _.expr, as = _.as, mod = _.modified(), flag = _.initonly ? pulse.ADD : mod ? pulse.SOURCE : pulse.modified(func.fields) || pulse.modified(as) ? pulse.ADD_MOD : pulse.ADD;
        if (mod) // parameters updated, need to reflow
        pulse = pulse.materialize().reflow(true);
        if (!_.initonly) pulse.modifies(as);
        return pulse.visit(flag, (t)=>t[as] = func(t, _));
    }
});
/**
 * Generates data tuples using a provided generator function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Parameters): object} params.generator - A tuple generator
 *   function. This function is given the operator parameters as input.
 *   Changes to any additional parameters will not trigger re-calculation
 *   of previously generated tuples. Only future tuples are affected.
 * @param {number} params.size - The number of tuples to produce.
 */ function Generate(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
(0, _vegaUtil.inherits)(Generate, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.ALL), gen = _.generator;
        let data = this.value, num = _.size - data.length, add, rem, t;
        if (num > 0) {
            // need more tuples, generate and add
            for(add = []; --num >= 0;){
                add.push(t = (0, _vegaDataflow.ingest)(gen(_)));
                data.push(t);
            }
            out.add = out.add.length ? out.materialize(out.ADD).add.concat(add) : add;
        } else {
            // need fewer tuples, remove
            rem = data.slice(0, -num);
            out.rem = out.rem.length ? out.materialize(out.REM).rem.concat(rem) : rem;
            data = data.slice(-num);
        }
        out.source = this.value = data;
        return out;
    }
});
const Methods = {
    value: 'value',
    median: (0, _d3Array.median),
    mean: (0, _d3Array.mean),
    min: (0, _d3Array.min),
    max: (0, _d3Array.max)
};
const Empty = [];
/**
 * Impute missing values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to impute.
 * @param {Array<function(object): *>} [params.groupby] - An array of
 *   accessors to determine series within which to perform imputation.
 * @param {function(object): *} params.key - An accessor for a key value.
 *   Each key value should be unique within a group. New tuples will be
 *   imputed for any key values that are not found within a group.
 * @param {Array<*>} [params.keyvals] - Optional array of required key
 *   values. New tuples will be imputed for any key values that are not
 *   found within a group. In addition, these values will be automatically
 *   augmented with the key values observed in the input data.
 * @param {string} [method='value'] - The imputation method to use. One of
 *   'value', 'mean', 'median', 'max', 'min'.
 * @param {*} [value=0] - The constant value to use for imputation
 *   when using method 'value'.
 */ function Impute(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
Impute.Definition = {
    'type': 'Impute',
    'metadata': {
        'changes': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'key',
            'type': 'field',
            'required': true
        },
        {
            'name': 'keyvals',
            'array': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'method',
            'type': 'enum',
            'default': 'value',
            'values': [
                'value',
                'mean',
                'median',
                'max',
                'min'
            ]
        },
        {
            'name': 'value',
            'default': 0
        }
    ]
};
function getValue(_) {
    var m = _.method || Methods.value, v;
    if (Methods[m] == null) (0, _vegaUtil.error)('Unrecognized imputation method: ' + m);
    else if (m === Methods.value) {
        v = _.value !== undefined ? _.value : 0;
        return ()=>v;
    } else return Methods[m];
}
function getField(_) {
    const f = _.field;
    return (t)=>t ? f(t) : NaN;
}
(0, _vegaUtil.inherits)(Impute, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ALL), impute = getValue(_), field = getField(_), fName = (0, _vegaUtil.accessorName)(_.field), kName = (0, _vegaUtil.accessorName)(_.key), gNames = (_.groupby || []).map((0, _vegaUtil.accessorName)), groups = partition(pulse.source, _.groupby, _.key, _.keyvals), curr = [], prev = this.value, m = groups.domain.length, group, value, gVals, kVal, g, i, j, l, n, t;
        for(g = 0, l = groups.length; g < l; ++g){
            group = groups[g];
            gVals = group.values;
            value = NaN;
            // add tuples for missing values
            for(j = 0; j < m; ++j){
                if (group[j] != null) continue;
                kVal = groups.domain[j];
                t = {
                    _impute: true
                };
                for(i = 0, n = gVals.length; i < n; ++i)t[gNames[i]] = gVals[i];
                t[kName] = kVal;
                t[fName] = Number.isNaN(value) ? value = impute(group, field) : value;
                curr.push((0, _vegaDataflow.ingest)(t));
            }
        }
        // update pulse with imputed tuples
        if (curr.length) out.add = out.materialize(out.ADD).add.concat(curr);
        if (prev.length) out.rem = out.materialize(out.REM).rem.concat(prev);
        this.value = curr;
        return out;
    }
});
function partition(data, groupby, key, keyvals) {
    var get = (f)=>f(t), groups = [], domain = keyvals ? keyvals.slice() : [], kMap = {}, gMap = {}, gVals, gKey, group, i, j, k, n, t;
    domain.forEach((k, i)=>kMap[k] = i + 1);
    for(i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = key(t);
        j = kMap[k] || (kMap[k] = domain.push(k));
        gKey = (gVals = groupby ? groupby.map(get) : Empty) + '';
        if (!(group = gMap[gKey])) {
            group = gMap[gKey] = [];
            groups.push(group);
            group.values = gVals;
        }
        group[j - 1] = t;
    }
    groups.domain = domain;
    return groups;
}
/**
 * Extend input tuples with aggregate values.
 * Calcuates aggregate values and joins them with the input stream.
 * @constructor
 */ function JoinAggregate(params) {
    Aggregate.call(this, params);
}
JoinAggregate.Definition = {
    'type': 'JoinAggregate',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'null': true,
            'array': true
        },
        {
            'name': 'ops',
            'type': 'enum',
            'array': true,
            'values': ValidAggregateOps
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        },
        {
            'name': 'key',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(JoinAggregate, Aggregate, {
    transform (_, pulse) {
        const aggr = this, mod = _.modified();
        let cells;
        // process all input tuples to calculate aggregates
        if (aggr.value && (mod || pulse.modified(aggr._inputs, true))) {
            cells = aggr.value = mod ? aggr.init(_) : {};
            pulse.visit(pulse.SOURCE, (t)=>aggr.add(t));
        } else {
            cells = aggr.value = aggr.value || this.init(_);
            pulse.visit(pulse.REM, (t)=>aggr.rem(t));
            pulse.visit(pulse.ADD, (t)=>aggr.add(t));
        }
        // update aggregation cells
        aggr.changes();
        // write aggregate values to input tuples
        pulse.visit(pulse.SOURCE, (t)=>{
            (0, _vegaUtil.extend)(t, cells[aggr.cellkey(t)].tuple);
        });
        return pulse.reflow(mod).modifies(this._outputs);
    },
    changes () {
        const adds = this._adds, mods = this._mods;
        let i, n;
        for(i = 0, n = this._alen; i < n; ++i){
            this.celltuple(adds[i]);
            adds[i] = null; // for garbage collection
        }
        for(i = 0, n = this._mlen; i < n; ++i){
            this.celltuple(mods[i]);
            mods[i] = null; // for garbage collection
        }
        this._alen = this._mlen = 0; // reset list of active cells
    }
});
/**
 * Compute kernel density estimates (KDE) for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {function(object): *} params.field - An accessor for the data field
 *   to estimate.
 * @param {number} [params.bandwidth=0] - The KDE kernel bandwidth.
 *   If zero or unspecified, the bandwidth is automatically determined.
 * @param {boolean} [params.counts=false] - A boolean flag indicating if the
 *   output values should be probability estimates (false, default) or
 *   smoothed counts (true).
 * @param {string} [params.cumulative=false] - A boolean flag indicating if a
 *   density (false) or cumulative distribution (true) should be generated.
 * @param {Array<number>} [params.extent] - The domain extent over which to
 *   plot the density. If unspecified, the [min, max] data extent is used.
 * @param {string} [params.resolve='independent'] - Indicates how parameters for
 *   multiple densities should be resolved. If "independent" (the default), each
 *   density may have its own domain extent and dynamic number of curve sample
 *   steps. If "shared", the KDE transform will ensure that all densities are
 *   defined over a shared domain and curve steps, enabling stacking.
 * @param {number} [params.minsteps=25] - The minimum number of curve samples
 *   for plotting the density.
 * @param {number} [params.maxsteps=200] - The maximum number of curve samples
 *   for plotting the density.
 * @param {number} [params.steps] - The exact number of curve samples for
 *   plotting the density. If specified, overrides both minsteps and maxsteps
 *   to set an exact number of uniform samples. Useful in conjunction with
 *   a fixed extent to ensure consistent sample points for stacked densities.
 */ function KDE(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
KDE.Definition = {
    'type': 'KDE',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'cumulative',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'counts',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'bandwidth',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'resolve',
            'type': 'enum',
            'values': [
                'shared',
                'independent'
            ],
            'default': 'independent'
        },
        {
            'name': 'steps',
            'type': 'number'
        },
        {
            'name': 'minsteps',
            'type': 'number',
            'default': 25
        },
        {
            'name': 'maxsteps',
            'type': 'number',
            'default': 200
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'default': [
                'value',
                'density'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(KDE, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const source = pulse.materialize(pulse.SOURCE).source, groups = partition$1(source, _.groupby, _.field), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), bandwidth = _.bandwidth, method = _.cumulative ? 'cdf' : 'pdf', as = _.as || [
                'value',
                'density'
            ], values = [];
            let domain = _.extent, minsteps = _.steps || _.minsteps || 25, maxsteps = _.steps || _.maxsteps || 200;
            if (method !== 'pdf' && method !== 'cdf') (0, _vegaUtil.error)('Invalid density method: ' + method);
            if (_.resolve === 'shared') {
                if (!domain) domain = (0, _vegaUtil.extent)(source, _.field);
                minsteps = maxsteps = _.steps || maxsteps;
            }
            groups.forEach((g)=>{
                const density = (0, _vegaStatistics.randomKDE)(g, bandwidth)[method], scale = _.counts ? g.length : 1, local = domain || (0, _vegaUtil.extent)(g);
                (0, _vegaStatistics.sampleCurve)(density, local, minsteps, maxsteps).forEach((v)=>{
                    const t = {};
                    for(let i = 0; i < names.length; ++i)t[names[i]] = g.dims[i];
                    t[as[0]] = v[0];
                    t[as[1]] = v[1] * scale;
                    values.push((0, _vegaDataflow.ingest)(t));
                });
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});
/**
 * Generates a key function.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<string>} params.fields - The field name(s) for the key function.
 * @param {boolean} params.flat - A boolean flag indicating if the field names
 *  should be treated as flat property names, side-stepping nested field
 *  lookups normally indicated by dot or bracket notation.
 */ function Key(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$2, params);
}
(0, _vegaUtil.inherits)(Key, (0, _vegaDataflow.Operator));
function update$2(_) {
    return this.value && !_.modified() ? this.value : (0, _vegaUtil.key)(_.fields, _.flat);
}
/**
 * Load and parse data from an external source. Marshalls parameter
 * values and then invokes the Dataflow request method.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.url - The URL to load from.
 * @param {object} params.format - The data format options.
 */ function Load(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
    this._pending = null;
}
(0, _vegaUtil.inherits)(Load, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const df = pulse.dataflow;
        if (this._pending) // update state and return pulse
        return output(this, pulse, this._pending);
        if (stop(_)) return pulse.StopPropagation;
        if (_.values) // parse and ingest values, return output pulse
        return output(this, pulse, df.parse(_.values, _.format));
        else if (_.async) {
            // return promise for non-blocking async loading
            const p = df.request(_.url, _.format).then((res)=>{
                this._pending = (0, _vegaUtil.array)(res.data);
                return (df)=>df.touch(this);
            });
            return {
                async: p
            };
        } else // return promise for synchronous loading
        return df.request(_.url, _.format).then((res)=>output(this, pulse, (0, _vegaUtil.array)(res.data)));
    }
});
function stop(_) {
    return _.modified('async') && !(_.modified('values') || _.modified('url') || _.modified('format'));
}
function output(op, pulse, data) {
    data.forEach((0, _vegaDataflow.ingest));
    const out = pulse.fork(pulse.NO_FIELDS & pulse.NO_SOURCE);
    out.rem = op.value;
    op.value = out.source = out.add = data;
    op._pending = null;
    if (out.rem.length) out.clean(true);
    return out;
}
/**
 * Extend tuples by joining them with values from a lookup table.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Map} params.index - The lookup table map.
 * @param {Array<function(object): *} params.fields - The fields to lookup.
 * @param {Array<string>} params.as - Output field names for each lookup value.
 * @param {*} [params.default] - A default value to use if lookup fails.
 */ function Lookup(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
}
Lookup.Definition = {
    'type': 'Lookup',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'index',
            'type': 'index',
            'params': [
                {
                    'name': 'from',
                    'type': 'data',
                    'required': true
                },
                {
                    'name': 'key',
                    'type': 'field',
                    'required': true
                }
            ]
        },
        {
            'name': 'values',
            'type': 'field',
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        },
        {
            'name': 'default',
            'default': null
        }
    ]
};
(0, _vegaUtil.inherits)(Lookup, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const keys = _.fields, index = _.index, values = _.values, defaultValue = _.default == null ? null : _.default, reset = _.modified(), n = keys.length;
        let flag = reset ? pulse.SOURCE : pulse.ADD, out = pulse, as = _.as, set, m, mods;
        if (values) {
            m = values.length;
            if (n > 1 && !as) (0, _vegaUtil.error)('Multi-field lookup requires explicit "as" parameter.');
            if (as && as.length !== n * m) (0, _vegaUtil.error)('The "as" parameter has too few output field names.');
            as = as || values.map((0, _vegaUtil.accessorName));
            set = function(t) {
                for(var i = 0, k = 0, j, v; i < n; ++i){
                    v = index.get(keys[i](t));
                    if (v == null) for(j = 0; j < m; ++j, ++k)t[as[k]] = defaultValue;
                    else for(j = 0; j < m; ++j, ++k)t[as[k]] = values[j](v);
                }
            };
        } else {
            if (!as) (0, _vegaUtil.error)('Missing output field names.');
            set = function(t) {
                for(var i = 0, v; i < n; ++i){
                    v = index.get(keys[i](t));
                    t[as[i]] = v == null ? defaultValue : v;
                }
            };
        }
        if (reset) out = pulse.reflow(true);
        else {
            mods = keys.some((k)=>pulse.modified(k.fields));
            flag |= mods ? pulse.MOD : 0;
        }
        pulse.visit(flag, set);
        return out.modifies(as);
    }
});
/**
 * Computes global min/max extents over a collection of extents.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<Array<number>>} params.extents - The input extents.
 */ function MultiExtent(params) {
    (0, _vegaDataflow.Operator).call(this, null, update$1, params);
}
(0, _vegaUtil.inherits)(MultiExtent, (0, _vegaDataflow.Operator));
function update$1(_) {
    if (this.value && !_.modified()) return this.value;
    const ext = _.extents, n = ext.length;
    let min = Infinity, max = -Infinity, i, e;
    for(i = 0; i < n; ++i){
        e = ext[i];
        if (e[0] < min) min = e[0];
        if (e[1] > max) max = e[1];
    }
    return [
        min,
        max
    ];
}
/**
 * Merge a collection of value arrays.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<Array<*>>} params.values - The input value arrrays.
 */ function MultiValues(params) {
    (0, _vegaDataflow.Operator).call(this, null, update, params);
}
(0, _vegaUtil.inherits)(MultiValues, (0, _vegaDataflow.Operator));
function update(_) {
    return this.value && !_.modified() ? this.value : _.values.reduce((data, _)=>data.concat(_), []);
}
/**
 * Operator whose value is simply its parameter hash. This operator is
 * useful for enabling reactive updates to values of nested objects.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Params(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Params, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.modified(_.modified());
        this.value = _;
        return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS); // do not pass tuples
    }
});
/**
 * Aggregate and pivot selected field values to become new fields.
 * This operator is useful to construction cross-tabulations.
 * @constructor
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *  to groupby. These fields act just like groupby fields of an Aggregate transform.
 * @param {function(object): *} params.field - The field to pivot on. The unique
 *  values of this field become new field names in the output stream.
 * @param {function(object): *} params.value - The field to populate pivoted fields.
 *  The aggregate values of this field become the values of the new pivoted fields.
 * @param {string} [params.op] - The aggregation operation for the value field,
 *  applied per cell in the output stream. The default is "sum".
 * @param {number} [params.limit] - An optional parameter indicating the maximum
 *  number of pivoted fields to generate. The pivoted field names are sorted in
 *  ascending order prior to enforcing the limit.
 */ function Pivot(params) {
    Aggregate.call(this, params);
}
Pivot.Definition = {
    'type': 'Pivot',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'value',
            'type': 'field',
            'required': true
        },
        {
            'name': 'op',
            'type': 'enum',
            'values': ValidAggregateOps,
            'default': 'sum'
        },
        {
            'name': 'limit',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'key',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(Pivot, Aggregate, {
    _transform: Aggregate.prototype.transform,
    transform (_, pulse) {
        return this._transform(aggregateParams(_, pulse), pulse);
    }
});
// Shoehorn a pivot transform into an aggregate transform!
// First collect all unique pivot field values.
// Then generate aggregate fields for each output pivot field.
function aggregateParams(_, pulse) {
    const key = _.field, value = _.value, op = (_.op === 'count' ? '__count__' : _.op) || 'sum', fields = (0, _vegaUtil.accessorFields)(key).concat((0, _vegaUtil.accessorFields)(value)), keys = pivotKeys(key, _.limit || 0, pulse);
    // if data stream content changes, pivot fields may change
    // flag parameter modification to ensure re-initialization
    if (pulse.changed()) _.set('__pivot__', null, null, true);
    return {
        key: _.key,
        groupby: _.groupby,
        ops: keys.map(()=>op),
        fields: keys.map((k)=>get(k, key, value, fields)),
        as: keys.map((k)=>k + ''),
        modified: _.modified.bind(_)
    };
}
// Generate aggregate field accessor.
// Output NaN for non-existent values; aggregator will ignore!
function get(k, key, value, fields) {
    return (0, _vegaUtil.accessor)((d)=>key(d) === k ? value(d) : NaN, fields, k + '');
}
// Collect (and optionally limit) all unique pivot values.
function pivotKeys(key, limit, pulse) {
    const map = {}, list = [];
    pulse.visit(pulse.SOURCE, (t)=>{
        const k = key(t);
        if (!map[k]) {
            map[k] = 1;
            list.push(k);
        }
    });
    list.sort((0, _vegaUtil.ascending));
    return limit ? list.slice(0, limit) : list;
}
/**
 * Partitions pre-faceted data into tuple subflows.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(Dataflow, string): Operator} params.subflow - A function
 *   that generates a subflow of operators and returns its root operator.
 * @param {function(object): Array<object>} params.field - The field
 *   accessor for an array of subflow tuple objects.
 */ function PreFacet(params) {
    Facet.call(this, params);
}
(0, _vegaUtil.inherits)(PreFacet, Facet, {
    transform (_, pulse) {
        const flow = _.subflow, field = _.field, subflow = (t)=>this.subflow((0, _vegaDataflow.tupleid)(t), flow, pulse, t);
        if (_.modified('field') || field && pulse.modified((0, _vegaUtil.accessorFields)(field))) (0, _vegaUtil.error)('PreFacet does not support field modification.');
        this.initTargets(); // reset list of active subflows
        if (field) {
            pulse.visit(pulse.MOD, (t)=>{
                const sf = subflow(t);
                field(t).forEach((_)=>sf.mod(_));
            });
            pulse.visit(pulse.ADD, (t)=>{
                const sf = subflow(t);
                field(t).forEach((_)=>sf.add((0, _vegaDataflow.ingest)(_)));
            });
            pulse.visit(pulse.REM, (t)=>{
                const sf = subflow(t);
                field(t).forEach((_)=>sf.rem(_));
            });
        } else {
            pulse.visit(pulse.MOD, (t)=>subflow(t).mod(t));
            pulse.visit(pulse.ADD, (t)=>subflow(t).add(t));
            pulse.visit(pulse.REM, (t)=>subflow(t).rem(t));
        }
        if (pulse.clean()) pulse.runAfter(()=>this.clean());
        return pulse;
    }
});
/**
 * Performs a relational projection, copying selected fields from source
 * tuples to a new set of derived tuples.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *} params.fields - The fields to project,
 *   as an array of field accessors. If unspecified, all fields will be
 *   copied with names unchanged.
 * @param {Array<string>} [params.as] - Output field names for each projected
 *   field. Any unspecified fields will use the field name provided by
 *   the field accessor.
 */ function Project(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Project.Definition = {
    'type': 'Project',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Project, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), fields = _.fields, as = fieldNames(_.fields, _.as || []), derive = fields ? (s, t)=>project(s, t, fields, as) : (0, _vegaDataflow.rederive);
        let lut;
        if (this.value) lut = this.value;
        else {
            pulse = pulse.addAll();
            lut = this.value = {};
        }
        pulse.visit(pulse.REM, (t)=>{
            const id = (0, _vegaDataflow.tupleid)(t);
            out.rem.push(lut[id]);
            lut[id] = null;
        });
        pulse.visit(pulse.ADD, (t)=>{
            const dt = derive(t, (0, _vegaDataflow.ingest)({}));
            lut[(0, _vegaDataflow.tupleid)(t)] = dt;
            out.add.push(dt);
        });
        pulse.visit(pulse.MOD, (t)=>{
            out.mod.push(derive(t, lut[(0, _vegaDataflow.tupleid)(t)]));
        });
        return out;
    }
});
function project(s, t, fields, as) {
    for(let i = 0, n = fields.length; i < n; ++i)t[as[i]] = fields[i](s);
    return t;
}
/**
 * Proxy the value of another operator as a pure signal value.
 * Ensures no tuples are propagated.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {*} params.value - The value to proxy, becomes the value of this operator.
 */ function Proxy(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Proxy, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.value = _.value;
        return _.modified('value') ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
    }
});
/**
 * Generates sample quantile values from an input data stream.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - An accessor for the data field
 *   over which to calculate quantile values.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {Array<number>} [params.probs] - An array of probabilities in
 *   the range (0, 1) for which to compute quantile values. If not specified,
 *   the *step* parameter will be used.
 * @param {Array<number>} [params.step=0.01] - A probability step size for
 *   sampling quantile values. All values from one-half the step size up to
 *   1 (exclusive) will be sampled. This parameter is only used if the
 *   *quantiles* parameter is not provided.
 */ function Quantile(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Quantile.Definition = {
    'type': 'Quantile',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'probs',
            'type': 'number',
            'array': true
        },
        {
            'name': 'step',
            'type': 'number',
            'default': 0.01
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'default': [
                'prob',
                'value'
            ]
        }
    ]
};
const EPSILON = 1e-14;
(0, _vegaUtil.inherits)(Quantile, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), as = _.as || [
            'prob',
            'value'
        ];
        if (this.value && !_.modified() && !pulse.changed()) {
            out.source = this.value;
            return out;
        }
        const source = pulse.materialize(pulse.SOURCE).source, groups = partition$1(source, _.groupby, _.field), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), values = [], step = _.step || 0.01, p = _.probs || (0, _d3Array.range)(step / 2, 1 - EPSILON, step), n = p.length;
        groups.forEach((g)=>{
            const q = (0, _vegaStatistics.quantiles)(g, p);
            for(let i = 0; i < n; ++i){
                const t = {};
                for(let i = 0; i < names.length; ++i)t[names[i]] = g.dims[i];
                t[as[0]] = p[i];
                t[as[1]] = q[i];
                values.push((0, _vegaDataflow.ingest)(t));
            }
        });
        if (this.value) out.rem = this.value;
        this.value = out.add = out.source = values;
        return out;
    }
});
/**
 * Relays a data stream between data processing pipelines.
 * If the derive parameter is set, this transform will create derived
 * copies of observed tuples. This provides derived data streams in which
 * modifications to the tuples do not pollute an upstream data source.
 * @param {object} params - The parameters for this operator.
 * @param {number} [params.derive=false] - Boolean flag indicating if
 *   the transform should make derived copies of incoming tuples.
 * @constructor
 */ function Relay(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Relay, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        let out, lut;
        if (this.value) lut = this.value;
        else {
            out = pulse = pulse.addAll();
            lut = this.value = {};
        }
        if (_.derive) {
            out = pulse.fork(pulse.NO_SOURCE);
            pulse.visit(pulse.REM, (t)=>{
                const id = (0, _vegaDataflow.tupleid)(t);
                out.rem.push(lut[id]);
                lut[id] = null;
            });
            pulse.visit(pulse.ADD, (t)=>{
                const dt = (0, _vegaDataflow.derive)(t);
                lut[(0, _vegaDataflow.tupleid)(t)] = dt;
                out.add.push(dt);
            });
            pulse.visit(pulse.MOD, (t)=>{
                const dt = lut[(0, _vegaDataflow.tupleid)(t)];
                for(const k in t){
                    dt[k] = t[k];
                    // down stream writes may overwrite re-derived tuples
                    // conservatively mark all source fields as modified
                    out.modifies(k);
                }
                out.mod.push(dt);
            });
        }
        return out;
    }
});
/**
 * Samples tuples passing through this operator.
 * Uses reservoir sampling to maintain a representative sample.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {number} [params.size=1000] - The maximum number of samples.
 */ function Sample(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
    this.count = 0;
}
Sample.Definition = {
    'type': 'Sample',
    'metadata': {},
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'default': 1000
        }
    ]
};
(0, _vegaUtil.inherits)(Sample, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE), mod = _.modified('size'), num = _.size, map = this.value.reduce((m, t)=>(m[(0, _vegaDataflow.tupleid)(t)] = 1, m), {});
        let res = this.value, cnt = this.count, cap = 0;
        // sample reservoir update function
        function update(t) {
            let p, idx;
            if (res.length < num) res.push(t);
            else {
                idx = ~~((cnt + 1) * (0, _vegaStatistics.random)());
                if (idx < res.length && idx >= cap) {
                    p = res[idx];
                    if (map[(0, _vegaDataflow.tupleid)(p)]) out.rem.push(p); // eviction
                    res[idx] = t;
                }
            }
            ++cnt;
        }
        if (pulse.rem.length) {
            // find all tuples that should be removed, add to output
            pulse.visit(pulse.REM, (t)=>{
                const id = (0, _vegaDataflow.tupleid)(t);
                if (map[id]) {
                    map[id] = -1;
                    out.rem.push(t);
                }
                --cnt;
            });
            // filter removed tuples out of the sample reservoir
            res = res.filter((t)=>map[(0, _vegaDataflow.tupleid)(t)] !== -1);
        }
        if ((pulse.rem.length || mod) && res.length < num && pulse.source) {
            // replenish sample if backing data source is available
            cap = cnt = res.length;
            pulse.visit(pulse.SOURCE, (t)=>{
                // update, but skip previously sampled tuples
                if (!map[(0, _vegaDataflow.tupleid)(t)]) update(t);
            });
            cap = -1;
        }
        if (mod && res.length > num) {
            const n = res.length - num;
            for(let i = 0; i < n; ++i){
                map[(0, _vegaDataflow.tupleid)(res[i])] = -1;
                out.rem.push(res[i]);
            }
            res = res.slice(n);
        }
        if (pulse.mod.length) // propagate modified tuples in the sample reservoir
        pulse.visit(pulse.MOD, (t)=>{
            if (map[(0, _vegaDataflow.tupleid)(t)]) out.mod.push(t);
        });
        if (pulse.add.length) // update sample reservoir
        pulse.visit(pulse.ADD, update);
        if (pulse.add.length || cap < 0) // output newly added tuples
        out.add = res.filter((t)=>!map[(0, _vegaDataflow.tupleid)(t)]);
        this.count = cnt;
        this.value = out.source = res;
        return out;
    }
});
/**
 * Generates data tuples for a specified sequence range of numbers.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {number} params.start - The first number in the sequence.
 * @param {number} params.stop - The last number (exclusive) in the sequence.
 * @param {number} [params.step=1] - The step size between numbers in the sequence.
 */ function Sequence(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Sequence.Definition = {
    'type': 'Sequence',
    'metadata': {
        'generates': true,
        'changes': true
    },
    'params': [
        {
            'name': 'start',
            'type': 'number',
            'required': true
        },
        {
            'name': 'stop',
            'type': 'number',
            'required': true
        },
        {
            'name': 'step',
            'type': 'number',
            'default': 1
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'data'
        }
    ]
};
(0, _vegaUtil.inherits)(Sequence, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !_.modified()) return;
        const out = pulse.materialize().fork(pulse.MOD), as = _.as || 'data';
        out.rem = this.value ? pulse.rem.concat(this.value) : pulse.rem;
        this.value = (0, _d3Array.range)(_.start, _.stop, _.step || 1).map((v)=>{
            const t = {};
            t[as] = v;
            return (0, _vegaDataflow.ingest)(t);
        });
        out.add = pulse.add.concat(this.value);
        return out;
    }
});
/**
 * Propagates a new pulse without any tuples so long as the input
 * pulse contains some added, removed or modified tuples.
 * @param {object} params - The parameters for this operator.
 * @constructor
 */ function Sieve(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this.modified(true); // always treat as modified
}
(0, _vegaUtil.inherits)(Sieve, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.value = pulse.source;
        return pulse.changed() ? pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS) : pulse.StopPropagation;
    }
});
/**
 * Discretize dates to specific time units.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The data field containing date/time values.
 */ function TimeUnit(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const OUTPUT = [
    'unit0',
    'unit1'
];
TimeUnit.Definition = {
    'type': 'TimeUnit',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field',
            'required': true
        },
        {
            'name': 'interval',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'units',
            'type': 'enum',
            'values': (0, _vegaTime.TIME_UNITS),
            'array': true
        },
        {
            'name': 'step',
            'type': 'number',
            'default': 1
        },
        {
            'name': 'maxbins',
            'type': 'number',
            'default': 40
        },
        {
            'name': 'extent',
            'type': 'date',
            'array': true
        },
        {
            'name': 'timezone',
            'type': 'enum',
            'default': 'local',
            'values': [
                'local',
                'utc'
            ]
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': OUTPUT
        }
    ]
};
(0, _vegaUtil.inherits)(TimeUnit, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const field = _.field, band = _.interval !== false, utc = _.timezone === 'utc', floor = this._floor(_, pulse), offset = (utc ? (0, _vegaTime.utcInterval) : (0, _vegaTime.timeInterval))(floor.unit).offset, as = _.as || OUTPUT, u0 = as[0], u1 = as[1], step = floor.step;
        let min = floor.start || Infinity, max = floor.stop || -Infinity, flag = pulse.ADD;
        if (_.modified() || pulse.changed(pulse.REM) || pulse.modified((0, _vegaUtil.accessorFields)(field))) {
            pulse = pulse.reflow(true);
            flag = pulse.SOURCE;
            min = Infinity;
            max = -Infinity;
        }
        pulse.visit(flag, (t)=>{
            const v = field(t);
            let a, b;
            if (v == null) {
                t[u0] = null;
                if (band) t[u1] = null;
            } else {
                t[u0] = a = b = floor(v);
                if (band) t[u1] = b = offset(a, step);
                if (a < min) min = a;
                if (b > max) max = b;
            }
        });
        floor.start = min;
        floor.stop = max;
        return pulse.modifies(band ? as : u0);
    },
    _floor (_, pulse) {
        const utc = _.timezone === 'utc';
        // get parameters
        const { units, step } = _.units ? {
            units: _.units,
            step: _.step || 1
        } : (0, _vegaTime.timeBin)({
            extent: _.extent || (0, _vegaUtil.extent)(pulse.materialize(pulse.SOURCE).source, _.field),
            maxbins: _.maxbins
        });
        // check / standardize time units
        const tunits = (0, _vegaTime.timeUnits)(units), prev = this.value || {}, floor = (utc ? (0, _vegaTime.utcFloor) : (0, _vegaTime.timeFloor))(tunits, step);
        floor.unit = (0, _vegaUtil.peek)(tunits);
        floor.units = tunits;
        floor.step = step;
        floor.start = prev.start;
        floor.stop = prev.stop;
        return this.value = floor;
    }
});
/**
 * An index that maps from unique, string-coerced, field values to tuples.
 * Assumes that the field serves as a unique key with no duplicate values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The field accessor to index.
 */ function TupleIndex(params) {
    (0, _vegaDataflow.Transform).call(this, (0, _vegaUtil.fastmap)(), params);
}
(0, _vegaUtil.inherits)(TupleIndex, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const df = pulse.dataflow, field = _.field, index = this.value, set = (t)=>index.set(field(t), t);
        let mod = true;
        if (_.modified('field') || pulse.modified(field.fields)) {
            index.clear();
            pulse.visit(pulse.SOURCE, set);
        } else if (pulse.changed()) {
            pulse.visit(pulse.REM, (t)=>index.delete(field(t)));
            pulse.visit(pulse.ADD, set);
        } else mod = false;
        this.modified(mod);
        if (index.empty > df.cleanThreshold) df.runAfter(index.clean);
        return pulse.fork();
    }
});
/**
 * Extracts an array of values. Assumes the source data has already been
 * reduced as needed (e.g., by an upstream Aggregate transform).
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The domain field to extract.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for sorting the values. The comparator will be
 *   applied to backing tuples prior to value extraction.
 */ function Values(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Values, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const run = !this.value || _.modified('field') || _.modified('sort') || pulse.changed() || _.sort && pulse.modified(_.sort.fields);
        if (run) this.value = (_.sort ? pulse.source.slice().sort((0, _vegaDataflow.stableCompare)(_.sort)) : pulse.source).map(_.field);
    }
});
function WindowOp(op, field, param, as) {
    const fn = WindowOps[op](field, param);
    return {
        init: fn.init || (0, _vegaUtil.zero),
        update: function(w, t) {
            t[as] = fn.next(w);
        }
    };
}
const WindowOps = {
    row_number: function() {
        return {
            next: (w)=>w.index + 1
        };
    },
    rank: function() {
        let rank;
        return {
            init: ()=>rank = 1,
            next: (w)=>{
                const i = w.index, data = w.data;
                return i && w.compare(data[i - 1], data[i]) ? rank = i + 1 : rank;
            }
        };
    },
    dense_rank: function() {
        let drank;
        return {
            init: ()=>drank = 1,
            next: (w)=>{
                const i = w.index, d = w.data;
                return i && w.compare(d[i - 1], d[i]) ? ++drank : drank;
            }
        };
    },
    percent_rank: function() {
        const rank = WindowOps.rank(), next = rank.next;
        return {
            init: rank.init,
            next: (w)=>(next(w) - 1) / (w.data.length - 1)
        };
    },
    cume_dist: function() {
        let cume;
        return {
            init: ()=>cume = 0,
            next: (w)=>{
                const d = w.data, c = w.compare;
                let i = w.index;
                if (cume < i) {
                    while(i + 1 < d.length && !c(d[i], d[i + 1]))++i;
                    cume = i;
                }
                return (1 + cume) / d.length;
            }
        };
    },
    ntile: function(field, num) {
        num = +num;
        if (!(num > 0)) (0, _vegaUtil.error)('ntile num must be greater than zero.');
        const cume = WindowOps.cume_dist(), next = cume.next;
        return {
            init: cume.init,
            next: (w)=>Math.ceil(num * next(w))
        };
    },
    lag: function(field, offset) {
        offset = +offset || 1;
        return {
            next: (w)=>{
                const i = w.index - offset;
                return i >= 0 ? field(w.data[i]) : null;
            }
        };
    },
    lead: function(field, offset) {
        offset = +offset || 1;
        return {
            next: (w)=>{
                const i = w.index + offset, d = w.data;
                return i < d.length ? field(d[i]) : null;
            }
        };
    },
    first_value: function(field) {
        return {
            next: (w)=>field(w.data[w.i0])
        };
    },
    last_value: function(field) {
        return {
            next: (w)=>field(w.data[w.i1 - 1])
        };
    },
    nth_value: function(field, nth) {
        nth = +nth;
        if (!(nth > 0)) (0, _vegaUtil.error)('nth_value nth must be greater than zero.');
        return {
            next: (w)=>{
                const i = w.i0 + (nth - 1);
                return i < w.i1 ? field(w.data[i]) : null;
            }
        };
    },
    prev_value: function(field) {
        let prev;
        return {
            init: ()=>prev = null,
            next: (w)=>{
                const v = field(w.data[w.index]);
                return v != null ? prev = v : prev;
            }
        };
    },
    next_value: function(field) {
        let v, i;
        return {
            init: ()=>(v = null, i = -1),
            next: (w)=>{
                const d = w.data;
                return w.index <= i ? v : (i = find(field, d, w.index)) < 0 ? (i = d.length, v = null) : v = field(d[i]);
            }
        };
    }
};
function find(field, data, index) {
    for(let n = data.length; index < n; ++index){
        const v = field(data[index]);
        if (v != null) return index;
    }
    return -1;
}
const ValidWindowOps = Object.keys(WindowOps);
function WindowState(_) {
    const ops = (0, _vegaUtil.array)(_.ops), fields = (0, _vegaUtil.array)(_.fields), params = (0, _vegaUtil.array)(_.params), aggregate_params = (0, _vegaUtil.array)(_.aggregate_params), as = (0, _vegaUtil.array)(_.as), outputs = this.outputs = [], windows = this.windows = [], inputs = {}, map = {}, counts = [], measures = [];
    let countOnly = true;
    function visitInputs(f) {
        (0, _vegaUtil.array)((0, _vegaUtil.accessorFields)(f)).forEach((_)=>inputs[_] = 1);
    }
    visitInputs(_.sort);
    ops.forEach((op, i)=>{
        const field = fields[i], param = params[i], aggregate_param = aggregate_params[i] || null, mname = (0, _vegaUtil.accessorName)(field), name = measureName(op, mname, as[i]);
        visitInputs(field);
        outputs.push(name);
        // Window operation
        if ((0, _vegaUtil.hasOwnProperty)(WindowOps, op)) windows.push(WindowOp(op, field, param, name));
        else {
            if (field == null && op !== 'count') (0, _vegaUtil.error)('Null aggregate field specified.');
            if (op === 'count') {
                counts.push(name);
                return;
            }
            countOnly = false;
            let m = map[mname];
            if (!m) {
                m = map[mname] = [];
                m.field = field;
                measures.push(m);
            }
            m.push(createMeasure(op, aggregate_param, name));
        }
    });
    if (counts.length || measures.length) this.cell = cell(measures, counts, countOnly);
    this.inputs = Object.keys(inputs);
}
const prototype = WindowState.prototype;
prototype.init = function() {
    this.windows.forEach((_)=>_.init());
    if (this.cell) this.cell.init();
};
prototype.update = function(w, t) {
    const cell = this.cell, wind = this.windows, data = w.data, m = wind && wind.length;
    let j;
    if (cell) {
        for(j = w.p0; j < w.i0; ++j)cell.rem(data[j]);
        for(j = w.p1; j < w.i1; ++j)cell.add(data[j]);
        cell.set(t);
    }
    for(j = 0; j < m; ++j)wind[j].update(w, t);
};
function cell(measures, counts, countOnly) {
    measures = measures.map((m)=>compileMeasures(m, m.field));
    const cell = {
        num: 0,
        agg: null,
        store: false,
        count: counts
    };
    if (!countOnly) {
        var n = measures.length, a = cell.agg = Array(n), i = 0;
        for(; i < n; ++i)a[i] = new measures[i](cell);
    }
    if (cell.store) var store = cell.data = new TupleStore();
    cell.add = function(t) {
        cell.num += 1;
        if (countOnly) return;
        if (store) store.add(t);
        for(let i = 0; i < n; ++i)a[i].add(a[i].get(t), t);
    };
    cell.rem = function(t) {
        cell.num -= 1;
        if (countOnly) return;
        if (store) store.rem(t);
        for(let i = 0; i < n; ++i)a[i].rem(a[i].get(t), t);
    };
    cell.set = function(t) {
        let i, n;
        // consolidate stored values
        if (store) store.values();
        // update tuple properties
        for(i = 0, n = counts.length; i < n; ++i)t[counts[i]] = cell.num;
        if (!countOnly) for(i = 0, n = a.length; i < n; ++i)a[i].set(t);
    };
    cell.init = function() {
        cell.num = 0;
        if (store) store.reset();
        for(let i = 0; i < n; ++i)a[i].init();
    };
    return cell;
}
/**
 * Perform window calculations and write results to the input stream.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator function for sorting tuples within a window.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors by which to partition tuples into separate windows.
 * @param {Array<string>} params.ops - An array of strings indicating window operations to perform.
 * @param {Array<function(object): *>} [params.fields] - An array of accessors
 *   for data fields to use as inputs to window operations.
 * @param {Array<*>} [params.params] - An array of parameter values for window operations.
 * @param {Array<number>} [params.aggregate_params] - An optional array of parameter values for aggregation operations.
 * @param {Array<string>} [params.as] - An array of output field names for window operations.
 * @param {Array<number>} [params.frame] - Window frame definition as two-element array.
 * @param {boolean} [params.ignorePeers=false] - If true, base window frame boundaries on row
 *   number alone, ignoring peers with identical sort values. If false (default),
 *   the window boundaries will be adjusted to include peer values.
 */ function Window(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
    this._mlen = 0;
    this._mods = [];
}
Window.Definition = {
    'type': 'Window',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'ops',
            'type': 'enum',
            'array': true,
            'values': ValidWindowOps.concat(ValidAggregateOps)
        },
        {
            'name': 'params',
            'type': 'number',
            'null': true,
            'array': true
        },
        {
            'name': 'aggregate_params',
            'type': 'number',
            'null': true,
            'array': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'null': true,
            'array': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'array': true
        },
        {
            'name': 'frame',
            'type': 'number',
            'null': true,
            'array': true,
            'length': 2,
            'default': [
                null,
                0
            ]
        },
        {
            'name': 'ignorePeers',
            'type': 'boolean',
            'default': false
        }
    ]
};
(0, _vegaUtil.inherits)(Window, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        this.stamp = pulse.stamp;
        const mod = _.modified(), cmp = (0, _vegaDataflow.stableCompare)(_.sort), key = groupkey(_.groupby), group = (t)=>this.group(key(t));
        // initialize window state
        let state = this.state;
        if (!state || mod) state = this.state = new WindowState(_);
        // partition input tuples
        if (mod || pulse.modified(state.inputs)) {
            this.value = {};
            pulse.visit(pulse.SOURCE, (t)=>group(t).add(t));
        } else {
            pulse.visit(pulse.REM, (t)=>group(t).remove(t));
            pulse.visit(pulse.ADD, (t)=>group(t).add(t));
        }
        // perform window calculations for each modified partition
        for(let i = 0, n = this._mlen; i < n; ++i)processPartition(this._mods[i], state, cmp, _);
        this._mlen = 0;
        this._mods = [];
        // TODO don't reflow everything?
        return pulse.reflow(mod).modifies(state.outputs);
    },
    group (key) {
        let group = this.value[key];
        if (!group) {
            group = this.value[key] = SortedList((0, _vegaDataflow.tupleid));
            group.stamp = -1;
        }
        if (group.stamp < this.stamp) {
            group.stamp = this.stamp;
            this._mods[this._mlen++] = group;
        }
        return group;
    }
});
function processPartition(list, state, cmp, _) {
    const sort = _.sort, range = sort && !_.ignorePeers, frame = _.frame || [
        null,
        0
    ], data = list.data(cmp), // use cmp for stable sort
    n = data.length, b = range ? (0, _d3Array.bisector)(sort) : null, w = {
        i0: 0,
        i1: 0,
        p0: 0,
        p1: 0,
        index: 0,
        data: data,
        compare: sort || (0, _vegaUtil.constant)(-1)
    };
    state.init();
    for(let i = 0; i < n; ++i){
        setWindow(w, frame, i, n);
        if (range) adjustRange(w, b);
        state.update(w, data[i]);
    }
}
function setWindow(w, f, i, n) {
    w.p0 = w.i0;
    w.p1 = w.i1;
    w.i0 = f[0] == null ? 0 : Math.max(0, i - Math.abs(f[0]));
    w.i1 = f[1] == null ? n : Math.min(n, i + Math.abs(f[1]) + 1);
    w.index = i;
}
// if frame type is 'range', adjust window for peer values
function adjustRange(w, bisect) {
    const r0 = w.i0, r1 = w.i1 - 1, c = w.compare, d = w.data, n = d.length - 1;
    if (r0 > 0 && !c(d[r0], d[r0 - 1])) w.i0 = bisect.left(d, d[r0]);
    if (r1 < n && !c(d[r1], d[r1 + 1])) w.i1 = bisect.right(d, d[r1]);
}

},{"vega-util":"kncZn","vega-dataflow":"eoU45","vega-statistics":"6sdPC","d3-array":"4pSqo","vega-time":"c8K2C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6sdPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bandwidthNRD", ()=>estimateBandwidth);
parcelHelpers.export(exports, "bin", ()=>bin);
parcelHelpers.export(exports, "bootstrapCI", ()=>bootstrapCI);
parcelHelpers.export(exports, "cumulativeLogNormal", ()=>cumulativeLogNormal);
parcelHelpers.export(exports, "cumulativeNormal", ()=>cumulativeNormal);
parcelHelpers.export(exports, "cumulativeUniform", ()=>cumulativeUniform);
parcelHelpers.export(exports, "densityLogNormal", ()=>densityLogNormal);
parcelHelpers.export(exports, "densityNormal", ()=>densityNormal);
parcelHelpers.export(exports, "densityUniform", ()=>densityUniform);
parcelHelpers.export(exports, "dotbin", ()=>dotbin);
parcelHelpers.export(exports, "quantileLogNormal", ()=>quantileLogNormal);
parcelHelpers.export(exports, "quantileNormal", ()=>quantileNormal);
parcelHelpers.export(exports, "quantileUniform", ()=>quantileUniform);
parcelHelpers.export(exports, "quantiles", ()=>quantiles);
parcelHelpers.export(exports, "quartiles", ()=>quartiles);
parcelHelpers.export(exports, "random", ()=>random);
parcelHelpers.export(exports, "randomInteger", ()=>integer);
parcelHelpers.export(exports, "randomKDE", ()=>kde);
parcelHelpers.export(exports, "randomLCG", ()=>lcg);
parcelHelpers.export(exports, "randomLogNormal", ()=>lognormal);
parcelHelpers.export(exports, "randomMixture", ()=>mixture);
parcelHelpers.export(exports, "randomNormal", ()=>gaussian);
parcelHelpers.export(exports, "randomUniform", ()=>uniform);
parcelHelpers.export(exports, "regressionConstant", ()=>constant);
parcelHelpers.export(exports, "regressionExp", ()=>exp);
parcelHelpers.export(exports, "regressionLinear", ()=>linear);
parcelHelpers.export(exports, "regressionLoess", ()=>loess);
parcelHelpers.export(exports, "regressionLog", ()=>log);
parcelHelpers.export(exports, "regressionPoly", ()=>poly);
parcelHelpers.export(exports, "regressionPow", ()=>pow);
parcelHelpers.export(exports, "regressionQuad", ()=>quad);
parcelHelpers.export(exports, "sampleCurve", ()=>sampleCurve);
parcelHelpers.export(exports, "sampleLogNormal", ()=>sampleLogNormal);
parcelHelpers.export(exports, "sampleNormal", ()=>sampleNormal);
parcelHelpers.export(exports, "sampleUniform", ()=>sampleUniform);
parcelHelpers.export(exports, "setRandom", ()=>setRandom);
var _d3Array = require("d3-array");
function* numbers(values, valueof) {
    if (valueof == null) {
        for (let value of values)if (value != null && value !== '' && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values){
            value = valueof(value, ++index, values);
            if (value != null && value !== '' && (value = +value) >= value) yield value;
        }
    }
}
function quantiles(array, p, f) {
    const values = Float64Array.from(numbers(array, f));
    // don't depend on return value from typed array sort call
    // protects against undefined sort results in Safari (vega/vega-lite#4964)
    values.sort((0, _d3Array.ascending));
    return p.map((_)=>(0, _d3Array.quantileSorted)(values, _));
}
function quartiles(array, f) {
    return quantiles(array, [
        0.25,
        0.50,
        0.75
    ], f);
}
// Scott, D. W. (1992) Multivariate Density Estimation:
// Theory, Practice, and Visualization. Wiley.
function estimateBandwidth(array, f) {
    const n = array.length, d = (0, _d3Array.deviation)(array, f), q = quartiles(array, f), h = (q[2] - q[0]) / 1.34, v = Math.min(d, h) || d || Math.abs(q[0]) || 1;
    return 1.06 * v * Math.pow(n, -0.2);
}
function bin(_) {
    // determine range
    const maxb = _.maxbins || 20, base = _.base || 10, logb = Math.log(base), div = _.divide || [
        5,
        2
    ];
    let min = _.extent[0], max = _.extent[1], step, level, minstep, v, i, n;
    const span = _.span || max - min || Math.abs(min) || 1;
    if (_.step) // if step size is explicitly given, use that
    step = _.step;
    else if (_.steps) {
        // if provided, limit choice to acceptable step sizes
        v = span / maxb;
        for(i = 0, n = _.steps.length; i < n && _.steps[i] < v; ++i);
        step = _.steps[Math.max(0, i - 1)];
    } else {
        // else use span to determine step size
        level = Math.ceil(Math.log(maxb) / logb);
        minstep = _.minstep || 0;
        step = Math.max(minstep, Math.pow(base, Math.round(Math.log(span) / logb) - level));
        // increase step size if too many bins
        while(Math.ceil(span / step) > maxb)step *= base;
        // decrease step size if allowed
        for(i = 0, n = div.length; i < n; ++i){
            v = step / div[i];
            if (v >= minstep && span / v <= maxb) step = v;
        }
    }
    // update precision, min and max
    v = Math.log(step);
    const precision = v >= 0 ? 0 : ~~(-v / logb) + 1, eps = Math.pow(base, -precision - 1);
    if (_.nice || _.nice === undefined) {
        v = Math.floor(min / step + eps) * step;
        min = min < v ? v - step : v;
        max = Math.ceil(max / step) * step;
    }
    return {
        start: min,
        stop: max === min ? min + step : max,
        step: step
    };
}
var random = Math.random;
function setRandom(r) {
    random = r;
}
function bootstrapCI(array, samples, alpha, f) {
    if (!array.length) return [
        undefined,
        undefined
    ];
    const values = Float64Array.from(numbers(array, f)), n = values.length, m = samples;
    let a, i, j, mu;
    for(j = 0, mu = Array(m); j < m; ++j){
        for(a = 0, i = 0; i < n; ++i)a += values[~~(random() * n)];
        mu[j] = a / n;
    }
    mu.sort((0, _d3Array.ascending));
    return [
        (0, _d3Array.quantile)(mu, alpha / 2),
        (0, _d3Array.quantile)(mu, 1 - alpha / 2)
    ];
}
// Dot density binning for dot plot construction.
// Based on Leland Wilkinson, Dot Plots, The American Statistician, 1999.
// https://www.cs.uic.edu/~wilkinson/Publications/dotplots.pdf
function dotbin(array, step, smooth, f) {
    f = f || ((_)=>_);
    const n = array.length, v = new Float64Array(n);
    let i = 0, j = 1, a = f(array[0]), b = a, w = a + step, x;
    for(; j < n; ++j){
        x = f(array[j]);
        if (x >= w) {
            b = (a + b) / 2;
            for(; i < j; ++i)v[i] = b;
            w = x + step;
            a = x;
        }
        b = x;
    }
    b = (a + b) / 2;
    for(; i < j; ++i)v[i] = b;
    return smooth ? smoothing(v, step + step / 4) : v;
}
// perform smoothing to reduce variance
// swap points between "adjacent" stacks
// Wilkinson defines adjacent as within step/4 units
function smoothing(v, thresh) {
    const n = v.length;
    let a = 0, b = 1, c, d;
    // get left stack
    while(v[a] === v[b])++b;
    while(b < n){
        // get right stack
        c = b + 1;
        while(v[b] === v[c])++c;
        // are stacks adjacent?
        // if so, compare sizes and swap as needed
        if (v[b] - v[b - 1] < thresh) {
            d = b + (a + c - b - b >> 1);
            while(d < b)v[d++] = v[b];
            while(d > b)v[d--] = v[a];
        }
        // update left stack indices
        a = b;
        b = c;
    }
    return v;
}
function lcg(seed) {
    // Random numbers using a Linear Congruential Generator with seed value
    // Uses glibc values from https://en.wikipedia.org/wiki/Linear_congruential_generator
    return function() {
        seed = (1103515245 * seed + 12345) % 2147483647;
        return seed / 2147483647;
    };
}
function integer(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    let a, b, d;
    const dist = {
        min (_) {
            if (arguments.length) {
                a = _ || 0;
                d = b - a;
                return dist;
            } else return a;
        },
        max (_) {
            if (arguments.length) {
                b = _ || 0;
                d = b - a;
                return dist;
            } else return b;
        },
        sample () {
            return a + Math.floor(d * random());
        },
        pdf (x) {
            return x === Math.floor(x) && x >= a && x < b ? 1 / d : 0;
        },
        cdf (x) {
            const v = Math.floor(x);
            return v < a ? 0 : v >= b ? 1 : (v - a + 1) / d;
        },
        icdf (p) {
            return p >= 0 && p <= 1 ? a - 1 + Math.floor(p * d) : NaN;
        }
    };
    return dist.min(min).max(max);
}
const SQRT2PI = Math.sqrt(2 * Math.PI);
const SQRT2 = Math.SQRT2;
let nextSample = NaN;
function sampleNormal(mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    let x = 0, y = 0, rds, c;
    if (nextSample === nextSample) {
        x = nextSample;
        nextSample = NaN;
    } else {
        do {
            x = random() * 2 - 1;
            y = random() * 2 - 1;
            rds = x * x + y * y;
        }while (rds === 0 || rds > 1);
        c = Math.sqrt(-2 * Math.log(rds) / rds); // Box-Muller transform
        x *= c;
        nextSample = y * c;
    }
    return mean + x * stdev;
}
function densityNormal(value, mean, stdev) {
    stdev = stdev == null ? 1 : stdev;
    const z = (value - (mean || 0)) / stdev;
    return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI);
}
// Approximation from West (2009)
// Better Approximations to Cumulative Normal Functions
function cumulativeNormal(value, mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    const z = (value - mean) / stdev, Z = Math.abs(z);
    let cd;
    if (Z > 37) cd = 0;
    else {
        const exp = Math.exp(-Z * Z / 2);
        let sum;
        if (Z < 7.07106781186547) {
            sum = 3.52624965998911e-02 * Z + 0.700383064443688;
            sum = sum * Z + 6.37396220353165;
            sum = sum * Z + 33.912866078383;
            sum = sum * Z + 112.079291497871;
            sum = sum * Z + 221.213596169931;
            sum = sum * Z + 220.206867912376;
            cd = exp * sum;
            sum = 8.83883476483184e-02 * Z + 1.75566716318264;
            sum = sum * Z + 16.064177579207;
            sum = sum * Z + 86.7807322029461;
            sum = sum * Z + 296.564248779674;
            sum = sum * Z + 637.333633378831;
            sum = sum * Z + 793.826512519948;
            sum = sum * Z + 440.413735824752;
            cd = cd / sum;
        } else {
            sum = Z + 0.65;
            sum = Z + 4 / sum;
            sum = Z + 3 / sum;
            sum = Z + 2 / sum;
            sum = Z + 1 / sum;
            cd = exp / sum / 2.506628274631;
        }
    }
    return z > 0 ? 1 - cd : cd;
}
// Approximation of Probit function using inverse error function.
function quantileNormal(p, mean, stdev) {
    if (p < 0 || p > 1) return NaN;
    return (mean || 0) + (stdev == null ? 1 : stdev) * SQRT2 * erfinv(2 * p - 1);
}
// Approximate inverse error function. Implementation from "Approximating
// the erfinv function" by Mike Giles, GPU Computing Gems, volume 2, 2010.
// Ported from Apache Commons Math, http://www.apache.org/licenses/LICENSE-2.0
function erfinv(x) {
    // beware that the logarithm argument must be
    // commputed as (1.0 - x) * (1.0 + x),
    // it must NOT be simplified as 1.0 - x * x as this
    // would induce rounding errors near the boundaries +/-1
    let w = -Math.log((1 - x) * (1 + x)), p;
    if (w < 6.25) {
        w -= 3.125;
        p = -0.00000000000000000000364441206401782;
        p = -0.00000000000000000016850591381820166 + p * w;
        p = 1.2858480715256400167e-18 + p * w;
        p = 1.115787767802518096e-17 + p * w;
        p = -0.0000000000000001333171662854621 + p * w;
        p = 2.0972767875968561637e-17 + p * w;
        p = 6.6376381343583238325e-15 + p * w;
        p = -0.00000000000004054566272975207 + p * w;
        p = -0.00000000000008151934197605472 + p * w;
        p = 2.6335093153082322977e-12 + p * w;
        p = -0.000000000012975133253453532 + p * w;
        p = -0.00000000005415412054294628 + p * w;
        p = 1.051212273321532285e-09 + p * w;
        p = -0.000000004112633980346984 + p * w;
        p = -0.000000029070369957882005 + p * w;
        p = 4.2347877827932403518e-07 + p * w;
        p = -0.0000013654692000834679 + p * w;
        p = -0.000013882523362786469 + p * w;
        p = 0.0001867342080340571352 + p * w;
        p = -0.000740702534166267 + p * w;
        p = -0.006033670871430149 + p * w;
        p = 0.24015818242558961693 + p * w;
        p = 1.6536545626831027356 + p * w;
    } else if (w < 16.0) {
        w = Math.sqrt(w) - 3.25;
        p = 2.2137376921775787049e-09;
        p = 9.0756561938885390979e-08 + p * w;
        p = -0.00000027517406297064545 + p * w;
        p = 1.8239629214389227755e-08 + p * w;
        p = 1.5027403968909827627e-06 + p * w;
        p = -0.000004013867526981546 + p * w;
        p = 2.9234449089955446044e-06 + p * w;
        p = 1.2475304481671778723e-05 + p * w;
        p = -0.000047318229009055734 + p * w;
        p = 6.8284851459573175448e-05 + p * w;
        p = 2.4031110387097893999e-05 + p * w;
        p = -0.0003550375203628475 + p * w;
        p = 0.00095328937973738049703 + p * w;
        p = -0.0016882755560235047 + p * w;
        p = 0.0024914420961078508066 + p * w;
        p = -0.003751208507569241 + p * w;
        p = 0.005370914553590063617 + p * w;
        p = 1.0052589676941592334 + p * w;
        p = 3.0838856104922207635 + p * w;
    } else if (Number.isFinite(w)) {
        w = Math.sqrt(w) - 5.0;
        p = -0.000000000027109920616438573;
        p = -0.0000000002555641816996525 + p * w;
        p = 1.5076572693500548083e-09 + p * w;
        p = -0.000000003789465440126737 + p * w;
        p = 7.6157012080783393804e-09 + p * w;
        p = -0.00000001496002662714924 + p * w;
        p = 2.9147953450901080826e-08 + p * w;
        p = -0.00000006771199775845234 + p * w;
        p = 2.2900482228026654717e-07 + p * w;
        p = -0.00000099298272942317 + p * w;
        p = 4.5260625972231537039e-06 + p * w;
        p = -0.00001968177810553167 + p * w;
        p = 7.5995277030017761139e-05 + p * w;
        p = -0.00021503011930044477 + p * w;
        p = -0.00013871931833623122 + p * w;
        p = 1.0103004648645343977 + p * w;
        p = 4.8499064014085844221 + p * w;
    } else p = Infinity;
    return p * x;
}
function gaussian(mean, stdev) {
    let mu, sigma;
    const dist = {
        mean (_) {
            if (arguments.length) {
                mu = _ || 0;
                return dist;
            } else return mu;
        },
        stdev (_) {
            if (arguments.length) {
                sigma = _ == null ? 1 : _;
                return dist;
            } else return sigma;
        },
        sample: ()=>sampleNormal(mu, sigma),
        pdf: (value)=>densityNormal(value, mu, sigma),
        cdf: (value)=>cumulativeNormal(value, mu, sigma),
        icdf: (p)=>quantileNormal(p, mu, sigma)
    };
    return dist.mean(mean).stdev(stdev);
}
function kde(support, bandwidth) {
    const kernel = gaussian();
    let n = 0;
    const dist = {
        data (_) {
            if (arguments.length) {
                support = _;
                n = _ ? _.length : 0;
                return dist.bandwidth(bandwidth);
            } else return support;
        },
        bandwidth (_) {
            if (!arguments.length) return bandwidth;
            bandwidth = _;
            if (!bandwidth && support) bandwidth = estimateBandwidth(support);
            return dist;
        },
        sample () {
            return support[~~(random() * n)] + bandwidth * kernel.sample();
        },
        pdf (x) {
            let y = 0, i = 0;
            for(; i < n; ++i)y += kernel.pdf((x - support[i]) / bandwidth);
            return y / bandwidth / n;
        },
        cdf (x) {
            let y = 0, i = 0;
            for(; i < n; ++i)y += kernel.cdf((x - support[i]) / bandwidth);
            return y / n;
        },
        icdf () {
            throw Error('KDE icdf not supported.');
        }
    };
    return dist.data(support);
}
function sampleLogNormal(mean, stdev) {
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    return Math.exp(mean + sampleNormal() * stdev);
}
function densityLogNormal(value, mean, stdev) {
    if (value <= 0) return 0;
    mean = mean || 0;
    stdev = stdev == null ? 1 : stdev;
    const z = (Math.log(value) - mean) / stdev;
    return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI * value);
}
function cumulativeLogNormal(value, mean, stdev) {
    return cumulativeNormal(Math.log(value), mean, stdev);
}
function quantileLogNormal(p, mean, stdev) {
    return Math.exp(quantileNormal(p, mean, stdev));
}
function lognormal(mean, stdev) {
    let mu, sigma;
    const dist = {
        mean (_) {
            if (arguments.length) {
                mu = _ || 0;
                return dist;
            } else return mu;
        },
        stdev (_) {
            if (arguments.length) {
                sigma = _ == null ? 1 : _;
                return dist;
            } else return sigma;
        },
        sample: ()=>sampleLogNormal(mu, sigma),
        pdf: (value)=>densityLogNormal(value, mu, sigma),
        cdf: (value)=>cumulativeLogNormal(value, mu, sigma),
        icdf: (p)=>quantileLogNormal(p, mu, sigma)
    };
    return dist.mean(mean).stdev(stdev);
}
function mixture(dists, weights) {
    let m = 0, w;
    function normalize(x) {
        const w = [];
        let sum = 0, i;
        for(i = 0; i < m; ++i)sum += w[i] = x[i] == null ? 1 : +x[i];
        for(i = 0; i < m; ++i)w[i] /= sum;
        return w;
    }
    const dist = {
        weights (_) {
            if (arguments.length) {
                w = normalize(weights = _ || []);
                return dist;
            }
            return weights;
        },
        distributions (_) {
            if (arguments.length) {
                if (_) {
                    m = _.length;
                    dists = _;
                } else {
                    m = 0;
                    dists = [];
                }
                return dist.weights(weights);
            }
            return dists;
        },
        sample () {
            const r = random();
            let d = dists[m - 1], v = w[0], i = 0;
            // first select distribution
            for(; i < m - 1; v += w[++i])if (r < v) {
                d = dists[i];
                break;
            }
            // then sample from it
            return d.sample();
        },
        pdf (x) {
            let p = 0, i = 0;
            for(; i < m; ++i)p += w[i] * dists[i].pdf(x);
            return p;
        },
        cdf (x) {
            let p = 0, i = 0;
            for(; i < m; ++i)p += w[i] * dists[i].cdf(x);
            return p;
        },
        icdf () {
            throw Error('Mixture icdf not supported.');
        }
    };
    return dist.distributions(dists).weights(weights);
}
function sampleUniform(min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return min + (max - min) * random();
}
function densityUniform(value, min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return value >= min && value <= max ? 1 / (max - min) : 0;
}
function cumulativeUniform(value, min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return value < min ? 0 : value > max ? 1 : (value - min) / (max - min);
}
function quantileUniform(p, min, max) {
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return p >= 0 && p <= 1 ? min + p * (max - min) : NaN;
}
function uniform(min, max) {
    let a, b;
    const dist = {
        min (_) {
            if (arguments.length) {
                a = _ || 0;
                return dist;
            } else return a;
        },
        max (_) {
            if (arguments.length) {
                b = _ == null ? 1 : _;
                return dist;
            } else return b;
        },
        sample: ()=>sampleUniform(a, b),
        pdf: (value)=>densityUniform(value, a, b),
        cdf: (value)=>cumulativeUniform(value, a, b),
        icdf: (p)=>quantileUniform(p, a, b)
    };
    if (max == null) {
        max = min == null ? 1 : min;
        min = 0;
    }
    return dist.min(min).max(max);
}
function constant(data, x, y) {
    let mean = 0, n = 0;
    for (const d of data){
        const val = y(d);
        if (x(d) == null || val == null || isNaN(val)) continue;
        mean += (val - mean) / ++n;
    }
    return {
        coef: [
            mean
        ],
        predict: ()=>mean,
        rSquared: 0
    };
}
// Ordinary Least Squares
function ols(uX, uY, uXY, uX2) {
    const delta = uX2 - uX * uX, slope = Math.abs(delta) < 1e-24 ? 0 : (uXY - uX * uY) / delta, intercept = uY - slope * uX;
    return [
        intercept,
        slope
    ];
}
function points(data, x, y, sort) {
    data = data.filter((d)=>{
        let u = x(d), v = y(d);
        return u != null && (u = +u) >= u && v != null && (v = +v) >= v;
    });
    if (sort) data.sort((a, b)=>x(a) - x(b));
    const n = data.length, X = new Float64Array(n), Y = new Float64Array(n);
    // extract values, calculate means
    let i = 0, ux = 0, uy = 0, xv, yv, d;
    for (d of data){
        X[i] = xv = +x(d);
        Y[i] = yv = +y(d);
        ++i;
        ux += (xv - ux) / i;
        uy += (yv - uy) / i;
    }
    // mean center the data
    for(i = 0; i < n; ++i){
        X[i] -= ux;
        Y[i] -= uy;
    }
    return [
        X,
        Y,
        ux,
        uy
    ];
}
function visitPoints(data, x, y, callback) {
    let i = -1, u, v;
    for (const d of data){
        u = x(d);
        v = y(d);
        if (u != null && (u = +u) >= u && v != null && (v = +v) >= v) callback(u, v, ++i);
    }
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function rSquared(data, x, y, uY, predict) {
    let SSE = 0, SST = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        const sse = dy - predict(dx), sst = dy - uY;
        SSE += sse * sse;
        SST += sst * sst;
    });
    return 1 - SSE / SST;
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function linear(data, x, y) {
    let X = 0, Y = 0, XY = 0, X2 = 0, n = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        ++n;
        X += (dx - X) / n;
        Y += (dy - Y) / n;
        XY += (dx * dy - XY) / n;
        X2 += (dx * dx - X2) / n;
    });
    const coef = ols(X, Y, XY, X2), predict = (x)=>coef[0] + coef[1] * x;
    return {
        coef: coef,
        predict: predict,
        rSquared: rSquared(data, x, y, Y, predict)
    };
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function log(data, x, y) {
    let X = 0, Y = 0, XY = 0, X2 = 0, n = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        ++n;
        dx = Math.log(dx);
        X += (dx - X) / n;
        Y += (dy - Y) / n;
        XY += (dx * dy - XY) / n;
        X2 += (dx * dx - X2) / n;
    });
    const coef = ols(X, Y, XY, X2), predict = (x)=>coef[0] + coef[1] * Math.log(x);
    return {
        coef: coef,
        predict: predict,
        rSquared: rSquared(data, x, y, Y, predict)
    };
}
function exp(data, x, y) {
    const [xv, yv, ux, uy] = points(data, x, y);
    let YL = 0, XY = 0, XYL = 0, X2Y = 0, n = 0, dx, ly, xy;
    visitPoints(data, x, y, (_, dy)=>{
        dx = xv[n++];
        ly = Math.log(dy);
        xy = dx * dy;
        YL += (dy * ly - YL) / n;
        XY += (xy - XY) / n;
        XYL += (xy * ly - XYL) / n;
        X2Y += (dx * xy - X2Y) / n;
    });
    const [c0, c1] = ols(XY / uy, YL / uy, XYL / uy, X2Y / uy), predict = (x)=>Math.exp(c0 + c1 * (x - ux));
    return {
        coef: [
            Math.exp(c0 - c1 * ux),
            c1
        ],
        predict: predict,
        rSquared: rSquared(data, x, y, uy, predict)
    };
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
function pow(data, x, y) {
    let X = 0, Y = 0, XY = 0, X2 = 0, YS = 0, n = 0;
    visitPoints(data, x, y, (dx, dy)=>{
        const lx = Math.log(dx), ly = Math.log(dy);
        ++n;
        X += (lx - X) / n;
        Y += (ly - Y) / n;
        XY += (lx * ly - XY) / n;
        X2 += (lx * lx - X2) / n;
        YS += (dy - YS) / n;
    });
    const coef = ols(X, Y, XY, X2), predict = (x)=>coef[0] * Math.pow(x, coef[1]);
    coef[0] = Math.exp(coef[0]);
    return {
        coef: coef,
        predict: predict,
        rSquared: rSquared(data, x, y, YS, predict)
    };
}
function quad(data, x, y) {
    const [xv, yv, ux, uy] = points(data, x, y), n = xv.length;
    let X2 = 0, X3 = 0, X4 = 0, XY = 0, X2Y = 0, i, dx, dy, x2;
    for(i = 0; i < n;){
        dx = xv[i];
        dy = yv[i++];
        x2 = dx * dx;
        X2 += (x2 - X2) / i;
        X3 += (x2 * dx - X3) / i;
        X4 += (x2 * x2 - X4) / i;
        XY += (dx * dy - XY) / i;
        X2Y += (x2 * dy - X2Y) / i;
    }
    const X2X2 = X4 - X2 * X2, d = X2 * X2X2 - X3 * X3, a = (X2Y * X2 - XY * X3) / d, b = (XY * X2X2 - X2Y * X3) / d, c = -a * X2, predict = (x)=>{
        x = x - ux;
        return a * x * x + b * x + c + uy;
    };
    // transform coefficients back from mean-centered space
    return {
        coef: [
            c - b * ux + a * ux * ux + uy,
            b - 2 * a * ux,
            a
        ],
        predict: predict,
        rSquared: rSquared(data, x, y, uy, predict)
    };
}
// Adapted from d3-regression by Harry Stevens
// License: https://github.com/HarryStevens/d3-regression/blob/master/LICENSE
// ... which was adapted from regression-js by Tom Alexander
// Source: https://github.com/Tom-Alexander/regression-js/blob/master/src/regression.js#L246
// License: https://github.com/Tom-Alexander/regression-js/blob/master/LICENSE
function poly(data, x, y, order) {
    // use more efficient methods for lower orders
    if (order === 0) return constant(data, x, y);
    if (order === 1) return linear(data, x, y);
    if (order === 2) return quad(data, x, y);
    const [xv, yv, ux, uy] = points(data, x, y), n = xv.length, lhs = [], rhs = [], k = order + 1;
    let i, j, l, v, c;
    for(i = 0; i < k; ++i){
        for(l = 0, v = 0; l < n; ++l)v += Math.pow(xv[l], i) * yv[l];
        lhs.push(v);
        c = new Float64Array(k);
        for(j = 0; j < k; ++j){
            for(l = 0, v = 0; l < n; ++l)v += Math.pow(xv[l], i + j);
            c[j] = v;
        }
        rhs.push(c);
    }
    rhs.push(lhs);
    const coef = gaussianElimination(rhs), predict = (x)=>{
        x -= ux;
        let y = uy + coef[0] + coef[1] * x + coef[2] * x * x;
        for(i = 3; i < k; ++i)y += coef[i] * Math.pow(x, i);
        return y;
    };
    return {
        coef: uncenter(k, coef, -ux, uy),
        predict: predict,
        rSquared: rSquared(data, x, y, uy, predict)
    };
}
function uncenter(k, a, x, y) {
    const z = Array(k);
    let i, j, v, c;
    // initialize to zero
    for(i = 0; i < k; ++i)z[i] = 0;
    // polynomial expansion
    for(i = k - 1; i >= 0; --i){
        v = a[i];
        c = 1;
        z[i] += v;
        for(j = 1; j <= i; ++j){
            c *= (i + 1 - j) / j; // binomial coefficent
            z[i - j] += v * Math.pow(x, j) * c;
        }
    }
    // bias term
    z[0] += y;
    return z;
}
// Given an array for a two-dimensional matrix and the polynomial order,
// solve A * x = b using Gaussian elimination.
function gaussianElimination(matrix) {
    const n = matrix.length - 1, coef = [];
    let i, j, k, r, t;
    for(i = 0; i < n; ++i){
        r = i; // max row
        for(j = i + 1; j < n; ++j)if (Math.abs(matrix[i][j]) > Math.abs(matrix[i][r])) r = j;
        for(k = i; k < n + 1; ++k){
            t = matrix[k][i];
            matrix[k][i] = matrix[k][r];
            matrix[k][r] = t;
        }
        for(j = i + 1; j < n; ++j)for(k = n; k >= i; k--)matrix[k][j] -= matrix[k][i] * matrix[i][j] / matrix[i][i];
    }
    for(j = n - 1; j >= 0; --j){
        t = 0;
        for(k = j + 1; k < n; ++k)t += matrix[k][j] * coef[k];
        coef[j] = (matrix[n][j] - t) / matrix[j][j];
    }
    return coef;
}
const maxiters = 2, epsilon = 1e-12;
// Adapted from science.js by Jason Davies
// Source: https://github.com/jasondavies/science.js/blob/master/src/stats/loess.js
// License: https://github.com/jasondavies/science.js/blob/master/LICENSE
function loess(data, x, y, bandwidth) {
    const [xv, yv, ux, uy] = points(data, x, y, true), n = xv.length, bw = Math.max(2, ~~(bandwidth * n)), // # nearest neighbors
    yhat = new Float64Array(n), residuals = new Float64Array(n), robustWeights = new Float64Array(n).fill(1);
    for(let iter = -1; ++iter <= maxiters;){
        const interval = [
            0,
            bw - 1
        ];
        for(let i = 0; i < n; ++i){
            const dx = xv[i], i0 = interval[0], i1 = interval[1], edge = dx - xv[i0] > xv[i1] - dx ? i0 : i1;
            let W = 0, X = 0, Y = 0, XY = 0, X2 = 0;
            const denom = 1 / Math.abs(xv[edge] - dx || 1); // avoid singularity!
            for(let k = i0; k <= i1; ++k){
                const xk = xv[k], yk = yv[k], w = tricube(Math.abs(dx - xk) * denom) * robustWeights[k], xkw = xk * w;
                W += w;
                X += xkw;
                Y += yk * w;
                XY += yk * xkw;
                X2 += xk * xkw;
            }
            // linear regression fit
            const [a, b] = ols(X / W, Y / W, XY / W, X2 / W);
            yhat[i] = a + b * dx;
            residuals[i] = Math.abs(yv[i] - yhat[i]);
            updateInterval(xv, i + 1, interval);
        }
        if (iter === maxiters) break;
        const medianResidual = (0, _d3Array.median)(residuals);
        if (Math.abs(medianResidual) < epsilon) break;
        for(let i = 0, arg, w; i < n; ++i){
            arg = residuals[i] / (6 * medianResidual);
            // default to epsilon (rather than zero) for large deviations
            // keeping weights tiny but non-zero prevents singularites
            robustWeights[i] = arg >= 1 ? epsilon : (w = 1 - arg * arg) * w;
        }
    }
    return output(xv, yhat, ux, uy);
}
// weighting kernel for local regression
function tricube(x) {
    return (x = 1 - x * x * x) * x * x;
}
// advance sliding window interval of nearest neighbors
function updateInterval(xv, i, interval) {
    const val = xv[i];
    let left = interval[0], right = interval[1] + 1;
    if (right >= xv.length) return;
    // step right if distance to new right edge is <= distance to old left edge
    // step when distance is equal to ensure movement over duplicate x values
    while(i > left && xv[right] - val <= val - xv[left]){
        interval[0] = ++left;
        interval[1] = right;
        ++right;
    }
}
// generate smoothed output points
// average points with repeated x values
function output(xv, yhat, ux, uy) {
    const n = xv.length, out = [];
    let i = 0, cnt = 0, prev = [], v;
    for(; i < n; ++i){
        v = xv[i] + ux;
        if (prev[0] === v) // average output values via online update
        prev[1] += (yhat[i] - prev[1]) / ++cnt;
        else {
            // add new output point
            cnt = 0;
            prev[1] += uy;
            prev = [
                v,
                yhat[i]
            ];
            out.push(prev);
        }
    }
    prev[1] += uy;
    return out;
}
// subdivide up to accuracy of 0.5 degrees
const MIN_RADIANS = 0.5 * Math.PI / 180;
// Adaptively sample an interpolated function over a domain extent
function sampleCurve(f, extent, minSteps, maxSteps) {
    minSteps = minSteps || 25;
    maxSteps = Math.max(minSteps, maxSteps || 200);
    const point = (x)=>[
            x,
            f(x)
        ], minX = extent[0], maxX = extent[1], span = maxX - minX, stop = span / maxSteps, prev = [
        point(minX)
    ], next = [];
    if (minSteps === maxSteps) {
        // no adaptation, sample uniform grid directly and return
        for(let i = 1; i < maxSteps; ++i)prev.push(point(minX + i / minSteps * span));
        prev.push(point(maxX));
        return prev;
    } else {
        // sample minimum points on uniform grid
        // then move on to perform adaptive refinement
        next.push(point(maxX));
        for(let i = minSteps; --i > 0;)next.push(point(minX + i / minSteps * span));
    }
    let p0 = prev[0];
    let p1 = next[next.length - 1];
    const sx = 1 / span;
    const sy = scaleY(p0[1], next);
    while(p1){
        // midpoint for potential curve subdivision
        const pm = point((p0[0] + p1[0]) / 2);
        const dx = pm[0] - p0[0] >= stop;
        if (dx && angleDelta(p0, pm, p1, sx, sy) > MIN_RADIANS) // maximum resolution has not yet been met, and
        // subdivision midpoint is sufficiently different from endpoint
        // save subdivision, push midpoint onto the visitation stack
        next.push(pm);
        else {
            // subdivision midpoint sufficiently similar to endpoint
            // skip subdivision, store endpoint, move to next point on the stack
            p0 = p1;
            prev.push(p1);
            next.pop();
        }
        p1 = next[next.length - 1];
    }
    return prev;
}
function scaleY(init, points) {
    let ymin = init;
    let ymax = init;
    const n = points.length;
    for(let i = 0; i < n; ++i){
        const y = points[i][1];
        if (y < ymin) ymin = y;
        if (y > ymax) ymax = y;
    }
    return 1 / (ymax - ymin);
}
function angleDelta(p, q, r, sx, sy) {
    const a0 = Math.atan2(sy * (r[1] - p[1]), sx * (r[0] - p[0])), a1 = Math.atan2(sy * (q[1] - p[1]), sx * (q[0] - p[0]));
    return Math.abs(a0 - a1);
}

},{"d3-array":"4pSqo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6M7us":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bound", ()=>Bound);
parcelHelpers.export(exports, "identifier", ()=>Identifier);
parcelHelpers.export(exports, "mark", ()=>Mark);
parcelHelpers.export(exports, "overlap", ()=>Overlap);
parcelHelpers.export(exports, "render", ()=>Render);
parcelHelpers.export(exports, "viewlayout", ()=>ViewLayout);
var _vegaDataflow = require("vega-dataflow");
var _vegaScenegraph = require("vega-scenegraph");
var _vegaUtil = require("vega-util");
const Top = 'top';
const Left = 'left';
const Right = 'right';
const Bottom = 'bottom';
const TopLeft = 'top-left';
const TopRight = 'top-right';
const BottomLeft = 'bottom-left';
const BottomRight = 'bottom-right';
const Start = 'start';
const Middle = 'middle';
const End = 'end';
const X = 'x';
const Y = 'y';
const Group = 'group';
const AxisRole = 'axis';
const TitleRole = 'title';
const FrameRole = 'frame';
const ScopeRole = 'scope';
const LegendRole = 'legend';
const RowHeader = 'row-header';
const RowFooter = 'row-footer';
const RowTitle = 'row-title';
const ColHeader = 'column-header';
const ColFooter = 'column-footer';
const ColTitle = 'column-title';
const Padding = 'padding';
const Symbols = 'symbol';
const Fit = 'fit';
const FitX = 'fit-x';
const FitY = 'fit-y';
const Pad = 'pad';
const None = 'none';
const All = 'all';
const Each = 'each';
const Flush = 'flush';
const Column = 'column';
const Row = 'row';
/**
 * Calculate bounding boxes for scenegraph items.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.mark - The scenegraph mark instance to bound.
 */ function Bound(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Bound, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const view = pulse.dataflow, mark = _.mark, type = mark.marktype, entry = (0, _vegaScenegraph.Marks)[type], bound = entry.bound;
        let markBounds = mark.bounds, rebound;
        if (entry.nested) {
            // multi-item marks have a single bounds instance
            if (mark.items.length) view.dirty(mark.items[0]);
            markBounds = boundItem(mark, bound);
            mark.items.forEach((item)=>{
                item.bounds.clear().union(markBounds);
            });
        } else if (type === Group || _.modified()) {
            // operator parameters modified -> re-bound all items
            // updates group bounds in response to modified group content
            pulse.visit(pulse.MOD, (item)=>view.dirty(item));
            markBounds.clear();
            mark.items.forEach((item)=>markBounds.union(boundItem(item, bound)));
            // force reflow for axes/legends/titles to propagate any layout changes
            switch(mark.role){
                case AxisRole:
                case LegendRole:
                case TitleRole:
                    pulse.reflow();
            }
        } else {
            // incrementally update bounds, re-bound mark as needed
            rebound = pulse.changed(pulse.REM);
            pulse.visit(pulse.ADD, (item)=>{
                markBounds.union(boundItem(item, bound));
            });
            pulse.visit(pulse.MOD, (item)=>{
                rebound = rebound || markBounds.alignsWith(item.bounds);
                view.dirty(item);
                markBounds.union(boundItem(item, bound));
            });
            if (rebound) {
                markBounds.clear();
                mark.items.forEach((item)=>markBounds.union(item.bounds));
            }
        }
        // ensure mark bounds do not exceed any clipping region
        (0, _vegaScenegraph.boundClip)(mark);
        return pulse.modifies('bounds');
    }
});
function boundItem(item, bound, opt) {
    return bound(item.bounds.clear(), item, opt);
}
const COUNTER_NAME = ':vega_identifier:';
/**
 * Adds a unique identifier to all added tuples.
 * This transform creates a new signal that serves as an id counter.
 * As a result, the id counter is shared across all instances of this
 * transform, generating unique ids across multiple data streams. In
 * addition, this signal value can be included in a snapshot of the
 * dataflow state, enabling correct resumption of id allocation.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {string} params.as - The field name for the generated identifier.
 */ function Identifier(params) {
    (0, _vegaDataflow.Transform).call(this, 0, params);
}
Identifier.Definition = {
    'type': 'Identifier',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'as',
            'type': 'string',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Identifier, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const counter = getCounter(pulse.dataflow), as = _.as;
        let id = counter.value;
        pulse.visit(pulse.ADD, (t)=>t[as] = t[as] || ++id);
        counter.set(this.value = id);
        return pulse;
    }
});
function getCounter(view) {
    return view._signals[COUNTER_NAME] || (view._signals[COUNTER_NAME] = view.add(0));
}
/**
 * Bind scenegraph items to a scenegraph mark instance.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.markdef - The mark definition for creating the mark.
 *   This is an object of legal scenegraph mark properties which *must* include
 *   the 'marktype' property.
 */ function Mark(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Mark, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        let mark = this.value;
        // acquire mark on first invocation, bind context and group
        if (!mark) {
            mark = pulse.dataflow.scenegraph().mark(_.markdef, lookup$1(_), _.index);
            mark.group.context = _.context;
            if (!_.context.group) _.context.group = mark.group;
            mark.source = this.source; // point to upstream collector
            mark.clip = _.clip;
            mark.interactive = _.interactive;
            this.value = mark;
        }
        // initialize entering items
        const Init = mark.marktype === Group ? (0, _vegaScenegraph.GroupItem) : (0, _vegaScenegraph.Item);
        pulse.visit(pulse.ADD, (item)=>Init.call(item, mark));
        // update clipping and/or interactive status
        if (_.modified('clip') || _.modified('interactive')) {
            mark.clip = _.clip;
            mark.interactive = !!_.interactive;
            mark.zdirty = true; // force scenegraph re-eval
            pulse.reflow();
        }
        // bind items array to scenegraph mark
        mark.items = pulse.source;
        return pulse;
    }
});
function lookup$1(_) {
    const g = _.groups, p = _.parent;
    return g && g.size === 1 ? g.get(Object.keys(g.object)[0]) : g && p ? g.lookup(p) : null;
}
/**
 * Analyze items for overlap, changing opacity to hide items with
 * overlapping bounding boxes. This transform will preserve at least
 * two items (e.g., first and last) even if overlap persists.
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator
 *   function for sorting items.
 * @param {object} [params.method] - The overlap removal method to apply.
 *   One of 'parity' (default, hide every other item until there is no
 *   more overlap) or 'greedy' (sequentially scan and hide and items that
 *   overlap with the last visible item).
 * @param {object} [params.boundScale] - A scale whose range should be used
 *   to bound the items. Items exceeding the bounds of the scale range
 *   will be treated as overlapping. If null or undefined, no bounds check
 *   will be applied.
 * @param {object} [params.boundOrient] - The orientation of the scale
 *   (top, bottom, left, or right) used to bound items. This parameter is
 *   ignored if boundScale is null or undefined.
 * @param {object} [params.boundTolerance] - The tolerance in pixels for
 *   bound inclusion testing (default 1). This specifies by how many pixels
 *   an item's bounds may exceed the scale range bounds and not be culled.
 * @constructor
 */ function Overlap(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const methods = {
    parity: (items)=>items.filter((item, i)=>i % 2 ? item.opacity = 0 : 1),
    greedy: (items, sep)=>{
        let a;
        return items.filter((b, i)=>!i || !intersect(a.bounds, b.bounds, sep) ? (a = b, 1) : b.opacity = 0);
    }
};
// compute bounding box intersection
// including padding pixels of separation
const intersect = (a, b, sep)=>sep > Math.max(b.x1 - a.x2, a.x1 - b.x2, b.y1 - a.y2, a.y1 - b.y2);
const hasOverlap = (items, pad)=>{
    for(var i = 1, n = items.length, a = items[0].bounds, b; i < n; a = b, ++i){
        if (intersect(a, b = items[i].bounds, pad)) return true;
    }
};
const hasBounds = (item)=>{
    const b = item.bounds;
    return b.width() > 1 && b.height() > 1;
};
const boundTest = (scale, orient, tolerance)=>{
    var range = scale.range(), b = new (0, _vegaScenegraph.Bounds)();
    if (orient === Top || orient === Bottom) b.set(range[0], -Infinity, range[1], Infinity);
    else b.set(-Infinity, range[0], Infinity, range[1]);
    b.expand(tolerance || 1);
    return (item)=>b.encloses(item.bounds);
};
// reset all items to be fully opaque
const reset = (source)=>{
    source.forEach((item)=>item.opacity = 1);
    return source;
};
// add all tuples to mod, fork pulse if parameters were modified
// fork prevents cross-stream tuple pollution (e.g., pulse from scale)
const reflow = (pulse, _)=>pulse.reflow(_.modified()).modifies('opacity');
(0, _vegaUtil.inherits)(Overlap, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const reduce = methods[_.method] || methods.parity, sep = _.separation || 0;
        let source = pulse.materialize(pulse.SOURCE).source, items, test;
        if (!source || !source.length) return;
        if (!_.method) {
            // early exit if method is falsy
            if (_.modified('method')) {
                reset(source);
                pulse = reflow(pulse, _);
            }
            return pulse;
        }
        // skip labels with no content
        source = source.filter(hasBounds);
        // early exit, nothing to do
        if (!source.length) return;
        if (_.sort) source = source.slice().sort(_.sort);
        items = reset(source);
        pulse = reflow(pulse, _);
        if (items.length >= 3 && hasOverlap(items, sep)) {
            do items = reduce(items, sep);
            while (items.length >= 3 && hasOverlap(items, sep));
            if (items.length < 3 && !(0, _vegaUtil.peek)(source).opacity) {
                if (items.length > 1) (0, _vegaUtil.peek)(items).opacity = 0;
                (0, _vegaUtil.peek)(source).opacity = 1;
            }
        }
        if (_.boundScale && _.boundTolerance >= 0) {
            test = boundTest(_.boundScale, _.boundOrient, +_.boundTolerance);
            source.forEach((item)=>{
                if (!test(item)) item.opacity = 0;
            });
        }
        // re-calculate mark bounds
        const bounds = items[0].mark.bounds.clear();
        source.forEach((item)=>{
            if (item.opacity) bounds.union(item.bounds);
        });
        return pulse;
    }
});
/**
 * Queue modified scenegraph items for rendering.
 * @constructor
 */ function Render(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Render, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const view = pulse.dataflow;
        pulse.visit(pulse.ALL, (item)=>view.dirty(item));
        // set z-index dirty flag as needed
        if (pulse.fields && pulse.fields['zindex']) {
            const item = pulse.source && pulse.source[0];
            if (item) item.mark.zdirty = true;
        }
    }
});
const tempBounds = new (0, _vegaScenegraph.Bounds)();
function set(item, property, value) {
    return item[property] === value ? 0 : (item[property] = value, 1);
}
function isYAxis(mark) {
    var orient = mark.items[0].orient;
    return orient === Left || orient === Right;
}
function axisIndices(datum) {
    let index = +datum.grid;
    return [
        datum.ticks ? index++ : -1,
        // ticks index
        datum.labels ? index++ : -1,
        // labels index
        index + +datum.domain // title index
    ];
}
function axisLayout(view, axis, width, height) {
    var item = axis.items[0], datum = item.datum, delta = item.translate != null ? item.translate : 0.5, orient = item.orient, indices = axisIndices(datum), range = item.range, offset = item.offset, position = item.position, minExtent = item.minExtent, maxExtent = item.maxExtent, title = datum.title && item.items[indices[2]].items[0], titlePadding = item.titlePadding, bounds = item.bounds, dl = title && (0, _vegaScenegraph.multiLineOffset)(title), x = 0, y = 0, i, s;
    tempBounds.clear().union(bounds);
    bounds.clear();
    if ((i = indices[0]) > -1) bounds.union(item.items[i].bounds);
    if ((i = indices[1]) > -1) bounds.union(item.items[i].bounds);
    // position axis group and title
    switch(orient){
        case Top:
            x = position || 0;
            y = -offset;
            s = Math.max(minExtent, Math.min(maxExtent, -bounds.y1));
            bounds.add(0, -s).add(range, 0);
            if (title) axisTitleLayout(view, title, s, titlePadding, dl, 0, -1, bounds);
            break;
        case Left:
            x = -offset;
            y = position || 0;
            s = Math.max(minExtent, Math.min(maxExtent, -bounds.x1));
            bounds.add(-s, 0).add(0, range);
            if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, -1, bounds);
            break;
        case Right:
            x = width + offset;
            y = position || 0;
            s = Math.max(minExtent, Math.min(maxExtent, bounds.x2));
            bounds.add(0, 0).add(s, range);
            if (title) axisTitleLayout(view, title, s, titlePadding, dl, 1, 1, bounds);
            break;
        case Bottom:
            x = position || 0;
            y = height + offset;
            s = Math.max(minExtent, Math.min(maxExtent, bounds.y2));
            bounds.add(0, 0).add(range, s);
            if (title) axisTitleLayout(view, title, s, titlePadding, 0, 0, 1, bounds);
            break;
        default:
            x = item.x;
            y = item.y;
    }
    // update bounds
    (0, _vegaScenegraph.boundStroke)(bounds.translate(x, y), item);
    if (set(item, 'x', x + delta) | set(item, 'y', y + delta)) {
        item.bounds = tempBounds;
        view.dirty(item);
        item.bounds = bounds;
        view.dirty(item);
    }
    return item.mark.bounds.clear().union(bounds);
}
function axisTitleLayout(view, title, offset, pad, dl, isYAxis, sign, bounds) {
    const b = title.bounds;
    if (title.auto) {
        const v = sign * (offset + dl + pad);
        let dx = 0, dy = 0;
        view.dirty(title);
        isYAxis ? dx = (title.x || 0) - (title.x = v) : dy = (title.y || 0) - (title.y = v);
        title.mark.bounds.clear().union(b.translate(-dx, -dy));
        view.dirty(title);
    }
    bounds.union(b);
}
// aggregation functions for grid margin determination
const min = (a, b)=>Math.floor(Math.min(a, b));
const max = (a, b)=>Math.ceil(Math.max(a, b));
function gridLayoutGroups(group) {
    var groups = group.items, n = groups.length, i = 0, mark, items;
    const views = {
        marks: [],
        rowheaders: [],
        rowfooters: [],
        colheaders: [],
        colfooters: [],
        rowtitle: null,
        coltitle: null
    };
    // layout axes, gather legends, collect bounds
    for(; i < n; ++i){
        mark = groups[i];
        items = mark.items;
        if (mark.marktype === Group) switch(mark.role){
            case AxisRole:
            case LegendRole:
            case TitleRole:
                break;
            case RowHeader:
                views.rowheaders.push(...items);
                break;
            case RowFooter:
                views.rowfooters.push(...items);
                break;
            case ColHeader:
                views.colheaders.push(...items);
                break;
            case ColFooter:
                views.colfooters.push(...items);
                break;
            case RowTitle:
                views.rowtitle = items[0];
                break;
            case ColTitle:
                views.coltitle = items[0];
                break;
            default:
                views.marks.push(...items);
        }
    }
    return views;
}
function bboxFlush(item) {
    return new (0, _vegaScenegraph.Bounds)().set(0, 0, item.width || 0, item.height || 0);
}
function bboxFull(item) {
    const b = item.bounds.clone();
    return b.empty() ? b.set(0, 0, 0, 0) : b.translate(-(item.x || 0), -(item.y || 0));
}
function get(opt, key, d) {
    const v = (0, _vegaUtil.isObject)(opt) ? opt[key] : opt;
    return v != null ? v : d !== undefined ? d : 0;
}
function offsetValue(v) {
    return v < 0 ? Math.ceil(-v) : 0;
}
function gridLayout(view, groups, opt) {
    var dirty = !opt.nodirty, bbox = opt.bounds === Flush ? bboxFlush : bboxFull, bounds = tempBounds.set(0, 0, 0, 0), alignCol = get(opt.align, Column), alignRow = get(opt.align, Row), padCol = get(opt.padding, Column), padRow = get(opt.padding, Row), ncols = opt.columns || groups.length, nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols), n = groups.length, xOffset = Array(n), xExtent = Array(ncols), xMax = 0, yOffset = Array(n), yExtent = Array(nrows), yMax = 0, dx = Array(n), dy = Array(n), boxes = Array(n), m, i, c, r, b, g, px, py, x, y, offset;
    for(i = 0; i < ncols; ++i)xExtent[i] = 0;
    for(i = 0; i < nrows; ++i)yExtent[i] = 0;
    // determine offsets for each group
    for(i = 0; i < n; ++i){
        g = groups[i];
        b = boxes[i] = bbox(g);
        g.x = g.x || 0;
        dx[i] = 0;
        g.y = g.y || 0;
        dy[i] = 0;
        c = i % ncols;
        r = ~~(i / ncols);
        xMax = Math.max(xMax, px = Math.ceil(b.x2));
        yMax = Math.max(yMax, py = Math.ceil(b.y2));
        xExtent[c] = Math.max(xExtent[c], px);
        yExtent[r] = Math.max(yExtent[r], py);
        xOffset[i] = padCol + offsetValue(b.x1);
        yOffset[i] = padRow + offsetValue(b.y1);
        if (dirty) view.dirty(groups[i]);
    }
    // set initial alignment offsets
    for(i = 0; i < n; ++i){
        if (i % ncols === 0) xOffset[i] = 0;
        if (i < ncols) yOffset[i] = 0;
    }
    // enforce column alignment constraints
    if (alignCol === Each) for(c = 1; c < ncols; ++c){
        for(offset = 0, i = c; i < n; i += ncols)if (offset < xOffset[i]) offset = xOffset[i];
        for(i = c; i < n; i += ncols)xOffset[i] = offset + xExtent[c - 1];
    }
    else if (alignCol === All) {
        for(offset = 0, i = 0; i < n; ++i)if (i % ncols && offset < xOffset[i]) offset = xOffset[i];
        for(i = 0; i < n; ++i)if (i % ncols) xOffset[i] = offset + xMax;
    } else {
        for(alignCol = false, c = 1; c < ncols; ++c)for(i = c; i < n; i += ncols)xOffset[i] += xExtent[c - 1];
    }
    // enforce row alignment constraints
    if (alignRow === Each) for(r = 1; r < nrows; ++r){
        for(offset = 0, i = r * ncols, m = i + ncols; i < m; ++i)if (offset < yOffset[i]) offset = yOffset[i];
        for(i = r * ncols; i < m; ++i)yOffset[i] = offset + yExtent[r - 1];
    }
    else if (alignRow === All) {
        for(offset = 0, i = ncols; i < n; ++i)if (offset < yOffset[i]) offset = yOffset[i];
        for(i = ncols; i < n; ++i)yOffset[i] = offset + yMax;
    } else {
        for(alignRow = false, r = 1; r < nrows; ++r)for(i = r * ncols, m = i + ncols; i < m; ++i)yOffset[i] += yExtent[r - 1];
    }
    // perform horizontal grid layout
    for(x = 0, i = 0; i < n; ++i){
        x = xOffset[i] + (i % ncols ? x : 0);
        dx[i] += x - groups[i].x;
    }
    // perform vertical grid layout
    for(c = 0; c < ncols; ++c)for(y = 0, i = c; i < n; i += ncols){
        y += yOffset[i];
        dy[i] += y - groups[i].y;
    }
    // perform horizontal centering
    if (alignCol && get(opt.center, Column) && nrows > 1) for(i = 0; i < n; ++i){
        b = alignCol === All ? xMax : xExtent[i % ncols];
        x = b - boxes[i].x2 - groups[i].x - dx[i];
        if (x > 0) dx[i] += x / 2;
    }
    // perform vertical centering
    if (alignRow && get(opt.center, Row) && ncols !== 1) for(i = 0; i < n; ++i){
        b = alignRow === All ? yMax : yExtent[~~(i / ncols)];
        y = b - boxes[i].y2 - groups[i].y - dy[i];
        if (y > 0) dy[i] += y / 2;
    }
    // position grid relative to anchor
    for(i = 0; i < n; ++i)bounds.union(boxes[i].translate(dx[i], dy[i]));
    x = get(opt.anchor, X);
    y = get(opt.anchor, Y);
    switch(get(opt.anchor, Column)){
        case End:
            x -= bounds.width();
            break;
        case Middle:
            x -= bounds.width() / 2;
    }
    switch(get(opt.anchor, Row)){
        case End:
            y -= bounds.height();
            break;
        case Middle:
            y -= bounds.height() / 2;
    }
    x = Math.round(x);
    y = Math.round(y);
    // update mark positions, bounds, dirty
    bounds.clear();
    for(i = 0; i < n; ++i)groups[i].mark.bounds.clear();
    for(i = 0; i < n; ++i){
        g = groups[i];
        g.x += dx[i] += x;
        g.y += dy[i] += y;
        bounds.union(g.mark.bounds.union(g.bounds.translate(dx[i], dy[i])));
        if (dirty) view.dirty(g);
    }
    return bounds;
}
function trellisLayout(view, group, opt) {
    var views = gridLayoutGroups(group), groups = views.marks, bbox = opt.bounds === Flush ? boundFlush : boundFull, off = opt.offset, ncols = opt.columns || groups.length, nrows = ncols <= 0 ? 1 : Math.ceil(groups.length / ncols), cells = nrows * ncols, x, y, x2, y2, anchor, band, offset;
    // -- initial grid layout
    const bounds = gridLayout(view, groups, opt);
    if (bounds.empty()) bounds.set(0, 0, 0, 0); // empty grid
    // -- layout grid headers and footers --
    // perform row header layout
    if (views.rowheaders) {
        band = get(opt.headerBand, Row, null);
        x = layoutHeaders(view, views.rowheaders, groups, ncols, nrows, -get(off, 'rowHeader'), min, 0, bbox, 'x1', 0, ncols, 1, band);
    }
    // perform column header layout
    if (views.colheaders) {
        band = get(opt.headerBand, Column, null);
        y = layoutHeaders(view, views.colheaders, groups, ncols, ncols, -get(off, 'columnHeader'), min, 1, bbox, 'y1', 0, 1, ncols, band);
    }
    // perform row footer layout
    if (views.rowfooters) {
        band = get(opt.footerBand, Row, null);
        x2 = layoutHeaders(view, views.rowfooters, groups, ncols, nrows, get(off, 'rowFooter'), max, 0, bbox, 'x2', ncols - 1, ncols, 1, band);
    }
    // perform column footer layout
    if (views.colfooters) {
        band = get(opt.footerBand, Column, null);
        y2 = layoutHeaders(view, views.colfooters, groups, ncols, ncols, get(off, 'columnFooter'), max, 1, bbox, 'y2', cells - ncols, 1, ncols, band);
    }
    // perform row title layout
    if (views.rowtitle) {
        anchor = get(opt.titleAnchor, Row);
        offset = get(off, 'rowTitle');
        offset = anchor === End ? x2 + offset : x - offset;
        band = get(opt.titleBand, Row, 0.5);
        layoutTitle(view, views.rowtitle, offset, 0, bounds, band);
    }
    // perform column title layout
    if (views.coltitle) {
        anchor = get(opt.titleAnchor, Column);
        offset = get(off, 'columnTitle');
        offset = anchor === End ? y2 + offset : y - offset;
        band = get(opt.titleBand, Column, 0.5);
        layoutTitle(view, views.coltitle, offset, 1, bounds, band);
    }
}
function boundFlush(item, field) {
    return field === 'x1' ? item.x || 0 : field === 'y1' ? item.y || 0 : field === 'x2' ? (item.x || 0) + (item.width || 0) : field === 'y2' ? (item.y || 0) + (item.height || 0) : undefined;
}
function boundFull(item, field) {
    return item.bounds[field];
}
function layoutHeaders(view, headers, groups, ncols, limit, offset, agg, isX, bound, bf, start, stride, back, band) {
    var n = groups.length, init = 0, edge = 0, i, j, k, m, b, h, g, x, y;
    // if no groups, early exit and return 0
    if (!n) return init;
    // compute margin
    for(i = start; i < n; i += stride)if (groups[i]) init = agg(init, bound(groups[i], bf));
    // if no headers, return margin calculation
    if (!headers.length) return init;
    // check if number of headers exceeds number of rows or columns
    if (headers.length > limit) {
        view.warn('Grid headers exceed limit: ' + limit);
        headers = headers.slice(0, limit);
    }
    // apply offset
    init += offset;
    // clear mark bounds for all headers
    for(j = 0, m = headers.length; j < m; ++j){
        view.dirty(headers[j]);
        headers[j].mark.bounds.clear();
    }
    // layout each header
    for(i = start, j = 0, m = headers.length; j < m; ++j, i += stride){
        h = headers[j];
        b = h.mark.bounds;
        // search for nearest group to align to
        // necessary if table has empty cells
        for(k = i; k >= 0 && (g = groups[k]) == null; k -= back);
        // assign coordinates and update bounds
        if (isX) {
            x = band == null ? g.x : Math.round(g.bounds.x1 + band * g.bounds.width());
            y = init;
        } else {
            x = init;
            y = band == null ? g.y : Math.round(g.bounds.y1 + band * g.bounds.height());
        }
        b.union(h.bounds.translate(x - (h.x || 0), y - (h.y || 0)));
        h.x = x;
        h.y = y;
        view.dirty(h);
        // update current edge of layout bounds
        edge = agg(edge, b[bf]);
    }
    return edge;
}
function layoutTitle(view, g, offset, isX, bounds, band) {
    if (!g) return;
    view.dirty(g);
    // compute title coordinates
    var x = offset, y = offset;
    isX ? x = Math.round(bounds.x1 + band * bounds.width()) : y = Math.round(bounds.y1 + band * bounds.height());
    // assign coordinates and update bounds
    g.bounds.translate(x - (g.x || 0), y - (g.y || 0));
    g.mark.bounds.clear().union(g.bounds);
    g.x = x;
    g.y = y;
    // queue title for redraw
    view.dirty(g);
}
// utility for looking up legend layout configuration
function lookup(config, orient) {
    const opt = config[orient] || {};
    return (key, d)=>opt[key] != null ? opt[key] : config[key] != null ? config[key] : d;
}
// if legends specify offset directly, use the maximum specified value
function offsets(legends, value) {
    let max = -Infinity;
    legends.forEach((item)=>{
        if (item.offset != null) max = Math.max(max, item.offset);
    });
    return max > -Infinity ? max : value;
}
function legendParams(g, orient, config, xb, yb, w, h) {
    const _ = lookup(config, orient), offset = offsets(g, _('offset', 0)), anchor = _('anchor', Start), mult = anchor === End ? 1 : anchor === Middle ? 0.5 : 0;
    const p = {
        align: Each,
        bounds: _('bounds', Flush),
        columns: _('direction') === 'vertical' ? 1 : g.length,
        padding: _('margin', 8),
        center: _('center'),
        nodirty: true
    };
    switch(orient){
        case Left:
            p.anchor = {
                x: Math.floor(xb.x1) - offset,
                column: End,
                y: mult * (h || xb.height() + 2 * xb.y1),
                row: anchor
            };
            break;
        case Right:
            p.anchor = {
                x: Math.ceil(xb.x2) + offset,
                y: mult * (h || xb.height() + 2 * xb.y1),
                row: anchor
            };
            break;
        case Top:
            p.anchor = {
                y: Math.floor(yb.y1) - offset,
                row: End,
                x: mult * (w || yb.width() + 2 * yb.x1),
                column: anchor
            };
            break;
        case Bottom:
            p.anchor = {
                y: Math.ceil(yb.y2) + offset,
                x: mult * (w || yb.width() + 2 * yb.x1),
                column: anchor
            };
            break;
        case TopLeft:
            p.anchor = {
                x: offset,
                y: offset
            };
            break;
        case TopRight:
            p.anchor = {
                x: w - offset,
                y: offset,
                column: End
            };
            break;
        case BottomLeft:
            p.anchor = {
                x: offset,
                y: h - offset,
                row: End
            };
            break;
        case BottomRight:
            p.anchor = {
                x: w - offset,
                y: h - offset,
                column: End,
                row: End
            };
            break;
    }
    return p;
}
function legendLayout(view, legend) {
    var item = legend.items[0], datum = item.datum, orient = item.orient, bounds = item.bounds, x = item.x, y = item.y, w, h;
    // cache current bounds for later comparison
    item._bounds ? item._bounds.clear().union(bounds) : item._bounds = bounds.clone();
    bounds.clear();
    // adjust legend to accommodate padding and title
    legendGroupLayout(view, item, item.items[0].items[0]);
    // aggregate bounds to determine size, and include origin
    bounds = legendBounds(item, bounds);
    w = 2 * item.padding;
    h = 2 * item.padding;
    if (!bounds.empty()) {
        w = Math.ceil(bounds.width() + w);
        h = Math.ceil(bounds.height() + h);
    }
    if (datum.type === Symbols) legendEntryLayout(item.items[0].items[0].items[0].items);
    if (orient !== None) {
        item.x = x = 0;
        item.y = y = 0;
    }
    item.width = w;
    item.height = h;
    (0, _vegaScenegraph.boundStroke)(bounds.set(x, y, x + w, y + h), item);
    item.mark.bounds.clear().union(bounds);
    return item;
}
function legendBounds(item, b) {
    // aggregate item bounds
    item.items.forEach((_)=>b.union(_.bounds));
    // anchor to legend origin
    b.x1 = item.padding;
    b.y1 = item.padding;
    return b;
}
function legendGroupLayout(view, item, entry) {
    var pad = item.padding, ex = pad - entry.x, ey = pad - entry.y;
    if (!item.datum.title) {
        if (ex || ey) translate(view, entry, ex, ey);
    } else {
        var title = item.items[1].items[0], anchor = title.anchor, tpad = item.titlePadding || 0, tx = pad - title.x, ty = pad - title.y;
        switch(title.orient){
            case Left:
                ex += Math.ceil(title.bounds.width()) + tpad;
                break;
            case Right:
            case Bottom:
                break;
            default:
                ey += title.bounds.height() + tpad;
        }
        if (ex || ey) translate(view, entry, ex, ey);
        switch(title.orient){
            case Left:
                ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
                break;
            case Right:
                tx += legendTitleOffset(item, entry, title, End, 0, 0) + tpad;
                ty += legendTitleOffset(item, entry, title, anchor, 1, 1);
                break;
            case Bottom:
                tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
                ty += legendTitleOffset(item, entry, title, End, -1, 0, 1) + tpad;
                break;
            default:
                tx += legendTitleOffset(item, entry, title, anchor, 0, 0);
        }
        if (tx || ty) translate(view, title, tx, ty);
        // translate legend if title pushes into negative coordinates
        if ((tx = Math.round(title.bounds.x1 - pad)) < 0) {
            translate(view, entry, -tx, 0);
            translate(view, title, -tx, 0);
        }
    }
}
function legendTitleOffset(item, entry, title, anchor, y, lr, noBar) {
    const grad = item.datum.type !== 'symbol', vgrad = title.datum.vgrad, e = grad && (lr || !vgrad) && !noBar ? entry.items[0] : entry, s = e.bounds[y ? 'y2' : 'x2'] - item.padding, u = vgrad && lr ? s : 0, v = vgrad && lr ? 0 : s, o = y <= 0 ? 0 : (0, _vegaScenegraph.multiLineOffset)(title);
    return Math.round(anchor === Start ? u : anchor === End ? v - o : 0.5 * (s - o));
}
function translate(view, item, dx, dy) {
    item.x += dx;
    item.y += dy;
    item.bounds.translate(dx, dy);
    item.mark.bounds.translate(dx, dy);
    view.dirty(item);
}
function legendEntryLayout(entries) {
    // get max widths for each column
    const widths = entries.reduce((w, g)=>{
        w[g.column] = Math.max(g.bounds.x2 - g.x, w[g.column] || 0);
        return w;
    }, {});
    // set dimensions of legend entry groups
    entries.forEach((g)=>{
        g.width = widths[g.column];
        g.height = g.bounds.y2 - g.y;
    });
}
function titleLayout(view, mark, width, height, viewBounds) {
    var group = mark.items[0], frame = group.frame, orient = group.orient, anchor = group.anchor, offset = group.offset, padding = group.padding, title = group.items[0].items[0], subtitle = group.items[1] && group.items[1].items[0], end = orient === Left || orient === Right ? height : width, start = 0, x = 0, y = 0, sx = 0, sy = 0, pos;
    if (frame !== Group) orient === Left ? (start = viewBounds.y2, end = viewBounds.y1) : orient === Right ? (start = viewBounds.y1, end = viewBounds.y2) : (start = viewBounds.x1, end = viewBounds.x2);
    else if (orient === Left) start = height, end = 0;
    pos = anchor === Start ? start : anchor === End ? end : (start + end) / 2;
    if (subtitle && subtitle.text) {
        // position subtitle
        switch(orient){
            case Top:
            case Bottom:
                sy = title.bounds.height() + padding;
                break;
            case Left:
                sx = title.bounds.width() + padding;
                break;
            case Right:
                sx = -title.bounds.width() - padding;
                break;
        }
        tempBounds.clear().union(subtitle.bounds);
        tempBounds.translate(sx - (subtitle.x || 0), sy - (subtitle.y || 0));
        if (set(subtitle, 'x', sx) | set(subtitle, 'y', sy)) {
            view.dirty(subtitle);
            subtitle.bounds.clear().union(tempBounds);
            subtitle.mark.bounds.clear().union(tempBounds);
            view.dirty(subtitle);
        }
        tempBounds.clear().union(subtitle.bounds);
    } else tempBounds.clear();
    tempBounds.union(title.bounds);
    // position title group
    switch(orient){
        case Top:
            x = pos;
            y = viewBounds.y1 - tempBounds.height() - offset;
            break;
        case Left:
            x = viewBounds.x1 - tempBounds.width() - offset;
            y = pos;
            break;
        case Right:
            x = viewBounds.x2 + tempBounds.width() + offset;
            y = pos;
            break;
        case Bottom:
            x = pos;
            y = viewBounds.y2 + offset;
            break;
        default:
            x = group.x;
            y = group.y;
    }
    if (set(group, 'x', x) | set(group, 'y', y)) {
        tempBounds.translate(x, y);
        view.dirty(group);
        group.bounds.clear().union(tempBounds);
        mark.bounds.clear().union(tempBounds);
        view.dirty(group);
    }
    return group.bounds;
}
/**
 * Layout view elements such as axes and legends.
 * Also performs size adjustments.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.mark - Scenegraph mark of groups to layout.
 */ function ViewLayout(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(ViewLayout, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const view = pulse.dataflow;
        _.mark.items.forEach((group)=>{
            if (_.layout) trellisLayout(view, group, _.layout);
            layoutGroup(view, group, _);
        });
        return shouldReflow(_.mark.group) ? pulse.reflow() : pulse;
    }
});
function shouldReflow(group) {
    // We typically should reflow if layout is invoked (#2568), as child items
    // may have resized and reflow ensures group bounds are re-calculated.
    // However, legend entries have a special exception to avoid instability.
    // For example, if a selected legend symbol gains a stroke on hover,
    // we don't want to re-position subsequent elements in the legend.
    return group && group.mark.role !== 'legend-entry';
}
function layoutGroup(view, group, _) {
    var items = group.items, width = Math.max(0, group.width || 0), height = Math.max(0, group.height || 0), viewBounds = new (0, _vegaScenegraph.Bounds)().set(0, 0, width, height), xBounds = viewBounds.clone(), yBounds = viewBounds.clone(), legends = [], title, mark, orient, b, i, n;
    // layout axes, gather legends, collect bounds
    for(i = 0, n = items.length; i < n; ++i){
        mark = items[i];
        switch(mark.role){
            case AxisRole:
                b = isYAxis(mark) ? xBounds : yBounds;
                b.union(axisLayout(view, mark, width, height));
                break;
            case TitleRole:
                title = mark;
                break;
            case LegendRole:
                legends.push(legendLayout(view, mark));
                break;
            case FrameRole:
            case ScopeRole:
            case RowHeader:
            case RowFooter:
            case RowTitle:
            case ColHeader:
            case ColFooter:
            case ColTitle:
                xBounds.union(mark.bounds);
                yBounds.union(mark.bounds);
                break;
            default:
                viewBounds.union(mark.bounds);
        }
    }
    // layout legends, adjust viewBounds
    if (legends.length) {
        // group legends by orient
        const l = {};
        legends.forEach((item)=>{
            orient = item.orient || Right;
            if (orient !== None) (l[orient] || (l[orient] = [])).push(item);
        });
        // perform grid layout for each orient group
        for(const orient in l){
            const g = l[orient];
            gridLayout(view, g, legendParams(g, orient, _.legends, xBounds, yBounds, width, height));
        }
        // update view bounds
        legends.forEach((item)=>{
            const b = item.bounds;
            if (!b.equals(item._bounds)) {
                item.bounds = item._bounds;
                view.dirty(item); // dirty previous location
                item.bounds = b;
                view.dirty(item);
            }
            if (_.autosize && (_.autosize.type === Fit || _.autosize.type === FitX || _.autosize.type === FitY)) // For autosize fit, incorporate the orthogonal dimension only.
            // Legends that overrun the chart area will then be clipped;
            // otherwise the chart area gets reduced to nothing!
            switch(item.orient){
                case Left:
                case Right:
                    viewBounds.add(b.x1, 0).add(b.x2, 0);
                    break;
                case Top:
                case Bottom:
                    viewBounds.add(0, b.y1).add(0, b.y2);
            }
            else viewBounds.union(b);
        });
    }
    // combine bounding boxes
    viewBounds.union(xBounds).union(yBounds);
    // layout title, adjust bounds
    if (title) viewBounds.union(titleLayout(view, title, width, height, viewBounds));
    // override aggregated view bounds if content is clipped
    if (group.clip) viewBounds.set(0, 0, group.width || 0, group.height || 0);
    // perform size adjustment
    viewSizeLayout(view, group, viewBounds, _);
}
function viewSizeLayout(view, group, viewBounds, _) {
    const auto = _.autosize || {}, type = auto.type;
    if (view._autosize < 1 || !type) return;
    let viewWidth = view._width, viewHeight = view._height, width = Math.max(0, group.width || 0), left = Math.max(0, Math.ceil(-viewBounds.x1)), height = Math.max(0, group.height || 0), top = Math.max(0, Math.ceil(-viewBounds.y1));
    const right = Math.max(0, Math.ceil(viewBounds.x2 - width)), bottom = Math.max(0, Math.ceil(viewBounds.y2 - height));
    if (auto.contains === Padding) {
        const padding = view.padding();
        viewWidth -= padding.left + padding.right;
        viewHeight -= padding.top + padding.bottom;
    }
    if (type === None) {
        left = 0;
        top = 0;
        width = viewWidth;
        height = viewHeight;
    } else if (type === Fit) {
        width = Math.max(0, viewWidth - left - right);
        height = Math.max(0, viewHeight - top - bottom);
    } else if (type === FitX) {
        width = Math.max(0, viewWidth - left - right);
        viewHeight = height + top + bottom;
    } else if (type === FitY) {
        viewWidth = width + left + right;
        height = Math.max(0, viewHeight - top - bottom);
    } else if (type === Pad) {
        viewWidth = width + left + right;
        viewHeight = height + top + bottom;
    }
    view._resizeView(viewWidth, viewHeight, width, height, [
        left,
        top
    ], auto.resize);
}

},{"vega-dataflow":"eoU45","vega-scenegraph":"fdlnS","vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fdlnS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", ()=>(0, _d3Path.path));
parcelHelpers.export(exports, "Bounds", ()=>Bounds);
parcelHelpers.export(exports, "CanvasHandler", ()=>CanvasHandler);
parcelHelpers.export(exports, "CanvasRenderer", ()=>CanvasRenderer);
parcelHelpers.export(exports, "Gradient", ()=>Gradient);
parcelHelpers.export(exports, "GroupItem", ()=>GroupItem);
parcelHelpers.export(exports, "Handler", ()=>Handler);
parcelHelpers.export(exports, "HybridHandler", ()=>HybridHandler);
parcelHelpers.export(exports, "HybridRenderer", ()=>HybridRenderer);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "Marks", ()=>Marks);
parcelHelpers.export(exports, "RenderType", ()=>RenderType);
parcelHelpers.export(exports, "Renderer", ()=>Renderer);
parcelHelpers.export(exports, "ResourceLoader", ()=>ResourceLoader);
parcelHelpers.export(exports, "SVGHandler", ()=>SVGHandler);
parcelHelpers.export(exports, "SVGRenderer", ()=>SVGRenderer);
parcelHelpers.export(exports, "SVGStringRenderer", ()=>SVGStringRenderer);
parcelHelpers.export(exports, "Scenegraph", ()=>Scenegraph);
parcelHelpers.export(exports, "boundClip", ()=>boundClip);
parcelHelpers.export(exports, "boundContext", ()=>boundContext);
parcelHelpers.export(exports, "boundItem", ()=>boundItem);
parcelHelpers.export(exports, "boundMark", ()=>boundMark);
parcelHelpers.export(exports, "boundStroke", ()=>boundStroke);
parcelHelpers.export(exports, "domChild", ()=>domChild);
parcelHelpers.export(exports, "domClear", ()=>domClear);
parcelHelpers.export(exports, "domCreate", ()=>domCreate);
parcelHelpers.export(exports, "domFind", ()=>domFind);
parcelHelpers.export(exports, "font", ()=>font);
parcelHelpers.export(exports, "fontFamily", ()=>fontFamily);
parcelHelpers.export(exports, "fontSize", ()=>fontSize);
parcelHelpers.export(exports, "intersect", ()=>intersect);
parcelHelpers.export(exports, "intersectBoxLine", ()=>intersectBoxLine);
parcelHelpers.export(exports, "intersectPath", ()=>intersectPath);
parcelHelpers.export(exports, "intersectPoint", ()=>intersectPoint);
parcelHelpers.export(exports, "intersectRule", ()=>intersectRule);
parcelHelpers.export(exports, "lineHeight", ()=>lineHeight);
parcelHelpers.export(exports, "markup", ()=>markup);
parcelHelpers.export(exports, "multiLineOffset", ()=>multiLineOffset);
parcelHelpers.export(exports, "pathCurves", ()=>curves);
parcelHelpers.export(exports, "pathEqual", ()=>pathEqual);
parcelHelpers.export(exports, "pathParse", ()=>parse);
parcelHelpers.export(exports, "pathRectangle", ()=>vg_rect);
parcelHelpers.export(exports, "pathRender", ()=>pathRender);
parcelHelpers.export(exports, "pathSymbols", ()=>symbols);
parcelHelpers.export(exports, "pathTrail", ()=>vg_trail);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "renderModule", ()=>renderModule);
parcelHelpers.export(exports, "resetSVGDefIds", ()=>resetSVGDefIds);
parcelHelpers.export(exports, "sceneEqual", ()=>sceneEqual);
parcelHelpers.export(exports, "sceneFromJSON", ()=>sceneFromJSON);
parcelHelpers.export(exports, "scenePickVisit", ()=>pickVisit);
parcelHelpers.export(exports, "sceneToJSON", ()=>sceneToJSON);
parcelHelpers.export(exports, "sceneVisit", ()=>visit);
parcelHelpers.export(exports, "sceneZOrder", ()=>zorder);
parcelHelpers.export(exports, "serializeXML", ()=>serializeXML);
parcelHelpers.export(exports, "setHybridRendererOptions", ()=>setHybridRendererOptions);
parcelHelpers.export(exports, "textMetrics", ()=>textMetrics);
var _vegaUtil = require("vega-util");
var _d3Shape = require("d3-shape");
var _d3Path = require("d3-path");
var _vegaCanvas = require("vega-canvas");
var _vegaLoader = require("vega-loader");
var _vegaScale = require("vega-scale");
let gradient_id = 0;
function resetSVGGradientId() {
    gradient_id = 0;
}
const patternPrefix = 'p_';
function isGradient(value) {
    return value && value.gradient;
}
function gradientRef(g, defs, base) {
    const type = g.gradient;
    let id = g.id, prefix = type === 'radial' ? patternPrefix : '';
    // check id, assign default values as needed
    if (!id) {
        id = g.id = 'gradient_' + gradient_id++;
        if (type === 'radial') {
            g.x1 = get(g.x1, 0.5);
            g.y1 = get(g.y1, 0.5);
            g.r1 = get(g.r1, 0);
            g.x2 = get(g.x2, 0.5);
            g.y2 = get(g.y2, 0.5);
            g.r2 = get(g.r2, 0.5);
            prefix = patternPrefix;
        } else {
            g.x1 = get(g.x1, 0);
            g.y1 = get(g.y1, 0);
            g.x2 = get(g.x2, 1);
            g.y2 = get(g.y2, 0);
        }
    }
    // register definition
    defs[id] = g;
    // return url reference
    return 'url(' + (base || '') + '#' + prefix + id + ')';
}
function get(val, def) {
    return val != null ? val : def;
}
function Gradient(p0, p1) {
    var stops = [], gradient;
    return gradient = {
        gradient: 'linear',
        x1: p0 ? p0[0] : 0,
        y1: p0 ? p0[1] : 0,
        x2: p1 ? p1[0] : 1,
        y2: p1 ? p1[1] : 0,
        stops: stops,
        stop: function(offset, color) {
            stops.push({
                offset: offset,
                color: color
            });
            return gradient;
        }
    };
}
const lookup = {
    'basis': {
        curve: (0, _d3Shape.curveBasis)
    },
    'basis-closed': {
        curve: (0, _d3Shape.curveBasisClosed)
    },
    'basis-open': {
        curve: (0, _d3Shape.curveBasisOpen)
    },
    'bundle': {
        curve: (0, _d3Shape.curveBundle),
        tension: 'beta',
        value: 0.85
    },
    'cardinal': {
        curve: (0, _d3Shape.curveCardinal),
        tension: 'tension',
        value: 0
    },
    'cardinal-open': {
        curve: (0, _d3Shape.curveCardinalOpen),
        tension: 'tension',
        value: 0
    },
    'cardinal-closed': {
        curve: (0, _d3Shape.curveCardinalClosed),
        tension: 'tension',
        value: 0
    },
    'catmull-rom': {
        curve: (0, _d3Shape.curveCatmullRom),
        tension: 'alpha',
        value: 0.5
    },
    'catmull-rom-closed': {
        curve: (0, _d3Shape.curveCatmullRomClosed),
        tension: 'alpha',
        value: 0.5
    },
    'catmull-rom-open': {
        curve: (0, _d3Shape.curveCatmullRomOpen),
        tension: 'alpha',
        value: 0.5
    },
    'linear': {
        curve: (0, _d3Shape.curveLinear)
    },
    'linear-closed': {
        curve: (0, _d3Shape.curveLinearClosed)
    },
    'monotone': {
        horizontal: (0, _d3Shape.curveMonotoneY),
        vertical: (0, _d3Shape.curveMonotoneX)
    },
    'natural': {
        curve: (0, _d3Shape.curveNatural)
    },
    'step': {
        curve: (0, _d3Shape.curveStep)
    },
    'step-after': {
        curve: (0, _d3Shape.curveStepAfter)
    },
    'step-before': {
        curve: (0, _d3Shape.curveStepBefore)
    }
};
function curves(type, orientation, tension) {
    var entry = (0, _vegaUtil.hasOwnProperty)(lookup, type) && lookup[type], curve = null;
    if (entry) {
        curve = entry.curve || entry[orientation || 'vertical'];
        if (entry.tension && tension != null) curve = curve[entry.tension](tension);
    }
    return curve;
}
const paramCounts = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    z: 0,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
};
const commandPattern = /[mlhvzcsqta]([^mlhvzcsqta]+|$)/gi;
const numberPattern = /^[+-]?(([0-9]*\.[0-9]+)|([0-9]+\.)|([0-9]+))([eE][+-]?[0-9]+)?/;
const spacePattern = /^((\s+,?\s*)|(,\s*))/;
const flagPattern = /^[01]/;
function parse(path) {
    const commands = [];
    const matches = path.match(commandPattern) || [];
    matches.forEach((str)=>{
        let cmd = str[0];
        const type = cmd.toLowerCase();
        // parse parameters
        const paramCount = paramCounts[type];
        const params = parseParams(type, paramCount, str.slice(1).trim());
        const count = params.length;
        // error checking based on parameter count
        if (count < paramCount || count && count % paramCount !== 0) throw Error('Invalid SVG path, incorrect parameter count');
        // register the command
        commands.push([
            cmd,
            ...params.slice(0, paramCount)
        ]);
        // exit now if we're done, also handles zero-param 'z'
        if (count === paramCount) return;
        // handle implicit line-to
        if (type === 'm') cmd = cmd === 'M' ? 'L' : 'l';
        // repeat command when given extended param list
        for(let i = paramCount; i < count; i += paramCount)commands.push([
            cmd,
            ...params.slice(i, i + paramCount)
        ]);
    });
    return commands;
}
function parseParams(type, paramCount, segment) {
    const params = [];
    for(let index = 0; paramCount && index < segment.length;)for(let i = 0; i < paramCount; ++i){
        const pattern = type === 'a' && (i === 3 || i === 4) ? flagPattern : numberPattern;
        const match = segment.slice(index).match(pattern);
        if (match === null) throw Error('Invalid SVG path, incorrect parameter type');
        index += match[0].length;
        params.push(+match[0]);
        const ws = segment.slice(index).match(spacePattern);
        if (ws !== null) index += ws[0].length;
    }
    return params;
}
const DegToRad = Math.PI / 180;
const Epsilon = 1e-14;
const HalfPi = Math.PI / 2;
const Tau = Math.PI * 2;
const HalfSqrt3 = Math.sqrt(3) / 2;
var segmentCache = {};
var bezierCache = {};
var join = [].join;
// Copied from Inkscape svgtopdf, thanks!
function segments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    const key = join.call(arguments);
    if (segmentCache[key]) return segmentCache[key];
    const th = rotateX * DegToRad;
    const sin_th = Math.sin(th);
    const cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    const py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    let pl = px * px / (rx * rx) + py * py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    const a00 = cos_th / rx;
    const a01 = sin_th / rx;
    const a10 = -sin_th / ry;
    const a11 = cos_th / ry;
    const x0 = a00 * ox + a01 * oy;
    const y0 = a10 * ox + a11 * oy;
    const x1 = a00 * x + a01 * y;
    const y1 = a10 * x + a11 * y;
    const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    let sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    let sfactor = Math.sqrt(sfactor_sq);
    if (sweep == large) sfactor = -sfactor;
    const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    const th0 = Math.atan2(y0 - yc, x0 - xc);
    const th1 = Math.atan2(y1 - yc, x1 - xc);
    let th_arc = th1 - th0;
    if (th_arc < 0 && sweep === 1) th_arc += Tau;
    else if (th_arc > 0 && sweep === 0) th_arc -= Tau;
    const segs = Math.ceil(Math.abs(th_arc / (HalfPi + 0.001)));
    const result = [];
    for(let i = 0; i < segs; ++i){
        const th2 = th0 + i * th_arc / segs;
        const th3 = th0 + (i + 1) * th_arc / segs;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sin_th,
            cos_th
        ];
    }
    return segmentCache[key] = result;
}
function bezier(params) {
    const key = join.call(params);
    if (bezierCache[key]) return bezierCache[key];
    var cx = params[0], cy = params[1], th0 = params[2], th1 = params[3], rx = params[4], ry = params[5], sin_th = params[6], cos_th = params[7];
    const a00 = cos_th * rx;
    const a01 = -sin_th * ry;
    const a10 = sin_th * rx;
    const a11 = cos_th * ry;
    const cos_th0 = Math.cos(th0);
    const sin_th0 = Math.sin(th0);
    const cos_th1 = Math.cos(th1);
    const sin_th1 = Math.sin(th1);
    const th_half = 0.5 * (th1 - th0);
    const sin_th_h2 = Math.sin(th_half * 0.5);
    const t = 8 / 3 * sin_th_h2 * sin_th_h2 / Math.sin(th_half);
    const x1 = cx + cos_th0 - t * sin_th0;
    const y1 = cy + sin_th0 + t * cos_th0;
    const x3 = cx + cos_th1;
    const y3 = cy + sin_th1;
    const x2 = x3 + t * sin_th1;
    const y2 = y3 - t * cos_th1;
    return bezierCache[key] = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
}
const temp = [
    'l',
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
function scale$1(current, sX, sY) {
    const c = temp[0] = current[0];
    if (c === 'a' || c === 'A') {
        temp[1] = sX * current[1];
        temp[2] = sY * current[2];
        temp[3] = current[3];
        temp[4] = current[4];
        temp[5] = current[5];
        temp[6] = sX * current[6];
        temp[7] = sY * current[7];
    } else if (c === 'h' || c === 'H') temp[1] = sX * current[1];
    else if (c === 'v' || c === 'V') temp[1] = sY * current[1];
    else for(var i = 1, n = current.length; i < n; ++i)temp[i] = (i % 2 == 1 ? sX : sY) * current[i];
    return temp;
}
function pathRender(context, path, l, t, sX, sY) {
    var current, // current instruction
    previous = null, x = 0, // current x
    y = 0, // current y
    controlX = 0, // current control point x
    controlY = 0, // current control point y
    tempX, tempY, tempControlX, tempControlY, anchorX = 0, anchorY = 0;
    if (l == null) l = 0;
    if (t == null) t = 0;
    if (sX == null) sX = 1;
    if (sY == null) sY = sX;
    if (context.beginPath) context.beginPath();
    for(var i = 0, len = path.length; i < len; ++i){
        current = path[i];
        if (sX !== 1 || sY !== 1) current = scale$1(current, sX, sY);
        switch(current[0]){
            // first letter
            case 'l':
                // lineto, relative
                x += current[1];
                y += current[2];
                context.lineTo(x + l, y + t);
                break;
            case 'L':
                // lineto, absolute
                x = current[1];
                y = current[2];
                context.lineTo(x + l, y + t);
                break;
            case 'h':
                // horizontal lineto, relative
                x += current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'H':
                // horizontal lineto, absolute
                x = current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'v':
                // vertical lineto, relative
                y += current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'V':
                // verical lineto, absolute
                y = current[1];
                context.lineTo(x + l, y + t);
                break;
            case 'm':
                // moveTo, relative
                x += current[1];
                y += current[2];
                anchorX = x;
                anchorY = y;
                context.moveTo(x + l, y + t);
                break;
            case 'M':
                // moveTo, absolute
                x = current[1];
                y = current[2];
                anchorX = x;
                anchorY = y;
                context.moveTo(x + l, y + t);
                break;
            case 'c':
                // bezierCurveTo, relative
                tempX = x + current[5];
                tempY = y + current[6];
                controlX = x + current[3];
                controlY = y + current[4];
                context.bezierCurveTo(x + current[1] + l, // x1
                y + current[2] + t, // y1
                controlX + l, // x2
                controlY + t, // y2
                tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                break;
            case 'C':
                // bezierCurveTo, absolute
                x = current[5];
                y = current[6];
                controlX = current[3];
                controlY = current[4];
                context.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
                break;
            case 's':
                // shorthand cubic bezierCurveTo, relative
                // transform to absolute x,y
                tempX = x + current[3];
                tempY = y + current[4];
                // calculate reflection of previous control points
                controlX = 2 * x - controlX;
                controlY = 2 * y - controlY;
                context.bezierCurveTo(controlX + l, controlY + t, x + current[1] + l, y + current[2] + t, tempX + l, tempY + t);
                // set control point to 2nd one of this command
                // the first control point is assumed to be the reflection of
                // the second control point on the previous command relative
                // to the current point.
                controlX = x + current[1];
                controlY = y + current[2];
                x = tempX;
                y = tempY;
                break;
            case 'S':
                // shorthand cubic bezierCurveTo, absolute
                tempX = current[3];
                tempY = current[4];
                // calculate reflection of previous control points
                controlX = 2 * x - controlX;
                controlY = 2 * y - controlY;
                context.bezierCurveTo(controlX + l, controlY + t, current[1] + l, current[2] + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                // set control point to 2nd one of this command
                // the first control point is assumed to be the reflection of
                // the second control point on the previous command relative
                // to the current point.
                controlX = current[1];
                controlY = current[2];
                break;
            case 'q':
                // quadraticCurveTo, relative
                // transform to absolute x,y
                tempX = x + current[3];
                tempY = y + current[4];
                controlX = x + current[1];
                controlY = y + current[2];
                context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                break;
            case 'Q':
                // quadraticCurveTo, absolute
                tempX = current[3];
                tempY = current[4];
                context.quadraticCurveTo(current[1] + l, current[2] + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                controlX = current[1];
                controlY = current[2];
                break;
            case 't':
                // shorthand quadraticCurveTo, relative
                // transform to absolute x,y
                tempX = x + current[1];
                tempY = y + current[2];
                if (previous[0].match(/[QqTt]/) === null) {
                    // If there is no previous command or if the previous command was not a Q, q, T or t,
                    // assume the control point is coincident with the current point
                    controlX = x;
                    controlY = y;
                } else if (previous[0] === 't') {
                    // calculate reflection of previous control points for t
                    controlX = 2 * x - tempControlX;
                    controlY = 2 * y - tempControlY;
                } else if (previous[0] === 'q') {
                    // calculate reflection of previous control points for q
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                }
                tempControlX = controlX;
                tempControlY = controlY;
                context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                controlX = x + current[1];
                controlY = y + current[2];
                break;
            case 'T':
                tempX = current[1];
                tempY = current[2];
                // calculate reflection of previous control points
                controlX = 2 * x - controlX;
                controlY = 2 * y - controlY;
                context.quadraticCurveTo(controlX + l, controlY + t, tempX + l, tempY + t);
                x = tempX;
                y = tempY;
                break;
            case 'a':
                drawArc(context, x + l, y + t, [
                    current[1],
                    current[2],
                    current[3],
                    current[4],
                    current[5],
                    current[6] + x + l,
                    current[7] + y + t
                ]);
                x += current[6];
                y += current[7];
                break;
            case 'A':
                drawArc(context, x + l, y + t, [
                    current[1],
                    current[2],
                    current[3],
                    current[4],
                    current[5],
                    current[6] + l,
                    current[7] + t
                ]);
                x = current[6];
                y = current[7];
                break;
            case 'z':
            case 'Z':
                x = anchorX;
                y = anchorY;
                context.closePath();
                break;
        }
        previous = current;
    }
}
function drawArc(context, x, y, coords) {
    const seg = segments(coords[5], // end x
    coords[6], // end y
    coords[0], // radius x
    coords[1], // radius y
    coords[3], // large flag
    coords[4], // sweep flag
    coords[2], // rotation
    x, y);
    for(let i = 0; i < seg.length; ++i){
        const bez = bezier(seg[i]);
        context.bezierCurveTo(bez[0], bez[1], bez[2], bez[3], bez[4], bez[5]);
    }
}
const Tan30 = 0.5773502691896257;
const builtins = {
    'circle': {
        draw: function(context, size) {
            const r = Math.sqrt(size) / 2;
            context.moveTo(r, 0);
            context.arc(0, 0, r, 0, Tau);
        }
    },
    'cross': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, s = r / 2.5;
            context.moveTo(-r, -s);
            context.lineTo(-r, s);
            context.lineTo(-s, s);
            context.lineTo(-s, r);
            context.lineTo(s, r);
            context.lineTo(s, s);
            context.lineTo(r, s);
            context.lineTo(r, -s);
            context.lineTo(s, -s);
            context.lineTo(s, -r);
            context.lineTo(-s, -r);
            context.lineTo(-s, -s);
            context.closePath();
        }
    },
    'diamond': {
        draw: function(context, size) {
            const r = Math.sqrt(size) / 2;
            context.moveTo(-r, 0);
            context.lineTo(0, -r);
            context.lineTo(r, 0);
            context.lineTo(0, r);
            context.closePath();
        }
    },
    'square': {
        draw: function(context, size) {
            var w = Math.sqrt(size), x = -w / 2;
            context.rect(x, x, w, w);
        }
    },
    'arrow': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, s = r / 7, t = r / 2.5, v = r / 8;
            context.moveTo(-s, r);
            context.lineTo(s, r);
            context.lineTo(s, -v);
            context.lineTo(t, -v);
            context.lineTo(0, -r);
            context.lineTo(-t, -v);
            context.lineTo(-s, -v);
            context.closePath();
        }
    },
    'wedge': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r, o = h - r * Tan30, b = r / 4;
            context.moveTo(0, -h - o);
            context.lineTo(-b, h - o);
            context.lineTo(b, h - o);
            context.closePath();
        }
    },
    'triangle': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r, o = h - r * Tan30;
            context.moveTo(0, -h - o);
            context.lineTo(-r, h - o);
            context.lineTo(r, h - o);
            context.closePath();
        }
    },
    'triangle-up': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(0, -h);
            context.lineTo(-r, h);
            context.lineTo(r, h);
            context.closePath();
        }
    },
    'triangle-down': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(0, h);
            context.lineTo(-r, -h);
            context.lineTo(r, -h);
            context.closePath();
        }
    },
    'triangle-right': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(h, 0);
            context.lineTo(-h, -r);
            context.lineTo(-h, r);
            context.closePath();
        }
    },
    'triangle-left': {
        draw: function(context, size) {
            var r = Math.sqrt(size) / 2, h = HalfSqrt3 * r;
            context.moveTo(-h, 0);
            context.lineTo(h, -r);
            context.lineTo(h, r);
            context.closePath();
        }
    },
    'stroke': {
        draw: function(context, size) {
            const r = Math.sqrt(size) / 2;
            context.moveTo(-r, 0);
            context.lineTo(r, 0);
        }
    }
};
function symbols(_) {
    return (0, _vegaUtil.hasOwnProperty)(builtins, _) ? builtins[_] : customSymbol(_);
}
var custom = {};
function customSymbol(path) {
    if (!(0, _vegaUtil.hasOwnProperty)(custom, path)) {
        const parsed = parse(path);
        custom[path] = {
            draw: function(context, size) {
                pathRender(context, parsed, 0, 0, Math.sqrt(size) / 2);
            }
        };
    }
    return custom[path];
}
// See http://spencermortensen.com/articles/bezier-circle/
const C = 0.448084975506; // C = 1 - c
function rectangleX(d) {
    return d.x;
}
function rectangleY(d) {
    return d.y;
}
function rectangleWidth(d) {
    return d.width;
}
function rectangleHeight(d) {
    return d.height;
}
function number(_) {
    return typeof _ === 'function' ? _ : ()=>+_;
}
function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
}
function vg_rect() {
    var x = rectangleX, y = rectangleY, width = rectangleWidth, height = rectangleHeight, crTL = number(0), crTR = crTL, crBL = crTL, crBR = crTL, context = null;
    function rectangle(_, x0, y0) {
        var buffer, x1 = x0 != null ? x0 : +x.call(this, _), y1 = y0 != null ? y0 : +y.call(this, _), w = +width.call(this, _), h = +height.call(this, _), s = Math.min(w, h) / 2, tl = clamp(+crTL.call(this, _), 0, s), tr = clamp(+crTR.call(this, _), 0, s), bl = clamp(+crBL.call(this, _), 0, s), br = clamp(+crBR.call(this, _), 0, s);
        if (!context) context = buffer = (0, _d3Path.path)();
        if (tl <= 0 && tr <= 0 && bl <= 0 && br <= 0) context.rect(x1, y1, w, h);
        else {
            var x2 = x1 + w, y2 = y1 + h;
            context.moveTo(x1 + tl, y1);
            context.lineTo(x2 - tr, y1);
            context.bezierCurveTo(x2 - C * tr, y1, x2, y1 + C * tr, x2, y1 + tr);
            context.lineTo(x2, y2 - br);
            context.bezierCurveTo(x2, y2 - C * br, x2 - C * br, y2, x2 - br, y2);
            context.lineTo(x1 + bl, y2);
            context.bezierCurveTo(x1 + C * bl, y2, x1, y2 - C * bl, x1, y2 - bl);
            context.lineTo(x1, y1 + tl);
            context.bezierCurveTo(x1, y1 + C * tl, x1 + C * tl, y1, x1 + tl, y1);
            context.closePath();
        }
        if (buffer) {
            context = null;
            return buffer + '' || null;
        }
    }
    rectangle.x = function(_) {
        if (arguments.length) {
            x = number(_);
            return rectangle;
        } else return x;
    };
    rectangle.y = function(_) {
        if (arguments.length) {
            y = number(_);
            return rectangle;
        } else return y;
    };
    rectangle.width = function(_) {
        if (arguments.length) {
            width = number(_);
            return rectangle;
        } else return width;
    };
    rectangle.height = function(_) {
        if (arguments.length) {
            height = number(_);
            return rectangle;
        } else return height;
    };
    rectangle.cornerRadius = function(tl, tr, br, bl) {
        if (arguments.length) {
            crTL = number(tl);
            crTR = tr != null ? number(tr) : crTL;
            crBR = br != null ? number(br) : crTL;
            crBL = bl != null ? number(bl) : crTR;
            return rectangle;
        } else return crTL;
    };
    rectangle.context = function(_) {
        if (arguments.length) {
            context = _ == null ? null : _;
            return rectangle;
        } else return context;
    };
    return rectangle;
}
function vg_trail() {
    var x, y, size, defined, context = null, ready, x1, y1, r1;
    function point(x2, y2, w2) {
        const r2 = w2 / 2;
        if (ready) {
            var ux = y1 - y2, uy = x2 - x1;
            if (ux || uy) {
                // get normal vector
                var ud = Math.hypot(ux, uy), rx = (ux /= ud) * r1, ry = (uy /= ud) * r1, t = Math.atan2(uy, ux);
                // draw segment
                context.moveTo(x1 - rx, y1 - ry);
                context.lineTo(x2 - ux * r2, y2 - uy * r2);
                context.arc(x2, y2, r2, t - Math.PI, t);
                context.lineTo(x1 + rx, y1 + ry);
                context.arc(x1, y1, r1, t, t + Math.PI);
            } else context.arc(x2, y2, r2, 0, Tau);
            context.closePath();
        } else ready = 1;
        x1 = x2;
        y1 = y2;
        r1 = r2;
    }
    function trail(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) context = buffer = (0, _d3Path.path)();
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) ready = 0;
            }
            if (defined0) point(+x(d, i, data), +y(d, i, data), +size(d, i, data));
        }
        if (buffer) {
            context = null;
            return buffer + '' || null;
        }
    }
    trail.x = function(_) {
        if (arguments.length) {
            x = _;
            return trail;
        } else return x;
    };
    trail.y = function(_) {
        if (arguments.length) {
            y = _;
            return trail;
        } else return y;
    };
    trail.size = function(_) {
        if (arguments.length) {
            size = _;
            return trail;
        } else return size;
    };
    trail.defined = function(_) {
        if (arguments.length) {
            defined = _;
            return trail;
        } else return defined;
    };
    trail.context = function(_) {
        if (arguments.length) {
            if (_ == null) context = null;
            else context = _;
            return trail;
        } else return context;
    };
    return trail;
}
function value$1(a, b) {
    return a != null ? a : b;
}
const x = (item)=>item.x || 0, y = (item)=>item.y || 0, w = (item)=>item.width || 0, h = (item)=>item.height || 0, xw = (item)=>(item.x || 0) + (item.width || 0), yh = (item)=>(item.y || 0) + (item.height || 0), sa = (item)=>item.startAngle || 0, ea = (item)=>item.endAngle || 0, pa = (item)=>item.padAngle || 0, ir = (item)=>item.innerRadius || 0, or = (item)=>item.outerRadius || 0, cr = (item)=>item.cornerRadius || 0, tl = (item)=>value$1(item.cornerRadiusTopLeft, item.cornerRadius) || 0, tr = (item)=>value$1(item.cornerRadiusTopRight, item.cornerRadius) || 0, br = (item)=>value$1(item.cornerRadiusBottomRight, item.cornerRadius) || 0, bl = (item)=>value$1(item.cornerRadiusBottomLeft, item.cornerRadius) || 0, sz = (item)=>value$1(item.size, 64), ts = (item)=>item.size || 1, def = (item)=>!(item.defined === false), type = (item)=>symbols(item.shape || 'circle');
const arcShape = (0, _d3Shape.arc)().startAngle(sa).endAngle(ea).padAngle(pa).innerRadius(ir).outerRadius(or).cornerRadius(cr), areavShape = (0, _d3Shape.area)().x(x).y1(y).y0(yh).defined(def), areahShape = (0, _d3Shape.area)().y(y).x1(x).x0(xw).defined(def), lineShape = (0, _d3Shape.line)().x(x).y(y).defined(def), rectShape = vg_rect().x(x).y(y).width(w).height(h).cornerRadius(tl, tr, br, bl), symbolShape = (0, _d3Shape.symbol)().type(type).size(sz), trailShape = vg_trail().x(x).y(y).defined(def).size(ts);
function hasCornerRadius(item) {
    return item.cornerRadius || item.cornerRadiusTopLeft || item.cornerRadiusTopRight || item.cornerRadiusBottomRight || item.cornerRadiusBottomLeft;
}
function arc$1(context, item) {
    return arcShape.context(context)(item);
}
function area$1(context, items) {
    const item = items[0], interp = item.interpolate || 'linear';
    return (item.orient === 'horizontal' ? areahShape : areavShape).curve(curves(interp, item.orient, item.tension)).context(context)(items);
}
function line$1(context, items) {
    const item = items[0], interp = item.interpolate || 'linear';
    return lineShape.curve(curves(interp, item.orient, item.tension)).context(context)(items);
}
function rectangle(context, item, x, y) {
    return rectShape.context(context)(item, x, y);
}
function shape$1(context, item) {
    return (item.mark.shape || item.shape).context(context)(item);
}
function symbol$1(context, item) {
    return symbolShape.context(context)(item);
}
function trail$1(context, items) {
    return trailShape.context(context)(items);
}
var clip_id = 1;
function resetSVGClipId() {
    clip_id = 1;
}
function clip$1(renderer, item, size) {
    var clip = item.clip, defs = renderer._defs, id = item.clip_id || (item.clip_id = 'clip' + clip_id++), c = defs.clipping[id] || (defs.clipping[id] = {
        id: id
    });
    if ((0, _vegaUtil.isFunction)(clip)) c.path = clip(null);
    else if (hasCornerRadius(size)) c.path = rectangle(null, size, 0, 0);
    else {
        c.width = size.width || 0;
        c.height = size.height || 0;
    }
    return 'url(#' + id + ')';
}
function Bounds(b) {
    this.clear();
    if (b) this.union(b);
}
Bounds.prototype = {
    clone () {
        return new Bounds(this);
    },
    clear () {
        this.x1 = +Number.MAX_VALUE;
        this.y1 = +Number.MAX_VALUE;
        this.x2 = -Number.MAX_VALUE;
        this.y2 = -Number.MAX_VALUE;
        return this;
    },
    empty () {
        return this.x1 === +Number.MAX_VALUE && this.y1 === +Number.MAX_VALUE && this.x2 === -Number.MAX_VALUE && this.y2 === -Number.MAX_VALUE;
    },
    equals (b) {
        return this.x1 === b.x1 && this.y1 === b.y1 && this.x2 === b.x2 && this.y2 === b.y2;
    },
    set (x1, y1, x2, y2) {
        if (x2 < x1) {
            this.x2 = x1;
            this.x1 = x2;
        } else {
            this.x1 = x1;
            this.x2 = x2;
        }
        if (y2 < y1) {
            this.y2 = y1;
            this.y1 = y2;
        } else {
            this.y1 = y1;
            this.y2 = y2;
        }
        return this;
    },
    add (x, y) {
        if (x < this.x1) this.x1 = x;
        if (y < this.y1) this.y1 = y;
        if (x > this.x2) this.x2 = x;
        if (y > this.y2) this.y2 = y;
        return this;
    },
    expand (d) {
        this.x1 -= d;
        this.y1 -= d;
        this.x2 += d;
        this.y2 += d;
        return this;
    },
    round () {
        this.x1 = Math.floor(this.x1);
        this.y1 = Math.floor(this.y1);
        this.x2 = Math.ceil(this.x2);
        this.y2 = Math.ceil(this.y2);
        return this;
    },
    scale (s) {
        this.x1 *= s;
        this.y1 *= s;
        this.x2 *= s;
        this.y2 *= s;
        return this;
    },
    translate (dx, dy) {
        this.x1 += dx;
        this.x2 += dx;
        this.y1 += dy;
        this.y2 += dy;
        return this;
    },
    rotate (angle, x, y) {
        const p = this.rotatedPoints(angle, x, y);
        return this.clear().add(p[0], p[1]).add(p[2], p[3]).add(p[4], p[5]).add(p[6], p[7]);
    },
    rotatedPoints (angle, x, y) {
        var { x1, y1, x2, y2 } = this, cos = Math.cos(angle), sin = Math.sin(angle), cx = x - x * cos + y * sin, cy = y - x * sin - y * cos;
        return [
            cos * x1 - sin * y1 + cx,
            sin * x1 + cos * y1 + cy,
            cos * x1 - sin * y2 + cx,
            sin * x1 + cos * y2 + cy,
            cos * x2 - sin * y1 + cx,
            sin * x2 + cos * y1 + cy,
            cos * x2 - sin * y2 + cx,
            sin * x2 + cos * y2 + cy
        ];
    },
    union (b) {
        if (b.x1 < this.x1) this.x1 = b.x1;
        if (b.y1 < this.y1) this.y1 = b.y1;
        if (b.x2 > this.x2) this.x2 = b.x2;
        if (b.y2 > this.y2) this.y2 = b.y2;
        return this;
    },
    intersect (b) {
        if (b.x1 > this.x1) this.x1 = b.x1;
        if (b.y1 > this.y1) this.y1 = b.y1;
        if (b.x2 < this.x2) this.x2 = b.x2;
        if (b.y2 < this.y2) this.y2 = b.y2;
        return this;
    },
    encloses (b) {
        return b && this.x1 <= b.x1 && this.x2 >= b.x2 && this.y1 <= b.y1 && this.y2 >= b.y2;
    },
    alignsWith (b) {
        return b && (this.x1 == b.x1 || this.x2 == b.x2 || this.y1 == b.y1 || this.y2 == b.y2);
    },
    intersects (b) {
        return b && !(this.x2 < b.x1 || this.x1 > b.x2 || this.y2 < b.y1 || this.y1 > b.y2);
    },
    contains (x, y) {
        return !(x < this.x1 || x > this.x2 || y < this.y1 || y > this.y2);
    },
    width () {
        return this.x2 - this.x1;
    },
    height () {
        return this.y2 - this.y1;
    }
};
function Item(mark) {
    this.mark = mark;
    this.bounds = this.bounds || new Bounds();
}
function GroupItem(mark) {
    Item.call(this, mark);
    this.items = this.items || [];
}
(0, _vegaUtil.inherits)(GroupItem, Item);
class ResourceLoader {
    constructor(customLoader){
        this._pending = 0;
        this._loader = customLoader || (0, _vegaLoader.loader)();
    }
    pending() {
        return this._pending;
    }
    sanitizeURL(uri) {
        const loader = this;
        increment(loader);
        return loader._loader.sanitize(uri, {
            context: 'href'
        }).then((opt)=>{
            decrement(loader);
            return opt;
        }).catch(()=>{
            decrement(loader);
            return null;
        });
    }
    loadImage(uri) {
        const loader = this, Image = (0, _vegaCanvas.image)();
        increment(loader);
        return loader._loader.sanitize(uri, {
            context: 'image'
        }).then((opt)=>{
            const url = opt.href;
            if (!url || !Image) throw {
                url: url
            };
            const img = new Image();
            // set crossOrigin only if cors is defined; empty string sets anonymous mode
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/crossOrigin
            const cors = (0, _vegaUtil.hasOwnProperty)(opt, 'crossOrigin') ? opt.crossOrigin : 'anonymous';
            if (cors != null) img.crossOrigin = cors;
            // attempt to load image resource
            img.onload = ()=>decrement(loader);
            img.onerror = ()=>decrement(loader);
            img.src = url;
            return img;
        }).catch((e)=>{
            decrement(loader);
            return {
                complete: false,
                width: 0,
                height: 0,
                src: e && e.url || ''
            };
        });
    }
    ready() {
        const loader = this;
        return new Promise((accept)=>{
            function poll(value) {
                if (!loader.pending()) accept(value);
                else setTimeout(()=>{
                    poll(true);
                }, 10);
            }
            poll(false);
        });
    }
}
function increment(loader) {
    loader._pending += 1;
}
function decrement(loader) {
    loader._pending -= 1;
}
function boundStroke(bounds, item, miter) {
    if (item.stroke && item.opacity !== 0 && item.strokeOpacity !== 0) {
        const sw = item.strokeWidth != null ? +item.strokeWidth : 1;
        bounds.expand(sw + (miter ? miterAdjustment(item, sw) : 0));
    }
    return bounds;
}
function miterAdjustment(item, strokeWidth) {
    // TODO: more sophisticated adjustment? Or miter support in boundContext?
    return item.strokeJoin && item.strokeJoin !== 'miter' ? 0 : strokeWidth;
}
const circleThreshold = Tau - 1e-8;
let bounds, lx, ly, rot, ma, mb, mc, md;
const add = (x, y)=>bounds.add(x, y);
const addL = (x, y)=>add(lx = x, ly = y);
const addX = (x)=>add(x, bounds.y1);
const addY = (y)=>add(bounds.x1, y);
const px = (x, y)=>ma * x + mc * y;
const py = (x, y)=>mb * x + md * y;
const addp = (x, y)=>add(px(x, y), py(x, y));
const addpL = (x, y)=>addL(px(x, y), py(x, y));
function boundContext(_, deg) {
    bounds = _;
    if (deg) {
        rot = deg * DegToRad;
        ma = md = Math.cos(rot);
        mb = Math.sin(rot);
        mc = -mb;
    } else {
        ma = md = 1;
        rot = mb = mc = 0;
    }
    return context$1;
}
const context$1 = {
    beginPath () {},
    closePath () {},
    moveTo: addpL,
    lineTo: addpL,
    rect (x, y, w, h) {
        if (rot) {
            addp(x + w, y);
            addp(x + w, y + h);
            addp(x, y + h);
            addpL(x, y);
        } else {
            add(x + w, y + h);
            addL(x, y);
        }
    },
    quadraticCurveTo (x1, y1, x2, y2) {
        const px1 = px(x1, y1), py1 = py(x1, y1), px2 = px(x2, y2), py2 = py(x2, y2);
        quadExtrema(lx, px1, px2, addX);
        quadExtrema(ly, py1, py2, addY);
        addL(px2, py2);
    },
    bezierCurveTo (x1, y1, x2, y2, x3, y3) {
        const px1 = px(x1, y1), py1 = py(x1, y1), px2 = px(x2, y2), py2 = py(x2, y2), px3 = px(x3, y3), py3 = py(x3, y3);
        cubicExtrema(lx, px1, px2, px3, addX);
        cubicExtrema(ly, py1, py2, py3, addY);
        addL(px3, py3);
    },
    arc (cx, cy, r, sa, ea, ccw) {
        sa += rot;
        ea += rot;
        // store last point on path
        lx = r * Math.cos(ea) + cx;
        ly = r * Math.sin(ea) + cy;
        if (Math.abs(ea - sa) > circleThreshold) {
            // treat as full circle
            add(cx - r, cy - r);
            add(cx + r, cy + r);
        } else {
            const update = (a)=>add(r * Math.cos(a) + cx, r * Math.sin(a) + cy);
            let s, i;
            // sample end points
            update(sa);
            update(ea);
            // sample interior points aligned with 90 degrees
            if (ea !== sa) {
                sa = sa % Tau;
                if (sa < 0) sa += Tau;
                ea = ea % Tau;
                if (ea < 0) ea += Tau;
                if (ea < sa) {
                    ccw = !ccw; // flip direction
                    s = sa;
                    sa = ea;
                    ea = s; // swap end-points
                }
                if (ccw) {
                    ea -= Tau;
                    s = sa - sa % HalfPi;
                    for(i = 0; i < 4 && s > ea; ++i, s -= HalfPi)update(s);
                } else {
                    s = sa - sa % HalfPi + HalfPi;
                    for(i = 0; i < 4 && s < ea; ++i, s = s + HalfPi)update(s);
                }
            }
        }
    }
};
function quadExtrema(x0, x1, x2, cb) {
    const t = (x0 - x1) / (x0 + x2 - 2 * x1);
    if (0 < t && t < 1) cb(x0 + (x1 - x0) * t);
}
function cubicExtrema(x0, x1, x2, x3, cb) {
    const a = x3 - x0 + 3 * x1 - 3 * x2, b = x0 + x2 - 2 * x1, c = x0 - x1;
    let t0 = 0, t1 = 0, r;
    // solve for parameter t
    if (Math.abs(a) > Epsilon) {
        // quadratic equation
        r = b * b + c * a;
        if (r >= 0) {
            r = Math.sqrt(r);
            t0 = (-b + r) / a;
            t1 = (-b - r) / a;
        }
    } else // linear equation
    t0 = 0.5 * c / b;
    // calculate position
    if (0 < t0 && t0 < 1) cb(cubic(t0, x0, x1, x2, x3));
    if (0 < t1 && t1 < 1) cb(cubic(t1, x0, x1, x2, x3));
}
function cubic(t, x0, x1, x2, x3) {
    const s = 1 - t, s2 = s * s, t2 = t * t;
    return s2 * s * x0 + 3 * s2 * t * x1 + 3 * s * t2 * x2 + t2 * t * x3;
}
var context = (context = (0, _vegaCanvas.canvas)(1, 1)) ? context.getContext('2d') : null;
const b = new Bounds();
function intersectPath(draw) {
    return function(item, brush) {
        // rely on (inaccurate) bounds intersection if no context
        if (!context) return true;
        // add path to offscreen graphics context
        draw(context, item);
        // get bounds intersection region
        b.clear().union(item.bounds).intersect(brush).round();
        const { x1, y1, x2, y2 } = b;
        // iterate over intersection region
        // perform fine grained inclusion test
        for(let y = y1; y <= y2; ++y)for(let x = x1; x <= x2; ++x){
            if (context.isPointInPath(x, y)) return true;
        }
        // false if no hits in intersection region
        return false;
    };
}
function intersectPoint(item, box) {
    return box.contains(item.x || 0, item.y || 0);
}
function intersectRect(item, box) {
    const x = item.x || 0, y = item.y || 0, w = item.width || 0, h = item.height || 0;
    return box.intersects(b.set(x, y, x + w, y + h));
}
function intersectRule(item, box) {
    const x = item.x || 0, y = item.y || 0, x2 = item.x2 != null ? item.x2 : x, y2 = item.y2 != null ? item.y2 : y;
    return intersectBoxLine(box, x, y, x2, y2);
}
function intersectBoxLine(box, x, y, u, v) {
    const { x1, y1, x2, y2 } = box, dx = u - x, dy = v - y;
    let t0 = 0, t1 = 1, p, q, r, e;
    for(e = 0; e < 4; ++e){
        if (e === 0) {
            p = -dx;
            q = -(x1 - x);
        }
        if (e === 1) {
            p = dx;
            q = x2 - x;
        }
        if (e === 2) {
            p = -dy;
            q = -(y1 - y);
        }
        if (e === 3) {
            p = dy;
            q = y2 - y;
        }
        if (Math.abs(p) < 1e-10 && q < 0) return false;
        r = q / p;
        if (p < 0) {
            if (r > t1) return false;
            else if (r > t0) t0 = r;
        } else if (p > 0) {
            if (r < t0) return false;
            else if (r < t1) t1 = r;
        }
    }
    return true;
}
function blend(context, item) {
    context.globalCompositeOperation = item.blend || 'source-over';
}
function value(value, dflt) {
    return value == null ? dflt : value;
}
function addStops(gradient, stops) {
    const n = stops.length;
    for(let i = 0; i < n; ++i)gradient.addColorStop(stops[i].offset, stops[i].color);
    return gradient;
}
function gradient(context, spec, bounds) {
    const w = bounds.width(), h = bounds.height();
    let gradient;
    if (spec.gradient === 'radial') gradient = context.createRadialGradient(bounds.x1 + value(spec.x1, 0.5) * w, bounds.y1 + value(spec.y1, 0.5) * h, Math.max(w, h) * value(spec.r1, 0), bounds.x1 + value(spec.x2, 0.5) * w, bounds.y1 + value(spec.y2, 0.5) * h, Math.max(w, h) * value(spec.r2, 0.5));
    else {
        // linear gradient
        const x1 = value(spec.x1, 0), y1 = value(spec.y1, 0), x2 = value(spec.x2, 1), y2 = value(spec.y2, 0);
        if (x1 === x2 || y1 === y2 || w === h) // axis aligned: use normal gradient
        gradient = context.createLinearGradient(bounds.x1 + x1 * w, bounds.y1 + y1 * h, bounds.x1 + x2 * w, bounds.y1 + y2 * h);
        else {
            // not axis aligned: render gradient into a pattern (#2365)
            // this allows us to use normalized bounding box coordinates
            const image = (0, _vegaCanvas.canvas)(Math.ceil(w), Math.ceil(h)), ictx = image.getContext('2d');
            ictx.scale(w, h);
            ictx.fillStyle = addStops(ictx.createLinearGradient(x1, y1, x2, y2), spec.stops);
            ictx.fillRect(0, 0, w, h);
            return context.createPattern(image, 'no-repeat');
        }
    }
    return addStops(gradient, spec.stops);
}
function color(context, item, value) {
    return isGradient(value) ? gradient(context, value, item.bounds) : value;
}
function fill(context, item, opacity) {
    opacity *= item.fillOpacity == null ? 1 : item.fillOpacity;
    if (opacity > 0) {
        context.globalAlpha = opacity;
        context.fillStyle = color(context, item, item.fill);
        return true;
    } else return false;
}
var Empty = [];
function stroke(context, item, opacity) {
    var lw = (lw = item.strokeWidth) != null ? lw : 1;
    if (lw <= 0) return false;
    opacity *= item.strokeOpacity == null ? 1 : item.strokeOpacity;
    if (opacity > 0) {
        context.globalAlpha = opacity;
        context.strokeStyle = color(context, item, item.stroke);
        context.lineWidth = lw;
        context.lineCap = item.strokeCap || 'butt';
        context.lineJoin = item.strokeJoin || 'miter';
        context.miterLimit = item.strokeMiterLimit || 10;
        if (context.setLineDash) {
            context.setLineDash(item.strokeDash || Empty);
            context.lineDashOffset = item.strokeDashOffset || 0;
        }
        return true;
    } else return false;
}
function compare(a, b) {
    return a.zindex - b.zindex || a.index - b.index;
}
function zorder(scene) {
    if (!scene.zdirty) return scene.zitems;
    var items = scene.items, output = [], item, i, n;
    for(i = 0, n = items.length; i < n; ++i){
        item = items[i];
        item.index = i;
        if (item.zindex) output.push(item);
    }
    scene.zdirty = false;
    return scene.zitems = output.sort(compare);
}
function visit(scene, visitor) {
    var items = scene.items, i, n;
    if (!items || !items.length) return;
    const zitems = zorder(scene);
    if (zitems && zitems.length) {
        for(i = 0, n = items.length; i < n; ++i)if (!items[i].zindex) visitor(items[i]);
        items = zitems;
    }
    for(i = 0, n = items.length; i < n; ++i)visitor(items[i]);
}
function pickVisit(scene, visitor) {
    var items = scene.items, hit, i;
    if (!items || !items.length) return null;
    const zitems = zorder(scene);
    if (zitems && zitems.length) items = zitems;
    for(i = items.length; --i >= 0;){
        if (hit = visitor(items[i])) return hit;
    }
    if (items === zitems) {
        for(items = scene.items, i = items.length; --i >= 0;)if (!items[i].zindex) {
            if (hit = visitor(items[i])) return hit;
        }
    }
    return null;
}
function drawAll(path) {
    return function(context, scene, bounds) {
        visit(scene, (item)=>{
            if (!bounds || bounds.intersects(item.bounds)) drawPath(path, context, item, item);
        });
    };
}
function drawOne(path) {
    return function(context, scene, bounds) {
        if (scene.items.length && (!bounds || bounds.intersects(scene.bounds))) drawPath(path, context, scene.items[0], scene.items);
    };
}
function drawPath(path, context, item, items) {
    var opacity = item.opacity == null ? 1 : item.opacity;
    if (opacity === 0) return;
    if (path(context, items)) return;
    blend(context, item);
    if (item.fill && fill(context, item, opacity)) context.fill();
    if (item.stroke && stroke(context, item, opacity)) context.stroke();
}
function pick$1(test) {
    test = test || (0, _vegaUtil.truthy);
    return function(context, scene, x, y, gx, gy) {
        x *= context.pixelRatio;
        y *= context.pixelRatio;
        return pickVisit(scene, (item)=>{
            const b = item.bounds;
            // first hit test against bounding box
            if (b && !b.contains(gx, gy) || !b) return;
            // if in bounding box, perform more careful test
            if (test(context, item, x, y, gx, gy)) return item;
        });
    };
}
function hitPath(path, filled) {
    return function(context, o, x, y) {
        var item = Array.isArray(o) ? o[0] : o, fill = filled == null ? item.fill : filled, stroke = item.stroke && context.isPointInStroke, lw, lc;
        if (stroke) {
            lw = item.strokeWidth;
            lc = item.strokeCap;
            context.lineWidth = lw != null ? lw : 1;
            context.lineCap = lc != null ? lc : 'butt';
        }
        return path(context, o) ? false : fill && context.isPointInPath(x, y) || stroke && context.isPointInStroke(x, y);
    };
}
function pickPath(path) {
    return pick$1(hitPath(path));
}
function translate(x, y) {
    return 'translate(' + x + ',' + y + ')';
}
function rotate(a) {
    return 'rotate(' + a + ')';
}
function scale(scaleX, scaleY) {
    return 'scale(' + scaleX + ',' + scaleY + ')';
}
function translateItem(item) {
    return translate(item.x || 0, item.y || 0);
}
function rotateItem(item) {
    return translate(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '');
}
function transformItem(item) {
    return translate(item.x || 0, item.y || 0) + (item.angle ? ' ' + rotate(item.angle) : '') + (item.scaleX || item.scaleY ? ' ' + scale(item.scaleX || 1, item.scaleY || 1) : '');
}
function markItemPath(type, shape, isect) {
    function attr(emit, item) {
        emit('transform', rotateItem(item));
        emit('d', shape(null, item));
    }
    function bound(bounds, item) {
        shape(boundContext(bounds, item.angle), item);
        return boundStroke(bounds, item).translate(item.x || 0, item.y || 0);
    }
    function draw(context, item) {
        var x = item.x || 0, y = item.y || 0, a = item.angle || 0;
        context.translate(x, y);
        if (a) context.rotate(a *= DegToRad);
        context.beginPath();
        shape(context, item);
        if (a) context.rotate(-a);
        context.translate(-x, -y);
    }
    return {
        type: type,
        tag: 'path',
        nested: false,
        attr: attr,
        bound: bound,
        draw: drawAll(draw),
        pick: pickPath(draw),
        isect: isect || intersectPath(draw)
    };
}
var arc = markItemPath('arc', arc$1);
function pickArea(a, p) {
    var v = a[0].orient === 'horizontal' ? p[1] : p[0], z = a[0].orient === 'horizontal' ? 'y' : 'x', i = a.length, min = Infinity, hit, d;
    while(--i >= 0){
        if (a[i].defined === false) continue;
        d = Math.abs(a[i][z] - v);
        if (d < min) {
            min = d;
            hit = a[i];
        }
    }
    return hit;
}
function pickLine(a, p) {
    var t = Math.pow(a[0].strokeWidth || 1, 2), i = a.length, dx, dy, dd;
    while(--i >= 0){
        if (a[i].defined === false) continue;
        dx = a[i].x - p[0];
        dy = a[i].y - p[1];
        dd = dx * dx + dy * dy;
        if (dd < t) return a[i];
    }
    return null;
}
function pickTrail(a, p) {
    var i = a.length, dx, dy, dd;
    while(--i >= 0){
        if (a[i].defined === false) continue;
        dx = a[i].x - p[0];
        dy = a[i].y - p[1];
        dd = dx * dx + dy * dy;
        dx = a[i].size || 1;
        if (dd < dx * dx) return a[i];
    }
    return null;
}
function markMultiItemPath(type, shape, tip) {
    function attr(emit, item) {
        var items = item.mark.items;
        if (items.length) emit('d', shape(null, items));
    }
    function bound(bounds, mark) {
        var items = mark.items;
        if (items.length === 0) return bounds;
        else {
            shape(boundContext(bounds), items);
            return boundStroke(bounds, items[0]);
        }
    }
    function draw(context, items) {
        context.beginPath();
        shape(context, items);
    }
    const hit = hitPath(draw);
    function pick(context, scene, x, y, gx, gy) {
        var items = scene.items, b = scene.bounds;
        if (!items || !items.length || b && !b.contains(gx, gy)) return null;
        x *= context.pixelRatio;
        y *= context.pixelRatio;
        return hit(context, items, x, y) ? items[0] : null;
    }
    return {
        type: type,
        tag: 'path',
        nested: true,
        attr: attr,
        bound: bound,
        draw: drawOne(draw),
        pick: pick,
        isect: intersectPoint,
        tip: tip
    };
}
var area = markMultiItemPath('area', area$1, pickArea);
function clip(context, scene) {
    var clip = scene.clip;
    context.save();
    if ((0, _vegaUtil.isFunction)(clip)) {
        context.beginPath();
        clip(context);
        context.clip();
    } else clipGroup(context, scene.group);
}
function clipGroup(context, group) {
    context.beginPath();
    hasCornerRadius(group) ? rectangle(context, group, 0, 0) : context.rect(0, 0, group.width || 0, group.height || 0);
    context.clip();
}
function offset$1(item) {
    const sw = value(item.strokeWidth, 1);
    return item.strokeOffset != null ? item.strokeOffset : item.stroke && sw > 0.5 && sw < 1.5 ? 0.5 - Math.abs(sw - 1) : 0;
}
function attr$5(emit, item) {
    emit('transform', translateItem(item));
}
function emitRectangle(emit, item) {
    const off = offset$1(item);
    emit('d', rectangle(null, item, off, off));
}
function background(emit, item) {
    emit('class', 'background');
    emit('aria-hidden', true);
    emitRectangle(emit, item);
}
function foreground(emit, item) {
    emit('class', 'foreground');
    emit('aria-hidden', true);
    if (item.strokeForeground) emitRectangle(emit, item);
    else emit('d', '');
}
function content(emit, item, renderer) {
    const url = item.clip ? clip$1(renderer, item, item) : null;
    emit('clip-path', url);
}
function bound$5(bounds, group) {
    if (!group.clip && group.items) {
        const items = group.items, m = items.length;
        for(let j = 0; j < m; ++j)bounds.union(items[j].bounds);
    }
    if ((group.clip || group.width || group.height) && !group.noBound) bounds.add(0, 0).add(group.width || 0, group.height || 0);
    boundStroke(bounds, group);
    return bounds.translate(group.x || 0, group.y || 0);
}
function rectanglePath(context, group, x, y) {
    const off = offset$1(group);
    context.beginPath();
    rectangle(context, group, (x || 0) + off, (y || 0) + off);
}
const hitBackground = hitPath(rectanglePath);
const hitForeground = hitPath(rectanglePath, false);
const hitCorner = hitPath(rectanglePath, true);
function draw$4(context, scene, bounds, markTypes) {
    visit(scene, (group)=>{
        const gx = group.x || 0, gy = group.y || 0, fore = group.strokeForeground, opacity = group.opacity == null ? 1 : group.opacity;
        // draw group background
        if ((group.stroke || group.fill) && opacity) {
            rectanglePath(context, group, gx, gy);
            blend(context, group);
            if (group.fill && fill(context, group, opacity)) context.fill();
            if (group.stroke && !fore && stroke(context, group, opacity)) context.stroke();
        }
        // setup graphics context, set clip and bounds
        context.save();
        context.translate(gx, gy);
        if (group.clip) clipGroup(context, group);
        if (bounds) bounds.translate(-gx, -gy);
        // draw group contents
        visit(group, (item)=>{
            if (item.marktype === 'group' || markTypes == null || markTypes.includes(item.marktype)) this.draw(context, item, bounds, markTypes);
        });
        // restore graphics context
        if (bounds) bounds.translate(gx, gy);
        context.restore();
        // draw group foreground
        if (fore && group.stroke && opacity) {
            rectanglePath(context, group, gx, gy);
            blend(context, group);
            if (stroke(context, group, opacity)) context.stroke();
        }
    });
}
function pick(context, scene, x, y, gx, gy) {
    if (scene.bounds && !scene.bounds.contains(gx, gy) || !scene.items) return null;
    const cx = x * context.pixelRatio, cy = y * context.pixelRatio;
    return pickVisit(scene, (group)=>{
        let hit, dx, dy;
        // first hit test bounding box
        const b = group.bounds;
        if (b && !b.contains(gx, gy)) return;
        // passed bounds check, test rectangular clip
        dx = group.x || 0;
        dy = group.y || 0;
        const dw = dx + (group.width || 0), dh = dy + (group.height || 0), c = group.clip;
        if (c && (gx < dx || gx > dw || gy < dy || gy > dh)) return;
        // adjust coordinate system
        context.save();
        context.translate(dx, dy);
        dx = gx - dx;
        dy = gy - dy;
        // test background for rounded corner clip
        if (c && hasCornerRadius(group) && !hitCorner(context, group, cx, cy)) {
            context.restore();
            return null;
        }
        const fore = group.strokeForeground, ix = scene.interactive !== false;
        // hit test against group foreground
        if (ix && fore && group.stroke && hitForeground(context, group, cx, cy)) {
            context.restore();
            return group;
        }
        // hit test against contained marks
        hit = pickVisit(group, (mark)=>pickMark(mark, dx, dy) ? this.pick(mark, x, y, dx, dy) : null);
        // hit test against group background
        if (!hit && ix && (group.fill || !fore && group.stroke) && hitBackground(context, group, cx, cy)) hit = group;
        // restore state and return
        context.restore();
        return hit || null;
    });
}
function pickMark(mark, x, y) {
    return (mark.interactive !== false || mark.marktype === 'group') && mark.bounds && mark.bounds.contains(x, y);
}
var group = {
    type: 'group',
    tag: 'g',
    nested: false,
    attr: attr$5,
    bound: bound$5,
    draw: draw$4,
    pick: pick,
    isect: intersectRect,
    content: content,
    background: background,
    foreground: foreground
};
var metadata = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlns:xlink': 'http://www.w3.org/1999/xlink',
    'version': '1.1'
};
function getImage(item, renderer) {
    var image = item.image;
    if (!image || item.url && item.url !== image.url) {
        image = {
            complete: false,
            width: 0,
            height: 0
        };
        renderer.loadImage(item.url).then((image)=>{
            item.image = image;
            item.image.url = item.url;
        });
    }
    return image;
}
function imageWidth(item, image) {
    return item.width != null ? item.width : !image || !image.width ? 0 : item.aspect !== false && item.height ? item.height * image.width / image.height : image.width;
}
function imageHeight(item, image) {
    return item.height != null ? item.height : !image || !image.height ? 0 : item.aspect !== false && item.width ? item.width * image.height / image.width : image.height;
}
function imageXOffset(align, w) {
    return align === 'center' ? w / 2 : align === 'right' ? w : 0;
}
function imageYOffset(baseline, h) {
    return baseline === 'middle' ? h / 2 : baseline === 'bottom' ? h : 0;
}
function attr$4(emit, item, renderer) {
    const img = getImage(item, renderer), w = imageWidth(item, img), h = imageHeight(item, img), x = (item.x || 0) - imageXOffset(item.align, w), y = (item.y || 0) - imageYOffset(item.baseline, h), i = !img.src && img.toDataURL ? img.toDataURL() : img.src || '';
    emit('href', i, metadata['xmlns:xlink'], 'xlink:href');
    emit('transform', translate(x, y));
    emit('width', w);
    emit('height', h);
    emit('preserveAspectRatio', item.aspect === false ? 'none' : 'xMidYMid');
}
function bound$4(bounds, item) {
    const img = item.image, w = imageWidth(item, img), h = imageHeight(item, img), x = (item.x || 0) - imageXOffset(item.align, w), y = (item.y || 0) - imageYOffset(item.baseline, h);
    return bounds.set(x, y, x + w, y + h);
}
function draw$3(context, scene, bounds) {
    visit(scene, (item)=>{
        if (bounds && !bounds.intersects(item.bounds)) return; // bounds check
        const img = getImage(item, this);
        let w = imageWidth(item, img);
        let h = imageHeight(item, img);
        if (w === 0 || h === 0) return; // early exit
        let x = (item.x || 0) - imageXOffset(item.align, w), y = (item.y || 0) - imageYOffset(item.baseline, h), opacity, ar0, ar1, t;
        if (item.aspect !== false) {
            ar0 = img.width / img.height;
            ar1 = item.width / item.height;
            if (ar0 === ar0 && ar1 === ar1 && ar0 !== ar1) {
                if (ar1 < ar0) {
                    t = w / ar0;
                    y += (h - t) / 2;
                    h = t;
                } else {
                    t = h * ar0;
                    x += (w - t) / 2;
                    w = t;
                }
            }
        }
        if (img.complete || img.toDataURL) {
            blend(context, item);
            context.globalAlpha = (opacity = item.opacity) != null ? opacity : 1;
            context.imageSmoothingEnabled = item.smooth !== false;
            context.drawImage(img, x, y, w, h);
        }
    });
}
var image = {
    type: 'image',
    tag: 'image',
    nested: false,
    attr: attr$4,
    bound: bound$4,
    draw: draw$3,
    pick: pick$1(),
    isect: (0, _vegaUtil.truthy),
    // bounds check is sufficient
    get: getImage,
    xOffset: imageXOffset,
    yOffset: imageYOffset
};
var line = markMultiItemPath('line', line$1, pickLine);
function attr$3(emit, item) {
    var sx = item.scaleX || 1, sy = item.scaleY || 1;
    if (sx !== 1 || sy !== 1) emit('vector-effect', 'non-scaling-stroke');
    emit('transform', transformItem(item));
    emit('d', item.path);
}
function path$1(context, item) {
    var path = item.path;
    if (path == null) return true;
    var x = item.x || 0, y = item.y || 0, sx = item.scaleX || 1, sy = item.scaleY || 1, a = (item.angle || 0) * DegToRad, cache = item.pathCache;
    if (!cache || cache.path !== path) (item.pathCache = cache = parse(path)).path = path;
    if (a && context.rotate && context.translate) {
        context.translate(x, y);
        context.rotate(a);
        pathRender(context, cache, 0, 0, sx, sy);
        context.rotate(-a);
        context.translate(-x, -y);
    } else pathRender(context, cache, x, y, sx, sy);
}
function bound$3(bounds, item) {
    return path$1(boundContext(bounds, item.angle), item) ? bounds.set(0, 0, 0, 0) : boundStroke(bounds, item, true);
}
var path$2 = {
    type: 'path',
    tag: 'path',
    nested: false,
    attr: attr$3,
    bound: bound$3,
    draw: drawAll(path$1),
    pick: pickPath(path$1),
    isect: intersectPath(path$1)
};
function attr$2(emit, item) {
    emit('d', rectangle(null, item));
}
function bound$2(bounds, item) {
    var x, y;
    return boundStroke(bounds.set(x = item.x || 0, y = item.y || 0, x + item.width || 0, y + item.height || 0), item);
}
function draw$2(context, item) {
    context.beginPath();
    rectangle(context, item);
}
var rect = {
    type: 'rect',
    tag: 'path',
    nested: false,
    attr: attr$2,
    bound: bound$2,
    draw: drawAll(draw$2),
    pick: pickPath(draw$2),
    isect: intersectRect
};
function attr$1(emit, item) {
    emit('transform', translateItem(item));
    emit('x2', item.x2 != null ? item.x2 - (item.x || 0) : 0);
    emit('y2', item.y2 != null ? item.y2 - (item.y || 0) : 0);
}
function bound$1(bounds, item) {
    var x1, y1;
    return boundStroke(bounds.set(x1 = item.x || 0, y1 = item.y || 0, item.x2 != null ? item.x2 : x1, item.y2 != null ? item.y2 : y1), item);
}
function path(context, item, opacity) {
    var x1, y1, x2, y2;
    if (item.stroke && stroke(context, item, opacity)) {
        x1 = item.x || 0;
        y1 = item.y || 0;
        x2 = item.x2 != null ? item.x2 : x1;
        y2 = item.y2 != null ? item.y2 : y1;
        context.beginPath();
        context.moveTo(x1, y1);
        context.lineTo(x2, y2);
        return true;
    }
    return false;
}
function draw$1(context, scene, bounds) {
    visit(scene, (item)=>{
        if (bounds && !bounds.intersects(item.bounds)) return; // bounds check
        var opacity = item.opacity == null ? 1 : item.opacity;
        if (opacity && path(context, item, opacity)) {
            blend(context, item);
            context.stroke();
        }
    });
}
function hit$1(context, item, x, y) {
    if (!context.isPointInStroke) return false;
    return path(context, item, 1) && context.isPointInStroke(x, y);
}
var rule = {
    type: 'rule',
    tag: 'line',
    nested: false,
    attr: attr$1,
    bound: bound$1,
    draw: draw$1,
    pick: pick$1(hit$1),
    isect: intersectRule
};
var shape = markItemPath('shape', shape$1);
var symbol = markItemPath('symbol', symbol$1, intersectPoint);
// memoize text width measurement
const widthCache = (0, _vegaUtil.lruCache)();
var textMetrics = {
    height: fontSize,
    measureWidth: measureWidth,
    estimateWidth: estimateWidth,
    width: estimateWidth,
    canvas: useCanvas
};
useCanvas(true);
function useCanvas(use) {
    textMetrics.width = use && context ? measureWidth : estimateWidth;
}
// make simple estimate if no canvas is available
function estimateWidth(item, text) {
    return _estimateWidth(textValue(item, text), fontSize(item));
}
function _estimateWidth(text, currentFontHeight) {
    return ~~(0.8 * text.length * currentFontHeight);
}
// measure text width if canvas is available
function measureWidth(item, text) {
    return fontSize(item) <= 0 || !(text = textValue(item, text)) ? 0 : _measureWidth(text, font(item));
}
function _measureWidth(text, currentFont) {
    const key = `(${currentFont}) ${text}`;
    let width = widthCache.get(key);
    if (width === undefined) {
        context.font = currentFont;
        width = context.measureText(text).width;
        widthCache.set(key, width);
    }
    return width;
}
function fontSize(item) {
    return item.fontSize != null ? +item.fontSize || 0 : 11;
}
function lineHeight(item) {
    return item.lineHeight != null ? item.lineHeight : fontSize(item) + 2;
}
function lineArray(_) {
    return (0, _vegaUtil.isArray)(_) ? _.length > 1 ? _ : _[0] : _;
}
function textLines(item) {
    return lineArray(item.lineBreak && item.text && !(0, _vegaUtil.isArray)(item.text) ? item.text.split(item.lineBreak) : item.text);
}
function multiLineOffset(item) {
    const tl = textLines(item);
    return ((0, _vegaUtil.isArray)(tl) ? tl.length - 1 : 0) * lineHeight(item);
}
function textValue(item, line) {
    const text = line == null ? '' : (line + '').trim();
    return item.limit > 0 && text.length ? truncate(item, text) : text;
}
function widthGetter(item) {
    if (textMetrics.width === measureWidth) {
        // we are using canvas
        const currentFont = font(item);
        return (text)=>_measureWidth(text, currentFont);
    } else if (textMetrics.width === estimateWidth) {
        // we are relying on estimates
        const currentFontHeight = fontSize(item);
        return (text)=>_estimateWidth(text, currentFontHeight);
    } else // User defined textMetrics.width function in use (e.g. vl-convert)
    return (text)=>textMetrics.width(item, text);
}
function truncate(item, text) {
    var limit = +item.limit, width = widthGetter(item);
    if (width(text) < limit) return text;
    var ellipsis = item.ellipsis || '\u2026', rtl = item.dir === 'rtl', lo = 0, hi = text.length, mid;
    limit -= width(ellipsis);
    if (rtl) {
        while(lo < hi){
            mid = lo + hi >>> 1;
            if (width(text.slice(mid)) > limit) lo = mid + 1;
            else hi = mid;
        }
        return ellipsis + text.slice(lo);
    } else {
        while(lo < hi){
            mid = 1 + (lo + hi >>> 1);
            if (width(text.slice(0, mid)) < limit) lo = mid;
            else hi = mid - 1;
        }
        return text.slice(0, lo) + ellipsis;
    }
}
function fontFamily(item, quote) {
    var font = item.font;
    return (quote && font ? String(font).replace(/"/g, '\'') : font) || 'sans-serif';
}
function font(item, quote) {
    return '' + (item.fontStyle ? item.fontStyle + ' ' : '') + (item.fontVariant ? item.fontVariant + ' ' : '') + (item.fontWeight ? item.fontWeight + ' ' : '') + fontSize(item) + 'px ' + fontFamily(item, quote);
}
function offset(item) {
    // perform our own font baseline calculation
    // why? not all browsers support SVG 1.1 'alignment-baseline' :(
    // this also ensures consistent layout across renderers
    var baseline = item.baseline, h = fontSize(item);
    return Math.round(baseline === 'top' ? 0.79 * h : baseline === 'middle' ? 0.30 * h : baseline === 'bottom' ? -0.21 * h : baseline === 'line-top' ? 0.29 * h + 0.5 * lineHeight(item) : baseline === 'line-bottom' ? 0.29 * h - 0.5 * lineHeight(item) : 0);
}
const textAlign = {
    'left': 'start',
    'center': 'middle',
    'right': 'end'
};
const tempBounds = new Bounds();
function anchorPoint(item) {
    var x = item.x || 0, y = item.y || 0, r = item.radius || 0, t;
    if (r) {
        t = (item.theta || 0) - HalfPi;
        x += r * Math.cos(t);
        y += r * Math.sin(t);
    }
    tempBounds.x1 = x;
    tempBounds.y1 = y;
    return tempBounds;
}
function attr(emit, item) {
    var dx = item.dx || 0, dy = (item.dy || 0) + offset(item), p = anchorPoint(item), x = p.x1, y = p.y1, a = item.angle || 0, t;
    emit('text-anchor', textAlign[item.align] || 'start');
    if (a) {
        t = translate(x, y) + ' ' + rotate(a);
        if (dx || dy) t += ' ' + translate(dx, dy);
    } else t = translate(x + dx, y + dy);
    emit('transform', t);
}
function bound(bounds, item, mode) {
    var h = textMetrics.height(item), a = item.align, p = anchorPoint(item), x = p.x1, y = p.y1, dx = item.dx || 0, dy = (item.dy || 0) + offset(item) - Math.round(0.8 * h), // use 4/5 offset
    tl = textLines(item), w;
    // get dimensions
    if ((0, _vegaUtil.isArray)(tl)) {
        // multi-line text
        h += lineHeight(item) * (tl.length - 1);
        w = tl.reduce((w, t)=>Math.max(w, textMetrics.width(item, t)), 0);
    } else // single-line text
    w = textMetrics.width(item, tl);
    // horizontal alignment
    if (a === 'center') dx -= w / 2;
    else if (a === 'right') dx -= w;
    bounds.set(dx += x, dy += y, dx + w, dy + h);
    if (item.angle && !mode) bounds.rotate(item.angle * DegToRad, x, y);
    else if (mode === 2) return bounds.rotatedPoints(item.angle * DegToRad, x, y);
    return bounds;
}
function draw(context, scene, bounds) {
    visit(scene, (item)=>{
        var opacity = item.opacity == null ? 1 : item.opacity, p, x, y, i, lh, tl, str;
        if (bounds && !bounds.intersects(item.bounds) || // bounds check
        opacity === 0 || item.fontSize <= 0 || item.text == null || item.text.length === 0) return;
        context.font = font(item);
        context.textAlign = item.align || 'left';
        p = anchorPoint(item);
        x = p.x1, y = p.y1;
        if (item.angle) {
            context.save();
            context.translate(x, y);
            context.rotate(item.angle * DegToRad);
            x = y = 0; // reset x, y
        }
        x += item.dx || 0;
        y += (item.dy || 0) + offset(item);
        tl = textLines(item);
        blend(context, item);
        if ((0, _vegaUtil.isArray)(tl)) {
            lh = lineHeight(item);
            for(i = 0; i < tl.length; ++i){
                str = textValue(item, tl[i]);
                if (item.fill && fill(context, item, opacity)) context.fillText(str, x, y);
                if (item.stroke && stroke(context, item, opacity)) context.strokeText(str, x, y);
                y += lh;
            }
        } else {
            str = textValue(item, tl);
            if (item.fill && fill(context, item, opacity)) context.fillText(str, x, y);
            if (item.stroke && stroke(context, item, opacity)) context.strokeText(str, x, y);
        }
        if (item.angle) context.restore();
    });
}
function hit(context, item, x, y, gx, gy) {
    if (item.fontSize <= 0) return false;
    if (!item.angle) return true; // bounds sufficient if no rotation
    // project point into space of unrotated bounds
    var p = anchorPoint(item), ax = p.x1, ay = p.y1, b = bound(tempBounds, item, 1), a = -item.angle * DegToRad, cos = Math.cos(a), sin = Math.sin(a), px = cos * gx - sin * gy + (ax - cos * ax + sin * ay), py = sin * gx + cos * gy + (ay - sin * ax - cos * ay);
    return b.contains(px, py);
}
function intersectText(item, box) {
    const p = bound(tempBounds, item, 2);
    return intersectBoxLine(box, p[0], p[1], p[2], p[3]) || intersectBoxLine(box, p[0], p[1], p[4], p[5]) || intersectBoxLine(box, p[4], p[5], p[6], p[7]) || intersectBoxLine(box, p[2], p[3], p[6], p[7]);
}
var text = {
    type: 'text',
    tag: 'text',
    nested: false,
    attr: attr,
    bound: bound,
    draw: draw,
    pick: pick$1(hit),
    isect: intersectText
};
var trail = markMultiItemPath('trail', trail$1, pickTrail);
var Marks = {
    arc: arc,
    area: area,
    group: group,
    image: image,
    line: line,
    path: path$2,
    rect: rect,
    rule: rule,
    shape: shape,
    symbol: symbol,
    text: text,
    trail: trail
};
function boundItem(item, func, opt) {
    var type = Marks[item.mark.marktype], bound = func || type.bound;
    if (type.nested) item = item.mark;
    return bound(item.bounds || (item.bounds = new Bounds()), item, opt);
}
var DUMMY = {
    mark: null
};
function boundMark(mark, bounds, opt) {
    var type = Marks[mark.marktype], bound = type.bound, items = mark.items, hasItems = items && items.length, i, n, item, b;
    if (type.nested) {
        if (hasItems) item = items[0];
        else {
            // no items, fake it
            DUMMY.mark = mark;
            item = DUMMY;
        }
        b = boundItem(item, bound, opt);
        bounds = bounds && bounds.union(b) || b;
        return bounds;
    }
    bounds = bounds || mark.bounds && mark.bounds.clear() || new Bounds();
    if (hasItems) for(i = 0, n = items.length; i < n; ++i)bounds.union(boundItem(items[i], bound, opt));
    return mark.bounds = bounds;
}
const keys = [
    'marktype',
    'name',
    'role',
    'interactive',
    'clip',
    'items',
    'zindex',
    'x',
    'y',
    'width',
    'height',
    'align',
    'baseline',
    // layout
    'fill',
    'fillOpacity',
    'opacity',
    'blend',
    // fill
    'stroke',
    'strokeOpacity',
    'strokeWidth',
    'strokeCap',
    // stroke
    'strokeDash',
    'strokeDashOffset',
    // stroke dash
    'strokeForeground',
    'strokeOffset',
    // group
    'startAngle',
    'endAngle',
    'innerRadius',
    'outerRadius',
    // arc
    'cornerRadius',
    'padAngle',
    // arc, rect
    'cornerRadiusTopLeft',
    'cornerRadiusTopRight',
    // rect, group
    'cornerRadiusBottomLeft',
    'cornerRadiusBottomRight',
    'interpolate',
    'tension',
    'orient',
    'defined',
    // area, line
    'url',
    'aspect',
    'smooth',
    // image
    'path',
    'scaleX',
    'scaleY',
    // path
    'x2',
    'y2',
    // rule
    'size',
    'shape',
    // symbol
    'text',
    'angle',
    'theta',
    'radius',
    'dir',
    'dx',
    'dy',
    // text
    'ellipsis',
    'limit',
    'lineBreak',
    'lineHeight',
    'font',
    'fontSize',
    'fontWeight',
    'fontStyle',
    'fontVariant',
    // font
    'description',
    'aria',
    'ariaRole',
    'ariaRoleDescription' // aria
];
function sceneToJSON(scene, indent) {
    return JSON.stringify(scene, keys, indent);
}
function sceneFromJSON(json) {
    const scene = typeof json === 'string' ? JSON.parse(json) : json;
    return initialize(scene);
}
function initialize(scene) {
    var type = scene.marktype, items = scene.items, parent, i, n;
    if (items) for(i = 0, n = items.length; i < n; ++i){
        parent = type ? 'mark' : 'group';
        items[i][parent] = scene;
        if (items[i].zindex) items[i][parent].zdirty = true;
        if ('group' === (type || parent)) initialize(items[i]);
    }
    if (type) boundMark(scene);
    return scene;
}
class Scenegraph {
    constructor(scene){
        if (arguments.length) this.root = sceneFromJSON(scene);
        else {
            this.root = createMark({
                marktype: 'group',
                name: 'root',
                role: 'frame'
            });
            this.root.items = [
                new GroupItem(this.root)
            ];
        }
    }
    toJSON(indent) {
        return sceneToJSON(this.root, indent || 0);
    }
    mark(markdef, group, index) {
        group = group || this.root.items[0];
        const mark = createMark(markdef, group);
        group.items[index] = mark;
        if (mark.zindex) mark.group.zdirty = true;
        return mark;
    }
}
function createMark(def, group) {
    const mark = {
        bounds: new Bounds(),
        clip: !!def.clip,
        group: group,
        interactive: def.interactive === false ? false : true,
        items: [],
        marktype: def.marktype,
        name: def.name || undefined,
        role: def.role || undefined,
        zindex: def.zindex || 0
    };
    // add accessibility properties if defined
    if (def.aria != null) mark.aria = def.aria;
    if (def.description) mark.description = def.description;
    return mark;
}
// create a new DOM element
function domCreate(doc, tag, ns) {
    if (!doc && typeof document !== 'undefined' && document.createElement) doc = document;
    return doc ? ns ? doc.createElementNS(ns, tag) : doc.createElement(tag) : null;
}
// find first child element with matching tag
function domFind(el, tag) {
    tag = tag.toLowerCase();
    var nodes = el.childNodes, i = 0, n = nodes.length;
    for(; i < n; ++i)if (nodes[i].tagName.toLowerCase() === tag) return nodes[i];
}
// retrieve child element at given index
// create & insert if doesn't exist or if tags do not match
function domChild(el, index, tag, ns) {
    var a = el.childNodes[index], b;
    if (!a || a.tagName.toLowerCase() !== tag.toLowerCase()) {
        b = a || null;
        a = domCreate(el.ownerDocument, tag, ns);
        el.insertBefore(a, b);
    }
    return a;
}
// remove all child elements at or above the given index
function domClear(el, index) {
    var nodes = el.childNodes, curr = nodes.length;
    while(curr > index)el.removeChild(nodes[--curr]);
    return el;
}
// generate css class name for mark
function cssClass(mark) {
    return 'mark-' + mark.marktype + (mark.role ? ' role-' + mark.role : '') + (mark.name ? ' ' + mark.name : '');
}
function point(event, el) {
    const rect = el.getBoundingClientRect();
    return [
        event.clientX - rect.left - (el.clientLeft || 0),
        event.clientY - rect.top - (el.clientTop || 0)
    ];
}
function resolveItem(item, event, el, origin) {
    var mark = item && item.mark, mdef, p;
    if (mark && (mdef = Marks[mark.marktype]).tip) {
        p = point(event, el);
        p[0] -= origin[0];
        p[1] -= origin[1];
        while(item = item.mark.group){
            p[0] -= item.x || 0;
            p[1] -= item.y || 0;
        }
        item = mdef.tip(mark.items, p);
    }
    return item;
}
class Handler {
    /**
   * Create a new Handler instance.
   * @param {object} [customLoader] - Optional loader instance for
   *   href URL sanitization. If not specified, a standard loader
   *   instance will be generated.
   * @param {function} [customTooltip] - Optional tooltip handler
   *   function for custom tooltip display.
   * @constructor
   */ constructor(customLoader, customTooltip){
        this._active = null;
        this._handlers = {};
        this._loader = customLoader || (0, _vegaLoader.loader)();
        this._tooltip = customTooltip || defaultTooltip;
    }
    /**
   * Initialize a new Handler instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {object} [obj] - Optional context object that should serve as
   *   the "this" context for event callbacks.
   * @return {Handler} - This handler instance.
   */ initialize(el, origin, obj) {
        this._el = el;
        this._obj = obj || null;
        return this.origin(origin);
    }
    /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */ element() {
        return this._el;
    }
    /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */ canvas() {
        return this._el && this._el.firstChild;
    }
    /**
   * Get / set the origin coordinates of the visualization.
   */ origin(origin) {
        if (arguments.length) {
            this._origin = origin || [
                0,
                0
            ];
            return this;
        } else return this._origin.slice();
    }
    /**
   * Get / set the scenegraph root.
   */ scene(scene) {
        if (!arguments.length) return this._scene;
        this._scene = scene;
        return this;
    }
    /**
   * Add an event handler. Subclasses should override this method.
   */ on() {}
    /**
   * Remove an event handler. Subclasses should override this method.
   */ off() {}
    /**
   * Utility method for finding the array index of an event handler.
   * @param {Array} h - An array of registered event handlers.
   * @param {string} type - The event type.
   * @param {function} handler - The event handler instance to find.
   * @return {number} - The handler's array index or -1 if not registered.
   */ _handlerIndex(h, type, handler) {
        for(let i = h ? h.length : 0; --i >= 0;){
            if (h[i].type === type && (!handler || h[i].handler === handler)) return i;
        }
        return -1;
    }
    /**
   * Returns an array with registered event handlers.
   * @param {string} [type] - The event type to query. Any annotations
   *   are ignored; for example, for the argument "click.foo", ".foo" will
   *   be ignored and the method returns all "click" handlers. If type is
   *   null or unspecified, this method returns handlers for all types.
   * @return {Array} - A new array containing all registered event handlers.
   */ handlers(type) {
        const h = this._handlers, a = [];
        if (type) a.push(...h[this.eventName(type)]);
        else for(const k in h)a.push(...h[k]);
        return a;
    }
    /**
   * Parses an event name string to return the specific event type.
   * For example, given "click.foo" returns "click"
   * @param {string} name - The input event type string.
   * @return {string} - A string with the event type only.
   */ eventName(name) {
        const i = name.indexOf('.');
        return i < 0 ? name : name.slice(0, i);
    }
    /**
   * Handle hyperlink navigation in response to an item.href value.
   * @param {Event} event - The event triggering hyperlink navigation.
   * @param {Item} item - The scenegraph item.
   * @param {string} href - The URL to navigate to.
   */ handleHref(event, item, href) {
        this._loader.sanitize(href, {
            context: 'href'
        }).then((opt)=>{
            const e = new MouseEvent(event.type, event), a = domCreate(null, 'a');
            for(const name in opt)a.setAttribute(name, opt[name]);
            a.dispatchEvent(e);
        }).catch(()=>{});
    }
    /**
   * Handle tooltip display in response to an item.tooltip value.
   * @param {Event} event - The event triggering tooltip display.
   * @param {Item} item - The scenegraph item.
   * @param {boolean} show - A boolean flag indicating whether
   *   to show or hide a tooltip for the given item.
   */ handleTooltip(event, item, show) {
        if (item && item.tooltip != null) {
            item = resolveItem(item, event, this.canvas(), this._origin);
            const value = show && item && item.tooltip || null;
            this._tooltip.call(this._obj, this, event, item, value);
        }
    }
    /**
   * Returns the size of a scenegraph item and its position relative
   * to the viewport.
   * @param {Item} item - The scenegraph item.
   * @return {object} - A bounding box object (compatible with the
   *   DOMRect type) consisting of x, y, width, heigh, top, left,
   *   right, and bottom properties.
   */ getItemBoundingClientRect(item) {
        const el = this.canvas();
        if (!el) return;
        const rect = el.getBoundingClientRect(), origin = this._origin, bounds = item.bounds, width = bounds.width(), height = bounds.height();
        let x = bounds.x1 + origin[0] + rect.left, y = bounds.y1 + origin[1] + rect.top;
        // translate coordinate for each parent group
        while(item.mark && (item = item.mark.group)){
            x += item.x || 0;
            y += item.y || 0;
        }
        // return DOMRect-compatible bounding box
        return {
            x,
            y,
            width,
            height,
            left: x,
            top: y,
            right: x + width,
            bottom: y + height
        };
    }
}
// The default tooltip display handler.
// Sets the HTML title attribute on the visualization container.
function defaultTooltip(handler, event, item, value) {
    handler.element().setAttribute('title', value || '');
}
class Renderer {
    /**
   * Create a new Renderer instance.
   * @param {object} [loader] - Optional loader instance for
   *   image and href URL sanitization. If not specified, a
   *   standard loader instance will be generated.
   * @constructor
   */ constructor(loader){
        this._el = null;
        this._bgcolor = null;
        this._loader = new ResourceLoader(loader);
    }
    /**
   * Initialize a new Renderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance.
   */ initialize(el, width, height, origin, scaleFactor) {
        this._el = el;
        return this.resize(width, height, origin, scaleFactor);
    }
    /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */ element() {
        return this._el;
    }
    /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */ canvas() {
        return this._el && this._el.firstChild;
    }
    /**
   * Get / set the background color.
   */ background(bgcolor) {
        if (arguments.length === 0) return this._bgcolor;
        this._bgcolor = bgcolor;
        return this;
    }
    /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance;
   */ resize(width, height, origin, scaleFactor) {
        this._width = width;
        this._height = height;
        this._origin = origin || [
            0,
            0
        ];
        this._scale = scaleFactor || 1;
        return this;
    }
    /**
   * Report a dirty item whose bounds should be redrawn.
   * This base class method does nothing. Subclasses that perform
   * incremental should implement this method.
   * @param {Item} item - The dirty item whose bounds should be redrawn.
   */ dirty() {}
    /**
   * Render an input scenegraph, potentially with a set of dirty items.
   * This method will perform an immediate rendering with available resources.
   * The renderer may also need to perform image loading to perform a complete
   * render. This process can lead to asynchronous re-rendering of the scene
   * after this method returns. To receive notification when rendering is
   * complete, use the renderAsync method instead.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Renderer} - This renderer instance.
   */ render(scene, markTypes) {
        const r = this;
        // bind arguments into a render call, and cache it
        // this function may be subsequently called for async redraw
        r._call = function() {
            r._render(scene, markTypes);
        };
        // invoke the renderer
        r._call();
        // clear the cached call for garbage collection
        // async redraws will stash their own copy
        r._call = null;
        return r;
    }
    /**
   * Internal rendering method. Renderer subclasses should override this
   * method to actually perform rendering.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ _render() {
    // subclasses to override
    }
    /**
   * Asynchronous rendering method. Similar to render, but returns a Promise
   * that resolves when all rendering is completed. Sometimes a renderer must
   * perform image loading to get a complete rendering. The returned
   * Promise will not resolve until this process completes.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   * @return {Promise} - A Promise that resolves when rendering is complete.
   */ renderAsync(scene, markTypes) {
        const r = this.render(scene, markTypes);
        return this._ready ? this._ready.then(()=>r) : Promise.resolve(r);
    }
    /**
   * Internal method for asynchronous resource loading.
   * Proxies method calls to the ImageLoader, and tracks loading
   * progress to invoke a re-render once complete.
   * @param {string} method - The method name to invoke on the ImageLoader.
   * @param {string} uri - The URI for the requested resource.
   * @return {Promise} - A Promise that resolves to the requested resource.
   */ _load(method, uri) {
        var r = this, p = r._loader[method](uri);
        if (!r._ready) {
            // re-render the scene when loading completes
            const call = r._call;
            r._ready = r._loader.ready().then((redraw)=>{
                if (redraw) call();
                r._ready = null;
            });
        }
        return p;
    }
    /**
   * Sanitize a URL to include as a hyperlink in the rendered scene.
   * This method proxies a call to ImageLoader.sanitizeURL, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string to sanitize.
   * @return {Promise} - A Promise that resolves to the sanitized URL.
   */ sanitizeURL(uri) {
        return this._load('sanitizeURL', uri);
    }
    /**
   * Requests an image to include in the rendered scene.
   * This method proxies a call to ImageLoader.loadImage, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string of the image.
   * @return {Promise} - A Promise that resolves to the loaded Image.
   */ loadImage(uri) {
        return this._load('loadImage', uri);
    }
}
const KeyDownEvent = 'keydown';
const KeyPressEvent = 'keypress';
const KeyUpEvent = 'keyup';
const DragEnterEvent = 'dragenter';
const DragLeaveEvent = 'dragleave';
const DragOverEvent = 'dragover';
const PointerDownEvent = 'pointerdown';
const PointerUpEvent = 'pointerup';
const PointerMoveEvent = 'pointermove';
const PointerOutEvent = 'pointerout';
const PointerOverEvent = 'pointerover';
const MouseDownEvent = 'mousedown';
const MouseUpEvent = 'mouseup';
const MouseMoveEvent = 'mousemove';
const MouseOutEvent = 'mouseout';
const MouseOverEvent = 'mouseover';
const ClickEvent = 'click';
const DoubleClickEvent = 'dblclick';
const WheelEvent = 'wheel';
const MouseWheelEvent = 'mousewheel';
const TouchStartEvent = 'touchstart';
const TouchMoveEvent = 'touchmove';
const TouchEndEvent = 'touchend';
const Events = [
    KeyDownEvent,
    KeyPressEvent,
    KeyUpEvent,
    DragEnterEvent,
    DragLeaveEvent,
    DragOverEvent,
    PointerDownEvent,
    PointerUpEvent,
    PointerMoveEvent,
    PointerOutEvent,
    PointerOverEvent,
    MouseDownEvent,
    MouseUpEvent,
    MouseMoveEvent,
    MouseOutEvent,
    MouseOverEvent,
    ClickEvent,
    DoubleClickEvent,
    WheelEvent,
    MouseWheelEvent,
    TouchStartEvent,
    TouchMoveEvent,
    TouchEndEvent
];
const TooltipShowEvent = PointerMoveEvent;
const TooltipHideEvent = MouseOutEvent;
const HrefEvent = ClickEvent;
class CanvasHandler extends Handler {
    constructor(loader, tooltip){
        super(loader, tooltip);
        this._down = null;
        this._touch = null;
        this._first = true;
        this._events = {};
        // supported events
        this.events = Events;
        this.pointermove = move([
            PointerMoveEvent,
            MouseMoveEvent
        ], [
            PointerOverEvent,
            MouseOverEvent
        ], [
            PointerOutEvent,
            MouseOutEvent
        ]);
        this.dragover = move([
            DragOverEvent
        ], [
            DragEnterEvent
        ], [
            DragLeaveEvent
        ]), this.pointerout = inactive([
            PointerOutEvent,
            MouseOutEvent
        ]);
        this.dragleave = inactive([
            DragLeaveEvent
        ]);
    }
    initialize(el, origin, obj) {
        this._canvas = el && domFind(el, 'canvas');
        // add minimal events required for proper state management
        [
            ClickEvent,
            MouseDownEvent,
            PointerDownEvent,
            PointerMoveEvent,
            PointerOutEvent,
            DragLeaveEvent
        ].forEach((type)=>eventListenerCheck(this, type));
        return super.initialize(el, origin, obj);
    }
    // return the backing canvas instance
    canvas() {
        return this._canvas;
    }
    // retrieve the current canvas context
    context() {
        return this._canvas.getContext('2d');
    }
    // to keep old versions of firefox happy
    DOMMouseScroll(evt) {
        this.fire(MouseWheelEvent, evt);
    }
    pointerdown(evt) {
        this._down = this._active;
        this.fire(PointerDownEvent, evt);
    }
    mousedown(evt) {
        this._down = this._active;
        this.fire(MouseDownEvent, evt);
    }
    click(evt) {
        if (this._down === this._active) {
            this.fire(ClickEvent, evt);
            this._down = null;
        }
    }
    touchstart(evt) {
        this._touch = this.pickEvent(evt.changedTouches[0]);
        if (this._first) {
            this._active = this._touch;
            this._first = false;
        }
        this.fire(TouchStartEvent, evt, true);
    }
    touchmove(evt) {
        this.fire(TouchMoveEvent, evt, true);
    }
    touchend(evt) {
        this.fire(TouchEndEvent, evt, true);
        this._touch = null;
    }
    // fire an event
    fire(type, evt, touch) {
        const a = touch ? this._touch : this._active, h = this._handlers[type];
        // set event type relative to scenegraph items
        evt.vegaType = type;
        // handle hyperlinks and tooltips first
        if (type === HrefEvent && a && a.href) this.handleHref(evt, a, a.href);
        else if (type === TooltipShowEvent || type === TooltipHideEvent) this.handleTooltip(evt, a, type !== TooltipHideEvent);
        // invoke all registered handlers
        if (h) for(let i = 0, len = h.length; i < len; ++i)h[i].handler.call(this._obj, evt, a);
    }
    // add an event handler
    on(type, handler) {
        const name = this.eventName(type), h = this._handlers, i = this._handlerIndex(h[name], type, handler);
        if (i < 0) {
            eventListenerCheck(this, type);
            (h[name] || (h[name] = [])).push({
                type: type,
                handler: handler
            });
        }
        return this;
    }
    // remove an event handler
    off(type, handler) {
        const name = this.eventName(type), h = this._handlers[name], i = this._handlerIndex(h, type, handler);
        if (i >= 0) h.splice(i, 1);
        return this;
    }
    pickEvent(evt) {
        const p = point(evt, this._canvas), o = this._origin;
        return this.pick(this._scene, p[0], p[1], p[0] - o[0], p[1] - o[1]);
    }
    // find the scenegraph item at the current pointer position
    // x, y -- the absolute x, y pointer coordinates on the canvas element
    // gx, gy -- the relative coordinates within the current group
    pick(scene, x, y, gx, gy) {
        const g = this.context(), mark = Marks[scene.marktype];
        return mark.pick.call(this, g, scene, x, y, gx, gy);
    }
}
const eventBundle = (type)=>type === TouchStartEvent || type === TouchMoveEvent || type === TouchEndEvent ? [
        TouchStartEvent,
        TouchMoveEvent,
        TouchEndEvent
    ] : [
        type
    ];
// lazily add listeners to the canvas as needed
function eventListenerCheck(handler, type) {
    eventBundle(type).forEach((_)=>addEventListener(handler, _));
}
function addEventListener(handler, type) {
    const canvas = handler.canvas();
    if (canvas && !handler._events[type]) {
        handler._events[type] = 1;
        canvas.addEventListener(type, handler[type] ? (evt)=>handler[type](evt) : (evt)=>handler.fire(type, evt));
    }
}
function fireAll(handler, types, event) {
    types.forEach((type)=>handler.fire(type, event));
}
function move(moveEvents, overEvents, outEvents) {
    return function(evt) {
        const a = this._active, p = this.pickEvent(evt);
        if (p === a) // active item and picked item are the same
        fireAll(this, moveEvents, evt); // fire move
        else {
            // active item and picked item are different
            if (!a || !a.exit) // fire out for prior active item
            // suppress if active item was removed from scene
            fireAll(this, outEvents, evt);
            this._active = p; // set new active item
            fireAll(this, overEvents, evt); // fire over for new active item
            fireAll(this, moveEvents, evt); // fire move for new active item
        }
    };
}
function inactive(types) {
    return function(evt) {
        fireAll(this, types, evt);
        this._active = null;
    };
}
function devicePixelRatio() {
    return typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
}
function resize(canvas, width, height, origin, scaleFactor, opt) {
    const inDOM = typeof HTMLElement !== 'undefined' && canvas instanceof HTMLElement && canvas.parentNode != null, context = canvas.getContext('2d'), ratio = inDOM ? devicePixelRatio() : scaleFactor;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    for(const key in opt)context[key] = opt[key];
    if (inDOM && ratio !== 1) {
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    context.pixelRatio = ratio;
    context.setTransform(ratio, 0, 0, ratio, ratio * origin[0], ratio * origin[1]);
    return canvas;
}
class CanvasRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._options = {};
        this._redraw = false;
        this._dirty = new Bounds();
        this._tempb = new Bounds();
    }
    initialize(el, width, height, origin, scaleFactor, options) {
        this._options = options || {};
        this._canvas = this._options.externalContext ? null : (0, _vegaCanvas.canvas)(1, 1, this._options.type); // instantiate a small canvas
        if (el && this._canvas) {
            domClear(el, 0).appendChild(this._canvas);
            this._canvas.setAttribute('class', 'marks');
        }
        // this method will invoke resize to size the canvas appropriately
        return super.initialize(el, width, height, origin, scaleFactor);
    }
    resize(width, height, origin, scaleFactor) {
        super.resize(width, height, origin, scaleFactor);
        if (this._canvas) // configure canvas size and transform
        resize(this._canvas, this._width, this._height, this._origin, this._scale, this._options.context);
        else {
            // external context needs to be scaled and positioned to origin
            const ctx = this._options.externalContext;
            if (!ctx) (0, _vegaUtil.error)('CanvasRenderer is missing a valid canvas or context');
            ctx.scale(this._scale, this._scale);
            ctx.translate(this._origin[0], this._origin[1]);
        }
        this._redraw = true;
        return this;
    }
    canvas() {
        return this._canvas;
    }
    context() {
        return this._options.externalContext || (this._canvas ? this._canvas.getContext('2d') : null);
    }
    dirty(item) {
        const b = this._tempb.clear().union(item.bounds);
        let g = item.mark.group;
        while(g){
            b.translate(g.x || 0, g.y || 0);
            g = g.mark.group;
        }
        this._dirty.union(b);
    }
    _render(scene, markTypes) {
        const g = this.context(), o = this._origin, w = this._width, h = this._height, db = this._dirty, vb = viewBounds(o, w, h);
        // setup
        g.save();
        const b = this._redraw || db.empty() ? (this._redraw = false, vb.expand(1)) : clipToBounds(g, vb.intersect(db), o);
        this.clear(-o[0], -o[1], w, h);
        // render
        this.draw(g, scene, b, markTypes);
        // takedown
        g.restore();
        db.clear();
        return this;
    }
    draw(ctx, scene, bounds, markTypes) {
        if (scene.marktype !== 'group' && markTypes != null && !markTypes.includes(scene.marktype)) return;
        const mark = Marks[scene.marktype];
        if (scene.clip) clip(ctx, scene);
        mark.draw.call(this, ctx, scene, bounds, markTypes);
        if (scene.clip) ctx.restore();
    }
    clear(x, y, w, h) {
        const opt = this._options, g = this.context();
        if (opt.type !== 'pdf' && !opt.externalContext) // calling clear rect voids vector output in pdf mode
        // and could remove external context content (#2615)
        g.clearRect(x, y, w, h);
        if (this._bgcolor != null) {
            g.fillStyle = this._bgcolor;
            g.fillRect(x, y, w, h);
        }
    }
}
const viewBounds = (origin, width, height)=>new Bounds().set(0, 0, width, height).translate(-origin[0], -origin[1]);
function clipToBounds(g, b, origin) {
    // expand bounds by 1 pixel, then round to pixel boundaries
    b.expand(1).round();
    // align to base pixel grid in case of non-integer scaling (#2425)
    if (g.pixelRatio % 1) b.scale(g.pixelRatio).round().scale(1 / g.pixelRatio);
    // to avoid artifacts translate if origin has fractional pixels
    b.translate(-(origin[0] % 1), -(origin[1] % 1));
    // set clip path
    g.beginPath();
    g.rect(b.x1, b.y1, b.width(), b.height());
    g.clip();
    return b;
}
class SVGHandler extends Handler {
    constructor(loader, tooltip){
        super(loader, tooltip);
        const h = this;
        h._hrefHandler = listener(h, (evt, item)=>{
            if (item && item.href) h.handleHref(evt, item, item.href);
        });
        h._tooltipHandler = listener(h, (evt, item)=>{
            h.handleTooltip(evt, item, evt.type !== TooltipHideEvent);
        });
    }
    initialize(el, origin, obj) {
        let svg = this._svg;
        if (svg) {
            svg.removeEventListener(HrefEvent, this._hrefHandler);
            svg.removeEventListener(TooltipShowEvent, this._tooltipHandler);
            svg.removeEventListener(TooltipHideEvent, this._tooltipHandler);
        }
        this._svg = svg = el && domFind(el, 'svg');
        if (svg) {
            svg.addEventListener(HrefEvent, this._hrefHandler);
            svg.addEventListener(TooltipShowEvent, this._tooltipHandler);
            svg.addEventListener(TooltipHideEvent, this._tooltipHandler);
        }
        return super.initialize(el, origin, obj);
    }
    canvas() {
        return this._svg;
    }
    // add an event handler
    on(type, handler) {
        const name = this.eventName(type), h = this._handlers, i = this._handlerIndex(h[name], type, handler);
        if (i < 0) {
            const x = {
                type,
                handler,
                listener: listener(this, handler)
            };
            (h[name] || (h[name] = [])).push(x);
            if (this._svg) this._svg.addEventListener(name, x.listener);
        }
        return this;
    }
    // remove an event handler
    off(type, handler) {
        const name = this.eventName(type), h = this._handlers[name], i = this._handlerIndex(h, type, handler);
        if (i >= 0) {
            if (this._svg) this._svg.removeEventListener(name, h[i].listener);
            h.splice(i, 1);
        }
        return this;
    }
}
// wrap an event listener for the SVG DOM
const listener = (context, handler)=>(evt)=>{
        let item = evt.target.__data__;
        item = Array.isArray(item) ? item[0] : item;
        evt.vegaType = evt.type;
        handler.call(context._obj, evt, item);
    };
const ARIA_HIDDEN = 'aria-hidden';
const ARIA_LABEL = 'aria-label';
const ARIA_ROLE = 'role';
const ARIA_ROLEDESCRIPTION = 'aria-roledescription';
const GRAPHICS_OBJECT = 'graphics-object';
const GRAPHICS_SYMBOL = 'graphics-symbol';
const bundle = (role, roledesc, label)=>({
        [ARIA_ROLE]: role,
        [ARIA_ROLEDESCRIPTION]: roledesc,
        [ARIA_LABEL]: label || undefined
    });
// these roles are covered by related roles
// we can ignore them, no need to generate attributes
const AriaIgnore = (0, _vegaUtil.toSet)([
    'axis-domain',
    'axis-grid',
    'axis-label',
    'axis-tick',
    'axis-title',
    'legend-band',
    'legend-entry',
    'legend-gradient',
    'legend-label',
    'legend-title',
    'legend-symbol',
    'title'
]);
// aria attribute generators for guide roles
const AriaGuides = {
    'axis': {
        desc: 'axis',
        caption: axisCaption
    },
    'legend': {
        desc: 'legend',
        caption: legendCaption
    },
    'title-text': {
        desc: 'title',
        caption: (item)=>`Title text '${titleCaption(item)}'`
    },
    'title-subtitle': {
        desc: 'subtitle',
        caption: (item)=>`Subtitle text '${titleCaption(item)}'`
    }
};
// aria properties generated for mark item encoding channels
const AriaEncode = {
    ariaRole: ARIA_ROLE,
    ariaRoleDescription: ARIA_ROLEDESCRIPTION,
    description: ARIA_LABEL
};
function ariaItemAttributes(emit, item) {
    const hide = item.aria === false;
    emit(ARIA_HIDDEN, hide || undefined);
    if (hide || item.description == null) for(const prop in AriaEncode)emit(AriaEncode[prop], undefined);
    else {
        const type = item.mark.marktype;
        emit(ARIA_LABEL, item.description);
        emit(ARIA_ROLE, item.ariaRole || (type === 'group' ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL));
        emit(ARIA_ROLEDESCRIPTION, item.ariaRoleDescription || `${type} mark`);
    }
}
function ariaMarkAttributes(mark) {
    return mark.aria === false ? {
        [ARIA_HIDDEN]: true
    } : AriaIgnore[mark.role] ? null : AriaGuides[mark.role] ? ariaGuide(mark, AriaGuides[mark.role]) : ariaMark(mark);
}
function ariaMark(mark) {
    const type = mark.marktype;
    const recurse = type === 'group' || type === 'text' || mark.items.some((_)=>_.description != null && _.aria !== false);
    return bundle(recurse ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL, `${type} mark container`, mark.description);
}
function ariaGuide(mark, opt) {
    try {
        const item = mark.items[0], caption = opt.caption || (()=>'');
        return bundle(opt.role || GRAPHICS_SYMBOL, opt.desc, item.description || caption(item));
    } catch (err) {
        return null;
    }
}
function titleCaption(item) {
    return (0, _vegaUtil.array)(item.text).join(' ');
}
function axisCaption(item) {
    const datum = item.datum, orient = item.orient, title = datum.title ? extractTitle(item) : null, ctx = item.context, scale = ctx.scales[datum.scale].value, locale = ctx.dataflow.locale(), type = scale.type, xy = orient === 'left' || orient === 'right' ? 'Y' : 'X';
    return `${xy}-axis` + (title ? ` titled '${title}'` : '') + ` for a ${(0, _vegaScale.isDiscrete)(type) ? 'discrete' : type} scale` + ` with ${(0, _vegaScale.domainCaption)(locale, scale, item)}`;
}
function legendCaption(item) {
    const datum = item.datum, title = datum.title ? extractTitle(item) : null, type = `${datum.type || ''} legend`.trim(), scales = datum.scales, props = Object.keys(scales), ctx = item.context, scale = ctx.scales[scales[props[0]]].value, locale = ctx.dataflow.locale();
    return capitalize(type) + (title ? ` titled '${title}'` : '') + ` for ${channelCaption(props)}` + ` with ${(0, _vegaScale.domainCaption)(locale, scale, item)}`;
}
function extractTitle(item) {
    try {
        return (0, _vegaUtil.array)((0, _vegaUtil.peek)(item.items).items[0].text).join(' ');
    } catch (err) {
        return null;
    }
}
function channelCaption(props) {
    props = props.map((p)=>p + (p === 'fill' || p === 'stroke' ? ' color' : ''));
    return props.length < 2 ? props[0] : props.slice(0, -1).join(', ') + ' and ' + (0, _vegaUtil.peek)(props);
}
function capitalize(s) {
    return s.length ? s[0].toUpperCase() + s.slice(1) : s;
}
const innerText = (val)=>(val + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const attrText = (val)=>innerText(val).replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
function markup() {
    let buf = '', outer = '', inner = '';
    const stack = [], clear = ()=>outer = inner = '', push = (tag)=>{
        if (outer) {
            buf += `${outer}>${inner}`;
            clear();
        }
        stack.push(tag);
    }, attr = (name, value)=>{
        if (value != null) outer += ` ${name}="${attrText(value)}"`;
        return m;
    }, m = {
        open (tag) {
            push(tag);
            outer = '<' + tag;
            for(var _len = arguments.length, attrs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)attrs[_key - 1] = arguments[_key];
            for (const set of attrs)for(const key in set)attr(key, set[key]);
            return m;
        },
        close () {
            const tag = stack.pop();
            if (outer) buf += outer + (inner ? `>${inner}</${tag}>` : '/>');
            else buf += `</${tag}>`;
            clear();
            return m;
        },
        attr,
        text: (t)=>(inner += innerText(t), m),
        toString: ()=>buf
    };
    return m;
}
const serializeXML = (node)=>_serialize(markup(), node) + '';
function _serialize(m, node) {
    m.open(node.tagName);
    if (node.hasAttributes()) {
        const attrs = node.attributes, n = attrs.length;
        for(let i = 0; i < n; ++i)m.attr(attrs[i].name, attrs[i].value);
    }
    if (node.hasChildNodes()) {
        const children = node.childNodes;
        for (const child of children)child.nodeType === 3 // text node
         ? m.text(child.nodeValue) : _serialize(m, child);
    }
    return m.close();
}
const stylesAttr = {
    fill: 'fill',
    fillOpacity: 'fill-opacity',
    stroke: 'stroke',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    strokeCap: 'stroke-linecap',
    strokeJoin: 'stroke-linejoin',
    strokeDash: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeMiterLimit: 'stroke-miterlimit',
    opacity: 'opacity'
};
const stylesCss = {
    blend: 'mix-blend-mode'
};
// ensure miter limit default is consistent with canvas (#2498)
const rootAttributes = {
    'fill': 'none',
    'stroke-miterlimit': 10
};
const RootIndex = 0, xmlns = 'http://www.w3.org/2000/xmlns/', svgns = metadata.xmlns;
class SVGRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._dirtyID = 0;
        this._dirty = [];
        this._svg = null;
        this._root = null;
        this._defs = null;
    }
    /**
   * Initialize a new SVGRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance.
   */ initialize(el, width, height, origin, scaleFactor) {
        // create the svg definitions cache
        this._defs = {};
        this._clearDefs();
        if (el) {
            this._svg = domChild(el, 0, 'svg', svgns);
            this._svg.setAttributeNS(xmlns, 'xmlns', svgns);
            this._svg.setAttributeNS(xmlns, 'xmlns:xlink', metadata['xmlns:xlink']);
            this._svg.setAttribute('version', metadata['version']);
            this._svg.setAttribute('class', 'marks');
            domClear(el, 1);
            // set the svg root group
            this._root = domChild(this._svg, RootIndex, 'g', svgns);
            setAttributes(this._root, rootAttributes);
            // ensure no additional child elements
            domClear(this._svg, RootIndex + 1);
        }
        // set background color if defined
        this.background(this._bgcolor);
        return super.initialize(el, width, height, origin, scaleFactor);
    }
    /**
   * Get / set the background color.
   */ background(bgcolor) {
        if (arguments.length && this._svg) this._svg.style.setProperty('background-color', bgcolor);
        return super.background(...arguments);
    }
    /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */ resize(width, height, origin, scaleFactor) {
        super.resize(width, height, origin, scaleFactor);
        if (this._svg) {
            setAttributes(this._svg, {
                width: this._width * this._scale,
                height: this._height * this._scale,
                viewBox: `0 0 ${this._width} ${this._height}`
            });
            this._root.setAttribute('transform', `translate(${this._origin})`);
        }
        this._dirty = [];
        return this;
    }
    /**
   * Returns the SVG element of the visualization.
   * @return {DOMElement} - The SVG element.
   */ canvas() {
        return this._svg;
    }
    /**
   * Returns an SVG text string for the rendered content,
   * or null if this renderer is currently headless.
   */ svg() {
        const svg = this._svg, bg = this._bgcolor;
        if (!svg) return null;
        let node;
        if (bg) {
            svg.removeAttribute('style');
            node = domChild(svg, RootIndex, 'rect', svgns);
            setAttributes(node, {
                width: this._width,
                height: this._height,
                fill: bg
            });
        }
        const text = serializeXML(svg);
        if (bg) {
            svg.removeChild(node);
            this._svg.style.setProperty('background-color', bg);
        }
        return text;
    }
    /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ _render(scene, markTypes) {
        // perform spot updates and re-render markup
        if (this._dirtyCheck()) {
            if (this._dirtyAll) this._clearDefs();
            this.mark(this._root, scene, undefined, markTypes);
            domClear(this._root, 1);
        }
        this.defs();
        this._dirty = [];
        ++this._dirtyID;
        return this;
    }
    // -- Manage rendering of items marked as dirty --
    /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */ dirty(item) {
        if (item.dirty !== this._dirtyID) {
            item.dirty = this._dirtyID;
            this._dirty.push(item);
        }
    }
    /**
   * Check if a mark item is considered dirty.
   * @param {Item} item - The mark item.
   */ isDirty(item) {
        return this._dirtyAll || !item._svg || !item._svg.ownerSVGElement || item.dirty === this._dirtyID;
    }
    /**
   * Internal method to check dirty status and, if possible,
   * make targetted updates without a full rendering pass.
   */ _dirtyCheck() {
        this._dirtyAll = true;
        const items = this._dirty;
        if (!items.length || !this._dirtyID) return true;
        const id = ++this._dirtyID;
        let item, mark, type, mdef, i, n, o;
        for(i = 0, n = items.length; i < n; ++i){
            item = items[i];
            mark = item.mark;
            if (mark.marktype !== type) {
                // memoize mark instance lookup
                type = mark.marktype;
                mdef = Marks[type];
            }
            if (mark.zdirty && mark.dirty !== id) {
                this._dirtyAll = false;
                dirtyParents(item, id);
                mark.items.forEach((i)=>{
                    i.dirty = id;
                });
            }
            if (mark.zdirty) continue; // handle in standard drawing pass
            if (item.exit) {
                // EXIT
                if (mdef.nested && mark.items.length) {
                    // if nested mark with remaining points, update instead
                    o = mark.items[0];
                    if (o._svg) this._update(mdef, o._svg, o);
                } else if (item._svg) {
                    // otherwise remove from DOM
                    o = item._svg.parentNode;
                    if (o) o.removeChild(item._svg);
                }
                item._svg = null;
                continue;
            }
            item = mdef.nested ? mark.items[0] : item;
            if (item._update === id) continue; // already visited
            if (!item._svg || !item._svg.ownerSVGElement) {
                // ENTER
                this._dirtyAll = false;
                dirtyParents(item, id);
            } else // IN-PLACE UPDATE
            this._update(mdef, item._svg, item);
            item._update = id;
        }
        return !this._dirtyAll;
    }
    // -- Construct & maintain scenegraph to SVG mapping ---
    /**
   * Render a set of mark items.
   * @param {SVGElement} el - The parent element in the SVG tree.
   * @param {object} scene - The mark parent to render.
   * @param {SVGElement} prev - The previous sibling in the SVG tree.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ mark(el, scene, prev, markTypes) {
        if (!this.isDirty(scene)) return scene._svg;
        const svg = this._svg, markType = scene.marktype, mdef = Marks[markType], events = scene.interactive === false ? 'none' : null, isGroup = mdef.tag === 'g';
        const parent = bind(scene, el, prev, 'g', svg);
        if (markType !== 'group' && markTypes != null && !markTypes.includes(markType)) {
            domClear(parent, 0);
            return scene._svg;
        }
        parent.setAttribute('class', cssClass(scene));
        // apply aria attributes to parent container element
        const aria = ariaMarkAttributes(scene);
        for(const key in aria)setAttribute(parent, key, aria[key]);
        if (!isGroup) setAttribute(parent, 'pointer-events', events);
        setAttribute(parent, 'clip-path', scene.clip ? clip$1(this, scene, scene.group) : null);
        let sibling = null, i = 0;
        const process = (item)=>{
            const dirty = this.isDirty(item), node = bind(item, parent, sibling, mdef.tag, svg);
            if (dirty) {
                this._update(mdef, node, item);
                if (isGroup) recurse(this, node, item, markTypes);
            }
            sibling = node;
            ++i;
        };
        if (mdef.nested) {
            if (scene.items.length) process(scene.items[0]);
        } else visit(scene, process);
        domClear(parent, i);
        return parent;
    }
    /**
   * Update the attributes of an SVG element for a mark item.
   * @param {object} mdef - The mark definition object
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */ _update(mdef, el, item) {
        // set dom element and values cache
        // provides access to emit method
        element = el;
        values = el.__values__;
        // apply aria-specific properties
        ariaItemAttributes(emit, item);
        // apply svg attributes
        mdef.attr(emit, item, this);
        // some marks need special treatment
        const extra = mark_extras[mdef.type];
        if (extra) extra.call(this, mdef, el, item);
        // apply svg style attributes
        // note: element state may have been modified by 'extra' method
        if (element) this.style(element, item);
    }
    /**
   * Update the presentation attributes of an SVG element for a mark item.
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */ style(el, item) {
        if (item == null) return;
        for(const prop in stylesAttr){
            let value = prop === 'font' ? fontFamily(item) : item[prop];
            if (value === values[prop]) continue;
            const name = stylesAttr[prop];
            if (value == null) el.removeAttribute(name);
            else {
                if (isGradient(value)) value = gradientRef(value, this._defs.gradient, href());
                el.setAttribute(name, value + '');
            }
            values[prop] = value;
        }
        for(const prop in stylesCss)setStyle(el, stylesCss[prop], item[prop]);
    }
    /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   */ defs() {
        const svg = this._svg, defs = this._defs;
        let el = defs.el, index = 0;
        for(const id in defs.gradient){
            if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
            index = updateGradient(el, defs.gradient[id], index);
        }
        for(const id in defs.clipping){
            if (!el) defs.el = el = domChild(svg, RootIndex + 1, 'defs', svgns);
            index = updateClipping(el, defs.clipping[id], index);
        }
        // clean-up
        if (el) index === 0 ? (svg.removeChild(el), defs.el = null) : domClear(el, index);
    }
    /**
   * Clear defs caches.
   */ _clearDefs() {
        const def = this._defs;
        def.gradient = {};
        def.clipping = {};
    }
}
// mark ancestor chain with a dirty id
function dirtyParents(item, id) {
    for(; item && item.dirty !== id; item = item.mark.group){
        item.dirty = id;
        if (item.mark && item.mark.dirty !== id) item.mark.dirty = id;
        else return;
    }
}
// update gradient definitions
function updateGradient(el, grad, index) {
    let i, n, stop;
    if (grad.gradient === 'radial') {
        // SVG radial gradients automatically transform to normalized bbox
        // coordinates, in a way that is cumbersome to replicate in canvas.
        // We wrap the radial gradient in a pattern element, allowing us to
        // maintain a circular gradient that matches what canvas provides.
        let pt = domChild(el, index++, 'pattern', svgns);
        setAttributes(pt, {
            id: patternPrefix + grad.id,
            viewBox: '0,0,1,1',
            width: '100%',
            height: '100%',
            preserveAspectRatio: 'xMidYMid slice'
        });
        pt = domChild(pt, 0, 'rect', svgns);
        setAttributes(pt, {
            width: 1,
            height: 1,
            fill: `url(${href()}#${grad.id})`
        });
        el = domChild(el, index++, 'radialGradient', svgns);
        setAttributes(el, {
            id: grad.id,
            fx: grad.x1,
            fy: grad.y1,
            fr: grad.r1,
            cx: grad.x2,
            cy: grad.y2,
            r: grad.r2
        });
    } else {
        el = domChild(el, index++, 'linearGradient', svgns);
        setAttributes(el, {
            id: grad.id,
            x1: grad.x1,
            x2: grad.x2,
            y1: grad.y1,
            y2: grad.y2
        });
    }
    for(i = 0, n = grad.stops.length; i < n; ++i){
        stop = domChild(el, i, 'stop', svgns);
        stop.setAttribute('offset', grad.stops[i].offset);
        stop.setAttribute('stop-color', grad.stops[i].color);
    }
    domClear(el, i);
    return index;
}
// update clipping path definitions
function updateClipping(el, clip, index) {
    let mask;
    el = domChild(el, index, 'clipPath', svgns);
    el.setAttribute('id', clip.id);
    if (clip.path) {
        mask = domChild(el, 0, 'path', svgns);
        mask.setAttribute('d', clip.path);
    } else {
        mask = domChild(el, 0, 'rect', svgns);
        setAttributes(mask, {
            x: 0,
            y: 0,
            width: clip.width,
            height: clip.height
        });
    }
    domClear(el, 1);
    return index + 1;
}
// Recursively process group contents.
function recurse(renderer, el, group, markTypes) {
    // child 'g' element is second to last among children (path, g, path)
    // other children here are foreground and background path elements
    el = el.lastChild.previousSibling;
    let prev, idx = 0;
    visit(group, (item)=>{
        prev = renderer.mark(el, item, prev, markTypes);
        ++idx;
    });
    // remove any extraneous DOM elements
    domClear(el, 1 + idx);
}
// Bind a scenegraph item to an SVG DOM element.
// Create new SVG elements as needed.
function bind(item, el, sibling, tag, svg) {
    let node = item._svg, doc;
    // create a new dom node if needed
    if (!node) {
        doc = el.ownerDocument;
        node = domCreate(doc, tag, svgns);
        item._svg = node;
        if (item.mark) {
            node.__data__ = item;
            node.__values__ = {
                fill: 'default'
            };
            // if group, create background, content, and foreground elements
            if (tag === 'g') {
                const bg = domCreate(doc, 'path', svgns);
                node.appendChild(bg);
                bg.__data__ = item;
                const cg = domCreate(doc, 'g', svgns);
                node.appendChild(cg);
                cg.__data__ = item;
                const fg = domCreate(doc, 'path', svgns);
                node.appendChild(fg);
                fg.__data__ = item;
                fg.__values__ = {
                    fill: 'default'
                };
            }
        }
    }
    // (re-)insert if (a) not contained in SVG or (b) sibling order has changed
    if (node.ownerSVGElement !== svg || siblingCheck(node, sibling)) el.insertBefore(node, sibling ? sibling.nextSibling : el.firstChild);
    return node;
}
// check if two nodes are ordered siblings
function siblingCheck(node, sibling) {
    return node.parentNode && node.parentNode.childNodes.length > 1 && node.previousSibling != sibling; // treat null/undefined the same
}
// -- Set attributes & styles on SVG elements ---
let element = null, // temp var for current SVG element
values = null; // temp var for current values hash
// Extra configuration for certain mark types
const mark_extras = {
    group (mdef, el, item) {
        const fg = element = el.childNodes[2];
        values = fg.__values__;
        mdef.foreground(emit, item, this);
        values = el.__values__; // use parent's values hash
        element = el.childNodes[1];
        mdef.content(emit, item, this);
        const bg = element = el.childNodes[0];
        mdef.background(emit, item, this);
        const value = item.mark.interactive === false ? 'none' : null;
        if (value !== values.events) {
            setAttribute(fg, 'pointer-events', value);
            setAttribute(bg, 'pointer-events', value);
            values.events = value;
        }
        if (item.strokeForeground && item.stroke) {
            const fill = item.fill;
            setAttribute(fg, 'display', null);
            // set style of background
            this.style(bg, item);
            setAttribute(bg, 'stroke', null);
            // set style of foreground
            if (fill) item.fill = null;
            values = fg.__values__;
            this.style(fg, item);
            if (fill) item.fill = fill;
            // leave element null to prevent downstream styling
            element = null;
        } else // ensure foreground is ignored
        setAttribute(fg, 'display', 'none');
    },
    image (mdef, el, item) {
        if (item.smooth === false) {
            setStyle(el, 'image-rendering', 'optimizeSpeed');
            setStyle(el, 'image-rendering', 'pixelated');
        } else setStyle(el, 'image-rendering', null);
    },
    text (mdef, el, item) {
        const tl = textLines(item);
        let key, value, doc, lh;
        if ((0, _vegaUtil.isArray)(tl)) {
            // multi-line text
            value = tl.map((_)=>textValue(item, _));
            key = value.join('\n'); // content cache key
            if (key !== values.text) {
                domClear(el, 0);
                doc = el.ownerDocument;
                lh = lineHeight(item);
                value.forEach((t, i)=>{
                    const ts = domCreate(doc, 'tspan', svgns);
                    ts.__data__ = item; // data binding
                    ts.textContent = t;
                    if (i) {
                        ts.setAttribute('x', 0);
                        ts.setAttribute('dy', lh);
                    }
                    el.appendChild(ts);
                });
                values.text = key;
            }
        } else {
            // single-line text
            value = textValue(item, tl);
            if (value !== values.text) {
                el.textContent = value;
                values.text = value;
            }
        }
        setAttribute(el, 'font-family', fontFamily(item));
        setAttribute(el, 'font-size', fontSize(item) + 'px');
        setAttribute(el, 'font-style', item.fontStyle);
        setAttribute(el, 'font-variant', item.fontVariant);
        setAttribute(el, 'font-weight', item.fontWeight);
    }
};
function emit(name, value, ns) {
    // early exit if value is unchanged
    if (value === values[name]) return;
    // use appropriate method given namespace (ns)
    if (ns) setAttributeNS(element, name, value, ns);
    else setAttribute(element, name, value);
    // note current value for future comparison
    values[name] = value;
}
function setStyle(el, name, value) {
    if (value !== values[name]) {
        if (value == null) el.style.removeProperty(name);
        else el.style.setProperty(name, value + '');
        values[name] = value;
    }
}
function setAttributes(el, attrs) {
    for(const key in attrs)setAttribute(el, key, attrs[key]);
}
function setAttribute(el, name, value) {
    if (value != null) // if value is provided, update DOM attribute
    el.setAttribute(name, value);
    else // else remove DOM attribute
    el.removeAttribute(name);
}
function setAttributeNS(el, name, value, ns) {
    if (value != null) // if value is provided, update DOM attribute
    el.setAttributeNS(ns, name, value);
    else // else remove DOM attribute
    el.removeAttributeNS(ns, name);
}
function href() {
    let loc;
    return typeof window === 'undefined' ? '' : (loc = window.location).hash ? loc.href.slice(0, -loc.hash.length) : loc.href;
}
class SVGStringRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._text = null;
        this._defs = {
            gradient: {},
            clipping: {}
        };
    }
    /**
   * Returns the rendered SVG text string,
   * or null if rendering has not yet occurred.
   */ svg() {
        return this._text;
    }
    /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   */ _render(scene) {
        const m = markup();
        // svg tag
        m.open('svg', (0, _vegaUtil.extend)({}, metadata, {
            class: 'marks',
            width: this._width * this._scale,
            height: this._height * this._scale,
            viewBox: `0 0 ${this._width} ${this._height}`
        }));
        // background, if defined
        const bg = this._bgcolor;
        if (bg && bg !== 'transparent' && bg !== 'none') m.open('rect', {
            width: this._width,
            height: this._height,
            fill: bg
        }).close();
        // root content group
        m.open('g', rootAttributes, {
            transform: 'translate(' + this._origin + ')'
        });
        this.mark(m, scene);
        m.close(); // </g>
        // defs
        this.defs(m);
        // get SVG text string
        this._text = m.close() + '';
        return this;
    }
    /**
   * Render a set of mark items.
   * @param {object} m - The markup context.
   * @param {object} scene - The mark parent to render.
   */ mark(m, scene) {
        const mdef = Marks[scene.marktype], tag = mdef.tag, attrList = [
            ariaItemAttributes,
            mdef.attr
        ];
        // render opening group tag
        m.open('g', {
            'class': cssClass(scene),
            'clip-path': scene.clip ? clip$1(this, scene, scene.group) : null
        }, ariaMarkAttributes(scene), {
            'pointer-events': tag !== 'g' && scene.interactive === false ? 'none' : null
        });
        // render contained elements
        const process = (item)=>{
            const href = this.href(item);
            if (href) m.open('a', href);
            m.open(tag, this.attr(scene, item, attrList, tag !== 'g' ? tag : null));
            if (tag === 'text') {
                const tl = textLines(item);
                if ((0, _vegaUtil.isArray)(tl)) {
                    // multi-line text
                    const attrs = {
                        x: 0,
                        dy: lineHeight(item)
                    };
                    for(let i = 0; i < tl.length; ++i)m.open('tspan', i ? attrs : null).text(textValue(item, tl[i])).close();
                } else // single-line text
                m.text(textValue(item, tl));
            } else if (tag === 'g') {
                const fore = item.strokeForeground, fill = item.fill, stroke = item.stroke;
                if (fore && stroke) item.stroke = null;
                m.open('path', this.attr(scene, item, mdef.background, 'bgrect')).close();
                // recurse for group content
                m.open('g', this.attr(scene, item, mdef.content));
                visit(item, (scene)=>this.mark(m, scene));
                m.close();
                if (fore && stroke) {
                    if (fill) item.fill = null;
                    item.stroke = stroke;
                    m.open('path', this.attr(scene, item, mdef.foreground, 'bgrect')).close();
                    if (fill) item.fill = fill;
                } else m.open('path', this.attr(scene, item, mdef.foreground, 'bgfore')).close();
            }
            m.close(); // </tag>
            if (href) m.close(); // </a>
        };
        if (mdef.nested) {
            if (scene.items && scene.items.length) process(scene.items[0]);
        } else visit(scene, process);
        // render closing group tag
        return m.close(); // </g>
    }
    /**
   * Get href attributes for a hyperlinked mark item.
   * @param {Item} item - The mark item.
   */ href(item) {
        const href = item.href;
        let attr;
        if (href) {
            if (attr = this._hrefs && this._hrefs[href]) return attr;
            else this.sanitizeURL(href).then((attr)=>{
                // rewrite to use xlink namespace
                attr['xlink:href'] = attr.href;
                attr.href = null;
                (this._hrefs || (this._hrefs = {}))[href] = attr;
            });
        }
        return null;
    }
    /**
   * Get an object of SVG attributes for a mark item.
   * @param {object} scene - The mark parent.
   * @param {Item} item - The mark item.
   * @param {array|function} attrs - One or more attribute emitters.
   * @param {string} tag - The tag being rendered.
   */ attr(scene, item, attrs, tag) {
        const object = {}, emit = (name, value, ns, prefixed)=>{
            object[prefixed || name] = value;
        };
        // apply mark specific attributes
        if (Array.isArray(attrs)) attrs.forEach((fn)=>fn(emit, item, this));
        else attrs(emit, item, this);
        // apply style attributes
        if (tag) style(object, item, scene, tag, this._defs);
        return object;
    }
    /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   * @param {object} m - The markup context.
   */ defs(m) {
        const gradient = this._defs.gradient, clipping = this._defs.clipping, count = Object.keys(gradient).length + Object.keys(clipping).length;
        if (count === 0) return; // nothing to do
        m.open('defs');
        for(const id in gradient){
            const def = gradient[id], stops = def.stops;
            if (def.gradient === 'radial') {
                // SVG radial gradients automatically transform to normalized bbox
                // coordinates, in a way that is cumbersome to replicate in canvas.
                // We wrap the radial gradient in a pattern element, allowing us to
                // maintain a circular gradient that matches what canvas provides.
                m.open('pattern', {
                    id: patternPrefix + id,
                    viewBox: '0,0,1,1',
                    width: '100%',
                    height: '100%',
                    preserveAspectRatio: 'xMidYMid slice'
                });
                m.open('rect', {
                    width: '1',
                    height: '1',
                    fill: 'url(#' + id + ')'
                }).close();
                m.close(); // </pattern>
                m.open('radialGradient', {
                    id: id,
                    fx: def.x1,
                    fy: def.y1,
                    fr: def.r1,
                    cx: def.x2,
                    cy: def.y2,
                    r: def.r2
                });
            } else m.open('linearGradient', {
                id: id,
                x1: def.x1,
                x2: def.x2,
                y1: def.y1,
                y2: def.y2
            });
            for(let i = 0; i < stops.length; ++i)m.open('stop', {
                offset: stops[i].offset,
                'stop-color': stops[i].color
            }).close();
            m.close();
        }
        for(const id in clipping){
            const def = clipping[id];
            m.open('clipPath', {
                id: id
            });
            if (def.path) m.open('path', {
                d: def.path
            }).close();
            else m.open('rect', {
                x: 0,
                y: 0,
                width: def.width,
                height: def.height
            }).close();
            m.close();
        }
        m.close();
    }
}
// Helper function for attr for style presentation attributes
function style(s, item, scene, tag, defs) {
    let styleList;
    if (item == null) return s;
    if (tag === 'bgrect' && scene.interactive === false) s['pointer-events'] = 'none';
    if (tag === 'bgfore') {
        if (scene.interactive === false) s['pointer-events'] = 'none';
        s.display = 'none';
        if (item.fill !== null) return s;
    }
    if (tag === 'image' && item.smooth === false) styleList = [
        'image-rendering: optimizeSpeed;',
        'image-rendering: pixelated;'
    ];
    if (tag === 'text') {
        s['font-family'] = fontFamily(item);
        s['font-size'] = fontSize(item) + 'px';
        s['font-style'] = item.fontStyle;
        s['font-variant'] = item.fontVariant;
        s['font-weight'] = item.fontWeight;
    }
    for(const prop in stylesAttr){
        let value = item[prop];
        const name = stylesAttr[prop];
        if (value === 'transparent' && (name === 'fill' || name === 'stroke')) ;
        else if (value != null) {
            if (isGradient(value)) value = gradientRef(value, defs.gradient, '');
            s[name] = value;
        }
    }
    for(const prop in stylesCss){
        const value = item[prop];
        if (value != null) {
            styleList = styleList || [];
            styleList.push(`${stylesCss[prop]}: ${value};`);
        }
    }
    if (styleList) s.style = styleList.join(' ');
    return s;
}
/**
 * @typedef {Object} HybridRendererOptions
 *
 * @property {string[]} [svgMarkTypes=['text']] - An array of SVG mark types to render
 *                                                in the SVG layer. All other mark types
 *                                                will be rendered in the Canvas layer.
 * @property {boolean} [svgOnTop=true] - Flag to determine if SVG should be rendered on top.
 * @property {boolean} [debug=false] - Flag to enable or disable debugging mode. When true,
 *                                     the top layer will be stacked below the bottom layer
 *                                     rather than overlaid on top.
 */ /** @type {HybridRendererOptions} */ const OPTS = {
    svgMarkTypes: [
        'text'
    ],
    svgOnTop: true,
    debug: false
};
/**
 * Configure the HybridRenderer
 *
 * @param {HybridRendererOptions} options - HybridRenderer configuration options.
 */ function setHybridRendererOptions(options) {
    OPTS['svgMarkTypes'] = options.svgMarkTypes ?? [
        'text'
    ];
    OPTS['svgOnTop'] = options.svgOnTop ?? true;
    OPTS['debug'] = options.debug ?? false;
}
class HybridRenderer extends Renderer {
    constructor(loader){
        super(loader);
        this._svgRenderer = new SVGRenderer(loader);
        this._canvasRenderer = new CanvasRenderer(loader);
    }
    /**
   * Initialize a new HybridRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {HybridRenderer} - This renderer instance.
   */ initialize(el, width, height, origin, scaleFactor) {
        this._root_el = domChild(el, 0, 'div');
        const bottomEl = domChild(this._root_el, 0, 'div');
        const topEl = domChild(this._root_el, 1, 'div');
        this._root_el.style.position = 'relative';
        // Set position absolute to overlay svg on top of canvas
        if (!OPTS.debug) {
            bottomEl.style.height = '100%';
            topEl.style.position = 'absolute';
            topEl.style.top = '0';
            topEl.style.left = '0';
            topEl.style.height = '100%';
            topEl.style.width = '100%';
        }
        this._svgEl = OPTS.svgOnTop ? topEl : bottomEl;
        this._canvasEl = OPTS.svgOnTop ? bottomEl : topEl;
        // pointer-events to none on SVG layer so that canvas gets all events
        this._svgEl.style.pointerEvents = 'none';
        this._canvasRenderer.initialize(this._canvasEl, width, height, origin, scaleFactor);
        this._svgRenderer.initialize(this._svgEl, width, height, origin, scaleFactor);
        return super.initialize(el, width, height, origin, scaleFactor);
    }
    /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */ dirty(item) {
        if (OPTS.svgMarkTypes.includes(item.mark.marktype)) this._svgRenderer.dirty(item);
        else this._canvasRenderer.dirty(item);
        return this;
    }
    /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @param {Array} markTypes - Array of the mark types to render.
   *                            If undefined, render all mark types
   */ _render(scene, markTypes) {
        const allMarkTypes = markTypes ?? [
            'arc',
            'area',
            'image',
            'line',
            'path',
            'rect',
            'rule',
            'shape',
            'symbol',
            'text',
            'trail'
        ];
        const canvasMarkTypes = allMarkTypes.filter((m)=>!OPTS.svgMarkTypes.includes(m));
        this._svgRenderer.render(scene, OPTS.svgMarkTypes);
        this._canvasRenderer.render(scene, canvasMarkTypes);
    }
    /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */ resize(width, height, origin, scaleFactor) {
        super.resize(width, height, origin, scaleFactor);
        this._svgRenderer.resize(width, height, origin, scaleFactor);
        this._canvasRenderer.resize(width, height, origin, scaleFactor);
        return this;
    }
    background(bgcolor) {
        // Propagate background color to lower canvas renderer
        if (OPTS.svgOnTop) this._canvasRenderer.background(bgcolor);
        else this._svgRenderer.background(bgcolor);
        return this;
    }
}
class HybridHandler extends CanvasHandler {
    constructor(loader, tooltip){
        super(loader, tooltip);
    }
    initialize(el, origin, obj) {
        const canvas = domChild(domChild(el, 0, 'div'), OPTS.svgOnTop ? 0 : 1, 'div');
        return super.initialize(canvas, origin, obj);
    }
}
const Canvas = 'canvas';
const Hybrid = 'hybrid';
const PNG = 'png';
const SVG = 'svg';
const None = 'none';
const RenderType = {
    Canvas: Canvas,
    PNG: PNG,
    SVG: SVG,
    Hybrid: Hybrid,
    None: None
};
const modules = {};
modules[Canvas] = modules[PNG] = {
    renderer: CanvasRenderer,
    headless: CanvasRenderer,
    handler: CanvasHandler
};
modules[SVG] = {
    renderer: SVGRenderer,
    headless: SVGStringRenderer,
    handler: SVGHandler
};
modules[Hybrid] = {
    renderer: HybridRenderer,
    headless: HybridRenderer,
    handler: HybridHandler
};
modules[None] = {};
function renderModule(name, _) {
    name = String(name || '').toLowerCase();
    if (arguments.length > 1) {
        modules[name] = _;
        return this;
    } else return modules[name];
}
function intersect(scene, bounds, filter) {
    const hits = [], // intersection results
    box = new Bounds().union(bounds), // defensive copy
    type = scene.marktype;
    return type ? intersectMark(scene, box, filter, hits) : type === 'group' ? intersectGroup(scene, box, filter, hits) : (0, _vegaUtil.error)('Intersect scene must be mark node or group item.');
}
function intersectMark(mark, box, filter, hits) {
    if (visitMark(mark, box, filter)) {
        const items = mark.items, type = mark.marktype, n = items.length;
        let i = 0;
        if (type === 'group') for(; i < n; ++i)intersectGroup(items[i], box, filter, hits);
        else for(const test = Marks[type].isect; i < n; ++i){
            const item = items[i];
            if (intersectItem(item, box, test)) hits.push(item);
        }
    }
    return hits;
}
function visitMark(mark, box, filter) {
    // process if bounds intersect and if
    // (1) mark is a group mark (so we must recurse), or
    // (2) mark is interactive and passes filter
    return mark.bounds && box.intersects(mark.bounds) && (mark.marktype === 'group' || mark.interactive !== false && (!filter || filter(mark)));
}
function intersectGroup(group, box, filter, hits) {
    // test intersect against group
    // skip groups by default unless filter says otherwise
    if (filter && filter(group.mark) && intersectItem(group, box, Marks.group.isect)) hits.push(group);
    // recursively test children marks
    // translate box to group coordinate space
    const marks = group.items, n = marks && marks.length;
    if (n) {
        const x = group.x || 0, y = group.y || 0;
        box.translate(-x, -y);
        for(let i = 0; i < n; ++i)intersectMark(marks[i], box, filter, hits);
        box.translate(x, y);
    }
    return hits;
}
function intersectItem(item, box, test) {
    // test bounds enclosure, bounds intersection, then detailed test
    const bounds = item.bounds;
    return box.encloses(bounds) || box.intersects(bounds) && test(item, box);
}
const clipBounds = new Bounds();
function boundClip(mark) {
    const clip = mark.clip;
    if ((0, _vegaUtil.isFunction)(clip)) clip(boundContext(clipBounds.clear()));
    else if (clip) clipBounds.set(0, 0, mark.group.width, mark.group.height);
    else return;
    mark.bounds.intersect(clipBounds);
}
const TOLERANCE = 1e-9;
function sceneEqual(a, b, key) {
    return a === b ? true : key === 'path' ? pathEqual(a, b) : a instanceof Date && b instanceof Date ? +a === +b : (0, _vegaUtil.isNumber)(a) && (0, _vegaUtil.isNumber)(b) ? Math.abs(a - b) <= TOLERANCE : !a || !b || !(0, _vegaUtil.isObject)(a) && !(0, _vegaUtil.isObject)(b) ? a == b : objectEqual(a, b);
}
function pathEqual(a, b) {
    return sceneEqual(parse(a), parse(b));
}
function objectEqual(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b), key, i;
    if (ka.length !== kb.length) return false;
    ka.sort();
    kb.sort();
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!sceneEqual(a[key], b[key], key)) return false;
    }
    return typeof a === typeof b;
}
function resetSVGDefIds() {
    resetSVGClipId();
    resetSVGGradientId();
}

},{"vega-util":"kncZn","d3-shape":"1tv6N","d3-path":"41uJT","vega-canvas":"5PubP","vega-loader":"btcyl","vega-scale":"fMau0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1tv6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "link", ()=>(0, _linkJs.link));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _linkJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _linkJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _linkJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbolsStroke", ()=>(0, _symbolJs.symbolsStroke));
parcelHelpers.export(exports, "symbolsFill", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbolAsterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond2", ()=>(0, _diamond2JsDefault.default));
parcelHelpers.export(exports, "symbolPlus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolSquare2", ()=>(0, _square2JsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle2", ()=>(0, _triangle2JsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "symbolTimes", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "symbolX", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBumpX", ()=>(0, _bumpJs.bumpX));
parcelHelpers.export(exports, "curveBumpY", ()=>(0, _bumpJs.bumpY));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _linkJs = require("./link.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bumpJs = require("./curve/bump.js");
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"h7igG","./area.js":"2HPHS","./line.js":"4uhfL","./pie.js":false,"./areaRadial.js":false,"./lineRadial.js":false,"./pointRadial.js":false,"./link.js":false,"./symbol.js":"kFQt8","./symbol/asterisk.js":false,"./symbol/circle.js":false,"./symbol/cross.js":false,"./symbol/diamond.js":false,"./symbol/diamond2.js":false,"./symbol/plus.js":false,"./symbol/square.js":false,"./symbol/square2.js":false,"./symbol/star.js":false,"./symbol/triangle.js":false,"./symbol/triangle2.js":false,"./symbol/wye.js":false,"./symbol/times.js":false,"./curve/basisClosed.js":"37kO7","./curve/basisOpen.js":"hSSEq","./curve/basis.js":"fgTmG","./curve/bump.js":false,"./curve/bundle.js":"beXYC","./curve/cardinalClosed.js":"3zkf0","./curve/cardinalOpen.js":"ltWuC","./curve/cardinal.js":"Rduof","./curve/catmullRomClosed.js":"3nauk","./curve/catmullRomOpen.js":"hJOJZ","./curve/catmullRom.js":"ikgoz","./curve/linearClosed.js":"cL4IC","./curve/linear.js":"6Ipvl","./curve/monotone.js":"deXBO","./curve/natural.js":"yX1t5","./curve/step.js":"dWNDX","./stack.js":false,"./offset/expand.js":false,"./offset/diverging.js":false,"./offset/none.js":false,"./offset/silhouette.js":false,"./offset/wiggle.js":false,"./order/appearance.js":false,"./order/ascending.js":false,"./order/descending.js":false,"./order/insideOut.js":false,"./order/none.js":false,"./order/reverse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h7igG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = (0, _pathJs.withPath)(arc);
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle. If this
                    // intersection fails, it’s probably because the arc is too small, so
                    // disable the corner radius entirely.
                    if (da < (0, _mathJs.pi)) {
                        if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                            rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                        } else rc0 = rc1 = 0;
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _pathJs = require("./path.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"./constant.js":"9KS39","./math.js":"kMcO8","./path.js":"5OBEk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KS39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMcO8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5OBEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withPath", ()=>withPath);
var _d3Path = require("d3-path");
function withPath(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, _d3Path.Path)(digits);
}

},{"d3-path":"41uJT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41uJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>(0, _pathJs.Path));
parcelHelpers.export(exports, "path", ()=>(0, _pathJs.path));
parcelHelpers.export(exports, "pathRound", ()=>(0, _pathJs.pathRound));
var _pathJs = require("./path.js");

},{"./path.js":"jFrOU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jFrOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "path", ()=>path);
parcelHelpers.export(exports, "pathRound", ()=>pathRound);
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class Path {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? append : appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > epsilon) this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function path() {
    return new Path;
}
// Allow instanceof d3.path
path.prototype = Path.prototype;
function pathRound(digits = 3) {
    return new Path(+digits);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2HPHS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x0, y0, y1) {
        var x1 = null, defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(area);
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constantJsDefault.default)(0) : (0, _constantJsDefault.default)(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(+y1);
        function area(data) {
            var i, j, k, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"i1x8O","./constant.js":"9KS39","./curve/linear.js":"6Ipvl","./line.js":"4uhfL","./path.js":"5OBEk","./point.js":"aihDY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i1x8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Ipvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uhfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(line);
        x = typeof x === "function" ? x : x === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(x);
        y = typeof y === "function" ? y : y === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(y);
        function line(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"i1x8O","./constant.js":"9KS39","./curve/linear.js":"6Ipvl","./path.js":"5OBEk","./point.js":"aihDY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aihDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kFQt8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbolsFill", ()=>symbolsFill);
parcelHelpers.export(exports, "symbolsStroke", ()=>symbolsStroke);
parcelHelpers.export(exports, "default", ()=>Symbol);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pathJs = require("./path.js");
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
const symbolsFill = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];
const symbolsStroke = [
    (0, _circleJsDefault.default),
    (0, _plusJsDefault.default),
    (0, _timesJsDefault.default),
    (0, _triangle2JsDefault.default),
    (0, _asteriskJsDefault.default),
    (0, _square2JsDefault.default),
    (0, _diamond2JsDefault.default)
];
function Symbol(type, size) {
    let context = null, path = (0, _pathJs.withPath)(symbol);
    type = typeof type === "function" ? type : (0, _constantJsDefault.default)(type || (0, _circleJsDefault.default));
    size = typeof size === "function" ? size : (0, _constantJsDefault.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"./constant.js":"9KS39","./path.js":"5OBEk","./symbol/asterisk.js":"7yuOf","./symbol/circle.js":"hxwzK","./symbol/cross.js":"lAKSk","./symbol/diamond.js":"65NuR","./symbol/diamond2.js":"h7gwW","./symbol/plus.js":"k4gHL","./symbol/square.js":"dRaOu","./symbol/square2.js":"eNxbt","./symbol/star.js":"gKyk0","./symbol/triangle.js":"40Hhf","./symbol/triangle2.js":"8exgR","./symbol/wye.js":"jP73p","./symbol/times.js":"fguTY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yuOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size + (0, _mathJs.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hxwzK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lAKSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"65NuR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const tan30 = (0, _mathJs.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
exports.default = {
    draw (context, size) {
        const y = (0, _mathJs.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h7gwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k4gHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRaOu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const w = (0, _mathJs.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eNxbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKyk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const ka = 0.89081309152928522810;
const kr = (0, _mathJs.sin)((0, _mathJs.pi) / 10) / (0, _mathJs.sin)(7 * (0, _mathJs.pi) / 10);
const kx = (0, _mathJs.sin)((0, _mathJs.tau) / 10) * kr;
const ky = -(0, _mathJs.cos)((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, _mathJs.tau) * i / 5;
            const c = (0, _mathJs.cos)(a);
            const s = (0, _mathJs.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"40Hhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const y = -(0, _mathJs.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8exgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const s = (0, _mathJs.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jP73p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const c = -0.5;
const s = (0, _mathJs.sqrt)(3) / 2;
const k = 1 / (0, _mathJs.sqrt)(12);
const a = (k / 2 + 1) * 3;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fguTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37kO7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"41zTG","./basis.js":"fgTmG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41zTG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgTmG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hSSEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"fgTmG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"beXYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"fgTmG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3zkf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"41zTG","./cardinal.js":"Rduof","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Rduof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ltWuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"Rduof","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3nauk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"3zkf0","../noop.js":"41zTG","./catmullRom.js":"ikgoz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ikgoz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"kMcO8","./cardinal.js":"Rduof","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJOJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"ltWuC","./catmullRom.js":"ikgoz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cL4IC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"41zTG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"deXBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"yX1t5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dWNDX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5PubP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canvas", ()=>domCanvas);
parcelHelpers.export(exports, "domCanvas", ()=>domCanvas);
parcelHelpers.export(exports, "image", ()=>domImage);
function domCanvas(w, h) {
    if (typeof document !== 'undefined' && document.createElement) {
        const c = document.createElement('canvas');
        if (c && c.getContext) {
            c.width = w;
            c.height = h;
            return c;
        }
    }
    return null;
}
const domImage = ()=>typeof Image !== 'undefined' ? Image : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fMau0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _d3Scale.scaleImplicit));
parcelHelpers.export(exports, "Band", ()=>Band);
parcelHelpers.export(exports, "BinOrdinal", ()=>BinOrdinal);
parcelHelpers.export(exports, "DiscreteLegend", ()=>DiscreteLegend);
parcelHelpers.export(exports, "Diverging", ()=>Diverging);
parcelHelpers.export(exports, "GradientLegend", ()=>GradientLegend);
parcelHelpers.export(exports, "Identity", ()=>Identity);
parcelHelpers.export(exports, "Linear", ()=>Linear);
parcelHelpers.export(exports, "Log", ()=>Log);
parcelHelpers.export(exports, "Ordinal", ()=>Ordinal);
parcelHelpers.export(exports, "Point", ()=>Point);
parcelHelpers.export(exports, "Pow", ()=>Pow);
parcelHelpers.export(exports, "Quantile", ()=>Quantile);
parcelHelpers.export(exports, "Quantize", ()=>Quantize);
parcelHelpers.export(exports, "Sequential", ()=>Sequential);
parcelHelpers.export(exports, "Sqrt", ()=>Sqrt);
parcelHelpers.export(exports, "SymbolLegend", ()=>SymbolLegend);
parcelHelpers.export(exports, "Symlog", ()=>Symlog);
parcelHelpers.export(exports, "Threshold", ()=>Threshold);
parcelHelpers.export(exports, "Time", ()=>Time);
parcelHelpers.export(exports, "UTC", ()=>UTC);
parcelHelpers.export(exports, "bandSpace", ()=>bandSpace);
parcelHelpers.export(exports, "domainCaption", ()=>domainCaption);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "interpolateColors", ()=>interpolateColors);
parcelHelpers.export(exports, "interpolateRange", ()=>interpolateRange);
parcelHelpers.export(exports, "isContinuous", ()=>isContinuous);
parcelHelpers.export(exports, "isDiscrete", ()=>isDiscrete);
parcelHelpers.export(exports, "isDiscretizing", ()=>isDiscretizing);
parcelHelpers.export(exports, "isInterpolating", ()=>isInterpolating);
parcelHelpers.export(exports, "isLogarithmic", ()=>isLogarithmic);
parcelHelpers.export(exports, "isQuantile", ()=>isQuantile);
parcelHelpers.export(exports, "isRegisteredScale", ()=>isRegisteredScale);
parcelHelpers.export(exports, "isTemporal", ()=>isTemporal);
parcelHelpers.export(exports, "isValidScaleType", ()=>isValidScaleType);
parcelHelpers.export(exports, "labelFormat", ()=>labelFormat);
parcelHelpers.export(exports, "labelFraction", ()=>labelFraction);
parcelHelpers.export(exports, "labelValues", ()=>labelValues);
parcelHelpers.export(exports, "quantizeInterpolator", ()=>quantizeInterpolator);
parcelHelpers.export(exports, "registerScale", ()=>registerScale);
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "scaleCopy", ()=>scaleCopy);
parcelHelpers.export(exports, "scaleFraction", ()=>scaleFraction);
parcelHelpers.export(exports, "scheme", ()=>scheme);
parcelHelpers.export(exports, "tickCount", ()=>tickCount);
parcelHelpers.export(exports, "tickFormat", ()=>tickFormat);
parcelHelpers.export(exports, "tickValues", ()=>tickValues);
parcelHelpers.export(exports, "validTicks", ()=>validTicks);
var _vegaUtil = require("vega-util");
var _d3Array = require("d3-array");
var _d3Scale = require("d3-scale");
var _d3Interpolate = require("d3-interpolate");
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _vegaTime = require("vega-time");
function bandSpace(count, paddingInner, paddingOuter) {
    const space = count - paddingInner + paddingOuter * 2;
    return count ? space > 0 ? space : 1 : 0;
}
const Identity = 'identity';
const Linear = 'linear';
const Log = 'log';
const Pow = 'pow';
const Sqrt = 'sqrt';
const Symlog = 'symlog';
const Time = 'time';
const UTC = 'utc';
const Sequential = 'sequential';
const Diverging = 'diverging';
const Quantile = 'quantile';
const Quantize = 'quantize';
const Threshold = 'threshold';
const Ordinal = 'ordinal';
const Point = 'point';
const Band = 'band';
const BinOrdinal = 'bin-ordinal';
// categories
const Continuous = 'continuous';
const Discrete = 'discrete';
const Discretizing = 'discretizing';
const Interpolating = 'interpolating';
const Temporal = 'temporal';
function invertRange(scale) {
    return function(_) {
        let lo = _[0], hi = _[1], t;
        if (hi < lo) {
            t = lo;
            lo = hi;
            hi = t;
        }
        return [
            scale.invert(lo),
            scale.invert(hi)
        ];
    };
}
function invertRangeExtent(scale) {
    return function(_) {
        const range = scale.range();
        let lo = _[0], hi = _[1], min = -1, max, t, i, n;
        if (hi < lo) {
            t = lo;
            lo = hi;
            hi = t;
        }
        for(i = 0, n = range.length; i < n; ++i)if (range[i] >= lo && range[i] <= hi) {
            if (min < 0) min = i;
            max = i;
        }
        if (min < 0) return undefined;
        lo = scale.invertExtent(range[min]);
        hi = scale.invertExtent(range[max]);
        return [
            lo[0] === undefined ? lo[1] : lo[0],
            hi[1] === undefined ? hi[0] : hi[1]
        ];
    };
}
function band() {
    const scale = (0, _d3Scale.scaleOrdinal)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range;
    let range$1 = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        const n = domain().length, reverse = range$1[1] < range$1[0], stop = range$1[1 - reverse], space = bandSpace(n, paddingInner, paddingOuter);
        let start = range$1[reverse - 0];
        step = (stop - start) / (space || 1);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) {
            start = Math.round(start);
            bandwidth = Math.round(bandwidth);
        }
        const values = (0, _d3Array.range)(n).map((i)=>start + step * i);
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        if (arguments.length) {
            domain(_);
            return rescale();
        } else return domain();
    };
    scale.range = function(_) {
        if (arguments.length) {
            range$1 = [
                +_[0],
                +_[1]
            ];
            return rescale();
        } else return range$1.slice();
    };
    scale.rangeRound = function(_) {
        range$1 = [
            +_[0],
            +_[1]
        ];
        round = true;
        return rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        if (arguments.length) {
            round = !!_;
            return rescale();
        } else return round;
    };
    scale.padding = function(_) {
        if (arguments.length) {
            paddingOuter = Math.max(0, Math.min(1, _));
            paddingInner = paddingOuter;
            return rescale();
        } else return paddingInner;
    };
    scale.paddingInner = function(_) {
        if (arguments.length) {
            paddingInner = Math.max(0, Math.min(1, _));
            return rescale();
        } else return paddingInner;
    };
    scale.paddingOuter = function(_) {
        if (arguments.length) {
            paddingOuter = Math.max(0, Math.min(1, _));
            return rescale();
        } else return paddingOuter;
    };
    scale.align = function(_) {
        if (arguments.length) {
            align = Math.max(0, Math.min(1, _));
            return rescale();
        } else return align;
    };
    scale.invertRange = function(_) {
        // bail if range has null or undefined values
        if (_[0] == null || _[1] == null) return;
        const reverse = range$1[1] < range$1[0], values = reverse ? ordinalRange().reverse() : ordinalRange(), n = values.length - 1;
        let lo = +_[0], hi = +_[1], a, b, t;
        // bail if either range endpoint is invalid
        if (lo !== lo || hi !== hi) return;
        // order range inputs, bail if outside of scale range
        if (hi < lo) {
            t = lo;
            lo = hi;
            hi = t;
        }
        if (hi < values[0] || lo > range$1[1 - reverse]) return;
        // binary search to index into scale range
        a = Math.max(0, (0, _d3Array.bisectRight)(values, lo) - 1);
        b = lo === hi ? a : (0, _d3Array.bisectRight)(values, hi) - 1;
        // increment index a if lo is within padding gap
        if (lo - values[a] > bandwidth + 1e-10) ++a;
        if (reverse) {
            // map + swap
            t = a;
            a = n - b;
            b = n - t;
        }
        return a > b ? undefined : domain().slice(a, b + 1);
    };
    scale.invert = function(_) {
        const value = scale.invertRange([
            _,
            _
        ]);
        return value ? value[0] : value;
    };
    scale.copy = function() {
        return band().domain(domain()).range(range$1).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return rescale();
}
function pointish(scale) {
    const copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band().paddingInner(1));
}
var map = Array.prototype.map;
function numbers(_) {
    return map.call(_, (0, _vegaUtil.toNumber));
}
const slice = Array.prototype.slice;
function scaleBinOrdinal() {
    let domain = [], range = [];
    function scale(x) {
        return x == null || x !== x ? undefined : range[((0, _d3Array.bisect)(domain, x) - 1) % range.length];
    }
    scale.domain = function(_) {
        if (arguments.length) {
            domain = numbers(_);
            return scale;
        } else return domain.slice();
    };
    scale.range = function(_) {
        if (arguments.length) {
            range = slice.call(_);
            return scale;
        } else return range.slice();
    };
    scale.tickFormat = function(count, specifier) {
        return (0, _d3Scale.tickFormat)(domain[0], (0, _vegaUtil.peek)(domain), count == null ? 10 : count, specifier);
    };
    scale.copy = function() {
        return scaleBinOrdinal().domain(scale.domain()).range(scale.range());
    };
    return scale;
}
/** Private scale registry: should not be exported */ const scales = new Map();
const VEGA_SCALE = Symbol('vega_scale');
function registerScale(scale) {
    scale[VEGA_SCALE] = true;
    return scale;
}
/**
 * Return true if object was created by a constructor from the vega-scale `scale` function.
 */ function isRegisteredScale(scale) {
    return scale && scale[VEGA_SCALE] === true;
}
/**
 * Augment scales with their type and needed inverse methods.
 */ function create(type, constructor, metadata) {
    const ctr = function scale() {
        const s = constructor();
        if (!s.invertRange) s.invertRange = s.invert ? invertRange(s) : s.invertExtent ? invertRangeExtent(s) : undefined;
        s.type = type;
        return registerScale(s);
    };
    ctr.metadata = (0, _vegaUtil.toSet)((0, _vegaUtil.array)(metadata));
    return ctr;
}
/**
 * Registry function for adding and accessing scale constructor functions.
 * The *type* argument is a String indicating the name of the scale type.
 *
 * If the *scale* argument is not specified, this method returns the matching scale constructor in the registry, or `null` if not found.
 * If the *scale* argument is provided, it must be a scale constructor function to add to the registry under the given *type* name.
 * The *metadata* argument provides additional information to guide appropriate use of scales within Vega.
 *
 *  *metadata* can be either a string or string array. The valid string values are:
 * - `"continuous"` - the scale is defined over a continuous-valued domain.
 * - `"discrete"` - the scale is defined over a discrete domain and range.
 * - `"discretizing"` - the scale discretizes a continuous domain to a discrete range.
 * - `"interpolating"` - the scale range is defined using a color interpolator.
 * - `"log"` - the scale performs a logarithmic transform of the continuous domain.
 * - `"temporal"` - the scale domain is defined over date-time values.
 */ function scale(type, scale, metadata) {
    if (arguments.length > 1) {
        scales.set(type, create(type, scale, metadata));
        return this;
    } else return isValidScaleType(type) ? scales.get(type) : undefined;
}
// identity scale
scale(Identity, _d3Scale.scaleIdentity);
// continuous scales
scale(Linear, _d3Scale.scaleLinear, Continuous);
scale(Log, _d3Scale.scaleLog, [
    Continuous,
    Log
]);
scale(Pow, _d3Scale.scalePow, Continuous);
scale(Sqrt, _d3Scale.scaleSqrt, Continuous);
scale(Symlog, _d3Scale.scaleSymlog, Continuous);
scale(Time, _d3Scale.scaleTime, [
    Continuous,
    Temporal
]);
scale(UTC, _d3Scale.scaleUtc, [
    Continuous,
    Temporal
]);
// sequential scales
scale(Sequential, _d3Scale.scaleSequential, [
    Continuous,
    Interpolating
]); // backwards compat
scale(`${Sequential}-${Linear}`, _d3Scale.scaleSequential, [
    Continuous,
    Interpolating
]);
scale(`${Sequential}-${Log}`, _d3Scale.scaleSequentialLog, [
    Continuous,
    Interpolating,
    Log
]);
scale(`${Sequential}-${Pow}`, _d3Scale.scaleSequentialPow, [
    Continuous,
    Interpolating
]);
scale(`${Sequential}-${Sqrt}`, _d3Scale.scaleSequentialSqrt, [
    Continuous,
    Interpolating
]);
scale(`${Sequential}-${Symlog}`, _d3Scale.scaleSequentialSymlog, [
    Continuous,
    Interpolating
]);
// diverging scales
scale(`${Diverging}-${Linear}`, _d3Scale.scaleDiverging, [
    Continuous,
    Interpolating
]);
scale(`${Diverging}-${Log}`, _d3Scale.scaleDivergingLog, [
    Continuous,
    Interpolating,
    Log
]);
scale(`${Diverging}-${Pow}`, _d3Scale.scaleDivergingPow, [
    Continuous,
    Interpolating
]);
scale(`${Diverging}-${Sqrt}`, _d3Scale.scaleDivergingSqrt, [
    Continuous,
    Interpolating
]);
scale(`${Diverging}-${Symlog}`, _d3Scale.scaleDivergingSymlog, [
    Continuous,
    Interpolating
]);
// discretizing scales
scale(Quantile, _d3Scale.scaleQuantile, [
    Discretizing,
    Quantile
]);
scale(Quantize, _d3Scale.scaleQuantize, Discretizing);
scale(Threshold, _d3Scale.scaleThreshold, Discretizing);
// discrete scales
scale(BinOrdinal, scaleBinOrdinal, [
    Discrete,
    Discretizing
]);
scale(Ordinal, _d3Scale.scaleOrdinal, Discrete);
scale(Band, band, Discrete);
scale(Point, point, Discrete);
function isValidScaleType(type) {
    return scales.has(type);
}
function hasType(key, type) {
    const s = scales.get(key);
    return s && s.metadata[type];
}
function isContinuous(key) {
    return hasType(key, Continuous);
}
function isDiscrete(key) {
    return hasType(key, Discrete);
}
function isDiscretizing(key) {
    return hasType(key, Discretizing);
}
function isLogarithmic(key) {
    return hasType(key, Log);
}
function isTemporal(key) {
    return hasType(key, Temporal);
}
function isInterpolating(key) {
    return hasType(key, Interpolating);
}
function isQuantile(key) {
    return hasType(key, Quantile);
}
const scaleProps = [
    'clamp',
    'base',
    'constant',
    'exponent'
];
function interpolateRange(interpolator, range) {
    const start = range[0], span = (0, _vegaUtil.peek)(range) - start;
    return function(i) {
        return interpolator(start + i * span);
    };
}
function interpolateColors(colors, type, gamma) {
    return _d3Interpolate.piecewise(interpolate(type || 'rgb', gamma), colors);
}
function quantizeInterpolator(interpolator, count) {
    const samples = new Array(count), n = count + 1;
    for(let i = 0; i < count;)samples[i] = interpolator(++i / n);
    return samples;
}
function scaleCopy(scale) {
    const t = scale.type, s = scale.copy();
    s.type = t;
    return s;
}
function scaleFraction(scale$1, min, max) {
    const delta = max - min;
    let i, t, s;
    if (!delta || !Number.isFinite(delta)) return (0, _vegaUtil.constant)(0.5);
    else {
        i = (t = scale$1.type).indexOf('-');
        t = i < 0 ? t : t.slice(i + 1);
        s = scale(t)().domain([
            min,
            max
        ]).range([
            0,
            1
        ]);
        scaleProps.forEach((m)=>scale$1[m] ? s[m](scale$1[m]()) : 0);
        return s;
    }
}
function interpolate(type, gamma) {
    const interp = _d3Interpolate[method(type)];
    return gamma != null && interp && interp.gamma ? interp.gamma(gamma) : interp;
}
function method(type) {
    return 'interpolate' + type.toLowerCase().split('-').map((s)=>s[0].toUpperCase() + s.slice(1)).join('');
}
const continuous = {
    blues: 'cfe1f2bed8eca8cee58fc1de74b2d75ba3cf4592c63181bd206fb2125ca40a4a90',
    greens: 'd3eecdc0e6baabdda594d3917bc77d60ba6c46ab5e329a512089430e7735036429',
    greys: 'e2e2e2d4d4d4c4c4c4b1b1b19d9d9d8888887575756262624d4d4d3535351e1e1e',
    oranges: 'fdd8b3fdc998fdb87bfda55efc9244f87f2cf06b18e4580bd14904b93d029f3303',
    purples: 'e2e1efd4d4e8c4c5e0b4b3d6a3a0cc928ec3827cb97566ae684ea25c3696501f8c',
    reds: 'fdc9b4fcb49afc9e80fc8767fa7051f6573fec3f2fdc2a25c81b1db21218970b13',
    blueGreen: 'd5efedc1e8e0a7ddd18bd2be70c6a958ba9144ad77319c5d2089460e7736036429',
    bluePurple: 'ccddecbad0e4a8c2dd9ab0d4919cc98d85be8b6db28a55a6873c99822287730f71',
    greenBlue: 'd3eecec5e8c3b1e1bb9bd8bb82cec269c2ca51b2cd3c9fc7288abd1675b10b60a1',
    orangeRed: 'fddcaffdcf9bfdc18afdad77fb9562f67d53ee6545e24932d32d1ebf130da70403',
    purpleBlue: 'dbdaebc8cee4b1c3de97b7d87bacd15b9fc93a90c01e7fb70b70ab056199045281',
    purpleBlueGreen: 'dbd8eac8cee4b0c3de93b7d872acd1549fc83892bb1c88a3097f8702736b016353',
    purpleRed: 'dcc9e2d3b3d7ce9eccd186c0da6bb2e14da0e23189d91e6fc61159ab07498f023a',
    redPurple: 'fccfccfcbec0faa9b8f98faff571a5ec539ddb3695c41b8aa908808d0179700174',
    yellowGreen: 'e4f4acd1eca0b9e2949ed68880c97c62bb6e47aa5e3297502083440e723b036034',
    yellowOrangeBrown: 'feeaa1fedd84fecc63feb746fca031f68921eb7215db5e0bc54c05ab3d038f3204',
    yellowOrangeRed: 'fee087fed16ffebd59fea849fd903efc7335f9522bee3423de1b20ca0b22af0225',
    blueOrange: '134b852f78b35da2cb9dcae1d2e5eff2f0ebfce0bafbbf74e8932fc5690d994a07',
    brownBlueGreen: '704108a0651ac79548e3c78af3e6c6eef1eac9e9e48ed1c74da79e187a72025147',
    purpleGreen: '5b1667834792a67fb6c9aed3e6d6e8eff0efd9efd5aedda971bb75368e490e5e29',
    purpleOrange: '4114696647968f83b7b9b4d6dadbebf3eeeafce0bafbbf74e8932fc5690d994a07',
    redBlue: '8c0d25bf363adf745ef4ae91fbdbc9f2efeed2e5ef9dcae15da2cb2f78b3134b85',
    redGrey: '8c0d25bf363adf745ef4ae91fcdccbfaf4f1e2e2e2c0c0c0969696646464343434',
    yellowGreenBlue: 'eff9bddbf1b4bde5b594d5b969c5be45b4c22c9ec02182b82163aa23479c1c3185',
    redYellowBlue: 'a50026d4322cf16e43fcac64fedd90faf8c1dcf1ecabd6e875abd04a74b4313695',
    redYellowGreen: 'a50026d4322cf16e43fcac63fedd8df9f7aed7ee8ea4d86e64bc6122964f006837',
    pinkYellowGreen: '8e0152c0267edd72adf0b3d6faddedf5f3efe1f2cab6de8780bb474f9125276419',
    spectral: '9e0142d13c4bf0704afcac63fedd8dfbf8b0e0f3a1a9dda269bda94288b55e4fa2',
    viridis: '440154470e61481a6c482575472f7d443a834144873d4e8a39568c35608d31688e2d708e2a788e27818e23888e21918d1f988b1fa08822a8842ab07f35b77943bf7154c56866cc5d7ad1518fd744a5db36bcdf27d2e21be9e51afde725',
    magma: '0000040404130b0924150e3720114b2c11603b0f704a107957157e651a80721f817f24828c29819a2e80a8327db6377ac43c75d1426fde4968e95462f1605df76f5cfa7f5efc8f65fe9f6dfeaf78febf84fece91fddea0fcedaffcfdbf',
    inferno: '0000040403130c0826170c3b240c4f330a5f420a68500d6c5d126e6b176e781c6d86216b932667a12b62ae305cbb3755c73e4cd24644dd513ae65c30ed6925f3771af8850ffb9506fca50afcb519fac62df6d645f2e661f3f484fcffa4',
    plasma: '0d088723069033059742039d5002a25d01a66a00a87801a88405a7900da49c179ea72198b12a90ba3488c33d80cb4779d35171da5a69e16462e76e5bed7953f2834cf68f44fa9a3dfca636fdb32ffec029fcce25f9dc24f5ea27f0f921',
    cividis: '00205100235800265d002961012b65042e670831690d346b11366c16396d1c3c6e213f6e26426e2c456e31476e374a6e3c4d6e42506e47536d4c566d51586e555b6e5a5e6e5e616e62646f66676f6a6a706e6d717270717573727976737c79747f7c75827f758682768985778c8877908b78938e789691789a94789e9778a19b78a59e77a9a177aea575b2a874b6ab73bbaf71c0b26fc5b66dc9b96acebd68d3c065d8c462ddc85fe2cb5ce7cf58ebd355f0d652f3da4ff7de4cfae249fce647',
    rainbow: '6e40aa883eb1a43db3bf3cafd83fa4ee4395fe4b83ff576eff6659ff7847ff8c38f3a130e2b72fcfcc36bee044aff05b8ff4576ff65b52f6673af27828ea8d1ddfa319d0b81cbecb23abd82f96e03d82e14c6edb5a5dd0664dbf6e40aa',
    sinebow: 'ff4040fc582af47218e78d0bd5a703bfbf00a7d5038de70b72f41858fc2a40ff402afc5818f4720be78d03d5a700bfbf03a7d50b8de71872f42a58fc4040ff582afc7218f48d0be7a703d5bf00bfd503a7e70b8df41872fc2a58ff4040',
    turbo: '23171b32204a3e2a71453493493eae4b49c54a53d7485ee44569ee4074f53c7ff8378af93295f72e9ff42ba9ef28b3e926bce125c5d925cdcf27d5c629dcbc2de3b232e9a738ee9d3ff39347f68950f9805afc7765fd6e70fe667cfd5e88fc5795fb51a1f84badf545b9f140c5ec3cd0e637dae034e4d931ecd12ef4c92bfac029ffb626ffad24ffa223ff9821ff8d1fff821dff771cfd6c1af76118f05616e84b14df4111d5380fcb2f0dc0260ab61f07ac1805a313029b0f00950c00910b00',
    browns: 'eedbbdecca96e9b97ae4a865dc9856d18954c7784cc0673fb85536ad44339f3632',
    tealBlues: 'bce4d89dd3d181c3cb65b3c245a2b9368fae347da0306a932c5985',
    teals: 'bbdfdfa2d4d58ac9c975bcbb61b0af4da5a43799982b8b8c1e7f7f127273006667',
    warmGreys: 'dcd4d0cec5c1c0b8b4b3aaa7a59c9998908c8b827f7e7673726866665c5a59504e',
    goldGreen: 'f4d166d5ca60b6c35c98bb597cb25760a6564b9c533f8f4f33834a257740146c36',
    goldOrange: 'f4d166f8be5cf8aa4cf5983bf3852aef701be2621fd65322c54923b142239e3a26',
    goldRed: 'f4d166f6be59f9aa51fc964ef6834bee734ae56249db5247cf4244c43141b71d3e',
    lightGreyRed: 'efe9e6e1dad7d5cbc8c8bdb9bbaea9cd967ddc7b43e15f19df4011dc000b',
    lightGreyTeal: 'e4eaead6dcddc8ced2b7c2c7a6b4bc64b0bf22a6c32295c11f85be1876bc',
    lightMulti: 'e0f1f2c4e9d0b0de9fd0e181f6e072f6c053f3993ef77440ef4a3c',
    lightOrange: 'f2e7daf7d5baf9c499fab184fa9c73f68967ef7860e8645bde515bd43d5b',
    lightTealBlue: 'e3e9e0c0dccf9aceca7abfc859afc0389fb9328dad2f7ca0276b95255988',
    darkBlue: '3232322d46681a5c930074af008cbf05a7ce25c0dd38daed50f3faffffff',
    darkGold: '3c3c3c584b37725e348c7631ae8b2bcfa424ecc31ef9de30fff184ffffff',
    darkGreen: '3a3a3a215748006f4d048942489e4276b340a6c63dd2d836ffeb2cffffaa',
    darkMulti: '3737371f5287197d8c29a86995ce3fffe800ffffff',
    darkRed: '3434347036339e3c38cc4037e75d1eec8620eeab29f0ce32ffeb2c'
};
const discrete = {
    accent: (0, _d3ScaleChromatic.schemeAccent),
    category10: (0, _d3ScaleChromatic.schemeCategory10),
    category20: '1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5',
    category20b: '393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6',
    category20c: '3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9',
    dark2: (0, _d3ScaleChromatic.schemeDark2),
    observable10: (0, _d3ScaleChromatic.schemeObservable10),
    paired: (0, _d3ScaleChromatic.schemePaired),
    pastel1: (0, _d3ScaleChromatic.schemePastel1),
    pastel2: (0, _d3ScaleChromatic.schemePastel2),
    set1: (0, _d3ScaleChromatic.schemeSet1),
    set2: (0, _d3ScaleChromatic.schemeSet2),
    set3: (0, _d3ScaleChromatic.schemeSet3),
    tableau10: '4c78a8f58518e4575672b7b254a24beeca3bb279a2ff9da69d755dbab0ac',
    tableau20: '4c78a89ecae9f58518ffbf7954a24b88d27ab79a20f2cf5b43989483bcb6e45756ff9d9879706ebab0acd67195fcbfd2b279a2d6a5c99e765fd8b5a5'
};
function colors(palette) {
    if ((0, _vegaUtil.isArray)(palette)) return palette;
    const n = palette.length / 6 | 0, c = new Array(n);
    for(let i = 0; i < n;)c[i] = '#' + palette.slice(i * 6, ++i * 6);
    return c;
}
function apply(_, f) {
    for(const k in _)scheme(k, f(_[k]));
}
const schemes = {};
apply(discrete, colors);
apply(continuous, (_)=>interpolateColors(colors(_)));
function scheme(name, scheme) {
    name = name && name.toLowerCase();
    if (arguments.length > 1) {
        schemes[name] = scheme;
        return this;
    } else return schemes[name];
}
const SymbolLegend = 'symbol';
const DiscreteLegend = 'discrete';
const GradientLegend = 'gradient';
const defaultFormatter = (value)=>(0, _vegaUtil.isArray)(value) ? value.map((v)=>String(v)) : String(value);
const ascending = (a, b)=>a[1] - b[1];
const descending = (a, b)=>b[1] - a[1];
/**
 * Determine the tick count or interval function.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {*} count - The desired tick count or interval specifier.
 * @param {number} minStep - The desired minimum step between tick values.
 * @return {*} - The tick count or interval function.
 */ function tickCount(scale, count, minStep) {
    let step;
    if ((0, _vegaUtil.isNumber)(count)) {
        if (scale.bins) count = Math.max(count, scale.bins.length);
        if (minStep != null) count = Math.min(count, Math.floor((0, _vegaUtil.span)(scale.domain()) / minStep || 1) + 1);
    }
    if ((0, _vegaUtil.isObject)(count)) {
        step = count.step;
        count = count.interval;
    }
    if ((0, _vegaUtil.isString)(count)) {
        count = scale.type === Time ? (0, _vegaTime.timeInterval)(count) : scale.type == UTC ? (0, _vegaTime.utcInterval)(count) : (0, _vegaUtil.error)('Only time and utc scales accept interval strings.');
        if (step) count = count.every(step);
    }
    return count;
}
/**
 * Filter a set of candidate tick values, ensuring that only tick values
 * that lie within the scale range are included.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {Array<*>} ticks - The candidate tick values.
 * @param {*} count - The tick count or interval function.
 * @return {Array<*>} - The filtered tick values.
 */ function validTicks(scale, ticks, count) {
    let range = scale.range(), lo = range[0], hi = (0, _vegaUtil.peek)(range), cmp = ascending;
    if (lo > hi) {
        range = hi;
        hi = lo;
        lo = range;
        cmp = descending;
    }
    lo = Math.floor(lo);
    hi = Math.ceil(hi);
    // filter ticks to valid values within the range
    // additionally sort ticks in range order (#2579)
    ticks = ticks.map((v)=>[
            v,
            scale(v)
        ]).filter((_)=>lo <= _[1] && _[1] <= hi).sort(cmp).map((_)=>_[0]);
    if (count > 0 && ticks.length > 1) {
        const endpoints = [
            ticks[0],
            (0, _vegaUtil.peek)(ticks)
        ];
        while(ticks.length > count && ticks.length >= 3)ticks = ticks.filter((_, i)=>!(i % 2));
        if (ticks.length < 3) ticks = endpoints;
    }
    return ticks;
}
/**
 * Generate tick values for the given scale and approximate tick count or
 * interval value. If the scale has a 'ticks' method, it will be used to
 * generate the ticks, with the count argument passed as a parameter. If the
 * scale lacks a 'ticks' method, the full scale domain will be returned.
 * @param {Scale} scale - The scale for which to generate tick values.
 * @param {*} [count] - The approximate number of desired ticks.
 * @return {Array<*>} - The generated tick values.
 */ function tickValues(scale, count) {
    return scale.bins ? validTicks(scale, scale.bins, count) : scale.ticks ? scale.ticks(count) : scale.domain();
}
/**
 * Generate a label format function for a scale. If the scale has a
 * 'tickFormat' method, it will be used to generate the formatter, with the
 * count and specifier arguments passed as parameters. If the scale lacks a
 * 'tickFormat' method, the returned formatter performs simple string coercion.
 * If the input scale is a logarithmic scale and the format specifier does not
 * indicate a desired decimal precision, a special variable precision formatter
 * that automatically trims trailing zeroes will be generated.
 * @param {Scale} scale - The scale for which to generate the label formatter.
 * @param {*} [count] - The approximate number of desired ticks.
 * @param {string} [specifier] - The format specifier. Must be a legal d3
 *   specifier string (see https://github.com/d3/d3-format#formatSpecifier) or
 *   time multi-format specifier object.
 * @return {function(*):string} - The generated label formatter.
 */ function tickFormat(locale, scale, count, specifier, formatType, noSkip) {
    const type = scale.type;
    let format = defaultFormatter;
    if (type === Time || formatType === Time) format = locale.timeFormat(specifier);
    else if (type === UTC || formatType === UTC) format = locale.utcFormat(specifier);
    else if (isLogarithmic(type)) {
        const varfmt = locale.formatFloat(specifier);
        if (noSkip || scale.bins) format = varfmt;
        else {
            const test = tickLog(scale, count, false);
            format = (_)=>test(_) ? varfmt(_) : '';
        }
    } else if (scale.tickFormat) {
        // if d3 scale has tickFormat, it must be continuous
        const d = scale.domain();
        format = locale.formatSpan(d[0], d[d.length - 1], count, specifier);
    } else if (specifier) format = locale.format(specifier);
    return format;
}
function tickLog(scale, count, values) {
    const ticks = tickValues(scale, count), base = scale.base(), logb = Math.log(base), k = Math.max(1, base * count / ticks.length);
    // apply d3-scale's log format filter criteria
    const test = (d)=>{
        let i = d / Math.pow(base, Math.round(Math.log(d) / logb));
        if (i * base < base - 0.5) i *= base;
        return i <= k;
    };
    return values ? ticks.filter(test) : test;
}
const symbols = {
    [Quantile]: 'quantiles',
    [Quantize]: 'thresholds',
    [Threshold]: 'domain'
};
const formats = {
    [Quantile]: 'quantiles',
    [Quantize]: 'domain'
};
function labelValues(scale, count) {
    return scale.bins ? binValues(scale.bins) : scale.type === Log ? tickLog(scale, count, true) : symbols[scale.type] ? thresholdValues(scale[symbols[scale.type]]()) : tickValues(scale, count);
}
function thresholdFormat(locale, scale, specifier) {
    const _ = scale[formats[scale.type]](), n = _.length;
    let d = n > 1 ? _[1] - _[0] : _[0], i;
    for(i = 1; i < n; ++i)d = Math.min(d, _[i] - _[i - 1]);
    // tickCount = 3 ticks times 10 for increased resolution
    return locale.formatSpan(0, d, 30, specifier);
}
function thresholdValues(thresholds) {
    const values = [
        -Infinity
    ].concat(thresholds);
    values.max = Infinity;
    return values;
}
function binValues(bins) {
    const values = bins.slice(0, -1);
    values.max = (0, _vegaUtil.peek)(bins);
    return values;
}
const isDiscreteRange = (scale)=>symbols[scale.type] || scale.bins;
function labelFormat(locale, scale, count, type, specifier, formatType, noSkip) {
    const format = formats[scale.type] && formatType !== Time && formatType !== UTC ? thresholdFormat(locale, scale, specifier) : tickFormat(locale, scale, count, specifier, formatType, noSkip);
    return type === SymbolLegend && isDiscreteRange(scale) ? formatRange(format) : type === DiscreteLegend ? formatDiscrete(format) : formatPoint(format);
}
const formatRange = (format)=>(value, index, array)=>{
        const limit = get(array[index + 1], get(array.max, Infinity)), lo = formatValue(value, format), hi = formatValue(limit, format);
        return lo && hi ? lo + ' \u2013 ' + hi : hi ? '< ' + hi : '\u2265 ' + lo;
    };
const get = (value, dflt)=>value != null ? value : dflt;
const formatDiscrete = (format)=>(value, index)=>index ? format(value) : null;
const formatPoint = (format)=>(value)=>format(value);
const formatValue = (value, format)=>Number.isFinite(value) ? format(value) : null;
function labelFraction(scale) {
    const domain = scale.domain(), count = domain.length - 1;
    let lo = +domain[0], hi = +(0, _vegaUtil.peek)(domain), span = hi - lo;
    if (scale.type === Threshold) {
        const adjust = count ? span / count : 0.1;
        lo -= adjust;
        hi += adjust;
        span = hi - lo;
    }
    return (value)=>(value - lo) / span;
}
function format(locale, scale, specifier, formatType) {
    const type = formatType || scale.type;
    // replace abbreviated time specifiers to improve screen reader experience
    if ((0, _vegaUtil.isString)(specifier) && isTemporal(type)) specifier = specifier.replace(/%a/g, '%A').replace(/%b/g, '%B');
    return !specifier && type === Time ? locale.timeFormat('%A, %d %B %Y, %X') : !specifier && type === UTC ? locale.utcFormat('%A, %d %B %Y, %X UTC') : labelFormat(locale, scale, 5, null, specifier, formatType, true);
}
function domainCaption(locale, scale, opt) {
    opt = opt || {};
    const max = Math.max(3, opt.maxlen || 7), fmt = format(locale, scale, opt.format, opt.formatType);
    // if scale breaks domain into bins, describe boundaries
    if (isDiscretizing(scale.type)) {
        const v = labelValues(scale).slice(1).map(fmt), n = v.length;
        return `${n} boundar${n === 1 ? 'y' : 'ies'}: ${v.join(', ')}`;
    } else if (isDiscrete(scale.type)) {
        const d = scale.domain(), n = d.length, v = n > max ? d.slice(0, max - 2).map(fmt).join(', ') + ', ending with ' + d.slice(-1).map(fmt) : d.map(fmt).join(', ');
        return `${n} value${n === 1 ? '' : 's'}: ${v}`;
    } else {
        const d = scale.domain();
        return `values from ${fmt(d[0])} to ${fmt((0, _vegaUtil.peek)(d))}`;
    }
}

},{"vega-util":"kncZn","d3-array":"4pSqo","d3-scale":"33tt3","d3-interpolate":"gKQHn","d3-scale-chromatic":"5y5Lb","vega-time":"c8K2C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"33tt3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"hxl8x","./identity.js":"9LL7I","./linear.js":"7SztY","./log.js":"idfbA","./symlog.js":"g07CI","./ordinal.js":"hup2W","./pow.js":"ljC55","./radial.js":"42gCO","./quantile.js":"jb3oU","./quantize.js":"4DTyJ","./threshold.js":"2GhxC","./time.js":"5G37R","./utcTime.js":"9Mols","./sequential.js":"2SIjS","./sequentialQuantile.js":"4bzQH","./diverging.js":"ecRvG","./tickFormat.js":"k6jbH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hxl8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":"4pSqo","./init.js":"h9ql6","./ordinal.js":"hup2W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h9ql6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hup2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new (0, _d3Array.InternMap)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, _d3Array.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"4pSqo","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9LL7I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, _numberJsDefault.default)) : [
        0,
        1
    ];
    return (0, _linearJs.linearish)(scale);
}

},{"./linear.js":"7SztY","./number.js":"lyk5i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7SztY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"4pSqo","./continuous.js":"1zZMt","./init.js":"h9ql6","./tickFormat.js":"k6jbH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1zZMt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":"4pSqo","d3-interpolate":"gKQHn","./constant.js":"4keph","./number.js":"lyk5i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKQHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"bQQ1J","./array.js":"9Rmt3","./basis.js":"8v2RP","./basisClosed.js":"93ABE","./date.js":"4wvkD","./discrete.js":"bwmhY","./hue.js":"lP44T","./number.js":"lU4Z0","./numberArray.js":"8eUFq","./object.js":"csAzg","./round.js":"aOsJ9","./string.js":"iNjOh","./transform/index.js":"iN9Uy","./zoom.js":"7BEmP","./rgb.js":"bG7wU","./hsl.js":"jLI2t","./lab.js":"5bI6L","./hcl.js":"aNxuN","./cubehelix.js":"8c1po","./piecewise.js":"gakap","./quantize.js":"6ihUf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bQQ1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":"c8Fkk","./rgb.js":"bG7wU","./array.js":"9Rmt3","./date.js":"4wvkD","./number.js":"lU4Z0","./object.js":"csAzg","./string.js":"iNjOh","./constant.js":"lJpIo","./numberArray.js":"8eUFq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c8Fkk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"cZjkf","./lab.js":"bikfP","./cubehelix.js":"b6Cou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cZjkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"34Inj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"34Inj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bikfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "default", ()=>lab);
parcelHelpers.export(exports, "Lab", ()=>Lab);
parcelHelpers.export(exports, "lch", ()=>lch);
parcelHelpers.export(exports, "hcl", ()=>hcl);
parcelHelpers.export(exports, "Hcl", ()=>Hcl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.degrees);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.radians);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"34Inj","./color.js":"cZjkf","./math.js":"ddscs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ddscs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b6Cou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"34Inj","./color.js":"cZjkf","./math.js":"ddscs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bG7wU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"c8Fkk","./basis.js":"8v2RP","./basisClosed.js":"93ABE","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8v2RP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"93ABE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"8v2RP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"igqbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"lJpIo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lJpIo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Rmt3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"bQQ1J","./numberArray.js":"8eUFq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8eUFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4wvkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lU4Z0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"csAzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"bQQ1J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iNjOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"lU4Z0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwmhY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lP44T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = (0, _colorJs.hue)(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    });
var _colorJs = require("./color.js");

},{"./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aOsJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iN9Uy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"lU4Z0","./parse.js":"4Gvvu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Gvvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"8mHaF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8mHaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7BEmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jLI2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", ()=>hslLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"c8Fkk","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5bI6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lab);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":"c8Fkk","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aNxuN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", ()=>hclLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"c8Fkk","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8c1po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"c8Fkk","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gakap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, _valueJsDefault.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"./value.js":"bQQ1J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ihUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4keph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyk5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6jbH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"4pSqo","d3-format":"9IytR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"idfbA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _d3Format.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _d3Format.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuousJs.copy)(scale, log()).base(scale.base());
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"4pSqo","d3-format":"9IytR","./nice.js":"dN8Tk","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dN8Tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g07CI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"7SztY","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ljC55":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"7SztY","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"42gCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>radial);
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuousJsDefault.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, _numberJsDefault.default))).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return (0, _linearJs.linearish)(scale);
}

},{"./continuous.js":"1zZMt","./init.js":"h9ql6","./linear.js":"7SztY","./number.js":"lyk5i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jb3oU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"4pSqo","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DTyJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"4pSqo","./linear.js":"7SztY","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2GhxC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"4pSqo","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5G37R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>time);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"5UzaV","d3-time-format":"l85y1","./continuous.js":"1zZMt","./init.js":"h9ql6","./nice.js":"dN8Tk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Mols":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcTime);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _timeJs = require("./time.js");
var _initJs = require("./init.js");
function utcTime() {
    return (0, _initJs.initRange).apply((0, _timeJs.calendar)((0, _d3Time.utcTicks), (0, _d3Time.utcTickInterval), (0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3TimeFormat.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"5UzaV","d3-time-format":"l85y1","./time.js":"5G37R","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2SIjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"gKQHn","./continuous.js":"1zZMt","./init.js":"h9ql6","./linear.js":"7SztY","./log.js":"idfbA","./symlog.js":"g07CI","./pow.js":"ljC55","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bzQH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequentialQuantile);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function sequentialQuantile() {
    var domain = [], interpolator = (0, _continuousJs.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _d3Array.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _d3Array.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}

},{"d3-array":"4pSqo","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ecRvG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _sequentialJs = require("./sequential.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuousJs.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _d3Interpolate.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, diverging());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"gKQHn","./continuous.js":"1zZMt","./init.js":"h9ql6","./linear.js":"7SztY","./log.js":"idfbA","./sequential.js":"2SIjS","./symlog.js":"g07CI","./pow.js":"ljC55","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5y5Lb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemeObservable10", ()=>(0, _observable10JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _observable10Js = require("./categorical/observable10.js");
var _observable10JsDefault = parcelHelpers.interopDefault(_observable10Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"jpLdi","./categorical/Accent.js":"5D1Ra","./categorical/Dark2.js":"6rKCe","./categorical/observable10.js":"9cKJK","./categorical/Paired.js":"1NhJ9","./categorical/Pastel1.js":"9EAtH","./categorical/Pastel2.js":"7X9fp","./categorical/Set1.js":"jIw3p","./categorical/Set2.js":"aMpd0","./categorical/Set3.js":"hD9GR","./categorical/Tableau10.js":false,"./diverging/BrBG.js":false,"./diverging/PRGn.js":false,"./diverging/PiYG.js":false,"./diverging/PuOr.js":false,"./diverging/RdBu.js":false,"./diverging/RdGy.js":false,"./diverging/RdYlBu.js":false,"./diverging/RdYlGn.js":false,"./diverging/Spectral.js":false,"./sequential-multi/BuGn.js":false,"./sequential-multi/BuPu.js":false,"./sequential-multi/GnBu.js":false,"./sequential-multi/OrRd.js":false,"./sequential-multi/PuBuGn.js":false,"./sequential-multi/PuBu.js":false,"./sequential-multi/PuRd.js":false,"./sequential-multi/RdPu.js":false,"./sequential-multi/YlGnBu.js":false,"./sequential-multi/YlGn.js":false,"./sequential-multi/YlOrBr.js":false,"./sequential-multi/YlOrRd.js":false,"./sequential-single/Blues.js":false,"./sequential-single/Greens.js":false,"./sequential-single/Greys.js":false,"./sequential-single/Purples.js":false,"./sequential-single/Reds.js":false,"./sequential-single/Oranges.js":false,"./sequential-multi/cividis.js":false,"./sequential-multi/cubehelix.js":false,"./sequential-multi/rainbow.js":false,"./sequential-multi/sinebow.js":false,"./sequential-multi/turbo.js":false,"./sequential-multi/viridis.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jpLdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j7FVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5D1Ra":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6rKCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9cKJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1NhJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9EAtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7X9fp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jIw3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMpd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hD9GR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gaxHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisticks", ()=>AxisTicks);
parcelHelpers.export(exports, "datajoin", ()=>DataJoin);
parcelHelpers.export(exports, "encode", ()=>Encode);
parcelHelpers.export(exports, "legendentries", ()=>LegendEntries);
parcelHelpers.export(exports, "linkpath", ()=>LinkPath);
parcelHelpers.export(exports, "pie", ()=>Pie);
parcelHelpers.export(exports, "scale", ()=>Scale);
parcelHelpers.export(exports, "sortitems", ()=>SortItems);
parcelHelpers.export(exports, "stack", ()=>Stack);
var _vegaDataflow = require("vega-dataflow");
var _vegaScale = require("vega-scale");
var _vegaUtil = require("vega-util");
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
/**
 * Generates axis ticks for visualizing a spatial scale.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Scale} params.scale - The scale to generate ticks for.
 * @param {*} [params.count=10] - The approximate number of ticks, or
 *   desired tick interval, to use.
 * @param {Array<*>} [params.values] - The exact tick values to use.
 *   These must be legal domain values for the provided scale.
 *   If provided, the count argument is ignored.
 * @param {function(*):string} [params.formatSpecifier] - A format specifier
 *   to use in conjunction with scale.tickFormat. Legal values are
 *   any valid d3 4.0 format specifier.
 * @param {function(*):string} [params.format] - The format function to use.
 *   If provided, the formatSpecifier argument is ignored.
 */ function AxisTicks(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(AxisTicks, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !_.modified()) return pulse.StopPropagation;
        var locale = pulse.dataflow.locale(), out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), ticks = this.value, scale = _.scale, tally = _.count == null ? _.values ? _.values.length : 10 : _.count, count = (0, _vegaScale.tickCount)(scale, tally, _.minstep), format = _.format || (0, _vegaScale.tickFormat)(locale, scale, count, _.formatSpecifier, _.formatType, !!_.values), values = _.values ? (0, _vegaScale.validTicks)(scale, _.values, count) : (0, _vegaScale.tickValues)(scale, count);
        if (ticks) out.rem = ticks;
        ticks = values.map((value, i)=>(0, _vegaDataflow.ingest)({
                index: i / (values.length - 1 || 1),
                value: value,
                label: format(value)
            }));
        if (_.extra && ticks.length) // add an extra tick pegged to the initial domain value
        // this is used to generate axes with 'binned' domains
        ticks.push((0, _vegaDataflow.ingest)({
            index: -1,
            extra: {
                value: ticks[0].value
            },
            label: ''
        }));
        out.source = ticks;
        out.add = ticks;
        this.value = ticks;
        return out;
    }
});
/**
 * Joins a set of data elements against a set of visual items.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): object} [params.item] - An item generator function.
 * @param {function(object): *} [params.key] - The key field associating data and visual items.
 */ function DataJoin(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
function defaultItemCreate() {
    return (0, _vegaDataflow.ingest)({});
}
function newMap(key) {
    const map = (0, _vegaUtil.fastmap)().test((t)=>t.exit);
    map.lookup = (t)=>map.get(key(t));
    return map;
}
(0, _vegaUtil.inherits)(DataJoin, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var df = pulse.dataflow, out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), item = _.item || defaultItemCreate, key = _.key || (0, _vegaDataflow.tupleid), map = this.value;
        // prevent transient (e.g., hover) requests from
        // cascading across marks derived from marks
        if ((0, _vegaUtil.isArray)(out.encode)) out.encode = null;
        if (map && (_.modified('key') || pulse.modified(key))) (0, _vegaUtil.error)('DataJoin does not support modified key function or fields.');
        if (!map) {
            pulse = pulse.addAll();
            this.value = map = newMap(key);
        }
        pulse.visit(pulse.ADD, (t)=>{
            const k = key(t);
            let x = map.get(k);
            if (x) {
                if (x.exit) {
                    map.empty--;
                    out.add.push(x);
                } else out.mod.push(x);
            } else {
                x = item(t);
                map.set(k, x);
                out.add.push(x);
            }
            x.datum = t;
            x.exit = false;
        });
        pulse.visit(pulse.MOD, (t)=>{
            const k = key(t), x = map.get(k);
            if (x) {
                x.datum = t;
                out.mod.push(x);
            }
        });
        pulse.visit(pulse.REM, (t)=>{
            const k = key(t), x = map.get(k);
            if (t === x.datum && !x.exit) {
                out.rem.push(x);
                x.exit = true;
                ++map.empty;
            }
        });
        if (pulse.changed(pulse.ADD_MOD)) out.modifies('datum');
        if (pulse.clean() || _.clean && map.empty > df.cleanThreshold) df.runAfter(map.clean);
        return out;
    }
});
/**
 * Invokes encoding functions for visual items.
 * @constructor
 * @param {object} params - The parameters to the encoding functions. This
 *   parameter object will be passed through to all invoked encoding functions.
 * @param {object} [params.mod=false] - Flag indicating if tuples in the input
 *   mod set that are unmodified by encoders should be included in the output.
 * @param {object} param.encoders - The encoding functions
 * @param {function(object, object): boolean} [param.encoders.update] - Update encoding set
 * @param {function(object, object): boolean} [param.encoders.enter] - Enter encoding set
 * @param {function(object, object): boolean} [param.encoders.exit] - Exit encoding set
 */ function Encode(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(Encode, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ADD_REM), fmod = _.mod || false, encoders = _.encoders, encode = pulse.encode;
        // if an array, the encode directive includes additional sets
        // that must be defined in order for the primary set to be invoked
        // e.g., only run the update set if the hover set is defined
        if ((0, _vegaUtil.isArray)(encode)) {
            if (out.changed() || encode.every((e)=>encoders[e])) {
                encode = encode[0];
                out.encode = null; // consume targeted encode directive
            } else return pulse.StopPropagation;
        }
        // marshall encoder functions
        var reenter = encode === 'enter', update = encoders.update || (0, _vegaUtil.falsy), enter = encoders.enter || (0, _vegaUtil.falsy), exit = encoders.exit || (0, _vegaUtil.falsy), set = (encode && !reenter ? encoders[encode] : update) || (0, _vegaUtil.falsy);
        if (pulse.changed(pulse.ADD)) {
            pulse.visit(pulse.ADD, (t)=>{
                enter(t, _);
                update(t, _);
            });
            out.modifies(enter.output);
            out.modifies(update.output);
            if (set !== (0, _vegaUtil.falsy) && set !== update) {
                pulse.visit(pulse.ADD, (t)=>{
                    set(t, _);
                });
                out.modifies(set.output);
            }
        }
        if (pulse.changed(pulse.REM) && exit !== (0, _vegaUtil.falsy)) {
            pulse.visit(pulse.REM, (t)=>{
                exit(t, _);
            });
            out.modifies(exit.output);
        }
        if (reenter || set !== (0, _vegaUtil.falsy)) {
            const flag = pulse.MOD | (_.modified() ? pulse.REFLOW : 0);
            if (reenter) {
                pulse.visit(flag, (t)=>{
                    const mod = enter(t, _) || fmod;
                    if (set(t, _) || mod) out.mod.push(t);
                });
                if (out.mod.length) out.modifies(enter.output);
            } else pulse.visit(flag, (t)=>{
                if (set(t, _) || fmod) out.mod.push(t);
            });
            if (out.mod.length) out.modifies(set.output);
        }
        return out.changed() ? out : pulse.StopPropagation;
    }
});
/**
 * Generates legend entries for visualizing a scale.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Scale} params.scale - The scale to generate items for.
 * @param {*} [params.count=5] - The approximate number of items, or
 *   desired tick interval, to use.
 * @param {*} [params.limit] - The maximum number of entries to
 *   include in a symbol legend.
 * @param {Array<*>} [params.values] - The exact tick values to use.
 *   These must be legal domain values for the provided scale.
 *   If provided, the count argument is ignored.
 * @param {string} [params.formatSpecifier] - A format specifier
 *   to use in conjunction with scale.tickFormat. Legal values are
 *   any valid D3 format specifier string.
 * @param {function(*):string} [params.format] - The format function to use.
 *   If provided, the formatSpecifier argument is ignored.
 */ function LegendEntries(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
(0, _vegaUtil.inherits)(LegendEntries, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value != null && !_.modified()) return pulse.StopPropagation;
        var locale = pulse.dataflow.locale(), out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), items = this.value, type = _.type || (0, _vegaScale.SymbolLegend), scale = _.scale, limit = +_.limit, count = (0, _vegaScale.tickCount)(scale, _.count == null ? 5 : _.count, _.minstep), lskip = !!_.values || type === (0, _vegaScale.SymbolLegend), format = _.format || (0, _vegaScale.labelFormat)(locale, scale, count, type, _.formatSpecifier, _.formatType, lskip), values = _.values || (0, _vegaScale.labelValues)(scale, count), domain, fraction, size, offset, ellipsis;
        if (items) out.rem = items;
        if (type === (0, _vegaScale.SymbolLegend)) {
            if (limit && values.length > limit) {
                pulse.dataflow.warn('Symbol legend count exceeds limit, filtering items.');
                items = values.slice(0, limit - 1);
                ellipsis = true;
            } else items = values;
            if ((0, _vegaUtil.isFunction)(size = _.size)) {
                // if first value maps to size zero, remove from list (vega#717)
                if (!_.values && scale(items[0]) === 0) items = items.slice(1);
                // compute size offset for legend entries
                offset = items.reduce((max, value)=>Math.max(max, size(value, _)), 0);
            } else size = (0, _vegaUtil.constant)(offset = size || 8);
            items = items.map((value, index)=>(0, _vegaDataflow.ingest)({
                    index: index,
                    label: format(value, index, items),
                    value: value,
                    offset: offset,
                    size: size(value, _)
                }));
            if (ellipsis) {
                ellipsis = values[items.length];
                items.push((0, _vegaDataflow.ingest)({
                    index: items.length,
                    label: `\u2026${values.length - items.length} entries`,
                    value: ellipsis,
                    offset: offset,
                    size: size(ellipsis, _)
                }));
            }
        } else if (type === (0, _vegaScale.GradientLegend)) {
            domain = scale.domain(), fraction = (0, _vegaScale.scaleFraction)(scale, domain[0], (0, _vegaUtil.peek)(domain));
            // if automatic label generation produces 2 or fewer values,
            // use the domain end points instead (fixes vega/vega#1364)
            if (values.length < 3 && !_.values && domain[0] !== (0, _vegaUtil.peek)(domain)) values = [
                domain[0],
                (0, _vegaUtil.peek)(domain)
            ];
            items = values.map((value, index)=>(0, _vegaDataflow.ingest)({
                    index: index,
                    label: format(value, index, values),
                    value: value,
                    perc: fraction(value)
                }));
        } else {
            size = values.length - 1;
            fraction = (0, _vegaScale.labelFraction)(scale);
            items = values.map((value, index)=>(0, _vegaDataflow.ingest)({
                    index: index,
                    label: format(value, index, values),
                    value: value,
                    perc: index ? fraction(value) : 0,
                    perc2: index === size ? 1 : fraction(values[index + 1])
                }));
        }
        out.source = items;
        out.add = items;
        this.value = items;
        return out;
    }
});
const sourceX = (t)=>t.source.x;
const sourceY = (t)=>t.source.y;
const targetX = (t)=>t.target.x;
const targetY = (t)=>t.target.y;
/**
 * Layout paths linking source and target elements.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function LinkPath(params) {
    (0, _vegaDataflow.Transform).call(this, {}, params);
}
LinkPath.Definition = {
    'type': 'LinkPath',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'sourceX',
            'type': 'field',
            'default': 'source.x'
        },
        {
            'name': 'sourceY',
            'type': 'field',
            'default': 'source.y'
        },
        {
            'name': 'targetX',
            'type': 'field',
            'default': 'target.x'
        },
        {
            'name': 'targetY',
            'type': 'field',
            'default': 'target.y'
        },
        {
            'name': 'orient',
            'type': 'enum',
            'default': 'vertical',
            'values': [
                'horizontal',
                'vertical',
                'radial'
            ]
        },
        {
            'name': 'shape',
            'type': 'enum',
            'default': 'line',
            'values': [
                'line',
                'arc',
                'curve',
                'diagonal',
                'orthogonal'
            ]
        },
        {
            'name': 'require',
            'type': 'signal'
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'path'
        }
    ]
};
(0, _vegaUtil.inherits)(LinkPath, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var sx = _.sourceX || sourceX, sy = _.sourceY || sourceY, tx = _.targetX || targetX, ty = _.targetY || targetY, as = _.as || 'path', orient = _.orient || 'vertical', shape = _.shape || 'line', path = Paths.get(shape + '-' + orient) || Paths.get(shape);
        if (!path) (0, _vegaUtil.error)('LinkPath unsupported type: ' + _.shape + (_.orient ? '-' + _.orient : ''));
        pulse.visit(pulse.SOURCE, (t)=>{
            t[as] = path(sx(t), sy(t), tx(t), ty(t));
        });
        return pulse.reflow(_.modified()).modifies(as);
    }
});
const line = (sx, sy, tx, ty)=>'M' + sx + ',' + sy + 'L' + tx + ',' + ty;
const lineR = (sa, sr, ta, tr)=>line(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const arc = (sx, sy, tx, ty)=>{
    var dx = tx - sx, dy = ty - sy, rr = Math.hypot(dx, dy) / 2, ra = 180 * Math.atan2(dy, dx) / Math.PI;
    return 'M' + sx + ',' + sy + 'A' + rr + ',' + rr + ' ' + ra + ' 0 1' + ' ' + tx + ',' + ty;
};
const arcR = (sa, sr, ta, tr)=>arc(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const curve = (sx, sy, tx, ty)=>{
    const dx = tx - sx, dy = ty - sy, ix = 0.2 * (dx + dy), iy = 0.2 * (dy - dx);
    return 'M' + sx + ',' + sy + 'C' + (sx + ix) + ',' + (sy + iy) + ' ' + (tx + iy) + ',' + (ty - ix) + ' ' + tx + ',' + ty;
};
const curveR = (sa, sr, ta, tr)=>curve(sr * Math.cos(sa), sr * Math.sin(sa), tr * Math.cos(ta), tr * Math.sin(ta));
const orthoX = (sx, sy, tx, ty)=>'M' + sx + ',' + sy + 'V' + ty + 'H' + tx;
const orthoY = (sx, sy, tx, ty)=>'M' + sx + ',' + sy + 'H' + tx + 'V' + ty;
const orthoR = (sa, sr, ta, tr)=>{
    const sc = Math.cos(sa), ss = Math.sin(sa), tc = Math.cos(ta), ts = Math.sin(ta), sf = Math.abs(ta - sa) > Math.PI ? ta <= sa : ta > sa;
    return 'M' + sr * sc + ',' + sr * ss + 'A' + sr + ',' + sr + ' 0 0,' + (sf ? 1 : 0) + ' ' + sr * tc + ',' + sr * ts + 'L' + tr * tc + ',' + tr * ts;
};
const diagonalX = (sx, sy, tx, ty)=>{
    const m = (sx + tx) / 2;
    return 'M' + sx + ',' + sy + 'C' + m + ',' + sy + ' ' + m + ',' + ty + ' ' + tx + ',' + ty;
};
const diagonalY = (sx, sy, tx, ty)=>{
    const m = (sy + ty) / 2;
    return 'M' + sx + ',' + sy + 'C' + sx + ',' + m + ' ' + tx + ',' + m + ' ' + tx + ',' + ty;
};
const diagonalR = (sa, sr, ta, tr)=>{
    const sc = Math.cos(sa), ss = Math.sin(sa), tc = Math.cos(ta), ts = Math.sin(ta), mr = (sr + tr) / 2;
    return 'M' + sr * sc + ',' + sr * ss + 'C' + mr * sc + ',' + mr * ss + ' ' + mr * tc + ',' + mr * ts + ' ' + tr * tc + ',' + tr * ts;
};
const Paths = (0, _vegaUtil.fastmap)({
    'line': line,
    'line-radial': lineR,
    'arc': arc,
    'arc-radial': arcR,
    'curve': curve,
    'curve-radial': curveR,
    'orthogonal-horizontal': orthoX,
    'orthogonal-vertical': orthoY,
    'orthogonal-radial': orthoR,
    'diagonal-horizontal': diagonalX,
    'diagonal-vertical': diagonalY,
    'diagonal-radial': diagonalR
});
/**
 * Pie and donut chart layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size pie segments.
 * @param {number} [params.startAngle=0] - The start angle (in radians) of the layout.
 * @param {number} [params.endAngle=2π] - The end angle (in radians) of the layout.
 * @param {boolean} [params.sort] - Boolean flag for sorting sectors by value.
 */ function Pie(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Pie.Definition = {
    'type': 'Pie',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'startAngle',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'endAngle',
            'type': 'number',
            'default': 6.283185307179586
        },
        {
            'name': 'sort',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'startAngle',
                'endAngle'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(Pie, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var as = _.as || [
            'startAngle',
            'endAngle'
        ], startAngle = as[0], endAngle = as[1], field = _.field || (0, _vegaUtil.one), start = _.startAngle || 0, stop = _.endAngle != null ? _.endAngle : 2 * Math.PI, data = pulse.source, values = data.map(field), n = values.length, a = start, k = (stop - start) / (0, _d3Array.sum)(values), index = (0, _d3Array.range)(n), i, t, v;
        if (_.sort) index.sort((a, b)=>values[a] - values[b]);
        for(i = 0; i < n; ++i){
            v = values[index[i]];
            t = data[index[i]];
            t[startAngle] = a;
            t[endAngle] = a += v * k;
        }
        this.value = values;
        return pulse.reflow(_.modified()).modifies(as);
    }
});
const DEFAULT_COUNT = 5;
function includeZero(scale) {
    const type = scale.type;
    return !scale.bins && (type === (0, _vegaScale.Linear) || type === (0, _vegaScale.Pow) || type === (0, _vegaScale.Sqrt));
}
function includePad(type) {
    return (0, _vegaScale.isContinuous)(type) && type !== (0, _vegaScale.Sequential);
}
const SKIP = (0, _vegaUtil.toSet)([
    'set',
    'modified',
    'clear',
    'type',
    'scheme',
    'schemeExtent',
    'schemeCount',
    'domain',
    'domainMin',
    'domainMid',
    'domainMax',
    'domainRaw',
    'domainImplicit',
    'nice',
    'zero',
    'bins',
    'range',
    'rangeStep',
    'round',
    'reverse',
    'interpolate',
    'interpolateGamma'
]);
/**
 * Maintains a scale function mapping data values to visual channels.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Scale(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this.modified(true); // always treat as modified
}
(0, _vegaUtil.inherits)(Scale, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var df = pulse.dataflow, scale$1 = this.value, key = scaleKey(_);
        if (!scale$1 || key !== scale$1.type) this.value = scale$1 = (0, _vegaScale.scale)(key)();
        for(key in _)if (!SKIP[key]) {
            // padding is a scale property for band/point but not others
            if (key === 'padding' && includePad(scale$1.type)) continue;
            // invoke scale property setter, raise warning if not found
            (0, _vegaUtil.isFunction)(scale$1[key]) ? scale$1[key](_[key]) : df.warn('Unsupported scale property: ' + key);
        }
        configureRange(scale$1, _, configureBins(scale$1, _, configureDomain(scale$1, _, df)));
        return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    }
});
function scaleKey(_) {
    var t = _.type, d = '', n;
    // backwards compatibility pre Vega 5.
    if (t === (0, _vegaScale.Sequential)) return (0, _vegaScale.Sequential) + '-' + (0, _vegaScale.Linear);
    if (isContinuousColor(_)) {
        n = _.rawDomain ? _.rawDomain.length : _.domain ? _.domain.length + +(_.domainMid != null) : 0;
        d = n === 2 ? (0, _vegaScale.Sequential) + '-' : n === 3 ? (0, _vegaScale.Diverging) + '-' : '';
    }
    return (d + t || (0, _vegaScale.Linear)).toLowerCase();
}
function isContinuousColor(_) {
    const t = _.type;
    return (0, _vegaScale.isContinuous)(t) && t !== (0, _vegaScale.Time) && t !== (0, _vegaScale.UTC) && (_.scheme || _.range && _.range.length && _.range.every((0, _vegaUtil.isString)));
}
function configureDomain(scale, _, df) {
    // check raw domain, if provided use that and exit early
    const raw = rawDomain(scale, _.domainRaw, df);
    if (raw > -1) return raw;
    var domain = _.domain, type = scale.type, zero = _.zero || _.zero === undefined && includeZero(scale), n, mid;
    if (!domain) return 0;
    // adjust domain based on zero, min, max settings
    if (zero || _.domainMin != null || _.domainMax != null || _.domainMid != null) {
        n = (domain = domain.slice()).length - 1 || 1;
        if (zero) {
            if (domain[0] > 0) domain[0] = 0;
            if (domain[n] < 0) domain[n] = 0;
        }
        if (_.domainMin != null) domain[0] = _.domainMin;
        if (_.domainMax != null) domain[n] = _.domainMax;
        if (_.domainMid != null) {
            mid = _.domainMid;
            const i = mid > domain[n] ? n + 1 : mid < domain[0] ? 0 : n;
            if (i !== n) df.warn('Scale domainMid exceeds domain min or max.', mid);
            domain.splice(i, 0, mid);
        }
    }
    // adjust continuous domain for minimum pixel padding
    if (includePad(type) && _.padding && domain[0] !== (0, _vegaUtil.peek)(domain)) domain = padDomain(type, domain, _.range, _.padding, _.exponent, _.constant);
    // set the scale domain
    scale.domain(domainCheck(type, domain, df));
    // if ordinal scale domain is defined, prevent implicit
    // domain construction as side-effect of scale lookup
    if (type === (0, _vegaScale.Ordinal)) scale.unknown(_.domainImplicit ? (0, _vegaScale.scaleImplicit) : undefined);
    // perform 'nice' adjustment as requested
    if (_.nice && scale.nice) scale.nice(_.nice !== true && (0, _vegaScale.tickCount)(scale, _.nice) || null);
    // return the cardinality of the domain
    return domain.length;
}
function rawDomain(scale, raw, df) {
    if (raw) {
        scale.domain(domainCheck(scale.type, raw, df));
        return raw.length;
    } else return -1;
}
function padDomain(type, domain, range, pad, exponent, constant) {
    var span = Math.abs((0, _vegaUtil.peek)(range) - range[0]), frac = span / (span - 2 * pad), d = type === (0, _vegaScale.Log) ? (0, _vegaUtil.zoomLog)(domain, null, frac) : type === (0, _vegaScale.Sqrt) ? (0, _vegaUtil.zoomPow)(domain, null, frac, 0.5) : type === (0, _vegaScale.Pow) ? (0, _vegaUtil.zoomPow)(domain, null, frac, exponent || 1) : type === (0, _vegaScale.Symlog) ? (0, _vegaUtil.zoomSymlog)(domain, null, frac, constant || 1) : (0, _vegaUtil.zoomLinear)(domain, null, frac);
    domain = domain.slice();
    domain[0] = d[0];
    domain[domain.length - 1] = d[1];
    return domain;
}
function domainCheck(type, domain, df) {
    if ((0, _vegaScale.isLogarithmic)(type)) {
        // sum signs of domain values
        // if all pos or all neg, abs(sum) === domain.length
        var s = Math.abs(domain.reduce((s, v)=>s + (v < 0 ? -1 : v > 0 ? 1 : 0), 0));
        if (s !== domain.length) df.warn('Log scale domain includes zero: ' + (0, _vegaUtil.stringValue)(domain));
    }
    return domain;
}
function configureBins(scale, _, count) {
    let bins = _.bins;
    if (bins && !(0, _vegaUtil.isArray)(bins)) {
        // generate bin boundary array
        const domain = scale.domain(), lo = domain[0], hi = (0, _vegaUtil.peek)(domain), step = bins.step;
        let start = bins.start == null ? lo : bins.start, stop = bins.stop == null ? hi : bins.stop;
        if (!step) (0, _vegaUtil.error)('Scale bins parameter missing step property.');
        if (start < lo) start = step * Math.ceil(lo / step);
        if (stop > hi) stop = step * Math.floor(hi / step);
        bins = (0, _d3Array.range)(start, stop + step / 2, step);
    }
    if (bins) // assign bin boundaries to scale instance
    scale.bins = bins;
    else if (scale.bins) // no current bins, remove bins if previously set
    delete scale.bins;
    // special handling for bin-ordinal scales
    if (scale.type === (0, _vegaScale.BinOrdinal)) {
        if (!bins) // the domain specifies the bins
        scale.bins = scale.domain();
        else if (!_.domain && !_.domainRaw) {
            // the bins specify the domain
            scale.domain(bins);
            count = bins.length;
        }
    }
    // return domain cardinality
    return count;
}
function configureRange(scale, _, count) {
    var type = scale.type, round = _.round || false, range = _.range;
    // if range step specified, calculate full range extent
    if (_.rangeStep != null) range = configureRangeStep(type, _, count);
    else if (_.scheme) {
        range = configureScheme(type, _, count);
        if ((0, _vegaUtil.isFunction)(range)) {
            if (scale.interpolator) return scale.interpolator(range);
            else (0, _vegaUtil.error)(`Scale type ${type} does not support interpolating color schemes.`);
        }
    }
    // given a range array for an interpolating scale, convert to interpolator
    if (range && (0, _vegaScale.isInterpolating)(type)) return scale.interpolator((0, _vegaScale.interpolateColors)(flip(range, _.reverse), _.interpolate, _.interpolateGamma));
    // configure rounding / interpolation
    if (range && _.interpolate && scale.interpolate) scale.interpolate((0, _vegaScale.interpolate)(_.interpolate, _.interpolateGamma));
    else if ((0, _vegaUtil.isFunction)(scale.round)) scale.round(round);
    else if ((0, _vegaUtil.isFunction)(scale.rangeRound)) scale.interpolate(round ? (0, _d3Interpolate.interpolateRound) : (0, _d3Interpolate.interpolate));
    if (range) scale.range(flip(range, _.reverse));
}
function configureRangeStep(type, _, count) {
    if (type !== (0, _vegaScale.Band) && type !== (0, _vegaScale.Point)) (0, _vegaUtil.error)('Only band and point scales support rangeStep.');
    // calculate full range based on requested step size and padding
    var outer = (_.paddingOuter != null ? _.paddingOuter : _.padding) || 0, inner = type === (0, _vegaScale.Point) ? 1 : (_.paddingInner != null ? _.paddingInner : _.padding) || 0;
    return [
        0,
        _.rangeStep * (0, _vegaScale.bandSpace)(count, inner, outer)
    ];
}
function configureScheme(type, _, count) {
    var extent = _.schemeExtent, name, scheme$1;
    if ((0, _vegaUtil.isArray)(_.scheme)) scheme$1 = (0, _vegaScale.interpolateColors)(_.scheme, _.interpolate, _.interpolateGamma);
    else {
        name = _.scheme.toLowerCase();
        scheme$1 = (0, _vegaScale.scheme)(name);
        if (!scheme$1) (0, _vegaUtil.error)(`Unrecognized scheme name: ${_.scheme}`);
    }
    // determine size for potential discrete range
    count = type === (0, _vegaScale.Threshold) ? count + 1 : type === (0, _vegaScale.BinOrdinal) ? count - 1 : type === (0, _vegaScale.Quantile) || type === (0, _vegaScale.Quantize) ? +_.schemeCount || DEFAULT_COUNT : count;
    // adjust and/or quantize scheme as appropriate
    return (0, _vegaScale.isInterpolating)(type) ? adjustScheme(scheme$1, extent, _.reverse) : (0, _vegaUtil.isFunction)(scheme$1) ? (0, _vegaScale.quantizeInterpolator)(adjustScheme(scheme$1, extent), count) : type === (0, _vegaScale.Ordinal) ? scheme$1 : scheme$1.slice(0, count);
}
function adjustScheme(scheme, extent, reverse) {
    return (0, _vegaUtil.isFunction)(scheme) && (extent || reverse) ? (0, _vegaScale.interpolateRange)(scheme, flip(extent || [
        0,
        1
    ], reverse)) : scheme;
}
function flip(array, reverse) {
    return reverse ? array.slice().reverse() : array;
}
/**
 * Sorts scenegraph items in the pulse source array.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(*,*): number} [params.sort] - A comparator
 *   function for sorting tuples.
 */ function SortItems(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
(0, _vegaUtil.inherits)(SortItems, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const mod = _.modified('sort') || pulse.changed(pulse.ADD) || pulse.modified(_.sort.fields) || pulse.modified('datum');
        if (mod) pulse.source.sort((0, _vegaDataflow.stableCompare)(_.sort));
        this.modified(mod);
        return pulse;
    }
});
const Zero = 'zero', Center = 'center', Normalize = 'normalize', DefOutput = [
    'y0',
    'y1'
];
/**
 * Stack layout for visualization elements.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to stack.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {function(object,object): number} [params.sort] - A comparator for stack sorting.
 * @param {string} [offset='zero'] - Stack baseline offset. One of 'zero', 'center', 'normalize'.
 */ function Stack(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Stack.Definition = {
    'type': 'Stack',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'offset',
            'type': 'enum',
            'default': Zero,
            'values': [
                Zero,
                Center,
                Normalize
            ]
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': DefOutput
        }
    ]
};
(0, _vegaUtil.inherits)(Stack, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var as = _.as || DefOutput, y0 = as[0], y1 = as[1], sort = (0, _vegaDataflow.stableCompare)(_.sort), field = _.field || (0, _vegaUtil.one), stack = _.offset === Center ? stackCenter : _.offset === Normalize ? stackNormalize : stackZero, groups, i, n, max;
        // partition, sum, and sort the stack groups
        groups = partition(pulse.source, _.groupby, sort, field);
        // compute stack layouts per group
        for(i = 0, n = groups.length, max = groups.max; i < n; ++i)stack(groups[i], max, field, y0, y1);
        return pulse.reflow(_.modified()).modifies(as);
    }
});
function stackCenter(group, max, field, y0, y1) {
    var last = (max - group.sum) / 2, m = group.length, j = 0, t;
    for(; j < m; ++j){
        t = group[j];
        t[y0] = last;
        t[y1] = last += Math.abs(field(t));
    }
}
function stackNormalize(group, max, field, y0, y1) {
    var scale = 1 / group.sum, last = 0, m = group.length, j = 0, v = 0, t;
    for(; j < m; ++j){
        t = group[j];
        t[y0] = last;
        t[y1] = last = scale * (v += Math.abs(field(t)));
    }
}
function stackZero(group, max, field, y0, y1) {
    var lastPos = 0, lastNeg = 0, m = group.length, j = 0, v, t;
    for(; j < m; ++j){
        t = group[j];
        v = +field(t);
        if (v < 0) {
            t[y0] = lastNeg;
            t[y1] = lastNeg += v;
        } else {
            t[y0] = lastPos;
            t[y1] = lastPos += v;
        }
    }
}
function partition(data, groupby, sort, field) {
    var groups = [], get = (f)=>f(t), map, i, n, m, t, k, g, s, max;
    // partition data points into stack groups
    if (groupby == null) groups.push(data.slice());
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            groups.push(g);
        }
        g.push(t);
    }
    // compute sums of groups, sort groups as needed
    for(k = 0, max = 0, m = groups.length; k < m; ++k){
        g = groups[k];
        for(i = 0, s = 0, n = g.length; i < n; ++i)s += Math.abs(field(g[i]));
        g.sum = s;
        if (s > max) max = s;
        if (sort) g.sort(sort);
    }
    groups.max = max;
    return groups;
}

},{"vega-dataflow":"eoU45","vega-scale":"fMau0","vega-util":"kncZn","d3-array":"4pSqo","d3-interpolate":"gKQHn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eXHJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contour", ()=>Contour);
parcelHelpers.export(exports, "geojson", ()=>GeoJSON);
parcelHelpers.export(exports, "geopath", ()=>GeoPath);
parcelHelpers.export(exports, "geopoint", ()=>GeoPoint);
parcelHelpers.export(exports, "geoshape", ()=>GeoShape);
parcelHelpers.export(exports, "graticule", ()=>Graticule);
parcelHelpers.export(exports, "heatmap", ()=>Heatmap);
parcelHelpers.export(exports, "isocontour", ()=>Isocontour);
parcelHelpers.export(exports, "kde2d", ()=>KDE2D);
parcelHelpers.export(exports, "projection", ()=>Projection);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Array = require("d3-array");
var _vegaStatistics = require("vega-statistics");
var _vegaProjection = require("vega-projection");
var _d3Geo = require("d3-geo");
var _d3Color = require("d3-color");
var _vegaCanvas = require("vega-canvas");
function noop() {}
const cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
// Implementation adapted from d3/d3-contour. Thanks!
function contours() {
    var dx = 1, dy = 1, smooth = smoothLinear;
    function contours(values, tz) {
        return tz.map((value)=>contour(values, value));
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, (ring)=>{
            smooth(ring, values, value);
            if (area(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach((hole)=>{
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if (contains((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: 'MultiPolygon',
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = [], fragmentByEnd = [], x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            cases[t0 | t1 << 1].forEach(stitch);
        }
        cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach((point)=>{
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) (0, _vegaUtil.error)('invalid size');
        return dx = _0, dy = _1, contours;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : noop, contours) : smooth === smoothLinear;
    };
    return contours;
}
function area(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}
function contains(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = ringContains(ring, hole[i])) return c;
    return 0;
}
function ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function segmentContains(a, b, c) {
    var i;
    return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}
function quantize(k, nice, zero) {
    return function(values) {
        var ex = (0, _vegaUtil.extent)(values), start = zero ? Math.min(ex[0], 0) : ex[0], stop = ex[1], span = stop - start, step = nice ? (0, _d3Array.tickStep)(start, stop, k) : span / (k + 1);
        return (0, _d3Array.range)(start + step, stop, step);
    };
}
/**
 * Generate isocontours (level sets) based on input raster grid data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} [params.field] - The field with raster grid
 *   data. If unspecified, the tuple itself is interpreted as a raster grid.
 * @param {Array<number>} [params.thresholds] - Contour threshold array. If
 *   specified, the levels, nice, resolve, and zero parameters are ignored.
 * @param {number} [params.levels] - The desired number of contour levels.
 * @param {boolean} [params.nice] - Boolean flag indicating if the contour
 *   threshold values should be automatically aligned to "nice"
 *   human-friendly values. Setting this flag may cause the number of
 *   thresholds to deviate from the specified levels.
 * @param {string} [params.resolve] - The method for resolving thresholds
 *   across multiple input grids. If 'independent' (the default), threshold
 *   calculation will be performed separately for each grid. If 'shared', a
 *   single set of threshold values will be used for all input grids.
 * @param {boolean} [params.zero] - Boolean flag indicating if the contour
 *   threshold values should include zero.
 * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
 *   polygons should be smoothed using linear interpolation. The default is
 *   true. The parameter is ignored when using density estimation.
 * @param {boolean} [params.scale] - Optional numerical value by which to
 *   scale the output isocontour coordinates. This parameter can be useful
 *   to scale the contours to match a desired output resolution.
 * @param {string} [params.as='contour'] - The output field in which to store
 *   the generated isocontour data (default 'contour').
 */ function Isocontour(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Isocontour.Definition = {
    'type': 'Isocontour',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'thresholds',
            'type': 'number',
            'array': true
        },
        {
            'name': 'levels',
            'type': 'number'
        },
        {
            'name': 'nice',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'resolve',
            'type': 'enum',
            'values': [
                'shared',
                'independent'
            ],
            'default': 'independent'
        },
        {
            'name': 'zero',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'smooth',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'scale',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'translate',
            'type': 'number',
            'array': true,
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'null': true,
            'default': 'contour'
        }
    ]
};
(0, _vegaUtil.inherits)(Isocontour, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), source = pulse.materialize(pulse.SOURCE).source, field = _.field || (0, _vegaUtil.identity), contour = contours().smooth(_.smooth !== false), tz = _.thresholds || levels(source, field, _), as = _.as === null ? null : _.as || 'contour', values = [];
        source.forEach((t)=>{
            const grid = field(t);
            // generate contour paths in GeoJSON format
            const paths = contour.size([
                grid.width,
                grid.height
            ])(grid.values, (0, _vegaUtil.isArray)(tz) ? tz : tz(grid.values));
            // adjust contour path coordinates as needed
            transformPaths(paths, grid, t, _);
            // ingest; copy source data properties to output
            paths.forEach((p)=>{
                values.push((0, _vegaDataflow.rederive)(t, (0, _vegaDataflow.ingest)(as != null ? {
                    [as]: p
                } : p)));
            });
        });
        if (this.value) out.rem = this.value;
        this.value = out.source = out.add = values;
        return out;
    }
});
function levels(values, f, _) {
    const q = quantize(_.levels || 10, _.nice, _.zero !== false);
    return _.resolve !== 'shared' ? q : q(values.map((t)=>(0, _d3Array.max)(f(t).values)));
}
function transformPaths(paths, grid, datum, _) {
    let s = _.scale || grid.scale, t = _.translate || grid.translate;
    if ((0, _vegaUtil.isFunction)(s)) s = s(datum, _);
    if ((0, _vegaUtil.isFunction)(t)) t = t(datum, _);
    if ((s === 1 || s == null) && !t) return;
    const sx = ((0, _vegaUtil.isNumber)(s) ? s : s[0]) || 1, sy = ((0, _vegaUtil.isNumber)(s) ? s : s[1]) || 1, tx = t && t[0] || 0, ty = t && t[1] || 0;
    paths.forEach(transform(grid, sx, sy, tx, ty));
}
function transform(grid, sx, sy, tx, ty) {
    const x1 = grid.x1 || 0, y1 = grid.y1 || 0, flip = sx * sy < 0;
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        if (flip) coordinates.reverse(); // maintain winding order
        coordinates.forEach(transformPoint);
    }
    function transformPoint(coordinates) {
        coordinates[0] = (coordinates[0] - x1) * sx + tx;
        coordinates[1] = (coordinates[1] - y1) * sy + ty;
    }
    return function(geometry) {
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    };
}
function radius(bw, data, f) {
    const v = bw >= 0 ? bw : (0, _vegaStatistics.bandwidthNRD)(data, f);
    return Math.round((Math.sqrt(4 * v * v + 1) - 1) / 2);
}
function number(_) {
    return (0, _vegaUtil.isFunction)(_) ? _ : (0, _vegaUtil.constant)(+_);
}
// Implementation adapted from d3/d3-contour. Thanks!
function density2D() {
    var x = (d)=>d[0], y = (d)=>d[1], weight = (0, _vegaUtil.one), bandwidth = [
        -1,
        -1
    ], dx = 960, dy = 500, k = 2; // log2(cellSize)
    function density(data, counts) {
        const rx = radius(bandwidth[0], data, x) >> k, // blur x-radius
        ry = radius(bandwidth[1], data, y) >> k, // blur y-radius
        ox = rx ? rx + 2 : 0, // x-offset padding for blur
        oy = ry ? ry + 2 : 0, // y-offset padding for blur
        n = 2 * ox + (dx >> k), // grid width
        m = 2 * oy + (dy >> k), // grid height
        values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        let values = values0;
        data.forEach((d)=>{
            const xi = ox + (+x(d) >> k), yi = oy + (+y(d) >> k);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += +weight(d);
        });
        if (rx > 0 && ry > 0) {
            blurX(n, m, values0, values1, rx);
            blurY(n, m, values1, values0, ry);
            blurX(n, m, values0, values1, rx);
            blurY(n, m, values1, values0, ry);
            blurX(n, m, values0, values1, rx);
            blurY(n, m, values1, values0, ry);
        } else if (rx > 0) {
            blurX(n, m, values0, values1, rx);
            blurX(n, m, values1, values0, rx);
            blurX(n, m, values0, values1, rx);
            values = values1;
        } else if (ry > 0) {
            blurY(n, m, values0, values1, ry);
            blurY(n, m, values1, values0, ry);
            blurY(n, m, values0, values1, ry);
            values = values1;
        }
        // scale density estimates
        // density in points per square pixel or probability density
        const s = counts ? Math.pow(2, -2 * k) : 1 / (0, _d3Array.sum)(values);
        for(let i = 0, sz = n * m; i < sz; ++i)values[i] *= s;
        return {
            values: values,
            scale: 1 << k,
            width: n,
            height: m,
            x1: ox,
            y1: oy,
            x2: ox + (dx >> k),
            y2: oy + (dy >> k)
        };
    }
    density.x = function(_) {
        return arguments.length ? (x = number(_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = number(_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = number(_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) (0, _vegaUtil.error)('invalid size');
        return dx = _0, dy = _1, density;
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) (0, _vegaUtil.error)('invalid cell size');
        k = Math.floor(Math.log(_) / Math.LN2);
        return density;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return bandwidth;
        _ = (0, _vegaUtil.array)(_);
        if (_.length === 1) _ = [
            +_[0],
            +_[0]
        ];
        if (_.length !== 2) (0, _vegaUtil.error)('invalid bandwidth');
        return bandwidth = _, density;
    };
    return density;
}
function blurX(n, m, source, target, r) {
    const w = (r << 1) + 1;
    for(let j = 0; j < m; ++j)for(let i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source[i - w + j * n];
            target[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function blurY(n, m, source, target, r) {
    const w = (r << 1) + 1;
    for(let i = 0; i < n; ++i)for(let j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source[i + (j - w) * n];
            target[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}
/**
 * Perform 2D kernel-density estimation of point data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The [width, height] extent (in
 *   units of input pixels) over which to perform density estimation.
 * @param {function(object): number} params.x - The x-coordinate accessor.
 * @param {function(object): number} params.y - The y-coordinate accessor.
 * @param {function(object): number} [params.weight] - The weight accessor.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors
 *   to groupby.
 * @param {number} [params.cellSize] - Contour density calculation cell size.
 *   This parameter determines the level of spatial approximation. For example,
 *   the default value of 4 maps to 2x reductions in both x- and y- dimensions.
 *   A value of 1 will result in an output raster grid whose dimensions exactly
 *   matches the size parameter.
 * @param {Array<number>} [params.bandwidth] - The KDE kernel bandwidths,
 *   in pixels. The input can be a two-element array specifying separate
 *   x and y bandwidths, or a single-element array specifying both. If the
 *   bandwidth is unspecified or less than zero, the bandwidth will be
 *   automatically determined.
 * @param {boolean} [params.counts=false] - A boolean flag indicating if the
 *   output values should be probability estimates (false, default) or
 *   smoothed counts (true).
 * @param {string} [params.as='grid'] - The output field in which to store
 *   the generated raster grid (default 'grid').
 */ function KDE2D(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
KDE2D.Definition = {
    'type': 'KDE2D',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2,
            'required': true
        },
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'weight',
            'type': 'field'
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'cellSize',
            'type': 'number'
        },
        {
            'name': 'bandwidth',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'counts',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'grid'
        }
    ]
};
const PARAMS = [
    'x',
    'y',
    'weight',
    'size',
    'cellSize',
    'bandwidth'
];
function params(obj, _) {
    PARAMS.forEach((param)=>_[param] != null ? obj[param](_[param]) : 0);
    return obj;
}
(0, _vegaUtil.inherits)(KDE2D, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), source = pulse.materialize(pulse.SOURCE).source, groups = partition(source, _.groupby), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), kde = params(density2D(), _), as = _.as || 'grid', values = [];
        function set(t, vals) {
            for(let i = 0; i < names.length; ++i)t[names[i]] = vals[i];
            return t;
        }
        // generate density raster grids
        values = groups.map((g)=>(0, _vegaDataflow.ingest)(set({
                [as]: kde(g, _.counts)
            }, g.dims)));
        if (this.value) out.rem = this.value;
        this.value = out.source = out.add = values;
        return out;
    }
});
function partition(data, groupby) {
    var groups = [], get = (f)=>f(t), map, i, n, t, k, g;
    // partition data points into groups
    if (groupby == null) groups.push(data);
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            g.dims = k;
            groups.push(g);
        }
        g.push(t);
    }
    return groups;
}
/**
 * Generate contours based on kernel-density estimation of point data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The dimensions [width, height] over which to compute contours.
 *  If the values parameter is provided, this must be the dimensions of the input data.
 *  If density estimation is performed, this is the output view dimensions in pixels.
 * @param {Array<number>} [params.values] - An array of numeric values representing an
 *  width x height grid of values over which to compute contours. If unspecified, this
 *  transform will instead attempt to compute contours for the kernel density estimate
 *  using values drawn from data tuples in the input pulse.
 * @param {function(object): number} [params.x] - The pixel x-coordinate accessor for density estimation.
 * @param {function(object): number} [params.y] - The pixel y-coordinate accessor for density estimation.
 * @param {function(object): number} [params.weight] - The data point weight accessor for density estimation.
 * @param {number} [params.cellSize] - Contour density calculation cell size.
 * @param {number} [params.bandwidth] - Kernel density estimation bandwidth.
 * @param {Array<number>} [params.thresholds] - Contour threshold array. If
 *   this parameter is set, the count and nice parameters will be ignored.
 * @param {number} [params.count] - The desired number of contours.
 * @param {boolean} [params.nice] - Boolean flag indicating if the contour
 *   threshold values should be automatically aligned to "nice"
 *   human-friendly values. Setting this flag may cause the number of
 *   thresholds to deviate from the specified count.
 * @param {boolean} [params.smooth] - Boolean flag indicating if the contour
 *   polygons should be smoothed using linear interpolation. The default is
 *   true. The parameter is ignored when using density estimation.
 */ function Contour(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Contour.Definition = {
    'type': 'Contour',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2,
            'required': true
        },
        {
            'name': 'values',
            'type': 'number',
            'array': true
        },
        {
            'name': 'x',
            'type': 'field'
        },
        {
            'name': 'y',
            'type': 'field'
        },
        {
            'name': 'weight',
            'type': 'field'
        },
        {
            'name': 'cellSize',
            'type': 'number'
        },
        {
            'name': 'bandwidth',
            'type': 'number'
        },
        {
            'name': 'count',
            'type': 'number'
        },
        {
            'name': 'nice',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'thresholds',
            'type': 'number',
            'array': true
        },
        {
            'name': 'smooth',
            'type': 'boolean',
            'default': true
        }
    ]
};
(0, _vegaUtil.inherits)(Contour, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (this.value && !pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS), contour = contours().smooth(_.smooth !== false), values = _.values, thresh = _.thresholds || quantize(_.count || 10, _.nice, !!values), size = _.size, grid, post;
        if (!values) {
            values = pulse.materialize(pulse.SOURCE).source;
            grid = params(density2D(), _)(values, true);
            post = transform(grid, grid.scale || 1, grid.scale || 1, 0, 0);
            size = [
                grid.width,
                grid.height
            ];
            values = grid.values;
        }
        thresh = (0, _vegaUtil.isArray)(thresh) ? thresh : thresh(values);
        values = contour.size(size)(values, thresh);
        if (post) values.forEach(post);
        if (this.value) out.rem = this.value;
        this.value = out.source = out.add = (values || []).map((0, _vegaDataflow.ingest));
        return out;
    }
});
const Feature = 'Feature';
const FeatureCollection = 'FeatureCollection';
const MultiPoint = 'MultiPoint';
/**
 * Consolidate an array of [longitude, latitude] points or GeoJSON features
 * into a combined GeoJSON object. This transform is particularly useful for
 * combining geo data for a Projection's fit argument. The resulting GeoJSON
 * data is available as this transform's value. Input pulses are unchanged.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} [params.fields] - A two-element array
 *   of field accessors for the longitude and latitude values.
 * @param {function(object): *} params.geojson - A field accessor for
 *   retrieving GeoJSON feature data.
 */ function GeoJSON(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoJSON.Definition = {
    'type': 'GeoJSON',
    'metadata': {},
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'length': 2
        },
        {
            'name': 'geojson',
            'type': 'field'
        }
    ]
};
(0, _vegaUtil.inherits)(GeoJSON, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var features = this._features, points = this._points, fields = _.fields, lon = fields && fields[0], lat = fields && fields[1], geojson = _.geojson || !fields && (0, _vegaUtil.identity), flag = pulse.ADD, mod;
        mod = _.modified() || pulse.changed(pulse.REM) || pulse.modified((0, _vegaUtil.accessorFields)(geojson)) || lon && pulse.modified((0, _vegaUtil.accessorFields)(lon)) || lat && pulse.modified((0, _vegaUtil.accessorFields)(lat));
        if (!this.value || mod) {
            flag = pulse.SOURCE;
            this._features = features = [];
            this._points = points = [];
        }
        if (geojson) pulse.visit(flag, (t)=>features.push(geojson(t)));
        if (lon && lat) {
            pulse.visit(flag, (t)=>{
                var x = lon(t), y = lat(t);
                if (x != null && y != null && (x = +x) === x && (y = +y) === y) points.push([
                    x,
                    y
                ]);
            });
            features = features.concat({
                type: Feature,
                geometry: {
                    type: MultiPoint,
                    coordinates: points
                }
            });
        }
        this.value = {
            type: FeatureCollection,
            features: features
        };
    }
});
/**
 * Map GeoJSON data to an SVG path string.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {function(object): *} [params.field] - The field with GeoJSON data,
 *   or null if the tuple itself is a GeoJSON feature.
 * @param {string} [params.as='path'] - The output field in which to store
 *   the generated path data (default 'path').
 */ function GeoPath(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoPath.Definition = {
    'type': 'GeoPath',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'projection',
            'type': 'projection'
        },
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'pointRadius',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'path'
        }
    ]
};
(0, _vegaUtil.inherits)(GeoPath, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ALL), path = this.value, field = _.field || (0, _vegaUtil.identity), as = _.as || 'path', flag = out.SOURCE;
        if (!path || _.modified()) {
            // parameters updated, reset and reflow
            this.value = path = (0, _vegaProjection.getProjectionPath)(_.projection);
            out.materialize().reflow();
        } else flag = field === (0, _vegaUtil.identity) || pulse.modified(field.fields) ? out.ADD_MOD : out.ADD;
        const prev = initPath(path, _.pointRadius);
        out.visit(flag, (t)=>t[as] = path(field(t)));
        path.pointRadius(prev);
        return out.modifies(as);
    }
});
function initPath(path, pointRadius) {
    const prev = path.pointRadius();
    path.context(null);
    if (pointRadius != null) path.pointRadius(pointRadius);
    return prev;
}
/**
 * Geo-code a longitude/latitude point to an x/y coordinate.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {Array<function(object): *>} params.fields - A two-element array of
 *   field accessors for the longitude and latitude values.
 * @param {Array<string>} [params.as] - A two-element array of field names
 *   under which to store the result. Defaults to ['x','y'].
 */ function GeoPoint(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoPoint.Definition = {
    'type': 'GeoPoint',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'projection',
            'type': 'projection',
            'required': true
        },
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 2,
            'default': [
                'x',
                'y'
            ]
        }
    ]
};
(0, _vegaUtil.inherits)(GeoPoint, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var proj = _.projection, lon = _.fields[0], lat = _.fields[1], as = _.as || [
            'x',
            'y'
        ], x = as[0], y = as[1], mod;
        function set(t) {
            const xy = proj([
                lon(t),
                lat(t)
            ]);
            if (xy) {
                t[x] = xy[0];
                t[y] = xy[1];
            } else {
                t[x] = undefined;
                t[y] = undefined;
            }
        }
        if (_.modified()) // parameters updated, reflow
        pulse = pulse.materialize().reflow(true).visit(pulse.SOURCE, set);
        else {
            mod = pulse.modified(lon.fields) || pulse.modified(lat.fields);
            pulse.visit(mod ? pulse.ADD_MOD : pulse.ADD, set);
        }
        return pulse.modifies(as);
    }
});
/**
 * Annotate items with a geopath shape generator.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(number, number): *} params.projection - The cartographic
 *   projection to apply.
 * @param {function(object): *} [params.field] - The field with GeoJSON data,
 *   or null if the tuple itself is a GeoJSON feature.
 * @param {string} [params.as='shape'] - The output field in which to store
 *   the generated path data (default 'shape').
 */ function GeoShape(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
GeoShape.Definition = {
    'type': 'GeoShape',
    'metadata': {
        'modifies': true,
        'nomod': true
    },
    'params': [
        {
            'name': 'projection',
            'type': 'projection'
        },
        {
            'name': 'field',
            'type': 'field',
            'default': 'datum'
        },
        {
            'name': 'pointRadius',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'shape'
        }
    ]
};
(0, _vegaUtil.inherits)(GeoShape, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var out = pulse.fork(pulse.ALL), shape = this.value, as = _.as || 'shape', flag = out.ADD;
        if (!shape || _.modified()) {
            // parameters updated, reset and reflow
            this.value = shape = shapeGenerator((0, _vegaProjection.getProjectionPath)(_.projection), _.field || (0, _vegaUtil.field)('datum'), _.pointRadius);
            out.materialize().reflow();
            flag = out.SOURCE;
        }
        out.visit(flag, (t)=>t[as] = shape);
        return out.modifies(as);
    }
});
function shapeGenerator(path, field, pointRadius) {
    const shape = pointRadius == null ? (_)=>path(field(_)) : (_)=>{
        var prev = path.pointRadius(), value = path.pointRadius(pointRadius)(field(_));
        path.pointRadius(prev);
        return value;
    };
    shape.context = (_)=>{
        path.context(_);
        return shape;
    };
    return shape;
}
/**
 * GeoJSON feature generator for creating graticules.
 * @constructor
 */ function Graticule(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
    this.generator = (0, _d3Geo.geoGraticule)();
}
Graticule.Definition = {
    'type': 'Graticule',
    'metadata': {
        'changes': true,
        'generates': true
    },
    'params': [
        {
            'name': 'extent',
            'type': 'array',
            'array': true,
            'length': 2,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'extentMajor',
            'type': 'array',
            'array': true,
            'length': 2,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'extentMinor',
            'type': 'array',
            'array': true,
            'length': 2,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'step',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'stepMajor',
            'type': 'number',
            'array': true,
            'length': 2,
            'default': [
                90,
                360
            ]
        },
        {
            'name': 'stepMinor',
            'type': 'number',
            'array': true,
            'length': 2,
            'default': [
                10,
                10
            ]
        },
        {
            'name': 'precision',
            'type': 'number',
            'default': 2.5
        }
    ]
};
(0, _vegaUtil.inherits)(Graticule, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var src = this.value, gen = this.generator, t;
        if (!src.length || _.modified()) {
            for(const prop in _)if ((0, _vegaUtil.isFunction)(gen[prop])) gen[prop](_[prop]);
        }
        t = gen();
        if (src.length) pulse.mod.push((0, _vegaDataflow.replace)(src[0], t));
        else pulse.add.push((0, _vegaDataflow.ingest)(t));
        src[0] = t;
        return pulse;
    }
});
/**
 * Render a heatmap image for input raster grid data.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} [params.field] - The field with raster grid
 *   data. If unspecified, the tuple itself is interpreted as a raster grid.
 * @param {string} [params.color] - A constant color value or function for
 *   individual pixel color. If a function, it will be invoked with an input
 *   object that includes $x, $y, $value, and $max fields for the grid.
 * @param {number} [params.opacity] - A constant opacity value or function for
 *   individual pixel opacity. If a function, it will be invoked with an input
 *   object that includes $x, $y, $value, and $max fields for the grid.
 * @param {string} [params.resolve] - The method for resolving maximum values
 *   across multiple input grids. If 'independent' (the default), maximum
 *   calculation will be performed separately for each grid. If 'shared',
 *   a single global maximum will be used for all input grids.
 * @param {string} [params.as='image'] - The output field in which to store
 *   the generated bitmap canvas images (default 'image').
 */ function Heatmap(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Heatmap.Definition = {
    'type': 'heatmap',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'color',
            'type': 'string',
            'expr': true
        },
        {
            'name': 'opacity',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'resolve',
            'type': 'enum',
            'values': [
                'shared',
                'independent'
            ],
            'default': 'independent'
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'image'
        }
    ]
};
(0, _vegaUtil.inherits)(Heatmap, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.changed() && !_.modified()) return pulse.StopPropagation;
        var source = pulse.materialize(pulse.SOURCE).source, shared = _.resolve === 'shared', field = _.field || (0, _vegaUtil.identity), opacity = opacity_(_.opacity, _), color = color_(_.color, _), as = _.as || 'image', obj = {
            $x: 0,
            $y: 0,
            $value: 0,
            $max: shared ? (0, _d3Array.max)(source.map((t)=>(0, _d3Array.max)(field(t).values))) : 0
        };
        source.forEach((t)=>{
            const v = field(t);
            // build proxy data object
            const o = (0, _vegaUtil.extend)({}, t, obj);
            // set maximum value if not globally shared
            if (!shared) o.$max = (0, _d3Array.max)(v.values || []);
            // generate canvas image
            // optimize color/opacity if not pixel-dependent
            t[as] = toCanvas(v, o, color.dep ? color : (0, _vegaUtil.constant)(color(o)), opacity.dep ? opacity : (0, _vegaUtil.constant)(opacity(o)));
        });
        return pulse.reflow(true).modifies(as);
    }
});
// get image color function
function color_(color, _) {
    let f;
    if ((0, _vegaUtil.isFunction)(color)) {
        f = (obj)=>(0, _d3Color.rgb)(color(obj, _));
        f.dep = dependency(color);
    } else // default to mid-grey
    f = (0, _vegaUtil.constant)((0, _d3Color.rgb)(color || '#888'));
    return f;
}
// get image opacity function
function opacity_(opacity, _) {
    let f;
    if ((0, _vegaUtil.isFunction)(opacity)) {
        f = (obj)=>opacity(obj, _);
        f.dep = dependency(opacity);
    } else if (opacity) f = (0, _vegaUtil.constant)(opacity);
    else {
        // default to [0, max] opacity gradient
        f = (obj)=>obj.$value / obj.$max || 0;
        f.dep = true;
    }
    return f;
}
// check if function depends on individual pixel data
function dependency(f) {
    if (!(0, _vegaUtil.isFunction)(f)) return false;
    const set = (0, _vegaUtil.toSet)((0, _vegaUtil.accessorFields)(f));
    return set.$x || set.$y || set.$value || set.$max;
}
// render raster grid to canvas
function toCanvas(grid, obj, color, opacity) {
    const n = grid.width, m = grid.height, x1 = grid.x1 || 0, y1 = grid.y1 || 0, x2 = grid.x2 || n, y2 = grid.y2 || m, val = grid.values, value = val ? (i)=>val[i] : (0, _vegaUtil.zero), can = (0, _vegaCanvas.canvas)(x2 - x1, y2 - y1), ctx = can.getContext('2d'), img = ctx.getImageData(0, 0, x2 - x1, y2 - y1), pix = img.data;
    for(let j = y1, k = 0; j < y2; ++j){
        obj.$y = j - y1;
        for(let i = x1, r = j * n; i < x2; ++i, k += 4){
            obj.$x = i - x1;
            obj.$value = value(i + r);
            const v = color(obj);
            pix[k + 0] = v.r;
            pix[k + 1] = v.g;
            pix[k + 2] = v.b;
            pix[k + 3] = ~~(255 * opacity(obj));
        }
    }
    ctx.putImageData(img, 0, 0);
    return can;
}
/**
 * Maintains a cartographic projection.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Projection(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
    this.modified(true); // always treat as modified
}
(0, _vegaUtil.inherits)(Projection, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        let proj = this.value;
        if (!proj || _.modified('type')) {
            this.value = proj = create(_.type);
            (0, _vegaProjection.projectionProperties).forEach((prop)=>{
                if (_[prop] != null) set(proj, prop, _[prop]);
            });
        } else (0, _vegaProjection.projectionProperties).forEach((prop)=>{
            if (_.modified(prop)) set(proj, prop, _[prop]);
        });
        if (_.pointRadius != null) proj.path.pointRadius(_.pointRadius);
        if (_.fit) fit(proj, _);
        return pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
    }
});
function fit(proj, _) {
    const data = collectGeoJSON(_.fit);
    _.extent ? proj.fitExtent(_.extent, data) : _.size && proj.fitSize(_.size, data);
}
function create(type) {
    const constructor = (0, _vegaProjection.projection)((type || 'mercator').toLowerCase());
    if (!constructor) (0, _vegaUtil.error)('Unrecognized projection type: ' + type);
    return constructor();
}
function set(proj, key, value) {
    if ((0, _vegaUtil.isFunction)(proj[key])) proj[key](value);
}
function collectGeoJSON(data) {
    data = (0, _vegaUtil.array)(data);
    return data.length === 1 ? data[0] : {
        type: FeatureCollection,
        features: data.reduce((a, f)=>a.concat(featurize(f)), [])
    };
}
function featurize(f) {
    return f.type === FeatureCollection ? f.features : (0, _vegaUtil.array)(f).filter((d)=>d != null).map((d)=>d.type === Feature ? d : {
            type: Feature,
            geometry: d
        });
}

},{"vega-dataflow":"eoU45","vega-util":"kncZn","d3-array":"4pSqo","vega-statistics":"6sdPC","vega-projection":"d411C","d3-geo":"hvz1M","d3-color":"c8Fkk","vega-canvas":"5PubP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d411C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProjectionPath", ()=>getProjectionPath);
parcelHelpers.export(exports, "projection", ()=>projection);
parcelHelpers.export(exports, "projectionProperties", ()=>projectionProperties);
var _d3Geo = require("d3-geo");
var _d3GeoProjection = require("d3-geo-projection");
var _vegaScale = require("vega-scale");
const defaultPath = (0, _d3Geo.geoPath)();
const projectionProperties = [
    // standard properties in d3-geo
    'clipAngle',
    'clipExtent',
    'scale',
    'translate',
    'center',
    'rotate',
    'parallels',
    'precision',
    'reflectX',
    'reflectY',
    // extended properties in d3-geo-projections
    'coefficient',
    'distance',
    'fraction',
    'lobes',
    'parallel',
    'radius',
    'ratio',
    'spacing',
    'tilt'
];
/**
 * Augment projections with their type and a copy method.
 */ function create(type, constructor) {
    return function projection() {
        const p = constructor();
        p.type = type;
        p.path = (0, _d3Geo.geoPath)().projection(p);
        p.copy = p.copy || function() {
            const c = projection();
            projectionProperties.forEach((prop)=>{
                if (p[prop]) c[prop](p[prop]());
            });
            c.path.pointRadius(p.path.pointRadius());
            return c;
        };
        return (0, _vegaScale.registerScale)(p);
    };
}
function projection(type, proj) {
    if (!type || typeof type !== 'string') throw new Error('Projection type must be a name string.');
    type = type.toLowerCase();
    if (arguments.length > 1) {
        projections[type] = create(type, proj);
        return this;
    } else return projections[type] || null;
}
function getProjectionPath(proj) {
    return proj && proj.path || defaultPath;
}
const projections = {
    // base d3-geo projection types
    albers: (0, _d3Geo.geoAlbers),
    albersusa: (0, _d3Geo.geoAlbersUsa),
    azimuthalequalarea: (0, _d3Geo.geoAzimuthalEqualArea),
    azimuthalequidistant: (0, _d3Geo.geoAzimuthalEquidistant),
    conicconformal: (0, _d3Geo.geoConicConformal),
    conicequalarea: (0, _d3Geo.geoConicEqualArea),
    conicequidistant: (0, _d3Geo.geoConicEquidistant),
    equalEarth: (0, _d3Geo.geoEqualEarth),
    equirectangular: (0, _d3Geo.geoEquirectangular),
    gnomonic: (0, _d3Geo.geoGnomonic),
    identity: (0, _d3Geo.geoIdentity),
    mercator: (0, _d3Geo.geoMercator),
    mollweide: (0, _d3GeoProjection.geoMollweide),
    naturalEarth1: (0, _d3Geo.geoNaturalEarth1),
    orthographic: (0, _d3Geo.geoOrthographic),
    stereographic: (0, _d3Geo.geoStereographic),
    transversemercator: (0, _d3Geo.geoTransverseMercator)
};
for(const key in projections)projection(key, projections[key]);

},{"d3-geo":"hvz1M","d3-geo-projection":"50OFW","vega-scale":"fMau0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hvz1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "geoBounds", ()=>(0, _boundsJsDefault.default));
parcelHelpers.export(exports, "geoCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "geoCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "geoClipAntimeridian", ()=>(0, _antimeridianJsDefault.default));
parcelHelpers.export(exports, "geoClipCircle", ()=>(0, _circleJsDefault1.default));
parcelHelpers.export(exports, "geoClipExtent", ()=>(0, _extentJsDefault.default)) // DEPRECATED! Use d3.geoIdentity().clipExtent(…).
;
parcelHelpers.export(exports, "geoClipRectangle", ()=>(0, _rectangleJsDefault.default));
parcelHelpers.export(exports, "geoContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "geoDistance", ()=>(0, _distanceJsDefault.default));
parcelHelpers.export(exports, "geoGraticule", ()=>(0, _graticuleJsDefault.default));
parcelHelpers.export(exports, "geoGraticule10", ()=>(0, _graticuleJs.graticule10));
parcelHelpers.export(exports, "geoInterpolate", ()=>(0, _interpolateJsDefault.default));
parcelHelpers.export(exports, "geoLength", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "geoPath", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "geoAlbers", ()=>(0, _albersJsDefault.default));
parcelHelpers.export(exports, "geoAlbersUsa", ()=>(0, _albersUsaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualArea", ()=>(0, _azimuthalEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualAreaRaw", ()=>(0, _azimuthalEqualAreaJs.azimuthalEqualAreaRaw));
parcelHelpers.export(exports, "geoAzimuthalEquidistant", ()=>(0, _azimuthalEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEquidistantRaw", ()=>(0, _azimuthalEquidistantJs.azimuthalEquidistantRaw));
parcelHelpers.export(exports, "geoConicConformal", ()=>(0, _conicConformalJsDefault.default));
parcelHelpers.export(exports, "geoConicConformalRaw", ()=>(0, _conicConformalJs.conicConformalRaw));
parcelHelpers.export(exports, "geoConicEqualArea", ()=>(0, _conicEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoConicEqualAreaRaw", ()=>(0, _conicEqualAreaJs.conicEqualAreaRaw));
parcelHelpers.export(exports, "geoConicEquidistant", ()=>(0, _conicEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoConicEquidistantRaw", ()=>(0, _conicEquidistantJs.conicEquidistantRaw));
parcelHelpers.export(exports, "geoEqualEarth", ()=>(0, _equalEarthJsDefault.default));
parcelHelpers.export(exports, "geoEqualEarthRaw", ()=>(0, _equalEarthJs.equalEarthRaw));
parcelHelpers.export(exports, "geoEquirectangular", ()=>(0, _equirectangularJsDefault.default));
parcelHelpers.export(exports, "geoEquirectangularRaw", ()=>(0, _equirectangularJs.equirectangularRaw));
parcelHelpers.export(exports, "geoGnomonic", ()=>(0, _gnomonicJsDefault.default));
parcelHelpers.export(exports, "geoGnomonicRaw", ()=>(0, _gnomonicJs.gnomonicRaw));
parcelHelpers.export(exports, "geoIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "geoProjection", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "geoProjectionMutator", ()=>(0, _indexJs1.projectionMutator));
parcelHelpers.export(exports, "geoMercator", ()=>(0, _mercatorJsDefault.default));
parcelHelpers.export(exports, "geoMercatorRaw", ()=>(0, _mercatorJs.mercatorRaw));
parcelHelpers.export(exports, "geoNaturalEarth1", ()=>(0, _naturalEarth1JsDefault.default));
parcelHelpers.export(exports, "geoNaturalEarth1Raw", ()=>(0, _naturalEarth1Js.naturalEarth1Raw));
parcelHelpers.export(exports, "geoOrthographic", ()=>(0, _orthographicJsDefault.default));
parcelHelpers.export(exports, "geoOrthographicRaw", ()=>(0, _orthographicJs.orthographicRaw));
parcelHelpers.export(exports, "geoStereographic", ()=>(0, _stereographicJsDefault.default));
parcelHelpers.export(exports, "geoStereographicRaw", ()=>(0, _stereographicJs.stereographicRaw));
parcelHelpers.export(exports, "geoTransverseMercator", ()=>(0, _transverseMercatorJsDefault.default));
parcelHelpers.export(exports, "geoTransverseMercatorRaw", ()=>(0, _transverseMercatorJs.transverseMercatorRaw));
parcelHelpers.export(exports, "geoRotation", ()=>(0, _rotationJsDefault.default));
parcelHelpers.export(exports, "geoStream", ()=>(0, _streamJsDefault.default));
parcelHelpers.export(exports, "geoTransform", ()=>(0, _transformJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _antimeridianJs = require("./clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs1 = require("./clip/circle.js");
var _circleJsDefault1 = parcelHelpers.interopDefault(_circleJs1);
var _extentJs = require("./clip/extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _rectangleJs = require("./clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _graticuleJs = require("./graticule.js");
var _graticuleJsDefault = parcelHelpers.interopDefault(_graticuleJs);
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _indexJs = require("./path/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _albersJs = require("./projection/albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _albersUsaJs = require("./projection/albersUsa.js");
var _albersUsaJsDefault = parcelHelpers.interopDefault(_albersUsaJs);
var _azimuthalEqualAreaJs = require("./projection/azimuthalEqualArea.js");
var _azimuthalEqualAreaJsDefault = parcelHelpers.interopDefault(_azimuthalEqualAreaJs);
var _azimuthalEquidistantJs = require("./projection/azimuthalEquidistant.js");
var _azimuthalEquidistantJsDefault = parcelHelpers.interopDefault(_azimuthalEquidistantJs);
var _conicConformalJs = require("./projection/conicConformal.js");
var _conicConformalJsDefault = parcelHelpers.interopDefault(_conicConformalJs);
var _conicEqualAreaJs = require("./projection/conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _conicEquidistantJs = require("./projection/conicEquidistant.js");
var _conicEquidistantJsDefault = parcelHelpers.interopDefault(_conicEquidistantJs);
var _equalEarthJs = require("./projection/equalEarth.js");
var _equalEarthJsDefault = parcelHelpers.interopDefault(_equalEarthJs);
var _equirectangularJs = require("./projection/equirectangular.js");
var _equirectangularJsDefault = parcelHelpers.interopDefault(_equirectangularJs);
var _gnomonicJs = require("./projection/gnomonic.js");
var _gnomonicJsDefault = parcelHelpers.interopDefault(_gnomonicJs);
var _identityJs = require("./projection/identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _indexJs1 = require("./projection/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _mercatorJs = require("./projection/mercator.js");
var _mercatorJsDefault = parcelHelpers.interopDefault(_mercatorJs);
var _naturalEarth1Js = require("./projection/naturalEarth1.js");
var _naturalEarth1JsDefault = parcelHelpers.interopDefault(_naturalEarth1Js);
var _orthographicJs = require("./projection/orthographic.js");
var _orthographicJsDefault = parcelHelpers.interopDefault(_orthographicJs);
var _stereographicJs = require("./projection/stereographic.js");
var _stereographicJsDefault = parcelHelpers.interopDefault(_stereographicJs);
var _transverseMercatorJs = require("./projection/transverseMercator.js");
var _transverseMercatorJsDefault = parcelHelpers.interopDefault(_transverseMercatorJs);
var _rotationJs = require("./rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./area.js":"fU0uC","./bounds.js":"90PvZ","./centroid.js":"fSoBX","./circle.js":"2UTty","./clip/antimeridian.js":false,"./clip/circle.js":false,"./clip/extent.js":false,"./clip/rectangle.js":false,"./contains.js":false,"./distance.js":false,"./graticule.js":"bJKKE","./interpolate.js":"a1PWF","./length.js":false,"./path/index.js":"funLc","./projection/albers.js":"gVkNI","./projection/albersUsa.js":"kKmvt","./projection/azimuthalEqualArea.js":"agpPS","./projection/azimuthalEquidistant.js":"1EsCY","./projection/conicConformal.js":"d2zyE","./projection/conicEqualArea.js":"84dLC","./projection/conicEquidistant.js":"4pwTI","./projection/equalEarth.js":"3QHBT","./projection/equirectangular.js":"ivpfD","./projection/gnomonic.js":"8g2g8","./projection/identity.js":"3FhuX","./projection/index.js":"jabgC","./projection/mercator.js":"awlzv","./projection/naturalEarth1.js":"invjX","./projection/orthographic.js":"awIEX","./projection/stereographic.js":"fBs4c","./projection/transverseMercator.js":"i3KJ4","./rotation.js":"ka8Fr","./stream.js":"hAqHD","./transform.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fU0uC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaRingSum", ()=>areaRingSum);
parcelHelpers.export(exports, "areaStream", ()=>areaStream);
parcelHelpers.export(exports, "default", ()=>function(object) {
        areaSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, areaStream);
        return areaSum * 2;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var areaRingSum = new (0, _d3Array.Adder)();
// hello?
var areaSum = new (0, _d3Array.Adder)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaRingSum = new (0, _d3Array.Adder)();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? (0, _mathJs.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, _noopJsDefault.default);
    },
    sphere: function() {
        areaSum.add((0, _mathJs.tau));
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaRingEnd() {
    areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi) {
    areaStream.point = areaPoint;
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, cosPhi0 = (0, _mathJs.cos)(phi = phi / 2 + (0, _mathJs.quarterPi)), sinPhi0 = (0, _mathJs.sin)(phi);
}
function areaPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    phi = phi / 2 + (0, _mathJs.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _mathJs.cos)(adLambda), v = k * sdLambda * (0, _mathJs.sin)(adLambda);
    areaRingSum.add((0, _mathJs.atan2)(v, u));
    // Advance the previous points.
    lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

},{"d3-array":"4pSqo","./math.js":"hswBu","./noop.js":"bwHmr","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hswBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "hypot", ()=>hypot);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "haversin", ()=>haversin);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
    return (x = sin(x / 2)) * x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwHmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hAqHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    });
function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
}
var streamObjectType = {
    Feature: function(object, stream) {
        streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)streamGeometry(features[i].geometry, stream);
    }
};
var streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)streamGeometry(geometries[i], stream);
    }
};
function streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90PvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
        ranges = [];
        (0, _streamJsDefault.default)(feature, boundsStream);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    });
var _d3Array = require("d3-array");
var _areaJs = require("./area.js");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum, ranges, range;
var boundsStream = {
    point: boundsPoint,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum = new (0, _d3Array.Adder)();
        (0, _areaJs.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, _areaJs.areaStream).polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if ((0, _areaJs.areaRingSum) < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > (0, _mathJs.epsilon)) phi1 = 90;
        else if (deltaSum < -(0, _mathJs.epsilon)) phi0 = -90;
        range[0] = lambda0, range[1] = lambda1;
    },
    sphere: function() {
        lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
};
function boundsPoint(lambda, phi) {
    ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
    var p = (0, _cartesianJs.cartesian)([
        lambda * (0, _mathJs.radians),
        phi * (0, _mathJs.radians)
    ]);
    if (p0) {
        var normal = (0, _cartesianJs.cartesianCross)(p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, _cartesianJs.cartesianCross)(equatorial, normal);
        (0, _cartesianJs.cartesianNormalizeInPlace)(inflection);
        inflection = (0, _cartesianJs.spherical)(inflection);
        var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, _mathJs.degrees) * sign, phii, antimeridian = (0, _mathJs.abs)(delta) > 180;
        if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, _mathJs.degrees);
            if (phii > phi1) phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, _mathJs.degrees);
            if (phii < phi0) phi0 = phii;
        } else {
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        } else if (lambda1 >= lambda0) {
            if (lambda < lambda0) lambda0 = lambda;
            if (lambda > lambda1) lambda1 = lambda;
        } else {
            if (lambda > lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
    } else ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
    boundsStream.point = linePoint;
}
function boundsLineEnd() {
    range[0] = lambda0, range[1] = lambda1;
    boundsStream.point = boundsPoint;
    p0 = null;
}
function boundsRingPoint(lambda, phi) {
    if (p0) {
        var delta = lambda - lambda2;
        deltaSum.add((0, _mathJs.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else lambda00 = lambda, phi00 = phi;
    (0, _areaJs.areaStream).point(lambda, phi);
    linePoint(lambda, phi);
}
function boundsRingStart() {
    (0, _areaJs.areaStream).lineStart();
}
function boundsRingEnd() {
    boundsRingPoint(lambda00, phi00);
    (0, _areaJs.areaStream).lineEnd();
    if ((0, _mathJs.abs)(deltaSum) > (0, _mathJs.epsilon)) lambda0 = -(lambda1 = 180);
    range[0] = lambda0, range[1] = lambda1;
    p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
    return a[0] - b[0];
}
function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

},{"d3-array":"4pSqo","./area.js":"fU0uC","./cartesian.js":"90jyE","./math.js":"hswBu","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90jyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spherical", ()=>spherical);
parcelHelpers.export(exports, "cartesian", ()=>cartesian);
parcelHelpers.export(exports, "cartesianDot", ()=>cartesianDot);
parcelHelpers.export(exports, "cartesianCross", ()=>cartesianCross);
// TODO return a
parcelHelpers.export(exports, "cartesianAddInPlace", ()=>cartesianAddInPlace);
parcelHelpers.export(exports, "cartesianScale", ()=>cartesianScale);
// TODO return d
parcelHelpers.export(exports, "cartesianNormalizeInPlace", ()=>cartesianNormalizeInPlace);
var _mathJs = require("./math.js");
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]),
        (0, _mathJs.asin)(cartesian[2])
    ];
}
function cartesian(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, _mathJs.cos)(phi);
    return [
        cosPhi * (0, _mathJs.cos)(lambda),
        cosPhi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}
function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function cartesianNormalizeInPlace(d) {
    var l = (0, _mathJs.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

},{"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSoBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = 0;
        X2 = new (0, _d3Array.Adder)();
        Y2 = new (0, _d3Array.Adder)();
        Z2 = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, centroidStream);
        var x = +X2, y = +Y2, z = +Z2, m = (0, _mathJs.hypot)(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < (0, _mathJs.epsilon2)) {
            x = X1, y = Y1, z = Z1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < (0, _mathJs.epsilon)) x = X0, y = Y0, z = Z0;
            m = (0, _mathJs.hypot)(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < (0, _mathJs.epsilon2)) return [
                NaN,
                NaN
            ];
        }
        return [
            (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
            (0, _mathJs.asin)(z / m) * (0, _mathJs.degrees)
        ];
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0; // previous point
var centroidStream = {
    sphere: (0, _noopJsDefault.default),
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    centroidPointCartesian(cosPhi * (0, _mathJs.cos)(lambda), cosPhi * (0, _mathJs.sin)(lambda), (0, _mathJs.sin)(phi));
}
function centroidPointCartesian(x, y, z) {
    ++W0;
    X0 += (x - X0) / W0;
    Y0 += (y - Y0) / W0;
    Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
    centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidStream.point = centroidLinePoint;
    centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), w = (0, _mathJs.atan2)((0, _mathJs.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
    centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
    centroidRingPoint(lambda00, phi00);
    centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    centroidStream.point = centroidRingPoint;
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _mathJs.hypot)(cx, cy, cz), w = (0, _mathJs.asin)(m), v = m && -w / m; // area weight multiplier
    X2.add(v * cx);
    Y2.add(v * cy);
    Z2.add(v * cz);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}

},{"d3-array":"4pSqo","./math.js":"hswBu","./noop.js":"bwHmr","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2UTty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generates a circle centered at [0°, 0°], with a given radius and precision.
parcelHelpers.export(exports, "circleStream", ()=>circleStream);
parcelHelpers.export(exports, "default", ()=>function() {
        var center = (0, _constantJsDefault.default)([
            0,
            0
        ]), radius = (0, _constantJsDefault.default)(90), precision = (0, _constantJsDefault.default)(2), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= (0, _mathJs.degrees), x[1] *= (0, _mathJs.degrees);
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, _mathJs.radians), p = precision.apply(this, arguments) * (0, _mathJs.radians);
            ring = [];
            rotate = (0, _rotationJs.rotateRadians)(-c[0] * (0, _mathJs.radians), -c[1] * (0, _mathJs.radians), 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : precision;
        };
        return circle;
    });
var _cartesianJs = require("./cartesian.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _rotationJs = require("./rotation.js");
function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, _mathJs.cos)(radius), sinRadius = (0, _mathJs.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, _mathJs.tau);
        t1 = radius - step / 2;
    } else {
        t0 = circleRadius(cosRadius, t0);
        t1 = circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, _mathJs.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, _cartesianJs.spherical)([
            cosRadius,
            -sinRadius * (0, _mathJs.cos)(t),
            -sinRadius * (0, _mathJs.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
    point = (0, _cartesianJs.cartesian)(point), point[0] -= cosRadius;
    (0, _cartesianJs.cartesianNormalizeInPlace)(point);
    var radius = (0, _mathJs.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, _mathJs.tau) - (0, _mathJs.epsilon)) % (0, _mathJs.tau);
}

},{"./cartesian.js":"90jyE","./constant.js":"kMW7Y","./math.js":"hswBu","./rotation.js":"ka8Fr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMW7Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ka8Fr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rotateRadians", ()=>rotateRadians);
parcelHelpers.export(exports, "default", ()=>function(rotate) {
        rotate = rotateRadians(rotate[0] * (0, _mathJs.radians), rotate[1] * (0, _mathJs.radians), rotate.length > 2 ? rotate[2] * (0, _mathJs.radians) : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        };
        return forward;
    });
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mathJs = require("./math.js");
function rotationIdentity(lambda, phi) {
    if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
    return [
        lambda,
        phi
    ];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, _mathJs.tau)) ? deltaPhi || deltaGamma ? (0, _composeJsDefault.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
        return [
            lambda,
            phi
        ];
    };
}
function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, _mathJs.cos)(deltaPhi), sinDeltaPhi = (0, _mathJs.sin)(deltaPhi), cosDeltaGamma = (0, _mathJs.cos)(deltaGamma), sinDeltaGamma = (0, _mathJs.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}

},{"./compose.js":"2iAT7","./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iAT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bpOyZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
exports.default = (0, _indexJsDefault.default)(function() {
    return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [
    -(0, _mathJs.pi),
    -(0, _mathJs.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi), delta = (0, _mathJs.abs)(lambda1 - lambda0);
            if ((0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, _mathJs.pi)) {
                if ((0, _mathJs.abs)(lambda0 - sign0) < (0, _mathJs.epsilon)) lambda0 -= sign0 * (0, _mathJs.epsilon); // handle degeneracies
                if ((0, _mathJs.abs)(lambda1 - sign1) < (0, _mathJs.epsilon)) lambda1 -= sign1 * (0, _mathJs.epsilon);
                phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _mathJs.sin)(lambda0 - lambda1);
    return (0, _mathJs.abs)(sinLambda0Lambda1) > (0, _mathJs.epsilon) ? (0, _mathJs.atan)(((0, _mathJs.sin)(phi0) * (cosPhi1 = (0, _mathJs.cos)(phi1)) * (0, _mathJs.sin)(lambda1) - (0, _mathJs.sin)(phi1) * (cosPhi0 = (0, _mathJs.cos)(phi0)) * (0, _mathJs.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, _mathJs.halfPi);
        stream.point(-(0, _mathJs.pi), phi);
        stream.point(0, phi);
        stream.point((0, _mathJs.pi), phi);
        stream.point((0, _mathJs.pi), 0);
        stream.point((0, _mathJs.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, _mathJs.pi), -phi);
        stream.point(-(0, _mathJs.pi), 0);
        stream.point(-(0, _mathJs.pi), phi);
    } else if ((0, _mathJs.abs)(from[0] - to[0]) > (0, _mathJs.epsilon)) {
        var lambda = from[0] < to[0] ? (0, _mathJs.pi) : -(0, _mathJs.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

},{"./index.js":"dJoEr","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJoEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = (0, _bufferJsDefault.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = (0, _d3Array.merge)(segments);
                    var startInside = (0, _polygonContainsJsDefault.default)(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    });
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _mathJs = require("../math.js");
var _polygonContainsJs = require("../polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _d3Array = require("d3-array");
function validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - b[1]);
}

},{"./buffer.js":"8HaBU","./rejoin.js":"gC1l2","../math.js":"hswBu","../polygonContains.js":"dRixn","d3-array":"4pSqo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8HaBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: (0, _noopJsDefault.default),
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);

},{"../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gC1l2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
parcelHelpers.export(exports, "default", ()=>function(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if ((0, _pointEqualJsDefault.default)(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * (0, _mathJs.epsilon);
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link(subject);
        link(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    });
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _mathJs = require("../math.js");
function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

},{"../pointEqual.js":"aecr8","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aecr8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
    });
var _mathJs = require("./math.js");

},{"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRixn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = (0, _mathJs.sin)(phi), normal = [
            (0, _mathJs.sin)(lambda),
            -(0, _mathJs.cos)(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new (0, _d3Array.Adder)();
        if (sinPhi === 1) phi = (0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        else if (sinPhi === -1) phi = -(0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + (0, _mathJs.quarterPi), sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + (0, _mathJs.quarterPi), sinPhi1 = (0, _mathJs.sin)(phi1), cosPhi1 = (0, _mathJs.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, _mathJs.pi), k = sinPhi0 * sinPhi1;
                sum.add((0, _mathJs.atan2)(k * sign * (0, _mathJs.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _mathJs.cos)(absDelta)));
                angle += antimeridian ? delta + sign * (0, _mathJs.tau) : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = (0, _cartesianJs.cartesianCross)((0, _cartesianJs.cartesian)(point0), (0, _cartesianJs.cartesian)(point1));
                    (0, _cartesianJs.cartesianNormalizeInPlace)(arc);
                    var intersection = (0, _cartesianJs.cartesianCross)(normal, arc);
                    (0, _cartesianJs.cartesianNormalizeInPlace)(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _mathJs.asin)(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -(0, _mathJs.epsilon) || angle < (0, _mathJs.epsilon) && sum < -(0, _mathJs.epsilon2)) ^ winding & 1;
    });
var _d3Array = require("d3-array");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
function longitude(point) {
    return (0, _mathJs.abs)(point[0]) <= (0, _mathJs.pi) ? point[0] : (0, _mathJs.sign)(point[0]) * (((0, _mathJs.abs)(point[0]) + (0, _mathJs.pi)) % (0, _mathJs.tau) - (0, _mathJs.pi));
}

},{"d3-array":"4pSqo","./cartesian.js":"90jyE","./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8GPcP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var cr = (0, _mathJs.cos)(radius), delta = 2 * (0, _mathJs.radians), smallRadius = cr > 0, notHemisphere = (0, _mathJs.abs)(cr) > (0, _mathJs.epsilon); // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            (0, _circleJs.circleStream)(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return (0, _mathJs.cos)(lambda) * (0, _mathJs.cos)(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi)), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || (0, _pointEqualJsDefault.default)(point0, point2) || (0, _pointEqualJsDefault.default)(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !(0, _pointEqualJsDefault.default)(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = (0, _cartesianJs.cartesian)(a), pb = (0, _cartesianJs.cartesian)(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = (0, _cartesianJs.cartesianCross)(pa, pb), n2n2 = (0, _cartesianJs.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesianJs.cartesianCross)(n1, n2), A = (0, _cartesianJs.cartesianScale)(n1, c1), B = (0, _cartesianJs.cartesianScale)(n2, c2);
            (0, _cartesianJs.cartesianAddInPlace)(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = (0, _cartesianJs.cartesianDot)(A, u), uu = (0, _cartesianJs.cartesianDot)(u, u), t2 = w * w - uu * ((0, _cartesianJs.cartesianDot)(A, A) - 1);
            if (t2 < 0) return;
            var t = (0, _mathJs.sqrt)(t2), q = (0, _cartesianJs.cartesianScale)(u, (-w - t) / uu);
            (0, _cartesianJs.cartesianAddInPlace)(q, A);
            q = (0, _cartesianJs.spherical)(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = (0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon), meridian = polar || delta < (0, _mathJs.epsilon);
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _mathJs.abs)(q[0] - lambda0) < (0, _mathJs.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, _mathJs.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = (0, _cartesianJs.cartesianScale)(u, (-w + t) / uu);
                (0, _cartesianJs.cartesianAddInPlace)(q1, A);
                return [
                    q,
                    (0, _cartesianJs.spherical)(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : (0, _mathJs.pi) - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return (0, _indexJsDefault.default)(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -(0, _mathJs.pi),
            radius - (0, _mathJs.pi)
        ]);
    });
var _cartesianJs = require("../cartesian.js");
var _circleJs = require("../circle.js");
var _mathJs = require("../math.js");
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../cartesian.js":"90jyE","../circle.js":"2UTty","../math.js":"hswBu","../pointEqual.js":"aecr8","./index.js":"dJoEr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hgkNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clipRectangle);
var _mathJs = require("../math.js");
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _d3Array = require("d3-array");
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, _mathJs.abs)(p[0] - x0) < (0, _mathJs.epsilon) ? direction > 0 ? 0 : 3 : (0, _mathJs.abs)(p[0] - x1) < (0, _mathJs.epsilon) ? direction > 0 ? 2 : 1 : (0, _mathJs.abs)(p[1] - y0) < (0, _mathJs.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, _bufferJsDefault.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, _d3Array.merge)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                    y_ = Math.max(clipMin, Math.min(clipMax, y_))
                ], b = [
                    x = Math.max(clipMin, Math.min(clipMax, x)),
                    y = Math.max(clipMin, Math.min(clipMax, y))
                ];
                if ((0, _lineJsDefault.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

},{"../math.js":"hswBu","./buffer.js":"8HaBU","./line.js":"ekx16","./rejoin.js":"gC1l2","d3-array":"4pSqo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekx16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJKKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>graticule);
parcelHelpers.export(exports, "graticule10", ()=>graticule10);
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
function graticuleX(y0, y1, dy) {
    var y = (0, _d3Array.range)(y0, y1 - (0, _mathJs.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function graticuleY(x0, x1, dx) {
    var x = (0, _d3Array.range)(x0, x1 - (0, _mathJs.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function graticule() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, _d3Array.range)((0, _mathJs.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _mathJs.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _mathJs.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, _mathJs.abs)(x % DX) > (0, _mathJs.epsilon);
        }).map(x)).concat((0, _d3Array.range)((0, _mathJs.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, _mathJs.abs)(y % DY) > (0, _mathJs.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = graticuleX(y0, y1, 90);
        y = graticuleY(x0, x1, precision);
        X = graticuleX(Y0, Y1, 90);
        Y = graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, _mathJs.epsilon)
        ],
        [
            180,
            90 - (0, _mathJs.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, _mathJs.epsilon)
        ],
        [
            180,
            80 + (0, _mathJs.epsilon)
        ]
    ]);
}
function graticule10() {
    return graticule()();
}

},{"d3-array":"4pSqo","./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a1PWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var x0 = a[0] * (0, _mathJs.radians), y0 = a[1] * (0, _mathJs.radians), x1 = b[0] * (0, _mathJs.radians), y1 = b[1] * (0, _mathJs.radians), cy0 = (0, _mathJs.cos)(y0), sy0 = (0, _mathJs.sin)(y0), cy1 = (0, _mathJs.cos)(y1), sy1 = (0, _mathJs.sin)(y1), kx0 = cy0 * (0, _mathJs.cos)(x0), ky0 = cy0 * (0, _mathJs.sin)(x0), kx1 = cy1 * (0, _mathJs.cos)(x1), ky1 = cy1 * (0, _mathJs.sin)(x1), d = 2 * (0, _mathJs.asin)((0, _mathJs.sqrt)((0, _mathJs.haversin)(y1 - y0) + cy0 * cy1 * (0, _mathJs.haversin)(x1 - x0))), k = (0, _mathJs.sin)(d);
        var interpolate = d ? function(t) {
            var B = (0, _mathJs.sin)(t *= d) / k, A = (0, _mathJs.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
                (0, _mathJs.atan2)(z, (0, _mathJs.sqrt)(x * x + y * y)) * (0, _mathJs.degrees)
            ];
        } : function() {
            return [
                x0 * (0, _mathJs.degrees),
                y0 * (0, _mathJs.degrees)
            ];
        };
        interpolate.distance = d;
        return interpolate;
    });
var _mathJs = require("./math.js");

},{"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"funLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projection, context) {
        let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                (0, _streamJsDefault.default)(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _areaJsDefault.default)));
            return (0, _areaJsDefault.default).result();
        };
        path.measure = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _measureJsDefault.default)));
            return (0, _measureJsDefault.default).result();
        };
        path.bounds = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _boundsJsDefault.default)));
            return (0, _boundsJsDefault.default).result();
        };
        path.centroid = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _centroidJsDefault.default)));
            return (0, _centroidJsDefault.default).result();
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectionStream = _ == null ? (projection = null, _identityJsDefault.default) : (projection = _).stream;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new (0, _stringJsDefault.default)(digits)) : new (0, _contextJsDefault.default)(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        path.digits = function(_) {
            if (!arguments.length) return digits;
            if (_ == null) digits = null;
            else {
                const d = Math.floor(_);
                if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
                digits = d;
            }
            if (context === null) contextStream = new (0, _stringJsDefault.default)(digits);
            return path;
        };
        return path.projection(projection).digits(digits).context(context);
    });
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _contextJs = require("./context.js");
var _contextJsDefault = parcelHelpers.interopDefault(_contextJs);
var _measureJs = require("./measure.js");
var _measureJsDefault = parcelHelpers.interopDefault(_measureJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);

},{"../identity.js":"gpb1g","../stream.js":"hAqHD","./area.js":"4cqHY","./bounds.js":"2k57R","./centroid.js":"d8ydg","./context.js":"5yul9","./measure.js":"8wEvG","./string.js":"16pyK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gpb1g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4cqHY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var areaSum = new (0, _d3Array.Adder)(), areaRingSum = new (0, _d3Array.Adder)(), x00, y00, x0, y0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        areaStream.lineStart = areaStream.lineEnd = areaStream.point = (0, _noopJsDefault.default);
        areaSum.add((0, _mathJs.abs)(areaRingSum));
        areaRingSum = new (0, _d3Array.Adder)();
    },
    result: function() {
        var area = areaSum / 2;
        areaSum = new (0, _d3Array.Adder)();
        return area;
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
    areaRingSum.add(y0 * x - x0 * y);
    x0 = x, y0 = y;
}
function areaRingEnd() {
    areaPoint(x00, y00);
}
exports.default = areaStream;

},{"d3-array":"4pSqo","../math.js":"hswBu","../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2k57R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
    point: boundsPoint,
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        var bounds = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x1 = y1 = -(y0 = x0 = Infinity);
        return bounds;
    }
};
function boundsPoint(x, y) {
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
}
exports.default = boundsStream;

},{"../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d8ydg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
// TODO Enforce positive area for exterior, negative area for interior?
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00, y00, x0, y0;
var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.point = centroidPoint;
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    },
    result: function() {
        var centroid = Z2 ? [
            X2 / Z2,
            Y2 / Z2
        ] : Z1 ? [
            X1 / Z1,
            Y1 / Z1
        ] : Z0 ? [
            X0 / Z0,
            Y0 / Z0
        ] : [
            NaN,
            NaN
        ];
        X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        return centroid;
    }
};
function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
}
function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0 = x, y0 = y);
}
function centroidPointLine(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    centroidPoint(x0 = x, y0 = y);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
    centroidPointRing(x00, y00);
}
function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00 = x0 = x, y00 = y0 = y);
}
function centroidPointRing(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    z = y0 * x - x0 * y;
    X2 += z * (x0 + x);
    Y2 += z * (y0 + y);
    Z2 += z * 3;
    centroidPoint(x0 = x, y0 = y);
}
exports.default = centroidStream;

},{"../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5yul9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathContext);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function PathContext(context) {
    this._context = context;
}
PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, _mathJs.tau));
                break;
        }
    },
    result: (0, _noopJsDefault.default)
};

},{"../math.js":"hswBu","../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wEvG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var lengthSum = new (0, _d3Array.Adder)(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
    point: (0, _noopJsDefault.default),
    lineStart: function() {
        lengthStream.point = lengthPointFirst;
    },
    lineEnd: function() {
        if (lengthRing) lengthPoint(x00, y00);
        lengthStream.point = (0, _noopJsDefault.default);
    },
    polygonStart: function() {
        lengthRing = true;
    },
    polygonEnd: function() {
        lengthRing = null;
    },
    result: function() {
        var length = +lengthSum;
        lengthSum = new (0, _d3Array.Adder)();
        return length;
    }
};
function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add((0, _mathJs.sqrt)(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
}
exports.default = lengthStream;

},{"d3-array":"4pSqo","../math.js":"hswBu","../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"16pyK":[function(require,module,exports,__globalThis) {
// Simple caching for constant-radius points.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
class PathString {
    constructor(digits){
        this._append = digits == null ? append : appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== cacheRadius || this._append !== cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    cacheRadius = r;
                    cacheAppend = this._append;
                    cacheCircle = this._;
                    this._ = s;
                }
                this._ += cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
exports.default = PathString;
function append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return append;
    if (d !== cacheDigits) {
        const k = 10 ** d;
        cacheDigits = d;
        cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return cacheAppend;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gVkNI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicEqualAreaJsDefault.default)().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    });
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);

},{"./conicEqualArea.js":"84dLC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"84dLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEqualAreaRaw", ()=>conicEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
function conicEqualAreaRaw(y0, y1) {
    var sy0 = (0, _mathJs.sin)(y0), n = (sy0 + (0, _mathJs.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, _mathJs.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, _mathJs.sqrt)(c - 2 * n * (0, _mathJs.sin)(y)) / n;
        return [
            r * (0, _mathJs.sin)(x *= n),
            r0 - r * (0, _mathJs.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(r0y)) * (0, _mathJs.sign)(r0y);
        if (r0y * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(r0y);
        return [
            l / n,
            (0, _mathJs.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}

},{"../math.js":"hswBu","./conic.js":"dYBWc","./cylindricalEqualArea.js":"1c2m0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYBWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicProjection", ()=>conicProjection);
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
function conicProjection(projectAt) {
    var phi0 = 0, phi1 = (0, _mathJs.pi) / 3, m = (0, _indexJs.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, _mathJs.radians), phi1 = _[1] * (0, _mathJs.radians)) : [
            phi0 * (0, _mathJs.degrees),
            phi1 * (0, _mathJs.degrees)
        ];
    };
    return p;
}

},{"../math.js":"hswBu","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jabgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>projection);
parcelHelpers.export(exports, "projectionMutator", ()=>projectionMutator);
var _antimeridianJs = require("../clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs = require("../clip/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _composeJs = require("../compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _resampleJs = require("./resample.js");
var _resampleJsDefault = parcelHelpers.interopDefault(_resampleJs);
var transformRadians = (0, _transformJs.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, _mathJs.radians), y * (0, _mathJs.radians));
    }
});
function transformRotate(rotate) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function projection(project) {
    return projectionMutator(function() {
        return project;
    })();
}
function projectionMutator(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, _antimeridianJsDefault.default), x0 = null, y0, x1, y1, postclip = (0, _identityJsDefault.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, _mathJs.radians), point[1] * (0, _mathJs.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, _mathJs.degrees),
            point[1] * (0, _mathJs.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, _circleJsDefault.default)(theta = _ * (0, _mathJs.radians)) : (theta = null, _antimeridianJsDefault.default), reset()) : theta * (0, _mathJs.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, _mathJs.radians), phi = _[1] % 360 * (0, _mathJs.radians), recenter()) : [
            lambda * (0, _mathJs.degrees),
            phi * (0, _mathJs.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, _mathJs.radians), deltaPhi = _[1] % 360 * (0, _mathJs.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, _mathJs.radians) : 0, recenter()) : [
            deltaLambda * (0, _mathJs.degrees),
            deltaPhi * (0, _mathJs.degrees),
            deltaGamma * (0, _mathJs.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), recenter()) : alpha * (0, _mathJs.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2 = _ * _), reset()) : (0, _mathJs.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, _fitJs.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, _fitJs.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, _fitJs.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, _fitJs.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, _rotationJs.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, _composeJsDefault.default)(project, transform);
        projectRotateTransform = (0, _composeJsDefault.default)(rotate, projectTransform);
        projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

},{"../clip/antimeridian.js":"bpOyZ","../clip/circle.js":"8GPcP","../clip/rectangle.js":"hgkNK","../compose.js":"2iAT7","../identity.js":"gpb1g","../math.js":"hswBu","../rotation.js":"ka8Fr","../transform.js":"2cPnh","./fit.js":"8wphn","./resample.js":"l0Yg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2cPnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(methods) {
        return {
            stream: transformer(methods)
        };
    });
parcelHelpers.export(exports, "transformer", ()=>transformer);
function transformer(methods) {
    return function(stream) {
        var s = new TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() {}
TransformStream.prototype = {
    constructor: TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wphn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fitExtent", ()=>fitExtent);
parcelHelpers.export(exports, "fitSize", ()=>fitSize);
parcelHelpers.export(exports, "fitWidth", ()=>fitWidth);
parcelHelpers.export(exports, "fitHeight", ()=>fitHeight);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _boundsJs = require("../path/bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
function fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, _streamJsDefault.default)(object, projection.stream((0, _boundsJsDefault.default)));
    fitBounds((0, _boundsJsDefault.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function fitExtent(projection, extent, object) {
    return fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitSize(projection, size, object) {
    return fitExtent(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function fitWidth(projection, width, object) {
    return fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitHeight(projection, height, object) {
    return fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

},{"../stream.js":"hAqHD","../path/bounds.js":"2k57R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l0Yg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, delta2) {
        return +delta2 ? resample(project, delta2) : resampleNone(project);
    });
var _cartesianJs = require("../cartesian.js");
var _mathJs = require("../math.js");
var _transformJs = require("../transform.js");
var maxDepth = 16, cosMinDistance = (0, _mathJs.cos)(30 * (0, _mathJs.radians)); // cos(minimum angular distance)
function resampleNone(project) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, _mathJs.sqrt)(a * a + b * b + c * c), phi2 = (0, _mathJs.asin)(c /= m), lambda2 = (0, _mathJs.abs)((0, _mathJs.abs)(c) - 1) < (0, _mathJs.epsilon) || (0, _mathJs.abs)(lambda0 - lambda1) < (0, _mathJs.epsilon) ? (lambda0 + lambda1) / 2 : (0, _mathJs.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, _mathJs.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, _cartesianJs.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

},{"../cartesian.js":"90jyE","../math.js":"hswBu","../transform.js":"2cPnh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1c2m0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
var _mathJs = require("../math.js");
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kKmvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
parcelHelpers.export(exports, "default", ()=>function() {
        var cache, cacheStream, lower48 = (0, _albersJsDefault.default)(), lower48Point, alaska = (0, _conicEqualAreaJsDefault.default)().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = (0, _conicEqualAreaJsDefault.default)().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + (0, _mathJs.epsilon),
                    y + 0.120 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.214 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + (0, _mathJs.epsilon),
                    y + 0.166 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.115 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    });
var _mathJs = require("../math.js");
var _albersJs = require("./albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _fitJs = require("./fit.js");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}

},{"../math.js":"hswBu","./albers.js":"gVkNI","./conicEqualArea.js":"84dLC","./fit.js":"8wphn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"agpPS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEqualAreaRaw", ()=>azimuthalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEqualAreaRaw = (0, _azimuthalJs.azimuthalRaw)(function(cxcy) {
    return (0, _mathJs.sqrt)(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.asin)(z / 2);
});

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlPcy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalRaw", ()=>azimuthalRaw);
parcelHelpers.export(exports, "azimuthalInvert", ()=>azimuthalInvert);
var _mathJs = require("../math.js");
function azimuthalRaw(scale) {
    return function(x, y) {
        var cx = (0, _mathJs.cos)(x), cy = (0, _mathJs.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, _mathJs.sin)(x),
            k * (0, _mathJs.sin)(y)
        ];
    };
}
function azimuthalInvert(angle) {
    return function(x, y) {
        var z = (0, _mathJs.sqrt)(x * x + y * y), c = angle(z), sc = (0, _mathJs.sin)(c), cc = (0, _mathJs.cos)(c);
        return [
            (0, _mathJs.atan2)(x * sc, z * cc),
            (0, _mathJs.asin)(z && y * sc / z)
        ];
    };
}

},{"../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EsCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEquidistantRaw", ()=>azimuthalEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEquidistantRaw = (0, _azimuthalJs.azimuthalRaw)(function(c) {
    return (c = (0, _mathJs.acos)(c)) && c / (0, _mathJs.sin)(c);
});
azimuthalEquidistantRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return z;
});

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d2zyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicConformalRaw", ()=>conicConformalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _mercatorJs = require("./mercator.js");
function tany(y) {
    return (0, _mathJs.tan)(((0, _mathJs.halfPi) + y) / 2);
}
function conicConformalRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (0, _mathJs.log)(cy0 / (0, _mathJs.cos)(y1)) / (0, _mathJs.log)(tany(y1) / tany(y0)), f = cy0 * (0, _mathJs.pow)(tany(y0), n) / n;
    if (!n) return 0, _mercatorJs.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, _mathJs.halfPi) + (0, _mathJs.epsilon)) y = -(0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        } else if (y > (0, _mathJs.halfPi) - (0, _mathJs.epsilon)) y = (0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        var r = f / (0, _mathJs.pow)(tany(y), n);
        return [
            r * (0, _mathJs.sin)(n * x),
            f - r * (0, _mathJs.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + fy * fy), l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(fy)) * (0, _mathJs.sign)(fy);
        if (fy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(fy);
        return [
            l / n,
            2 * (0, _mathJs.atan)((0, _mathJs.pow)(f / r, 1 / n)) - (0, _mathJs.halfPi)
        ];
    };
    return project;
}

},{"../math.js":"hswBu","./conic.js":"dYBWc","./mercator.js":"awlzv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awlzv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercatorRaw", ()=>mercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return mercatorProjection(mercatorRaw).scale(961 / (0, _mathJs.tau));
    });
parcelHelpers.export(exports, "mercatorProjection", ()=>mercatorProjection);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function mercatorRaw(lambda, phi) {
    return [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2))
    ];
}
mercatorRaw.invert = function(x, y) {
    return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
};
function mercatorProjection(project) {
    var m = (0, _indexJsDefault.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, _mathJs.pi) * scale(), t = m((0, _rotationJsDefault.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === mercatorRaw ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

},{"../math.js":"hswBu","../rotation.js":"ka8Fr","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pwTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEquidistantRaw", ()=>conicEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _equirectangularJs = require("./equirectangular.js");
function conicEquidistantRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (cy0 - (0, _mathJs.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return 0, _equirectangularJs.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, _mathJs.sin)(nx),
            g - gy * (0, _mathJs.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(gy)) * (0, _mathJs.sign)(gy);
        if (gy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(gy);
        return [
            l / n,
            g - (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}

},{"../math.js":"hswBu","./conic.js":"dYBWc","./equirectangular.js":"ivpfD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ivpfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equirectangularRaw", ()=>equirectangularRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equirectangularRaw).scale(152.63);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function equirectangularRaw(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
equirectangularRaw.invert = equirectangularRaw;

},{"./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3QHBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equalEarthRaw", ()=>equalEarthRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equalEarthRaw).scale(177.158);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = (0, _mathJs.sqrt)(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
    var l = (0, _mathJs.asin)(M * (0, _mathJs.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, _mathJs.cos)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
        l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
    ];
}
equalEarthRaw.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < iterations; ++i){
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2)) break;
    }
    return [
        M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, _mathJs.cos)(l),
        (0, _mathJs.asin)((0, _mathJs.sin)(l) / M)
    ];
};

},{"./index.js":"jabgC","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8g2g8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gnomonicRaw", ()=>gnomonicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(gnomonicRaw).scale(144.049).clipAngle(60);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function gnomonicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
gnomonicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.atan));

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3FhuX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, _transformJs.transformer)({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = (0, _identityJsDefault.default), cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), sa = (0, _mathJs.sin)(alpha), ca = (0, _mathJs.cos)(alpha), reset()) : alpha * (0, _mathJs.degrees);
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(projection, height, object);
        };
        return projection;
    });
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _mathJs = require("../math.js");

},{"../clip/rectangle.js":"hgkNK","../identity.js":"gpb1g","../transform.js":"2cPnh","./fit.js":"8wphn","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"invjX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth1Raw", ()=>naturalEarth1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(naturalEarth1Raw).scale(175.295);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
naturalEarth1Raw.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};

},{"./index.js":"jabgC","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awIEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orthographicRaw", ()=>orthographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(orthographicRaw).scale(249.5).clipAngle(90 + (0, _mathJs.epsilon));
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function orthographicRaw(x, y) {
    return [
        (0, _mathJs.cos)(y) * (0, _mathJs.sin)(x),
        (0, _mathJs.sin)(y)
    ];
}
orthographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.asin));

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fBs4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereographicRaw", ()=>stereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(stereographicRaw).scale(250).clipAngle(142);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function stereographicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = 1 + (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
stereographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.atan)(z);
});

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3KJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transverseMercatorRaw", ()=>transverseMercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var m = (0, _mercatorJs.mercatorProjection)(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    });
var _mathJs = require("../math.js");
var _mercatorJs = require("./mercator.js");
function transverseMercatorRaw(lambda, phi) {
    return [
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2)),
        -lambda
    ];
}
transverseMercatorRaw.invert = function(x, y) {
    return [
        -y,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(x)) - (0, _mathJs.halfPi)
    ];
};

},{"../math.js":"hswBu","./mercator.js":"awlzv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"50OFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoAiry", ()=>(0, _airyJsDefault.default));
parcelHelpers.export(exports, "geoAiryRaw", ()=>(0, _airyJs.airyRaw));
parcelHelpers.export(exports, "geoAitoff", ()=>(0, _aitoffJsDefault.default));
parcelHelpers.export(exports, "geoAitoffRaw", ()=>(0, _aitoffJs.aitoffRaw));
parcelHelpers.export(exports, "geoArmadillo", ()=>(0, _armadilloJsDefault.default));
parcelHelpers.export(exports, "geoArmadilloRaw", ()=>(0, _armadilloJs.armadilloRaw));
parcelHelpers.export(exports, "geoAugust", ()=>(0, _augustJsDefault.default));
parcelHelpers.export(exports, "geoAugustRaw", ()=>(0, _augustJs.augustRaw));
parcelHelpers.export(exports, "geoBaker", ()=>(0, _bakerJsDefault.default));
parcelHelpers.export(exports, "geoBakerRaw", ()=>(0, _bakerJs.bakerRaw));
parcelHelpers.export(exports, "geoBerghaus", ()=>(0, _berghausJsDefault.default));
parcelHelpers.export(exports, "geoBerghausRaw", ()=>(0, _berghausJs.berghausRaw));
parcelHelpers.export(exports, "geoBertin1953", ()=>(0, _bertinJsDefault.default));
parcelHelpers.export(exports, "geoBertin1953Raw", ()=>(0, _bertinJs.bertin1953Raw));
parcelHelpers.export(exports, "geoBoggs", ()=>(0, _boggsJsDefault.default));
parcelHelpers.export(exports, "geoBoggsRaw", ()=>(0, _boggsJs.boggsRaw));
parcelHelpers.export(exports, "geoBonne", ()=>(0, _bonneJsDefault.default));
parcelHelpers.export(exports, "geoBonneRaw", ()=>(0, _bonneJs.bonneRaw));
parcelHelpers.export(exports, "geoBottomley", ()=>(0, _bottomleyJsDefault.default));
parcelHelpers.export(exports, "geoBottomleyRaw", ()=>(0, _bottomleyJs.bottomleyRaw));
parcelHelpers.export(exports, "geoBromley", ()=>(0, _bromleyJsDefault.default));
parcelHelpers.export(exports, "geoBromleyRaw", ()=>(0, _bromleyJs.bromleyRaw));
parcelHelpers.export(exports, "geoChamberlin", ()=>(0, _chamberlinJsDefault.default));
parcelHelpers.export(exports, "geoChamberlinRaw", ()=>(0, _chamberlinJs.chamberlinRaw));
parcelHelpers.export(exports, "geoChamberlinAfrica", ()=>(0, _chamberlinJs.chamberlinAfrica));
parcelHelpers.export(exports, "geoCollignon", ()=>(0, _collignonJsDefault.default));
parcelHelpers.export(exports, "geoCollignonRaw", ()=>(0, _collignonJs.collignonRaw));
parcelHelpers.export(exports, "geoCraig", ()=>(0, _craigJsDefault.default));
parcelHelpers.export(exports, "geoCraigRaw", ()=>(0, _craigJs.craigRaw));
parcelHelpers.export(exports, "geoCraster", ()=>(0, _crasterJsDefault.default));
parcelHelpers.export(exports, "geoCrasterRaw", ()=>(0, _crasterJs.crasterRaw));
parcelHelpers.export(exports, "geoCylindricalEqualArea", ()=>(0, _cylindricalEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoCylindricalEqualAreaRaw", ()=>(0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw));
parcelHelpers.export(exports, "geoCylindricalStereographic", ()=>(0, _cylindricalStereographicJsDefault.default));
parcelHelpers.export(exports, "geoCylindricalStereographicRaw", ()=>(0, _cylindricalStereographicJs.cylindricalStereographicRaw));
parcelHelpers.export(exports, "geoEckert1", ()=>(0, _eckert1JsDefault.default));
parcelHelpers.export(exports, "geoEckert1Raw", ()=>(0, _eckert1Js.eckert1Raw));
parcelHelpers.export(exports, "geoEckert2", ()=>(0, _eckert2JsDefault.default));
parcelHelpers.export(exports, "geoEckert2Raw", ()=>(0, _eckert2Js.eckert2Raw));
parcelHelpers.export(exports, "geoEckert3", ()=>(0, _eckert3JsDefault.default));
parcelHelpers.export(exports, "geoEckert3Raw", ()=>(0, _eckert3Js.eckert3Raw));
parcelHelpers.export(exports, "geoEckert4", ()=>(0, _eckert4JsDefault.default));
parcelHelpers.export(exports, "geoEckert4Raw", ()=>(0, _eckert4Js.eckert4Raw));
parcelHelpers.export(exports, "geoEckert5", ()=>(0, _eckert5JsDefault.default));
parcelHelpers.export(exports, "geoEckert5Raw", ()=>(0, _eckert5Js.eckert5Raw));
parcelHelpers.export(exports, "geoEckert6", ()=>(0, _eckert6JsDefault.default));
parcelHelpers.export(exports, "geoEckert6Raw", ()=>(0, _eckert6Js.eckert6Raw));
parcelHelpers.export(exports, "geoEisenlohr", ()=>(0, _eisenlohrJsDefault.default));
parcelHelpers.export(exports, "geoEisenlohrRaw", ()=>(0, _eisenlohrJs.eisenlohrRaw));
parcelHelpers.export(exports, "geoFahey", ()=>(0, _faheyJsDefault.default));
parcelHelpers.export(exports, "geoFaheyRaw", ()=>(0, _faheyJs.faheyRaw));
parcelHelpers.export(exports, "geoFoucaut", ()=>(0, _foucautJsDefault.default));
parcelHelpers.export(exports, "geoFoucautRaw", ()=>(0, _foucautJs.foucautRaw));
parcelHelpers.export(exports, "geoFoucautSinusoidal", ()=>(0, _foucautSinusoidalJsDefault.default));
parcelHelpers.export(exports, "geoFoucautSinusoidalRaw", ()=>(0, _foucautSinusoidalJs.foucautSinusoidalRaw));
parcelHelpers.export(exports, "geoGilbert", ()=>(0, _gilbertJsDefault.default));
parcelHelpers.export(exports, "geoGingery", ()=>(0, _gingeryJsDefault.default));
parcelHelpers.export(exports, "geoGingeryRaw", ()=>(0, _gingeryJs.gingeryRaw));
parcelHelpers.export(exports, "geoGinzburg4", ()=>(0, _ginzburg4JsDefault.default));
parcelHelpers.export(exports, "geoGinzburg4Raw", ()=>(0, _ginzburg4Js.ginzburg4Raw));
parcelHelpers.export(exports, "geoGinzburg5", ()=>(0, _ginzburg5JsDefault.default));
parcelHelpers.export(exports, "geoGinzburg5Raw", ()=>(0, _ginzburg5Js.ginzburg5Raw));
parcelHelpers.export(exports, "geoGinzburg6", ()=>(0, _ginzburg6JsDefault.default));
parcelHelpers.export(exports, "geoGinzburg6Raw", ()=>(0, _ginzburg6Js.ginzburg6Raw));
parcelHelpers.export(exports, "geoGinzburg8", ()=>(0, _ginzburg8JsDefault.default));
parcelHelpers.export(exports, "geoGinzburg8Raw", ()=>(0, _ginzburg8Js.ginzburg8Raw));
parcelHelpers.export(exports, "geoGinzburg9", ()=>(0, _ginzburg9JsDefault.default));
parcelHelpers.export(exports, "geoGinzburg9Raw", ()=>(0, _ginzburg9Js.ginzburg9Raw));
parcelHelpers.export(exports, "geoGringorten", ()=>(0, _gringortenJsDefault.default));
parcelHelpers.export(exports, "geoGringortenRaw", ()=>(0, _gringortenJs.gringortenRaw));
parcelHelpers.export(exports, "geoGuyou", ()=>(0, _guyouJsDefault.default));
parcelHelpers.export(exports, "geoGuyouRaw", ()=>(0, _guyouJs.guyouRaw));
parcelHelpers.export(exports, "geoHammer", ()=>(0, _hammerJsDefault.default));
parcelHelpers.export(exports, "geoHammerRaw", ()=>(0, _hammerJs.hammerRaw));
parcelHelpers.export(exports, "geoHammerRetroazimuthal", ()=>(0, _hammerRetroazimuthalJsDefault.default));
parcelHelpers.export(exports, "geoHammerRetroazimuthalRaw", ()=>(0, _hammerRetroazimuthalJs.hammerRetroazimuthalRaw));
parcelHelpers.export(exports, "geoHealpix", ()=>(0, _healpixJsDefault.default));
parcelHelpers.export(exports, "geoHealpixRaw", ()=>(0, _healpixJs.healpixRaw));
parcelHelpers.export(exports, "geoHill", ()=>(0, _hillJsDefault.default));
parcelHelpers.export(exports, "geoHillRaw", ()=>(0, _hillJs.hillRaw));
parcelHelpers.export(exports, "geoHomolosine", ()=>(0, _homolosineJsDefault.default));
parcelHelpers.export(exports, "geoHomolosineRaw", ()=>(0, _homolosineJs.homolosineRaw));
parcelHelpers.export(exports, "geoHufnagel", ()=>(0, _hufnagelJsDefault.default));
parcelHelpers.export(exports, "geoHufnagelRaw", ()=>(0, _hufnagelJs.hufnagelRaw));
parcelHelpers.export(exports, "geoHyperelliptical", ()=>(0, _hyperellipticalJsDefault.default));
parcelHelpers.export(exports, "geoHyperellipticalRaw", ()=>(0, _hyperellipticalJs.hyperellipticalRaw));
parcelHelpers.export(exports, "geoInterrupt", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "geoInterruptedBoggs", ()=>(0, _boggsJsDefault1.default));
parcelHelpers.export(exports, "geoInterruptedHomolosine", ()=>(0, _homolosineJsDefault1.default));
parcelHelpers.export(exports, "geoInterruptedMollweide", ()=>(0, _mollweideJsDefault.default));
parcelHelpers.export(exports, "geoInterruptedMollweideHemispheres", ()=>(0, _mollweideHemispheresJsDefault.default));
parcelHelpers.export(exports, "geoInterruptedSinuMollweide", ()=>(0, _sinuMollweideJsDefault.default));
parcelHelpers.export(exports, "geoInterruptedSinusoidal", ()=>(0, _sinusoidalJsDefault.default));
parcelHelpers.export(exports, "geoKavrayskiy7", ()=>(0, _kavrayskiy7JsDefault.default));
parcelHelpers.export(exports, "geoKavrayskiy7Raw", ()=>(0, _kavrayskiy7Js.kavrayskiy7Raw));
parcelHelpers.export(exports, "geoLagrange", ()=>(0, _lagrangeJsDefault.default));
parcelHelpers.export(exports, "geoLagrangeRaw", ()=>(0, _lagrangeJs.lagrangeRaw));
parcelHelpers.export(exports, "geoLarrivee", ()=>(0, _larriveeJsDefault.default));
parcelHelpers.export(exports, "geoLarriveeRaw", ()=>(0, _larriveeJs.larriveeRaw));
parcelHelpers.export(exports, "geoLaskowski", ()=>(0, _laskowskiJsDefault.default));
parcelHelpers.export(exports, "geoLaskowskiRaw", ()=>(0, _laskowskiJs.laskowskiRaw));
parcelHelpers.export(exports, "geoLittrow", ()=>(0, _littrowJsDefault.default));
parcelHelpers.export(exports, "geoLittrowRaw", ()=>(0, _littrowJs.littrowRaw));
parcelHelpers.export(exports, "geoLoximuthal", ()=>(0, _loximuthalJsDefault.default));
parcelHelpers.export(exports, "geoLoximuthalRaw", ()=>(0, _loximuthalJs.loximuthalRaw));
parcelHelpers.export(exports, "geoMiller", ()=>(0, _millerJsDefault.default));
parcelHelpers.export(exports, "geoMillerRaw", ()=>(0, _millerJs.millerRaw));
parcelHelpers.export(exports, "geoModifiedStereographic", ()=>(0, _modifiedStereographicJsDefault.default));
parcelHelpers.export(exports, "geoModifiedStereographicRaw", ()=>(0, _modifiedStereographicJs.modifiedStereographicRaw));
parcelHelpers.export(exports, "geoModifiedStereographicAlaska", ()=>(0, _modifiedStereographicJs.modifiedStereographicAlaska));
parcelHelpers.export(exports, "geoModifiedStereographicGs48", ()=>(0, _modifiedStereographicJs.modifiedStereographicGs48));
parcelHelpers.export(exports, "geoModifiedStereographicGs50", ()=>(0, _modifiedStereographicJs.modifiedStereographicGs50));
parcelHelpers.export(exports, "geoModifiedStereographicMiller", ()=>(0, _modifiedStereographicJs.modifiedStereographicMiller));
parcelHelpers.export(exports, "geoModifiedStereographicLee", ()=>(0, _modifiedStereographicJs.modifiedStereographicLee));
parcelHelpers.export(exports, "geoMollweide", ()=>(0, _mollweideJsDefault1.default));
parcelHelpers.export(exports, "geoMollweideRaw", ()=>(0, _mollweideJs1.mollweideRaw));
parcelHelpers.export(exports, "geoMtFlatPolarParabolic", ()=>(0, _mtFlatPolarParabolicJsDefault.default));
parcelHelpers.export(exports, "geoMtFlatPolarParabolicRaw", ()=>(0, _mtFlatPolarParabolicJs.mtFlatPolarParabolicRaw));
parcelHelpers.export(exports, "geoMtFlatPolarQuartic", ()=>(0, _mtFlatPolarQuarticJsDefault.default));
parcelHelpers.export(exports, "geoMtFlatPolarQuarticRaw", ()=>(0, _mtFlatPolarQuarticJs.mtFlatPolarQuarticRaw));
parcelHelpers.export(exports, "geoMtFlatPolarSinusoidal", ()=>(0, _mtFlatPolarSinusoidalJsDefault.default));
parcelHelpers.export(exports, "geoMtFlatPolarSinusoidalRaw", ()=>(0, _mtFlatPolarSinusoidalJs.mtFlatPolarSinusoidalRaw));
parcelHelpers.export(exports, "geoNaturalEarth2", ()=>(0, _naturalEarth2JsDefault.default));
parcelHelpers.export(exports, "geoNaturalEarth2Raw", ()=>(0, _naturalEarth2Js.naturalEarth2Raw));
parcelHelpers.export(exports, "geoNellHammer", ()=>(0, _nellHammerJsDefault.default));
parcelHelpers.export(exports, "geoNellHammerRaw", ()=>(0, _nellHammerJs.nellHammerRaw));
parcelHelpers.export(exports, "geoInterruptedQuarticAuthalic", ()=>(0, _quarticAuthalicJsDefault.default));
parcelHelpers.export(exports, "geoNicolosi", ()=>(0, _nicolosiJsDefault.default));
parcelHelpers.export(exports, "geoNicolosiRaw", ()=>(0, _nicolosiJs.nicolosiRaw));
parcelHelpers.export(exports, "geoPatterson", ()=>(0, _pattersonJsDefault.default));
parcelHelpers.export(exports, "geoPattersonRaw", ()=>(0, _pattersonJs.pattersonRaw));
parcelHelpers.export(exports, "geoPolyconic", ()=>(0, _polyconicJsDefault.default));
parcelHelpers.export(exports, "geoPolyconicRaw", ()=>(0, _polyconicJs.polyconicRaw));
parcelHelpers.export(exports, "geoPolyhedral", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "geoPolyhedralButterfly", ()=>(0, _butterflyJsDefault.default));
parcelHelpers.export(exports, "geoPolyhedralCollignon", ()=>(0, _collignonJsDefault1.default));
parcelHelpers.export(exports, "geoPolyhedralWaterman", ()=>(0, _watermanJsDefault.default));
parcelHelpers.export(exports, "geoProject", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "geoGringortenQuincuncial", ()=>(0, _gringortenJsDefault1.default));
parcelHelpers.export(exports, "geoPeirceQuincuncial", ()=>(0, _peirceJsDefault.default));
parcelHelpers.export(exports, "geoQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "geoQuincuncial", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "geoRectangularPolyconic", ()=>(0, _rectangularPolyconicJsDefault.default));
parcelHelpers.export(exports, "geoRectangularPolyconicRaw", ()=>(0, _rectangularPolyconicJs.rectangularPolyconicRaw));
parcelHelpers.export(exports, "geoRobinson", ()=>(0, _robinsonJsDefault.default));
parcelHelpers.export(exports, "geoRobinsonRaw", ()=>(0, _robinsonJs.robinsonRaw));
parcelHelpers.export(exports, "geoSatellite", ()=>(0, _satelliteJsDefault.default));
parcelHelpers.export(exports, "geoSatelliteRaw", ()=>(0, _satelliteJs.satelliteRaw));
parcelHelpers.export(exports, "geoSinuMollweide", ()=>(0, _sinuMollweideJsDefault1.default));
parcelHelpers.export(exports, "geoSinuMollweideRaw", ()=>(0, _sinuMollweideJs1.sinuMollweideRaw));
parcelHelpers.export(exports, "geoSinusoidal", ()=>(0, _sinusoidalJsDefault1.default));
parcelHelpers.export(exports, "geoSinusoidalRaw", ()=>(0, _sinusoidalJs1.sinusoidalRaw));
parcelHelpers.export(exports, "geoStitch", ()=>(0, _stitchJsDefault.default));
parcelHelpers.export(exports, "geoTimes", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "geoTimesRaw", ()=>(0, _timesJs.timesRaw));
parcelHelpers.export(exports, "geoTwoPointAzimuthal", ()=>(0, _twoPointAzimuthalJsDefault.default));
parcelHelpers.export(exports, "geoTwoPointAzimuthalRaw", ()=>(0, _twoPointAzimuthalJs.twoPointAzimuthalRaw));
parcelHelpers.export(exports, "geoTwoPointAzimuthalUsa", ()=>(0, _twoPointAzimuthalJs.twoPointAzimuthalUsa));
parcelHelpers.export(exports, "geoTwoPointEquidistant", ()=>(0, _twoPointEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoTwoPointEquidistantRaw", ()=>(0, _twoPointEquidistantJs.twoPointEquidistantRaw));
parcelHelpers.export(exports, "geoTwoPointEquidistantUsa", ()=>(0, _twoPointEquidistantJs.twoPointEquidistantUsa));
parcelHelpers.export(exports, "geoVanDerGrinten", ()=>(0, _vanDerGrintenJsDefault.default));
parcelHelpers.export(exports, "geoVanDerGrintenRaw", ()=>(0, _vanDerGrintenJs.vanDerGrintenRaw));
parcelHelpers.export(exports, "geoVanDerGrinten2", ()=>(0, _vanDerGrinten2JsDefault.default));
parcelHelpers.export(exports, "geoVanDerGrinten2Raw", ()=>(0, _vanDerGrinten2Js.vanDerGrinten2Raw));
parcelHelpers.export(exports, "geoVanDerGrinten3", ()=>(0, _vanDerGrinten3JsDefault.default));
parcelHelpers.export(exports, "geoVanDerGrinten3Raw", ()=>(0, _vanDerGrinten3Js.vanDerGrinten3Raw));
parcelHelpers.export(exports, "geoVanDerGrinten4", ()=>(0, _vanDerGrinten4JsDefault.default));
parcelHelpers.export(exports, "geoVanDerGrinten4Raw", ()=>(0, _vanDerGrinten4Js.vanDerGrinten4Raw));
parcelHelpers.export(exports, "geoWagner", ()=>(0, _wagnerJsDefault.default));
parcelHelpers.export(exports, "geoWagner7", ()=>(0, _wagnerJs.wagner7));
parcelHelpers.export(exports, "geoWagnerRaw", ()=>(0, _wagnerJs.wagnerRaw));
parcelHelpers.export(exports, "geoWagner4", ()=>(0, _wagner4JsDefault.default));
parcelHelpers.export(exports, "geoWagner4Raw", ()=>(0, _wagner4Js.wagner4Raw));
parcelHelpers.export(exports, "geoWagner6", ()=>(0, _wagner6JsDefault.default));
parcelHelpers.export(exports, "geoWagner6Raw", ()=>(0, _wagner6Js.wagner6Raw));
parcelHelpers.export(exports, "geoWiechel", ()=>(0, _wiechelJsDefault.default));
parcelHelpers.export(exports, "geoWiechelRaw", ()=>(0, _wiechelJs.wiechelRaw));
parcelHelpers.export(exports, "geoWinkel3", ()=>(0, _winkel3JsDefault.default));
parcelHelpers.export(exports, "geoWinkel3Raw", ()=>(0, _winkel3Js.winkel3Raw));
var _airyJs = require("./airy.js");
var _airyJsDefault = parcelHelpers.interopDefault(_airyJs);
var _aitoffJs = require("./aitoff.js");
var _aitoffJsDefault = parcelHelpers.interopDefault(_aitoffJs);
var _armadilloJs = require("./armadillo.js");
var _armadilloJsDefault = parcelHelpers.interopDefault(_armadilloJs);
var _augustJs = require("./august.js");
var _augustJsDefault = parcelHelpers.interopDefault(_augustJs);
var _bakerJs = require("./baker.js");
var _bakerJsDefault = parcelHelpers.interopDefault(_bakerJs);
var _berghausJs = require("./berghaus.js");
var _berghausJsDefault = parcelHelpers.interopDefault(_berghausJs);
var _bertinJs = require("./bertin.js");
var _bertinJsDefault = parcelHelpers.interopDefault(_bertinJs);
var _boggsJs = require("./boggs.js");
var _boggsJsDefault = parcelHelpers.interopDefault(_boggsJs);
var _bonneJs = require("./bonne.js");
var _bonneJsDefault = parcelHelpers.interopDefault(_bonneJs);
var _bottomleyJs = require("./bottomley.js");
var _bottomleyJsDefault = parcelHelpers.interopDefault(_bottomleyJs);
var _bromleyJs = require("./bromley.js");
var _bromleyJsDefault = parcelHelpers.interopDefault(_bromleyJs);
var _chamberlinJs = require("./chamberlin.js");
var _chamberlinJsDefault = parcelHelpers.interopDefault(_chamberlinJs);
var _collignonJs = require("./collignon.js");
var _collignonJsDefault = parcelHelpers.interopDefault(_collignonJs);
var _craigJs = require("./craig.js");
var _craigJsDefault = parcelHelpers.interopDefault(_craigJs);
var _crasterJs = require("./craster.js");
var _crasterJsDefault = parcelHelpers.interopDefault(_crasterJs);
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
var _cylindricalEqualAreaJsDefault = parcelHelpers.interopDefault(_cylindricalEqualAreaJs);
var _cylindricalStereographicJs = require("./cylindricalStereographic.js");
var _cylindricalStereographicJsDefault = parcelHelpers.interopDefault(_cylindricalStereographicJs);
var _eckert1Js = require("./eckert1.js");
var _eckert1JsDefault = parcelHelpers.interopDefault(_eckert1Js);
var _eckert2Js = require("./eckert2.js");
var _eckert2JsDefault = parcelHelpers.interopDefault(_eckert2Js);
var _eckert3Js = require("./eckert3.js");
var _eckert3JsDefault = parcelHelpers.interopDefault(_eckert3Js);
var _eckert4Js = require("./eckert4.js");
var _eckert4JsDefault = parcelHelpers.interopDefault(_eckert4Js);
var _eckert5Js = require("./eckert5.js");
var _eckert5JsDefault = parcelHelpers.interopDefault(_eckert5Js);
var _eckert6Js = require("./eckert6.js");
var _eckert6JsDefault = parcelHelpers.interopDefault(_eckert6Js);
var _eisenlohrJs = require("./eisenlohr.js");
var _eisenlohrJsDefault = parcelHelpers.interopDefault(_eisenlohrJs);
var _faheyJs = require("./fahey.js");
var _faheyJsDefault = parcelHelpers.interopDefault(_faheyJs);
var _foucautJs = require("./foucaut.js");
var _foucautJsDefault = parcelHelpers.interopDefault(_foucautJs);
var _foucautSinusoidalJs = require("./foucautSinusoidal.js");
var _foucautSinusoidalJsDefault = parcelHelpers.interopDefault(_foucautSinusoidalJs);
var _gilbertJs = require("./gilbert.js");
var _gilbertJsDefault = parcelHelpers.interopDefault(_gilbertJs);
var _gingeryJs = require("./gingery.js");
var _gingeryJsDefault = parcelHelpers.interopDefault(_gingeryJs);
var _ginzburg4Js = require("./ginzburg4.js");
var _ginzburg4JsDefault = parcelHelpers.interopDefault(_ginzburg4Js);
var _ginzburg5Js = require("./ginzburg5.js");
var _ginzburg5JsDefault = parcelHelpers.interopDefault(_ginzburg5Js);
var _ginzburg6Js = require("./ginzburg6.js");
var _ginzburg6JsDefault = parcelHelpers.interopDefault(_ginzburg6Js);
var _ginzburg8Js = require("./ginzburg8.js");
var _ginzburg8JsDefault = parcelHelpers.interopDefault(_ginzburg8Js);
var _ginzburg9Js = require("./ginzburg9.js");
var _ginzburg9JsDefault = parcelHelpers.interopDefault(_ginzburg9Js);
var _gringortenJs = require("./gringorten.js");
var _gringortenJsDefault = parcelHelpers.interopDefault(_gringortenJs);
var _guyouJs = require("./guyou.js");
var _guyouJsDefault = parcelHelpers.interopDefault(_guyouJs);
var _hammerJs = require("./hammer.js");
var _hammerJsDefault = parcelHelpers.interopDefault(_hammerJs);
var _hammerRetroazimuthalJs = require("./hammerRetroazimuthal.js");
var _hammerRetroazimuthalJsDefault = parcelHelpers.interopDefault(_hammerRetroazimuthalJs);
var _healpixJs = require("./healpix.js");
var _healpixJsDefault = parcelHelpers.interopDefault(_healpixJs);
var _hillJs = require("./hill.js");
var _hillJsDefault = parcelHelpers.interopDefault(_hillJs);
var _homolosineJs = require("./homolosine.js");
var _homolosineJsDefault = parcelHelpers.interopDefault(_homolosineJs);
var _hufnagelJs = require("./hufnagel.js");
var _hufnagelJsDefault = parcelHelpers.interopDefault(_hufnagelJs);
var _hyperellipticalJs = require("./hyperelliptical.js");
var _hyperellipticalJsDefault = parcelHelpers.interopDefault(_hyperellipticalJs);
var _indexJs = require("./interrupted/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _boggsJs1 = require("./interrupted/boggs.js");
var _boggsJsDefault1 = parcelHelpers.interopDefault(_boggsJs1);
var _homolosineJs1 = require("./interrupted/homolosine.js");
var _homolosineJsDefault1 = parcelHelpers.interopDefault(_homolosineJs1);
var _mollweideJs = require("./interrupted/mollweide.js");
var _mollweideJsDefault = parcelHelpers.interopDefault(_mollweideJs);
var _mollweideHemispheresJs = require("./interrupted/mollweideHemispheres.js");
var _mollweideHemispheresJsDefault = parcelHelpers.interopDefault(_mollweideHemispheresJs);
var _sinuMollweideJs = require("./interrupted/sinuMollweide.js");
var _sinuMollweideJsDefault = parcelHelpers.interopDefault(_sinuMollweideJs);
var _sinusoidalJs = require("./interrupted/sinusoidal.js");
var _sinusoidalJsDefault = parcelHelpers.interopDefault(_sinusoidalJs);
var _kavrayskiy7Js = require("./kavrayskiy7.js");
var _kavrayskiy7JsDefault = parcelHelpers.interopDefault(_kavrayskiy7Js);
var _lagrangeJs = require("./lagrange.js");
var _lagrangeJsDefault = parcelHelpers.interopDefault(_lagrangeJs);
var _larriveeJs = require("./larrivee.js");
var _larriveeJsDefault = parcelHelpers.interopDefault(_larriveeJs);
var _laskowskiJs = require("./laskowski.js");
var _laskowskiJsDefault = parcelHelpers.interopDefault(_laskowskiJs);
var _littrowJs = require("./littrow.js");
var _littrowJsDefault = parcelHelpers.interopDefault(_littrowJs);
var _loximuthalJs = require("./loximuthal.js");
var _loximuthalJsDefault = parcelHelpers.interopDefault(_loximuthalJs);
var _millerJs = require("./miller.js");
var _millerJsDefault = parcelHelpers.interopDefault(_millerJs);
var _modifiedStereographicJs = require("./modifiedStereographic.js");
var _modifiedStereographicJsDefault = parcelHelpers.interopDefault(_modifiedStereographicJs);
var _mollweideJs1 = require("./mollweide.js");
var _mollweideJsDefault1 = parcelHelpers.interopDefault(_mollweideJs1);
var _mtFlatPolarParabolicJs = require("./mtFlatPolarParabolic.js");
var _mtFlatPolarParabolicJsDefault = parcelHelpers.interopDefault(_mtFlatPolarParabolicJs);
var _mtFlatPolarQuarticJs = require("./mtFlatPolarQuartic.js");
var _mtFlatPolarQuarticJsDefault = parcelHelpers.interopDefault(_mtFlatPolarQuarticJs);
var _mtFlatPolarSinusoidalJs = require("./mtFlatPolarSinusoidal.js");
var _mtFlatPolarSinusoidalJsDefault = parcelHelpers.interopDefault(_mtFlatPolarSinusoidalJs);
var _naturalEarth2Js = require("./naturalEarth2.js");
var _naturalEarth2JsDefault = parcelHelpers.interopDefault(_naturalEarth2Js);
var _nellHammerJs = require("./nellHammer.js");
var _nellHammerJsDefault = parcelHelpers.interopDefault(_nellHammerJs);
var _quarticAuthalicJs = require("./interrupted/quarticAuthalic.js");
var _quarticAuthalicJsDefault = parcelHelpers.interopDefault(_quarticAuthalicJs);
var _nicolosiJs = require("./nicolosi.js");
var _nicolosiJsDefault = parcelHelpers.interopDefault(_nicolosiJs);
var _pattersonJs = require("./patterson.js");
var _pattersonJsDefault = parcelHelpers.interopDefault(_pattersonJs);
var _polyconicJs = require("./polyconic.js");
var _polyconicJsDefault = parcelHelpers.interopDefault(_polyconicJs);
var _indexJs1 = require("./polyhedral/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _butterflyJs = require("./polyhedral/butterfly.js");
var _butterflyJsDefault = parcelHelpers.interopDefault(_butterflyJs);
var _collignonJs1 = require("./polyhedral/collignon.js");
var _collignonJsDefault1 = parcelHelpers.interopDefault(_collignonJs1);
var _watermanJs = require("./polyhedral/waterman.js");
var _watermanJsDefault = parcelHelpers.interopDefault(_watermanJs);
var _indexJs2 = require("./project/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _gringortenJs1 = require("./quincuncial/gringorten.js");
var _gringortenJsDefault1 = parcelHelpers.interopDefault(_gringortenJs1);
var _peirceJs = require("./quincuncial/peirce.js");
var _peirceJsDefault = parcelHelpers.interopDefault(_peirceJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _indexJs3 = require("./quincuncial/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _rectangularPolyconicJs = require("./rectangularPolyconic.js");
var _rectangularPolyconicJsDefault = parcelHelpers.interopDefault(_rectangularPolyconicJs);
var _robinsonJs = require("./robinson.js");
var _robinsonJsDefault = parcelHelpers.interopDefault(_robinsonJs);
var _satelliteJs = require("./satellite.js");
var _satelliteJsDefault = parcelHelpers.interopDefault(_satelliteJs);
var _sinuMollweideJs1 = require("./sinuMollweide.js");
var _sinuMollweideJsDefault1 = parcelHelpers.interopDefault(_sinuMollweideJs1);
var _sinusoidalJs1 = require("./sinusoidal.js");
var _sinusoidalJsDefault1 = parcelHelpers.interopDefault(_sinusoidalJs1);
var _stitchJs = require("./stitch.js");
var _stitchJsDefault = parcelHelpers.interopDefault(_stitchJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _twoPointAzimuthalJs = require("./twoPointAzimuthal.js");
var _twoPointAzimuthalJsDefault = parcelHelpers.interopDefault(_twoPointAzimuthalJs);
var _twoPointEquidistantJs = require("./twoPointEquidistant.js");
var _twoPointEquidistantJsDefault = parcelHelpers.interopDefault(_twoPointEquidistantJs);
var _vanDerGrintenJs = require("./vanDerGrinten.js");
var _vanDerGrintenJsDefault = parcelHelpers.interopDefault(_vanDerGrintenJs);
var _vanDerGrinten2Js = require("./vanDerGrinten2.js");
var _vanDerGrinten2JsDefault = parcelHelpers.interopDefault(_vanDerGrinten2Js);
var _vanDerGrinten3Js = require("./vanDerGrinten3.js");
var _vanDerGrinten3JsDefault = parcelHelpers.interopDefault(_vanDerGrinten3Js);
var _vanDerGrinten4Js = require("./vanDerGrinten4.js");
var _vanDerGrinten4JsDefault = parcelHelpers.interopDefault(_vanDerGrinten4Js);
var _wagnerJs = require("./wagner.js");
var _wagnerJsDefault = parcelHelpers.interopDefault(_wagnerJs);
var _wagner4Js = require("./wagner4.js");
var _wagner4JsDefault = parcelHelpers.interopDefault(_wagner4Js);
var _wagner6Js = require("./wagner6.js");
var _wagner6JsDefault = parcelHelpers.interopDefault(_wagner6Js);
var _wiechelJs = require("./wiechel.js");
var _wiechelJsDefault = parcelHelpers.interopDefault(_wiechelJs);
var _winkel3Js = require("./winkel3.js");
var _winkel3JsDefault = parcelHelpers.interopDefault(_winkel3Js);

},{"./airy.js":"b3Bc8","./aitoff.js":"j6uie","./armadillo.js":"4cWJU","./august.js":"boWOH","./baker.js":"4UnGD","./berghaus.js":"9XhOz","./bertin.js":"i72QO","./boggs.js":"87pEy","./bonne.js":"lEBzg","./bottomley.js":"1saCE","./bromley.js":"2Gdsy","./chamberlin.js":"7XCet","./collignon.js":"94537","./craig.js":"joY7i","./craster.js":"c8Grz","./cylindricalEqualArea.js":"d3E2z","./cylindricalStereographic.js":"dUHf0","./eckert1.js":"jDASo","./eckert2.js":"b8uHZ","./eckert3.js":"aWJtZ","./eckert4.js":"9XUWx","./eckert5.js":"iaeY3","./eckert6.js":"kmePe","./eisenlohr.js":"7Yqsl","./fahey.js":"a2adt","./foucaut.js":"4xWIz","./foucautSinusoidal.js":"ggZIz","./gilbert.js":"i3g8X","./gingery.js":"jZq2N","./ginzburg4.js":"3t2vb","./ginzburg5.js":"khpCN","./ginzburg6.js":"8TYKL","./ginzburg8.js":"2K2bJ","./ginzburg9.js":"ePso8","./gringorten.js":"58Ivv","./guyou.js":"bxyzm","./hammer.js":"esU8A","./hammerRetroazimuthal.js":"bnB8U","./healpix.js":"koVca","./hill.js":"gFFQv","./homolosine.js":"gQeQn","./hufnagel.js":"c5jMT","./hyperelliptical.js":"dHCqJ","./interrupted/index.js":"a3s0h","./interrupted/boggs.js":"809cn","./interrupted/homolosine.js":"cAU8X","./interrupted/mollweide.js":"bfFEj","./interrupted/mollweideHemispheres.js":"89H7S","./interrupted/sinuMollweide.js":"3ZUnK","./interrupted/sinusoidal.js":"e7mvK","./kavrayskiy7.js":"33iOA","./lagrange.js":"1kZI3","./larrivee.js":"1IEHa","./laskowski.js":"aC68x","./littrow.js":"3M31o","./loximuthal.js":"jyDjs","./miller.js":"7I16f","./modifiedStereographic.js":"a2w74","./mollweide.js":"4WAID","./mtFlatPolarParabolic.js":"6Dect","./mtFlatPolarQuartic.js":"3cJRe","./mtFlatPolarSinusoidal.js":"jozQb","./naturalEarth2.js":"i1U7p","./nellHammer.js":"lgB94","./interrupted/quarticAuthalic.js":"cdujQ","./nicolosi.js":"S8F17","./patterson.js":"jidHn","./polyconic.js":"9RS1p","./polyhedral/index.js":"9trgU","./polyhedral/butterfly.js":"aSeq3","./polyhedral/collignon.js":"4PkJg","./polyhedral/waterman.js":"9DsWE","./project/index.js":"2bMtR","./quincuncial/gringorten.js":"2exzo","./quincuncial/peirce.js":"c1wCa","./quantize.js":"4lOlx","./quincuncial/index.js":"42qzq","./rectangularPolyconic.js":"2ninv","./robinson.js":"d5UE9","./satellite.js":"8ycxT","./sinuMollweide.js":"9rTuc","./sinusoidal.js":"aqIah","./stitch.js":"ipdQr","./times.js":"2zMwo","./twoPointAzimuthal.js":"7KKLU","./twoPointEquidistant.js":"gxdCy","./vanDerGrinten.js":"13oJ2","./vanDerGrinten2.js":"k6K5R","./vanDerGrinten3.js":"j5q57","./vanDerGrinten4.js":"izzR1","./wagner.js":"fsEzE","./wagner4.js":"jh5E6","./wagner6.js":"aJmk0","./wiechel.js":"b8gAD","./winkel3.js":"lXBM1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3Bc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "airyRaw", ()=>airyRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var beta = (0, _mathJs.halfPi), m = (0, _d3Geo.geoProjectionMutator)(airyRaw), p = m(beta);
        p.radius = function(_) {
            return arguments.length ? m(beta = _ * (0, _mathJs.radians)) : beta * (0, _mathJs.degrees);
        };
        return p.scale(179.976).clipAngle(147);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function airyRaw(beta) {
    var tanBeta_2 = (0, _mathJs.tan)(beta / 2), b = 2 * (0, _mathJs.log)((0, _mathJs.cos)(beta / 2)) / (tanBeta_2 * tanBeta_2);
    function forward(x, y) {
        var cosx = (0, _mathJs.cos)(x), cosy = (0, _mathJs.cos)(y), siny = (0, _mathJs.sin)(y), cosz = cosy * cosx, k = -((1 - cosz ? (0, _mathJs.log)((1 + cosz) / 2) / (1 - cosz) : -0.5) + b / (1 + cosz));
        return [
            k * cosy * (0, _mathJs.sin)(x),
            k * siny
        ];
    }
    forward.invert = function(x, y) {
        var r = (0, _mathJs.sqrt)(x * x + y * y), z = -beta / 2, i = 50, delta;
        if (!r) return [
            0,
            0
        ];
        do {
            var z_2 = z / 2, cosz_2 = (0, _mathJs.cos)(z_2), sinz_2 = (0, _mathJs.sin)(z_2), tanz_2 = sinz_2 / cosz_2, lnsecz_2 = -(0, _mathJs.log)((0, _mathJs.abs)(cosz_2));
            z -= delta = (2 / tanz_2 * lnsecz_2 - b * tanz_2 - r) / (-lnsecz_2 / (sinz_2 * sinz_2) + 1 - b / (2 * cosz_2 * cosz_2)) * (cosz_2 < 0 ? 0.7 : 1);
        }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
        var sinz = (0, _mathJs.sin)(z);
        return [
            (0, _mathJs.atan2)(x * sinz, r * (0, _mathJs.cos)(z)),
            (0, _mathJs.asin)(y * sinz / r)
        ];
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g023h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "sqrt1_2", ()=>sqrt1_2);
parcelHelpers.export(exports, "sqrt2", ()=>sqrt2);
parcelHelpers.export(exports, "sqrtPi", ()=>sqrtPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "sinci", ()=>sinci);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tanh", ()=>tanh);
parcelHelpers.export(exports, "sinh", ()=>sinh);
parcelHelpers.export(exports, "cosh", ()=>cosh);
parcelHelpers.export(exports, "arsinh", ()=>arsinh);
parcelHelpers.export(exports, "arcosh", ()=>arcosh);
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var ceil = Math.ceil;
var cos = Math.cos;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var max = Math.max;
var min = Math.min;
var pow = Math.pow;
var round = Math.round;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sin = Math.sin;
var tan = Math.tan;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var sqrt1_2 = Math.SQRT1_2;
var sqrt2 = sqrt(2);
var sqrtPi = sqrt(pi);
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
function sinci(x) {
    return x ? x / Math.sin(x) : 1;
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function sqrt(x) {
    return x > 0 ? Math.sqrt(x) : 0;
}
function tanh(x) {
    x = exp(2 * x);
    return (x - 1) / (x + 1);
}
function sinh(x) {
    return (exp(x) - exp(-x)) / 2;
}
function cosh(x) {
    return (exp(x) + exp(-x)) / 2;
}
function arsinh(x) {
    return log(x + sqrt(x * x + 1));
}
function arcosh(x) {
    return log(x + sqrt(x * x - 1));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j6uie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aitoffRaw", ()=>aitoffRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(aitoffRaw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function aitoffRaw(x, y) {
    var cosy = (0, _mathJs.cos)(y), sincia = (0, _mathJs.sinci)((0, _mathJs.acos)(cosy * (0, _mathJs.cos)(x /= 2)));
    return [
        2 * cosy * (0, _mathJs.sin)(x) * sincia,
        (0, _mathJs.sin)(y) * sincia
    ];
}
// Abort if [x, y] is not within an ellipse centered at [0, 0] with
// semi-major axis pi and semi-minor axis pi/2.
aitoffRaw.invert = function(x, y) {
    if (x * x + 4 * y * y > (0, _mathJs.pi) * (0, _mathJs.pi) + (0, _mathJs.epsilon)) return;
    var x1 = x, y1 = y, i = 25;
    do {
        var sinx = (0, _mathJs.sin)(x1), sinx_2 = (0, _mathJs.sin)(x1 / 2), cosx_2 = (0, _mathJs.cos)(x1 / 2), siny = (0, _mathJs.sin)(y1), cosy = (0, _mathJs.cos)(y1), sin_2y = (0, _mathJs.sin)(2 * y1), sin2y = siny * siny, cos2y = cosy * cosy, sin2x_2 = sinx_2 * sinx_2, c = 1 - cos2y * cosx_2 * cosx_2, e = c ? (0, _mathJs.acos)(cosy * cosx_2) * (0, _mathJs.sqrt)(f = 1 / c) : f = 0, f, fx = 2 * e * cosy * sinx_2 - x, fy = e * siny - y, dxdx = f * (cos2y * sin2x_2 + e * cosy * cosx_2 * sin2y), dxdy = f * (0.5 * sinx * sin_2y - e * 2 * siny * sinx_2), dydx = f * 0.25 * (sin_2y * sinx_2 - e * siny * cos2y * sinx), dydy = f * (sin2y * cosx_2 + e * sin2x_2 * cosy), z = dxdy * dydx - dydy * dxdx;
        if (!z) break;
        var dx = (fy * dxdy - fx * dydy) / z, dy = (fx * dydx - fy * dxdx) / z;
        x1 -= dx, y1 -= dy;
    }while (((0, _mathJs.abs)(dx) > (0, _mathJs.epsilon) || (0, _mathJs.abs)(dy) > (0, _mathJs.epsilon)) && --i > 0);
    return [
        x1,
        y1
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4cWJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "armadilloRaw", ()=>armadilloRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var phi0 = 20 * (0, _mathJs.radians), sPhi0 = phi0 >= 0 ? 1 : -1, tanPhi0 = (0, _mathJs.tan)(sPhi0 * phi0), m = (0, _d3Geo.geoProjectionMutator)(armadilloRaw), p = m(phi0), stream_ = p.stream;
        p.parallel = function(_) {
            if (!arguments.length) return phi0 * (0, _mathJs.degrees);
            tanPhi0 = (0, _mathJs.tan)((sPhi0 = (phi0 = _ * (0, _mathJs.radians)) >= 0 ? 1 : -1) * phi0);
            return m(phi0);
        };
        p.stream = function(stream) {
            var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([
                0,
                0
            ]), stream_(stream)), precision = p.precision();
            p.rotate(rotate);
            rotateStream.sphere = function() {
                sphereStream.polygonStart(), sphereStream.lineStart();
                for(var lambda = sPhi0 * -180; sPhi0 * lambda < 180; lambda += sPhi0 * 90)sphereStream.point(lambda, sPhi0 * 90);
                if (phi0) while(sPhi0 * (lambda -= 3 * sPhi0 * precision) >= -180)sphereStream.point(lambda, sPhi0 * -(0, _mathJs.atan2)((0, _mathJs.cos)(lambda * (0, _mathJs.radians) / 2), tanPhi0) * (0, _mathJs.degrees));
                sphereStream.lineEnd(), sphereStream.polygonEnd();
            };
            return rotateStream;
        };
        return p.scale(218.695).center([
            0,
            28.0974
        ]);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function armadilloRaw(phi0) {
    var sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0), sPhi0 = phi0 >= 0 ? 1 : -1, tanPhi0 = (0, _mathJs.tan)(sPhi0 * phi0), k = (1 + sinPhi0 - cosPhi0) / 2;
    function forward(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), cosLambda = (0, _mathJs.cos)(lambda /= 2);
        return [
            (1 + cosPhi) * (0, _mathJs.sin)(lambda),
            (sPhi0 * phi > -(0, _mathJs.atan2)(cosLambda, tanPhi0) - 1e-3 ? 0 : -sPhi0 * 10) + k + (0, _mathJs.sin)(phi) * cosPhi0 - (1 + cosPhi) * sinPhi0 * cosLambda // TODO D3 core should allow null or [NaN, NaN] to be returned.
        ];
    }
    forward.invert = function(x, y) {
        var lambda = 0, phi = 0, i = 50;
        do {
            var cosLambda = (0, _mathJs.cos)(lambda), sinLambda = (0, _mathJs.sin)(lambda), cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), A = 1 + cosPhi, fx = A * sinLambda - x, fy = k + sinPhi * cosPhi0 - A * sinPhi0 * cosLambda - y, dxdLambda = A * cosLambda / 2, dxdPhi = -sinLambda * sinPhi, dydLambda = sinPhi0 * A * sinLambda / 2, dydPhi = cosPhi0 * cosPhi + sinPhi0 * cosLambda * sinPhi, denominator = dxdPhi * dydLambda - dydPhi * dxdLambda, dLambda = (fy * dxdPhi - fx * dydPhi) / denominator / 2, dPhi = (fx * dydLambda - fy * dxdLambda) / denominator;
            if ((0, _mathJs.abs)(dPhi) > 2) dPhi /= 2;
            lambda -= dLambda, phi -= dPhi;
        }while (((0, _mathJs.abs)(dLambda) > (0, _mathJs.epsilon) || (0, _mathJs.abs)(dPhi) > (0, _mathJs.epsilon)) && --i > 0);
        return sPhi0 * phi > -(0, _mathJs.atan2)((0, _mathJs.cos)(lambda), tanPhi0) - 1e-3 ? [
            lambda * 2,
            phi
        ] : null;
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"boWOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "augustRaw", ()=>augustRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(augustRaw).scale(66.1603);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function augustRaw(lambda, phi) {
    var tanPhi = (0, _mathJs.tan)(phi / 2), k = (0, _mathJs.sqrt)(1 - tanPhi * tanPhi), c = 1 + k * (0, _mathJs.cos)(lambda /= 2), x = (0, _mathJs.sin)(lambda) * k / c, y = tanPhi / c, x2 = x * x, y2 = y * y;
    return [
        4 / 3 * x * (3 + x2 - 3 * y2),
        4 / 3 * y * (3 + 3 * x2 - y2)
    ];
}
augustRaw.invert = function(x, y) {
    x *= 3 / 8, y *= 3 / 8;
    if (!x && (0, _mathJs.abs)(y) > 1) return null;
    var x2 = x * x, y2 = y * y, s = 1 + x2 + y2, sin3Eta = (0, _mathJs.sqrt)((s - (0, _mathJs.sqrt)(s * s - 4 * y * y)) / 2), eta = (0, _mathJs.asin)(sin3Eta) / 3, xi = sin3Eta ? (0, _mathJs.arcosh)((0, _mathJs.abs)(y / sin3Eta)) / 3 : (0, _mathJs.arsinh)((0, _mathJs.abs)(x)) / 3, cosEta = (0, _mathJs.cos)(eta), coshXi = (0, _mathJs.cosh)(xi), d = coshXi * coshXi - cosEta * cosEta;
    return [
        (0, _mathJs.sign)(x) * 2 * (0, _mathJs.atan2)((0, _mathJs.sinh)(xi) * cosEta, 0.25 - d),
        (0, _mathJs.sign)(y) * 2 * (0, _mathJs.atan2)(coshXi * (0, _mathJs.sin)(eta), 0.25 + d)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4UnGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bakerRaw", ()=>bakerRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(bakerRaw).scale(112.314);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var sqrt8 = (0, _mathJs.sqrt)(8), phi0 = (0, _mathJs.log)(1 + (0, _mathJs.sqrt2));
function bakerRaw(lambda, phi) {
    var phi0 = (0, _mathJs.abs)(phi);
    return phi0 < (0, _mathJs.quarterPi) ? [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)((0, _mathJs.quarterPi) + phi / 2))
    ] : [
        lambda * (0, _mathJs.cos)(phi0) * (2 * (0, _mathJs.sqrt2) - 1 / (0, _mathJs.sin)(phi0)),
        (0, _mathJs.sign)(phi) * (2 * (0, _mathJs.sqrt2) * (phi0 - (0, _mathJs.quarterPi)) - (0, _mathJs.log)((0, _mathJs.tan)(phi0 / 2)))
    ];
}
bakerRaw.invert = function(x, y) {
    if ((y0 = (0, _mathJs.abs)(y)) < phi0) return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
    var phi = (0, _mathJs.quarterPi), i = 25, delta, y0;
    do {
        var cosPhi_2 = (0, _mathJs.cos)(phi / 2), tanPhi_2 = (0, _mathJs.tan)(phi / 2);
        phi -= delta = (sqrt8 * (phi - (0, _mathJs.quarterPi)) - (0, _mathJs.log)(tanPhi_2) - y0) / (sqrt8 - cosPhi_2 * cosPhi_2 / (2 * tanPhi_2));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon2) && --i > 0);
    return [
        x / ((0, _mathJs.cos)(phi) * (sqrt8 - 1 / (0, _mathJs.sin)(phi))),
        (0, _mathJs.sign)(y) * phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9XhOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "berghausRaw", ()=>berghausRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var lobes = 5, m = (0, _d3Geo.geoProjectionMutator)(berghausRaw), p = m(lobes), projectionStream = p.stream, epsilon = 1e-2, cr = -(0, _mathJs.cos)(epsilon * (0, _mathJs.radians)), sr = (0, _mathJs.sin)(epsilon * (0, _mathJs.radians));
        p.lobes = function(_) {
            return arguments.length ? m(lobes = +_) : lobes;
        };
        p.stream = function(stream) {
            var rotate = p.rotate(), rotateStream = projectionStream(stream), sphereStream = (p.rotate([
                0,
                0
            ]), projectionStream(stream));
            p.rotate(rotate);
            rotateStream.sphere = function() {
                sphereStream.polygonStart(), sphereStream.lineStart();
                for(var i = 0, delta = 360 / lobes, delta0 = 2 * (0, _mathJs.pi) / lobes, phi = 90 - 180 / lobes, phi0 = (0, _mathJs.halfPi); i < lobes; ++i, phi -= delta, phi0 -= delta0){
                    sphereStream.point((0, _mathJs.atan2)(sr * (0, _mathJs.cos)(phi0), cr) * (0, _mathJs.degrees), (0, _mathJs.asin)(sr * (0, _mathJs.sin)(phi0)) * (0, _mathJs.degrees));
                    if (phi < -90) {
                        sphereStream.point(-90, -180 - phi - epsilon);
                        sphereStream.point(-90, -180 - phi + epsilon);
                    } else {
                        sphereStream.point(90, phi + epsilon);
                        sphereStream.point(90, phi - epsilon);
                    }
                }
                sphereStream.lineEnd(), sphereStream.polygonEnd();
            };
            return rotateStream;
        };
        return p.scale(87.8076).center([
            0,
            17.1875
        ]).clipAngle(179.999);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function berghausRaw(lobes) {
    var k = 2 * (0, _mathJs.pi) / lobes;
    function forward(lambda, phi) {
        var p = (0, _d3Geo.geoAzimuthalEquidistantRaw)(lambda, phi);
        if ((0, _mathJs.abs)(lambda) > (0, _mathJs.halfPi)) {
            var theta = (0, _mathJs.atan2)(p[1], p[0]), r = (0, _mathJs.sqrt)(p[0] * p[0] + p[1] * p[1]), theta0 = k * (0, _mathJs.round)((theta - (0, _mathJs.halfPi)) / k) + (0, _mathJs.halfPi), alpha = (0, _mathJs.atan2)((0, _mathJs.sin)(theta -= theta0), 2 - (0, _mathJs.cos)(theta)); // angle relative to lobe end
            theta = theta0 + (0, _mathJs.asin)((0, _mathJs.pi) / r * (0, _mathJs.sin)(alpha)) - alpha;
            p[0] = r * (0, _mathJs.cos)(theta);
            p[1] = r * (0, _mathJs.sin)(theta);
        }
        return p;
    }
    forward.invert = function(x, y) {
        var r = (0, _mathJs.sqrt)(x * x + y * y);
        if (r > (0, _mathJs.halfPi)) {
            var theta = (0, _mathJs.atan2)(y, x), theta0 = k * (0, _mathJs.round)((theta - (0, _mathJs.halfPi)) / k) + (0, _mathJs.halfPi), s = theta > theta0 ? -1 : 1, A = r * (0, _mathJs.cos)(theta0 - theta), cotAlpha = 1 / (0, _mathJs.tan)(s * (0, _mathJs.acos)((A - (0, _mathJs.pi)) / (0, _mathJs.sqrt)((0, _mathJs.pi) * ((0, _mathJs.pi) - 2 * A) + r * r)));
            theta = theta0 + 2 * (0, _mathJs.atan)((cotAlpha + s * (0, _mathJs.sqrt)(cotAlpha * cotAlpha - 3)) / 3);
            x = r * (0, _mathJs.cos)(theta), y = r * (0, _mathJs.sin)(theta);
        }
        return (0, _d3Geo.geoAzimuthalEquidistantRaw).invert(x, y);
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i72QO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Bertin 1953 as a modified Briesemeister
// https://bl.ocks.org/Fil/5b9ee9636dfb6ffa53443c9006beb642
parcelHelpers.export(exports, "bertin1953Raw", ()=>bertin1953Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        // this projection should not be rotated
        return (0, _d3Geo.geoProjection)(bertin1953Raw()).rotate([
            -16.5,
            -42
        ]).scale(176.57).center([
            7.93,
            0.09
        ]);
    });
var _d3Geo = require("d3-geo");
var _hammerJs = require("./hammer.js");
var _mathJs = require("./math.js");
var _newtonJs = require("./newton.js");
function bertin1953Raw() {
    var hammer = (0, _hammerJs.hammerRaw)(1.68, 2), fu = 1.4, k = 12;
    function forward(lambda, phi) {
        if (lambda + phi < -fu) {
            var u = (lambda - phi + 1.6) * (lambda + phi + fu) / 8;
            lambda += u;
            phi -= 0.8 * u * (0, _mathJs.sin)(phi + (0, _mathJs.pi) / 2);
        }
        var r = hammer(lambda, phi);
        var d = (1 - (0, _mathJs.cos)(lambda * phi)) / k;
        if (r[1] < 0) r[0] *= 1 + d;
        if (r[1] > 0) r[1] *= 1 + d / 1.5 * r[0] * r[0];
        return r;
    }
    forward.invert = (0, _newtonJs.solve2d)(forward);
    return forward;
}

},{"d3-geo":"hvz1M","./hammer.js":"esU8A","./math.js":"g023h","./newton.js":"6xPTk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esU8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hammerRaw", ()=>hammerRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var B = 2, m = (0, _d3Geo.geoProjectionMutator)(hammerRaw), p = m(B);
        p.coefficient = function(_) {
            if (!arguments.length) return B;
            return m(B = +_);
        };
        return p.scale(169.529);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function hammerRaw(A, B) {
    if (arguments.length < 2) B = A;
    if (B === 1) return 0, _d3Geo.geoAzimuthalEqualAreaRaw;
    if (B === Infinity) return hammerQuarticAuthalicRaw;
    function forward(lambda, phi) {
        var coordinates = (0, _d3Geo.geoAzimuthalEqualAreaRaw)(lambda / B, phi);
        coordinates[0] *= A;
        return coordinates;
    }
    forward.invert = function(x, y) {
        var coordinates = (0, _d3Geo.geoAzimuthalEqualAreaRaw).invert(x / A, y);
        coordinates[0] *= B;
        return coordinates;
    };
    return forward;
}
function hammerQuarticAuthalicRaw(lambda, phi) {
    return [
        lambda * (0, _mathJs.cos)(phi) / (0, _mathJs.cos)(phi /= 2),
        2 * (0, _mathJs.sin)(phi)
    ];
}
hammerQuarticAuthalicRaw.invert = function(x, y) {
    var phi = 2 * (0, _mathJs.asin)(y / 2);
    return [
        x * (0, _mathJs.cos)(phi / 2) / (0, _mathJs.cos)(phi),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6xPTk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Approximate Newton-Raphson
// Solve f(x) = y, start from x
parcelHelpers.export(exports, "solve", ()=>solve);
// Approximate Newton-Raphson in 2D
// Solve f(a,b) = [x,y]
parcelHelpers.export(exports, "solve2d", ()=>solve2d);
var _mathJs = require("./math.js");
function solve(f, y, x) {
    var steps = 100, delta, f0, f1;
    x = x === undefined ? 0 : +x;
    y = +y;
    do {
        f0 = f(x);
        f1 = f(x + (0, _mathJs.epsilon));
        if (f0 === f1) f1 = f0 + (0, _mathJs.epsilon);
        x -= delta = -1 * (0, _mathJs.epsilon) * (f0 - y) / (f0 - f1);
    }while (steps-- > 0 && (0, _mathJs.abs)(delta) > (0, _mathJs.epsilon));
    return steps < 0 ? NaN : x;
}
function solve2d(f, MAX_ITERATIONS, eps) {
    if (MAX_ITERATIONS === undefined) MAX_ITERATIONS = 40;
    if (eps === undefined) eps = (0, _mathJs.epsilon2);
    return function(x, y, a, b) {
        var err2, da, db;
        a = a === undefined ? 0 : +a;
        b = b === undefined ? 0 : +b;
        for(var i = 0; i < MAX_ITERATIONS; i++){
            var p = f(a, b), // diffs
            tx = p[0] - x, ty = p[1] - y;
            if ((0, _mathJs.abs)(tx) < eps && (0, _mathJs.abs)(ty) < eps) break; // we're there!
            // backtrack if we overshot
            var h = tx * tx + ty * ty;
            if (h > err2) {
                a -= da /= 2;
                b -= db /= 2;
                continue;
            }
            err2 = h;
            // partial derivatives
            var ea = (a > 0 ? -1 : 1) * eps, eb = (b > 0 ? -1 : 1) * eps, pa = f(a + ea, b), pb = f(a, b + eb), dxa = (pa[0] - p[0]) / ea, dya = (pa[1] - p[1]) / ea, dxb = (pb[0] - p[0]) / eb, dyb = (pb[1] - p[1]) / eb, // determinant
            D = dyb * dxa - dya * dxb, // newton step — or half-step for small D
            l = ((0, _mathJs.abs)(D) < 0.5 ? 0.5 : 1) / D;
            da = (ty * dxb - tx * dyb) * l;
            db = (tx * dya - ty * dxa) * l;
            a += da;
            b += db;
            if ((0, _mathJs.abs)(da) < eps && (0, _mathJs.abs)(db) < eps) break; // we're crawling
        }
        return [
            a,
            b
        ];
    };
}

},{"./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"87pEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "boggsRaw", ()=>boggsRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(boggsRaw).scale(160.857);
    });
var _d3Geo = require("d3-geo");
var _mollweideJs = require("./mollweide.js");
var _mathJs = require("./math.js");
var k = 2.00276, w = 1.11072;
function boggsRaw(lambda, phi) {
    var theta = (0, _mollweideJs.mollweideBromleyTheta)((0, _mathJs.pi), phi);
    return [
        k * lambda / (1 / (0, _mathJs.cos)(phi) + w / (0, _mathJs.cos)(theta)),
        (phi + (0, _mathJs.sqrt2) * (0, _mathJs.sin)(theta)) / k
    ];
}
boggsRaw.invert = function(x, y) {
    var ky = k * y, theta = y < 0 ? -(0, _mathJs.quarterPi) : (0, _mathJs.quarterPi), i = 25, delta, phi;
    do {
        phi = ky - (0, _mathJs.sqrt2) * (0, _mathJs.sin)(theta);
        theta -= delta = ((0, _mathJs.sin)(2 * theta) + 2 * theta - (0, _mathJs.pi) * (0, _mathJs.sin)(phi)) / (2 * (0, _mathJs.cos)(2 * theta) + 2 + (0, _mathJs.pi) * (0, _mathJs.cos)(phi) * (0, _mathJs.sqrt2) * (0, _mathJs.cos)(theta));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    phi = ky - (0, _mathJs.sqrt2) * (0, _mathJs.sin)(theta);
    return [
        x * (1 / (0, _mathJs.cos)(phi) + w / (0, _mathJs.cos)(theta)) / k,
        phi
    ];
};

},{"d3-geo":"hvz1M","./mollweide.js":"4WAID","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4WAID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mollweideBromleyTheta", ()=>mollweideBromleyTheta);
parcelHelpers.export(exports, "mollweideBromleyRaw", ()=>mollweideBromleyRaw);
parcelHelpers.export(exports, "mollweideRaw", ()=>mollweideRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(mollweideRaw).scale(169.529);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function mollweideBromleyTheta(cp, phi) {
    var cpsinPhi = cp * (0, _mathJs.sin)(phi), i = 30, delta;
    do phi -= delta = (phi + (0, _mathJs.sin)(phi) - cpsinPhi) / (1 + (0, _mathJs.cos)(phi));
    while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return phi / 2;
}
function mollweideBromleyRaw(cx, cy, cp) {
    function forward(lambda, phi) {
        return [
            cx * lambda * (0, _mathJs.cos)(phi = mollweideBromleyTheta(cp, phi)),
            cy * (0, _mathJs.sin)(phi)
        ];
    }
    forward.invert = function(x, y) {
        return y = (0, _mathJs.asin)(y / cy), [
            x / (cx * (0, _mathJs.cos)(y)),
            (0, _mathJs.asin)((2 * y + (0, _mathJs.sin)(2 * y)) / cp)
        ];
    };
    return forward;
}
var mollweideRaw = mollweideBromleyRaw((0, _mathJs.sqrt2) / (0, _mathJs.halfPi), (0, _mathJs.sqrt2), (0, _mathJs.pi));

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lEBzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bonneRaw", ()=>bonneRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _parallel1JsDefault.default)(bonneRaw).scale(123.082).center([
            0,
            26.1441
        ]).parallel(45);
    });
var _parallel1Js = require("./parallel1.js");
var _parallel1JsDefault = parcelHelpers.interopDefault(_parallel1Js);
var _mathJs = require("./math.js");
var _sinusoidalJs = require("./sinusoidal.js");
function bonneRaw(phi0) {
    if (!phi0) return 0, _sinusoidalJs.sinusoidalRaw;
    var cotPhi0 = 1 / (0, _mathJs.tan)(phi0);
    function forward(lambda, phi) {
        var rho = cotPhi0 + phi0 - phi, e = rho ? lambda * (0, _mathJs.cos)(phi) / rho : rho;
        return [
            rho * (0, _mathJs.sin)(e),
            cotPhi0 - rho * (0, _mathJs.cos)(e)
        ];
    }
    forward.invert = function(x, y) {
        var rho = (0, _mathJs.sqrt)(x * x + (y = cotPhi0 - y) * y), phi = cotPhi0 + phi0 - rho;
        return [
            rho / (0, _mathJs.cos)(phi) * (0, _mathJs.atan2)(x, y),
            phi
        ];
    };
    return forward;
}

},{"./parallel1.js":"7dEak","./math.js":"g023h","./sinusoidal.js":"aqIah","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7dEak":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projectAt) {
        var phi0 = 0, m = (0, _d3Geo.geoProjectionMutator)(projectAt), p = m(phi0);
        p.parallel = function(_) {
            return arguments.length ? m(phi0 = _ * (0, _mathJs.radians)) : phi0 * (0, _mathJs.degrees);
        };
        return p;
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aqIah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinusoidalRaw", ()=>sinusoidalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(sinusoidalRaw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function sinusoidalRaw(lambda, phi) {
    return [
        lambda * (0, _mathJs.cos)(phi),
        phi
    ];
}
sinusoidalRaw.invert = function(x, y) {
    return [
        x / (0, _mathJs.cos)(y),
        y
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1saCE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bottomleyRaw", ()=>bottomleyRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var sinPsi = 0.5, m = (0, _d3Geo.geoProjectionMutator)(bottomleyRaw), p = m(sinPsi);
        p.fraction = function(_) {
            return arguments.length ? m(sinPsi = +_) : sinPsi;
        };
        return p.scale(158.837);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function bottomleyRaw(sinPsi) {
    function forward(lambda, phi) {
        var rho = (0, _mathJs.halfPi) - phi, eta = rho ? lambda * sinPsi * (0, _mathJs.sin)(rho) / rho : rho;
        return [
            rho * (0, _mathJs.sin)(eta) / sinPsi,
            (0, _mathJs.halfPi) - rho * (0, _mathJs.cos)(eta)
        ];
    }
    forward.invert = function(x, y) {
        var x1 = x * sinPsi, y1 = (0, _mathJs.halfPi) - y, rho = (0, _mathJs.sqrt)(x1 * x1 + y1 * y1), eta = (0, _mathJs.atan2)(x1, y1);
        return [
            (rho ? rho / (0, _mathJs.sin)(rho) : 1) * eta / sinPsi,
            (0, _mathJs.halfPi) - rho
        ];
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Gdsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bromleyRaw", ()=>bromleyRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(bromleyRaw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _mollweideJs = require("./mollweide.js");
var bromleyRaw = (0, _mollweideJs.mollweideBromleyRaw)(1, 4 / (0, _mathJs.pi), (0, _mathJs.pi));

},{"d3-geo":"hvz1M","./math.js":"g023h","./mollweide.js":"4WAID","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7XCet":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chamberlinRaw", ()=>chamberlinRaw);
parcelHelpers.export(exports, "chamberlinAfrica", ()=>chamberlinAfrica);
parcelHelpers.export(exports, "default", ()=>chamberlin);
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _newtonJs = require("./newton.js");
// Azimuthal distance.
function distance(dPhi, c1, s1, c2, s2, dLambda) {
    var cosdLambda = (0, _mathJs.cos)(dLambda), r;
    if ((0, _mathJs.abs)(dPhi) > 1 || (0, _mathJs.abs)(dLambda) > 1) r = (0, _mathJs.acos)(s1 * s2 + c1 * c2 * cosdLambda);
    else {
        var sindPhi = (0, _mathJs.sin)(dPhi / 2), sindLambda = (0, _mathJs.sin)(dLambda / 2);
        r = 2 * (0, _mathJs.asin)((0, _mathJs.sqrt)(sindPhi * sindPhi + c1 * c2 * sindLambda * sindLambda));
    }
    return (0, _mathJs.abs)(r) > (0, _mathJs.epsilon) ? [
        r,
        (0, _mathJs.atan2)(c2 * (0, _mathJs.sin)(dLambda), c1 * s2 - s1 * c2 * cosdLambda)
    ] : [
        0,
        0
    ];
}
// Angle opposite a, and contained between sides of lengths b and c.
function angle(b, c, a) {
    return (0, _mathJs.acos)((b * b + c * c - a * a) / (2 * b * c));
}
// Normalize longitude.
function longitude(lambda) {
    return lambda - 2 * (0, _mathJs.pi) * (0, _mathJs.floor)((lambda + (0, _mathJs.pi)) / (2 * (0, _mathJs.pi)));
}
function chamberlinRaw(p0, p1, p2) {
    var points = [
        [
            p0[0],
            p0[1],
            (0, _mathJs.sin)(p0[1]),
            (0, _mathJs.cos)(p0[1])
        ],
        [
            p1[0],
            p1[1],
            (0, _mathJs.sin)(p1[1]),
            (0, _mathJs.cos)(p1[1])
        ],
        [
            p2[0],
            p2[1],
            (0, _mathJs.sin)(p2[1]),
            (0, _mathJs.cos)(p2[1])
        ]
    ];
    for(var a = points[2], b, i = 0; i < 3; ++i, a = b){
        b = points[i];
        a.v = distance(b[1] - a[1], a[3], a[2], b[3], b[2], b[0] - a[0]);
        a.point = [
            0,
            0
        ];
    }
    var beta0 = angle(points[0].v[0], points[2].v[0], points[1].v[0]), beta1 = angle(points[0].v[0], points[1].v[0], points[2].v[0]), beta2 = (0, _mathJs.pi) - beta0;
    points[2].point[1] = 0;
    points[0].point[0] = -(points[1].point[0] = points[0].v[0] / 2);
    var mean = [
        points[2].point[0] = points[0].point[0] + points[2].v[0] * (0, _mathJs.cos)(beta0),
        2 * (points[0].point[1] = points[1].point[1] = points[2].v[0] * (0, _mathJs.sin)(beta0))
    ];
    function forward(lambda, phi) {
        var sinPhi = (0, _mathJs.sin)(phi), cosPhi = (0, _mathJs.cos)(phi), v = new Array(3), i;
        // Compute distance and azimuth from control points.
        for(i = 0; i < 3; ++i){
            var p = points[i];
            v[i] = distance(phi - p[1], p[3], p[2], cosPhi, sinPhi, lambda - p[0]);
            if (!v[i][0]) return p.point;
            v[i][1] = longitude(v[i][1] - p.v[1]);
        }
        // Arithmetic mean of interception points.
        var point = mean.slice();
        for(i = 0; i < 3; ++i){
            var j = i == 2 ? 0 : i + 1;
            var a = angle(points[i].v[0], v[i][0], v[j][0]);
            if (v[i][1] < 0) a = -a;
            if (!i) {
                point[0] += v[i][0] * (0, _mathJs.cos)(a);
                point[1] -= v[i][0] * (0, _mathJs.sin)(a);
            } else if (i == 1) {
                a = beta1 - a;
                point[0] -= v[i][0] * (0, _mathJs.cos)(a);
                point[1] -= v[i][0] * (0, _mathJs.sin)(a);
            } else {
                a = beta2 - a;
                point[0] += v[i][0] * (0, _mathJs.cos)(a);
                point[1] += v[i][0] * (0, _mathJs.sin)(a);
            }
        }
        point[0] /= 3, point[1] /= 3;
        return point;
    }
    return forward;
}
function pointRadians(p) {
    return p[0] *= (0, _mathJs.radians), p[1] *= (0, _mathJs.radians), p;
}
function chamberlinAfrica() {
    return chamberlin([
        0,
        22
    ], [
        45,
        22
    ], [
        22.5,
        -22
    ]).scale(380).center([
        22.5,
        2
    ]);
}
function chamberlin(p0, p1, p2) {
    var c = (0, _d3Geo.geoCentroid)({
        type: "MultiPoint",
        coordinates: [
            p0,
            p1,
            p2
        ]
    }), R = [
        -c[0],
        -c[1]
    ], r = (0, _d3Geo.geoRotation)(R), f = chamberlinRaw(pointRadians(r(p0)), pointRadians(r(p1)), pointRadians(r(p2)));
    f.invert = (0, _newtonJs.solve2d)(f);
    var p = (0, _d3Geo.geoProjection)(f).rotate(R), center = p.center;
    delete p.rotate;
    p.center = function(_) {
        return arguments.length ? center(r(_)) : r.invert(center());
    };
    return p.clipAngle(90);
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./newton.js":"6xPTk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"94537":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "collignonRaw", ()=>collignonRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(collignonRaw).scale(95.6464).center([
            0,
            30
        ]);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function collignonRaw(lambda, phi) {
    var alpha = (0, _mathJs.sqrt)(1 - (0, _mathJs.sin)(phi));
    return [
        2 / (0, _mathJs.sqrtPi) * lambda * alpha,
        (0, _mathJs.sqrtPi) * (1 - alpha)
    ];
}
collignonRaw.invert = function(x, y) {
    var lambda = (lambda = y / (0, _mathJs.sqrtPi) - 1) * lambda;
    return [
        lambda > 0 ? x * (0, _mathJs.sqrt)((0, _mathJs.pi) / lambda) / 2 : 0,
        (0, _mathJs.asin)(1 - lambda)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joY7i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "craigRaw", ()=>craigRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _parallel1JsDefault.default)(craigRaw).scale(249.828).clipAngle(90);
    });
var _mathJs = require("./math.js");
var _parallel1Js = require("./parallel1.js");
var _parallel1JsDefault = parcelHelpers.interopDefault(_parallel1Js);
function craigRaw(phi0) {
    var tanPhi0 = (0, _mathJs.tan)(phi0);
    function forward(lambda, phi) {
        return [
            lambda,
            (lambda ? lambda / (0, _mathJs.sin)(lambda) : 1) * ((0, _mathJs.sin)(phi) * (0, _mathJs.cos)(lambda) - tanPhi0 * (0, _mathJs.cos)(phi))
        ];
    }
    forward.invert = tanPhi0 ? function(x, y) {
        if (x) y *= (0, _mathJs.sin)(x) / x;
        var cosLambda = (0, _mathJs.cos)(x);
        return [
            x,
            2 * (0, _mathJs.atan2)((0, _mathJs.sqrt)(cosLambda * cosLambda + tanPhi0 * tanPhi0 - y * y) - cosLambda, tanPhi0 - y)
        ];
    } : function(x, y) {
        return [
            x,
            (0, _mathJs.asin)(x ? y * (0, _mathJs.tan)(x) / x : y)
        ];
    };
    return forward;
}

},{"./math.js":"g023h","./parallel1.js":"7dEak","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c8Grz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "crasterRaw", ()=>crasterRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(crasterRaw).scale(156.19);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var sqrt3 = (0, _mathJs.sqrt)(3);
function crasterRaw(lambda, phi) {
    return [
        sqrt3 * lambda * (2 * (0, _mathJs.cos)(2 * phi / 3) - 1) / (0, _mathJs.sqrtPi),
        sqrt3 * (0, _mathJs.sqrtPi) * (0, _mathJs.sin)(phi / 3)
    ];
}
crasterRaw.invert = function(x, y) {
    var phi = 3 * (0, _mathJs.asin)(y / (sqrt3 * (0, _mathJs.sqrtPi)));
    return [
        (0, _mathJs.sqrtPi) * x / (sqrt3 * (2 * (0, _mathJs.cos)(2 * phi / 3) - 1)),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d3E2z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _parallel1JsDefault.default)(cylindricalEqualAreaRaw).parallel(38.58) // acos(sqrt(width / height / pi)) * radians
        .scale(195.044); // width / (sqrt(width / height / pi) * 2 * pi)
    });
var _mathJs = require("./math.js");
var _parallel1Js = require("./parallel1.js");
var _parallel1JsDefault = parcelHelpers.interopDefault(_parallel1Js);
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"./math.js":"g023h","./parallel1.js":"7dEak","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dUHf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalStereographicRaw", ()=>cylindricalStereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _parallel1JsDefault.default)(cylindricalStereographicRaw).scale(124.75);
    });
var _mathJs = require("./math.js");
var _parallel1Js = require("./parallel1.js");
var _parallel1JsDefault = parcelHelpers.interopDefault(_parallel1Js);
function cylindricalStereographicRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (1 + cosPhi0) * (0, _mathJs.tan)(phi / 2)
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.atan)(y / (1 + cosPhi0)) * 2
        ];
    };
    return forward;
}

},{"./math.js":"g023h","./parallel1.js":"7dEak","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jDASo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eckert1Raw", ()=>eckert1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eckert1Raw).scale(165.664);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function eckert1Raw(lambda, phi) {
    var alpha = (0, _mathJs.sqrt)(8 / (3 * (0, _mathJs.pi)));
    return [
        alpha * lambda * (1 - (0, _mathJs.abs)(phi) / (0, _mathJs.pi)),
        alpha * phi
    ];
}
eckert1Raw.invert = function(x, y) {
    var alpha = (0, _mathJs.sqrt)(8 / (3 * (0, _mathJs.pi))), phi = y / alpha;
    return [
        x / (alpha * (1 - (0, _mathJs.abs)(phi) / (0, _mathJs.pi))),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8uHZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eckert2Raw", ()=>eckert2Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eckert2Raw).scale(165.664);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function eckert2Raw(lambda, phi) {
    var alpha = (0, _mathJs.sqrt)(4 - 3 * (0, _mathJs.sin)((0, _mathJs.abs)(phi)));
    return [
        2 / (0, _mathJs.sqrt)(6 * (0, _mathJs.pi)) * lambda * alpha,
        (0, _mathJs.sign)(phi) * (0, _mathJs.sqrt)(2 * (0, _mathJs.pi) / 3) * (2 - alpha)
    ];
}
eckert2Raw.invert = function(x, y) {
    var alpha = 2 - (0, _mathJs.abs)(y) / (0, _mathJs.sqrt)(2 * (0, _mathJs.pi) / 3);
    return [
        x * (0, _mathJs.sqrt)(6 * (0, _mathJs.pi)) / (2 * alpha),
        (0, _mathJs.sign)(y) * (0, _mathJs.asin)((4 - alpha * alpha) / 3)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aWJtZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eckert3Raw", ()=>eckert3Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eckert3Raw).scale(180.739);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function eckert3Raw(lambda, phi) {
    var k = (0, _mathJs.sqrt)((0, _mathJs.pi) * (4 + (0, _mathJs.pi)));
    return [
        2 / k * lambda * (1 + (0, _mathJs.sqrt)(1 - 4 * phi * phi / ((0, _mathJs.pi) * (0, _mathJs.pi)))),
        4 / k * phi
    ];
}
eckert3Raw.invert = function(x, y) {
    var k = (0, _mathJs.sqrt)((0, _mathJs.pi) * (4 + (0, _mathJs.pi))) / 2;
    return [
        x * k / (1 + (0, _mathJs.sqrt)(1 - y * y * (4 + (0, _mathJs.pi)) / (4 * (0, _mathJs.pi)))),
        y * k / 2
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9XUWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eckert4Raw", ()=>eckert4Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eckert4Raw).scale(180.739);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function eckert4Raw(lambda, phi) {
    var k = (2 + (0, _mathJs.halfPi)) * (0, _mathJs.sin)(phi);
    phi /= 2;
    for(var i = 0, delta = Infinity; i < 10 && (0, _mathJs.abs)(delta) > (0, _mathJs.epsilon); i++){
        var cosPhi = (0, _mathJs.cos)(phi);
        phi -= delta = (phi + (0, _mathJs.sin)(phi) * (cosPhi + 2) - k) / (2 * cosPhi * (1 + cosPhi));
    }
    return [
        2 / (0, _mathJs.sqrt)((0, _mathJs.pi) * (4 + (0, _mathJs.pi))) * lambda * (1 + (0, _mathJs.cos)(phi)),
        2 * (0, _mathJs.sqrt)((0, _mathJs.pi) / (4 + (0, _mathJs.pi))) * (0, _mathJs.sin)(phi)
    ];
}
eckert4Raw.invert = function(x, y) {
    var A = y * (0, _mathJs.sqrt)((4 + (0, _mathJs.pi)) / (0, _mathJs.pi)) / 2, k = (0, _mathJs.asin)(A), c = (0, _mathJs.cos)(k);
    return [
        x / (2 / (0, _mathJs.sqrt)((0, _mathJs.pi) * (4 + (0, _mathJs.pi))) * (1 + c)),
        (0, _mathJs.asin)((k + A * (c + 2)) / (2 + (0, _mathJs.halfPi)))
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iaeY3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eckert5Raw", ()=>eckert5Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eckert5Raw).scale(173.044);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function eckert5Raw(lambda, phi) {
    return [
        lambda * (1 + (0, _mathJs.cos)(phi)) / (0, _mathJs.sqrt)(2 + (0, _mathJs.pi)),
        2 * phi / (0, _mathJs.sqrt)(2 + (0, _mathJs.pi))
    ];
}
eckert5Raw.invert = function(x, y) {
    var k = (0, _mathJs.sqrt)(2 + (0, _mathJs.pi)), phi = y * k / 2;
    return [
        k * x / (1 + (0, _mathJs.cos)(phi)),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kmePe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eckert6Raw", ()=>eckert6Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eckert6Raw).scale(173.044);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function eckert6Raw(lambda, phi) {
    var k = (1 + (0, _mathJs.halfPi)) * (0, _mathJs.sin)(phi);
    for(var i = 0, delta = Infinity; i < 10 && (0, _mathJs.abs)(delta) > (0, _mathJs.epsilon); i++)phi -= delta = (phi + (0, _mathJs.sin)(phi) - k) / (1 + (0, _mathJs.cos)(phi));
    k = (0, _mathJs.sqrt)(2 + (0, _mathJs.pi));
    return [
        lambda * (1 + (0, _mathJs.cos)(phi)) / k,
        2 * phi / k
    ];
}
eckert6Raw.invert = function(x, y) {
    var j = 1 + (0, _mathJs.halfPi), k = (0, _mathJs.sqrt)(j / 2);
    return [
        x * 2 * k / (1 + (0, _mathJs.cos)(y *= k)),
        (0, _mathJs.asin)((y + (0, _mathJs.sin)(y)) / j)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Yqsl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eisenlohrRaw", ()=>eisenlohrRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(eisenlohrRaw).scale(62.5271);
    });
var _d3Geo = require("d3-geo");
var _augustJs = require("./august.js");
var _mathJs = require("./math.js");
var eisenlohrK = 3 + 2 * (0, _mathJs.sqrt2);
function eisenlohrRaw(lambda, phi) {
    var s0 = (0, _mathJs.sin)(lambda /= 2), c0 = (0, _mathJs.cos)(lambda), k = (0, _mathJs.sqrt)((0, _mathJs.cos)(phi)), c1 = (0, _mathJs.cos)(phi /= 2), t = (0, _mathJs.sin)(phi) / (c1 + (0, _mathJs.sqrt2) * c0 * k), c = (0, _mathJs.sqrt)(2 / (1 + t * t)), v = (0, _mathJs.sqrt)(((0, _mathJs.sqrt2) * c1 + (c0 + s0) * k) / ((0, _mathJs.sqrt2) * c1 + (c0 - s0) * k));
    return [
        eisenlohrK * (c * (v - 1 / v) - 2 * (0, _mathJs.log)(v)),
        eisenlohrK * (c * t * (v + 1 / v) - 2 * (0, _mathJs.atan)(t))
    ];
}
eisenlohrRaw.invert = function(x, y) {
    if (!(p = (0, _augustJs.augustRaw).invert(x / 1.2, y * 1.065))) return null;
    var lambda = p[0], phi = p[1], i = 20, p;
    x /= eisenlohrK, y /= eisenlohrK;
    do {
        var _0 = lambda / 2, _1 = phi / 2, s0 = (0, _mathJs.sin)(_0), c0 = (0, _mathJs.cos)(_0), s1 = (0, _mathJs.sin)(_1), c1 = (0, _mathJs.cos)(_1), cos1 = (0, _mathJs.cos)(phi), k = (0, _mathJs.sqrt)(cos1), t = s1 / (c1 + (0, _mathJs.sqrt2) * c0 * k), t2 = t * t, c = (0, _mathJs.sqrt)(2 / (1 + t2)), v0 = (0, _mathJs.sqrt2) * c1 + (c0 + s0) * k, v1 = (0, _mathJs.sqrt2) * c1 + (c0 - s0) * k, v2 = v0 / v1, v = (0, _mathJs.sqrt)(v2), vm1v = v - 1 / v, vp1v = v + 1 / v, fx = c * vm1v - 2 * (0, _mathJs.log)(v) - x, fy = c * t * vp1v - 2 * (0, _mathJs.atan)(t) - y, deltatDeltaLambda = s1 && (0, _mathJs.sqrt1_2) * k * s0 * t2 / s1, deltatDeltaPhi = ((0, _mathJs.sqrt2) * c0 * c1 + k) / (2 * (c1 + (0, _mathJs.sqrt2) * c0 * k) * (c1 + (0, _mathJs.sqrt2) * c0 * k) * k), deltacDeltat = -0.5 * t * c * c * c, deltacDeltaLambda = deltacDeltat * deltatDeltaLambda, deltacDeltaPhi = deltacDeltat * deltatDeltaPhi, A = (A = 2 * c1 + (0, _mathJs.sqrt2) * k * (c0 - s0)) * A * v, deltavDeltaLambda = ((0, _mathJs.sqrt2) * c0 * c1 * k + cos1) / A, deltavDeltaPhi = -((0, _mathJs.sqrt2) * s0 * s1) / (k * A), deltaxDeltaLambda = vm1v * deltacDeltaLambda - 2 * deltavDeltaLambda / v + c * (deltavDeltaLambda + deltavDeltaLambda / v2), deltaxDeltaPhi = vm1v * deltacDeltaPhi - 2 * deltavDeltaPhi / v + c * (deltavDeltaPhi + deltavDeltaPhi / v2), deltayDeltaLambda = t * vp1v * deltacDeltaLambda - 2 * deltatDeltaLambda / (1 + t2) + c * vp1v * deltatDeltaLambda + c * t * (deltavDeltaLambda - deltavDeltaLambda / v2), deltayDeltaPhi = t * vp1v * deltacDeltaPhi - 2 * deltatDeltaPhi / (1 + t2) + c * vp1v * deltatDeltaPhi + c * t * (deltavDeltaPhi - deltavDeltaPhi / v2), denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
        if (!denominator) break;
        var deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator, deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
        lambda -= deltaLambda;
        phi = (0, _mathJs.max)(-(0, _mathJs.halfPi), (0, _mathJs.min)((0, _mathJs.halfPi), phi - deltaPhi));
    }while (((0, _mathJs.abs)(deltaLambda) > (0, _mathJs.epsilon) || (0, _mathJs.abs)(deltaPhi) > (0, _mathJs.epsilon)) && --i > 0);
    return (0, _mathJs.abs)((0, _mathJs.abs)(phi) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon) ? [
        0,
        phi
    ] : i && [
        lambda,
        phi
    ];
};

},{"d3-geo":"hvz1M","./august.js":"boWOH","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a2adt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "faheyRaw", ()=>faheyRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(faheyRaw).scale(137.152);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var faheyK = (0, _mathJs.cos)(35 * (0, _mathJs.radians));
function faheyRaw(lambda, phi) {
    var t = (0, _mathJs.tan)(phi / 2);
    return [
        lambda * faheyK * (0, _mathJs.sqrt)(1 - t * t),
        (1 + faheyK) * t
    ];
}
faheyRaw.invert = function(x, y) {
    var t = y / (1 + faheyK);
    return [
        x && x / (faheyK * (0, _mathJs.sqrt)(1 - t * t)),
        2 * (0, _mathJs.atan)(t)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4xWIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "foucautRaw", ()=>foucautRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(foucautRaw).scale(135.264);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function foucautRaw(lambda, phi) {
    var k = phi / 2, cosk = (0, _mathJs.cos)(k);
    return [
        2 * lambda / (0, _mathJs.sqrtPi) * (0, _mathJs.cos)(phi) * cosk * cosk,
        (0, _mathJs.sqrtPi) * (0, _mathJs.tan)(k)
    ];
}
foucautRaw.invert = function(x, y) {
    var k = (0, _mathJs.atan)(y / (0, _mathJs.sqrtPi)), cosk = (0, _mathJs.cos)(k), phi = 2 * k;
    return [
        x * (0, _mathJs.sqrtPi) / 2 / ((0, _mathJs.cos)(phi) * cosk * cosk),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ggZIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "foucautSinusoidalRaw", ()=>foucautSinusoidalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var alpha = 0.5, m = (0, _d3Geo.geoProjectionMutator)(foucautSinusoidalRaw), p = m(alpha);
        p.alpha = function(_) {
            return arguments.length ? m(alpha = +_) : alpha;
        };
        return p.scale(168.725);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _newtonJs = require("./newton.js");
function foucautSinusoidalRaw(alpha) {
    var beta = 1 - alpha, equatorial = raw((0, _mathJs.pi), 0)[0] - raw(-(0, _mathJs.pi), 0)[0], polar = raw(0, (0, _mathJs.halfPi))[1] - raw(0, -(0, _mathJs.halfPi))[1], ratio = (0, _mathJs.sqrt)(2 * polar / equatorial);
    function raw(lambda, phi) {
        var cosphi = (0, _mathJs.cos)(phi), sinphi = (0, _mathJs.sin)(phi);
        return [
            cosphi / (beta + alpha * cosphi) * lambda,
            beta * phi + alpha * sinphi
        ];
    }
    function forward(lambda, phi) {
        var p = raw(lambda, phi);
        return [
            p[0] * ratio,
            p[1] / ratio
        ];
    }
    function forwardMeridian(phi) {
        return forward(0, phi)[1];
    }
    forward.invert = function(x, y) {
        var phi = (0, _newtonJs.solve)(forwardMeridian, y), lambda = x / ratio * (alpha + beta / (0, _mathJs.cos)(phi));
        return [
            lambda,
            phi
        ];
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./newton.js":"6xPTk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3g8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projectionType) {
        if (projectionType == null) projectionType = (0, _d3Geo.geoOrthographic);
        var projection = projectionType(), equirectangular = (0, _d3Geo.geoEquirectangular)().scale((0, _mathJs.degrees)).precision(0).clipAngle(null).translate([
            0,
            0
        ]); // antimeridian cutting
        function gilbert(point) {
            return projection(gilbertForward(point));
        }
        if (projection.invert) gilbert.invert = function(point) {
            return gilbertInvert(projection.invert(point));
        };
        gilbert.stream = function(stream) {
            var s1 = projection.stream(stream), s0 = equirectangular.stream({
                point: function(lambda, phi) {
                    s1.point(lambda / 2, (0, _mathJs.asin)((0, _mathJs.tan)(-phi / 2 * (0, _mathJs.radians))) * (0, _mathJs.degrees));
                },
                lineStart: function() {
                    s1.lineStart();
                },
                lineEnd: function() {
                    s1.lineEnd();
                },
                polygonStart: function() {
                    s1.polygonStart();
                },
                polygonEnd: function() {
                    s1.polygonEnd();
                }
            });
            s0.sphere = s1.sphere;
            return s0;
        };
        function property(name) {
            gilbert[name] = function() {
                return arguments.length ? (projection[name].apply(projection, arguments), gilbert) : projection[name]();
            };
        }
        gilbert.rotate = function(_) {
            return arguments.length ? (equirectangular.rotate(_), gilbert) : equirectangular.rotate();
        };
        gilbert.center = function(_) {
            return arguments.length ? (projection.center(gilbertForward(_)), gilbert) : gilbertInvert(projection.center());
        };
        property("angle");
        property("clipAngle");
        property("clipExtent");
        property("fitExtent");
        property("fitHeight");
        property("fitSize");
        property("fitWidth");
        property("scale");
        property("translate");
        property("precision");
        return gilbert.scale(249.5);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function gilbertForward(point) {
    return [
        point[0] / 2,
        (0, _mathJs.asin)((0, _mathJs.tan)(point[1] / 2 * (0, _mathJs.radians))) * (0, _mathJs.degrees)
    ];
}
function gilbertInvert(point) {
    return [
        point[0] * 2,
        2 * (0, _mathJs.atan)((0, _mathJs.sin)(point[1] * (0, _mathJs.radians))) * (0, _mathJs.degrees)
    ];
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jZq2N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gingeryRaw", ()=>gingeryRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var n = 6, rho = 30 * (0, _mathJs.radians), cRho = (0, _mathJs.cos)(rho), sRho = (0, _mathJs.sin)(rho), m = (0, _d3Geo.geoProjectionMutator)(gingeryRaw), p = m(rho, n), stream_ = p.stream, epsilon = 1e-2, cr = -(0, _mathJs.cos)(epsilon * (0, _mathJs.radians)), sr = (0, _mathJs.sin)(epsilon * (0, _mathJs.radians));
        p.radius = function(_) {
            if (!arguments.length) return rho * (0, _mathJs.degrees);
            cRho = (0, _mathJs.cos)(rho = _ * (0, _mathJs.radians));
            sRho = (0, _mathJs.sin)(rho);
            return m(rho, n);
        };
        p.lobes = function(_) {
            if (!arguments.length) return n;
            return m(rho, n = +_);
        };
        p.stream = function(stream) {
            var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([
                0,
                0
            ]), stream_(stream));
            p.rotate(rotate);
            rotateStream.sphere = function() {
                sphereStream.polygonStart(), sphereStream.lineStart();
                for(var i = 0, delta = 2 * (0, _mathJs.pi) / n, phi = 0; i < n; ++i, phi -= delta){
                    sphereStream.point((0, _mathJs.atan2)(sr * (0, _mathJs.cos)(phi), cr) * (0, _mathJs.degrees), (0, _mathJs.asin)(sr * (0, _mathJs.sin)(phi)) * (0, _mathJs.degrees));
                    sphereStream.point((0, _mathJs.atan2)(sRho * (0, _mathJs.cos)(phi - delta / 2), cRho) * (0, _mathJs.degrees), (0, _mathJs.asin)(sRho * (0, _mathJs.sin)(phi - delta / 2)) * (0, _mathJs.degrees));
                }
                sphereStream.lineEnd(), sphereStream.polygonEnd();
            };
            return rotateStream;
        };
        return p.rotate([
            90,
            -40
        ]).scale(91.7095).clipAngle(179.999);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function gingeryRaw(rho, n) {
    var k = 2 * (0, _mathJs.pi) / n, rho2 = rho * rho;
    function forward(lambda, phi) {
        var p = (0, _d3Geo.geoAzimuthalEquidistantRaw)(lambda, phi), x = p[0], y = p[1], r2 = x * x + y * y;
        if (r2 > rho2) {
            var r = (0, _mathJs.sqrt)(r2), theta = (0, _mathJs.atan2)(y, x), theta0 = k * (0, _mathJs.round)(theta / k), alpha = theta - theta0, rhoCosAlpha = rho * (0, _mathJs.cos)(alpha), k_ = (rho * (0, _mathJs.sin)(alpha) - alpha * (0, _mathJs.sin)(rhoCosAlpha)) / ((0, _mathJs.halfPi) - rhoCosAlpha), s_ = gingeryLength(alpha, k_), e = ((0, _mathJs.pi) - rho) / gingeryIntegrate(s_, rhoCosAlpha, (0, _mathJs.pi));
            x = r;
            var i = 50, delta;
            do x -= delta = (rho + gingeryIntegrate(s_, rhoCosAlpha, x) * e - r) / (s_(x) * e);
            while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
            y = alpha * (0, _mathJs.sin)(x);
            if (x < (0, _mathJs.halfPi)) y -= k_ * (x - (0, _mathJs.halfPi));
            var s = (0, _mathJs.sin)(theta0), c = (0, _mathJs.cos)(theta0);
            p[0] = x * c - y * s;
            p[1] = x * s + y * c;
        }
        return p;
    }
    forward.invert = function(x, y) {
        var r2 = x * x + y * y;
        if (r2 > rho2) {
            var r = (0, _mathJs.sqrt)(r2), theta = (0, _mathJs.atan2)(y, x), theta0 = k * (0, _mathJs.round)(theta / k), dTheta = theta - theta0;
            x = r * (0, _mathJs.cos)(dTheta);
            y = r * (0, _mathJs.sin)(dTheta);
            var x_halfPi = x - (0, _mathJs.halfPi), sinx = (0, _mathJs.sin)(x), alpha = y / sinx, delta = x < (0, _mathJs.halfPi) ? Infinity : 0, i = 10;
            while(true){
                var rhosinAlpha = rho * (0, _mathJs.sin)(alpha), rhoCosAlpha = rho * (0, _mathJs.cos)(alpha), sinRhoCosAlpha = (0, _mathJs.sin)(rhoCosAlpha), halfPi_RhoCosAlpha = (0, _mathJs.halfPi) - rhoCosAlpha, k_ = (rhosinAlpha - alpha * sinRhoCosAlpha) / halfPi_RhoCosAlpha, s_ = gingeryLength(alpha, k_);
                if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2) || !--i) break;
                alpha -= delta = (alpha * sinx - k_ * x_halfPi - y) / (sinx - x_halfPi * 2 * (halfPi_RhoCosAlpha * (rhoCosAlpha + alpha * rhosinAlpha * (0, _mathJs.cos)(rhoCosAlpha) - sinRhoCosAlpha) - rhosinAlpha * (rhosinAlpha - alpha * sinRhoCosAlpha)) / (halfPi_RhoCosAlpha * halfPi_RhoCosAlpha));
            }
            r = rho + gingeryIntegrate(s_, rhoCosAlpha, x) * ((0, _mathJs.pi) - rho) / gingeryIntegrate(s_, rhoCosAlpha, (0, _mathJs.pi));
            theta = theta0 + alpha;
            x = r * (0, _mathJs.cos)(theta);
            y = r * (0, _mathJs.sin)(theta);
        }
        return (0, _d3Geo.geoAzimuthalEquidistantRaw).invert(x, y);
    };
    return forward;
}
function gingeryLength(alpha, k) {
    return function(x) {
        var y_ = alpha * (0, _mathJs.cos)(x);
        if (x < (0, _mathJs.halfPi)) y_ -= k;
        return (0, _mathJs.sqrt)(1 + y_ * y_);
    };
}
// Numerical integration: trapezoidal rule.
function gingeryIntegrate(f, a, b) {
    var n = 50, h = (b - a) / n, s = f(a) + f(b);
    for(var i = 1, x = a; i < n; ++i)s += 2 * f(x += h);
    return s * 0.5 * h;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3t2vb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ginzburg4Raw", ()=>ginzburg4Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(ginzburg4Raw).scale(149.995);
    });
var _d3Geo = require("d3-geo");
var _ginzburgPolyconicJs = require("./ginzburgPolyconic.js");
var _ginzburgPolyconicJsDefault = parcelHelpers.interopDefault(_ginzburgPolyconicJs);
var ginzburg4Raw = (0, _ginzburgPolyconicJsDefault.default)(2.8284, -1.6988, 0.75432, -0.18071, 1.76003, -0.38914, 0.042555);

},{"d3-geo":"hvz1M","./ginzburgPolyconic.js":"dHAWa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dHAWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f, g, h) {
        if (arguments.length < 8) h = 0;
        function forward(lambda, phi) {
            if (!phi) return [
                a * lambda / (0, _mathJs.pi),
                0
            ];
            var phi2 = phi * phi, xB = a + phi2 * (b + phi2 * (c + phi2 * d)), yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)), m = (xB * xB + yB * yB) / (2 * yB), alpha = lambda * (0, _mathJs.asin)(xB / m) / (0, _mathJs.pi);
            return [
                m * (0, _mathJs.sin)(alpha),
                phi * (1 + phi2 * h) + m * (1 - (0, _mathJs.cos)(alpha))
            ];
        }
        forward.invert = function(x, y) {
            var lambda = (0, _mathJs.pi) * x / a, phi = y, deltaLambda, deltaPhi, i = 50;
            do {
                var phi2 = phi * phi, xB = a + phi2 * (b + phi2 * (c + phi2 * d)), yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)), p = xB * xB + yB * yB, q = 2 * yB, m = p / q, m2 = m * m, dAlphadLambda = (0, _mathJs.asin)(xB / m) / (0, _mathJs.pi), alpha = lambda * dAlphadLambda, xB2 = xB * xB, dxBdPhi = (2 * b + phi2 * (4 * c + phi2 * 6 * d)) * phi, dyBdPhi = e + phi2 * (3 * f + phi2 * 5 * g), dpdPhi = 2 * (xB * dxBdPhi + yB * (dyBdPhi - 1)), dqdPhi = 2 * (dyBdPhi - 1), dmdPhi = (dpdPhi * q - p * dqdPhi) / (q * q), cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), mcosAlpha = m * cosAlpha, msinAlpha = m * sinAlpha, dAlphadPhi = lambda / (0, _mathJs.pi) * (1 / (0, _mathJs.sqrt)(1 - xB2 / m2)) * (dxBdPhi * m - xB * dmdPhi) / m2, fx = msinAlpha - x, fy = phi * (1 + phi2 * h) + m - mcosAlpha - y, deltaxDeltaPhi = dmdPhi * sinAlpha + mcosAlpha * dAlphadPhi, deltaxDeltaLambda = mcosAlpha * dAlphadLambda, deltayDeltaPhi = 1 + dmdPhi - (dmdPhi * cosAlpha - msinAlpha * dAlphadPhi), deltayDeltaLambda = msinAlpha * dAlphadLambda, denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
                if (!denominator) break;
                lambda -= deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator;
                phi -= deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
            }while (((0, _mathJs.abs)(deltaLambda) > (0, _mathJs.epsilon) || (0, _mathJs.abs)(deltaPhi) > (0, _mathJs.epsilon)) && --i > 0);
            return [
                lambda,
                phi
            ];
        };
        return forward;
    });
var _mathJs = require("./math.js");

},{"./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"khpCN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ginzburg5Raw", ()=>ginzburg5Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(ginzburg5Raw).scale(153.93);
    });
var _d3Geo = require("d3-geo");
var _ginzburgPolyconicJs = require("./ginzburgPolyconic.js");
var _ginzburgPolyconicJsDefault = parcelHelpers.interopDefault(_ginzburgPolyconicJs);
var ginzburg5Raw = (0, _ginzburgPolyconicJsDefault.default)(2.583819, -0.835827, 0.170354, -0.038094, 1.543313, -0.411435, 0.082742);

},{"d3-geo":"hvz1M","./ginzburgPolyconic.js":"dHAWa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8TYKL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ginzburg6Raw", ()=>ginzburg6Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(ginzburg6Raw).scale(130.945);
    });
var _d3Geo = require("d3-geo");
var _ginzburgPolyconicJs = require("./ginzburgPolyconic.js");
var _ginzburgPolyconicJsDefault = parcelHelpers.interopDefault(_ginzburgPolyconicJs);
var _mathJs = require("./math.js");
var ginzburg6Raw = (0, _ginzburgPolyconicJsDefault.default)(5 / 6 * (0, _mathJs.pi), -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, 0.045);

},{"d3-geo":"hvz1M","./ginzburgPolyconic.js":"dHAWa","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2K2bJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ginzburg8Raw", ()=>ginzburg8Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(ginzburg8Raw).scale(131.747);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function ginzburg8Raw(lambda, phi) {
    var lambda2 = lambda * lambda, phi2 = phi * phi;
    return [
        lambda * (1 - 0.162388 * phi2) * (0.87 - 0.000952426 * lambda2 * lambda2),
        phi * (1 + phi2 / 12)
    ];
}
ginzburg8Raw.invert = function(x, y) {
    var lambda = x, phi = y, i = 50, delta;
    do {
        var phi2 = phi * phi;
        phi -= delta = (phi * (1 + phi2 / 12) - y) / (1 + phi2 / 4);
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    i = 50;
    x /= 1 - 0.162388 * phi2;
    do {
        var lambda4 = (lambda4 = lambda * lambda) * lambda4;
        lambda -= delta = (lambda * (0.87 - 0.000952426 * lambda4) - x) / (0.87 - 0.00476213 * lambda4);
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        lambda,
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ePso8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ginzburg9Raw", ()=>ginzburg9Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(ginzburg9Raw).scale(131.087);
    });
var _d3Geo = require("d3-geo");
var _ginzburgPolyconicJs = require("./ginzburgPolyconic.js");
var _ginzburgPolyconicJsDefault = parcelHelpers.interopDefault(_ginzburgPolyconicJs);
var ginzburg9Raw = (0, _ginzburgPolyconicJsDefault.default)(2.6516, -0.76534, 0.19123, -0.047094, 1.36289, -0.13965, 0.031762);

},{"d3-geo":"hvz1M","./ginzburgPolyconic.js":"dHAWa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"58Ivv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gringortenRaw", ()=>gringortenRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)((0, _squareJsDefault.default)(gringortenRaw)).scale(239.75);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _squareJs = require("./square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
function gringortenRaw(lambda, phi) {
    var sLambda = (0, _mathJs.sign)(lambda), sPhi = (0, _mathJs.sign)(phi), cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(sPhi * phi);
    lambda = (0, _mathJs.abs)((0, _mathJs.atan2)(y, z));
    phi = (0, _mathJs.asin)(x);
    if ((0, _mathJs.abs)(lambda - (0, _mathJs.halfPi)) > (0, _mathJs.epsilon)) lambda %= (0, _mathJs.halfPi);
    var point = gringortenHexadecant(lambda > (0, _mathJs.pi) / 4 ? (0, _mathJs.halfPi) - lambda : lambda, phi);
    if (lambda > (0, _mathJs.pi) / 4) z = point[0], point[0] = -point[1], point[1] = -z;
    return point[0] *= sLambda, point[1] *= -sPhi, point;
}
gringortenRaw.invert = function(x, y) {
    if ((0, _mathJs.abs)(x) > 1) x = (0, _mathJs.sign)(x) * 2 - x;
    if ((0, _mathJs.abs)(y) > 1) y = (0, _mathJs.sign)(y) * 2 - y;
    var sx = (0, _mathJs.sign)(x), sy = (0, _mathJs.sign)(y), x0 = -sx * x, y0 = -sy * y, t = y0 / x0 < 1, p = gringortenHexadecantInvert(t ? y0 : x0, t ? x0 : y0), lambda = p[0], phi = p[1], cosPhi = (0, _mathJs.cos)(phi);
    if (t) lambda = -(0, _mathJs.halfPi) - lambda;
    return [
        sx * ((0, _mathJs.atan2)((0, _mathJs.sin)(lambda) * cosPhi, -(0, _mathJs.sin)(phi)) + (0, _mathJs.pi)),
        sy * (0, _mathJs.asin)((0, _mathJs.cos)(lambda) * cosPhi)
    ];
};
function gringortenHexadecant(lambda, phi) {
    if (phi === (0, _mathJs.halfPi)) return [
        0,
        0
    ];
    var sinPhi = (0, _mathJs.sin)(phi), r = sinPhi * sinPhi, r2 = r * r, j = 1 + r2, k = 1 + 3 * r2, q = 1 - r2, z = (0, _mathJs.asin)(1 / (0, _mathJs.sqrt)(j)), v = q + r * j * z, p2 = (1 - sinPhi) / v, p = (0, _mathJs.sqrt)(p2), a2 = p2 * j, a = (0, _mathJs.sqrt)(a2), h = p * q, x, i;
    if (lambda === 0) return [
        0,
        -(h + r * a)
    ];
    var cosPhi = (0, _mathJs.cos)(phi), secPhi = 1 / cosPhi, drdPhi = 2 * sinPhi * cosPhi, dvdPhi = (-3 * r + z * k) * drdPhi, dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v), dpdPhi = 0.5 * dp2dPhi / p, dhdPhi = q * dpdPhi - 2 * r * p * drdPhi, dra2dPhi = r * j * dp2dPhi + p2 * k * drdPhi, mu = -secPhi * drdPhi, nu = -secPhi * dra2dPhi, zeta = -2 * secPhi * dhdPhi, lambda1 = 4 * lambda / (0, _mathJs.pi), delta;
    // Slower but accurate bisection method.
    if (lambda > 0.222 * (0, _mathJs.pi) || phi < (0, _mathJs.pi) / 4 && lambda > 0.175 * (0, _mathJs.pi)) {
        x = (h + r * (0, _mathJs.sqrt)(a2 * (1 + r2) - h * h)) / (1 + r2);
        if (lambda > (0, _mathJs.pi) / 4) return [
            x,
            x
        ];
        var x1 = x, x0 = 0.5 * x;
        x = 0.5 * (x0 + x1), i = 50;
        do {
            var g = (0, _mathJs.sqrt)(a2 - x * x), f = x * (zeta + mu * g) + nu * (0, _mathJs.asin)(x / a) - lambda1;
            if (!f) break;
            if (f < 0) x0 = x;
            else x1 = x;
            x = 0.5 * (x0 + x1);
        }while ((0, _mathJs.abs)(x1 - x0) > (0, _mathJs.epsilon) && --i > 0);
    } else {
        x = (0, _mathJs.epsilon), i = 25;
        do {
            var x2 = x * x, g2 = (0, _mathJs.sqrt)(a2 - x2), zetaMug = zeta + mu * g2, f2 = x * zetaMug + nu * (0, _mathJs.asin)(x / a) - lambda1, df = zetaMug + (nu - mu * x2) / g2;
            x -= delta = g2 ? f2 / df : 0;
        }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    }
    return [
        x,
        -h - r * (0, _mathJs.sqrt)(a2 - x * x)
    ];
}
function gringortenHexadecantInvert(x, y) {
    var x0 = 0, x1 = 1, r = 0.5, i = 50;
    while(true){
        var r2 = r * r, sinPhi = (0, _mathJs.sqrt)(r), z = (0, _mathJs.asin)(1 / (0, _mathJs.sqrt)(1 + r2)), v = 1 - r2 + r * (1 + r2) * z, p2 = (1 - sinPhi) / v, p = (0, _mathJs.sqrt)(p2), a2 = p2 * (1 + r2), h = p * (1 - r2), g2 = a2 - x * x, g = (0, _mathJs.sqrt)(g2), y0 = y + h + r * g;
        if ((0, _mathJs.abs)(x1 - x0) < (0, _mathJs.epsilon2) || --i === 0 || y0 === 0) break;
        if (y0 > 0) x0 = r;
        else x1 = r;
        r = 0.5 * (x0 + x1);
    }
    if (!i) return null;
    var phi = (0, _mathJs.asin)(sinPhi), cosPhi = (0, _mathJs.cos)(phi), secPhi = 1 / cosPhi, drdPhi = 2 * sinPhi * cosPhi, dvdPhi = (-3 * r + z * (1 + 3 * r2)) * drdPhi, dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v), dpdPhi = 0.5 * dp2dPhi / p, dhdPhi = (1 - r2) * dpdPhi - 2 * r * p * drdPhi, zeta = -2 * secPhi * dhdPhi, mu = -secPhi * drdPhi, nu = -secPhi * (r * (1 + r2) * dp2dPhi + p2 * (1 + 3 * r2) * drdPhi);
    return [
        (0, _mathJs.pi) / 4 * (x * (zeta + mu * g) + nu * (0, _mathJs.asin)(x / (0, _mathJs.sqrt)(a2))),
        phi
    ];
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./square.js":"c381T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c381T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project) {
        var dx = project((0, _mathJs.halfPi), 0)[0] - project(-(0, _mathJs.halfPi), 0)[0];
        function projectSquare(lambda, phi) {
            var s = lambda > 0 ? -0.5 : 0.5, point = project(lambda + s * (0, _mathJs.pi), phi);
            point[0] -= s * dx;
            return point;
        }
        if (project.invert) projectSquare.invert = function(x, y) {
            var s = x > 0 ? -0.5 : 0.5, location = project.invert(x + s * dx, y), lambda = location[0] - s * (0, _mathJs.pi);
            if (lambda < -(0, _mathJs.pi)) lambda += 2 * (0, _mathJs.pi);
            else if (lambda > (0, _mathJs.pi)) lambda -= 2 * (0, _mathJs.pi);
            location[0] = lambda;
            return location;
        };
        return projectSquare;
    });
var _mathJs = require("./math.js");

},{"./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bxyzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "guyouRaw", ()=>guyouRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)((0, _squareJsDefault.default)(guyouRaw)).scale(151.496);
    });
var _d3Geo = require("d3-geo");
var _ellipticJs = require("./elliptic.js");
var _mathJs = require("./math.js");
var _squareJs = require("./square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
function guyouRaw(lambda, phi) {
    var k_ = ((0, _mathJs.sqrt2) - 1) / ((0, _mathJs.sqrt2) + 1), k = (0, _mathJs.sqrt)(1 - k_ * k_), K = (0, _ellipticJs.ellipticF)((0, _mathJs.halfPi), k * k), f = -1, psi = (0, _mathJs.log)((0, _mathJs.tan)((0, _mathJs.pi) / 4 + (0, _mathJs.abs)(phi) / 2)), r = (0, _mathJs.exp)(f * psi) / (0, _mathJs.sqrt)(k_), at = guyouComplexAtan(r * (0, _mathJs.cos)(f * lambda), r * (0, _mathJs.sin)(f * lambda)), t = (0, _ellipticJs.ellipticFi)(at[0], at[1], k * k);
    return [
        -t[1],
        (phi >= 0 ? 1 : -1) * (0.5 * K - t[0])
    ];
}
function guyouComplexAtan(x, y) {
    var x2 = x * x, y_1 = y + 1, t = 1 - x2 - y * y;
    return [
        0.5 * ((x >= 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi)) - (0, _mathJs.atan2)(t, 2 * x)),
        -0.25 * (0, _mathJs.log)(t * t + 4 * x2) + 0.5 * (0, _mathJs.log)(y_1 * y_1 + x2)
    ];
}
function guyouComplexDivide(a, b) {
    var denominator = b[0] * b[0] + b[1] * b[1];
    return [
        (a[0] * b[0] + a[1] * b[1]) / denominator,
        (a[1] * b[0] - a[0] * b[1]) / denominator
    ];
}
guyouRaw.invert = function(x, y) {
    var k_ = ((0, _mathJs.sqrt2) - 1) / ((0, _mathJs.sqrt2) + 1), k = (0, _mathJs.sqrt)(1 - k_ * k_), K = (0, _ellipticJs.ellipticF)((0, _mathJs.halfPi), k * k), f = -1, j = (0, _ellipticJs.ellipticJi)(0.5 * K - y, -x, k * k), tn = guyouComplexDivide(j[0], j[1]), lambda = (0, _mathJs.atan2)(tn[1], tn[0]) / f;
    return [
        lambda,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(0.5 / f * (0, _mathJs.log)(k_ * tn[0] * tn[0] + k_ * tn[1] * tn[1]))) - (0, _mathJs.halfPi)
    ];
};

},{"d3-geo":"hvz1M","./elliptic.js":"lSL0n","./math.js":"g023h","./square.js":"c381T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lSL0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Returns [sn, cn, dn](u + iv|m).
parcelHelpers.export(exports, "ellipticJi", ()=>ellipticJi);
// Returns [sn, cn, dn, ph](u|m).
parcelHelpers.export(exports, "ellipticJ", ()=>ellipticJ);
// Calculate F(phi+iPsi|m).
// See Abramowitz and Stegun, 17.4.11.
parcelHelpers.export(exports, "ellipticFi", ()=>ellipticFi);
// Calculate F(phi|m) where m = k² = sin²α.
// See Abramowitz and Stegun, 17.6.7.
parcelHelpers.export(exports, "ellipticF", ()=>ellipticF);
var _mathJs = require("./math.js");
function ellipticJi(u, v, m) {
    var a, b, c;
    if (!u) {
        b = ellipticJ(v, 1 - m);
        return [
            [
                0,
                b[0] / b[1]
            ],
            [
                1 / b[1],
                0
            ],
            [
                b[2] / b[1],
                0
            ]
        ];
    }
    a = ellipticJ(u, m);
    if (!v) return [
        [
            a[0],
            0
        ],
        [
            a[1],
            0
        ],
        [
            a[2],
            0
        ]
    ];
    b = ellipticJ(v, 1 - m);
    c = b[1] * b[1] + m * a[0] * a[0] * b[0] * b[0];
    return [
        [
            a[0] * b[2] / c,
            a[1] * a[2] * b[0] * b[1] / c
        ],
        [
            a[1] * b[1] / c,
            -a[0] * a[2] * b[0] * b[2] / c
        ],
        [
            a[2] * b[1] * b[2] / c,
            -m * a[0] * a[1] * b[0] / c
        ]
    ];
}
function ellipticJ(u, m) {
    var ai, b, phi, t, twon;
    if (m < (0, _mathJs.epsilon)) {
        t = (0, _mathJs.sin)(u);
        b = (0, _mathJs.cos)(u);
        ai = m * (u - t * b) / 4;
        return [
            t - ai * b,
            b + ai * t,
            1 - m * t * t / 2,
            u - ai
        ];
    }
    if (m >= 1 - (0, _mathJs.epsilon)) {
        ai = (1 - m) / 4;
        b = (0, _mathJs.cosh)(u);
        t = (0, _mathJs.tanh)(u);
        phi = 1 / b;
        twon = b * (0, _mathJs.sinh)(u);
        return [
            t + ai * (twon - u) / (b * b),
            phi - ai * t * phi * (twon - u),
            phi + ai * t * phi * (twon + u),
            2 * (0, _mathJs.atan)((0, _mathJs.exp)(u)) - (0, _mathJs.halfPi) + ai * (twon - u) / b
        ];
    }
    var a = [
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], c = [
        (0, _mathJs.sqrt)(m),
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], i = 0;
    b = (0, _mathJs.sqrt)(1 - m);
    twon = 1;
    while((0, _mathJs.abs)(c[i] / a[i]) > (0, _mathJs.epsilon) && i < 8){
        ai = a[i++];
        c[i] = (ai - b) / 2;
        a[i] = (ai + b) / 2;
        b = (0, _mathJs.sqrt)(ai * b);
        twon *= 2;
    }
    phi = twon * a[i] * u;
    do {
        t = c[i] * (0, _mathJs.sin)(b = phi) / a[i];
        phi = ((0, _mathJs.asin)(t) + phi) / 2;
    }while (--i);
    return [
        (0, _mathJs.sin)(phi),
        t = (0, _mathJs.cos)(phi),
        t / (0, _mathJs.cos)(phi - b),
        phi
    ];
}
function ellipticFi(phi, psi, m) {
    var r = (0, _mathJs.abs)(phi), i = (0, _mathJs.abs)(psi), sinhPsi = (0, _mathJs.sinh)(i);
    if (r) {
        var cscPhi = 1 / (0, _mathJs.sin)(r), cotPhi2 = 1 / ((0, _mathJs.tan)(r) * (0, _mathJs.tan)(r)), b = -(cotPhi2 + m * (sinhPsi * sinhPsi * cscPhi * cscPhi) - 1 + m), c = (m - 1) * cotPhi2, cotLambda2 = (-b + (0, _mathJs.sqrt)(b * b - 4 * c)) / 2;
        return [
            ellipticF((0, _mathJs.atan)(1 / (0, _mathJs.sqrt)(cotLambda2)), m) * (0, _mathJs.sign)(phi),
            ellipticF((0, _mathJs.atan)((0, _mathJs.sqrt)((cotLambda2 / cotPhi2 - 1) / m)), 1 - m) * (0, _mathJs.sign)(psi)
        ];
    }
    return [
        0,
        ellipticF((0, _mathJs.atan)(sinhPsi), 1 - m) * (0, _mathJs.sign)(psi)
    ];
}
function ellipticF(phi, m) {
    if (!m) return phi;
    if (m === 1) return (0, _mathJs.log)((0, _mathJs.tan)(phi / 2 + (0, _mathJs.quarterPi)));
    var a = 1, b = (0, _mathJs.sqrt)(1 - m), c = (0, _mathJs.sqrt)(m);
    for(var i = 0; (0, _mathJs.abs)(c) > (0, _mathJs.epsilon); i++){
        if (phi % (0, _mathJs.pi)) {
            var dPhi = (0, _mathJs.atan)(b * (0, _mathJs.tan)(phi) / a);
            if (dPhi < 0) dPhi += (0, _mathJs.pi);
            phi += dPhi + ~~(phi / (0, _mathJs.pi)) * (0, _mathJs.pi);
        } else phi += phi;
        c = (a + b) / 2;
        b = (0, _mathJs.sqrt)(a * b);
        c = ((a = c) - b) / 2;
    }
    return phi / ((0, _mathJs.pow)(2, i) * a);
}

},{"./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnB8U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hammerRetroazimuthalRaw", ()=>hammerRetroazimuthalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var phi0 = 0, m = (0, _d3Geo.geoProjectionMutator)(hammerRetroazimuthalRaw), p = m(phi0), rotate_ = p.rotate, stream_ = p.stream, circle = (0, _d3Geo.geoCircle)();
        p.parallel = function(_) {
            if (!arguments.length) return phi0 * (0, _mathJs.degrees);
            var r = p.rotate();
            return m(phi0 = _ * (0, _mathJs.radians)).rotate(r);
        };
        // Temporary hack; see hammerRetroazimuthalRotation.
        p.rotate = function(_) {
            if (!arguments.length) return _ = rotate_.call(p), _[1] += phi0 * (0, _mathJs.degrees), _;
            rotate_.call(p, [
                _[0],
                _[1] - phi0 * (0, _mathJs.degrees)
            ]);
            circle.center([
                -_[0],
                -_[1]
            ]);
            return p;
        };
        p.stream = function(stream) {
            stream = stream_(stream);
            stream.sphere = function() {
                stream.polygonStart();
                var epsilon = 1e-2, ring = circle.radius(90 - epsilon)().coordinates[0], n = ring.length - 1, i = -1, p;
                stream.lineStart();
                while(++i < n)stream.point((p = ring[i])[0], p[1]);
                stream.lineEnd();
                ring = circle.radius(90 + epsilon)().coordinates[0];
                n = ring.length - 1;
                stream.lineStart();
                while(--i >= 0)stream.point((p = ring[i])[0], p[1]);
                stream.lineEnd();
                stream.polygonEnd();
            };
            return stream;
        };
        return p.scale(79.4187).parallel(45).clipAngle(179.999);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function hammerRetroazimuthalRaw(phi0) {
    var sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0), rotate = hammerRetroazimuthalRotation(phi0);
    rotate.invert = hammerRetroazimuthalRotation(-phi0);
    function forward(lambda, phi) {
        var p = rotate(lambda, phi);
        lambda = p[0], phi = p[1];
        var sinPhi = (0, _mathJs.sin)(phi), cosPhi = (0, _mathJs.cos)(phi), cosLambda = (0, _mathJs.cos)(lambda), z = (0, _mathJs.acos)(sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosLambda), sinz = (0, _mathJs.sin)(z), K = (0, _mathJs.abs)(sinz) > (0, _mathJs.epsilon) ? z / sinz : 1;
        return [
            K * cosPhi0 * (0, _mathJs.sin)(lambda),
            ((0, _mathJs.abs)(lambda) > (0, _mathJs.halfPi) ? K : -K // rotate for back hemisphere
            ) * (sinPhi0 * cosPhi - cosPhi0 * sinPhi * cosLambda)
        ];
    }
    forward.invert = function(x, y) {
        var rho = (0, _mathJs.sqrt)(x * x + y * y), sinz = -(0, _mathJs.sin)(rho), cosz = (0, _mathJs.cos)(rho), a = rho * cosz, b = -y * sinz, c = rho * sinPhi0, d = (0, _mathJs.sqrt)(a * a + b * b - c * c), phi = (0, _mathJs.atan2)(a * c + b * d, b * c - a * d), lambda = (rho > (0, _mathJs.halfPi) ? -1 : 1) * (0, _mathJs.atan2)(x * sinz, rho * (0, _mathJs.cos)(phi) * cosz + y * (0, _mathJs.sin)(phi) * sinz);
        return rotate.invert(lambda, phi);
    };
    return forward;
}
// Latitudinal rotation by phi0.
// Temporary hack until D3 supports arbitrary small-circle clipping origins.
function hammerRetroazimuthalRotation(phi0) {
    var sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
    return function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi);
        return [
            (0, _mathJs.atan2)(y, x * cosPhi0 - z * sinPhi0),
            (0, _mathJs.asin)(z * cosPhi0 + x * sinPhi0)
        ];
    };
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"koVca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "healpixRaw", ()=>healpixRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var H = 4, m = (0, _d3Geo.geoProjectionMutator)(healpixRaw), p = m(H), stream_ = p.stream;
        p.lobes = function(_) {
            return arguments.length ? m(H = +_) : H;
        };
        p.stream = function(stream) {
            var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([
                0,
                0
            ]), stream_(stream));
            p.rotate(rotate);
            rotateStream.sphere = function() {
                (0, _d3Geo.geoStream)(sphere(180 / H), sphereStream);
            };
            return rotateStream;
        };
        return p.scale(239.75);
    });
var _d3Array = require("d3-array");
var _d3Geo = require("d3-geo");
var _collignonJs = require("./collignon.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
var _mathJs = require("./math.js");
var K = 3, healpixParallel = (0, _mathJs.asin)(1 - 1 / K) * (0, _mathJs.degrees), healpixLambert = (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(0);
function healpixRaw(H) {
    var phi0 = healpixParallel * (0, _mathJs.radians), dx = (0, _collignonJs.collignonRaw)((0, _mathJs.pi), phi0)[0] - (0, _collignonJs.collignonRaw)(-(0, _mathJs.pi), phi0)[0], y0 = healpixLambert(0, phi0)[1], y1 = (0, _collignonJs.collignonRaw)(0, phi0)[1], dy1 = (0, _mathJs.sqrtPi) - y1, k = (0, _mathJs.tau) / H, w = 4 / (0, _mathJs.tau), h = y0 + dy1 * dy1 * 4 / (0, _mathJs.tau);
    function forward(lambda, phi) {
        var point, phi2 = (0, _mathJs.abs)(phi);
        if (phi2 > phi0) {
            var i = (0, _mathJs.min)(H - 1, (0, _mathJs.max)(0, (0, _mathJs.floor)((lambda + (0, _mathJs.pi)) / k)));
            lambda += (0, _mathJs.pi) * (H - 1) / H - i * k;
            point = (0, _collignonJs.collignonRaw)(lambda, phi2);
            point[0] = point[0] * (0, _mathJs.tau) / dx - (0, _mathJs.tau) * (H - 1) / (2 * H) + i * (0, _mathJs.tau) / H;
            point[1] = y0 + (point[1] - y1) * 4 * dy1 / (0, _mathJs.tau);
            if (phi < 0) point[1] = -point[1];
        } else point = healpixLambert(lambda, phi);
        point[0] *= w, point[1] /= h;
        return point;
    }
    forward.invert = function(x, y) {
        x /= w, y *= h;
        var y2 = (0, _mathJs.abs)(y);
        if (y2 > y0) {
            var i = (0, _mathJs.min)(H - 1, (0, _mathJs.max)(0, (0, _mathJs.floor)((x + (0, _mathJs.pi)) / k)));
            x = (x + (0, _mathJs.pi) * (H - 1) / H - i * k) * dx / (0, _mathJs.tau);
            var point = (0, _collignonJs.collignonRaw).invert(x, 0.25 * (y2 - y0) * (0, _mathJs.tau) / dy1 + y1);
            point[0] -= (0, _mathJs.pi) * (H - 1) / H - i * k;
            if (y < 0) point[1] = -point[1];
            return point;
        }
        return healpixLambert.invert(x, y);
    };
    return forward;
}
function sphereTop(x, i) {
    return [
        x,
        i & 1 ? 90 - (0, _mathJs.epsilon) : healpixParallel
    ];
}
function sphereBottom(x, i) {
    return [
        x,
        i & 1 ? -90 + (0, _mathJs.epsilon) : -healpixParallel
    ];
}
function sphereNudge(d) {
    return [
        d[0] * (1 - (0, _mathJs.epsilon)),
        d[1]
    ];
}
function sphere(step) {
    var c = [].concat((0, _d3Array.range)(-180, 180 + step / 2, step).map(sphereTop), (0, _d3Array.range)(180, -180 - step / 2, -step).map(sphereBottom));
    return {
        type: "Polygon",
        coordinates: [
            step === 180 ? c.map(sphereNudge) : c
        ]
    };
}

},{"d3-array":"4pSqo","d3-geo":"hvz1M","./collignon.js":"94537","./cylindricalEqualArea.js":"d3E2z","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gFFQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hillRaw", ()=>hillRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var K = 1, m = (0, _d3Geo.geoProjectionMutator)(hillRaw), p = m(K);
        p.ratio = function(_) {
            return arguments.length ? m(K = +_) : K;
        };
        return p.scale(167.774).center([
            0,
            18.67
        ]);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function hillRaw(K) {
    var L = 1 + K, sinBt = (0, _mathJs.sin)(1 / L), Bt = (0, _mathJs.asin)(sinBt), A = 2 * (0, _mathJs.sqrt)((0, _mathJs.pi) / (B = (0, _mathJs.pi) + 4 * Bt * L)), B, rho0 = 0.5 * A * (L + (0, _mathJs.sqrt)(K * (2 + K))), K2 = K * K, L2 = L * L;
    function forward(lambda, phi) {
        var t = 1 - (0, _mathJs.sin)(phi), rho, omega;
        if (t && t < 2) {
            var theta = (0, _mathJs.halfPi) - phi, i = 25, delta;
            do {
                var sinTheta = (0, _mathJs.sin)(theta), cosTheta = (0, _mathJs.cos)(theta), Bt_Bt1 = Bt + (0, _mathJs.atan2)(sinTheta, L - cosTheta), C = 1 + L2 - 2 * L * cosTheta;
                theta -= delta = (theta - K2 * Bt - L * sinTheta + C * Bt_Bt1 - 0.5 * t * B) / (2 * L * sinTheta * Bt_Bt1);
            }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon2) && --i > 0);
            rho = A * (0, _mathJs.sqrt)(C);
            omega = lambda * Bt_Bt1 / (0, _mathJs.pi);
        } else {
            rho = A * (K + t);
            omega = lambda * Bt / (0, _mathJs.pi);
        }
        return [
            rho * (0, _mathJs.sin)(omega),
            rho0 - rho * (0, _mathJs.cos)(omega)
        ];
    }
    forward.invert = function(x, y) {
        var rho2 = x * x + (y -= rho0) * y, cosTheta = (1 + L2 - rho2 / (A * A)) / (2 * L), theta = (0, _mathJs.acos)(cosTheta), sinTheta = (0, _mathJs.sin)(theta), Bt_Bt1 = Bt + (0, _mathJs.atan2)(sinTheta, L - cosTheta);
        return [
            (0, _mathJs.asin)(x / (0, _mathJs.sqrt)(rho2)) * (0, _mathJs.pi) / Bt_Bt1,
            (0, _mathJs.asin)(1 - 2 * (theta - K2 * Bt - L * sinTheta + (1 + L2 - 2 * L * cosTheta) * Bt_Bt1) / B)
        ];
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gQeQn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "homolosineRaw", ()=>homolosineRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(homolosineRaw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _mollweideJs = require("./mollweide.js");
var _sinusoidalJs = require("./sinusoidal.js");
var _sinuMollweideJs = require("./sinuMollweide.js");
function homolosineRaw(lambda, phi) {
    return (0, _mathJs.abs)(phi) > (0, _sinuMollweideJs.sinuMollweidePhi) ? (lambda = (0, _mollweideJs.mollweideRaw)(lambda, phi), lambda[1] -= phi > 0 ? (0, _sinuMollweideJs.sinuMollweideY) : -(0, _sinuMollweideJs.sinuMollweideY), lambda) : (0, _sinusoidalJs.sinusoidalRaw)(lambda, phi);
}
homolosineRaw.invert = function(x, y) {
    return (0, _mathJs.abs)(y) > (0, _sinuMollweideJs.sinuMollweidePhi) ? (0, _mollweideJs.mollweideRaw).invert(x, y + (y > 0 ? (0, _sinuMollweideJs.sinuMollweideY) : -(0, _sinuMollweideJs.sinuMollweideY))) : (0, _sinusoidalJs.sinusoidalRaw).invert(x, y);
};

},{"d3-geo":"hvz1M","./math.js":"g023h","./mollweide.js":"4WAID","./sinusoidal.js":"aqIah","./sinuMollweide.js":"9rTuc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9rTuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinuMollweidePhi", ()=>sinuMollweidePhi);
parcelHelpers.export(exports, "sinuMollweideY", ()=>sinuMollweideY);
parcelHelpers.export(exports, "sinuMollweideRaw", ()=>sinuMollweideRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(sinuMollweideRaw).rotate([
            -20,
            -55
        ]).scale(164.263).center([
            0,
            -5.4036
        ]);
    });
var _d3Geo = require("d3-geo");
var _mollweideJs = require("./mollweide.js");
var _sinusoidalJs = require("./sinusoidal.js");
var sinuMollweidePhi = 0.7109889596207567;
var sinuMollweideY = 0.0528035274542;
function sinuMollweideRaw(lambda, phi) {
    return phi > -sinuMollweidePhi ? (lambda = (0, _mollweideJs.mollweideRaw)(lambda, phi), lambda[1] += sinuMollweideY, lambda) : (0, _sinusoidalJs.sinusoidalRaw)(lambda, phi);
}
sinuMollweideRaw.invert = function(x, y) {
    return y > -sinuMollweidePhi ? (0, _mollweideJs.mollweideRaw).invert(x, y - sinuMollweideY) : (0, _sinusoidalJs.sinusoidalRaw).invert(x, y);
};

},{"d3-geo":"hvz1M","./mollweide.js":"4WAID","./sinusoidal.js":"aqIah","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c5jMT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hufnagelRaw", ()=>hufnagelRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var a = 1, b = 0, psiMax = 45 * (0, _mathJs.radians), ratio = 2, mutate = (0, _d3Geo.geoProjectionMutator)(hufnagelRaw), projection = mutate(a, b, psiMax, ratio);
        projection.a = function(_) {
            return arguments.length ? mutate(a = +_, b, psiMax, ratio) : a;
        };
        projection.b = function(_) {
            return arguments.length ? mutate(a, b = +_, psiMax, ratio) : b;
        };
        projection.psiMax = function(_) {
            return arguments.length ? mutate(a, b, psiMax = +_ * (0, _mathJs.radians), ratio) : psiMax * (0, _mathJs.degrees);
        };
        projection.ratio = function(_) {
            return arguments.length ? mutate(a, b, psiMax, ratio = +_) : ratio;
        };
        return projection.scale(180.739);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _newtonJs = require("./newton.js");
function hufnagelRaw(a, b, psiMax, ratio) {
    var k = (0, _mathJs.sqrt)(4 * (0, _mathJs.pi) / (2 * psiMax + (1 + a - b / 2) * (0, _mathJs.sin)(2 * psiMax) + (a + b) / 2 * (0, _mathJs.sin)(4 * psiMax) + b / 2 * (0, _mathJs.sin)(6 * psiMax))), c = (0, _mathJs.sqrt)(ratio * (0, _mathJs.sin)(psiMax) * (0, _mathJs.sqrt)((1 + a * (0, _mathJs.cos)(2 * psiMax) + b * (0, _mathJs.cos)(4 * psiMax)) / (1 + a + b))), M = psiMax * mapping(1);
    function radius(psi) {
        return (0, _mathJs.sqrt)(1 + a * (0, _mathJs.cos)(2 * psi) + b * (0, _mathJs.cos)(4 * psi));
    }
    function mapping(t) {
        var psi = t * psiMax;
        return (2 * psi + (1 + a - b / 2) * (0, _mathJs.sin)(2 * psi) + (a + b) / 2 * (0, _mathJs.sin)(4 * psi) + b / 2 * (0, _mathJs.sin)(6 * psi)) / psiMax;
    }
    function inversemapping(psi) {
        return radius(psi) * (0, _mathJs.sin)(psi);
    }
    var forward = function(lambda, phi) {
        var psi = psiMax * (0, _newtonJs.solve)(mapping, M * (0, _mathJs.sin)(phi) / psiMax, phi / (0, _mathJs.pi));
        if (isNaN(psi)) psi = psiMax * (0, _mathJs.sign)(phi);
        var kr = k * radius(psi);
        return [
            kr * c * lambda / (0, _mathJs.pi) * (0, _mathJs.cos)(psi),
            kr / c * (0, _mathJs.sin)(psi)
        ];
    };
    forward.invert = function(x, y) {
        var psi = (0, _newtonJs.solve)(inversemapping, y * c / k);
        return [
            x * (0, _mathJs.pi) / ((0, _mathJs.cos)(psi) * k * c * radius(psi)),
            (0, _mathJs.asin)(psiMax * mapping(psi / psiMax) / M)
        ];
    };
    if (psiMax === 0) {
        k = (0, _mathJs.sqrt)(ratio / (0, _mathJs.pi));
        forward = function(lambda, phi) {
            return [
                lambda * k,
                (0, _mathJs.sin)(phi) / k
            ];
        };
        forward.invert = function(x, y) {
            return [
                x / k,
                (0, _mathJs.asin)(y * k)
            ];
        };
    }
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./newton.js":"6xPTk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dHCqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hyperellipticalRaw", ()=>hyperellipticalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var alpha = 0, k = 2.5, gamma = 1.183136, m = (0, _d3Geo.geoProjectionMutator)(hyperellipticalRaw), p = m(alpha, k, gamma);
        p.alpha = function(_) {
            return arguments.length ? m(alpha = +_, k, gamma) : alpha;
        };
        p.k = function(_) {
            return arguments.length ? m(alpha, k = +_, gamma) : k;
        };
        p.gamma = function(_) {
            return arguments.length ? m(alpha, k, gamma = +_) : gamma;
        };
        return p.scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _integrateJs = require("./integrate.js");
function hyperellipticalRaw(alpha, k, gamma) {
    function elliptic(f) {
        return alpha + (1 - alpha) * (0, _mathJs.pow)(1 - (0, _mathJs.pow)(f, k), 1 / k);
    }
    function z(f) {
        return (0, _integrateJs.integrate)(elliptic, 0, f, 1e-4);
    }
    var G = 1 / z(1), n = 1000, m = (1 + 1e-8) * G, approx = [];
    for(var i = 0; i <= n; i++)approx.push(z(i / n) * m);
    function Y(sinphi) {
        var rmin = 0, rmax = n, r = n >> 1;
        do {
            if (approx[r] > sinphi) rmax = r;
            else rmin = r;
            r = rmin + rmax >> 1;
        }while (r > rmin);
        var u = approx[r + 1] - approx[r];
        if (u) u = (sinphi - approx[r + 1]) / u;
        return (r + 1 + u) / n;
    }
    var ratio = 2 * Y(1) / (0, _mathJs.pi) * G / gamma;
    var forward = function(lambda, phi) {
        var y = Y((0, _mathJs.abs)((0, _mathJs.sin)(phi))), x = elliptic(y) * lambda;
        y /= ratio;
        return [
            x,
            phi >= 0 ? y : -y
        ];
    };
    forward.invert = function(x, y) {
        var phi;
        y *= ratio;
        if ((0, _mathJs.abs)(y) < 1) phi = (0, _mathJs.sign)(y) * (0, _mathJs.asin)(z((0, _mathJs.abs)(y)) * G);
        return [
            x / elliptic((0, _mathJs.abs)(y)),
            phi
        ];
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./integrate.js":"h80PB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h80PB":[function(require,module,exports,__globalThis) {
// https://github.com/scijs/integrate-adaptive-simpson
// This algorithm adapted from pseudocode in:
// http://www.math.utk.edu/~ccollins/refs/Handouts/rich.pdf
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "integrate", ()=>integrate);
function adsimp(f, a, b, fa, fm, fb, V0, tol, maxdepth, depth, state) {
    if (state.nanEncountered) return NaN;
    var h, f1, f2, sl, sr, s2, m, V1, V2, err;
    h = b - a;
    f1 = f(a + h * 0.25);
    f2 = f(b - h * 0.25);
    // Simple check for NaN:
    if (isNaN(f1)) {
        state.nanEncountered = true;
        return;
    }
    // Simple check for NaN:
    if (isNaN(f2)) {
        state.nanEncountered = true;
        return;
    }
    sl = h * (fa + 4 * f1 + fm) / 12;
    sr = h * (fm + 4 * f2 + fb) / 12;
    s2 = sl + sr;
    err = (s2 - V0) / 15;
    if (depth > maxdepth) {
        state.maxDepthCount++;
        return s2 + err;
    } else if (Math.abs(err) < tol) return s2 + err;
    else {
        m = a + h * 0.5;
        V1 = adsimp(f, a, m, fa, f1, fm, sl, tol * 0.5, maxdepth, depth + 1, state);
        if (isNaN(V1)) {
            state.nanEncountered = true;
            return NaN;
        }
        V2 = adsimp(f, m, b, fm, f2, fb, sr, tol * 0.5, maxdepth, depth + 1, state);
        if (isNaN(V2)) {
            state.nanEncountered = true;
            return NaN;
        }
        return V1 + V2;
    }
}
function integrate(f, a, b, tol, maxdepth) {
    var state = {
        maxDepthCount: 0,
        nanEncountered: false
    };
    if (tol === undefined) tol = 1e-8;
    if (maxdepth === undefined) maxdepth = 20;
    var fa = f(a);
    var fm = f(0.5 * (a + b));
    var fb = f(b);
    var V0 = (fa + 4 * fm + fb) * (b - a) / 6;
    var result = adsimp(f, a, b, fa, fm, fb, V0, tol, maxdepth, 1, state);
    /*
  if (state.maxDepthCount > 0 && console && console.warn) {
    console.warn('integrate-adaptive-simpson: Warning: maximum recursion depth (' + maxdepth + ') reached ' + state.maxDepthCount + ' times');
  }

  if (state.nanEncountered && console && console.warn) {
    console.warn('integrate-adaptive-simpson: Warning: NaN encountered. Halting early.');
  }
*/ return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3s0h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, lobes, inverse) {
        var sphere, bounds;
        function forward(lambda, phi) {
            var sign = phi < 0 ? -1 : 1, lobe = lobes[+(phi < 0)];
            for(var i = 0, n = lobe.length - 1; i < n && lambda > lobe[i][2][0]; ++i);
            var p = project(lambda - lobe[i][1][0], phi);
            p[0] += project(lobe[i][1][0], sign * phi > sign * lobe[i][0][1] ? lobe[i][0][1] : phi)[0];
            return p;
        }
        if (inverse) forward.invert = inverse(forward);
        else if (project.invert) forward.invert = function(x, y) {
            var bound = bounds[+(y < 0)], lobe = lobes[+(y < 0)];
            for(var i = 0, n = bound.length; i < n; ++i){
                var b = bound[i];
                if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
                    var p = project.invert(x - project(lobe[i][1][0], 0)[0], y);
                    p[0] += lobe[i][1][0];
                    return pointEqual(forward(p[0], p[1]), [
                        x,
                        y
                    ]) ? p : null;
                }
            }
        };
        var p = (0, _d3Geo.geoProjection)(forward), stream_ = p.stream;
        p.stream = function(stream) {
            var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([
                0,
                0
            ]), stream_(stream));
            p.rotate(rotate);
            rotateStream.sphere = function() {
                (0, _d3Geo.geoStream)(sphere, sphereStream);
            };
            return rotateStream;
        };
        p.lobes = function(_) {
            if (!arguments.length) return lobes.map(function(lobe) {
                return lobe.map(function(l) {
                    return [
                        [
                            l[0][0] * (0, _mathJs.degrees),
                            l[0][1] * (0, _mathJs.degrees)
                        ],
                        [
                            l[1][0] * (0, _mathJs.degrees),
                            l[1][1] * (0, _mathJs.degrees)
                        ],
                        [
                            l[2][0] * (0, _mathJs.degrees),
                            l[2][1] * (0, _mathJs.degrees)
                        ]
                    ];
                });
            });
            sphere = interpolateSphere(_);
            lobes = _.map(function(lobe) {
                return lobe.map(function(l) {
                    return [
                        [
                            l[0][0] * (0, _mathJs.radians),
                            l[0][1] * (0, _mathJs.radians)
                        ],
                        [
                            l[1][0] * (0, _mathJs.radians),
                            l[1][1] * (0, _mathJs.radians)
                        ],
                        [
                            l[2][0] * (0, _mathJs.radians),
                            l[2][1] * (0, _mathJs.radians)
                        ]
                    ];
                });
            });
            bounds = lobes.map(function(lobe) {
                return lobe.map(function(l) {
                    var x0 = project(l[0][0], l[0][1])[0], x1 = project(l[2][0], l[2][1])[0], y0 = project(l[1][0], l[0][1])[1], y1 = project(l[1][0], l[1][1])[1], t;
                    if (y0 > y1) t = y0, y0 = y1, y1 = t;
                    return [
                        [
                            x0,
                            y0
                        ],
                        [
                            x1,
                            y1
                        ]
                    ];
                });
            });
            return p;
        };
        if (lobes != null) p.lobes(lobes);
        return p;
    });
var _d3Array = require("d3-array");
var _d3Geo = require("d3-geo");
var _mathJs = require("../math.js");
function pointEqual(a, b) {
    return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
}
function interpolateLine(coordinates, m) {
    var i = -1, n = coordinates.length, p0 = coordinates[0], p1, dx, dy, resampled = [];
    while(++i < n){
        p1 = coordinates[i];
        dx = (p1[0] - p0[0]) / m;
        dy = (p1[1] - p0[1]) / m;
        for(var j = 0; j < m; ++j)resampled.push([
            p0[0] + j * dx,
            p0[1] + j * dy
        ]);
        p0 = p1;
    }
    resampled.push(p1);
    return resampled;
}
function interpolateSphere(lobes) {
    var coordinates = [], lobe, lambda0, phi0, phi1, lambda2, phi2, i, n = lobes[0].length;
    // Northern Hemisphere
    for(i = 0; i < n; ++i){
        lobe = lobes[0][i];
        lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
        lambda2 = lobe[2][0], phi2 = lobe[2][1];
        coordinates.push(interpolateLine([
            [
                lambda0 + (0, _mathJs.epsilon),
                phi0 + (0, _mathJs.epsilon)
            ],
            [
                lambda0 + (0, _mathJs.epsilon),
                phi1 - (0, _mathJs.epsilon)
            ],
            [
                lambda2 - (0, _mathJs.epsilon),
                phi1 - (0, _mathJs.epsilon)
            ],
            [
                lambda2 - (0, _mathJs.epsilon),
                phi2 + (0, _mathJs.epsilon)
            ]
        ], 30));
    }
    // Southern Hemisphere
    for(i = lobes[1].length - 1; i >= 0; --i){
        lobe = lobes[1][i];
        lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
        lambda2 = lobe[2][0], phi2 = lobe[2][1];
        coordinates.push(interpolateLine([
            [
                lambda2 - (0, _mathJs.epsilon),
                phi2 - (0, _mathJs.epsilon)
            ],
            [
                lambda2 - (0, _mathJs.epsilon),
                phi1 + (0, _mathJs.epsilon)
            ],
            [
                lambda0 + (0, _mathJs.epsilon),
                phi1 + (0, _mathJs.epsilon)
            ],
            [
                lambda0 + (0, _mathJs.epsilon),
                phi0 - (0, _mathJs.epsilon)
            ]
        ], 30));
    }
    return {
        type: "Polygon",
        coordinates: [
            (0, _d3Array.merge)(coordinates)
        ]
    };
}

},{"d3-array":"4pSqo","d3-geo":"hvz1M","../math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"809cn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _boggsJs.boggsRaw), lobes).scale(160.857);
    });
var _boggsJs = require("../boggs.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var lobes = [
    [
        [
            [
                -180,
                0
            ],
            [
                -100,
                90
            ],
            [
                -40,
                0
            ]
        ],
        [
            [
                -40,
                0
            ],
            [
                30,
                90
            ],
            [
                180,
                0
            ]
        ]
    ],
    [
        [
            [
                -180,
                0
            ],
            [
                -160,
                -90
            ],
            [
                -100,
                0
            ]
        ],
        [
            [
                -100,
                0
            ],
            [
                -60,
                -90
            ],
            [
                -20,
                0
            ]
        ],
        [
            [
                -20,
                0
            ],
            [
                20,
                -90
            ],
            [
                80,
                0
            ]
        ],
        [
            [
                80,
                0
            ],
            [
                140,
                -90
            ],
            [
                180,
                0
            ]
        ]
    ]
];

},{"../boggs.js":"87pEy","./index.js":"a3s0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cAU8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _homolosineJs.homolosineRaw), lobes).scale(152.63);
    });
var _homolosineJs = require("../homolosine.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var lobes = [
    [
        [
            [
                -180,
                0
            ],
            [
                -100,
                90
            ],
            [
                -40,
                0
            ]
        ],
        [
            [
                -40,
                0
            ],
            [
                30,
                90
            ],
            [
                180,
                0
            ]
        ]
    ],
    [
        [
            [
                -180,
                0
            ],
            [
                -160,
                -90
            ],
            [
                -100,
                0
            ]
        ],
        [
            [
                -100,
                0
            ],
            [
                -60,
                -90
            ],
            [
                -20,
                0
            ]
        ],
        [
            [
                -20,
                0
            ],
            [
                20,
                -90
            ],
            [
                80,
                0
            ]
        ],
        [
            [
                80,
                0
            ],
            [
                140,
                -90
            ],
            [
                180,
                0
            ]
        ]
    ]
];

},{"../homolosine.js":"gQeQn","./index.js":"a3s0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bfFEj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _mollweideJs.mollweideRaw), lobes).scale(169.529);
    });
var _mollweideJs = require("../mollweide.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var lobes = [
    [
        [
            [
                -180,
                0
            ],
            [
                -100,
                90
            ],
            [
                -40,
                0
            ]
        ],
        [
            [
                -40,
                0
            ],
            [
                30,
                90
            ],
            [
                180,
                0
            ]
        ]
    ],
    [
        [
            [
                -180,
                0
            ],
            [
                -160,
                -90
            ],
            [
                -100,
                0
            ]
        ],
        [
            [
                -100,
                0
            ],
            [
                -60,
                -90
            ],
            [
                -20,
                0
            ]
        ],
        [
            [
                -20,
                0
            ],
            [
                20,
                -90
            ],
            [
                80,
                0
            ]
        ],
        [
            [
                80,
                0
            ],
            [
                140,
                -90
            ],
            [
                180,
                0
            ]
        ]
    ]
];

},{"../mollweide.js":"4WAID","./index.js":"a3s0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89H7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _mollweideJs.mollweideRaw), lobes).scale(169.529).rotate([
            20,
            0
        ]);
    });
var _mollweideJs = require("../mollweide.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var lobes = [
    [
        [
            [
                -180,
                0
            ],
            [
                -90,
                90
            ],
            [
                0,
                0
            ]
        ],
        [
            [
                0,
                0
            ],
            [
                90,
                90
            ],
            [
                180,
                0
            ]
        ]
    ],
    [
        [
            [
                -180,
                0
            ],
            [
                -90,
                -90
            ],
            [
                0,
                0
            ]
        ],
        [
            [
                0,
                0
            ],
            [
                90,
                -90
            ],
            [
                180,
                0
            ]
        ]
    ]
];

},{"../mollweide.js":"4WAID","./index.js":"a3s0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ZUnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _sinuMollweideJs.sinuMollweideRaw), lobes, (0, _newtonJs.solve2d)).rotate([
            -20,
            -55
        ]).scale(164.263).center([
            0,
            -5.4036
        ]);
    });
var _sinuMollweideJs = require("../sinuMollweide.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _newtonJs = require("../newton.js");
var lobes = [
    [
        [
            [
                -180,
                35
            ],
            [
                -30,
                90
            ],
            [
                0,
                35
            ]
        ],
        [
            [
                0,
                35
            ],
            [
                30,
                90
            ],
            [
                180,
                35
            ]
        ]
    ],
    [
        [
            [
                -180,
                -10
            ],
            [
                -102,
                -90
            ],
            [
                -65,
                -10
            ]
        ],
        [
            [
                -65,
                -10
            ],
            [
                5,
                -90
            ],
            [
                77,
                -10
            ]
        ],
        [
            [
                77,
                -10
            ],
            [
                103,
                -90
            ],
            [
                180,
                -10
            ]
        ]
    ]
];

},{"../sinuMollweide.js":"9rTuc","./index.js":"a3s0h","../newton.js":"6xPTk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e7mvK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _sinusoidalJs.sinusoidalRaw), lobes).scale(152.63).rotate([
            -20,
            0
        ]);
    });
var _sinusoidalJs = require("../sinusoidal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var lobes = [
    [
        [
            [
                -180,
                0
            ],
            [
                -110,
                90
            ],
            [
                -40,
                0
            ]
        ],
        [
            [
                -40,
                0
            ],
            [
                0,
                90
            ],
            [
                40,
                0
            ]
        ],
        [
            [
                40,
                0
            ],
            [
                110,
                90
            ],
            [
                180,
                0
            ]
        ]
    ],
    [
        [
            [
                -180,
                0
            ],
            [
                -110,
                -90
            ],
            [
                -40,
                0
            ]
        ],
        [
            [
                -40,
                0
            ],
            [
                0,
                -90
            ],
            [
                40,
                0
            ]
        ],
        [
            [
                40,
                0
            ],
            [
                110,
                -90
            ],
            [
                180,
                0
            ]
        ]
    ]
];

},{"../sinusoidal.js":"aqIah","./index.js":"a3s0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"33iOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "kavrayskiy7Raw", ()=>kavrayskiy7Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(kavrayskiy7Raw).scale(158.837);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function kavrayskiy7Raw(lambda, phi) {
    return [
        3 / (0, _mathJs.tau) * lambda * (0, _mathJs.sqrt)((0, _mathJs.pi) * (0, _mathJs.pi) / 3 - phi * phi),
        phi
    ];
}
kavrayskiy7Raw.invert = function(x, y) {
    return [
        (0, _mathJs.tau) / 3 * x / (0, _mathJs.sqrt)((0, _mathJs.pi) * (0, _mathJs.pi) / 3 - y * y),
        y
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1kZI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lagrangeRaw", ()=>lagrangeRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var n = 0.5, m = (0, _d3Geo.geoProjectionMutator)(lagrangeRaw), p = m(n);
        p.spacing = function(_) {
            return arguments.length ? m(n = +_) : n;
        };
        return p.scale(124.75);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function lagrangeRaw(n) {
    function forward(lambda, phi) {
        if ((0, _mathJs.abs)((0, _mathJs.abs)(phi) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon)) return [
            0,
            phi < 0 ? -2 : 2
        ];
        var sinPhi = (0, _mathJs.sin)(phi), v = (0, _mathJs.pow)((1 + sinPhi) / (1 - sinPhi), n / 2), c = 0.5 * (v + 1 / v) + (0, _mathJs.cos)(lambda *= n);
        return [
            2 * (0, _mathJs.sin)(lambda) / c,
            (v - 1 / v) / c
        ];
    }
    forward.invert = function(x, y) {
        var y0 = (0, _mathJs.abs)(y);
        if ((0, _mathJs.abs)(y0 - 2) < (0, _mathJs.epsilon)) return x ? null : [
            0,
            (0, _mathJs.sign)(y) * (0, _mathJs.halfPi)
        ];
        if (y0 > 2) return null;
        x /= 2, y /= 2;
        var x2 = x * x, y2 = y * y, t = 2 * y / (1 + x2 + y2); // tanh(nPhi)
        t = (0, _mathJs.pow)((1 + t) / (1 - t), 1 / n);
        return [
            (0, _mathJs.atan2)(2 * x, 1 - x2 - y2) / n,
            (0, _mathJs.asin)((t - 1) / (t + 1))
        ];
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1IEHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "larriveeRaw", ()=>larriveeRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(larriveeRaw).scale(97.2672);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var pi_sqrt2 = (0, _mathJs.pi) / (0, _mathJs.sqrt2);
function larriveeRaw(lambda, phi) {
    return [
        lambda * (1 + (0, _mathJs.sqrt)((0, _mathJs.cos)(phi))) / 2,
        phi / ((0, _mathJs.cos)(phi / 2) * (0, _mathJs.cos)(lambda / 6))
    ];
}
larriveeRaw.invert = function(x, y) {
    var x0 = (0, _mathJs.abs)(x), y0 = (0, _mathJs.abs)(y), lambda = (0, _mathJs.epsilon), phi = (0, _mathJs.halfPi);
    if (y0 < pi_sqrt2) phi *= y0 / pi_sqrt2;
    else lambda += 6 * (0, _mathJs.acos)(pi_sqrt2 / y0);
    for(var i = 0; i < 25; i++){
        var sinPhi = (0, _mathJs.sin)(phi), sqrtcosPhi = (0, _mathJs.sqrt)((0, _mathJs.cos)(phi)), sinPhi_2 = (0, _mathJs.sin)(phi / 2), cosPhi_2 = (0, _mathJs.cos)(phi / 2), sinLambda_6 = (0, _mathJs.sin)(lambda / 6), cosLambda_6 = (0, _mathJs.cos)(lambda / 6), f0 = 0.5 * lambda * (1 + sqrtcosPhi) - x0, f1 = phi / (cosPhi_2 * cosLambda_6) - y0, df0dPhi = sqrtcosPhi ? -0.25 * lambda * sinPhi / sqrtcosPhi : 0, df0dLambda = 0.5 * (1 + sqrtcosPhi), df1dPhi = (1 + 0.5 * phi * sinPhi_2 / cosPhi_2) / (cosPhi_2 * cosLambda_6), df1dLambda = phi / cosPhi_2 * (sinLambda_6 / 6) / (cosLambda_6 * cosLambda_6), denom = df0dPhi * df1dLambda - df1dPhi * df0dLambda, dPhi = (f0 * df1dLambda - f1 * df0dLambda) / denom, dLambda = (f1 * df0dPhi - f0 * df1dPhi) / denom;
        phi -= dPhi;
        lambda -= dLambda;
        if ((0, _mathJs.abs)(dPhi) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(dLambda) < (0, _mathJs.epsilon)) break;
    }
    return [
        x < 0 ? -lambda : lambda,
        y < 0 ? -phi : phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aC68x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "laskowskiRaw", ()=>laskowskiRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(laskowskiRaw).scale(139.98);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function laskowskiRaw(lambda, phi) {
    var lambda2 = lambda * lambda, phi2 = phi * phi;
    return [
        lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)),
        phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032))
    ];
}
laskowskiRaw.invert = function(x, y) {
    var lambda = (0, _mathJs.sign)(x) * (0, _mathJs.pi), phi = y / 2, i = 50;
    do {
        var lambda2 = lambda * lambda, phi2 = phi * phi, lambdaPhi = lambda * phi, fx = lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)) - x, fy = phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032)) - y, deltaxDeltaLambda = 0.975534 - phi2 * (0.119161 + 3 * lambda2 * 0.0143059 + phi2 * 0.0547009), deltaxDeltaPhi = -lambdaPhi * (0.238322 + 0.2188036 * phi2 + 0.0286118 * lambda2), deltayDeltaLambda = lambdaPhi * (0.1605788 + 0.0007961 * lambda2 + -0.0571 * phi2), deltayDeltaPhi = 1.00384 + lambda2 * (0.0802894 + 0.000199025 * lambda2) + phi2 * (3 * (0.0998909 - 0.02855 * lambda2) - 0.245516 * phi2), denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda, deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator, deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
        lambda -= deltaLambda, phi -= deltaPhi;
    }while (((0, _mathJs.abs)(deltaLambda) > (0, _mathJs.epsilon) || (0, _mathJs.abs)(deltaPhi) > (0, _mathJs.epsilon)) && --i > 0);
    return i && [
        lambda,
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3M31o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "littrowRaw", ()=>littrowRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(littrowRaw).scale(144.049).clipAngle(89.999);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function littrowRaw(lambda, phi) {
    return [
        (0, _mathJs.sin)(lambda) / (0, _mathJs.cos)(phi),
        (0, _mathJs.tan)(phi) * (0, _mathJs.cos)(lambda)
    ];
}
littrowRaw.invert = function(x, y) {
    var x2 = x * x, y2 = y * y, y2_1 = y2 + 1, x2_y2_1 = x2 + y2_1, cosPhi = x ? (0, _mathJs.sqrt1_2) * (0, _mathJs.sqrt)((x2_y2_1 - (0, _mathJs.sqrt)(x2_y2_1 * x2_y2_1 - 4 * x2)) / x2) : 1 / (0, _mathJs.sqrt)(y2_1);
    return [
        (0, _mathJs.asin)(x * cosPhi),
        (0, _mathJs.sign)(y) * (0, _mathJs.acos)(cosPhi)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jyDjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loximuthalRaw", ()=>loximuthalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _parallel1JsDefault.default)(loximuthalRaw).parallel(40).scale(158.837);
    });
var _parallel1Js = require("./parallel1.js");
var _parallel1JsDefault = parcelHelpers.interopDefault(_parallel1Js);
var _mathJs = require("./math.js");
function loximuthalRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0), tanPhi0 = (0, _mathJs.tan)((0, _mathJs.quarterPi) + phi0 / 2);
    function forward(lambda, phi) {
        var y = phi - phi0, x = (0, _mathJs.abs)(y) < (0, _mathJs.epsilon) ? lambda * cosPhi0 : (0, _mathJs.abs)(x = (0, _mathJs.quarterPi) + phi / 2) < (0, _mathJs.epsilon) || (0, _mathJs.abs)((0, _mathJs.abs)(x) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon) ? 0 : lambda * y / (0, _mathJs.log)((0, _mathJs.tan)(x) / tanPhi0);
        return [
            x,
            y
        ];
    }
    forward.invert = function(x, y) {
        var lambda, phi = y + phi0;
        return [
            (0, _mathJs.abs)(y) < (0, _mathJs.epsilon) ? x / cosPhi0 : (0, _mathJs.abs)(lambda = (0, _mathJs.quarterPi) + phi / 2) < (0, _mathJs.epsilon) || (0, _mathJs.abs)((0, _mathJs.abs)(lambda) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon) ? 0 : x * (0, _mathJs.log)((0, _mathJs.tan)(lambda) / tanPhi0) / y,
            phi
        ];
    };
    return forward;
}

},{"./parallel1.js":"7dEak","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7I16f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millerRaw", ()=>millerRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(millerRaw).scale(108.318);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function millerRaw(lambda, phi) {
    return [
        lambda,
        1.25 * (0, _mathJs.log)((0, _mathJs.tan)((0, _mathJs.quarterPi) + 0.4 * phi))
    ];
}
millerRaw.invert = function(x, y) {
    return [
        x,
        2.5 * (0, _mathJs.atan)((0, _mathJs.exp)(0.8 * y)) - 0.625 * (0, _mathJs.pi)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a2w74":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modifiedStereographicRaw", ()=>modifiedStereographicRaw);
parcelHelpers.export(exports, "modifiedStereographicAlaska", ()=>modifiedStereographicAlaska);
parcelHelpers.export(exports, "modifiedStereographicGs48", ()=>modifiedStereographicGs48);
parcelHelpers.export(exports, "modifiedStereographicGs50", ()=>modifiedStereographicGs50);
parcelHelpers.export(exports, "modifiedStereographicMiller", ()=>modifiedStereographicMiller);
parcelHelpers.export(exports, "modifiedStereographicLee", ()=>modifiedStereographicLee);
parcelHelpers.export(exports, "default", ()=>modifiedStereographic);
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function modifiedStereographicRaw(C) {
    var m = C.length - 1;
    function forward(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), k = 2 / (1 + cosPhi * (0, _mathJs.cos)(lambda)), zr = k * cosPhi * (0, _mathJs.sin)(lambda), zi = k * (0, _mathJs.sin)(phi), i = m, w = C[i], ar = w[0], ai = w[1], t;
        while(--i >= 0){
            w = C[i];
            ar = w[0] + zr * (t = ar) - zi * ai;
            ai = w[1] + zr * ai + zi * t;
        }
        ar = zr * (t = ar) - zi * ai;
        ai = zr * ai + zi * t;
        return [
            ar,
            ai
        ];
    }
    forward.invert = function(x, y) {
        var i = 20, zr = x, zi = y;
        do {
            var j = m, w = C[j], ar = w[0], ai = w[1], br = 0, bi = 0, t;
            while(--j >= 0){
                w = C[j];
                br = ar + zr * (t = br) - zi * bi;
                bi = ai + zr * bi + zi * t;
                ar = w[0] + zr * (t = ar) - zi * ai;
                ai = w[1] + zr * ai + zi * t;
            }
            br = ar + zr * (t = br) - zi * bi;
            bi = ai + zr * bi + zi * t;
            ar = zr * (t = ar) - zi * ai - x;
            ai = zr * ai + zi * t - y;
            var denominator = br * br + bi * bi, deltar, deltai;
            zr -= deltar = (ar * br + ai * bi) / denominator;
            zi -= deltai = (ai * br - ar * bi) / denominator;
        }while ((0, _mathJs.abs)(deltar) + (0, _mathJs.abs)(deltai) > (0, _mathJs.epsilon) * (0, _mathJs.epsilon) && --i > 0);
        if (i) {
            var rho = (0, _mathJs.sqrt)(zr * zr + zi * zi), c = 2 * (0, _mathJs.atan)(rho * 0.5), sinc = (0, _mathJs.sin)(c);
            return [
                (0, _mathJs.atan2)(zr * sinc, rho * (0, _mathJs.cos)(c)),
                rho ? (0, _mathJs.asin)(zi * sinc / rho) : 0
            ];
        }
    };
    return forward;
}
var alaska = [
    [
        0.9972523,
        0
    ],
    [
        0.0052513,
        -0.0041175
    ],
    [
        0.0074606,
        0.0048125
    ],
    [
        -0.0153783,
        -0.1968253
    ],
    [
        0.0636871,
        -0.1408027
    ],
    [
        0.3660976,
        -0.2937382
    ]
], gs48 = [
    [
        0.98879,
        0
    ],
    [
        0,
        0
    ],
    [
        -0.050909,
        0
    ],
    [
        0,
        0
    ],
    [
        0.075528,
        0
    ]
], gs50 = [
    [
        0.9842990,
        0
    ],
    [
        0.0211642,
        0.0037608
    ],
    [
        -0.1036018,
        -0.0575102
    ],
    [
        -0.0329095,
        -0.0320119
    ],
    [
        0.0499471,
        0.1223335
    ],
    [
        0.0260460,
        0.0899805
    ],
    [
        0.0007388,
        -0.1435792
    ],
    [
        0.0075848,
        -0.1334108
    ],
    [
        -0.0216473,
        0.0776645
    ],
    [
        -0.0225161,
        0.0853673
    ]
], miller = [
    [
        0.9245,
        0
    ],
    [
        0,
        0
    ],
    [
        0.01943,
        0
    ]
], lee = [
    [
        0.721316,
        0
    ],
    [
        0,
        0
    ],
    [
        -0.00881625,
        -0.00617325
    ]
];
function modifiedStereographicAlaska() {
    return modifiedStereographic(alaska, [
        152,
        -64
    ]).scale(1400).center([
        -160.908,
        62.4864
    ]).clipAngle(30).angle(7.8);
}
function modifiedStereographicGs48() {
    return modifiedStereographic(gs48, [
        95,
        -38
    ]).scale(1000).clipAngle(55).center([
        -96.5563,
        38.8675
    ]);
}
function modifiedStereographicGs50() {
    return modifiedStereographic(gs50, [
        120,
        -45
    ]).scale(359.513).clipAngle(55).center([
        -117.474,
        53.0628
    ]);
}
function modifiedStereographicMiller() {
    return modifiedStereographic(miller, [
        -20,
        -18
    ]).scale(209.091).center([
        20,
        16.7214
    ]).clipAngle(82);
}
function modifiedStereographicLee() {
    return modifiedStereographic(lee, [
        165,
        10
    ]).scale(250).clipAngle(130).center([
        -165,
        -10
    ]);
}
function modifiedStereographic(coefficients, rotate) {
    var p = (0, _d3Geo.geoProjection)(modifiedStereographicRaw(coefficients)).rotate(rotate).clipAngle(90), r = (0, _d3Geo.geoRotation)(rotate), center = p.center;
    delete p.rotate;
    p.center = function(_) {
        return arguments.length ? center(r(_)) : r.invert(center());
    };
    return p;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Dect":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mtFlatPolarParabolicRaw", ()=>mtFlatPolarParabolicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(mtFlatPolarParabolicRaw).scale(164.859);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var sqrt6 = (0, _mathJs.sqrt)(6), sqrt7 = (0, _mathJs.sqrt)(7);
function mtFlatPolarParabolicRaw(lambda, phi) {
    var theta = (0, _mathJs.asin)(7 * (0, _mathJs.sin)(phi) / (3 * sqrt6));
    return [
        sqrt6 * lambda * (2 * (0, _mathJs.cos)(2 * theta / 3) - 1) / sqrt7,
        9 * (0, _mathJs.sin)(theta / 3) / sqrt7
    ];
}
mtFlatPolarParabolicRaw.invert = function(x, y) {
    var theta = 3 * (0, _mathJs.asin)(y * sqrt7 / 9);
    return [
        x * sqrt7 / (sqrt6 * (2 * (0, _mathJs.cos)(2 * theta / 3) - 1)),
        (0, _mathJs.asin)((0, _mathJs.sin)(theta) * 3 * sqrt6 / 7)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cJRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mtFlatPolarQuarticRaw", ()=>mtFlatPolarQuarticRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(mtFlatPolarQuarticRaw).scale(188.209);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function mtFlatPolarQuarticRaw(lambda, phi) {
    var k = (1 + (0, _mathJs.sqrt1_2)) * (0, _mathJs.sin)(phi), theta = phi;
    for(var i = 0, delta; i < 25; i++){
        theta -= delta = ((0, _mathJs.sin)(theta / 2) + (0, _mathJs.sin)(theta) - k) / (0.5 * (0, _mathJs.cos)(theta / 2) + (0, _mathJs.cos)(theta));
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon)) break;
    }
    return [
        lambda * (1 + 2 * (0, _mathJs.cos)(theta) / (0, _mathJs.cos)(theta / 2)) / (3 * (0, _mathJs.sqrt2)),
        2 * (0, _mathJs.sqrt)(3) * (0, _mathJs.sin)(theta / 2) / (0, _mathJs.sqrt)(2 + (0, _mathJs.sqrt2))
    ];
}
mtFlatPolarQuarticRaw.invert = function(x, y) {
    var sinTheta_2 = y * (0, _mathJs.sqrt)(2 + (0, _mathJs.sqrt2)) / (2 * (0, _mathJs.sqrt)(3)), theta = 2 * (0, _mathJs.asin)(sinTheta_2);
    return [
        3 * (0, _mathJs.sqrt2) * x / (1 + 2 * (0, _mathJs.cos)(theta) / (0, _mathJs.cos)(theta / 2)),
        (0, _mathJs.asin)((sinTheta_2 + (0, _mathJs.sin)(theta)) / (1 + (0, _mathJs.sqrt1_2)))
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jozQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mtFlatPolarSinusoidalRaw", ()=>mtFlatPolarSinusoidalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(mtFlatPolarSinusoidalRaw).scale(166.518);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function mtFlatPolarSinusoidalRaw(lambda, phi) {
    var A = (0, _mathJs.sqrt)(6 / (4 + (0, _mathJs.pi))), k = (1 + (0, _mathJs.pi) / 4) * (0, _mathJs.sin)(phi), theta = phi / 2;
    for(var i = 0, delta; i < 25; i++){
        theta -= delta = (theta / 2 + (0, _mathJs.sin)(theta) - k) / (0.5 + (0, _mathJs.cos)(theta));
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon)) break;
    }
    return [
        A * (0.5 + (0, _mathJs.cos)(theta)) * lambda / 1.5,
        A * theta
    ];
}
mtFlatPolarSinusoidalRaw.invert = function(x, y) {
    var A = (0, _mathJs.sqrt)(6 / (4 + (0, _mathJs.pi))), theta = y / A;
    if ((0, _mathJs.abs)((0, _mathJs.abs)(theta) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon)) theta = theta < 0 ? -(0, _mathJs.halfPi) : (0, _mathJs.halfPi);
    return [
        1.5 * x / (A * (0.5 + (0, _mathJs.cos)(theta))),
        (0, _mathJs.asin)((theta / 2 + (0, _mathJs.sin)(theta)) / (1 + (0, _mathJs.pi) / 4))
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i1U7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth2Raw", ()=>naturalEarth2Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(naturalEarth2Raw).scale(175.295);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function naturalEarth2Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2, phi6 = phi2 * phi4;
    return [
        lambda * (0.84719 - 0.13063 * phi2 + phi6 * phi6 * (-0.04515 + 0.05494 * phi2 - 0.02326 * phi4 + 0.00331 * phi6)),
        phi * (1.01183 + phi4 * phi4 * (-0.02625 + 0.01926 * phi2 - 0.00396 * phi4))
    ];
}
naturalEarth2Raw.invert = function(x, y) {
    var phi = y, i = 25, delta, phi2, phi4, phi6;
    do {
        phi2 = phi * phi;
        phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.01183 + phi4 * phi4 * (-0.02625 + 0.01926 * phi2 - 0.00396 * phi4)) - y) / (1.01183 + phi4 * phi4 * (-0.23625 + 0.21186 * phi2 + -0.05148 * phi4));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon2) && --i > 0);
    phi2 = phi * phi;
    phi4 = phi2 * phi2;
    phi6 = phi2 * phi4;
    return [
        x / (0.84719 - 0.13063 * phi2 + phi6 * phi6 * (-0.04515 + 0.05494 * phi2 - 0.02326 * phi4 + 0.00331 * phi6)),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lgB94":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nellHammerRaw", ()=>nellHammerRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(nellHammerRaw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function nellHammerRaw(lambda, phi) {
    return [
        lambda * (1 + (0, _mathJs.cos)(phi)) / 2,
        2 * (phi - (0, _mathJs.tan)(phi / 2))
    ];
}
nellHammerRaw.invert = function(x, y) {
    var p = y / 2;
    for(var i = 0, delta = Infinity; i < 10 && (0, _mathJs.abs)(delta) > (0, _mathJs.epsilon); ++i){
        var c = (0, _mathJs.cos)(y / 2);
        y -= delta = (y - (0, _mathJs.tan)(y / 2) - p) / (1 - 0.5 / (c * c));
    }
    return [
        2 * x / (1 + (0, _mathJs.cos)(y)),
        y
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cdujQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _hammerJs.hammerRaw)(Infinity), lobes).rotate([
            20,
            0
        ]).scale(152.63);
    });
var _hammerJs = require("../hammer.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var lobes = [
    [
        [
            [
                -180,
                0
            ],
            [
                -90,
                90
            ],
            [
                0,
                0
            ]
        ],
        [
            [
                0,
                0
            ],
            [
                90,
                90
            ],
            [
                180,
                0
            ]
        ]
    ],
    [
        [
            [
                -180,
                0
            ],
            [
                -90,
                -90
            ],
            [
                0,
                0
            ]
        ],
        [
            [
                0,
                0
            ],
            [
                90,
                -90
            ],
            [
                180,
                0
            ]
        ]
    ]
];

},{"../hammer.js":"esU8A","./index.js":"a3s0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"S8F17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Based on Torben Jansen's implementation
// https://beta.observablehq.com/@toja/nicolosi-globular-projection
// https://beta.observablehq.com/@toja/nicolosi-globular-inverse
parcelHelpers.export(exports, "nicolosiRaw", ()=>nicolosiRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(nicolosiRaw).scale(127.267);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _newtonJs = require("./newton.js");
function nicolosiRaw(lambda, phi) {
    var sinPhi = (0, _mathJs.sin)(phi), q = (0, _mathJs.cos)(phi), s = (0, _mathJs.sign)(lambda);
    if (lambda === 0 || (0, _mathJs.abs)(phi) === (0, _mathJs.halfPi)) return [
        0,
        phi
    ];
    else if (phi === 0) return [
        lambda,
        0
    ];
    else if ((0, _mathJs.abs)(lambda) === (0, _mathJs.halfPi)) return [
        lambda * q,
        (0, _mathJs.halfPi) * sinPhi
    ];
    var b = (0, _mathJs.pi) / (2 * lambda) - 2 * lambda / (0, _mathJs.pi), c = 2 * phi / (0, _mathJs.pi), d = (1 - c * c) / (sinPhi - c);
    var b2 = b * b, d2 = d * d, b2d2 = 1 + b2 / d2, d2b2 = 1 + d2 / b2;
    var M = (b * sinPhi / d - b / 2) / b2d2, N = (d2 * sinPhi / b2 + d / 2) / d2b2, m = M * M + q * q / b2d2, n = N * N - (d2 * sinPhi * sinPhi / b2 + d * sinPhi - 1) / d2b2;
    return [
        (0, _mathJs.halfPi) * (M + (0, _mathJs.sqrt)(m) * s),
        (0, _mathJs.halfPi) * (N + (0, _mathJs.sqrt)(n < 0 ? 0 : n) * (0, _mathJs.sign)(-phi * b) * s)
    ];
}
nicolosiRaw.invert = function(x, y) {
    x /= (0, _mathJs.halfPi);
    y /= (0, _mathJs.halfPi);
    var x2 = x * x, y2 = y * y, x2y2 = x2 + y2, pi2 = (0, _mathJs.pi) * (0, _mathJs.pi);
    return [
        x ? (x2y2 - 1 + (0, _mathJs.sqrt)((1 - x2y2) * (1 - x2y2) + 4 * x2)) / (2 * x) * (0, _mathJs.halfPi) : 0,
        (0, _newtonJs.solve)(function(phi) {
            return x2y2 * ((0, _mathJs.pi) * (0, _mathJs.sin)(phi) - 2 * phi) * (0, _mathJs.pi) + 4 * phi * phi * (y - (0, _mathJs.sin)(phi)) + 2 * (0, _mathJs.pi) * phi - pi2 * y;
        }, 0)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","./newton.js":"6xPTk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jidHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pattersonRaw", ()=>pattersonRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(pattersonRaw).scale(139.319);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
// Based on Java implementation by Bojan Savric.
// https://github.com/OSUCartography/JMapProjLib/blob/master/src/com/jhlabs/map/proj/PattersonProjection.java
var pattersonK1 = 1.0148, pattersonK2 = 0.23185, pattersonK3 = -0.14499, pattersonK4 = 0.02406, pattersonC1 = pattersonK1, pattersonC2 = 5 * pattersonK2, pattersonC3 = 7 * pattersonK3, pattersonC4 = 9 * pattersonK4, pattersonYmax = 1.790857183;
function pattersonRaw(lambda, phi) {
    var phi2 = phi * phi;
    return [
        lambda,
        phi * (pattersonK1 + phi2 * phi2 * (pattersonK2 + phi2 * (pattersonK3 + pattersonK4 * phi2)))
    ];
}
pattersonRaw.invert = function(x, y) {
    if (y > pattersonYmax) y = pattersonYmax;
    else if (y < -pattersonYmax) y = -pattersonYmax;
    var yc = y, delta;
    do {
        var y2 = yc * yc;
        yc -= delta = (yc * (pattersonK1 + y2 * y2 * (pattersonK2 + y2 * (pattersonK3 + pattersonK4 * y2))) - y) / (pattersonC1 + y2 * y2 * (pattersonC2 + y2 * (pattersonC3 + pattersonC4 * y2)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon));
    return [
        x,
        yc
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9RS1p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyconicRaw", ()=>polyconicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(polyconicRaw).scale(103.74);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function polyconicRaw(lambda, phi) {
    if ((0, _mathJs.abs)(phi) < (0, _mathJs.epsilon)) return [
        lambda,
        0
    ];
    var tanPhi = (0, _mathJs.tan)(phi), k = lambda * (0, _mathJs.sin)(phi);
    return [
        (0, _mathJs.sin)(k) / tanPhi,
        phi + (1 - (0, _mathJs.cos)(k)) / tanPhi
    ];
}
polyconicRaw.invert = function(x, y) {
    if ((0, _mathJs.abs)(y) < (0, _mathJs.epsilon)) return [
        x,
        0
    ];
    var k = x * x + y * y, phi = y * 0.5, i = 10, delta;
    do {
        var tanPhi = (0, _mathJs.tan)(phi), secPhi = 1 / (0, _mathJs.cos)(phi), j = k - 2 * y * phi + phi * phi;
        phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    tanPhi = (0, _mathJs.tan)(phi);
    return [
        ((0, _mathJs.abs)(y) < (0, _mathJs.abs)(phi + 1 / tanPhi) ? (0, _mathJs.asin)(x * tanPhi) : (0, _mathJs.sign)(y) * (0, _mathJs.sign)(x) * ((0, _mathJs.acos)((0, _mathJs.abs)(x * tanPhi)) + (0, _mathJs.halfPi))) / (0, _mathJs.sin)(phi),
        phi
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9trgU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Creates a polyhedral projection.
//  * root: a spanning tree of polygon faces.  Nodes are automatically
//    augmented with a transform matrix.
//  * face: a function that returns the appropriate node for a given {lambda, phi}
//    point (radians).
parcelHelpers.export(exports, "default", ()=>function(root, face) {
        recurse(root, {
            transform: null
        });
        function recurse(node, parent) {
            node.edges = faceEdges(node.face);
            // Find shared edge.
            if (parent.face) {
                var shared = node.shared = sharedEdge(node.face, parent.face), m = (0, _matrixJsDefault.default)(shared.map(parent.project), shared.map(node.project));
                node.transform = parent.transform ? (0, _matrixJs.multiply)(parent.transform, m) : m;
                // Replace shared edge in parent edges array.
                var edges = parent.edges;
                for(var i = 0, n = edges.length; i < n; ++i){
                    if (pointEqual(shared[0], edges[i][1]) && pointEqual(shared[1], edges[i][0])) edges[i] = node;
                    if (pointEqual(shared[0], edges[i][0]) && pointEqual(shared[1], edges[i][1])) edges[i] = node;
                }
                edges = node.edges;
                for(i = 0, n = edges.length; i < n; ++i){
                    if (pointEqual(shared[0], edges[i][0]) && pointEqual(shared[1], edges[i][1])) edges[i] = parent;
                    if (pointEqual(shared[0], edges[i][1]) && pointEqual(shared[1], edges[i][0])) edges[i] = parent;
                }
            } else node.transform = parent.transform;
            if (node.children) node.children.forEach(function(child) {
                recurse(child, node);
            });
            return node;
        }
        function forward(lambda, phi) {
            var node = face(lambda, phi), point = node.project([
                lambda * (0, _mathJs.degrees),
                phi * (0, _mathJs.degrees)
            ]), t;
            if (t = node.transform) return [
                t[0] * point[0] + t[1] * point[1] + t[2],
                -(t[3] * point[0] + t[4] * point[1] + t[5])
            ];
            point[1] = -point[1];
            return point;
        }
        // Naive inverse!  A faster solution would use bounding boxes, or even a
        // polygonal quadtree.
        if (hasInverse(root)) forward.invert = function(x, y) {
            var coordinates = faceInvert(root, [
                x,
                -y
            ]);
            return coordinates && (coordinates[0] *= (0, _mathJs.radians), coordinates[1] *= (0, _mathJs.radians), coordinates);
        };
        function faceInvert(node, coordinates) {
            var invert = node.project.invert, t = node.transform, point = coordinates;
            if (t) {
                t = (0, _matrixJs.inverse)(t);
                point = [
                    t[0] * point[0] + t[1] * point[1] + t[2],
                    t[3] * point[0] + t[4] * point[1] + t[5]
                ];
            }
            if (invert && node === faceDegrees(p = invert(point))) return p;
            var p, children = node.children;
            for(var i = 0, n = children && children.length; i < n; ++i){
                if (p = faceInvert(children[i], coordinates)) return p;
            }
        }
        function faceDegrees(coordinates) {
            return face(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
        }
        var proj = (0, _d3Geo.geoProjection)(forward), stream_ = proj.stream;
        proj.stream = function(stream) {
            var rotate = proj.rotate(), rotateStream = stream_(stream), sphereStream = (proj.rotate([
                0,
                0
            ]), stream_(stream));
            proj.rotate(rotate);
            rotateStream.sphere = function() {
                sphereStream.polygonStart();
                sphereStream.lineStart();
                outline(sphereStream, root);
                sphereStream.lineEnd();
                sphereStream.polygonEnd();
            };
            return rotateStream;
        };
        return proj.angle(-30);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("../math.js");
var _matrixJs = require("./matrix.js");
var _matrixJsDefault = parcelHelpers.interopDefault(_matrixJs);
function outline(stream, node, parent) {
    var point, edges = node.edges, n = edges.length, edge, multiPoint = {
        type: "MultiPoint",
        coordinates: node.face
    }, notPoles = node.face.filter(function(d) {
        return (0, _mathJs.abs)(d[1]) !== 90;
    }), b = (0, _d3Geo.geoBounds)({
        type: "MultiPoint",
        coordinates: notPoles
    }), inside = false, j = -1, dx = b[1][0] - b[0][0];
    // TODO
    var c = dx === 180 || dx === 360 ? [
        (b[0][0] + b[1][0]) / 2,
        (b[0][1] + b[1][1]) / 2
    ] : (0, _d3Geo.geoCentroid)(multiPoint);
    // First find the shared edge…
    if (parent) while(++j < n){
        if (edges[j] === parent) break;
    }
    ++j;
    for(var i = 0; i < n; ++i){
        edge = edges[(i + j) % n];
        if (Array.isArray(edge)) {
            if (!inside) {
                stream.point((point = (0, _d3Geo.geoInterpolate)(edge[0], c)((0, _mathJs.epsilon)))[0], point[1]);
                inside = true;
            }
            stream.point((point = (0, _d3Geo.geoInterpolate)(edge[1], c)((0, _mathJs.epsilon)))[0], point[1]);
        } else {
            inside = false;
            if (edge !== parent) outline(stream, edge, node);
        }
    }
}
// Tests equality of two spherical points.
function pointEqual(a, b) {
    return a && b && a[0] === b[0] && a[1] === b[1];
}
// Finds a shared edge given two clockwise polygons.
function sharedEdge(a, b) {
    var x, y, n = a.length, found = null;
    for(var i = 0; i < n; ++i){
        x = a[i];
        for(var j = b.length; --j >= 0;){
            y = b[j];
            if (x[0] === y[0] && x[1] === y[1]) {
                if (found) return [
                    found,
                    x
                ];
                found = x;
            }
        }
    }
}
// Converts an array of n face vertices to an array of n + 1 edges.
function faceEdges(face) {
    var n = face.length, edges = [];
    for(var a = face[n - 1], i = 0; i < n; ++i)edges.push([
        a,
        a = face[i]
    ]);
    return edges;
}
function hasInverse(node) {
    return node.project.invert || node.children && node.children.some(hasInverse);
}

},{"d3-geo":"hvz1M","../math.js":"g023h","./matrix.js":"lWTMg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lWTMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Note: 6-element arrays are used to denote the 3x3 affine transform matrix:
// [a, b, c,
//  d, e, f,
//  0, 0, 1] - this redundant row is left out.
// Transform matrix for [a0, a1] -> [b0, b1].
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var u = subtract(a[1], a[0]), v = subtract(b[1], b[0]), phi = angle(u, v), s = length(u) / length(v);
        return multiply([
            1,
            0,
            a[0][0],
            0,
            1,
            a[0][1]
        ], multiply([
            s,
            0,
            0,
            0,
            s,
            0
        ], multiply([
            (0, _mathJs.cos)(phi),
            (0, _mathJs.sin)(phi),
            0,
            -(0, _mathJs.sin)(phi),
            (0, _mathJs.cos)(phi),
            0
        ], [
            1,
            0,
            -b[0][0],
            0,
            1,
            -b[0][1]
        ])));
    });
// Inverts a transform matrix.
parcelHelpers.export(exports, "inverse", ()=>inverse);
// Multiplies two 3x2 matrices.
parcelHelpers.export(exports, "multiply", ()=>multiply);
var _mathJs = require("../math.js");
function inverse(m) {
    var k = 1 / (m[0] * m[4] - m[1] * m[3]);
    return [
        k * m[4],
        -k * m[1],
        k * (m[1] * m[5] - m[2] * m[4]),
        -k * m[3],
        k * m[0],
        k * (m[2] * m[3] - m[0] * m[5])
    ];
}
function multiply(a, b) {
    return [
        a[0] * b[0] + a[1] * b[3],
        a[0] * b[1] + a[1] * b[4],
        a[0] * b[2] + a[1] * b[5] + a[2],
        a[3] * b[0] + a[4] * b[3],
        a[3] * b[1] + a[4] * b[4],
        a[3] * b[2] + a[4] * b[5] + a[5]
    ];
}
// Subtracts 2D vectors.
function subtract(a, b) {
    return [
        a[0] - b[0],
        a[1] - b[1]
    ];
}
// Magnitude of a 2D vector.
function length(v) {
    return (0, _mathJs.sqrt)(v[0] * v[0] + v[1] * v[1]);
}
// Angle between two 2D vectors.
function angle(a, b) {
    return (0, _mathJs.atan2)(a[0] * b[1] - a[1] * b[0], a[0] * b[0] + a[1] * b[1]);
}

},{"../math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aSeq3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(faceProjection) {
        faceProjection = faceProjection || function(face) {
            var c = (0, _d3Geo.geoCentroid)({
                type: "MultiPoint",
                coordinates: face
            });
            return (0, _d3Geo.geoGnomonic)().scale(1).translate([
                0,
                0
            ]).rotate([
                -c[0],
                -c[1]
            ]);
        };
        var faces = (0, _octahedronJsDefault.default).map(function(face) {
            return {
                face: face,
                project: faceProjection(face)
            };
        });
        [
            -1,
            0,
            0,
            1,
            0,
            1,
            4,
            5
        ].forEach(function(d, i) {
            var node = faces[d];
            node && (node.children || (node.children = [])).push(faces[i]);
        });
        return (0, _indexJsDefault.default)(faces[0], function(lambda, phi) {
            return faces[lambda < -(0, _mathJs.pi) / 2 ? phi < 0 ? 6 : 4 : lambda < 0 ? phi < 0 ? 2 : 0 : lambda < (0, _mathJs.pi) / 2 ? phi < 0 ? 3 : 1 : phi < 0 ? 7 : 5];
        }).angle(-30).scale(101.858).center([
            0,
            45
        ]);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _octahedronJs = require("./octahedron.js");
var _octahedronJsDefault = parcelHelpers.interopDefault(_octahedronJs);

},{"d3-geo":"hvz1M","../math.js":"g023h","./index.js":"9trgU","./octahedron.js":"9H4Tz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9H4Tz":[function(require,module,exports,__globalThis) {
// TODO generate on-the-fly to avoid external modification.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var octahedron = [
    [
        0,
        90
    ],
    [
        -90,
        0
    ],
    [
        0,
        0
    ],
    [
        90,
        0
    ],
    [
        180,
        0
    ],
    [
        0,
        -90
    ]
];
exports.default = [
    [
        0,
        2,
        1
    ],
    [
        0,
        3,
        2
    ],
    [
        5,
        1,
        2
    ],
    [
        5,
        2,
        3
    ],
    [
        0,
        1,
        4
    ],
    [
        0,
        4,
        3
    ],
    [
        5,
        4,
        1
    ],
    [
        5,
        3,
        4
    ]
].map(function(face) {
    return face.map(function(i) {
        return octahedron[i];
    });
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4PkJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(faceProjection) {
        faceProjection = faceProjection || function(face) {
            var c = (0, _d3Geo.geoCentroid)({
                type: "MultiPoint",
                coordinates: face
            });
            return (0, _d3Geo.geoProjection)(collignonK).translate([
                0,
                0
            ]).scale(1).rotate(c[1] > 0 ? [
                -c[0],
                0
            ] : [
                180 - c[0],
                180
            ]);
        };
        var faces = (0, _octahedronJsDefault.default).map(function(face) {
            return {
                face: face,
                project: faceProjection(face)
            };
        });
        [
            -1,
            0,
            0,
            1,
            0,
            1,
            4,
            5
        ].forEach(function(d, i) {
            var node = faces[d];
            node && (node.children || (node.children = [])).push(faces[i]);
        });
        return (0, _indexJsDefault.default)(faces[0], function(lambda, phi) {
            return faces[lambda < -(0, _mathJs.pi) / 2 ? phi < 0 ? 6 : 4 : lambda < 0 ? phi < 0 ? 2 : 0 : lambda < (0, _mathJs.pi) / 2 ? phi < 0 ? 3 : 1 : phi < 0 ? 7 : 5];
        }).angle(-30).scale(121.906).center([
            0,
            48.5904
        ]);
    });
var _d3Geo = require("d3-geo");
var _collignonJs = require("../collignon.js");
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _octahedronJs = require("./octahedron.js");
var _octahedronJsDefault = parcelHelpers.interopDefault(_octahedronJs);
var kx = 2 / (0, _mathJs.sqrt)(3);
function collignonK(a, b) {
    var p = (0, _collignonJs.collignonRaw)(a, b);
    return [
        p[0] * kx,
        p[1]
    ];
}
collignonK.invert = function(x, y) {
    return (0, _collignonJs.collignonRaw).invert(x / kx, y);
};

},{"d3-geo":"hvz1M","../collignon.js":"94537","../math.js":"g023h","./index.js":"9trgU","./octahedron.js":"9H4Tz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9DsWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(faceProjection) {
        faceProjection = faceProjection || function(face) {
            var c = face.length === 6 ? (0, _d3Geo.geoCentroid)({
                type: "MultiPoint",
                coordinates: face
            }) : face[0];
            return (0, _d3Geo.geoGnomonic)().scale(1).translate([
                0,
                0
            ]).rotate([
                -c[0],
                -c[1]
            ]);
        };
        var w5 = (0, _octahedronJsDefault.default).map(function(face) {
            var xyz = face.map(cartesian), n = xyz.length, a = xyz[n - 1], b, hexagon = [];
            for(var i = 0; i < n; ++i){
                b = xyz[i];
                hexagon.push(spherical([
                    a[0] * 0.9486832980505138 + b[0] * 0.31622776601683794,
                    a[1] * 0.9486832980505138 + b[1] * 0.31622776601683794,
                    a[2] * 0.9486832980505138 + b[2] * 0.31622776601683794
                ]), spherical([
                    b[0] * 0.9486832980505138 + a[0] * 0.31622776601683794,
                    b[1] * 0.9486832980505138 + a[1] * 0.31622776601683794,
                    b[2] * 0.9486832980505138 + a[2] * 0.31622776601683794
                ]));
                a = b;
            }
            return hexagon;
        });
        var cornerNormals = [];
        var parents = [
            -1,
            0,
            0,
            1,
            0,
            1,
            4,
            5
        ];
        w5.forEach(function(hexagon, j) {
            var face = (0, _octahedronJsDefault.default)[j], n = face.length, normals = cornerNormals[j] = [];
            for(var i = 0; i < n; ++i){
                w5.push([
                    face[i],
                    hexagon[(i * 2 + 2) % (2 * n)],
                    hexagon[(i * 2 + 1) % (2 * n)]
                ]);
                parents.push(j);
                normals.push(cross(cartesian(hexagon[(i * 2 + 2) % (2 * n)]), cartesian(hexagon[(i * 2 + 1) % (2 * n)])));
            }
        });
        var faces = w5.map(function(face) {
            return {
                project: faceProjection(face),
                face: face
            };
        });
        parents.forEach(function(d, i) {
            var parent = faces[d];
            parent && (parent.children || (parent.children = [])).push(faces[i]);
        });
        function face(lambda, phi) {
            var cosphi = (0, _mathJs.cos)(phi), p = [
                cosphi * (0, _mathJs.cos)(lambda),
                cosphi * (0, _mathJs.sin)(lambda),
                (0, _mathJs.sin)(phi)
            ];
            var hexagon = lambda < -(0, _mathJs.pi) / 2 ? phi < 0 ? 6 : 4 : lambda < 0 ? phi < 0 ? 2 : 0 : lambda < (0, _mathJs.pi) / 2 ? phi < 0 ? 3 : 1 : phi < 0 ? 7 : 5;
            var n = cornerNormals[hexagon];
            return faces[dot(n[0], p) < 0 ? 8 + 3 * hexagon : dot(n[1], p) < 0 ? 8 + 3 * hexagon + 1 : dot(n[2], p) < 0 ? 8 + 3 * hexagon + 2 : hexagon];
        }
        return (0, _indexJsDefault.default)(faces[0], face).angle(-30).scale(110.625).center([
            0,
            45
        ]);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _octahedronJs = require("./octahedron.js");
var _octahedronJsDefault = parcelHelpers.interopDefault(_octahedronJs);
function dot(a, b) {
    for(var i = 0, n = a.length, s = 0; i < n; ++i)s += a[i] * b[i];
    return s;
}
function cross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
// Converts 3D Cartesian to spherical coordinates (degrees).
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]) * (0, _mathJs.degrees),
        (0, _mathJs.asin)((0, _mathJs.max)(-1, (0, _mathJs.min)(1, cartesian[2]))) * (0, _mathJs.degrees)
    ];
}
// Converts spherical coordinates (degrees) to 3D Cartesian.
function cartesian(coordinates) {
    var lambda = coordinates[0] * (0, _mathJs.radians), phi = coordinates[1] * (0, _mathJs.radians), cosphi = (0, _mathJs.cos)(phi);
    return [
        cosphi * (0, _mathJs.cos)(lambda),
        cosphi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}

},{"d3-geo":"hvz1M","../math.js":"g023h","./index.js":"9trgU","./octahedron.js":"9H4Tz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2bMtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, projection) {
        var stream = projection.stream, project;
        if (!stream) throw new Error("invalid projection");
        switch(object && object.type){
            case "Feature":
                project = projectFeature;
                break;
            case "FeatureCollection":
                project = projectFeatureCollection;
                break;
            default:
                project = projectGeometry;
                break;
        }
        return project(object, stream);
    });
var _d3Geo = require("d3-geo");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _clockwiseJs = require("./clockwise.js");
var _clockwiseJsDefault = parcelHelpers.interopDefault(_clockwiseJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
function projectFeatureCollection(o, stream) {
    return {
        type: "FeatureCollection",
        features: o.features.map(function(f) {
            return projectFeature(f, stream);
        })
    };
}
function projectFeature(o, stream) {
    return {
        type: "Feature",
        id: o.id,
        properties: o.properties,
        geometry: projectGeometry(o.geometry, stream)
    };
}
function projectGeometryCollection(o, stream) {
    return {
        type: "GeometryCollection",
        geometries: o.geometries.map(function(o) {
            return projectGeometry(o, stream);
        })
    };
}
function projectGeometry(o, stream) {
    if (!o) return null;
    if (o.type === "GeometryCollection") return projectGeometryCollection(o, stream);
    var sink;
    switch(o.type){
        case "Point":
            sink = sinkPoint;
            break;
        case "MultiPoint":
            sink = sinkPoint;
            break;
        case "LineString":
            sink = sinkLine;
            break;
        case "MultiLineString":
            sink = sinkLine;
            break;
        case "Polygon":
            sink = sinkPolygon;
            break;
        case "MultiPolygon":
            sink = sinkPolygon;
            break;
        case "Sphere":
            sink = sinkPolygon;
            break;
        default:
            return null;
    }
    (0, _d3Geo.geoStream)(o, stream(sink));
    return sink.result();
}
var points = [], lines = [];
var sinkPoint = {
    point: function(x, y) {
        points.push([
            x,
            y
        ]);
    },
    result: function() {
        var result = !points.length ? null : points.length < 2 ? {
            type: "Point",
            coordinates: points[0]
        } : {
            type: "MultiPoint",
            coordinates: points
        };
        points = [];
        return result;
    }
};
var sinkLine = {
    lineStart: (0, _noopJsDefault.default),
    point: function(x, y) {
        points.push([
            x,
            y
        ]);
    },
    lineEnd: function() {
        if (points.length) lines.push(points), points = [];
    },
    result: function() {
        var result = !lines.length ? null : lines.length < 2 ? {
            type: "LineString",
            coordinates: lines[0]
        } : {
            type: "MultiLineString",
            coordinates: lines
        };
        lines = [];
        return result;
    }
};
var sinkPolygon = {
    polygonStart: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    point: function(x, y) {
        points.push([
            x,
            y
        ]);
    },
    lineEnd: function() {
        var n = points.length;
        if (n) {
            do points.push(points[0].slice());
            while (++n < 4);
            lines.push(points), points = [];
        }
    },
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        if (!lines.length) return null;
        var polygons = [], holes = [];
        // https://github.com/d3/d3/issues/1558
        lines.forEach(function(ring) {
            if ((0, _clockwiseJsDefault.default)(ring)) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            var point = hole[0];
            polygons.some(function(polygon) {
                if ((0, _containsJsDefault.default)(polygon[0], point)) {
                    polygon.push(hole);
                    return true;
                }
            }) || polygons.push([
                hole
            ]);
        });
        lines = [];
        return !polygons.length ? null : polygons.length > 1 ? {
            type: "MultiPolygon",
            coordinates: polygons
        } : {
            type: "Polygon",
            coordinates: polygons[0]
        };
    }
};

},{"d3-geo":"hvz1M","../noop.js":"1h8RR","./clockwise.js":"50VFi","./contains.js":"epslh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1h8RR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = ()=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"50VFi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring) {
        if ((n = ring.length) < 4) return false;
        var i = 0, n, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area <= 0;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"epslh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring, point) {
        var x = point[0], y = point[1], contains = false;
        for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
            var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
            if (yi > y ^ yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = !contains;
        }
        return contains;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2exzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _gringortenJs.gringortenRaw)).scale(176.423);
    });
var _gringortenJs = require("../gringorten.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../gringorten.js":"58Ivv","./index.js":"42qzq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"42qzq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project) {
        var dx = project((0, _mathJs.halfPi), 0)[0] - project(-(0, _mathJs.halfPi), 0)[0];
        function projectQuincuncial(lambda, phi) {
            var t = (0, _mathJs.abs)(lambda) < (0, _mathJs.halfPi), p = project(t ? lambda : lambda > 0 ? lambda - (0, _mathJs.pi) : lambda + (0, _mathJs.pi), phi), x = (p[0] - p[1]) * (0, _mathJs.sqrt1_2), y = (p[0] + p[1]) * (0, _mathJs.sqrt1_2);
            if (t) return [
                x,
                y
            ];
            var d = dx * (0, _mathJs.sqrt1_2), s = x > 0 ^ y > 0 ? -1 : 1;
            return [
                s * x - (0, _mathJs.sign)(y) * d,
                s * y - (0, _mathJs.sign)(x) * d
            ];
        }
        if (project.invert) projectQuincuncial.invert = function(x0, y0) {
            var x = (x0 + y0) * (0, _mathJs.sqrt1_2), y = (y0 - x0) * (0, _mathJs.sqrt1_2), t = (0, _mathJs.abs)(x) < 0.5 * dx && (0, _mathJs.abs)(y) < 0.5 * dx;
            if (!t) {
                var d = dx * (0, _mathJs.sqrt1_2), s = x > 0 ^ y > 0 ? -1 : 1, x1 = -s * x0 + (y > 0 ? 1 : -1) * d, y1 = -s * y0 + (x > 0 ? 1 : -1) * d;
                x = (-x1 - y1) * (0, _mathJs.sqrt1_2);
                y = (x1 - y1) * (0, _mathJs.sqrt1_2);
            }
            var p = project.invert(x, y);
            if (!t) p[0] += x > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi);
            return p;
        };
        return (0, _d3Geo.geoProjection)(projectQuincuncial).rotate([
            -90,
            -90,
            45
        ]).clipAngle(179.999);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("../math.js");

},{"d3-geo":"hvz1M","../math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c1wCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)((0, _guyouJs.guyouRaw)).scale(111.48);
    });
var _guyouJs = require("../guyou.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../guyou.js":"bxyzm","./index.js":"42qzq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4lOlx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, digits) {
        if (!(0 <= (digits = +digits) && digits <= 20)) throw new Error("invalid digits");
        function quantizePoint(input) {
            var n = input.length, i = 2, output = new Array(n);
            output[0] = +input[0].toFixed(digits);
            output[1] = +input[1].toFixed(digits);
            while(i < n)output[i] = input[i], ++i;
            return output;
        }
        function quantizePoints(input) {
            return input.map(quantizePoint);
        }
        function quantizePointsNoDuplicates(input) {
            var point0 = quantizePoint(input[0]);
            var output = [
                point0
            ];
            for(var i = 1; i < input.length; i++){
                var point = quantizePoint(input[i]);
                if (point.length > 2 || point[0] != point0[0] || point[1] != point0[1]) {
                    output.push(point);
                    point0 = point;
                }
            }
            if (output.length === 1 && input.length > 1) output.push(quantizePoint(input[input.length - 1]));
            return output;
        }
        function quantizePolygon(input) {
            return input.map(quantizePointsNoDuplicates);
        }
        function quantizeGeometry(input) {
            if (input == null) return input;
            var output;
            switch(input.type){
                case "GeometryCollection":
                    output = {
                        type: "GeometryCollection",
                        geometries: input.geometries.map(quantizeGeometry)
                    };
                    break;
                case "Point":
                    output = {
                        type: "Point",
                        coordinates: quantizePoint(input.coordinates)
                    };
                    break;
                case "MultiPoint":
                    output = {
                        type: input.type,
                        coordinates: quantizePoints(input.coordinates)
                    };
                    break;
                case "LineString":
                    output = {
                        type: input.type,
                        coordinates: quantizePointsNoDuplicates(input.coordinates)
                    };
                    break;
                case "MultiLineString":
                case "Polygon":
                    output = {
                        type: input.type,
                        coordinates: quantizePolygon(input.coordinates)
                    };
                    break;
                case "MultiPolygon":
                    output = {
                        type: "MultiPolygon",
                        coordinates: input.coordinates.map(quantizePolygon)
                    };
                    break;
                default:
                    return input;
            }
            if (input.bbox != null) output.bbox = input.bbox;
            return output;
        }
        function quantizeFeature(input) {
            var output = {
                type: "Feature",
                properties: input.properties,
                geometry: quantizeGeometry(input.geometry)
            };
            if (input.id != null) output.id = input.id;
            if (input.bbox != null) output.bbox = input.bbox;
            return output;
        }
        if (input != null) switch(input.type){
            case "Feature":
                return quantizeFeature(input);
            case "FeatureCollection":
                var output = {
                    type: "FeatureCollection",
                    features: input.features.map(quantizeFeature)
                };
                if (input.bbox != null) output.bbox = input.bbox;
                return output;
            default:
                return quantizeGeometry(input);
        }
        return input;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ninv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectangularPolyconicRaw", ()=>rectangularPolyconicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _parallel1JsDefault.default)(rectangularPolyconicRaw).scale(131.215);
    });
var _mathJs = require("./math.js");
var _parallel1Js = require("./parallel1.js");
var _parallel1JsDefault = parcelHelpers.interopDefault(_parallel1Js);
function rectangularPolyconicRaw(phi0) {
    var sinPhi0 = (0, _mathJs.sin)(phi0);
    function forward(lambda, phi) {
        var A = sinPhi0 ? (0, _mathJs.tan)(lambda * sinPhi0 / 2) / sinPhi0 : lambda / 2;
        if (!phi) return [
            2 * A,
            -phi0
        ];
        var E = 2 * (0, _mathJs.atan)(A * (0, _mathJs.sin)(phi)), cotPhi = 1 / (0, _mathJs.tan)(phi);
        return [
            (0, _mathJs.sin)(E) * cotPhi,
            phi + (1 - (0, _mathJs.cos)(E)) * cotPhi - phi0
        ];
    }
    // TODO return null for points outside outline.
    forward.invert = function(x, y) {
        if ((0, _mathJs.abs)(y += phi0) < (0, _mathJs.epsilon)) return [
            sinPhi0 ? 2 * (0, _mathJs.atan)(sinPhi0 * x / 2) / sinPhi0 : x,
            0
        ];
        var k = x * x + y * y, phi = 0, i = 10, delta;
        do {
            var tanPhi = (0, _mathJs.tan)(phi), secPhi = 1 / (0, _mathJs.cos)(phi), j = k - 2 * y * phi + phi * phi;
            phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
        }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
        var E = x * (tanPhi = (0, _mathJs.tan)(phi)), A = (0, _mathJs.tan)((0, _mathJs.abs)(y) < (0, _mathJs.abs)(phi + 1 / tanPhi) ? (0, _mathJs.asin)(E) * 0.5 : (0, _mathJs.acos)(E) * 0.5 + (0, _mathJs.pi) / 4) / (0, _mathJs.sin)(phi);
        return [
            sinPhi0 ? 2 * (0, _mathJs.atan)(sinPhi0 * A) / sinPhi0 : 2 * A,
            phi
        ];
    };
    return forward;
}

},{"./math.js":"g023h","./parallel1.js":"7dEak","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d5UE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "robinsonRaw", ()=>robinsonRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(robinsonRaw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var K = [
    [
        0.9986,
        -0.062
    ],
    [
        1.0000,
        0.0000
    ],
    [
        0.9986,
        0.0620
    ],
    [
        0.9954,
        0.1240
    ],
    [
        0.9900,
        0.1860
    ],
    [
        0.9822,
        0.2480
    ],
    [
        0.9730,
        0.3100
    ],
    [
        0.9600,
        0.3720
    ],
    [
        0.9427,
        0.4340
    ],
    [
        0.9216,
        0.4958
    ],
    [
        0.8962,
        0.5571
    ],
    [
        0.8679,
        0.6176
    ],
    [
        0.8350,
        0.6769
    ],
    [
        0.7986,
        0.7346
    ],
    [
        0.7597,
        0.7903
    ],
    [
        0.7186,
        0.8435
    ],
    [
        0.6732,
        0.8936
    ],
    [
        0.6213,
        0.9394
    ],
    [
        0.5722,
        0.9761
    ],
    [
        0.5322,
        1.0000
    ]
];
K.forEach(function(d) {
    d[1] *= 1.593415793900743;
});
function robinsonRaw(lambda, phi) {
    var i = (0, _mathJs.min)(18, (0, _mathJs.abs)(phi) * 36 / (0, _mathJs.pi)), i0 = (0, _mathJs.floor)(i), di = i - i0, ax = (k = K[i0])[0], ay = k[1], bx = (k = K[++i0])[0], by = k[1], cx = (k = K[(0, _mathJs.min)(19, ++i0)])[0], cy = k[1], k;
    return [
        lambda * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
        (0, _mathJs.sign)(phi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2)
    ];
}
robinsonRaw.invert = function(x, y) {
    var phi = y * 90, i = (0, _mathJs.min)(18, (0, _mathJs.abs)(phi / 5)), i0 = (0, _mathJs.max)(0, (0, _mathJs.floor)(i));
    do {
        var ay = K[i0][1], by = K[i0 + 1][1], cy = K[(0, _mathJs.min)(19, i0 + 2)][1], u = cy - ay, v = cy - 2 * by + ay, t = 2 * ((0, _mathJs.abs)(y) - by) / u, c = v / u, di = t * (1 - c * t * (1 - 2 * c * t));
        if (di >= 0 || i0 === 1) {
            phi = (y >= 0 ? 5 : -5) * (di + i);
            var j = 50, delta;
            do {
                i = (0, _mathJs.min)(18, (0, _mathJs.abs)(phi) / 5);
                i0 = (0, _mathJs.floor)(i);
                di = i - i0;
                ay = K[i0][1];
                by = K[i0 + 1][1];
                cy = K[(0, _mathJs.min)(19, i0 + 2)][1];
                phi -= (delta = (0, _mathJs.sign)(y) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * (0, _mathJs.degrees);
            }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon2) && --j > 0);
            break;
        }
    }while (--i0 >= 0);
    var ax = K[i0][0], bx = K[i0 + 1][0], cx = K[(0, _mathJs.min)(19, i0 + 2)][0];
    return [
        x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
        phi * (0, _mathJs.radians)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ycxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "satelliteRaw", ()=>satelliteRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var distance = 2, omega = 0, m = (0, _d3Geo.geoProjectionMutator)(satelliteRaw), p = m(distance, omega);
        // As a multiple of radius.
        p.distance = function(_) {
            if (!arguments.length) return distance;
            return m(distance = +_, omega);
        };
        p.tilt = function(_) {
            if (!arguments.length) return omega * (0, _mathJs.degrees);
            return m(distance, omega = _ * (0, _mathJs.radians));
        };
        return p.scale(432.147).clipAngle((0, _mathJs.acos)(1 / distance) * (0, _mathJs.degrees) - 1e-6);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function satelliteVerticalRaw(P) {
    function forward(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), k = (P - 1) / (P - cosPhi * (0, _mathJs.cos)(lambda));
        return [
            k * cosPhi * (0, _mathJs.sin)(lambda),
            k * (0, _mathJs.sin)(phi)
        ];
    }
    forward.invert = function(x, y) {
        var rho2 = x * x + y * y, rho = (0, _mathJs.sqrt)(rho2), sinc = (P - (0, _mathJs.sqrt)(1 - rho2 * (P + 1) / (P - 1))) / ((P - 1) / rho + rho / (P - 1));
        return [
            (0, _mathJs.atan2)(x * sinc, rho * (0, _mathJs.sqrt)(1 - sinc * sinc)),
            rho ? (0, _mathJs.asin)(y * sinc / rho) : 0
        ];
    };
    return forward;
}
function satelliteRaw(P, omega) {
    var vertical = satelliteVerticalRaw(P);
    if (!omega) return vertical;
    var cosOmega = (0, _mathJs.cos)(omega), sinOmega = (0, _mathJs.sin)(omega);
    function forward(lambda, phi) {
        var coordinates = vertical(lambda, phi), y = coordinates[1], A = y * sinOmega / (P - 1) + cosOmega;
        return [
            coordinates[0] * cosOmega / A,
            y / A
        ];
    }
    forward.invert = function(x, y) {
        var k = (P - 1) / (P - 1 - y * sinOmega);
        return vertical.invert(k * x, k * y * cosOmega);
    };
    return forward;
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ipdQr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input) {
        if (input == null) return input;
        switch(input.type){
            case "Feature":
                return stitchFeature(input);
            case "FeatureCollection":
                var output = {
                    type: "FeatureCollection",
                    features: input.features.map(stitchFeature)
                };
                if (input.bbox != null) output.bbox = input.bbox;
                return output;
            default:
                return stitchGeometry(input);
        }
    });
var epsilon = 1e-4, epsilonInverse = 1e4, x0 = -180, x0e = x0 + epsilon, x1 = 180, x1e = x1 - epsilon, y0 = -90, y0e = y0 + epsilon, y1 = 90, y1e = y1 - epsilon;
function nonempty(coordinates) {
    return coordinates.length > 0;
}
function quantize(x) {
    return Math.floor(x * epsilonInverse) / epsilonInverse;
}
function normalizePoint(y) {
    return y === y0 || y === y1 ? [
        0,
        y
    ] : [
        x0,
        quantize(y)
    ]; // pole or antimeridian?
}
function clampPoint(p) {
    var x = p[0], y = p[1], clamped = false;
    if (x <= x0e) x = x0, clamped = true;
    else if (x >= x1e) x = x1, clamped = true;
    if (y <= y0e) y = y0, clamped = true;
    else if (y >= y1e) y = y1, clamped = true;
    return clamped ? [
        x,
        y
    ] : p;
}
function clampPoints(points) {
    return points.map(clampPoint);
}
// For each ring, detect where it crosses the antimeridian or pole.
function extractFragments(rings, polygon, fragments) {
    for(var j = 0, m = rings.length; j < m; ++j){
        var ring = rings[j].slice();
        // By default, assume that this ring doesn’t need any stitching.
        fragments.push({
            index: -1,
            polygon: polygon,
            ring: ring
        });
        for(var i = 0, n = ring.length; i < n; ++i){
            var point = ring[i], x = point[0], y = point[1];
            // If this is an antimeridian or polar point…
            if (x <= x0e || x >= x1e || y <= y0e || y >= y1e) {
                ring[i] = clampPoint(point);
                // Advance through any antimeridian or polar points…
                for(var k = i + 1; k < n; ++k){
                    var pointk = ring[k], xk = pointk[0], yk = pointk[1];
                    if (xk > x0e && xk < x1e && yk > y0e && yk < y1e) break;
                }
                // If this was just a single antimeridian or polar point,
                // we don’t need to cut this ring into a fragment;
                // we can just leave it as-is.
                if (k === i + 1) continue;
                // Otherwise, if this is not the first point in the ring,
                // cut the current fragment so that it ends at the current point.
                // The current point is also normalized for later joining.
                if (i) {
                    var fragmentBefore = {
                        index: -1,
                        polygon: polygon,
                        ring: ring.slice(0, i + 1)
                    };
                    fragmentBefore.ring[fragmentBefore.ring.length - 1] = normalizePoint(y);
                    fragments[fragments.length - 1] = fragmentBefore;
                } else fragments.pop();
                // If the remainder of the ring is an antimeridian fragment,
                // move on to the next ring.
                if (k >= n) break;
                // Otherwise, add the remaining ring fragment and continue.
                fragments.push({
                    index: -1,
                    polygon: polygon,
                    ring: ring = ring.slice(k - 1)
                });
                ring[0] = normalizePoint(ring[0][1]);
                i = -1;
                n = ring.length;
            }
        }
    }
}
// Now stitch the fragments back together into rings.
function stitchFragments(fragments) {
    var i, n = fragments.length;
    // To connect the fragments start-to-end, create a simple index by end.
    var fragmentByStart = {}, fragmentByEnd = {}, fragment, start, startFragment, end, endFragment;
    // For each fragment…
    for(i = 0; i < n; ++i){
        fragment = fragments[i];
        start = fragment.ring[0];
        end = fragment.ring[fragment.ring.length - 1];
        // If this fragment is closed, add it as a standalone ring.
        if (start[0] === end[0] && start[1] === end[1]) {
            fragment.polygon.push(fragment.ring);
            fragments[i] = null;
            continue;
        }
        fragment.index = i;
        fragmentByStart[start] = fragmentByEnd[end] = fragment;
    }
    // For each open fragment…
    for(i = 0; i < n; ++i){
        fragment = fragments[i];
        if (fragment) {
            start = fragment.ring[0];
            end = fragment.ring[fragment.ring.length - 1];
            startFragment = fragmentByEnd[start];
            endFragment = fragmentByStart[end];
            delete fragmentByStart[start];
            delete fragmentByEnd[end];
            // If this fragment is closed, add it as a standalone ring.
            if (start[0] === end[0] && start[1] === end[1]) {
                fragment.polygon.push(fragment.ring);
                continue;
            }
            if (startFragment) {
                delete fragmentByEnd[start];
                delete fragmentByStart[startFragment.ring[0]];
                startFragment.ring.pop(); // drop the shared coordinate
                fragments[startFragment.index] = null;
                fragment = {
                    index: -1,
                    polygon: startFragment.polygon,
                    ring: startFragment.ring.concat(fragment.ring)
                };
                if (startFragment === endFragment) // Connect both ends to this single fragment to create a ring.
                fragment.polygon.push(fragment.ring);
                else {
                    fragment.index = n++;
                    fragments.push(fragmentByStart[fragment.ring[0]] = fragmentByEnd[fragment.ring[fragment.ring.length - 1]] = fragment);
                }
            } else if (endFragment) {
                delete fragmentByStart[end];
                delete fragmentByEnd[endFragment.ring[endFragment.ring.length - 1]];
                fragment.ring.pop(); // drop the shared coordinate
                fragment = {
                    index: n++,
                    polygon: endFragment.polygon,
                    ring: fragment.ring.concat(endFragment.ring)
                };
                fragments[endFragment.index] = null;
                fragments.push(fragmentByStart[fragment.ring[0]] = fragmentByEnd[fragment.ring[fragment.ring.length - 1]] = fragment);
            } else {
                fragment.ring.push(fragment.ring[0]); // close ring
                fragment.polygon.push(fragment.ring);
            }
        }
    }
}
function stitchFeature(input) {
    var output = {
        type: "Feature",
        geometry: stitchGeometry(input.geometry)
    };
    if (input.id != null) output.id = input.id;
    if (input.bbox != null) output.bbox = input.bbox;
    if (input.properties != null) output.properties = input.properties;
    return output;
}
function stitchGeometry(input) {
    if (input == null) return input;
    var output, fragments, i, n;
    switch(input.type){
        case "GeometryCollection":
            output = {
                type: "GeometryCollection",
                geometries: input.geometries.map(stitchGeometry)
            };
            break;
        case "Point":
            output = {
                type: "Point",
                coordinates: clampPoint(input.coordinates)
            };
            break;
        case "MultiPoint":
        case "LineString":
            output = {
                type: input.type,
                coordinates: clampPoints(input.coordinates)
            };
            break;
        case "MultiLineString":
            output = {
                type: "MultiLineString",
                coordinates: input.coordinates.map(clampPoints)
            };
            break;
        case "Polygon":
            var polygon = [];
            extractFragments(input.coordinates, polygon, fragments = []);
            stitchFragments(fragments);
            output = {
                type: "Polygon",
                coordinates: polygon
            };
            break;
        case "MultiPolygon":
            fragments = [], i = -1, n = input.coordinates.length;
            var polygons = new Array(n);
            while(++i < n)extractFragments(input.coordinates[i], polygons[i] = [], fragments);
            stitchFragments(fragments);
            output = {
                type: "MultiPolygon",
                coordinates: polygons.filter(nonempty)
            };
            break;
        default:
            return input;
    }
    if (input.bbox != null) output.bbox = input.bbox;
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2zMwo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timesRaw", ()=>timesRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(timesRaw).scale(146.153);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function timesRaw(lambda, phi) {
    var t = (0, _mathJs.tan)(phi / 2), s = (0, _mathJs.sin)((0, _mathJs.quarterPi) * t);
    return [
        lambda * (0.74482 - 0.34588 * s * s),
        1.70711 * t
    ];
}
timesRaw.invert = function(x, y) {
    var t = y / 1.70711, s = (0, _mathJs.sin)((0, _mathJs.quarterPi) * t);
    return [
        x / (0.74482 - 0.34588 * s * s),
        2 * (0, _mathJs.atan)(t)
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KKLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "twoPointAzimuthalRaw", ()=>twoPointAzimuthalRaw);
parcelHelpers.export(exports, "twoPointAzimuthalUsa", ()=>twoPointAzimuthalUsa);
parcelHelpers.export(exports, "default", ()=>twoPointAzimuthal);
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _twoPointJs = require("./twoPoint.js");
var _twoPointJsDefault = parcelHelpers.interopDefault(_twoPointJs);
function twoPointAzimuthalRaw(d) {
    var cosd = (0, _mathJs.cos)(d);
    function forward(lambda, phi) {
        var coordinates = (0, _d3Geo.geoGnomonicRaw)(lambda, phi);
        coordinates[0] *= cosd;
        return coordinates;
    }
    forward.invert = function(x, y) {
        return (0, _d3Geo.geoGnomonicRaw).invert(x / cosd, y);
    };
    return forward;
}
function twoPointAzimuthalUsa() {
    return twoPointAzimuthal([
        -158,
        21.5
    ], [
        -77,
        39
    ]).clipAngle(60).scale(400);
}
function twoPointAzimuthal(p0, p1) {
    return (0, _twoPointJsDefault.default)(twoPointAzimuthalRaw, p0, p1);
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./twoPoint.js":"1njAl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1njAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Compute the origin as the midpoint of the two reference points.
// Rotate one of the reference points by the origin.
// Apply the spherical law of sines to compute gamma rotation.
parcelHelpers.export(exports, "default", ()=>function(raw, p0, p1) {
        var i = (0, _d3Geo.geoInterpolate)(p0, p1), o = i(0.5), a = (0, _d3Geo.geoRotation)([
            -o[0],
            -o[1]
        ])(p0), b = i.distance / 2, y = -(0, _mathJs.asin)((0, _mathJs.sin)(a[1] * (0, _mathJs.radians)) / (0, _mathJs.sin)(b)), R = [
            -o[0],
            -o[1],
            -(a[0] > 0 ? (0, _mathJs.pi) - y : y) * (0, _mathJs.degrees)
        ], p = (0, _d3Geo.geoProjection)(raw(b)).rotate(R), r = (0, _d3Geo.geoRotation)(R), center = p.center;
        delete p.rotate;
        p.center = function(_) {
            return arguments.length ? center(r(_)) : r.invert(center());
        };
        return p.clipAngle(90);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gxdCy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "twoPointEquidistantRaw", ()=>twoPointEquidistantRaw);
parcelHelpers.export(exports, "twoPointEquidistantUsa", ()=>twoPointEquidistantUsa);
parcelHelpers.export(exports, "default", ()=>twoPointEquidistant);
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _twoPointJs = require("./twoPoint.js");
var _twoPointJsDefault = parcelHelpers.interopDefault(_twoPointJs);
function twoPointEquidistantRaw(z0) {
    if (!(z0 *= 2)) return 0, _d3Geo.geoAzimuthalEquidistantRaw;
    var lambdaa = -z0 / 2, lambdab = -lambdaa, z02 = z0 * z0, tanLambda0 = (0, _mathJs.tan)(lambdab), S = 0.5 / (0, _mathJs.sin)(lambdab);
    function forward(lambda, phi) {
        var za = (0, _mathJs.acos)((0, _mathJs.cos)(phi) * (0, _mathJs.cos)(lambda - lambdaa)), zb = (0, _mathJs.acos)((0, _mathJs.cos)(phi) * (0, _mathJs.cos)(lambda - lambdab)), ys = phi < 0 ? -1 : 1;
        za *= za, zb *= zb;
        return [
            (za - zb) / (2 * z0),
            ys * (0, _mathJs.sqrt)(4 * z02 * zb - (z02 - za + zb) * (z02 - za + zb)) / (2 * z0)
        ];
    }
    forward.invert = function(x, y) {
        var y2 = y * y, cosza = (0, _mathJs.cos)((0, _mathJs.sqrt)(y2 + (t = x + lambdaa) * t)), coszb = (0, _mathJs.cos)((0, _mathJs.sqrt)(y2 + (t = x + lambdab) * t)), t, d;
        return [
            (0, _mathJs.atan2)(d = cosza - coszb, t = (cosza + coszb) * tanLambda0),
            (y < 0 ? -1 : 1) * (0, _mathJs.acos)((0, _mathJs.sqrt)(t * t + d * d) * S)
        ];
    };
    return forward;
}
function twoPointEquidistantUsa() {
    return twoPointEquidistant([
        -158,
        21.5
    ], [
        -77,
        39
    ]).clipAngle(130).scale(122.571);
}
function twoPointEquidistant(p0, p1) {
    return (0, _twoPointJsDefault.default)(twoPointEquidistantRaw, p0, p1);
}

},{"d3-geo":"hvz1M","./math.js":"g023h","./twoPoint.js":"1njAl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"13oJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vanDerGrintenRaw", ()=>vanDerGrintenRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(vanDerGrintenRaw).scale(79.4183);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function vanDerGrintenRaw(lambda, phi) {
    if ((0, _mathJs.abs)(phi) < (0, _mathJs.epsilon)) return [
        lambda,
        0
    ];
    var sinTheta = (0, _mathJs.abs)(phi / (0, _mathJs.halfPi)), theta = (0, _mathJs.asin)(sinTheta);
    if ((0, _mathJs.abs)(lambda) < (0, _mathJs.epsilon) || (0, _mathJs.abs)((0, _mathJs.abs)(phi) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon)) return [
        0,
        (0, _mathJs.sign)(phi) * (0, _mathJs.pi) * (0, _mathJs.tan)(theta / 2)
    ];
    var cosTheta = (0, _mathJs.cos)(theta), A = (0, _mathJs.abs)((0, _mathJs.pi) / lambda - lambda / (0, _mathJs.pi)) / 2, A2 = A * A, G = cosTheta / (sinTheta + cosTheta - 1), P = G * (2 / sinTheta - 1), P2 = P * P, P2_A2 = P2 + A2, G_P2 = G - P2, Q = A2 + G;
    return [
        (0, _mathJs.sign)(lambda) * (0, _mathJs.pi) * (A * G_P2 + (0, _mathJs.sqrt)(A2 * G_P2 * G_P2 - P2_A2 * (G * G - P2))) / P2_A2,
        (0, _mathJs.sign)(phi) * (0, _mathJs.pi) * (P * Q - A * (0, _mathJs.sqrt)((A2 + 1) * P2_A2 - Q * Q)) / P2_A2
    ];
}
vanDerGrintenRaw.invert = function(x, y) {
    if ((0, _mathJs.abs)(y) < (0, _mathJs.epsilon)) return [
        x,
        0
    ];
    if ((0, _mathJs.abs)(x) < (0, _mathJs.epsilon)) return [
        0,
        (0, _mathJs.halfPi) * (0, _mathJs.sin)(2 * (0, _mathJs.atan)(y / (0, _mathJs.pi)))
    ];
    var x2 = (x /= (0, _mathJs.pi)) * x, y2 = (y /= (0, _mathJs.pi)) * y, x2_y2 = x2 + y2, z = x2_y2 * x2_y2, c1 = -(0, _mathJs.abs)(y) * (1 + x2_y2), c2 = c1 - 2 * y2 + x2, c3 = -2 * c1 + 1 + 2 * y2 + z, d = y2 / c3 + (2 * c2 * c2 * c2 / (c3 * c3 * c3) - 9 * c1 * c2 / (c3 * c3)) / 27, a1 = (c1 - c2 * c2 / (3 * c3)) / c3, m1 = 2 * (0, _mathJs.sqrt)(-a1 / 3), theta1 = (0, _mathJs.acos)(3 * d / (a1 * m1)) / 3;
    return [
        (0, _mathJs.pi) * (x2_y2 - 1 + (0, _mathJs.sqrt)(1 + 2 * (x2 - y2) + z)) / (2 * x),
        (0, _mathJs.sign)(y) * (0, _mathJs.pi) * (-m1 * (0, _mathJs.cos)(theta1 + (0, _mathJs.pi) / 3) - c2 / (3 * c3))
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6K5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vanDerGrinten2Raw", ()=>vanDerGrinten2Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(vanDerGrinten2Raw).scale(79.4183);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function vanDerGrinten2Raw(lambda, phi) {
    if ((0, _mathJs.abs)(phi) < (0, _mathJs.epsilon)) return [
        lambda,
        0
    ];
    var sinTheta = (0, _mathJs.abs)(phi / (0, _mathJs.halfPi)), theta = (0, _mathJs.asin)(sinTheta);
    if ((0, _mathJs.abs)(lambda) < (0, _mathJs.epsilon) || (0, _mathJs.abs)((0, _mathJs.abs)(phi) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon)) return [
        0,
        (0, _mathJs.sign)(phi) * (0, _mathJs.pi) * (0, _mathJs.tan)(theta / 2)
    ];
    var cosTheta = (0, _mathJs.cos)(theta), A = (0, _mathJs.abs)((0, _mathJs.pi) / lambda - lambda / (0, _mathJs.pi)) / 2, A2 = A * A, x1 = cosTheta * ((0, _mathJs.sqrt)(1 + A2) - A * cosTheta) / (1 + A2 * sinTheta * sinTheta);
    return [
        (0, _mathJs.sign)(lambda) * (0, _mathJs.pi) * x1,
        (0, _mathJs.sign)(phi) * (0, _mathJs.pi) * (0, _mathJs.sqrt)(1 - x1 * (2 * A + x1))
    ];
}
vanDerGrinten2Raw.invert = function(x, y) {
    if (!x) return [
        0,
        (0, _mathJs.halfPi) * (0, _mathJs.sin)(2 * (0, _mathJs.atan)(y / (0, _mathJs.pi)))
    ];
    var x1 = (0, _mathJs.abs)(x / (0, _mathJs.pi)), A = (1 - x1 * x1 - (y /= (0, _mathJs.pi)) * y) / (2 * x1), A2 = A * A, B = (0, _mathJs.sqrt)(A2 + 1);
    return [
        (0, _mathJs.sign)(x) * (0, _mathJs.pi) * (B - A),
        (0, _mathJs.sign)(y) * (0, _mathJs.halfPi) * (0, _mathJs.sin)(2 * (0, _mathJs.atan2)((0, _mathJs.sqrt)((1 - 2 * A * x1) * (A + B) - x1), (0, _mathJs.sqrt)(B + A + x1)))
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j5q57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vanDerGrinten3Raw", ()=>vanDerGrinten3Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(vanDerGrinten3Raw).scale(79.4183);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function vanDerGrinten3Raw(lambda, phi) {
    if ((0, _mathJs.abs)(phi) < (0, _mathJs.epsilon)) return [
        lambda,
        0
    ];
    var sinTheta = phi / (0, _mathJs.halfPi), theta = (0, _mathJs.asin)(sinTheta);
    if ((0, _mathJs.abs)(lambda) < (0, _mathJs.epsilon) || (0, _mathJs.abs)((0, _mathJs.abs)(phi) - (0, _mathJs.halfPi)) < (0, _mathJs.epsilon)) return [
        0,
        (0, _mathJs.pi) * (0, _mathJs.tan)(theta / 2)
    ];
    var A = ((0, _mathJs.pi) / lambda - lambda / (0, _mathJs.pi)) / 2, y1 = sinTheta / (1 + (0, _mathJs.cos)(theta));
    return [
        (0, _mathJs.pi) * ((0, _mathJs.sign)(lambda) * (0, _mathJs.sqrt)(A * A + 1 - y1 * y1) - A),
        (0, _mathJs.pi) * y1
    ];
}
vanDerGrinten3Raw.invert = function(x, y) {
    if (!y) return [
        x,
        0
    ];
    var y1 = y / (0, _mathJs.pi), A = ((0, _mathJs.pi) * (0, _mathJs.pi) * (1 - y1 * y1) - x * x) / (2 * (0, _mathJs.pi) * x);
    return [
        x ? (0, _mathJs.pi) * ((0, _mathJs.sign)(x) * (0, _mathJs.sqrt)(A * A + 1) - A) : 0,
        (0, _mathJs.halfPi) * (0, _mathJs.sin)(2 * (0, _mathJs.atan)(y1))
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"izzR1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vanDerGrinten4Raw", ()=>vanDerGrinten4Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(vanDerGrinten4Raw).scale(127.16);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function vanDerGrinten4Raw(lambda, phi) {
    if (!phi) return [
        lambda,
        0
    ];
    var phi0 = (0, _mathJs.abs)(phi);
    if (!lambda || phi0 === (0, _mathJs.halfPi)) return [
        0,
        phi
    ];
    var B = phi0 / (0, _mathJs.halfPi), B2 = B * B, C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)), C2 = C * C, BC = B * C, B_C2 = B2 + C2 + 2 * BC, B_3C = B + 3 * C, lambda0 = lambda / (0, _mathJs.halfPi), lambda1 = lambda0 + 1 / lambda0, D = (0, _mathJs.sign)((0, _mathJs.abs)(lambda) - (0, _mathJs.halfPi)) * (0, _mathJs.sqrt)(lambda1 * lambda1 - 4), D2 = D * D, F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + 12 * BC * C2 + 4 * C2 * C2), x1 = (D * (B_C2 + C2 - 1) + 2 * (0, _mathJs.sqrt)(F)) / (4 * B_C2 + D2);
    return [
        (0, _mathJs.sign)(lambda) * (0, _mathJs.halfPi) * x1,
        (0, _mathJs.sign)(phi) * (0, _mathJs.halfPi) * (0, _mathJs.sqrt)(1 + D * (0, _mathJs.abs)(x1) - x1 * x1)
    ];
}
vanDerGrinten4Raw.invert = function(x, y) {
    var delta;
    if (!x || !y) return [
        x,
        y
    ];
    var sy = (0, _mathJs.sign)(y);
    y = (0, _mathJs.abs)(y) / (0, _mathJs.pi);
    var x1 = (0, _mathJs.sign)(x) * x / (0, _mathJs.halfPi), D = (x1 * x1 - 1 + 4 * y * y) / (0, _mathJs.abs)(x1), D2 = D * D, B = y * (2 - (y > 0.5 ? (0, _mathJs.min)(y, (0, _mathJs.abs)(x)) : 0)), r = x * x + y * y, i = 50;
    do {
        var B2 = B * B, C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)), C_ = (3 * B - B2 * B - 10) / (2 * B2 * B), C2 = C * C, BC = B * C, B_C = B + C, B_C2 = B_C * B_C, B_3C = B + 3 * C, F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + C2 * (12 * BC + 4 * C2)), F_ = -2 * B_C * (4 * BC * C2 + (1 - 4 * B2 + 3 * B2 * B2) * (1 + C_) + C2 * (-6 + 14 * B2 - D2 + (-8 + 8 * B2 - 2 * D2) * C_) + BC * (-8 + 12 * B2 + (-10 + 10 * B2 - D2) * C_)), sqrtF = (0, _mathJs.sqrt)(F), f = D * (B_C2 + C2 - 1) + 2 * sqrtF - x1 * (4 * B_C2 + D2), f_ = D * (2 * C * C_ + 2 * B_C * (1 + C_)) + F_ / sqrtF - 8 * B_C * (D * (-1 + C2 + B_C2) + 2 * sqrtF) * (1 + C_) / (D2 + 4 * B_C2);
        B -= delta = f / f_;
    }while (delta * r * r > (0, _mathJs.epsilon) && --i > 0);
    return [
        (0, _mathJs.sign)(x) * ((0, _mathJs.sqrt)(D * D + 4) + D) * (0, _mathJs.pi) / 4,
        sy * (0, _mathJs.halfPi) * B
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fsEzE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wagnerRaw", ()=>wagnerRaw);
parcelHelpers.export(exports, "default", ()=>wagner);
parcelHelpers.export(exports, "wagner7", ()=>wagner7);
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function wagnerFormula(cx, cy, m1, m2, n) {
    function forward(lambda, phi) {
        var s = m1 * (0, _mathJs.sin)(m2 * phi), c0 = (0, _mathJs.sqrt)(1 - s * s), c1 = (0, _mathJs.sqrt)(2 / (1 + c0 * (0, _mathJs.cos)(lambda *= n)));
        return [
            cx * c0 * c1 * (0, _mathJs.sin)(lambda),
            cy * s * c1
        ];
    }
    forward.invert = function(x, y) {
        var t1 = x / cx, t2 = y / cy, p = (0, _mathJs.sqrt)(t1 * t1 + t2 * t2), c = 2 * (0, _mathJs.asin)(p / 2);
        return [
            (0, _mathJs.atan2)(x * (0, _mathJs.tan)(c), cx * p) / n,
            p && (0, _mathJs.asin)(y * (0, _mathJs.sin)(c) / (cy * m1 * p)) / m2
        ];
    };
    return forward;
}
function wagnerRaw(poleline, parallels, inflation, ratio) {
    // 60 is always used as reference parallel
    var phi1 = (0, _mathJs.pi) / 3;
    // sanitizing the input values
    // poleline and parallels may approximate but never equal 0
    poleline = (0, _mathJs.max)(poleline, (0, _mathJs.epsilon));
    parallels = (0, _mathJs.max)(parallels, (0, _mathJs.epsilon));
    // poleline must be <= 90; parallels may approximate but never equal 180
    poleline = (0, _mathJs.min)(poleline, (0, _mathJs.halfPi));
    parallels = (0, _mathJs.min)(parallels, (0, _mathJs.pi) - (0, _mathJs.epsilon));
    // 0 <= inflation <= 99.999
    inflation = (0, _mathJs.max)(inflation, 0);
    inflation = (0, _mathJs.min)(inflation, 100 - (0, _mathJs.epsilon));
    // ratio > 0.
    // sensible values, i.e. something that renders a map which still can be
    // recognized as world map, are e.g. 20 <= ratio <= 1000.
    ratio = (0, _mathJs.max)(ratio, (0, _mathJs.epsilon));
    // convert values from boehm notation
    // areal inflation e.g. from 0 to 1 or 20 to 1.2:
    var vinflation = inflation / 100 + 1;
    // axial ratio e.g. from 200 to 2:
    var vratio = ratio / 100;
    // the other ones are a bit more complicated...
    var m2 = (0, _mathJs.acos)(vinflation * (0, _mathJs.cos)(phi1)) / phi1, m1 = (0, _mathJs.sin)(poleline) / (0, _mathJs.sin)(m2 * (0, _mathJs.halfPi)), n = parallels / (0, _mathJs.pi), k = (0, _mathJs.sqrt)(vratio * (0, _mathJs.sin)(poleline / 2) / (0, _mathJs.sin)(parallels / 2)), cx = k / (0, _mathJs.sqrt)(n * m1 * m2), cy = 1 / (k * (0, _mathJs.sqrt)(n * m1 * m2));
    return wagnerFormula(cx, cy, m1, m2, n);
}
function wagner() {
    // default values generate wagner8
    var poleline = 65 * (0, _mathJs.radians), parallels = 60 * (0, _mathJs.radians), inflation = 20, ratio = 200, mutate = (0, _d3Geo.geoProjectionMutator)(wagnerRaw), projection = mutate(poleline, parallels, inflation, ratio);
    projection.poleline = function(_) {
        return arguments.length ? mutate(poleline = +_ * (0, _mathJs.radians), parallels, inflation, ratio) : poleline * (0, _mathJs.degrees);
    };
    projection.parallels = function(_) {
        return arguments.length ? mutate(poleline, parallels = +_ * (0, _mathJs.radians), inflation, ratio) : parallels * (0, _mathJs.degrees);
    };
    projection.inflation = function(_) {
        return arguments.length ? mutate(poleline, parallels, inflation = +_, ratio) : inflation;
    };
    projection.ratio = function(_) {
        return arguments.length ? mutate(poleline, parallels, inflation, ratio = +_) : ratio;
    };
    return projection.scale(163.775);
}
function wagner7() {
    return wagner().poleline(65).parallels(60).inflation(0).ratio(200).scale(172.633);
}

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jh5E6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wagner4Raw", ()=>wagner4Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(wagner4Raw).scale(176.84);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
var _mollweideJs = require("./mollweide.js");
var A = 4 * (0, _mathJs.pi) + 3 * (0, _mathJs.sqrt)(3), B = 2 * (0, _mathJs.sqrt)(2 * (0, _mathJs.pi) * (0, _mathJs.sqrt)(3) / A);
var wagner4Raw = (0, _mollweideJs.mollweideBromleyRaw)(B * (0, _mathJs.sqrt)(3) / (0, _mathJs.pi), B, A / 6);

},{"d3-geo":"hvz1M","./math.js":"g023h","./mollweide.js":"4WAID","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aJmk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wagner6Raw", ()=>wagner6Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(wagner6Raw).scale(152.63);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function wagner6Raw(lambda, phi) {
    return [
        lambda * (0, _mathJs.sqrt)(1 - 3 * phi * phi / ((0, _mathJs.pi) * (0, _mathJs.pi))),
        phi
    ];
}
wagner6Raw.invert = function(x, y) {
    return [
        x / (0, _mathJs.sqrt)(1 - 3 * y * y / ((0, _mathJs.pi) * (0, _mathJs.pi))),
        y
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8gAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wiechelRaw", ()=>wiechelRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(wiechelRaw).rotate([
            0,
            -90,
            45
        ]).scale(124.75).clipAngle(179.999);
    });
var _d3Geo = require("d3-geo");
var _mathJs = require("./math.js");
function wiechelRaw(lambda, phi) {
    var cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.cos)(lambda) * cosPhi, sin1_Phi = 1 - sinPhi, cosLambda = (0, _mathJs.cos)(lambda = (0, _mathJs.atan2)((0, _mathJs.sin)(lambda) * cosPhi, -(0, _mathJs.sin)(phi))), sinLambda = (0, _mathJs.sin)(lambda);
    cosPhi = (0, _mathJs.sqrt)(1 - sinPhi * sinPhi);
    return [
        sinLambda * cosPhi - cosLambda * sin1_Phi,
        -cosLambda * cosPhi - sinLambda * sin1_Phi
    ];
}
wiechelRaw.invert = function(x, y) {
    var w = (x * x + y * y) / -2, k = (0, _mathJs.sqrt)(-w * (2 + w)), b = y * w + x * k, a = x * w - y * k, D = (0, _mathJs.sqrt)(a * a + b * b);
    return [
        (0, _mathJs.atan2)(k * b, D * (1 + w)),
        D ? -(0, _mathJs.asin)(k * a / D) : 0
    ];
};

},{"d3-geo":"hvz1M","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lXBM1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "winkel3Raw", ()=>winkel3Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _d3Geo.geoProjection)(winkel3Raw).scale(158.837);
    });
var _d3Geo = require("d3-geo");
var _aitoffJs = require("./aitoff.js");
var _mathJs = require("./math.js");
function winkel3Raw(lambda, phi) {
    var coordinates = (0, _aitoffJs.aitoffRaw)(lambda, phi);
    return [
        (coordinates[0] + lambda / (0, _mathJs.halfPi)) / 2,
        (coordinates[1] + phi) / 2
    ];
}
winkel3Raw.invert = function(x, y) {
    var lambda = x, phi = y, i = 25;
    do {
        var cosphi = (0, _mathJs.cos)(phi), sinphi = (0, _mathJs.sin)(phi), sin_2phi = (0, _mathJs.sin)(2 * phi), sin2phi = sinphi * sinphi, cos2phi = cosphi * cosphi, sinlambda = (0, _mathJs.sin)(lambda), coslambda_2 = (0, _mathJs.cos)(lambda / 2), sinlambda_2 = (0, _mathJs.sin)(lambda / 2), sin2lambda_2 = sinlambda_2 * sinlambda_2, C = 1 - cos2phi * coslambda_2 * coslambda_2, E = C ? (0, _mathJs.acos)(cosphi * coslambda_2) * (0, _mathJs.sqrt)(F = 1 / C) : F = 0, F, fx = 0.5 * (2 * E * cosphi * sinlambda_2 + lambda / (0, _mathJs.halfPi)) - x, fy = 0.5 * (E * sinphi + phi) - y, dxdlambda = 0.5 * F * (cos2phi * sin2lambda_2 + E * cosphi * coslambda_2 * sin2phi) + 0.5 / (0, _mathJs.halfPi), dxdphi = F * (sinlambda * sin_2phi / 4 - E * sinphi * sinlambda_2), dydlambda = 0.125 * F * (sin_2phi * sinlambda_2 - E * sinphi * cos2phi * sinlambda), dydphi = 0.5 * F * (sin2phi * coslambda_2 + E * sin2lambda_2 * cosphi) + 0.5, denominator = dxdphi * dydlambda - dydphi * dxdlambda, dlambda = (fy * dxdphi - fx * dydphi) / denominator, dphi = (fx * dydlambda - fy * dxdlambda) / denominator;
        lambda -= dlambda, phi -= dphi;
    }while (((0, _mathJs.abs)(dlambda) > (0, _mathJs.epsilon) || (0, _mathJs.abs)(dphi) > (0, _mathJs.epsilon)) && --i > 0);
    return [
        lambda,
        phi
    ];
};

},{"d3-geo":"hvz1M","./aitoff.js":"j6uie","./math.js":"g023h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvunA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "force", ()=>Force);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Force = require("d3-force");
const ForceMap = {
    center: (0, _d3Force.forceCenter),
    collide: (0, _d3Force.forceCollide),
    nbody: (0, _d3Force.forceManyBody),
    link: (0, _d3Force.forceLink),
    x: (0, _d3Force.forceX),
    y: (0, _d3Force.forceY)
};
const Forces = 'forces', ForceParams = [
    'alpha',
    'alphaMin',
    'alphaTarget',
    'velocityDecay',
    'forces'
], ForceConfig = [
    'static',
    'iterations'
], ForceOutput = [
    'x',
    'y',
    'vx',
    'vy'
];
/**
 * Force simulation layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<object>} params.forces - The forces to apply.
 */ function Force(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Force.Definition = {
    'type': 'Force',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'static',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'restart',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'iterations',
            'type': 'number',
            'default': 300
        },
        {
            'name': 'alpha',
            'type': 'number',
            'default': 1
        },
        {
            'name': 'alphaMin',
            'type': 'number',
            'default': 0.001
        },
        {
            'name': 'alphaTarget',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'velocityDecay',
            'type': 'number',
            'default': 0.4
        },
        {
            'name': 'forces',
            'type': 'param',
            'array': true,
            'params': [
                {
                    'key': {
                        'force': 'center'
                    },
                    'params': [
                        {
                            'name': 'x',
                            'type': 'number',
                            'default': 0
                        },
                        {
                            'name': 'y',
                            'type': 'number',
                            'default': 0
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'collide'
                    },
                    'params': [
                        {
                            'name': 'radius',
                            'type': 'number',
                            'expr': true
                        },
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': 0.7
                        },
                        {
                            'name': 'iterations',
                            'type': 'number',
                            'default': 1
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'nbody'
                    },
                    'params': [
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': -30,
                            'expr': true
                        },
                        {
                            'name': 'theta',
                            'type': 'number',
                            'default': 0.9
                        },
                        {
                            'name': 'distanceMin',
                            'type': 'number',
                            'default': 1
                        },
                        {
                            'name': 'distanceMax',
                            'type': 'number'
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'link'
                    },
                    'params': [
                        {
                            'name': 'links',
                            'type': 'data'
                        },
                        {
                            'name': 'id',
                            'type': 'field'
                        },
                        {
                            'name': 'distance',
                            'type': 'number',
                            'default': 30,
                            'expr': true
                        },
                        {
                            'name': 'strength',
                            'type': 'number',
                            'expr': true
                        },
                        {
                            'name': 'iterations',
                            'type': 'number',
                            'default': 1
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'x'
                    },
                    'params': [
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': 0.1
                        },
                        {
                            'name': 'x',
                            'type': 'field'
                        }
                    ]
                },
                {
                    'key': {
                        'force': 'y'
                    },
                    'params': [
                        {
                            'name': 'strength',
                            'type': 'number',
                            'default': 0.1
                        },
                        {
                            'name': 'y',
                            'type': 'field'
                        }
                    ]
                }
            ]
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'modify': false,
            'default': ForceOutput
        }
    ]
};
(0, _vegaUtil.inherits)(Force, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        var sim = this.value, change = pulse.changed(pulse.ADD_REM), params = _.modified(ForceParams), iters = _.iterations || 300;
        // configure simulation
        if (!sim) {
            this.value = sim = simulation(pulse.source, _);
            sim.on('tick', rerun(pulse.dataflow, this));
            if (!_.static) {
                change = true;
                sim.tick(); // ensure we run on init
            }
            pulse.modifies('index');
        } else {
            if (change) {
                pulse.modifies('index');
                sim.nodes(pulse.source);
            }
            if (params || pulse.changed(pulse.MOD)) setup(sim, _, 0, pulse);
        }
        // run simulation
        if (params || change || _.modified(ForceConfig) || pulse.changed() && _.restart) {
            sim.alpha(Math.max(sim.alpha(), _.alpha || 1)).alphaDecay(1 - Math.pow(sim.alphaMin(), 1 / iters));
            if (_.static) for(sim.stop(); --iters >= 0;)sim.tick();
            else {
                if (sim.stopped()) sim.restart();
                if (!change) return pulse.StopPropagation; // defer to sim ticks
            }
        }
        return this.finish(_, pulse);
    },
    finish (_, pulse) {
        const dataflow = pulse.dataflow;
        // inspect dependencies, touch link source data
        for(let args = this._argops, j = 0, m = args.length, arg; j < m; ++j){
            arg = args[j];
            if (arg.name !== Forces || arg.op._argval.force !== 'link') continue;
            for(var ops = arg.op._argops, i = 0, n = ops.length, op; i < n; ++i)if (ops[i].name === 'links' && (op = ops[i].op.source)) {
                dataflow.pulse(op, dataflow.changeset().reflow());
                break;
            }
        }
        // reflow all nodes
        return pulse.reflow(_.modified()).modifies(ForceOutput);
    }
});
function rerun(df, op) {
    return ()=>df.touch(op).run();
}
function simulation(nodes, _) {
    const sim = (0, _d3Force.forceSimulation)(nodes), stop = sim.stop, restart = sim.restart;
    let stopped = false;
    sim.stopped = ()=>stopped;
    sim.restart = ()=>(stopped = false, restart());
    sim.stop = ()=>(stopped = true, stop());
    return setup(sim, _, true).on('end', ()=>stopped = true);
}
function setup(sim, _, init, pulse) {
    var f = (0, _vegaUtil.array)(_.forces), i, n, p, name;
    for(i = 0, n = ForceParams.length; i < n; ++i){
        p = ForceParams[i];
        if (p !== Forces && _.modified(p)) sim[p](_[p]);
    }
    for(i = 0, n = f.length; i < n; ++i){
        name = Forces + i;
        p = init || _.modified(Forces, i) ? getForce(f[i]) : pulse && modified(f[i], pulse) ? sim.force(name) : null;
        if (p) sim.force(name, p);
    }
    for(n = sim.numForces || 0; i < n; ++i)sim.force(Forces + i, null); // remove
    sim.numForces = f.length;
    return sim;
}
function modified(f, pulse) {
    var k, v;
    for(k in f){
        if ((0, _vegaUtil.isFunction)(v = f[k]) && pulse.modified((0, _vegaUtil.accessorFields)(v))) return 1;
    }
    return 0;
}
function getForce(_) {
    var f, p;
    if (!(0, _vegaUtil.hasOwnProperty)(ForceMap, _.force)) (0, _vegaUtil.error)('Unrecognized force: ' + _.force);
    f = ForceMap[_.force]();
    for(p in _)if ((0, _vegaUtil.isFunction)(f[p])) setForceParam(f[p], _[p], _);
    return f;
}
function setForceParam(f, v, _) {
    f((0, _vegaUtil.isFunction)(v) ? (d)=>v(d, _) : v);
}

},{"vega-dataflow":"eoU45","vega-util":"kncZn","d3-force":"39JL7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39JL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceCenter", ()=>(0, _centerJsDefault.default));
parcelHelpers.export(exports, "forceCollide", ()=>(0, _collideJsDefault.default));
parcelHelpers.export(exports, "forceLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "forceManyBody", ()=>(0, _manyBodyJsDefault.default));
parcelHelpers.export(exports, "forceRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "forceSimulation", ()=>(0, _simulationJsDefault.default));
parcelHelpers.export(exports, "forceX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "forceY", ()=>(0, _yJsDefault.default));
var _centerJs = require("./center.js");
var _centerJsDefault = parcelHelpers.interopDefault(_centerJs);
var _collideJs = require("./collide.js");
var _collideJsDefault = parcelHelpers.interopDefault(_collideJs);
var _linkJs = require("./link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _manyBodyJs = require("./manyBody.js");
var _manyBodyJsDefault = parcelHelpers.interopDefault(_manyBodyJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _simulationJs = require("./simulation.js");
var _simulationJsDefault = parcelHelpers.interopDefault(_simulationJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);

},{"./center.js":"k3HJq","./collide.js":"cwyEu","./link.js":"gvzg5","./manyBody.js":"WlvbG","./radial.js":false,"./simulation.js":"jWL0m","./x.js":"kEXmp","./y.js":"cdBKy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k3HJq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwyEu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                            if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"d3-quadtree":"d5sFf","./constant.js":"2K30W","./jiggle.js":"9fHEz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d5sFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadtree", ()=>(0, _quadtreeJsDefault.default));
var _quadtreeJs = require("./quadtree.js");
var _quadtreeJsDefault = parcelHelpers.interopDefault(_quadtreeJs);

},{"./quadtree.js":"60xyB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"60xyB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"2TVLM","./cover.js":"iUBZo","./data.js":"bIuX8","./extent.js":"i0Pjn","./find.js":"exOv9","./remove.js":"5vdMH","./root.js":"7bueU","./size.js":"jTW2e","./visit.js":"9NrfC","./visitAfter.js":"i8GPg","./x.js":"8GC2s","./y.js":"eNKHk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2TVLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iUBZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bIuX8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i0Pjn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exOv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"hhEMd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hhEMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vdMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7bueU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jTW2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9NrfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"hhEMd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8GPg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"hhEMd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8GC2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eNKHk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2K30W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9fHEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(random) {
        return (random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvzg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantJsDefault.default)(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleJsDefault.default)(random);
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleJsDefault.default)(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}

},{"./constant.js":"2K30W","./jiggle.js":"9fHEz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WlvbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, random, alpha, strength = (0, _constantJsDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulationJs.x), (0, _simulationJs.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                    if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
var _simulationJs = require("./simulation.js");

},{"d3-quadtree":"d5sFf","./constant.js":"2K30W","./jiggle.js":"9fHEz","./simulation.js":"jWL0m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jWL0m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end"), random = (0, _lcgJsDefault.default)();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":"fCaQb","d3-timer":"cOPFt","./lcg.js":"cLvrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fCaQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"avnlO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"avnlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cOPFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"bgtMb","./timeout.js":false,"./interval.js":"lQOyO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bgtMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lQOyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer), total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? (0, _timerJs.now)() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"bgtMb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLvrs":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kEXmp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantJsDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2K30W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cdBKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantJsDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2K30W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i90iv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nest", ()=>Nest);
parcelHelpers.export(exports, "pack", ()=>Pack);
parcelHelpers.export(exports, "partition", ()=>Partition);
parcelHelpers.export(exports, "stratify", ()=>Stratify);
parcelHelpers.export(exports, "tree", ()=>Tree);
parcelHelpers.export(exports, "treelinks", ()=>TreeLinks);
parcelHelpers.export(exports, "treemap", ()=>Treemap);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Hierarchy = require("d3-hierarchy");
// Build lookup table mapping tuple keys to tree node instances
function lookup(tree, key, filter) {
    const map = {};
    tree.each((node)=>{
        const t = node.data;
        if (filter(t)) map[key(t)] = node;
    });
    tree.lookup = map;
    return tree;
}
/**
 * Nest tuples into a tree structure, grouped by key values.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.keys - The key fields to nest by, in order.
 * @param {boolean} [params.generate=false] - A boolean flag indicating if
 *   non-leaf nodes generated by this transform should be included in the
 *   output. The default (false) includes only the input data (leaf nodes)
 *   in the data stream.
 */ function Nest(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Nest.Definition = {
    'type': 'Nest',
    'metadata': {
        'treesource': true,
        'changes': true
    },
    'params': [
        {
            'name': 'keys',
            'type': 'field',
            'array': true
        },
        {
            'name': 'generate',
            'type': 'boolean'
        }
    ]
};
const children = (n)=>n.values;
(0, _vegaUtil.inherits)(Nest, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.source) (0, _vegaUtil.error)('Nest transform requires an upstream data source.');
        var gen = _.generate, mod = _.modified(), out = pulse.clone(), tree = this.value;
        if (!tree || mod || pulse.changed()) {
            // collect nodes to remove
            if (tree) tree.each((node)=>{
                if (node.children && (0, _vegaDataflow.isTuple)(node.data)) out.rem.push(node.data);
            });
            // generate new tree structure
            this.value = tree = (0, _d3Hierarchy.hierarchy)({
                values: (0, _vegaUtil.array)(_.keys).reduce((n, k)=>{
                    n.key(k);
                    return n;
                }, nest()).entries(out.source)
            }, children);
            // collect nodes to add
            if (gen) tree.each((node)=>{
                if (node.children) {
                    node = (0, _vegaDataflow.ingest)(node.data);
                    out.add.push(node);
                    out.source.push(node);
                }
            });
            // build lookup table
            lookup(tree, (0, _vegaDataflow.tupleid), (0, _vegaDataflow.tupleid));
        }
        out.source.root = tree;
        return out;
    }
});
function nest() {
    const keys = [], nest = {
        entries: (array)=>entries(apply(array, 0), 0),
        key: (d)=>(keys.push(d), nest)
    };
    function apply(array, depth) {
        if (depth >= keys.length) return array;
        const n = array.length, key = keys[depth++], valuesByKey = {}, result = {};
        let i = -1, keyValue, value, values;
        while(++i < n){
            keyValue = key(value = array[i]) + '';
            if (values = valuesByKey[keyValue]) values.push(value);
            else valuesByKey[keyValue] = [
                value
            ];
        }
        for(keyValue in valuesByKey)result[keyValue] = apply(valuesByKey[keyValue], depth);
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        const array = [];
        for(const key in map)array.push({
            key,
            values: entries(map[key], depth)
        });
        return array;
    }
    return nest;
}
/**
 * Abstract class for tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function HierarchyLayout(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
const defaultSeparation = (a, b)=>a.parent === b.parent ? 1 : 2;
(0, _vegaUtil.inherits)(HierarchyLayout, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.source || !pulse.source.root) (0, _vegaUtil.error)(this.constructor.name + ' transform requires a backing tree data source.');
        const layout = this.layout(_.method), fields = this.fields, root = pulse.source.root, as = _.as || fields;
        if (_.field) root.sum(_.field);
        else root.count();
        if (_.sort) root.sort((0, _vegaDataflow.stableCompare)(_.sort, (d)=>d.data));
        setParams(layout, this.params, _);
        if (layout.separation) layout.separation(_.separation !== false ? defaultSeparation : (0, _vegaUtil.one));
        try {
            this.value = layout(root);
        } catch (err) {
            (0, _vegaUtil.error)(err);
        }
        root.each((node)=>setFields(node, fields, as));
        return pulse.reflow(_.modified()).modifies(as).modifies('leaf');
    }
});
function setParams(layout, params, _) {
    for(let p, i = 0, n = params.length; i < n; ++i){
        p = params[i];
        if (p in _) layout[p](_[p]);
    }
}
function setFields(node, fields, as) {
    const t = node.data, n = fields.length - 1;
    for(let i = 0; i < n; ++i)t[as[i]] = node[fields[i]];
    t[as[n]] = node.children ? node.children.length : 0;
}
const Output$3 = [
    'x',
    'y',
    'r',
    'depth',
    'children'
];
/**
 * Packed circle tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */ function Pack(params) {
    HierarchyLayout.call(this, params);
}
Pack.Definition = {
    'type': 'Pack',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'padding',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'radius',
            'type': 'field',
            'default': null
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output$3.length,
            'default': Output$3
        }
    ]
};
(0, _vegaUtil.inherits)(Pack, HierarchyLayout, {
    layout: (0, _d3Hierarchy.pack),
    params: [
        'radius',
        'size',
        'padding'
    ],
    fields: Output$3
});
const Output$2 = [
    'x0',
    'y0',
    'x1',
    'y1',
    'depth',
    'children'
];
/**
 * Partition tree layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */ function Partition(params) {
    HierarchyLayout.call(this, params);
}
Partition.Definition = {
    'type': 'Partition',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'padding',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'round',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output$2.length,
            'default': Output$2
        }
    ]
};
(0, _vegaUtil.inherits)(Partition, HierarchyLayout, {
    layout: (0, _d3Hierarchy.partition),
    params: [
        'size',
        'round',
        'padding'
    ],
    fields: Output$2
});
/**
 * Stratify a collection of tuples into a tree structure based on
 * id and parent id fields.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.key - Unique key field for each tuple.
 * @param {function(object): *} params.parentKey - Field with key for parent tuple.
 */ function Stratify(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Stratify.Definition = {
    'type': 'Stratify',
    'metadata': {
        'treesource': true
    },
    'params': [
        {
            'name': 'key',
            'type': 'field',
            'required': true
        },
        {
            'name': 'parentKey',
            'type': 'field',
            'required': true
        }
    ]
};
(0, _vegaUtil.inherits)(Stratify, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!pulse.source) (0, _vegaUtil.error)('Stratify transform requires an upstream data source.');
        let tree = this.value;
        const mod = _.modified(), out = pulse.fork(pulse.ALL).materialize(pulse.SOURCE), run = !tree || mod || pulse.changed(pulse.ADD_REM) || pulse.modified(_.key.fields) || pulse.modified(_.parentKey.fields);
        // prevent upstream source pollution
        out.source = out.source.slice();
        if (run) tree = out.source.length ? lookup((0, _d3Hierarchy.stratify)().id(_.key).parentId(_.parentKey)(out.source), _.key, (0, _vegaUtil.truthy)) : lookup((0, _d3Hierarchy.stratify)()([
            {}
        ]), _.key, _.key);
        out.source.root = this.value = tree;
        return out;
    }
});
const Layouts = {
    tidy: (0, _d3Hierarchy.tree),
    cluster: (0, _d3Hierarchy.cluster)
};
const Output$1 = [
    'x',
    'y',
    'depth',
    'children'
];
/**
 * Tree layout. Depending on the method parameter, performs either
 * Reingold-Tilford 'tidy' layout or dendrogram 'cluster' layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function Tree(params) {
    HierarchyLayout.call(this, params);
}
Tree.Definition = {
    'type': 'Tree',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'method',
            'type': 'enum',
            'default': 'tidy',
            'values': [
                'tidy',
                'cluster'
            ]
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'nodeSize',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'separation',
            'type': 'boolean',
            'default': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output$1.length,
            'default': Output$1
        }
    ]
};
(0, _vegaUtil.inherits)(Tree, HierarchyLayout, {
    /**
   * Tree layout generator. Supports both 'tidy' and 'cluster' layouts.
   */ layout (method) {
        const m = method || 'tidy';
        if ((0, _vegaUtil.hasOwnProperty)(Layouts, m)) return Layouts[m]();
        else (0, _vegaUtil.error)('Unrecognized Tree layout method: ' + m);
    },
    params: [
        'size',
        'nodeSize'
    ],
    fields: Output$1
});
/**
 * Generate tuples representing links between tree nodes.
 * The resulting tuples will contain 'source' and 'target' fields,
 * which point to parent and child node tuples, respectively.
 * @constructor
 * @param {object} params - The parameters for this operator.
 */ function TreeLinks(params) {
    (0, _vegaDataflow.Transform).call(this, [], params);
}
TreeLinks.Definition = {
    'type': 'TreeLinks',
    'metadata': {
        'tree': true,
        'generates': true,
        'changes': true
    },
    'params': []
};
(0, _vegaUtil.inherits)(TreeLinks, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const links = this.value, tree = pulse.source && pulse.source.root, out = pulse.fork(pulse.NO_SOURCE), lut = {};
        if (!tree) (0, _vegaUtil.error)('TreeLinks transform requires a tree data source.');
        if (pulse.changed(pulse.ADD_REM)) {
            // remove previous links
            out.rem = links;
            // build lookup table of valid tuples
            pulse.visit(pulse.SOURCE, (t)=>lut[(0, _vegaDataflow.tupleid)(t)] = 1);
            // generate links for all edges incident on valid tuples
            tree.each((node)=>{
                const t = node.data, p = node.parent && node.parent.data;
                if (p && lut[(0, _vegaDataflow.tupleid)(t)] && lut[(0, _vegaDataflow.tupleid)(p)]) out.add.push((0, _vegaDataflow.ingest)({
                    source: p,
                    target: t
                }));
            });
            this.value = out.add;
        } else if (pulse.changed(pulse.MOD)) {
            // build lookup table of modified tuples
            pulse.visit(pulse.MOD, (t)=>lut[(0, _vegaDataflow.tupleid)(t)] = 1);
            // gather links incident on modified tuples
            links.forEach((link)=>{
                if (lut[(0, _vegaDataflow.tupleid)(link.source)] || lut[(0, _vegaDataflow.tupleid)(link.target)]) out.mod.push(link);
            });
        }
        return out;
    }
});
const Tiles = {
    binary: (0, _d3Hierarchy.treemapBinary),
    dice: (0, _d3Hierarchy.treemapDice),
    slice: (0, _d3Hierarchy.treemapSlice),
    slicedice: (0, _d3Hierarchy.treemapSliceDice),
    squarify: (0, _d3Hierarchy.treemapSquarify),
    resquarify: (0, _d3Hierarchy.treemapResquarify)
};
const Output = [
    'x0',
    'y0',
    'x1',
    'y1',
    'depth',
    'children'
];
/**
 * Treemap layout.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.field - The value field to size nodes.
 */ function Treemap(params) {
    HierarchyLayout.call(this, params);
}
Treemap.Definition = {
    'type': 'Treemap',
    'metadata': {
        'tree': true,
        'modifies': true
    },
    'params': [
        {
            'name': 'field',
            'type': 'field'
        },
        {
            'name': 'sort',
            'type': 'compare'
        },
        {
            'name': 'method',
            'type': 'enum',
            'default': 'squarify',
            'values': [
                'squarify',
                'resquarify',
                'binary',
                'dice',
                'slice',
                'slicedice'
            ]
        },
        {
            'name': 'padding',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingInner',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingOuter',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingTop',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingRight',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingBottom',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'paddingLeft',
            'type': 'number',
            'default': 0
        },
        {
            'name': 'ratio',
            'type': 'number',
            'default': 1.618033988749895
        },
        {
            'name': 'round',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': Output.length,
            'default': Output
        }
    ]
};
(0, _vegaUtil.inherits)(Treemap, HierarchyLayout, {
    /**
   * Treemap layout generator. Adds 'method' and 'ratio' parameters
   * to configure the underlying tile method.
   */ layout () {
        const x = (0, _d3Hierarchy.treemap)();
        x.ratio = (_)=>{
            const t = x.tile();
            if (t.ratio) x.tile(t.ratio(_));
        };
        x.method = (_)=>{
            if ((0, _vegaUtil.hasOwnProperty)(Tiles, _)) x.tile(Tiles[_]);
            else (0, _vegaUtil.error)('Unrecognized Treemap layout method: ' + _);
        };
        return x;
    },
    params: [
        'method',
        'ratio',
        'size',
        'round',
        'padding',
        'paddingInner',
        'paddingOuter',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft'
    ],
    fields: Output
});

},{"vega-dataflow":"eoU45","vega-util":"kncZn","d3-hierarchy":"ib0IG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ib0IG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cluster", ()=>(0, _clusterJsDefault.default));
parcelHelpers.export(exports, "hierarchy", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "Node", ()=>(0, _indexJs.Node));
parcelHelpers.export(exports, "pack", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "packSiblings", ()=>(0, _siblingsJsDefault.default));
parcelHelpers.export(exports, "packEnclose", ()=>(0, _encloseJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "stratify", ()=>(0, _stratifyJsDefault.default));
parcelHelpers.export(exports, "tree", ()=>(0, _treeJsDefault.default));
parcelHelpers.export(exports, "treemap", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "treemapBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "treemapDice", ()=>(0, _diceJsDefault.default));
parcelHelpers.export(exports, "treemapSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "treemapSliceDice", ()=>(0, _sliceDiceJsDefault.default));
parcelHelpers.export(exports, "treemapSquarify", ()=>(0, _squarifyJsDefault.default));
parcelHelpers.export(exports, "treemapResquarify", ()=>(0, _resquarifyJsDefault.default));
var _clusterJs = require("./cluster.js");
var _clusterJsDefault = parcelHelpers.interopDefault(_clusterJs);
var _indexJs = require("./hierarchy/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./pack/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _siblingsJs = require("./pack/siblings.js");
var _siblingsJsDefault = parcelHelpers.interopDefault(_siblingsJs);
var _encloseJs = require("./pack/enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _stratifyJs = require("./stratify.js");
var _stratifyJsDefault = parcelHelpers.interopDefault(_stratifyJs);
var _treeJs = require("./tree.js");
var _treeJsDefault = parcelHelpers.interopDefault(_treeJs);
var _indexJs2 = require("./treemap/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _binaryJs = require("./treemap/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./treemap/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sliceDiceJs = require("./treemap/sliceDice.js");
var _sliceDiceJsDefault = parcelHelpers.interopDefault(_sliceDiceJs);
var _squarifyJs = require("./treemap/squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _resquarifyJs = require("./treemap/resquarify.js");
var _resquarifyJsDefault = parcelHelpers.interopDefault(_resquarifyJs);

},{"./cluster.js":"80u41","./hierarchy/index.js":"dielx","./pack/index.js":"g70u9","./pack/siblings.js":false,"./pack/enclose.js":false,"./partition.js":"2cSVo","./stratify.js":"b3EYW","./tree.js":"6ix7A","./treemap/index.js":"dQUds","./treemap/binary.js":"cwOYb","./treemap/dice.js":"2vaII","./treemap/slice.js":"fnBvC","./treemap/sliceDice.js":"5nWez","./treemap/squarify.js":"dFeQs","./treemap/resquarify.js":"gjqpQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80u41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    });
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
    return x + c.x;
}
function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dielx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
function hierarchy(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = mapChildren;
    } else if (children === undefined) children = objectChildren;
    var root = new Node(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new Node(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
    return d.children;
}
function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    find: (0, _findJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy,
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};

},{"./count.js":"eSSsq","./each.js":"5HqsA","./eachBefore.js":"cEibP","./eachAfter.js":"7y28Y","./find.js":"fxLUL","./sum.js":"cBkcq","./sort.js":"kdz8M","./path.js":"h8btk","./ancestors.js":"Ps2TY","./descendants.js":"46Kyd","./leaves.js":"ftjw3","./links.js":"rmksM","./iterator.js":"1OfuY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eSSsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5HqsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cEibP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7y28Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fxLUL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cBkcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kdz8M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8btk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Ps2TY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"46Kyd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ftjw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"rmksM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1OfuY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g70u9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var radius = null, dx = 1, dy = 1, padding = (0, _constantJs.constantZero);
        function pack(root) {
            const random = (0, _lcgJsDefault.default)();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom((0, _constantJs.constantZero), 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = (0, _accessorsJs.optional)(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), pack) : padding;
        };
        return pack;
    });
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _siblingsJs = require("./siblings.js");
function defaultRadius(d) {
    return Math.sqrt(d.value);
}
function radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, _siblingsJs.packSiblingsRandom)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

},{"../accessors.js":"bZ9BQ","../constant.js":"cLuOx","../lcg.js":"lu3XO","./siblings.js":"k2M8h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bZ9BQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "required", ()=>required);
function optional(f) {
    return f == null ? null : required(f);
}
function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLuOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantZero", ()=>constantZero);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });
function constantZero() {
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lu3XO":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k2M8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packSiblingsRandom", ()=>packSiblingsRandom);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        packSiblingsRandom(circles, (0, _lcgJsDefault.default)());
        return circles;
    });
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _encloseJs = require("./enclose.js");
function place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function packSiblingsRandom(circles, random) {
    if (!(n = (circles = (0, _arrayJsDefault.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        place(a._, b._, c = circles[i]), c = new Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if (intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if (intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = score(a);
        while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, _encloseJs.packEncloseRandom)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}

},{"../array.js":"2xiEp","../lcg.js":"lu3XO","./enclose.js":"dlMAD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2xiEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
function shuffle(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlMAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        return packEncloseRandom(circles, (0, _lcgJsDefault.default)());
    });
parcelHelpers.export(exports, "packEncloseRandom", ()=>packEncloseRandom);
var _arrayJs = require("../array.js");
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function packEncloseRandom(circles, random) {
    var i = 0, n = (circles = (0, _arrayJs.shuffle)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && enclosesWeak(e, p)) ++i;
        else e = encloseBasis(B = extendBasis(B, p)), i = 0;
    }
    return e;
}
function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function encloseBasis(B) {
    switch(B.length){
        case 1:
            return encloseBasis1(B[0]);
        case 2:
            return encloseBasis2(B[0], B[1]);
        case 3:
            return encloseBasis3(B[0], B[1], B[2]);
    }
}
function encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

},{"../array.js":"2xiEp","../lcg.js":"lu3XO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2cSVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) (0, _diceJsDefault.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    });
var _roundJs = require("./treemap/round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);

},{"./treemap/round.js":"lDVwz","./treemap/dice.js":"2vaII","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDVwz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2vaII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3EYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new (0, _indexJs.Node)(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore((0, _indexJs.computeHeight));
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = (0, _accessorsJs.optional)(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = (0, _accessorsJs.optional)(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = (0, _accessorsJs.optional)(x), stratify) : path;
        };
        return stratify;
    });
var _accessorsJs = require("./accessors.js");
var _indexJs = require("./hierarchy/index.js");
var preroot = {
    depth: -1
}, ambiguous = {}, imputed = {};
function defaultId(d) {
    return d.id;
}
function defaultParentId(d) {
    return d.parentId;
}
// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function normalize(path) {
    path = `${path}`;
    let i = path.length;
    if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
}
// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while(--i > 1)if (slash(path, i)) break;
    return path.slice(0, i);
}
// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function slash(path, i) {
    if (path[i] === "/") {
        let k = 0;
        while(i > 0 && path[--i] === "\\")++k;
        if ((k & 1) === 0) return true;
    }
    return false;
}

},{"./accessors.js":"bZ9BQ","./hierarchy/index.js":"dielx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ix7A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    });
var _indexJs = require("./hierarchy/index.js");
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
TreeNode.prototype = Object.create((0, _indexJs.Node).prototype);
function treeRoot(root) {
    var tree = new TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}

},{"./hierarchy/index.js":"dielx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dQUds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var tile = (0, _squarifyJsDefault.default), round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = (0, _constantJs.constantZero), paddingTop = (0, _constantJs.constantZero), paddingRight = (0, _constantJs.constantZero), paddingBottom = (0, _constantJs.constantZero), paddingLeft = (0, _constantJs.constantZero);
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = (0, _accessorsJs.required)(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingLeft;
        };
        return treemap;
    });
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _squarifyJs = require("./squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./round.js":"lDVwz","./squarify.js":"dFeQs","../accessors.js":"bZ9BQ","../constant.js":"cLuOx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dFeQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"2vaII","./slice.js":"fnBvC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fnBvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwOYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5nWez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"2vaII","./slice.js":"fnBvC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gjqpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"2vaII","./slice.js":"fnBvC","./squarify.js":"dFeQs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"527mi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "label", ()=>Label);
var _vegaScenegraph = require("vega-scenegraph");
var _vegaCanvas = require("vega-canvas");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
// bit mask for getting first 2 bytes of alpha value
const ALPHA_MASK = 0xff000000;
function baseBitmaps($, data) {
    const bitmap = $.bitmap();
    // when there is no base mark but data points are to be avoided
    (data || []).forEach((d)=>bitmap.set($(d.boundary[0]), $(d.boundary[3])));
    return [
        bitmap,
        undefined
    ];
}
function markBitmaps($, baseMark, avoidMarks, labelInside, isGroupArea) {
    // create canvas
    const width = $.width, height = $.height, border = labelInside || isGroupArea, context = (0, _vegaCanvas.canvas)(width, height).getContext('2d'), baseMarkContext = (0, _vegaCanvas.canvas)(width, height).getContext('2d'), strokeContext = border && (0, _vegaCanvas.canvas)(width, height).getContext('2d');
    // render all marks to be avoided into canvas
    avoidMarks.forEach((items)=>draw(context, items, false));
    draw(baseMarkContext, baseMark, false);
    if (border) draw(strokeContext, baseMark, true);
    // get canvas buffer, create bitmaps
    const buffer = getBuffer(context, width, height), baseMarkBuffer = getBuffer(baseMarkContext, width, height), strokeBuffer = border && getBuffer(strokeContext, width, height), layer1 = $.bitmap(), layer2 = border && $.bitmap();
    // populate bitmap layers
    let x, y, u, v, index, alpha, strokeAlpha, baseMarkAlpha;
    for(y = 0; y < height; ++y)for(x = 0; x < width; ++x){
        index = y * width + x;
        alpha = buffer[index] & ALPHA_MASK;
        baseMarkAlpha = baseMarkBuffer[index] & ALPHA_MASK;
        strokeAlpha = border && strokeBuffer[index] & ALPHA_MASK;
        if (alpha || strokeAlpha || baseMarkAlpha) {
            u = $(x);
            v = $(y);
            if (!isGroupArea && (alpha || baseMarkAlpha)) layer1.set(u, v); // update interior bitmap
            if (border && (alpha || strokeAlpha)) layer2.set(u, v); // update border bitmap
        }
    }
    return [
        layer1,
        layer2
    ];
}
function getBuffer(context, width, height) {
    return new Uint32Array(context.getImageData(0, 0, width, height).data.buffer);
}
function draw(context, items, interior) {
    if (!items.length) return;
    const type = items[0].mark.marktype;
    if (type === 'group') items.forEach((group)=>{
        group.items.forEach((mark)=>draw(context, mark.items, interior));
    });
    else (0, _vegaScenegraph.Marks)[type].draw(context, {
        items: interior ? items.map(prepare) : items
    });
}
/**
 * Prepare item before drawing into canvas (setting stroke and opacity)
 * @param {object} source item to be prepared
 * @returns prepared item
 */ function prepare(source) {
    const item = (0, _vegaDataflow.rederive)(source, {});
    if (item.stroke && item.strokeOpacity !== 0 || item.fill && item.fillOpacity !== 0) return {
        ...item,
        strokeOpacity: 1,
        stroke: '#000',
        fillOpacity: 0
    };
    return item;
}
const DIV = 5, // bit shift from x, y index to bit vector array index
MOD = 31, // bit mask for index lookup within a bit vector
SIZE = 32, // individual bit vector size
RIGHT0 = new Uint32Array(SIZE + 1), // left-anchored bit vectors, full -> 0
RIGHT1 = new Uint32Array(SIZE + 1); // right-anchored bit vectors, 0 -> full
RIGHT1[0] = 0;
RIGHT0[0] = ~RIGHT1[0];
for(let i = 1; i <= SIZE; ++i){
    RIGHT1[i] = RIGHT1[i - 1] << 1 | 1;
    RIGHT0[i] = ~RIGHT1[i];
}
function Bitmap(w, h) {
    const array = new Uint32Array(~~((w * h + SIZE) / SIZE));
    function _set(index, mask) {
        array[index] |= mask;
    }
    function _clear(index, mask) {
        array[index] &= mask;
    }
    return {
        array: array,
        get: (x, y)=>{
            const index = y * w + x;
            return array[index >>> DIV] & 1 << (index & MOD);
        },
        set: (x, y)=>{
            const index = y * w + x;
            _set(index >>> DIV, 1 << (index & MOD));
        },
        clear: (x, y)=>{
            const index = y * w + x;
            _clear(index >>> DIV, ~(1 << (index & MOD)));
        },
        getRange: (x, y, x2, y2)=>{
            let r = y2, start, end, indexStart, indexEnd;
            for(; r >= y; --r){
                start = r * w + x;
                end = r * w + x2;
                indexStart = start >>> DIV;
                indexEnd = end >>> DIV;
                if (indexStart === indexEnd) {
                    if (array[indexStart] & RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]) return true;
                } else {
                    if (array[indexStart] & RIGHT0[start & MOD]) return true;
                    if (array[indexEnd] & RIGHT1[(end & MOD) + 1]) return true;
                    for(let i = indexStart + 1; i < indexEnd; ++i){
                        if (array[i]) return true;
                    }
                }
            }
            return false;
        },
        setRange: (x, y, x2, y2)=>{
            let start, end, indexStart, indexEnd, i;
            for(; y <= y2; ++y){
                start = y * w + x;
                end = y * w + x2;
                indexStart = start >>> DIV;
                indexEnd = end >>> DIV;
                if (indexStart === indexEnd) _set(indexStart, RIGHT0[start & MOD] & RIGHT1[(end & MOD) + 1]);
                else {
                    _set(indexStart, RIGHT0[start & MOD]);
                    _set(indexEnd, RIGHT1[(end & MOD) + 1]);
                    for(i = indexStart + 1; i < indexEnd; ++i)_set(i, 0xffffffff);
                }
            }
        },
        clearRange: (x, y, x2, y2)=>{
            let start, end, indexStart, indexEnd, i;
            for(; y <= y2; ++y){
                start = y * w + x;
                end = y * w + x2;
                indexStart = start >>> DIV;
                indexEnd = end >>> DIV;
                if (indexStart === indexEnd) _clear(indexStart, RIGHT1[start & MOD] | RIGHT0[(end & MOD) + 1]);
                else {
                    _clear(indexStart, RIGHT1[start & MOD]);
                    _clear(indexEnd, RIGHT0[(end & MOD) + 1]);
                    for(i = indexStart + 1; i < indexEnd; ++i)_clear(i, 0);
                }
            }
        },
        outOfBounds: (x, y, x2, y2)=>x < 0 || y < 0 || y2 >= h || x2 >= w
    };
}
function scaler(width, height, padding) {
    const ratio = Math.max(1, Math.sqrt(width * height / 1e6)), w = ~~((width + 2 * padding + ratio) / ratio), h = ~~((height + 2 * padding + ratio) / ratio), scale = (_)=>~~((_ + padding) / ratio);
    scale.invert = (_)=>_ * ratio - padding;
    scale.bitmap = ()=>Bitmap(w, h);
    scale.ratio = ratio;
    scale.padding = padding;
    scale.width = width;
    scale.height = height;
    return scale;
}
function placeAreaLabelNaive($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width, height = $.height;
    // try to place a label within an input area mark
    return function(d) {
        const items = d.datum.datum.items[markIndex].items, // area points
        n = items.length, // number of points
        textHeight = d.datum.fontSize, // label width
        textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text); // label height
        let maxAreaWidth = 0, x1, x2, y1, y2, x, y, areaWidth;
        // for each area sample point
        for(let i = 0; i < n; ++i){
            x1 = items[i].x;
            y1 = items[i].y;
            x2 = items[i].x2 === undefined ? x1 : items[i].x2;
            y2 = items[i].y2 === undefined ? y1 : items[i].y2;
            x = (x1 + x2) / 2;
            y = (y1 + y2) / 2;
            areaWidth = Math.abs(x2 - x1 + y2 - y1);
            if (areaWidth >= maxAreaWidth) {
                maxAreaWidth = areaWidth;
                d.x = x;
                d.y = y;
            }
        }
        x = textWidth / 2;
        y = textHeight / 2;
        x1 = d.x - x;
        x2 = d.x + x;
        y1 = d.y - y;
        y2 = d.y + y;
        d.align = 'center';
        if (x1 < 0 && x2 <= width) d.align = 'left';
        else if (0 <= x1 && width < x2) d.align = 'right';
        d.baseline = 'middle';
        if (y1 < 0 && y2 <= height) d.baseline = 'top';
        else if (0 <= y1 && height < y2) d.baseline = 'bottom';
        return true;
    };
}
function outOfBounds(x, y, textWidth, textHeight, width, height) {
    let r = textWidth / 2;
    return x - r < 0 || x + r > width || y - (r = textHeight / 2) < 0 || y + r > height;
}
function collision($, x, y, textHeight, textWidth, h, bm0, bm1) {
    const w = textWidth * h / (textHeight * 2), x1 = $(x - w), x2 = $(x + w), y1 = $(y - (h = h / 2)), y2 = $(y + h);
    return bm0.outOfBounds(x1, y1, x2, y2) || bm0.getRange(x1, y1, x2, y2) || bm1 && bm1.getRange(x1, y1, x2, y2);
}
function placeAreaLabelReducedSearch($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width, height = $.height, bm0 = bitmaps[0], // where labels have been placed
    bm1 = bitmaps[1]; // area outlines
    function tryLabel(_x, _y, maxSize, textWidth, textHeight) {
        const x = $.invert(_x), y = $.invert(_y);
        let lo = maxSize, hi = height, mid;
        if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
            // if the label fits at the current sample point,
            // perform binary search to find the largest font size that fits
            while(hi - lo >= 1){
                mid = (lo + hi) / 2;
                if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) hi = mid;
                else lo = mid;
            }
            // place label if current lower bound exceeds prior max font size
            if (lo > maxSize) return [
                x,
                y,
                lo,
                true
            ];
        }
    }
    // try to place a label within an input area mark
    return function(d) {
        const items = d.datum.datum.items[markIndex].items, // area points
        n = items.length, // number of points
        textHeight = d.datum.fontSize, // label width
        textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text); // label height
        let maxSize = avoidBaseMark ? textHeight : 0, labelPlaced = false, labelPlaced2 = false, maxAreaWidth = 0, x1, x2, y1, y2, x, y, _x, _y, _x1, _xMid, _x2, _y1, _yMid, _y2, areaWidth, result, swapTmp;
        // for each area sample point
        for(let i = 0; i < n; ++i){
            x1 = items[i].x;
            y1 = items[i].y;
            x2 = items[i].x2 === undefined ? x1 : items[i].x2;
            y2 = items[i].y2 === undefined ? y1 : items[i].y2;
            if (x1 > x2) {
                swapTmp = x1;
                x1 = x2;
                x2 = swapTmp;
            }
            if (y1 > y2) {
                swapTmp = y1;
                y1 = y2;
                y2 = swapTmp;
            }
            _x1 = $(x1);
            _x2 = $(x2);
            _xMid = ~~((_x1 + _x2) / 2);
            _y1 = $(y1);
            _y2 = $(y2);
            _yMid = ~~((_y1 + _y2) / 2);
            // search along the line from mid point between the 2 border to lower border
            for(_x = _xMid; _x >= _x1; --_x)for(_y = _yMid; _y >= _y1; --_y){
                result = tryLabel(_x, _y, maxSize, textWidth, textHeight);
                if (result) [d.x, d.y, maxSize, labelPlaced] = result;
            }
            // search along the line from mid point between the 2 border to upper border
            for(_x = _xMid; _x <= _x2; ++_x)for(_y = _yMid; _y <= _y2; ++_y){
                result = tryLabel(_x, _y, maxSize, textWidth, textHeight);
                if (result) [d.x, d.y, maxSize, labelPlaced] = result;
            }
            // place label at slice center if not placed through other means
            // and if we're not avoiding overlap with other areas
            if (!labelPlaced && !avoidBaseMark) {
                // one span is zero, hence we can add
                areaWidth = Math.abs(x2 - x1 + y2 - y1);
                x = (x1 + x2) / 2;
                y = (y1 + y2) / 2;
                // place label if it fits and improves the max area width
                if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
                    maxAreaWidth = areaWidth;
                    d.x = x;
                    d.y = y;
                    labelPlaced2 = true;
                }
            }
        }
        // record current label placement information, update label bitmap
        if (labelPlaced || labelPlaced2) {
            x = textWidth / 2;
            y = textHeight / 2;
            bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
            d.align = 'center';
            d.baseline = 'middle';
            return true;
        } else return false;
    };
}
// pixel direction offsets for flood fill search
const X_DIR = [
    -1,
    -1,
    1,
    1
];
const Y_DIR = [
    -1,
    1,
    -1,
    1
];
function placeAreaLabelFloodFill($, bitmaps, avoidBaseMark, markIndex) {
    const width = $.width, height = $.height, bm0 = bitmaps[0], // where labels have been placed
    bm1 = bitmaps[1], // area outlines
    bm2 = $.bitmap(); // flood-fill visitations
    // try to place a label within an input area mark
    return function(d) {
        const items = d.datum.datum.items[markIndex].items, // area points
        n = items.length, // number of points
        textHeight = d.datum.fontSize, // label width
        textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text), // label height
        stack = []; // flood fill stack
        let maxSize = avoidBaseMark ? textHeight : 0, labelPlaced = false, labelPlaced2 = false, maxAreaWidth = 0, x1, x2, y1, y2, x, y, _x, _y, lo, hi, mid, areaWidth;
        // for each area sample point
        for(let i = 0; i < n; ++i){
            x1 = items[i].x;
            y1 = items[i].y;
            x2 = items[i].x2 === undefined ? x1 : items[i].x2;
            y2 = items[i].y2 === undefined ? y1 : items[i].y2;
            // add scaled center point to stack
            stack.push([
                $((x1 + x2) / 2),
                $((y1 + y2) / 2)
            ]);
            // perform flood fill, visit points
            while(stack.length){
                [_x, _y] = stack.pop();
                // exit if point already marked
                if (bm0.get(_x, _y) || bm1.get(_x, _y) || bm2.get(_x, _y)) continue;
                // mark point in flood fill bitmap
                // add search points for all (in bound) directions
                bm2.set(_x, _y);
                for(let j = 0; j < 4; ++j){
                    x = _x + X_DIR[j];
                    y = _y + Y_DIR[j];
                    if (!bm2.outOfBounds(x, y, x, y)) stack.push([
                        x,
                        y
                    ]);
                }
                // unscale point back to x, y space
                x = $.invert(_x);
                y = $.invert(_y);
                lo = maxSize;
                hi = height; // TODO: make this bound smaller
                if (!outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, lo, bm0, bm1) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
                    // if the label fits at the current sample point,
                    // perform binary search to find the largest font size that fits
                    while(hi - lo >= 1){
                        mid = (lo + hi) / 2;
                        if (collision($, x, y, textHeight, textWidth, mid, bm0, bm1)) hi = mid;
                        else lo = mid;
                    }
                    // place label if current lower bound exceeds prior max font size
                    if (lo > maxSize) {
                        d.x = x;
                        d.y = y;
                        maxSize = lo;
                        labelPlaced = true;
                    }
                }
            }
            // place label at slice center if not placed through other means
            // and if we're not avoiding overlap with other areas
            if (!labelPlaced && !avoidBaseMark) {
                // one span is zero, hence we can add
                areaWidth = Math.abs(x2 - x1 + y2 - y1);
                x = (x1 + x2) / 2;
                y = (y1 + y2) / 2;
                // place label if it fits and improves the max area width
                if (areaWidth >= maxAreaWidth && !outOfBounds(x, y, textWidth, textHeight, width, height) && !collision($, x, y, textHeight, textWidth, textHeight, bm0, null)) {
                    maxAreaWidth = areaWidth;
                    d.x = x;
                    d.y = y;
                    labelPlaced2 = true;
                }
            }
        }
        // record current label placement information, update label bitmap
        if (labelPlaced || labelPlaced2) {
            x = textWidth / 2;
            y = textHeight / 2;
            bm0.setRange($(d.x - x), $(d.y - y), $(d.x + x), $(d.y + y));
            d.align = 'center';
            d.baseline = 'middle';
            return true;
        } else return false;
    };
}
const Aligns = [
    'right',
    'center',
    'left'
], Baselines = [
    'bottom',
    'middle',
    'top'
];
function placeMarkLabel($, bitmaps, anchors, offsets) {
    const width = $.width, height = $.height, bm0 = bitmaps[0], bm1 = bitmaps[1], n = offsets.length;
    return function(d) {
        const boundary = d.boundary, textHeight = d.datum.fontSize;
        // can not be placed if the mark is not visible in the graph bound
        if (boundary[2] < 0 || boundary[5] < 0 || boundary[0] > width || boundary[3] > height) return false;
        let textWidth = d.textWidth ?? 0, dx, dy, isInside, sizeFactor, insideFactor, x1, x2, y1, y2, xc, yc, _x1, _x2, _y1, _y2;
        // for each anchor and offset
        for(let i = 0; i < n; ++i){
            dx = (anchors[i] & 0x3) - 1;
            dy = (anchors[i] >>> 0x2 & 0x3) - 1;
            isInside = dx === 0 && dy === 0 || offsets[i] < 0;
            sizeFactor = dx && dy ? Math.SQRT1_2 : 1;
            insideFactor = offsets[i] < 0 ? -1 : 1;
            x1 = boundary[1 + dx] + offsets[i] * dx * sizeFactor;
            yc = boundary[4 + dy] + insideFactor * textHeight * dy / 2 + offsets[i] * dy * sizeFactor;
            y1 = yc - textHeight / 2;
            y2 = yc + textHeight / 2;
            _x1 = $(x1);
            _y1 = $(y1);
            _y2 = $(y2);
            if (!textWidth) {
                // to avoid finding width of text label,
                if (!test(_x1, _x1, _y1, _y2, bm0, bm1, x1, x1, y1, y2, boundary, isInside)) continue;
                else // Otherwise, find the label width
                textWidth = (0, _vegaScenegraph.textMetrics).width(d.datum, d.datum.text);
            }
            xc = x1 + insideFactor * textWidth * dx / 2;
            x1 = xc - textWidth / 2;
            x2 = xc + textWidth / 2;
            _x1 = $(x1);
            _x2 = $(x2);
            if (test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside)) {
                // place label if the position is placeable
                d.x = !dx ? xc : dx * insideFactor < 0 ? x2 : x1;
                d.y = !dy ? yc : dy * insideFactor < 0 ? y2 : y1;
                d.align = Aligns[dx * insideFactor + 1];
                d.baseline = Baselines[dy * insideFactor + 1];
                bm0.setRange(_x1, _y1, _x2, _y2);
                return true;
            }
        }
        return false;
    };
}
// Test if a label with the given dimensions can be added without overlap
function test(_x1, _x2, _y1, _y2, bm0, bm1, x1, x2, y1, y2, boundary, isInside) {
    return !(bm0.outOfBounds(_x1, _y1, _x2, _y2) || (isInside && bm1 || bm0).getRange(_x1, _y1, _x2, _y2));
}
// 8-bit representation of anchors
const TOP = 0x0, MIDDLE = 0x4, BOTTOM = 0x8, LEFT = 0x0, CENTER = 0x1, RIGHT = 0x2;
// Mapping from text anchor to number representation
const anchorCode = {
    'top-left': TOP + LEFT,
    'top': TOP + CENTER,
    'top-right': TOP + RIGHT,
    'left': MIDDLE + LEFT,
    'middle': MIDDLE + CENTER,
    'right': MIDDLE + RIGHT,
    'bottom-left': BOTTOM + LEFT,
    'bottom': BOTTOM + CENTER,
    'bottom-right': BOTTOM + RIGHT
};
const placeAreaLabel = {
    'naive': placeAreaLabelNaive,
    'reduced-search': placeAreaLabelReducedSearch,
    'floodfill': placeAreaLabelFloodFill
};
function labelLayout(texts, size, compare, offset, anchor, avoidMarks, avoidBaseMark, lineAnchor, markIndex, padding, method) {
    // early exit for empty data
    if (!texts.length) return texts;
    const positions = Math.max(offset.length, anchor.length), offsets = getOffsets(offset, positions), anchors = getAnchors(anchor, positions), marktype = markType(texts[0].datum), grouptype = marktype === 'group' && texts[0].datum.items[markIndex].marktype, isGroupArea = grouptype === 'area', boundary = markBoundary(marktype, grouptype, lineAnchor, markIndex), infPadding = padding === null || padding === Infinity, isNaiveGroupArea = isGroupArea && method === 'naive';
    let maxTextWidth = -1, maxTextHeight = -1;
    // prepare text mark data for placing
    const data = texts.map((d)=>{
        const textWidth = infPadding ? (0, _vegaScenegraph.textMetrics).width(d, d.text) : undefined;
        maxTextWidth = Math.max(maxTextWidth, textWidth);
        maxTextHeight = Math.max(maxTextHeight, d.fontSize);
        return {
            datum: d,
            opacity: 0,
            x: undefined,
            y: undefined,
            align: undefined,
            baseline: undefined,
            boundary: boundary(d),
            textWidth
        };
    });
    padding = padding === null || padding === Infinity ? Math.max(maxTextWidth, maxTextHeight) + Math.max(...offset) : padding;
    const $ = scaler(size[0], size[1], padding);
    let bitmaps;
    if (!isNaiveGroupArea) {
        // sort labels in priority order, if comparator is provided
        if (compare) data.sort((a, b)=>compare(a.datum, b.datum));
        // flag indicating if label can be placed inside its base mark
        let labelInside = false;
        for(let i = 0; i < anchors.length && !labelInside; ++i)// label inside if anchor is at center
        // label inside if offset to be inside the mark bound
        labelInside = anchors[i] === 0x5 || offsets[i] < 0;
        // extract data information from base mark when base mark is to be avoided
        // base mark is implicitly avoided if it is a group area
        const baseMark = (marktype && avoidBaseMark || isGroupArea) && texts.map((d)=>d.datum);
        // generate bitmaps for layout calculation
        bitmaps = avoidMarks.length || baseMark ? markBitmaps($, baseMark || [], avoidMarks, labelInside, isGroupArea) : baseBitmaps($, avoidBaseMark && data);
    }
    // generate label placement function
    const place = isGroupArea ? placeAreaLabel[method]($, bitmaps, avoidBaseMark, markIndex) : placeMarkLabel($, bitmaps, anchors, offsets);
    // place all labels
    data.forEach((d)=>d.opacity = +place(d));
    return data;
}
function getOffsets(_, count) {
    const offsets = new Float64Array(count), n = _.length;
    for(let i = 0; i < n; ++i)offsets[i] = _[i] || 0;
    for(let i = n; i < count; ++i)offsets[i] = offsets[n - 1];
    return offsets;
}
function getAnchors(_, count) {
    const anchors = new Int8Array(count), n = _.length;
    for(let i = 0; i < n; ++i)anchors[i] |= anchorCode[_[i]];
    for(let i = n; i < count; ++i)anchors[i] = anchors[n - 1];
    return anchors;
}
function markType(item) {
    return item && item.mark && item.mark.marktype;
}
/**
 * Factory function for function for getting base mark boundary, depending
 * on mark and group type. When mark type is undefined, line or area: boundary
 * is the coordinate of each data point. When base mark is grouped line,
 * boundary is either at the start or end of the line depending on the
 * value of lineAnchor. Otherwise, use bounds of base mark.
 */ function markBoundary(marktype, grouptype, lineAnchor, markIndex) {
    const xy = (d)=>[
            d.x,
            d.x,
            d.x,
            d.y,
            d.y,
            d.y
        ];
    if (!marktype) return xy; // no reactive geometry
    else if (marktype === 'line' || marktype === 'area') return (d)=>xy(d.datum);
    else if (grouptype === 'line') return (d)=>{
        const items = d.datum.items[markIndex].items;
        return xy(items.length ? items[lineAnchor === 'start' ? 0 : items.length - 1] : {
            x: NaN,
            y: NaN
        });
    };
    else return (d)=>{
        const b = d.datum.bounds;
        return [
            b.x1,
            (b.x1 + b.x2) / 2,
            b.x2,
            b.y1,
            (b.y1 + b.y2) / 2,
            b.y2
        ];
    };
}
const Output = [
    'x',
    'y',
    'opacity',
    'align',
    'baseline'
];
const Anchors = [
    'top-left',
    'left',
    'bottom-left',
    'top',
    'bottom',
    'top-right',
    'right',
    'bottom-right'
];
/**
 * Compute text label layout to annotate marks.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<number>} params.size - The size of the layout, provided as a [width, height] array.
 * @param {function(*,*): number} [params.sort] - An optional
 *   comparator function for sorting label data in priority order.
 * @param {Array<string>} [params.anchor] - Label anchor points relative to the base mark bounding box.
 *   The available options are 'top-left', 'left', 'bottom-left', 'top',
 *   'bottom', 'top-right', 'right', 'bottom-right', 'middle'.
 * @param {Array<number>} [params.offset] - Label offsets (in pixels) from the base mark bounding box.
 *   This parameter is parallel to the list of anchor points.
 * @param {number | null} [params.padding=0] - The amount (in pixels) that a label may exceed the layout size.
 *   If this parameter is null, a label may exceed the layout size without any boundary.
 * @param {string} [params.lineAnchor='end'] - For group line mark labels only, indicates the anchor
 *   position for labels. One of 'start' or 'end'.
 * @param {string} [params.markIndex=0] - For group mark labels only, an index indicating
 *   which mark within the group should be labeled.
 * @param {Array<number>} [params.avoidMarks] - A list of additional mark names for which the label
 *   layout should avoid overlap.
 * @param {boolean} [params.avoidBaseMark=true] - Boolean flag indicating if labels should avoid
 *   overlap with the underlying base mark being labeled.
 * @param {string} [params.method='naive'] - For area make labels only, a method for
 *   place labels. One of 'naive', 'reduced-search', or 'floodfill'.
 * @param {Array<string>} [params.as] - The output fields written by the transform.
 *   The default is ['x', 'y', 'opacity', 'align', 'baseline'].
 */ function Label(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Label.Definition = {
    type: 'Label',
    metadata: {
        modifies: true
    },
    params: [
        {
            name: 'size',
            type: 'number',
            array: true,
            length: 2,
            required: true
        },
        {
            name: 'sort',
            type: 'compare'
        },
        {
            name: 'anchor',
            type: 'string',
            array: true,
            default: Anchors
        },
        {
            name: 'offset',
            type: 'number',
            array: true,
            default: [
                1
            ]
        },
        {
            name: 'padding',
            type: 'number',
            default: 0,
            null: true
        },
        {
            name: 'lineAnchor',
            type: 'string',
            values: [
                'start',
                'end'
            ],
            default: 'end'
        },
        {
            name: 'markIndex',
            type: 'number',
            default: 0
        },
        {
            name: 'avoidBaseMark',
            type: 'boolean',
            default: true
        },
        {
            name: 'avoidMarks',
            type: 'data',
            array: true
        },
        {
            name: 'method',
            type: 'string',
            default: 'naive'
        },
        {
            name: 'as',
            type: 'string',
            array: true,
            length: Output.length,
            default: Output
        }
    ]
};
(0, _vegaUtil.inherits)(Label, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        function modp(param) {
            const p = _[param];
            return (0, _vegaUtil.isFunction)(p) && pulse.modified(p.fields);
        }
        const mod = _.modified();
        if (!(mod || pulse.changed(pulse.ADD_REM) || modp('sort'))) return;
        if (!_.size || _.size.length !== 2) (0, _vegaUtil.error)('Size parameter should be specified as a [width, height] array.');
        const as = _.as || Output;
        // run label layout
        labelLayout(pulse.materialize(pulse.SOURCE).source || [], _.size, _.sort, (0, _vegaUtil.array)(_.offset == null ? 1 : _.offset), (0, _vegaUtil.array)(_.anchor || Anchors), _.avoidMarks || [], _.avoidBaseMark !== false, _.lineAnchor || 'end', _.markIndex || 0, _.padding === undefined ? 0 : _.padding, _.method || 'naive').forEach((l)=>{
            // write layout results to data stream
            const t = l.datum;
            t[as[0]] = l.x;
            t[as[1]] = l.y;
            t[as[2]] = l.opacity;
            t[as[3]] = l.align;
            t[as[4]] = l.baseline;
        });
        return pulse.reflow(mod).modifies(as);
    }
});

},{"vega-scenegraph":"fdlnS","vega-canvas":"5PubP","vega-dataflow":"eoU45","vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3UzsD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loess", ()=>Loess);
parcelHelpers.export(exports, "regression", ()=>Regression);
var _vegaStatistics = require("vega-statistics");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
function partition(data, groupby) {
    var groups = [], get = function(f) {
        return f(t);
    }, map, i, n, t, k, g;
    // partition data points into stack groups
    if (groupby == null) groups.push(data);
    else for(map = {}, i = 0, n = data.length; i < n; ++i){
        t = data[i];
        k = groupby.map(get);
        g = map[k];
        if (!g) {
            map[k] = g = [];
            g.dims = k;
            groups.push(g);
        }
        g.push(t);
    }
    return groups;
}
/**
 * Compute locally-weighted regression fits for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.x - An accessor for the predictor data field.
 * @param {function(object): *} params.y - An accessor for the predicted data field.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {number} [params.bandwidth=0.3] - The loess bandwidth.
 */ function Loess(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Loess.Definition = {
    'type': 'Loess',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'bandwidth',
            'type': 'number',
            'default': 0.3
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Loess, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const source = pulse.materialize(pulse.SOURCE).source, groups = partition(source, _.groupby), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), m = names.length, as = _.as || [
                (0, _vegaUtil.accessorName)(_.x),
                (0, _vegaUtil.accessorName)(_.y)
            ], values = [];
            groups.forEach((g)=>{
                (0, _vegaStatistics.regressionLoess)(g, _.x, _.y, _.bandwidth || 0.3).forEach((p)=>{
                    const t = {};
                    for(let i = 0; i < m; ++i)t[names[i]] = g.dims[i];
                    t[as[0]] = p[0];
                    t[as[1]] = p[1];
                    values.push((0, _vegaDataflow.ingest)(t));
                });
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});
const Methods = {
    constant: (0, _vegaStatistics.regressionConstant),
    linear: (0, _vegaStatistics.regressionLinear),
    log: (0, _vegaStatistics.regressionLog),
    exp: (0, _vegaStatistics.regressionExp),
    pow: (0, _vegaStatistics.regressionPow),
    quad: (0, _vegaStatistics.regressionQuad),
    poly: (0, _vegaStatistics.regressionPoly)
};
const degreesOfFreedom = (method, order)=>method === 'poly' ? order : method === 'quad' ? 2 : 1;
/**
 * Compute regression fits for one or more data groups.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {function(object): *} params.x - An accessor for the predictor data field.
 * @param {function(object): *} params.y - An accessor for the predicted data field.
 * @param {string} [params.method='linear'] - The regression method to apply.
 * @param {Array<function(object): *>} [params.groupby] - An array of accessors to groupby.
 * @param {Array<number>} [params.extent] - The domain extent over which to plot the regression line.
 * @param {number} [params.order=3] - The polynomial order. Only applies to the 'poly' method.
 */ function Regression(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Regression.Definition = {
    'type': 'Regression',
    'metadata': {
        'generates': true
    },
    'params': [
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'groupby',
            'type': 'field',
            'array': true
        },
        {
            'name': 'method',
            'type': 'string',
            'default': 'linear',
            'values': Object.keys(Methods)
        },
        {
            'name': 'order',
            'type': 'number',
            'default': 3
        },
        {
            'name': 'extent',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'params',
            'type': 'boolean',
            'default': false
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true
        }
    ]
};
(0, _vegaUtil.inherits)(Regression, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const out = pulse.fork(pulse.NO_SOURCE | pulse.NO_FIELDS);
        if (!this.value || pulse.changed() || _.modified()) {
            const source = pulse.materialize(pulse.SOURCE).source, groups = partition(source, _.groupby), names = (_.groupby || []).map((0, _vegaUtil.accessorName)), method = _.method || 'linear', order = _.order == null ? 3 : _.order, dof = degreesOfFreedom(method, order), as = _.as || [
                (0, _vegaUtil.accessorName)(_.x),
                (0, _vegaUtil.accessorName)(_.y)
            ], fit = Methods[method], values = [];
            let domain = _.extent;
            if (!(0, _vegaUtil.hasOwnProperty)(Methods, method)) (0, _vegaUtil.error)('Invalid regression method: ' + method);
            if (domain != null) {
                if (method === 'log' && domain[0] <= 0) {
                    pulse.dataflow.warn('Ignoring extent with values <= 0 for log regression.');
                    domain = null;
                }
            }
            groups.forEach((g)=>{
                const n = g.length;
                if (n <= dof) {
                    pulse.dataflow.warn('Skipping regression with more parameters than data points.');
                    return;
                }
                const model = fit(g, _.x, _.y, order);
                if (_.params) {
                    // if parameter vectors requested return those
                    values.push((0, _vegaDataflow.ingest)({
                        keys: g.dims,
                        coef: model.coef,
                        rSquared: model.rSquared
                    }));
                    return;
                }
                const dom = domain || (0, _vegaUtil.extent)(g, _.x), add = (p)=>{
                    const t = {};
                    for(let i = 0; i < names.length; ++i)t[names[i]] = g.dims[i];
                    t[as[0]] = p[0];
                    t[as[1]] = p[1];
                    values.push((0, _vegaDataflow.ingest)(t));
                };
                if (method === 'linear' || method === 'constant') // for linear or constant regression we only need the end points
                dom.forEach((x)=>add([
                        x,
                        model.predict(x)
                    ]));
                else // otherwise return trend line sample points
                (0, _vegaStatistics.sampleCurve)(model.predict, dom, 25, 200).forEach(add);
            });
            if (this.value) out.rem = this.value;
            this.value = out.add = out.source = values;
        }
        return out;
    }
});

},{"vega-statistics":"6sdPC","vega-dataflow":"eoU45","vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"02vkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "voronoi", ()=>Voronoi);
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _d3Delaunay = require("d3-delaunay");
function Voronoi(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
Voronoi.Definition = {
    'type': 'Voronoi',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'x',
            'type': 'field',
            'required': true
        },
        {
            'name': 'y',
            'type': 'field',
            'required': true
        },
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'extent',
            'type': 'array',
            'array': true,
            'length': 2,
            'default': [
                [
                    -100000,
                    -100000
                ],
                [
                    1e5,
                    1e5
                ]
            ],
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        },
        {
            'name': 'as',
            'type': 'string',
            'default': 'path'
        }
    ]
};
const defaultExtent = [
    -100000,
    -100000,
    1e5,
    1e5
];
(0, _vegaUtil.inherits)(Voronoi, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const as = _.as || 'path', data = pulse.source;
        // nothing to do if no data
        if (!data || !data.length) return pulse;
        // configure and construct voronoi diagram
        let s = _.size;
        s = s ? [
            0,
            0,
            s[0],
            s[1]
        ] : (s = _.extent) ? [
            s[0][0],
            s[0][1],
            s[1][0],
            s[1][1]
        ] : defaultExtent;
        const voronoi = this.value = (0, _d3Delaunay.Delaunay).from(data, _.x, _.y).voronoi(s);
        // map polygons to paths
        for(let i = 0, n = data.length; i < n; ++i){
            const polygon = voronoi.cellPolygon(i);
            data[i][as] = polygon && !isPoint(polygon) ? toPathString(polygon) : null;
        }
        return pulse.reflow(_.modified()).modifies(as);
    }
});
// suppress duplicated end point vertices
function toPathString(p) {
    const x = p[0][0], y = p[0][1];
    let n = p.length - 1;
    for(; p[n][0] === x && p[n][1] === y; --n);
    return 'M' + p.slice(0, n + 1).join('L') + 'Z';
}
function isPoint(p) {
    return p.length === 2 && p[0][0] === p[1][0] && p[0][1] === p[1][1];
}

},{"vega-dataflow":"eoU45","vega-util":"kncZn","d3-delaunay":"hlXWZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hlXWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delaunay", ()=>(0, _delaunayJsDefault.default));
parcelHelpers.export(exports, "Voronoi", ()=>(0, _voronoiJsDefault.default));
var _delaunayJs = require("./delaunay.js");
var _delaunayJsDefault = parcelHelpers.interopDefault(_delaunayJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);

},{"./delaunay.js":"dJasL","./voronoi.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJasL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _delaunator = require("delaunator");
var _delaunatorDefault = parcelHelpers.interopDefault(_delaunator);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    const { triangles, coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
        return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, _delaunatorDefault.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, _delaunatorDefault.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, _voronoiJsDefault.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, halfedges, triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
exports.default = Delaunay;
function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

},{"delaunator":"b2ccY","./path.js":"ebBL9","./polygon.js":"bSOj4","./voronoi.js":"l0HTg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b2ccY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _robustPredicates = require("robust-predicates");
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new Delaunator(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, _robustPredicates.orient2d)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, _robustPredicates.orient2d)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
exports.default = Delaunator;
// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x,
        y
    };
}
function quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultGetX(p) {
    return p[0];
}
function defaultGetY(p) {
    return p[1];
}

},{"robust-predicates":"8K7Zx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8K7Zx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>(0, _orient2DJs.orient2d));
parcelHelpers.export(exports, "orient2dfast", ()=>(0, _orient2DJs.orient2dfast));
parcelHelpers.export(exports, "orient3d", ()=>(0, _orient3DJs.orient3d));
parcelHelpers.export(exports, "orient3dfast", ()=>(0, _orient3DJs.orient3dfast));
parcelHelpers.export(exports, "incircle", ()=>(0, _incircleJs.incircle));
parcelHelpers.export(exports, "incirclefast", ()=>(0, _incircleJs.incirclefast));
parcelHelpers.export(exports, "insphere", ()=>(0, _insphereJs.insphere));
parcelHelpers.export(exports, "inspherefast", ()=>(0, _insphereJs.inspherefast));
var _orient2DJs = require("./esm/orient2d.js");
var _orient3DJs = require("./esm/orient3d.js");
var _incircleJs = require("./esm/incircle.js");
var _insphereJs = require("./esm/insphere.js");

},{"./esm/orient2d.js":"aMxbU","./esm/orient3d.js":"aRdDo","./esm/incircle.js":"cGSqn","./esm/insphere.js":"a9t6m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMxbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>orient2d);
parcelHelpers.export(exports, "orient2dfast", ()=>orient2dfast);
var _utilJs = require("./util.js");
const ccwerrboundA = (3 + 16 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundB = (2 + 12 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundC = (9 + 64 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const B = (0, _utilJs.vec)(4);
const C1 = (0, _utilJs.vec)(8);
const C2 = (0, _utilJs.vec)(12);
const D = (0, _utilJs.vec)(16);
const u = (0, _utilJs.vec)(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    B[3] = u3;
    let det = (0, _utilJs.estimate)(4, B);
    let errbound = ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = ccwerrboundC * detsum + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C1len = (0, _utilJs.sum)(4, B, 4, u, C1);
    s1 = acx * bcytail;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C2len = (0, _utilJs.sum)(C1len, C1, 4, u, C2);
    s1 = acxtail * bcytail;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const Dlen = (0, _utilJs.sum)(C2len, C2, 4, u, D);
    return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= ccwerrboundA * detsum) return det;
    return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function orient2dfast(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dWrL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "splitter", ()=>splitter);
parcelHelpers.export(exports, "resulterrbound", ()=>resulterrbound);
// fast_expansion_sum_zeroelim routine from oritinal code
parcelHelpers.export(exports, "sum", ()=>sum);
parcelHelpers.export(exports, "sum_three", ()=>sum_three);
// scale_expansion_zeroelim routine from oritinal code
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "negate", ()=>negate);
parcelHelpers.export(exports, "estimate", ()=>estimate);
parcelHelpers.export(exports, "vec", ()=>vec);
const epsilon = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon) * epsilon;
function sum(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function sum_three(alen, a, blen, b, clen, c, tmp, out) {
    return sum(sum(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function scale(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = splitter * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = splitter * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function negate(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function estimate(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function vec(n) {
    return new Float64Array(n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRdDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient3d", ()=>orient3d);
parcelHelpers.export(exports, "orient3dfast", ()=>orient3dfast);
var _utilJs = require("./util.js");
const o3derrboundA = (7 + 56 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundB = (3 + 28 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundC = (26 + 288 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const at_b = (0, _utilJs.vec)(4);
const at_c = (0, _utilJs.vec)(4);
const bt_c = (0, _utilJs.vec)(4);
const bt_a = (0, _utilJs.vec)(4);
const ct_a = (0, _utilJs.vec)(4);
const ct_b = (0, _utilJs.vec)(4);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const u = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(8);
const _12 = (0, _utilJs.vec)(12);
let fin = (0, _utilJs.vec)(192);
let fin2 = (0, _utilJs.vec)(192);
function finadd(finlen, alen, a) {
    finlen = (0, _utilJs.sum)(finlen, fin, alen, a, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, _utilJs.splitter) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, _utilJs.splitter) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, _utilJs.splitter) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, _utilJs.splitter) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, _utilJs.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, _utilJs.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, _utilJs.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, _utilJs.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, _utilJs.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, _utilJs.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    u[2] = _k - (u3 - _j);
    u[3] = u3;
    finlen = finadd(finlen, 4, u);
    if (z !== 0) {
        c = (0, _utilJs.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, _utilJs.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, _utilJs.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        u[2] = _k - (u3 - _j);
        u[3] = u3;
        finlen = finadd(finlen, 4, u);
    }
    return finlen;
}
function orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)(4, bc, adz, _8), _8, (0, _utilJs.scale)(4, ca, bdz, _8b), _8b, _16), _16, (0, _utilJs.scale)(4, ab, cdz, _8), _8, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = o3derrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, at_b, at_c);
    const bt_len = tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, bt_c, bt_a);
    const ct_len = tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, ct_a, ct_b);
    const bctlen = (0, _utilJs.sum)(bt_len, bt_c, ct_len, ct_b, bct);
    finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adz, _16), _16);
    const catlen = (0, _utilJs.sum)(ct_len, ct_a, at_len, at_c, cat);
    finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdz, _16), _16);
    const abtlen = (0, _utilJs.sum)(at_len, at_b, bt_len, bt_a, abt);
    finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdz, _16), _16);
    if (adztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, bc, adztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adztail, _16), _16);
    }
    if (bdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ca, bdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdztail, _16), _16);
    }
    if (cdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ab, cdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdztail, _16), _16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return fin[finlen - 1];
}
function orient3d(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function orient3dfast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cGSqn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "incircle", ()=>incircle);
parcelHelpers.export(exports, "incirclefast", ()=>incirclefast);
var _utilJs = require("./util.js");
const iccerrboundA = (10 + 96 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundB = (4 + 48 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundC = (44 + 576 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const aa = (0, _utilJs.vec)(4);
const bb = (0, _utilJs.vec)(4);
const cc = (0, _utilJs.vec)(4);
const u = (0, _utilJs.vec)(4);
const v = (0, _utilJs.vec)(4);
const axtbc = (0, _utilJs.vec)(8);
const aytbc = (0, _utilJs.vec)(8);
const bxtca = (0, _utilJs.vec)(8);
const bytca = (0, _utilJs.vec)(8);
const cxtab = (0, _utilJs.vec)(8);
const cytab = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abtt = (0, _utilJs.vec)(4);
const bctt = (0, _utilJs.vec)(4);
const catt = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _16b = (0, _utilJs.vec)(16);
const _16c = (0, _utilJs.vec)(16);
const _32 = (0, _utilJs.vec)(32);
const _32b = (0, _utilJs.vec)(32);
const _48 = (0, _utilJs.vec)(48);
const _64 = (0, _utilJs.vec)(64);
let fin = (0, _utilJs.vec)(1152);
let fin2 = (0, _utilJs.vec)(1152);
function finadd(finlen, a, alen) {
    finlen = (0, _utilJs.sum)(finlen, fin, a, alen, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, bc, adx, _8), _8, adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bc, ady, _8), _8, ady, _16b), _16b, _32), _32, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdx, _8), _8, bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdy, _8), _8, bdy, _16b), _16b, _32b), _32b, _64), _64, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdx, _8), _8, cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdy, _8), _8, cdy, _16b), _16b, _32), _32, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = iccerrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, _utilJs.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, _utilJs.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, _utilJs.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, _utilJs.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, _utilJs.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, _utilJs.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, _utilJs.scale)(4, bc, adxtail, axtbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(axtbclen, axtbc, 2 * adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adxtail, _8), _8, -cdy, _16c), _16c, _32, _48), _48);
    }
    if (adytail !== 0) {
        aytbclen = (0, _utilJs.scale)(4, bc, adytail, aytbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(aytbclen, aytbc, 2 * ady, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adytail, _8), _8, cdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adytail, _8), _8, -bdx, _16c), _16c, _32, _48), _48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, _utilJs.scale)(4, ca, bdxtail, bxtca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bxtcalen, bxtca, 2 * bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdxtail, _8), _8, -ady, _16c), _16c, _32, _48), _48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, _utilJs.scale)(4, ca, bdytail, bytca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bytcalen, bytca, 2 * bdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdytail, _8), _8, adx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdytail, _8), _8, -cdx, _16c), _16c, _32, _48), _48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, _utilJs.scale)(4, ab, cdxtail, cxtab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cxtablen, cxtab, 2 * cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, ady, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdxtail, _8), _8, -bdy, _16c), _16c, _32, _48), _48);
    }
    if (cdytail !== 0) {
        cytablen = (0, _utilJs.scale)(4, ab, cdytail, cytab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cytablen, cytab, 2 * cdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdytail, _8), _8, bdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdytail, _8), _8, -adx, _16c), _16c, _32, _48), _48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            bctlen = (0, _utilJs.sum)(4, u, 4, v, bct);
            s1 = bdxtail * cdytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            bctt[3] = u3;
            bcttlen = 4;
        } else {
            bct[0] = 0;
            bctlen = 1;
            bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(axtbclen, axtbc, adxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * adx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * adx, _16), _16, (0, _utilJs.scale)(len2, _8, adxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adxtail, _32), _32, _32b, _64), _64);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdytail, _16), _16);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, -adxtail, _8), _8, cdytail, _16), _16);
        }
        if (adytail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(aytbclen, aytbc, adytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * ady, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * ady, _16), _16, (0, _utilJs.scale)(len2, _8, adytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adytail, _32), _32, _32b, _64), _64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            catlen = (0, _utilJs.sum)(4, u, 4, v, cat);
            s1 = cdxtail * adytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            catt[3] = u3;
            cattlen = 4;
        } else {
            cat[0] = 0;
            catlen = 1;
            catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bxtcalen, bxtca, bdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdx, _16), _16, (0, _utilJs.scale)(len2, _8, bdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdxtail, _32), _32, _32b, _64), _64);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdytail, _16), _16);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, -bdxtail, _8), _8, adytail, _16), _16);
        }
        if (bdytail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bytcalen, bytca, bdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdy, _16), _16, (0, _utilJs.scale)(len2, _8, bdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdytail, _32), _32, _32b, _64), _64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            abtlen = (0, _utilJs.sum)(4, u, 4, v, abt);
            s1 = adxtail * bdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            abtt[3] = u3;
            abttlen = 4;
        } else {
            abt[0] = 0;
            abtlen = 1;
            abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cxtablen, cxtab, cdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdx, _16), _16, (0, _utilJs.scale)(len2, _8, cdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdxtail, _32), _32, _32b, _64), _64);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, adytail, _16), _16);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, -cdxtail, _8), _8, bdytail, _16), _16);
        }
        if (cdytail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cytablen, cytab, cdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdy, _16), _16, (0, _utilJs.scale)(len2, _8, cdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdytail, _32), _32, _32b, _64), _64);
        }
    }
    return fin[finlen - 1];
}
function incircle(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function incirclefast(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a9t6m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insphere", ()=>insphere);
parcelHelpers.export(exports, "inspherefast", ()=>inspherefast);
var _utilJs = require("./util.js");
const isperrboundA = (16 + 224 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundB = (5 + 72 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundC = (71 + 1408 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const ab = (0, _utilJs.vec)(4);
const bc = (0, _utilJs.vec)(4);
const cd = (0, _utilJs.vec)(4);
const de = (0, _utilJs.vec)(4);
const ea = (0, _utilJs.vec)(4);
const ac = (0, _utilJs.vec)(4);
const bd = (0, _utilJs.vec)(4);
const ce = (0, _utilJs.vec)(4);
const da = (0, _utilJs.vec)(4);
const eb = (0, _utilJs.vec)(4);
const abc = (0, _utilJs.vec)(24);
const bcd = (0, _utilJs.vec)(24);
const cde = (0, _utilJs.vec)(24);
const dea = (0, _utilJs.vec)(24);
const eab = (0, _utilJs.vec)(24);
const abd = (0, _utilJs.vec)(24);
const bce = (0, _utilJs.vec)(24);
const cda = (0, _utilJs.vec)(24);
const deb = (0, _utilJs.vec)(24);
const eac = (0, _utilJs.vec)(24);
const adet = (0, _utilJs.vec)(1152);
const bdet = (0, _utilJs.vec)(1152);
const cdet = (0, _utilJs.vec)(1152);
const ddet = (0, _utilJs.vec)(1152);
const edet = (0, _utilJs.vec)(1152);
const abdet = (0, _utilJs.vec)(2304);
const cddet = (0, _utilJs.vec)(2304);
const cdedet = (0, _utilJs.vec)(3456);
const deter = (0, _utilJs.vec)(5760);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _8c = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _24 = (0, _utilJs.vec)(24);
const _48 = (0, _utilJs.vec)(48);
const _48b = (0, _utilJs.vec)(48);
const _96 = (0, _utilJs.vec)(96);
const _192 = (0, _utilJs.vec)(192);
const _384x = (0, _utilJs.vec)(384);
const _384y = (0, _utilJs.vec)(384);
const _384z = (0, _utilJs.vec)(384);
const _768 = (0, _utilJs.vec)(768);
function sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, _utilJs.sum_three)((0, _utilJs.scale)(4, a, az, _8), _8, (0, _utilJs.scale)(4, b, bz, _8b), _8b, (0, _utilJs.scale)(4, c, cz, _8c), _8c, _16, out);
}
function liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, _utilJs.sum)((0, _utilJs.sum)(alen, a, blen, b, _48), _48, (0, _utilJs.negate)((0, _utilJs.sum)(clen, c, dlen, d, _48b), _48b), _48b, _96);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _96, x, _192), _192, x, _384x), _384x, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, y, _192), _192, y, _384y), _384y, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, z, _192), _192, z, _384z), _384z, _768, out);
}
function insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    s1 = bx * cy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cx * dy;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    cd[3] = u3;
    s1 = dx * ey;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    de[3] = u3;
    s1 = ex * ay;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ea[3] = u3;
    s1 = ax * cy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ac[3] = u3;
    s1 = bx * dy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bd[3] = u3;
    s1 = cx * ey;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ce[3] = u3;
    s1 = dx * ay;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    da[3] = u3;
    s1 = ex * by;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    eb[3] = u3;
    const abclen = sum_three_scale(ab, bc, ac, cz, az, -bz, abc);
    const bcdlen = sum_three_scale(bc, cd, bd, dz, bz, -cz, bcd);
    const cdelen = sum_three_scale(cd, de, ce, ez, cz, -dz, cde);
    const dealen = sum_three_scale(de, ea, da, az, dz, -ez, dea);
    const eablen = sum_three_scale(ea, ab, eb, bz, ez, -az, eab);
    const abdlen = sum_three_scale(ab, bd, da, dz, az, bz, abd);
    const bcelen = sum_three_scale(bc, ce, eb, ez, bz, cz, bce);
    const cdalen = sum_three_scale(cd, da, ac, az, cz, dz, cda);
    const deblen = sum_three_scale(de, eb, bd, bz, dz, ez, deb);
    const eaclen = sum_three_scale(ea, ac, ce, cz, ez, az, eac);
    const deterlen = (0, _utilJs.sum_three)(liftexact(cdelen, cde, bcelen, bce, deblen, deb, bcdlen, bcd, ax, ay, az, adet), adet, liftexact(dealen, dea, cdalen, cda, eaclen, eac, cdelen, cde, bx, by, bz, bdet), bdet, (0, _utilJs.sum_three)(liftexact(eablen, eab, deblen, deb, abdlen, abd, dealen, dea, cx, cy, cz, cdet), cdet, liftexact(abclen, abc, eaclen, eac, bcelen, bce, eablen, eab, dx, dy, dz, ddet), ddet, liftexact(bcdlen, bcd, abdlen, abd, cdalen, cda, abclen, abc, ex, ey, ez, edet), edet, cddet, cdedet), cdedet, abdet, deter);
    return deter[deterlen - 1];
}
const xdet = (0, _utilJs.vec)(96);
const ydet = (0, _utilJs.vec)(96);
const zdet = (0, _utilJs.vec)(96);
const fin = (0, _utilJs.vec)(1152);
function liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = sum_three_scale(a, b, c, az, bz, cz, _24);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _24, x, _48), _48, x, xdet), xdet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, y, _48), _48, y, ydet), ydet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, z, _48), _48, z, zdet), zdet, _192, out);
}
function insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    ab[3] = ab3;
    s1 = bex * cey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    bc[3] = bc3;
    s1 = cex * dey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    cd[3] = cd3;
    s1 = dex * aey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    da[3] = da3;
    s1 = aex * cey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    ac[3] = ac3;
    s1 = bex * dey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    bd[3] = bd3;
    const finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(bc, cd, bd, dez, bez, -cez, aex, aey, aez, adet), adet), adet, liftadapt(cd, da, ac, aez, cez, dez, bex, bey, bez, bdet), bdet, abdet), abdet, (0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(da, ab, bd, bez, dez, aez, cex, cey, cez, cdet), cdet), cdet, liftadapt(ab, bc, ac, cez, aez, -bez, dex, dey, dez, ddet), ddet, cddet), cddet, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = isperrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function insphere(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function inspherefast(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ebBL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const epsilon = 1e-6;
class Path {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}
exports.default = Path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bSOj4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Polygon {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}
exports.default = Polygon;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l0HTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class Voronoi {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}
exports.default = Voronoi;

},{"./path.js":"ebBL9","./polygon.js":"bSOj4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6hmHB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wordcloud", ()=>Wordcloud);
var _vegaCanvas = require("vega-canvas");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
var _vegaScale = require("vega-scale");
var _vegaStatistics = require("vega-statistics");
/*
Copyright (c) 2013, Jason Davies.
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.

  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

  * The name Jason Davies may not be used to endorse or promote products
    derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL JASON DAVIES BE LIABLE FOR ANY DIRECT, INDIRECT,
INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ // Word cloud layout by Jason Davies, https://www.jasondavies.com/wordcloud/
// Algorithm due to Jonathan Feinberg, http://static.mrfeinberg.com/bv_ch03.pdf
var cloudRadians = Math.PI / 180, cw = 64, ch = 2048;
function cloud() {
    var size = [
        256,
        256
    ], text, font, fontSize, fontStyle, fontWeight, rotate, padding, spiral = archimedeanSpiral, words = [], random = Math.random, cloud = {};
    cloud.layout = function() {
        var contextAndRatio = getContext((0, _vegaCanvas.canvas)()), board = zeroArray((size[0] >> 5) * size[1]), bounds = null, n = words.length, i = -1, tags = [], data = words.map((d)=>({
                text: text(d),
                font: font(d),
                style: fontStyle(d),
                weight: fontWeight(d),
                rotate: rotate(d),
                size: ~~(fontSize(d) + 1e-14),
                padding: padding(d),
                xoff: 0,
                yoff: 0,
                x1: 0,
                y1: 0,
                x0: 0,
                y0: 0,
                hasText: false,
                sprite: null,
                datum: d
            })).sort((a, b)=>b.size - a.size);
        while(++i < n){
            var d = data[i];
            d.x = size[0] * (random() + .5) >> 1;
            d.y = size[1] * (random() + .5) >> 1;
            cloudSprite(contextAndRatio, d, data, i);
            if (d.hasText && place(board, d, bounds)) {
                tags.push(d);
                if (bounds) cloudBounds(bounds, d);
                else bounds = [
                    {
                        x: d.x + d.x0,
                        y: d.y + d.y0
                    },
                    {
                        x: d.x + d.x1,
                        y: d.y + d.y1
                    }
                ];
                // Temporary hack
                d.x -= size[0] >> 1;
                d.y -= size[1] >> 1;
            }
        }
        return tags;
    };
    function getContext(canvas) {
        canvas.width = canvas.height = 1;
        var ratio = Math.sqrt(canvas.getContext('2d').getImageData(0, 0, 1, 1).data.length >> 2);
        canvas.width = (cw << 5) / ratio;
        canvas.height = ch / ratio;
        var context = canvas.getContext('2d');
        context.fillStyle = context.strokeStyle = 'red';
        context.textAlign = 'center';
        return {
            context: context,
            ratio: ratio
        };
    }
    function place(board, tag, bounds) {
        var startX = tag.x, startY = tag.y, maxDelta = Math.hypot(size[0], size[1]), s = spiral(size), dt = random() < .5 ? 1 : -1, t = -dt, dxdy, dx, dy;
        while(dxdy = s(t += dt)){
            dx = ~~dxdy[0];
            dy = ~~dxdy[1];
            if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) break;
            tag.x = startX + dx;
            tag.y = startY + dy;
            if (tag.x + tag.x0 < 0 || tag.y + tag.y0 < 0 || tag.x + tag.x1 > size[0] || tag.y + tag.y1 > size[1]) continue;
            // TODO only check for collisions within current bounds.
            if (!bounds || !cloudCollide(tag, board, size[0])) {
                if (!bounds || collideRects(tag, bounds)) {
                    var sprite = tag.sprite, w = tag.width >> 5, sw = size[0] >> 5, lx = tag.x - (w << 4), sx = lx & 0x7f, msx = 32 - sx, h = tag.y1 - tag.y0, x = (tag.y + tag.y0) * sw + (lx >> 5), last;
                    for(var j = 0; j < h; j++){
                        last = 0;
                        for(var i = 0; i <= w; i++)board[x + i] |= last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0);
                        x += sw;
                    }
                    tag.sprite = null;
                    return true;
                }
            }
        }
        return false;
    }
    cloud.words = function(_) {
        if (arguments.length) {
            words = _;
            return cloud;
        } else return words;
    };
    cloud.size = function(_) {
        if (arguments.length) {
            size = [
                +_[0],
                +_[1]
            ];
            return cloud;
        } else return size;
    };
    cloud.font = function(_) {
        if (arguments.length) {
            font = functor(_);
            return cloud;
        } else return font;
    };
    cloud.fontStyle = function(_) {
        if (arguments.length) {
            fontStyle = functor(_);
            return cloud;
        } else return fontStyle;
    };
    cloud.fontWeight = function(_) {
        if (arguments.length) {
            fontWeight = functor(_);
            return cloud;
        } else return fontWeight;
    };
    cloud.rotate = function(_) {
        if (arguments.length) {
            rotate = functor(_);
            return cloud;
        } else return rotate;
    };
    cloud.text = function(_) {
        if (arguments.length) {
            text = functor(_);
            return cloud;
        } else return text;
    };
    cloud.spiral = function(_) {
        if (arguments.length) {
            spiral = spirals[_] || _;
            return cloud;
        } else return spiral;
    };
    cloud.fontSize = function(_) {
        if (arguments.length) {
            fontSize = functor(_);
            return cloud;
        } else return fontSize;
    };
    cloud.padding = function(_) {
        if (arguments.length) {
            padding = functor(_);
            return cloud;
        } else return padding;
    };
    cloud.random = function(_) {
        if (arguments.length) {
            random = _;
            return cloud;
        } else return random;
    };
    return cloud;
}
// Fetches a monochrome sprite bitmap for the specified text.
// Load in batches for speed.
function cloudSprite(contextAndRatio, d, data, di) {
    if (d.sprite) return;
    var c = contextAndRatio.context, ratio = contextAndRatio.ratio;
    c.clearRect(0, 0, (cw << 5) / ratio, ch / ratio);
    var x = 0, y = 0, maxh = 0, n = data.length, w, w32, h, i, j;
    --di;
    while(++di < n){
        d = data[di];
        c.save();
        c.font = d.style + ' ' + d.weight + ' ' + ~~((d.size + 1) / ratio) + 'px ' + d.font;
        w = c.measureText(d.text + 'm').width * ratio;
        h = d.size << 1;
        if (d.rotate) {
            var sr = Math.sin(d.rotate * cloudRadians), cr = Math.cos(d.rotate * cloudRadians), wcr = w * cr, wsr = w * sr, hcr = h * cr, hsr = h * sr;
            w = Math.max(Math.abs(wcr + hsr), Math.abs(wcr - hsr)) + 0x1f >> 5 << 5;
            h = ~~Math.max(Math.abs(wsr + hcr), Math.abs(wsr - hcr));
        } else w = w + 0x1f >> 5 << 5;
        if (h > maxh) maxh = h;
        if (x + w >= cw << 5) {
            x = 0;
            y += maxh;
            maxh = 0;
        }
        if (y + h >= ch) break;
        c.translate((x + (w >> 1)) / ratio, (y + (h >> 1)) / ratio);
        if (d.rotate) c.rotate(d.rotate * cloudRadians);
        c.fillText(d.text, 0, 0);
        if (d.padding) {
            c.lineWidth = 2 * d.padding;
            c.strokeText(d.text, 0, 0);
        }
        c.restore();
        d.width = w;
        d.height = h;
        d.xoff = x;
        d.yoff = y;
        d.x1 = w >> 1;
        d.y1 = h >> 1;
        d.x0 = -d.x1;
        d.y0 = -d.y1;
        d.hasText = true;
        x += w;
    }
    var pixels = c.getImageData(0, 0, (cw << 5) / ratio, ch / ratio).data, sprite = [];
    while(--di >= 0){
        d = data[di];
        if (!d.hasText) continue;
        w = d.width;
        w32 = w >> 5;
        h = d.y1 - d.y0;
        // Zero the buffer
        for(i = 0; i < h * w32; i++)sprite[i] = 0;
        x = d.xoff;
        if (x == null) return;
        y = d.yoff;
        var seen = 0, seenRow = -1;
        for(j = 0; j < h; j++){
            for(i = 0; i < w; i++){
                var k = w32 * j + (i >> 5), m = pixels[(y + j) * (cw << 5) + (x + i) << 2] ? 1 << 31 - i % 32 : 0;
                sprite[k] |= m;
                seen |= m;
            }
            if (seen) seenRow = j;
            else {
                d.y0++;
                h--;
                j--;
                y++;
            }
        }
        d.y1 = d.y0 + seenRow;
        d.sprite = sprite.slice(0, (d.y1 - d.y0) * w32);
    }
}
// Use mask-based collision detection.
function cloudCollide(tag, board, sw) {
    sw >>= 5;
    var sprite = tag.sprite, w = tag.width >> 5, lx = tag.x - (w << 4), sx = lx & 0x7f, msx = 32 - sx, h = tag.y1 - tag.y0, x = (tag.y + tag.y0) * sw + (lx >> 5), last;
    for(var j = 0; j < h; j++){
        last = 0;
        for(var i = 0; i <= w; i++){
            if ((last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0)) & board[x + i]) return true;
        }
        x += sw;
    }
    return false;
}
function cloudBounds(bounds, d) {
    var b0 = bounds[0], b1 = bounds[1];
    if (d.x + d.x0 < b0.x) b0.x = d.x + d.x0;
    if (d.y + d.y0 < b0.y) b0.y = d.y + d.y0;
    if (d.x + d.x1 > b1.x) b1.x = d.x + d.x1;
    if (d.y + d.y1 > b1.y) b1.y = d.y + d.y1;
}
function collideRects(a, b) {
    return a.x + a.x1 > b[0].x && a.x + a.x0 < b[1].x && a.y + a.y1 > b[0].y && a.y + a.y0 < b[1].y;
}
function archimedeanSpiral(size) {
    var e = size[0] / size[1];
    return function(t) {
        return [
            e * (t *= .1) * Math.cos(t),
            t * Math.sin(t)
        ];
    };
}
function rectangularSpiral(size) {
    var dy = 4, dx = dy * size[0] / size[1], x = 0, y = 0;
    return function(t) {
        var sign = t < 0 ? -1 : 1;
        // See triangular numbers: T_n = n * (n + 1) / 2.
        switch(Math.sqrt(1 + 4 * sign * t) - sign & 3){
            case 0:
                x += dx;
                break;
            case 1:
                y += dy;
                break;
            case 2:
                x -= dx;
                break;
            default:
                y -= dy;
                break;
        }
        return [
            x,
            y
        ];
    };
}
// TODO reuse arrays?
function zeroArray(n) {
    var a = [], i = -1;
    while(++i < n)a[i] = 0;
    return a;
}
function functor(d) {
    return typeof d === 'function' ? d : function() {
        return d;
    };
}
var spirals = {
    archimedean: archimedeanSpiral,
    rectangular: rectangularSpiral
};
const Output = [
    'x',
    'y',
    'font',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'angle'
];
const Params = [
    'text',
    'font',
    'rotate',
    'fontSize',
    'fontStyle',
    'fontWeight'
];
function Wordcloud(params) {
    (0, _vegaDataflow.Transform).call(this, cloud(), params);
}
Wordcloud.Definition = {
    'type': 'Wordcloud',
    'metadata': {
        'modifies': true
    },
    'params': [
        {
            'name': 'size',
            'type': 'number',
            'array': true,
            'length': 2
        },
        {
            'name': 'font',
            'type': 'string',
            'expr': true,
            'default': 'sans-serif'
        },
        {
            'name': 'fontStyle',
            'type': 'string',
            'expr': true,
            'default': 'normal'
        },
        {
            'name': 'fontWeight',
            'type': 'string',
            'expr': true,
            'default': 'normal'
        },
        {
            'name': 'fontSize',
            'type': 'number',
            'expr': true,
            'default': 14
        },
        {
            'name': 'fontSizeRange',
            'type': 'number',
            'array': 'nullable',
            'default': [
                10,
                50
            ]
        },
        {
            'name': 'rotate',
            'type': 'number',
            'expr': true,
            'default': 0
        },
        {
            'name': 'text',
            'type': 'field'
        },
        {
            'name': 'spiral',
            'type': 'string',
            'values': [
                'archimedean',
                'rectangular'
            ]
        },
        {
            'name': 'padding',
            'type': 'number',
            'expr': true
        },
        {
            'name': 'as',
            'type': 'string',
            'array': true,
            'length': 7,
            'default': Output
        }
    ]
};
(0, _vegaUtil.inherits)(Wordcloud, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (_.size && !(_.size[0] && _.size[1])) (0, _vegaUtil.error)('Wordcloud size dimensions must be non-zero.');
        function modp(param) {
            const p = _[param];
            return (0, _vegaUtil.isFunction)(p) && pulse.modified(p.fields);
        }
        const mod = _.modified();
        if (!(mod || pulse.changed(pulse.ADD_REM) || Params.some(modp))) return;
        const data = pulse.materialize(pulse.SOURCE).source, layout = this.value, as = _.as || Output;
        let fontSize = _.fontSize || 14, range;
        (0, _vegaUtil.isFunction)(fontSize) ? range = _.fontSizeRange : fontSize = (0, _vegaUtil.constant)(fontSize);
        // create font size scaling function as needed
        if (range) {
            const fsize = fontSize, sizeScale = (0, _vegaScale.scale)('sqrt')().domain((0, _vegaUtil.extent)(data, fsize)).range(range);
            fontSize = (x)=>sizeScale(fsize(x));
        }
        data.forEach((t)=>{
            t[as[0]] = NaN;
            t[as[1]] = NaN;
            t[as[3]] = 0;
        });
        // configure layout
        const words = layout.words(data).text(_.text).size(_.size || [
            500,
            500
        ]).padding(_.padding || 1).spiral(_.spiral || 'archimedean').rotate(_.rotate || 0).font(_.font || 'sans-serif').fontStyle(_.fontStyle || 'normal').fontWeight(_.fontWeight || 'normal').fontSize(fontSize).random((0, _vegaStatistics.random)).layout();
        const size = layout.size(), dx = size[0] >> 1, dy = size[1] >> 1, n = words.length;
        for(let i = 0, w, t; i < n; ++i){
            w = words[i];
            t = w.datum;
            t[as[0]] = w.x + dx;
            t[as[1]] = w.y + dy;
            t[as[2]] = w.font;
            t[as[3]] = w.size;
            t[as[4]] = w.style;
            t[as[5]] = w.weight;
            t[as[6]] = w.rotate;
        }
        return pulse.reflow(mod).modifies(as);
    }
});

},{"vega-canvas":"5PubP","vega-dataflow":"eoU45","vega-util":"kncZn","vega-scale":"fMau0","vega-statistics":"6sdPC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Y9pC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "crossfilter", ()=>CrossFilter);
parcelHelpers.export(exports, "resolvefilter", ()=>ResolveFilter);
var _d3Array = require("d3-array");
var _vegaDataflow = require("vega-dataflow");
var _vegaUtil = require("vega-util");
const array8 = (n)=>new Uint8Array(n);
const array16 = (n)=>new Uint16Array(n);
const array32 = (n)=>new Uint32Array(n);
/**
 * Maintains CrossFilter state.
 */ function Bitmaps() {
    let width = 8, data = [], seen = array32(0), curr = array(0, width), prev = array(0, width);
    return {
        data: ()=>data,
        seen: ()=>seen = lengthen(seen, data.length),
        add (array) {
            for(let i = 0, j = data.length, n = array.length, t; i < n; ++i){
                t = array[i];
                t._index = j++;
                data.push(t);
            }
        },
        remove (num, map) {
            // map: index -> boolean (true => remove)
            const n = data.length, copy = Array(n - num), reindex = data; // reuse old data array for index map
            let t, i, j;
            // seek forward to first removal
            for(i = 0; !map[i] && i < n; ++i){
                copy[i] = data[i];
                reindex[i] = i;
            }
            // condense arrays
            for(j = i; i < n; ++i){
                t = data[i];
                if (!map[i]) {
                    reindex[i] = j;
                    curr[j] = curr[i];
                    prev[j] = prev[i];
                    copy[j] = t;
                    t._index = j++;
                } else reindex[i] = -1;
                curr[i] = 0; // clear unused bits
            }
            data = copy;
            return reindex;
        },
        size: ()=>data.length,
        curr: ()=>curr,
        prev: ()=>prev,
        reset: (k)=>prev[k] = curr[k],
        all: ()=>width < 0x101 ? 0xff : width < 0x10001 ? 0xffff : 0xffffffff,
        set (k, one) {
            curr[k] |= one;
        },
        clear (k, one) {
            curr[k] &= ~one;
        },
        resize (n, m) {
            const k = curr.length;
            if (n > k || m > width) {
                width = Math.max(m, width);
                curr = array(n, width, curr);
                prev = array(n, width);
            }
        }
    };
}
function lengthen(array, length, copy) {
    if (array.length >= length) return array;
    copy = copy || new array.constructor(length);
    copy.set(array);
    return copy;
}
function array(n, m, array) {
    const copy = (m < 0x101 ? array8 : m < 0x10001 ? array16 : array32)(n);
    if (array) copy.set(array);
    return copy;
}
function Dimension(index, i, query) {
    const bit = 1 << i;
    return {
        one: bit,
        zero: ~bit,
        range: query.slice(),
        bisect: index.bisect,
        index: index.index,
        size: index.size,
        onAdd (added, curr) {
            const dim = this, range = dim.bisect(dim.range, added.value), idx = added.index, lo = range[0], hi = range[1], n1 = idx.length;
            let i;
            for(i = 0; i < lo; ++i)curr[idx[i]] |= bit;
            for(i = hi; i < n1; ++i)curr[idx[i]] |= bit;
            return dim;
        }
    };
}
/**
 * Maintains a list of values, sorted by key.
 */ function SortedIndex() {
    let index = array32(0), value = [], size = 0;
    function insert(key, data, base) {
        if (!data.length) return [];
        const n0 = size, n1 = data.length, addi = array32(n1);
        let addv = Array(n1), oldv, oldi, i;
        for(i = 0; i < n1; ++i){
            addv[i] = key(data[i]);
            addi[i] = i;
        }
        addv = sort(addv, addi);
        if (n0) {
            oldv = value;
            oldi = index;
            value = Array(n0 + n1);
            index = array32(n0 + n1);
            merge(base, oldv, oldi, n0, addv, addi, n1, value, index);
        } else {
            if (base > 0) for(i = 0; i < n1; ++i)addi[i] += base;
            value = addv;
            index = addi;
        }
        size = n0 + n1;
        return {
            index: addi,
            value: addv
        };
    }
    function remove(num, map) {
        // map: index -> remove
        const n = size;
        let idx, i, j;
        // seek forward to first removal
        for(i = 0; !map[index[i]] && i < n; ++i);
        // condense index and value arrays
        for(j = i; i < n; ++i)if (!map[idx = index[i]]) {
            index[j] = idx;
            value[j] = value[i];
            ++j;
        }
        size = n - num;
    }
    function reindex(map) {
        for(let i = 0, n = size; i < n; ++i)index[i] = map[index[i]];
    }
    function bisect(range, array) {
        let n;
        if (array) n = array.length;
        else {
            array = value;
            n = size;
        }
        return [
            (0, _d3Array.bisectLeft)(array, range[0], 0, n),
            (0, _d3Array.bisectRight)(array, range[1], 0, n)
        ];
    }
    return {
        insert: insert,
        remove: remove,
        bisect: bisect,
        reindex: reindex,
        index: ()=>index,
        size: ()=>size
    };
}
function sort(values, index) {
    values.sort.call(index, (a, b)=>{
        const x = values[a], y = values[b];
        return x < y ? -1 : x > y ? 1 : 0;
    });
    return (0, _d3Array.permute)(values, index);
}
function merge(base, value0, index0, n0, value1, index1, n1, value, index) {
    let i0 = 0, i1 = 0, i;
    for(i = 0; i0 < n0 && i1 < n1; ++i)if (value0[i0] < value1[i1]) {
        value[i] = value0[i0];
        index[i] = index0[i0++];
    } else {
        value[i] = value1[i1];
        index[i] = index1[i1++] + base;
    }
    for(; i0 < n0; ++i0, ++i){
        value[i] = value0[i0];
        index[i] = index0[i0];
    }
    for(; i1 < n1; ++i1, ++i){
        value[i] = value1[i1];
        index[i] = index1[i1] + base;
    }
}
/**
 * An indexed multi-dimensional filter.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {Array<function(object): *>} params.fields - An array of dimension accessors to filter.
 * @param {Array} params.query - An array of per-dimension range queries.
 */ function CrossFilter(params) {
    (0, _vegaDataflow.Transform).call(this, Bitmaps(), params);
    this._indices = null;
    this._dims = null;
}
CrossFilter.Definition = {
    'type': 'CrossFilter',
    'metadata': {},
    'params': [
        {
            'name': 'fields',
            'type': 'field',
            'array': true,
            'required': true
        },
        {
            'name': 'query',
            'type': 'array',
            'array': true,
            'required': true,
            'content': {
                'type': 'number',
                'array': true,
                'length': 2
            }
        }
    ]
};
(0, _vegaUtil.inherits)(CrossFilter, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        if (!this._dims) return this.init(_, pulse);
        else {
            var init = _.modified('fields') || _.fields.some((f)=>pulse.modified(f.fields));
            return init ? this.reinit(_, pulse) : this.eval(_, pulse);
        }
    },
    init (_, pulse) {
        const fields = _.fields, query = _.query, indices = this._indices = {}, dims = this._dims = [], m = query.length;
        let i = 0, key, index;
        // instantiate indices and dimensions
        for(; i < m; ++i){
            key = fields[i].fname;
            index = indices[key] || (indices[key] = SortedIndex());
            dims.push(Dimension(index, i, query[i]));
        }
        return this.eval(_, pulse);
    },
    reinit (_, pulse) {
        const output = pulse.materialize().fork(), fields = _.fields, query = _.query, indices = this._indices, dims = this._dims, bits = this.value, curr = bits.curr(), prev = bits.prev(), all = bits.all(), out = output.rem = output.add, mod = output.mod, m = query.length, adds = {};
        let add, index, key, mods, remMap, modMap, i, n, f;
        // set prev to current state
        prev.set(curr);
        // if pulse has remove tuples, process them first
        if (pulse.rem.length) remMap = this.remove(_, pulse, output);
        // if pulse has added tuples, add them to state
        if (pulse.add.length) bits.add(pulse.add);
        // if pulse has modified tuples, create an index map
        if (pulse.mod.length) {
            modMap = {};
            for(mods = pulse.mod, i = 0, n = mods.length; i < n; ++i)modMap[mods[i]._index] = 1;
        }
        // re-initialize indices as needed, update curr bitmap
        for(i = 0; i < m; ++i){
            f = fields[i];
            if (!dims[i] || _.modified('fields', i) || pulse.modified(f.fields)) {
                key = f.fname;
                if (!(add = adds[key])) {
                    indices[key] = index = SortedIndex();
                    adds[key] = add = index.insert(f, pulse.source, 0);
                }
                dims[i] = Dimension(index, i, query[i]).onAdd(add, curr);
            }
        }
        // visit each tuple
        // if filter state changed, push index to add/rem
        // else if in mod and passes a filter, push index to mod
        for(i = 0, n = bits.data().length; i < n; ++i){
            if (remMap[i]) continue;
            else if (prev[i] !== curr[i]) // add if state changed
            out.push(i);
            else if (modMap[i] && curr[i] !== all) // otherwise, pass mods through
            mod.push(i);
        }
        bits.mask = (1 << m) - 1;
        return output;
    },
    eval (_, pulse) {
        const output = pulse.materialize().fork(), m = this._dims.length;
        let mask = 0;
        if (pulse.rem.length) {
            this.remove(_, pulse, output);
            mask |= (1 << m) - 1;
        }
        if (_.modified('query') && !_.modified('fields')) mask |= this.update(_, pulse, output);
        if (pulse.add.length) {
            this.insert(_, pulse, output);
            mask |= (1 << m) - 1;
        }
        if (pulse.mod.length) {
            this.modify(pulse, output);
            mask |= (1 << m) - 1;
        }
        this.value.mask = mask;
        return output;
    },
    insert (_, pulse, output) {
        const tuples = pulse.add, bits = this.value, dims = this._dims, indices = this._indices, fields = _.fields, adds = {}, out = output.add, n = bits.size() + tuples.length, m = dims.length;
        let k = bits.size(), j, key, add;
        // resize bitmaps and add tuples as needed
        bits.resize(n, m);
        bits.add(tuples);
        const curr = bits.curr(), prev = bits.prev(), all = bits.all();
        // add to dimensional indices
        for(j = 0; j < m; ++j){
            key = fields[j].fname;
            add = adds[key] || (adds[key] = indices[key].insert(fields[j], tuples, k));
            dims[j].onAdd(add, curr);
        }
        // set previous filters, output if passes at least one filter
        for(; k < n; ++k){
            prev[k] = all;
            if (curr[k] !== all) out.push(k);
        }
    },
    modify (pulse, output) {
        const out = output.mod, bits = this.value, curr = bits.curr(), all = bits.all(), tuples = pulse.mod;
        let i, n, k;
        for(i = 0, n = tuples.length; i < n; ++i){
            k = tuples[i]._index;
            if (curr[k] !== all) out.push(k);
        }
    },
    remove (_, pulse, output) {
        const indices = this._indices, bits = this.value, curr = bits.curr(), prev = bits.prev(), all = bits.all(), map = {}, out = output.rem, tuples = pulse.rem;
        let i, n, k, f;
        // process tuples, output if passes at least one filter
        for(i = 0, n = tuples.length; i < n; ++i){
            k = tuples[i]._index;
            map[k] = 1; // build index map
            prev[k] = f = curr[k];
            curr[k] = all;
            if (f !== all) out.push(k);
        }
        // remove from dimensional indices
        for(k in indices)indices[k].remove(n, map);
        this.reindex(pulse, n, map);
        return map;
    },
    // reindex filters and indices after propagation completes
    reindex (pulse, num, map) {
        const indices = this._indices, bits = this.value;
        pulse.runAfter(()=>{
            const indexMap = bits.remove(num, map);
            for(const key in indices)indices[key].reindex(indexMap);
        });
    },
    update (_, pulse, output) {
        const dims = this._dims, query = _.query, stamp = pulse.stamp, m = dims.length;
        let mask = 0, i, q;
        // survey how many queries have changed
        output.filters = 0;
        for(q = 0; q < m; ++q)if (_.modified('query', q)) {
            i = q;
            ++mask;
        }
        if (mask === 1) {
            // only one query changed, use more efficient update
            mask = dims[i].one;
            this.incrementOne(dims[i], query[i], output.add, output.rem);
        } else // multiple queries changed, perform full record keeping
        for(q = 0, mask = 0; q < m; ++q){
            if (!_.modified('query', q)) continue;
            mask |= dims[q].one;
            this.incrementAll(dims[q], query[q], stamp, output.add);
            output.rem = output.add; // duplicate add/rem for downstream resolve
        }
        return mask;
    },
    incrementAll (dim, query, stamp, out) {
        const bits = this.value, seen = bits.seen(), curr = bits.curr(), prev = bits.prev(), index = dim.index(), old = dim.bisect(dim.range), range = dim.bisect(query), lo1 = range[0], hi1 = range[1], lo0 = old[0], hi0 = old[1], one = dim.one;
        let i, j, k;
        // Fast incremental update based on previous lo index.
        if (lo1 < lo0) for(i = lo1, j = Math.min(lo0, hi1); i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        else if (lo1 > lo0) for(i = lo0, j = Math.min(lo1, hi0); i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        // Fast incremental update based on previous hi index.
        if (hi1 > hi0) for(i = Math.max(lo1, hi0), j = hi1; i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        else if (hi1 < hi0) for(i = Math.max(lo0, hi1), j = hi0; i < j; ++i){
            k = index[i];
            if (seen[k] !== stamp) {
                prev[k] = curr[k];
                seen[k] = stamp;
                out.push(k);
            }
            curr[k] ^= one;
        }
        dim.range = query.slice();
    },
    incrementOne (dim, query, add, rem) {
        const bits = this.value, curr = bits.curr(), index = dim.index(), old = dim.bisect(dim.range), range = dim.bisect(query), lo1 = range[0], hi1 = range[1], lo0 = old[0], hi0 = old[1], one = dim.one;
        let i, j, k;
        // Fast incremental update based on previous lo index.
        if (lo1 < lo0) for(i = lo1, j = Math.min(lo0, hi1); i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            add.push(k);
        }
        else if (lo1 > lo0) for(i = lo0, j = Math.min(lo1, hi0); i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            rem.push(k);
        }
        // Fast incremental update based on previous hi index.
        if (hi1 > hi0) for(i = Math.max(lo1, hi0), j = hi1; i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            add.push(k);
        }
        else if (hi1 < hi0) for(i = Math.max(lo0, hi1), j = hi0; i < j; ++i){
            k = index[i];
            curr[k] ^= one;
            rem.push(k);
        }
        dim.range = query.slice();
    }
});
/**
 * Selectively filters tuples by resolving against a filter bitmap.
 * Useful for processing the output of a cross-filter transform.
 * @constructor
 * @param {object} params - The parameters for this operator.
 * @param {object} params.ignore - A bit mask indicating which filters to ignore.
 * @param {object} params.filter - The per-tuple filter bitmaps. Typically this
 *   parameter value is a reference to a {@link CrossFilter} transform.
 */ function ResolveFilter(params) {
    (0, _vegaDataflow.Transform).call(this, null, params);
}
ResolveFilter.Definition = {
    'type': 'ResolveFilter',
    'metadata': {},
    'params': [
        {
            'name': 'ignore',
            'type': 'number',
            'required': true,
            'description': 'A bit mask indicating which filters to ignore.'
        },
        {
            'name': 'filter',
            'type': 'object',
            'required': true,
            'description': 'Per-tuple filter bitmaps from a CrossFilter transform.'
        }
    ]
};
(0, _vegaUtil.inherits)(ResolveFilter, (0, _vegaDataflow.Transform), {
    transform (_, pulse) {
        const ignore = ~(_.ignore || 0), // bit mask where zeros -> dims to ignore
        bitmap = _.filter, mask = bitmap.mask;
        // exit early if no relevant filter changes
        if ((mask & ignore) === 0) return pulse.StopPropagation;
        const output = pulse.fork(pulse.ALL), data = bitmap.data(), curr = bitmap.curr(), prev = bitmap.prev(), pass = (k)=>!(curr[k] & ignore) ? data[k] : null;
        // propagate all mod tuples that pass the filter
        output.filter(output.MOD, pass);
        // determine add & rem tuples via filter functions
        // for efficiency, we do *not* populate new arrays,
        // instead we add filter functions applied downstream
        if (!(mask & mask - 1)) {
            // only one filter changed
            output.filter(output.ADD, pass);
            output.filter(output.REM, (k)=>(curr[k] & ignore) === mask ? data[k] : null);
        } else {
            // multiple filters changed
            output.filter(output.ADD, (k)=>{
                const c = curr[k] & ignore, f = !c && c ^ prev[k] & ignore;
                return f ? data[k] : null;
            });
            output.filter(output.REM, (k)=>{
                const c = curr[k] & ignore, f = c && !(c ^ (c ^ prev[k] & ignore));
                return f ? data[k] : null;
            });
        }
        // add filter to source data in case of reflow...
        return output.filter(output.SOURCE, (t)=>pass(t._index));
    }
});

},{"d3-array":"4pSqo","vega-dataflow":"eoU45","vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1x0KD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>View);
var _vegaUtil = require("vega-util");
var _vegaDataflow = require("vega-dataflow");
var _vegaScenegraph = require("vega-scenegraph");
var _d3Array = require("d3-array");
var _vegaFunctions = require("vega-functions");
var _vegaRuntime = require("vega-runtime");
var _d3Timer = require("d3-timer");
var _vegaFormat = require("vega-format");
// initialize aria role and label attributes
function initializeAria(view) {
    const el = view.container();
    if (el) {
        el.setAttribute('role', 'graphics-document');
        el.setAttribute('aria-roleDescription', 'visualization');
        ariaLabel(el, view.description());
    }
}
// update aria-label if we have a DOM container element
function ariaLabel(el, desc) {
    if (el) desc == null ? el.removeAttribute('aria-label') : el.setAttribute('aria-label', desc);
}
function background(view) {
    // respond to background signal
    view.add(null, (_)=>{
        view._background = _.bg;
        view._resize = 1;
        return _.bg;
    }, {
        bg: view._signals.background
    });
}
const Default = 'default';
function cursor(view) {
    // get cursor signal, add to dataflow if needed
    const cursor = view._signals.cursor || (view._signals.cursor = view.add({
        user: Default,
        item: null
    }));
    // evaluate cursor on each pointermove event
    view.on(view.events('view', 'pointermove'), cursor, (_, event)=>{
        const value = cursor.value, user = value ? (0, _vegaUtil.isString)(value) ? value : value.user : Default, item = event.item && event.item.cursor || null;
        return value && user === value.user && item == value.item ? value : {
            user: user,
            item: item
        };
    });
    // when cursor signal updates, set visible cursor
    view.add(null, function(_) {
        let user = _.cursor, item = this.value;
        if (!(0, _vegaUtil.isString)(user)) {
            item = user.item;
            user = user.user;
        }
        setCursor(view, user && user !== Default ? user : item || user);
        return item;
    }, {
        cursor: cursor
    });
}
function setCursor(view, cursor) {
    const el = view.globalCursor() ? typeof document !== 'undefined' && document.body : view.container();
    if (el) return cursor == null ? el.style.removeProperty('cursor') : el.style.cursor = cursor;
}
function dataref(view, name) {
    var data = view._runtime.data;
    if (!(0, _vegaUtil.hasOwnProperty)(data, name)) (0, _vegaUtil.error)('Unrecognized data set: ' + name);
    return data[name];
}
function data(name, values) {
    return arguments.length < 2 ? dataref(this, name).values.value : change.call(this, name, (0, _vegaDataflow.changeset)().remove((0, _vegaUtil.truthy)).insert(values));
}
function change(name, changes) {
    if (!(0, _vegaDataflow.isChangeSet)(changes)) (0, _vegaUtil.error)('Second argument to changes must be a changeset.');
    const dataset = dataref(this, name);
    dataset.modified = true;
    return this.pulse(dataset.input, changes);
}
function insert(name, _) {
    return change.call(this, name, (0, _vegaDataflow.changeset)().insert(_));
}
function remove(name, _) {
    return change.call(this, name, (0, _vegaDataflow.changeset)().remove(_));
}
function width(view) {
    var padding = view.padding();
    return Math.max(0, view._viewWidth + padding.left + padding.right);
}
function height(view) {
    var padding = view.padding();
    return Math.max(0, view._viewHeight + padding.top + padding.bottom);
}
function offset(view) {
    var padding = view.padding(), origin = view._origin;
    return [
        padding.left + origin[0],
        padding.top + origin[1]
    ];
}
function resizeRenderer(view) {
    var origin = offset(view), w = width(view), h = height(view);
    view._renderer.background(view.background());
    view._renderer.resize(w, h, origin);
    view._handler.origin(origin);
    view._resizeListeners.forEach((handler)=>{
        try {
            handler(w, h);
        } catch (error) {
            view.error(error);
        }
    });
}
/**
 * Extend an event with additional view-specific methods.
 * Adds a new property ('vega') to an event that provides a number
 * of methods for querying information about the current interaction.
 * The vega object provides the following methods:
 *   view - Returns the backing View instance.
 *   item - Returns the currently active scenegraph item (if any).
 *   group - Returns the currently active scenegraph group (if any).
 *     This method accepts a single string-typed argument indicating the name
 *     of the desired parent group. The scenegraph will be traversed from
 *     the item up towards the root to search for a matching group. If no
 *     argument is provided the enclosing group for the active item is
 *     returned, unless the item it itself a group, in which case it is
 *     returned directly.
 *   xy - Returns a two-element array containing the x and y coordinates for
 *     mouse or touch events. For touch events, this is based on the first
 *     elements in the changedTouches array. This method accepts a single
 *     argument: either an item instance or mark name that should serve as
 *     the reference coordinate system. If no argument is provided the
 *     top-level view coordinate system is assumed.
 *   x - Returns the current x-coordinate, accepts the same arguments as xy.
 *   y - Returns the current y-coordinate, accepts the same arguments as xy.
 * @param {Event} event - The input event to extend.
 * @param {Item} item - The currently active scenegraph item (if any).
 * @return {Event} - The extended input event.
 */ function eventExtend(view, event, item) {
    var r = view._renderer, el = r && r.canvas(), p, e, translate;
    if (el) {
        translate = offset(view);
        e = event.changedTouches ? event.changedTouches[0] : event;
        p = (0, _vegaScenegraph.point)(e, el);
        p[0] -= translate[0];
        p[1] -= translate[1];
    }
    event.dataflow = view;
    event.item = item;
    event.vega = extension(view, item, p);
    return event;
}
function extension(view, item, point) {
    const itemGroup = item ? item.mark.marktype === 'group' ? item : item.mark.group : null;
    function group(name) {
        var g = itemGroup, i;
        if (name) {
            for(i = item; i; i = i.mark.group)if (i.mark.name === name) {
                g = i;
                break;
            }
        }
        return g && g.mark && g.mark.interactive ? g : {};
    }
    function xy(item) {
        if (!item) return point;
        if ((0, _vegaUtil.isString)(item)) item = group(item);
        const p = point.slice();
        while(item){
            p[0] -= item.x || 0;
            p[1] -= item.y || 0;
            item = item.mark && item.mark.group;
        }
        return p;
    }
    return {
        view: (0, _vegaUtil.constant)(view),
        item: (0, _vegaUtil.constant)(item || {}),
        group: group,
        xy: xy,
        x: (item)=>xy(item)[0],
        y: (item)=>xy(item)[1]
    };
}
const VIEW = 'view', TIMER = 'timer', WINDOW = 'window', NO_TRAP = {
    trap: false
};
/**
 * Initialize event handling configuration.
 * @param {object} config - The configuration settings.
 * @return {object}
 */ function initializeEventConfig(config) {
    const events = (0, _vegaUtil.extend)({
        defaults: {}
    }, config);
    const unpack = (obj, keys)=>{
        keys.forEach((k)=>{
            if ((0, _vegaUtil.isArray)(obj[k])) obj[k] = (0, _vegaUtil.toSet)(obj[k]);
        });
    };
    unpack(events.defaults, [
        'prevent',
        'allow'
    ]);
    unpack(events, [
        'view',
        'window',
        'selector'
    ]);
    return events;
}
function trackEventListener(view, sources, type, handler) {
    view._eventListeners.push({
        type: type,
        sources: (0, _vegaUtil.array)(sources),
        handler: handler
    });
}
function prevent(view, type) {
    var def = view._eventConfig.defaults, prevent = def.prevent, allow = def.allow;
    return prevent === false || allow === true ? false : prevent === true || allow === false ? true : prevent ? prevent[type] : allow ? !allow[type] : view.preventDefault();
}
function permit(view, key, type) {
    const rule = view._eventConfig && view._eventConfig[key];
    if (rule === false || (0, _vegaUtil.isObject)(rule) && !rule[type]) {
        view.warn(`Blocked ${key} ${type} event listener.`);
        return false;
    }
    return true;
}
/**
 * Create a new event stream from an event source.
 * @param {object} source - The event source to monitor.
 * @param {string} type - The event type.
 * @param {function(object): boolean} [filter] - Event filter function.
 * @return {EventStream}
 */ function events(source, type, filter) {
    var view = this, s = new (0, _vegaDataflow.EventStream)(filter), send = function(e, item) {
        view.runAsync(null, ()=>{
            if (source === VIEW && prevent(view, type)) e.preventDefault();
            s.receive(eventExtend(view, e, item));
        });
    }, sources;
    if (source === TIMER) {
        if (permit(view, 'timer', type)) view.timer(send, type);
    } else if (source === VIEW) {
        if (permit(view, 'view', type)) // send traps errors, so use {trap: false} option
        view.addEventListener(type, send, NO_TRAP);
    } else {
        if (source === WINDOW) {
            if (permit(view, 'window', type) && typeof window !== 'undefined') sources = [
                window
            ];
        } else if (typeof document !== 'undefined') {
            if (permit(view, 'selector', type)) sources = Array.from(document.querySelectorAll(source));
        }
        if (!sources) view.warn('Can not resolve event source: ' + source);
        else {
            for(var i = 0, n = sources.length; i < n; ++i)sources[i].addEventListener(type, send);
            trackEventListener(view, sources, type, send);
        }
    }
    return s;
}
function itemFilter(event) {
    return event.item;
}
function markTarget(event) {
    // grab upstream collector feeding the mark operator
    return event.item.mark.source;
}
function invoke(name) {
    return function(_, event) {
        return event.vega.view().changeset().encode(event.item, name);
    };
}
function hover(hoverSet, leaveSet) {
    hoverSet = [
        hoverSet || 'hover'
    ];
    leaveSet = [
        leaveSet || 'update',
        hoverSet[0]
    ];
    // invoke hover set upon pointerover
    this.on(this.events('view', 'pointerover', itemFilter), markTarget, invoke(hoverSet));
    // invoke leave set upon pointerout
    this.on(this.events('view', 'pointerout', itemFilter), markTarget, invoke(leaveSet));
    return this;
}
/**
 * Finalize a View instance that is being removed.
 * Cancel any running timers.
 * Remove all external event listeners.
 * Remove any currently displayed tooltip.
 */ function finalize() {
    var tooltip = this._tooltip, timers = this._timers, handlers = this._handler.handlers(), listeners = this._eventListeners, n, m, e, h, t;
    n = timers.length;
    while(--n >= 0)timers[n].stop();
    n = listeners.length;
    while(--n >= 0){
        e = listeners[n];
        m = e.sources.length;
        while(--m >= 0)e.sources[m].removeEventListener(e.type, e.handler);
    }
    if (tooltip) tooltip.call(this, this._handler, null, null, null);
    // turn off all registered handlers
    n = handlers.length;
    while(--n >= 0){
        t = handlers[n].type;
        h = handlers[n].handler;
        this._handler.off(t, h);
    }
    return this;
}
function element(tag, attr, text) {
    const el = document.createElement(tag);
    for(const key in attr)el.setAttribute(key, attr[key]);
    if (text != null) el.textContent = text;
    return el;
}
const BindClass = 'vega-bind', NameClass = 'vega-bind-name', RadioClass = 'vega-bind-radio';
/**
 * Bind a signal to an external HTML input element. The resulting two-way
 * binding will propagate input changes to signals, and propagate signal
 * changes to the input element state. If this view instance has no parent
 * element, we assume the view is headless and no bindings are created.
 * @param {Element|string} el - The parent DOM element to which the input
 *   element should be appended as a child. If string-valued, this argument
 *   will be treated as a CSS selector. If null or undefined, the parent
 *   element of this view will be used as the element.
 * @param {object} param - The binding parameters which specify the signal
 *   to bind to, the input element type, and type-specific configuration.
 * @return {View} - This view instance.
 */ function bind(view, el, binding) {
    if (!el) return;
    const param = binding.param;
    let bind = binding.state;
    if (!bind) {
        bind = binding.state = {
            elements: null,
            active: false,
            set: null,
            update: (value)=>{
                if (value != view.signal(param.signal)) view.runAsync(null, ()=>{
                    bind.source = true;
                    view.signal(param.signal, value);
                });
            }
        };
        if (param.debounce) bind.update = (0, _vegaUtil.debounce)(param.debounce, bind.update);
    }
    const create = param.input == null && param.element ? target : generate;
    create(bind, el, param, view);
    if (!bind.active) {
        view.on(view._signals[param.signal], null, ()=>{
            bind.source ? bind.source = false : bind.set(view.signal(param.signal));
        });
        bind.active = true;
    }
    return bind;
}
/**
 * Bind the signal to an external EventTarget.
 */ function target(bind, node, param, view) {
    const type = param.event || 'input';
    const handler = ()=>bind.update(node.value);
    // initialize signal value to external input value
    view.signal(param.signal, node.value);
    // listen for changes on the element
    node.addEventListener(type, handler);
    // register with view, so we can remove it upon finalization
    trackEventListener(view, node, type, handler);
    // propagate change to element
    bind.set = (value)=>{
        node.value = value;
        node.dispatchEvent(event(type));
    };
}
function event(type) {
    return typeof Event !== 'undefined' ? new Event(type) : {
        type
    };
}
/**
 * Generate an HTML input form element and bind it to a signal.
 */ function generate(bind, el, param, view) {
    const value = view.signal(param.signal);
    const div = element('div', {
        'class': BindClass
    });
    const wrapper = param.input === 'radio' ? div : div.appendChild(element('label'));
    wrapper.appendChild(element('span', {
        'class': NameClass
    }, param.name || param.signal));
    el.appendChild(div);
    let input = form;
    switch(param.input){
        case 'checkbox':
            input = checkbox;
            break;
        case 'select':
            input = select;
            break;
        case 'radio':
            input = radio;
            break;
        case 'range':
            input = range;
            break;
    }
    input(bind, wrapper, param, value);
}
/**
 * Generates an arbitrary input form element.
 * The input type is controlled via user-provided parameters.
 */ function form(bind, el, param, value) {
    const node = element('input');
    for(const key in param)if (key !== 'signal' && key !== 'element') node.setAttribute(key === 'input' ? 'type' : key, param[key]);
    node.setAttribute('name', param.signal);
    node.value = value;
    el.appendChild(node);
    node.addEventListener('input', ()=>bind.update(node.value));
    bind.elements = [
        node
    ];
    bind.set = (value)=>node.value = value;
}
/**
 * Generates a checkbox input element.
 */ function checkbox(bind, el, param, value) {
    const attr = {
        type: 'checkbox',
        name: param.signal
    };
    if (value) attr.checked = true;
    const node = element('input', attr);
    el.appendChild(node);
    node.addEventListener('change', ()=>bind.update(node.checked));
    bind.elements = [
        node
    ];
    bind.set = (value)=>node.checked = !!value || null;
}
/**
 * Generates a selection list input element.
 */ function select(bind, el, param, value) {
    const node = element('select', {
        name: param.signal
    }), labels = param.labels || [];
    param.options.forEach((option, i)=>{
        const attr = {
            value: option
        };
        if (valuesEqual(option, value)) attr.selected = true;
        node.appendChild(element('option', attr, (labels[i] || option) + ''));
    });
    el.appendChild(node);
    node.addEventListener('change', ()=>{
        bind.update(param.options[node.selectedIndex]);
    });
    bind.elements = [
        node
    ];
    bind.set = (value)=>{
        for(let i = 0, n = param.options.length; i < n; ++i)if (valuesEqual(param.options[i], value)) {
            node.selectedIndex = i;
            return;
        }
    };
}
/**
 * Generates a radio button group.
 */ function radio(bind, el, param, value) {
    const group = element('span', {
        'class': RadioClass
    }), labels = param.labels || [];
    el.appendChild(group);
    bind.elements = param.options.map((option, i)=>{
        const attr = {
            type: 'radio',
            name: param.signal,
            value: option
        };
        if (valuesEqual(option, value)) attr.checked = true;
        const input = element('input', attr);
        input.addEventListener('change', ()=>bind.update(option));
        const label = element('label', {}, (labels[i] || option) + '');
        label.prepend(input);
        group.appendChild(label);
        return input;
    });
    bind.set = (value)=>{
        const nodes = bind.elements, n = nodes.length;
        for(let i = 0; i < n; ++i)if (valuesEqual(nodes[i].value, value)) nodes[i].checked = true;
    };
}
/**
 * Generates a slider input element.
 */ function range(bind, el, param, value) {
    value = value !== undefined ? value : (+param.max + +param.min) / 2;
    const max = param.max != null ? param.max : Math.max(100, +value) || 100, min = param.min || Math.min(0, max, +value) || 0, step = param.step || (0, _d3Array.tickStep)(min, max, 100);
    const node = element('input', {
        type: 'range',
        name: param.signal,
        min: min,
        max: max,
        step: step
    });
    node.value = value;
    const span = element('span', {}, +value);
    el.appendChild(node);
    el.appendChild(span);
    const update = ()=>{
        span.textContent = node.value;
        bind.update(+node.value);
    };
    // subscribe to both input and change
    node.addEventListener('input', update);
    node.addEventListener('change', update);
    bind.elements = [
        node
    ];
    bind.set = (value)=>{
        node.value = value;
        span.textContent = value;
    };
}
function valuesEqual(a, b) {
    return a === b || a + '' === b + '';
}
function initializeRenderer(view, r, el, constructor, scaleFactor, opt) {
    r = r || new constructor(view.loader());
    return r.initialize(el, width(view), height(view), offset(view), scaleFactor, opt).background(view.background());
}
function trap(view, fn) {
    return !fn ? null : function() {
        try {
            fn.apply(this, arguments);
        } catch (error) {
            view.error(error);
        }
    };
}
function initializeHandler(view, prevHandler, el, constructor) {
    // instantiate scenegraph handler
    const handler = new constructor(view.loader(), trap(view, view.tooltip())).scene(view.scenegraph().root).initialize(el, offset(view), view);
    // transfer event handlers
    if (prevHandler) prevHandler.handlers().forEach((h)=>{
        handler.on(h.type, h.handler);
    });
    return handler;
}
function initialize(el, elBind) {
    const view = this, type = view._renderType, config = view._eventConfig.bind, module = (0, _vegaScenegraph.renderModule)(type);
    // containing dom element
    el = view._el = el ? lookup(view, el, true) : null;
    // initialize aria attributes
    initializeAria(view);
    // select appropriate renderer & handler
    if (!module) view.error('Unrecognized renderer type: ' + type);
    const Handler = module.handler || (0, _vegaScenegraph.CanvasHandler), Renderer = el ? module.renderer : module.headless;
    // initialize renderer and input handler
    view._renderer = !Renderer ? null : initializeRenderer(view, view._renderer, el, Renderer);
    view._handler = initializeHandler(view, view._handler, el, Handler);
    view._redraw = true;
    // initialize signal bindings
    if (el && config !== 'none') {
        elBind = elBind ? view._elBind = lookup(view, elBind, true) : el.appendChild(element('form', {
            'class': 'vega-bindings'
        }));
        view._bind.forEach((_)=>{
            if (_.param.element && config !== 'container') _.element = lookup(view, _.param.element, !!_.param.input);
        });
        view._bind.forEach((_)=>{
            bind(view, _.element || elBind, _);
        });
    }
    return view;
}
function lookup(view, el, clear) {
    if (typeof el === 'string') {
        if (typeof document !== 'undefined') {
            el = document.querySelector(el);
            if (!el) {
                view.error('Signal bind element not found: ' + el);
                return null;
            }
        } else {
            view.error('DOM document instance not found.');
            return null;
        }
    }
    if (el && clear) try {
        el.textContent = '';
    } catch (e) {
        el = null;
        view.error(e);
    }
    return el;
}
const number = (_)=>+_ || 0;
const paddingObject = (_)=>({
        top: _,
        bottom: _,
        left: _,
        right: _
    });
function padding(_) {
    return (0, _vegaUtil.isObject)(_) ? {
        top: number(_.top),
        bottom: number(_.bottom),
        left: number(_.left),
        right: number(_.right)
    } : paddingObject(number(_));
}
/**
 * Render the current scene in a headless fashion.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A Promise that resolves to a renderer.
 */ async function renderHeadless(view, type, scaleFactor, opt) {
    const module = (0, _vegaScenegraph.renderModule)(type), ctr = module && module.headless;
    if (!ctr) (0, _vegaUtil.error)('Unrecognized renderer type: ' + type);
    await view.runAsync();
    return initializeRenderer(view, null, null, ctr, scaleFactor, opt).renderAsync(view._scenegraph.root);
}
/**
 * Produce an image URL for the visualization. Depending on the type
 * parameter, the generated URL contains data for either a PNG or SVG image.
 * The URL can be used (for example) to download images of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @param {string} type - The image type. One of 'svg', 'png' or 'canvas'.
 *   The 'canvas' and 'png' types are synonyms for a PNG image.
 * @return {Promise} - A promise that resolves to an image URL.
 */ async function renderToImageURL(type, scaleFactor) {
    if (type !== (0, _vegaScenegraph.RenderType).Canvas && type !== (0, _vegaScenegraph.RenderType).SVG && type !== (0, _vegaScenegraph.RenderType).PNG) (0, _vegaUtil.error)('Unrecognized image type: ' + type);
    const r = await renderHeadless(this, type, scaleFactor);
    return type === (0, _vegaScenegraph.RenderType).SVG ? toBlobURL(r.svg(), 'image/svg+xml') : r.canvas().toDataURL('image/png');
}
function toBlobURL(data, mime) {
    const blob = new Blob([
        data
    ], {
        type: mime
    });
    return window.URL.createObjectURL(blob);
}
/**
 * Produce a Canvas instance containing a rendered visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to a Canvas instance.
 */ async function renderToCanvas(scaleFactor, opt) {
    const r = await renderHeadless(this, (0, _vegaScenegraph.RenderType).Canvas, scaleFactor, opt);
    return r.canvas();
}
/**
 * Produce a rendered SVG string of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to an SVG string.
 */ async function renderToSVG(scaleFactor) {
    const r = await renderHeadless(this, (0, _vegaScenegraph.RenderType).SVG, scaleFactor);
    return r.svg();
}
function runtime(view, spec, expr) {
    return (0, _vegaRuntime.context)(view, (0, _vegaDataflow.transforms), (0, _vegaFunctions.functionContext), expr).parse(spec);
}
function scale(name) {
    var scales = this._runtime.scales;
    if (!(0, _vegaUtil.hasOwnProperty)(scales, name)) (0, _vegaUtil.error)('Unrecognized scale or projection: ' + name);
    return scales[name].value;
}
var Width = 'width', Height = 'height', Padding = 'padding', Skip = {
    skip: true
};
function viewWidth(view, width) {
    var a = view.autosize(), p = view.padding();
    return width - (a && a.contains === Padding ? p.left + p.right : 0);
}
function viewHeight(view, height) {
    var a = view.autosize(), p = view.padding();
    return height - (a && a.contains === Padding ? p.top + p.bottom : 0);
}
function initializeResize(view) {
    var s = view._signals, w = s[Width], h = s[Height], p = s[Padding];
    function resetSize() {
        view._autosize = view._resize = 1;
    }
    // respond to width signal
    view._resizeWidth = view.add(null, (_)=>{
        view._width = _.size;
        view._viewWidth = viewWidth(view, _.size);
        resetSize();
    }, {
        size: w
    });
    // respond to height signal
    view._resizeHeight = view.add(null, (_)=>{
        view._height = _.size;
        view._viewHeight = viewHeight(view, _.size);
        resetSize();
    }, {
        size: h
    });
    // respond to padding signal
    const resizePadding = view.add(null, resetSize, {
        pad: p
    });
    // set rank to run immediately after source signal
    view._resizeWidth.rank = w.rank + 1;
    view._resizeHeight.rank = h.rank + 1;
    resizePadding.rank = p.rank + 1;
}
function resizeView(viewWidth, viewHeight, width, height, origin, auto) {
    this.runAfter((view)=>{
        let rerun = 0;
        // reset autosize flag
        view._autosize = 0;
        // width value changed: update signal, skip resize op
        if (view.width() !== width) {
            rerun = 1;
            view.signal(Width, width, Skip); // set width, skip update calc
            view._resizeWidth.skip(true); // skip width resize handler
        }
        // height value changed: update signal, skip resize op
        if (view.height() !== height) {
            rerun = 1;
            view.signal(Height, height, Skip); // set height, skip update calc
            view._resizeHeight.skip(true); // skip height resize handler
        }
        // view width changed: update view property, set resize flag
        if (view._viewWidth !== viewWidth) {
            view._resize = 1;
            view._viewWidth = viewWidth;
        }
        // view height changed: update view property, set resize flag
        if (view._viewHeight !== viewHeight) {
            view._resize = 1;
            view._viewHeight = viewHeight;
        }
        // origin changed: update view property, set resize flag
        if (view._origin[0] !== origin[0] || view._origin[1] !== origin[1]) {
            view._resize = 1;
            view._origin = origin;
        }
        // run dataflow on width/height signal change
        if (rerun) view.run('enter');
        if (auto) view.runAfter((v)=>v.resize());
    }, false, 1);
}
/**
 * Get the current view state, consisting of signal values and/or data sets.
 * @param {object} [options] - Options flags indicating which state to export.
 *   If unspecified, all signals and data sets will be exported.
 * @param {function(string, Operator):boolean} [options.signals] - Optional
 *   predicate function for testing if a signal should be included in the
 *   exported state. If unspecified, all signals will be included, except for
 *   those named 'parent' or those which refer to a Transform value.
 * @param {function(string, object):boolean} [options.data] - Optional
 *   predicate function for testing if a data set's input should be included
 *   in the exported state. If unspecified, all data sets that have been
 *   explicitly modified will be included.
 * @param {boolean} [options.recurse=true] - Flag indicating if the exported
 *   state should recursively include state from group mark sub-contexts.
 * @return {object} - An object containing the exported state values.
 */ function getState(options) {
    return this._runtime.getState(options || {
        data: dataTest,
        signals: signalTest,
        recurse: true
    });
}
function dataTest(name, data) {
    return data.modified && (0, _vegaUtil.isArray)(data.input.value) && !name.startsWith('_:vega:_');
}
function signalTest(name, op) {
    return !(name === 'parent' || op instanceof (0, _vegaDataflow.transforms).proxy);
}
/**
 * Sets the current view state and updates the view by invoking run.
 * @param {object} state - A state object containing signal and/or
 *   data set values, following the format used by the getState method.
 * @return {View} - This view instance.
 */ function setState(state) {
    this.runAsync(null, (v)=>{
        v._trigger = false;
        v._runtime.setState(state);
    }, (v)=>{
        v._trigger = true;
    });
    return this;
}
function timer(callback, delay) {
    function tick(elapsed) {
        callback({
            timestamp: Date.now(),
            elapsed: elapsed
        });
    }
    this._timers.push((0, _d3Timer.interval)(tick, delay));
}
function defaultTooltip(handler, event, item, value) {
    const el = handler.element();
    if (el) el.setAttribute('title', formatTooltip(value));
}
function formatTooltip(value) {
    return value == null ? '' : (0, _vegaUtil.isArray)(value) ? formatArray(value) : (0, _vegaUtil.isObject)(value) && !(0, _vegaUtil.isDate)(value) ? formatObject(value) : value + '';
}
function formatObject(obj) {
    return Object.keys(obj).map((key)=>{
        const v = obj[key];
        return key + ': ' + ((0, _vegaUtil.isArray)(v) ? formatArray(v) : formatValue(v));
    }).join('\n');
}
function formatArray(value) {
    return '[' + value.map(formatValue).join(', ') + ']';
}
function formatValue(value) {
    return (0, _vegaUtil.isArray)(value) ? '[\u2026]' : (0, _vegaUtil.isObject)(value) && !(0, _vegaUtil.isDate)(value) ? '{\u2026}' : value;
}
function watchPixelRatio() {
    // based on https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
    if (this.renderer() === 'canvas' && this._renderer._canvas) {
        let remove = null;
        const updatePixelRatio = ()=>{
            if (remove != null) remove();
            const media = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            media.addEventListener('change', updatePixelRatio);
            remove = ()=>{
                media.removeEventListener('change', updatePixelRatio);
            };
            this._renderer._canvas.getContext('2d').pixelRatio = window.devicePixelRatio || 1;
            this._redraw = true;
            this._resize = 1;
            this.resize().runAsync();
        };
        updatePixelRatio();
    }
}
/**
 * Create a new View instance from a Vega dataflow runtime specification.
 * The generated View will not immediately be ready for display. Callers
 * should also invoke the initialize method (e.g., to set the parent
 * DOM element in browser-based deployment) and then invoke the run
 * method to evaluate the dataflow graph. Rendering will automatically
 * be performed upon dataflow runs.
 * @constructor
 * @param {object} spec - The Vega dataflow runtime specification.
 */ function View(spec, options) {
    const view = this;
    options = options || {};
    (0, _vegaDataflow.Dataflow).call(view);
    if (options.loader) view.loader(options.loader);
    if (options.logger) view.logger(options.logger);
    if (options.logLevel != null) view.logLevel(options.logLevel);
    if (options.locale || spec.locale) {
        const loc = (0, _vegaUtil.extend)({}, spec.locale, options.locale);
        view.locale((0, _vegaFormat.locale)(loc.number, loc.time));
    }
    view._el = null;
    view._elBind = null;
    view._renderType = options.renderer || (0, _vegaScenegraph.RenderType).Canvas;
    view._scenegraph = new (0, _vegaScenegraph.Scenegraph)();
    const root = view._scenegraph.root;
    // initialize renderer, handler and event management
    view._renderer = null;
    view._tooltip = options.tooltip || defaultTooltip, view._redraw = true;
    view._handler = new (0, _vegaScenegraph.CanvasHandler)().scene(root);
    view._globalCursor = false;
    view._preventDefault = false;
    view._timers = [];
    view._eventListeners = [];
    view._resizeListeners = [];
    // initialize event configuration
    view._eventConfig = initializeEventConfig(spec.eventConfig);
    view.globalCursor(view._eventConfig.globalCursor);
    // initialize dataflow graph
    const ctx = runtime(view, spec, options.expr);
    view._runtime = ctx;
    view._signals = ctx.signals;
    view._bind = (spec.bindings || []).map((_)=>({
            state: null,
            param: (0, _vegaUtil.extend)({}, _)
        }));
    // initialize scenegraph
    if (ctx.root) ctx.root.set(root);
    root.source = ctx.data.root.input;
    view.pulse(ctx.data.root.input, view.changeset().insert(root.items));
    // initialize view size
    view._width = view.width();
    view._height = view.height();
    view._viewWidth = viewWidth(view, view._width);
    view._viewHeight = viewHeight(view, view._height);
    view._origin = [
        0,
        0
    ];
    view._resize = 0;
    view._autosize = 1;
    initializeResize(view);
    // initialize background color
    background(view);
    // initialize cursor
    cursor(view);
    // initialize view description
    view.description(spec.description);
    // initialize hover proessing, if requested
    if (options.hover) view.hover();
    // initialize DOM container(s) and renderer
    if (options.container) view.initialize(options.container, options.bind);
    if (options.watchPixelRatio) view._watchPixelRatio();
}
function lookupSignal(view, name) {
    return (0, _vegaUtil.hasOwnProperty)(view._signals, name) ? view._signals[name] : (0, _vegaUtil.error)('Unrecognized signal name: ' + (0, _vegaUtil.stringValue)(name));
}
function findOperatorHandler(op, handler) {
    const h = (op._targets || []).filter((op)=>op._update && op._update.handler === handler);
    return h.length ? h[0] : null;
}
function addOperatorListener(view, name, op, handler) {
    let h = findOperatorHandler(op, handler);
    if (!h) {
        h = trap(view, ()=>handler(name, op.value));
        h.handler = handler;
        view.on(op, null, h);
    }
    return view;
}
function removeOperatorListener(view, op, handler) {
    const h = findOperatorHandler(op, handler);
    if (h) op._targets.remove(h);
    return view;
}
(0, _vegaUtil.inherits)(View, (0, _vegaDataflow.Dataflow), {
    // -- DATAFLOW / RENDERING ----
    async evaluate (encode, prerun, postrun) {
        // evaluate dataflow and prerun
        await (0, _vegaDataflow.Dataflow).prototype.evaluate.call(this, encode, prerun);
        // render as needed
        if (this._redraw || this._resize) try {
            if (this._renderer) {
                if (this._resize) {
                    this._resize = 0;
                    resizeRenderer(this);
                }
                await this._renderer.renderAsync(this._scenegraph.root);
            }
            this._redraw = false;
        } catch (e) {
            this.error(e);
        }
        // evaluate postrun
        if (postrun) (0, _vegaDataflow.asyncCallback)(this, postrun);
        return this;
    },
    dirty (item) {
        this._redraw = true;
        this._renderer && this._renderer.dirty(item);
    },
    // -- GET / SET ----
    description (text) {
        if (arguments.length) {
            const desc = text != null ? text + '' : null;
            if (desc !== this._desc) ariaLabel(this._el, this._desc = desc);
            return this;
        }
        return this._desc;
    },
    container () {
        return this._el;
    },
    scenegraph () {
        return this._scenegraph;
    },
    origin () {
        return this._origin.slice();
    },
    signal (name, value, options) {
        const op = lookupSignal(this, name);
        return arguments.length === 1 ? op.value : this.update(op, value, options);
    },
    width (_) {
        return arguments.length ? this.signal('width', _) : this.signal('width');
    },
    height (_) {
        return arguments.length ? this.signal('height', _) : this.signal('height');
    },
    padding (_) {
        return arguments.length ? this.signal('padding', padding(_)) : padding(this.signal('padding'));
    },
    autosize (_) {
        return arguments.length ? this.signal('autosize', _) : this.signal('autosize');
    },
    background (_) {
        return arguments.length ? this.signal('background', _) : this.signal('background');
    },
    renderer (type) {
        if (!arguments.length) return this._renderType;
        if (!(0, _vegaScenegraph.renderModule)(type)) (0, _vegaUtil.error)('Unrecognized renderer type: ' + type);
        if (type !== this._renderType) {
            this._renderType = type;
            this._resetRenderer();
        }
        return this;
    },
    tooltip (handler) {
        if (!arguments.length) return this._tooltip;
        if (handler !== this._tooltip) {
            this._tooltip = handler;
            this._resetRenderer();
        }
        return this;
    },
    loader (loader) {
        if (!arguments.length) return this._loader;
        if (loader !== this._loader) {
            (0, _vegaDataflow.Dataflow).prototype.loader.call(this, loader);
            this._resetRenderer();
        }
        return this;
    },
    resize () {
        // set flag to perform autosize
        this._autosize = 1;
        // touch autosize signal to ensure top-level ViewLayout runs
        return this.touch(lookupSignal(this, 'autosize'));
    },
    _resetRenderer () {
        if (this._renderer) {
            this._renderer = null;
            this.initialize(this._el, this._elBind);
        }
    },
    // -- SIZING ----
    _resizeView: resizeView,
    // -- EVENT HANDLING ----
    addEventListener (type, handler, options) {
        let callback = handler;
        if (!(options && options.trap === false)) {
            // wrap callback in error handler
            callback = trap(this, handler);
            callback.raw = handler;
        }
        this._handler.on(type, callback);
        return this;
    },
    removeEventListener (type, handler) {
        var handlers = this._handler.handlers(type), i = handlers.length, h, t;
        // search registered handlers, remove if match found
        while(--i >= 0){
            t = handlers[i].type;
            h = handlers[i].handler;
            if (type === t && (handler === h || handler === h.raw)) {
                this._handler.off(t, h);
                break;
            }
        }
        return this;
    },
    addResizeListener (handler) {
        const l = this._resizeListeners;
        if (!l.includes(handler)) // add handler if it isn't already registered
        // note: error trapping handled elsewhere, so
        // no need to wrap handlers here
        l.push(handler);
        return this;
    },
    removeResizeListener (handler) {
        var l = this._resizeListeners, i = l.indexOf(handler);
        if (i >= 0) l.splice(i, 1);
        return this;
    },
    addSignalListener (name, handler) {
        return addOperatorListener(this, name, lookupSignal(this, name), handler);
    },
    removeSignalListener (name, handler) {
        return removeOperatorListener(this, lookupSignal(this, name), handler);
    },
    addDataListener (name, handler) {
        return addOperatorListener(this, name, dataref(this, name).values, handler);
    },
    removeDataListener (name, handler) {
        return removeOperatorListener(this, dataref(this, name).values, handler);
    },
    globalCursor (_) {
        if (arguments.length) {
            if (this._globalCursor !== !!_) {
                const prev = setCursor(this, null); // clear previous cursor
                this._globalCursor = !!_;
                if (prev) setCursor(this, prev); // swap cursor
            }
            return this;
        } else return this._globalCursor;
    },
    preventDefault (_) {
        if (arguments.length) {
            this._preventDefault = _;
            return this;
        } else return this._preventDefault;
    },
    timer,
    events,
    finalize,
    hover,
    // -- DATA ----
    data,
    change,
    insert,
    remove,
    // -- SCALES --
    scale,
    // -- INITIALIZATION ----
    initialize,
    // -- HEADLESS RENDERING ----
    toImageURL: renderToImageURL,
    toCanvas: renderToCanvas,
    toSVG: renderToSVG,
    // -- SAVE / RESTORE STATE ----
    getState,
    setState,
    // RE-RENDER ON ZOOM
    _watchPixelRatio: watchPixelRatio
});

},{"vega-util":"kncZn","vega-dataflow":"eoU45","vega-scenegraph":"fdlnS","d3-array":"4pSqo","vega-functions":"l0VB3","vega-runtime":"89vAE","d3-timer":"cOPFt","vega-format":"er6y3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l0VB3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataPrefix", ()=>DataPrefix);
parcelHelpers.export(exports, "IndexPrefix", ()=>IndexPrefix);
parcelHelpers.export(exports, "ScalePrefix", ()=>ScalePrefix);
parcelHelpers.export(exports, "SignalPrefix", ()=>SignalPrefix);
parcelHelpers.export(exports, "bandspace", ()=>bandspace);
parcelHelpers.export(exports, "bandwidth", ()=>bandwidth);
parcelHelpers.export(exports, "codeGenerator", ()=>codeGenerator);
parcelHelpers.export(exports, "codegenParams", ()=>codegenParams);
parcelHelpers.export(exports, "containerSize", ()=>containerSize);
parcelHelpers.export(exports, "contrast", ()=>contrast);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "dataVisitor", ()=>dataVisitor);
parcelHelpers.export(exports, "dayAbbrevFormat", ()=>dayAbbrevFormat);
parcelHelpers.export(exports, "dayFormat", ()=>dayFormat);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "domain", ()=>domain);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "expressionFunction", ()=>expressionFunction);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "functionContext", ()=>functionContext);
parcelHelpers.export(exports, "geoArea", ()=>geoArea);
parcelHelpers.export(exports, "geoBounds", ()=>geoBounds);
parcelHelpers.export(exports, "geoCentroid", ()=>geoCentroid);
parcelHelpers.export(exports, "geoScale", ()=>geoScale);
parcelHelpers.export(exports, "geoShape", ()=>geoShape);
parcelHelpers.export(exports, "inScope", ()=>inScope);
parcelHelpers.export(exports, "indata", ()=>indata);
parcelHelpers.export(exports, "indataVisitor", ()=>indataVisitor);
parcelHelpers.export(exports, "indexof", ()=>indexof);
parcelHelpers.export(exports, "info", ()=>info);
parcelHelpers.export(exports, "invert", ()=>invert);
parcelHelpers.export(exports, "join", ()=>join);
parcelHelpers.export(exports, "lastindexof", ()=>lastindexof);
parcelHelpers.export(exports, "luminance", ()=>luminance);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "modify", ()=>modify);
parcelHelpers.export(exports, "monthAbbrevFormat", ()=>monthAbbrevFormat);
parcelHelpers.export(exports, "monthFormat", ()=>monthFormat);
parcelHelpers.export(exports, "parseExpression", ()=>parser);
parcelHelpers.export(exports, "pathShape", ()=>pathShape);
parcelHelpers.export(exports, "pinchAngle", ()=>pinchAngle);
parcelHelpers.export(exports, "pinchDistance", ()=>pinchDistance);
parcelHelpers.export(exports, "pluck", ()=>pluck);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "scaleGradient", ()=>scaleGradient);
parcelHelpers.export(exports, "scaleVisitor", ()=>scaleVisitor);
parcelHelpers.export(exports, "screen", ()=>screen);
parcelHelpers.export(exports, "setdata", ()=>setdata);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "sort", ()=>sort);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "treeAncestors", ()=>treeAncestors);
parcelHelpers.export(exports, "treePath", ()=>treePath);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "windowSize", ()=>windowSize);
var _vegaUtil = require("vega-util");
var _vegaExpression = require("vega-expression");
var _vegaScale = require("vega-scale");
var _d3Geo = require("d3-geo");
var _d3Color = require("d3-color");
var _vegaDataflow = require("vega-dataflow");
var _vegaScenegraph = require("vega-scenegraph");
var _vegaSelections = require("vega-selections");
var _vegaStatistics = require("vega-statistics");
var _vegaTime = require("vega-time");
var _d3Array = require("d3-array");
function data(name) {
    const data = this.context.data[name];
    return data ? data.values.value : [];
}
function indata(name, field, value) {
    const index = this.context.data[name]['index:' + field], entry = index ? index.value.get(value) : undefined;
    return entry ? entry.count : entry;
}
function setdata(name, tuples) {
    const df = this.context.dataflow, data = this.context.data[name], input = data.input;
    df.pulse(input, df.changeset().remove((0, _vegaUtil.truthy)).insert(tuples));
    return 1;
}
function encode(item, name, retval) {
    if (item) {
        const df = this.context.dataflow, target = item.mark.source;
        df.pulse(target, df.changeset().encode(item, name));
    }
    return retval !== undefined ? retval : item;
}
const wrap = (method)=>function(value, spec) {
        const locale = this.context.dataflow.locale();
        return value === null ? 'null' : locale[method](spec)(value);
    };
const format = wrap('format');
const timeFormat = wrap('timeFormat');
const utcFormat = wrap('utcFormat');
const timeParse = wrap('timeParse');
const utcParse = wrap('utcParse');
const dateObj = new Date(2000, 0, 1);
function time(month, day, specifier) {
    if (!Number.isInteger(month) || !Number.isInteger(day)) return '';
    dateObj.setYear(2000);
    dateObj.setMonth(month);
    dateObj.setDate(day);
    return timeFormat.call(this, dateObj, specifier);
}
function monthFormat(month) {
    return time.call(this, month, 1, '%B');
}
function monthAbbrevFormat(month) {
    return time.call(this, month, 1, '%b');
}
function dayFormat(day) {
    return time.call(this, 0, 2 + day, '%A');
}
function dayAbbrevFormat(day) {
    return time.call(this, 0, 2 + day, '%a');
}
const DataPrefix = ':';
const IndexPrefix = '@';
const ScalePrefix = '%';
const SignalPrefix = '$';
function dataVisitor(name, args, scope, params) {
    if (args[0].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('First argument to data functions must be a string literal.');
    const data = args[0].value, dataName = DataPrefix + data;
    if (!(0, _vegaUtil.hasOwnProperty)(dataName, params)) try {
        params[dataName] = scope.getData(data).tuplesRef();
    } catch (err) {
    // if data set does not exist, there's nothing to track
    }
}
function indataVisitor(name, args, scope, params) {
    if (args[0].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('First argument to indata must be a string literal.');
    if (args[1].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('Second argument to indata must be a string literal.');
    const data = args[0].value, field = args[1].value, indexName = IndexPrefix + field;
    if (!(0, _vegaUtil.hasOwnProperty)(indexName, params)) params[indexName] = scope.getData(data).indataRef(scope, field);
}
function scaleVisitor(name, args, scope, params) {
    if (args[0].type === (0, _vegaExpression.Literal)) // add scale dependency
    addScaleDependency(scope, params, args[0].value);
    else // indirect scale lookup; add all scales as parameters
    for(name in scope.scales)addScaleDependency(scope, params, name);
}
function addScaleDependency(scope, params, name) {
    const scaleName = ScalePrefix + name;
    if (!(0, _vegaUtil.hasOwnProperty)(params, scaleName)) try {
        params[scaleName] = scope.scaleRef(name);
    } catch (err) {
    // TODO: error handling? warning?
    }
}
/**
 * nameOrFunction must be a string or function that was registered.
 * Return undefined if scale is not recognized.
 */ function getScale(nameOrFunction, ctx) {
    if ((0, _vegaUtil.isString)(nameOrFunction)) {
        const maybeScale = ctx.scales[nameOrFunction];
        return maybeScale && (0, _vegaScale.isRegisteredScale)(maybeScale.value) ? maybeScale.value : undefined;
    } else if ((0, _vegaUtil.isFunction)(nameOrFunction)) return (0, _vegaScale.isRegisteredScale)(nameOrFunction) ? nameOrFunction : undefined;
    return undefined;
}
function internalScaleFunctions(codegen, fnctx, visitors) {
    // add helper method to the 'this' expression function context
    fnctx.__bandwidth = (s)=>s && s.bandwidth ? s.bandwidth() : 0;
    // register AST visitors for internal scale functions
    visitors._bandwidth = scaleVisitor;
    visitors._range = scaleVisitor;
    visitors._scale = scaleVisitor;
    // resolve scale reference directly to the signal hash argument
    const ref = (arg)=>'_[' + (arg.type === (0, _vegaExpression.Literal) ? (0, _vegaUtil.stringValue)(ScalePrefix + arg.value) : (0, _vegaUtil.stringValue)(ScalePrefix) + '+' + codegen(arg)) + ']';
    // define and return internal scale function code generators
    // these internal functions are called by mark encoders
    return {
        _bandwidth: (args)=>`this.__bandwidth(${ref(args[0])})`,
        _range: (args)=>`${ref(args[0])}.range()`,
        _scale: (args)=>`${ref(args[0])}(${codegen(args[1])})`
    };
}
function geoMethod(methodName, globalMethod) {
    return function(projection, geojson, group) {
        if (projection) {
            // projection defined, use it
            const p = getScale(projection, (group || this).context);
            return p && p.path[methodName](geojson);
        } else // projection undefined, use global method
        return globalMethod(geojson);
    };
}
const geoArea = geoMethod('area', (0, _d3Geo.geoArea));
const geoBounds = geoMethod('bounds', (0, _d3Geo.geoBounds));
const geoCentroid = geoMethod('centroid', (0, _d3Geo.geoCentroid));
function geoScale(projection, group) {
    const p = getScale(projection, (group || this).context);
    return p && p.scale();
}
function inScope(item) {
    const group = this.context.group;
    let value = false;
    if (group) while(item){
        if (item === group) {
            value = true;
            break;
        }
        item = item.mark.group;
    }
    return value;
}
function log(df, method, args) {
    try {
        df[method].apply(df, [
            'EXPRESSION'
        ].concat([].slice.call(args)));
    } catch (err) {
        df.warn(err);
    }
    return args[args.length - 1];
}
function warn() {
    return log(this.context.dataflow, 'warn', arguments);
}
function info() {
    return log(this.context.dataflow, 'info', arguments);
}
function debug() {
    return log(this.context.dataflow, 'debug', arguments);
}
// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
function channel_luminance_value(channelValue) {
    const val = channelValue / 255;
    if (val <= 0.03928) return val / 12.92;
    return Math.pow((val + 0.055) / 1.055, 2.4);
}
function luminance(color) {
    const c = (0, _d3Color.rgb)(color), r = channel_luminance_value(c.r), g = channel_luminance_value(c.g), b = channel_luminance_value(c.b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
// https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
function contrast(color1, color2) {
    const lum1 = luminance(color1), lum2 = luminance(color2), lumL = Math.max(lum1, lum2), lumD = Math.min(lum1, lum2);
    return (lumL + 0.05) / (lumD + 0.05);
}
function merge() {
    const args = [].slice.call(arguments);
    args.unshift({});
    return (0, _vegaUtil.extend)(...args);
}
function equal(a, b) {
    return a === b || a !== a && b !== b ? true : (0, _vegaUtil.isArray)(a) ? (0, _vegaUtil.isArray)(b) && a.length === b.length ? equalArray(a, b) : false : (0, _vegaUtil.isObject)(a) && (0, _vegaUtil.isObject)(b) ? equalObject(a, b) : false;
}
function equalArray(a, b) {
    for(let i = 0, n = a.length; i < n; ++i){
        if (!equal(a[i], b[i])) return false;
    }
    return true;
}
function equalObject(a, b) {
    for(const key in a){
        if (!equal(a[key], b[key])) return false;
    }
    return true;
}
function removePredicate(props) {
    return (_)=>equalObject(props, _);
}
function modify(name, insert, remove, toggle, modify, values) {
    const df = this.context.dataflow, data = this.context.data[name], input = data.input, stamp = df.stamp();
    let changes = data.changes, predicate, key;
    if (df._trigger === false || !(input.value.length || insert || toggle)) // nothing to do!
    return 0;
    if (!changes || changes.stamp < stamp) {
        data.changes = changes = df.changeset();
        changes.stamp = stamp;
        df.runAfter(()=>{
            data.modified = true;
            df.pulse(input, changes).run();
        }, true, 1);
    }
    if (remove) {
        predicate = remove === true ? (0, _vegaUtil.truthy) : (0, _vegaUtil.isArray)(remove) || (0, _vegaDataflow.isTuple)(remove) ? remove : removePredicate(remove);
        changes.remove(predicate);
    }
    if (insert) changes.insert(insert);
    if (toggle) {
        predicate = removePredicate(toggle);
        if (input.value.some(predicate)) changes.remove(predicate);
        else changes.insert(toggle);
    }
    if (modify) for(key in values)changes.modify(modify, key, values[key]);
    return 1;
}
function pinchDistance(event) {
    const t = event.touches, dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.hypot(dx, dy);
}
function pinchAngle(event) {
    const t = event.touches;
    return Math.atan2(t[0].clientY - t[1].clientY, t[0].clientX - t[1].clientX);
}
// memoize accessor functions
const accessors = {};
function pluck(data, name) {
    const accessor = accessors[name] || (accessors[name] = (0, _vegaUtil.field)(name));
    return (0, _vegaUtil.isArray)(data) ? data.map(accessor) : accessor(data);
}
function array(seq) {
    return (0, _vegaUtil.isArray)(seq) || ArrayBuffer.isView(seq) ? seq : null;
}
function sequence(seq) {
    return array(seq) || ((0, _vegaUtil.isString)(seq) ? seq : null);
}
function join(seq) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return array(seq).join(...args);
}
function indexof(seq) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return sequence(seq).indexOf(...args);
}
function lastindexof(seq) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return sequence(seq).lastIndexOf(...args);
}
function slice(seq) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return sequence(seq).slice(...args);
}
function replace(str, pattern, repl) {
    if ((0, _vegaUtil.isFunction)(repl)) (0, _vegaUtil.error)('Function argument passed to replace.');
    if (!(0, _vegaUtil.isString)(pattern) && !(0, _vegaUtil.isRegExp)(pattern)) (0, _vegaUtil.error)('Please pass a string or RegExp argument to replace.');
    return String(str).replace(pattern, repl);
}
function reverse(seq) {
    return array(seq).slice().reverse();
}
function sort(seq) {
    return array(seq).slice().sort((0, _vegaUtil.ascending));
}
function bandspace(count, paddingInner, paddingOuter) {
    return (0, _vegaScale.bandSpace)(count || 0, paddingInner || 0, paddingOuter || 0);
}
function bandwidth(name, group) {
    const s = getScale(name, (group || this).context);
    return s && s.bandwidth ? s.bandwidth() : 0;
}
function copy(name, group) {
    const s = getScale(name, (group || this).context);
    return s ? s.copy() : undefined;
}
function domain(name, group) {
    const s = getScale(name, (group || this).context);
    return s ? s.domain() : [];
}
function invert(name, range, group) {
    const s = getScale(name, (group || this).context);
    return !s ? undefined : (0, _vegaUtil.isArray)(range) ? (s.invertRange || s.invert)(range) : (s.invert || s.invertExtent)(range);
}
function range(name, group) {
    const s = getScale(name, (group || this).context);
    return s && s.range ? s.range() : [];
}
function scale(name, value, group) {
    const s = getScale(name, (group || this).context);
    return s ? s(value) : undefined;
}
function scaleGradient(scale, p0, p1, count, group) {
    scale = getScale(scale, (group || this).context);
    const gradient = (0, _vegaScenegraph.Gradient)(p0, p1);
    let stops = scale.domain(), min = stops[0], max = (0, _vegaUtil.peek)(stops), fraction = (0, _vegaUtil.identity);
    if (!(max - min)) // expand scale if domain has zero span, fix #1479
    scale = (scale.interpolator ? (0, _vegaScale.scale)('sequential')().interpolator(scale.interpolator()) : (0, _vegaScale.scale)('linear')().interpolate(scale.interpolate()).range(scale.range())).domain([
        min = 0,
        max = 1
    ]);
    else fraction = (0, _vegaScale.scaleFraction)(scale, min, max);
    if (scale.ticks) {
        stops = scale.ticks(+count || 15);
        if (min !== stops[0]) stops.unshift(min);
        if (max !== (0, _vegaUtil.peek)(stops)) stops.push(max);
    }
    stops.forEach((_)=>gradient.stop(fraction(_), scale(_)));
    return gradient;
}
function geoShape(projection, geojson, group) {
    const p = getScale(projection, (group || this).context);
    return function(context) {
        return p ? p.path.context(context)(geojson) : '';
    };
}
function pathShape(path) {
    let p = null;
    return function(context) {
        return context ? (0, _vegaScenegraph.pathRender)(context, p = p || (0, _vegaScenegraph.pathParse)(path)) : path;
    };
}
const datum = (d)=>d.data;
function treeNodes(name, context) {
    const tree = data.call(context, name);
    return tree.root && tree.root.lookup || {};
}
function treePath(name, source, target) {
    const nodes = treeNodes(name, this), s = nodes[source], t = nodes[target];
    return s && t ? s.path(t).map(datum) : undefined;
}
function treeAncestors(name, node) {
    const n = treeNodes(name, this)[node];
    return n ? n.ancestors().map(datum) : undefined;
}
const _window = ()=>typeof window !== 'undefined' && window || null;
function screen() {
    const w = _window();
    return w ? w.screen : {};
}
function windowSize() {
    const w = _window();
    return w ? [
        w.innerWidth,
        w.innerHeight
    ] : [
        undefined,
        undefined
    ];
}
function containerSize() {
    const view = this.context.dataflow, el = view.container && view.container();
    return el ? [
        el.clientWidth,
        el.clientHeight
    ] : [
        undefined,
        undefined
    ];
}
function intersect(b, opt, group) {
    if (!b) return [];
    const [u, v] = b, box = new (0, _vegaScenegraph.Bounds)().set(u[0], u[1], v[0], v[1]), scene = group || this.context.dataflow.scenegraph().root;
    return (0, _vegaScenegraph.intersect)(scene, box, filter(opt));
}
function filter(opt) {
    let p = null;
    if (opt) {
        const types = (0, _vegaUtil.array)(opt.marktype), names = (0, _vegaUtil.array)(opt.markname);
        p = (_)=>(!types.length || types.some((t)=>_.marktype === t)) && (!names.length || names.some((s)=>_.name === s));
    }
    return p;
}
/**
 * Appends a new point to the lasso
 *
 * @param {*} lasso the lasso in pixel space
 * @param {*} x the x coordinate in pixel space
 * @param {*} y the y coordinate in pixel space
 * @param {*} minDist the minimum distance, in pixels, that thenew point needs to be apart from the last point
 * @returns a new array containing the lasso with the new point
 */ function lassoAppend(lasso, x, y) {
    let minDist = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
    lasso = (0, _vegaUtil.array)(lasso);
    const last = lasso[lasso.length - 1];
    // Add point to lasso if its the first point or distance to last point exceed minDist
    return last === undefined || Math.hypot(last[0] - x, last[1] - y) > minDist ? [
        ...lasso,
        [
            x,
            y
        ]
    ] : lasso;
}
/**
 * Generates a svg path command which draws a lasso
 *
 * @param {*} lasso the lasso in pixel space in the form [[x,y], [x,y], ...]
 * @returns the svg path command that draws the lasso
 */ function lassoPath(lasso) {
    return (0, _vegaUtil.array)(lasso).reduce((svg, _ref, i)=>{
        let [x, y] = _ref;
        return svg += i == 0 ? `M ${x},${y} ` : i === lasso.length - 1 ? ' Z' : `L ${x},${y} `;
    }, '');
}
/**
 * Inverts the lasso from pixel space to an array of vega scenegraph tuples
 *
 * @param {*} data the dataset
 * @param {*} pixelLasso the lasso in pixel space, [[x,y], [x,y], ...]
 * @param {*} unit the unit where the lasso is defined
 *
 * @returns an array of vega scenegraph tuples
 */ function intersectLasso(markname, pixelLasso, unit) {
    const { x, y, mark } = unit;
    const bb = new (0, _vegaScenegraph.Bounds)().set(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
    // Get bounding box around lasso
    for (const [px, py] of pixelLasso){
        if (px < bb.x1) bb.x1 = px;
        if (px > bb.x2) bb.x2 = px;
        if (py < bb.y1) bb.y1 = py;
        if (py > bb.y2) bb.y2 = py;
    }
    // Translate bb against unit coordinates
    bb.translate(x, y);
    const intersection = intersect([
        [
            bb.x1,
            bb.y1
        ],
        [
            bb.x2,
            bb.y2
        ]
    ], markname, mark);
    // Check every point against the lasso
    return intersection.filter((tuple)=>pointInPolygon(tuple.x, tuple.y, pixelLasso));
}
/**
 * Performs a test if a point is inside a polygon based on the idea from
 * https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
 *
 * This method will not need the same start/end point since it wraps around the edges of the array
 *
 * @param {*} test a point to test against
 * @param {*} polygon a polygon in the form [[x,y], [x,y], ...]
 * @returns true if the point lies inside the polygon, false otherwise
 */ function pointInPolygon(testx, testy, polygon) {
    let intersections = 0;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const [prevX, prevY] = polygon[j];
        const [x, y] = polygon[i];
        // count intersections
        if (y > testy != prevY > testy && testx < (prevX - x) * (testy - y) / (prevY - y) + x) intersections++;
    }
    // point is in polygon if intersection count is odd
    return intersections & 1;
}
// Expression function context object
const functionContext = {
    random () {
        return (0, _vegaStatistics.random)();
    },
    cumulativeNormal: // override default
    (0, _vegaStatistics.cumulativeNormal),
    cumulativeLogNormal: (0, _vegaStatistics.cumulativeLogNormal),
    cumulativeUniform: (0, _vegaStatistics.cumulativeUniform),
    densityNormal: (0, _vegaStatistics.densityNormal),
    densityLogNormal: (0, _vegaStatistics.densityLogNormal),
    densityUniform: (0, _vegaStatistics.densityUniform),
    quantileNormal: (0, _vegaStatistics.quantileNormal),
    quantileLogNormal: (0, _vegaStatistics.quantileLogNormal),
    quantileUniform: (0, _vegaStatistics.quantileUniform),
    sampleNormal: (0, _vegaStatistics.sampleNormal),
    sampleLogNormal: (0, _vegaStatistics.sampleLogNormal),
    sampleUniform: (0, _vegaStatistics.sampleUniform),
    isArray: (0, _vegaUtil.isArray),
    isBoolean: (0, _vegaUtil.isBoolean),
    isDate: (0, _vegaUtil.isDate),
    isDefined (_) {
        return _ !== undefined;
    },
    isNumber: (0, _vegaUtil.isNumber),
    isObject: (0, _vegaUtil.isObject),
    isRegExp: (0, _vegaUtil.isRegExp),
    isString: (0, _vegaUtil.isString),
    isTuple: (0, _vegaDataflow.isTuple),
    isValid (_) {
        return _ != null && _ === _;
    },
    toBoolean: (0, _vegaUtil.toBoolean),
    toDate (_) {
        return (0, _vegaUtil.toDate)(_);
    },
    toNumber: // suppress extra arguments
    (0, _vegaUtil.toNumber),
    toString: (0, _vegaUtil.toString),
    indexof,
    join,
    lastindexof,
    replace,
    reverse,
    sort,
    slice,
    flush: (0, _vegaUtil.flush),
    lerp: (0, _vegaUtil.lerp),
    merge,
    pad: (0, _vegaUtil.pad),
    peek: (0, _vegaUtil.peek),
    pluck,
    span: (0, _vegaUtil.span),
    inrange: (0, _vegaUtil.inrange),
    truncate: (0, _vegaUtil.truncate),
    rgb: (0, _d3Color.rgb),
    lab: (0, _d3Color.lab),
    hcl: (0, _d3Color.hcl),
    hsl: (0, _d3Color.hsl),
    luminance,
    contrast,
    sequence: (0, _d3Array.range),
    format,
    utcFormat,
    utcParse,
    utcOffset: (0, _vegaTime.utcOffset),
    utcSequence: (0, _vegaTime.utcSequence),
    timeFormat,
    timeParse,
    timeOffset: (0, _vegaTime.timeOffset),
    timeSequence: (0, _vegaTime.timeSequence),
    timeUnitSpecifier: (0, _vegaTime.timeUnitSpecifier),
    monthFormat,
    monthAbbrevFormat,
    dayFormat,
    dayAbbrevFormat,
    quarter: (0, _vegaUtil.quarter),
    utcquarter: (0, _vegaUtil.utcquarter),
    week: (0, _vegaTime.week),
    utcweek: (0, _vegaTime.utcweek),
    dayofyear: (0, _vegaTime.dayofyear),
    utcdayofyear: (0, _vegaTime.utcdayofyear),
    warn,
    info,
    debug,
    extent (_) {
        return (0, _vegaUtil.extent)(_);
    },
    // suppress extra arguments
    inScope,
    intersect,
    clampRange: (0, _vegaUtil.clampRange),
    pinchDistance,
    pinchAngle,
    screen,
    containerSize,
    windowSize,
    bandspace,
    setdata,
    pathShape,
    panLinear: (0, _vegaUtil.panLinear),
    panLog: (0, _vegaUtil.panLog),
    panPow: (0, _vegaUtil.panPow),
    panSymlog: (0, _vegaUtil.panSymlog),
    zoomLinear: (0, _vegaUtil.zoomLinear),
    zoomLog: (0, _vegaUtil.zoomLog),
    zoomPow: (0, _vegaUtil.zoomPow),
    zoomSymlog: (0, _vegaUtil.zoomSymlog),
    encode,
    modify,
    lassoAppend,
    lassoPath,
    intersectLasso
};
const eventFunctions = [
    'view',
    'item',
    'group',
    'xy',
    'x',
    'y'
], // event functions
eventPrefix = 'event.vega.', // event function prefix
thisPrefix = 'this.', // function context prefix
astVisitors = {}; // AST visitors for dependency analysis
// export code generator parameters
const codegenParams = {
    forbidden: [
        '_'
    ],
    allowed: [
        'datum',
        'event',
        'item'
    ],
    fieldvar: 'datum',
    globalvar: (id)=>`_[${(0, _vegaUtil.stringValue)(SignalPrefix + id)}]`,
    functions: buildFunctions,
    constants: (0, _vegaExpression.constants),
    visitors: astVisitors
};
// export code generator
const codeGenerator = (0, _vegaExpression.codegenExpression)(codegenParams);
// Build expression function registry
function buildFunctions(codegen) {
    const fn = (0, _vegaExpression.functions)(codegen);
    eventFunctions.forEach((name)=>fn[name] = eventPrefix + name);
    for(const name in functionContext)fn[name] = thisPrefix + name;
    (0, _vegaUtil.extend)(fn, internalScaleFunctions(codegen, functionContext, astVisitors));
    return fn;
}
// Register an expression function
function expressionFunction(name, fn, visitor) {
    if (arguments.length === 1) return functionContext[name];
    // register with the functionContext
    functionContext[name] = fn;
    // if there is an astVisitor register that, too
    if (visitor) astVisitors[name] = visitor;
    // if the code generator has already been initialized,
    // we need to also register the function with it
    if (codeGenerator) codeGenerator.functions[name] = thisPrefix + name;
    return this;
}
// register expression functions with ast visitors
expressionFunction('bandwidth', bandwidth, scaleVisitor);
expressionFunction('copy', copy, scaleVisitor);
expressionFunction('domain', domain, scaleVisitor);
expressionFunction('range', range, scaleVisitor);
expressionFunction('invert', invert, scaleVisitor);
expressionFunction('scale', scale, scaleVisitor);
expressionFunction('gradient', scaleGradient, scaleVisitor);
expressionFunction('geoArea', geoArea, scaleVisitor);
expressionFunction('geoBounds', geoBounds, scaleVisitor);
expressionFunction('geoCentroid', geoCentroid, scaleVisitor);
expressionFunction('geoShape', geoShape, scaleVisitor);
expressionFunction('geoScale', geoScale, scaleVisitor);
expressionFunction('indata', indata, indataVisitor);
expressionFunction('data', data, dataVisitor);
expressionFunction('treePath', treePath, dataVisitor);
expressionFunction('treeAncestors', treeAncestors, dataVisitor);
// register Vega-Lite selection functions
expressionFunction('vlSelectionTest', (0, _vegaSelections.selectionTest), (0, _vegaSelections.selectionVisitor));
expressionFunction('vlSelectionIdTest', (0, _vegaSelections.selectionIdTest), (0, _vegaSelections.selectionVisitor));
expressionFunction('vlSelectionResolve', (0, _vegaSelections.selectionResolve), (0, _vegaSelections.selectionVisitor));
expressionFunction('vlSelectionTuples', (0, _vegaSelections.selectionTuples));
function parser(expr, scope) {
    const params = {};
    // parse the expression to an abstract syntax tree (ast)
    let ast;
    try {
        expr = (0, _vegaUtil.isString)(expr) ? expr : (0, _vegaUtil.stringValue)(expr) + '';
        ast = (0, _vegaExpression.parseExpression)(expr);
    } catch (err) {
        (0, _vegaUtil.error)('Expression parse error: ' + expr);
    }
    // analyze ast function calls for dependencies
    ast.visit((node)=>{
        if (node.type !== (0, _vegaExpression.CallExpression)) return;
        const name = node.callee.name, visit = codegenParams.visitors[name];
        if (visit) visit(name, node.arguments, scope, params);
    });
    // perform code generation
    const gen = codeGenerator(ast);
    // collect signal dependencies
    gen.globals.forEach((name)=>{
        const signalName = SignalPrefix + name;
        if (!(0, _vegaUtil.hasOwnProperty)(params, signalName) && scope.getSignal(name)) params[signalName] = scope.signalRef(name);
    });
    // return generated expression code and dependencies
    return {
        $expr: (0, _vegaUtil.extend)({
            code: gen.code
        }, scope.options.ast ? {
            ast
        } : null),
        $fields: gen.fields,
        $params: params
    };
}

},{"vega-util":"kncZn","vega-expression":"4bIBh","vega-scale":"fMau0","d3-geo":"hvz1M","d3-color":"c8Fkk","vega-dataflow":"eoU45","vega-scenegraph":"fdlnS","vega-selections":"eqgVt","vega-statistics":"6sdPC","vega-time":"c8K2C","d3-array":"4pSqo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bIBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASTNode", ()=>ASTNode);
parcelHelpers.export(exports, "ArrayExpression", ()=>ArrayExpression);
parcelHelpers.export(exports, "BinaryExpression", ()=>BinaryExpression);
parcelHelpers.export(exports, "CallExpression", ()=>CallExpression);
parcelHelpers.export(exports, "ConditionalExpression", ()=>ConditionalExpression);
parcelHelpers.export(exports, "Identifier", ()=>Identifier);
parcelHelpers.export(exports, "Literal", ()=>Literal);
parcelHelpers.export(exports, "LogicalExpression", ()=>LogicalExpression);
parcelHelpers.export(exports, "MemberExpression", ()=>MemberExpression);
parcelHelpers.export(exports, "ObjectExpression", ()=>ObjectExpression);
parcelHelpers.export(exports, "Property", ()=>Property);
parcelHelpers.export(exports, "RawCode", ()=>RawCode);
parcelHelpers.export(exports, "UnaryExpression", ()=>UnaryExpression);
parcelHelpers.export(exports, "codegenExpression", ()=>codegen);
parcelHelpers.export(exports, "constants", ()=>Constants);
parcelHelpers.export(exports, "functions", ()=>Functions);
parcelHelpers.export(exports, "parseExpression", ()=>parser);
var _vegaUtil = require("vega-util");
const RawCode = 'RawCode';
const Literal = 'Literal';
const Property = 'Property';
const Identifier = 'Identifier';
const ArrayExpression = 'ArrayExpression';
const BinaryExpression = 'BinaryExpression';
const CallExpression = 'CallExpression';
const ConditionalExpression = 'ConditionalExpression';
const LogicalExpression = 'LogicalExpression';
const MemberExpression = 'MemberExpression';
const ObjectExpression = 'ObjectExpression';
const UnaryExpression = 'UnaryExpression';
function ASTNode(type) {
    this.type = type;
}
ASTNode.prototype.visit = function(visitor) {
    let c, i, n;
    if (visitor(this)) return 1;
    for(c = children(this), i = 0, n = c.length; i < n; ++i){
        if (c[i].visit(visitor)) return 1;
    }
};
function children(node) {
    switch(node.type){
        case ArrayExpression:
            return node.elements;
        case BinaryExpression:
        case LogicalExpression:
            return [
                node.left,
                node.right
            ];
        case CallExpression:
            return [
                node.callee
            ].concat(node.arguments);
        case ConditionalExpression:
            return [
                node.test,
                node.consequent,
                node.alternate
            ];
        case MemberExpression:
            return [
                node.object,
                node.property
            ];
        case ObjectExpression:
            return node.properties;
        case Property:
            return [
                node.key,
                node.value
            ];
        case UnaryExpression:
            return [
                node.argument
            ];
        case Identifier:
        case Literal:
        case RawCode:
        default:
            return [];
    }
}
/*
  The following expression parser is based on Esprima (http://esprima.org/).
  Original header comment and license for Esprima is included here:

  Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
  Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
  Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
  Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
  Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
  Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
  Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
  Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>

  Redistribution and use in source and binary forms, with or without
  modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var TokenName, source, index, length, lookahead;
var TokenBooleanLiteral = 1, TokenEOF = 2, TokenIdentifier = 3, TokenKeyword = 4, TokenNullLiteral = 5, TokenNumericLiteral = 6, TokenPunctuator = 7, TokenStringLiteral = 8, TokenRegularExpression = 9;
TokenName = {};
TokenName[TokenBooleanLiteral] = 'Boolean';
TokenName[TokenEOF] = '<end>';
TokenName[TokenIdentifier] = 'Identifier';
TokenName[TokenKeyword] = 'Keyword';
TokenName[TokenNullLiteral] = 'Null';
TokenName[TokenNumericLiteral] = 'Numeric';
TokenName[TokenPunctuator] = 'Punctuator';
TokenName[TokenStringLiteral] = 'String';
TokenName[TokenRegularExpression] = 'RegularExpression';
var SyntaxArrayExpression = 'ArrayExpression', SyntaxBinaryExpression = 'BinaryExpression', SyntaxCallExpression = 'CallExpression', SyntaxConditionalExpression = 'ConditionalExpression', SyntaxIdentifier = 'Identifier', SyntaxLiteral = 'Literal', SyntaxLogicalExpression = 'LogicalExpression', SyntaxMemberExpression = 'MemberExpression', SyntaxObjectExpression = 'ObjectExpression', SyntaxProperty = 'Property', SyntaxUnaryExpression = 'UnaryExpression';
// Error messages should be identical to V8.
var MessageUnexpectedToken = 'Unexpected token %0', MessageUnexpectedNumber = 'Unexpected number', MessageUnexpectedString = 'Unexpected string', MessageUnexpectedIdentifier = 'Unexpected identifier', MessageUnexpectedReserved = 'Unexpected reserved word', MessageUnexpectedEOS = 'Unexpected end of input', MessageInvalidRegExp = 'Invalid regular expression', MessageUnterminatedRegExp = 'Invalid regular expression: missing /', MessageStrictOctalLiteral = 'Octal literals are not allowed in strict mode.', MessageStrictDuplicateProperty = 'Duplicate data property in object literal not allowed in strict mode';
var ILLEGAL = 'ILLEGAL', DISABLED = 'Disabled.';
// See also tools/generate-unicode-regex.py.
var RegexNonAsciiIdentifierStart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]'), // eslint-disable-next-line no-misleading-character-class
RegexNonAsciiIdentifierPart = new RegExp('[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]');
// Ensure the condition is true, otherwise throw an error.
// This is only to have a better contract semantic, i.e. another safety net
// to catch a logic error. The condition shall be fulfilled in normal case.
// Do NOT use this to enforce a certain condition on any user input.
function assert(condition, message) {
    /* istanbul ignore next */ if (!condition) throw new Error('ASSERT: ' + message);
}
function isDecimalDigit(ch) {
    return ch >= 0x30 && ch <= 0x39; // 0..9
}
function isHexDigit(ch) {
    return '0123456789abcdefABCDEF'.includes(ch);
}
function isOctalDigit(ch) {
    return '01234567'.includes(ch);
}
// 7.2 White Space
function isWhiteSpace(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && [
        0x1680,
        0x180E,
        0x2000,
        0x2001,
        0x2002,
        0x2003,
        0x2004,
        0x2005,
        0x2006,
        0x2007,
        0x2008,
        0x2009,
        0x200A,
        0x202F,
        0x205F,
        0x3000,
        0xFEFF
    ].includes(ch);
}
// 7.3 Line Terminators
function isLineTerminator(ch) {
    return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
}
// 7.6 Identifier Names and Identifiers
function isIdentifierStart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierStart.test(String.fromCharCode(ch));
}
function isIdentifierPart(ch) {
    return ch === 0x24 || ch === 0x5F || // $ (dollar) and _ (underscore)
    ch >= 0x41 && ch <= 0x5A || // A..Z
    ch >= 0x61 && ch <= 0x7A || // a..z
    ch >= 0x30 && ch <= 0x39 || // 0..9
    ch === 0x5C || // \ (backslash)
    ch >= 0x80 && RegexNonAsciiIdentifierPart.test(String.fromCharCode(ch));
}
// 7.6.1.1 Keywords
const keywords = {
    'if': 1,
    'in': 1,
    'do': 1,
    'var': 1,
    'for': 1,
    'new': 1,
    'try': 1,
    'let': 1,
    'this': 1,
    'else': 1,
    'case': 1,
    'void': 1,
    'with': 1,
    'enum': 1,
    'while': 1,
    'break': 1,
    'catch': 1,
    'throw': 1,
    'const': 1,
    'yield': 1,
    'class': 1,
    'super': 1,
    'return': 1,
    'typeof': 1,
    'delete': 1,
    'switch': 1,
    'export': 1,
    'import': 1,
    'public': 1,
    'static': 1,
    'default': 1,
    'finally': 1,
    'extends': 1,
    'package': 1,
    'private': 1,
    'function': 1,
    'continue': 1,
    'debugger': 1,
    'interface': 1,
    'protected': 1,
    'instanceof': 1,
    'implements': 1
};
function skipComment() {
    while(index < length){
        const ch = source.charCodeAt(index);
        if (isWhiteSpace(ch) || isLineTerminator(ch)) ++index;
        else break;
    }
}
function scanHexEscape(prefix) {
    var i, len, ch, code = 0;
    len = prefix === 'u' ? 4 : 2;
    for(i = 0; i < len; ++i)if (index < length && isHexDigit(source[index])) {
        ch = source[index++];
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    } else throwError({}, MessageUnexpectedToken, ILLEGAL);
    return String.fromCharCode(code);
}
function scanUnicodeCodePointEscape() {
    var ch, code, cu1, cu2;
    ch = source[index];
    code = 0;
    // At least, one hex digit is required.
    if (ch === '}') throwError({}, MessageUnexpectedToken, ILLEGAL);
    while(index < length){
        ch = source[index++];
        if (!isHexDigit(ch)) break;
        code = code * 16 + '0123456789abcdef'.indexOf(ch.toLowerCase());
    }
    if (code > 0x10FFFF || ch !== '}') throwError({}, MessageUnexpectedToken, ILLEGAL);
    // UTF-16 Encoding
    if (code <= 0xFFFF) return String.fromCharCode(code);
    cu1 = (code - 0x10000 >> 10) + 0xD800;
    cu2 = (code - 0x10000 & 1023) + 0xDC00;
    return String.fromCharCode(cu1, cu2);
}
function getEscapedIdentifier() {
    var ch, id;
    ch = source.charCodeAt(index++);
    id = String.fromCharCode(ch);
    // '\u' (U+005C, U+0075) denotes an escaped character.
    if (ch === 0x5C) {
        if (source.charCodeAt(index) !== 0x75) throwError({}, MessageUnexpectedToken, ILLEGAL);
        ++index;
        ch = scanHexEscape('u');
        if (!ch || ch === '\\' || !isIdentifierStart(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
        id = ch;
    }
    while(index < length){
        ch = source.charCodeAt(index);
        if (!isIdentifierPart(ch)) break;
        ++index;
        id += String.fromCharCode(ch);
        // '\u' (U+005C, U+0075) denotes an escaped character.
        if (ch === 0x5C) {
            id = id.substr(0, id.length - 1);
            if (source.charCodeAt(index) !== 0x75) throwError({}, MessageUnexpectedToken, ILLEGAL);
            ++index;
            ch = scanHexEscape('u');
            if (!ch || ch === '\\' || !isIdentifierPart(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
            id += ch;
        }
    }
    return id;
}
function getIdentifier() {
    var start, ch;
    start = index++;
    while(index < length){
        ch = source.charCodeAt(index);
        if (ch === 0x5C) {
            // Blackslash (U+005C) marks Unicode escape sequence.
            index = start;
            return getEscapedIdentifier();
        }
        if (isIdentifierPart(ch)) ++index;
        else break;
    }
    return source.slice(start, index);
}
function scanIdentifier() {
    var start, id, type;
    start = index;
    // Backslash (U+005C) starts an escaped character.
    id = source.charCodeAt(index) === 0x5C ? getEscapedIdentifier() : getIdentifier();
    // There is no keyword or literal with only one character.
    // Thus, it must be an identifier.
    if (id.length === 1) type = TokenIdentifier;
    else if (keywords.hasOwnProperty(id)) // eslint-disable-line no-prototype-builtins
    type = TokenKeyword;
    else if (id === 'null') type = TokenNullLiteral;
    else if (id === 'true' || id === 'false') type = TokenBooleanLiteral;
    else type = TokenIdentifier;
    return {
        type: type,
        value: id,
        start: start,
        end: index
    };
}
// 7.7 Punctuators
function scanPunctuator() {
    var start = index, code = source.charCodeAt(index), code2, ch1 = source[index], ch2, ch3, ch4;
    switch(code){
        // Check for most common single-character punctuators.
        case 0x2E:
        case 0x28:
        case 0x29:
        case 0x3B:
        case 0x2C:
        case 0x7B:
        case 0x7D:
        case 0x5B:
        case 0x5D:
        case 0x3A:
        case 0x3F:
        case 0x7E:
            // ~
            ++index;
            return {
                type: TokenPunctuator,
                value: String.fromCharCode(code),
                start: start,
                end: index
            };
        default:
            code2 = source.charCodeAt(index + 1);
            // '=' (U+003D) marks an assignment or comparison operator.
            if (code2 === 0x3D) switch(code){
                case 0x2B:
                case 0x2D:
                case 0x2F:
                case 0x3C:
                case 0x3E:
                case 0x5E:
                case 0x7C:
                case 0x25:
                case 0x26:
                case 0x2A:
                    // *
                    index += 2;
                    return {
                        type: TokenPunctuator,
                        value: String.fromCharCode(code) + String.fromCharCode(code2),
                        start: start,
                        end: index
                    };
                case 0x21:
                case 0x3D:
                    // =
                    index += 2;
                    // !== and ===
                    if (source.charCodeAt(index) === 0x3D) ++index;
                    return {
                        type: TokenPunctuator,
                        value: source.slice(start, index),
                        start: start,
                        end: index
                    };
            }
    }
    // 4-character punctuator: >>>=
    ch4 = source.substr(index, 4);
    if (ch4 === '>>>=') {
        index += 4;
        return {
            type: TokenPunctuator,
            value: ch4,
            start: start,
            end: index
        };
    }
    // 3-character punctuators: === !== >>> <<= >>=
    ch3 = ch4.substr(0, 3);
    if (ch3 === '>>>' || ch3 === '<<=' || ch3 === '>>=') {
        index += 3;
        return {
            type: TokenPunctuator,
            value: ch3,
            start: start,
            end: index
        };
    }
    // Other 2-character punctuators: ++ -- << >> && ||
    ch2 = ch3.substr(0, 2);
    if (ch1 === ch2[1] && '+-<>&|'.includes(ch1) || ch2 === '=>') {
        index += 2;
        return {
            type: TokenPunctuator,
            value: ch2,
            start: start,
            end: index
        };
    }
    if (ch2 === '//') throwError({}, MessageUnexpectedToken, ILLEGAL);
    // 1-character punctuators: < > = ! + - * % & | ^ /
    if ('<>=!+-*%&|^/'.includes(ch1)) {
        ++index;
        return {
            type: TokenPunctuator,
            value: ch1,
            start: start,
            end: index
        };
    }
    throwError({}, MessageUnexpectedToken, ILLEGAL);
}
// 7.8.3 Numeric Literals
function scanHexLiteral(start) {
    let number = '';
    while(index < length){
        if (!isHexDigit(source[index])) break;
        number += source[index++];
    }
    if (number.length === 0) throwError({}, MessageUnexpectedToken, ILLEGAL);
    if (isIdentifierStart(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseInt('0x' + number, 16),
        start: start,
        end: index
    };
}
function scanOctalLiteral(start) {
    let number = '0' + source[index++];
    while(index < length){
        if (!isOctalDigit(source[index])) break;
        number += source[index++];
    }
    if (isIdentifierStart(source.charCodeAt(index)) || isDecimalDigit(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseInt(number, 8),
        octal: true,
        start: start,
        end: index
    };
}
function scanNumericLiteral() {
    var number, start, ch;
    ch = source[index];
    assert(isDecimalDigit(ch.charCodeAt(0)) || ch === '.', 'Numeric literal must start with a decimal digit or a decimal point');
    start = index;
    number = '';
    if (ch !== '.') {
        number = source[index++];
        ch = source[index];
        // Hex number starts with '0x'.
        // Octal number starts with '0'.
        if (number === '0') {
            if (ch === 'x' || ch === 'X') {
                ++index;
                return scanHexLiteral(start);
            }
            if (isOctalDigit(ch)) return scanOctalLiteral(start);
            // decimal number starts with '0' such as '09' is illegal.
            if (ch && isDecimalDigit(ch.charCodeAt(0))) throwError({}, MessageUnexpectedToken, ILLEGAL);
        }
        while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        ch = source[index];
    }
    if (ch === '.') {
        number += source[index++];
        while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        ch = source[index];
    }
    if (ch === 'e' || ch === 'E') {
        number += source[index++];
        ch = source[index];
        if (ch === '+' || ch === '-') number += source[index++];
        if (isDecimalDigit(source.charCodeAt(index))) while(isDecimalDigit(source.charCodeAt(index)))number += source[index++];
        else throwError({}, MessageUnexpectedToken, ILLEGAL);
    }
    if (isIdentifierStart(source.charCodeAt(index))) throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenNumericLiteral,
        value: parseFloat(number),
        start: start,
        end: index
    };
}
// 7.8.4 String Literals
function scanStringLiteral() {
    var str = '', quote, start, ch, code, octal = false;
    quote = source[index];
    assert(quote === '\'' || quote === '"', 'String literal must starts with a quote');
    start = index;
    ++index;
    while(index < length){
        ch = source[index++];
        if (ch === quote) {
            quote = '';
            break;
        } else if (ch === '\\') {
            ch = source[index++];
            if (!ch || !isLineTerminator(ch.charCodeAt(0))) switch(ch){
                case 'u':
                case 'x':
                    if (source[index] === '{') {
                        ++index;
                        str += scanUnicodeCodePointEscape();
                    } else str += scanHexEscape(ch);
                    break;
                case 'n':
                    str += '\n';
                    break;
                case 'r':
                    str += '\r';
                    break;
                case 't':
                    str += '\t';
                    break;
                case 'b':
                    str += '\b';
                    break;
                case 'f':
                    str += '\f';
                    break;
                case 'v':
                    str += '\x0B';
                    break;
                default:
                    if (isOctalDigit(ch)) {
                        code = '01234567'.indexOf(ch);
                        // \0 is not octal escape sequence
                        if (code !== 0) octal = true;
                        if (index < length && isOctalDigit(source[index])) {
                            octal = true;
                            code = code * 8 + '01234567'.indexOf(source[index++]);
                            // 3 digits are only allowed when string starts
                            // with 0, 1, 2, 3
                            if ('0123'.includes(ch) && index < length && isOctalDigit(source[index])) code = code * 8 + '01234567'.indexOf(source[index++]);
                        }
                        str += String.fromCharCode(code);
                    } else str += ch;
                    break;
            }
            else if (ch === '\r' && source[index] === '\n') ++index;
        } else if (isLineTerminator(ch.charCodeAt(0))) break;
        else str += ch;
    }
    if (quote !== '') throwError({}, MessageUnexpectedToken, ILLEGAL);
    return {
        type: TokenStringLiteral,
        value: str,
        octal: octal,
        start: start,
        end: index
    };
}
function testRegExp(pattern, flags) {
    let tmp = pattern;
    if (flags.includes('u')) // Replace each astral symbol and every Unicode code point
    // escape sequence with a single ASCII symbol to avoid throwing on
    // regular expressions that are only valid in combination with the
    // `/u` flag.
    // Note: replacing with the ASCII symbol `x` might cause false
    // negatives in unlikely scenarios. For example, `[\u{61}-b]` is a
    // perfectly valid pattern that is equivalent to `[a-b]`, but it
    // would be replaced by `[x-b]` which throws an error.
    tmp = tmp.replace(/\\u\{([0-9a-fA-F]+)\}/g, ($0, $1)=>{
        if (parseInt($1, 16) <= 0x10FFFF) return 'x';
        throwError({}, MessageInvalidRegExp);
    }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, 'x');
    // First, detect invalid regular expressions.
    try {
        new RegExp(tmp);
    } catch (e) {
        throwError({}, MessageInvalidRegExp);
    }
    // Return a regular expression object for this pattern-flag pair, or
    // `null` in case the current environment doesn't support the flags it
    // uses.
    try {
        return new RegExp(pattern, flags);
    } catch (exception) {
        return null;
    }
}
function scanRegExpBody() {
    var ch, str, classMarker, terminated, body;
    ch = source[index];
    assert(ch === '/', 'Regular expression literal must start with a slash');
    str = source[index++];
    classMarker = false;
    terminated = false;
    while(index < length){
        ch = source[index++];
        str += ch;
        if (ch === '\\') {
            ch = source[index++];
            // ECMA-262 7.8.5
            if (isLineTerminator(ch.charCodeAt(0))) throwError({}, MessageUnterminatedRegExp);
            str += ch;
        } else if (isLineTerminator(ch.charCodeAt(0))) throwError({}, MessageUnterminatedRegExp);
        else if (classMarker) {
            if (ch === ']') classMarker = false;
        } else {
            if (ch === '/') {
                terminated = true;
                break;
            } else if (ch === '[') classMarker = true;
        }
    }
    if (!terminated) throwError({}, MessageUnterminatedRegExp);
    // Exclude leading and trailing slash.
    body = str.substr(1, str.length - 2);
    return {
        value: body,
        literal: str
    };
}
function scanRegExpFlags() {
    var ch, str, flags;
    str = '';
    flags = '';
    while(index < length){
        ch = source[index];
        if (!isIdentifierPart(ch.charCodeAt(0))) break;
        ++index;
        if (ch === '\\' && index < length) throwError({}, MessageUnexpectedToken, ILLEGAL);
        else {
            flags += ch;
            str += ch;
        }
    }
    if (flags.search(/[^gimuy]/g) >= 0) throwError({}, MessageInvalidRegExp, flags);
    return {
        value: flags,
        literal: str
    };
}
function scanRegExp() {
    var start, body, flags, value;
    lookahead = null;
    skipComment();
    start = index;
    body = scanRegExpBody();
    flags = scanRegExpFlags();
    value = testRegExp(body.value, flags.value);
    return {
        literal: body.literal + flags.literal,
        value: value,
        regex: {
            pattern: body.value,
            flags: flags.value
        },
        start: start,
        end: index
    };
}
function isIdentifierName(token) {
    return token.type === TokenIdentifier || token.type === TokenKeyword || token.type === TokenBooleanLiteral || token.type === TokenNullLiteral;
}
function advance() {
    skipComment();
    if (index >= length) return {
        type: TokenEOF,
        start: index,
        end: index
    };
    const ch = source.charCodeAt(index);
    if (isIdentifierStart(ch)) return scanIdentifier();
    // Very common: ( and ) and ;
    if (ch === 0x28 || ch === 0x29 || ch === 0x3B) return scanPunctuator();
    // String literal starts with single quote (U+0027) or double quote (U+0022).
    if (ch === 0x27 || ch === 0x22) return scanStringLiteral();
    // Dot (.) U+002E can also start a floating-point number, hence the need
    // to check the next character.
    if (ch === 0x2E) {
        if (isDecimalDigit(source.charCodeAt(index + 1))) return scanNumericLiteral();
        return scanPunctuator();
    }
    if (isDecimalDigit(ch)) return scanNumericLiteral();
    return scanPunctuator();
}
function lex() {
    const token = lookahead;
    index = token.end;
    lookahead = advance();
    index = token.end;
    return token;
}
function peek() {
    const pos = index;
    lookahead = advance();
    index = pos;
}
function finishArrayExpression(elements) {
    const node = new ASTNode(SyntaxArrayExpression);
    node.elements = elements;
    return node;
}
function finishBinaryExpression(operator, left, right) {
    const node = new ASTNode(operator === '||' || operator === '&&' ? SyntaxLogicalExpression : SyntaxBinaryExpression);
    node.operator = operator;
    node.left = left;
    node.right = right;
    return node;
}
function finishCallExpression(callee, args) {
    const node = new ASTNode(SyntaxCallExpression);
    node.callee = callee;
    node.arguments = args;
    return node;
}
function finishConditionalExpression(test, consequent, alternate) {
    const node = new ASTNode(SyntaxConditionalExpression);
    node.test = test;
    node.consequent = consequent;
    node.alternate = alternate;
    return node;
}
function finishIdentifier(name) {
    const node = new ASTNode(SyntaxIdentifier);
    node.name = name;
    return node;
}
function finishLiteral(token) {
    const node = new ASTNode(SyntaxLiteral);
    node.value = token.value;
    node.raw = source.slice(token.start, token.end);
    if (token.regex) {
        if (node.raw === '//') node.raw = '/(?:)/';
        node.regex = token.regex;
    }
    return node;
}
function finishMemberExpression(accessor, object, property) {
    const node = new ASTNode(SyntaxMemberExpression);
    node.computed = accessor === '[';
    node.object = object;
    node.property = property;
    if (!node.computed) property.member = true;
    return node;
}
function finishObjectExpression(properties) {
    const node = new ASTNode(SyntaxObjectExpression);
    node.properties = properties;
    return node;
}
function finishProperty(kind, key, value) {
    const node = new ASTNode(SyntaxProperty);
    node.key = key;
    node.value = value;
    node.kind = kind;
    return node;
}
function finishUnaryExpression(operator, argument) {
    const node = new ASTNode(SyntaxUnaryExpression);
    node.operator = operator;
    node.argument = argument;
    node.prefix = true;
    return node;
}
// Throw an exception
function throwError(token, messageFormat) {
    var error, args = Array.prototype.slice.call(arguments, 2), msg = messageFormat.replace(/%(\d)/g, (whole, index)=>{
        assert(index < args.length, 'Message reference must be in range');
        return args[index];
    });
    error = new Error(msg);
    error.index = index;
    error.description = msg;
    throw error;
}
// Throw an exception because of the token.
function throwUnexpected(token) {
    if (token.type === TokenEOF) throwError(token, MessageUnexpectedEOS);
    if (token.type === TokenNumericLiteral) throwError(token, MessageUnexpectedNumber);
    if (token.type === TokenStringLiteral) throwError(token, MessageUnexpectedString);
    if (token.type === TokenIdentifier) throwError(token, MessageUnexpectedIdentifier);
    if (token.type === TokenKeyword) throwError(token, MessageUnexpectedReserved);
    // BooleanLiteral, NullLiteral, or Punctuator.
    throwError(token, MessageUnexpectedToken, token.value);
}
// Expect the next token to match the specified punctuator.
// If not, an exception will be thrown.
function expect(value) {
    const token = lex();
    if (token.type !== TokenPunctuator || token.value !== value) throwUnexpected(token);
}
// Return true if the next token matches the specified punctuator.
function match(value) {
    return lookahead.type === TokenPunctuator && lookahead.value === value;
}
// Return true if the next token matches the specified keyword
function matchKeyword(keyword) {
    return lookahead.type === TokenKeyword && lookahead.value === keyword;
}
// 11.1.4 Array Initialiser
function parseArrayInitialiser() {
    const elements = [];
    index = lookahead.start;
    expect('[');
    while(!match(']'))if (match(',')) {
        lex();
        elements.push(null);
    } else {
        elements.push(parseConditionalExpression());
        if (!match(']')) expect(',');
    }
    lex();
    return finishArrayExpression(elements);
}
// 11.1.5 Object Initialiser
function parseObjectPropertyKey() {
    index = lookahead.start;
    const token = lex();
    // Note: This function is called only from parseObjectProperty(), where
    // EOF and Punctuator tokens are already filtered out.
    if (token.type === TokenStringLiteral || token.type === TokenNumericLiteral) {
        if (token.octal) throwError(token, MessageStrictOctalLiteral);
        return finishLiteral(token);
    }
    return finishIdentifier(token.value);
}
function parseObjectProperty() {
    var token, key, id, value;
    index = lookahead.start;
    token = lookahead;
    if (token.type === TokenIdentifier) {
        id = parseObjectPropertyKey();
        expect(':');
        value = parseConditionalExpression();
        return finishProperty('init', id, value);
    }
    if (token.type === TokenEOF || token.type === TokenPunctuator) throwUnexpected(token);
    else {
        key = parseObjectPropertyKey();
        expect(':');
        value = parseConditionalExpression();
        return finishProperty('init', key, value);
    }
}
function parseObjectInitialiser() {
    var properties = [], property, name, key, map = {}, toString = String;
    index = lookahead.start;
    expect('{');
    while(!match('}')){
        property = parseObjectProperty();
        if (property.key.type === SyntaxIdentifier) name = property.key.name;
        else name = toString(property.key.value);
        key = '$' + name;
        if (Object.prototype.hasOwnProperty.call(map, key)) throwError({}, MessageStrictDuplicateProperty);
        else map[key] = true;
        properties.push(property);
        if (!match('}')) expect(',');
    }
    expect('}');
    return finishObjectExpression(properties);
}
// 11.1.6 The Grouping Operator
function parseGroupExpression() {
    expect('(');
    const expr = parseExpression();
    expect(')');
    return expr;
}
// 11.1 Primary Expressions
const legalKeywords = {
    'if': 1
};
function parsePrimaryExpression() {
    var type, token, expr;
    if (match('(')) return parseGroupExpression();
    if (match('[')) return parseArrayInitialiser();
    if (match('{')) return parseObjectInitialiser();
    type = lookahead.type;
    index = lookahead.start;
    if (type === TokenIdentifier || legalKeywords[lookahead.value]) expr = finishIdentifier(lex().value);
    else if (type === TokenStringLiteral || type === TokenNumericLiteral) {
        if (lookahead.octal) throwError(lookahead, MessageStrictOctalLiteral);
        expr = finishLiteral(lex());
    } else if (type === TokenKeyword) throw new Error(DISABLED);
    else if (type === TokenBooleanLiteral) {
        token = lex();
        token.value = token.value === 'true';
        expr = finishLiteral(token);
    } else if (type === TokenNullLiteral) {
        token = lex();
        token.value = null;
        expr = finishLiteral(token);
    } else if (match('/') || match('/=')) {
        expr = finishLiteral(scanRegExp());
        peek();
    } else throwUnexpected(lex());
    return expr;
}
// 11.2 Left-Hand-Side Expressions
function parseArguments() {
    const args = [];
    expect('(');
    if (!match(')')) while(index < length){
        args.push(parseConditionalExpression());
        if (match(')')) break;
        expect(',');
    }
    expect(')');
    return args;
}
function parseNonComputedProperty() {
    index = lookahead.start;
    const token = lex();
    if (!isIdentifierName(token)) throwUnexpected(token);
    return finishIdentifier(token.value);
}
function parseNonComputedMember() {
    expect('.');
    return parseNonComputedProperty();
}
function parseComputedMember() {
    expect('[');
    const expr = parseExpression();
    expect(']');
    return expr;
}
function parseLeftHandSideExpressionAllowCall() {
    var expr, args, property;
    expr = parsePrimaryExpression();
    for(;;){
        if (match('.')) {
            property = parseNonComputedMember();
            expr = finishMemberExpression('.', expr, property);
        } else if (match('(')) {
            args = parseArguments();
            expr = finishCallExpression(expr, args);
        } else if (match('[')) {
            property = parseComputedMember();
            expr = finishMemberExpression('[', expr, property);
        } else break;
    }
    return expr;
}
// 11.3 Postfix Expressions
function parsePostfixExpression() {
    const expr = parseLeftHandSideExpressionAllowCall();
    if (lookahead.type === TokenPunctuator) {
        if (match('++') || match('--')) throw new Error(DISABLED);
    }
    return expr;
}
// 11.4 Unary Operators
function parseUnaryExpression() {
    var token, expr;
    if (lookahead.type !== TokenPunctuator && lookahead.type !== TokenKeyword) expr = parsePostfixExpression();
    else if (match('++') || match('--')) throw new Error(DISABLED);
    else if (match('+') || match('-') || match('~') || match('!')) {
        token = lex();
        expr = parseUnaryExpression();
        expr = finishUnaryExpression(token.value, expr);
    } else if (matchKeyword('delete') || matchKeyword('void') || matchKeyword('typeof')) throw new Error(DISABLED);
    else expr = parsePostfixExpression();
    return expr;
}
function binaryPrecedence(token) {
    let prec = 0;
    if (token.type !== TokenPunctuator && token.type !== TokenKeyword) return 0;
    switch(token.value){
        case '||':
            prec = 1;
            break;
        case '&&':
            prec = 2;
            break;
        case '|':
            prec = 3;
            break;
        case '^':
            prec = 4;
            break;
        case '&':
            prec = 5;
            break;
        case '==':
        case '!=':
        case '===':
        case '!==':
            prec = 6;
            break;
        case '<':
        case '>':
        case '<=':
        case '>=':
        case 'instanceof':
        case 'in':
            prec = 7;
            break;
        case '<<':
        case '>>':
        case '>>>':
            prec = 8;
            break;
        case '+':
        case '-':
            prec = 9;
            break;
        case '*':
        case '/':
        case '%':
            prec = 11;
            break;
    }
    return prec;
}
// 11.5 Multiplicative Operators
// 11.6 Additive Operators
// 11.7 Bitwise Shift Operators
// 11.8 Relational Operators
// 11.9 Equality Operators
// 11.10 Binary Bitwise Operators
// 11.11 Binary Logical Operators
function parseBinaryExpression() {
    var marker, markers, expr, token, prec, stack, right, operator, left, i;
    marker = lookahead;
    left = parseUnaryExpression();
    token = lookahead;
    prec = binaryPrecedence(token);
    if (prec === 0) return left;
    token.prec = prec;
    lex();
    markers = [
        marker,
        lookahead
    ];
    right = parseUnaryExpression();
    stack = [
        left,
        token,
        right
    ];
    while((prec = binaryPrecedence(lookahead)) > 0){
        // Reduce: make a binary expression from the three topmost entries.
        while(stack.length > 2 && prec <= stack[stack.length - 2].prec){
            right = stack.pop();
            operator = stack.pop().value;
            left = stack.pop();
            markers.pop();
            expr = finishBinaryExpression(operator, left, right);
            stack.push(expr);
        }
        // Shift.
        token = lex();
        token.prec = prec;
        stack.push(token);
        markers.push(lookahead);
        expr = parseUnaryExpression();
        stack.push(expr);
    }
    // Final reduce to clean-up the stack.
    i = stack.length - 1;
    expr = stack[i];
    markers.pop();
    while(i > 1){
        markers.pop();
        expr = finishBinaryExpression(stack[i - 1].value, stack[i - 2], expr);
        i -= 2;
    }
    return expr;
}
// 11.12 Conditional Operator
function parseConditionalExpression() {
    var expr, consequent, alternate;
    expr = parseBinaryExpression();
    if (match('?')) {
        lex();
        consequent = parseConditionalExpression();
        expect(':');
        alternate = parseConditionalExpression();
        expr = finishConditionalExpression(expr, consequent, alternate);
    }
    return expr;
}
// 11.14 Comma Operator
function parseExpression() {
    const expr = parseConditionalExpression();
    if (match(',')) throw new Error(DISABLED); // no sequence expressions
    return expr;
}
function parser(code) {
    source = code;
    index = 0;
    length = source.length;
    lookahead = null;
    peek();
    const expr = parseExpression();
    if (lookahead.type !== TokenEOF) throw new Error('Unexpect token after expression.');
    return expr;
}
var Constants = {
    NaN: 'NaN',
    E: 'Math.E',
    LN2: 'Math.LN2',
    LN10: 'Math.LN10',
    LOG2E: 'Math.LOG2E',
    LOG10E: 'Math.LOG10E',
    PI: 'Math.PI',
    SQRT1_2: 'Math.SQRT1_2',
    SQRT2: 'Math.SQRT2',
    MIN_VALUE: 'Number.MIN_VALUE',
    MAX_VALUE: 'Number.MAX_VALUE'
};
function Functions(codegen) {
    function fncall(name, args, cast, type) {
        let obj = codegen(args[0]);
        if (cast) {
            obj = cast + '(' + obj + ')';
            if (cast.lastIndexOf('new ', 0) === 0) obj = '(' + obj + ')';
        }
        return obj + '.' + name + (type < 0 ? '' : type === 0 ? '()' : '(' + args.slice(1).map(codegen).join(',') + ')');
    }
    function fn(name, cast, type) {
        return (args)=>fncall(name, args, cast, type);
    }
    const DATE = 'new Date', STRING = 'String', REGEXP = 'RegExp';
    return {
        // MATH functions
        isNaN: 'Number.isNaN',
        isFinite: 'Number.isFinite',
        abs: 'Math.abs',
        acos: 'Math.acos',
        asin: 'Math.asin',
        atan: 'Math.atan',
        atan2: 'Math.atan2',
        ceil: 'Math.ceil',
        cos: 'Math.cos',
        exp: 'Math.exp',
        floor: 'Math.floor',
        hypot: 'Math.hypot',
        log: 'Math.log',
        max: 'Math.max',
        min: 'Math.min',
        pow: 'Math.pow',
        random: 'Math.random',
        round: 'Math.round',
        sin: 'Math.sin',
        sqrt: 'Math.sqrt',
        tan: 'Math.tan',
        clamp: function(args) {
            if (args.length < 3) (0, _vegaUtil.error)('Missing arguments to clamp function.');
            if (args.length > 3) (0, _vegaUtil.error)('Too many arguments to clamp function.');
            const a = args.map(codegen);
            return 'Math.max(' + a[1] + ', Math.min(' + a[2] + ',' + a[0] + '))';
        },
        // DATE functions
        now: 'Date.now',
        utc: 'Date.UTC',
        datetime: DATE,
        date: fn('getDate', DATE, 0),
        day: fn('getDay', DATE, 0),
        year: fn('getFullYear', DATE, 0),
        month: fn('getMonth', DATE, 0),
        hours: fn('getHours', DATE, 0),
        minutes: fn('getMinutes', DATE, 0),
        seconds: fn('getSeconds', DATE, 0),
        milliseconds: fn('getMilliseconds', DATE, 0),
        time: fn('getTime', DATE, 0),
        timezoneoffset: fn('getTimezoneOffset', DATE, 0),
        utcdate: fn('getUTCDate', DATE, 0),
        utcday: fn('getUTCDay', DATE, 0),
        utcyear: fn('getUTCFullYear', DATE, 0),
        utcmonth: fn('getUTCMonth', DATE, 0),
        utchours: fn('getUTCHours', DATE, 0),
        utcminutes: fn('getUTCMinutes', DATE, 0),
        utcseconds: fn('getUTCSeconds', DATE, 0),
        utcmilliseconds: fn('getUTCMilliseconds', DATE, 0),
        // sequence functions
        length: fn('length', null, -1),
        // STRING functions
        parseFloat: 'parseFloat',
        parseInt: 'parseInt',
        upper: fn('toUpperCase', STRING, 0),
        lower: fn('toLowerCase', STRING, 0),
        substring: fn('substring', STRING),
        split: fn('split', STRING),
        trim: fn('trim', STRING, 0),
        // base64 encode/decode
        btoa: 'btoa',
        atob: 'atob',
        // REGEXP functions
        regexp: REGEXP,
        test: fn('test', REGEXP),
        // Control Flow functions
        if: function(args) {
            if (args.length < 3) (0, _vegaUtil.error)('Missing arguments to if function.');
            if (args.length > 3) (0, _vegaUtil.error)('Too many arguments to if function.');
            const a = args.map(codegen);
            return '(' + a[0] + '?' + a[1] + ':' + a[2] + ')';
        }
    };
}
function stripQuotes(s) {
    const n = s && s.length - 1;
    return n && (s[0] === '"' && s[n] === '"' || s[0] === '\'' && s[n] === '\'') ? s.slice(1, -1) : s;
}
function codegen(opt) {
    opt = opt || {};
    const allowed = opt.allowed ? (0, _vegaUtil.toSet)(opt.allowed) : {}, forbidden = opt.forbidden ? (0, _vegaUtil.toSet)(opt.forbidden) : {}, constants = opt.constants || Constants, functions = (opt.functions || Functions)(visit), globalvar = opt.globalvar, fieldvar = opt.fieldvar, outputGlobal = (0, _vegaUtil.isFunction)(globalvar) ? globalvar : (id)=>`${globalvar}["${id}"]`;
    let globals = {}, fields = {}, memberDepth = 0;
    function visit(ast) {
        if ((0, _vegaUtil.isString)(ast)) return ast;
        const generator = Generators[ast.type];
        if (generator == null) (0, _vegaUtil.error)('Unsupported type: ' + ast.type);
        return generator(ast);
    }
    const Generators = {
        Literal: (n)=>n.raw,
        Identifier: (n)=>{
            const id = n.name;
            if (memberDepth > 0) return id;
            else if ((0, _vegaUtil.hasOwnProperty)(forbidden, id)) return (0, _vegaUtil.error)('Illegal identifier: ' + id);
            else if ((0, _vegaUtil.hasOwnProperty)(constants, id)) return constants[id];
            else if ((0, _vegaUtil.hasOwnProperty)(allowed, id)) return id;
            else {
                globals[id] = 1;
                return outputGlobal(id);
            }
        },
        MemberExpression: (n)=>{
            const d = !n.computed, o = visit(n.object);
            if (d) memberDepth += 1;
            const p = visit(n.property);
            if (o === fieldvar) // strip quotes to sanitize field name (#1653)
            fields[stripQuotes(p)] = 1;
            if (d) memberDepth -= 1;
            return o + (d ? '.' + p : '[' + p + ']');
        },
        CallExpression: (n)=>{
            if (n.callee.type !== 'Identifier') (0, _vegaUtil.error)('Illegal callee type: ' + n.callee.type);
            const callee = n.callee.name, args = n.arguments, fn = (0, _vegaUtil.hasOwnProperty)(functions, callee) && functions[callee];
            if (!fn) (0, _vegaUtil.error)('Unrecognized function: ' + callee);
            return (0, _vegaUtil.isFunction)(fn) ? fn(args) : fn + '(' + args.map(visit).join(',') + ')';
        },
        ArrayExpression: (n)=>'[' + n.elements.map(visit).join(',') + ']',
        BinaryExpression: (n)=>'(' + visit(n.left) + ' ' + n.operator + ' ' + visit(n.right) + ')',
        UnaryExpression: (n)=>'(' + n.operator + visit(n.argument) + ')',
        ConditionalExpression: (n)=>'(' + visit(n.test) + '?' + visit(n.consequent) + ':' + visit(n.alternate) + ')',
        LogicalExpression: (n)=>'(' + visit(n.left) + n.operator + visit(n.right) + ')',
        ObjectExpression: (n)=>'{' + n.properties.map(visit).join(',') + '}',
        Property: (n)=>{
            memberDepth += 1;
            const k = visit(n.key);
            memberDepth -= 1;
            return k + ':' + visit(n.value);
        }
    };
    function codegen(ast) {
        const result = {
            code: visit(ast),
            globals: Object.keys(globals),
            fields: Object.keys(fields)
        };
        globals = {};
        fields = {};
        return result;
    }
    codegen.functions = functions;
    codegen.constants = constants;
    return codegen;
}

},{"vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eqgVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectionIdTest", ()=>selectionIdTest);
parcelHelpers.export(exports, "selectionResolve", ()=>selectionResolve);
parcelHelpers.export(exports, "selectionTest", ()=>selectionTest);
parcelHelpers.export(exports, "selectionTuples", ()=>selectionTuples);
parcelHelpers.export(exports, "selectionVisitor", ()=>selectionVisitor);
var _d3Array = require("d3-array");
var _vegaUtil = require("vega-util");
var _vegaExpression = require("vega-expression");
// Registers vega-util field accessors to protect against XSS attacks
const SELECTION_GETTER = Symbol('vega_selection_getter');
function getter(f) {
    if (!f.getter || !f.getter[SELECTION_GETTER]) {
        f.getter = (0, _vegaUtil.field)(f.field);
        f.getter[SELECTION_GETTER] = true;
    }
    return f.getter;
}
const Intersect = 'intersect';
const Union = 'union';
const VlMulti = 'vlMulti';
const VlPoint = 'vlPoint';
const Or = 'or';
const And = 'and';
const SelectionId = '_vgsid_';
const $selectionId = (0, _vegaUtil.field)(SelectionId);
const TYPE_ENUM = 'E', TYPE_RANGE_INC = 'R', TYPE_RANGE_EXC = 'R-E', TYPE_RANGE_LE = 'R-LE', TYPE_RANGE_RE = 'R-RE', TYPE_PRED_LT = 'E-LT', TYPE_PRED_LTE = 'E-LTE', TYPE_PRED_GT = 'E-GT', TYPE_PRED_GTE = 'E-GTE', TYPE_PRED_VALID = 'E-VALID', TYPE_PRED_ONE_OF = 'E-ONE', UNIT_INDEX = 'index:unit';
// TODO: revisit date coercion?
function testPoint(datum, entry) {
    var fields = entry.fields, values = entry.values, n = fields.length, i = 0, dval, f;
    for(; i < n; ++i){
        f = fields[i];
        dval = getter(f)(datum);
        if ((0, _vegaUtil.isDate)(dval)) dval = (0, _vegaUtil.toNumber)(dval);
        if ((0, _vegaUtil.isDate)(values[i])) values[i] = (0, _vegaUtil.toNumber)(values[i]);
        if ((0, _vegaUtil.isArray)(values[i]) && (0, _vegaUtil.isDate)(values[i][0])) values[i] = values[i].map((0, _vegaUtil.toNumber));
        if (f.type === TYPE_ENUM) {
            // Enumerated fields can either specify individual values (single/multi selections)
            // or an array of values (interval selections).
            if ((0, _vegaUtil.isArray)(values[i]) ? !values[i].includes(dval) : dval !== values[i]) return false;
        } else {
            if (f.type === TYPE_RANGE_INC) {
                if (!(0, _vegaUtil.inrange)(dval, values[i])) return false;
            } else if (f.type === TYPE_RANGE_RE) {
                // Discrete selection of bins test within the range [bin_start, bin_end).
                if (!(0, _vegaUtil.inrange)(dval, values[i], true, false)) return false;
            } else if (f.type === TYPE_RANGE_EXC) {
                // 'R-E'/'R-LE' included for completeness.
                if (!(0, _vegaUtil.inrange)(dval, values[i], false, false)) return false;
            } else if (f.type === TYPE_RANGE_LE) {
                if (!(0, _vegaUtil.inrange)(dval, values[i], false, true)) return false;
            } else if (f.type === TYPE_PRED_LT) {
                if (dval >= values[i]) return false;
            } else if (f.type === TYPE_PRED_LTE) {
                if (dval > values[i]) return false;
            } else if (f.type === TYPE_PRED_GT) {
                if (dval <= values[i]) return false;
            } else if (f.type === TYPE_PRED_GTE) {
                if (dval < values[i]) return false;
            } else if (f.type === TYPE_PRED_VALID) {
                if (dval === null || isNaN(dval)) return false;
            } else if (f.type === TYPE_PRED_ONE_OF) {
                if (values[i].indexOf(dval) === -1) return false;
            }
        }
    }
    return true;
}
/**
 * Tests if a tuple is contained within an interactive selection.
 * @param {string} name - The name of the data set representing the selection.
 *  Tuples in the dataset are of the form
 *  {unit: string, fields: array<fielddef>, values: array<*>}.
 *  Fielddef is of the form
 *  {field: string, channel: string, type: 'E' | 'R'} where
 *  'type' identifies whether tuples in the dataset enumerate
 *  values for the field, or specify a continuous range.
 * @param {object} datum - The tuple to test for inclusion.
 * @param {string} op - The set operation for combining selections.
 *   One of 'intersect' or 'union' (default).
 * @return {boolean} - True if the datum is in the selection, false otherwise.
 */ function selectionTest(name, datum, op) {
    var data = this.context.data[name], entries = data ? data.values.value : [], unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined, intersect = op === Intersect, n = entries.length, i = 0, entry, miss, count, unit, b;
    for(; i < n; ++i){
        entry = entries[i];
        if (unitIdx && intersect) {
            // multi selections union within the same unit and intersect across units.
            miss = miss || {};
            count = miss[unit = entry.unit] || 0;
            // if we've already matched this unit, skip.
            if (count === -1) continue;
            b = testPoint(datum, entry);
            miss[unit] = b ? -1 : ++count;
            // if we match and there are no other units return true
            // if we've missed against all tuples in this unit return false
            if (b && unitIdx.size === 1) return true;
            if (!b && count === unitIdx.get(unit).count) return false;
        } else {
            b = testPoint(datum, entry);
            // if we find a miss and we do require intersection return false
            // if we find a match and we don't require intersection return true
            if (intersect ^ b) return b;
        }
    }
    // if intersecting and we made it here, then we saw no misses
    // if not intersecting, then we saw no matches
    // if no active selections, return false
    return n && intersect;
}
const bisect = (0, _d3Array.bisector)($selectionId), bisectLeft = bisect.left, bisectRight = bisect.right;
function selectionIdTest(name, datum, op) {
    const data = this.context.data[name], entries = data ? data.values.value : [], unitIdx = data ? data[UNIT_INDEX] && data[UNIT_INDEX].value : undefined, intersect = op === Intersect, value = $selectionId(datum), index = bisectLeft(entries, value);
    if (index === entries.length) return false;
    if ($selectionId(entries[index]) !== value) return false;
    if (unitIdx && intersect) {
        if (unitIdx.size === 1) return true;
        if (bisectRight(entries, value) - index < unitIdx.size) return false;
    }
    return true;
}
/**
 * Maps an array of scene graph items to an array of selection tuples.
 * @param {string} name  - The name of the dataset representing the selection.
 * @param {string} base  - The base object that generated tuples extend.
 *
 * @returns {array} An array of selection entries for the given unit.
 */ function selectionTuples(array, base) {
    return array.map((x)=>(0, _vegaUtil.extend)(base.fields ? {
            values: base.fields.map((f)=>getter(f)(x.datum))
        } : {
            [SelectionId]: $selectionId(x.datum)
        }, base));
}
/**
 * Resolves selection for use as a scale domain or reads via the API.
 * @param {string} name - The name of the dataset representing the selection
 * @param {string} [op='union'] - The set operation for combining selections.
 *                 One of 'intersect' or 'union' (default).
 * @param {boolean} isMulti - Identifies a "multi" selection to perform more
 *                 expensive resolution computation.
 * @param {boolean} vl5 - With Vega-Lite v5, "multi" selections are now called "point"
 *                 selections, and thus the resolved tuple should reflect this name.
 *                 This parameter allows us to reflect this change without triggering
 *                 a major version bump for Vega.
 * @returns {object} An object of selected fields and values.
 */ function selectionResolve(name, op, isMulti, vl5) {
    var data = this.context.data[name], entries = data ? data.values.value : [], resolved = {}, multiRes = {}, types = {}, entry, fields, values, unit, field, value, res, resUnit, type, union, n = entries.length, i = 0, j, m;
    // First union all entries within the same unit.
    for(; i < n; ++i){
        entry = entries[i];
        unit = entry.unit;
        fields = entry.fields;
        values = entry.values;
        if (fields && values) {
            // Intentional selection stores
            for(j = 0, m = fields.length; j < m; ++j){
                field = fields[j];
                res = resolved[field.field] || (resolved[field.field] = {});
                resUnit = res[unit] || (res[unit] = []);
                types[field.field] = type = field.type.charAt(0);
                union = ops[`${type}_union`];
                res[unit] = union(resUnit, (0, _vegaUtil.array)(values[j]));
            }
            // If the same multi-selection is repeated over views and projected over
            // an encoding, it may operate over different fields making it especially
            // tricky to reliably resolve it. At best, we can de-dupe identical entries
            // but doing so may be more computationally expensive than it is worth.
            // Instead, for now, we simply transform our store representation into
            // a more human-friendly one.
            if (isMulti) {
                resUnit = multiRes[unit] || (multiRes[unit] = []);
                resUnit.push((0, _vegaUtil.array)(values).reduce((obj, curr, j)=>(obj[fields[j].field] = curr, obj), {}));
            }
        } else {
            // Short circuit extensional selectionId stores which hold sorted IDs unique to each unit.
            field = SelectionId;
            value = $selectionId(entry);
            res = resolved[field] || (resolved[field] = {});
            resUnit = res[unit] || (res[unit] = []);
            resUnit.push(value);
            if (isMulti) {
                resUnit = multiRes[unit] || (multiRes[unit] = []);
                resUnit.push({
                    [SelectionId]: value
                });
            }
        }
    }
    // Then resolve fields across units as per the op.
    op = op || Union;
    if (resolved[SelectionId]) resolved[SelectionId] = ops[`${SelectionId}_${op}`](...Object.values(resolved[SelectionId]));
    else Object.keys(resolved).forEach((field)=>{
        resolved[field] = Object.keys(resolved[field]).map((unit)=>resolved[field][unit]).reduce((acc, curr)=>acc === undefined ? curr : ops[`${types[field]}_${op}`](acc, curr));
    });
    entries = Object.keys(multiRes);
    if (isMulti && entries.length) {
        const key = vl5 ? VlPoint : VlMulti;
        resolved[key] = op === Union ? {
            [Or]: entries.reduce((acc, k)=>(acc.push(...multiRes[k]), acc), [])
        } : {
            [And]: entries.map((k)=>({
                    [Or]: multiRes[k]
                }))
        };
    }
    return resolved;
}
var ops = {
    [`${SelectionId}_union`]: (0, _d3Array.union),
    [`${SelectionId}_intersect`]: (0, _d3Array.intersection),
    E_union: function(base, value) {
        if (!base.length) return value;
        var i = 0, n = value.length;
        for(; i < n; ++i)if (!base.includes(value[i])) base.push(value[i]);
        return base;
    },
    E_intersect: function(base, value) {
        return !base.length ? value : base.filter((v)=>value.includes(v));
    },
    R_union: function(base, value) {
        var lo = (0, _vegaUtil.toNumber)(value[0]), hi = (0, _vegaUtil.toNumber)(value[1]);
        if (lo > hi) {
            lo = value[1];
            hi = value[0];
        }
        if (!base.length) return [
            lo,
            hi
        ];
        if (base[0] > lo) base[0] = lo;
        if (base[1] < hi) base[1] = hi;
        return base;
    },
    R_intersect: function(base, value) {
        var lo = (0, _vegaUtil.toNumber)(value[0]), hi = (0, _vegaUtil.toNumber)(value[1]);
        if (lo > hi) {
            lo = value[1];
            hi = value[0];
        }
        if (!base.length) return [
            lo,
            hi
        ];
        if (hi < base[0] || base[1] < lo) return [];
        else {
            if (base[0] < lo) base[0] = lo;
            if (base[1] > hi) base[1] = hi;
        }
        return base;
    }
};
const DataPrefix = ':', IndexPrefix = '@';
function selectionVisitor(name, args, scope, params) {
    if (args[0].type !== (0, _vegaExpression.Literal)) (0, _vegaUtil.error)('First argument to selection functions must be a string literal.');
    const data = args[0].value, op = args.length >= 2 && (0, _vegaUtil.peek)(args).value, field = 'unit', indexName = IndexPrefix + field, dataName = DataPrefix + data;
    if (op === Intersect && !(0, _vegaUtil.hasOwnProperty)(params, indexName)) params[indexName] = scope.getData(data).indataRef(scope, field);
    if (!(0, _vegaUtil.hasOwnProperty)(params, dataName)) params[dataName] = scope.getData(data).tuplesRef();
}

},{"d3-array":"4pSqo","vega-util":"kncZn","vega-expression":"4bIBh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89vAE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "context", ()=>context);
var _vegaUtil = require("vega-util");
var _vegaDataflow = require("vega-dataflow");
/**
 * Parse a serialized dataflow specification.
 */ function parse(spec) {
    const ctx = this, operators = spec.operators || [];
    // parse background
    if (spec.background) ctx.background = spec.background;
    // parse event configuration
    if (spec.eventConfig) ctx.eventConfig = spec.eventConfig;
    // parse locale configuration
    if (spec.locale) ctx.locale = spec.locale;
    // parse operators
    operators.forEach((entry)=>ctx.parseOperator(entry));
    // parse operator parameters
    operators.forEach((entry)=>ctx.parseOperatorParameters(entry));
    // parse streams
    (spec.streams || []).forEach((entry)=>ctx.parseStream(entry));
    // parse updates
    (spec.updates || []).forEach((entry)=>ctx.parseUpdate(entry));
    return ctx.resolve();
}
const Skip = (0, _vegaUtil.toSet)([
    'rule'
]), Swap = (0, _vegaUtil.toSet)([
    'group',
    'image',
    'rect'
]);
function adjustSpatial(encode, marktype) {
    let code = '';
    if (Skip[marktype]) return code;
    if (encode.x2) {
        if (encode.x) {
            if (Swap[marktype]) code += 'if(o.x>o.x2)$=o.x,o.x=o.x2,o.x2=$;';
            code += 'o.width=o.x2-o.x;';
        } else code += 'o.x=o.x2-(o.width||0);';
    }
    if (encode.xc) code += 'o.x=o.xc-(o.width||0)/2;';
    if (encode.y2) {
        if (encode.y) {
            if (Swap[marktype]) code += 'if(o.y>o.y2)$=o.y,o.y=o.y2,o.y2=$;';
            code += 'o.height=o.y2-o.y;';
        } else code += 'o.y=o.y2-(o.height||0);';
    }
    if (encode.yc) code += 'o.y=o.yc-(o.height||0)/2;';
    return code;
}
function canonicalType(type) {
    return (type + '').toLowerCase();
}
function isOperator(type) {
    return canonicalType(type) === 'operator';
}
function isCollect(type) {
    return canonicalType(type) === 'collect';
}
function expression(ctx, args, code) {
    // wrap code in return statement if expression does not terminate
    if (!code.endsWith(';')) code = 'return(' + code + ');';
    const fn = Function(...args.concat(code));
    return ctx && ctx.functions ? fn.bind(ctx.functions) : fn;
}
// generate code for comparing a single field
function _compare(u, v, lt, gt) {
    return `((u = ${u}) < (v = ${v}) || u == null) && v != null ? ${lt}
  : (u > v || v == null) && u != null ? ${gt}
  : ((v = v instanceof Date ? +v : v), (u = u instanceof Date ? +u : u)) !== u && v === v ? ${lt}
  : v !== v && u === u ? ${gt} : `;
}
var expressionCodegen = {
    /**
   * Parse an expression used to update an operator value.
   */ operator: (ctx, expr)=>expression(ctx, [
            '_'
        ], expr.code),
    /**
   * Parse an expression provided as an operator parameter value.
   */ parameter: (ctx, expr)=>expression(ctx, [
            'datum',
            '_'
        ], expr.code),
    /**
   * Parse an expression applied to an event stream.
   */ event: (ctx, expr)=>expression(ctx, [
            'event'
        ], expr.code),
    /**
   * Parse an expression used to handle an event-driven operator update.
   */ handler: (ctx, expr)=>{
        const code = `var datum=event.item&&event.item.datum;return ${expr.code};`;
        return expression(ctx, [
            '_',
            'event'
        ], code);
    },
    /**
   * Parse an expression that performs visual encoding.
   */ encode: (ctx, encode)=>{
        const { marktype, channels } = encode;
        let code = 'var o=item,datum=o.datum,m=0,$;';
        for(const name in channels){
            const o = 'o[' + (0, _vegaUtil.stringValue)(name) + ']';
            code += `$=${channels[name].code};if(${o}!==$)${o}=$,m=1;`;
        }
        code += adjustSpatial(channels, marktype);
        code += 'return m;';
        return expression(ctx, [
            'item',
            '_'
        ], code);
    },
    /**
   * Optimized code generators for access and comparison.
   */ codegen: {
        get (path) {
            const ref = `[${path.map((0, _vegaUtil.stringValue)).join('][')}]`;
            const get = Function('_', `return _${ref};`);
            get.path = ref;
            return get;
        },
        comparator (fields, orders) {
            let t;
            const map = (f, i)=>{
                const o = orders[i];
                let u, v;
                if (f.path) {
                    u = `a${f.path}`;
                    v = `b${f.path}`;
                } else {
                    (t = t || {})['f' + i] = f;
                    u = `this.f${i}(a)`;
                    v = `this.f${i}(b)`;
                }
                return _compare(u, v, -o, o);
            };
            const fn = Function('a', 'b', 'var u, v; return ' + fields.map(map).join('') + '0;');
            return t ? fn.bind(t) : fn;
        }
    }
};
/**
 * Parse a dataflow operator.
 */ function parseOperator(spec) {
    const ctx = this;
    if (isOperator(spec.type) || !spec.type) ctx.operator(spec, spec.update ? ctx.operatorExpression(spec.update) : null);
    else ctx.transform(spec, spec.type);
}
/**
 * Parse and assign operator parameters.
 */ function parseOperatorParameters(spec) {
    const ctx = this;
    if (spec.params) {
        const op = ctx.get(spec.id);
        if (!op) (0, _vegaUtil.error)('Invalid operator id: ' + spec.id);
        ctx.dataflow.connect(op, op.parameters(ctx.parseParameters(spec.params), spec.react, spec.initonly));
    }
}
/**
 * Parse a set of operator parameters.
 */ function parseParameters(spec, params) {
    params = params || {};
    const ctx = this;
    for(const key in spec){
        const value = spec[key];
        params[key] = (0, _vegaUtil.isArray)(value) ? value.map((v)=>parseParameter(v, ctx, params)) : parseParameter(value, ctx, params);
    }
    return params;
}
/**
 * Parse a single parameter.
 */ function parseParameter(spec, ctx, params) {
    if (!spec || !(0, _vegaUtil.isObject)(spec)) return spec;
    for(let i = 0, n = PARSERS.length, p; i < n; ++i){
        p = PARSERS[i];
        if ((0, _vegaUtil.hasOwnProperty)(spec, p.key)) return p.parse(spec, ctx, params);
    }
    return spec;
}
/** Reference parsers. */ var PARSERS = [
    {
        key: '$ref',
        parse: getOperator
    },
    {
        key: '$key',
        parse: getKey
    },
    {
        key: '$expr',
        parse: getExpression
    },
    {
        key: '$field',
        parse: getField
    },
    {
        key: '$encode',
        parse: getEncode
    },
    {
        key: '$compare',
        parse: getCompare
    },
    {
        key: '$context',
        parse: getContext
    },
    {
        key: '$subflow',
        parse: getSubflow
    },
    {
        key: '$tupleid',
        parse: getTupleId
    }
];
/**
 * Resolve an operator reference.
 */ function getOperator(_, ctx) {
    return ctx.get(_.$ref) || (0, _vegaUtil.error)('Operator not defined: ' + _.$ref);
}
/**
 * Resolve an expression reference.
 */ function getExpression(_, ctx, params) {
    if (_.$params) // parse expression parameters
    ctx.parseParameters(_.$params, params);
    const k = 'e:' + _.$expr.code;
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.accessor)(ctx.parameterExpression(_.$expr), _.$fields));
}
/**
 * Resolve a key accessor reference.
 */ function getKey(_, ctx) {
    const k = 'k:' + _.$key + '_' + !!_.$flat;
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.key)(_.$key, _.$flat, ctx.expr.codegen));
}
/**
 * Resolve a field accessor reference.
 */ function getField(_, ctx) {
    if (!_.$field) return null;
    const k = 'f:' + _.$field + '_' + _.$name;
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.field)(_.$field, _.$name, ctx.expr.codegen));
}
/**
 * Resolve a comparator function reference.
 */ function getCompare(_, ctx) {
    // As of Vega 5.5.3, $tupleid sort is no longer used.
    // Keep here for now for backwards compatibility.
    const k = 'c:' + _.$compare + '_' + _.$order, c = (0, _vegaUtil.array)(_.$compare).map((_)=>_ && _.$tupleid ? (0, _vegaDataflow.tupleid) : _);
    return ctx.fn[k] || (ctx.fn[k] = (0, _vegaUtil.compare)(c, _.$order, ctx.expr.codegen));
}
/**
 * Resolve an encode operator reference.
 */ function getEncode(_, ctx) {
    const spec = _.$encode, encode = {};
    for(const name in spec){
        const enc = spec[name];
        encode[name] = (0, _vegaUtil.accessor)(ctx.encodeExpression(enc.$expr), enc.$fields);
        encode[name].output = enc.$output;
    }
    return encode;
}
/**
 * Resolve a context reference.
 */ function getContext(_, ctx) {
    return ctx;
}
/**
 * Resolve a recursive subflow specification.
 */ function getSubflow(_, ctx) {
    const spec = _.$subflow;
    return function(dataflow, key, parent) {
        const subctx = ctx.fork().parse(spec), op = subctx.get(spec.operators[0].id), p = subctx.signals.parent;
        if (p) p.set(parent);
        op.detachSubflow = ()=>ctx.detach(subctx);
        return op;
    };
}
/**
 * Resolve a tuple id reference.
 */ function getTupleId() {
    return 0, _vegaDataflow.tupleid;
}
/**
 * Parse an event stream specification.
 */ function parseStream(spec) {
    var ctx = this, filter = spec.filter != null ? ctx.eventExpression(spec.filter) : undefined, stream = spec.stream != null ? ctx.get(spec.stream) : undefined, args;
    if (spec.source) stream = ctx.events(spec.source, spec.type, filter);
    else if (spec.merge) {
        args = spec.merge.map((_)=>ctx.get(_));
        stream = args[0].merge.apply(args[0], args.slice(1));
    }
    if (spec.between) {
        args = spec.between.map((_)=>ctx.get(_));
        stream = stream.between(args[0], args[1]);
    }
    if (spec.filter) stream = stream.filter(filter);
    if (spec.throttle != null) stream = stream.throttle(+spec.throttle);
    if (spec.debounce != null) stream = stream.debounce(+spec.debounce);
    if (stream == null) (0, _vegaUtil.error)('Invalid stream definition: ' + JSON.stringify(spec));
    if (spec.consume) stream.consume(true);
    ctx.stream(spec, stream);
}
/**
 * Parse an event-driven operator update.
 */ function parseUpdate(spec) {
    var ctx = this, srcid = (0, _vegaUtil.isObject)(srcid = spec.source) ? srcid.$ref : srcid, source = ctx.get(srcid), target = null, update = spec.update, params = undefined;
    if (!source) (0, _vegaUtil.error)('Source not defined: ' + spec.source);
    target = spec.target && spec.target.$expr ? ctx.eventExpression(spec.target.$expr) : ctx.get(spec.target);
    if (update && update.$expr) {
        if (update.$params) params = ctx.parseParameters(update.$params);
        update = ctx.handlerExpression(update.$expr);
    }
    ctx.update(spec, source, target, update, params);
}
const SKIP = {
    skip: true
};
function getState(options) {
    var ctx = this, state = {};
    if (options.signals) {
        var signals = state.signals = {};
        Object.keys(ctx.signals).forEach((key)=>{
            const op = ctx.signals[key];
            if (options.signals(key, op)) signals[key] = op.value;
        });
    }
    if (options.data) {
        var data = state.data = {};
        Object.keys(ctx.data).forEach((key)=>{
            const dataset = ctx.data[key];
            if (options.data(key, dataset)) data[key] = dataset.input.value;
        });
    }
    if (ctx.subcontext && options.recurse !== false) state.subcontext = ctx.subcontext.map((ctx)=>ctx.getState(options));
    return state;
}
function setState(state) {
    var ctx = this, df = ctx.dataflow, data = state.data, signals = state.signals;
    Object.keys(signals || {}).forEach((key)=>{
        df.update(ctx.signals[key], signals[key], SKIP);
    });
    Object.keys(data || {}).forEach((key)=>{
        df.pulse(ctx.data[key].input, df.changeset().remove((0, _vegaUtil.truthy)).insert(data[key]));
    });
    (state.subcontext || []).forEach((substate, i)=>{
        const subctx = ctx.subcontext[i];
        if (subctx) subctx.setState(substate);
    });
}
/**
 * Context objects store the current parse state.
 * Enables lookup of parsed operators, event streams, accessors, etc.
 * Provides a 'fork' method for creating child contexts for subflows.
 */ function context(df, transforms, functions, expr) {
    return new Context(df, transforms, functions, expr);
}
function Context(df, transforms, functions, expr) {
    this.dataflow = df;
    this.transforms = transforms;
    this.events = df.events.bind(df);
    this.expr = expr || expressionCodegen, this.signals = {};
    this.scales = {};
    this.nodes = {};
    this.data = {};
    this.fn = {};
    if (functions) {
        this.functions = Object.create(functions);
        this.functions.context = this;
    }
}
function Subcontext(ctx) {
    this.dataflow = ctx.dataflow;
    this.transforms = ctx.transforms;
    this.events = ctx.events;
    this.expr = ctx.expr;
    this.signals = Object.create(ctx.signals);
    this.scales = Object.create(ctx.scales);
    this.nodes = Object.create(ctx.nodes);
    this.data = Object.create(ctx.data);
    this.fn = Object.create(ctx.fn);
    if (ctx.functions) {
        this.functions = Object.create(ctx.functions);
        this.functions.context = this;
    }
}
Context.prototype = Subcontext.prototype = {
    fork () {
        const ctx = new Subcontext(this);
        (this.subcontext || (this.subcontext = [])).push(ctx);
        return ctx;
    },
    detach (ctx) {
        this.subcontext = this.subcontext.filter((c)=>c !== ctx);
        // disconnect all nodes in the subcontext
        // wipe out targets first for better efficiency
        const keys = Object.keys(ctx.nodes);
        for (const key of keys)ctx.nodes[key]._targets = null;
        for (const key of keys)ctx.nodes[key].detach();
        ctx.nodes = null;
    },
    get (id) {
        return this.nodes[id];
    },
    set (id, node) {
        return this.nodes[id] = node;
    },
    add (spec, op) {
        const ctx = this, df = ctx.dataflow, data = spec.value;
        ctx.set(spec.id, op);
        if (isCollect(spec.type) && data) {
            if (data.$ingest) df.ingest(op, data.$ingest, data.$format);
            else if (data.$request) df.preload(op, data.$request, data.$format);
            else df.pulse(op, df.changeset().insert(data));
        }
        if (spec.root) ctx.root = op;
        if (spec.parent) {
            let p = ctx.get(spec.parent.$ref);
            if (p) {
                df.connect(p, [
                    op
                ]);
                op.targets().add(p);
            } else (ctx.unresolved = ctx.unresolved || []).push(()=>{
                p = ctx.get(spec.parent.$ref);
                df.connect(p, [
                    op
                ]);
                op.targets().add(p);
            });
        }
        if (spec.signal) ctx.signals[spec.signal] = op;
        if (spec.scale) ctx.scales[spec.scale] = op;
        if (spec.data) for(const name in spec.data){
            const data = ctx.data[name] || (ctx.data[name] = {});
            spec.data[name].forEach((role)=>data[role] = op);
        }
    },
    resolve () {
        (this.unresolved || []).forEach((fn)=>fn());
        delete this.unresolved;
        return this;
    },
    operator (spec, update) {
        this.add(spec, this.dataflow.add(spec.value, update));
    },
    transform (spec, type) {
        this.add(spec, this.dataflow.add(this.transforms[canonicalType(type)]));
    },
    stream (spec, stream) {
        this.set(spec.id, stream);
    },
    update (spec, stream, target, update, params) {
        this.dataflow.on(stream, target, update, params, spec.options);
    },
    // expression parsing
    operatorExpression (expr) {
        return this.expr.operator(this, expr);
    },
    parameterExpression (expr) {
        return this.expr.parameter(this, expr);
    },
    eventExpression (expr) {
        return this.expr.event(this, expr);
    },
    handlerExpression (expr) {
        return this.expr.handler(this, expr);
    },
    encodeExpression (encode) {
        return this.expr.encode(this, encode);
    },
    // parse methods
    parse,
    parseOperator,
    parseOperatorParameters,
    parseParameters,
    parseStream,
    parseUpdate,
    // state methods
    getState,
    setState
};

},{"vega-util":"kncZn","vega-dataflow":"eoU45","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3c3BX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AxisDomainRole", ()=>AxisDomainRole);
parcelHelpers.export(exports, "AxisGridRole", ()=>AxisGridRole);
parcelHelpers.export(exports, "AxisLabelRole", ()=>AxisLabelRole);
parcelHelpers.export(exports, "AxisRole", ()=>AxisRole);
parcelHelpers.export(exports, "AxisTickRole", ()=>AxisTickRole);
parcelHelpers.export(exports, "AxisTitleRole", ()=>AxisTitleRole);
parcelHelpers.export(exports, "DataScope", ()=>DataScope);
parcelHelpers.export(exports, "FrameRole", ()=>FrameRole);
parcelHelpers.export(exports, "LegendEntryRole", ()=>LegendEntryRole);
parcelHelpers.export(exports, "LegendLabelRole", ()=>LegendLabelRole);
parcelHelpers.export(exports, "LegendRole", ()=>LegendRole);
parcelHelpers.export(exports, "LegendSymbolRole", ()=>LegendSymbolRole);
parcelHelpers.export(exports, "LegendTitleRole", ()=>LegendTitleRole);
parcelHelpers.export(exports, "MarkRole", ()=>MarkRole);
parcelHelpers.export(exports, "Scope", ()=>Scope);
parcelHelpers.export(exports, "ScopeRole", ()=>ScopeRole);
parcelHelpers.export(exports, "config", ()=>defaults);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "signal", ()=>parseSignal);
parcelHelpers.export(exports, "signalUpdates", ()=>parseSignalUpdates);
parcelHelpers.export(exports, "stream", ()=>parseStream);
var _vegaUtil = require("vega-util");
var _vegaFunctions = require("vega-functions");
var _vegaEventSelector = require("vega-event-selector");
var _vegaScale = require("vega-scale");
var _vegaDataflow = require("vega-dataflow");
function parseAutosize(spec) {
    return (0, _vegaUtil.isObject)(spec) ? spec : {
        type: spec || 'pad'
    };
}
const number = (_)=>+_ || 0;
const paddingObject = (_)=>({
        top: _,
        bottom: _,
        left: _,
        right: _
    });
function parsePadding(spec) {
    return !(0, _vegaUtil.isObject)(spec) ? paddingObject(number(spec)) : spec.signal ? spec : {
        top: number(spec.top),
        bottom: number(spec.bottom),
        left: number(spec.left),
        right: number(spec.right)
    };
}
const encoder = (_)=>(0, _vegaUtil.isObject)(_) && !(0, _vegaUtil.isArray)(_) ? (0, _vegaUtil.extend)({}, _) : {
        value: _
    };
function addEncode(object, name, value, set) {
    if (value != null) {
        const isEncoder = (0, _vegaUtil.isObject)(value) && !(0, _vegaUtil.isArray)(value) || (0, _vegaUtil.isArray)(value) && value.length && (0, _vegaUtil.isObject)(value[0]);
        // Always assign signal to update, even if the signal is from the enter block
        if (isEncoder) object.update[name] = value;
        else object[set || 'enter'][name] = {
            value: value
        };
        return 1;
    } else return 0;
}
function addEncoders(object, enter, update) {
    for(const name in enter)addEncode(object, name, enter[name]);
    for(const name in update)addEncode(object, name, update[name], 'update');
}
function extendEncode(encode, extra, skip) {
    for(const name in extra){
        if (skip && (0, _vegaUtil.hasOwnProperty)(skip, name)) continue;
        encode[name] = (0, _vegaUtil.extend)(encode[name] || {}, extra[name]);
    }
    return encode;
}
function has(key, encode) {
    return encode && (encode.enter && encode.enter[key] || encode.update && encode.update[key]);
}
const MarkRole = 'mark';
const FrameRole = 'frame';
const ScopeRole = 'scope';
const AxisRole = 'axis';
const AxisDomainRole = 'axis-domain';
const AxisGridRole = 'axis-grid';
const AxisLabelRole = 'axis-label';
const AxisTickRole = 'axis-tick';
const AxisTitleRole = 'axis-title';
const LegendRole = 'legend';
const LegendBandRole = 'legend-band';
const LegendEntryRole = 'legend-entry';
const LegendGradientRole = 'legend-gradient';
const LegendLabelRole = 'legend-label';
const LegendSymbolRole = 'legend-symbol';
const LegendTitleRole = 'legend-title';
const TitleRole = 'title';
const TitleTextRole = 'title-text';
const TitleSubtitleRole = 'title-subtitle';
function applyDefaults(encode, type, role, style, config) {
    const defaults = {}, enter = {};
    let update, key, skip, props;
    // if text mark, apply global lineBreak settings (#2370)
    key = 'lineBreak';
    if (type === 'text' && config[key] != null && !has(key, encode)) applyDefault(defaults, key, config[key]);
    // ignore legend and axis roles
    if (role == 'legend' || String(role).startsWith('axis')) role = null;
    // resolve mark config
    props = role === FrameRole ? config.group : role === MarkRole ? (0, _vegaUtil.extend)({}, config.mark, config[type]) : null;
    for(key in props){
        // do not apply defaults if relevant fields are defined
        skip = has(key, encode) || (key === 'fill' || key === 'stroke') && (has('fill', encode) || has('stroke', encode));
        if (!skip) applyDefault(defaults, key, props[key]);
    }
    // resolve styles, apply with increasing precedence
    (0, _vegaUtil.array)(style).forEach((name)=>{
        const props = config.style && config.style[name];
        for(const key in props)if (!has(key, encode)) applyDefault(defaults, key, props[key]);
    });
    encode = (0, _vegaUtil.extend)({}, encode); // defensive copy
    for(key in defaults){
        props = defaults[key];
        if (props.signal) (update = update || {})[key] = props;
        else enter[key] = props;
    }
    encode.enter = (0, _vegaUtil.extend)(enter, encode.enter);
    if (update) encode.update = (0, _vegaUtil.extend)(update, encode.update);
    return encode;
}
function applyDefault(defaults, key, value) {
    defaults[key] = value && value.signal ? {
        signal: value.signal
    } : {
        value: value
    };
}
const scaleRef = (scale)=>(0, _vegaUtil.isString)(scale) ? (0, _vegaUtil.stringValue)(scale) : scale.signal ? `(${scale.signal})` : field(scale);
function entry$1(enc) {
    if (enc.gradient != null) return gradient(enc);
    let value = enc.signal ? `(${enc.signal})` : enc.color ? color(enc.color) : enc.field != null ? field(enc.field) : enc.value !== undefined ? (0, _vegaUtil.stringValue)(enc.value) : undefined;
    if (enc.scale != null) value = scale(enc, value);
    if (value === undefined) value = null;
    if (enc.exponent != null) value = `pow(${value},${property(enc.exponent)})`;
    if (enc.mult != null) value += `*${property(enc.mult)}`;
    if (enc.offset != null) value += `+${property(enc.offset)}`;
    if (enc.round) value = `round(${value})`;
    return value;
}
const _color = (type, x, y, z)=>`(${type}(${[
        x,
        y,
        z
    ].map(entry$1).join(',')})+'')`;
function color(enc) {
    return enc.c ? _color('hcl', enc.h, enc.c, enc.l) : enc.h || enc.s ? _color('hsl', enc.h, enc.s, enc.l) : enc.l || enc.a ? _color('lab', enc.l, enc.a, enc.b) : enc.r || enc.g || enc.b ? _color('rgb', enc.r, enc.g, enc.b) : null;
}
function gradient(enc) {
    // map undefined to null; expression lang does not allow undefined
    const args = [
        enc.start,
        enc.stop,
        enc.count
    ].map((_)=>_ == null ? null : (0, _vegaUtil.stringValue)(_));
    // trim null inputs from the end
    while(args.length && (0, _vegaUtil.peek)(args) == null)args.pop();
    args.unshift(scaleRef(enc.gradient));
    return `gradient(${args.join(',')})`;
}
function property(property) {
    return (0, _vegaUtil.isObject)(property) ? '(' + entry$1(property) + ')' : property;
}
function field(ref) {
    return resolveField((0, _vegaUtil.isObject)(ref) ? ref : {
        datum: ref
    });
}
function resolveField(ref) {
    let object, level, field;
    if (ref.signal) {
        object = 'datum';
        field = ref.signal;
    } else if (ref.group || ref.parent) {
        level = Math.max(1, ref.level || 1);
        object = 'item';
        while(level-- > 0)object += '.mark.group';
        if (ref.parent) {
            field = ref.parent;
            object += '.datum';
        } else field = ref.group;
    } else if (ref.datum) {
        object = 'datum';
        field = ref.datum;
    } else (0, _vegaUtil.error)('Invalid field reference: ' + (0, _vegaUtil.stringValue)(ref));
    if (!ref.signal) field = (0, _vegaUtil.isString)(field) ? (0, _vegaUtil.splitAccessPath)(field).map((0, _vegaUtil.stringValue)).join('][') : resolveField(field);
    return object + '[' + field + ']';
}
function scale(enc, value) {
    const scale = scaleRef(enc.scale);
    if (enc.range != null) // pull value from scale range
    value = `lerp(_range(${scale}), ${+enc.range})`;
    else {
        // run value through scale and/or pull scale bandwidth
        if (value !== undefined) value = `_scale(${scale}, ${value})`;
        if (enc.band) {
            value = (value ? value + '+' : '') + `_bandwidth(${scale})` + (+enc.band === 1 ? '' : '*' + property(enc.band));
            if (enc.extra) // include logic to handle extraneous elements
            value = `(datum.extra ? _scale(${scale}, datum.extra.value) : ${value})`;
        }
        if (value == null) value = '0';
    }
    return value;
}
function rule(enc) {
    let code = '';
    enc.forEach((rule)=>{
        const value = entry$1(rule);
        code += rule.test ? `(${rule.test})?${value}:` : value;
    });
    // if no else clause, terminate with null (#1366)
    if ((0, _vegaUtil.peek)(code) === ':') code += 'null';
    return code;
}
function parseEncode(encode, type, role, style, scope, params) {
    const enc = {};
    params = params || {};
    params.encoders = {
        $encode: enc
    };
    encode = applyDefaults(encode, type, role, style, scope.config);
    for(const key in encode)enc[key] = parseBlock(encode[key], type, params, scope);
    return params;
}
function parseBlock(block, marktype, params, scope) {
    const channels = {}, fields = {};
    for(const name in block)if (block[name] != null) // skip any null entries
    channels[name] = parse$1(expr(block[name]), scope, params, fields);
    return {
        $expr: {
            marktype,
            channels
        },
        $fields: Object.keys(fields),
        $output: Object.keys(block)
    };
}
function expr(enc) {
    return (0, _vegaUtil.isArray)(enc) ? rule(enc) : entry$1(enc);
}
function parse$1(code, scope, params, fields) {
    const expr = (0, _vegaFunctions.parseExpression)(code, scope);
    expr.$fields.forEach((name)=>fields[name] = 1);
    (0, _vegaUtil.extend)(params, expr.$params);
    return expr.$expr;
}
const OUTER = 'outer', OUTER_INVALID = [
    'value',
    'update',
    'init',
    'react',
    'bind'
];
function outerError(prefix, name) {
    (0, _vegaUtil.error)(prefix + ' for "outer" push: ' + (0, _vegaUtil.stringValue)(name));
}
function parseSignal(signal, scope) {
    const name = signal.name;
    if (signal.push === OUTER) {
        // signal must already be defined, raise error if not
        if (!scope.signals[name]) outerError('No prior signal definition', name);
        // signal push must not use properties reserved for standard definition
        OUTER_INVALID.forEach((prop)=>{
            if (signal[prop] !== undefined) outerError('Invalid property ', prop);
        });
    } else {
        // define a new signal in the current scope
        const op = scope.addSignal(name, signal.value);
        if (signal.react === false) op.react = false;
        if (signal.bind) scope.addBinding(name, signal.bind);
    }
}
function Entry(type, value, params, parent) {
    this.id = -1;
    this.type = type;
    this.value = value;
    this.params = params;
    if (parent) this.parent = parent;
}
function entry(type, value, params, parent) {
    return new Entry(type, value, params, parent);
}
function operator(value, params) {
    return entry('operator', value, params);
}
// -----
function ref(op) {
    const ref = {
        $ref: op.id
    };
    // if operator not yet registered, cache ref to resolve later
    if (op.id < 0) (op.refs = op.refs || []).push(ref);
    return ref;
}
function fieldRef$1(field, name) {
    return name ? {
        $field: field,
        $name: name
    } : {
        $field: field
    };
}
const keyFieldRef = fieldRef$1('key');
function compareRef(fields, orders) {
    return {
        $compare: fields,
        $order: orders
    };
}
function keyRef(fields, flat) {
    const ref = {
        $key: fields
    };
    if (flat) ref.$flat = true;
    return ref;
}
// -----
const Ascending = 'ascending';
const Descending = 'descending';
function sortKey(sort) {
    return !(0, _vegaUtil.isObject)(sort) ? '' : (sort.order === Descending ? '-' : '+') + aggrField(sort.op, sort.field);
}
function aggrField(op, field) {
    return (op && op.signal ? '$' + op.signal : op || '') + (op && field ? '_' : '') + (field && field.signal ? '$' + field.signal : field || '');
}
// -----
const Scope$1 = 'scope';
const View = 'view';
function isSignal(_) {
    return _ && _.signal;
}
function isExpr$1(_) {
    return _ && _.expr;
}
function hasSignal(_) {
    if (isSignal(_)) return true;
    if ((0, _vegaUtil.isObject)(_)) for(const key in _){
        if (hasSignal(_[key])) return true;
    }
    return false;
}
function value(specValue, defaultValue) {
    return specValue != null ? specValue : defaultValue;
}
function deref(v) {
    return v && v.signal || v;
}
const Timer = 'timer';
function parseStream(stream, scope) {
    const method = stream.merge ? mergeStream : stream.stream ? nestedStream : stream.type ? eventStream : (0, _vegaUtil.error)('Invalid stream specification: ' + (0, _vegaUtil.stringValue)(stream));
    return method(stream, scope);
}
function eventSource(source) {
    return source === Scope$1 ? View : source || View;
}
function mergeStream(stream, scope) {
    const list = stream.merge.map((s)=>parseStream(s, scope)), entry = streamParameters({
        merge: list
    }, stream, scope);
    return scope.addStream(entry).id;
}
function nestedStream(stream, scope) {
    const id = parseStream(stream.stream, scope), entry = streamParameters({
        stream: id
    }, stream, scope);
    return scope.addStream(entry).id;
}
function eventStream(stream, scope) {
    let id;
    if (stream.type === Timer) {
        id = scope.event(Timer, stream.throttle);
        stream = {
            between: stream.between,
            filter: stream.filter
        };
    } else id = scope.event(eventSource(stream.source), stream.type);
    const entry = streamParameters({
        stream: id
    }, stream, scope);
    return Object.keys(entry).length === 1 ? id : scope.addStream(entry).id;
}
function streamParameters(entry, stream, scope) {
    let param = stream.between;
    if (param) {
        if (param.length !== 2) (0, _vegaUtil.error)('Stream "between" parameter must have 2 entries: ' + (0, _vegaUtil.stringValue)(stream));
        entry.between = [
            parseStream(param[0], scope),
            parseStream(param[1], scope)
        ];
    }
    param = stream.filter ? [].concat(stream.filter) : [];
    if (stream.marktype || stream.markname || stream.markrole) // add filter for mark type, name and/or role
    param.push(filterMark(stream.marktype, stream.markname, stream.markrole));
    if (stream.source === Scope$1) // add filter to limit events from sub-scope only
    param.push('inScope(event.item)');
    if (param.length) entry.filter = (0, _vegaFunctions.parseExpression)('(' + param.join(')&&(') + ')', scope).$expr;
    if ((param = stream.throttle) != null) entry.throttle = +param;
    if ((param = stream.debounce) != null) entry.debounce = +param;
    if (stream.consume) entry.consume = true;
    return entry;
}
function filterMark(type, name, role) {
    const item = 'event.item';
    return item + (type && type !== '*' ? '&&' + item + '.mark.marktype===\'' + type + '\'' : '') + (role ? '&&' + item + '.mark.role===\'' + role + '\'' : '') + (name ? '&&' + item + '.mark.name===\'' + name + '\'' : '');
}
// bypass expression parser for internal operator references
const OP_VALUE_EXPR = {
    code: '_.$value',
    ast: {
        type: 'Identifier',
        value: 'value'
    }
};
function parseUpdate(spec, scope, target) {
    const encode = spec.encode, entry = {
        target: target
    };
    let events = spec.events, update = spec.update, sources = [];
    if (!events) (0, _vegaUtil.error)('Signal update missing events specification.');
    // interpret as an event selector string
    if ((0, _vegaUtil.isString)(events)) events = (0, _vegaEventSelector.parseSelector)(events, scope.isSubscope() ? Scope$1 : View);
    // separate event streams from signal updates
    events = (0, _vegaUtil.array)(events).filter((s)=>s.signal || s.scale ? (sources.push(s), 0) : 1);
    // merge internal operator listeners
    if (sources.length > 1) sources = [
        mergeSources(sources)
    ];
    // merge event streams, include as source
    if (events.length) sources.push(events.length > 1 ? {
        merge: events
    } : events[0]);
    if (encode != null) {
        if (update) (0, _vegaUtil.error)('Signal encode and update are mutually exclusive.');
        update = 'encode(item(),' + (0, _vegaUtil.stringValue)(encode) + ')';
    }
    // resolve update value
    entry.update = (0, _vegaUtil.isString)(update) ? (0, _vegaFunctions.parseExpression)(update, scope) : update.expr != null ? (0, _vegaFunctions.parseExpression)(update.expr, scope) : update.value != null ? update.value : update.signal != null ? {
        $expr: OP_VALUE_EXPR,
        $params: {
            $value: scope.signalRef(update.signal)
        }
    } : (0, _vegaUtil.error)('Invalid signal update specification.');
    if (spec.force) entry.options = {
        force: true
    };
    sources.forEach((source)=>scope.addUpdate((0, _vegaUtil.extend)(streamSource(source, scope), entry)));
}
function streamSource(stream, scope) {
    return {
        source: stream.signal ? scope.signalRef(stream.signal) : stream.scale ? scope.scaleRef(stream.scale) : parseStream(stream, scope)
    };
}
function mergeSources(sources) {
    return {
        signal: '[' + sources.map((s)=>s.scale ? 'scale("' + s.scale + '")' : s.signal) + ']'
    };
}
function parseSignalUpdates(signal, scope) {
    const op = scope.getSignal(signal.name);
    let expr = signal.update;
    if (signal.init) {
        if (expr) (0, _vegaUtil.error)('Signals can not include both init and update expressions.');
        else {
            expr = signal.init;
            op.initonly = true;
        }
    }
    if (expr) {
        expr = (0, _vegaFunctions.parseExpression)(expr, scope);
        op.update = expr.$expr;
        op.params = expr.$params;
    }
    if (signal.on) signal.on.forEach((_)=>parseUpdate(_, scope, op.id));
}
const transform = (name)=>(params, value, parent)=>entry(name, value, params || undefined, parent);
const Aggregate = transform('aggregate');
const AxisTicks = transform('axisticks');
const Bound = transform('bound');
const Collect = transform('collect');
const Compare = transform('compare');
const DataJoin = transform('datajoin');
const Encode = transform('encode');
const Expression = transform('expression');
const Facet = transform('facet');
const Field = transform('field');
const Key = transform('key');
const LegendEntries = transform('legendentries');
const Load = transform('load');
const Mark = transform('mark');
const MultiExtent = transform('multiextent');
const MultiValues = transform('multivalues');
const Overlap = transform('overlap');
const Params = transform('params');
const PreFacet = transform('prefacet');
const Projection = transform('projection');
const Proxy = transform('proxy');
const Relay = transform('relay');
const Render = transform('render');
const Scale = transform('scale');
const Sieve = transform('sieve');
const SortItems = transform('sortitems');
const ViewLayout = transform('viewlayout');
const Values = transform('values');
let FIELD_REF_ID = 0;
const MULTIDOMAIN_SORT_OPS = {
    min: 'min',
    max: 'max',
    count: 'sum'
};
function initScale(spec, scope) {
    const type = spec.type || 'linear';
    if (!(0, _vegaScale.isValidScaleType)(type)) (0, _vegaUtil.error)('Unrecognized scale type: ' + (0, _vegaUtil.stringValue)(type));
    scope.addScale(spec.name, {
        type,
        domain: undefined
    });
}
function parseScale(spec, scope) {
    const params = scope.getScale(spec.name).params;
    let key;
    params.domain = parseScaleDomain(spec.domain, spec, scope);
    if (spec.range != null) params.range = parseScaleRange(spec, scope, params);
    if (spec.interpolate != null) parseScaleInterpolate(spec.interpolate, params);
    if (spec.nice != null) params.nice = parseScaleNice(spec.nice, scope);
    if (spec.bins != null) params.bins = parseScaleBins(spec.bins, scope);
    for(key in spec){
        if ((0, _vegaUtil.hasOwnProperty)(params, key) || key === 'name') continue;
        params[key] = parseLiteral(spec[key], scope);
    }
}
function parseLiteral(v, scope) {
    return !(0, _vegaUtil.isObject)(v) ? v : v.signal ? scope.signalRef(v.signal) : (0, _vegaUtil.error)('Unsupported object: ' + (0, _vegaUtil.stringValue)(v));
}
function parseArray(v, scope) {
    return v.signal ? scope.signalRef(v.signal) : v.map((v)=>parseLiteral(v, scope));
}
function dataLookupError(name) {
    (0, _vegaUtil.error)('Can not find data set: ' + (0, _vegaUtil.stringValue)(name));
}
// -- SCALE DOMAIN ----
function parseScaleDomain(domain, spec, scope) {
    if (!domain) {
        if (spec.domainMin != null || spec.domainMax != null) (0, _vegaUtil.error)('No scale domain defined for domainMin/domainMax to override.');
        return; // default domain
    }
    return domain.signal ? scope.signalRef(domain.signal) : ((0, _vegaUtil.isArray)(domain) ? explicitDomain : domain.fields ? multipleDomain : singularDomain)(domain, spec, scope);
}
function explicitDomain(domain, spec, scope) {
    return domain.map((v)=>parseLiteral(v, scope));
}
function singularDomain(domain, spec, scope) {
    const data = scope.getData(domain.data);
    if (!data) dataLookupError(domain.data);
    return (0, _vegaScale.isDiscrete)(spec.type) ? data.valuesRef(scope, domain.field, parseSort(domain.sort, false)) : (0, _vegaScale.isQuantile)(spec.type) ? data.domainRef(scope, domain.field) : data.extentRef(scope, domain.field);
}
function multipleDomain(domain, spec, scope) {
    const data = domain.data, fields = domain.fields.reduce((dom, d)=>{
        d = (0, _vegaUtil.isString)(d) ? {
            data: data,
            field: d
        } : (0, _vegaUtil.isArray)(d) || d.signal ? fieldRef(d, scope) : d;
        dom.push(d);
        return dom;
    }, []);
    return ((0, _vegaScale.isDiscrete)(spec.type) ? ordinalMultipleDomain : (0, _vegaScale.isQuantile)(spec.type) ? quantileMultipleDomain : numericMultipleDomain)(domain, scope, fields);
}
function fieldRef(data, scope) {
    const name = '_:vega:_' + FIELD_REF_ID++, coll = Collect({});
    if ((0, _vegaUtil.isArray)(data)) coll.value = {
        $ingest: data
    };
    else if (data.signal) {
        const code = 'setdata(' + (0, _vegaUtil.stringValue)(name) + ',' + data.signal + ')';
        coll.params.input = scope.signalRef(code);
    }
    scope.addDataPipeline(name, [
        coll,
        Sieve({})
    ]);
    return {
        data: name,
        field: 'data'
    };
}
function ordinalMultipleDomain(domain, scope, fields) {
    const sort = parseSort(domain.sort, true);
    let a, v;
    // get value counts for each domain field
    const counts = fields.map((f)=>{
        const data = scope.getData(f.data);
        if (!data) dataLookupError(f.data);
        return data.countsRef(scope, f.field, sort);
    });
    // aggregate the results from each domain field
    const p = {
        groupby: keyFieldRef,
        pulse: counts
    };
    if (sort) {
        a = sort.op || 'count';
        v = sort.field ? aggrField(a, sort.field) : 'count';
        p.ops = [
            MULTIDOMAIN_SORT_OPS[a]
        ];
        p.fields = [
            scope.fieldRef(v)
        ];
        p.as = [
            v
        ];
    }
    a = scope.add(Aggregate(p));
    // collect aggregate output
    const c = scope.add(Collect({
        pulse: ref(a)
    }));
    // extract values for combined domain
    v = scope.add(Values({
        field: keyFieldRef,
        sort: scope.sortRef(sort),
        pulse: ref(c)
    }));
    return ref(v);
}
function parseSort(sort, multidomain) {
    if (sort) {
        if (!sort.field && !sort.op) {
            if ((0, _vegaUtil.isObject)(sort)) sort.field = 'key';
            else sort = {
                field: 'key'
            };
        } else if (!sort.field && sort.op !== 'count') (0, _vegaUtil.error)('No field provided for sort aggregate op: ' + sort.op);
        else if (multidomain && sort.field) {
            if (sort.op && !MULTIDOMAIN_SORT_OPS[sort.op]) (0, _vegaUtil.error)('Multiple domain scales can not be sorted using ' + sort.op);
        }
    }
    return sort;
}
function quantileMultipleDomain(domain, scope, fields) {
    // get value arrays for each domain field
    const values = fields.map((f)=>{
        const data = scope.getData(f.data);
        if (!data) dataLookupError(f.data);
        return data.domainRef(scope, f.field);
    });
    // combine value arrays
    return ref(scope.add(MultiValues({
        values: values
    })));
}
function numericMultipleDomain(domain, scope, fields) {
    // get extents for each domain field
    const extents = fields.map((f)=>{
        const data = scope.getData(f.data);
        if (!data) dataLookupError(f.data);
        return data.extentRef(scope, f.field);
    });
    // combine extents
    return ref(scope.add(MultiExtent({
        extents: extents
    })));
}
// -- SCALE BINS -----
function parseScaleBins(v, scope) {
    return v.signal || (0, _vegaUtil.isArray)(v) ? parseArray(v, scope) : scope.objectProperty(v);
}
// -- SCALE NICE -----
function parseScaleNice(nice, scope) {
    return nice.signal ? scope.signalRef(nice.signal) : (0, _vegaUtil.isObject)(nice) ? {
        interval: parseLiteral(nice.interval),
        step: parseLiteral(nice.step)
    } : parseLiteral(nice);
}
// -- SCALE INTERPOLATION -----
function parseScaleInterpolate(interpolate, params) {
    params.interpolate = parseLiteral(interpolate.type || interpolate);
    if (interpolate.gamma != null) params.interpolateGamma = parseLiteral(interpolate.gamma);
}
// -- SCALE RANGE -----
function parseScaleRange(spec, scope, params) {
    const config = scope.config.range;
    let range = spec.range;
    if (range.signal) return scope.signalRef(range.signal);
    else if ((0, _vegaUtil.isString)(range)) {
        if (config && (0, _vegaUtil.hasOwnProperty)(config, range)) {
            spec = (0, _vegaUtil.extend)({}, spec, {
                range: config[range]
            });
            return parseScaleRange(spec, scope, params);
        } else if (range === 'width') range = [
            0,
            {
                signal: 'width'
            }
        ];
        else if (range === 'height') range = (0, _vegaScale.isDiscrete)(spec.type) ? [
            0,
            {
                signal: 'height'
            }
        ] : [
            {
                signal: 'height'
            },
            0
        ];
        else (0, _vegaUtil.error)('Unrecognized scale range value: ' + (0, _vegaUtil.stringValue)(range));
    } else if (range.scheme) {
        params.scheme = (0, _vegaUtil.isArray)(range.scheme) ? parseArray(range.scheme, scope) : parseLiteral(range.scheme, scope);
        if (range.extent) params.schemeExtent = parseArray(range.extent, scope);
        if (range.count) params.schemeCount = parseLiteral(range.count, scope);
        return;
    } else if (range.step) {
        params.rangeStep = parseLiteral(range.step, scope);
        return;
    } else if ((0, _vegaScale.isDiscrete)(spec.type) && !(0, _vegaUtil.isArray)(range)) return parseScaleDomain(range, spec, scope);
    else if (!(0, _vegaUtil.isArray)(range)) (0, _vegaUtil.error)('Unsupported range type: ' + (0, _vegaUtil.stringValue)(range));
    return range.map((v)=>((0, _vegaUtil.isArray)(v) ? parseArray : parseLiteral)(v, scope));
}
function parseProjection(proj, scope) {
    const config = scope.config.projection || {}, params = {};
    for(const name in proj){
        if (name === 'name') continue;
        params[name] = parseParameter$1(proj[name], name, scope);
    }
    // apply projection defaults from config
    for(const name in config)if (params[name] == null) params[name] = parseParameter$1(config[name], name, scope);
    scope.addProjection(proj.name, params);
}
function parseParameter$1(_, name, scope) {
    return (0, _vegaUtil.isArray)(_) ? _.map((_)=>parseParameter$1(_, name, scope)) : !(0, _vegaUtil.isObject)(_) ? _ : _.signal ? scope.signalRef(_.signal) : name === 'fit' ? _ : (0, _vegaUtil.error)('Unsupported parameter object: ' + (0, _vegaUtil.stringValue)(_));
}
const Top = 'top';
const Left = 'left';
const Right = 'right';
const Bottom = 'bottom';
const Center = 'center';
const Vertical = 'vertical';
const Start = 'start';
const Middle = 'middle';
const End = 'end';
const Index = 'index';
const Label = 'label';
const Offset = 'offset';
const Perc = 'perc';
const Perc2 = 'perc2';
const Value = 'value';
const GuideLabelStyle = 'guide-label';
const GuideTitleStyle = 'guide-title';
const GroupTitleStyle = 'group-title';
const GroupSubtitleStyle = 'group-subtitle';
/** All values of LegendType */ const Symbols = 'symbol';
const Gradient = 'gradient';
const Discrete = 'discrete';
const Size = 'size';
const Shape = 'shape';
const Fill = 'fill';
const Stroke = 'stroke';
const StrokeWidth = 'strokeWidth';
const StrokeDash = 'strokeDash';
const Opacity = 'opacity';
// Encoding channels supported by legends
// In priority order of 'canonical' scale
const LegendScales = [
    Size,
    Shape,
    Fill,
    Stroke,
    StrokeWidth,
    StrokeDash,
    Opacity
];
const Skip = {
    name: 1,
    style: 1,
    interactive: 1
};
const zero = {
    value: 0
};
const one = {
    value: 1
};
const GroupMark = 'group';
const RectMark = 'rect';
const RuleMark = 'rule';
const SymbolMark = 'symbol';
const TextMark = 'text';
function guideGroup(mark) {
    mark.type = GroupMark;
    mark.interactive = mark.interactive || false;
    return mark;
}
function lookup(spec, config) {
    const _ = (name, dflt)=>value(spec[name], value(config[name], dflt));
    _.isVertical = (s)=>Vertical === value(spec.direction, config.direction || (s ? config.symbolDirection : config.gradientDirection));
    _.gradientLength = ()=>value(spec.gradientLength, config.gradientLength || config.gradientWidth);
    _.gradientThickness = ()=>value(spec.gradientThickness, config.gradientThickness || config.gradientHeight);
    _.entryColumns = ()=>value(spec.columns, value(config.columns, +_.isVertical(true)));
    return _;
}
function getEncoding(name, encode) {
    const v = encode && (encode.update && encode.update[name] || encode.enter && encode.enter[name]);
    return v && v.signal ? v : v ? v.value : null;
}
function getStyle(name, scope, style) {
    const s = scope.config.style[style];
    return s && s[name];
}
function anchorExpr(s, e, m) {
    return `item.anchor === '${Start}' ? ${s} : item.anchor === '${End}' ? ${e} : ${m}`;
}
const alignExpr$1 = anchorExpr((0, _vegaUtil.stringValue)(Left), (0, _vegaUtil.stringValue)(Right), (0, _vegaUtil.stringValue)(Center));
function tickBand(_) {
    const v = _('tickBand');
    let offset = _('tickOffset'), band, extra;
    if (!v) {
        // if no tick band entry, fall back on other properties
        band = _('bandPosition');
        extra = _('tickExtra');
    } else if (v.signal) {
        // if signal, augment code to interpret values
        band = {
            signal: `(${v.signal}) === 'extent' ? 1 : 0.5`
        };
        extra = {
            signal: `(${v.signal}) === 'extent'`
        };
        if (!(0, _vegaUtil.isObject)(offset)) offset = {
            signal: `(${v.signal}) === 'extent' ? 0 : ${offset}`
        };
    } else if (v === 'extent') {
        // if constant, simply set values
        band = 1;
        extra = true;
        offset = 0;
    } else {
        band = 0.5;
        extra = false;
    }
    return {
        extra,
        band,
        offset
    };
}
function extendOffset(value, offset) {
    return !offset ? value : !value ? offset : !(0, _vegaUtil.isObject)(value) ? {
        value,
        offset
    } : Object.assign({}, value, {
        offset: extendOffset(value.offset, offset)
    });
}
function guideMark(mark, extras) {
    if (extras) {
        mark.name = extras.name;
        mark.style = extras.style || mark.style;
        mark.interactive = !!extras.interactive;
        mark.encode = extendEncode(mark.encode, extras, Skip);
    } else mark.interactive = false;
    return mark;
}
function legendGradient(spec, scale, config, userEncode) {
    const _ = lookup(spec, config), vertical = _.isVertical(), thickness = _.gradientThickness(), length = _.gradientLength();
    let enter, start, stop, width, height;
    if (vertical) {
        start = [
            0,
            1
        ];
        stop = [
            0,
            0
        ];
        width = thickness;
        height = length;
    } else {
        start = [
            0,
            0
        ];
        stop = [
            1,
            0
        ];
        width = length;
        height = thickness;
    }
    const encode = {
        enter: enter = {
            opacity: zero,
            x: zero,
            y: zero,
            width: encoder(width),
            height: encoder(height)
        },
        update: (0, _vegaUtil.extend)({}, enter, {
            opacity: one,
            fill: {
                gradient: scale,
                start: start,
                stop: stop
            }
        }),
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('gradientStrokeColor'),
        strokeWidth: _('gradientStrokeWidth')
    }, {
        // update
        opacity: _('gradientOpacity')
    });
    return guideMark({
        type: RectMark,
        role: LegendGradientRole,
        encode
    }, userEncode);
}
function legendGradientDiscrete(spec, scale, config, userEncode, dataRef) {
    const _ = lookup(spec, config), vertical = _.isVertical(), thickness = _.gradientThickness(), length = _.gradientLength();
    let u, v, uu, vv, adjust = '';
    vertical ? (u = 'y', uu = 'y2', v = 'x', vv = 'width', adjust = '1-') : (u = 'x', uu = 'x2', v = 'y', vv = 'height');
    const enter = {
        opacity: zero,
        fill: {
            scale: scale,
            field: Value
        }
    };
    enter[u] = {
        signal: adjust + 'datum.' + Perc,
        mult: length
    };
    enter[v] = zero;
    enter[uu] = {
        signal: adjust + 'datum.' + Perc2,
        mult: length
    };
    enter[vv] = encoder(thickness);
    const encode = {
        enter: enter,
        update: (0, _vegaUtil.extend)({}, enter, {
            opacity: one
        }),
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('gradientStrokeColor'),
        strokeWidth: _('gradientStrokeWidth')
    }, {
        // update
        opacity: _('gradientOpacity')
    });
    return guideMark({
        type: RectMark,
        role: LegendBandRole,
        key: Value,
        from: dataRef,
        encode
    }, userEncode);
}
const alignExpr = `datum.${Perc}<=0?"${Left}":datum.${Perc}>=1?"${Right}":"${Center}"`, baselineExpr = `datum.${Perc}<=0?"${Bottom}":datum.${Perc}>=1?"${Top}":"${Middle}"`;
function legendGradientLabels(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config), vertical = _.isVertical(), thickness = encoder(_.gradientThickness()), length = _.gradientLength();
    let overlap = _('labelOverlap'), enter, update, u, v, adjust = '';
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one,
            text: {
                field: Label
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        fill: _('labelColor'),
        fillOpacity: _('labelOpacity'),
        font: _('labelFont'),
        fontSize: _('labelFontSize'),
        fontStyle: _('labelFontStyle'),
        fontWeight: _('labelFontWeight'),
        limit: value(spec.labelLimit, config.gradientLabelLimit)
    });
    if (vertical) {
        enter.align = {
            value: 'left'
        };
        enter.baseline = update.baseline = {
            signal: baselineExpr
        };
        u = 'y';
        v = 'x';
        adjust = '1-';
    } else {
        enter.align = update.align = {
            signal: alignExpr
        };
        enter.baseline = {
            value: 'top'
        };
        u = 'x';
        v = 'y';
    }
    enter[u] = update[u] = {
        signal: adjust + 'datum.' + Perc,
        mult: length
    };
    enter[v] = update[v] = thickness;
    thickness.offset = value(spec.labelOffset, config.gradientLabelOffset) || 0;
    overlap = overlap ? {
        separation: _('labelSeparation'),
        method: overlap,
        order: 'datum.' + Index
    } : undefined;
    // type, role, style, key, dataRef, encode, extras
    return guideMark({
        type: TextMark,
        role: LegendLabelRole,
        style: GuideLabelStyle,
        key: Value,
        from: dataRef,
        encode,
        overlap
    }, userEncode);
}
// userEncode is top-level, includes entries, symbols, labels
function legendSymbolGroups(spec, config, userEncode, dataRef, columns) {
    const _ = lookup(spec, config), entries = userEncode.entries, interactive = !!(entries && entries.interactive), name = entries ? entries.name : undefined, height = _('clipHeight'), symbolOffset = _('symbolOffset'), valueRef = {
        data: 'value'
    }, xSignal = `(${columns}) ? datum.${Offset} : datum.${Size}`, yEncode = height ? encoder(height) : {
        field: Size
    }, index = `datum.${Index}`, ncols = `max(1, ${columns})`;
    let encode, enter, update, nrows, sort;
    yEncode.mult = 0.5;
    // -- LEGEND SYMBOLS --
    encode = {
        enter: enter = {
            opacity: zero,
            x: {
                signal: xSignal,
                mult: 0.5,
                offset: symbolOffset
            },
            y: yEncode
        },
        update: update = {
            opacity: one,
            x: enter.x,
            y: enter.y
        },
        exit: {
            opacity: zero
        }
    };
    let baseFill = null, baseStroke = null;
    if (!spec.fill) {
        baseFill = config.symbolBaseFillColor;
        baseStroke = config.symbolBaseStrokeColor;
    }
    addEncoders(encode, {
        fill: _('symbolFillColor', baseFill),
        shape: _('symbolType'),
        size: _('symbolSize'),
        stroke: _('symbolStrokeColor', baseStroke),
        strokeDash: _('symbolDash'),
        strokeDashOffset: _('symbolDashOffset'),
        strokeWidth: _('symbolStrokeWidth')
    }, {
        // update
        opacity: _('symbolOpacity')
    });
    LegendScales.forEach((scale)=>{
        if (spec[scale]) update[scale] = enter[scale] = {
            scale: spec[scale],
            field: Value
        };
    });
    const symbols = guideMark({
        type: SymbolMark,
        role: LegendSymbolRole,
        key: Value,
        from: valueRef,
        clip: height ? true : undefined,
        encode
    }, userEncode.symbols);
    // -- LEGEND LABELS --
    const labelOffset = encoder(symbolOffset);
    labelOffset.offset = _('labelOffset');
    encode = {
        enter: enter = {
            opacity: zero,
            x: {
                signal: xSignal,
                offset: labelOffset
            },
            y: yEncode
        },
        update: update = {
            opacity: one,
            text: {
                field: Label
            },
            x: enter.x,
            y: enter.y
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        align: _('labelAlign'),
        baseline: _('labelBaseline'),
        fill: _('labelColor'),
        fillOpacity: _('labelOpacity'),
        font: _('labelFont'),
        fontSize: _('labelFontSize'),
        fontStyle: _('labelFontStyle'),
        fontWeight: _('labelFontWeight'),
        limit: _('labelLimit')
    });
    const labels = guideMark({
        type: TextMark,
        role: LegendLabelRole,
        style: GuideLabelStyle,
        key: Value,
        from: valueRef,
        encode
    }, userEncode.labels);
    // -- LEGEND ENTRY GROUPS --
    encode = {
        enter: {
            noBound: {
                value: !height
            },
            // ignore width/height in bounds calc
            width: zero,
            height: height ? encoder(height) : zero,
            opacity: zero
        },
        exit: {
            opacity: zero
        },
        update: update = {
            opacity: one,
            row: {
                signal: null
            },
            column: {
                signal: null
            }
        }
    };
    // annotate and sort groups to ensure correct ordering
    if (_.isVertical(true)) {
        nrows = `ceil(item.mark.items.length / ${ncols})`;
        update.row.signal = `${index}%${nrows}`;
        update.column.signal = `floor(${index} / ${nrows})`;
        sort = {
            field: [
                'row',
                index
            ]
        };
    } else {
        update.row.signal = `floor(${index} / ${ncols})`;
        update.column.signal = `${index} % ${ncols}`;
        sort = {
            field: index
        };
    }
    // handle zero column case (implies infinite columns)
    update.column.signal = `(${columns})?${update.column.signal}:${index}`;
    // facet legend entries into sub-groups
    dataRef = {
        facet: {
            data: dataRef,
            name: 'value',
            groupby: Index
        }
    };
    return guideGroup({
        role: ScopeRole,
        from: dataRef,
        encode: extendEncode(encode, entries, Skip),
        marks: [
            symbols,
            labels
        ],
        name,
        interactive,
        sort
    });
}
function legendSymbolLayout(spec, config) {
    const _ = lookup(spec, config);
    // layout parameters for legend entries
    return {
        align: _('gridAlign'),
        columns: _.entryColumns(),
        center: {
            row: true,
            column: false
        },
        padding: {
            row: _('rowPadding'),
            column: _('columnPadding')
        }
    };
}
// expression logic for align, anchor, angle, and baseline calculation
const isL = 'item.orient === "left"', isR = 'item.orient === "right"', isLR = `(${isL} || ${isR})`, isVG = `datum.vgrad && ${isLR}`, baseline = anchorExpr('"top"', '"bottom"', '"middle"'), alignFlip = anchorExpr('"right"', '"left"', '"center"'), exprAlign = `datum.vgrad && ${isR} ? (${alignFlip}) : (${isLR} && !(datum.vgrad && ${isL})) ? "left" : ${alignExpr$1}`, exprAnchor = `item._anchor || (${isLR} ? "middle" : "start")`, exprAngle = `${isVG} ? (${isL} ? -90 : 90) : 0`, exprBaseline = `${isLR} ? (datum.vgrad ? (${isR} ? "bottom" : "top") : ${baseline}) : "top"`;
function legendTitle(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config);
    const encode = {
        enter: {
            opacity: zero
        },
        update: {
            opacity: one,
            x: {
                field: {
                    group: 'padding'
                }
            },
            y: {
                field: {
                    group: 'padding'
                }
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        orient: _('titleOrient'),
        _anchor: _('titleAnchor'),
        anchor: {
            signal: exprAnchor
        },
        angle: {
            signal: exprAngle
        },
        align: {
            signal: exprAlign
        },
        baseline: {
            signal: exprBaseline
        },
        text: spec.title,
        fill: _('titleColor'),
        fillOpacity: _('titleOpacity'),
        font: _('titleFont'),
        fontSize: _('titleFontSize'),
        fontStyle: _('titleFontStyle'),
        fontWeight: _('titleFontWeight'),
        limit: _('titleLimit'),
        lineHeight: _('titleLineHeight')
    }, {
        // require update
        align: _('titleAlign'),
        baseline: _('titleBaseline')
    });
    return guideMark({
        type: TextMark,
        role: LegendTitleRole,
        style: GuideTitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function clip(clip, scope) {
    let expr;
    if ((0, _vegaUtil.isObject)(clip)) {
        if (clip.signal) expr = clip.signal;
        else if (clip.path) expr = 'pathShape(' + param(clip.path) + ')';
        else if (clip.sphere) expr = 'geoShape(' + param(clip.sphere) + ', {type: "Sphere"})';
    }
    return expr ? scope.signalRef(expr) : !!clip;
}
function param(value) {
    return (0, _vegaUtil.isObject)(value) && value.signal ? value.signal : (0, _vegaUtil.stringValue)(value);
}
function getRole(spec) {
    const role = spec.role || '';
    return role.startsWith('axis') || role.startsWith('legend') || role.startsWith('title') ? role : spec.type === GroupMark ? ScopeRole : role || MarkRole;
}
function definition(spec) {
    return {
        marktype: spec.type,
        name: spec.name || undefined,
        role: spec.role || getRole(spec),
        zindex: +spec.zindex || undefined,
        aria: spec.aria,
        description: spec.description
    };
}
function interactive(spec, scope) {
    return spec && spec.signal ? scope.signalRef(spec.signal) : spec === false ? false : true;
}
/**
 * Parse a data transform specification.
 */ function parseTransform(spec, scope) {
    const def = (0, _vegaDataflow.definition)(spec.type);
    if (!def) (0, _vegaUtil.error)('Unrecognized transform type: ' + (0, _vegaUtil.stringValue)(spec.type));
    const t = entry(def.type.toLowerCase(), null, parseParameters(def, spec, scope));
    if (spec.signal) scope.addSignal(spec.signal, scope.proxy(t));
    t.metadata = def.metadata || {};
    return t;
}
/**
 * Parse all parameters of a data transform.
 */ function parseParameters(def, spec, scope) {
    const params = {}, n = def.params.length;
    for(let i = 0; i < n; ++i){
        const pdef = def.params[i];
        params[pdef.name] = parseParameter(pdef, spec, scope);
    }
    return params;
}
/**
 * Parse a data transform parameter.
 */ function parseParameter(def, spec, scope) {
    const type = def.type, value = spec[def.name];
    if (type === 'index') return parseIndexParameter(def, spec, scope);
    else if (value === undefined) {
        if (def.required) (0, _vegaUtil.error)('Missing required ' + (0, _vegaUtil.stringValue)(spec.type) + ' parameter: ' + (0, _vegaUtil.stringValue)(def.name));
        return;
    } else if (type === 'param') return parseSubParameters(def, spec, scope);
    else if (type === 'projection') return scope.projectionRef(spec[def.name]);
    return def.array && !isSignal(value) ? value.map((v)=>parameterValue(def, v, scope)) : parameterValue(def, value, scope);
}
/**
 * Parse a single parameter value.
 */ function parameterValue(def, value, scope) {
    const type = def.type;
    if (isSignal(value)) return isExpr(type) ? (0, _vegaUtil.error)('Expression references can not be signals.') : isField(type) ? scope.fieldRef(value) : isCompare(type) ? scope.compareRef(value) : scope.signalRef(value.signal);
    else {
        const expr = def.expr || isField(type);
        return expr && outerExpr(value) ? scope.exprRef(value.expr, value.as) : expr && outerField(value) ? fieldRef$1(value.field, value.as) : isExpr(type) ? (0, _vegaFunctions.parseExpression)(value, scope) : isData(type) ? ref(scope.getData(value).values) : isField(type) ? fieldRef$1(value) : isCompare(type) ? scope.compareRef(value) : value;
    }
}
/**
 * Parse parameter for accessing an index of another data set.
 */ function parseIndexParameter(def, spec, scope) {
    if (!(0, _vegaUtil.isString)(spec.from)) (0, _vegaUtil.error)('Lookup "from" parameter must be a string literal.');
    return scope.getData(spec.from).lookupRef(scope, spec.key);
}
/**
 * Parse a parameter that contains one or more sub-parameter objects.
 */ function parseSubParameters(def, spec, scope) {
    const value = spec[def.name];
    if (def.array) {
        if (!(0, _vegaUtil.isArray)(value)) // signals not allowed!
        (0, _vegaUtil.error)('Expected an array of sub-parameters. Instead: ' + (0, _vegaUtil.stringValue)(value));
        return value.map((v)=>parseSubParameter(def, v, scope));
    } else return parseSubParameter(def, value, scope);
}
/**
 * Parse a sub-parameter object.
 */ function parseSubParameter(def, value, scope) {
    const n = def.params.length;
    let pdef;
    // loop over defs to find matching key
    for(let i = 0; i < n; ++i){
        pdef = def.params[i];
        for(const k in pdef.key)if (pdef.key[k] !== value[k]) {
            pdef = null;
            break;
        }
        if (pdef) break;
    }
    // raise error if matching key not found
    if (!pdef) (0, _vegaUtil.error)('Unsupported parameter: ' + (0, _vegaUtil.stringValue)(value));
    // parse params, create Params transform, return ref
    const params = (0, _vegaUtil.extend)(parseParameters(pdef, value, scope), pdef.key);
    return ref(scope.add(Params(params)));
}
// -- Utilities -----
const outerExpr = (_)=>_ && _.expr;
const outerField = (_)=>_ && _.field;
const isData = (_)=>_ === 'data';
const isExpr = (_)=>_ === 'expr';
const isField = (_)=>_ === 'field';
const isCompare = (_)=>_ === 'compare';
function parseData$1(from, group, scope) {
    let facet, key, op, dataRef, parent;
    // if no source data, generate singleton datum
    if (!from) dataRef = ref(scope.add(Collect(null, [
        {}
    ])));
    else if (facet = from.facet) {
        if (!group) (0, _vegaUtil.error)('Only group marks can be faceted.');
        // use pre-faceted source data, if available
        if (facet.field != null) dataRef = parent = getDataRef(facet, scope);
        else {
            // generate facet aggregates if no direct data specification
            if (!from.data) {
                op = parseTransform((0, _vegaUtil.extend)({
                    type: 'aggregate',
                    groupby: (0, _vegaUtil.array)(facet.groupby)
                }, facet.aggregate), scope);
                op.params.key = scope.keyRef(facet.groupby);
                op.params.pulse = getDataRef(facet, scope);
                dataRef = parent = ref(scope.add(op));
            } else parent = ref(scope.getData(from.data).aggregate);
            key = scope.keyRef(facet.groupby, true);
        }
    }
    // if not yet defined, get source data reference
    if (!dataRef) dataRef = getDataRef(from, scope);
    return {
        key: key,
        pulse: dataRef,
        parent: parent
    };
}
function getDataRef(from, scope) {
    return from.$ref ? from : from.data && from.data.$ref ? from.data : ref(scope.getData(from.data).output);
}
function DataScope(scope, input, output, values, aggr) {
    this.scope = scope; // parent scope object
    this.input = input; // first operator in pipeline (tuple input)
    this.output = output; // last operator in pipeline (tuple output)
    this.values = values; // operator for accessing tuples (but not tuple flow)
    // last aggregate in transform pipeline
    this.aggregate = aggr;
    // lookup table of field indices
    this.index = {};
}
DataScope.fromEntries = function(scope, entries) {
    const n = entries.length, values = entries[n - 1], output = entries[n - 2];
    let input = entries[0], aggr = null, i = 1;
    if (input && input.type === 'load') input = entries[1];
    // add operator entries to this scope, wire up pulse chain
    scope.add(entries[0]);
    for(; i < n; ++i){
        entries[i].params.pulse = ref(entries[i - 1]);
        scope.add(entries[i]);
        if (entries[i].type === 'aggregate') aggr = entries[i];
    }
    return new DataScope(scope, input, output, values, aggr);
};
function fieldKey(field) {
    return (0, _vegaUtil.isString)(field) ? field : null;
}
function addSortField(scope, p, sort) {
    const as = aggrField(sort.op, sort.field);
    let s;
    if (p.ops) for(let i = 0, n = p.as.length; i < n; ++i){
        if (p.as[i] === as) return;
    }
    else {
        p.ops = [
            'count'
        ];
        p.fields = [
            null
        ];
        p.as = [
            'count'
        ];
    }
    if (sort.op) {
        p.ops.push((s = sort.op.signal) ? scope.signalRef(s) : sort.op);
        p.fields.push(scope.fieldRef(sort.field));
        p.as.push(as);
    }
}
function cache(scope, ds, name, optype, field, counts, index) {
    const cache = ds[name] || (ds[name] = {}), sort = sortKey(counts);
    let k = fieldKey(field), v, op;
    if (k != null) {
        scope = ds.scope;
        k = k + (sort ? '|' + sort : '');
        v = cache[k];
    }
    if (!v) {
        const params = counts ? {
            field: keyFieldRef,
            pulse: ds.countsRef(scope, field, counts)
        } : {
            field: scope.fieldRef(field),
            pulse: ref(ds.output)
        };
        if (sort) params.sort = scope.sortRef(counts);
        op = scope.add(entry(optype, undefined, params));
        if (index) ds.index[field] = op;
        v = ref(op);
        if (k != null) cache[k] = v;
    }
    return v;
}
DataScope.prototype = {
    countsRef (scope, field, sort) {
        const ds = this, cache = ds.counts || (ds.counts = {}), k = fieldKey(field);
        let v, a, p;
        if (k != null) {
            scope = ds.scope;
            v = cache[k];
        }
        if (!v) {
            p = {
                groupby: scope.fieldRef(field, 'key'),
                pulse: ref(ds.output)
            };
            if (sort && sort.field) addSortField(scope, p, sort);
            a = scope.add(Aggregate(p));
            v = scope.add(Collect({
                pulse: ref(a)
            }));
            v = {
                agg: a,
                ref: ref(v)
            };
            if (k != null) cache[k] = v;
        } else if (sort && sort.field) addSortField(scope, v.agg.params, sort);
        return v.ref;
    },
    tuplesRef () {
        return ref(this.values);
    },
    extentRef (scope, field) {
        return cache(scope, this, 'extent', 'extent', field, false);
    },
    domainRef (scope, field) {
        return cache(scope, this, 'domain', 'values', field, false);
    },
    valuesRef (scope, field, sort) {
        return cache(scope, this, 'vals', 'values', field, sort || true);
    },
    lookupRef (scope, field) {
        return cache(scope, this, 'lookup', 'tupleindex', field, false);
    },
    indataRef (scope, field) {
        return cache(scope, this, 'indata', 'tupleindex', field, true, true);
    }
};
function parseFacet(spec, scope, group) {
    const facet = spec.from.facet, name = facet.name, data = getDataRef(facet, scope);
    let op;
    if (!facet.name) (0, _vegaUtil.error)('Facet must have a name: ' + (0, _vegaUtil.stringValue)(facet));
    if (!facet.data) (0, _vegaUtil.error)('Facet must reference a data set: ' + (0, _vegaUtil.stringValue)(facet));
    if (facet.field) op = scope.add(PreFacet({
        field: scope.fieldRef(facet.field),
        pulse: data
    }));
    else if (facet.groupby) op = scope.add(Facet({
        key: scope.keyRef(facet.groupby),
        group: ref(scope.proxy(group.parent)),
        pulse: data
    }));
    else (0, _vegaUtil.error)('Facet must specify groupby or field: ' + (0, _vegaUtil.stringValue)(facet));
    // initialize facet subscope
    const subscope = scope.fork(), source = subscope.add(Collect()), values = subscope.add(Sieve({
        pulse: ref(source)
    }));
    subscope.addData(name, new DataScope(subscope, source, source, values));
    subscope.addSignal('parent', null);
    // parse faceted subflow
    op.params.subflow = {
        $subflow: subscope.parse(spec).toRuntime()
    };
}
function parseSubflow(spec, scope, input) {
    const op = scope.add(PreFacet({
        pulse: input.pulse
    })), subscope = scope.fork();
    subscope.add(Sieve());
    subscope.addSignal('parent', null);
    // parse group mark subflow
    op.params.subflow = {
        $subflow: subscope.parse(spec).toRuntime()
    };
}
function parseTrigger(spec, scope, name) {
    const remove = spec.remove, insert = spec.insert, toggle = spec.toggle, modify = spec.modify, values = spec.values, op = scope.add(operator());
    const update = 'if(' + spec.trigger + ',modify("' + name + '",' + [
        insert,
        remove,
        toggle,
        modify,
        values
    ].map((_)=>_ == null ? 'null' : _).join(',') + '),0)';
    const expr = (0, _vegaFunctions.parseExpression)(update, scope);
    op.update = expr.$expr;
    op.params = expr.$params;
}
function parseMark(spec, scope) {
    const role = getRole(spec), group = spec.type === GroupMark, facet = spec.from && spec.from.facet, overlap = spec.overlap;
    let layout = spec.layout || role === ScopeRole || role === FrameRole, ops, op, store, enc, name, layoutRef, boundRef;
    const nested = role === MarkRole || layout || facet;
    // resolve input data
    const input = parseData$1(spec.from, group, scope);
    // data join to map tuples to visual items
    op = scope.add(DataJoin({
        key: input.key || (spec.key ? fieldRef$1(spec.key) : undefined),
        pulse: input.pulse,
        clean: !group
    }));
    const joinRef = ref(op);
    // collect visual items
    op = store = scope.add(Collect({
        pulse: joinRef
    }));
    // connect visual items to scenegraph
    op = scope.add(Mark({
        markdef: definition(spec),
        interactive: interactive(spec.interactive, scope),
        clip: clip(spec.clip, scope),
        context: {
            $context: true
        },
        groups: scope.lookup(),
        parent: scope.signals.parent ? scope.signalRef('parent') : null,
        index: scope.markpath(),
        pulse: ref(op)
    }));
    const markRef = ref(op);
    // add visual encoders
    op = enc = scope.add(Encode(parseEncode(spec.encode, spec.type, role, spec.style, scope, {
        mod: false,
        pulse: markRef
    })));
    // monitor parent marks to propagate changes
    op.params.parent = scope.encode();
    // add post-encoding transforms, if defined
    if (spec.transform) spec.transform.forEach((_)=>{
        const tx = parseTransform(_, scope), md = tx.metadata;
        if (md.generates || md.changes) (0, _vegaUtil.error)('Mark transforms should not generate new data.');
        if (!md.nomod) enc.params.mod = true; // update encode mod handling
        tx.params.pulse = ref(op);
        scope.add(op = tx);
    });
    // if item sort specified, perform post-encoding
    if (spec.sort) op = scope.add(SortItems({
        sort: scope.compareRef(spec.sort),
        pulse: ref(op)
    }));
    const encodeRef = ref(op);
    // add view layout operator if needed
    if (facet || layout) {
        layout = scope.add(ViewLayout({
            layout: scope.objectProperty(spec.layout),
            legends: scope.legends,
            mark: markRef,
            pulse: encodeRef
        }));
        layoutRef = ref(layout);
    }
    // compute bounding boxes
    const bound = scope.add(Bound({
        mark: markRef,
        pulse: layoutRef || encodeRef
    }));
    boundRef = ref(bound);
    // if group mark, recurse to parse nested content
    if (group) {
        // juggle layout & bounds to ensure they run *after* any faceting transforms
        if (nested) {
            ops = scope.operators;
            ops.pop();
            if (layout) ops.pop();
        }
        scope.pushState(encodeRef, layoutRef || boundRef, joinRef);
        facet ? parseFacet(spec, scope, input) // explicit facet
         : nested ? parseSubflow(spec, scope, input) // standard mark group
         : scope.parse(spec); // guide group, we can avoid nested scopes
        scope.popState();
        if (nested) {
            if (layout) ops.push(layout);
            ops.push(bound);
        }
    }
    // if requested, add overlap removal transform
    if (overlap) boundRef = parseOverlap(overlap, boundRef, scope);
    // render / sieve items
    const render = scope.add(Render({
        pulse: boundRef
    })), sieve = scope.add(Sieve({
        pulse: ref(render)
    }, undefined, scope.parent()));
    // if mark is named, make accessible as reactive geometry
    // add trigger updates if defined
    if (spec.name != null) {
        name = spec.name;
        scope.addData(name, new DataScope(scope, store, render, sieve));
        if (spec.on) spec.on.forEach((on)=>{
            if (on.insert || on.remove || on.toggle) (0, _vegaUtil.error)('Marks only support modify triggers.');
            parseTrigger(on, scope, name);
        });
    }
}
function parseOverlap(overlap, source, scope) {
    const method = overlap.method, bound = overlap.bound, sep = overlap.separation;
    const params = {
        separation: isSignal(sep) ? scope.signalRef(sep.signal) : sep,
        method: isSignal(method) ? scope.signalRef(method.signal) : method,
        pulse: source
    };
    if (overlap.order) params.sort = scope.compareRef({
        field: overlap.order
    });
    if (bound) {
        const tol = bound.tolerance;
        params.boundTolerance = isSignal(tol) ? scope.signalRef(tol.signal) : +tol;
        params.boundScale = scope.scaleRef(bound.scale);
        params.boundOrient = bound.orient;
    }
    return ref(scope.add(Overlap(params)));
}
function parseLegend(spec, scope) {
    const config = scope.config.legend, encode = spec.encode || {}, _ = lookup(spec, config), legendEncode = encode.legend || {}, name = legendEncode.name || undefined, interactive = legendEncode.interactive, style = legendEncode.style, scales = {};
    let scale = 0, entryLayout, params, children;
    // resolve scales and 'canonical' scale name
    LegendScales.forEach((s)=>spec[s] ? (scales[s] = spec[s], scale = scale || spec[s]) : 0);
    if (!scale) (0, _vegaUtil.error)('Missing valid scale for legend.');
    // resolve legend type (symbol, gradient, or discrete gradient)
    const type = legendType(spec, scope.scaleType(scale));
    // single-element data source for legend group
    const datum = {
        title: spec.title != null,
        scales: scales,
        type: type,
        vgrad: type !== 'symbol' && _.isVertical()
    };
    const dataRef = ref(scope.add(Collect(null, [
        datum
    ])));
    // encoding properties for legend entry sub-group
    const entryEncode = {
        enter: {
            x: {
                value: 0
            },
            y: {
                value: 0
            }
        }
    };
    // data source for legend values
    const entryRef = ref(scope.add(LegendEntries(params = {
        type: type,
        scale: scope.scaleRef(scale),
        count: scope.objectProperty(_('tickCount')),
        limit: scope.property(_('symbolLimit')),
        values: scope.objectProperty(spec.values),
        minstep: scope.property(spec.tickMinStep),
        formatType: scope.property(spec.formatType),
        formatSpecifier: scope.property(spec.format)
    })));
    // continuous gradient legend
    if (type === Gradient) {
        children = [
            legendGradient(spec, scale, config, encode.gradient),
            legendGradientLabels(spec, config, encode.labels, entryRef)
        ];
        // adjust default tick count based on the gradient length
        params.count = params.count || scope.signalRef(`max(2,2*floor((${deref(_.gradientLength())})/100))`);
    } else if (type === Discrete) children = [
        legendGradientDiscrete(spec, scale, config, encode.gradient, entryRef),
        legendGradientLabels(spec, config, encode.labels, entryRef)
    ];
    else {
        // determine legend symbol group layout
        entryLayout = legendSymbolLayout(spec, config);
        children = [
            legendSymbolGroups(spec, config, encode, entryRef, deref(entryLayout.columns))
        ];
        // pass symbol size information to legend entry generator
        params.size = sizeExpression(spec, scope, children[0].marks);
    }
    // generate legend marks
    children = [
        guideGroup({
            role: LegendEntryRole,
            from: dataRef,
            encode: entryEncode,
            marks: children,
            layout: entryLayout,
            interactive
        })
    ];
    // include legend title if defined
    if (datum.title) children.push(legendTitle(spec, config, encode.title, dataRef));
    // parse legend specification
    return parseMark(guideGroup({
        role: LegendRole,
        from: dataRef,
        encode: extendEncode(buildLegendEncode(_, spec, config), legendEncode, Skip),
        marks: children,
        aria: _('aria'),
        description: _('description'),
        zindex: _('zindex'),
        name,
        interactive,
        style
    }), scope);
}
function legendType(spec, scaleType) {
    let type = spec.type || Symbols;
    if (!spec.type && scaleCount(spec) === 1 && (spec.fill || spec.stroke)) type = (0, _vegaScale.isContinuous)(scaleType) ? Gradient : (0, _vegaScale.isDiscretizing)(scaleType) ? Discrete : Symbols;
    return type !== Gradient ? type : (0, _vegaScale.isDiscretizing)(scaleType) ? Discrete : Gradient;
}
function scaleCount(spec) {
    return LegendScales.reduce((count, type)=>count + (spec[type] ? 1 : 0), 0);
}
function buildLegendEncode(_, spec, config) {
    const encode = {
        enter: {},
        update: {}
    };
    addEncoders(encode, {
        orient: _('orient'),
        offset: _('offset'),
        padding: _('padding'),
        titlePadding: _('titlePadding'),
        cornerRadius: _('cornerRadius'),
        fill: _('fillColor'),
        stroke: _('strokeColor'),
        strokeWidth: config.strokeWidth,
        strokeDash: config.strokeDash,
        x: _('legendX'),
        y: _('legendY'),
        // accessibility support
        format: spec.format,
        formatType: spec.formatType
    });
    return encode;
}
function sizeExpression(spec, scope, marks) {
    const size = deref(getChannel('size', spec, marks)), strokeWidth = deref(getChannel('strokeWidth', spec, marks)), fontSize = deref(getFontSize(marks[1].encode, scope, GuideLabelStyle));
    return (0, _vegaFunctions.parseExpression)(`max(ceil(sqrt(${size})+${strokeWidth}),${fontSize})`, scope);
}
function getChannel(name, spec, marks) {
    return spec[name] ? `scale("${spec[name]}",datum)` : getEncoding(name, marks[0].encode);
}
function getFontSize(encode, scope, style) {
    return getEncoding('fontSize', encode) || getStyle('fontSize', scope, style);
}
const angleExpr = `item.orient==="${Left}"?-90:item.orient==="${Right}"?90:0`;
function parseTitle(spec, scope) {
    spec = (0, _vegaUtil.isString)(spec) ? {
        text: spec
    } : spec;
    const _ = lookup(spec, scope.config.title), encode = spec.encode || {}, userEncode = encode.group || {}, name = userEncode.name || undefined, interactive = userEncode.interactive, style = userEncode.style, children = [];
    // single-element data source for group title
    const datum = {}, dataRef = ref(scope.add(Collect(null, [
        datum
    ])));
    // include title text
    children.push(buildTitle(spec, _, titleEncode(spec), dataRef));
    // include subtitle text
    if (spec.subtitle) children.push(buildSubTitle(spec, _, encode.subtitle, dataRef));
    // parse title specification
    return parseMark(guideGroup({
        role: TitleRole,
        from: dataRef,
        encode: groupEncode(_, userEncode),
        marks: children,
        aria: _('aria'),
        description: _('description'),
        zindex: _('zindex'),
        name,
        interactive,
        style
    }), scope);
}
// provide backwards-compatibility for title custom encode;
// the top-level encode block has been *deprecated*.
function titleEncode(spec) {
    const encode = spec.encode;
    return encode && encode.title || (0, _vegaUtil.extend)({
        name: spec.name,
        interactive: spec.interactive,
        style: spec.style
    }, encode);
}
function groupEncode(_, userEncode) {
    const encode = {
        enter: {},
        update: {}
    };
    addEncoders(encode, {
        orient: _('orient'),
        anchor: _('anchor'),
        align: {
            signal: alignExpr$1
        },
        angle: {
            signal: angleExpr
        },
        limit: _('limit'),
        frame: _('frame'),
        offset: _('offset') || 0,
        padding: _('subtitlePadding')
    });
    return extendEncode(encode, userEncode, Skip);
}
function buildTitle(spec, _, userEncode, dataRef) {
    const zero = {
        value: 0
    }, text = spec.text, encode = {
        enter: {
            opacity: zero
        },
        update: {
            opacity: {
                value: 1
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        text: text,
        align: {
            signal: 'item.mark.group.align'
        },
        angle: {
            signal: 'item.mark.group.angle'
        },
        limit: {
            signal: 'item.mark.group.limit'
        },
        baseline: 'top',
        dx: _('dx'),
        dy: _('dy'),
        fill: _('color'),
        font: _('font'),
        fontSize: _('fontSize'),
        fontStyle: _('fontStyle'),
        fontWeight: _('fontWeight'),
        lineHeight: _('lineHeight')
    }, {
        // update
        align: _('align'),
        angle: _('angle'),
        baseline: _('baseline')
    });
    return guideMark({
        type: TextMark,
        role: TitleTextRole,
        style: GroupTitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function buildSubTitle(spec, _, userEncode, dataRef) {
    const zero = {
        value: 0
    }, text = spec.subtitle, encode = {
        enter: {
            opacity: zero
        },
        update: {
            opacity: {
                value: 1
            }
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        text: text,
        align: {
            signal: 'item.mark.group.align'
        },
        angle: {
            signal: 'item.mark.group.angle'
        },
        limit: {
            signal: 'item.mark.group.limit'
        },
        baseline: 'top',
        dx: _('dx'),
        dy: _('dy'),
        fill: _('subtitleColor'),
        font: _('subtitleFont'),
        fontSize: _('subtitleFontSize'),
        fontStyle: _('subtitleFontStyle'),
        fontWeight: _('subtitleFontWeight'),
        lineHeight: _('subtitleLineHeight')
    }, {
        // update
        align: _('align'),
        angle: _('angle'),
        baseline: _('baseline')
    });
    return guideMark({
        type: TextMark,
        role: TitleSubtitleRole,
        style: GroupSubtitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function parseData(data, scope) {
    const transforms = [];
    if (data.transform) data.transform.forEach((tx)=>{
        transforms.push(parseTransform(tx, scope));
    });
    if (data.on) data.on.forEach((on)=>{
        parseTrigger(on, scope, data.name);
    });
    scope.addDataPipeline(data.name, analyze(data, scope, transforms));
}
/**
 * Analyze a data pipeline, add needed operators.
 */ function analyze(data, scope, ops) {
    const output = [];
    let source = null, modify = false, generate = false, upstream, i, n, t, m;
    if (data.values) {
        // hard-wired input data set
        if (isSignal(data.values) || hasSignal(data.format)) {
            // if either values is signal or format has signal, use dynamic loader
            output.push(load(scope, data));
            output.push(source = collect());
        } else // otherwise, ingest upon dataflow init
        output.push(source = collect({
            $ingest: data.values,
            $format: data.format
        }));
    } else if (data.url) {
        // load data from external source
        if (hasSignal(data.url) || hasSignal(data.format)) {
            // if either url or format has signal, use dynamic loader
            output.push(load(scope, data));
            output.push(source = collect());
        } else // otherwise, request load upon dataflow init
        output.push(source = collect({
            $request: data.url,
            $format: data.format
        }));
    } else if (data.source) {
        // derives from one or more other data sets
        source = upstream = (0, _vegaUtil.array)(data.source).map((d)=>ref(scope.getData(d).output));
        output.push(null); // populate later
    }
    // scan data transforms, add collectors as needed
    for(i = 0, n = ops.length; i < n; ++i){
        t = ops[i];
        m = t.metadata;
        if (!source && !m.source) output.push(source = collect());
        output.push(t);
        if (m.generates) generate = true;
        if (m.modifies && !generate) modify = true;
        if (m.source) source = t;
        else if (m.changes) source = null;
    }
    if (upstream) {
        n = upstream.length - 1;
        output[0] = Relay({
            derive: modify,
            pulse: n ? upstream : upstream[0]
        });
        if (modify || n) // collect derived and multi-pulse tuples
        output.splice(1, 0, collect());
    }
    if (!source) output.push(collect());
    output.push(Sieve({}));
    return output;
}
function collect(values) {
    const s = Collect({}, values);
    s.metadata = {
        source: true
    };
    return s;
}
function load(scope, data) {
    return Load({
        url: data.url ? scope.property(data.url) : undefined,
        async: data.async ? scope.property(data.async) : undefined,
        values: data.values ? scope.property(data.values) : undefined,
        format: scope.objectProperty(data.format)
    });
}
const isX = (orient)=>orient === Bottom || orient === Top;
// get sign coefficient based on axis orient
const getSign = (orient, a, b)=>isSignal(orient) ? ifLeftTopExpr(orient.signal, a, b) : orient === Left || orient === Top ? a : b;
// condition on axis x-direction
const ifX = (orient, a, b)=>isSignal(orient) ? ifXEnc(orient.signal, a, b) : isX(orient) ? a : b;
// condition on axis y-direction
const ifY = (orient, a, b)=>isSignal(orient) ? ifYEnc(orient.signal, a, b) : isX(orient) ? b : a;
const ifTop = (orient, a, b)=>isSignal(orient) ? ifTopExpr(orient.signal, a, b) : orient === Top ? {
        value: a
    } : {
        value: b
    };
const ifRight = (orient, a, b)=>isSignal(orient) ? ifRightExpr(orient.signal, a, b) : orient === Right ? {
        value: a
    } : {
        value: b
    };
const ifXEnc = ($orient, a, b)=>ifEnc(`${$orient} === '${Top}' || ${$orient} === '${Bottom}'`, a, b);
const ifYEnc = ($orient, a, b)=>ifEnc(`${$orient} !== '${Top}' && ${$orient} !== '${Bottom}'`, a, b);
const ifLeftTopExpr = ($orient, a, b)=>ifExpr(`${$orient} === '${Left}' || ${$orient} === '${Top}'`, a, b);
const ifTopExpr = ($orient, a, b)=>ifExpr(`${$orient} === '${Top}'`, a, b);
const ifRightExpr = ($orient, a, b)=>ifExpr(`${$orient} === '${Right}'`, a, b);
const ifEnc = (test, a, b)=>{
    // ensure inputs are encoder objects (or null)
    a = a != null ? encoder(a) : a;
    b = b != null ? encoder(b) : b;
    if (isSimple(a) && isSimple(b)) {
        // if possible generate simple signal expression
        a = a ? a.signal || (0, _vegaUtil.stringValue)(a.value) : null;
        b = b ? b.signal || (0, _vegaUtil.stringValue)(b.value) : null;
        return {
            signal: `${test} ? (${a}) : (${b})`
        };
    } else // otherwise generate rule set
    return [
        (0, _vegaUtil.extend)({
            test
        }, a)
    ].concat(b || []);
};
const isSimple = (enc)=>enc == null || Object.keys(enc).length === 1;
const ifExpr = (test, a, b)=>({
        signal: `${test} ? (${toExpr(a)}) : (${toExpr(b)})`
    });
const ifOrient = ($orient, t, b, l, r)=>({
        signal: (l != null ? `${$orient} === '${Left}' ? (${toExpr(l)}) : ` : '') + (b != null ? `${$orient} === '${Bottom}' ? (${toExpr(b)}) : ` : '') + (r != null ? `${$orient} === '${Right}' ? (${toExpr(r)}) : ` : '') + (t != null ? `${$orient} === '${Top}' ? (${toExpr(t)}) : ` : '') + '(null)'
    });
const toExpr = (v)=>isSignal(v) ? v.signal : v == null ? null : (0, _vegaUtil.stringValue)(v);
const mult = (sign, value)=>value === 0 ? 0 : isSignal(sign) ? {
        signal: `(${sign.signal}) * ${value}`
    } : {
        value: sign * value
    };
const patch = (value, base)=>{
    const s = value.signal;
    return s && s.endsWith('(null)') ? {
        signal: s.slice(0, -6) + base.signal
    } : value;
};
function fallback(prop, config, axisConfig, style) {
    let styleProp;
    if (config && (0, _vegaUtil.hasOwnProperty)(config, prop)) return config[prop];
    else if ((0, _vegaUtil.hasOwnProperty)(axisConfig, prop)) return axisConfig[prop];
    else if (prop.startsWith('title')) {
        switch(prop){
            case 'titleColor':
                styleProp = 'fill';
                break;
            case 'titleFont':
            case 'titleFontSize':
            case 'titleFontWeight':
                styleProp = prop[5].toLowerCase() + prop.slice(6);
        }
        return style[GuideTitleStyle][styleProp];
    } else if (prop.startsWith('label')) {
        switch(prop){
            case 'labelColor':
                styleProp = 'fill';
                break;
            case 'labelFont':
            case 'labelFontSize':
                styleProp = prop[5].toLowerCase() + prop.slice(6);
        }
        return style[GuideLabelStyle][styleProp];
    }
    return null;
}
function keys(objects) {
    const map = {};
    for (const obj of objects){
        if (!obj) continue;
        for(const key in obj)map[key] = 1;
    }
    return Object.keys(map);
}
function axisConfig(spec, scope) {
    var config = scope.config, style = config.style, axis = config.axis, band = scope.scaleType(spec.scale) === 'band' && config.axisBand, orient = spec.orient, xy, or, key;
    if (isSignal(orient)) {
        const xyKeys = keys([
            config.axisX,
            config.axisY
        ]), orientKeys = keys([
            config.axisTop,
            config.axisBottom,
            config.axisLeft,
            config.axisRight
        ]);
        xy = {};
        for (key of xyKeys)xy[key] = ifX(orient, fallback(key, config.axisX, axis, style), fallback(key, config.axisY, axis, style));
        or = {};
        for (key of orientKeys)or[key] = ifOrient(orient.signal, fallback(key, config.axisTop, axis, style), fallback(key, config.axisBottom, axis, style), fallback(key, config.axisLeft, axis, style), fallback(key, config.axisRight, axis, style));
    } else {
        xy = orient === Top || orient === Bottom ? config.axisX : config.axisY;
        or = config['axis' + orient[0].toUpperCase() + orient.slice(1)];
    }
    const result = xy || or || band ? (0, _vegaUtil.extend)({}, axis, xy, or, band) : axis;
    return result;
}
function axisDomain(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config), orient = spec.orient;
    let enter, update;
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one
        },
        exit: {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('domainColor'),
        strokeCap: _('domainCap'),
        strokeDash: _('domainDash'),
        strokeDashOffset: _('domainDashOffset'),
        strokeWidth: _('domainWidth'),
        strokeOpacity: _('domainOpacity')
    });
    const pos0 = position(spec, 0);
    const pos1 = position(spec, 1);
    enter.x = update.x = ifX(orient, pos0, zero);
    enter.x2 = update.x2 = ifX(orient, pos1);
    enter.y = update.y = ifY(orient, pos0, zero);
    enter.y2 = update.y2 = ifY(orient, pos1);
    return guideMark({
        type: RuleMark,
        role: AxisDomainRole,
        from: dataRef,
        encode
    }, userEncode);
}
function position(spec, pos) {
    return {
        scale: spec.scale,
        range: pos
    };
}
function axisGrid(spec, config, userEncode, dataRef, band) {
    const _ = lookup(spec, config), orient = spec.orient, vscale = spec.gridScale, sign = getSign(orient, 1, -1), offset = offsetValue(spec.offset, sign);
    let enter, exit, update;
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one
        },
        exit: exit = {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('gridColor'),
        strokeCap: _('gridCap'),
        strokeDash: _('gridDash'),
        strokeDashOffset: _('gridDashOffset'),
        strokeOpacity: _('gridOpacity'),
        strokeWidth: _('gridWidth')
    });
    const tickPos = {
        scale: spec.scale,
        field: Value,
        band: band.band,
        extra: band.extra,
        offset: band.offset,
        round: _('tickRound')
    };
    const sz = ifX(orient, {
        signal: 'height'
    }, {
        signal: 'width'
    });
    const gridStart = vscale ? {
        scale: vscale,
        range: 0,
        mult: sign,
        offset: offset
    } : {
        value: 0,
        offset: offset
    };
    const gridEnd = vscale ? {
        scale: vscale,
        range: 1,
        mult: sign,
        offset: offset
    } : (0, _vegaUtil.extend)(sz, {
        mult: sign,
        offset: offset
    });
    enter.x = update.x = ifX(orient, tickPos, gridStart);
    enter.y = update.y = ifY(orient, tickPos, gridStart);
    enter.x2 = update.x2 = ifY(orient, gridEnd);
    enter.y2 = update.y2 = ifX(orient, gridEnd);
    exit.x = ifX(orient, tickPos);
    exit.y = ifY(orient, tickPos);
    return guideMark({
        type: RuleMark,
        role: AxisGridRole,
        key: Value,
        from: dataRef,
        encode
    }, userEncode);
}
function offsetValue(offset, sign) {
    if (sign === 1) ;
    else if (!(0, _vegaUtil.isObject)(offset)) offset = isSignal(sign) ? {
        signal: `(${sign.signal}) * (${offset || 0})`
    } : sign * (offset || 0);
    else {
        let entry = offset = (0, _vegaUtil.extend)({}, offset);
        while(entry.mult != null)if (!(0, _vegaUtil.isObject)(entry.mult)) {
            entry.mult = isSignal(sign) // no offset if sign === 1
             ? {
                signal: `(${entry.mult}) * (${sign.signal})`
            } : entry.mult * sign;
            return offset;
        } else entry = entry.mult = (0, _vegaUtil.extend)({}, entry.mult);
        entry.mult = sign;
    }
    return offset;
}
function axisTicks(spec, config, userEncode, dataRef, size, band) {
    const _ = lookup(spec, config), orient = spec.orient, sign = getSign(orient, -1, 1);
    let enter, exit, update;
    const encode = {
        enter: enter = {
            opacity: zero
        },
        update: update = {
            opacity: one
        },
        exit: exit = {
            opacity: zero
        }
    };
    addEncoders(encode, {
        stroke: _('tickColor'),
        strokeCap: _('tickCap'),
        strokeDash: _('tickDash'),
        strokeDashOffset: _('tickDashOffset'),
        strokeOpacity: _('tickOpacity'),
        strokeWidth: _('tickWidth')
    });
    const tickSize = encoder(size);
    tickSize.mult = sign;
    const tickPos = {
        scale: spec.scale,
        field: Value,
        band: band.band,
        extra: band.extra,
        offset: band.offset,
        round: _('tickRound')
    };
    update.y = enter.y = ifX(orient, zero, tickPos);
    update.y2 = enter.y2 = ifX(orient, tickSize);
    exit.x = ifX(orient, tickPos);
    update.x = enter.x = ifY(orient, zero, tickPos);
    update.x2 = enter.x2 = ifY(orient, tickSize);
    exit.y = ifY(orient, tickPos);
    return guideMark({
        type: RuleMark,
        role: AxisTickRole,
        key: Value,
        from: dataRef,
        encode
    }, userEncode);
}
function flushExpr(scale, threshold, a, b, c) {
    return {
        signal: 'flush(range("' + scale + '"), ' + 'scale("' + scale + '", datum.value), ' + threshold + ',' + a + ',' + b + ',' + c + ')'
    };
}
function axisLabels(spec, config, userEncode, dataRef, size, band) {
    const _ = lookup(spec, config), orient = spec.orient, scale = spec.scale, sign = getSign(orient, -1, 1), flush = deref(_('labelFlush')), flushOffset = deref(_('labelFlushOffset')), labelAlign = _('labelAlign'), labelBaseline = _('labelBaseline');
    let flushOn = flush === 0 || !!flush, update;
    const tickSize = encoder(size);
    tickSize.mult = sign;
    tickSize.offset = encoder(_('labelPadding') || 0);
    tickSize.offset.mult = sign;
    const tickPos = {
        scale: scale,
        field: Value,
        band: 0.5,
        offset: extendOffset(band.offset, _('labelOffset'))
    };
    const align = ifX(orient, flushOn ? flushExpr(scale, flush, '"left"', '"right"', '"center"') : {
        value: 'center'
    }, ifRight(orient, 'left', 'right'));
    const baseline = ifX(orient, ifTop(orient, 'bottom', 'top'), flushOn ? flushExpr(scale, flush, '"top"', '"bottom"', '"middle"') : {
        value: 'middle'
    });
    const offsetExpr = flushExpr(scale, flush, `-(${flushOffset})`, flushOffset, 0);
    flushOn = flushOn && flushOffset;
    const enter = {
        opacity: zero,
        x: ifX(orient, tickPos, tickSize),
        y: ifY(orient, tickPos, tickSize)
    };
    const encode = {
        enter: enter,
        update: update = {
            opacity: one,
            text: {
                field: Label
            },
            x: enter.x,
            y: enter.y,
            align,
            baseline
        },
        exit: {
            opacity: zero,
            x: enter.x,
            y: enter.y
        }
    };
    addEncoders(encode, {
        dx: !labelAlign && flushOn ? ifX(orient, offsetExpr) : null,
        dy: !labelBaseline && flushOn ? ifY(orient, offsetExpr) : null
    });
    addEncoders(encode, {
        angle: _('labelAngle'),
        fill: _('labelColor'),
        fillOpacity: _('labelOpacity'),
        font: _('labelFont'),
        fontSize: _('labelFontSize'),
        fontWeight: _('labelFontWeight'),
        fontStyle: _('labelFontStyle'),
        limit: _('labelLimit'),
        lineHeight: _('labelLineHeight')
    }, {
        align: labelAlign,
        baseline: labelBaseline
    });
    const bound = _('labelBound');
    let overlap = _('labelOverlap');
    // if overlap method or bound defined, request label overlap removal
    overlap = overlap || bound ? {
        separation: _('labelSeparation'),
        method: overlap,
        order: 'datum.index',
        bound: bound ? {
            scale,
            orient,
            tolerance: bound
        } : null
    } : undefined;
    if (update.align !== align) update.align = patch(update.align, align);
    if (update.baseline !== baseline) update.baseline = patch(update.baseline, baseline);
    return guideMark({
        type: TextMark,
        role: AxisLabelRole,
        style: GuideLabelStyle,
        key: Value,
        from: dataRef,
        encode,
        overlap
    }, userEncode);
}
function axisTitle(spec, config, userEncode, dataRef) {
    const _ = lookup(spec, config), orient = spec.orient, sign = getSign(orient, -1, 1);
    let enter, update;
    const encode = {
        enter: enter = {
            opacity: zero,
            anchor: encoder(_('titleAnchor', null)),
            align: {
                signal: alignExpr$1
            }
        },
        update: update = (0, _vegaUtil.extend)({}, enter, {
            opacity: one,
            text: encoder(spec.title)
        }),
        exit: {
            opacity: zero
        }
    };
    const titlePos = {
        signal: `lerp(range("${spec.scale}"), ${anchorExpr(0, 1, 0.5)})`
    };
    update.x = ifX(orient, titlePos);
    update.y = ifY(orient, titlePos);
    enter.angle = ifX(orient, zero, mult(sign, 90));
    enter.baseline = ifX(orient, ifTop(orient, Bottom, Top), {
        value: Bottom
    });
    update.angle = enter.angle;
    update.baseline = enter.baseline;
    addEncoders(encode, {
        fill: _('titleColor'),
        fillOpacity: _('titleOpacity'),
        font: _('titleFont'),
        fontSize: _('titleFontSize'),
        fontStyle: _('titleFontStyle'),
        fontWeight: _('titleFontWeight'),
        limit: _('titleLimit'),
        lineHeight: _('titleLineHeight')
    }, {
        // require update
        align: _('titleAlign'),
        angle: _('titleAngle'),
        baseline: _('titleBaseline')
    });
    autoLayout(_, orient, encode, userEncode);
    encode.update.align = patch(encode.update.align, enter.align);
    encode.update.angle = patch(encode.update.angle, enter.angle);
    encode.update.baseline = patch(encode.update.baseline, enter.baseline);
    return guideMark({
        type: TextMark,
        role: AxisTitleRole,
        style: GuideTitleStyle,
        from: dataRef,
        encode
    }, userEncode);
}
function autoLayout(_, orient, encode, userEncode) {
    const auto = (value, dim)=>value != null ? (encode.update[dim] = patch(encoder(value), encode.update[dim]), false) : !has(dim, userEncode) ? true : false;
    const autoY = auto(_('titleX'), 'x'), autoX = auto(_('titleY'), 'y');
    encode.enter.auto = autoX === autoY ? encoder(autoX) : ifX(orient, encoder(autoX), encoder(autoY));
}
function parseAxis(spec, scope) {
    const config = axisConfig(spec, scope), encode = spec.encode || {}, axisEncode = encode.axis || {}, name = axisEncode.name || undefined, interactive = axisEncode.interactive, style = axisEncode.style, _ = lookup(spec, config), band = tickBand(_);
    // single-element data source for axis group
    const datum = {
        scale: spec.scale,
        ticks: !!_('ticks'),
        labels: !!_('labels'),
        grid: !!_('grid'),
        domain: !!_('domain'),
        title: spec.title != null
    };
    const dataRef = ref(scope.add(Collect({}, [
        datum
    ])));
    // data source for axis ticks
    const ticksRef = ref(scope.add(AxisTicks({
        scale: scope.scaleRef(spec.scale),
        extra: scope.property(band.extra),
        count: scope.objectProperty(spec.tickCount),
        values: scope.objectProperty(spec.values),
        minstep: scope.property(spec.tickMinStep),
        formatType: scope.property(spec.formatType),
        formatSpecifier: scope.property(spec.format)
    })));
    // generate axis marks
    const children = [];
    let size;
    // include axis gridlines if requested
    if (datum.grid) children.push(axisGrid(spec, config, encode.grid, ticksRef, band));
    // include axis ticks if requested
    if (datum.ticks) {
        size = _('tickSize');
        children.push(axisTicks(spec, config, encode.ticks, ticksRef, size, band));
    }
    // include axis labels if requested
    if (datum.labels) {
        size = datum.ticks ? size : 0;
        children.push(axisLabels(spec, config, encode.labels, ticksRef, size, band));
    }
    // include axis domain path if requested
    if (datum.domain) children.push(axisDomain(spec, config, encode.domain, dataRef));
    // include axis title if defined
    if (datum.title) children.push(axisTitle(spec, config, encode.title, dataRef));
    // parse axis specification
    return parseMark(guideGroup({
        role: AxisRole,
        from: dataRef,
        encode: extendEncode(buildAxisEncode(_, spec), axisEncode, Skip),
        marks: children,
        aria: _('aria'),
        description: _('description'),
        zindex: _('zindex'),
        name,
        interactive,
        style
    }), scope);
}
function buildAxisEncode(_, spec) {
    const encode = {
        enter: {},
        update: {}
    };
    addEncoders(encode, {
        orient: _('orient'),
        offset: _('offset') || 0,
        position: value(spec.position, 0),
        titlePadding: _('titlePadding'),
        minExtent: _('minExtent'),
        maxExtent: _('maxExtent'),
        range: {
            signal: `abs(span(range("${spec.scale}")))`
        },
        translate: _('translate'),
        // accessibility support
        format: spec.format,
        formatType: spec.formatType
    });
    return encode;
}
function parseScope(spec, scope, preprocessed) {
    const signals = (0, _vegaUtil.array)(spec.signals), scales = (0, _vegaUtil.array)(spec.scales);
    // parse signal definitions, if not already preprocessed
    if (!preprocessed) signals.forEach((_)=>parseSignal(_, scope));
    // parse cartographic projection definitions
    (0, _vegaUtil.array)(spec.projections).forEach((_)=>parseProjection(_, scope));
    // initialize scale references
    scales.forEach((_)=>initScale(_, scope));
    // parse data sources
    (0, _vegaUtil.array)(spec.data).forEach((_)=>parseData(_, scope));
    // parse scale definitions
    scales.forEach((_)=>parseScale(_, scope));
    // parse signal updates
    (preprocessed || signals).forEach((_)=>parseSignalUpdates(_, scope));
    // parse axis definitions
    (0, _vegaUtil.array)(spec.axes).forEach((_)=>parseAxis(_, scope));
    // parse mark definitions
    (0, _vegaUtil.array)(spec.marks).forEach((_)=>parseMark(_, scope));
    // parse legend definitions
    (0, _vegaUtil.array)(spec.legends).forEach((_)=>parseLegend(_, scope));
    // parse title, if defined
    if (spec.title) parseTitle(spec.title, scope);
    // parse collected lambda (anonymous) expressions
    scope.parseLambdas();
    return scope;
}
const rootEncode = (spec)=>extendEncode({
        enter: {
            x: {
                value: 0
            },
            y: {
                value: 0
            }
        },
        update: {
            width: {
                signal: 'width'
            },
            height: {
                signal: 'height'
            }
        }
    }, spec);
function parseView(spec, scope) {
    const config = scope.config;
    // add scenegraph root
    const root = ref(scope.root = scope.add(operator()));
    // parse top-level signal definitions
    const signals = collectSignals(spec, config);
    signals.forEach((_)=>parseSignal(_, scope));
    // assign description, event, legend, and locale configuration
    scope.description = spec.description || config.description;
    scope.eventConfig = config.events;
    scope.legends = scope.objectProperty(config.legend && config.legend.layout);
    scope.locale = config.locale;
    // store root group item
    const input = scope.add(Collect());
    // encode root group item
    const encode = scope.add(Encode(parseEncode(rootEncode(spec.encode), GroupMark, FrameRole, spec.style, scope, {
        pulse: ref(input)
    })));
    // perform view layout
    const parent = scope.add(ViewLayout({
        layout: scope.objectProperty(spec.layout),
        legends: scope.legends,
        autosize: scope.signalRef('autosize'),
        mark: root,
        pulse: ref(encode)
    }));
    scope.operators.pop();
    // parse remainder of specification
    scope.pushState(ref(encode), ref(parent), null);
    parseScope(spec, scope, signals);
    scope.operators.push(parent);
    // bound / render / sieve root item
    let op = scope.add(Bound({
        mark: root,
        pulse: ref(parent)
    }));
    op = scope.add(Render({
        pulse: ref(op)
    }));
    op = scope.add(Sieve({
        pulse: ref(op)
    }));
    // track metadata for root item
    scope.addData('root', new DataScope(scope, input, input, op));
    return scope;
}
function signalObject(name, value) {
    return value && value.signal ? {
        name,
        update: value.signal
    } : {
        name,
        value
    };
}
/**
 * Collect top-level signals, merging values as needed. Signals
 * defined in the config signals arrays are added only if that
 * signal is not explicitly defined in the specification.
 * Built-in signals (autosize, background, padding, width, height)
 * receive special treatment. They are initialized using the
 * top-level spec property, or, if undefined in the spec, using
 * the corresponding top-level config property. If this property
 * is a signal reference object, the signal expression maps to the
 * signal 'update' property. If the spec's top-level signal array
 * contains an entry that matches a built-in signal, that entry
 * will be merged with the built-in specification, potentially
 * overwriting existing 'value' or 'update' properties.
 */ function collectSignals(spec, config) {
    const _ = (name)=>value(spec[name], config[name]), signals = [
        signalObject('background', _('background')),
        signalObject('autosize', parseAutosize(_('autosize'))),
        signalObject('padding', parsePadding(_('padding'))),
        signalObject('width', _('width') || 0),
        signalObject('height', _('height') || 0)
    ], pre = signals.reduce((p, s)=>(p[s.name] = s, p), {}), map = {};
    // add spec signal array
    (0, _vegaUtil.array)(spec.signals).forEach((s)=>{
        if ((0, _vegaUtil.hasOwnProperty)(pre, s.name)) // merge if built-in signal
        s = (0, _vegaUtil.extend)(pre[s.name], s);
        else // otherwise add to signal list
        signals.push(s);
        map[s.name] = s;
    });
    // add config signal array
    (0, _vegaUtil.array)(config.signals).forEach((s)=>{
        if (!(0, _vegaUtil.hasOwnProperty)(map, s.name) && !(0, _vegaUtil.hasOwnProperty)(pre, s.name)) // add to signal list if not already defined
        signals.push(s);
    });
    return signals;
}
function Scope(config, options) {
    this.config = config || {};
    this.options = options || {};
    this.bindings = [];
    this.field = {};
    this.signals = {};
    this.lambdas = {};
    this.scales = {};
    this.events = {};
    this.data = {};
    this.streams = [];
    this.updates = [];
    this.operators = [];
    this.eventConfig = null;
    this.locale = null;
    this._id = 0;
    this._subid = 0;
    this._nextsub = [
        0
    ];
    this._parent = [];
    this._encode = [];
    this._lookup = [];
    this._markpath = [];
}
function Subscope(scope) {
    this.config = scope.config;
    this.options = scope.options;
    this.legends = scope.legends;
    this.field = Object.create(scope.field);
    this.signals = Object.create(scope.signals);
    this.lambdas = Object.create(scope.lambdas);
    this.scales = Object.create(scope.scales);
    this.events = Object.create(scope.events);
    this.data = Object.create(scope.data);
    this.streams = [];
    this.updates = [];
    this.operators = [];
    this._id = 0;
    this._subid = ++scope._nextsub[0];
    this._nextsub = scope._nextsub;
    this._parent = scope._parent.slice();
    this._encode = scope._encode.slice();
    this._lookup = scope._lookup.slice();
    this._markpath = scope._markpath;
}
Scope.prototype = Subscope.prototype = {
    parse (spec) {
        return parseScope(spec, this);
    },
    fork () {
        return new Subscope(this);
    },
    isSubscope () {
        return this._subid > 0;
    },
    toRuntime () {
        this.finish();
        return {
            description: this.description,
            operators: this.operators,
            streams: this.streams,
            updates: this.updates,
            bindings: this.bindings,
            eventConfig: this.eventConfig,
            locale: this.locale
        };
    },
    id () {
        return (this._subid ? this._subid + ':' : 0) + this._id++;
    },
    add (op) {
        this.operators.push(op);
        op.id = this.id();
        // if pre-registration references exist, resolve them now
        if (op.refs) {
            op.refs.forEach((ref)=>{
                ref.$ref = op.id;
            });
            op.refs = null;
        }
        return op;
    },
    proxy (op) {
        const vref = op instanceof Entry ? ref(op) : op;
        return this.add(Proxy({
            value: vref
        }));
    },
    addStream (stream) {
        this.streams.push(stream);
        stream.id = this.id();
        return stream;
    },
    addUpdate (update) {
        this.updates.push(update);
        return update;
    },
    // Apply metadata
    finish () {
        let name, ds;
        // annotate root
        if (this.root) this.root.root = true;
        // annotate signals
        for(name in this.signals)this.signals[name].signal = name;
        // annotate scales
        for(name in this.scales)this.scales[name].scale = name;
        // annotate data sets
        function annotate(op, name, type) {
            let data, list;
            if (op) {
                data = op.data || (op.data = {});
                list = data[name] || (data[name] = []);
                list.push(type);
            }
        }
        for(name in this.data){
            ds = this.data[name];
            annotate(ds.input, name, 'input');
            annotate(ds.output, name, 'output');
            annotate(ds.values, name, 'values');
            for(const field in ds.index)annotate(ds.index[field], name, 'index:' + field);
        }
        return this;
    },
    // ----
    pushState (encode, parent, lookup) {
        this._encode.push(ref(this.add(Sieve({
            pulse: encode
        }))));
        this._parent.push(parent);
        this._lookup.push(lookup ? ref(this.proxy(lookup)) : null);
        this._markpath.push(-1);
    },
    popState () {
        this._encode.pop();
        this._parent.pop();
        this._lookup.pop();
        this._markpath.pop();
    },
    parent () {
        return (0, _vegaUtil.peek)(this._parent);
    },
    encode () {
        return (0, _vegaUtil.peek)(this._encode);
    },
    lookup () {
        return (0, _vegaUtil.peek)(this._lookup);
    },
    markpath () {
        const p = this._markpath;
        return ++p[p.length - 1];
    },
    // ----
    fieldRef (field, name) {
        if ((0, _vegaUtil.isString)(field)) return fieldRef$1(field, name);
        if (!field.signal) (0, _vegaUtil.error)('Unsupported field reference: ' + (0, _vegaUtil.stringValue)(field));
        const s = field.signal;
        let f = this.field[s];
        if (!f) {
            const params = {
                name: this.signalRef(s)
            };
            if (name) params.as = name;
            this.field[s] = f = ref(this.add(Field(params)));
        }
        return f;
    },
    compareRef (cmp) {
        let signal = false;
        const check = (_)=>isSignal(_) ? (signal = true, this.signalRef(_.signal)) : isExpr$1(_) ? (signal = true, this.exprRef(_.expr)) : _;
        const fields = (0, _vegaUtil.array)(cmp.field).map(check), orders = (0, _vegaUtil.array)(cmp.order).map(check);
        return signal ? ref(this.add(Compare({
            fields: fields,
            orders: orders
        }))) : compareRef(fields, orders);
    },
    keyRef (fields, flat) {
        let signal = false;
        const check = (_)=>isSignal(_) ? (signal = true, ref(sig[_.signal])) : _;
        const sig = this.signals;
        fields = (0, _vegaUtil.array)(fields).map(check);
        return signal ? ref(this.add(Key({
            fields: fields,
            flat: flat
        }))) : keyRef(fields, flat);
    },
    sortRef (sort) {
        if (!sort) return sort;
        // including id ensures stable sorting
        const a = aggrField(sort.op, sort.field), o = sort.order || Ascending;
        return o.signal ? ref(this.add(Compare({
            fields: a,
            orders: this.signalRef(o.signal)
        }))) : compareRef(a, o);
    },
    // ----
    event (source, type) {
        const key = source + ':' + type;
        if (!this.events[key]) {
            const id = this.id();
            this.streams.push({
                id: id,
                source: source,
                type: type
            });
            this.events[key] = id;
        }
        return this.events[key];
    },
    // ----
    hasOwnSignal (name) {
        return (0, _vegaUtil.hasOwnProperty)(this.signals, name);
    },
    addSignal (name, value) {
        if (this.hasOwnSignal(name)) (0, _vegaUtil.error)('Duplicate signal name: ' + (0, _vegaUtil.stringValue)(name));
        const op = value instanceof Entry ? value : this.add(operator(value));
        return this.signals[name] = op;
    },
    getSignal (name) {
        if (!this.signals[name]) (0, _vegaUtil.error)('Unrecognized signal name: ' + (0, _vegaUtil.stringValue)(name));
        return this.signals[name];
    },
    signalRef (s) {
        if (this.signals[s]) return ref(this.signals[s]);
        else if (!(0, _vegaUtil.hasOwnProperty)(this.lambdas, s)) this.lambdas[s] = this.add(operator(null));
        return ref(this.lambdas[s]);
    },
    parseLambdas () {
        const code = Object.keys(this.lambdas);
        for(let i = 0, n = code.length; i < n; ++i){
            const s = code[i], e = (0, _vegaFunctions.parseExpression)(s, this), op = this.lambdas[s];
            op.params = e.$params;
            op.update = e.$expr;
        }
    },
    property (spec) {
        return spec && spec.signal ? this.signalRef(spec.signal) : spec;
    },
    objectProperty (spec) {
        return !spec || !(0, _vegaUtil.isObject)(spec) ? spec : this.signalRef(spec.signal || propertyLambda(spec));
    },
    exprRef (code, name) {
        const params = {
            expr: (0, _vegaFunctions.parseExpression)(code, this)
        };
        if (name) params.expr.$name = name;
        return ref(this.add(Expression(params)));
    },
    addBinding (name, bind) {
        if (!this.bindings) (0, _vegaUtil.error)('Nested signals do not support binding: ' + (0, _vegaUtil.stringValue)(name));
        this.bindings.push((0, _vegaUtil.extend)({
            signal: name
        }, bind));
    },
    // ----
    addScaleProj (name, transform) {
        if ((0, _vegaUtil.hasOwnProperty)(this.scales, name)) (0, _vegaUtil.error)('Duplicate scale or projection name: ' + (0, _vegaUtil.stringValue)(name));
        this.scales[name] = this.add(transform);
    },
    addScale (name, params) {
        this.addScaleProj(name, Scale(params));
    },
    addProjection (name, params) {
        this.addScaleProj(name, Projection(params));
    },
    getScale (name) {
        if (!this.scales[name]) (0, _vegaUtil.error)('Unrecognized scale name: ' + (0, _vegaUtil.stringValue)(name));
        return this.scales[name];
    },
    scaleRef (name) {
        return ref(this.getScale(name));
    },
    scaleType (name) {
        return this.getScale(name).params.type;
    },
    projectionRef (name) {
        return this.scaleRef(name);
    },
    projectionType (name) {
        return this.scaleType(name);
    },
    // ----
    addData (name, dataScope) {
        if ((0, _vegaUtil.hasOwnProperty)(this.data, name)) (0, _vegaUtil.error)('Duplicate data set name: ' + (0, _vegaUtil.stringValue)(name));
        return this.data[name] = dataScope;
    },
    getData (name) {
        if (!this.data[name]) (0, _vegaUtil.error)('Undefined data set name: ' + (0, _vegaUtil.stringValue)(name));
        return this.data[name];
    },
    addDataPipeline (name, entries) {
        if ((0, _vegaUtil.hasOwnProperty)(this.data, name)) (0, _vegaUtil.error)('Duplicate data set name: ' + (0, _vegaUtil.stringValue)(name));
        return this.addData(name, DataScope.fromEntries(this, entries));
    }
};
function propertyLambda(spec) {
    return ((0, _vegaUtil.isArray)(spec) ? arrayLambda : objectLambda)(spec);
}
function arrayLambda(array) {
    const n = array.length;
    let code = '[';
    for(let i = 0; i < n; ++i){
        const value = array[i];
        code += (i > 0 ? ',' : '') + ((0, _vegaUtil.isObject)(value) ? value.signal || propertyLambda(value) : (0, _vegaUtil.stringValue)(value));
    }
    return code + ']';
}
function objectLambda(obj) {
    let code = '{', i = 0, key, value;
    for(key in obj){
        value = obj[key];
        code += (++i > 1 ? ',' : '') + (0, _vegaUtil.stringValue)(key) + ':' + ((0, _vegaUtil.isObject)(value) ? value.signal || propertyLambda(value) : (0, _vegaUtil.stringValue)(value));
    }
    return code + '}';
}
/**
 * Standard configuration defaults for Vega specification parsing.
 * Users can provide their own (sub-)set of these default values
 * by passing in a config object to the top-level parse method.
 */ function defaults() {
    const defaultFont = 'sans-serif', defaultSymbolSize = 30, defaultStrokeWidth = 2, defaultColor = '#4c78a8', black = '#000', gray = '#888', lightGray = '#ddd';
    return {
        // default visualization description
        description: 'Vega visualization',
        // default padding around visualization
        padding: 0,
        // default for automatic sizing; options: 'none', 'pad', 'fit'
        // or provide an object (e.g., {'type': 'pad', 'resize': true})
        autosize: 'pad',
        // default view background color
        // covers the entire view component
        background: null,
        // default event handling configuration
        // preventDefault for view-sourced event types except 'wheel'
        events: {
            defaults: {
                allow: [
                    'wheel'
                ]
            }
        },
        // defaults for top-level group marks
        // accepts mark properties (fill, stroke, etc)
        // covers the data rectangle within group width/height
        group: null,
        // defaults for basic mark types
        // each subset accepts mark properties (fill, stroke, etc)
        mark: null,
        arc: {
            fill: defaultColor
        },
        area: {
            fill: defaultColor
        },
        image: null,
        line: {
            stroke: defaultColor,
            strokeWidth: defaultStrokeWidth
        },
        path: {
            stroke: defaultColor
        },
        rect: {
            fill: defaultColor
        },
        rule: {
            stroke: black
        },
        shape: {
            stroke: defaultColor
        },
        symbol: {
            fill: defaultColor,
            size: 64
        },
        text: {
            fill: black,
            font: defaultFont,
            fontSize: 11
        },
        trail: {
            fill: defaultColor,
            size: defaultStrokeWidth
        },
        // style definitions
        style: {
            // axis & legend labels
            'guide-label': {
                fill: black,
                font: defaultFont,
                fontSize: 10
            },
            // axis & legend titles
            'guide-title': {
                fill: black,
                font: defaultFont,
                fontSize: 11,
                fontWeight: 'bold'
            },
            // headers, including chart title
            'group-title': {
                fill: black,
                font: defaultFont,
                fontSize: 13,
                fontWeight: 'bold'
            },
            // chart subtitle
            'group-subtitle': {
                fill: black,
                font: defaultFont,
                fontSize: 12
            },
            // defaults for styled point marks in Vega-Lite
            point: {
                size: defaultSymbolSize,
                strokeWidth: defaultStrokeWidth,
                shape: 'circle'
            },
            circle: {
                size: defaultSymbolSize,
                strokeWidth: defaultStrokeWidth
            },
            square: {
                size: defaultSymbolSize,
                strokeWidth: defaultStrokeWidth,
                shape: 'square'
            },
            // defaults for styled group marks in Vega-Lite
            cell: {
                fill: 'transparent',
                stroke: lightGray
            },
            view: {
                fill: 'transparent'
            }
        },
        // defaults for title
        title: {
            orient: 'top',
            anchor: 'middle',
            offset: 4,
            subtitlePadding: 3
        },
        // defaults for axes
        axis: {
            minExtent: 0,
            maxExtent: 200,
            bandPosition: 0.5,
            domain: true,
            domainWidth: 1,
            domainColor: gray,
            grid: false,
            gridWidth: 1,
            gridColor: lightGray,
            labels: true,
            labelAngle: 0,
            labelLimit: 180,
            labelOffset: 0,
            labelPadding: 2,
            ticks: true,
            tickColor: gray,
            tickOffset: 0,
            tickRound: true,
            tickSize: 5,
            tickWidth: 1,
            titlePadding: 4
        },
        // correction for centering bias
        axisBand: {
            tickOffset: -0.5
        },
        // defaults for cartographic projection
        projection: {
            type: 'mercator'
        },
        // defaults for legends
        legend: {
            orient: 'right',
            padding: 0,
            gridAlign: 'each',
            columnPadding: 10,
            rowPadding: 2,
            symbolDirection: 'vertical',
            gradientDirection: 'vertical',
            gradientLength: 200,
            gradientThickness: 16,
            gradientStrokeColor: lightGray,
            gradientStrokeWidth: 0,
            gradientLabelOffset: 2,
            labelAlign: 'left',
            labelBaseline: 'middle',
            labelLimit: 160,
            labelOffset: 4,
            labelOverlap: true,
            symbolLimit: 30,
            symbolType: 'circle',
            symbolSize: 100,
            symbolOffset: 0,
            symbolStrokeWidth: 1.5,
            symbolBaseFillColor: 'transparent',
            symbolBaseStrokeColor: gray,
            titleLimit: 180,
            titleOrient: 'top',
            titlePadding: 5,
            layout: {
                offset: 18,
                direction: 'horizontal',
                left: {
                    direction: 'vertical'
                },
                right: {
                    direction: 'vertical'
                }
            }
        },
        // defaults for scale ranges
        range: {
            category: {
                scheme: 'tableau10'
            },
            ordinal: {
                scheme: 'blues'
            },
            heatmap: {
                scheme: 'yellowgreenblue'
            },
            ramp: {
                scheme: 'blues'
            },
            diverging: {
                scheme: 'blueorange',
                extent: [
                    1,
                    0
                ]
            },
            symbol: [
                'circle',
                'square',
                'triangle-up',
                'cross',
                'diamond',
                'triangle-right',
                'triangle-down',
                'triangle-left'
            ]
        }
    };
}
function parse(spec, config, options) {
    if (!(0, _vegaUtil.isObject)(spec)) (0, _vegaUtil.error)('Input Vega specification must be an object.');
    config = (0, _vegaUtil.mergeConfig)(defaults(), config, spec.config);
    return parseView(spec, new Scope(config, options)).toRuntime();
}

},{"vega-util":"kncZn","vega-functions":"l0VB3","vega-event-selector":"4BhtH","vega-scale":"fMau0","vega-dataflow":"eoU45","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4BhtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSelector", ()=>eventSelector);
const VIEW = 'view', LBRACK = '[', RBRACK = ']', LBRACE = '{', RBRACE = '}', COLON = ':', COMMA = ',', NAME = '@', GT = '>', ILLEGAL = /[[\]{}]/, DEFAULT_MARKS = {
    '*': 1,
    arc: 1,
    area: 1,
    group: 1,
    image: 1,
    line: 1,
    path: 1,
    rect: 1,
    rule: 1,
    shape: 1,
    symbol: 1,
    text: 1,
    trail: 1
};
let DEFAULT_SOURCE, MARKS;
/**
 * Parse an event selector string.
 * Returns an array of event stream definitions.
 */ function eventSelector(selector, source, marks) {
    DEFAULT_SOURCE = source || VIEW;
    MARKS = marks || DEFAULT_MARKS;
    return parseMerge(selector.trim()).map(parseSelector);
}
function isMarkType(type) {
    return MARKS[type];
}
function find(s, i, endChar, pushChar, popChar) {
    const n = s.length;
    let count = 0, c;
    for(; i < n; ++i){
        c = s[i];
        if (!count && c === endChar) return i;
        else if (popChar && popChar.includes(c)) --count;
        else if (pushChar && pushChar.includes(c)) ++count;
    }
    return i;
}
function parseMerge(s) {
    const output = [], n = s.length;
    let start = 0, i = 0;
    while(i < n){
        i = find(s, i, COMMA, LBRACK + LBRACE, RBRACK + RBRACE);
        output.push(s.substring(start, i).trim());
        start = ++i;
    }
    if (output.length === 0) throw 'Empty event selector: ' + s;
    return output;
}
function parseSelector(s) {
    return s[0] === '[' ? parseBetween(s) : parseStream(s);
}
function parseBetween(s) {
    const n = s.length;
    let i = 1, b;
    i = find(s, i, RBRACK, LBRACK, RBRACK);
    if (i === n) throw 'Empty between selector: ' + s;
    b = parseMerge(s.substring(1, i));
    if (b.length !== 2) throw 'Between selector must have two elements: ' + s;
    s = s.slice(i + 1).trim();
    if (s[0] !== GT) throw 'Expected \'>\' after between selector: ' + s;
    b = b.map(parseSelector);
    const stream = parseSelector(s.slice(1).trim());
    if (stream.between) return {
        between: b,
        stream: stream
    };
    else stream.between = b;
    return stream;
}
function parseStream(s) {
    const stream = {
        source: DEFAULT_SOURCE
    }, source = [];
    let throttle = [
        0,
        0
    ], markname = 0, start = 0, n = s.length, i = 0, j, filter;
    // extract throttle from end
    if (s[n - 1] === RBRACE) {
        i = s.lastIndexOf(LBRACE);
        if (i >= 0) {
            try {
                throttle = parseThrottle(s.substring(i + 1, n - 1));
            } catch (e) {
                throw 'Invalid throttle specification: ' + s;
            }
            s = s.slice(0, i).trim();
            n = s.length;
        } else throw 'Unmatched right brace: ' + s;
        i = 0;
    }
    if (!n) throw s;
    // set name flag based on first char
    if (s[0] === NAME) markname = ++i;
    // extract first part of multi-part stream selector
    j = find(s, i, COLON);
    if (j < n) {
        source.push(s.substring(start, j).trim());
        start = i = ++j;
    }
    // extract remaining part of stream selector
    i = find(s, i, LBRACK);
    if (i === n) source.push(s.substring(start, n).trim());
    else {
        source.push(s.substring(start, i).trim());
        filter = [];
        start = ++i;
        if (start === n) throw 'Unmatched left bracket: ' + s;
    }
    // extract filters
    while(i < n){
        i = find(s, i, RBRACK);
        if (i === n) throw 'Unmatched left bracket: ' + s;
        filter.push(s.substring(start, i).trim());
        if (i < n - 1 && s[++i] !== LBRACK) throw 'Expected left bracket: ' + s;
        start = ++i;
    }
    // marshall event stream specification
    if (!(n = source.length) || ILLEGAL.test(source[n - 1])) throw 'Invalid event selector: ' + s;
    if (n > 1) {
        stream.type = source[1];
        if (markname) stream.markname = source[0].slice(1);
        else if (isMarkType(source[0])) stream.marktype = source[0];
        else stream.source = source[0];
    } else stream.type = source[0];
    if (stream.type.slice(-1) === '!') {
        stream.consume = true;
        stream.type = stream.type.slice(0, -1);
    }
    if (filter != null) stream.filter = filter;
    if (throttle[0]) stream.throttle = throttle[0];
    if (throttle[1]) stream.debounce = throttle[1];
    return stream;
}
function parseThrottle(s) {
    const a = s.split(COMMA);
    if (!s.length || a.length > 2) throw s;
    return a.map((_)=>{
        const x = +_;
        if (x !== x) throw s;
        return x;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eTD5L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accessPathDepth", ()=>accessPathDepth);
parcelHelpers.export(exports, "accessPathWithDatum", ()=>accessPathWithDatum);
parcelHelpers.export(exports, "accessWithDatumToUnescapedPath", ()=>accessWithDatumToUnescapedPath);
parcelHelpers.export(exports, "compile", ()=>compile);
parcelHelpers.export(exports, "contains", ()=>contains);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
parcelHelpers.export(exports, "deleteNestedProperty", ()=>deleteNestedProperty);
parcelHelpers.export(exports, "duplicate", ()=>duplicate);
parcelHelpers.export(exports, "entries", ()=>entries$1);
parcelHelpers.export(exports, "every", ()=>every);
parcelHelpers.export(exports, "fieldIntersection", ()=>fieldIntersection);
parcelHelpers.export(exports, "flatAccessWithDatum", ()=>flatAccessWithDatum);
parcelHelpers.export(exports, "getFirstDefined", ()=>getFirstDefined);
parcelHelpers.export(exports, "hasIntersection", ()=>hasIntersection);
parcelHelpers.export(exports, "hasProperty", ()=>hasProperty);
parcelHelpers.export(exports, "hash", ()=>hash);
parcelHelpers.export(exports, "internalField", ()=>internalField);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "isInternalField", ()=>isInternalField);
parcelHelpers.export(exports, "isNullOrFalse", ()=>isNullOrFalse);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "logicalExpr", ()=>logicalExpr);
parcelHelpers.export(exports, "mergeDeep", ()=>mergeDeep);
parcelHelpers.export(exports, "never", ()=>never);
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "normalizeAngle", ()=>normalizeAngle);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "prefixGenerator", ()=>prefixGenerator);
parcelHelpers.export(exports, "removePathFromField", ()=>removePathFromField);
parcelHelpers.export(exports, "replaceAll", ()=>replaceAll);
parcelHelpers.export(exports, "replacePathInField", ()=>replacePathInField);
parcelHelpers.export(exports, "resetIdCounter", ()=>resetIdCounter);
parcelHelpers.export(exports, "setEqual", ()=>setEqual);
parcelHelpers.export(exports, "some", ()=>some);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "titleCase", ()=>titleCase);
parcelHelpers.export(exports, "unique", ()=>unique);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "vals", ()=>vals);
parcelHelpers.export(exports, "varName", ()=>varName);
parcelHelpers.export(exports, "version", ()=>version);
var _vegaUtil = require("vega-util");
var _vega = require("vega");
var _vegaEventSelector = require("vega-event-selector");
var _vegaExpression = require("vega-expression");
var version$1 = "6.1.0";
var pkg = {
    version: version$1
};
function isLogicalOr(op) {
    return hasProperty(op, 'or');
}
function isLogicalAnd(op) {
    return hasProperty(op, 'and');
}
function isLogicalNot(op) {
    return hasProperty(op, 'not');
}
function forEachLeaf(op, fn) {
    if (isLogicalNot(op)) forEachLeaf(op.not, fn);
    else if (isLogicalAnd(op)) for (const subop of op.and)forEachLeaf(subop, fn);
    else if (isLogicalOr(op)) for (const subop of op.or)forEachLeaf(subop, fn);
    else fn(op);
}
function normalizeLogicalComposition(op, normalizer) {
    if (isLogicalNot(op)) return {
        not: normalizeLogicalComposition(op.not, normalizer)
    };
    else if (isLogicalAnd(op)) return {
        and: op.and.map((o)=>normalizeLogicalComposition(o, normalizer))
    };
    else if (isLogicalOr(op)) return {
        or: op.or.map((o)=>normalizeLogicalComposition(o, normalizer))
    };
    else return normalizer(op);
}
const duplicate = structuredClone;
function never(message) {
    throw new Error(message);
}
/**
 * Creates an object composed of the picked object properties.
 *
 * var object = {'a': 1, 'b': '2', 'c': 3};
 * pick(object, ['a', 'c']);
 * // → {'a': 1, 'c': 3}
 */ function pick(obj, props) {
    const copy = {};
    for (const prop of props)if ((0, _vegaUtil.hasOwnProperty)(obj, prop)) copy[prop] = obj[prop];
    return copy;
}
/**
 * The opposite of _.pick; this method creates an object composed of the own
 * and inherited enumerable string keyed properties of object that are not omitted.
 */ function omit(obj, props) {
    const copy = {
        ...obj
    };
    for (const prop of props)delete copy[prop];
    return copy;
}
/**
 * Monkey patch Set so that `stringify` produces a string representation of sets.
 */ Set.prototype['toJSON'] = function() {
    return `Set(${[
        ...this
    ].map((x)=>stringify(x)).join(',')})`;
};
/**
 * Converts any object to a string of limited size, or a number.
 */ function hash(a) {
    if ((0, _vegaUtil.isNumber)(a)) return a;
    const str = (0, _vegaUtil.isString)(a) ? a : stringify(a);
    // short strings can be used as hash directly, longer strings are hashed to reduce memory usage
    if (str.length < 250) return str;
    // from http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    let h = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        h = (h << 5) - h + char;
        h = h & h; // Convert to 32bit integer
    }
    return h;
}
function isNullOrFalse(x) {
    return x === false || x === null;
}
function contains(array, item) {
    return array.includes(item);
}
/**
 * Returns true if any item returns true.
 */ function some(arr, f) {
    let i = 0;
    for (const [k, a] of arr.entries()){
        if (f(a, k, i++)) return true;
    }
    return false;
}
/**
 * Returns true if all items return true.
 */ function every(arr, f) {
    let i = 0;
    for (const [k, a] of arr.entries()){
        if (!f(a, k, i++)) return false;
    }
    return true;
}
/**
 * recursively merges src into dest
 */ function mergeDeep(dest, ...src) {
    for (const s of src)deepMerge_(dest, s ?? {});
    return dest;
}
function deepMerge_(dest, src) {
    for (const property of keys(src))(0, _vegaUtil.writeConfig)(dest, property, src[property], true);
}
function unique(values, f) {
    const results = [];
    const u = {};
    let v;
    for (const val of values){
        v = f(val);
        if (v in u) continue;
        u[v] = 1;
        results.push(val);
    }
    return results;
}
/**
 * Returns true if the two dictionaries agree. Applies only to defined values.
 */ function isEqual(dict, other) {
    const dictKeys = keys(dict);
    const otherKeys = keys(other);
    if (dictKeys.length !== otherKeys.length) return false;
    for (const key of dictKeys){
        if (dict[key] !== other[key]) return false;
    }
    return true;
}
function setEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const e of a){
        if (!b.has(e)) return false;
    }
    return true;
}
function hasIntersection(a, b) {
    for (const key of a){
        if (b.has(key)) return true;
    }
    return false;
}
function prefixGenerator(a) {
    const prefixes = new Set();
    for (const x of a){
        const splitField = (0, _vegaUtil.splitAccessPath)(x);
        // Wrap every element other than the first in `[]`
        const wrappedWithAccessors = splitField.map((y, i)=>i === 0 ? y : `[${y}]`);
        const computedPrefixes = wrappedWithAccessors.map((_, i)=>wrappedWithAccessors.slice(0, i + 1).join(''));
        for (const y of computedPrefixes)prefixes.add(y);
    }
    return prefixes;
}
/**
 * Returns true if a and b have an intersection. Also return true if a or b are undefined
 * since this means we don't know what fields a node produces or depends on.
 */ function fieldIntersection(a, b) {
    if (a === undefined || b === undefined) return true;
    return hasIntersection(prefixGenerator(a), prefixGenerator(b));
}
function isEmpty(obj) {
    return keys(obj).length === 0;
}
// This is a stricter version of Object.keys but with better types. See https://github.com/Microsoft/TypeScript/pull/12253#issuecomment-263132208
const keys = Object.keys;
// Stricter version from https://github.com/microsoft/TypeScript/issues/51572#issuecomment-1319153323
const vals = Object.values;
// Stricter version from https://github.com/microsoft/TypeScript/issues/51572#issuecomment-1319153323
const entries$1 = Object.entries;
function isBoolean(b) {
    return b === true || b === false;
}
/**
 * Convert a string into a valid variable name
 */ function varName(s) {
    // Replace non-alphanumeric characters (anything besides a-zA-Z0-9_) with _
    const alphanumericS = s.replace(/\W/g, '_');
    // Add _ if the string has leading numbers.
    return (s.match(/^\d+/) ? '_' : '') + alphanumericS;
}
function logicalExpr(op, cb) {
    if (isLogicalNot(op)) return `!(${logicalExpr(op.not, cb)})`;
    else if (isLogicalAnd(op)) return `(${op.and.map((and)=>logicalExpr(and, cb)).join(') && (')})`;
    else if (isLogicalOr(op)) return `(${op.or.map((or)=>logicalExpr(or, cb)).join(') || (')})`;
    else return cb(op);
}
/**
 * Delete nested property of an object, and delete the ancestors of the property if they become empty.
 */ function deleteNestedProperty(obj, orderedProps) {
    if (orderedProps.length === 0) return true;
    const prop = orderedProps.shift();
    if (prop in obj && deleteNestedProperty(obj[prop], orderedProps)) delete obj[prop];
    return isEmpty(obj);
}
function titleCase(s) {
    return s.charAt(0).toUpperCase() + s.substr(1);
}
/**
 * Converts a path to an access path with datum.
 * @param path The field name.
 * @param datum The string to use for `datum`.
 */ function accessPathWithDatum(path, datum = 'datum') {
    const pieces = (0, _vegaUtil.splitAccessPath)(path);
    const prefixes = [];
    for(let i = 1; i <= pieces.length; i++){
        const prefix = `[${pieces.slice(0, i).map((0, _vegaUtil.stringValue)).join('][')}]`;
        prefixes.push(`${datum}${prefix}`);
    }
    return prefixes.join(' && ');
}
/**
 * Return access with datum to the flattened field.
 *
 * @param path The field name.
 * @param datum The string to use for `datum`.
 */ function flatAccessWithDatum(path, datum = 'datum') {
    return `${datum}[${(0, _vegaUtil.stringValue)((0, _vegaUtil.splitAccessPath)(path).join('.'))}]`;
}
/**
 * Return access with datum to **an unescaped path**.
 *
 * ```ts
 * console.log(accessWithDatumToUnescapedPath("vega's favorite"))
 * // "datum['vega\\'s favorite']"
 * ```
 *
 * @param path The unescaped path name. E.g., `"a.b"`, `"vega's favorite"`. (Note
 * that the field defs take escaped strings like `"a\\.b"`, `"vega\\'s favorite"`,
 * but this function is for the unescaped field/path)
 */ function accessWithDatumToUnescapedPath(unescapedPath) {
    const singleQuoteEscapedPath = unescapedPath.replaceAll("'", "\\'");
    return `datum['${singleQuoteEscapedPath}']`;
}
function escapePathAccess(string) {
    return string.replace(/(\[|\]|\.|'|")/g, '\\$1');
}
/**
 * Replaces path accesses with access to non-nested field.
 * For example, `foo["bar"].baz` becomes `foo\\.bar\\.baz`.
 */ function replacePathInField(path) {
    return `${(0, _vegaUtil.splitAccessPath)(path).map(escapePathAccess).join('\\.')}`;
}
/**
 * Replace all occurrences of a string with another string.
 *
 * @param string the string to replace in
 * @param find the string to replace
 * @param replacement the replacement
 */ function replaceAll(string, find, replacement) {
    return string.replace(new RegExp(find.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replacement);
}
/**
 * Remove path accesses with access from field.
 * For example, `foo["bar"].baz` becomes `foo.bar.baz`.
 */ function removePathFromField(path) {
    return `${(0, _vegaUtil.splitAccessPath)(path).join('.')}`;
}
/**
 * Count the depth of the path. Returns 1 for fields that are not nested.
 */ function accessPathDepth(path) {
    if (!path) return 0;
    return (0, _vegaUtil.splitAccessPath)(path).length;
}
/**
 * This is a replacement for chained || for numeric properties or properties that respect null so that 0 will be included.
 */ function getFirstDefined(...args) {
    return args.find((a)=>a !== undefined);
}
// variable used to generate id
let idCounter = 42;
/**
 * Returns a new random id every time it gets called.
 *
 * Has side effect!
 */ function uniqueId(prefix) {
    const id = ++idCounter;
    return prefix ? String(prefix) + id : id;
}
/**
 * Resets the id counter used in uniqueId. This can be useful for testing.
 */ function resetIdCounter() {
    idCounter = 42;
}
function internalField(name) {
    return isInternalField(name) ? name : `__${name}`;
}
function isInternalField(name) {
    return name.startsWith('__');
}
/**
 * Normalize angle to be within [0,360).
 */ function normalizeAngle(angle) {
    if (angle === undefined) return undefined;
    return (angle % 360 + 360) % 360;
}
/**
 * Returns whether the passed in value is a valid number.
 */ function isNumeric(value) {
    if ((0, _vegaUtil.isNumber)(value)) return true;
    return !isNaN(value) && !isNaN(parseFloat(value));
}
const clonedProto = Object.getPrototypeOf(structuredClone({}));
/**
 * Compares two values for equality, including arrays and objects.
 *
 * Adapted from https://github.com/epoberezkin/fast-deep-equal.
 */ function deepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        // compare names to avoid issues with structured clone
        if (a.constructor.name !== b.constructor.name) return false;
        let length;
        let i;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!deepEqual(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (const e of a.entries())if (!b.has(e[0])) return false;
            for (const e of a.entries())if (!deepEqual(e[1], b.get(e[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (const e of a.entries())if (!b.has(e[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // also compare to structured clone prototype
        if (a.valueOf !== Object.prototype.valueOf && a.valueOf !== clonedProto.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && a.toString !== clonedProto.toString) return a.toString() === b.toString();
        const ks = Object.keys(a);
        length = ks.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, ks[i])) return false;
        for(i = length; i-- !== 0;){
            const key = ks[i];
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
}
/**
 * Converts any object to a string representation that can be consumed by humans.
 *
 * Adapted from https://github.com/epoberezkin/fast-json-stable-stringify
 */ function stringify(data) {
    const seen = [];
    return function _stringify(node) {
        if (node?.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return undefined;
        if (typeof node == 'number') return isFinite(node) ? `${node}` : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        let i;
        let out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += _stringify(node[i]) || 'null';
            }
            return `${out}]`;
        }
        if (node === null) return 'null';
        if (seen.includes(node)) throw new TypeError('Converting circular structure to JSON');
        const seenIndex = seen.push(node) - 1;
        const ks = Object.keys(node).sort();
        out = '';
        for(i = 0; i < ks.length; i++){
            const key = ks[i];
            const value = _stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += `${JSON.stringify(key)}:${value}`;
        }
        seen.splice(seenIndex, 1);
        return `{${out}}`;
    }(data);
}
/**
 * Check if the input object has the property and it's not undefined.
 *
 * @param object the object
 * @param property the property to search
 * @returns if the object has the property and it's not undefined.
 */ function hasProperty(obj, key) {
    return (0, _vegaUtil.isObject)(obj) && (0, _vegaUtil.hasOwnProperty)(obj, key) && obj[key] !== undefined;
}
/*
 * Constants and utilities for encoding channels (Visual variables)
 * such as 'x', 'y', 'color'.
 */ // Facet
const ROW = 'row';
const COLUMN = 'column';
const FACET = 'facet';
// Position
const X = 'x';
const Y = 'y';
const X2 = 'x2';
const Y2 = 'y2';
// Position Offset
const XOFFSET = 'xOffset';
const YOFFSET = 'yOffset';
// Arc-Position
const RADIUS = 'radius';
const RADIUS2 = 'radius2';
const THETA = 'theta';
const THETA2 = 'theta2';
// Geo Position
const LATITUDE = 'latitude';
const LONGITUDE = 'longitude';
const LATITUDE2 = 'latitude2';
const LONGITUDE2 = 'longitude2';
// Time
const TIME = 'time';
// Mark property with scale
const COLOR = 'color';
const FILL = 'fill';
const STROKE = 'stroke';
const SHAPE = 'shape';
const SIZE = 'size';
const ANGLE = 'angle';
const OPACITY = 'opacity';
const FILLOPACITY = 'fillOpacity';
const STROKEOPACITY = 'strokeOpacity';
const STROKEWIDTH = 'strokeWidth';
const STROKEDASH = 'strokeDash';
// Non-scale channel
const TEXT$1 = 'text';
const ORDER = 'order';
const DETAIL = 'detail';
const KEY = 'key';
const TOOLTIP = 'tooltip';
const HREF = 'href';
const URL = 'url';
const DESCRIPTION = 'description';
const POSITION_CHANNEL_INDEX = {
    x: 1,
    y: 1,
    x2: 1,
    y2: 1
};
const POLAR_POSITION_CHANNEL_INDEX = {
    theta: 1,
    theta2: 1,
    radius: 1,
    radius2: 1
};
function isPolarPositionChannel(c) {
    return (0, _vegaUtil.hasOwnProperty)(POLAR_POSITION_CHANNEL_INDEX, c);
}
const GEO_POSIITON_CHANNEL_INDEX = {
    longitude: 1,
    longitude2: 1,
    latitude: 1,
    latitude2: 1
};
function getPositionChannelFromLatLong(channel) {
    switch(channel){
        case LATITUDE:
            return 'y';
        case LATITUDE2:
            return 'y2';
        case LONGITUDE:
            return 'x';
        case LONGITUDE2:
            return 'x2';
    }
}
function isGeoPositionChannel(c) {
    return (0, _vegaUtil.hasOwnProperty)(GEO_POSIITON_CHANNEL_INDEX, c);
}
const GEOPOSITION_CHANNELS = keys(GEO_POSIITON_CHANNEL_INDEX);
const UNIT_CHANNEL_INDEX = {
    ...POSITION_CHANNEL_INDEX,
    ...POLAR_POSITION_CHANNEL_INDEX,
    ...GEO_POSIITON_CHANNEL_INDEX,
    xOffset: 1,
    yOffset: 1,
    // color
    color: 1,
    fill: 1,
    stroke: 1,
    // time
    time: 1,
    // other non-position with scale
    opacity: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDash: 1,
    size: 1,
    angle: 1,
    shape: 1,
    // channels without scales
    order: 1,
    text: 1,
    detail: 1,
    key: 1,
    tooltip: 1,
    href: 1,
    url: 1,
    description: 1
};
function isColorChannel(channel) {
    return channel === COLOR || channel === FILL || channel === STROKE;
}
const FACET_CHANNEL_INDEX = {
    row: 1,
    column: 1,
    facet: 1
};
const FACET_CHANNELS = keys(FACET_CHANNEL_INDEX);
const CHANNEL_INDEX = {
    ...UNIT_CHANNEL_INDEX,
    ...FACET_CHANNEL_INDEX
};
const CHANNELS = keys(CHANNEL_INDEX);
const { order: _o, detail: _d, tooltip: _tt1, ...SINGLE_DEF_CHANNEL_INDEX } = CHANNEL_INDEX;
const { row: _r, column: _c, facet: _f, ...SINGLE_DEF_UNIT_CHANNEL_INDEX } = SINGLE_DEF_CHANNEL_INDEX;
function isSingleDefUnitChannel(str) {
    return (0, _vegaUtil.hasOwnProperty)(SINGLE_DEF_UNIT_CHANNEL_INDEX, str);
}
function isChannel(str) {
    return (0, _vegaUtil.hasOwnProperty)(CHANNEL_INDEX, str);
}
const SECONDARY_RANGE_CHANNEL = [
    X2,
    Y2,
    LATITUDE2,
    LONGITUDE2,
    THETA2,
    RADIUS2
];
function isSecondaryRangeChannel(c) {
    const main = getMainRangeChannel(c);
    return main !== c;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ function getMainRangeChannel(channel) {
    switch(channel){
        case X2:
            return X;
        case Y2:
            return Y;
        case LATITUDE2:
            return LATITUDE;
        case LONGITUDE2:
            return LONGITUDE;
        case THETA2:
            return THETA;
        case RADIUS2:
            return RADIUS;
    }
    return channel;
}
function getVgPositionChannel(channel) {
    if (isPolarPositionChannel(channel)) switch(channel){
        case THETA:
            return 'startAngle';
        case THETA2:
            return 'endAngle';
        case RADIUS:
            return 'outerRadius';
        case RADIUS2:
            return 'innerRadius';
    }
    return channel;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ function getSecondaryRangeChannel(channel) {
    switch(channel){
        case X:
            return X2;
        case Y:
            return Y2;
        case LATITUDE:
            return LATITUDE2;
        case LONGITUDE:
            return LONGITUDE2;
        case THETA:
            return THETA2;
        case RADIUS:
            return RADIUS2;
    }
    return undefined;
}
function getSizeChannel(channel) {
    switch(channel){
        case X:
        case X2:
            return 'width';
        case Y:
        case Y2:
            return 'height';
    }
    return undefined;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ function getOffsetChannel(channel) {
    switch(channel){
        case X:
            return 'xOffset';
        case Y:
            return 'yOffset';
        case X2:
            return 'x2Offset';
        case Y2:
            return 'y2Offset';
        case THETA:
            return 'thetaOffset';
        case RADIUS:
            return 'radiusOffset';
        case THETA2:
            return 'theta2Offset';
        case RADIUS2:
            return 'radius2Offset';
    }
    return undefined;
}
/**
 * Get the main channel for a range channel. E.g. `x` for `x2`.
 */ function getOffsetScaleChannel(channel) {
    switch(channel){
        case X:
            return 'xOffset';
        case Y:
            return 'yOffset';
    }
    return undefined;
}
function getMainChannelFromOffsetChannel(channel) {
    switch(channel){
        case 'xOffset':
            return 'x';
        case 'yOffset':
            return 'y';
    }
}
// CHANNELS without COLUMN, ROW
const UNIT_CHANNELS = keys(UNIT_CHANNEL_INDEX);
// NONPOSITION_CHANNELS = UNIT_CHANNELS without X, Y, X2, Y2;
const { x: _x, y: _y, // x2 and y2 share the same scale as x and y
x2: _x2, y2: _y2, //
xOffset: _xo, yOffset: _yo, latitude: _latitude, longitude: _longitude, latitude2: _latitude2, longitude2: _longitude2, theta: _theta, theta2: _theta2, radius: _radius, radius2: _radius2, // The rest of unit channels then have scale
...NONPOSITION_CHANNEL_INDEX } = UNIT_CHANNEL_INDEX;
const NONPOSITION_CHANNELS = keys(NONPOSITION_CHANNEL_INDEX);
const POSITION_SCALE_CHANNEL_INDEX = {
    x: 1,
    y: 1
};
const POSITION_SCALE_CHANNELS = keys(POSITION_SCALE_CHANNEL_INDEX);
function isXorY(channel) {
    return (0, _vegaUtil.hasOwnProperty)(POSITION_SCALE_CHANNEL_INDEX, channel);
}
const POLAR_POSITION_SCALE_CHANNEL_INDEX = {
    theta: 1,
    radius: 1
};
const POLAR_POSITION_SCALE_CHANNELS = keys(POLAR_POSITION_SCALE_CHANNEL_INDEX);
function getPositionScaleChannel(sizeType) {
    return sizeType === 'width' ? X : Y;
}
const OFFSET_SCALE_CHANNEL_INDEX = {
    xOffset: 1,
    yOffset: 1
};
function isXorYOffset(channel) {
    return (0, _vegaUtil.hasOwnProperty)(OFFSET_SCALE_CHANNEL_INDEX, channel);
}
const TIME_SCALE_CHANNEL_INDEX = {
    time: 1
};
function isTime(channel) {
    return channel in TIME_SCALE_CHANNEL_INDEX;
}
// NON_POSITION_SCALE_CHANNEL = SCALE_CHANNELS without position / offset
const { // x2 and y2 share the same scale as x and y
// text and tooltip have format instead of scale,
// href has neither format, nor scale
text: _t, tooltip: _tt, href: _hr, url: _u, description: _al, // detail and order have no scale
detail: _dd, key: _k, order: _oo, ...NONPOSITION_SCALE_CHANNEL_INDEX } = NONPOSITION_CHANNEL_INDEX;
const NONPOSITION_SCALE_CHANNELS = keys(NONPOSITION_SCALE_CHANNEL_INDEX);
function isNonPositionScaleChannel(channel) {
    return (0, _vegaUtil.hasOwnProperty)(NONPOSITION_CHANNEL_INDEX, channel);
}
/**
 * @returns whether Vega supports legends for a particular channel
 */ function supportLegend(channel) {
    switch(channel){
        case COLOR:
        case FILL:
        case STROKE:
        case SIZE:
        case SHAPE:
        case OPACITY:
        case STROKEWIDTH:
        case STROKEDASH:
            return true;
        case FILLOPACITY:
        case STROKEOPACITY:
        case ANGLE:
        case TIME:
            return false;
    }
}
// Declare SCALE_CHANNEL_INDEX
const SCALE_CHANNEL_INDEX = {
    ...POSITION_SCALE_CHANNEL_INDEX,
    ...POLAR_POSITION_SCALE_CHANNEL_INDEX,
    ...OFFSET_SCALE_CHANNEL_INDEX,
    ...NONPOSITION_SCALE_CHANNEL_INDEX
};
/** List of channels with scales */ const SCALE_CHANNELS = keys(SCALE_CHANNEL_INDEX);
function isScaleChannel(channel) {
    return (0, _vegaUtil.hasOwnProperty)(SCALE_CHANNEL_INDEX, channel);
}
/**
 * Return whether a channel supports a particular mark type.
 * @param channel  channel name
 * @param mark the mark type
 * @return whether the mark supports the channel
 */ function supportMark(channel, mark) {
    return getSupportedMark(channel)[mark];
}
const ALL_MARKS = {
    // all marks
    arc: 'always',
    area: 'always',
    bar: 'always',
    circle: 'always',
    geoshape: 'always',
    image: 'always',
    line: 'always',
    rule: 'always',
    point: 'always',
    rect: 'always',
    square: 'always',
    trail: 'always',
    text: 'always',
    tick: 'always'
};
const { geoshape: _g, ...ALL_MARKS_EXCEPT_GEOSHAPE } = ALL_MARKS;
/**
 * Return a dictionary showing whether a channel supports mark type.
 * @param channel
 * @return A dictionary mapping mark types to 'always', 'binned', or undefined
 */ function getSupportedMark(channel) {
    switch(channel){
        case COLOR:
        case FILL:
        case STROKE:
        // falls through
        case DESCRIPTION:
        case DETAIL:
        case KEY:
        case TOOLTIP:
        case HREF:
        case ORDER:
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        case STROKEWIDTH:
        // falls through
        case FACET:
        case ROW:
        case COLUMN:
            return ALL_MARKS;
        case X:
        case Y:
        case XOFFSET:
        case YOFFSET:
        case LATITUDE:
        case LONGITUDE:
        case TIME:
            // all marks except geoshape. geoshape does not use X, Y -- it uses a projection
            return ALL_MARKS_EXCEPT_GEOSHAPE;
        case X2:
        case Y2:
        case LATITUDE2:
        case LONGITUDE2:
            return {
                area: 'always',
                bar: 'always',
                image: 'always',
                rect: 'always',
                rule: 'always',
                circle: 'binned',
                point: 'binned',
                square: 'binned',
                tick: 'binned',
                line: 'binned',
                trail: 'binned'
            };
        case SIZE:
            return {
                point: 'always',
                tick: 'always',
                rule: 'always',
                circle: 'always',
                square: 'always',
                bar: 'always',
                text: 'always',
                line: 'always',
                trail: 'always'
            };
        case STROKEDASH:
            return {
                line: 'always',
                point: 'always',
                tick: 'always',
                rule: 'always',
                circle: 'always',
                square: 'always',
                bar: 'always',
                geoshape: 'always'
            };
        case SHAPE:
            return {
                point: 'always',
                geoshape: 'always'
            };
        case TEXT$1:
            return {
                text: 'always'
            };
        case ANGLE:
            return {
                point: 'always',
                square: 'always',
                text: 'always'
            };
        case URL:
            return {
                image: 'always'
            };
        case THETA:
            return {
                text: 'always',
                arc: 'always'
            };
        case RADIUS:
            return {
                text: 'always',
                arc: 'always'
            };
        case THETA2:
        case RADIUS2:
            return {
                arc: 'always'
            };
    }
}
function rangeType(channel) {
    switch(channel){
        case X:
        case Y:
        case THETA:
        case RADIUS:
        case XOFFSET:
        case YOFFSET:
        case SIZE:
        case ANGLE:
        case STROKEWIDTH:
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        case TIME:
        // X2 and Y2 use X and Y scales, so they similarly have continuous range. [falls through]
        case X2:
        case Y2:
        case THETA2:
        case RADIUS2:
            return undefined;
        case FACET:
        case ROW:
        case COLUMN:
        case SHAPE:
        case STROKEDASH:
        // TEXT, TOOLTIP, URL, and HREF have no scale but have discrete output [falls through]
        case TEXT$1:
        case TOOLTIP:
        case HREF:
        case URL:
        case DESCRIPTION:
            return 'discrete';
        // Color can be either continuous or discrete, depending on scale type.
        case COLOR:
        case FILL:
        case STROKE:
            return 'flexible';
        // No scale, no range type.
        case LATITUDE:
        case LONGITUDE:
        case LATITUDE2:
        case LONGITUDE2:
        case DETAIL:
        case KEY:
        case ORDER:
            return undefined;
    }
}
const AGGREGATE_OP_INDEX = {
    argmax: 1,
    argmin: 1,
    average: 1,
    count: 1,
    distinct: 1,
    exponential: 1,
    exponentialb: 1,
    product: 1,
    max: 1,
    mean: 1,
    median: 1,
    min: 1,
    missing: 1,
    q1: 1,
    q3: 1,
    ci0: 1,
    ci1: 1,
    stderr: 1,
    stdev: 1,
    stdevp: 1,
    sum: 1,
    valid: 1,
    values: 1,
    variance: 1,
    variancep: 1
};
const MULTIDOMAIN_SORT_OP_INDEX = {
    count: 1,
    min: 1,
    max: 1
};
function isArgminDef(a) {
    return hasProperty(a, 'argmin');
}
function isArgmaxDef(a) {
    return hasProperty(a, 'argmax');
}
function isAggregateOp(a) {
    return (0, _vegaUtil.isString)(a) && (0, _vegaUtil.hasOwnProperty)(AGGREGATE_OP_INDEX, a);
}
const COUNTING_OPS = new Set([
    'count',
    'valid',
    'missing',
    'distinct'
]);
function isCountingAggregateOp(aggregate) {
    return (0, _vegaUtil.isString)(aggregate) && COUNTING_OPS.has(aggregate);
}
function isMinMaxOp(aggregate) {
    return (0, _vegaUtil.isString)(aggregate) && contains([
        'min',
        'max'
    ], aggregate);
}
/** Additive-based aggregation operations. These can be applied to stack. */ const SUM_OPS = new Set([
    'count',
    'sum',
    'distinct',
    'valid',
    'missing'
]);
/**
 * Aggregation operators that always produce values within the range [domainMin, domainMax].
 */ const SHARED_DOMAIN_OPS = new Set([
    'mean',
    'average',
    'median',
    'q1',
    'q3',
    'min',
    'max'
]);
/**
 * Create a key for the bin configuration. Not for prebinned bin.
 */ function binToString(bin) {
    if ((0, _vegaUtil.isBoolean)(bin)) bin = normalizeBin(bin, undefined);
    return `bin${keys(bin).map((p)=>isParameterExtent(bin[p]) ? varName(`_${p}_${entries$1(bin[p])}`) : varName(`_${p}_${bin[p]}`)).join('')}`;
}
/**
 * Vega-Lite should bin the data.
 */ function isBinning(bin) {
    return bin === true || isBinParams(bin) && !bin.binned;
}
/**
 * The data is already binned and so Vega-Lite should not bin it again.
 */ function isBinned(bin) {
    return bin === 'binned' || isBinParams(bin) && bin.binned === true;
}
function isBinParams(bin) {
    return (0, _vegaUtil.isObject)(bin);
}
function isParameterExtent(extent) {
    return hasProperty(extent, 'param');
}
function autoMaxBins(channel) {
    switch(channel){
        case ROW:
        case COLUMN:
        case SIZE:
        case COLOR:
        case FILL:
        case STROKE:
        case STROKEWIDTH:
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        // Facets and Size shouldn't have too many bins
        // We choose 6 like shape to simplify the rule [falls through]
        case SHAPE:
            return 6; // Vega's "shape" has 6 distinct values
        case STROKEDASH:
            return 4; // We only provide 5 different stroke dash values (but 4 is more effective)
        default:
            return 10;
    }
}
function isExprRef(o) {
    return hasProperty(o, 'expr');
}
function replaceExprRef(index, { level } = {
    level: 0
}) {
    const props = keys(index || {});
    const newIndex = {};
    for (const prop of props)newIndex[prop] = level === 0 ? signalRefOrValue(index[prop]) : replaceExprRef(index[prop], {
        level: level - 1
    });
    return newIndex;
}
function extractTitleConfig(titleConfig) {
    const { // These are non-mark title config that need to be hardcoded
    anchor, frame, offset, orient, angle, limit, // color needs to be redirect to fill
    color, // subtitle properties
    subtitleColor, subtitleFont, subtitleFontSize, subtitleFontStyle, subtitleFontWeight, subtitleLineHeight, subtitlePadding, // The rest are mark config.
    ...rest } = titleConfig;
    const titleMarkConfig = {
        ...rest,
        ...color ? {
            fill: color
        } : {}
    };
    // These are non-mark title config that need to be hardcoded
    const nonMarkTitleProperties = {
        ...anchor ? {
            anchor
        } : {},
        ...frame ? {
            frame
        } : {},
        ...offset ? {
            offset
        } : {},
        ...orient ? {
            orient
        } : {},
        ...angle !== undefined ? {
            angle
        } : {},
        ...limit !== undefined ? {
            limit
        } : {}
    };
    // subtitle part can stay in config.title since header titles do not use subtitle
    const subtitle = {
        ...subtitleColor ? {
            subtitleColor
        } : {},
        ...subtitleFont ? {
            subtitleFont
        } : {},
        ...subtitleFontSize ? {
            subtitleFontSize
        } : {},
        ...subtitleFontStyle ? {
            subtitleFontStyle
        } : {},
        ...subtitleFontWeight ? {
            subtitleFontWeight
        } : {},
        ...subtitleLineHeight ? {
            subtitleLineHeight
        } : {},
        ...subtitlePadding ? {
            subtitlePadding
        } : {}
    };
    const subtitleMarkConfig = pick(titleConfig, [
        'align',
        'baseline',
        'dx',
        'dy',
        'limit'
    ]);
    return {
        titleMarkConfig,
        subtitleMarkConfig,
        nonMarkTitleProperties,
        subtitle
    };
}
function isText(v) {
    return (0, _vegaUtil.isString)(v) || (0, _vegaUtil.isArray)(v) && (0, _vegaUtil.isString)(v[0]);
}
function isSignalRef(o) {
    return hasProperty(o, 'signal');
}
function isVgRangeStep(range) {
    return hasProperty(range, 'step');
}
function isDataRefUnionedDomain(domain) {
    if (!(0, _vegaUtil.isArray)(domain)) return hasProperty(domain, 'fields') && !hasProperty(domain, 'data');
    return false;
}
function isFieldRefUnionDomain(domain) {
    if (!(0, _vegaUtil.isArray)(domain)) return hasProperty(domain, 'fields') && hasProperty(domain, 'data');
    return false;
}
function isDataRefDomain(domain) {
    if (!(0, _vegaUtil.isArray)(domain)) return hasProperty(domain, 'field') && hasProperty(domain, 'data');
    return false;
}
const VG_MARK_CONFIG_INDEX = {
    aria: 1,
    description: 1,
    ariaRole: 1,
    ariaRoleDescription: 1,
    blend: 1,
    opacity: 1,
    fill: 1,
    fillOpacity: 1,
    stroke: 1,
    strokeCap: 1,
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeDash: 1,
    strokeDashOffset: 1,
    strokeJoin: 1,
    strokeOffset: 1,
    strokeMiterLimit: 1,
    startAngle: 1,
    endAngle: 1,
    padAngle: 1,
    innerRadius: 1,
    outerRadius: 1,
    size: 1,
    shape: 1,
    interpolate: 1,
    tension: 1,
    orient: 1,
    align: 1,
    baseline: 1,
    text: 1,
    dir: 1,
    dx: 1,
    dy: 1,
    ellipsis: 1,
    limit: 1,
    radius: 1,
    theta: 1,
    angle: 1,
    font: 1,
    fontSize: 1,
    fontWeight: 1,
    fontStyle: 1,
    lineBreak: 1,
    lineHeight: 1,
    cursor: 1,
    href: 1,
    tooltip: 1,
    cornerRadius: 1,
    cornerRadiusTopLeft: 1,
    cornerRadiusTopRight: 1,
    cornerRadiusBottomLeft: 1,
    cornerRadiusBottomRight: 1,
    aspect: 1,
    width: 1,
    height: 1,
    url: 1,
    smooth: 1
};
const VG_MARK_CONFIGS = keys(VG_MARK_CONFIG_INDEX);
const VG_MARK_INDEX = {
    arc: 1,
    area: 1,
    group: 1,
    image: 1,
    line: 1,
    path: 1,
    rect: 1,
    rule: 1,
    shape: 1,
    symbol: 1,
    text: 1,
    trail: 1
};
// Vega's cornerRadius channels.
const VG_CORNERRADIUS_CHANNELS = [
    'cornerRadius',
    'cornerRadiusTopLeft',
    'cornerRadiusTopRight',
    'cornerRadiusBottomLeft',
    'cornerRadiusBottomRight'
];
function signalOrValueRefWithCondition(val) {
    const condition = (0, _vegaUtil.isArray)(val.condition) ? val.condition.map(conditionalSignalRefOrValue) : conditionalSignalRefOrValue(val.condition);
    return {
        ...signalRefOrValue(val),
        condition
    };
}
function signalRefOrValue(value) {
    if (isExprRef(value)) {
        const { expr, ...rest } = value;
        return {
            signal: expr,
            ...rest
        };
    }
    return value;
}
function conditionalSignalRefOrValue(value) {
    if (isExprRef(value)) {
        const { expr, ...rest } = value;
        return {
            signal: expr,
            ...rest
        };
    }
    return value;
}
function signalOrValueRef(value) {
    if (isExprRef(value)) {
        const { expr, ...rest } = value;
        return {
            signal: expr,
            ...rest
        };
    }
    if (isSignalRef(value)) return value;
    return value !== undefined ? {
        value
    } : undefined;
}
function exprFromSignalRefOrValue(ref) {
    if (isSignalRef(ref)) return ref.signal;
    return (0, _vegaUtil.stringValue)(ref);
}
function exprFromValueRefOrSignalRef(ref) {
    if (isSignalRef(ref)) return ref.signal;
    return (0, _vegaUtil.stringValue)(ref.value);
}
function signalOrStringValue(v) {
    if (isSignalRef(v)) return v.signal;
    return v == null ? null : (0, _vegaUtil.stringValue)(v);
}
function applyMarkConfig(e, model, propsList) {
    for (const property of propsList){
        const value = getMarkConfig(property, model.markDef, model.config);
        if (value !== undefined) e[property] = signalOrValueRef(value);
    }
    return e;
}
function getStyles(mark) {
    return [].concat(mark.type, mark.style ?? []);
}
function getMarkPropOrConfig(channel, mark, config, opt = {}) {
    const { vgChannel, ignoreVgConfig } = opt;
    if (vgChannel && hasProperty(mark, vgChannel)) return mark[vgChannel];
    else if (mark[channel] !== undefined) return mark[channel];
    else if (ignoreVgConfig && (!vgChannel || vgChannel === channel)) return undefined;
    return getMarkConfig(channel, mark, config, opt);
}
/**
 * Return property value from style or mark specific config property if exists.
 * Otherwise, return general mark specific config.
 */ function getMarkConfig(channel, mark, config, { vgChannel } = {}) {
    const cfg = getMarkStyleConfig(channel, mark, config.style);
    return getFirstDefined(// style config has highest precedence
    vgChannel ? cfg : undefined, cfg, // then mark-specific config
    vgChannel ? config[mark.type][vgChannel] : undefined, config[mark.type][channel], // If there is vgChannel, skip vl channel.
    // For example, vl size for text is vg fontSize, but config.mark.size is only for point size.
    vgChannel ? config.mark[vgChannel] : config.mark[channel]);
}
function getMarkStyleConfig(prop, mark, styleConfigIndex) {
    return getStyleConfig(prop, getStyles(mark), styleConfigIndex);
}
function getStyleConfig(p, styles, styleConfigIndex) {
    styles = (0, _vegaUtil.array)(styles);
    let value;
    for (const style of styles){
        const styleConfig = styleConfigIndex[style];
        if (hasProperty(styleConfig, p)) value = styleConfig[p];
    }
    return value;
}
/**
 * Return Vega sort parameters (tuple of field and order).
 */ function sortParams(orderDef, fieldRefOption) {
    return (0, _vegaUtil.array)(orderDef).reduce((s, orderChannelDef)=>{
        s.field.push(vgField(orderChannelDef, fieldRefOption));
        s.order.push(orderChannelDef.sort ?? 'ascending');
        return s;
    }, {
        field: [],
        order: []
    });
}
function mergeTitleFieldDefs(f1, f2) {
    const merged = [
        ...f1
    ];
    f2.forEach((fdToMerge)=>{
        for (const fieldDef1 of merged){
            // If already exists, no need to append to merged array
            if (deepEqual(fieldDef1, fdToMerge)) return;
        }
        merged.push(fdToMerge);
    });
    return merged;
}
function mergeTitle(title1, title2) {
    if (deepEqual(title1, title2) || !title2) // if titles are the same or title2 is falsy
    return title1;
    else if (!title1) // if title1 is falsy
    return title2;
    else return [
        ...(0, _vegaUtil.array)(title1),
        ...(0, _vegaUtil.array)(title2)
    ].join(', ');
}
function mergeTitleComponent(v1, v2) {
    const v1Val = v1.value;
    const v2Val = v2.value;
    if (v1Val == null || v2Val === null) return {
        explicit: v1.explicit,
        value: null
    };
    else if ((isText(v1Val) || isSignalRef(v1Val)) && (isText(v2Val) || isSignalRef(v2Val))) return {
        explicit: v1.explicit,
        value: mergeTitle(v1Val, v2Val)
    };
    else if (isText(v1Val) || isSignalRef(v1Val)) return {
        explicit: v1.explicit,
        value: v1Val
    };
    else if (isText(v2Val) || isSignalRef(v2Val)) return {
        explicit: v1.explicit,
        value: v2Val
    };
    else if (!isText(v1Val) && !isSignalRef(v1Val) && !isText(v2Val) && !isSignalRef(v2Val)) return {
        explicit: v1.explicit,
        value: mergeTitleFieldDefs(v1Val, v2Val)
    };
    /* istanbul ignore next: Condition should not happen -- only for warning in development. */ throw new Error('It should never reach here');
}
/**
 * Collection of all Vega-Lite Error Messages
 */ function invalidSpec(spec) {
    return `Invalid specification ${stringify(spec)}. Make sure the specification includes at least one of the following properties: "mark", "layer", "facet", "hconcat", "vconcat", "concat", or "repeat".`;
}
// FIT
const FIT_NON_SINGLE = 'Autosize "fit" only works for single views and layered views.';
function containerSizeNonSingle(name) {
    const uName = name == 'width' ? 'Width' : 'Height';
    return `${uName} "container" only works for single views and layered views.`;
}
function containerSizeNotCompatibleWithAutosize(name) {
    const uName = name == 'width' ? 'Width' : 'Height';
    const fitDirection = name == 'width' ? 'x' : 'y';
    return `${uName} "container" only works well with autosize "fit" or "fit-${fitDirection}".`;
}
function droppingFit(channel) {
    return channel ? `Dropping "fit-${channel}" because spec has discrete ${getSizeChannel(channel)}.` : `Dropping "fit" because spec has discrete size.`;
}
// VIEW SIZE
function unknownField(channel) {
    return `Unknown field for ${channel}. Cannot calculate view size.`;
}
// SELECTION
function cannotProjectOnChannelWithoutField(channel) {
    return `Cannot project a selection on encoding channel "${channel}", which has no field.`;
}
function cannotProjectAggregate(channel, aggregate) {
    return `Cannot project a selection on encoding channel "${channel}" as it uses an aggregate function ("${aggregate}").`;
}
function nearestNotSupportForContinuous(mark) {
    return `The "nearest" transform is not supported for ${mark} marks.`;
}
function selectionNotSupported(mark) {
    return `Selection not supported for ${mark} yet.`;
}
function selectionNotFound(name) {
    return `Cannot find a selection named "${name}".`;
}
const SCALE_BINDINGS_CONTINUOUS = 'Scale bindings are currently only supported for scales with unbinned, continuous domains.';
const SEQUENTIAL_SCALE_DEPRECATED = 'Sequntial scales are deprecated. The available quantitative scale type values are linear, log, pow, sqrt, symlog, time and utc';
const LEGEND_BINDINGS_MUST_HAVE_PROJECTION = 'Legend bindings are only supported for selections over an individual field or encoding channel.';
function cannotLookupVariableParameter(name) {
    return `Lookups can only be performed on selection parameters. "${name}" is a variable parameter.`;
}
function noSameUnitLookup(name) {
    return `Cannot define and lookup the "${name}" selection in the same view. ` + `Try moving the lookup into a second, layered view?`;
}
const NEEDS_SAME_SELECTION = 'The same selection must be used to override scale domains in a layered view.';
const INTERVAL_INITIALIZED_WITH_POS = 'Interval selections should be initialized using "x", "y", "longitude", or "latitude" keys.';
// REPEAT
function noSuchRepeatedValue(field) {
    return `Unknown repeated value "${field}".`;
}
function columnsNotSupportByRowCol(type) {
    return `The "columns" property cannot be used when "${type}" has nested row/column.`;
}
const MULTIPLE_TIMER_ANIMATION_SELECTION = 'Multiple timer selections in one unit spec are not supported. Ignoring all but the first.';
const MULTI_VIEW_ANIMATION_UNSUPPORTED = 'Animation involving facet, layer, or concat is currently unsupported.';
function selectionAsScaleDomainWithoutField(field) {
    return 'A "field" or "encoding" must be specified when using a selection as a scale domain. ' + `Using "field": ${(0, _vega.stringValue)(field)}.`;
}
function selectionAsScaleDomainWrongEncodings(encodings, encoding, extent, field) {
    return `${!encodings.length ? 'No ' : 'Multiple '}matching ${(0, _vega.stringValue)(encoding)} encoding found for selection ${(0, _vega.stringValue)(extent.param)}. ` + `Using "field": ${(0, _vega.stringValue)(field)}.`;
}
// CONCAT / REPEAT
const CONCAT_CANNOT_SHARE_AXIS = 'Axes cannot be shared in concatenated or repeated views yet (https://github.com/vega/vega-lite/issues/2415).';
// DATA
function unrecognizedParse(p) {
    return `Unrecognized parse "${p}".`;
}
function differentParse(field, local, ancestor) {
    return `An ancestor parsed field "${field}" as ${ancestor} but a child wants to parse the field as ${local}.`;
}
const ADD_SAME_CHILD_TWICE = 'Attempt to add the same child twice.';
// TRANSFORMS
function invalidTransformIgnored(transform) {
    return `Ignoring an invalid transform: ${stringify(transform)}.`;
}
const NO_FIELDS_NEEDS_AS = 'If "from.fields" is not specified, "as" has to be a string that specifies the key to be used for the data from the secondary source.';
// ENCODING & FACET
function customFormatTypeNotAllowed(channel) {
    return `Config.customFormatTypes is not true, thus custom format type and format for channel ${channel} are dropped.`;
}
function projectionOverridden(opt) {
    const { parentProjection, projection } = opt;
    return `Layer's shared projection ${stringify(parentProjection)} is overridden by a child projection ${stringify(projection)}.`;
}
const REPLACE_ANGLE_WITH_THETA = 'Arc marks uses theta channel rather than angle, replacing angle with theta.';
function offsetNestedInsideContinuousPositionScaleDropped(mainChannel) {
    return `${mainChannel}Offset dropped because ${mainChannel} is continuous`;
}
function primitiveChannelDef(channel, type, value) {
    return `Channel ${channel} is a ${type}. Converted to {value: ${stringify(value)}}.`;
}
function invalidFieldType(type) {
    return `Invalid field type "${type}".`;
}
function invalidFieldTypeForCountAggregate(type, aggregate) {
    return `Invalid field type "${type}" for aggregate: "${aggregate}", using "quantitative" instead.`;
}
function invalidAggregate(aggregate) {
    return `Invalid aggregation operator "${aggregate}".`;
}
function droppingColor(type, opt) {
    const { fill, stroke } = opt;
    return `Dropping color ${type} as the plot also has ${fill && stroke ? 'fill and stroke' : fill ? 'fill' : 'stroke'}.`;
}
function relativeBandSizeNotSupported(sizeChannel) {
    return `Position range does not support relative band size for ${sizeChannel}.`;
}
function emptyFieldDef(fieldDef, channel) {
    return `Dropping ${stringify(fieldDef)} from channel "${channel}" since it does not contain any data field, datum, value, or signal.`;
}
const LINE_WITH_VARYING_SIZE = 'Line marks cannot encode size with a non-groupby field. You may want to use trail marks instead.';
function incompatibleChannel(channel, markOrFacet, when) {
    return `${channel} dropped as it is incompatible with "${markOrFacet}"${''}.`;
}
function invalidEncodingChannel(channel) {
    return `${channel}-encoding is dropped as ${channel} is not a valid encoding channel.`;
}
function channelShouldBeDiscrete(channel) {
    return `${channel} encoding should be discrete (ordinal / nominal / binned).`;
}
function channelShouldBeDiscreteOrDiscretizing(channel) {
    return `${channel} encoding should be discrete (ordinal / nominal / binned) or use a discretizing scale (e.g. threshold).`;
}
function facetChannelDropped(channels) {
    return `Facet encoding dropped as ${channels.join(' and ')} ${channels.length > 1 ? 'are' : 'is'} also specified.`;
}
function discreteChannelCannotEncode(channel, type) {
    return `Using discrete channel "${channel}" to encode "${type}" field can be misleading as it does not encode ${type === 'ordinal' ? 'order' : 'magnitude'}.`;
}
// MARK
function rangeMarkAlignmentCannotBeExpression(align) {
    return `The ${align} for range marks cannot be an expression`;
}
function lineWithRange(hasX2, hasY2) {
    const channels = hasX2 && hasY2 ? 'x2 and y2' : hasX2 ? 'x2' : 'y2';
    return `Line mark is for continuous lines and thus cannot be used with ${channels}. We will use the rule mark (line segments) instead.`;
}
function orientOverridden(original, actual) {
    return `Specified orient "${original}" overridden with "${actual}".`;
}
function cannotUseScalePropertyWithNonColor(prop) {
    return `Cannot use the scale property "${prop}" with non-color channel.`;
}
function cannotUseRelativeBandSizeWithNonBandScale(scaleType) {
    return `Cannot use the relative band size with ${scaleType} scale.`;
}
function unaggregateDomainHasNoEffectForRawField(fieldDef) {
    return `Using unaggregated domain with raw field has no effect (${stringify(fieldDef)}).`;
}
function unaggregateDomainWithNonSharedDomainOp(aggregate) {
    return `Unaggregated domain not applicable for "${aggregate}" since it produces values outside the origin domain of the source data.`;
}
function unaggregatedDomainWithLogScale(fieldDef) {
    return `Unaggregated domain is currently unsupported for log scale (${stringify(fieldDef)}).`;
}
function cannotApplySizeToNonOrientedMark(mark) {
    return `Cannot apply size to non-oriented mark "${mark}".`;
}
function scaleTypeNotWorkWithChannel(channel, scaleType, defaultScaleType) {
    return `Channel "${channel}" does not work with "${scaleType}" scale. We are using "${defaultScaleType}" scale instead.`;
}
function scaleTypeNotWorkWithFieldDef(scaleType, defaultScaleType) {
    return `FieldDef does not work with "${scaleType}" scale. We are using "${defaultScaleType}" scale instead.`;
}
function scalePropertyNotWorkWithScaleType(scaleType, propName, channel) {
    return `${channel}-scale's "${propName}" is dropped as it does not work with ${scaleType} scale.`;
}
function stepDropped(channel) {
    return `The step for "${channel}" is dropped because the ${channel === 'width' ? 'x' : 'y'} is continuous.`;
}
function mergeConflictingProperty(property, propertyOf, v1, v2) {
    return `Conflicting ${propertyOf.toString()} property "${property.toString()}" (${stringify(v1)} and ${stringify(v2)}). Using ${stringify(v1)}.`;
}
function mergeConflictingDomainProperty(property, propertyOf, v1, v2) {
    return `Conflicting ${propertyOf.toString()} property "${property.toString()}" (${stringify(v1)} and ${stringify(v2)}). Using the union of the two domains.`;
}
function independentScaleMeansIndependentGuide(channel) {
    return `Setting the scale to be independent for "${channel}" means we also have to set the guide (axis or legend) to be independent.`;
}
function domainSortDropped(sort) {
    return `Dropping sort property ${stringify(sort)} as unioned domains only support boolean or op "count", "min", and "max".`;
}
const MORE_THAN_ONE_SORT = 'Domains that should be unioned has conflicting sort properties. Sort will be set to true.';
const FACETED_INDEPENDENT_DIFFERENT_SOURCES = 'Detected faceted independent scales that union domain of multiple fields from different data sources. We will use the first field. The result view size may be incorrect.';
const FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES = 'Detected faceted independent scales that union domain of the same fields from different source. We will assume that this is the same field from a different fork of the same data source. However, if this is not the case, the result view size may be incorrect.';
const FACETED_INDEPENDENT_SAME_SOURCE = 'Detected faceted independent scales that union domain of multiple fields from the same data source. We will use the first field. The result view size may be incorrect.';
// STACK
function cannotStackRangedMark(channel) {
    return `Cannot stack "${channel}" if there is already "${channel}2".`;
}
function stackNonLinearScale(scaleType) {
    return `Stack is applied to a non-linear scale (${scaleType}).`;
}
function stackNonSummativeAggregate(aggregate) {
    return `Stacking is applied even though the aggregate function is non-summative ("${aggregate}").`;
}
// TIMEUNIT
function invalidTimeUnit(unitName, value) {
    return `Invalid ${unitName}: ${stringify(value)}.`;
}
function droppedDay(d) {
    return `Dropping day from datetime ${stringify(d)} as day cannot be combined with other units.`;
}
function errorBarCenterAndExtentAreNotNeeded(center, extent) {
    return `${extent ? 'extent ' : ''}${extent && center ? 'and ' : ''}${center ? 'center ' : ''}${extent && center ? 'are ' : 'is '}not needed when data are aggregated.`;
}
function errorBarCenterIsUsedWithWrongExtent(center, extent, mark) {
    return `${center} is not usually used with ${extent} for ${mark}.`;
}
function errorBarContinuousAxisHasCustomizedAggregate(aggregate, compositeMark) {
    return `Continuous axis should not have customized aggregation function ${aggregate}; ${compositeMark} already agregates the axis.`;
}
function errorBand1DNotSupport(property) {
    return `1D error band does not support ${property}.`;
}
// CHANNEL
function channelRequiredForBinned(channel) {
    return `Channel ${channel} is required for "binned" bin.`;
}
function channelShouldNotBeUsedForBinned(channel) {
    return `Channel ${channel} should not be used with "binned" bin.`;
}
function domainRequiredForThresholdScale(channel) {
    return `Domain for ${channel} is required for threshold scale.`;
}
/**
 * Vega-Lite's singleton logger utility.
 */ /**
 * Main (default) Vega Logger instance for Vega-Lite.
 */ const main = (0, _vegaUtil.logger)((0, _vegaUtil.Warn));
let current = main;
/**
 * Set the singleton logger to be a custom logger.
 */ function set(newLogger) {
    current = newLogger;
    return current;
}
/**
 * Reset the main logger to use the default Vega Logger.
 */ function reset() {
    current = main;
    return current;
}
function error(...args) {
    current.error(...args);
}
function warn(...args) {
    current.warn(...args);
}
function debug(...args) {
    current.debug(...args);
}
// DateTime definition object
function isDateTime(o) {
    if (o && (0, _vegaUtil.isObject)(o)) for (const part of TIMEUNIT_PARTS){
        if (hasProperty(o, part)) return true;
    }
    return false;
}
const MONTHS = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
const SHORT_MONTHS = MONTHS.map((m)=>m.substr(0, 3));
const DAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
];
const SHORT_DAYS = DAYS.map((d)=>d.substr(0, 3));
function normalizeQuarter(q) {
    if (isNumeric(q)) q = +q;
    if ((0, _vegaUtil.isNumber)(q)) {
        if (q > 4) warn(invalidTimeUnit('quarter', q));
        // We accept 1-based quarter, so need to readjust to 0-based quarter
        return q - 1;
    } else // Invalid quarter
    throw new Error(invalidTimeUnit('quarter', q));
}
function normalizeMonth(m) {
    if (isNumeric(m)) m = +m;
    if ((0, _vegaUtil.isNumber)(m)) // We accept 1-based month, so need to readjust to 0-based month
    return m - 1;
    else {
        const lowerM = m.toLowerCase();
        const monthIndex = MONTHS.indexOf(lowerM);
        if (monthIndex !== -1) return monthIndex; // 0 for january, ...
        const shortM = lowerM.substr(0, 3);
        const shortMonthIndex = SHORT_MONTHS.indexOf(shortM);
        if (shortMonthIndex !== -1) return shortMonthIndex;
        // Invalid month
        throw new Error(invalidTimeUnit('month', m));
    }
}
function normalizeDay(d) {
    if (isNumeric(d)) d = +d;
    if ((0, _vegaUtil.isNumber)(d)) // mod so that this can be both 0-based where 0 = sunday
    // and 1-based where 7=sunday
    return d % 7;
    else {
        const lowerD = d.toLowerCase();
        const dayIndex = DAYS.indexOf(lowerD);
        if (dayIndex !== -1) return dayIndex; // 0 for january, ...
        const shortD = lowerD.substr(0, 3);
        const shortDayIndex = SHORT_DAYS.indexOf(shortD);
        if (shortDayIndex !== -1) return shortDayIndex;
        // Invalid day
        throw new Error(invalidTimeUnit('day', d));
    }
}
/**
 * @param d the date.
 * @param normalize whether to normalize quarter, month, day. This should probably be true if d is a DateTime.
 * @returns array of date time parts [year, month, day, hours, minutes, seconds, milliseconds]
 */ function dateTimeParts(d, normalize) {
    const parts = [];
    if (normalize && d.day !== undefined) {
        if (keys(d).length > 1) {
            warn(droppedDay(d));
            d = duplicate(d);
            delete d.day;
        }
    }
    if (d.year !== undefined) parts.push(d.year);
    else // Just like Vega's timeunit transform, set default year to 2012, so domain conversion will be compatible with Vega
    // Note: 2012 is a leap year (and so the date February 29 is respected) that begins on a Sunday (and so days of the week will order properly at the beginning of the year).
    parts.push(2012);
    if (d.month !== undefined) {
        const month = normalize ? normalizeMonth(d.month) : d.month;
        parts.push(month);
    } else if (d.quarter !== undefined) {
        const quarter = normalize ? normalizeQuarter(d.quarter) : d.quarter;
        parts.push((0, _vegaUtil.isNumber)(quarter) ? quarter * 3 : `${quarter}*3`);
    } else parts.push(0); // months start at zero in JS
    if (d.date !== undefined) parts.push(d.date);
    else if (d.day !== undefined) {
        // HACK: Day only works as a standalone unit
        // This is only correct because we always set year to 2006 for day
        const day = normalize ? normalizeDay(d.day) : d.day;
        parts.push((0, _vegaUtil.isNumber)(day) ? day + 1 : `${day}+1`);
    } else parts.push(1); // Date starts at 1 in JS
    // Note: can't use TimeUnit enum here as importing it will create
    // circular dependency problem!
    for (const timeUnit of [
        'hours',
        'minutes',
        'seconds',
        'milliseconds'
    ]){
        const unit = d[timeUnit];
        parts.push(typeof unit === 'undefined' ? 0 : unit);
    }
    return parts;
}
/**
 * Return Vega expression for a date time.
 *
 * @param d the date time.
 * @returns the Vega expression.
 */ function dateTimeToExpr(d) {
    const parts = dateTimeParts(d, true);
    const string = parts.join(', ');
    if (d.utc) return `utc(${string})`;
    else return `datetime(${string})`;
}
/**
 * Return Vega expression for a date time expression.
 *
 * @param d the internal date time object with expression.
 * @returns the Vega expression.
 */ function dateTimeExprToExpr(d) {
    const parts = dateTimeParts(d, false);
    const string = parts.join(', ');
    if (d.utc) return `utc(${string})`;
    else return `datetime(${string})`;
}
/**
 * @param d the date time.
 * @returns the timestamp.
 */ function dateTimeToTimestamp(d) {
    const parts = dateTimeParts(d, true);
    if (d.utc) return +new Date(Date.UTC(...parts));
    else return +new Date(...parts);
}
/** Time Unit that only corresponds to only one part of Date objects. */ const LOCAL_SINGLE_TIMEUNIT_INDEX = {
    year: 1,
    quarter: 1,
    month: 1,
    week: 1,
    day: 1,
    dayofyear: 1,
    date: 1,
    hours: 1,
    minutes: 1,
    seconds: 1,
    milliseconds: 1
};
const TIMEUNIT_PARTS = keys(LOCAL_SINGLE_TIMEUNIT_INDEX);
function isLocalSingleTimeUnit(timeUnit) {
    return (0, _vega.hasOwnProperty)(LOCAL_SINGLE_TIMEUNIT_INDEX, timeUnit);
}
function isBinnedTimeUnit(timeUnit) {
    if ((0, _vegaUtil.isObject)(timeUnit)) return timeUnit.binned;
    return isBinnedTimeUnitString(timeUnit);
}
function isBinnedTimeUnitString(timeUnit) {
    return timeUnit?.startsWith('binned');
}
function isUTCTimeUnit(t) {
    return t.startsWith('utc');
}
function getLocalTimeUnitFromUTCTimeUnit(t) {
    return t.substring(3);
}
// In order of increasing specificity
const VEGALITE_TIMEFORMAT = {
    'year-month': '%b %Y ',
    'year-month-date': '%b %d, %Y '
};
function getTimeUnitParts(timeUnit) {
    return TIMEUNIT_PARTS.filter((part)=>containsTimeUnit(timeUnit, part));
}
function getSmallestTimeUnitPart(timeUnit) {
    const parts = getTimeUnitParts(timeUnit);
    return parts[parts.length - 1];
}
/** Returns true if fullTimeUnit contains the timeUnit, false otherwise. */ function containsTimeUnit(fullTimeUnit, timeUnit) {
    const index = fullTimeUnit.indexOf(timeUnit);
    if (index < 0) return false;
    // exclude milliseconds
    if (index > 0 && timeUnit === 'seconds' && fullTimeUnit.charAt(index - 1) === 'i') return false;
    // exclude dayofyear
    if (fullTimeUnit.length > index + 3 && timeUnit === 'day' && fullTimeUnit.charAt(index + 3) === 'o') return false;
    if (index > 0 && timeUnit === 'year' && fullTimeUnit.charAt(index - 1) === 'f') return false;
    return true;
}
/**
 * Returns Vega expression for a given timeUnit and fieldRef
 */ function fieldExpr(fullTimeUnit, field, { end } = {
    end: false
}) {
    const fieldRef = accessPathWithDatum(field);
    const utc = isUTCTimeUnit(fullTimeUnit) ? 'utc' : '';
    function func(timeUnit) {
        if (timeUnit === 'quarter') // quarter starting at 0 (0,3,6,9).
        return `(${utc}quarter(${fieldRef})-1)`;
        else return `${utc}${timeUnit}(${fieldRef})`;
    }
    let lastTimeUnit;
    const dateExpr = {};
    for (const part of TIMEUNIT_PARTS)if (containsTimeUnit(fullTimeUnit, part)) {
        dateExpr[part] = func(part);
        lastTimeUnit = part;
    }
    if (end) dateExpr[lastTimeUnit] += '+1';
    return dateTimeExprToExpr(dateExpr);
}
function timeUnitSpecifierExpression(timeUnit) {
    if (!timeUnit) return undefined;
    const timeUnitParts = getTimeUnitParts(timeUnit);
    return `timeUnitSpecifier(${stringify(timeUnitParts)}, ${stringify(VEGALITE_TIMEFORMAT)})`;
}
/**
 * Returns the signal expression used for axis labels for a time unit.
 */ function formatExpression(timeUnit, field, isUTCScale) {
    if (!timeUnit) return undefined;
    const expr = timeUnitSpecifierExpression(timeUnit);
    // We only use utcFormat for utc scale
    // For utc time units, the data is already converted as a part of timeUnit transform.
    // Thus, utc time units should use timeFormat to avoid shifting the time twice.
    const utc = isUTCScale || isUTCTimeUnit(timeUnit);
    return `${utc ? 'utc' : 'time'}Format(${field}, ${expr})`;
}
function normalizeTimeUnit(timeUnit) {
    if (!timeUnit) return undefined;
    let params;
    if ((0, _vegaUtil.isString)(timeUnit)) {
        if (isBinnedTimeUnitString(timeUnit)) params = {
            unit: timeUnit.substring(6),
            binned: true
        };
        else params = {
            unit: timeUnit
        };
    } else if ((0, _vegaUtil.isObject)(timeUnit)) params = {
        ...timeUnit,
        ...timeUnit.unit ? {
            unit: timeUnit.unit
        } : {}
    };
    if (isUTCTimeUnit(params.unit)) {
        params.utc = true;
        params.unit = getLocalTimeUnitFromUTCTimeUnit(params.unit);
    }
    return params;
}
function timeUnitToString(tu) {
    const { utc, ...rest } = normalizeTimeUnit(tu);
    if (rest.unit) return (utc ? 'utc' : '') + keys(rest).map((p)=>varName(`${p === 'unit' ? '' : `_${p}_`}${rest[p]}`)).join('');
    else // when maxbins is specified instead of units
    return `${utc ? 'utc' : ''}timeunit${keys(rest).map((p)=>varName(`_${p}_${rest[p]}`)).join('')}`;
}
function durationExpr(timeUnit, wrap = (x)=>x) {
    const normalizedTimeUnit = normalizeTimeUnit(timeUnit);
    const smallestUnitPart = getSmallestTimeUnitPart(normalizedTimeUnit.unit);
    if (smallestUnitPart && smallestUnitPart !== 'day') {
        const startDate = {
            year: 2001,
            month: 1,
            date: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
        };
        const { step, part } = getDateTimePartAndStep(smallestUnitPart, normalizedTimeUnit.step);
        const endDate = {
            ...startDate,
            [part]: +startDate[part] + step
        };
        // Calculate timestamp duration for the smallest unit listed
        return `${wrap(dateTimeToExpr(endDate))} - ${wrap(dateTimeToExpr(startDate))}`;
    }
    return undefined;
}
const DATE_PARTS = {
    year: 1,
    month: 1,
    date: 1,
    hours: 1,
    minutes: 1,
    seconds: 1,
    milliseconds: 1
};
function isDatePart(timeUnit) {
    return (0, _vega.hasOwnProperty)(DATE_PARTS, timeUnit);
}
function getDateTimePartAndStep(timeUnit, step = 1) {
    if (isDatePart(timeUnit)) return {
        part: timeUnit,
        step
    };
    switch(timeUnit){
        case 'day':
        case 'dayofyear':
            return {
                part: 'date',
                step
            };
        case 'quarter':
            return {
                part: 'month',
                step: step * 3
            };
        case 'week':
            return {
                part: 'date',
                step: step * 7
            };
    }
}
function isSelectionPredicate(predicate) {
    return hasProperty(predicate, 'param');
}
function isFieldEqualPredicate(predicate) {
    return !!predicate?.field && predicate.equal !== undefined;
}
function isFieldLTPredicate(predicate) {
    return !!predicate?.field && predicate.lt !== undefined;
}
function isFieldLTEPredicate(predicate) {
    return !!predicate?.field && predicate.lte !== undefined;
}
function isFieldGTPredicate(predicate) {
    return !!predicate?.field && predicate.gt !== undefined;
}
function isFieldGTEPredicate(predicate) {
    return !!predicate?.field && predicate.gte !== undefined;
}
function isFieldRangePredicate(predicate) {
    if (predicate?.field) {
        if ((0, _vegaUtil.isArray)(predicate.range) && predicate.range.length === 2) return true;
        else if (isSignalRef(predicate.range)) return true;
    }
    return false;
}
function isFieldOneOfPredicate(predicate) {
    return !!predicate?.field && ((0, _vegaUtil.isArray)(predicate.oneOf) || (0, _vegaUtil.isArray)(predicate.in) // backward compatibility
    );
}
function isFieldValidPredicate(predicate) {
    return !!predicate?.field && predicate.valid !== undefined;
}
function isFieldPredicate(predicate) {
    return isFieldOneOfPredicate(predicate) || isFieldEqualPredicate(predicate) || isFieldRangePredicate(predicate) || isFieldLTPredicate(predicate) || isFieldGTPredicate(predicate) || isFieldLTEPredicate(predicate) || isFieldGTEPredicate(predicate);
}
function predicateValueExpr(v, timeUnit) {
    return valueExpr(v, {
        timeUnit,
        wrapTime: true
    });
}
function predicateValuesExpr(vals, timeUnit) {
    return vals.map((v)=>predicateValueExpr(v, timeUnit));
}
// This method is used by Voyager. Do not change its behavior without changing Voyager.
function fieldFilterExpression(predicate, useInRange = true) {
    const { field } = predicate;
    const normalizedTimeUnit = normalizeTimeUnit(predicate.timeUnit);
    const { unit, binned } = normalizedTimeUnit || {};
    const rawFieldExpr = vgField(predicate, {
        expr: 'datum'
    });
    const fieldExpr$1 = unit ? // TODO: We calculate timeUnit on the fly here. Consider if we would like to consolidate this with timeUnit pipeline
    // TODO: support utc
    `time(${!binned ? fieldExpr(unit, field) : rawFieldExpr})` : rawFieldExpr;
    if (isFieldEqualPredicate(predicate)) return `${fieldExpr$1}===${predicateValueExpr(predicate.equal, unit)}`;
    else if (isFieldLTPredicate(predicate)) {
        const upper = predicate.lt;
        return `${fieldExpr$1}<${predicateValueExpr(upper, unit)}`;
    } else if (isFieldGTPredicate(predicate)) {
        const lower = predicate.gt;
        return `${fieldExpr$1}>${predicateValueExpr(lower, unit)}`;
    } else if (isFieldLTEPredicate(predicate)) {
        const upper = predicate.lte;
        return `${fieldExpr$1}<=${predicateValueExpr(upper, unit)}`;
    } else if (isFieldGTEPredicate(predicate)) {
        const lower = predicate.gte;
        return `${fieldExpr$1}>=${predicateValueExpr(lower, unit)}`;
    } else if (isFieldOneOfPredicate(predicate)) return `indexof([${predicateValuesExpr(predicate.oneOf, unit).join(',')}], ${fieldExpr$1}) !== -1`;
    else if (isFieldValidPredicate(predicate)) return fieldValidPredicate(fieldExpr$1, predicate.valid);
    else if (isFieldRangePredicate(predicate)) {
        const { range } = replaceExprRef(predicate);
        const lower = isSignalRef(range) ? {
            signal: `${range.signal}[0]`
        } : range[0];
        const upper = isSignalRef(range) ? {
            signal: `${range.signal}[1]`
        } : range[1];
        if (lower !== null && upper !== null && useInRange) return `inrange(${fieldExpr$1}, [${predicateValueExpr(lower, unit)}, ${predicateValueExpr(upper, unit)}])`;
        const exprs = [];
        if (lower !== null) exprs.push(`${fieldExpr$1} >= ${predicateValueExpr(lower, unit)}`);
        if (upper !== null) exprs.push(`${fieldExpr$1} <= ${predicateValueExpr(upper, unit)}`);
        return exprs.length > 0 ? exprs.join(' && ') : 'true';
    }
    /* istanbul ignore next: it should never reach here */ throw new Error(`Invalid field predicate: ${stringify(predicate)}`);
}
function fieldValidPredicate(fieldExpr, valid = true) {
    if (valid) return `isValid(${fieldExpr}) && isFinite(+${fieldExpr})`;
    else return `!isValid(${fieldExpr}) || !isFinite(+${fieldExpr})`;
}
function normalizePredicate$1(f) {
    if (isFieldPredicate(f) && f.timeUnit) return {
        ...f,
        timeUnit: normalizeTimeUnit(f.timeUnit)
    };
    return f;
}
/**
 * Data type based on level of measurement
 */ const Type = {
    quantitative: 'quantitative',
    ordinal: 'ordinal',
    temporal: 'temporal',
    nominal: 'nominal',
    geojson: 'geojson'
};
function isContinuous(type) {
    return type === 'quantitative' || type === 'temporal';
}
function isDiscrete$1(type) {
    return type === 'ordinal' || type === 'nominal';
}
const QUANTITATIVE = Type.quantitative;
const ORDINAL = Type.ordinal;
const TEMPORAL = Type.temporal;
const NOMINAL = Type.nominal;
const GEOJSON = Type.geojson;
/**
 * Get full, lowercase type name for a given type.
 * @param  type
 * @return Full type name.
 */ function getFullName(type) {
    if (type) {
        type = type.toLowerCase();
        switch(type){
            case 'q':
            case QUANTITATIVE:
                return 'quantitative';
            case 't':
            case TEMPORAL:
                return 'temporal';
            case 'o':
            case ORDINAL:
                return 'ordinal';
            case 'n':
            case NOMINAL:
                return 'nominal';
            case GEOJSON:
                return 'geojson';
        }
    }
    // If we get invalid input, return undefined type.
    return undefined;
}
const ScaleType = {
    // Continuous - Quantitative
    LINEAR: 'linear',
    LOG: 'log',
    POW: 'pow',
    SQRT: 'sqrt',
    // Continuous - Time
    TIME: 'time',
    UTC: 'utc',
    POINT: 'point',
    BAND: 'band'
};
/**
 * Index for scale categories -- only scale of the same categories can be merged together.
 * Current implementation is trying to be conservative and avoid merging scale type that might not work together
 */ const SCALE_CATEGORY_INDEX = {
    linear: 'numeric',
    log: 'numeric',
    pow: 'numeric',
    sqrt: 'numeric',
    symlog: 'numeric',
    identity: 'numeric',
    sequential: 'numeric',
    time: 'time',
    utc: 'time',
    ordinal: 'ordinal',
    'bin-ordinal': 'bin-ordinal',
    point: 'ordinal-position',
    band: 'ordinal-position',
    quantile: 'discretizing',
    quantize: 'discretizing',
    threshold: 'discretizing'
};
/**
 * Whether the two given scale types can be merged together.
 */ function scaleCompatible(scaleType1, scaleType2) {
    const scaleCategory1 = SCALE_CATEGORY_INDEX[scaleType1];
    const scaleCategory2 = SCALE_CATEGORY_INDEX[scaleType2];
    return scaleCategory1 === scaleCategory2 || scaleCategory1 === 'ordinal-position' && scaleCategory2 === 'time' || scaleCategory2 === 'ordinal-position' && scaleCategory1 === 'time';
}
/**
 * Index for scale precedence -- high score = higher priority for merging.
 */ const SCALE_PRECEDENCE_INDEX = {
    // numeric
    linear: 0,
    log: 1,
    pow: 1,
    sqrt: 1,
    symlog: 1,
    identity: 1,
    sequential: 1,
    // time
    time: 0,
    utc: 0,
    // ordinal-position -- these have higher precedence than continuous scales as they support more types of data
    point: 10,
    band: 11,
    // non grouped types
    ordinal: 0,
    'bin-ordinal': 0,
    quantile: 0,
    quantize: 0,
    threshold: 0
};
/**
 * Return scale categories -- only scale of the same categories can be merged together.
 */ function scaleTypePrecedence(scaleType) {
    return SCALE_PRECEDENCE_INDEX[scaleType];
}
const QUANTITATIVE_SCALES = new Set([
    'linear',
    'log',
    'pow',
    'sqrt',
    'symlog'
]);
const CONTINUOUS_TO_CONTINUOUS_SCALES = new Set([
    ...QUANTITATIVE_SCALES,
    'time',
    'utc'
]);
function isQuantitative(type) {
    return QUANTITATIVE_SCALES.has(type);
}
const CONTINUOUS_TO_DISCRETE_SCALES = new Set([
    'quantile',
    'quantize',
    'threshold'
]);
const CONTINUOUS_DOMAIN_SCALES = new Set([
    ...CONTINUOUS_TO_CONTINUOUS_SCALES,
    ...CONTINUOUS_TO_DISCRETE_SCALES,
    'sequential',
    'identity'
]);
const DISCRETE_DOMAIN_SCALES = new Set([
    'ordinal',
    'bin-ordinal',
    'point',
    'band'
]);
function hasDiscreteDomain(type) {
    return DISCRETE_DOMAIN_SCALES.has(type);
}
function hasContinuousDomain(type) {
    return CONTINUOUS_DOMAIN_SCALES.has(type);
}
function isContinuousToContinuous(type) {
    return CONTINUOUS_TO_CONTINUOUS_SCALES.has(type);
}
function isContinuousToDiscrete(type) {
    return CONTINUOUS_TO_DISCRETE_SCALES.has(type);
}
const defaultScaleConfig = {
    pointPadding: 0.5,
    barBandPaddingInner: 0.1,
    rectBandPaddingInner: 0,
    tickBandPaddingInner: 0.25,
    bandWithNestedOffsetPaddingInner: 0.2,
    bandWithNestedOffsetPaddingOuter: 0.2,
    minBandSize: 2,
    minFontSize: 8,
    maxFontSize: 40,
    minOpacity: 0.3,
    maxOpacity: 0.8,
    // FIXME: revise if these *can* become ratios of width/height step
    minSize: 4,
    minStrokeWidth: 1,
    maxStrokeWidth: 4,
    quantileCount: 4,
    quantizeCount: 4,
    zero: true,
    framesPerSecond: 2,
    animationDuration: 5
};
function isExtendedScheme(scheme) {
    return !(0, _vegaUtil.isString)(scheme) && hasProperty(scheme, 'name');
}
function isParameterDomain(domain) {
    return hasProperty(domain, 'param');
}
function isDomainUnionWith(domain) {
    return hasProperty(domain, 'unionWith');
}
function isFieldRange(range) {
    return (0, _vegaUtil.isObject)(range) && 'field' in range;
}
const SCALE_PROPERTY_INDEX = {
    type: 1,
    domain: 1,
    domainMax: 1,
    domainMin: 1,
    domainMid: 1,
    domainRaw: 1,
    align: 1,
    range: 1,
    rangeMax: 1,
    rangeMin: 1,
    scheme: 1,
    bins: 1,
    // Other properties
    reverse: 1,
    round: 1,
    // quantitative / time
    clamp: 1,
    nice: 1,
    // quantitative
    base: 1,
    exponent: 1,
    constant: 1,
    interpolate: 1,
    zero: 1,
    // band/point
    padding: 1,
    paddingInner: 1,
    paddingOuter: 1
};
const { type, domain: domain$1, range, rangeMax, rangeMin, scheme, ...NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTY_INDEX } = SCALE_PROPERTY_INDEX;
const NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES = keys(NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTY_INDEX);
function scaleTypeSupportProperty(scaleType, propName) {
    switch(propName){
        case 'type':
        case 'domain':
        case 'reverse':
        case 'range':
            return true;
        case 'scheme':
        case 'interpolate':
            return ![
                'point',
                'band',
                'identity'
            ].includes(scaleType);
        case 'bins':
            return ![
                'point',
                'band',
                'identity',
                'ordinal'
            ].includes(scaleType);
        case 'round':
            return isContinuousToContinuous(scaleType) || scaleType === 'band' || scaleType === 'point';
        case 'padding':
        case 'rangeMin':
        case 'rangeMax':
            return isContinuousToContinuous(scaleType) || [
                'point',
                'band'
            ].includes(scaleType);
        case 'paddingOuter':
        case 'align':
            return [
                'point',
                'band'
            ].includes(scaleType);
        case 'paddingInner':
            return scaleType === 'band';
        case 'domainMax':
        case 'domainMid':
        case 'domainMin':
        case 'domainRaw':
        case 'clamp':
            return isContinuousToContinuous(scaleType);
        case 'nice':
            return isContinuousToContinuous(scaleType) || scaleType === 'quantize' || scaleType === 'threshold';
        case 'exponent':
            return scaleType === 'pow';
        case 'base':
            return scaleType === 'log';
        case 'constant':
            return scaleType === 'symlog';
        case 'zero':
            return hasContinuousDomain(scaleType) && !contains([
                'log',
                'time',
                'utc',
                'threshold',
                'quantile'
            ], scaleType);
    }
}
/**
 * Returns undefined if the input channel supports the input scale property name
 */ function channelScalePropertyIncompatability(channel, propName) {
    switch(propName){
        case 'interpolate':
        case 'scheme':
        case 'domainMid':
            if (!isColorChannel(channel)) return cannotUseScalePropertyWithNonColor(propName);
            return undefined;
        case 'align':
        case 'type':
        case 'bins':
        case 'domain':
        case 'domainMax':
        case 'domainMin':
        case 'domainRaw':
        case 'range':
        case 'base':
        case 'exponent':
        case 'constant':
        case 'nice':
        case 'padding':
        case 'paddingInner':
        case 'paddingOuter':
        case 'rangeMax':
        case 'rangeMin':
        case 'reverse':
        case 'round':
        case 'clamp':
        case 'zero':
            return undefined; // GOOD!
    }
}
function scaleTypeSupportDataType(specifiedType, fieldDefType) {
    if (contains([
        ORDINAL,
        NOMINAL
    ], fieldDefType)) return specifiedType === undefined || hasDiscreteDomain(specifiedType);
    else if (fieldDefType === TEMPORAL) return contains([
        ScaleType.TIME,
        ScaleType.UTC,
        undefined
    ], specifiedType);
    else if (fieldDefType === QUANTITATIVE) return isQuantitative(specifiedType) || isContinuousToDiscrete(specifiedType) || specifiedType === undefined;
    return true;
}
function channelSupportScaleType(channel, scaleType, hasNestedOffsetScale = false) {
    if (!isScaleChannel(channel)) return false;
    switch(channel){
        case X:
        case Y:
        case XOFFSET:
        case YOFFSET:
        case THETA:
        case RADIUS:
            if (isContinuousToContinuous(scaleType)) return true;
            else if (scaleType === 'band') return true;
            else if (scaleType === 'point') /*
                  Point scale can't be use if the position has a nested offset scale
                  because if there is a nested scale, then it's band.
                */ return !hasNestedOffsetScale;
            return false;
        case TIME:
            return contains([
                'linear',
                'band'
            ], scaleType);
        case SIZE:
        case STROKEWIDTH:
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        case ANGLE:
            // Although it generally doesn't make sense to use band with size and opacity,
            // it can also work since we use band: 0.5 to get midpoint.
            return isContinuousToContinuous(scaleType) || isContinuousToDiscrete(scaleType) || contains([
                'band',
                'point',
                'ordinal'
            ], scaleType);
        case COLOR:
        case FILL:
        case STROKE:
            return scaleType !== 'band'; // band does not make sense with color
        case STROKEDASH:
        case SHAPE:
            return scaleType === 'ordinal' || isContinuousToDiscrete(scaleType);
    }
}
function isScaleInvalidDataIncludeAsValue(invalidDataMode) {
    return (0, _vegaUtil.isObject)(invalidDataMode) && 'value' in invalidDataMode;
}
/**
 * All types of primitive marks.
 */ const Mark = {
    arc: 'arc',
    area: 'area',
    bar: 'bar',
    image: 'image',
    line: 'line',
    point: 'point',
    rect: 'rect',
    rule: 'rule',
    text: 'text',
    tick: 'tick',
    trail: 'trail',
    circle: 'circle',
    square: 'square',
    geoshape: 'geoshape'
};
const ARC = Mark.arc;
const AREA = Mark.area;
const BAR = Mark.bar;
const IMAGE = Mark.image;
const LINE = Mark.line;
const POINT = Mark.point;
const RECT = Mark.rect;
const RULE = Mark.rule;
const TEXT = Mark.text;
const TICK = Mark.tick;
const TRAIL = Mark.trail;
const CIRCLE = Mark.circle;
const SQUARE = Mark.square;
const GEOSHAPE = Mark.geoshape;
function isPathMark(m) {
    return [
        'line',
        'area',
        'trail'
    ].includes(m);
}
function isRectBasedMark(m) {
    return [
        'rect',
        'bar',
        'image',
        'arc',
        'tick' /* arc is rect/interval in polar coordinate */ 
    ].includes(m);
}
const PRIMITIVE_MARKS = new Set(keys(Mark));
function isMarkDef(mark) {
    return hasProperty(mark, 'type');
}
const STROKE_CONFIG = [
    'stroke',
    'strokeWidth',
    'strokeDash',
    'strokeDashOffset',
    'strokeOpacity',
    'strokeJoin',
    'strokeMiterLimit'
];
const FILL_CONFIG = [
    'fill',
    'fillOpacity'
];
const FILL_STROKE_CONFIG = [
    ...STROKE_CONFIG,
    ...FILL_CONFIG
];
const VL_ONLY_MARK_CONFIG_INDEX = {
    color: 1,
    filled: 1,
    invalid: 1,
    order: 1,
    radius2: 1,
    theta2: 1,
    timeUnitBandSize: 1,
    timeUnitBandPosition: 1
};
const VL_ONLY_MARK_CONFIG_PROPERTIES = keys(VL_ONLY_MARK_CONFIG_INDEX);
const VL_ONLY_RECT_CONFIG = [
    'binSpacing',
    'continuousBandSize',
    'discreteBandSize',
    'minBandSize'
];
const VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = {
    area: [
        'line',
        'point'
    ],
    bar: VL_ONLY_RECT_CONFIG,
    rect: VL_ONLY_RECT_CONFIG,
    line: [
        'point'
    ],
    tick: [
        'bandSize',
        'thickness',
        ...VL_ONLY_RECT_CONFIG
    ]
};
const defaultMarkConfig = {
    color: '#4c78a8',
    invalid: 'break-paths-show-path-domains',
    timeUnitBandSize: 1
};
const MARK_CONFIG_INDEX = {
    mark: 1,
    arc: 1,
    area: 1,
    bar: 1,
    circle: 1,
    image: 1,
    line: 1,
    point: 1,
    rect: 1,
    rule: 1,
    square: 1,
    text: 1,
    tick: 1,
    trail: 1,
    geoshape: 1
};
const MARK_CONFIGS = keys(MARK_CONFIG_INDEX);
function isRelativeBandSize(o) {
    return hasProperty(o, 'band');
}
const BAR_CORNER_RADIUS_INDEX = {
    horizontal: [
        'cornerRadiusTopRight',
        'cornerRadiusBottomRight'
    ],
    vertical: [
        'cornerRadiusTopLeft',
        'cornerRadiusTopRight'
    ]
};
const DEFAULT_RECT_BAND_SIZE = 5;
const defaultRectConfig = {
    binSpacing: 0,
    continuousBandSize: DEFAULT_RECT_BAND_SIZE,
    minBandSize: 0.25,
    timeUnitBandPosition: 0.5
};
const defaultBarConfig = {
    ...defaultRectConfig,
    binSpacing: 1
};
const defaultTickConfig = {
    ...defaultRectConfig,
    thickness: 1
};
function getMarkType(m) {
    return isMarkDef(m) ? m.type : m;
}
function normalizeInvalidDataMode(mode, { isPath }) {
    if (mode === undefined || mode === 'break-paths-show-path-domains') return isPath ? 'break-paths-show-domains' : 'filter';
    else if (mode === null) return 'show';
    return mode;
}
function getScaleInvalidDataMode({ markDef, config, scaleChannel, scaleType, isCountAggregate }) {
    if (!scaleType || !hasContinuousDomain(scaleType) || isCountAggregate) // - Discrete scales can always display null as another category
    // - Count cannot output null values
    return 'always-valid';
    const invalidMode = normalizeInvalidDataMode(getMarkPropOrConfig('invalid', markDef, config), {
        isPath: isPathMark(markDef.type)
    });
    const scaleOutputForInvalid = config.scale?.invalid?.[scaleChannel];
    if (scaleOutputForInvalid !== undefined) // Regardless of the current invalid mode, if the channel has a default value, we consider the field valid.
    return 'show';
    return invalidMode;
}
function shouldBreakPath(mode) {
    return mode === 'break-paths-filter-domains' || mode === 'break-paths-show-domains';
}
function scaledZeroOrMinOrMax({ scaleName, scale, mode }) {
    const domain = `domain('${scaleName}')`;
    if (!scale || !scaleName) return undefined;
    const min = `${domain}[0]`;
    const max = `peek(${domain})`; // peek = the last item of the array
    // If there is a scale (and hence its name)
    const domainHasZero = scale.domainHasZero();
    // zeroOrMin or zeroOrMax mode
    if (domainHasZero === 'definitely') return {
        scale: scaleName,
        value: 0
    };
    else if (domainHasZero === 'maybe') {
        const nonZeroValue = mode === 'zeroOrMin' ? min : max;
        return {
            signal: `scale('${scaleName}', inrange(0, ${domain}) ? 0 : ${nonZeroValue})`
        };
    } else // domainHasZero === 'definitely-not'
    return {
        signal: `scale('${scaleName}', ${mode === 'zeroOrMin' ? min : max})`
    };
}
function getConditionalValueRefForIncludingInvalidValue({ scaleChannel, channelDef, scale, scaleName, markDef, config }) {
    const scaleType = scale?.get('type');
    const fieldDef = getFieldDef(channelDef);
    const isCountAggregate = isCountingAggregateOp(fieldDef?.aggregate);
    const invalidDataMode = getScaleInvalidDataMode({
        scaleChannel,
        markDef,
        config,
        scaleType,
        isCountAggregate
    });
    if (fieldDef && invalidDataMode === 'show') {
        const includeAs = config.scale.invalid?.[scaleChannel] ?? 'zero-or-min';
        return {
            test: fieldValidPredicate(vgField(fieldDef, {
                expr: 'datum'
            }), false),
            ...refForInvalidValues(includeAs, scale, scaleName)
        };
    }
    return undefined;
}
function refForInvalidValues(includeAs, scale, scaleName) {
    if (isScaleInvalidDataIncludeAsValue(includeAs)) {
        const { value } = includeAs;
        return isSignalRef(value) ? {
            signal: value.signal
        } : {
            value
        };
    }
    return scaledZeroOrMinOrMax({
        scale,
        scaleName,
        mode: 'zeroOrMin'
    });
}
function midPointRefWithPositionInvalidTest(params) {
    const { channel, channelDef, markDef, scale, scaleName, config } = params;
    const scaleChannel = getMainRangeChannel(channel);
    const mainRef = midPoint(params);
    const valueRefForIncludingInvalid = getConditionalValueRefForIncludingInvalidValue({
        scaleChannel,
        channelDef,
        scale,
        scaleName,
        markDef,
        config
    });
    return valueRefForIncludingInvalid !== undefined ? [
        valueRefForIncludingInvalid,
        mainRef
    ] : mainRef;
}
function datumDefToExpr(datumDef) {
    const { datum } = datumDef;
    if (isDateTime(datum)) return dateTimeToExpr(datum);
    return `${stringify(datum)}`;
}
function valueRefForFieldOrDatumDef(fieldDef, scaleName, opt, encode) {
    const ref = {};
    if (scaleName) ref.scale = scaleName;
    if (isDatumDef(fieldDef)) {
        const { datum } = fieldDef;
        if (isDateTime(datum)) ref.signal = dateTimeToExpr(datum);
        else if (isSignalRef(datum)) ref.signal = datum.signal;
        else if (isExprRef(datum)) ref.signal = datum.expr;
        else ref.value = datum;
    } else ref.field = vgField(fieldDef, opt);
    if (encode) {
        const { offset, band } = encode;
        if (offset) ref.offset = offset;
        if (band) ref.band = band;
    }
    return ref;
}
/**
 * Signal that returns the middle of a bin from start and end field. Should only be used with x and y.
 */ function interpolatedSignalRef({ scaleName, fieldOrDatumDef, fieldOrDatumDef2, offset, startSuffix, endSuffix = 'end', bandPosition = 0.5 }) {
    const expr = !isSignalRef(bandPosition) && 0 < bandPosition && bandPosition < 1 ? 'datum' : undefined;
    const start = vgField(fieldOrDatumDef, {
        expr,
        suffix: startSuffix
    });
    const end = fieldOrDatumDef2 !== undefined ? vgField(fieldOrDatumDef2, {
        expr
    }) : vgField(fieldOrDatumDef, {
        suffix: endSuffix,
        expr
    });
    const ref = {};
    if (bandPosition === 0 || bandPosition === 1) {
        ref.scale = scaleName;
        const field = bandPosition === 0 ? start : end;
        ref.field = field;
    } else {
        const datum = isSignalRef(bandPosition) ? `(1-${bandPosition.signal}) * ${start} + ${bandPosition.signal} * ${end}` : `${1 - bandPosition} * ${start} + ${bandPosition} * ${end}`;
        ref.signal = `scale("${scaleName}", ${datum})`;
    }
    if (offset) ref.offset = offset;
    return ref;
}
function binSizeExpr({ scaleName, fieldDef }) {
    const start = vgField(fieldDef, {
        expr: 'datum'
    });
    const end = vgField(fieldDef, {
        expr: 'datum',
        suffix: 'end'
    });
    return `abs(scale("${scaleName}", ${end}) - scale("${scaleName}", ${start}))`;
}
/**
 * @returns {VgValueRef} Value Ref for xc / yc or mid point for other channels.
 */ function midPoint({ channel, channelDef, channel2Def, markDef, config, scaleName, scale, stack, offset, defaultRef, bandPosition }) {
    // TODO: datum support
    if (channelDef) {
        /* istanbul ignore else */ if (isFieldOrDatumDef(channelDef)) {
            const scaleType = scale?.get('type');
            if (isTypedFieldDef(channelDef)) {
                bandPosition ??= getBandPosition({
                    fieldDef: channelDef,
                    fieldDef2: channel2Def,
                    markDef,
                    config
                });
                const { bin, timeUnit, type } = channelDef;
                if (isBinning(bin) || bandPosition && timeUnit && type === TEMPORAL) {
                    // Use middle only for x an y to place marks in the center between start and end of the bin range.
                    // We do not use the mid point for other channels (e.g. size) so that properties of legends and marks match.
                    if (stack?.impute) // For stack, we computed bin_mid so we can impute.
                    return valueRefForFieldOrDatumDef(channelDef, scaleName, {
                        binSuffix: 'mid'
                    }, {
                        offset
                    });
                    if (bandPosition && !hasDiscreteDomain(scaleType)) // if band = 0, no need to call interpolation
                    // For non-stack, we can just calculate bin mid on the fly using signal.
                    return interpolatedSignalRef({
                        scaleName,
                        fieldOrDatumDef: channelDef,
                        bandPosition,
                        offset
                    });
                    return valueRefForFieldOrDatumDef(channelDef, scaleName, binRequiresRange(channelDef, channel) ? {
                        binSuffix: 'range'
                    } : {}, {
                        offset
                    });
                } else if (isBinned(bin)) {
                    if (isFieldDef(channel2Def)) return interpolatedSignalRef({
                        scaleName,
                        fieldOrDatumDef: channelDef,
                        fieldOrDatumDef2: channel2Def,
                        bandPosition,
                        offset
                    });
                    else {
                        const channel2 = channel === X ? X2 : Y2;
                        warn(channelRequiredForBinned(channel2));
                    }
                }
            }
            return valueRefForFieldOrDatumDef(channelDef, scaleName, hasDiscreteDomain(scaleType) ? {
                binSuffix: 'range'
            } : {}, {
                offset,
                // For band, to get mid point, need to offset by half of the band
                band: scaleType === 'band' ? bandPosition ?? channelDef.bandPosition ?? 0.5 : undefined
            });
        } else if (isValueDef(channelDef)) {
            const value = channelDef.value;
            const offsetMixins = offset ? {
                offset
            } : {};
            return {
                ...widthHeightValueOrSignalRef(channel, value),
                ...offsetMixins
            };
        }
    // If channelDef is neither field def or value def, it's a condition-only def.
    // In such case, we will use default ref.
    }
    if ((0, _vegaUtil.isFunction)(defaultRef)) defaultRef = defaultRef();
    if (defaultRef) // for non-position, ref could be undefined.
    return {
        ...defaultRef,
        // only include offset when it is non-zero (zero = no offset)
        ...offset ? {
            offset
        } : {}
    };
    return defaultRef;
}
/**
 * Convert special "width" and "height" values in Vega-Lite into Vega value ref.
 */ function widthHeightValueOrSignalRef(channel, value) {
    if (contains([
        'x',
        'x2'
    ], channel) && value === 'width') return {
        field: {
            group: 'width'
        }
    };
    else if (contains([
        'y',
        'y2'
    ], channel) && value === 'height') return {
        field: {
            group: 'height'
        }
    };
    return signalOrValueRef(value);
}
function isCustomFormatType(formatType) {
    return formatType && formatType !== 'number' && formatType !== 'time';
}
function customFormatExpr(formatType, field, format) {
    return `${formatType}(${field}${format ? `, ${stringify(format)}` : ''})`;
}
const BIN_RANGE_DELIMITER = ' \u2013 ';
function formatSignalRef({ fieldOrDatumDef, format, formatType, expr, normalizeStack, config }) {
    if (isCustomFormatType(formatType)) return formatCustomType({
        fieldOrDatumDef,
        format,
        formatType,
        expr,
        config
    });
    const field = fieldToFormat(fieldOrDatumDef, expr, normalizeStack);
    const type = channelDefType(fieldOrDatumDef);
    if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if (type === 'quantitative') {
            if (normalizeStack && config.normalizedNumberFormatType) return formatCustomType({
                fieldOrDatumDef,
                format: config.normalizedNumberFormat,
                formatType: config.normalizedNumberFormatType,
                expr,
                config
            });
            if (config.numberFormatType) return formatCustomType({
                fieldOrDatumDef,
                format: config.numberFormat,
                formatType: config.numberFormatType,
                expr,
                config
            });
        }
        if (type === 'temporal' && config.timeFormatType && isFieldDef(fieldOrDatumDef) && fieldOrDatumDef.timeUnit === undefined) return formatCustomType({
            fieldOrDatumDef,
            format: config.timeFormat,
            formatType: config.timeFormatType,
            expr,
            config
        });
    }
    if (isFieldOrDatumDefForTimeFormat(fieldOrDatumDef)) {
        const signal = timeFormatExpression({
            field,
            timeUnit: isFieldDef(fieldOrDatumDef) ? normalizeTimeUnit(fieldOrDatumDef.timeUnit)?.unit : undefined,
            format,
            formatType: config.timeFormatType,
            rawTimeFormat: config.timeFormat,
            isUTCScale: isScaleFieldDef(fieldOrDatumDef) && fieldOrDatumDef.scale?.type === ScaleType.UTC
        });
        return signal ? {
            signal
        } : undefined;
    }
    format = numberFormat({
        type,
        specifiedFormat: format,
        config,
        normalizeStack
    });
    if (isFieldDef(fieldOrDatumDef) && isBinning(fieldOrDatumDef.bin)) {
        const endField = vgField(fieldOrDatumDef, {
            expr,
            binSuffix: 'end'
        });
        return {
            signal: binFormatExpression(field, endField, format, formatType, config)
        };
    } else if (format || channelDefType(fieldOrDatumDef) === 'quantitative') return {
        signal: `${formatExpr(field, format)}`
    };
    else return {
        signal: `isValid(${field}) ? ${field} : ""+${field}`
    };
}
function fieldToFormat(fieldOrDatumDef, expr, normalizeStack) {
    if (isFieldDef(fieldOrDatumDef)) {
        if (normalizeStack) return `${vgField(fieldOrDatumDef, {
            expr,
            suffix: 'end'
        })}-${vgField(fieldOrDatumDef, {
            expr,
            suffix: 'start'
        })}`;
        else return vgField(fieldOrDatumDef, {
            expr
        });
    } else return datumDefToExpr(fieldOrDatumDef);
}
function formatCustomType({ fieldOrDatumDef, format, formatType, expr, normalizeStack, config, field }) {
    field ??= fieldToFormat(fieldOrDatumDef, expr, normalizeStack);
    if (field !== 'datum.value' && // For axis/legend, we can't correctly know the end of the bin from `datum`
    isFieldDef(fieldOrDatumDef) && isBinning(fieldOrDatumDef.bin)) {
        const endField = vgField(fieldOrDatumDef, {
            expr,
            binSuffix: 'end'
        });
        return {
            signal: binFormatExpression(field, endField, format, formatType, config)
        };
    }
    return {
        signal: customFormatExpr(formatType, field, format)
    };
}
function guideFormat(fieldOrDatumDef, type, format, formatType, config, omitTimeFormatConfig) {
    if ((0, _vegaUtil.isString)(formatType) && isCustomFormatType(formatType)) return undefined; // handled in encode block
    else if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if (channelDefType(fieldOrDatumDef) === 'quantitative') {
            if (config.normalizedNumberFormatType && isPositionFieldOrDatumDef(fieldOrDatumDef) && fieldOrDatumDef.stack === 'normalize') return undefined; // handled in encode block
            if (config.numberFormatType) return undefined; // handled in encode block
        }
    }
    if (isPositionFieldOrDatumDef(fieldOrDatumDef) && fieldOrDatumDef.stack === 'normalize' && config.normalizedNumberFormat) return numberFormat({
        type: 'quantitative',
        config,
        normalizeStack: true
    });
    if (isFieldOrDatumDefForTimeFormat(fieldOrDatumDef)) {
        const timeUnit = isFieldDef(fieldOrDatumDef) ? normalizeTimeUnit(fieldOrDatumDef.timeUnit)?.unit : undefined;
        if (timeUnit === undefined && config.customFormatTypes && config.timeFormatType) return undefined; // hanlded in encode block
        return timeFormat({
            specifiedFormat: format,
            timeUnit,
            config,
            omitTimeFormatConfig
        });
    }
    return numberFormat({
        type,
        specifiedFormat: format,
        config
    });
}
function guideFormatType(formatType, fieldOrDatumDef, scaleType) {
    if (formatType && (isSignalRef(formatType) || formatType === 'number' || formatType === 'time')) return formatType;
    if (isFieldOrDatumDefForTimeFormat(fieldOrDatumDef) && scaleType !== 'time' && scaleType !== 'utc') return isFieldDef(fieldOrDatumDef) && normalizeTimeUnit(fieldOrDatumDef?.timeUnit)?.utc ? 'utc' : 'time';
    return undefined;
}
/**
 * Returns number format for a fieldDef.
 */ function numberFormat({ type, specifiedFormat, config, normalizeStack }) {
    // Specified format in axis/legend has higher precedence than fieldDef.format
    if ((0, _vegaUtil.isString)(specifiedFormat)) return specifiedFormat;
    if (type === QUANTITATIVE) // we only apply the default if the field is quantitative
    return normalizeStack ? config.normalizedNumberFormat : config.numberFormat;
    return undefined;
}
/**
 * Returns time format for a fieldDef for use in guides.
 */ function timeFormat({ specifiedFormat, timeUnit, config, omitTimeFormatConfig }) {
    if (specifiedFormat) return specifiedFormat;
    if (timeUnit) return {
        signal: timeUnitSpecifierExpression(timeUnit)
    };
    return omitTimeFormatConfig ? undefined : config.timeFormat;
}
function formatExpr(field, format) {
    return `format(${field}, "${format || ''}")`;
}
function binNumberFormatExpr(field, format, formatType, config) {
    if (isCustomFormatType(formatType)) return customFormatExpr(formatType, field, format);
    return formatExpr(field, ((0, _vegaUtil.isString)(format) ? format : undefined) ?? config.numberFormat);
}
function binFormatExpression(startField, endField, format, formatType, config) {
    if (format === undefined && formatType === undefined && config.customFormatTypes && config.numberFormatType) return binFormatExpression(startField, endField, config.numberFormat, config.numberFormatType, config);
    const start = binNumberFormatExpr(startField, format, formatType, config);
    const end = binNumberFormatExpr(endField, format, formatType, config);
    return `${fieldValidPredicate(startField, false)} ? "null" : ${start} + "${BIN_RANGE_DELIMITER}" + ${end}`;
}
/**
 * Returns the time expression used for axis/legend labels or text mark for a temporal field
 */ function timeFormatExpression({ field, timeUnit, format, formatType, rawTimeFormat, isUTCScale }) {
    if (!timeUnit || format) {
        // If there is no time unit, or if user explicitly specifies format for axis/legend/text.
        if (!timeUnit && formatType) return `${formatType}(${field}, ${stringify(format)})`;
        format = (0, _vegaUtil.isString)(format) ? format : rawTimeFormat; // only use provided timeFormat if there is no timeUnit.
        return `${isUTCScale ? 'utc' : 'time'}Format(${field}, ${stringify(format)})`;
    } else return formatExpression(timeUnit, field, isUTCScale);
}
const DEFAULT_SORT_OP = 'min';
const SORT_BY_CHANNEL_INDEX = {
    x: 1,
    y: 1,
    color: 1,
    fill: 1,
    stroke: 1,
    strokeWidth: 1,
    size: 1,
    shape: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    opacity: 1,
    text: 1
};
function isSortByChannel(c) {
    return (0, _vegaUtil.hasOwnProperty)(SORT_BY_CHANNEL_INDEX, c);
}
function isSortByEncoding(sort) {
    return hasProperty(sort, 'encoding');
}
function isSortField(sort) {
    return sort && (sort.op === 'count' || hasProperty(sort, 'field'));
}
function isSortArray(sort) {
    return sort && (0, _vegaUtil.isArray)(sort);
}
function isFacetMapping(f) {
    return hasProperty(f, 'row') || hasProperty(f, 'column');
}
function isFacetFieldDef(channelDef) {
    return hasProperty(channelDef, 'header');
}
function isFacetSpec(spec) {
    return hasProperty(spec, 'facet');
}
function isConditionalParameter(c) {
    return hasProperty(c, 'param');
}
function isRepeatRef(field) {
    return !(0, _vegaUtil.isString)(field) && hasProperty(field, 'repeat');
}
function toFieldDefBase(fieldDef) {
    const { field, timeUnit, bin, aggregate } = fieldDef;
    return {
        ...timeUnit ? {
            timeUnit
        } : {},
        ...bin ? {
            bin
        } : {},
        ...aggregate ? {
            aggregate
        } : {},
        field
    };
}
function isSortableFieldDef(fieldDef) {
    return hasProperty(fieldDef, 'sort');
}
function getBandPosition({ fieldDef, fieldDef2, markDef: mark, config }) {
    if (isFieldOrDatumDef(fieldDef) && fieldDef.bandPosition !== undefined) return fieldDef.bandPosition;
    if (isFieldDef(fieldDef)) {
        const { timeUnit, bin } = fieldDef;
        if (timeUnit && !fieldDef2) return getMarkConfig('timeUnitBandPosition', mark, config);
        else if (isBinning(bin)) return 0.5;
    }
    return undefined;
}
function getBandSize({ channel, fieldDef, fieldDef2, markDef: mark, config, scaleType, useVlSizeChannel }) {
    const sizeChannel = getSizeChannel(channel);
    const size = getMarkPropOrConfig(useVlSizeChannel ? 'size' : sizeChannel, mark, config, {
        vgChannel: sizeChannel
    });
    if (size !== undefined) return size;
    if (isFieldDef(fieldDef)) {
        const { timeUnit, bin } = fieldDef;
        if (timeUnit && !fieldDef2) return {
            band: getMarkConfig('timeUnitBandSize', mark, config)
        };
        else if (isBinning(bin) && !hasDiscreteDomain(scaleType)) return {
            band: 1
        };
    }
    if (isRectBasedMark(mark.type)) {
        if (scaleType) {
            if (hasDiscreteDomain(scaleType)) return config[mark.type]?.discreteBandSize || {
                band: 1
            };
            else return config[mark.type]?.continuousBandSize;
        }
        return config[mark.type]?.discreteBandSize;
    }
    return undefined;
}
function hasBandEnd(fieldDef, fieldDef2, markDef, config) {
    if (isBinning(fieldDef.bin) || fieldDef.timeUnit && isTypedFieldDef(fieldDef) && fieldDef.type === 'temporal') // Need to check bandPosition because non-rect marks (e.g., point) with timeUnit
    // doesn't have to use bandEnd if there is no bandPosition.
    return getBandPosition({
        fieldDef,
        fieldDef2,
        markDef,
        config
    }) !== undefined;
    return false;
}
function isOrderOnlyDef(orderDef) {
    return hasProperty(orderDef, 'sort') && !hasProperty(orderDef, 'field');
}
function isConditionalDef(channelDef) {
    return hasProperty(channelDef, 'condition');
}
/**
 * Return if a channelDef is a ConditionalValueDef with ConditionFieldDef
 */ function hasConditionalFieldDef(channelDef) {
    const condition = channelDef?.['condition'];
    return !!condition && !(0, _vegaUtil.isArray)(condition) && isFieldDef(condition);
}
function hasConditionalFieldOrDatumDef(channelDef) {
    const condition = channelDef?.['condition'];
    return !!condition && !(0, _vegaUtil.isArray)(condition) && isFieldOrDatumDef(condition);
}
function hasConditionalValueDef(channelDef) {
    const condition = channelDef?.['condition'];
    return !!condition && ((0, _vegaUtil.isArray)(condition) || isValueDef(condition));
}
function isFieldDef(channelDef) {
    return hasProperty(channelDef, 'field') || channelDef?.aggregate === 'count';
}
function channelDefType(channelDef) {
    return channelDef?.['type'];
}
function isDatumDef(channelDef) {
    return hasProperty(channelDef, 'datum');
}
function isContinuousFieldOrDatumDef(cd) {
    // TODO: make datum support DateTime object
    return isTypedFieldDef(cd) && !isDiscrete(cd) || isNumericDataDef(cd);
}
function isUnbinnedQuantitativeFieldOrDatumDef(cd) {
    // TODO: make datum support DateTime object
    return isTypedFieldDef(cd) && cd.type === 'quantitative' && !cd.bin || isNumericDataDef(cd);
}
function isNumericDataDef(cd) {
    return isDatumDef(cd) && (0, _vegaUtil.isNumber)(cd.datum);
}
function isFieldOrDatumDef(channelDef) {
    return isFieldDef(channelDef) || isDatumDef(channelDef);
}
function isTypedFieldDef(channelDef) {
    return channelDef && (hasProperty(channelDef, 'field') || channelDef['aggregate'] === 'count') && hasProperty(channelDef, 'type');
}
function isValueDef(channelDef) {
    return hasProperty(channelDef, 'value');
}
function isScaleFieldDef(channelDef) {
    return hasProperty(channelDef, 'scale') || hasProperty(channelDef, 'sort');
}
function isPositionFieldOrDatumDef(channelDef) {
    return hasProperty(channelDef, 'axis') || hasProperty(channelDef, 'stack') || hasProperty(channelDef, 'impute');
}
function isMarkPropFieldOrDatumDef(channelDef) {
    return hasProperty(channelDef, 'legend');
}
function isStringFieldOrDatumDef(channelDef) {
    return hasProperty(channelDef, 'format') || hasProperty(channelDef, 'formatType');
}
function toStringFieldDef(fieldDef) {
    // omit properties that don't exist in string field defs
    return omit(fieldDef, [
        'legend',
        'axis',
        'header',
        'scale'
    ]);
}
function isOpFieldDef(fieldDef) {
    return hasProperty(fieldDef, 'op');
}
/**
 * Get a Vega field reference from a Vega-Lite field def.
 */ function vgField(fieldDef, opt = {}) {
    let field = fieldDef.field;
    const prefix = opt.prefix;
    let suffix = opt.suffix;
    let argAccessor = ''; // for accessing argmin/argmax field at the end without getting escaped
    if (isCount(fieldDef)) field = internalField('count');
    else {
        let fn;
        if (!opt.nofn) {
            if (isOpFieldDef(fieldDef)) fn = fieldDef.op;
            else {
                const { bin, aggregate, timeUnit } = fieldDef;
                if (isBinning(bin)) {
                    fn = binToString(bin);
                    suffix = (opt.binSuffix ?? '') + (opt.suffix ?? '');
                } else if (aggregate) {
                    if (isArgmaxDef(aggregate)) {
                        argAccessor = `["${field}"]`;
                        field = `argmax_${aggregate.argmax}`;
                    } else if (isArgminDef(aggregate)) {
                        argAccessor = `["${field}"]`;
                        field = `argmin_${aggregate.argmin}`;
                    } else fn = String(aggregate);
                } else if (timeUnit && !isBinnedTimeUnit(timeUnit)) {
                    fn = timeUnitToString(timeUnit);
                    suffix = (![
                        'range',
                        'mid'
                    ].includes(opt.binSuffix) && opt.binSuffix || '') + (opt.suffix ?? '');
                }
            }
        }
        if (fn) field = field ? `${fn}_${field}` : fn;
    }
    if (suffix) field = `${field}_${suffix}`;
    if (prefix) field = `${prefix}_${field}`;
    if (opt.forAs) return removePathFromField(field);
    else if (opt.expr) // Expression to access flattened field. No need to escape dots.
    return flatAccessWithDatum(field, opt.expr) + argAccessor;
    else // We flattened all fields so paths should have become dot.
    return replacePathInField(field) + argAccessor;
}
function isDiscrete(def) {
    switch(def.type){
        case 'nominal':
        case 'ordinal':
        case 'geojson':
            return true;
        case 'quantitative':
            return isFieldDef(def) && !!def.bin;
        case 'temporal':
            return false;
    }
    throw new Error(invalidFieldType(def.type));
}
function isDiscretizing(def) {
    return isScaleFieldDef(def) && isContinuousToDiscrete(def.scale?.type);
}
function isCount(fieldDef) {
    return fieldDef.aggregate === 'count';
}
function verbalTitleFormatter(fieldDef, config) {
    const { field, bin, timeUnit, aggregate } = fieldDef;
    if (aggregate === 'count') return config.countTitle;
    else if (isBinning(bin)) return `${field} (binned)`;
    else if (timeUnit && !isBinnedTimeUnit(timeUnit)) {
        const unit = normalizeTimeUnit(timeUnit)?.unit;
        if (unit) return `${field} (${getTimeUnitParts(unit).join('-')})`;
    } else if (aggregate) {
        if (isArgmaxDef(aggregate)) return `${field} for max ${aggregate.argmax}`;
        else if (isArgminDef(aggregate)) return `${field} for min ${aggregate.argmin}`;
        else return `${titleCase(aggregate)} of ${field}`;
    }
    return field;
}
function functionalTitleFormatter(fieldDef) {
    const { aggregate, bin, timeUnit, field } = fieldDef;
    if (isArgmaxDef(aggregate)) return `${field} for argmax(${aggregate.argmax})`;
    else if (isArgminDef(aggregate)) return `${field} for argmin(${aggregate.argmin})`;
    const timeUnitParams = timeUnit && !isBinnedTimeUnit(timeUnit) ? normalizeTimeUnit(timeUnit) : undefined;
    const fn = aggregate || timeUnitParams?.unit || timeUnitParams?.maxbins && 'timeunit' || isBinning(bin) && 'bin';
    return fn ? `${fn.toUpperCase()}(${field})` : field;
}
const defaultTitleFormatter = (fieldDef, config)=>{
    switch(config.fieldTitle){
        case 'plain':
            return fieldDef.field;
        case 'functional':
            return functionalTitleFormatter(fieldDef);
        default:
            return verbalTitleFormatter(fieldDef, config);
    }
};
let titleFormatter = defaultTitleFormatter;
function setTitleFormatter(formatter) {
    titleFormatter = formatter;
}
function resetTitleFormatter() {
    setTitleFormatter(defaultTitleFormatter);
}
function title(fieldOrDatumDef, config, { allowDisabling, includeDefault = true }) {
    const guideTitle = getGuide(fieldOrDatumDef)?.title;
    if (!isFieldDef(fieldOrDatumDef)) return guideTitle ?? fieldOrDatumDef.title;
    const fieldDef = fieldOrDatumDef;
    const def = includeDefault ? defaultTitle(fieldDef, config) : undefined;
    if (allowDisabling) return getFirstDefined(guideTitle, fieldDef.title, def);
    else return guideTitle ?? fieldDef.title ?? def;
}
function getGuide(fieldDef) {
    if (isPositionFieldOrDatumDef(fieldDef) && fieldDef.axis) return fieldDef.axis;
    else if (isMarkPropFieldOrDatumDef(fieldDef) && fieldDef.legend) return fieldDef.legend;
    else if (isFacetFieldDef(fieldDef) && fieldDef.header) return fieldDef.header;
    return undefined;
}
function defaultTitle(fieldDef, config) {
    return titleFormatter(fieldDef, config);
}
function getFormatMixins(fieldDef) {
    if (isStringFieldOrDatumDef(fieldDef)) {
        const { format, formatType } = fieldDef;
        return {
            format,
            formatType
        };
    } else {
        const guide = getGuide(fieldDef) ?? {};
        const { format, formatType } = guide;
        return {
            format,
            formatType
        };
    }
}
function defaultType$2(fieldDef, channel) {
    switch(channel){
        case 'latitude':
        case 'longitude':
            return 'quantitative';
        case 'row':
        case 'column':
        case 'facet':
        case 'shape':
        case 'strokeDash':
            return 'nominal';
        case 'order':
            return 'ordinal';
    }
    if (isSortableFieldDef(fieldDef) && (0, _vegaUtil.isArray)(fieldDef.sort)) return 'ordinal';
    const { aggregate, bin, timeUnit } = fieldDef;
    if (timeUnit) return 'temporal';
    if (bin || aggregate && !isArgmaxDef(aggregate) && !isArgminDef(aggregate)) return 'quantitative';
    if (isScaleFieldDef(fieldDef) && fieldDef.scale?.type) switch(SCALE_CATEGORY_INDEX[fieldDef.scale.type]){
        case 'numeric':
        case 'discretizing':
            return 'quantitative';
        case 'time':
            return 'temporal';
    }
    return 'nominal';
}
/**
 * Returns the fieldDef -- either from the outer channelDef or from the condition of channelDef.
 * @param channelDef
 */ function getFieldDef(channelDef) {
    if (isFieldDef(channelDef)) return channelDef;
    else if (hasConditionalFieldDef(channelDef)) return channelDef.condition;
    return undefined;
}
function getFieldOrDatumDef(channelDef) {
    if (isFieldOrDatumDef(channelDef)) return channelDef;
    else if (hasConditionalFieldOrDatumDef(channelDef)) return channelDef.condition;
    return undefined;
}
/**
 * Convert type to full, lowercase type, or augment the fieldDef with a default type if missing.
 */ function initChannelDef(channelDef, channel, config, opt = {}) {
    if ((0, _vegaUtil.isString)(channelDef) || (0, _vegaUtil.isNumber)(channelDef) || (0, _vegaUtil.isBoolean)(channelDef)) {
        const primitiveType = (0, _vegaUtil.isString)(channelDef) ? 'string' : (0, _vegaUtil.isNumber)(channelDef) ? 'number' : 'boolean';
        warn(primitiveChannelDef(channel, primitiveType, channelDef));
        return {
            value: channelDef
        };
    }
    // If a fieldDef contains a field, we need type.
    if (isFieldOrDatumDef(channelDef)) return initFieldOrDatumDef(channelDef, channel, config, opt);
    else if (hasConditionalFieldOrDatumDef(channelDef)) return {
        ...channelDef,
        // Need to cast as normalizeFieldDef normally return FieldDef, but here we know that it is definitely Condition<FieldDef>
        condition: initFieldOrDatumDef(channelDef.condition, channel, config, opt)
    };
    return channelDef;
}
function initFieldOrDatumDef(fd, channel, config, opt) {
    if (isStringFieldOrDatumDef(fd)) {
        const { format, formatType, ...rest } = fd;
        if (isCustomFormatType(formatType) && !config.customFormatTypes) {
            warn(customFormatTypeNotAllowed(channel));
            return initFieldOrDatumDef(rest, channel, config, opt);
        }
    } else {
        const guideType = isPositionFieldOrDatumDef(fd) ? 'axis' : isMarkPropFieldOrDatumDef(fd) ? 'legend' : isFacetFieldDef(fd) ? 'header' : null;
        if (guideType && fd[guideType]) {
            const { format, formatType, ...newGuide } = fd[guideType];
            if (isCustomFormatType(formatType) && !config.customFormatTypes) {
                warn(customFormatTypeNotAllowed(channel));
                return initFieldOrDatumDef({
                    ...fd,
                    [guideType]: newGuide
                }, channel, config, opt);
            }
        }
    }
    if (isFieldDef(fd)) return initFieldDef(fd, channel, opt);
    return initDatumDef(fd);
}
function initDatumDef(datumDef) {
    let type = datumDef['type'];
    if (type) return datumDef;
    const { datum } = datumDef;
    type = (0, _vegaUtil.isNumber)(datum) ? 'quantitative' : (0, _vegaUtil.isString)(datum) ? 'nominal' : isDateTime(datum) ? 'temporal' : undefined;
    return {
        ...datumDef,
        type
    };
}
function initFieldDef(fd, channel, { compositeMark = false } = {}) {
    const { aggregate, timeUnit, bin, field } = fd;
    const fieldDef = {
        ...fd
    };
    // Drop invalid aggregate
    if (!compositeMark && aggregate && !isAggregateOp(aggregate) && !isArgmaxDef(aggregate) && !isArgminDef(aggregate)) {
        warn(invalidAggregate(aggregate));
        delete fieldDef.aggregate;
    }
    // Normalize Time Unit
    if (timeUnit) fieldDef.timeUnit = normalizeTimeUnit(timeUnit);
    if (field) fieldDef.field = `${field}`;
    // Normalize bin
    if (isBinning(bin)) fieldDef.bin = normalizeBin(bin, channel);
    if (isBinned(bin) && !isXorY(channel)) warn(channelShouldNotBeUsedForBinned(channel));
    // Normalize Type
    if (isTypedFieldDef(fieldDef)) {
        const { type } = fieldDef;
        const fullType = getFullName(type);
        if (type !== fullType) // convert short type to full type
        fieldDef.type = fullType;
        if (type !== 'quantitative') {
            if (isCountingAggregateOp(aggregate)) {
                warn(invalidFieldTypeForCountAggregate(type, aggregate));
                fieldDef.type = 'quantitative';
            }
        }
    } else if (!isSecondaryRangeChannel(channel)) {
        // If type is empty / invalid, then augment with default type
        const newType = defaultType$2(fieldDef, channel);
        fieldDef['type'] = newType;
    }
    if (isTypedFieldDef(fieldDef)) {
        const { compatible, warning } = channelCompatibility(fieldDef, channel) || {};
        if (compatible === false) warn(warning);
    }
    if (isSortableFieldDef(fieldDef) && (0, _vegaUtil.isString)(fieldDef.sort)) {
        const { sort } = fieldDef;
        if (isSortByChannel(sort)) return {
            ...fieldDef,
            sort: {
                encoding: sort
            }
        };
        const sub = sort.substring(1);
        if (sort.charAt(0) === '-' && isSortByChannel(sub)) return {
            ...fieldDef,
            sort: {
                encoding: sub,
                order: 'descending'
            }
        };
    }
    if (isFacetFieldDef(fieldDef)) {
        const { header } = fieldDef;
        if (header) {
            const { orient, ...rest } = header;
            if (orient) return {
                ...fieldDef,
                header: {
                    ...rest,
                    labelOrient: header.labelOrient || orient,
                    titleOrient: header.titleOrient || orient
                }
            };
        }
    }
    return fieldDef;
}
function normalizeBin(bin, channel) {
    if ((0, _vegaUtil.isBoolean)(bin)) return {
        maxbins: autoMaxBins(channel)
    };
    else if (bin === 'binned') return {
        binned: true
    };
    else if (!bin.maxbins && !bin.step) return {
        ...bin,
        maxbins: autoMaxBins(channel)
    };
    else return bin;
}
const COMPATIBLE = {
    compatible: true
};
function channelCompatibility(fieldDef, channel) {
    const type = fieldDef.type;
    if (type === 'geojson' && channel !== 'shape') return {
        compatible: false,
        warning: `Channel ${channel} should not be used with a geojson data.`
    };
    switch(channel){
        case ROW:
        case COLUMN:
        case FACET:
            if (!isDiscrete(fieldDef)) return {
                compatible: false,
                warning: channelShouldBeDiscrete(channel)
            };
            return COMPATIBLE;
        case X:
        case Y:
        case XOFFSET:
        case YOFFSET:
        case COLOR:
        case FILL:
        case STROKE:
        case TEXT$1:
        case DETAIL:
        case KEY:
        case TOOLTIP:
        case HREF:
        case URL:
        case ANGLE:
        case THETA:
        case RADIUS:
        case DESCRIPTION:
            return COMPATIBLE;
        case LONGITUDE:
        case LONGITUDE2:
        case LATITUDE:
        case LATITUDE2:
            if (type !== QUANTITATIVE) return {
                compatible: false,
                warning: `Channel ${channel} should be used with a quantitative field only, not ${fieldDef.type} field.`
            };
            return COMPATIBLE;
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
        case STROKEWIDTH:
        case SIZE:
        case THETA2:
        case RADIUS2:
        case X2:
        case Y2:
        case TIME:
            if (type === 'nominal' && !fieldDef['sort']) return {
                compatible: false,
                warning: `Channel ${channel} should not be used with an unsorted discrete field.`
            };
            return COMPATIBLE;
        case SHAPE:
        case STROKEDASH:
            if (!isDiscrete(fieldDef) && !isDiscretizing(fieldDef)) return {
                compatible: false,
                warning: channelShouldBeDiscreteOrDiscretizing(channel)
            };
            return COMPATIBLE;
        case ORDER:
            if (fieldDef.type === 'nominal' && !('sort' in fieldDef)) return {
                compatible: false,
                warning: `Channel order is inappropriate for nominal field, which has no inherent order.`
            };
            return COMPATIBLE;
    }
}
/**
 * Check if the field def uses a time format or does not use any format but is temporal
 * (this does not cover field defs that are temporal but use a number format).
 */ function isFieldOrDatumDefForTimeFormat(fieldOrDatumDef) {
    const { formatType } = getFormatMixins(fieldOrDatumDef);
    return formatType === 'time' || !formatType && isTemporalFieldDef(fieldOrDatumDef);
}
/**
 * Check if field def has type `temporal`. If you want to also cover field defs that use a time format, use `isFieldOrDatumDefForTimeFormat`.
 */ function isTemporalFieldDef(def) {
    return def && (def['type'] === 'temporal' || isFieldDef(def) && !!def.timeUnit);
}
/**
 * Getting a value associated with a fielddef.
 * Convert the value to Vega expression if applicable (for datetime object, or string if the field def is temporal or has timeUnit)
 */ function valueExpr(v, { timeUnit, type, wrapTime, undefinedIfExprNotRequired }) {
    const unit = timeUnit && normalizeTimeUnit(timeUnit)?.unit;
    let isTime = unit || type === 'temporal';
    let expr;
    if (isExprRef(v)) expr = v.expr;
    else if (isSignalRef(v)) expr = v.signal;
    else if (isDateTime(v)) {
        isTime = true;
        expr = dateTimeToExpr(v);
    } else if ((0, _vegaUtil.isString)(v) || (0, _vegaUtil.isNumber)(v)) {
        if (isTime) {
            expr = `datetime(${stringify(v)})`;
            if (isLocalSingleTimeUnit(unit)) // for single timeUnit, we will use dateTimeToExpr to convert number/string to match the timeUnit
            {
                if ((0, _vegaUtil.isNumber)(v) && v < 10000 || (0, _vegaUtil.isString)(v) && isNaN(Date.parse(v))) expr = dateTimeToExpr({
                    [unit]: v
                });
            }
        }
    }
    if (expr) return wrapTime && isTime ? `time(${expr})` : expr;
    // number or boolean or normal string
    return undefinedIfExprNotRequired ? undefined : stringify(v);
}
/**
 * Standardize value array -- convert each value to Vega expression if applicable
 */ function valueArray(fieldOrDatumDef, values) {
    const { type } = fieldOrDatumDef;
    return values.map((v)=>{
        const timeUnit = isFieldDef(fieldOrDatumDef) && !isBinnedTimeUnit(fieldOrDatumDef.timeUnit) ? fieldOrDatumDef.timeUnit : undefined;
        const expr = valueExpr(v, {
            timeUnit,
            type,
            undefinedIfExprNotRequired: true
        });
        // return signal for the expression if we need an expression
        if (expr !== undefined) return {
            signal: expr
        };
        // otherwise just return the original value
        return v;
    });
}
/**
 * Checks whether a fieldDef for a particular channel requires a computed bin range.
 */ function binRequiresRange(fieldDef, channel) {
    if (!isBinning(fieldDef.bin)) {
        console.warn('Only call this method for binned field defs.');
        return false;
    }
    // We need the range only when the user explicitly forces a binned field to be use discrete scale. In this case, bin range is used in axis and legend labels.
    // We could check whether the axis or legend exists (not disabled) but that seems overkill.
    return isScaleChannel(channel) && [
        'ordinal',
        'nominal'
    ].includes(fieldDef.type);
}
const CONDITIONAL_AXIS_PROP_INDEX = {
    labelAlign: {
        part: 'labels',
        vgProp: 'align'
    },
    labelBaseline: {
        part: 'labels',
        vgProp: 'baseline'
    },
    labelColor: {
        part: 'labels',
        vgProp: 'fill'
    },
    labelFont: {
        part: 'labels',
        vgProp: 'font'
    },
    labelFontSize: {
        part: 'labels',
        vgProp: 'fontSize'
    },
    labelFontStyle: {
        part: 'labels',
        vgProp: 'fontStyle'
    },
    labelFontWeight: {
        part: 'labels',
        vgProp: 'fontWeight'
    },
    labelOpacity: {
        part: 'labels',
        vgProp: 'opacity'
    },
    labelOffset: null,
    labelPadding: null,
    gridColor: {
        part: 'grid',
        vgProp: 'stroke'
    },
    gridDash: {
        part: 'grid',
        vgProp: 'strokeDash'
    },
    gridDashOffset: {
        part: 'grid',
        vgProp: 'strokeDashOffset'
    },
    gridOpacity: {
        part: 'grid',
        vgProp: 'opacity'
    },
    gridWidth: {
        part: 'grid',
        vgProp: 'strokeWidth'
    },
    tickColor: {
        part: 'ticks',
        vgProp: 'stroke'
    },
    tickDash: {
        part: 'ticks',
        vgProp: 'strokeDash'
    },
    tickDashOffset: {
        part: 'ticks',
        vgProp: 'strokeDashOffset'
    },
    tickOpacity: {
        part: 'ticks',
        vgProp: 'opacity'
    },
    tickSize: null,
    tickWidth: {
        part: 'ticks',
        vgProp: 'strokeWidth'
    }
};
function isConditionalAxisValue(v) {
    return v?.condition;
}
const AXIS_PARTS = [
    'domain',
    'grid',
    'labels',
    'ticks',
    'title'
];
/**
 * A dictionary listing whether a certain axis property is applicable for only main axes or only grid axes.
 */ const AXIS_PROPERTY_TYPE = {
    grid: 'grid',
    gridCap: 'grid',
    gridColor: 'grid',
    gridDash: 'grid',
    gridDashOffset: 'grid',
    gridOpacity: 'grid',
    gridScale: 'grid',
    gridWidth: 'grid',
    orient: 'main',
    bandPosition: 'both',
    aria: 'main',
    description: 'main',
    domain: 'main',
    domainCap: 'main',
    domainColor: 'main',
    domainDash: 'main',
    domainDashOffset: 'main',
    domainOpacity: 'main',
    domainWidth: 'main',
    format: 'main',
    formatType: 'main',
    labelAlign: 'main',
    labelAngle: 'main',
    labelBaseline: 'main',
    labelBound: 'main',
    labelColor: 'main',
    labelFlush: 'main',
    labelFlushOffset: 'main',
    labelFont: 'main',
    labelFontSize: 'main',
    labelFontStyle: 'main',
    labelFontWeight: 'main',
    labelLimit: 'main',
    labelLineHeight: 'main',
    labelOffset: 'main',
    labelOpacity: 'main',
    labelOverlap: 'main',
    labelPadding: 'main',
    labels: 'main',
    labelSeparation: 'main',
    maxExtent: 'main',
    minExtent: 'main',
    offset: 'both',
    position: 'main',
    tickCap: 'main',
    tickColor: 'main',
    tickDash: 'main',
    tickDashOffset: 'main',
    tickMinStep: 'both',
    tickOffset: 'both',
    tickOpacity: 'main',
    tickRound: 'both',
    ticks: 'main',
    tickSize: 'main',
    tickWidth: 'both',
    title: 'main',
    titleAlign: 'main',
    titleAnchor: 'main',
    titleAngle: 'main',
    titleBaseline: 'main',
    titleColor: 'main',
    titleFont: 'main',
    titleFontSize: 'main',
    titleFontStyle: 'main',
    titleFontWeight: 'main',
    titleLimit: 'main',
    titleLineHeight: 'main',
    titleOpacity: 'main',
    titlePadding: 'main',
    titleX: 'main',
    titleY: 'main',
    encode: 'both',
    scale: 'both',
    tickBand: 'both',
    tickCount: 'both',
    tickExtra: 'both',
    translate: 'both',
    values: 'both',
    zindex: 'both'
};
const COMMON_AXIS_PROPERTIES_INDEX = {
    orient: 1,
    aria: 1,
    bandPosition: 1,
    description: 1,
    domain: 1,
    domainCap: 1,
    domainColor: 1,
    domainDash: 1,
    domainDashOffset: 1,
    domainOpacity: 1,
    domainWidth: 1,
    format: 1,
    formatType: 1,
    grid: 1,
    gridCap: 1,
    gridColor: 1,
    gridDash: 1,
    gridDashOffset: 1,
    gridOpacity: 1,
    gridWidth: 1,
    labelAlign: 1,
    labelAngle: 1,
    labelBaseline: 1,
    labelBound: 1,
    labelColor: 1,
    labelFlush: 1,
    labelFlushOffset: 1,
    labelFont: 1,
    labelFontSize: 1,
    labelFontStyle: 1,
    labelFontWeight: 1,
    labelLimit: 1,
    labelLineHeight: 1,
    labelOffset: 1,
    labelOpacity: 1,
    labelOverlap: 1,
    labelPadding: 1,
    labels: 1,
    labelSeparation: 1,
    maxExtent: 1,
    minExtent: 1,
    offset: 1,
    position: 1,
    tickBand: 1,
    tickCap: 1,
    tickColor: 1,
    tickCount: 1,
    tickDash: 1,
    tickDashOffset: 1,
    tickExtra: 1,
    tickMinStep: 1,
    tickOffset: 1,
    tickOpacity: 1,
    tickRound: 1,
    ticks: 1,
    tickSize: 1,
    tickWidth: 1,
    title: 1,
    titleAlign: 1,
    titleAnchor: 1,
    titleAngle: 1,
    titleBaseline: 1,
    titleColor: 1,
    titleFont: 1,
    titleFontSize: 1,
    titleFontStyle: 1,
    titleFontWeight: 1,
    titleLimit: 1,
    titleLineHeight: 1,
    titleOpacity: 1,
    titlePadding: 1,
    titleX: 1,
    titleY: 1,
    translate: 1,
    values: 1,
    zindex: 1
};
const AXIS_PROPERTIES_INDEX = {
    ...COMMON_AXIS_PROPERTIES_INDEX,
    style: 1,
    labelExpr: 1,
    encoding: 1
};
function isAxisProperty(prop) {
    return (0, _vegaUtil.hasOwnProperty)(AXIS_PROPERTIES_INDEX, prop);
}
const AXIS_CONFIGS_INDEX = {
    axis: 1,
    axisBand: 1,
    axisBottom: 1,
    axisDiscrete: 1,
    axisLeft: 1,
    axisPoint: 1,
    axisQuantitative: 1,
    axisRight: 1,
    axisTemporal: 1,
    axisTop: 1,
    axisX: 1,
    axisXBand: 1,
    axisXDiscrete: 1,
    axisXPoint: 1,
    axisXQuantitative: 1,
    axisXTemporal: 1,
    axisY: 1,
    axisYBand: 1,
    axisYDiscrete: 1,
    axisYPoint: 1,
    axisYQuantitative: 1,
    axisYTemporal: 1
};
const AXIS_CONFIGS = keys(AXIS_CONFIGS_INDEX);
function isUnitSpec(spec) {
    return hasProperty(spec, 'mark');
}
class CompositeMarkNormalizer {
    name;
    run;
    constructor(name, run){
        this.name = name;
        this.run = run;
    }
    hasMatchingType(spec) {
        if (isUnitSpec(spec)) return getMarkType(spec.mark) === this.name;
        return false;
    }
}
function channelHasField(encoding, channel) {
    const channelDef = encoding?.[channel];
    if (channelDef) {
        if ((0, _vegaUtil.isArray)(channelDef)) return some(channelDef, (fieldDef)=>!!fieldDef.field);
        else return isFieldDef(channelDef) || hasConditionalFieldDef(channelDef);
    }
    return false;
}
function channelHasFieldOrDatum(encoding, channel) {
    const channelDef = encoding?.[channel];
    if (channelDef) {
        if ((0, _vegaUtil.isArray)(channelDef)) return some(channelDef, (fieldDef)=>!!fieldDef.field);
        else return isFieldDef(channelDef) || isDatumDef(channelDef) || hasConditionalFieldOrDatumDef(channelDef);
    }
    return false;
}
function channelHasNestedOffsetScale(encoding, channel) {
    if (isXorY(channel)) {
        const fieldDef = encoding[channel];
        if ((isFieldDef(fieldDef) || isDatumDef(fieldDef)) && (isDiscrete$1(fieldDef.type) || isFieldDef(fieldDef) && fieldDef.timeUnit)) {
            const offsetChannel = getOffsetScaleChannel(channel);
            return channelHasFieldOrDatum(encoding, offsetChannel);
        }
    }
    return false;
}
function isAggregate$1(encoding) {
    return some(CHANNELS, (channel)=>{
        if (channelHasField(encoding, channel)) {
            const channelDef = encoding[channel];
            if ((0, _vegaUtil.isArray)(channelDef)) return some(channelDef, (fieldDef)=>!!fieldDef.aggregate);
            else {
                const fieldDef = getFieldDef(channelDef);
                return fieldDef && !!fieldDef.aggregate;
            }
        }
        return false;
    });
}
function extractTransformsFromEncoding(oldEncoding, config) {
    const groupby = [];
    const bins = [];
    const timeUnits = [];
    const aggregate = [];
    const encoding = {};
    forEach(oldEncoding, (channelDef, channel)=>{
        // Extract potential embedded transformations along with remaining properties
        if (isFieldDef(channelDef)) {
            const { field, aggregate: aggOp, bin, timeUnit, ...remaining } = channelDef;
            if (aggOp || timeUnit || bin) {
                const guide = getGuide(channelDef);
                const isTitleDefined = guide?.title;
                let newField = vgField(channelDef, {
                    forAs: true
                });
                const newFieldDef = {
                    // Only add title if it doesn't exist
                    ...isTitleDefined ? [] : {
                        title: title(channelDef, config, {
                            allowDisabling: true
                        })
                    },
                    ...remaining,
                    // Always overwrite field
                    field: newField
                };
                if (aggOp) {
                    let op;
                    if (isArgmaxDef(aggOp)) {
                        op = 'argmax';
                        newField = vgField({
                            op: 'argmax',
                            field: aggOp.argmax
                        }, {
                            forAs: true
                        });
                        newFieldDef.field = `${newField}.${field}`;
                    } else if (isArgminDef(aggOp)) {
                        op = 'argmin';
                        newField = vgField({
                            op: 'argmin',
                            field: aggOp.argmin
                        }, {
                            forAs: true
                        });
                        newFieldDef.field = `${newField}.${field}`;
                    } else if (aggOp !== 'boxplot' && aggOp !== 'errorbar' && aggOp !== 'errorband') op = aggOp;
                    if (op) {
                        const aggregateEntry = {
                            op,
                            as: newField
                        };
                        if (field) aggregateEntry.field = field;
                        aggregate.push(aggregateEntry);
                    }
                } else {
                    groupby.push(newField);
                    if (isTypedFieldDef(channelDef) && isBinning(bin)) {
                        bins.push({
                            bin,
                            field,
                            as: newField
                        });
                        // Add additional groupbys for range and end of bins
                        groupby.push(vgField(channelDef, {
                            binSuffix: 'end'
                        }));
                        if (binRequiresRange(channelDef, channel)) groupby.push(vgField(channelDef, {
                            binSuffix: 'range'
                        }));
                        // Create accompanying 'x2' or 'y2' field if channel is 'x' or 'y' respectively
                        if (isXorY(channel)) {
                            const secondaryChannel = {
                                field: `${newField}_end`
                            };
                            encoding[`${channel}2`] = secondaryChannel;
                        }
                        newFieldDef.bin = 'binned';
                        if (!isSecondaryRangeChannel(channel)) newFieldDef['type'] = QUANTITATIVE;
                    } else if (timeUnit && !isBinnedTimeUnit(timeUnit)) {
                        timeUnits.push({
                            timeUnit,
                            field,
                            as: newField
                        });
                        // define the format type for later compilation
                        const formatType = isTypedFieldDef(channelDef) && channelDef.type !== TEMPORAL && 'time';
                        if (formatType) {
                            if (channel === TEXT$1 || channel === TOOLTIP) newFieldDef['formatType'] = formatType;
                            else if (isNonPositionScaleChannel(channel)) newFieldDef['legend'] = {
                                formatType,
                                ...newFieldDef['legend']
                            };
                            else if (isXorY(channel)) newFieldDef['axis'] = {
                                formatType,
                                ...newFieldDef['axis']
                            };
                        }
                    }
                }
                // now the field should refer to post-transformed field instead
                encoding[channel] = newFieldDef;
            } else {
                groupby.push(field);
                encoding[channel] = oldEncoding[channel];
            }
        } else // For value def / signal ref / datum def, just copy
        encoding[channel] = oldEncoding[channel];
    });
    return {
        bins,
        timeUnits,
        aggregate,
        groupby,
        encoding
    };
}
function markChannelCompatible(encoding, channel, mark) {
    const markSupported = supportMark(channel, mark);
    if (!markSupported) return false;
    else if (markSupported === 'binned') {
        const primaryFieldDef = encoding[channel === X2 ? X : Y];
        // circle, point, square and tick only support x2/y2 when their corresponding x/y fieldDef
        // has "binned" data and thus need x2/y2 to specify the bin-end field.
        if (isFieldDef(primaryFieldDef) && isFieldDef(encoding[channel]) && isBinned(primaryFieldDef.bin)) return true;
        else return false;
    }
    return true;
}
function initEncoding(encoding, mark, filled, config) {
    const normalizedEncoding = {};
    for (const key of keys(encoding))if (!isChannel(key)) // Drop invalid channel
    warn(invalidEncodingChannel(key));
    for (let channel of UNIT_CHANNELS){
        if (!encoding[channel]) continue;
        const channelDef = encoding[channel];
        if (isXorYOffset(channel)) {
            const mainChannel = getMainChannelFromOffsetChannel(channel);
            const positionDef = normalizedEncoding[mainChannel];
            if (isFieldDef(positionDef)) {
                if (isContinuous(positionDef.type)) {
                    if (isFieldDef(channelDef) && !positionDef.timeUnit) {
                        // TODO: nesting continuous field instead continuous field should
                        // behave like offsetting the data in data domain
                        warn(offsetNestedInsideContinuousPositionScaleDropped(mainChannel));
                        continue;
                    }
                }
            }
        }
        if (channel === 'angle' && mark === 'arc' && !encoding.theta) {
            warn(REPLACE_ANGLE_WITH_THETA);
            channel = THETA;
        }
        if (!markChannelCompatible(encoding, channel, mark)) {
            // Drop unsupported channel
            warn(incompatibleChannel(channel, mark));
            continue;
        }
        // Drop line's size if the field is aggregated.
        if (channel === SIZE && mark === 'line') {
            const fieldDef = getFieldDef(encoding[channel]);
            if (fieldDef?.aggregate) {
                warn(LINE_WITH_VARYING_SIZE);
                continue;
            }
        }
        // Drop color if either fill or stroke is specified
        if (channel === COLOR && (filled ? 'fill' in encoding : 'stroke' in encoding)) {
            warn(droppingColor('encoding', {
                fill: 'fill' in encoding,
                stroke: 'stroke' in encoding
            }));
            continue;
        }
        if (channel === DETAIL || channel === ORDER && !(0, _vegaUtil.isArray)(channelDef) && !isValueDef(channelDef) || channel === TOOLTIP && (0, _vegaUtil.isArray)(channelDef)) {
            if (channelDef) {
                if (channel === ORDER) {
                    const def = encoding[channel];
                    if (isOrderOnlyDef(def)) {
                        normalizedEncoding[channel] = def;
                        continue;
                    }
                }
                // Array of fieldDefs for detail channel (or production rule)
                normalizedEncoding[channel] = (0, _vegaUtil.array)(channelDef).reduce((defs, fieldDef)=>{
                    if (!isFieldDef(fieldDef)) warn(emptyFieldDef(fieldDef, channel));
                    else defs.push(initFieldDef(fieldDef, channel));
                    return defs;
                }, []);
            }
        } else {
            if (channel === TOOLTIP && channelDef === null) // Preserve null so we can use it to disable tooltip
            normalizedEncoding[channel] = null;
            else if (!isFieldDef(channelDef) && !isDatumDef(channelDef) && !isValueDef(channelDef) && !isConditionalDef(channelDef) && !isSignalRef(channelDef)) {
                warn(emptyFieldDef(channelDef, channel));
                continue;
            }
            normalizedEncoding[channel] = initChannelDef(channelDef, channel, config);
        }
    }
    return normalizedEncoding;
}
/**
 * For composite marks, we have to call initChannelDef during init so we can infer types earlier.
 */ function normalizeEncoding(encoding, config) {
    const normalizedEncoding = {};
    for (const channel of keys(encoding)){
        const newChannelDef = initChannelDef(encoding[channel], channel, config, {
            compositeMark: true
        });
        normalizedEncoding[channel] = newChannelDef;
    }
    return normalizedEncoding;
}
function fieldDefs(encoding) {
    const arr = [];
    for (const channel of keys(encoding))if (channelHasField(encoding, channel)) {
        const channelDef = encoding[channel];
        const channelDefArray = (0, _vegaUtil.array)(channelDef);
        for (const def of channelDefArray){
            if (isFieldDef(def)) arr.push(def);
            else if (hasConditionalFieldDef(def)) arr.push(def.condition);
        }
    }
    return arr;
}
function forEach(mapping, f, thisArg) {
    if (!mapping) return;
    for (const channel of keys(mapping)){
        const el = mapping[channel];
        if ((0, _vegaUtil.isArray)(el)) for (const channelDef of el)f.call(thisArg, channelDef, channel);
        else f.call(thisArg, el, channel);
    }
}
function reduce(mapping, f, init, thisArg) {
    if (!mapping) return init;
    return keys(mapping).reduce((r, channel)=>{
        const map = mapping[channel];
        if ((0, _vegaUtil.isArray)(map)) return map.reduce((r1, channelDef)=>{
            return f.call(thisArg, r1, channelDef, channel);
        }, r);
        else return f.call(thisArg, r, map, channel);
    }, init);
}
/**
 * Returns list of path grouping fields for the given encoding
 */ function pathGroupingFields(mark, encoding) {
    return keys(encoding).reduce((details, channel)=>{
        switch(channel){
            // x, y, x2, y2, lat, long, lat1, long2, order, tooltip, href, aria label, cursor should not cause lines to group
            case X:
            case Y:
            case HREF:
            case DESCRIPTION:
            case URL:
            case X2:
            case Y2:
            case XOFFSET:
            case YOFFSET:
            case THETA:
            case THETA2:
            case RADIUS:
            case RADIUS2:
            case TIME:
            // falls through
            case LATITUDE:
            case LONGITUDE:
            case LATITUDE2:
            case LONGITUDE2:
            // TODO: case 'cursor':
            // text, shape, shouldn't be a part of line/trail/area [falls through]
            case TEXT$1:
            case SHAPE:
            case ANGLE:
            // falls through
            // tooltip fields should not be added to group by [falls through]
            case TOOLTIP:
                return details;
            case ORDER:
                // order should not group line / trail
                if (mark === 'line' || mark === 'trail') return details;
            // but order should group area for stacking (falls through)
            case DETAIL:
            case KEY:
                {
                    const channelDef = encoding[channel];
                    if ((0, _vegaUtil.isArray)(channelDef) || isFieldDef(channelDef)) {
                        for (const fieldDef of (0, _vegaUtil.array)(channelDef))if (!fieldDef.aggregate) details.push(vgField(fieldDef, {}));
                    }
                    return details;
                }
            case SIZE:
                if (mark === 'trail') // For trail, size should not group trail lines.
                return details;
            // For line, size should group lines.
            // falls through
            case COLOR:
            case FILL:
            case STROKE:
            case OPACITY:
            case FILLOPACITY:
            case STROKEOPACITY:
            case STROKEDASH:
            case STROKEWIDTH:
                {
                    // TODO strokeDashOffset:
                    // falls through
                    const fieldDef = getFieldDef(encoding[channel]);
                    if (fieldDef && !fieldDef.aggregate) details.push(vgField(fieldDef, {}));
                    return details;
                }
        }
    }, []);
}
function filterTooltipWithAggregatedField(oldEncoding) {
    const { tooltip, ...filteredEncoding } = oldEncoding;
    if (!tooltip) return {
        filteredEncoding
    };
    let customTooltipWithAggregatedField;
    let customTooltipWithoutAggregatedField;
    if ((0, _vegaUtil.isArray)(tooltip)) {
        for (const t of tooltip)if (t.aggregate) {
            if (!customTooltipWithAggregatedField) customTooltipWithAggregatedField = [];
            customTooltipWithAggregatedField.push(t);
        } else {
            if (!customTooltipWithoutAggregatedField) customTooltipWithoutAggregatedField = [];
            customTooltipWithoutAggregatedField.push(t);
        }
        if (customTooltipWithAggregatedField) filteredEncoding.tooltip = customTooltipWithAggregatedField;
    } else if (tooltip.aggregate) filteredEncoding.tooltip = tooltip;
    else customTooltipWithoutAggregatedField = tooltip;
    if ((0, _vegaUtil.isArray)(customTooltipWithoutAggregatedField) && customTooltipWithoutAggregatedField.length === 1) customTooltipWithoutAggregatedField = customTooltipWithoutAggregatedField[0];
    return {
        customTooltipWithoutAggregatedField,
        filteredEncoding
    };
}
function getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, withFieldName = true) {
    if ('tooltip' in encodingWithoutContinuousAxis) return {
        tooltip: encodingWithoutContinuousAxis.tooltip
    };
    const fiveSummaryTooltip = tooltipSummary.map(({ fieldPrefix, titlePrefix })=>{
        const mainTitle = withFieldName ? ` of ${getTitle(continuousAxisChannelDef)}` : '';
        return {
            field: fieldPrefix + continuousAxisChannelDef.field,
            type: continuousAxisChannelDef.type,
            title: isSignalRef(titlePrefix) ? {
                signal: `${titlePrefix}"${escape(mainTitle)}"`
            } : titlePrefix + mainTitle
        };
    });
    const tooltipFieldDefs = fieldDefs(encodingWithoutContinuousAxis).map(toStringFieldDef);
    return {
        tooltip: [
            ...fiveSummaryTooltip,
            // need to cast because TextFieldDef supports fewer types of bin
            ...unique(tooltipFieldDefs, hash)
        ]
    };
}
function getTitle(continuousAxisChannelDef) {
    const { title, field } = continuousAxisChannelDef;
    return getFirstDefined(title, field);
}
function makeCompositeAggregatePartFactory(compositeMarkDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, compositeMarkConfig) {
    const { scale, axis } = continuousAxisChannelDef;
    return ({ partName, mark, positionPrefix, endPositionPrefix, extraEncoding = {} })=>{
        const title = getTitle(continuousAxisChannelDef);
        return partLayerMixins(compositeMarkDef, partName, compositeMarkConfig, {
            mark,
            encoding: {
                [continuousAxis]: {
                    field: `${positionPrefix}_${continuousAxisChannelDef.field}`,
                    type: continuousAxisChannelDef.type,
                    ...title !== undefined ? {
                        title
                    } : {},
                    ...scale !== undefined ? {
                        scale
                    } : {},
                    ...axis !== undefined ? {
                        axis
                    } : {}
                },
                ...(0, _vegaUtil.isString)(endPositionPrefix) ? {
                    [`${continuousAxis}2`]: {
                        field: `${endPositionPrefix}_${continuousAxisChannelDef.field}`
                    }
                } : {},
                ...sharedEncoding,
                ...extraEncoding
            }
        });
    };
}
function partLayerMixins(markDef, part, compositeMarkConfig, partBaseSpec) {
    const { clip, color, opacity } = markDef;
    const mark = markDef.type;
    if (markDef[part] || markDef[part] === undefined && compositeMarkConfig[part]) return [
        {
            ...partBaseSpec,
            mark: {
                ...compositeMarkConfig[part],
                ...clip ? {
                    clip
                } : {},
                ...color ? {
                    color
                } : {},
                ...opacity ? {
                    opacity
                } : {},
                ...isMarkDef(partBaseSpec.mark) ? partBaseSpec.mark : {
                    type: partBaseSpec.mark
                },
                style: `${mark}-${String(part)}`,
                ...(0, _vegaUtil.isBoolean)(markDef[part]) ? {} : markDef[part]
            }
        }
    ];
    return [];
}
function compositeMarkContinuousAxis(spec, orient, compositeMark) {
    const { encoding } = spec;
    const continuousAxis = orient === 'vertical' ? 'y' : 'x';
    const continuousAxisChannelDef = encoding[continuousAxis]; // Safe to cast because if x is not continuous fielddef, the orient would not be horizontal.
    const continuousAxisChannelDef2 = encoding[`${continuousAxis}2`];
    const continuousAxisChannelDefError = encoding[`${continuousAxis}Error`];
    const continuousAxisChannelDefError2 = encoding[`${continuousAxis}Error2`];
    return {
        continuousAxisChannelDef: filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark),
        continuousAxisChannelDef2: filterAggregateFromChannelDef(continuousAxisChannelDef2, compositeMark),
        continuousAxisChannelDefError: filterAggregateFromChannelDef(continuousAxisChannelDefError, compositeMark),
        continuousAxisChannelDefError2: filterAggregateFromChannelDef(continuousAxisChannelDefError2, compositeMark),
        continuousAxis
    };
}
function filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark) {
    if (continuousAxisChannelDef?.aggregate) {
        const { aggregate, ...continuousAxisWithoutAggregate } = continuousAxisChannelDef;
        if (aggregate !== compositeMark) warn(errorBarContinuousAxisHasCustomizedAggregate(aggregate, compositeMark));
        return continuousAxisWithoutAggregate;
    } else return continuousAxisChannelDef;
}
function compositeMarkOrient(spec, compositeMark) {
    const { mark, encoding } = spec;
    const { x, y } = encoding;
    if (isMarkDef(mark) && mark.orient) return mark.orient;
    if (isContinuousFieldOrDatumDef(x)) {
        // x is continuous
        if (isContinuousFieldOrDatumDef(y)) {
            // both x and y are continuous
            const xAggregate = isFieldDef(x) && x.aggregate;
            const yAggregate = isFieldDef(y) && y.aggregate;
            if (!xAggregate && yAggregate === compositeMark) return 'vertical';
            else if (!yAggregate && xAggregate === compositeMark) return 'horizontal';
            else if (xAggregate === compositeMark && yAggregate === compositeMark) throw new Error('Both x and y cannot have aggregate');
            else {
                if (isFieldOrDatumDefForTimeFormat(y) && !isFieldOrDatumDefForTimeFormat(x)) // y is temporal but x is not
                return 'horizontal';
                // default orientation for two continuous
                return 'vertical';
            }
        }
        return 'horizontal';
    } else if (isContinuousFieldOrDatumDef(y)) // y is continuous but x is not
    return 'vertical';
    else // Neither x nor y is continuous.
    throw new Error(`Need a valid continuous axis for ${compositeMark}s`);
}
const BOXPLOT = 'boxplot';
const BOXPLOT_PARTS = [
    'box',
    'median',
    'outliers',
    'rule',
    'ticks'
];
const boxPlotNormalizer = new CompositeMarkNormalizer(BOXPLOT, normalizeBoxPlot);
function getBoxPlotType(extent) {
    if ((0, _vegaUtil.isNumber)(extent)) return 'tukey';
    // Ham: If we ever want to, we could add another extent syntax `{kIQR: number}` for the original [Q1-k*IQR, Q3+k*IQR] whisker and call this boxPlotType = `kIQR`. However, I'm not exposing this for now.
    return extent;
}
function normalizeBoxPlot(spec, { config }) {
    // Need to initEncoding first so we can infer type
    spec = {
        ...spec,
        encoding: normalizeEncoding(spec.encoding, config)
    };
    const { mark, encoding: _encoding, params, projection: _p, ...outerSpec } = spec;
    const markDef = isMarkDef(mark) ? mark : {
        type: mark
    };
    // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support
    if (params) warn(selectionNotSupported('boxplot'));
    const extent = markDef.extent ?? config.boxplot.extent;
    const sizeValue = getMarkPropOrConfig('size', markDef, config);
    const invalid = markDef.invalid;
    const boxPlotType = getBoxPlotType(extent);
    const { bins, timeUnits, transform, continuousAxisChannelDef, continuousAxis, groupby, aggregate, encodingWithoutContinuousAxis, ticksOrient, boxOrient, customTooltipWithoutAggregatedField } = boxParams(spec, extent, config);
    const aliasedFieldName = removePathFromField(continuousAxisChannelDef.field);
    const { color, size, ...encodingWithoutSizeColorAndContinuousAxis } = encodingWithoutContinuousAxis;
    const makeBoxPlotPart = (sharedEncoding)=>{
        return makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, config.boxplot);
    };
    const makeBoxPlotExtent = makeBoxPlotPart(encodingWithoutSizeColorAndContinuousAxis);
    const makeBoxPlotBox = makeBoxPlotPart(encodingWithoutContinuousAxis);
    const defaultBoxColor = ((0, _vegaUtil.isObject)(config.boxplot.box) ? config.boxplot.box.color : config.mark.color) || '#4c78a8';
    const makeBoxPlotMidTick = makeBoxPlotPart({
        ...encodingWithoutSizeColorAndContinuousAxis,
        ...size ? {
            size
        } : {},
        color: {
            condition: {
                test: `${accessWithDatumToUnescapedPath(`lower_box_${continuousAxisChannelDef.field}`)} >= ${accessWithDatumToUnescapedPath(`upper_box_${continuousAxisChannelDef.field}`)}`,
                ...color || {
                    value: defaultBoxColor
                }
            }
        }
    });
    const fiveSummaryTooltipEncoding = getCompositeMarkTooltip([
        {
            fieldPrefix: boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_',
            titlePrefix: 'Max'
        },
        {
            fieldPrefix: 'upper_box_',
            titlePrefix: 'Q3'
        },
        {
            fieldPrefix: 'mid_box_',
            titlePrefix: 'Median'
        },
        {
            fieldPrefix: 'lower_box_',
            titlePrefix: 'Q1'
        },
        {
            fieldPrefix: boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_',
            titlePrefix: 'Min'
        }
    ], continuousAxisChannelDef, encodingWithoutContinuousAxis);
    // ## Whisker Layers
    const endTick = {
        type: 'tick',
        color: 'black',
        opacity: 1,
        orient: ticksOrient,
        invalid,
        aria: false
    };
    const whiskerTooltipEncoding = boxPlotType === 'min-max' ? fiveSummaryTooltipEncoding // for min-max, show five-summary tooltip for whisker
     : getCompositeMarkTooltip([
        {
            fieldPrefix: 'upper_whisker_',
            titlePrefix: 'Upper Whisker'
        },
        {
            fieldPrefix: 'lower_whisker_',
            titlePrefix: 'Lower Whisker'
        }
    ], continuousAxisChannelDef, encodingWithoutContinuousAxis);
    const whiskerLayers = [
        ...makeBoxPlotExtent({
            partName: 'rule',
            mark: {
                type: 'rule',
                invalid,
                aria: false
            },
            positionPrefix: 'lower_whisker',
            endPositionPrefix: 'lower_box',
            extraEncoding: whiskerTooltipEncoding
        }),
        ...makeBoxPlotExtent({
            partName: 'rule',
            mark: {
                type: 'rule',
                invalid,
                aria: false
            },
            positionPrefix: 'upper_box',
            endPositionPrefix: 'upper_whisker',
            extraEncoding: whiskerTooltipEncoding
        }),
        ...makeBoxPlotExtent({
            partName: 'ticks',
            mark: endTick,
            positionPrefix: 'lower_whisker',
            extraEncoding: whiskerTooltipEncoding
        }),
        ...makeBoxPlotExtent({
            partName: 'ticks',
            mark: endTick,
            positionPrefix: 'upper_whisker',
            extraEncoding: whiskerTooltipEncoding
        })
    ];
    // ## Box Layers
    // TODO: support hiding certain mark parts
    const boxLayers = [
        ...boxPlotType !== 'tukey' ? whiskerLayers : [],
        ...makeBoxPlotBox({
            partName: 'box',
            mark: {
                type: 'bar',
                ...sizeValue ? {
                    size: sizeValue
                } : {},
                orient: boxOrient,
                invalid,
                ariaRoleDescription: 'box'
            },
            positionPrefix: 'lower_box',
            endPositionPrefix: 'upper_box',
            extraEncoding: fiveSummaryTooltipEncoding
        }),
        ...makeBoxPlotMidTick({
            partName: 'median',
            mark: {
                type: 'tick',
                invalid,
                ...(0, _vegaUtil.isObject)(config.boxplot.median) && config.boxplot.median.color ? {
                    color: config.boxplot.median.color
                } : {},
                ...sizeValue ? {
                    size: sizeValue
                } : {},
                orient: ticksOrient,
                aria: false
            },
            positionPrefix: 'mid_box',
            extraEncoding: fiveSummaryTooltipEncoding
        })
    ];
    if (boxPlotType === 'min-max') return {
        ...outerSpec,
        transform: (outerSpec.transform ?? []).concat(transform),
        layer: boxLayers
    };
    // Tukey Box Plot
    const lowerBoxExpr = accessWithDatumToUnescapedPath(`lower_box_${continuousAxisChannelDef.field}`);
    const upperBoxExpr = accessWithDatumToUnescapedPath(`upper_box_${continuousAxisChannelDef.field}`);
    const iqrExpr = `(${upperBoxExpr} - ${lowerBoxExpr})`;
    const lowerWhiskerExpr = `${lowerBoxExpr} - ${extent} * ${iqrExpr}`;
    const upperWhiskerExpr = `${upperBoxExpr} + ${extent} * ${iqrExpr}`;
    const fieldExpr = accessWithDatumToUnescapedPath(continuousAxisChannelDef.field);
    const joinaggregateTransform = {
        joinaggregate: boxParamsQuartiles(continuousAxisChannelDef.field),
        groupby
    };
    const filteredWhiskerSpec = {
        transform: [
            {
                filter: `(${lowerWhiskerExpr} <= ${fieldExpr}) && (${fieldExpr} <= ${upperWhiskerExpr})`
            },
            {
                aggregate: [
                    {
                        op: 'min',
                        field: continuousAxisChannelDef.field,
                        as: `lower_whisker_${aliasedFieldName}`
                    },
                    {
                        op: 'max',
                        field: continuousAxisChannelDef.field,
                        as: `upper_whisker_${aliasedFieldName}`
                    },
                    // preserve lower_box / upper_box
                    {
                        op: 'min',
                        field: `lower_box_${continuousAxisChannelDef.field}`,
                        as: `lower_box_${aliasedFieldName}`
                    },
                    {
                        op: 'max',
                        field: `upper_box_${continuousAxisChannelDef.field}`,
                        as: `upper_box_${aliasedFieldName}`
                    },
                    ...aggregate
                ],
                groupby
            }
        ],
        layer: whiskerLayers
    };
    const { tooltip, ...encodingWithoutSizeColorContinuousAxisAndTooltip } = encodingWithoutSizeColorAndContinuousAxis;
    const { scale, axis } = continuousAxisChannelDef;
    const title = getTitle(continuousAxisChannelDef);
    const outlierLayersMixins = partLayerMixins(markDef, 'outliers', config.boxplot, {
        transform: [
            {
                filter: `(${fieldExpr} < ${lowerWhiskerExpr}) || (${fieldExpr} > ${upperWhiskerExpr})`
            }
        ],
        mark: 'point',
        encoding: {
            [continuousAxis]: {
                field: continuousAxisChannelDef.field,
                type: continuousAxisChannelDef.type,
                ...title !== undefined ? {
                    title
                } : {},
                ...scale !== undefined ? {
                    scale
                } : {},
                ...axis !== undefined ? {
                    axis
                } : {}
            },
            ...encodingWithoutSizeColorContinuousAxisAndTooltip,
            ...color ? {
                color
            } : {},
            ...customTooltipWithoutAggregatedField ? {
                tooltip: customTooltipWithoutAggregatedField
            } : {}
        }
    })[0];
    let filteredLayersMixins;
    const filteredLayersMixinsTransforms = [
        ...bins,
        ...timeUnits,
        joinaggregateTransform
    ];
    if (outlierLayersMixins) filteredLayersMixins = {
        transform: filteredLayersMixinsTransforms,
        layer: [
            outlierLayersMixins,
            filteredWhiskerSpec
        ]
    };
    else {
        filteredLayersMixins = filteredWhiskerSpec;
        filteredLayersMixins.transform.unshift(...filteredLayersMixinsTransforms);
    }
    return {
        ...outerSpec,
        layer: [
            filteredLayersMixins,
            {
                // boxplot
                transform,
                layer: boxLayers
            }
        ]
    };
}
function boxParamsQuartiles(continousAxisField) {
    const aliasedFieldName = removePathFromField(continousAxisField);
    return [
        {
            op: 'q1',
            field: continousAxisField,
            as: `lower_box_${aliasedFieldName}`
        },
        {
            op: 'q3',
            field: continousAxisField,
            as: `upper_box_${aliasedFieldName}`
        }
    ];
}
function boxParams(spec, extent, config) {
    const orient = compositeMarkOrient(spec, BOXPLOT);
    const { continuousAxisChannelDef, continuousAxis } = compositeMarkContinuousAxis(spec, orient, BOXPLOT);
    const continuousFieldName = continuousAxisChannelDef.field;
    const aliasedFieldName = removePathFromField(continuousFieldName);
    const boxPlotType = getBoxPlotType(extent);
    const boxplotSpecificAggregate = [
        ...boxParamsQuartiles(continuousFieldName),
        {
            op: 'median',
            field: continuousFieldName,
            as: `mid_box_${aliasedFieldName}`
        },
        {
            op: 'min',
            field: continuousFieldName,
            as: (boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_') + aliasedFieldName
        },
        {
            op: 'max',
            field: continuousFieldName,
            as: (boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_') + aliasedFieldName
        }
    ];
    const postAggregateCalculates = boxPlotType === 'min-max' || boxPlotType === 'tukey' ? [] : [
        // This is for the  original k-IQR, which we do not expose
        {
            calculate: `${accessWithDatumToUnescapedPath(`upper_box_${aliasedFieldName}`)} - ${accessWithDatumToUnescapedPath(`lower_box_${aliasedFieldName}`)}`,
            as: `iqr_${aliasedFieldName}`
        },
        {
            calculate: `min(${accessWithDatumToUnescapedPath(`upper_box_${aliasedFieldName}`)} + ${accessWithDatumToUnescapedPath(`iqr_${aliasedFieldName}`)} * ${extent}, ${accessWithDatumToUnescapedPath(`max_${aliasedFieldName}`)})`,
            as: `upper_whisker_${aliasedFieldName}`
        },
        {
            calculate: `max(${accessWithDatumToUnescapedPath(`lower_box_${aliasedFieldName}`)} - ${accessWithDatumToUnescapedPath(`iqr_${aliasedFieldName}`)} * ${extent}, ${accessWithDatumToUnescapedPath(`min_${aliasedFieldName}`)})`,
            as: `lower_whisker_${aliasedFieldName}`
        }
    ];
    const { [continuousAxis]: oldContinuousAxisChannelDef, ...oldEncodingWithoutContinuousAxis } = spec.encoding;
    const { customTooltipWithoutAggregatedField, filteredEncoding } = filterTooltipWithAggregatedField(oldEncodingWithoutContinuousAxis);
    const { bins, timeUnits, aggregate, groupby, encoding: encodingWithoutContinuousAxis } = extractTransformsFromEncoding(filteredEncoding, config);
    const ticksOrient = orient === 'vertical' ? 'horizontal' : 'vertical';
    const boxOrient = orient;
    const transform = [
        ...bins,
        ...timeUnits,
        {
            aggregate: [
                ...aggregate,
                ...boxplotSpecificAggregate
            ],
            groupby
        },
        ...postAggregateCalculates
    ];
    return {
        bins,
        timeUnits,
        transform,
        groupby,
        aggregate,
        continuousAxisChannelDef,
        continuousAxis,
        encodingWithoutContinuousAxis,
        ticksOrient,
        boxOrient,
        customTooltipWithoutAggregatedField
    };
}
const ERRORBAR = 'errorbar';
const ERRORBAR_PARTS = [
    'ticks',
    'rule'
];
const errorBarNormalizer = new CompositeMarkNormalizer(ERRORBAR, normalizeErrorBar);
function normalizeErrorBar(spec, { config }) {
    // Need to initEncoding first so we can infer type
    spec = {
        ...spec,
        encoding: normalizeEncoding(spec.encoding, config)
    };
    const { transform, continuousAxisChannelDef, continuousAxis, encodingWithoutContinuousAxis, ticksOrient, markDef, outerSpec, tooltipEncoding } = errorBarParams(spec, ERRORBAR, config);
    delete encodingWithoutContinuousAxis.size;
    const makeErrorBarPart = makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorbar);
    const thickness = markDef.thickness;
    const size = markDef.size;
    const tick = {
        type: 'tick',
        orient: ticksOrient,
        aria: false,
        ...thickness !== undefined ? {
            thickness
        } : {},
        ...size !== undefined ? {
            size
        } : {}
    };
    const layer = [
        ...makeErrorBarPart({
            partName: 'ticks',
            mark: tick,
            positionPrefix: 'lower',
            extraEncoding: tooltipEncoding
        }),
        ...makeErrorBarPart({
            partName: 'ticks',
            mark: tick,
            positionPrefix: 'upper',
            extraEncoding: tooltipEncoding
        }),
        ...makeErrorBarPart({
            partName: 'rule',
            mark: {
                type: 'rule',
                ariaRoleDescription: 'errorbar',
                ...thickness !== undefined ? {
                    size: thickness
                } : {}
            },
            positionPrefix: 'lower',
            endPositionPrefix: 'upper',
            extraEncoding: tooltipEncoding
        })
    ];
    return {
        ...outerSpec,
        transform,
        ...layer.length > 1 ? {
            layer
        } : {
            ...layer[0]
        }
    };
}
function errorBarOrientAndInputType(spec, compositeMark) {
    const { encoding } = spec;
    if (errorBarIsInputTypeRaw(encoding)) return {
        orient: compositeMarkOrient(spec, compositeMark),
        inputType: 'raw'
    };
    const isTypeAggregatedUpperLower = errorBarIsInputTypeAggregatedUpperLower(encoding);
    const isTypeAggregatedError = errorBarIsInputTypeAggregatedError(encoding);
    const x = encoding.x;
    const y = encoding.y;
    if (isTypeAggregatedUpperLower) {
        // type is aggregated-upper-lower
        if (isTypeAggregatedError) throw new Error(`${compositeMark} cannot be both type aggregated-upper-lower and aggregated-error`);
        const x2 = encoding.x2;
        const y2 = encoding.y2;
        if (isFieldOrDatumDef(x2) && isFieldOrDatumDef(y2)) // having both x, x2 and y, y2
        throw new Error(`${compositeMark} cannot have both x2 and y2`);
        else if (isFieldOrDatumDef(x2)) {
            if (isContinuousFieldOrDatumDef(x)) // having x, x2 quantitative and field y, y2 are not specified
            return {
                orient: 'horizontal',
                inputType: 'aggregated-upper-lower'
            };
            else // having x, x2 that are not both quantitative
            throw new Error(`Both x and x2 have to be quantitative in ${compositeMark}`);
        } else if (isFieldOrDatumDef(y2)) {
            // y2 is a FieldDef
            if (isContinuousFieldOrDatumDef(y)) // having y, y2 quantitative and field x, x2 are not specified
            return {
                orient: 'vertical',
                inputType: 'aggregated-upper-lower'
            };
            else // having y, y2 that are not both quantitative
            throw new Error(`Both y and y2 have to be quantitative in ${compositeMark}`);
        }
        throw new Error('No ranged axis');
    } else {
        // type is aggregated-error
        const xError = encoding.xError;
        const xError2 = encoding.xError2;
        const yError = encoding.yError;
        const yError2 = encoding.yError2;
        if (isFieldOrDatumDef(xError2) && !isFieldOrDatumDef(xError)) // having xError2 without xError
        throw new Error(`${compositeMark} cannot have xError2 without xError`);
        if (isFieldOrDatumDef(yError2) && !isFieldOrDatumDef(yError)) // having yError2 without yError
        throw new Error(`${compositeMark} cannot have yError2 without yError`);
        if (isFieldOrDatumDef(xError) && isFieldOrDatumDef(yError)) // having both xError and yError
        throw new Error(`${compositeMark} cannot have both xError and yError with both are quantiative`);
        else if (isFieldOrDatumDef(xError)) {
            if (isContinuousFieldOrDatumDef(x)) // having x and xError that are all quantitative
            return {
                orient: 'horizontal',
                inputType: 'aggregated-error'
            };
            else // having x, xError, and xError2 that are not all quantitative
            throw new Error('All x, xError, and xError2 (if exist) have to be quantitative');
        } else if (isFieldOrDatumDef(yError)) {
            if (isContinuousFieldOrDatumDef(y)) // having y and yError that are all quantitative
            return {
                orient: 'vertical',
                inputType: 'aggregated-error'
            };
            else // having y, yError, and yError2 that are not all quantitative
            throw new Error('All y, yError, and yError2 (if exist) have to be quantitative');
        }
        throw new Error('No ranged axis');
    }
}
function errorBarIsInputTypeRaw(encoding) {
    return (isFieldOrDatumDef(encoding.x) || isFieldOrDatumDef(encoding.y)) && !isFieldOrDatumDef(encoding.x2) && !isFieldOrDatumDef(encoding.y2) && !isFieldOrDatumDef(encoding.xError) && !isFieldOrDatumDef(encoding.xError2) && !isFieldOrDatumDef(encoding.yError) && !isFieldOrDatumDef(encoding.yError2);
}
function errorBarIsInputTypeAggregatedUpperLower(encoding) {
    return isFieldOrDatumDef(encoding.x2) || isFieldOrDatumDef(encoding.y2);
}
function errorBarIsInputTypeAggregatedError(encoding) {
    return isFieldOrDatumDef(encoding.xError) || isFieldOrDatumDef(encoding.xError2) || isFieldOrDatumDef(encoding.yError) || isFieldOrDatumDef(encoding.yError2);
}
function errorBarParams(spec, compositeMark, config) {
    // TODO: use selection
    const { mark, encoding, params, projection: _p, ...outerSpec } = spec;
    const markDef = isMarkDef(mark) ? mark : {
        type: mark
    };
    // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support
    if (params) warn(selectionNotSupported(compositeMark));
    const { orient, inputType } = errorBarOrientAndInputType(spec, compositeMark);
    const { continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, continuousAxis } = compositeMarkContinuousAxis(spec, orient, compositeMark);
    const { errorBarSpecificAggregate, postAggregateCalculates, tooltipSummary, tooltipTitleWithFieldName } = errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config);
    const { [continuousAxis]: oldContinuousAxisChannelDef, [continuousAxis === 'x' ? 'x2' : 'y2']: oldContinuousAxisChannelDef2, [continuousAxis === 'x' ? 'xError' : 'yError']: oldContinuousAxisChannelDefError, [continuousAxis === 'x' ? 'xError2' : 'yError2']: oldContinuousAxisChannelDefError2, ...oldEncodingWithoutContinuousAxis } = encoding;
    const { bins, timeUnits, aggregate: oldAggregate, groupby: oldGroupBy, encoding: encodingWithoutContinuousAxis } = extractTransformsFromEncoding(oldEncodingWithoutContinuousAxis, config);
    const aggregate = [
        ...oldAggregate,
        ...errorBarSpecificAggregate
    ];
    const groupby = inputType !== 'raw' ? [] : oldGroupBy;
    const tooltipEncoding = getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, tooltipTitleWithFieldName);
    return {
        transform: [
            ...outerSpec.transform ?? [],
            ...bins,
            ...timeUnits,
            ...aggregate.length === 0 ? [] : [
                {
                    aggregate,
                    groupby
                }
            ],
            ...postAggregateCalculates
        ],
        groupby,
        continuousAxisChannelDef,
        continuousAxis,
        encodingWithoutContinuousAxis,
        ticksOrient: orient === 'vertical' ? 'horizontal' : 'vertical',
        markDef,
        outerSpec,
        tooltipEncoding
    };
}
function errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config) {
    let errorBarSpecificAggregate = [];
    let postAggregateCalculates = [];
    const continuousFieldName = continuousAxisChannelDef.field;
    let tooltipSummary;
    let tooltipTitleWithFieldName = false;
    if (inputType === 'raw') {
        const center = markDef.center ? markDef.center : markDef.extent ? markDef.extent === 'iqr' ? 'median' : 'mean' : config.errorbar.center;
        const extent = markDef.extent ? markDef.extent : center === 'mean' ? 'stderr' : 'iqr';
        if (center === 'median' !== (extent === 'iqr')) warn(errorBarCenterIsUsedWithWrongExtent(center, extent, compositeMark));
        if (extent === 'stderr' || extent === 'stdev') {
            errorBarSpecificAggregate = [
                {
                    op: extent,
                    field: continuousFieldName,
                    as: `extent_${continuousFieldName}`
                },
                {
                    op: center,
                    field: continuousFieldName,
                    as: `center_${continuousFieldName}`
                }
            ];
            postAggregateCalculates = [
                {
                    calculate: `${accessWithDatumToUnescapedPath(`center_${continuousFieldName}`)} + ${accessWithDatumToUnescapedPath(`extent_${continuousFieldName}`)}`,
                    as: `upper_${continuousFieldName}`
                },
                {
                    calculate: `${accessWithDatumToUnescapedPath(`center_${continuousFieldName}`)} - ${accessWithDatumToUnescapedPath(`extent_${continuousFieldName}`)}`,
                    as: `lower_${continuousFieldName}`
                }
            ];
            tooltipSummary = [
                {
                    fieldPrefix: 'center_',
                    titlePrefix: titleCase(center)
                },
                {
                    fieldPrefix: 'upper_',
                    titlePrefix: getTitlePrefix(center, extent, '+')
                },
                {
                    fieldPrefix: 'lower_',
                    titlePrefix: getTitlePrefix(center, extent, '-')
                }
            ];
            tooltipTitleWithFieldName = true;
        } else {
            let centerOp;
            let lowerExtentOp;
            let upperExtentOp;
            if (extent === 'ci') {
                centerOp = 'mean';
                lowerExtentOp = 'ci0';
                upperExtentOp = 'ci1';
            } else {
                centerOp = 'median';
                lowerExtentOp = 'q1';
                upperExtentOp = 'q3';
            }
            errorBarSpecificAggregate = [
                {
                    op: lowerExtentOp,
                    field: continuousFieldName,
                    as: `lower_${continuousFieldName}`
                },
                {
                    op: upperExtentOp,
                    field: continuousFieldName,
                    as: `upper_${continuousFieldName}`
                },
                {
                    op: centerOp,
                    field: continuousFieldName,
                    as: `center_${continuousFieldName}`
                }
            ];
            tooltipSummary = [
                {
                    fieldPrefix: 'upper_',
                    titlePrefix: title({
                        field: continuousFieldName,
                        aggregate: upperExtentOp,
                        type: 'quantitative'
                    }, config, {
                        allowDisabling: false
                    })
                },
                {
                    fieldPrefix: 'lower_',
                    titlePrefix: title({
                        field: continuousFieldName,
                        aggregate: lowerExtentOp,
                        type: 'quantitative'
                    }, config, {
                        allowDisabling: false
                    })
                },
                {
                    fieldPrefix: 'center_',
                    titlePrefix: title({
                        field: continuousFieldName,
                        aggregate: centerOp,
                        type: 'quantitative'
                    }, config, {
                        allowDisabling: false
                    })
                }
            ];
        }
    } else {
        if (markDef.center || markDef.extent) warn(errorBarCenterAndExtentAreNotNeeded(markDef.center, markDef.extent));
        if (inputType === 'aggregated-upper-lower') {
            tooltipSummary = [];
            postAggregateCalculates = [
                {
                    calculate: accessWithDatumToUnescapedPath(continuousAxisChannelDef2.field),
                    as: `upper_${continuousFieldName}`
                },
                {
                    calculate: accessWithDatumToUnescapedPath(continuousFieldName),
                    as: `lower_${continuousFieldName}`
                }
            ];
        } else if (inputType === 'aggregated-error') {
            tooltipSummary = [
                {
                    fieldPrefix: '',
                    titlePrefix: continuousFieldName
                }
            ];
            postAggregateCalculates = [
                {
                    calculate: `${accessWithDatumToUnescapedPath(continuousFieldName)} + ${accessWithDatumToUnescapedPath(continuousAxisChannelDefError.field)}`,
                    as: `upper_${continuousFieldName}`
                }
            ];
            if (continuousAxisChannelDefError2) postAggregateCalculates.push({
                calculate: `${accessWithDatumToUnescapedPath(continuousFieldName)} + ${accessWithDatumToUnescapedPath(continuousAxisChannelDefError2.field)}`,
                as: `lower_${continuousFieldName}`
            });
            else postAggregateCalculates.push({
                calculate: `${accessWithDatumToUnescapedPath(continuousFieldName)} - ${accessWithDatumToUnescapedPath(continuousAxisChannelDefError.field)}`,
                as: `lower_${continuousFieldName}`
            });
        }
        for (const postAggregateCalculate of postAggregateCalculates)tooltipSummary.push({
            fieldPrefix: postAggregateCalculate.as.substring(0, 6),
            titlePrefix: replaceAll(replaceAll(postAggregateCalculate.calculate, "datum['", ''), "']", '')
        });
    }
    return {
        postAggregateCalculates,
        errorBarSpecificAggregate,
        tooltipSummary,
        tooltipTitleWithFieldName
    };
}
function getTitlePrefix(center, extent, operation) {
    return `${titleCase(center)} ${operation} ${extent}`;
}
const ERRORBAND = 'errorband';
const ERRORBAND_PARTS = [
    'band',
    'borders'
];
const errorBandNormalizer = new CompositeMarkNormalizer(ERRORBAND, normalizeErrorBand);
function normalizeErrorBand(spec, { config }) {
    // Need to initEncoding first so we can infer type
    spec = {
        ...spec,
        encoding: normalizeEncoding(spec.encoding, config)
    };
    const { transform, continuousAxisChannelDef, continuousAxis, encodingWithoutContinuousAxis, markDef, outerSpec, tooltipEncoding } = errorBarParams(spec, ERRORBAND, config);
    const errorBandDef = markDef;
    const makeErrorBandPart = makeCompositeAggregatePartFactory(errorBandDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorband);
    const is2D = spec.encoding.x !== undefined && spec.encoding.y !== undefined;
    let bandMark = {
        type: is2D ? 'area' : 'rect'
    };
    let bordersMark = {
        type: is2D ? 'line' : 'rule'
    };
    const interpolate = {
        ...errorBandDef.interpolate ? {
            interpolate: errorBandDef.interpolate
        } : {},
        ...errorBandDef.tension && errorBandDef.interpolate ? {
            tension: errorBandDef.tension
        } : {}
    };
    if (is2D) {
        bandMark = {
            ...bandMark,
            ...interpolate,
            ariaRoleDescription: 'errorband'
        };
        bordersMark = {
            ...bordersMark,
            ...interpolate,
            aria: false
        };
    } else if (errorBandDef.interpolate) warn(errorBand1DNotSupport('interpolate'));
    else if (errorBandDef.tension) warn(errorBand1DNotSupport('tension'));
    return {
        ...outerSpec,
        transform,
        layer: [
            ...makeErrorBandPart({
                partName: 'band',
                mark: bandMark,
                positionPrefix: 'lower',
                endPositionPrefix: 'upper',
                extraEncoding: tooltipEncoding
            }),
            ...makeErrorBandPart({
                partName: 'borders',
                mark: bordersMark,
                positionPrefix: 'lower',
                extraEncoding: tooltipEncoding
            }),
            ...makeErrorBandPart({
                partName: 'borders',
                mark: bordersMark,
                positionPrefix: 'upper',
                extraEncoding: tooltipEncoding
            })
        ]
    };
}
/**
 * Registry index for all composite mark's normalizer
 */ const compositeMarkRegistry = {};
function add(mark, run, parts) {
    const normalizer = new CompositeMarkNormalizer(mark, run);
    compositeMarkRegistry[mark] = {
        normalizer,
        parts
    };
}
function getAllCompositeMarks() {
    return keys(compositeMarkRegistry);
}
add(BOXPLOT, normalizeBoxPlot, BOXPLOT_PARTS);
add(ERRORBAR, normalizeErrorBar, ERRORBAR_PARTS);
add(ERRORBAND, normalizeErrorBand, ERRORBAND_PARTS);
const VL_ONLY_LEGEND_CONFIG = [
    'gradientHorizontalMaxLength',
    'gradientHorizontalMinLength',
    'gradientVerticalMaxLength',
    'gradientVerticalMinLength',
    'unselectedOpacity'
];
const HEADER_TITLE_PROPERTIES_MAP = {
    titleAlign: 'align',
    titleAnchor: 'anchor',
    titleAngle: 'angle',
    titleBaseline: 'baseline',
    titleColor: 'color',
    titleFont: 'font',
    titleFontSize: 'fontSize',
    titleFontStyle: 'fontStyle',
    titleFontWeight: 'fontWeight',
    titleLimit: 'limit',
    titleLineHeight: 'lineHeight',
    titleOrient: 'orient',
    titlePadding: 'offset'
};
const HEADER_LABEL_PROPERTIES_MAP = {
    labelAlign: 'align',
    labelAnchor: 'anchor',
    labelAngle: 'angle',
    labelBaseline: 'baseline',
    labelColor: 'color',
    labelFont: 'font',
    labelFontSize: 'fontSize',
    labelFontStyle: 'fontStyle',
    labelFontWeight: 'fontWeight',
    labelLimit: 'limit',
    labelLineHeight: 'lineHeight',
    labelOrient: 'orient',
    labelPadding: 'offset'
};
const HEADER_TITLE_PROPERTIES = keys(HEADER_TITLE_PROPERTIES_MAP);
const HEADER_LABEL_PROPERTIES = keys(HEADER_LABEL_PROPERTIES_MAP);
const HEADER_CONFIGS_INDEX = {
    header: 1,
    headerRow: 1,
    headerColumn: 1,
    headerFacet: 1
};
const HEADER_CONFIGS = keys(HEADER_CONFIGS_INDEX);
const LEGEND_SCALE_CHANNELS = [
    'size',
    'shape',
    'fill',
    'stroke',
    'strokeDash',
    'strokeWidth',
    'opacity'
];
const defaultLegendConfig = {
    gradientHorizontalMaxLength: 200,
    gradientHorizontalMinLength: 100,
    gradientVerticalMaxLength: 200,
    gradientVerticalMinLength: 64,
    unselectedOpacity: 0.35
};
const COMMON_LEGEND_PROPERTY_INDEX = {
    aria: 1,
    clipHeight: 1,
    columnPadding: 1,
    columns: 1,
    cornerRadius: 1,
    description: 1,
    direction: 1,
    fillColor: 1,
    format: 1,
    formatType: 1,
    gradientLength: 1,
    gradientOpacity: 1,
    gradientStrokeColor: 1,
    gradientStrokeWidth: 1,
    gradientThickness: 1,
    gridAlign: 1,
    labelAlign: 1,
    labelBaseline: 1,
    labelColor: 1,
    labelFont: 1,
    labelFontSize: 1,
    labelFontStyle: 1,
    labelFontWeight: 1,
    labelLimit: 1,
    labelOffset: 1,
    labelOpacity: 1,
    labelOverlap: 1,
    labelPadding: 1,
    labelSeparation: 1,
    legendX: 1,
    legendY: 1,
    offset: 1,
    orient: 1,
    padding: 1,
    rowPadding: 1,
    strokeColor: 1,
    symbolDash: 1,
    symbolDashOffset: 1,
    symbolFillColor: 1,
    symbolLimit: 1,
    symbolOffset: 1,
    symbolOpacity: 1,
    symbolSize: 1,
    symbolStrokeColor: 1,
    symbolStrokeWidth: 1,
    symbolType: 1,
    tickCount: 1,
    tickMinStep: 1,
    title: 1,
    titleAlign: 1,
    titleAnchor: 1,
    titleBaseline: 1,
    titleColor: 1,
    titleFont: 1,
    titleFontSize: 1,
    titleFontStyle: 1,
    titleFontWeight: 1,
    titleLimit: 1,
    titleLineHeight: 1,
    titleOpacity: 1,
    titleOrient: 1,
    titlePadding: 1,
    type: 1,
    values: 1,
    zindex: 1
};
const SELECTION_ID = '_vgsid_';
const defaultConfig$1 = {
    point: {
        on: 'click',
        fields: [
            SELECTION_ID
        ],
        toggle: 'event.shiftKey',
        resolve: 'global',
        clear: 'dblclick'
    },
    interval: {
        on: '[pointerdown, window:pointerup] > window:pointermove!',
        encodings: [
            'x',
            'y'
        ],
        translate: '[pointerdown, window:pointerup] > window:pointermove!',
        zoom: 'wheel!',
        mark: {
            fill: '#333',
            fillOpacity: 0.125,
            stroke: 'white'
        },
        resolve: 'global',
        clear: 'dblclick'
    }
};
function isLegendBinding(bind) {
    return bind === 'legend' || !!bind?.legend;
}
function isLegendStreamBinding(bind) {
    return isLegendBinding(bind) && (0, _vegaUtil.isObject)(bind);
}
function isSelectionParameter(param) {
    return !!param?.['select'];
}
function assembleParameterSignals(params) {
    const signals = [];
    for (const param of params || []){
        // Selection parameters are handled separately via assembleSelectionTopLevelSignals
        // and assembleSignals methods registered on the Model.
        if (isSelectionParameter(param)) continue;
        const { expr, bind, ...rest } = param;
        if (bind && expr) {
            // Vega's InitSignal -- apply expr to "init"
            const signal = {
                ...rest,
                bind,
                init: expr
            };
            signals.push(signal);
        } else {
            const signal = {
                ...rest,
                ...expr ? {
                    update: expr
                } : {},
                ...bind ? {
                    bind
                } : {}
            };
            signals.push(signal);
        }
    }
    return signals;
}
function isAnyConcatSpec(spec) {
    return isVConcatSpec(spec) || isHConcatSpec(spec) || isConcatSpec(spec);
}
function isConcatSpec(spec) {
    return hasProperty(spec, 'concat');
}
function isVConcatSpec(spec) {
    return hasProperty(spec, 'vconcat');
}
function isHConcatSpec(spec) {
    return hasProperty(spec, 'hconcat');
}
function getStepFor({ step, offsetIsDiscrete }) {
    if (offsetIsDiscrete) return step.for ?? 'offset';
    else return 'position';
}
function isStep(size) {
    return hasProperty(size, 'step');
}
function isFrameMixins(o) {
    return hasProperty(o, 'view') || hasProperty(o, 'width') || hasProperty(o, 'height');
}
const DEFAULT_SPACING = 20;
const COMPOSITION_LAYOUT_INDEX = {
    align: 1,
    bounds: 1,
    center: 1,
    columns: 1,
    spacing: 1
};
const COMPOSITION_LAYOUT_PROPERTIES = keys(COMPOSITION_LAYOUT_INDEX);
function extractCompositionLayout(spec, specType, config) {
    const compositionConfig = config[specType];
    const layout = {};
    // Apply config first
    const { spacing: spacingConfig, columns } = compositionConfig;
    if (spacingConfig !== undefined) layout.spacing = spacingConfig;
    if (columns !== undefined) {
        if (isFacetSpec(spec) && !isFacetMapping(spec.facet) || isConcatSpec(spec)) layout.columns = columns;
    }
    if (isVConcatSpec(spec)) layout.columns = 1;
    // Then copy properties from the spec
    for (const prop of COMPOSITION_LAYOUT_PROPERTIES)if (spec[prop] !== undefined) {
        if (prop === 'spacing') {
            const spacing = spec[prop];
            layout[prop] = (0, _vegaUtil.isNumber)(spacing) ? spacing : {
                row: spacing.row ?? spacingConfig,
                column: spacing.column ?? spacingConfig
            };
        } else layout[prop] = spec[prop];
    }
    return layout;
}
function getViewConfigContinuousSize(viewConfig, channel) {
    return viewConfig[channel] ?? viewConfig[channel === 'width' ? 'continuousWidth' : 'continuousHeight']; // get width/height for backwards compatibility
}
function getViewConfigDiscreteStep(viewConfig, channel) {
    const size = getViewConfigDiscreteSize(viewConfig, channel);
    return isStep(size) ? size.step : DEFAULT_STEP;
}
function getViewConfigDiscreteSize(viewConfig, channel) {
    const size = viewConfig[channel] ?? viewConfig[channel === 'width' ? 'discreteWidth' : 'discreteHeight']; // get width/height for backwards compatibility
    return getFirstDefined(size, {
        step: viewConfig.step
    });
}
const DEFAULT_STEP = 20;
const defaultViewConfig = {
    continuousWidth: 300,
    continuousHeight: 300,
    step: DEFAULT_STEP
};
const defaultConfig = {
    background: 'white',
    padding: 5,
    timeFormat: '%b %d, %Y',
    countTitle: 'Count of Records',
    view: defaultViewConfig,
    mark: defaultMarkConfig,
    arc: {},
    area: {},
    bar: defaultBarConfig,
    circle: {},
    geoshape: {},
    image: {},
    line: {},
    point: {},
    rect: defaultRectConfig,
    rule: {
        color: 'black'
    },
    square: {},
    text: {
        color: 'black'
    },
    tick: defaultTickConfig,
    trail: {},
    boxplot: {
        size: 14,
        extent: 1.5,
        box: {},
        median: {
            color: 'white'
        },
        outliers: {},
        rule: {},
        ticks: null
    },
    errorbar: {
        center: 'mean',
        rule: true,
        ticks: false
    },
    errorband: {
        band: {
            opacity: 0.3
        },
        borders: false
    },
    scale: defaultScaleConfig,
    projection: {},
    legend: defaultLegendConfig,
    header: {
        titlePadding: 10,
        labelPadding: 10
    },
    headerColumn: {},
    headerRow: {},
    headerFacet: {},
    selection: defaultConfig$1,
    style: {},
    title: {},
    facet: {
        spacing: DEFAULT_SPACING
    },
    concat: {
        spacing: DEFAULT_SPACING
    },
    normalizedNumberFormat: '.0%'
};
// Tableau10 color palette, copied from `vegaScale.scheme('tableau10')`
const tab10 = [
    '#4c78a8',
    '#f58518',
    '#e45756',
    '#72b7b2',
    '#54a24b',
    '#eeca3b',
    '#b279a2',
    '#ff9da6',
    '#9d755d',
    '#bab0ac'
];
const DEFAULT_FONT_SIZE = {
    text: 11,
    guideLabel: 10,
    guideTitle: 11,
    groupTitle: 13,
    groupSubtitle: 12
};
const DEFAULT_COLOR = {
    blue: tab10[0],
    orange: tab10[1],
    red: tab10[2],
    teal: tab10[3],
    green: tab10[4],
    yellow: tab10[5],
    purple: tab10[6],
    pink: tab10[7],
    brown: tab10[8],
    gray0: '#000',
    gray1: '#111',
    gray2: '#222',
    gray3: '#333',
    gray4: '#444',
    gray5: '#555',
    gray6: '#666',
    gray7: '#777',
    gray8: '#888',
    gray9: '#999',
    gray10: '#aaa',
    gray11: '#bbb',
    gray12: '#ccc',
    gray13: '#ddd',
    gray14: '#eee',
    gray15: '#fff'
};
function colorSignalConfig(color = {}) {
    return {
        signals: [
            {
                name: 'color',
                value: (0, _vegaUtil.isObject)(color) ? {
                    ...DEFAULT_COLOR,
                    ...color
                } : DEFAULT_COLOR
            }
        ],
        mark: {
            color: {
                signal: 'color.blue'
            }
        },
        rule: {
            color: {
                signal: 'color.gray0'
            }
        },
        text: {
            color: {
                signal: 'color.gray0'
            }
        },
        style: {
            'guide-label': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            'guide-title': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            'group-title': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            'group-subtitle': {
                fill: {
                    signal: 'color.gray0'
                }
            },
            cell: {
                stroke: {
                    signal: 'color.gray8'
                }
            }
        },
        axis: {
            domainColor: {
                signal: 'color.gray13'
            },
            gridColor: {
                signal: 'color.gray8'
            },
            tickColor: {
                signal: 'color.gray13'
            }
        },
        range: {
            category: [
                {
                    signal: 'color.blue'
                },
                {
                    signal: 'color.orange'
                },
                {
                    signal: 'color.red'
                },
                {
                    signal: 'color.teal'
                },
                {
                    signal: 'color.green'
                },
                {
                    signal: 'color.yellow'
                },
                {
                    signal: 'color.purple'
                },
                {
                    signal: 'color.pink'
                },
                {
                    signal: 'color.brown'
                },
                {
                    signal: 'color.grey8'
                }
            ]
        }
    };
}
function fontSizeSignalConfig(fontSize) {
    return {
        signals: [
            {
                name: 'fontSize',
                value: (0, _vegaUtil.isObject)(fontSize) ? {
                    ...DEFAULT_FONT_SIZE,
                    ...fontSize
                } : DEFAULT_FONT_SIZE
            }
        ],
        text: {
            fontSize: {
                signal: 'fontSize.text'
            }
        },
        style: {
            'guide-label': {
                fontSize: {
                    signal: 'fontSize.guideLabel'
                }
            },
            'guide-title': {
                fontSize: {
                    signal: 'fontSize.guideTitle'
                }
            },
            'group-title': {
                fontSize: {
                    signal: 'fontSize.groupTitle'
                }
            },
            'group-subtitle': {
                fontSize: {
                    signal: 'fontSize.groupSubtitle'
                }
            }
        }
    };
}
function fontConfig(font) {
    return {
        text: {
            font
        },
        style: {
            'guide-label': {
                font
            },
            'guide-title': {
                font
            },
            'group-title': {
                font
            },
            'group-subtitle': {
                font
            }
        }
    };
}
function getAxisConfigInternal(axisConfig) {
    const props = keys(axisConfig || {});
    const axisConfigInternal = {};
    for (const prop of props){
        const val = axisConfig[prop];
        axisConfigInternal[prop] = isConditionalAxisValue(val) ? signalOrValueRefWithCondition(val) : signalRefOrValue(val);
    }
    return axisConfigInternal;
}
function getStyleConfigInternal(styleConfig) {
    const props = keys(styleConfig);
    const styleConfigInternal = {};
    for (const prop of props)// We need to cast to cheat a bit here since styleConfig can be either mark config or axis config
    styleConfigInternal[prop] = getAxisConfigInternal(styleConfig[prop]);
    return styleConfigInternal;
}
const configPropsWithExpr = [
    ...MARK_CONFIGS,
    ...AXIS_CONFIGS,
    ...HEADER_CONFIGS,
    'background',
    'padding',
    'legend',
    'lineBreak',
    'scale',
    'style',
    'title',
    'view'
];
/**
 * Merge specified config with default config and config for the `color` flag,
 * then replace all expressions with signals
 */ function initConfig(specifiedConfig = {}) {
    const { color, font, fontSize, selection, ...restConfig } = specifiedConfig;
    const mergedConfig = (0, _vegaUtil.mergeConfig)({}, duplicate(defaultConfig), font ? fontConfig(font) : {}, color ? colorSignalConfig(color) : {}, fontSize ? fontSizeSignalConfig(fontSize) : {}, restConfig || {});
    // mergeConfig doesn't recurse and overrides object values.
    if (selection) (0, _vegaUtil.writeConfig)(mergedConfig, 'selection', selection, true);
    const outputConfig = omit(mergedConfig, configPropsWithExpr);
    for (const prop of [
        'background',
        'lineBreak',
        'padding'
    ])if (mergedConfig[prop]) outputConfig[prop] = signalRefOrValue(mergedConfig[prop]);
    for (const markConfigType of MARK_CONFIGS)if (mergedConfig[markConfigType]) // FIXME: outputConfig[markConfigType] expects that types are replaced recursively but replaceExprRef only replaces one level deep
    outputConfig[markConfigType] = replaceExprRef(mergedConfig[markConfigType]);
    for (const axisConfigType of AXIS_CONFIGS)if (mergedConfig[axisConfigType]) outputConfig[axisConfigType] = getAxisConfigInternal(mergedConfig[axisConfigType]);
    for (const headerConfigType of HEADER_CONFIGS)if (mergedConfig[headerConfigType]) outputConfig[headerConfigType] = replaceExprRef(mergedConfig[headerConfigType]);
    if (mergedConfig.legend) outputConfig.legend = replaceExprRef(mergedConfig.legend);
    if (mergedConfig.scale) {
        const { invalid, ...otherScaleConfig } = mergedConfig.scale;
        const newScaleInvalid = replaceExprRef(invalid, {
            level: 1
        });
        outputConfig.scale = {
            ...replaceExprRef(otherScaleConfig),
            ...keys(newScaleInvalid).length > 0 ? {
                invalid: newScaleInvalid
            } : {}
        };
    }
    if (mergedConfig.style) outputConfig.style = getStyleConfigInternal(mergedConfig.style);
    if (mergedConfig.title) outputConfig.title = replaceExprRef(mergedConfig.title);
    if (mergedConfig.view) outputConfig.view = replaceExprRef(mergedConfig.view);
    return outputConfig;
}
const MARK_STYLES = new Set([
    'view',
    ...PRIMITIVE_MARKS
]);
const VL_ONLY_CONFIG_PROPERTIES = [
    'color',
    'fontSize',
    'background',
    'padding',
    'facet',
    'concat',
    'numberFormat',
    'numberFormatType',
    'normalizedNumberFormat',
    'normalizedNumberFormatType',
    'timeFormat',
    'countTitle',
    'header',
    'axisQuantitative',
    'axisTemporal',
    'axisDiscrete',
    'axisPoint',
    'axisXBand',
    'axisXPoint',
    'axisXDiscrete',
    'axisXQuantitative',
    'axisXTemporal',
    'axisYBand',
    'axisYPoint',
    'axisYDiscrete',
    'axisYQuantitative',
    'axisYTemporal',
    'scale',
    'selection',
    'overlay'
];
const VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX = {
    view: [
        'continuousWidth',
        'continuousHeight',
        'discreteWidth',
        'discreteHeight',
        'step'
    ],
    ...VL_ONLY_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX
};
function stripAndRedirectConfig(config) {
    config = duplicate(config);
    for (const prop of VL_ONLY_CONFIG_PROPERTIES)delete config[prop];
    if (config.axis) {
        // delete condition axis config
        for(const prop in config.axis)if (isConditionalAxisValue(config.axis[prop])) delete config.axis[prop];
    }
    if (config.legend) for (const prop of VL_ONLY_LEGEND_CONFIG)delete config.legend[prop];
    // Remove Vega-Lite only generic mark config
    if (config.mark) {
        for (const prop of VL_ONLY_MARK_CONFIG_PROPERTIES)delete config.mark[prop];
        if (config.mark.tooltip && (0, _vegaUtil.isObject)(config.mark.tooltip)) delete config.mark.tooltip;
    }
    if (config.params) {
        config.signals = (config.signals || []).concat(assembleParameterSignals(config.params));
        delete config.params;
    }
    for (const markType of MARK_STYLES){
        // Remove Vega-Lite-only mark config
        for (const prop of VL_ONLY_MARK_CONFIG_PROPERTIES)delete config[markType][prop];
        // Remove Vega-Lite only mark-specific config
        const vlOnlyMarkSpecificConfigs = VL_ONLY_ALL_MARK_SPECIFIC_CONFIG_PROPERTY_INDEX[markType];
        if (vlOnlyMarkSpecificConfigs) for (const prop of vlOnlyMarkSpecificConfigs)delete config[markType][prop];
        // Redirect mark config to config.style so that mark config only affect its own mark type
        // without affecting other marks that share the same underlying Vega marks.
        // For example, config.rect should not affect bar marks.
        redirectConfigToStyleConfig(config, markType);
    }
    for (const m of getAllCompositeMarks())// Clean up the composite mark config as we don't need them in the output specs anymore
    delete config[m];
    redirectTitleConfig(config);
    // Remove empty config objects.
    for(const prop in config)// @ts-expect-error(TS7053)
    if ((0, _vegaUtil.isObject)(config[prop]) && isEmpty(config[prop])) // @ts-expect-error(TS7053)
    delete config[prop];
    return isEmpty(config) ? undefined : config;
}
/**
 *
 * Redirect config.title -- so that title config do not affect header labels,
 * which also uses `title` directive to implement.
 *
 * For subtitle configs in config.title, keep them in config.title as header titles never have subtitles.
 */ function redirectTitleConfig(config) {
    const { titleMarkConfig, subtitleMarkConfig, subtitle } = extractTitleConfig(config.title);
    // set config.style if title/subtitleMarkConfig is not an empty object
    if (!isEmpty(titleMarkConfig)) config.style['group-title'] = {
        ...config.style['group-title'],
        ...titleMarkConfig
    };
    if (!isEmpty(subtitleMarkConfig)) config.style['group-subtitle'] = {
        ...config.style['group-subtitle'],
        ...subtitleMarkConfig
    };
    // subtitle part can stay in config.title since header titles do not use subtitle
    if (!isEmpty(subtitle)) config.title = subtitle;
    else delete config.title;
}
function redirectConfigToStyleConfig(config, prop, toProp, compositeMarkPart) {
    const propConfig = config[prop];
    if (prop === 'view') toProp = 'cell'; // View's default style is "cell"
    const style = {
        ...propConfig,
        ...config.style[toProp ?? prop]
    };
    // set config.style if it is not an empty object
    if (!isEmpty(style)) config.style[toProp ?? prop] = style;
    // For composite mark, so don't delete the whole config yet as we have to do multiple redirections.
    delete config[prop];
}
function isLayerSpec(spec) {
    return hasProperty(spec, 'layer');
}
function isRepeatSpec(spec) {
    return hasProperty(spec, 'repeat');
}
function isLayerRepeatSpec(spec) {
    return !(0, _vegaUtil.isArray)(spec.repeat) && hasProperty(spec.repeat, 'layer');
}
class SpecMapper {
    map(spec, params) {
        if (isFacetSpec(spec)) return this.mapFacet(spec, params);
        else if (isRepeatSpec(spec)) return this.mapRepeat(spec, params);
        else if (isHConcatSpec(spec)) return this.mapHConcat(spec, params);
        else if (isVConcatSpec(spec)) return this.mapVConcat(spec, params);
        else if (isConcatSpec(spec)) return this.mapConcat(spec, params);
        else return this.mapLayerOrUnit(spec, params);
    }
    mapLayerOrUnit(spec, params) {
        if (isLayerSpec(spec)) return this.mapLayer(spec, params);
        else if (isUnitSpec(spec)) return this.mapUnit(spec, params);
        throw new Error(invalidSpec(spec));
    }
    mapLayer(spec, params) {
        return {
            ...spec,
            layer: spec.layer.map((subspec)=>this.mapLayerOrUnit(subspec, params))
        };
    }
    mapHConcat(spec, params) {
        return {
            ...spec,
            hconcat: spec.hconcat.map((subspec)=>this.map(subspec, params))
        };
    }
    mapVConcat(spec, params) {
        return {
            ...spec,
            vconcat: spec.vconcat.map((subspec)=>this.map(subspec, params))
        };
    }
    mapConcat(spec, params) {
        const { concat, ...rest } = spec;
        return {
            ...rest,
            concat: concat.map((subspec)=>this.map(subspec, params))
        };
    }
    mapFacet(spec, params) {
        return {
            // as any is required here since TS cannot infer that FO may only be FieldName or Field, but not RepeatRef
            ...spec,
            // TODO: remove "any" once we support all facet listed in https://github.com/vega/vega-lite/issues/2760
            spec: this.map(spec.spec, params)
        };
    }
    mapRepeat(spec, params) {
        return {
            ...spec,
            // as any is required here since TS cannot infer that the output type satisfies the input type
            spec: this.map(spec.spec, params)
        };
    }
}
const STACK_OFFSET_INDEX = {
    zero: 1,
    center: 1,
    normalize: 1
};
function isStackOffset(s) {
    return (0, _vegaUtil.hasOwnProperty)(STACK_OFFSET_INDEX, s);
}
const STACKABLE_MARKS = new Set([
    ARC,
    BAR,
    AREA,
    RULE,
    POINT,
    CIRCLE,
    SQUARE,
    LINE,
    TEXT,
    TICK
]);
const STACK_BY_DEFAULT_MARKS = new Set([
    BAR,
    AREA,
    ARC
]);
function isUnbinnedQuantitative(channelDef) {
    return isFieldDef(channelDef) && channelDefType(channelDef) === 'quantitative' && !channelDef.bin;
}
function potentialStackedChannel(encoding, x, { orient, type: mark }) {
    const y = x === 'x' ? 'y' : 'radius';
    const isCartesianBarOrArea = x === 'x' && [
        'bar',
        'area'
    ].includes(mark);
    const xDef = encoding[x];
    const yDef = encoding[y];
    if (isFieldDef(xDef) && isFieldDef(yDef)) {
        if (isUnbinnedQuantitative(xDef) && isUnbinnedQuantitative(yDef)) {
            if (xDef.stack) return x;
            else if (yDef.stack) return y;
            const xAggregate = isFieldDef(xDef) && !!xDef.aggregate;
            const yAggregate = isFieldDef(yDef) && !!yDef.aggregate;
            // if there is no explicit stacking, only apply stack if there is only one aggregate for x or y
            if (xAggregate !== yAggregate) return xAggregate ? x : y;
            if (isCartesianBarOrArea) {
                if (orient === 'vertical') return y;
                else if (orient === 'horizontal') return x;
            }
        } else if (isUnbinnedQuantitative(xDef)) return x;
        else if (isUnbinnedQuantitative(yDef)) return y;
    } else if (isUnbinnedQuantitative(xDef)) {
        if (isCartesianBarOrArea && orient === 'vertical') return undefined;
        return x;
    } else if (isUnbinnedQuantitative(yDef)) {
        if (isCartesianBarOrArea && orient === 'horizontal') return undefined;
        return y;
    }
    return undefined;
}
function getDimensionChannel(channel) {
    switch(channel){
        case 'x':
            return 'y';
        case 'y':
            return 'x';
        case 'theta':
            return 'radius';
        case 'radius':
            return 'theta';
    }
}
function stack(m, encoding) {
    const markDef = isMarkDef(m) ? m : {
        type: m
    };
    const mark = markDef.type;
    // Should have stackable mark
    if (!STACKABLE_MARKS.has(mark)) return null;
    // Run potential stacked twice, one for Cartesian and another for Polar,
    // so text marks can be stacked in any of the coordinates.
    // Note: The logic here is not perfectly correct.  If we want to support stacked dot plots where each dot is a pie chart with label, we have to change the stack logic here to separate Cartesian stacking for polar stacking.
    // However, since we probably never want to do that, let's just note the limitation here.
    const fieldChannel = potentialStackedChannel(encoding, 'x', markDef) || potentialStackedChannel(encoding, 'theta', markDef);
    if (!fieldChannel) return null;
    const stackedFieldDef = encoding[fieldChannel];
    const stackedField = isFieldDef(stackedFieldDef) ? vgField(stackedFieldDef, {}) : undefined;
    const dimensionChannel = getDimensionChannel(fieldChannel);
    const groupbyChannels = [];
    const groupbyFields = new Set();
    if (encoding[dimensionChannel]) {
        const dimensionDef = encoding[dimensionChannel];
        const dimensionField = isFieldDef(dimensionDef) ? vgField(dimensionDef, {}) : undefined;
        if (dimensionField && dimensionField !== stackedField) {
            // avoid grouping by the stacked field
            groupbyChannels.push(dimensionChannel);
            groupbyFields.add(dimensionField);
        }
    }
    const dimensionOffsetChannel = dimensionChannel === 'x' ? 'xOffset' : 'yOffset';
    const dimensionOffsetDef = encoding[dimensionOffsetChannel];
    const dimensionOffsetField = isFieldDef(dimensionOffsetDef) ? vgField(dimensionOffsetDef, {}) : undefined;
    if (dimensionOffsetField && dimensionOffsetField !== stackedField) {
        // avoid grouping by the stacked field
        groupbyChannels.push(dimensionOffsetChannel);
        groupbyFields.add(dimensionOffsetField);
    }
    // If the dimension has offset, don't stack anymore
    // Should have grouping level of detail that is different from the dimension field
    const stackBy = NONPOSITION_CHANNELS.reduce((sc, channel)=>{
        // Ignore tooltip in stackBy (https://github.com/vega/vega-lite/issues/4001)
        if (channel !== 'tooltip' && channelHasField(encoding, channel)) {
            const channelDef = encoding[channel];
            for (const cDef of (0, _vegaUtil.array)(channelDef)){
                const fieldDef = getFieldDef(cDef);
                if (fieldDef.aggregate) continue;
                // Check whether the channel's field is identical to x/y's field or if the channel is a repeat
                const f = vgField(fieldDef, {});
                if (// if fielddef is a repeat, just include it in the stack by
                !f || // otherwise, the field must be different from the groupBy fields.
                !groupbyFields.has(f)) sc.push({
                    channel,
                    fieldDef
                });
            }
        }
        return sc;
    }, []);
    // Automatically determine offset
    let offset;
    if (stackedFieldDef.stack !== undefined) {
        if ((0, _vegaUtil.isBoolean)(stackedFieldDef.stack)) offset = stackedFieldDef.stack ? 'zero' : null;
        else offset = stackedFieldDef.stack;
    } else if (STACK_BY_DEFAULT_MARKS.has(mark)) offset = 'zero';
    if (!offset || !isStackOffset(offset)) return null;
    if (isAggregate$1(encoding) && stackBy.length === 0) return null;
    // warn when stacking non-linear
    if (stackedFieldDef?.scale?.type && stackedFieldDef?.scale?.type !== ScaleType.LINEAR) {
        if (stackedFieldDef?.stack) warn(stackNonLinearScale(stackedFieldDef.scale.type));
    }
    // Check if it is a ranged mark
    if (isFieldOrDatumDef(encoding[getSecondaryRangeChannel(fieldChannel)])) {
        if (stackedFieldDef.stack !== undefined) warn(cannotStackRangedMark(fieldChannel));
        return null;
    }
    // Warn if stacking non-summative aggregate
    if (isFieldDef(stackedFieldDef) && stackedFieldDef.aggregate && !SUM_OPS.has(stackedFieldDef.aggregate)) warn(stackNonSummativeAggregate(stackedFieldDef.aggregate));
    return {
        groupbyChannels,
        groupbyFields,
        fieldChannel,
        impute: stackedFieldDef.impute === null ? false : isPathMark(mark),
        stackBy,
        offset
    };
}
function initMarkdef(originalMarkDef, encoding, config) {
    // FIXME: markDef expects that exprRefs are replaced recursively but replaceExprRef only replaces the top level
    const markDef = replaceExprRef(originalMarkDef);
    // set orient, which can be overridden by rules as sometimes the specified orient is invalid.
    const specifiedOrient = getMarkPropOrConfig('orient', markDef, config);
    markDef.orient = orient(markDef.type, encoding, specifiedOrient);
    if (specifiedOrient !== undefined && specifiedOrient !== markDef.orient) warn(orientOverridden(markDef.orient, specifiedOrient));
    if (markDef.type === 'bar' && markDef.orient) {
        const cornerRadiusEnd = getMarkPropOrConfig('cornerRadiusEnd', markDef, config);
        if (cornerRadiusEnd !== undefined) {
            const newProps = markDef.orient === 'horizontal' && encoding.x2 || markDef.orient === 'vertical' && encoding.y2 ? [
                'cornerRadius'
            ] : BAR_CORNER_RADIUS_INDEX[markDef.orient];
            for (const newProp of newProps)markDef[newProp] = cornerRadiusEnd;
            if (markDef.cornerRadiusEnd !== undefined) delete markDef.cornerRadiusEnd; // no need to keep the original cap cornerRadius
        }
    }
    // set opacity and filled if not specified in mark config
    const specifiedOpacity = getMarkPropOrConfig('opacity', markDef, config);
    const specifiedfillOpacity = getMarkPropOrConfig('fillOpacity', markDef, config);
    if (specifiedOpacity === undefined && specifiedfillOpacity === undefined) markDef.opacity = opacity(markDef.type, encoding);
    // set cursor, which should be pointer if href channel is present unless otherwise specified
    const specifiedCursor = getMarkPropOrConfig('cursor', markDef, config);
    if (specifiedCursor === undefined) markDef.cursor = cursor(markDef, encoding, config);
    return markDef;
}
function cursor(markDef, encoding, config) {
    if (encoding.href || markDef.href || getMarkPropOrConfig('href', markDef, config)) return 'pointer';
    return markDef.cursor;
}
function opacity(mark, encoding) {
    if (contains([
        POINT,
        TICK,
        CIRCLE,
        SQUARE
    ], mark)) {
        // point-based marks
        if (!isAggregate$1(encoding)) return 0.7;
    }
    return undefined;
}
function defaultFilled(markDef, config, { graticule }) {
    if (graticule) return false;
    const filledConfig = getMarkConfig('filled', markDef, config);
    const mark = markDef.type;
    return getFirstDefined(filledConfig, mark !== POINT && mark !== LINE && mark !== RULE);
}
function orient(mark, encoding, specifiedOrient) {
    switch(mark){
        case POINT:
        case CIRCLE:
        case SQUARE:
        case TEXT:
        case RECT:
        case IMAGE:
            // orient is meaningless for these marks.
            return undefined;
    }
    const { x, y, x2, y2 } = encoding;
    switch(mark){
        case BAR:
            if (isFieldDef(x) && (isBinned(x.bin) || isFieldDef(y) && y.aggregate && !x.aggregate)) return 'vertical';
            if (isFieldDef(y) && (isBinned(y.bin) || isFieldDef(x) && x.aggregate && !y.aggregate)) return 'horizontal';
            if (y2 || x2) {
                // Ranged bar does not always have clear orientation, so we allow overriding
                if (specifiedOrient) return specifiedOrient;
                // If y is range and x is non-range, non-bin Q
                if (!x2) {
                    if (isFieldDef(x) && x.type === QUANTITATIVE && !isBinning(x.bin) || isNumericDataDef(x)) {
                        if (isFieldDef(y) && isBinned(y.bin)) return 'horizontal';
                    }
                    return 'vertical';
                }
                // If x is range and y is non-range, non-bin Q
                if (!y2) {
                    if (isFieldDef(y) && y.type === QUANTITATIVE && !isBinning(y.bin) || isNumericDataDef(y)) {
                        if (isFieldDef(x) && isBinned(x.bin)) return 'vertical';
                    }
                    return 'horizontal';
                }
            }
        // falls through
        case RULE:
            // return undefined for line segment rule and bar with both axis ranged
            // we have to ignore the case that the data are already binned
            if (x2 && !(isFieldDef(x) && isBinned(x.bin)) && y2 && !(isFieldDef(y) && isBinned(y.bin))) return undefined;
        // falls through
        case AREA:
            // If there are range for both x and y, y (vertical) has higher precedence.
            if (y2) {
                if (isFieldDef(y) && isBinned(y.bin)) return 'horizontal';
                else return 'vertical';
            } else if (x2) {
                if (isFieldDef(x) && isBinned(x.bin)) return 'vertical';
                else return 'horizontal';
            } else if (mark === RULE) {
                if (x && !y) return 'vertical';
                else if (y && !x) return 'horizontal';
            }
        // falls through
        case LINE:
        case TICK:
            {
                const xIsMeasure = isUnbinnedQuantitativeFieldOrDatumDef(x);
                const yIsMeasure = isUnbinnedQuantitativeFieldOrDatumDef(y);
                if (specifiedOrient) return specifiedOrient;
                else if (xIsMeasure && !yIsMeasure) // Tick is opposite to bar, line, area
                return mark !== 'tick' ? 'horizontal' : 'vertical';
                else if (!xIsMeasure && yIsMeasure) // Tick is opposite to bar, line, area
                return mark !== 'tick' ? 'vertical' : 'horizontal';
                else if (xIsMeasure && yIsMeasure) return 'vertical';
                else {
                    const xIsTemporal = isTypedFieldDef(x) && x.type === TEMPORAL;
                    const yIsTemporal = isTypedFieldDef(y) && y.type === TEMPORAL;
                    // x: T, y: N --> vertical tick
                    if (xIsTemporal && !yIsTemporal) return 'vertical';
                    else if (!xIsTemporal && yIsTemporal) return 'horizontal';
                }
                return undefined;
            }
    }
    return 'vertical';
}
function dropLineAndPoint(markDef) {
    const { point: _point, line: _line, ...mark } = markDef;
    return keys(mark).length > 1 ? mark : mark.type;
}
function dropLineAndPointFromConfig(config) {
    for (const mark of [
        'line',
        'area',
        'rule',
        'trail'
    ])if (config[mark]) config = {
        ...config,
        // TODO: remove as any
        [mark]: omit(config[mark], [
            'point',
            'line'
        ])
    };
    return config;
}
function getPointOverlay(markDef, markConfig = {}, encoding) {
    if (markDef.point === 'transparent') return {
        opacity: 0
    };
    else if (markDef.point) // truthy : true or object
    return (0, _vegaUtil.isObject)(markDef.point) ? markDef.point : {};
    else if (markDef.point !== undefined) // false or null
    return null;
    else {
        // undefined (not disabled)
        if (markConfig.point || encoding.shape) // enable point overlay if config[mark].point is truthy or if encoding.shape is provided
        return (0, _vegaUtil.isObject)(markConfig.point) ? markConfig.point : {};
        // markDef.point is defined as falsy
        return undefined;
    }
}
function getLineOverlay(markDef, markConfig = {}) {
    if (markDef.line) // true or object
    return markDef.line === true ? {} : markDef.line;
    else if (markDef.line !== undefined) // false or null
    return null;
    else {
        // undefined (not disabled)
        if (markConfig.line) // enable line overlay if config[mark].line is truthy
        return markConfig.line === true ? {} : markConfig.line;
        // markDef.point is defined as falsy
        return undefined;
    }
}
class PathOverlayNormalizer {
    name = 'path-overlay';
    hasMatchingType(spec, config) {
        if (isUnitSpec(spec)) {
            const { mark, encoding } = spec;
            const markDef = isMarkDef(mark) ? mark : {
                type: mark
            };
            switch(markDef.type){
                case 'line':
                case 'rule':
                case 'trail':
                    return !!getPointOverlay(markDef, config[markDef.type], encoding);
                case 'area':
                    return(// false / null are also included as we want to remove the properties
                    !!getPointOverlay(markDef, config[markDef.type], encoding) || !!getLineOverlay(markDef, config[markDef.type]));
            }
        }
        return false;
    }
    run(spec, normParams, normalize) {
        const { config } = normParams;
        const { params, projection, mark, name, encoding: e, ...outerSpec } = spec;
        // Need to call normalizeEncoding because we need the inferred types to correctly determine stack
        const encoding = normalizeEncoding(e, config);
        const markDef = isMarkDef(mark) ? mark : {
            type: mark
        };
        const pointOverlay = getPointOverlay(markDef, config[markDef.type], encoding);
        const lineOverlay = markDef.type === 'area' && getLineOverlay(markDef, config[markDef.type]);
        const layer = [
            {
                name,
                ...params ? {
                    params
                } : {},
                mark: dropLineAndPoint({
                    // TODO: extract this 0.7 to be shared with default opacity for point/tick/...
                    ...markDef.type === 'area' && markDef.opacity === undefined && markDef.fillOpacity === undefined ? {
                        opacity: 0.7
                    } : {},
                    ...markDef
                }),
                // drop shape from encoding as this might be used to trigger point overlay
                encoding: omit(encoding, [
                    'shape'
                ])
            }
        ];
        // FIXME: determine rules for applying selections.
        // Need to copy stack config to overlayed layer
        // FIXME: normalizer shouldn't call `initMarkdef`, a method from an init phase.
        const stackProps = stack(initMarkdef(markDef, encoding, config), encoding);
        let overlayEncoding = encoding;
        if (stackProps) {
            const { fieldChannel: stackFieldChannel, offset } = stackProps;
            overlayEncoding = {
                ...encoding,
                [stackFieldChannel]: {
                    ...encoding[stackFieldChannel],
                    ...offset ? {
                        stack: offset
                    } : {}
                }
            };
        }
        // overlay line layer should be on the edge of area but passing y2/x2 makes
        // it as "rule" mark so that it draws unwanted vertical/horizontal lines.
        // point overlay also should not have y2/x2 as it does not support.
        overlayEncoding = omit(overlayEncoding, [
            'y2',
            'x2'
        ]);
        if (lineOverlay) layer.push({
            ...projection ? {
                projection
            } : {},
            mark: {
                type: 'line',
                ...pick(markDef, [
                    'clip',
                    'interpolate',
                    'tension',
                    'tooltip'
                ]),
                ...lineOverlay
            },
            encoding: overlayEncoding
        });
        if (pointOverlay) layer.push({
            ...projection ? {
                projection
            } : {},
            mark: {
                type: 'point',
                opacity: 1,
                filled: true,
                ...pick(markDef, [
                    'clip',
                    'tooltip'
                ]),
                ...pointOverlay
            },
            encoding: overlayEncoding
        });
        return normalize({
            ...outerSpec,
            layer
        }, {
            ...normParams,
            config: dropLineAndPointFromConfig(config)
        });
    }
}
function replaceRepeaterInFacet(facet, repeater) {
    if (!repeater) return facet;
    if (isFacetMapping(facet)) return replaceRepeaterInMapping(facet, repeater);
    return replaceRepeaterInFieldDef(facet, repeater);
}
function replaceRepeaterInEncoding(encoding, repeater) {
    if (!repeater) return encoding;
    return replaceRepeaterInMapping(encoding, repeater);
}
/**
 * Replaces repeated value and returns if the repeated value is valid.
 */ function replaceRepeatInProp(prop, o, repeater) {
    const val = o[prop];
    if (isRepeatRef(val)) {
        if (val.repeat in repeater) return {
            ...o,
            [prop]: repeater[val.repeat]
        };
        else {
            warn(noSuchRepeatedValue(val.repeat));
            return undefined;
        }
    }
    return o;
}
/**
 * Replace repeater values in a field def with the concrete field name.
 */ function replaceRepeaterInFieldDef(fieldDef, repeater) {
    fieldDef = replaceRepeatInProp('field', fieldDef, repeater);
    if (fieldDef === undefined) // the field def should be ignored
    return undefined;
    else if (fieldDef === null) return null;
    if (isSortableFieldDef(fieldDef) && isSortField(fieldDef.sort)) {
        const sort = replaceRepeatInProp('field', fieldDef.sort, repeater);
        fieldDef = {
            ...fieldDef,
            ...sort ? {
                sort
            } : {}
        };
    }
    return fieldDef;
}
function replaceRepeaterInFieldOrDatumDef(def, repeater) {
    if (isFieldDef(def)) return replaceRepeaterInFieldDef(def, repeater);
    else {
        const datumDef = replaceRepeatInProp('datum', def, repeater);
        if (datumDef !== def && !datumDef.type) datumDef.type = 'nominal';
        return datumDef;
    }
}
function replaceRepeaterInChannelDef(channelDef, repeater) {
    if (isFieldOrDatumDef(channelDef)) {
        const fd = replaceRepeaterInFieldOrDatumDef(channelDef, repeater);
        if (fd) return fd;
        else if (isConditionalDef(channelDef)) return {
            condition: channelDef.condition
        };
    } else {
        if (hasConditionalFieldOrDatumDef(channelDef)) {
            const fd = replaceRepeaterInFieldOrDatumDef(channelDef.condition, repeater);
            if (fd) return {
                ...channelDef,
                condition: fd
            };
            else {
                const { condition, ...channelDefWithoutCondition } = channelDef;
                return channelDefWithoutCondition;
            }
        }
        return channelDef;
    }
    return undefined;
}
function replaceRepeaterInMapping(mapping, repeater) {
    const out = {};
    for(const channel in mapping)if (hasProperty(mapping, channel)) {
        const channelDef = mapping[channel];
        if ((0, _vegaUtil.isArray)(channelDef)) // array cannot have condition
        out[channel] = channelDef // somehow we need to cast it here
        .map((cd)=>replaceRepeaterInChannelDef(cd, repeater)).filter((cd)=>cd);
        else {
            const cd = replaceRepeaterInChannelDef(channelDef, repeater);
            if (cd !== undefined) out[channel] = cd;
        }
    }
    return out;
}
class RuleForRangedLineNormalizer {
    name = 'RuleForRangedLine';
    hasMatchingType(spec) {
        if (isUnitSpec(spec)) {
            const { encoding, mark } = spec;
            if (mark === 'line' || isMarkDef(mark) && mark.type === 'line') for (const channel of SECONDARY_RANGE_CHANNEL){
                const mainChannel = getMainRangeChannel(channel);
                const mainChannelDef = encoding[mainChannel];
                if (encoding[channel]) {
                    if (isFieldDef(mainChannelDef) && !isBinned(mainChannelDef.bin) || isDatumDef(mainChannelDef)) return true;
                }
            }
        }
        return false;
    }
    run(spec, params, normalize) {
        const { encoding, mark } = spec;
        warn(lineWithRange(!!encoding.x2, !!encoding.y2));
        return normalize({
            ...spec,
            mark: (0, _vegaUtil.isObject)(mark) ? {
                ...mark,
                type: 'rule'
            } : 'rule'
        }, params);
    }
}
class CoreNormalizer extends SpecMapper {
    nonFacetUnitNormalizers = [
        boxPlotNormalizer,
        errorBarNormalizer,
        errorBandNormalizer,
        new PathOverlayNormalizer(),
        new RuleForRangedLineNormalizer()
    ];
    map(spec, params) {
        // Special handling for a faceted unit spec as it can return a facet spec, not just a layer or unit spec like a normal unit spec.
        if (isUnitSpec(spec)) {
            const hasRow = channelHasField(spec.encoding, ROW);
            const hasColumn = channelHasField(spec.encoding, COLUMN);
            const hasFacet = channelHasField(spec.encoding, FACET);
            if (hasRow || hasColumn || hasFacet) return this.mapFacetedUnit(spec, params);
        }
        return super.map(spec, params);
    }
    // This is for normalizing non-facet unit
    mapUnit(spec, params) {
        const { parentEncoding, parentProjection } = params;
        const encoding = replaceRepeaterInEncoding(spec.encoding, params.repeater);
        const specWithReplacedEncoding = {
            ...spec,
            ...spec.name ? {
                name: [
                    params.repeaterPrefix,
                    spec.name
                ].filter((n)=>n).join('_')
            } : {},
            ...encoding ? {
                encoding
            } : {}
        };
        if (parentEncoding || parentProjection) return this.mapUnitWithParentEncodingOrProjection(specWithReplacedEncoding, params);
        const normalizeLayerOrUnit = this.mapLayerOrUnit.bind(this);
        for (const unitNormalizer of this.nonFacetUnitNormalizers){
            if (unitNormalizer.hasMatchingType(specWithReplacedEncoding, params.config)) return unitNormalizer.run(specWithReplacedEncoding, params, normalizeLayerOrUnit);
        }
        return specWithReplacedEncoding;
    }
    mapRepeat(spec, params) {
        if (isLayerRepeatSpec(spec)) return this.mapLayerRepeat(spec, params);
        else return this.mapNonLayerRepeat(spec, params);
    }
    mapLayerRepeat(spec, params) {
        const { repeat, spec: childSpec, ...rest } = spec;
        const { row, column, layer } = repeat;
        const { repeater = {}, repeaterPrefix = '' } = params;
        if (row || column) return this.mapRepeat({
            ...spec,
            repeat: {
                ...row ? {
                    row
                } : {},
                ...column ? {
                    column
                } : {}
            },
            spec: {
                repeat: {
                    layer
                },
                spec: childSpec
            }
        }, params);
        else return {
            ...rest,
            layer: layer.map((layerValue)=>{
                const childRepeater = {
                    ...repeater,
                    layer: layerValue
                };
                const childName = `${(childSpec.name ? `${childSpec.name}_` : '') + repeaterPrefix}child__layer_${varName(layerValue)}`;
                const child = this.mapLayerOrUnit(childSpec, {
                    ...params,
                    repeater: childRepeater,
                    repeaterPrefix: childName
                });
                child.name = childName;
                return child;
            })
        };
    }
    mapNonLayerRepeat(spec, params) {
        const { repeat, spec: childSpec, data, ...remainingProperties } = spec;
        if (!(0, _vegaUtil.isArray)(repeat) && spec.columns) {
            // is repeat with row/column
            spec = omit(spec, [
                'columns'
            ]);
            warn(columnsNotSupportByRowCol('repeat'));
        }
        const concat = [];
        const { repeater = {}, repeaterPrefix = '' } = params;
        const row = !(0, _vegaUtil.isArray)(repeat) && repeat.row || [
            repeater ? repeater.row : null
        ];
        const column = !(0, _vegaUtil.isArray)(repeat) && repeat.column || [
            repeater ? repeater.column : null
        ];
        const repeatValues = (0, _vegaUtil.isArray)(repeat) && repeat || [
            repeater ? repeater.repeat : null
        ];
        // cross product
        for (const repeatValue of repeatValues){
            for (const rowValue of row)for (const columnValue of column){
                const childRepeater = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue,
                    layer: repeater.layer
                };
                const childName = `${(childSpec.name ? `${childSpec.name}_` : '') + repeaterPrefix}child__${(0, _vegaUtil.isArray)(repeat) ? `${varName(repeatValue)}` : (repeat.row ? `row_${varName(rowValue)}` : '') + (repeat.column ? `column_${varName(columnValue)}` : '')}`;
                const child = this.map(childSpec, {
                    ...params,
                    repeater: childRepeater,
                    repeaterPrefix: childName
                });
                child.name = childName;
                // we move data up
                concat.push(omit(child, [
                    'data'
                ]));
            }
        }
        const columns = (0, _vegaUtil.isArray)(repeat) ? spec.columns : repeat.column ? repeat.column.length : 1;
        return {
            data: childSpec.data ?? data,
            align: 'all',
            ...remainingProperties,
            columns,
            concat
        };
    }
    mapFacet(spec, params) {
        const { facet } = spec;
        if (isFacetMapping(facet) && spec.columns) {
            // is facet with row/column
            spec = omit(spec, [
                'columns'
            ]);
            warn(columnsNotSupportByRowCol('facet'));
        }
        return super.mapFacet(spec, params);
    }
    mapUnitWithParentEncodingOrProjection(spec, params) {
        const { encoding, projection } = spec;
        const { parentEncoding, parentProjection, config } = params;
        const mergedProjection = mergeProjection({
            parentProjection,
            projection
        });
        const mergedEncoding = mergeEncoding({
            parentEncoding,
            encoding: replaceRepeaterInEncoding(encoding, params.repeater)
        });
        return this.mapUnit({
            ...spec,
            ...mergedProjection ? {
                projection: mergedProjection
            } : {},
            ...mergedEncoding ? {
                encoding: mergedEncoding
            } : {}
        }, {
            config
        });
    }
    mapFacetedUnit(spec, normParams) {
        // New encoding in the inside spec should not contain row / column
        // as row/column should be moved to facet
        const { row, column, facet, ...encoding } = spec.encoding;
        // Mark and encoding should be moved into the inner spec
        const { mark, width, projection, height, view, params, encoding: _, ...outerSpec } = spec;
        const { facetMapping, layout } = this.getFacetMappingAndLayout({
            row,
            column,
            facet
        }, normParams);
        const newEncoding = replaceRepeaterInEncoding(encoding, normParams.repeater);
        return this.mapFacet({
            ...outerSpec,
            ...layout,
            // row / column has higher precedence than facet
            facet: facetMapping,
            spec: {
                ...width ? {
                    width
                } : {},
                ...height ? {
                    height
                } : {},
                ...view ? {
                    view
                } : {},
                ...projection ? {
                    projection
                } : {},
                mark,
                encoding: newEncoding,
                ...params ? {
                    params
                } : {}
            }
        }, normParams);
    }
    getFacetMappingAndLayout(facets, params) {
        const { row, column, facet } = facets;
        if (row || column) {
            if (facet) warn(facetChannelDropped([
                ...row ? [
                    ROW
                ] : [],
                ...column ? [
                    COLUMN
                ] : []
            ]));
            const facetMapping = {};
            const layout = {};
            for (const channel of [
                ROW,
                COLUMN
            ]){
                const def = facets[channel];
                if (def) {
                    const { align, center, spacing, columns, ...defWithoutLayout } = def;
                    facetMapping[channel] = defWithoutLayout;
                    for (const prop of [
                        'align',
                        'center',
                        'spacing'
                    ])if (def[prop] !== undefined) {
                        layout[prop] ??= {};
                        layout[prop][channel] = def[prop];
                    }
                }
            }
            return {
                facetMapping,
                layout
            };
        } else {
            const { align, center, spacing, columns, ...facetMapping } = facet;
            return {
                facetMapping: replaceRepeaterInFacet(facetMapping, params.repeater),
                layout: {
                    ...align ? {
                        align
                    } : {},
                    ...center ? {
                        center
                    } : {},
                    ...spacing ? {
                        spacing
                    } : {},
                    ...columns ? {
                        columns
                    } : {}
                }
            };
        }
    }
    mapLayer(spec, { parentEncoding, parentProjection, ...otherParams }) {
        // Special handling for extended layer spec
        const { encoding, projection, ...rest } = spec;
        const params = {
            ...otherParams,
            parentEncoding: mergeEncoding({
                parentEncoding,
                encoding,
                layer: true
            }),
            parentProjection: mergeProjection({
                parentProjection,
                projection
            })
        };
        return super.mapLayer({
            ...rest,
            ...spec.name ? {
                name: [
                    params.repeaterPrefix,
                    spec.name
                ].filter((n)=>n).join('_')
            } : {}
        }, params);
    }
}
function mergeEncoding({ parentEncoding, encoding = {}, layer }) {
    let merged = {};
    if (parentEncoding) {
        const channels = new Set([
            ...keys(parentEncoding),
            ...keys(encoding)
        ]);
        for (const channel of channels){
            const channelDef = encoding[channel];
            const parentChannelDef = parentEncoding[channel];
            if (isFieldOrDatumDef(channelDef)) {
                // Field/Datum Def can inherit properties from its parent
                // Note that parentChannelDef doesn't have to be a field/datum def if the channelDef is already one.
                const mergedChannelDef = {
                    ...parentChannelDef,
                    ...channelDef
                };
                merged[channel] = mergedChannelDef;
            } else if (hasConditionalFieldOrDatumDef(channelDef)) merged[channel] = {
                ...channelDef,
                condition: {
                    ...parentChannelDef,
                    ...channelDef.condition
                }
            };
            else if (channelDef || channelDef === null) merged[channel] = channelDef;
            else if (layer || isValueDef(parentChannelDef) || isSignalRef(parentChannelDef) || isFieldOrDatumDef(parentChannelDef) || (0, _vegaUtil.isArray)(parentChannelDef)) merged[channel] = parentChannelDef;
        }
    } else merged = encoding;
    return !merged || isEmpty(merged) ? undefined : merged;
}
function mergeProjection(opt) {
    const { parentProjection, projection } = opt;
    if (parentProjection && projection) warn(projectionOverridden({
        parentProjection,
        projection
    }));
    return projection ?? parentProjection;
}
function isFilter(t) {
    return hasProperty(t, 'filter');
}
function isImputeSequence(t) {
    return hasProperty(t, 'stop');
}
function isLookup(t) {
    return hasProperty(t, 'lookup');
}
function isLookupData(from) {
    return hasProperty(from, 'data');
}
function isLookupSelection(from) {
    return hasProperty(from, 'param');
}
function isPivot(t) {
    return hasProperty(t, 'pivot');
}
function isDensity(t) {
    return hasProperty(t, 'density');
}
function isQuantile(t) {
    return hasProperty(t, 'quantile');
}
function isRegression(t) {
    return hasProperty(t, 'regression');
}
function isLoess(t) {
    return hasProperty(t, 'loess');
}
function isSample(t) {
    return hasProperty(t, 'sample');
}
function isWindow(t) {
    return hasProperty(t, 'window');
}
function isJoinAggregate(t) {
    return hasProperty(t, 'joinaggregate');
}
function isFlatten(t) {
    return hasProperty(t, 'flatten');
}
function isCalculate(t) {
    return hasProperty(t, 'calculate');
}
function isBin(t) {
    return hasProperty(t, 'bin');
}
function isImpute(t) {
    return hasProperty(t, 'impute');
}
function isTimeUnit(t) {
    return hasProperty(t, 'timeUnit');
}
function isAggregate(t) {
    return hasProperty(t, 'aggregate');
}
function isStack(t) {
    return hasProperty(t, 'stack');
}
function isFold(t) {
    return hasProperty(t, 'fold');
}
function isExtent(t) {
    return hasProperty(t, 'extent') && !hasProperty(t, 'density') && !hasProperty(t, 'regression');
}
function normalizeTransform(transform) {
    return transform.map((t)=>{
        if (isFilter(t)) return {
            filter: normalizeLogicalComposition(t.filter, normalizePredicate$1)
        };
        return t;
    });
}
class SelectionCompatibilityNormalizer extends SpecMapper {
    map(spec, normParams) {
        normParams.emptySelections ??= {};
        normParams.selectionPredicates ??= {};
        spec = normalizeTransforms(spec, normParams);
        return super.map(spec, normParams);
    }
    mapLayerOrUnit(spec, normParams) {
        spec = normalizeTransforms(spec, normParams);
        if (spec.encoding) {
            const encoding = {};
            for (const [channel, enc] of entries$1(spec.encoding))encoding[channel] = normalizeChannelDef(enc, normParams);
            spec = {
                ...spec,
                encoding
            };
        }
        return super.mapLayerOrUnit(spec, normParams);
    }
    mapUnit(spec, normParams) {
        const { selection, ...rest } = spec;
        if (selection) return {
            ...rest,
            params: entries$1(selection).map(([name, selDef])=>{
                const { init: value, bind, empty, ...select } = selDef;
                if (select.type === 'single') {
                    select.type = 'point';
                    select.toggle = false;
                } else if (select.type === 'multi') select.type = 'point';
                // Propagate emptiness forwards and backwards
                normParams.emptySelections[name] = empty !== 'none';
                for (const pred of vals(normParams.selectionPredicates[name] ?? {}))pred.empty = empty !== 'none';
                return {
                    name,
                    value,
                    select,
                    bind
                };
            })
        };
        return spec;
    }
}
function normalizeTransforms(spec, normParams) {
    const { transform: tx, ...rest } = spec;
    if (tx) {
        const transform = tx.map((t)=>{
            if (isFilter(t)) return {
                filter: normalizePredicate(t, normParams)
            };
            else if (isBin(t) && isBinParams(t.bin)) return {
                ...t,
                bin: normalizeBinExtent(t.bin)
            };
            else if (isLookup(t)) {
                const { selection: param, ...from } = t.from;
                return param ? {
                    ...t,
                    from: {
                        param,
                        ...from
                    }
                } : t;
            }
            return t;
        });
        return {
            ...rest,
            transform
        };
    }
    return spec;
}
function normalizeChannelDef(obj, normParams) {
    const enc = duplicate(obj);
    if (isFieldDef(enc) && isBinParams(enc.bin)) enc.bin = normalizeBinExtent(enc.bin);
    if (isScaleFieldDef(enc) && enc.scale?.domain?.selection) {
        const { selection: param, ...domain } = enc.scale.domain;
        enc.scale.domain = {
            ...domain,
            ...param ? {
                param
            } : {}
        };
    }
    if (isConditionalDef(enc)) {
        if ((0, _vegaUtil.isArray)(enc.condition)) enc.condition = enc.condition.map((c)=>{
            const { selection, param, test, ...cond } = c;
            return param ? c : {
                ...cond,
                test: normalizePredicate(c, normParams)
            };
        });
        else {
            const { selection, param, test, ...cond } = normalizeChannelDef(enc.condition, normParams);
            enc.condition = param ? enc.condition : {
                ...cond,
                test: normalizePredicate(enc.condition, normParams)
            };
        }
    }
    return enc;
}
function normalizeBinExtent(bin) {
    const ext = bin.extent;
    if (ext?.selection) {
        const { selection: param, ...rest } = ext;
        return {
            ...bin,
            extent: {
                ...rest,
                param
            }
        };
    }
    return bin;
}
function normalizePredicate(op, normParams) {
    // Normalize old compositions of selection names (e.g., selection: {and: ["one", "two"]})
    const normalizeSelectionComposition = (o)=>{
        return normalizeLogicalComposition(o, (param)=>{
            const empty = normParams.emptySelections[param] ?? true;
            const pred = {
                param,
                empty
            };
            normParams.selectionPredicates[param] ??= [];
            normParams.selectionPredicates[param].push(pred);
            return pred;
        });
    };
    return op.selection ? normalizeSelectionComposition(op.selection) : normalizeLogicalComposition(op.test || op.filter, (o)=>o.selection ? normalizeSelectionComposition(o.selection) : o);
}
class TopLevelSelectionsNormalizer extends SpecMapper {
    map(spec, normParams) {
        const selections = normParams.selections ?? [];
        if (spec.params && !isUnitSpec(spec)) {
            const params = [];
            for (const param of spec.params)if (isSelectionParameter(param)) selections.push(param);
            else params.push(param);
            spec.params = params;
        }
        normParams.selections = selections;
        return super.map(spec, normParams);
    }
    mapUnit(spec, normParams) {
        const selections = normParams.selections;
        if (!selections || !selections.length) return spec;
        const path = (normParams.path ?? []).concat(spec.name);
        const params = [];
        for (const selection of selections)// By default, apply selections to all unit views.
        if (!selection.views || !selection.views.length) params.push(selection);
        else {
            for (const view of selection.views)// view is either a specific unit name, or a partial path through the spec tree.
            if ((0, _vegaUtil.isString)(view) && (view === spec.name || path.includes(view)) || (0, _vegaUtil.isArray)(view) && // logic for backwards compatibility with view paths before we had unique names
            view.map((v)=>path.indexOf(v)).every((v, i, arr)=>v !== -1 && (i === 0 || v > arr[i - 1]))) params.push(selection);
        }
        if (params.length) spec.params = params;
        return spec;
    }
}
for (const method of [
    'mapFacet',
    'mapRepeat',
    'mapHConcat',
    'mapVConcat',
    'mapLayer'
]){
    const proto = TopLevelSelectionsNormalizer.prototype[method];
    TopLevelSelectionsNormalizer.prototype[method] = function(spec, params) {
        return proto.call(this, spec, addSpecNameToParams(spec, params));
    };
}
function addSpecNameToParams(spec, params) {
    return spec.name ? {
        ...params,
        path: (params.path ?? []).concat(spec.name)
    } : params;
}
function normalize(spec, config) {
    if (config === undefined) config = initConfig(spec.config);
    const normalizedSpec = normalizeGenericSpec(spec, config);
    const { width, height } = spec;
    const autosize = normalizeAutoSize(normalizedSpec, {
        width,
        height,
        autosize: spec.autosize
    }, config);
    return {
        ...normalizedSpec,
        ...autosize ? {
            autosize
        } : {}
    };
}
const coreNormalizer = new CoreNormalizer();
const selectionCompatNormalizer = new SelectionCompatibilityNormalizer();
const topLevelSelectionNormalizer = new TopLevelSelectionsNormalizer();
/**
 * Decompose extended unit specs into composition of pure unit specs.
 * And push top-level selection definitions down to unit specs.
 */ function normalizeGenericSpec(spec, config = {}) {
    const normParams = {
        config
    };
    return topLevelSelectionNormalizer.map(coreNormalizer.map(selectionCompatNormalizer.map(spec, normParams), normParams), normParams);
}
function _normalizeAutoSize(autosize) {
    return (0, _vegaUtil.isString)(autosize) ? {
        type: autosize
    } : autosize ?? {};
}
/**
 * Normalize autosize and deal with width or height == "container".
 */ function normalizeAutoSize(spec, sizeInfo, config) {
    let { width, height } = sizeInfo;
    const isFitCompatible = isUnitSpec(spec) || isLayerSpec(spec);
    const autosizeDefault = {};
    if (!isFitCompatible) {
        // If spec is not compatible with autosize == "fit", discard width/height == container
        if (width == 'container') {
            warn(containerSizeNonSingle('width'));
            width = undefined;
        }
        if (height == 'container') {
            warn(containerSizeNonSingle('height'));
            height = undefined;
        }
    } else {
        // Default autosize parameters to fit when width/height is "container"
        if (width == 'container' && height == 'container') {
            autosizeDefault.type = 'fit';
            autosizeDefault.contains = 'padding';
        } else if (width == 'container') {
            autosizeDefault.type = 'fit-x';
            autosizeDefault.contains = 'padding';
        } else if (height == 'container') {
            autosizeDefault.type = 'fit-y';
            autosizeDefault.contains = 'padding';
        }
    }
    const autosize = {
        type: 'pad',
        ...autosizeDefault,
        ...config ? _normalizeAutoSize(config.autosize) : {},
        ..._normalizeAutoSize(spec.autosize)
    };
    if (autosize.type === 'fit' && !isFitCompatible) {
        warn(FIT_NON_SINGLE);
        autosize.type = 'pad';
    }
    if (width == 'container' && !(autosize.type == 'fit' || autosize.type == 'fit-x')) warn(containerSizeNotCompatibleWithAutosize('width'));
    if (height == 'container' && !(autosize.type == 'fit' || autosize.type == 'fit-y')) warn(containerSizeNotCompatibleWithAutosize('height'));
    // Delete autosize property if it's Vega's default
    if (deepEqual(autosize, {
        type: 'pad'
    })) return undefined;
    return autosize;
}
function isFitType(autoSizeType) {
    return [
        'fit',
        'fit-x',
        'fit-y'
    ].includes(autoSizeType);
}
function getFitType(sizeType) {
    return sizeType ? `fit-${getPositionScaleChannel(sizeType)}` : 'fit';
}
const TOP_LEVEL_PROPERTIES = [
    'background',
    'padding'
];
function extractTopLevelProperties(t, includeParams) {
    const o = {};
    for (const p of TOP_LEVEL_PROPERTIES)if (t && t[p] !== undefined) o[p] = signalRefOrValue(t[p]);
    if (includeParams) o.params = t.params;
    return o;
}
/**
 * Generic class for storing properties that are explicitly specified
 * and implicitly determined by the compiler.
 * This is important for scale/axis/legend merging as
 * we want to prioritize properties that users explicitly specified.
 */ class Split {
    explicit;
    implicit;
    constructor(explicit = {}, implicit = {}){
        this.explicit = explicit;
        this.implicit = implicit;
    }
    clone() {
        return new Split(duplicate(this.explicit), duplicate(this.implicit));
    }
    combine() {
        return {
            ...this.explicit,
            ...this.implicit
        };
    }
    get(key) {
        // Explicit has higher precedence
        return getFirstDefined(this.explicit[key], this.implicit[key]);
    }
    getWithExplicit(key) {
        // Explicit has higher precedence
        if (this.explicit[key] !== undefined) return {
            explicit: true,
            value: this.explicit[key]
        };
        else if (this.implicit[key] !== undefined) return {
            explicit: false,
            value: this.implicit[key]
        };
        return {
            explicit: false,
            value: undefined
        };
    }
    setWithExplicit(key, { value, explicit }) {
        if (value !== undefined) this.set(key, value, explicit);
    }
    set(key, value, explicit) {
        delete this[explicit ? 'implicit' : 'explicit'][key];
        this[explicit ? 'explicit' : 'implicit'][key] = value;
        return this;
    }
    copyKeyFromSplit(key, { explicit, implicit }) {
        // Explicit has higher precedence
        if (explicit[key] !== undefined) this.set(key, explicit[key], true);
        else if (implicit[key] !== undefined) this.set(key, implicit[key], false);
    }
    copyKeyFromObject(key, s) {
        // Explicit has higher precedence
        if (s[key] !== undefined) this.set(key, s[key], true);
    }
    /**
     * Merge split object into this split object. Properties from the other split
     * overwrite properties from this split.
     */ copyAll(other) {
        for (const key of keys(other.combine())){
            const val = other.getWithExplicit(key);
            this.setWithExplicit(key, val);
        }
    }
}
function makeExplicit(value) {
    return {
        explicit: true,
        value
    };
}
function makeImplicit(value) {
    return {
        explicit: false,
        value
    };
}
function tieBreakByComparing(compare) {
    return (v1, v2, property, propertyOf)=>{
        const diff = compare(v1.value, v2.value);
        if (diff > 0) return v1;
        else if (diff < 0) return v2;
        return defaultTieBreaker(v1, v2, property, propertyOf);
    };
}
function defaultTieBreaker(v1, v2, property, propertyOf) {
    if (v1.explicit && v2.explicit) warn(mergeConflictingProperty(property, propertyOf, v1.value, v2.value));
    // If equal score, prefer v1.
    return v1;
}
function mergeValuesWithExplicit(v1, v2, property, propertyOf, tieBreaker = defaultTieBreaker) {
    if (v1 === undefined || v1.value === undefined) // For first run
    return v2;
    if (v1.explicit && !v2.explicit) return v1;
    else if (v2.explicit && !v1.explicit) return v2;
    else if (deepEqual(v1.value, v2.value)) return v1;
    else return tieBreaker(v1, v2, property, propertyOf);
}
/**
 * Class to track interesting properties (see https://15721.courses.cs.cmu.edu/spring2016/papers/graefe-ieee1995.pdf)
 * about how fields have been parsed or whether they have been derived in a transform. We use this to not parse the
 * same field again (or differently).
 */ class AncestorParse extends Split {
    explicit;
    implicit;
    parseNothing;
    constructor(explicit = {}, implicit = {}, parseNothing = false){
        super(explicit, implicit);
        this.explicit = explicit;
        this.implicit = implicit;
        this.parseNothing = parseNothing;
    }
    clone() {
        const clone = super.clone();
        clone.parseNothing = this.parseNothing;
        return clone;
    }
}
function isUrlData(data) {
    return hasProperty(data, 'url');
}
function isInlineData(data) {
    return hasProperty(data, 'values');
}
function isNamedData(data) {
    return hasProperty(data, 'name') && !isUrlData(data) && !isInlineData(data) && !isGenerator(data);
}
function isGenerator(data) {
    return data && (isSequenceGenerator(data) || isSphereGenerator(data) || isGraticuleGenerator(data));
}
function isSequenceGenerator(data) {
    return hasProperty(data, 'sequence');
}
function isSphereGenerator(data) {
    return hasProperty(data, 'sphere');
}
function isGraticuleGenerator(data) {
    return hasProperty(data, 'graticule');
}
var DataSourceType;
(function(DataSourceType) {
    DataSourceType[DataSourceType["Raw"] = 0] = "Raw";
    /** Main data source for marks */ DataSourceType[DataSourceType["Main"] = 1] = "Main";
    DataSourceType[DataSourceType["Row"] = 2] = "Row";
    DataSourceType[DataSourceType["Column"] = 3] = "Column";
    DataSourceType[DataSourceType["Lookup"] = 4] = "Lookup";
    /** Pre-filter-invalid data source for scale domains */ DataSourceType[DataSourceType["PreFilterInvalid"] = 5] = "PreFilterInvalid";
    /** Post-filter-invalid data source for scale domains */ DataSourceType[DataSourceType["PostFilterInvalid"] = 6] = "PostFilterInvalid";
})(DataSourceType || (DataSourceType = {}));
function getDataSourcesForHandlingInvalidValues({ invalid, isPath }) {
    const normalizedInvalid = normalizeInvalidDataMode(invalid, {
        isPath
    });
    switch(normalizedInvalid){
        case 'filter':
            // Both marks and scales use post-filter data
            return {
                marks: 'exclude-invalid-values',
                scales: 'exclude-invalid-values'
            };
        case 'break-paths-show-domains':
            return {
                // Path-based marks use pre-filter data so we know to skip these invalid points in the path.
                // For non-path based marks, we skip by not showing them at all.
                marks: isPath ? 'include-invalid-values' : 'exclude-invalid-values',
                scales: 'include-invalid-values'
            };
        case 'break-paths-filter-domains':
            // For path marks, the marks will use unfiltered data (and skip points). But we need a separate data sources to feed the domain.
            // For non-path marks, we can use the filtered data for both marks and scales.
            return {
                marks: isPath ? 'include-invalid-values' : 'exclude-invalid-values',
                // Unlike 'break-paths-show-domains', 'break-paths-filter-domains' uses post-filter data to feed scale.
                scales: 'exclude-invalid-values'
            };
        case 'show':
            return {
                marks: 'include-invalid-values',
                scales: 'include-invalid-values'
            };
    }
}
function getScaleDataSourceForHandlingInvalidValues(props) {
    const { marks, scales } = getDataSourcesForHandlingInvalidValues(props);
    if (marks === scales) // If both marks and scales use the same data, there is only the main data source.
    return DataSourceType.Main;
    // If marks and scales use differetnt data, return the pre/post-filter data source accordingly.
    return scales === 'include-invalid-values' ? DataSourceType.PreFilterInvalid : DataSourceType.PostFilterInvalid;
}
/**
 * A node in the dataflow tree.
 */ class DataFlowNode {
    debugName;
    _children = [];
    _parent = null;
    _hash;
    constructor(parent, debugName){
        this.debugName = debugName;
        if (parent) this.parent = parent;
    }
    /**
     * Clone this node with a deep copy but don't clone links to children or parents.
     */ clone() {
        throw new Error('Cannot clone node');
    }
    get parent() {
        return this._parent;
    }
    /**
     * Set the parent of the node and also add this node to the parent's children.
     */ set parent(parent) {
        this._parent = parent;
        if (parent) parent.addChild(this);
    }
    get children() {
        return this._children;
    }
    numChildren() {
        return this._children.length;
    }
    addChild(child, loc) {
        // do not add the same child twice
        if (this._children.includes(child)) {
            warn(ADD_SAME_CHILD_TWICE);
            return;
        }
        if (loc !== undefined) this._children.splice(loc, 0, child);
        else this._children.push(child);
    }
    removeChild(oldChild) {
        const loc = this._children.indexOf(oldChild);
        this._children.splice(loc, 1);
        return loc;
    }
    /**
     * Remove node from the dataflow.
     */ remove() {
        let loc = this._parent.removeChild(this);
        for (const child of this._children){
            // do not use the set method because we want to insert at a particular location
            child._parent = this._parent;
            this._parent.addChild(child, loc++);
        }
    }
    /**
     * Insert another node as a parent of this node.
     */ insertAsParentOf(other) {
        const parent = other.parent;
        parent.removeChild(this);
        this.parent = parent;
        other.parent = this;
    }
    swapWithParent() {
        const parent = this._parent;
        const newParent = parent.parent;
        // reconnect the children
        for (const child of this._children)child.parent = parent;
        // remove old links
        this._children = []; // equivalent to removing every child link one by one
        parent.removeChild(this);
        const loc = parent.parent.removeChild(parent);
        // swap two nodes but maintain order in children
        this._parent = newParent;
        newParent.addChild(this, loc);
        parent.parent = this;
    }
}
class OutputNode extends DataFlowNode {
    type;
    refCounts;
    _source;
    _name;
    clone() {
        const cloneObj = new this.constructor();
        cloneObj.debugName = `clone_${this.debugName}`;
        cloneObj._source = this._source;
        cloneObj._name = `clone_${this._name}`;
        cloneObj.type = this.type;
        cloneObj.refCounts = this.refCounts;
        cloneObj.refCounts[cloneObj._name] = 0;
        return cloneObj;
    }
    /**
     * @param source The name of the source. Will change in assemble.
     * @param type The type of the output node.
     * @param refCounts A global ref counter map.
     */ constructor(parent, source, type, refCounts){
        super(parent, source);
        this.type = type;
        this.refCounts = refCounts;
        this._source = this._name = source;
        if (this.refCounts && !(this._name in this.refCounts)) this.refCounts[this._name] = 0;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set();
    }
    hash() {
        if (this._hash === undefined) this._hash = `Output ${uniqueId()}`;
        return this._hash;
    }
    /**
     * Request the datasource name and increase the ref counter.
     *
     * During the parsing phase, this will return the simple name such as 'main' or 'raw'.
     * It is crucial to request the name from an output node to mark it as a required node.
     * If nobody ever requests the name, this datasource will not be instantiated in the assemble phase.
     *
     * In the assemble phase, this will return the correct name.
     */ getSource() {
        this.refCounts[this._name]++;
        return this._source;
    }
    isRequired() {
        return !!this.refCounts[this._name];
    }
    setSource(source) {
        this._source = source;
    }
}
function isTimeUnitTransformComponent(timeUnitComponent) {
    return timeUnitComponent.as !== undefined;
}
function offsetAs(field) {
    return `${field}_end`;
}
class TimeUnitNode extends DataFlowNode {
    timeUnits;
    clone() {
        return new TimeUnitNode(null, duplicate(this.timeUnits));
    }
    constructor(parent, timeUnits){
        super(parent);
        this.timeUnits = timeUnits;
    }
    static makeFromEncoding(parent, model) {
        const formula = model.reduceFieldDef((timeUnitComponent, fieldDef, channel)=>{
            const { field, timeUnit } = fieldDef;
            if (timeUnit) {
                let component;
                if (isBinnedTimeUnit(timeUnit)) // For binned time unit, only produce end if the mark is a rect-based mark (rect, bar, image, arc), which needs "range".
                {
                    if (isUnitModel(model)) {
                        const { mark, markDef, config } = model;
                        const bandPosition = getBandPosition({
                            fieldDef,
                            markDef,
                            config
                        });
                        if (isRectBasedMark(mark) || !!bandPosition) component = {
                            timeUnit: normalizeTimeUnit(timeUnit),
                            field
                        };
                    }
                } else component = {
                    as: vgField(fieldDef, {
                        forAs: true
                    }),
                    field,
                    timeUnit
                };
                if (isUnitModel(model)) {
                    const { mark, markDef, config } = model;
                    const bandPosition = getBandPosition({
                        fieldDef,
                        markDef,
                        config
                    });
                    if (isRectBasedMark(mark) && isXorY(channel) && bandPosition !== 0.5) component.rectBandPosition = bandPosition;
                }
                if (component) timeUnitComponent[hash(component)] = component;
            }
            return timeUnitComponent;
        }, {});
        if (isEmpty(formula)) return null;
        return new TimeUnitNode(parent, formula);
    }
    static makeFromTransform(parent, t) {
        const { timeUnit, ...other } = {
            ...t
        };
        const normalizedTimeUnit = normalizeTimeUnit(timeUnit);
        const component = {
            ...other,
            timeUnit: normalizedTimeUnit
        };
        return new TimeUnitNode(parent, {
            [hash(component)]: component
        });
    }
    /**
     * Merge together TimeUnitNodes assigning the children of `other` to `this`
     * and removing `other`.
     */ merge(other) {
        this.timeUnits = {
            ...this.timeUnits
        };
        // if the same hash happen twice, merge
        for(const key in other.timeUnits)if (!this.timeUnits[key]) // copy if it's not a duplicate
        this.timeUnits[key] = other.timeUnits[key];
        for (const child of other.children){
            other.removeChild(child);
            child.parent = this;
        }
        other.remove();
    }
    /**
     * Remove time units coming from the other node.
     */ removeFormulas(fields) {
        const newFormula = {};
        for (const [key, timeUnitComponent] of entries$1(this.timeUnits)){
            const fieldAs = isTimeUnitTransformComponent(timeUnitComponent) ? timeUnitComponent.as : `${timeUnitComponent.field}_end`;
            if (!fields.has(fieldAs)) newFormula[key] = timeUnitComponent;
        }
        this.timeUnits = newFormula;
    }
    producedFields() {
        return new Set(vals(this.timeUnits).map((f)=>{
            return isTimeUnitTransformComponent(f) ? f.as : offsetAs(f.field);
        }));
    }
    dependentFields() {
        return new Set(vals(this.timeUnits).map((f)=>f.field));
    }
    hash() {
        return `TimeUnit ${hash(this.timeUnits)}`;
    }
    assemble() {
        const transforms = [];
        for (const f of vals(this.timeUnits)){
            const { rectBandPosition } = f;
            const normalizedTimeUnit = normalizeTimeUnit(f.timeUnit);
            if (isTimeUnitTransformComponent(f)) {
                const { field, as } = f;
                const { unit, utc, ...params } = normalizedTimeUnit;
                const startEnd = [
                    as,
                    `${as}_end`
                ];
                transforms.push({
                    field: replacePathInField(field),
                    type: 'timeunit',
                    ...unit ? {
                        units: getTimeUnitParts(unit)
                    } : {},
                    ...utc ? {
                        timezone: 'utc'
                    } : {},
                    ...params,
                    as: startEnd
                });
                transforms.push(...offsetedRectFormulas(startEnd, rectBandPosition, normalizedTimeUnit));
            } else if (f) {
                const { field: escapedField } = f;
                // since this is a expression, we want the unescaped field name
                const field = escapedField.replaceAll('\\.', '.');
                const expr = offsetExpr({
                    timeUnit: normalizedTimeUnit,
                    field
                });
                const endAs = offsetAs(field);
                transforms.push({
                    type: 'formula',
                    expr,
                    as: endAs
                });
                transforms.push(...offsetedRectFormulas([
                    field,
                    endAs
                ], rectBandPosition, normalizedTimeUnit));
            }
        }
        return transforms;
    }
}
const OFFSETTED_RECT_START_SUFFIX = 'offsetted_rect_start';
const OFFSETTED_RECT_END_SUFFIX = 'offsetted_rect_end';
function offsetExpr({ timeUnit, field, reverse }) {
    const { unit, utc } = timeUnit;
    const smallestUnit = getSmallestTimeUnitPart(unit);
    const { part, step } = getDateTimePartAndStep(smallestUnit, timeUnit.step);
    const offsetFn = utc ? 'utcOffset' : 'timeOffset';
    const expr = `${offsetFn}('${part}', ${accessWithDatumToUnescapedPath(field)}, ${reverse ? -step : step})`;
    return expr;
}
function offsetedRectFormulas([startField, endField], rectBandPosition, timeUnit) {
    if (rectBandPosition !== undefined && rectBandPosition !== 0.5) {
        const startExpr = accessWithDatumToUnescapedPath(startField);
        const endExpr = accessWithDatumToUnescapedPath(endField);
        return [
            {
                type: 'formula',
                expr: interpolateExpr([
                    offsetExpr({
                        timeUnit,
                        field: startField,
                        reverse: true
                    }),
                    startExpr
                ], rectBandPosition + 0.5),
                as: `${startField}_${OFFSETTED_RECT_START_SUFFIX}`
            },
            {
                type: 'formula',
                expr: interpolateExpr([
                    startExpr,
                    endExpr
                ], rectBandPosition + 0.5),
                as: `${startField}_${OFFSETTED_RECT_END_SUFFIX}`
            }
        ];
    }
    return [];
}
function interpolateExpr([start, end], fraction) {
    return `${1 - fraction} * ${start} + ${fraction} * ${end}`;
}
const TUPLE_FIELDS = '_tuple_fields';
class SelectionProjectionComponent {
    hasChannel;
    hasField;
    hasSelectionId;
    timeUnit;
    items;
    constructor(...items){
        this.items = items;
        this.hasChannel = {};
        this.hasField = {};
        this.hasSelectionId = false;
    }
}
const project = {
    defined: ()=>{
        return true; // This transform handles its own defaults, so always run parse.
    },
    parse: (model, selCmpt, selDef)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project ??= new SelectionProjectionComponent();
        const parsed = {};
        const timeUnits = {};
        const signals = new Set();
        const signalName = (p, range)=>{
            const suffix = range === 'visual' ? p.channel : p.field;
            let sg = varName(`${name}_${suffix}`);
            for(let counter = 1; signals.has(sg); counter++)sg = varName(`${name}_${suffix}_${counter}`);
            signals.add(sg);
            return {
                [range]: sg
            };
        };
        const type = selCmpt.type;
        const cfg = model.config.selection[type];
        const init = selDef.value !== undefined ? (0, _vegaUtil.array)(selDef.value) : null;
        // If no explicit projection (either fields or encodings) is specified, set some defaults.
        // If an initial value is set, try to infer projections.
        let { fields, encodings } = (0, _vegaUtil.isObject)(selDef.select) ? selDef.select : {};
        if (!fields && !encodings && init) for (const initVal of init){
            // initVal may be a scalar value to smoothen varParam -> pointSelection gradient.
            if (!(0, _vegaUtil.isObject)(initVal)) continue;
            for (const key of keys(initVal)){
                if (isSingleDefUnitChannel(key)) (encodings || (encodings = [])).push(key);
                else if (type === 'interval') {
                    warn(INTERVAL_INITIALIZED_WITH_POS);
                    encodings = cfg.encodings;
                } else (fields ??= []).push(key);
            }
        }
        // If no initial value is specified, use the default configuration.
        // We break this out as a separate if block (instead of an else condition)
        // to account for unprojected point selections that have scalar initial values
        if (!fields && !encodings) {
            encodings = cfg.encodings;
            if ('fields' in cfg) fields = cfg.fields;
        }
        for (const channel of encodings ?? []){
            const fieldDef = model.fieldDef(channel);
            if (fieldDef) {
                let field = fieldDef.field;
                if (fieldDef.aggregate) {
                    warn(cannotProjectAggregate(channel, fieldDef.aggregate));
                    continue;
                } else if (!field) {
                    warn(cannotProjectOnChannelWithoutField(channel));
                    continue;
                }
                if (fieldDef.timeUnit && !isBinnedTimeUnit(fieldDef.timeUnit)) {
                    field = model.vgField(channel);
                    // Construct TimeUnitComponents which will be combined into a
                    // TimeUnitNode. This node may need to be inserted into the
                    // dataflow if the selection is used across views that do not
                    // have these time units defined.
                    const component = {
                        timeUnit: fieldDef.timeUnit,
                        as: field,
                        field: fieldDef.field
                    };
                    timeUnits[hash(component)] = component;
                }
                // Prevent duplicate projections on the same field.
                // TODO: what if the same field is bound to multiple channels (e.g., SPLOM diag).
                if (!parsed[field]) {
                    // Determine whether the tuple will store enumerated or ranged values.
                    // Interval selections store ranges for continuous scales, and enumerations otherwise.
                    // Single/multi selections store ranges for binned fields, and enumerations otherwise.
                    const tplType = type === 'interval' && isScaleChannel(channel) && hasContinuousDomain(model.getScaleComponent(channel).get('type')) ? 'R' : fieldDef.bin ? 'R-RE' : 'E';
                    const p = {
                        field,
                        channel,
                        type: tplType,
                        index: proj.items.length
                    };
                    p.signals = {
                        ...signalName(p, 'data'),
                        ...signalName(p, 'visual')
                    };
                    proj.items.push(parsed[field] = p);
                    proj.hasField[field] = parsed[field];
                    proj.hasSelectionId = proj.hasSelectionId || field === SELECTION_ID;
                    if (isGeoPositionChannel(channel)) {
                        p.geoChannel = channel;
                        p.channel = getPositionChannelFromLatLong(channel);
                        proj.hasChannel[p.channel] = parsed[field];
                    } else proj.hasChannel[channel] = parsed[field];
                }
            } else warn(cannotProjectOnChannelWithoutField(channel));
        }
        for (const field of fields ?? []){
            if (proj.hasField[field]) continue;
            const p = {
                type: 'E',
                field,
                index: proj.items.length
            };
            p.signals = {
                ...signalName(p, 'data')
            };
            proj.items.push(p);
            proj.hasField[field] = p;
            proj.hasSelectionId = proj.hasSelectionId || field === SELECTION_ID;
        }
        if (init) selCmpt.init = init.map((v)=>{
            // Selections can be initialized either with a full object that maps projections to values
            // or scalar values to smoothen the abstraction gradient from variable params to point selections.
            return proj.items.map((p)=>(0, _vegaUtil.isObject)(v) ? v[p.geoChannel || p.channel] !== undefined ? v[p.geoChannel || p.channel] : v[p.field] : v);
        });
        if (!isEmpty(timeUnits)) proj.timeUnit = new TimeUnitNode(null, timeUnits);
    },
    signals: (model, selCmpt, allSignals)=>{
        const name = selCmpt.name + TUPLE_FIELDS;
        const hasSignal = allSignals.filter((s)=>s.name === name);
        return hasSignal.length > 0 || selCmpt.project.hasSelectionId ? allSignals : allSignals.concat({
            name,
            value: selCmpt.project.items.map(assembleProjection)
        });
    }
};
const CURR = '_curr';
const ANIM_VALUE = 'anim_value';
const ANIM_CLOCK = 'anim_clock';
const EASED_ANIM_CLOCK = 'eased_anim_clock';
const MIN_EXTENT = 'min_extent';
const MAX_RANGE_EXTENT = 'max_range_extent';
const LAST_TICK = 'last_tick_at';
const IS_PLAYING = 'is_playing';
const THROTTLE = 1 / 60 * 1000; // 60 FPS
const animationSignals = (selectionName, scaleName)=>{
    return [
        // timer signals
        {
            name: EASED_ANIM_CLOCK,
            // update: 'easeLinear(anim_clock / max_range_extent) * max_range_extent'
            update: ANIM_CLOCK
        },
        // scale signals
        // TODO(jzong): uncomment commented signals below when implementing interpolation
        {
            name: `${selectionName}_domain`,
            init: `domain('${scaleName}')`
        },
        {
            name: MIN_EXTENT,
            init: `extent(${selectionName}_domain)[0]`
        },
        // {name: 'max_extent', init: `extent(${selectionName}_domain)[1]`},
        {
            name: MAX_RANGE_EXTENT,
            init: `extent(range('${scaleName}'))[1]`
        },
        // {name: 't_index', update: `indexof(${selectionName}_domain, anim_value)`},
        {
            name: ANIM_VALUE,
            update: `invert('${scaleName}', ${EASED_ANIM_CLOCK})`
        }
    ];
};
const point$1 = {
    defined: (selCmpt)=>selCmpt.type === 'point',
    topLevelSignals: (model, selCmpt, signals)=>{
        if (isTimerSelection(selCmpt)) signals = signals.concat([
            {
                name: ANIM_CLOCK,
                init: '0',
                on: [
                    {
                        events: {
                            type: 'timer',
                            throttle: THROTTLE
                        },
                        update: `${IS_PLAYING} ? (${ANIM_CLOCK} + (now() - ${LAST_TICK}) > ${MAX_RANGE_EXTENT} ? 0 : ${ANIM_CLOCK} + (now() - ${LAST_TICK})) : ${ANIM_CLOCK}`
                    }
                ]
            },
            {
                name: LAST_TICK,
                init: 'now()',
                on: [
                    {
                        events: [
                            {
                                signal: ANIM_CLOCK
                            },
                            {
                                signal: IS_PLAYING
                            }
                        ],
                        update: 'now()'
                    }
                ]
            },
            {
                name: IS_PLAYING,
                init: 'true'
            }
        ]);
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const fieldsSg = name + TUPLE_FIELDS;
        const project = selCmpt.project;
        const datum = '(item().isVoronoi ? datum.datum : datum)';
        // Only add a discrete selection to the store if a datum is present _and_
        // the interaction isn't occurring on a group mark. This guards against
        // polluting interactive state with invalid values in faceted displays
        // as the group marks are also data-driven. We force the update to account
        // for constant null states but varying toggles (e.g., shift-click in
        // whitespace followed by a click in whitespace; the store should only
        // be cleared on the second click).
        const brushes = vals(model.component.selection ?? {}).reduce((acc, cmpt)=>{
            return cmpt.type === 'interval' ? acc.concat(cmpt.name + BRUSH) : acc;
        }, []).map((b)=>`indexof(item().mark.name, '${b}') < 0`).join(' && ');
        const test = `datum && item().mark.marktype !== 'group' && indexof(item().mark.role, 'legend') < 0${brushes ? ` && ${brushes}` : ''}`;
        let update = `unit: ${unitName(model)}, `;
        if (selCmpt.project.hasSelectionId) update += `${SELECTION_ID}: ${datum}[${(0, _vegaUtil.stringValue)(SELECTION_ID)}]`;
        else if (isTimerSelection(selCmpt)) update += `fields: ${fieldsSg}, values: [${ANIM_VALUE} ? ${ANIM_VALUE} : ${MIN_EXTENT}]`;
        else {
            const values = project.items.map((p)=>{
                const fieldDef = model.fieldDef(p.channel);
                // Binned fields should capture extents, for a range test against the raw field.
                return fieldDef?.bin ? `[${datum}[${(0, _vegaUtil.stringValue)(model.vgField(p.channel, {}))}], ` + `${datum}[${(0, _vegaUtil.stringValue)(model.vgField(p.channel, {
                    binSuffix: 'end'
                }))}]]` : `${datum}[${(0, _vegaUtil.stringValue)(p.field)}]`;
            }).join(', ');
            update += `fields: ${fieldsSg}, values: [${values}]`;
        }
        if (isTimerSelection(selCmpt)) // timer event: selection is for animation
        return signals.concat(animationSignals(selCmpt.name, model.scaleName(TIME)), [
            {
                name: name + TUPLE,
                on: [
                    {
                        events: [
                            {
                                signal: EASED_ANIM_CLOCK
                            },
                            {
                                signal: ANIM_VALUE
                            }
                        ],
                        update: `{${update}}`,
                        force: true
                    }
                ]
            }
        ]);
        else {
            const events = selCmpt.events;
            return signals.concat([
                {
                    name: name + TUPLE,
                    on: events ? [
                        {
                            events,
                            update: `${test} ? {${update}} : null`,
                            force: true
                        }
                    ] : []
                }
            ]);
        }
    }
};
function assembleProjection(proj) {
    const { signals, hasLegend, index, ...rest } = proj;
    rest.field = replacePathInField(rest.field);
    return rest;
}
function assembleInit(init, isExpr = true, wrap = (0, _vegaUtil.identity)) {
    if ((0, _vegaUtil.isArray)(init)) {
        const assembled = init.map((v)=>assembleInit(v, isExpr, wrap));
        return isExpr ? `[${assembled.join(', ')}]` : assembled;
    } else if (isDateTime(init)) {
        if (isExpr) return wrap(dateTimeToExpr(init));
        else return wrap(dateTimeToTimestamp(init));
    }
    return isExpr ? wrap(stringify(init)) : init;
}
function assembleUnitSelectionSignals(model, signals) {
    for (const selCmpt of vals(model.component.selection ?? {})){
        const name = selCmpt.name;
        let modifyExpr = `${name}${TUPLE}, ${selCmpt.resolve === 'global' ? 'true' : `{unit: ${unitName(model)}}`}`;
        for (const c of selectionCompilers){
            if (!c.defined(selCmpt)) continue;
            if (c.signals) signals = c.signals(model, selCmpt, signals);
            if (c.modifyExpr) modifyExpr = c.modifyExpr(model, selCmpt, modifyExpr);
        }
        signals.push({
            name: name + MODIFY,
            on: [
                {
                    events: {
                        signal: selCmpt.name + TUPLE
                    },
                    update: `modify(${(0, _vegaUtil.stringValue)(selCmpt.name + STORE)}, ${modifyExpr})`
                }
            ]
        });
    }
    return cleanupEmptyOnArray(signals);
}
function assembleFacetSignals(model, signals) {
    if (model.component.selection && keys(model.component.selection).length) {
        const name = (0, _vegaUtil.stringValue)(model.getName('cell'));
        signals.unshift({
            name: 'facet',
            value: {},
            on: [
                {
                    events: (0, _vegaEventSelector.parseSelector)('pointermove', 'scope'),
                    update: `isTuple(facet) ? facet : group(${name}).datum`
                }
            ]
        });
    }
    return cleanupEmptyOnArray(signals);
}
function assembleTopLevelSignals(model, signals) {
    let hasSelections = false;
    for (const selCmpt of vals(model.component.selection ?? {})){
        const name = selCmpt.name;
        const store = (0, _vegaUtil.stringValue)(name + STORE);
        const hasSg = signals.filter((s)=>s.name === name);
        if (hasSg.length === 0) {
            const resolve = selCmpt.resolve === 'global' ? 'union' : selCmpt.resolve;
            const isPoint = selCmpt.type === 'point' ? ', true, true)' : ')';
            signals.push({
                name: selCmpt.name,
                update: `${VL_SELECTION_RESOLVE}(${store}, ${(0, _vegaUtil.stringValue)(resolve)}${isPoint}`
            });
        }
        hasSelections = true;
        for (const c of selectionCompilers)if (c.defined(selCmpt) && c.topLevelSignals) signals = c.topLevelSignals(model, selCmpt, signals);
    }
    if (hasSelections) {
        const hasUnit = signals.filter((s)=>s.name === 'unit');
        if (hasUnit.length === 0) signals.unshift({
            name: 'unit',
            value: {},
            on: [
                {
                    events: 'pointermove',
                    update: 'isTuple(group()) ? group() : unit'
                }
            ]
        });
    }
    return cleanupEmptyOnArray(signals);
}
function assembleUnitSelectionData(model, data) {
    const selectionData = [];
    const animationData = [];
    const unit = unitName(model, {
        escape: false
    });
    for (const selCmpt of vals(model.component.selection ?? {})){
        const store = {
            name: selCmpt.name + STORE
        };
        if (selCmpt.project.hasSelectionId) store.transform = [
            {
                type: 'collect',
                sort: {
                    field: SELECTION_ID
                }
            }
        ];
        if (selCmpt.init) {
            const fields = selCmpt.project.items.map(assembleProjection);
            store.values = selCmpt.project.hasSelectionId ? selCmpt.init.map((i)=>({
                    unit,
                    [SELECTION_ID]: assembleInit(i, false)[0]
                })) : selCmpt.init.map((i)=>({
                    unit,
                    fields,
                    values: assembleInit(i, false)
                }));
        }
        const contains = [
            ...selectionData,
            ...data
        ].filter((d)=>d.name === selCmpt.name + STORE);
        if (!contains.length) selectionData.push(store);
        if (isTimerSelection(selCmpt) && data.length) {
            // TODO(jzong): eventually uncomment this stuff when we want to support multi-view
            // const sourceName =
            //   model.parent && model.parent.type !== 'unit' // facet, layer, or concat
            //     ? model.parent.lookupDataSource(model.parent.getDataName(DataSourceType.Main))
            //     : model.lookupDataSource(model.getDataName(DataSourceType.Main));
            const sourceName = model.lookupDataSource(model.getDataName(DataSourceType.Main));
            const sourceData = data.find((d)=>d.name === sourceName);
            // find the filter transform for the current selection
            const sourceDataFilter = sourceData.transform.find((t)=>t.type === 'filter' && t.expr.includes('vlSelectionTest'));
            if (sourceDataFilter) {
                // remove it from the original dataset
                sourceData.transform = sourceData.transform.filter((t)=>t !== sourceDataFilter);
                // create dataset to hold current animation frame
                const currentFrame = {
                    name: sourceData.name + CURR,
                    source: sourceData.name,
                    transform: [
                        sourceDataFilter
                    ]
                };
                animationData.push(currentFrame);
            }
        }
    }
    return selectionData.concat(data, animationData);
}
function assembleUnitSelectionMarks(model, marks) {
    for (const selCmpt of vals(model.component.selection ?? {})){
        for (const c of selectionCompilers)if (c.defined(selCmpt) && c.marks) marks = c.marks(model, selCmpt, marks);
    }
    return marks;
}
function assembleLayerSelectionMarks(model, marks) {
    for (const child of model.children)if (isUnitModel(child)) marks = assembleUnitSelectionMarks(child, marks);
    return marks;
}
function assembleSelectionScaleDomain(model, extent, scaleCmpt, domain) {
    const parsedExtent = parseSelectionExtent(model, extent.param, extent);
    return {
        signal: hasContinuousDomain(scaleCmpt.get('type')) && (0, _vegaUtil.isArray)(domain) && domain[0] > domain[1] ? `isValid(${parsedExtent}) && reverse(${parsedExtent})` : parsedExtent
    };
}
function cleanupEmptyOnArray(signals) {
    return signals.map((s)=>{
        if (s.on && !s.on.length) delete s.on;
        return s;
    });
}
const scaleBindings = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'interval' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind === 'scales';
    },
    parse: (model, selCmpt)=>{
        const bound = selCmpt.scales = [];
        for (const proj of selCmpt.project.items){
            const channel = proj.channel;
            if (!isScaleChannel(channel)) continue;
            const scale = model.getScaleComponent(channel);
            const scaleType = scale ? scale.get('type') : undefined;
            if (scaleType == 'sequential') warn(SEQUENTIAL_SCALE_DEPRECATED);
            if (!scale || !hasContinuousDomain(scaleType)) {
                warn(SCALE_BINDINGS_CONTINUOUS);
                continue;
            }
            scale.set('selectionExtent', {
                param: selCmpt.name,
                field: proj.field
            }, true);
            bound.push(proj);
        }
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        const bound = selCmpt.scales.filter((proj)=>signals.filter((s)=>s.name === proj.signals.data).length === 0);
        // Top-level signals are only needed for multiview displays and if this
        // view's top-level signals haven't already been generated.
        if (!model.parent || isTopLevelLayer(model) || bound.length === 0) return signals;
        // vlSelectionResolve does not account for the behavior of bound scales in
        // multiview displays. Each unit view adds a tuple to the store, but the
        // state of the selection is the unit selection most recently updated. This
        // state is captured by the top-level signals that we insert and "push
        // outer" to from within the units. We need to reassemble this state into
        // the top-level named signal, except no single selCmpt has a global view.
        const namedSg = signals.find((s)=>s.name === selCmpt.name);
        let update = namedSg.update;
        if (update.includes(VL_SELECTION_RESOLVE)) namedSg.update = `{${bound.map((proj)=>`${(0, _vegaUtil.stringValue)(replacePathInField(proj.field))}: ${proj.signals.data}`).join(', ')}}`;
        else {
            for (const proj of bound){
                const mapping = `${(0, _vegaUtil.stringValue)(replacePathInField(proj.field))}: ${proj.signals.data}`;
                if (!update.includes(mapping)) update = `${update.substring(0, update.length - 1)}, ${mapping}}`;
            }
            namedSg.update = update;
        }
        return signals.concat(bound.map((proj)=>({
                name: proj.signals.data
            })));
    },
    signals: (model, selCmpt, signals)=>{
        // Nested signals need only push to top-level signals with multiview displays.
        if (model.parent && !isTopLevelLayer(model)) for (const proj of selCmpt.scales){
            const signal = signals.find((s)=>s.name === proj.signals.data);
            signal.push = 'outer';
            delete signal.value;
            delete signal.update;
        }
        return signals;
    }
};
function domain(model, channel) {
    const scale = (0, _vegaUtil.stringValue)(model.scaleName(channel));
    return `domain(${scale})`;
}
function isTopLevelLayer(model) {
    return model.parent && isLayerModel(model.parent) && (!model.parent.parent || isTopLevelLayer(model.parent.parent));
}
const BRUSH = '_brush';
const SCALE_TRIGGER = '_scale_trigger';
const GEO_INIT_TICK = 'geo_interval_init_tick'; // Workaround for https://github.com/vega/vega/issues/3481
const INIT = '_init';
const CENTER = '_center';
const interval = {
    defined: (selCmpt)=>selCmpt.type === 'interval',
    parse: (model, selCmpt, selDef)=>{
        if (model.hasProjection) {
            const def = {
                ...(0, _vega.isObject)(selDef.select) ? selDef.select : {}
            };
            def.fields = [
                SELECTION_ID
            ];
            if (!def.encodings) // Remap default x/y projection
            def.encodings = selDef.value ? keys(selDef.value) : [
                LONGITUDE,
                LATITUDE
            ];
            selDef.select = {
                type: 'interval',
                ...def
            };
        }
        if (selCmpt.translate && !scaleBindings.defined(selCmpt)) {
            const filterExpr = `!event.item || event.item.mark.name !== ${(0, _vegaUtil.stringValue)(selCmpt.name + BRUSH)}`;
            for (const evt of selCmpt.events){
                if (!evt.between) {
                    warn(`${evt} is not an ordered event stream for interval selections.`);
                    continue;
                }
                const filters = (0, _vegaUtil.array)(evt.between[0].filter ??= []);
                if (!filters.includes(filterExpr)) filters.push(filterExpr);
            }
        }
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const tupleSg = name + TUPLE;
        const channels = vals(selCmpt.project.hasChannel).filter((p)=>p.channel === X || p.channel === Y);
        const init = selCmpt.init ? selCmpt.init[0] : null;
        signals.push(...channels.reduce((arr, proj)=>arr.concat(channelSignals(model, selCmpt, proj, init?.[proj.index])), []));
        if (!model.hasProjection) {
            // Proxy scale reactions to ensure that an infinite loop doesn't occur
            // when an interval selection filter touches the scale.
            if (!scaleBindings.defined(selCmpt)) {
                const triggerSg = name + SCALE_TRIGGER;
                const scaleTriggers = channels.map((proj)=>{
                    const channel = proj.channel;
                    const { data: dname, visual: vname } = proj.signals;
                    const scaleName = (0, _vegaUtil.stringValue)(model.scaleName(channel));
                    const scaleType = model.getScaleComponent(channel).get('type');
                    const toNum = hasContinuousDomain(scaleType) ? '+' : '';
                    return `(!isArray(${dname}) || ` + `(${toNum}invert(${scaleName}, ${vname})[0] === ${toNum}${dname}[0] && ` + `${toNum}invert(${scaleName}, ${vname})[1] === ${toNum}${dname}[1]))`;
                });
                if (scaleTriggers.length) signals.push({
                    name: triggerSg,
                    value: {},
                    on: [
                        {
                            events: channels.map((proj)=>({
                                    scale: model.scaleName(proj.channel)
                                })),
                            update: `${scaleTriggers.join(' && ')} ? ${triggerSg} : {}`
                        }
                    ]
                });
            }
            // Only add an interval to the store if it has valid data extents. Data extents
            // are set to null if pixel extents are equal to account for intervals over
            // ordinal/nominal domains which, when inverted, will still produce a valid datum.
            const dataSignals = channels.map((proj)=>proj.signals.data);
            const update = `unit: ${unitName(model)}, fields: ${name + TUPLE_FIELDS}, values`;
            return signals.concat({
                name: tupleSg,
                ...init ? {
                    init: `{${update}: ${assembleInit(init)}}`
                } : {},
                ...dataSignals.length ? {
                    on: [
                        {
                            events: [
                                {
                                    signal: dataSignals.join(' || ')
                                }
                            ],
                            update: `${dataSignals.join(' && ')} ? {${update}: [${dataSignals}]} : null`
                        }
                    ]
                } : {}
            });
        } else {
            const projection = (0, _vegaUtil.stringValue)(model.projectionName());
            const centerSg = model.projectionName() + CENTER;
            const { x, y } = selCmpt.project.hasChannel;
            const xvname = x?.signals.visual;
            const yvname = y?.signals.visual;
            const xinit = x ? init?.[x.index] : `${centerSg}[0]`;
            const yinit = y ? init?.[y.index] : `${centerSg}[1]`;
            const sizeSg = (layout)=>model.getSizeSignalRef(layout).signal;
            const bbox = `[` + `[${xvname ? `${xvname}[0]` : '0'}, ${yvname ? `${yvname}[0]` : '0'}],` + `[${xvname ? `${xvname}[1]` : sizeSg('width')}, ` + `${yvname ? `${yvname}[1]` : sizeSg('height')}]` + `]`;
            if (init) {
                signals.unshift({
                    name: name + INIT,
                    init: `[scale(${projection}, [${x ? xinit[0] : xinit}, ${y ? yinit[0] : yinit}]), ` + `scale(${projection}, [${x ? xinit[1] : xinit}, ${y ? yinit[1] : yinit}])]`
                });
                if (!x || !y) {
                    // If initializing a uni-dimensional brush, use the center of the view to determine the other coord
                    const hasCenterSg = signals.find((s)=>s.name === centerSg);
                    if (!hasCenterSg) signals.unshift({
                        name: centerSg,
                        update: `invert(${projection}, [${sizeSg('width')}/2, ${sizeSg('height')}/2])`
                    });
                }
            }
            const intersect = `intersect(${bbox}, {markname: ${(0, _vegaUtil.stringValue)(model.getName('marks'))}}, unit.mark)`;
            const base = `{unit: ${unitName(model)}}`;
            const update = `vlSelectionTuples(${intersect}, ${base})`;
            const visualSignals = channels.map((proj)=>proj.signals.visual);
            return signals.concat({
                name: tupleSg,
                on: [
                    {
                        events: [
                            ...visualSignals.length ? [
                                {
                                    signal: visualSignals.join(' || ')
                                }
                            ] : [],
                            ...init ? [
                                {
                                    signal: GEO_INIT_TICK
                                }
                            ] : []
                        ],
                        update
                    }
                ]
            });
        }
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        if (isUnitModel(model) && model.hasProjection && selCmpt.init) {
            // Workaround for https://github.com/vega/vega/issues/3481
            // The scenegraph isn't populated on the first pulse. So we use a timer signal
            // to re-pulse the dataflow as soon as possible. We return an object to ensure
            // this only occurs once.
            const hasTick = signals.filter((s)=>s.name === GEO_INIT_TICK);
            if (!hasTick.length) signals.unshift({
                name: GEO_INIT_TICK,
                value: null,
                on: [
                    {
                        events: 'timer{1}',
                        update: `${GEO_INIT_TICK} === null ? {} : ${GEO_INIT_TICK}`
                    }
                ]
            });
        }
        return signals;
    },
    marks: (model, selCmpt, marks)=>{
        const name = selCmpt.name;
        const { x, y } = selCmpt.project.hasChannel;
        const xvname = x?.signals.visual;
        const yvname = y?.signals.visual;
        const store = `data(${(0, _vegaUtil.stringValue)(selCmpt.name + STORE)})`;
        // Do not add a brush if we're binding to scales
        // or we don't have a valid interval projection
        if (scaleBindings.defined(selCmpt) || !x && !y) return marks;
        const update = {
            x: x !== undefined ? {
                signal: `${xvname}[0]`
            } : {
                value: 0
            },
            y: y !== undefined ? {
                signal: `${yvname}[0]`
            } : {
                value: 0
            },
            x2: x !== undefined ? {
                signal: `${xvname}[1]`
            } : {
                field: {
                    group: 'width'
                }
            },
            y2: y !== undefined ? {
                signal: `${yvname}[1]`
            } : {
                field: {
                    group: 'height'
                }
            }
        };
        // If the selection is resolved to global, only a single interval is in
        // the store. Wrap brush mark's encodings with a production rule to test
        // this based on the `unit` property. Hide the brush mark if it corresponds
        // to a unit different from the one in the store.
        if (selCmpt.resolve === 'global') for (const key of keys(update))update[key] = [
            {
                test: `${store}.length && ${store}[0].unit === ${unitName(model)}`,
                ...update[key]
            },
            {
                value: 0
            }
        ];
        // Two brush marks ensure that fill colors and other aesthetic choices do
        // not interefere with the core marks, but that the brushed region can still
        // be interacted with (e.g., dragging it around).
        const { fill, fillOpacity, cursor, ...stroke } = selCmpt.mark;
        const vgStroke = keys(stroke).reduce((def, k)=>{
            def[k] = [
                {
                    test: [
                        x !== undefined && `${xvname}[0] !== ${xvname}[1]`,
                        y !== undefined && `${yvname}[0] !== ${yvname}[1]`
                    ].filter((t)=>t).join(' && '),
                    value: stroke[k]
                },
                {
                    value: null
                }
            ];
            return def;
        }, {});
        // Set cursor to move unless the brush cannot be translated
        const vgCursor = cursor ?? (selCmpt.translate ? 'move' : null);
        return [
            {
                name: `${name + BRUSH}_bg`,
                type: 'rect',
                clip: true,
                encode: {
                    enter: {
                        fill: {
                            value: fill
                        },
                        fillOpacity: {
                            value: fillOpacity
                        }
                    },
                    update
                }
            },
            ...marks,
            {
                name: name + BRUSH,
                type: 'rect',
                clip: true,
                encode: {
                    enter: {
                        ...vgCursor ? {
                            cursor: {
                                value: vgCursor
                            }
                        } : {},
                        fill: {
                            value: 'transparent'
                        }
                    },
                    update: {
                        ...update,
                        ...vgStroke
                    }
                }
            }
        ];
    }
};
/**
 * Returns the visual and data signals for an interval selection.
 */ function channelSignals(model, selCmpt, proj, init) {
    const scaledInterval = !model.hasProjection;
    const channel = proj.channel;
    const vname = proj.signals.visual;
    const scaleName = (0, _vegaUtil.stringValue)(scaledInterval ? model.scaleName(channel) : model.projectionName());
    const scaled = (str)=>`scale(${scaleName}, ${str})`;
    const size = model.getSizeSignalRef(channel === X ? 'width' : 'height').signal;
    const coord = `${channel}(unit)`;
    const von = selCmpt.events.reduce((def, evt)=>{
        return [
            ...def,
            {
                events: evt.between[0],
                update: `[${coord}, ${coord}]`
            },
            {
                events: evt,
                update: `[${vname}[0], clamp(${coord}, 0, ${size})]`
            }
        ];
    }, []);
    if (scaledInterval) {
        const dname = proj.signals.data;
        const hasScales = scaleBindings.defined(selCmpt);
        const scale = model.getScaleComponent(channel);
        const scaleType = scale ? scale.get('type') : undefined;
        const vinit = init ? {
            init: assembleInit(init, true, scaled)
        } : {
            value: []
        };
        // React to pan/zooms of continuous scales. Non-continuous scales
        // (band, point) cannot be pan/zoomed and any other changes
        // to their domains (e.g., filtering) should clear the brushes.
        von.push({
            events: {
                signal: selCmpt.name + SCALE_TRIGGER
            },
            update: hasContinuousDomain(scaleType) ? `[${scaled(`${dname}[0]`)}, ${scaled(`${dname}[1]`)}]` : `[0, 0]`
        });
        return hasScales ? [
            {
                name: dname,
                on: []
            }
        ] : [
            {
                name: vname,
                ...vinit,
                on: von
            },
            {
                name: dname,
                ...init ? {
                    init: assembleInit(init)
                } : {},
                on: [
                    {
                        events: {
                            signal: vname
                        },
                        update: `${vname}[0] === ${vname}[1] ? null : invert(${scaleName}, ${vname})`
                    }
                ]
            }
        ];
    } else {
        const initIdx = channel === X ? 0 : 1;
        const initSg = selCmpt.name + INIT;
        const vinit = init ? {
            init: `[${initSg}[0][${initIdx}], ${initSg}[1][${initIdx}]]`
        } : {
            value: []
        };
        return [
            {
                name: vname,
                ...vinit,
                on: von
            }
        ];
    }
}
/**
 * Return a VgEncodeEntry that includes a Vega production rule for a scale channel's encoding or guide encoding, which includes:
 * (1) the conditional rules (if provided as part of channelDef)
 * (2) invalidValueRef for handling invalid values (if provided as a parameter of this method)
 * (3) main reference for the encoded data.
 */ function wrapCondition({ model, channelDef, vgChannel, invalidValueRef, mainRefFn }) {
    const condition = isConditionalDef(channelDef) && channelDef.condition;
    let valueRefs = [];
    if (condition) {
        const conditions = (0, _vegaUtil.array)(condition);
        valueRefs = conditions.map((c)=>{
            const conditionValueRef = mainRefFn(c);
            if (isConditionalParameter(c)) {
                const { param, empty } = c;
                const test = parseSelectionPredicate(model, {
                    param,
                    empty
                });
                return {
                    test,
                    ...conditionValueRef
                };
            } else {
                const test = expression(model, c.test); // FIXME: remove casting once TS is no longer dumb about it
                return {
                    test,
                    ...conditionValueRef
                };
            }
        });
    }
    if (invalidValueRef !== undefined) valueRefs.push(invalidValueRef);
    const mainValueRef = mainRefFn(channelDef);
    if (mainValueRef !== undefined) valueRefs.push(mainValueRef);
    if (valueRefs.length > 1 || valueRefs.length === 1 && Boolean(valueRefs[0].test) // We must use array form valueRefs if test exists, otherwise Vega won't execute the test.
    ) return {
        [vgChannel]: valueRefs
    };
    else if (valueRefs.length === 1) return {
        [vgChannel]: valueRefs[0]
    };
    return {};
}
function text$1(model, channel = 'text') {
    const channelDef = model.encoding[channel];
    return wrapCondition({
        model,
        channelDef,
        vgChannel: channel,
        mainRefFn: (cDef)=>textRef(cDef, model.config),
        invalidValueRef: undefined
    });
}
function textRef(channelDef, config, expr = 'datum') {
    // text
    if (channelDef) {
        if (isValueDef(channelDef)) return signalOrValueRef(channelDef.value);
        if (isFieldOrDatumDef(channelDef)) {
            const { format, formatType } = getFormatMixins(channelDef);
            return formatSignalRef({
                fieldOrDatumDef: channelDef,
                format,
                formatType,
                expr,
                config
            });
        }
    }
    return undefined;
}
function tooltip(model, opt = {}) {
    const { encoding, markDef, config, stack } = model;
    const channelDef = encoding.tooltip;
    if ((0, _vegaUtil.isArray)(channelDef)) return {
        tooltip: tooltipRefForEncoding({
            tooltip: channelDef
        }, stack, config, opt)
    };
    else {
        const datum = opt.reactiveGeom ? 'datum.datum' : 'datum';
        const mainRefFn = (cDef)=>{
            // use valueRef based on channelDef first
            const tooltipRefFromChannelDef = textRef(cDef, config, datum);
            if (tooltipRefFromChannelDef) return tooltipRefFromChannelDef;
            if (cDef === null) // Allow using encoding.tooltip = null to disable tooltip
            return undefined;
            let markTooltip = getMarkPropOrConfig('tooltip', markDef, config);
            if (markTooltip === true) markTooltip = {
                content: 'encoding'
            };
            if ((0, _vegaUtil.isString)(markTooltip)) return {
                value: markTooltip
            };
            else if ((0, _vegaUtil.isObject)(markTooltip)) {
                // `tooltip` is `{fields: 'encodings' | 'fields'}`
                if (isSignalRef(markTooltip)) return markTooltip;
                else if (markTooltip.content === 'encoding') return tooltipRefForEncoding(encoding, stack, config, opt);
                else return {
                    signal: datum
                };
            }
            return undefined;
        };
        return wrapCondition({
            model,
            channelDef,
            vgChannel: 'tooltip',
            mainRefFn,
            invalidValueRef: undefined
        });
    }
}
function tooltipData(encoding, stack, config, { reactiveGeom } = {}) {
    const formatConfig = {
        ...config,
        ...config.tooltipFormat
    };
    const toSkip = new Set();
    const expr = reactiveGeom ? 'datum.datum' : 'datum';
    const tuples = [];
    function add(fDef, channel) {
        const mainChannel = getMainRangeChannel(channel);
        const fieldDef = isTypedFieldDef(fDef) ? fDef : {
            ...fDef,
            type: encoding[mainChannel].type
        };
        const title = fieldDef.title || defaultTitle(fieldDef, formatConfig);
        const key = (0, _vegaUtil.array)(title).join(', ').replaceAll(/"/g, '\\"');
        let value;
        if (isXorY(channel)) {
            const channel2 = channel === 'x' ? 'x2' : 'y2';
            const fieldDef2 = getFieldDef(encoding[channel2]);
            if (isBinned(fieldDef.bin) && fieldDef2) {
                const startField = vgField(fieldDef, {
                    expr
                });
                const endField = vgField(fieldDef2, {
                    expr
                });
                const { format, formatType } = getFormatMixins(fieldDef);
                value = binFormatExpression(startField, endField, format, formatType, formatConfig);
                toSkip.add(channel2);
            }
        }
        if ((isXorY(channel) || channel === THETA || channel === RADIUS) && stack && stack.fieldChannel === channel && stack.offset === 'normalize') {
            const { format, formatType } = getFormatMixins(fieldDef);
            value = formatSignalRef({
                fieldOrDatumDef: fieldDef,
                format,
                formatType,
                expr,
                config: formatConfig,
                normalizeStack: true
            }).signal;
        }
        value ??= textRef(fieldDef, formatConfig, expr).signal;
        tuples.push({
            channel,
            key,
            value
        });
    }
    forEach(encoding, (channelDef, channel)=>{
        if (isFieldDef(channelDef)) add(channelDef, channel);
        else if (hasConditionalFieldDef(channelDef)) add(channelDef.condition, channel);
    });
    const out = {};
    for (const { channel, key, value } of tuples)if (!toSkip.has(channel) && !out[key]) out[key] = value;
    return out;
}
function tooltipRefForEncoding(encoding, stack, config, { reactiveGeom } = {}) {
    const data = tooltipData(encoding, stack, config, {
        reactiveGeom
    });
    const keyValues = entries$1(data).map(([key, value])=>`"${key}": ${value}`);
    return keyValues.length > 0 ? {
        signal: `{${keyValues.join(', ')}}`
    } : undefined;
}
function aria(model) {
    const { markDef, config } = model;
    const enableAria = getMarkPropOrConfig('aria', markDef, config);
    // We can ignore other aria properties if ariaHidden is true.
    if (enableAria === false) // getMarkGroups sets aria to false already so we don't have to set it in the encode block
    return {};
    return {
        ...enableAria ? {
            aria: enableAria
        } : {},
        ...ariaRoleDescription(model),
        ...description(model)
    };
}
function ariaRoleDescription(model) {
    const { mark, markDef, config } = model;
    if (config.aria === false) return {};
    const ariaRoleDesc = getMarkPropOrConfig('ariaRoleDescription', markDef, config);
    if (ariaRoleDesc != null) return {
        ariaRoleDescription: {
            value: ariaRoleDesc
        }
    };
    return (0, _vegaUtil.hasOwnProperty)(VG_MARK_INDEX, mark) ? {} : {
        ariaRoleDescription: {
            value: mark
        }
    };
}
function description(model) {
    const { encoding, markDef, config, stack } = model;
    const channelDef = encoding.description;
    if (channelDef) return wrapCondition({
        model,
        channelDef,
        vgChannel: 'description',
        mainRefFn: (cDef)=>textRef(cDef, model.config),
        invalidValueRef: undefined
    });
    // Use default from mark def or config if defined.
    // Functions in encode usually just return undefined but since we are defining a default below, we need to check the default here.
    const descriptionValue = getMarkPropOrConfig('description', markDef, config);
    if (descriptionValue != null) return {
        description: signalOrValueRef(descriptionValue)
    };
    if (config.aria === false) return {};
    const data = tooltipData(encoding, stack, config);
    if (isEmpty(data)) return undefined;
    return {
        description: {
            signal: entries$1(data).map(([key, value], index)=>`"${index > 0 ? '; ' : ''}${key}: " + (${value})`).join(' + ')
        }
    };
}
/**
 * Return encode for non-positional channels with scales. (Text doesn't have scale.)
 */ function nonPosition(channel, model, opt = {}) {
    const { markDef, encoding, config } = model;
    const { vgChannel } = opt;
    let { defaultRef, defaultValue } = opt;
    const channelDef = encoding[channel];
    if (defaultRef === undefined) {
        // prettier-ignore
        defaultValue ??= getMarkPropOrConfig(channel, markDef, config, {
            vgChannel,
            // If there is no conditonal def, we ignore vgConfig so the output spec is concise.
            // However, if there is a conditional def, we must include vgConfig so the default is respected.
            ignoreVgConfig: !isConditionalDef(channelDef)
        });
        if (defaultValue !== undefined) defaultRef = signalOrValueRef(defaultValue);
    }
    const commonProps = {
        markDef,
        config,
        scaleName: model.scaleName(channel),
        scale: model.getScaleComponent(channel)
    };
    const invalidValueRef = getConditionalValueRefForIncludingInvalidValue({
        ...commonProps,
        scaleChannel: channel,
        channelDef
    });
    const mainRefFn = (cDef)=>{
        return midPoint({
            ...commonProps,
            channel,
            channelDef: cDef,
            stack: null,
            defaultRef
        });
    };
    return wrapCondition({
        model,
        channelDef,
        vgChannel: vgChannel ?? channel,
        invalidValueRef,
        mainRefFn
    });
}
function color(model, opt = {
    filled: undefined
}) {
    const { markDef, encoding, config } = model;
    const { type: markType } = markDef;
    // Allow filled to be overridden (for trail's "filled")
    const filled = opt.filled ?? getMarkPropOrConfig('filled', markDef, config);
    const transparentIfNeeded = contains([
        'bar',
        'point',
        'circle',
        'square',
        'geoshape'
    ], markType) ? 'transparent' : undefined;
    const defaultFill = getMarkPropOrConfig(filled === true ? 'color' : undefined, markDef, config, {
        vgChannel: 'fill'
    }) ?? // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
    config.mark[filled === true && 'color'] ?? // If there is no fill, always fill symbols, bar, geoshape
    // with transparent fills https://github.com/vega/vega-lite/issues/1316
    transparentIfNeeded;
    const defaultStroke = getMarkPropOrConfig(filled === false ? 'color' : undefined, markDef, config, {
        vgChannel: 'stroke'
    }) ?? // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
    config.mark[filled === false && 'color'];
    const colorVgChannel = filled ? 'fill' : 'stroke';
    const fillStrokeMarkDefAndConfig = {
        ...defaultFill ? {
            fill: signalOrValueRef(defaultFill)
        } : {},
        ...defaultStroke ? {
            stroke: signalOrValueRef(defaultStroke)
        } : {}
    };
    if (markDef.color && (filled ? markDef.fill : markDef.stroke)) warn(droppingColor('property', {
        fill: 'fill' in markDef,
        stroke: 'stroke' in markDef
    }));
    return {
        ...fillStrokeMarkDefAndConfig,
        ...nonPosition('color', model, {
            vgChannel: colorVgChannel,
            defaultValue: filled ? defaultFill : defaultStroke
        }),
        ...nonPosition('fill', model, {
            // if there is encoding.fill, include default fill just in case we have conditional-only fill encoding
            defaultValue: encoding.fill ? defaultFill : undefined
        }),
        ...nonPosition('stroke', model, {
            // if there is encoding.stroke, include default fill just in case we have conditional-only stroke encoding
            defaultValue: encoding.stroke ? defaultStroke : undefined
        })
    };
}
function zindex(model) {
    const { encoding, mark } = model;
    const order = encoding.order;
    if (!isPathMark(mark) && isValueDef(order)) return wrapCondition({
        model,
        channelDef: order,
        vgChannel: 'zindex',
        mainRefFn: (cd)=>signalOrValueRef(cd.value),
        invalidValueRef: undefined
    });
    return {};
}
function positionOffset({ channel: baseChannel, markDef, encoding = {}, model, bandPosition }) {
    const channel = `${baseChannel}Offset`; // Need to cast as the type can't be inferred automatically
    const defaultValue = markDef[channel];
    // FIXME: remove as any
    const channelDef = encoding[channel];
    if ((channel === 'xOffset' || channel === 'yOffset') && channelDef) {
        const ref = midPoint({
            channel: channel,
            channelDef,
            markDef,
            config: model?.config,
            scaleName: model.scaleName(channel),
            scale: model.getScaleComponent(channel),
            stack: null,
            defaultRef: signalOrValueRef(defaultValue),
            bandPosition
        });
        return {
            offsetType: 'encoding',
            offset: ref
        };
    }
    const markDefOffsetValue = markDef[channel];
    if (markDefOffsetValue) return {
        offsetType: 'visual',
        offset: markDefOffsetValue
    };
    return {};
}
/**
 * Return encode for point (non-band) position channels.
 */ function pointPosition(channel, model, { defaultPos, vgChannel }) {
    const { encoding, markDef, config, stack } = model;
    const channelDef = encoding[channel];
    const channel2Def = encoding[getSecondaryRangeChannel(channel)];
    const scaleName = model.scaleName(channel);
    const scale = model.getScaleComponent(channel);
    const { offset, offsetType } = positionOffset({
        channel,
        markDef,
        encoding,
        model,
        bandPosition: 0.5
    });
    // Get default position or position from mark def
    const defaultRef = pointPositionDefaultRef({
        model,
        defaultPos,
        channel,
        scaleName,
        scale
    });
    const valueRef = !channelDef && isXorY(channel) && (encoding.latitude || encoding.longitude) ? {
        field: model.getName(channel)
    } : positionRef({
        channel,
        channelDef,
        channel2Def,
        markDef,
        config,
        scaleName,
        scale,
        stack,
        offset,
        defaultRef,
        bandPosition: offsetType === 'encoding' ? 0 : undefined
    });
    return valueRef ? {
        [vgChannel || channel]: valueRef
    } : undefined;
}
// TODO: we need to find a way to refactor these so that scaleName is a part of scale
// but that's complicated. For now, this is a huge step moving forward.
/**
 * @return Vega ValueRef for normal x- or y-position without projection
 */ function positionRef(params) {
    const { channel, channelDef, scaleName, stack, offset, markDef } = params;
    // This isn't a part of midPoint because we use midPoint for non-position too
    if (isFieldOrDatumDef(channelDef) && stack && channel === stack.fieldChannel) {
        if (isFieldDef(channelDef)) {
            let bandPosition = channelDef.bandPosition;
            if (bandPosition === undefined && markDef.type === 'text' && (channel === 'radius' || channel === 'theta')) // theta and radius of text mark should use bandPosition = 0.5 by default
            // so that labels for arc marks are centered automatically
            bandPosition = 0.5;
            if (bandPosition !== undefined) return interpolatedSignalRef({
                scaleName,
                fieldOrDatumDef: channelDef,
                startSuffix: 'start',
                bandPosition,
                offset
            });
        }
        // x or y use stack_end so that stacked line's point mark use stack_end too.
        return valueRefForFieldOrDatumDef(channelDef, scaleName, {
            suffix: 'end'
        }, {
            offset
        });
    }
    return midPointRefWithPositionInvalidTest(params);
}
function pointPositionDefaultRef({ model, defaultPos, channel, scaleName, scale }) {
    const { markDef, config } = model;
    return ()=>{
        const mainChannel = getMainRangeChannel(channel);
        const vgChannel = getVgPositionChannel(channel);
        const definedValueOrConfig = getMarkPropOrConfig(channel, markDef, config, {
            vgChannel
        });
        if (definedValueOrConfig !== undefined) return widthHeightValueOrSignalRef(channel, definedValueOrConfig);
        switch(defaultPos){
            case 'zeroOrMin':
                return zeroOrMinOrMaxPosition({
                    scaleName,
                    scale,
                    mode: 'zeroOrMin',
                    mainChannel,
                    config
                });
            case 'zeroOrMax':
                return zeroOrMinOrMaxPosition({
                    scaleName,
                    scale,
                    mode: {
                        zeroOrMax: {
                            widthSignal: model.width.signal,
                            heightSignal: model.height.signal
                        }
                    },
                    mainChannel,
                    config
                });
            case 'mid':
                {
                    const sizeRef = model[getSizeChannel(channel)];
                    return {
                        ...sizeRef,
                        mult: 0.5
                    };
                }
        }
        // defaultPos === null
        return undefined;
    };
}
function zeroOrMinOrMaxPosition({ mainChannel, config, ...otherProps }) {
    const scaledValueRef = scaledZeroOrMinOrMax(otherProps);
    const { mode } = otherProps;
    if (scaledValueRef) return scaledValueRef;
    switch(mainChannel){
        case 'radius':
            {
                if (mode === 'zeroOrMin') return {
                    value: 0
                }; // min value
                const { widthSignal, heightSignal } = mode.zeroOrMax;
                // max of radius is min(width, height) / 2
                return {
                    signal: `min(${widthSignal},${heightSignal})/2`
                };
            }
        case 'theta':
            return mode === 'zeroOrMin' ? {
                value: 0
            } : {
                signal: '2*PI'
            };
        case 'x':
            return mode === 'zeroOrMin' ? {
                value: 0
            } : {
                field: {
                    group: 'width'
                }
            };
        case 'y':
            return mode === 'zeroOrMin' ? {
                field: {
                    group: 'height'
                }
            } : {
                value: 0
            };
    }
}
const ALIGNED_X_CHANNEL = {
    left: 'x',
    center: 'xc',
    right: 'x2'
};
const BASELINED_Y_CHANNEL = {
    top: 'y',
    middle: 'yc',
    bottom: 'y2'
};
function vgAlignedPositionChannel(channel, markDef, config, defaultAlign = 'middle') {
    if (channel === 'radius' || channel === 'theta') return getVgPositionChannel(channel);
    const alignChannel = channel === 'x' ? 'align' : 'baseline';
    const align = getMarkPropOrConfig(alignChannel, markDef, config);
    let alignExcludingSignal;
    if (isSignalRef(align)) {
        warn(rangeMarkAlignmentCannotBeExpression(alignChannel));
        alignExcludingSignal = undefined;
    } else alignExcludingSignal = align;
    // FIXME: remove as any
    if (channel === 'x') return ALIGNED_X_CHANNEL[alignExcludingSignal || (defaultAlign === 'top' ? 'left' : 'center')];
    else return BASELINED_Y_CHANNEL[alignExcludingSignal || defaultAlign];
}
/**
 * Utility for area/rule position, which can be either point or range.
 * (One of the axes should be point and the other should be range.)
 */ function pointOrRangePosition(channel, model, { defaultPos, defaultPos2, range }) {
    if (range) return rangePosition(channel, model, {
        defaultPos,
        defaultPos2
    });
    return pointPosition(channel, model, {
        defaultPos
    });
}
function rangePosition(channel, model, { defaultPos, defaultPos2 }) {
    const { markDef, config } = model;
    const channel2 = getSecondaryRangeChannel(channel);
    const sizeChannel = getSizeChannel(channel);
    const pos2Mixins = pointPosition2OrSize(model, defaultPos2, channel2);
    const vgChannel = pos2Mixins[sizeChannel] ? vgAlignedPositionChannel(channel, markDef, config) : getVgPositionChannel(channel);
    return {
        ...pointPosition(channel, model, {
            defaultPos,
            vgChannel
        }),
        ...pos2Mixins
    };
}
/**
 * Return encode for x2, y2.
 * If channel is not specified, return one channel based on orientation.
 */ function pointPosition2OrSize(model, defaultPos, channel) {
    const { encoding, mark, markDef, stack, config } = model;
    const baseChannel = getMainRangeChannel(channel);
    const sizeChannel = getSizeChannel(channel);
    const vgChannel = getVgPositionChannel(channel);
    const channelDef = encoding[baseChannel];
    const scaleName = model.scaleName(baseChannel);
    const scale = model.getScaleComponent(baseChannel);
    const { offset } = channel in encoding || channel in markDef ? positionOffset({
        channel,
        markDef,
        encoding,
        model
    }) : positionOffset({
        channel: baseChannel,
        markDef,
        encoding,
        model
    });
    if (!channelDef && (channel === 'x2' || channel === 'y2') && (encoding.latitude || encoding.longitude)) {
        const vgSizeChannel = getSizeChannel(channel);
        const size = model.markDef[vgSizeChannel];
        if (size != null) return {
            [vgSizeChannel]: {
                value: size
            }
        };
        else return {
            [vgChannel]: {
                field: model.getName(channel)
            }
        };
    }
    const valueRef = position2Ref({
        channel,
        channelDef,
        channel2Def: encoding[channel],
        markDef,
        config,
        scaleName,
        scale,
        stack,
        offset,
        defaultRef: undefined
    });
    if (valueRef !== undefined) return {
        [vgChannel]: valueRef
    };
    // TODO: check width/height encoding here once we add them
    // no x2/y2 encoding, then try to read x2/y2 or width/height based on precedence:
    // markDef > config.style > mark-specific config (config[mark]) > general mark config (config.mark)
    return position2orSize(channel, markDef) || position2orSize(channel, {
        [channel]: getMarkStyleConfig(channel, markDef, config.style),
        [sizeChannel]: getMarkStyleConfig(sizeChannel, markDef, config.style)
    }) || position2orSize(channel, config[mark]) || position2orSize(channel, config.mark) || {
        [vgChannel]: pointPositionDefaultRef({
            model,
            defaultPos,
            channel,
            scaleName,
            scale
        })()
    };
}
function position2Ref({ channel, channelDef, channel2Def, markDef, config, scaleName, scale, stack, offset, defaultRef }) {
    if (isFieldOrDatumDef(channelDef) && stack && // If fieldChannel is X and channel is X2 (or Y and Y2)
    channel.charAt(0) === stack.fieldChannel.charAt(0)) return valueRefForFieldOrDatumDef(channelDef, scaleName, {
        suffix: 'start'
    }, {
        offset
    });
    return midPointRefWithPositionInvalidTest({
        channel,
        channelDef: channel2Def,
        scaleName,
        scale,
        stack,
        markDef,
        config,
        offset,
        defaultRef
    });
}
function position2orSize(channel, markDef) {
    const sizeChannel = getSizeChannel(channel);
    const vgChannel = getVgPositionChannel(channel);
    if (markDef[vgChannel] !== undefined) return {
        [vgChannel]: widthHeightValueOrSignalRef(channel, markDef[vgChannel])
    };
    else if (markDef[channel] !== undefined) return {
        [vgChannel]: widthHeightValueOrSignalRef(channel, markDef[channel])
    };
    else if (markDef[sizeChannel]) {
        const dimensionSize = markDef[sizeChannel];
        if (isRelativeBandSize(dimensionSize)) warn(relativeBandSizeNotSupported(sizeChannel));
        else return {
            [sizeChannel]: widthHeightValueOrSignalRef(channel, dimensionSize)
        };
    }
    return undefined;
}
function rectPosition(model, channel) {
    const { config, encoding, markDef } = model;
    const mark = markDef.type;
    const channel2 = getSecondaryRangeChannel(channel);
    const sizeChannel = getSizeChannel(channel);
    const channelDef = encoding[channel];
    const channelDef2 = encoding[channel2];
    const scale = model.getScaleComponent(channel);
    const scaleType = scale ? scale.get('type') : undefined;
    const orient = markDef.orient;
    const hasSizeDef = encoding[sizeChannel] ?? encoding.size ?? getMarkPropOrConfig('size', markDef, config, {
        vgChannel: sizeChannel
    });
    const offsetScaleChannel = getOffsetChannel(channel);
    const isBarOrTickBand = mark === 'bar' && (channel === 'x' ? orient === 'vertical' : orient === 'horizontal') || mark === 'tick' && (channel === 'y' ? orient === 'vertical' : orient === 'horizontal');
    // x, x2, and width -- we must specify two of these in all conditions
    if (isFieldDef(channelDef) && (isBinning(channelDef.bin) || isBinned(channelDef.bin) || channelDef.timeUnit && !channelDef2) && !(hasSizeDef && !isRelativeBandSize(hasSizeDef)) && !encoding[offsetScaleChannel] && !hasDiscreteDomain(scaleType)) return rectBinPosition({
        fieldDef: channelDef,
        fieldDef2: channelDef2,
        channel,
        model
    });
    else if ((isFieldOrDatumDef(channelDef) && hasDiscreteDomain(scaleType) || isBarOrTickBand) && !channelDef2) return positionAndSize(channelDef, channel, model);
    else return rangePosition(channel, model, {
        defaultPos: 'zeroOrMax',
        defaultPos2: 'zeroOrMin'
    });
}
function defaultSizeRef(sizeChannel, scaleName, scale, config, bandSize, hasFieldDef, mark) {
    if (isRelativeBandSize(bandSize)) {
        if (scale) {
            const scaleType = scale.get('type');
            if (scaleType === 'band') {
                let bandWidth = `bandwidth('${scaleName}')`;
                if (bandSize.band !== 1) bandWidth = `${bandSize.band} * ${bandWidth}`;
                const minBandSize = getMarkConfig('minBandSize', {
                    type: mark
                }, config);
                return {
                    signal: minBandSize ? `max(${signalOrStringValue(minBandSize)}, ${bandWidth})` : bandWidth
                };
            } else if (bandSize.band !== 1) {
                warn(cannotUseRelativeBandSizeWithNonBandScale(scaleType));
                bandSize = undefined;
            }
        } else return {
            mult: bandSize.band,
            field: {
                group: sizeChannel
            }
        };
    } else if (isSignalRef(bandSize)) return bandSize;
    else if (bandSize) return {
        value: bandSize
    };
    // no valid band size
    if (scale) {
        const scaleRange = scale.get('range');
        if (isVgRangeStep(scaleRange) && (0, _vegaUtil.isNumber)(scaleRange.step)) return {
            value: scaleRange.step - 2
        };
    }
    if (!hasFieldDef) {
        const { bandPaddingInner, barBandPaddingInner, rectBandPaddingInner, tickBandPaddingInner } = config.scale;
        const padding = getFirstDefined(bandPaddingInner, mark === 'tick' ? tickBandPaddingInner : mark === 'bar' ? barBandPaddingInner : rectBandPaddingInner); // this part is like paddingInner in scale.ts
        if (isSignalRef(padding)) return {
            signal: `(1 - (${padding.signal})) * ${sizeChannel}`
        };
        else if ((0, _vegaUtil.isNumber)(padding)) return {
            signal: `${1 - padding} * ${sizeChannel}`
        };
    }
    const defaultStep = getViewConfigDiscreteStep(config.view, sizeChannel);
    return {
        value: defaultStep - 2
    };
}
/**
 * Output position encoding and its size encoding for continuous, point, and band scales.
 */ function positionAndSize(fieldDef, channel, model) {
    const { markDef, encoding, config, stack } = model;
    const orient = markDef.orient;
    const scaleName = model.scaleName(channel);
    const scale = model.getScaleComponent(channel);
    const vgSizeChannel = getSizeChannel(channel);
    const channel2 = getSecondaryRangeChannel(channel);
    const offsetScaleChannel = getOffsetChannel(channel);
    const offsetScaleName = model.scaleName(offsetScaleChannel);
    const offsetScale = model.getScaleComponent(getOffsetScaleChannel(channel));
    const useVlSizeChannel = // Always uses size channel for ticks, because tick only calls rectPosition() for the size channel
    markDef.type === 'tick' || // use "size" channel for bars, if there is orient and the channel matches the right orientation
    orient === 'horizontal' && channel === 'y' || orient === 'vertical' && channel === 'x';
    // Use size encoding / mark property / config if it exists
    let sizeMixins;
    if (encoding.size || markDef.size) {
        if (useVlSizeChannel) sizeMixins = nonPosition('size', model, {
            vgChannel: vgSizeChannel,
            defaultRef: signalOrValueRef(markDef.size)
        });
        else warn(cannotApplySizeToNonOrientedMark(markDef.type));
    }
    const hasSizeFromMarkOrEncoding = !!sizeMixins;
    // Otherwise, apply default value
    const bandSize = getBandSize({
        channel,
        fieldDef,
        markDef,
        config,
        scaleType: (scale || offsetScale)?.get('type'),
        useVlSizeChannel
    });
    sizeMixins = sizeMixins || {
        [vgSizeChannel]: defaultSizeRef(vgSizeChannel, offsetScaleName || scaleName, offsetScale || scale, config, bandSize, !!fieldDef, markDef.type)
    };
    /*
      Band scales with size value and all point scales, use xc/yc + band=0.5
  
      Otherwise (band scales that has size based on a band ref), use x/y with position band = (1 - size_band) / 2.
      In this case, size_band is the band specified in the x/y-encoding.
      By default band is 1, so `(1 - band) / 2` = 0.
      If band is 0.6, the the x/y position in such case should be `(1 - band) / 2` = 0.2
     */ const defaultBandAlign = (scale || offsetScale)?.get('type') === 'band' && isRelativeBandSize(bandSize) && !hasSizeFromMarkOrEncoding ? 'top' : 'middle';
    const vgChannel = vgAlignedPositionChannel(channel, markDef, config, defaultBandAlign);
    const center = vgChannel === 'xc' || vgChannel === 'yc';
    const { offset, offsetType } = positionOffset({
        channel,
        markDef,
        encoding,
        model,
        bandPosition: center ? 0.5 : 0
    });
    const posRef = midPointRefWithPositionInvalidTest({
        channel,
        channelDef: fieldDef,
        markDef,
        config,
        scaleName,
        scale,
        stack,
        offset,
        defaultRef: pointPositionDefaultRef({
            model,
            defaultPos: 'mid',
            channel,
            scaleName,
            scale
        }),
        bandPosition: center ? offsetType === 'encoding' ? 0 : 0.5 : isSignalRef(bandSize) ? {
            signal: `(1-${bandSize})/2`
        } : isRelativeBandSize(bandSize) ? (1 - bandSize.band) / 2 : 0
    });
    if (vgSizeChannel) return {
        [vgChannel]: posRef,
        ...sizeMixins
    };
    else {
        // otherwise, we must simulate size by setting position2 = position + size
        // (for theta/radius since Vega doesn't have thetaWidth/radiusWidth)
        const vgChannel2 = getVgPositionChannel(channel2);
        const sizeRef = sizeMixins[vgSizeChannel];
        const sizeOffset = offset ? {
            ...sizeRef,
            offset
        } : sizeRef;
        return {
            [vgChannel]: posRef,
            // posRef might be an array that wraps position invalid test
            [vgChannel2]: (0, _vegaUtil.isArray)(posRef) ? [
                posRef[0],
                {
                    ...posRef[1],
                    offset: sizeOffset
                }
            ] : {
                ...posRef,
                offset: sizeOffset
            }
        };
    }
}
function getBinSpacing(channel, spacing, reverse, axisTranslate, offset, minBandSize, bandSizeExpr) {
    if (isPolarPositionChannel(channel)) return 0;
    const isEnd = channel === 'x' || channel === 'y2';
    const spacingOffset = isEnd ? -spacing / 2 : spacing / 2;
    if (isSignalRef(reverse) || isSignalRef(offset) || isSignalRef(axisTranslate) || minBandSize) {
        const reverseExpr = signalOrStringValue(reverse);
        const offsetExpr = signalOrStringValue(offset);
        const axisTranslateExpr = signalOrStringValue(axisTranslate);
        const minBandSizeExpr = signalOrStringValue(minBandSize);
        const sign = isEnd ? '' : '-';
        const spacingAndSizeOffset = minBandSize ? `(${bandSizeExpr} < ${minBandSizeExpr} ? ${sign}0.5 * (${minBandSizeExpr} - (${bandSizeExpr})) : ${spacingOffset})` : spacingOffset;
        const t = axisTranslateExpr ? `${axisTranslateExpr} + ` : '';
        const r = reverseExpr ? `(${reverseExpr} ? -1 : 1) * ` : '';
        const o = offsetExpr ? `(${offsetExpr} + ${spacingAndSizeOffset})` : spacingAndSizeOffset;
        return {
            signal: t + r + o
        };
    } else {
        offset = offset || 0;
        // FIXME: remove this override
        // eslint-disable-next-line @typescript-eslint/no-unsafe-unary-minus
        return axisTranslate + (reverse ? -offset - spacingOffset : +offset + spacingOffset);
    }
}
function rectBinPosition({ fieldDef, fieldDef2, channel, model }) {
    const { config, markDef, encoding } = model;
    const scale = model.getScaleComponent(channel);
    const scaleName = model.scaleName(channel);
    const scaleType = scale ? scale.get('type') : undefined;
    const reverse = scale.get('reverse');
    const bandSize = getBandSize({
        channel,
        fieldDef,
        markDef,
        config,
        scaleType
    });
    const axis = model.component.axes[channel]?.[0];
    const axisTranslate = axis?.get('translate') ?? 0.5; // vega default is 0.5
    const spacing = isXorY(channel) ? getMarkPropOrConfig('binSpacing', markDef, config) ?? 0 : 0;
    const channel2 = getSecondaryRangeChannel(channel);
    const vgChannel = getVgPositionChannel(channel);
    const vgChannel2 = getVgPositionChannel(channel2);
    const minBandSize = getMarkConfig('minBandSize', markDef, config);
    const { offset } = positionOffset({
        channel,
        markDef,
        encoding,
        model,
        bandPosition: 0
    });
    const { offset: offset2 } = positionOffset({
        channel: channel2,
        markDef,
        encoding,
        model,
        bandPosition: 0
    });
    const bandSizeExpr = binSizeExpr({
        fieldDef,
        scaleName
    });
    const binSpacingOffset = getBinSpacing(channel, spacing, reverse, axisTranslate, offset, minBandSize, bandSizeExpr);
    const binSpacingOffset2 = getBinSpacing(channel2, spacing, reverse, axisTranslate, offset2 ?? offset, minBandSize, bandSizeExpr);
    const bandPositionForBandSize = isSignalRef(bandSize) ? {
        signal: `(1-${bandSize.signal})/2`
    } : isRelativeBandSize(bandSize) ? (1 - bandSize.band) / 2 : 0.5;
    const bandPosition = getBandPosition({
        fieldDef,
        fieldDef2,
        markDef,
        config
    });
    if (isBinning(fieldDef.bin) || fieldDef.timeUnit) {
        const useRectOffsetField = fieldDef.timeUnit && bandPosition !== 0.5;
        return {
            [vgChannel2]: rectBinRef({
                fieldDef,
                scaleName,
                bandPosition: bandPositionForBandSize,
                offset: binSpacingOffset2,
                useRectOffsetField
            }),
            [vgChannel]: rectBinRef({
                fieldDef,
                scaleName,
                bandPosition: isSignalRef(bandPositionForBandSize) ? {
                    signal: `1-${bandPositionForBandSize.signal}`
                } : 1 - bandPositionForBandSize,
                offset: binSpacingOffset,
                useRectOffsetField
            })
        };
    } else if (isBinned(fieldDef.bin)) {
        const startRef = valueRefForFieldOrDatumDef(fieldDef, scaleName, {}, {
            offset: binSpacingOffset2
        });
        if (isFieldDef(fieldDef2)) return {
            [vgChannel2]: startRef,
            [vgChannel]: valueRefForFieldOrDatumDef(fieldDef2, scaleName, {}, {
                offset: binSpacingOffset
            })
        };
        else if (isBinParams(fieldDef.bin) && fieldDef.bin.step) return {
            [vgChannel2]: startRef,
            [vgChannel]: {
                signal: `scale("${scaleName}", ${vgField(fieldDef, {
                    expr: 'datum'
                })} + ${fieldDef.bin.step})`,
                offset: binSpacingOffset
            }
        };
    }
    warn(channelRequiredForBinned(channel2));
    return undefined;
}
/**
 * Value Ref for binned fields
 */ function rectBinRef({ fieldDef, scaleName, bandPosition, offset, useRectOffsetField }) {
    return interpolatedSignalRef({
        scaleName,
        fieldOrDatumDef: fieldDef,
        bandPosition,
        offset,
        ...useRectOffsetField ? {
            startSuffix: OFFSETTED_RECT_START_SUFFIX,
            endSuffix: OFFSETTED_RECT_END_SUFFIX
        } : {}
    });
}
const ALWAYS_IGNORE = new Set([
    'aria',
    'width',
    'height'
]);
function baseEncodeEntry(model, ignore) {
    const { fill, stroke } = ignore.color === 'include' ? color(model) : {};
    return {
        ...markDefProperties(model.markDef, ignore),
        ...colorRef('fill', fill),
        ...colorRef('stroke', stroke),
        ...nonPosition('opacity', model),
        ...nonPosition('fillOpacity', model),
        ...nonPosition('strokeOpacity', model),
        ...nonPosition('strokeWidth', model),
        ...nonPosition('strokeDash', model),
        ...zindex(model),
        ...tooltip(model),
        ...text$1(model, 'href'),
        ...aria(model)
    };
}
function colorRef(channel, valueRef) {
    return valueRef ? {
        [channel]: valueRef
    } : {};
}
function markDefProperties(mark, ignore) {
    return VG_MARK_CONFIGS.reduce((m, prop)=>{
        if (!ALWAYS_IGNORE.has(prop) && hasProperty(mark, prop) && ignore[prop] !== 'ignore') m[prop] = signalOrValueRef(mark[prop]);
        return m;
    }, {});
}
/**
 * Create Vega's "defined" encoding to break paths in a path mark for invalid values.
 */ function defined(model) {
    const { config, markDef } = model;
    // For each channel (x/y), add fields to break path to a set first.
    const fieldsToBreakPath = new Set();
    model.forEachFieldDef((fieldDef, channel)=>{
        let scaleType;
        if (!isScaleChannel(channel) || !(scaleType = model.getScaleType(channel))) // Skip if the channel is not a scale channel or does not have a scale
        return;
        const isCountAggregate = isCountingAggregateOp(fieldDef.aggregate);
        const invalidDataMode = getScaleInvalidDataMode({
            scaleChannel: channel,
            markDef,
            config,
            scaleType,
            isCountAggregate
        });
        if (shouldBreakPath(invalidDataMode)) {
            const field = model.vgField(channel, {
                expr: 'datum',
                binSuffix: model.stack?.impute ? 'mid' : undefined
            });
            if (field) fieldsToBreakPath.add(field);
        }
    });
    // If the set is not empty, return a defined signal.
    if (fieldsToBreakPath.size > 0) {
        const signal = [
            ...fieldsToBreakPath
        ].map((field)=>fieldValidPredicate(field, true)).join(' && ');
        return {
            defined: {
                signal
            }
        };
    }
    return undefined;
}
function valueIfDefined(prop, value) {
    if (value !== undefined) return {
        [prop]: signalOrValueRef(value)
    };
    return undefined;
}
const VORONOI = 'voronoi';
const nearest = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'point' && selCmpt.nearest;
    },
    parse: (model, selCmpt)=>{
        // Scope selection events to the voronoi mark to prevent capturing
        // events that occur on the group mark (https://github.com/vega/vega/issues/2112).
        if (selCmpt.events) for (const s of selCmpt.events)s.markname = model.getName(VORONOI);
    },
    marks: (model, selCmpt, marks)=>{
        const { x, y } = selCmpt.project.hasChannel;
        const markType = model.mark;
        if (isPathMark(markType)) {
            warn(nearestNotSupportForContinuous(markType));
            return marks;
        }
        const cellDef = {
            name: model.getName(VORONOI),
            type: 'path',
            interactive: true,
            from: {
                data: model.getName('marks')
            },
            encode: {
                update: {
                    fill: {
                        value: 'transparent'
                    },
                    strokeWidth: {
                        value: 0.35
                    },
                    stroke: {
                        value: 'transparent'
                    },
                    isVoronoi: {
                        value: true
                    },
                    ...tooltip(model, {
                        reactiveGeom: true
                    })
                }
            },
            transform: [
                {
                    type: 'voronoi',
                    x: {
                        expr: x || !y ? 'datum.datum.x || 0' : '0'
                    },
                    y: {
                        expr: y || !x ? 'datum.datum.y || 0' : '0'
                    },
                    size: [
                        model.getSizeSignalRef('width'),
                        model.getSizeSignalRef('height')
                    ]
                }
            ]
        };
        let index = 0;
        let exists = false;
        marks.forEach((mark, i)=>{
            const name = mark.name ?? '';
            if (name === model.component.mark[0].name) index = i;
            else if (name.includes(VORONOI)) exists = true;
        });
        if (!exists) marks.splice(index + 1, 0, cellDef);
        return marks;
    }
};
const inputBindings = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'point' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind !== 'scales' && !isLegendBinding(selCmpt.bind);
    },
    parse: (model, selCmpt, selDef)=>disableDirectManipulation(selCmpt, selDef),
    topLevelSignals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project;
        const bind = selCmpt.bind;
        const init = selCmpt.init?.[0]; // Can only exist on single selections (one initial value).
        const datum = nearest.defined(selCmpt) ? '(item().isVoronoi ? datum.datum : datum)' : 'datum';
        proj.items.forEach((p, i)=>{
            const sgname = varName(`${name}_${p.field}`);
            const hasSignal = signals.filter((s)=>s.name === sgname);
            if (!hasSignal.length) signals.unshift({
                name: sgname,
                ...init ? {
                    init: assembleInit(init[i])
                } : {
                    value: null
                },
                on: selCmpt.events ? [
                    {
                        events: selCmpt.events,
                        update: `datum && item().mark.marktype !== 'group' ? ${datum}[${(0, _vegaUtil.stringValue)(p.field)}] : null`
                    }
                ] : [],
                bind: bind[p.field] ?? bind[p.channel] ?? bind
            });
        });
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project;
        const signal = signals.find((s)=>s.name === name + TUPLE);
        const fields = name + TUPLE_FIELDS;
        const values = proj.items.map((p)=>varName(`${name}_${p.field}`));
        const valid = values.map((v)=>`${v} !== null`).join(' && ');
        if (values.length) signal.update = `${valid} ? {fields: ${fields}, values: [${values.join(', ')}]} : null`;
        delete signal.value;
        delete signal.on;
        return signals;
    }
};
const TOGGLE = '_toggle';
const toggle = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'point' && !isTimerSelection(selCmpt) && !!selCmpt.toggle;
    },
    signals: (model, selCmpt, signals)=>{
        return signals.concat({
            name: selCmpt.name + TOGGLE,
            value: false,
            on: [
                {
                    events: selCmpt.events,
                    update: selCmpt.toggle
                }
            ]
        });
    },
    modifyExpr: (model, selCmpt)=>{
        const tpl = selCmpt.name + TUPLE;
        const signal = selCmpt.name + TOGGLE;
        return `${signal} ? null : ${tpl}, ${selCmpt.resolve === 'global' ? `${signal} ? null : true, ` : `${signal} ? null : {unit: ${unitName(model)}}, `}${signal} ? ${tpl} : null`;
    }
};
const clear = {
    defined: (selCmpt)=>{
        return selCmpt.clear !== undefined && selCmpt.clear !== false && !isTimerSelection(selCmpt);
    },
    parse: (model, selCmpt)=>{
        if (selCmpt.clear) selCmpt.clear = (0, _vegaUtil.isString)(selCmpt.clear) ? (0, _vegaEventSelector.parseSelector)(selCmpt.clear, 'view') : selCmpt.clear;
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        if (inputBindings.defined(selCmpt)) for (const proj of selCmpt.project.items){
            const idx = signals.findIndex((n)=>n.name === varName(`${selCmpt.name}_${proj.field}`));
            if (idx !== -1) signals[idx].on.push({
                events: selCmpt.clear,
                update: 'null'
            });
        }
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        function addClear(idx, update) {
            if (idx !== -1 && signals[idx].on) signals[idx].on.push({
                events: selCmpt.clear,
                update
            });
        }
        // Be as minimalist as possible when adding clear triggers to minimize dataflow execution.
        if (selCmpt.type === 'interval') for (const proj of selCmpt.project.items){
            const vIdx = signals.findIndex((n)=>n.name === proj.signals.visual);
            addClear(vIdx, '[0, 0]');
            if (vIdx === -1) {
                const dIdx = signals.findIndex((n)=>n.name === proj.signals.data);
                addClear(dIdx, 'null');
            }
        }
        else {
            let tIdx = signals.findIndex((n)=>n.name === selCmpt.name + TUPLE);
            addClear(tIdx, 'null');
            if (toggle.defined(selCmpt)) {
                tIdx = signals.findIndex((n)=>n.name === selCmpt.name + TOGGLE);
                addClear(tIdx, 'false');
            }
        }
        return signals;
    }
};
const legendBindings = {
    defined: (selCmpt)=>{
        const spec = selCmpt.resolve === 'global' && selCmpt.bind && isLegendBinding(selCmpt.bind);
        const projLen = selCmpt.project.items.length === 1 && selCmpt.project.items[0].field !== SELECTION_ID;
        if (spec && !projLen) warn(LEGEND_BINDINGS_MUST_HAVE_PROJECTION);
        return spec && projLen;
    },
    parse: (model, selCmpt, selDef)=>{
        // Allow legend items to be toggleable by default even though direct manipulation is disabled.
        const selDef_ = duplicate(selDef);
        selDef_.select = (0, _vegaUtil.isString)(selDef_.select) ? {
            type: selDef_.select,
            toggle: selCmpt.toggle
        } : {
            ...selDef_.select,
            toggle: selCmpt.toggle
        };
        disableDirectManipulation(selCmpt, selDef_);
        if ((0, _vega.isObject)(selDef.select) && (selDef.select.on || selDef.select.clear)) {
            const legendFilter = 'event.item && indexof(event.item.mark.role, "legend") < 0';
            for (const evt of selCmpt.events){
                evt.filter = (0, _vegaUtil.array)(evt.filter ?? []);
                if (!evt.filter.includes(legendFilter)) evt.filter.push(legendFilter);
            }
        }
        const evt = isLegendStreamBinding(selCmpt.bind) ? selCmpt.bind.legend : 'click';
        const stream = (0, _vegaUtil.isString)(evt) ? (0, _vegaEventSelector.parseSelector)(evt, 'view') : (0, _vegaUtil.array)(evt);
        selCmpt.bind = {
            legend: {
                merge: stream
            }
        };
    },
    topLevelSignals: (model, selCmpt, signals)=>{
        const selName = selCmpt.name;
        const stream = isLegendStreamBinding(selCmpt.bind) && selCmpt.bind.legend;
        const markName = (name)=>(s)=>{
                const ds = duplicate(s);
                ds.markname = name;
                return ds;
            };
        for (const proj of selCmpt.project.items){
            if (!proj.hasLegend) continue;
            const prefix = `${varName(proj.field)}_legend`;
            const sgName = `${selName}_${prefix}`;
            const hasSignal = signals.filter((s)=>s.name === sgName);
            if (hasSignal.length === 0) {
                const events = stream.merge.map(markName(`${prefix}_symbols`)).concat(stream.merge.map(markName(`${prefix}_labels`))).concat(stream.merge.map(markName(`${prefix}_entries`)));
                signals.unshift({
                    name: sgName,
                    ...!selCmpt.init ? {
                        value: null
                    } : {},
                    on: [
                        // Legend entries do not store values, so we need to walk the scenegraph to the symbol datum.
                        {
                            events,
                            update: 'isDefined(datum.value) ? datum.value : item().items[0].items[0].datum.value',
                            force: true
                        },
                        {
                            events: stream.merge,
                            update: `!event.item || !datum ? null : ${sgName}`,
                            force: true
                        }
                    ]
                });
            }
        }
        return signals;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const proj = selCmpt.project;
        const tuple = signals.find((s)=>s.name === name + TUPLE);
        const fields = name + TUPLE_FIELDS;
        const values = proj.items.filter((p)=>p.hasLegend).map((p)=>varName(`${name}_${varName(p.field)}_legend`));
        const valid = values.map((v)=>`${v} !== null`).join(' && ');
        const update = `${valid} ? {fields: ${fields}, values: [${values.join(', ')}]} : null`;
        if (selCmpt.events && values.length > 0) tuple.on.push({
            events: values.map((signal)=>({
                    signal
                })),
            update
        });
        else if (values.length > 0) {
            tuple.update = update;
            delete tuple.value;
            delete tuple.on;
        }
        const toggle = signals.find((s)=>s.name === name + TOGGLE);
        const events = isLegendStreamBinding(selCmpt.bind) && selCmpt.bind.legend;
        if (toggle) {
            if (!selCmpt.events) toggle.on[0].events = events;
            else toggle.on.push({
                ...toggle.on[0],
                events
            });
        }
        return signals;
    }
};
function parseInteractiveLegend(model, channel, legendCmpt) {
    const field = model.fieldDef(channel)?.field;
    for (const selCmpt of vals(model.component.selection ?? {})){
        const proj = selCmpt.project.hasField[field] ?? selCmpt.project.hasChannel[channel];
        if (proj && legendBindings.defined(selCmpt)) {
            const legendSelections = legendCmpt.get('selections') ?? [];
            legendSelections.push(selCmpt.name);
            legendCmpt.set('selections', legendSelections, false);
            proj.hasLegend = true;
        }
    }
}
const ANCHOR$1 = '_translate_anchor';
const DELTA$1 = '_translate_delta';
const translate = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'interval' && selCmpt.translate;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const boundScales = scaleBindings.defined(selCmpt);
        const anchor = name + ANCHOR$1;
        const { x, y } = selCmpt.project.hasChannel;
        let events = (0, _vegaEventSelector.parseSelector)(selCmpt.translate, 'scope');
        if (!boundScales) events = events.map((e)=>(e.between[0].markname = name + BRUSH, e));
        signals.push({
            name: anchor,
            value: {},
            on: [
                {
                    events: events.map((e)=>e.between[0]),
                    update: `{x: x(unit), y: y(unit)${x !== undefined ? `, extent_x: ${boundScales ? domain(model, X) : `slice(${x.signals.visual})`}` : ''}${y !== undefined ? `, extent_y: ${boundScales ? domain(model, Y) : `slice(${y.signals.visual})`}` : ''}}`
                }
            ]
        }, {
            name: name + DELTA$1,
            value: {},
            on: [
                {
                    events,
                    update: `{x: ${anchor}.x - x(unit), y: ${anchor}.y - y(unit)}`
                }
            ]
        });
        if (x !== undefined) onDelta$1(model, selCmpt, x, 'width', signals);
        if (y !== undefined) onDelta$1(model, selCmpt, y, 'height', signals);
        return signals;
    }
};
function onDelta$1(model, selCmpt, proj, size, signals) {
    const name = selCmpt.name;
    const anchor = name + ANCHOR$1;
    const delta = name + DELTA$1;
    const channel = proj.channel;
    const boundScales = scaleBindings.defined(selCmpt);
    const signal = signals.find((s)=>s.name === proj.signals[boundScales ? 'data' : 'visual']);
    const sizeSg = model.getSizeSignalRef(size).signal;
    const scaleCmpt = model.getScaleComponent(channel);
    const scaleType = scaleCmpt?.get('type');
    const reversed = scaleCmpt?.get('reverse'); // scale parsing sets this flag for fieldDef.sort
    const sign = !boundScales ? '' : channel === X ? reversed ? '' : '-' : reversed ? '-' : '';
    const extent = `${anchor}.extent_${channel}`;
    const offset = `${sign}${delta}.${channel} / ${boundScales ? `${sizeSg}` : `span(${extent})`}`;
    const panFn = !boundScales || !scaleCmpt ? 'panLinear' : scaleType === 'log' ? 'panLog' : scaleType === 'symlog' ? 'panSymlog' : scaleType === 'pow' ? 'panPow' : 'panLinear';
    const arg = !boundScales ? '' : scaleType === 'pow' ? `, ${scaleCmpt.get('exponent') ?? 1}` : scaleType === 'symlog' ? `, ${scaleCmpt.get('constant') ?? 1}` : '';
    const update = `${panFn}(${extent}, ${offset}${arg})`;
    signal.on.push({
        events: {
            signal: delta
        },
        update: boundScales ? update : `clampRange(${update}, 0, ${sizeSg})`
    });
}
const ANCHOR = '_zoom_anchor';
const DELTA = '_zoom_delta';
const zoom = {
    defined: (selCmpt)=>{
        return selCmpt.type === 'interval' && selCmpt.zoom;
    },
    signals: (model, selCmpt, signals)=>{
        const name = selCmpt.name;
        const boundScales = scaleBindings.defined(selCmpt);
        const delta = name + DELTA;
        const { x, y } = selCmpt.project.hasChannel;
        const sx = (0, _vegaUtil.stringValue)(model.scaleName(X));
        const sy = (0, _vegaUtil.stringValue)(model.scaleName(Y));
        let events = (0, _vegaEventSelector.parseSelector)(selCmpt.zoom, 'scope');
        if (!boundScales) events = events.map((e)=>(e.markname = name + BRUSH, e));
        signals.push({
            name: name + ANCHOR,
            on: [
                {
                    events,
                    update: !boundScales ? `{x: x(unit), y: y(unit)}` : `{${[
                        sx ? `x: invert(${sx}, x(unit))` : '',
                        sy ? `y: invert(${sy}, y(unit))` : ''
                    ].filter((expr)=>expr).join(', ')}}`
                }
            ]
        }, {
            name: delta,
            on: [
                {
                    events,
                    force: true,
                    update: 'pow(1.001, event.deltaY * pow(16, event.deltaMode))'
                }
            ]
        });
        if (x !== undefined) onDelta(model, selCmpt, x, 'width', signals);
        if (y !== undefined) onDelta(model, selCmpt, y, 'height', signals);
        return signals;
    }
};
function onDelta(model, selCmpt, proj, size, signals) {
    const name = selCmpt.name;
    const channel = proj.channel;
    const boundScales = scaleBindings.defined(selCmpt);
    const signal = signals.find((s)=>s.name === proj.signals[boundScales ? 'data' : 'visual']);
    const sizeSg = model.getSizeSignalRef(size).signal;
    const scaleCmpt = model.getScaleComponent(channel);
    const scaleType = scaleCmpt?.get('type');
    const base = boundScales ? domain(model, channel) : signal.name;
    const delta = name + DELTA;
    const anchor = `${name}${ANCHOR}.${channel}`;
    const zoomFn = !boundScales || !scaleCmpt ? 'zoomLinear' : scaleType === 'log' ? 'zoomLog' : scaleType === 'symlog' ? 'zoomSymlog' : scaleType === 'pow' ? 'zoomPow' : 'zoomLinear';
    const arg = !boundScales ? '' : scaleType === 'pow' ? `, ${scaleCmpt.get('exponent') ?? 1}` : scaleType === 'symlog' ? `, ${scaleCmpt.get('constant') ?? 1}` : '';
    const update = `${zoomFn}(${base}, ${anchor}, ${delta}${arg})`;
    signal.on.push({
        events: {
            signal: delta
        },
        update: boundScales ? update : `clampRange(${update}, 0, ${sizeSg})`
    });
}
const STORE = '_store';
const TUPLE = '_tuple';
const MODIFY = '_modify';
const VL_SELECTION_RESOLVE = 'vlSelectionResolve';
// Order matters for parsing and assembly.
const selectionCompilers = [
    point$1,
    interval,
    project,
    toggle,
    // Bindings may disable direct manipulation.
    inputBindings,
    scaleBindings,
    legendBindings,
    clear,
    translate,
    zoom,
    nearest
];
function getFacetModel(model) {
    let parent = model.parent;
    while(parent){
        if (isFacetModel(parent)) break;
        parent = parent.parent;
    }
    return parent;
}
function unitName(model, { escape: escape1 } = {
    escape: true
}) {
    let name = escape1 ? (0, _vegaUtil.stringValue)(model.name) : model.name;
    const facetModel = getFacetModel(model);
    if (facetModel) {
        const { facet } = facetModel;
        for (const channel of FACET_CHANNELS)if (facet[channel]) name += ` + '__facet_${channel}_' + (facet[${(0, _vegaUtil.stringValue)(facetModel.vgField(channel))}])`;
    }
    return name;
}
function requiresSelectionId(model) {
    return vals(model.component.selection ?? {}).reduce((identifier, selCmpt)=>{
        return identifier || selCmpt.project.hasSelectionId;
    }, false);
}
// Binding a point selection to query widgets or legends disables default direct manipulation interaction.
// A user can choose to re-enable it by explicitly specifying triggering input events.
function disableDirectManipulation(selCmpt, selDef) {
    if ((0, _vega.isString)(selDef.select) || !selDef.select.on) delete selCmpt.events;
    if ((0, _vega.isString)(selDef.select) || !selDef.select.clear) delete selCmpt.clear;
    if ((0, _vega.isString)(selDef.select) || !selDef.select.toggle) delete selCmpt.toggle;
}
function isTimerSelection(selCmpt) {
    return selCmpt.events?.find((e)=>'type' in e && e.type === 'timer');
}
function getName(node) {
    const name = [];
    if (node.type === 'Identifier') return [
        node.name
    ];
    if (node.type === 'Literal') return [
        node.value
    ];
    if (node.type === 'MemberExpression') {
        name.push(...getName(node.object));
        name.push(...getName(node.property));
    }
    return name;
}
function startsWithDatum(node) {
    if (node.object.type === 'MemberExpression') return startsWithDatum(node.object);
    return node.object.name === 'datum';
}
function getDependentFields(expression) {
    const ast = (0, _vegaExpression.parseExpression)(expression);
    const dependents = new Set();
    // visit is missing in types https://github.com/vega/vega/issues/3298
    ast.visit((node)=>{
        if (node.type === 'MemberExpression' && startsWithDatum(node)) dependents.add(getName(node).slice(1).join('.'));
    });
    return dependents;
}
class FilterNode extends DataFlowNode {
    model;
    filter;
    expr;
    _dependentFields;
    clone() {
        return new FilterNode(null, this.model, duplicate(this.filter));
    }
    constructor(parent, model, filter){
        super(parent);
        this.model = model;
        this.filter = filter;
        // TODO: refactor this to not take a node and
        // then add a static function makeFromOperand and make the constructor take only an expression
        this.expr = expression(this.model, this.filter, this);
        this._dependentFields = getDependentFields(this.expr);
    }
    dependentFields() {
        return this._dependentFields;
    }
    producedFields() {
        return new Set(); // filter does not produce any new fields
    }
    assemble() {
        return {
            type: 'filter',
            expr: this.expr
        };
    }
    hash() {
        return `Filter ${this.expr}`;
    }
}
function parseUnitSelection(model, selDefs) {
    const selCmpts = {};
    const selectionConfig = model.config.selection;
    if (!selDefs || !selDefs.length) return selCmpts;
    let nTimerSelections = 0;
    for (const def of selDefs){
        const name = varName(def.name);
        const selDef = def.select;
        const type = (0, _vegaUtil.isString)(selDef) ? selDef : selDef.type;
        const defaults = (0, _vegaUtil.isObject)(selDef) ? duplicate(selDef) : {
            type
        };
        // Set default values from config if a property hasn't been specified,
        // or if it is true. E.g., "translate": true should use the default
        // event handlers for translate. However, true may be a valid value for
        // a property (e.g., "nearest": true).
        const cfg = selectionConfig[type];
        for(const key in cfg){
            // Project transform applies its defaults.
            if (key === 'fields' || key === 'encodings') continue;
            if (key === 'mark') defaults.mark = {
                ...cfg.mark,
                ...defaults.mark
            };
            if (defaults[key] === undefined || defaults[key] === true) defaults[key] = duplicate(cfg[key] ?? defaults[key]);
        }
        const selCmpt = selCmpts[name] = {
            ...defaults,
            name,
            type,
            init: def.value,
            bind: def.bind,
            events: (0, _vegaUtil.isString)(defaults.on) ? (0, _vegaEventSelector.parseSelector)(defaults.on, 'scope') : (0, _vegaUtil.array)(duplicate(defaults.on))
        };
        if (isTimerSelection(selCmpt)) {
            nTimerSelections++;
            // check for multiple timer selections and ignore all but the first one
            if (nTimerSelections > 1) {
                delete selCmpts[name];
                continue;
            }
        }
        const def_ = duplicate(def); // defensive copy to prevent compilers from causing side effects
        for (const c of selectionCompilers)if (c.defined(selCmpt) && c.parse) c.parse(model, selCmpt, def_);
    }
    if (nTimerSelections > 1) // if multiple timer selections were found, issue a warning
    warn(MULTIPLE_TIMER_ANIMATION_SELECTION);
    return selCmpts;
}
function parseSelectionPredicate(model, pred, dfnode, datum = 'datum') {
    const name = (0, _vegaUtil.isString)(pred) ? pred : pred.param;
    const vname = varName(name);
    const store = (0, _vegaUtil.stringValue)(vname + STORE);
    let selCmpt;
    try {
        selCmpt = model.getSelectionComponent(vname, name);
    } catch  {
        // If a selection isn't found, treat as a variable parameter and coerce to boolean.
        return `!!${vname}`;
    }
    if (selCmpt.project.timeUnit) {
        const child = dfnode ?? model.component.data.raw;
        const tunode = selCmpt.project.timeUnit.clone();
        if (child.parent) tunode.insertAsParentOf(child);
        else child.parent = tunode;
    }
    const fn = selCmpt.project.hasSelectionId ? 'vlSelectionIdTest(' : 'vlSelectionTest(';
    const resolve = selCmpt.resolve === 'global' ? ')' : `, ${(0, _vegaUtil.stringValue)(selCmpt.resolve)})`;
    const test = `${fn}${store}, ${datum}${resolve}`;
    const length = `length(data(${store}))`;
    return pred.empty === false ? `${length} && ${test}` : `!${length} || ${test}`;
}
function parseSelectionExtent(model, name, extent) {
    const vname = varName(name);
    const encoding = extent.encoding;
    let field = extent.field;
    let selCmpt;
    try {
        selCmpt = model.getSelectionComponent(vname, name);
    } catch  {
        // If a selection isn't found, treat it as a variable parameter.
        return vname;
    }
    if (!encoding && !field) {
        field = selCmpt.project.items[0].field;
        if (selCmpt.project.items.length > 1) warn(selectionAsScaleDomainWithoutField(field));
    } else if (encoding && !field) {
        const encodings = selCmpt.project.items.filter((p)=>p.channel === encoding);
        if (!encodings.length || encodings.length > 1) {
            field = selCmpt.project.items[0].field;
            warn(selectionAsScaleDomainWrongEncodings(encodings, encoding, extent, field));
        } else field = encodings[0].field;
    }
    return `${selCmpt.name}[${(0, _vegaUtil.stringValue)(replacePathInField(field))}]`;
}
function materializeSelections(model, main) {
    for (const [selection, selCmpt] of entries$1(model.component.selection ?? {})){
        const lookupName = model.getName(`lookup_${selection}`);
        model.component.data.outputNodes[lookupName] = selCmpt.materialized = new OutputNode(new FilterNode(main, model, {
            param: selection
        }), lookupName, DataSourceType.Lookup, model.component.data.outputNodeRefCounts);
    }
}
/**
 * Converts a predicate into an expression.
 */ // model is only used for selection filters.
function expression(model, filterOp, node) {
    return logicalExpr(filterOp, (predicate)=>{
        if ((0, _vegaUtil.isString)(predicate)) return predicate;
        else if (isSelectionPredicate(predicate)) return parseSelectionPredicate(model, predicate, node);
        else // Filter Object
        return fieldFilterExpression(predicate);
    });
}
function assembleTitle(title, config) {
    if (!title) return undefined;
    if ((0, _vegaUtil.isArray)(title) && !isText(title)) return title.map((fieldDef)=>defaultTitle(fieldDef, config)).join(', ');
    return title;
}
function setAxisEncode(axis, part, vgProp, vgRef) {
    axis.encode ??= {};
    axis.encode[part] ??= {};
    axis.encode[part].update ??= {};
    // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
    axis.encode[part].update[vgProp] = vgRef;
}
function assembleAxis(axisCmpt, kind, config, opt = {
    header: false
}) {
    const { disable, orient, scale, labelExpr, title, zindex, ...axis } = axisCmpt.combine();
    if (disable) return undefined;
    for(const p in axis){
        const prop = p;
        const propType = AXIS_PROPERTY_TYPE[prop];
        const propValue = axis[prop];
        if (propType && propType !== kind && propType !== 'both') // Remove properties that are not valid for this kind of axis
        delete axis[prop];
        else if (isConditionalAxisValue(propValue)) {
            // deal with conditional axis value
            const { condition, ...valueOrSignalRef } = propValue;
            const conditions = (0, _vegaUtil.array)(condition);
            const propIndex = CONDITIONAL_AXIS_PROP_INDEX[prop];
            if (propIndex) {
                const { vgProp, part } = propIndex;
                // If there is a corresponding Vega property for the channel,
                // use Vega's custom axis encoding and delete the original axis property to avoid conflicts
                const vgRef = [
                    ...conditions.map((c)=>{
                        const { test, ...valueOrSignalCRef } = c;
                        return {
                            test: expression(null, test),
                            ...valueOrSignalCRef
                        };
                    }),
                    valueOrSignalRef
                ];
                setAxisEncode(axis, part, vgProp, vgRef);
                delete axis[prop];
            } else if (propIndex === null) {
                // If propIndex is null, this means we support conditional axis property by converting the condition to signal instead.
                const signalRef = {
                    signal: conditions.map((c)=>{
                        const { test, ...valueOrSignalCRef } = c;
                        return `${expression(null, test)} ? ${exprFromValueRefOrSignalRef(valueOrSignalCRef)} : `;
                    }).join('') + exprFromValueRefOrSignalRef(valueOrSignalRef)
                };
                axis[prop] = signalRef;
            }
        } else if (isSignalRef(propValue)) {
            const propIndex = CONDITIONAL_AXIS_PROP_INDEX[prop];
            if (propIndex) {
                const { vgProp, part } = propIndex;
                // FIXME: remove as any
                setAxisEncode(axis, part, vgProp, propValue);
                delete axis[prop];
            } // else do nothing since the property already supports signal
        }
        // Do not pass labelAlign/Baseline = null to Vega since it won't pass the schema
        // Note that we need to use null so the default labelAlign is preserved.
        if (contains([
            'labelAlign',
            'labelBaseline'
        ], prop) && axis[prop] === null) delete axis[prop];
    }
    if (kind === 'grid') {
        if (!axis.grid) return undefined;
        // Remove unnecessary encode block
        if (axis.encode) {
            // Only need to keep encode block for grid
            const { grid } = axis.encode;
            axis.encode = {
                ...grid ? {
                    grid
                } : {}
            };
            if (isEmpty(axis.encode)) delete axis.encode;
        }
        return {
            scale,
            orient,
            ...axis,
            domain: false,
            labels: false,
            aria: false,
            // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
            // would not affect gridAxis
            maxExtent: 0,
            minExtent: 0,
            ticks: false,
            zindex: getFirstDefined(zindex, 0)
        };
    } else {
        // kind === 'main'
        if (!opt.header && axisCmpt.mainExtracted) // if mainExtracted has been extracted to a separate facet
        return undefined;
        if (labelExpr !== undefined) {
            let expr = labelExpr;
            if (axis.encode?.labels?.update && isSignalRef(axis.encode.labels.update.text)) expr = replaceAll(labelExpr, 'datum.label', axis.encode.labels.update.text.signal);
            setAxisEncode(axis, 'labels', 'text', {
                signal: expr
            });
        }
        if (axis.labelAlign === null) delete axis.labelAlign;
        // Remove unnecessary encode block
        if (axis.encode) {
            for (const part of AXIS_PARTS)if (!axisCmpt.hasAxisPart(part)) delete axis.encode[part];
            if (isEmpty(axis.encode)) delete axis.encode;
        }
        const titleString = assembleTitle(title, config);
        return {
            scale,
            orient,
            grid: false,
            ...titleString ? {
                title: titleString
            } : {},
            ...axis,
            ...config.aria === false ? {
                aria: false
            } : {},
            zindex: getFirstDefined(zindex, 0)
        };
    }
}
/**
 * Add axis signals so grid line works correctly
 * (Fix https://github.com/vega/vega-lite/issues/4226)
 */ function assembleAxisSignals(model) {
    const { axes } = model.component;
    const signals = [];
    for (const channel of POSITION_SCALE_CHANNELS)if (axes[channel]) {
        for (const axis of axes[channel])if (!axis.get('disable') && !axis.get('gridScale')) {
            // If there is x-axis but no y-scale for gridScale, need to set height/width so x-axis can draw the grid with the right height. Same for y-axis and width.
            const sizeType = channel === 'x' ? 'height' : 'width';
            const update = model.getSizeSignalRef(sizeType).signal;
            if (sizeType !== update) signals.push({
                name: sizeType,
                update
            });
        }
    }
    return signals;
}
function assembleAxes(axisComponents, config) {
    const { x = [], y = [] } = axisComponents;
    return [
        ...x.map((a)=>assembleAxis(a, 'grid', config)),
        ...y.map((a)=>assembleAxis(a, 'grid', config)),
        ...x.map((a)=>assembleAxis(a, 'main', config)),
        ...y.map((a)=>assembleAxis(a, 'main', config))
    ].filter((a)=>a); // filter undefined
}
function getAxisConfigFromConfigTypes(configTypes, config, channel, orient) {
    // TODO: add special casing to add conditional value based on orient signal
    return Object.assign.apply(null, [
        {},
        ...configTypes.map((configType)=>{
            if (configType === 'axisOrient') {
                const orient1 = channel === 'x' ? 'bottom' : 'left';
                const orientConfig1 = config[channel === 'x' ? 'axisBottom' : 'axisLeft'] || {};
                const orientConfig2 = config[channel === 'x' ? 'axisTop' : 'axisRight'] || {};
                const props = new Set([
                    ...keys(orientConfig1),
                    ...keys(orientConfig2)
                ]);
                const conditionalOrientAxisConfig = {};
                for (const prop of props.values())conditionalOrientAxisConfig[prop] = {
                    // orient is surely signal in this case
                    signal: `${orient['signal']} === "${orient1}" ? ${signalOrStringValue(orientConfig1[prop])} : ${signalOrStringValue(orientConfig2[prop])}`
                };
                return conditionalOrientAxisConfig;
            }
            return config[configType];
        })
    ]);
}
function getAxisConfigs(channel, scaleType, orient, config) {
    const typeBasedConfigTypes = scaleType === 'band' ? [
        'axisDiscrete',
        'axisBand'
    ] : scaleType === 'point' ? [
        'axisDiscrete',
        'axisPoint'
    ] : isQuantitative(scaleType) ? [
        'axisQuantitative'
    ] : scaleType === 'time' || scaleType === 'utc' ? [
        'axisTemporal'
    ] : [];
    const axisChannel = channel === 'x' ? 'axisX' : 'axisY';
    const axisOrient = isSignalRef(orient) ? 'axisOrient' : `axis${titleCase(orient)}`; // axisTop, axisBottom, ...
    const vlOnlyConfigTypes = [
        // technically Vega does have axisBand, but if we make another separation here,
        // it will further introduce complexity in the code
        ...typeBasedConfigTypes,
        ...typeBasedConfigTypes.map((c)=>axisChannel + c.substr(4))
    ];
    const vgConfigTypes = [
        'axis',
        axisOrient,
        axisChannel
    ];
    return {
        vlOnlyAxisConfig: getAxisConfigFromConfigTypes(vlOnlyConfigTypes, config, channel, orient),
        vgAxisConfig: getAxisConfigFromConfigTypes(vgConfigTypes, config, channel, orient),
        axisConfigStyle: getAxisConfigStyle([
            ...vgConfigTypes,
            ...vlOnlyConfigTypes
        ], config)
    };
}
function getAxisConfigStyle(axisConfigTypes, config) {
    const toMerge = [
        {}
    ];
    for (const configType of axisConfigTypes){
        // TODO: add special casing to add conditional value based on orient signal
        let style = config[configType]?.style;
        if (style) {
            style = (0, _vegaUtil.array)(style);
            for (const s of style)toMerge.push(config.style[s]);
        }
    }
    return Object.assign.apply(null, toMerge);
}
function getAxisConfig(property, styleConfigIndex, style, axisConfigs = {}) {
    const styleConfig = getStyleConfig(property, style, styleConfigIndex);
    if (styleConfig !== undefined) return {
        configFrom: 'style',
        configValue: styleConfig
    };
    for (const configFrom of [
        'vlOnlyAxisConfig',
        'vgAxisConfig',
        'axisConfigStyle'
    ]){
        if (axisConfigs[configFrom]?.[property] !== undefined) return {
            configFrom,
            configValue: axisConfigs[configFrom][property]
        };
    }
    return {};
}
const axisRules = {
    scale: ({ model, channel })=>model.scaleName(channel),
    format: ({ format })=>format,
    formatType: ({ formatType })=>formatType,
    grid: ({ fieldOrDatumDef, axis, scaleType })=>axis.grid ?? defaultGrid(scaleType, fieldOrDatumDef),
    gridScale: ({ model, channel })=>gridScale(model, channel),
    labelAlign: ({ axis, labelAngle, orient, channel })=>axis.labelAlign || defaultLabelAlign(labelAngle, orient, channel),
    labelAngle: ({ labelAngle })=>labelAngle,
    labelBaseline: ({ axis, labelAngle, orient, channel })=>axis.labelBaseline || defaultLabelBaseline(labelAngle, orient, channel),
    labelFlush: ({ axis, fieldOrDatumDef, channel })=>axis.labelFlush ?? defaultLabelFlush(fieldOrDatumDef.type, channel),
    labelOverlap: ({ axis, fieldOrDatumDef, scaleType })=>axis.labelOverlap ?? defaultLabelOverlap$1(fieldOrDatumDef.type, scaleType, isFieldDef(fieldOrDatumDef) && !!fieldOrDatumDef.timeUnit, isFieldDef(fieldOrDatumDef) ? fieldOrDatumDef.sort : undefined),
    // we already calculate orient in parse
    orient: ({ orient })=>orient,
    tickCount: ({ channel, model, axis, fieldOrDatumDef, scaleType })=>{
        const sizeType = channel === 'x' ? 'width' : channel === 'y' ? 'height' : undefined;
        const size = sizeType ? model.getSizeSignalRef(sizeType) : undefined;
        return axis.tickCount ?? defaultTickCount({
            fieldOrDatumDef,
            scaleType,
            size,
            values: axis.values
        });
    },
    tickMinStep: ({ axis, format, fieldOrDatumDef })=>axis.tickMinStep ?? defaultTickMinStep({
            format,
            fieldOrDatumDef
        }),
    title: ({ axis, model, channel })=>{
        if (axis.title !== undefined) return axis.title;
        const fieldDefTitle = getFieldDefTitle(model, channel);
        if (fieldDefTitle !== undefined) return fieldDefTitle;
        const fieldDef = model.typedFieldDef(channel);
        const channel2 = channel === 'x' ? 'x2' : 'y2';
        const fieldDef2 = model.fieldDef(channel2);
        // If title not specified, store base parts of fieldDef (and fieldDef2 if exists)
        return mergeTitleFieldDefs(fieldDef ? [
            toFieldDefBase(fieldDef)
        ] : [], isFieldDef(fieldDef2) ? [
            toFieldDefBase(fieldDef2)
        ] : []);
    },
    values: ({ axis, fieldOrDatumDef })=>values$1(axis, fieldOrDatumDef),
    zindex: ({ axis, fieldOrDatumDef, mark })=>axis.zindex ?? defaultZindex(mark, fieldOrDatumDef)
};
// TODO: we need to refactor this method after we take care of config refactoring
/**
 * Default rules for whether to show a grid should be shown for a channel.
 * If `grid` is unspecified, the default value is `true` for ordinal scales that are not binned
 */ function defaultGrid(scaleType, fieldDef) {
    return !hasDiscreteDomain(scaleType) && isFieldDef(fieldDef) && !isBinning(fieldDef?.bin) && !isBinned(fieldDef?.bin);
}
function gridScale(model, channel) {
    const gridChannel = channel === 'x' ? 'y' : 'x';
    if (model.getScaleComponent(gridChannel)) return model.scaleName(gridChannel);
    return undefined;
}
function getLabelAngle(fieldOrDatumDef, axis, channel, styleConfig, axisConfigs) {
    const labelAngle = axis?.labelAngle;
    // try axis value
    if (labelAngle !== undefined) return isSignalRef(labelAngle) ? labelAngle : normalizeAngle(labelAngle);
    else {
        // try axis config value
        const { configValue: angle } = getAxisConfig('labelAngle', styleConfig, axis?.style, axisConfigs);
        if (angle !== undefined) return normalizeAngle(angle);
        else {
            // get default value
            if (channel === X && contains([
                NOMINAL,
                ORDINAL
            ], fieldOrDatumDef.type) && !(isFieldDef(fieldOrDatumDef) && fieldOrDatumDef.timeUnit)) return 270;
            // no default
            return undefined;
        }
    }
}
function normalizeAngleExpr(angle) {
    return `(((${angle.signal} % 360) + 360) % 360)`;
}
function defaultLabelBaseline(angle, orient, channel, alwaysIncludeMiddle) {
    if (angle !== undefined) {
        if (channel === 'x') {
            if (isSignalRef(angle)) {
                const a = normalizeAngleExpr(angle);
                const orientIsTop = isSignalRef(orient) ? `(${orient.signal} === "top")` : orient === 'top';
                return {
                    signal: `(45 < ${a} && ${a} < 135) || (225 < ${a} && ${a} < 315) ? "middle" :` + `(${a} <= 45 || 315 <= ${a}) === ${orientIsTop} ? "bottom" : "top"`
                };
            }
            if (45 < angle && angle < 135 || 225 < angle && angle < 315) return 'middle';
            if (isSignalRef(orient)) {
                const op = angle <= 45 || 315 <= angle ? '===' : '!==';
                return {
                    signal: `${orient.signal} ${op} "top" ? "bottom" : "top"`
                };
            }
            return (angle <= 45 || 315 <= angle) === (orient === 'top') ? 'bottom' : 'top';
        } else {
            if (isSignalRef(angle)) {
                const a = normalizeAngleExpr(angle);
                const orientIsLeft = isSignalRef(orient) ? `(${orient.signal} === "left")` : orient === 'left';
                const middle = alwaysIncludeMiddle ? '"middle"' : 'null';
                return {
                    signal: `${a} <= 45 || 315 <= ${a} || (135 <= ${a} && ${a} <= 225) ? ${middle} : (45 <= ${a} && ${a} <= 135) === ${orientIsLeft} ? "top" : "bottom"`
                };
            }
            if (angle <= 45 || 315 <= angle || 135 <= angle && angle <= 225) return alwaysIncludeMiddle ? 'middle' : null;
            if (isSignalRef(orient)) {
                const op = 45 <= angle && angle <= 135 ? '===' : '!==';
                return {
                    signal: `${orient.signal} ${op} "left" ? "top" : "bottom"`
                };
            }
            return (45 <= angle && angle <= 135) === (orient === 'left') ? 'top' : 'bottom';
        }
    }
    return undefined;
}
function defaultLabelAlign(angle, orient, channel) {
    if (angle === undefined) return undefined;
    const isX = channel === 'x';
    const startAngle = isX ? 0 : 90;
    const mainOrient = isX ? 'bottom' : 'left';
    if (isSignalRef(angle)) {
        const a = normalizeAngleExpr(angle);
        const orientIsMain = isSignalRef(orient) ? `(${orient.signal} === "${mainOrient}")` : orient === mainOrient;
        return {
            signal: `(${startAngle ? `(${a} + 90)` : a} % 180 === 0) ? ${isX ? null : '"center"'} :` + `(${startAngle} < ${a} && ${a} < ${180 + startAngle}) === ${orientIsMain} ? "left" : "right"`
        };
    }
    if ((angle + startAngle) % 180 === 0) // For bottom, use default label align so label flush still works
    return isX ? null : 'center';
    if (isSignalRef(orient)) {
        const op = startAngle < angle && angle < 180 + startAngle ? '===' : '!==';
        const orientIsMain = `${orient.signal} ${op} "${mainOrient}"`;
        return {
            signal: `${orientIsMain} ? "left" : "right"`
        };
    }
    if ((startAngle < angle && angle < 180 + startAngle) === (orient === mainOrient)) return 'left';
    return 'right';
}
function defaultLabelFlush(type, channel) {
    if (channel === 'x' && contains([
        'quantitative',
        'temporal'
    ], type)) return true;
    return undefined;
}
function defaultLabelOverlap$1(type, scaleType, hasTimeUnit, sort) {
    // do not prevent overlap for nominal data because there is no way to infer what the missing labels are
    if (hasTimeUnit && !(0, _vegaUtil.isObject)(sort) || type !== 'nominal' && type !== 'ordinal') {
        if (scaleType === 'log' || scaleType === 'symlog') return 'greedy';
        return true;
    }
    return undefined;
}
function defaultOrient(channel) {
    return channel === 'x' ? 'bottom' : 'left';
}
function defaultTickCount({ fieldOrDatumDef, scaleType, size, values: vals }) {
    if (!vals && !hasDiscreteDomain(scaleType) && scaleType !== 'log') {
        if (isFieldDef(fieldOrDatumDef)) {
            if (isBinning(fieldOrDatumDef.bin)) // for binned data, we don't want more ticks than maxbins
            return {
                signal: `ceil(${size.signal}/10)`
            };
            if (fieldOrDatumDef.timeUnit && contains([
                'month',
                'hours',
                'day',
                'quarter'
            ], normalizeTimeUnit(fieldOrDatumDef.timeUnit)?.unit)) return undefined;
        }
        return {
            signal: `ceil(${size.signal}/40)`
        };
    }
    return undefined;
}
function defaultTickMinStep({ format, fieldOrDatumDef }) {
    if (format === 'd') return 1;
    if (isFieldDef(fieldOrDatumDef)) {
        const { timeUnit } = fieldOrDatumDef;
        if (timeUnit) {
            const signal = durationExpr(timeUnit);
            if (signal) return {
                signal
            };
        }
    }
    return undefined;
}
function getFieldDefTitle(model, channel) {
    const channel2 = channel === 'x' ? 'x2' : 'y2';
    const fieldDef = model.fieldDef(channel);
    const fieldDef2 = model.fieldDef(channel2);
    const title1 = fieldDef ? fieldDef.title : undefined;
    const title2 = fieldDef2 ? fieldDef2.title : undefined;
    if (title1 && title2) return mergeTitle(title1, title2);
    else if (title1) return title1;
    else if (title2) return title2;
    else if (title1 !== undefined) // falsy value to disable config
    return title1;
    else if (title2 !== undefined) // falsy value to disable config
    return title2;
    return undefined;
}
function values$1(axis, fieldOrDatumDef) {
    const vals = axis.values;
    if ((0, _vegaUtil.isArray)(vals)) return valueArray(fieldOrDatumDef, vals);
    else if (isSignalRef(vals)) return vals;
    return undefined;
}
function defaultZindex(mark, fieldDef) {
    if (mark === 'rect' && isDiscrete(fieldDef)) return 1;
    return 0;
}
class CalculateNode extends DataFlowNode {
    transform;
    _dependentFields;
    clone() {
        return new CalculateNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this._dependentFields = getDependentFields(this.transform.calculate);
    }
    static parseAllForSortIndex(parent, model) {
        // get all the encoding with sort fields from model
        model.forEachFieldDef((fieldDef, channel)=>{
            if (!isScaleFieldDef(fieldDef)) return;
            if (isSortArray(fieldDef.sort)) {
                const { field, timeUnit } = fieldDef;
                const sort = fieldDef.sort;
                // generate `datum["a"] === val0 ? 0 : datum["a"] === val1 ? 1 : ... : n` via FieldEqualPredicate
                const calculate = sort.map((sortValue, i)=>{
                    return `${fieldFilterExpression({
                        field,
                        timeUnit,
                        equal: sortValue
                    })} ? ${i} : `;
                }).join('') + sort.length;
                parent = new CalculateNode(parent, {
                    calculate,
                    as: sortArrayIndexField(fieldDef, channel, {
                        forAs: true
                    })
                });
            }
        });
        return parent;
    }
    producedFields() {
        return new Set([
            this.transform.as
        ]);
    }
    dependentFields() {
        return this._dependentFields;
    }
    assemble() {
        return {
            type: 'formula',
            expr: this.transform.calculate,
            as: this.transform.as
        };
    }
    hash() {
        return `Calculate ${hash(this.transform)}`;
    }
}
function sortArrayIndexField(fieldDef, channel, opt) {
    return vgField(fieldDef, {
        prefix: channel,
        suffix: 'sort_index',
        ...opt
    });
}
/**
 * Get header channel, which can be different from facet channel when orient is specified or when the facet channel is facet.
 */ function getHeaderChannel(channel, orient) {
    if (contains([
        'top',
        'bottom'
    ], orient)) return 'column';
    else if (contains([
        'left',
        'right'
    ], orient)) return 'row';
    return channel === 'row' ? 'row' : 'column';
}
function getHeaderProperty(prop, header, config, channel) {
    const headerSpecificConfig = channel === 'row' ? config.headerRow : channel === 'column' ? config.headerColumn : config.headerFacet;
    return getFirstDefined((header || {})[prop], headerSpecificConfig[prop], config.header[prop]);
}
function getHeaderProperties(properties, header, config, channel) {
    const props = {};
    for (const prop of properties){
        const value = getHeaderProperty(prop, header || {}, config, channel);
        if (value !== undefined) props[prop] = value;
    }
    return props;
}
const HEADER_CHANNELS = [
    'row',
    'column'
];
const HEADER_TYPES = [
    'header',
    'footer'
];
/**
 * Utility for generating row / column headers
 */ // TODO: rename to assembleHeaderTitleGroup
function assembleTitleGroup(model, channel) {
    const title = model.component.layoutHeaders[channel].title;
    const config = model.config ? model.config : undefined;
    const facetFieldDef = model.component.layoutHeaders[channel].facetFieldDef ? model.component.layoutHeaders[channel].facetFieldDef : undefined;
    const { titleAnchor, titleAngle: ta, titleOrient } = getHeaderProperties([
        'titleAnchor',
        'titleAngle',
        'titleOrient'
    ], facetFieldDef.header, config, channel);
    const headerChannel = getHeaderChannel(channel, titleOrient);
    const titleAngle = normalizeAngle(ta);
    return {
        name: `${channel}-title`,
        type: 'group',
        role: `${headerChannel}-title`,
        title: {
            text: title,
            ...channel === 'row' ? {
                orient: 'left'
            } : {},
            style: 'guide-title',
            ...defaultHeaderGuideBaseline(titleAngle, headerChannel),
            ...defaultHeaderGuideAlign(headerChannel, titleAngle, titleAnchor),
            ...assembleHeaderProperties(config, facetFieldDef, channel, HEADER_TITLE_PROPERTIES, HEADER_TITLE_PROPERTIES_MAP)
        }
    };
}
function defaultHeaderGuideAlign(headerChannel, angle, anchor = 'middle') {
    switch(anchor){
        case 'start':
            return {
                align: 'left'
            };
        case 'end':
            return {
                align: 'right'
            };
    }
    const align = defaultLabelAlign(angle, headerChannel === 'row' ? 'left' : 'top', headerChannel === 'row' ? 'y' : 'x');
    return align ? {
        align
    } : {};
}
function defaultHeaderGuideBaseline(angle, channel) {
    const baseline = defaultLabelBaseline(angle, channel === 'row' ? 'left' : 'top', channel === 'row' ? 'y' : 'x', true);
    return baseline ? {
        baseline
    } : {};
}
function assembleHeaderGroups(model, channel) {
    const layoutHeader = model.component.layoutHeaders[channel];
    const groups = [];
    for (const headerType of HEADER_TYPES){
        if (layoutHeader[headerType]) for (const headerComponent of layoutHeader[headerType]){
            const group = assembleHeaderGroup(model, channel, headerType, layoutHeader, headerComponent);
            if (group != null) groups.push(group);
        }
    }
    return groups;
}
function getSort$1(facetFieldDef, channel) {
    const { sort } = facetFieldDef;
    if (isSortField(sort)) return {
        field: vgField(sort, {
            expr: 'datum'
        }),
        order: sort.order ?? 'ascending'
    };
    else if ((0, _vegaUtil.isArray)(sort)) return {
        field: sortArrayIndexField(facetFieldDef, channel, {
            expr: 'datum'
        }),
        order: 'ascending'
    };
    else return {
        field: vgField(facetFieldDef, {
            expr: 'datum'
        }),
        order: sort ?? 'ascending'
    };
}
function assembleLabelTitle(facetFieldDef, channel, config) {
    const { format, formatType, labelAngle, labelAnchor, labelOrient, labelExpr } = getHeaderProperties([
        'format',
        'formatType',
        'labelAngle',
        'labelAnchor',
        'labelOrient',
        'labelExpr'
    ], facetFieldDef.header, config, channel);
    const titleTextExpr = formatSignalRef({
        fieldOrDatumDef: facetFieldDef,
        format,
        formatType,
        expr: 'parent',
        config
    }).signal;
    const headerChannel = getHeaderChannel(channel, labelOrient);
    return {
        text: {
            signal: labelExpr ? replaceAll(replaceAll(labelExpr, 'datum.label', titleTextExpr), 'datum.value', vgField(facetFieldDef, {
                expr: 'parent'
            })) : titleTextExpr
        },
        ...channel === 'row' ? {
            orient: 'left'
        } : {},
        style: 'guide-label',
        frame: 'group',
        ...defaultHeaderGuideBaseline(labelAngle, headerChannel),
        ...defaultHeaderGuideAlign(headerChannel, labelAngle, labelAnchor),
        ...assembleHeaderProperties(config, facetFieldDef, channel, HEADER_LABEL_PROPERTIES, HEADER_LABEL_PROPERTIES_MAP)
    };
}
function assembleHeaderGroup(model, channel, headerType, layoutHeader, headerComponent) {
    if (headerComponent) {
        let title = null;
        const { facetFieldDef } = layoutHeader;
        const config = model.config ? model.config : undefined;
        if (facetFieldDef && headerComponent.labels) {
            const { labelOrient } = getHeaderProperties([
                'labelOrient'
            ], facetFieldDef.header, config, channel);
            // Include label title in the header if orient aligns with the channel
            if (channel === 'row' && !contains([
                'top',
                'bottom'
            ], labelOrient) || channel === 'column' && !contains([
                'left',
                'right'
            ], labelOrient)) title = assembleLabelTitle(facetFieldDef, channel, config);
        }
        const isFacetWithoutRowCol = isFacetModel(model) && !isFacetMapping(model.facet);
        const axes = headerComponent.axes;
        const hasAxes = axes?.length > 0;
        if (title || hasAxes) {
            const sizeChannel = channel === 'row' ? 'height' : 'width';
            return {
                name: model.getName(`${channel}_${headerType}`),
                type: 'group',
                role: `${channel}-${headerType}`,
                ...layoutHeader.facetFieldDef ? {
                    from: {
                        data: model.getName(`${channel}_domain`)
                    },
                    sort: getSort$1(facetFieldDef, channel)
                } : {},
                ...hasAxes && isFacetWithoutRowCol ? {
                    from: {
                        data: model.getName(`facet_domain_${channel}`)
                    }
                } : {},
                ...title ? {
                    title
                } : {},
                ...headerComponent.sizeSignal ? {
                    encode: {
                        update: {
                            [sizeChannel]: headerComponent.sizeSignal
                        }
                    }
                } : {},
                ...hasAxes ? {
                    axes
                } : {}
            };
        }
    }
    return null;
}
const LAYOUT_TITLE_BAND = {
    column: {
        start: 0,
        end: 1
    },
    row: {
        start: 1,
        end: 0
    }
};
function getLayoutTitleBand(titleAnchor, headerChannel) {
    return LAYOUT_TITLE_BAND[headerChannel][titleAnchor];
}
function assembleLayoutTitleBand(headerComponentIndex, config) {
    const titleBand = {};
    for (const channel of FACET_CHANNELS){
        const headerComponent = headerComponentIndex[channel];
        if (headerComponent?.facetFieldDef) {
            const { titleAnchor, titleOrient } = getHeaderProperties([
                'titleAnchor',
                'titleOrient'
            ], headerComponent.facetFieldDef.header, config, channel);
            const headerChannel = getHeaderChannel(channel, titleOrient);
            const band = getLayoutTitleBand(titleAnchor, headerChannel);
            if (band !== undefined) titleBand[headerChannel] = band;
        }
    }
    return isEmpty(titleBand) ? undefined : titleBand;
}
function assembleHeaderProperties(config, facetFieldDef, channel, properties, propertiesMap) {
    const props = {};
    for (const prop of properties){
        if (!propertiesMap[prop]) continue;
        const value = getHeaderProperty(prop, facetFieldDef?.header, config, channel);
        if (value !== undefined) props[propertiesMap[prop]] = value;
    }
    return props;
}
function assembleLayoutSignals(model) {
    return [
        ...sizeSignals(model, 'width'),
        ...sizeSignals(model, 'height'),
        ...sizeSignals(model, 'childWidth'),
        ...sizeSignals(model, 'childHeight')
    ];
}
function sizeSignals(model, sizeType) {
    const channel = sizeType === 'width' ? 'x' : 'y';
    const size = model.component.layoutSize.get(sizeType);
    if (!size || size === 'merged') return [];
    // Read size signal name from name map, just in case it is the top-level size signal that got renamed.
    const name = model.getSizeSignalRef(sizeType).signal;
    if (size === 'step') {
        const scaleComponent = model.getScaleComponent(channel);
        if (scaleComponent) {
            const type = scaleComponent.get('type');
            const range = scaleComponent.get('range');
            if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
                const scaleName = model.scaleName(channel);
                if (isFacetModel(model.parent)) {
                    // If parent is facet and this is an independent scale, return only signal signal
                    // as the width/height will be calculated using the cardinality from
                    // facet's aggregate rather than reading from scale domain
                    const parentResolve = model.parent.component.resolve;
                    if (parentResolve.scale[channel] === 'independent') return [
                        stepSignal(scaleName, range)
                    ];
                }
                return [
                    stepSignal(scaleName, range),
                    {
                        name,
                        update: sizeExpr(scaleName, scaleComponent, `domain('${scaleName}').length`)
                    }
                ];
            }
        }
        /* istanbul ignore next: Condition should not happen -- only for warning in development. */ throw new Error('layout size is step although width/height is not step.');
    } else if (size == 'container') {
        const isWidth = name.endsWith('width');
        const expr = isWidth ? 'containerSize()[0]' : 'containerSize()[1]';
        const defaultValue = getViewConfigContinuousSize(model.config.view, isWidth ? 'width' : 'height');
        const safeExpr = `isFinite(${expr}) ? ${expr} : ${defaultValue}`;
        return [
            {
                name,
                init: safeExpr,
                on: [
                    {
                        update: safeExpr,
                        events: 'window:resize'
                    }
                ]
            }
        ];
    } else return [
        {
            name,
            value: size
        }
    ];
}
function stepSignal(scaleName, range) {
    const name = `${scaleName}_step`;
    if (isSignalRef(range.step)) return {
        name,
        update: range.step.signal
    };
    else return {
        name,
        value: range.step
    };
}
function sizeExpr(scaleName, scaleComponent, cardinality) {
    const type = scaleComponent.get('type');
    const padding = scaleComponent.get('padding');
    const paddingOuter = getFirstDefined(scaleComponent.get('paddingOuter'), padding);
    let paddingInner = scaleComponent.get('paddingInner');
    paddingInner = type === 'band' ? paddingInner !== undefined ? paddingInner : padding : // it's equivalent to have paddingInner = 1 since there is only n-1 steps between n points.
    1;
    return `bandspace(${cardinality}, ${signalOrStringValue(paddingInner)}, ${signalOrStringValue(paddingOuter)}) * ${scaleName}_step`;
}
function getSizeTypeFromLayoutSizeType(layoutSizeType) {
    return layoutSizeType === 'childWidth' ? 'width' : layoutSizeType === 'childHeight' ? 'height' : layoutSizeType;
}
function guideEncodeEntry(encoding, model) {
    return keys(encoding).reduce((encode, channel)=>{
        return {
            ...encode,
            ...wrapCondition({
                model,
                channelDef: encoding[channel],
                vgChannel: channel,
                mainRefFn: (def)=>signalOrValueRef(def.value),
                invalidValueRef: undefined
            })
        };
    }, {});
}
function defaultScaleResolve(channel, model) {
    if (isFacetModel(model)) return channel === 'theta' ? 'independent' : 'shared';
    else if (isLayerModel(model)) return 'shared';
    else if (isConcatModel(model)) return isXorY(channel) || channel === 'theta' || channel === 'radius' ? 'independent' : 'shared';
    /* istanbul ignore next: should never reach here. */ throw new Error('invalid model type for resolve');
}
function parseGuideResolve(resolve, channel) {
    const channelScaleResolve = resolve.scale[channel];
    const guide = isXorY(channel) ? 'axis' : 'legend';
    if (channelScaleResolve === 'independent') {
        if (resolve[guide][channel] === 'shared') warn(independentScaleMeansIndependentGuide(channel));
        return 'independent';
    }
    return resolve[guide][channel] || 'shared';
}
const LEGEND_COMPONENT_PROPERTY_INDEX = {
    ...COMMON_LEGEND_PROPERTY_INDEX,
    disable: 1,
    labelExpr: 1,
    selections: 1,
    // channel scales
    opacity: 1,
    shape: 1,
    stroke: 1,
    fill: 1,
    size: 1,
    strokeWidth: 1,
    strokeDash: 1,
    // encode
    encode: 1
};
const LEGEND_COMPONENT_PROPERTIES = keys(LEGEND_COMPONENT_PROPERTY_INDEX);
class LegendComponent extends Split {
}
const legendEncodeRules = {
    symbols,
    gradient,
    labels: labels$1,
    entries
};
function symbols(symbolsSpec, { fieldOrDatumDef, model, channel, legendCmpt, legendType }) {
    if (legendType !== 'symbol') return undefined;
    const { markDef, encoding, config, mark } = model;
    const filled = markDef.filled && mark !== 'trail';
    let out = {
        ...applyMarkConfig({}, model, FILL_STROKE_CONFIG),
        ...color(model, {
            filled
        })
    }; // FIXME: remove this when VgEncodeEntry is compatible with SymbolEncodeEntry
    const symbolOpacity = legendCmpt.get('symbolOpacity') ?? config.legend.symbolOpacity;
    const symbolFillColor = legendCmpt.get('symbolFillColor') ?? config.legend.symbolFillColor;
    const symbolStrokeColor = legendCmpt.get('symbolStrokeColor') ?? config.legend.symbolStrokeColor;
    const opacity = symbolOpacity === undefined ? getMaxValue(encoding.opacity) ?? markDef.opacity : undefined;
    if (out.fill) {
        // for fill legend, we don't want any fill in symbol
        if (channel === 'fill' || filled && channel === COLOR) delete out.fill;
        else if (hasProperty(out.fill, 'field')) {
            // For others, set fill to some opaque value (or nothing if a color is already set)
            if (symbolFillColor) delete out.fill;
            else {
                out.fill = signalOrValueRef(config.legend.symbolBaseFillColor ?? 'black');
                out.fillOpacity = signalOrValueRef(opacity ?? 1);
            }
        } else if ((0, _vegaUtil.isArray)(out.fill)) {
            const fill = getFirstConditionValue(encoding.fill ?? encoding.color) ?? markDef.fill ?? (filled && markDef.color);
            if (fill) out.fill = signalOrValueRef(fill);
        }
    }
    if (out.stroke) {
        if (channel === 'stroke' || !filled && channel === COLOR) delete out.stroke;
        else if (hasProperty(out.stroke, 'field') || symbolStrokeColor) // For others, remove stroke field
        delete out.stroke;
        else if ((0, _vegaUtil.isArray)(out.stroke)) {
            const stroke = getFirstDefined(getFirstConditionValue(encoding.stroke || encoding.color), markDef.stroke, filled ? markDef.color : undefined);
            if (stroke) out.stroke = {
                value: stroke
            };
        }
    }
    if (channel !== OPACITY) {
        const condition = isFieldDef(fieldOrDatumDef) && selectedCondition(model, legendCmpt, fieldOrDatumDef);
        if (condition) out.opacity = [
            {
                test: condition,
                ...signalOrValueRef(opacity ?? 1)
            },
            signalOrValueRef(config.legend.unselectedOpacity)
        ];
        else if (opacity) out.opacity = signalOrValueRef(opacity);
    }
    out = {
        ...out,
        ...symbolsSpec
    };
    return isEmpty(out) ? undefined : out;
}
function gradient(gradientSpec, { model, legendType, legendCmpt }) {
    if (legendType !== 'gradient') return undefined;
    const { config, markDef, encoding } = model;
    let out = {};
    const gradientOpacity = legendCmpt.get('gradientOpacity') ?? config.legend.gradientOpacity;
    const opacity = gradientOpacity === undefined ? getMaxValue(encoding.opacity) || markDef.opacity : undefined;
    if (opacity) // only apply opacity if it is neither zero or undefined
    out.opacity = signalOrValueRef(opacity);
    out = {
        ...out,
        ...gradientSpec
    };
    return isEmpty(out) ? undefined : out;
}
function labels$1(specifiedlabelsSpec, { fieldOrDatumDef, model, channel, legendCmpt }) {
    const legend = model.legend(channel) || {};
    const config = model.config;
    const condition = isFieldDef(fieldOrDatumDef) ? selectedCondition(model, legendCmpt, fieldOrDatumDef) : undefined;
    const opacity = condition ? [
        {
            test: condition,
            value: 1
        },
        {
            value: config.legend.unselectedOpacity
        }
    ] : undefined;
    const { format, formatType } = legend;
    let text = undefined;
    if (isCustomFormatType(formatType)) text = formatCustomType({
        fieldOrDatumDef,
        field: 'datum.value',
        format,
        formatType,
        config
    });
    else if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if (fieldOrDatumDef.type === 'quantitative' && config.numberFormatType) text = formatCustomType({
            fieldOrDatumDef,
            field: 'datum.value',
            format: config.numberFormat,
            formatType: config.numberFormatType,
            config
        });
        else if (fieldOrDatumDef.type === 'temporal' && config.timeFormatType && isFieldDef(fieldOrDatumDef) && fieldOrDatumDef.timeUnit === undefined) text = formatCustomType({
            fieldOrDatumDef,
            field: 'datum.value',
            format: config.timeFormat,
            formatType: config.timeFormatType,
            config
        });
    }
    const labelsSpec = {
        ...opacity ? {
            opacity
        } : {},
        ...text ? {
            text
        } : {},
        ...specifiedlabelsSpec
    };
    return isEmpty(labelsSpec) ? undefined : labelsSpec;
}
function entries(entriesSpec, { legendCmpt }) {
    const selections = legendCmpt.get('selections');
    return selections?.length ? {
        ...entriesSpec,
        fill: {
            value: 'transparent'
        }
    } : entriesSpec;
}
function getMaxValue(channelDef) {
    return getConditionValue(channelDef, (v, conditionalDef)=>Math.max(v, conditionalDef.value));
}
function getFirstConditionValue(channelDef) {
    return getConditionValue(channelDef, (v, conditionalDef)=>{
        return getFirstDefined(v, conditionalDef.value);
    });
}
function getConditionValue(channelDef, reducer) {
    if (hasConditionalValueDef(channelDef)) return (0, _vegaUtil.array)(channelDef.condition).reduce(reducer, channelDef.value);
    else if (isValueDef(channelDef)) return channelDef.value;
    return undefined;
}
function selectedCondition(model, legendCmpt, fieldDef) {
    const selections = legendCmpt.get('selections');
    if (!selections?.length) return undefined;
    const field = (0, _vegaUtil.stringValue)(fieldDef.field);
    return selections.map((name)=>{
        const store = (0, _vegaUtil.stringValue)(varName(name) + STORE);
        return `(!length(data(${store})) || (${name}[${field}] && indexof(${name}[${field}], datum.value) >= 0))`;
    }).join(' || ');
}
const legendRules = {
    direction: ({ direction })=>direction,
    format: ({ fieldOrDatumDef, legend, config })=>{
        const { format, formatType } = legend;
        return guideFormat(fieldOrDatumDef, fieldOrDatumDef.type, format, formatType, config, false);
    },
    formatType: ({ legend, fieldOrDatumDef, scaleType })=>{
        const { formatType } = legend;
        return guideFormatType(formatType, fieldOrDatumDef, scaleType);
    },
    gradientLength: (params)=>{
        const { legend, legendConfig } = params;
        return legend.gradientLength ?? legendConfig.gradientLength ?? defaultGradientLength(params);
    },
    labelOverlap: ({ legend, legendConfig, scaleType })=>legend.labelOverlap ?? legendConfig.labelOverlap ?? defaultLabelOverlap(scaleType),
    symbolType: ({ legend, markDef, channel, encoding })=>legend.symbolType ?? defaultSymbolType(markDef.type, channel, encoding.shape, markDef.shape),
    title: ({ fieldOrDatumDef, config })=>title(fieldOrDatumDef, config, {
            allowDisabling: true
        }),
    type: ({ legendType, scaleType, channel })=>{
        if (isColorChannel(channel) && isContinuousToContinuous(scaleType)) {
            if (legendType === 'gradient') return undefined;
        } else if (legendType === 'symbol') return undefined;
        return legendType;
    },
    values: ({ fieldOrDatumDef, legend })=>values(legend, fieldOrDatumDef)
};
function values(legend, fieldOrDatumDef) {
    const vals = legend.values;
    if ((0, _vegaUtil.isArray)(vals)) return valueArray(fieldOrDatumDef, vals);
    else if (isSignalRef(vals)) return vals;
    return undefined;
}
function defaultSymbolType(mark, channel, shapeChannelDef, markShape) {
    if (channel !== 'shape') {
        // use the value from the shape encoding or the mark config if they exist
        const shape = getFirstConditionValue(shapeChannelDef) ?? markShape;
        if (shape) return shape;
    }
    switch(mark){
        case 'bar':
        case 'rect':
        case 'image':
        case 'square':
            return 'square';
        case 'line':
        case 'trail':
        case 'rule':
            return 'stroke';
        case 'arc':
        case 'point':
        case 'circle':
        case 'tick':
        case 'geoshape':
        case 'area':
        case 'text':
            return 'circle';
    }
}
function getLegendType(params) {
    const { legend } = params;
    return getFirstDefined(legend.type, defaultType$1(params));
}
function defaultType$1({ channel, timeUnit, scaleType }) {
    // Following the logic in https://github.com/vega/vega-parser/blob/master/src/parsers/legend.js
    if (isColorChannel(channel)) {
        if (contains([
            'quarter',
            'month',
            'day'
        ], timeUnit)) return 'symbol';
        if (isContinuousToContinuous(scaleType)) return 'gradient';
    }
    return 'symbol';
}
function getDirection({ legendConfig, legendType, orient, legend }) {
    return legend.direction ?? legendConfig[legendType ? 'gradientDirection' : 'symbolDirection'] ?? defaultDirection(orient, legendType);
}
function defaultDirection(orient, legendType) {
    switch(orient){
        case 'top':
        case 'bottom':
            return 'horizontal';
        case 'left':
        case 'right':
        case 'none':
        case undefined:
            return undefined; // vertical is Vega's default
        default:
            // top-left / ...
            // For inner legend, uses compact layout like Tableau
            return legendType === 'gradient' ? 'horizontal' : undefined;
    }
}
function defaultGradientLength({ legendConfig, model, direction, orient, scaleType }) {
    const { gradientHorizontalMaxLength, gradientHorizontalMinLength, gradientVerticalMaxLength, gradientVerticalMinLength } = legendConfig;
    if (isContinuousToContinuous(scaleType)) {
        if (direction === 'horizontal') {
            if (orient === 'top' || orient === 'bottom') return gradientLengthSignal(model, 'width', gradientHorizontalMinLength, gradientHorizontalMaxLength);
            else return gradientHorizontalMinLength;
        } else // vertical / undefined (Vega uses vertical by default)
        return gradientLengthSignal(model, 'height', gradientVerticalMinLength, gradientVerticalMaxLength);
    }
    return undefined;
}
function gradientLengthSignal(model, sizeType, min, max) {
    const sizeSignal = model.getSizeSignalRef(sizeType).signal;
    return {
        signal: `clamp(${sizeSignal}, ${min}, ${max})`
    };
}
function defaultLabelOverlap(scaleType) {
    if (contains([
        'quantile',
        'threshold',
        'log',
        'symlog'
    ], scaleType)) return 'greedy';
    return undefined;
}
function parseLegend(model) {
    const legendComponent = isUnitModel(model) ? parseUnitLegend(model) : parseNonUnitLegend(model);
    model.component.legends = legendComponent;
    return legendComponent;
}
function parseUnitLegend(model) {
    const { encoding } = model;
    const legendComponent = {};
    for (const channel of [
        COLOR,
        ...LEGEND_SCALE_CHANNELS
    ]){
        const def = getFieldOrDatumDef(encoding[channel]);
        if (!def || !model.getScaleComponent(channel)) continue;
        if (channel === SHAPE && isFieldDef(def) && def.type === GEOJSON) continue;
        legendComponent[channel] = parseLegendForChannel(model, channel);
    }
    return legendComponent;
}
function getLegendDefWithScale(model, channel) {
    const scale = model.scaleName(channel);
    if (model.mark === 'trail') {
        if (channel === 'color') // trail is a filled mark, but its default symbolType ("stroke") should use "stroke"
        return {
            stroke: scale
        };
        else if (channel === 'size') return {
            strokeWidth: scale
        };
    }
    if (channel === 'color') return model.markDef.filled ? {
        fill: scale
    } : {
        stroke: scale
    };
    return {
        [channel]: scale
    };
}
function isExplicit$1(value, property, legend, fieldDef) {
    switch(property){
        case 'disable':
            return legend !== undefined; // if axis is specified or null/false, then its enable/disable state is explicit
        case 'values':
            // specified legend.values is already respected, but may get transformed.
            return !!legend?.values;
        case 'title':
            // title can be explicit if fieldDef.title is set
            if (property === 'title' && value === fieldDef?.title) return true;
    }
    // Otherwise, things are explicit if the returned value matches the specified property
    return value === (legend || {})[property];
}
function parseLegendForChannel(model, channel) {
    let legend = model.legend(channel);
    const { markDef, encoding, config } = model;
    const legendConfig = config.legend;
    const legendCmpt = new LegendComponent({}, getLegendDefWithScale(model, channel));
    parseInteractiveLegend(model, channel, legendCmpt);
    const disable = legend !== undefined ? !legend : legendConfig.disable;
    legendCmpt.set('disable', disable, legend !== undefined);
    if (disable) return legendCmpt;
    legend = legend || {};
    const scaleType = model.getScaleComponent(channel).get('type');
    const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
    const timeUnit = isFieldDef(fieldOrDatumDef) ? normalizeTimeUnit(fieldOrDatumDef.timeUnit)?.unit : undefined;
    const orient = legend.orient || config.legend.orient || 'right';
    const legendType = getLegendType({
        legend,
        channel,
        timeUnit,
        scaleType
    });
    const direction = getDirection({
        legend,
        legendType,
        orient,
        legendConfig
    });
    const ruleParams = {
        legend,
        channel,
        model,
        markDef,
        encoding,
        fieldOrDatumDef,
        legendConfig,
        config,
        scaleType,
        orient,
        legendType,
        direction
    };
    for (const property of LEGEND_COMPONENT_PROPERTIES){
        if (legendType === 'gradient' && property.startsWith('symbol') || legendType === 'symbol' && property.startsWith('gradient')) continue;
        const value = property in legendRules ? legendRules[property](ruleParams) : legend[property];
        if (value !== undefined) {
            const explicit = isExplicit$1(value, property, legend, model.fieldDef(channel));
            if (explicit || config.legend[property] === undefined) legendCmpt.set(property, value, explicit);
        }
    }
    const legendEncoding = legend?.encoding ?? {};
    const selections = legendCmpt.get('selections');
    const legendEncode = {};
    const legendEncodeParams = {
        fieldOrDatumDef,
        model,
        channel,
        legendCmpt,
        legendType
    };
    for (const part of [
        'labels',
        'legend',
        'title',
        'symbols',
        'gradient',
        'entries'
    ]){
        // FIXME: remove as any (figure out what legendEncoding.entries is)
        const legendEncodingPart = guideEncodeEntry(legendEncoding[part] ?? {}, model);
        const value = part in legendEncodeRules ? legendEncodeRules[part](legendEncodingPart, legendEncodeParams) // apply rule
         : legendEncodingPart; // no rule -- just default values
        if (value !== undefined && !isEmpty(value)) legendEncode[part] = {
            ...selections?.length && isFieldDef(fieldOrDatumDef) ? {
                name: `${varName(fieldOrDatumDef.field)}_legend_${part}`
            } : {},
            ...selections?.length ? {
                interactive: !!selections
            } : {},
            update: value
        };
    }
    if (!isEmpty(legendEncode)) legendCmpt.set('encode', legendEncode, !!legend?.encoding);
    return legendCmpt;
}
function parseNonUnitLegend(model) {
    const { legends, resolve } = model.component;
    for (const child of model.children){
        parseLegend(child);
        for (const channel of keys(child.component.legends)){
            resolve.legend[channel] = parseGuideResolve(model.component.resolve, channel);
            if (resolve.legend[channel] === 'shared') {
                // If the resolve says shared (and has not been overridden)
                // We will try to merge and see if there is a conflict
                legends[channel] = mergeLegendComponent(legends[channel], child.component.legends[channel]);
                if (!legends[channel]) {
                    // If merge returns nothing, there is a conflict so we cannot make the legend shared.
                    // Thus, mark legend as independent and remove the legend component.
                    resolve.legend[channel] = 'independent';
                    delete legends[channel];
                }
            }
        }
    }
    for (const channel of keys(legends))for (const child of model.children){
        if (!child.component.legends[channel]) continue;
        if (resolve.legend[channel] === 'shared') // After merging shared legend, make sure to remove legend from child
        delete child.component.legends[channel];
    }
    return legends;
}
function mergeLegendComponent(mergedLegend, childLegend) {
    if (!mergedLegend) return childLegend.clone();
    const mergedOrient = mergedLegend.getWithExplicit('orient');
    const childOrient = childLegend.getWithExplicit('orient');
    if (mergedOrient.explicit && childOrient.explicit && mergedOrient.value !== childOrient.value) // TODO: throw warning if resolve is explicit (We don't have info about explicit/implicit resolve yet.)
    // Cannot merge due to inconsistent orient
    return undefined;
    let typeMerged = false;
    // Otherwise, let's merge
    for (const prop of LEGEND_COMPONENT_PROPERTIES){
        const mergedValueWithExplicit = mergeValuesWithExplicit(mergedLegend.getWithExplicit(prop), childLegend.getWithExplicit(prop), prop, 'legend', // Tie breaker function
        (v1, v2)=>{
            switch(prop){
                case 'symbolType':
                    return mergeSymbolType(v1, v2);
                case 'title':
                    return mergeTitleComponent(v1, v2);
                case 'type':
                    // There are only two types. If we have different types, then prefer symbol over gradient.
                    typeMerged = true;
                    return makeImplicit('symbol');
            }
            return defaultTieBreaker(v1, v2, prop, 'legend');
        });
        mergedLegend.setWithExplicit(prop, mergedValueWithExplicit);
    }
    if (typeMerged) {
        if (mergedLegend.implicit?.encode?.gradient) deleteNestedProperty(mergedLegend.implicit, [
            'encode',
            'gradient'
        ]);
        if (mergedLegend.explicit?.encode?.gradient) deleteNestedProperty(mergedLegend.explicit, [
            'encode',
            'gradient'
        ]);
    }
    return mergedLegend;
}
function mergeSymbolType(st1, st2) {
    if (st2.value === 'circle') // prefer "circle" over "stroke"
    return st2;
    return st1;
}
function setLegendEncode(legend, part, vgProp, vgRef) {
    legend.encode ??= {};
    legend.encode[part] ??= {};
    legend.encode[part].update ??= {};
    // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
    legend.encode[part].update[vgProp] = vgRef;
}
function assembleLegends(model) {
    const legendComponentIndex = model.component.legends;
    const legendByDomain = {};
    for (const channel of keys(legendComponentIndex)){
        const scaleComponent = model.getScaleComponent(channel);
        const domainHash = stringify(scaleComponent.get('domains'));
        if (legendByDomain[domainHash]) for (const mergedLegendComponent of legendByDomain[domainHash]){
            const merged = mergeLegendComponent(mergedLegendComponent, legendComponentIndex[channel]);
            if (!merged) // If cannot merge, need to add this legend separately
            legendByDomain[domainHash].push(legendComponentIndex[channel]);
        }
        else legendByDomain[domainHash] = [
            legendComponentIndex[channel].clone()
        ];
    }
    const legends = vals(legendByDomain).flat().map((l)=>assembleLegend(l, model.config)).filter((l)=>l !== undefined);
    return legends;
}
function assembleLegend(legendCmpt, config) {
    const { disable, labelExpr, selections, ...legend } = legendCmpt.combine();
    if (disable) return undefined;
    if (config.aria === false && legend.aria == undefined) legend.aria = false;
    if (legend.encode?.symbols) {
        const out = legend.encode.symbols.update;
        if (out.fill && out.fill['value'] !== 'transparent' && !out.stroke && !legend.stroke) // For non color channel's legend, we need to override symbol stroke config from Vega config if stroke channel is not used.
        out.stroke = {
            value: 'transparent'
        };
        // Remove properties that the legend is encoding.
        for (const property of LEGEND_SCALE_CHANNELS)if (legend[property]) delete out[property];
    }
    if (!legend.title) // title schema doesn't include null, ''
    delete legend.title;
    if (labelExpr !== undefined) {
        let expr = labelExpr;
        if (legend.encode?.labels?.update && isSignalRef(legend.encode.labels.update.text)) expr = replaceAll(labelExpr, 'datum.label', legend.encode.labels.update.text.signal);
        setLegendEncode(legend, 'labels', 'text', {
            signal: expr
        });
    }
    return legend;
}
function assembleProjections(model) {
    if (isLayerModel(model) || isConcatModel(model)) return assembleProjectionsForModelAndChildren(model);
    else return assembleProjectionForModel(model);
}
function assembleProjectionsForModelAndChildren(model) {
    return model.children.reduce((projections, child)=>{
        return projections.concat(child.assembleProjections());
    }, assembleProjectionForModel(model));
}
function assembleProjectionForModel(model) {
    const component = model.component.projection;
    if (!component || component.merged) return [];
    const projection = component.combine();
    const { name } = projection; // we need to extract name so that it is always present in the output and pass TS type validation
    if (!component.data) // generate custom projection, no automatic fitting
    return [
        {
            name,
            // translate to center by default
            translate: {
                signal: '[width / 2, height / 2]'
            },
            // parameters, overwrite default translate if specified
            ...projection
        }
    ];
    else {
        // generate projection that uses extent fitting
        const size = {
            signal: `[${component.size.map((ref)=>ref.signal).join(', ')}]`
        };
        const fits = component.data.reduce((sources, data)=>{
            const source = isSignalRef(data) ? data.signal : `data('${model.lookupDataSource(data)}')`;
            if (!contains(sources, source)) // build a unique list of sources
            sources.push(source);
            return sources;
        }, []);
        if (fits.length <= 0) throw new Error("Projection's fit didn't find any data sources");
        return [
            {
                name,
                size,
                fit: {
                    signal: fits.length > 1 ? `[${fits.join(', ')}]` : fits[0]
                },
                ...projection
            }
        ];
    }
}
const PROJECTION_PROPERTIES = [
    'type',
    'clipAngle',
    'clipExtent',
    'center',
    'rotate',
    'precision',
    'reflectX',
    'reflectY',
    'coefficient',
    'distance',
    'fraction',
    'lobes',
    'parallel',
    'radius',
    'ratio',
    'spacing',
    'tilt'
];
class ProjectionComponent extends Split {
    specifiedProjection;
    size;
    data;
    merged = false;
    constructor(name, specifiedProjection, size, data){
        super({
            ...specifiedProjection
        }, {
            name
        });
        this.specifiedProjection = specifiedProjection;
        this.size = size;
        this.data = data;
    }
    /**
     * Whether the projection parameters should fit provided data.
     */ get isFit() {
        return !!this.data;
    }
}
function parseProjection(model) {
    model.component.projection = isUnitModel(model) ? parseUnitProjection(model) : parseNonUnitProjections(model);
}
function parseUnitProjection(model) {
    if (model.hasProjection) {
        const proj = replaceExprRef(model.specifiedProjection);
        const fit = !(proj && (proj.scale != null || proj.translate != null));
        const size = fit ? [
            model.getSizeSignalRef('width'),
            model.getSizeSignalRef('height')
        ] : undefined;
        const data = fit ? gatherFitData(model) : undefined;
        const projComp = new ProjectionComponent(model.projectionName(true), {
            ...replaceExprRef(model.config.projection),
            ...proj
        }, size, data);
        if (!projComp.get('type')) projComp.set('type', 'equalEarth', false);
        return projComp;
    }
    return undefined;
}
function gatherFitData(model) {
    const data = [];
    const { encoding } = model;
    for (const posssiblePair of [
        [
            LONGITUDE,
            LATITUDE
        ],
        [
            LONGITUDE2,
            LATITUDE2
        ]
    ])if (getFieldOrDatumDef(encoding[posssiblePair[0]]) || getFieldOrDatumDef(encoding[posssiblePair[1]])) data.push({
        signal: model.getName(`geojson_${data.length}`)
    });
    if (model.channelHasField(SHAPE) && model.typedFieldDef(SHAPE).type === GEOJSON) data.push({
        signal: model.getName(`geojson_${data.length}`)
    });
    if (data.length === 0) // main source is geojson, so we can just use that
    data.push(model.requestDataName(DataSourceType.Main));
    return data;
}
function mergeIfNoConflict(first, second) {
    const allPropertiesShared = every(PROJECTION_PROPERTIES, (prop)=>{
        // neither has the property
        if (!(0, _vegaUtil.hasOwnProperty)(first.explicit, prop) && !(0, _vegaUtil.hasOwnProperty)(second.explicit, prop)) return true;
        // both have property and an equal value for property
        if ((0, _vegaUtil.hasOwnProperty)(first.explicit, prop) && (0, _vegaUtil.hasOwnProperty)(second.explicit, prop) && // some properties might be signals or objects and require hashing for comparison
        deepEqual(first.get(prop), second.get(prop))) return true;
        return false;
    });
    const size = deepEqual(first.size, second.size);
    if (size) {
        if (allPropertiesShared) return first;
        else if (deepEqual(first.explicit, {})) return second;
        else if (deepEqual(second.explicit, {})) return first;
    }
    // if all properties don't match, let each unit spec have its own projection
    return null;
}
function parseNonUnitProjections(model) {
    if (model.children.length === 0) return undefined;
    let nonUnitProjection;
    // parse all children first
    for (const child of model.children)parseProjection(child);
    // analyze parsed projections, attempt to merge
    const mergable = every(model.children, (child)=>{
        const projection = child.component.projection;
        if (!projection) // child layer does not use a projection
        return true;
        else if (!nonUnitProjection) {
            // cached 'projection' is null, cache this one
            nonUnitProjection = projection;
            return true;
        } else {
            const merge = mergeIfNoConflict(nonUnitProjection, projection);
            if (merge) nonUnitProjection = merge;
            return !!merge;
        }
    });
    // if cached one and all other children share the same projection,
    if (nonUnitProjection && mergable) {
        // so we can elevate it to the layer level
        const name = model.projectionName(true);
        const modelProjection = new ProjectionComponent(name, nonUnitProjection.specifiedProjection, nonUnitProjection.size, duplicate(nonUnitProjection.data));
        // rename and assign all others as merged
        for (const child of model.children){
            const projection = child.component.projection;
            if (projection) {
                if (projection.isFit) modelProjection.data.push(...child.component.projection.data);
                child.renameProjection(projection.get('name'), name);
                projection.merged = true;
            }
        }
        return modelProjection;
    }
    return undefined;
}
function rangeFormula(model, fieldDef, channel, config) {
    if (binRequiresRange(fieldDef, channel)) {
        // read format from axis or legend, if there is no format then use config.numberFormat
        const guide = isUnitModel(model) ? model.axis(channel) ?? model.legend(channel) ?? {} : {};
        const startField = vgField(fieldDef, {
            expr: 'datum'
        });
        const endField = vgField(fieldDef, {
            expr: 'datum',
            binSuffix: 'end'
        });
        return {
            formulaAs: vgField(fieldDef, {
                binSuffix: 'range',
                forAs: true
            }),
            formula: binFormatExpression(startField, endField, guide.format, guide.formatType, config)
        };
    }
    return {};
}
function binKey(bin, field) {
    return `${binToString(bin)}_${field}`;
}
function getSignalsFromModel(model, key) {
    return {
        signal: model.getName(`${key}_bins`),
        extentSignal: model.getName(`${key}_extent`)
    };
}
function getBinSignalName(model, field, bin) {
    const normalizedBin = normalizeBin(bin, undefined) ?? {};
    const key = binKey(normalizedBin, field);
    return model.getName(`${key}_bins`);
}
function isBinTransform(t) {
    return 'as' in t;
}
function createBinComponent(t, bin, model) {
    let as;
    let span;
    if (isBinTransform(t)) as = (0, _vegaUtil.isString)(t.as) ? [
        t.as,
        `${t.as}_end`
    ] : [
        t.as[0],
        t.as[1]
    ];
    else as = [
        vgField(t, {
            forAs: true
        }),
        vgField(t, {
            binSuffix: 'end',
            forAs: true
        })
    ];
    const normalizedBin = {
        ...normalizeBin(bin, undefined)
    };
    const key = binKey(normalizedBin, t.field);
    const { signal, extentSignal } = getSignalsFromModel(model, key);
    if (isParameterExtent(normalizedBin.extent)) {
        const ext = normalizedBin.extent;
        span = parseSelectionExtent(model, ext.param, ext);
        delete normalizedBin.extent; // Vega-Lite selection extent map to Vega's span property.
    }
    const binComponent = {
        bin: normalizedBin,
        field: t.field,
        as: [
            as
        ],
        ...signal ? {
            signal
        } : {},
        ...extentSignal ? {
            extentSignal
        } : {},
        ...span ? {
            span
        } : {}
    };
    return {
        key,
        binComponent
    };
}
class BinNode extends DataFlowNode {
    bins;
    clone() {
        return new BinNode(null, duplicate(this.bins));
    }
    constructor(parent, bins){
        super(parent);
        this.bins = bins;
    }
    static makeFromEncoding(parent, model) {
        const bins = model.reduceFieldDef((binComponentIndex, fieldDef, channel)=>{
            if (isTypedFieldDef(fieldDef) && isBinning(fieldDef.bin)) {
                const { key, binComponent } = createBinComponent(fieldDef, fieldDef.bin, model);
                binComponentIndex[key] = {
                    ...binComponent,
                    ...binComponentIndex[key],
                    ...rangeFormula(model, fieldDef, channel, model.config)
                };
            }
            return binComponentIndex;
        }, {});
        if (isEmpty(bins)) return null;
        return new BinNode(parent, bins);
    }
    /**
     * Creates a bin node from BinTransform.
     * The optional parameter should provide
     */ static makeFromTransform(parent, t, model) {
        const { key, binComponent } = createBinComponent(t, t.bin, model);
        return new BinNode(parent, {
            [key]: binComponent
        });
    }
    /**
     * Merge bin nodes. This method either integrates the bin config from the other node
     * or if this node already has a bin config, renames the corresponding signal in the model.
     */ merge(other, renameSignal) {
        for (const key of keys(other.bins))if (key in this.bins) {
            renameSignal(other.bins[key].signal, this.bins[key].signal);
            // Ensure that we don't have duplicate names for signal pairs
            this.bins[key].as = unique([
                ...this.bins[key].as,
                ...other.bins[key].as
            ], hash);
        } else this.bins[key] = other.bins[key];
        for (const child of other.children){
            other.removeChild(child);
            child.parent = this;
        }
        other.remove();
    }
    producedFields() {
        return new Set(vals(this.bins).map((c)=>c.as).flat(2));
    }
    dependentFields() {
        return new Set(vals(this.bins).map((c)=>c.field));
    }
    hash() {
        return `Bin ${hash(this.bins)}`;
    }
    assemble() {
        return vals(this.bins).flatMap((bin)=>{
            const transform = [];
            const [binAs, ...remainingAs] = bin.as;
            const { extent, ...params } = bin.bin;
            const binTrans = {
                type: 'bin',
                field: replacePathInField(bin.field),
                as: binAs,
                signal: bin.signal,
                ...!isParameterExtent(extent) ? {
                    extent
                } : {
                    extent: null
                },
                ...bin.span ? {
                    span: {
                        signal: `span(${bin.span})`
                    }
                } : {},
                ...params
            };
            if (!extent && bin.extentSignal) {
                transform.push({
                    type: 'extent',
                    field: replacePathInField(bin.field),
                    signal: bin.extentSignal
                });
                binTrans.extent = {
                    signal: bin.extentSignal
                };
            }
            transform.push(binTrans);
            for (const as of remainingAs)for(let i = 0; i < 2; i++)transform.push({
                type: 'formula',
                expr: vgField({
                    field: binAs[i]
                }, {
                    expr: 'datum'
                }),
                as: as[i]
            });
            if (bin.formula) transform.push({
                type: 'formula',
                expr: bin.formula,
                as: bin.formulaAs
            });
            return transform;
        });
    }
}
function addDimension(dims, channel, fieldDef, model) {
    const channelDef2 = isUnitModel(model) ? model.encoding[getSecondaryRangeChannel(channel)] : undefined;
    if (isTypedFieldDef(fieldDef) && isUnitModel(model) && hasBandEnd(fieldDef, channelDef2, model.markDef, model.config)) {
        dims.add(vgField(fieldDef, {}));
        dims.add(vgField(fieldDef, {
            suffix: 'end'
        }));
        const { mark, markDef, config } = model;
        const bandPosition = getBandPosition({
            fieldDef,
            markDef,
            config
        });
        if (isRectBasedMark(mark) && bandPosition !== 0.5 && isXorY(channel)) {
            dims.add(vgField(fieldDef, {
                suffix: OFFSETTED_RECT_START_SUFFIX
            }));
            dims.add(vgField(fieldDef, {
                suffix: OFFSETTED_RECT_END_SUFFIX
            }));
        }
        if (fieldDef.bin && binRequiresRange(fieldDef, channel)) dims.add(vgField(fieldDef, {
            binSuffix: 'range'
        }));
    } else if (isGeoPositionChannel(channel)) {
        const posChannel = getPositionChannelFromLatLong(channel);
        dims.add(model.getName(posChannel));
    } else dims.add(vgField(fieldDef));
    if (isScaleFieldDef(fieldDef) && isFieldRange(fieldDef.scale?.range)) dims.add(fieldDef.scale.range.field);
    return dims;
}
function mergeMeasures(parentMeasures, childMeasures) {
    for (const field of keys(childMeasures)){
        // when we merge a measure, we either have to add an aggregation operator or even a new field
        const ops = childMeasures[field];
        for (const op of keys(ops))if (field in parentMeasures) // add operator to existing measure field
        parentMeasures[field][op] = new Set([
            ...parentMeasures[field][op] ?? [],
            ...ops[op]
        ]);
        else parentMeasures[field] = {
            [op]: ops[op]
        };
    }
}
class AggregateNode extends DataFlowNode {
    dimensions;
    measures;
    clone() {
        return new AggregateNode(null, new Set(this.dimensions), duplicate(this.measures));
    }
    /**
     * @param dimensions string set for dimensions
     * @param measures dictionary mapping field name => dict of aggregation functions and names to use
     */ constructor(parent, dimensions, measures){
        super(parent);
        this.dimensions = dimensions;
        this.measures = measures;
    }
    get groupBy() {
        return this.dimensions;
    }
    static makeFromEncoding(parent, model) {
        let isAggregate = false;
        model.forEachFieldDef((fd)=>{
            if (fd.aggregate) isAggregate = true;
        });
        const meas = {};
        const dims = new Set();
        if (!isAggregate) // no need to create this node if the model has no aggregation
        return null;
        model.forEachFieldDef((fieldDef, channel)=>{
            const { aggregate, field } = fieldDef;
            if (aggregate) {
                if (aggregate === 'count') {
                    meas['*'] ??= {};
                    meas['*']['count'] = new Set([
                        vgField(fieldDef, {
                            forAs: true
                        })
                    ]);
                } else {
                    if (isArgminDef(aggregate) || isArgmaxDef(aggregate)) {
                        const op = isArgminDef(aggregate) ? 'argmin' : 'argmax';
                        const argField = aggregate[op];
                        meas[argField] ??= {};
                        meas[argField][op] = new Set([
                            vgField({
                                op,
                                field: argField
                            }, {
                                forAs: true
                            })
                        ]);
                    } else {
                        meas[field] ??= {};
                        meas[field][aggregate] = new Set([
                            vgField(fieldDef, {
                                forAs: true
                            })
                        ]);
                    }
                    // For scale channel with domain === 'unaggregated', add min/max so we can use their union as unaggregated domain
                    if (isScaleChannel(channel) && model.scaleDomain(channel) === 'unaggregated') {
                        meas[field] ??= {};
                        meas[field]['min'] = new Set([
                            vgField({
                                field,
                                aggregate: 'min'
                            }, {
                                forAs: true
                            })
                        ]);
                        meas[field]['max'] = new Set([
                            vgField({
                                field,
                                aggregate: 'max'
                            }, {
                                forAs: true
                            })
                        ]);
                    }
                }
            } else addDimension(dims, channel, fieldDef, model);
        });
        if (dims.size + keys(meas).length === 0) return null;
        return new AggregateNode(parent, dims, meas);
    }
    static makeFromTransform(parent, t) {
        const dims = new Set();
        const meas = {};
        for (const s of t.aggregate){
            const { op, field, as } = s;
            if (op) {
                if (op === 'count') {
                    meas['*'] ??= {};
                    meas['*']['count'] = new Set([
                        as ? as : vgField(s, {
                            forAs: true
                        })
                    ]);
                } else {
                    meas[field] ??= {};
                    meas[field][op] ??= new Set();
                    meas[field][op].add(as ? as : vgField(s, {
                        forAs: true
                    }));
                }
            }
        }
        for (const s of t.groupby ?? [])dims.add(s);
        if (dims.size + keys(meas).length === 0) return null;
        return new AggregateNode(parent, dims, meas);
    }
    merge(other) {
        if (setEqual(this.dimensions, other.dimensions)) {
            mergeMeasures(this.measures, other.measures);
            return true;
        }
        debug('different dimensions, cannot merge');
        return false;
    }
    addDimensions(fields) {
        fields.forEach(this.dimensions.add, this.dimensions);
    }
    dependentFields() {
        return new Set([
            ...this.dimensions,
            ...keys(this.measures)
        ]);
    }
    producedFields() {
        const out = new Set();
        for (const field of keys(this.measures))for (const op of keys(this.measures[field])){
            const m = this.measures[field][op];
            if (m.size === 0) out.add(`${op}_${field}`);
            else m.forEach(out.add, out);
        }
        return out;
    }
    hash() {
        return `Aggregate ${hash({
            dimensions: this.dimensions,
            measures: this.measures
        })}`;
    }
    assemble() {
        const ops = [];
        const fields = [];
        const as = [];
        for (const field of keys(this.measures)){
            for (const op of keys(this.measures[field]))for (const alias of this.measures[field][op]){
                as.push(alias);
                ops.push(op);
                fields.push(field === '*' ? null : replacePathInField(field));
            }
        }
        const result = {
            type: 'aggregate',
            groupby: [
                ...this.dimensions
            ].map(replacePathInField),
            ops,
            fields,
            as
        };
        return result;
    }
}
/**
 * A node that helps us track what fields we are faceting by.
 */ class FacetNode extends DataFlowNode {
    model;
    name;
    data;
    column;
    row;
    facet;
    childModel;
    /**
     * @param model The facet model.
     * @param name The name that this facet source will have.
     * @param data The source data for this facet data.
     */ constructor(parent, model, name, data){
        super(parent);
        this.model = model;
        this.name = name;
        this.data = data;
        for (const channel of FACET_CHANNELS){
            const fieldDef = model.facet[channel];
            if (fieldDef) {
                const { bin, sort } = fieldDef;
                this[channel] = {
                    name: model.getName(`${channel}_domain`),
                    fields: [
                        vgField(fieldDef),
                        ...isBinning(bin) ? [
                            vgField(fieldDef, {
                                binSuffix: 'end'
                            })
                        ] : []
                    ],
                    ...isSortField(sort) ? {
                        sortField: sort
                    } : (0, _vegaUtil.isArray)(sort) ? {
                        sortIndexField: sortArrayIndexField(fieldDef, channel)
                    } : {}
                };
            }
        }
        this.childModel = model.child;
    }
    hash() {
        let out = `Facet`;
        for (const channel of FACET_CHANNELS)if (this[channel]) out += ` ${channel.charAt(0)}:${hash(this[channel])}`;
        return out;
    }
    get fields() {
        const f = [];
        for (const channel of FACET_CHANNELS)if (this[channel]?.fields) f.push(...this[channel].fields);
        return f;
    }
    dependentFields() {
        const depFields = new Set(this.fields);
        for (const channel of FACET_CHANNELS)if (this[channel]) {
            if (this[channel].sortField) depFields.add(this[channel].sortField.field);
            if (this[channel].sortIndexField) depFields.add(this[channel].sortIndexField);
        }
        return depFields;
    }
    producedFields() {
        return new Set(); // facet does not produce any new fields
    }
    /**
     * The name to reference this source is its name.
     */ getSource() {
        return this.name;
    }
    getChildIndependentFieldsWithStep() {
        const childIndependentFieldsWithStep = {};
        for (const channel of POSITION_SCALE_CHANNELS){
            const childScaleComponent = this.childModel.component.scales[channel];
            if (childScaleComponent && !childScaleComponent.merged) {
                // independent scale
                const type = childScaleComponent.get('type');
                const range = childScaleComponent.get('range');
                if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
                    const domain = assembleDomain(this.childModel, channel);
                    const field = getFieldFromDomain(domain);
                    if (field) childIndependentFieldsWithStep[channel] = field;
                    else warn(unknownField(channel));
                }
            }
        }
        return childIndependentFieldsWithStep;
    }
    assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep) {
        const childChannel = {
            row: 'y',
            column: 'x',
            facet: undefined
        }[channel];
        const fields = [];
        const ops = [];
        const as = [];
        if (childChannel && childIndependentFieldsWithStep && childIndependentFieldsWithStep[childChannel]) {
            if (crossedDataName) {
                // If there is a crossed data, calculate max
                fields.push(`distinct_${childIndependentFieldsWithStep[childChannel]}`);
                ops.push('max');
            } else {
                // If there is no crossed data, just calculate distinct
                fields.push(childIndependentFieldsWithStep[childChannel]);
                ops.push('distinct');
            }
            // Although it is technically a max, just name it distinct so it's easier to refer to it
            as.push(`distinct_${childIndependentFieldsWithStep[childChannel]}`);
        }
        const { sortField, sortIndexField } = this[channel];
        if (sortField) {
            const { op = DEFAULT_SORT_OP, field } = sortField;
            fields.push(field);
            ops.push(op);
            as.push(vgField(sortField, {
                forAs: true
            }));
        } else if (sortIndexField) {
            fields.push(sortIndexField);
            ops.push('max');
            as.push(sortIndexField);
        }
        return {
            name: this[channel].name,
            // Use data from the crossed one if it exist
            source: crossedDataName ?? this.data,
            transform: [
                {
                    type: 'aggregate',
                    groupby: this[channel].fields,
                    ...fields.length ? {
                        fields,
                        ops,
                        as
                    } : {}
                }
            ]
        };
    }
    assembleFacetHeaderData(childIndependentFieldsWithStep) {
        const { columns } = this.model.layout;
        const { layoutHeaders } = this.model.component;
        const data = [];
        const hasSharedAxis = {};
        for (const headerChannel of HEADER_CHANNELS){
            for (const headerType of HEADER_TYPES){
                const headers = layoutHeaders[headerChannel]?.[headerType] ?? [];
                for (const header of headers)if (header.axes?.length > 0) {
                    hasSharedAxis[headerChannel] = true;
                    break;
                }
            }
            if (hasSharedAxis[headerChannel]) {
                const cardinality = `length(data("${this.facet.name}"))`;
                const stop = headerChannel === 'row' ? columns ? {
                    signal: `ceil(${cardinality} / ${columns})`
                } : 1 : columns ? {
                    signal: `min(${cardinality}, ${columns})`
                } : {
                    signal: cardinality
                };
                data.push({
                    name: `${this.facet.name}_${headerChannel}`,
                    transform: [
                        {
                            type: 'sequence',
                            start: 0,
                            stop
                        }
                    ]
                });
            }
        }
        const { row, column } = hasSharedAxis;
        if (row || column) data.unshift(this.assembleRowColumnHeaderData('facet', null, childIndependentFieldsWithStep));
        return data;
    }
    assemble() {
        const data = [];
        let crossedDataName = null;
        const childIndependentFieldsWithStep = this.getChildIndependentFieldsWithStep();
        const { column, row, facet } = this;
        if (column && row && (childIndependentFieldsWithStep.x || childIndependentFieldsWithStep.y)) {
            // Need to create a cross dataset to correctly calculate cardinality
            crossedDataName = `cross_${this.column.name}_${this.row.name}`;
            const fields = [].concat(childIndependentFieldsWithStep.x ?? [], childIndependentFieldsWithStep.y ?? []);
            const ops = fields.map(()=>'distinct');
            data.push({
                name: crossedDataName,
                source: this.data,
                transform: [
                    {
                        type: 'aggregate',
                        groupby: this.fields,
                        fields,
                        ops
                    }
                ]
            });
        }
        for (const channel of [
            COLUMN,
            ROW
        ])if (this[channel]) data.push(this.assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep));
        if (facet) {
            const facetData = this.assembleFacetHeaderData(childIndependentFieldsWithStep);
            if (facetData) data.push(...facetData);
        }
        return data;
    }
}
/**
 * Remove quotes from a string.
 */ function unquote(pattern) {
    if (pattern.startsWith("'") && pattern.endsWith("'") || pattern.startsWith('"') && pattern.endsWith('"')) return pattern.slice(1, -1);
    return pattern;
}
/**
 * @param field The field.
 * @param parse What to parse the field as.
 */ function parseExpression(field, parse) {
    const f = accessPathWithDatum(field);
    if (parse === 'number') return `toNumber(${f})`;
    else if (parse === 'boolean') return `toBoolean(${f})`;
    else if (parse === 'string') return `toString(${f})`;
    else if (parse === 'date') return `toDate(${f})`;
    else if (parse === 'flatten') return f;
    else if (parse.startsWith('date:')) {
        const specifier = unquote(parse.slice(5, parse.length));
        return `timeParse(${f},'${specifier}')`;
    } else if (parse.startsWith('utc:')) {
        const specifier = unquote(parse.slice(4, parse.length));
        return `utcParse(${f},'${specifier}')`;
    } else {
        warn(unrecognizedParse(parse));
        return null;
    }
}
function getImplicitFromFilterTransform(transform) {
    const implicit = {};
    forEachLeaf(transform.filter, (filter)=>{
        if (isFieldPredicate(filter)) {
            // Automatically add a parse node for filters with filter objects
            let val = null;
            // For EqualFilter, just use the equal property.
            // For RangeFilter and OneOfFilter, all array members should have
            // the same type, so we only use the first one.
            if (isFieldEqualPredicate(filter)) val = signalRefOrValue(filter.equal);
            else if (isFieldLTEPredicate(filter)) val = signalRefOrValue(filter.lte);
            else if (isFieldLTPredicate(filter)) val = signalRefOrValue(filter.lt);
            else if (isFieldGTPredicate(filter)) val = signalRefOrValue(filter.gt);
            else if (isFieldGTEPredicate(filter)) val = signalRefOrValue(filter.gte);
            else if (isFieldRangePredicate(filter)) // FIXME: remove as any
            val = filter.range[0];
            else if (isFieldOneOfPredicate(filter)) val = (filter.oneOf ?? filter.in)[0];
             // else -- for filter expression, we can't infer anything
            if (val) {
                if (isDateTime(val)) implicit[filter.field] = 'date';
                else if ((0, _vegaUtil.isNumber)(val)) implicit[filter.field] = 'number';
                else if ((0, _vegaUtil.isString)(val)) implicit[filter.field] = 'string';
            }
            if (filter.timeUnit) implicit[filter.field] = 'date';
        }
    });
    return implicit;
}
/**
 * Creates a parse node for implicit parsing from a model and updates ancestorParse.
 */ function getImplicitFromEncoding(model) {
    const implicit = {};
    function add(fieldDef) {
        if (isFieldOrDatumDefForTimeFormat(fieldDef)) implicit[fieldDef.field] = 'date';
        else if (fieldDef.type === 'quantitative' && isMinMaxOp(fieldDef.aggregate) // we need to parse numbers to support correct min and max
        ) implicit[fieldDef.field] = 'number';
        else if (accessPathDepth(fieldDef.field) > 1) // For non-date/non-number (strings and booleans), derive a flattened field for a referenced nested field.
        // (Parsing numbers / dates already flattens numeric and temporal fields.)
        {
            if (!(fieldDef.field in implicit)) implicit[fieldDef.field] = 'flatten';
        } else if (isScaleFieldDef(fieldDef) && isSortField(fieldDef.sort) && accessPathDepth(fieldDef.sort.field) > 1) // Flatten fields that we sort by but that are not otherwise flattened.
        {
            if (!(fieldDef.sort.field in implicit)) implicit[fieldDef.sort.field] = 'flatten';
        }
    }
    if (isUnitModel(model) || isFacetModel(model)) // Parse encoded fields
    model.forEachFieldDef((fieldDef, channel)=>{
        if (isTypedFieldDef(fieldDef)) add(fieldDef);
        else {
            const mainChannel = getMainRangeChannel(channel);
            const mainFieldDef = model.fieldDef(mainChannel);
            add({
                ...fieldDef,
                type: mainFieldDef.type
            });
        }
    });
    // Parse quantitative dimension fields of path marks as numbers so that we sort them correctly.
    if (isUnitModel(model)) {
        const { mark, markDef, encoding } = model;
        if (isPathMark(mark) && // No need to sort by dimension if we have a connected scatterplot (order channel is present)
        !model.encoding.order) {
            const dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
            const dimensionChannelDef = encoding[dimensionChannel];
            if (isFieldDef(dimensionChannelDef) && dimensionChannelDef.type === 'quantitative' && !(dimensionChannelDef.field in implicit)) implicit[dimensionChannelDef.field] = 'number';
        }
    }
    return implicit;
}
/**
 * Creates a parse node for implicit parsing from a model and updates ancestorParse.
 */ function getImplicitFromSelection(model) {
    const implicit = {};
    if (isUnitModel(model) && model.component.selection) for (const name of keys(model.component.selection)){
        const selCmpt = model.component.selection[name];
        for (const proj of selCmpt.project.items)if (!proj.channel && accessPathDepth(proj.field) > 1) implicit[proj.field] = 'flatten';
    }
    return implicit;
}
class ParseNode extends DataFlowNode {
    _parse;
    clone() {
        return new ParseNode(null, duplicate(this._parse));
    }
    constructor(parent, parse){
        super(parent);
        this._parse = parse;
    }
    hash() {
        return `Parse ${hash(this._parse)}`;
    }
    /**
     * Creates a parse node from a data.format.parse and updates ancestorParse.
     */ static makeExplicit(parent, model, ancestorParse) {
        // Custom parse
        let explicit = {};
        const data = model.data;
        if (!isGenerator(data) && data?.format?.parse) explicit = data.format.parse;
        return this.makeWithAncestors(parent, explicit, {}, ancestorParse);
    }
    /**
     * Creates a parse node from "explicit" parse and "implicit" parse and updates ancestorParse.
     */ static makeWithAncestors(parent, explicit, implicit, ancestorParse) {
        // We should not parse what has already been parsed in a parent (explicitly or implicitly) or what has been derived (maked as "derived"). We also don't need to flatten a field that has already been parsed.
        for (const field of keys(implicit)){
            const parsedAs = ancestorParse.getWithExplicit(field);
            if (parsedAs.value !== undefined) {
                // We always ignore derived fields even if they are implicitly defined because we expect users to create the right types.
                if (parsedAs.explicit || parsedAs.value === implicit[field] || parsedAs.value === 'derived' || implicit[field] === 'flatten') delete implicit[field];
                else warn(differentParse(field, implicit[field], parsedAs.value));
            }
        }
        for (const field of keys(explicit)){
            const parsedAs = ancestorParse.get(field);
            if (parsedAs !== undefined) {
                // Don't parse a field again if it has been parsed with the same type already.
                if (parsedAs === explicit[field]) delete explicit[field];
                else warn(differentParse(field, explicit[field], parsedAs));
            }
        }
        const parse = new Split(explicit, implicit);
        // add the format parse from this model so that children don't parse the same field again
        ancestorParse.copyAll(parse);
        // copy only non-null parses
        const p = {};
        for (const key of keys(parse.combine())){
            const val = parse.get(key);
            if (val !== null) p[key] = val;
        }
        if (keys(p).length === 0 || ancestorParse.parseNothing) return null;
        return new ParseNode(parent, p);
    }
    get parse() {
        return this._parse;
    }
    merge(other) {
        this._parse = {
            ...this._parse,
            ...other.parse
        };
        other.remove();
    }
    /**
     * Assemble an object for Vega's format.parse property.
     */ assembleFormatParse() {
        const formatParse = {};
        for (const field of keys(this._parse)){
            const p = this._parse[field];
            if (accessPathDepth(field) === 1) formatParse[field] = p;
        }
        return formatParse;
    }
    // format parse depends and produces all fields in its parse
    producedFields() {
        return new Set(keys(this._parse));
    }
    dependentFields() {
        return new Set(keys(this._parse));
    }
    assembleTransforms(onlyNested = false) {
        return keys(this._parse).filter((field)=>onlyNested ? accessPathDepth(field) > 1 : true).map((field)=>{
            const expr = parseExpression(field, this._parse[field]);
            if (!expr) return null;
            const formula = {
                type: 'formula',
                expr,
                as: removePathFromField(field)
            };
            return formula;
        }).filter((t)=>t !== null);
    }
}
class IdentifierNode extends DataFlowNode {
    clone() {
        return new IdentifierNode(null);
    }
    constructor(parent){
        super(parent);
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set([
            SELECTION_ID
        ]);
    }
    hash() {
        return 'Identifier';
    }
    assemble() {
        return {
            type: 'identifier',
            as: SELECTION_ID
        };
    }
}
class GraticuleNode extends DataFlowNode {
    params;
    clone() {
        return new GraticuleNode(null, this.params);
    }
    constructor(parent, params){
        super(parent);
        this.params = params;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return undefined; // there should never be a node before graticule
    }
    hash() {
        return `Graticule ${hash(this.params)}`;
    }
    assemble() {
        return {
            type: 'graticule',
            ...this.params === true ? {} : this.params
        };
    }
}
class SequenceNode extends DataFlowNode {
    params;
    clone() {
        return new SequenceNode(null, this.params);
    }
    constructor(parent, params){
        super(parent);
        this.params = params;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set([
            this.params.as ?? 'data'
        ]);
    }
    hash() {
        return `Hash ${hash(this.params)}`;
    }
    assemble() {
        return {
            type: 'sequence',
            ...this.params
        };
    }
}
class SourceNode extends DataFlowNode {
    _data;
    _name;
    _generator;
    constructor(data){
        super(null); // source cannot have parent
        data ??= {
            name: 'source'
        };
        let format;
        if (!isGenerator(data)) format = data.format ? {
            ...omit(data.format, [
                'parse'
            ])
        } : {};
        if (isInlineData(data)) this._data = {
            values: data.values
        };
        else if (isUrlData(data)) {
            this._data = {
                url: data.url
            };
            if (!format.type) {
                // Extract extension from URL using snippet from
                // http://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript
                let defaultExtension = /(?:\.([^.]+))?$/.exec(data.url)[1];
                if (!contains([
                    'json',
                    'csv',
                    'tsv',
                    'dsv',
                    'topojson'
                ], defaultExtension)) defaultExtension = 'json';
                // defaultExtension has type string but we ensure that it is DataFormatType above
                format.type = defaultExtension;
            }
        } else if (isSphereGenerator(data)) // hardwire GeoJSON sphere data into output specification
        this._data = {
            values: [
                {
                    type: 'Sphere'
                }
            ]
        };
        else if (isNamedData(data) || isGenerator(data)) this._data = {};
        // set flag to check if generator
        this._generator = isGenerator(data);
        // any dataset can be named
        if (data.name) this._name = data.name;
        if (format && !isEmpty(format)) this._data.format = format;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return undefined; // we don't know what this source produces
    }
    get data() {
        return this._data;
    }
    hasName() {
        return !!this._name;
    }
    get isGenerator() {
        return this._generator;
    }
    get dataName() {
        return this._name;
    }
    set dataName(name) {
        this._name = name;
    }
    set parent(parent) {
        throw new Error('Source nodes have to be roots.');
    }
    remove() {
        throw new Error('Source nodes are roots and cannot be removed.');
    }
    hash() {
        throw new Error('Cannot hash sources');
    }
    assemble() {
        return {
            name: this._name,
            ...this._data,
            transform: []
        };
    }
}
/**
 * Whether this dataflow node is the source of the dataflow that produces data i.e. a source or a generator.
 */ function isDataSourceNode(node) {
    return node instanceof SourceNode || node instanceof GraticuleNode || node instanceof SequenceNode;
}
/**
 * Abstract base class for Dataflow optimizers.
 * Contains only mutation handling logic. Subclasses need to implement iteration logic.
 */ class Optimizer {
    #modified;
    constructor(){
        this.#modified = false;
    }
    // Once true, #modified is never set to false
    setModified() {
        this.#modified = true;
    }
    get modifiedFlag() {
        return this.#modified;
    }
}
/**
 * Starts from a node and runs the optimization function (the "run" method) upwards to the root,
 * depending on the continue and modified flag values returned by the optimization function.
 */ class BottomUpOptimizer extends Optimizer {
    /**
     * Compute a map of node depths that we can use to determine a topological sort order.
     */ getNodeDepths(node, depth, depths) {
        depths.set(node, depth);
        for (const child of node.children)this.getNodeDepths(child, depth + 1, depths);
        return depths;
    }
    /**
     * Run the optimizer on all nodes starting from the leaves.
     */ optimize(node) {
        const depths = this.getNodeDepths(node, 0, new Map());
        const topologicalSort = [
            ...depths.entries()
        ].sort((a, b)=>b[1] - a[1]);
        for (const tuple of topologicalSort)this.run(tuple[0]);
        return this.modifiedFlag;
    }
}
/**
 * The optimizer function (the "run" method), is invoked on the given node and then continues recursively.
 */ class TopDownOptimizer extends Optimizer {
    /**
     * Run the optimizer depth first on all nodes starting from the roots.
     */ optimize(node) {
        this.run(node);
        for (const child of node.children)this.optimize(child);
        return this.modifiedFlag;
    }
}
/**
 * Merge identical nodes at forks by comparing hashes.
 *
 * Does not need to iterate from leaves so we implement this with recursion as it's a bit simpler.
 */ class MergeIdenticalNodes extends TopDownOptimizer {
    mergeNodes(parent, nodes) {
        const mergedNode = nodes.shift();
        for (const node of nodes){
            parent.removeChild(node);
            node.parent = mergedNode;
            node.remove();
        }
    }
    run(node) {
        const hashes = node.children.map((x)=>x.hash());
        const buckets = {};
        for(let i = 0; i < hashes.length; i++)if (buckets[hashes[i]] === undefined) buckets[hashes[i]] = [
            node.children[i]
        ];
        else buckets[hashes[i]].push(node.children[i]);
        for (const k of keys(buckets))if (buckets[k].length > 1) {
            this.setModified();
            this.mergeNodes(node, buckets[k]);
        }
    }
}
/**
 * Optimizer that removes identifier nodes that are not needed for selections.
 */ class RemoveUnnecessaryIdentifierNodes extends TopDownOptimizer {
    requiresSelectionId;
    constructor(model){
        super();
        this.requiresSelectionId = model && requiresSelectionId(model);
    }
    run(node) {
        if (node instanceof IdentifierNode) // Only preserve IdentifierNodes if we have default discrete selections
        // in our model tree, and if the nodes come after tuple producing nodes.
        {
            if (!(this.requiresSelectionId && (isDataSourceNode(node.parent) || node.parent instanceof AggregateNode || node.parent instanceof ParseNode))) {
                this.setModified();
                node.remove();
            }
        }
    }
}
/**
 * Removes duplicate time unit nodes (as determined by the name of the output field) that may be generated due to
 * selections projected over time units. Only keeps the first time unit in any branch.
 *
 * This optimizer is a custom top down optimizer that keep track of produced fields in a branch.
 */ class RemoveDuplicateTimeUnits extends Optimizer {
    optimize(node) {
        this.run(node, new Set());
        return this.modifiedFlag;
    }
    run(node, timeUnitFields) {
        let producedFields = new Set();
        if (node instanceof TimeUnitNode) {
            producedFields = node.producedFields();
            if (hasIntersection(producedFields, timeUnitFields)) {
                this.setModified();
                node.removeFormulas(timeUnitFields);
                if (node.producedFields.length === 0) node.remove();
            }
        }
        for (const child of node.children)this.run(child, new Set([
            ...timeUnitFields,
            ...producedFields
        ]));
    }
}
/**
 * Remove output nodes that are not required.
 */ class RemoveUnnecessaryOutputNodes extends TopDownOptimizer {
    constructor(){
        super();
    }
    run(node) {
        if (node instanceof OutputNode && !node.isRequired()) {
            this.setModified();
            node.remove();
        }
    }
}
/**
 * Move parse nodes up to forks and merges them if possible.
 */ class MoveParseUp extends BottomUpOptimizer {
    run(node) {
        if (isDataSourceNode(node)) return;
        if (node.numChildren() > 1) // Don't move parse further up but continue with parent.
        return;
        for (const child of node.children)if (child instanceof ParseNode) {
            if (node instanceof ParseNode) {
                this.setModified();
                node.merge(child);
            } else {
                // Don't swap with nodes that produce something that the parse node depends on (e.g. lookup).
                if (fieldIntersection(node.producedFields(), child.dependentFields())) continue;
                this.setModified();
                child.swapWithParent();
            }
        }
        return;
    }
}
/**
 * Inserts an intermediate ParseNode containing all non-conflicting parse fields and removes the empty ParseNodes.
 *
 * We assume that dependent paths that do not have a parse node can be just merged.
 */ class MergeParse extends BottomUpOptimizer {
    run(node) {
        const originalChildren = [
            ...node.children
        ];
        const parseChildren = node.children.filter((child)=>child instanceof ParseNode);
        if (node.numChildren() > 1 && parseChildren.length >= 1) {
            const commonParse = {};
            const conflictingParse = new Set();
            for (const parseNode of parseChildren){
                const parse = parseNode.parse;
                for (const k of keys(parse)){
                    if (!(k in commonParse)) commonParse[k] = parse[k];
                    else if (commonParse[k] !== parse[k]) conflictingParse.add(k);
                }
            }
            for (const field of conflictingParse)delete commonParse[field];
            if (!isEmpty(commonParse)) {
                this.setModified();
                const mergedParseNode = new ParseNode(node, commonParse);
                for (const childNode of originalChildren){
                    if (childNode instanceof ParseNode) for (const key of keys(commonParse))delete childNode.parse[key];
                    node.removeChild(childNode);
                    childNode.parent = mergedParseNode;
                    // remove empty parse nodes
                    if (childNode instanceof ParseNode && keys(childNode.parse).length === 0) childNode.remove();
                }
            }
        }
    }
}
/**
 * Repeatedly remove leaf nodes that are not output or facet nodes.
 * The reason is that we don't need subtrees that don't have any output nodes.
 * Facet nodes are needed for the row or column domains.
 */ class RemoveUnusedSubtrees extends BottomUpOptimizer {
    run(node) {
        if (node instanceof OutputNode || node.numChildren() > 0 || node instanceof FacetNode) ;
        else if (node instanceof SourceNode) ;
        else {
            this.setModified();
            node.remove();
        }
    }
}
/**
 * Merge adjacent time unit nodes.
 */ class MergeTimeUnits extends BottomUpOptimizer {
    run(node) {
        const timeUnitChildren = node.children.filter((x)=>x instanceof TimeUnitNode);
        const combination = timeUnitChildren.pop();
        for (const timeUnit of timeUnitChildren){
            this.setModified();
            combination.merge(timeUnit);
        }
    }
}
class MergeAggregates extends BottomUpOptimizer {
    run(node) {
        const aggChildren = node.children.filter((child)=>child instanceof AggregateNode);
        // Object which we'll use to map the fields which an aggregate is grouped by to
        // the set of aggregates with that grouping. This is useful as only aggregates
        // with the same group by can be merged
        const groupedAggregates = {};
        // Build groupedAggregates
        for (const agg of aggChildren){
            const groupBys = hash(agg.groupBy);
            if (!(groupBys in groupedAggregates)) groupedAggregates[groupBys] = [];
            groupedAggregates[groupBys].push(agg);
        }
        // Merge aggregateNodes with same key in groupedAggregates
        for (const group of keys(groupedAggregates)){
            const mergeableAggs = groupedAggregates[group];
            if (mergeableAggs.length > 1) {
                const mergedAggs = mergeableAggs.pop();
                for (const agg of mergeableAggs)if (mergedAggs.merge(agg)) {
                    node.removeChild(agg);
                    agg.parent = mergedAggs;
                    agg.remove();
                    this.setModified();
                }
            }
        }
    }
}
/**
 * Merge bin nodes and move them up through forks. Stop at filters, parse, identifier as we want them to stay before the bin node.
 */ class MergeBins extends BottomUpOptimizer {
    model;
    constructor(model){
        super();
        this.model = model;
    }
    run(node) {
        const moveBinsUp = !(isDataSourceNode(node) || node instanceof FilterNode || node instanceof ParseNode || node instanceof IdentifierNode);
        const promotableBins = [];
        const remainingBins = [];
        for (const child of node.children)if (child instanceof BinNode) {
            if (moveBinsUp && !fieldIntersection(node.producedFields(), child.dependentFields())) promotableBins.push(child);
            else remainingBins.push(child);
        }
        if (promotableBins.length > 0) {
            const promotedBin = promotableBins.pop();
            for (const bin of promotableBins)promotedBin.merge(bin, this.model.renameSignal.bind(this.model));
            this.setModified();
            if (node instanceof BinNode) node.merge(promotedBin, this.model.renameSignal.bind(this.model));
            else promotedBin.swapWithParent();
        }
        if (remainingBins.length > 1) {
            const remainingBin = remainingBins.pop();
            for (const bin of remainingBins)remainingBin.merge(bin, this.model.renameSignal.bind(this.model));
            this.setModified();
        }
    }
}
/**
 * This optimizer takes output nodes that are at a fork and moves them before the fork.
 *
 * The algorithm iterates over the children and tries to find the last output node in a chain of output nodes.
 * It then moves all output nodes before that main output node. All other children (and the children of the output nodes)
 * are inserted after the main output node.
 */ class MergeOutputs extends BottomUpOptimizer {
    run(node) {
        const children = [
            ...node.children
        ];
        const hasOutputChild = some(children, (child)=>child instanceof OutputNode);
        if (!hasOutputChild || node.numChildren() <= 1) return;
        const otherChildren = [];
        // The output node we will connect all other nodes to.
        // Output nodes will be added before the new node, other nodes after.
        let mainOutput;
        for (const child of children)if (child instanceof OutputNode) {
            let lastOutput = child;
            while(lastOutput.numChildren() === 1){
                const [theChild] = lastOutput.children;
                if (theChild instanceof OutputNode) lastOutput = theChild;
                else break;
            }
            otherChildren.push(...lastOutput.children);
            if (mainOutput) {
                // Move the output nodes before the mainOutput. We do this by setting
                // the parent of the first not to the parent of the main output and
                // the main output's parent to the last output.
                // note: the child is the first output
                node.removeChild(child);
                child.parent = mainOutput.parent;
                mainOutput.parent.removeChild(mainOutput);
                mainOutput.parent = lastOutput;
                this.setModified();
            } else mainOutput = lastOutput;
        } else otherChildren.push(child);
        if (otherChildren.length) {
            this.setModified();
            for (const child of otherChildren){
                child.parent.removeChild(child);
                child.parent = mainOutput;
            }
        }
    }
}
/**
 * A class for the join aggregate transform nodes.
 */ class JoinAggregateTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new JoinAggregateTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    addDimensions(fields) {
        this.transform.groupby = unique(this.transform.groupby.concat(fields), (d)=>d);
    }
    dependentFields() {
        const out = new Set();
        if (this.transform.groupby) this.transform.groupby.forEach(out.add, out);
        this.transform.joinaggregate.map((w)=>w.field).filter((f)=>f !== undefined).forEach(out.add, out);
        return out;
    }
    producedFields() {
        return new Set(this.transform.joinaggregate.map(this.getDefaultName));
    }
    getDefaultName(joinAggregateFieldDef) {
        return joinAggregateFieldDef.as ?? vgField(joinAggregateFieldDef);
    }
    hash() {
        return `JoinAggregateTransform ${hash(this.transform)}`;
    }
    assemble() {
        const fields = [];
        const ops = [];
        const as = [];
        for (const joinaggregate of this.transform.joinaggregate){
            ops.push(joinaggregate.op);
            as.push(this.getDefaultName(joinaggregate));
            fields.push(joinaggregate.field === undefined ? null : joinaggregate.field);
        }
        const groupby = this.transform.groupby;
        return {
            type: 'joinaggregate',
            as,
            ops,
            fields,
            ...groupby !== undefined ? {
                groupby
            } : {}
        };
    }
}
class FilterInvalidNode extends DataFlowNode {
    filter;
    clone() {
        return new FilterInvalidNode(null, {
            ...this.filter
        });
    }
    constructor(parent, filter){
        super(parent);
        this.filter = filter;
    }
    static make(parent, model, dataSourcesForHandlingInvalidValues) {
        const { config, markDef } = model;
        const { marks, scales } = dataSourcesForHandlingInvalidValues;
        if (marks === 'include-invalid-values' && scales === 'include-invalid-values') // If neither marks nor scale domains need data source to filter null values, then don't add the filter.
        return null;
        const filter = model.reduceFieldDef((aggregator, fieldDef, channel)=>{
            const scaleComponent = isScaleChannel(channel) && model.getScaleComponent(channel);
            if (scaleComponent) {
                const scaleType = scaleComponent.get('type');
                const { aggregate } = fieldDef;
                const invalidDataMode = getScaleInvalidDataMode({
                    scaleChannel: channel,
                    markDef,
                    config,
                    scaleType,
                    isCountAggregate: isCountingAggregateOp(aggregate)
                });
                // If the invalid data mode is include or always-valid, we don't need to filter invalid values as the scale can handle invalid values.
                if (invalidDataMode !== 'show' && invalidDataMode !== 'always-valid') aggregator[fieldDef.field] = fieldDef; // we know that the fieldDef is a typed field def
            }
            return aggregator;
        }, {});
        if (!keys(filter).length) return null;
        return new FilterInvalidNode(parent, filter);
    }
    dependentFields() {
        return new Set(keys(this.filter));
    }
    producedFields() {
        return new Set(); // filter does not produce any new fields
    }
    hash() {
        return `FilterInvalid ${hash(this.filter)}`;
    }
    /**
     * Create the VgTransforms for each of the filtered fields.
     */ assemble() {
        const filters = keys(this.filter).reduce((vegaFilters, field)=>{
            const fieldDef = this.filter[field];
            const ref = vgField(fieldDef, {
                expr: 'datum'
            });
            if (fieldDef !== null) {
                if (fieldDef.type === 'temporal') vegaFilters.push(`(isDate(${ref}) || (${isValidFiniteNumberExpr(ref)}))`);
                else if (fieldDef.type === 'quantitative') vegaFilters.push(isValidFiniteNumberExpr(ref));
            }
            return vegaFilters;
        }, []);
        return filters.length > 0 ? {
            type: 'filter',
            expr: filters.join(' && ')
        } : null;
    }
}
function isValidFiniteNumberExpr(ref) {
    return `isValid(${ref}) && isFinite(+${ref})`;
}
function getStackByFields(model) {
    return model.stack.stackBy.reduce((fields, by)=>{
        const fieldDef = by.fieldDef;
        const _field = vgField(fieldDef);
        if (_field) fields.push(_field);
        return fields;
    }, []);
}
function isValidAsArray(as) {
    return (0, _vegaUtil.isArray)(as) && as.every((s)=>(0, _vegaUtil.isString)(s)) && as.length > 1;
}
class StackNode extends DataFlowNode {
    _stack;
    clone() {
        return new StackNode(null, duplicate(this._stack));
    }
    constructor(parent, stack){
        super(parent);
        this._stack = stack;
    }
    static makeFromTransform(parent, stackTransform) {
        const { stack, groupby, as, offset = 'zero' } = stackTransform;
        const sortFields = [];
        const sortOrder = [];
        if (stackTransform.sort !== undefined) for (const sortField of stackTransform.sort){
            sortFields.push(sortField.field);
            sortOrder.push(getFirstDefined(sortField.order, 'ascending'));
        }
        const sort = {
            field: sortFields,
            order: sortOrder
        };
        let normalizedAs;
        if (isValidAsArray(as)) normalizedAs = as;
        else if ((0, _vegaUtil.isString)(as)) normalizedAs = [
            as,
            `${as}_end`
        ];
        else normalizedAs = [
            `${stackTransform.stack}_start`,
            `${stackTransform.stack}_end`
        ];
        return new StackNode(parent, {
            dimensionFieldDefs: [],
            stackField: stack,
            groupby,
            offset,
            sort,
            facetby: [],
            as: normalizedAs
        });
    }
    static makeFromEncoding(parent, model) {
        const stackProperties = model.stack;
        const { encoding } = model;
        if (!stackProperties) return null;
        const { groupbyChannels, fieldChannel, offset, impute } = stackProperties;
        const dimensionFieldDefs = groupbyChannels.map((groupbyChannel)=>{
            const cDef = encoding[groupbyChannel];
            return getFieldDef(cDef);
        }).filter((def)=>!!def);
        const stackby = getStackByFields(model);
        const orderDef = model.encoding.order;
        let sort;
        if ((0, _vegaUtil.isArray)(orderDef) || isFieldDef(orderDef)) sort = sortParams(orderDef);
        else {
            const sortOrder = isOrderOnlyDef(orderDef) ? orderDef.sort : fieldChannel === 'y' ? 'descending' : 'ascending';
            // default = descending by stackFields
            // FIXME is the default here correct for binned fields?
            sort = stackby.reduce((s, field)=>{
                if (!s.field.includes(field)) {
                    s.field.push(field);
                    s.order.push(sortOrder);
                }
                return s;
            }, {
                field: [],
                order: []
            });
        }
        return new StackNode(parent, {
            dimensionFieldDefs,
            stackField: model.vgField(fieldChannel),
            facetby: [],
            stackby,
            sort,
            offset,
            impute,
            as: [
                model.vgField(fieldChannel, {
                    suffix: 'start',
                    forAs: true
                }),
                model.vgField(fieldChannel, {
                    suffix: 'end',
                    forAs: true
                })
            ]
        });
    }
    get stack() {
        return this._stack;
    }
    addDimensions(fields) {
        this._stack.facetby.push(...fields);
    }
    dependentFields() {
        const out = new Set();
        out.add(this._stack.stackField);
        this.getGroupbyFields().forEach(out.add, out);
        this._stack.facetby.forEach(out.add, out);
        this._stack.sort.field.forEach(out.add, out);
        return out;
    }
    producedFields() {
        return new Set(this._stack.as);
    }
    hash() {
        return `Stack ${hash(this._stack)}`;
    }
    getGroupbyFields() {
        const { dimensionFieldDefs, impute, groupby } = this._stack;
        if (dimensionFieldDefs.length > 0) return dimensionFieldDefs.map((dimensionFieldDef)=>{
            if (dimensionFieldDef.bin) {
                if (impute) // For binned group by field with impute, we calculate bin_mid
                // as we cannot impute two fields simultaneously
                return [
                    vgField(dimensionFieldDef, {
                        binSuffix: 'mid'
                    })
                ];
                return [
                    // For binned group by field without impute, we need both bin (start) and bin_end
                    vgField(dimensionFieldDef, {}),
                    vgField(dimensionFieldDef, {
                        binSuffix: 'end'
                    })
                ];
            }
            return [
                vgField(dimensionFieldDef)
            ];
        }).flat();
        return groupby ?? [];
    }
    assemble() {
        const transform = [];
        const { facetby, dimensionFieldDefs, stackField: field, stackby, sort, offset, impute, as } = this._stack;
        // Impute
        if (impute) for (const dimensionFieldDef of dimensionFieldDefs){
            const { bandPosition = 0.5, bin } = dimensionFieldDef;
            if (bin) {
                // As we can only impute one field at a time, we need to calculate
                // mid point for a binned field
                const binStart = vgField(dimensionFieldDef, {
                    expr: 'datum'
                });
                const binEnd = vgField(dimensionFieldDef, {
                    expr: 'datum',
                    binSuffix: 'end'
                });
                transform.push({
                    type: 'formula',
                    expr: `${isValidFiniteNumberExpr(binStart)} ? ${bandPosition}*${binStart}+${1 - bandPosition}*${binEnd} : ${binStart}`,
                    as: vgField(dimensionFieldDef, {
                        binSuffix: 'mid',
                        forAs: true
                    })
                });
            }
            transform.push({
                type: 'impute',
                field,
                groupby: [
                    ...stackby,
                    ...facetby
                ],
                key: vgField(dimensionFieldDef, {
                    binSuffix: 'mid'
                }),
                method: 'value',
                value: 0
            });
        }
        // Stack
        transform.push({
            type: 'stack',
            groupby: [
                ...this.getGroupbyFields(),
                ...facetby
            ],
            field,
            sort,
            as,
            offset
        });
        return transform;
    }
}
/**
 * A class for the window transform nodes
 */ class WindowTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new WindowTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    addDimensions(fields) {
        this.transform.groupby = unique(this.transform.groupby.concat(fields), (d)=>d);
    }
    dependentFields() {
        const out = new Set();
        (this.transform.groupby ?? []).forEach(out.add, out);
        (this.transform.sort ?? []).forEach((m)=>out.add(m.field));
        this.transform.window.map((w)=>w.field).filter((f)=>f !== undefined).forEach(out.add, out);
        return out;
    }
    producedFields() {
        return new Set(this.transform.window.map(this.getDefaultName));
    }
    getDefaultName(windowFieldDef) {
        return windowFieldDef.as ?? vgField(windowFieldDef);
    }
    hash() {
        return `WindowTransform ${hash(this.transform)}`;
    }
    assemble() {
        const fields = [];
        const ops = [];
        const as = [];
        const params = [];
        for (const window of this.transform.window){
            ops.push(window.op);
            as.push(this.getDefaultName(window));
            params.push(window.param === undefined ? null : window.param);
            fields.push(window.field === undefined ? null : window.field);
        }
        const frame = this.transform.frame;
        const groupby = this.transform.groupby;
        if (frame && frame[0] === null && frame[1] === null && ops.every((o)=>isAggregateOp(o))) // when the window does not rely on any particular window ops or frame, switch to a simpler and more efficient joinaggregate
        return {
            type: 'joinaggregate',
            as,
            ops: ops,
            fields,
            ...groupby !== undefined ? {
                groupby
            } : {}
        };
        const sortFields = [];
        const sortOrder = [];
        if (this.transform.sort !== undefined) for (const sortField of this.transform.sort){
            sortFields.push(sortField.field);
            sortOrder.push(sortField.order ?? 'ascending');
        }
        const sort = {
            field: sortFields,
            order: sortOrder
        };
        const ignorePeers = this.transform.ignorePeers;
        return {
            type: 'window',
            params,
            as,
            ops,
            fields,
            sort,
            ...ignorePeers !== undefined ? {
                ignorePeers
            } : {},
            ...groupby !== undefined ? {
                groupby
            } : {},
            ...frame !== undefined ? {
                frame
            } : {}
        };
    }
}
/**
 * Clones the subtree and ignores output nodes except for the leaves, which are renamed.
 */ function cloneSubtree(facet) {
    function clone(node) {
        if (!(node instanceof FacetNode)) {
            const copy = node.clone();
            if (copy instanceof OutputNode) {
                const newName = FACET_SCALE_PREFIX + copy.getSource();
                copy.setSource(newName);
                facet.model.component.data.outputNodes[newName] = copy;
            } else if (copy instanceof AggregateNode || copy instanceof StackNode || copy instanceof WindowTransformNode || copy instanceof JoinAggregateTransformNode) copy.addDimensions(facet.fields);
            for (const n of node.children.flatMap(clone))n.parent = copy;
            return [
                copy
            ];
        }
        return node.children.flatMap(clone);
    }
    return clone;
}
/**
 * Move facet nodes down to the next fork or output node. Also pull the main output with the facet node.
 * After moving down the facet node, make a copy of the subtree and make it a child of the main output.
 */ function moveFacetDown(node) {
    if (node instanceof FacetNode) {
        if (node.numChildren() === 1 && !(node.children[0] instanceof OutputNode)) {
            // move down until we hit a fork or output node
            const child = node.children[0];
            if (child instanceof AggregateNode || child instanceof StackNode || child instanceof WindowTransformNode || child instanceof JoinAggregateTransformNode) child.addDimensions(node.fields);
            child.swapWithParent();
            moveFacetDown(node);
        } else {
            // move main to facet
            const facetMain = node.model.component.data.main;
            moveMainDownToFacet(facetMain);
            // replicate the subtree and place it before the facet's main node
            const cloner = cloneSubtree(node);
            const copy = node.children.map(cloner).flat();
            for (const c of copy)c.parent = facetMain;
        }
    } else node.children.map(moveFacetDown);
}
function moveMainDownToFacet(node) {
    if (node instanceof OutputNode && node.type === DataSourceType.Main) {
        if (node.numChildren() === 1) {
            const child = node.children[0];
            if (!(child instanceof FacetNode)) {
                child.swapWithParent();
                moveMainDownToFacet(node);
            }
        }
    }
}
const FACET_SCALE_PREFIX = 'scale_';
const MAX_OPTIMIZATION_RUNS = 5;
/**
 * Iterates over a dataflow graph and checks whether all links are consistent.
 */ function checkLinks(nodes) {
    for (const node of nodes){
        for (const child of node.children){
            if (child.parent !== node) // log.error('Dataflow graph is inconsistent.', node, child);
            return false;
        }
        if (!checkLinks(node.children)) return false;
    }
    return true;
}
/**
 * Run the specified optimizer on the provided nodes.
 *
 * @param optimizer The optimizer instance to run.
 * @param nodes A set of nodes to optimize.
 */ function runOptimizer(optimizer, nodes) {
    let modified = false;
    for (const node of nodes)modified = optimizer.optimize(node) || modified;
    return modified;
}
function optimizationDataflowHelper(dataComponent, model, firstPass) {
    let roots = dataComponent.sources;
    let modified = false;
    modified = runOptimizer(new RemoveUnnecessaryOutputNodes(), roots) || modified;
    modified = runOptimizer(new RemoveUnnecessaryIdentifierNodes(model), roots) || modified;
    // remove source nodes that don't have any children because they also don't have output nodes
    roots = roots.filter((r)=>r.numChildren() > 0);
    modified = runOptimizer(new RemoveUnusedSubtrees(), roots) || modified;
    roots = roots.filter((r)=>r.numChildren() > 0);
    if (!firstPass) {
        // Only run these optimizations after the optimizer has moved down the facet node.
        // With this change, we can be more aggressive in the optimizations.
        modified = runOptimizer(new MoveParseUp(), roots) || modified;
        modified = runOptimizer(new MergeBins(model), roots) || modified;
        modified = runOptimizer(new RemoveDuplicateTimeUnits(), roots) || modified;
        modified = runOptimizer(new MergeParse(), roots) || modified;
        modified = runOptimizer(new MergeAggregates(), roots) || modified;
        modified = runOptimizer(new MergeTimeUnits(), roots) || modified;
        modified = runOptimizer(new MergeIdenticalNodes(), roots) || modified;
        modified = runOptimizer(new MergeOutputs(), roots) || modified;
    }
    dataComponent.sources = roots;
    return modified;
}
/**
 * Optimizes the dataflow of the passed in data component.
 */ function optimizeDataflow(data, model) {
    // check before optimizations
    checkLinks(data.sources);
    let firstPassCounter = 0;
    let secondPassCounter = 0;
    for(let i = 0; i < MAX_OPTIMIZATION_RUNS; i++){
        if (!optimizationDataflowHelper(data, model, true)) break;
        firstPassCounter++;
    }
    // move facets down and make a copy of the subtree so that we can have scales at the top level
    data.sources.map(moveFacetDown);
    for(let i = 0; i < MAX_OPTIMIZATION_RUNS; i++){
        if (!optimizationDataflowHelper(data, model, false)) break;
        secondPassCounter++;
    }
    // check after optimizations
    checkLinks(data.sources);
    if (Math.max(firstPassCounter, secondPassCounter) === MAX_OPTIMIZATION_RUNS) warn(`Maximum optimization runs(${MAX_OPTIMIZATION_RUNS}) reached.`);
}
/**
 * A class that behaves like a SignalRef but lazily generates the signal.
 * The provided generator function should use `Model.getSignalName` to use the correct signal name.
 */ class SignalRefWrapper {
    constructor(exprGenerator){
        Object.defineProperty(this, 'signal', {
            enumerable: true,
            get: exprGenerator
        });
    }
    signal;
    static fromName(rename, signalName) {
        return new SignalRefWrapper(()=>rename(signalName));
    }
}
function parseScaleDomain(model) {
    if (isUnitModel(model)) parseUnitScaleDomain(model);
    else parseNonUnitScaleDomain(model);
}
function parseUnitScaleDomain(model) {
    const localScaleComponents = model.component.scales;
    for (const channel of keys(localScaleComponents)){
        const domains = parseDomainForChannel(model, channel);
        const localScaleCmpt = localScaleComponents[channel];
        localScaleCmpt.setWithExplicit('domains', domains);
        parseSelectionDomain(model, channel);
        if (model.component.data.isFaceted) {
            // get resolve from closest facet parent as this decides whether we need to refer to cloned subtree or not
            let facetParent = model;
            while(!isFacetModel(facetParent) && facetParent.parent)facetParent = facetParent.parent;
            const resolve = facetParent.component.resolve.scale[channel];
            if (resolve === 'shared') {
                for (const domain of domains.value)// Replace the scale domain with data output from a cloned subtree after the facet.
                if (isDataRefDomain(domain)) // use data from cloned subtree (which is the same as data but with a prefix added once)
                domain.data = FACET_SCALE_PREFIX + domain.data.replace(FACET_SCALE_PREFIX, '');
            }
        }
    }
}
function parseNonUnitScaleDomain(model) {
    for (const child of model.children)parseScaleDomain(child);
    const localScaleComponents = model.component.scales;
    for (const channel of keys(localScaleComponents)){
        let domains;
        let selectionExtent = null;
        for (const child of model.children){
            const childComponent = child.component.scales[channel];
            if (childComponent) {
                if (domains === undefined) domains = childComponent.getWithExplicit('domains');
                else domains = mergeValuesWithExplicit(domains, childComponent.getWithExplicit('domains'), 'domains', 'scale', domainsTieBreaker);
                const se = childComponent.get('selectionExtent');
                if (selectionExtent && se && selectionExtent.param !== se.param) warn(NEEDS_SAME_SELECTION);
                selectionExtent = se;
            }
        }
        localScaleComponents[channel].setWithExplicit('domains', domains);
        if (selectionExtent) localScaleComponents[channel].set('selectionExtent', selectionExtent, true);
    }
}
/**
 * Remove unaggregated domain if it is not applicable
 * Add unaggregated domain if domain is not specified and config.scale.useUnaggregatedDomain is true.
 */ function normalizeUnaggregatedDomain(domain, fieldDef, scaleType, scaleConfig) {
    if (domain === 'unaggregated') {
        const { valid, reason } = canUseUnaggregatedDomain(fieldDef, scaleType);
        if (!valid) {
            warn(reason);
            return undefined;
        }
    } else if (domain === undefined && scaleConfig.useUnaggregatedDomain) {
        // Apply config if domain is not specified.
        const { valid } = canUseUnaggregatedDomain(fieldDef, scaleType);
        if (valid) return 'unaggregated';
    }
    return domain;
}
function parseDomainForChannel(model, channel) {
    const scaleType = model.getScaleComponent(channel).get('type');
    const { encoding } = model;
    const domain = normalizeUnaggregatedDomain(model.scaleDomain(channel), model.typedFieldDef(channel), scaleType, model.config.scale);
    if (domain !== model.scaleDomain(channel)) model.specifiedScales[channel] = {
        ...model.specifiedScales[channel],
        domain
    };
    // If channel is either X or Y then union them with X2 & Y2 if they exist
    if (channel === 'x' && getFieldOrDatumDef(encoding.x2)) {
        if (getFieldOrDatumDef(encoding.x)) return mergeValuesWithExplicit(parseSingleChannelDomain(scaleType, domain, model, 'x'), parseSingleChannelDomain(scaleType, domain, model, 'x2'), 'domain', 'scale', domainsTieBreaker);
        else return parseSingleChannelDomain(scaleType, domain, model, 'x2');
    } else if (channel === 'y' && getFieldOrDatumDef(encoding.y2)) {
        if (getFieldOrDatumDef(encoding.y)) return mergeValuesWithExplicit(parseSingleChannelDomain(scaleType, domain, model, 'y'), parseSingleChannelDomain(scaleType, domain, model, 'y2'), 'domain', 'scale', domainsTieBreaker);
        else return parseSingleChannelDomain(scaleType, domain, model, 'y2');
    }
    return parseSingleChannelDomain(scaleType, domain, model, channel);
}
function mapDomainToDataSignal(domain, type, timeUnit) {
    return domain.map((v)=>{
        const data = valueExpr(v, {
            timeUnit,
            type
        });
        return {
            signal: `{data: ${data}}`
        };
    });
}
function convertDomainIfItIsDateTime(domain, type, timeUnit) {
    // explicit value
    const normalizedTimeUnit = normalizeTimeUnit(timeUnit)?.unit;
    if (type === 'temporal' || normalizedTimeUnit) return mapDomainToDataSignal(domain, type, normalizedTimeUnit);
    return [
        domain
    ]; // Date time won't make sense
}
function parseSingleChannelDomain(scaleType, domain, model, channel) {
    const { encoding, markDef, mark, config, stack } = model;
    const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
    const { type } = fieldOrDatumDef;
    const timeUnit = fieldOrDatumDef['timeUnit'];
    const dataSourceTypeForScaleDomain = getScaleDataSourceForHandlingInvalidValues({
        invalid: getMarkConfig('invalid', markDef, config),
        isPath: isPathMark(mark)
    });
    if (isDomainUnionWith(domain)) {
        const defaultDomain = parseSingleChannelDomain(scaleType, undefined, model, channel);
        const unionWith = convertDomainIfItIsDateTime(domain.unionWith, type, timeUnit);
        return makeExplicit([
            ...unionWith,
            ...defaultDomain.value
        ]);
    } else if (isSignalRef(domain)) return makeExplicit([
        domain
    ]);
    else if (domain && domain !== 'unaggregated' && !isParameterDomain(domain)) return makeExplicit(convertDomainIfItIsDateTime(domain, type, timeUnit));
    if (stack && channel === stack.fieldChannel) {
        if (stack.offset === 'normalize') return makeImplicit([
            [
                0,
                1
            ]
        ]);
        const data = model.requestDataName(dataSourceTypeForScaleDomain);
        return makeImplicit([
            {
                data,
                field: model.vgField(channel, {
                    suffix: 'start'
                })
            },
            {
                data,
                field: model.vgField(channel, {
                    suffix: 'end'
                })
            }
        ]);
    }
    const sort = isScaleChannel(channel) && isFieldDef(fieldOrDatumDef) ? domainSort(model, channel, scaleType) : undefined;
    if (isDatumDef(fieldOrDatumDef)) {
        const d = convertDomainIfItIsDateTime([
            fieldOrDatumDef.datum
        ], type, timeUnit);
        return makeImplicit(d);
    }
    const fieldDef = fieldOrDatumDef; // now we can be sure it's a fieldDef
    if (domain === 'unaggregated') {
        const { field } = fieldOrDatumDef;
        return makeImplicit([
            {
                data: model.requestDataName(dataSourceTypeForScaleDomain),
                field: vgField({
                    field,
                    aggregate: 'min'
                })
            },
            {
                data: model.requestDataName(dataSourceTypeForScaleDomain),
                field: vgField({
                    field,
                    aggregate: 'max'
                })
            }
        ]);
    } else if (isBinning(fieldDef.bin)) {
        if (hasDiscreteDomain(scaleType)) {
            if (scaleType === 'bin-ordinal') // we can omit the domain as it is inferred from the `bins` property
            return makeImplicit([]);
            // ordinal bin scale takes domain from bin_range, ordered by bin start
            // This is useful for both axis-based scale (x/y) and legend-based scale (other channels).
            return makeImplicit([
                {
                    // If sort by aggregation of a specified sort field, we need to use RAW table,
                    // so we can aggregate values for the scale independently from the main aggregation.
                    data: isBoolean(sort) ? model.requestDataName(dataSourceTypeForScaleDomain) : model.requestDataName(DataSourceType.Raw),
                    // Use range if we added it and the scale does not support computing a range as a signal.
                    field: model.vgField(channel, binRequiresRange(fieldDef, channel) ? {
                        binSuffix: 'range'
                    } : {}),
                    // we have to use a sort object if sort = true to make the sort correct by bin start
                    sort: sort === true || !(0, _vegaUtil.isObject)(sort) ? {
                        field: model.vgField(channel, {}),
                        op: 'min'
                    } : sort
                }
            ]);
        } else {
            // continuous scales
            const { bin } = fieldDef;
            if (isBinning(bin)) {
                const binSignal = getBinSignalName(model, fieldDef.field, bin);
                return makeImplicit([
                    new SignalRefWrapper(()=>{
                        const signal = model.getSignalName(binSignal);
                        return `[${signal}.start, ${signal}.stop]`;
                    })
                ]);
            } else return makeImplicit([
                {
                    data: model.requestDataName(dataSourceTypeForScaleDomain),
                    field: model.vgField(channel, {})
                }
            ]);
        }
    } else if (fieldDef.timeUnit && contains([
        'time',
        'utc'
    ], scaleType)) {
        const fieldDef2 = encoding[getSecondaryRangeChannel(channel)];
        if (hasBandEnd(fieldDef, fieldDef2, markDef, config)) {
            const data = model.requestDataName(dataSourceTypeForScaleDomain);
            const bandPosition = getBandPosition({
                fieldDef,
                fieldDef2,
                markDef,
                config
            });
            const isRectWithOffset = isRectBasedMark(mark) && bandPosition !== 0.5 && isXorY(channel);
            return makeImplicit([
                {
                    data,
                    field: model.vgField(channel, isRectWithOffset ? {
                        suffix: OFFSETTED_RECT_START_SUFFIX
                    } : {})
                },
                {
                    data,
                    field: model.vgField(channel, {
                        suffix: isRectWithOffset ? OFFSETTED_RECT_END_SUFFIX : 'end'
                    })
                }
            ]);
        }
    }
    if (sort) return makeImplicit([
        {
            // If sort by aggregation of a specified sort field, we need to use RAW table,
            // so we can aggregate values for the scale independently from the main aggregation.
            data: isBoolean(sort) ? model.requestDataName(dataSourceTypeForScaleDomain) : model.requestDataName(DataSourceType.Raw),
            field: model.vgField(channel),
            sort
        }
    ]);
    else return makeImplicit([
        {
            data: model.requestDataName(dataSourceTypeForScaleDomain),
            field: model.vgField(channel)
        }
    ]);
}
function normalizeSortField(sort, isStackedMeasure) {
    const { op, field, order } = sort;
    return {
        // Apply default op
        op: op ?? (isStackedMeasure ? 'sum' : DEFAULT_SORT_OP),
        // flatten nested fields
        ...field ? {
            field: replacePathInField(field)
        } : {},
        ...order ? {
            order
        } : {}
    };
}
function parseSelectionDomain(model, channel) {
    const scale = model.component.scales[channel];
    const spec = model.specifiedScales[channel].domain;
    const bin = model.fieldDef(channel)?.bin;
    const domain = isParameterDomain(spec) ? spec : undefined;
    const extent = isBinParams(bin) && isParameterExtent(bin.extent) ? bin.extent : undefined;
    if (domain || extent) // As scale parsing occurs before selection parsing, we cannot set
    // domainRaw directly. So instead, we store the selectionExtent on
    // the scale component, and then add domainRaw during scale assembly.
    scale.set('selectionExtent', domain ?? extent, true);
}
function domainSort(model, channel, scaleType) {
    if (!hasDiscreteDomain(scaleType)) return undefined;
    // save to cast as the only exception is the geojson type for shape, which would not generate a scale
    const fieldDef = model.fieldDef(channel);
    const sort = fieldDef.sort;
    // if the sort is specified with array, use the derived sort index field
    if (isSortArray(sort)) return {
        op: 'min',
        field: sortArrayIndexField(fieldDef, channel),
        order: 'ascending'
    };
    const { stack } = model;
    const stackDimensions = stack ? new Set([
        ...stack.groupbyFields,
        ...stack.stackBy.map((s)=>s.fieldDef.field)
    ]) : undefined;
    // Sorted based on an aggregate calculation over a specified sort field (only for ordinal scale)
    if (isSortField(sort)) {
        const isStackedMeasure = stack && !stackDimensions.has(sort.field);
        return normalizeSortField(sort, isStackedMeasure);
    } else if (isSortByEncoding(sort)) {
        const { encoding, order } = sort;
        const fieldDefToSortBy = model.fieldDef(encoding);
        const { aggregate, field } = fieldDefToSortBy;
        const isStackedMeasure = stack && !stackDimensions.has(field);
        if (isArgminDef(aggregate) || isArgmaxDef(aggregate)) return normalizeSortField({
            field: vgField(fieldDefToSortBy),
            order
        }, isStackedMeasure);
        else if (isAggregateOp(aggregate) || !aggregate) return normalizeSortField({
            op: aggregate,
            field,
            order
        }, isStackedMeasure);
    } else if (sort === 'descending') return {
        op: 'min',
        field: model.vgField(channel),
        order: 'descending'
    };
    else if (contains([
        'ascending',
        undefined /* default =ascending*/ 
    ], sort)) return true;
    // sort == null
    return undefined;
}
/**
 * Determine if a scale can use unaggregated domain.
 * @return {Boolean} Returns true if all of the following conditions apply:
 * 1. `scale.domain` is `unaggregated`
 * 2. Aggregation function is not `count` or `sum`
 * 3. The scale is quantitative or time scale.
 */ function canUseUnaggregatedDomain(fieldDef, scaleType) {
    const { aggregate, type } = fieldDef;
    if (!aggregate) return {
        valid: false,
        reason: unaggregateDomainHasNoEffectForRawField(fieldDef)
    };
    if ((0, _vegaUtil.isString)(aggregate) && !SHARED_DOMAIN_OPS.has(aggregate)) return {
        valid: false,
        reason: unaggregateDomainWithNonSharedDomainOp(aggregate)
    };
    if (type === 'quantitative') {
        if (scaleType === 'log') return {
            valid: false,
            reason: unaggregatedDomainWithLogScale(fieldDef)
        };
    }
    return {
        valid: true
    };
}
/**
 * Tie breaker for mergeValuesWithExplicit for domains. We concat the specified values.
 */ function domainsTieBreaker(v1, v2, property, propertyOf) {
    if (v1.explicit && v2.explicit) warn(mergeConflictingDomainProperty(property, propertyOf, v1.value, v2.value));
    // If equal score, concat the domains so that we union them later.
    return {
        explicit: v1.explicit,
        value: [
            ...v1.value,
            ...v2.value
        ]
    };
}
/**
 * Converts an array of domains to a single Vega scale domain.
 */ function mergeDomains(domains) {
    const uniqueDomains = unique(domains.map((domain)=>{
        // ignore sort property when computing the unique domains
        if (isDataRefDomain(domain)) {
            const { sort: _s, ...domainWithoutSort } = domain;
            return domainWithoutSort;
        }
        return domain;
    }), hash);
    const sorts = unique(domains.map((d)=>{
        if (isDataRefDomain(d)) {
            const s = d.sort;
            if (s !== undefined && !isBoolean(s)) {
                if ('op' in s && s.op === 'count') // let's make sure that if op is count, we don't use a field
                delete s.field;
                if (s.order === 'ascending') // drop order: ascending as it is the default
                delete s.order;
            }
            return s;
        }
        return undefined;
    }).filter((s)=>s !== undefined), hash);
    if (uniqueDomains.length === 0) return undefined;
    else if (uniqueDomains.length === 1) {
        const domain = domains[0];
        if (isDataRefDomain(domain) && sorts.length > 0) {
            let sort = sorts[0];
            if (sorts.length > 1) {
                warn(MORE_THAN_ONE_SORT);
                // Get sorts with non-default ops
                const filteredSorts = sorts.filter((s)=>(0, _vegaUtil.isObject)(s) && 'op' in s && s.op !== 'min');
                if (sorts.every((s)=>(0, _vegaUtil.isObject)(s) && 'op' in s) && filteredSorts.length === 1) sort = filteredSorts[0];
                else sort = true;
            } else // Simplify domain sort by removing field and op when the field is the same as the domain field.
            if ((0, _vegaUtil.isObject)(sort) && 'field' in sort) {
                const sortField = sort.field;
                if (domain.field === sortField) sort = sort.order ? {
                    order: sort.order
                } : true;
            }
            return {
                ...domain,
                sort
            };
        }
        return domain;
    }
    // only keep sort properties that work with unioned domains
    const unionDomainSorts = unique(sorts.map((s)=>{
        if (isBoolean(s) || !('op' in s) || (0, _vegaUtil.isString)(s.op) && (0, _vegaUtil.hasOwnProperty)(MULTIDOMAIN_SORT_OP_INDEX, s.op)) return s;
        warn(domainSortDropped(s));
        return true;
    }), hash);
    let sort;
    if (unionDomainSorts.length === 1) sort = unionDomainSorts[0];
    else if (unionDomainSorts.length > 1) {
        warn(MORE_THAN_ONE_SORT);
        sort = true;
    }
    const allData = unique(domains.map((d)=>{
        if (isDataRefDomain(d)) return d.data;
        return null;
    }), (x)=>x);
    if (allData.length === 1 && allData[0] !== null) {
        // create a union domain of different fields with a single data source
        const domain = {
            data: allData[0],
            fields: uniqueDomains.map((d)=>d.field),
            ...sort ? {
                sort
            } : {}
        };
        return domain;
    }
    return {
        fields: uniqueDomains,
        ...sort ? {
            sort
        } : {}
    };
}
/**
 * Return a field if a scale uses a single field.
 * Return `undefined` otherwise.
 */ function getFieldFromDomain(domain) {
    if (isDataRefDomain(domain) && (0, _vegaUtil.isString)(domain.field)) return domain.field;
    else if (isDataRefUnionedDomain(domain)) {
        let field;
        for (const nonUnionDomain of domain.fields)if (isDataRefDomain(nonUnionDomain) && (0, _vegaUtil.isString)(nonUnionDomain.field)) {
            if (!field) field = nonUnionDomain.field;
            else if (field !== nonUnionDomain.field) {
                warn(FACETED_INDEPENDENT_DIFFERENT_SOURCES);
                return field;
            }
        }
        warn(FACETED_INDEPENDENT_SAME_FIELDS_DIFFERENT_SOURCES);
        return field;
    } else if (isFieldRefUnionDomain(domain)) {
        warn(FACETED_INDEPENDENT_SAME_SOURCE);
        const field = domain.fields[0];
        return (0, _vegaUtil.isString)(field) ? field : undefined;
    }
    return undefined;
}
function assembleDomain(model, channel) {
    const scaleComponent = model.component.scales[channel];
    const domains = scaleComponent.get('domains').map((domain)=>{
        // Correct references to data as the original domain's data was determined
        // in parseScale, which happens before parseData. Thus the original data
        // reference can be incorrect.
        if (isDataRefDomain(domain)) domain.data = model.lookupDataSource(domain.data);
        return domain;
    });
    // domains is an array that has to be merged into a single vega domain
    return mergeDomains(domains);
}
function assembleScales(model) {
    if (isLayerModel(model) || isConcatModel(model)) // For concat and layer, include scales of children too
    return model.children.reduce((scales, child)=>{
        return scales.concat(assembleScales(child));
    }, assembleScalesForModel(model));
    else // For facet, child scales would not be included in the parent's scope.
    // For unit, there is no child.
    return assembleScalesForModel(model);
}
function assembleScalesForModel(model) {
    return keys(model.component.scales).reduce((scales, channel)=>{
        const scaleComponent = model.component.scales[channel];
        if (scaleComponent.merged) // Skipped merged scales
        return scales;
        const scale = scaleComponent.combine();
        const { name, type, selectionExtent, domains: _d, range: _r, reverse, ...otherScaleProps } = scale;
        const range = assembleScaleRange(scale.range, name, channel, model);
        const domain = assembleDomain(model, channel);
        const domainRaw = selectionExtent ? assembleSelectionScaleDomain(model, selectionExtent, scaleComponent, domain) : null;
        scales.push({
            name,
            type,
            ...domain ? {
                domain
            } : {},
            ...domainRaw ? {
                domainRaw
            } : {},
            range,
            ...reverse !== undefined ? {
                reverse: reverse
            } : {},
            ...otherScaleProps
        });
        return scales;
    }, []);
}
function assembleScaleRange(scaleRange, scaleName, channel, model) {
    // add signals to x/y range
    if (isXorY(channel)) {
        if (isVgRangeStep(scaleRange)) // For width/height step, use a signal created in layout assemble instead of a constant step.
        return {
            step: {
                signal: `${scaleName}_step`
            }
        };
    } else if ((0, _vegaUtil.isObject)(scaleRange) && isDataRefDomain(scaleRange)) return {
        ...scaleRange,
        data: model.lookupDataSource(scaleRange.data)
    };
    return scaleRange;
}
class ScaleComponent extends Split {
    merged = false;
    constructor(name, typeWithExplicit){
        super({}, {
            name
        });
        this.setWithExplicit('type', typeWithExplicit);
    }
    /**
     * Whether the scale definitely includes or not include zero in the domain
     */ domainHasZero() {
        const scaleType = this.get('type');
        if (contains([
            ScaleType.LOG,
            ScaleType.TIME,
            ScaleType.UTC
        ], scaleType)) // Log scales cannot have zero.
        // Zero in time scale is arbitrary, and does not affect ratio.
        // (Time is an interval level of measurement, not ratio).
        // See https://en.wikipedia.org/wiki/Level_of_measurement for more info.
        return 'definitely-not';
        const scaleZero = this.get('zero');
        if (scaleZero === true || // If zero is undefined, linear/sqrt/pow scales have zero by default.
        scaleZero === undefined && contains([
            ScaleType.LINEAR,
            ScaleType.SQRT,
            ScaleType.POW
        ], scaleType)) return 'definitely';
        const domains = this.get('domains');
        if (domains.length > 0) {
            let hasExplicitDomainWithZero = false;
            let hasExplicitDomainWithoutZero = false;
            let hasDomainBasedOnField = false;
            for (const d of domains){
                if ((0, _vegaUtil.isArray)(d)) {
                    const first = d[0];
                    const last = d[d.length - 1];
                    if ((0, _vegaUtil.isNumber)(first) && (0, _vegaUtil.isNumber)(last)) {
                        if (first <= 0 && last >= 0) {
                            hasExplicitDomainWithZero = true;
                            continue;
                        } else {
                            hasExplicitDomainWithoutZero = true;
                            continue;
                        }
                    }
                }
                hasDomainBasedOnField = true;
            }
            if (hasExplicitDomainWithZero) return 'definitely';
            else if (hasExplicitDomainWithoutZero && !hasDomainBasedOnField) return 'definitely-not';
        }
        return 'maybe';
    }
}
const RANGE_PROPERTIES = [
    'range',
    'scheme'
];
function parseUnitScaleRange(model) {
    const localScaleComponents = model.component.scales;
    // use SCALE_CHANNELS instead of scales[channel] to ensure that x, y come first!
    for (const channel of SCALE_CHANNELS){
        const localScaleCmpt = localScaleComponents[channel];
        if (!localScaleCmpt) continue;
        const rangeWithExplicit = parseRangeForChannel(channel, model);
        localScaleCmpt.setWithExplicit('range', rangeWithExplicit);
    }
}
function getBinStepSignal(model, channel) {
    const fieldDef = model.fieldDef(channel);
    if (fieldDef?.bin) {
        const { bin, field } = fieldDef;
        const sizeType = getSizeChannel(channel);
        const sizeSignal = model.getName(sizeType);
        if ((0, _vegaUtil.isObject)(bin) && bin.binned && bin.step !== undefined) return new SignalRefWrapper(()=>{
            const scaleName = model.scaleName(channel);
            const binCount = `(domain("${scaleName}")[1] - domain("${scaleName}")[0]) / ${bin.step}`;
            return `${model.getSignalName(sizeSignal)} / (${binCount})`;
        });
        else if (isBinning(bin)) {
            const binSignal = getBinSignalName(model, field, bin);
            // TODO: extract this to be range step signal
            return new SignalRefWrapper(()=>{
                const updatedName = model.getSignalName(binSignal);
                const binCount = `(${updatedName}.stop - ${updatedName}.start) / ${updatedName}.step`;
                return `${model.getSignalName(sizeSignal)} / (${binCount})`;
            });
        }
    }
    return undefined;
}
/**
 * Return mixins that includes one of the Vega range types (explicit range, range.step, range.scheme).
 */ function parseRangeForChannel(channel, model) {
    const specifiedScale = model.specifiedScales[channel];
    const { size } = model;
    const mergedScaleCmpt = model.getScaleComponent(channel);
    const scaleType = mergedScaleCmpt.get('type');
    // Check if any of the range properties is specified.
    // If so, check if it is compatible and make sure that we only output one of the properties
    for (const property of RANGE_PROPERTIES)if (specifiedScale[property] !== undefined) {
        const supportedByScaleType = scaleTypeSupportProperty(scaleType, property);
        const channelIncompatability = channelScalePropertyIncompatability(channel, property);
        if (!supportedByScaleType) warn(scalePropertyNotWorkWithScaleType(scaleType, property, channel));
        else if (channelIncompatability) // channel
        warn(channelIncompatability);
        else switch(property){
            case 'range':
                {
                    const range = specifiedScale.range;
                    if ((0, _vegaUtil.isArray)(range)) {
                        if (isXorY(channel)) return makeExplicit(range.map((v)=>{
                            if (v === 'width' || v === 'height') {
                                // get signal for width/height
                                // Just like default range logic below, we use SignalRefWrapper to account for potential merges and renames.
                                const sizeSignal = model.getName(v);
                                const getSignalName = model.getSignalName.bind(model);
                                return SignalRefWrapper.fromName(getSignalName, sizeSignal);
                            }
                            return v;
                        }));
                    } else if ((0, _vegaUtil.isObject)(range)) return makeExplicit({
                        data: model.requestDataName(DataSourceType.Main),
                        field: range.field,
                        sort: {
                            op: 'min',
                            field: model.vgField(channel)
                        }
                    });
                    return makeExplicit(range);
                }
            case 'scheme':
                return makeExplicit(parseScheme(specifiedScale[property]));
        }
    }
    const sizeChannel = channel === X || channel === 'xOffset' ? 'width' : 'height';
    const sizeValue = size[sizeChannel];
    if (isStep(sizeValue)) {
        if (isXorY(channel)) {
            if (hasDiscreteDomain(scaleType)) {
                const step = getPositionStep(sizeValue, model, channel);
                // Need to be explicit so layer with step wins over layer without step
                if (step) return makeExplicit({
                    step
                });
            } else warn(stepDropped(sizeChannel));
        } else if (isXorYOffset(channel)) {
            const positionChannel = channel === XOFFSET ? 'x' : 'y';
            const positionScaleCmpt = model.getScaleComponent(positionChannel);
            const positionScaleType = positionScaleCmpt.get('type');
            if (positionScaleType === 'band') {
                const step = getOffsetStep(sizeValue, scaleType);
                if (step) return makeExplicit(step);
            }
        }
    }
    const { rangeMin, rangeMax } = specifiedScale;
    const d = defaultRange(channel, model);
    if ((rangeMin !== undefined || rangeMax !== undefined) && // it's ok to check just rangeMin's compatibility since rangeMin/rangeMax are the same
    scaleTypeSupportProperty(scaleType, 'rangeMin') && (0, _vegaUtil.isArray)(d) && d.length === 2) return makeExplicit([
        rangeMin ?? d[0],
        rangeMax ?? d[1]
    ]);
    return makeImplicit(d);
}
function parseScheme(scheme) {
    if (isExtendedScheme(scheme)) return {
        scheme: scheme.name,
        ...omit(scheme, [
            'name'
        ])
    };
    return {
        scheme
    };
}
function fullWidthOrHeightRange(channel, model, scaleType, { center } = {}) {
    // If step is null, use zero to width or height.
    // Note that we use SignalRefWrapper to account for potential merges and renames.
    const sizeType = getSizeChannel(channel);
    const sizeSignal = model.getName(sizeType);
    const getSignalName = model.getSignalName.bind(model);
    if (channel === Y && hasContinuousDomain(scaleType)) // For y continuous scale, we have to start from the height as the bottom part has the max value.
    return center ? [
        SignalRefWrapper.fromName((name)=>`${getSignalName(name)}/2`, sizeSignal),
        SignalRefWrapper.fromName((name)=>`-${getSignalName(name)}/2`, sizeSignal)
    ] : [
        SignalRefWrapper.fromName(getSignalName, sizeSignal),
        0
    ];
    else return center ? [
        SignalRefWrapper.fromName((name)=>`-${getSignalName(name)}/2`, sizeSignal),
        SignalRefWrapper.fromName((name)=>`${getSignalName(name)}/2`, sizeSignal)
    ] : [
        0,
        SignalRefWrapper.fromName(getSignalName, sizeSignal)
    ];
}
function defaultRange(channel, model) {
    const { size, config, mark, encoding } = model;
    const { type } = getFieldOrDatumDef(encoding[channel]);
    const mergedScaleCmpt = model.getScaleComponent(channel);
    const scaleType = mergedScaleCmpt.get('type');
    const { domain, domainMid } = model.specifiedScales[channel];
    switch(channel){
        case X:
        case Y:
            // If there is no explicit width/height for discrete x/y scales
            if (contains([
                'point',
                'band'
            ], scaleType)) {
                const positionSize = getDiscretePositionSize(channel, size, config.view);
                if (isStep(positionSize)) {
                    const step = getPositionStep(positionSize, model, channel);
                    return {
                        step
                    };
                }
            }
            return fullWidthOrHeightRange(channel, model, scaleType);
        case XOFFSET:
        case YOFFSET:
            return getOffsetRange(channel, model, scaleType);
        case SIZE:
            {
                // TODO: support custom rangeMin, rangeMax
                const rangeMin = sizeRangeMin(mark, config);
                const rangeMax = sizeRangeMax(mark, size, model, config);
                if (isContinuousToDiscrete(scaleType)) return interpolateRange(rangeMin, rangeMax, defaultContinuousToDiscreteCount(scaleType, config, domain, channel));
                else return [
                    rangeMin,
                    rangeMax
                ];
            }
        case THETA:
            return [
                0,
                Math.PI * 2
            ];
        case ANGLE:
            // TODO: add config.scale.min/maxAngleDegree (for point and text) and config.scale.min/maxAngleRadian (for arc) once we add arc marks.
            // (It's weird to add just config.scale.min/maxAngleDegree for now)
            return [
                0,
                360
            ];
        case RADIUS:
            // max radius = half od min(width,height)
            return [
                0,
                new SignalRefWrapper(()=>{
                    const w = model.getSignalName(isFacetModel(model.parent) ? 'child_width' : 'width');
                    const h = model.getSignalName(isFacetModel(model.parent) ? 'child_height' : 'height');
                    return `min(${w},${h})/2`;
                })
            ];
        case TIME:
            // if (scaleType === 'band') {
            return {
                step: 1000 / config.scale.framesPerSecond
            };
        case STROKEWIDTH:
            // TODO: support custom rangeMin, rangeMax
            return [
                config.scale.minStrokeWidth,
                config.scale.maxStrokeWidth
            ];
        case STROKEDASH:
            return [
                // TODO: add this to Vega's config.range?
                [
                    1,
                    0
                ],
                [
                    4,
                    2
                ],
                [
                    2,
                    1
                ],
                [
                    1,
                    1
                ],
                [
                    1,
                    2,
                    4,
                    2
                ]
            ];
        case SHAPE:
            return 'symbol';
        case COLOR:
        case FILL:
        case STROKE:
            if (scaleType === 'ordinal') // Only nominal data uses ordinal scale by default
            return type === 'nominal' ? 'category' : 'ordinal';
            else {
                if (domainMid !== undefined) return 'diverging';
                else return mark === 'rect' || mark === 'geoshape' ? 'heatmap' : 'ramp';
            }
        case OPACITY:
        case FILLOPACITY:
        case STROKEOPACITY:
            // TODO: support custom rangeMin, rangeMax
            return [
                config.scale.minOpacity,
                config.scale.maxOpacity
            ];
    }
}
function getPositionStep(step, model, channel) {
    const { encoding } = model;
    const mergedScaleCmpt = model.getScaleComponent(channel);
    const offsetChannel = getOffsetScaleChannel(channel);
    const offsetDef = encoding[offsetChannel];
    const stepFor = getStepFor({
        step,
        offsetIsDiscrete: isFieldOrDatumDef(offsetDef) && isDiscrete$1(offsetDef.type)
    });
    if (stepFor === 'offset' && channelHasFieldOrDatum(encoding, offsetChannel)) {
        const offsetScaleCmpt = model.getScaleComponent(offsetChannel);
        const offsetScaleName = model.scaleName(offsetChannel);
        let stepCount = `domain('${offsetScaleName}').length`;
        if (offsetScaleCmpt.get('type') === 'band') {
            const offsetPaddingInner = offsetScaleCmpt.get('paddingInner') ?? offsetScaleCmpt.get('padding') ?? 0;
            const offsetPaddingOuter = offsetScaleCmpt.get('paddingOuter') ?? offsetScaleCmpt.get('padding') ?? 0;
            stepCount = `bandspace(${stepCount}, ${offsetPaddingInner}, ${offsetPaddingOuter})`;
        }
        const paddingInner = mergedScaleCmpt.get('paddingInner') ?? mergedScaleCmpt.get('padding');
        return {
            signal: `${step.step} * ${stepCount} / (1-${exprFromSignalRefOrValue(paddingInner)})`
        };
    } else return step.step;
}
function getOffsetStep(step, offsetScaleType) {
    const stepFor = getStepFor({
        step,
        offsetIsDiscrete: hasDiscreteDomain(offsetScaleType)
    });
    if (stepFor === 'offset') return {
        step: step.step
    };
    return undefined;
}
function getOffsetRange(channel, model, offsetScaleType) {
    const positionChannel = channel === XOFFSET ? 'x' : 'y';
    const positionScaleCmpt = model.getScaleComponent(positionChannel);
    if (!positionScaleCmpt) return fullWidthOrHeightRange(positionChannel, model, offsetScaleType, {
        center: true
    });
    const positionScaleType = positionScaleCmpt.get('type');
    const positionScaleName = model.scaleName(positionChannel);
    const { markDef, config } = model;
    if (positionScaleType === 'band') {
        const size = getDiscretePositionSize(positionChannel, model.size, model.config.view);
        if (isStep(size)) {
            // step is for offset
            const step = getOffsetStep(size, offsetScaleType);
            if (step) return step;
        }
        // otherwise use the position
        return [
            0,
            {
                signal: `bandwidth('${positionScaleName}')`
            }
        ];
    } else {
        // continuous scale
        const positionDef = model.encoding[positionChannel];
        if (isFieldDef(positionDef) && positionDef.timeUnit) {
            const duration = durationExpr(positionDef.timeUnit, (expr)=>`scale('${positionScaleName}', ${expr})`);
            const padding = model.config.scale.bandWithNestedOffsetPaddingInner;
            const bandPositionOffset = getBandPosition({
                fieldDef: positionDef,
                markDef,
                config
            }) - 0.5;
            const bandPositionOffsetExpr = bandPositionOffset !== 0 ? ` + ${bandPositionOffset}` : '';
            if (padding) {
                const startRatio = isSignalRef(padding) ? `${padding.signal}/2${bandPositionOffsetExpr}` : `${padding / 2 + bandPositionOffset}`;
                const endRatio = isSignalRef(padding) ? `(1 - ${padding.signal}/2)${bandPositionOffsetExpr}` : `${1 - padding / 2 + bandPositionOffset}`;
                return [
                    {
                        signal: `${startRatio} * (${duration})`
                    },
                    {
                        signal: `${endRatio} * (${duration})`
                    }
                ];
            }
            return [
                0,
                {
                    signal: duration
                }
            ];
        }
        return never(`Cannot use ${channel} scale if ${positionChannel} scale is not discrete.`);
    }
}
function getDiscretePositionSize(channel, size, viewConfig) {
    const sizeChannel = channel === X ? 'width' : 'height';
    const sizeValue = size[sizeChannel];
    if (sizeValue) return sizeValue;
    return getViewConfigDiscreteSize(viewConfig, sizeChannel);
}
function defaultContinuousToDiscreteCount(scaleType, config, domain, channel) {
    switch(scaleType){
        case 'quantile':
            return config.scale.quantileCount;
        case 'quantize':
            return config.scale.quantizeCount;
        case 'threshold':
            if (domain !== undefined && (0, _vegaUtil.isArray)(domain)) return domain.length + 1;
            else {
                warn(domainRequiredForThresholdScale(channel));
                // default threshold boundaries for threshold scale since domain has cardinality of 2
                return 3;
            }
    }
}
/**
 * Returns the linear interpolation of the range according to the cardinality
 *
 * @param rangeMin start of the range
 * @param rangeMax end of the range
 * @param cardinality number of values in the output range
 */ function interpolateRange(rangeMin, rangeMax, cardinality) {
    // always return a signal since it's better to compute the sequence in Vega later
    const f = ()=>{
        const rMax = signalOrStringValue(rangeMax);
        const rMin = signalOrStringValue(rangeMin);
        const step = `(${rMax} - ${rMin}) / (${cardinality} - 1)`;
        return `sequence(${rMin}, ${rMax} + ${step}, ${step})`;
    };
    if (isSignalRef(rangeMax)) return new SignalRefWrapper(f);
    else return {
        signal: f()
    };
}
function sizeRangeMin(mark, config) {
    switch(mark){
        case 'bar':
        case 'tick':
            return config.scale.minBandSize;
        case 'line':
        case 'trail':
        case 'rule':
            return config.scale.minStrokeWidth;
        case 'text':
            return config.scale.minFontSize;
        case 'point':
        case 'square':
        case 'circle':
            return config.scale.minSize;
    }
    /* istanbul ignore next: should never reach here */ // sizeRangeMin not implemented for the mark
    throw new Error(incompatibleChannel('size', mark));
}
const MAX_SIZE_RANGE_STEP_RATIO = 0.95;
function sizeRangeMax(mark, size, model, config) {
    const xyStepSignals = {
        x: getBinStepSignal(model, 'x'),
        y: getBinStepSignal(model, 'y')
    };
    switch(mark){
        case 'bar':
        case 'tick':
            {
                if (config.scale.maxBandSize !== undefined) return config.scale.maxBandSize;
                const min = minXYStep(size, xyStepSignals, config.view);
                if ((0, _vegaUtil.isNumber)(min)) return min - 1;
                else return new SignalRefWrapper(()=>`${min.signal} - 1`);
            }
        case 'line':
        case 'trail':
        case 'rule':
            return config.scale.maxStrokeWidth;
        case 'text':
            return config.scale.maxFontSize;
        case 'point':
        case 'square':
        case 'circle':
            {
                if (config.scale.maxSize) return config.scale.maxSize;
                const pointStep = minXYStep(size, xyStepSignals, config.view);
                if ((0, _vegaUtil.isNumber)(pointStep)) return Math.pow(MAX_SIZE_RANGE_STEP_RATIO * pointStep, 2);
                else return new SignalRefWrapper(()=>`pow(${MAX_SIZE_RANGE_STEP_RATIO} * ${pointStep.signal}, 2)`);
            }
    }
    /* istanbul ignore next: should never reach here */ // sizeRangeMax not implemented for the mark
    throw new Error(incompatibleChannel('size', mark));
}
/**
 * @returns {number} Range step of x or y or minimum between the two if both are ordinal scale.
 */ function minXYStep(size, xyStepSignals, viewConfig) {
    const widthStep = isStep(size.width) ? size.width.step : getViewConfigDiscreteStep(viewConfig, 'width');
    const heightStep = isStep(size.height) ? size.height.step : getViewConfigDiscreteStep(viewConfig, 'height');
    if (xyStepSignals.x || xyStepSignals.y) return new SignalRefWrapper(()=>{
        const exprs = [
            xyStepSignals.x ? xyStepSignals.x.signal : widthStep,
            xyStepSignals.y ? xyStepSignals.y.signal : heightStep
        ];
        return `min(${exprs.join(', ')})`;
    });
    return Math.min(widthStep, heightStep);
}
function parseScaleProperty(model, property) {
    if (isUnitModel(model)) parseUnitScaleProperty(model, property);
    else parseNonUnitScaleProperty(model, property);
}
function parseUnitScaleProperty(model, property) {
    const localScaleComponents = model.component.scales;
    const { config, encoding, markDef, specifiedScales } = model;
    for (const channel of keys(localScaleComponents)){
        const specifiedScale = specifiedScales[channel];
        const localScaleCmpt = localScaleComponents[channel];
        const mergedScaleCmpt = model.getScaleComponent(channel);
        const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
        const specifiedValue = specifiedScale[property];
        const scaleType = mergedScaleCmpt.get('type');
        const scalePadding = mergedScaleCmpt.get('padding');
        const scalePaddingInner = mergedScaleCmpt.get('paddingInner');
        const supportedByScaleType = scaleTypeSupportProperty(scaleType, property);
        const channelIncompatability = channelScalePropertyIncompatability(channel, property);
        if (specifiedValue !== undefined) {
            // If there is a specified value, check if it is compatible with scale type and channel
            if (!supportedByScaleType) warn(scalePropertyNotWorkWithScaleType(scaleType, property, channel));
            else if (channelIncompatability) // channel
            warn(channelIncompatability);
        }
        if (supportedByScaleType && channelIncompatability === undefined) {
            if (specifiedValue !== undefined) {
                const timeUnit = fieldOrDatumDef.timeUnit;
                const type = fieldOrDatumDef.type;
                switch(property){
                    // domainMax/Min to signal if the value is a datetime object
                    case 'domainMax':
                    case 'domainMin':
                        if (isDateTime(specifiedScale[property]) || type === 'temporal' || timeUnit) localScaleCmpt.set(property, {
                            signal: valueExpr(specifiedScale[property], {
                                type,
                                timeUnit
                            })
                        }, true);
                        else localScaleCmpt.set(property, specifiedScale[property], true);
                        break;
                    default:
                        localScaleCmpt.copyKeyFromObject(property, specifiedScale);
                }
            } else {
                const value = hasProperty(scaleRules, property) ? scaleRules[property]({
                    model,
                    channel,
                    fieldOrDatumDef,
                    scaleType,
                    scalePadding,
                    scalePaddingInner,
                    domain: specifiedScale.domain,
                    domainMin: specifiedScale.domainMin,
                    domainMax: specifiedScale.domainMax,
                    markDef,
                    config,
                    hasNestedOffsetScale: channelHasNestedOffsetScale(encoding, channel),
                    hasSecondaryRangeChannel: !!encoding[getSecondaryRangeChannel(channel)]
                }) : config.scale[property];
                if (value !== undefined) localScaleCmpt.set(property, value, false);
            }
        }
    }
}
const scaleRules = {
    bins: ({ model, fieldOrDatumDef })=>isFieldDef(fieldOrDatumDef) ? bins(model, fieldOrDatumDef) : undefined,
    interpolate: ({ channel, fieldOrDatumDef })=>interpolate(channel, fieldOrDatumDef.type),
    nice: ({ scaleType, channel, domain, domainMin, domainMax, fieldOrDatumDef })=>nice(scaleType, channel, domain, domainMin, domainMax, fieldOrDatumDef),
    padding: ({ channel, scaleType, fieldOrDatumDef, markDef, config })=>padding(channel, scaleType, config.scale, fieldOrDatumDef, markDef, config.bar),
    paddingInner: ({ scalePadding, channel, markDef, scaleType, config, hasNestedOffsetScale })=>paddingInner(scalePadding, channel, markDef.type, scaleType, config.scale, hasNestedOffsetScale),
    paddingOuter: ({ scalePadding, channel, scaleType, scalePaddingInner, config, hasNestedOffsetScale })=>paddingOuter(scalePadding, channel, scaleType, scalePaddingInner, config.scale, hasNestedOffsetScale),
    reverse: ({ fieldOrDatumDef, scaleType, channel, config })=>{
        const sort = isFieldDef(fieldOrDatumDef) ? fieldOrDatumDef.sort : undefined;
        return reverse(scaleType, sort, channel, config.scale);
    },
    zero: ({ channel, fieldOrDatumDef, domain, markDef, scaleType, config, hasSecondaryRangeChannel })=>zero(channel, fieldOrDatumDef, domain, markDef, scaleType, config.scale, hasSecondaryRangeChannel)
};
// This method is here rather than in range.ts to avoid circular dependency.
function parseScaleRange(model) {
    if (isUnitModel(model)) parseUnitScaleRange(model);
    else parseNonUnitScaleProperty(model, 'range');
}
function parseNonUnitScaleProperty(model, property) {
    const localScaleComponents = model.component.scales;
    for (const child of model.children)if (property === 'range') parseScaleRange(child);
    else parseScaleProperty(child, property);
    for (const channel of keys(localScaleComponents)){
        let valueWithExplicit;
        for (const child of model.children){
            const childComponent = child.component.scales[channel];
            if (childComponent) {
                const childValueWithExplicit = childComponent.getWithExplicit(property);
                valueWithExplicit = mergeValuesWithExplicit(valueWithExplicit, childValueWithExplicit, property, 'scale', tieBreakByComparing((v1, v2)=>{
                    switch(property){
                        case 'range':
                            // For step, prefer larger step
                            if (v1.step && v2.step) return v1.step - v2.step;
                            return 0;
                    }
                    return 0;
                }));
            }
        }
        localScaleComponents[channel].setWithExplicit(property, valueWithExplicit);
    }
}
function bins(model, fieldDef) {
    const bin = fieldDef.bin;
    if (isBinning(bin)) {
        const binSignal = getBinSignalName(model, fieldDef.field, bin);
        return new SignalRefWrapper(()=>{
            return model.getSignalName(binSignal);
        });
    } else if (isBinned(bin) && isBinParams(bin) && bin.step !== undefined) // start and stop will be determined from the scale domain
    return {
        step: bin.step
    };
    return undefined;
}
function interpolate(channel, type) {
    if (contains([
        COLOR,
        FILL,
        STROKE
    ], channel) && type !== 'nominal') return 'hcl';
    return undefined;
}
function nice(scaleType, channel, specifiedDomain, domainMin, domainMax, fieldOrDatumDef) {
    if (getFieldDef(fieldOrDatumDef)?.bin || (0, _vegaUtil.isArray)(specifiedDomain) || domainMax != null || domainMin != null || contains([
        ScaleType.TIME,
        ScaleType.UTC
    ], scaleType)) return undefined;
    return isXorY(channel) ? true : undefined;
}
function padding(channel, scaleType, scaleConfig, fieldOrDatumDef, markDef, barConfig) {
    if (isXorY(channel)) {
        if (isContinuousToContinuous(scaleType)) {
            if (scaleConfig.continuousPadding !== undefined) return scaleConfig.continuousPadding;
            const { type, orient } = markDef;
            if (type === 'bar' && !(isFieldDef(fieldOrDatumDef) && (fieldOrDatumDef.bin || fieldOrDatumDef.timeUnit))) {
                if (orient === 'vertical' && channel === 'x' || orient === 'horizontal' && channel === 'y') return barConfig.continuousBandSize;
            }
        }
        if (scaleType === ScaleType.POINT) return scaleConfig.pointPadding;
    }
    return undefined;
}
function paddingInner(paddingValue, channel, mark, scaleType, scaleConfig, hasNestedOffsetScale = false) {
    if (paddingValue !== undefined) // If user has already manually specified "padding", no need to add default paddingInner.
    return undefined;
    if (isXorY(channel)) {
        // Padding is only set for X and Y by default.
        // Basically it doesn't make sense to add padding for color and size.
        // paddingOuter would only be called if it's a band scale, just return the default for bandScale.
        const { bandPaddingInner, barBandPaddingInner, rectBandPaddingInner, tickBandPaddingInner, bandWithNestedOffsetPaddingInner } = scaleConfig;
        if (hasNestedOffsetScale) return bandWithNestedOffsetPaddingInner;
        return getFirstDefined(bandPaddingInner, mark === 'bar' ? barBandPaddingInner : mark === 'tick' ? tickBandPaddingInner : rectBandPaddingInner);
    } else if (isXorYOffset(channel)) {
        if (scaleType === ScaleType.BAND) return scaleConfig.offsetBandPaddingInner;
    }
    return undefined;
}
function paddingOuter(paddingValue, channel, scaleType, paddingInnerValue, scaleConfig, hasNestedOffsetScale = false) {
    if (paddingValue !== undefined) // If user has already manually specified "padding", no need to add default paddingOuter.
    return undefined;
    if (isXorY(channel)) {
        const { bandPaddingOuter, bandWithNestedOffsetPaddingOuter } = scaleConfig;
        if (hasNestedOffsetScale) return bandWithNestedOffsetPaddingOuter;
        // Padding is only set for X and Y by default.
        // Basically it doesn't make sense to add padding for color and size.
        if (scaleType === ScaleType.BAND) return getFirstDefined(bandPaddingOuter, /* By default, paddingOuter is paddingInner / 2. The reason is that
              size (width/height) = step * (cardinality - paddingInner + 2 * paddingOuter).
              and we want the width/height to be integer by default.
              Note that step (by default) and cardinality are integers.) */ isSignalRef(paddingInnerValue) ? {
            signal: `${paddingInnerValue.signal}/2`
        } : paddingInnerValue / 2);
    } else if (isXorYOffset(channel)) {
        if (scaleType === ScaleType.POINT) return 0.5; // so the point positions align with centers of band scales.
        else if (scaleType === ScaleType.BAND) return scaleConfig.offsetBandPaddingOuter;
    }
    return undefined;
}
function reverse(scaleType, sort, channel, scaleConfig) {
    if (channel === 'x' && scaleConfig.xReverse !== undefined) {
        if (hasContinuousDomain(scaleType) && sort === 'descending') {
            if (isSignalRef(scaleConfig.xReverse)) return {
                signal: `!${scaleConfig.xReverse.signal}`
            };
            else return !scaleConfig.xReverse;
        }
        return scaleConfig.xReverse;
    }
    if (hasContinuousDomain(scaleType) && sort === 'descending') // For continuous domain scales, Vega does not support domain sort.
    // Thus, we reverse range instead if sort is descending
    return true;
    return undefined;
}
function zero(channel, fieldDef, specifiedDomain, markDef, scaleType, scaleConfig, hasSecondaryRangeChannel) {
    // If users explicitly provide a domain, we should not augment zero as that will be unexpected.
    const hasCustomDomain = !!specifiedDomain && specifiedDomain !== 'unaggregated';
    if (hasCustomDomain) {
        if (hasContinuousDomain(scaleType)) {
            if ((0, _vegaUtil.isArray)(specifiedDomain)) {
                const first = specifiedDomain[0];
                const last = specifiedDomain[specifiedDomain.length - 1];
                if ((0, _vegaUtil.isNumber)(first) && first <= 0 && (0, _vegaUtil.isNumber)(last) && last >= 0) // if the domain includes zero, make zero remain true
                return true;
            }
            return false;
        }
    }
    // If there is no custom domain, return configZero value (=`true` as default) only for the following cases:
    // 1) using quantitative field with size
    // While this can be either ratio or interval fields, our assumption is that
    // ratio are more common. However, if the scaleType is discretizing scale, we want to return
    // false so that range doesn't start at zero
    if (channel === 'size' && fieldDef.type === 'quantitative' && !isContinuousToDiscrete(scaleType)) return true;
    // 2) non-binned, quantitative x-scale or y-scale
    // (For binning, we should not include zero by default because binning are calculated without zero.)
    // (For area/bar charts with ratio scale chart, we should always include zero.)
    if (!(isFieldDef(fieldDef) && fieldDef.bin) && contains([
        ...POSITION_SCALE_CHANNELS,
        ...POLAR_POSITION_SCALE_CHANNELS
    ], channel)) {
        const { orient, type } = markDef;
        if (contains([
            'bar',
            'area',
            'line',
            'trail'
        ], type)) {
            if (orient === 'horizontal' && channel === 'y' || orient === 'vertical' && channel === 'x') return false;
        }
        if (contains([
            'bar',
            'area'
        ], type) && !hasSecondaryRangeChannel) return true;
        return scaleConfig?.zero;
    }
    return false;
}
/**
 * Determine if there is a specified scale type and if it is appropriate,
 * or determine default type if type is unspecified or inappropriate.
 */ // NOTE: CompassQL uses this method.
function scaleType(specifiedScale, channel, fieldDef, mark, hasNestedOffsetScale = false) {
    const defaultScaleType = defaultType(channel, fieldDef, mark, hasNestedOffsetScale);
    const { type } = specifiedScale;
    if (!isScaleChannel(channel)) // There is no scale for these channels
    return null;
    if (type !== undefined) {
        // Check if explicitly specified scale type is supported by the channel
        if (!channelSupportScaleType(channel, type)) {
            warn(scaleTypeNotWorkWithChannel(channel, type, defaultScaleType));
            return defaultScaleType;
        }
        // Check if explicitly specified scale type is supported by the data type
        if (isFieldDef(fieldDef) && !scaleTypeSupportDataType(type, fieldDef.type)) {
            warn(scaleTypeNotWorkWithFieldDef(type, defaultScaleType));
            return defaultScaleType;
        }
        return type;
    }
    return defaultScaleType;
}
/**
 * Determine appropriate default scale type.
 */ // NOTE: Voyager uses this method.
function defaultType(channel, fieldDef, mark, hasNestedOffsetScale) {
    switch(fieldDef.type){
        case 'nominal':
        case 'ordinal':
            {
                if (isColorChannel(channel) || rangeType(channel) === 'discrete') {
                    if (channel === 'shape' && fieldDef.type === 'ordinal') warn(discreteChannelCannotEncode(channel, 'ordinal'));
                    return 'ordinal';
                }
                if (isTime(channel)) return 'band';
                if (isXorY(channel) || isXorYOffset(channel)) {
                    if (contains([
                        'rect',
                        'bar',
                        'image',
                        'rule',
                        'tick'
                    ], mark.type)) // The rect/bar/tick mark should fit into a band.
                    // For rule, using band scale to make rule align with axis ticks better https://github.com/vega/vega-lite/issues/3429
                    return 'band';
                    if (hasNestedOffsetScale) // If there is a nested offset scale, then there is a "band" for the span of the nested scale.
                    return 'band';
                } else if (mark.type === 'arc' && channel in POLAR_POSITION_SCALE_CHANNEL_INDEX) return 'band';
                const dimensionSize = mark[getSizeChannel(channel)];
                if (isRelativeBandSize(dimensionSize)) return 'band';
                if (isPositionFieldOrDatumDef(fieldDef) && fieldDef.axis?.tickBand) return 'band';
                // Otherwise, use ordinal point scale so we can easily get center positions of the marks.
                return 'point';
            }
        case 'temporal':
            if (isColorChannel(channel)) return 'time';
            else if (rangeType(channel) === 'discrete') {
                warn(discreteChannelCannotEncode(channel, 'temporal'));
                // TODO: consider using quantize (equivalent to binning) once we have it
                return 'ordinal';
            } else if (isFieldDef(fieldDef) && fieldDef.timeUnit && normalizeTimeUnit(fieldDef.timeUnit).utc) return 'utc';
            else if (isTime(channel)) // return 'linear';
            return 'band'; // TODO(jzong): when interpolation is implemented, this should be 'linear'
            return 'time';
        case 'quantitative':
            if (isColorChannel(channel)) {
                if (isFieldDef(fieldDef) && isBinning(fieldDef.bin)) return 'bin-ordinal';
                return 'linear';
            } else if (rangeType(channel) === 'discrete') {
                warn(discreteChannelCannotEncode(channel, 'quantitative'));
                // TODO: consider using quantize (equivalent to binning) once we have it
                return 'ordinal';
            } else if (isTime(channel)) // return 'linear';
            return 'band'; // TODO(jzong): when interpolation is implemented, this should be 'linear'
            return 'linear';
        case 'geojson':
            return undefined;
    }
    /* istanbul ignore next: should never reach this */ throw new Error(invalidFieldType(fieldDef.type));
}
function parseScales(model, { ignoreRange } = {}) {
    parseScaleCore(model);
    parseScaleDomain(model);
    for (const prop of NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES)parseScaleProperty(model, prop);
    if (!ignoreRange) // range depends on zero
    parseScaleRange(model);
}
function parseScaleCore(model) {
    if (isUnitModel(model)) model.component.scales = parseUnitScaleCore(model);
    else model.component.scales = parseNonUnitScaleCore(model);
}
/**
 * Parse scales for all channels of a model.
 */ function parseUnitScaleCore(model) {
    const { encoding, mark, markDef } = model;
    const scaleComponents = {};
    for (const channel of SCALE_CHANNELS){
        const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]); // must be typed def to have scale
        // Don't generate scale for shape of geoshape
        if (fieldOrDatumDef && mark === GEOSHAPE && channel === SHAPE && fieldOrDatumDef.type === GEOJSON) continue;
        let specifiedScale = fieldOrDatumDef && fieldOrDatumDef.scale;
        if (fieldOrDatumDef && specifiedScale !== null && specifiedScale !== false) {
            specifiedScale ??= {};
            const hasNestedOffsetScale = channelHasNestedOffsetScale(encoding, channel);
            const sType = scaleType(specifiedScale, channel, fieldOrDatumDef, markDef, hasNestedOffsetScale);
            scaleComponents[channel] = new ScaleComponent(model.scaleName(`${channel}`, true), {
                value: sType,
                explicit: specifiedScale.type === sType
            });
        }
    }
    return scaleComponents;
}
const scaleTypeTieBreaker = tieBreakByComparing((st1, st2)=>scaleTypePrecedence(st1) - scaleTypePrecedence(st2));
function parseNonUnitScaleCore(model) {
    const scaleComponents = model.component.scales = {};
    const scaleTypeWithExplicitIndex = {};
    const resolve = model.component.resolve;
    // Parse each child scale and determine if a particular channel can be merged.
    for (const child of model.children){
        parseScaleCore(child);
        // Instead of always merging right away -- check if it is compatible to merge first!
        for (const channel of keys(child.component.scales)){
            // if resolve is undefined, set default first
            resolve.scale[channel] ??= defaultScaleResolve(channel, model);
            if (resolve.scale[channel] === 'shared') {
                const explicitScaleType = scaleTypeWithExplicitIndex[channel];
                const childScaleType = child.component.scales[channel].getWithExplicit('type');
                if (explicitScaleType) {
                    if (scaleCompatible(explicitScaleType.value, childScaleType.value)) // merge scale component if type are compatible
                    scaleTypeWithExplicitIndex[channel] = mergeValuesWithExplicit(explicitScaleType, childScaleType, 'type', 'scale', scaleTypeTieBreaker);
                    else {
                        // Otherwise, update conflicting channel to be independent
                        resolve.scale[channel] = 'independent';
                        // Remove from the index so they don't get merged
                        delete scaleTypeWithExplicitIndex[channel];
                    }
                } else scaleTypeWithExplicitIndex[channel] = childScaleType;
            }
        }
    }
    // Merge each channel listed in the index
    for (const channel of keys(scaleTypeWithExplicitIndex)){
        // Create new merged scale component
        const name = model.scaleName(channel, true);
        const typeWithExplicit = scaleTypeWithExplicitIndex[channel];
        scaleComponents[channel] = new ScaleComponent(name, typeWithExplicit);
        // rename each child and mark them as merged
        for (const child of model.children){
            const childScale = child.component.scales[channel];
            if (childScale) {
                child.renameScale(childScale.get('name'), name);
                childScale.merged = true;
            }
        }
    }
    return scaleComponents;
}
class NameMap {
    nameMap;
    constructor(){
        this.nameMap = {};
    }
    rename(oldName, newName) {
        this.nameMap[oldName] = newName;
    }
    has(name) {
        return this.nameMap[name] !== undefined;
    }
    get(name) {
        // If the name appears in the _nameMap, we need to read its new name.
        // We have to loop over the dict just in case the new name also gets renamed.
        while(this.nameMap[name] && name !== this.nameMap[name])name = this.nameMap[name];
        return name;
    }
}
/*
  We use type guards instead of `instanceof` as `instanceof` makes
  different parts of the compiler depend on the actual implementation of
  the model classes, which in turn depend on different parts of the compiler.
  Thus, `instanceof` leads to circular dependency problems.

  On the other hand, type guards only make different parts of the compiler
  depend on the type of the model classes, but not the actual implementation.
*/ function isUnitModel(model) {
    return model?.type === 'unit';
}
function isFacetModel(model) {
    return model?.type === 'facet';
}
function isConcatModel(model) {
    return model?.type === 'concat';
}
function isLayerModel(model) {
    return model?.type === 'layer';
}
class Model {
    type;
    parent;
    config;
    name;
    size;
    title;
    description;
    data;
    transforms;
    layout;
    /** Name map for scales, which can be renamed by a model's parent. */ scaleNameMap;
    /** Name map for projections, which can be renamed by a model's parent. */ projectionNameMap;
    /** Name map for signals, which can be renamed by a model's parent. */ signalNameMap;
    component;
    view;
    constructor(spec, type, parent, parentGivenName, config, resolve, view){
        this.type = type;
        this.parent = parent;
        this.config = config;
        this.parent = parent;
        this.config = config;
        this.view = replaceExprRef(view);
        // If name is not provided, always use parent's givenName to avoid name conflicts.
        this.name = spec.name ?? parentGivenName;
        this.title = isText(spec.title) ? {
            text: spec.title
        } : spec.title ? replaceExprRef(spec.title) : undefined;
        // Shared name maps
        this.scaleNameMap = parent ? parent.scaleNameMap : new NameMap();
        this.projectionNameMap = parent ? parent.projectionNameMap : new NameMap();
        this.signalNameMap = parent ? parent.signalNameMap : new NameMap();
        this.data = spec.data;
        this.description = spec.description;
        this.transforms = normalizeTransform(spec.transform ?? []);
        this.layout = type === 'layer' || type === 'unit' ? {} : extractCompositionLayout(spec, type, config);
        this.component = {
            data: {
                sources: parent ? parent.component.data.sources : [],
                outputNodes: parent ? parent.component.data.outputNodes : {},
                outputNodeRefCounts: parent ? parent.component.data.outputNodeRefCounts : {},
                // data is faceted if the spec is a facet spec or the parent has faceted data and data is undefined
                isFaceted: isFacetSpec(spec) || parent?.component.data.isFaceted && spec.data === undefined
            },
            layoutSize: new Split(),
            layoutHeaders: {
                row: {},
                column: {},
                facet: {}
            },
            mark: null,
            resolve: {
                scale: {},
                axis: {},
                legend: {},
                ...resolve ? duplicate(resolve) : {}
            },
            selection: null,
            scales: null,
            projection: null,
            axes: {},
            legends: {}
        };
    }
    get width() {
        return this.getSizeSignalRef('width');
    }
    get height() {
        return this.getSizeSignalRef('height');
    }
    parse() {
        this.parseScale();
        this.parseLayoutSize(); // depends on scale
        this.renameTopLevelLayoutSizeSignal();
        this.parseSelections();
        this.parseProjection();
        this.parseData(); // (pathorder) depends on markDef; selection filters depend on parsed selections; depends on projection because some transforms require the finalized projection name.
        this.parseAxesAndHeaders(); // depends on scale and layout size
        this.parseLegends(); // depends on scale, markDef
        this.parseMarkGroup(); // depends on data name, scale, layout size, axisGroup, and children's scale, axis, legend and mark.
    }
    parseScale() {
        parseScales(this);
    }
    parseProjection() {
        parseProjection(this);
    }
    /**
     * Rename top-level spec's size to be just width / height, ignoring model name.
     * This essentially merges the top-level spec's width/height signals with the width/height signals
     * to help us reduce redundant signals declaration.
     */ renameTopLevelLayoutSizeSignal() {
        if (this.getName('width') !== 'width') this.renameSignal(this.getName('width'), 'width');
        if (this.getName('height') !== 'height') this.renameSignal(this.getName('height'), 'height');
    }
    parseLegends() {
        parseLegend(this);
    }
    assembleEncodeFromView(view) {
        // Exclude "style"
        const { style: _, ...baseView } = view;
        const e = {};
        for (const property of keys(baseView)){
            const value = baseView[property];
            if (value !== undefined) e[property] = signalOrValueRef(value);
        }
        return e;
    }
    assembleGroupEncodeEntry(isTopLevel) {
        let encodeEntry = {};
        if (this.view) encodeEntry = this.assembleEncodeFromView(this.view);
        if (!isTopLevel) {
            // Descriptions are already added to the top-level description so we only need to add them to the inner views.
            if (this.description) encodeEntry['description'] = signalOrValueRef(this.description);
            // For top-level spec, we can set the global width and height signal to adjust the group size.
            // For other child specs, we have to manually set width and height in the encode entry.
            if (this.type === 'unit' || this.type === 'layer') return {
                width: this.getSizeSignalRef('width'),
                height: this.getSizeSignalRef('height'),
                ...encodeEntry
            };
        }
        return isEmpty(encodeEntry) ? undefined : encodeEntry;
    }
    assembleLayout() {
        if (!this.layout) return undefined;
        const { spacing, ...layout } = this.layout;
        const { component, config } = this;
        const titleBand = assembleLayoutTitleBand(component.layoutHeaders, config);
        return {
            padding: spacing,
            ...this.assembleDefaultLayout(),
            ...layout,
            ...titleBand ? {
                titleBand
            } : {}
        };
    }
    assembleDefaultLayout() {
        return {};
    }
    assembleHeaderMarks() {
        const { layoutHeaders } = this.component;
        let headerMarks = [];
        for (const channel of FACET_CHANNELS)if (layoutHeaders[channel].title) headerMarks.push(assembleTitleGroup(this, channel));
        for (const channel of HEADER_CHANNELS)headerMarks = headerMarks.concat(assembleHeaderGroups(this, channel));
        return headerMarks;
    }
    assembleAxes() {
        return assembleAxes(this.component.axes, this.config);
    }
    assembleLegends() {
        return assembleLegends(this);
    }
    assembleProjections() {
        return assembleProjections(this);
    }
    assembleTitle() {
        const { encoding, ...titleNoEncoding } = this.title ?? {};
        const title = {
            ...extractTitleConfig(this.config.title).nonMarkTitleProperties,
            ...titleNoEncoding,
            ...encoding ? {
                encode: {
                    update: encoding
                }
            } : {}
        };
        if (title.text) {
            if (contains([
                'unit',
                'layer'
            ], this.type)) // Unit/Layer
            {
                if (contains([
                    'middle',
                    undefined
                ], title.anchor)) title.frame ??= 'group';
            } else // composition with Vega layout
            // Set title = "start" by default for composition as "middle" does not look nice
            // https://github.com/vega/vega/issues/960#issuecomment-471360328
            title.anchor ??= 'start';
            return isEmpty(title) ? undefined : title;
        }
        return undefined;
    }
    /**
     * Assemble the mark group for this model. We accept optional `signals` so that we can include concat top-level signals with the top-level model's local signals.
     */ assembleGroup(signals = []) {
        const group = {};
        signals = signals.concat(this.assembleSignals());
        if (signals.length > 0) group.signals = signals;
        const layout = this.assembleLayout();
        if (layout) group.layout = layout;
        group.marks = [].concat(this.assembleHeaderMarks(), this.assembleMarks());
        // Only include scales if this spec is top-level or if parent is facet.
        // (Otherwise, it will be merged with upper-level's scope.)
        const scales = !this.parent || isFacetModel(this.parent) ? assembleScales(this) : [];
        if (scales.length > 0) group.scales = scales;
        const axes = this.assembleAxes();
        if (axes.length > 0) group.axes = axes;
        const legends = this.assembleLegends();
        if (legends.length > 0) group.legends = legends;
        return group;
    }
    getName(text) {
        return varName((this.name ? `${this.name}_` : '') + text);
    }
    getDataName(type) {
        return this.getName(DataSourceType[type].toLowerCase());
    }
    /**
     * Request a data source name for the given data source type and mark that data source as required.
     * This method should be called in parse, so that all used data source can be correctly instantiated in assembleData().
     * You can lookup the correct dataset name in assemble with `lookupDataSource`.
     */ requestDataName(name) {
        const fullName = this.getDataName(name);
        // Increase ref count. This is critical because otherwise we won't create a data source.
        // We also increase the ref counts on OutputNode.getSource() calls.
        const refCounts = this.component.data.outputNodeRefCounts;
        refCounts[fullName] = (refCounts[fullName] || 0) + 1;
        return fullName;
    }
    getSizeSignalRef(layoutSizeType) {
        if (isFacetModel(this.parent)) {
            const sizeType = getSizeTypeFromLayoutSizeType(layoutSizeType);
            const channel = getPositionScaleChannel(sizeType);
            const scaleComponent = this.component.scales[channel];
            if (scaleComponent && !scaleComponent.merged) {
                // independent scale
                const type = scaleComponent.get('type');
                const range = scaleComponent.get('range');
                if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
                    const scaleName = scaleComponent.get('name');
                    const domain = assembleDomain(this, channel);
                    const field = getFieldFromDomain(domain);
                    if (field) {
                        const fieldRef = vgField({
                            aggregate: 'distinct',
                            field
                        }, {
                            expr: 'datum'
                        });
                        return {
                            signal: sizeExpr(scaleName, scaleComponent, fieldRef)
                        };
                    } else {
                        warn(unknownField(channel));
                        return null;
                    }
                }
            }
        }
        return {
            signal: this.signalNameMap.get(this.getName(layoutSizeType))
        };
    }
    /**
     * Lookup the name of the datasource for an output node. You probably want to call this in assemble.
     */ lookupDataSource(name) {
        const node = this.component.data.outputNodes[name];
        if (!node) // Name not found in map so let's just return what we got.
        // This can happen if we already have the correct name.
        return name;
        return node.getSource();
    }
    getSignalName(oldSignalName) {
        return this.signalNameMap.get(oldSignalName);
    }
    renameSignal(oldName, newName) {
        this.signalNameMap.rename(oldName, newName);
    }
    renameScale(oldName, newName) {
        this.scaleNameMap.rename(oldName, newName);
    }
    renameProjection(oldName, newName) {
        this.projectionNameMap.rename(oldName, newName);
    }
    /**
     * @return scale name for a given channel after the scale has been parsed and named.
     */ scaleName(originalScaleName, parse) {
        if (parse) // During the parse phase always return a value
        // No need to refer to rename map because a scale can't be renamed
        // before it has the original name.
        return this.getName(originalScaleName);
        // If there is a scale for the channel, it should either
        // be in the scale component or exist in the name map
        if (// If there is a scale for the channel, there should be a local scale component for it
        isChannel(originalScaleName) && isScaleChannel(originalScaleName) && this.component.scales[originalScaleName] || // in the scale name map (the scale get merged by its parent)
        this.scaleNameMap.has(this.getName(originalScaleName))) return this.scaleNameMap.get(this.getName(originalScaleName));
        return undefined;
    }
    /**
     * @return projection name after the projection has been parsed and named.
     */ projectionName(parse) {
        if (parse) // During the parse phase always return a value
        // No need to refer to rename map because a projection can't be renamed
        // before it has the original name.
        return this.getName('projection');
        if (this.component.projection && !this.component.projection.merged || this.projectionNameMap.has(this.getName('projection'))) return this.projectionNameMap.get(this.getName('projection'));
        return undefined;
    }
    /**
     * Traverse a model's hierarchy to get the scale component for a particular channel.
     */ getScaleComponent(channel) {
        /* istanbul ignore next: This is warning for debugging test */ if (!this.component.scales) throw new Error('getScaleComponent cannot be called before parseScale(). Make sure you have called parseScale or use parseUnitModelWithScale().');
        const localScaleComponent = this.component.scales[channel];
        if (localScaleComponent && !localScaleComponent.merged) return localScaleComponent;
        return this.parent ? this.parent.getScaleComponent(channel) : undefined;
    }
    getScaleType(channel) {
        const scaleComponent = this.getScaleComponent(channel);
        return scaleComponent ? scaleComponent.get('type') : undefined;
    }
    /**
     * Traverse a model's hierarchy to get a particular selection component.
     */ getSelectionComponent(variableName, origName) {
        let sel = this.component.selection[variableName];
        if (!sel && this.parent) sel = this.parent.getSelectionComponent(variableName, origName);
        if (!sel) throw new Error(selectionNotFound(origName));
        return sel;
    }
    /**
     * Returns true if the model has a signalRef for an axis orient.
     */ hasAxisOrientSignalRef() {
        return this.component.axes.x?.some((a)=>a.hasOrientSignalRef()) || this.component.axes.y?.some((a)=>a.hasOrientSignalRef());
    }
}
/** Abstract class for UnitModel and FacetModel. Both of which can contain fieldDefs as a part of its own specification. */ class ModelWithField extends Model {
    /** Get "field" reference for Vega */ vgField(channel, opt = {}) {
        const fieldDef = this.fieldDef(channel);
        if (!fieldDef) return undefined;
        return vgField(fieldDef, opt);
    }
    reduceFieldDef(f, init) {
        return reduce(this.getMapping(), (acc, cd, c)=>{
            const fieldDef = getFieldDef(cd);
            if (fieldDef) return f(acc, fieldDef, c);
            return acc;
        }, init);
    }
    forEachFieldDef(f, t) {
        forEach(this.getMapping(), (cd, c)=>{
            const fieldDef = getFieldDef(cd);
            if (fieldDef) f(fieldDef, c);
        }, t);
    }
}
/**
 * A class for density transform nodes
 */ class DensityTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new DensityTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? 'value',
            specifiedAs[1] ?? 'density'
        ];
        const resolve = this.transform.resolve ?? 'shared';
        this.transform.resolve = resolve;
    }
    dependentFields() {
        return new Set([
            this.transform.density,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `DensityTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { density, ...rest } = this.transform;
        const result = {
            type: 'kde',
            field: density,
            ...rest
        };
        result.resolve = this.transform.resolve;
        return result;
    }
}
/**
 * A class for flatten transform nodes
 */ class ExtentTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new ExtentTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform);
    }
    dependentFields() {
        return new Set([
            this.transform.extent
        ]);
    }
    producedFields() {
        return new Set([]);
    }
    hash() {
        return `ExtentTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { extent, param } = this.transform;
        const result = {
            type: 'extent',
            field: extent,
            signal: param
        };
        return result;
    }
}
/**
 * A class for flatten transform nodes
 */ class FlattenTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new FlattenTransformNode(this.parent, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform); // duplicate to prevent side effects
        const { flatten, as = [] } = this.transform;
        this.transform.as = flatten.map((f, i)=>as[i] ?? f);
    }
    dependentFields() {
        return new Set(this.transform.flatten);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `FlattenTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { flatten: fields, as } = this.transform;
        const result = {
            type: 'flatten',
            fields,
            as
        };
        return result;
    }
}
/**
 * A class for flatten transform nodes
 */ class FoldTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new FoldTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? 'key',
            specifiedAs[1] ?? 'value'
        ];
    }
    dependentFields() {
        return new Set(this.transform.fold);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `FoldTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { fold, as } = this.transform;
        const result = {
            type: 'fold',
            fields: fold,
            as
        };
        return result;
    }
}
class GeoJSONNode extends DataFlowNode {
    fields;
    geojson;
    signal;
    clone() {
        return new GeoJSONNode(null, duplicate(this.fields), this.geojson, this.signal);
    }
    static parseAll(parent, model) {
        if (model.component.projection && !model.component.projection.isFit) return parent;
        let geoJsonCounter = 0;
        for (const coordinates of [
            [
                LONGITUDE,
                LATITUDE
            ],
            [
                LONGITUDE2,
                LATITUDE2
            ]
        ]){
            const pair = coordinates.map((channel)=>{
                const def = getFieldOrDatumDef(model.encoding[channel]);
                return isFieldDef(def) ? def.field : isDatumDef(def) ? {
                    expr: `${def.datum}`
                } : isValueDef(def) ? {
                    expr: `${def['value']}`
                } : undefined;
            });
            if (pair[0] || pair[1]) parent = new GeoJSONNode(parent, pair, null, model.getName(`geojson_${geoJsonCounter++}`));
        }
        if (model.channelHasField(SHAPE)) {
            const fieldDef = model.typedFieldDef(SHAPE);
            if (fieldDef.type === GEOJSON) parent = new GeoJSONNode(parent, null, fieldDef.field, model.getName(`geojson_${geoJsonCounter++}`));
        }
        return parent;
    }
    constructor(parent, fields, geojson, signal){
        super(parent);
        this.fields = fields;
        this.geojson = geojson;
        this.signal = signal;
    }
    dependentFields() {
        const fields = (this.fields ?? []).filter((0, _vegaUtil.isString));
        return new Set([
            ...this.geojson ? [
                this.geojson
            ] : [],
            ...fields
        ]);
    }
    producedFields() {
        return new Set();
    }
    hash() {
        return `GeoJSON ${this.geojson} ${this.signal} ${hash(this.fields)}`;
    }
    assemble() {
        return [
            ...this.geojson ? [
                {
                    type: 'filter',
                    expr: `isValid(datum["${this.geojson}"])`
                }
            ] : [],
            {
                type: 'geojson',
                ...this.fields ? {
                    fields: this.fields
                } : {},
                ...this.geojson ? {
                    geojson: this.geojson
                } : {},
                signal: this.signal
            }
        ];
    }
}
class GeoPointNode extends DataFlowNode {
    projection;
    fields;
    as;
    clone() {
        return new GeoPointNode(null, this.projection, duplicate(this.fields), duplicate(this.as));
    }
    constructor(parent, projection, fields, as){
        super(parent);
        this.projection = projection;
        this.fields = fields;
        this.as = as;
    }
    static parseAll(parent, model) {
        if (!model.projectionName()) return parent;
        for (const coordinates of [
            [
                LONGITUDE,
                LATITUDE
            ],
            [
                LONGITUDE2,
                LATITUDE2
            ]
        ]){
            const pair = coordinates.map((channel)=>{
                const def = getFieldOrDatumDef(model.encoding[channel]);
                return isFieldDef(def) ? def.field : isDatumDef(def) ? {
                    expr: `${def.datum}`
                } : isValueDef(def) ? {
                    expr: `${def['value']}`
                } : undefined;
            });
            const suffix = coordinates[0] === LONGITUDE2 ? '2' : '';
            if (pair[0] || pair[1]) parent = new GeoPointNode(parent, model.projectionName(), pair, [
                model.getName(`x${suffix}`),
                model.getName(`y${suffix}`)
            ]);
        }
        return parent;
    }
    dependentFields() {
        return new Set(this.fields.filter((0, _vegaUtil.isString)));
    }
    producedFields() {
        return new Set(this.as);
    }
    hash() {
        return `Geopoint ${this.projection} ${hash(this.fields)} ${hash(this.as)}`;
    }
    assemble() {
        return {
            type: 'geopoint',
            projection: this.projection,
            fields: this.fields,
            as: this.as
        };
    }
}
class ImputeNode extends DataFlowNode {
    transform;
    clone() {
        return new ImputeNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    dependentFields() {
        return new Set([
            this.transform.impute,
            this.transform.key,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set([
            this.transform.impute
        ]);
    }
    processSequence(keyvals) {
        const { start = 0, stop, step } = keyvals;
        const result = [
            start,
            stop,
            ...step ? [
                step
            ] : []
        ].join(',');
        return {
            signal: `sequence(${result})`
        };
    }
    static makeFromTransform(parent, imputeTransform) {
        return new ImputeNode(parent, imputeTransform);
    }
    static makeFromEncoding(parent, model) {
        const encoding = model.encoding;
        const xDef = encoding.x;
        const yDef = encoding.y;
        if (isFieldDef(xDef) && isFieldDef(yDef)) {
            const imputedChannel = xDef.impute ? xDef : yDef.impute ? yDef : undefined;
            if (imputedChannel === undefined) return undefined;
            const keyChannel = xDef.impute ? yDef : yDef.impute ? xDef : undefined;
            const { method, value, frame, keyvals } = imputedChannel.impute;
            const groupbyFields = pathGroupingFields(model.mark, encoding);
            return new ImputeNode(parent, {
                impute: imputedChannel.field,
                key: keyChannel.field,
                ...method ? {
                    method
                } : {},
                ...value !== undefined ? {
                    value
                } : {},
                ...frame ? {
                    frame
                } : {},
                ...keyvals !== undefined ? {
                    keyvals
                } : {},
                ...groupbyFields.length ? {
                    groupby: groupbyFields
                } : {}
            });
        }
        return null;
    }
    hash() {
        return `Impute ${hash(this.transform)}`;
    }
    assemble() {
        const { impute, key, keyvals, method, groupby, value, frame = [
            null,
            null
        ] } = this.transform;
        const imputeTransform = {
            type: 'impute',
            field: impute,
            key,
            ...keyvals ? {
                keyvals: isImputeSequence(keyvals) ? this.processSequence(keyvals) : keyvals
            } : {},
            method: 'value',
            ...groupby ? {
                groupby
            } : {},
            value: !method || method === 'value' ? value : null
        };
        if (method && method !== 'value') {
            const deriveNewField = {
                type: 'window',
                as: [
                    `imputed_${impute}_value`
                ],
                ops: [
                    method
                ],
                fields: [
                    impute
                ],
                frame,
                ignorePeers: false,
                ...groupby ? {
                    groupby
                } : {}
            };
            const replaceOriginal = {
                type: 'formula',
                expr: `datum.${impute} === null ? datum.imputed_${impute}_value : datum.${impute}`,
                as: impute
            };
            return [
                imputeTransform,
                deriveNewField,
                replaceOriginal
            ];
        } else return [
            imputeTransform
        ];
    }
}
/**
 * A class for loess transform nodes
 */ class LoessTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new LoessTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? transform.on,
            specifiedAs[1] ?? transform.loess
        ];
    }
    dependentFields() {
        return new Set([
            this.transform.loess,
            this.transform.on,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `LoessTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { loess, on, ...rest } = this.transform;
        const result = {
            type: 'loess',
            x: on,
            y: loess,
            ...rest
        };
        return result;
    }
}
class LookupNode extends DataFlowNode {
    transform;
    secondary;
    clone() {
        return new LookupNode(null, duplicate(this.transform), this.secondary);
    }
    constructor(parent, transform, secondary){
        super(parent);
        this.transform = transform;
        this.secondary = secondary;
    }
    static make(parent, model, transform, counter) {
        const sources = model.component.data.sources;
        const { from } = transform;
        let fromOutputNode = null;
        if (isLookupData(from)) {
            let fromSource = findSource(from.data, sources);
            if (!fromSource) {
                fromSource = new SourceNode(from.data);
                sources.push(fromSource);
            }
            const fromOutputName = model.getName(`lookup_${counter}`);
            fromOutputNode = new OutputNode(fromSource, fromOutputName, DataSourceType.Lookup, model.component.data.outputNodeRefCounts);
            model.component.data.outputNodes[fromOutputName] = fromOutputNode;
        } else if (isLookupSelection(from)) {
            const selName = from.param;
            transform = {
                as: selName,
                ...transform
            };
            let selCmpt;
            try {
                selCmpt = model.getSelectionComponent(varName(selName), selName);
            } catch  {
                throw new Error(cannotLookupVariableParameter(selName));
            }
            fromOutputNode = selCmpt.materialized;
            if (!fromOutputNode) throw new Error(noSameUnitLookup(selName));
        }
        return new LookupNode(parent, transform, fromOutputNode.getSource());
    }
    dependentFields() {
        return new Set([
            this.transform.lookup
        ]);
    }
    producedFields() {
        return new Set(this.transform.as ? (0, _vegaUtil.array)(this.transform.as) : this.transform.from.fields);
    }
    hash() {
        return `Lookup ${hash({
            transform: this.transform,
            secondary: this.secondary
        })}`;
    }
    assemble() {
        let foreign;
        if (this.transform.from.fields) // lookup a few fields and add create a flat output
        foreign = {
            values: this.transform.from.fields,
            ...this.transform.as ? {
                as: (0, _vegaUtil.array)(this.transform.as)
            } : {}
        };
        else {
            // lookup full record and nest it
            let asName = this.transform.as;
            if (!(0, _vegaUtil.isString)(asName)) {
                warn(NO_FIELDS_NEEDS_AS);
                asName = '_lookup';
            }
            foreign = {
                as: [
                    asName
                ]
            };
        }
        return {
            type: 'lookup',
            from: this.secondary,
            key: this.transform.from.key,
            fields: [
                this.transform.lookup
            ],
            ...foreign,
            ...this.transform.default ? {
                default: this.transform.default
            } : {}
        };
    }
}
/**
 * A class for quantile transform nodes
 */ class QuantileTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new QuantileTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? 'prob',
            specifiedAs[1] ?? 'value'
        ];
    }
    dependentFields() {
        return new Set([
            this.transform.quantile,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `QuantileTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { quantile, ...rest } = this.transform;
        const result = {
            type: 'quantile',
            field: quantile,
            ...rest
        };
        return result;
    }
}
/**
 * A class for regression transform nodes
 */ class RegressionTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new RegressionTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
        this.transform = duplicate(transform); // duplicate to prevent side effects
        const specifiedAs = this.transform.as ?? [
            undefined,
            undefined
        ];
        this.transform.as = [
            specifiedAs[0] ?? transform.on,
            specifiedAs[1] ?? transform.regression
        ];
    }
    dependentFields() {
        return new Set([
            this.transform.regression,
            this.transform.on,
            ...this.transform.groupby ?? []
        ]);
    }
    producedFields() {
        return new Set(this.transform.as);
    }
    hash() {
        return `RegressionTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { regression, on, ...rest } = this.transform;
        const result = {
            type: 'regression',
            x: on,
            y: regression,
            ...rest
        };
        return result;
    }
}
/**
 * A class for pivot transform nodes.
 */ class PivotTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new PivotTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    addDimensions(fields) {
        this.transform.groupby = unique((this.transform.groupby ?? []).concat(fields), (d)=>d);
    }
    producedFields() {
        return undefined; // return undefined so that potentially everything can depend on the pivot
    }
    dependentFields() {
        return new Set([
            this.transform.pivot,
            this.transform.value,
            ...this.transform.groupby ?? []
        ]);
    }
    hash() {
        return `PivotTransform ${hash(this.transform)}`;
    }
    assemble() {
        const { pivot, value, groupby, limit, op } = this.transform;
        return {
            type: 'pivot',
            field: pivot,
            value,
            ...limit !== undefined ? {
                limit
            } : {},
            ...op !== undefined ? {
                op
            } : {},
            ...groupby !== undefined ? {
                groupby
            } : {}
        };
    }
}
/**
 * A class for the sample transform nodes
 */ class SampleTransformNode extends DataFlowNode {
    transform;
    clone() {
        return new SampleTransformNode(null, duplicate(this.transform));
    }
    constructor(parent, transform){
        super(parent);
        this.transform = transform;
    }
    dependentFields() {
        return new Set();
    }
    producedFields() {
        return new Set();
    }
    hash() {
        return `SampleTransform ${hash(this.transform)}`;
    }
    assemble() {
        return {
            type: 'sample',
            size: this.transform.sample
        };
    }
}
function makeWalkTree(data) {
    // to name datasources
    let datasetIndex = 0;
    /**
     * Recursively walk down the tree.
     */ function walkTree(node, dataSource) {
        if (node instanceof SourceNode) // If the source is a named data source or a data source with values, we need
        // to put it in a different data source. Otherwise, Vega may override the data.
        {
            if (!node.isGenerator && !isUrlData(node.data)) {
                data.push(dataSource);
                const newData = {
                    name: null,
                    source: dataSource.name,
                    transform: []
                };
                dataSource = newData;
            }
        }
        if (node instanceof ParseNode) {
            if (node.parent instanceof SourceNode && !dataSource.source) {
                // If node's parent is a root source and the data source does not refer to another data source, use normal format parse
                dataSource.format = {
                    ...dataSource.format,
                    parse: node.assembleFormatParse()
                };
                // add calculates for all nested fields
                dataSource.transform.push(...node.assembleTransforms(true));
            } else // Otherwise use Vega expression to parse
            dataSource.transform.push(...node.assembleTransforms());
        }
        if (node instanceof FacetNode) {
            if (!dataSource.name) dataSource.name = `data_${datasetIndex++}`;
            if (!dataSource.source || dataSource.transform.length > 0) {
                data.push(dataSource);
                node.data = dataSource.name;
            } else node.data = dataSource.source;
            data.push(...node.assemble());
            // break here because the rest of the tree has to be taken care of by the facet.
            return;
        }
        if (node instanceof GraticuleNode || node instanceof SequenceNode || node instanceof FilterInvalidNode || node instanceof FilterNode || node instanceof CalculateNode || node instanceof GeoPointNode || node instanceof AggregateNode || node instanceof LookupNode || node instanceof WindowTransformNode || node instanceof JoinAggregateTransformNode || node instanceof FoldTransformNode || node instanceof FlattenTransformNode || node instanceof DensityTransformNode || node instanceof LoessTransformNode || node instanceof QuantileTransformNode || node instanceof RegressionTransformNode || node instanceof IdentifierNode || node instanceof SampleTransformNode || node instanceof PivotTransformNode || node instanceof ExtentTransformNode) dataSource.transform.push(node.assemble());
        if (node instanceof BinNode || node instanceof TimeUnitNode || node instanceof ImputeNode || node instanceof StackNode || node instanceof GeoJSONNode) dataSource.transform.push(...node.assemble());
        if (node instanceof OutputNode) {
            if (dataSource.source && dataSource.transform.length === 0) node.setSource(dataSource.source);
            else if (node.parent instanceof OutputNode) // Note that an output node may be required but we still do not assemble a
            // separate data source for it.
            node.setSource(dataSource.name);
            else {
                if (!dataSource.name) dataSource.name = `data_${datasetIndex++}`;
                // Here we set the name of the datasource we generated. From now on
                // other assemblers can use it.
                node.setSource(dataSource.name);
                // if this node has more than one child, we will add a datasource automatically
                if (node.numChildren() === 1) {
                    data.push(dataSource);
                    const newData = {
                        name: null,
                        source: dataSource.name,
                        transform: []
                    };
                    dataSource = newData;
                }
            }
        }
        switch(node.numChildren()){
            case 0:
                // done
                if (node instanceof OutputNode && (!dataSource.source || dataSource.transform.length > 0)) // do not push empty datasources that are simply references
                data.push(dataSource);
                break;
            case 1:
                walkTree(node.children[0], dataSource);
                break;
            default:
                {
                    if (!dataSource.name) dataSource.name = `data_${datasetIndex++}`;
                    let source = dataSource.name;
                    if (!dataSource.source || dataSource.transform.length > 0) data.push(dataSource);
                    else source = dataSource.source;
                    for (const child of node.children){
                        const newData = {
                            name: null,
                            source,
                            transform: []
                        };
                        walkTree(child, newData);
                    }
                    break;
                }
        }
    }
    return walkTree;
}
/**
 * Assemble data sources that are derived from faceted data.
 */ function assembleFacetData(root) {
    const data = [];
    const walkTree = makeWalkTree(data);
    for (const child of root.children)walkTree(child, {
        source: root.name,
        name: null,
        transform: []
    });
    return data;
}
/**
 * Create Vega data array from a given compiled model and append all of them to the given array
 *
 * @param  model
 * @param  data array
 * @return modified data array
 */ function assembleRootData(dataComponent, datasets) {
    const data = [];
    // dataComponent.sources.forEach(debug);
    // draw(dataComponent.sources);
    const walkTree = makeWalkTree(data);
    let sourceIndex = 0;
    for (const root of dataComponent.sources){
        // assign a name if the source does not have a name yet
        if (!root.hasName()) root.dataName = `source_${sourceIndex++}`;
        const newData = root.assemble();
        walkTree(root, newData);
    }
    // remove empty transform arrays for cleaner output
    for (const d of data)if (d.transform.length === 0) delete d.transform;
    // move sources without transforms (the ones that are potentially used in lookups) to the beginning
    let whereTo = 0;
    for (const [i, d] of data.entries())if ((d.transform ?? []).length === 0 && !d.source) data.splice(whereTo++, 0, data.splice(i, 1)[0]);
    // now fix the from references in lookup transforms
    for (const d of data){
        for (const t of d.transform ?? [])if (t.type === 'lookup') t.from = dataComponent.outputNodes[t.from].getSource();
    }
    // inline values for datasets that are in the datastore
    for (const d of data)if (d.name in datasets) d.values = datasets[d.name];
    return data;
}
function getHeaderType(orient) {
    if (orient === 'top' || orient === 'left' || isSignalRef(orient)) // we always use header for orient signal since we can't dynamically make header becomes footer
    return 'header';
    return 'footer';
}
function parseFacetHeaders(model) {
    for (const channel of FACET_CHANNELS)parseFacetHeader(model, channel);
    mergeChildAxis(model, 'x');
    mergeChildAxis(model, 'y');
}
function parseFacetHeader(model, channel) {
    const { facet, config, child, component } = model;
    if (model.channelHasField(channel)) {
        const fieldDef = facet[channel];
        const titleConfig = getHeaderProperty('title', null, config, channel);
        let title$1 = title(fieldDef, config, {
            allowDisabling: true,
            includeDefault: titleConfig === undefined || !!titleConfig
        });
        if (child.component.layoutHeaders[channel].title) {
            // TODO: better handle multiline titles
            title$1 = (0, _vegaUtil.isArray)(title$1) ? title$1.join(', ') : title$1;
            // merge title with child to produce "Title / Subtitle / Sub-subtitle"
            title$1 += ` / ${child.component.layoutHeaders[channel].title}`;
            child.component.layoutHeaders[channel].title = null;
        }
        const labelOrient = getHeaderProperty('labelOrient', fieldDef.header, config, channel);
        const labels = fieldDef.header !== null ? getFirstDefined(fieldDef.header?.labels, config.header.labels, true) : false;
        const headerType = contains([
            'bottom',
            'right'
        ], labelOrient) ? 'footer' : 'header';
        component.layoutHeaders[channel] = {
            title: fieldDef.header !== null ? title$1 : null,
            facetFieldDef: fieldDef,
            [headerType]: channel === 'facet' ? [] : [
                makeHeaderComponent(model, channel, labels)
            ]
        };
    }
}
function makeHeaderComponent(model, channel, labels) {
    const sizeType = channel === 'row' ? 'height' : 'width';
    return {
        labels,
        sizeSignal: model.child.component.layoutSize.get(sizeType) ? model.child.getSizeSignalRef(sizeType) : undefined,
        axes: []
    };
}
function mergeChildAxis(model, channel) {
    const { child } = model;
    if (child.component.axes[channel]) {
        const { layoutHeaders, resolve } = model.component;
        resolve.axis[channel] = parseGuideResolve(resolve, channel);
        if (resolve.axis[channel] === 'shared') {
            // For shared axis, move the axes to facet's header or footer
            const headerChannel = channel === 'x' ? 'column' : 'row';
            const layoutHeader = layoutHeaders[headerChannel];
            for (const axisComponent of child.component.axes[channel]){
                const headerType = getHeaderType(axisComponent.get('orient'));
                layoutHeader[headerType] ??= [
                    makeHeaderComponent(model, headerChannel, false)
                ];
                // FIXME: assemble shouldn't be called here, but we do it this way so we only extract the main part of the axes
                const mainAxis = assembleAxis(axisComponent, 'main', model.config, {
                    header: true
                });
                if (mainAxis) // LayoutHeader no longer keep track of property precedence, thus let's combine.
                layoutHeader[headerType][0].axes.push(mainAxis);
                axisComponent.mainExtracted = true;
            }
        }
    }
}
function parseLayerLayoutSize(model) {
    parseChildrenLayoutSize(model);
    parseNonUnitLayoutSizeForChannel(model, 'width');
    parseNonUnitLayoutSizeForChannel(model, 'height');
}
function parseConcatLayoutSize(model) {
    parseChildrenLayoutSize(model);
    // for columns === 1 (vconcat), we can completely merge width. Otherwise, we can treat merged width as childWidth.
    const widthType = model.layout.columns === 1 ? 'width' : 'childWidth';
    // for columns === undefined (hconcat), we can completely merge height. Otherwise, we can treat merged height as childHeight.
    const heightType = model.layout.columns === undefined ? 'height' : 'childHeight';
    parseNonUnitLayoutSizeForChannel(model, widthType);
    parseNonUnitLayoutSizeForChannel(model, heightType);
}
function parseChildrenLayoutSize(model) {
    for (const child of model.children)child.parseLayoutSize();
}
/**
 * Merge child layout size (width or height).
 */ function parseNonUnitLayoutSizeForChannel(model, layoutSizeType) {
    /*
     * For concat, the parent width or height might not be the same as the children's shared height.
     * For example, hconcat's subviews may share width, but the shared width is not the hconcat view's width.
     *
     * layoutSizeType represents the output of the view (could be childWidth/childHeight/width/height)
     * while the sizeType represents the properties of the child.
     */ const sizeType = getSizeTypeFromLayoutSizeType(layoutSizeType);
    const channel = getPositionScaleChannel(sizeType);
    const resolve = model.component.resolve;
    const layoutSizeCmpt = model.component.layoutSize;
    let mergedSize;
    // Try to merge layout size
    for (const child of model.children){
        const childSize = child.component.layoutSize.getWithExplicit(sizeType);
        const scaleResolve = resolve.scale[channel] ?? defaultScaleResolve(channel, model);
        if (scaleResolve === 'independent' && childSize.value === 'step') {
            // Do not merge independent scales with range-step as their size depends
            // on the scale domains, which can be different between scales.
            mergedSize = undefined;
            break;
        }
        if (mergedSize) {
            if (scaleResolve === 'independent' && mergedSize.value !== childSize.value) {
                // For independent scale, only merge if all the sizes are the same.
                // If the values are different, abandon the merge!
                mergedSize = undefined;
                break;
            }
            mergedSize = mergeValuesWithExplicit(mergedSize, childSize, sizeType, '');
        } else mergedSize = childSize;
    }
    if (mergedSize) {
        // If merged, rename size and set size of all children.
        for (const child of model.children){
            model.renameSignal(child.getName(sizeType), model.getName(layoutSizeType));
            child.component.layoutSize.set(sizeType, 'merged', false);
        }
        layoutSizeCmpt.setWithExplicit(layoutSizeType, mergedSize);
    } else layoutSizeCmpt.setWithExplicit(layoutSizeType, {
        explicit: false,
        value: undefined
    });
}
function parseUnitLayoutSize(model) {
    const { size, component } = model;
    for (const channel of POSITION_SCALE_CHANNELS){
        const sizeType = getSizeChannel(channel);
        if (size[sizeType]) {
            const specifiedSize = size[sizeType];
            component.layoutSize.set(sizeType, isStep(specifiedSize) ? 'step' : specifiedSize, true);
        } else {
            const defaultSize = defaultUnitSize(model, sizeType);
            component.layoutSize.set(sizeType, defaultSize, false);
        }
    }
}
function defaultUnitSize(model, sizeType) {
    const channel = sizeType === 'width' ? 'x' : 'y';
    const config = model.config;
    const scaleComponent = model.getScaleComponent(channel);
    if (scaleComponent) {
        const scaleType = scaleComponent.get('type');
        const range = scaleComponent.get('range');
        if (hasDiscreteDomain(scaleType)) {
            const size = getViewConfigDiscreteSize(config.view, sizeType);
            if (isVgRangeStep(range) || isStep(size)) // For discrete domain with range.step, use dynamic width/height
            return 'step';
            else return size;
        } else return getViewConfigContinuousSize(config.view, sizeType);
    } else if (model.hasProjection || model.mark === 'arc') // arc should use continuous size by default otherwise the pie is extremely small
    return getViewConfigContinuousSize(config.view, sizeType);
    else {
        const size = getViewConfigDiscreteSize(config.view, sizeType);
        return isStep(size) ? size.step : size;
    }
}
function facetSortFieldName(fieldDef, sort, opt) {
    return vgField(sort, {
        suffix: `by_${vgField(fieldDef)}`,
        ...opt
    });
}
class FacetModel extends ModelWithField {
    facet;
    child;
    children;
    constructor(spec, parent, parentGivenName, config){
        super(spec, 'facet', parent, parentGivenName, config, spec.resolve);
        this.child = buildModel(spec.spec, this, this.getName('child'), undefined, config);
        this.children = [
            this.child
        ];
        this.facet = this.initFacet(spec.facet);
    }
    initFacet(facet) {
        // clone to prevent side effect to the original spec
        if (!isFacetMapping(facet)) return {
            facet: this.initFacetFieldDef(facet, 'facet')
        };
        const channels = keys(facet);
        const normalizedFacet = {};
        for (const channel of channels){
            if (![
                ROW,
                COLUMN
            ].includes(channel)) {
                // Drop unsupported channel
                warn(incompatibleChannel(channel, 'facet'));
                break;
            }
            const fieldDef = facet[channel];
            if (fieldDef.field === undefined) {
                warn(emptyFieldDef(fieldDef, channel));
                break;
            }
            normalizedFacet[channel] = this.initFacetFieldDef(fieldDef, channel);
        }
        return normalizedFacet;
    }
    initFacetFieldDef(fieldDef, channel) {
        // Cast because we call initFieldDef, which assumes general FieldDef.
        // However, FacetFieldDef is a bit more constrained than the general FieldDef
        const facetFieldDef = initFieldDef(fieldDef, channel);
        if (facetFieldDef.header) facetFieldDef.header = replaceExprRef(facetFieldDef.header);
        else if (facetFieldDef.header === null) facetFieldDef.header = null;
        return facetFieldDef;
    }
    channelHasField(channel) {
        return hasProperty(this.facet, channel);
    }
    fieldDef(channel) {
        return this.facet[channel];
    }
    parseData() {
        this.component.data = parseData(this);
        this.child.parseData();
    }
    parseLayoutSize() {
        parseChildrenLayoutSize(this);
    }
    parseSelections() {
        // As a facet has a single child, the selection components are the same.
        // The child maintains its selections to assemble signals, which remain
        // within its unit.
        this.child.parseSelections();
        this.component.selection = this.child.component.selection;
        if (vals(this.component.selection).some((selCmpt)=>isTimerSelection(selCmpt))) error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
    }
    parseMarkGroup() {
        this.child.parseMarkGroup();
    }
    parseAxesAndHeaders() {
        this.child.parseAxesAndHeaders();
        parseFacetHeaders(this);
    }
    assembleSelectionTopLevelSignals(signals) {
        return this.child.assembleSelectionTopLevelSignals(signals);
    }
    assembleSignals() {
        this.child.assembleSignals();
        return [];
    }
    assembleSelectionData(data) {
        return this.child.assembleSelectionData(data);
    }
    getHeaderLayoutMixins() {
        const layoutMixins = {};
        for (const channel of FACET_CHANNELS)for (const headerType of HEADER_TYPES){
            const layoutHeaderComponent = this.component.layoutHeaders[channel];
            const headerComponent = layoutHeaderComponent[headerType];
            const { facetFieldDef } = layoutHeaderComponent;
            if (facetFieldDef) {
                const titleOrient = getHeaderProperty('titleOrient', facetFieldDef.header, this.config, channel);
                if ([
                    'right',
                    'bottom'
                ].includes(titleOrient)) {
                    const headerChannel = getHeaderChannel(channel, titleOrient);
                    layoutMixins.titleAnchor ??= {};
                    layoutMixins.titleAnchor[headerChannel] = 'end';
                }
            }
            if (headerComponent?.[0]) {
                // set header/footerBand
                const sizeType = channel === 'row' ? 'height' : 'width';
                const bandType = headerType === 'header' ? 'headerBand' : 'footerBand';
                if (channel !== 'facet' && !this.child.component.layoutSize.get(sizeType)) {
                    // If facet child does not have size signal, then apply headerBand
                    layoutMixins[bandType] ??= {};
                    layoutMixins[bandType][channel] = 0.5;
                }
                if (layoutHeaderComponent.title) {
                    layoutMixins.offset ??= {};
                    layoutMixins.offset[channel === 'row' ? 'rowTitle' : 'columnTitle'] = 10;
                }
            }
        }
        return layoutMixins;
    }
    assembleDefaultLayout() {
        const { column, row } = this.facet;
        const columns = column ? this.columnDistinctSignal() : row ? 1 : undefined;
        let align = 'all';
        // Do not align the cells if the scale corresponding to the direction is indepent.
        // We always align when we facet into both row and column.
        if (!row && this.component.resolve.scale.x === 'independent') align = 'none';
        else if (!column && this.component.resolve.scale.y === 'independent') align = 'none';
        return {
            ...this.getHeaderLayoutMixins(),
            ...columns ? {
                columns
            } : {},
            bounds: 'full',
            align
        };
    }
    assembleLayoutSignals() {
        // FIXME(https://github.com/vega/vega-lite/issues/1193): this can be incorrect if we have independent scales.
        return this.child.assembleLayoutSignals();
    }
    columnDistinctSignal() {
        if (this.parent && this.parent instanceof FacetModel) // For nested facet, we will add columns to group mark instead
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return undefined;
        else {
            // In facetNode.assemble(), the name is always this.getName('column') + '_layout'.
            const facetLayoutDataName = this.getName('column_domain');
            return {
                signal: `length(data('${facetLayoutDataName}'))`
            };
        }
    }
    assembleGroupStyle() {
        return undefined;
    }
    assembleGroup(signals) {
        if (this.parent && this.parent instanceof FacetModel) // Provide number of columns for layout.
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return {
            ...this.channelHasField('column') ? {
                encode: {
                    update: {
                        // TODO(https://github.com/vega/vega-lite/issues/2759):
                        // Correct the signal for facet of concat of facet_column
                        columns: {
                            field: vgField(this.facet.column, {
                                prefix: 'distinct'
                            })
                        }
                    }
                }
            } : {},
            ...super.assembleGroup(signals)
        };
        return super.assembleGroup(signals);
    }
    /**
     * Aggregate cardinality for calculating size
     */ getCardinalityAggregateForChild() {
        const fields = [];
        const ops = [];
        const as = [];
        if (this.child instanceof FacetModel) {
            if (this.child.channelHasField('column')) {
                const field = vgField(this.child.facet.column);
                fields.push(field);
                ops.push('distinct');
                as.push(`distinct_${field}`);
            }
        } else for (const channel of POSITION_SCALE_CHANNELS){
            const childScaleComponent = this.child.component.scales[channel];
            if (childScaleComponent && !childScaleComponent.merged) {
                const type = childScaleComponent.get('type');
                const range = childScaleComponent.get('range');
                if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
                    const domain = assembleDomain(this.child, channel);
                    const field = getFieldFromDomain(domain);
                    if (field) {
                        fields.push(field);
                        ops.push('distinct');
                        as.push(`distinct_${field}`);
                    } else warn(unknownField(channel));
                }
            }
        }
        return {
            fields,
            ops,
            as
        };
    }
    assembleFacet() {
        const { name, data } = this.component.data.facetRoot;
        const { row, column } = this.facet;
        const { fields, ops, as } = this.getCardinalityAggregateForChild();
        const groupby = [];
        for (const channel of FACET_CHANNELS){
            const fieldDef = this.facet[channel];
            if (fieldDef) {
                groupby.push(vgField(fieldDef));
                const { bin, sort } = fieldDef;
                if (isBinning(bin)) groupby.push(vgField(fieldDef, {
                    binSuffix: 'end'
                }));
                if (isSortField(sort)) {
                    const { field, op = DEFAULT_SORT_OP } = sort;
                    const outputName = facetSortFieldName(fieldDef, sort);
                    if (row && column) {
                        // For crossed facet, use pre-calculate field as it requires a different groupby
                        // For each calculated field, apply max and assign them to the same name as
                        // all values of the same group should be the same anyway.
                        fields.push(outputName);
                        ops.push('max');
                        as.push(outputName);
                    } else {
                        fields.push(field);
                        ops.push(op);
                        as.push(outputName);
                    }
                } else if ((0, _vegaUtil.isArray)(sort)) {
                    const outputName = sortArrayIndexField(fieldDef, channel);
                    fields.push(outputName);
                    ops.push('max');
                    as.push(outputName);
                }
            }
        }
        const cross = !!row && !!column;
        return {
            name,
            data,
            groupby,
            ...cross || fields.length > 0 ? {
                aggregate: {
                    ...cross ? {
                        cross
                    } : {},
                    ...fields.length ? {
                        fields,
                        ops,
                        as
                    } : {}
                }
            } : {}
        };
    }
    facetSortFields(channel) {
        const { facet } = this;
        const fieldDef = facet[channel];
        if (fieldDef) {
            if (isSortField(fieldDef.sort)) return [
                facetSortFieldName(fieldDef, fieldDef.sort, {
                    expr: 'datum'
                })
            ];
            else if ((0, _vegaUtil.isArray)(fieldDef.sort)) return [
                sortArrayIndexField(fieldDef, channel, {
                    expr: 'datum'
                })
            ];
            return [
                vgField(fieldDef, {
                    expr: 'datum'
                })
            ];
        }
        return [];
    }
    facetSortOrder(channel) {
        const { facet } = this;
        const fieldDef = facet[channel];
        if (fieldDef) {
            const { sort } = fieldDef;
            const order = (isSortField(sort) ? sort.order : !(0, _vegaUtil.isArray)(sort) && sort) || 'ascending';
            return [
                order
            ];
        }
        return [];
    }
    assembleLabelTitle() {
        const { facet, config } = this;
        if (facet.facet) // Facet always uses title to display labels
        return assembleLabelTitle(facet.facet, 'facet', config);
        const ORTHOGONAL_ORIENT = {
            row: [
                'top',
                'bottom'
            ],
            column: [
                'left',
                'right'
            ]
        };
        for (const channel of HEADER_CHANNELS)if (facet[channel]) {
            const labelOrient = getHeaderProperty('labelOrient', facet[channel]?.header, config, channel);
            if (ORTHOGONAL_ORIENT[channel].includes(labelOrient)) // Row/Column with orthogonal labelOrient must use title to display labels
            return assembleLabelTitle(facet[channel], channel, config);
        }
        return undefined;
    }
    assembleMarks() {
        const { child } = this;
        // If we facet by two dimensions, we need to add a cross operator to the aggregation
        // so that we create all groups
        const facetRoot = this.component.data.facetRoot;
        const data = assembleFacetData(facetRoot);
        const encodeEntry = child.assembleGroupEncodeEntry(false);
        const title = this.assembleLabelTitle() || child.assembleTitle();
        const style = child.assembleGroupStyle();
        const markGroup = {
            name: this.getName('cell'),
            type: 'group',
            ...title ? {
                title
            } : {},
            ...style ? {
                style
            } : {},
            from: {
                facet: this.assembleFacet()
            },
            // TODO: move this to after data
            sort: {
                field: FACET_CHANNELS.map((c)=>this.facetSortFields(c)).flat(),
                order: FACET_CHANNELS.map((c)=>this.facetSortOrder(c)).flat()
            },
            ...data.length > 0 ? {
                data
            } : {},
            ...encodeEntry ? {
                encode: {
                    update: encodeEntry
                }
            } : {},
            ...child.assembleGroup(assembleFacetSignals(this, []))
        };
        return [
            markGroup
        ];
    }
    getMapping() {
        return this.facet;
    }
}
function makeJoinAggregateFromFacet(parent, facet) {
    const { row, column } = facet;
    if (row && column) {
        let newParent = null;
        // only need to make one for crossed facet
        for (const fieldDef of [
            row,
            column
        ])if (isSortField(fieldDef.sort)) {
            const { field, op = DEFAULT_SORT_OP } = fieldDef.sort;
            parent = newParent = new JoinAggregateTransformNode(parent, {
                joinaggregate: [
                    {
                        op,
                        field,
                        as: facetSortFieldName(fieldDef, fieldDef.sort, {
                            forAs: true
                        })
                    }
                ],
                groupby: [
                    vgField(fieldDef)
                ]
            });
        }
        return newParent;
    }
    return null;
}
function findSource(data, sources) {
    for (const other of sources){
        const otherData = other.data;
        // if both datasets have a name defined, we cannot merge
        if (data.name && other.hasName() && data.name !== other.dataName) continue;
        const formatMesh = data.format?.mesh;
        const otherFeature = otherData.format?.feature;
        // feature and mesh are mutually exclusive
        if (formatMesh && otherFeature) continue;
        // we have to extract the same feature or mesh
        const formatFeature = data.format?.feature;
        if ((formatFeature || otherFeature) && formatFeature !== otherFeature) continue;
        const otherMesh = otherData.format?.mesh;
        if ((formatMesh || otherMesh) && formatMesh !== otherMesh) continue;
        if (isInlineData(data) && isInlineData(otherData)) {
            if (deepEqual(data.values, otherData.values)) return other;
        } else if (isUrlData(data) && isUrlData(otherData)) {
            if (data.url === otherData.url) return other;
        } else if (isNamedData(data)) {
            if (data.name === other.dataName) return other;
        }
    }
    return null;
}
function parseRoot(model, sources) {
    if (model.data || !model.parent) {
        // if the model defines a data source or is the root, create a source node
        if (model.data === null) {
            // data: null means we should ignore the parent's data so we just create a new data source
            const source = new SourceNode({
                values: []
            });
            sources.push(source);
            return source;
        }
        const existingSource = findSource(model.data, sources);
        if (existingSource) {
            if (!isGenerator(model.data)) existingSource.data.format = mergeDeep({}, model.data.format, existingSource.data.format);
            // if the new source has a name but the existing one does not, we can set it
            if (!existingSource.hasName() && model.data.name) existingSource.dataName = model.data.name;
            return existingSource;
        } else {
            const source = new SourceNode(model.data);
            sources.push(source);
            return source;
        }
    } else // If we don't have a source defined (overriding parent's data), use the parent's facet root or main.
    return model.parent.component.data.facetRoot ? model.parent.component.data.facetRoot : model.parent.component.data.main;
}
/**
 * Parses a transform array into a chain of connected dataflow nodes.
 */ function parseTransformArray(head, model, ancestorParse) {
    let lookupCounter = 0;
    for (const t of model.transforms){
        let derivedType = undefined;
        let transformNode;
        if (isCalculate(t)) {
            transformNode = head = new CalculateNode(head, t);
            derivedType = 'derived';
        } else if (isFilter(t)) {
            const implicit = getImplicitFromFilterTransform(t);
            transformNode = head = ParseNode.makeWithAncestors(head, {}, implicit, ancestorParse) ?? head;
            head = new FilterNode(head, model, t.filter);
        } else if (isBin(t)) {
            transformNode = head = BinNode.makeFromTransform(head, t, model);
            derivedType = 'number';
        } else if (isTimeUnit(t)) {
            derivedType = 'date';
            const parsedAs = ancestorParse.getWithExplicit(t.field);
            // Create parse node because the input to time unit is always date.
            if (parsedAs.value === undefined) {
                head = new ParseNode(head, {
                    [t.field]: derivedType
                });
                ancestorParse.set(t.field, derivedType, false);
            }
            transformNode = head = TimeUnitNode.makeFromTransform(head, t);
        } else if (isAggregate(t)) {
            transformNode = head = AggregateNode.makeFromTransform(head, t);
            derivedType = 'number';
            if (requiresSelectionId(model)) head = new IdentifierNode(head);
        } else if (isLookup(t)) {
            transformNode = head = LookupNode.make(head, model, t, lookupCounter++);
            derivedType = 'derived';
        } else if (isWindow(t)) {
            transformNode = head = new WindowTransformNode(head, t);
            derivedType = 'number';
        } else if (isJoinAggregate(t)) {
            transformNode = head = new JoinAggregateTransformNode(head, t);
            derivedType = 'number';
        } else if (isStack(t)) {
            transformNode = head = StackNode.makeFromTransform(head, t);
            derivedType = 'derived';
        } else if (isFold(t)) {
            transformNode = head = new FoldTransformNode(head, t);
            derivedType = 'derived';
        } else if (isExtent(t)) {
            transformNode = head = new ExtentTransformNode(head, t);
            derivedType = 'derived';
        } else if (isFlatten(t)) {
            transformNode = head = new FlattenTransformNode(head, t);
            derivedType = 'derived';
        } else if (isPivot(t)) {
            transformNode = head = new PivotTransformNode(head, t);
            derivedType = 'derived';
        } else if (isSample(t)) head = new SampleTransformNode(head, t);
        else if (isImpute(t)) {
            transformNode = head = ImputeNode.makeFromTransform(head, t);
            derivedType = 'derived';
        } else if (isDensity(t)) {
            transformNode = head = new DensityTransformNode(head, t);
            derivedType = 'derived';
        } else if (isQuantile(t)) {
            transformNode = head = new QuantileTransformNode(head, t);
            derivedType = 'derived';
        } else if (isRegression(t)) {
            transformNode = head = new RegressionTransformNode(head, t);
            derivedType = 'derived';
        } else if (isLoess(t)) {
            transformNode = head = new LoessTransformNode(head, t);
            derivedType = 'derived';
        } else {
            warn(invalidTransformIgnored(t));
            continue;
        }
        if (transformNode && derivedType !== undefined) for (const field of transformNode.producedFields() ?? [])ancestorParse.set(field, derivedType, false);
    }
    return head;
}
/*
Description of the dataflow (http://asciiflow.com/):
     +--------+
     | Source |
     +---+----+
         |
         v
     FormatParse
     (explicit)
         |
         v
     Transforms
(Filter, Calculate, Binning, TimeUnit, Aggregate, Window, ...)
         |
         v
     FormatParse
     (implicit)
         |
         v
 Binning (in `encoding`)
         |
         v
 Timeunit (in `encoding`)
         |
         v
Formula From Sort Array
         |
         v
      +--+--+
      | Raw |
      +-----+
         |
         v
  Aggregate (in `encoding`)
         |
         v
  Stack (in `encoding`)
         |
         v
+- - - - - - - - - - -+
|   PreFilterInvalid  | - - - -> scale domains
|(when scales need it)|
+- - - - - - - - - - -+
         |
         v
  Invalid Filter (if the main data source needs it)
         |
         v
   +----------+
   |   Main   | - - - -> scale domains
   +----------+
         |
         v
+- - - - - - - - - - -+
|   PostFilterInvalid | - - - -> scale domains
|(when scales need it)|
+- - - - - - - - - - -+
         |
         v
     +-------+
     | Facet |----> "column", "column-layout", and "row"
     +-------+
         |
         v
  ...Child data...
*/ function parseData(model) {
    let head = parseRoot(model, model.component.data.sources);
    const { outputNodes, outputNodeRefCounts } = model.component.data;
    const data = model.data;
    const newData = data && (isGenerator(data) || isUrlData(data) || isInlineData(data));
    const ancestorParse = !newData && model.parent ? model.parent.component.data.ancestorParse.clone() : new AncestorParse();
    if (isGenerator(data)) {
        // insert generator transform
        if (isSequenceGenerator(data)) head = new SequenceNode(head, data.sequence);
        else if (isGraticuleGenerator(data)) head = new GraticuleNode(head, data.graticule);
        // no parsing necessary for generator
        ancestorParse.parseNothing = true;
    } else if (data?.format?.parse === null) // format.parse: null means disable parsing
    ancestorParse.parseNothing = true;
    head = ParseNode.makeExplicit(head, model, ancestorParse) ?? head;
    // Default discrete selections require an identifer transform to
    // uniquely identify data points. Add this transform at the head of
    // the pipeline such that the identifier field is available for all
    // subsequent datasets. During optimization, we will remove this
    // transform if it proves to be unnecessary. Additional identifier
    // transforms will be necessary when new tuples are constructed
    // (e.g., post-aggregation).
    head = new IdentifierNode(head);
    // HACK: This is equivalent for merging bin extent for union scale.
    // FIXME(https://github.com/vega/vega-lite/issues/2270): Correctly merge extent / bin node for shared bin scale
    const parentIsLayer = model.parent && isLayerModel(model.parent);
    if (isUnitModel(model) || isFacetModel(model)) {
        if (parentIsLayer) head = BinNode.makeFromEncoding(head, model) ?? head;
    }
    if (model.transforms.length > 0) head = parseTransformArray(head, model, ancestorParse);
    // create parse nodes for fields that need to be parsed (or flattened) implicitly
    const implicitSelection = getImplicitFromSelection(model);
    const implicitEncoding = getImplicitFromEncoding(model);
    head = ParseNode.makeWithAncestors(head, {}, {
        ...implicitSelection,
        ...implicitEncoding
    }, ancestorParse) ?? head;
    if (isUnitModel(model)) {
        head = GeoJSONNode.parseAll(head, model);
        head = GeoPointNode.parseAll(head, model);
    }
    if (isUnitModel(model) || isFacetModel(model)) {
        if (!parentIsLayer) head = BinNode.makeFromEncoding(head, model) ?? head;
        head = TimeUnitNode.makeFromEncoding(head, model) ?? head;
        head = CalculateNode.parseAllForSortIndex(head, model);
    }
    // add an output node pre aggregation
    const raw = head = makeOutputNode(DataSourceType.Raw, model, head);
    if (isUnitModel(model)) {
        const agg = AggregateNode.makeFromEncoding(head, model);
        if (agg) {
            head = agg;
            if (requiresSelectionId(model)) head = new IdentifierNode(head);
        }
        head = ImputeNode.makeFromEncoding(head, model) ?? head;
        head = StackNode.makeFromEncoding(head, model) ?? head;
    }
    let preFilterInvalid;
    let dataSourcesForHandlingInvalidValues;
    if (isUnitModel(model)) {
        const { markDef, mark, config } = model;
        const invalid = getMarkPropOrConfig('invalid', markDef, config);
        const { marks, scales } = dataSourcesForHandlingInvalidValues = getDataSourcesForHandlingInvalidValues({
            invalid,
            isPath: isPathMark(mark)
        });
        if (marks !== scales && scales === 'include-invalid-values') // Create a seperate preFilterInvalid dataSource if scales need pre-filter data but marks needs post-filter.
        preFilterInvalid = head = makeOutputNode(DataSourceType.PreFilterInvalid, model, head);
        if (marks === 'exclude-invalid-values') head = FilterInvalidNode.make(head, model, dataSourcesForHandlingInvalidValues) ?? head;
    }
    // output "main" node for marks
    const main = head = makeOutputNode(DataSourceType.Main, model, head);
    let postFilterInvalid;
    if (isUnitModel(model) && dataSourcesForHandlingInvalidValues) {
        const { marks, scales } = dataSourcesForHandlingInvalidValues;
        if (marks === 'include-invalid-values' && scales === 'exclude-invalid-values') {
            // Create a seperate postFilterInvalid dataSource if scales need post-filter data but marks needs pre-filter.
            head = FilterInvalidNode.make(head, model, dataSourcesForHandlingInvalidValues) ?? head;
            postFilterInvalid = head = makeOutputNode(DataSourceType.PostFilterInvalid, model, head);
        }
    }
    if (isUnitModel(model)) materializeSelections(model, main);
    // add facet marker
    let facetRoot = null;
    if (isFacetModel(model)) {
        const facetName = model.getName('facet');
        // Derive new aggregate for facet's sort field
        // augment data source with new fields for crossed facet
        head = makeJoinAggregateFromFacet(head, model.facet) ?? head;
        facetRoot = new FacetNode(head, model, facetName, main.getSource());
        outputNodes[facetName] = facetRoot;
    }
    return {
        ...model.component.data,
        outputNodes,
        outputNodeRefCounts,
        raw,
        main,
        facetRoot,
        ancestorParse,
        preFilterInvalid,
        postFilterInvalid
    };
}
function makeOutputNode(dataSourceType, model, head) {
    const { outputNodes, outputNodeRefCounts } = model.component.data;
    const name = model.getDataName(dataSourceType);
    const node = new OutputNode(head, name, dataSourceType, outputNodeRefCounts);
    outputNodes[name] = node;
    return node;
}
class ConcatModel extends Model {
    children;
    constructor(spec, parent, parentGivenName, config){
        super(spec, 'concat', parent, parentGivenName, config, spec.resolve);
        if (spec.resolve?.axis?.x === 'shared' || spec.resolve?.axis?.y === 'shared') warn(CONCAT_CANNOT_SHARE_AXIS);
        this.children = this.getChildren(spec).map((child, i)=>{
            return buildModel(child, this, this.getName(`concat_${i}`), undefined, config);
        });
    }
    parseData() {
        this.component.data = parseData(this);
        for (const child of this.children)child.parseData();
    }
    parseSelections() {
        // Merge selections up the hierarchy so that they may be referenced
        // across unit specs. Persist their definitions within each child
        // to assemble signals which remain within output Vega unit groups.
        this.component.selection = {};
        for (const child of this.children){
            child.parseSelections();
            for (const key of keys(child.component.selection))this.component.selection[key] = child.component.selection[key];
        }
        if (vals(this.component.selection).some((selCmpt)=>isTimerSelection(selCmpt))) error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
    }
    parseMarkGroup() {
        for (const child of this.children)child.parseMarkGroup();
    }
    parseAxesAndHeaders() {
        for (const child of this.children)child.parseAxesAndHeaders();
    // TODO(#2415): support shared axes
    }
    getChildren(spec) {
        if (isVConcatSpec(spec)) return spec.vconcat;
        else if (isHConcatSpec(spec)) return spec.hconcat;
        return spec.concat;
    }
    parseLayoutSize() {
        parseConcatLayoutSize(this);
    }
    parseAxisGroup() {
        return null;
    }
    assembleSelectionTopLevelSignals(signals) {
        return this.children.reduce((sg, child)=>child.assembleSelectionTopLevelSignals(sg), signals);
    }
    assembleSignals() {
        this.children.forEach((child)=>child.assembleSignals());
        return [];
    }
    assembleLayoutSignals() {
        const layoutSignals = assembleLayoutSignals(this);
        for (const child of this.children)layoutSignals.push(...child.assembleLayoutSignals());
        return layoutSignals;
    }
    assembleSelectionData(data) {
        return this.children.reduce((db, child)=>child.assembleSelectionData(db), data);
    }
    assembleMarks() {
        // only children have marks
        return this.children.map((child)=>{
            const title = child.assembleTitle();
            const style = child.assembleGroupStyle();
            const encodeEntry = child.assembleGroupEncodeEntry(false);
            return {
                type: 'group',
                name: child.getName('group'),
                ...title ? {
                    title
                } : {},
                ...style ? {
                    style
                } : {},
                ...encodeEntry ? {
                    encode: {
                        update: encodeEntry
                    }
                } : {},
                ...child.assembleGroup()
            };
        });
    }
    assembleGroupStyle() {
        return undefined;
    }
    assembleDefaultLayout() {
        const columns = this.layout.columns;
        return {
            ...columns != null ? {
                columns
            } : {},
            bounds: 'full',
            // Use align each so it can work with multiple plots with different size
            align: 'each'
        };
    }
}
function isFalseOrNull(v) {
    return v === false || v === null;
}
const AXIS_COMPONENT_PROPERTIES_INDEX = {
    disable: 1,
    gridScale: 1,
    scale: 1,
    ...COMMON_AXIS_PROPERTIES_INDEX,
    labelExpr: 1,
    encode: 1
};
const AXIS_COMPONENT_PROPERTIES = keys(AXIS_COMPONENT_PROPERTIES_INDEX);
class AxisComponent extends Split {
    explicit;
    implicit;
    mainExtracted;
    constructor(explicit = {}, implicit = {}, mainExtracted = false){
        super();
        this.explicit = explicit;
        this.implicit = implicit;
        this.mainExtracted = mainExtracted;
    }
    clone() {
        return new AxisComponent(duplicate(this.explicit), duplicate(this.implicit), this.mainExtracted);
    }
    hasAxisPart(part) {
        // FIXME(https://github.com/vega/vega-lite/issues/2552) this method can be wrong if users use a Vega theme.
        if (part === 'axis') // always has the axis container part
        return true;
        if (part === 'grid' || part === 'title') return !!this.get(part);
        // Other parts are enabled by default, so they should not be false or null.
        return !isFalseOrNull(this.get(part));
    }
    hasOrientSignalRef() {
        return isSignalRef(this.explicit.orient);
    }
}
function labels(model, channel, specifiedLabelsSpec) {
    const { encoding, config } = model;
    const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]) ?? getFieldOrDatumDef(encoding[getSecondaryRangeChannel(channel)]);
    const axis = model.axis(channel) || {};
    const { format, formatType } = axis;
    if (isCustomFormatType(formatType)) return {
        text: formatCustomType({
            fieldOrDatumDef,
            field: 'datum.value',
            format,
            formatType,
            config
        }),
        ...specifiedLabelsSpec
    };
    else if (format === undefined && formatType === undefined && config.customFormatTypes) {
        if (channelDefType(fieldOrDatumDef) === 'quantitative') {
            if (isPositionFieldOrDatumDef(fieldOrDatumDef) && fieldOrDatumDef.stack === 'normalize' && config.normalizedNumberFormatType) return {
                text: formatCustomType({
                    fieldOrDatumDef,
                    field: 'datum.value',
                    format: config.normalizedNumberFormat,
                    formatType: config.normalizedNumberFormatType,
                    config
                }),
                ...specifiedLabelsSpec
            };
            else if (config.numberFormatType) return {
                text: formatCustomType({
                    fieldOrDatumDef,
                    field: 'datum.value',
                    format: config.numberFormat,
                    formatType: config.numberFormatType,
                    config
                }),
                ...specifiedLabelsSpec
            };
        }
        if (channelDefType(fieldOrDatumDef) === 'temporal' && config.timeFormatType && isFieldDef(fieldOrDatumDef) && !fieldOrDatumDef.timeUnit) return {
            text: formatCustomType({
                fieldOrDatumDef,
                field: 'datum.value',
                format: config.timeFormat,
                formatType: config.timeFormatType,
                config
            }),
            ...specifiedLabelsSpec
        };
    }
    return specifiedLabelsSpec;
}
function parseUnitAxes(model) {
    return POSITION_SCALE_CHANNELS.reduce((axis, channel)=>{
        if (model.component.scales[channel]) axis[channel] = [
            parseAxis(channel, model)
        ];
        return axis;
    }, {});
}
const OPPOSITE_ORIENT = {
    bottom: 'top',
    top: 'bottom',
    left: 'right',
    right: 'left'
};
function parseLayerAxes(model) {
    const { axes, resolve } = model.component;
    const axisCount = {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
    };
    for (const child of model.children){
        child.parseAxesAndHeaders();
        for (const channel of keys(child.component.axes)){
            resolve.axis[channel] = parseGuideResolve(model.component.resolve, channel);
            if (resolve.axis[channel] === 'shared') {
                // If the resolve says shared (and has not been overridden)
                // We will try to merge and see if there is a conflict
                axes[channel] = mergeAxisComponents(axes[channel], child.component.axes[channel]);
                if (!axes[channel]) {
                    // If merge returns nothing, there is a conflict so we cannot make the axis shared.
                    // Thus, mark axis as independent and remove the axis component.
                    resolve.axis[channel] = 'independent';
                    delete axes[channel];
                }
            }
        }
    }
    // Move axes to layer's axis component and merge shared axes
    for (const channel of POSITION_SCALE_CHANNELS){
        for (const child of model.children){
            if (!child.component.axes[channel]) continue;
            if (resolve.axis[channel] === 'independent') {
                // If axes are independent, concat the axisComponent array.
                axes[channel] = (axes[channel] ?? []).concat(child.component.axes[channel]);
                // Automatically adjust orient
                for (const axisComponent of child.component.axes[channel]){
                    const { value: orient, explicit } = axisComponent.getWithExplicit('orient');
                    if (isSignalRef(orient)) continue;
                    if (axisCount[orient] > 0 && !explicit) {
                        // Change axis orient if the number do not match
                        const oppositeOrient = OPPOSITE_ORIENT[orient];
                        if (axisCount[orient] > axisCount[oppositeOrient]) axisComponent.set('orient', oppositeOrient, false);
                    }
                    axisCount[orient]++;
                // TODO(https://github.com/vega/vega-lite/issues/2634): automatically add extra offset?
                }
            }
            // After merging, make sure to remove axes from child
            delete child.component.axes[channel];
        }
        // Show gridlines for first axis only for dual-axis chart
        if (resolve.axis[channel] === 'independent' && axes[channel] && axes[channel].length > 1) {
            for (const [index, axisCmpt] of (axes[channel] || []).entries())if (index > 0 && !!axisCmpt.get('grid') && !axisCmpt.explicit.grid) axisCmpt.implicit.grid = false;
        }
    }
}
function mergeAxisComponents(mergedAxisCmpts, childAxisCmpts) {
    if (mergedAxisCmpts) {
        // FIXME: this is a bit wrong once we support multiple axes
        if (mergedAxisCmpts.length !== childAxisCmpts.length) return undefined; // Cannot merge axis component with different number of axes.
        const length = mergedAxisCmpts.length;
        for(let i = 0; i < length; i++){
            const merged = mergedAxisCmpts[i];
            const child = childAxisCmpts[i];
            if (!!merged !== !!child) return undefined;
            else if (merged && child) {
                const mergedOrient = merged.getWithExplicit('orient');
                const childOrient = child.getWithExplicit('orient');
                if (mergedOrient.explicit && childOrient.explicit && mergedOrient.value !== childOrient.value) // TODO: throw warning if resolve is explicit (We don't have info about explicit/implicit resolve yet.)
                // Cannot merge due to inconsistent orient
                return undefined;
                else mergedAxisCmpts[i] = mergeAxisComponent(merged, child);
            }
        }
    } else // For first one, return a copy of the child
    return childAxisCmpts.map((axisComponent)=>axisComponent.clone());
    return mergedAxisCmpts;
}
function mergeAxisComponent(merged, child) {
    for (const prop of AXIS_COMPONENT_PROPERTIES){
        const mergedValueWithExplicit = mergeValuesWithExplicit(merged.getWithExplicit(prop), child.getWithExplicit(prop), prop, 'axis', // Tie breaker function
        (v1, v2)=>{
            switch(prop){
                case 'title':
                    return mergeTitleComponent(v1, v2);
                case 'gridScale':
                    return {
                        explicit: v1.explicit,
                        value: getFirstDefined(v1.value, v2.value)
                    };
            }
            return defaultTieBreaker(v1, v2, prop, 'axis');
        });
        merged.setWithExplicit(prop, mergedValueWithExplicit);
    }
    return merged;
}
function isExplicit(value, property, axis, model, channel) {
    if (property === 'disable') return axis !== undefined; // if axis is specified or null/false, then its enable/disable state is explicit
    axis = axis || {};
    switch(property){
        case 'titleAngle':
        case 'labelAngle':
            return value === (isSignalRef(axis.labelAngle) ? axis.labelAngle : normalizeAngle(axis.labelAngle));
        case 'values':
            return !!axis.values;
        // specified axis.values is already respected, but may get transformed.
        case 'encode':
            // both VL axis.encoding and axis.labelAngle affect VG axis.encode
            return !!axis.encoding || !!axis.labelAngle;
        case 'title':
            // title can be explicit if fieldDef.title is set
            if (value === getFieldDefTitle(model, channel)) return true;
    }
    // Otherwise, things are explicit if the returned value matches the specified property
    return value === axis[property];
}
/**
 * Properties to always include values from config
 */ const propsToAlwaysIncludeConfig = new Set([
    'grid',
    'translate',
    // the rest are not axis configs in Vega, but are in VL, so we need to set too.
    'format',
    'formatType',
    'orient',
    'labelExpr',
    'tickCount',
    'position',
    'tickMinStep'
]);
function parseAxis(channel, model) {
    let axis = model.axis(channel);
    const axisComponent = new AxisComponent();
    const fieldOrDatumDef = getFieldOrDatumDef(model.encoding[channel]);
    const { mark, config } = model;
    const orient = axis?.orient || config[channel === 'x' ? 'axisX' : 'axisY']?.orient || config.axis?.orient || defaultOrient(channel);
    const scaleType = model.getScaleComponent(channel).get('type');
    const axisConfigs = getAxisConfigs(channel, scaleType, orient, model.config);
    const disable = axis !== undefined ? !axis : getAxisConfig('disable', config.style, axis?.style, axisConfigs).configValue;
    axisComponent.set('disable', disable, axis !== undefined);
    if (disable) return axisComponent;
    axis = axis || {};
    const labelAngle = getLabelAngle(fieldOrDatumDef, axis, channel, config.style, axisConfigs);
    const formatType = guideFormatType(axis.formatType, fieldOrDatumDef, scaleType);
    const format = guideFormat(fieldOrDatumDef, fieldOrDatumDef.type, axis.format, axis.formatType, config, true);
    const ruleParams = {
        fieldOrDatumDef,
        axis,
        channel,
        model,
        scaleType,
        orient,
        labelAngle,
        format,
        formatType,
        mark,
        config
    };
    // 1.2. Add properties
    for (const property of AXIS_COMPONENT_PROPERTIES){
        const value = property in axisRules ? axisRules[property](ruleParams) : isAxisProperty(property) ? axis[property] : undefined;
        const hasValue = value !== undefined;
        const explicit = isExplicit(value, property, axis, model, channel);
        if (hasValue && explicit) axisComponent.set(property, value, explicit);
        else {
            const { configValue, configFrom } = isAxisProperty(property) && property !== 'values' ? getAxisConfig(property, config.style, axis.style, axisConfigs) : {};
            const hasConfigValue = configValue !== undefined;
            if (hasValue && !hasConfigValue) // only set property if it is explicitly set or has no config value (otherwise we will accidentally override config)
            axisComponent.set(property, value, explicit);
            else if (// Cases need implicit values
            // 1. Axis config that aren't available in Vega
            !(configFrom === 'vgAxisConfig') || // 2. Certain properties are always included (see `propsToAlwaysIncludeConfig`'s declaration for more details)
            propsToAlwaysIncludeConfig.has(property) && hasConfigValue || // 3. Conditional axis values and signals
            isConditionalAxisValue(configValue) || isSignalRef(configValue)) // If a config is specified and is conditional, copy conditional value from axis config
            axisComponent.set(property, configValue, false);
        }
    }
    // 2) Add guide encode definition groups
    const axisEncoding = axis.encoding ?? {};
    const axisEncode = AXIS_PARTS.reduce((e, part)=>{
        if (!axisComponent.hasAxisPart(part)) // No need to create encode for a disabled part.
        return e;
        const axisEncodingPart = guideEncodeEntry(axisEncoding[part] ?? {}, model);
        const value = part === 'labels' ? labels(model, channel, axisEncodingPart) : axisEncodingPart;
        if (value !== undefined && !isEmpty(value)) e[part] = {
            update: value
        };
        return e;
    }, {});
    // FIXME: By having encode as one property, we won't have fine grained encode merging.
    if (!isEmpty(axisEncode)) axisComponent.set('encode', axisEncode, !!axis.encoding || axis.labelAngle !== undefined);
    return axisComponent;
}
function initLayoutSize({ encoding, size }) {
    for (const channel of POSITION_SCALE_CHANNELS){
        const sizeType = getSizeChannel(channel);
        if (isStep(size[sizeType])) {
            if (isContinuousFieldOrDatumDef(encoding[channel])) {
                delete size[sizeType];
                warn(stepDropped(sizeType));
            }
        }
    }
    return size;
}
const arc = {
    vgMark: 'arc',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'ignore'
            }),
            ...pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ...pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            // arcs are rectangles in polar coordinates
            ...rectPosition(model, 'radius'),
            ...rectPosition(model, 'theta')
        };
    }
};
const area = {
    vgMark: 'area',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'include',
                size: 'ignore',
                theta: 'ignore'
            }),
            ...pointOrRangePosition('x', model, {
                defaultPos: 'zeroOrMin',
                defaultPos2: 'zeroOrMin',
                range: model.markDef.orient === 'horizontal'
            }),
            ...pointOrRangePosition('y', model, {
                defaultPos: 'zeroOrMin',
                defaultPos2: 'zeroOrMin',
                range: model.markDef.orient === 'vertical'
            }),
            ...defined(model)
        };
    }
};
const bar = {
    vgMark: 'rect',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ...rectPosition(model, 'x'),
            ...rectPosition(model, 'y')
        };
    }
};
const geoshape = {
    vgMark: 'shape',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'ignore'
            })
        };
    },
    postEncodingTransform: (model)=>{
        const { encoding } = model;
        const shapeDef = encoding.shape;
        const transform = {
            type: 'geoshape',
            projection: model.projectionName(),
            // as: 'shape',
            ...shapeDef && isFieldDef(shapeDef) && shapeDef.type === GEOJSON ? {
                field: vgField(shapeDef, {
                    expr: 'datum'
                })
            } : {}
        };
        return [
            transform
        ];
    }
};
const image = {
    vgMark: 'image',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'ignore',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ...rectPosition(model, 'x'),
            ...rectPosition(model, 'y'),
            ...text$1(model, 'url')
        };
    }
};
const line = {
    vgMark: 'line',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'ignore'
            }),
            ...pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ...pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            ...nonPosition('size', model, {
                vgChannel: 'strokeWidth'
            }),
            ...defined(model)
        };
    }
};
const trail = {
    vgMark: 'trail',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                size: 'include',
                orient: 'ignore',
                theta: 'ignore'
            }),
            ...pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ...pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            ...nonPosition('size', model),
            ...defined(model)
        };
    }
};
function encodeEntry(model, fixedShape) {
    const { config } = model;
    return {
        ...baseEncodeEntry(model, {
            align: 'ignore',
            baseline: 'ignore',
            color: 'include',
            size: 'include',
            orient: 'ignore',
            theta: 'ignore'
        }),
        ...pointPosition('x', model, {
            defaultPos: 'mid'
        }),
        ...pointPosition('y', model, {
            defaultPos: 'mid'
        }),
        ...nonPosition('size', model),
        ...nonPosition('angle', model),
        ...shapeMixins(model, config, fixedShape)
    };
}
function shapeMixins(model, config, fixedShape) {
    if (fixedShape) return {
        shape: {
            value: fixedShape
        }
    };
    return nonPosition('shape', model);
}
const point = {
    vgMark: 'symbol',
    encodeEntry: (model)=>{
        return encodeEntry(model);
    }
};
const circle = {
    vgMark: 'symbol',
    encodeEntry: (model)=>{
        return encodeEntry(model, 'circle');
    }
};
const square = {
    vgMark: 'symbol',
    encodeEntry: (model)=>{
        return encodeEntry(model, 'square');
    }
};
const rect = {
    vgMark: 'rect',
    encodeEntry: (model)=>{
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ...rectPosition(model, 'x'),
            ...rectPosition(model, 'y')
        };
    }
};
const rule = {
    vgMark: 'rule',
    encodeEntry: (model)=>{
        const { markDef } = model;
        const orient = markDef.orient;
        if (!model.encoding.x && !model.encoding.y && !model.encoding.latitude && !model.encoding.longitude) // Show nothing if we have none of x, y, lat, and long.
        return {};
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ...pointOrRangePosition('x', model, {
                defaultPos: orient === 'horizontal' ? 'zeroOrMax' : 'mid',
                defaultPos2: 'zeroOrMin',
                range: orient !== 'vertical'
            }),
            ...pointOrRangePosition('y', model, {
                defaultPos: orient === 'vertical' ? 'zeroOrMax' : 'mid',
                defaultPos2: 'zeroOrMin',
                range: orient !== 'horizontal'
            }),
            ...nonPosition('size', model, {
                vgChannel: 'strokeWidth'
            })
        };
    }
};
const text = {
    vgMark: 'text',
    encodeEntry: (model)=>{
        const { config, encoding } = model;
        return {
            ...baseEncodeEntry(model, {
                align: 'include',
                baseline: 'include',
                color: 'include',
                size: 'ignore',
                orient: 'ignore',
                theta: 'include'
            }),
            ...pointPosition('x', model, {
                defaultPos: 'mid'
            }),
            ...pointPosition('y', model, {
                defaultPos: 'mid'
            }),
            ...text$1(model),
            ...nonPosition('size', model, {
                vgChannel: 'fontSize'
            }),
            ...nonPosition('angle', model),
            ...valueIfDefined('align', align(model.markDef, encoding, config)),
            ...valueIfDefined('baseline', baseline(model.markDef, encoding, config)),
            ...pointPosition('radius', model, {
                defaultPos: null
            }),
            ...pointPosition('theta', model, {
                defaultPos: null
            })
        };
    }
};
function align(markDef, encoding, config) {
    const a = getMarkPropOrConfig('align', markDef, config);
    if (a === undefined) return 'center';
    // If there is a config, Vega-parser will process this already.
    return undefined;
}
function baseline(markDef, encoding, config) {
    const b = getMarkPropOrConfig('baseline', markDef, config);
    if (b === undefined) return 'middle';
    // If there is a config, Vega-parser will process this already.
    return undefined;
}
const tick = {
    vgMark: 'rect',
    encodeEntry: (model)=>{
        const { config, markDef } = model;
        const orient = markDef.orient;
        const vgSizeAxisChannel = orient === 'horizontal' ? 'x' : 'y';
        const vgThicknessAxisChannel = orient === 'horizontal' ? 'y' : 'x';
        const vgThicknessChannel = orient === 'horizontal' ? 'height' : 'width';
        return {
            ...baseEncodeEntry(model, {
                align: 'ignore',
                baseline: 'ignore',
                color: 'include',
                orient: 'ignore',
                size: 'ignore',
                theta: 'ignore'
            }),
            ...rectPosition(model, vgSizeAxisChannel),
            ...pointPosition(vgThicknessAxisChannel, model, {
                defaultPos: 'mid',
                vgChannel: vgThicknessAxisChannel === 'y' ? 'yc' : 'xc'
            }),
            [vgThicknessChannel]: signalOrValueRef(getMarkPropOrConfig('thickness', markDef, config))
        };
    }
};
const markCompiler = {
    arc,
    area,
    bar,
    circle,
    geoshape,
    image,
    line,
    point,
    rect,
    rule,
    square,
    text,
    tick,
    trail
};
function parseMarkGroups(model) {
    if (contains([
        LINE,
        AREA,
        TRAIL
    ], model.mark)) {
        const details = pathGroupingFields(model.mark, model.encoding);
        if (details.length > 0) return getPathGroups(model, details);
    // otherwise use standard mark groups
    } else if (model.mark === BAR) {
        const hasCornerRadius = VG_CORNERRADIUS_CHANNELS.some((prop)=>getMarkPropOrConfig(prop, model.markDef, model.config));
        if (model.stack && !model.fieldDef('size') && hasCornerRadius) return getGroupsForStackedBarWithCornerRadius(model);
    }
    return getMarkGroup(model);
}
const FACETED_PATH_PREFIX = 'faceted_path_';
function getPathGroups(model, details) {
    // TODO: for non-stacked plot, map order to zindex. (Maybe rename order for layer to zindex?)
    return [
        {
            name: model.getName('pathgroup'),
            type: 'group',
            from: {
                facet: {
                    name: FACETED_PATH_PREFIX + model.requestDataName(DataSourceType.Main),
                    data: model.requestDataName(DataSourceType.Main),
                    groupby: details
                }
            },
            encode: {
                update: {
                    width: {
                        field: {
                            group: 'width'
                        }
                    },
                    height: {
                        field: {
                            group: 'height'
                        }
                    }
                }
            },
            // With subfacet for line/area group, need to use faceted data from above.
            marks: getMarkGroup(model, {
                fromPrefix: FACETED_PATH_PREFIX
            })
        }
    ];
}
const STACK_GROUP_PREFIX = 'stack_group_';
/**
 * We need to put stacked bars into groups in order to enable cornerRadius for stacks.
 * If stack is used and the model doesn't have size encoding, we put the mark into groups,
 * and apply cornerRadius properties at the group.
 */ function getGroupsForStackedBarWithCornerRadius(model) {
    // Generate the mark
    const [mark] = getMarkGroup(model, {
        fromPrefix: STACK_GROUP_PREFIX
    });
    // Get the scale for the stacked field
    const fieldScale = model.scaleName(model.stack.fieldChannel);
    const stackField = (opt = {})=>model.vgField(model.stack.fieldChannel, opt);
    // Find the min/max of the pixel value on the stacked direction
    const stackFieldGroup = (func, expr)=>{
        const vgFieldMinMax = [
            stackField({
                prefix: 'min',
                suffix: 'start',
                expr
            }),
            stackField({
                prefix: 'max',
                suffix: 'start',
                expr
            }),
            stackField({
                prefix: 'min',
                suffix: 'end',
                expr
            }),
            stackField({
                prefix: 'max',
                suffix: 'end',
                expr
            })
        ];
        return `${func}(${vgFieldMinMax.map((field)=>`scale('${fieldScale}',${field})`).join(',')})`;
    };
    let groupUpdate;
    let innerGroupUpdate;
    // Build the encoding for group and an inner group
    if (model.stack.fieldChannel === 'x') {
        // Move cornerRadius, y/yc/y2/height properties to group
        // Group x/x2 should be the min/max of the marks within
        groupUpdate = {
            ...pick(mark.encode.update, [
                'y',
                'yc',
                'y2',
                'height',
                ...VG_CORNERRADIUS_CHANNELS
            ]),
            x: {
                signal: stackFieldGroup('min', 'datum')
            },
            x2: {
                signal: stackFieldGroup('max', 'datum')
            },
            clip: {
                value: true
            }
        };
        // Inner group should revert the x translation, and pass height through
        innerGroupUpdate = {
            x: {
                field: {
                    group: 'x'
                },
                mult: -1
            },
            height: {
                field: {
                    group: 'height'
                }
            }
        };
        // The marks should use the same height as group, without y/yc/y2 properties (because it's already done by group)
        // This is why size encoding is not supported yet
        mark.encode.update = {
            ...omit(mark.encode.update, [
                'y',
                'yc',
                'y2'
            ]),
            height: {
                field: {
                    group: 'height'
                }
            }
        };
    } else {
        groupUpdate = {
            ...pick(mark.encode.update, [
                'x',
                'xc',
                'x2',
                'width'
            ]),
            y: {
                signal: stackFieldGroup('min', 'datum')
            },
            y2: {
                signal: stackFieldGroup('max', 'datum')
            },
            clip: {
                value: true
            }
        };
        innerGroupUpdate = {
            y: {
                field: {
                    group: 'y'
                },
                mult: -1
            },
            width: {
                field: {
                    group: 'width'
                }
            }
        };
        mark.encode.update = {
            ...omit(mark.encode.update, [
                'x',
                'xc',
                'x2'
            ]),
            width: {
                field: {
                    group: 'width'
                }
            }
        };
    }
    // Deal with cornerRadius properties
    for (const key of VG_CORNERRADIUS_CHANNELS){
        const configValue = getMarkConfig(key, model.markDef, model.config);
        // Move from mark to group
        if (mark.encode.update[key]) {
            groupUpdate[key] = mark.encode.update[key];
            delete mark.encode.update[key];
        } else if (configValue) groupUpdate[key] = signalOrValueRef(configValue);
        // Overwrite any cornerRadius on mark set by config --- they are already moved to the group
        if (configValue) mark.encode.update[key] = {
            value: 0
        };
    }
    const groupby = [];
    if (model.stack.groupbyChannels?.length > 0) for (const groupbyChannel of model.stack.groupbyChannels){
        // For bin and time unit, we have to add bin/timeunit -end channels.
        const groupByField = model.fieldDef(groupbyChannel);
        const field = vgField(groupByField);
        if (field) groupby.push(field);
        if (groupByField?.bin || groupByField?.timeUnit) groupby.push(vgField(groupByField, {
            binSuffix: 'end'
        }));
    }
    const strokeProperties = [
        'stroke',
        'strokeWidth',
        'strokeJoin',
        'strokeCap',
        'strokeDash',
        'strokeDashOffset',
        'strokeMiterLimit',
        'strokeOpacity'
    ];
    // Generate stroke properties for the group
    groupUpdate = strokeProperties.reduce((encode, prop)=>{
        if (mark.encode.update[prop]) return {
            ...encode,
            [prop]: mark.encode.update[prop]
        };
        else {
            const configValue = getMarkConfig(prop, model.markDef, model.config);
            if (configValue !== undefined) return {
                ...encode,
                [prop]: signalOrValueRef(configValue)
            };
            else return encode;
        }
    }, groupUpdate);
    // Apply strokeForeground and strokeOffset if stroke is used
    if (groupUpdate.stroke) {
        groupUpdate.strokeForeground = {
            value: true
        };
        groupUpdate.strokeOffset = {
            value: 0
        };
    }
    return [
        {
            type: 'group',
            from: {
                facet: {
                    data: model.requestDataName(DataSourceType.Main),
                    name: STACK_GROUP_PREFIX + model.requestDataName(DataSourceType.Main),
                    groupby,
                    aggregate: {
                        fields: [
                            stackField({
                                suffix: 'start'
                            }),
                            stackField({
                                suffix: 'start'
                            }),
                            stackField({
                                suffix: 'end'
                            }),
                            stackField({
                                suffix: 'end'
                            })
                        ],
                        ops: [
                            'min',
                            'max',
                            'min',
                            'max'
                        ]
                    }
                }
            },
            encode: {
                update: groupUpdate
            },
            marks: [
                {
                    type: 'group',
                    encode: {
                        update: innerGroupUpdate
                    },
                    marks: [
                        mark
                    ]
                }
            ]
        }
    ];
}
function getSort(model) {
    const { encoding, stack, mark, markDef, config } = model;
    const order = encoding.order;
    if (!(0, _vegaUtil.isArray)(order) && isValueDef(order) && isNullOrFalse(order.value) || !order && isNullOrFalse(getMarkPropOrConfig('order', markDef, config))) return undefined;
    else if (((0, _vegaUtil.isArray)(order) || isFieldDef(order)) && !stack) // Sort by the order field if it is specified and the field is not stacked. (For stacked field, order specify stack order.)
    return sortParams(order, {
        expr: 'datum'
    });
    else if (isPathMark(mark)) {
        // For both line and area, we sort values based on dimension by default
        const dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
        const dimensionChannelDef = encoding[dimensionChannel];
        if (isFieldDef(dimensionChannelDef)) return {
            field: dimensionChannel
        };
    }
    return undefined;
}
function getMarkGroup(model, opt = {
    fromPrefix: ''
}) {
    const { mark, markDef, encoding, config } = model;
    const clip = getFirstDefined(markDef.clip, scaleClip(model), projectionClip(model));
    const style = getStyles(markDef);
    const key = encoding.key;
    const sort = getSort(model);
    const interactive = interactiveFlag(model);
    const aria = getMarkPropOrConfig('aria', markDef, config);
    const postEncodingTransform = markCompiler[mark].postEncodingTransform ? markCompiler[mark].postEncodingTransform(model) : null;
    return [
        {
            name: model.getName('marks'),
            type: markCompiler[mark].vgMark,
            ...clip ? {
                clip
            } : {},
            ...style ? {
                style
            } : {},
            ...key ? {
                key: key.field
            } : {},
            ...sort ? {
                sort
            } : {},
            ...interactive ? interactive : {},
            ...aria === false ? {
                aria
            } : {},
            from: {
                data: opt.fromPrefix + model.requestDataName(DataSourceType.Main)
            },
            encode: {
                update: markCompiler[mark].encodeEntry(model)
            },
            ...postEncodingTransform ? {
                transform: postEncodingTransform
            } : {}
        }
    ];
}
/**
 * If scales are bound to interval selections, we want to automatically clip
 * marks to account for panning/zooming interactions. We identify bound scales
 * by the selectionExtent property, which gets added during scale parsing.
 */ function scaleClip(model) {
    const xScale = model.getScaleComponent('x');
    const yScale = model.getScaleComponent('y');
    return xScale?.get('selectionExtent') || yScale?.get('selectionExtent') ? true : undefined;
}
/**
 * If we use a custom projection with auto-fitting to the geodata extent,
 * we need to clip to ensure the chart size doesn't explode.
 */ function projectionClip(model) {
    const projection = model.component.projection;
    return projection && !projection.isFit ? true : undefined;
}
/**
 * Only output interactive flags if we have selections defined somewhere in our model hierarchy.
 */ function interactiveFlag(model) {
    if (!model.component.selection) return null;
    const unitCount = keys(model.component.selection).length;
    let parentCount = unitCount;
    let parent = model.parent;
    while(parent && parentCount === 0){
        parentCount = keys(parent.component.selection).length;
        parent = parent.parent;
    }
    return parentCount ? {
        interactive: unitCount > 0 || model.mark === 'geoshape' || !!model.encoding.tooltip || !!model.markDef.tooltip
    } : null;
}
/**
 * Internal model of Vega-Lite specification for the compiler.
 */ class UnitModel extends ModelWithField {
    markDef;
    encoding;
    specifiedScales = {};
    stack;
    specifiedAxes = {};
    specifiedLegends = {};
    specifiedProjection = {};
    selection = [];
    children = [];
    constructor(spec, parent, parentGivenName, parentGivenSize = {}, config){
        super(spec, 'unit', parent, parentGivenName, config, undefined, isFrameMixins(spec) ? spec.view : undefined);
        const markDef = isMarkDef(spec.mark) ? {
            ...spec.mark
        } : {
            type: spec.mark
        };
        const mark = markDef.type;
        // Need to init filled before other mark properties because encoding depends on filled but other mark properties depend on types inside encoding
        if (markDef.filled === undefined) markDef.filled = defaultFilled(markDef, config, {
            graticule: spec.data && isGraticuleGenerator(spec.data)
        });
        const encoding = this.encoding = initEncoding(spec.encoding || {}, mark, markDef.filled, config);
        this.markDef = initMarkdef(markDef, encoding, config);
        this.size = initLayoutSize({
            encoding,
            size: isFrameMixins(spec) ? {
                ...parentGivenSize,
                ...spec.width ? {
                    width: spec.width
                } : {},
                ...spec.height ? {
                    height: spec.height
                } : {}
            } : parentGivenSize
        });
        // calculate stack properties
        this.stack = stack(this.markDef, encoding);
        this.specifiedScales = this.initScales(mark, encoding);
        this.specifiedAxes = this.initAxes(encoding);
        this.specifiedLegends = this.initLegends(encoding);
        this.specifiedProjection = spec.projection;
        // Selections will be initialized upon parse.
        this.selection = (spec.params ?? []).filter((p)=>isSelectionParameter(p));
    }
    get hasProjection() {
        const { encoding } = this;
        const isGeoShapeMark = this.mark === GEOSHAPE;
        const hasGeoPosition = encoding && GEOPOSITION_CHANNELS.some((channel)=>isFieldOrDatumDef(encoding[channel]));
        return isGeoShapeMark || hasGeoPosition;
    }
    /**
     * Return specified Vega-Lite scale domain for a particular channel
     * @param channel
     */ scaleDomain(channel) {
        const scale = this.specifiedScales[channel];
        return scale ? scale.domain : undefined;
    }
    axis(channel) {
        return this.specifiedAxes[channel];
    }
    legend(channel) {
        return this.specifiedLegends[channel];
    }
    initScales(mark, encoding) {
        return SCALE_CHANNELS.reduce((scales, channel)=>{
            const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
            if (fieldOrDatumDef) scales[channel] = this.initScale(fieldOrDatumDef.scale ?? {});
            return scales;
        }, {});
    }
    initScale(scale) {
        const { domain, range } = scale;
        // TODO: we could simplify this function if we had a recursive replace function
        const scaleInternal = replaceExprRef(scale);
        if ((0, _vegaUtil.isArray)(domain)) scaleInternal.domain = domain.map(signalRefOrValue);
        if ((0, _vegaUtil.isArray)(range)) scaleInternal.range = range.map(signalRefOrValue);
        return scaleInternal;
    }
    initAxes(encoding) {
        return POSITION_SCALE_CHANNELS.reduce((_axis, channel)=>{
            // Position Axis
            // TODO: handle ConditionFieldDef
            const channelDef = encoding[channel];
            if (isFieldOrDatumDef(channelDef) || channel === X && isFieldOrDatumDef(encoding.x2) || channel === Y && isFieldOrDatumDef(encoding.y2)) {
                const axisSpec = isFieldOrDatumDef(channelDef) ? channelDef.axis : undefined;
                _axis[channel] = axisSpec ? this.initAxis({
                    ...axisSpec
                }) // convert truthy value to object
                 : axisSpec;
            }
            return _axis;
        }, {});
    }
    initAxis(axis) {
        const props = keys(axis);
        const axisInternal = {};
        for (const prop of props){
            const val = axis[prop];
            axisInternal[prop] = isConditionalAxisValue(val) ? signalOrValueRefWithCondition(val) : signalRefOrValue(val);
        }
        return axisInternal;
    }
    initLegends(encoding) {
        return NONPOSITION_SCALE_CHANNELS.reduce((_legend, channel)=>{
            const fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
            if (fieldOrDatumDef && supportLegend(channel)) {
                const legend = fieldOrDatumDef.legend;
                _legend[channel] = legend ? replaceExprRef(legend) // convert truthy value to object
                 : legend;
            }
            return _legend;
        }, {});
    }
    parseData() {
        this.component.data = parseData(this);
    }
    parseLayoutSize() {
        parseUnitLayoutSize(this);
    }
    parseSelections() {
        this.component.selection = parseUnitSelection(this, this.selection);
    }
    parseMarkGroup() {
        this.component.mark = parseMarkGroups(this);
    }
    parseAxesAndHeaders() {
        this.component.axes = parseUnitAxes(this);
    }
    assembleSelectionTopLevelSignals(signals) {
        return assembleTopLevelSignals(this, signals);
    }
    assembleSignals() {
        return [
            ...assembleAxisSignals(this),
            ...assembleUnitSelectionSignals(this, [])
        ];
    }
    assembleSelectionData(data) {
        return assembleUnitSelectionData(this, data);
    }
    assembleLayout() {
        return null;
    }
    assembleLayoutSignals() {
        return assembleLayoutSignals(this);
    }
    /**
     * Corrects the data references in marks after assemble.
     */ correctDataNames = (mark)=>{
        // for normal data references
        if (mark.from?.data) {
            mark.from.data = this.lookupDataSource(mark.from.data);
            if ('time' in this.encoding) mark.from.data = mark.from.data + CURR;
        }
        // for access to facet data
        if (mark.from?.facet?.data) mark.from.facet.data = this.lookupDataSource(mark.from.facet.data);
        return mark;
    };
    assembleMarks() {
        let marks = this.component.mark ?? [];
        // If this unit is part of a layer, selections should augment
        // all in concert rather than each unit individually. This
        // ensures correct interleaving of clipping and brushed marks.
        if (!this.parent || !isLayerModel(this.parent)) marks = assembleUnitSelectionMarks(this, marks);
        return marks.map(this.correctDataNames);
    }
    assembleGroupStyle() {
        const { style } = this.view || {};
        if (style !== undefined) return style;
        if (this.encoding.x || this.encoding.y) return 'cell';
        else return 'view';
    }
    getMapping() {
        return this.encoding;
    }
    get mark() {
        return this.markDef.type;
    }
    channelHasField(channel) {
        return channelHasField(this.encoding, channel);
    }
    fieldDef(channel) {
        const channelDef = this.encoding[channel];
        return getFieldDef(channelDef);
    }
    typedFieldDef(channel) {
        const fieldDef = this.fieldDef(channel);
        if (isTypedFieldDef(fieldDef)) return fieldDef;
        return null;
    }
}
class LayerModel extends Model {
    // HACK: This should be (LayerModel | UnitModel)[], but setting the correct type leads to weird error.
    // So I'm just putting generic Model for now
    children;
    constructor(spec, parent, parentGivenName, parentGivenSize, config){
        super(spec, 'layer', parent, parentGivenName, config, spec.resolve, spec.view);
        const layoutSize = {
            ...parentGivenSize,
            ...spec.width ? {
                width: spec.width
            } : {},
            ...spec.height ? {
                height: spec.height
            } : {}
        };
        this.children = spec.layer.map((layer, i)=>{
            if (isLayerSpec(layer)) return new LayerModel(layer, this, this.getName(`layer_${i}`), layoutSize, config);
            else if (isUnitSpec(layer)) return new UnitModel(layer, this, this.getName(`layer_${i}`), layoutSize, config);
            throw new Error(invalidSpec(layer));
        });
    }
    parseData() {
        this.component.data = parseData(this);
        for (const child of this.children)child.parseData();
    }
    parseLayoutSize() {
        parseLayerLayoutSize(this);
    }
    parseSelections() {
        // Merge selections up the hierarchy so that they may be referenced
        // across unit specs. Persist their definitions within each child
        // to assemble signals which remain within output Vega unit groups.
        this.component.selection = {};
        for (const child of this.children){
            child.parseSelections();
            for (const key of keys(child.component.selection))this.component.selection[key] = child.component.selection[key];
        }
        if (vals(this.component.selection).some((selCmpt)=>isTimerSelection(selCmpt))) error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
    }
    parseMarkGroup() {
        for (const child of this.children)child.parseMarkGroup();
    }
    parseAxesAndHeaders() {
        parseLayerAxes(this);
    }
    assembleSelectionTopLevelSignals(signals) {
        return this.children.reduce((sg, child)=>child.assembleSelectionTopLevelSignals(sg), signals);
    }
    // TODO: Support same named selections across children.
    assembleSignals() {
        return this.children.reduce((signals, child)=>{
            return signals.concat(child.assembleSignals());
        }, assembleAxisSignals(this));
    }
    assembleLayoutSignals() {
        return this.children.reduce((signals, child)=>{
            return signals.concat(child.assembleLayoutSignals());
        }, assembleLayoutSignals(this));
    }
    assembleSelectionData(data) {
        return this.children.reduce((db, child)=>child.assembleSelectionData(db), data);
    }
    assembleGroupStyle() {
        const uniqueStyles = new Set();
        for (const child of this.children)for (const style of (0, _vegaUtil.array)(child.assembleGroupStyle()))uniqueStyles.add(style);
        const styles = Array.from(uniqueStyles);
        return styles.length > 1 ? styles : styles.length === 1 ? styles[0] : undefined;
    }
    assembleTitle() {
        let title = super.assembleTitle();
        if (title) return title;
        // If title does not provide layer, look into children
        for (const child of this.children){
            title = child.assembleTitle();
            if (title) return title;
        }
        return undefined;
    }
    assembleLayout() {
        return null;
    }
    assembleMarks() {
        return assembleLayerSelectionMarks(this, this.children.flatMap((child)=>{
            return child.assembleMarks();
        }));
    }
    assembleLegends() {
        return this.children.reduce((legends, child)=>{
            return legends.concat(child.assembleLegends());
        }, assembleLegends(this));
    }
}
function buildModel(spec, parent, parentGivenName, unitSize, config) {
    if (isFacetSpec(spec)) return new FacetModel(spec, parent, parentGivenName, config);
    else if (isLayerSpec(spec)) return new LayerModel(spec, parent, parentGivenName, unitSize, config);
    else if (isUnitSpec(spec)) return new UnitModel(spec, parent, parentGivenName, unitSize, config);
    else if (isAnyConcatSpec(spec)) return new ConcatModel(spec, parent, parentGivenName, config);
    throw new Error(invalidSpec(spec));
}
/**
 * Vega-Lite's main function, for compiling Vega-Lite spec into Vega spec.
 *
 * At a high-level, we make the following transformations in different phases:
 *
 * Input spec
 *     |
 *     |  (Normalization)
 *     v
 * Normalized Spec (Row/Column channels in single-view specs becomes faceted specs, composite marks becomes layered specs.)
 *     |
 *     |  (Build Model)
 *     v
 * A model tree of the spec
 *     |
 *     |  (Parse)
 *     v
 * A model tree with parsed components (intermediate structure of visualization primitives in a format that can be easily merged)
 *     |
 *     | (Optimize)
 *     v
 * A model tree with parsed components with the data component optimized
 *     |
 *     | (Assemble)
 *     v
 * Vega spec
 *
 * @param inputSpec The Vega-Lite specification.
 * @param opt       Optional arguments passed to the Vega-Lite compiler.
 * @returns         An object containing the compiled Vega spec and normalized Vega-Lite spec.
 */ function compile(inputSpec, opt = {}) {
    // 0. Augment opt with default opts
    if (opt.logger) // set the singleton logger to the provided logger
    set(opt.logger);
    if (opt.fieldTitle) // set the singleton field title formatter
    setTitleFormatter(opt.fieldTitle);
    try {
        // 1. Initialize config by deep merging default config with the config provided via option and the input spec.
        const config = initConfig((0, _vegaUtil.mergeConfig)(opt.config, inputSpec.config));
        // 2. Normalize: Convert input spec -> normalized spec
        // - Decompose all extended unit specs into composition of unit spec. For example, a box plot get expanded into multiple layers of bars, ticks, and rules. The shorthand row/column channel is also expanded to a facet spec.
        // - Normalize autosize and width or height spec
        const spec = normalize(inputSpec, config);
        // 3. Build Model: normalized spec -> Model (a tree structure)
        // This phases instantiates the models with default config by doing a top-down traversal. This allows us to pass properties that child models derive from their parents via their constructors.
        // See the abstract `Model` class and its children (UnitModel, LayerModel, FacetModel, ConcatModel) for different types of models.
        const model = buildModel(spec, null, '', undefined, config);
        // 4 Parse: Model --> Model with components
        // Note that components = intermediate representations that are equivalent to Vega specs.
        // We need these intermediate representation because we need to merge many visualization "components" like projections, scales, axes, and legends.
        // We will later convert these components into actual Vega specs in the assemble phase.
        // In this phase, we do a bottom-up traversal over the whole tree to
        // parse for each type of components once (e.g., data, layout, mark, scale).
        // By doing bottom-up traversal, we start parsing components of unit specs and
        // then merge child components of parent composite specs.
        //
        // Please see inside model.parse() for order of different components parsed.
        model.parse();
        // drawDataflow(model.component.data.sources);
        // 5. Optimize the dataflow. This will modify the data component of the model.
        optimizeDataflow(model.component.data, model);
        // drawDataflow(model.component.data.sources);
        // 6. Assemble: convert model components --> Vega Spec.
        const vgSpec = assembleTopLevelModel(model, getTopLevelProperties(inputSpec, spec.autosize, config, model), inputSpec.datasets, inputSpec.usermeta);
        return {
            spec: vgSpec,
            normalized: spec
        };
    } finally{
        // Reset the singleton logger if a logger is provided
        if (opt.logger) reset();
        // Reset the singleton field title formatter if provided
        if (opt.fieldTitle) resetTitleFormatter();
    }
}
function getTopLevelProperties(inputSpec, autosize, config, model) {
    const width = model.component.layoutSize.get('width');
    const height = model.component.layoutSize.get('height');
    if (autosize === undefined) {
        autosize = {
            type: 'pad'
        };
        if (model.hasAxisOrientSignalRef()) autosize.resize = true;
    } else if ((0, _vegaUtil.isString)(autosize)) autosize = {
        type: autosize
    };
    if (width && height && isFitType(autosize.type)) {
        if (width === 'step' && height === 'step') {
            warn(droppingFit());
            autosize.type = 'pad';
        } else if (width === 'step' || height === 'step') {
            // effectively XOR, because else if
            // get step dimension
            const sizeType = width === 'step' ? 'width' : 'height';
            // log that we're dropping fit for respective channel
            warn(droppingFit(getPositionScaleChannel(sizeType)));
            // setting type to inverse fit (so if we dropped fit-x, type is now fit-y)
            const inverseSizeType = sizeType === 'width' ? 'height' : 'width';
            autosize.type = getFitType(inverseSizeType);
        }
    }
    return {
        ...keys(autosize).length === 1 && autosize.type ? autosize.type === 'pad' ? {} : {
            autosize: autosize.type
        } : {
            autosize
        },
        ...extractTopLevelProperties(config, false),
        ...extractTopLevelProperties(inputSpec, true)
    };
}
/*
 * Assemble the top-level model to a Vega spec.
 *
 * Note: this couldn't be `model.assemble()` since the top-level model
 * needs some special treatment to generate top-level properties.
 */ function assembleTopLevelModel(model, topLevelProperties, datasets = {}, usermeta) {
    // Config with Vega-Lite only config removed.
    const vgConfig = model.config ? stripAndRedirectConfig(model.config) : undefined;
    const rootData = assembleRootData(model.component.data, datasets);
    const data = model.assembleSelectionData(rootData);
    const projections = model.assembleProjections();
    const title = model.assembleTitle();
    const style = model.assembleGroupStyle();
    const encodeEntry = model.assembleGroupEncodeEntry(true);
    let layoutSignals = model.assembleLayoutSignals();
    // move width and height signals with values to top level
    layoutSignals = layoutSignals.filter((signal)=>{
        if ((signal.name === 'width' || signal.name === 'height') && signal.value !== undefined) {
            topLevelProperties[signal.name] = +signal.value;
            return false;
        }
        return true;
    });
    const { params, ...otherTopLevelProps } = topLevelProperties;
    return {
        $schema: 'https://vega.github.io/schema/vega/v6.json',
        ...model.description ? {
            description: model.description
        } : {},
        ...otherTopLevelProps,
        ...title ? {
            title
        } : {},
        ...style ? {
            style
        } : {},
        ...encodeEntry ? {
            encode: {
                update: encodeEntry
            }
        } : {},
        data,
        ...projections.length > 0 ? {
            projections
        } : {},
        ...model.assembleGroup([
            ...layoutSignals,
            ...model.assembleSelectionTopLevelSignals([]),
            ...assembleParameterSignals(params)
        ]),
        ...vgConfig ? {
            config: vgConfig
        } : {},
        ...usermeta ? {
            usermeta
        } : {}
    };
}
const version = pkg.version;

},{"vega-util":"kncZn","vega":"jxCvh","vega-event-selector":"4BhtH","vega-expression":"4bIBh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lSYby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setupMonaco);
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _jsoncParser = require("jsonc-parser");
var _vegaLite = require("vega-lite");
var _markdownPropsJs = require("./markdownProps.js");
var _markdownPropsJsDefault = parcelHelpers.interopDefault(_markdownPropsJs);
var _vegaLiteSchemaJson = require("vega-lite/vega-lite-schema.json");
var _vegaLiteSchemaJsonDefault = parcelHelpers.interopDefault(_vegaLiteSchemaJson);
var _vegaSchemaJson = require("vega/vega-schema.json");
var _vegaSchemaJsonDefault = parcelHelpers.interopDefault(_vegaSchemaJson);
var _react = require("@monaco-editor/react");
(0, _markdownPropsJsDefault.default)((0, _vegaSchemaJsonDefault.default));
(0, _markdownPropsJsDefault.default)((0, _vegaLiteSchemaJsonDefault.default));
const schemas = [
    {
        schema: (0, _vegaSchemaJsonDefault.default),
        uri: 'https://vega.github.io/schema/vega/v5.json'
    },
    {
        schema: (0, _vegaLiteSchemaJsonDefault.default),
        uri: 'https://vega.github.io/schema/vega-lite/v5.json'
    },
    {
        schema: (0, _vegaLite.mergeDeep)({}, (0, _vegaLiteSchemaJsonDefault.default), {
            $ref: '#/definitions/Config',
            definitions: {
                Config: {
                    properties: {
                        $schema: {
                            type: 'string'
                        }
                    }
                }
            }
        }),
        uri: 'https://vega.github.io/schema/vega-lite/v5.json#Config'
    },
    {
        schema: {
            $schema: 'http://json-schema.org/draft-06/schema#',
            type: 'object'
        },
        uri: 'https://vega.github.io/schema/vega/v5.json#Config'
    }
];
async function setupMonaco() {
    const monaco = await (0, _react.loader).init();
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        comments: 'warning',
        trailingCommas: 'warning',
        enableSchemaRequest: true,
        schemas,
        validate: true
    });
    monaco.languages.json.jsonDefaults.setModeConfiguration({
        documentFormattingEdits: false,
        documentRangeFormattingEdits: false,
        completionItems: true,
        hovers: true,
        documentSymbols: true,
        tokens: true,
        colors: true,
        foldingRanges: true,
        diagnostics: true
    });
    monaco.languages.registerDocumentFormattingEditProvider('json', {
        provideDocumentFormattingEdits (model) {
            return [
                {
                    range: model.getFullModelRange(),
                    text: (0, _jsonStringifyPrettyCompactDefault.default)((0, _jsoncParser.parse)(model.getValue()))
                }
            ];
        }
    });
}

},{"json-stringify-pretty-compact":"jn76Q","jsonc-parser":"81Jm5","vega-lite":"eTD5L","./markdownProps.js":"jr1nI","vega-lite/vega-lite-schema.json":"ifxp5","vega/vega-schema.json":"sbR1U","@monaco-editor/react":"495Y5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jn76Q":[function(require,module,exports,__globalThis) {
// Note: This regex matches even invalid JSON strings, but since we’re
// working on the output of `JSON.stringify` we know that only valid strings
// are present (unless the user supplied a weird `options.indent` but in
// that case we don’t care since the output would be invalid anyway).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>stringify);
const stringOrChar = /("(?:[^\\"]|\\.)*")|[:,]/g;
function stringify(passedObj, options = {}) {
    const indent = JSON.stringify([
        1
    ], undefined, options.indent === undefined ? 2 : options.indent).slice(2, -3);
    const maxLength = indent === "" ? Infinity : options.maxLength === undefined ? 80 : options.maxLength;
    let { replacer } = options;
    return function _stringify(obj, currentIndent, reserved) {
        if (obj && typeof obj.toJSON === "function") obj = obj.toJSON();
        const string = JSON.stringify(obj, replacer);
        if (string === undefined) return string;
        const length = maxLength - currentIndent.length - reserved;
        if (string.length <= length) {
            const prettified = string.replace(stringOrChar, (match, stringLiteral)=>{
                return stringLiteral || `${match} `;
            });
            if (prettified.length <= length) return prettified;
        }
        if (replacer != null) {
            obj = JSON.parse(string);
            replacer = undefined;
        }
        if (typeof obj === "object" && obj !== null) {
            const nextIndent = currentIndent + indent;
            const items = [];
            let index = 0;
            let start;
            let end;
            if (Array.isArray(obj)) {
                start = "[";
                end = "]";
                const { length } = obj;
                for(; index < length; index++)items.push(_stringify(obj[index], nextIndent, index === length - 1 ? 0 : 1) || "null");
            } else {
                start = "{";
                end = "}";
                const keys = Object.keys(obj);
                const { length } = keys;
                for(; index < length; index++){
                    const key = keys[index];
                    const keyPart = `${JSON.stringify(key)}: `;
                    const value = _stringify(obj[key], nextIndent, keyPart.length + (index === length - 1 ? 0 : 1));
                    if (value !== undefined) items.push(keyPart + value);
                }
            }
            if (items.length > 0) return [
                start,
                indent + items.join(`,\n${nextIndent}`),
                end
            ].join(`\n${currentIndent}`);
        }
        return string;
    }(passedObj, "", 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"81Jm5":[function(require,module,exports,__globalThis) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScanner", ()=>createScanner);
parcelHelpers.export(exports, "ScanError", ()=>ScanError);
parcelHelpers.export(exports, "SyntaxKind", ()=>SyntaxKind);
parcelHelpers.export(exports, "getLocation", ()=>getLocation);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parseTree", ()=>parseTree);
parcelHelpers.export(exports, "findNodeAtLocation", ()=>findNodeAtLocation);
parcelHelpers.export(exports, "findNodeAtOffset", ()=>findNodeAtOffset);
parcelHelpers.export(exports, "getNodePath", ()=>getNodePath);
parcelHelpers.export(exports, "getNodeValue", ()=>getNodeValue);
parcelHelpers.export(exports, "visit", ()=>visit);
parcelHelpers.export(exports, "stripComments", ()=>stripComments);
parcelHelpers.export(exports, "ParseErrorCode", ()=>ParseErrorCode);
parcelHelpers.export(exports, "printParseErrorCode", ()=>printParseErrorCode);
/**
 * Computes the edit operations needed to format a JSON document.
 *
 * @param documentText The input text
 * @param range The range to format or `undefined` to format the full content
 * @param options The formatting options
 * @returns The edit operations describing the formatting changes to the original document following the format described in {@linkcode EditResult}.
 * To apply the edit operations to the input, use {@linkcode applyEdits}.
 */ parcelHelpers.export(exports, "format", ()=>format);
/**
 * Computes the edit operations needed to modify a value in the JSON document.
 *
 * @param documentText The input text
 * @param path The path of the value to change. The path represents either to the document root, a property or an array item.
 * If the path points to an non-existing property or item, it will be created.
 * @param value The new value for the specified property or item. If the value is undefined,
 * the property or item will be removed.
 * @param options Options
 * @returns The edit operations describing the changes to the original document, following the format described in {@linkcode EditResult}.
 * To apply the edit operations to the input, use {@linkcode applyEdits}.
 */ parcelHelpers.export(exports, "modify", ()=>modify);
/**
 * Applies edits to an input string.
 * @param text The input text
 * @param edits Edit operations following the format described in {@linkcode EditResult}.
 * @returns The text with the applied edits.
 * @throws An error if the edit operations are not well-formed as described in {@linkcode EditResult}.
 */ parcelHelpers.export(exports, "applyEdits", ()=>applyEdits);
var _format = require("./impl/format");
var _edit = require("./impl/edit");
var _scanner = require("./impl/scanner");
var _parser = require("./impl/parser");
'use strict';
const createScanner = _scanner.createScanner;
var ScanError;
(function(ScanError) {
    ScanError[ScanError["None"] = 0] = "None";
    ScanError[ScanError["UnexpectedEndOfComment"] = 1] = "UnexpectedEndOfComment";
    ScanError[ScanError["UnexpectedEndOfString"] = 2] = "UnexpectedEndOfString";
    ScanError[ScanError["UnexpectedEndOfNumber"] = 3] = "UnexpectedEndOfNumber";
    ScanError[ScanError["InvalidUnicode"] = 4] = "InvalidUnicode";
    ScanError[ScanError["InvalidEscapeCharacter"] = 5] = "InvalidEscapeCharacter";
    ScanError[ScanError["InvalidCharacter"] = 6] = "InvalidCharacter";
})(ScanError || (ScanError = {}));
var SyntaxKind;
(function(SyntaxKind) {
    SyntaxKind[SyntaxKind["OpenBraceToken"] = 1] = "OpenBraceToken";
    SyntaxKind[SyntaxKind["CloseBraceToken"] = 2] = "CloseBraceToken";
    SyntaxKind[SyntaxKind["OpenBracketToken"] = 3] = "OpenBracketToken";
    SyntaxKind[SyntaxKind["CloseBracketToken"] = 4] = "CloseBracketToken";
    SyntaxKind[SyntaxKind["CommaToken"] = 5] = "CommaToken";
    SyntaxKind[SyntaxKind["ColonToken"] = 6] = "ColonToken";
    SyntaxKind[SyntaxKind["NullKeyword"] = 7] = "NullKeyword";
    SyntaxKind[SyntaxKind["TrueKeyword"] = 8] = "TrueKeyword";
    SyntaxKind[SyntaxKind["FalseKeyword"] = 9] = "FalseKeyword";
    SyntaxKind[SyntaxKind["StringLiteral"] = 10] = "StringLiteral";
    SyntaxKind[SyntaxKind["NumericLiteral"] = 11] = "NumericLiteral";
    SyntaxKind[SyntaxKind["LineCommentTrivia"] = 12] = "LineCommentTrivia";
    SyntaxKind[SyntaxKind["BlockCommentTrivia"] = 13] = "BlockCommentTrivia";
    SyntaxKind[SyntaxKind["LineBreakTrivia"] = 14] = "LineBreakTrivia";
    SyntaxKind[SyntaxKind["Trivia"] = 15] = "Trivia";
    SyntaxKind[SyntaxKind["Unknown"] = 16] = "Unknown";
    SyntaxKind[SyntaxKind["EOF"] = 17] = "EOF";
})(SyntaxKind || (SyntaxKind = {}));
const getLocation = _parser.getLocation;
const parse = _parser.parse;
const parseTree = _parser.parseTree;
const findNodeAtLocation = _parser.findNodeAtLocation;
const findNodeAtOffset = _parser.findNodeAtOffset;
const getNodePath = _parser.getNodePath;
const getNodeValue = _parser.getNodeValue;
const visit = _parser.visit;
const stripComments = _parser.stripComments;
var ParseErrorCode;
(function(ParseErrorCode) {
    ParseErrorCode[ParseErrorCode["InvalidSymbol"] = 1] = "InvalidSymbol";
    ParseErrorCode[ParseErrorCode["InvalidNumberFormat"] = 2] = "InvalidNumberFormat";
    ParseErrorCode[ParseErrorCode["PropertyNameExpected"] = 3] = "PropertyNameExpected";
    ParseErrorCode[ParseErrorCode["ValueExpected"] = 4] = "ValueExpected";
    ParseErrorCode[ParseErrorCode["ColonExpected"] = 5] = "ColonExpected";
    ParseErrorCode[ParseErrorCode["CommaExpected"] = 6] = "CommaExpected";
    ParseErrorCode[ParseErrorCode["CloseBraceExpected"] = 7] = "CloseBraceExpected";
    ParseErrorCode[ParseErrorCode["CloseBracketExpected"] = 8] = "CloseBracketExpected";
    ParseErrorCode[ParseErrorCode["EndOfFileExpected"] = 9] = "EndOfFileExpected";
    ParseErrorCode[ParseErrorCode["InvalidCommentToken"] = 10] = "InvalidCommentToken";
    ParseErrorCode[ParseErrorCode["UnexpectedEndOfComment"] = 11] = "UnexpectedEndOfComment";
    ParseErrorCode[ParseErrorCode["UnexpectedEndOfString"] = 12] = "UnexpectedEndOfString";
    ParseErrorCode[ParseErrorCode["UnexpectedEndOfNumber"] = 13] = "UnexpectedEndOfNumber";
    ParseErrorCode[ParseErrorCode["InvalidUnicode"] = 14] = "InvalidUnicode";
    ParseErrorCode[ParseErrorCode["InvalidEscapeCharacter"] = 15] = "InvalidEscapeCharacter";
    ParseErrorCode[ParseErrorCode["InvalidCharacter"] = 16] = "InvalidCharacter";
})(ParseErrorCode || (ParseErrorCode = {}));
function printParseErrorCode(code) {
    switch(code){
        case 1 /* ParseErrorCode.InvalidSymbol */ :
            return 'InvalidSymbol';
        case 2 /* ParseErrorCode.InvalidNumberFormat */ :
            return 'InvalidNumberFormat';
        case 3 /* ParseErrorCode.PropertyNameExpected */ :
            return 'PropertyNameExpected';
        case 4 /* ParseErrorCode.ValueExpected */ :
            return 'ValueExpected';
        case 5 /* ParseErrorCode.ColonExpected */ :
            return 'ColonExpected';
        case 6 /* ParseErrorCode.CommaExpected */ :
            return 'CommaExpected';
        case 7 /* ParseErrorCode.CloseBraceExpected */ :
            return 'CloseBraceExpected';
        case 8 /* ParseErrorCode.CloseBracketExpected */ :
            return 'CloseBracketExpected';
        case 9 /* ParseErrorCode.EndOfFileExpected */ :
            return 'EndOfFileExpected';
        case 10 /* ParseErrorCode.InvalidCommentToken */ :
            return 'InvalidCommentToken';
        case 11 /* ParseErrorCode.UnexpectedEndOfComment */ :
            return 'UnexpectedEndOfComment';
        case 12 /* ParseErrorCode.UnexpectedEndOfString */ :
            return 'UnexpectedEndOfString';
        case 13 /* ParseErrorCode.UnexpectedEndOfNumber */ :
            return 'UnexpectedEndOfNumber';
        case 14 /* ParseErrorCode.InvalidUnicode */ :
            return 'InvalidUnicode';
        case 15 /* ParseErrorCode.InvalidEscapeCharacter */ :
            return 'InvalidEscapeCharacter';
        case 16 /* ParseErrorCode.InvalidCharacter */ :
            return 'InvalidCharacter';
    }
    return '<unknown ParseErrorCode>';
}
function format(documentText, range, options) {
    return _format.format(documentText, range, options);
}
function modify(text, path, value, options) {
    return _edit.setProperty(text, path, value, options);
}
function applyEdits(text, edits) {
    let sortedEdits = edits.slice(0).sort((a, b)=>{
        const diff = a.offset - b.offset;
        if (diff === 0) return a.length - b.length;
        return diff;
    });
    let lastModifiedOffset = text.length;
    for(let i = sortedEdits.length - 1; i >= 0; i--){
        let e = sortedEdits[i];
        if (e.offset + e.length <= lastModifiedOffset) text = _edit.applyEdit(text, e);
        else throw new Error('Overlapping edit');
        lastModifiedOffset = e.offset;
    }
    return text;
}

},{"./impl/format":"6CYcR","./impl/edit":"4aAQ8","./impl/scanner":"29mzA","./impl/parser":"7XFj5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6CYcR":[function(require,module,exports,__globalThis) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "isEOL", ()=>isEOL);
var _scanner = require("./scanner");
var _stringIntern = require("./string-intern");
'use strict';
function format(documentText, range, options) {
    let initialIndentLevel;
    let formatText;
    let formatTextStart;
    let rangeStart;
    let rangeEnd;
    if (range) {
        rangeStart = range.offset;
        rangeEnd = rangeStart + range.length;
        formatTextStart = rangeStart;
        while(formatTextStart > 0 && !isEOL(documentText, formatTextStart - 1))formatTextStart--;
        let endOffset = rangeEnd;
        while(endOffset < documentText.length && !isEOL(documentText, endOffset))endOffset++;
        formatText = documentText.substring(formatTextStart, endOffset);
        initialIndentLevel = computeIndentLevel(formatText, options);
    } else {
        formatText = documentText;
        initialIndentLevel = 0;
        formatTextStart = 0;
        rangeStart = 0;
        rangeEnd = documentText.length;
    }
    const eol = getEOL(options, documentText);
    const eolFastPathSupported = (0, _stringIntern.supportedEols).includes(eol);
    let numberLineBreaks = 0;
    let indentLevel = 0;
    let indentValue;
    if (options.insertSpaces) indentValue = (0, _stringIntern.cachedSpaces)[options.tabSize || 4] ?? repeat((0, _stringIntern.cachedSpaces)[1], options.tabSize || 4);
    else indentValue = '\t';
    const indentType = indentValue === '\t' ? '\t' : ' ';
    let scanner = (0, _scanner.createScanner)(formatText, false);
    let hasError = false;
    function newLinesAndIndent() {
        if (numberLineBreaks > 1) return repeat(eol, numberLineBreaks) + repeat(indentValue, initialIndentLevel + indentLevel);
        const amountOfSpaces = indentValue.length * (initialIndentLevel + indentLevel);
        if (!eolFastPathSupported || amountOfSpaces > (0, _stringIntern.cachedBreakLinesWithSpaces)[indentType][eol].length) return eol + repeat(indentValue, initialIndentLevel + indentLevel);
        if (amountOfSpaces <= 0) return eol;
        return (0, _stringIntern.cachedBreakLinesWithSpaces)[indentType][eol][amountOfSpaces];
    }
    function scanNext() {
        let token = scanner.scan();
        numberLineBreaks = 0;
        while(token === 15 /* SyntaxKind.Trivia */  || token === 14 /* SyntaxKind.LineBreakTrivia */ ){
            if (token === 14 /* SyntaxKind.LineBreakTrivia */  && options.keepLines) numberLineBreaks += 1;
            else if (token === 14 /* SyntaxKind.LineBreakTrivia */ ) numberLineBreaks = 1;
            token = scanner.scan();
        }
        hasError = token === 16 /* SyntaxKind.Unknown */  || scanner.getTokenError() !== 0 /* ScanError.None */ ;
        return token;
    }
    const editOperations = [];
    function addEdit(text, startOffset, endOffset) {
        if (!hasError && (!range || startOffset < rangeEnd && endOffset > rangeStart) && documentText.substring(startOffset, endOffset) !== text) editOperations.push({
            offset: startOffset,
            length: endOffset - startOffset,
            content: text
        });
    }
    let firstToken = scanNext();
    if (options.keepLines && numberLineBreaks > 0) addEdit(repeat(eol, numberLineBreaks), 0, 0);
    if (firstToken !== 17 /* SyntaxKind.EOF */ ) {
        let firstTokenStart = scanner.getTokenOffset() + formatTextStart;
        let initialIndent = indentValue.length * initialIndentLevel < 20 && options.insertSpaces ? (0, _stringIntern.cachedSpaces)[indentValue.length * initialIndentLevel] : repeat(indentValue, initialIndentLevel);
        addEdit(initialIndent, formatTextStart, firstTokenStart);
    }
    while(firstToken !== 17 /* SyntaxKind.EOF */ ){
        let firstTokenEnd = scanner.getTokenOffset() + scanner.getTokenLength() + formatTextStart;
        let secondToken = scanNext();
        let replaceContent = '';
        let needsLineBreak = false;
        while(numberLineBreaks === 0 && (secondToken === 12 /* SyntaxKind.LineCommentTrivia */  || secondToken === 13 /* SyntaxKind.BlockCommentTrivia */ )){
            let commentTokenStart = scanner.getTokenOffset() + formatTextStart;
            addEdit((0, _stringIntern.cachedSpaces)[1], firstTokenEnd, commentTokenStart);
            firstTokenEnd = scanner.getTokenOffset() + scanner.getTokenLength() + formatTextStart;
            needsLineBreak = secondToken === 12 /* SyntaxKind.LineCommentTrivia */ ;
            replaceContent = needsLineBreak ? newLinesAndIndent() : '';
            secondToken = scanNext();
        }
        if (secondToken === 2 /* SyntaxKind.CloseBraceToken */ ) {
            if (firstToken !== 1 /* SyntaxKind.OpenBraceToken */ ) indentLevel--;
            if (options.keepLines && numberLineBreaks > 0 || !options.keepLines && firstToken !== 1 /* SyntaxKind.OpenBraceToken */ ) replaceContent = newLinesAndIndent();
            else if (options.keepLines) replaceContent = (0, _stringIntern.cachedSpaces)[1];
        } else if (secondToken === 4 /* SyntaxKind.CloseBracketToken */ ) {
            if (firstToken !== 3 /* SyntaxKind.OpenBracketToken */ ) indentLevel--;
            if (options.keepLines && numberLineBreaks > 0 || !options.keepLines && firstToken !== 3 /* SyntaxKind.OpenBracketToken */ ) replaceContent = newLinesAndIndent();
            else if (options.keepLines) replaceContent = (0, _stringIntern.cachedSpaces)[1];
        } else {
            switch(firstToken){
                case 3 /* SyntaxKind.OpenBracketToken */ :
                case 1 /* SyntaxKind.OpenBraceToken */ :
                    indentLevel++;
                    if (options.keepLines && numberLineBreaks > 0 || !options.keepLines) replaceContent = newLinesAndIndent();
                    else replaceContent = (0, _stringIntern.cachedSpaces)[1];
                    break;
                case 5 /* SyntaxKind.CommaToken */ :
                    if (options.keepLines && numberLineBreaks > 0 || !options.keepLines) replaceContent = newLinesAndIndent();
                    else replaceContent = (0, _stringIntern.cachedSpaces)[1];
                    break;
                case 12 /* SyntaxKind.LineCommentTrivia */ :
                    replaceContent = newLinesAndIndent();
                    break;
                case 13 /* SyntaxKind.BlockCommentTrivia */ :
                    if (numberLineBreaks > 0) replaceContent = newLinesAndIndent();
                    else if (!needsLineBreak) replaceContent = (0, _stringIntern.cachedSpaces)[1];
                    break;
                case 6 /* SyntaxKind.ColonToken */ :
                    if (options.keepLines && numberLineBreaks > 0) replaceContent = newLinesAndIndent();
                    else if (!needsLineBreak) replaceContent = (0, _stringIntern.cachedSpaces)[1];
                    break;
                case 10 /* SyntaxKind.StringLiteral */ :
                    if (options.keepLines && numberLineBreaks > 0) replaceContent = newLinesAndIndent();
                    else if (secondToken === 6 /* SyntaxKind.ColonToken */  && !needsLineBreak) replaceContent = '';
                    break;
                case 7 /* SyntaxKind.NullKeyword */ :
                case 8 /* SyntaxKind.TrueKeyword */ :
                case 9 /* SyntaxKind.FalseKeyword */ :
                case 11 /* SyntaxKind.NumericLiteral */ :
                case 2 /* SyntaxKind.CloseBraceToken */ :
                case 4 /* SyntaxKind.CloseBracketToken */ :
                    if (options.keepLines && numberLineBreaks > 0) replaceContent = newLinesAndIndent();
                    else {
                        if ((secondToken === 12 /* SyntaxKind.LineCommentTrivia */  || secondToken === 13 /* SyntaxKind.BlockCommentTrivia */ ) && !needsLineBreak) replaceContent = (0, _stringIntern.cachedSpaces)[1];
                        else if (secondToken !== 5 /* SyntaxKind.CommaToken */  && secondToken !== 17 /* SyntaxKind.EOF */ ) hasError = true;
                    }
                    break;
                case 16 /* SyntaxKind.Unknown */ :
                    hasError = true;
                    break;
            }
            if (numberLineBreaks > 0 && (secondToken === 12 /* SyntaxKind.LineCommentTrivia */  || secondToken === 13 /* SyntaxKind.BlockCommentTrivia */ )) replaceContent = newLinesAndIndent();
        }
        if (secondToken === 17 /* SyntaxKind.EOF */ ) {
            if (options.keepLines && numberLineBreaks > 0) replaceContent = newLinesAndIndent();
            else replaceContent = options.insertFinalNewline ? eol : '';
        }
        const secondTokenStart = scanner.getTokenOffset() + formatTextStart;
        addEdit(replaceContent, firstTokenEnd, secondTokenStart);
        firstToken = secondToken;
    }
    return editOperations;
}
function repeat(s, count) {
    let result = '';
    for(let i = 0; i < count; i++)result += s;
    return result;
}
function computeIndentLevel(content, options) {
    let i = 0;
    let nChars = 0;
    const tabSize = options.tabSize || 4;
    while(i < content.length){
        let ch = content.charAt(i);
        if (ch === (0, _stringIntern.cachedSpaces)[1]) nChars++;
        else if (ch === '\t') nChars += tabSize;
        else break;
        i++;
    }
    return Math.floor(nChars / tabSize);
}
function getEOL(options, text) {
    for(let i = 0; i < text.length; i++){
        const ch = text.charAt(i);
        if (ch === '\r') {
            if (i + 1 < text.length && text.charAt(i + 1) === '\n') return '\r\n';
            return '\r';
        } else if (ch === '\n') return '\n';
    }
    return options && options.eol || '\n';
}
function isEOL(text, offset) {
    return '\r\n'.indexOf(text.charAt(offset)) !== -1;
}

},{"./scanner":"29mzA","./string-intern":"24vkl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"29mzA":[function(require,module,exports,__globalThis) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Creates a JSON scanner on the given text.
 * If ignoreTrivia is set, whitespaces or comments are ignored.
 */ parcelHelpers.export(exports, "createScanner", ()=>createScanner);
'use strict';
function createScanner(text, ignoreTrivia = false) {
    const len = text.length;
    let pos = 0, value = '', tokenOffset = 0, token = 16 /* SyntaxKind.Unknown */ , lineNumber = 0, lineStartOffset = 0, tokenLineStartOffset = 0, prevTokenLineStartOffset = 0, scanError = 0 /* ScanError.None */ ;
    function scanHexDigits(count, exact) {
        let digits = 0;
        let value = 0;
        while(digits < count || !exact){
            let ch = text.charCodeAt(pos);
            if (ch >= 48 /* CharacterCodes._0 */  && ch <= 57 /* CharacterCodes._9 */ ) value = value * 16 + ch - 48 /* CharacterCodes._0 */ ;
            else if (ch >= 65 /* CharacterCodes.A */  && ch <= 70 /* CharacterCodes.F */ ) value = value * 16 + ch - 65 /* CharacterCodes.A */  + 10;
            else if (ch >= 97 /* CharacterCodes.a */  && ch <= 102 /* CharacterCodes.f */ ) value = value * 16 + ch - 97 /* CharacterCodes.a */  + 10;
            else break;
            pos++;
            digits++;
        }
        if (digits < count) value = -1;
        return value;
    }
    function setPosition(newPosition) {
        pos = newPosition;
        value = '';
        tokenOffset = 0;
        token = 16 /* SyntaxKind.Unknown */ ;
        scanError = 0 /* ScanError.None */ ;
    }
    function scanNumber() {
        let start = pos;
        if (text.charCodeAt(pos) === 48 /* CharacterCodes._0 */ ) pos++;
        else {
            pos++;
            while(pos < text.length && isDigit(text.charCodeAt(pos)))pos++;
        }
        if (pos < text.length && text.charCodeAt(pos) === 46 /* CharacterCodes.dot */ ) {
            pos++;
            if (pos < text.length && isDigit(text.charCodeAt(pos))) {
                pos++;
                while(pos < text.length && isDigit(text.charCodeAt(pos)))pos++;
            } else {
                scanError = 3 /* ScanError.UnexpectedEndOfNumber */ ;
                return text.substring(start, pos);
            }
        }
        let end = pos;
        if (pos < text.length && (text.charCodeAt(pos) === 69 /* CharacterCodes.E */  || text.charCodeAt(pos) === 101 /* CharacterCodes.e */ )) {
            pos++;
            if (pos < text.length && text.charCodeAt(pos) === 43 /* CharacterCodes.plus */  || text.charCodeAt(pos) === 45 /* CharacterCodes.minus */ ) pos++;
            if (pos < text.length && isDigit(text.charCodeAt(pos))) {
                pos++;
                while(pos < text.length && isDigit(text.charCodeAt(pos)))pos++;
                end = pos;
            } else scanError = 3 /* ScanError.UnexpectedEndOfNumber */ ;
        }
        return text.substring(start, end);
    }
    function scanString() {
        let result = '', start = pos;
        while(true){
            if (pos >= len) {
                result += text.substring(start, pos);
                scanError = 2 /* ScanError.UnexpectedEndOfString */ ;
                break;
            }
            const ch = text.charCodeAt(pos);
            if (ch === 34 /* CharacterCodes.doubleQuote */ ) {
                result += text.substring(start, pos);
                pos++;
                break;
            }
            if (ch === 92 /* CharacterCodes.backslash */ ) {
                result += text.substring(start, pos);
                pos++;
                if (pos >= len) {
                    scanError = 2 /* ScanError.UnexpectedEndOfString */ ;
                    break;
                }
                const ch2 = text.charCodeAt(pos++);
                switch(ch2){
                    case 34 /* CharacterCodes.doubleQuote */ :
                        result += '\"';
                        break;
                    case 92 /* CharacterCodes.backslash */ :
                        result += '\\';
                        break;
                    case 47 /* CharacterCodes.slash */ :
                        result += '/';
                        break;
                    case 98 /* CharacterCodes.b */ :
                        result += '\b';
                        break;
                    case 102 /* CharacterCodes.f */ :
                        result += '\f';
                        break;
                    case 110 /* CharacterCodes.n */ :
                        result += '\n';
                        break;
                    case 114 /* CharacterCodes.r */ :
                        result += '\r';
                        break;
                    case 116 /* CharacterCodes.t */ :
                        result += '\t';
                        break;
                    case 117 /* CharacterCodes.u */ :
                        const ch3 = scanHexDigits(4, true);
                        if (ch3 >= 0) result += String.fromCharCode(ch3);
                        else scanError = 4 /* ScanError.InvalidUnicode */ ;
                        break;
                    default:
                        scanError = 5 /* ScanError.InvalidEscapeCharacter */ ;
                }
                start = pos;
                continue;
            }
            if (ch >= 0 && ch <= 0x1f) {
                if (isLineBreak(ch)) {
                    result += text.substring(start, pos);
                    scanError = 2 /* ScanError.UnexpectedEndOfString */ ;
                    break;
                } else scanError = 6 /* ScanError.InvalidCharacter */ ;
            }
            pos++;
        }
        return result;
    }
    function scanNext() {
        value = '';
        scanError = 0 /* ScanError.None */ ;
        tokenOffset = pos;
        lineStartOffset = lineNumber;
        prevTokenLineStartOffset = tokenLineStartOffset;
        if (pos >= len) {
            // at the end
            tokenOffset = len;
            return token = 17 /* SyntaxKind.EOF */ ;
        }
        let code = text.charCodeAt(pos);
        // trivia: whitespace
        if (isWhiteSpace(code)) {
            do {
                pos++;
                value += String.fromCharCode(code);
                code = text.charCodeAt(pos);
            }while (isWhiteSpace(code));
            return token = 15 /* SyntaxKind.Trivia */ ;
        }
        // trivia: newlines
        if (isLineBreak(code)) {
            pos++;
            value += String.fromCharCode(code);
            if (code === 13 /* CharacterCodes.carriageReturn */  && text.charCodeAt(pos) === 10 /* CharacterCodes.lineFeed */ ) {
                pos++;
                value += '\n';
            }
            lineNumber++;
            tokenLineStartOffset = pos;
            return token = 14 /* SyntaxKind.LineBreakTrivia */ ;
        }
        switch(code){
            // tokens: []{}:,
            case 123 /* CharacterCodes.openBrace */ :
                pos++;
                return token = 1 /* SyntaxKind.OpenBraceToken */ ;
            case 125 /* CharacterCodes.closeBrace */ :
                pos++;
                return token = 2 /* SyntaxKind.CloseBraceToken */ ;
            case 91 /* CharacterCodes.openBracket */ :
                pos++;
                return token = 3 /* SyntaxKind.OpenBracketToken */ ;
            case 93 /* CharacterCodes.closeBracket */ :
                pos++;
                return token = 4 /* SyntaxKind.CloseBracketToken */ ;
            case 58 /* CharacterCodes.colon */ :
                pos++;
                return token = 6 /* SyntaxKind.ColonToken */ ;
            case 44 /* CharacterCodes.comma */ :
                pos++;
                return token = 5 /* SyntaxKind.CommaToken */ ;
            // strings
            case 34 /* CharacterCodes.doubleQuote */ :
                pos++;
                value = scanString();
                return token = 10 /* SyntaxKind.StringLiteral */ ;
            // comments
            case 47 /* CharacterCodes.slash */ :
                const start = pos - 1;
                // Single-line comment
                if (text.charCodeAt(pos + 1) === 47 /* CharacterCodes.slash */ ) {
                    pos += 2;
                    while(pos < len){
                        if (isLineBreak(text.charCodeAt(pos))) break;
                        pos++;
                    }
                    value = text.substring(start, pos);
                    return token = 12 /* SyntaxKind.LineCommentTrivia */ ;
                }
                // Multi-line comment
                if (text.charCodeAt(pos + 1) === 42 /* CharacterCodes.asterisk */ ) {
                    pos += 2;
                    const safeLength = len - 1; // For lookahead.
                    let commentClosed = false;
                    while(pos < safeLength){
                        const ch = text.charCodeAt(pos);
                        if (ch === 42 /* CharacterCodes.asterisk */  && text.charCodeAt(pos + 1) === 47 /* CharacterCodes.slash */ ) {
                            pos += 2;
                            commentClosed = true;
                            break;
                        }
                        pos++;
                        if (isLineBreak(ch)) {
                            if (ch === 13 /* CharacterCodes.carriageReturn */  && text.charCodeAt(pos) === 10 /* CharacterCodes.lineFeed */ ) pos++;
                            lineNumber++;
                            tokenLineStartOffset = pos;
                        }
                    }
                    if (!commentClosed) {
                        pos++;
                        scanError = 1 /* ScanError.UnexpectedEndOfComment */ ;
                    }
                    value = text.substring(start, pos);
                    return token = 13 /* SyntaxKind.BlockCommentTrivia */ ;
                }
                // just a single slash
                value += String.fromCharCode(code);
                pos++;
                return token = 16 /* SyntaxKind.Unknown */ ;
            // numbers
            case 45 /* CharacterCodes.minus */ :
                value += String.fromCharCode(code);
                pos++;
                if (pos === len || !isDigit(text.charCodeAt(pos))) return token = 16 /* SyntaxKind.Unknown */ ;
            // found a minus, followed by a number so
            // we fall through to proceed with scanning
            // numbers
            case 48 /* CharacterCodes._0 */ :
            case 49 /* CharacterCodes._1 */ :
            case 50 /* CharacterCodes._2 */ :
            case 51 /* CharacterCodes._3 */ :
            case 52 /* CharacterCodes._4 */ :
            case 53 /* CharacterCodes._5 */ :
            case 54 /* CharacterCodes._6 */ :
            case 55 /* CharacterCodes._7 */ :
            case 56 /* CharacterCodes._8 */ :
            case 57 /* CharacterCodes._9 */ :
                value += scanNumber();
                return token = 11 /* SyntaxKind.NumericLiteral */ ;
            // literals and unknown symbols
            default:
                // is a literal? Read the full word.
                while(pos < len && isUnknownContentCharacter(code)){
                    pos++;
                    code = text.charCodeAt(pos);
                }
                if (tokenOffset !== pos) {
                    value = text.substring(tokenOffset, pos);
                    // keywords: true, false, null
                    switch(value){
                        case 'true':
                            return token = 8 /* SyntaxKind.TrueKeyword */ ;
                        case 'false':
                            return token = 9 /* SyntaxKind.FalseKeyword */ ;
                        case 'null':
                            return token = 7 /* SyntaxKind.NullKeyword */ ;
                    }
                    return token = 16 /* SyntaxKind.Unknown */ ;
                }
                // some
                value += String.fromCharCode(code);
                pos++;
                return token = 16 /* SyntaxKind.Unknown */ ;
        }
    }
    function isUnknownContentCharacter(code) {
        if (isWhiteSpace(code) || isLineBreak(code)) return false;
        switch(code){
            case 125 /* CharacterCodes.closeBrace */ :
            case 93 /* CharacterCodes.closeBracket */ :
            case 123 /* CharacterCodes.openBrace */ :
            case 91 /* CharacterCodes.openBracket */ :
            case 34 /* CharacterCodes.doubleQuote */ :
            case 58 /* CharacterCodes.colon */ :
            case 44 /* CharacterCodes.comma */ :
            case 47 /* CharacterCodes.slash */ :
                return false;
        }
        return true;
    }
    function scanNextNonTrivia() {
        let result;
        do result = scanNext();
        while (result >= 12 /* SyntaxKind.LineCommentTrivia */  && result <= 15 /* SyntaxKind.Trivia */ );
        return result;
    }
    return {
        setPosition: setPosition,
        getPosition: ()=>pos,
        scan: ignoreTrivia ? scanNextNonTrivia : scanNext,
        getToken: ()=>token,
        getTokenValue: ()=>value,
        getTokenOffset: ()=>tokenOffset,
        getTokenLength: ()=>pos - tokenOffset,
        getTokenStartLine: ()=>lineStartOffset,
        getTokenStartCharacter: ()=>tokenOffset - prevTokenLineStartOffset,
        getTokenError: ()=>scanError
    };
}
function isWhiteSpace(ch) {
    return ch === 32 /* CharacterCodes.space */  || ch === 9 /* CharacterCodes.tab */ ;
}
function isLineBreak(ch) {
    return ch === 10 /* CharacterCodes.lineFeed */  || ch === 13 /* CharacterCodes.carriageReturn */ ;
}
function isDigit(ch) {
    return ch >= 48 /* CharacterCodes._0 */  && ch <= 57 /* CharacterCodes._9 */ ;
}
var CharacterCodes;
(function(CharacterCodes) {
    CharacterCodes[CharacterCodes["lineFeed"] = 10] = "lineFeed";
    CharacterCodes[CharacterCodes["carriageReturn"] = 13] = "carriageReturn";
    CharacterCodes[CharacterCodes["space"] = 32] = "space";
    CharacterCodes[CharacterCodes["_0"] = 48] = "_0";
    CharacterCodes[CharacterCodes["_1"] = 49] = "_1";
    CharacterCodes[CharacterCodes["_2"] = 50] = "_2";
    CharacterCodes[CharacterCodes["_3"] = 51] = "_3";
    CharacterCodes[CharacterCodes["_4"] = 52] = "_4";
    CharacterCodes[CharacterCodes["_5"] = 53] = "_5";
    CharacterCodes[CharacterCodes["_6"] = 54] = "_6";
    CharacterCodes[CharacterCodes["_7"] = 55] = "_7";
    CharacterCodes[CharacterCodes["_8"] = 56] = "_8";
    CharacterCodes[CharacterCodes["_9"] = 57] = "_9";
    CharacterCodes[CharacterCodes["a"] = 97] = "a";
    CharacterCodes[CharacterCodes["b"] = 98] = "b";
    CharacterCodes[CharacterCodes["c"] = 99] = "c";
    CharacterCodes[CharacterCodes["d"] = 100] = "d";
    CharacterCodes[CharacterCodes["e"] = 101] = "e";
    CharacterCodes[CharacterCodes["f"] = 102] = "f";
    CharacterCodes[CharacterCodes["g"] = 103] = "g";
    CharacterCodes[CharacterCodes["h"] = 104] = "h";
    CharacterCodes[CharacterCodes["i"] = 105] = "i";
    CharacterCodes[CharacterCodes["j"] = 106] = "j";
    CharacterCodes[CharacterCodes["k"] = 107] = "k";
    CharacterCodes[CharacterCodes["l"] = 108] = "l";
    CharacterCodes[CharacterCodes["m"] = 109] = "m";
    CharacterCodes[CharacterCodes["n"] = 110] = "n";
    CharacterCodes[CharacterCodes["o"] = 111] = "o";
    CharacterCodes[CharacterCodes["p"] = 112] = "p";
    CharacterCodes[CharacterCodes["q"] = 113] = "q";
    CharacterCodes[CharacterCodes["r"] = 114] = "r";
    CharacterCodes[CharacterCodes["s"] = 115] = "s";
    CharacterCodes[CharacterCodes["t"] = 116] = "t";
    CharacterCodes[CharacterCodes["u"] = 117] = "u";
    CharacterCodes[CharacterCodes["v"] = 118] = "v";
    CharacterCodes[CharacterCodes["w"] = 119] = "w";
    CharacterCodes[CharacterCodes["x"] = 120] = "x";
    CharacterCodes[CharacterCodes["y"] = 121] = "y";
    CharacterCodes[CharacterCodes["z"] = 122] = "z";
    CharacterCodes[CharacterCodes["A"] = 65] = "A";
    CharacterCodes[CharacterCodes["B"] = 66] = "B";
    CharacterCodes[CharacterCodes["C"] = 67] = "C";
    CharacterCodes[CharacterCodes["D"] = 68] = "D";
    CharacterCodes[CharacterCodes["E"] = 69] = "E";
    CharacterCodes[CharacterCodes["F"] = 70] = "F";
    CharacterCodes[CharacterCodes["G"] = 71] = "G";
    CharacterCodes[CharacterCodes["H"] = 72] = "H";
    CharacterCodes[CharacterCodes["I"] = 73] = "I";
    CharacterCodes[CharacterCodes["J"] = 74] = "J";
    CharacterCodes[CharacterCodes["K"] = 75] = "K";
    CharacterCodes[CharacterCodes["L"] = 76] = "L";
    CharacterCodes[CharacterCodes["M"] = 77] = "M";
    CharacterCodes[CharacterCodes["N"] = 78] = "N";
    CharacterCodes[CharacterCodes["O"] = 79] = "O";
    CharacterCodes[CharacterCodes["P"] = 80] = "P";
    CharacterCodes[CharacterCodes["Q"] = 81] = "Q";
    CharacterCodes[CharacterCodes["R"] = 82] = "R";
    CharacterCodes[CharacterCodes["S"] = 83] = "S";
    CharacterCodes[CharacterCodes["T"] = 84] = "T";
    CharacterCodes[CharacterCodes["U"] = 85] = "U";
    CharacterCodes[CharacterCodes["V"] = 86] = "V";
    CharacterCodes[CharacterCodes["W"] = 87] = "W";
    CharacterCodes[CharacterCodes["X"] = 88] = "X";
    CharacterCodes[CharacterCodes["Y"] = 89] = "Y";
    CharacterCodes[CharacterCodes["Z"] = 90] = "Z";
    CharacterCodes[CharacterCodes["asterisk"] = 42] = "asterisk";
    CharacterCodes[CharacterCodes["backslash"] = 92] = "backslash";
    CharacterCodes[CharacterCodes["closeBrace"] = 125] = "closeBrace";
    CharacterCodes[CharacterCodes["closeBracket"] = 93] = "closeBracket";
    CharacterCodes[CharacterCodes["colon"] = 58] = "colon";
    CharacterCodes[CharacterCodes["comma"] = 44] = "comma";
    CharacterCodes[CharacterCodes["dot"] = 46] = "dot";
    CharacterCodes[CharacterCodes["doubleQuote"] = 34] = "doubleQuote";
    CharacterCodes[CharacterCodes["minus"] = 45] = "minus";
    CharacterCodes[CharacterCodes["openBrace"] = 123] = "openBrace";
    CharacterCodes[CharacterCodes["openBracket"] = 91] = "openBracket";
    CharacterCodes[CharacterCodes["plus"] = 43] = "plus";
    CharacterCodes[CharacterCodes["slash"] = 47] = "slash";
    CharacterCodes[CharacterCodes["formFeed"] = 12] = "formFeed";
    CharacterCodes[CharacterCodes["tab"] = 9] = "tab";
})(CharacterCodes || (CharacterCodes = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"24vkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cachedSpaces", ()=>cachedSpaces);
parcelHelpers.export(exports, "cachedBreakLinesWithSpaces", ()=>cachedBreakLinesWithSpaces);
parcelHelpers.export(exports, "supportedEols", ()=>supportedEols);
const cachedSpaces = new Array(20).fill(0).map((_, index)=>{
    return ' '.repeat(index);
});
const maxCachedValues = 200;
const cachedBreakLinesWithSpaces = {
    ' ': {
        '\n': new Array(maxCachedValues).fill(0).map((_, index)=>{
            return '\n' + ' '.repeat(index);
        }),
        '\r': new Array(maxCachedValues).fill(0).map((_, index)=>{
            return '\r' + ' '.repeat(index);
        }),
        '\r\n': new Array(maxCachedValues).fill(0).map((_, index)=>{
            return '\r\n' + ' '.repeat(index);
        })
    },
    '\t': {
        '\n': new Array(maxCachedValues).fill(0).map((_, index)=>{
            return '\n' + '\t'.repeat(index);
        }),
        '\r': new Array(maxCachedValues).fill(0).map((_, index)=>{
            return '\r' + '\t'.repeat(index);
        }),
        '\r\n': new Array(maxCachedValues).fill(0).map((_, index)=>{
            return '\r\n' + '\t'.repeat(index);
        })
    }
};
const supportedEols = [
    '\n',
    '\r',
    '\r\n'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4aAQ8":[function(require,module,exports,__globalThis) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeProperty", ()=>removeProperty);
parcelHelpers.export(exports, "setProperty", ()=>setProperty);
parcelHelpers.export(exports, "applyEdit", ()=>applyEdit);
parcelHelpers.export(exports, "isWS", ()=>isWS);
var _format = require("./format");
var _parser = require("./parser");
'use strict';
function removeProperty(text, path, options) {
    return setProperty(text, path, void 0, options);
}
function setProperty(text, originalPath, value, options) {
    const path = originalPath.slice();
    const errors = [];
    const root = (0, _parser.parseTree)(text, errors);
    let parent = void 0;
    let lastSegment = void 0;
    while(path.length > 0){
        lastSegment = path.pop();
        parent = (0, _parser.findNodeAtLocation)(root, path);
        if (parent === void 0 && value !== void 0) {
            if (typeof lastSegment === 'string') value = {
                [lastSegment]: value
            };
            else value = [
                value
            ];
        } else break;
    }
    if (!parent) {
        // empty document
        if (value === void 0) throw new Error('Can not delete in empty document');
        return withFormatting(text, {
            offset: root ? root.offset : 0,
            length: root ? root.length : 0,
            content: JSON.stringify(value)
        }, options);
    } else if (parent.type === 'object' && typeof lastSegment === 'string' && Array.isArray(parent.children)) {
        const existing = (0, _parser.findNodeAtLocation)(parent, [
            lastSegment
        ]);
        if (existing !== void 0) {
            if (value === void 0) {
                if (!existing.parent) throw new Error('Malformed AST');
                const propertyIndex = parent.children.indexOf(existing.parent);
                let removeBegin;
                let removeEnd = existing.parent.offset + existing.parent.length;
                if (propertyIndex > 0) {
                    // remove the comma of the previous node
                    let previous = parent.children[propertyIndex - 1];
                    removeBegin = previous.offset + previous.length;
                } else {
                    removeBegin = parent.offset + 1;
                    if (parent.children.length > 1) {
                        // remove the comma of the next node
                        let next = parent.children[1];
                        removeEnd = next.offset;
                    }
                }
                return withFormatting(text, {
                    offset: removeBegin,
                    length: removeEnd - removeBegin,
                    content: ''
                }, options);
            } else // set value of existing property
            return withFormatting(text, {
                offset: existing.offset,
                length: existing.length,
                content: JSON.stringify(value)
            }, options);
        } else {
            if (value === void 0) return []; // property does not exist, nothing to do
            const newProperty = `${JSON.stringify(lastSegment)}: ${JSON.stringify(value)}`;
            const index = options.getInsertionIndex ? options.getInsertionIndex(parent.children.map((p)=>p.children[0].value)) : parent.children.length;
            let edit;
            if (index > 0) {
                let previous = parent.children[index - 1];
                edit = {
                    offset: previous.offset + previous.length,
                    length: 0,
                    content: ',' + newProperty
                };
            } else if (parent.children.length === 0) edit = {
                offset: parent.offset + 1,
                length: 0,
                content: newProperty
            };
            else edit = {
                offset: parent.offset + 1,
                length: 0,
                content: newProperty + ','
            };
            return withFormatting(text, edit, options);
        }
    } else if (parent.type === 'array' && typeof lastSegment === 'number' && Array.isArray(parent.children)) {
        const insertIndex = lastSegment;
        if (insertIndex === -1) {
            // Insert
            const newProperty = `${JSON.stringify(value)}`;
            let edit;
            if (parent.children.length === 0) edit = {
                offset: parent.offset + 1,
                length: 0,
                content: newProperty
            };
            else {
                const previous = parent.children[parent.children.length - 1];
                edit = {
                    offset: previous.offset + previous.length,
                    length: 0,
                    content: ',' + newProperty
                };
            }
            return withFormatting(text, edit, options);
        } else if (value === void 0 && parent.children.length >= 0) {
            // Removal
            const removalIndex = lastSegment;
            const toRemove = parent.children[removalIndex];
            let edit;
            if (parent.children.length === 1) // only item
            edit = {
                offset: parent.offset + 1,
                length: parent.length - 2,
                content: ''
            };
            else if (parent.children.length - 1 === removalIndex) {
                // last item
                let previous = parent.children[removalIndex - 1];
                let offset = previous.offset + previous.length;
                let parentEndOffset = parent.offset + parent.length;
                edit = {
                    offset,
                    length: parentEndOffset - 2 - offset,
                    content: ''
                };
            } else edit = {
                offset: toRemove.offset,
                length: parent.children[removalIndex + 1].offset - toRemove.offset,
                content: ''
            };
            return withFormatting(text, edit, options);
        } else if (value !== void 0) {
            let edit;
            const newProperty = `${JSON.stringify(value)}`;
            if (!options.isArrayInsertion && parent.children.length > lastSegment) {
                const toModify = parent.children[lastSegment];
                edit = {
                    offset: toModify.offset,
                    length: toModify.length,
                    content: newProperty
                };
            } else if (parent.children.length === 0 || lastSegment === 0) edit = {
                offset: parent.offset + 1,
                length: 0,
                content: parent.children.length === 0 ? newProperty : newProperty + ','
            };
            else {
                const index = lastSegment > parent.children.length ? parent.children.length : lastSegment;
                const previous = parent.children[index - 1];
                edit = {
                    offset: previous.offset + previous.length,
                    length: 0,
                    content: ',' + newProperty
                };
            }
            return withFormatting(text, edit, options);
        } else throw new Error(`Can not ${value === void 0 ? 'remove' : options.isArrayInsertion ? 'insert' : 'modify'} Array index ${insertIndex} as length is not sufficient`);
    } else throw new Error(`Can not add ${typeof lastSegment !== 'number' ? 'index' : 'property'} to parent of type ${parent.type}`);
}
function withFormatting(text, edit, options) {
    if (!options.formattingOptions) return [
        edit
    ];
    // apply the edit
    let newText = applyEdit(text, edit);
    // format the new text
    let begin = edit.offset;
    let end = edit.offset + edit.content.length;
    if (edit.length === 0 || edit.content.length === 0) {
        while(begin > 0 && !(0, _format.isEOL)(newText, begin - 1))begin--;
        while(end < newText.length && !(0, _format.isEOL)(newText, end))end++;
    }
    const edits = (0, _format.format)(newText, {
        offset: begin,
        length: end - begin
    }, {
        ...options.formattingOptions,
        keepLines: false
    });
    // apply the formatting edits and track the begin and end offsets of the changes
    for(let i = edits.length - 1; i >= 0; i--){
        const edit = edits[i];
        newText = applyEdit(newText, edit);
        begin = Math.min(begin, edit.offset);
        end = Math.max(end, edit.offset + edit.length);
        end += edit.content.length - edit.length;
    }
    // create a single edit with all changes
    const editLength = text.length - (newText.length - end) - begin;
    return [
        {
            offset: begin,
            length: editLength,
            content: newText.substring(begin, end)
        }
    ];
}
function applyEdit(text, edit) {
    return text.substring(0, edit.offset) + edit.content + text.substring(edit.offset + edit.length);
}
function isWS(text, offset) {
    return '\r\n \t'.indexOf(text.charAt(offset)) !== -1;
}

},{"./format":"6CYcR","./parser":"7XFj5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7XFj5":[function(require,module,exports,__globalThis) {
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * For a given offset, evaluate the location in the JSON document. Each segment in the location path is either a property name or an array index.
 */ parcelHelpers.export(exports, "getLocation", ()=>getLocation);
/**
 * Parses the given text and returns the object the JSON content represents. On invalid input, the parser tries to be as fault tolerant as possible, but still return a result.
 * Therefore always check the errors list to find out if the input was valid.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Parses the given text and returns a tree representation the JSON content. On invalid input, the parser tries to be as fault tolerant as possible, but still return a result.
 */ parcelHelpers.export(exports, "parseTree", ()=>parseTree);
/**
 * Finds the node at the given path in a JSON DOM.
 */ parcelHelpers.export(exports, "findNodeAtLocation", ()=>findNodeAtLocation);
/**
 * Gets the JSON path of the given JSON DOM node
 */ parcelHelpers.export(exports, "getNodePath", ()=>getNodePath);
/**
 * Evaluates the JavaScript object of the given JSON DOM node
 */ parcelHelpers.export(exports, "getNodeValue", ()=>getNodeValue);
parcelHelpers.export(exports, "contains", ()=>contains);
/**
 * Finds the most inner node at the given offset. If includeRightBound is set, also finds nodes that end at the given offset.
 */ parcelHelpers.export(exports, "findNodeAtOffset", ()=>findNodeAtOffset);
/**
 * Parses the given text and invokes the visitor functions for each object, array and literal reached.
 */ parcelHelpers.export(exports, "visit", ()=>visit);
/**
 * Takes JSON with JavaScript-style comments and remove
 * them. Optionally replaces every none-newline character
 * of comments with a replaceCharacter
 */ parcelHelpers.export(exports, "stripComments", ()=>stripComments);
parcelHelpers.export(exports, "getNodeType", ()=>getNodeType);
var _scanner = require("./scanner");
'use strict';
var ParseOptions;
(function(ParseOptions) {
    ParseOptions.DEFAULT = {
        allowTrailingComma: false
    };
})(ParseOptions || (ParseOptions = {}));
function getLocation(text, position) {
    const segments = []; // strings or numbers
    const earlyReturnException = new Object();
    let previousNode = undefined;
    const previousNodeInst = {
        value: {},
        offset: 0,
        length: 0,
        type: 'object',
        parent: undefined
    };
    let isAtPropertyKey = false;
    function setPreviousNode(value, offset, length, type) {
        previousNodeInst.value = value;
        previousNodeInst.offset = offset;
        previousNodeInst.length = length;
        previousNodeInst.type = type;
        previousNodeInst.colonOffset = undefined;
        previousNode = previousNodeInst;
    }
    try {
        visit(text, {
            onObjectBegin: (offset, length)=>{
                if (position <= offset) throw earlyReturnException;
                previousNode = undefined;
                isAtPropertyKey = position > offset;
                segments.push(''); // push a placeholder (will be replaced)
            },
            onObjectProperty: (name, offset, length)=>{
                if (position < offset) throw earlyReturnException;
                setPreviousNode(name, offset, length, 'property');
                segments[segments.length - 1] = name;
                if (position <= offset + length) throw earlyReturnException;
            },
            onObjectEnd: (offset, length)=>{
                if (position <= offset) throw earlyReturnException;
                previousNode = undefined;
                segments.pop();
            },
            onArrayBegin: (offset, length)=>{
                if (position <= offset) throw earlyReturnException;
                previousNode = undefined;
                segments.push(0);
            },
            onArrayEnd: (offset, length)=>{
                if (position <= offset) throw earlyReturnException;
                previousNode = undefined;
                segments.pop();
            },
            onLiteralValue: (value, offset, length)=>{
                if (position < offset) throw earlyReturnException;
                setPreviousNode(value, offset, length, getNodeType(value));
                if (position <= offset + length) throw earlyReturnException;
            },
            onSeparator: (sep, offset, length)=>{
                if (position <= offset) throw earlyReturnException;
                if (sep === ':' && previousNode && previousNode.type === 'property') {
                    previousNode.colonOffset = offset;
                    isAtPropertyKey = false;
                    previousNode = undefined;
                } else if (sep === ',') {
                    const last = segments[segments.length - 1];
                    if (typeof last === 'number') segments[segments.length - 1] = last + 1;
                    else {
                        isAtPropertyKey = true;
                        segments[segments.length - 1] = '';
                    }
                    previousNode = undefined;
                }
            }
        });
    } catch (e) {
        if (e !== earlyReturnException) throw e;
    }
    return {
        path: segments,
        previousNode,
        isAtPropertyKey,
        matches: (pattern)=>{
            let k = 0;
            for(let i = 0; k < pattern.length && i < segments.length; i++){
                if (pattern[k] === segments[i] || pattern[k] === '*') k++;
                else if (pattern[k] !== '**') return false;
            }
            return k === pattern.length;
        }
    };
}
function parse(text, errors = [], options = ParseOptions.DEFAULT) {
    let currentProperty = null;
    let currentParent = [];
    const previousParents = [];
    function onValue(value) {
        if (Array.isArray(currentParent)) currentParent.push(value);
        else if (currentProperty !== null) currentParent[currentProperty] = value;
    }
    const visitor = {
        onObjectBegin: ()=>{
            const object = {};
            onValue(object);
            previousParents.push(currentParent);
            currentParent = object;
            currentProperty = null;
        },
        onObjectProperty: (name)=>{
            currentProperty = name;
        },
        onObjectEnd: ()=>{
            currentParent = previousParents.pop();
        },
        onArrayBegin: ()=>{
            const array = [];
            onValue(array);
            previousParents.push(currentParent);
            currentParent = array;
            currentProperty = null;
        },
        onArrayEnd: ()=>{
            currentParent = previousParents.pop();
        },
        onLiteralValue: onValue,
        onError: (error, offset, length)=>{
            errors.push({
                error,
                offset,
                length
            });
        }
    };
    visit(text, visitor, options);
    return currentParent[0];
}
function parseTree(text, errors = [], options = ParseOptions.DEFAULT) {
    let currentParent = {
        type: 'array',
        offset: -1,
        length: -1,
        children: [],
        parent: undefined
    }; // artificial root
    function ensurePropertyComplete(endOffset) {
        if (currentParent.type === 'property') {
            currentParent.length = endOffset - currentParent.offset;
            currentParent = currentParent.parent;
        }
    }
    function onValue(valueNode) {
        currentParent.children.push(valueNode);
        return valueNode;
    }
    const visitor = {
        onObjectBegin: (offset)=>{
            currentParent = onValue({
                type: 'object',
                offset,
                length: -1,
                parent: currentParent,
                children: []
            });
        },
        onObjectProperty: (name, offset, length)=>{
            currentParent = onValue({
                type: 'property',
                offset,
                length: -1,
                parent: currentParent,
                children: []
            });
            currentParent.children.push({
                type: 'string',
                value: name,
                offset,
                length,
                parent: currentParent
            });
        },
        onObjectEnd: (offset, length)=>{
            ensurePropertyComplete(offset + length); // in case of a missing value for a property: make sure property is complete
            currentParent.length = offset + length - currentParent.offset;
            currentParent = currentParent.parent;
            ensurePropertyComplete(offset + length);
        },
        onArrayBegin: (offset, length)=>{
            currentParent = onValue({
                type: 'array',
                offset,
                length: -1,
                parent: currentParent,
                children: []
            });
        },
        onArrayEnd: (offset, length)=>{
            currentParent.length = offset + length - currentParent.offset;
            currentParent = currentParent.parent;
            ensurePropertyComplete(offset + length);
        },
        onLiteralValue: (value, offset, length)=>{
            onValue({
                type: getNodeType(value),
                offset,
                length,
                parent: currentParent,
                value
            });
            ensurePropertyComplete(offset + length);
        },
        onSeparator: (sep, offset, length)=>{
            if (currentParent.type === 'property') {
                if (sep === ':') currentParent.colonOffset = offset;
                else if (sep === ',') ensurePropertyComplete(offset);
            }
        },
        onError: (error, offset, length)=>{
            errors.push({
                error,
                offset,
                length
            });
        }
    };
    visit(text, visitor, options);
    const result = currentParent.children[0];
    if (result) delete result.parent;
    return result;
}
function findNodeAtLocation(root, path) {
    if (!root) return undefined;
    let node = root;
    for (let segment of path)if (typeof segment === 'string') {
        if (node.type !== 'object' || !Array.isArray(node.children)) return undefined;
        let found = false;
        for (const propertyNode of node.children)if (Array.isArray(propertyNode.children) && propertyNode.children[0].value === segment && propertyNode.children.length === 2) {
            node = propertyNode.children[1];
            found = true;
            break;
        }
        if (!found) return undefined;
    } else {
        const index = segment;
        if (node.type !== 'array' || index < 0 || !Array.isArray(node.children) || index >= node.children.length) return undefined;
        node = node.children[index];
    }
    return node;
}
function getNodePath(node) {
    if (!node.parent || !node.parent.children) return [];
    const path = getNodePath(node.parent);
    if (node.parent.type === 'property') {
        const key = node.parent.children[0].value;
        path.push(key);
    } else if (node.parent.type === 'array') {
        const index = node.parent.children.indexOf(node);
        if (index !== -1) path.push(index);
    }
    return path;
}
function getNodeValue(node) {
    switch(node.type){
        case 'array':
            return node.children.map(getNodeValue);
        case 'object':
            const obj = Object.create(null);
            for (let prop of node.children){
                const valueNode = prop.children[1];
                if (valueNode) obj[prop.children[0].value] = getNodeValue(valueNode);
            }
            return obj;
        case 'null':
        case 'string':
        case 'number':
        case 'boolean':
            return node.value;
        default:
            return undefined;
    }
}
function contains(node, offset, includeRightBound = false) {
    return offset >= node.offset && offset < node.offset + node.length || includeRightBound && offset === node.offset + node.length;
}
function findNodeAtOffset(node, offset, includeRightBound = false) {
    if (contains(node, offset, includeRightBound)) {
        const children = node.children;
        if (Array.isArray(children)) for(let i = 0; i < children.length && children[i].offset <= offset; i++){
            const item = findNodeAtOffset(children[i], offset, includeRightBound);
            if (item) return item;
        }
        return node;
    }
    return undefined;
}
function visit(text, visitor, options = ParseOptions.DEFAULT) {
    const _scanner1 = (0, _scanner.createScanner)(text, false);
    // Important: Only pass copies of this to visitor functions to prevent accidental modification, and
    // to not affect visitor functions which stored a reference to a previous JSONPath
    const _jsonPath = [];
    // Depth of onXXXBegin() callbacks suppressed. onXXXEnd() decrements this if it isn't 0 already.
    // Callbacks are only called when this value is 0.
    let suppressedCallbacks = 0;
    function toNoArgVisit(visitFunction) {
        return visitFunction ? ()=>suppressedCallbacks === 0 && visitFunction(_scanner1.getTokenOffset(), _scanner1.getTokenLength(), _scanner1.getTokenStartLine(), _scanner1.getTokenStartCharacter()) : ()=>true;
    }
    function toOneArgVisit(visitFunction) {
        return visitFunction ? (arg)=>suppressedCallbacks === 0 && visitFunction(arg, _scanner1.getTokenOffset(), _scanner1.getTokenLength(), _scanner1.getTokenStartLine(), _scanner1.getTokenStartCharacter()) : ()=>true;
    }
    function toOneArgVisitWithPath(visitFunction) {
        return visitFunction ? (arg)=>suppressedCallbacks === 0 && visitFunction(arg, _scanner1.getTokenOffset(), _scanner1.getTokenLength(), _scanner1.getTokenStartLine(), _scanner1.getTokenStartCharacter(), ()=>_jsonPath.slice()) : ()=>true;
    }
    function toBeginVisit(visitFunction) {
        return visitFunction ? ()=>{
            if (suppressedCallbacks > 0) suppressedCallbacks++;
            else {
                let cbReturn = visitFunction(_scanner1.getTokenOffset(), _scanner1.getTokenLength(), _scanner1.getTokenStartLine(), _scanner1.getTokenStartCharacter(), ()=>_jsonPath.slice());
                if (cbReturn === false) suppressedCallbacks = 1;
            }
        } : ()=>true;
    }
    function toEndVisit(visitFunction) {
        return visitFunction ? ()=>{
            if (suppressedCallbacks > 0) suppressedCallbacks--;
            if (suppressedCallbacks === 0) visitFunction(_scanner1.getTokenOffset(), _scanner1.getTokenLength(), _scanner1.getTokenStartLine(), _scanner1.getTokenStartCharacter());
        } : ()=>true;
    }
    const onObjectBegin = toBeginVisit(visitor.onObjectBegin), onObjectProperty = toOneArgVisitWithPath(visitor.onObjectProperty), onObjectEnd = toEndVisit(visitor.onObjectEnd), onArrayBegin = toBeginVisit(visitor.onArrayBegin), onArrayEnd = toEndVisit(visitor.onArrayEnd), onLiteralValue = toOneArgVisitWithPath(visitor.onLiteralValue), onSeparator = toOneArgVisit(visitor.onSeparator), onComment = toNoArgVisit(visitor.onComment), onError = toOneArgVisit(visitor.onError);
    const disallowComments = options && options.disallowComments;
    const allowTrailingComma = options && options.allowTrailingComma;
    function scanNext() {
        while(true){
            const token = _scanner1.scan();
            switch(_scanner1.getTokenError()){
                case 4 /* ScanError.InvalidUnicode */ :
                    handleError(14 /* ParseErrorCode.InvalidUnicode */ );
                    break;
                case 5 /* ScanError.InvalidEscapeCharacter */ :
                    handleError(15 /* ParseErrorCode.InvalidEscapeCharacter */ );
                    break;
                case 3 /* ScanError.UnexpectedEndOfNumber */ :
                    handleError(13 /* ParseErrorCode.UnexpectedEndOfNumber */ );
                    break;
                case 1 /* ScanError.UnexpectedEndOfComment */ :
                    if (!disallowComments) handleError(11 /* ParseErrorCode.UnexpectedEndOfComment */ );
                    break;
                case 2 /* ScanError.UnexpectedEndOfString */ :
                    handleError(12 /* ParseErrorCode.UnexpectedEndOfString */ );
                    break;
                case 6 /* ScanError.InvalidCharacter */ :
                    handleError(16 /* ParseErrorCode.InvalidCharacter */ );
                    break;
            }
            switch(token){
                case 12 /* SyntaxKind.LineCommentTrivia */ :
                case 13 /* SyntaxKind.BlockCommentTrivia */ :
                    if (disallowComments) handleError(10 /* ParseErrorCode.InvalidCommentToken */ );
                    else onComment();
                    break;
                case 16 /* SyntaxKind.Unknown */ :
                    handleError(1 /* ParseErrorCode.InvalidSymbol */ );
                    break;
                case 15 /* SyntaxKind.Trivia */ :
                case 14 /* SyntaxKind.LineBreakTrivia */ :
                    break;
                default:
                    return token;
            }
        }
    }
    function handleError(error, skipUntilAfter = [], skipUntil = []) {
        onError(error);
        if (skipUntilAfter.length + skipUntil.length > 0) {
            let token = _scanner1.getToken();
            while(token !== 17 /* SyntaxKind.EOF */ ){
                if (skipUntilAfter.indexOf(token) !== -1) {
                    scanNext();
                    break;
                } else if (skipUntil.indexOf(token) !== -1) break;
                token = scanNext();
            }
        }
    }
    function parseString(isValue) {
        const value = _scanner1.getTokenValue();
        if (isValue) onLiteralValue(value);
        else {
            onObjectProperty(value);
            // add property name afterwards
            _jsonPath.push(value);
        }
        scanNext();
        return true;
    }
    function parseLiteral() {
        switch(_scanner1.getToken()){
            case 11 /* SyntaxKind.NumericLiteral */ :
                const tokenValue = _scanner1.getTokenValue();
                let value = Number(tokenValue);
                if (isNaN(value)) {
                    handleError(2 /* ParseErrorCode.InvalidNumberFormat */ );
                    value = 0;
                }
                onLiteralValue(value);
                break;
            case 7 /* SyntaxKind.NullKeyword */ :
                onLiteralValue(null);
                break;
            case 8 /* SyntaxKind.TrueKeyword */ :
                onLiteralValue(true);
                break;
            case 9 /* SyntaxKind.FalseKeyword */ :
                onLiteralValue(false);
                break;
            default:
                return false;
        }
        scanNext();
        return true;
    }
    function parseProperty() {
        if (_scanner1.getToken() !== 10 /* SyntaxKind.StringLiteral */ ) {
            handleError(3 /* ParseErrorCode.PropertyNameExpected */ , [], [
                2 /* SyntaxKind.CloseBraceToken */ ,
                5 /* SyntaxKind.CommaToken */ 
            ]);
            return false;
        }
        parseString(false);
        if (_scanner1.getToken() === 6 /* SyntaxKind.ColonToken */ ) {
            onSeparator(':');
            scanNext(); // consume colon
            if (!parseValue()) handleError(4 /* ParseErrorCode.ValueExpected */ , [], [
                2 /* SyntaxKind.CloseBraceToken */ ,
                5 /* SyntaxKind.CommaToken */ 
            ]);
        } else handleError(5 /* ParseErrorCode.ColonExpected */ , [], [
            2 /* SyntaxKind.CloseBraceToken */ ,
            5 /* SyntaxKind.CommaToken */ 
        ]);
        _jsonPath.pop(); // remove processed property name
        return true;
    }
    function parseObject() {
        onObjectBegin();
        scanNext(); // consume open brace
        let needsComma = false;
        while(_scanner1.getToken() !== 2 /* SyntaxKind.CloseBraceToken */  && _scanner1.getToken() !== 17 /* SyntaxKind.EOF */ ){
            if (_scanner1.getToken() === 5 /* SyntaxKind.CommaToken */ ) {
                if (!needsComma) handleError(4 /* ParseErrorCode.ValueExpected */ , [], []);
                onSeparator(',');
                scanNext(); // consume comma
                if (_scanner1.getToken() === 2 /* SyntaxKind.CloseBraceToken */  && allowTrailingComma) break;
            } else if (needsComma) handleError(6 /* ParseErrorCode.CommaExpected */ , [], []);
            if (!parseProperty()) handleError(4 /* ParseErrorCode.ValueExpected */ , [], [
                2 /* SyntaxKind.CloseBraceToken */ ,
                5 /* SyntaxKind.CommaToken */ 
            ]);
            needsComma = true;
        }
        onObjectEnd();
        if (_scanner1.getToken() !== 2 /* SyntaxKind.CloseBraceToken */ ) handleError(7 /* ParseErrorCode.CloseBraceExpected */ , [
            2 /* SyntaxKind.CloseBraceToken */ 
        ], []);
        else scanNext(); // consume close brace
        return true;
    }
    function parseArray() {
        onArrayBegin();
        scanNext(); // consume open bracket
        let isFirstElement = true;
        let needsComma = false;
        while(_scanner1.getToken() !== 4 /* SyntaxKind.CloseBracketToken */  && _scanner1.getToken() !== 17 /* SyntaxKind.EOF */ ){
            if (_scanner1.getToken() === 5 /* SyntaxKind.CommaToken */ ) {
                if (!needsComma) handleError(4 /* ParseErrorCode.ValueExpected */ , [], []);
                onSeparator(',');
                scanNext(); // consume comma
                if (_scanner1.getToken() === 4 /* SyntaxKind.CloseBracketToken */  && allowTrailingComma) break;
            } else if (needsComma) handleError(6 /* ParseErrorCode.CommaExpected */ , [], []);
            if (isFirstElement) {
                _jsonPath.push(0);
                isFirstElement = false;
            } else _jsonPath[_jsonPath.length - 1]++;
            if (!parseValue()) handleError(4 /* ParseErrorCode.ValueExpected */ , [], [
                4 /* SyntaxKind.CloseBracketToken */ ,
                5 /* SyntaxKind.CommaToken */ 
            ]);
            needsComma = true;
        }
        onArrayEnd();
        if (!isFirstElement) _jsonPath.pop(); // remove array index
        if (_scanner1.getToken() !== 4 /* SyntaxKind.CloseBracketToken */ ) handleError(8 /* ParseErrorCode.CloseBracketExpected */ , [
            4 /* SyntaxKind.CloseBracketToken */ 
        ], []);
        else scanNext(); // consume close bracket
        return true;
    }
    function parseValue() {
        switch(_scanner1.getToken()){
            case 3 /* SyntaxKind.OpenBracketToken */ :
                return parseArray();
            case 1 /* SyntaxKind.OpenBraceToken */ :
                return parseObject();
            case 10 /* SyntaxKind.StringLiteral */ :
                return parseString(true);
            default:
                return parseLiteral();
        }
    }
    scanNext();
    if (_scanner1.getToken() === 17 /* SyntaxKind.EOF */ ) {
        if (options.allowEmptyContent) return true;
        handleError(4 /* ParseErrorCode.ValueExpected */ , [], []);
        return false;
    }
    if (!parseValue()) {
        handleError(4 /* ParseErrorCode.ValueExpected */ , [], []);
        return false;
    }
    if (_scanner1.getToken() !== 17 /* SyntaxKind.EOF */ ) handleError(9 /* ParseErrorCode.EndOfFileExpected */ , [], []);
    return true;
}
function stripComments(text, replaceCh) {
    let _scanner1 = (0, _scanner.createScanner)(text), parts = [], kind, offset = 0, pos;
    do {
        pos = _scanner1.getPosition();
        kind = _scanner1.scan();
        switch(kind){
            case 12 /* SyntaxKind.LineCommentTrivia */ :
            case 13 /* SyntaxKind.BlockCommentTrivia */ :
            case 17 /* SyntaxKind.EOF */ :
                if (offset !== pos) parts.push(text.substring(offset, pos));
                if (replaceCh !== undefined) parts.push(_scanner1.getTokenValue().replace(/[^\r\n]/g, replaceCh));
                offset = _scanner1.getPosition();
                break;
        }
    }while (kind !== 17 /* SyntaxKind.EOF */ );
    return parts.join('');
}
function getNodeType(value) {
    switch(typeof value){
        case 'boolean':
            return 'boolean';
        case 'number':
            return 'number';
        case 'string':
            return 'string';
        case 'object':
            if (!value) return 'null';
            else if (Array.isArray(value)) return 'array';
            return 'object';
        default:
            return 'null';
    }
}

},{"./scanner":"29mzA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jr1nI":[function(require,module,exports,__globalThis) {
/**
 * Adds markdownDescription props to a schema. See https://github.com/Microsoft/monaco-editor/issues/885
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMarkdownProps);
function addMarkdownProps(value) {
    if (typeof value === 'object' && value !== null) {
        if (value.description) value.markdownDescription = value.description;
        for(const key in value)if (value.hasOwnProperty(key)) value[key] = addMarkdownProps(value[key]);
    }
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ifxp5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"$ref":"#/definitions/TopLevelSpec","$schema":"http://json-schema.org/draft-07/schema#","definitions":{"Aggregate":{"anyOf":[{"$ref":"#/definitions/NonArgAggregateOp"},{"$ref":"#/definitions/ArgmaxDef"},{"$ref":"#/definitions/ArgminDef"}]},"AggregateOp":{"enum":["argmax","argmin","average","count","distinct","max","mean","median","min","missing","product","q1","q3","ci0","ci1","stderr","stdev","stdevp","sum","valid","values","variance","variancep","exponential","exponentialb"],"type":"string"},"AggregateTransform":{"additionalProperties":false,"properties":{"aggregate":{"description":"Array of objects that define fields to aggregate.","items":{"$ref":"#/definitions/AggregatedFieldDef"},"type":"array"},"groupby":{"description":"The data fields to group by. If not specified, a single group containing all data objects will be used.","items":{"$ref":"#/definitions/FieldName"},"type":"array"}},"required":["aggregate"],"type":"object"},"AggregatedFieldDef":{"additionalProperties":false,"properties":{"as":{"$ref":"#/definitions/FieldName","description":"The output field names to use for each aggregated field."},"field":{"$ref":"#/definitions/FieldName","description":"The data field for which to compute aggregate function. This is required for all aggregation operations except `\\"count\\"`."},"op":{"$ref":"#/definitions/AggregateOp","description":"The aggregation operation to apply to the fields (e.g., `\\"sum\\"`, `\\"average\\"`, or `\\"count\\"`). See the [full list of supported aggregation operations](https://vega.github.io/vega-lite/docs/aggregate.html#ops) for more information."}},"required":["op","as"],"type":"object"},"Align":{"enum":["left","center","right"],"type":"string"},"AllSortString":{"anyOf":[{"$ref":"#/definitions/SortOrder"},{"$ref":"#/definitions/SortByChannel"},{"$ref":"#/definitions/SortByChannelDesc"}]},"AnyMark":{"anyOf":[{"$ref":"#/definitions/CompositeMark"},{"$ref":"#/definitions/CompositeMarkDef"},{"$ref":"#/definitions/Mark"},{"$ref":"#/definitions/MarkDef"}]},"AnyMarkConfig":{"anyOf":[{"$ref":"#/definitions/MarkConfig"},{"$ref":"#/definitions/AreaConfig"},{"$ref":"#/definitions/BarConfig"},{"$ref":"#/definitions/RectConfig"},{"$ref":"#/definitions/LineConfig"},{"$ref":"#/definitions/TickConfig"}]},"AreaConfig":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"line":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/OverlayMarkDef"}],"description":"A flag for overlaying line on top of area marks, or an object defining the properties of the overlayed lines.\\n\\n- If this value is an empty object (`{}`) or `true`, lines with default properties will be used.\\n\\n- If this value is `false`, no lines would be automatically added to area marks.\\n\\n__Default value:__ `false`."},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"point":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/OverlayMarkDef"},{"const":"transparent","type":"string"}],"description":"A flag for overlaying points on top of line or area marks, or an object defining the properties of the overlayed points.\\n\\n- If this property is `\\"transparent\\"`, transparent points will be used (for enhancing tooltips and selections).\\n\\n- If this property is an empty object (`{}`) or `true`, filled points with default properties will be used.\\n\\n- If this property is `false`, no points would be automatically added to line or area marks.\\n\\n__Default value:__ `false`."},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"ArgmaxDef":{"additionalProperties":false,"properties":{"argmax":{"$ref":"#/definitions/FieldName"}},"required":["argmax"],"type":"object"},"ArgminDef":{"additionalProperties":false,"properties":{"argmin":{"$ref":"#/definitions/FieldName"}},"required":["argmin"],"type":"object"},"AutoSizeParams":{"additionalProperties":false,"properties":{"contains":{"description":"Determines how size calculation should be performed, one of `\\"content\\"` or `\\"padding\\"`. The default setting (`\\"content\\"`) interprets the width and height settings as the data rectangle (plotting) dimensions, to which padding is then added. In contrast, the `\\"padding\\"` setting includes the padding within the view size calculations, such that the width and height settings indicate the **total** intended size of the view.\\n\\n__Default value__: `\\"content\\"`","enum":["content","padding"],"type":"string"},"resize":{"description":"A boolean flag indicating if autosize layout should be re-calculated on every view update.\\n\\n__Default value__: `false`","type":"boolean"},"type":{"$ref":"#/definitions/AutosizeType","description":"The sizing format type. One of `\\"pad\\"`, `\\"fit\\"`, `\\"fit-x\\"`, `\\"fit-y\\"`,  or `\\"none\\"`. See the [autosize type](https://vega.github.io/vega-lite/docs/size.html#autosize) documentation for descriptions of each.\\n\\n__Default value__: `\\"pad\\"`"}},"type":"object"},"AutosizeType":{"enum":["pad","none","fit","fit-x","fit-y"],"type":"string"},"Axis":{"additionalProperties":false,"properties":{"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG group, removing the axis from the ARIA accessibility tree.\\n\\n__Default value:__ `true`","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"bandPosition":{"anyOf":[{"description":"An interpolation fraction indicating where, for `band` scales, axis ticks should be positioned. A value of `0` places ticks at the left edge of their bands. A value of `0.5` places ticks in the middle of their bands.\\n\\n __Default value:__ `0.5`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of this axis for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If the `aria` property is true, for SVG output the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute) will be set to this description. If the description is unspecified it will be automatically generated.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"domain":{"description":"A boolean flag indicating if the domain (the axis baseline) should be included as part of the axis.\\n\\n__Default value:__ `true`","type":"boolean"},"domainCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for the domain line\'s ending style. One of `\\"butt\\"`, `\\"round\\"` or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"domainColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Color of axis domain line.\\n\\n__Default value:__ `\\"gray\\"`."},{"$ref":"#/definitions/ExprRef"}]},"domainDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed domain lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"domainDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the domain dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"domainOpacity":{"anyOf":[{"description":"Opacity of the axis domain line.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"domainWidth":{"anyOf":[{"description":"Stroke width of axis domain line\\n\\n__Default value:__ `1`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"grid":{"description":"A boolean flag indicating if grid lines should be included as part of the axis\\n\\n__Default value:__ `true` for [continuous scales](https://vega.github.io/vega-lite/docs/scale.html#continuous) that are not binned; otherwise, `false`.","type":"boolean"},"gridCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for grid lines\' ending style. One of `\\"butt\\"`, `\\"round\\"` or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"gridColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Color of gridlines.\\n\\n__Default value:__ `\\"lightGray\\"`."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisColor"}]},"gridDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed grid lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumberArray"}]},"gridDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the grid dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"gridOpacity":{"anyOf":[{"description":"The stroke opacity of grid (value between [0,1])\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"gridWidth":{"anyOf":[{"description":"The grid width, in pixels.\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"Horizontal text alignment of axis tick labels, overriding the default setting for the current axis orientation."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelAlign"}]},"labelAngle":{"anyOf":[{"description":"The rotation angle of the axis labels.\\n\\n__Default value:__ `-90` for nominal and ordinal fields; `0` otherwise.","maximum":360,"minimum":-360,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline of axis tick labels, overriding the default setting for the current axis orientation. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelBaseline"}]},"labelBound":{"anyOf":[{"description":"Indicates if labels should be hidden if they exceed the axis range. If `false` (the default) no bounds overlap analysis is performed. If `true`, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.\\n\\n__Default value:__ `false`.","type":["number","boolean"]},{"$ref":"#/definitions/ExprRef"}]},"labelColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the tick label, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisColor"}]},"labelExpr":{"description":"[Vega expression](https://vega.github.io/vega/docs/expressions/) for customizing labels.\\n\\n__Note:__ The label text and value can be assessed via the `label` and `value` properties of the axis\'s backing `datum` object.","type":"string"},"labelFlush":{"description":"Indicates if the first and last axis labels should be aligned flush with the scale range. Flush alignment for a horizontal axis will left-align the first label and right-align the last label. For vertical axes, bottom and top text baselines are applied instead. If this property is a number, it also indicates the number of pixels by which to offset the first and last labels; for example, a value of 2 will flush-align the first and last labels and also push them 2 pixels outward from the center of the axis. The additional adjustment can sometimes help the labels better visually group with corresponding axis ticks.\\n\\n__Default value:__ `true` for axis of a continuous x-scale. Otherwise, `false`.","type":["boolean","number"]},"labelFlushOffset":{"anyOf":[{"description":"Indicates the number of pixels by which to offset flush-adjusted labels. For example, a value of `2` will push flush-adjusted labels 2 pixels outward from the center of the axis. Offsets can help the labels better visually group with corresponding axis ticks.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelFont":{"anyOf":[{"description":"The font of the tick label.","type":"string"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisString"}]},"labelFontSize":{"anyOf":[{"description":"The font size of the label, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style of the title."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelFontStyle"}]},"labelFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight of axis tick labels."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelFontWeight"}]},"labelLimit":{"anyOf":[{"description":"Maximum allowed pixel width of axis tick labels.\\n\\n__Default value:__ `180`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line label text or label text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOffset":{"anyOf":[{"description":"Position offset in pixels to apply to labels, in addition to tickOffset.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelOpacity":{"anyOf":[{"description":"The opacity of the labels.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelOverlap":{"anyOf":[{"$ref":"#/definitions/LabelOverlap"},{"$ref":"#/definitions/ExprRef"}],"description":"The strategy to use for resolving overlap of axis labels. If `false` (the default), no overlap reduction is attempted. If set to `true` or `\\"parity\\"`, a strategy of removing every other label is used (this works well for standard linear axes). If set to `\\"greedy\\"`, a linear scan of the labels is performed, removing any labels that overlaps with the last visible label (this often works better for log-scaled axes).\\n\\n__Default value:__ `true` for non-nominal fields with non-log scales; `\\"greedy\\"` for log scales; otherwise `false`."},"labelPadding":{"anyOf":[{"description":"The padding in pixels between labels and ticks.\\n\\n__Default value:__ `2`","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelSeparation":{"anyOf":[{"description":"The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default `0`). This property is ignored if *labelOverlap* resolution is not enabled.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labels":{"description":"A boolean flag indicating if labels should be included as part of the axis.\\n\\n__Default value:__ `true`.","type":"boolean"},"maxExtent":{"anyOf":[{"description":"The maximum extent in pixels that axis ticks and labels should use. This determines a maximum offset value for axis titles.\\n\\n__Default value:__ `undefined`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"minExtent":{"anyOf":[{"description":"The minimum extent in pixels that axis ticks and labels should use. This determines a minimum offset value for axis titles.\\n\\n__Default value:__ `30` for y-axis; `undefined` for x-axis.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The offset, in pixels, by which to displace the axis from the edge of the enclosing group or data rectangle.\\n\\n__Default value:__ derived from the [axis config](https://vega.github.io/vega-lite/docs/config.html#facet-scale-config)\'s `offset` (`0` by default)"},"orient":{"anyOf":[{"$ref":"#/definitions/AxisOrient"},{"$ref":"#/definitions/ExprRef"}],"description":"The orientation of the axis. One of `\\"top\\"`, `\\"bottom\\"`, `\\"left\\"` or `\\"right\\"`. The orientation can be used to further specialize the axis type (e.g., a y-axis oriented towards the right edge of the chart).\\n\\n__Default value:__ `\\"bottom\\"` for x-axes and `\\"left\\"` for y-axes."},"position":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The anchor position of the axis in pixels. For x-axes with top or bottom orientation, this sets the axis group x coordinate. For y-axes with left or right orientation, this sets the axis group y coordinate.\\n\\n__Default value__: `0`"},"style":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}],"description":"A string or array of strings indicating the name of custom styles to apply to the axis. A style is a named collection of axis property defined within the [style configuration](https://vega.github.io/vega-lite/docs/mark.html#style-config). If style is an array, later styles will override earlier styles.\\n\\n__Default value:__ (none) __Note:__ Any specified style will augment the default style. For example, an x-axis mark with `\\"style\\": \\"foo\\"` will use `config.axisX` and `config.style.foo` (the specified style `\\"foo\\"` has higher precedence)."},"tickBand":{"anyOf":[{"description":"For band scales, indicates if ticks and grid lines should be placed at the `\\"center\\"` of a band (default) or at the band `\\"extent\\"`s to indicate intervals","enum":["center","extent"],"type":"string"},{"$ref":"#/definitions/ExprRef"}]},"tickCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for the tick lines\' ending style. One of `\\"butt\\"`, `\\"round\\"` or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"tickColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the axis\'s tick.\\n\\n__Default value:__ `\\"gray\\"`"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisColor"}]},"tickCount":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/TimeInterval"},{"$ref":"#/definitions/TimeIntervalStep"},{"$ref":"#/definitions/ExprRef"}],"description":"A desired number of ticks, for axes visualizing quantitative scales. The resulting number may be different so that values are \\"nice\\" (multiples of 2, 5, 10) and lie within the underlying scale\'s range.\\n\\nFor scales of type `\\"time\\"` or `\\"utc\\"`, the tick count can instead be a time interval specifier. Legal string values are `\\"millisecond\\"`, `\\"second\\"`, `\\"minute\\"`, `\\"hour\\"`, `\\"day\\"`, `\\"week\\"`, `\\"month\\"`, and `\\"year\\"`. Alternatively, an object-valued interval specifier of the form `{\\"interval\\": \\"month\\", \\"step\\": 3}` includes a desired number of interval steps. Here, ticks are generated for each quarter (Jan, Apr, Jul, Oct) boundary.\\n\\n__Default value__: Determine using a formula `ceil(width/40)` for x and `ceil(height/40)` for y.","minimum":0},"tickDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed tick mark lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumberArray"}]},"tickDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the tick mark dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"tickExtra":{"description":"Boolean flag indicating if an extra axis tick should be added for the initial position of the axis. This flag is useful for styling axes for `band` scales such that ticks are placed on band boundaries rather in the middle of a band. Use in conjunction with `\\"bandPosition\\": 1` and an axis `\\"padding\\"` value of `0`.","type":"boolean"},"tickMinStep":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum desired step between axis ticks, in terms of scale domain values. For example, a value of `1` indicates that ticks should not be less than 1 unit apart. If `tickMinStep` is specified, the `tickCount` value will be adjusted, if necessary, to enforce the minimum step value."},"tickOffset":{"anyOf":[{"description":"Position offset in pixels to apply to ticks, labels, and gridlines.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tickOpacity":{"anyOf":[{"description":"Opacity of the ticks.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"tickRound":{"description":"Boolean flag indicating if pixel position values should be rounded to the nearest integer.\\n\\n__Default value:__ `true`","type":"boolean"},"tickSize":{"anyOf":[{"description":"The size in pixels of axis ticks.\\n\\n__Default value:__ `5`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"tickWidth":{"anyOf":[{"description":"The width, in pixels, of ticks.\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"ticks":{"description":"Boolean value that determines whether the axis should include ticks.\\n\\n__Default value:__ `true`","type":"boolean"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"titleAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"Horizontal text alignment of axis titles."},{"$ref":"#/definitions/ExprRef"}]},"titleAnchor":{"anyOf":[{"$ref":"#/definitions/TitleAnchor","description":"Text anchor position for placing axis titles."},{"$ref":"#/definitions/ExprRef"}]},"titleAngle":{"anyOf":[{"description":"Angle in degrees of axis titles.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline for axis titles. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone."},{"$ref":"#/definitions/ExprRef"}]},"titleColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Color of the title, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"}]},"titleFont":{"anyOf":[{"description":"Font of the title. (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"titleFontSize":{"anyOf":[{"description":"Font size of the title.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style of the title."},{"$ref":"#/definitions/ExprRef"}]},"titleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight of the title. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"titleLimit":{"anyOf":[{"description":"Maximum allowed pixel width of axis titles.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleOpacity":{"anyOf":[{"description":"Opacity of the axis title.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titlePadding":{"anyOf":[{"description":"The padding, in pixels, between title and axis.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleX":{"anyOf":[{"description":"X-coordinate of the axis title relative to the axis group.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleY":{"anyOf":[{"description":"Y-coordinate of the axis title relative to the axis group.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"translate":{"anyOf":[{"description":"Coordinate space translation offset for axis layout. By default, axes are translated by a 0.5 pixel offset for both the x and y coordinates in order to align stroked lines with the pixel grid. However, for vector graphics output these pixel-specific adjustments may be undesirable, in which case translate can be changed (for example, to zero).\\n\\n__Default value:__ `0.5`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"values":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"items":{"type":"string"},"type":"array"},{"items":{"type":"boolean"},"type":"array"},{"items":{"$ref":"#/definitions/DateTime"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"Explicitly set the visible axis tick values."},"zindex":{"description":"A non-negative integer indicating the z-index of the axis. If zindex is 0, axes should be drawn behind all chart elements. To put them in front, set `zindex` to `1` or more.\\n\\n__Default value:__ `0` (behind the marks).","minimum":0,"type":"number"}},"type":"object"},"AxisConfig":{"additionalProperties":false,"properties":{"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG group, removing the axis from the ARIA accessibility tree.\\n\\n__Default value:__ `true`","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"bandPosition":{"anyOf":[{"description":"An interpolation fraction indicating where, for `band` scales, axis ticks should be positioned. A value of `0` places ticks at the left edge of their bands. A value of `0.5` places ticks in the middle of their bands.\\n\\n __Default value:__ `0.5`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of this axis for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If the `aria` property is true, for SVG output the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute) will be set to this description. If the description is unspecified it will be automatically generated.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"disable":{"description":"Disable axis by default.","type":"boolean"},"domain":{"description":"A boolean flag indicating if the domain (the axis baseline) should be included as part of the axis.\\n\\n__Default value:__ `true`","type":"boolean"},"domainCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for the domain line\'s ending style. One of `\\"butt\\"`, `\\"round\\"` or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"domainColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Color of axis domain line.\\n\\n__Default value:__ `\\"gray\\"`."},{"$ref":"#/definitions/ExprRef"}]},"domainDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed domain lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"domainDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the domain dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"domainOpacity":{"anyOf":[{"description":"Opacity of the axis domain line.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"domainWidth":{"anyOf":[{"description":"Stroke width of axis domain line\\n\\n__Default value:__ `1`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"grid":{"description":"A boolean flag indicating if grid lines should be included as part of the axis\\n\\n__Default value:__ `true` for [continuous scales](https://vega.github.io/vega-lite/docs/scale.html#continuous) that are not binned; otherwise, `false`.","type":"boolean"},"gridCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for grid lines\' ending style. One of `\\"butt\\"`, `\\"round\\"` or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"gridColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Color of gridlines.\\n\\n__Default value:__ `\\"lightGray\\"`."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisColor"}]},"gridDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed grid lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumberArray"}]},"gridDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the grid dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"gridOpacity":{"anyOf":[{"description":"The stroke opacity of grid (value between [0,1])\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"gridWidth":{"anyOf":[{"description":"The grid width, in pixels.\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"Horizontal text alignment of axis tick labels, overriding the default setting for the current axis orientation."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelAlign"}]},"labelAngle":{"anyOf":[{"description":"The rotation angle of the axis labels.\\n\\n__Default value:__ `-90` for nominal and ordinal fields; `0` otherwise.","maximum":360,"minimum":-360,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline of axis tick labels, overriding the default setting for the current axis orientation. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelBaseline"}]},"labelBound":{"anyOf":[{"description":"Indicates if labels should be hidden if they exceed the axis range. If `false` (the default) no bounds overlap analysis is performed. If `true`, labels will be hidden if they exceed the axis range by more than 1 pixel. If this property is a number, it specifies the pixel tolerance: the maximum amount by which a label bounding box may exceed the axis range.\\n\\n__Default value:__ `false`.","type":["number","boolean"]},{"$ref":"#/definitions/ExprRef"}]},"labelColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the tick label, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisColor"}]},"labelExpr":{"description":"[Vega expression](https://vega.github.io/vega/docs/expressions/) for customizing labels.\\n\\n__Note:__ The label text and value can be assessed via the `label` and `value` properties of the axis\'s backing `datum` object.","type":"string"},"labelFlush":{"description":"Indicates if the first and last axis labels should be aligned flush with the scale range. Flush alignment for a horizontal axis will left-align the first label and right-align the last label. For vertical axes, bottom and top text baselines are applied instead. If this property is a number, it also indicates the number of pixels by which to offset the first and last labels; for example, a value of 2 will flush-align the first and last labels and also push them 2 pixels outward from the center of the axis. The additional adjustment can sometimes help the labels better visually group with corresponding axis ticks.\\n\\n__Default value:__ `true` for axis of a continuous x-scale. Otherwise, `false`.","type":["boolean","number"]},"labelFlushOffset":{"anyOf":[{"description":"Indicates the number of pixels by which to offset flush-adjusted labels. For example, a value of `2` will push flush-adjusted labels 2 pixels outward from the center of the axis. Offsets can help the labels better visually group with corresponding axis ticks.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelFont":{"anyOf":[{"description":"The font of the tick label.","type":"string"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisString"}]},"labelFontSize":{"anyOf":[{"description":"The font size of the label, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style of the title."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelFontStyle"}]},"labelFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight of axis tick labels."},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisLabelFontWeight"}]},"labelLimit":{"anyOf":[{"description":"Maximum allowed pixel width of axis tick labels.\\n\\n__Default value:__ `180`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line label text or label text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOffset":{"anyOf":[{"description":"Position offset in pixels to apply to labels, in addition to tickOffset.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelOpacity":{"anyOf":[{"description":"The opacity of the labels.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelOverlap":{"anyOf":[{"$ref":"#/definitions/LabelOverlap"},{"$ref":"#/definitions/ExprRef"}],"description":"The strategy to use for resolving overlap of axis labels. If `false` (the default), no overlap reduction is attempted. If set to `true` or `\\"parity\\"`, a strategy of removing every other label is used (this works well for standard linear axes). If set to `\\"greedy\\"`, a linear scan of the labels is performed, removing any labels that overlaps with the last visible label (this often works better for log-scaled axes).\\n\\n__Default value:__ `true` for non-nominal fields with non-log scales; `\\"greedy\\"` for log scales; otherwise `false`."},"labelPadding":{"anyOf":[{"description":"The padding in pixels between labels and ticks.\\n\\n__Default value:__ `2`","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"labelSeparation":{"anyOf":[{"description":"The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default `0`). This property is ignored if *labelOverlap* resolution is not enabled.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labels":{"description":"A boolean flag indicating if labels should be included as part of the axis.\\n\\n__Default value:__ `true`.","type":"boolean"},"maxExtent":{"anyOf":[{"description":"The maximum extent in pixels that axis ticks and labels should use. This determines a maximum offset value for axis titles.\\n\\n__Default value:__ `undefined`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"minExtent":{"anyOf":[{"description":"The minimum extent in pixels that axis ticks and labels should use. This determines a minimum offset value for axis titles.\\n\\n__Default value:__ `30` for y-axis; `undefined` for x-axis.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The offset, in pixels, by which to displace the axis from the edge of the enclosing group or data rectangle.\\n\\n__Default value:__ derived from the [axis config](https://vega.github.io/vega-lite/docs/config.html#facet-scale-config)\'s `offset` (`0` by default)"},"orient":{"anyOf":[{"$ref":"#/definitions/AxisOrient"},{"$ref":"#/definitions/ExprRef"}],"description":"The orientation of the axis. One of `\\"top\\"`, `\\"bottom\\"`, `\\"left\\"` or `\\"right\\"`. The orientation can be used to further specialize the axis type (e.g., a y-axis oriented towards the right edge of the chart).\\n\\n__Default value:__ `\\"bottom\\"` for x-axes and `\\"left\\"` for y-axes."},"position":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The anchor position of the axis in pixels. For x-axes with top or bottom orientation, this sets the axis group x coordinate. For y-axes with left or right orientation, this sets the axis group y coordinate.\\n\\n__Default value__: `0`"},"style":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}],"description":"A string or array of strings indicating the name of custom styles to apply to the axis. A style is a named collection of axis property defined within the [style configuration](https://vega.github.io/vega-lite/docs/mark.html#style-config). If style is an array, later styles will override earlier styles.\\n\\n__Default value:__ (none) __Note:__ Any specified style will augment the default style. For example, an x-axis mark with `\\"style\\": \\"foo\\"` will use `config.axisX` and `config.style.foo` (the specified style `\\"foo\\"` has higher precedence)."},"tickBand":{"anyOf":[{"description":"For band scales, indicates if ticks and grid lines should be placed at the `\\"center\\"` of a band (default) or at the band `\\"extent\\"`s to indicate intervals","enum":["center","extent"],"type":"string"},{"$ref":"#/definitions/ExprRef"}]},"tickCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for the tick lines\' ending style. One of `\\"butt\\"`, `\\"round\\"` or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"tickColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the axis\'s tick.\\n\\n__Default value:__ `\\"gray\\"`"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisColor"}]},"tickCount":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/TimeInterval"},{"$ref":"#/definitions/TimeIntervalStep"},{"$ref":"#/definitions/ExprRef"}],"description":"A desired number of ticks, for axes visualizing quantitative scales. The resulting number may be different so that values are \\"nice\\" (multiples of 2, 5, 10) and lie within the underlying scale\'s range.\\n\\nFor scales of type `\\"time\\"` or `\\"utc\\"`, the tick count can instead be a time interval specifier. Legal string values are `\\"millisecond\\"`, `\\"second\\"`, `\\"minute\\"`, `\\"hour\\"`, `\\"day\\"`, `\\"week\\"`, `\\"month\\"`, and `\\"year\\"`. Alternatively, an object-valued interval specifier of the form `{\\"interval\\": \\"month\\", \\"step\\": 3}` includes a desired number of interval steps. Here, ticks are generated for each quarter (Jan, Apr, Jul, Oct) boundary.\\n\\n__Default value__: Determine using a formula `ceil(width/40)` for x and `ceil(height/40)` for y.","minimum":0},"tickDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed tick mark lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumberArray"}]},"tickDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the tick mark dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"tickExtra":{"description":"Boolean flag indicating if an extra axis tick should be added for the initial position of the axis. This flag is useful for styling axes for `band` scales such that ticks are placed on band boundaries rather in the middle of a band. Use in conjunction with `\\"bandPosition\\": 1` and an axis `\\"padding\\"` value of `0`.","type":"boolean"},"tickMinStep":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum desired step between axis ticks, in terms of scale domain values. For example, a value of `1` indicates that ticks should not be less than 1 unit apart. If `tickMinStep` is specified, the `tickCount` value will be adjusted, if necessary, to enforce the minimum step value."},"tickOffset":{"anyOf":[{"description":"Position offset in pixels to apply to ticks, labels, and gridlines.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tickOpacity":{"anyOf":[{"description":"Opacity of the ticks.","type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"tickRound":{"description":"Boolean flag indicating if pixel position values should be rounded to the nearest integer.\\n\\n__Default value:__ `true`","type":"boolean"},"tickSize":{"anyOf":[{"description":"The size in pixels of axis ticks.\\n\\n__Default value:__ `5`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"tickWidth":{"anyOf":[{"description":"The width, in pixels, of ticks.\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ConditionalAxisNumber"}]},"ticks":{"description":"Boolean value that determines whether the axis should include ticks.\\n\\n__Default value:__ `true`","type":"boolean"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"titleAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"Horizontal text alignment of axis titles."},{"$ref":"#/definitions/ExprRef"}]},"titleAnchor":{"anyOf":[{"$ref":"#/definitions/TitleAnchor","description":"Text anchor position for placing axis titles."},{"$ref":"#/definitions/ExprRef"}]},"titleAngle":{"anyOf":[{"description":"Angle in degrees of axis titles.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline for axis titles. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone."},{"$ref":"#/definitions/ExprRef"}]},"titleColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Color of the title, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"}]},"titleFont":{"anyOf":[{"description":"Font of the title. (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"titleFontSize":{"anyOf":[{"description":"Font size of the title.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style of the title."},{"$ref":"#/definitions/ExprRef"}]},"titleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight of the title. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"titleLimit":{"anyOf":[{"description":"Maximum allowed pixel width of axis titles.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleOpacity":{"anyOf":[{"description":"Opacity of the axis title.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titlePadding":{"anyOf":[{"description":"The padding, in pixels, between title and axis.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleX":{"anyOf":[{"description":"X-coordinate of the axis title relative to the axis group.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleY":{"anyOf":[{"description":"Y-coordinate of the axis title relative to the axis group.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"translate":{"anyOf":[{"description":"Coordinate space translation offset for axis layout. By default, axes are translated by a 0.5 pixel offset for both the x and y coordinates in order to align stroked lines with the pixel grid. However, for vector graphics output these pixel-specific adjustments may be undesirable, in which case translate can be changed (for example, to zero).\\n\\n__Default value:__ `0.5`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"values":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"items":{"type":"string"},"type":"array"},{"items":{"type":"boolean"},"type":"array"},{"items":{"$ref":"#/definitions/DateTime"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"Explicitly set the visible axis tick values."},"zindex":{"description":"A non-negative integer indicating the z-index of the axis. If zindex is 0, axes should be drawn behind all chart elements. To put them in front, set `zindex` to `1` or more.\\n\\n__Default value:__ `0` (behind the marks).","minimum":0,"type":"number"}},"type":"object"},"AxisOrient":{"enum":["top","bottom","left","right"],"type":"string"},"AxisResolveMap":{"additionalProperties":false,"properties":{"x":{"$ref":"#/definitions/ResolveMode"},"y":{"$ref":"#/definitions/ResolveMode"}},"type":"object"},"BBox":{"anyOf":[{"items":{"type":"number"},"maxItems":4,"minItems":4,"type":"array"},{"items":{"type":"number"},"maxItems":6,"minItems":6,"type":"array"}],"description":"Bounding box https://tools.ietf.org/html/rfc7946#section-5"},"BarConfig":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"binSpacing":{"description":"Offset between bars for binned field. The ideal value for this is either 0 (preferred by statisticians) or 1 (Vega-Lite default, D3 example style).\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"continuousBandSize":{"description":"The default size of the bars on continuous scales.\\n\\n__Default value:__ `5`","minimum":0,"type":"number"},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusEnd":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For vertical bars, top-left and top-right corner radius.\\n\\n- For horizontal bars, top-right and bottom-right corner radius."},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"discreteBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RelativeBandSize"}],"description":"The default size of the bars with discrete dimensions. If unspecified, the default size is  `step-2`, which provides 2 pixel offset between bars.","minimum":0},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"minBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum band size for bar and rectangle marks. __Default value:__ `0.25`"},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"BaseTitleNoValueRefs":{"additionalProperties":false,"properties":{"align":{"$ref":"#/definitions/Align","description":"Horizontal text alignment for title text. One of `\\"left\\"`, `\\"center\\"`, or `\\"right\\"`."},"anchor":{"anyOf":[{"$ref":"#/definitions/TitleAnchor","description":"The anchor position for placing the title and subtitle text. One of `\\"start\\"`, `\\"middle\\"`, or `\\"end\\"`. For example, with an orientation of top these anchor positions map to a left-, center-, or right-aligned title."},{"$ref":"#/definitions/ExprRef"}]},"angle":{"anyOf":[{"description":"Angle in degrees of title and subtitle text.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG group, removing the title from the ARIA accessibility tree.\\n\\n__Default value:__ `true`","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline for title and subtitle text. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone."},"color":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Text color for title text."},{"$ref":"#/definitions/ExprRef"}]},"dx":{"anyOf":[{"description":"Delta offset for title and subtitle text x-coordinate.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"Delta offset for title and subtitle text y-coordinate.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"font":{"anyOf":[{"description":"Font name for title text.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"Font size in pixels for title text.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style for title text."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight for title text. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"frame":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/TitleFrame"},{"type":"string"}],"description":"The reference frame for the anchor position, one of `\\"bounds\\"` (to anchor relative to the full bounding box) or `\\"group\\"` (to anchor relative to the group width or height)."},{"$ref":"#/definitions/ExprRef"}]},"limit":{"anyOf":[{"description":"The maximum allowed length in pixels of title and subtitle text.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"offset":{"anyOf":[{"description":"The orthogonal offset in pixels by which to displace the title group from its position along the edge of the chart.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"orient":{"anyOf":[{"$ref":"#/definitions/TitleOrient","description":"Default title orientation (`\\"top\\"`, `\\"bottom\\"`, `\\"left\\"`, or `\\"right\\"`)"},{"$ref":"#/definitions/ExprRef"}]},"subtitleColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Text color for subtitle text."},{"$ref":"#/definitions/ExprRef"}]},"subtitleFont":{"anyOf":[{"description":"Font name for subtitle text.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"subtitleFontSize":{"anyOf":[{"description":"Font size in pixels for subtitle text.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"subtitleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style for subtitle text."},{"$ref":"#/definitions/ExprRef"}]},"subtitleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight for subtitle text. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"subtitleLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line subtitle text.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"subtitlePadding":{"anyOf":[{"description":"The padding in pixels between title and subtitle text.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"zindex":{"anyOf":[{"description":"The integer z-index indicating the layering of the title group relative to other axis, mark, and legend groups.\\n\\n__Default value:__ `0`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]}},"type":"object"},"Baseline":{"enum":["top","middle","bottom"],"type":"string"},"BinExtent":{"anyOf":[{"items":{"type":"number"},"maxItems":2,"minItems":2,"type":"array"},{"$ref":"#/definitions/ParameterExtent"}]},"BinParams":{"additionalProperties":false,"description":"Binning properties or boolean flag for determining whether to bin data or not.","properties":{"anchor":{"description":"A value in the binned domain at which to anchor the bins, shifting the bin boundaries if necessary to ensure that a boundary aligns with the anchor value.\\n\\n__Default value:__ the minimum bin extent value","type":"number"},"base":{"description":"The number base to use for automatic bin determination (default is base 10).\\n\\n__Default value:__ `10`","type":"number"},"binned":{"description":"When set to `true`, Vega-Lite treats the input data as already binned.","type":"boolean"},"divide":{"description":"Scale factors indicating allowable subdivisions. The default value is [5, 2], which indicates that for base 10 numbers (the default base), the method may consider dividing bin sizes by 5 and/or 2. For example, for an initial step size of 10, the method can check if bin sizes of 2 (= 10/5), 5 (= 10/2), or 1 (= 10/(5*2)) might also satisfy the given constraints.\\n\\n__Default value:__ `[5, 2]`","items":{"type":"number"},"maxItems":2,"minItems":1,"type":"array"},"extent":{"$ref":"#/definitions/BinExtent","description":"A two-element (`[min, max]`) array indicating the range of desired bin values."},"maxbins":{"description":"Maximum number of bins.\\n\\n__Default value:__ `6` for `row`, `column` and `shape` channels; `10` for other channels","minimum":2,"type":"number"},"minstep":{"description":"A minimum allowable step size (particularly useful for integer values).","type":"number"},"nice":{"description":"If true, attempts to make the bin boundaries use human-friendly boundaries, such as multiples of ten.\\n\\n__Default value:__ `true`","type":"boolean"},"step":{"description":"An exact step size to use between bins.\\n\\n__Note:__ If provided, options such as maxbins will be ignored.","type":"number"},"steps":{"description":"An array of allowable step sizes to choose from.","items":{"type":"number"},"minItems":1,"type":"array"}},"type":"object"},"BinTransform":{"additionalProperties":false,"properties":{"as":{"anyOf":[{"$ref":"#/definitions/FieldName"},{"items":{"$ref":"#/definitions/FieldName"},"type":"array"}],"description":"The output fields at which to write the start and end bin values. This can be either a string or an array of strings with two elements denoting the name for the fields for bin start and bin end respectively. If a single string (e.g., `\\"val\\"`) is provided, the end field will be `\\"val_end\\"`."},"bin":{"anyOf":[{"const":true,"type":"boolean"},{"$ref":"#/definitions/BinParams"}],"description":"An object indicating bin properties, or simply `true` for using default bin parameters."},"field":{"$ref":"#/definitions/FieldName","description":"The data field to bin."}},"required":["bin","field","as"],"type":"object"},"BindCheckbox":{"additionalProperties":false,"properties":{"debounce":{"description":"If defined, delays event handling until the specified milliseconds have elapsed since the last event was fired.","type":"number"},"element":{"$ref":"#/definitions/Element","description":"An optional CSS selector string indicating the parent element to which the input element should be added. By default, all input elements are added within the parent container of the Vega view."},"input":{"const":"checkbox","type":"string"},"name":{"description":"By default, the signal name is used to label input elements. This `name` property can be used instead to specify a custom label for the bound signal.","type":"string"}},"required":["input"],"type":"object"},"BindDirect":{"additionalProperties":false,"properties":{"debounce":{"description":"If defined, delays event handling until the specified milliseconds have elapsed since the last event was fired.","type":"number"},"element":{"anyOf":[{"$ref":"#/definitions/Element"},{"additionalProperties":false,"type":"object"}],"description":"An input element that exposes a _value_ property and supports the [EventTarget](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget) interface, or a CSS selector string to such an element. When the element updates and dispatches an event, the _value_ property will be used as the new, bound signal value. When the signal updates independent of the element, the _value_ property will be set to the signal value and a new event will be dispatched on the element."},"event":{"description":"The event (default `\\"input\\"`) to listen for to track changes on the external element.","type":"string"}},"required":["element"],"type":"object"},"BindInput":{"additionalProperties":false,"properties":{"autocomplete":{"description":"A hint for form autofill. See the [HTML autocomplete attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) for additional information.","type":"string"},"debounce":{"description":"If defined, delays event handling until the specified milliseconds have elapsed since the last event was fired.","type":"number"},"element":{"$ref":"#/definitions/Element","description":"An optional CSS selector string indicating the parent element to which the input element should be added. By default, all input elements are added within the parent container of the Vega view."},"input":{"description":"The type of input element to use. The valid values are `\\"checkbox\\"`, `\\"radio\\"`, `\\"range\\"`, `\\"select\\"`, and any other legal [HTML form input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input).","type":"string"},"name":{"description":"By default, the signal name is used to label input elements. This `name` property can be used instead to specify a custom label for the bound signal.","type":"string"},"placeholder":{"description":"Text that appears in the form control when it has no value set.","type":"string"}},"type":"object"},"BindRadioSelect":{"additionalProperties":false,"properties":{"debounce":{"description":"If defined, delays event handling until the specified milliseconds have elapsed since the last event was fired.","type":"number"},"element":{"$ref":"#/definitions/Element","description":"An optional CSS selector string indicating the parent element to which the input element should be added. By default, all input elements are added within the parent container of the Vega view."},"input":{"enum":["radio","select"],"type":"string"},"labels":{"description":"An array of label strings to represent the `options` values. If unspecified, the `options` value will be coerced to a string and used as the label.","items":{"type":"string"},"type":"array"},"name":{"description":"By default, the signal name is used to label input elements. This `name` property can be used instead to specify a custom label for the bound signal.","type":"string"},"options":{"description":"An array of options to select from.","items":{},"type":"array"}},"required":["input","options"],"type":"object"},"BindRange":{"additionalProperties":false,"properties":{"debounce":{"description":"If defined, delays event handling until the specified milliseconds have elapsed since the last event was fired.","type":"number"},"element":{"$ref":"#/definitions/Element","description":"An optional CSS selector string indicating the parent element to which the input element should be added. By default, all input elements are added within the parent container of the Vega view."},"input":{"const":"range","type":"string"},"max":{"description":"Sets the maximum slider value. Defaults to the larger of the signal value and `100`.","type":"number"},"min":{"description":"Sets the minimum slider value. Defaults to the smaller of the signal value and `0`.","type":"number"},"name":{"description":"By default, the signal name is used to label input elements. This `name` property can be used instead to specify a custom label for the bound signal.","type":"string"},"step":{"description":"Sets the minimum slider increment. If undefined, the step size will be automatically determined based on the `min` and `max` values.","type":"number"}},"required":["input"],"type":"object"},"Binding":{"anyOf":[{"$ref":"#/definitions/BindCheckbox"},{"$ref":"#/definitions/BindRadioSelect"},{"$ref":"#/definitions/BindRange"},{"$ref":"#/definitions/BindInput"},{"$ref":"#/definitions/BindDirect"}]},"BinnedTimeUnit":{"enum":["binnedyear","binnedyearquarter","binnedyearquartermonth","binnedyearmonth","binnedyearmonthdate","binnedyearmonthdatehours","binnedyearmonthdatehoursminutes","binnedyearmonthdatehoursminutesseconds","binnedyearweek","binnedyearweekday","binnedyearweekdayhours","binnedyearweekdayhoursminutes","binnedyearweekdayhoursminutesseconds","binnedyeardayofyear","binnedutcyear","binnedutcyearquarter","binnedutcyearquartermonth","binnedutcyearmonth","binnedutcyearmonthdate","binnedutcyearmonthdatehours","binnedutcyearmonthdatehoursminutes","binnedutcyearmonthdatehoursminutesseconds","binnedutcyearweek","binnedutcyearweekday","binnedutcyearweekdayhours","binnedutcyearweekdayhoursminutes","binnedutcyearweekdayhoursminutesseconds","binnedutcyeardayofyear"],"type":"string"},"Blend":{"enum":[null,"multiply","screen","overlay","darken","lighten","color-dodge","color-burn","hard-light","soft-light","difference","exclusion","hue","saturation","color","luminosity"],"type":["null","string"]},"BoxPlot":{"const":"boxplot","type":"string"},"BoxPlotConfig":{"additionalProperties":false,"properties":{"box":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"extent":{"anyOf":[{"const":"min-max","type":"string"},{"type":"number"}],"description":"The extent of the whiskers. Available options include:\\n- `\\"min-max\\"`: min and max are the lower and upper whiskers respectively.\\n- A number representing multiple of the interquartile range. This number will be multiplied by the IQR to determine whisker boundary, which spans from the smallest data to the largest data within the range _[Q1 - k * IQR, Q3 + k * IQR]_ where _Q1_ and _Q3_ are the first and third quartiles while _IQR_ is the interquartile range (_Q3-Q1_).\\n\\n__Default value:__ `1.5`."},"median":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"outliers":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"rule":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"size":{"description":"Size of the box and median tick of a box plot","type":"number"},"ticks":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]}},"type":"object"},"BoxPlotDef":{"additionalProperties":false,"properties":{"box":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"clip":{"description":"Whether a composite mark be clipped to the enclosing group\u2019s width and height.","type":"boolean"},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"extent":{"anyOf":[{"const":"min-max","type":"string"},{"type":"number"}],"description":"The extent of the whiskers. Available options include:\\n- `\\"min-max\\"`: min and max are the lower and upper whiskers respectively.\\n- A number representing multiple of the interquartile range. This number will be multiplied by the IQR to determine whisker boundary, which spans from the smallest data to the largest data within the range _[Q1 - k * IQR, Q3 + k * IQR]_ where _Q1_ and _Q3_ are the first and third quartiles while _IQR_ is the interquartile range (_Q3-Q1_).\\n\\n__Default value:__ `1.5`."},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"median":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"opacity":{"description":"The opacity (value between [0,1]) of the mark.","maximum":1,"minimum":0,"type":"number"},"orient":{"$ref":"#/definitions/Orientation","description":"Orientation of the box plot. This is normally automatically determined based on types of fields on x and y channels. However, an explicit `orient` be specified when the orientation is ambiguous.\\n\\n__Default value:__ `\\"vertical\\"`."},"outliers":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"rule":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"size":{"description":"Size of the box and median tick of a box plot","type":"number"},"ticks":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"type":{"$ref":"#/definitions/BoxPlot","description":"The mark type. This could a primitive mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"geoshape\\"`, `\\"rule\\"`, and `\\"text\\"`) or a composite mark type (`\\"boxplot\\"`, `\\"errorband\\"`, `\\"errorbar\\"`)."}},"required":["type"],"type":"object"},"BrushConfig":{"additionalProperties":false,"properties":{"cursor":{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the interval mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},"fill":{"$ref":"#/definitions/Color","description":"The fill color of the interval mark.\\n\\n__Default value:__ `\\"#333333\\"`"},"fillOpacity":{"description":"The fill opacity of the interval mark (a value between `0` and `1`).\\n\\n__Default value:__ `0.125`","type":"number"},"stroke":{"$ref":"#/definitions/Color","description":"The stroke color of the interval mark.\\n\\n__Default value:__ `\\"#ffffff\\"`"},"strokeDash":{"description":"An array of alternating stroke and space lengths, for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},"strokeDashOffset":{"description":"The offset (in pixels) with which to begin drawing the stroke dash array.","type":"number"},"strokeOpacity":{"description":"The stroke opacity of the interval mark (a value between `0` and `1`).","type":"number"},"strokeWidth":{"description":"The stroke width of the interval mark.","type":"number"}},"type":"object"},"CalculateTransform":{"additionalProperties":false,"properties":{"as":{"$ref":"#/definitions/FieldName","description":"The field for storing the computed formula value."},"calculate":{"description":"A [expression](https://vega.github.io/vega-lite/docs/types.html#expression) string. Use the variable `datum` to refer to the current data object.","type":"string"}},"required":["calculate","as"],"type":"object"},"Categorical":{"enum":["accent","category10","category20","category20b","category20c","dark2","paired","pastel1","pastel2","set1","set2","set3","tableau10","tableau20","observable10"],"type":"string"},"Color":{"anyOf":[{"$ref":"#/definitions/ColorName"},{"$ref":"#/definitions/HexColor"},{"type":"string"}]},"ColorDef":{"$ref":"#/definitions/MarkPropDef<(Gradient|string|null)>"},"ColorName":{"enum":["black","silver","gray","white","maroon","red","purple","fuchsia","green","lime","olive","yellow","navy","blue","teal","aqua","orange","aliceblue","antiquewhite","aquamarine","azure","beige","bisque","blanchedalmond","blueviolet","brown","burlywood","cadetblue","chartreuse","chocolate","coral","cornflowerblue","cornsilk","crimson","cyan","darkblue","darkcyan","darkgoldenrod","darkgray","darkgreen","darkgrey","darkkhaki","darkmagenta","darkolivegreen","darkorange","darkorchid","darkred","darksalmon","darkseagreen","darkslateblue","darkslategray","darkslategrey","darkturquoise","darkviolet","deeppink","deepskyblue","dimgray","dimgrey","dodgerblue","firebrick","floralwhite","forestgreen","gainsboro","ghostwhite","gold","goldenrod","greenyellow","grey","honeydew","hotpink","indianred","indigo","ivory","khaki","lavender","lavenderblush","lawngreen","lemonchiffon","lightblue","lightcoral","lightcyan","lightgoldenrodyellow","lightgray","lightgreen","lightgrey","lightpink","lightsalmon","lightseagreen","lightskyblue","lightslategray","lightslategrey","lightsteelblue","lightyellow","limegreen","linen","magenta","mediumaquamarine","mediumblue","mediumorchid","mediumpurple","mediumseagreen","mediumslateblue","mediumspringgreen","mediumturquoise","mediumvioletred","midnightblue","mintcream","mistyrose","moccasin","navajowhite","oldlace","olivedrab","orangered","orchid","palegoldenrod","palegreen","paleturquoise","palevioletred","papayawhip","peachpuff","peru","pink","plum","powderblue","rosybrown","royalblue","saddlebrown","salmon","sandybrown","seagreen","seashell","sienna","skyblue","slateblue","slategray","slategrey","snow","springgreen","steelblue","tan","thistle","tomato","turquoise","violet","wheat","whitesmoke","yellowgreen","rebeccapurple"],"type":"string"},"ColorScheme":{"anyOf":[{"$ref":"#/definitions/Categorical"},{"$ref":"#/definitions/SequentialSingleHue"},{"$ref":"#/definitions/SequentialMultiHue"},{"$ref":"#/definitions/Diverging"},{"$ref":"#/definitions/Cyclical"}]},"Encoding":{"additionalProperties":false,"properties":{"angle":{"$ref":"#/definitions/NumericMarkPropDef","description":"Rotation angle of point and text marks."},"color":{"$ref":"#/definitions/ColorDef","description":"Color of the marks \u2013 either fill or stroke color based on  the `filled` property of mark definition. By default, `color` represents fill color for `\\"area\\"`, `\\"bar\\"`, `\\"tick\\"`, `\\"text\\"`, `\\"trail\\"`, `\\"circle\\"`, and `\\"square\\"` / stroke color for `\\"line\\"` and `\\"point\\"`.\\n\\n__Default value:__ If undefined, the default color depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `color` property.\\n\\n_Note:_ 1) For fine-grained control over both fill and stroke colors of the marks, please use the `fill` and `stroke` channels. The `fill` or `stroke` encodings have higher precedence than `color`, thus may override the `color` encoding if conflicting encodings are specified. 2) See the scale documentation for more information about customizing [color scheme](https://vega.github.io/vega-lite/docs/scale.html#scheme)."},"description":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"}],"description":"A text description of this mark for ARIA accessibility (SVG output only). For SVG output the `\\"aria-label\\"` attribute will be set to this description."},"detail":{"anyOf":[{"$ref":"#/definitions/FieldDefWithoutScale"},{"items":{"$ref":"#/definitions/FieldDefWithoutScale"},"type":"array"}],"description":"Additional levels of detail for grouping data in aggregate views and in line, trail, and area marks without mapping data to a specific visual channel."},"fill":{"$ref":"#/definitions/ColorDef","description":"Fill color of the marks. __Default value:__ If undefined, the default color depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `color` property.\\n\\n_Note:_ The `fill` encoding has higher precedence than `color`, thus may override the `color` encoding if conflicting encodings are specified."},"fillOpacity":{"$ref":"#/definitions/NumericMarkPropDef","description":"Fill opacity of the marks.\\n\\n__Default value:__ If undefined, the default opacity depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `fillOpacity` property."},"href":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"}],"description":"A URL to load upon mouse click."},"key":{"$ref":"#/definitions/FieldDefWithoutScale","description":"A data field to use as a unique key for data binding. When a visualization\u2019s data is updated, the key value will be used to match data elements to existing mark instances. Use a key channel to enable object constancy for transitions over dynamic data."},"latitude":{"$ref":"#/definitions/LatLongDef","description":"Latitude position of geographically projected marks."},"latitude2":{"$ref":"#/definitions/Position2Def","description":"Latitude-2 position for geographically projected ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`."},"longitude":{"$ref":"#/definitions/LatLongDef","description":"Longitude position of geographically projected marks."},"longitude2":{"$ref":"#/definitions/Position2Def","description":"Longitude-2 position for geographically projected ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`."},"opacity":{"$ref":"#/definitions/NumericMarkPropDef","description":"Opacity of the marks.\\n\\n__Default value:__ If undefined, the default opacity depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `opacity` property."},"order":{"anyOf":[{"$ref":"#/definitions/OrderFieldDef"},{"items":{"$ref":"#/definitions/OrderFieldDef"},"type":"array"},{"$ref":"#/definitions/OrderValueDef"},{"$ref":"#/definitions/OrderOnlyDef"}],"description":"Order of the marks.\\n- For stacked marks, this `order` channel encodes [stack order](https://vega.github.io/vega-lite/docs/stack.html#order).\\n- For line and trail marks, this `order` channel encodes order of data points in the lines. This can be useful for creating [a connected scatterplot](https://vega.github.io/vega-lite/examples/connected_scatterplot.html). Setting `order` to `{\\"value\\": null}` makes the line marks use the original order in the data sources.\\n- Otherwise, this `order` channel encodes layer order of the marks.\\n\\n__Note__: In aggregate plots, `order` field should be `aggregate`d to avoid creating additional aggregation grouping."},"radius":{"$ref":"#/definitions/PolarDef","description":"The outer radius in pixels of arc marks."},"radius2":{"$ref":"#/definitions/Position2Def","description":"The inner radius in pixels of arc marks."},"shape":{"$ref":"#/definitions/ShapeDef","description":"Shape of the mark.\\n\\n1. For `point` marks the supported values include:   - plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.   - the line symbol `\\"stroke\\"`   - centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`   - a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n2. For `geoshape` marks it should be a field definition of the geojson data\\n\\n__Default value:__ If undefined, the default shape depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#point-config)\'s `shape` property. (`\\"circle\\"` if unset.)"},"size":{"$ref":"#/definitions/NumericMarkPropDef","description":"Size of the mark.\\n- For `\\"point\\"`, `\\"square\\"` and `\\"circle\\"`, \u2013 the symbol size, or pixel area of the mark.\\n- For `\\"bar\\"` and `\\"tick\\"` \u2013 the bar and tick\'s size.\\n- For `\\"text\\"` \u2013 the text\'s font size.\\n- Size is unsupported for `\\"line\\"`, `\\"area\\"`, and `\\"rect\\"`. (Use `\\"trail\\"` instead of line with varying size)"},"stroke":{"$ref":"#/definitions/ColorDef","description":"Stroke color of the marks. __Default value:__ If undefined, the default color depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `color` property.\\n\\n_Note:_ The `stroke` encoding has higher precedence than `color`, thus may override the `color` encoding if conflicting encodings are specified."},"strokeDash":{"$ref":"#/definitions/NumericArrayMarkPropDef","description":"Stroke dash of the marks.\\n\\n__Default value:__ `[1,0]` (No dash)."},"strokeOpacity":{"$ref":"#/definitions/NumericMarkPropDef","description":"Stroke opacity of the marks.\\n\\n__Default value:__ If undefined, the default opacity depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `strokeOpacity` property."},"strokeWidth":{"$ref":"#/definitions/NumericMarkPropDef","description":"Stroke width of the marks.\\n\\n__Default value:__ If undefined, the default stroke width depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `strokeWidth` property."},"text":{"$ref":"#/definitions/TextDef","description":"Text of the `text` mark."},"theta":{"$ref":"#/definitions/PolarDef","description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians."},"theta2":{"$ref":"#/definitions/Position2Def","description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"$ref":"#/definitions/TimeDef"},"tooltip":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"},{"items":{"$ref":"#/definitions/StringFieldDef"},"type":"array"},{"type":"null"}],"description":"The tooltip text to show upon mouse hover. Specifying `tooltip` encoding overrides [the `tooltip` property in the mark definition](https://vega.github.io/vega-lite/docs/mark.html#mark-def).\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip in Vega-Lite."},"url":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"}],"description":"The URL of an image mark."},"x":{"$ref":"#/definitions/PositionDef","description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"$ref":"#/definitions/Position2Def","description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"xError":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Error value of x coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"xError2":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Secondary error value of x coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"xOffset":{"$ref":"#/definitions/OffsetDef","description":"Offset of x-position of the marks"},"y":{"$ref":"#/definitions/PositionDef","description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"$ref":"#/definitions/Position2Def","description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"yError":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Error value of y coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"yError2":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Secondary error value of y coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"yOffset":{"$ref":"#/definitions/OffsetDef","description":"Offset of y-position of the marks"}},"type":"object"},"CompositeMark":{"anyOf":[{"$ref":"#/definitions/BoxPlot"},{"$ref":"#/definitions/ErrorBar"},{"$ref":"#/definitions/ErrorBand"}]},"CompositeMarkDef":{"anyOf":[{"$ref":"#/definitions/BoxPlotDef"},{"$ref":"#/definitions/ErrorBarDef"},{"$ref":"#/definitions/ErrorBandDef"}]},"CompositionConfig":{"additionalProperties":false,"properties":{"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"spacing":{"description":"The default spacing in pixels between composed sub-views.\\n\\n__Default value__: `20`","type":"number"}},"type":"object"},"ConditionalMarkPropFieldOrDatumDef":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<MarkPropFieldOrDatumDef>"},{"$ref":"#/definitions/ConditionalParameter<MarkPropFieldOrDatumDef>"}]},"ConditionalMarkPropFieldOrDatumDef<TypeForShape>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<MarkPropFieldOrDatumDef<TypeForShape>>"},{"$ref":"#/definitions/ConditionalParameter<MarkPropFieldOrDatumDef<TypeForShape>>"}]},"ConditionalStringFieldDef":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<StringFieldDef>"},{"$ref":"#/definitions/ConditionalParameter<StringFieldDef>"}]},"ConditionalValueDef<(Gradient|string|null|ExprRef)>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<(Gradient|string|null|ExprRef)>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<(Gradient|string|null|ExprRef)>>"}]},"ConditionalValueDef<(Text|ExprRef)>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<(Text|ExprRef)>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<(Text|ExprRef)>>"}]},"ConditionalValueDef<(number[]|ExprRef)>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<(number[]|ExprRef)>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<(number[]|ExprRef)>>"}]},"ConditionalValueDef<(number|ExprRef)>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<(number|ExprRef)>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<(number|ExprRef)>>"}]},"ConditionalValueDef<(string|ExprRef)>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<(string|ExprRef)>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<(string|ExprRef)>>"}]},"ConditionalValueDef<(string|null|ExprRef)>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<(string|null|ExprRef)>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<(string|null|ExprRef)>>"}]},"ConditionalValueDef<number>":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<ValueDef<number>>"},{"$ref":"#/definitions/ConditionalParameter<ValueDef<number>>"}]},"ConditionalAxisColor":{"$ref":"#/definitions/ConditionalAxisProperty<(Color|null)>"},"ConditionalAxisLabelAlign":{"$ref":"#/definitions/ConditionalAxisProperty<(Align|null)>"},"ConditionalAxisLabelBaseline":{"$ref":"#/definitions/ConditionalAxisProperty<(TextBaseline|null)>"},"ConditionalAxisLabelFontStyle":{"$ref":"#/definitions/ConditionalAxisProperty<(FontStyle|null)>"},"ConditionalAxisLabelFontWeight":{"$ref":"#/definitions/ConditionalAxisProperty<(FontWeight|null)>"},"ConditionalAxisNumber":{"$ref":"#/definitions/ConditionalAxisProperty<(number|null)>"},"ConditionalAxisNumberArray":{"$ref":"#/definitions/ConditionalAxisProperty<(number[]|null)>"},"ConditionalAxisProperty<(Align|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Align|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Align|null)>|ExprRef)>"},"type":"array"}]},"value":{"anyOf":[{"$ref":"#/definitions/Align"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Align|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Align|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(Color|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Color|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Color|null)>|ExprRef)>"},"type":"array"}]},"value":{"anyOf":[{"$ref":"#/definitions/Color"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Color|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(Color|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(FontStyle|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontStyle|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontStyle|null)>|ExprRef)>"},"type":"array"}]},"value":{"anyOf":[{"$ref":"#/definitions/FontStyle"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontStyle|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontStyle|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(FontWeight|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontWeight|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontWeight|null)>|ExprRef)>"},"type":"array"}]},"value":{"anyOf":[{"$ref":"#/definitions/FontWeight"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontWeight|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(FontWeight|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(TextBaseline|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(TextBaseline|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(TextBaseline|null)>|ExprRef)>"},"type":"array"}]},"value":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(TextBaseline|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(TextBaseline|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(number[]|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number[]|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number[]|null)>|ExprRef)>"},"type":"array"}]},"value":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number[]|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number[]|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(number|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number|null)>|ExprRef)>"},"type":"array"}]},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":["number","null"]}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(number|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisProperty<(string|null)>":{"anyOf":[{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(string|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(string|null)>|ExprRef)>"},"type":"array"}]},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":["string","null"]}},"required":["condition","value"],"type":"object"},{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(string|null)>|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalPredicate<(ValueDef<(string|null)>|ExprRef)>"},"type":"array"}]},"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["condition","expr"],"type":"object"}]},"ConditionalAxisString":{"$ref":"#/definitions/ConditionalAxisProperty<(string|null)>"},"ConditionalParameter<MarkPropFieldOrDatumDef>":{"anyOf":[{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["param"],"type":"object"},{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["param"],"type":"object"}]},"ConditionalParameter<MarkPropFieldOrDatumDef<TypeForShape>>":{"anyOf":[{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/TypeForShape","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["param"],"type":"object"},{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["param"],"type":"object"}]},"ConditionalParameter<StringFieldDef>":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["param"],"type":"object"},"ConditionalParameter<ValueDef<(Gradient|string|null|ExprRef)>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"anyOf":[{"$ref":"#/definitions/Gradient"},{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["param","value"],"type":"object"},"ConditionalParameter<ValueDef<(Text|ExprRef)>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["param","value"],"type":"object"},"ConditionalParameter<ValueDef<(number[]|ExprRef)>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["param","value"],"type":"object"},"ConditionalParameter<ValueDef<(number|ExprRef)>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["param","value"],"type":"object"},"ConditionalParameter<ValueDef<(string|ExprRef)>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["param","value"],"type":"object"},"ConditionalParameter<ValueDef<(string|null|ExprRef)>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["param","value"],"type":"object"},"ConditionalParameter<ValueDef<number>>":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"required":["param","value"],"type":"object"},"ConditionalPredicate<(ValueDef<(Align|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/Align"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(Color|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/Color"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(FontStyle|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/FontStyle"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(FontWeight|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/FontWeight"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(TextBaseline|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(number[]|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"type":"null"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(number|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":["number","null"]}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<(ValueDef<(string|null)>|ExprRef)>":{"anyOf":[{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":["string","null"]}},"required":["test","value"],"type":"object"},{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"}},"required":["expr","test"],"type":"object"}]},"ConditionalPredicate<MarkPropFieldOrDatumDef>":{"anyOf":[{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["test"],"type":"object"},{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["test"],"type":"object"}]},"ConditionalPredicate<MarkPropFieldOrDatumDef<TypeForShape>>":{"anyOf":[{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/TypeForShape","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["test"],"type":"object"},{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["test"],"type":"object"}]},"ConditionalPredicate<StringFieldDef>":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"required":["test"],"type":"object"},"ConditionalPredicate<ValueDef<(Gradient|string|null|ExprRef)>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/Gradient"},{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},"ConditionalPredicate<ValueDef<(Text|ExprRef)>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},"ConditionalPredicate<ValueDef<(number[]|ExprRef)>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},"ConditionalPredicate<ValueDef<(number|ExprRef)>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},"ConditionalPredicate<ValueDef<(string|ExprRef)>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},"ConditionalPredicate<ValueDef<(string|null|ExprRef)>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["test","value"],"type":"object"},"ConditionalPredicate<ValueDef<number>>":{"additionalProperties":false,"properties":{"test":{"$ref":"#/definitions/PredicateComposition","description":"Predicate for triggering the condition"},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"required":["test","value"],"type":"object"},"Config":{"additionalProperties":false,"properties":{"arc":{"$ref":"#/definitions/RectConfig","description":"Arc-specific Config"},"area":{"$ref":"#/definitions/AreaConfig","description":"Area-Specific Config"},"aria":{"description":"A boolean flag indicating if ARIA default attributes should be included for marks and guides (SVG output only). If false, the `\\"aria-hidden\\"` attribute will be set for all guides, removing them from the ARIA accessibility tree and Vega-Lite will not generate default descriptions for marks.\\n\\n__Default value:__ `true`.","type":"boolean"},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"axis":{"$ref":"#/definitions/AxisConfig","description":"Axis configuration, which determines default properties for all `x` and `y` [axes](https://vega.github.io/vega-lite/docs/axis.html). For a full list of axis configuration options, please see the [corresponding section of the axis documentation](https://vega.github.io/vega-lite/docs/axis.html#config)."},"axisBand":{"$ref":"#/definitions/AxisConfig","description":"Config for axes with \\"band\\" scales."},"axisBottom":{"$ref":"#/definitions/AxisConfig","description":"Config for x-axis along the bottom edge of the chart."},"axisDiscrete":{"$ref":"#/definitions/AxisConfig","description":"Config for axes with \\"point\\" or \\"band\\" scales."},"axisLeft":{"$ref":"#/definitions/AxisConfig","description":"Config for y-axis along the left edge of the chart."},"axisPoint":{"$ref":"#/definitions/AxisConfig","description":"Config for axes with \\"point\\" scales."},"axisQuantitative":{"$ref":"#/definitions/AxisConfig","description":"Config for quantitative axes."},"axisRight":{"$ref":"#/definitions/AxisConfig","description":"Config for y-axis along the right edge of the chart."},"axisTemporal":{"$ref":"#/definitions/AxisConfig","description":"Config for temporal axes."},"axisTop":{"$ref":"#/definitions/AxisConfig","description":"Config for x-axis along the top edge of the chart."},"axisX":{"$ref":"#/definitions/AxisConfig","description":"X-axis specific config."},"axisXBand":{"$ref":"#/definitions/AxisConfig","description":"Config for x-axes with \\"band\\" scales."},"axisXDiscrete":{"$ref":"#/definitions/AxisConfig","description":"Config for x-axes with \\"point\\" or \\"band\\" scales."},"axisXPoint":{"$ref":"#/definitions/AxisConfig","description":"Config for x-axes with \\"point\\" scales."},"axisXQuantitative":{"$ref":"#/definitions/AxisConfig","description":"Config for x-quantitative axes."},"axisXTemporal":{"$ref":"#/definitions/AxisConfig","description":"Config for x-temporal axes."},"axisY":{"$ref":"#/definitions/AxisConfig","description":"Y-axis specific config."},"axisYBand":{"$ref":"#/definitions/AxisConfig","description":"Config for y-axes with \\"band\\" scales."},"axisYDiscrete":{"$ref":"#/definitions/AxisConfig","description":"Config for y-axes with \\"point\\" or \\"band\\" scales."},"axisYPoint":{"$ref":"#/definitions/AxisConfig","description":"Config for y-axes with \\"point\\" scales."},"axisYQuantitative":{"$ref":"#/definitions/AxisConfig","description":"Config for y-quantitative axes."},"axisYTemporal":{"$ref":"#/definitions/AxisConfig","description":"Config for y-temporal axes."},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bar":{"$ref":"#/definitions/BarConfig","description":"Bar-Specific Config"},"boxplot":{"$ref":"#/definitions/BoxPlotConfig","description":"Box Config"},"circle":{"$ref":"#/definitions/MarkConfig","description":"Circle-Specific Config"},"concat":{"$ref":"#/definitions/CompositionConfig","description":"Default configuration for all concatenation and repeat view composition operators (`concat`, `hconcat`, `vconcat`, and `repeat`)"},"countTitle":{"description":"Default axis and legend title for count fields.\\n\\n__Default value:__ `\'Count of Records`.","type":"string"},"customFormatTypes":{"description":"Allow the `formatType` property for text marks and guides to accept a custom formatter function [registered as a Vega expression](https://vega.github.io/vega-lite/usage/compile.html#format-type).","type":"boolean"},"errorband":{"$ref":"#/definitions/ErrorBandConfig","description":"ErrorBand Config"},"errorbar":{"$ref":"#/definitions/ErrorBarConfig","description":"ErrorBar Config"},"facet":{"$ref":"#/definitions/CompositionConfig","description":"Default configuration for the `facet` view composition operator"},"fieldTitle":{"description":"Defines how Vega-Lite generates title for fields. There are three possible styles:\\n- `\\"verbal\\"` (Default) - displays function in a verbal style (e.g., \\"Sum of field\\", \\"Year-month of date\\", \\"field (binned)\\").\\n- `\\"function\\"` - displays function using parentheses and capitalized texts (e.g., \\"SUM(field)\\", \\"YEARMONTH(date)\\", \\"BIN(field)\\").\\n- `\\"plain\\"` - displays only the field name without functions (e.g., \\"field\\", \\"date\\", \\"field\\").","enum":["verbal","functional","plain"],"type":"string"},"font":{"description":"Default font for all text marks, titles, and labels.","type":"string"},"geoshape":{"$ref":"#/definitions/MarkConfig","description":"Geoshape-Specific Config"},"header":{"$ref":"#/definitions/HeaderConfig","description":"Header configuration, which determines default properties for all [headers](https://vega.github.io/vega-lite/docs/header.html).\\n\\nFor a full list of header configuration options, please see the [corresponding section of in the header documentation](https://vega.github.io/vega-lite/docs/header.html#config)."},"headerColumn":{"$ref":"#/definitions/HeaderConfig","description":"Header configuration, which determines default properties for column [headers](https://vega.github.io/vega-lite/docs/header.html).\\n\\nFor a full list of header configuration options, please see the [corresponding section of in the header documentation](https://vega.github.io/vega-lite/docs/header.html#config)."},"headerFacet":{"$ref":"#/definitions/HeaderConfig","description":"Header configuration, which determines default properties for non-row/column facet [headers](https://vega.github.io/vega-lite/docs/header.html).\\n\\nFor a full list of header configuration options, please see the [corresponding section of in the header documentation](https://vega.github.io/vega-lite/docs/header.html#config)."},"headerRow":{"$ref":"#/definitions/HeaderConfig","description":"Header configuration, which determines default properties for row [headers](https://vega.github.io/vega-lite/docs/header.html).\\n\\nFor a full list of header configuration options, please see the [corresponding section of in the header documentation](https://vega.github.io/vega-lite/docs/header.html#config)."},"image":{"$ref":"#/definitions/RectConfig","description":"Image-specific Config"},"legend":{"$ref":"#/definitions/LegendConfig","description":"Legend configuration, which determines default properties for all [legends](https://vega.github.io/vega-lite/docs/legend.html). For a full list of legend configuration options, please see the [corresponding section of in the legend documentation](https://vega.github.io/vega-lite/docs/legend.html#config)."},"line":{"$ref":"#/definitions/LineConfig","description":"Line-Specific Config"},"lineBreak":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property provides a global default for text marks, which is overridden by mark or style config settings, and by the lineBreak mark encoding channel. If signal-valued, either string or regular expression (regexp) values are valid."},"locale":{"$ref":"#/definitions/Locale","description":"Locale definitions for string parsing and formatting of number and date values. The locale object should contain `number` and/or `time` properties with [locale definitions](https://vega.github.io/vega/docs/api/locale/). Locale definitions provided in the config block may be overridden by the View constructor locale option."},"mark":{"$ref":"#/definitions/MarkConfig","description":"Mark Config"},"normalizedNumberFormat":{"description":"If normalizedNumberFormatType is not specified, D3 number format for axis labels, text marks, and tooltips of normalized stacked fields (fields with `stack: \\"normalize\\"`). For example `\\"s\\"` for SI units. Use [D3\'s number format pattern](https://github.com/d3/d3-format#locale_format).\\n\\nIf `config.normalizedNumberFormatType` is specified and `config.customFormatTypes` is `true`, this value will be passed as `format` alongside `datum.value` to the `config.numberFormatType` function. __Default value:__ `%`","type":"string"},"normalizedNumberFormatType":{"description":"[Custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type) for `config.normalizedNumberFormat`.\\n\\n__Default value:__ `undefined` -- This is equilvalent to call D3-format, which is exposed as [`format` in Vega-Expression](https://vega.github.io/vega/docs/expressions/#format). __Note:__ You must also set `customFormatTypes` to `true` to use this feature.","type":"string"},"numberFormat":{"description":"If numberFormatType is not specified, D3 number format for guide labels, text marks, and tooltips of non-normalized fields (fields *without* `stack: \\"normalize\\"`). For example `\\"s\\"` for SI units. Use [D3\'s number format pattern](https://github.com/d3/d3-format#locale_format).\\n\\nIf `config.numberFormatType` is specified and `config.customFormatTypes` is `true`, this value will be passed as `format` alongside `datum.value` to the `config.numberFormatType` function.","type":"string"},"numberFormatType":{"description":"[Custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type) for `config.numberFormat`.\\n\\n__Default value:__ `undefined` -- This is equilvalent to call D3-format, which is exposed as [`format` in Vega-Expression](https://vega.github.io/vega/docs/expressions/#format). __Note:__ You must also set `customFormatTypes` to `true` to use this feature.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"point":{"$ref":"#/definitions/MarkConfig","description":"Point-Specific Config"},"projection":{"$ref":"#/definitions/ProjectionConfig","description":"Projection configuration, which determines default properties for all [projections](https://vega.github.io/vega-lite/docs/projection.html). For a full list of projection configuration options, please see the [corresponding section of the projection documentation](https://vega.github.io/vega-lite/docs/projection.html#config)."},"range":{"$ref":"#/definitions/RangeConfig","description":"An object hash that defines default range arrays or schemes for using with scales. For a full list of scale range configuration options, please see the [corresponding section of the scale documentation](https://vega.github.io/vega-lite/docs/scale.html#config)."},"rect":{"$ref":"#/definitions/RectConfig","description":"Rect-Specific Config"},"rule":{"$ref":"#/definitions/MarkConfig","description":"Rule-Specific Config"},"scale":{"$ref":"#/definitions/ScaleConfig","description":"Scale configuration determines default properties for all [scales](https://vega.github.io/vega-lite/docs/scale.html). For a full list of scale configuration options, please see the [corresponding section of the scale documentation](https://vega.github.io/vega-lite/docs/scale.html#config)."},"selection":{"$ref":"#/definitions/SelectionConfig","description":"An object hash for defining default properties for each type of selections."},"square":{"$ref":"#/definitions/MarkConfig","description":"Square-Specific Config"},"style":{"$ref":"#/definitions/StyleConfigIndex","description":"An object hash that defines key-value mappings to determine default properties for marks with a given [style](https://vega.github.io/vega-lite/docs/mark.html#mark-def). The keys represent styles names; the values have to be valid [mark configuration objects](https://vega.github.io/vega-lite/docs/mark.html#config)."},"text":{"$ref":"#/definitions/MarkConfig","description":"Text-Specific Config"},"tick":{"$ref":"#/definitions/TickConfig","description":"Tick-Specific Config"},"timeFormat":{"description":"Default time format for raw time values (without time units) in text marks, legend labels and header labels.\\n\\n__Default value:__ `\\"%b %d, %Y\\"` __Note:__ Axes automatically determine the format for each label automatically so this config does not affect axes.","type":"string"},"timeFormatType":{"description":"[Custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type) for `config.timeFormat`.\\n\\n__Default value:__ `undefined` -- This is equilvalent to call D3-time-format, which is exposed as [`timeFormat` in Vega-Expression](https://vega.github.io/vega/docs/expressions/#timeFormat). __Note:__ You must also set `customFormatTypes` to `true` and there must *not* be a `timeUnit` defined to use this feature.","type":"string"},"title":{"$ref":"#/definitions/TitleConfig","description":"Title configuration, which determines default properties for all [titles](https://vega.github.io/vega-lite/docs/title.html). For a full list of title configuration options, please see the [corresponding section of the title documentation](https://vega.github.io/vega-lite/docs/title.html#config)."},"tooltipFormat":{"$ref":"#/definitions/FormatConfig","description":"Define [custom format configuration](https://vega.github.io/vega-lite/docs/config.html#format) for tooltips. If unspecified, default format config will be applied."},"trail":{"$ref":"#/definitions/LineConfig","description":"Trail-Specific Config"},"view":{"$ref":"#/definitions/ViewConfig","description":"Default properties for [single view plots](https://vega.github.io/vega-lite/docs/spec.html#single)."}},"type":"object"},"CsvDataFormat":{"additionalProperties":false,"properties":{"parse":{"anyOf":[{"$ref":"#/definitions/Parse"},{"type":"null"}],"description":"If set to `null`, disable type inference based on the spec and only use type inference based on the data. Alternatively, a parsing directive object can be provided for explicit data types. Each property of the object corresponds to a field name, and the value to the desired data type (one of `\\"number\\"`, `\\"boolean\\"`, `\\"date\\"`, or null (do not parse the field)). For example, `\\"parse\\": {\\"modified_on\\": \\"date\\"}` parses the `modified_on` field in each input record a Date value.\\n\\nFor `\\"date\\"`, we parse data based using JavaScript\'s [`Date.parse()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse). For Specific date formats can be provided (e.g., `{foo: \\"date:\'%m%d%Y\'\\"}`), using the [d3-time-format syntax](https://github.com/d3/d3-time-format#locale_format). UTC date format parsing is supported similarly (e.g., `{foo: \\"utc:\'%m%d%Y\'\\"}`). See more about [UTC time](https://vega.github.io/vega-lite/docs/timeunit.html#utc)"},"type":{"description":"Type of input data: `\\"json\\"`, `\\"csv\\"`, `\\"tsv\\"`, `\\"dsv\\"`.\\n\\n__Default value:__  The default format type is determined by the extension of the file URL. If no extension is detected, `\\"json\\"` will be used by default.","enum":["csv","tsv"],"type":"string"}},"type":"object"},"Cursor":{"enum":["auto","default","none","context-menu","help","pointer","progress","wait","cell","crosshair","text","vertical-text","alias","copy","move","no-drop","not-allowed","e-resize","n-resize","ne-resize","nw-resize","s-resize","se-resize","sw-resize","w-resize","ew-resize","ns-resize","nesw-resize","nwse-resize","col-resize","row-resize","all-scroll","zoom-in","zoom-out","grab","grabbing"],"type":"string"},"Cyclical":{"enum":["rainbow","sinebow"],"type":"string"},"Data":{"anyOf":[{"$ref":"#/definitions/DataSource"},{"$ref":"#/definitions/Generator"}]},"DataFormat":{"anyOf":[{"$ref":"#/definitions/CsvDataFormat"},{"$ref":"#/definitions/DsvDataFormat"},{"$ref":"#/definitions/JsonDataFormat"},{"$ref":"#/definitions/TopoDataFormat"}]},"DataSource":{"anyOf":[{"$ref":"#/definitions/UrlData"},{"$ref":"#/definitions/InlineData"},{"$ref":"#/definitions/NamedData"}]},"Datasets":{"$ref":"#/definitions/Dict<InlineDataset>"},"DateTime":{"additionalProperties":false,"description":"Object for defining datetime in Vega-Lite Filter. If both month and quarter are provided, month has higher precedence. `day` cannot be combined with other date. We accept string for month and day names.","properties":{"date":{"description":"Integer value representing the date (day of the month) from 1-31.","maximum":31,"minimum":1,"type":"number"},"day":{"anyOf":[{"$ref":"#/definitions/Day"},{"type":"string"}],"description":"Value representing the day of a week. This can be one of: (1) integer value -- `1` represents Monday; (2) case-insensitive day name (e.g., `\\"Monday\\"`); (3) case-insensitive, 3-character short day name (e.g., `\\"Mon\\"`).\\n\\n**Warning:** A DateTime definition object with `day`** should not be combined with `year`, `quarter`, `month`, or `date`."},"hours":{"description":"Integer value representing the hour of a day from 0-23.","maximum":24,"minimum":0,"type":"number"},"milliseconds":{"description":"Integer value representing the millisecond segment of time.","maximum":1000,"minimum":0,"type":"number"},"minutes":{"description":"Integer value representing the minute segment of time from 0-59.","maximum":60,"minimum":0,"type":"number"},"month":{"anyOf":[{"$ref":"#/definitions/Month"},{"type":"string"}],"description":"One of: (1) integer value representing the month from `1`-`12`. `1` represents January; (2) case-insensitive month name (e.g., `\\"January\\"`); (3) case-insensitive, 3-character short month name (e.g., `\\"Jan\\"`)."},"quarter":{"description":"Integer value representing the quarter of the year (from 1-4).","maximum":4,"minimum":1,"type":"number"},"seconds":{"description":"Integer value representing the second segment (0-59) of a time value","maximum":60,"minimum":0,"type":"number"},"utc":{"description":"A boolean flag indicating if date time is in utc time. If false, the date time is in local time","type":"boolean"},"year":{"description":"Integer value representing the year.","type":"number"}},"type":"object"},"DatumDef":{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"Day":{"maximum":7,"minimum":1,"type":"number"},"DensityTransform":{"additionalProperties":false,"properties":{"as":{"description":"The output fields for the sample value and corresponding density estimate.\\n\\n__Default value:__ `[\\"value\\", \\"density\\"]`","items":{"$ref":"#/definitions/FieldName"},"maxItems":2,"minItems":2,"type":"array"},"bandwidth":{"description":"The bandwidth (standard deviation) of the Gaussian kernel. If unspecified or set to zero, the bandwidth value is automatically estimated from the input data using Scott\u2019s rule.","type":"number"},"counts":{"description":"A boolean flag indicating if the output values should be probability estimates (false) or smoothed counts (true).\\n\\n__Default value:__ `false`","type":"boolean"},"cumulative":{"description":"A boolean flag indicating whether to produce density estimates (false) or cumulative density estimates (true).\\n\\n__Default value:__ `false`","type":"boolean"},"density":{"$ref":"#/definitions/FieldName","description":"The data field for which to perform density estimation."},"extent":{"description":"A [min, max] domain from which to sample the distribution. If unspecified, the extent will be determined by the observed minimum and maximum values of the density value field.","items":{"type":"number"},"maxItems":2,"minItems":2,"type":"array"},"groupby":{"description":"The data fields to group by. If not specified, a single group containing all data objects will be used.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"maxsteps":{"description":"The maximum number of samples to take along the extent domain for plotting the density.\\n\\n__Default value:__ `200`","type":"number"},"minsteps":{"description":"The minimum number of samples to take along the extent domain for plotting the density.\\n\\n__Default value:__ `25`","type":"number"},"resolve":{"description":"Indicates how parameters for multiple densities should be resolved. If `\\"independent\\"`, each density may have its own domain extent and dynamic number of curve sample steps. If `\\"shared\\"`, the KDE transform will ensure that all densities are defined over a shared domain and curve steps, enabling stacking.\\n\\n__Default value:__ `\\"shared\\"`","enum":["independent","shared"],"type":"string"},"steps":{"description":"The exact number of samples to take along the extent domain for plotting the density. If specified, overrides both minsteps and maxsteps to set an exact number of uniform samples. Potentially useful in conjunction with a fixed extent to ensure consistent sample points for stacked densities.","type":"number"}},"required":["density"],"type":"object"},"DerivedStream":{"additionalProperties":false,"properties":{"between":{"items":{"$ref":"#/definitions/Stream"},"type":"array"},"consume":{"type":"boolean"},"debounce":{"type":"number"},"filter":{"anyOf":[{"$ref":"#/definitions/Expr"},{"items":{"$ref":"#/definitions/Expr"},"type":"array"}]},"markname":{"type":"string"},"marktype":{"$ref":"#/definitions/MarkType"},"stream":{"$ref":"#/definitions/Stream"},"throttle":{"type":"number"}},"required":["stream"],"type":"object"},"Dict<InlineDataset>":{"additionalProperties":{"$ref":"#/definitions/InlineDataset"},"type":"object"},"Dict<SelectionInit>":{"additionalProperties":{"$ref":"#/definitions/SelectionInit"},"type":"object"},"Dict<SelectionInitInterval>":{"additionalProperties":{"$ref":"#/definitions/SelectionInitInterval"},"type":"object"},"Dict":{"additionalProperties":{},"type":"object"},"Diverging":{"enum":["blueorange","blueorange-3","blueorange-4","blueorange-5","blueorange-6","blueorange-7","blueorange-8","blueorange-9","blueorange-10","blueorange-11","brownbluegreen","brownbluegreen-3","brownbluegreen-4","brownbluegreen-5","brownbluegreen-6","brownbluegreen-7","brownbluegreen-8","brownbluegreen-9","brownbluegreen-10","brownbluegreen-11","purplegreen","purplegreen-3","purplegreen-4","purplegreen-5","purplegreen-6","purplegreen-7","purplegreen-8","purplegreen-9","purplegreen-10","purplegreen-11","pinkyellowgreen","pinkyellowgreen-3","pinkyellowgreen-4","pinkyellowgreen-5","pinkyellowgreen-6","pinkyellowgreen-7","pinkyellowgreen-8","pinkyellowgreen-9","pinkyellowgreen-10","pinkyellowgreen-11","purpleorange","purpleorange-3","purpleorange-4","purpleorange-5","purpleorange-6","purpleorange-7","purpleorange-8","purpleorange-9","purpleorange-10","purpleorange-11","redblue","redblue-3","redblue-4","redblue-5","redblue-6","redblue-7","redblue-8","redblue-9","redblue-10","redblue-11","redgrey","redgrey-3","redgrey-4","redgrey-5","redgrey-6","redgrey-7","redgrey-8","redgrey-9","redgrey-10","redgrey-11","redyellowblue","redyellowblue-3","redyellowblue-4","redyellowblue-5","redyellowblue-6","redyellowblue-7","redyellowblue-8","redyellowblue-9","redyellowblue-10","redyellowblue-11","redyellowgreen","redyellowgreen-3","redyellowgreen-4","redyellowgreen-5","redyellowgreen-6","redyellowgreen-7","redyellowgreen-8","redyellowgreen-9","redyellowgreen-10","redyellowgreen-11","spectral","spectral-3","spectral-4","spectral-5","spectral-6","spectral-7","spectral-8","spectral-9","spectral-10","spectral-11"],"type":"string"},"DomainUnionWith":{"additionalProperties":false,"properties":{"unionWith":{"description":"Customized domain values to be union with the field\'s values or explicitly defined domain. Should be an array of valid scale domain values.","items":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/DateTime"}]},"type":"array"}},"required":["unionWith"],"type":"object"},"DsvDataFormat":{"additionalProperties":false,"properties":{"delimiter":{"description":"The delimiter between records. The delimiter must be a single character (i.e., a single 16-bit code unit); so, ASCII delimiters are fine, but emoji delimiters are not.","maxLength":1,"minLength":1,"type":"string"},"parse":{"anyOf":[{"$ref":"#/definitions/Parse"},{"type":"null"}],"description":"If set to `null`, disable type inference based on the spec and only use type inference based on the data. Alternatively, a parsing directive object can be provided for explicit data types. Each property of the object corresponds to a field name, and the value to the desired data type (one of `\\"number\\"`, `\\"boolean\\"`, `\\"date\\"`, or null (do not parse the field)). For example, `\\"parse\\": {\\"modified_on\\": \\"date\\"}` parses the `modified_on` field in each input record a Date value.\\n\\nFor `\\"date\\"`, we parse data based using JavaScript\'s [`Date.parse()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse). For Specific date formats can be provided (e.g., `{foo: \\"date:\'%m%d%Y\'\\"}`), using the [d3-time-format syntax](https://github.com/d3/d3-time-format#locale_format). UTC date format parsing is supported similarly (e.g., `{foo: \\"utc:\'%m%d%Y\'\\"}`). See more about [UTC time](https://vega.github.io/vega-lite/docs/timeunit.html#utc)"},"type":{"const":"dsv","description":"Type of input data: `\\"json\\"`, `\\"csv\\"`, `\\"tsv\\"`, `\\"dsv\\"`.\\n\\n__Default value:__  The default format type is determined by the extension of the file URL. If no extension is detected, `\\"json\\"` will be used by default.","type":"string"}},"required":["delimiter"],"type":"object"},"Element":{"type":"string"},"EncodingSortField":{"additionalProperties":false,"description":"A sort definition for sorting a discrete scale in an encoding field definition.","properties":{"field":{"$ref":"#/definitions/Field","description":"The data [field](https://vega.github.io/vega-lite/docs/field.html) to sort by.\\n\\n__Default value:__ If unspecified, defaults to the field specified in the outer data reference."},"op":{"$ref":"#/definitions/NonArgAggregateOp","description":"An [aggregate operation](https://vega.github.io/vega-lite/docs/aggregate.html#ops) to perform on the field prior to sorting (e.g., `\\"count\\"`, `\\"mean\\"` and `\\"median\\"`). An aggregation is required when there are multiple values of the sort field for each encoded data field. The input data objects will be aggregated, grouped by the encoded data field.\\n\\nFor a full list of operations, please see the documentation for [aggregate](https://vega.github.io/vega-lite/docs/aggregate.html#ops).\\n\\n__Default value:__ `\\"sum\\"` for stacked plots. Otherwise, `\\"min\\"`."},"order":{"anyOf":[{"$ref":"#/definitions/SortOrder"},{"type":"null"}],"description":"The sort order. One of `\\"ascending\\"` (default), `\\"descending\\"`, or `null` (do not sort)."}},"type":"object"},"ErrorBand":{"const":"errorband","type":"string"},"ErrorBandConfig":{"additionalProperties":false,"properties":{"band":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"borders":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"extent":{"$ref":"#/definitions/ErrorBarExtent","description":"The extent of the band. Available options include:\\n- `\\"ci\\"`: Extend the band to the 95% bootstrapped confidence interval of the mean.\\n- `\\"stderr\\"`: The size of band are set to the value of standard error, extending from the mean.\\n- `\\"stdev\\"`: The size of band are set to the value of standard deviation, extending from the mean.\\n- `\\"iqr\\"`: Extend the band to the q1 and q3.\\n\\n__Default value:__ `\\"stderr\\"`."},"interpolate":{"$ref":"#/definitions/Interpolate","description":"The line interpolation method for the error band. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: a piecewise constant function (a step function) consisting of alternating horizontal and vertical lines. The y-value changes at the midpoint of each pair of adjacent x-values.\\n- `\\"step-before\\"`: a piecewise constant function (a step function) consisting of alternating horizontal and vertical lines. The y-value changes before the x-value.\\n- `\\"step-after\\"`: a piecewise constant function (a step function) consisting of alternating horizontal and vertical lines. The y-value changes after the x-value.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},"tension":{"description":"The tension parameter for the interpolation type of the error band.","maximum":1,"minimum":0,"type":"number"}},"type":"object"},"ErrorBandDef":{"additionalProperties":false,"properties":{"band":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"borders":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"clip":{"description":"Whether a composite mark be clipped to the enclosing group\u2019s width and height.","type":"boolean"},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"extent":{"$ref":"#/definitions/ErrorBarExtent","description":"The extent of the band. Available options include:\\n- `\\"ci\\"`: Extend the band to the 95% bootstrapped confidence interval of the mean.\\n- `\\"stderr\\"`: The size of band are set to the value of standard error, extending from the mean.\\n- `\\"stdev\\"`: The size of band are set to the value of standard deviation, extending from the mean.\\n- `\\"iqr\\"`: Extend the band to the q1 and q3.\\n\\n__Default value:__ `\\"stderr\\"`."},"interpolate":{"$ref":"#/definitions/Interpolate","description":"The line interpolation method for the error band. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: a piecewise constant function (a step function) consisting of alternating horizontal and vertical lines. The y-value changes at the midpoint of each pair of adjacent x-values.\\n- `\\"step-before\\"`: a piecewise constant function (a step function) consisting of alternating horizontal and vertical lines. The y-value changes before the x-value.\\n- `\\"step-after\\"`: a piecewise constant function (a step function) consisting of alternating horizontal and vertical lines. The y-value changes after the x-value.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},"opacity":{"description":"The opacity (value between [0,1]) of the mark.","maximum":1,"minimum":0,"type":"number"},"orient":{"$ref":"#/definitions/Orientation","description":"Orientation of the error band. This is normally automatically determined, but can be specified when the orientation is ambiguous and cannot be automatically determined."},"tension":{"description":"The tension parameter for the interpolation type of the error band.","maximum":1,"minimum":0,"type":"number"},"type":{"$ref":"#/definitions/ErrorBand","description":"The mark type. This could a primitive mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"geoshape\\"`, `\\"rule\\"`, and `\\"text\\"`) or a composite mark type (`\\"boxplot\\"`, `\\"errorband\\"`, `\\"errorbar\\"`)."}},"required":["type"],"type":"object"},"ErrorBar":{"const":"errorbar","type":"string"},"ErrorBarConfig":{"additionalProperties":false,"properties":{"extent":{"$ref":"#/definitions/ErrorBarExtent","description":"The extent of the rule. Available options include:\\n- `\\"ci\\"`: Extend the rule to the 95% bootstrapped confidence interval of the mean.\\n- `\\"stderr\\"`: The size of rule are set to the value of standard error, extending from the mean.\\n- `\\"stdev\\"`: The size of rule are set to the value of standard deviation, extending from the mean.\\n- `\\"iqr\\"`: Extend the rule to the q1 and q3.\\n\\n__Default value:__ `\\"stderr\\"`."},"rule":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"size":{"description":"Size of the ticks of an error bar","type":"number"},"thickness":{"description":"Thickness of the ticks and the bar of an error bar","type":"number"},"ticks":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]}},"type":"object"},"ErrorBarDef":{"additionalProperties":false,"properties":{"clip":{"description":"Whether a composite mark be clipped to the enclosing group\u2019s width and height.","type":"boolean"},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"extent":{"$ref":"#/definitions/ErrorBarExtent","description":"The extent of the rule. Available options include:\\n- `\\"ci\\"`: Extend the rule to the 95% bootstrapped confidence interval of the mean.\\n- `\\"stderr\\"`: The size of rule are set to the value of standard error, extending from the mean.\\n- `\\"stdev\\"`: The size of rule are set to the value of standard deviation, extending from the mean.\\n- `\\"iqr\\"`: Extend the rule to the q1 and q3.\\n\\n__Default value:__ `\\"stderr\\"`."},"opacity":{"description":"The opacity (value between [0,1]) of the mark.","maximum":1,"minimum":0,"type":"number"},"orient":{"$ref":"#/definitions/Orientation","description":"Orientation of the error bar. This is normally automatically determined, but can be specified when the orientation is ambiguous and cannot be automatically determined."},"rule":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"size":{"description":"Size of the ticks of an error bar","type":"number"},"thickness":{"description":"Thickness of the ticks and the bar of an error bar","type":"number"},"ticks":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/AnyMarkConfig"}]},"type":{"$ref":"#/definitions/ErrorBar","description":"The mark type. This could a primitive mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"geoshape\\"`, `\\"rule\\"`, and `\\"text\\"`) or a composite mark type (`\\"boxplot\\"`, `\\"errorband\\"`, `\\"errorbar\\"`)."}},"required":["type"],"type":"object"},"ErrorBarExtent":{"enum":["ci","iqr","stderr","stdev"],"type":"string"},"EventStream":{"anyOf":[{"additionalProperties":false,"properties":{"between":{"items":{"$ref":"#/definitions/Stream"},"type":"array"},"consume":{"type":"boolean"},"debounce":{"type":"number"},"filter":{"anyOf":[{"$ref":"#/definitions/Expr"},{"items":{"$ref":"#/definitions/Expr"},"type":"array"}]},"markname":{"type":"string"},"marktype":{"$ref":"#/definitions/MarkType"},"source":{"enum":["view","scope"],"type":"string"},"throttle":{"type":"number"},"type":{"$ref":"#/definitions/EventType"}},"required":["type"],"type":"object"},{"additionalProperties":false,"properties":{"between":{"items":{"$ref":"#/definitions/Stream"},"type":"array"},"consume":{"type":"boolean"},"debounce":{"type":"number"},"filter":{"anyOf":[{"$ref":"#/definitions/Expr"},{"items":{"$ref":"#/definitions/Expr"},"type":"array"}]},"markname":{"type":"string"},"marktype":{"$ref":"#/definitions/MarkType"},"source":{"const":"window","type":"string"},"throttle":{"type":"number"},"type":{"$ref":"#/definitions/WindowEventType"}},"required":["source","type"],"type":"object"}]},"EventType":{"enum":["click","dblclick","dragenter","dragleave","dragover","keydown","keypress","keyup","mousedown","mousemove","mouseout","mouseover","mouseup","mousewheel","pointerdown","pointermove","pointerout","pointerover","pointerup","timer","touchend","touchmove","touchstart","wheel"],"type":"string"},"Expr":{"type":"string"},"ExprRef":{"additionalProperties":false,"properties":{"expr":{"description":"Vega expression (which can refer to Vega-Lite parameters).","type":"string"}},"required":["expr"],"type":"object"},"ExtentTransform":{"additionalProperties":false,"properties":{"extent":{"$ref":"#/definitions/FieldName","description":"The field of which to get the extent."},"param":{"$ref":"#/definitions/ParameterName","description":"The output parameter produced by the extent transform."}},"required":["extent","param"],"type":"object"},"FacetEncodingFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"header":{"anyOf":[{"$ref":"#/definitions/Header"},{"type":"null"}],"description":"An object defining properties of a facet\'s header."},"sort":{"anyOf":[{"$ref":"#/definitions/SortArray"},{"$ref":"#/definitions/SortOrder"},{"$ref":"#/definitions/EncodingSortField"},{"type":"null"}],"description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` is not supported for `row` and `column`."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FacetFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"header":{"anyOf":[{"$ref":"#/definitions/Header"},{"type":"null"}],"description":"An object defining properties of a facet\'s header."},"sort":{"anyOf":[{"$ref":"#/definitions/SortArray"},{"$ref":"#/definitions/SortOrder"},{"$ref":"#/definitions/EncodingSortField"},{"type":"null"}],"description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` is not supported for `row` and `column`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FacetMapping":{"additionalProperties":false,"properties":{"column":{"$ref":"#/definitions/FacetFieldDef","description":"A field definition for the horizontal facet of trellis plots."},"row":{"$ref":"#/definitions/FacetFieldDef","description":"A field definition for the vertical facet of trellis plots."}},"type":"object"},"FacetedEncoding":{"additionalProperties":false,"properties":{"angle":{"$ref":"#/definitions/NumericMarkPropDef","description":"Rotation angle of point and text marks."},"color":{"$ref":"#/definitions/ColorDef","description":"Color of the marks \u2013 either fill or stroke color based on  the `filled` property of mark definition. By default, `color` represents fill color for `\\"area\\"`, `\\"bar\\"`, `\\"tick\\"`, `\\"text\\"`, `\\"trail\\"`, `\\"circle\\"`, and `\\"square\\"` / stroke color for `\\"line\\"` and `\\"point\\"`.\\n\\n__Default value:__ If undefined, the default color depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `color` property.\\n\\n_Note:_ 1) For fine-grained control over both fill and stroke colors of the marks, please use the `fill` and `stroke` channels. The `fill` or `stroke` encodings have higher precedence than `color`, thus may override the `color` encoding if conflicting encodings are specified. 2) See the scale documentation for more information about customizing [color scheme](https://vega.github.io/vega-lite/docs/scale.html#scheme)."},"column":{"$ref":"#/definitions/RowColumnEncodingFieldDef","description":"A field definition for the horizontal facet of trellis plots."},"description":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"}],"description":"A text description of this mark for ARIA accessibility (SVG output only). For SVG output the `\\"aria-label\\"` attribute will be set to this description."},"detail":{"anyOf":[{"$ref":"#/definitions/FieldDefWithoutScale"},{"items":{"$ref":"#/definitions/FieldDefWithoutScale"},"type":"array"}],"description":"Additional levels of detail for grouping data in aggregate views and in line, trail, and area marks without mapping data to a specific visual channel."},"facet":{"$ref":"#/definitions/FacetEncodingFieldDef","description":"A field definition for the (flexible) facet of trellis plots.\\n\\nIf either `row` or `column` is specified, this channel will be ignored."},"fill":{"$ref":"#/definitions/ColorDef","description":"Fill color of the marks. __Default value:__ If undefined, the default color depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `color` property.\\n\\n_Note:_ The `fill` encoding has higher precedence than `color`, thus may override the `color` encoding if conflicting encodings are specified."},"fillOpacity":{"$ref":"#/definitions/NumericMarkPropDef","description":"Fill opacity of the marks.\\n\\n__Default value:__ If undefined, the default opacity depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `fillOpacity` property."},"href":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"}],"description":"A URL to load upon mouse click."},"key":{"$ref":"#/definitions/FieldDefWithoutScale","description":"A data field to use as a unique key for data binding. When a visualization\u2019s data is updated, the key value will be used to match data elements to existing mark instances. Use a key channel to enable object constancy for transitions over dynamic data."},"latitude":{"$ref":"#/definitions/LatLongDef","description":"Latitude position of geographically projected marks."},"latitude2":{"$ref":"#/definitions/Position2Def","description":"Latitude-2 position for geographically projected ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`."},"longitude":{"$ref":"#/definitions/LatLongDef","description":"Longitude position of geographically projected marks."},"longitude2":{"$ref":"#/definitions/Position2Def","description":"Longitude-2 position for geographically projected ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`."},"opacity":{"$ref":"#/definitions/NumericMarkPropDef","description":"Opacity of the marks.\\n\\n__Default value:__ If undefined, the default opacity depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `opacity` property."},"order":{"anyOf":[{"$ref":"#/definitions/OrderFieldDef"},{"items":{"$ref":"#/definitions/OrderFieldDef"},"type":"array"},{"$ref":"#/definitions/OrderValueDef"},{"$ref":"#/definitions/OrderOnlyDef"}],"description":"Order of the marks.\\n- For stacked marks, this `order` channel encodes [stack order](https://vega.github.io/vega-lite/docs/stack.html#order).\\n- For line and trail marks, this `order` channel encodes order of data points in the lines. This can be useful for creating [a connected scatterplot](https://vega.github.io/vega-lite/examples/connected_scatterplot.html). Setting `order` to `{\\"value\\": null}` makes the line marks use the original order in the data sources.\\n- Otherwise, this `order` channel encodes layer order of the marks.\\n\\n__Note__: In aggregate plots, `order` field should be `aggregate`d to avoid creating additional aggregation grouping."},"radius":{"$ref":"#/definitions/PolarDef","description":"The outer radius in pixels of arc marks."},"radius2":{"$ref":"#/definitions/Position2Def","description":"The inner radius in pixels of arc marks."},"row":{"$ref":"#/definitions/RowColumnEncodingFieldDef","description":"A field definition for the vertical facet of trellis plots."},"shape":{"$ref":"#/definitions/ShapeDef","description":"Shape of the mark.\\n\\n1. For `point` marks the supported values include:   - plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.   - the line symbol `\\"stroke\\"`   - centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`   - a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n2. For `geoshape` marks it should be a field definition of the geojson data\\n\\n__Default value:__ If undefined, the default shape depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#point-config)\'s `shape` property. (`\\"circle\\"` if unset.)"},"size":{"$ref":"#/definitions/NumericMarkPropDef","description":"Size of the mark.\\n- For `\\"point\\"`, `\\"square\\"` and `\\"circle\\"`, \u2013 the symbol size, or pixel area of the mark.\\n- For `\\"bar\\"` and `\\"tick\\"` \u2013 the bar and tick\'s size.\\n- For `\\"text\\"` \u2013 the text\'s font size.\\n- Size is unsupported for `\\"line\\"`, `\\"area\\"`, and `\\"rect\\"`. (Use `\\"trail\\"` instead of line with varying size)"},"stroke":{"$ref":"#/definitions/ColorDef","description":"Stroke color of the marks. __Default value:__ If undefined, the default color depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `color` property.\\n\\n_Note:_ The `stroke` encoding has higher precedence than `color`, thus may override the `color` encoding if conflicting encodings are specified."},"strokeDash":{"$ref":"#/definitions/NumericArrayMarkPropDef","description":"Stroke dash of the marks.\\n\\n__Default value:__ `[1,0]` (No dash)."},"strokeOpacity":{"$ref":"#/definitions/NumericMarkPropDef","description":"Stroke opacity of the marks.\\n\\n__Default value:__ If undefined, the default opacity depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `strokeOpacity` property."},"strokeWidth":{"$ref":"#/definitions/NumericMarkPropDef","description":"Stroke width of the marks.\\n\\n__Default value:__ If undefined, the default stroke width depends on [mark config](https://vega.github.io/vega-lite/docs/config.html#mark-config)\'s `strokeWidth` property."},"text":{"$ref":"#/definitions/TextDef","description":"Text of the `text` mark."},"theta":{"$ref":"#/definitions/PolarDef","description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians."},"theta2":{"$ref":"#/definitions/Position2Def","description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"$ref":"#/definitions/TimeDef"},"tooltip":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"},{"items":{"$ref":"#/definitions/StringFieldDef"},"type":"array"},{"type":"null"}],"description":"The tooltip text to show upon mouse hover. Specifying `tooltip` encoding overrides [the `tooltip` property in the mark definition](https://vega.github.io/vega-lite/docs/mark.html#mark-def).\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip in Vega-Lite."},"url":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"}],"description":"The URL of an image mark."},"x":{"$ref":"#/definitions/PositionDef","description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"$ref":"#/definitions/Position2Def","description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"xError":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Error value of x coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"xError2":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Secondary error value of x coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"xOffset":{"$ref":"#/definitions/OffsetDef","description":"Offset of x-position of the marks"},"y":{"$ref":"#/definitions/PositionDef","description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"$ref":"#/definitions/Position2Def","description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"yError":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Error value of y coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"yError2":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/ValueDef<number>"}],"description":"Secondary error value of y coordinates for error specified `\\"errorbar\\"` and `\\"errorband\\"`."},"yOffset":{"$ref":"#/definitions/OffsetDef","description":"Offset of y-position of the marks"}},"type":"object"},"FacetedUnitSpec":{"additionalProperties":false,"description":"Unit spec that can have a composite mark and row or column channels (shorthand for a facet spec).","properties":{"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"encoding":{"$ref":"#/definitions/FacetedEncoding","description":"A key-value mapping between encoding channels and definition of fields."},"height":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The height of a visualization.\\n\\n- For a plot with a continuous y-field, height should be a number.\\n- For a plot with either a discrete y-field or no y-field, height can be either a number indicating a fixed height or an object in the form of `{step: number}` defining the height per discrete step. (No y-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on height, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousHeight` for a plot with a continuous y-field and `config.view.discreteHeight` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the height of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`height`](https://vega.github.io/vega-lite/docs/size.html) documentation."},"mark":{"$ref":"#/definitions/AnyMark","description":"A string describing the mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"rule\\"`, `\\"geoshape\\"`, and `\\"text\\"`) or a [mark definition object](https://vega.github.io/vega-lite/docs/mark.html#mark-def)."},"name":{"description":"Name of the visualization for later reference.","type":"string"},"params":{"description":"An array of parameters that may either be simple variables, or more complex selections that map user input to data queries.","items":{"$ref":"#/definitions/SelectionParameter"},"type":"array"},"projection":{"$ref":"#/definitions/Projection","description":"An object defining properties of geographic projection, which will be applied to `shape` path for `\\"geoshape\\"` marks and to `latitude` and `\\"longitude\\"` channels for other marks."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"view":{"$ref":"#/definitions/ViewBackground","description":"An object defining the view background\'s fill and stroke.\\n\\n__Default value:__ none (transparent)"},"width":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The width of a visualization.\\n\\n- For a plot with a continuous x-field, width should be a number.\\n- For a plot with either a discrete x-field or no x-field, width can be either a number indicating a fixed width or an object in the form of `{step: number}` defining the width per discrete step. (No x-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on width, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousWidth` for a plot with a continuous x-field and `config.view.discreteWidth` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the width of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`width`](https://vega.github.io/vega-lite/docs/size.html) documentation."}},"required":["mark"],"type":"object"},"Feature":{"additionalProperties":false,"description":"A feature object which contains a geometry and associated properties. https://tools.ietf.org/html/rfc7946#section-3.2","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"geometry":{"$ref":"#/definitions/Geometry","description":"The feature\'s geometry"},"id":{"description":"A value that uniquely identifies this feature in a https://tools.ietf.org/html/rfc7946#section-3.2.","type":["string","number"]},"properties":{"$ref":"#/definitions/GeoJsonProperties","description":"Properties associated with this feature."},"type":{"const":"Feature","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["geometry","properties","type"],"type":"object"},"Feature<Geometry,GeoJsonProperties>":{"additionalProperties":false,"description":"A feature object which contains a geometry and associated properties. https://tools.ietf.org/html/rfc7946#section-3.2","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"geometry":{"$ref":"#/definitions/Geometry","description":"The feature\'s geometry"},"id":{"description":"A value that uniquely identifies this feature in a https://tools.ietf.org/html/rfc7946#section-3.2.","type":["string","number"]},"properties":{"$ref":"#/definitions/GeoJsonProperties","description":"Properties associated with this feature."},"type":{"const":"Feature","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["geometry","properties","type"],"type":"object"},"FeatureCollection":{"additionalProperties":false,"description":"A collection of feature objects.  https://tools.ietf.org/html/rfc7946#section-3.3","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"features":{"items":{"$ref":"#/definitions/Feature<Geometry,GeoJsonProperties>"},"type":"array"},"type":{"const":"FeatureCollection","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["features","type"],"type":"object"},"Field":{"anyOf":[{"$ref":"#/definitions/FieldName"},{"$ref":"#/definitions/RepeatRef"}]},"FieldDefWithoutScale":{"$ref":"#/definitions/TypedFieldDef","description":"Field Def without scale (and without bin: \\"binned\\" support)."},"FieldEqualPredicate":{"additionalProperties":false,"properties":{"equal":{"anyOf":[{"type":"string"},{"type":"number"},{"type":"boolean"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"The value that the field should be equal to."},"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["equal","field"],"type":"object"},"FieldGTEPredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"gte":{"anyOf":[{"type":"string"},{"type":"number"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"The value that the field should be greater than or equals to."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["field","gte"],"type":"object"},"FieldGTPredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"gt":{"anyOf":[{"type":"string"},{"type":"number"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"The value that the field should be greater than."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["field","gt"],"type":"object"},"FieldLTEPredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"lte":{"anyOf":[{"type":"string"},{"type":"number"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"The value that the field should be less than or equals to."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["field","lte"],"type":"object"},"FieldLTPredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"lt":{"anyOf":[{"type":"string"},{"type":"number"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"The value that the field should be less than."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["field","lt"],"type":"object"},"FieldName":{"type":"string"},"FieldOneOfPredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"oneOf":{"anyOf":[{"items":{"type":"string"},"type":"array"},{"items":{"type":"number"},"type":"array"},{"items":{"type":"boolean"},"type":"array"},{"items":{"$ref":"#/definitions/DateTime"},"type":"array"}],"description":"A set of values that the `field`\'s value should be a member of, for a data item included in the filtered data."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["field","oneOf"],"type":"object"},"FieldOrDatumDefWithCondition<DatumDef,(Gradient|string|null)>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<DatumDef,(string|null)>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<DatumDef,number>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<DatumDef,number[]>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<MarkPropFieldDef,(Gradient|string|null)>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<MarkPropFieldDef,number>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<MarkPropFieldDef,number[]>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<MarkPropFieldDef<TypeForShape>,(string|null)>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/TypeForShape","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<StringDatumDef,Text>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<StringFieldDef,Text>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldOrDatumDefWithCondition<StringFieldDef,string>":{"additionalProperties":false,"description":"A FieldDef with Condition<ValueDef> {   condition: {value: ...},   field: ...,   ... }","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"FieldRange":{"additionalProperties":false,"properties":{"field":{"type":"string"}},"required":["field"],"type":"object"},"FieldRangePredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"range":{"anyOf":[{"items":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/DateTime"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}]},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"An array of inclusive minimum and maximum values for a field value of a data item to be included in the filtered data.","maxItems":2,"minItems":2},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."}},"required":["field","range"],"type":"object"},"FieldValidPredicate":{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"Field to be tested."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit for the field to be tested."},"valid":{"description":"If set to true the field\'s value has to be valid, meaning both not `null` and not [`NaN`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NaN).","type":"boolean"}},"required":["field","valid"],"type":"object"},"FilterTransform":{"additionalProperties":false,"properties":{"filter":{"$ref":"#/definitions/PredicateComposition","description":"The `filter` property must be a predication definition, which can take one of the following forms:\\n\\n1) an [expression](https://vega.github.io/vega-lite/docs/types.html#expression) string, where `datum` can be used to refer to the current data object. For example, `{filter: \\"datum.b2 > 60\\"}` would make the output data includes only items that have values in the field `b2` over 60.\\n\\n2) one of the [field predicates](https://vega.github.io/vega-lite/docs/predicate.html#field-predicate): [`equal`](https://vega.github.io/vega-lite/docs/predicate.html#field-equal-predicate), [`lt`](https://vega.github.io/vega-lite/docs/predicate.html#lt-predicate), [`lte`](https://vega.github.io/vega-lite/docs/predicate.html#lte-predicate), [`gt`](https://vega.github.io/vega-lite/docs/predicate.html#gt-predicate), [`gte`](https://vega.github.io/vega-lite/docs/predicate.html#gte-predicate), [`range`](https://vega.github.io/vega-lite/docs/predicate.html#range-predicate), [`oneOf`](https://vega.github.io/vega-lite/docs/predicate.html#one-of-predicate), or [`valid`](https://vega.github.io/vega-lite/docs/predicate.html#valid-predicate),\\n\\n3) a [selection predicate](https://vega.github.io/vega-lite/docs/predicate.html#selection-predicate), which define the names of a selection that the data point should belong to (or a logical composition of selections).\\n\\n4) a [logical composition](https://vega.github.io/vega-lite/docs/predicate.html#composition) of (1), (2), or (3)."}},"required":["filter"],"type":"object"},"Fit":{"anyOf":[{"$ref":"#/definitions/GeoJsonFeature"},{"$ref":"#/definitions/GeoJsonFeatureCollection"},{"items":{"$ref":"#/definitions/GeoJsonFeature"},"type":"array"}]},"FlattenTransform":{"additionalProperties":false,"properties":{"as":{"description":"The output field names for extracted array values.\\n\\n__Default value:__ The field name of the corresponding array field","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"flatten":{"description":"An array of one or more data fields containing arrays to flatten. If multiple fields are specified, their array values should have a parallel structure, ideally with the same length. If the lengths of parallel arrays do not match, the longest array will be used with `null` values added for missing entries.","items":{"$ref":"#/definitions/FieldName"},"type":"array"}},"required":["flatten"],"type":"object"},"FoldTransform":{"additionalProperties":false,"properties":{"as":{"description":"The output field names for the key and value properties produced by the fold transform. __Default value:__ `[\\"key\\", \\"value\\"]`","items":{"$ref":"#/definitions/FieldName"},"maxItems":2,"minItems":2,"type":"array"},"fold":{"description":"An array of data fields indicating the properties to fold.","items":{"$ref":"#/definitions/FieldName"},"type":"array"}},"required":["fold"],"type":"object"},"FontStyle":{"type":"string"},"FontWeight":{"enum":["normal","bold","lighter","bolder",100,200,300,400,500,600,700,800,900],"type":["string","number"]},"Format":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/TimeFormatSpecifier"},{"$ref":"#/definitions/Dict"}]},"FormatConfig":{"additionalProperties":false,"properties":{"normalizedNumberFormat":{"description":"If normalizedNumberFormatType is not specified, D3 number format for axis labels, text marks, and tooltips of normalized stacked fields (fields with `stack: \\"normalize\\"`). For example `\\"s\\"` for SI units. Use [D3\'s number format pattern](https://github.com/d3/d3-format#locale_format).\\n\\nIf `config.normalizedNumberFormatType` is specified and `config.customFormatTypes` is `true`, this value will be passed as `format` alongside `datum.value` to the `config.numberFormatType` function. __Default value:__ `%`","type":"string"},"normalizedNumberFormatType":{"description":"[Custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type) for `config.normalizedNumberFormat`.\\n\\n__Default value:__ `undefined` -- This is equilvalent to call D3-format, which is exposed as [`format` in Vega-Expression](https://vega.github.io/vega/docs/expressions/#format). __Note:__ You must also set `customFormatTypes` to `true` to use this feature.","type":"string"},"numberFormat":{"description":"If numberFormatType is not specified, D3 number format for guide labels, text marks, and tooltips of non-normalized fields (fields *without* `stack: \\"normalize\\"`). For example `\\"s\\"` for SI units. Use [D3\'s number format pattern](https://github.com/d3/d3-format#locale_format).\\n\\nIf `config.numberFormatType` is specified and `config.customFormatTypes` is `true`, this value will be passed as `format` alongside `datum.value` to the `config.numberFormatType` function.","type":"string"},"numberFormatType":{"description":"[Custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type) for `config.numberFormat`.\\n\\n__Default value:__ `undefined` -- This is equilvalent to call D3-format, which is exposed as [`format` in Vega-Expression](https://vega.github.io/vega/docs/expressions/#format). __Note:__ You must also set `customFormatTypes` to `true` to use this feature.","type":"string"},"timeFormat":{"description":"Default time format for raw time values (without time units) in text marks, legend labels and header labels.\\n\\n__Default value:__ `\\"%b %d, %Y\\"` __Note:__ Axes automatically determine the format for each label automatically so this config does not affect axes.","type":"string"},"timeFormatType":{"description":"[Custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type) for `config.timeFormat`.\\n\\n__Default value:__ `undefined` -- This is equilvalent to call D3-time-format, which is exposed as [`timeFormat` in Vega-Expression](https://vega.github.io/vega/docs/expressions/#timeFormat). __Note:__ You must also set `customFormatTypes` to `true` and there must *not* be a `timeUnit` defined to use this feature.","type":"string"}},"type":"object"},"Generator":{"anyOf":[{"$ref":"#/definitions/SequenceGenerator"},{"$ref":"#/definitions/SphereGenerator"},{"$ref":"#/definitions/GraticuleGenerator"}]},"ConcatSpec<GenericSpec>":{"additionalProperties":false,"description":"Base interface for a generalized concatenation specification.","properties":{"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"concat":{"description":"A list of views to be concatenated.","items":{"$ref":"#/definitions/Spec"},"type":"array"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"}},"required":["concat"],"type":"object"},"FacetSpec":{"additionalProperties":false,"description":"Base interface for a facet specification.","properties":{"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"facet":{"anyOf":[{"$ref":"#/definitions/FacetFieldDef"},{"$ref":"#/definitions/FacetMapping"}],"description":"Definition for how to facet the data. One of: 1) [a field definition for faceting the plot by one field](https://vega.github.io/vega-lite/docs/facet.html#field-def) 2) [An object that maps `row` and `column` channels to their field definitions](https://vega.github.io/vega-lite/docs/facet.html#mapping)"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"spec":{"anyOf":[{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/FacetedUnitSpec"}],"description":"A specification of the view that gets faceted."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"}},"required":["facet","spec"],"type":"object"},"HConcatSpec<GenericSpec>":{"additionalProperties":false,"description":"Base interface for a horizontal concatenation specification.","properties":{"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\n__Default value:__ `false`","type":"boolean"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"hconcat":{"description":"A list of views to be concatenated and put into a row.","items":{"$ref":"#/definitions/Spec"},"type":"array"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"description":"The spacing in pixels between sub-views of the concat operator.\\n\\n__Default value__: `10`","type":"number"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"}},"required":["hconcat"],"type":"object"},"Spec":{"anyOf":[{"$ref":"#/definitions/FacetedUnitSpec"},{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/RepeatSpec"},{"$ref":"#/definitions/FacetSpec"},{"$ref":"#/definitions/ConcatSpec<GenericSpec>"},{"$ref":"#/definitions/VConcatSpec<GenericSpec>"},{"$ref":"#/definitions/HConcatSpec<GenericSpec>"}],"description":"Any specification in Vega-Lite."},"GenericUnitSpec<Encoding,AnyMark>":{"additionalProperties":false,"description":"Base interface for a unit (single-view) specification.","properties":{"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"encoding":{"$ref":"#/definitions/Encoding","description":"A key-value mapping between encoding channels and definition of fields."},"mark":{"$ref":"#/definitions/AnyMark","description":"A string describing the mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"rule\\"`, `\\"geoshape\\"`, and `\\"text\\"`) or a [mark definition object](https://vega.github.io/vega-lite/docs/mark.html#mark-def)."},"name":{"description":"Name of the visualization for later reference.","type":"string"},"params":{"description":"An array of parameters that may either be simple variables, or more complex selections that map user input to data queries.","items":{"$ref":"#/definitions/SelectionParameter"},"type":"array"},"projection":{"$ref":"#/definitions/Projection","description":"An object defining properties of geographic projection, which will be applied to `shape` path for `\\"geoshape\\"` marks and to `latitude` and `\\"longitude\\"` channels for other marks."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"}},"required":["mark"],"type":"object"},"VConcatSpec<GenericSpec>":{"additionalProperties":false,"description":"Base interface for a vertical concatenation specification.","properties":{"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\n__Default value:__ `false`","type":"boolean"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"description":"The spacing in pixels between sub-views of the concat operator.\\n\\n__Default value__: `10`","type":"number"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"vconcat":{"description":"A list of views to be concatenated and put into a column.","items":{"$ref":"#/definitions/Spec"},"type":"array"}},"required":["vconcat"],"type":"object"},"GeoJsonFeature":{"$ref":"#/definitions/Feature"},"GeoJsonFeatureCollection":{"$ref":"#/definitions/FeatureCollection"},"GeoJsonProperties":{"anyOf":[{"type":"object"},{"type":"null"}]},"Geometry":{"anyOf":[{"$ref":"#/definitions/Point"},{"$ref":"#/definitions/MultiPoint"},{"$ref":"#/definitions/LineString"},{"$ref":"#/definitions/MultiLineString"},{"$ref":"#/definitions/Polygon"},{"$ref":"#/definitions/MultiPolygon"},{"$ref":"#/definitions/GeometryCollection"}],"description":"Geometry object. https://tools.ietf.org/html/rfc7946#section-3"},"GeometryCollection":{"additionalProperties":false,"description":"Geometry Collection https://tools.ietf.org/html/rfc7946#section-3.1.8","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"geometries":{"items":{"$ref":"#/definitions/Geometry"},"type":"array"},"type":{"const":"GeometryCollection","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["geometries","type"],"type":"object"},"Gradient":{"anyOf":[{"$ref":"#/definitions/LinearGradient"},{"$ref":"#/definitions/RadialGradient"}]},"GradientStop":{"additionalProperties":false,"properties":{"color":{"$ref":"#/definitions/Color","description":"The color value at this point in the gradient."},"offset":{"description":"The offset fraction for the color stop, indicating its position within the gradient.","type":"number"}},"required":["offset","color"],"type":"object"},"GraticuleGenerator":{"additionalProperties":false,"properties":{"graticule":{"anyOf":[{"const":true,"type":"boolean"},{"$ref":"#/definitions/GraticuleParams"}],"description":"Generate graticule GeoJSON data for geographic reference lines."},"name":{"description":"Provide a placeholder name and bind data at runtime.","type":"string"}},"required":["graticule"],"type":"object"},"GraticuleParams":{"additionalProperties":false,"properties":{"extent":{"$ref":"#/definitions/Vector2<Vector2<number>>","description":"Sets both the major and minor extents to the same values."},"extentMajor":{"$ref":"#/definitions/Vector2<Vector2<number>>","description":"The major extent of the graticule as a two-element array of coordinates."},"extentMinor":{"$ref":"#/definitions/Vector2<Vector2<number>>","description":"The minor extent of the graticule as a two-element array of coordinates."},"precision":{"description":"The precision of the graticule in degrees.\\n\\n__Default value:__ `2.5`","type":"number"},"step":{"$ref":"#/definitions/Vector2<number>","description":"Sets both the major and minor step angles to the same values."},"stepMajor":{"$ref":"#/definitions/Vector2<number>","description":"The major step angles of the graticule.\\n\\n\\n__Default value:__ `[90, 360]`"},"stepMinor":{"$ref":"#/definitions/Vector2<number>","description":"The minor step angles of the graticule.\\n\\n__Default value:__ `[10, 10]`"}},"type":"object"},"Header":{"additionalProperties":false,"description":"Headers of row / column channels for faceted plots.","properties":{"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"labelAlign":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"Horizontal text alignment of header labels. One of `\\"left\\"`, `\\"center\\"`, or `\\"right\\"`."},"labelAnchor":{"$ref":"#/definitions/TitleAnchor","description":"The anchor position for placing the labels. One of `\\"start\\"`, `\\"middle\\"`, or `\\"end\\"`. For example, with a label orientation of top these anchor positions map to a left-, center-, or right-aligned label."},"labelAngle":{"description":"The rotation angle of the header labels.\\n\\n__Default value:__ `0` for column header, `-90` for row header.","maximum":360,"minimum":-360,"type":"number"},"labelBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"The vertical text baseline for the header labels. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `titleLineHeight` rather than `titleFontSize` alone."},"labelColor":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"The color of the header label, can be in hex color code or regular color name."},"labelExpr":{"description":"[Vega expression](https://vega.github.io/vega/docs/expressions/) for customizing labels.\\n\\n__Note:__ The label text and value can be assessed via the `label` and `value` properties of the header\'s backing `datum` object.","type":"string"},"labelFont":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"The font of the header label."},"labelFontSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The font size of the header label, in pixels.","minimum":0},"labelFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle"},{"$ref":"#/definitions/ExprRef"}],"description":"The font style of the header label."},"labelFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight"},{"$ref":"#/definitions/ExprRef"}],"description":"The font weight of the header label."},"labelLimit":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The maximum length of the header label in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0`, indicating no limit"},"labelLineHeight":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Line height in pixels for multi-line header labels or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline."},"labelOrient":{"$ref":"#/definitions/Orient","description":"The orientation of the header label. One of `\\"top\\"`, `\\"bottom\\"`, `\\"left\\"` or `\\"right\\"`."},"labelPadding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The padding, in pixel, between facet header\'s label and the plot.\\n\\n__Default value:__ `10`"},"labels":{"description":"A boolean flag indicating if labels should be included as part of the header.\\n\\n__Default value:__ `true`.","type":"boolean"},"orient":{"$ref":"#/definitions/Orient","description":"Shortcut for setting both labelOrient and titleOrient."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"titleAlign":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"Horizontal text alignment (to the anchor) of header titles."},"titleAnchor":{"$ref":"#/definitions/TitleAnchor","description":"The anchor position for placing the title. One of `\\"start\\"`, `\\"middle\\"`, or `\\"end\\"`. For example, with an orientation of top these anchor positions map to a left-, center-, or right-aligned title."},"titleAngle":{"description":"The rotation angle of the header title.\\n\\n__Default value:__ `0`.","maximum":360,"minimum":-360,"type":"number"},"titleBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"The vertical text baseline for the header title. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `titleLineHeight` rather than `titleFontSize` alone.\\n\\n__Default value:__ `\\"middle\\"`"},"titleColor":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"Color of the header title, can be in hex color code or regular color name."},"titleFont":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Font of the header title. (e.g., `\\"Helvetica Neue\\"`)."},"titleFontSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Font size of the header title.","minimum":0},"titleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle"},{"$ref":"#/definitions/ExprRef"}],"description":"The font style of the header title."},"titleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight"},{"$ref":"#/definitions/ExprRef"}],"description":"Font weight of the header title. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},"titleLimit":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The maximum length of the header title in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0`, indicating no limit"},"titleLineHeight":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Line height in pixels for multi-line header title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline."},"titleOrient":{"$ref":"#/definitions/Orient","description":"The orientation of the header title. One of `\\"top\\"`, `\\"bottom\\"`, `\\"left\\"` or `\\"right\\"`."},"titlePadding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The padding, in pixel, between facet header\'s title and the label.\\n\\n__Default value:__ `10`"}},"type":"object"},"HeaderConfig":{"additionalProperties":false,"properties":{"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"labelAlign":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"Horizontal text alignment of header labels. One of `\\"left\\"`, `\\"center\\"`, or `\\"right\\"`."},"labelAnchor":{"$ref":"#/definitions/TitleAnchor","description":"The anchor position for placing the labels. One of `\\"start\\"`, `\\"middle\\"`, or `\\"end\\"`. For example, with a label orientation of top these anchor positions map to a left-, center-, or right-aligned label."},"labelAngle":{"description":"The rotation angle of the header labels.\\n\\n__Default value:__ `0` for column header, `-90` for row header.","maximum":360,"minimum":-360,"type":"number"},"labelBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"The vertical text baseline for the header labels. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `titleLineHeight` rather than `titleFontSize` alone."},"labelColor":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"The color of the header label, can be in hex color code or regular color name."},"labelExpr":{"description":"[Vega expression](https://vega.github.io/vega/docs/expressions/) for customizing labels.\\n\\n__Note:__ The label text and value can be assessed via the `label` and `value` properties of the header\'s backing `datum` object.","type":"string"},"labelFont":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"The font of the header label."},"labelFontSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The font size of the header label, in pixels.","minimum":0},"labelFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle"},{"$ref":"#/definitions/ExprRef"}],"description":"The font style of the header label."},"labelFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight"},{"$ref":"#/definitions/ExprRef"}],"description":"The font weight of the header label."},"labelLimit":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The maximum length of the header label in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0`, indicating no limit"},"labelLineHeight":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Line height in pixels for multi-line header labels or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline."},"labelOrient":{"$ref":"#/definitions/Orient","description":"The orientation of the header label. One of `\\"top\\"`, `\\"bottom\\"`, `\\"left\\"` or `\\"right\\"`."},"labelPadding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The padding, in pixel, between facet header\'s label and the plot.\\n\\n__Default value:__ `10`"},"labels":{"description":"A boolean flag indicating if labels should be included as part of the header.\\n\\n__Default value:__ `true`.","type":"boolean"},"orient":{"$ref":"#/definitions/Orient","description":"Shortcut for setting both labelOrient and titleOrient."},"title":{"description":"Set to null to disable title for the axis, legend, or header.","type":"null"},"titleAlign":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"Horizontal text alignment (to the anchor) of header titles."},"titleAnchor":{"$ref":"#/definitions/TitleAnchor","description":"The anchor position for placing the title. One of `\\"start\\"`, `\\"middle\\"`, or `\\"end\\"`. For example, with an orientation of top these anchor positions map to a left-, center-, or right-aligned title."},"titleAngle":{"description":"The rotation angle of the header title.\\n\\n__Default value:__ `0`.","maximum":360,"minimum":-360,"type":"number"},"titleBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"The vertical text baseline for the header title. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `titleLineHeight` rather than `titleFontSize` alone.\\n\\n__Default value:__ `\\"middle\\"`"},"titleColor":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"Color of the header title, can be in hex color code or regular color name."},"titleFont":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Font of the header title. (e.g., `\\"Helvetica Neue\\"`)."},"titleFontSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Font size of the header title.","minimum":0},"titleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle"},{"$ref":"#/definitions/ExprRef"}],"description":"The font style of the header title."},"titleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight"},{"$ref":"#/definitions/ExprRef"}],"description":"Font weight of the header title. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},"titleLimit":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The maximum length of the header title in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0`, indicating no limit"},"titleLineHeight":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Line height in pixels for multi-line header title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline."},"titleOrient":{"$ref":"#/definitions/Orient","description":"The orientation of the header title. One of `\\"top\\"`, `\\"bottom\\"`, `\\"left\\"` or `\\"right\\"`."},"titlePadding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The padding, in pixel, between facet header\'s title and the label.\\n\\n__Default value:__ `10`"}},"type":"object"},"HexColor":{"format":"color-hex","type":"string"},"ImputeMethod":{"enum":["value","median","max","min","mean"],"type":"string"},"ImputeParams":{"additionalProperties":false,"properties":{"frame":{"description":"A frame specification as a two-element array used to control the window over which the specified method is applied. The array entries should either be a number indicating the offset from the current data object, or null to indicate unbounded rows preceding or following the current data object. For example, the value `[-5, 5]` indicates that the window should include five objects preceding and five objects following the current object.\\n\\n__Default value:__:  `[null, null]` indicating that the window includes all objects.","items":{"type":["null","number"]},"maxItems":2,"minItems":2,"type":"array"},"keyvals":{"anyOf":[{"items":{},"type":"array"},{"$ref":"#/definitions/ImputeSequence"}],"description":"Defines the key values that should be considered for imputation. An array of key values or an object defining a [number sequence](https://vega.github.io/vega-lite/docs/impute.html#sequence-def).\\n\\nIf provided, this will be used in addition to the key values observed within the input data. If not provided, the values will be derived from all unique values of the `key` field. For `impute` in `encoding`, the key field is the x-field if the y-field is imputed, or vice versa.\\n\\nIf there is no impute grouping, this property _must_ be specified."},"method":{"$ref":"#/definitions/ImputeMethod","description":"The imputation method to use for the field value of imputed data objects. One of `\\"value\\"`, `\\"mean\\"`, `\\"median\\"`, `\\"max\\"` or `\\"min\\"`.\\n\\n__Default value:__  `\\"value\\"`"},"value":{"description":"The field value to use when the imputation `method` is `\\"value\\"`."}},"type":"object"},"ImputeSequence":{"additionalProperties":false,"properties":{"start":{"description":"The starting value of the sequence. __Default value:__ `0`","type":"number"},"step":{"description":"The step value between sequence entries. __Default value:__ `1` or `-1` if `stop < start`","type":"number"},"stop":{"description":"The ending value(exclusive) of the sequence.","type":"number"}},"required":["stop"],"type":"object"},"ImputeTransform":{"additionalProperties":false,"properties":{"frame":{"description":"A frame specification as a two-element array used to control the window over which the specified method is applied. The array entries should either be a number indicating the offset from the current data object, or null to indicate unbounded rows preceding or following the current data object. For example, the value `[-5, 5]` indicates that the window should include five objects preceding and five objects following the current object.\\n\\n__Default value:__:  `[null, null]` indicating that the window includes all objects.","items":{"type":["null","number"]},"maxItems":2,"minItems":2,"type":"array"},"groupby":{"description":"An optional array of fields by which to group the values. Imputation will then be performed on a per-group basis.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"impute":{"$ref":"#/definitions/FieldName","description":"The data field for which the missing values should be imputed."},"key":{"$ref":"#/definitions/FieldName","description":"A key field that uniquely identifies data objects within a group. Missing key values (those occurring in the data but not in the current group) will be imputed."},"keyvals":{"anyOf":[{"items":{},"type":"array"},{"$ref":"#/definitions/ImputeSequence"}],"description":"Defines the key values that should be considered for imputation. An array of key values or an object defining a [number sequence](https://vega.github.io/vega-lite/docs/impute.html#sequence-def).\\n\\nIf provided, this will be used in addition to the key values observed within the input data. If not provided, the values will be derived from all unique values of the `key` field. For `impute` in `encoding`, the key field is the x-field if the y-field is imputed, or vice versa.\\n\\nIf there is no impute grouping, this property _must_ be specified."},"method":{"$ref":"#/definitions/ImputeMethod","description":"The imputation method to use for the field value of imputed data objects. One of `\\"value\\"`, `\\"mean\\"`, `\\"median\\"`, `\\"max\\"` or `\\"min\\"`.\\n\\n__Default value:__  `\\"value\\"`"},"value":{"description":"The field value to use when the imputation `method` is `\\"value\\"`."}},"required":["impute","key"],"type":"object"},"InlineData":{"additionalProperties":false,"properties":{"format":{"$ref":"#/definitions/DataFormat","description":"An object that specifies the format for parsing the data."},"name":{"description":"Provide a placeholder name and bind data at runtime.","type":"string"},"values":{"$ref":"#/definitions/InlineDataset","description":"The full data set, included inline. This can be an array of objects or primitive values, an object, or a string. Arrays of primitive values are ingested as objects with a `data` property. Strings are parsed according to the specified format type."}},"required":["values"],"type":"object"},"InlineDataset":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"items":{"type":"string"},"type":"array"},{"items":{"type":"boolean"},"type":"array"},{"items":{"type":"object"},"type":"array"},{"type":"string"},{"type":"object"}]},"Interpolate":{"enum":["basis","basis-open","basis-closed","bundle","cardinal","cardinal-open","cardinal-closed","catmull-rom","linear","linear-closed","monotone","natural","step","step-before","step-after"],"type":"string"},"IntervalSelectionConfig":{"additionalProperties":false,"properties":{"clear":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"},{"type":"boolean"}],"description":"Clears the selection, emptying it of all values. This property can be a [Event Stream](https://vega.github.io/vega/docs/event-streams/) or `false` to disable clear.\\n\\n__Default value:__ `dblclick`.\\n\\n__See also:__ [`clear` examples ](https://vega.github.io/vega-lite/docs/selection.html#clear) in the documentation."},"encodings":{"description":"An array of encoding channels. The corresponding data field values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/SingleDefUnitChannel"},"type":"array"},"fields":{"description":"An array of field names whose values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"mark":{"$ref":"#/definitions/BrushConfig","description":"An interval selection also adds a rectangle mark to depict the extents of the interval. The `mark` property can be used to customize the appearance of the mark.\\n\\n__See also:__ [`mark` examples](https://vega.github.io/vega-lite/docs/selection.html#mark) in the documentation."},"on":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"}],"description":"A [Vega event stream](https://vega.github.io/vega/docs/event-streams/) (object or selector) that triggers the selection. For interval selections, the event stream must specify a [start and end](https://vega.github.io/vega/docs/event-streams/#between-filters).\\n\\n__See also:__ [`on` examples](https://vega.github.io/vega-lite/docs/selection.html#on) in the documentation."},"resolve":{"$ref":"#/definitions/SelectionResolution","description":"With layered and multi-view displays, a strategy that determines how selections\' data queries are resolved when applied in a filter transform, conditional encoding rule, or scale domain.\\n\\nOne of:\\n- `\\"global\\"` -- only one brush exists for the entire SPLOM. When the user begins to drag, any previous brushes are cleared, and a new one is constructed.\\n- `\\"union\\"` -- each cell contains its own brush, and points are highlighted if they lie within _any_ of these individual brushes.\\n- `\\"intersect\\"` -- each cell contains its own brush, and points are highlighted only if they fall within _all_ of these individual brushes.\\n\\n__Default value:__ `global`.\\n\\n__See also:__ [`resolve` examples](https://vega.github.io/vega-lite/docs/selection.html#resolve) in the documentation."},"translate":{"description":"When truthy, allows a user to interactively move an interval selection back-and-forth. Can be `true`, `false` (to disable panning), or a [Vega event stream definition](https://vega.github.io/vega/docs/event-streams/) which must include a start and end event to trigger continuous panning. Discrete panning (e.g., pressing the left/right arrow keys) will be supported in future versions.\\n\\n__Default value:__ `true`, which corresponds to `[pointerdown, window:pointerup] > window:pointermove!`. This default allows users to clicks and drags within an interval selection to reposition it.\\n\\n__See also:__ [`translate` examples](https://vega.github.io/vega-lite/docs/selection.html#translate) in the documentation.","type":["string","boolean"]},"type":{"const":"interval","description":"Determines the default event processing and data query for the selection. Vega-Lite currently supports two selection types:\\n\\n- `\\"point\\"` -- to select multiple discrete data values; the first value is selected on `click` and additional values toggled on shift-click.\\n- `\\"interval\\"` -- to select a continuous range of data values on `drag`.","type":"string"},"zoom":{"description":"When truthy, allows a user to interactively resize an interval selection. Can be `true`, `false` (to disable zooming), or a [Vega event stream definition](https://vega.github.io/vega/docs/event-streams/). Currently, only `wheel` events are supported, but custom event streams can still be used to specify filters, debouncing, and throttling. Future versions will expand the set of events that can trigger this transformation.\\n\\n__Default value:__ `true`, which corresponds to `wheel!`. This default allows users to use the mouse wheel to resize an interval selection.\\n\\n__See also:__ [`zoom` examples](https://vega.github.io/vega-lite/docs/selection.html#zoom) in the documentation.","type":["string","boolean"]}},"required":["type"],"type":"object"},"IntervalSelectionConfigWithoutType":{"additionalProperties":false,"properties":{"clear":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"},{"type":"boolean"}],"description":"Clears the selection, emptying it of all values. This property can be a [Event Stream](https://vega.github.io/vega/docs/event-streams/) or `false` to disable clear.\\n\\n__Default value:__ `dblclick`.\\n\\n__See also:__ [`clear` examples ](https://vega.github.io/vega-lite/docs/selection.html#clear) in the documentation."},"encodings":{"description":"An array of encoding channels. The corresponding data field values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/SingleDefUnitChannel"},"type":"array"},"fields":{"description":"An array of field names whose values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"mark":{"$ref":"#/definitions/BrushConfig","description":"An interval selection also adds a rectangle mark to depict the extents of the interval. The `mark` property can be used to customize the appearance of the mark.\\n\\n__See also:__ [`mark` examples](https://vega.github.io/vega-lite/docs/selection.html#mark) in the documentation."},"on":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"}],"description":"A [Vega event stream](https://vega.github.io/vega/docs/event-streams/) (object or selector) that triggers the selection. For interval selections, the event stream must specify a [start and end](https://vega.github.io/vega/docs/event-streams/#between-filters).\\n\\n__See also:__ [`on` examples](https://vega.github.io/vega-lite/docs/selection.html#on) in the documentation."},"resolve":{"$ref":"#/definitions/SelectionResolution","description":"With layered and multi-view displays, a strategy that determines how selections\' data queries are resolved when applied in a filter transform, conditional encoding rule, or scale domain.\\n\\nOne of:\\n- `\\"global\\"` -- only one brush exists for the entire SPLOM. When the user begins to drag, any previous brushes are cleared, and a new one is constructed.\\n- `\\"union\\"` -- each cell contains its own brush, and points are highlighted if they lie within _any_ of these individual brushes.\\n- `\\"intersect\\"` -- each cell contains its own brush, and points are highlighted only if they fall within _all_ of these individual brushes.\\n\\n__Default value:__ `global`.\\n\\n__See also:__ [`resolve` examples](https://vega.github.io/vega-lite/docs/selection.html#resolve) in the documentation."},"translate":{"description":"When truthy, allows a user to interactively move an interval selection back-and-forth. Can be `true`, `false` (to disable panning), or a [Vega event stream definition](https://vega.github.io/vega/docs/event-streams/) which must include a start and end event to trigger continuous panning. Discrete panning (e.g., pressing the left/right arrow keys) will be supported in future versions.\\n\\n__Default value:__ `true`, which corresponds to `[pointerdown, window:pointerup] > window:pointermove!`. This default allows users to clicks and drags within an interval selection to reposition it.\\n\\n__See also:__ [`translate` examples](https://vega.github.io/vega-lite/docs/selection.html#translate) in the documentation.","type":["string","boolean"]},"zoom":{"description":"When truthy, allows a user to interactively resize an interval selection. Can be `true`, `false` (to disable zooming), or a [Vega event stream definition](https://vega.github.io/vega/docs/event-streams/). Currently, only `wheel` events are supported, but custom event streams can still be used to specify filters, debouncing, and throttling. Future versions will expand the set of events that can trigger this transformation.\\n\\n__Default value:__ `true`, which corresponds to `wheel!`. This default allows users to use the mouse wheel to resize an interval selection.\\n\\n__See also:__ [`zoom` examples](https://vega.github.io/vega-lite/docs/selection.html#zoom) in the documentation.","type":["string","boolean"]}},"type":"object"},"JoinAggregateFieldDef":{"additionalProperties":false,"properties":{"as":{"$ref":"#/definitions/FieldName","description":"The output name for the join aggregate operation."},"field":{"$ref":"#/definitions/FieldName","description":"The data field for which to compute the aggregate function. This can be omitted for functions that do not operate over a field such as `\\"count\\"`."},"op":{"$ref":"#/definitions/AggregateOp","description":"The aggregation operation to apply (e.g., `\\"sum\\"`, `\\"average\\"` or `\\"count\\"`). See the list of all supported operations [here](https://vega.github.io/vega-lite/docs/aggregate.html#ops)."}},"required":["op","as"],"type":"object"},"JoinAggregateTransform":{"additionalProperties":false,"properties":{"groupby":{"description":"The data fields for partitioning the data objects into separate groups. If unspecified, all data points will be in a single group.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"joinaggregate":{"description":"The definition of the fields in the join aggregate, and what calculations to use.","items":{"$ref":"#/definitions/JoinAggregateFieldDef"},"type":"array"}},"required":["joinaggregate"],"type":"object"},"JsonDataFormat":{"additionalProperties":false,"properties":{"parse":{"anyOf":[{"$ref":"#/definitions/Parse"},{"type":"null"}],"description":"If set to `null`, disable type inference based on the spec and only use type inference based on the data. Alternatively, a parsing directive object can be provided for explicit data types. Each property of the object corresponds to a field name, and the value to the desired data type (one of `\\"number\\"`, `\\"boolean\\"`, `\\"date\\"`, or null (do not parse the field)). For example, `\\"parse\\": {\\"modified_on\\": \\"date\\"}` parses the `modified_on` field in each input record a Date value.\\n\\nFor `\\"date\\"`, we parse data based using JavaScript\'s [`Date.parse()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse). For Specific date formats can be provided (e.g., `{foo: \\"date:\'%m%d%Y\'\\"}`), using the [d3-time-format syntax](https://github.com/d3/d3-time-format#locale_format). UTC date format parsing is supported similarly (e.g., `{foo: \\"utc:\'%m%d%Y\'\\"}`). See more about [UTC time](https://vega.github.io/vega-lite/docs/timeunit.html#utc)"},"property":{"description":"The JSON property containing the desired data. This parameter can be used when the loaded JSON file may have surrounding structure or meta-data. For example `\\"property\\": \\"values.features\\"` is equivalent to retrieving `json.values.features` from the loaded JSON object.","type":"string"},"type":{"const":"json","description":"Type of input data: `\\"json\\"`, `\\"csv\\"`, `\\"tsv\\"`, `\\"dsv\\"`.\\n\\n__Default value:__  The default format type is determined by the extension of the file URL. If no extension is detected, `\\"json\\"` will be used by default.","type":"string"}},"type":"object"},"LabelOverlap":{"anyOf":[{"type":"boolean"},{"const":"parity","type":"string"},{"const":"greedy","type":"string"}]},"LatLongDef":{"anyOf":[{"$ref":"#/definitions/LatLongFieldDef"},{"$ref":"#/definitions/DatumDef"}]},"LatLongFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"const":"quantitative","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation.","type":"string"}},"type":"object"},"LayerRepeatMapping":{"additionalProperties":false,"properties":{"column":{"description":"An array of fields to be repeated horizontally.","items":{"type":"string"},"type":"array"},"layer":{"description":"An array of fields to be repeated as layers.","items":{"type":"string"},"type":"array"},"row":{"description":"An array of fields to be repeated vertically.","items":{"type":"string"},"type":"array"}},"required":["layer"],"type":"object"},"LayerRepeatSpec":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"repeat":{"$ref":"#/definitions/LayerRepeatMapping","description":"Definition for fields to be repeated. One of: 1) An array of fields to be repeated. If `\\"repeat\\"` is an array, the field can be referred to as `{\\"repeat\\": \\"repeat\\"}`. The repeated views are laid out in a wrapped row. You can set the number of columns to control the wrapping. 2) An object that maps `\\"row\\"` and/or `\\"column\\"` to the listed fields to be repeated along the particular orientations. The objects `{\\"repeat\\": \\"row\\"}` and `{\\"repeat\\": \\"column\\"}` can be used to refer to the repeated field respectively."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"spec":{"anyOf":[{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/UnitSpecWithFrame"}],"description":"A specification of the view that gets repeated."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"}},"required":["repeat","spec"],"type":"object"},"LayerSpec":{"additionalProperties":false,"description":"A full layered plot specification, which may contains `encoding` and `projection` properties that will be applied to underlying unit (single-view) specifications.","properties":{"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"encoding":{"$ref":"#/definitions/SharedEncoding","description":"A shared key-value mapping between encoding channels and definition of fields in the underlying layers."},"height":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The height of a visualization.\\n\\n- For a plot with a continuous y-field, height should be a number.\\n- For a plot with either a discrete y-field or no y-field, height can be either a number indicating a fixed height or an object in the form of `{step: number}` defining the height per discrete step. (No y-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on height, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousHeight` for a plot with a continuous y-field and `config.view.discreteHeight` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the height of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`height`](https://vega.github.io/vega-lite/docs/size.html) documentation."},"layer":{"description":"Layer or single view specifications to be layered.\\n\\n__Note__: Specifications inside `layer` cannot use `row` and `column` channels as layering facet specifications is not allowed. Instead, use the [facet operator](https://vega.github.io/vega-lite/docs/facet.html) and place a layer inside a facet.","items":{"anyOf":[{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/UnitSpec"}]},"type":"array"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"projection":{"$ref":"#/definitions/Projection","description":"An object defining properties of the geographic projection shared by underlying layers."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"view":{"$ref":"#/definitions/ViewBackground","description":"An object defining the view background\'s fill and stroke.\\n\\n__Default value:__ none (transparent)"},"width":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The width of a visualization.\\n\\n- For a plot with a continuous x-field, width should be a number.\\n- For a plot with either a discrete x-field or no x-field, width can be either a number indicating a fixed width or an object in the form of `{step: number}` defining the width per discrete step. (No x-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on width, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousWidth` for a plot with a continuous x-field and `config.view.discreteWidth` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the width of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`width`](https://vega.github.io/vega-lite/docs/size.html) documentation."}},"required":["layer"],"type":"object"},"LayoutAlign":{"enum":["all","each","none"],"type":"string"},"Legend":{"additionalProperties":false,"description":"Properties of a legend or boolean flag for determining whether to show it.","properties":{"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG group, removing the legend from the ARIA accessibility tree.\\n\\n__Default value:__ `true`","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"clipHeight":{"anyOf":[{"description":"The height in pixels to clip symbol legend entries and limit their size.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"columnPadding":{"anyOf":[{"description":"The horizontal padding in pixels between symbol legend entries.\\n\\n__Default value:__ `10`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"columns":{"anyOf":[{"description":"The number of columns in which to arrange symbol legend entries. A value of `0` or lower indicates a single row with one column per entry.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadius":{"anyOf":[{"description":"Corner radius for the full legend.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of this legend for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If the `aria` property is true, for SVG output the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute) will be set to this description. If the description is unspecified it will be automatically generated.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"direction":{"$ref":"#/definitions/Orientation","description":"The direction of the legend, one of `\\"vertical\\"` or `\\"horizontal\\"`.\\n\\n__Default value:__\\n- For top-/bottom-`orient`ed legends, `\\"horizontal\\"`\\n- For left-/right-`orient`ed legends, `\\"vertical\\"`\\n- For top/bottom-left/right-`orient`ed legends, `\\"horizontal\\"` for gradient legends and `\\"vertical\\"` for symbol legends."},"fillColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Background fill color for the full legend."},{"$ref":"#/definitions/ExprRef"}]},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"gradientLength":{"anyOf":[{"description":"The length in pixels of the primary axis of a color gradient. This value corresponds to the height of a vertical gradient or the width of a horizontal gradient.\\n\\n__Default value:__ `200`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientOpacity":{"anyOf":[{"description":"Opacity of the color gradient.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientStrokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the gradient stroke, can be in hex color code or regular color name.\\n\\n__Default value:__ `\\"lightGray\\"`."},{"$ref":"#/definitions/ExprRef"}]},"gradientStrokeWidth":{"anyOf":[{"description":"The width of the gradient stroke, in pixels.\\n\\n__Default value:__ `0`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientThickness":{"anyOf":[{"description":"The thickness in pixels of the color gradient. This value corresponds to the width of a vertical gradient or the height of a horizontal gradient.\\n\\n__Default value:__ `16`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gridAlign":{"anyOf":[{"$ref":"#/definitions/LayoutAlign","description":"The alignment to apply to symbol legends rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"` (the default), and `none`. For more information, see the [grid layout documentation](https://vega.github.io/vega/docs/layout).\\n\\n__Default value:__ `\\"each\\"`."},{"$ref":"#/definitions/ExprRef"}]},"labelAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"The alignment of the legend label, can be left, center, or right."},{"$ref":"#/definitions/ExprRef"}]},"labelBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"The position of the baseline of legend label, can be `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, or `\\"alphabetic\\"`.\\n\\n__Default value:__ `\\"middle\\"`."},{"$ref":"#/definitions/ExprRef"}]},"labelColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the legend label, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"}]},"labelExpr":{"description":"[Vega expression](https://vega.github.io/vega/docs/expressions/) for customizing labels.\\n\\n__Note:__ The label text and value can be assessed via the `label` and `value` properties of the legend\'s backing `datum` object.","type":"string"},"labelFont":{"anyOf":[{"description":"The font of the legend label.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"labelFontSize":{"anyOf":[{"description":"The font size of legend label.\\n\\n__Default value:__ `10`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style of legend label."},{"$ref":"#/definitions/ExprRef"}]},"labelFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight of legend label."},{"$ref":"#/definitions/ExprRef"}]},"labelLimit":{"anyOf":[{"description":"Maximum allowed pixel width of legend tick labels.\\n\\n__Default value:__ `160`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOffset":{"anyOf":[{"description":"The offset of the legend label.\\n\\n__Default value:__ `4`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOpacity":{"anyOf":[{"description":"Opacity of labels.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOverlap":{"anyOf":[{"$ref":"#/definitions/LabelOverlap","description":"The strategy to use for resolving overlap of labels in gradient legends. If `false`, no overlap reduction is attempted. If set to `true` (default) or `\\"parity\\"`, a strategy of removing every other label is used. If set to `\\"greedy\\"`, a linear scan of the labels is performed, removing any label that overlaps with the last visible label (this often works better for log-scaled axes).\\n\\n__Default value:__ `true`."},{"$ref":"#/definitions/ExprRef"}]},"labelPadding":{"anyOf":[{"description":"Padding in pixels between the legend and legend labels.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelSeparation":{"anyOf":[{"description":"The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default `0`). This property is ignored if *labelOverlap* resolution is not enabled.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"legendX":{"anyOf":[{"description":"Custom x-position for legend with orient \\"none\\".","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"legendY":{"anyOf":[{"description":"Custom y-position for legend with orient \\"none\\".","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"offset":{"anyOf":[{"description":"The offset in pixels by which to displace the legend from the data rectangle and axes.\\n\\n__Default value:__ `18`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"orient":{"$ref":"#/definitions/LegendOrient","description":"The orientation of the legend, which determines how the legend is positioned within the scene. One of `\\"left\\"`, `\\"right\\"`, `\\"top\\"`, `\\"bottom\\"`, `\\"top-left\\"`, `\\"top-right\\"`, `\\"bottom-left\\"`, `\\"bottom-right\\"`, `\\"none\\"`.\\n\\n__Default value:__ `\\"right\\"`"},"padding":{"anyOf":[{"description":"The padding between the border and content of the legend group.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"rowPadding":{"anyOf":[{"description":"The vertical padding in pixels between symbol legend entries.\\n\\n__Default value:__ `2`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Border stroke color for the full legend."},{"$ref":"#/definitions/ExprRef"}]},"symbolDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed symbol strokes.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"symbolDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the symbol stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolFillColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the legend symbol,"},{"$ref":"#/definitions/ExprRef"}]},"symbolLimit":{"anyOf":[{"description":"The maximum number of allowed entries for a symbol legend. Additional entries will be dropped.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolOffset":{"anyOf":[{"description":"Horizontal pixel offset for legend symbols.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolOpacity":{"anyOf":[{"description":"Opacity of the legend symbols.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolSize":{"anyOf":[{"description":"The size of the legend symbol, in pixels.\\n\\n__Default value:__ `100`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolStrokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Stroke color for legend symbols."},{"$ref":"#/definitions/ExprRef"}]},"symbolStrokeWidth":{"anyOf":[{"description":"The width of the symbol\'s stroke.\\n\\n__Default value:__ `1.5`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolType":{"anyOf":[{"$ref":"#/definitions/SymbolShape","description":"The symbol shape. One of the plotting shapes `circle` (default), `square`, `cross`, `diamond`, `triangle-up`, `triangle-down`, `triangle-right`, or `triangle-left`, the line symbol `stroke`, or one of the centered directional shapes `arrow`, `wedge`, or `triangle`. Alternatively, a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) can be provided. For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.\\n\\n__Default value:__ `\\"circle\\"`."},{"$ref":"#/definitions/ExprRef"}]},"tickCount":{"anyOf":[{"$ref":"#/definitions/TickCount","description":"The desired number of tick values for quantitative legends."},{"$ref":"#/definitions/ExprRef"}]},"tickMinStep":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum desired step between legend ticks, in terms of scale domain values. For example, a value of `1` indicates that ticks should not be less than 1 unit apart. If `tickMinStep` is specified, the `tickCount` value will be adjusted, if necessary, to enforce the minimum step value.\\n\\n__Default value__: `undefined`"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"titleAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"Horizontal text alignment for legend titles.\\n\\n__Default value:__ `\\"left\\"`."},{"$ref":"#/definitions/ExprRef"}]},"titleAnchor":{"anyOf":[{"$ref":"#/definitions/TitleAnchor","description":"Text anchor position for placing legend titles."},{"$ref":"#/definitions/ExprRef"}]},"titleBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline for legend titles.  One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone.\\n\\n__Default value:__ `\\"top\\"`."},{"$ref":"#/definitions/ExprRef"}]},"titleColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the legend title, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"}]},"titleFont":{"anyOf":[{"description":"The font of the legend title.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"titleFontSize":{"anyOf":[{"description":"The font size of the legend title.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style of the legend title."},{"$ref":"#/definitions/ExprRef"}]},"titleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight of the legend title. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"titleLimit":{"anyOf":[{"description":"Maximum allowed pixel width of legend titles.\\n\\n__Default value:__ `180`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleOpacity":{"anyOf":[{"description":"Opacity of the legend title.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleOrient":{"anyOf":[{"$ref":"#/definitions/Orient","description":"Orientation of the legend title."},{"$ref":"#/definitions/ExprRef"}]},"titlePadding":{"anyOf":[{"description":"The padding, in pixels, between title and legend.\\n\\n__Default value:__ `5`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"type":{"description":"The type of the legend. Use `\\"symbol\\"` to create a discrete legend and `\\"gradient\\"` for a continuous color gradient.\\n\\n__Default value:__ `\\"gradient\\"` for non-binned quantitative fields and temporal fields; `\\"symbol\\"` otherwise.","enum":["symbol","gradient"],"type":"string"},"values":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"items":{"type":"string"},"type":"array"},{"items":{"type":"boolean"},"type":"array"},{"items":{"$ref":"#/definitions/DateTime"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"Explicitly set the visible legend values."},"zindex":{"description":"A non-negative integer indicating the z-index of the legend. If zindex is 0, legend should be drawn behind all chart elements. To put them in front, use zindex = 1.","minimum":0,"type":"number"}},"type":"object"},"LegendBinding":{"anyOf":[{"const":"legend","type":"string"},{"$ref":"#/definitions/LegendStreamBinding"}]},"LegendConfig":{"additionalProperties":false,"properties":{"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG group, removing the legend from the ARIA accessibility tree.\\n\\n__Default value:__ `true`","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"clipHeight":{"anyOf":[{"description":"The height in pixels to clip symbol legend entries and limit their size.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"columnPadding":{"anyOf":[{"description":"The horizontal padding in pixels between symbol legend entries.\\n\\n__Default value:__ `10`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"columns":{"anyOf":[{"description":"The number of columns in which to arrange symbol legend entries. A value of `0` or lower indicates a single row with one column per entry.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadius":{"anyOf":[{"description":"Corner radius for the full legend.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of this legend for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If the `aria` property is true, for SVG output the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute) will be set to this description. If the description is unspecified it will be automatically generated.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"direction":{"$ref":"#/definitions/Orientation","description":"The direction of the legend, one of `\\"vertical\\"` or `\\"horizontal\\"`.\\n\\n__Default value:__\\n- For top-/bottom-`orient`ed legends, `\\"horizontal\\"`\\n- For left-/right-`orient`ed legends, `\\"vertical\\"`\\n- For top/bottom-left/right-`orient`ed legends, `\\"horizontal\\"` for gradient legends and `\\"vertical\\"` for symbol legends."},"disable":{"description":"Disable legend by default","type":"boolean"},"fillColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Background fill color for the full legend."},{"$ref":"#/definitions/ExprRef"}]},"gradientDirection":{"anyOf":[{"$ref":"#/definitions/Orientation","description":"The default direction (`\\"horizontal\\"` or `\\"vertical\\"`) for gradient legends.\\n\\n__Default value:__ `\\"vertical\\"`."},{"$ref":"#/definitions/ExprRef"}]},"gradientHorizontalMaxLength":{"description":"Max legend length for a horizontal gradient when `config.legend.gradientLength` is undefined.\\n\\n__Default value:__ `200`","type":"number"},"gradientHorizontalMinLength":{"description":"Min legend length for a horizontal gradient when `config.legend.gradientLength` is undefined.\\n\\n__Default value:__ `100`","type":"number"},"gradientLabelLimit":{"anyOf":[{"description":"The maximum allowed length in pixels of color ramp gradient labels.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientLabelOffset":{"anyOf":[{"description":"Vertical offset in pixels for color ramp gradient labels.\\n\\n__Default value:__ `2`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientLength":{"anyOf":[{"description":"The length in pixels of the primary axis of a color gradient. This value corresponds to the height of a vertical gradient or the width of a horizontal gradient.\\n\\n__Default value:__ `200`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientOpacity":{"anyOf":[{"description":"Opacity of the color gradient.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientStrokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the gradient stroke, can be in hex color code or regular color name.\\n\\n__Default value:__ `\\"lightGray\\"`."},{"$ref":"#/definitions/ExprRef"}]},"gradientStrokeWidth":{"anyOf":[{"description":"The width of the gradient stroke, in pixels.\\n\\n__Default value:__ `0`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientThickness":{"anyOf":[{"description":"The thickness in pixels of the color gradient. This value corresponds to the width of a vertical gradient or the height of a horizontal gradient.\\n\\n__Default value:__ `16`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"gradientVerticalMaxLength":{"description":"Max legend length for a vertical gradient when `config.legend.gradientLength` is undefined.\\n\\n__Default value:__ `200`","type":"number"},"gradientVerticalMinLength":{"description":"Min legend length for a vertical gradient when `config.legend.gradientLength` is undefined.\\n\\n__Default value:__ `100`","type":"number"},"gridAlign":{"anyOf":[{"$ref":"#/definitions/LayoutAlign","description":"The alignment to apply to symbol legends rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"` (the default), and `none`. For more information, see the [grid layout documentation](https://vega.github.io/vega/docs/layout).\\n\\n__Default value:__ `\\"each\\"`."},{"$ref":"#/definitions/ExprRef"}]},"labelAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"The alignment of the legend label, can be left, center, or right."},{"$ref":"#/definitions/ExprRef"}]},"labelBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"The position of the baseline of legend label, can be `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, or `\\"alphabetic\\"`.\\n\\n__Default value:__ `\\"middle\\"`."},{"$ref":"#/definitions/ExprRef"}]},"labelColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the legend label, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"}]},"labelFont":{"anyOf":[{"description":"The font of the legend label.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"labelFontSize":{"anyOf":[{"description":"The font size of legend label.\\n\\n__Default value:__ `10`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style of legend label."},{"$ref":"#/definitions/ExprRef"}]},"labelFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight of legend label."},{"$ref":"#/definitions/ExprRef"}]},"labelLimit":{"anyOf":[{"description":"Maximum allowed pixel width of legend tick labels.\\n\\n__Default value:__ `160`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOffset":{"anyOf":[{"description":"The offset of the legend label.\\n\\n__Default value:__ `4`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOpacity":{"anyOf":[{"description":"Opacity of labels.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelOverlap":{"anyOf":[{"$ref":"#/definitions/LabelOverlap"},{"$ref":"#/definitions/ExprRef"}],"description":"The strategy to use for resolving overlap of labels in gradient legends. If `false`, no overlap reduction is attempted. If set to `true` or `\\"parity\\"`, a strategy of removing every other label is used. If set to `\\"greedy\\"`, a linear scan of the labels is performed, removing any label that overlaps with the last visible label (this often works better for log-scaled axes).\\n\\n__Default value:__ `\\"greedy\\"` for log scales otherwise `true`."},"labelPadding":{"anyOf":[{"description":"Padding in pixels between the legend and legend labels.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"labelSeparation":{"anyOf":[{"description":"The minimum separation that must be between label bounding boxes for them to be considered non-overlapping (default `0`). This property is ignored if *labelOverlap* resolution is not enabled.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"layout":{"$ref":"#/definitions/ExprRef"},"legendX":{"anyOf":[{"description":"Custom x-position for legend with orient \\"none\\".","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"legendY":{"anyOf":[{"description":"Custom y-position for legend with orient \\"none\\".","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"offset":{"anyOf":[{"description":"The offset in pixels by which to displace the legend from the data rectangle and axes.\\n\\n__Default value:__ `18`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"orient":{"$ref":"#/definitions/LegendOrient","description":"The orientation of the legend, which determines how the legend is positioned within the scene. One of `\\"left\\"`, `\\"right\\"`, `\\"top\\"`, `\\"bottom\\"`, `\\"top-left\\"`, `\\"top-right\\"`, `\\"bottom-left\\"`, `\\"bottom-right\\"`, `\\"none\\"`.\\n\\n__Default value:__ `\\"right\\"`"},"padding":{"anyOf":[{"description":"The padding between the border and content of the legend group.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"rowPadding":{"anyOf":[{"description":"The vertical padding in pixels between symbol legend entries.\\n\\n__Default value:__ `2`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Border stroke color for the full legend."},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"Border stroke dash pattern for the full legend.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"Border stroke width for the full legend.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolBaseFillColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Default fill color for legend symbols. Only applied if there is no `\\"fill\\"` scale color encoding for the legend.\\n\\n__Default value:__ `\\"transparent\\"`."},{"$ref":"#/definitions/ExprRef"}]},"symbolBaseStrokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Default stroke color for legend symbols. Only applied if there is no `\\"fill\\"` scale color encoding for the legend.\\n\\n__Default value:__ `\\"gray\\"`."},{"$ref":"#/definitions/ExprRef"}]},"symbolDash":{"anyOf":[{"description":"An array of alternating [stroke, space] lengths for dashed symbol strokes.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"symbolDashOffset":{"anyOf":[{"description":"The pixel offset at which to start drawing with the symbol stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolDirection":{"anyOf":[{"$ref":"#/definitions/Orientation","description":"The default direction (`\\"horizontal\\"` or `\\"vertical\\"`) for symbol legends.\\n\\n__Default value:__ `\\"vertical\\"`."},{"$ref":"#/definitions/ExprRef"}]},"symbolFillColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the legend symbol,"},{"$ref":"#/definitions/ExprRef"}]},"symbolLimit":{"anyOf":[{"description":"The maximum number of allowed entries for a symbol legend. Additional entries will be dropped.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolOffset":{"anyOf":[{"description":"Horizontal pixel offset for legend symbols.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolOpacity":{"anyOf":[{"description":"Opacity of the legend symbols.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolSize":{"anyOf":[{"description":"The size of the legend symbol, in pixels.\\n\\n__Default value:__ `100`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolStrokeColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Stroke color for legend symbols."},{"$ref":"#/definitions/ExprRef"}]},"symbolStrokeWidth":{"anyOf":[{"description":"The width of the symbol\'s stroke.\\n\\n__Default value:__ `1.5`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"symbolType":{"anyOf":[{"$ref":"#/definitions/SymbolShape","description":"The symbol shape. One of the plotting shapes `circle` (default), `square`, `cross`, `diamond`, `triangle-up`, `triangle-down`, `triangle-right`, or `triangle-left`, the line symbol `stroke`, or one of the centered directional shapes `arrow`, `wedge`, or `triangle`. Alternatively, a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) can be provided. For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.\\n\\n__Default value:__ `\\"circle\\"`."},{"$ref":"#/definitions/ExprRef"}]},"tickCount":{"anyOf":[{"$ref":"#/definitions/TickCount","description":"The desired number of tick values for quantitative legends."},{"$ref":"#/definitions/ExprRef"}]},"title":{"description":"Set to null to disable title for the axis, legend, or header.","type":"null"},"titleAlign":{"anyOf":[{"$ref":"#/definitions/Align","description":"Horizontal text alignment for legend titles.\\n\\n__Default value:__ `\\"left\\"`."},{"$ref":"#/definitions/ExprRef"}]},"titleAnchor":{"anyOf":[{"$ref":"#/definitions/TitleAnchor","description":"Text anchor position for placing legend titles."},{"$ref":"#/definitions/ExprRef"}]},"titleBaseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline for legend titles.  One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone.\\n\\n__Default value:__ `\\"top\\"`."},{"$ref":"#/definitions/ExprRef"}]},"titleColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"The color of the legend title, can be in hex color code or regular color name."},{"$ref":"#/definitions/ExprRef"}]},"titleFont":{"anyOf":[{"description":"The font of the legend title.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"titleFontSize":{"anyOf":[{"description":"The font size of the legend title.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style of the legend title."},{"$ref":"#/definitions/ExprRef"}]},"titleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight of the legend title. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"titleLimit":{"anyOf":[{"description":"Maximum allowed pixel width of legend titles.\\n\\n__Default value:__ `180`.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleOpacity":{"anyOf":[{"description":"Opacity of the legend title.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"titleOrient":{"anyOf":[{"$ref":"#/definitions/Orient","description":"Orientation of the legend title."},{"$ref":"#/definitions/ExprRef"}]},"titlePadding":{"anyOf":[{"description":"The padding, in pixels, between title and legend.\\n\\n__Default value:__ `5`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"unselectedOpacity":{"description":"The opacity of unselected legend entries.\\n\\n__Default value:__ 0.35.","type":"number"},"zindex":{"anyOf":[{"description":"The integer z-index indicating the layering of the legend group relative to other axis, mark, and legend groups.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]}},"type":"object"},"LegendOrient":{"enum":["none","left","right","top","bottom","top-left","top-right","bottom-left","bottom-right"],"type":"string"},"LegendResolveMap":{"additionalProperties":false,"properties":{"angle":{"$ref":"#/definitions/ResolveMode"},"color":{"$ref":"#/definitions/ResolveMode"},"fill":{"$ref":"#/definitions/ResolveMode"},"fillOpacity":{"$ref":"#/definitions/ResolveMode"},"opacity":{"$ref":"#/definitions/ResolveMode"},"shape":{"$ref":"#/definitions/ResolveMode"},"size":{"$ref":"#/definitions/ResolveMode"},"stroke":{"$ref":"#/definitions/ResolveMode"},"strokeDash":{"$ref":"#/definitions/ResolveMode"},"strokeOpacity":{"$ref":"#/definitions/ResolveMode"},"strokeWidth":{"$ref":"#/definitions/ResolveMode"},"time":{"$ref":"#/definitions/ResolveMode"}},"type":"object"},"LegendStreamBinding":{"additionalProperties":false,"properties":{"legend":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/Stream"}]}},"required":["legend"],"type":"object"},"LineConfig":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"point":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/OverlayMarkDef"},{"const":"transparent","type":"string"}],"description":"A flag for overlaying points on top of line or area marks, or an object defining the properties of the overlayed points.\\n\\n- If this property is `\\"transparent\\"`, transparent points will be used (for enhancing tooltips and selections).\\n\\n- If this property is an empty object (`{}`) or `true`, filled points with default properties will be used.\\n\\n- If this property is `false`, no points would be automatically added to line or area marks.\\n\\n__Default value:__ `false`."},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"LineString":{"additionalProperties":false,"description":"LineString geometry object. https://tools.ietf.org/html/rfc7946#section-3.1.4","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"coordinates":{"items":{"$ref":"#/definitions/Position"},"type":"array"},"type":{"const":"LineString","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["coordinates","type"],"type":"object"},"LinearGradient":{"additionalProperties":false,"properties":{"gradient":{"const":"linear","description":"The type of gradient. Use `\\"linear\\"` for a linear gradient.","type":"string"},"id":{"type":"string"},"stops":{"description":"An array of gradient stops defining the gradient color sequence.","items":{"$ref":"#/definitions/GradientStop"},"type":"array"},"x1":{"description":"The starting x-coordinate, in normalized [0, 1] coordinates, of the linear gradient.\\n\\n__Default value:__ `0`","type":"number"},"x2":{"description":"The ending x-coordinate, in normalized [0, 1] coordinates, of the linear gradient.\\n\\n__Default value:__ `1`","type":"number"},"y1":{"description":"The starting y-coordinate, in normalized [0, 1] coordinates, of the linear gradient.\\n\\n__Default value:__ `0`","type":"number"},"y2":{"description":"The ending y-coordinate, in normalized [0, 1] coordinates, of the linear gradient.\\n\\n__Default value:__ `0`","type":"number"}},"required":["gradient","stops"],"type":"object"},"LocalMultiTimeUnit":{"enum":["yearquarter","yearquartermonth","yearmonth","yearmonthdate","yearmonthdatehours","yearmonthdatehoursminutes","yearmonthdatehoursminutesseconds","yearweek","yearweekday","yearweekdayhours","yearweekdayhoursminutes","yearweekdayhoursminutesseconds","yeardayofyear","quartermonth","monthdate","monthdatehours","monthdatehoursminutes","monthdatehoursminutesseconds","weekday","weekdayhours","weekdayhoursminutes","weekdayhoursminutesseconds","dayhours","dayhoursminutes","dayhoursminutesseconds","hoursminutes","hoursminutesseconds","minutesseconds","secondsmilliseconds"],"type":"string"},"LocalSingleTimeUnit":{"enum":["year","quarter","month","week","day","dayofyear","date","hours","minutes","seconds","milliseconds"],"type":"string"},"Locale":{"additionalProperties":false,"properties":{"number":{"$ref":"#/definitions/NumberLocale"},"time":{"$ref":"#/definitions/TimeLocale"}},"type":"object"},"LoessTransform":{"additionalProperties":false,"properties":{"as":{"description":"The output field names for the smoothed points generated by the loess transform.\\n\\n__Default value:__ The field names of the input x and y values.","items":{"$ref":"#/definitions/FieldName"},"maxItems":2,"minItems":2,"type":"array"},"bandwidth":{"description":"A bandwidth parameter in the range `[0, 1]` that determines the amount of smoothing.\\n\\n__Default value:__ `0.3`","type":"number"},"groupby":{"description":"The data fields to group by. If not specified, a single group containing all data objects will be used.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"loess":{"$ref":"#/definitions/FieldName","description":"The data field of the dependent variable to smooth."},"on":{"$ref":"#/definitions/FieldName","description":"The data field of the independent variable to use a predictor."}},"required":["loess","on"],"type":"object"},"LogicalAnd<Predicate>":{"additionalProperties":false,"properties":{"and":{"items":{"$ref":"#/definitions/PredicateComposition"},"type":"array"}},"required":["and"],"type":"object"},"PredicateComposition":{"anyOf":[{"$ref":"#/definitions/LogicalNot<Predicate>"},{"$ref":"#/definitions/LogicalAnd<Predicate>"},{"$ref":"#/definitions/LogicalOr<Predicate>"},{"$ref":"#/definitions/Predicate"}]},"LogicalNot<Predicate>":{"additionalProperties":false,"properties":{"not":{"$ref":"#/definitions/PredicateComposition"}},"required":["not"],"type":"object"},"LogicalOr<Predicate>":{"additionalProperties":false,"properties":{"or":{"items":{"$ref":"#/definitions/PredicateComposition"},"type":"array"}},"required":["or"],"type":"object"},"LookupData":{"additionalProperties":false,"properties":{"data":{"$ref":"#/definitions/Data","description":"Secondary data source to lookup in."},"fields":{"description":"Fields in foreign data or selection to lookup. If not specified, the entire object is queried.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"key":{"$ref":"#/definitions/FieldName","description":"Key in data to lookup."}},"required":["data","key"],"type":"object"},"LookupSelection":{"additionalProperties":false,"properties":{"fields":{"description":"Fields in foreign data or selection to lookup. If not specified, the entire object is queried.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"key":{"$ref":"#/definitions/FieldName","description":"Key in data to lookup."},"param":{"$ref":"#/definitions/ParameterName","description":"Selection parameter name to look up."}},"required":["key","param"],"type":"object"},"LookupTransform":{"additionalProperties":false,"properties":{"as":{"anyOf":[{"$ref":"#/definitions/FieldName"},{"items":{"$ref":"#/definitions/FieldName"},"type":"array"}],"description":"The output fields on which to store the looked up data values.\\n\\nFor data lookups, this property may be left blank if `from.fields` has been specified (those field names will be used); if `from.fields` has not been specified, `as` must be a string.\\n\\nFor selection lookups, this property is optional: if unspecified, looked up values will be stored under a property named for the selection; and if specified, it must correspond to `from.fields`."},"default":{"description":"The default value to use if lookup fails.\\n\\n__Default value:__ `null`"},"from":{"anyOf":[{"$ref":"#/definitions/LookupData"},{"$ref":"#/definitions/LookupSelection"}],"description":"Data source or selection for secondary data reference."},"lookup":{"description":"Key in primary data source.","type":"string"}},"required":["lookup","from"],"type":"object"},"Mark":{"description":"All types of primitive marks.","enum":["arc","area","bar","image","line","point","rect","rule","text","tick","trail","circle","square","geoshape"],"type":"string"},"MarkConfig":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"MarkDef":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"bandSize":{"description":"The width of the ticks.\\n\\n__Default value:__  3/4 of step (width step for horizontal ticks and height step for vertical ticks).","minimum":0,"type":"number"},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"binSpacing":{"description":"Offset between bars for binned field. The ideal value for this is either 0 (preferred by statisticians) or 1 (Vega-Lite default, D3 example style).\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"clip":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"Whether a mark be clipped to the enclosing group\u2019s width and height."},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"continuousBandSize":{"description":"The default size of the bars on continuous scales.\\n\\n__Default value:__ `5`","minimum":0,"type":"number"},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusEnd":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For vertical bars, top-left and top-right corner radius.\\n\\n- For horizontal bars, top-right and bottom-right corner radius."},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"discreteBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RelativeBandSize"}],"description":"The default size of the bars with discrete dimensions. If unspecified, the default size is  `step-2`, which provides 2 pixel offset between bars.","minimum":0},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RelativeBandSize"}],"description":"Height of the marks.  One of:\\n\\n- A number representing a fixed pixel height.\\n\\n- A relative band size definition.  For example, `{band: 0.5}` represents half of the band"},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"line":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/OverlayMarkDef"}],"description":"A flag for overlaying line on top of area marks, or an object defining the properties of the overlayed lines.\\n\\n- If this value is an empty object (`{}`) or `true`, lines with default properties will be used.\\n\\n- If this value is `false`, no lines would be automatically added to area marks.\\n\\n__Default value:__ `false`."},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"minBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum band size for bar and rectangle marks. __Default value:__ `0.25`"},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"point":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/OverlayMarkDef"},{"const":"transparent","type":"string"}],"description":"A flag for overlaying points on top of line or area marks, or an object defining the properties of the overlayed points.\\n\\n- If this property is `\\"transparent\\"`, transparent points will be used (for enhancing tooltips and selections).\\n\\n- If this property is an empty object (`{}`) or `true`, filled points with default properties will be used.\\n\\n- If this property is `false`, no points would be automatically added to line or area marks.\\n\\n__Default value:__ `false`."},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"radius2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for radius2."},"radiusOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for radius."},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"style":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}],"description":"A string or array of strings indicating the name of custom styles to apply to the mark. A style is a named collection of mark property defaults defined within the [style configuration](https://vega.github.io/vega-lite/docs/mark.html#style-config). If style is an array, later styles will override earlier styles. Any [mark properties](https://vega.github.io/vega-lite/docs/encoding.html#mark-prop) explicitly defined within the `encoding` will override a style default.\\n\\n__Default value:__ The mark\'s name. For example, a bar mark will have style `\\"bar\\"` by default. __Note:__ Any specified style will augment the default style. For example, a bar mark with `\\"style\\": \\"foo\\"` will receive from `config.style.bar` and `config.style.foo` (the specified style `\\"foo\\"` has higher precedence)."},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"theta2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for theta2."},"thetaOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for theta."},"thickness":{"description":"Thickness of the tick mark.\\n\\n__Default value:__  `1`","minimum":0,"type":"number"},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"type":{"$ref":"#/definitions/Mark","description":"The mark type. This could a primitive mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"geoshape\\"`, `\\"rule\\"`, and `\\"text\\"`) or a composite mark type (`\\"boxplot\\"`, `\\"errorband\\"`, `\\"errorbar\\"`)."},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RelativeBandSize"}],"description":"Width of the marks.  One of:\\n\\n- A number representing a fixed pixel width.\\n\\n- A relative band size definition.  For example, `{band: 0.5}` represents half of the band."},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for x2-position."},"xOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for x-position."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for y2-position."},"yOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for y-position."}},"required":["type"],"type":"object"},"MarkInvalidDataMode":{"enum":["filter","break-paths-filter-domains","break-paths-show-domains","break-paths-show-path-domains","show"],"type":"string"},"MarkPropDef<(Gradient|string|null)>":{"anyOf":[{"$ref":"#/definitions/FieldOrDatumDefWithCondition<MarkPropFieldDef,(Gradient|string|null)>"},{"$ref":"#/definitions/FieldOrDatumDefWithCondition<DatumDef,(Gradient|string|null)>"},{"$ref":"#/definitions/ValueDefWithCondition<MarkPropFieldOrDatumDef,(Gradient|string|null)>"}]},"MarkPropDef<(string|null),TypeForShape>":{"anyOf":[{"$ref":"#/definitions/FieldOrDatumDefWithCondition<MarkPropFieldDef<TypeForShape>,(string|null)>"},{"$ref":"#/definitions/FieldOrDatumDefWithCondition<DatumDef,(string|null)>"},{"$ref":"#/definitions/ValueDefWithCondition<MarkPropFieldOrDatumDef<TypeForShape>,(string|null)>"}]},"MarkPropDef<number>":{"anyOf":[{"$ref":"#/definitions/FieldOrDatumDefWithCondition<MarkPropFieldDef,number>"},{"$ref":"#/definitions/FieldOrDatumDefWithCondition<DatumDef,number>"},{"$ref":"#/definitions/ValueDefWithCondition<MarkPropFieldOrDatumDef,number>"}]},"MarkPropDef<number[]>":{"anyOf":[{"$ref":"#/definitions/FieldOrDatumDefWithCondition<MarkPropFieldDef,number[]>"},{"$ref":"#/definitions/FieldOrDatumDefWithCondition<DatumDef,number[]>"},{"$ref":"#/definitions/ValueDefWithCondition<MarkPropFieldOrDatumDef,number[]>"}]},"MarkType":{"enum":["arc","area","image","group","line","path","rect","rule","shape","symbol","text","trail"],"type":"string"},"MergedStream":{"additionalProperties":false,"properties":{"between":{"items":{"$ref":"#/definitions/Stream"},"type":"array"},"consume":{"type":"boolean"},"debounce":{"type":"number"},"filter":{"anyOf":[{"$ref":"#/definitions/Expr"},{"items":{"$ref":"#/definitions/Expr"},"type":"array"}]},"markname":{"type":"string"},"marktype":{"$ref":"#/definitions/MarkType"},"merge":{"items":{"$ref":"#/definitions/Stream"},"type":"array"},"throttle":{"type":"number"}},"required":["merge"],"type":"object"},"Month":{"maximum":12,"minimum":1,"type":"number"},"MultiLineString":{"additionalProperties":false,"description":"MultiLineString geometry object. https://tools.ietf.org/html/rfc7946#section-3.1.5","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"coordinates":{"items":{"items":{"$ref":"#/definitions/Position"},"type":"array"},"type":"array"},"type":{"const":"MultiLineString","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["coordinates","type"],"type":"object"},"MultiPoint":{"additionalProperties":false,"description":"MultiPoint geometry object.  https://tools.ietf.org/html/rfc7946#section-3.1.3","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"coordinates":{"items":{"$ref":"#/definitions/Position"},"type":"array"},"type":{"const":"MultiPoint","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["coordinates","type"],"type":"object"},"MultiPolygon":{"additionalProperties":false,"description":"MultiPolygon geometry object. https://tools.ietf.org/html/rfc7946#section-3.1.7","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"coordinates":{"items":{"items":{"items":{"$ref":"#/definitions/Position"},"type":"array"},"type":"array"},"type":"array"},"type":{"const":"MultiPolygon","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["coordinates","type"],"type":"object"},"MultiTimeUnit":{"anyOf":[{"$ref":"#/definitions/LocalMultiTimeUnit"},{"$ref":"#/definitions/UtcMultiTimeUnit"}]},"NamedData":{"additionalProperties":false,"properties":{"format":{"$ref":"#/definitions/DataFormat","description":"An object that specifies the format for parsing the data."},"name":{"description":"Provide a placeholder name and bind data at runtime.\\n\\nNew data may change the layout but Vega does not always resize the chart. To update the layout when the data updates, set [autosize](https://vega.github.io/vega-lite/docs/size.html#autosize) or explicitly use [view.resize](https://vega.github.io/vega/docs/api/view/#view_resize).","type":"string"}},"required":["name"],"type":"object"},"NonArgAggregateOp":{"enum":["average","count","distinct","max","mean","median","min","missing","product","q1","q3","ci0","ci1","stderr","stdev","stdevp","sum","valid","values","variance","variancep","exponential","exponentialb"],"type":"string"},"NonLayerRepeatSpec":{"additionalProperties":false,"description":"Base interface for a repeat specification.","properties":{"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"repeat":{"anyOf":[{"items":{"type":"string"},"type":"array"},{"$ref":"#/definitions/RepeatMapping"}],"description":"Definition for fields to be repeated. One of: 1) An array of fields to be repeated. If `\\"repeat\\"` is an array, the field can be referred to as `{\\"repeat\\": \\"repeat\\"}`. The repeated views are laid out in a wrapped row. You can set the number of columns to control the wrapping. 2) An object that maps `\\"row\\"` and/or `\\"column\\"` to the listed fields to be repeated along the particular orientations. The objects `{\\"repeat\\": \\"row\\"}` and `{\\"repeat\\": \\"column\\"}` can be used to refer to the repeated field respectively."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"spec":{"$ref":"#/definitions/NonNormalizedSpec","description":"A specification of the view that gets repeated."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"}},"required":["repeat","spec"],"type":"object"},"NonNormalizedSpec":{"$ref":"#/definitions/Spec"},"NumberLocale":{"additionalProperties":false,"description":"Locale definition for formatting numbers.","properties":{"currency":{"$ref":"#/definitions/Vector2<string>","description":"The currency prefix and suffix (e.g., [\\"$\\", \\"\\"])."},"decimal":{"description":"The decimal point (e.g., \\".\\").","type":"string"},"grouping":{"description":"The array of group sizes (e.g., [3]), cycled as needed.","items":{"type":"number"},"type":"array"},"minus":{"description":"The minus sign (defaults to hyphen-minus, \\"-\\").","type":"string"},"nan":{"description":"The not-a-number value (defaults to \\"NaN\\").","type":"string"},"numerals":{"$ref":"#/definitions/Vector10<string>","description":"An array of ten strings to replace the numerals 0-9."},"percent":{"description":"The percent sign (defaults to \\"%\\").","type":"string"},"thousands":{"description":"The group separator (e.g., \\",\\").","type":"string"}},"required":["decimal","thousands","grouping","currency"],"type":"object"},"NumericArrayMarkPropDef":{"$ref":"#/definitions/MarkPropDef<number[]>"},"NumericMarkPropDef":{"$ref":"#/definitions/MarkPropDef<number>"},"OffsetDef":{"anyOf":[{"$ref":"#/definitions/ScaleFieldDef"},{"$ref":"#/definitions/ScaleDatumDef"},{"$ref":"#/definitions/ValueDef<number>"}]},"OrderFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"sort":{"$ref":"#/definitions/SortOrder","description":"The sort order. One of `\\"ascending\\"` (default) or `\\"descending\\"`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"OrderOnlyDef":{"additionalProperties":false,"properties":{"sort":{"$ref":"#/definitions/SortOrder","description":"The sort order. One of `\\"ascending\\"` (default) or `\\"descending\\"`."}},"type":"object"},"OrderValueDef":{"additionalProperties":false,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<number>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<number>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["value"],"type":"object"},"Orient":{"enum":["left","right","top","bottom"],"type":"string"},"Orientation":{"enum":["horizontal","vertical"],"type":"string"},"OverlayMarkDef":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"clip":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"Whether a mark be clipped to the enclosing group\u2019s width and height."},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"radius2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for radius2."},"radiusOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for radius."},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"style":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}],"description":"A string or array of strings indicating the name of custom styles to apply to the mark. A style is a named collection of mark property defaults defined within the [style configuration](https://vega.github.io/vega-lite/docs/mark.html#style-config). If style is an array, later styles will override earlier styles. Any [mark properties](https://vega.github.io/vega-lite/docs/encoding.html#mark-prop) explicitly defined within the `encoding` will override a style default.\\n\\n__Default value:__ The mark\'s name. For example, a bar mark will have style `\\"bar\\"` by default. __Note:__ Any specified style will augment the default style. For example, a bar mark with `\\"style\\": \\"foo\\"` will receive from `config.style.bar` and `config.style.foo` (the specified style `\\"foo\\"` has higher precedence)."},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"theta2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for theta2."},"thetaOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for theta."},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for x2-position."},"xOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for x-position."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2Offset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for y2-position."},"yOffset":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Offset for y-position."}},"type":"object"},"Padding":{"anyOf":[{"type":"number"},{"additionalProperties":false,"properties":{"bottom":{"type":"number"},"left":{"type":"number"},"right":{"type":"number"},"top":{"type":"number"}},"type":"object"}],"minimum":0},"ParameterExtent":{"anyOf":[{"additionalProperties":false,"properties":{"field":{"$ref":"#/definitions/FieldName","description":"If a selection parameter is specified, the field name to extract selected values for when the selection is [projected](https://vega.github.io/vega-lite/docs/selection.html#project) over multiple fields or encodings."},"param":{"$ref":"#/definitions/ParameterName","description":"The name of a parameter."}},"required":["param"],"type":"object"},{"additionalProperties":false,"properties":{"encoding":{"$ref":"#/definitions/SingleDefUnitChannel","description":"If a selection parameter is specified, the encoding channel to extract selected values for when a selection is [projected](https://vega.github.io/vega-lite/docs/selection.html#project) over multiple fields or encodings."},"param":{"$ref":"#/definitions/ParameterName","description":"The name of a parameter."}},"required":["param"],"type":"object"}]},"ParameterName":{"type":"string"},"ParameterPredicate":{"additionalProperties":false,"properties":{"empty":{"description":"For selection parameters, the predicate of empty selections returns true by default. Override this behavior, by setting this property `empty: false`.","type":"boolean"},"param":{"$ref":"#/definitions/ParameterName","description":"Filter using a parameter name."}},"required":["param"],"type":"object"},"Parse":{"additionalProperties":{"$ref":"#/definitions/ParseValue"},"type":"object"},"ParseValue":{"type":["string","null"]},"PivotTransform":{"additionalProperties":false,"properties":{"groupby":{"description":"The optional data fields to group by. If not specified, a single group containing all data objects will be used.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"limit":{"description":"An optional parameter indicating the maximum number of pivoted fields to generate. The default (`0`) applies no limit. The pivoted `pivot` names are sorted in ascending order prior to enforcing the limit. __Default value:__ `0`","type":"number"},"op":{"$ref":"#/definitions/AggregateOp","description":"The aggregation operation to apply to grouped `value` field values. __Default value:__ `sum`"},"pivot":{"$ref":"#/definitions/FieldName","description":"The data field to pivot on. The unique values of this field become new field names in the output stream."},"value":{"$ref":"#/definitions/FieldName","description":"The data field to populate pivoted fields. The aggregate values of this field become the values of the new pivoted fields."}},"required":["pivot","value"],"type":"object"},"Point":{"additionalProperties":false,"description":"Point geometry object. https://tools.ietf.org/html/rfc7946#section-3.1.2","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"coordinates":{"$ref":"#/definitions/Position"},"type":{"const":"Point","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["coordinates","type"],"type":"object"},"PointSelectionConfig":{"additionalProperties":false,"properties":{"clear":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"},{"type":"boolean"}],"description":"Clears the selection, emptying it of all values. This property can be a [Event Stream](https://vega.github.io/vega/docs/event-streams/) or `false` to disable clear.\\n\\n__Default value:__ `dblclick`.\\n\\n__See also:__ [`clear` examples ](https://vega.github.io/vega-lite/docs/selection.html#clear) in the documentation."},"encodings":{"description":"An array of encoding channels. The corresponding data field values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/SingleDefUnitChannel"},"type":"array"},"fields":{"description":"An array of field names whose values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"nearest":{"description":"When true, an invisible voronoi diagram is computed to accelerate discrete selection. The data value _nearest_ the mouse cursor is added to the selection.\\n\\n__Default value:__ `false`, which means that data values must be interacted with directly (e.g., clicked on) to be added to the selection.\\n\\n__See also:__ [`nearest` examples](https://vega.github.io/vega-lite/docs/selection.html#nearest) documentation.","type":"boolean"},"on":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"}],"description":"A [Vega event stream](https://vega.github.io/vega/docs/event-streams/) (object or selector) that triggers the selection. For interval selections, the event stream must specify a [start and end](https://vega.github.io/vega/docs/event-streams/#between-filters).\\n\\n__See also:__ [`on` examples](https://vega.github.io/vega-lite/docs/selection.html#on) in the documentation."},"resolve":{"$ref":"#/definitions/SelectionResolution","description":"With layered and multi-view displays, a strategy that determines how selections\' data queries are resolved when applied in a filter transform, conditional encoding rule, or scale domain.\\n\\nOne of:\\n- `\\"global\\"` -- only one brush exists for the entire SPLOM. When the user begins to drag, any previous brushes are cleared, and a new one is constructed.\\n- `\\"union\\"` -- each cell contains its own brush, and points are highlighted if they lie within _any_ of these individual brushes.\\n- `\\"intersect\\"` -- each cell contains its own brush, and points are highlighted only if they fall within _all_ of these individual brushes.\\n\\n__Default value:__ `global`.\\n\\n__See also:__ [`resolve` examples](https://vega.github.io/vega-lite/docs/selection.html#resolve) in the documentation."},"toggle":{"description":"Controls whether data values should be toggled (inserted or removed from a point selection) or only ever inserted into point selections.\\n\\nOne of:\\n- `true` -- the default behavior, which corresponds to `\\"event.shiftKey\\"`.  As a result, data values are toggled when the user interacts with the shift-key pressed.\\n- `false` -- disables toggling behaviour; the selection will only ever contain a single data value corresponding to the most recent interaction.\\n- A [Vega expression](https://vega.github.io/vega/docs/expressions/) which is re-evaluated as the user interacts. If the expression evaluates to `true`, the data value is toggled into or out of the point selection. If the expression evaluates to `false`, the point selection is first cleared, and the data value is then inserted. For example, setting the value to the Vega expression `\\"true\\"` will toggle data values without the user pressing the shift-key.\\n\\n__Default value:__ `true`\\n\\n__See also:__ [`toggle` examples](https://vega.github.io/vega-lite/docs/selection.html#toggle) in the documentation.","type":["string","boolean"]},"type":{"const":"point","description":"Determines the default event processing and data query for the selection. Vega-Lite currently supports two selection types:\\n\\n- `\\"point\\"` -- to select multiple discrete data values; the first value is selected on `click` and additional values toggled on shift-click.\\n- `\\"interval\\"` -- to select a continuous range of data values on `drag`.","type":"string"}},"required":["type"],"type":"object"},"PointSelectionConfigWithoutType":{"additionalProperties":false,"properties":{"clear":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"},{"type":"boolean"}],"description":"Clears the selection, emptying it of all values. This property can be a [Event Stream](https://vega.github.io/vega/docs/event-streams/) or `false` to disable clear.\\n\\n__Default value:__ `dblclick`.\\n\\n__See also:__ [`clear` examples ](https://vega.github.io/vega-lite/docs/selection.html#clear) in the documentation."},"encodings":{"description":"An array of encoding channels. The corresponding data field values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/SingleDefUnitChannel"},"type":"array"},"fields":{"description":"An array of field names whose values must match for a data tuple to fall within the selection.\\n\\n__See also:__ The [projection with `encodings` and `fields` section](https://vega.github.io/vega-lite/docs/selection.html#project) in the documentation.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"nearest":{"description":"When true, an invisible voronoi diagram is computed to accelerate discrete selection. The data value _nearest_ the mouse cursor is added to the selection.\\n\\n__Default value:__ `false`, which means that data values must be interacted with directly (e.g., clicked on) to be added to the selection.\\n\\n__See also:__ [`nearest` examples](https://vega.github.io/vega-lite/docs/selection.html#nearest) documentation.","type":"boolean"},"on":{"anyOf":[{"$ref":"#/definitions/Stream"},{"type":"string"}],"description":"A [Vega event stream](https://vega.github.io/vega/docs/event-streams/) (object or selector) that triggers the selection. For interval selections, the event stream must specify a [start and end](https://vega.github.io/vega/docs/event-streams/#between-filters).\\n\\n__See also:__ [`on` examples](https://vega.github.io/vega-lite/docs/selection.html#on) in the documentation."},"resolve":{"$ref":"#/definitions/SelectionResolution","description":"With layered and multi-view displays, a strategy that determines how selections\' data queries are resolved when applied in a filter transform, conditional encoding rule, or scale domain.\\n\\nOne of:\\n- `\\"global\\"` -- only one brush exists for the entire SPLOM. When the user begins to drag, any previous brushes are cleared, and a new one is constructed.\\n- `\\"union\\"` -- each cell contains its own brush, and points are highlighted if they lie within _any_ of these individual brushes.\\n- `\\"intersect\\"` -- each cell contains its own brush, and points are highlighted only if they fall within _all_ of these individual brushes.\\n\\n__Default value:__ `global`.\\n\\n__See also:__ [`resolve` examples](https://vega.github.io/vega-lite/docs/selection.html#resolve) in the documentation."},"toggle":{"description":"Controls whether data values should be toggled (inserted or removed from a point selection) or only ever inserted into point selections.\\n\\nOne of:\\n- `true` -- the default behavior, which corresponds to `\\"event.shiftKey\\"`.  As a result, data values are toggled when the user interacts with the shift-key pressed.\\n- `false` -- disables toggling behaviour; the selection will only ever contain a single data value corresponding to the most recent interaction.\\n- A [Vega expression](https://vega.github.io/vega/docs/expressions/) which is re-evaluated as the user interacts. If the expression evaluates to `true`, the data value is toggled into or out of the point selection. If the expression evaluates to `false`, the point selection is first cleared, and the data value is then inserted. For example, setting the value to the Vega expression `\\"true\\"` will toggle data values without the user pressing the shift-key.\\n\\n__Default value:__ `true`\\n\\n__See also:__ [`toggle` examples](https://vega.github.io/vega-lite/docs/selection.html#toggle) in the documentation.","type":["string","boolean"]}},"type":"object"},"PolarDef":{"anyOf":[{"$ref":"#/definitions/PositionFieldDefBase"},{"$ref":"#/definitions/PositionDatumDefBase"},{"$ref":"#/definitions/PositionValueDef"}]},"Polygon":{"additionalProperties":false,"description":"Polygon geometry object. https://tools.ietf.org/html/rfc7946#section-3.1.6","properties":{"bbox":{"$ref":"#/definitions/BBox","description":"Bounding box of the coordinate range of the object\'s Geometries, Features, or Feature Collections. The value of the bbox member is an array of length 2*n where n is the number of dimensions represented in the contained geometries, with all axes of the most southwesterly point followed by all axes of the more northeasterly point. The axes order of a bbox follows the axes order of geometries. https://tools.ietf.org/html/rfc7946#section-5"},"coordinates":{"items":{"items":{"$ref":"#/definitions/Position"},"type":"array"},"type":"array"},"type":{"const":"Polygon","description":"Specifies the type of GeoJSON object.","type":"string"}},"required":["coordinates","type"],"type":"object"},"Position":{"description":"A Position is an array of coordinates. https://tools.ietf.org/html/rfc7946#section-3.1.1 Array should contain between two and three elements. The previous GeoJSON specification allowed more elements (e.g., which could be used to represent M values), but the current specification only allows X, Y, and (optionally) Z to be defined.\\n\\nNote: the type will not be narrowed down to `[number, number] | [number, number, number]` due to marginal benefits and the large impact of breaking change.\\n\\nSee previous discussions on the type narrowing:\\n-  {@link  https://github.com/DefinitelyTyped/DefinitelyTyped/pull/21590 Nov 2017 } \\n-  {@link  https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/67773 Dec 2023 } \\n-  {@link  https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/71441 Dec 2024 } \\n\\nOne can use a  {@link  https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates user-defined type guard that returns a type predicate }  to determine if a position is a 2D or 3D position.","items":{"type":"number"},"type":"array"},"Position2Def":{"anyOf":[{"$ref":"#/definitions/SecondaryFieldDef"},{"$ref":"#/definitions/DatumDef"},{"$ref":"#/definitions/PositionValueDef"}]},"PositionDatumDef":{"additionalProperties":false,"properties":{"axis":{"anyOf":[{"$ref":"#/definitions/Axis"},{"type":"null"}],"description":"An object defining properties of axis\'s gridlines, ticks and labels. If `null`, the axis for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [axis properties](https://vega.github.io/vega-lite/docs/axis.html) are applied.\\n\\n__See also:__ [`axis`](https://vega.github.io/vega-lite/docs/axis.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"impute":{"anyOf":[{"$ref":"#/definitions/ImputeParams"},{"type":"null"}],"description":"An object defining the properties of the Impute Operation to be applied. The field value of the other positional channel is taken as `key` of the `Impute` Operation. The field of the `color` channel if specified is used as `groupby` of the `Impute` Operation.\\n\\n__See also:__ [`impute`](https://vega.github.io/vega-lite/docs/impute.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"PositionDatumDefBase":{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"PositionDef":{"anyOf":[{"$ref":"#/definitions/PositionFieldDef"},{"$ref":"#/definitions/PositionDatumDef"},{"$ref":"#/definitions/PositionValueDef"}]},"PositionFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"axis":{"anyOf":[{"$ref":"#/definitions/Axis"},{"type":"null"}],"description":"An object defining properties of axis\'s gridlines, ticks and labels. If `null`, the axis for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [axis properties](https://vega.github.io/vega-lite/docs/axis.html) are applied.\\n\\n__See also:__ [`axis`](https://vega.github.io/vega-lite/docs/axis.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"impute":{"anyOf":[{"$ref":"#/definitions/ImputeParams"},{"type":"null"}],"description":"An object defining the properties of the Impute Operation to be applied. The field value of the other positional channel is taken as `key` of the `Impute` Operation. The field of the `color` channel if specified is used as `groupby` of the `Impute` Operation.\\n\\n__See also:__ [`impute`](https://vega.github.io/vega-lite/docs/impute.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"PositionFieldDefBase":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"PositionValueDef":{"$ref":"#/definitions/ValueDef<(number|\\"width\\"|\\"height\\"|ExprRef)>"},"Predicate":{"anyOf":[{"$ref":"#/definitions/FieldEqualPredicate"},{"$ref":"#/definitions/FieldRangePredicate"},{"$ref":"#/definitions/FieldOneOfPredicate"},{"$ref":"#/definitions/FieldLTPredicate"},{"$ref":"#/definitions/FieldGTPredicate"},{"$ref":"#/definitions/FieldLTEPredicate"},{"$ref":"#/definitions/FieldGTEPredicate"},{"$ref":"#/definitions/FieldValidPredicate"},{"$ref":"#/definitions/ParameterPredicate"},{"type":"string"}]},"PrimitiveValue":{"type":["number","string","boolean","null"]},"Projection":{"additionalProperties":false,"properties":{"center":{"anyOf":[{"$ref":"#/definitions/Vector2<number>","description":"The projection\'s center, a two-element array of longitude and latitude in degrees.\\n\\n__Default value:__ `[0, 0]`"},{"$ref":"#/definitions/ExprRef"}]},"clipAngle":{"anyOf":[{"description":"The projection\'s clipping circle radius to the specified angle in degrees. If `null`, switches to [antimeridian](http://bl.ocks.org/mbostock/3788999) cutting rather than small-circle clipping.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"clipExtent":{"anyOf":[{"$ref":"#/definitions/Vector2<Vector2<number>>","description":"The projection\'s viewport clip extent to the specified bounds in pixels. The extent bounds are specified as an array `[[x0, y0], [x1, y1]]`, where `x0` is the left-side of the viewport, `y0` is the top, `x1` is the right and `y1` is the bottom. If `null`, no viewport clipping is performed."},{"$ref":"#/definitions/ExprRef"}]},"coefficient":{"anyOf":[{"description":"The coefficient parameter for the `hammer` projection.\\n\\n__Default value:__ `2`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"distance":{"anyOf":[{"description":"For the `satellite` projection, the distance from the center of the sphere to the point of view, as a proportion of the sphere\u2019s radius. The recommended maximum clip angle for a given `distance` is acos(1 / distance) converted to degrees. If tilt is also applied, then more conservative clipping may be necessary.\\n\\n__Default value:__ `2.0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"extent":{"anyOf":[{"$ref":"#/definitions/Vector2<Vector2<number>>"},{"$ref":"#/definitions/ExprRef"}]},"fit":{"anyOf":[{"$ref":"#/definitions/Fit"},{"items":{"$ref":"#/definitions/Fit"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"fraction":{"anyOf":[{"description":"The fraction parameter for the `bottomley` projection.\\n\\n__Default value:__ `0.5`, corresponding to a sin(\u03C8) where \u03C8 = \u03C0/6.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lobes":{"anyOf":[{"description":"The number of lobes in projections that support multi-lobe views: `berghaus`, `gingery`, or `healpix`. The default value varies based on the projection type.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"parallel":{"anyOf":[{"description":"The parallel parameter for projections that support it: `armadillo`, `bonne`, `craig`, `cylindricalEqualArea`, `cylindricalStereographic`, `hammerRetroazimuthal`, `loximuthal`, or `rectangularPolyconic`. The default value varies based on the projection type.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"parallels":{"anyOf":[{"description":"For conic projections, the [two standard parallels](https://en.wikipedia.org/wiki/Map_projection#Conic) that define the map layout. The default depends on the specific conic projection used.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"pointRadius":{"anyOf":[{"description":"The default radius (in pixels) to use when drawing GeoJSON `Point` and `MultiPoint` geometries. This parameter sets a constant default value. To modify the point radius in response to data, see the corresponding parameter of the GeoPath and GeoShape transforms.\\n\\n__Default value:__ `4.5`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"precision":{"anyOf":[{"description":"The threshold for the projection\'s [adaptive resampling](http://bl.ocks.org/mbostock/3795544) to the specified value in pixels. This value corresponds to the [Douglas\u2013Peucker distance](http://en.wikipedia.org/wiki/Ramer%E2%80%93Douglas%E2%80%93Peucker_algorithm). If precision is not specified, returns the projection\'s current resampling precision which defaults to `\u221A0.5 \u2245 0.70710\u2026`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"radius":{"anyOf":[{"description":"The radius parameter for the `airy` or `gingery` projection. The default value varies based on the projection type.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ratio":{"anyOf":[{"description":"The ratio parameter for the `hill`, `hufnagel`, or `wagner` projections. The default value varies based on the projection type.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"reflectX":{"anyOf":[{"description":"Sets whether or not the x-dimension is reflected (negated) in the output.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"reflectY":{"anyOf":[{"description":"Sets whether or not the y-dimension is reflected (negated) in the output.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"rotate":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/Vector2<number>"},{"$ref":"#/definitions/Vector3<number>"}],"description":"The projection\'s three-axis rotation to the specified angles, which must be a two- or three-element array of numbers [`lambda`, `phi`, `gamma`] specifying the rotation angles in degrees about each spherical axis. (These correspond to yaw, pitch and roll.)\\n\\n__Default value:__ `[0, 0, 0]`"},{"$ref":"#/definitions/ExprRef"}]},"scale":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The projection\u2019s scale (zoom) factor, overriding automatic fitting. The default scale is projection-specific. The scale factor corresponds linearly to the distance between projected points; however, scale factor values are not equivalent across projections."},"size":{"anyOf":[{"$ref":"#/definitions/Vector2<number>","description":"Used in conjunction with fit, provides the width and height in pixels of the area to which the projection should be automatically fit."},{"$ref":"#/definitions/ExprRef"}]},"spacing":{"anyOf":[{"description":"The spacing parameter for the `lagrange` projection.\\n\\n__Default value:__ `0.5`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tilt":{"anyOf":[{"description":"The tilt angle (in degrees) for the `satellite` projection.\\n\\n__Default value:__ `0`.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"translate":{"anyOf":[{"$ref":"#/definitions/Vector2<number>"},{"$ref":"#/definitions/ExprRef"}],"description":"The projection\u2019s translation offset as a two-element array `[tx, ty]`."},"type":{"anyOf":[{"$ref":"#/definitions/ProjectionType"},{"$ref":"#/definitions/ExprRef"}],"description":"The cartographic projection to use. This value is case-insensitive, for example `\\"albers\\"` and `\\"Albers\\"` indicate the same projection type. You can find all valid projection types [in the documentation](https://vega.github.io/vega-lite/docs/projection.html#projection-types).\\n\\n__Default value:__ `equalEarth`"}},"type":"object"},"ProjectionConfig":{"$ref":"#/definitions/Projection","description":"Any property of Projection can be in config"},"ProjectionType":{"enum":["albers","albersUsa","azimuthalEqualArea","azimuthalEquidistant","conicConformal","conicEqualArea","conicEquidistant","equalEarth","equirectangular","gnomonic","identity","mercator","naturalEarth1","orthographic","stereographic","transverseMercator"],"type":"string"},"QuantileTransform":{"additionalProperties":false,"properties":{"as":{"description":"The output field names for the probability and quantile values.\\n\\n__Default value:__ `[\\"prob\\", \\"value\\"]`","items":{"$ref":"#/definitions/FieldName"},"maxItems":2,"minItems":2,"type":"array"},"groupby":{"description":"The data fields to group by. If not specified, a single group containing all data objects will be used.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"probs":{"description":"An array of probabilities in the range (0, 1) for which to compute quantile values. If not specified, the *step* parameter will be used.","items":{"type":"number"},"type":"array"},"quantile":{"$ref":"#/definitions/FieldName","description":"The data field for which to perform quantile estimation."},"step":{"description":"A probability step size (default 0.01) for sampling quantile values. All values from one-half the step size up to 1 (exclusive) will be sampled. This parameter is only used if the *probs* parameter is not provided.","type":"number"}},"required":["quantile"],"type":"object"},"RadialGradient":{"additionalProperties":false,"properties":{"gradient":{"const":"radial","description":"The type of gradient. Use `\\"radial\\"` for a radial gradient.","type":"string"},"id":{"type":"string"},"r1":{"description":"The radius length, in normalized [0, 1] coordinates, of the inner circle for the gradient.\\n\\n__Default value:__ `0`","type":"number"},"r2":{"description":"The radius length, in normalized [0, 1] coordinates, of the outer circle for the gradient.\\n\\n__Default value:__ `0.5`","type":"number"},"stops":{"description":"An array of gradient stops defining the gradient color sequence.","items":{"$ref":"#/definitions/GradientStop"},"type":"array"},"x1":{"description":"The x-coordinate, in normalized [0, 1] coordinates, for the center of the inner circle for the gradient.\\n\\n__Default value:__ `0.5`","type":"number"},"x2":{"description":"The x-coordinate, in normalized [0, 1] coordinates, for the center of the outer circle for the gradient.\\n\\n__Default value:__ `0.5`","type":"number"},"y1":{"description":"The y-coordinate, in normalized [0, 1] coordinates, for the center of the inner circle for the gradient.\\n\\n__Default value:__ `0.5`","type":"number"},"y2":{"description":"The y-coordinate, in normalized [0, 1] coordinates, for the center of the outer circle for the gradient.\\n\\n__Default value:__ `0.5`","type":"number"}},"required":["gradient","stops"],"type":"object"},"RangeConfig":{"additionalProperties":{"anyOf":[{"$ref":"#/definitions/RangeScheme"},{"type":"array"}]},"properties":{"category":{"anyOf":[{"$ref":"#/definitions/RangeScheme"},{"items":{"$ref":"#/definitions/Color"},"type":"array"}],"description":"Default [color scheme](https://vega.github.io/vega/docs/schemes/) for categorical data."},"diverging":{"anyOf":[{"$ref":"#/definitions/RangeScheme"},{"items":{"$ref":"#/definitions/Color"},"type":"array"}],"description":"Default [color scheme](https://vega.github.io/vega/docs/schemes/) for diverging quantitative ramps."},"heatmap":{"anyOf":[{"$ref":"#/definitions/RangeScheme"},{"items":{"$ref":"#/definitions/Color"},"type":"array"}],"description":"Default [color scheme](https://vega.github.io/vega/docs/schemes/) for quantitative heatmaps."},"ordinal":{"anyOf":[{"$ref":"#/definitions/RangeScheme"},{"items":{"$ref":"#/definitions/Color"},"type":"array"}],"description":"Default [color scheme](https://vega.github.io/vega/docs/schemes/) for rank-ordered data."},"ramp":{"anyOf":[{"$ref":"#/definitions/RangeScheme"},{"items":{"$ref":"#/definitions/Color"},"type":"array"}],"description":"Default [color scheme](https://vega.github.io/vega/docs/schemes/) for sequential quantitative ramps."},"symbol":{"description":"Array of [symbol](https://vega.github.io/vega/docs/marks/symbol/) names or paths for the default shape palette.","items":{"$ref":"#/definitions/SymbolShape"},"type":"array"}},"type":"object"},"RangeEnum":{"enum":["width","height","symbol","category","ordinal","ramp","diverging","heatmap"],"type":"string"},"RangeRaw":{"items":{"anyOf":[{"type":"null"},{"type":"boolean"},{"type":"string"},{"type":"number"},{"$ref":"#/definitions/RangeRawArray"}]},"type":"array"},"RangeRawArray":{"items":{"type":"number"},"type":"array"},"RangeScheme":{"anyOf":[{"$ref":"#/definitions/RangeEnum"},{"$ref":"#/definitions/RangeRaw"},{"additionalProperties":false,"properties":{"count":{"type":"number"},"extent":{"items":{"type":"number"},"type":"array"},"scheme":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"},{"$ref":"#/definitions/ColorScheme"}]}},"required":["scheme"],"type":"object"}]},"RectConfig":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"binSpacing":{"description":"Offset between bars for binned field. The ideal value for this is either 0 (preferred by statisticians) or 1 (Vega-Lite default, D3 example style).\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"continuousBandSize":{"description":"The default size of the bars on continuous scales.\\n\\n__Default value:__ `5`","minimum":0,"type":"number"},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"discreteBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RelativeBandSize"}],"description":"The default size of the bars with discrete dimensions. If unspecified, the default size is  `step-2`, which provides 2 pixel offset between bars.","minimum":0},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"minBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum band size for bar and rectangle marks. __Default value:__ `0.25`"},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"RegressionTransform":{"additionalProperties":false,"properties":{"as":{"description":"The output field names for the smoothed points generated by the regression transform.\\n\\n__Default value:__ The field names of the input x and y values.","items":{"$ref":"#/definitions/FieldName"},"maxItems":2,"minItems":2,"type":"array"},"extent":{"description":"A [min, max] domain over the independent (x) field for the starting and ending points of the generated trend line.","items":{"type":"number"},"maxItems":2,"minItems":2,"type":"array"},"groupby":{"description":"The data fields to group by. If not specified, a single group containing all data objects will be used.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"method":{"description":"The functional form of the regression model. One of `\\"linear\\"`, `\\"log\\"`, `\\"exp\\"`, `\\"pow\\"`, `\\"quad\\"`, or `\\"poly\\"`.\\n\\n__Default value:__ `\\"linear\\"`","enum":["linear","log","exp","pow","quad","poly"],"type":"string"},"on":{"$ref":"#/definitions/FieldName","description":"The data field of the independent variable to use a predictor."},"order":{"description":"The polynomial order (number of coefficients) for the \'poly\' method.\\n\\n__Default value:__ `3`","type":"number"},"params":{"description":"A boolean flag indicating if the transform should return the regression model parameters (one object per group), rather than trend line points. The resulting objects include a `coef` array of fitted coefficient values (starting with the intercept term and then including terms of increasing order) and an `rSquared` value (indicating the total variance explained by the model).\\n\\n__Default value:__ `false`","type":"boolean"},"regression":{"$ref":"#/definitions/FieldName","description":"The data field of the dependent variable to predict."}},"required":["regression","on"],"type":"object"},"RelativeBandSize":{"additionalProperties":false,"properties":{"band":{"description":"The relative band size.  For example `0.5` means half of the band scale\'s band width.","type":"number"}},"required":["band"],"type":"object"},"RepeatMapping":{"additionalProperties":false,"properties":{"column":{"description":"An array of fields to be repeated horizontally.","items":{"type":"string"},"type":"array"},"row":{"description":"An array of fields to be repeated vertically.","items":{"type":"string"},"type":"array"}},"type":"object"},"RepeatRef":{"additionalProperties":false,"description":"Reference to a repeated value.","properties":{"repeat":{"enum":["row","column","repeat","layer"],"type":"string"}},"required":["repeat"],"type":"object"},"RepeatSpec":{"anyOf":[{"$ref":"#/definitions/NonLayerRepeatSpec"},{"$ref":"#/definitions/LayerRepeatSpec"}]},"Resolve":{"additionalProperties":false,"description":"Defines how scales, axes, and legends from different specs should be combined. Resolve is a mapping from `scale`, `axis`, and `legend` to a mapping from channels to resolutions. Scales and guides can be resolved to be `\\"independent\\"` or `\\"shared\\"`.","properties":{"axis":{"$ref":"#/definitions/AxisResolveMap"},"legend":{"$ref":"#/definitions/LegendResolveMap"},"scale":{"$ref":"#/definitions/ScaleResolveMap"}},"type":"object"},"ResolveMode":{"enum":["independent","shared"],"type":"string"},"RowCol<LayoutAlign>":{"additionalProperties":false,"properties":{"column":{"$ref":"#/definitions/LayoutAlign"},"row":{"$ref":"#/definitions/LayoutAlign"}},"type":"object"},"RowCol<boolean>":{"additionalProperties":false,"properties":{"column":{"type":"boolean"},"row":{"type":"boolean"}},"type":"object"},"RowCol<number>":{"additionalProperties":false,"properties":{"column":{"type":"number"},"row":{"type":"number"}},"type":"object"},"RowColumnEncodingFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"align":{"$ref":"#/definitions/LayoutAlign","description":"The alignment to apply to row/column facet\'s subplot. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"center":{"description":"Boolean flag indicating if facet\'s subviews should be centered relative to their respective rows or columns.\\n\\n__Default value:__ `false`","type":"boolean"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"header":{"anyOf":[{"$ref":"#/definitions/Header"},{"type":"null"}],"description":"An object defining properties of a facet\'s header."},"sort":{"anyOf":[{"$ref":"#/definitions/SortArray"},{"$ref":"#/definitions/SortOrder"},{"$ref":"#/definitions/EncodingSortField"},{"type":"null"}],"description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` is not supported for `row` and `column`."},"spacing":{"description":"The spacing in pixels between facet\'s sub-views.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)","type":"number"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"SampleTransform":{"additionalProperties":false,"properties":{"sample":{"description":"The maximum number of data objects to include in the sample.\\n\\n__Default value:__ `1000`","type":"number"}},"required":["sample"],"type":"object"},"Scale":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The alignment of the steps within the scale range.\\n\\nThis value must lie in the range `[0,1]`. A value of `0.5` indicates that the steps should be centered within the range. A value of `0` or `1` may be used to shift the bands to one side, say to position them adjacent to an axis.\\n\\n__Default value:__ `0.5`"},"base":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The logarithm base of the `log` scale (default `10`)."},"bins":{"$ref":"#/definitions/ScaleBins","description":"Bin boundaries can be provided to scales as either an explicit array of bin boundaries or as a bin specification object. The legal values are:\\n- An [array](../types/#Array) literal of bin boundary values. For example, `[0, 5, 10, 15, 20]`. The array must include both starting and ending boundaries. The previous example uses five values to indicate a total of four bin intervals: [0-5), [5-10), [10-15), [15-20]. Array literals may include signal references as elements.\\n- A [bin specification object](https://vega.github.io/vega-lite/docs/scale.html#bins) that indicates the bin _step_ size, and optionally the _start_ and _stop_ boundaries.\\n- An array of bin boundaries over the scale domain. If provided, axes and legends will use the bin boundaries to inform the choice of tick marks and text labels."},"clamp":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"If `true`, values that exceed the data domain are clamped to either the minimum or maximum range value\\n\\n__Default value:__ derived from the [scale config](https://vega.github.io/vega-lite/docs/config.html#scale-config)\'s `clamp` (`true` by default)."},"constant":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant determining the slope of the symlog function around zero. Only used for `symlog` scales.\\n\\n__Default value:__ `1`"},"domain":{"anyOf":[{"items":{"anyOf":[{"type":"null"},{"type":"string"},{"type":"number"},{"type":"boolean"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}]},"type":"array"},{"const":"unaggregated","type":"string"},{"$ref":"#/definitions/ParameterExtent"},{"$ref":"#/definitions/DomainUnionWith"},{"$ref":"#/definitions/ExprRef"}],"description":"Customized domain values in the form of constant values or dynamic values driven by a parameter.\\n\\n1) Constant `domain` for _quantitative_ fields can take one of the following forms:\\n\\n- A two-element array with minimum and maximum values. To create a diverging scale, this two-element array can be combined with the `domainMid` property.\\n- An array with more than two entries, for [Piecewise quantitative scales](https://vega.github.io/vega-lite/docs/scale.html#piecewise).\\n- A string value `\\"unaggregated\\"`, if the input field is aggregated, to indicate that the domain should include the raw data values prior to the aggregation.\\n\\n2) Constant `domain` for _temporal_ fields can be a two-element array with minimum and maximum values, in the form of either timestamps or the [DateTime definition objects](https://vega.github.io/vega-lite/docs/types.html#datetime).\\n\\n3) Constant `domain` for _ordinal_ and _nominal_ fields can be an array that lists valid input values.\\n\\n4) To combine (union) specified constant domain with the field\'s values, `domain` can be an object with a `unionWith` property that specify constant domain to be combined. For example, `domain: {unionWith: [0, 100]}` for a quantitative scale means that the scale domain always includes `[0, 100]`, but will include other values in the fields beyond `[0, 100]`.\\n\\n5) Domain can also takes an object defining a field or encoding of a parameter that [interactively determines](https://vega.github.io/vega-lite/docs/selection.html#scale-domains) the scale domain."},"domainMax":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"Sets the maximum value in the scale domain, overriding the `domain` property. This property is only intended for use with scales having continuous domains."},"domainMid":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Inserts a single mid-point value into a two-element domain. The mid-point value must lie between the domain minimum and maximum values. This property can be useful for setting a midpoint for [diverging color scales](https://vega.github.io/vega-lite/docs/scale.html#piecewise). The domainMid property is only intended for use with scales supporting continuous, piecewise domains."},"domainMin":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"}],"description":"Sets the minimum value in the scale domain, overriding the domain property. This property is only intended for use with scales having continuous domains."},"domainRaw":{"$ref":"#/definitions/ExprRef","description":"An expression for an array of raw values that, if non-null, directly overrides the _domain_ property. This is useful for supporting interactions such as panning or zooming a scale. The scale may be initially determined using a data-driven domain, then modified in response to user input by setting the rawDomain value."},"exponent":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The exponent of the `pow` scale."},"interpolate":{"anyOf":[{"$ref":"#/definitions/ScaleInterpolateEnum"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/ScaleInterpolateParams"}],"description":"The interpolation method for range values. By default, a general interpolator for numbers, dates, strings and colors (in HCL space) is used. For color ranges, this property allows interpolation in alternative color spaces. Legal values include `rgb`, `hsl`, `hsl-long`, `lab`, `hcl`, `hcl-long`, `cubehelix` and `cubehelix-long` (\'-long\' variants use longer paths in polar coordinate spaces). If object-valued, this property accepts an object with a string-valued _type_ property and an optional numeric _gamma_ property applicable to rgb and cubehelix interpolators. For more, see the [d3-interpolate documentation](https://github.com/d3/d3-interpolate).\\n\\n* __Default value:__ `hcl`"},"nice":{"anyOf":[{"type":"boolean"},{"type":"number"},{"$ref":"#/definitions/TimeInterval"},{"$ref":"#/definitions/TimeIntervalStep"},{"$ref":"#/definitions/ExprRef"}],"description":"Extending the domain so that it starts and ends on nice round values. This method typically modifies the scale\u2019s domain, and may only extend the bounds to the nearest round value. Nicing is useful if the domain is computed from data and may be irregular. For example, for a domain of _[0.201479\u2026, 0.996679\u2026]_, a nice domain might be _[0.2, 1.0]_.\\n\\nFor quantitative scales such as linear, `nice` can be either a boolean flag or a number. If `nice` is a number, it will represent a desired tick count. This allows greater control over the step size used to extend the bounds, guaranteeing that the returned ticks will exactly cover the domain.\\n\\nFor temporal fields with time and utc scales, the `nice` value can be a string indicating the desired time interval. Legal values are `\\"millisecond\\"`, `\\"second\\"`, `\\"minute\\"`, `\\"hour\\"`, `\\"day\\"`, `\\"week\\"`, `\\"month\\"`, and `\\"year\\"`. Alternatively, `time` and `utc` scales can accept an object-valued interval specifier of the form `{\\"interval\\": \\"month\\", \\"step\\": 3}`, which includes a desired number of interval steps. Here, the domain would snap to quarter (Jan, Apr, Jul, Oct) boundaries.\\n\\n__Default value:__ `true` for unbinned _quantitative_ fields without explicit domain bounds; `false` otherwise."},"padding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For _[continuous](https://vega.github.io/vega-lite/docs/scale.html#continuous)_ scales, expands the scale domain to accommodate the specified number of pixels on each of the scale range. The scale range must represent pixels for this parameter to function as intended. Padding adjustment is performed\xa0prior\xa0to all other adjustments, including the effects of the\xa0`zero`,\xa0`nice`,\xa0`domainMin`, and\xa0`domainMax`\xa0properties.\\n\\nFor _[band](https://vega.github.io/vega-lite/docs/scale.html#band)_ scales, shortcut for setting `paddingInner` and `paddingOuter` to the same value.\\n\\nFor _[point](https://vega.github.io/vega-lite/docs/scale.html#point)_ scales, alias for `paddingOuter`.\\n\\n__Default value:__ For _continuous_ scales, derived from the [scale config](https://vega.github.io/vega-lite/docs/scale.html#config)\'s `continuousPadding`. For _band and point_ scales, see `paddingInner` and `paddingOuter`. By default, Vega-Lite sets padding such that _width/height = number of unique values * step_.","minimum":0},"paddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner padding (spacing) within each band step of band scales, as a fraction of the step size. This value must lie in the range [0,1].\\n\\nFor point scale, this property is invalid as point scales do not have internal band widths (only step sizes between bands).\\n\\n__Default value:__ derived from the [scale config](https://vega.github.io/vega-lite/docs/scale.html#config)\'s `bandPaddingInner`.","maximum":1,"minimum":0},"paddingOuter":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer padding (spacing) at the ends of the range of band and point scales, as a fraction of the step size. This value must lie in the range [0,1].\\n\\n__Default value:__ derived from the [scale config](https://vega.github.io/vega-lite/docs/scale.html#config)\'s `bandPaddingOuter` for band scales and `pointPadding` for point scales. By default, Vega-Lite sets outer padding such that _width/height = number of unique values * step_.","maximum":1,"minimum":0},"range":{"anyOf":[{"$ref":"#/definitions/RangeEnum"},{"items":{"anyOf":[{"type":"number"},{"type":"string"},{"items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"type":"array"},{"$ref":"#/definitions/FieldRange"}],"description":"The range of the scale. One of:\\n\\n- A string indicating a [pre-defined named scale range](https://vega.github.io/vega-lite/docs/scale.html#range-config) (e.g., example, `\\"symbol\\"`, or `\\"diverging\\"`).\\n\\n- For [continuous scales](https://vega.github.io/vega-lite/docs/scale.html#continuous), two-element array indicating  minimum and maximum values, or an array with more than two entries for specifying a [piecewise scale](https://vega.github.io/vega-lite/docs/scale.html#piecewise).\\n\\n- For [discrete](https://vega.github.io/vega-lite/docs/scale.html#discrete) and [discretizing](https://vega.github.io/vega-lite/docs/scale.html#discretizing) scales, an array of desired output values or an object with a `field` property representing the range values.  For example, if a field `color` contains CSS color names, we can set `range` to `{field: \\"color\\"}`.\\n\\n__Notes:__\\n\\n1) For color scales you can also specify a color [`scheme`](https://vega.github.io/vega-lite/docs/scale.html#scheme) instead of `range`.\\n\\n2) Any directly specified `range` for `x` and `y` channels will be ignored. Range can be customized via the view\'s corresponding [size](https://vega.github.io/vega-lite/docs/size.html) (`width` and `height`)."},"rangeMax":{"anyOf":[{"type":"number"},{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Sets the maximum value in the scale range, overriding the `range` property or the default range. This property is only intended for use with scales having continuous ranges."},"rangeMin":{"anyOf":[{"type":"number"},{"type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Sets the minimum value in the scale range, overriding the `range` property or the default range. This property is only intended for use with scales having continuous ranges."},"reverse":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"If true, reverses the order of the scale range. __Default value:__ `false`."},"round":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"If `true`, rounds numeric output values to integers. This can be helpful for snapping to the pixel grid.\\n\\n__Default value:__ `false`."},"scheme":{"anyOf":[{"$ref":"#/definitions/ColorScheme"},{"$ref":"#/definitions/SchemeParams"},{"$ref":"#/definitions/ExprRef"}],"description":"A string indicating a color [scheme](https://vega.github.io/vega-lite/docs/scale.html#scheme) name (e.g., `\\"category10\\"` or `\\"blues\\"`) or a [scheme parameter object](https://vega.github.io/vega-lite/docs/scale.html#scheme-params).\\n\\nDiscrete color schemes may be used with [discrete](https://vega.github.io/vega-lite/docs/scale.html#discrete) or [discretizing](https://vega.github.io/vega-lite/docs/scale.html#discretizing) scales. Continuous color schemes are intended for use with color scales.\\n\\nTo set a custom scheme, instead set the list of values [as the scale range](https://vega.github.io/vega-lite/docs/scale.html#2-setting-the-range-property-to-an-array-of-valid-css-color-strings).\\n\\nFor the full list of supported schemes, please refer to the [Vega Scheme](https://vega.github.io/vega/docs/schemes/#reference) reference."},"type":{"$ref":"#/definitions/ScaleType","description":"The type of scale. Vega-Lite supports the following categories of scale types:\\n\\n1) [**Continuous Scales**](https://vega.github.io/vega-lite/docs/scale.html#continuous) -- mapping continuous domains to continuous output ranges ([`\\"linear\\"`](https://vega.github.io/vega-lite/docs/scale.html#linear), [`\\"pow\\"`](https://vega.github.io/vega-lite/docs/scale.html#pow), [`\\"sqrt\\"`](https://vega.github.io/vega-lite/docs/scale.html#sqrt), [`\\"symlog\\"`](https://vega.github.io/vega-lite/docs/scale.html#symlog), [`\\"log\\"`](https://vega.github.io/vega-lite/docs/scale.html#log), [`\\"time\\"`](https://vega.github.io/vega-lite/docs/scale.html#time), [`\\"utc\\"`](https://vega.github.io/vega-lite/docs/scale.html#utc).\\n\\n2) [**Discrete Scales**](https://vega.github.io/vega-lite/docs/scale.html#discrete) -- mapping discrete domains to discrete ([`\\"ordinal\\"`](https://vega.github.io/vega-lite/docs/scale.html#ordinal)) or continuous ([`\\"band\\"`](https://vega.github.io/vega-lite/docs/scale.html#band) and [`\\"point\\"`](https://vega.github.io/vega-lite/docs/scale.html#point)) output ranges.\\n\\n3) [**Discretizing Scales**](https://vega.github.io/vega-lite/docs/scale.html#discretizing) -- mapping continuous domains to discrete output ranges [`\\"bin-ordinal\\"`](https://vega.github.io/vega-lite/docs/scale.html#bin-ordinal), [`\\"quantile\\"`](https://vega.github.io/vega-lite/docs/scale.html#quantile), [`\\"quantize\\"`](https://vega.github.io/vega-lite/docs/scale.html#quantize) and [`\\"threshold\\"`](https://vega.github.io/vega-lite/docs/scale.html#threshold).\\n\\n__Default value:__ please see the [scale type table](https://vega.github.io/vega-lite/docs/scale.html#type)."},"zero":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"If `true`, ensures that a zero baseline value is included in the scale domain.\\n\\n__Default value:__ `true` for x and y channels if the quantitative field is not binned and no custom `domain` is provided; `false` otherwise.\\n\\n__Note:__ Log, time, and utc scales do not support `zero`."}},"type":"object"},"ScaleBinParams":{"additionalProperties":false,"properties":{"start":{"description":"The starting (lowest-valued) bin boundary.\\n\\n__Default value:__ The lowest value of the scale domain will be used.","type":"number"},"step":{"description":"The step size defining the bin interval width.","type":"number"},"stop":{"description":"The stopping (highest-valued) bin boundary.\\n\\n__Default value:__ The highest value of the scale domain will be used.","type":"number"}},"required":["step"],"type":"object"},"ScaleBins":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ScaleBinParams"}]},"ScaleConfig":{"additionalProperties":false,"properties":{"animationDuration":{"description":"Default animation duration (in seconds) for time encodings, except for [`band`](https://vega.github.io/vega-lite/docs/scale.html#band) scales.\\n\\n__Default value:__ `5`","type":"number"},"bandPaddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default inner padding for `x` and `y` band scales.\\n\\n__Default value:__\\n- `nestedOffsetPaddingInner` for x/y scales with nested x/y offset scales.\\n- `barBandPaddingInner` for bar marks (`0.1` by default)\\n- `rectBandPaddingInner` for rect and other marks (`0` by default)","maximum":1,"minimum":0},"bandPaddingOuter":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default outer padding for `x` and `y` band scales.\\n\\n__Default value:__ `paddingInner/2` (which makes _width/height = number of unique values * step_)","maximum":1,"minimum":0},"bandWithNestedOffsetPaddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default inner padding for `x` and `y` band scales with nested `xOffset` and `yOffset` encoding.\\n\\n__Default value:__ `0.2`","maximum":1,"minimum":0},"bandWithNestedOffsetPaddingOuter":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default outer padding for `x` and `y` band scales with nested `xOffset` and `yOffset` encoding.\\n\\n__Default value:__ `0.2`","maximum":1,"minimum":0},"barBandPaddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default inner padding for `x` and `y` band-ordinal scales of `\\"bar\\"` marks.\\n\\n__Default value:__ `0.1`","maximum":1,"minimum":0},"clamp":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"If true, values that exceed the data domain are clamped to either the minimum or maximum range value"},"continuousPadding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default padding for continuous x/y scales.\\n\\n__Default:__ The bar width for continuous x-scale of a vertical bar and continuous y-scale of a horizontal bar.; `0` otherwise.","minimum":0},"framesPerSecond":{"description":"Default framerate (frames per second) for time [`band`](https://vega.github.io/vega-lite/docs/scale.html#band) scales.\\n\\n__Default value:__ `2`","type":"number"},"invalid":{"$ref":"#/definitions/ScaleInvalidDataConfig","description":"An object that defines scale outputs per channel for invalid values (nulls and NaNs on a continuous scale).\\n- The keys in this object are the scale channels.\\n- The values is either `\\"zero-or-min\\"` (use zero if the scale includes zero or min value otherwise) or a value definition `{value: ...}`.\\n\\n_Example:_ Setting this `config.scale.invalid` property to `{color: {value: \'#aaa\'}}` will make the visualization color all invalid values with \'#aaa\'.\\n\\nSee [https://vega.github.io/vega-lite/docs/invalid-data.html](Invalid Data Docs) for more details."},"maxBandSize":{"description":"The default max value for mapping quantitative fields to bar\'s size/bandSize.\\n\\nIf undefined (default), we will use the axis\'s size (width or height) - 1.","minimum":0,"type":"number"},"maxFontSize":{"description":"The default max value for mapping quantitative fields to text\'s size/fontSize scale.\\n\\n__Default value:__ `40`","minimum":0,"type":"number"},"maxOpacity":{"description":"Default max opacity for mapping a field to opacity.\\n\\n__Default value:__ `0.8`","maximum":1,"minimum":0,"type":"number"},"maxSize":{"description":"Default max value for point size scale.","minimum":0,"type":"number"},"maxStrokeWidth":{"description":"Default max strokeWidth for the scale of strokeWidth for rule and line marks and of size for trail marks.\\n\\n__Default value:__ `4`","minimum":0,"type":"number"},"minBandSize":{"description":"The default min value for mapping quantitative fields to bar and tick\'s size/bandSize scale.\\n\\n__Default value:__ `2`","minimum":0,"type":"number"},"minFontSize":{"description":"The default min value for mapping quantitative fields to text\'s size/fontSize scale.\\n\\n__Default value:__ `8`","minimum":0,"type":"number"},"minOpacity":{"description":"Default minimum opacity for mapping a field to opacity.\\n\\n__Default value:__ `0.3`","maximum":1,"minimum":0,"type":"number"},"minSize":{"description":"Default minimum value for point size scale.\\n\\n__Default value:__ `9`","minimum":0,"type":"number"},"minStrokeWidth":{"description":"Default minimum strokeWidth for the scale of strokeWidth for rule and line marks and of size for trail marks.\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},"offsetBandPaddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default padding inner for xOffset/yOffset\'s band scales.\\n\\n__Default Value:__ `0`"},"offsetBandPaddingOuter":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default padding outer for xOffset/yOffset\'s band scales.\\n\\n__Default Value:__ `0`"},"pointPadding":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default outer padding for `x` and `y` point-ordinal scales.\\n\\n__Default value:__ `0.5` (which makes _width/height = number of unique values * step_)","maximum":1,"minimum":0},"quantileCount":{"description":"Default range cardinality for [`quantile`](https://vega.github.io/vega-lite/docs/scale.html#quantile) scale.\\n\\n__Default value:__ `4`","minimum":0,"type":"number"},"quantizeCount":{"description":"Default range cardinality for [`quantize`](https://vega.github.io/vega-lite/docs/scale.html#quantize) scale.\\n\\n__Default value:__ `4`","minimum":0,"type":"number"},"rectBandPaddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default inner padding for `x` and `y` band-ordinal scales of `\\"rect\\"` marks.\\n\\n__Default value:__ `0`","maximum":1,"minimum":0},"round":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"If true, rounds numeric output values to integers. This can be helpful for snapping to the pixel grid. (Only available for `x`, `y`, and `size` scales.)"},"tickBandPaddingInner":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default inner padding for `x` and `y` band-ordinal scales of `\\"tick\\"` marks.\\n\\n__Default value:__ `0.25`","maximum":1,"minimum":0},"useUnaggregatedDomain":{"description":"Use the source data range before aggregation as scale domain instead of aggregated data for aggregate axis.\\n\\nThis is equivalent to setting `domain` to `\\"unaggregate\\"` for aggregated _quantitative_ fields by default.\\n\\nThis property only works with aggregate functions that produce values within the raw data domain (`\\"mean\\"`, `\\"average\\"`, `\\"median\\"`, `\\"q1\\"`, `\\"q3\\"`, `\\"min\\"`, `\\"max\\"`). For other aggregations that produce values outside of the raw data domain (e.g. `\\"count\\"`, `\\"sum\\"`), this property is ignored.\\n\\n__Default value:__ `false`","type":"boolean"},"xReverse":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/ExprRef"}],"description":"Reverse x-scale by default (useful for right-to-left charts)."},"zero":{"description":"Default `scale.zero` for [`continuous`](https://vega.github.io/vega-lite/docs/scale.html#continuous) scales except for (1) x/y-scales of non-ranged bar or area charts and (2) size scales.\\n\\n__Default value:__ `true`","type":"boolean"}},"type":"object"},"ScaleDatumDef":{"additionalProperties":false,"properties":{"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"ScaleFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"ScaleInterpolateEnum":{"enum":["rgb","lab","hcl","hsl","hsl-long","hcl-long","cubehelix","cubehelix-long"],"type":"string"},"ScaleInterpolateParams":{"additionalProperties":false,"properties":{"gamma":{"type":"number"},"type":{"enum":["rgb","cubehelix","cubehelix-long"],"type":"string"}},"required":["type"],"type":"object"},"ScaleInvalidDataConfig":{"additionalProperties":false,"properties":{"angle":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"angle\\">"},"color":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"color\\">"},"fill":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"fill\\">"},"fillOpacity":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"fillOpacity\\">"},"opacity":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"opacity\\">"},"radius":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"radius\\">"},"shape":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"shape\\">"},"size":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"size\\">"},"stroke":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"stroke\\">"},"strokeDash":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"strokeDash\\">"},"strokeOpacity":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"strokeOpacity\\">"},"strokeWidth":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"strokeWidth\\">"},"theta":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"theta\\">"},"time":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"time\\">"},"x":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"x\\">"},"xOffset":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"xOffset\\">"},"y":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"y\\">"},"yOffset":{"$ref":"#/definitions/ScaleInvalidDataShowAs<\\"yOffset\\">"}},"type":"object"},"ScaleInvalidDataShowAs<\\"angle\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"angle\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"color\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"color\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"fill\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"fill\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"fillOpacity\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"fillOpacity\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"opacity\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"opacity\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"radius\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"radius\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"shape\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"shape\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"size\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"size\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"stroke\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"stroke\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"strokeDash\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"strokeDash\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"strokeOpacity\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"strokeOpacity\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"strokeWidth\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"strokeWidth\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"theta\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"theta\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"time\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"time\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"x\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"x\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"xOffset\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"xOffset\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"y\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"y\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAs<\\"yOffset\\">":{"anyOf":[{"$ref":"#/definitions/ScaleInvalidDataShowAsValue<\\"yOffset\\">"},{"const":"zero-or-min","type":"string"}]},"ScaleInvalidDataShowAsValue<\\"angle\\">":{"additionalProperties":false,"properties":{"value":{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"color\\">":{"additionalProperties":false,"properties":{"value":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"fill\\">":{"additionalProperties":false,"properties":{"value":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"fillOpacity\\">":{"additionalProperties":false,"properties":{"value":{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"opacity\\">":{"additionalProperties":false,"properties":{"value":{"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"radius\\">":{"additionalProperties":false,"properties":{"value":{"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"shape\\">":{"additionalProperties":false,"properties":{"value":{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"size\\">":{"additionalProperties":false,"properties":{"value":{"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"stroke\\">":{"additionalProperties":false,"properties":{"value":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"strokeDash\\">":{"additionalProperties":false,"properties":{"value":{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"strokeOpacity\\">":{"additionalProperties":false,"properties":{"value":{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"strokeWidth\\">":{"additionalProperties":false,"properties":{"value":{"description":"The stroke width, in pixels.","minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"theta\\">":{"additionalProperties":false,"properties":{"value":{"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0,"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"time\\">":{"additionalProperties":false,"properties":{"value":{"type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"x\\">":{"additionalProperties":false,"properties":{"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"xOffset\\">":{"additionalProperties":false,"properties":{"value":{"description":"Offset for x-position.","type":"number"}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"y\\">":{"additionalProperties":false,"properties":{"value":{"anyOf":[{"type":"number"},{"const":"height","type":"string"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"ScaleInvalidDataShowAsValue<\\"yOffset\\">":{"additionalProperties":false,"properties":{"value":{"description":"Offset for y-position.","type":"number"}},"type":"object"},"ScaleResolveMap":{"additionalProperties":false,"properties":{"angle":{"$ref":"#/definitions/ResolveMode"},"color":{"$ref":"#/definitions/ResolveMode"},"fill":{"$ref":"#/definitions/ResolveMode"},"fillOpacity":{"$ref":"#/definitions/ResolveMode"},"opacity":{"$ref":"#/definitions/ResolveMode"},"radius":{"$ref":"#/definitions/ResolveMode"},"shape":{"$ref":"#/definitions/ResolveMode"},"size":{"$ref":"#/definitions/ResolveMode"},"stroke":{"$ref":"#/definitions/ResolveMode"},"strokeDash":{"$ref":"#/definitions/ResolveMode"},"strokeOpacity":{"$ref":"#/definitions/ResolveMode"},"strokeWidth":{"$ref":"#/definitions/ResolveMode"},"theta":{"$ref":"#/definitions/ResolveMode"},"time":{"$ref":"#/definitions/ResolveMode"},"x":{"$ref":"#/definitions/ResolveMode"},"xOffset":{"$ref":"#/definitions/ResolveMode"},"y":{"$ref":"#/definitions/ResolveMode"},"yOffset":{"$ref":"#/definitions/ResolveMode"}},"type":"object"},"ScaleType":{"enum":["linear","log","pow","sqrt","symlog","identity","sequential","time","utc","quantile","quantize","threshold","bin-ordinal","ordinal","point","band"],"type":"string"},"SchemeParams":{"additionalProperties":false,"properties":{"count":{"description":"The number of colors to use in the scheme. This can be useful for scale types such as `\\"quantize\\"`, which use the length of the scale range to determine the number of discrete bins for the scale domain.","type":"number"},"extent":{"description":"The extent of the color range to use. For example `[0.2, 1]` will rescale the color scheme such that color values in the range _[0, 0.2)_ are excluded from the scheme.","items":{"type":"number"},"type":"array"},"name":{"$ref":"#/definitions/ColorScheme","description":"A color scheme name for ordinal scales (e.g., `\\"category10\\"` or `\\"blues\\"`).\\n\\nFor the full list of supported schemes, please refer to the [Vega Scheme](https://vega.github.io/vega/docs/schemes/#reference) reference."}},"required":["name"],"type":"object"},"SecondaryFieldDef":{"additionalProperties":false,"description":"A field definition of a secondary channel that shares a scale with another primary channel. For example, `x2`, `xError` and `xError2` share the same scale with `x`.","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."}},"type":"object"},"SelectionConfig":{"additionalProperties":false,"properties":{"interval":{"$ref":"#/definitions/IntervalSelectionConfigWithoutType","description":"The default definition for an [`interval`](https://vega.github.io/vega-lite/docs/parameter.html#select) selection. All properties and transformations for an interval selection definition (except `type`) may be specified here.\\n\\nFor instance, setting `interval` to `{\\"translate\\": false}` disables the ability to move interval selections by default."},"point":{"$ref":"#/definitions/PointSelectionConfigWithoutType","description":"The default definition for a [`point`](https://vega.github.io/vega-lite/docs/parameter.html#select) selection. All properties and transformations  for a point selection definition (except `type`) may be specified here.\\n\\nFor instance, setting `point` to `{\\"on\\": \\"dblclick\\"}` populates point selections on double-click by default."}},"type":"object"},"SelectionInit":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"}]},"SelectionInitInterval":{"anyOf":[{"$ref":"#/definitions/Vector2<boolean>"},{"$ref":"#/definitions/Vector2<number>"},{"$ref":"#/definitions/Vector2<string>"},{"$ref":"#/definitions/Vector2<DateTime>"}]},"SelectionInitIntervalMapping":{"$ref":"#/definitions/Dict<SelectionInitInterval>"},"SelectionInitMapping":{"$ref":"#/definitions/Dict<SelectionInit>"},"SelectionParameter":{"additionalProperties":false,"properties":{"bind":{"anyOf":[{"$ref":"#/definitions/Binding"},{"additionalProperties":{"$ref":"#/definitions/Binding"},"type":"object"},{"$ref":"#/definitions/LegendBinding"},{"const":"scales","type":"string"}],"description":"When set, a selection is populated by input elements (also known as dynamic query widgets) or by interacting with the corresponding legend. Direct manipulation interaction is disabled by default; to re-enable it, set the selection\'s [`on`](https://vega.github.io/vega-lite/docs/selection.html#common-selection-properties) property.\\n\\nLegend bindings are restricted to selections that only specify a single field or encoding.\\n\\nQuery widget binding takes the form of Vega\'s [input element binding definition](https://vega.github.io/vega/docs/signals/#bind) or can be a mapping between projected field/encodings and binding definitions.\\n\\n__See also:__ [`bind`](https://vega.github.io/vega-lite/docs/bind.html) documentation."},"name":{"$ref":"#/definitions/ParameterName","description":"Required. A unique name for the selection parameter. Selection names should be valid JavaScript identifiers: they should contain only alphanumeric characters (or \\"$\\", or \\"_\\") and may not start with a digit. Reserved keywords that may not be used as parameter names are \\"datum\\", \\"event\\", \\"item\\", and \\"parent\\"."},"select":{"anyOf":[{"$ref":"#/definitions/SelectionType"},{"$ref":"#/definitions/PointSelectionConfig"},{"$ref":"#/definitions/IntervalSelectionConfig"}],"description":"Determines the default event processing and data query for the selection. Vega-Lite currently supports two selection types:\\n\\n- `\\"point\\"` -- to select multiple discrete data values; the first value is selected on `click` and additional values toggled on shift-click.\\n- `\\"interval\\"` -- to select a continuous range of data values on `drag`."},"value":{"anyOf":[{"$ref":"#/definitions/SelectionInit"},{"items":{"$ref":"#/definitions/SelectionInitMapping"},"type":"array"},{"$ref":"#/definitions/SelectionInitIntervalMapping"}],"description":"Initialize the selection with a mapping between [projected channels or field names](https://vega.github.io/vega-lite/docs/selection.html#project) and initial values.\\n\\n__See also:__ [`init`](https://vega.github.io/vega-lite/docs/value.html) documentation."}},"required":["name","select"],"type":"object"},"SelectionResolution":{"enum":["global","union","intersect"],"type":"string"},"SelectionType":{"enum":["point","interval"],"type":"string"},"SequenceGenerator":{"additionalProperties":false,"properties":{"name":{"description":"Provide a placeholder name and bind data at runtime.","type":"string"},"sequence":{"$ref":"#/definitions/SequenceParams","description":"Generate a sequence of numbers."}},"required":["sequence"],"type":"object"},"SequenceParams":{"additionalProperties":false,"properties":{"as":{"$ref":"#/definitions/FieldName","description":"The name of the generated sequence field.\\n\\n__Default value:__ `\\"data\\"`"},"start":{"description":"The starting value of the sequence (inclusive).","type":"number"},"step":{"description":"The step value between sequence entries.\\n\\n__Default value:__ `1`","type":"number"},"stop":{"description":"The ending value of the sequence (exclusive).","type":"number"}},"required":["start","stop"],"type":"object"},"SequentialMultiHue":{"enum":["turbo","viridis","inferno","magma","plasma","cividis","bluegreen","bluegreen-3","bluegreen-4","bluegreen-5","bluegreen-6","bluegreen-7","bluegreen-8","bluegreen-9","bluepurple","bluepurple-3","bluepurple-4","bluepurple-5","bluepurple-6","bluepurple-7","bluepurple-8","bluepurple-9","goldgreen","goldgreen-3","goldgreen-4","goldgreen-5","goldgreen-6","goldgreen-7","goldgreen-8","goldgreen-9","goldorange","goldorange-3","goldorange-4","goldorange-5","goldorange-6","goldorange-7","goldorange-8","goldorange-9","goldred","goldred-3","goldred-4","goldred-5","goldred-6","goldred-7","goldred-8","goldred-9","greenblue","greenblue-3","greenblue-4","greenblue-5","greenblue-6","greenblue-7","greenblue-8","greenblue-9","orangered","orangered-3","orangered-4","orangered-5","orangered-6","orangered-7","orangered-8","orangered-9","purplebluegreen","purplebluegreen-3","purplebluegreen-4","purplebluegreen-5","purplebluegreen-6","purplebluegreen-7","purplebluegreen-8","purplebluegreen-9","purpleblue","purpleblue-3","purpleblue-4","purpleblue-5","purpleblue-6","purpleblue-7","purpleblue-8","purpleblue-9","purplered","purplered-3","purplered-4","purplered-5","purplered-6","purplered-7","purplered-8","purplered-9","redpurple","redpurple-3","redpurple-4","redpurple-5","redpurple-6","redpurple-7","redpurple-8","redpurple-9","yellowgreenblue","yellowgreenblue-3","yellowgreenblue-4","yellowgreenblue-5","yellowgreenblue-6","yellowgreenblue-7","yellowgreenblue-8","yellowgreenblue-9","yellowgreen","yellowgreen-3","yellowgreen-4","yellowgreen-5","yellowgreen-6","yellowgreen-7","yellowgreen-8","yellowgreen-9","yelloworangebrown","yelloworangebrown-3","yelloworangebrown-4","yelloworangebrown-5","yelloworangebrown-6","yelloworangebrown-7","yelloworangebrown-8","yelloworangebrown-9","yelloworangered","yelloworangered-3","yelloworangered-4","yelloworangered-5","yelloworangered-6","yelloworangered-7","yelloworangered-8","yelloworangered-9","darkblue","darkblue-3","darkblue-4","darkblue-5","darkblue-6","darkblue-7","darkblue-8","darkblue-9","darkgold","darkgold-3","darkgold-4","darkgold-5","darkgold-6","darkgold-7","darkgold-8","darkgold-9","darkgreen","darkgreen-3","darkgreen-4","darkgreen-5","darkgreen-6","darkgreen-7","darkgreen-8","darkgreen-9","darkmulti","darkmulti-3","darkmulti-4","darkmulti-5","darkmulti-6","darkmulti-7","darkmulti-8","darkmulti-9","darkred","darkred-3","darkred-4","darkred-5","darkred-6","darkred-7","darkred-8","darkred-9","lightgreyred","lightgreyred-3","lightgreyred-4","lightgreyred-5","lightgreyred-6","lightgreyred-7","lightgreyred-8","lightgreyred-9","lightgreyteal","lightgreyteal-3","lightgreyteal-4","lightgreyteal-5","lightgreyteal-6","lightgreyteal-7","lightgreyteal-8","lightgreyteal-9","lightmulti","lightmulti-3","lightmulti-4","lightmulti-5","lightmulti-6","lightmulti-7","lightmulti-8","lightmulti-9","lightorange","lightorange-3","lightorange-4","lightorange-5","lightorange-6","lightorange-7","lightorange-8","lightorange-9","lighttealblue","lighttealblue-3","lighttealblue-4","lighttealblue-5","lighttealblue-6","lighttealblue-7","lighttealblue-8","lighttealblue-9"],"type":"string"},"SequentialSingleHue":{"enum":["blues","tealblues","teals","greens","browns","greys","purples","warmgreys","reds","oranges"],"type":"string"},"ShapeDef":{"$ref":"#/definitions/MarkPropDef<(string|null),TypeForShape>"},"SharedEncoding":{"additionalProperties":false,"properties":{"angle":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"color":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"$ref":"#/definitions/Gradient"},{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"description":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"detail":{"anyOf":[{"$ref":"#/definitions/FieldDefWithoutScale"},{"items":{"$ref":"#/definitions/FieldDefWithoutScale"},"type":"array"}],"description":"Additional levels of detail for grouping data in aggregate views and in line, trail, and area marks without mapping data to a specific visual channel."},"fill":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"$ref":"#/definitions/Gradient"},{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"fillOpacity":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"href":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"key":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"latitude":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"const":"quantitative","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation.","type":"string"},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"latitude2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"longitude":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"const":"quantitative","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation.","type":"string"},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"longitude2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"opacity":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"order":{"anyOf":[{"$ref":"#/definitions/OrderFieldDef"},{"items":{"$ref":"#/definitions/OrderFieldDef"},"type":"array"},{"$ref":"#/definitions/OrderValueDef"},{"$ref":"#/definitions/OrderOnlyDef"}],"description":"Order of the marks.\\n- For stacked marks, this `order` channel encodes [stack order](https://vega.github.io/vega-lite/docs/stack.html#order).\\n- For line and trail marks, this `order` channel encodes order of data points in the lines. This can be useful for creating [a connected scatterplot](https://vega.github.io/vega-lite/examples/connected_scatterplot.html). Setting `order` to `{\\"value\\": null}` makes the line marks use the original order in the data sources.\\n- Otherwise, this `order` channel encodes layer order of the marks.\\n\\n__Note__: In aggregate plots, `order` field should be `aggregate`d to avoid creating additional aggregation grouping."},"radius":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"radius2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"shape":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef<TypeForShape>"},{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/TypeForShape","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"size":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"stroke":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"$ref":"#/definitions/Gradient"},{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"strokeDash":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"strokeOpacity":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"strokeWidth":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"legend":{"anyOf":[{"$ref":"#/definitions/Legend"},{"type":"null"}],"description":"An object defining properties of the legend. If `null`, the legend for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [legend properties](https://vega.github.io/vega-lite/docs/legend.html) are applied.\\n\\n__See also:__ [`legend`](https://vega.github.io/vega-lite/docs/legend.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"text":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalStringFieldDef"},{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"theta":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"theta2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"time":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"rescale":{"type":"boolean"},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"tooltip":{"anyOf":[{"$ref":"#/definitions/StringFieldDefWithCondition"},{"$ref":"#/definitions/StringValueDefWithCondition"},{"items":{"$ref":"#/definitions/StringFieldDef"},"type":"array"},{"type":"null"}],"description":"The tooltip text to show upon mouse hover. Specifying `tooltip` encoding overrides [the `tooltip` property in the mark definition](https://vega.github.io/vega-lite/docs/mark.html#mark-def).\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip in Vega-Lite."},"url":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"condition":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|ExprRef)>"},"type":"array"}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."}],"description":"One or more value definition(s) with [a parameter or a test predicate](https://vega.github.io/vega-lite/docs/condition.html).\\n\\n__Note:__ A field definition\'s `condition` property can only contain [conditional value definitions](https://vega.github.io/vega-lite/docs/condition.html#value) since Vega-Lite only allows at most one encoded field per encoding channel."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"x":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"axis":{"anyOf":[{"$ref":"#/definitions/Axis"},{"type":"null"}],"description":"An object defining properties of axis\'s gridlines, ticks and labels. If `null`, the axis for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [axis properties](https://vega.github.io/vega-lite/docs/axis.html) are applied.\\n\\n__See also:__ [`axis`](https://vega.github.io/vega-lite/docs/axis.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"impute":{"anyOf":[{"$ref":"#/definitions/ImputeParams"},{"type":"null"}],"description":"An object defining the properties of the Impute Operation to be applied. The field value of the other positional channel is taken as `key` of the `Impute` Operation. The field of the `color` channel if specified is used as `groupby` of the `Impute` Operation.\\n\\n__See also:__ [`impute`](https://vega.github.io/vega-lite/docs/impute.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"x2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"xError":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"type":"object"},"xError2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"type":"object"},"xOffset":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"type":"object"},"y":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"axis":{"anyOf":[{"$ref":"#/definitions/Axis"},{"type":"null"}],"description":"An object defining properties of axis\'s gridlines, ticks and labels. If `null`, the axis for the encoding channel will be removed.\\n\\n__Default value:__ If undefined, default [axis properties](https://vega.github.io/vega-lite/docs/axis.html) are applied.\\n\\n__See also:__ [`axis`](https://vega.github.io/vega-lite/docs/axis.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"impute":{"anyOf":[{"$ref":"#/definitions/ImputeParams"},{"type":"null"}],"description":"An object defining the properties of the Impute Operation to be applied. The field value of the other positional channel is taken as `key` of the `Impute` Operation. The field of the `color` channel if specified is used as `groupby` of the `Impute` Operation.\\n\\n__See also:__ [`impute`](https://vega.github.io/vega-lite/docs/impute.html) documentation."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"stack":{"anyOf":[{"$ref":"#/definitions/StackOffset"},{"type":"null"},{"type":"boolean"}],"description":"Type of stacking offset if the field should be stacked. `stack` is only applicable for `x`, `y`, `theta`, and `radius` channels with continuous domains. For example, `stack` of `y` can be used to customize stacking for a vertical bar chart.\\n\\n`stack` can be one of the following values:\\n- `\\"zero\\"` or `true`: stacking with baseline offset at zero value of the scale (for creating typical stacked [bar](https://vega.github.io/vega-lite/docs/stack.html#bar) and [area](https://vega.github.io/vega-lite/docs/stack.html#area) chart).\\n- `\\"normalize\\"` - stacking with normalized domain (for creating [normalized stacked bar and area charts](https://vega.github.io/vega-lite/docs/stack.html#normalized) and pie charts [with percentage tooltip](https://vega.github.io/vega-lite/docs/arc.html#tooltip)). <br/>\\n-`\\"center\\"` - stacking with center baseline (for [streamgraph](https://vega.github.io/vega-lite/docs/stack.html#streamgraph)).\\n- `null` or `false` - No-stacking. This will produce layered [bar](https://vega.github.io/vega-lite/docs/stack.html#layered-bar-chart) and area chart.\\n\\n__Default value:__ `zero` for plots with all of the following conditions are true: (1) the mark is `bar`, `area`, or `arc`; (2) the stacked measure channel (x or y) has a linear scale; (3) At least one of non-position channels mapped to an unaggregated field that is different from x and y. Otherwise, `null` by default.\\n\\n__See also:__ [`stack`](https://vega.github.io/vega-lite/docs/stack.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"y2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"yError":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"type":"object"},"yError2":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation.","type":"null"},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"type":"object"},"yOffset":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"datum":{"anyOf":[{"$ref":"#/definitions/PrimitiveValue"},{"$ref":"#/definitions/DateTime"},{"$ref":"#/definitions/ExprRef"},{"$ref":"#/definitions/RepeatRef"}],"description":"A constant value in data domain."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"anyOf":[{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},{"$ref":"#/definitions/Type","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}],"description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."},"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"type":"object"}},"type":"object"},"SingleDefUnitChannel":{"enum":["text","shape","x","y","xOffset","yOffset","x2","y2","longitude","latitude","longitude2","latitude2","theta","theta2","radius","radius2","time","color","fill","stroke","opacity","fillOpacity","strokeOpacity","strokeWidth","strokeDash","size","angle","key","href","url","description"],"type":"string"},"SingleTimeUnit":{"anyOf":[{"$ref":"#/definitions/LocalSingleTimeUnit"},{"$ref":"#/definitions/UtcSingleTimeUnit"}]},"Sort":{"anyOf":[{"$ref":"#/definitions/SortArray"},{"$ref":"#/definitions/AllSortString"},{"$ref":"#/definitions/EncodingSortField"},{"$ref":"#/definitions/SortByEncoding"},{"type":"null"}]},"SortArray":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"items":{"type":"string"},"type":"array"},{"items":{"type":"boolean"},"type":"array"},{"items":{"$ref":"#/definitions/DateTime"},"type":"array"}]},"SortByChannel":{"enum":["x","y","color","fill","stroke","strokeWidth","size","shape","fillOpacity","strokeOpacity","opacity","text"],"type":"string"},"SortByChannelDesc":{"enum":["-x","-y","-color","-fill","-stroke","-strokeWidth","-size","-shape","-fillOpacity","-strokeOpacity","-opacity","-text"],"type":"string"},"SortByEncoding":{"additionalProperties":false,"properties":{"encoding":{"$ref":"#/definitions/SortByChannel","description":"The [encoding channel](https://vega.github.io/vega-lite/docs/encoding.html#channels) to sort by (e.g., `\\"x\\"`, `\\"y\\"`)"},"order":{"anyOf":[{"$ref":"#/definitions/SortOrder"},{"type":"null"}],"description":"The sort order. One of `\\"ascending\\"` (default), `\\"descending\\"`, or `null` (do not sort)."}},"required":["encoding"],"type":"object"},"SortField":{"additionalProperties":false,"description":"A sort definition for transform","properties":{"field":{"$ref":"#/definitions/FieldName","description":"The name of the field to sort."},"order":{"anyOf":[{"$ref":"#/definitions/SortOrder"},{"type":"null"}],"description":"Whether to sort the field in ascending or descending order. One of `\\"ascending\\"` (default), `\\"descending\\"`, or `null` (do not sort)."}},"required":["field"],"type":"object"},"SortOrder":{"enum":["ascending","descending"],"type":"string"},"SphereGenerator":{"additionalProperties":false,"properties":{"name":{"description":"Provide a placeholder name and bind data at runtime.","type":"string"},"sphere":{"anyOf":[{"const":true,"type":"boolean"},{"type":"object"}],"description":"Generate sphere GeoJSON data for the full globe."}},"required":["sphere"],"type":"object"},"StackOffset":{"enum":["zero","center","normalize"],"type":"string"},"StackTransform":{"additionalProperties":false,"properties":{"as":{"anyOf":[{"$ref":"#/definitions/FieldName"},{"items":{"$ref":"#/definitions/FieldName"},"maxItems":2,"minItems":2,"type":"array"}],"description":"Output field names. This can be either a string or an array of strings with two elements denoting the name for the fields for stack start and stack end respectively. If a single string(e.g., `\\"val\\"`) is provided, the end field will be `\\"val_end\\"`."},"groupby":{"description":"The data fields to group by.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"offset":{"description":"Mode for stacking marks. One of `\\"zero\\"` (default), `\\"center\\"`, or `\\"normalize\\"`. The `\\"zero\\"` offset will stack starting at `0`. The `\\"center\\"` offset will center the stacks. The `\\"normalize\\"` offset will compute percentage values for each stack point, with output values in the range `[0,1]`.\\n\\n__Default value:__ `\\"zero\\"`","enum":["zero","center","normalize"],"type":"string"},"sort":{"description":"Field that determines the order of leaves in the stacked charts.","items":{"$ref":"#/definitions/SortField"},"type":"array"},"stack":{"$ref":"#/definitions/FieldName","description":"The field which is stacked."}},"required":["stack","groupby","as"],"type":"object"},"StandardType":{"enum":["quantitative","ordinal","temporal","nominal"],"type":"string"},"Step":{"additionalProperties":false,"properties":{"for":{"$ref":"#/definitions/StepFor","description":"Whether to apply the step to position scale or offset scale when there are both `x` and `xOffset` or both `y` and `yOffset` encodings."},"step":{"description":"The size (width/height) per discrete step.","type":"number"}},"required":["step"],"type":"object"},"StepFor":{"enum":["position","offset"],"type":"string"},"Stream":{"anyOf":[{"$ref":"#/definitions/EventStream"},{"$ref":"#/definitions/DerivedStream"},{"$ref":"#/definitions/MergedStream"}]},"StringFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"format":{"$ref":"#/definitions/Format","description":"The text format specifier for formatting number and date/time in labels of guides (axes, legends, headers) and text marks.\\n\\nIf the format type is `\\"number\\"` (e.g., for quantitative fields), this is a D3\'s [number format pattern string](https://github.com/d3/d3-format#locale_format).\\n\\nIf the format type is `\\"time\\"` (e.g., for temporal fields), this is either:   a) D3\'s [time format pattern](https://d3js.org/d3-time-format#locale_format) if you desire to set a static time format.\\n\\n  b) [dynamic time format specifier object](https://vega.github.io/vega-lite/docs/format.html#dynamic-time-format) if you desire to set a dynamic time format that uses different formats depending on the granularity of the input date (e.g., if the date lies on a year, month, date, hour, etc. boundary).\\n\\nWhen used with a [custom `formatType`](https://vega.github.io/vega-lite/docs/config.html#custom-format-type), this value will be passed as `format` alongside `datum.value` to the registered function.\\n\\n__Default value:__  Derived from [numberFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for number format and from [timeFormat](https://vega.github.io/vega-lite/docs/config.html#format) config for time format."},"formatType":{"description":"The format type for labels. One of `\\"number\\"`, `\\"time\\"`, or a [registered custom format type](https://vega.github.io/vega-lite/docs/config.html#custom-format-type).\\n\\n__Default value:__\\n- `\\"time\\"` for temporal fields and ordinal and nominal fields with `timeUnit`.\\n- `\\"number\\"` for quantitative fields as well as ordinal and nominal fields without `timeUnit`.","type":"string"},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"StringFieldDefWithCondition":{"$ref":"#/definitions/FieldOrDatumDefWithCondition<StringFieldDef,string>"},"StringValueDefWithCondition":{"$ref":"#/definitions/ValueDefWithCondition<MarkPropFieldOrDatumDef,(string|null)>"},"StrokeCap":{"enum":["butt","round","square"],"type":"string"},"StrokeJoin":{"enum":["miter","round","bevel"],"type":"string"},"StyleConfigIndex":{"additionalProperties":{"anyOf":[{"$ref":"#/definitions/AnyMarkConfig"},{"$ref":"#/definitions/Axis"}]},"properties":{"arc":{"$ref":"#/definitions/RectConfig","description":"Arc-specific Config"},"area":{"$ref":"#/definitions/AreaConfig","description":"Area-Specific Config"},"bar":{"$ref":"#/definitions/BarConfig","description":"Bar-Specific Config"},"circle":{"$ref":"#/definitions/MarkConfig","description":"Circle-Specific Config"},"geoshape":{"$ref":"#/definitions/MarkConfig","description":"Geoshape-Specific Config"},"group-subtitle":{"$ref":"#/definitions/MarkConfig","description":"Default style for chart subtitles"},"group-title":{"$ref":"#/definitions/MarkConfig","description":"Default style for chart titles"},"guide-label":{"$ref":"#/definitions/MarkConfig","description":"Default style for axis, legend, and header labels."},"guide-title":{"$ref":"#/definitions/MarkConfig","description":"Default style for axis, legend, and header titles."},"image":{"$ref":"#/definitions/RectConfig","description":"Image-specific Config"},"line":{"$ref":"#/definitions/LineConfig","description":"Line-Specific Config"},"mark":{"$ref":"#/definitions/MarkConfig","description":"Mark Config"},"point":{"$ref":"#/definitions/MarkConfig","description":"Point-Specific Config"},"rect":{"$ref":"#/definitions/RectConfig","description":"Rect-Specific Config"},"rule":{"$ref":"#/definitions/MarkConfig","description":"Rule-Specific Config"},"square":{"$ref":"#/definitions/MarkConfig","description":"Square-Specific Config"},"text":{"$ref":"#/definitions/MarkConfig","description":"Text-Specific Config"},"tick":{"$ref":"#/definitions/TickConfig","description":"Tick-Specific Config"},"trail":{"$ref":"#/definitions/LineConfig","description":"Trail-Specific Config"}},"type":"object"},"SymbolShape":{"type":"string"},"Text":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}]},"TextBaseline":{"anyOf":[{"const":"alphabetic","type":"string"},{"$ref":"#/definitions/Baseline"},{"const":"line-top","type":"string"},{"const":"line-bottom","type":"string"}]},"TextDef":{"anyOf":[{"$ref":"#/definitions/FieldOrDatumDefWithCondition<StringFieldDef,Text>"},{"$ref":"#/definitions/FieldOrDatumDefWithCondition<StringDatumDef,Text>"},{"$ref":"#/definitions/ValueDefWithCondition<StringFieldDef,Text>"}]},"TextDirection":{"enum":["ltr","rtl"],"type":"string"},"TickConfig":{"additionalProperties":false,"properties":{"align":{"anyOf":[{"$ref":"#/definitions/Align"},{"$ref":"#/definitions/ExprRef"}],"description":"The horizontal alignment of the text or ranged marks (area, bar, image, rect, rule). One of `\\"left\\"`, `\\"right\\"`, `\\"center\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"angle":{"anyOf":[{"description":"The rotation angle of the text, in degrees.","maximum":360,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG element, removing the mark item from the ARIA accessibility tree.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"ariaRole":{"anyOf":[{"description":"Sets the type of user interface element of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"role\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"ariaRoleDescription":{"anyOf":[{"description":"A human-readable, author-localized description for the role of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the \\"aria-roledescription\\" attribute. Warning: this property is experimental and may be changed in the future.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"aspect":{"anyOf":[{"description":"Whether to keep aspect ratio of image marks.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"bandSize":{"description":"The width of the ticks.\\n\\n__Default value:__  3/4 of step (width step for horizontal ticks and height step for vertical ticks).","minimum":0,"type":"number"},"baseline":{"anyOf":[{"$ref":"#/definitions/TextBaseline"},{"$ref":"#/definitions/ExprRef"}],"description":"For text marks, the vertical text baseline. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, `\\"line-bottom\\"`, or an expression reference that provides one of the valid values. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the `lineHeight` rather than `fontSize` alone.\\n\\nFor range marks, the vertical alignment of the marks. One of `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`.\\n\\n__Note:__ Expression reference is *not* supported for range marks."},"binSpacing":{"description":"Offset between bars for binned field. The ideal value for this is either 0 (preferred by statisticians) or 1 (Vega-Lite default, D3 example style).\\n\\n__Default value:__ `1`","minimum":0,"type":"number"},"blend":{"anyOf":[{"$ref":"#/definitions/Blend","description":"The color blend mode for drawing an item on its current background. Any valid [CSS mix-blend-mode](https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode) value can be used.\\n\\n__Default value: `\\"source-over\\"`"},{"$ref":"#/definitions/ExprRef"}]},"color":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"$ref":"#/definitions/ExprRef"}],"description":"Default color.\\n\\n__Default value:__ <span style=\\"color: #4682b4;\\">&#9632;</span> `\\"#4682b4\\"`\\n\\n__Note:__\\n- This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).\\n- The `fill` and `stroke` properties have higher precedence than `color` and will override `color`."},"continuousBandSize":{"description":"The default size of the bars on continuous scales.\\n\\n__Default value:__ `5`","minimum":0,"type":"number"},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusBottomRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' bottom right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopLeft":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top right corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cornerRadiusTopRight":{"anyOf":[{"description":"The radius in pixels of rounded rectangles\' top left corner.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"anyOf":[{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the mark. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},{"$ref":"#/definitions/ExprRef"}]},"description":{"anyOf":[{"description":"A text description of the mark item for [ARIA accessibility](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) (SVG output only). If specified, this property determines the [\\"aria-label\\" attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"dir":{"anyOf":[{"$ref":"#/definitions/TextDirection","description":"The direction of the text. One of `\\"ltr\\"` (left-to-right) or `\\"rtl\\"` (right-to-left). This property determines on which side is truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"ltr\\"`"},{"$ref":"#/definitions/ExprRef"}]},"discreteBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RelativeBandSize"}],"description":"The default size of the bars with discrete dimensions. If unspecified, the default size is  `step-2`, which provides 2 pixel offset between bars.","minimum":0},"dx":{"anyOf":[{"description":"The horizontal offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"The vertical offset, in pixels, between the text label and its anchor point. The offset is applied after rotation by the _angle_ property.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"ellipsis":{"anyOf":[{"description":"The ellipsis string for text truncated in response to the limit parameter.\\n\\n__Default value:__ `\\"\u2026\\"`","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"endAngle":{"anyOf":[{"description":"The end angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default fill color. This property has higher precedence than `config.color`. Set to `null` to remove fill.\\n\\n__Default value:__ (None)"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"filled":{"description":"Whether the mark\'s color should be used as fill color instead of stroke color.\\n\\n__Default value:__ `false` for all `point`, `line`, and `rule` marks as well as `geoshape` marks for [`graticule`](https://vega.github.io/vega-lite/docs/data.html#graticule) data sources; otherwise, `true`.\\n\\n__Note:__ This property cannot be used in a [style config](https://vega.github.io/vega-lite/docs/mark.html#style-config).","type":"boolean"},"font":{"anyOf":[{"description":"The typeface to set the text in (e.g., `\\"Helvetica Neue\\"`).","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"The font size, in pixels.\\n\\n__Default value:__ `11`","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"The font style (e.g., `\\"italic\\"`)."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"The font weight. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"height":{"anyOf":[{"description":"Height of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"href":{"anyOf":[{"$ref":"#/definitions/URI","description":"A URL to load upon mouse click. If defined, the mark acts as a hyperlink."},{"$ref":"#/definitions/ExprRef"}]},"innerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The inner radius in pixels of arc marks. `innerRadius` is an alias for `radius2`.\\n\\n__Default value:__ `0`","minimum":0},"interpolate":{"anyOf":[{"$ref":"#/definitions/Interpolate","description":"The line interpolation method to use for line and area marks. One of the following:\\n- `\\"linear\\"`: piecewise linear segments, as in a polyline.\\n- `\\"linear-closed\\"`: close the linear segments to form a polygon.\\n- `\\"step\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"step-before\\"`: alternate between vertical and horizontal segments, as in a step function.\\n- `\\"step-after\\"`: alternate between horizontal and vertical segments, as in a step function.\\n- `\\"basis\\"`: a B-spline, with control point duplication on the ends.\\n- `\\"basis-open\\"`: an open B-spline; may not intersect the start or end.\\n- `\\"basis-closed\\"`: a closed B-spline, as in a loop.\\n- `\\"cardinal\\"`: a Cardinal spline, with control point duplication on the ends.\\n- `\\"cardinal-open\\"`: an open Cardinal spline; may not intersect the start or end, but will intersect other control points.\\n- `\\"cardinal-closed\\"`: a closed Cardinal spline, as in a loop.\\n- `\\"bundle\\"`: equivalent to basis, except the tension parameter is used to straighten the spline.\\n- `\\"monotone\\"`: cubic interpolation that preserves monotonicity in y."},{"$ref":"#/definitions/ExprRef"}]},"invalid":{"anyOf":[{"$ref":"#/definitions/MarkInvalidDataMode"},{"type":"null"}],"description":"Invalid data mode, which defines how the marks and corresponding scales should represent invalid values (`null` and `NaN` in continuous scales *without* defined output for invalid values).\\n\\n- `\\"filter\\"` \u2014 *Exclude* all invalid values from the visualization\'s *marks* and *scales*. For path marks (for line, area, trail), this option will create paths that connect valid points, as if the data rows with invalid values do not exist.\\n\\n- `\\"break-paths-filter-domains\\"` \u2014 Break path marks (for line, area, trail) at invalid values.  For non-path marks, this is equivalent to `\\"filter\\"`. All *scale* domains will *exclude* these filtered data points.\\n\\n- `\\"break-paths-show-domains\\"` \u2014 Break paths (for line, area, trail) at invalid values.  Hide invalid values for non-path marks. All *scale* domains will *include* these filtered data points (for both path and non-path marks).\\n\\n- `\\"show\\"` or `null` \u2014 Show all data points in the marks and scale domains. Each scale will use the output for invalid values defined in `config.scale.invalid` or, if unspecified, by default invalid values will produce the same visual values as zero (if the scale includes zero) or the minimum value (if the scale does not include zero).\\n\\n- `\\"break-paths-show-path-domains\\"` (default) \u2014 This is equivalent to `\\"break-paths-show-domains\\"` for path-based marks (line/area/trail) and `\\"filter\\"` for non-path marks.\\n\\n__Note__: If any channel\'s scale has an output for invalid values defined in `config.scale.invalid`, all values for the scales will be considered \\"valid\\" since they can produce a reasonable output for the scales. Thus, fields for such channels will not be filtered and will not cause path breaks."},"limit":{"anyOf":[{"description":"The maximum length of the text mark in pixels. The text value will be automatically truncated if the rendered size exceeds the limit.\\n\\n__Default value:__ `0` -- indicating no limit","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineBreak":{"anyOf":[{"description":"A delimiter, such as a newline character, upon which to break text strings into multiple lines. This property is ignored if the text is array-valued.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"The line height in pixels (the spacing between subsequent lines of text) for multi-line text marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"minBandSize":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The minimum band size for bar and rectangle marks. __Default value:__ `0.25`"},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"order":{"description":"For line and trail marks, this `order` property can be set to `null` or `false` to make the lines use the original order in the data sources.","type":["null","boolean"]},"orient":{"$ref":"#/definitions/Orientation","description":"The orientation of a non-stacked bar, tick, area, and line charts. The value is either horizontal (default) or vertical.\\n- For bar, rule and tick, this determines whether the size of the bar and tick should be applied to x or y dimension.\\n- For area, this property determines the orient property of the Vega output.\\n- For line and trail marks, this property determines the sort order of the points in the line if `config.sortLineBy` is not specified. For stacked charts, this is always determined by the orientation of the stack; therefore explicitly specified value will be ignored."},"outerRadius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The outer radius in pixels of arc marks. `outerRadius` is an alias for `radius`.\\n\\n__Default value:__ `0`","minimum":0},"padAngle":{"anyOf":[{"description":"The angular padding applied to sides of the arc, in radians.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"radius":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"For arc mark, the primary (outer) radius in pixels.\\n\\nFor text marks, polar coordinate radial offset, in pixels, of the text from the origin determined by the `x` and `y` properties.\\n\\n__Default value:__ `min(plot_width, plot_height)/2`","minimum":0},"radius2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The secondary (inner) radius in pixels of arc marks.\\n\\n__Default value:__ `0`","minimum":0},"shape":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/SymbolShape"},{"type":"string"}],"description":"Shape of the point marks. Supported values include:\\n- plotting shapes: `\\"circle\\"`, `\\"square\\"`, `\\"cross\\"`, `\\"diamond\\"`, `\\"triangle-up\\"`, `\\"triangle-down\\"`, `\\"triangle-right\\"`, or `\\"triangle-left\\"`.\\n- the line symbol `\\"stroke\\"`\\n- centered directional shapes `\\"arrow\\"`, `\\"wedge\\"`, or `\\"triangle\\"`\\n- a custom [SVG path string](https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths) (For correct sizing, custom shape paths should be defined within a square bounding box with coordinates ranging from -1 to 1 along both the x and y dimensions.)\\n\\n__Default value:__ `\\"circle\\"`"},{"$ref":"#/definitions/ExprRef"}]},"size":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"Default size for marks.\\n- For `point`/`circle`/`square`, this represents the pixel area of the marks. Note that this value sets the area of the symbol; the side lengths will increase with the square root of this value.\\n- For `bar`, this represents the band size of the bar, in pixels.\\n- For `text`, this represents the font size, in pixels.\\n\\n__Default value:__\\n- `30` for point, circle, square marks; width/height\'s `step`\\n- `2` for bar marks with discrete dimensions;\\n- `5` for bar marks with continuous dimensions;\\n- `11` for text marks.","minimum":0},"smooth":{"anyOf":[{"description":"A boolean flag (default true) indicating if the image should be smoothed when resized. If false, individual pixels should be scaled directly rather than interpolated with smoothing. For SVG rendering, this option may not work in some browsers due to lack of standardization.","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"startAngle":{"anyOf":[{"description":"The start angle in radians for arc marks. A value of `0` indicates up (north), increasing values proceed clockwise.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/Gradient"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"Default stroke color. This property has higher precedence than `config.color`. Set to `null` to remove stroke.\\n\\n__Default value:__ (None)"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOffset":{"anyOf":[{"description":"The offset in pixels at which to draw the group stroke and fill. If unspecified, the default behavior is to dynamically offset stroked groups such that 1 pixel stroke widths align with the pixel grid.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"tension":{"anyOf":[{"description":"Depending on the interpolation type, sets the tension parameter (for line and area marks).","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text","description":"Placeholder text if the `text` channel is not specified"},{"$ref":"#/definitions/ExprRef"}]},"theta":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"- For arc marks, the arc length in radians if theta2 is not specified, otherwise the start arc angle. (A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise.)\\n\\n- For text marks, polar coordinate angle in radians.","maximum":360,"minimum":0},"theta2":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The end angle of arc marks in radians. A value of 0 indicates up or \u201Cnorth\u201D, increasing values proceed clockwise."},"thickness":{"description":"Thickness of the tick mark.\\n\\n__Default value:__  `1`","minimum":0,"type":"number"},"time":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"timeUnitBandPosition":{"description":"Default relative band position for a time unit. If set to `0`, the marks will be positioned at the beginning of the time unit band step. If set to `0.5`, the marks will be positioned in the middle of the time unit band step.","type":"number"},"timeUnitBandSize":{"description":"Default relative band size for a time unit. If set to `1`, the bandwidth of the marks will be equal to the time unit band step. If set to `0.5`, bandwidth of the marks will be half of the time unit band step.","type":"number"},"tooltip":{"anyOf":[{"type":"number"},{"type":"string"},{"type":"boolean"},{"$ref":"#/definitions/TooltipContent"},{"$ref":"#/definitions/ExprRef"},{"type":"null"}],"description":"The tooltip text string to show upon mouse hover or an object defining which fields should the tooltip be derived from.\\n\\n- If `tooltip` is `true` or `{\\"content\\": \\"encoding\\"}`, then all fields from `encoding` will be used.\\n- If `tooltip` is `{\\"content\\": \\"data\\"}`, then all fields that appear in the highlighted data point will be used.\\n- If set to `null` or `false`, then no tooltip will be used.\\n\\nSee the [`tooltip`](https://vega.github.io/vega-lite/docs/tooltip.html) documentation for a detailed discussion about tooltip  in Vega-Lite.\\n\\n__Default value:__ `null`"},"url":{"anyOf":[{"$ref":"#/definitions/URI","description":"The URL of the image file for image marks."},{"$ref":"#/definitions/ExprRef"}]},"width":{"anyOf":[{"description":"Width of the marks.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"x":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X coordinates of the marks, or width of horizontal `\\"bar\\"` and `\\"area\\"` without specified `x2` or `width`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"x2":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"X2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"width\\"` for the width of the plot."},"y":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y coordinates of the marks, or height of vertical `\\"bar\\"` and `\\"area\\"` without specified `y2` or `height`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."},"y2":{"anyOf":[{"type":"number"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"Y2 coordinates for ranged `\\"area\\"`, `\\"bar\\"`, `\\"rect\\"`, and  `\\"rule\\"`.\\n\\nThe `value` of this channel can be a number or a string `\\"height\\"` for the height of the plot."}},"type":"object"},"TickCount":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/TimeInterval"},{"$ref":"#/definitions/TimeIntervalStep"}]},"TimeDef":{"$ref":"#/definitions/TimeFieldDef"},"TimeFieldDef":{"additionalProperties":false,"properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"rescale":{"type":"boolean"},"scale":{"anyOf":[{"$ref":"#/definitions/Scale"},{"type":"null"}],"description":"An object defining properties of the channel\'s scale, which is the function that transforms values in the data domain (numbers, dates, strings, etc) to visual values (pixels, colors, sizes) of the encoding channels.\\n\\nIf `null`, the scale will be [disabled and the data value will be directly encoded](https://vega.github.io/vega-lite/docs/scale.html#disable).\\n\\n__Default value:__ If undefined, default [scale properties](https://vega.github.io/vega-lite/docs/scale.html) are applied.\\n\\n__See also:__ [`scale`](https://vega.github.io/vega-lite/docs/scale.html) documentation."},"sort":{"$ref":"#/definitions/Sort","description":"Sort order for the encoded field.\\n\\nFor continuous fields (quantitative or temporal), `sort` can be either `\\"ascending\\"` or `\\"descending\\"`.\\n\\nFor discrete fields, `sort` can be one of the following:\\n- `\\"ascending\\"` or `\\"descending\\"` -- for sorting by the values\' natural order in JavaScript.\\n- [A string indicating an encoding channel name to sort by](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding) (e.g., `\\"x\\"` or `\\"y\\"`) with an optional minus prefix for descending sort (e.g., `\\"-x\\"` to sort by x-field, descending). This channel string is short-form of [a sort-by-encoding definition](https://vega.github.io/vega-lite/docs/sort.html#sort-by-encoding). For example, `\\"sort\\": \\"-x\\"` is equivalent to `\\"sort\\": {\\"encoding\\": \\"x\\", \\"order\\": \\"descending\\"}`.\\n- [A sort field definition](https://vega.github.io/vega-lite/docs/sort.html#sort-field) for sorting by another field.\\n- [An array specifying the field values in preferred order](https://vega.github.io/vega-lite/docs/sort.html#sort-array). In this case, the sort order will obey the values in the array, followed by any unspecified values in their original order. For discrete time field, values in the sort array can be [date-time definition objects](types#datetime). In addition, for time units `\\"month\\"` and `\\"day\\"`, the values can be the month or day names (case insensitive) or their 3-letter initials (e.g., `\\"Mon\\"`, `\\"Tue\\"`).\\n- `null` indicating no sort.\\n\\n__Default value:__ `\\"ascending\\"`\\n\\n__Note:__ `null` and sorting by another channel is not supported for `row` and `column`.\\n\\n__See also:__ [`sort`](https://vega.github.io/vega-lite/docs/sort.html) documentation."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"TimeFormatSpecifier":{"additionalProperties":false,"properties":{"date":{"type":"string"},"day":{"type":"string"},"hours":{"type":"string"},"milliseconds":{"type":"string"},"minutes":{"type":"string"},"month":{"type":"string"},"quarter":{"type":"string"},"seconds":{"type":"string"},"week":{"type":"string"},"year":{"type":"string"}},"type":"object"},"TimeInterval":{"enum":["millisecond","second","minute","hour","day","week","month","year"],"type":"string"},"TimeIntervalStep":{"additionalProperties":false,"properties":{"interval":{"$ref":"#/definitions/TimeInterval"},"step":{"type":"number"}},"required":["interval","step"],"type":"object"},"TimeLocale":{"additionalProperties":false,"description":"Locale definition for formatting dates and times.","properties":{"date":{"description":"The date (%x) format specifier (e.g., \\"%m/%d/%Y\\").","type":"string"},"dateTime":{"description":"The date and time (%c) format specifier (e.g., \\"%a %b %e %X %Y\\").","type":"string"},"days":{"$ref":"#/definitions/Vector7<string>","description":"The full names of the weekdays, starting with Sunday."},"months":{"$ref":"#/definitions/Vector12<string>","description":"The full names of the months (starting with January)."},"periods":{"$ref":"#/definitions/Vector2<string>","description":"The A.M. and P.M. equivalents (e.g., [\\"AM\\", \\"PM\\"])."},"shortDays":{"$ref":"#/definitions/Vector7<string>","description":"The abbreviated names of the weekdays, starting with Sunday."},"shortMonths":{"$ref":"#/definitions/Vector12<string>","description":"The abbreviated names of the months (starting with January)."},"time":{"description":"The time (%X) format specifier (e.g., \\"%H:%M:%S\\").","type":"string"}},"required":["dateTime","date","time","periods","days","shortDays","months","shortMonths"],"type":"object"},"TimeUnit":{"anyOf":[{"$ref":"#/definitions/SingleTimeUnit"},{"$ref":"#/definitions/MultiTimeUnit"}]},"TimeUnitParams":{"additionalProperties":false,"description":"Time Unit Params for encoding predicate, which can specified if the data is  already \\"binned\\".","properties":{"binned":{"description":"Whether the data has already been binned to this time unit. If true, Vega-Lite will only format the data, marks, and guides, without applying the timeUnit transform to re-bin the data again.","type":"boolean"},"maxbins":{"description":"If no `unit` is specified, maxbins is used to infer time units.","type":"number"},"step":{"description":"The number of steps between bins, in terms of the least significant unit provided.","type":"number"},"unit":{"$ref":"#/definitions/TimeUnit","description":"Defines how date-time values should be binned."},"utc":{"description":"True to use UTC timezone. Equivalent to using a `utc` prefixed `TimeUnit`.","type":"boolean"}},"type":"object"},"TimeUnitTransform":{"additionalProperties":false,"properties":{"as":{"$ref":"#/definitions/FieldName","description":"The output field to write the timeUnit value."},"field":{"$ref":"#/definitions/FieldName","description":"The data field to apply time unit."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/TimeUnitTransformParams"}],"description":"The timeUnit."}},"required":["timeUnit","field","as"],"type":"object"},"TimeUnitTransformParams":{"additionalProperties":false,"properties":{"maxbins":{"description":"If no `unit` is specified, maxbins is used to infer time units.","type":"number"},"step":{"description":"The number of steps between bins, in terms of the least significant unit provided.","type":"number"},"unit":{"$ref":"#/definitions/TimeUnit","description":"Defines how date-time values should be binned."},"utc":{"description":"True to use UTC timezone. Equivalent to using a `utc` prefixed `TimeUnit`.","type":"boolean"}},"type":"object"},"TitleAnchor":{"enum":[null,"start","middle","end"],"type":["null","string"]},"TitleConfig":{"$ref":"#/definitions/BaseTitleNoValueRefs"},"TitleFrame":{"enum":["bounds","group"],"type":"string"},"TitleOrient":{"enum":["none","left","right","top","bottom"],"type":"string"},"TitleParams":{"additionalProperties":false,"properties":{"align":{"$ref":"#/definitions/Align","description":"Horizontal text alignment for title text. One of `\\"left\\"`, `\\"center\\"`, or `\\"right\\"`."},"anchor":{"$ref":"#/definitions/TitleAnchor","description":"The anchor position for placing the title. One of `\\"start\\"`, `\\"middle\\"`, or `\\"end\\"`. For example, with an orientation of top these anchor positions map to a left-, center-, or right-aligned title.\\n\\n__Default value:__ `\\"middle\\"` for [single](https://vega.github.io/vega-lite/docs/spec.html) and [layered](https://vega.github.io/vega-lite/docs/layer.html) views. `\\"start\\"` for other composite views.\\n\\n__Note:__ [For now](https://github.com/vega/vega-lite/issues/2875), `anchor` is only customizable only for [single](https://vega.github.io/vega-lite/docs/spec.html) and [layered](https://vega.github.io/vega-lite/docs/layer.html) views. For other composite views, `anchor` is always `\\"start\\"`."},"angle":{"anyOf":[{"description":"Angle in degrees of title and subtitle text.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"aria":{"anyOf":[{"description":"A boolean flag indicating if [ARIA attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) should be included (SVG output only). If `false`, the \\"aria-hidden\\" attribute will be set on the output SVG group, removing the title from the ARIA accessibility tree.\\n\\n__Default value:__ `true`","type":"boolean"},{"$ref":"#/definitions/ExprRef"}]},"baseline":{"$ref":"#/definitions/TextBaseline","description":"Vertical text baseline for title and subtitle text. One of `\\"alphabetic\\"` (default), `\\"top\\"`, `\\"middle\\"`, `\\"bottom\\"`, `\\"line-top\\"`, or `\\"line-bottom\\"`. The `\\"line-top\\"` and `\\"line-bottom\\"` values operate similarly to `\\"top\\"` and `\\"bottom\\"`, but are calculated relative to the *lineHeight* rather than *fontSize* alone."},"color":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Text color for title text."},{"$ref":"#/definitions/ExprRef"}]},"dx":{"anyOf":[{"description":"Delta offset for title and subtitle text x-coordinate.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"dy":{"anyOf":[{"description":"Delta offset for title and subtitle text y-coordinate.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"font":{"anyOf":[{"description":"Font name for title text.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"fontSize":{"anyOf":[{"description":"Font size in pixels for title text.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"fontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style for title text."},{"$ref":"#/definitions/ExprRef"}]},"fontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight for title text. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"frame":{"anyOf":[{"anyOf":[{"$ref":"#/definitions/TitleFrame"},{"type":"string"}],"description":"The reference frame for the anchor position, one of `\\"bounds\\"` (to anchor relative to the full bounding box) or `\\"group\\"` (to anchor relative to the group width or height)."},{"$ref":"#/definitions/ExprRef"}]},"limit":{"anyOf":[{"description":"The maximum allowed length in pixels of title and subtitle text.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"lineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line title text or title text with `\\"line-top\\"` or `\\"line-bottom\\"` baseline.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"offset":{"anyOf":[{"description":"The orthogonal offset in pixels by which to displace the title group from its position along the edge of the chart.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"orient":{"anyOf":[{"$ref":"#/definitions/TitleOrient","description":"Default title orientation (`\\"top\\"`, `\\"bottom\\"`, `\\"left\\"`, or `\\"right\\"`)"},{"$ref":"#/definitions/ExprRef"}]},"style":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}],"description":"A [mark style property](https://vega.github.io/vega-lite/docs/config.html#style) to apply to the title text mark.\\n\\n__Default value:__ `\\"group-title\\"`."},"subtitle":{"$ref":"#/definitions/Text","description":"The subtitle Text."},"subtitleColor":{"anyOf":[{"anyOf":[{"type":"null"},{"$ref":"#/definitions/Color"}],"description":"Text color for subtitle text."},{"$ref":"#/definitions/ExprRef"}]},"subtitleFont":{"anyOf":[{"description":"Font name for subtitle text.","type":"string"},{"$ref":"#/definitions/ExprRef"}]},"subtitleFontSize":{"anyOf":[{"description":"Font size in pixels for subtitle text.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"subtitleFontStyle":{"anyOf":[{"$ref":"#/definitions/FontStyle","description":"Font style for subtitle text."},{"$ref":"#/definitions/ExprRef"}]},"subtitleFontWeight":{"anyOf":[{"$ref":"#/definitions/FontWeight","description":"Font weight for subtitle text. This can be either a string (e.g `\\"bold\\"`, `\\"normal\\"`) or a number (`100`, `200`, `300`, ..., `900` where `\\"normal\\"` = `400` and `\\"bold\\"` = `700`)."},{"$ref":"#/definitions/ExprRef"}]},"subtitleLineHeight":{"anyOf":[{"description":"Line height in pixels for multi-line subtitle text.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"subtitlePadding":{"anyOf":[{"description":"The padding in pixels between title and subtitle text.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"text":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/ExprRef"}],"description":"The title text."},"zindex":{"description":"The integer z-index indicating the layering of the title group relative to other axis, mark and legend groups.\\n\\n__Default value:__ `0`.","minimum":0,"type":"number"}},"required":["text"],"type":"object"},"TooltipContent":{"additionalProperties":false,"properties":{"content":{"enum":["encoding","data"],"type":"string"}},"required":["content"],"type":"object"},"TopLevelConcatSpec":{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"concat":{"description":"A list of views to be concatenated.","items":{"$ref":"#/definitions/NonNormalizedSpec"},"type":"array"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."}},"required":["concat"],"type":"object"},"TopLevelHConcatSpec":{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\n__Default value:__ `false`","type":"boolean"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"hconcat":{"description":"A list of views to be concatenated and put into a row.","items":{"$ref":"#/definitions/NonNormalizedSpec"},"type":"array"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"description":"The spacing in pixels between sub-views of the concat operator.\\n\\n__Default value__: `10`","type":"number"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."}},"required":["hconcat"],"type":"object"},"TopLevelVConcatSpec":{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\n__Default value:__ `false`","type":"boolean"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"description":"The spacing in pixels between sub-views of the concat operator.\\n\\n__Default value__: `10`","type":"number"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."},"vconcat":{"description":"A list of views to be concatenated and put into a column.","items":{"$ref":"#/definitions/NonNormalizedSpec"},"type":"array"}},"required":["vconcat"],"type":"object"},"TopLevelLayerSpec":{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"encoding":{"$ref":"#/definitions/SharedEncoding","description":"A shared key-value mapping between encoding channels and definition of fields in the underlying layers."},"height":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The height of a visualization.\\n\\n- For a plot with a continuous y-field, height should be a number.\\n- For a plot with either a discrete y-field or no y-field, height can be either a number indicating a fixed height or an object in the form of `{step: number}` defining the height per discrete step. (No y-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on height, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousHeight` for a plot with a continuous y-field and `config.view.discreteHeight` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the height of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`height`](https://vega.github.io/vega-lite/docs/size.html) documentation."},"layer":{"description":"Layer or single view specifications to be layered.\\n\\n__Note__: Specifications inside `layer` cannot use `row` and `column` channels as layering facet specifications is not allowed. Instead, use the [facet operator](https://vega.github.io/vega-lite/docs/facet.html) and place a layer inside a facet.","items":{"anyOf":[{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/UnitSpec"}]},"type":"array"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"projection":{"$ref":"#/definitions/Projection","description":"An object defining properties of the geographic projection shared by underlying layers."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."},"view":{"$ref":"#/definitions/ViewBackground","description":"An object defining the view background\'s fill and stroke.\\n\\n__Default value:__ none (transparent)"},"width":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The width of a visualization.\\n\\n- For a plot with a continuous x-field, width should be a number.\\n- For a plot with either a discrete x-field or no x-field, width can be either a number indicating a fixed width or an object in the form of `{step: number}` defining the width per discrete step. (No x-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on width, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousWidth` for a plot with a continuous x-field and `config.view.discreteWidth` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the width of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`width`](https://vega.github.io/vega-lite/docs/size.html) documentation."}},"required":["layer"],"type":"object"},"TopLevelRepeatSpec":{"anyOf":[{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"repeat":{"anyOf":[{"items":{"type":"string"},"type":"array"},{"$ref":"#/definitions/RepeatMapping"}],"description":"Definition for fields to be repeated. One of: 1) An array of fields to be repeated. If `\\"repeat\\"` is an array, the field can be referred to as `{\\"repeat\\": \\"repeat\\"}`. The repeated views are laid out in a wrapped row. You can set the number of columns to control the wrapping. 2) An object that maps `\\"row\\"` and/or `\\"column\\"` to the listed fields to be repeated along the particular orientations. The objects `{\\"repeat\\": \\"row\\"}` and `{\\"repeat\\": \\"column\\"}` can be used to refer to the repeated field respectively."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"spec":{"$ref":"#/definitions/NonNormalizedSpec","description":"A specification of the view that gets repeated."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."}},"required":["repeat","spec"],"type":"object"},{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"repeat":{"$ref":"#/definitions/LayerRepeatMapping","description":"Definition for fields to be repeated. One of: 1) An array of fields to be repeated. If `\\"repeat\\"` is an array, the field can be referred to as `{\\"repeat\\": \\"repeat\\"}`. The repeated views are laid out in a wrapped row. You can set the number of columns to control the wrapping. 2) An object that maps `\\"row\\"` and/or `\\"column\\"` to the listed fields to be repeated along the particular orientations. The objects `{\\"repeat\\": \\"row\\"}` and `{\\"repeat\\": \\"column\\"}` can be used to refer to the repeated field respectively."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"spec":{"anyOf":[{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/UnitSpecWithFrame"}],"description":"A specification of the view that gets repeated."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."}},"required":["repeat","spec"],"type":"object"}]},"TopLevelFacetSpec":{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"columns":{"description":"The number of columns to include in the view composition layout.\\n\\n__Default value__: `undefined` -- An infinite number of columns (a single row) will be assumed. This is equivalent to `hconcat` (for `concat`) and to using the `column` channel (for `facet` and `repeat`).\\n\\n__Note__:\\n\\n1) This property is only for:\\n- the general (wrappable) `concat` operator (not `hconcat`/`vconcat`)\\n- the `facet` and `repeat` operator with one field/repetition definition (without row/column nesting)\\n\\n2) Setting the `columns` to `1` is equivalent to `vconcat` (for `concat`) and to using the `row` channel (for `facet` and `repeat`).","type":"number"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"facet":{"anyOf":[{"$ref":"#/definitions/FacetFieldDef"},{"$ref":"#/definitions/FacetMapping"}],"description":"Definition for how to facet the data. One of: 1) [a field definition for faceting the plot by one field](https://vega.github.io/vega-lite/docs/facet.html#field-def) 2) [An object that maps `row` and `column` channels to their field definitions](https://vega.github.io/vega-lite/docs/facet.html#mapping)"},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"Dynamic variables or selections that parameterize a visualization.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"spec":{"anyOf":[{"$ref":"#/definitions/LayerSpec"},{"$ref":"#/definitions/UnitSpecWithFrame"}],"description":"A specification of the view that gets faceted."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."}},"required":["data","facet","spec"],"type":"object"},"TopLevelParameter":{"anyOf":[{"$ref":"#/definitions/VariableParameter"},{"$ref":"#/definitions/TopLevelSelectionParameter"}]},"TopLevelSelectionParameter":{"additionalProperties":false,"properties":{"bind":{"anyOf":[{"$ref":"#/definitions/Binding"},{"additionalProperties":{"$ref":"#/definitions/Binding"},"type":"object"},{"$ref":"#/definitions/LegendBinding"},{"const":"scales","type":"string"}],"description":"When set, a selection is populated by input elements (also known as dynamic query widgets) or by interacting with the corresponding legend. Direct manipulation interaction is disabled by default; to re-enable it, set the selection\'s [`on`](https://vega.github.io/vega-lite/docs/selection.html#common-selection-properties) property.\\n\\nLegend bindings are restricted to selections that only specify a single field or encoding.\\n\\nQuery widget binding takes the form of Vega\'s [input element binding definition](https://vega.github.io/vega/docs/signals/#bind) or can be a mapping between projected field/encodings and binding definitions.\\n\\n__See also:__ [`bind`](https://vega.github.io/vega-lite/docs/bind.html) documentation."},"name":{"$ref":"#/definitions/ParameterName","description":"Required. A unique name for the selection parameter. Selection names should be valid JavaScript identifiers: they should contain only alphanumeric characters (or \\"$\\", or \\"_\\") and may not start with a digit. Reserved keywords that may not be used as parameter names are \\"datum\\", \\"event\\", \\"item\\", and \\"parent\\"."},"select":{"anyOf":[{"$ref":"#/definitions/SelectionType"},{"$ref":"#/definitions/PointSelectionConfig"},{"$ref":"#/definitions/IntervalSelectionConfig"}],"description":"Determines the default event processing and data query for the selection. Vega-Lite currently supports two selection types:\\n\\n- `\\"point\\"` -- to select multiple discrete data values; the first value is selected on `click` and additional values toggled on shift-click.\\n- `\\"interval\\"` -- to select a continuous range of data values on `drag`."},"value":{"anyOf":[{"$ref":"#/definitions/SelectionInit"},{"items":{"$ref":"#/definitions/SelectionInitMapping"},"type":"array"},{"$ref":"#/definitions/SelectionInitIntervalMapping"}],"description":"Initialize the selection with a mapping between [projected channels or field names](https://vega.github.io/vega-lite/docs/selection.html#project) and initial values.\\n\\n__See also:__ [`init`](https://vega.github.io/vega-lite/docs/value.html) documentation."},"views":{"description":"By default, top-level selections are applied to every view in the visualization. If this property is specified, selections will only be applied to views with the given names.","items":{"type":"string"},"type":"array"}},"required":["name","select"],"type":"object"},"TopLevelSpec":{"anyOf":[{"$ref":"#/definitions/TopLevelUnitSpec"},{"$ref":"#/definitions/TopLevelFacetSpec"},{"$ref":"#/definitions/TopLevelLayerSpec"},{"$ref":"#/definitions/TopLevelRepeatSpec"},{"$ref":"#/definitions/TopLevelConcatSpec"},{"$ref":"#/definitions/TopLevelVConcatSpec"},{"$ref":"#/definitions/TopLevelHConcatSpec"}],"description":"A Vega-Lite top-level specification. This is the root class for all Vega-Lite specifications. (The json schema is generated from this type.)"},"TopLevelUnitSpec":{"additionalProperties":false,"properties":{"$schema":{"description":"URL to [JSON schema](http://json-schema.org/) for a Vega-Lite specification. Unless you have a reason to change this, use `https://vega.github.io/schema/vega-lite/v6.json`. Setting the `$schema` property allows automatic validation and autocomplete in editors that support JSON schema.","format":"uri","type":"string"},"align":{"anyOf":[{"$ref":"#/definitions/LayoutAlign"},{"$ref":"#/definitions/RowCol<LayoutAlign>"}],"description":"The alignment to apply to grid rows and columns. The supported string values are `\\"all\\"`, `\\"each\\"`, and `\\"none\\"`.\\n\\n- For `\\"none\\"`, a flow layout will be used, in which adjacent subviews are simply placed one after the other.\\n- For `\\"each\\"`, subviews will be aligned into a clean grid structure, but each row or column may be of variable size.\\n- For `\\"all\\"`, subviews will be aligned and each row or column will be sized identically based on the maximum observed size. String values for this property will be applied to both grid rows and columns.\\n\\nAlternatively, an object value of the form `{\\"row\\": string, \\"column\\": string}` can be used to supply different alignments for rows and columns.\\n\\n__Default value:__ `\\"all\\"`."},"autosize":{"anyOf":[{"$ref":"#/definitions/AutosizeType"},{"$ref":"#/definitions/AutoSizeParams"}],"description":"How the visualization size should be determined. If a string, should be one of `\\"pad\\"`, `\\"fit\\"` or `\\"none\\"`. Object values can additionally specify parameters for content sizing and automatic resizing.\\n\\n__Default value__: `pad`"},"background":{"anyOf":[{"$ref":"#/definitions/Color"},{"$ref":"#/definitions/ExprRef"}],"description":"CSS color property to use as the background of the entire view.\\n\\n__Default value:__ `\\"white\\"`"},"bounds":{"description":"The bounds calculation method to use for determining the extent of a sub-plot. One of `full` (the default) or `flush`.\\n\\n- If set to `full`, the entire calculated bounds (including axes, title, and legend) will be used.\\n- If set to `flush`, only the specified width and height values for the sub-view will be used. The `flush` setting can be useful when attempting to place sub-plots without axes or legends into a uniform grid structure.\\n\\n__Default value:__ `\\"full\\"`","enum":["full","flush"],"type":"string"},"center":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/RowCol<boolean>"}],"description":"Boolean flag indicating if subviews should be centered relative to their respective rows or columns.\\n\\nAn object value of the form `{\\"row\\": boolean, \\"column\\": boolean}` can be used to supply different centering values for rows and columns.\\n\\n__Default value:__ `false`"},"config":{"$ref":"#/definitions/Config","description":"Vega-Lite configuration object. This property can only be defined at the top-level of a specification."},"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"datasets":{"$ref":"#/definitions/Datasets","description":"A global data store for named datasets. This is a mapping from names to inline datasets. This can be an array of objects or primitive values or a string. Arrays of primitive values are ingested as objects with a `data` property."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"encoding":{"$ref":"#/definitions/FacetedEncoding","description":"A key-value mapping between encoding channels and definition of fields."},"height":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The height of a visualization.\\n\\n- For a plot with a continuous y-field, height should be a number.\\n- For a plot with either a discrete y-field or no y-field, height can be either a number indicating a fixed height or an object in the form of `{step: number}` defining the height per discrete step. (No y-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on height, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousHeight` for a plot with a continuous y-field and `config.view.discreteHeight` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the height of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`height`](https://vega.github.io/vega-lite/docs/size.html) documentation."},"mark":{"$ref":"#/definitions/AnyMark","description":"A string describing the mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"rule\\"`, `\\"geoshape\\"`, and `\\"text\\"`) or a [mark definition object](https://vega.github.io/vega-lite/docs/mark.html#mark-def)."},"name":{"description":"Name of the visualization for later reference.","type":"string"},"padding":{"anyOf":[{"$ref":"#/definitions/Padding"},{"$ref":"#/definitions/ExprRef"}],"description":"The default visualization padding, in pixels, from the edge of the visualization canvas to the data rectangle. If a number, specifies padding for all sides. If an object, the value should have the format `{\\"left\\": 5, \\"top\\": 5, \\"right\\": 5, \\"bottom\\": 5}` to specify padding for each side of the visualization.\\n\\n__Default value__: `5`"},"params":{"description":"An array of parameters that may either be simple variables, or more complex selections that map user input to data queries.","items":{"$ref":"#/definitions/TopLevelParameter"},"type":"array"},"projection":{"$ref":"#/definitions/Projection","description":"An object defining properties of geographic projection, which will be applied to `shape` path for `\\"geoshape\\"` marks and to `latitude` and `\\"longitude\\"` channels for other marks."},"resolve":{"$ref":"#/definitions/Resolve","description":"Scale, axis, and legend resolutions for view composition specifications."},"spacing":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/RowCol<number>"}],"description":"The spacing in pixels between sub-views of the composition operator. An object of the form `{\\"row\\": number, \\"column\\": number}` can be used to set different spacing values for rows and columns.\\n\\n__Default value__: Depends on `\\"spacing\\"` property of [the view composition configuration](https://vega.github.io/vega-lite/docs/config.html#view-config) (`20` by default)"},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"usermeta":{"$ref":"#/definitions/Dict","description":"Optional metadata that will be passed to Vega. This object is completely ignored by Vega and Vega-Lite and can be used for custom metadata."},"view":{"$ref":"#/definitions/ViewBackground","description":"An object defining the view background\'s fill and stroke.\\n\\n__Default value:__ none (transparent)"},"width":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The width of a visualization.\\n\\n- For a plot with a continuous x-field, width should be a number.\\n- For a plot with either a discrete x-field or no x-field, width can be either a number indicating a fixed width or an object in the form of `{step: number}` defining the width per discrete step. (No x-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on width, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousWidth` for a plot with a continuous x-field and `config.view.discreteWidth` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the width of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`width`](https://vega.github.io/vega-lite/docs/size.html) documentation."}},"required":["data","mark"],"type":"object"},"TopoDataFormat":{"additionalProperties":false,"properties":{"feature":{"description":"The name of the TopoJSON object set to convert to a GeoJSON feature collection. For example, in a map of the world, there may be an object set named `\\"countries\\"`. Using the feature property, we can extract this set and generate a GeoJSON feature object for each country.","type":"string"},"mesh":{"description":"The name of the TopoJSON object set to convert to mesh. Similar to the `feature` option, `mesh` extracts a named TopoJSON object set.  Unlike the `feature` option, the corresponding geo data is returned as a single, unified mesh instance, not as individual GeoJSON features. Extracting a mesh is useful for more efficiently drawing borders or other geographic elements that you do not need to associate with specific regions such as individual countries, states or counties.","type":"string"},"parse":{"anyOf":[{"$ref":"#/definitions/Parse"},{"type":"null"}],"description":"If set to `null`, disable type inference based on the spec and only use type inference based on the data. Alternatively, a parsing directive object can be provided for explicit data types. Each property of the object corresponds to a field name, and the value to the desired data type (one of `\\"number\\"`, `\\"boolean\\"`, `\\"date\\"`, or null (do not parse the field)). For example, `\\"parse\\": {\\"modified_on\\": \\"date\\"}` parses the `modified_on` field in each input record a Date value.\\n\\nFor `\\"date\\"`, we parse data based using JavaScript\'s [`Date.parse()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse). For Specific date formats can be provided (e.g., `{foo: \\"date:\'%m%d%Y\'\\"}`), using the [d3-time-format syntax](https://github.com/d3/d3-time-format#locale_format). UTC date format parsing is supported similarly (e.g., `{foo: \\"utc:\'%m%d%Y\'\\"}`). See more about [UTC time](https://vega.github.io/vega-lite/docs/timeunit.html#utc)"},"type":{"const":"topojson","description":"Type of input data: `\\"json\\"`, `\\"csv\\"`, `\\"tsv\\"`, `\\"dsv\\"`.\\n\\n__Default value:__  The default format type is determined by the extension of the file URL. If no extension is detected, `\\"json\\"` will be used by default.","type":"string"}},"type":"object"},"Transform":{"anyOf":[{"$ref":"#/definitions/AggregateTransform"},{"$ref":"#/definitions/BinTransform"},{"$ref":"#/definitions/CalculateTransform"},{"$ref":"#/definitions/DensityTransform"},{"$ref":"#/definitions/ExtentTransform"},{"$ref":"#/definitions/FilterTransform"},{"$ref":"#/definitions/FlattenTransform"},{"$ref":"#/definitions/FoldTransform"},{"$ref":"#/definitions/ImputeTransform"},{"$ref":"#/definitions/JoinAggregateTransform"},{"$ref":"#/definitions/LoessTransform"},{"$ref":"#/definitions/LookupTransform"},{"$ref":"#/definitions/QuantileTransform"},{"$ref":"#/definitions/RegressionTransform"},{"$ref":"#/definitions/TimeUnitTransform"},{"$ref":"#/definitions/SampleTransform"},{"$ref":"#/definitions/StackTransform"},{"$ref":"#/definitions/WindowTransform"},{"$ref":"#/definitions/PivotTransform"}]},"Type":{"description":"Data type based on level of measurement","enum":["quantitative","ordinal","temporal","nominal","geojson"],"type":"string"},"TypeForShape":{"enum":["nominal","ordinal","geojson"],"type":"string"},"TypedFieldDef":{"additionalProperties":false,"description":"Definition object for a data field, its type and transformation of an encoding channel.","properties":{"aggregate":{"$ref":"#/definitions/Aggregate","description":"Aggregation function for the field (e.g., `\\"mean\\"`, `\\"sum\\"`, `\\"median\\"`, `\\"min\\"`, `\\"max\\"`, `\\"count\\"`).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html) documentation."},"bandPosition":{"description":"Relative position on a band of a stacked, binned, time unit, or band scale. For example, the marks will be positioned at the beginning of the band if set to `0`, and at the middle of the band if set to `0.5`.","maximum":1,"minimum":0,"type":"number"},"bin":{"anyOf":[{"type":"boolean"},{"$ref":"#/definitions/BinParams"},{"const":"binned","type":"string"},{"type":"null"}],"description":"A flag for binning a `quantitative` field, [an object defining binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters), or indicating that the data for `x` or `y` channel are binned before they are imported into Vega-Lite (`\\"binned\\"`).\\n\\n- If `true`, default [binning parameters](https://vega.github.io/vega-lite/docs/bin.html#bin-parameters) will be applied.\\n\\n- If `\\"binned\\"`, this indicates that the data for the `x` (or `y`) channel are already binned. You can map the bin-start field to `x` (or `y`) and the bin-end field to `x2` (or `y2`). The scale and axis will be formatted similar to binning in Vega-Lite.  To adjust the axis ticks based on the bin step, you can also set the axis\'s [`tickMinStep`](https://vega.github.io/vega-lite/docs/axis.html#ticks) property.\\n\\n__Default value:__ `false`\\n\\n__See also:__ [`bin`](https://vega.github.io/vega-lite/docs/bin.html) documentation."},"field":{"$ref":"#/definitions/Field","description":"__Required.__ A string defining the name of the field from which to pull a data value or an object defining iterated values from the [`repeat`](https://vega.github.io/vega-lite/docs/repeat.html) operator.\\n\\n__See also:__ [`field`](https://vega.github.io/vega-lite/docs/field.html) documentation.\\n\\n__Notes:__ 1)  Dots (`.`) and brackets (`[` and `]`) can be used to access nested objects (e.g., `\\"field\\": \\"foo.bar\\"` and `\\"field\\": \\"foo[\'bar\']\\"`). If field names contain dots or brackets but are not nested, you can use `\\\\\\\\` to escape dots and brackets (e.g., `\\"a\\\\\\\\.b\\"` and `\\"a\\\\\\\\[0\\\\\\\\]\\"`). See more details about escaping in the [field documentation](https://vega.github.io/vega-lite/docs/field.html). 2) `field` is not required if `aggregate` is `count`."},"timeUnit":{"anyOf":[{"$ref":"#/definitions/TimeUnit"},{"$ref":"#/definitions/BinnedTimeUnit"},{"$ref":"#/definitions/TimeUnitParams"}],"description":"Time unit (e.g., `year`, `yearmonth`, `month`, `hours`) for a temporal field. or [a temporal field that gets casted as ordinal](https://vega.github.io/vega-lite/docs/type.html#cast).\\n\\n__Default value:__ `undefined` (None)\\n\\n__See also:__ [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html) documentation."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"type":"null"}],"description":"A title for the field. If `null`, the title will be removed.\\n\\n__Default value:__  derived from the field\'s name and transformation function (`aggregate`, `bin` and `timeUnit`). If the field has an aggregate function, the function is displayed as part of the title (e.g., `\\"Sum of Profit\\"`). If the field is binned or has a time unit applied, the applied function is shown in parentheses (e.g., `\\"Profit (binned)\\"`, `\\"Transaction Date (year-month)\\"`). Otherwise, the title is simply the field name.\\n\\n__Notes__:\\n\\n1) You can customize the default field title format by providing the [`fieldTitle`](https://vega.github.io/vega-lite/docs/config.html#top-level-config) property in the [config](https://vega.github.io/vega-lite/docs/config.html) or [`fieldTitle` function via the `compile` function\'s options](https://vega.github.io/vega-lite/usage/compile.html#field-title).\\n\\n2) If both field definition\'s `title` and axis, header, or legend `title` are defined, axis/header/legend title will be used."},"type":{"$ref":"#/definitions/StandardType","description":"The type of measurement (`\\"quantitative\\"`, `\\"temporal\\"`, `\\"ordinal\\"`, or `\\"nominal\\"`) for the encoded field or constant value (`datum`). It can also be a `\\"geojson\\"` type for encoding [\'geoshape\'](https://vega.github.io/vega-lite/docs/geoshape.html).\\n\\nVega-Lite automatically infers data types in many cases as discussed below. However, type is required for a field if: (1) the field is not nominal and the field encoding has no specified `aggregate` (except `argmin` and `argmax`), `bin`, scale type, custom `sort` order, nor `timeUnit` or (2) if you wish to use an ordinal scale for a field with `bin` or `timeUnit`.\\n\\n__Default value:__\\n\\n1) For a data `field`, `\\"nominal\\"` is the default data type unless the field encoding has `aggregate`, `channel`, `bin`, scale type, `sort`, or `timeUnit` that satisfies the following criteria:\\n- `\\"quantitative\\"` is the default type if (1) the encoded field contains `bin` or `aggregate` except `\\"argmin\\"` and `\\"argmax\\"`, (2) the encoding channel is `latitude` or `longitude` channel or (3) if the specified scale type is [a quantitative scale](https://vega.github.io/vega-lite/docs/scale.html#type).\\n- `\\"temporal\\"` is the default type if (1) the encoded field contains `timeUnit` or (2) the specified scale type is a time or utc scale\\n- `\\"ordinal\\"` is the default type if (1) the encoded field contains a [custom `sort` order](https://vega.github.io/vega-lite/docs/sort.html#specifying-custom-sort-order), (2) the specified scale type is an ordinal/point/band scale, or (3) the encoding channel is `order`.\\n\\n2) For a constant value in data domain (`datum`):\\n- `\\"quantitative\\"` if the datum is a number\\n- `\\"nominal\\"` if the datum is a string\\n- `\\"temporal\\"` if the datum is [a date time object](https://vega.github.io/vega-lite/docs/datetime.html)\\n\\n__Note:__\\n- Data `type` describes the semantics of the data rather than the primitive data types (number, string, etc.). The same primitive data type can have different types of measurement. For example, numeric data can represent quantitative, ordinal, or nominal data.\\n- Data values for a temporal field can be either a date-time string (e.g., `\\"2015-03-07 12:32:17\\"`, `\\"17:01\\"`, `\\"2015-03-16\\"`. `\\"2015\\"`) or a timestamp number (e.g., `1552199579097`).\\n- When using with [`bin`](https://vega.github.io/vega-lite/docs/bin.html), the `type` property can be either `\\"quantitative\\"` (for using a linear bin scale) or [`\\"ordinal\\"` (for using an ordinal bin scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`timeUnit`](https://vega.github.io/vega-lite/docs/timeunit.html), the `type` property can be either `\\"temporal\\"` (default, for using a temporal scale) or [`\\"ordinal\\"` (for using an ordinal scale)](https://vega.github.io/vega-lite/docs/type.html#cast-bin).\\n- When using with [`aggregate`](https://vega.github.io/vega-lite/docs/aggregate.html), the `type` property refers to the post-aggregation data type. For example, we can calculate count `distinct` of a categorical field `\\"cat\\"` using `{\\"aggregate\\": \\"distinct\\", \\"field\\": \\"cat\\"}`. The `\\"type\\"` of the aggregate output is `\\"quantitative\\"`.\\n- Secondary channels (e.g., `x2`, `y2`, `xError`, `yError`) do not have `type` as they must have exactly the same type as their primary channels (e.g., `x`, `y`).\\n\\n__See also:__ [`type`](https://vega.github.io/vega-lite/docs/type.html) documentation."}},"type":"object"},"URI":{"format":"uri-reference","type":"string"},"UnitSpec":{"$ref":"#/definitions/GenericUnitSpec<Encoding,AnyMark>","description":"A unit specification, which can contain either [primitive marks or composite marks](https://vega.github.io/vega-lite/docs/mark.html#types)."},"UnitSpecWithFrame":{"additionalProperties":false,"properties":{"data":{"anyOf":[{"$ref":"#/definitions/Data"},{"type":"null"}],"description":"An object describing the data source. Set to `null` to ignore the parent\'s data source. If no data is set, it is derived from the parent."},"description":{"description":"Description of this mark for commenting purpose.","type":"string"},"encoding":{"$ref":"#/definitions/Encoding","description":"A key-value mapping between encoding channels and definition of fields."},"height":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The height of a visualization.\\n\\n- For a plot with a continuous y-field, height should be a number.\\n- For a plot with either a discrete y-field or no y-field, height can be either a number indicating a fixed height or an object in the form of `{step: number}` defining the height per discrete step. (No y-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on height, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousHeight` for a plot with a continuous y-field and `config.view.discreteHeight` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the height of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`height`](https://vega.github.io/vega-lite/docs/size.html) documentation."},"mark":{"$ref":"#/definitions/AnyMark","description":"A string describing the mark type (one of `\\"bar\\"`, `\\"circle\\"`, `\\"square\\"`, `\\"tick\\"`, `\\"line\\"`, `\\"area\\"`, `\\"point\\"`, `\\"rule\\"`, `\\"geoshape\\"`, and `\\"text\\"`) or a [mark definition object](https://vega.github.io/vega-lite/docs/mark.html#mark-def)."},"name":{"description":"Name of the visualization for later reference.","type":"string"},"params":{"description":"An array of parameters that may either be simple variables, or more complex selections that map user input to data queries.","items":{"$ref":"#/definitions/SelectionParameter"},"type":"array"},"projection":{"$ref":"#/definitions/Projection","description":"An object defining properties of geographic projection, which will be applied to `shape` path for `\\"geoshape\\"` marks and to `latitude` and `\\"longitude\\"` channels for other marks."},"title":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/TitleParams"}],"description":"Title for the plot."},"transform":{"description":"An array of data transformations such as filter and new field calculation.","items":{"$ref":"#/definitions/Transform"},"type":"array"},"view":{"$ref":"#/definitions/ViewBackground","description":"An object defining the view background\'s fill and stroke.\\n\\n__Default value:__ none (transparent)"},"width":{"anyOf":[{"type":"number"},{"const":"container","type":"string"},{"$ref":"#/definitions/Step"}],"description":"The width of a visualization.\\n\\n- For a plot with a continuous x-field, width should be a number.\\n- For a plot with either a discrete x-field or no x-field, width can be either a number indicating a fixed width or an object in the form of `{step: number}` defining the width per discrete step. (No x-field is equivalent to having one discrete step.)\\n- To enable responsive sizing on width, it should be set to `\\"container\\"`.\\n\\n__Default value:__ Based on `config.view.continuousWidth` for a plot with a continuous x-field and `config.view.discreteWidth` otherwise.\\n\\n__Note:__ For plots with [`row` and `column` channels](https://vega.github.io/vega-lite/docs/encoding.html#facet), this represents the width of a single view and the `\\"container\\"` option cannot be used.\\n\\n__See also:__ [`width`](https://vega.github.io/vega-lite/docs/size.html) documentation."}},"required":["mark"],"type":"object"},"UrlData":{"additionalProperties":false,"properties":{"format":{"$ref":"#/definitions/DataFormat","description":"An object that specifies the format for parsing the data."},"name":{"description":"Provide a placeholder name and bind data at runtime.","type":"string"},"url":{"description":"An URL from which to load the data set. Use the `format.type` property to ensure the loaded data is correctly parsed.","type":"string"}},"required":["url"],"type":"object"},"UtcMultiTimeUnit":{"enum":["utcyearquarter","utcyearquartermonth","utcyearmonth","utcyearmonthdate","utcyearmonthdatehours","utcyearmonthdatehoursminutes","utcyearmonthdatehoursminutesseconds","utcyearweek","utcyearweekday","utcyearweekdayhours","utcyearweekdayhoursminutes","utcyearweekdayhoursminutesseconds","utcyeardayofyear","utcquartermonth","utcmonthdate","utcmonthdatehours","utcmonthdatehoursminutes","utcmonthdatehoursminutesseconds","utcweekday","utcweekdayhours","utcweekdayhoursminutes","utcweekdayhoursminutesseconds","utcdayhours","utcdayhoursminutes","utcdayhoursminutesseconds","utchoursminutes","utchoursminutesseconds","utcminutesseconds","utcsecondsmilliseconds"],"type":"string"},"UtcSingleTimeUnit":{"enum":["utcyear","utcquarter","utcmonth","utcweek","utcday","utcdayofyear","utcdate","utchours","utcminutes","utcseconds","utcmilliseconds"],"type":"string"},"ValueDef<(number|\\"width\\"|\\"height\\"|ExprRef)>":{"additionalProperties":false,"description":"Definition object for a constant value (primitive value or gradient definition) of an encoding channel.","properties":{"value":{"anyOf":[{"type":"number"},{"const":"width","type":"string"},{"const":"height","type":"string"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"required":["value"],"type":"object"},"ValueDef<number>":{"additionalProperties":false,"description":"Definition object for a constant value (primitive value or gradient definition) of an encoding channel.","properties":{"value":{"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity).","type":"number"}},"required":["value"],"type":"object"},"ValueDefWithCondition<MarkPropFieldOrDatumDef,(Gradient|string|null)>":{"additionalProperties":false,"minProperties":1,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Gradient|string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."},"value":{"anyOf":[{"$ref":"#/definitions/Gradient"},{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"ValueDefWithCondition<MarkPropFieldOrDatumDef,(string|null)>":{"additionalProperties":false,"minProperties":1,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"ValueDefWithCondition<MarkPropFieldOrDatumDef,number>":{"additionalProperties":false,"minProperties":1,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."},"value":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"ValueDefWithCondition<MarkPropFieldOrDatumDef,number[]>":{"additionalProperties":false,"minProperties":1,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef"},{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(number[]|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."},"value":{"anyOf":[{"items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"ValueDefWithCondition<MarkPropFieldOrDatumDef<TypeForShape>,(string|null)>":{"additionalProperties":false,"minProperties":1,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalMarkPropFieldOrDatumDef<TypeForShape>"},{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(string|null|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."},"value":{"anyOf":[{"type":"string"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"ValueDefWithCondition<StringFieldDef,Text>":{"additionalProperties":false,"minProperties":1,"properties":{"condition":{"anyOf":[{"$ref":"#/definitions/ConditionalStringFieldDef"},{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},{"items":{"$ref":"#/definitions/ConditionalValueDef<(Text|ExprRef)>"},"type":"array"}],"description":"A field definition or one or more value definition(s) with a parameter predicate."},"value":{"anyOf":[{"$ref":"#/definitions/Text"},{"$ref":"#/definitions/ExprRef"}],"description":"A constant value in visual domain (e.g., `\\"red\\"` / `\\"#0099ff\\"` / [gradient definition](https://vega.github.io/vega-lite/docs/types.html#gradient) for color, values between `0` to `1` for opacity)."}},"type":"object"},"VariableParameter":{"additionalProperties":false,"properties":{"bind":{"$ref":"#/definitions/Binding","description":"Binds the parameter to an external input element such as a slider, selection list or radio button group."},"expr":{"$ref":"#/definitions/Expr","description":"An expression for the value of the parameter. This expression may include other parameters, in which case the parameter will automatically update in response to upstream parameter changes."},"name":{"$ref":"#/definitions/ParameterName","description":"A unique name for the variable parameter. Parameter names should be valid JavaScript identifiers: they should contain only alphanumeric characters (or \\"$\\", or \\"_\\") and may not start with a digit. Reserved keywords that may not be used as parameter names are \\"datum\\", \\"event\\", \\"item\\", and \\"parent\\"."},"react":{"description":"A boolean flag (default `true`) indicating if the update expression should be automatically re-evaluated when any upstream signal dependencies update. If `false`, the update expression will not register any dependencies on other signals, even for initialization.\\n\\n __Default value:__ `true`","type":"boolean"},"value":{"description":"The [initial value](http://vega.github.io/vega-lite/docs/value.html) of the parameter.\\n\\n__Default value:__ `undefined`"}},"required":["name"],"type":"object"},"Vector10<string>":{"items":{"type":"string"},"maxItems":10,"minItems":10,"type":"array"},"Vector12<string>":{"items":{"type":"string"},"maxItems":12,"minItems":12,"type":"array"},"Vector2<DateTime>":{"items":{"$ref":"#/definitions/DateTime"},"maxItems":2,"minItems":2,"type":"array"},"Vector2<Vector2<number>>":{"items":{"$ref":"#/definitions/Vector2<number>"},"maxItems":2,"minItems":2,"type":"array"},"Vector2<boolean>":{"items":{"type":"boolean"},"maxItems":2,"minItems":2,"type":"array"},"Vector2<number>":{"items":{"type":"number"},"maxItems":2,"minItems":2,"type":"array"},"Vector2<string>":{"items":{"type":"string"},"maxItems":2,"minItems":2,"type":"array"},"Vector3<number>":{"items":{"type":"number"},"maxItems":3,"minItems":3,"type":"array"},"Vector7<string>":{"items":{"type":"string"},"maxItems":7,"minItems":7,"type":"array"},"ViewBackground":{"additionalProperties":false,"properties":{"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the view. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"The fill color.\\n\\n__Default value:__ `undefined`"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"The stroke color.\\n\\n__Default value:__ `\\"#ddd\\"`"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"style":{"anyOf":[{"type":"string"},{"items":{"type":"string"},"type":"array"}],"description":"A string or array of strings indicating the name of custom styles to apply to the view background. A style is a named collection of mark property defaults defined within the [style configuration](https://vega.github.io/vega-lite/docs/mark.html#style-config). If style is an array, later styles will override earlier styles.\\n\\n__Default value:__ `\\"cell\\"` __Note:__ Any specified view background properties will augment the default style."}},"type":"object"},"ViewConfig":{"additionalProperties":false,"properties":{"clip":{"description":"Whether the view should be clipped.","type":"boolean"},"continuousHeight":{"description":"The default height when the plot has a continuous y-field for x or latitude, or has arc marks.\\n\\n__Default value:__ `300`","type":"number"},"continuousWidth":{"description":"The default width when the plot has a continuous field for x or longitude, or has arc marks.\\n\\n__Default value:__ `300`","type":"number"},"cornerRadius":{"anyOf":[{"description":"The radius in pixels of rounded rectangles or arcs\' corners.\\n\\n__Default value:__ `0`","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"cursor":{"$ref":"#/definitions/Cursor","description":"The mouse cursor used over the view. Any valid [CSS cursor type](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Values) can be used."},"discreteHeight":{"anyOf":[{"type":"number"},{"additionalProperties":false,"properties":{"step":{"type":"number"}},"required":["step"],"type":"object"}],"description":"The default height when the plot has non arc marks and either a discrete y-field or no y-field. The height can be either a number indicating a fixed height or an object in the form of `{step: number}` defining the height per discrete step.\\n\\n__Default value:__ a step size based on `config.view.step`."},"discreteWidth":{"anyOf":[{"type":"number"},{"additionalProperties":false,"properties":{"step":{"type":"number"}},"required":["step"],"type":"object"}],"description":"The default width when the plot has non-arc marks and either a discrete x-field or no x-field. The width can be either a number indicating a fixed width or an object in the form of `{step: number}` defining the width per discrete step.\\n\\n__Default value:__ a step size based on `config.view.step`."},"fill":{"anyOf":[{"$ref":"#/definitions/Color"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"The fill color.\\n\\n__Default value:__ `undefined`"},"fillOpacity":{"anyOf":[{"description":"The fill opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"opacity":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/ExprRef"}],"description":"The overall opacity (value between [0,1]).\\n\\n__Default value:__ `0.7` for non-aggregate plots with `point`, `tick`, `circle`, or `square` marks or layered `bar` charts and `1` otherwise.","maximum":1,"minimum":0},"step":{"description":"Default step size for x-/y- discrete fields.","type":"number"},"stroke":{"anyOf":[{"$ref":"#/definitions/Color"},{"type":"null"},{"$ref":"#/definitions/ExprRef"}],"description":"The stroke color.\\n\\n__Default value:__ `\\"#ddd\\"`"},"strokeCap":{"anyOf":[{"$ref":"#/definitions/StrokeCap","description":"The stroke cap for line ending style. One of `\\"butt\\"`, `\\"round\\"`, or `\\"square\\"`.\\n\\n__Default value:__ `\\"butt\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeDash":{"anyOf":[{"description":"An array of alternating stroke, space lengths for creating dashed or dotted lines.","items":{"type":"number"},"type":"array"},{"$ref":"#/definitions/ExprRef"}]},"strokeDashOffset":{"anyOf":[{"description":"The offset (in pixels) into which to begin drawing with the stroke dash array.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeJoin":{"anyOf":[{"$ref":"#/definitions/StrokeJoin","description":"The stroke line join method. One of `\\"miter\\"`, `\\"round\\"` or `\\"bevel\\"`.\\n\\n__Default value:__ `\\"miter\\"`"},{"$ref":"#/definitions/ExprRef"}]},"strokeMiterLimit":{"anyOf":[{"description":"The miter limit at which to bevel a line join.","type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeOpacity":{"anyOf":[{"description":"The stroke opacity (value between [0,1]).\\n\\n__Default value:__ `1`","maximum":1,"minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]},"strokeWidth":{"anyOf":[{"description":"The stroke width, in pixels.","minimum":0,"type":"number"},{"$ref":"#/definitions/ExprRef"}]}},"type":"object"},"WindowEventType":{"anyOf":[{"$ref":"#/definitions/EventType"},{"type":"string"}]},"WindowFieldDef":{"additionalProperties":false,"properties":{"as":{"$ref":"#/definitions/FieldName","description":"The output name for the window operation."},"field":{"$ref":"#/definitions/FieldName","description":"The data field for which to compute the aggregate or window function. This can be omitted for window functions that do not operate over a field such as `\\"count\\"`, `\\"rank\\"`, `\\"dense_rank\\"`."},"op":{"anyOf":[{"$ref":"#/definitions/AggregateOp"},{"$ref":"#/definitions/WindowOnlyOp"}],"description":"The window or aggregation operation to apply within a window (e.g., `\\"rank\\"`, `\\"lead\\"`, `\\"sum\\"`, `\\"average\\"` or `\\"count\\"`). See the list of all supported operations [here](https://vega.github.io/vega-lite/docs/window.html#ops)."},"param":{"description":"Parameter values for the window functions. Parameter values can be omitted for operations that do not accept a parameter.\\n\\nSee the list of all supported operations and their parameters [here](https://vega.github.io/vega-lite/docs/transforms/window.html).","type":"number"}},"required":["op","as"],"type":"object"},"WindowOnlyOp":{"enum":["row_number","rank","dense_rank","percent_rank","cume_dist","ntile","lag","lead","first_value","last_value","nth_value"],"type":"string"},"WindowTransform":{"additionalProperties":false,"properties":{"frame":{"description":"A frame specification as a two-element array indicating how the sliding window should proceed. The array entries should either be a number indicating the offset from the current data object, or null to indicate unbounded rows preceding or following the current data object. The default value is `[null, 0]`, indicating that the sliding window includes the current object and all preceding objects. The value `[-5, 5]` indicates that the window should include five objects preceding and five objects following the current object. Finally, `[null, null]` indicates that the window frame should always include all data objects. If you this frame and want to assign the same value to add objects, you can use the simpler [join aggregate transform](https://vega.github.io/vega-lite/docs/joinaggregate.html). The only operators affected are the aggregation operations and the `first_value`, `last_value`, and `nth_value` window operations. The other window operations are not affected by this.\\n\\n__Default value:__:  `[null, 0]` (includes the current object and all preceding objects)","items":{"type":["null","number"]},"type":"array"},"groupby":{"description":"The data fields for partitioning the data objects into separate windows. If unspecified, all data points will be in a single window.","items":{"$ref":"#/definitions/FieldName"},"type":"array"},"ignorePeers":{"description":"Indicates if the sliding window frame should ignore peer values (data that are considered identical by the sort criteria). The default is false, causing the window frame to expand to include all peer values. If set to true, the window frame will be defined by offset values only. This setting only affects those operations that depend on the window frame, namely aggregation operations and the first_value, last_value, and nth_value window operations.\\n\\n__Default value:__ `false`","type":"boolean"},"sort":{"description":"A sort field definition for sorting data objects within a window. If two data objects are considered equal by the comparator, they are considered \\"peer\\" values of equal rank. If sort is not specified, the order is undefined: data objects are processed in the order they are observed and none are considered peers (the ignorePeers parameter is ignored and treated as if set to `true`).","items":{"$ref":"#/definitions/SortField"},"type":"array"},"window":{"description":"The definition of the fields in the window, and what calculations to use.","items":{"$ref":"#/definitions/WindowFieldDef"},"type":"array"}},"required":["window"],"type":"object"}}}');

},{}],"sbR1U":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Vega Visualization Specification Language\",\"definitions\":{\"autosize\":{\"oneOf\":[{\"enum\":[\"pad\",\"fit\",\"fit-x\",\"fit-y\",\"none\"],\"default\":\"pad\"},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"pad\",\"fit\",\"fit-x\",\"fit-y\",\"none\"],\"default\":\"pad\"},\"resize\":{\"type\":\"boolean\"},\"contains\":{\"enum\":[\"content\",\"padding\"]}},\"required\":[\"type\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"axis\":{\"type\":\"object\",\"properties\":{\"orient\":{\"oneOf\":[{\"enum\":[\"top\",\"bottom\",\"left\",\"right\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"scale\":{\"type\":\"string\"},\"format\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"object\",\"properties\":{\"year\":{\"type\":\"string\"},\"quarter\":{\"type\":\"string\"},\"month\":{\"type\":\"string\"},\"date\":{\"type\":\"string\"},\"week\":{\"type\":\"string\"},\"day\":{\"type\":\"string\"},\"hours\":{\"type\":\"string\"},\"minutes\":{\"type\":\"string\"},\"seconds\":{\"type\":\"string\"},\"milliseconds\":{\"type\":\"string\"}},\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"formatType\":{\"oneOf\":[{\"enum\":[\"number\",\"time\",\"utc\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"minExtent\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"maxExtent\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"offset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"position\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"bandPosition\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"translate\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"values\":{\"$ref\":\"#/definitions/arrayOrSignal\"},\"zindex\":{\"type\":\"number\"},\"aria\":{\"type\":\"boolean\"},\"description\":{\"type\":\"string\"},\"title\":{\"$ref\":\"#/definitions/textOrSignal\"},\"titlePadding\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleAlign\":{\"oneOf\":[{\"enum\":[\"left\",\"right\",\"center\"]},{\"$ref\":\"#/definitions/alignValue\"}]},\"titleAnchor\":{\"oneOf\":[{\"enum\":[null,\"start\",\"middle\",\"end\"]},{\"$ref\":\"#/definitions/anchorValue\"}]},\"titleAngle\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleX\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleY\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleBaseline\":{\"oneOf\":[{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\",\"line-top\",\"line-bottom\"]},{\"$ref\":\"#/definitions/baselineValue\"}]},\"titleColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"titleFont\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"titleFontSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleFontStyle\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"titleFontWeight\":{\"oneOf\":[{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]},{\"$ref\":\"#/definitions/fontWeightValue\"}]},\"titleLimit\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleLineHeight\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"domain\":{\"type\":\"boolean\"},\"domainCap\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"domainColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"domainDash\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"type\":\"number\"}},{\"$ref\":\"#/definitions/arrayValue\"}]},\"domainDashOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"domainOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"domainWidth\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"ticks\":{\"type\":\"boolean\"},\"tickBand\":{\"$ref\":\"#/definitions/tickBand\"},\"tickCap\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"tickColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"tickDash\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"type\":\"number\"}},{\"$ref\":\"#/definitions/arrayValue\"}]},\"tickDashOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"tickOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"tickOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"tickRound\":{\"oneOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/booleanValue\"}]},\"tickSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"tickWidth\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"tickCount\":{\"$ref\":\"#/definitions/tickCount\"},\"tickExtra\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"tickMinStep\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"grid\":{\"type\":\"boolean\"},\"gridScale\":{\"type\":\"string\"},\"gridCap\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"gridColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"gridDash\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"type\":\"number\"}},{\"$ref\":\"#/definitions/arrayValue\"}]},\"gridDashOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"gridOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"gridWidth\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labels\":{\"type\":\"boolean\"},\"labelAlign\":{\"oneOf\":[{\"enum\":[\"left\",\"right\",\"center\"]},{\"$ref\":\"#/definitions/alignValue\"}]},\"labelBaseline\":{\"oneOf\":[{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\",\"line-top\",\"line-bottom\"]},{\"$ref\":\"#/definitions/baselineValue\"}]},\"labelBound\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"labelFlush\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"labelFlushOffset\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"labelOverlap\":{\"$ref\":\"#/definitions/labelOverlap\"},\"labelAngle\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"labelFont\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"labelFontSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelFontWeight\":{\"oneOf\":[{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]},{\"$ref\":\"#/definitions/fontWeightValue\"}]},\"labelFontStyle\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"labelLimit\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelLineHeight\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelPadding\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelSeparation\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"encode\":{\"type\":\"object\",\"properties\":{\"axis\":{\"$ref\":\"#/definitions/guideEncode\"},\"ticks\":{\"$ref\":\"#/definitions/guideEncode\"},\"labels\":{\"$ref\":\"#/definitions/guideEncode\"},\"title\":{\"$ref\":\"#/definitions/guideEncode\"},\"grid\":{\"$ref\":\"#/definitions/guideEncode\"},\"domain\":{\"$ref\":\"#/definitions/guideEncode\"}},\"additionalProperties\":false}},\"required\":[\"orient\",\"scale\"],\"additionalProperties\":false},\"labelOverlap\":{\"oneOf\":[{\"type\":\"boolean\"},{\"enum\":[\"parity\",\"greedy\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"tickBand\":{\"oneOf\":[{\"enum\":[\"center\",\"extent\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"tickCount\":{\"oneOf\":[{\"type\":\"number\"},{\"enum\":[\"millisecond\",\"second\",\"minute\",\"hour\",\"day\",\"week\",\"month\",\"year\"]},{\"type\":\"object\",\"properties\":{\"interval\":{\"oneOf\":[{\"enum\":[\"millisecond\",\"second\",\"minute\",\"hour\",\"day\",\"week\",\"month\",\"year\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"required\":[\"interval\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"background\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"bind\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"input\":{\"enum\":[\"checkbox\"]},\"element\":{\"$ref\":\"#/definitions/element\"},\"debounce\":{\"type\":\"number\"},\"name\":{\"type\":\"string\"}},\"required\":[\"input\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"input\":{\"enum\":[\"radio\",\"select\"]},\"element\":{\"$ref\":\"#/definitions/element\"},\"options\":{\"type\":\"array\"},\"labels\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"debounce\":{\"type\":\"number\"},\"name\":{\"type\":\"string\"}},\"required\":[\"input\",\"options\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"input\":{\"enum\":[\"range\"]},\"element\":{\"$ref\":\"#/definitions/element\"},\"min\":{\"type\":\"number\"},\"max\":{\"type\":\"number\"},\"step\":{\"type\":\"number\"},\"debounce\":{\"type\":\"number\"},\"name\":{\"type\":\"string\"}},\"required\":[\"input\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"input\":{\"not\":{\"enum\":[\"checkbox\",\"radio\",\"range\",\"select\"]}},\"element\":{\"$ref\":\"#/definitions/element\"},\"debounce\":{\"type\":\"number\"},\"name\":{\"type\":\"string\"}},\"required\":[\"input\"],\"additionalProperties\":true},{\"type\":\"object\",\"properties\":{\"element\":{\"$ref\":\"#/definitions/element\"},\"event\":{\"type\":\"string\"},\"debounce\":{\"type\":\"number\"}},\"required\":[\"element\"],\"additionalProperties\":false}]},\"element\":{\"type\":\"string\"},\"data\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"transform\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/transform\"}},\"on\":{\"$ref\":\"#/definitions/onTrigger\"}},\"required\":[\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"source\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":1}]},\"name\":{\"type\":\"string\"},\"transform\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/transform\"}},\"on\":{\"$ref\":\"#/definitions/onTrigger\"}},\"required\":[\"source\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"url\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"format\":{\"oneOf\":[{\"anyOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}}},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"json\"]},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"property\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"copy\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"csv\",\"tsv\"]},\"header\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"dsv\"]},\"delimiter\":{\"type\":\"string\"},\"header\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"delimiter\"],\"additionalProperties\":false},{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"topojson\"]},\"feature\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"property\":{\"$ref\":\"#/definitions/stringOrSignal\"}},\"required\":[\"type\",\"feature\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"topojson\"]},\"mesh\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"property\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"filter\":{\"enum\":[\"interior\",\"exterior\",null]}},\"required\":[\"type\",\"mesh\"],\"additionalProperties\":false}]}]},{\"$ref\":\"#/definitions/signalRef\"}]},\"async\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"name\":{\"type\":\"string\"},\"transform\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/transform\"}},\"on\":{\"$ref\":\"#/definitions/onTrigger\"}},\"required\":[\"url\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"values\":{\"oneOf\":[{},{\"$ref\":\"#/definitions/signalRef\"}]},\"format\":{\"oneOf\":[{\"anyOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}}},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"json\"]},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"property\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"copy\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"csv\",\"tsv\"]},\"header\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"dsv\"]},\"delimiter\":{\"type\":\"string\"},\"header\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"parse\":{\"oneOf\":[{\"enum\":[\"auto\"]},{\"type\":\"object\",\"properties\":{},\"additionalProperties\":{\"oneOf\":[{\"enum\":[\"boolean\",\"number\",\"date\",\"string\"]},{\"type\":\"string\",\"pattern\":\"^(date|utc):.*$\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"delimiter\"],\"additionalProperties\":false},{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"topojson\"]},\"feature\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"property\":{\"$ref\":\"#/definitions/stringOrSignal\"}},\"required\":[\"type\",\"feature\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"topojson\"]},\"mesh\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"property\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"filter\":{\"enum\":[\"interior\",\"exterior\",null]}},\"required\":[\"type\",\"mesh\"],\"additionalProperties\":false}]}]},{\"$ref\":\"#/definitions/signalRef\"}]},\"async\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"name\":{\"type\":\"string\"},\"transform\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/transform\"}},\"on\":{\"$ref\":\"#/definitions/onTrigger\"}},\"required\":[\"values\",\"name\"],\"additionalProperties\":false}]},\"paramField\":{\"type\":\"object\",\"properties\":{\"field\":{\"type\":\"string\"},\"as\":{\"type\":\"string\"}},\"required\":[\"field\"],\"additionalProperties\":false},\"rule\":{\"type\":\"object\",\"properties\":{\"test\":{\"type\":\"string\"}}},\"encodeEntry\":{\"type\":\"object\",\"properties\":{\"x\":{\"$ref\":\"#/definitions/numberValue\"},\"x2\":{\"$ref\":\"#/definitions/numberValue\"},\"xc\":{\"$ref\":\"#/definitions/numberValue\"},\"width\":{\"$ref\":\"#/definitions/numberValue\"},\"y\":{\"$ref\":\"#/definitions/numberValue\"},\"y2\":{\"$ref\":\"#/definitions/numberValue\"},\"yc\":{\"$ref\":\"#/definitions/numberValue\"},\"height\":{\"$ref\":\"#/definitions/numberValue\"},\"opacity\":{\"$ref\":\"#/definitions/numberValue\"},\"fill\":{\"$ref\":\"#/definitions/colorValue\"},\"fillOpacity\":{\"$ref\":\"#/definitions/numberValue\"},\"stroke\":{\"$ref\":\"#/definitions/colorValue\"},\"strokeOpacity\":{\"$ref\":\"#/definitions/numberValue\"},\"strokeWidth\":{\"$ref\":\"#/definitions/numberValue\"},\"strokeCap\":{\"$ref\":\"#/definitions/strokeCapValue\"},\"strokeDash\":{\"$ref\":\"#/definitions/arrayValue\"},\"strokeDashOffset\":{\"$ref\":\"#/definitions/numberValue\"},\"strokeJoin\":{\"$ref\":\"#/definitions/strokeJoinValue\"},\"strokeMiterLimit\":{\"$ref\":\"#/definitions/numberValue\"},\"blend\":{\"$ref\":\"#/definitions/blendValue\"},\"cursor\":{\"$ref\":\"#/definitions/stringValue\"},\"tooltip\":{\"$ref\":\"#/definitions/anyValue\"},\"zindex\":{\"$ref\":\"#/definitions/numberValue\"},\"description\":{\"$ref\":\"#/definitions/stringValue\"},\"aria\":{\"$ref\":\"#/definitions/booleanValue\"},\"ariaRole\":{\"$ref\":\"#/definitions/stringValue\"},\"ariaRoleDescription\":{\"$ref\":\"#/definitions/stringValue\"},\"clip\":{\"$ref\":\"#/definitions/booleanValue\"},\"strokeForeground\":{\"$ref\":\"#/definitions/booleanValue\"},\"strokeOffset\":{\"$ref\":\"#/definitions/numberValue\"},\"cornerRadius\":{\"$ref\":\"#/definitions/numberValue\"},\"cornerRadiusTopLeft\":{\"$ref\":\"#/definitions/numberValue\"},\"cornerRadiusTopRight\":{\"$ref\":\"#/definitions/numberValue\"},\"cornerRadiusBottomRight\":{\"$ref\":\"#/definitions/numberValue\"},\"cornerRadiusBottomLeft\":{\"$ref\":\"#/definitions/numberValue\"},\"angle\":{\"$ref\":\"#/definitions/numberValue\"},\"size\":{\"$ref\":\"#/definitions/numberValue\"},\"shape\":{\"$ref\":\"#/definitions/stringValue\"},\"path\":{\"$ref\":\"#/definitions/stringValue\"},\"scaleX\":{\"$ref\":\"#/definitions/numberValue\"},\"scaleY\":{\"$ref\":\"#/definitions/numberValue\"},\"innerRadius\":{\"$ref\":\"#/definitions/numberValue\"},\"outerRadius\":{\"$ref\":\"#/definitions/numberValue\"},\"startAngle\":{\"$ref\":\"#/definitions/numberValue\"},\"endAngle\":{\"$ref\":\"#/definitions/numberValue\"},\"padAngle\":{\"$ref\":\"#/definitions/numberValue\"},\"interpolate\":{\"$ref\":\"#/definitions/stringValue\"},\"tension\":{\"$ref\":\"#/definitions/numberValue\"},\"orient\":{\"$ref\":\"#/definitions/directionValue\"},\"defined\":{\"$ref\":\"#/definitions/booleanValue\"},\"url\":{\"$ref\":\"#/definitions/stringValue\"},\"align\":{\"$ref\":\"#/definitions/alignValue\"},\"baseline\":{\"$ref\":\"#/definitions/baselineValue\"},\"aspect\":{\"$ref\":\"#/definitions/booleanValue\"},\"smooth\":{\"$ref\":\"#/definitions/booleanValue\"},\"text\":{\"$ref\":\"#/definitions/textValue\"},\"dir\":{\"$ref\":\"#/definitions/stringValue\"},\"ellipsis\":{\"$ref\":\"#/definitions/stringValue\"},\"limit\":{\"$ref\":\"#/definitions/numberValue\"},\"lineBreak\":{\"$ref\":\"#/definitions/stringValue\"},\"lineHeight\":{\"$ref\":\"#/definitions/numberValue\"},\"dx\":{\"$ref\":\"#/definitions/numberValue\"},\"dy\":{\"$ref\":\"#/definitions/numberValue\"},\"radius\":{\"$ref\":\"#/definitions/numberValue\"},\"theta\":{\"$ref\":\"#/definitions/numberValue\"},\"font\":{\"$ref\":\"#/definitions/stringValue\"},\"fontSize\":{\"$ref\":\"#/definitions/numberValue\"},\"fontWeight\":{\"$ref\":\"#/definitions/fontWeightValue\"},\"fontStyle\":{\"$ref\":\"#/definitions/stringValue\"}},\"additionalProperties\":true},\"encode\":{\"type\":\"object\",\"additionalProperties\":false,\"patternProperties\":{\"^.+$\":{\"$ref\":\"#/definitions/encodeEntry\"}}},\"field\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"datum\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"datum\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"group\":{\"$ref\":\"#/definitions/field\"},\"level\":{\"type\":\"number\"}},\"required\":[\"group\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"parent\":{\"$ref\":\"#/definitions/field\"},\"level\":{\"type\":\"number\"}},\"required\":[\"parent\"],\"additionalProperties\":false}]},\"stringModifiers\":{\"type\":\"object\",\"properties\":{\"scale\":{\"$ref\":\"#/definitions/field\"}}},\"numberModifiers\":{\"type\":\"object\",\"properties\":{\"exponent\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"mult\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"offset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"round\":{\"type\":\"boolean\",\"default\":false},\"scale\":{\"$ref\":\"#/definitions/field\"},\"band\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]},\"extra\":{\"type\":\"boolean\"}}},\"anyValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"blendValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[null,\"multiply\",\"screen\",\"overlay\",\"darken\",\"lighten\",\"color-dodge\",\"color-burn\",\"hard-light\",\"soft-light\",\"difference\",\"exclusion\",\"hue\",\"saturation\",\"color\",\"luminosity\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[null,\"multiply\",\"screen\",\"overlay\",\"darken\",\"lighten\",\"color-dodge\",\"color-burn\",\"hard-light\",\"soft-light\",\"difference\",\"exclusion\",\"hue\",\"saturation\",\"color\",\"luminosity\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"numberValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/numberModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"number\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/numberModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"number\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"stringValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"string\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"string\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"textValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"type\":\"string\"}}]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"type\":\"string\"}}]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"booleanValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"boolean\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"boolean\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"arrayValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"array\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"type\":\"array\"}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"fontWeightValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"anchorValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"start\",\"middle\",\"end\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"start\",\"middle\",\"end\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"alignValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"left\",\"right\",\"center\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"left\",\"right\",\"center\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"baselineValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"directionValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"horizontal\",\"vertical\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"horizontal\",\"vertical\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"orientValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"left\",\"right\",\"top\",\"bottom\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"left\",\"right\",\"top\",\"bottom\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"strokeCapValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"butt\",\"round\",\"square\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"butt\",\"round\",\"square\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"strokeJoinValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"miter\",\"round\",\"bevel\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]}},{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"enum\":[\"miter\",\"round\",\"bevel\"]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]}]},\"baseColorValue\":{\"oneOf\":[{\"allOf\":[{\"$ref\":\"#/definitions/stringModifiers\"},{\"anyOf\":[{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"null\"}]}},\"required\":[\"value\"]},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/field\"}},\"required\":[\"field\"]},{\"type\":\"object\",\"properties\":{\"range\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"boolean\"}]}},\"required\":[\"range\"]}]},{\"type\":\"object\",\"required\":[\"scale\",\"value\"]},{\"type\":\"object\",\"required\":[\"scale\",\"band\"]},{\"type\":\"object\",\"required\":[\"offset\"]}]}]},{\"type\":\"object\",\"properties\":{\"value\":{\"$ref\":\"#/definitions/linearGradient\"}},\"required\":[\"value\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"value\":{\"$ref\":\"#/definitions/radialGradient\"}},\"required\":[\"value\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"gradient\":{\"$ref\":\"#/definitions/field\"},\"start\":{\"type\":\"array\",\"items\":{\"type\":\"number\"},\"minItems\":2,\"maxItems\":2},\"stop\":{\"type\":\"array\",\"items\":{\"type\":\"number\"},\"minItems\":2,\"maxItems\":2},\"count\":{\"type\":\"number\"}},\"required\":[\"gradient\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"color\":{\"oneOf\":[{\"$ref\":\"#/definitions/colorRGB\"},{\"$ref\":\"#/definitions/colorHSL\"},{\"$ref\":\"#/definitions/colorLAB\"},{\"$ref\":\"#/definitions/colorHCL\"}]}},\"required\":[\"color\"],\"additionalProperties\":false}]},\"colorRGB\":{\"type\":\"object\",\"properties\":{\"r\":{\"$ref\":\"#/definitions/numberValue\"},\"g\":{\"$ref\":\"#/definitions/numberValue\"},\"b\":{\"$ref\":\"#/definitions/numberValue\"}},\"required\":[\"r\",\"g\",\"b\"]},\"colorHSL\":{\"type\":\"object\",\"properties\":{\"h\":{\"$ref\":\"#/definitions/numberValue\"},\"s\":{\"$ref\":\"#/definitions/numberValue\"},\"l\":{\"$ref\":\"#/definitions/numberValue\"}},\"required\":[\"h\",\"s\",\"l\"]},\"colorLAB\":{\"type\":\"object\",\"properties\":{\"l\":{\"$ref\":\"#/definitions/numberValue\"},\"a\":{\"$ref\":\"#/definitions/numberValue\"},\"b\":{\"$ref\":\"#/definitions/numberValue\"}},\"required\":[\"l\",\"a\",\"b\"]},\"colorHCL\":{\"type\":\"object\",\"properties\":{\"h\":{\"$ref\":\"#/definitions/numberValue\"},\"c\":{\"$ref\":\"#/definitions/numberValue\"},\"l\":{\"$ref\":\"#/definitions/numberValue\"}},\"required\":[\"h\",\"c\",\"l\"]},\"colorValue\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"allOf\":[{\"$ref\":\"#/definitions/rule\"},{\"$ref\":\"#/definitions/baseColorValue\"}]}},{\"$ref\":\"#/definitions/baseColorValue\"}]},\"gradientStops\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"offset\":{\"type\":\"number\"},\"color\":{\"type\":\"string\"}},\"required\":[\"offset\",\"color\"],\"additionalProperties\":false}},\"linearGradient\":{\"type\":\"object\",\"properties\":{\"gradient\":{\"enum\":[\"linear\"]},\"id\":{\"type\":\"string\"},\"x1\":{\"type\":\"number\"},\"y1\":{\"type\":\"number\"},\"x2\":{\"type\":\"number\"},\"y2\":{\"type\":\"number\"},\"stops\":{\"$ref\":\"#/definitions/gradientStops\"}},\"required\":[\"gradient\",\"stops\"],\"additionalProperties\":false},\"radialGradient\":{\"type\":\"object\",\"properties\":{\"gradient\":{\"enum\":[\"radial\"]},\"id\":{\"type\":\"string\"},\"x1\":{\"type\":\"number\"},\"y1\":{\"type\":\"number\"},\"r1\":{\"type\":\"number\"},\"x2\":{\"type\":\"number\"},\"y2\":{\"type\":\"number\"},\"r2\":{\"type\":\"number\"},\"stops\":{\"$ref\":\"#/definitions/gradientStops\"}},\"required\":[\"gradient\",\"stops\"],\"additionalProperties\":false},\"expr\":{\"type\":\"object\",\"properties\":{\"expr\":{\"type\":\"string\"},\"as\":{\"type\":\"string\"}},\"required\":[\"expr\"]},\"exprString\":{\"type\":\"string\"},\"layout\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"align\":{\"oneOf\":[{\"oneOf\":[{\"enum\":[\"all\",\"each\",\"none\"]},{\"$ref\":\"#/definitions/signalRef\"}]},{\"type\":\"object\",\"properties\":{\"row\":{\"oneOf\":[{\"enum\":[\"all\",\"each\",\"none\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"column\":{\"oneOf\":[{\"enum\":[\"all\",\"each\",\"none\"]},{\"$ref\":\"#/definitions/signalRef\"}]}},\"additionalProperties\":false}]},\"bounds\":{\"oneOf\":[{\"enum\":[\"full\",\"flush\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"center\":{\"oneOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"row\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"column\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"additionalProperties\":false}]},\"columns\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"padding\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"row\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"column\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"additionalProperties\":false}]},\"offset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"rowHeader\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"rowFooter\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"rowTitle\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"columnHeader\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"columnFooter\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"columnTitle\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"additionalProperties\":false}]},\"headerBand\":{\"oneOf\":[{\"$ref\":\"#/definitions/numberOrSignal\"},{\"type\":\"null\"},{\"type\":\"object\",\"properties\":{\"row\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"column\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"additionalProperties\":false}]},\"footerBand\":{\"oneOf\":[{\"$ref\":\"#/definitions/numberOrSignal\"},{\"type\":\"null\"},{\"type\":\"object\",\"properties\":{\"row\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"column\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"additionalProperties\":false}]},\"titleBand\":{\"oneOf\":[{\"$ref\":\"#/definitions/numberOrSignal\"},{\"type\":\"null\"},{\"type\":\"object\",\"properties\":{\"row\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"column\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"additionalProperties\":false}]},\"titleAnchor\":{\"oneOf\":[{\"oneOf\":[{\"enum\":[\"start\",\"end\"]},{\"$ref\":\"#/definitions/signalRef\"}]},{\"type\":\"object\",\"properties\":{\"row\":{\"oneOf\":[{\"enum\":[\"start\",\"end\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"column\":{\"oneOf\":[{\"enum\":[\"start\",\"end\"]},{\"$ref\":\"#/definitions/signalRef\"}]}},\"additionalProperties\":false}]}},\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"guideEncode\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"interactive\":{\"type\":\"boolean\",\"default\":false},\"style\":{\"$ref\":\"#/definitions/style\"}},\"additionalProperties\":false,\"patternProperties\":{\"^(?!interactive|name|style).+$\":{\"$ref\":\"#/definitions/encodeEntry\"}}},\"legend\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"size\":{\"type\":\"string\"},\"shape\":{\"type\":\"string\"},\"fill\":{\"type\":\"string\"},\"stroke\":{\"type\":\"string\"},\"opacity\":{\"type\":\"string\"},\"strokeDash\":{\"type\":\"string\"},\"strokeWidth\":{\"type\":\"string\"},\"type\":{\"enum\":[\"gradient\",\"symbol\"]},\"direction\":{\"enum\":[\"vertical\",\"horizontal\"]},\"orient\":{\"oneOf\":[{\"enum\":[\"none\",\"left\",\"right\",\"top\",\"bottom\",\"top-left\",\"top-right\",\"bottom-left\",\"bottom-right\"],\"default\":\"right\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"tickCount\":{\"$ref\":\"#/definitions/tickCount\"},\"tickMinStep\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"symbolLimit\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"values\":{\"$ref\":\"#/definitions/arrayOrSignal\"},\"zindex\":{\"type\":\"number\"},\"aria\":{\"type\":\"boolean\"},\"description\":{\"type\":\"string\"},\"cornerRadius\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"fillColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"offset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"padding\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"strokeColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"legendX\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"legendY\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"title\":{\"$ref\":\"#/definitions/textOrSignal\"},\"titleAlign\":{\"oneOf\":[{\"enum\":[\"left\",\"right\",\"center\"]},{\"$ref\":\"#/definitions/alignValue\"}]},\"titleAnchor\":{\"oneOf\":[{\"enum\":[null,\"start\",\"middle\",\"end\"]},{\"$ref\":\"#/definitions/anchorValue\"}]},\"titleBaseline\":{\"oneOf\":[{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\",\"line-top\",\"line-bottom\"]},{\"$ref\":\"#/definitions/baselineValue\"}]},\"titleColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"titleFont\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"titleFontSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleFontStyle\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"titleFontWeight\":{\"oneOf\":[{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]},{\"$ref\":\"#/definitions/fontWeightValue\"}]},\"titleLimit\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleLineHeight\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"titleOrient\":{\"oneOf\":[{\"enum\":[\"left\",\"right\",\"top\",\"bottom\"]},{\"$ref\":\"#/definitions/orientValue\"}]},\"titlePadding\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"gradientLength\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"gradientOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"gradientStrokeColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"gradientStrokeWidth\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"gradientThickness\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"clipHeight\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"columns\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"columnPadding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"rowPadding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"gridAlign\":{\"oneOf\":[{\"enum\":[\"all\",\"each\",\"none\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"symbolDash\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"type\":\"number\"}},{\"$ref\":\"#/definitions/arrayValue\"}]},\"symbolDashOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"symbolFillColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"symbolOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"symbolOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"symbolSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"symbolStrokeColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"symbolStrokeWidth\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"symbolType\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"format\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"object\",\"properties\":{\"year\":{\"type\":\"string\"},\"quarter\":{\"type\":\"string\"},\"month\":{\"type\":\"string\"},\"date\":{\"type\":\"string\"},\"week\":{\"type\":\"string\"},\"day\":{\"type\":\"string\"},\"hours\":{\"type\":\"string\"},\"minutes\":{\"type\":\"string\"},\"seconds\":{\"type\":\"string\"},\"milliseconds\":{\"type\":\"string\"}},\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"formatType\":{\"oneOf\":[{\"enum\":[\"number\",\"time\",\"utc\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"labelAlign\":{\"oneOf\":[{\"enum\":[\"left\",\"right\",\"center\"]},{\"$ref\":\"#/definitions/alignValue\"}]},\"labelBaseline\":{\"oneOf\":[{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\",\"line-top\",\"line-bottom\"]},{\"$ref\":\"#/definitions/baselineValue\"}]},\"labelColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"labelFont\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"labelFontSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelFontStyle\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"labelFontWeight\":{\"oneOf\":[{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]},{\"$ref\":\"#/definitions/fontWeightValue\"}]},\"labelLimit\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelOffset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelOpacity\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"labelOverlap\":{\"$ref\":\"#/definitions/labelOverlap\"},\"labelSeparation\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"encode\":{\"type\":\"object\",\"properties\":{\"title\":{\"$ref\":\"#/definitions/guideEncode\"},\"labels\":{\"$ref\":\"#/definitions/guideEncode\"},\"legend\":{\"$ref\":\"#/definitions/guideEncode\"},\"entries\":{\"$ref\":\"#/definitions/guideEncode\"},\"symbols\":{\"$ref\":\"#/definitions/guideEncode\"},\"gradient\":{\"$ref\":\"#/definitions/guideEncode\"}},\"additionalProperties\":false}},\"additionalProperties\":false},{\"anyOf\":[{\"type\":\"object\",\"required\":[\"size\"]},{\"type\":\"object\",\"required\":[\"shape\"]},{\"type\":\"object\",\"required\":[\"fill\"]},{\"type\":\"object\",\"required\":[\"stroke\"]},{\"type\":\"object\",\"required\":[\"opacity\"]},{\"type\":\"object\",\"required\":[\"strokeDash\"]},{\"type\":\"object\",\"required\":[\"strokeWidth\"]}]}]},\"compare\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/expr\"}]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"field\":{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"order\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/sortOrder\"}}},\"additionalProperties\":false}]},\"from\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"}},\"additionalProperties\":false},\"facet\":{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"facet\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"data\":{\"type\":\"string\"},\"field\":{\"type\":\"string\"}},\"required\":[\"name\",\"data\",\"field\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"data\":{\"type\":\"string\"},\"groupby\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"type\":\"string\"}}]},\"aggregate\":{\"type\":\"object\",\"properties\":{\"cross\":{\"type\":\"boolean\"},\"fields\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"ops\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}},\"as\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}}},\"additionalProperties\":false}},\"required\":[\"name\",\"data\",\"groupby\"],\"additionalProperties\":false}]}},\"required\":[\"facet\"],\"additionalProperties\":false},\"mark\":{\"type\":\"object\",\"properties\":{\"type\":{\"$ref\":\"#/definitions/marktype\"},\"role\":{\"type\":\"string\"},\"name\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"aria\":{\"type\":\"boolean\"},\"style\":{\"$ref\":\"#/definitions/style\"},\"key\":{\"type\":\"string\"},\"clip\":{\"$ref\":\"#/definitions/markclip\"},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"interactive\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"encode\":{\"$ref\":\"#/definitions/encode\"},\"transform\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/transformMark\"}},\"on\":{\"$ref\":\"#/definitions/onMarkTrigger\"}},\"required\":[\"type\"]},\"markclip\":{\"oneOf\":[{\"$ref\":\"#/definitions/booleanOrSignal\"},{\"type\":\"object\",\"properties\":{\"path\":{\"$ref\":\"#/definitions/stringOrSignal\"}},\"required\":[\"path\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"sphere\":{\"$ref\":\"#/definitions/stringOrSignal\"}},\"required\":[\"sphere\"],\"additionalProperties\":false}]},\"markGroup\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"group\"]},\"from\":{\"oneOf\":[{\"$ref\":\"#/definitions/from\"},{\"$ref\":\"#/definitions/facet\"}]}},\"required\":[\"type\"]},{\"$ref\":\"#/definitions/mark\"},{\"$ref\":\"#/definitions/scope\"}]},\"markVisual\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"not\":{\"enum\":[\"group\"]}},\"from\":{\"$ref\":\"#/definitions/from\"}}},{\"$ref\":\"#/definitions/mark\"}]},\"style\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"type\":\"string\"}}]},\"marktype\":{\"type\":\"string\"},\"listener\":{\"oneOf\":[{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"scale\":{\"type\":\"string\"}},\"required\":[\"scale\"]},{\"$ref\":\"#/definitions/stream\"}]},\"onEvents\":{\"type\":\"array\",\"items\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"events\":{\"oneOf\":[{\"$ref\":\"#/definitions/selector\"},{\"$ref\":\"#/definitions/listener\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/listener\"},\"minItems\":1}]},\"force\":{\"type\":\"boolean\"}},\"required\":[\"events\"]},{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"encode\":{\"type\":\"string\"}},\"required\":[\"encode\"]},{\"type\":\"object\",\"properties\":{\"update\":{\"oneOf\":[{\"$ref\":\"#/definitions/exprString\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"value\":{}},\"required\":[\"value\"]}]}},\"required\":[\"update\"]}]}]}},\"onTrigger\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"trigger\":{\"$ref\":\"#/definitions/exprString\"},\"insert\":{\"$ref\":\"#/definitions/exprString\"},\"remove\":{\"oneOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/exprString\"}]},\"toggle\":{\"$ref\":\"#/definitions/exprString\"},\"modify\":{\"$ref\":\"#/definitions/exprString\"},\"values\":{\"$ref\":\"#/definitions/exprString\"}},\"required\":[\"trigger\"],\"additionalProperties\":false}},\"onMarkTrigger\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"trigger\":{\"$ref\":\"#/definitions/exprString\"},\"modify\":{\"$ref\":\"#/definitions/exprString\"},\"values\":{\"$ref\":\"#/definitions/exprString\"}},\"required\":[\"trigger\"],\"additionalProperties\":false}},\"padding\":{\"oneOf\":[{\"type\":\"number\"},{\"type\":\"object\",\"properties\":{\"top\":{\"type\":\"number\"},\"bottom\":{\"type\":\"number\"},\"left\":{\"type\":\"number\"},\"right\":{\"type\":\"number\"}},\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"projection\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"type\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"clipAngle\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"clipExtent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"scale\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"translate\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"center\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"rotate\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":3},{\"$ref\":\"#/definitions/signalRef\"}]},\"parallels\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"precision\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"pointRadius\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"fit\":{\"oneOf\":[{\"type\":\"object\"},{\"type\":\"array\"}]},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"name\"],\"additionalProperties\":true},\"scale\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"identity\"]},\"nice\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"ordinal\"]},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"sort\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"op\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false}]}},\"required\":[\"data\",\"field\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"fields\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"minItems\":1},\"sort\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"object\",\"properties\":{\"op\":{\"enum\":[\"count\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"op\":{\"enum\":[\"count\",\"min\",\"max\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"required\":[\"field\",\"op\"],\"additionalProperties\":false}]}},\"required\":[\"data\",\"fields\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"fields\":{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"}},\"required\":[\"data\",\"field\"],\"additionalProperties\":false},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"number\"},{\"type\":\"boolean\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"minItems\":1},\"sort\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"object\",\"properties\":{\"op\":{\"enum\":[\"count\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"op\":{\"enum\":[\"count\",\"min\",\"max\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"required\":[\"field\",\"op\"],\"additionalProperties\":false}]}},\"required\":[\"fields\"],\"additionalProperties\":false}]},{\"$ref\":\"#/definitions/signalRef\"}]},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"domainImplicit\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"band\"]},\"paddingInner\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"step\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"required\":[\"step\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"paddingOuter\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"align\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"point\"]},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"step\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"required\":[\"step\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"paddingOuter\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"align\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"quantize\",\"threshold\"]},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"nice\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"zero\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"quantile\"]},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"bin-ordinal\"]},\"bins\":{\"$ref\":\"#/definitions/scaleBins\"},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"time\",\"utc\"]},\"nice\":{\"oneOf\":[{\"type\":\"boolean\"},{\"enum\":[\"millisecond\",\"second\",\"minute\",\"hour\",\"day\",\"week\",\"month\",\"year\"]},{\"type\":\"object\",\"properties\":{\"interval\":{\"oneOf\":[{\"enum\":[\"millisecond\",\"second\",\"minute\",\"hour\",\"day\",\"week\",\"month\",\"year\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"required\":[\"interval\"],\"additionalProperties\":false}]},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"bins\":{\"$ref\":\"#/definitions/scaleBins\"},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"clamp\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"linear\",\"sqrt\",\"sequential\"]},\"nice\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"zero\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"bins\":{\"$ref\":\"#/definitions/scaleBins\"},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"clamp\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"log\"]},\"base\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"nice\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"zero\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"bins\":{\"$ref\":\"#/definitions/scaleBins\"},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"clamp\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"pow\"]},\"exponent\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"nice\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"zero\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"bins\":{\"$ref\":\"#/definitions/scaleBins\"},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"clamp\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"symlog\"]},\"constant\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"nice\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"zero\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"range\":{\"oneOf\":[{\"enum\":[\"width\",\"height\",\"symbol\",\"category\",\"ordinal\",\"ramp\",\"diverging\",\"heatmap\"]},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"type\":\"object\",\"properties\":{\"scheme\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"minItems\":2,\"maxItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"scheme\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"bins\":{\"$ref\":\"#/definitions/scaleBins\"},\"interpolate\":{\"$ref\":\"#/definitions/scaleInterpolate\"},\"clamp\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"padding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"name\":{\"type\":\"string\"},\"domain\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"boolean\"},{\"type\":\"string\"},{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}}]}},{\"$ref\":\"#/definitions/scaleData\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"domainMin\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMax\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainMid\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"domainRaw\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"reverse\":{\"$ref\":\"#/definitions/booleanOrSignal\"},\"round\":{\"$ref\":\"#/definitions/booleanOrSignal\"}},\"required\":[\"type\",\"name\"],\"additionalProperties\":false}]},\"scaleField\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"sortOrder\":{\"oneOf\":[{\"enum\":[\"ascending\",\"descending\"]},{\"$ref\":\"#/definitions/signalRef\"}]},\"scaleBins\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/numberOrSignal\"}},{\"type\":\"object\",\"properties\":{\"step\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"start\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"stop\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"required\":[\"step\"],\"additionalProperties\":false},{\"$ref\":\"#/definitions/signalRef\"}]},\"scaleInterpolate\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"object\",\"properties\":{\"type\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"gamma\":{\"$ref\":\"#/definitions/numberOrSignal\"}},\"required\":[\"type\"],\"additionalProperties\":false}]},\"scaleData\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"sort\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"op\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false}]}},\"required\":[\"data\",\"field\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"fields\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"minItems\":1},\"sort\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"object\",\"properties\":{\"op\":{\"enum\":[\"count\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"op\":{\"enum\":[\"count\",\"min\",\"max\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"required\":[\"field\",\"op\"],\"additionalProperties\":false}]}},\"required\":[\"data\",\"fields\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"fields\":{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"string\"},\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"}},\"required\":[\"data\",\"field\"],\"additionalProperties\":false},{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"number\"},{\"type\":\"boolean\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"minItems\":1},\"sort\":{\"oneOf\":[{\"type\":\"boolean\"},{\"type\":\"object\",\"properties\":{\"op\":{\"enum\":[\"count\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"field\":{\"$ref\":\"#/definitions/stringOrSignal\"},\"op\":{\"enum\":[\"count\",\"min\",\"max\"]},\"order\":{\"$ref\":\"#/definitions/sortOrder\"}},\"required\":[\"field\",\"op\"],\"additionalProperties\":false}]}},\"required\":[\"fields\"],\"additionalProperties\":false}]},\"scope\":{\"type\":\"object\",\"properties\":{\"encode\":{\"$ref\":\"#/definitions/encode\"},\"layout\":{\"$ref\":\"#/definitions/layout\"},\"signals\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/signal\"}},\"data\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/data\"}},\"scales\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/scale\"}},\"projections\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/projection\"}},\"axes\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/axis\"}},\"legends\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/legend\"}},\"title\":{\"$ref\":\"#/definitions/title\"},\"marks\":{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/markGroup\"},{\"$ref\":\"#/definitions/markVisual\"}]}},\"usermeta\":{\"type\":\"object\"}}},\"selector\":{\"type\":\"string\"},\"signal\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"name\":{\"$ref\":\"#/definitions/signalName\"},\"description\":{\"type\":\"string\"},\"push\":{\"enum\":[\"outer\"]},\"on\":{\"$ref\":\"#/definitions/onEvents\"}},\"required\":[\"name\",\"push\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"name\":{\"$ref\":\"#/definitions/signalName\"},\"description\":{\"type\":\"string\"},\"value\":{},\"react\":{\"type\":\"boolean\",\"default\":true},\"update\":{\"$ref\":\"#/definitions/exprString\"},\"on\":{\"$ref\":\"#/definitions/onEvents\"},\"bind\":{\"$ref\":\"#/definitions/bind\"}},\"required\":[\"name\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"name\":{\"$ref\":\"#/definitions/signalName\"},\"description\":{\"type\":\"string\"},\"value\":{},\"init\":{\"$ref\":\"#/definitions/exprString\"},\"on\":{\"$ref\":\"#/definitions/onEvents\"},\"bind\":{\"$ref\":\"#/definitions/bind\"}},\"required\":[\"name\",\"init\"],\"additionalProperties\":false}]},\"signalName\":{\"type\":\"string\",\"not\":{\"enum\":[\"parent\",\"datum\",\"event\",\"item\"]}},\"signalRef\":{\"type\":\"object\",\"properties\":{\"signal\":{\"type\":\"string\"}},\"required\":[\"signal\"]},\"arrayOrSignal\":{\"oneOf\":[{\"type\":\"array\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"booleanOrSignal\":{\"oneOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"numberOrSignal\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"stringOrSignal\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"textOrSignal\":{\"oneOf\":[{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"array\",\"items\":{\"type\":\"string\"}}]},{\"$ref\":\"#/definitions/signalRef\"}]},\"stream\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"between\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/stream\"},\"minItems\":2,\"maxItems\":2},\"marktype\":{\"type\":\"string\"},\"markname\":{\"type\":\"string\"},\"filter\":{\"oneOf\":[{\"$ref\":\"#/definitions/exprString\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/exprString\"},\"minItems\":1}]},\"throttle\":{\"type\":\"number\"},\"debounce\":{\"type\":\"number\"},\"consume\":{\"type\":\"boolean\"}}},{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\"},\"source\":{\"type\":\"string\"}},\"required\":[\"type\"]},{\"type\":\"object\",\"properties\":{\"stream\":{\"$ref\":\"#/definitions/stream\"}},\"required\":[\"stream\"]},{\"type\":\"object\",\"properties\":{\"merge\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/stream\"},\"minItems\":1}},\"required\":[\"merge\"]}]}]},\"title\":{\"oneOf\":[{\"type\":\"string\"},{\"type\":\"object\",\"properties\":{\"orient\":{\"oneOf\":[{\"enum\":[\"none\",\"left\",\"right\",\"top\",\"bottom\"],\"default\":\"top\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"anchor\":{\"oneOf\":[{\"enum\":[null,\"start\",\"middle\",\"end\"]},{\"$ref\":\"#/definitions/anchorValue\"}]},\"frame\":{\"oneOf\":[{\"enum\":[\"group\",\"bounds\"]},{\"$ref\":\"#/definitions/stringValue\"}]},\"offset\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"aria\":{\"type\":\"boolean\"},\"limit\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"zindex\":{\"type\":\"number\"},\"align\":{\"oneOf\":[{\"enum\":[\"left\",\"right\",\"center\"]},{\"$ref\":\"#/definitions/alignValue\"}]},\"angle\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"baseline\":{\"oneOf\":[{\"enum\":[\"top\",\"middle\",\"bottom\",\"alphabetic\",\"line-top\",\"line-bottom\"]},{\"$ref\":\"#/definitions/baselineValue\"}]},\"dx\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"dy\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"text\":{\"$ref\":\"#/definitions/textOrSignal\"},\"color\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"font\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"fontSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"fontStyle\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"fontWeight\":{\"oneOf\":[{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]},{\"$ref\":\"#/definitions/fontWeightValue\"}]},\"lineHeight\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"subtitle\":{\"$ref\":\"#/definitions/textOrSignal\"},\"subtitleColor\":{\"oneOf\":[{\"type\":\"null\"},{\"type\":\"string\"},{\"$ref\":\"#/definitions/colorValue\"}]},\"subtitleFont\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"subtitleFontSize\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"subtitleFontStyle\":{\"oneOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/stringValue\"}]},\"subtitleFontWeight\":{\"oneOf\":[{\"enum\":[null,\"normal\",\"bold\",\"lighter\",\"bolder\",\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\",100,200,300,400,500,600,700,800,900]},{\"$ref\":\"#/definitions/fontWeightValue\"}]},\"subtitleLineHeight\":{\"oneOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/numberValue\"}]},\"subtitlePadding\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"encode\":{\"anyOf\":[{\"type\":\"object\",\"additionalProperties\":false,\"patternProperties\":{\"^(?!interactive|name|style).+$\":{\"$ref\":\"#/definitions/encodeEntry\"}}},{\"type\":\"object\",\"properties\":{\"group\":{\"$ref\":\"#/definitions/guideEncode\"},\"title\":{\"$ref\":\"#/definitions/guideEncode\"},\"subtitle\":{\"$ref\":\"#/definitions/guideEncode\"}},\"additionalProperties\":false}]},\"name\":{\"type\":\"string\"},\"interactive\":{\"type\":\"boolean\"},\"style\":{\"$ref\":\"#/definitions/style\"}},\"additionalProperties\":false}]},\"transform\":{\"oneOf\":[{\"$ref\":\"#/definitions/crossfilterTransform\"},{\"$ref\":\"#/definitions/resolvefilterTransform\"},{\"$ref\":\"#/definitions/linkpathTransform\"},{\"$ref\":\"#/definitions/pieTransform\"},{\"$ref\":\"#/definitions/stackTransform\"},{\"$ref\":\"#/definitions/forceTransform\"},{\"$ref\":\"#/definitions/contourTransform\"},{\"$ref\":\"#/definitions/geojsonTransform\"},{\"$ref\":\"#/definitions/geopathTransform\"},{\"$ref\":\"#/definitions/geopointTransform\"},{\"$ref\":\"#/definitions/geoshapeTransform\"},{\"$ref\":\"#/definitions/graticuleTransform\"},{\"$ref\":\"#/definitions/heatmapTransform\"},{\"$ref\":\"#/definitions/isocontourTransform\"},{\"$ref\":\"#/definitions/kde2dTransform\"},{\"$ref\":\"#/definitions/nestTransform\"},{\"$ref\":\"#/definitions/packTransform\"},{\"$ref\":\"#/definitions/partitionTransform\"},{\"$ref\":\"#/definitions/stratifyTransform\"},{\"$ref\":\"#/definitions/treeTransform\"},{\"$ref\":\"#/definitions/treelinksTransform\"},{\"$ref\":\"#/definitions/treemapTransform\"},{\"$ref\":\"#/definitions/labelTransform\"},{\"$ref\":\"#/definitions/loessTransform\"},{\"$ref\":\"#/definitions/regressionTransform\"},{\"$ref\":\"#/definitions/aggregateTransform\"},{\"$ref\":\"#/definitions/binTransform\"},{\"$ref\":\"#/definitions/collectTransform\"},{\"$ref\":\"#/definitions/countpatternTransform\"},{\"$ref\":\"#/definitions/crossTransform\"},{\"$ref\":\"#/definitions/densityTransform\"},{\"$ref\":\"#/definitions/dotbinTransform\"},{\"$ref\":\"#/definitions/extentTransform\"},{\"$ref\":\"#/definitions/filterTransform\"},{\"$ref\":\"#/definitions/flattenTransform\"},{\"$ref\":\"#/definitions/foldTransform\"},{\"$ref\":\"#/definitions/formulaTransform\"},{\"$ref\":\"#/definitions/imputeTransform\"},{\"$ref\":\"#/definitions/joinaggregateTransform\"},{\"$ref\":\"#/definitions/kdeTransform\"},{\"$ref\":\"#/definitions/lookupTransform\"},{\"$ref\":\"#/definitions/pivotTransform\"},{\"$ref\":\"#/definitions/projectTransform\"},{\"$ref\":\"#/definitions/quantileTransform\"},{\"$ref\":\"#/definitions/sampleTransform\"},{\"$ref\":\"#/definitions/sequenceTransform\"},{\"$ref\":\"#/definitions/timeunitTransform\"},{\"$ref\":\"#/definitions/windowTransform\"},{\"$ref\":\"#/definitions/identifierTransform\"},{\"$ref\":\"#/definitions/voronoiTransform\"},{\"$ref\":\"#/definitions/wordcloudTransform\"}]},\"transformMark\":{\"oneOf\":[{\"$ref\":\"#/definitions/crossfilterTransform\"},{\"$ref\":\"#/definitions/resolvefilterTransform\"},{\"$ref\":\"#/definitions/linkpathTransform\"},{\"$ref\":\"#/definitions/pieTransform\"},{\"$ref\":\"#/definitions/stackTransform\"},{\"$ref\":\"#/definitions/forceTransform\"},{\"$ref\":\"#/definitions/geojsonTransform\"},{\"$ref\":\"#/definitions/geopathTransform\"},{\"$ref\":\"#/definitions/geopointTransform\"},{\"$ref\":\"#/definitions/geoshapeTransform\"},{\"$ref\":\"#/definitions/heatmapTransform\"},{\"$ref\":\"#/definitions/packTransform\"},{\"$ref\":\"#/definitions/partitionTransform\"},{\"$ref\":\"#/definitions/stratifyTransform\"},{\"$ref\":\"#/definitions/treeTransform\"},{\"$ref\":\"#/definitions/treemapTransform\"},{\"$ref\":\"#/definitions/labelTransform\"},{\"$ref\":\"#/definitions/binTransform\"},{\"$ref\":\"#/definitions/collectTransform\"},{\"$ref\":\"#/definitions/dotbinTransform\"},{\"$ref\":\"#/definitions/extentTransform\"},{\"$ref\":\"#/definitions/formulaTransform\"},{\"$ref\":\"#/definitions/joinaggregateTransform\"},{\"$ref\":\"#/definitions/lookupTransform\"},{\"$ref\":\"#/definitions/sampleTransform\"},{\"$ref\":\"#/definitions/timeunitTransform\"},{\"$ref\":\"#/definitions/windowTransform\"},{\"$ref\":\"#/definitions/identifierTransform\"},{\"$ref\":\"#/definitions/voronoiTransform\"},{\"$ref\":\"#/definitions/wordcloudTransform\"}]},\"crossfilterTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"crossfilter\"]},\"signal\":{\"type\":\"string\"},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"query\":{\"oneOf\":[{\"type\":\"array\",\"items\":{}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"fields\",\"query\"],\"additionalProperties\":false},\"resolvefilterTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"resolvefilter\"]},\"signal\":{\"type\":\"string\"},\"ignore\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"filter\":{}},\"required\":[\"type\",\"ignore\",\"filter\"],\"additionalProperties\":false},\"linkpathTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"linkpath\"]},\"signal\":{\"type\":\"string\"},\"sourceX\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}],\"default\":\"source.x\"},\"sourceY\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}],\"default\":\"source.y\"},\"targetX\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}],\"default\":\"target.x\"},\"targetY\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}],\"default\":\"target.y\"},\"orient\":{\"anyOf\":[{\"enum\":[\"horizontal\",\"vertical\",\"radial\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"vertical\"},\"shape\":{\"anyOf\":[{\"enum\":[\"line\",\"arc\",\"curve\",\"diagonal\",\"orthogonal\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"line\"},\"require\":{\"$ref\":\"#/definitions/signalRef\"},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"path\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"pieTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"pie\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"startAngle\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"endAngle\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":6.283185307179586},\"sort\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"startAngle\",\"endAngle\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"stackTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"stack\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"offset\":{\"anyOf\":[{\"enum\":[\"zero\",\"center\",\"normalize\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"zero\"},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"y0\",\"y1\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"forceTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"force\"]},\"signal\":{\"type\":\"string\"},\"static\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"restart\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"iterations\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":300},\"alpha\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1},\"alphaMin\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.001},\"alphaTarget\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"velocityDecay\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.4},\"forces\":{\"type\":\"array\",\"items\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"force\":{\"enum\":[\"center\"]},\"x\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"y\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"force\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"force\":{\"enum\":[\"collide\"]},\"radius\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"strength\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.7},\"iterations\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1}},\"required\":[\"force\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"force\":{\"enum\":[\"nbody\"]},\"strength\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}],\"default\":-30},\"theta\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.9},\"distanceMin\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1},\"distanceMax\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"force\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"force\":{\"enum\":[\"link\"]},\"links\":{\"type\":\"string\"},\"id\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"distance\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}],\"default\":30},\"strength\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"iterations\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1}},\"required\":[\"force\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"force\":{\"enum\":[\"x\"]},\"strength\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.1},\"x\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"force\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"force\":{\"enum\":[\"y\"]},\"strength\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.1},\"y\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"force\"],\"additionalProperties\":false}]}},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x\",\"y\",\"vx\",\"vy\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"contourTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"contour\"]},\"signal\":{\"type\":\"string\"},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"values\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"x\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"y\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"weight\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"cellSize\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"bandwidth\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"count\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"nice\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"thresholds\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"smooth\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true}},\"required\":[\"type\",\"size\"],\"additionalProperties\":false},\"geojsonTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"geojson\"]},\"signal\":{\"type\":\"string\"},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"geojson\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},\"geopathTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"geopath\"]},\"signal\":{\"type\":\"string\"},\"projection\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"pointRadius\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"path\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"geopointTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"geopoint\"]},\"signal\":{\"type\":\"string\"},\"projection\":{\"type\":\"string\"},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x\",\"y\"]}},\"required\":[\"type\",\"projection\",\"fields\"],\"additionalProperties\":false},\"geoshapeTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"geoshape\"]},\"signal\":{\"type\":\"string\"},\"projection\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}],\"default\":\"datum\"},\"pointRadius\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"shape\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"graticuleTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"graticule\"]},\"signal\":{\"type\":\"string\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"extentMajor\":{\"oneOf\":[{\"type\":\"array\",\"items\":{},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"extentMinor\":{\"oneOf\":[{\"type\":\"array\",\"items\":{},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"stepMajor\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[90,360]},\"stepMinor\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[10,10]},\"precision\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":2.5}},\"required\":[\"type\"],\"additionalProperties\":false},\"heatmapTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"heatmap\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"color\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"opacity\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"resolve\":{\"anyOf\":[{\"enum\":[\"shared\",\"independent\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"independent\"},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"image\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"isocontourTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"isocontour\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"thresholds\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"levels\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"nice\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"resolve\":{\"anyOf\":[{\"enum\":[\"shared\",\"independent\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"independent\"},\"zero\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"smooth\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"scale\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"translate\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}],\"default\":\"contour\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"kde2dTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"kde2d\"]},\"signal\":{\"type\":\"string\"},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"x\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"y\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"weight\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"cellSize\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"bandwidth\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"counts\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"grid\"}},\"required\":[\"type\",\"size\",\"x\",\"y\"],\"additionalProperties\":false},\"nestTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"nest\"]},\"signal\":{\"type\":\"string\"},\"keys\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"generate\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},\"packTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"pack\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"padding\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"radius\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":5,\"minItems\":5},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x\",\"y\",\"r\",\"depth\",\"children\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"partitionTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"partition\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"padding\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"round\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":6,\"minItems\":6},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x0\",\"y0\",\"x1\",\"y1\",\"depth\",\"children\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"stratifyTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"stratify\"]},\"signal\":{\"type\":\"string\"},\"key\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"parentKey\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"type\",\"key\",\"parentKey\"],\"additionalProperties\":false},\"treeTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"tree\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"method\":{\"anyOf\":[{\"enum\":[\"tidy\",\"cluster\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"tidy\"},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"nodeSize\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"separation\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":4,\"minItems\":4},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x\",\"y\",\"depth\",\"children\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"treelinksTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"treelinks\"]},\"signal\":{\"type\":\"string\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"treemapTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"treemap\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"method\":{\"anyOf\":[{\"enum\":[\"squarify\",\"resquarify\",\"binary\",\"dice\",\"slice\",\"slicedice\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"squarify\"},\"padding\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"paddingInner\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"paddingOuter\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"paddingTop\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"paddingRight\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"paddingBottom\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"paddingLeft\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"ratio\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1.618033988749895},\"round\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":6,\"minItems\":6},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x0\",\"y0\",\"x1\",\"y1\",\"depth\",\"children\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"labelTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"label\"]},\"signal\":{\"type\":\"string\"},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"anchor\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"top-left\",\"left\",\"bottom-left\",\"top\",\"bottom\",\"top-right\",\"right\",\"bottom-right\"]},\"offset\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[1]},\"padding\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]},\"lineAnchor\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"end\"},\"markIndex\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"avoidBaseMark\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"avoidMarks\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"type\":\"string\"}},{\"$ref\":\"#/definitions/signalRef\"}]},\"method\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"naive\"},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":5,\"minItems\":5},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x\",\"y\",\"opacity\",\"align\",\"baseline\"]}},\"required\":[\"type\",\"size\"],\"additionalProperties\":false},\"loessTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"loess\"]},\"signal\":{\"type\":\"string\"},\"x\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"y\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"bandwidth\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.3},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"x\",\"y\"],\"additionalProperties\":false},\"regressionTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"regression\"]},\"signal\":{\"type\":\"string\"},\"x\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"y\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"method\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"linear\"},\"order\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":3},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"params\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"x\",\"y\"],\"additionalProperties\":false},\"aggregateTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"aggregate\"]},\"signal\":{\"type\":\"string\"},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"ops\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"enum\":[\"values\",\"count\",\"missing\",\"valid\",\"sum\",\"product\",\"mean\",\"average\",\"variance\",\"variancep\",\"stdev\",\"stdevp\",\"stderr\",\"distinct\",\"ci0\",\"ci1\",\"median\",\"q1\",\"q3\",\"min\",\"max\",\"argmin\",\"argmax\",\"exponential\",\"exponentialb\"]},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"aggregate_params\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"drop\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"cross\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"key\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},\"binTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"bin\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"interval\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"anchor\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxbins\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":20},\"base\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":10},\"divide\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[5,2]},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"span\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"steps\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"minstep\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"nice\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"name\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"bin0\",\"bin1\"]}},\"required\":[\"type\",\"field\",\"extent\"],\"additionalProperties\":false},\"collectTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"collect\"]},\"signal\":{\"type\":\"string\"},\"sort\":{\"$ref\":\"#/definitions/compare\"}},\"required\":[\"type\"],\"additionalProperties\":false},\"countpatternTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"countpattern\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"case\":{\"anyOf\":[{\"enum\":[\"upper\",\"lower\",\"mixed\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"mixed\"},\"pattern\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"[\\\\w\\\"]+\"},\"stopwords\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"text\",\"count\"]}},\"required\":[\"type\",\"field\"],\"additionalProperties\":false},\"crossTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"cross\"]},\"signal\":{\"type\":\"string\"},\"filter\":{\"$ref\":\"#/definitions/exprString\"},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"a\",\"b\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"densityTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"density\"]},\"signal\":{\"type\":\"string\"},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"steps\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"minsteps\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":25},\"maxsteps\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":200},\"method\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"pdf\"},\"distribution\":{\"oneOf\":[{\"type\":\"object\",\"properties\":{\"function\":{\"enum\":[\"normal\"]},\"mean\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"stdev\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1}},\"required\":[\"function\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"function\":{\"enum\":[\"lognormal\"]},\"mean\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"stdev\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1}},\"required\":[\"function\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"function\":{\"enum\":[\"uniform\"]},\"min\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"max\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1}},\"required\":[\"function\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"function\":{\"enum\":[\"kde\"]},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"from\":{\"type\":\"string\"},\"bandwidth\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"function\",\"field\"],\"additionalProperties\":false},{\"type\":\"object\",\"properties\":{\"function\":{\"enum\":[\"mixture\"]},\"distributions\":{\"oneOf\":[{\"type\":\"array\",\"items\":{}},{\"$ref\":\"#/definitions/signalRef\"}]},\"weights\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"function\"],\"additionalProperties\":false}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"value\",\"density\"]}},\"required\":[\"type\"],\"additionalProperties\":false},\"dotbinTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"dotbin\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"smooth\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"bin\"}},\"required\":[\"type\",\"field\"],\"additionalProperties\":false},\"extentTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"extent\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"type\",\"field\"],\"additionalProperties\":false},\"filterTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"filter\"]},\"signal\":{\"type\":\"string\"},\"expr\":{\"$ref\":\"#/definitions/exprString\"}},\"required\":[\"type\",\"expr\"],\"additionalProperties\":false},\"flattenTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"flatten\"]},\"signal\":{\"type\":\"string\"},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"index\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"fields\"],\"additionalProperties\":false},\"foldTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"fold\"]},\"signal\":{\"type\":\"string\"},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"key\",\"value\"]}},\"required\":[\"type\",\"fields\"],\"additionalProperties\":false},\"formulaTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"formula\"]},\"signal\":{\"type\":\"string\"},\"expr\":{\"$ref\":\"#/definitions/exprString\"},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"initonly\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"expr\",\"as\"],\"additionalProperties\":false},\"imputeTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"impute\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"key\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"keyvals\":{\"oneOf\":[{\"type\":\"array\",\"items\":{}},{\"$ref\":\"#/definitions/signalRef\"}]},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"method\":{\"anyOf\":[{\"enum\":[\"value\",\"mean\",\"median\",\"max\",\"min\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"value\"},\"value\":{}},\"required\":[\"type\",\"field\",\"key\"],\"additionalProperties\":false},\"joinaggregateTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"joinaggregate\"]},\"signal\":{\"type\":\"string\"},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"ops\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"enum\":[\"values\",\"count\",\"missing\",\"valid\",\"sum\",\"product\",\"mean\",\"average\",\"variance\",\"variancep\",\"stdev\",\"stdevp\",\"stderr\",\"distinct\",\"ci0\",\"ci1\",\"median\",\"q1\",\"q3\",\"min\",\"max\",\"argmin\",\"argmax\",\"exponential\",\"exponentialb\"]},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"key\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},\"kdeTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"kde\"]},\"signal\":{\"type\":\"string\"},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"cumulative\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"counts\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"bandwidth\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"resolve\":{\"anyOf\":[{\"enum\":[\"shared\",\"independent\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"independent\"},\"steps\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"minsteps\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":25},\"maxsteps\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":200},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"value\",\"density\"]}},\"required\":[\"type\",\"field\"],\"additionalProperties\":false},\"lookupTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"lookup\"]},\"signal\":{\"type\":\"string\"},\"from\":{\"type\":\"string\"},\"key\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"values\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"default\":{}},\"required\":[\"type\",\"from\",\"key\",\"fields\"],\"additionalProperties\":false},\"pivotTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"pivot\"]},\"signal\":{\"type\":\"string\"},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"value\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"op\":{\"anyOf\":[{\"enum\":[\"values\",\"count\",\"missing\",\"valid\",\"sum\",\"product\",\"mean\",\"average\",\"variance\",\"variancep\",\"stdev\",\"stdevp\",\"stderr\",\"distinct\",\"ci0\",\"ci1\",\"median\",\"q1\",\"q3\",\"min\",\"max\",\"argmin\",\"argmax\",\"exponential\",\"exponentialb\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"sum\"},\"limit\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"key\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},\"required\":[\"type\",\"field\",\"value\"],\"additionalProperties\":false},\"projectTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"project\"]},\"signal\":{\"type\":\"string\"},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},\"quantileTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"quantile\"]},\"signal\":{\"type\":\"string\"},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"probs\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":0.01},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"prob\",\"value\"]}},\"required\":[\"type\",\"field\"],\"additionalProperties\":false},\"sampleTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"sample\"]},\"signal\":{\"type\":\"string\"},\"size\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1000}},\"required\":[\"type\"],\"additionalProperties\":false},\"sequenceTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"sequence\"]},\"signal\":{\"type\":\"string\"},\"start\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"stop\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"data\"}},\"required\":[\"type\",\"start\",\"stop\"],\"additionalProperties\":false},\"timeunitTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"timeunit\"]},\"signal\":{\"type\":\"string\"},\"field\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"interval\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":true},\"units\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"enum\":[\"year\",\"quarter\",\"month\",\"week\",\"date\",\"day\",\"dayofyear\",\"hours\",\"minutes\",\"seconds\",\"milliseconds\"]},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"step\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":1},\"maxbins\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":40},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"timezone\":{\"anyOf\":[{\"enum\":[\"local\",\"utc\"]},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"local\"},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"unit0\",\"unit1\"]}},\"required\":[\"type\",\"field\"],\"additionalProperties\":false},\"windowTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"window\"]},\"signal\":{\"type\":\"string\"},\"sort\":{\"$ref\":\"#/definitions/compare\"},\"groupby\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"ops\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"enum\":[\"row_number\",\"rank\",\"dense_rank\",\"percent_rank\",\"cume_dist\",\"ntile\",\"lag\",\"lead\",\"first_value\",\"last_value\",\"nth_value\",\"prev_value\",\"next_value\",\"values\",\"count\",\"missing\",\"valid\",\"sum\",\"product\",\"mean\",\"average\",\"variance\",\"variancep\",\"stdev\",\"stdevp\",\"stderr\",\"distinct\",\"ci0\",\"ci1\",\"median\",\"q1\",\"q3\",\"min\",\"max\",\"argmin\",\"argmax\",\"exponential\",\"exponentialb\"]},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"params\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"aggregate_params\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"fields\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]}},{\"$ref\":\"#/definitions/signalRef\"}]},\"frame\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[null,0]},\"ignorePeers\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\"],\"additionalProperties\":false},\"identifierTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"identifier\"]},\"signal\":{\"type\":\"string\"},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]}},\"required\":[\"type\",\"as\"],\"additionalProperties\":false},\"voronoiTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"voronoi\"]},\"signal\":{\"type\":\"string\"},\"x\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"y\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"extent\":{\"oneOf\":[{\"type\":\"array\",\"items\":{},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[[-100000,-100000],[100000,100000]]},\"as\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":\"path\"}},\"required\":[\"type\",\"x\",\"y\"],\"additionalProperties\":false},\"wordcloudTransform\":{\"type\":\"object\",\"properties\":{\"type\":{\"enum\":[\"wordcloud\"]},\"signal\":{\"type\":\"string\"},\"size\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":2,\"minItems\":2},{\"$ref\":\"#/definitions/signalRef\"}]},\"font\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}],\"default\":\"sans-serif\"},\"fontStyle\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}],\"default\":\"normal\"},\"fontWeight\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}],\"default\":\"normal\"},\"fontSize\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}],\"default\":14},\"fontSizeRange\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"}]}},{\"$ref\":\"#/definitions/signalRef\"},{\"type\":\"null\"}],\"default\":[10,50]},\"rotate\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"text\":{\"oneOf\":[{\"$ref\":\"#/definitions/scaleField\"},{\"$ref\":\"#/definitions/paramField\"},{\"$ref\":\"#/definitions/expr\"}]},\"spiral\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"padding\":{\"anyOf\":[{\"type\":\"number\"},{\"$ref\":\"#/definitions/signalRef\"},{\"$ref\":\"#/definitions/expr\"},{\"$ref\":\"#/definitions/paramField\"}]},\"as\":{\"oneOf\":[{\"type\":\"array\",\"items\":{\"anyOf\":[{\"type\":\"string\"},{\"$ref\":\"#/definitions/signalRef\"}]},\"maxItems\":7,\"minItems\":7},{\"$ref\":\"#/definitions/signalRef\"}],\"default\":[\"x\",\"y\",\"font\",\"fontSize\",\"fontStyle\",\"fontWeight\",\"angle\"]}},\"required\":[\"type\"],\"additionalProperties\":false}},\"type\":\"object\",\"allOf\":[{\"$ref\":\"#/definitions/scope\"},{\"properties\":{\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"config\":{\"type\":\"object\"},\"description\":{\"type\":\"string\"},\"width\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"height\":{\"$ref\":\"#/definitions/numberOrSignal\"},\"padding\":{\"$ref\":\"#/definitions/padding\"},\"autosize\":{\"$ref\":\"#/definitions/autosize\"},\"background\":{\"$ref\":\"#/definitions/background\"},\"style\":{\"$ref\":\"#/definitions/style\"}}}]}");

},{}],"495Y5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiffEditor", ()=>we);
parcelHelpers.export(exports, "Editor", ()=>de);
parcelHelpers.export(exports, "default", ()=>Ft);
parcelHelpers.export(exports, "loader", ()=>(0, _loaderDefault.default));
parcelHelpers.export(exports, "useMonaco", ()=>Le);
var _loader = require("@monaco-editor/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var le = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
}, v = le;
var ae = {
    container: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }
}, Y = ae;
function Me({ children: e }) {
    return (0, _reactDefault.default).createElement("div", {
        style: Y.container
    }, e);
}
var Z = Me;
var $ = Z;
function Ee({ width: e, height: r, isEditorReady: n, loading: t, _ref: a, className: m, wrapperProps: E }) {
    return (0, _reactDefault.default).createElement("section", {
        style: {
            ...v.wrapper,
            width: e,
            height: r
        },
        ...E
    }, !n && (0, _reactDefault.default).createElement($, null, t), (0, _reactDefault.default).createElement("div", {
        ref: a,
        style: {
            ...v.fullWidth,
            ...!n && v.hide
        },
        className: m
    }));
}
var ee = Ee;
var H = (0, _react.memo)(ee);
function Ce(e) {
    (0, _react.useEffect)(e, []);
}
var k = Ce;
function he(e, r, n = !0) {
    let t = (0, _react.useRef)(!0);
    (0, _react.useEffect)(t.current || !n ? ()=>{
        t.current = !1;
    } : e, r);
}
var l = he;
function D() {}
function h(e, r, n, t) {
    return De(e, t) || be(e, r, n, t);
}
function De(e, r) {
    return e.editor.getModel(te(e, r));
}
function be(e, r, n, t) {
    return e.editor.createModel(r, n, t ? te(e, t) : void 0);
}
function te(e, r) {
    return e.Uri.parse(r);
}
function Oe({ original: e, modified: r, language: n, originalLanguage: t, modifiedLanguage: a, originalModelPath: m, modifiedModelPath: E, keepCurrentOriginalModel: g = !1, keepCurrentModifiedModel: N = !1, theme: x = "light", loading: P = "Loading...", options: y = {}, height: V = "100%", width: z = "100%", className: F, wrapperProps: j = {}, beforeMount: A = D, onMount: q = D }) {
    let [M, O] = (0, _react.useState)(!1), [T, s] = (0, _react.useState)(!0), u = (0, _react.useRef)(null), c = (0, _react.useRef)(null), w = (0, _react.useRef)(null), d = (0, _react.useRef)(q), o = (0, _react.useRef)(A), b = (0, _react.useRef)(!1);
    k(()=>{
        let i = (0, _loaderDefault.default).init();
        return i.then((f)=>(c.current = f) && s(!1)).catch((f)=>f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), ()=>u.current ? I() : i.cancel();
    }), l(()=>{
        if (u.current && c.current) {
            let i = u.current.getOriginalEditor(), f = h(c.current, e || "", t || n || "text", m || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        m
    ], M), l(()=>{
        if (u.current && c.current) {
            let i = u.current.getModifiedEditor(), f = h(c.current, r || "", a || n || "text", E || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        E
    ], M), l(()=>{
        let i = u.current.getModifiedEditor();
        i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [
            {
                range: i.getModel().getFullModelRange(),
                text: r || "",
                forceMoveMarkers: !0
            }
        ]), i.pushUndoStop());
    }, [
        r
    ], M), l(()=>{
        u.current?.getModel()?.original.setValue(e || "");
    }, [
        e
    ], M), l(()=>{
        let { original: i, modified: f } = u.current.getModel();
        c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
    }, [
        n,
        t,
        a
    ], M), l(()=>{
        c.current?.editor.setTheme(x);
    }, [
        x
    ], M), l(()=>{
        u.current?.updateOptions(y);
    }, [
        y
    ], M);
    let L = (0, _react.useCallback)(()=>{
        if (!c.current) return;
        o.current(c.current);
        let i = h(c.current, e || "", t || n || "text", m || ""), f = h(c.current, r || "", a || n || "text", E || "");
        u.current?.setModel({
            original: i,
            modified: f
        });
    }, [
        n,
        r,
        a,
        e,
        t,
        m,
        E
    ]), U = (0, _react.useCallback)(()=>{
        !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
            automaticLayout: !0,
            ...y
        }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [
        y,
        x,
        L
    ]);
    (0, _react.useEffect)(()=>{
        M && d.current(u.current, c.current);
    }, [
        M
    ]), (0, _react.useEffect)(()=>{
        !T && !M && U();
    }, [
        T,
        M,
        U
    ]);
    function I() {
        let i = u.current?.getModel();
        g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
    }
    return (0, _reactDefault.default).createElement(H, {
        width: z,
        height: V,
        isEditorReady: M,
        loading: P,
        _ref: w,
        className: F,
        wrapperProps: j
    });
}
var ie = Oe;
var we = (0, _react.memo)(ie);
function Pe() {
    let [e, r] = (0, _react.useState)((0, _loaderDefault.default).__getMonacoInstance());
    return k(()=>{
        let n;
        return e || (n = (0, _loaderDefault.default).init(), n.then((t)=>{
            r(t);
        })), ()=>n?.cancel();
    }), e;
}
var Le = Pe;
function He(e) {
    let r = (0, _react.useRef)();
    return (0, _react.useEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r.current;
}
var se = He;
var _ = new Map;
function Ve({ defaultValue: e, defaultLanguage: r, defaultPath: n, value: t, language: a, path: m, theme: E = "light", line: g, loading: N = "Loading...", options: x = {}, overrideServices: P = {}, saveViewState: y = !0, keepCurrentModel: V = !1, width: z = "100%", height: F = "100%", className: j, wrapperProps: A = {}, beforeMount: q = D, onMount: M = D, onChange: O, onValidate: T = D }) {
    let [s, u] = (0, _react.useState)(!1), [c, w] = (0, _react.useState)(!0), d = (0, _react.useRef)(null), o = (0, _react.useRef)(null), b = (0, _react.useRef)(null), L = (0, _react.useRef)(M), U = (0, _react.useRef)(q), I = (0, _react.useRef)(), i = (0, _react.useRef)(t), f = se(m), Q = (0, _react.useRef)(!1), B = (0, _react.useRef)(!1);
    k(()=>{
        let p = (0, _loaderDefault.default).init();
        return p.then((R)=>(d.current = R) && w(!1)).catch((R)=>R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), ()=>o.current ? pe() : p.cancel();
    }), l(()=>{
        let p = h(d.current, e || t || "", r || a || "", m || n || "");
        p !== o.current?.getModel() && (y && _.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState(_.get(m)));
    }, [
        m
    ], s), l(()=>{
        o.current?.updateOptions(x);
    }, [
        x
    ], s), l(()=>{
        !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [
            {
                range: o.current.getModel().getFullModelRange(),
                text: t,
                forceMoveMarkers: !0
            }
        ]), o.current.pushUndoStop(), B.current = !1));
    }, [
        t
    ], s), l(()=>{
        let p = o.current?.getModel();
        p && a && d.current?.editor.setModelLanguage(p, a);
    }, [
        a
    ], s), l(()=>{
        g !== void 0 && o.current?.revealLine(g);
    }, [
        g
    ], s), l(()=>{
        d.current?.editor.setTheme(E);
    }, [
        E
    ], s);
    let X = (0, _react.useCallback)(()=>{
        if (!(!b.current || !d.current) && !Q.current) {
            U.current(d.current);
            let p = m || n, R = h(d.current, t || e || "", r || a || "", p || "");
            o.current = d.current?.editor.create(b.current, {
                model: R,
                automaticLayout: !0,
                ...x
            }, P), y && o.current.restoreViewState(_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
        }
    }, [
        e,
        r,
        n,
        t,
        a,
        m,
        x,
        P,
        y,
        E,
        g
    ]);
    (0, _react.useEffect)(()=>{
        s && L.current(o.current, d.current);
    }, [
        s
    ]), (0, _react.useEffect)(()=>{
        !c && !s && X();
    }, [
        c,
        s,
        X
    ]), i.current = t, (0, _react.useEffect)(()=>{
        s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent((p)=>{
            B.current || O(o.current.getValue(), p);
        }));
    }, [
        s,
        O
    ]), (0, _react.useEffect)(()=>{
        if (s) {
            let p = d.current.editor.onDidChangeMarkers((R)=>{
                let G = o.current.getModel()?.uri;
                if (G && R.find((J)=>J.path === G.path)) {
                    let J = d.current.editor.getModelMarkers({
                        resource: G
                    });
                    T?.(J);
                }
            });
            return ()=>{
                p?.dispose();
            };
        }
        return ()=>{};
    }, [
        s,
        T
    ]);
    function pe() {
        I.current?.dispose(), V ? y && _.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
    }
    return (0, _reactDefault.default).createElement(H, {
        width: z,
        height: F,
        isEditorReady: s,
        loading: N,
        _ref: b,
        className: j,
        wrapperProps: A
    });
}
var fe = Ve;
var de = (0, _react.memo)(fe);
var Ft = de;

},{"@monaco-editor/loader":"lHoCY","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lHoCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _indexJsDefault.default));
var _indexJs = require("./loader/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"./loader/index.js":"3UPnP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3UPnP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rollupPluginBabelHelpersJs = require("../_virtual/_rollupPluginBabelHelpers.js");
var _stateLocal = require("state-local");
var _stateLocalDefault = parcelHelpers.interopDefault(_stateLocal);
var _indexJs = require("../config/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../validators/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _composeJs = require("../utils/compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _deepMergeJs = require("../utils/deepMerge.js");
var _deepMergeJsDefault = parcelHelpers.interopDefault(_deepMergeJs);
var _makeCancelableJs = require("../utils/makeCancelable.js");
var _makeCancelableJsDefault = parcelHelpers.interopDefault(_makeCancelableJs);
/** the local state of the module */ var _state$create = (0, _stateLocalDefault.default).create({
    config: (0, _indexJsDefault.default),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), _state$create2 = (0, _rollupPluginBabelHelpersJs.slicedToArray)(_state$create, 2), getState = _state$create2[0], setState = _state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function config(globalConfig) {
    var _validators$config = (0, _indexJsDefault1.default).config(globalConfig), monaco = _validators$config.monaco, config = (0, _rollupPluginBabelHelpersJs.objectWithoutProperties)(_validators$config, [
        "monaco"
    ]);
    setState(function(state) {
        return {
            config: (0, _deepMergeJsDefault.default)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function init() {
    var state = getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, _makeCancelableJsDefault.default)(wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, _makeCancelableJsDefault.default)(wrapperPromise);
        }
        (0, _composeJsDefault.default)(injectScripts, getMonacoLoaderScript)(configureLoader);
    }
    return (0, _makeCancelableJsDefault.default)(wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function createScript(src) {
    var script = document.createElement('script');
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function getMonacoLoaderScript(configureLoader) {
    var state = getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function configureLoader() {
    var state = getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require1 = window.require;
    require1.config(state.config);
    require1([
        'vs/editor/editor.main'
    ], function(monaco) {
        storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function storeMonacoInstance(monaco) {
    if (!getState().monaco) setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function __getMonacoInstance() {
    return getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var wrapperPromise = new Promise(function(resolve, reject) {
    return setState({
        resolve: resolve,
        reject: reject
    });
});
var loader = {
    config: config,
    init: init,
    __getMonacoInstance: __getMonacoInstance
};
exports.default = loader;

},{"../_virtual/_rollupPluginBabelHelpers.js":"7OfQp","state-local":"1BvdH","../config/index.js":"h39rq","../validators/index.js":"fp03m","../utils/compose.js":"64O3f","../utils/deepMerge.js":"lvms7","../utils/makeCancelable.js":"6vCf6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7OfQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayLikeToArray", ()=>_arrayLikeToArray);
parcelHelpers.export(exports, "arrayWithHoles", ()=>_arrayWithHoles);
parcelHelpers.export(exports, "defineProperty", ()=>_defineProperty);
parcelHelpers.export(exports, "iterableToArrayLimit", ()=>_iterableToArrayLimit);
parcelHelpers.export(exports, "nonIterableRest", ()=>_nonIterableRest);
parcelHelpers.export(exports, "objectSpread2", ()=>_objectSpread2);
parcelHelpers.export(exports, "objectWithoutProperties", ()=>_objectWithoutProperties);
parcelHelpers.export(exports, "objectWithoutPropertiesLoose", ()=>_objectWithoutPropertiesLoose);
parcelHelpers.export(exports, "slicedToArray", ()=>_slicedToArray);
parcelHelpers.export(exports, "unsupportedIterableToArray", ()=>_unsupportedIterableToArray);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1BvdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
function isEmpty(obj) {
    return !Object.keys(obj).length;
}
function isFunction(value) {
    return typeof value === 'function';
}
function hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function validateChanges(initial, changes) {
    if (!isObject(changes)) errorHandler('changeType');
    if (Object.keys(changes).some(function(field) {
        return !hasOwnProperty(initial, field);
    })) errorHandler('changeField');
    return changes;
}
function validateSelector(selector) {
    if (!isFunction(selector)) errorHandler('selectorType');
}
function validateHandler(handler) {
    if (!(isFunction(handler) || isObject(handler))) errorHandler('handlerType');
    if (isObject(handler) && Object.values(handler).some(function(_handler) {
        return !isFunction(_handler);
    })) errorHandler('handlersType');
}
function validateInitial(initial) {
    if (!initial) errorHandler('initialIsRequired');
    if (!isObject(initial)) errorHandler('initialType');
    if (isEmpty(initial)) errorHandler('initialContent');
}
function throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
    initialIsRequired: 'initial state is required',
    initialType: 'initial state should be an object',
    initialContent: 'initial state shouldn\'t be an empty object',
    handlerType: 'handler should be an object or a function',
    handlersType: 'all handlers should be a functions',
    selectorType: 'selector should be a function',
    changeType: 'provided value of changes should be an object',
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": 'an unknown error accured in `state-local` package'
};
var errorHandler = curry(throwError)(errorMessages);
var validators = {
    changes: validateChanges,
    selector: validateSelector,
    handler: validateHandler,
    initial: validateInitial
};
function create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validators.initial(initial);
    validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = curry(didStateUpdate)(state, handler);
    var update = curry(updateState)(state);
    var validate = curry(validators.changes)(initial);
    var getChanges = curry(extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function extractChanges(state, causedChanges) {
    return isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function updateState(state, changes) {
    state.current = _objectSpread2(_objectSpread2({}, state.current), changes);
    return changes;
}
function didStateUpdate(state, handler, changes) {
    isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var index = {
    create: create
};
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h39rq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var config = {
    paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs'
    }
};
exports.default = config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fp03m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorHandler", ()=>errorHandler);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
var _curryJs = require("../utils/curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _isObjectJs = require("../utils/isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function validateConfig(config) {
    if (!config) errorHandler('configIsRequired');
    if (!(0, _isObjectJsDefault.default)(config)) errorHandler('configType');
    if (config.urls) {
        informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function informAboutDeprecation() {
    console.warn(errorMessages.deprecation);
}
function throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
    configIsRequired: 'the configuration object is required',
    configType: 'the configuration object should be an object',
    "default": 'an unknown error accured in `@monaco-editor/loader` package',
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var errorHandler = (0, _curryJsDefault.default)(throwError)(errorMessages);
var validators = {
    config: validateConfig
};
exports.default = validators;

},{"../utils/curry.js":"VL6Tq","../utils/isObject.js":"euI92","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"VL6Tq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
exports.default = curry;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"euI92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"64O3f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};
exports.default = compose;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lvms7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rollupPluginBabelHelpersJs = require("../_virtual/_rollupPluginBabelHelpers.js");
function merge(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], merge(target[key], source[key]));
        }
    });
    return (0, _rollupPluginBabelHelpersJs.objectSpread2)((0, _rollupPluginBabelHelpersJs.objectSpread2)({}, target), source);
}
exports.default = merge;

},{"../_virtual/_rollupPluginBabelHelpers.js":"7OfQp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6vCf6":[function(require,module,exports,__globalThis) {
// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CANCELATION_MESSAGE", ()=>CANCELATION_MESSAGE);
var CANCELATION_MESSAGE = {
    type: 'cancelation',
    msg: 'operation is manually canceled'
};
function makeCancelable(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}
exports.default = makeCancelable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cQ16f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _appJs = require("./app.js");
var _appJsDefault = parcelHelpers.interopDefault(_appJs);
var _resetJs = require("./reset.js");
var _resetJsDefault = parcelHelpers.interopDefault(_resetJs);
class AppShell extends _react.PureComponent {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/",
                        exact: true,
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/reset",
                        component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetJsDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/edited",
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        exact: true,
                        path: "/gist/:id/:filename",
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        exact: true,
                        path: "/gist/:id/:filename/view",
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/gist/:id/:revision/:filename",
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/examples/:mode/:example_name",
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/examples/:mode",
                        component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appJsDefault.default), {
                                showExample: true
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/examples",
                        component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appJsDefault.default), {
                                showExample: true
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/custom/:mode",
                        component: (0, _appJsDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/url/:mode/:compressed",
                        component: (0, _appJsDefault.default)
                    })
                ]
            })
        });
    }
}
exports.default = AppShell;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./app.js":"5LEAA","./reset.js":"ekPAW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5LEAA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _jsoncParser = require("jsonc-parser");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _reactSplitPaneR17 = require("react-split-pane-r17");
var _reactSplitPaneR17Default = parcelHelpers.interopDefault(_reactSplitPaneR17);
var _redux = require("redux");
var _vegaLite = require("vega-lite");
var _editorJs = require("../actions/editor.js");
var _indexJs = require("../constants/index.js");
var _constsJs = require("../constants/consts.js");
var _appCss = require("./app.css");
var _indexJs1 = require("./header/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./input-panel/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./sidebar/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./viz-pane/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _githubJs = require("../utils/github.js");
class App extends _react.PureComponent {
    w = window.innerWidth;
    componentDidMount() {
        window.addEventListener('message', (evt)=>{
            const data = evt.data;
            if (!data.spec) return;
            // setting baseURL as event's origin
            this.props.setBaseUrl(evt.origin);
            console.info('[Vega-Editor] Received Message', evt.origin, data);
            if (data.config) this.props.setConfig((0, _jsonStringifyPrettyCompactDefault.default)(data.config));
            if (data.spec || data.file) // FIXME: remove any
            evt.source.postMessage(true, '*');
            if (data.spec) {
                if (data.mode.toUpperCase() === 'VEGA') this.props.updateVegaSpec(data.spec);
                else if (data.mode.toUpperCase() === 'VEGA-LITE') this.props.updateVegaLiteSpec(data.spec);
            }
            if (data.renderer) this.props.setRenderer(data.renderer);
        }, false);
        const parameter = this.props.match.params;
        if (parameter.mode) {
            if (parameter.mode === 'vega' || parameter.mode === 'vega-lite') this.props.setModeOnly(parameter.mode);
        }
        this.setSpecInUrl(parameter);
    }
    componentDidUpdate(prevProps) {
        if ((0, _vegaLite.hash)(this.props.match.params) !== (0, _vegaLite.hash)(prevProps.match.params)) this.setSpecInUrl(this.props.match.params);
    }
    setSpecInUrl(parameter) {
        if (parameter) {
            if (parameter.example_name) this.setExample(parameter);
            else if (parameter.mode && !parameter.compressed) this.setEmptySpec((0, _constsJs.NAME_TO_MODE)[parameter.mode]);
            else if (parameter.id) this.setGist(parameter);
        }
    }
    async setExample(parameter) {
        const name = parameter.example_name;
        this.props.setConfig(this.props.configEditorString);
        this.props.setSidePaneItem((0, _constsJs.SIDEPANE).Editor);
        this.props.editorRef?.focus();
        switch(parameter.mode){
            case 'vega':
                {
                    const r = await fetch(`./spec/vega/${name}.vg.json`);
                    this.props.setVegaExample(name, await r.text());
                    break;
                }
            case 'vega-lite':
                {
                    const r = await fetch(`./spec/vega-lite/${name}.vl.json`);
                    this.props.setVegaLiteExample(name, await r.text());
                    break;
                }
            default:
                console.warn(`Unknown mode ${parameter.mode}`);
                break;
        }
    }
    setEmptySpec(mode) {
        if (mode === (0, _indexJs.Mode).Vega) this.props.updateVegaSpec((0, _constsJs.VEGA_START_SPEC));
        else if (mode === (0, _indexJs.Mode).VegaLite) this.props.updateVegaLiteSpec((0, _constsJs.VEGA_LITE_START_SPEC));
    }
    async setGist(parameter) {
        try {
            const gistApiUrl = `https://api.github.com/gists/${parameter.id}${parameter.revision !== undefined ? `/${parameter.revision}` : ''}`;
            const headers = {
                'Content-Type': 'application/json'
            };
            let githubToken;
            try {
                githubToken = await (0, _githubJs.getGithubToken)();
                if (githubToken) headers['Authorization'] = `token ${githubToken}`;
            } catch (error) {
                console.error('Failed to get GitHub token:', error);
            }
            const gistResponse = await fetch(gistApiUrl, {
                headers
            });
            if (!gistResponse.ok) throw new Error(`Failed to fetch gist: ${gistResponse.status}`);
            const gistData = await gistResponse.json();
            if (!gistData.files[parameter.filename]) throw new Error(`File ${parameter.filename} not found in gist`);
            let content;
            if (gistData.files[parameter.filename].content) content = gistData.files[parameter.filename].content;
            else if (gistData.files[parameter.filename].truncated) {
                console.warn('File content truncated - using proxy approach');
                const contentResponse = await fetch(gistData.files[parameter.filename].raw_url, {
                    headers
                });
                if (!contentResponse.ok) throw new Error(`Failed to fetch content: ${contentResponse.status}`);
                content = await contentResponse.text();
            } else throw new Error('Could not retrieve file content');
            const contentObj = (0, _jsoncParser.parse)(content);
            if (!('$schema' in contentObj)) this.props.setGistVegaLiteSpec('', content);
            else {
                const mode = contentObj.$schema.split('/').slice(-2)[0];
                if (mode === (0, _indexJs.Mode).Vega) this.props.setGistVegaSpec('', content);
                else if (mode === (0, _indexJs.Mode).VegaLite) this.props.setGistVegaLiteSpec('', content);
            }
        } catch (error) {
            console.error('Error loading gist:', error);
        }
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "app-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
                    showExample: this.props.showExample
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        height: `calc(100vh - ${(0, _indexJs.LAYOUT).HeaderHeight}px)`
                    },
                    className: "main-panel",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSplitPaneR17Default.default), {
                            split: "vertical",
                            minSize: 300,
                            defaultSize: Math.min(this.w * 0.4, 800),
                            pane1Style: {
                                display: 'flex'
                            },
                            className: "main-pane",
                            pane2Style: {
                                overflow: 'scroll'
                            },
                            style: {
                                position: 'relative'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault1.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault3.default), {})
                            ]
                        }),
                        this.props.settings && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault2.default), {})
                    ]
                })
            ]
        });
    }
}
function mapStateToProps(state) {
    return {
        configEditorString: state.configEditorString,
        editorRef: state.editorRef,
        settings: state.settings,
        view: state.view
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setBaseUrl: _editorJs.setBaseUrl,
        setConfig: _editorJs.setConfig,
        setGistVegaLiteSpec: _editorJs.setGistVegaLiteSpec,
        setGistVegaSpec: _editorJs.setGistVegaSpec,
        setModeOnly: _editorJs.setModeOnly,
        setRenderer: _editorJs.setRenderer,
        setSettingsState: _editorJs.setSettingsState,
        setSidePaneItem: _editorJs.setSidePaneItem,
        setVegaExample: _editorJs.setVegaExample,
        setVegaLiteExample: _editorJs.setVegaLiteExample,
        updateVegaLiteSpec: _editorJs.updateVegaLiteSpec,
        updateVegaSpec: _editorJs.updateVegaSpec
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(App));

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","jsonc-parser":"81Jm5","react":"bmhQu","react-redux":"dwYd3","react-router-dom":"b9X5n","react-split-pane-r17":"Q6ksT","redux":"jTcSr","vega-lite":"eTD5L","../actions/editor.js":"wC9No","../constants/index.js":"4z2sr","../constants/consts.js":"1PtM7","./app.css":"iVDT3","./header/index.js":"jsETu","./input-panel/index.js":"bk4m3","./sidebar/index.js":"aJ7i1","./viz-pane/index.js":"bQpN0","../utils/github.js":"GBWwL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Q6ksT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pane", ()=>Pane);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactStyleProptype = require("react-style-proptype");
var _reactStyleProptypeDefault = parcelHelpers.interopDefault(_reactStyleProptype);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _createSuper(Derived) {
    return function() {
        var Super = _getPrototypeOf(Derived), result;
        if (_isNativeReflectConstruct()) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
var Pane = /*#__PURE__*/ function(_React$PureComponent) {
    _inherits(Pane, _React$PureComponent);
    var _super = _createSuper(Pane);
    function Pane() {
        _classCallCheck(this, Pane);
        return _super.apply(this, arguments);
    }
    _createClass(Pane, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, className = _this$props.className, split = _this$props.split, styleProps = _this$props.style, size = _this$props.size, eleRef = _this$props.eleRef;
                var classes = [
                    'Pane',
                    split,
                    className
                ];
                var style = {
                    flex: 1,
                    position: 'relative',
                    outline: 'none'
                };
                if (size !== undefined) {
                    if (split === 'vertical') style.width = size;
                    else {
                        style.height = size;
                        style.display = 'flex';
                    }
                    style.flex = 'none';
                }
                style = Object.assign({}, style, styleProps || {});
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    ref: eleRef,
                    className: classes.join(' '),
                    style: style
                }, children);
            }
        }
    ]);
    return Pane;
}((0, _reactDefault.default).PureComponent);
Pane.propTypes = {
    className: (0, _propTypesDefault.default).string.isRequired,
    children: (0, _propTypesDefault.default).node.isRequired,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    split: (0, _propTypesDefault.default).oneOf([
        'vertical',
        'horizontal'
    ]),
    style: (0, _reactStyleProptypeDefault.default),
    eleRef: (0, _propTypesDefault.default).func
};
Pane.defaultProps = {};
var RESIZER_DEFAULT_CLASSNAME = 'Resizer';
var Resizer = /*#__PURE__*/ function(_React$Component) {
    _inherits(Resizer, _React$Component);
    var _super = _createSuper(Resizer);
    function Resizer() {
        _classCallCheck(this, Resizer);
        return _super.apply(this, arguments);
    }
    _createClass(Resizer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, _onClick = _this$props.onClick, _onDoubleClick = _this$props.onDoubleClick, _onMouseDown = _this$props.onMouseDown, _onTouchEnd = _this$props.onTouchEnd, _onTouchStart = _this$props.onTouchStart, resizerClassName = _this$props.resizerClassName, split = _this$props.split, style = _this$props.style;
                var classes = [
                    resizerClassName,
                    split,
                    className
                ];
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    role: "presentation",
                    className: classes.join(' '),
                    style: style,
                    onMouseDown: function onMouseDown(event) {
                        return _onMouseDown(event);
                    },
                    onTouchStart: function onTouchStart(event) {
                        event.preventDefault();
                        _onTouchStart(event);
                    },
                    onTouchEnd: function onTouchEnd(event) {
                        event.preventDefault();
                        _onTouchEnd(event);
                    },
                    onClick: function onClick(event) {
                        if (_onClick) {
                            event.preventDefault();
                            _onClick(event);
                        }
                    },
                    onDoubleClick: function onDoubleClick(event) {
                        if (_onDoubleClick) {
                            event.preventDefault();
                            _onDoubleClick(event);
                        }
                    }
                });
            }
        }
    ]);
    return Resizer;
}((0, _reactDefault.default).Component);
Resizer.propTypes = {
    className: (0, _propTypesDefault.default).string.isRequired,
    onClick: (0, _propTypesDefault.default).func,
    onDoubleClick: (0, _propTypesDefault.default).func,
    onMouseDown: (0, _propTypesDefault.default).func.isRequired,
    onTouchStart: (0, _propTypesDefault.default).func.isRequired,
    onTouchEnd: (0, _propTypesDefault.default).func.isRequired,
    split: (0, _propTypesDefault.default).oneOf([
        'vertical',
        'horizontal'
    ]),
    style: (0, _reactStyleProptypeDefault.default),
    resizerClassName: (0, _propTypesDefault.default).string.isRequired
};
Resizer.defaultProps = {
    resizerClassName: RESIZER_DEFAULT_CLASSNAME
};
function unFocus(document1, window1) {
    if (document1.selection) document1.selection.empty();
    else try {
        window1.getSelection().removeAllRanges(); // eslint-disable-next-line no-empty
    } catch (e) {}
}
function getDefaultSize(defaultSize, minSize, maxSize, draggedSize) {
    if (typeof draggedSize === 'number') {
        var min = typeof minSize === 'number' ? minSize : 0;
        var max = typeof maxSize === 'number' && maxSize >= 0 ? maxSize : Infinity;
        return Math.max(min, Math.min(max, draggedSize));
    }
    if (defaultSize !== undefined) return defaultSize;
    return minSize;
}
function removeNullChildren(children) {
    return (0, _reactDefault.default).Children.toArray(children).filter(function(c) {
        return c;
    });
}
var SplitPane = /*#__PURE__*/ function(_React$Component) {
    _inherits(SplitPane, _React$Component);
    var _super = _createSuper(SplitPane);
    function SplitPane(props) {
        var _this;
        _classCallCheck(this, SplitPane);
        _this = _super.call(this, props);
        _this.onMouseDown = _this.onMouseDown.bind(_assertThisInitialized(_this));
        _this.onTouchStart = _this.onTouchStart.bind(_assertThisInitialized(_this));
        _this.onMouseMove = _this.onMouseMove.bind(_assertThisInitialized(_this));
        _this.onTouchMove = _this.onTouchMove.bind(_assertThisInitialized(_this));
        _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_this)); // order of setting panel sizes.
        // 1. size
        // 2. getDefaultSize(defaultSize, minsize, maxSize)
        var size = props.size, defaultSize = props.defaultSize, minSize = props.minSize, maxSize = props.maxSize, primary = props.primary;
        var initialSize = size !== undefined ? size : getDefaultSize(defaultSize, minSize, maxSize, null);
        _this.state = {
            active: false,
            resized: false,
            pane1Size: primary === 'first' ? initialSize : undefined,
            pane2Size: primary === 'second' ? initialSize : undefined,
            // these are props that are needed in static functions. ie: gDSFP
            instanceProps: {
                size: size
            }
        };
        return _this;
    }
    _createClass(SplitPane, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('mouseup', this.onMouseUp);
                document.addEventListener('mousemove', this.onMouseMove);
                document.addEventListener('touchmove', this.onTouchMove);
                this.setState(SplitPane.getSizeUpdate(this.props, this.state));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('mouseup', this.onMouseUp);
                document.removeEventListener('mousemove', this.onMouseMove);
                document.removeEventListener('touchmove', this.onTouchMove);
            }
        },
        {
            key: "onMouseDown",
            value: function onMouseDown(event) {
                var eventWithTouches = Object.assign({}, event, {
                    touches: [
                        {
                            clientX: event.clientX,
                            clientY: event.clientY
                        }
                    ]
                });
                this.onTouchStart(eventWithTouches);
            }
        },
        {
            key: "onTouchStart",
            value: function onTouchStart(event) {
                var _this$props = this.props, allowResize = _this$props.allowResize, onDragStarted = _this$props.onDragStarted, split = _this$props.split;
                if (allowResize) {
                    unFocus(document, window);
                    var position = split === 'vertical' ? event.touches[0].clientX : event.touches[0].clientY;
                    if (typeof onDragStarted === 'function') onDragStarted();
                    this.setState({
                        active: true,
                        position: position
                    });
                }
            }
        },
        {
            key: "onMouseMove",
            value: function onMouseMove(event) {
                var eventWithTouches = Object.assign({}, event, {
                    touches: [
                        {
                            clientX: event.clientX,
                            clientY: event.clientY
                        }
                    ]
                });
                this.onTouchMove(eventWithTouches);
            }
        },
        {
            key: "onTouchMove",
            value: function onTouchMove(event) {
                var _this$props2 = this.props, allowResize = _this$props2.allowResize, maxSize = _this$props2.maxSize, minSize = _this$props2.minSize, onChange = _this$props2.onChange, split = _this$props2.split, step = _this$props2.step;
                var _this$state = this.state, active = _this$state.active, position = _this$state.position;
                if (allowResize && active) {
                    unFocus(document, window);
                    var isPrimaryFirst = this.props.primary === 'first';
                    var ref = isPrimaryFirst ? this.pane1 : this.pane2;
                    var ref2 = isPrimaryFirst ? this.pane2 : this.pane1;
                    if (ref) {
                        var node = ref;
                        var node2 = ref2;
                        if (node.getBoundingClientRect) {
                            var width = node.getBoundingClientRect().width;
                            var height = node.getBoundingClientRect().height;
                            var current = split === 'vertical' ? event.touches[0].clientX : event.touches[0].clientY;
                            var size = split === 'vertical' ? width : height;
                            var positionDelta = position - current;
                            if (step) {
                                if (Math.abs(positionDelta) < step) return;
                                 // Integer division
                                // eslint-disable-next-line no-bitwise
                                positionDelta = ~~(positionDelta / step) * step;
                            }
                            var sizeDelta = isPrimaryFirst ? positionDelta : -positionDelta;
                            var pane1Order = parseInt(window.getComputedStyle(node).order);
                            var pane2Order = parseInt(window.getComputedStyle(node2).order);
                            if (pane1Order > pane2Order) sizeDelta = -sizeDelta;
                            var newMaxSize = maxSize;
                            if (maxSize !== undefined && maxSize <= 0) {
                                var splitPane = this.splitPane;
                                if (split === 'vertical') newMaxSize = splitPane.getBoundingClientRect().width + maxSize;
                                else newMaxSize = splitPane.getBoundingClientRect().height + maxSize;
                            }
                            var newSize = size - sizeDelta;
                            var newPosition = position - positionDelta;
                            if (newSize < minSize) newSize = minSize;
                            else if (maxSize !== undefined && newSize > newMaxSize) newSize = newMaxSize;
                            else this.setState({
                                position: newPosition,
                                resized: true
                            });
                            if (onChange) onChange(newSize);
                            this.setState(_defineProperty({
                                draggedSize: newSize
                            }, isPrimaryFirst ? 'pane1Size' : 'pane2Size', newSize));
                        }
                    }
                }
            }
        },
        {
            key: "onMouseUp",
            value: function onMouseUp() {
                var _this$props3 = this.props, allowResize = _this$props3.allowResize, onDragFinished = _this$props3.onDragFinished;
                var _this$state2 = this.state, active = _this$state2.active, draggedSize = _this$state2.draggedSize;
                if (allowResize && active) {
                    if (typeof onDragFinished === 'function') onDragFinished(draggedSize);
                    this.setState({
                        active: false
                    });
                }
            } // we have to check values since gDSFP is called on every render and more in StrictMode
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, allowResize = _this$props4.allowResize, children = _this$props4.children, className = _this$props4.className, onResizerClick = _this$props4.onResizerClick, onResizerDoubleClick = _this$props4.onResizerDoubleClick, paneClassName = _this$props4.paneClassName, pane1ClassName = _this$props4.pane1ClassName, pane2ClassName = _this$props4.pane2ClassName, paneStyle = _this$props4.paneStyle, pane1StyleProps = _this$props4.pane1Style, pane2StyleProps = _this$props4.pane2Style, resizerClassName = _this$props4.resizerClassName, resizerStyle = _this$props4.resizerStyle, split = _this$props4.split, styleProps = _this$props4.style;
                var _this$state3 = this.state, pane1Size = _this$state3.pane1Size, pane2Size = _this$state3.pane2Size;
                var disabledClass = allowResize ? '' : 'disabled';
                var resizerClassNamesIncludingDefault = resizerClassName ? "".concat(resizerClassName, " ").concat(RESIZER_DEFAULT_CLASSNAME) : resizerClassName;
                var notNullChildren = removeNullChildren(children);
                var style = _objectSpread2({
                    display: 'flex',
                    flex: 1,
                    height: '100%',
                    position: 'absolute',
                    outline: 'none',
                    overflow: 'hidden',
                    MozUserSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    userSelect: 'text'
                }, styleProps);
                if (split === 'vertical') Object.assign(style, {
                    flexDirection: 'row',
                    left: 0,
                    right: 0
                });
                else Object.assign(style, {
                    bottom: 0,
                    flexDirection: 'column',
                    minHeight: '100%',
                    top: 0,
                    width: '100%'
                });
                var classes = [
                    'SplitPane',
                    className,
                    split,
                    disabledClass
                ];
                var pane1Style = _objectSpread2({}, paneStyle, {}, pane1StyleProps);
                var pane2Style = _objectSpread2({}, paneStyle, {}, pane2StyleProps);
                var pane1Classes = [
                    'Pane1',
                    paneClassName,
                    pane1ClassName
                ].join(' ');
                var pane2Classes = [
                    'Pane2',
                    paneClassName,
                    pane2ClassName
                ].join(' ');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: classes.join(' '),
                    ref: function ref(node) {
                        _this2.splitPane = node;
                    },
                    style: style
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Pane, {
                    className: pane1Classes,
                    key: "pane1",
                    eleRef: function eleRef(node) {
                        _this2.pane1 = node;
                    },
                    size: pane1Size,
                    split: split,
                    style: pane1Style
                }, notNullChildren[0]), /*#__PURE__*/ (0, _reactDefault.default).createElement(Resizer, {
                    className: disabledClass,
                    onClick: onResizerClick,
                    onDoubleClick: onResizerDoubleClick,
                    onMouseDown: this.onMouseDown,
                    onTouchStart: this.onTouchStart,
                    onTouchEnd: this.onMouseUp,
                    key: "resizer",
                    resizerClassName: resizerClassNamesIncludingDefault,
                    split: split,
                    style: resizerStyle || {}
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Pane, {
                    className: pane2Classes,
                    key: "pane2",
                    eleRef: function eleRef(node) {
                        _this2.pane2 = node;
                    },
                    size: pane2Size,
                    split: split,
                    style: pane2Style
                }, notNullChildren[1]));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                return SplitPane.getSizeUpdate(nextProps, prevState);
            }
        },
        {
            key: "getSizeUpdate",
            value: function getSizeUpdate(props, state) {
                var newState = {};
                var instanceProps = state.instanceProps;
                if (instanceProps.size === props.size && props.size !== undefined) return {};
                var newSize = props.size !== undefined ? props.size : getDefaultSize(props.defaultSize, props.minSize, props.maxSize, state.draggedSize);
                if (props.size !== undefined) newState.draggedSize = newSize;
                var isPanel1Primary = props.primary === 'first';
                newState[isPanel1Primary ? 'pane1Size' : 'pane2Size'] = newSize;
                newState[isPanel1Primary ? 'pane2Size' : 'pane1Size'] = undefined;
                newState.instanceProps = {
                    size: props.size
                };
                return newState;
            }
        }
    ]);
    return SplitPane;
}((0, _reactDefault.default).Component);
SplitPane.propTypes = {
    allowResize: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node).isRequired,
    className: (0, _propTypesDefault.default).string,
    primary: (0, _propTypesDefault.default).oneOf([
        'first',
        'second'
    ]),
    minSize: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    maxSize: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    // eslint-disable-next-line react/no-unused-prop-types
    defaultSize: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    split: (0, _propTypesDefault.default).oneOf([
        'vertical',
        'horizontal'
    ]),
    onDragStarted: (0, _propTypesDefault.default).func,
    onDragFinished: (0, _propTypesDefault.default).func,
    onChange: (0, _propTypesDefault.default).func,
    onResizerClick: (0, _propTypesDefault.default).func,
    onResizerDoubleClick: (0, _propTypesDefault.default).func,
    style: (0, _reactStyleProptypeDefault.default),
    resizerStyle: (0, _reactStyleProptypeDefault.default),
    paneClassName: (0, _propTypesDefault.default).string,
    pane1ClassName: (0, _propTypesDefault.default).string,
    pane2ClassName: (0, _propTypesDefault.default).string,
    paneStyle: (0, _reactStyleProptypeDefault.default),
    pane1Style: (0, _reactStyleProptypeDefault.default),
    pane2Style: (0, _reactStyleProptypeDefault.default),
    resizerClassName: (0, _propTypesDefault.default).string,
    step: (0, _propTypesDefault.default).number
};
SplitPane.defaultProps = {
    allowResize: true,
    minSize: 50,
    primary: 'first',
    split: 'vertical',
    paneClassName: '',
    pane1ClassName: '',
    pane2ClassName: ''
};
(0, _reactLifecyclesCompat.polyfill)(SplitPane);
exports.default = SplitPane;

},{"react":"bmhQu","prop-types":"gLXGb","react-style-proptype":"fWRis","react-lifecycles-compat":"itCeo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fWRis":[function(require,module,exports,__globalThis) {
var properties = require("3fb5623aca37c243");
var PropTypes = require("d15ec2847c3d87f6");
module.exports = function(props, propName, componentName) {
    var styles = props[propName];
    if (!styles) return;
    var failures = [];
    Object.keys(styles).forEach(function(styleKey) {
        if (properties.indexOf(styleKey) === -1) failures.push(styleKey);
    });
    if (failures.length) throw new Error('Prop ' + propName + ' passed to ' + componentName + '. Has invalid keys ' + failures.join(', '));
};
module.exports.isRequired = function(props, propName, componentName) {
    if (!props[propName]) throw new Error('Prop ' + propName + ' passed to ' + componentName + ' is required');
    return module.exports(props, propName, componentName);
};
module.exports.supportingArrays = PropTypes.oneOfType([
    PropTypes.arrayOf(module.exports),
    module.exports
]);

},{"3fb5623aca37c243":"2MpMD","d15ec2847c3d87f6":"gLXGb"}],"2MpMD":[function(require,module,exports,__globalThis) {
// GENERATED DO NOT EDIT
module.exports = [
    "alignContent",
    "MozAlignContent",
    "WebkitAlignContent",
    "MSAlignContent",
    "OAlignContent",
    "alignItems",
    "MozAlignItems",
    "WebkitAlignItems",
    "MSAlignItems",
    "OAlignItems",
    "alignSelf",
    "MozAlignSelf",
    "WebkitAlignSelf",
    "MSAlignSelf",
    "OAlignSelf",
    "all",
    "MozAll",
    "WebkitAll",
    "MSAll",
    "OAll",
    "animation",
    "MozAnimation",
    "WebkitAnimation",
    "MSAnimation",
    "OAnimation",
    "animationDelay",
    "MozAnimationDelay",
    "WebkitAnimationDelay",
    "MSAnimationDelay",
    "OAnimationDelay",
    "animationDirection",
    "MozAnimationDirection",
    "WebkitAnimationDirection",
    "MSAnimationDirection",
    "OAnimationDirection",
    "animationDuration",
    "MozAnimationDuration",
    "WebkitAnimationDuration",
    "MSAnimationDuration",
    "OAnimationDuration",
    "animationFillMode",
    "MozAnimationFillMode",
    "WebkitAnimationFillMode",
    "MSAnimationFillMode",
    "OAnimationFillMode",
    "animationIterationCount",
    "MozAnimationIterationCount",
    "WebkitAnimationIterationCount",
    "MSAnimationIterationCount",
    "OAnimationIterationCount",
    "animationName",
    "MozAnimationName",
    "WebkitAnimationName",
    "MSAnimationName",
    "OAnimationName",
    "animationPlayState",
    "MozAnimationPlayState",
    "WebkitAnimationPlayState",
    "MSAnimationPlayState",
    "OAnimationPlayState",
    "animationTimingFunction",
    "MozAnimationTimingFunction",
    "WebkitAnimationTimingFunction",
    "MSAnimationTimingFunction",
    "OAnimationTimingFunction",
    "backfaceVisibility",
    "MozBackfaceVisibility",
    "WebkitBackfaceVisibility",
    "MSBackfaceVisibility",
    "OBackfaceVisibility",
    "background",
    "MozBackground",
    "WebkitBackground",
    "MSBackground",
    "OBackground",
    "backgroundAttachment",
    "MozBackgroundAttachment",
    "WebkitBackgroundAttachment",
    "MSBackgroundAttachment",
    "OBackgroundAttachment",
    "backgroundBlendMode",
    "MozBackgroundBlendMode",
    "WebkitBackgroundBlendMode",
    "MSBackgroundBlendMode",
    "OBackgroundBlendMode",
    "backgroundClip",
    "MozBackgroundClip",
    "WebkitBackgroundClip",
    "MSBackgroundClip",
    "OBackgroundClip",
    "backgroundColor",
    "MozBackgroundColor",
    "WebkitBackgroundColor",
    "MSBackgroundColor",
    "OBackgroundColor",
    "backgroundImage",
    "MozBackgroundImage",
    "WebkitBackgroundImage",
    "MSBackgroundImage",
    "OBackgroundImage",
    "backgroundOrigin",
    "MozBackgroundOrigin",
    "WebkitBackgroundOrigin",
    "MSBackgroundOrigin",
    "OBackgroundOrigin",
    "backgroundPosition",
    "MozBackgroundPosition",
    "WebkitBackgroundPosition",
    "MSBackgroundPosition",
    "OBackgroundPosition",
    "backgroundRepeat",
    "MozBackgroundRepeat",
    "WebkitBackgroundRepeat",
    "MSBackgroundRepeat",
    "OBackgroundRepeat",
    "backgroundSize",
    "MozBackgroundSize",
    "WebkitBackgroundSize",
    "MSBackgroundSize",
    "OBackgroundSize",
    "blockSize",
    "MozBlockSize",
    "WebkitBlockSize",
    "MSBlockSize",
    "OBlockSize",
    "border",
    "MozBorder",
    "WebkitBorder",
    "MSBorder",
    "OBorder",
    "borderBlockEnd",
    "MozBorderBlockEnd",
    "WebkitBorderBlockEnd",
    "MSBorderBlockEnd",
    "OBorderBlockEnd",
    "borderBlockEndColor",
    "MozBorderBlockEndColor",
    "WebkitBorderBlockEndColor",
    "MSBorderBlockEndColor",
    "OBorderBlockEndColor",
    "borderBlockEndStyle",
    "MozBorderBlockEndStyle",
    "WebkitBorderBlockEndStyle",
    "MSBorderBlockEndStyle",
    "OBorderBlockEndStyle",
    "borderBlockEndWidth",
    "MozBorderBlockEndWidth",
    "WebkitBorderBlockEndWidth",
    "MSBorderBlockEndWidth",
    "OBorderBlockEndWidth",
    "borderBlockStart",
    "MozBorderBlockStart",
    "WebkitBorderBlockStart",
    "MSBorderBlockStart",
    "OBorderBlockStart",
    "borderBlockStartColor",
    "MozBorderBlockStartColor",
    "WebkitBorderBlockStartColor",
    "MSBorderBlockStartColor",
    "OBorderBlockStartColor",
    "borderBlockStartStyle",
    "MozBorderBlockStartStyle",
    "WebkitBorderBlockStartStyle",
    "MSBorderBlockStartStyle",
    "OBorderBlockStartStyle",
    "borderBlockStartWidth",
    "MozBorderBlockStartWidth",
    "WebkitBorderBlockStartWidth",
    "MSBorderBlockStartWidth",
    "OBorderBlockStartWidth",
    "borderBottom",
    "MozBorderBottom",
    "WebkitBorderBottom",
    "MSBorderBottom",
    "OBorderBottom",
    "borderBottomColor",
    "MozBorderBottomColor",
    "WebkitBorderBottomColor",
    "MSBorderBottomColor",
    "OBorderBottomColor",
    "borderBottomLeftRadius",
    "MozBorderBottomLeftRadius",
    "WebkitBorderBottomLeftRadius",
    "MSBorderBottomLeftRadius",
    "OBorderBottomLeftRadius",
    "borderBottomRightRadius",
    "MozBorderBottomRightRadius",
    "WebkitBorderBottomRightRadius",
    "MSBorderBottomRightRadius",
    "OBorderBottomRightRadius",
    "borderBottomStyle",
    "MozBorderBottomStyle",
    "WebkitBorderBottomStyle",
    "MSBorderBottomStyle",
    "OBorderBottomStyle",
    "borderBottomWidth",
    "MozBorderBottomWidth",
    "WebkitBorderBottomWidth",
    "MSBorderBottomWidth",
    "OBorderBottomWidth",
    "borderCollapse",
    "MozBorderCollapse",
    "WebkitBorderCollapse",
    "MSBorderCollapse",
    "OBorderCollapse",
    "borderColor",
    "MozBorderColor",
    "WebkitBorderColor",
    "MSBorderColor",
    "OBorderColor",
    "borderImage",
    "MozBorderImage",
    "WebkitBorderImage",
    "MSBorderImage",
    "OBorderImage",
    "borderImageOutset",
    "MozBorderImageOutset",
    "WebkitBorderImageOutset",
    "MSBorderImageOutset",
    "OBorderImageOutset",
    "borderImageRepeat",
    "MozBorderImageRepeat",
    "WebkitBorderImageRepeat",
    "MSBorderImageRepeat",
    "OBorderImageRepeat",
    "borderImageSlice",
    "MozBorderImageSlice",
    "WebkitBorderImageSlice",
    "MSBorderImageSlice",
    "OBorderImageSlice",
    "borderImageSource",
    "MozBorderImageSource",
    "WebkitBorderImageSource",
    "MSBorderImageSource",
    "OBorderImageSource",
    "borderImageWidth",
    "MozBorderImageWidth",
    "WebkitBorderImageWidth",
    "MSBorderImageWidth",
    "OBorderImageWidth",
    "borderInlineEnd",
    "MozBorderInlineEnd",
    "WebkitBorderInlineEnd",
    "MSBorderInlineEnd",
    "OBorderInlineEnd",
    "borderInlineEndColor",
    "MozBorderInlineEndColor",
    "WebkitBorderInlineEndColor",
    "MSBorderInlineEndColor",
    "OBorderInlineEndColor",
    "borderInlineEndStyle",
    "MozBorderInlineEndStyle",
    "WebkitBorderInlineEndStyle",
    "MSBorderInlineEndStyle",
    "OBorderInlineEndStyle",
    "borderInlineEndWidth",
    "MozBorderInlineEndWidth",
    "WebkitBorderInlineEndWidth",
    "MSBorderInlineEndWidth",
    "OBorderInlineEndWidth",
    "borderInlineStart",
    "MozBorderInlineStart",
    "WebkitBorderInlineStart",
    "MSBorderInlineStart",
    "OBorderInlineStart",
    "borderInlineStartColor",
    "MozBorderInlineStartColor",
    "WebkitBorderInlineStartColor",
    "MSBorderInlineStartColor",
    "OBorderInlineStartColor",
    "borderInlineStartStyle",
    "MozBorderInlineStartStyle",
    "WebkitBorderInlineStartStyle",
    "MSBorderInlineStartStyle",
    "OBorderInlineStartStyle",
    "borderInlineStartWidth",
    "MozBorderInlineStartWidth",
    "WebkitBorderInlineStartWidth",
    "MSBorderInlineStartWidth",
    "OBorderInlineStartWidth",
    "borderLeft",
    "MozBorderLeft",
    "WebkitBorderLeft",
    "MSBorderLeft",
    "OBorderLeft",
    "borderLeftColor",
    "MozBorderLeftColor",
    "WebkitBorderLeftColor",
    "MSBorderLeftColor",
    "OBorderLeftColor",
    "borderLeftStyle",
    "MozBorderLeftStyle",
    "WebkitBorderLeftStyle",
    "MSBorderLeftStyle",
    "OBorderLeftStyle",
    "borderLeftWidth",
    "MozBorderLeftWidth",
    "WebkitBorderLeftWidth",
    "MSBorderLeftWidth",
    "OBorderLeftWidth",
    "borderRadius",
    "MozBorderRadius",
    "WebkitBorderRadius",
    "MSBorderRadius",
    "OBorderRadius",
    "borderRight",
    "MozBorderRight",
    "WebkitBorderRight",
    "MSBorderRight",
    "OBorderRight",
    "borderRightColor",
    "MozBorderRightColor",
    "WebkitBorderRightColor",
    "MSBorderRightColor",
    "OBorderRightColor",
    "borderRightStyle",
    "MozBorderRightStyle",
    "WebkitBorderRightStyle",
    "MSBorderRightStyle",
    "OBorderRightStyle",
    "borderRightWidth",
    "MozBorderRightWidth",
    "WebkitBorderRightWidth",
    "MSBorderRightWidth",
    "OBorderRightWidth",
    "borderSpacing",
    "MozBorderSpacing",
    "WebkitBorderSpacing",
    "MSBorderSpacing",
    "OBorderSpacing",
    "borderStyle",
    "MozBorderStyle",
    "WebkitBorderStyle",
    "MSBorderStyle",
    "OBorderStyle",
    "borderTop",
    "MozBorderTop",
    "WebkitBorderTop",
    "MSBorderTop",
    "OBorderTop",
    "borderTopColor",
    "MozBorderTopColor",
    "WebkitBorderTopColor",
    "MSBorderTopColor",
    "OBorderTopColor",
    "borderTopLeftRadius",
    "MozBorderTopLeftRadius",
    "WebkitBorderTopLeftRadius",
    "MSBorderTopLeftRadius",
    "OBorderTopLeftRadius",
    "borderTopRightRadius",
    "MozBorderTopRightRadius",
    "WebkitBorderTopRightRadius",
    "MSBorderTopRightRadius",
    "OBorderTopRightRadius",
    "borderTopStyle",
    "MozBorderTopStyle",
    "WebkitBorderTopStyle",
    "MSBorderTopStyle",
    "OBorderTopStyle",
    "borderTopWidth",
    "MozBorderTopWidth",
    "WebkitBorderTopWidth",
    "MSBorderTopWidth",
    "OBorderTopWidth",
    "borderWidth",
    "MozBorderWidth",
    "WebkitBorderWidth",
    "MSBorderWidth",
    "OBorderWidth",
    "bottom",
    "MozBottom",
    "WebkitBottom",
    "MSBottom",
    "OBottom",
    "boxDecorationBreak",
    "MozBoxDecorationBreak",
    "WebkitBoxDecorationBreak",
    "MSBoxDecorationBreak",
    "OBoxDecorationBreak",
    "boxShadow",
    "MozBoxShadow",
    "WebkitBoxShadow",
    "MSBoxShadow",
    "OBoxShadow",
    "boxSizing",
    "MozBoxSizing",
    "WebkitBoxSizing",
    "MSBoxSizing",
    "OBoxSizing",
    "breakAfter",
    "MozBreakAfter",
    "WebkitBreakAfter",
    "MSBreakAfter",
    "OBreakAfter",
    "breakBefore",
    "MozBreakBefore",
    "WebkitBreakBefore",
    "MSBreakBefore",
    "OBreakBefore",
    "breakInside",
    "MozBreakInside",
    "WebkitBreakInside",
    "MSBreakInside",
    "OBreakInside",
    "captionSide",
    "MozCaptionSide",
    "WebkitCaptionSide",
    "MSCaptionSide",
    "OCaptionSide",
    "caretColor",
    "MozCaretColor",
    "WebkitCaretColor",
    "MSCaretColor",
    "OCaretColor",
    "ch",
    "MozCh",
    "WebkitCh",
    "MSCh",
    "OCh",
    "clear",
    "MozClear",
    "WebkitClear",
    "MSClear",
    "OClear",
    "clip",
    "MozClip",
    "WebkitClip",
    "MSClip",
    "OClip",
    "clipPath",
    "MozClipPath",
    "WebkitClipPath",
    "MSClipPath",
    "OClipPath",
    "cm",
    "MozCm",
    "WebkitCm",
    "MSCm",
    "OCm",
    "color",
    "MozColor",
    "WebkitColor",
    "MSColor",
    "OColor",
    "columnCount",
    "MozColumnCount",
    "WebkitColumnCount",
    "MSColumnCount",
    "OColumnCount",
    "columnFill",
    "MozColumnFill",
    "WebkitColumnFill",
    "MSColumnFill",
    "OColumnFill",
    "columnGap",
    "MozColumnGap",
    "WebkitColumnGap",
    "MSColumnGap",
    "OColumnGap",
    "columnRule",
    "MozColumnRule",
    "WebkitColumnRule",
    "MSColumnRule",
    "OColumnRule",
    "columnRuleColor",
    "MozColumnRuleColor",
    "WebkitColumnRuleColor",
    "MSColumnRuleColor",
    "OColumnRuleColor",
    "columnRuleStyle",
    "MozColumnRuleStyle",
    "WebkitColumnRuleStyle",
    "MSColumnRuleStyle",
    "OColumnRuleStyle",
    "columnRuleWidth",
    "MozColumnRuleWidth",
    "WebkitColumnRuleWidth",
    "MSColumnRuleWidth",
    "OColumnRuleWidth",
    "columnSpan",
    "MozColumnSpan",
    "WebkitColumnSpan",
    "MSColumnSpan",
    "OColumnSpan",
    "columnWidth",
    "MozColumnWidth",
    "WebkitColumnWidth",
    "MSColumnWidth",
    "OColumnWidth",
    "columns",
    "MozColumns",
    "WebkitColumns",
    "MSColumns",
    "OColumns",
    "content",
    "MozContent",
    "WebkitContent",
    "MSContent",
    "OContent",
    "counterIncrement",
    "MozCounterIncrement",
    "WebkitCounterIncrement",
    "MSCounterIncrement",
    "OCounterIncrement",
    "counterReset",
    "MozCounterReset",
    "WebkitCounterReset",
    "MSCounterReset",
    "OCounterReset",
    "cursor",
    "MozCursor",
    "WebkitCursor",
    "MSCursor",
    "OCursor",
    "deg",
    "MozDeg",
    "WebkitDeg",
    "MSDeg",
    "ODeg",
    "direction",
    "MozDirection",
    "WebkitDirection",
    "MSDirection",
    "ODirection",
    "display",
    "MozDisplay",
    "WebkitDisplay",
    "MSDisplay",
    "ODisplay",
    "dpcm",
    "MozDpcm",
    "WebkitDpcm",
    "MSDpcm",
    "ODpcm",
    "dpi",
    "MozDpi",
    "WebkitDpi",
    "MSDpi",
    "ODpi",
    "dppx",
    "MozDppx",
    "WebkitDppx",
    "MSDppx",
    "ODppx",
    "em",
    "MozEm",
    "WebkitEm",
    "MSEm",
    "OEm",
    "emptyCells",
    "MozEmptyCells",
    "WebkitEmptyCells",
    "MSEmptyCells",
    "OEmptyCells",
    "ex",
    "MozEx",
    "WebkitEx",
    "MSEx",
    "OEx",
    "filter",
    "MozFilter",
    "WebkitFilter",
    "MSFilter",
    "OFilter",
    "flexBasis",
    "MozFlexBasis",
    "WebkitFlexBasis",
    "MSFlexBasis",
    "OFlexBasis",
    "flexDirection",
    "MozFlexDirection",
    "WebkitFlexDirection",
    "MSFlexDirection",
    "OFlexDirection",
    "flexFlow",
    "MozFlexFlow",
    "WebkitFlexFlow",
    "MSFlexFlow",
    "OFlexFlow",
    "flexGrow",
    "MozFlexGrow",
    "WebkitFlexGrow",
    "MSFlexGrow",
    "OFlexGrow",
    "flexShrink",
    "MozFlexShrink",
    "WebkitFlexShrink",
    "MSFlexShrink",
    "OFlexShrink",
    "flexWrap",
    "MozFlexWrap",
    "WebkitFlexWrap",
    "MSFlexWrap",
    "OFlexWrap",
    "float",
    "MozFloat",
    "WebkitFloat",
    "MSFloat",
    "OFloat",
    "font",
    "MozFont",
    "WebkitFont",
    "MSFont",
    "OFont",
    "fontFamily",
    "MozFontFamily",
    "WebkitFontFamily",
    "MSFontFamily",
    "OFontFamily",
    "fontFeatureSettings",
    "MozFontFeatureSettings",
    "WebkitFontFeatureSettings",
    "MSFontFeatureSettings",
    "OFontFeatureSettings",
    "fontKerning",
    "MozFontKerning",
    "WebkitFontKerning",
    "MSFontKerning",
    "OFontKerning",
    "fontLanguageOverride",
    "MozFontLanguageOverride",
    "WebkitFontLanguageOverride",
    "MSFontLanguageOverride",
    "OFontLanguageOverride",
    "fontSize",
    "MozFontSize",
    "WebkitFontSize",
    "MSFontSize",
    "OFontSize",
    "fontSizeAdjust",
    "MozFontSizeAdjust",
    "WebkitFontSizeAdjust",
    "MSFontSizeAdjust",
    "OFontSizeAdjust",
    "fontStretch",
    "MozFontStretch",
    "WebkitFontStretch",
    "MSFontStretch",
    "OFontStretch",
    "fontStyle",
    "MozFontStyle",
    "WebkitFontStyle",
    "MSFontStyle",
    "OFontStyle",
    "fontSynthesis",
    "MozFontSynthesis",
    "WebkitFontSynthesis",
    "MSFontSynthesis",
    "OFontSynthesis",
    "fontVariant",
    "MozFontVariant",
    "WebkitFontVariant",
    "MSFontVariant",
    "OFontVariant",
    "fontVariantAlternates",
    "MozFontVariantAlternates",
    "WebkitFontVariantAlternates",
    "MSFontVariantAlternates",
    "OFontVariantAlternates",
    "fontVariantCaps",
    "MozFontVariantCaps",
    "WebkitFontVariantCaps",
    "MSFontVariantCaps",
    "OFontVariantCaps",
    "fontVariantEastAsian",
    "MozFontVariantEastAsian",
    "WebkitFontVariantEastAsian",
    "MSFontVariantEastAsian",
    "OFontVariantEastAsian",
    "fontVariantLigatures",
    "MozFontVariantLigatures",
    "WebkitFontVariantLigatures",
    "MSFontVariantLigatures",
    "OFontVariantLigatures",
    "fontVariantNumeric",
    "MozFontVariantNumeric",
    "WebkitFontVariantNumeric",
    "MSFontVariantNumeric",
    "OFontVariantNumeric",
    "fontVariantPosition",
    "MozFontVariantPosition",
    "WebkitFontVariantPosition",
    "MSFontVariantPosition",
    "OFontVariantPosition",
    "fontWeight",
    "MozFontWeight",
    "WebkitFontWeight",
    "MSFontWeight",
    "OFontWeight",
    "fr",
    "MozFr",
    "WebkitFr",
    "MSFr",
    "OFr",
    "grad",
    "MozGrad",
    "WebkitGrad",
    "MSGrad",
    "OGrad",
    "grid",
    "MozGrid",
    "WebkitGrid",
    "MSGrid",
    "OGrid",
    "gridArea",
    "MozGridArea",
    "WebkitGridArea",
    "MSGridArea",
    "OGridArea",
    "gridAutoColumns",
    "MozGridAutoColumns",
    "WebkitGridAutoColumns",
    "MSGridAutoColumns",
    "OGridAutoColumns",
    "gridAutoFlow",
    "MozGridAutoFlow",
    "WebkitGridAutoFlow",
    "MSGridAutoFlow",
    "OGridAutoFlow",
    "gridAutoRows",
    "MozGridAutoRows",
    "WebkitGridAutoRows",
    "MSGridAutoRows",
    "OGridAutoRows",
    "gridColumn",
    "MozGridColumn",
    "WebkitGridColumn",
    "MSGridColumn",
    "OGridColumn",
    "gridColumnEnd",
    "MozGridColumnEnd",
    "WebkitGridColumnEnd",
    "MSGridColumnEnd",
    "OGridColumnEnd",
    "gridColumnGap",
    "MozGridColumnGap",
    "WebkitGridColumnGap",
    "MSGridColumnGap",
    "OGridColumnGap",
    "gridColumnStart",
    "MozGridColumnStart",
    "WebkitGridColumnStart",
    "MSGridColumnStart",
    "OGridColumnStart",
    "gridGap",
    "MozGridGap",
    "WebkitGridGap",
    "MSGridGap",
    "OGridGap",
    "gridRow",
    "MozGridRow",
    "WebkitGridRow",
    "MSGridRow",
    "OGridRow",
    "gridRowEnd",
    "MozGridRowEnd",
    "WebkitGridRowEnd",
    "MSGridRowEnd",
    "OGridRowEnd",
    "gridRowGap",
    "MozGridRowGap",
    "WebkitGridRowGap",
    "MSGridRowGap",
    "OGridRowGap",
    "gridRowStart",
    "MozGridRowStart",
    "WebkitGridRowStart",
    "MSGridRowStart",
    "OGridRowStart",
    "gridTemplate",
    "MozGridTemplate",
    "WebkitGridTemplate",
    "MSGridTemplate",
    "OGridTemplate",
    "gridTemplateAreas",
    "MozGridTemplateAreas",
    "WebkitGridTemplateAreas",
    "MSGridTemplateAreas",
    "OGridTemplateAreas",
    "gridTemplateColumns",
    "MozGridTemplateColumns",
    "WebkitGridTemplateColumns",
    "MSGridTemplateColumns",
    "OGridTemplateColumns",
    "gridTemplateRows",
    "MozGridTemplateRows",
    "WebkitGridTemplateRows",
    "MSGridTemplateRows",
    "OGridTemplateRows",
    "height",
    "MozHeight",
    "WebkitHeight",
    "MSHeight",
    "OHeight",
    "hyphens",
    "MozHyphens",
    "WebkitHyphens",
    "MSHyphens",
    "OHyphens",
    "hz",
    "MozHz",
    "WebkitHz",
    "MSHz",
    "OHz",
    "imageOrientation",
    "MozImageOrientation",
    "WebkitImageOrientation",
    "MSImageOrientation",
    "OImageOrientation",
    "imageRendering",
    "MozImageRendering",
    "WebkitImageRendering",
    "MSImageRendering",
    "OImageRendering",
    "imageResolution",
    "MozImageResolution",
    "WebkitImageResolution",
    "MSImageResolution",
    "OImageResolution",
    "imeMode",
    "MozImeMode",
    "WebkitImeMode",
    "MSImeMode",
    "OImeMode",
    "in",
    "MozIn",
    "WebkitIn",
    "MSIn",
    "OIn",
    "inherit",
    "MozInherit",
    "WebkitInherit",
    "MSInherit",
    "OInherit",
    "initial",
    "MozInitial",
    "WebkitInitial",
    "MSInitial",
    "OInitial",
    "inlineSize",
    "MozInlineSize",
    "WebkitInlineSize",
    "MSInlineSize",
    "OInlineSize",
    "isolation",
    "MozIsolation",
    "WebkitIsolation",
    "MSIsolation",
    "OIsolation",
    "justifyContent",
    "MozJustifyContent",
    "WebkitJustifyContent",
    "MSJustifyContent",
    "OJustifyContent",
    "khz",
    "MozKhz",
    "WebkitKhz",
    "MSKhz",
    "OKhz",
    "left",
    "MozLeft",
    "WebkitLeft",
    "MSLeft",
    "OLeft",
    "letterSpacing",
    "MozLetterSpacing",
    "WebkitLetterSpacing",
    "MSLetterSpacing",
    "OLetterSpacing",
    "lineBreak",
    "MozLineBreak",
    "WebkitLineBreak",
    "MSLineBreak",
    "OLineBreak",
    "lineHeight",
    "MozLineHeight",
    "WebkitLineHeight",
    "MSLineHeight",
    "OLineHeight",
    "listStyle",
    "MozListStyle",
    "WebkitListStyle",
    "MSListStyle",
    "OListStyle",
    "listStyleImage",
    "MozListStyleImage",
    "WebkitListStyleImage",
    "MSListStyleImage",
    "OListStyleImage",
    "listStylePosition",
    "MozListStylePosition",
    "WebkitListStylePosition",
    "MSListStylePosition",
    "OListStylePosition",
    "listStyleType",
    "MozListStyleType",
    "WebkitListStyleType",
    "MSListStyleType",
    "OListStyleType",
    "margin",
    "MozMargin",
    "WebkitMargin",
    "MSMargin",
    "OMargin",
    "marginBlockEnd",
    "MozMarginBlockEnd",
    "WebkitMarginBlockEnd",
    "MSMarginBlockEnd",
    "OMarginBlockEnd",
    "marginBlockStart",
    "MozMarginBlockStart",
    "WebkitMarginBlockStart",
    "MSMarginBlockStart",
    "OMarginBlockStart",
    "marginBottom",
    "MozMarginBottom",
    "WebkitMarginBottom",
    "MSMarginBottom",
    "OMarginBottom",
    "marginInlineEnd",
    "MozMarginInlineEnd",
    "WebkitMarginInlineEnd",
    "MSMarginInlineEnd",
    "OMarginInlineEnd",
    "marginInlineStart",
    "MozMarginInlineStart",
    "WebkitMarginInlineStart",
    "MSMarginInlineStart",
    "OMarginInlineStart",
    "marginLeft",
    "MozMarginLeft",
    "WebkitMarginLeft",
    "MSMarginLeft",
    "OMarginLeft",
    "marginRight",
    "MozMarginRight",
    "WebkitMarginRight",
    "MSMarginRight",
    "OMarginRight",
    "marginTop",
    "MozMarginTop",
    "WebkitMarginTop",
    "MSMarginTop",
    "OMarginTop",
    "mask",
    "MozMask",
    "WebkitMask",
    "MSMask",
    "OMask",
    "maskClip",
    "MozMaskClip",
    "WebkitMaskClip",
    "MSMaskClip",
    "OMaskClip",
    "maskComposite",
    "MozMaskComposite",
    "WebkitMaskComposite",
    "MSMaskComposite",
    "OMaskComposite",
    "maskImage",
    "MozMaskImage",
    "WebkitMaskImage",
    "MSMaskImage",
    "OMaskImage",
    "maskMode",
    "MozMaskMode",
    "WebkitMaskMode",
    "MSMaskMode",
    "OMaskMode",
    "maskOrigin",
    "MozMaskOrigin",
    "WebkitMaskOrigin",
    "MSMaskOrigin",
    "OMaskOrigin",
    "maskPosition",
    "MozMaskPosition",
    "WebkitMaskPosition",
    "MSMaskPosition",
    "OMaskPosition",
    "maskRepeat",
    "MozMaskRepeat",
    "WebkitMaskRepeat",
    "MSMaskRepeat",
    "OMaskRepeat",
    "maskSize",
    "MozMaskSize",
    "WebkitMaskSize",
    "MSMaskSize",
    "OMaskSize",
    "maskType",
    "MozMaskType",
    "WebkitMaskType",
    "MSMaskType",
    "OMaskType",
    "maxHeight",
    "MozMaxHeight",
    "WebkitMaxHeight",
    "MSMaxHeight",
    "OMaxHeight",
    "maxWidth",
    "MozMaxWidth",
    "WebkitMaxWidth",
    "MSMaxWidth",
    "OMaxWidth",
    "minBlockSize",
    "MozMinBlockSize",
    "WebkitMinBlockSize",
    "MSMinBlockSize",
    "OMinBlockSize",
    "minHeight",
    "MozMinHeight",
    "WebkitMinHeight",
    "MSMinHeight",
    "OMinHeight",
    "minInlineSize",
    "MozMinInlineSize",
    "WebkitMinInlineSize",
    "MSMinInlineSize",
    "OMinInlineSize",
    "minWidth",
    "MozMinWidth",
    "WebkitMinWidth",
    "MSMinWidth",
    "OMinWidth",
    "mixBlendMode",
    "MozMixBlendMode",
    "WebkitMixBlendMode",
    "MSMixBlendMode",
    "OMixBlendMode",
    "mm",
    "MozMm",
    "WebkitMm",
    "MSMm",
    "OMm",
    "ms",
    "MozMs",
    "WebkitMs",
    "MSMs",
    "OMs",
    "objectFit",
    "MozObjectFit",
    "WebkitObjectFit",
    "MSObjectFit",
    "OObjectFit",
    "objectPosition",
    "MozObjectPosition",
    "WebkitObjectPosition",
    "MSObjectPosition",
    "OObjectPosition",
    "offsetBlockEnd",
    "MozOffsetBlockEnd",
    "WebkitOffsetBlockEnd",
    "MSOffsetBlockEnd",
    "OOffsetBlockEnd",
    "offsetBlockStart",
    "MozOffsetBlockStart",
    "WebkitOffsetBlockStart",
    "MSOffsetBlockStart",
    "OOffsetBlockStart",
    "offsetInlineEnd",
    "MozOffsetInlineEnd",
    "WebkitOffsetInlineEnd",
    "MSOffsetInlineEnd",
    "OOffsetInlineEnd",
    "offsetInlineStart",
    "MozOffsetInlineStart",
    "WebkitOffsetInlineStart",
    "MSOffsetInlineStart",
    "OOffsetInlineStart",
    "opacity",
    "MozOpacity",
    "WebkitOpacity",
    "MSOpacity",
    "OOpacity",
    "order",
    "MozOrder",
    "WebkitOrder",
    "MSOrder",
    "OOrder",
    "orphans",
    "MozOrphans",
    "WebkitOrphans",
    "MSOrphans",
    "OOrphans",
    "outline",
    "MozOutline",
    "WebkitOutline",
    "MSOutline",
    "OOutline",
    "outlineColor",
    "MozOutlineColor",
    "WebkitOutlineColor",
    "MSOutlineColor",
    "OOutlineColor",
    "outlineOffset",
    "MozOutlineOffset",
    "WebkitOutlineOffset",
    "MSOutlineOffset",
    "OOutlineOffset",
    "outlineStyle",
    "MozOutlineStyle",
    "WebkitOutlineStyle",
    "MSOutlineStyle",
    "OOutlineStyle",
    "outlineWidth",
    "MozOutlineWidth",
    "WebkitOutlineWidth",
    "MSOutlineWidth",
    "OOutlineWidth",
    "overflow",
    "MozOverflow",
    "WebkitOverflow",
    "MSOverflow",
    "OOverflow",
    "overflowWrap",
    "MozOverflowWrap",
    "WebkitOverflowWrap",
    "MSOverflowWrap",
    "OOverflowWrap",
    "overflowX",
    "MozOverflowX",
    "WebkitOverflowX",
    "MSOverflowX",
    "OOverflowX",
    "overflowY",
    "MozOverflowY",
    "WebkitOverflowY",
    "MSOverflowY",
    "OOverflowY",
    "padding",
    "MozPadding",
    "WebkitPadding",
    "MSPadding",
    "OPadding",
    "paddingBlockEnd",
    "MozPaddingBlockEnd",
    "WebkitPaddingBlockEnd",
    "MSPaddingBlockEnd",
    "OPaddingBlockEnd",
    "paddingBlockStart",
    "MozPaddingBlockStart",
    "WebkitPaddingBlockStart",
    "MSPaddingBlockStart",
    "OPaddingBlockStart",
    "paddingBottom",
    "MozPaddingBottom",
    "WebkitPaddingBottom",
    "MSPaddingBottom",
    "OPaddingBottom",
    "paddingInlineEnd",
    "MozPaddingInlineEnd",
    "WebkitPaddingInlineEnd",
    "MSPaddingInlineEnd",
    "OPaddingInlineEnd",
    "paddingInlineStart",
    "MozPaddingInlineStart",
    "WebkitPaddingInlineStart",
    "MSPaddingInlineStart",
    "OPaddingInlineStart",
    "paddingLeft",
    "MozPaddingLeft",
    "WebkitPaddingLeft",
    "MSPaddingLeft",
    "OPaddingLeft",
    "paddingRight",
    "MozPaddingRight",
    "WebkitPaddingRight",
    "MSPaddingRight",
    "OPaddingRight",
    "paddingTop",
    "MozPaddingTop",
    "WebkitPaddingTop",
    "MSPaddingTop",
    "OPaddingTop",
    "pageBreakAfter",
    "MozPageBreakAfter",
    "WebkitPageBreakAfter",
    "MSPageBreakAfter",
    "OPageBreakAfter",
    "pageBreakBefore",
    "MozPageBreakBefore",
    "WebkitPageBreakBefore",
    "MSPageBreakBefore",
    "OPageBreakBefore",
    "pageBreakInside",
    "MozPageBreakInside",
    "WebkitPageBreakInside",
    "MSPageBreakInside",
    "OPageBreakInside",
    "pc",
    "MozPc",
    "WebkitPc",
    "MSPc",
    "OPc",
    "perspective",
    "MozPerspective",
    "WebkitPerspective",
    "MSPerspective",
    "OPerspective",
    "perspectiveOrigin",
    "MozPerspectiveOrigin",
    "WebkitPerspectiveOrigin",
    "MSPerspectiveOrigin",
    "OPerspectiveOrigin",
    "pointerEvents",
    "MozPointerEvents",
    "WebkitPointerEvents",
    "MSPointerEvents",
    "OPointerEvents",
    "position",
    "MozPosition",
    "WebkitPosition",
    "MSPosition",
    "OPosition",
    "pt",
    "MozPt",
    "WebkitPt",
    "MSPt",
    "OPt",
    "px",
    "MozPx",
    "WebkitPx",
    "MSPx",
    "OPx",
    "q",
    "MozQ",
    "WebkitQ",
    "MSQ",
    "OQ",
    "quotes",
    "MozQuotes",
    "WebkitQuotes",
    "MSQuotes",
    "OQuotes",
    "rad",
    "MozRad",
    "WebkitRad",
    "MSRad",
    "ORad",
    "rem",
    "MozRem",
    "WebkitRem",
    "MSRem",
    "ORem",
    "resize",
    "MozResize",
    "WebkitResize",
    "MSResize",
    "OResize",
    "revert",
    "MozRevert",
    "WebkitRevert",
    "MSRevert",
    "ORevert",
    "right",
    "MozRight",
    "WebkitRight",
    "MSRight",
    "ORight",
    "rubyAlign",
    "MozRubyAlign",
    "WebkitRubyAlign",
    "MSRubyAlign",
    "ORubyAlign",
    "rubyMerge",
    "MozRubyMerge",
    "WebkitRubyMerge",
    "MSRubyMerge",
    "ORubyMerge",
    "rubyPosition",
    "MozRubyPosition",
    "WebkitRubyPosition",
    "MSRubyPosition",
    "ORubyPosition",
    "s",
    "MozS",
    "WebkitS",
    "MSS",
    "OS",
    "scrollBehavior",
    "MozScrollBehavior",
    "WebkitScrollBehavior",
    "MSScrollBehavior",
    "OScrollBehavior",
    "scrollSnapCoordinate",
    "MozScrollSnapCoordinate",
    "WebkitScrollSnapCoordinate",
    "MSScrollSnapCoordinate",
    "OScrollSnapCoordinate",
    "scrollSnapDestination",
    "MozScrollSnapDestination",
    "WebkitScrollSnapDestination",
    "MSScrollSnapDestination",
    "OScrollSnapDestination",
    "scrollSnapType",
    "MozScrollSnapType",
    "WebkitScrollSnapType",
    "MSScrollSnapType",
    "OScrollSnapType",
    "shapeImageThreshold",
    "MozShapeImageThreshold",
    "WebkitShapeImageThreshold",
    "MSShapeImageThreshold",
    "OShapeImageThreshold",
    "shapeMargin",
    "MozShapeMargin",
    "WebkitShapeMargin",
    "MSShapeMargin",
    "OShapeMargin",
    "shapeOutside",
    "MozShapeOutside",
    "WebkitShapeOutside",
    "MSShapeOutside",
    "OShapeOutside",
    "tabSize",
    "MozTabSize",
    "WebkitTabSize",
    "MSTabSize",
    "OTabSize",
    "tableLayout",
    "MozTableLayout",
    "WebkitTableLayout",
    "MSTableLayout",
    "OTableLayout",
    "textAlign",
    "MozTextAlign",
    "WebkitTextAlign",
    "MSTextAlign",
    "OTextAlign",
    "textAlignLast",
    "MozTextAlignLast",
    "WebkitTextAlignLast",
    "MSTextAlignLast",
    "OTextAlignLast",
    "textCombineUpright",
    "MozTextCombineUpright",
    "WebkitTextCombineUpright",
    "MSTextCombineUpright",
    "OTextCombineUpright",
    "textDecoration",
    "MozTextDecoration",
    "WebkitTextDecoration",
    "MSTextDecoration",
    "OTextDecoration",
    "textDecorationColor",
    "MozTextDecorationColor",
    "WebkitTextDecorationColor",
    "MSTextDecorationColor",
    "OTextDecorationColor",
    "textDecorationLine",
    "MozTextDecorationLine",
    "WebkitTextDecorationLine",
    "MSTextDecorationLine",
    "OTextDecorationLine",
    "textDecorationStyle",
    "MozTextDecorationStyle",
    "WebkitTextDecorationStyle",
    "MSTextDecorationStyle",
    "OTextDecorationStyle",
    "textEmphasis",
    "MozTextEmphasis",
    "WebkitTextEmphasis",
    "MSTextEmphasis",
    "OTextEmphasis",
    "textEmphasisColor",
    "MozTextEmphasisColor",
    "WebkitTextEmphasisColor",
    "MSTextEmphasisColor",
    "OTextEmphasisColor",
    "textEmphasisPosition",
    "MozTextEmphasisPosition",
    "WebkitTextEmphasisPosition",
    "MSTextEmphasisPosition",
    "OTextEmphasisPosition",
    "textEmphasisStyle",
    "MozTextEmphasisStyle",
    "WebkitTextEmphasisStyle",
    "MSTextEmphasisStyle",
    "OTextEmphasisStyle",
    "textIndent",
    "MozTextIndent",
    "WebkitTextIndent",
    "MSTextIndent",
    "OTextIndent",
    "textOrientation",
    "MozTextOrientation",
    "WebkitTextOrientation",
    "MSTextOrientation",
    "OTextOrientation",
    "textOverflow",
    "MozTextOverflow",
    "WebkitTextOverflow",
    "MSTextOverflow",
    "OTextOverflow",
    "textRendering",
    "MozTextRendering",
    "WebkitTextRendering",
    "MSTextRendering",
    "OTextRendering",
    "textShadow",
    "MozTextShadow",
    "WebkitTextShadow",
    "MSTextShadow",
    "OTextShadow",
    "textTransform",
    "MozTextTransform",
    "WebkitTextTransform",
    "MSTextTransform",
    "OTextTransform",
    "textUnderlinePosition",
    "MozTextUnderlinePosition",
    "WebkitTextUnderlinePosition",
    "MSTextUnderlinePosition",
    "OTextUnderlinePosition",
    "top",
    "MozTop",
    "WebkitTop",
    "MSTop",
    "OTop",
    "touchAction",
    "MozTouchAction",
    "WebkitTouchAction",
    "MSTouchAction",
    "OTouchAction",
    "transform",
    "MozTransform",
    "WebkitTransform",
    "msTransform",
    "OTransform",
    "transformBox",
    "MozTransformBox",
    "WebkitTransformBox",
    "MSTransformBox",
    "OTransformBox",
    "transformOrigin",
    "MozTransformOrigin",
    "WebkitTransformOrigin",
    "MSTransformOrigin",
    "OTransformOrigin",
    "transformStyle",
    "MozTransformStyle",
    "WebkitTransformStyle",
    "MSTransformStyle",
    "OTransformStyle",
    "transition",
    "MozTransition",
    "WebkitTransition",
    "MSTransition",
    "OTransition",
    "transitionDelay",
    "MozTransitionDelay",
    "WebkitTransitionDelay",
    "MSTransitionDelay",
    "OTransitionDelay",
    "transitionDuration",
    "MozTransitionDuration",
    "WebkitTransitionDuration",
    "MSTransitionDuration",
    "OTransitionDuration",
    "transitionProperty",
    "MozTransitionProperty",
    "WebkitTransitionProperty",
    "MSTransitionProperty",
    "OTransitionProperty",
    "transitionTimingFunction",
    "MozTransitionTimingFunction",
    "WebkitTransitionTimingFunction",
    "MSTransitionTimingFunction",
    "OTransitionTimingFunction",
    "turn",
    "MozTurn",
    "WebkitTurn",
    "MSTurn",
    "OTurn",
    "unicodeBidi",
    "MozUnicodeBidi",
    "WebkitUnicodeBidi",
    "MSUnicodeBidi",
    "OUnicodeBidi",
    "unset",
    "MozUnset",
    "WebkitUnset",
    "MSUnset",
    "OUnset",
    "verticalAlign",
    "MozVerticalAlign",
    "WebkitVerticalAlign",
    "MSVerticalAlign",
    "OVerticalAlign",
    "vh",
    "MozVh",
    "WebkitVh",
    "MSVh",
    "OVh",
    "visibility",
    "MozVisibility",
    "WebkitVisibility",
    "MSVisibility",
    "OVisibility",
    "vmax",
    "MozVmax",
    "WebkitVmax",
    "MSVmax",
    "OVmax",
    "vmin",
    "MozVmin",
    "WebkitVmin",
    "MSVmin",
    "OVmin",
    "vw",
    "MozVw",
    "WebkitVw",
    "MSVw",
    "OVw",
    "whiteSpace",
    "MozWhiteSpace",
    "WebkitWhiteSpace",
    "MSWhiteSpace",
    "OWhiteSpace",
    "widows",
    "MozWidows",
    "WebkitWidows",
    "MSWidows",
    "OWidows",
    "width",
    "MozWidth",
    "WebkitWidth",
    "MSWidth",
    "OWidth",
    "willChange",
    "MozWillChange",
    "WebkitWillChange",
    "MSWillChange",
    "OWillChange",
    "wordBreak",
    "MozWordBreak",
    "WebkitWordBreak",
    "MSWordBreak",
    "OWordBreak",
    "wordSpacing",
    "MozWordSpacing",
    "WebkitWordSpacing",
    "MSWordSpacing",
    "OWordSpacing",
    "wordWrap",
    "MozWordWrap",
    "WebkitWordWrap",
    "MSWordWrap",
    "OWordWrap",
    "writingMode",
    "MozWritingMode",
    "WebkitWritingMode",
    "MSWritingMode",
    "OWritingMode",
    "zIndex",
    "MozZIndex",
    "WebkitZIndex",
    "MSZIndex",
    "OZIndex",
    "fontSize",
    "MozFontSize",
    "WebkitFontSize",
    "MSFontSize",
    "OFontSize",
    "flex",
    "MozFlex",
    "WebkitFlex",
    "MSFlex",
    "OFlex",
    "fr",
    "MozFr",
    "WebkitFr",
    "MSFr",
    "OFr",
    "overflowScrolling",
    "MozOverflowScrolling",
    "WebkitOverflowScrolling",
    "MSOverflowScrolling",
    "OOverflowScrolling",
    "userSelect",
    "MozUserSelect",
    "WebkitUserSelect",
    "MSUserSelect",
    "OUserSelect"
];

},{}],"itCeo":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jTcSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if (isDate(val)) return 'date';
    if (isError(val)) return 'error';
    var constructorName = ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dn9qZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"ibVzI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ibVzI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"awXxm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awXxm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"8oq3j","./toPrimitive.js":"e5E6H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8oq3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e5E6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"8oq3j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"wC9No":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RECEIVE_CURRENT_USER", ()=>RECEIVE_CURRENT_USER);
parcelHelpers.export(exports, "EXPORT_VEGA", ()=>EXPORT_VEGA);
parcelHelpers.export(exports, "LOG_ERROR", ()=>LOG_ERROR);
parcelHelpers.export(exports, "PARSE_SPEC", ()=>PARSE_SPEC);
parcelHelpers.export(exports, "SET_BASEURL", ()=>SET_BASEURL);
parcelHelpers.export(exports, "SET_COMPILED_VEGA_PANE_SIZE", ()=>SET_COMPILED_VEGA_PANE_SIZE);
parcelHelpers.export(exports, "SET_DEBUG_PANE_SIZE", ()=>SET_DEBUG_PANE_SIZE);
parcelHelpers.export(exports, "SET_EDITOR_REFERENCE", ()=>SET_EDITOR_REFERENCE);
parcelHelpers.export(exports, "SET_GIST_VEGA_LITE_SPEC", ()=>SET_GIST_VEGA_LITE_SPEC);
parcelHelpers.export(exports, "SET_GIST_VEGA_SPEC", ()=>SET_GIST_VEGA_SPEC);
parcelHelpers.export(exports, "SET_MODE", ()=>SET_MODE);
parcelHelpers.export(exports, "SET_MODE_ONLY", ()=>SET_MODE_ONLY);
parcelHelpers.export(exports, "SET_SCROLL_POSITION", ()=>SET_SCROLL_POSITION);
parcelHelpers.export(exports, "SET_RENDERER", ()=>SET_RENDERER);
parcelHelpers.export(exports, "SET_VEGA_EXAMPLE", ()=>SET_VEGA_EXAMPLE);
parcelHelpers.export(exports, "SET_VEGA_LITE_EXAMPLE", ()=>SET_VEGA_LITE_EXAMPLE);
parcelHelpers.export(exports, "SET_VIEW", ()=>SET_VIEW);
parcelHelpers.export(exports, "SHOW_LOGS", ()=>SHOW_LOGS);
parcelHelpers.export(exports, "TOGGLE_AUTO_PARSE", ()=>TOGGLE_AUTO_PARSE);
parcelHelpers.export(exports, "TOGGLE_COMPILED_VEGA_SPEC", ()=>TOGGLE_COMPILED_VEGA_SPEC);
parcelHelpers.export(exports, "TOGGLE_DEBUG_PANE", ()=>TOGGLE_DEBUG_PANE);
parcelHelpers.export(exports, "TOGGLE_GIST_PRIVACY", ()=>TOGGLE_GIST_PRIVACY);
parcelHelpers.export(exports, "TOGGLE_NAV_BAR", ()=>TOGGLE_NAV_BAR);
parcelHelpers.export(exports, "UPDATE_EDITOR_STRING", ()=>UPDATE_EDITOR_STRING);
parcelHelpers.export(exports, "UPDATE_VEGA_LITE_SPEC", ()=>UPDATE_VEGA_LITE_SPEC);
parcelHelpers.export(exports, "UPDATE_VEGA_SPEC", ()=>UPDATE_VEGA_SPEC);
parcelHelpers.export(exports, "SET_SETTINGS", ()=>SET_SETTINGS);
parcelHelpers.export(exports, "SET_CONFIG", ()=>SET_CONFIG);
parcelHelpers.export(exports, "SET_THEME_NAME", ()=>SET_THEME_NAME);
parcelHelpers.export(exports, "SET_SIDEPANE_ITEM", ()=>SET_SIDEPANE_ITEM);
parcelHelpers.export(exports, "SET_COMPILEDPANE_ITEM", ()=>SET_COMPILEDPANE_ITEM);
parcelHelpers.export(exports, "SET_CONFIG_EDITOR_STRING", ()=>SET_CONFIG_EDITOR_STRING);
parcelHelpers.export(exports, "SET_LOG_LEVEL", ()=>SET_LOG_LEVEL);
parcelHelpers.export(exports, "SET_HOVER", ()=>SET_HOVER);
parcelHelpers.export(exports, "SET_TOOLTIP", ()=>SET_TOOLTIP);
parcelHelpers.export(exports, "CLEAR_CONFIG", ()=>CLEAR_CONFIG);
parcelHelpers.export(exports, "MERGE_CONFIG_SPEC", ()=>MERGE_CONFIG_SPEC);
parcelHelpers.export(exports, "EXTRACT_CONFIG_SPEC", ()=>EXTRACT_CONFIG_SPEC);
parcelHelpers.export(exports, "SET_SIGNALS", ()=>SET_SIGNALS);
parcelHelpers.export(exports, "ADD_SIGNAL", ()=>ADD_SIGNAL);
parcelHelpers.export(exports, "SET_DECORATION", ()=>SET_DECORATION);
parcelHelpers.export(exports, "SET_COMPILED_EDITOR_REFERENCE", ()=>SET_COMPILED_EDITOR_REFERENCE);
parcelHelpers.export(exports, "SET_EDITOR_FOCUS", ()=>SET_EDITOR_FOCUS);
parcelHelpers.export(exports, "SET_BACKGROUND_COLOR", ()=>SET_BACKGROUND_COLOR);
parcelHelpers.export(exports, "SET_EXPRESSION_INTERPRETER", ()=>SET_EXPRESSION_INTERPRETER);
parcelHelpers.export(exports, "ERROR", ()=>ERROR);
parcelHelpers.export(exports, "WARN", ()=>WARN);
parcelHelpers.export(exports, "INFO", ()=>INFO);
parcelHelpers.export(exports, "DEBUG", ()=>DEBUG);
parcelHelpers.export(exports, "setMode", ()=>setMode);
parcelHelpers.export(exports, "setModeOnly", ()=>setModeOnly);
parcelHelpers.export(exports, "setScrollPosition", ()=>setScrollPosition);
parcelHelpers.export(exports, "parseSpec", ()=>parseSpec);
parcelHelpers.export(exports, "setVegaExample", ()=>setVegaExample);
parcelHelpers.export(exports, "setVegaLiteExample", ()=>setVegaLiteExample);
parcelHelpers.export(exports, "updateVegaSpec", ()=>updateVegaSpec);
parcelHelpers.export(exports, "updateVegaLiteSpec", ()=>updateVegaLiteSpec);
parcelHelpers.export(exports, "setGistVegaSpec", ()=>setGistVegaSpec);
parcelHelpers.export(exports, "setGistVegaLiteSpec", ()=>setGistVegaLiteSpec);
parcelHelpers.export(exports, "toggleAutoParse", ()=>toggleAutoParse);
parcelHelpers.export(exports, "toggleCompiledVegaSpec", ()=>toggleCompiledVegaSpec);
parcelHelpers.export(exports, "toggleDebugPane", ()=>toggleDebugPane);
parcelHelpers.export(exports, "logError", ()=>logError);
parcelHelpers.export(exports, "updateEditorString", ()=>updateEditorString);
parcelHelpers.export(exports, "exportVega", ()=>exportVega);
parcelHelpers.export(exports, "setRenderer", ()=>setRenderer);
parcelHelpers.export(exports, "setBaseUrl", ()=>setBaseUrl);
parcelHelpers.export(exports, "setView", ()=>setView);
parcelHelpers.export(exports, "setDebugPaneSize", ()=>setDebugPaneSize);
parcelHelpers.export(exports, "showLogs", ()=>showLogs);
parcelHelpers.export(exports, "setCompiledVegaPaneSize", ()=>setCompiledVegaPaneSize);
parcelHelpers.export(exports, "toggleNavbar", ()=>toggleNavbar);
parcelHelpers.export(exports, "setSettingsState", ()=>setSettingsState);
parcelHelpers.export(exports, "setConfig", ()=>setConfig);
parcelHelpers.export(exports, "setConfigEditorString", ()=>setConfigEditorString);
parcelHelpers.export(exports, "setThemeName", ()=>setThemeName);
parcelHelpers.export(exports, "setSidePaneItem", ()=>setSidePaneItem);
parcelHelpers.export(exports, "setEditorReference", ()=>setEditorReference);
parcelHelpers.export(exports, "setCompiledEditorRef", ()=>setCompiledEditorRef);
parcelHelpers.export(exports, "setCompiledPaneItem", ()=>setCompiledPaneItem);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
parcelHelpers.export(exports, "setHover", ()=>setHover);
parcelHelpers.export(exports, "setTooltip", ()=>setTooltip);
parcelHelpers.export(exports, "clearConfig", ()=>clearConfig);
parcelHelpers.export(exports, "mergeConfigSpec", ()=>mergeConfigSpec);
parcelHelpers.export(exports, "extractConfigSpec", ()=>extractConfigSpec);
parcelHelpers.export(exports, "setSignals", ()=>setSignals);
parcelHelpers.export(exports, "addSignal", ()=>addSignal);
parcelHelpers.export(exports, "setDecorations", ()=>setDecorations);
parcelHelpers.export(exports, "setEditorFocus", ()=>setEditorFocus);
parcelHelpers.export(exports, "receiveCurrentUser", ()=>receiveCurrentUser);
parcelHelpers.export(exports, "toggleGistPrivacy", ()=>toggleGistPrivacy);
parcelHelpers.export(exports, "setBackgroundColor", ()=>setBackgroundColor);
parcelHelpers.export(exports, "addError", ()=>addError);
parcelHelpers.export(exports, "addWarning", ()=>addWarning);
parcelHelpers.export(exports, "addInfo", ()=>addInfo);
parcelHelpers.export(exports, "addDebug", ()=>addDebug);
parcelHelpers.export(exports, "setExpressionInterpreter", ()=>setExpressionInterpreter);
const RECEIVE_CURRENT_USER = 'RECEIVE_CURRENT_USER';
const EXPORT_VEGA = 'EXPORT_VEGA';
const LOG_ERROR = 'LOG_ERROR';
const PARSE_SPEC = 'PARSE_SPEC';
const SET_BASEURL = 'SET_BASEURL';
const SET_COMPILED_VEGA_PANE_SIZE = 'SET_COMPILED_VEGA_PANE_SIZE';
const SET_DEBUG_PANE_SIZE = 'SET_DEBUG_PANE_SIZE';
const SET_EDITOR_REFERENCE = 'SET_EDITOR_REFERENCE';
const SET_GIST_VEGA_LITE_SPEC = 'SET_GIST_VEGA_LITE_SPEC';
const SET_GIST_VEGA_SPEC = 'SET_GIST_VEGA_SPEC';
const SET_MODE = 'SET_MODE';
const SET_MODE_ONLY = 'SET_MODE_ONLY';
const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';
const SET_RENDERER = 'SET_RENDERER';
const SET_VEGA_EXAMPLE = 'SET_VEGA_EXAMPLE';
const SET_VEGA_LITE_EXAMPLE = 'SET_VEGA_LITE_EXAMPLE';
const SET_VIEW = 'SET_VIEW';
const SHOW_LOGS = 'SHOW_LOGS';
const TOGGLE_AUTO_PARSE = 'TOGGLE_AUTO_PARSE';
const TOGGLE_COMPILED_VEGA_SPEC = 'TOGGLE_COMPILED_VEGA_SPEC';
const TOGGLE_DEBUG_PANE = 'TOGGLE_DEBUG_PANE';
const TOGGLE_GIST_PRIVACY = 'TOGGLE_GIST_PRIVACY';
const TOGGLE_NAV_BAR = 'TOGGLE_NAV_BAR';
const UPDATE_EDITOR_STRING = 'UPDATE_EDITOR_STRING';
const UPDATE_VEGA_LITE_SPEC = 'UPDATE_VEGA_LITE_SPEC';
const UPDATE_VEGA_SPEC = 'UPDATE_VEGA_SPEC';
const SET_SETTINGS = 'SET_SETTINGS';
const SET_CONFIG = 'SET_CONFIG';
const SET_THEME_NAME = 'SET_THEME_NAME';
const SET_SIDEPANE_ITEM = 'SET_SIDEPANE_ITEM';
const SET_COMPILEDPANE_ITEM = 'SET_COMPILEDPANE_ITEM';
const SET_CONFIG_EDITOR_STRING = 'SET_CONFIG_EDITOR_STRING';
const SET_LOG_LEVEL = 'SET_LOG_LEVEL';
const SET_HOVER = 'SET_HOVER';
const SET_TOOLTIP = 'SET_TOOLTIP';
const CLEAR_CONFIG = 'CLEAR_CONFIG';
const MERGE_CONFIG_SPEC = 'MERGE_CONFIG_SPEC';
const EXTRACT_CONFIG_SPEC = 'EXTRACT_CONFIG_SPEC';
const SET_SIGNALS = 'SET_SIGNALS';
const ADD_SIGNAL = 'ADD_SIGNAL';
const SET_DECORATION = 'SET_DECORATION';
const SET_COMPILED_EDITOR_REFERENCE = 'SET_COMPILED_EDITOR_REFERENCE';
const SET_EDITOR_FOCUS = 'SET_EDITOR_FOCUS';
const SET_BACKGROUND_COLOR = 'SET_BACKGROUND_COLOR';
const SET_EXPRESSION_INTERPRETER = 'SET_EXPRESSION_INTERPRETER';
const ERROR = 'ERROR';
const WARN = 'WARN';
const INFO = 'INFO';
const DEBUG = 'DEBUG';
function setMode(mode) {
    return {
        mode,
        type: SET_MODE
    };
}
function setModeOnly(mode) {
    return {
        mode,
        type: SET_MODE_ONLY
    };
}
function setScrollPosition(position) {
    return {
        position,
        type: SET_SCROLL_POSITION
    };
}
function parseSpec(value) {
    return {
        parse: value,
        type: PARSE_SPEC
    };
}
function setVegaExample(example, spec) {
    return {
        example,
        spec,
        type: SET_VEGA_EXAMPLE
    };
}
function setVegaLiteExample(example, spec) {
    return {
        example,
        spec,
        type: SET_VEGA_LITE_EXAMPLE
    };
}
function updateVegaSpec(spec, config) {
    return {
        spec,
        config,
        type: UPDATE_VEGA_SPEC
    };
}
function updateVegaLiteSpec(spec, config) {
    return {
        spec,
        config,
        type: UPDATE_VEGA_LITE_SPEC
    };
}
function setGistVegaSpec(gist, spec) {
    return {
        gist,
        spec,
        type: SET_GIST_VEGA_SPEC
    };
}
function setGistVegaLiteSpec(gist, spec) {
    return {
        gist,
        spec,
        type: SET_GIST_VEGA_LITE_SPEC
    };
}
function toggleAutoParse() {
    return {
        type: TOGGLE_AUTO_PARSE
    };
}
function toggleCompiledVegaSpec() {
    return {
        type: TOGGLE_COMPILED_VEGA_SPEC
    };
}
function toggleDebugPane() {
    return {
        type: TOGGLE_DEBUG_PANE
    };
}
function logError(err) {
    return {
        error: {
            message: err.message
        },
        type: LOG_ERROR
    };
}
function updateEditorString(editorString) {
    return {
        editorString,
        type: UPDATE_EDITOR_STRING
    };
}
function exportVega(value) {
    return {
        export: value,
        type: EXPORT_VEGA
    };
}
function setRenderer(renderer) {
    return {
        renderer,
        type: SET_RENDERER
    };
}
function setBaseUrl(baseURL) {
    return {
        baseURL,
        type: SET_BASEURL
    };
}
function setView(view) {
    return {
        type: SET_VIEW,
        view
    };
}
function setDebugPaneSize(size) {
    return {
        debugPaneSize: size,
        type: SET_DEBUG_PANE_SIZE
    };
}
function showLogs(value) {
    return {
        logs: value,
        type: SHOW_LOGS
    };
}
function setCompiledVegaPaneSize(size) {
    return {
        compiledVegaPaneSize: size,
        type: SET_COMPILED_VEGA_PANE_SIZE
    };
}
function toggleNavbar(value) {
    return {
        navItem: value,
        type: TOGGLE_NAV_BAR
    };
}
function setSettingsState(value) {
    return {
        settings: value,
        type: SET_SETTINGS
    };
}
function setConfig(value) {
    return {
        configEditorString: value,
        type: SET_CONFIG
    };
}
function setConfigEditorString(value) {
    return {
        configEditorString: value,
        type: SET_CONFIG_EDITOR_STRING
    };
}
function setThemeName(value) {
    return {
        themeName: value,
        type: SET_THEME_NAME
    };
}
function setSidePaneItem(value) {
    return {
        sidePaneItem: value,
        type: SET_SIDEPANE_ITEM
    };
}
function setEditorReference(editorRef) {
    return {
        editorRef: editorRef,
        type: SET_EDITOR_REFERENCE
    };
}
function setCompiledEditorRef(editorRef) {
    return {
        editorRef: editorRef,
        type: SET_COMPILED_EDITOR_REFERENCE
    };
}
function setCompiledPaneItem(value) {
    return {
        compiledPaneItem: value,
        type: SET_COMPILEDPANE_ITEM
    };
}
function setLogLevel(logLevel) {
    return {
        logLevel,
        type: SET_LOG_LEVEL
    };
}
function setHover(hover) {
    return {
        hoverEnable: hover,
        type: SET_HOVER
    };
}
function setTooltip(tooltip) {
    return {
        tooltipEnable: tooltip,
        type: SET_TOOLTIP
    };
}
function clearConfig() {
    return {
        type: CLEAR_CONFIG
    };
}
function mergeConfigSpec() {
    return {
        type: MERGE_CONFIG_SPEC
    };
}
function extractConfigSpec() {
    return {
        type: EXTRACT_CONFIG_SPEC
    };
}
function setSignals(value) {
    return {
        signals: value,
        type: SET_SIGNALS
    };
}
function addSignal(value) {
    return {
        signal: value,
        type: ADD_SIGNAL
    };
}
function setDecorations(value) {
    return {
        decoration: value,
        type: SET_DECORATION
    };
}
function setEditorFocus(value) {
    return {
        editorFocus: value,
        type: SET_EDITOR_FOCUS
    };
}
function receiveCurrentUser(isAuthenticated, handle, name, profilePicUrl) {
    return {
        handle,
        isAuthenticated,
        name,
        profilePicUrl,
        type: RECEIVE_CURRENT_USER
    };
}
function toggleGistPrivacy() {
    return {
        type: TOGGLE_GIST_PRIVACY
    };
}
function setBackgroundColor(color) {
    return {
        type: SET_BACKGROUND_COLOR,
        color
    };
}
function addError(error) {
    return {
        type: ERROR,
        error
    };
}
function addWarning(warn) {
    return {
        type: WARN,
        warn
    };
}
function addInfo(info) {
    return {
        type: INFO,
        info
    };
}
function addDebug(debug) {
    return {
        type: DEBUG,
        debug
    };
}
function setExpressionInterpreter(value) {
    return {
        type: SET_EXPRESSION_INTERPRETER,
        expressionInterpreter: value
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4z2sr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VEGA_SPECS", ()=>(0, _specsJs.VEGA_SPECS));
parcelHelpers.export(exports, "VEGA_LITE_SPECS", ()=>(0, _specsJs.VEGA_LITE_SPECS));
parcelHelpers.export(exports, "DEFAULT_STATE", ()=>(0, _defaultStateJs.DEFAULT_STATE));
var _specsJs = require("./specs.js");
var _constsJs = require("./consts.js");
parcelHelpers.exportAll(_constsJs, exports);
var _defaultStateJs = require("./default-state.js");

},{"./specs.js":"gKJCt","./consts.js":"1PtM7","./default-state.js":"4nviH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKJCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VEGA_SPECS", ()=>(0, _indexJsonDefault.default));
parcelHelpers.export(exports, "VEGA_LITE_SPECS", ()=>(0, _indexJsonDefault1.default));
var _indexJson = require("../../public/spec/vega/index.json");
var _indexJsonDefault = parcelHelpers.interopDefault(_indexJson);
var _indexJson1 = require("../../public/spec/vega-lite/index.json");
var _indexJsonDefault1 = parcelHelpers.interopDefault(_indexJson1);

},{"../../public/spec/vega/index.json":"559Gv","../../public/spec/vega-lite/index.json":"foluU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"559Gv":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"Bar Charts\":[{\"name\":\"bar-chart\"},{\"name\":\"stacked-bar-chart\"},{\"name\":\"grouped-bar-chart\"},{\"name\":\"nested-bar-chart\"},{\"name\":\"population-pyramid\"}],\"Line & Area Charts\":[{\"name\":\"line-chart\"},{\"name\":\"area-chart\"},{\"name\":\"stacked-area-chart\"},{\"name\":\"horizon-graph\"},{\"name\":\"job-voyager\"}],\"Circular Charts\":[{\"name\":\"pie-chart\"},{\"name\":\"donut-chart\"},{\"name\":\"radial-plot\"},{\"name\":\"radar-chart\"}],\"Scatter Plots\":[{\"name\":\"scatter-plot\"},{\"name\":\"scatter-plot-null-values\"},{\"name\":\"connected-scatter-plot\"},{\"name\":\"error-bars\"},{\"name\":\"barley-trellis-plot\"},{\"name\":\"regression\"},{\"name\":\"loess-regression\"},{\"name\":\"labeled-scatter-plot\"}],\"Distributions\":[{\"name\":\"top-k-plot\"},{\"name\":\"top-k-plot-with-others\"},{\"name\":\"histogram\"},{\"name\":\"histogram-null-values\"},{\"name\":\"dot-plot\"},{\"name\":\"probability-density\"},{\"name\":\"box-plot\"},{\"name\":\"violin-plot\"},{\"name\":\"binned-scatter-plot\"},{\"name\":\"contour-plot\"},{\"name\":\"wheat-plot\"},{\"name\":\"quantile-quantile-plot\"},{\"name\":\"quantile-dot-plot\"},{\"name\":\"hypothetical-outcome-plots\"},{\"name\":\"time-units\"}],\"Geographic Maps\":[{\"name\":\"county-unemployment\"},{\"name\":\"dorling-cartogram\"},{\"name\":\"world-map\"},{\"name\":\"earthquakes\"},{\"name\":\"projections\"},{\"name\":\"zoomable-world-map\"},{\"name\":\"distortion-comparison\"},{\"name\":\"volcano-contours\"},{\"name\":\"wind-vectors\"},{\"name\":\"annual-precipitation\"}],\"Tree Diagrams\":[{\"name\":\"tree-layout\"},{\"name\":\"radial-tree-layout\"},{\"name\":\"treemap\"},{\"name\":\"circle-packing\"},{\"name\":\"sunburst\"}],\"Network Diagrams\":[{\"name\":\"edge-bundling\"},{\"name\":\"force-directed-layout\"},{\"name\":\"reorderable-matrix\"},{\"name\":\"arc-diagram\"},{\"name\":\"airport-connections\"}],\"Other Chart Types\":[{\"name\":\"heatmap\"},{\"name\":\"density-heatmaps\"},{\"name\":\"parallel-coordinates\"},{\"name\":\"word-cloud\"},{\"name\":\"beeswarm-plot\"},{\"name\":\"calendar-view\"},{\"name\":\"packed-bubble-chart\"}],\"Custom Designs\":[{\"name\":\"budget-forecasts\"},{\"name\":\"wheat-and-wages\"},{\"name\":\"falkensee-population\"},{\"name\":\"annual-temperature\"},{\"name\":\"weekly-temperature\"},{\"name\":\"flight-passengers\"},{\"name\":\"timelines\"},{\"name\":\"u-district-cuisine\"},{\"name\":\"clock\"},{\"name\":\"watch\"},{\"name\":\"warming-stripes\"},{\"name\":\"earthquakes-globe\"},{\"name\":\"serpentine-timeline\"}],\"Interaction Techniques\":[{\"name\":\"crossfilter-flights\"},{\"name\":\"overview-plus-detail\"},{\"name\":\"brushing-scatter-plots\"},{\"name\":\"zoomable-scatter-plot\"},{\"name\":\"zoomable-binned-plot\"},{\"name\":\"global-development\"},{\"name\":\"interactive-legend\"},{\"name\":\"stock-index-chart\"},{\"name\":\"pi-monte-carlo\"},{\"name\":\"zoomable-circle-packing\"},{\"name\":\"table-scrollbar\"},{\"name\":\"bar-line-toggle\"},{\"name\":\"map-with-tooltip\"},{\"name\":\"pacman\"},{\"name\":\"platformer\"}]}");

},{}],"foluU":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"Single-View Plots":{"Bar Charts":[{"name":"bar","title":"Simple Bar Chart","description":"A bar chart encodes quantitative values as the extent of rectangular bars.","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"bar_size_responsive","title":"Responsive Bar Chart","description":"The bar gets automatically resized based on container size. To see how the bar gets automatically resized try this in [the editor](https://vega.github.io/editor/#/examples/vega-lite/bar_size_responsive)."},{"name":"bar_aggregate","title":"Aggregate Bar Chart"},{"name":"bar_aggregate_sort_by_encoding","title":"Aggregate Bar Chart (Sorted)"},{"name":"bar_grouped","title":"Grouped Bar Chart","description":"Read [here](https://vega.github.io/vega-lite/docs/size.html#offset-step) for more details about how to set step size for grouped bar. "},{"name":"bar_grouped_repeated","title":"Grouped Bar Chart (Multiple Measure with Repeat)","description":"Read [here](https://vega.github.io/vega-lite/docs/size.html#offset-step) for more details about how to set step size for grouped bar. "},{"name":"stacked_bar_weather","title":"Stacked Bar Chart"},{"name":"stacked_bar_count_corner_radius_mark","title":"Stacked Bar Chart with Rounded Corners"},{"name":"stacked_bar_h","title":"Horizontal Stacked Bar Chart"},{"name":"stacked_bar_normalize","title":"Normalized (Percentage) Stacked Bar Chart"},{"name":"stacked_bar_h_normalized_labeled","title":"Normalized (Percentage) Stacked Bar Chart With Labels"},{"name":"bar_gantt","title":"Gantt Chart (Ranged Bar Marks)","style":"background-size: auto 75%; background-position-y: center !important;"},{"name":"bar_color_disabled_scale","title":"A Bar Chart Encoding Color Names in the Data"},{"name":"bar_layered_transparent","title":"Layered Bar Chart"},{"name":"bar_diverging_stack_population_pyramid","title":"Diverging Stacked Bar Chart (Population Pyramid)"},{"name":"bar_diverging_stack_transform","title":"Diverging Stacked Bar Chart (with Neutral Parts)"},{"name":"layer_bar_labels","title":"Bar Chart with Labels","style":"background-size: auto 70%; background-position-y: center;"},{"name":"layer_bar_labels_grey","title":"Bar Chart with Label Overlays"},{"name":"bar_month_temporal_initial","title":"Bar Chart showing Initials of Month Names"},{"name":"bar_month_temporal_band_center","title":"Bar Chart with bars center-aligned with time unit ticks"},{"name":"bar_negative","title":"Bar Chart with Negative Values and a Zero-Baseline"},{"name":"bar_negative_horizontal_label","title":"Horizontal Bar Chart with Negative Values and Labels"},{"name":"bar_axis_space_saving","title":"Bar Chart with a Spacing-Saving Y-Axis"},{"name":"bar_heatlane","title":"Heat Lane Chart"}],"Histograms, Density Plots, and Dot Plots":[{"name":"histogram","title":"Histogram","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"bar_binned_data","title":"Histogram (from Binned Data)","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"histogram_log","title":"Log-scaled Histogram"},{"name":"histogram_nonlinear","title":"Non-linear Histogram"},{"name":"histogram_rel_freq","title":"Relative Frequency Histogram"},{"name":"area_density","title":"Density Plot"},{"name":"area_density_stacked","title":"Stacked Density Estimates"},{"name":"circle_binned","title":"2D Histogram Scatterplot"},{"name":"rect_binned_heatmap","title":"2D Histogram Heatmap"},{"name":"area_cumulative_freq","title":"Cumulative Frequency Distribution","style":"background-size: auto 105%; background-position: center center !important;","png":true},{"name":"layer_cumulative_histogram","title":"Layered Histogram and Cumulative Histogram","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"circle_wilkinson_dotplot","title":"Wilkinson Dot Plot"},{"name":"isotype_bar_chart","title":"Isotype Dot Plot","description":"Inspired by this [Only An Ocean Between, 1943](http://www.thomwhite.co.uk/?p=1303). Population Live Stock, p.13. This example was created by [@jwoLondon](https://github.com/jwoLondon)."},{"name":"isotype_bar_chart_emoji","title":"Isotype Dot Plot with Emoji","description":"This example was inspired by [@jakevdp](https://github.com/jakevdp) and Isotype Bar Chart by [@jwoLondon](https://github.com/jwoLondon)."},{"name":"bar_percent_of_total","title":"Relative Bar Chart (Calculate Percentage of Total)"}],"Scatter & Strip Plots":[{"name":"point_2d","title":"Scatterplot","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"tick_dot","title":"1D Strip Plot","style":"background-size: auto 50%; background-position-y: center !important;"},{"name":"tick_strip","title":"Strip Plot","style":"background-size: auto 85%; background-position-y: center !important;"},{"name":"point_color_with_shape","title":"Colored Scatterplot"},{"name":"circle_binned","title":"2D Histogram Scatterplot"},{"name":"point_bubble","title":"Bubble Plot"},{"name":"point_invalid_color","png":true,"title":"Scatterplot with Null Values in Grey"},{"name":"circle","title":"Scatterplot with Filled Circles","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"circle_bubble_health_income","title":"Bubble Plot (Gapminder)"},{"name":"circle_natural_disasters","description":"Visualization of global deaths from natural disasters. Copy of chart from [Our World in Data](https://ourworldindata.org/natural-catastrophes).","title":"Bubble Plot (Natural Disasters)","png":true},{"name":"text_scatterplot_colored","title":"Scatter Plot with Text Marks"},{"name":"scatter_image","title":"Image-based Scatter Plot"},{"name":"circle_custom_tick_labels","description":"After using the numerical values to calculate the average rating, they are replaced by string labels.","title":"Strip plot with custom axis tick labels"},{"name":"point_offset_random","title":"Dot Plot with Jittering"}],"Line Charts":[{"name":"line","title":"Line Chart","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"line_overlay","title":"Line Chart with Point Markers","style":"background-size: auto 105%; background-position: center center !important;","description":"By setting the `point` property of the line mark definition to an object defining a property of the overlaying point marks, we can overlay point markers on top of line. \\n\\n Notes&#58; (1) This is equivalent to adding another layer of point marks. \\n (2) While `\\"point\\"` marks are normally semi-transparent, the overlay point marker has `opacity` = 1 by default."},{"name":"line_overlay_stroked","title":"Line Chart with Stroked Point Markers","style":"background-size: auto 105%; background-position: center center !important;","description":"By setting the `point` property of the line mark definition to an object defining a property of the overlaying point marks, we can overlay point markers on top of line. Here we create stroked points by setting their `\\"filled\\"` to `false` and their `fill` to `\\"white\\"`. \\n\\n Notes&#58; (1) This is equivalent to adding another layer of point marks. \\n (2) While `\\"point\\"` marks are normally semi-transparent, the overlay point marker has `opacity` = 1 by default."},{"name":"line_color","title":"Multi Series Line Chart"},{"name":"repeat_layer","title":"Multi Series Line Chart with Repeat Operator"},{"name":"line_color_halo","title":"Multi Series Line Chart with Halo Stroke"},{"name":"line_slope","title":"Slope Graph","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"line_step","title":"Step Chart","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"line_monotone","title":"Line Chart with Monotone Interpolation","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"line_conditional_axis","title":"Line Chart with Conditional Axis Properties","style":"background-size: auto 105%"},{"name":"connected_scatterplot","title":"Connected Scatterplot (Lines with Custom Paths)","description":"A connected scatterplot can be created by customizing line `order` and adding `point` overlay in the line mark definition.","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"line_bump","title":"Bump Chart"},{"name":"trail_color","title":"Line Chart with Varying Size (using the trail mark)"},{"name":"trail_comet","title":"A comet chart showing changes between between two states"},{"name":"line_skip_invalid_mid_overlay","title":"Line Chart with Markers and Invalid Values","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"layer_line_co2_concentration","title":"Carbon Dioxide in the Atmosphere","description":"This example was inspired by [Gregor Aisch](https://github.com/gka)\'s [Carbon Dioxide Concentration By Decade](https://www.datawrapper.de/_/OHgEm/)."},{"name":"window_rank","title":"Line Charts Showing Ranks Over Time"},{"name":"sequence_line_fold","title":"Drawing Sine and Cosine Curves with the Sequence Generator"},{"name":"line_strokedash","title":"Line chart with varying stroke dash"},{"name":"line_dashed_part","title":"Line chart with a dashed part"}],"Area Charts & Streamgraphs":[{"name":"area","title":"Area Chart"},{"name":"area_gradient","title":"Area Chart with Gradient"},{"name":"area_overlay","title":"Area Chart with Overlaying Lines and Point Markers"},{"name":"stacked_area","title":"Stacked Area Chart"},{"name":"stacked_area_normalize","title":"Normalized Stacked Area Chart"},{"name":"stacked_area_stream","title":"Streamgraph"},{"name":"area_horizon","title":"Horizon Graph","style":"background-size: auto 70%; background-position-y: center;"}],"Table-based Plots":[{"name":"rect_heatmap","title":"Table Heatmap","style":"background-size: auto"},{"name":"rect_heatmap_weather","title":"Annual Weather Heatmap"},{"name":"rect_binned_heatmap","title":"2D Histogram Heatmap"},{"name":"circle_github_punchcard","title":"Table Bubble Plot (Github Punch Card)"},{"name":"layer_text_heatmap","title":"Heatmap with Labels","style":"background-size: auto 55%; background-position-y: center !important;"},{"name":"rect_lasagna","title":"Lasagna Plot (Dense Time-Series Heatmap)"},{"name":"rect_mosaic_labelled_with_offset","title":"Mosaic Chart with Labels"},{"name":"point_angle_windvector","title":"Wind Vector Map"}],"Circular Plots":[{"name":"arc_pie","title":"Pie Chart","description":"A pie chart encodes proportional differences among a set of numeric values as the angular extent and area of a circular slice."},{"name":"arc_pie_normalize_tooltip","title":"Pie Chart with percentage_tooltip","description":"A pie chart with a tooltip that shows the percentage covered by the hovered slice."},{"name":"arc_donut","title":"Donut Chart","description":"A donut chart encodes proportional differences among a set of numeric values using angular extents."},{"name":"layer_arc_label","title":"Pie Chart with Labels","description":"Layering text over arc marks to label pie charts. For now, [you need to add `stack: true`](https://github.com/vega/vega-lite/issues/5078) to theta to force the text to apply the same polar stacking layout."},{"name":"arc_radial","title":"Radial Plot","description":"This radial plot uses both angular and radial extent to convey multiple dimensions of data. However, this approach is not perceptually effective, as viewers will most likely be drawn to the total area of the shape, conflating the two dimensions. This example also demonstrates a way to add labels to circular plots."},{"name":"arc_pie_pyramid","title":"Pyramid Pie Chart"}],"Advanced Calculations":[{"name":"bar_percent_of_total","title":"Relative Bar Chart (Calculate Percentage of Total)"},{"name":"joinaggregate_mean_difference","title":"Calculate Difference from Average"},{"name":"joinaggregate_mean_difference_by_year","title":"Calculate Difference from Annual Average"},{"name":"joinaggregate_residual_graph","title":"Calculate Residuals","style":"background-size: auto 105%; background-position: center center !important;","png":true},{"name":"window_rank","title":"Line Charts Showing Ranks Over Time"},{"name":"waterfall_chart","title":"Waterfall Chart of Monthly Profit and Loss"},{"name":"window_top_k","title":"Filtering Top-K Items","description":"Here we use window transform to derive the total number of students along with the rank of the current student to determine the top K students and display their score.","style":"background-size: 110%"},{"name":"window_top_k_others","title":"Top-K Plot with \\"Others\\"","description":"By @manzt, adapted from https://observablehq.com/@manzt/top-k-plot-with-others-vega-lite-example.","style":"background-size: 110%"},{"name":"lookup","title":"Using the lookup transform to combine data","style":"background-size: 75%; background-position-x: center;"},{"name":"area_cumulative_freq","title":"Cumulative Frequency Distribution","style":"background-size: auto 105%; background-position: center center !important;","png":true},{"name":"layer_cumulative_histogram","title":"Layered Histogram and Cumulative Histogram","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"parallel_coordinate","title":"Parallel Coordinate Plot","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"bar_argmax","title":"Bar Chart Showing Argmax Value"},{"name":"layer_line_mean_point_raw","title":"Layering Averages over Raw Values"},{"name":"layer_line_rolling_mean_point_raw","title":"Layering Rolling Averages over Raw Values"},{"name":"layer_line_window","title":"Line Chart to Show Benchmarking Results"},{"name":"point_quantile_quantile","title":"Quantile-Quantile Plot (QQ Plot)"},{"name":"layer_point_line_regression","title":"Linear Regression"},{"name":"layer_point_line_loess","title":"Loess Regression"},{"name":"window_impute_null","title":"Using window transform to impute missing values by averaging the previous and next values."}]},"Composite Marks":{"Error Bars & Error Bands":[{"name":"layer_point_errorbar_ci","title":"Error Bars Showing Confidence Interval"},{"name":"layer_point_errorbar_stdev","title":"Error Bars Showing Standard Deviation"},{"name":"layer_line_errorband_ci","title":"Line Chart with Confidence Interval Band"},{"name":"layer_scatter_errorband_1D_stdev_global_mean","title":"Scatterplot with Mean and Standard Deviation Overlay"}],"Box Plots":[{"name":"boxplot_minmax_2D_vertical","title":"Box Plot with Min/Max Whiskers"},{"name":"boxplot_2D_vertical","title":"Tukey Box Plot (1.5 IQR)"},{"name":"boxplot_preaggregated","title":"Box Plot with Pre-Calculated Summaries"}]},"Layered Plots":{"Labeling & Annotation":[{"name":"layer_bar_labels","title":"Simple Bar Chart with Labels","style":"background-size: auto 70%; background-position-y: center;"},{"name":"layer_bar_fruit","title":"Simple Bar Chart with Labels and Emojis"},{"name":"layer_text_heatmap","title":"Layering text over heatmap","style":"background-size: auto 55%; background-position-y: center !important;"},{"name":"layer_line_co2_concentration","title":"Carbon Dioxide in the Atmosphere","description":"This example was inspired by [Gregor Aisch](https://github.com/gka)\'s [Carbon Dioxide Concentration By Decade](https://www.datawrapper.de/_/OHgEm/)."},{"name":"layer_bar_annotations","title":"Bar Chart Highlighting Values beyond a Threshold","description":"To create a bar chart that highlights values beyond a threshold, we use two `layer`s of `bar` marks. The lower layer shows all the bars while the upper layer shows bar with values above the threshold in red (`#e45755`).  We then `layer` a `rule` mark and a `text` mark over the bars to annotate the threshold value."},{"name":"layer_precipitation_mean","title":"Mean overlay over precipitation chart"},{"name":"layer_histogram_global_mean","title":"Histogram with a Global Mean Overlay","style":"background-size: auto 105%; background-position: center center !important;"},{"name":"layer_falkensee","title":"Line Chart with Highlighted Rectangles","style":"background-size: auto 90%; background-position-y: center !important;"},{"name":"layer_line_mean_point_raw","title":"Layering Averages over Raw Values"},{"name":"layer_line_rolling_mean_point_raw","title":"Layering Rolling Averages over Raw Values"},{"name":"layer_likert","title":"Distributions and Medians of Likert Scale Ratings","description":"Distributions and Medians of Likert Scale Ratings. (Figure 9 from @jhoffswell and @zcliu\'s \'Interactive Repair of Tables Extracted from PDF Documents on Mobile Devices\' -- http://idl.cs.washington.edu/files/2019-InteractiveTableRepair-CHI.pdf)."},{"name":"concat_layer_voyager_result","title":"Comparative Likert Scale Ratings","description":"Comparing Likert scale ratings between two conditions. (Figure 10. from @kanitw et al.\'s \\"Voyager 2: Augmenting Visual Analysis with Partial View Specifications\\" -- http://idl.cs.washington.edu/files/2017-Voyager2-CHI.pdf)."}],"Other Layered Plots":[{"name":"layer_candlestick","title":"Candlestick Chart"},{"name":"layer_ranged_dot","title":"Ranged Dot Plot","style":"background-size: auto 70%; background-position-y: center;"},{"name":"facet_bullet","title":"Bullet Chart"},{"name":"layer_dual_axis","title":"Layered Plot with Dual-Axis","style":"background-size: 100% auto; background-position-y: center;"},{"name":"area_horizon","title":"Horizon Graph","style":"background-size: auto 70%; background-position-y: center;"},{"name":"bar_layered_weather","title":"Weekly Weather Plot","description":"Inspired by <a href=\'https://vega.github.io/vega-editor/?mode=vega&spec=weather\'>this Vega example</a>. Weekly weather data plot representing high/low ranges of record temperatures (light grey), average temperatures (dark grey), and both predicted and observed temperatures (black) for the given week. The first five days have high/low ranges of observed temperatures, and the last five days have ranges of predicted temperatures, where the upper barbell represents the range of high temperature predictions and the lower barbell represents the range of low temperature predictions. Created by @melissatdiamond."},{"name":"wheat_wages","title":"Wheat and Wages Example","description":"A recreation of William Playfair\u2019s classic chart visualizing the price of wheat, the wages of a mechanic, and the reigning British monarch. Based on a chart by @manzt."}]},"Multi-View Displays":{"Faceting (Trellis Plot / Small Multiples)":[{"name":"trellis_bar","title":"Trellis Bar Chart"},{"name":"trellis_stacked_bar","title":"Trellis Stacked Bar Chart"},{"name":"trellis_scatter","title":"Trellis Scatter Plot (wrapped)","png":true},{"name":"trellis_bar_histogram","title":"Trellis Histograms"},{"name":"trellis_anscombe","title":"Trellis Scatter Plot Showing Anscombe\'s Quartet"},{"name":"trellis_barley","title":"Becker\'s Barley Trellis Plot"},{"name":"trellis_area","title":"Trellis Area"},{"name":"trellis_area_seattle","title":"Trellis Area Plot Showing Annual Temperatures in Seattle"},{"name":"area_density_facet","title":"Faceted Density Plot"},{"name":"facet_grid_bar","title":"Compact Trellis Grid of Bar Charts"}],"Repeat & Concatenation":[{"name":"repeat_layer","title":"Repeat and Layer to Show Different Movie Measures"},{"name":"vconcat_weather","title":"Vertical Concatenation","description":"Two vertically concatenated charts"},{"name":"repeat_histogram","title":"Horizontally Repeated Charts","description":"Horizontally repeated charts that show the histograms of different parameters of cars in different countries."},{"name":"interactive_splom","png":true,"title":"Interactive Scatterplot Matrix"},{"name":"concat_marginal_histograms","title":"Marginal Histograms","description":"Marginal histograms show the counts along the x and y dimension."},{"name":"concat_bar_scales_discretize","title":"Discretizing scales","description":"Horizontally concatenated charts that show different types of discretizing scales."},{"name":"nested_concat_align","title":"Nested View Concatenation Aligned with Axis `minExtent`"},{"name":"concat_population_pyramid","title":"Population Pyramid"}]},"Maps (Geographic Displays)":{"":[{"name":"geo_choropleth","png":true,"title":"Choropleth of Unemployment Rate per County"},{"name":"geo_circle","png":true,"title":"One Dot per Zipcode in the U.S."},{"name":"geo_layer","png":true,"title":"One Dot per Airport in the U.S. Overlayed on Geoshape"},{"name":"geo_rule","png":true,"title":"Rules (line segments) Connecting SEA to every Airport Reachable via Direct Flights"},{"name":"geo_repeat","png":true,"title":"Three Choropleths Representing Disjoint Data from the Same Table"},{"name":"geo_text","png":true,"title":"U.S. State Capitals Overlayed on a Map of U.S."},{"name":"geo_line","png":true,"title":"Line between Airports in the U.S."},{"name":"geo_trellis","png":true,"title":"Income in the U.S. by State, Faceted over Income Brackets"},{"name":"geo_layer_line_london","title":"London Tube Lines","description":"This example was created by @jwoLondon.","png":true},{"name":"geo_params_projections","title":"Projection explorer","description":"Compare different projections.","png":true},{"name":"interactive_geo_earthquakes","title":"Earthquakes Example","description":"Interactive globe visualization of earthquakes","png":true}]},"Interactive":{"Interactive Charts":[{"name":"interactive_bar_select_highlight","title":"Bar Chart with Highlighting on Hover and Selection on Click"},{"name":"interactive_histogram_full_height_hover","title":"Histogram with Full-Height Hover Targets for Tooltip"},{"name":"interactive_legend","title":"Interactive Legend"},{"name":"point_href","title":"Scatterplot with External Links and Tooltips"},{"name":"interactive_brush","title":"Rectangular Brush"},{"name":"interactive_area_brush","title":"Area Chart with Rectangular Brush","descripton":"In this example, we apply an `interval` selection to select subset of data in an area chart. The selected data is highlighted in gold by the second layer of an area mark that `filter`s its data by the `brush` selection."},{"name":"interactive_paintbrush","title":"Paintbrush Highlight","png":true},{"name":"selection_translate_scatterplot_drag","title":"Scatterplot Pan & Zoom"},{"name":"interactive_query_widgets","title":"Query Widgets"},{"name":"selection_layer_bar_month","title":"Interactive Average","description":"The plot below uses an interval selection, which causes the chart to include an interactive brush (shown in grey). The brush selection parameterizes the red guideline, which visualizes the average value within the selected interval."},{"name":"interactive_line_hover","title":"Multi Series Line Chart with an Interactive Line Highlight","description":"The plot below uses argmax to position text labels at the end of line.  It also applies single selection to highlight a hovered line.  Note that we can hidden thick lines to make it easier to hover."},{"name":"interactive_line_point_hover","title":"Multi Series Line Chart with an Interactive Point Highlight"},{"name":"interactive_multi_line_label","title":"Multi Series Line Chart with Labels","description":"The plot displays labels for all stock prices of the hovered time. The example is forked/modified from [@jakevdp\'s block](https://bl.ocks.org/jakevdp/a414950f61e4b224765f2439dd1f09b9).","png":true},{"name":"interactive_multi_line_pivot_tooltip","title":"Multi Series Line Chart with Tooltip","description":"The plot displays labels for all stock prices of the hovered time. This example uses a pivot transform to compute the data for the tooltip.","png":true},{"name":"interactive_multi_line_tooltip","title":"Multi Series Line Chart with Tooltip","description":"This plot requires the data to have different series in different fields.  See [#1274](https://github.com/vega/vega-lite/issues/1274) and [#1552](https://github.com/vega/vega-lite/issues/1552) for relevant future syntax improvements.","png":true},{"name":"isotype_grid","title":"Isotype Grid","description":"Inspired by this [D3 example by Alan Smith](http://bl.ocks.org/alansmithy/d832fc03f6e6a91e99f4). Drag region to select. This example was created by @jwoLondon.","png":true},{"name":"brush_table","title":"Brushing Scatter Plot to show data on a table"},{"name":"selection_heatmap","title":"Selectable Heatmap"},{"name":"bar_count_minimap","title":"Bar Chart with a Minimap"},{"name":"interactive_index_chart","title":"Interactive Index Chart"},{"name":"interactive_bin_extent","title":"Focus + Context - Smooth Histogram Zooming"},{"name":"dynamic_color_legend","title":"Dynamic Color Legend"},{"name":"param_search_input","description":"Search to highlight the relevant car models. Regexes are supported so you can type e.g. `mazda|ford`","title":"Search Input"},{"name":"selection_type_point_zorder","description":"Show points on top when hovered over with the pointer","title":"Change zorder on hover"}],"Interactive Multi-View Displays":[{"name":"interactive_overview_detail","title":"Overview and Detail"},{"name":"interactive_crossfilter","title":"Crossfilter (Filter)"},{"name":"interactive_layered_crossfilter","title":"Crossfilter (Highlight)"},{"name":"interactive_splom","png":true,"title":"Interactive Scatterplot Matrix"},{"name":"interactive_concat_layer","title":"Interactive Dashboard with Cross Highlight"},{"name":"interactive_seattle_weather","title":"Seattle Weather Exploration","description":"This graph shows an interactive view of Seattle\'s weather, including maximum temperature, amount of precipitation, and type of weather. By clicking and dragging on the scatter plot, you can see the proportion of days in that range that have sun, rain, fog, snow, etc. Created by @jakevdp.","png":true},{"name":"airport_connections","png":true,"title":"Connections among Major U.S. Airports."},{"name":"interactive_global_development","title":"An interactive scatter plot of global health statistics by country and year.","description":"Similar to the Vega version at https://vega.github.io/vega/examples/global-development/.","png":true}]}}');

},{}],"1PtM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mode", ()=>Mode);
parcelHelpers.export(exports, "GistPrivacy", ()=>GistPrivacy);
parcelHelpers.export(exports, "NAME_TO_MODE", ()=>NAME_TO_MODE);
parcelHelpers.export(exports, "NAMES", ()=>NAMES);
parcelHelpers.export(exports, "LAYOUT", ()=>LAYOUT);
parcelHelpers.export(exports, "SCHEMA", ()=>SCHEMA);
parcelHelpers.export(exports, "VEGA_START_SPEC", ()=>VEGA_START_SPEC);
parcelHelpers.export(exports, "VEGA_LITE_START_SPEC", ()=>VEGA_LITE_START_SPEC);
parcelHelpers.export(exports, "NAVBAR", ()=>NAVBAR);
parcelHelpers.export(exports, "SIDEPANE", ()=>SIDEPANE);
parcelHelpers.export(exports, "COMPILEDPANE", ()=>COMPILEDPANE);
parcelHelpers.export(exports, "EDITOR_FOCUS", ()=>EDITOR_FOCUS);
parcelHelpers.export(exports, "KEYCODES", ()=>KEYCODES);
parcelHelpers.export(exports, "WORD_SEPARATORS", ()=>WORD_SEPARATORS);
parcelHelpers.export(exports, "BACKEND_URL", ()=>BACKEND_URL);
parcelHelpers.export(exports, "COOKIE_NAME", ()=>COOKIE_NAME);
var Mode = /*#__PURE__*/ function(Mode) {
    Mode["Vega"] = "vega";
    Mode["VegaLite"] = "vega-lite";
    return Mode;
}({});
var GistPrivacy = /*#__PURE__*/ function(GistPrivacy) {
    GistPrivacy["PUBLIC"] = "PUBLIC";
    GistPrivacy["ALL"] = "ALL";
    return GistPrivacy;
}({});
const NAME_TO_MODE = {
    vega: "vega",
    'vega-lite': "vega-lite"
};
const NAMES = {
    ["vega"]: 'Vega',
    ["vega-lite"]: 'Vega-Lite'
};
const LAYOUT = {
    DebugPaneSize: 200,
    HeaderHeight: 60,
    MinPaneSize: 30
};
const SCHEMA = {
    ["vega"]: 'https://vega.github.io/schema/vega/v5.json',
    ["vega-lite"]: 'https://vega.github.io/schema/vega-lite/v5.json'
};
const VEGA_START_SPEC = `{
  "$schema": "${SCHEMA.vega}"
}`;
const VEGA_LITE_START_SPEC = `{
  "$schema": "${SCHEMA['vega-lite']}"
}`;
const NAVBAR = {
    DataViewer: 'DataViewer',
    Logs: 'Logs',
    SignalViewer: 'SignalViewer',
    DataflowViewer: 'DataflowViewer'
};
const SIDEPANE = {
    Config: 'Config',
    Editor: 'Editor'
};
const COMPILEDPANE = {
    Vega: 'Vega',
    NormalizedVegaLite: 'NormalizedVegaLite'
};
const EDITOR_FOCUS = {
    CompiledEditor: 'compiled-editor',
    SpecEditor: 'spec-editor'
};
const KEYCODES = {
    B: 66,
    ESCAPE: 27,
    S: 83,
    SINGLE_QUOTE: 222,
    SLASH: 191
};
const WORD_SEPARATORS = '`~!@#$%^&*()-=+[{]}\\|;:\'",.<>/?';
const BACKEND_URL = window.location.hostname === 'localhost' ? 'http://localhost:3000/' : 'https://vega-editor-backend.vercel.app/';
const COOKIE_NAME = 'vega_session';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4nviH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_STATE", ()=>DEFAULT_STATE);
var _vegaEmbed = require("vega-embed");
var _indexJs = require("../features/dataflow/index.js");
var _constsJs = require("./consts.js");
const DEFAULT_STATE = {
    baseURL: null,
    compiledEditorRef: null,
    compiledVegaPaneSize: (0, _constsJs.LAYOUT).MinPaneSize,
    compiledVegaSpec: false,
    config: {},
    configEditorString: '{}',
    debugPane: false,
    debugPaneSize: (0, _constsJs.LAYOUT).MinPaneSize,
    decorations: [],
    editorFocus: (0, _constsJs.EDITOR_FOCUS).SpecEditor,
    editorRef: null,
    editorString: (0, _constsJs.VEGA_LITE_START_SPEC),
    error: null,
    export: false,
    gist: null,
    handle: '',
    hoverEnable: 'auto',
    isAuthenticated: false,
    lastPosition: 0,
    logLevel: (0, _vegaEmbed.vega).Warn,
    logs: false,
    manualParse: false,
    mode: (0, _constsJs.Mode).VegaLite,
    name: '',
    navItem: (0, _constsJs.NAVBAR).Logs,
    parse: false,
    private: (0, _constsJs.GistPrivacy).ALL,
    profilePicUrl: '',
    renderer: 'svg',
    selectedExample: null,
    settings: false,
    sidePaneItem: (0, _constsJs.SIDEPANE).Editor,
    compiledPaneItem: (0, _constsJs.COMPILEDPANE).Vega,
    signals: {},
    themeName: 'custom',
    tooltipEnable: true,
    vegaLiteSpec: null,
    normalizedVegaLiteSpec: null,
    vegaSpec: {},
    view: null,
    errors: [],
    warns: [],
    debugs: [],
    infos: [],
    backgroundColor: '#ffffff',
    expressionInterpreter: false,
    ...(0, _indexJs.dataflowInitialState)
};

},{"vega-embed":"aAWYH","../features/dataflow/index.js":"lyRHo","./consts.js":"1PtM7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aAWYH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ACTIONS", ()=>DEFAULT_ACTIONS);
parcelHelpers.export(exports, "default", ()=>embed);
parcelHelpers.export(exports, "guessMode", ()=>guessMode);
parcelHelpers.export(exports, "vega", ()=>vega);
parcelHelpers.export(exports, "vegaLite", ()=>vegaLite);
parcelHelpers.export(exports, "version", ()=>version);
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _vega = require("vega");
var _vegaInterpreter = require("vega-interpreter");
var _vegaLite = require("vega-lite");
var _vegaSchemaUrlParser = require("vega-schema-url-parser");
var _vegaSchemaUrlParserDefault = parcelHelpers.interopDefault(_vegaSchemaUrlParser);
var _vegaThemes = require("vega-themes");
var _vegaTooltip = require("vega-tooltip");
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */ var __extends = function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(obj, key) {
    return _hasOwnProperty.call(obj, key);
}
function _objectKeys(obj) {
    if (Array.isArray(obj)) {
        var keys_1 = new Array(obj.length);
        for(var k = 0; k < keys_1.length; k++)keys_1[k] = "" + k;
        return keys_1;
    }
    if (Object.keys) return Object.keys(obj);
    var keys = [];
    for(var i in obj)if (hasOwnProperty(obj, i)) keys.push(i);
    return keys;
}
/**
* Deeply clone the object.
* https://jsperf.com/deep-copy-vs-json-stringify-json-parse/25 (recursiveDeepCopy)
* @param  {any} obj value to clone
* @return {any} cloned obj
*/ function _deepClone(obj) {
    switch(typeof obj){
        case "object":
            return JSON.parse(JSON.stringify(obj)); //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
        case "undefined":
            return null; //this is how JSON.stringify behaves for array items
        default:
            return obj; //no need to clone primitives
    }
}
//3x faster than cached /^\d+$/.test(str)
function isInteger(str) {
    var i = 0;
    var len = str.length;
    var charCode;
    while(i < len){
        charCode = str.charCodeAt(i);
        if (charCode >= 48 && charCode <= 57) {
            i++;
            continue;
        }
        return false;
    }
    return true;
}
/**
* Escapes a json pointer path
* @param path The raw pointer
* @return the Escaped path
*/ function escapePathComponent(path) {
    if (path.indexOf('/') === -1 && path.indexOf('~') === -1) return path;
    return path.replace(/~/g, '~0').replace(/\//g, '~1');
}
/**
 * Unescapes a json pointer path
 * @param path The escaped pointer
 * @return The unescaped path
 */ function unescapePathComponent(path) {
    return path.replace(/~1/g, '/').replace(/~0/g, '~');
}
/**
* Recursively checks whether an object has any undefined values inside.
*/ function hasUndefined(obj) {
    if (obj === undefined) return true;
    if (obj) {
        if (Array.isArray(obj)) for(var i_1 = 0, len = obj.length; i_1 < len; i_1++){
            if (hasUndefined(obj[i_1])) return true;
        }
        else if (typeof obj === "object") {
            var objKeys = _objectKeys(obj);
            var objKeysLength = objKeys.length;
            for(var i = 0; i < objKeysLength; i++){
                if (hasUndefined(obj[objKeys[i]])) return true;
            }
        }
    }
    return false;
}
function patchErrorMessageFormatter(message, args) {
    var messageParts = [
        message
    ];
    for(var key in args){
        var value = typeof args[key] === 'object' ? JSON.stringify(args[key], null, 2) : args[key]; // pretty print
        if (typeof value !== 'undefined') messageParts.push(key + ": " + value);
    }
    return messageParts.join('\n');
}
var PatchError = /** @class */ function(_super) {
    __extends(PatchError, _super);
    function PatchError(message, name, index, operation, tree) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, patchErrorMessageFormatter(message, {
            name: name,
            index: index,
            operation: operation,
            tree: tree
        })) || this;
        _this.name = name;
        _this.index = index;
        _this.operation = operation;
        _this.tree = tree;
        Object.setPrototypeOf(_this, _newTarget.prototype); // restore prototype chain, see https://stackoverflow.com/a/48342359
        _this.message = patchErrorMessageFormatter(message, {
            name: name,
            index: index,
            operation: operation,
            tree: tree
        });
        return _this;
    }
    return PatchError;
}(Error);
var JsonPatchError = PatchError;
var deepClone = _deepClone;
/* We use a Javascript hash to store each
 function. Each hash entry (property) uses
 the operation identifiers specified in rfc6902.
 In this way, we can map each patch operation
 to its dedicated function in efficient way.
 */ /* The operations applicable to an object */ var objOps = {
    add: function(obj, key, document1) {
        obj[key] = this.value;
        return {
            newDocument: document1
        };
    },
    remove: function(obj, key, document1) {
        var removed = obj[key];
        delete obj[key];
        return {
            newDocument: document1,
            removed: removed
        };
    },
    replace: function(obj, key, document1) {
        var removed = obj[key];
        obj[key] = this.value;
        return {
            newDocument: document1,
            removed: removed
        };
    },
    move: function(obj, key, document1) {
        /* in case move target overwrites an existing value,
        return the removed value, this can be taxing performance-wise,
        and is potentially unneeded */ var removed = getValueByPointer(document1, this.path);
        if (removed) removed = _deepClone(removed);
        var originalValue = applyOperation(document1, {
            op: "remove",
            path: this.from
        }).removed;
        applyOperation(document1, {
            op: "add",
            path: this.path,
            value: originalValue
        });
        return {
            newDocument: document1,
            removed: removed
        };
    },
    copy: function(obj, key, document1) {
        var valueToCopy = getValueByPointer(document1, this.from);
        // enforce copy by value so further operations don't affect source (see issue #177)
        applyOperation(document1, {
            op: "add",
            path: this.path,
            value: _deepClone(valueToCopy)
        });
        return {
            newDocument: document1
        };
    },
    test: function(obj, key, document1) {
        return {
            newDocument: document1,
            test: _areEquals(obj[key], this.value)
        };
    },
    _get: function(obj, key, document1) {
        this.value = obj[key];
        return {
            newDocument: document1
        };
    }
};
/* The operations applicable to an array. Many are the same as for the object */ var arrOps = {
    add: function(arr, i, document1) {
        if (isInteger(i)) arr.splice(i, 0, this.value);
        else arr[i] = this.value;
        // this may be needed when using '-' in an array
        return {
            newDocument: document1,
            index: i
        };
    },
    remove: function(arr, i, document1) {
        var removedList = arr.splice(i, 1);
        return {
            newDocument: document1,
            removed: removedList[0]
        };
    },
    replace: function(arr, i, document1) {
        var removed = arr[i];
        arr[i] = this.value;
        return {
            newDocument: document1,
            removed: removed
        };
    },
    move: objOps.move,
    copy: objOps.copy,
    test: objOps.test,
    _get: objOps._get
};
/**
 * Retrieves a value from a JSON document by a JSON pointer.
 * Returns the value.
 *
 * @param document The document to get the value from
 * @param pointer an escaped JSON pointer
 * @return The retrieved value
 */ function getValueByPointer(document1, pointer) {
    if (pointer == '') return document1;
    var getOriginalDestination = {
        op: "_get",
        path: pointer
    };
    applyOperation(document1, getOriginalDestination);
    return getOriginalDestination.value;
}
/**
 * Apply a single JSON Patch Operation on a JSON document.
 * Returns the {newDocument, result} of the operation.
 * It modifies the `document` and `operation` objects - it gets the values by reference.
 * If you would like to avoid touching your values, clone them:
 * `jsonpatch.applyOperation(document, jsonpatch._deepClone(operation))`.
 *
 * @param document The document to patch
 * @param operation The operation to apply
 * @param validateOperation `false` is without validation, `true` to use default jsonpatch's validation, or you can pass a `validateOperation` callback to be used for validation.
 * @param mutateDocument Whether to mutate the original document or clone it before applying
 * @param banPrototypeModifications Whether to ban modifications to `__proto__`, defaults to `true`.
 * @return `{newDocument, result}` after the operation
 */ function applyOperation(document1, operation, validateOperation, mutateDocument, banPrototypeModifications, index) {
    if (validateOperation === void 0) validateOperation = false;
    if (mutateDocument === void 0) mutateDocument = true;
    if (banPrototypeModifications === void 0) banPrototypeModifications = true;
    if (index === void 0) index = 0;
    if (validateOperation) {
        if (typeof validateOperation == 'function') validateOperation(operation, 0, document1, operation.path);
        else validator(operation, 0);
    }
    /* ROOT OPERATIONS */ if (operation.path === "") {
        var returnValue = {
            newDocument: document1
        };
        if (operation.op === 'add') {
            returnValue.newDocument = operation.value;
            return returnValue;
        } else if (operation.op === 'replace') {
            returnValue.newDocument = operation.value;
            returnValue.removed = document1; //document we removed
            return returnValue;
        } else if (operation.op === 'move' || operation.op === 'copy') {
            returnValue.newDocument = getValueByPointer(document1, operation.from); // get the value by json-pointer in `from` field
            if (operation.op === 'move') returnValue.removed = document1;
            return returnValue;
        } else if (operation.op === 'test') {
            returnValue.test = _areEquals(document1, operation.value);
            if (returnValue.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document1);
            returnValue.newDocument = document1;
            return returnValue;
        } else if (operation.op === 'remove') {
            returnValue.removed = document1;
            returnValue.newDocument = null;
            return returnValue;
        } else if (operation.op === '_get') {
            operation.value = document1;
            return returnValue;
        } else {
            if (validateOperation) throw new JsonPatchError('Operation `op` property is not one of operations defined in RFC-6902', 'OPERATION_OP_INVALID', index, operation, document1);
            else return returnValue;
        }
    } else {
        if (!mutateDocument) document1 = _deepClone(document1);
        var path = operation.path || "";
        var keys = path.split('/');
        var obj = document1;
        var t = 1; //skip empty element - http://jsperf.com/to-shift-or-not-to-shift
        var len = keys.length;
        var existingPathFragment = undefined;
        var key = void 0;
        var validateFunction = void 0;
        if (typeof validateOperation == 'function') validateFunction = validateOperation;
        else validateFunction = validator;
        while(true){
            key = keys[t];
            if (key && key.indexOf('~') != -1) key = unescapePathComponent(key);
            if (banPrototypeModifications && (key == '__proto__' || key == 'prototype' && t > 0 && keys[t - 1] == 'constructor')) throw new TypeError('JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README');
            if (validateOperation) {
                if (existingPathFragment === undefined) {
                    if (obj[key] === undefined) existingPathFragment = keys.slice(0, t).join('/');
                    else if (t == len - 1) existingPathFragment = operation.path;
                    if (existingPathFragment !== undefined) validateFunction(operation, 0, document1, existingPathFragment);
                }
            }
            t++;
            if (Array.isArray(obj)) {
                if (key === '-') key = obj.length;
                else {
                    if (validateOperation && !isInteger(key)) throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", index, operation, document1);
                    else if (isInteger(key)) key = ~~key;
                }
                if (t >= len) {
                    if (validateOperation && operation.op === "add" && key > obj.length) throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", index, operation, document1);
                    var returnValue = arrOps[operation.op].call(operation, obj, key, document1); // Apply patch
                    if (returnValue.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document1);
                    return returnValue;
                }
            } else if (t >= len) {
                var returnValue = objOps[operation.op].call(operation, obj, key, document1); // Apply patch
                if (returnValue.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document1);
                return returnValue;
            }
            obj = obj[key];
            // If we have more keys in the path, but the next value isn't a non-null object,
            // throw an OPERATION_PATH_UNRESOLVABLE error instead of iterating again.
            if (validateOperation && t < len && (!obj || typeof obj !== "object")) throw new JsonPatchError('Cannot perform operation at the desired path', 'OPERATION_PATH_UNRESOLVABLE', index, operation, document1);
        }
    }
}
/**
 * Apply a full JSON Patch array on a JSON document.
 * Returns the {newDocument, result} of the patch.
 * It modifies the `document` object and `patch` - it gets the values by reference.
 * If you would like to avoid touching your values, clone them:
 * `jsonpatch.applyPatch(document, jsonpatch._deepClone(patch))`.
 *
 * @param document The document to patch
 * @param patch The patch to apply
 * @param validateOperation `false` is without validation, `true` to use default jsonpatch's validation, or you can pass a `validateOperation` callback to be used for validation.
 * @param mutateDocument Whether to mutate the original document or clone it before applying
 * @param banPrototypeModifications Whether to ban modifications to `__proto__`, defaults to `true`.
 * @return An array of `{newDocument, result}` after the patch
 */ function applyPatch(document1, patch, validateOperation, mutateDocument, banPrototypeModifications) {
    if (mutateDocument === void 0) mutateDocument = true;
    if (banPrototypeModifications === void 0) banPrototypeModifications = true;
    if (validateOperation) {
        if (!Array.isArray(patch)) throw new JsonPatchError('Patch sequence must be an array', 'SEQUENCE_NOT_AN_ARRAY');
    }
    if (!mutateDocument) document1 = _deepClone(document1);
    var results = new Array(patch.length);
    for(var i = 0, length_1 = patch.length; i < length_1; i++){
        // we don't need to pass mutateDocument argument because if it was true, we already deep cloned the object, we'll just pass `true`
        results[i] = applyOperation(document1, patch[i], validateOperation, true, banPrototypeModifications, i);
        document1 = results[i].newDocument; // in case root was replaced
    }
    results.newDocument = document1;
    return results;
}
/**
 * Apply a single JSON Patch Operation on a JSON document.
 * Returns the updated document.
 * Suitable as a reducer.
 *
 * @param document The document to patch
 * @param operation The operation to apply
 * @return The updated document
 */ function applyReducer(document1, operation, index) {
    var operationResult = applyOperation(document1, operation);
    if (operationResult.test === false) throw new JsonPatchError("Test operation failed", 'TEST_OPERATION_FAILED', index, operation, document1);
    return operationResult.newDocument;
}
/**
 * Validates a single operation. Called from `jsonpatch.validate`. Throws `JsonPatchError` in case of an error.
 * @param {object} operation - operation object (patch)
 * @param {number} index - index of operation in the sequence
 * @param {object} [document] - object where the operation is supposed to be applied
 * @param {string} [existingPathFragment] - comes along with `document`
 */ function validator(operation, index, document1, existingPathFragment) {
    if (typeof operation !== 'object' || operation === null || Array.isArray(operation)) throw new JsonPatchError('Operation is not an object', 'OPERATION_NOT_AN_OBJECT', index, operation, document1);
    else if (!objOps[operation.op]) throw new JsonPatchError('Operation `op` property is not one of operations defined in RFC-6902', 'OPERATION_OP_INVALID', index, operation, document1);
    else if (typeof operation.path !== 'string') throw new JsonPatchError('Operation `path` property is not a string', 'OPERATION_PATH_INVALID', index, operation, document1);
    else if (operation.path.indexOf('/') !== 0 && operation.path.length > 0) // paths that aren't empty string should start with "/"
    throw new JsonPatchError('Operation `path` property must start with "/"', 'OPERATION_PATH_INVALID', index, operation, document1);
    else if ((operation.op === 'move' || operation.op === 'copy') && typeof operation.from !== 'string') throw new JsonPatchError('Operation `from` property is not present (applicable in `move` and `copy` operations)', 'OPERATION_FROM_REQUIRED', index, operation, document1);
    else if ((operation.op === 'add' || operation.op === 'replace' || operation.op === 'test') && operation.value === undefined) throw new JsonPatchError('Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)', 'OPERATION_VALUE_REQUIRED', index, operation, document1);
    else if ((operation.op === 'add' || operation.op === 'replace' || operation.op === 'test') && hasUndefined(operation.value)) throw new JsonPatchError('Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)', 'OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED', index, operation, document1);
    else if (document1) {
        if (operation.op == "add") {
            var pathLen = operation.path.split("/").length;
            var existingPathLen = existingPathFragment.split("/").length;
            if (pathLen !== existingPathLen + 1 && pathLen !== existingPathLen) throw new JsonPatchError('Cannot perform an `add` operation at the desired path', 'OPERATION_PATH_CANNOT_ADD', index, operation, document1);
        } else if (operation.op === 'replace' || operation.op === 'remove' || operation.op === '_get') {
            if (operation.path !== existingPathFragment) throw new JsonPatchError('Cannot perform the operation at a path that does not exist', 'OPERATION_PATH_UNRESOLVABLE', index, operation, document1);
        } else if (operation.op === 'move' || operation.op === 'copy') {
            var existingValue = {
                op: "_get",
                path: operation.from,
                value: undefined
            };
            var error = validate([
                existingValue
            ], document1);
            if (error && error.name === 'OPERATION_PATH_UNRESOLVABLE') throw new JsonPatchError('Cannot perform the operation from a path that does not exist', 'OPERATION_FROM_UNRESOLVABLE', index, operation, document1);
        }
    }
}
/**
 * Validates a sequence of operations. If `document` parameter is provided, the sequence is additionally validated against the object document.
 * If error is encountered, returns a JsonPatchError object
 * @param sequence
 * @param document
 * @returns {JsonPatchError|undefined}
 */ function validate(sequence, document1, externalValidator) {
    try {
        if (!Array.isArray(sequence)) throw new JsonPatchError('Patch sequence must be an array', 'SEQUENCE_NOT_AN_ARRAY');
        if (document1) //clone document and sequence so that we can safely try applying operations
        applyPatch(_deepClone(document1), _deepClone(sequence), externalValidator || true);
        else {
            externalValidator = externalValidator || validator;
            for(var i = 0; i < sequence.length; i++)externalValidator(sequence[i], i, document1, undefined);
        }
    } catch (e) {
        if (e instanceof JsonPatchError) return e;
        else throw e;
    }
}
// based on https://github.com/epoberezkin/fast-deep-equal
// MIT License
// Copyright (c) 2017 Evgeny Poberezkin
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
function _areEquals(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = Array.isArray(a), arrB = Array.isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!_areEquals(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!b.hasOwnProperty(keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!_areEquals(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
var core = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    JsonPatchError: JsonPatchError,
    _areEquals: _areEquals,
    applyOperation: applyOperation,
    applyPatch: applyPatch,
    applyReducer: applyReducer,
    deepClone: deepClone,
    getValueByPointer: getValueByPointer,
    validate: validate,
    validator: validator
});
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */ var beforeDict = new WeakMap();
var Mirror = /** @class */ function() {
    function Mirror(obj) {
        this.observers = new Map();
        this.obj = obj;
    }
    return Mirror;
}();
var ObserverInfo = /** @class */ function() {
    function ObserverInfo(callback, observer) {
        this.callback = callback;
        this.observer = observer;
    }
    return ObserverInfo;
}();
function getMirror(obj) {
    return beforeDict.get(obj);
}
function getObserverFromMirror(mirror, callback) {
    return mirror.observers.get(callback);
}
function removeObserverFromMirror(mirror, observer) {
    mirror.observers.delete(observer.callback);
}
/**
 * Detach an observer from an object
 */ function unobserve(root, observer) {
    observer.unobserve();
}
/**
 * Observes changes made to an object, which can then be retrieved using generate
 */ function observe(obj, callback) {
    var patches = [];
    var observer;
    var mirror = getMirror(obj);
    if (!mirror) {
        mirror = new Mirror(obj);
        beforeDict.set(obj, mirror);
    } else {
        var observerInfo = getObserverFromMirror(mirror, callback);
        observer = observerInfo && observerInfo.observer;
    }
    if (observer) return observer;
    observer = {};
    mirror.value = _deepClone(obj);
    if (callback) {
        observer.callback = callback;
        observer.next = null;
        var dirtyCheck = function() {
            generate(observer);
        };
        var fastCheck = function() {
            clearTimeout(observer.next);
            observer.next = setTimeout(dirtyCheck);
        };
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', fastCheck);
            window.addEventListener('keyup', fastCheck);
            window.addEventListener('mousedown', fastCheck);
            window.addEventListener('keydown', fastCheck);
            window.addEventListener('change', fastCheck);
        }
    }
    observer.patches = patches;
    observer.object = obj;
    observer.unobserve = function() {
        generate(observer);
        clearTimeout(observer.next);
        removeObserverFromMirror(mirror, observer);
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', fastCheck);
            window.removeEventListener('keyup', fastCheck);
            window.removeEventListener('mousedown', fastCheck);
            window.removeEventListener('keydown', fastCheck);
            window.removeEventListener('change', fastCheck);
        }
    };
    mirror.observers.set(callback, new ObserverInfo(callback, observer));
    return observer;
}
/**
 * Generate an array of patches from an observer
 */ function generate(observer, invertible) {
    if (invertible === void 0) invertible = false;
    var mirror = beforeDict.get(observer.object);
    _generate(mirror.value, observer.object, observer.patches, "", invertible);
    if (observer.patches.length) applyPatch(mirror.value, observer.patches);
    var temp = observer.patches;
    if (temp.length > 0) {
        observer.patches = [];
        if (observer.callback) observer.callback(temp);
    }
    return temp;
}
// Dirty check if obj is different from mirror, generate patches and update mirror
function _generate(mirror, obj, patches, path, invertible) {
    if (obj === mirror) return;
    if (typeof obj.toJSON === "function") obj = obj.toJSON();
    var newKeys = _objectKeys(obj);
    var oldKeys = _objectKeys(mirror);
    var deleted = false;
    //if ever "move" operation is implemented here, make sure this test runs OK: "should not generate the same patch twice (move)"
    for(var t = oldKeys.length - 1; t >= 0; t--){
        var key = oldKeys[t];
        var oldVal = mirror[key];
        if (hasOwnProperty(obj, key) && !(obj[key] === undefined && oldVal !== undefined && Array.isArray(obj) === false)) {
            var newVal = obj[key];
            if (typeof oldVal == "object" && oldVal != null && typeof newVal == "object" && newVal != null && Array.isArray(oldVal) === Array.isArray(newVal)) _generate(oldVal, newVal, patches, path + "/" + escapePathComponent(key), invertible);
            else if (oldVal !== newVal) {
                if (invertible) patches.push({
                    op: "test",
                    path: path + "/" + escapePathComponent(key),
                    value: _deepClone(oldVal)
                });
                patches.push({
                    op: "replace",
                    path: path + "/" + escapePathComponent(key),
                    value: _deepClone(newVal)
                });
            }
        } else if (Array.isArray(mirror) === Array.isArray(obj)) {
            if (invertible) patches.push({
                op: "test",
                path: path + "/" + escapePathComponent(key),
                value: _deepClone(oldVal)
            });
            patches.push({
                op: "remove",
                path: path + "/" + escapePathComponent(key)
            });
            deleted = true; // property has been deleted
        } else {
            if (invertible) patches.push({
                op: "test",
                path: path,
                value: mirror
            });
            patches.push({
                op: "replace",
                path: path,
                value: obj
            });
        }
    }
    if (!deleted && newKeys.length == oldKeys.length) return;
    for(var t = 0; t < newKeys.length; t++){
        var key = newKeys[t];
        if (!hasOwnProperty(mirror, key) && obj[key] !== undefined) patches.push({
            op: "add",
            path: path + "/" + escapePathComponent(key),
            value: _deepClone(obj[key])
        });
    }
}
/**
 * Create an array of patches from the differences in two objects
 */ function compare(tree1, tree2, invertible) {
    if (invertible === void 0) invertible = false;
    var patches = [];
    _generate(tree1, tree2, patches, '', invertible);
    return patches;
}
var duplex = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    compare: compare,
    generate: generate,
    observe: observe,
    unobserve: unobserve
});
Object.assign({}, core, duplex, {
    JsonPatchError: PatchError,
    deepClone: _deepClone,
    escapePathComponent,
    unescapePathComponent
});
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var lrucache;
var hasRequiredLrucache;
function requireLrucache() {
    if (hasRequiredLrucache) return lrucache;
    hasRequiredLrucache = 1;
    class LRUCache {
        constructor(){
            this.max = 1000;
            this.map = new Map();
        }
        get(key) {
            const value = this.map.get(key);
            if (value === undefined) return undefined;
            else {
                // Remove the key from the map and add it to the end
                this.map.delete(key);
                this.map.set(key, value);
                return value;
            }
        }
        delete(key) {
            return this.map.delete(key);
        }
        set(key, value) {
            const deleted = this.delete(key);
            if (!deleted && value !== undefined) {
                // If cache is full, delete the least recently used item
                if (this.map.size >= this.max) {
                    const firstKey = this.map.keys().next().value;
                    this.delete(firstKey);
                }
                this.map.set(key, value);
            }
            return this;
        }
    }
    lrucache = LRUCache;
    return lrucache;
}
var parseOptions_1;
var hasRequiredParseOptions;
function requireParseOptions() {
    if (hasRequiredParseOptions) return parseOptions_1;
    hasRequiredParseOptions = 1;
    // parse out just the options we care about
    const looseOption = Object.freeze({
        loose: true
    });
    const emptyOpts = Object.freeze({});
    const parseOptions = (options)=>{
        if (!options) return emptyOpts;
        if (typeof options !== 'object') return looseOption;
        return options;
    };
    parseOptions_1 = parseOptions;
    return parseOptions_1;
}
var re = {
    exports: {}
};
var constants;
var hasRequiredConstants;
function requireConstants() {
    if (hasRequiredConstants) return constants;
    hasRequiredConstants = 1;
    // Note: this is the semver.org version of the spec that it implements
    // Not necessarily the package version of this code.
    const SEMVER_SPEC_VERSION = '2.0.0';
    const MAX_LENGTH = 256;
    const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
    // Max safe segment length for coercion.
    const MAX_SAFE_COMPONENT_LENGTH = 16;
    // Max safe length for a build identifier. The max length minus 6 characters for
    // the shortest version with a build 0.0.0+BUILD.
    const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
    const RELEASE_TYPES = [
        'major',
        'premajor',
        'minor',
        'preminor',
        'patch',
        'prepatch',
        'prerelease'
    ];
    constants = {
        MAX_LENGTH,
        MAX_SAFE_COMPONENT_LENGTH,
        MAX_SAFE_BUILD_LENGTH,
        MAX_SAFE_INTEGER,
        RELEASE_TYPES,
        SEMVER_SPEC_VERSION,
        FLAG_INCLUDE_PRERELEASE: 1,
        FLAG_LOOSE: 2
    };
    return constants;
}
var debug_1;
var hasRequiredDebug;
function requireDebug() {
    if (hasRequiredDebug) return debug_1;
    hasRequiredDebug = 1;
    const debug = ()=>{};
    debug_1 = debug;
    return debug_1;
}
var hasRequiredRe;
function requireRe() {
    if (hasRequiredRe) return re.exports;
    hasRequiredRe = 1;
    (function(module, exports) {
        const { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = requireConstants();
        const debug = requireDebug();
        exports = module.exports = {};
        // The actual regexps go on exports.re
        const re = exports.re = [];
        const safeRe = exports.safeRe = [];
        const src = exports.src = [];
        const safeSrc = exports.safeSrc = [];
        const t = exports.t = {};
        let R = 0;
        const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
        // Replace some greedy regex tokens to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        const safeRegexReplacements = [
            [
                '\\s',
                1
            ],
            [
                '\\d',
                MAX_LENGTH
            ],
            [
                LETTERDASHNUMBER,
                MAX_SAFE_BUILD_LENGTH
            ]
        ];
        const makeSafeRegex = (value)=>{
            for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
            return value;
        };
        const createToken = (name, value, isGlobal)=>{
            const safe = makeSafeRegex(value);
            const index = R++;
            debug(name, index, value);
            t[name] = index;
            src[index] = value;
            safeSrc[index] = safe;
            re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
            safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
        };
        // The following Regular Expressions can be used for tokenizing,
        // validating, and parsing SemVer version strings.
        // ## Numeric Identifier
        // A single `0`, or a non-zero digit followed by zero or more digits.
        createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
        createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
        // ## Non-numeric Identifier
        // Zero or more digits, followed by a letter or hyphen, and then zero or
        // more letters, digits, or hyphens.
        createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
        // ## Main Version
        // Three dot-separated numeric identifiers.
        createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
        createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
        // ## Pre-release Version Identifier
        // A numeric identifier, or a non-numeric identifier.
        createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
        createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
        // ## Pre-release Version
        // Hyphen, followed by one or more dot-separated pre-release version
        // identifiers.
        createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
        createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
        // ## Build Metadata Identifier
        // Any combination of digits, letters, or hyphens.
        createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
        // ## Build Metadata
        // Plus sign, followed by one or more period-separated build metadata
        // identifiers.
        createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
        // ## Full Version String
        // A main version, followed optionally by a pre-release version and
        // build metadata.
        // Note that the only major, minor, patch, and pre-release sections of
        // the version string are capturing groups.  The build metadata is not a
        // capturing group, because it should not ever be used in version
        // comparison.
        createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
        createToken('FULL', `^${src[t.FULLPLAIN]}$`);
        // like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
        // also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
        // common in the npm registry.
        createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
        createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
        createToken('GTLT', '((?:<|>)?=?)');
        // Something like "2.*" or "1.2.x".
        // Note that "x.x" is a valid xRange identifer, meaning "any version"
        // Only the first item is strictly required.
        createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
        createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
        createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
        createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
        createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
        createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
        // Coercion.
        // Extract anything that could conceivably be a part of a valid semver
        createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`);
        createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
        createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
        createToken('COERCERTL', src[t.COERCE], true);
        createToken('COERCERTLFULL', src[t.COERCEFULL], true);
        // Tilde ranges.
        // Meaning is "reasonably at or greater than"
        createToken('LONETILDE', '(?:~>?)');
        createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
        exports.tildeTrimReplace = '$1~';
        createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
        createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
        // Caret ranges.
        // Meaning is "at least and backwards compatible with"
        createToken('LONECARET', '(?:\\^)');
        createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
        exports.caretTrimReplace = '$1^';
        createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
        createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
        // A simple gt/lt/eq thing, or just "" to indicate "any version"
        createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
        createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
        // An expression to strip any whitespace between the gtlt and the thing
        // it modifies, so that `> 1.2.3` ==> `>1.2.3`
        createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
        exports.comparatorTrimReplace = '$1$2$3';
        // Something like `1.2.3 - 1.2.4`
        // Note that these all use the loose form, because they'll be
        // checked against either the strict or loose comparator form
        // later.
        createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
        createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
        // Star ranges basically just allow anything at all.
        createToken('STAR', '(<|>)?=?\\s*\\*');
        // >=0.0.0 is like a star
        createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
        createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');
    })(re, re.exports);
    return re.exports;
}
var identifiers;
var hasRequiredIdentifiers;
function requireIdentifiers() {
    if (hasRequiredIdentifiers) return identifiers;
    hasRequiredIdentifiers = 1;
    const numeric = /^[0-9]+$/;
    const compareIdentifiers = (a, b)=>{
        const anum = numeric.test(a);
        const bnum = numeric.test(b);
        if (anum && bnum) {
            a = +a;
            b = +b;
        }
        return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
    };
    const rcompareIdentifiers = (a, b)=>compareIdentifiers(b, a);
    identifiers = {
        compareIdentifiers,
        rcompareIdentifiers
    };
    return identifiers;
}
var semver;
var hasRequiredSemver;
function requireSemver() {
    if (hasRequiredSemver) return semver;
    hasRequiredSemver = 1;
    const debug = requireDebug();
    const { MAX_LENGTH, MAX_SAFE_INTEGER } = requireConstants();
    const { safeRe: re, safeSrc: src, t } = requireRe();
    const parseOptions = requireParseOptions();
    const { compareIdentifiers } = requireIdentifiers();
    class SemVer {
        constructor(version, options){
            options = parseOptions(options);
            if (version instanceof SemVer) {
                if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
                else version = version.version;
            } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
            if (version.length > MAX_LENGTH) throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
            debug('SemVer', version, options);
            this.options = options;
            this.loose = !!options.loose;
            // this isn't actually relevant for versions, but keep it so that we
            // don't run into trouble passing this.options around.
            this.includePrerelease = !!options.includePrerelease;
            const m = version.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
            if (!m) throw new TypeError(`Invalid Version: ${version}`);
            this.raw = version;
            // these are actually numbers
            this.major = +m[1];
            this.minor = +m[2];
            this.patch = +m[3];
            if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
            if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
            if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
            // numberify any prerelease numeric ids
            if (!m[4]) this.prerelease = [];
            else this.prerelease = m[4].split('.').map((id)=>{
                if (/^[0-9]+$/.test(id)) {
                    const num = +id;
                    if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
                }
                return id;
            });
            this.build = m[5] ? m[5].split('.') : [];
            this.format();
        }
        format() {
            this.version = `${this.major}.${this.minor}.${this.patch}`;
            if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
            return this.version;
        }
        toString() {
            return this.version;
        }
        compare(other) {
            debug('SemVer.compare', this.version, this.options, other);
            if (!(other instanceof SemVer)) {
                if (typeof other === 'string' && other === this.version) return 0;
                other = new SemVer(other, this.options);
            }
            if (other.version === this.version) return 0;
            return this.compareMain(other) || this.comparePre(other);
        }
        compareMain(other) {
            if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
            return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
        }
        comparePre(other) {
            if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
            // NOT having a prerelease is > having one
            if (this.prerelease.length && !other.prerelease.length) return -1;
            else if (!this.prerelease.length && other.prerelease.length) return 1;
            else if (!this.prerelease.length && !other.prerelease.length) return 0;
            let i = 0;
            do {
                const a = this.prerelease[i];
                const b = other.prerelease[i];
                debug('prerelease compare', i, a, b);
                if (a === undefined && b === undefined) return 0;
                else if (b === undefined) return 1;
                else if (a === undefined) return -1;
                else if (a === b) continue;
                else return compareIdentifiers(a, b);
            }while (++i);
        }
        compareBuild(other) {
            if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
            let i = 0;
            do {
                const a = this.build[i];
                const b = other.build[i];
                debug('build compare', i, a, b);
                if (a === undefined && b === undefined) return 0;
                else if (b === undefined) return 1;
                else if (a === undefined) return -1;
                else if (a === b) continue;
                else return compareIdentifiers(a, b);
            }while (++i);
        }
        // preminor will bump the version up to the next minor release, and immediately
        // down to pre-release. premajor and prepatch work the same way.
        inc(release, identifier, identifierBase) {
            if (release.startsWith('pre')) {
                if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
                // Avoid an invalid semver results
                if (identifier) {
                    const r = new RegExp(`^${this.options.loose ? src[t.PRERELEASELOOSE] : src[t.PRERELEASE]}$`);
                    const match = `-${identifier}`.match(r);
                    if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
                }
            }
            switch(release){
                case 'premajor':
                    this.prerelease.length = 0;
                    this.patch = 0;
                    this.minor = 0;
                    this.major++;
                    this.inc('pre', identifier, identifierBase);
                    break;
                case 'preminor':
                    this.prerelease.length = 0;
                    this.patch = 0;
                    this.minor++;
                    this.inc('pre', identifier, identifierBase);
                    break;
                case 'prepatch':
                    // If this is already a prerelease, it will bump to the next version
                    // drop any prereleases that might already exist, since they are not
                    // relevant at this point.
                    this.prerelease.length = 0;
                    this.inc('patch', identifier, identifierBase);
                    this.inc('pre', identifier, identifierBase);
                    break;
                // If the input is a non-prerelease version, this acts the same as
                // prepatch.
                case 'prerelease':
                    if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                    this.inc('pre', identifier, identifierBase);
                    break;
                case 'release':
                    if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                    this.prerelease.length = 0;
                    break;
                case 'major':
                    // If this is a pre-major version, bump up to the same major version.
                    // Otherwise increment major.
                    // 1.0.0-5 bumps to 1.0.0
                    // 1.1.0 bumps to 2.0.0
                    if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                    this.minor = 0;
                    this.patch = 0;
                    this.prerelease = [];
                    break;
                case 'minor':
                    // If this is a pre-minor version, bump up to the same minor version.
                    // Otherwise increment minor.
                    // 1.2.0-5 bumps to 1.2.0
                    // 1.2.1 bumps to 1.3.0
                    if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                    this.patch = 0;
                    this.prerelease = [];
                    break;
                case 'patch':
                    // If this is not a pre-release version, it will increment the patch.
                    // If it is a pre-release it will bump up to the same patch version.
                    // 1.2.0-5 patches to 1.2.0
                    // 1.2.0 patches to 1.2.1
                    if (this.prerelease.length === 0) this.patch++;
                    this.prerelease = [];
                    break;
                // This probably shouldn't be used publicly.
                // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
                case 'pre':
                    {
                        const base = Number(identifierBase) ? 1 : 0;
                        if (this.prerelease.length === 0) this.prerelease = [
                            base
                        ];
                        else {
                            let i = this.prerelease.length;
                            while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                                this.prerelease[i]++;
                                i = -2;
                            }
                            if (i === -1) {
                                // didn't increment anything
                                if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                                this.prerelease.push(base);
                            }
                        }
                        if (identifier) {
                            // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                            // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                            let prerelease = [
                                identifier,
                                base
                            ];
                            if (identifierBase === false) prerelease = [
                                identifier
                            ];
                            if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
                                if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                            } else this.prerelease = prerelease;
                        }
                        break;
                    }
                default:
                    throw new Error(`invalid increment argument: ${release}`);
            }
            this.raw = this.format();
            if (this.build.length) this.raw += `+${this.build.join('.')}`;
            return this;
        }
    }
    semver = SemVer;
    return semver;
}
var compare_1;
var hasRequiredCompare;
function requireCompare() {
    if (hasRequiredCompare) return compare_1;
    hasRequiredCompare = 1;
    const SemVer = requireSemver();
    const compare = (a, b, loose)=>new SemVer(a, loose).compare(new SemVer(b, loose));
    compare_1 = compare;
    return compare_1;
}
var eq_1;
var hasRequiredEq;
function requireEq() {
    if (hasRequiredEq) return eq_1;
    hasRequiredEq = 1;
    const compare = requireCompare();
    const eq = (a, b, loose)=>compare(a, b, loose) === 0;
    eq_1 = eq;
    return eq_1;
}
var neq_1;
var hasRequiredNeq;
function requireNeq() {
    if (hasRequiredNeq) return neq_1;
    hasRequiredNeq = 1;
    const compare = requireCompare();
    const neq = (a, b, loose)=>compare(a, b, loose) !== 0;
    neq_1 = neq;
    return neq_1;
}
var gt_1;
var hasRequiredGt;
function requireGt() {
    if (hasRequiredGt) return gt_1;
    hasRequiredGt = 1;
    const compare = requireCompare();
    const gt = (a, b, loose)=>compare(a, b, loose) > 0;
    gt_1 = gt;
    return gt_1;
}
var gte_1;
var hasRequiredGte;
function requireGte() {
    if (hasRequiredGte) return gte_1;
    hasRequiredGte = 1;
    const compare = requireCompare();
    const gte = (a, b, loose)=>compare(a, b, loose) >= 0;
    gte_1 = gte;
    return gte_1;
}
var lt_1;
var hasRequiredLt;
function requireLt() {
    if (hasRequiredLt) return lt_1;
    hasRequiredLt = 1;
    const compare = requireCompare();
    const lt = (a, b, loose)=>compare(a, b, loose) < 0;
    lt_1 = lt;
    return lt_1;
}
var lte_1;
var hasRequiredLte;
function requireLte() {
    if (hasRequiredLte) return lte_1;
    hasRequiredLte = 1;
    const compare = requireCompare();
    const lte = (a, b, loose)=>compare(a, b, loose) <= 0;
    lte_1 = lte;
    return lte_1;
}
var cmp_1;
var hasRequiredCmp;
function requireCmp() {
    if (hasRequiredCmp) return cmp_1;
    hasRequiredCmp = 1;
    const eq = requireEq();
    const neq = requireNeq();
    const gt = requireGt();
    const gte = requireGte();
    const lt = requireLt();
    const lte = requireLte();
    const cmp = (a, op, b, loose)=>{
        switch(op){
            case '===':
                if (typeof a === 'object') a = a.version;
                if (typeof b === 'object') b = b.version;
                return a === b;
            case '!==':
                if (typeof a === 'object') a = a.version;
                if (typeof b === 'object') b = b.version;
                return a !== b;
            case '':
            case '=':
            case '==':
                return eq(a, b, loose);
            case '!=':
                return neq(a, b, loose);
            case '>':
                return gt(a, b, loose);
            case '>=':
                return gte(a, b, loose);
            case '<':
                return lt(a, b, loose);
            case '<=':
                return lte(a, b, loose);
            default:
                throw new TypeError(`Invalid operator: ${op}`);
        }
    };
    cmp_1 = cmp;
    return cmp_1;
}
var comparator;
var hasRequiredComparator;
function requireComparator() {
    if (hasRequiredComparator) return comparator;
    hasRequiredComparator = 1;
    const ANY = Symbol('SemVer ANY');
    // hoisted class for cyclic dependency
    class Comparator {
        static get ANY() {
            return ANY;
        }
        constructor(comp, options){
            options = parseOptions(options);
            if (comp instanceof Comparator) {
                if (comp.loose === !!options.loose) return comp;
                else comp = comp.value;
            }
            comp = comp.trim().split(/\s+/).join(' ');
            debug('comparator', comp, options);
            this.options = options;
            this.loose = !!options.loose;
            this.parse(comp);
            if (this.semver === ANY) this.value = '';
            else this.value = this.operator + this.semver.version;
            debug('comp', this);
        }
        parse(comp) {
            const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
            const m = comp.match(r);
            if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
            this.operator = m[1] !== undefined ? m[1] : '';
            if (this.operator === '=') this.operator = '';
            // if it literally is just '>' or '' then allow anything.
            if (!m[2]) this.semver = ANY;
            else this.semver = new SemVer(m[2], this.options.loose);
        }
        toString() {
            return this.value;
        }
        test(version) {
            debug('Comparator.test', version, this.options.loose);
            if (this.semver === ANY || version === ANY) return true;
            if (typeof version === 'string') try {
                version = new SemVer(version, this.options);
            } catch (er) {
                return false;
            }
            return cmp(version, this.operator, this.semver, this.options);
        }
        intersects(comp, options) {
            if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
            if (this.operator === '') {
                if (this.value === '') return true;
                return new Range(comp.value, options).test(this.value);
            } else if (comp.operator === '') {
                if (comp.value === '') return true;
                return new Range(this.value, options).test(comp.semver);
            }
            options = parseOptions(options);
            // Special cases where nothing can possibly be lower
            if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
            if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
            // Same direction increasing (> or >=)
            if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
            // Same direction decreasing (< or <=)
            if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
            // same SemVer and both sides are inclusive (<= or >=)
            if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
            // opposite directions less than
            if (cmp(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
            // opposite directions greater than
            if (cmp(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
            return false;
        }
    }
    comparator = Comparator;
    const parseOptions = requireParseOptions();
    const { safeRe: re, t } = requireRe();
    const cmp = requireCmp();
    const debug = requireDebug();
    const SemVer = requireSemver();
    const Range = requireRange();
    return comparator;
}
var range;
var hasRequiredRange;
function requireRange() {
    if (hasRequiredRange) return range;
    hasRequiredRange = 1;
    const SPACE_CHARACTERS = /\s+/g;
    // hoisted class for cyclic dependency
    class Range {
        constructor(range, options){
            options = parseOptions(options);
            if (range instanceof Range) {
                if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
                else return new Range(range.raw, options);
            }
            if (range instanceof Comparator) {
                // just put it in the set and return
                this.raw = range.value;
                this.set = [
                    [
                        range
                    ]
                ];
                this.formatted = undefined;
                return this;
            }
            this.options = options;
            this.loose = !!options.loose;
            this.includePrerelease = !!options.includePrerelease;
            // First reduce all whitespace as much as possible so we do not have to rely
            // on potentially slow regexes like \s*. This is then stored and used for
            // future error messages as well.
            this.raw = range.trim().replace(SPACE_CHARACTERS, ' ');
            // First, split on ||
            this.set = this.raw.split('||')// map the range to a 2d array of comparators
            .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
            // this generally means that it was not a valid range, which is allowed
            // in loose mode, but will still throw if the WHOLE range is invalid.
            .filter((c)=>c.length);
            if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
            // if we have any that are not the null set, throw out null sets.
            if (this.set.length > 1) {
                // keep the first one, in case they're all null sets
                const first = this.set[0];
                this.set = this.set.filter((c)=>!isNullSet(c[0]));
                if (this.set.length === 0) this.set = [
                    first
                ];
                else if (this.set.length > 1) {
                    // if we have any that are *, then the range is just *
                    for (const c of this.set)if (c.length === 1 && isAny(c[0])) {
                        this.set = [
                            c
                        ];
                        break;
                    }
                }
            }
            this.formatted = undefined;
        }
        get range() {
            if (this.formatted === undefined) {
                this.formatted = '';
                for(let i = 0; i < this.set.length; i++){
                    if (i > 0) this.formatted += '||';
                    const comps = this.set[i];
                    for(let k = 0; k < comps.length; k++){
                        if (k > 0) this.formatted += ' ';
                        this.formatted += comps[k].toString().trim();
                    }
                }
            }
            return this.formatted;
        }
        format() {
            return this.range;
        }
        toString() {
            return this.range;
        }
        parseRange(range) {
            // memoize range parsing for performance.
            // this is a very hot path, and fully deterministic.
            const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
            const memoKey = memoOpts + ':' + range;
            const cached = cache.get(memoKey);
            if (cached) return cached;
            const loose = this.options.loose;
            // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
            const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
            range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
            debug('hyphen replace', range);
            // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
            range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
            debug('comparator trim', range);
            // `~ 1.2.3` => `~1.2.3`
            range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
            debug('tilde trim', range);
            // `^ 1.2.3` => `^1.2.3`
            range = range.replace(re[t.CARETTRIM], caretTrimReplace);
            debug('caret trim', range);
            // At this point, the range is completely trimmed and
            // ready to be split into comparators.
            let rangeList = range.split(' ').map((comp)=>parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
            .map((comp)=>replaceGTE0(comp, this.options));
            if (loose) // in loose mode, throw out any that are not valid comparators
            rangeList = rangeList.filter((comp)=>{
                debug('loose invalid filter', comp, this.options);
                return !!comp.match(re[t.COMPARATORLOOSE]);
            });
            debug('range list', rangeList);
            // if any comparators are the null set, then replace with JUST null set
            // if more than one comparator, remove any * comparators
            // also, don't include the same comparator more than once
            const rangeMap = new Map();
            const comparators = rangeList.map((comp)=>new Comparator(comp, this.options));
            for (const comp of comparators){
                if (isNullSet(comp)) return [
                    comp
                ];
                rangeMap.set(comp.value, comp);
            }
            if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
            const result = [
                ...rangeMap.values()
            ];
            cache.set(memoKey, result);
            return result;
        }
        intersects(range, options) {
            if (!(range instanceof Range)) throw new TypeError('a Range is required');
            return this.set.some((thisComparators)=>{
                return isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                    return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                        return rangeComparators.every((rangeComparator)=>{
                            return thisComparator.intersects(rangeComparator, options);
                        });
                    });
                });
            });
        }
        // if ANY of the sets match ALL of its comparators, then pass
        test(version) {
            if (!version) return false;
            if (typeof version === 'string') try {
                version = new SemVer(version, this.options);
            } catch (er) {
                return false;
            }
            for(let i = 0; i < this.set.length; i++){
                if (testSet(this.set[i], version, this.options)) return true;
            }
            return false;
        }
    }
    range = Range;
    const LRU = requireLrucache();
    const cache = new LRU();
    const parseOptions = requireParseOptions();
    const Comparator = requireComparator();
    const debug = requireDebug();
    const SemVer = requireSemver();
    const { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = requireRe();
    const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = requireConstants();
    const isNullSet = (c)=>c.value === '<0.0.0-0';
    const isAny = (c)=>c.value === '';
    // take a set of comparators and determine whether there
    // exists a version which can satisfy it
    const isSatisfiable = (comparators, options)=>{
        let result = true;
        const remainingComparators = comparators.slice();
        let testComparator = remainingComparators.pop();
        while(result && remainingComparators.length){
            result = remainingComparators.every((otherComparator)=>{
                return testComparator.intersects(otherComparator, options);
            });
            testComparator = remainingComparators.pop();
        }
        return result;
    };
    // comprised of xranges, tildes, stars, and gtlt's at this point.
    // already replaced the hyphen ranges
    // turn into a set of JUST comparators.
    const parseComparator = (comp, options)=>{
        debug('comp', comp, options);
        comp = replaceCarets(comp, options);
        debug('caret', comp);
        comp = replaceTildes(comp, options);
        debug('tildes', comp);
        comp = replaceXRanges(comp, options);
        debug('xrange', comp);
        comp = replaceStars(comp, options);
        debug('stars', comp);
        return comp;
    };
    const isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
    // ~, ~> --> * (any, kinda silly)
    // ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
    // ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
    // ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
    // ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
    // ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
    // ~0.0.1 --> >=0.0.1 <0.1.0-0
    const replaceTildes = (comp, options)=>{
        return comp.trim().split(/\s+/).map((c)=>replaceTilde(c, options)).join(' ');
    };
    const replaceTilde = (comp, options)=>{
        const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
        return comp.replace(r, (_, M, m, p, pr)=>{
            debug('tilde', comp, _, M, m, p, pr);
            let ret;
            if (isX(M)) ret = '';
            else if (isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
            else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
            ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
            else if (pr) {
                debug('replaceTilde pr', pr);
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else // ~1.2.3 == >=1.2.3 <1.3.0-0
            ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
            debug('tilde return', ret);
            return ret;
        });
    };
    // ^ --> * (any, kinda silly)
    // ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
    // ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
    // ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
    // ^1.2.3 --> >=1.2.3 <2.0.0-0
    // ^1.2.0 --> >=1.2.0 <2.0.0-0
    // ^0.0.1 --> >=0.0.1 <0.0.2-0
    // ^0.1.0 --> >=0.1.0 <0.2.0-0
    const replaceCarets = (comp, options)=>{
        return comp.trim().split(/\s+/).map((c)=>replaceCaret(c, options)).join(' ');
    };
    const replaceCaret = (comp, options)=>{
        debug('caret', comp, options);
        const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
        const z = options.includePrerelease ? '-0' : '';
        return comp.replace(r, (_, M, m, p, pr)=>{
            debug('caret', comp, _, M, m, p, pr);
            let ret;
            if (isX(M)) ret = '';
            else if (isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
            else if (isX(p)) {
                if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
                else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
            } else if (pr) {
                debug('replaceCaret pr', pr);
                if (M === '0') {
                    if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                    else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
                } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
            } else {
                debug('no pr');
                if (M === '0') {
                    if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                    else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
                } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
            }
            debug('caret return', ret);
            return ret;
        });
    };
    const replaceXRanges = (comp, options)=>{
        debug('replaceXRanges', comp, options);
        return comp.split(/\s+/).map((c)=>replaceXRange(c, options)).join(' ');
    };
    const replaceXRange = (comp, options)=>{
        comp = comp.trim();
        const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
        return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
            debug('xRange', comp, ret, gtlt, M, m, p, pr);
            const xM = isX(M);
            const xm = xM || isX(m);
            const xp = xm || isX(p);
            const anyX = xp;
            if (gtlt === '=' && anyX) gtlt = '';
            // if we're including prereleases in the match, then we need
            // to fix this to -0, the lowest possible prerelease value
            pr = options.includePrerelease ? '-0' : '';
            if (xM) {
                if (gtlt === '>' || gtlt === '<') // nothing is allowed
                ret = '<0.0.0-0';
                else // nothing is forbidden
                ret = '*';
            } else if (gtlt && anyX) {
                // we know patch is an x, because we have any x at all.
                // replace X with 0
                if (xm) m = 0;
                p = 0;
                if (gtlt === '>') {
                    // >1 => >=2.0.0
                    // >1.2 => >=1.3.0
                    gtlt = '>=';
                    if (xm) {
                        M = +M + 1;
                        m = 0;
                        p = 0;
                    } else {
                        m = +m + 1;
                        p = 0;
                    }
                } else if (gtlt === '<=') {
                    // <=0.7.x is actually <0.8.0, since any 0.7.x should
                    // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                    gtlt = '<';
                    if (xm) M = +M + 1;
                    else m = +m + 1;
                }
                if (gtlt === '<') pr = '-0';
                ret = `${gtlt + M}.${m}.${p}${pr}`;
            } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
            else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
            debug('xRange return', ret);
            return ret;
        });
    };
    // Because * is AND-ed with everything else in the comparator,
    // and '' means "any version", just remove the *s entirely.
    const replaceStars = (comp, options)=>{
        debug('replaceStars', comp, options);
        // Looseness is ignored here.  star is always as loose as it gets!
        return comp.trim().replace(re[t.STAR], '');
    };
    const replaceGTE0 = (comp, options)=>{
        debug('replaceGTE0', comp, options);
        return comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '');
    };
    // This function is passed to string.replace(re[t.HYPHENRANGE])
    // M, m, patch, prerelease, build
    // 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
    // 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
    // 1.2 - 3.4 => >=1.2.0 <3.5.0-0
    // TODO build?
    const hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
            if (isX(fM)) from = '';
            else if (isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
            else if (isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
            else if (fpr) from = `>=${from}`;
            else from = `>=${from}${incPr ? '-0' : ''}`;
            if (isX(tM)) to = '';
            else if (isX(tm)) to = `<${+tM + 1}.0.0-0`;
            else if (isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
            else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
            else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
            else to = `<=${to}`;
            return `${from} ${to}`.trim();
        };
    const testSet = (set, version, options)=>{
        for(let i = 0; i < set.length; i++){
            if (!set[i].test(version)) return false;
        }
        if (version.prerelease.length && !options.includePrerelease) {
            // Find the set of versions that are allowed to have prereleases
            // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
            // That should allow `1.2.3-pr.2` to pass.
            // However, `1.2.4-alpha.notready` should NOT be allowed,
            // even though it's within the range set by the comparators.
            for(let i = 0; i < set.length; i++){
                debug(set[i].semver);
                if (set[i].semver === Comparator.ANY) continue;
                if (set[i].semver.prerelease.length > 0) {
                    const allowed = set[i].semver;
                    if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
                }
            }
            // Version has a -pre, but it's not one of the ones we like.
            return false;
        }
        return true;
    };
    return range;
}
var satisfies_1;
var hasRequiredSatisfies;
function requireSatisfies() {
    if (hasRequiredSatisfies) return satisfies_1;
    hasRequiredSatisfies = 1;
    const Range = requireRange();
    const satisfies = (version, range, options)=>{
        try {
            range = new Range(range, options);
        } catch (er) {
            return false;
        }
        return range.test(version);
    };
    satisfies_1 = satisfies;
    return satisfies_1;
}
var satisfiesExports = requireSatisfies();
var satisfies = /*@__PURE__*/ getDefaultExportFromCjs(satisfiesExports);
/**
 * Open editor url in a new window, and pass a message.
 */ function post(window1, url, data) {
    const editor = window1.open(url);
    const step = 250;
    const { origin } = new URL(url);
    let count = 40;
    function listen(evt) {
        if (evt.source === editor) {
            count = 0;
            window1.removeEventListener('message', listen, false);
        }
    }
    window1.addEventListener('message', listen, false);
    // send message
    // periodically resend until ack received or timeout
    function send() {
        if (count <= 0) return;
        editor.postMessage(data, origin);
        setTimeout(send, step);
        count -= 1;
    }
    setTimeout(send, step);
}
// generated with build-style.sh
var embedStyle = `.vega-embed {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
}
.vega-embed.has-actions {
  padding-right: 38px;
}
.vega-embed details:not([open]) > :not(summary) {
  display: none !important;
}
.vega-embed summary {
  list-style: none;
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px;
  z-index: 1000;
  background: white;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  color: #1b1e23;
  border: 1px solid #aaa;
  border-radius: 999px;
  opacity: 0.2;
  transition: opacity 0.4s ease-in;
  cursor: pointer;
  line-height: 0px;
}
.vega-embed summary::-webkit-details-marker {
  display: none;
}
.vega-embed summary:active {
  box-shadow: #aaa 0px 0px 0px 1px inset;
}
.vega-embed summary svg {
  width: 14px;
  height: 14px;
}
.vega-embed details[open] summary {
  opacity: 0.7;
}
.vega-embed:hover summary, .vega-embed:focus-within summary {
  opacity: 1 !important;
  transition: opacity 0.2s ease;
}
.vega-embed .vega-actions {
  position: absolute;
  z-index: 1001;
  top: 35px;
  right: -9px;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  padding-top: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid #d9d9d9;
  background: white;
  animation-duration: 0.15s;
  animation-name: scale-in;
  animation-timing-function: cubic-bezier(0.2, 0, 0.13, 1.5);
  text-align: left;
}
.vega-embed .vega-actions a {
  padding: 8px 16px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  color: #434a56;
  text-decoration: none;
}
.vega-embed .vega-actions a:hover, .vega-embed .vega-actions a:focus {
  background-color: #f7f7f9;
  color: black;
}
.vega-embed .vega-actions::before, .vega-embed .vega-actions::after {
  content: "";
  display: inline-block;
  position: absolute;
}
.vega-embed .vega-actions::before {
  left: auto;
  right: 14px;
  top: -16px;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #d9d9d9;
}
.vega-embed .vega-actions::after {
  left: auto;
  right: 15px;
  top: -14px;
  border: 7px solid rgba(0, 0, 0, 0);
  border-bottom-color: #fff;
}
.vega-embed .chart-wrapper.fit-x {
  width: 100%;
}
.vega-embed .chart-wrapper.fit-y {
  height: 100%;
}

.vega-embed-wrapper {
  max-width: 100%;
  overflow: auto;
  padding-right: 14px;
}

@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`;
function mergeDeep(dest, ...src) {
    for (const s of src)deepMerge_(dest, s);
    return dest;
}
function deepMerge_(dest, src) {
    for (const property of Object.keys(src))(0, _vega.writeConfig)(dest, property, src[property], true);
}
var version$1 = "7.0.2";
var pkg = {
    version: version$1
};
const version = pkg.version;
const vega = _vega;
let vegaLite = _vegaLite;
// For backwards compatibility with Vega-Lite before v4.
const w = typeof window !== 'undefined' ? window : undefined;
if (vegaLite === undefined && w?.vl?.compile) vegaLite = w.vl;
const DEFAULT_ACTIONS = {
    export: {
        svg: true,
        png: true
    },
    source: true,
    compiled: true,
    editor: true
};
const I18N = {
    CLICK_TO_VIEW_ACTIONS: 'Click to view actions',
    COMPILED_ACTION: 'View Compiled Vega',
    EDITOR_ACTION: 'Open in Vega Editor',
    PNG_ACTION: 'Save as PNG',
    SOURCE_ACTION: 'View Source',
    SVG_ACTION: 'Save as SVG'
};
const NAMES = {
    vega: 'Vega',
    'vega-lite': 'Vega-Lite'
};
const VERSION = {
    vega: vega.version,
    'vega-lite': vegaLite ? vegaLite.version : 'not available'
};
const PREPROCESSOR = {
    vega: (vgSpec)=>vgSpec,
    'vega-lite': (vlSpec, config)=>vegaLite.compile(vlSpec, {
            config: config
        }).spec
};
const SVG_CIRCLES = `
<svg viewBox="0 0 16 16" fill="currentColor" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <circle r="2" cy="8" cx="2"></circle>
  <circle r="2" cy="8" cx="8"></circle>
  <circle r="2" cy="8" cx="14"></circle>
</svg>`;
const CHART_WRAPPER_CLASS = 'chart-wrapper';
function isTooltipHandler(h) {
    return typeof h === 'function';
}
function viewSource(source, sourceHeader, sourceFooter, mode) {
    const header = `<html><head>${sourceHeader}</head><body><pre><code class="json">`;
    const footer = `</code></pre>${sourceFooter}</body></html>`;
    const win = window.open('');
    win.document.write(header + source + footer);
    win.document.title = `${NAMES[mode]} JSON Source`;
}
/**
 * Try to guess the type of spec.
 *
 * @param spec Vega or Vega-Lite spec.
 */ function guessMode(spec, providedMode) {
    // Decide mode
    if (spec.$schema) {
        const parsed = (0, _vegaSchemaUrlParserDefault.default)(spec.$schema);
        if (providedMode && providedMode !== parsed.library) console.warn(`The given visualization spec is written in ${NAMES[parsed.library]}, but mode argument sets ${NAMES[providedMode] ?? providedMode}.`);
        const mode = parsed.library;
        if (!satisfies(VERSION[mode], `^${parsed.version.slice(1)}`)) console.warn(`The input spec uses ${NAMES[mode]} ${parsed.version}, but the current version of ${NAMES[mode]} is v${VERSION[mode]}.`);
        return mode;
    }
    // try to guess from the provided spec
    if ('mark' in spec || 'encoding' in spec || 'layer' in spec || 'hconcat' in spec || 'vconcat' in spec || 'facet' in spec || 'repeat' in spec) return 'vega-lite';
    if ('marks' in spec || 'signals' in spec || 'scales' in spec || 'axes' in spec) return 'vega';
    return providedMode ?? 'vega';
}
function isLoader(o) {
    return !!(o && 'load' in o);
}
function createLoader(opts) {
    return isLoader(opts) ? opts : vega.loader(opts);
}
function embedOptionsFromUsermeta(parsedSpec) {
    const opts = parsedSpec.usermeta?.embedOptions ?? {};
    if ((0, _vega.isString)(opts.defaultStyle)) // we don't allow styles set via usermeta since it would allow injection of logic (we set the style via innerHTML)
    opts.defaultStyle = false;
    return opts;
}
/**
 * Embed a Vega visualization component in a web page. This function returns a promise.
 *
 * @param el        DOM element in which to place component (DOM node or CSS selector).
 * @param spec      String : A URL string from which to load the Vega specification.
 *                  Object : The Vega/Vega-Lite specification as a parsed JSON object.
 * @param opts       A JavaScript object containing options for embedding.
 */ async function embed(el, spec, opts = {}) {
    let parsedSpec;
    let loader;
    if ((0, _vega.isString)(spec)) {
        loader = createLoader(opts.loader);
        parsedSpec = JSON.parse(await loader.load(spec));
    } else parsedSpec = spec;
    const loadedEmbedOptions = embedOptionsFromUsermeta(parsedSpec);
    const usermetaLoader = loadedEmbedOptions.loader;
    // either create the loader for the first time or create a new loader if the spec has new loader options
    if (!loader || usermetaLoader) loader = createLoader(opts.loader ?? usermetaLoader);
    const usermetaOpts = await loadOpts(loadedEmbedOptions, loader);
    const parsedOpts = await loadOpts(opts, loader);
    const mergedOpts = {
        ...mergeDeep(parsedOpts, usermetaOpts),
        config: (0, _vega.mergeConfig)(parsedOpts.config ?? {}, usermetaOpts.config ?? {})
    };
    return await _embed(el, parsedSpec, mergedOpts, loader);
}
async function loadOpts(opt, loader) {
    const config = (0, _vega.isString)(opt.config) ? JSON.parse(await loader.load(opt.config)) : opt.config ?? {};
    const patch = (0, _vega.isString)(opt.patch) ? JSON.parse(await loader.load(opt.patch)) : opt.patch;
    return {
        ...opt,
        ...patch ? {
            patch
        } : {},
        ...config ? {
            config
        } : {}
    };
}
function getRoot(el) {
    const possibleRoot = el.getRootNode ? el.getRootNode() : document;
    return possibleRoot instanceof ShadowRoot ? {
        root: possibleRoot,
        rootContainer: possibleRoot
    } : {
        root: document,
        rootContainer: document.head ?? document.body
    };
}
async function _embed(el, spec, opts = {}, loader) {
    const config = opts.theme ? (0, _vega.mergeConfig)(_vegaThemes[opts.theme], opts.config ?? {}) : opts.config;
    const actions = (0, _vega.isBoolean)(opts.actions) ? opts.actions : mergeDeep({}, DEFAULT_ACTIONS, opts.actions ?? {});
    const i18n = {
        ...I18N,
        ...opts.i18n
    };
    const renderer = opts.renderer ?? 'svg';
    const logLevel = opts.logLevel ?? vega.Warn;
    const downloadFileName = opts.downloadFileName ?? 'visualization';
    const element = typeof el === 'string' ? document.querySelector(el) : el;
    if (!element) throw new Error(`${el} does not exist`);
    if (opts.defaultStyle !== false) {
        const ID = 'vega-embed-style';
        const { root, rootContainer } = getRoot(element);
        if (!root.getElementById(ID)) {
            const style = document.createElement('style');
            style.id = ID;
            style.innerHTML = opts.defaultStyle === undefined || opts.defaultStyle === true ? embedStyle.toString() : opts.defaultStyle;
            rootContainer.appendChild(style);
        }
    }
    const mode = guessMode(spec, opts.mode);
    let vgSpec = PREPROCESSOR[mode](spec, config);
    if (mode === 'vega-lite') {
        if (vgSpec.$schema) {
            const parsed = (0, _vegaSchemaUrlParserDefault.default)(vgSpec.$schema);
            if (!satisfies(VERSION.vega, `^${parsed.version.slice(1)}`)) console.warn(`The compiled spec uses Vega ${parsed.version}, but current version is v${VERSION.vega}.`);
        }
    }
    element.classList.add('vega-embed');
    if (actions) element.classList.add('has-actions');
    element.innerHTML = ''; // clear container
    let container = element;
    if (actions) {
        const chartWrapper = document.createElement('div');
        chartWrapper.classList.add(CHART_WRAPPER_CLASS);
        element.appendChild(chartWrapper);
        container = chartWrapper;
    }
    const patch = opts.patch;
    if (patch) vgSpec = patch instanceof Function ? patch(vgSpec) : applyPatch(vgSpec, patch, true, false).newDocument;
    // Set locale. Note that this is a global setting.
    if (opts.formatLocale) vega.formatLocale(opts.formatLocale);
    if (opts.timeFormatLocale) vega.timeFormatLocale(opts.timeFormatLocale);
    // Set custom expression functions
    if (opts.expressionFunctions) for(const name in opts.expressionFunctions){
        const expressionFunction = opts.expressionFunctions[name];
        if ('fn' in expressionFunction) vega.expressionFunction(name, expressionFunction.fn, expressionFunction['visitor']);
        else if (expressionFunction instanceof Function) vega.expressionFunction(name, expressionFunction);
    }
    const { ast } = opts;
    // Do not apply the config to Vega when we have already applied it to Vega-Lite.
    // This call may throw an Error if parsing fails.
    const runtime = vega.parse(vgSpec, mode === 'vega-lite' ? {} : config, {
        ast
    });
    const view = new (opts.viewClass || vega.View)(runtime, {
        loader,
        logLevel,
        renderer,
        ...ast ? {
            expr: vega.expressionInterpreter ?? opts.expr ?? (0, _vegaInterpreter.expressionInterpreter)
        } : {}
    });
    view.addSignalListener('autosize', (_, autosize)=>{
        const { type } = autosize;
        if (type == 'fit-x') {
            container.classList.add('fit-x');
            container.classList.remove('fit-y');
        } else if (type == 'fit-y') {
            container.classList.remove('fit-x');
            container.classList.add('fit-y');
        } else if (type == 'fit') container.classList.add('fit-x', 'fit-y');
        else container.classList.remove('fit-x', 'fit-y');
    });
    if (opts.tooltip !== false) {
        const { loader: loader_, tooltip } = opts;
        const baseURL = loader_ && !isLoader(loader_) ? loader_?.baseURL : undefined;
        const handler = isTooltipHandler(tooltip) ? tooltip : new (0, _vegaTooltip.Handler)({
            baseURL,
            ...tooltip === true ? {} : tooltip
        }).call;
        view.tooltip(handler);
    }
    let { hover } = opts;
    if (hover === undefined) hover = mode === 'vega';
    if (hover) {
        const { hoverSet, updateSet } = typeof hover === 'boolean' ? {} : hover;
        view.hover(hoverSet, updateSet);
    }
    if (opts) {
        if (opts.width != null) view.width(opts.width);
        if (opts.height != null) view.height(opts.height);
        if (opts.padding != null) view.padding(opts.padding);
    }
    await view.initialize(container, opts.bind).runAsync();
    let documentClickHandler;
    if (actions !== false) {
        let wrapper = element;
        if (opts.defaultStyle !== false || opts.forceActionsMenu) {
            const details = document.createElement('details');
            details.title = i18n.CLICK_TO_VIEW_ACTIONS;
            element.append(details);
            wrapper = details;
            const summary = document.createElement('summary');
            summary.innerHTML = SVG_CIRCLES;
            details.append(summary);
            documentClickHandler = (ev)=>{
                if (!details.contains(ev.target)) details.removeAttribute('open');
            };
            document.addEventListener('click', documentClickHandler);
        }
        const ctrl = document.createElement('div');
        wrapper.append(ctrl);
        ctrl.classList.add('vega-actions');
        // add 'Export' action
        if (actions === true || actions.export !== false) {
            for (const ext of [
                'svg',
                'png'
            ])if (actions === true || actions.export === true || actions.export[ext]) {
                const i18nExportAction = i18n[`${ext.toUpperCase()}_ACTION`];
                const exportLink = document.createElement('a');
                const scaleFactor = (0, _vega.isObject)(opts.scaleFactor) ? opts.scaleFactor[ext] : opts.scaleFactor;
                exportLink.text = i18nExportAction;
                exportLink.href = '#';
                exportLink.target = '_blank';
                exportLink.download = `${downloadFileName}.${ext}`;
                // add link on mousedown so that it's correct when the click happens
                exportLink.addEventListener('mousedown', async function(e) {
                    e.preventDefault();
                    const url = await view.toImageURL(ext, scaleFactor);
                    this.href = url;
                });
                ctrl.append(exportLink);
            }
        }
        // add 'View Source' action
        if (actions === true || actions.source !== false) {
            const viewSourceLink = document.createElement('a');
            viewSourceLink.text = i18n.SOURCE_ACTION;
            viewSourceLink.href = '#';
            viewSourceLink.addEventListener('click', function(e) {
                viewSource((0, _jsonStringifyPrettyCompactDefault.default)(spec), opts.sourceHeader ?? '', opts.sourceFooter ?? '', mode);
                e.preventDefault();
            });
            ctrl.append(viewSourceLink);
        }
        // add 'View Compiled' action
        if (mode === 'vega-lite' && (actions === true || actions.compiled !== false)) {
            const compileLink = document.createElement('a');
            compileLink.text = i18n.COMPILED_ACTION;
            compileLink.href = '#';
            compileLink.addEventListener('click', function(e) {
                viewSource((0, _jsonStringifyPrettyCompactDefault.default)(vgSpec), opts.sourceHeader ?? '', opts.sourceFooter ?? '', 'vega');
                e.preventDefault();
            });
            ctrl.append(compileLink);
        }
        // add 'Open in Vega Editor' action
        if (actions === true || actions.editor !== false) {
            const editorUrl = opts.editorUrl ?? 'https://vega.github.io/editor/';
            const editorLink = document.createElement('a');
            editorLink.text = i18n.EDITOR_ACTION;
            editorLink.href = '#';
            editorLink.addEventListener('click', function(e) {
                post(window, editorUrl, {
                    config: config,
                    mode: patch ? 'vega' : mode,
                    renderer,
                    spec: (0, _jsonStringifyPrettyCompactDefault.default)(patch ? vgSpec : spec)
                });
                e.preventDefault();
            });
            ctrl.append(editorLink);
        }
    }
    function finalize() {
        if (documentClickHandler) document.removeEventListener('click', documentClickHandler);
        view.finalize();
    }
    return {
        view,
        spec,
        vgSpec,
        finalize,
        embedOptions: opts
    };
}

},{"json-stringify-pretty-compact":"jn76Q","vega":"jxCvh","vega-interpreter":"gqRSK","vega-lite":"eTD5L","vega-schema-url-parser":"k72H2","vega-themes":"2t6BP","vega-tooltip":"jfqql","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gqRSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expressionInterpreter", ()=>expression);
var _vegaUtil = require("vega-util");
function adjustSpatial(item, encode, swap) {
    let t;
    if (encode.x2) {
        if (encode.x) {
            if (swap && item.x > item.x2) {
                t = item.x;
                item.x = item.x2;
                item.x2 = t;
            }
            item.width = item.x2 - item.x;
        } else item.x = item.x2 - (item.width || 0);
    }
    if (encode.xc) item.x = item.xc - (item.width || 0) / 2;
    if (encode.y2) {
        if (encode.y) {
            if (swap && item.y > item.y2) {
                t = item.y;
                item.y = item.y2;
                item.y2 = t;
            }
            item.height = item.y2 - item.y;
        } else item.y = item.y2 - (item.height || 0);
    }
    if (encode.yc) item.y = item.yc - (item.height || 0) / 2;
}
var Constants = {
    NaN: NaN,
    E: Math.E,
    LN2: Math.LN2,
    LN10: Math.LN10,
    LOG2E: Math.LOG2E,
    LOG10E: Math.LOG10E,
    PI: Math.PI,
    SQRT1_2: Math.SQRT1_2,
    SQRT2: Math.SQRT2,
    MIN_VALUE: Number.MIN_VALUE,
    MAX_VALUE: Number.MAX_VALUE
};
var Ops = {
    '*': (a, b)=>a * b,
    '+': (a, b)=>a + b,
    '-': (a, b)=>a - b,
    '/': (a, b)=>a / b,
    '%': (a, b)=>a % b,
    '>': (a, b)=>a > b,
    '<': (a, b)=>a < b,
    '<=': (a, b)=>a <= b,
    '>=': (a, b)=>a >= b,
    '==': (a, b)=>a == b,
    '!=': (a, b)=>a != b,
    '===': (a, b)=>a === b,
    '!==': (a, b)=>a !== b,
    '&': (a, b)=>a & b,
    '|': (a, b)=>a | b,
    '^': (a, b)=>a ^ b,
    '<<': (a, b)=>a << b,
    '>>': (a, b)=>a >> b,
    '>>>': (a, b)=>a >>> b
};
var Unary = {
    '+': (a)=>+a,
    '-': (a)=>-a,
    '~': (a)=>~a,
    '!': (a)=>!a
};
const slice = Array.prototype.slice;
const apply = (m, args, cast)=>{
    const obj = cast ? cast(args[0]) : args[0];
    return obj[m].apply(obj, slice.call(args, 1));
};
const datetime = function(yearOrTimestring) {
    let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    let H = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let M = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    let S = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    let ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    return (0, _vegaUtil.isString)(yearOrTimestring) ? new Date(yearOrTimestring) : new Date(yearOrTimestring, m, d, H, M, S, ms);
};
var Functions = {
    // math functions
    isNaN: Number.isNaN,
    isFinite: Number.isFinite,
    abs: Math.abs,
    acos: Math.acos,
    asin: Math.asin,
    atan: Math.atan,
    atan2: Math.atan2,
    ceil: Math.ceil,
    cos: Math.cos,
    exp: Math.exp,
    floor: Math.floor,
    log: Math.log,
    max: Math.max,
    min: Math.min,
    pow: Math.pow,
    random: Math.random,
    round: Math.round,
    sin: Math.sin,
    sqrt: Math.sqrt,
    tan: Math.tan,
    clamp: (a, b, c)=>Math.max(b, Math.min(c, a)),
    // date functions
    now: Date.now,
    utc: Date.UTC,
    datetime: datetime,
    date: (d)=>new Date(d).getDate(),
    day: (d)=>new Date(d).getDay(),
    year: (d)=>new Date(d).getFullYear(),
    month: (d)=>new Date(d).getMonth(),
    hours: (d)=>new Date(d).getHours(),
    minutes: (d)=>new Date(d).getMinutes(),
    seconds: (d)=>new Date(d).getSeconds(),
    milliseconds: (d)=>new Date(d).getMilliseconds(),
    time: (d)=>new Date(d).getTime(),
    timezoneoffset: (d)=>new Date(d).getTimezoneOffset(),
    utcdate: (d)=>new Date(d).getUTCDate(),
    utcday: (d)=>new Date(d).getUTCDay(),
    utcyear: (d)=>new Date(d).getUTCFullYear(),
    utcmonth: (d)=>new Date(d).getUTCMonth(),
    utchours: (d)=>new Date(d).getUTCHours(),
    utcminutes: (d)=>new Date(d).getUTCMinutes(),
    utcseconds: (d)=>new Date(d).getUTCSeconds(),
    utcmilliseconds: (d)=>new Date(d).getUTCMilliseconds(),
    // sequence functions
    length: (x)=>x.length,
    join: function() {
        return apply('join', arguments);
    },
    indexof: function() {
        return apply('indexOf', arguments);
    },
    lastindexof: function() {
        return apply('lastIndexOf', arguments);
    },
    slice: function() {
        return apply('slice', arguments);
    },
    reverse: (x)=>x.slice().reverse(),
    sort: (x)=>x.slice().sort((0, _vegaUtil.ascending)),
    // string functions
    parseFloat: parseFloat,
    parseInt: parseInt,
    upper: (x)=>String(x).toUpperCase(),
    lower: (x)=>String(x).toLowerCase(),
    substring: function() {
        return apply('substring', arguments, String);
    },
    split: function() {
        return apply('split', arguments, String);
    },
    replace: function() {
        return apply('replace', arguments, String);
    },
    trim: (x)=>String(x).trim(),
    // Base64 encode/decode
    // Convert binary string to base64-encoded ascii
    btoa: (x)=>btoa(x),
    // Convert base64-encoded ascii to binary string
    atob: (x)=>atob(x),
    // regexp functions
    regexp: RegExp,
    test: (r, t)=>RegExp(r).test(t)
};
const EventFunctions = [
    'view',
    'item',
    'group',
    'xy',
    'x',
    'y'
];
const DisallowedMethods = new Set([
    Function,
    eval,
    setTimeout,
    setInterval
]);
if (typeof setImmediate === 'function') DisallowedMethods.add(setImmediate);
const Visitors = {
    Literal: ($, n)=>n.value,
    Identifier: ($, n)=>{
        const id = n.name;
        return $.memberDepth > 0 ? id : id === 'datum' ? $.datum : id === 'event' ? $.event : id === 'item' ? $.item : Constants[id] || $.params['$' + id];
    },
    MemberExpression: ($, n)=>{
        const d = !n.computed, o = $(n.object);
        if (d) $.memberDepth += 1;
        const p = $(n.property);
        if (d) $.memberDepth -= 1;
        if (DisallowedMethods.has(o[p])) {
            // eslint-disable-next-line no-console
            console.error(`Prevented interpretation of member "${p}" which could lead to insecure code execution`);
            return;
        }
        return o[p];
    },
    CallExpression: ($, n)=>{
        const args = n.arguments;
        let name = n.callee.name;
        // handle special internal functions used by encoders
        // re-route to corresponding standard function
        if (name.startsWith('_')) name = name.slice(1);
        // special case "if" due to conditional evaluation of branches
        return name === 'if' ? $(args[0]) ? $(args[1]) : $(args[2]) : ($.fn[name] || Functions[name]).apply($.fn, args.map($));
    },
    ArrayExpression: ($, n)=>n.elements.map($),
    BinaryExpression: ($, n)=>Ops[n.operator]($(n.left), $(n.right)),
    UnaryExpression: ($, n)=>Unary[n.operator]($(n.argument)),
    ConditionalExpression: ($, n)=>$(n.test) ? $(n.consequent) : $(n.alternate),
    LogicalExpression: ($, n)=>n.operator === '&&' ? $(n.left) && $(n.right) : $(n.left) || $(n.right),
    ObjectExpression: ($, n)=>n.properties.reduce((o, p)=>{
            $.memberDepth += 1;
            const k = $(p.key);
            $.memberDepth -= 1;
            if (DisallowedMethods.has($(p.value))) // eslint-disable-next-line no-console
            console.error(`Prevented interpretation of property "${k}" which could lead to insecure code execution`);
            else o[k] = $(p.value);
            return o;
        }, {})
};
function interpret(ast, fn, params, datum, event, item) {
    const $ = (n)=>Visitors[n.type]($, n);
    $.memberDepth = 0;
    $.fn = Object.create(fn);
    $.params = params;
    $.datum = datum;
    $.event = event;
    $.item = item;
    // route event functions to annotated vega event context
    EventFunctions.forEach((f)=>$.fn[f] = function() {
            return event.vega[f](...arguments);
        });
    return $(ast);
}
var expression = {
    /**
   * Parse an expression used to update an operator value.
   */ operator (ctx, expr) {
        const ast = expr.ast, fn = ctx.functions;
        return (_)=>interpret(ast, fn, _);
    },
    /**
   * Parse an expression provided as an operator parameter value.
   */ parameter (ctx, expr) {
        const ast = expr.ast, fn = ctx.functions;
        return (datum, _)=>interpret(ast, fn, _, datum);
    },
    /**
   * Parse an expression applied to an event stream.
   */ event (ctx, expr) {
        const ast = expr.ast, fn = ctx.functions;
        return (event)=>interpret(ast, fn, undefined, undefined, event);
    },
    /**
   * Parse an expression used to handle an event-driven operator update.
   */ handler (ctx, expr) {
        const ast = expr.ast, fn = ctx.functions;
        return (_, event)=>{
            const datum = event.item && event.item.datum;
            return interpret(ast, fn, _, datum, event);
        };
    },
    /**
   * Parse an expression that performs visual encoding.
   */ encode (ctx, encode) {
        const { marktype, channels } = encode, fn = ctx.functions, swap = marktype === 'group' || marktype === 'image' || marktype === 'rect';
        return (item, _)=>{
            const datum = item.datum;
            let m = 0, v;
            for(const name in channels){
                v = interpret(channels[name].ast, fn, _, datum, undefined, item);
                if (item[name] !== v) {
                    item[name] = v;
                    m = 1;
                }
            }
            if (marktype !== 'rule') adjustSpatial(item, channels, swap);
            return m;
        };
    }
};

},{"vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k72H2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>e);
function e(e) {
    const [n, r] = /schema\/([\w-]+)\/([\w\.\-]+)\.json$/g.exec(e).slice(1, 3);
    return {
        library: n,
        version: r
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2t6BP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "carbong10", ()=>carbong10);
parcelHelpers.export(exports, "carbong100", ()=>carbong100);
parcelHelpers.export(exports, "carbong90", ()=>carbong90);
parcelHelpers.export(exports, "carbonwhite", ()=>carbonwhite);
parcelHelpers.export(exports, "dark", ()=>darkTheme);
parcelHelpers.export(exports, "excel", ()=>excelTheme);
parcelHelpers.export(exports, "fivethirtyeight", ()=>fiveThirtyEightTheme);
parcelHelpers.export(exports, "ggplot2", ()=>ggplot2Theme);
parcelHelpers.export(exports, "googlecharts", ()=>googlechartsTheme);
parcelHelpers.export(exports, "latimes", ()=>latimesTheme);
parcelHelpers.export(exports, "powerbi", ()=>powerbiTheme);
parcelHelpers.export(exports, "quartz", ()=>quartzTheme);
parcelHelpers.export(exports, "urbaninstitute", ()=>urbanInstituteTheme);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "vox", ()=>voxTheme);
var version$1 = "3.0.0";
var pkg = {
    version: version$1
};
const lightColor = '#fff';
const medColor = '#888';
const darkTheme = {
    background: '#333',
    view: {
        stroke: medColor
    },
    title: {
        color: lightColor,
        subtitleColor: lightColor
    },
    style: {
        'guide-label': {
            fill: lightColor
        },
        'guide-title': {
            fill: lightColor
        }
    },
    axis: {
        domainColor: lightColor,
        gridColor: medColor,
        tickColor: lightColor
    }
};
const markColor$7 = '#4572a7';
const excelTheme = {
    background: '#fff',
    arc: {
        fill: markColor$7
    },
    area: {
        fill: markColor$7
    },
    line: {
        stroke: markColor$7,
        strokeWidth: 2
    },
    path: {
        stroke: markColor$7
    },
    rect: {
        fill: markColor$7
    },
    shape: {
        stroke: markColor$7
    },
    symbol: {
        fill: markColor$7,
        strokeWidth: 1.5,
        size: 50
    },
    axis: {
        bandPosition: 0.5,
        grid: true,
        gridColor: '#000000',
        gridOpacity: 1,
        gridWidth: 0.5,
        labelPadding: 10,
        tickSize: 5,
        tickWidth: 0.5
    },
    axisBand: {
        grid: false,
        tickExtra: true
    },
    legend: {
        labelBaseline: 'middle',
        labelFontSize: 11,
        symbolSize: 50,
        symbolType: 'square'
    },
    range: {
        category: [
            '#4572a7',
            '#aa4643',
            '#8aa453',
            '#71598e',
            '#4598ae',
            '#d98445',
            '#94aace',
            '#d09393',
            '#b9cc98',
            '#a99cbc'
        ]
    }
};
const markColor$6 = '#30a2da';
const axisColor$2 = '#cbcbcb';
const guideLabelColor = '#999';
const guideTitleColor = '#333';
const backgroundColor$2 = '#f0f0f0';
const blackTitle = '#333';
const fiveThirtyEightTheme = {
    arc: {
        fill: markColor$6
    },
    area: {
        fill: markColor$6
    },
    axis: {
        domainColor: axisColor$2,
        grid: true,
        gridColor: axisColor$2,
        gridWidth: 1,
        labelColor: guideLabelColor,
        labelFontSize: 10,
        titleColor: guideTitleColor,
        tickColor: axisColor$2,
        tickSize: 10,
        titleFontSize: 14,
        titlePadding: 10,
        labelPadding: 4
    },
    axisBand: {
        grid: false
    },
    background: backgroundColor$2,
    group: {
        fill: backgroundColor$2
    },
    legend: {
        labelColor: blackTitle,
        labelFontSize: 11,
        padding: 1,
        symbolSize: 30,
        symbolType: 'square',
        titleColor: blackTitle,
        titleFontSize: 14,
        titlePadding: 10
    },
    line: {
        stroke: markColor$6,
        strokeWidth: 2
    },
    path: {
        stroke: markColor$6,
        strokeWidth: 0.5
    },
    rect: {
        fill: markColor$6
    },
    range: {
        category: [
            '#30a2da',
            '#fc4f30',
            '#e5ae38',
            '#6d904f',
            '#8b8b8b',
            '#b96db8',
            '#ff9e27',
            '#56cc60',
            '#52d2ca',
            '#52689e',
            '#545454',
            '#9fe4f8'
        ],
        diverging: [
            '#cc0020',
            '#e77866',
            '#f6e7e1',
            '#d6e8ed',
            '#91bfd9',
            '#1d78b5'
        ],
        heatmap: [
            '#d6e8ed',
            '#cee0e5',
            '#91bfd9',
            '#549cc6',
            '#1d78b5'
        ]
    },
    point: {
        filled: true,
        shape: 'circle'
    },
    shape: {
        stroke: markColor$6
    },
    bar: {
        binSpacing: 2,
        fill: markColor$6,
        stroke: null
    },
    title: {
        anchor: 'start',
        fontSize: 24,
        fontWeight: 600,
        offset: 20
    }
};
const markColor$5 = '#000';
const ggplot2Theme = {
    group: {
        fill: '#e5e5e5'
    },
    arc: {
        fill: markColor$5
    },
    area: {
        fill: markColor$5
    },
    line: {
        stroke: markColor$5
    },
    path: {
        stroke: markColor$5
    },
    rect: {
        fill: markColor$5
    },
    shape: {
        stroke: markColor$5
    },
    symbol: {
        fill: markColor$5,
        size: 40
    },
    axis: {
        domain: false,
        grid: true,
        gridColor: '#FFFFFF',
        gridOpacity: 1,
        labelColor: '#7F7F7F',
        labelPadding: 4,
        tickColor: '#7F7F7F',
        tickSize: 5.67,
        titleFontSize: 16,
        titleFontWeight: 'normal'
    },
    legend: {
        labelBaseline: 'middle',
        labelFontSize: 11,
        symbolSize: 40
    },
    range: {
        category: [
            '#000000',
            '#7F7F7F',
            '#1A1A1A',
            '#999999',
            '#333333',
            '#B0B0B0',
            '#4D4D4D',
            '#C9C9C9',
            '#666666',
            '#DCDCDC'
        ]
    }
};
const headlineFontSize = 22;
const headlineFontWeight = 'normal';
const labelFont$1 = 'Benton Gothic, sans-serif';
const labelFontSize = 11.5;
const labelFontWeight = 'normal';
const markColor$4 = '#82c6df';
// const markHighlight = '#006d8f';
// const markDemocrat = '#5789b8';
// const markRepublican = '#d94f54';
const titleFont = 'Benton Gothic Bold, sans-serif';
const titleFontWeight = 'normal';
const titleFontSize$1 = 13;
const colorSchemes$1 = {
    'category-6': [
        '#ec8431',
        '#829eb1',
        '#c89d29',
        '#3580b1',
        '#adc839',
        '#ab7fb4'
    ],
    'fire-7': [
        '#fbf2c7',
        '#f9e39c',
        '#f8d36e',
        '#f4bb6a',
        '#e68a4f',
        '#d15a40',
        '#ab4232'
    ],
    'fireandice-6': [
        '#e68a4f',
        '#f4bb6a',
        '#f9e39c',
        '#dadfe2',
        '#a6b7c6',
        '#849eae'
    ]
};
const latimesTheme = {
    background: '#ffffff',
    title: {
        anchor: 'start',
        color: '#000000',
        font: titleFont,
        fontSize: headlineFontSize,
        fontWeight: headlineFontWeight
    },
    arc: {
        fill: markColor$4
    },
    area: {
        fill: markColor$4
    },
    line: {
        stroke: markColor$4,
        strokeWidth: 2
    },
    path: {
        stroke: markColor$4
    },
    rect: {
        fill: markColor$4
    },
    shape: {
        stroke: markColor$4
    },
    symbol: {
        fill: markColor$4,
        size: 30
    },
    axis: {
        labelFont: labelFont$1,
        labelFontSize,
        labelFontWeight,
        titleFont,
        titleFontSize: titleFontSize$1,
        titleFontWeight
    },
    axisX: {
        labelAngle: 0,
        labelPadding: 4,
        tickSize: 3
    },
    axisY: {
        labelBaseline: 'middle',
        maxExtent: 45,
        minExtent: 45,
        tickSize: 2,
        titleAlign: 'left',
        titleAngle: 0,
        titleX: -45,
        titleY: -11
    },
    legend: {
        labelFont: labelFont$1,
        labelFontSize,
        symbolType: 'square',
        titleFont,
        titleFontSize: titleFontSize$1,
        titleFontWeight
    },
    range: {
        category: colorSchemes$1['category-6'],
        diverging: colorSchemes$1['fireandice-6'],
        heatmap: colorSchemes$1['fire-7'],
        ordinal: colorSchemes$1['fire-7'],
        ramp: colorSchemes$1['fire-7']
    }
};
const markColor$3 = '#ab5787';
const axisColor$1 = '#979797';
const quartzTheme = {
    background: '#f9f9f9',
    arc: {
        fill: markColor$3
    },
    area: {
        fill: markColor$3
    },
    line: {
        stroke: markColor$3
    },
    path: {
        stroke: markColor$3
    },
    rect: {
        fill: markColor$3
    },
    shape: {
        stroke: markColor$3
    },
    symbol: {
        fill: markColor$3,
        size: 30
    },
    axis: {
        domainColor: axisColor$1,
        domainWidth: 0.5,
        gridWidth: 0.2,
        labelColor: axisColor$1,
        tickColor: axisColor$1,
        tickWidth: 0.2,
        titleColor: axisColor$1
    },
    axisBand: {
        grid: false
    },
    axisX: {
        grid: true,
        tickSize: 10
    },
    axisY: {
        domain: false,
        grid: true,
        tickSize: 0
    },
    legend: {
        labelFontSize: 11,
        padding: 1,
        symbolSize: 30,
        symbolType: 'square'
    },
    range: {
        category: [
            '#ab5787',
            '#51b2e5',
            '#703c5c',
            '#168dd9',
            '#d190b6',
            '#00609f',
            '#d365ba',
            '#154866',
            '#666666',
            '#c4c4c4'
        ]
    }
};
const markColor$2 = '#3e5c69';
const voxTheme = {
    background: '#fff',
    arc: {
        fill: markColor$2
    },
    area: {
        fill: markColor$2
    },
    line: {
        stroke: markColor$2
    },
    path: {
        stroke: markColor$2
    },
    rect: {
        fill: markColor$2
    },
    shape: {
        stroke: markColor$2
    },
    symbol: {
        fill: markColor$2
    },
    axis: {
        domainWidth: 0.5,
        grid: true,
        labelPadding: 2,
        tickSize: 5,
        tickWidth: 0.5,
        titleFontWeight: 'normal'
    },
    axisBand: {
        grid: false
    },
    axisX: {
        gridWidth: 0.2
    },
    axisY: {
        gridDash: [
            3
        ],
        gridWidth: 0.4
    },
    legend: {
        labelFontSize: 11,
        padding: 1,
        symbolType: 'square'
    },
    range: {
        category: [
            '#3e5c69',
            '#6793a6',
            '#182429',
            '#0570b0',
            '#3690c0',
            '#74a9cf',
            '#a6bddb',
            '#e2ddf2'
        ]
    }
};
const markColor$1 = '#1696d2';
const axisColor = '#000000';
const backgroundColor$1 = '#FFFFFF';
const font = 'Lato';
const labelFont = 'Lato';
const sourceFont = 'Lato';
const gridColor$1 = '#DEDDDD';
const titleFontSize = 18;
const colorSchemes = {
    'shades-blue': [
        '#CFE8F3',
        '#A2D4EC',
        '#73BFE2',
        '#46ABDB',
        '#1696D2',
        '#12719E',
        '#0A4C6A',
        '#062635'
    ],
    'six-groups-cat-1': [
        '#1696d2',
        '#ec008b',
        '#fdbf11',
        '#000000',
        '#d2d2d2',
        '#55b748'
    ],
    'six-groups-seq': [
        '#cfe8f3',
        '#a2d4ec',
        '#73bfe2',
        '#46abdb',
        '#1696d2',
        '#12719e'
    ],
    'diverging-colors': [
        '#ca5800',
        '#fdbf11',
        '#fdd870',
        '#fff2cf',
        '#cfe8f3',
        '#73bfe2',
        '#1696d2',
        '#0a4c6a'
    ]
};
const urbanInstituteTheme = {
    background: backgroundColor$1,
    title: {
        anchor: 'start',
        fontSize: titleFontSize,
        font: font
    },
    axisX: {
        domain: true,
        domainColor: axisColor,
        domainWidth: 1,
        grid: false,
        labelFontSize: 12,
        labelFont: labelFont,
        labelAngle: 0,
        tickColor: axisColor,
        tickSize: 5,
        titleFontSize: 12,
        titlePadding: 10,
        titleFont: font
    },
    axisY: {
        domain: false,
        domainWidth: 1,
        grid: true,
        gridColor: gridColor$1,
        gridWidth: 1,
        labelFontSize: 12,
        labelFont: labelFont,
        labelPadding: 8,
        ticks: false,
        titleFontSize: 12,
        titlePadding: 10,
        titleFont: font,
        titleAngle: 0,
        titleY: -10,
        titleX: 18
    },
    legend: {
        labelFontSize: 12,
        labelFont: labelFont,
        symbolSize: 100,
        titleFontSize: 12,
        titlePadding: 10,
        titleFont: font,
        orient: 'right',
        offset: 10
    },
    view: {
        stroke: 'transparent'
    },
    range: {
        category: colorSchemes['six-groups-cat-1'],
        diverging: colorSchemes['diverging-colors'],
        heatmap: colorSchemes['diverging-colors'],
        ordinal: colorSchemes['six-groups-seq'],
        ramp: colorSchemes['shades-blue']
    },
    area: {
        fill: markColor$1
    },
    rect: {
        fill: markColor$1
    },
    line: {
        color: markColor$1,
        stroke: markColor$1,
        strokeWidth: 5
    },
    trail: {
        color: markColor$1,
        stroke: markColor$1,
        strokeWidth: 0,
        size: 1
    },
    path: {
        stroke: markColor$1,
        strokeWidth: 0.5
    },
    point: {
        filled: true
    },
    text: {
        font: sourceFont,
        color: markColor$1,
        fontSize: 11,
        align: 'center',
        fontWeight: 400,
        size: 11
    },
    style: {
        bar: {
            fill: markColor$1,
            stroke: null
        }
    },
    arc: {
        fill: markColor$1
    },
    shape: {
        stroke: markColor$1
    },
    symbol: {
        fill: markColor$1,
        size: 30
    }
};
/**
 * Copyright 2020 Google LLC.
 *
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file or at
 * https://developers.google.com/open-source/licenses/bsd
 */ const markColor = '#3366CC';
const gridColor = '#ccc';
const defaultFont$1 = 'Arial, sans-serif';
const googlechartsTheme = {
    arc: {
        fill: markColor
    },
    area: {
        fill: markColor
    },
    path: {
        stroke: markColor
    },
    rect: {
        fill: markColor
    },
    shape: {
        stroke: markColor
    },
    symbol: {
        stroke: markColor
    },
    circle: {
        fill: markColor
    },
    background: '#fff',
    padding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10
    },
    style: {
        'guide-label': {
            font: defaultFont$1,
            fontSize: 12
        },
        'guide-title': {
            font: defaultFont$1,
            fontSize: 12
        },
        'group-title': {
            font: defaultFont$1,
            fontSize: 12
        }
    },
    title: {
        font: defaultFont$1,
        fontSize: 14,
        fontWeight: 'bold',
        dy: -3,
        anchor: 'start'
    },
    axis: {
        gridColor: gridColor,
        tickColor: gridColor,
        domain: false,
        grid: true
    },
    range: {
        category: [
            '#4285F4',
            '#DB4437',
            '#F4B400',
            '#0F9D58',
            '#AB47BC',
            '#00ACC1',
            '#FF7043',
            '#9E9D24',
            '#5C6BC0',
            '#F06292',
            '#00796B',
            '#C2185B'
        ],
        heatmap: [
            '#c6dafc',
            '#5e97f6',
            '#2a56c6'
        ]
    }
};
const ptToPx = (value)=>value * (1 / 3 + 1);
const fontSmallPx = ptToPx(9);
const legendFontPx = ptToPx(10);
const fontLargePx = ptToPx(12);
const fontStandard = 'Segoe UI';
const fontTitle = 'wf_standard-font, helvetica, arial, sans-serif';
const firstLevelElementColor = '#252423';
const secondLevelElementColor = '#605E5C';
const backgroundColor = 'transparent';
const backgroundSecondaryColor = '#C8C6C4';
const paletteColor1 = '#118DFF';
const paletteColor2 = '#12239E';
const paletteColor3 = '#E66C37';
const paletteColor4 = '#6B007B';
const paletteColor5 = '#E044A7';
const paletteColor6 = '#744EC2';
const paletteColor7 = '#D9B300';
const paletteColor8 = '#D64550';
const divergentColorMax = paletteColor1;
const divergentColorMin = '#DEEFFF';
const divergentPalette = [
    divergentColorMin,
    divergentColorMax
];
const ordinalPalette = [
    divergentColorMin,
    '#c7e4ff',
    '#b0d9ff',
    '#9aceff',
    '#83c3ff',
    '#6cb9ff',
    '#55aeff',
    '#3fa3ff',
    '#2898ff',
    divergentColorMax
];
const powerbiTheme = {
    view: {
        stroke: backgroundColor
    },
    background: backgroundColor,
    font: fontStandard,
    header: {
        titleFont: fontTitle,
        titleFontSize: fontLargePx,
        titleColor: firstLevelElementColor,
        labelFont: fontStandard,
        labelFontSize: legendFontPx,
        labelColor: secondLevelElementColor
    },
    axis: {
        ticks: false,
        grid: false,
        domain: false,
        labelColor: secondLevelElementColor,
        labelFontSize: fontSmallPx,
        titleFont: fontTitle,
        titleColor: firstLevelElementColor,
        titleFontSize: fontLargePx,
        titleFontWeight: 'normal'
    },
    axisQuantitative: {
        tickCount: 3,
        grid: true,
        gridColor: backgroundSecondaryColor,
        gridDash: [
            1,
            5
        ],
        labelFlush: false
    },
    axisBand: {
        tickExtra: true
    },
    axisX: {
        labelPadding: 5
    },
    axisY: {
        labelPadding: 10
    },
    bar: {
        fill: paletteColor1
    },
    line: {
        stroke: paletteColor1,
        strokeWidth: 3,
        strokeCap: 'round',
        strokeJoin: 'round'
    },
    text: {
        font: fontStandard,
        fontSize: fontSmallPx,
        fill: secondLevelElementColor
    },
    arc: {
        fill: paletteColor1
    },
    area: {
        fill: paletteColor1,
        line: true,
        opacity: 0.6
    },
    path: {
        stroke: paletteColor1
    },
    rect: {
        fill: paletteColor1
    },
    point: {
        fill: paletteColor1,
        filled: true,
        size: 75
    },
    shape: {
        stroke: paletteColor1
    },
    symbol: {
        fill: paletteColor1,
        strokeWidth: 1.5,
        size: 50
    },
    legend: {
        titleFont: fontStandard,
        titleFontWeight: 'bold',
        titleColor: secondLevelElementColor,
        labelFont: fontStandard,
        labelFontSize: legendFontPx,
        labelColor: secondLevelElementColor,
        symbolType: 'circle',
        symbolSize: 75
    },
    range: {
        category: [
            paletteColor1,
            paletteColor2,
            paletteColor3,
            paletteColor4,
            paletteColor5,
            paletteColor6,
            paletteColor7,
            paletteColor8
        ],
        diverging: divergentPalette,
        heatmap: divergentPalette,
        ordinal: ordinalPalette
    }
};
const defaultFont = 'IBM Plex Sans,system-ui,-apple-system,BlinkMacSystemFont,".sfnstext-regular",sans-serif';
const condensedFont = 'IBM Plex Sans Condensed, system-ui, -apple-system, BlinkMacSystemFont, ".SFNSText-Regular", sans-serif';
const fontWeight = 400;
const TOKENS = {
    textPrimary: {
        g90: '#f4f4f4',
        g100: '#f4f4f4',
        white: '#161616',
        g10: '#161616'
    },
    textSecondary: {
        g90: '#c6c6c6',
        g100: '#c6c6c6',
        white: '#525252',
        g10: '#525252'
    },
    // layer
    layerAccent01: {
        white: '#e0e0e0',
        g10: '#e0e0e0',
        g90: '#525252',
        g100: '#393939'
    },
    // grid
    gridBg: {
        white: '#ffffff',
        g10: '#ffffff',
        g90: '#161616',
        g100: '#161616'
    }
};
const darkCategories = [
    '#8a3ffc',
    '#33b1ff',
    '#007d79',
    '#ff7eb6',
    '#fa4d56',
    '#fff1f1',
    '#6fdc8c',
    '#4589ff',
    '#d12771',
    '#d2a106',
    '#08bdba',
    '#bae6ff',
    '#ba4e00',
    '#d4bbff'
];
const lightCategories = [
    '#6929c4',
    '#1192e8',
    '#005d5d',
    '#9f1853',
    '#fa4d56',
    '#570408',
    '#198038',
    '#002d9c',
    '#ee538b',
    '#b28600',
    '#009d9a',
    '#012749',
    '#8a3800',
    '#a56eff'
];
function genCarbonConfig({ theme, background }) {
    const type = [
        'white',
        'g10'
    ].includes(theme) ? 'light' : 'dark';
    const viewbg = TOKENS.gridBg[theme];
    const titleColor = TOKENS.textPrimary[theme];
    const textColor = TOKENS.textSecondary[theme];
    const category = type === 'dark' ? darkCategories : lightCategories;
    const markColor = type === 'dark' ? '#d4bbff' : '#6929c4';
    return {
        background,
        arc: {
            fill: markColor
        },
        area: {
            fill: markColor
        },
        path: {
            stroke: markColor
        },
        rect: {
            fill: markColor
        },
        shape: {
            stroke: markColor
        },
        symbol: {
            stroke: markColor
        },
        circle: {
            fill: markColor
        },
        view: {
            fill: viewbg,
            stroke: viewbg
        },
        group: {
            fill: viewbg
        },
        title: {
            color: titleColor,
            anchor: 'start',
            dy: -15,
            fontSize: 16,
            font: defaultFont,
            fontWeight: 600
        },
        axis: {
            // Axis labels
            labelColor: textColor,
            labelFontSize: 12,
            labelFont: condensedFont,
            labelFontWeight: fontWeight,
            // Axis titles
            titleColor: titleColor,
            titleFontWeight: 600,
            titleFontSize: 12,
            // MISC
            grid: true,
            gridColor: TOKENS.layerAccent01[theme],
            labelAngle: 0
        },
        axisX: {
            titlePadding: 10
        },
        axisY: {
            titlePadding: 2.5
        },
        style: {
            'guide-label': {
                font: defaultFont,
                fill: textColor,
                fontWeight: fontWeight
            },
            'guide-title': {
                font: defaultFont,
                fill: textColor,
                fontWeight: fontWeight
            }
        },
        range: {
            category,
            diverging: [
                '#750e13',
                '#a2191f',
                '#da1e28',
                '#fa4d56',
                '#ff8389',
                '#ffb3b8',
                '#ffd7d9',
                '#fff1f1',
                '#e5f6ff',
                '#bae6ff',
                '#82cfff',
                '#33b1ff',
                '#1192e8',
                '#0072c3',
                '#00539a',
                '#003a6d'
            ],
            heatmap: [
                '#f6f2ff',
                '#e8daff',
                '#d4bbff',
                '#be95ff',
                '#a56eff',
                '#8a3ffc',
                '#6929c4',
                '#491d8b',
                '#31135e',
                '#1c0f30'
            ]
        }
    };
}
const carbonwhite = genCarbonConfig({
    theme: 'white',
    background: '#ffffff'
});
const carbong10 = genCarbonConfig({
    theme: 'g10',
    background: '#f4f4f4'
});
const carbong90 = genCarbonConfig({
    theme: 'g90',
    background: '#262626'
});
const carbong100 = genCarbonConfig({
    theme: 'g100',
    background: '#161616'
});
const version = pkg.version;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jfqql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_OPTIONS", ()=>DEFAULT_OPTIONS);
parcelHelpers.export(exports, "Handler", ()=>Handler);
parcelHelpers.export(exports, "calculatePositionRelativeToCursor", ()=>calculatePositionRelativeToCursor);
parcelHelpers.export(exports, "calculatePositionRelativeToMark", ()=>calculatePositionRelativeToMark);
parcelHelpers.export(exports, "createDefaultStyle", ()=>createDefaultStyle);
parcelHelpers.export(exports, "default", ()=>index);
parcelHelpers.export(exports, "escapeHTML", ()=>escapeHTML);
parcelHelpers.export(exports, "formatValue", ()=>formatValue);
parcelHelpers.export(exports, "getMarkBounds", ()=>getMarkBounds);
parcelHelpers.export(exports, "getPositions", ()=>getPositions);
parcelHelpers.export(exports, "mouseIsOnTooltip", ()=>mouseIsOnTooltip);
parcelHelpers.export(exports, "replacer", ()=>replacer);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "tooltipIsInViewport", ()=>tooltipIsInViewport);
parcelHelpers.export(exports, "version", ()=>version);
var _vegaUtil = require("vega-util");
var version$1 = "1.0.0";
var pkg = {
    version: version$1
};
/**
 * Format the value to be shown in the tooltip.
 *
 * @param value The value to show in the tooltip.
 * @param valueToHtml Function to convert a single cell value to an HTML string
 */ function formatValue(value, valueToHtml, maxDepth, baseURL) {
    if ((0, _vegaUtil.isArray)(value)) return `[${value.map((v)=>valueToHtml((0, _vegaUtil.isString)(v) ? v : stringify(v, maxDepth))).join(', ')}]`;
    if ((0, _vegaUtil.isObject)(value)) {
        let content = '';
        const { title, image, ...rest } = value;
        if (title) content += `<h2>${valueToHtml(title)}</h2>`;
        if (image) content += `<img src="${new URL(valueToHtml(image), baseURL || location.href).href}">`;
        const keys = Object.keys(rest);
        if (keys.length > 0) {
            content += '<table>';
            for (const key of keys){
                let val = rest[key];
                // ignore undefined properties
                if (val === undefined) continue;
                if ((0, _vegaUtil.isObject)(val)) val = stringify(val, maxDepth);
                content += `<tr><td class="key">${valueToHtml(key)}</td><td class="value">${valueToHtml(val)}</td></tr>`;
            }
            content += `</table>`;
        }
        return content || '{}'; // show empty object if there are no properties
    }
    return valueToHtml(value);
}
function replacer(maxDepth) {
    const stack = [];
    return function(key, value) {
        if (typeof value !== 'object' || value === null) return value;
        const pos = stack.indexOf(this) + 1;
        stack.length = pos;
        if (stack.length > maxDepth) return '[Object]';
        if (stack.indexOf(value) >= 0) return '[Circular]';
        stack.push(value);
        return value;
    };
}
/**
 * Stringify any JS object to valid JSON
 */ function stringify(obj, maxDepth) {
    return JSON.stringify(obj, replacer(maxDepth));
}
// generated with build-style.sh
var defaultStyle = `#vg-tooltip-element {
  visibility: hidden;
  padding: 8px;
  position: fixed;
  z-index: 1000;
  font-family: sans-serif;
  font-size: 11px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  /* The default theme is the light theme. */
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  color: black;
}
#vg-tooltip-element.visible {
  visibility: visible;
}
#vg-tooltip-element h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 13px;
}
#vg-tooltip-element table {
  border-spacing: 0;
}
#vg-tooltip-element table tr {
  border: none;
}
#vg-tooltip-element table tr td {
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 2px;
  padding-bottom: 2px;
}
#vg-tooltip-element table tr td.key {
  color: #808080;
  max-width: 150px;
  text-align: right;
  padding-right: 4px;
}
#vg-tooltip-element table tr td.value {
  display: block;
  max-width: 300px;
  max-height: 7em;
  text-align: left;
}
#vg-tooltip-element.dark-theme {
  background-color: rgba(32, 32, 32, 0.9);
  border: 1px solid #f5f5f5;
  color: white;
}
#vg-tooltip-element.dark-theme td.key {
  color: #bfbfbf;
}
`;
const EL_ID = 'vg-tooltip-element';
const DEFAULT_OPTIONS = {
    offsetX: 10,
    offsetY: 10,
    id: EL_ID,
    styleId: 'vega-tooltip-style',
    theme: 'light',
    disableDefaultStyle: false,
    sanitize: escapeHTML,
    maxDepth: 2,
    formatTooltip: formatValue,
    baseURL: '',
    anchor: 'cursor',
    position: [
        'top',
        'bottom',
        'left',
        'right',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]
};
/**
 * Escape special HTML characters.
 *
 * @param value A value to convert to string and HTML-escape.
 */ function escapeHTML(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;');
}
function createDefaultStyle(id) {
    // Just in case this id comes from a user, ensure these is no security issues
    if (!/^[A-Za-z]+[-:.\w]*$/.test(id)) throw new Error('Invalid HTML ID');
    return defaultStyle.toString().replaceAll(EL_ID, id);
}
/**
 * Position the tooltip
 *
 * @param event The mouse event.
 * @param tooltipBox
 * @param options Tooltip handler options.
 */ function calculatePositionRelativeToCursor(event, tooltipBox, { offsetX, offsetY }) {
    // the possible positions for the tooltip
    const positions = getPositions({
        x1: event.clientX,
        x2: event.clientX,
        y1: event.clientY,
        y2: event.clientY
    }, tooltipBox, offsetX, offsetY);
    // order of positions to try
    const postionArr = [
        'bottom-right',
        'bottom-left',
        'top-right',
        'top-left'
    ];
    // test positions till a valid one is found
    for (const p of postionArr){
        if (tooltipIsInViewport(positions[p], tooltipBox)) return positions[p];
    }
    // default to top-left if a valid position is not found
    // this is legacy behavior
    return positions['top-left'];
}
/**
 * Calculates the position of the tooltip relative to the mark.
 * @param handler The handler instance.
 * @param event The mouse event.
 * @param item The item that the tooltip is being shown for.
 * @param tooltipBox Client rect of the tooltip element.
 * @param options Tooltip handler options.
 * @returns
 */ function calculatePositionRelativeToMark(handler, event, item, tooltipBox, options) {
    const { position, offsetX, offsetY } = options;
    const containerBox = handler._el.getBoundingClientRect();
    const origin = handler._origin;
    // bounds of the mark relative to the viewport
    const markBounds = getMarkBounds(containerBox, origin, item);
    // the possible positions for the tooltip
    const positions = getPositions(markBounds, tooltipBox, offsetX, offsetY);
    // positions to test
    const positionArr = Array.isArray(position) ? position : [
        position
    ];
    // test positions till a valid one is found
    for (const p of positionArr){
        // verify that the tooltip is in the view and the mouse is not where the tooltip would be
        if (tooltipIsInViewport(positions[p], tooltipBox) && !mouseIsOnTooltip(event, positions[p], tooltipBox)) return positions[p];
    }
    // default to cursor position if a valid position is not found
    return calculatePositionRelativeToCursor(event, tooltipBox, options);
}
// Calculates the bounds of the mark relative to the viewport.
function getMarkBounds(containerBox, origin, item) {
    // if this is a voronoi mark, we want to use the bounds of the point that voronoi cell represents
    const markBounds = item.isVoronoi ? item.datum.bounds : item.bounds;
    let left = containerBox.left + origin[0] + markBounds.x1;
    let top = containerBox.top + origin[1] + markBounds.y1;
    // traverse mark groups, summing their offsets to get the total offset
    // item bounds are relative to their group so if there are multiple nested groups we need to add them all
    let parentItem = item;
    while(parentItem.mark.group){
        parentItem = parentItem.mark.group;
        left += parentItem.x ?? 0;
        top += parentItem.y ?? 0;
    }
    const markWidth = markBounds.x2 - markBounds.x1;
    const markHeight = markBounds.y2 - markBounds.y1;
    return {
        x1: left,
        x2: left + markWidth,
        y1: top,
        y2: top + markHeight
    };
}
// Calculates the tooltip xy for each possible position.
function getPositions(markBounds, tooltipBox, offsetX, offsetY) {
    const xc = (markBounds.x1 + markBounds.x2) / 2;
    const yc = (markBounds.y1 + markBounds.y2) / 2;
    // x positions
    const left = markBounds.x1 - tooltipBox.width - offsetX;
    const center = xc - tooltipBox.width / 2;
    const right = markBounds.x2 + offsetX;
    // y positions
    const top = markBounds.y1 - tooltipBox.height - offsetY;
    const middle = yc - tooltipBox.height / 2;
    const bottom = markBounds.y2 + offsetY;
    const positions = {
        top: {
            x: center,
            y: top
        },
        bottom: {
            x: center,
            y: bottom
        },
        left: {
            x: left,
            y: middle
        },
        right: {
            x: right,
            y: middle
        },
        'top-left': {
            x: left,
            y: top
        },
        'top-right': {
            x: right,
            y: top
        },
        'bottom-left': {
            x: left,
            y: bottom
        },
        'bottom-right': {
            x: right,
            y: bottom
        }
    };
    return positions;
}
// Checks if the tooltip would be in the viewport at the given position
function tooltipIsInViewport(position, tooltipBox) {
    return position.x >= 0 && position.y >= 0 && position.x + tooltipBox.width <= window.innerWidth && position.y + tooltipBox.height <= window.innerHeight;
}
// Checks if the mouse is within the tooltip area
function mouseIsOnTooltip(event, position, tooltipBox) {
    return event.clientX >= position.x && event.clientX <= position.x + tooltipBox.width && event.clientY >= position.y && event.clientY <= position.y + tooltipBox.height;
}
/**
 * The tooltip handler class.
 */ class Handler {
    /**
     * The handler function. We bind this to this function in the constructor.
     */ call;
    /**
     * Complete tooltip options.
     */ options;
    /**
     * The tooltip html element.
     */ el;
    /**
     * Create the tooltip handler and initialize the element and style.
     *
     * @param options Tooltip Options
     */ constructor(options){
        this.options = {
            ...DEFAULT_OPTIONS,
            ...options
        };
        const elementId = this.options.id;
        this.el = null;
        // bind this to call
        this.call = this.tooltipHandler.bind(this);
        // prepend a default stylesheet for tooltips to the head
        if (!this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
            const style = document.createElement('style');
            style.setAttribute('id', this.options.styleId);
            style.innerHTML = createDefaultStyle(elementId);
            const head = document.head;
            if (head.childNodes.length > 0) head.insertBefore(style, head.childNodes[0]);
            else head.appendChild(style);
        }
    }
    /**
     * The tooltip handler function.
     */ tooltipHandler(handler, event, item, value) {
        // append a div element that we use as a tooltip unless it already exists
        this.el = document.getElementById(this.options.id);
        if (!this.el) {
            this.el = document.createElement('div');
            this.el.setAttribute('id', this.options.id);
            this.el.classList.add('vg-tooltip');
            const tooltipContainer = document.fullscreenElement ?? document.body;
            tooltipContainer.appendChild(this.el);
        }
        // hide tooltip for null, undefined, or empty string values
        if (value == null || value === '') {
            this.el.classList.remove('visible', `${this.options.theme}-theme`);
            return;
        }
        // set the tooltip content
        this.el.innerHTML = this.options.formatTooltip(value, this.options.sanitize, this.options.maxDepth, this.options.baseURL);
        // make the tooltip visible
        this.el.classList.add('visible', `${this.options.theme}-theme`);
        const { x, y } = this.options.anchor === 'mark' ? calculatePositionRelativeToMark(handler, event, item, this.el.getBoundingClientRect(), this.options) : calculatePositionRelativeToCursor(event, this.el.getBoundingClientRect(), this.options);
        this.el.style.top = `${y}px`;
        this.el.style.left = `${x}px`;
    }
}
const version = pkg.version;
/**
 * Create a tooltip handler and register it with the provided view.
 *
 * @param view The Vega view.
 * @param opt Tooltip options.
 */ function index(view, opt) {
    const handler = new Handler(opt);
    view.tooltip(handler.call).run();
    return handler;
}

},{"vega-util":"kncZn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyRHo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Combines the slicers reducers manually, to account for leaving the rest
 * of the global reducer unchanged.
 */ parcelHelpers.export(exports, "dataflowReducer", ()=>dataflowReducer);
parcelHelpers.export(exports, "dataflowInitialState", ()=>dataflowInitialState);
var _pulsesSliceJs = require("./pulsesSlice.js");
var _runtimeSliceJs = require("./runtimeSlice.js");
var _selectionSliceJs = require("./selectionSlice.js");
var _layoutSliceJs = require("./layoutSlice.js");
var _popupSliceJs = require("./popupSlice.js");
// Since we are using a number of pulses defined here with the rest of the global redux state
// we need a few custom functions to combine these reducers and state types, to integrate
// them into the rest of the redux state.
const slices = [
    (0, _pulsesSliceJs.pulsesSlice),
    (0, _runtimeSliceJs.runtimeSlice),
    (0, _selectionSliceJs.selectionSlice),
    (0, _layoutSliceJs.layoutSlice),
    (0, _popupSliceJs.popupSlice)
];
function dataflowReducer(state, action) {
    const [changedStates, stateChanged] = slices.reduce((prevValue, slice)=>{
        const previousState = state[slice.name];
        const nextState = slice.reducer(previousState, action);
        if (nextState === previousState) return prevValue;
        return [
            {
                ...prevValue[0],
                [slice.name]: nextState
            },
            true
        ];
    }, [
        [],
        false
    ]);
    return stateChanged ? {
        ...state,
        ...changedStates
    } : state;
}
const dataflowInitialState = Object.fromEntries(slices.map((s)=>[
        s.name,
        undefined
    ]));

},{"./pulsesSlice.js":"eeulL","./runtimeSlice.js":"iZrZf","./selectionSlice.js":"bBSOy","./layoutSlice.js":"67Uyo","./popupSlice.js":"eODwE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eeulL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recordPulse", ()=>recordPulse);
parcelHelpers.export(exports, "resetPulses", ()=>resetPulses);
parcelHelpers.export(exports, "pulsesSlice", ()=>pulsesSlice);
parcelHelpers.export(exports, "pulsesSelector", ()=>pulsesSelector);
parcelHelpers.export(exports, "sortedPulsesSelector", ()=>sortedPulsesSelector);
parcelHelpers.export(exports, "pulsesEmptySelector", ()=>pulsesEmptySelector);
var _toolkit = require("@reduxjs/toolkit");
var _runtimeSliceJs = require("./runtimeSlice.js");
var _createSliceSelectorJs = require("./utils/createSliceSelector.js");
var _sanitizeValueJs = require("./utils/sanitizeValue.js");
const initialState = [];
// Trim stored pulses to this maximum. If new pulses are recorded past this, drop them
const MAX_PULSES = 100;
const recordPulse = (0, _toolkit.createAction)('recordPulse', (clock, values)=>({
        payload: {
            clock,
            values: Object.fromEntries(Object.entries(values).map(([k, v])=>[
                    k,
                    (0, _sanitizeValueJs.sanitizeValue)(v)
                ]))
        }
    }));
const resetPulses = (0, _toolkit.createAction)('resetPulses');
const pulsesSlice = (0, _toolkit.createSlice)({
    name: 'pulses',
    initialState,
    reducers: {},
    extraReducers: (builder)=>builder.addCase((0, _runtimeSliceJs.setRuntime), ()=>initialState).addCase(resetPulses, ()=>initialState).addCase(recordPulse, (state, { payload })=>{
            if (state.length > MAX_PULSES) state.shift();
            state.push({
                ...payload,
                nValues: Object.keys(payload.values).length
            });
        })
});
const pulsesSelector = (0, _createSliceSelectorJs.createSliceSelector)(pulsesSlice);
const sortedPulsesSelector = (0, _toolkit.createSelector)(pulsesSelector, (pulses)=>pulses.slice(0).reverse());
const pulsesEmptySelector = (0, _toolkit.createSelector)(pulsesSelector, (pulses)=>pulses.length === 0);

},{"@reduxjs/toolkit":"6q4uk","./runtimeSlice.js":"iZrZf","./utils/createSliceSelector.js":"fnXHV","./utils/sanitizeValue.js":"5jMZ7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6q4uk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnhancerArray", ()=>EnhancerArray);
parcelHelpers.export(exports, "MiddlewareArray", ()=>MiddlewareArray);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immerDefault.default));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "getDefaultMiddleware", ()=>getDefaultMiddleware);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
// src/index.ts
var _immer = require("immer");
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immerDefault = parcelHelpers.interopDefault(_immer);
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var global = arguments[3];
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for(var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = function(a, b) {
    return __defProps(a, __getOwnPropDescs(b));
};
var __async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var createDraftSafeSelector = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, _reselect.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, __spreadArray([
            (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function isAction(action) {
    return isPlainObject(action) && "type" in action;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
function isFSA(action) {
    return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var MiddlewareArray = /** @class */ function(_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var EnhancerArray = /** @class */ function(_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immerDefault.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = isPlain;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunkDefault.default));
        else middlewareArray.push((0, _reduxThunkDefault.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = true;
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if (isPlainObject(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, _redux.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        trace: !IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = __spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) getInitialState = function() {
        return freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immerDefault.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createDraftSafeSelector(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, _immer.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, _immerDefault.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !(selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) options = {};
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var miniSerializeError = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var createAsyncThunk = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = createAction(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = createAction(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return __async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof RejectWithValue) throw result;
                                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var matches = function(matcher, action) {
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return matches(matcher, action);
        });
    };
}
function isAllOf() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return matches(matcher, action);
        });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var noop = function() {};
var catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = noop;
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var validateActive = function(signal) {
    if (signal.aborted) throw new TaskAbortError(signal.reason);
};
function raceWithSignal(signal, promise2) {
    var cleanup = noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new TaskAbortError(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = noop;
    });
}
var runTask = function(task2, cleanUp) {
    return __async(void 0, null, function() {
        var value, error_1;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var createPause = function(signal) {
    return function(promise2) {
        return catchRejection(raceWithSignal(signal, promise2).then(function(output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function(signal) {
    var pause = createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return addAbortSignalListener(parentAbortSignal, function() {
            return abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function() {
            return __async(void 0, null, function() {
                var result2;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            validateActive(parentAbortSignal);
                            validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: createPause(childAbortController.signal),
                                    delay: createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return abortControllerWithReason(childAbortController, taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function() {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return __async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return catchRejection(take(predicate, timeout));
    };
};
var getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var createListenerEntry = function(options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, __spreadArray([
        alm + "/error"
    ], args));
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return __async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: createDelay(internalTaskController.signal),
                                pause: createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            abortControllerWithReason(controller, listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof TaskAbortError)) safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        abortControllerWithReason(internalTaskController, listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!isAction(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
        };
    };
};
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : globalThis) : function(cb) {
    return (promise || (promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, _immer.enableES5)();

},{"immer":"5MAV8","redux":"jTcSr","reselect":"1umb1","redux-thunk":"5hWib","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5MAV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>un);
parcelHelpers.export(exports, "applyPatches", ()=>pn);
parcelHelpers.export(exports, "castDraft", ()=>K);
parcelHelpers.export(exports, "castImmutable", ()=>$);
parcelHelpers.export(exports, "createDraft", ()=>ln);
parcelHelpers.export(exports, "current", ()=>R);
parcelHelpers.export(exports, "enableAllPlugins", ()=>J);
parcelHelpers.export(exports, "enableES5", ()=>F);
parcelHelpers.export(exports, "enableMapSet", ()=>C);
parcelHelpers.export(exports, "enablePatches", ()=>T);
parcelHelpers.export(exports, "finishDraft", ()=>dn);
parcelHelpers.export(exports, "freeze", ()=>d);
parcelHelpers.export(exports, "immerable", ()=>L);
parcelHelpers.export(exports, "isDraft", ()=>r);
parcelHelpers.export(exports, "isDraftable", ()=>t);
parcelHelpers.export(exports, "nothing", ()=>H);
parcelHelpers.export(exports, "original", ()=>e);
parcelHelpers.export(exports, "produce", ()=>fn);
parcelHelpers.export(exports, "produceWithPatches", ()=>cn);
parcelHelpers.export(exports, "setAutoFreeze", ()=>sn);
parcelHelpers.export(exports, "setUseProxies", ()=>vn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
exports.default = fn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1umb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"d50E4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d50E4":[function(require,module,exports,__globalThis) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = 'NOT_FOUND';
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5hWib":[function(require,module,exports,__globalThis) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iZrZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setRuntime", ()=>setRuntime);
parcelHelpers.export(exports, "runtimeSlice", ()=>runtimeSlice);
parcelHelpers.export(exports, "runtimeSelector", ()=>runtimeSelector);
parcelHelpers.export(exports, "graphSelector", ()=>graphSelector);
parcelHelpers.export(exports, "cytoscapeElementsSelector", ()=>cytoscapeElementsSelector);
var _toolkit = require("@reduxjs/toolkit");
var _toCytoscapeJs = require("./utils/toCytoscape.js");
var _createSliceSelectorJs = require("./utils/createSliceSelector.js");
var _runtimeToGraphJs = require("./utils/runtimeToGraph.js");
const initialState = null;
const setRuntime = (0, _toolkit.createAction)('setRuntime');
const runtimeSlice = (0, _toolkit.createSlice)({
    name: 'runtime',
    initialState,
    reducers: {},
    extraReducers: (builder)=>builder.addCase(setRuntime, (_state, { payload })=>payload)
});
const runtimeSelector = (0, _createSliceSelectorJs.createSliceSelector)(runtimeSlice);
const graphSelector = (0, _toolkit.createSelector)(runtimeSelector, (runtime)=>runtime === null ? null : (0, _runtimeToGraphJs.runtimeToGraph)(runtime));
const cytoscapeElementsSelector = (0, _toolkit.createSelector)(graphSelector, (graph)=>graph === null ? null : (0, _toCytoscapeJs.toCytoscape)(graph));

},{"@reduxjs/toolkit":"6q4uk","./utils/toCytoscape.js":"e7vgc","./utils/createSliceSelector.js":"fnXHV","./utils/runtimeToGraph.js":"2mhSP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e7vgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toCytoscape", ()=>toCytoscape);
function toCytoscape(graph) {
    // Keep a mapping of all IDs so we can add their position when traversing the ELK graph
    const nodes = Object.entries(graph.nodes).map(([id, { parent, label, colorKey, size }])=>({
            data: {
                id,
                parent,
                label,
                colorKey,
                ...size
            }
        }));
    const edges = Object.entries(graph.edges).map(([id, { source, target, primary, label }])=>({
            data: {
                id,
                source,
                target,
                primary: primary.toString(),
                label: label
            }
        }));
    return {
        nodes,
        edges
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fnXHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Type slice selectors conservatively, so they only require the part of the state that is relevant to the slice.
 */ parcelHelpers.export(exports, "createSliceSelector", ()=>createSliceSelector);
function createSliceSelector(slice) {
    return (state)=>state[slice.name];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2mhSP":[function(require,module,exports,__globalThis) {
/**
 * Converts a Vega dataflow runtime expression to an abstract graph representation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runtimeToGraph", ()=>runtimeToGraph);
var _prettifyJs = require("./prettify.js");
var _measureTextJs = require("./measureText.js");
function runtimeToGraph(runtime) {
    const graph = {
        nodes: {},
        edges: {}
    };
    addRuntime(graph, runtime);
    return graph;
}
function addRuntime(graph, runtime) {
    runtime.bindings.forEach((b)=>addBinding(graph, b));
    addFlow(graph, runtime, undefined);
}
function addFlow(graph, { streams, operators, updates }, parent) {
    streams.forEach((s)=>addStream(graph, s, parent));
    operators.forEach((o)=>addOperator(graph, o, parent));
    updates.forEach((u, i)=>addUpdate(graph, u, i, parent));
}
function addOperator(graph, { id, type, params, ...rest }, parent) {
    addNode(graph, {
        type: 'operator',
        id,
        parent,
        colorKey: `operator:${type}`,
        label: type
    });
    addParam(graph, id, 'ID', id.toString(), false);
    addOperatorParameters(graph, id, params);
    // Don't show metadata
    delete rest['metadata'];
    // Refs is always null
    delete rest['refs'];
    if ('update' in rest) {
        addParam(graph, id, 'update', rest.update.code);
        delete rest['update'];
    }
    if (rest.parent !== undefined) {
        const parentID = rest.parent.$ref;
        addEdge(graph, {
            source: parentID,
            target: id
        });
        delete rest['parent'];
    }
    // Handle data separately to show in graph as nodes
    if (rest.data !== undefined) {
        addData(graph, id, rest.data, parent);
        delete rest['data'];
    }
    if (rest.signal !== undefined) {
        addSignal(graph, id, rest.signal, parent);
        delete rest['signal'];
    }
    for (const [k, v] of Object.entries(rest)){
        if (v === undefined) continue;
        addParam(graph, id, k, JSON.stringify(v));
    }
}
function addSignal(graph, id, signal, parent) {
    // If we have a signal, add a node for that signal if we havent already,
    // and add an edge.
    // If we have already added a binding for that signal, we use that node instead
    // of making a new one
    const signalID = parent !== undefined ? `${parent}.${signal}` : signal;
    if (!hasNode(graph, signalID)) addNode(graph, {
        type: 'signal',
        id: signalID,
        parent,
        label: signal
    });
    associateNode(graph, signalID, id);
    addEdge(graph, {
        source: signalID,
        target: id,
        label: 'signal'
    });
}
function addData(graph, id, data, parent) {
    for (const [name, dataset] of Object.entries(data)){
        const datasetNodeID = `data.${parent ?? 'root'}.${name}`;
        if (!hasNode(graph, datasetNodeID)) addNode(graph, {
            type: 'data',
            id: datasetNodeID,
            parent,
            label: name
        });
        associateNode(graph, datasetNodeID, id);
        for (const stage of new Set(dataset)){
            const datasetStageNodeID = `${datasetNodeID}.${stage}`;
            addNode(graph, {
                type: 'data',
                id: datasetStageNodeID,
                parent: datasetNodeID,
                label: stage
            });
            associateNode(graph, datasetStageNodeID, id);
            addEdge(graph, {
                source: datasetStageNodeID,
                target: id
            });
        }
    }
}
function addOperatorParameters(graph, id, params) {
    for (const [k, v] of Object.entries(params ?? {})){
        if (v === undefined) continue;
        // We have to check to see if the parameter values is a either a regular JSON value,
        // or a special case parameter, or a list of values/special case parameters.
        if (Array.isArray(v)) {
            const added = new Set();
            for (const [i, vI] of v.entries())if (addOperatorParameter(graph, id, `${k}[${i}]`, vI)) added.add(i);
            // If we didn't add any operators, then add them all as one array
            if (added.size === 0) {
                addParam(graph, id, k, JSON.stringify(v));
                continue;
            }
            // otherwise, add all that aren't added
            for (const [i, vI] of v.entries())if (!added.has(i)) addParam(graph, id, `${k}[${i}]`, JSON.stringify(vI));
            continue;
        }
        // Tries adding the operator parameter as a special case, if that fails,
        // then add as a regular parameter by stringifying
        if (!addOperatorParameter(graph, id, k, v)) addParam(graph, id, k, JSON.stringify(v));
    }
}
/**
 * Adds a parameter, returning whether it was added or not.
 */ function addOperatorParameter(graph, id, k, v) {
    // Hide null parent params
    if (k === 'parent' && v === null) return true;
    if (typeof v !== 'object') return false;
    if (v === null) return false;
    if ('$ref' in v) {
        const vID = v.$ref;
        const primary = k === 'pulse';
        const label = primary ? undefined : k;
        addEdge(graph, {
            source: vID,
            target: id,
            label,
            primary
        });
        return true;
    }
    if ('$subflow' in v) {
        addFlow(graph, v.$subflow, id);
        // Add edge to first node, which is root node and is used to detach the subflow
        // TODO: Disable for now, until we understand its purpose
        // const rootID = v.$subflow.operators[0].id;
        // addEdge(graph, {source: id, target: rootID, label: 'root'});
        return true;
    }
    if ('$expr' in v) {
        addParam(graph, id, k, v.$expr.code);
        for (const [label, { $ref }] of Object.entries(v.$params))addEdge(graph, {
            source: $ref,
            target: id,
            label: `${k}.${label}`
        });
        return true;
    }
    if ('$encode' in v) {
        for (const [stage, { $expr }] of Object.entries(v.$encode)){
            // Assumes that the marktype is the same in all stages
            addParam(graph, id, 'encode marktype', $expr.marktype);
            // Add each stage as a param, mapping each channel to its value
            addParam(graph, id, `encode.${stage}`, '{' + Object.entries($expr.channels).map(([channel, { code }])=>`${channel}: ${(0, _prettifyJs.prettifyExpression)(code)},`).join('\n') + '}');
        }
        return true;
    }
    return false;
}
function addUpdate(graph, { source, target, update, options }, index, parent) {
    // ID updates by index
    const id = `update-${parent || 'root'}.${index}`;
    addNode(graph, {
        type: 'update',
        id: id,
        parent,
        label: 'update'
    });
    if (options?.force) addParam(graph, id, 'force', 'true');
    if (update && typeof update === 'object' && '$expr' in update) {
        addParam(graph, id, 'value', update.$expr.code);
        for (const [k, v] of Object.entries(update.$params ?? {})){
            const paramID = v.$ref;
            associateNode(graph, id, paramID);
            addEdge(graph, {
                source: paramID,
                target: id,
                label: k
            });
        }
    } else addParam(graph, id, 'value', JSON.stringify(update));
    const sourceID = typeof source === 'object' ? source.$ref : source;
    associateNode(graph, id, sourceID);
    associateNode(graph, id, target);
    addEdge(graph, {
        source: sourceID,
        target: id
    });
    addEdge(graph, {
        source: id,
        target
    });
}
function addBinding(graph, { signal, ...rest }) {
    addNode(graph, {
        type: 'binding',
        id: signal,
        label: signal
    });
    for (const [k, v] of Object.entries(rest)){
        if (v === undefined) continue;
        addParam(graph, signal, k, JSON.stringify(v));
    }
}
function addStream(graph, stream, parent) {
    const { id } = stream;
    const label = 'stream' in stream ? 'stream' : 'merge' in stream ? 'merge' : `${stream.source}:${stream.type}`;
    addNode(graph, {
        type: 'stream',
        id,
        label,
        parent
    });
    addParam(graph, id, 'type', 'stream');
    if ('stream' in stream) addEdge(graph, {
        source: stream.stream,
        target: id
    });
    else if ('merge' in stream) stream.merge.forEach((from)=>{
        addEdge(graph, {
            source: from,
            target: id
        });
    });
    if ('between' in stream) {
        const [before, after] = stream.between;
        addEdge(graph, {
            source: before,
            target: id,
            label: 'before'
        });
        addEdge(graph, {
            source: id,
            target: after,
            label: 'after'
        });
    }
    if (stream.consume) addParam(graph, id, 'consume', 'true');
    if (stream.debounce) addParam(graph, id, 'debounce', stream.debounce.toString());
    if (stream.throttle) addParam(graph, id, 'throttle', stream.throttle.toString());
    if (stream.filter) addParam(graph, id, 'filter', stream.filter.code);
}
// Helper function to assist in adding to the graph, taking care of denormalization, converting node IDs
// to string, and adding edge IDs.
function addNode(graph, { id: runtimeID, parent: parentRuntimeID, colorKey, ...rest }) {
    const id = runtimeID.toString();
    const node = getNode(graph, id);
    Object.assign(node, rest);
    node.colorKey = colorKey ?? rest.type;
    node.size = (0, _measureTextJs.measureText)(node.label);
    node.associated.push(id);
    node.partition = rest.type === 'binding' || rest.type === 'signal' ? 0 : rest.type === 'stream' || rest.type === 'data' ? 1 : 2;
    if (parentRuntimeID) {
        const parentID = parentRuntimeID.toString();
        node.parent = parentID;
        getNode(graph, parentID).children.push(id);
    }
}
// TODO Namespace signal by parent?
function addEdge(graph, { source: runtimeSource, target: runtimeTarget, primary, label }) {
    const source = runtimeSource.toString();
    const target = runtimeTarget.toString();
    // Increment edge ids to make each unique
    graph.edges[`edge:${Object.keys(graph.edges).length}`] = {
        source,
        target,
        label,
        primary: primary ?? false,
        size: (0, _measureTextJs.measureText)(label ?? '')
    };
    getNode(graph, source).outgoing.push(target);
    getNode(graph, target).incoming.push(source);
}
function addParam(graph, id, key, value, prettify = true) {
    getNode(graph, id.toString()).params[key] = prettify ? (0, _prettifyJs.prettifyExpression)(value, key.length) : value;
}
function hasNode(graph, id) {
    return graph.nodes[id] !== undefined;
}
function associateNode(graph, nodeID, relatedID) {
    getNode(graph, nodeID.toString()).associated.push(relatedID.toString());
}
function getNode({ nodes }, id) {
    let node = nodes[id];
    if (!node) {
        node = {
            children: [],
            incoming: [],
            outgoing: [],
            associated: [],
            params: {},
            size: null
        };
        nodes[id] = node;
    }
    return node;
}

},{"./prettify.js":"1Apxr","./measureText.js":"Y6Xna","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Apxr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prettify a JS expression, by creating a statement out of it, then removing the variable decleration and trailing semi-colon.
 *
 * Pass in a label length to adjust how much is wrapped on the first line.
 **/ parcelHelpers.export(exports, "prettifyExpression", ()=>prettifyExpression);
var _standaloneJs = require("prettier2/standalone.js");
var _parserBabelJs = require("prettier2/parser-babel.js");
function prettifyExpression(expression, labelLength = 1) {
    const label = 'a'.repeat(labelLength);
    const prefix = `${label} = `;
    return _standaloneJs.format(`${prefix}${expression}`, {
        parser: 'babel',
        printWidth: 60,
        plugins: [
            _parserBabelJs
        ]
    }).slice(prefix.length, -2);
}

},{"prettier2/standalone.js":"at4uR","prettier2/parser-babel.js":"9q4ta","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"at4uR":[function(require,module,exports,__globalThis) {
var global = arguments[3];
(function(e) {
    var f;
    module.exports = e();
})(function() {
    "use strict";
    var xe = (e, r)=>()=>(r || e((r = {
                exports: {}
            }).exports, r), r.exports);
    var pt = xe((r0, pu)=>{
        var ir = function(e) {
            return e && e.Math == Math && e;
        };
        pu.exports = ir(typeof globalThis == "object" && globalThis) || ir(typeof window == "object" && window) || ir(typeof self == "object" && self) || ir(typeof global == "object" && global) || function() {
            return this;
        }() || Function("return this")();
    });
    var Dt = xe((n0, fu)=>{
        fu.exports = function(e) {
            try {
                return !!e();
            } catch  {
                return !0;
            }
        };
    });
    var yt = xe((u0, Du)=>{
        var Mo = Dt();
        Du.exports = !Mo(function() {
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] != 7;
        });
    });
    var ar = xe((s0, mu)=>{
        var Ro = Dt();
        mu.exports = !Ro(function() {
            var e = (function() {}).bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
        });
    });
    var At = xe((i0, du)=>{
        var $o = ar(), or = Function.prototype.call;
        du.exports = $o ? or.bind(or) : function() {
            return or.apply(or, arguments);
        };
    });
    var vu = xe((hu)=>{
        "use strict";
        var gu = {}.propertyIsEnumerable, yu = Object.getOwnPropertyDescriptor, Vo = yu && !gu.call({
            1: 2
        }, 1);
        hu.f = Vo ? function(r) {
            var t = yu(this, r);
            return !!t && t.enumerable;
        } : gu;
    });
    var lr = xe((o0, Cu)=>{
        Cu.exports = function(e, r) {
            return {
                enumerable: !(e & 1),
                configurable: !(e & 2),
                writable: !(e & 4),
                value: r
            };
        };
    });
    var mt = xe((l0, Au)=>{
        var Eu = ar(), Fu = Function.prototype, Wr = Fu.call, Wo = Eu && Fu.bind.bind(Wr, Wr);
        Au.exports = Eu ? Wo : function(e) {
            return function() {
                return Wr.apply(e, arguments);
            };
        };
    });
    var Vt = xe((c0, xu)=>{
        var Su = mt(), Ho = Su({}.toString), Go = Su("".slice);
        xu.exports = function(e) {
            return Go(Ho(e), 8, -1);
        };
    });
    var Tu = xe((p0, bu)=>{
        var Uo = mt(), Jo = Dt(), zo = Vt(), Hr = Object, Xo = Uo("".split);
        bu.exports = Jo(function() {
            return !Hr("z").propertyIsEnumerable(0);
        }) ? function(e) {
            return zo(e) == "String" ? Xo(e, "") : Hr(e);
        } : Hr;
    });
    var cr = xe((f0, Bu)=>{
        Bu.exports = function(e) {
            return e == null;
        };
    });
    var Gr = xe((D0, Nu)=>{
        var Ko = cr(), Yo = TypeError;
        Nu.exports = function(e) {
            if (Ko(e)) throw Yo("Can't call method on " + e);
            return e;
        };
    });
    var pr = xe((m0, wu)=>{
        var Qo = Tu(), Zo = Gr();
        wu.exports = function(e) {
            return Qo(Zo(e));
        };
    });
    var Jr = xe((d0, _u)=>{
        var Ur = typeof document == "object" && document.all, el = typeof Ur > "u" && Ur !== void 0;
        _u.exports = {
            all: Ur,
            IS_HTMLDDA: el
        };
    });
    var ot = xe((g0, Iu)=>{
        var Pu = Jr(), tl = Pu.all;
        Iu.exports = Pu.IS_HTMLDDA ? function(e) {
            return typeof e == "function" || e === tl;
        } : function(e) {
            return typeof e == "function";
        };
    });
    var St = xe((y0, Ou)=>{
        var ku = ot(), Lu = Jr(), rl = Lu.all;
        Ou.exports = Lu.IS_HTMLDDA ? function(e) {
            return typeof e == "object" ? e !== null : ku(e) || e === rl;
        } : function(e) {
            return typeof e == "object" ? e !== null : ku(e);
        };
    });
    var Wt = xe((h0, ju)=>{
        var zr = pt(), nl = ot(), ul = function(e) {
            return nl(e) ? e : void 0;
        };
        ju.exports = function(e, r) {
            return arguments.length < 2 ? ul(zr[e]) : zr[e] && zr[e][r];
        };
    });
    var Xr = xe((v0, qu)=>{
        var sl = mt();
        qu.exports = sl({}.isPrototypeOf);
    });
    var Ru = xe((C0, Mu)=>{
        var il = Wt();
        Mu.exports = il("navigator", "userAgent") || "";
    });
    var Ju = xe((E0, Uu)=>{
        var Gu = pt(), Kr = Ru(), $u = Gu.process, Vu = Gu.Deno, Wu = $u && $u.versions || Vu && Vu.version, Hu = Wu && Wu.v8, dt, fr;
        Hu && (dt = Hu.split("."), fr = dt[0] > 0 && dt[0] < 4 ? 1 : +(dt[0] + dt[1]));
        !fr && Kr && (dt = Kr.match(/Edge\/(\d+)/), (!dt || dt[1] >= 74) && (dt = Kr.match(/Chrome\/(\d+)/), dt && (fr = +dt[1])));
        Uu.exports = fr;
    });
    var Yr = xe((F0, Xu)=>{
        var zu = Ju(), al = Dt();
        Xu.exports = !!Object.getOwnPropertySymbols && !al(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && zu && zu < 41;
        });
    });
    var Qr = xe((A0, Ku)=>{
        var ol = Yr();
        Ku.exports = ol && !Symbol.sham && typeof Symbol.iterator == "symbol";
    });
    var Zr = xe((S0, Yu)=>{
        var ll = Wt(), cl = ot(), pl = Xr(), fl = Qr(), Dl = Object;
        Yu.exports = fl ? function(e) {
            return typeof e == "symbol";
        } : function(e) {
            var r = ll("Symbol");
            return cl(r) && pl(r.prototype, Dl(e));
        };
    });
    var Dr = xe((x0, Qu)=>{
        var ml = String;
        Qu.exports = function(e) {
            try {
                return ml(e);
            } catch  {
                return "Object";
            }
        };
    });
    var Ht = xe((b0, Zu)=>{
        var dl = ot(), gl = Dr(), yl = TypeError;
        Zu.exports = function(e) {
            if (dl(e)) return e;
            throw yl(gl(e) + " is not a function");
        };
    });
    var mr = xe((T0, es)=>{
        var hl = Ht(), vl = cr();
        es.exports = function(e, r) {
            var t = e[r];
            return vl(t) ? void 0 : hl(t);
        };
    });
    var rs = xe((B0, ts)=>{
        var en = At(), tn = ot(), rn = St(), Cl = TypeError;
        ts.exports = function(e, r) {
            var t, s;
            if (r === "string" && tn(t = e.toString) && !rn(s = en(t, e)) || tn(t = e.valueOf) && !rn(s = en(t, e)) || r !== "string" && tn(t = e.toString) && !rn(s = en(t, e))) return s;
            throw Cl("Can't convert object to primitive value");
        };
    });
    var us = xe((N0, ns)=>{
        ns.exports = !1;
    });
    var dr = xe((w0, is)=>{
        var ss = pt(), El = Object.defineProperty;
        is.exports = function(e, r) {
            try {
                El(ss, e, {
                    value: r,
                    configurable: !0,
                    writable: !0
                });
            } catch  {
                ss[e] = r;
            }
            return r;
        };
    });
    var gr = xe((_0, os)=>{
        var Fl = pt(), Al = dr(), as = "__core-js_shared__", Sl = Fl[as] || Al(as, {});
        os.exports = Sl;
    });
    var nn = xe((P0, cs)=>{
        var xl = us(), ls = gr();
        (cs.exports = function(e, r) {
            return ls[e] || (ls[e] = r !== void 0 ? r : {});
        })("versions", []).push({
            version: "3.26.1",
            mode: xl ? "pure" : "global",
            copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)",
            license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE",
            source: "https://github.com/zloirock/core-js"
        });
    });
    var yr = xe((I0, ps)=>{
        var bl = Gr(), Tl = Object;
        ps.exports = function(e) {
            return Tl(bl(e));
        };
    });
    var Ct = xe((k0, fs)=>{
        var Bl = mt(), Nl = yr(), wl = Bl({}.hasOwnProperty);
        fs.exports = Object.hasOwn || function(r, t) {
            return wl(Nl(r), t);
        };
    });
    var un = xe((L0, Ds)=>{
        var _l = mt(), Pl = 0, Il = Math.random(), kl = _l(1..toString);
        Ds.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + kl(++Pl + Il, 36);
        };
    });
    var bt = xe((O0, hs)=>{
        var Ll = pt(), Ol = nn(), ms = Ct(), jl = un(), ds = Yr(), ys = Qr(), It = Ol("wks"), xt = Ll.Symbol, gs = xt && xt.for, ql = ys ? xt : xt && xt.withoutSetter || jl;
        hs.exports = function(e) {
            if (!ms(It, e) || !(ds || typeof It[e] == "string")) {
                var r = "Symbol." + e;
                ds && ms(xt, e) ? It[e] = xt[e] : ys && gs ? It[e] = gs(r) : It[e] = ql(r);
            }
            return It[e];
        };
    });
    var Fs = xe((j0, Es)=>{
        var Ml = At(), vs = St(), Cs = Zr(), Rl = mr(), $l = rs(), Vl = bt(), Wl = TypeError, Hl = Vl("toPrimitive");
        Es.exports = function(e, r) {
            if (!vs(e) || Cs(e)) return e;
            var t = Rl(e, Hl), s;
            if (t) {
                if (r === void 0 && (r = "default"), s = Ml(t, e, r), !vs(s) || Cs(s)) return s;
                throw Wl("Can't convert object to primitive value");
            }
            return r === void 0 && (r = "number"), $l(e, r);
        };
    });
    var hr = xe((q0, As)=>{
        var Gl = Fs(), Ul = Zr();
        As.exports = function(e) {
            var r = Gl(e, "string");
            return Ul(r) ? r : r + "";
        };
    });
    var bs = xe((M0, xs)=>{
        var Jl = pt(), Ss = St(), sn = Jl.document, zl = Ss(sn) && Ss(sn.createElement);
        xs.exports = function(e) {
            return zl ? sn.createElement(e) : {};
        };
    });
    var an = xe((R0, Ts)=>{
        var Xl = yt(), Kl = Dt(), Yl = bs();
        Ts.exports = !Xl && !Kl(function() {
            return Object.defineProperty(Yl("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a != 7;
        });
    });
    var on = xe((Ns)=>{
        var Ql = yt(), Zl = At(), ec = vu(), tc = lr(), rc = pr(), nc = hr(), uc = Ct(), sc = an(), Bs = Object.getOwnPropertyDescriptor;
        Ns.f = Ql ? Bs : function(r, t) {
            if (r = rc(r), t = nc(t), sc) try {
                return Bs(r, t);
            } catch  {}
            if (uc(r, t)) return tc(!Zl(ec.f, r, t), r[t]);
        };
    });
    var _s = xe((V0, ws)=>{
        var ic = yt(), ac = Dt();
        ws.exports = ic && ac(function() {
            return Object.defineProperty(function() {}, "prototype", {
                value: 42,
                writable: !1
            }).prototype != 42;
        });
    });
    var Tt = xe((W0, Ps)=>{
        var oc = St(), lc = String, cc = TypeError;
        Ps.exports = function(e) {
            if (oc(e)) return e;
            throw cc(lc(e) + " is not an object");
        };
    });
    var kt = xe((ks)=>{
        var pc = yt(), fc = an(), Dc = _s(), vr = Tt(), Is = hr(), mc = TypeError, ln = Object.defineProperty, dc = Object.getOwnPropertyDescriptor, cn = "enumerable", pn = "configurable", fn = "writable";
        ks.f = pc ? Dc ? function(r, t, s) {
            if (vr(r), t = Is(t), vr(s), typeof r == "function" && t === "prototype" && "value" in s && fn in s && !s[fn]) {
                var a = dc(r, t);
                a && a[fn] && (r[t] = s.value, s = {
                    configurable: pn in s ? s[pn] : a[pn],
                    enumerable: cn in s ? s[cn] : a[cn],
                    writable: !1
                });
            }
            return ln(r, t, s);
        } : ln : function(r, t, s) {
            if (vr(r), t = Is(t), vr(s), fc) try {
                return ln(r, t, s);
            } catch  {}
            if ("get" in s || "set" in s) throw mc("Accessors not supported");
            return "value" in s && (r[t] = s.value), r;
        };
    });
    var Dn = xe((G0, Ls)=>{
        var gc = yt(), yc = kt(), hc = lr();
        Ls.exports = gc ? function(e, r, t) {
            return yc.f(e, r, hc(1, t));
        } : function(e, r, t) {
            return e[r] = t, e;
        };
    });
    var qs = xe((U0, js)=>{
        var mn = yt(), vc = Ct(), Os = Function.prototype, Cc = mn && Object.getOwnPropertyDescriptor, dn = vc(Os, "name"), Ec = dn && (function() {}).name === "something", Fc = dn && (!mn || mn && Cc(Os, "name").configurable);
        js.exports = {
            EXISTS: dn,
            PROPER: Ec,
            CONFIGURABLE: Fc
        };
    });
    var yn = xe((J0, Ms)=>{
        var Ac = mt(), Sc = ot(), gn = gr(), xc = Ac(Function.toString);
        Sc(gn.inspectSource) || (gn.inspectSource = function(e) {
            return xc(e);
        });
        Ms.exports = gn.inspectSource;
    });
    var Vs = xe((z0, $s)=>{
        var bc = pt(), Tc = ot(), Rs = bc.WeakMap;
        $s.exports = Tc(Rs) && /native code/.test(String(Rs));
    });
    var Gs = xe((X0, Hs)=>{
        var Bc = nn(), Nc = un(), Ws = Bc("keys");
        Hs.exports = function(e) {
            return Ws[e] || (Ws[e] = Nc(e));
        };
    });
    var hn = xe((K0, Us)=>{
        Us.exports = {};
    });
    var Ks = xe((Y0, Xs)=>{
        var wc = Vs(), zs = pt(), _c = St(), Pc = Dn(), vn = Ct(), Cn = gr(), Ic = Gs(), kc = hn(), Js = "Object already initialized", En = zs.TypeError, Lc = zs.WeakMap, Cr, Gt, Er, Oc = function(e) {
            return Er(e) ? Gt(e) : Cr(e, {});
        }, jc = function(e) {
            return function(r) {
                var t;
                if (!_c(r) || (t = Gt(r)).type !== e) throw En("Incompatible receiver, " + e + " required");
                return t;
            };
        };
        wc || Cn.state ? (gt = Cn.state || (Cn.state = new Lc), gt.get = gt.get, gt.has = gt.has, gt.set = gt.set, Cr = function(e, r) {
            if (gt.has(e)) throw En(Js);
            return r.facade = e, gt.set(e, r), r;
        }, Gt = function(e) {
            return gt.get(e) || {};
        }, Er = function(e) {
            return gt.has(e);
        }) : (Bt = Ic("state"), kc[Bt] = !0, Cr = function(e, r) {
            if (vn(e, Bt)) throw En(Js);
            return r.facade = e, Pc(e, Bt, r), r;
        }, Gt = function(e) {
            return vn(e, Bt) ? e[Bt] : {};
        }, Er = function(e) {
            return vn(e, Bt);
        });
        var gt, Bt;
        Xs.exports = {
            set: Cr,
            get: Gt,
            has: Er,
            enforce: Oc,
            getterFor: jc
        };
    });
    var An = xe((Q0, Qs)=>{
        var qc = Dt(), Mc = ot(), Fr = Ct(), Fn = yt(), Rc = qs().CONFIGURABLE, $c = yn(), Ys = Ks(), Vc = Ys.enforce, Wc = Ys.get, Ar = Object.defineProperty, Hc = Fn && !qc(function() {
            return Ar(function() {}, "length", {
                value: 8
            }).length !== 8;
        }), Gc = String(String).split("String"), Uc = Qs.exports = function(e, r, t) {
            String(r).slice(0, 7) === "Symbol(" && (r = "[" + String(r).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), t && t.getter && (r = "get " + r), t && t.setter && (r = "set " + r), (!Fr(e, "name") || Rc && e.name !== r) && (Fn ? Ar(e, "name", {
                value: r,
                configurable: !0
            }) : e.name = r), Hc && t && Fr(t, "arity") && e.length !== t.arity && Ar(e, "length", {
                value: t.arity
            });
            try {
                t && Fr(t, "constructor") && t.constructor ? Fn && Ar(e, "prototype", {
                    writable: !1
                }) : e.prototype && (e.prototype = void 0);
            } catch  {}
            var s = Vc(e);
            return Fr(s, "source") || (s.source = Gc.join(typeof r == "string" ? r : "")), e;
        };
        Function.prototype.toString = Uc(function() {
            return Mc(this) && Wc(this).source || $c(this);
        }, "toString");
    });
    var ei = xe((Z0, Zs)=>{
        var Jc = ot(), zc = kt(), Xc = An(), Kc = dr();
        Zs.exports = function(e, r, t, s) {
            s || (s = {});
            var a = s.enumerable, n = s.name !== void 0 ? s.name : r;
            if (Jc(t) && Xc(t, n, s), s.global) a ? e[r] = t : Kc(r, t);
            else {
                try {
                    s.unsafe ? e[r] && (a = !0) : delete e[r];
                } catch  {}
                a ? e[r] = t : zc.f(e, r, {
                    value: t,
                    enumerable: !1,
                    configurable: !s.nonConfigurable,
                    writable: !s.nonWritable
                });
            }
            return e;
        };
    });
    var ri = xe((ey, ti)=>{
        var Yc = Math.ceil, Qc = Math.floor;
        ti.exports = Math.trunc || function(r) {
            var t = +r;
            return (t > 0 ? Qc : Yc)(t);
        };
    });
    var Sr = xe((ty, ni)=>{
        var Zc = ri();
        ni.exports = function(e) {
            var r = +e;
            return r !== r || r === 0 ? 0 : Zc(r);
        };
    });
    var si = xe((ry, ui)=>{
        var ep = Sr(), tp = Math.max, rp = Math.min;
        ui.exports = function(e, r) {
            var t = ep(e);
            return t < 0 ? tp(t + r, 0) : rp(t, r);
        };
    });
    var ai = xe((ny, ii)=>{
        var np = Sr(), up = Math.min;
        ii.exports = function(e) {
            return e > 0 ? up(np(e), 9007199254740991) : 0;
        };
    });
    var Lt = xe((uy, oi)=>{
        var sp = ai();
        oi.exports = function(e) {
            return sp(e.length);
        };
    });
    var pi = xe((sy, ci)=>{
        var ip = pr(), ap = si(), op = Lt(), li = function(e) {
            return function(r, t, s) {
                var a = ip(r), n = op(a), u = ap(s, n), i;
                if (e && t != t) {
                    for(; n > u;)if (i = a[u++], i != i) return !0;
                } else for(; n > u; u++)if ((e || u in a) && a[u] === t) return e || u || 0;
                return !e && -1;
            };
        };
        ci.exports = {
            includes: li(!0),
            indexOf: li(!1)
        };
    });
    var mi = xe((iy, Di)=>{
        var lp = mt(), Sn = Ct(), cp = pr(), pp = pi().indexOf, fp = hn(), fi = lp([].push);
        Di.exports = function(e, r) {
            var t = cp(e), s = 0, a = [], n;
            for(n in t)!Sn(fp, n) && Sn(t, n) && fi(a, n);
            for(; r.length > s;)Sn(t, n = r[s++]) && (~pp(a, n) || fi(a, n));
            return a;
        };
    });
    var gi = xe((ay, di)=>{
        di.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
        ];
    });
    var hi = xe((yi)=>{
        var Dp = mi(), mp = gi(), dp = mp.concat("length", "prototype");
        yi.f = Object.getOwnPropertyNames || function(r) {
            return Dp(r, dp);
        };
    });
    var Ci = xe((vi)=>{
        vi.f = Object.getOwnPropertySymbols;
    });
    var Fi = xe((cy, Ei)=>{
        var gp = Wt(), yp = mt(), hp = hi(), vp = Ci(), Cp = Tt(), Ep = yp([].concat);
        Ei.exports = gp("Reflect", "ownKeys") || function(r) {
            var t = hp.f(Cp(r)), s = vp.f;
            return s ? Ep(t, s(r)) : t;
        };
    });
    var xi = xe((py, Si)=>{
        var Ai = Ct(), Fp = Fi(), Ap = on(), Sp = kt();
        Si.exports = function(e, r, t) {
            for(var s = Fp(r), a = Sp.f, n = Ap.f, u = 0; u < s.length; u++){
                var i = s[u];
                !Ai(e, i) && !(t && Ai(t, i)) && a(e, i, n(r, i));
            }
        };
    });
    var Ti = xe((fy, bi)=>{
        var xp = Dt(), bp = ot(), Tp = /#|\.prototype\./, Ut = function(e, r) {
            var t = Np[Bp(e)];
            return t == _p ? !0 : t == wp ? !1 : bp(r) ? xp(r) : !!r;
        }, Bp = Ut.normalize = function(e) {
            return String(e).replace(Tp, ".").toLowerCase();
        }, Np = Ut.data = {}, wp = Ut.NATIVE = "N", _p = Ut.POLYFILL = "P";
        bi.exports = Ut;
    });
    var Jt = xe((Dy, Bi)=>{
        var xn = pt(), Pp = on().f, Ip = Dn(), kp = ei(), Lp = dr(), Op = xi(), jp = Ti();
        Bi.exports = function(e, r) {
            var t = e.target, s = e.global, a = e.stat, n, u, i, l, p, y;
            if (s ? u = xn : a ? u = xn[t] || Lp(t, {}) : u = (xn[t] || {}).prototype, u) for(i in r){
                if (p = r[i], e.dontCallGetSet ? (y = Pp(u, i), l = y && y.value) : l = u[i], n = jp(s ? i : t + (a ? "." : "#") + i, e.forced), !n && l !== void 0) {
                    if (typeof p == typeof l) continue;
                    Op(p, l);
                }
                (e.sham || l && l.sham) && Ip(p, "sham", !0), kp(u, i, p, e);
            }
        };
    });
    var bn = xe((my, Ni)=>{
        var qp = Vt();
        Ni.exports = Array.isArray || function(r) {
            return qp(r) == "Array";
        };
    });
    var _i = xe((dy, wi)=>{
        var Mp = TypeError, Rp = 9007199254740991;
        wi.exports = function(e) {
            if (e > Rp) throw Mp("Maximum allowed index exceeded");
            return e;
        };
    });
    var Ii = xe((gy, Pi)=>{
        var $p = Vt(), Vp = mt();
        Pi.exports = function(e) {
            if ($p(e) === "Function") return Vp(e);
        };
    });
    var Tn = xe((yy, Li)=>{
        var ki = Ii(), Wp = Ht(), Hp = ar(), Gp = ki(ki.bind);
        Li.exports = function(e, r) {
            return Wp(e), r === void 0 ? e : Hp ? Gp(e, r) : function() {
                return e.apply(r, arguments);
            };
        };
    });
    var Bn = xe((hy, ji)=>{
        "use strict";
        var Up = bn(), Jp = Lt(), zp = _i(), Xp = Tn(), Oi = function(e, r, t, s, a, n, u, i) {
            for(var l = a, p = 0, y = u ? Xp(u, i) : !1, h, g; p < s;)p in t && (h = y ? y(t[p], p, r) : t[p], n > 0 && Up(h) ? (g = Jp(h), l = Oi(e, r, h, g, l, n - 1) - 1) : (zp(l + 1), e[l] = h), l++), p++;
            return l;
        };
        ji.exports = Oi;
    });
    var Ri = xe((vy, Mi)=>{
        var Kp = bt(), Yp = Kp("toStringTag"), qi = {};
        qi[Yp] = "z";
        Mi.exports = String(qi) === "[object z]";
    });
    var Nn = xe((Cy, $i)=>{
        var Qp = Ri(), Zp = ot(), xr = Vt(), ef = bt(), tf = ef("toStringTag"), rf = Object, nf = xr(function() {
            return arguments;
        }()) == "Arguments", uf = function(e, r) {
            try {
                return e[r];
            } catch  {}
        };
        $i.exports = Qp ? xr : function(e) {
            var r, t, s;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = uf(r = rf(e), tf)) == "string" ? t : nf ? xr(r) : (s = xr(r)) == "Object" && Zp(r.callee) ? "Arguments" : s;
        };
    });
    var Ji = xe((Ey, Ui)=>{
        var sf = mt(), af = Dt(), Vi = ot(), of = Nn(), lf = Wt(), cf = yn(), Wi = function() {}, pf = [], Hi = lf("Reflect", "construct"), wn = /^\s*(?:class|function)\b/, ff = sf(wn.exec), Df = !wn.exec(Wi), zt = function(r) {
            if (!Vi(r)) return !1;
            try {
                return Hi(Wi, pf, r), !0;
            } catch  {
                return !1;
            }
        }, Gi = function(r) {
            if (!Vi(r)) return !1;
            switch(of(r)){
                case "AsyncFunction":
                case "GeneratorFunction":
                case "AsyncGeneratorFunction":
                    return !1;
            }
            try {
                return Df || !!ff(wn, cf(r));
            } catch  {
                return !0;
            }
        };
        Gi.sham = !0;
        Ui.exports = !Hi || af(function() {
            var e;
            return zt(zt.call) || !zt(Object) || !zt(function() {
                e = !0;
            }) || e;
        }) ? Gi : zt;
    });
    var Yi = xe((Fy, Ki)=>{
        var zi = bn(), mf = Ji(), df = St(), gf = bt(), yf = gf("species"), Xi = Array;
        Ki.exports = function(e) {
            var r;
            return zi(e) && (r = e.constructor, mf(r) && (r === Xi || zi(r.prototype)) ? r = void 0 : df(r) && (r = r[yf], r === null && (r = void 0))), r === void 0 ? Xi : r;
        };
    });
    var _n = xe((Ay, Qi)=>{
        var hf = Yi();
        Qi.exports = function(e, r) {
            return new (hf(e))(r === 0 ? 0 : r);
        };
    });
    var Zi = xe(()=>{
        "use strict";
        var vf = Jt(), Cf = Bn(), Ef = Ht(), Ff = yr(), Af = Lt(), Sf = _n();
        vf({
            target: "Array",
            proto: !0
        }, {
            flatMap: function(r) {
                var t = Ff(this), s = Af(t), a;
                return Ef(r), a = Sf(t, 0), a.length = Cf(a, t, t, s, 0, 1, r, arguments.length > 1 ? arguments[1] : void 0), a;
            }
        });
    });
    var Pn = xe((by, ea)=>{
        ea.exports = {};
    });
    var ra = xe((Ty, ta)=>{
        var xf = bt(), bf = Pn(), Tf = xf("iterator"), Bf = Array.prototype;
        ta.exports = function(e) {
            return e !== void 0 && (bf.Array === e || Bf[Tf] === e);
        };
    });
    var In = xe((By, ua)=>{
        var Nf = Nn(), na = mr(), wf = cr(), _f = Pn(), Pf = bt(), If = Pf("iterator");
        ua.exports = function(e) {
            if (!wf(e)) return na(e, If) || na(e, "@@iterator") || _f[Nf(e)];
        };
    });
    var ia = xe((Ny, sa)=>{
        var kf = At(), Lf = Ht(), Of = Tt(), jf = Dr(), qf = In(), Mf = TypeError;
        sa.exports = function(e, r) {
            var t = arguments.length < 2 ? qf(e) : r;
            if (Lf(t)) return Of(kf(t, e));
            throw Mf(jf(e) + " is not iterable");
        };
    });
    var la = xe((wy, oa)=>{
        var Rf = At(), aa = Tt(), $f = mr();
        oa.exports = function(e, r, t) {
            var s, a;
            aa(e);
            try {
                if (s = $f(e, "return"), !s) {
                    if (r === "throw") throw t;
                    return t;
                }
                s = Rf(s, e);
            } catch (n) {
                a = !0, s = n;
            }
            if (r === "throw") throw t;
            if (a) throw s;
            return aa(s), t;
        };
    });
    var ma = xe((_y, Da)=>{
        var Vf = Tn(), Wf = At(), Hf = Tt(), Gf = Dr(), Uf = ra(), Jf = Lt(), ca = Xr(), zf = ia(), Xf = In(), pa = la(), Kf = TypeError, br = function(e, r) {
            this.stopped = e, this.result = r;
        }, fa = br.prototype;
        Da.exports = function(e, r, t) {
            var s = t && t.that, a = !!(t && t.AS_ENTRIES), n = !!(t && t.IS_RECORD), u = !!(t && t.IS_ITERATOR), i = !!(t && t.INTERRUPTED), l = Vf(r, s), p, y, h, g, c, f, F, _ = function(E) {
                return p && pa(p, "normal", E), new br(!0, E);
            }, w = function(E) {
                return a ? (Hf(E), i ? l(E[0], E[1], _) : l(E[0], E[1])) : i ? l(E, _) : l(E);
            };
            if (n) p = e.iterator;
            else if (u) p = e;
            else {
                if (y = Xf(e), !y) throw Kf(Gf(e) + " is not iterable");
                if (Uf(y)) {
                    for(h = 0, g = Jf(e); g > h; h++)if (c = w(e[h]), c && ca(fa, c)) return c;
                    return new br(!1);
                }
                p = zf(e, y);
            }
            for(f = n ? e.next : p.next; !(F = Wf(f, p)).done;){
                try {
                    c = w(F.value);
                } catch (E) {
                    pa(p, "throw", E);
                }
                if (typeof c == "object" && c && ca(fa, c)) return c;
            }
            return new br(!1);
        };
    });
    var ga = xe((Py, da)=>{
        "use strict";
        var Yf = hr(), Qf = kt(), Zf = lr();
        da.exports = function(e, r, t) {
            var s = Yf(r);
            s in e ? Qf.f(e, s, Zf(0, t)) : e[s] = t;
        };
    });
    var ya = xe(()=>{
        var eD = Jt(), tD = ma(), rD = ga();
        eD({
            target: "Object",
            stat: !0
        }, {
            fromEntries: function(r) {
                var t = {};
                return tD(r, function(s, a) {
                    rD(t, s, a);
                }, {
                    AS_ENTRIES: !0
                }), t;
            }
        });
    });
    var Ca = xe((Ly, va)=>{
        var ha = An(), nD = kt();
        va.exports = function(e, r, t) {
            return t.get && ha(t.get, r, {
                getter: !0
            }), t.set && ha(t.set, r, {
                setter: !0
            }), nD.f(e, r, t);
        };
    });
    var Fa = xe((Oy, Ea)=>{
        "use strict";
        var uD = Tt();
        Ea.exports = function() {
            var e = uD(this), r = "";
            return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
        };
    });
    var xa = xe(()=>{
        var sD = pt(), iD = yt(), aD = Ca(), oD = Fa(), lD = Dt(), Aa = sD.RegExp, Sa = Aa.prototype, cD = iD && lD(function() {
            var e = !0;
            try {
                Aa(".", "d");
            } catch  {
                e = !1;
            }
            var r = {}, t = "", s = e ? "dgimsy" : "gimsy", a = function(l, p) {
                Object.defineProperty(r, l, {
                    get: function() {
                        return t += p, !0;
                    }
                });
            }, n = {
                dotAll: "s",
                global: "g",
                ignoreCase: "i",
                multiline: "m",
                sticky: "y"
            };
            e && (n.hasIndices = "d");
            for(var u in n)a(u, n[u]);
            var i = Object.getOwnPropertyDescriptor(Sa, "flags").get.call(r);
            return i !== s || t !== s;
        });
        cD && aD(Sa, "flags", {
            configurable: !0,
            get: oD
        });
    });
    var ba = xe(()=>{
        var pD = Jt(), kn = pt();
        pD({
            global: !0,
            forced: kn.globalThis !== kn
        }, {
            globalThis: kn
        });
    });
    var Ta = xe(()=>{
        ba();
    });
    var Ba = xe(()=>{
        "use strict";
        var fD = Jt(), DD = Bn(), mD = yr(), dD = Lt(), gD = Sr(), yD = _n();
        fD({
            target: "Array",
            proto: !0
        }, {
            flat: function() {
                var r = arguments.length ? arguments[0] : void 0, t = mD(this), s = dD(t), a = yD(t, 0);
                return a.length = DD(a, t, t, s, 0, r === void 0 ? 1 : gD(r)), a;
            }
        });
    });
    var e0 = xe((Uy, jo)=>{
        var hD = [
            "cliName",
            "cliCategory",
            "cliDescription"
        ], vD = [
            "_"
        ], CD = [
            "languageId"
        ];
        function Hn(e, r) {
            if (e == null) return {};
            var t = ED(e, r), s, a;
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(e);
                for(a = 0; a < n.length; a++)s = n[a], !(r.indexOf(s) >= 0) && Object.prototype.propertyIsEnumerable.call(e, s) && (t[s] = e[s]);
            }
            return t;
        }
        function ED(e, r) {
            if (e == null) return {};
            var t = {}, s = Object.keys(e), a, n;
            for(n = 0; n < s.length; n++)a = s[n], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
            return t;
        }
        Zi();
        ya();
        xa();
        Ta();
        Ba();
        var FD = Object.create, _r = Object.defineProperty, AD = Object.getOwnPropertyDescriptor, Gn = Object.getOwnPropertyNames, SD = Object.getPrototypeOf, xD = Object.prototype.hasOwnProperty, ht = (e, r)=>function() {
                return e && (r = (0, e[Gn(e)[0]])(e = 0)), r;
            }, te = (e, r)=>function() {
                return r || (0, e[Gn(e)[0]])((r = {
                    exports: {}
                }).exports, r), r.exports;
            }, Kt = (e, r)=>{
            for(var t in r)_r(e, t, {
                get: r[t],
                enumerable: !0
            });
        }, Pa = (e, r, t, s)=>{
            if (r && typeof r == "object" || typeof r == "function") for (let a of Gn(r))!xD.call(e, a) && a !== t && _r(e, a, {
                get: ()=>r[a],
                enumerable: !(s = AD(r, a)) || s.enumerable
            });
            return e;
        }, bD = (e, r, t)=>(t = e != null ? FD(SD(e)) : {}, Pa(r || !e || !e.__esModule ? _r(t, "default", {
                value: e,
                enumerable: !0
            }) : t, e)), ft = (e)=>Pa(_r({}, "__esModule", {
                value: !0
            }), e), wt, ne = ht({
            "<define:process>" () {
                wt = {
                    env: {},
                    argv: []
                };
            }
        }), Ia = te({
            "package.json" (e, r) {
                r.exports = {
                    version: "2.8.8"
                };
            }
        }), TD = te({
            "node_modules/diff/lib/diff/base.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.default = r;
                function r() {}
                r.prototype = {
                    diff: function(n, u) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = i.callback;
                        typeof i == "function" && (l = i, i = {}), this.options = i;
                        var p = this;
                        function y(N) {
                            return l ? (setTimeout(function() {
                                l(void 0, N);
                            }, 0), !0) : N;
                        }
                        n = this.castInput(n), u = this.castInput(u), n = this.removeEmpty(this.tokenize(n)), u = this.removeEmpty(this.tokenize(u));
                        var h = u.length, g = n.length, c = 1, f = h + g, F = [
                            {
                                newPos: -1,
                                components: []
                            }
                        ], _ = this.extractCommon(F[0], u, n, 0);
                        if (F[0].newPos + 1 >= h && _ + 1 >= g) return y([
                            {
                                value: this.join(u),
                                count: u.length
                            }
                        ]);
                        function w() {
                            for(var N = -1 * c; N <= c; N += 2){
                                var x = void 0, I = F[N - 1], P = F[N + 1], $ = (P ? P.newPos : 0) - N;
                                I && (F[N - 1] = void 0);
                                var D = I && I.newPos + 1 < h, T = P && 0 <= $ && $ < g;
                                if (!D && !T) {
                                    F[N] = void 0;
                                    continue;
                                }
                                if (!D || T && I.newPos < P.newPos ? (x = s(P), p.pushComponent(x.components, void 0, !0)) : (x = I, x.newPos++, p.pushComponent(x.components, !0, void 0)), $ = p.extractCommon(x, u, n, N), x.newPos + 1 >= h && $ + 1 >= g) return y(t(p, x.components, u, n, p.useLongestToken));
                                F[N] = x;
                            }
                            c++;
                        }
                        if (l) (function N() {
                            setTimeout(function() {
                                if (c > f) return l();
                                w() || N();
                            }, 0);
                        })();
                        else for(; c <= f;){
                            var E = w();
                            if (E) return E;
                        }
                    },
                    pushComponent: function(n, u, i) {
                        var l = n[n.length - 1];
                        l && l.added === u && l.removed === i ? n[n.length - 1] = {
                            count: l.count + 1,
                            added: u,
                            removed: i
                        } : n.push({
                            count: 1,
                            added: u,
                            removed: i
                        });
                    },
                    extractCommon: function(n, u, i, l) {
                        for(var p = u.length, y = i.length, h = n.newPos, g = h - l, c = 0; h + 1 < p && g + 1 < y && this.equals(u[h + 1], i[g + 1]);)h++, g++, c++;
                        return c && n.components.push({
                            count: c
                        }), n.newPos = h, g;
                    },
                    equals: function(n, u) {
                        return this.options.comparator ? this.options.comparator(n, u) : n === u || this.options.ignoreCase && n.toLowerCase() === u.toLowerCase();
                    },
                    removeEmpty: function(n) {
                        for(var u = [], i = 0; i < n.length; i++)n[i] && u.push(n[i]);
                        return u;
                    },
                    castInput: function(n) {
                        return n;
                    },
                    tokenize: function(n) {
                        return n.split("");
                    },
                    join: function(n) {
                        return n.join("");
                    }
                };
                function t(a, n, u, i, l) {
                    for(var p = 0, y = n.length, h = 0, g = 0; p < y; p++){
                        var c = n[p];
                        if (c.removed) {
                            if (c.value = a.join(i.slice(g, g + c.count)), g += c.count, p && n[p - 1].added) {
                                var F = n[p - 1];
                                n[p - 1] = n[p], n[p] = F;
                            }
                        } else {
                            if (!c.added && l) {
                                var f = u.slice(h, h + c.count);
                                f = f.map(function(w, E) {
                                    var N = i[g + E];
                                    return N.length > w.length ? N : w;
                                }), c.value = a.join(f);
                            } else c.value = a.join(u.slice(h, h + c.count));
                            h += c.count, c.added || (g += c.count);
                        }
                    }
                    var _ = n[y - 1];
                    return y > 1 && typeof _.value == "string" && (_.added || _.removed) && a.equals("", _.value) && (n[y - 2].value += _.value, n.pop()), n;
                }
                function s(a) {
                    return {
                        newPos: a.newPos,
                        components: a.components.slice(0)
                    };
                }
            }
        }), BD = te({
            "node_modules/diff/lib/diff/array.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.diffArrays = a, e.arrayDiff = void 0;
                var r = t(TD());
                function t(n) {
                    return n && n.__esModule ? n : {
                        default: n
                    };
                }
                var s = new r.default;
                e.arrayDiff = s, s.tokenize = function(n) {
                    return n.slice();
                }, s.join = s.removeEmpty = function(n) {
                    return n;
                };
                function a(n, u, i) {
                    return s.diff(n, u, i);
                }
            }
        }), Un = te({
            "src/document/doc-builders.js" (e, r) {
                "use strict";
                ne();
                function t(C) {
                    return {
                        type: "concat",
                        parts: C
                    };
                }
                function s(C) {
                    return {
                        type: "indent",
                        contents: C
                    };
                }
                function a(C, o) {
                    return {
                        type: "align",
                        contents: o,
                        n: C
                    };
                }
                function n(C) {
                    let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return {
                        type: "group",
                        id: o.id,
                        contents: C,
                        break: Boolean(o.shouldBreak),
                        expandedStates: o.expandedStates
                    };
                }
                function u(C) {
                    return a(Number.NEGATIVE_INFINITY, C);
                }
                function i(C) {
                    return a({
                        type: "root"
                    }, C);
                }
                function l(C) {
                    return a(-1, C);
                }
                function p(C, o) {
                    return n(C[0], Object.assign(Object.assign({}, o), {}, {
                        expandedStates: C
                    }));
                }
                function y(C) {
                    return {
                        type: "fill",
                        parts: C
                    };
                }
                function h(C, o) {
                    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                    return {
                        type: "if-break",
                        breakContents: C,
                        flatContents: o,
                        groupId: d.groupId
                    };
                }
                function g(C, o) {
                    return {
                        type: "indent-if-break",
                        contents: C,
                        groupId: o.groupId,
                        negate: o.negate
                    };
                }
                function c(C) {
                    return {
                        type: "line-suffix",
                        contents: C
                    };
                }
                var f = {
                    type: "line-suffix-boundary"
                }, F = {
                    type: "break-parent"
                }, _ = {
                    type: "trim"
                }, w = {
                    type: "line",
                    hard: !0
                }, E = {
                    type: "line",
                    hard: !0,
                    literal: !0
                }, N = {
                    type: "line"
                }, x = {
                    type: "line",
                    soft: !0
                }, I = t([
                    w,
                    F
                ]), P = t([
                    E,
                    F
                ]), $ = {
                    type: "cursor",
                    placeholder: Symbol("cursor")
                };
                function D(C, o) {
                    let d = [];
                    for(let v = 0; v < o.length; v++)v !== 0 && d.push(C), d.push(o[v]);
                    return t(d);
                }
                function T(C, o, d) {
                    let v = C;
                    if (o > 0) {
                        for(let S = 0; S < Math.floor(o / d); ++S)v = s(v);
                        v = a(o % d, v), v = a(Number.NEGATIVE_INFINITY, v);
                    }
                    return v;
                }
                function m(C, o) {
                    return {
                        type: "label",
                        label: C,
                        contents: o
                    };
                }
                r.exports = {
                    concat: t,
                    join: D,
                    line: N,
                    softline: x,
                    hardline: I,
                    literalline: P,
                    group: n,
                    conditionalGroup: p,
                    fill: y,
                    lineSuffix: c,
                    lineSuffixBoundary: f,
                    cursor: $,
                    breakParent: F,
                    ifBreak: h,
                    trim: _,
                    indent: s,
                    indentIfBreak: g,
                    align: a,
                    addAlignmentToDoc: T,
                    markAsRoot: i,
                    dedentToRoot: u,
                    dedent: l,
                    hardlineWithoutBreakParent: w,
                    literallineWithoutBreakParent: E,
                    label: m
                };
            }
        }), Jn = te({
            "src/common/end-of-line.js" (e, r) {
                "use strict";
                ne();
                function t(u) {
                    let i = u.indexOf("\r");
                    return i >= 0 ? u.charAt(i + 1) === `
` ? "crlf" : "cr" : "lf";
                }
                function s(u) {
                    switch(u){
                        case "cr":
                            return "\r";
                        case "crlf":
                            return `\r
`;
                        default:
                            return `
`;
                    }
                }
                function a(u, i) {
                    let l;
                    switch(i){
                        case `
`:
                            l = /\n/g;
                            break;
                        case "\r":
                            l = /\r/g;
                            break;
                        case `\r
`:
                            l = /\r\n/g;
                            break;
                        default:
                            throw new Error(`Unexpected "eol" ${JSON.stringify(i)}.`);
                    }
                    let p = u.match(l);
                    return p ? p.length : 0;
                }
                function n(u) {
                    return u.replace(/\r\n?/g, `
`);
                }
                r.exports = {
                    guessEndOfLine: t,
                    convertEndOfLineToChars: s,
                    countEndOfLineChars: a,
                    normalizeEndOfLine: n
                };
            }
        }), lt = te({
            "src/utils/get-last.js" (e, r) {
                "use strict";
                ne();
                var t = (s)=>s[s.length - 1];
                r.exports = t;
            }
        });
        function ND() {
            let { onlyFirst: e = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = [
                "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
                "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
            ].join("|");
            return new RegExp(r, e ? void 0 : "g");
        }
        var wD = ht({
            "node_modules/strip-ansi/node_modules/ansi-regex/index.js" () {
                ne();
            }
        });
        function _D(e) {
            if (typeof e != "string") throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
            return e.replace(ND(), "");
        }
        var PD = ht({
            "node_modules/strip-ansi/index.js" () {
                ne(), wD();
            }
        });
        function ID(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : !1;
        }
        var kD = ht({
            "node_modules/is-fullwidth-code-point/index.js" () {
                ne();
            }
        }), LD = te({
            "node_modules/emoji-regex/index.js" (e, r) {
                "use strict";
                ne(), r.exports = function() {
                    return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
                };
            }
        }), ka = {};
        Kt(ka, {
            default: ()=>OD
        });
        function OD(e) {
            if (typeof e != "string" || e.length === 0 || (e = _D(e), e.length === 0)) return 0;
            e = e.replace((0, La.default)(), "  ");
            let r = 0;
            for(let t = 0; t < e.length; t++){
                let s = e.codePointAt(t);
                s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && t++, r += ID(s) ? 2 : 1);
            }
            return r;
        }
        var La, jD = ht({
            "node_modules/string-width/index.js" () {
                ne(), PD(), kD(), La = bD(LD());
            }
        }), Oa = te({
            "src/utils/get-string-width.js" (e, r) {
                "use strict";
                ne();
                var t = (jD(), ft(ka)).default, s = /[^\x20-\x7F]/;
                function a(n) {
                    return n ? s.test(n) ? t(n) : n.length : 0;
                }
                r.exports = a;
            }
        }), Yt = te({
            "src/document/doc-utils.js" (e, r) {
                "use strict";
                ne();
                var t = lt(), { literalline: s, join: a } = Un(), n = (o)=>Array.isArray(o) || o && o.type === "concat", u = (o)=>{
                    if (Array.isArray(o)) return o;
                    if (o.type !== "concat" && o.type !== "fill") throw new Error("Expect doc type to be `concat` or `fill`.");
                    return o.parts;
                }, i = {};
                function l(o, d, v, S) {
                    let b = [
                        o
                    ];
                    for(; b.length > 0;){
                        let B = b.pop();
                        if (B === i) {
                            v(b.pop());
                            continue;
                        }
                        if (v && b.push(B, i), !d || d(B) !== !1) {
                            if (n(B) || B.type === "fill") {
                                let k = u(B);
                                for(let M = k.length, R = M - 1; R >= 0; --R)b.push(k[R]);
                            } else if (B.type === "if-break") B.flatContents && b.push(B.flatContents), B.breakContents && b.push(B.breakContents);
                            else if (B.type === "group" && B.expandedStates) {
                                if (S) for(let k = B.expandedStates.length, M = k - 1; M >= 0; --M)b.push(B.expandedStates[M]);
                                else b.push(B.contents);
                            } else B.contents && b.push(B.contents);
                        }
                    }
                }
                function p(o, d) {
                    let v = new Map;
                    return S(o);
                    function S(B) {
                        if (v.has(B)) return v.get(B);
                        let k = b(B);
                        return v.set(B, k), k;
                    }
                    function b(B) {
                        if (Array.isArray(B)) return d(B.map(S));
                        if (B.type === "concat" || B.type === "fill") {
                            let k = B.parts.map(S);
                            return d(Object.assign(Object.assign({}, B), {}, {
                                parts: k
                            }));
                        }
                        if (B.type === "if-break") {
                            let k = B.breakContents && S(B.breakContents), M = B.flatContents && S(B.flatContents);
                            return d(Object.assign(Object.assign({}, B), {}, {
                                breakContents: k,
                                flatContents: M
                            }));
                        }
                        if (B.type === "group" && B.expandedStates) {
                            let k = B.expandedStates.map(S), M = k[0];
                            return d(Object.assign(Object.assign({}, B), {}, {
                                contents: M,
                                expandedStates: k
                            }));
                        }
                        if (B.contents) {
                            let k = S(B.contents);
                            return d(Object.assign(Object.assign({}, B), {}, {
                                contents: k
                            }));
                        }
                        return d(B);
                    }
                }
                function y(o, d, v) {
                    let S = v, b = !1;
                    function B(k) {
                        let M = d(k);
                        if (M !== void 0 && (b = !0, S = M), b) return !1;
                    }
                    return l(o, B), S;
                }
                function h(o) {
                    if (o.type === "group" && o.break || o.type === "line" && o.hard || o.type === "break-parent") return !0;
                }
                function g(o) {
                    return y(o, h, !1);
                }
                function c(o) {
                    if (o.length > 0) {
                        let d = t(o);
                        !d.expandedStates && !d.break && (d.break = "propagated");
                    }
                    return null;
                }
                function f(o) {
                    let d = new Set, v = [];
                    function S(B) {
                        if (B.type === "break-parent" && c(v), B.type === "group") {
                            if (v.push(B), d.has(B)) return !1;
                            d.add(B);
                        }
                    }
                    function b(B) {
                        B.type === "group" && v.pop().break && c(v);
                    }
                    l(o, S, b, !0);
                }
                function F(o) {
                    return o.type === "line" && !o.hard ? o.soft ? "" : " " : o.type === "if-break" ? o.flatContents || "" : o;
                }
                function _(o) {
                    return p(o, F);
                }
                var w = (o, d)=>o && o.type === "line" && o.hard && d && d.type === "break-parent";
                function E(o) {
                    if (!o) return o;
                    if (n(o) || o.type === "fill") {
                        let d = u(o);
                        for(; d.length > 1 && w(...d.slice(-2));)d.length -= 2;
                        if (d.length > 0) {
                            let v = E(t(d));
                            d[d.length - 1] = v;
                        }
                        return Array.isArray(o) ? d : Object.assign(Object.assign({}, o), {}, {
                            parts: d
                        });
                    }
                    switch(o.type){
                        case "align":
                        case "indent":
                        case "indent-if-break":
                        case "group":
                        case "line-suffix":
                        case "label":
                            {
                                let d = E(o.contents);
                                return Object.assign(Object.assign({}, o), {}, {
                                    contents: d
                                });
                            }
                        case "if-break":
                            {
                                let d = E(o.breakContents), v = E(o.flatContents);
                                return Object.assign(Object.assign({}, o), {}, {
                                    breakContents: d,
                                    flatContents: v
                                });
                            }
                    }
                    return o;
                }
                function N(o) {
                    return E(I(o));
                }
                function x(o) {
                    switch(o.type){
                        case "fill":
                            if (o.parts.every((v)=>v === "")) return "";
                            break;
                        case "group":
                            if (!o.contents && !o.id && !o.break && !o.expandedStates) return "";
                            if (o.contents.type === "group" && o.contents.id === o.id && o.contents.break === o.break && o.contents.expandedStates === o.expandedStates) return o.contents;
                            break;
                        case "align":
                        case "indent":
                        case "indent-if-break":
                        case "line-suffix":
                            if (!o.contents) return "";
                            break;
                        case "if-break":
                            if (!o.flatContents && !o.breakContents) return "";
                            break;
                    }
                    if (!n(o)) return o;
                    let d = [];
                    for (let v of u(o)){
                        if (!v) continue;
                        let [S, ...b] = n(v) ? u(v) : [
                            v
                        ];
                        typeof S == "string" && typeof t(d) == "string" ? d[d.length - 1] += S : d.push(S), d.push(...b);
                    }
                    return d.length === 0 ? "" : d.length === 1 ? d[0] : Array.isArray(o) ? d : Object.assign(Object.assign({}, o), {}, {
                        parts: d
                    });
                }
                function I(o) {
                    return p(o, (d)=>x(d));
                }
                function P(o) {
                    let d = [], v = o.filter(Boolean);
                    for(; v.length > 0;){
                        let S = v.shift();
                        if (S) {
                            if (n(S)) {
                                v.unshift(...u(S));
                                continue;
                            }
                            if (d.length > 0 && typeof t(d) == "string" && typeof S == "string") {
                                d[d.length - 1] += S;
                                continue;
                            }
                            d.push(S);
                        }
                    }
                    return d;
                }
                function $(o) {
                    return p(o, (d)=>Array.isArray(d) ? P(d) : d.parts ? Object.assign(Object.assign({}, d), {}, {
                            parts: P(d.parts)
                        }) : d);
                }
                function D(o) {
                    return p(o, (d)=>typeof d == "string" && d.includes(`
`) ? T(d) : d);
                }
                function T(o) {
                    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
                    return a(d, o.split(`
`)).parts;
                }
                function m(o) {
                    if (o.type === "line") return !0;
                }
                function C(o) {
                    return y(o, m, !1);
                }
                r.exports = {
                    isConcat: n,
                    getDocParts: u,
                    willBreak: g,
                    traverseDoc: l,
                    findInDoc: y,
                    mapDoc: p,
                    propagateBreaks: f,
                    removeLines: _,
                    stripTrailingHardline: N,
                    normalizeParts: P,
                    normalizeDoc: $,
                    cleanDoc: I,
                    replaceTextEndOfLine: T,
                    replaceEndOfLine: D,
                    canBreak: C
                };
            }
        }), qD = te({
            "src/document/doc-printer.js" (e, r) {
                "use strict";
                ne();
                var { convertEndOfLineToChars: t } = Jn(), s = lt(), a = Oa(), { fill: n, cursor: u, indent: i } = Un(), { isConcat: l, getDocParts: p } = Yt(), y, h = 1, g = 2;
                function c() {
                    return {
                        value: "",
                        length: 0,
                        queue: []
                    };
                }
                function f(x, I) {
                    return _(x, {
                        type: "indent"
                    }, I);
                }
                function F(x, I, P) {
                    return I === Number.NEGATIVE_INFINITY ? x.root || c() : I < 0 ? _(x, {
                        type: "dedent"
                    }, P) : I ? I.type === "root" ? Object.assign(Object.assign({}, x), {}, {
                        root: x
                    }) : _(x, {
                        type: typeof I == "string" ? "stringAlign" : "numberAlign",
                        n: I
                    }, P) : x;
                }
                function _(x, I, P) {
                    let $ = I.type === "dedent" ? x.queue.slice(0, -1) : [
                        ...x.queue,
                        I
                    ], D = "", T = 0, m = 0, C = 0;
                    for (let k of $)switch(k.type){
                        case "indent":
                            v(), P.useTabs ? o(1) : d(P.tabWidth);
                            break;
                        case "stringAlign":
                            v(), D += k.n, T += k.n.length;
                            break;
                        case "numberAlign":
                            m += 1, C += k.n;
                            break;
                        default:
                            throw new Error(`Unexpected type '${k.type}'`);
                    }
                    return b(), Object.assign(Object.assign({}, x), {}, {
                        value: D,
                        length: T,
                        queue: $
                    });
                    function o(k) {
                        D += "	".repeat(k), T += P.tabWidth * k;
                    }
                    function d(k) {
                        D += " ".repeat(k), T += k;
                    }
                    function v() {
                        P.useTabs ? S() : b();
                    }
                    function S() {
                        m > 0 && o(m), B();
                    }
                    function b() {
                        C > 0 && d(C), B();
                    }
                    function B() {
                        m = 0, C = 0;
                    }
                }
                function w(x) {
                    if (x.length === 0) return 0;
                    let I = 0;
                    for(; x.length > 0 && typeof s(x) == "string" && /^[\t ]*$/.test(s(x));)I += x.pop().length;
                    if (x.length > 0 && typeof s(x) == "string") {
                        let P = s(x).replace(/[\t ]*$/, "");
                        I += s(x).length - P.length, x[x.length - 1] = P;
                    }
                    return I;
                }
                function E(x, I, P, $, D) {
                    let T = I.length, m = [
                        x
                    ], C = [];
                    for(; P >= 0;){
                        if (m.length === 0) {
                            if (T === 0) return !0;
                            m.push(I[--T]);
                            continue;
                        }
                        let { mode: o, doc: d } = m.pop();
                        if (typeof d == "string") C.push(d), P -= a(d);
                        else if (l(d) || d.type === "fill") {
                            let v = p(d);
                            for(let S = v.length - 1; S >= 0; S--)m.push({
                                mode: o,
                                doc: v[S]
                            });
                        } else switch(d.type){
                            case "indent":
                            case "align":
                            case "indent-if-break":
                            case "label":
                                m.push({
                                    mode: o,
                                    doc: d.contents
                                });
                                break;
                            case "trim":
                                P += w(C);
                                break;
                            case "group":
                                {
                                    if (D && d.break) return !1;
                                    let v = d.break ? h : o, S = d.expandedStates && v === h ? s(d.expandedStates) : d.contents;
                                    m.push({
                                        mode: v,
                                        doc: S
                                    });
                                    break;
                                }
                            case "if-break":
                                {
                                    let S = (d.groupId ? y[d.groupId] || g : o) === h ? d.breakContents : d.flatContents;
                                    S && m.push({
                                        mode: o,
                                        doc: S
                                    });
                                    break;
                                }
                            case "line":
                                if (o === h || d.hard) return !0;
                                d.soft || (C.push(" "), P--);
                                break;
                            case "line-suffix":
                                $ = !0;
                                break;
                            case "line-suffix-boundary":
                                if ($) return !1;
                                break;
                        }
                    }
                    return !1;
                }
                function N(x, I) {
                    y = {};
                    let P = I.printWidth, $ = t(I.endOfLine), D = 0, T = [
                        {
                            ind: c(),
                            mode: h,
                            doc: x
                        }
                    ], m = [], C = !1, o = [];
                    for(; T.length > 0;){
                        let { ind: v, mode: S, doc: b } = T.pop();
                        if (typeof b == "string") {
                            let B = $ !== `
` ? b.replace(/\n/g, $) : b;
                            m.push(B), D += a(B);
                        } else if (l(b)) {
                            let B = p(b);
                            for(let k = B.length - 1; k >= 0; k--)T.push({
                                ind: v,
                                mode: S,
                                doc: B[k]
                            });
                        } else switch(b.type){
                            case "cursor":
                                m.push(u.placeholder);
                                break;
                            case "indent":
                                T.push({
                                    ind: f(v, I),
                                    mode: S,
                                    doc: b.contents
                                });
                                break;
                            case "align":
                                T.push({
                                    ind: F(v, b.n, I),
                                    mode: S,
                                    doc: b.contents
                                });
                                break;
                            case "trim":
                                D -= w(m);
                                break;
                            case "group":
                                switch(S){
                                    case g:
                                        if (!C) {
                                            T.push({
                                                ind: v,
                                                mode: b.break ? h : g,
                                                doc: b.contents
                                            });
                                            break;
                                        }
                                    case h:
                                        {
                                            C = !1;
                                            let B = {
                                                ind: v,
                                                mode: g,
                                                doc: b.contents
                                            }, k = P - D, M = o.length > 0;
                                            if (!b.break && E(B, T, k, M)) T.push(B);
                                            else if (b.expandedStates) {
                                                let R = s(b.expandedStates);
                                                if (b.break) {
                                                    T.push({
                                                        ind: v,
                                                        mode: h,
                                                        doc: R
                                                    });
                                                    break;
                                                } else for(let q = 1; q < b.expandedStates.length + 1; q++)if (q >= b.expandedStates.length) {
                                                    T.push({
                                                        ind: v,
                                                        mode: h,
                                                        doc: R
                                                    });
                                                    break;
                                                } else {
                                                    let J = b.expandedStates[q], L = {
                                                        ind: v,
                                                        mode: g,
                                                        doc: J
                                                    };
                                                    if (E(L, T, k, M)) {
                                                        T.push(L);
                                                        break;
                                                    }
                                                }
                                            } else T.push({
                                                ind: v,
                                                mode: h,
                                                doc: b.contents
                                            });
                                            break;
                                        }
                                }
                                b.id && (y[b.id] = s(T).mode);
                                break;
                            case "fill":
                                {
                                    let B = P - D, { parts: k } = b;
                                    if (k.length === 0) break;
                                    let [M, R] = k, q = {
                                        ind: v,
                                        mode: g,
                                        doc: M
                                    }, J = {
                                        ind: v,
                                        mode: h,
                                        doc: M
                                    }, L = E(q, [], B, o.length > 0, !0);
                                    if (k.length === 1) {
                                        L ? T.push(q) : T.push(J);
                                        break;
                                    }
                                    let Q = {
                                        ind: v,
                                        mode: g,
                                        doc: R
                                    }, V = {
                                        ind: v,
                                        mode: h,
                                        doc: R
                                    };
                                    if (k.length === 2) {
                                        L ? T.push(Q, q) : T.push(V, J);
                                        break;
                                    }
                                    k.splice(0, 2);
                                    let j = {
                                        ind: v,
                                        mode: S,
                                        doc: n(k)
                                    }, Y = k[0];
                                    E({
                                        ind: v,
                                        mode: g,
                                        doc: [
                                            M,
                                            R,
                                            Y
                                        ]
                                    }, [], B, o.length > 0, !0) ? T.push(j, Q, q) : L ? T.push(j, V, q) : T.push(j, V, J);
                                    break;
                                }
                            case "if-break":
                            case "indent-if-break":
                                {
                                    let B = b.groupId ? y[b.groupId] : S;
                                    if (B === h) {
                                        let k = b.type === "if-break" ? b.breakContents : b.negate ? b.contents : i(b.contents);
                                        k && T.push({
                                            ind: v,
                                            mode: S,
                                            doc: k
                                        });
                                    }
                                    if (B === g) {
                                        let k = b.type === "if-break" ? b.flatContents : b.negate ? i(b.contents) : b.contents;
                                        k && T.push({
                                            ind: v,
                                            mode: S,
                                            doc: k
                                        });
                                    }
                                    break;
                                }
                            case "line-suffix":
                                o.push({
                                    ind: v,
                                    mode: S,
                                    doc: b.contents
                                });
                                break;
                            case "line-suffix-boundary":
                                o.length > 0 && T.push({
                                    ind: v,
                                    mode: S,
                                    doc: {
                                        type: "line",
                                        hard: !0
                                    }
                                });
                                break;
                            case "line":
                                switch(S){
                                    case g:
                                        if (b.hard) C = !0;
                                        else {
                                            b.soft || (m.push(" "), D += 1);
                                            break;
                                        }
                                    case h:
                                        if (o.length > 0) {
                                            T.push({
                                                ind: v,
                                                mode: S,
                                                doc: b
                                            }, ...o.reverse()), o.length = 0;
                                            break;
                                        }
                                        b.literal ? v.root ? (m.push($, v.root.value), D = v.root.length) : (m.push($), D = 0) : (D -= w(m), m.push($ + v.value), D = v.length);
                                        break;
                                }
                                break;
                            case "label":
                                T.push({
                                    ind: v,
                                    mode: S,
                                    doc: b.contents
                                });
                                break;
                            default:
                        }
                        T.length === 0 && o.length > 0 && (T.push(...o.reverse()), o.length = 0);
                    }
                    let d = m.indexOf(u.placeholder);
                    if (d !== -1) {
                        let v = m.indexOf(u.placeholder, d + 1), S = m.slice(0, d).join(""), b = m.slice(d + 1, v).join(""), B = m.slice(v + 1).join("");
                        return {
                            formatted: S + b + B,
                            cursorNodeStart: S.length,
                            cursorNodeText: b
                        };
                    }
                    return {
                        formatted: m.join("")
                    };
                }
                r.exports = {
                    printDocToString: N
                };
            }
        }), MD = te({
            "src/document/doc-debug.js" (e, r) {
                "use strict";
                ne();
                var { isConcat: t, getDocParts: s } = Yt();
                function a(u) {
                    if (!u) return "";
                    if (t(u)) {
                        let i = [];
                        for (let l of s(u))if (t(l)) i.push(...a(l).parts);
                        else {
                            let p = a(l);
                            p !== "" && i.push(p);
                        }
                        return {
                            type: "concat",
                            parts: i
                        };
                    }
                    return u.type === "if-break" ? Object.assign(Object.assign({}, u), {}, {
                        breakContents: a(u.breakContents),
                        flatContents: a(u.flatContents)
                    }) : u.type === "group" ? Object.assign(Object.assign({}, u), {}, {
                        contents: a(u.contents),
                        expandedStates: u.expandedStates && u.expandedStates.map(a)
                    }) : u.type === "fill" ? {
                        type: "fill",
                        parts: u.parts.map(a)
                    } : u.contents ? Object.assign(Object.assign({}, u), {}, {
                        contents: a(u.contents)
                    }) : u;
                }
                function n(u) {
                    let i = Object.create(null), l = new Set;
                    return p(a(u));
                    function p(h, g, c) {
                        if (typeof h == "string") return JSON.stringify(h);
                        if (t(h)) {
                            let f = s(h).map(p).filter(Boolean);
                            return f.length === 1 ? f[0] : `[${f.join(", ")}]`;
                        }
                        if (h.type === "line") {
                            let f = Array.isArray(c) && c[g + 1] && c[g + 1].type === "break-parent";
                            return h.literal ? f ? "literalline" : "literallineWithoutBreakParent" : h.hard ? f ? "hardline" : "hardlineWithoutBreakParent" : h.soft ? "softline" : "line";
                        }
                        if (h.type === "break-parent") return Array.isArray(c) && c[g - 1] && c[g - 1].type === "line" && c[g - 1].hard ? void 0 : "breakParent";
                        if (h.type === "trim") return "trim";
                        if (h.type === "indent") return "indent(" + p(h.contents) + ")";
                        if (h.type === "align") return h.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + p(h.contents) + ")" : h.n < 0 ? "dedent(" + p(h.contents) + ")" : h.n.type === "root" ? "markAsRoot(" + p(h.contents) + ")" : "align(" + JSON.stringify(h.n) + ", " + p(h.contents) + ")";
                        if (h.type === "if-break") return "ifBreak(" + p(h.breakContents) + (h.flatContents ? ", " + p(h.flatContents) : "") + (h.groupId ? (h.flatContents ? "" : ', ""') + `, { groupId: ${y(h.groupId)} }` : "") + ")";
                        if (h.type === "indent-if-break") {
                            let f = [];
                            h.negate && f.push("negate: true"), h.groupId && f.push(`groupId: ${y(h.groupId)}`);
                            let F = f.length > 0 ? `, { ${f.join(", ")} }` : "";
                            return `indentIfBreak(${p(h.contents)}${F})`;
                        }
                        if (h.type === "group") {
                            let f = [];
                            h.break && h.break !== "propagated" && f.push("shouldBreak: true"), h.id && f.push(`id: ${y(h.id)}`);
                            let F = f.length > 0 ? `, { ${f.join(", ")} }` : "";
                            return h.expandedStates ? `conditionalGroup([${h.expandedStates.map((_)=>p(_)).join(",")}]${F})` : `group(${p(h.contents)}${F})`;
                        }
                        if (h.type === "fill") return `fill([${h.parts.map((f)=>p(f)).join(", ")}])`;
                        if (h.type === "line-suffix") return "lineSuffix(" + p(h.contents) + ")";
                        if (h.type === "line-suffix-boundary") return "lineSuffixBoundary";
                        if (h.type === "label") return `label(${JSON.stringify(h.label)}, ${p(h.contents)})`;
                        throw new Error("Unknown doc type " + h.type);
                    }
                    function y(h) {
                        if (typeof h != "symbol") return JSON.stringify(String(h));
                        if (h in i) return i[h];
                        let g = String(h).slice(7, -1) || "symbol";
                        for(let c = 0;; c++){
                            let f = g + (c > 0 ? ` #${c}` : "");
                            if (!l.has(f)) return l.add(f), i[h] = `Symbol.for(${JSON.stringify(f)})`;
                        }
                    }
                }
                r.exports = {
                    printDocToDebug: n
                };
            }
        }), qe = te({
            "src/document/index.js" (e, r) {
                "use strict";
                ne(), r.exports = {
                    builders: Un(),
                    printer: qD(),
                    utils: Yt(),
                    debug: MD()
                };
            }
        }), ja = {};
        Kt(ja, {
            default: ()=>RD
        });
        function RD(e) {
            if (typeof e != "string") throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
        }
        var $D = ht({
            "node_modules/escape-string-regexp/index.js" () {
                ne();
            }
        }), qa = te({
            "node_modules/semver/internal/debug.js" (e, r) {
                ne();
                var t = typeof wt == "object" && wt.env && wt.env.NODE_DEBUG && /\bsemver\b/i.test(wt.env.NODE_DEBUG) ? function() {
                    for(var s = arguments.length, a = new Array(s), n = 0; n < s; n++)a[n] = arguments[n];
                    return console.error("SEMVER", ...a);
                } : ()=>{};
                r.exports = t;
            }
        }), Ma = te({
            "node_modules/semver/internal/constants.js" (e, r) {
                ne();
                var t = "2.0.0", s = 256, a = Number.MAX_SAFE_INTEGER || 9007199254740991, n = 16;
                r.exports = {
                    SEMVER_SPEC_VERSION: t,
                    MAX_LENGTH: s,
                    MAX_SAFE_INTEGER: a,
                    MAX_SAFE_COMPONENT_LENGTH: n
                };
            }
        }), VD = te({
            "node_modules/semver/internal/re.js" (e, r) {
                ne();
                var { MAX_SAFE_COMPONENT_LENGTH: t } = Ma(), s = qa();
                e = r.exports = {};
                var a = e.re = [], n = e.src = [], u = e.t = {}, i = 0, l = (p, y, h)=>{
                    let g = i++;
                    s(p, g, y), u[p] = g, n[g] = y, a[g] = new RegExp(y, h ? "g" : void 0);
                };
                l("NUMERICIDENTIFIER", "0|[1-9]\\d*"), l("NUMERICIDENTIFIERLOOSE", "[0-9]+"), l("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), l("MAINVERSION", `(${n[u.NUMERICIDENTIFIER]})\\.(${n[u.NUMERICIDENTIFIER]})\\.(${n[u.NUMERICIDENTIFIER]})`), l("MAINVERSIONLOOSE", `(${n[u.NUMERICIDENTIFIERLOOSE]})\\.(${n[u.NUMERICIDENTIFIERLOOSE]})\\.(${n[u.NUMERICIDENTIFIERLOOSE]})`), l("PRERELEASEIDENTIFIER", `(?:${n[u.NUMERICIDENTIFIER]}|${n[u.NONNUMERICIDENTIFIER]})`), l("PRERELEASEIDENTIFIERLOOSE", `(?:${n[u.NUMERICIDENTIFIERLOOSE]}|${n[u.NONNUMERICIDENTIFIER]})`), l("PRERELEASE", `(?:-(${n[u.PRERELEASEIDENTIFIER]}(?:\\.${n[u.PRERELEASEIDENTIFIER]})*))`), l("PRERELEASELOOSE", `(?:-?(${n[u.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${n[u.PRERELEASEIDENTIFIERLOOSE]})*))`), l("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), l("BUILD", `(?:\\+(${n[u.BUILDIDENTIFIER]}(?:\\.${n[u.BUILDIDENTIFIER]})*))`), l("FULLPLAIN", `v?${n[u.MAINVERSION]}${n[u.PRERELEASE]}?${n[u.BUILD]}?`), l("FULL", `^${n[u.FULLPLAIN]}$`), l("LOOSEPLAIN", `[v=\\s]*${n[u.MAINVERSIONLOOSE]}${n[u.PRERELEASELOOSE]}?${n[u.BUILD]}?`), l("LOOSE", `^${n[u.LOOSEPLAIN]}$`), l("GTLT", "((?:<|>)?=?)"), l("XRANGEIDENTIFIERLOOSE", `${n[u.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), l("XRANGEIDENTIFIER", `${n[u.NUMERICIDENTIFIER]}|x|X|\\*`), l("XRANGEPLAIN", `[v=\\s]*(${n[u.XRANGEIDENTIFIER]})(?:\\.(${n[u.XRANGEIDENTIFIER]})(?:\\.(${n[u.XRANGEIDENTIFIER]})(?:${n[u.PRERELEASE]})?${n[u.BUILD]}?)?)?`), l("XRANGEPLAINLOOSE", `[v=\\s]*(${n[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n[u.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n[u.XRANGEIDENTIFIERLOOSE]})(?:${n[u.PRERELEASELOOSE]})?${n[u.BUILD]}?)?)?`), l("XRANGE", `^${n[u.GTLT]}\\s*${n[u.XRANGEPLAIN]}$`), l("XRANGELOOSE", `^${n[u.GTLT]}\\s*${n[u.XRANGEPLAINLOOSE]}$`), l("COERCE", `(^|[^\\d])(\\d{1,${t}})(?:\\.(\\d{1,${t}}))?(?:\\.(\\d{1,${t}}))?(?:$|[^\\d])`), l("COERCERTL", n[u.COERCE], !0), l("LONETILDE", "(?:~>?)"), l("TILDETRIM", `(\\s*)${n[u.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", l("TILDE", `^${n[u.LONETILDE]}${n[u.XRANGEPLAIN]}$`), l("TILDELOOSE", `^${n[u.LONETILDE]}${n[u.XRANGEPLAINLOOSE]}$`), l("LONECARET", "(?:\\^)"), l("CARETTRIM", `(\\s*)${n[u.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", l("CARET", `^${n[u.LONECARET]}${n[u.XRANGEPLAIN]}$`), l("CARETLOOSE", `^${n[u.LONECARET]}${n[u.XRANGEPLAINLOOSE]}$`), l("COMPARATORLOOSE", `^${n[u.GTLT]}\\s*(${n[u.LOOSEPLAIN]})$|^$`), l("COMPARATOR", `^${n[u.GTLT]}\\s*(${n[u.FULLPLAIN]})$|^$`), l("COMPARATORTRIM", `(\\s*)${n[u.GTLT]}\\s*(${n[u.LOOSEPLAIN]}|${n[u.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", l("HYPHENRANGE", `^\\s*(${n[u.XRANGEPLAIN]})\\s+-\\s+(${n[u.XRANGEPLAIN]})\\s*$`), l("HYPHENRANGELOOSE", `^\\s*(${n[u.XRANGEPLAINLOOSE]})\\s+-\\s+(${n[u.XRANGEPLAINLOOSE]})\\s*$`), l("STAR", "(<|>)?=?\\s*\\*"), l("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), l("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
            }
        }), WD = te({
            "node_modules/semver/internal/parse-options.js" (e, r) {
                ne();
                var t = [
                    "includePrerelease",
                    "loose",
                    "rtl"
                ], s = (a)=>a ? typeof a != "object" ? {
                        loose: !0
                    } : t.filter((n)=>a[n]).reduce((n, u)=>(n[u] = !0, n), {}) : {};
                r.exports = s;
            }
        }), HD = te({
            "node_modules/semver/internal/identifiers.js" (e, r) {
                ne();
                var t = /^[0-9]+$/, s = (n, u)=>{
                    let i = t.test(n), l = t.test(u);
                    return i && l && (n = +n, u = +u), n === u ? 0 : i && !l ? -1 : l && !i ? 1 : n < u ? -1 : 1;
                }, a = (n, u)=>s(u, n);
                r.exports = {
                    compareIdentifiers: s,
                    rcompareIdentifiers: a
                };
            }
        }), GD = te({
            "node_modules/semver/classes/semver.js" (e, r) {
                ne();
                var t = qa(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: a } = Ma(), { re: n, t: u } = VD(), i = WD(), { compareIdentifiers: l } = HD(), p = class {
                    constructor(y, h){
                        if (h = i(h), y instanceof p) {
                            if (y.loose === !!h.loose && y.includePrerelease === !!h.includePrerelease) return y;
                            y = y.version;
                        } else if (typeof y != "string") throw new TypeError(`Invalid Version: ${y}`);
                        if (y.length > s) throw new TypeError(`version is longer than ${s} characters`);
                        t("SemVer", y, h), this.options = h, this.loose = !!h.loose, this.includePrerelease = !!h.includePrerelease;
                        let g = y.trim().match(h.loose ? n[u.LOOSE] : n[u.FULL]);
                        if (!g) throw new TypeError(`Invalid Version: ${y}`);
                        if (this.raw = y, this.major = +g[1], this.minor = +g[2], this.patch = +g[3], this.major > a || this.major < 0) throw new TypeError("Invalid major version");
                        if (this.minor > a || this.minor < 0) throw new TypeError("Invalid minor version");
                        if (this.patch > a || this.patch < 0) throw new TypeError("Invalid patch version");
                        g[4] ? this.prerelease = g[4].split(".").map((c)=>{
                            if (/^[0-9]+$/.test(c)) {
                                let f = +c;
                                if (f >= 0 && f < a) return f;
                            }
                            return c;
                        }) : this.prerelease = [], this.build = g[5] ? g[5].split(".") : [], this.format();
                    }
                    format() {
                        return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
                    }
                    toString() {
                        return this.version;
                    }
                    compare(y) {
                        if (t("SemVer.compare", this.version, this.options, y), !(y instanceof p)) {
                            if (typeof y == "string" && y === this.version) return 0;
                            y = new p(y, this.options);
                        }
                        return y.version === this.version ? 0 : this.compareMain(y) || this.comparePre(y);
                    }
                    compareMain(y) {
                        return y instanceof p || (y = new p(y, this.options)), l(this.major, y.major) || l(this.minor, y.minor) || l(this.patch, y.patch);
                    }
                    comparePre(y) {
                        if (y instanceof p || (y = new p(y, this.options)), this.prerelease.length && !y.prerelease.length) return -1;
                        if (!this.prerelease.length && y.prerelease.length) return 1;
                        if (!this.prerelease.length && !y.prerelease.length) return 0;
                        let h = 0;
                        do {
                            let g = this.prerelease[h], c = y.prerelease[h];
                            if (t("prerelease compare", h, g, c), g === void 0 && c === void 0) return 0;
                            if (c === void 0) return 1;
                            if (g === void 0) return -1;
                            if (g === c) continue;
                            return l(g, c);
                        }while (++h);
                    }
                    compareBuild(y) {
                        y instanceof p || (y = new p(y, this.options));
                        let h = 0;
                        do {
                            let g = this.build[h], c = y.build[h];
                            if (t("prerelease compare", h, g, c), g === void 0 && c === void 0) return 0;
                            if (c === void 0) return 1;
                            if (g === void 0) return -1;
                            if (g === c) continue;
                            return l(g, c);
                        }while (++h);
                    }
                    inc(y, h) {
                        switch(y){
                            case "premajor":
                                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", h);
                                break;
                            case "preminor":
                                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", h);
                                break;
                            case "prepatch":
                                this.prerelease.length = 0, this.inc("patch", h), this.inc("pre", h);
                                break;
                            case "prerelease":
                                this.prerelease.length === 0 && this.inc("patch", h), this.inc("pre", h);
                                break;
                            case "major":
                                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                                break;
                            case "minor":
                                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                                break;
                            case "patch":
                                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                                break;
                            case "pre":
                                if (this.prerelease.length === 0) this.prerelease = [
                                    0
                                ];
                                else {
                                    let g = this.prerelease.length;
                                    for(; --g >= 0;)typeof this.prerelease[g] == "number" && (this.prerelease[g]++, g = -2);
                                    g === -1 && this.prerelease.push(0);
                                }
                                h && (l(this.prerelease[0], h) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [
                                    h,
                                    0
                                ]) : this.prerelease = [
                                    h,
                                    0
                                ]);
                                break;
                            default:
                                throw new Error(`invalid increment argument: ${y}`);
                        }
                        return this.format(), this.raw = this.version, this;
                    }
                };
                r.exports = p;
            }
        }), zn = te({
            "node_modules/semver/functions/compare.js" (e, r) {
                ne();
                var t = GD(), s = (a, n, u)=>new t(a, u).compare(new t(n, u));
                r.exports = s;
            }
        }), UD = te({
            "node_modules/semver/functions/lt.js" (e, r) {
                ne();
                var t = zn(), s = (a, n, u)=>t(a, n, u) < 0;
                r.exports = s;
            }
        }), JD = te({
            "node_modules/semver/functions/gte.js" (e, r) {
                ne();
                var t = zn(), s = (a, n, u)=>t(a, n, u) >= 0;
                r.exports = s;
            }
        }), zD = te({
            "src/utils/arrayify.js" (e, r) {
                "use strict";
                ne(), r.exports = (t, s)=>Object.entries(t).map((a)=>{
                        let [n, u] = a;
                        return Object.assign({
                            [s]: n
                        }, u);
                    });
            }
        }), XD = te({
            "node_modules/outdent/lib/index.js" (e, r) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.outdent = void 0;
                function t() {
                    for(var E = [], N = 0; N < arguments.length; N++)E[N] = arguments[N];
                }
                function s() {
                    return typeof WeakMap < "u" ? new WeakMap : a();
                }
                function a() {
                    return {
                        add: t,
                        delete: t,
                        get: t,
                        set: t,
                        has: function(E) {
                            return !1;
                        }
                    };
                }
                var n = Object.prototype.hasOwnProperty, u = function(E, N) {
                    return n.call(E, N);
                };
                function i(E, N) {
                    for(var x in N)u(N, x) && (E[x] = N[x]);
                    return E;
                }
                var l = /^[ \t]*(?:\r\n|\r|\n)/, p = /(?:\r\n|\r|\n)[ \t]*$/, y = /^(?:[\r\n]|$)/, h = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, g = /^[ \t]*[\r\n][ \t\r\n]*$/;
                function c(E, N, x) {
                    var I = 0, P = E[0].match(h);
                    P && (I = P[1].length);
                    var $ = "(\\r\\n|\\r|\\n).{0," + I + "}", D = new RegExp($, "g");
                    N && (E = E.slice(1));
                    var T = x.newline, m = x.trimLeadingNewline, C = x.trimTrailingNewline, o = typeof T == "string", d = E.length, v = E.map(function(S, b) {
                        return S = S.replace(D, "$1"), b === 0 && m && (S = S.replace(l, "")), b === d - 1 && C && (S = S.replace(p, "")), o && (S = S.replace(/\r\n|\n|\r/g, function(B) {
                            return T;
                        })), S;
                    });
                    return v;
                }
                function f(E, N) {
                    for(var x = "", I = 0, P = E.length; I < P; I++)x += E[I], I < P - 1 && (x += N[I]);
                    return x;
                }
                function F(E) {
                    return u(E, "raw") && u(E, "length");
                }
                function _(E) {
                    var N = s(), x = s();
                    function I($) {
                        for(var D = [], T = 1; T < arguments.length; T++)D[T - 1] = arguments[T];
                        if (F($)) {
                            var m = $, C = (D[0] === I || D[0] === w) && g.test(m[0]) && y.test(m[1]), o = C ? x : N, d = o.get(m);
                            if (d || (d = c(m, C, E), o.set(m, d)), D.length === 0) return d[0];
                            var v = f(d, C ? D.slice(1) : D);
                            return v;
                        } else return _(i(i({}, E), $ || {}));
                    }
                    var P = i(I, {
                        string: function($) {
                            return c([
                                $
                            ], !1, E)[0];
                        }
                    });
                    return P;
                }
                var w = _({
                    trimLeadingNewline: !0,
                    trimTrailingNewline: !0
                });
                if (e.outdent = w, e.default = w, typeof r < "u") try {
                    r.exports = w, Object.defineProperty(w, "__esModule", {
                        value: !0
                    }), w.default = w, w.outdent = w;
                } catch  {}
            }
        }), KD = te({
            "src/main/core-options.js" (e, r) {
                "use strict";
                ne();
                var { outdent: t } = XD(), s = "Config", a = "Editor", n = "Format", u = "Other", i = "Output", l = "Global", p = "Special", y = {
                    cursorOffset: {
                        since: "1.4.0",
                        category: p,
                        type: "int",
                        default: -1,
                        range: {
                            start: -1,
                            end: Number.POSITIVE_INFINITY,
                            step: 1
                        },
                        description: t`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `,
                        cliCategory: a
                    },
                    endOfLine: {
                        since: "1.15.0",
                        category: l,
                        type: "choice",
                        default: [
                            {
                                since: "1.15.0",
                                value: "auto"
                            },
                            {
                                since: "2.0.0",
                                value: "lf"
                            }
                        ],
                        description: "Which end of line characters to apply.",
                        choices: [
                            {
                                value: "lf",
                                description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
                            },
                            {
                                value: "crlf",
                                description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
                            },
                            {
                                value: "cr",
                                description: "Carriage Return character only (\\r), used very rarely"
                            },
                            {
                                value: "auto",
                                description: t`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        `
                            }
                        ]
                    },
                    filepath: {
                        since: "1.4.0",
                        category: p,
                        type: "path",
                        description: "Specify the input filepath. This will be used to do parser inference.",
                        cliName: "stdin-filepath",
                        cliCategory: u,
                        cliDescription: "Path to the file to pretend that stdin comes from."
                    },
                    insertPragma: {
                        since: "1.8.0",
                        category: p,
                        type: "boolean",
                        default: !1,
                        description: "Insert @format pragma into file's first docblock comment.",
                        cliCategory: u
                    },
                    parser: {
                        since: "0.0.10",
                        category: l,
                        type: "choice",
                        default: [
                            {
                                since: "0.0.10",
                                value: "babylon"
                            },
                            {
                                since: "1.13.0",
                                value: void 0
                            }
                        ],
                        description: "Which parser to use.",
                        exception: (h)=>typeof h == "string" || typeof h == "function",
                        choices: [
                            {
                                value: "flow",
                                description: "Flow"
                            },
                            {
                                value: "babel",
                                since: "1.16.0",
                                description: "JavaScript"
                            },
                            {
                                value: "babel-flow",
                                since: "1.16.0",
                                description: "Flow"
                            },
                            {
                                value: "babel-ts",
                                since: "2.0.0",
                                description: "TypeScript"
                            },
                            {
                                value: "typescript",
                                since: "1.4.0",
                                description: "TypeScript"
                            },
                            {
                                value: "acorn",
                                since: "2.6.0",
                                description: "JavaScript"
                            },
                            {
                                value: "espree",
                                since: "2.2.0",
                                description: "JavaScript"
                            },
                            {
                                value: "meriyah",
                                since: "2.2.0",
                                description: "JavaScript"
                            },
                            {
                                value: "css",
                                since: "1.7.1",
                                description: "CSS"
                            },
                            {
                                value: "less",
                                since: "1.7.1",
                                description: "Less"
                            },
                            {
                                value: "scss",
                                since: "1.7.1",
                                description: "SCSS"
                            },
                            {
                                value: "json",
                                since: "1.5.0",
                                description: "JSON"
                            },
                            {
                                value: "json5",
                                since: "1.13.0",
                                description: "JSON5"
                            },
                            {
                                value: "json-stringify",
                                since: "1.13.0",
                                description: "JSON.stringify"
                            },
                            {
                                value: "graphql",
                                since: "1.5.0",
                                description: "GraphQL"
                            },
                            {
                                value: "markdown",
                                since: "1.8.0",
                                description: "Markdown"
                            },
                            {
                                value: "mdx",
                                since: "1.15.0",
                                description: "MDX"
                            },
                            {
                                value: "vue",
                                since: "1.10.0",
                                description: "Vue"
                            },
                            {
                                value: "yaml",
                                since: "1.14.0",
                                description: "YAML"
                            },
                            {
                                value: "glimmer",
                                since: "2.3.0",
                                description: "Ember / Handlebars"
                            },
                            {
                                value: "html",
                                since: "1.15.0",
                                description: "HTML"
                            },
                            {
                                value: "angular",
                                since: "1.15.0",
                                description: "Angular"
                            },
                            {
                                value: "lwc",
                                since: "1.17.0",
                                description: "Lightning Web Components"
                            }
                        ]
                    },
                    plugins: {
                        since: "1.10.0",
                        type: "path",
                        array: !0,
                        default: [
                            {
                                value: []
                            }
                        ],
                        category: l,
                        description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
                        exception: (h)=>typeof h == "string" || typeof h == "object",
                        cliName: "plugin",
                        cliCategory: s
                    },
                    pluginSearchDirs: {
                        since: "1.13.0",
                        type: "path",
                        array: !0,
                        default: [
                            {
                                value: []
                            }
                        ],
                        category: l,
                        description: t`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `,
                        exception: (h)=>typeof h == "string" || typeof h == "object",
                        cliName: "plugin-search-dir",
                        cliCategory: s
                    },
                    printWidth: {
                        since: "0.0.0",
                        category: l,
                        type: "int",
                        default: 80,
                        description: "The line length where Prettier will try wrap.",
                        range: {
                            start: 0,
                            end: Number.POSITIVE_INFINITY,
                            step: 1
                        }
                    },
                    rangeEnd: {
                        since: "1.4.0",
                        category: p,
                        type: "int",
                        default: Number.POSITIVE_INFINITY,
                        range: {
                            start: 0,
                            end: Number.POSITIVE_INFINITY,
                            step: 1
                        },
                        description: t`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `,
                        cliCategory: a
                    },
                    rangeStart: {
                        since: "1.4.0",
                        category: p,
                        type: "int",
                        default: 0,
                        range: {
                            start: 0,
                            end: Number.POSITIVE_INFINITY,
                            step: 1
                        },
                        description: t`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `,
                        cliCategory: a
                    },
                    requirePragma: {
                        since: "1.7.0",
                        category: p,
                        type: "boolean",
                        default: !1,
                        description: t`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `,
                        cliCategory: u
                    },
                    tabWidth: {
                        type: "int",
                        category: l,
                        default: 2,
                        description: "Number of spaces per indentation level.",
                        range: {
                            start: 0,
                            end: Number.POSITIVE_INFINITY,
                            step: 1
                        }
                    },
                    useTabs: {
                        since: "1.0.0",
                        category: l,
                        type: "boolean",
                        default: !1,
                        description: "Indent with tabs instead of spaces."
                    },
                    embeddedLanguageFormatting: {
                        since: "2.1.0",
                        category: l,
                        type: "choice",
                        default: [
                            {
                                since: "2.1.0",
                                value: "auto"
                            }
                        ],
                        description: "Control how Prettier formats quoted code embedded in the file.",
                        choices: [
                            {
                                value: "auto",
                                description: "Format embedded code if Prettier can automatically identify it."
                            },
                            {
                                value: "off",
                                description: "Never automatically format embedded code."
                            }
                        ]
                    }
                };
                r.exports = {
                    CATEGORY_CONFIG: s,
                    CATEGORY_EDITOR: a,
                    CATEGORY_FORMAT: n,
                    CATEGORY_OTHER: u,
                    CATEGORY_OUTPUT: i,
                    CATEGORY_GLOBAL: l,
                    CATEGORY_SPECIAL: p,
                    options: y
                };
            }
        }), Xn = te({
            "src/main/support.js" (e, r) {
                "use strict";
                ne();
                var t = {
                    compare: zn(),
                    lt: UD(),
                    gte: JD()
                }, s = zD(), a = Ia().version, n = KD().options;
                function u() {
                    let { plugins: l = [], showUnreleased: p = !1, showDeprecated: y = !1, showInternal: h = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = a.split("-", 1)[0], c = l.flatMap((E)=>E.languages || []).filter(F), f = s(Object.assign({}, ...l.map((E)=>{
                        let { options: N } = E;
                        return N;
                    }), n), "name").filter((E)=>F(E) && _(E)).sort((E, N)=>E.name === N.name ? 0 : E.name < N.name ? -1 : 1).map(w).map((E)=>{
                        E = Object.assign({}, E), Array.isArray(E.default) && (E.default = E.default.length === 1 ? E.default[0].value : E.default.filter(F).sort((x, I)=>t.compare(I.since, x.since))[0].value), Array.isArray(E.choices) && (E.choices = E.choices.filter((x)=>F(x) && _(x)), E.name === "parser" && i(E, c, l));
                        let N = Object.fromEntries(l.filter((x)=>x.defaultOptions && x.defaultOptions[E.name] !== void 0).map((x)=>[
                                x.name,
                                x.defaultOptions[E.name]
                            ]));
                        return Object.assign(Object.assign({}, E), {}, {
                            pluginDefaults: N
                        });
                    });
                    return {
                        languages: c,
                        options: f
                    };
                    function F(E) {
                        return p || !("since" in E) || E.since && t.gte(g, E.since);
                    }
                    function _(E) {
                        return y || !("deprecated" in E) || E.deprecated && t.lt(g, E.deprecated);
                    }
                    function w(E) {
                        if (h) return E;
                        let { cliName: N, cliCategory: x, cliDescription: I } = E;
                        return Hn(E, hD);
                    }
                }
                function i(l, p, y) {
                    let h = new Set(l.choices.map((g)=>g.value));
                    for (let g of p)if (g.parsers) {
                        for (let c of g.parsers)if (!h.has(c)) {
                            h.add(c);
                            let f = y.find((_)=>_.parsers && _.parsers[c]), F = g.name;
                            f && f.name && (F += ` (plugin: ${f.name})`), l.choices.push({
                                value: c,
                                description: F
                            });
                        }
                    }
                }
                r.exports = {
                    getSupportInfo: u
                };
            }
        }), Kn = te({
            "src/utils/is-non-empty-array.js" (e, r) {
                "use strict";
                ne();
                function t(s) {
                    return Array.isArray(s) && s.length > 0;
                }
                r.exports = t;
            }
        }), Pr = te({
            "src/utils/text/skip.js" (e, r) {
                "use strict";
                ne();
                function t(i) {
                    return (l, p, y)=>{
                        let h = y && y.backwards;
                        if (p === !1) return !1;
                        let { length: g } = l, c = p;
                        for(; c >= 0 && c < g;){
                            let f = l.charAt(c);
                            if (i instanceof RegExp) {
                                if (!i.test(f)) return c;
                            } else if (!i.includes(f)) return c;
                            h ? c-- : c++;
                        }
                        return c === -1 || c === g ? c : !1;
                    };
                }
                var s = t(/\s/), a = t(" 	"), n = t(",; 	"), u = t(/[^\n\r]/);
                r.exports = {
                    skipWhitespace: s,
                    skipSpaces: a,
                    skipToLineEnd: n,
                    skipEverythingButNewLine: u
                };
            }
        }), Ra = te({
            "src/utils/text/skip-inline-comment.js" (e, r) {
                "use strict";
                ne();
                function t(s, a) {
                    if (a === !1) return !1;
                    if (s.charAt(a) === "/" && s.charAt(a + 1) === "*") {
                        for(let n = a + 2; n < s.length; ++n)if (s.charAt(n) === "*" && s.charAt(n + 1) === "/") return n + 2;
                    }
                    return a;
                }
                r.exports = t;
            }
        }), $a = te({
            "src/utils/text/skip-trailing-comment.js" (e, r) {
                "use strict";
                ne();
                var { skipEverythingButNewLine: t } = Pr();
                function s(a, n) {
                    return n === !1 ? !1 : a.charAt(n) === "/" && a.charAt(n + 1) === "/" ? t(a, n) : n;
                }
                r.exports = s;
            }
        }), Va = te({
            "src/utils/text/skip-newline.js" (e, r) {
                "use strict";
                ne();
                function t(s, a, n) {
                    let u = n && n.backwards;
                    if (a === !1) return !1;
                    let i = s.charAt(a);
                    if (u) {
                        if (s.charAt(a - 1) === "\r" && i === `
`) return a - 2;
                        if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return a - 1;
                    } else {
                        if (i === "\r" && s.charAt(a + 1) === `
`) return a + 2;
                        if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return a + 1;
                    }
                    return a;
                }
                r.exports = t;
            }
        }), YD = te({
            "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js" (e, r) {
                "use strict";
                ne();
                var t = Ra(), s = Va(), a = $a(), { skipSpaces: n } = Pr();
                function u(i, l) {
                    let p = null, y = l;
                    for(; y !== p;)p = y, y = n(i, y), y = t(i, y), y = a(i, y), y = s(i, y);
                    return y;
                }
                r.exports = u;
            }
        }), Ue = te({
            "src/common/util.js" (e, r) {
                "use strict";
                ne();
                var { default: t } = ($D(), ft(ja)), s = lt(), { getSupportInfo: a } = Xn(), n = Kn(), u = Oa(), { skipWhitespace: i, skipSpaces: l, skipToLineEnd: p, skipEverythingButNewLine: y } = Pr(), h = Ra(), g = $a(), c = Va(), f = YD(), F = (V)=>V[V.length - 2];
                function _(V) {
                    return (j, Y, ie)=>{
                        let ee = ie && ie.backwards;
                        if (Y === !1) return !1;
                        let { length: ce } = j, W = Y;
                        for(; W >= 0 && W < ce;){
                            let K = j.charAt(W);
                            if (V instanceof RegExp) {
                                if (!V.test(K)) return W;
                            } else if (!V.includes(K)) return W;
                            ee ? W-- : W++;
                        }
                        return W === -1 || W === ce ? W : !1;
                    };
                }
                function w(V, j) {
                    let Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ie = l(V, Y.backwards ? j - 1 : j, Y), ee = c(V, ie, Y);
                    return ie !== ee;
                }
                function E(V, j, Y) {
                    for(let ie = j; ie < Y; ++ie)if (V.charAt(ie) === `
`) return !0;
                    return !1;
                }
                function N(V, j, Y) {
                    let ie = Y(j) - 1;
                    ie = l(V, ie, {
                        backwards: !0
                    }), ie = c(V, ie, {
                        backwards: !0
                    }), ie = l(V, ie, {
                        backwards: !0
                    });
                    let ee = c(V, ie, {
                        backwards: !0
                    });
                    return ie !== ee;
                }
                function x(V, j) {
                    let Y = null, ie = j;
                    for(; ie !== Y;)Y = ie, ie = p(V, ie), ie = h(V, ie), ie = l(V, ie);
                    return ie = g(V, ie), ie = c(V, ie), ie !== !1 && w(V, ie);
                }
                function I(V, j, Y) {
                    return x(V, Y(j));
                }
                function P(V, j, Y) {
                    return f(V, Y(j));
                }
                function $(V, j, Y) {
                    return V.charAt(P(V, j, Y));
                }
                function D(V, j) {
                    let Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                    return l(V, Y.backwards ? j - 1 : j, Y) !== j;
                }
                function T(V, j) {
                    let Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ie = 0;
                    for(let ee = Y; ee < V.length; ++ee)V[ee] === "	" ? ie = ie + j - ie % j : ie++;
                    return ie;
                }
                function m(V, j) {
                    let Y = V.lastIndexOf(`
`);
                    return Y === -1 ? 0 : T(V.slice(Y + 1).match(/^[\t ]*/)[0], j);
                }
                function C(V, j) {
                    let Y = {
                        quote: '"',
                        regex: /"/g,
                        escaped: "&quot;"
                    }, ie = {
                        quote: "'",
                        regex: /'/g,
                        escaped: "&apos;"
                    }, ee = j === "'" ? ie : Y, ce = ee === ie ? Y : ie, W = ee;
                    if (V.includes(ee.quote) || V.includes(ce.quote)) {
                        let K = (V.match(ee.regex) || []).length, de = (V.match(ce.regex) || []).length;
                        W = K > de ? ce : ee;
                    }
                    return W;
                }
                function o(V, j) {
                    let Y = V.slice(1, -1), ie = j.parser === "json" || j.parser === "json5" && j.quoteProps === "preserve" && !j.singleQuote ? '"' : j.__isInHtmlAttribute ? "'" : C(Y, j.singleQuote ? "'" : '"').quote;
                    return d(Y, ie, !(j.parser === "css" || j.parser === "less" || j.parser === "scss" || j.__embeddedInHtml));
                }
                function d(V, j, Y) {
                    let ie = j === '"' ? "'" : '"', ee = /\\(.)|(["'])/gs, ce = V.replace(ee, (W, K, de)=>K === ie ? K : de === j ? "\\" + de : de || (Y && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(K) ? K : "\\" + K));
                    return j + ce + j;
                }
                function v(V) {
                    return V.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
                }
                function S(V, j) {
                    let Y = V.match(new RegExp(`(${t(j)})+`, "g"));
                    return Y === null ? 0 : Y.reduce((ie, ee)=>Math.max(ie, ee.length / j.length), 0);
                }
                function b(V, j) {
                    let Y = V.match(new RegExp(`(${t(j)})+`, "g"));
                    if (Y === null) return 0;
                    let ie = new Map, ee = 0;
                    for (let ce of Y){
                        let W = ce.length / j.length;
                        ie.set(W, !0), W > ee && (ee = W);
                    }
                    for(let ce = 1; ce < ee; ce++)if (!ie.get(ce)) return ce;
                    return ee + 1;
                }
                function B(V, j) {
                    (V.comments || (V.comments = [])).push(j), j.printed = !1, j.nodeDescription = Q(V);
                }
                function k(V, j) {
                    j.leading = !0, j.trailing = !1, B(V, j);
                }
                function M(V, j, Y) {
                    j.leading = !1, j.trailing = !1, Y && (j.marker = Y), B(V, j);
                }
                function R(V, j) {
                    j.leading = !1, j.trailing = !0, B(V, j);
                }
                function q(V, j) {
                    let { languages: Y } = a({
                        plugins: j.plugins
                    }), ie = Y.find((ee)=>{
                        let { name: ce } = ee;
                        return ce.toLowerCase() === V;
                    }) || Y.find((ee)=>{
                        let { aliases: ce } = ee;
                        return Array.isArray(ce) && ce.includes(V);
                    }) || Y.find((ee)=>{
                        let { extensions: ce } = ee;
                        return Array.isArray(ce) && ce.includes(`.${V}`);
                    });
                    return ie && ie.parsers[0];
                }
                function J(V) {
                    return V && V.type === "front-matter";
                }
                function L(V) {
                    let j = new WeakMap;
                    return function(Y) {
                        return j.has(Y) || j.set(Y, Symbol(V)), j.get(Y);
                    };
                }
                function Q(V) {
                    let j = V.type || V.kind || "(unknown type)", Y = String(V.name || V.id && (typeof V.id == "object" ? V.id.name : V.id) || V.key && (typeof V.key == "object" ? V.key.name : V.key) || V.value && (typeof V.value == "object" ? "" : String(V.value)) || V.operator || "");
                    return Y.length > 20 && (Y = Y.slice(0, 19) + "\u2026"), j + (Y ? " " + Y : "");
                }
                r.exports = {
                    inferParserByLanguage: q,
                    getStringWidth: u,
                    getMaxContinuousCount: S,
                    getMinNotPresentContinuousCount: b,
                    getPenultimate: F,
                    getLast: s,
                    getNextNonSpaceNonCommentCharacterIndexWithStartIndex: f,
                    getNextNonSpaceNonCommentCharacterIndex: P,
                    getNextNonSpaceNonCommentCharacter: $,
                    skip: _,
                    skipWhitespace: i,
                    skipSpaces: l,
                    skipToLineEnd: p,
                    skipEverythingButNewLine: y,
                    skipInlineComment: h,
                    skipTrailingComment: g,
                    skipNewline: c,
                    isNextLineEmptyAfterIndex: x,
                    isNextLineEmpty: I,
                    isPreviousLineEmpty: N,
                    hasNewline: w,
                    hasNewlineInRange: E,
                    hasSpaces: D,
                    getAlignmentSize: T,
                    getIndentSize: m,
                    getPreferredQuote: C,
                    printString: o,
                    printNumber: v,
                    makeString: d,
                    addLeadingComment: k,
                    addDanglingComment: M,
                    addTrailingComment: R,
                    isFrontMatterNode: J,
                    isNonEmptyArray: n,
                    createGroupIdMapper: L
                };
            }
        }), Wa = {};
        Kt(Wa, {
            basename: ()=>za,
            default: ()=>Ka,
            delimiter: ()=>Mn,
            dirname: ()=>Ja,
            extname: ()=>Xa,
            isAbsolute: ()=>Qn,
            join: ()=>Ga,
            normalize: ()=>Yn,
            relative: ()=>Ua,
            resolve: ()=>wr,
            sep: ()=>qn
        });
        function Ha(e, r) {
            for(var t = 0, s = e.length - 1; s >= 0; s--){
                var a = e[s];
                a === "." ? e.splice(s, 1) : a === ".." ? (e.splice(s, 1), t++) : t && (e.splice(s, 1), t--);
            }
            if (r) for(; t--; t)e.unshift("..");
            return e;
        }
        function wr() {
            for(var e = "", r = !1, t = arguments.length - 1; t >= -1 && !r; t--){
                var s = t >= 0 ? arguments[t] : "/";
                if (typeof s != "string") throw new TypeError("Arguments to path.resolve must be strings");
                if (!s) continue;
                e = s + "/" + e, r = s.charAt(0) === "/";
            }
            return e = Ha(Zn(e.split("/"), function(a) {
                return !!a;
            }), !r).join("/"), (r ? "/" : "") + e || ".";
        }
        function Yn(e) {
            var r = Qn(e), t = Ya(e, -1) === "/";
            return e = Ha(Zn(e.split("/"), function(s) {
                return !!s;
            }), !r).join("/"), !e && !r && (e = "."), e && t && (e += "/"), (r ? "/" : "") + e;
        }
        function Qn(e) {
            return e.charAt(0) === "/";
        }
        function Ga() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Yn(Zn(e, function(r, t) {
                if (typeof r != "string") throw new TypeError("Arguments to path.join must be strings");
                return r;
            }).join("/"));
        }
        function Ua(e, r) {
            e = wr(e).substr(1), r = wr(r).substr(1);
            function t(p) {
                for(var y = 0; y < p.length && p[y] === ""; y++);
                for(var h = p.length - 1; h >= 0 && p[h] === ""; h--);
                return y > h ? [] : p.slice(y, h - y + 1);
            }
            for(var s = t(e.split("/")), a = t(r.split("/")), n = Math.min(s.length, a.length), u = n, i = 0; i < n; i++)if (s[i] !== a[i]) {
                u = i;
                break;
            }
            for(var l = [], i = u; i < s.length; i++)l.push("..");
            return l = l.concat(a.slice(u)), l.join("/");
        }
        function Ja(e) {
            var r = Ir(e), t = r[0], s = r[1];
            return !t && !s ? "." : (s && (s = s.substr(0, s.length - 1)), t + s);
        }
        function za(e, r) {
            var t = Ir(e)[2];
            return r && t.substr(-1 * r.length) === r && (t = t.substr(0, t.length - r.length)), t;
        }
        function Xa(e) {
            return Ir(e)[3];
        }
        function Zn(e, r) {
            if (e.filter) return e.filter(r);
            for(var t = [], s = 0; s < e.length; s++)r(e[s], s, e) && t.push(e[s]);
            return t;
        }
        var Na, Ir, qn, Mn, Ka, Ya, QD = ht({
            "node-modules-polyfills:path" () {
                ne(), Na = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Ir = function(e) {
                    return Na.exec(e).slice(1);
                }, qn = "/", Mn = ":", Ka = {
                    extname: Xa,
                    basename: za,
                    dirname: Ja,
                    sep: qn,
                    delimiter: Mn,
                    relative: Ua,
                    join: Ga,
                    isAbsolute: Qn,
                    normalize: Yn,
                    resolve: wr
                }, Ya = "ab".substr(-1) === "b" ? function(e, r, t) {
                    return e.substr(r, t);
                } : function(e, r, t) {
                    return r < 0 && (r = e.length + r), e.substr(r, t);
                };
            }
        }), ZD = te({
            "node-modules-polyfills-commonjs:path" (e, r) {
                ne();
                var t = (QD(), ft(Wa));
                if (t && t.default) {
                    r.exports = t.default;
                    for(let s in t)r.exports[s] = t[s];
                } else t && (r.exports = t);
            }
        }), Qt = te({
            "src/common/errors.js" (e, r) {
                "use strict";
                ne();
                var t = class extends Error {
                }, s = class extends Error {
                }, a = class extends Error {
                }, n = class extends Error {
                };
                r.exports = {
                    ConfigError: t,
                    DebugError: s,
                    UndefinedParserError: a,
                    ArgExpansionBailout: n
                };
            }
        }), vt = {};
        Kt(vt, {
            __assign: ()=>Nr,
            __asyncDelegator: ()=>fm,
            __asyncGenerator: ()=>pm,
            __asyncValues: ()=>Dm,
            __await: ()=>Xt,
            __awaiter: ()=>sm,
            __classPrivateFieldGet: ()=>ym,
            __classPrivateFieldSet: ()=>hm,
            __createBinding: ()=>am,
            __decorate: ()=>rm,
            __exportStar: ()=>om,
            __extends: ()=>em,
            __generator: ()=>im,
            __importDefault: ()=>gm,
            __importStar: ()=>dm,
            __makeTemplateObject: ()=>mm,
            __metadata: ()=>um,
            __param: ()=>nm,
            __read: ()=>Qa,
            __rest: ()=>tm,
            __spread: ()=>lm,
            __spreadArrays: ()=>cm,
            __values: ()=>Rn
        });
        function em(e, r) {
            Br(e, r);
            function t() {
                this.constructor = e;
            }
            e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t);
        }
        function tm(e, r) {
            var t = {};
            for(var s in e)Object.prototype.hasOwnProperty.call(e, s) && r.indexOf(s) < 0 && (t[s] = e[s]);
            if (e != null && typeof Object.getOwnPropertySymbols == "function") for(var a = 0, s = Object.getOwnPropertySymbols(e); a < s.length; a++)r.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[a]) && (t[s[a]] = e[s[a]]);
            return t;
        }
        function rm(e, r, t, s) {
            var a = arguments.length, n = a < 3 ? r : s === null ? s = Object.getOwnPropertyDescriptor(r, t) : s, u;
            if (typeof Reflect == "object" && typeof Reflect.decorate == "function") n = Reflect.decorate(e, r, t, s);
            else for(var i = e.length - 1; i >= 0; i--)(u = e[i]) && (n = (a < 3 ? u(n) : a > 3 ? u(r, t, n) : u(r, t)) || n);
            return a > 3 && n && Object.defineProperty(r, t, n), n;
        }
        function nm(e, r) {
            return function(t, s) {
                r(t, s, e);
            };
        }
        function um(e, r) {
            if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, r);
        }
        function sm(e, r, t, s) {
            function a(n) {
                return n instanceof t ? n : new t(function(u) {
                    u(n);
                });
            }
            return new (t || (t = Promise))(function(n, u) {
                function i(y) {
                    try {
                        p(s.next(y));
                    } catch (h) {
                        u(h);
                    }
                }
                function l(y) {
                    try {
                        p(s.throw(y));
                    } catch (h) {
                        u(h);
                    }
                }
                function p(y) {
                    y.done ? n(y.value) : a(y.value).then(i, l);
                }
                p((s = s.apply(e, r || [])).next());
            });
        }
        function im(e, r) {
            var t = {
                label: 0,
                sent: function() {
                    if (n[0] & 1) throw n[1];
                    return n[1];
                },
                trys: [],
                ops: []
            }, s, a, n, u;
            return u = {
                next: i(0),
                throw: i(1),
                return: i(2)
            }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
                return this;
            }), u;
            function i(p) {
                return function(y) {
                    return l([
                        p,
                        y
                    ]);
                };
            }
            function l(p) {
                if (s) throw new TypeError("Generator is already executing.");
                for(; t;)try {
                    if (s = 1, a && (n = p[0] & 2 ? a.return : p[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, p[1])).done) return n;
                    switch(a = 0, n && (p = [
                        p[0] & 2,
                        n.value
                    ]), p[0]){
                        case 0:
                        case 1:
                            n = p;
                            break;
                        case 4:
                            return t.label++, {
                                value: p[1],
                                done: !1
                            };
                        case 5:
                            t.label++, a = p[1], p = [
                                0
                            ];
                            continue;
                        case 7:
                            p = t.ops.pop(), t.trys.pop();
                            continue;
                        default:
                            if (n = t.trys, !(n = n.length > 0 && n[n.length - 1]) && (p[0] === 6 || p[0] === 2)) {
                                t = 0;
                                continue;
                            }
                            if (p[0] === 3 && (!n || p[1] > n[0] && p[1] < n[3])) {
                                t.label = p[1];
                                break;
                            }
                            if (p[0] === 6 && t.label < n[1]) {
                                t.label = n[1], n = p;
                                break;
                            }
                            if (n && t.label < n[2]) {
                                t.label = n[2], t.ops.push(p);
                                break;
                            }
                            n[2] && t.ops.pop(), t.trys.pop();
                            continue;
                    }
                    p = r.call(e, t);
                } catch (y) {
                    p = [
                        6,
                        y
                    ], a = 0;
                } finally{
                    s = n = 0;
                }
                if (p[0] & 5) throw p[1];
                return {
                    value: p[0] ? p[1] : void 0,
                    done: !0
                };
            }
        }
        function am(e, r, t, s) {
            s === void 0 && (s = t), e[s] = r[t];
        }
        function om(e, r) {
            for(var t in e)t !== "default" && !r.hasOwnProperty(t) && (r[t] = e[t]);
        }
        function Rn(e) {
            var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], s = 0;
            if (t) return t.call(e);
            if (e && typeof e.length == "number") return {
                next: function() {
                    return e && s >= e.length && (e = void 0), {
                        value: e && e[s++],
                        done: !e
                    };
                }
            };
            throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function Qa(e, r) {
            var t = typeof Symbol == "function" && e[Symbol.iterator];
            if (!t) return e;
            var s = t.call(e), a, n = [], u;
            try {
                for(; (r === void 0 || r-- > 0) && !(a = s.next()).done;)n.push(a.value);
            } catch (i) {
                u = {
                    error: i
                };
            } finally{
                try {
                    a && !a.done && (t = s.return) && t.call(s);
                } finally{
                    if (u) throw u.error;
                }
            }
            return n;
        }
        function lm() {
            for(var e = [], r = 0; r < arguments.length; r++)e = e.concat(Qa(arguments[r]));
            return e;
        }
        function cm() {
            for(var e = 0, r = 0, t = arguments.length; r < t; r++)e += arguments[r].length;
            for(var s = Array(e), a = 0, r = 0; r < t; r++)for(var n = arguments[r], u = 0, i = n.length; u < i; u++, a++)s[a] = n[u];
            return s;
        }
        function Xt(e) {
            return this instanceof Xt ? (this.v = e, this) : new Xt(e);
        }
        function pm(e, r, t) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var s = t.apply(e, r || []), a, n = [];
            return a = {}, u("next"), u("throw"), u("return"), a[Symbol.asyncIterator] = function() {
                return this;
            }, a;
            function u(g) {
                s[g] && (a[g] = function(c) {
                    return new Promise(function(f, F) {
                        n.push([
                            g,
                            c,
                            f,
                            F
                        ]) > 1 || i(g, c);
                    });
                });
            }
            function i(g, c) {
                try {
                    l(s[g](c));
                } catch (f) {
                    h(n[0][3], f);
                }
            }
            function l(g) {
                g.value instanceof Xt ? Promise.resolve(g.value.v).then(p, y) : h(n[0][2], g);
            }
            function p(g) {
                i("next", g);
            }
            function y(g) {
                i("throw", g);
            }
            function h(g, c) {
                g(c), n.shift(), n.length && i(n[0][0], n[0][1]);
            }
        }
        function fm(e) {
            var r, t;
            return r = {}, s("next"), s("throw", function(a) {
                throw a;
            }), s("return"), r[Symbol.iterator] = function() {
                return this;
            }, r;
            function s(a, n) {
                r[a] = e[a] ? function(u) {
                    return (t = !t) ? {
                        value: Xt(e[a](u)),
                        done: a === "return"
                    } : n ? n(u) : u;
                } : n;
            }
        }
        function Dm(e) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var r = e[Symbol.asyncIterator], t;
            return r ? r.call(e) : (e = typeof Rn == "function" ? Rn(e) : e[Symbol.iterator](), t = {}, s("next"), s("throw"), s("return"), t[Symbol.asyncIterator] = function() {
                return this;
            }, t);
            function s(n) {
                t[n] = e[n] && function(u) {
                    return new Promise(function(i, l) {
                        u = e[n](u), a(i, l, u.done, u.value);
                    });
                };
            }
            function a(n, u, i, l) {
                Promise.resolve(l).then(function(p) {
                    n({
                        value: p,
                        done: i
                    });
                }, u);
            }
        }
        function mm(e, r) {
            return Object.defineProperty ? Object.defineProperty(e, "raw", {
                value: r
            }) : e.raw = r, e;
        }
        function dm(e) {
            if (e && e.__esModule) return e;
            var r = {};
            if (e != null) for(var t in e)Object.hasOwnProperty.call(e, t) && (r[t] = e[t]);
            return r.default = e, r;
        }
        function gm(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        function ym(e, r) {
            if (!r.has(e)) throw new TypeError("attempted to get private field on non-instance");
            return r.get(e);
        }
        function hm(e, r, t) {
            if (!r.has(e)) throw new TypeError("attempted to set private field on non-instance");
            return r.set(e, t), t;
        }
        var Br, Nr, Et = ht({
            "node_modules/tslib/tslib.es6.js" () {
                ne(), Br = function(e, r) {
                    return Br = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, s) {
                        t.__proto__ = s;
                    } || function(t, s) {
                        for(var a in s)s.hasOwnProperty(a) && (t[a] = s[a]);
                    }, Br(e, r);
                }, Nr = function() {
                    return Nr = Object.assign || function(r) {
                        for(var t, s = 1, a = arguments.length; s < a; s++){
                            t = arguments[s];
                            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
                        }
                        return r;
                    }, Nr.apply(this, arguments);
                };
            }
        }), Za = te({
            "node_modules/vnopts/lib/descriptors/api.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.apiDescriptor = {
                    key: (r)=>/^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(r) ? r : JSON.stringify(r),
                    value (r) {
                        if (r === null || typeof r != "object") return JSON.stringify(r);
                        if (Array.isArray(r)) return `[${r.map((s)=>e.apiDescriptor.value(s)).join(", ")}]`;
                        let t = Object.keys(r);
                        return t.length === 0 ? "{}" : `{ ${t.map((s)=>`${e.apiDescriptor.key(s)}: ${e.apiDescriptor.value(r[s])}`).join(", ")} }`;
                    },
                    pair: (r)=>{
                        let { key: t, value: s } = r;
                        return e.apiDescriptor.value({
                            [t]: s
                        });
                    }
                };
            }
        }), vm = te({
            "node_modules/vnopts/lib/descriptors/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(Za(), e);
            }
        }), kr = te({
            "scripts/build/shims/chalk.cjs" (e, r) {
                "use strict";
                ne();
                var t = (s)=>s;
                t.grey = t, t.red = t, t.bold = t, t.yellow = t, t.blue = t, t.default = t, r.exports = t;
            }
        }), eo = te({
            "node_modules/vnopts/lib/handlers/deprecated/common.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = kr();
                e.commonDeprecatedHandler = (t, s, a)=>{
                    let { descriptor: n } = a, u = [
                        `${r.default.yellow(typeof t == "string" ? n.key(t) : n.pair(t))} is deprecated`
                    ];
                    return s && u.push(`we now treat it as ${r.default.blue(typeof s == "string" ? n.key(s) : n.pair(s))}`), u.join("; ") + ".";
                };
            }
        }), Cm = te({
            "node_modules/vnopts/lib/handlers/deprecated/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(eo(), e);
            }
        }), Em = te({
            "node_modules/vnopts/lib/handlers/invalid/common.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = kr();
                e.commonInvalidHandler = (t, s, a)=>[
                        `Invalid ${r.default.red(a.descriptor.key(t))} value.`,
                        `Expected ${r.default.blue(a.schemas[t].expected(a))},`,
                        `but received ${r.default.red(a.descriptor.value(s))}.`
                    ].join(" ");
            }
        }), to = te({
            "node_modules/vnopts/lib/handlers/invalid/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(Em(), e);
            }
        }), Fm = te({
            "node_modules/vnopts/node_modules/leven/index.js" (e, r) {
                "use strict";
                ne();
                var t = [], s = [];
                r.exports = function(a, n) {
                    if (a === n) return 0;
                    var u = a;
                    a.length > n.length && (a = n, n = u);
                    var i = a.length, l = n.length;
                    if (i === 0) return l;
                    if (l === 0) return i;
                    for(; i > 0 && a.charCodeAt(~-i) === n.charCodeAt(~-l);)i--, l--;
                    if (i === 0) return l;
                    for(var p = 0; p < i && a.charCodeAt(p) === n.charCodeAt(p);)p++;
                    if (i -= p, l -= p, i === 0) return l;
                    for(var y, h, g, c, f = 0, F = 0; f < i;)s[p + f] = a.charCodeAt(p + f), t[f] = ++f;
                    for(; F < l;)for(y = n.charCodeAt(p + F), g = F++, h = F, f = 0; f < i; f++)c = y === s[p + f] ? g : g + 1, g = t[f], h = t[f] = g > h ? c > h ? h + 1 : c : c > g ? g + 1 : c;
                    return h;
                };
            }
        }), ro = te({
            "node_modules/vnopts/lib/handlers/unknown/leven.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = kr(), t = Fm();
                e.levenUnknownHandler = (s, a, n)=>{
                    let { descriptor: u, logger: i, schemas: l } = n, p = [
                        `Ignored unknown option ${r.default.yellow(u.pair({
                            key: s,
                            value: a
                        }))}.`
                    ], y = Object.keys(l).sort().find((h)=>t(s, h) < 3);
                    y && p.push(`Did you mean ${r.default.blue(u.key(y))}?`), i.warn(p.join(" "));
                };
            }
        }), Am = te({
            "node_modules/vnopts/lib/handlers/unknown/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(ro(), e);
            }
        }), Sm = te({
            "node_modules/vnopts/lib/handlers/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(Cm(), e), r.__exportStar(to(), e), r.__exportStar(Am(), e);
            }
        }), Ft = te({
            "node_modules/vnopts/lib/schema.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = [
                    "default",
                    "expected",
                    "validate",
                    "deprecated",
                    "forward",
                    "redirect",
                    "overlap",
                    "preprocess",
                    "postprocess"
                ];
                function t(n, u) {
                    let i = new n(u), l = Object.create(i);
                    for (let p of r)p in u && (l[p] = a(u[p], i, s.prototype[p].length));
                    return l;
                }
                e.createSchema = t;
                var s = class {
                    constructor(n){
                        this.name = n.name;
                    }
                    static create(n) {
                        return t(this, n);
                    }
                    default(n) {}
                    expected(n) {
                        return "nothing";
                    }
                    validate(n, u) {
                        return !1;
                    }
                    deprecated(n, u) {
                        return !1;
                    }
                    forward(n, u) {}
                    redirect(n, u) {}
                    overlap(n, u, i) {
                        return n;
                    }
                    preprocess(n, u) {
                        return n;
                    }
                    postprocess(n, u) {
                        return n;
                    }
                };
                e.Schema = s;
                function a(n, u, i) {
                    return typeof n == "function" ? function() {
                        for(var l = arguments.length, p = new Array(l), y = 0; y < l; y++)p[y] = arguments[y];
                        return n(...p.slice(0, i - 1), u, ...p.slice(i - 1));
                    } : ()=>n;
                }
            }
        }), xm = te({
            "node_modules/vnopts/lib/schemas/alias.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Ft(), t = class extends r.Schema {
                    constructor(s){
                        super(s), this._sourceName = s.sourceName;
                    }
                    expected(s) {
                        return s.schemas[this._sourceName].expected(s);
                    }
                    validate(s, a) {
                        return a.schemas[this._sourceName].validate(s, a);
                    }
                    redirect(s, a) {
                        return this._sourceName;
                    }
                };
                e.AliasSchema = t;
            }
        }), bm = te({
            "node_modules/vnopts/lib/schemas/any.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Ft(), t = class extends r.Schema {
                    expected() {
                        return "anything";
                    }
                    validate() {
                        return !0;
                    }
                };
                e.AnySchema = t;
            }
        }), Tm = te({
            "node_modules/vnopts/lib/schemas/array.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt)), t = Ft(), s = class extends t.Schema {
                    constructor(n){
                        var { valueSchema: u, name: i = u.name } = n, l = r.__rest(n, [
                            "valueSchema",
                            "name"
                        ]);
                        super(Object.assign({}, l, {
                            name: i
                        })), this._valueSchema = u;
                    }
                    expected(n) {
                        return `an array of ${this._valueSchema.expected(n)}`;
                    }
                    validate(n, u) {
                        if (!Array.isArray(n)) return !1;
                        let i = [];
                        for (let l of n){
                            let p = u.normalizeValidateResult(this._valueSchema.validate(l, u), l);
                            p !== !0 && i.push(p.value);
                        }
                        return i.length === 0 ? !0 : {
                            value: i
                        };
                    }
                    deprecated(n, u) {
                        let i = [];
                        for (let l of n){
                            let p = u.normalizeDeprecatedResult(this._valueSchema.deprecated(l, u), l);
                            p !== !1 && i.push(...p.map((y)=>{
                                let { value: h } = y;
                                return {
                                    value: [
                                        h
                                    ]
                                };
                            }));
                        }
                        return i;
                    }
                    forward(n, u) {
                        let i = [];
                        for (let l of n){
                            let p = u.normalizeForwardResult(this._valueSchema.forward(l, u), l);
                            i.push(...p.map(a));
                        }
                        return i;
                    }
                    redirect(n, u) {
                        let i = [], l = [];
                        for (let p of n){
                            let y = u.normalizeRedirectResult(this._valueSchema.redirect(p, u), p);
                            "remain" in y && i.push(y.remain), l.push(...y.redirect.map(a));
                        }
                        return i.length === 0 ? {
                            redirect: l
                        } : {
                            redirect: l,
                            remain: i
                        };
                    }
                    overlap(n, u) {
                        return n.concat(u);
                    }
                };
                e.ArraySchema = s;
                function a(n) {
                    let { from: u, to: i } = n;
                    return {
                        from: [
                            u
                        ],
                        to: i
                    };
                }
            }
        }), Bm = te({
            "node_modules/vnopts/lib/schemas/boolean.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Ft(), t = class extends r.Schema {
                    expected() {
                        return "true or false";
                    }
                    validate(s) {
                        return typeof s == "boolean";
                    }
                };
                e.BooleanSchema = t;
            }
        }), eu = te({
            "node_modules/vnopts/lib/utils.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                function r(c, f) {
                    let F = Object.create(null);
                    for (let _ of c){
                        let w = _[f];
                        if (F[w]) throw new Error(`Duplicate ${f} ${JSON.stringify(w)}`);
                        F[w] = _;
                    }
                    return F;
                }
                e.recordFromArray = r;
                function t(c, f) {
                    let F = new Map;
                    for (let _ of c){
                        let w = _[f];
                        if (F.has(w)) throw new Error(`Duplicate ${f} ${JSON.stringify(w)}`);
                        F.set(w, _);
                    }
                    return F;
                }
                e.mapFromArray = t;
                function s() {
                    let c = Object.create(null);
                    return (f)=>{
                        let F = JSON.stringify(f);
                        return c[F] ? !0 : (c[F] = !0, !1);
                    };
                }
                e.createAutoChecklist = s;
                function a(c, f) {
                    let F = [], _ = [];
                    for (let w of c)f(w) ? F.push(w) : _.push(w);
                    return [
                        F,
                        _
                    ];
                }
                e.partition = a;
                function n(c) {
                    return c === Math.floor(c);
                }
                e.isInt = n;
                function u(c, f) {
                    if (c === f) return 0;
                    let F = typeof c, _ = typeof f, w = [
                        "undefined",
                        "object",
                        "boolean",
                        "number",
                        "string"
                    ];
                    return F !== _ ? w.indexOf(F) - w.indexOf(_) : F !== "string" ? Number(c) - Number(f) : c.localeCompare(f);
                }
                e.comparePrimitive = u;
                function i(c) {
                    return c === void 0 ? {} : c;
                }
                e.normalizeDefaultResult = i;
                function l(c, f) {
                    return c === !0 ? !0 : c === !1 ? {
                        value: f
                    } : c;
                }
                e.normalizeValidateResult = l;
                function p(c, f) {
                    let F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                    return c === !1 ? !1 : c === !0 ? F ? !0 : [
                        {
                            value: f
                        }
                    ] : "value" in c ? [
                        c
                    ] : c.length === 0 ? !1 : c;
                }
                e.normalizeDeprecatedResult = p;
                function y(c, f) {
                    return typeof c == "string" || "key" in c ? {
                        from: f,
                        to: c
                    } : "from" in c ? {
                        from: c.from,
                        to: c.to
                    } : {
                        from: f,
                        to: c.to
                    };
                }
                e.normalizeTransferResult = y;
                function h(c, f) {
                    return c === void 0 ? [] : Array.isArray(c) ? c.map((F)=>y(F, f)) : [
                        y(c, f)
                    ];
                }
                e.normalizeForwardResult = h;
                function g(c, f) {
                    let F = h(typeof c == "object" && "redirect" in c ? c.redirect : c, f);
                    return F.length === 0 ? {
                        remain: f,
                        redirect: F
                    } : typeof c == "object" && "remain" in c ? {
                        remain: c.remain,
                        redirect: F
                    } : {
                        redirect: F
                    };
                }
                e.normalizeRedirectResult = g;
            }
        }), Nm = te({
            "node_modules/vnopts/lib/schemas/choice.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Ft(), t = eu(), s = class extends r.Schema {
                    constructor(a){
                        super(a), this._choices = t.mapFromArray(a.choices.map((n)=>n && typeof n == "object" ? n : {
                                value: n
                            }), "value");
                    }
                    expected(a) {
                        let { descriptor: n } = a, u = Array.from(this._choices.keys()).map((p)=>this._choices.get(p)).filter((p)=>!p.deprecated).map((p)=>p.value).sort(t.comparePrimitive).map(n.value), i = u.slice(0, -2), l = u.slice(-2);
                        return i.concat(l.join(" or ")).join(", ");
                    }
                    validate(a) {
                        return this._choices.has(a);
                    }
                    deprecated(a) {
                        let n = this._choices.get(a);
                        return n && n.deprecated ? {
                            value: a
                        } : !1;
                    }
                    forward(a) {
                        let n = this._choices.get(a);
                        return n ? n.forward : void 0;
                    }
                    redirect(a) {
                        let n = this._choices.get(a);
                        return n ? n.redirect : void 0;
                    }
                };
                e.ChoiceSchema = s;
            }
        }), no = te({
            "node_modules/vnopts/lib/schemas/number.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Ft(), t = class extends r.Schema {
                    expected() {
                        return "a number";
                    }
                    validate(s, a) {
                        return typeof s == "number";
                    }
                };
                e.NumberSchema = t;
            }
        }), wm = te({
            "node_modules/vnopts/lib/schemas/integer.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = eu(), t = no(), s = class extends t.NumberSchema {
                    expected() {
                        return "an integer";
                    }
                    validate(a, n) {
                        return n.normalizeValidateResult(super.validate(a, n), a) === !0 && r.isInt(a);
                    }
                };
                e.IntegerSchema = s;
            }
        }), _m = te({
            "node_modules/vnopts/lib/schemas/string.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Ft(), t = class extends r.Schema {
                    expected() {
                        return "a string";
                    }
                    validate(s) {
                        return typeof s == "string";
                    }
                };
                e.StringSchema = t;
            }
        }), Pm = te({
            "node_modules/vnopts/lib/schemas/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(xm(), e), r.__exportStar(bm(), e), r.__exportStar(Tm(), e), r.__exportStar(Bm(), e), r.__exportStar(Nm(), e), r.__exportStar(wm(), e), r.__exportStar(no(), e), r.__exportStar(_m(), e);
            }
        }), Im = te({
            "node_modules/vnopts/lib/defaults.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Za(), t = eo(), s = to(), a = ro();
                e.defaultDescriptor = r.apiDescriptor, e.defaultUnknownHandler = a.levenUnknownHandler, e.defaultInvalidHandler = s.commonInvalidHandler, e.defaultDeprecatedHandler = t.commonDeprecatedHandler;
            }
        }), km = te({
            "node_modules/vnopts/lib/normalize.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Im(), t = eu();
                e.normalize = (a, n, u)=>new s(n, u).normalize(a);
                var s = class {
                    constructor(a, n){
                        let { logger: u = console, descriptor: i = r.defaultDescriptor, unknown: l = r.defaultUnknownHandler, invalid: p = r.defaultInvalidHandler, deprecated: y = r.defaultDeprecatedHandler } = n || {};
                        this._utils = {
                            descriptor: i,
                            logger: u || {
                                warn: ()=>{}
                            },
                            schemas: t.recordFromArray(a, "name"),
                            normalizeDefaultResult: t.normalizeDefaultResult,
                            normalizeDeprecatedResult: t.normalizeDeprecatedResult,
                            normalizeForwardResult: t.normalizeForwardResult,
                            normalizeRedirectResult: t.normalizeRedirectResult,
                            normalizeValidateResult: t.normalizeValidateResult
                        }, this._unknownHandler = l, this._invalidHandler = p, this._deprecatedHandler = y, this.cleanHistory();
                    }
                    cleanHistory() {
                        this._hasDeprecationWarned = t.createAutoChecklist();
                    }
                    normalize(a) {
                        let n = {}, u = [
                            a
                        ], i = ()=>{
                            for(; u.length !== 0;){
                                let l = u.shift(), p = this._applyNormalization(l, n);
                                u.push(...p);
                            }
                        };
                        i();
                        for (let l of Object.keys(this._utils.schemas)){
                            let p = this._utils.schemas[l];
                            if (!(l in n)) {
                                let y = t.normalizeDefaultResult(p.default(this._utils));
                                "value" in y && u.push({
                                    [l]: y.value
                                });
                            }
                        }
                        i();
                        for (let l of Object.keys(this._utils.schemas)){
                            let p = this._utils.schemas[l];
                            l in n && (n[l] = p.postprocess(n[l], this._utils));
                        }
                        return n;
                    }
                    _applyNormalization(a, n) {
                        let u = [], [i, l] = t.partition(Object.keys(a), (p)=>p in this._utils.schemas);
                        for (let p of i){
                            let y = this._utils.schemas[p], h = y.preprocess(a[p], this._utils), g = t.normalizeValidateResult(y.validate(h, this._utils), h);
                            if (g !== !0) {
                                let { value: w } = g, E = this._invalidHandler(p, w, this._utils);
                                throw typeof E == "string" ? new Error(E) : E;
                            }
                            let c = (w)=>{
                                let { from: E, to: N } = w;
                                u.push(typeof N == "string" ? {
                                    [N]: E
                                } : {
                                    [N.key]: N.value
                                });
                            }, f = (w)=>{
                                let { value: E, redirectTo: N } = w, x = t.normalizeDeprecatedResult(y.deprecated(E, this._utils), h, !0);
                                if (x !== !1) {
                                    if (x === !0) this._hasDeprecationWarned(p) || this._utils.logger.warn(this._deprecatedHandler(p, N, this._utils));
                                    else for (let { value: I } of x){
                                        let P = {
                                            key: p,
                                            value: I
                                        };
                                        if (!this._hasDeprecationWarned(P)) {
                                            let $ = typeof N == "string" ? {
                                                key: N,
                                                value: I
                                            } : N;
                                            this._utils.logger.warn(this._deprecatedHandler(P, $, this._utils));
                                        }
                                    }
                                }
                            };
                            t.normalizeForwardResult(y.forward(h, this._utils), h).forEach(c);
                            let _ = t.normalizeRedirectResult(y.redirect(h, this._utils), h);
                            if (_.redirect.forEach(c), "remain" in _) {
                                let w = _.remain;
                                n[p] = p in n ? y.overlap(n[p], w, this._utils) : w, f({
                                    value: w
                                });
                            }
                            for (let { from: w, to: E } of _.redirect)f({
                                value: w,
                                redirectTo: E
                            });
                        }
                        for (let p of l){
                            let y = a[p], h = this._unknownHandler(p, y, this._utils);
                            if (h) for (let g of Object.keys(h)){
                                let c = {
                                    [g]: h[g]
                                };
                                g in this._utils.schemas ? u.push(c) : Object.assign(n, c);
                            }
                        }
                        return u;
                    }
                };
                e.Normalizer = s;
            }
        }), Lm = te({
            "node_modules/vnopts/lib/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = (Et(), ft(vt));
                r.__exportStar(vm(), e), r.__exportStar(Sm(), e), r.__exportStar(Pm(), e), r.__exportStar(km(), e), r.__exportStar(Ft(), e);
            }
        }), Om = te({
            "src/main/options-normalizer.js" (e, r) {
                "use strict";
                ne();
                var t = Lm(), s = lt(), a = {
                    key: (g)=>g.length === 1 ? `-${g}` : `--${g}`,
                    value: (g)=>t.apiDescriptor.value(g),
                    pair: (g)=>{
                        let { key: c, value: f } = g;
                        return f === !1 ? `--no-${c}` : f === !0 ? a.key(c) : f === "" ? `${a.key(c)} without an argument` : `${a.key(c)}=${f}`;
                    }
                }, n = (g)=>{
                    let { colorsModule: c, levenshteinDistance: f } = g;
                    return class extends t.ChoiceSchema {
                        constructor(_){
                            let { name: w, flags: E } = _;
                            super({
                                name: w,
                                choices: E
                            }), this._flags = [
                                ...E
                            ].sort();
                        }
                        preprocess(_, w) {
                            if (typeof _ == "string" && _.length > 0 && !this._flags.includes(_)) {
                                let E = this._flags.find((N)=>f(N, _) < 3);
                                if (E) return w.logger.warn([
                                    `Unknown flag ${c.yellow(w.descriptor.value(_))},`,
                                    `did you mean ${c.blue(w.descriptor.value(E))}?`
                                ].join(" ")), E;
                            }
                            return _;
                        }
                        expected() {
                            return "a flag";
                        }
                    };
                }, u;
                function i(g, c) {
                    let { logger: f = !1, isCLI: F = !1, passThrough: _ = !1, colorsModule: w = null, levenshteinDistance: E = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, N = _ ? Array.isArray(_) ? (T, m)=>_.includes(T) ? {
                            [T]: m
                        } : void 0 : (T, m)=>({
                            [T]: m
                        }) : (T, m, C)=>{
                        let o = C.schemas, { _: d } = o, v = Hn(o, vD);
                        return t.levenUnknownHandler(T, m, Object.assign(Object.assign({}, C), {}, {
                            schemas: v
                        }));
                    }, x = F ? a : t.apiDescriptor, I = l(c, {
                        isCLI: F,
                        colorsModule: w,
                        levenshteinDistance: E
                    }), P = new t.Normalizer(I, {
                        logger: f,
                        unknown: N,
                        descriptor: x
                    }), $ = f !== !1;
                    $ && u && (P._hasDeprecationWarned = u);
                    let D = P.normalize(g);
                    return $ && (u = P._hasDeprecationWarned), F && D["plugin-search"] === !1 && (D["plugin-search-dir"] = !1), D;
                }
                function l(g, c) {
                    let { isCLI: f, colorsModule: F, levenshteinDistance: _ } = c, w = [];
                    f && w.push(t.AnySchema.create({
                        name: "_"
                    }));
                    for (let E of g)w.push(p(E, {
                        isCLI: f,
                        optionInfos: g,
                        colorsModule: F,
                        levenshteinDistance: _
                    })), E.alias && f && w.push(t.AliasSchema.create({
                        name: E.alias,
                        sourceName: E.name
                    }));
                    return w;
                }
                function p(g, c) {
                    let { isCLI: f, optionInfos: F, colorsModule: _, levenshteinDistance: w } = c, { name: E } = g;
                    if (E === "plugin-search-dir" || E === "pluginSearchDirs") return t.AnySchema.create({
                        name: E,
                        preprocess (P) {
                            return P === !1 || (P = Array.isArray(P) ? P : [
                                P
                            ]), P;
                        },
                        validate (P) {
                            return P === !1 ? !0 : P.every(($)=>typeof $ == "string");
                        },
                        expected () {
                            return "false or paths to plugin search dir";
                        }
                    });
                    let N = {
                        name: E
                    }, x, I = {};
                    switch(g.type){
                        case "int":
                            x = t.IntegerSchema, f && (N.preprocess = Number);
                            break;
                        case "string":
                            x = t.StringSchema;
                            break;
                        case "choice":
                            x = t.ChoiceSchema, N.choices = g.choices.map((P)=>typeof P == "object" && P.redirect ? Object.assign(Object.assign({}, P), {}, {
                                    redirect: {
                                        to: {
                                            key: g.name,
                                            value: P.redirect
                                        }
                                    }
                                }) : P);
                            break;
                        case "boolean":
                            x = t.BooleanSchema;
                            break;
                        case "flag":
                            x = n({
                                colorsModule: _,
                                levenshteinDistance: w
                            }), N.flags = F.flatMap((P)=>[
                                    P.alias,
                                    P.description && P.name,
                                    P.oppositeDescription && `no-${P.name}`
                                ].filter(Boolean));
                            break;
                        case "path":
                            x = t.StringSchema;
                            break;
                        default:
                            throw new Error(`Unexpected type ${g.type}`);
                    }
                    if (g.exception ? N.validate = (P, $, D)=>g.exception(P) || $.validate(P, D) : N.validate = (P, $, D)=>P === void 0 || $.validate(P, D), g.redirect && (I.redirect = (P)=>P ? {
                            to: {
                                key: g.redirect.option,
                                value: g.redirect.value
                            }
                        } : void 0), g.deprecated && (I.deprecated = !0), f && !g.array) {
                        let P = N.preprocess || (($)=>$);
                        N.preprocess = ($, D, T)=>D.preprocess(P(Array.isArray($) ? s($) : $), T);
                    }
                    return g.array ? t.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, f ? {
                        preprocess: (P)=>Array.isArray(P) ? P : [
                                P
                            ]
                    } : {}), I), {}, {
                        valueSchema: x.create(N)
                    })) : x.create(Object.assign(Object.assign({}, N), I));
                }
                function y(g, c, f) {
                    return i(g, c, f);
                }
                function h(g, c, f) {
                    return i(g, c, Object.assign({
                        isCLI: !0
                    }, f));
                }
                r.exports = {
                    normalizeApiOptions: y,
                    normalizeCliOptions: h
                };
            }
        }), ut = te({
            "src/language-js/loc.js" (e, r) {
                "use strict";
                ne();
                var t = Kn();
                function s(l) {
                    var p, y;
                    let h = l.range ? l.range[0] : l.start, g = (p = (y = l.declaration) === null || y === void 0 ? void 0 : y.decorators) !== null && p !== void 0 ? p : l.decorators;
                    return t(g) ? Math.min(s(g[0]), h) : h;
                }
                function a(l) {
                    return l.range ? l.range[1] : l.end;
                }
                function n(l, p) {
                    let y = s(l);
                    return Number.isInteger(y) && y === s(p);
                }
                function u(l, p) {
                    let y = a(l);
                    return Number.isInteger(y) && y === a(p);
                }
                function i(l, p) {
                    return n(l, p) && u(l, p);
                }
                r.exports = {
                    locStart: s,
                    locEnd: a,
                    hasSameLocStart: n,
                    hasSameLoc: i
                };
            }
        }), jm = te({
            "src/main/load-parser.js" (e, r) {
                ne(), r.exports = ()=>{};
            }
        }), qm = te({
            "scripts/build/shims/babel-highlight.cjs" (e, r) {
                "use strict";
                ne();
                var t = kr(), s = {
                    shouldHighlight: ()=>!1,
                    getChalk: ()=>t
                };
                r.exports = s;
            }
        }), Mm = te({
            "node_modules/@babel/code-frame/lib/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.codeFrameColumns = u, e.default = i;
                var r = qm(), t = !1;
                function s(l) {
                    return {
                        gutter: l.grey,
                        marker: l.red.bold,
                        message: l.red.bold
                    };
                }
                var a = /\r\n|[\n\r\u2028\u2029]/;
                function n(l, p, y) {
                    let h = Object.assign({
                        column: 0,
                        line: -1
                    }, l.start), g = Object.assign({}, h, l.end), { linesAbove: c = 2, linesBelow: f = 3 } = y || {}, F = h.line, _ = h.column, w = g.line, E = g.column, N = Math.max(F - (c + 1), 0), x = Math.min(p.length, w + f);
                    F === -1 && (N = 0), w === -1 && (x = p.length);
                    let I = w - F, P = {};
                    if (I) for(let $ = 0; $ <= I; $++){
                        let D = $ + F;
                        if (!_) P[D] = !0;
                        else if ($ === 0) {
                            let T = p[D - 1].length;
                            P[D] = [
                                _,
                                T - _ + 1
                            ];
                        } else if ($ === I) P[D] = [
                            0,
                            E
                        ];
                        else {
                            let T = p[D - $].length;
                            P[D] = [
                                0,
                                T
                            ];
                        }
                    }
                    else _ === E ? _ ? P[F] = [
                        _,
                        0
                    ] : P[F] = !0 : P[F] = [
                        _,
                        E - _
                    ];
                    return {
                        start: N,
                        end: x,
                        markerLines: P
                    };
                }
                function u(l, p) {
                    let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = (y.highlightCode || y.forceColor) && (0, r.shouldHighlight)(y), g = (0, r.getChalk)(y), c = s(g), f = ($, D)=>h ? $(D) : D, F = l.split(a), { start: _, end: w, markerLines: E } = n(p, F, y), N = p.start && typeof p.start.column == "number", x = String(w).length, P = (h ? (0, r.default)(l, y) : l).split(a, w).slice(_, w).map(($, D)=>{
                        let T = _ + 1 + D, C = ` ${` ${T}`.slice(-x)} |`, o = E[T], d = !E[T + 1];
                        if (o) {
                            let v = "";
                            if (Array.isArray(o)) {
                                let S = $.slice(0, Math.max(o[0] - 1, 0)).replace(/[^\t]/g, " "), b = o[1] || 1;
                                v = [
                                    `
 `,
                                    f(c.gutter, C.replace(/\d/g, " ")),
                                    " ",
                                    S,
                                    f(c.marker, "^").repeat(b)
                                ].join(""), d && y.message && (v += " " + f(c.message, y.message));
                            }
                            return [
                                f(c.marker, ">"),
                                f(c.gutter, C),
                                $.length > 0 ? ` ${$}` : "",
                                v
                            ].join("");
                        } else return ` ${f(c.gutter, C)}${$.length > 0 ? ` ${$}` : ""}`;
                    }).join(`
`);
                    return y.message && !N && (P = `${" ".repeat(x + 1)}${y.message}
${P}`), h ? g.reset(P) : P;
                }
                function i(l, p, y) {
                    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                    if (!t) {
                        t = !0;
                        let c = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
                        if (wt.emitWarning) wt.emitWarning(c, "DeprecationWarning");
                        else {
                            let f = new Error(c);
                            f.name = "DeprecationWarning", console.warn(new Error(c));
                        }
                    }
                    return y = Math.max(y, 0), u(l, {
                        start: {
                            column: y,
                            line: p
                        }
                    }, h);
                }
            }
        }), tu = te({
            "src/main/parser.js" (e, r) {
                "use strict";
                ne();
                var { ConfigError: t } = Qt(), s = ut(), a = jm(), { locStart: n, locEnd: u } = s, i = Object.getOwnPropertyNames, l = Object.getOwnPropertyDescriptor;
                function p(g) {
                    let c = {};
                    for (let f of g.plugins)if (f.parsers) for (let F of i(f.parsers))Object.defineProperty(c, F, l(f.parsers, F));
                    return c;
                }
                function y(g) {
                    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : p(g);
                    if (typeof g.parser == "function") return {
                        parse: g.parser,
                        astFormat: "estree",
                        locStart: n,
                        locEnd: u
                    };
                    if (typeof g.parser == "string") {
                        if (Object.prototype.hasOwnProperty.call(c, g.parser)) return c[g.parser];
                        throw new t(`Couldn't resolve parser "${g.parser}". Parsers must be explicitly added to the standalone bundle.`);
                    }
                }
                function h(g, c) {
                    let f = p(c), F = Object.defineProperties({}, Object.fromEntries(Object.keys(f).map((w)=>[
                            w,
                            {
                                enumerable: !0,
                                get () {
                                    return f[w].parse;
                                }
                            }
                        ]))), _ = y(c, f);
                    try {
                        return _.preprocess && (g = _.preprocess(g, c)), {
                            text: g,
                            ast: _.parse(g, F, c)
                        };
                    } catch (w) {
                        let { loc: E } = w;
                        if (E) {
                            let { codeFrameColumns: N } = Mm();
                            throw w.codeFrame = N(g, E, {
                                highlightCode: !0
                            }), w.message += `
` + w.codeFrame, w;
                        }
                        throw w;
                    }
                }
                r.exports = {
                    parse: h,
                    resolveParser: y
                };
            }
        }), uo = te({
            "src/main/options.js" (e, r) {
                "use strict";
                ne();
                var t = ZD(), { UndefinedParserError: s } = Qt(), { getSupportInfo: a } = Xn(), n = Om(), { resolveParser: u } = tu(), i = {
                    astFormat: "estree",
                    printer: {},
                    originalText: void 0,
                    locStart: null,
                    locEnd: null
                };
                function l(h) {
                    let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = Object.assign({}, h), f = a({
                        plugins: h.plugins,
                        showUnreleased: !0,
                        showDeprecated: !0
                    }).options, F = Object.assign(Object.assign({}, i), Object.fromEntries(f.filter((x)=>x.default !== void 0).map((x)=>[
                            x.name,
                            x.default
                        ])));
                    if (!c.parser) {
                        if (!c.filepath) (g.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), c.parser = "babel";
                        else if (c.parser = y(c.filepath, c.plugins), !c.parser) throw new s(`No parser could be inferred for file: ${c.filepath}`);
                    }
                    let _ = u(n.normalizeApiOptions(c, [
                        f.find((x)=>x.name === "parser")
                    ], {
                        passThrough: !0,
                        logger: !1
                    }));
                    c.astFormat = _.astFormat, c.locEnd = _.locEnd, c.locStart = _.locStart;
                    let w = p(c);
                    c.printer = w.printers[c.astFormat];
                    let E = Object.fromEntries(f.filter((x)=>x.pluginDefaults && x.pluginDefaults[w.name] !== void 0).map((x)=>[
                            x.name,
                            x.pluginDefaults[w.name]
                        ])), N = Object.assign(Object.assign({}, F), E);
                    for (let [x, I] of Object.entries(N))(c[x] === null || c[x] === void 0) && (c[x] = I);
                    return c.parser === "json" && (c.trailingComma = "none"), n.normalizeApiOptions(c, f, Object.assign({
                        passThrough: Object.keys(i)
                    }, g));
                }
                function p(h) {
                    let { astFormat: g } = h;
                    if (!g) throw new Error("getPlugin() requires astFormat to be set");
                    let c = h.plugins.find((f)=>f.printers && f.printers[g]);
                    if (!c) throw new Error(`Couldn't find plugin for AST format "${g}"`);
                    return c;
                }
                function y(h, g) {
                    let c = t.basename(h).toLowerCase(), F = a({
                        plugins: g
                    }).languages.filter((_)=>_.since !== null).find((_)=>_.extensions && _.extensions.some((w)=>c.endsWith(w)) || _.filenames && _.filenames.some((w)=>w.toLowerCase() === c));
                    return F && F.parsers[0];
                }
                r.exports = {
                    normalize: l,
                    hiddenDefaults: i,
                    inferParser: y
                };
            }
        }), Rm = te({
            "src/main/massage-ast.js" (e, r) {
                "use strict";
                ne();
                function t(s, a, n) {
                    if (Array.isArray(s)) return s.map((p)=>t(p, a, n)).filter(Boolean);
                    if (!s || typeof s != "object") return s;
                    let u = a.printer.massageAstNode, i;
                    u && u.ignoredProperties ? i = u.ignoredProperties : i = new Set;
                    let l = {};
                    for (let [p, y] of Object.entries(s))!i.has(p) && typeof y != "function" && (l[p] = t(y, a, s));
                    if (u) {
                        let p = u(s, l, n);
                        if (p === null) return;
                        if (p) return p;
                    }
                    return l;
                }
                r.exports = t;
            }
        }), Zt = te({
            "scripts/build/shims/assert.cjs" (e, r) {
                "use strict";
                ne();
                var t = ()=>{};
                t.ok = t, t.strictEqual = t, r.exports = t;
            }
        }), et = te({
            "src/main/comments.js" (e, r) {
                "use strict";
                ne();
                var t = Zt(), { builders: { line: s, hardline: a, breakParent: n, indent: u, lineSuffix: i, join: l, cursor: p } } = qe(), { hasNewline: y, skipNewline: h, skipSpaces: g, isPreviousLineEmpty: c, addLeadingComment: f, addDanglingComment: F, addTrailingComment: _ } = Ue(), w = new WeakMap;
                function E(k, M, R) {
                    if (!k) return;
                    let { printer: q, locStart: J, locEnd: L } = M;
                    if (R) {
                        if (q.canAttachComment && q.canAttachComment(k)) {
                            let V;
                            for(V = R.length - 1; V >= 0 && !(J(R[V]) <= J(k) && L(R[V]) <= L(k)); --V);
                            R.splice(V + 1, 0, k);
                            return;
                        }
                    } else if (w.has(k)) return w.get(k);
                    let Q = q.getCommentChildNodes && q.getCommentChildNodes(k, M) || typeof k == "object" && Object.entries(k).filter((V)=>{
                        let [j] = V;
                        return j !== "enclosingNode" && j !== "precedingNode" && j !== "followingNode" && j !== "tokens" && j !== "comments" && j !== "parent";
                    }).map((V)=>{
                        let [, j] = V;
                        return j;
                    });
                    if (Q) {
                        R || (R = [], w.set(k, R));
                        for (let V of Q)E(V, M, R);
                        return R;
                    }
                }
                function N(k, M, R, q) {
                    let { locStart: J, locEnd: L } = R, Q = J(M), V = L(M), j = E(k, R), Y, ie, ee = 0, ce = j.length;
                    for(; ee < ce;){
                        let W = ee + ce >> 1, K = j[W], de = J(K), ue = L(K);
                        if (de <= Q && V <= ue) return N(K, M, R, K);
                        if (ue <= Q) {
                            Y = K, ee = W + 1;
                            continue;
                        }
                        if (V <= de) {
                            ie = K, ce = W;
                            continue;
                        }
                        throw new Error("Comment location overlaps with node location");
                    }
                    if (q && q.type === "TemplateLiteral") {
                        let { quasis: W } = q, K = C(W, M, R);
                        Y && C(W, Y, R) !== K && (Y = null), ie && C(W, ie, R) !== K && (ie = null);
                    }
                    return {
                        enclosingNode: q,
                        precedingNode: Y,
                        followingNode: ie
                    };
                }
                var x = ()=>!1;
                function I(k, M, R, q) {
                    if (!Array.isArray(k)) return;
                    let J = [], { locStart: L, locEnd: Q, printer: { handleComments: V = {} } } = q, { avoidAstMutation: j, ownLine: Y = x, endOfLine: ie = x, remaining: ee = x } = V, ce = k.map((W, K)=>Object.assign(Object.assign({}, N(M, W, q)), {}, {
                            comment: W,
                            text: R,
                            options: q,
                            ast: M,
                            isLastComment: k.length - 1 === K
                        }));
                    for (let [W, K] of ce.entries()){
                        let { comment: de, precedingNode: ue, enclosingNode: Fe, followingNode: z, text: U, options: Z, ast: se, isLastComment: fe } = K;
                        if (Z.parser === "json" || Z.parser === "json5" || Z.parser === "__js_expression" || Z.parser === "__vue_expression" || Z.parser === "__vue_ts_expression") {
                            if (L(de) - L(se) <= 0) {
                                f(se, de);
                                continue;
                            }
                            if (Q(de) - Q(se) >= 0) {
                                _(se, de);
                                continue;
                            }
                        }
                        let ge;
                        if (j ? ge = [
                            K
                        ] : (de.enclosingNode = Fe, de.precedingNode = ue, de.followingNode = z, ge = [
                            de,
                            U,
                            Z,
                            se,
                            fe
                        ]), $(U, Z, ce, W)) de.placement = "ownLine", Y(...ge) || (z ? f(z, de) : ue ? _(ue, de) : F(Fe || se, de));
                        else if (D(U, Z, ce, W)) de.placement = "endOfLine", ie(...ge) || (ue ? _(ue, de) : z ? f(z, de) : F(Fe || se, de));
                        else if (de.placement = "remaining", !ee(...ge)) {
                            if (ue && z) {
                                let he = J.length;
                                he > 0 && J[he - 1].followingNode !== z && T(J, U, Z), J.push(K);
                            } else ue ? _(ue, de) : z ? f(z, de) : F(Fe || se, de);
                        }
                    }
                    if (T(J, R, q), !j) for (let W of k)delete W.precedingNode, delete W.enclosingNode, delete W.followingNode;
                }
                var P = (k)=>!/[\S\n\u2028\u2029]/.test(k);
                function $(k, M, R, q) {
                    let { comment: J, precedingNode: L } = R[q], { locStart: Q, locEnd: V } = M, j = Q(J);
                    if (L) for(let Y = q - 1; Y >= 0; Y--){
                        let { comment: ie, precedingNode: ee } = R[Y];
                        if (ee !== L || !P(k.slice(V(ie), j))) break;
                        j = Q(ie);
                    }
                    return y(k, j, {
                        backwards: !0
                    });
                }
                function D(k, M, R, q) {
                    let { comment: J, followingNode: L } = R[q], { locStart: Q, locEnd: V } = M, j = V(J);
                    if (L) for(let Y = q + 1; Y < R.length; Y++){
                        let { comment: ie, followingNode: ee } = R[Y];
                        if (ee !== L || !P(k.slice(j, Q(ie)))) break;
                        j = V(ie);
                    }
                    return y(k, j);
                }
                function T(k, M, R) {
                    let q = k.length;
                    if (q === 0) return;
                    let { precedingNode: J, followingNode: L, enclosingNode: Q } = k[0], V = R.printer.getGapRegex && R.printer.getGapRegex(Q) || /^[\s(]*$/, j = R.locStart(L), Y;
                    for(Y = q; Y > 0; --Y){
                        let { comment: ie, precedingNode: ee, followingNode: ce } = k[Y - 1];
                        t.strictEqual(ee, J), t.strictEqual(ce, L);
                        let W = M.slice(R.locEnd(ie), j);
                        if (V.test(W)) j = R.locStart(ie);
                        else break;
                    }
                    for (let [ie, { comment: ee }] of k.entries())ie < Y ? _(J, ee) : f(L, ee);
                    for (let ie of [
                        J,
                        L
                    ])ie.comments && ie.comments.length > 1 && ie.comments.sort((ee, ce)=>R.locStart(ee) - R.locStart(ce));
                    k.length = 0;
                }
                function m(k, M) {
                    let R = k.getValue();
                    return R.printed = !0, M.printer.printComment(k, M);
                }
                function C(k, M, R) {
                    let q = R.locStart(M) - 1;
                    for(let J = 1; J < k.length; ++J)if (q < R.locStart(k[J])) return J - 1;
                    return 0;
                }
                function o(k, M) {
                    let R = k.getValue(), q = [
                        m(k, M)
                    ], { printer: J, originalText: L, locStart: Q, locEnd: V } = M;
                    if (J.isBlockComment && J.isBlockComment(R)) {
                        let ie = y(L, V(R)) ? y(L, Q(R), {
                            backwards: !0
                        }) ? a : s : " ";
                        q.push(ie);
                    } else q.push(a);
                    let Y = h(L, g(L, V(R)));
                    return Y !== !1 && y(L, Y) && q.push(a), q;
                }
                function d(k, M) {
                    let R = k.getValue(), q = m(k, M), { printer: J, originalText: L, locStart: Q } = M, V = J.isBlockComment && J.isBlockComment(R);
                    if (y(L, Q(R), {
                        backwards: !0
                    })) {
                        let Y = c(L, R, Q);
                        return i([
                            a,
                            Y ? a : "",
                            q
                        ]);
                    }
                    let j = [
                        " ",
                        q
                    ];
                    return V || (j = [
                        i(j),
                        n
                    ]), j;
                }
                function v(k, M, R, q) {
                    let J = [], L = k.getValue();
                    return !L || !L.comments || (k.each(()=>{
                        let Q = k.getValue();
                        !Q.leading && !Q.trailing && (!q || q(Q)) && J.push(m(k, M));
                    }, "comments"), J.length === 0) ? "" : R ? l(a, J) : u([
                        a,
                        l(a, J)
                    ]);
                }
                function S(k, M, R) {
                    let q = k.getValue();
                    if (!q) return {};
                    let J = q.comments || [];
                    R && (J = J.filter((j)=>!R.has(j)));
                    let L = q === M.cursorNode;
                    if (J.length === 0) {
                        let j = L ? p : "";
                        return {
                            leading: j,
                            trailing: j
                        };
                    }
                    let Q = [], V = [];
                    return k.each(()=>{
                        let j = k.getValue();
                        if (R && R.has(j)) return;
                        let { leading: Y, trailing: ie } = j;
                        Y ? Q.push(o(k, M)) : ie && V.push(d(k, M));
                    }, "comments"), L && (Q.unshift(p), V.push(p)), {
                        leading: Q,
                        trailing: V
                    };
                }
                function b(k, M, R, q) {
                    let { leading: J, trailing: L } = S(k, R, q);
                    return !J && !L ? M : [
                        J,
                        M,
                        L
                    ];
                }
                function B(k) {
                    if (k) for (let M of k){
                        if (!M.printed) throw new Error('Comment "' + M.value.trim() + '" was not printed. Please report this error!');
                        delete M.printed;
                    }
                }
                r.exports = {
                    attach: I,
                    printComments: b,
                    printCommentsSeparately: S,
                    printDanglingComments: v,
                    getSortedChildNodes: E,
                    ensureAllCommentsPrinted: B
                };
            }
        }), $m = te({
            "src/common/ast-path.js" (e, r) {
                "use strict";
                ne();
                var t = lt();
                function s(u, i) {
                    let l = a(u.stack, i);
                    return l === -1 ? null : u.stack[l];
                }
                function a(u, i) {
                    for(let l = u.length - 1; l >= 0; l -= 2){
                        let p = u[l];
                        if (p && !Array.isArray(p) && --i < 0) return l;
                    }
                    return -1;
                }
                var n = class {
                    constructor(u){
                        this.stack = [
                            u
                        ];
                    }
                    getName() {
                        let { stack: u } = this, { length: i } = u;
                        return i > 1 ? u[i - 2] : null;
                    }
                    getValue() {
                        return t(this.stack);
                    }
                    getNode() {
                        let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                        return s(this, u);
                    }
                    getParentNode() {
                        let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                        return s(this, u + 1);
                    }
                    call(u) {
                        let { stack: i } = this, { length: l } = i, p = t(i);
                        for(var y = arguments.length, h = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)h[g - 1] = arguments[g];
                        for (let f of h)p = p[f], i.push(f, p);
                        let c = u(this);
                        return i.length = l, c;
                    }
                    callParent(u) {
                        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, l = a(this.stack, i + 1), p = this.stack.splice(l + 1), y = u(this);
                        return this.stack.push(...p), y;
                    }
                    each(u) {
                        let { stack: i } = this, { length: l } = i, p = t(i);
                        for(var y = arguments.length, h = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)h[g - 1] = arguments[g];
                        for (let c of h)p = p[c], i.push(c, p);
                        for(let c = 0; c < p.length; ++c)i.push(c, p[c]), u(this, c, p), i.length -= 2;
                        i.length = l;
                    }
                    map(u) {
                        let i = [];
                        for(var l = arguments.length, p = new Array(l > 1 ? l - 1 : 0), y = 1; y < l; y++)p[y - 1] = arguments[y];
                        return this.each((h, g, c)=>{
                            i[g] = u(h, g, c);
                        }, ...p), i;
                    }
                    try(u) {
                        let { stack: i } = this, l = [
                            ...i
                        ];
                        try {
                            return u();
                        } finally{
                            i.length = 0, i.push(...l);
                        }
                    }
                    match() {
                        let u = this.stack.length - 1, i = null, l = this.stack[u--];
                        for(var p = arguments.length, y = new Array(p), h = 0; h < p; h++)y[h] = arguments[h];
                        for (let g of y){
                            if (l === void 0) return !1;
                            let c = null;
                            if (typeof i == "number" && (c = i, i = this.stack[u--], l = this.stack[u--]), g && !g(l, i, c)) return !1;
                            i = this.stack[u--], l = this.stack[u--];
                        }
                        return !0;
                    }
                    findAncestor(u) {
                        let i = this.stack.length - 1, l = null, p = this.stack[i--];
                        for(; p;){
                            let y = null;
                            if (typeof l == "number" && (y = l, l = this.stack[i--], p = this.stack[i--]), l !== null && u(p, l, y)) return p;
                            l = this.stack[i--], p = this.stack[i--];
                        }
                    }
                };
                r.exports = n;
            }
        }), Vm = te({
            "src/main/multiparser.js" (e, r) {
                "use strict";
                ne();
                var { utils: { stripTrailingHardline: t } } = qe(), { normalize: s } = uo(), a = et();
                function n(i, l, p, y) {
                    if (p.printer.embed && p.embeddedLanguageFormatting === "auto") return p.printer.embed(i, l, (h, g, c)=>u(h, g, p, y, c), p);
                }
                function u(i, l, p, y) {
                    let { stripTrailingHardline: h = !1 } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, g = s(Object.assign(Object.assign(Object.assign({}, p), l), {}, {
                        parentParser: p.parser,
                        originalText: i
                    }), {
                        passThrough: !0
                    }), c = tu().parse(i, g), { ast: f } = c;
                    i = c.text;
                    let F = f.comments;
                    delete f.comments, a.attach(F, f, i, g), g[Symbol.for("comments")] = F || [], g[Symbol.for("tokens")] = f.tokens || [];
                    let _ = y(f, g);
                    return a.ensureAllCommentsPrinted(F), h ? typeof _ == "string" ? _.replace(/(?:\r?\n)*$/, "") : t(_) : _;
                }
                r.exports = {
                    printSubtree: n
                };
            }
        }), Wm = te({
            "src/main/ast-to-doc.js" (e, r) {
                "use strict";
                ne();
                var t = $m(), { builders: { hardline: s, addAlignmentToDoc: a }, utils: { propagateBreaks: n } } = qe(), { printComments: u } = et(), i = Vm();
                function l(h, g) {
                    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: f } = g;
                    f.preprocess && (h = f.preprocess(h, g));
                    let F = new Map, _ = new t(h), w = E();
                    return c > 0 && (w = a([
                        s,
                        w
                    ], c, g.tabWidth)), n(w), w;
                    function E(x, I) {
                        return x === void 0 || x === _ ? N(I) : Array.isArray(x) ? _.call(()=>N(I), ...x) : _.call(()=>N(I), x);
                    }
                    function N(x) {
                        let I = _.getValue(), P = I && typeof I == "object" && x === void 0;
                        if (P && F.has(I)) return F.get(I);
                        let $ = y(_, g, E, x);
                        return P && F.set(I, $), $;
                    }
                }
                function p(h, g) {
                    let { originalText: c, [Symbol.for("comments")]: f, locStart: F, locEnd: _ } = g, w = F(h), E = _(h), N = new Set;
                    for (let x of f)F(x) >= w && _(x) <= E && (x.printed = !0, N.add(x));
                    return {
                        doc: c.slice(w, E),
                        printedComments: N
                    };
                }
                function y(h, g, c, f) {
                    let F = h.getValue(), { printer: _ } = g, w, E;
                    if (_.hasPrettierIgnore && _.hasPrettierIgnore(h)) ({ doc: w, printedComments: E } = p(F, g));
                    else {
                        if (F) try {
                            w = i.printSubtree(h, c, g, l);
                        } catch (N) {
                            if (globalThis.PRETTIER_DEBUG) throw N;
                        }
                        w || (w = _.print(h, g, c, f));
                    }
                    return (!_.willPrintOwnComments || !_.willPrintOwnComments(h, g)) && (w = u(h, w, g, E)), w;
                }
                r.exports = l;
            }
        }), Hm = te({
            "src/main/range-util.js" (e, r) {
                "use strict";
                ne();
                var t = Zt(), s = et(), a = (f)=>{
                    let { parser: F } = f;
                    return F === "json" || F === "json5" || F === "json-stringify";
                };
                function n(f, F) {
                    let _ = [
                        f.node,
                        ...f.parentNodes
                    ], w = new Set([
                        F.node,
                        ...F.parentNodes
                    ]);
                    return _.find((E)=>y.has(E.type) && w.has(E));
                }
                function u(f) {
                    let F = f.length - 1;
                    for(;;){
                        let _ = f[F];
                        if (_ && (_.type === "Program" || _.type === "File")) F--;
                        else break;
                    }
                    return f.slice(0, F + 1);
                }
                function i(f, F, _) {
                    let { locStart: w, locEnd: E } = _, N = f.node, x = F.node;
                    if (N === x) return {
                        startNode: N,
                        endNode: x
                    };
                    let I = w(f.node);
                    for (let $ of u(F.parentNodes))if (w($) >= I) x = $;
                    else break;
                    let P = E(F.node);
                    for (let $ of u(f.parentNodes)){
                        if (E($) <= P) N = $;
                        else break;
                        if (N === x) break;
                    }
                    return {
                        startNode: N,
                        endNode: x
                    };
                }
                function l(f, F, _, w) {
                    let E = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], N = arguments.length > 5 ? arguments[5] : void 0, { locStart: x, locEnd: I } = _, P = x(f), $ = I(f);
                    if (!(F > $ || F < P || N === "rangeEnd" && F === P || N === "rangeStart" && F === $)) {
                        for (let D of s.getSortedChildNodes(f, _)){
                            let T = l(D, F, _, w, [
                                f,
                                ...E
                            ], N);
                            if (T) return T;
                        }
                        if (!w || w(f, E[0])) return {
                            node: f,
                            parentNodes: E
                        };
                    }
                }
                function p(f, F) {
                    return F !== "DeclareExportDeclaration" && f !== "TypeParameterDeclaration" && (f === "Directive" || f === "TypeAlias" || f === "TSExportAssignment" || f.startsWith("Declare") || f.startsWith("TSDeclare") || f.endsWith("Statement") || f.endsWith("Declaration"));
                }
                var y = new Set([
                    "ObjectExpression",
                    "ArrayExpression",
                    "StringLiteral",
                    "NumericLiteral",
                    "BooleanLiteral",
                    "NullLiteral",
                    "UnaryExpression",
                    "TemplateLiteral"
                ]), h = new Set([
                    "OperationDefinition",
                    "FragmentDefinition",
                    "VariableDefinition",
                    "TypeExtensionDefinition",
                    "ObjectTypeDefinition",
                    "FieldDefinition",
                    "DirectiveDefinition",
                    "EnumTypeDefinition",
                    "EnumValueDefinition",
                    "InputValueDefinition",
                    "InputObjectTypeDefinition",
                    "SchemaDefinition",
                    "OperationTypeDefinition",
                    "InterfaceTypeDefinition",
                    "UnionTypeDefinition",
                    "ScalarTypeDefinition"
                ]);
                function g(f, F, _) {
                    if (!F) return !1;
                    switch(f.parser){
                        case "flow":
                        case "babel":
                        case "babel-flow":
                        case "babel-ts":
                        case "typescript":
                        case "acorn":
                        case "espree":
                        case "meriyah":
                        case "__babel_estree":
                            return p(F.type, _ && _.type);
                        case "json":
                        case "json5":
                        case "json-stringify":
                            return y.has(F.type);
                        case "graphql":
                            return h.has(F.kind);
                        case "vue":
                            return F.tag !== "root";
                    }
                    return !1;
                }
                function c(f, F, _) {
                    let { rangeStart: w, rangeEnd: E, locStart: N, locEnd: x } = F;
                    t.ok(E > w);
                    let I = f.slice(w, E).search(/\S/), P = I === -1;
                    if (!P) for(w += I; E > w && !/\S/.test(f[E - 1]); --E);
                    let $ = l(_, w, F, (C, o)=>g(F, C, o), [], "rangeStart"), D = P ? $ : l(_, E, F, (C)=>g(F, C), [], "rangeEnd");
                    if (!$ || !D) return {
                        rangeStart: 0,
                        rangeEnd: 0
                    };
                    let T, m;
                    if (a(F)) {
                        let C = n($, D);
                        T = C, m = C;
                    } else ({ startNode: T, endNode: m } = i($, D, F));
                    return {
                        rangeStart: Math.min(N(T), N(m)),
                        rangeEnd: Math.max(x(T), x(m))
                    };
                }
                r.exports = {
                    calculateRange: c,
                    findNodeAtOffset: l
                };
            }
        }), Gm = te({
            "src/main/core.js" (e, r) {
                "use strict";
                ne();
                var { diffArrays: t } = BD(), { printer: { printDocToString: s }, debug: { printDocToDebug: a } } = qe(), { getAlignmentSize: n } = Ue(), { guessEndOfLine: u, convertEndOfLineToChars: i, countEndOfLineChars: l, normalizeEndOfLine: p } = Jn(), y = uo().normalize, h = Rm(), g = et(), c = tu(), f = Wm(), F = Hm(), _ = "\uFEFF", w = Symbol("cursor");
                function E(m, C, o) {
                    let d = C.comments;
                    return d && (delete C.comments, g.attach(d, C, m, o)), o[Symbol.for("comments")] = d || [], o[Symbol.for("tokens")] = C.tokens || [], o.originalText = m, d;
                }
                function N(m, C) {
                    let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                    if (!m || m.trim().length === 0) return {
                        formatted: "",
                        cursorOffset: -1,
                        comments: []
                    };
                    let { ast: d, text: v } = c.parse(m, C);
                    if (C.cursorOffset >= 0) {
                        let k = F.findNodeAtOffset(d, C.cursorOffset, C);
                        k && k.node && (C.cursorNode = k.node);
                    }
                    let S = E(v, d, C), b = f(d, C, o), B = s(b, C);
                    if (g.ensureAllCommentsPrinted(S), o > 0) {
                        let k = B.formatted.trim();
                        B.cursorNodeStart !== void 0 && (B.cursorNodeStart -= B.formatted.indexOf(k)), B.formatted = k + i(C.endOfLine);
                    }
                    if (C.cursorOffset >= 0) {
                        let k, M, R, q, J;
                        if (C.cursorNode && B.cursorNodeText ? (k = C.locStart(C.cursorNode), M = v.slice(k, C.locEnd(C.cursorNode)), R = C.cursorOffset - k, q = B.cursorNodeStart, J = B.cursorNodeText) : (k = 0, M = v, R = C.cursorOffset, q = 0, J = B.formatted), M === J) return {
                            formatted: B.formatted,
                            cursorOffset: q + R,
                            comments: S
                        };
                        let L = [
                            ...M
                        ];
                        L.splice(R, 0, w);
                        let Q = [
                            ...J
                        ], V = t(L, Q), j = q;
                        for (let Y of V)if (Y.removed) {
                            if (Y.value.includes(w)) break;
                        } else j += Y.count;
                        return {
                            formatted: B.formatted,
                            cursorOffset: j,
                            comments: S
                        };
                    }
                    return {
                        formatted: B.formatted,
                        cursorOffset: -1,
                        comments: S
                    };
                }
                function x(m, C) {
                    let { ast: o, text: d } = c.parse(m, C), { rangeStart: v, rangeEnd: S } = F.calculateRange(d, C, o), b = d.slice(v, S), B = Math.min(v, d.lastIndexOf(`
`, v) + 1), k = d.slice(B, v).match(/^\s*/)[0], M = n(k, C.tabWidth), R = N(b, Object.assign(Object.assign({}, C), {}, {
                        rangeStart: 0,
                        rangeEnd: Number.POSITIVE_INFINITY,
                        cursorOffset: C.cursorOffset > v && C.cursorOffset <= S ? C.cursorOffset - v : -1,
                        endOfLine: "lf"
                    }), M), q = R.formatted.trimEnd(), { cursorOffset: J } = C;
                    J > S ? J += q.length - b.length : R.cursorOffset >= 0 && (J = R.cursorOffset + v);
                    let L = d.slice(0, v) + q + d.slice(S);
                    if (C.endOfLine !== "lf") {
                        let Q = i(C.endOfLine);
                        J >= 0 && Q === `\r
` && (J += l(L.slice(0, J), `
`)), L = L.replace(/\n/g, Q);
                    }
                    return {
                        formatted: L,
                        cursorOffset: J,
                        comments: R.comments
                    };
                }
                function I(m, C, o) {
                    return typeof C != "number" || Number.isNaN(C) || C < 0 || C > m.length ? o : C;
                }
                function P(m, C) {
                    let { cursorOffset: o, rangeStart: d, rangeEnd: v } = C;
                    return o = I(m, o, -1), d = I(m, d, 0), v = I(m, v, m.length), Object.assign(Object.assign({}, C), {}, {
                        cursorOffset: o,
                        rangeStart: d,
                        rangeEnd: v
                    });
                }
                function $(m, C) {
                    let { cursorOffset: o, rangeStart: d, rangeEnd: v, endOfLine: S } = P(m, C), b = m.charAt(0) === _;
                    if (b && (m = m.slice(1), o--, d--, v--), S === "auto" && (S = u(m)), m.includes("\r")) {
                        let B = (k)=>l(m.slice(0, Math.max(k, 0)), `\r
`);
                        o -= B(o), d -= B(d), v -= B(v), m = p(m);
                    }
                    return {
                        hasBOM: b,
                        text: m,
                        options: P(m, Object.assign(Object.assign({}, C), {}, {
                            cursorOffset: o,
                            rangeStart: d,
                            rangeEnd: v,
                            endOfLine: S
                        }))
                    };
                }
                function D(m, C) {
                    let o = c.resolveParser(C);
                    return !o.hasPragma || o.hasPragma(m);
                }
                function T(m, C) {
                    let { hasBOM: o, text: d, options: v } = $(m, y(C));
                    if (v.rangeStart >= v.rangeEnd && d !== "" || v.requirePragma && !D(d, v)) return {
                        formatted: m,
                        cursorOffset: C.cursorOffset,
                        comments: []
                    };
                    let S;
                    return v.rangeStart > 0 || v.rangeEnd < d.length ? S = x(d, v) : (!v.requirePragma && v.insertPragma && v.printer.insertPragma && !D(d, v) && (d = v.printer.insertPragma(d)), S = N(d, v)), o && (S.formatted = _ + S.formatted, S.cursorOffset >= 0 && S.cursorOffset++), S;
                }
                r.exports = {
                    formatWithCursor: T,
                    parse (m, C, o) {
                        let { text: d, options: v } = $(m, y(C)), S = c.parse(d, v);
                        return o && (S.ast = h(S.ast, v)), S;
                    },
                    formatAST (m, C) {
                        C = y(C);
                        let o = f(m, C);
                        return s(o, C);
                    },
                    formatDoc (m, C) {
                        return T(a(m), Object.assign(Object.assign({}, C), {}, {
                            parser: "__js_expression"
                        })).formatted;
                    },
                    printToDoc (m, C) {
                        C = y(C);
                        let { ast: o, text: d } = c.parse(m, C);
                        return E(d, o, C), f(o, C);
                    },
                    printDocToString (m, C) {
                        return s(m, y(C));
                    }
                };
            }
        }), Um = te({
            "src/common/util-shared.js" (e, r) {
                "use strict";
                ne();
                var { getMaxContinuousCount: t, getStringWidth: s, getAlignmentSize: a, getIndentSize: n, skip: u, skipWhitespace: i, skipSpaces: l, skipNewline: p, skipToLineEnd: y, skipEverythingButNewLine: h, skipInlineComment: g, skipTrailingComment: c, hasNewline: f, hasNewlineInRange: F, hasSpaces: _, isNextLineEmpty: w, isNextLineEmptyAfterIndex: E, isPreviousLineEmpty: N, getNextNonSpaceNonCommentCharacterIndex: x, makeString: I, addLeadingComment: P, addDanglingComment: $, addTrailingComment: D } = Ue();
                r.exports = {
                    getMaxContinuousCount: t,
                    getStringWidth: s,
                    getAlignmentSize: a,
                    getIndentSize: n,
                    skip: u,
                    skipWhitespace: i,
                    skipSpaces: l,
                    skipNewline: p,
                    skipToLineEnd: y,
                    skipEverythingButNewLine: h,
                    skipInlineComment: g,
                    skipTrailingComment: c,
                    hasNewline: f,
                    hasNewlineInRange: F,
                    hasSpaces: _,
                    isNextLineEmpty: w,
                    isNextLineEmptyAfterIndex: E,
                    isPreviousLineEmpty: N,
                    getNextNonSpaceNonCommentCharacterIndex: x,
                    makeString: I,
                    addLeadingComment: P,
                    addDanglingComment: $,
                    addTrailingComment: D
                };
            }
        }), _t = te({
            "src/utils/create-language.js" (e, r) {
                "use strict";
                ne(), r.exports = function(t, s) {
                    let { languageId: a } = t, n = Hn(t, CD);
                    return Object.assign(Object.assign({
                        linguistLanguageId: a
                    }, n), s(t));
                };
            }
        }), Jm = te({
            "node_modules/esutils/lib/ast.js" (e, r) {
                ne(), function() {
                    "use strict";
                    function t(l) {
                        if (l == null) return !1;
                        switch(l.type){
                            case "ArrayExpression":
                            case "AssignmentExpression":
                            case "BinaryExpression":
                            case "CallExpression":
                            case "ConditionalExpression":
                            case "FunctionExpression":
                            case "Identifier":
                            case "Literal":
                            case "LogicalExpression":
                            case "MemberExpression":
                            case "NewExpression":
                            case "ObjectExpression":
                            case "SequenceExpression":
                            case "ThisExpression":
                            case "UnaryExpression":
                            case "UpdateExpression":
                                return !0;
                        }
                        return !1;
                    }
                    function s(l) {
                        if (l == null) return !1;
                        switch(l.type){
                            case "DoWhileStatement":
                            case "ForInStatement":
                            case "ForStatement":
                            case "WhileStatement":
                                return !0;
                        }
                        return !1;
                    }
                    function a(l) {
                        if (l == null) return !1;
                        switch(l.type){
                            case "BlockStatement":
                            case "BreakStatement":
                            case "ContinueStatement":
                            case "DebuggerStatement":
                            case "DoWhileStatement":
                            case "EmptyStatement":
                            case "ExpressionStatement":
                            case "ForInStatement":
                            case "ForStatement":
                            case "IfStatement":
                            case "LabeledStatement":
                            case "ReturnStatement":
                            case "SwitchStatement":
                            case "ThrowStatement":
                            case "TryStatement":
                            case "VariableDeclaration":
                            case "WhileStatement":
                            case "WithStatement":
                                return !0;
                        }
                        return !1;
                    }
                    function n(l) {
                        return a(l) || l != null && l.type === "FunctionDeclaration";
                    }
                    function u(l) {
                        switch(l.type){
                            case "IfStatement":
                                return l.alternate != null ? l.alternate : l.consequent;
                            case "LabeledStatement":
                            case "ForStatement":
                            case "ForInStatement":
                            case "WhileStatement":
                            case "WithStatement":
                                return l.body;
                        }
                        return null;
                    }
                    function i(l) {
                        var p;
                        if (l.type !== "IfStatement" || l.alternate == null) return !1;
                        p = l.consequent;
                        do {
                            if (p.type === "IfStatement" && p.alternate == null) return !0;
                            p = u(p);
                        }while (p);
                        return !1;
                    }
                    r.exports = {
                        isExpression: t,
                        isStatement: a,
                        isIterationStatement: s,
                        isSourceElement: n,
                        isProblematicIfStatement: i,
                        trailingStatement: u
                    };
                }();
            }
        }), so = te({
            "node_modules/esutils/lib/code.js" (e, r) {
                ne(), function() {
                    "use strict";
                    var t, s, a, n, u, i;
                    s = {
                        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
                        NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
                    }, t = {
                        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
                        NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
                    };
                    function l(E) {
                        return 48 <= E && E <= 57;
                    }
                    function p(E) {
                        return 48 <= E && E <= 57 || 97 <= E && E <= 102 || 65 <= E && E <= 70;
                    }
                    function y(E) {
                        return E >= 48 && E <= 55;
                    }
                    a = [
                        5760,
                        8192,
                        8193,
                        8194,
                        8195,
                        8196,
                        8197,
                        8198,
                        8199,
                        8200,
                        8201,
                        8202,
                        8239,
                        8287,
                        12288,
                        65279
                    ];
                    function h(E) {
                        return E === 32 || E === 9 || E === 11 || E === 12 || E === 160 || E >= 5760 && a.indexOf(E) >= 0;
                    }
                    function g(E) {
                        return E === 10 || E === 13 || E === 8232 || E === 8233;
                    }
                    function c(E) {
                        if (E <= 65535) return String.fromCharCode(E);
                        var N = String.fromCharCode(Math.floor((E - 65536) / 1024) + 55296), x = String.fromCharCode((E - 65536) % 1024 + 56320);
                        return N + x;
                    }
                    for(n = new Array(128), i = 0; i < 128; ++i)n[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i === 36 || i === 95;
                    for(u = new Array(128), i = 0; i < 128; ++i)u[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57 || i === 36 || i === 95;
                    function f(E) {
                        return E < 128 ? n[E] : s.NonAsciiIdentifierStart.test(c(E));
                    }
                    function F(E) {
                        return E < 128 ? u[E] : s.NonAsciiIdentifierPart.test(c(E));
                    }
                    function _(E) {
                        return E < 128 ? n[E] : t.NonAsciiIdentifierStart.test(c(E));
                    }
                    function w(E) {
                        return E < 128 ? u[E] : t.NonAsciiIdentifierPart.test(c(E));
                    }
                    r.exports = {
                        isDecimalDigit: l,
                        isHexDigit: p,
                        isOctalDigit: y,
                        isWhiteSpace: h,
                        isLineTerminator: g,
                        isIdentifierStartES5: f,
                        isIdentifierPartES5: F,
                        isIdentifierStartES6: _,
                        isIdentifierPartES6: w
                    };
                }();
            }
        }), zm = te({
            "node_modules/esutils/lib/keyword.js" (e, r) {
                ne(), function() {
                    "use strict";
                    var t = so();
                    function s(f) {
                        switch(f){
                            case "implements":
                            case "interface":
                            case "package":
                            case "private":
                            case "protected":
                            case "public":
                            case "static":
                            case "let":
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    function a(f, F) {
                        return !F && f === "yield" ? !1 : n(f, F);
                    }
                    function n(f, F) {
                        if (F && s(f)) return !0;
                        switch(f.length){
                            case 2:
                                return f === "if" || f === "in" || f === "do";
                            case 3:
                                return f === "var" || f === "for" || f === "new" || f === "try";
                            case 4:
                                return f === "this" || f === "else" || f === "case" || f === "void" || f === "with" || f === "enum";
                            case 5:
                                return f === "while" || f === "break" || f === "catch" || f === "throw" || f === "const" || f === "yield" || f === "class" || f === "super";
                            case 6:
                                return f === "return" || f === "typeof" || f === "delete" || f === "switch" || f === "export" || f === "import";
                            case 7:
                                return f === "default" || f === "finally" || f === "extends";
                            case 8:
                                return f === "function" || f === "continue" || f === "debugger";
                            case 10:
                                return f === "instanceof";
                            default:
                                return !1;
                        }
                    }
                    function u(f, F) {
                        return f === "null" || f === "true" || f === "false" || a(f, F);
                    }
                    function i(f, F) {
                        return f === "null" || f === "true" || f === "false" || n(f, F);
                    }
                    function l(f) {
                        return f === "eval" || f === "arguments";
                    }
                    function p(f) {
                        var F, _, w;
                        if (f.length === 0 || (w = f.charCodeAt(0), !t.isIdentifierStartES5(w))) return !1;
                        for(F = 1, _ = f.length; F < _; ++F)if (w = f.charCodeAt(F), !t.isIdentifierPartES5(w)) return !1;
                        return !0;
                    }
                    function y(f, F) {
                        return (f - 55296) * 1024 + (F - 56320) + 65536;
                    }
                    function h(f) {
                        var F, _, w, E, N;
                        if (f.length === 0) return !1;
                        for(N = t.isIdentifierStartES6, F = 0, _ = f.length; F < _; ++F){
                            if (w = f.charCodeAt(F), 55296 <= w && w <= 56319) {
                                if (++F, F >= _ || (E = f.charCodeAt(F), !(56320 <= E && E <= 57343))) return !1;
                                w = y(w, E);
                            }
                            if (!N(w)) return !1;
                            N = t.isIdentifierPartES6;
                        }
                        return !0;
                    }
                    function g(f, F) {
                        return p(f) && !u(f, F);
                    }
                    function c(f, F) {
                        return h(f) && !i(f, F);
                    }
                    r.exports = {
                        isKeywordES5: a,
                        isKeywordES6: n,
                        isReservedWordES5: u,
                        isReservedWordES6: i,
                        isRestrictedWord: l,
                        isIdentifierNameES5: p,
                        isIdentifierNameES6: h,
                        isIdentifierES5: g,
                        isIdentifierES6: c
                    };
                }();
            }
        }), Xm = te({
            "node_modules/esutils/lib/utils.js" (e) {
                ne(), function() {
                    "use strict";
                    e.ast = Jm(), e.code = so(), e.keyword = zm();
                }();
            }
        }), Pt = te({
            "src/language-js/utils/is-block-comment.js" (e, r) {
                "use strict";
                ne();
                var t = new Set([
                    "Block",
                    "CommentBlock",
                    "MultiLine"
                ]), s = (a)=>t.has(a == null ? void 0 : a.type);
                r.exports = s;
            }
        }), Km = te({
            "src/language-js/utils/is-node-matches.js" (e, r) {
                "use strict";
                ne();
                function t(a, n) {
                    let u = n.split(".");
                    for(let i = u.length - 1; i >= 0; i--){
                        let l = u[i];
                        if (i === 0) return a.type === "Identifier" && a.name === l;
                        if (a.type !== "MemberExpression" || a.optional || a.computed || a.property.type !== "Identifier" || a.property.name !== l) return !1;
                        a = a.object;
                    }
                }
                function s(a, n) {
                    return n.some((u)=>t(a, u));
                }
                r.exports = s;
            }
        }), Ke = te({
            "src/language-js/utils/index.js" (e, r) {
                "use strict";
                ne();
                var t = Xm().keyword.isIdentifierNameES5, { getLast: s, hasNewline: a, skipWhitespace: n, isNonEmptyArray: u, isNextLineEmptyAfterIndex: i, getStringWidth: l } = Ue(), { locStart: p, locEnd: y, hasSameLocStart: h } = ut(), g = Pt(), c = Km(), f = "(?:(?=.)\\s)", F = new RegExp(`^${f}*:`), _ = new RegExp(`^${f}*::`);
                function w(O) {
                    var me, _e;
                    return ((me = O.extra) === null || me === void 0 ? void 0 : me.parenthesized) && g((_e = O.trailingComments) === null || _e === void 0 ? void 0 : _e[0]) && F.test(O.trailingComments[0].value);
                }
                function E(O) {
                    let me = O == null ? void 0 : O[0];
                    return g(me) && _.test(me.value);
                }
                function N(O, me) {
                    if (!O || typeof O != "object") return !1;
                    if (Array.isArray(O)) return O.some((He)=>N(He, me));
                    let _e = me(O);
                    return typeof _e == "boolean" ? _e : Object.values(O).some((He)=>N(He, me));
                }
                function x(O) {
                    return O.type === "AssignmentExpression" || O.type === "BinaryExpression" || O.type === "LogicalExpression" || O.type === "NGPipeExpression" || O.type === "ConditionalExpression" || de(O) || ue(O) || O.type === "SequenceExpression" || O.type === "TaggedTemplateExpression" || O.type === "BindExpression" || O.type === "UpdateExpression" && !O.prefix || st(O) || O.type === "TSNonNullExpression";
                }
                function I(O) {
                    var me, _e, He, Ge, it, Qe;
                    return O.expressions ? O.expressions[0] : (me = (_e = (He = (Ge = (it = (Qe = O.left) !== null && Qe !== void 0 ? Qe : O.test) !== null && it !== void 0 ? it : O.callee) !== null && Ge !== void 0 ? Ge : O.object) !== null && He !== void 0 ? He : O.tag) !== null && _e !== void 0 ? _e : O.argument) !== null && me !== void 0 ? me : O.expression;
                }
                function P(O, me) {
                    if (me.expressions) return [
                        "expressions",
                        0
                    ];
                    if (me.left) return [
                        "left"
                    ];
                    if (me.test) return [
                        "test"
                    ];
                    if (me.object) return [
                        "object"
                    ];
                    if (me.callee) return [
                        "callee"
                    ];
                    if (me.tag) return [
                        "tag"
                    ];
                    if (me.argument) return [
                        "argument"
                    ];
                    if (me.expression) return [
                        "expression"
                    ];
                    throw new Error("Unexpected node has no left side.");
                }
                function $(O) {
                    return O = new Set(O), (me)=>O.has(me == null ? void 0 : me.type);
                }
                var D = $([
                    "Line",
                    "CommentLine",
                    "SingleLine",
                    "HashbangComment",
                    "HTMLOpen",
                    "HTMLClose"
                ]), T = $([
                    "ExportDefaultDeclaration",
                    "ExportDefaultSpecifier",
                    "DeclareExportDeclaration",
                    "ExportNamedDeclaration",
                    "ExportAllDeclaration"
                ]);
                function m(O) {
                    let me = O.getParentNode();
                    return O.getName() === "declaration" && T(me) ? me : null;
                }
                var C = $([
                    "BooleanLiteral",
                    "DirectiveLiteral",
                    "Literal",
                    "NullLiteral",
                    "NumericLiteral",
                    "BigIntLiteral",
                    "DecimalLiteral",
                    "RegExpLiteral",
                    "StringLiteral",
                    "TemplateLiteral",
                    "TSTypeLiteral",
                    "JSXText"
                ]);
                function o(O) {
                    return O.type === "NumericLiteral" || O.type === "Literal" && typeof O.value == "number";
                }
                function d(O) {
                    return O.type === "UnaryExpression" && (O.operator === "+" || O.operator === "-") && o(O.argument);
                }
                function v(O) {
                    return O.type === "StringLiteral" || O.type === "Literal" && typeof O.value == "string";
                }
                var S = $([
                    "ObjectTypeAnnotation",
                    "TSTypeLiteral",
                    "TSMappedType"
                ]), b = $([
                    "FunctionExpression",
                    "ArrowFunctionExpression"
                ]);
                function B(O) {
                    return O.type === "FunctionExpression" || O.type === "ArrowFunctionExpression" && O.body.type === "BlockStatement";
                }
                function k(O) {
                    return de(O) && O.callee.type === "Identifier" && [
                        "async",
                        "inject",
                        "fakeAsync",
                        "waitForAsync"
                    ].includes(O.callee.name);
                }
                var M = $([
                    "JSXElement",
                    "JSXFragment"
                ]);
                function R(O, me) {
                    if (O.parentParser !== "markdown" && O.parentParser !== "mdx") return !1;
                    let _e = me.getNode();
                    if (!_e.expression || !M(_e.expression)) return !1;
                    let He = me.getParentNode();
                    return He.type === "Program" && He.body.length === 1;
                }
                function q(O) {
                    return O.kind === "get" || O.kind === "set";
                }
                function J(O) {
                    return q(O) || h(O, O.value);
                }
                function L(O) {
                    return (O.type === "ObjectTypeProperty" || O.type === "ObjectTypeInternalSlot") && O.value.type === "FunctionTypeAnnotation" && !O.static && !J(O);
                }
                function Q(O) {
                    return (O.type === "TypeAnnotation" || O.type === "TSTypeAnnotation") && O.typeAnnotation.type === "FunctionTypeAnnotation" && !O.static && !h(O, O.typeAnnotation);
                }
                var V = $([
                    "BinaryExpression",
                    "LogicalExpression",
                    "NGPipeExpression"
                ]);
                function j(O) {
                    return ue(O) || O.type === "BindExpression" && Boolean(O.object);
                }
                var Y = new Set([
                    "AnyTypeAnnotation",
                    "TSAnyKeyword",
                    "NullLiteralTypeAnnotation",
                    "TSNullKeyword",
                    "ThisTypeAnnotation",
                    "TSThisType",
                    "NumberTypeAnnotation",
                    "TSNumberKeyword",
                    "VoidTypeAnnotation",
                    "TSVoidKeyword",
                    "BooleanTypeAnnotation",
                    "TSBooleanKeyword",
                    "BigIntTypeAnnotation",
                    "TSBigIntKeyword",
                    "SymbolTypeAnnotation",
                    "TSSymbolKeyword",
                    "StringTypeAnnotation",
                    "TSStringKeyword",
                    "BooleanLiteralTypeAnnotation",
                    "StringLiteralTypeAnnotation",
                    "BigIntLiteralTypeAnnotation",
                    "NumberLiteralTypeAnnotation",
                    "TSLiteralType",
                    "TSTemplateLiteralType",
                    "EmptyTypeAnnotation",
                    "MixedTypeAnnotation",
                    "TSNeverKeyword",
                    "TSObjectKeyword",
                    "TSUndefinedKeyword",
                    "TSUnknownKeyword"
                ]);
                function ie(O) {
                    return O ? !!((O.type === "GenericTypeAnnotation" || O.type === "TSTypeReference") && !O.typeParameters || Y.has(O.type)) : !1;
                }
                function ee(O) {
                    let me = /^(?:before|after)(?:Each|All)$/;
                    return O.callee.type === "Identifier" && me.test(O.callee.name) && O.arguments.length === 1;
                }
                var ce = [
                    "it",
                    "it.only",
                    "it.skip",
                    "describe",
                    "describe.only",
                    "describe.skip",
                    "test",
                    "test.only",
                    "test.skip",
                    "test.step",
                    "test.describe",
                    "test.describe.only",
                    "test.describe.parallel",
                    "test.describe.parallel.only",
                    "test.describe.serial",
                    "test.describe.serial.only",
                    "skip",
                    "xit",
                    "xdescribe",
                    "xtest",
                    "fit",
                    "fdescribe",
                    "ftest"
                ];
                function W(O) {
                    return c(O, ce);
                }
                function K(O, me) {
                    if (O.type !== "CallExpression") return !1;
                    if (O.arguments.length === 1) {
                        if (k(O) && me && K(me)) return b(O.arguments[0]);
                        if (ee(O)) return k(O.arguments[0]);
                    } else if ((O.arguments.length === 2 || O.arguments.length === 3) && (O.arguments[0].type === "TemplateLiteral" || v(O.arguments[0])) && W(O.callee)) return O.arguments[2] && !o(O.arguments[2]) ? !1 : (O.arguments.length === 2 ? b(O.arguments[1]) : B(O.arguments[1]) && ve(O.arguments[1]).length <= 1) || k(O.arguments[1]);
                    return !1;
                }
                var de = $([
                    "CallExpression",
                    "OptionalCallExpression"
                ]), ue = $([
                    "MemberExpression",
                    "OptionalMemberExpression"
                ]);
                function Fe(O) {
                    let me = "expressions";
                    O.type === "TSTemplateLiteralType" && (me = "types");
                    let _e = O[me];
                    return _e.length === 0 ? !1 : _e.every((He)=>{
                        if (Me(He)) return !1;
                        if (He.type === "Identifier" || He.type === "ThisExpression") return !0;
                        if (ue(He)) {
                            let Ge = He;
                            for(; ue(Ge);)if (Ge.property.type !== "Identifier" && Ge.property.type !== "Literal" && Ge.property.type !== "StringLiteral" && Ge.property.type !== "NumericLiteral" || (Ge = Ge.object, Me(Ge))) return !1;
                            return Ge.type === "Identifier" || Ge.type === "ThisExpression";
                        }
                        return !1;
                    });
                }
                function z(O, me) {
                    return O === "+" || O === "-" ? O + me : me;
                }
                function U(O, me) {
                    let _e = p(me), He = n(O, y(me));
                    return He !== !1 && O.slice(_e, _e + 2) === "/*" && O.slice(He, He + 2) === "*/";
                }
                function Z(O, me) {
                    return M(me) ? Oe(me) : Me(me, Te.Leading, (_e)=>a(O, y(_e)));
                }
                function se(O, me) {
                    return me.parser !== "json" && v(O.key) && oe(O.key).slice(1, -1) === O.key.value && (t(O.key.value) && !(me.parser === "babel-ts" && O.type === "ClassProperty" || me.parser === "typescript" && O.type === "PropertyDefinition") || fe(O.key.value) && String(Number(O.key.value)) === O.key.value && (me.parser === "babel" || me.parser === "acorn" || me.parser === "espree" || me.parser === "meriyah" || me.parser === "__babel_estree"));
                }
                function fe(O) {
                    return /^(?:\d+|\d+\.\d+)$/.test(O);
                }
                function ge(O, me) {
                    let _e = /^[fx]?(?:describe|it|test)$/;
                    return me.type === "TaggedTemplateExpression" && me.quasi === O && me.tag.type === "MemberExpression" && me.tag.property.type === "Identifier" && me.tag.property.name === "each" && (me.tag.object.type === "Identifier" && _e.test(me.tag.object.name) || me.tag.object.type === "MemberExpression" && me.tag.object.property.type === "Identifier" && (me.tag.object.property.name === "only" || me.tag.object.property.name === "skip") && me.tag.object.object.type === "Identifier" && _e.test(me.tag.object.object.name));
                }
                function he(O) {
                    return O.quasis.some((me)=>me.value.raw.includes(`
`));
                }
                function we(O, me) {
                    return (O.type === "TemplateLiteral" && he(O) || O.type === "TaggedTemplateExpression" && he(O.quasi)) && !a(me, p(O), {
                        backwards: !0
                    });
                }
                function ke(O) {
                    if (!Me(O)) return !1;
                    let me = s(ae(O, Te.Dangling));
                    return me && !g(me);
                }
                function Re(O) {
                    if (O.length <= 1) return !1;
                    let me = 0;
                    for (let _e of O)if (b(_e)) {
                        if (me += 1, me > 1) return !0;
                    } else if (de(_e)) {
                        for (let He of _e.arguments)if (b(He)) return !0;
                    }
                    return !1;
                }
                function Ne(O) {
                    let me = O.getValue(), _e = O.getParentNode();
                    return de(me) && de(_e) && _e.callee === me && me.arguments.length > _e.arguments.length && _e.arguments.length > 0;
                }
                function Pe(O, me) {
                    if (me >= 2) return !1;
                    let _e = (Qe)=>Pe(Qe, me + 1), He = O.type === "Literal" && "regex" in O && O.regex.pattern || O.type === "RegExpLiteral" && O.pattern;
                    if (He && l(He) > 5) return !1;
                    if (O.type === "Literal" || O.type === "BigIntLiteral" || O.type === "DecimalLiteral" || O.type === "BooleanLiteral" || O.type === "NullLiteral" || O.type === "NumericLiteral" || O.type === "RegExpLiteral" || O.type === "StringLiteral" || O.type === "Identifier" || O.type === "ThisExpression" || O.type === "Super" || O.type === "PrivateName" || O.type === "PrivateIdentifier" || O.type === "ArgumentPlaceholder" || O.type === "Import") return !0;
                    if (O.type === "TemplateLiteral") return O.quasis.every((Qe)=>!Qe.value.raw.includes(`
`)) && O.expressions.every(_e);
                    if (O.type === "ObjectExpression") return O.properties.every((Qe)=>!Qe.computed && (Qe.shorthand || Qe.value && _e(Qe.value)));
                    if (O.type === "ArrayExpression") return O.elements.every((Qe)=>Qe === null || _e(Qe));
                    if (tt(O)) return (O.type === "ImportExpression" || Pe(O.callee, me)) && Ye(O).every(_e);
                    if (ue(O)) return Pe(O.object, me) && Pe(O.property, me);
                    let Ge = {
                        "!": !0,
                        "-": !0,
                        "+": !0,
                        "~": !0
                    };
                    if (O.type === "UnaryExpression" && Ge[O.operator]) return Pe(O.argument, me);
                    let it = {
                        "++": !0,
                        "--": !0
                    };
                    return O.type === "UpdateExpression" && it[O.operator] ? Pe(O.argument, me) : O.type === "TSNonNullExpression" ? Pe(O.expression, me) : !1;
                }
                function oe(O) {
                    var me, _e;
                    return (me = (_e = O.extra) === null || _e === void 0 ? void 0 : _e.raw) !== null && me !== void 0 ? me : O.raw;
                }
                function H(O) {
                    return O;
                }
                function pe(O) {
                    return O.filepath && /\.tsx$/i.test(O.filepath);
                }
                function X(O) {
                    let me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
                    return O.trailingComma === "es5" && me === "es5" || O.trailingComma === "all" && (me === "all" || me === "es5");
                }
                function le(O, me) {
                    switch(O.type){
                        case "BinaryExpression":
                        case "LogicalExpression":
                        case "AssignmentExpression":
                        case "NGPipeExpression":
                            return le(O.left, me);
                        case "MemberExpression":
                        case "OptionalMemberExpression":
                            return le(O.object, me);
                        case "TaggedTemplateExpression":
                            return O.tag.type === "FunctionExpression" ? !1 : le(O.tag, me);
                        case "CallExpression":
                        case "OptionalCallExpression":
                            return O.callee.type === "FunctionExpression" ? !1 : le(O.callee, me);
                        case "ConditionalExpression":
                            return le(O.test, me);
                        case "UpdateExpression":
                            return !O.prefix && le(O.argument, me);
                        case "BindExpression":
                            return O.object && le(O.object, me);
                        case "SequenceExpression":
                            return le(O.expressions[0], me);
                        case "TSSatisfiesExpression":
                        case "TSAsExpression":
                        case "TSNonNullExpression":
                            return le(O.expression, me);
                        default:
                            return me(O);
                    }
                }
                var Ae = {
                    "==": !0,
                    "!=": !0,
                    "===": !0,
                    "!==": !0
                }, Ee = {
                    "*": !0,
                    "/": !0,
                    "%": !0
                }, De = {
                    ">>": !0,
                    ">>>": !0,
                    "<<": !0
                };
                function A(O, me) {
                    return !(re(me) !== re(O) || O === "**" || Ae[O] && Ae[me] || me === "%" && Ee[O] || O === "%" && Ee[me] || me !== O && Ee[me] && Ee[O] || De[O] && De[me]);
                }
                var G = new Map([
                    [
                        "|>"
                    ],
                    [
                        "??"
                    ],
                    [
                        "||"
                    ],
                    [
                        "&&"
                    ],
                    [
                        "|"
                    ],
                    [
                        "^"
                    ],
                    [
                        "&"
                    ],
                    [
                        "==",
                        "===",
                        "!=",
                        "!=="
                    ],
                    [
                        "<",
                        ">",
                        "<=",
                        ">=",
                        "in",
                        "instanceof"
                    ],
                    [
                        ">>",
                        "<<",
                        ">>>"
                    ],
                    [
                        "+",
                        "-"
                    ],
                    [
                        "*",
                        "/",
                        "%"
                    ],
                    [
                        "**"
                    ]
                ].flatMap((O, me)=>O.map((_e)=>[
                            _e,
                            me
                        ])));
                function re(O) {
                    return G.get(O);
                }
                function ye(O) {
                    return Boolean(De[O]) || O === "|" || O === "^" || O === "&";
                }
                function Ce(O) {
                    var me;
                    if (O.rest) return !0;
                    let _e = ve(O);
                    return ((me = s(_e)) === null || me === void 0 ? void 0 : me.type) === "RestElement";
                }
                var Be = new WeakMap;
                function ve(O) {
                    if (Be.has(O)) return Be.get(O);
                    let me = [];
                    return O.this && me.push(O.this), Array.isArray(O.parameters) ? me.push(...O.parameters) : Array.isArray(O.params) && me.push(...O.params), O.rest && me.push(O.rest), Be.set(O, me), me;
                }
                function ze(O, me) {
                    let _e = O.getValue(), He = 0, Ge = (it)=>me(it, He++);
                    _e.this && O.call(Ge, "this"), Array.isArray(_e.parameters) ? O.each(Ge, "parameters") : Array.isArray(_e.params) && O.each(Ge, "params"), _e.rest && O.call(Ge, "rest");
                }
                var be = new WeakMap;
                function Ye(O) {
                    if (be.has(O)) return be.get(O);
                    let me = O.arguments;
                    return O.type === "ImportExpression" && (me = [
                        O.source
                    ], O.attributes && me.push(O.attributes)), be.set(O, me), me;
                }
                function Se(O, me) {
                    let _e = O.getValue();
                    _e.type === "ImportExpression" ? (O.call((He)=>me(He, 0), "source"), _e.attributes && O.call((He)=>me(He, 1), "attributes")) : O.each(me, "arguments");
                }
                function Ie(O) {
                    return O.value.trim() === "prettier-ignore" && !O.unignore;
                }
                function Oe(O) {
                    return O && (O.prettierIgnore || Me(O, Te.PrettierIgnore));
                }
                function Je(O) {
                    let me = O.getValue();
                    return Oe(me);
                }
                var Te = {
                    Leading: 2,
                    Trailing: 4,
                    Dangling: 8,
                    Block: 16,
                    Line: 32,
                    PrettierIgnore: 64,
                    First: 128,
                    Last: 256
                }, je = (O, me)=>{
                    if (typeof O == "function" && (me = O, O = 0), O || me) return (_e, He, Ge)=>!(O & Te.Leading && !_e.leading || O & Te.Trailing && !_e.trailing || O & Te.Dangling && (_e.leading || _e.trailing) || O & Te.Block && !g(_e) || O & Te.Line && !D(_e) || O & Te.First && He !== 0 || O & Te.Last && He !== Ge.length - 1 || O & Te.PrettierIgnore && !Ie(_e) || me && !me(_e));
                };
                function Me(O, me, _e) {
                    if (!u(O == null ? void 0 : O.comments)) return !1;
                    let He = je(me, _e);
                    return He ? O.comments.some(He) : !0;
                }
                function ae(O, me, _e) {
                    if (!Array.isArray(O == null ? void 0 : O.comments)) return [];
                    let He = je(me, _e);
                    return He ? O.comments.filter(He) : O.comments;
                }
                var nt = (O, me)=>{
                    let { originalText: _e } = me;
                    return i(_e, y(O));
                };
                function tt(O) {
                    return de(O) || O.type === "NewExpression" || O.type === "ImportExpression";
                }
                function Ve(O) {
                    return O && (O.type === "ObjectProperty" || O.type === "Property" && !O.method && O.kind === "init");
                }
                function We(O) {
                    return Boolean(O.__isUsingHackPipeline);
                }
                var Xe = Symbol("ifWithoutBlockAndSameLineComment");
                function st(O) {
                    return O.type === "TSAsExpression" || O.type === "TSSatisfiesExpression";
                }
                r.exports = {
                    getFunctionParameters: ve,
                    iterateFunctionParametersPath: ze,
                    getCallArguments: Ye,
                    iterateCallArgumentsPath: Se,
                    hasRestParameter: Ce,
                    getLeftSide: I,
                    getLeftSidePathName: P,
                    getParentExportDeclaration: m,
                    getTypeScriptMappedTypeModifier: z,
                    hasFlowAnnotationComment: E,
                    hasFlowShorthandAnnotationComment: w,
                    hasLeadingOwnLineComment: Z,
                    hasNakedLeftSide: x,
                    hasNode: N,
                    hasIgnoreComment: Je,
                    hasNodeIgnoreComment: Oe,
                    identity: H,
                    isBinaryish: V,
                    isCallLikeExpression: tt,
                    isEnabledHackPipeline: We,
                    isLineComment: D,
                    isPrettierIgnoreComment: Ie,
                    isCallExpression: de,
                    isMemberExpression: ue,
                    isExportDeclaration: T,
                    isFlowAnnotationComment: U,
                    isFunctionCompositionArgs: Re,
                    isFunctionNotation: J,
                    isFunctionOrArrowExpression: b,
                    isGetterOrSetter: q,
                    isJestEachTemplateLiteral: ge,
                    isJsxNode: M,
                    isLiteral: C,
                    isLongCurriedCallExpression: Ne,
                    isSimpleCallArgument: Pe,
                    isMemberish: j,
                    isNumericLiteral: o,
                    isSignedNumericLiteral: d,
                    isObjectProperty: Ve,
                    isObjectType: S,
                    isObjectTypePropertyAFunction: L,
                    isSimpleType: ie,
                    isSimpleNumber: fe,
                    isSimpleTemplateLiteral: Fe,
                    isStringLiteral: v,
                    isStringPropSafeToUnquote: se,
                    isTemplateOnItsOwnLine: we,
                    isTestCall: K,
                    isTheOnlyJsxElementInMarkdown: R,
                    isTSXFile: pe,
                    isTypeAnnotationAFunction: Q,
                    isNextLineEmpty: nt,
                    needsHardlineAfterDanglingComment: ke,
                    rawText: oe,
                    shouldPrintComma: X,
                    isBitwiseOperator: ye,
                    shouldFlatten: A,
                    startsWithNoLookaheadToken: le,
                    getPrecedence: re,
                    hasComment: Me,
                    getComments: ae,
                    CommentCheckFlags: Te,
                    markerForIfWithoutBlockAndSameLineComment: Xe,
                    isTSTypeExpression: st
                };
            }
        }), jt = te({
            "src/language-js/print/template-literal.js" (e, r) {
                "use strict";
                ne();
                var t = lt(), { getStringWidth: s, getIndentSize: a } = Ue(), { builders: { join: n, hardline: u, softline: i, group: l, indent: p, align: y, lineSuffixBoundary: h, addAlignmentToDoc: g }, printer: { printDocToString: c }, utils: { mapDoc: f } } = qe(), { isBinaryish: F, isJestEachTemplateLiteral: _, isSimpleTemplateLiteral: w, hasComment: E, isMemberExpression: N, isTSTypeExpression: x } = Ke();
                function I(C, o, d) {
                    let v = C.getValue();
                    if (v.type === "TemplateLiteral" && _(v, C.getParentNode())) {
                        let R = P(C, d, o);
                        if (R) return R;
                    }
                    let b = "expressions";
                    v.type === "TSTemplateLiteralType" && (b = "types");
                    let B = [], k = C.map(o, b), M = w(v);
                    return M && (k = k.map((R)=>c(R, Object.assign(Object.assign({}, d), {}, {
                            printWidth: Number.POSITIVE_INFINITY
                        })).formatted)), B.push(h, "`"), C.each((R)=>{
                        let q = R.getName();
                        if (B.push(o()), q < k.length) {
                            let { tabWidth: J } = d, L = R.getValue(), Q = a(L.value.raw, J), V = k[q];
                            if (!M) {
                                let Y = v[b][q];
                                (E(Y) || N(Y) || Y.type === "ConditionalExpression" || Y.type === "SequenceExpression" || x(Y) || F(Y)) && (V = [
                                    p([
                                        i,
                                        V
                                    ]),
                                    i
                                ]);
                            }
                            let j = Q === 0 && L.value.raw.endsWith(`
`) ? y(Number.NEGATIVE_INFINITY, V) : g(V, Q, J);
                            B.push(l([
                                "${",
                                j,
                                h,
                                "}"
                            ]));
                        }
                    }, "quasis"), B.push("`"), B;
                }
                function P(C, o, d) {
                    let v = C.getNode(), S = v.quasis[0].value.raw.trim().split(/\s*\|\s*/);
                    if (S.length > 1 || S.some((b)=>b.length > 0)) {
                        o.__inJestEach = !0;
                        let b = C.map(d, "expressions");
                        o.__inJestEach = !1;
                        let B = [], k = b.map((L)=>"${" + c(L, Object.assign(Object.assign({}, o), {}, {
                                printWidth: Number.POSITIVE_INFINITY,
                                endOfLine: "lf"
                            })).formatted + "}"), M = [
                            {
                                hasLineBreak: !1,
                                cells: []
                            }
                        ];
                        for(let L = 1; L < v.quasis.length; L++){
                            let Q = t(M), V = k[L - 1];
                            Q.cells.push(V), V.includes(`
`) && (Q.hasLineBreak = !0), v.quasis[L].value.raw.includes(`
`) && M.push({
                                hasLineBreak: !1,
                                cells: []
                            });
                        }
                        let R = Math.max(S.length, ...M.map((L)=>L.cells.length)), q = Array.from({
                            length: R
                        }).fill(0), J = [
                            {
                                cells: S
                            },
                            ...M.filter((L)=>L.cells.length > 0)
                        ];
                        for (let { cells: L } of J.filter((Q)=>!Q.hasLineBreak))for (let [Q, V] of L.entries())q[Q] = Math.max(q[Q], s(V));
                        return B.push(h, "`", p([
                            u,
                            n(u, J.map((L)=>n(" | ", L.cells.map((Q, V)=>L.hasLineBreak ? Q : Q + " ".repeat(q[V] - s(Q))))))
                        ]), u, "`"), B;
                    }
                }
                function $(C, o) {
                    let d = C.getValue(), v = o();
                    return E(d) && (v = l([
                        p([
                            i,
                            v
                        ]),
                        i
                    ])), [
                        "${",
                        v,
                        h,
                        "}"
                    ];
                }
                function D(C, o) {
                    return C.map((d)=>$(d, o), "expressions");
                }
                function T(C, o) {
                    return f(C, (d)=>typeof d == "string" ? o ? d.replace(/(\\*)`/g, "$1$1\\`") : m(d) : d);
                }
                function m(C) {
                    return C.replace(/([\\`]|\${)/g, "\\$1");
                }
                r.exports = {
                    printTemplateLiteral: I,
                    printTemplateExpressions: D,
                    escapeTemplateCharacters: T,
                    uncookTemplateElementValue: m
                };
            }
        }), Ym = te({
            "src/language-js/embed/markdown.js" (e, r) {
                "use strict";
                ne();
                var { builders: { indent: t, softline: s, literalline: a, dedentToRoot: n } } = qe(), { escapeTemplateCharacters: u } = jt();
                function i(p, y, h) {
                    let c = p.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (w, E)=>"\\".repeat(E.length / 2) + "`"), f = l(c), F = f !== "";
                    F && (c = c.replace(new RegExp(`^${f}`, "gm"), ""));
                    let _ = u(h(c, {
                        parser: "markdown",
                        __inJsTemplate: !0
                    }, {
                        stripTrailingHardline: !0
                    }), !0);
                    return [
                        "`",
                        F ? t([
                            s,
                            _
                        ]) : [
                            a,
                            n(_)
                        ],
                        s,
                        "`"
                    ];
                }
                function l(p) {
                    let y = p.match(/^([^\S\n]*)\S/m);
                    return y === null ? "" : y[1];
                }
                r.exports = i;
            }
        }), Qm = te({
            "src/language-js/embed/css.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t } = Ue(), { builders: { indent: s, hardline: a, softline: n }, utils: { mapDoc: u, replaceEndOfLine: i, cleanDoc: l } } = qe(), { printTemplateExpressions: p } = jt();
                function y(c, f, F) {
                    let _ = c.getValue(), w = _.quasis.map((P)=>P.value.raw), E = 0, N = w.reduce((P, $, D)=>D === 0 ? $ : P + "@prettier-placeholder-" + E++ + "-id" + $, ""), x = F(N, {
                        parser: "scss"
                    }, {
                        stripTrailingHardline: !0
                    }), I = p(c, f);
                    return h(x, _, I);
                }
                function h(c, f, F) {
                    if (f.quasis.length === 1 && !f.quasis[0].value.raw.trim()) return "``";
                    let w = g(c, F);
                    if (!w) throw new Error("Couldn't insert all the expressions");
                    return [
                        "`",
                        s([
                            a,
                            w
                        ]),
                        n,
                        "`"
                    ];
                }
                function g(c, f) {
                    if (!t(f)) return c;
                    let F = 0, _ = u(l(c), (w)=>typeof w != "string" || !w.includes("@prettier-placeholder") ? w : w.split(/@prettier-placeholder-(\d+)-id/).map((E, N)=>N % 2 === 0 ? i(E) : (F++, f[E])));
                    return f.length === F ? _ : null;
                }
                r.exports = y;
            }
        }), Zm = te({
            "src/language-js/embed/graphql.js" (e, r) {
                "use strict";
                ne();
                var { builders: { indent: t, join: s, hardline: a } } = qe(), { escapeTemplateCharacters: n, printTemplateExpressions: u } = jt();
                function i(p, y, h) {
                    let g = p.getValue(), c = g.quasis.length;
                    if (c === 1 && g.quasis[0].value.raw.trim() === "") return "``";
                    let f = u(p, y), F = [];
                    for(let _ = 0; _ < c; _++){
                        let w = g.quasis[_], E = _ === 0, N = _ === c - 1, x = w.value.cooked, I = x.split(`
`), P = I.length, $ = f[_], D = P > 2 && I[0].trim() === "" && I[1].trim() === "", T = P > 2 && I[P - 1].trim() === "" && I[P - 2].trim() === "", m = I.every((o)=>/^\s*(?:#[^\n\r]*)?$/.test(o));
                        if (!N && /#[^\n\r]*$/.test(I[P - 1])) return null;
                        let C = null;
                        m ? C = l(I) : C = h(x, {
                            parser: "graphql"
                        }, {
                            stripTrailingHardline: !0
                        }), C ? (C = n(C, !1), !E && D && F.push(""), F.push(C), !N && T && F.push("")) : !E && !N && D && F.push(""), $ && F.push($);
                    }
                    return [
                        "`",
                        t([
                            a,
                            s(a, F)
                        ]),
                        a,
                        "`"
                    ];
                }
                function l(p) {
                    let y = [], h = !1, g = p.map((c)=>c.trim());
                    for (let [c, f] of g.entries())f !== "" && (g[c - 1] === "" && h ? y.push([
                        a,
                        f
                    ]) : y.push(f), h = !0);
                    return y.length === 0 ? null : s(a, y);
                }
                r.exports = i;
            }
        }), ed = te({
            "src/language-js/embed/html.js" (e, r) {
                "use strict";
                ne();
                var { builders: { indent: t, line: s, hardline: a, group: n }, utils: { mapDoc: u } } = qe(), { printTemplateExpressions: i, uncookTemplateElementValue: l } = jt(), p = 0;
                function y(h, g, c, f, F) {
                    let { parser: _ } = F, w = h.getValue(), E = p;
                    p = p + 1 >>> 0;
                    let N = (d)=>`PRETTIER_HTML_PLACEHOLDER_${d}_${E}_IN_JS`, x = w.quasis.map((d, v, S)=>v === S.length - 1 ? d.value.cooked : d.value.cooked + N(v)).join(""), I = i(h, g);
                    if (I.length === 0 && x.trim().length === 0) return "``";
                    let P = new RegExp(N("(\\d+)"), "g"), $ = 0, D = c(x, {
                        parser: _,
                        __onHtmlRoot (d) {
                            $ = d.children.length;
                        }
                    }, {
                        stripTrailingHardline: !0
                    }), T = u(D, (d)=>{
                        if (typeof d != "string") return d;
                        let v = [], S = d.split(P);
                        for(let b = 0; b < S.length; b++){
                            let B = S[b];
                            if (b % 2 === 0) {
                                B && (B = l(B), f.__embeddedInHtml && (B = B.replace(/<\/(script)\b/gi, "<\\/$1")), v.push(B));
                                continue;
                            }
                            let k = Number(B);
                            v.push(I[k]);
                        }
                        return v;
                    }), m = /^\s/.test(x) ? " " : "", C = /\s$/.test(x) ? " " : "", o = f.htmlWhitespaceSensitivity === "ignore" ? a : m && C ? s : null;
                    return n(o ? [
                        "`",
                        t([
                            o,
                            n(T)
                        ]),
                        o,
                        "`"
                    ] : [
                        "`",
                        m,
                        $ > 1 ? t(n(T)) : n(T),
                        C,
                        "`"
                    ]);
                }
                r.exports = y;
            }
        }), td = te({
            "src/language-js/embed.js" (e, r) {
                "use strict";
                ne();
                var { hasComment: t, CommentCheckFlags: s, isObjectProperty: a } = Ke(), n = Ym(), u = Qm(), i = Zm(), l = ed();
                function p(D) {
                    if (g(D) || _(D) || w(D) || c(D)) return "css";
                    if (x(D)) return "graphql";
                    if (P(D)) return "html";
                    if (f(D)) return "angular";
                    if (h(D)) return "markdown";
                }
                function y(D, T, m, C) {
                    let o = D.getValue();
                    if (o.type !== "TemplateLiteral" || $(o)) return;
                    let d = p(D);
                    if (d) {
                        if (d === "markdown") return n(D, T, m);
                        if (d === "css") return u(D, T, m);
                        if (d === "graphql") return i(D, T, m);
                        if (d === "html" || d === "angular") return l(D, T, m, C, {
                            parser: d
                        });
                    }
                }
                function h(D) {
                    let T = D.getValue(), m = D.getParentNode();
                    return m && m.type === "TaggedTemplateExpression" && T.quasis.length === 1 && m.tag.type === "Identifier" && (m.tag.name === "md" || m.tag.name === "markdown");
                }
                function g(D) {
                    let T = D.getValue(), m = D.getParentNode(), C = D.getParentNode(1);
                    return C && T.quasis && m.type === "JSXExpressionContainer" && C.type === "JSXElement" && C.openingElement.name.name === "style" && C.openingElement.attributes.some((o)=>o.name.name === "jsx") || m && m.type === "TaggedTemplateExpression" && m.tag.type === "Identifier" && m.tag.name === "css" || m && m.type === "TaggedTemplateExpression" && m.tag.type === "MemberExpression" && m.tag.object.name === "css" && (m.tag.property.name === "global" || m.tag.property.name === "resolve");
                }
                function c(D) {
                    return D.match((T)=>T.type === "TemplateLiteral", (T, m)=>T.type === "ArrayExpression" && m === "elements", (T, m)=>a(T) && T.key.type === "Identifier" && T.key.name === "styles" && m === "value", ...F);
                }
                function f(D) {
                    return D.match((T)=>T.type === "TemplateLiteral", (T, m)=>a(T) && T.key.type === "Identifier" && T.key.name === "template" && m === "value", ...F);
                }
                var F = [
                    (D, T)=>D.type === "ObjectExpression" && T === "properties",
                    (D, T)=>D.type === "CallExpression" && D.callee.type === "Identifier" && D.callee.name === "Component" && T === "arguments",
                    (D, T)=>D.type === "Decorator" && T === "expression"
                ];
                function _(D) {
                    let T = D.getParentNode();
                    if (!T || T.type !== "TaggedTemplateExpression") return !1;
                    let m = T.tag.type === "ParenthesizedExpression" ? T.tag.expression : T.tag;
                    switch(m.type){
                        case "MemberExpression":
                            return E(m.object) || N(m);
                        case "CallExpression":
                            return E(m.callee) || m.callee.type === "MemberExpression" && (m.callee.object.type === "MemberExpression" && (E(m.callee.object.object) || N(m.callee.object)) || m.callee.object.type === "CallExpression" && E(m.callee.object.callee));
                        case "Identifier":
                            return m.name === "css";
                        default:
                            return !1;
                    }
                }
                function w(D) {
                    let T = D.getParentNode(), m = D.getParentNode(1);
                    return m && T.type === "JSXExpressionContainer" && m.type === "JSXAttribute" && m.name.type === "JSXIdentifier" && m.name.name === "css";
                }
                function E(D) {
                    return D.type === "Identifier" && D.name === "styled";
                }
                function N(D) {
                    return /^[A-Z]/.test(D.object.name) && D.property.name === "extend";
                }
                function x(D) {
                    let T = D.getValue(), m = D.getParentNode();
                    return I(T, "GraphQL") || m && (m.type === "TaggedTemplateExpression" && (m.tag.type === "MemberExpression" && m.tag.object.name === "graphql" && m.tag.property.name === "experimental" || m.tag.type === "Identifier" && (m.tag.name === "gql" || m.tag.name === "graphql")) || m.type === "CallExpression" && m.callee.type === "Identifier" && m.callee.name === "graphql");
                }
                function I(D, T) {
                    return t(D, s.Block | s.Leading, (m)=>{
                        let { value: C } = m;
                        return C === ` ${T} `;
                    });
                }
                function P(D) {
                    return I(D.getValue(), "HTML") || D.match((T)=>T.type === "TemplateLiteral", (T, m)=>T.type === "TaggedTemplateExpression" && T.tag.type === "Identifier" && T.tag.name === "html" && m === "quasi");
                }
                function $(D) {
                    let { quasis: T } = D;
                    return T.some((m)=>{
                        let { value: { cooked: C } } = m;
                        return C === null;
                    });
                }
                r.exports = y;
            }
        }), rd = te({
            "src/language-js/clean.js" (e, r) {
                "use strict";
                ne();
                var t = Pt(), s = new Set([
                    "range",
                    "raw",
                    "comments",
                    "leadingComments",
                    "trailingComments",
                    "innerComments",
                    "extra",
                    "start",
                    "end",
                    "loc",
                    "flags",
                    "errors",
                    "tokens"
                ]), a = (u)=>{
                    for (let i of u.quasis)delete i.value;
                };
                function n(u, i, l) {
                    if (u.type === "Program" && delete i.sourceType, (u.type === "BigIntLiteral" || u.type === "BigIntLiteralTypeAnnotation") && i.value && (i.value = i.value.toLowerCase()), (u.type === "BigIntLiteral" || u.type === "Literal") && i.bigint && (i.bigint = i.bigint.toLowerCase()), u.type === "DecimalLiteral" && (i.value = Number(i.value)), u.type === "Literal" && i.decimal && (i.decimal = Number(i.decimal)), u.type === "EmptyStatement" || u.type === "JSXText" || u.type === "JSXExpressionContainer" && (u.expression.type === "Literal" || u.expression.type === "StringLiteral") && u.expression.value === " ") return null;
                    if ((u.type === "Property" || u.type === "ObjectProperty" || u.type === "MethodDefinition" || u.type === "ClassProperty" || u.type === "ClassMethod" || u.type === "PropertyDefinition" || u.type === "TSDeclareMethod" || u.type === "TSPropertySignature" || u.type === "ObjectTypeProperty") && typeof u.key == "object" && u.key && (u.key.type === "Literal" || u.key.type === "NumericLiteral" || u.key.type === "StringLiteral" || u.key.type === "Identifier") && delete i.key, u.type === "JSXElement" && u.openingElement.name.name === "style" && u.openingElement.attributes.some((h)=>h.name.name === "jsx")) for (let { type: h, expression: g } of i.children)h === "JSXExpressionContainer" && g.type === "TemplateLiteral" && a(g);
                    u.type === "JSXAttribute" && u.name.name === "css" && u.value.type === "JSXExpressionContainer" && u.value.expression.type === "TemplateLiteral" && a(i.value.expression), u.type === "JSXAttribute" && u.value && u.value.type === "Literal" && /["']|&quot;|&apos;/.test(u.value.value) && (i.value.value = i.value.value.replace(/["']|&quot;|&apos;/g, '"'));
                    let p = u.expression || u.callee;
                    if (u.type === "Decorator" && p.type === "CallExpression" && p.callee.name === "Component" && p.arguments.length === 1) {
                        let h = u.expression.arguments[0].properties;
                        for (let [g, c] of i.expression.arguments[0].properties.entries())switch(h[g].key.name){
                            case "styles":
                                c.value.type === "ArrayExpression" && a(c.value.elements[0]);
                                break;
                            case "template":
                                c.value.type === "TemplateLiteral" && a(c.value);
                                break;
                        }
                    }
                    if (u.type === "TaggedTemplateExpression" && (u.tag.type === "MemberExpression" || u.tag.type === "Identifier" && (u.tag.name === "gql" || u.tag.name === "graphql" || u.tag.name === "css" || u.tag.name === "md" || u.tag.name === "markdown" || u.tag.name === "html") || u.tag.type === "CallExpression") && a(i.quasi), u.type === "TemplateLiteral") {
                        var y;
                        (((y = u.leadingComments) === null || y === void 0 ? void 0 : y.some((g)=>t(g) && [
                                "GraphQL",
                                "HTML"
                            ].some((c)=>g.value === ` ${c} `))) || l.type === "CallExpression" && l.callee.name === "graphql" || !u.leadingComments) && a(i);
                    }
                    if (u.type === "InterpreterDirective" && (i.value = i.value.trimEnd()), (u.type === "TSIntersectionType" || u.type === "TSUnionType") && u.types.length === 1) return i.types[0];
                }
                n.ignoredProperties = s, r.exports = n;
            }
        }), io = {};
        Kt(io, {
            EOL: ()=>Wn,
            arch: ()=>nd,
            cpus: ()=>Do,
            default: ()=>vo,
            endianness: ()=>ao,
            freemem: ()=>po,
            getNetworkInterfaces: ()=>ho,
            hostname: ()=>oo,
            loadavg: ()=>lo,
            networkInterfaces: ()=>yo,
            platform: ()=>ud,
            release: ()=>go,
            tmpDir: ()=>$n,
            tmpdir: ()=>Vn,
            totalmem: ()=>fo,
            type: ()=>mo,
            uptime: ()=>co
        });
        function ao() {
            if (typeof Tr > "u") {
                var e = new ArrayBuffer(2), r = new Uint8Array(e), t = new Uint16Array(e);
                if (r[0] = 1, r[1] = 2, t[0] === 258) Tr = "BE";
                else if (t[0] === 513) Tr = "LE";
                else throw new Error("unable to figure out endianess");
            }
            return Tr;
        }
        function oo() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
        }
        function lo() {
            return [];
        }
        function co() {
            return 0;
        }
        function po() {
            return Number.MAX_VALUE;
        }
        function fo() {
            return Number.MAX_VALUE;
        }
        function Do() {
            return [];
        }
        function mo() {
            return "Browser";
        }
        function go() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
        }
        function yo() {}
        function ho() {}
        function nd() {
            return "javascript";
        }
        function ud() {
            return "browser";
        }
        function $n() {
            return "/tmp";
        }
        var Tr, Vn, Wn, vo, sd = ht({
            "node-modules-polyfills:os" () {
                ne(), Vn = $n, Wn = `
`, vo = {
                    EOL: Wn,
                    tmpdir: Vn,
                    tmpDir: $n,
                    networkInterfaces: yo,
                    getNetworkInterfaces: ho,
                    release: go,
                    type: mo,
                    cpus: Do,
                    totalmem: fo,
                    freemem: po,
                    uptime: co,
                    loadavg: lo,
                    hostname: oo,
                    endianness: ao
                };
            }
        }), id = te({
            "node-modules-polyfills-commonjs:os" (e, r) {
                ne();
                var t = (sd(), ft(io));
                if (t && t.default) {
                    r.exports = t.default;
                    for(let s in t)r.exports[s] = t[s];
                } else t && (r.exports = t);
            }
        }), ad = te({
            "node_modules/detect-newline/index.js" (e, r) {
                "use strict";
                ne();
                var t = (s)=>{
                    if (typeof s != "string") throw new TypeError("Expected a string");
                    let a = s.match(/(?:\r?\n)/g) || [];
                    if (a.length === 0) return;
                    let n = a.filter((i)=>i === `\r
`).length, u = a.length - n;
                    return n > u ? `\r
` : `
`;
                };
                r.exports = t, r.exports.graceful = (s)=>typeof s == "string" && t(s) || `
`;
            }
        }), od = te({
            "node_modules/jest-docblock/build/index.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.extract = c, e.parse = F, e.parseWithComments = _, e.print = w, e.strip = f;
                function r() {
                    let N = id();
                    return r = function() {
                        return N;
                    }, N;
                }
                function t() {
                    let N = s(ad());
                    return t = function() {
                        return N;
                    }, N;
                }
                function s(N) {
                    return N && N.__esModule ? N : {
                        default: N
                    };
                }
                var a = /\*\/$/, n = /^\/\*\*?/, u = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, i = /(^|\s+)\/\/([^\r\n]*)/g, l = /^(\r?\n)+/, p = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, y = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, h = /(\r?\n|^) *\* ?/g, g = [];
                function c(N) {
                    let x = N.match(u);
                    return x ? x[0].trimLeft() : "";
                }
                function f(N) {
                    let x = N.match(u);
                    return x && x[0] ? N.substring(x[0].length) : N;
                }
                function F(N) {
                    return _(N).pragmas;
                }
                function _(N) {
                    let x = (0, t().default)(N) || r().EOL;
                    N = N.replace(n, "").replace(a, "").replace(h, "$1");
                    let I = "";
                    for(; I !== N;)I = N, N = N.replace(p, `${x}$1 $2${x}`);
                    N = N.replace(l, "").trimRight();
                    let P = Object.create(null), $ = N.replace(y, "").replace(l, "").trimRight(), D;
                    for(; D = y.exec(N);){
                        let T = D[2].replace(i, "");
                        typeof P[D[1]] == "string" || Array.isArray(P[D[1]]) ? P[D[1]] = g.concat(P[D[1]], T) : P[D[1]] = T;
                    }
                    return {
                        comments: $,
                        pragmas: P
                    };
                }
                function w(N) {
                    let { comments: x = "", pragmas: I = {} } = N, P = (0, t().default)(x) || r().EOL, $ = "/**", D = " *", T = " */", m = Object.keys(I), C = m.map((d)=>E(d, I[d])).reduce((d, v)=>d.concat(v), []).map((d)=>`${D} ${d}${P}`).join("");
                    if (!x) {
                        if (m.length === 0) return "";
                        if (m.length === 1 && !Array.isArray(I[m[0]])) {
                            let d = I[m[0]];
                            return `${$} ${E(m[0], d)[0]}${T}`;
                        }
                    }
                    let o = x.split(P).map((d)=>`${D} ${d}`).join(P) + P;
                    return $ + P + (x ? o : "") + (x && m.length ? D + P : "") + C + T;
                }
                function E(N, x) {
                    return g.concat(x).map((I)=>`@${N} ${I}`.trim());
                }
            }
        }), ld = te({
            "src/language-js/utils/get-shebang.js" (e, r) {
                "use strict";
                ne();
                function t(s) {
                    if (!s.startsWith("#!")) return "";
                    let a = s.indexOf(`
`);
                    return a === -1 ? s : s.slice(0, a);
                }
                r.exports = t;
            }
        }), Co = te({
            "src/language-js/pragma.js" (e, r) {
                "use strict";
                ne();
                var { parseWithComments: t, strip: s, extract: a, print: n } = od(), { normalizeEndOfLine: u } = Jn(), i = ld();
                function l(h) {
                    let g = i(h);
                    g && (h = h.slice(g.length + 1));
                    let c = a(h), { pragmas: f, comments: F } = t(c);
                    return {
                        shebang: g,
                        text: h,
                        pragmas: f,
                        comments: F
                    };
                }
                function p(h) {
                    let g = Object.keys(l(h).pragmas);
                    return g.includes("prettier") || g.includes("format");
                }
                function y(h) {
                    let { shebang: g, text: c, pragmas: f, comments: F } = l(h), _ = s(c), w = n({
                        pragmas: Object.assign({
                            format: ""
                        }, f),
                        comments: F.trimStart()
                    });
                    return (g ? `${g}
` : "") + u(w) + (_.startsWith(`
`) ? `
` : `

`) + _;
                }
                r.exports = {
                    hasPragma: p,
                    insertPragma: y
                };
            }
        }), cd = te({
            "src/language-js/utils/is-type-cast-comment.js" (e, r) {
                "use strict";
                ne();
                var t = Pt();
                function s(a) {
                    return t(a) && a.value[0] === "*" && /@(?:type|satisfies)\b/.test(a.value);
                }
                r.exports = s;
            }
        }), Eo = te({
            "src/language-js/comments.js" (e, r) {
                "use strict";
                ne();
                var { getLast: t, hasNewline: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a, getNextNonSpaceNonCommentCharacter: n, hasNewlineInRange: u, addLeadingComment: i, addTrailingComment: l, addDanglingComment: p, getNextNonSpaceNonCommentCharacterIndex: y, isNonEmptyArray: h } = Ue(), { getFunctionParameters: g, isPrettierIgnoreComment: c, isJsxNode: f, hasFlowShorthandAnnotationComment: F, hasFlowAnnotationComment: _, hasIgnoreComment: w, isCallLikeExpression: E, getCallArguments: N, isCallExpression: x, isMemberExpression: I, isObjectProperty: P, isLineComment: $, getComments: D, CommentCheckFlags: T, markerForIfWithoutBlockAndSameLineComment: m } = Ke(), { locStart: C, locEnd: o } = ut(), d = Pt(), v = cd();
                function S(De) {
                    return [
                        H,
                        Fe,
                        Q,
                        q,
                        J,
                        L,
                        ie,
                        he,
                        se,
                        ge,
                        we,
                        ke,
                        ce,
                        z,
                        U
                    ].some((A)=>A(De));
                }
                function b(De) {
                    return [
                        R,
                        Fe,
                        V,
                        we,
                        q,
                        J,
                        L,
                        ie,
                        z,
                        Z,
                        fe,
                        ge,
                        Pe,
                        U,
                        X
                    ].some((A)=>A(De));
                }
                function B(De) {
                    return [
                        H,
                        q,
                        J,
                        j,
                        ue,
                        ce,
                        ge,
                        de,
                        K,
                        pe,
                        U,
                        oe
                    ].some((A)=>A(De));
                }
                function k(De, A) {
                    let G = (De.body || De.properties).find((re)=>{
                        let { type: ye } = re;
                        return ye !== "EmptyStatement";
                    });
                    G ? i(G, A) : p(De, A);
                }
                function M(De, A) {
                    De.type === "BlockStatement" ? k(De, A) : i(De, A);
                }
                function R(De) {
                    let { comment: A, followingNode: G } = De;
                    return G && v(A) ? (i(G, A), !0) : !1;
                }
                function q(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De;
                    if ((re == null ? void 0 : re.type) !== "IfStatement" || !ye) return !1;
                    if (n(Ce, A, o) === ")") return l(G, A), !0;
                    if (G === re.consequent && ye === re.alternate) {
                        if (G.type === "BlockStatement") l(G, A);
                        else {
                            let ve = A.type === "SingleLine" || A.loc.start.line === A.loc.end.line, ze = A.loc.start.line === G.loc.start.line;
                            ve && ze ? p(G, A, m) : p(re, A);
                        }
                        return !0;
                    }
                    return ye.type === "BlockStatement" ? (k(ye, A), !0) : ye.type === "IfStatement" ? (M(ye.consequent, A), !0) : re.consequent === ye ? (i(ye, A), !0) : !1;
                }
                function J(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De;
                    return (re == null ? void 0 : re.type) !== "WhileStatement" || !ye ? !1 : n(Ce, A, o) === ")" ? (l(G, A), !0) : ye.type === "BlockStatement" ? (k(ye, A), !0) : re.body === ye ? (i(ye, A), !0) : !1;
                }
                function L(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
                    return (re == null ? void 0 : re.type) !== "TryStatement" && (re == null ? void 0 : re.type) !== "CatchClause" || !ye ? !1 : re.type === "CatchClause" && G ? (l(G, A), !0) : ye.type === "BlockStatement" ? (k(ye, A), !0) : ye.type === "TryStatement" ? (M(ye.finalizer, A), !0) : ye.type === "CatchClause" ? (M(ye.body, A), !0) : !1;
                }
                function Q(De) {
                    let { comment: A, enclosingNode: G, followingNode: re } = De;
                    return I(G) && (re == null ? void 0 : re.type) === "Identifier" ? (i(G, A), !0) : !1;
                }
                function V(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De, Be = G && !u(Ce, o(G), C(A));
                    return (!G || !Be) && ((re == null ? void 0 : re.type) === "ConditionalExpression" || (re == null ? void 0 : re.type) === "TSConditionalType") && ye ? (i(ye, A), !0) : !1;
                }
                function j(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re } = De;
                    return P(re) && re.shorthand && re.key === G && re.value.type === "AssignmentPattern" ? (l(re.value.left, A), !0) : !1;
                }
                var Y = new Set([
                    "ClassDeclaration",
                    "ClassExpression",
                    "DeclareClass",
                    "DeclareInterface",
                    "InterfaceDeclaration",
                    "TSInterfaceDeclaration"
                ]);
                function ie(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
                    if (Y.has(re == null ? void 0 : re.type)) {
                        if (h(re.decorators) && !(ye && ye.type === "Decorator")) return l(t(re.decorators), A), !0;
                        if (re.body && ye === re.body) return k(re.body, A), !0;
                        if (ye) {
                            if (re.superClass && ye === re.superClass && G && (G === re.id || G === re.typeParameters)) return l(G, A), !0;
                            for (let Ce of [
                                "implements",
                                "extends",
                                "mixins"
                            ])if (re[Ce] && ye === re[Ce][0]) return G && (G === re.id || G === re.typeParameters || G === re.superClass) ? l(G, A) : p(re, A, Ce), !0;
                        }
                    }
                    return !1;
                }
                var ee = new Set([
                    "ClassMethod",
                    "ClassProperty",
                    "PropertyDefinition",
                    "TSAbstractPropertyDefinition",
                    "TSAbstractMethodDefinition",
                    "TSDeclareMethod",
                    "MethodDefinition",
                    "ClassAccessorProperty",
                    "AccessorProperty",
                    "TSAbstractAccessorProperty"
                ]);
                function ce(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, text: ye } = De;
                    return re && G && n(ye, A, o) === "(" && (re.type === "Property" || re.type === "TSDeclareMethod" || re.type === "TSAbstractMethodDefinition") && G.type === "Identifier" && re.key === G && n(ye, G, o) !== ":" || (G == null ? void 0 : G.type) === "Decorator" && ee.has(re == null ? void 0 : re.type) ? (l(G, A), !0) : !1;
                }
                var W = new Set([
                    "FunctionDeclaration",
                    "FunctionExpression",
                    "ClassMethod",
                    "MethodDefinition",
                    "ObjectMethod"
                ]);
                function K(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, text: ye } = De;
                    return n(ye, A, o) !== "(" ? !1 : G && W.has(re == null ? void 0 : re.type) ? (l(G, A), !0) : !1;
                }
                function de(De) {
                    let { comment: A, enclosingNode: G, text: re } = De;
                    if ((G == null ? void 0 : G.type) !== "ArrowFunctionExpression") return !1;
                    let ye = y(re, A, o);
                    return ye !== !1 && re.slice(ye, ye + 2) === "=>" ? (p(G, A), !0) : !1;
                }
                function ue(De) {
                    let { comment: A, enclosingNode: G, text: re } = De;
                    return n(re, A, o) !== ")" ? !1 : G && (le(G) && g(G).length === 0 || E(G) && N(G).length === 0) ? (p(G, A), !0) : ((G == null ? void 0 : G.type) === "MethodDefinition" || (G == null ? void 0 : G.type) === "TSAbstractMethodDefinition") && g(G.value).length === 0 ? (p(G.value, A), !0) : !1;
                }
                function Fe(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye, text: Ce } = De;
                    if ((G == null ? void 0 : G.type) === "FunctionTypeParam" && (re == null ? void 0 : re.type) === "FunctionTypeAnnotation" && (ye == null ? void 0 : ye.type) !== "FunctionTypeParam" || ((G == null ? void 0 : G.type) === "Identifier" || (G == null ? void 0 : G.type) === "AssignmentPattern") && re && le(re) && n(Ce, A, o) === ")") return l(G, A), !0;
                    if ((re == null ? void 0 : re.type) === "FunctionDeclaration" && (ye == null ? void 0 : ye.type) === "BlockStatement") {
                        let Be = (()=>{
                            let ve = g(re);
                            if (ve.length > 0) return a(Ce, o(t(ve)));
                            let ze = a(Ce, o(re.id));
                            return ze !== !1 && a(Ce, ze + 1);
                        })();
                        if (C(A) > Be) return k(ye, A), !0;
                    }
                    return !1;
                }
                function z(De) {
                    let { comment: A, enclosingNode: G } = De;
                    return (G == null ? void 0 : G.type) === "LabeledStatement" ? (i(G, A), !0) : !1;
                }
                function U(De) {
                    let { comment: A, enclosingNode: G } = De;
                    return ((G == null ? void 0 : G.type) === "ContinueStatement" || (G == null ? void 0 : G.type) === "BreakStatement") && !G.label ? (l(G, A), !0) : !1;
                }
                function Z(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re } = De;
                    return x(re) && G && re.callee === G && re.arguments.length > 0 ? (i(re.arguments[0], A), !0) : !1;
                }
                function se(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
                    return (re == null ? void 0 : re.type) === "UnionTypeAnnotation" || (re == null ? void 0 : re.type) === "TSUnionType" ? (c(A) && (ye.prettierIgnore = !0, A.unignore = !0), G ? (l(G, A), !0) : !1) : (((ye == null ? void 0 : ye.type) === "UnionTypeAnnotation" || (ye == null ? void 0 : ye.type) === "TSUnionType") && c(A) && (ye.types[0].prettierIgnore = !0, A.unignore = !0), !1);
                }
                function fe(De) {
                    let { comment: A, enclosingNode: G } = De;
                    return P(G) ? (i(G, A), !0) : !1;
                }
                function ge(De) {
                    let { comment: A, enclosingNode: G, followingNode: re, ast: ye, isLastComment: Ce } = De;
                    return ye && ye.body && ye.body.length === 0 ? (Ce ? p(ye, A) : i(ye, A), !0) : (G == null ? void 0 : G.type) === "Program" && (G == null ? void 0 : G.body.length) === 0 && !h(G.directives) ? (Ce ? p(G, A) : i(G, A), !0) : (re == null ? void 0 : re.type) === "Program" && (re == null ? void 0 : re.body.length) === 0 && (G == null ? void 0 : G.type) === "ModuleExpression" ? (p(re, A), !0) : !1;
                }
                function he(De) {
                    let { comment: A, enclosingNode: G } = De;
                    return (G == null ? void 0 : G.type) === "ForInStatement" || (G == null ? void 0 : G.type) === "ForOfStatement" ? (i(G, A), !0) : !1;
                }
                function we(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, text: ye } = De;
                    if ((re == null ? void 0 : re.type) === "ImportSpecifier" || (re == null ? void 0 : re.type) === "ExportSpecifier") return i(re, A), !0;
                    let Ce = (G == null ? void 0 : G.type) === "ImportSpecifier" && (re == null ? void 0 : re.type) === "ImportDeclaration", Be = (G == null ? void 0 : G.type) === "ExportSpecifier" && (re == null ? void 0 : re.type) === "ExportNamedDeclaration";
                    return (Ce || Be) && s(ye, o(A)) ? (l(G, A), !0) : !1;
                }
                function ke(De) {
                    let { comment: A, enclosingNode: G } = De;
                    return (G == null ? void 0 : G.type) === "AssignmentPattern" ? (i(G, A), !0) : !1;
                }
                var Re = new Set([
                    "VariableDeclarator",
                    "AssignmentExpression",
                    "TypeAlias",
                    "TSTypeAliasDeclaration"
                ]), Ne = new Set([
                    "ObjectExpression",
                    "ArrayExpression",
                    "TemplateLiteral",
                    "TaggedTemplateExpression",
                    "ObjectTypeAnnotation",
                    "TSTypeLiteral"
                ]);
                function Pe(De) {
                    let { comment: A, enclosingNode: G, followingNode: re } = De;
                    return Re.has(G == null ? void 0 : G.type) && re && (Ne.has(re.type) || d(A)) ? (i(re, A), !0) : !1;
                }
                function oe(De) {
                    let { comment: A, enclosingNode: G, followingNode: re, text: ye } = De;
                    return !re && ((G == null ? void 0 : G.type) === "TSMethodSignature" || (G == null ? void 0 : G.type) === "TSDeclareFunction" || (G == null ? void 0 : G.type) === "TSAbstractMethodDefinition") && n(ye, A, o) === ";" ? (l(G, A), !0) : !1;
                }
                function H(De) {
                    let { comment: A, enclosingNode: G, followingNode: re } = De;
                    if (c(A) && (G == null ? void 0 : G.type) === "TSMappedType" && (re == null ? void 0 : re.type) === "TSTypeParameter" && re.constraint) return G.prettierIgnore = !0, A.unignore = !0, !0;
                }
                function pe(De) {
                    let { comment: A, precedingNode: G, enclosingNode: re, followingNode: ye } = De;
                    return (re == null ? void 0 : re.type) !== "TSMappedType" ? !1 : (ye == null ? void 0 : ye.type) === "TSTypeParameter" && ye.name ? (i(ye.name, A), !0) : (G == null ? void 0 : G.type) === "TSTypeParameter" && G.constraint ? (l(G.constraint, A), !0) : !1;
                }
                function X(De) {
                    let { comment: A, enclosingNode: G, followingNode: re } = De;
                    return !G || G.type !== "SwitchCase" || G.test || !re || re !== G.consequent[0] ? !1 : (re.type === "BlockStatement" && $(A) ? k(re, A) : p(G, A), !0);
                }
                function le(De) {
                    return De.type === "ArrowFunctionExpression" || De.type === "FunctionExpression" || De.type === "FunctionDeclaration" || De.type === "ObjectMethod" || De.type === "ClassMethod" || De.type === "TSDeclareFunction" || De.type === "TSCallSignatureDeclaration" || De.type === "TSConstructSignatureDeclaration" || De.type === "TSMethodSignature" || De.type === "TSConstructorType" || De.type === "TSFunctionType" || De.type === "TSDeclareMethod";
                }
                function Ae(De, A) {
                    if ((A.parser === "typescript" || A.parser === "flow" || A.parser === "acorn" || A.parser === "espree" || A.parser === "meriyah" || A.parser === "__babel_estree") && De.type === "MethodDefinition" && De.value && De.value.type === "FunctionExpression" && g(De.value).length === 0 && !De.value.returnType && !h(De.value.typeParameters) && De.value.body) return [
                        ...De.decorators || [],
                        De.key,
                        De.value.body
                    ];
                }
                function Ee(De) {
                    let A = De.getValue(), G = De.getParentNode(), re = (ye)=>_(D(ye, T.Leading)) || _(D(ye, T.Trailing));
                    return (A && (f(A) || F(A) || x(G) && re(A)) || G && (G.type === "JSXSpreadAttribute" || G.type === "JSXSpreadChild" || G.type === "UnionTypeAnnotation" || G.type === "TSUnionType" || (G.type === "ClassDeclaration" || G.type === "ClassExpression") && G.superClass === A)) && (!w(De) || G.type === "UnionTypeAnnotation" || G.type === "TSUnionType");
                }
                r.exports = {
                    handleOwnLineComment: S,
                    handleEndOfLineComment: b,
                    handleRemainingComment: B,
                    getCommentChildNodes: Ae,
                    willPrintOwnComments: Ee
                };
            }
        }), qt = te({
            "src/language-js/needs-parens.js" (e, r) {
                "use strict";
                ne();
                var t = lt(), s = Kn(), { getFunctionParameters: a, getLeftSidePathName: n, hasFlowShorthandAnnotationComment: u, hasNakedLeftSide: i, hasNode: l, isBitwiseOperator: p, startsWithNoLookaheadToken: y, shouldFlatten: h, getPrecedence: g, isCallExpression: c, isMemberExpression: f, isObjectProperty: F, isTSTypeExpression: _ } = Ke();
                function w(D, T) {
                    let m = D.getParentNode();
                    if (!m) return !1;
                    let C = D.getName(), o = D.getNode();
                    if (T.__isInHtmlInterpolation && !T.bracketSpacing && I(o) && P(D)) return !0;
                    if (E(o)) return !1;
                    if (T.parser !== "flow" && u(D.getValue())) return !0;
                    if (o.type === "Identifier") {
                        if (o.extra && o.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(o.name) || C === "left" && (o.name === "async" && !m.await || o.name === "let") && m.type === "ForOfStatement") return !0;
                        if (o.name === "let") {
                            var d;
                            let S = (d = D.findAncestor((b)=>b.type === "ForOfStatement")) === null || d === void 0 ? void 0 : d.left;
                            if (S && y(S, (b)=>b === o)) return !0;
                        }
                        if (C === "object" && o.name === "let" && m.type === "MemberExpression" && m.computed && !m.optional) {
                            let S = D.findAncestor((B)=>B.type === "ExpressionStatement" || B.type === "ForStatement" || B.type === "ForInStatement"), b = S ? S.type === "ExpressionStatement" ? S.expression : S.type === "ForStatement" ? S.init : S.left : void 0;
                            if (b && y(b, (B)=>B === o)) return !0;
                        }
                        return !1;
                    }
                    if (o.type === "ObjectExpression" || o.type === "FunctionExpression" || o.type === "ClassExpression" || o.type === "DoExpression") {
                        var v;
                        let S = (v = D.findAncestor((b)=>b.type === "ExpressionStatement")) === null || v === void 0 ? void 0 : v.expression;
                        if (S && y(S, (b)=>b === o)) return !0;
                    }
                    switch(m.type){
                        case "ParenthesizedExpression":
                            return !1;
                        case "ClassDeclaration":
                        case "ClassExpression":
                            if (C === "superClass" && (o.type === "ArrowFunctionExpression" || o.type === "AssignmentExpression" || o.type === "AwaitExpression" || o.type === "BinaryExpression" || o.type === "ConditionalExpression" || o.type === "LogicalExpression" || o.type === "NewExpression" || o.type === "ObjectExpression" || o.type === "SequenceExpression" || o.type === "TaggedTemplateExpression" || o.type === "UnaryExpression" || o.type === "UpdateExpression" || o.type === "YieldExpression" || o.type === "TSNonNullExpression")) return !0;
                            break;
                        case "ExportDefaultDeclaration":
                            return $(D, T) || o.type === "SequenceExpression";
                        case "Decorator":
                            if (C === "expression") {
                                if (f(o) && o.computed) return !0;
                                let S = !1, b = !1, B = o;
                                for(; B;)switch(B.type){
                                    case "MemberExpression":
                                        b = !0, B = B.object;
                                        break;
                                    case "CallExpression":
                                        if (b || S) return T.parser !== "typescript";
                                        S = !0, B = B.callee;
                                        break;
                                    case "Identifier":
                                        return !1;
                                    case "TaggedTemplateExpression":
                                        return T.parser !== "typescript";
                                    default:
                                        return !0;
                                }
                                return !0;
                            }
                            break;
                        case "ArrowFunctionExpression":
                            if (C === "body" && o.type !== "SequenceExpression" && y(o, (S)=>S.type === "ObjectExpression")) return !0;
                            break;
                    }
                    switch(o.type){
                        case "UpdateExpression":
                            if (m.type === "UnaryExpression") return o.prefix && (o.operator === "++" && m.operator === "+" || o.operator === "--" && m.operator === "-");
                        case "UnaryExpression":
                            switch(m.type){
                                case "UnaryExpression":
                                    return o.operator === m.operator && (o.operator === "+" || o.operator === "-");
                                case "BindExpression":
                                    return !0;
                                case "MemberExpression":
                                case "OptionalMemberExpression":
                                    return C === "object";
                                case "TaggedTemplateExpression":
                                    return !0;
                                case "NewExpression":
                                case "CallExpression":
                                case "OptionalCallExpression":
                                    return C === "callee";
                                case "BinaryExpression":
                                    return C === "left" && m.operator === "**";
                                case "TSNonNullExpression":
                                    return !0;
                                default:
                                    return !1;
                            }
                        case "BinaryExpression":
                            if (m.type === "UpdateExpression" || o.operator === "in" && N(D)) return !0;
                            if (o.operator === "|>" && o.extra && o.extra.parenthesized) {
                                let S = D.getParentNode(1);
                                if (S.type === "BinaryExpression" && S.operator === "|>") return !0;
                            }
                        case "TSTypeAssertion":
                        case "TSAsExpression":
                        case "TSSatisfiesExpression":
                        case "LogicalExpression":
                            switch(m.type){
                                case "TSSatisfiesExpression":
                                case "TSAsExpression":
                                    return !_(o);
                                case "ConditionalExpression":
                                    return _(o);
                                case "CallExpression":
                                case "NewExpression":
                                case "OptionalCallExpression":
                                    return C === "callee";
                                case "ClassExpression":
                                case "ClassDeclaration":
                                    return C === "superClass";
                                case "TSTypeAssertion":
                                case "TaggedTemplateExpression":
                                case "UnaryExpression":
                                case "JSXSpreadAttribute":
                                case "SpreadElement":
                                case "SpreadProperty":
                                case "BindExpression":
                                case "AwaitExpression":
                                case "TSNonNullExpression":
                                case "UpdateExpression":
                                    return !0;
                                case "MemberExpression":
                                case "OptionalMemberExpression":
                                    return C === "object";
                                case "AssignmentExpression":
                                case "AssignmentPattern":
                                    return C === "left" && (o.type === "TSTypeAssertion" || _(o));
                                case "LogicalExpression":
                                    if (o.type === "LogicalExpression") return m.operator !== o.operator;
                                case "BinaryExpression":
                                    {
                                        let { operator: S, type: b } = o;
                                        if (!S && b !== "TSTypeAssertion") return !0;
                                        let B = g(S), k = m.operator, M = g(k);
                                        return M > B || C === "right" && M === B || M === B && !h(k, S) ? !0 : M < B && S === "%" ? k === "+" || k === "-" : !!p(k);
                                    }
                                default:
                                    return !1;
                            }
                        case "SequenceExpression":
                            switch(m.type){
                                case "ReturnStatement":
                                    return !1;
                                case "ForStatement":
                                    return !1;
                                case "ExpressionStatement":
                                    return C !== "expression";
                                case "ArrowFunctionExpression":
                                    return C !== "body";
                                default:
                                    return !0;
                            }
                        case "YieldExpression":
                            if (m.type === "UnaryExpression" || m.type === "AwaitExpression" || _(m) || m.type === "TSNonNullExpression") return !0;
                        case "AwaitExpression":
                            switch(m.type){
                                case "TaggedTemplateExpression":
                                case "UnaryExpression":
                                case "LogicalExpression":
                                case "SpreadElement":
                                case "SpreadProperty":
                                case "TSAsExpression":
                                case "TSSatisfiesExpression":
                                case "TSNonNullExpression":
                                case "BindExpression":
                                    return !0;
                                case "MemberExpression":
                                case "OptionalMemberExpression":
                                    return C === "object";
                                case "NewExpression":
                                case "CallExpression":
                                case "OptionalCallExpression":
                                    return C === "callee";
                                case "ConditionalExpression":
                                    return C === "test";
                                case "BinaryExpression":
                                    return !(!o.argument && m.operator === "|>");
                                default:
                                    return !1;
                            }
                        case "TSConditionalType":
                        case "TSFunctionType":
                        case "TSConstructorType":
                            if (C === "extendsType" && m.type === "TSConditionalType") {
                                if (o.type === "TSConditionalType") return !0;
                                let { typeAnnotation: S } = o.returnType || o.typeAnnotation;
                                if (S.type === "TSTypePredicate" && S.typeAnnotation && (S = S.typeAnnotation.typeAnnotation), S.type === "TSInferType" && S.typeParameter.constraint) return !0;
                            }
                            if (C === "checkType" && m.type === "TSConditionalType") return !0;
                        case "TSUnionType":
                        case "TSIntersectionType":
                            if ((m.type === "TSUnionType" || m.type === "TSIntersectionType") && m.types.length > 1 && (!o.types || o.types.length > 1)) return !0;
                        case "TSInferType":
                            if (o.type === "TSInferType" && m.type === "TSRestType") return !1;
                        case "TSTypeOperator":
                            return m.type === "TSArrayType" || m.type === "TSOptionalType" || m.type === "TSRestType" || C === "objectType" && m.type === "TSIndexedAccessType" || m.type === "TSTypeOperator" || m.type === "TSTypeAnnotation" && D.getParentNode(1).type.startsWith("TSJSDoc");
                        case "TSTypeQuery":
                            return C === "objectType" && m.type === "TSIndexedAccessType" || C === "elementType" && m.type === "TSArrayType";
                        case "TypeofTypeAnnotation":
                            return C === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType") || C === "elementType" && m.type === "ArrayTypeAnnotation";
                        case "ArrayTypeAnnotation":
                            return m.type === "NullableTypeAnnotation";
                        case "IntersectionTypeAnnotation":
                        case "UnionTypeAnnotation":
                            return m.type === "ArrayTypeAnnotation" || m.type === "NullableTypeAnnotation" || m.type === "IntersectionTypeAnnotation" || m.type === "UnionTypeAnnotation" || C === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                        case "NullableTypeAnnotation":
                            return m.type === "ArrayTypeAnnotation" || C === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
                        case "FunctionTypeAnnotation":
                            {
                                let S = m.type === "NullableTypeAnnotation" ? D.getParentNode(1) : m;
                                return S.type === "UnionTypeAnnotation" || S.type === "IntersectionTypeAnnotation" || S.type === "ArrayTypeAnnotation" || C === "objectType" && (S.type === "IndexedAccessType" || S.type === "OptionalIndexedAccessType") || S.type === "NullableTypeAnnotation" || m.type === "FunctionTypeParam" && m.name === null && a(o).some((b)=>b.typeAnnotation && b.typeAnnotation.type === "NullableTypeAnnotation");
                            }
                        case "OptionalIndexedAccessType":
                            return C === "objectType" && m.type === "IndexedAccessType";
                        case "StringLiteral":
                        case "NumericLiteral":
                        case "Literal":
                            if (typeof o.value == "string" && m.type === "ExpressionStatement" && !m.directive) {
                                let S = D.getParentNode(1);
                                return S.type === "Program" || S.type === "BlockStatement";
                            }
                            return C === "object" && m.type === "MemberExpression" && typeof o.value == "number";
                        case "AssignmentExpression":
                            {
                                let S = D.getParentNode(1);
                                return C === "body" && m.type === "ArrowFunctionExpression" ? !0 : C === "key" && (m.type === "ClassProperty" || m.type === "PropertyDefinition") && m.computed || (C === "init" || C === "update") && m.type === "ForStatement" ? !1 : m.type === "ExpressionStatement" ? o.left.type === "ObjectPattern" : !(C === "key" && m.type === "TSPropertySignature" || m.type === "AssignmentExpression" || m.type === "SequenceExpression" && S && S.type === "ForStatement" && (S.init === m || S.update === m) || C === "value" && m.type === "Property" && S && S.type === "ObjectPattern" && S.properties.includes(m) || m.type === "NGChainedExpression");
                            }
                        case "ConditionalExpression":
                            switch(m.type){
                                case "TaggedTemplateExpression":
                                case "UnaryExpression":
                                case "SpreadElement":
                                case "SpreadProperty":
                                case "BinaryExpression":
                                case "LogicalExpression":
                                case "NGPipeExpression":
                                case "ExportDefaultDeclaration":
                                case "AwaitExpression":
                                case "JSXSpreadAttribute":
                                case "TSTypeAssertion":
                                case "TypeCastExpression":
                                case "TSAsExpression":
                                case "TSSatisfiesExpression":
                                case "TSNonNullExpression":
                                    return !0;
                                case "NewExpression":
                                case "CallExpression":
                                case "OptionalCallExpression":
                                    return C === "callee";
                                case "ConditionalExpression":
                                    return C === "test";
                                case "MemberExpression":
                                case "OptionalMemberExpression":
                                    return C === "object";
                                default:
                                    return !1;
                            }
                        case "FunctionExpression":
                            switch(m.type){
                                case "NewExpression":
                                case "CallExpression":
                                case "OptionalCallExpression":
                                    return C === "callee";
                                case "TaggedTemplateExpression":
                                    return !0;
                                default:
                                    return !1;
                            }
                        case "ArrowFunctionExpression":
                            switch(m.type){
                                case "BinaryExpression":
                                    return m.operator !== "|>" || o.extra && o.extra.parenthesized;
                                case "NewExpression":
                                case "CallExpression":
                                case "OptionalCallExpression":
                                    return C === "callee";
                                case "MemberExpression":
                                case "OptionalMemberExpression":
                                    return C === "object";
                                case "TSAsExpression":
                                case "TSSatisfiesExpression":
                                case "TSNonNullExpression":
                                case "BindExpression":
                                case "TaggedTemplateExpression":
                                case "UnaryExpression":
                                case "LogicalExpression":
                                case "AwaitExpression":
                                case "TSTypeAssertion":
                                    return !0;
                                case "ConditionalExpression":
                                    return C === "test";
                                default:
                                    return !1;
                            }
                        case "ClassExpression":
                            if (s(o.decorators)) return !0;
                            switch(m.type){
                                case "NewExpression":
                                    return C === "callee";
                                default:
                                    return !1;
                            }
                        case "OptionalMemberExpression":
                        case "OptionalCallExpression":
                            {
                                let S = D.getParentNode(1);
                                if (C === "object" && m.type === "MemberExpression" || C === "callee" && (m.type === "CallExpression" || m.type === "NewExpression") || m.type === "TSNonNullExpression" && S.type === "MemberExpression" && S.object === m) return !0;
                            }
                        case "CallExpression":
                        case "MemberExpression":
                        case "TaggedTemplateExpression":
                        case "TSNonNullExpression":
                            if (C === "callee" && (m.type === "BindExpression" || m.type === "NewExpression")) {
                                let S = o;
                                for(; S;)switch(S.type){
                                    case "CallExpression":
                                    case "OptionalCallExpression":
                                        return !0;
                                    case "MemberExpression":
                                    case "OptionalMemberExpression":
                                    case "BindExpression":
                                        S = S.object;
                                        break;
                                    case "TaggedTemplateExpression":
                                        S = S.tag;
                                        break;
                                    case "TSNonNullExpression":
                                        S = S.expression;
                                        break;
                                    default:
                                        return !1;
                                }
                            }
                            return !1;
                        case "BindExpression":
                            return C === "callee" && (m.type === "BindExpression" || m.type === "NewExpression") || C === "object" && f(m);
                        case "NGPipeExpression":
                            return !(m.type === "NGRoot" || m.type === "NGMicrosyntaxExpression" || m.type === "ObjectProperty" && !(o.extra && o.extra.parenthesized) || m.type === "ArrayExpression" || c(m) && m.arguments[C] === o || C === "right" && m.type === "NGPipeExpression" || C === "property" && m.type === "MemberExpression" || m.type === "AssignmentExpression");
                        case "JSXFragment":
                        case "JSXElement":
                            return C === "callee" || C === "left" && m.type === "BinaryExpression" && m.operator === "<" || m.type !== "ArrayExpression" && m.type !== "ArrowFunctionExpression" && m.type !== "AssignmentExpression" && m.type !== "AssignmentPattern" && m.type !== "BinaryExpression" && m.type !== "NewExpression" && m.type !== "ConditionalExpression" && m.type !== "ExpressionStatement" && m.type !== "JsExpressionRoot" && m.type !== "JSXAttribute" && m.type !== "JSXElement" && m.type !== "JSXExpressionContainer" && m.type !== "JSXFragment" && m.type !== "LogicalExpression" && !c(m) && !F(m) && m.type !== "ReturnStatement" && m.type !== "ThrowStatement" && m.type !== "TypeCastExpression" && m.type !== "VariableDeclarator" && m.type !== "YieldExpression";
                        case "TypeAnnotation":
                            return C === "returnType" && m.type === "ArrowFunctionExpression" && x(o);
                    }
                    return !1;
                }
                function E(D) {
                    return D.type === "BlockStatement" || D.type === "BreakStatement" || D.type === "ClassBody" || D.type === "ClassDeclaration" || D.type === "ClassMethod" || D.type === "ClassProperty" || D.type === "PropertyDefinition" || D.type === "ClassPrivateProperty" || D.type === "ContinueStatement" || D.type === "DebuggerStatement" || D.type === "DeclareClass" || D.type === "DeclareExportAllDeclaration" || D.type === "DeclareExportDeclaration" || D.type === "DeclareFunction" || D.type === "DeclareInterface" || D.type === "DeclareModule" || D.type === "DeclareModuleExports" || D.type === "DeclareVariable" || D.type === "DoWhileStatement" || D.type === "EnumDeclaration" || D.type === "ExportAllDeclaration" || D.type === "ExportDefaultDeclaration" || D.type === "ExportNamedDeclaration" || D.type === "ExpressionStatement" || D.type === "ForInStatement" || D.type === "ForOfStatement" || D.type === "ForStatement" || D.type === "FunctionDeclaration" || D.type === "IfStatement" || D.type === "ImportDeclaration" || D.type === "InterfaceDeclaration" || D.type === "LabeledStatement" || D.type === "MethodDefinition" || D.type === "ReturnStatement" || D.type === "SwitchStatement" || D.type === "ThrowStatement" || D.type === "TryStatement" || D.type === "TSDeclareFunction" || D.type === "TSEnumDeclaration" || D.type === "TSImportEqualsDeclaration" || D.type === "TSInterfaceDeclaration" || D.type === "TSModuleDeclaration" || D.type === "TSNamespaceExportDeclaration" || D.type === "TypeAlias" || D.type === "VariableDeclaration" || D.type === "WhileStatement" || D.type === "WithStatement";
                }
                function N(D) {
                    let T = 0, m = D.getValue();
                    for(; m;){
                        let C = D.getParentNode(T++);
                        if (C && C.type === "ForStatement" && C.init === m) return !0;
                        m = C;
                    }
                    return !1;
                }
                function x(D) {
                    return l(D, (T)=>T.type === "ObjectTypeAnnotation" && l(T, (m)=>m.type === "FunctionTypeAnnotation" || void 0) || void 0);
                }
                function I(D) {
                    switch(D.type){
                        case "ObjectExpression":
                            return !0;
                        default:
                            return !1;
                    }
                }
                function P(D) {
                    let T = D.getValue(), m = D.getParentNode(), C = D.getName();
                    switch(m.type){
                        case "NGPipeExpression":
                            if (typeof C == "number" && m.arguments[C] === T && m.arguments.length - 1 === C) return D.callParent(P);
                            break;
                        case "ObjectProperty":
                            if (C === "value") {
                                let o = D.getParentNode(1);
                                return t(o.properties) === m;
                            }
                            break;
                        case "BinaryExpression":
                        case "LogicalExpression":
                            if (C === "right") return D.callParent(P);
                            break;
                        case "ConditionalExpression":
                            if (C === "alternate") return D.callParent(P);
                            break;
                        case "UnaryExpression":
                            if (m.prefix) return D.callParent(P);
                            break;
                    }
                    return !1;
                }
                function $(D, T) {
                    let m = D.getValue(), C = D.getParentNode();
                    return m.type === "FunctionExpression" || m.type === "ClassExpression" ? C.type === "ExportDefaultDeclaration" || !w(D, T) : !i(m) || C.type !== "ExportDefaultDeclaration" && w(D, T) ? !1 : D.call((o)=>$(o, T), ...n(D, m));
                }
                r.exports = w;
            }
        }), Fo = te({
            "src/language-js/print-preprocess.js" (e, r) {
                "use strict";
                ne();
                function t(s, a) {
                    switch(a.parser){
                        case "json":
                        case "json5":
                        case "json-stringify":
                        case "__js_expression":
                        case "__vue_expression":
                        case "__vue_ts_expression":
                            return Object.assign(Object.assign({}, s), {}, {
                                type: a.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot",
                                node: s,
                                comments: [],
                                rootMarker: a.rootMarker
                            });
                        default:
                            return s;
                    }
                }
                r.exports = t;
            }
        }), pd = te({
            "src/language-js/print/html-binding.js" (e, r) {
                "use strict";
                ne();
                var { builders: { join: t, line: s, group: a, softline: n, indent: u } } = qe();
                function i(p, y, h) {
                    let g = p.getValue();
                    if (y.__onHtmlBindingRoot && p.getName() === null && y.__onHtmlBindingRoot(g, y), g.type === "File") {
                        if (y.__isVueForBindingLeft) return p.call((c)=>{
                            let f = t([
                                ",",
                                s
                            ], c.map(h, "params")), { params: F } = c.getValue();
                            return F.length === 1 ? f : [
                                "(",
                                u([
                                    n,
                                    a(f)
                                ]),
                                n,
                                ")"
                            ];
                        }, "program", "body", 0);
                        if (y.__isVueBindings) return p.call((c)=>t([
                                ",",
                                s
                            ], c.map(h, "params")), "program", "body", 0);
                    }
                }
                function l(p) {
                    switch(p.type){
                        case "MemberExpression":
                            switch(p.property.type){
                                case "Identifier":
                                case "NumericLiteral":
                                case "StringLiteral":
                                    return l(p.object);
                            }
                            return !1;
                        case "Identifier":
                            return !0;
                        default:
                            return !1;
                    }
                }
                r.exports = {
                    isVueEventBindingExpression: l,
                    printHtmlBinding: i
                };
            }
        }), ru = te({
            "src/language-js/print/binaryish.js" (e, r) {
                "use strict";
                ne();
                var { printComments: t } = et(), { getLast: s } = Ue(), { builders: { join: a, line: n, softline: u, group: i, indent: l, align: p, indentIfBreak: y }, utils: { cleanDoc: h, getDocParts: g, isConcat: c } } = qe(), { hasLeadingOwnLineComment: f, isBinaryish: F, isJsxNode: _, shouldFlatten: w, hasComment: E, CommentCheckFlags: N, isCallExpression: x, isMemberExpression: I, isObjectProperty: P, isEnabledHackPipeline: $ } = Ke(), D = 0;
                function T(o, d, v) {
                    let S = o.getValue(), b = o.getParentNode(), B = o.getParentNode(1), k = S !== b.body && (b.type === "IfStatement" || b.type === "WhileStatement" || b.type === "SwitchStatement" || b.type === "DoWhileStatement"), M = $(d) && S.operator === "|>", R = m(o, v, d, !1, k);
                    if (k) return R;
                    if (M) return i(R);
                    if (x(b) && b.callee === S || b.type === "UnaryExpression" || I(b) && !b.computed) return i([
                        l([
                            u,
                            ...R
                        ]),
                        u
                    ]);
                    let q = b.type === "ReturnStatement" || b.type === "ThrowStatement" || b.type === "JSXExpressionContainer" && B.type === "JSXAttribute" || S.operator !== "|" && b.type === "JsExpressionRoot" || S.type !== "NGPipeExpression" && (b.type === "NGRoot" && d.parser === "__ng_binding" || b.type === "NGMicrosyntaxExpression" && B.type === "NGMicrosyntax" && B.body.length === 1) || S === b.body && b.type === "ArrowFunctionExpression" || S !== b.body && b.type === "ForStatement" || b.type === "ConditionalExpression" && B.type !== "ReturnStatement" && B.type !== "ThrowStatement" && !x(B) || b.type === "TemplateLiteral", J = b.type === "AssignmentExpression" || b.type === "VariableDeclarator" || b.type === "ClassProperty" || b.type === "PropertyDefinition" || b.type === "TSAbstractPropertyDefinition" || b.type === "ClassPrivateProperty" || P(b), L = F(S.left) && w(S.operator, S.left.operator);
                    if (q || C(S) && !L || !C(S) && J) return i(R);
                    if (R.length === 0) return "";
                    let Q = _(S.right), V = R.findIndex((W)=>typeof W != "string" && !Array.isArray(W) && W.type === "group"), j = R.slice(0, V === -1 ? 1 : V + 1), Y = R.slice(j.length, Q ? -1 : void 0), ie = Symbol("logicalChain-" + ++D), ee = i([
                        ...j,
                        l(Y)
                    ], {
                        id: ie
                    });
                    if (!Q) return ee;
                    let ce = s(R);
                    return i([
                        ee,
                        y(ce, {
                            groupId: ie
                        })
                    ]);
                }
                function m(o, d, v, S, b) {
                    let B = o.getValue();
                    if (!F(B)) return [
                        i(d())
                    ];
                    let k = [];
                    w(B.operator, B.left.operator) ? k = o.call((Y)=>m(Y, d, v, !0, b), "left") : k.push(i(d("left")));
                    let M = C(B), R = (B.operator === "|>" || B.type === "NGPipeExpression" || B.operator === "|" && v.parser === "__vue_expression") && !f(v.originalText, B.right), q = B.type === "NGPipeExpression" ? "|" : B.operator, J = B.type === "NGPipeExpression" && B.arguments.length > 0 ? i(l([
                        n,
                        ": ",
                        a([
                            n,
                            ": "
                        ], o.map(d, "arguments").map((Y)=>p(2, i(Y))))
                    ])) : "", L;
                    if (M) L = [
                        q,
                        " ",
                        d("right"),
                        J
                    ];
                    else {
                        let ie = $(v) && q === "|>" ? o.call((ee)=>m(ee, d, v, !0, b), "right") : d("right");
                        L = [
                            R ? n : "",
                            q,
                            R ? " " : n,
                            ie,
                            J
                        ];
                    }
                    let Q = o.getParentNode(), V = E(B.left, N.Trailing | N.Line), j = V || !(b && B.type === "LogicalExpression") && Q.type !== B.type && B.left.type !== B.type && B.right.type !== B.type;
                    if (k.push(R ? "" : " ", j ? i(L, {
                        shouldBreak: V
                    }) : L), S && E(B)) {
                        let Y = h(t(o, k, v));
                        return c(Y) || Y.type === "fill" ? g(Y) : [
                            Y
                        ];
                    }
                    return k;
                }
                function C(o) {
                    return o.type !== "LogicalExpression" ? !1 : !!(o.right.type === "ObjectExpression" && o.right.properties.length > 0 || o.right.type === "ArrayExpression" && o.right.elements.length > 0 || _(o.right));
                }
                r.exports = {
                    printBinaryishExpression: T,
                    shouldInlineLogicalExpression: C
                };
            }
        }), fd = te({
            "src/language-js/print/angular.js" (e, r) {
                "use strict";
                ne();
                var { builders: { join: t, line: s, group: a } } = qe(), { hasNode: n, hasComment: u, getComments: i } = Ke(), { printBinaryishExpression: l } = ru();
                function p(g, c, f) {
                    let F = g.getValue();
                    if (F.type.startsWith("NG")) switch(F.type){
                        case "NGRoot":
                            return [
                                f("node"),
                                u(F.node) ? " //" + i(F.node)[0].value.trimEnd() : ""
                            ];
                        case "NGPipeExpression":
                            return l(g, c, f);
                        case "NGChainedExpression":
                            return a(t([
                                ";",
                                s
                            ], g.map((_)=>h(_) ? f() : [
                                    "(",
                                    f(),
                                    ")"
                                ], "expressions")));
                        case "NGEmptyExpression":
                            return "";
                        case "NGQuotedExpression":
                            return [
                                F.prefix,
                                ": ",
                                F.value.trim()
                            ];
                        case "NGMicrosyntax":
                            return g.map((_, w)=>[
                                    w === 0 ? "" : y(_.getValue(), w, F) ? " " : [
                                        ";",
                                        s
                                    ],
                                    f()
                                ], "body");
                        case "NGMicrosyntaxKey":
                            return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(F.name) ? F.name : JSON.stringify(F.name);
                        case "NGMicrosyntaxExpression":
                            return [
                                f("expression"),
                                F.alias === null ? "" : [
                                    " as ",
                                    f("alias")
                                ]
                            ];
                        case "NGMicrosyntaxKeyedExpression":
                            {
                                let _ = g.getName(), w = g.getParentNode(), E = y(F, _, w) || (_ === 1 && (F.key.name === "then" || F.key.name === "else") || _ === 2 && F.key.name === "else" && w.body[_ - 1].type === "NGMicrosyntaxKeyedExpression" && w.body[_ - 1].key.name === "then") && w.body[0].type === "NGMicrosyntaxExpression";
                                return [
                                    f("key"),
                                    E ? " " : ": ",
                                    f("expression")
                                ];
                            }
                        case "NGMicrosyntaxLet":
                            return [
                                "let ",
                                f("key"),
                                F.value === null ? "" : [
                                    " = ",
                                    f("value")
                                ]
                            ];
                        case "NGMicrosyntaxAs":
                            return [
                                f("key"),
                                " as ",
                                f("alias")
                            ];
                        default:
                            throw new Error(`Unknown Angular node type: ${JSON.stringify(F.type)}.`);
                    }
                }
                function y(g, c, f) {
                    return g.type === "NGMicrosyntaxKeyedExpression" && g.key.name === "of" && c === 1 && f.body[0].type === "NGMicrosyntaxLet" && f.body[0].value === null;
                }
                function h(g) {
                    return n(g.getValue(), (c)=>{
                        switch(c.type){
                            case void 0:
                                return !1;
                            case "CallExpression":
                            case "OptionalCallExpression":
                            case "AssignmentExpression":
                                return !0;
                        }
                    });
                }
                r.exports = {
                    printAngular: p
                };
            }
        }), Dd = te({
            "src/language-js/print/jsx.js" (e, r) {
                "use strict";
                ne();
                var { printComments: t, printDanglingComments: s, printCommentsSeparately: a } = et(), { builders: { line: n, hardline: u, softline: i, group: l, indent: p, conditionalGroup: y, fill: h, ifBreak: g, lineSuffixBoundary: c, join: f }, utils: { willBreak: F } } = qe(), { getLast: _, getPreferredQuote: w } = Ue(), { isJsxNode: E, rawText: N, isCallExpression: x, isStringLiteral: I, isBinaryish: P, hasComment: $, CommentCheckFlags: D, hasNodeIgnoreComment: T } = Ke(), m = qt(), { willPrintOwnComments: C } = Eo(), o = (U)=>U === "" || U === n || U === u || U === i;
                function d(U, Z, se) {
                    let fe = U.getValue();
                    if (fe.type === "JSXElement" && de(fe)) return [
                        se("openingElement"),
                        se("closingElement")
                    ];
                    let ge = fe.type === "JSXElement" ? se("openingElement") : se("openingFragment"), he = fe.type === "JSXElement" ? se("closingElement") : se("closingFragment");
                    if (fe.children.length === 1 && fe.children[0].type === "JSXExpressionContainer" && (fe.children[0].expression.type === "TemplateLiteral" || fe.children[0].expression.type === "TaggedTemplateExpression")) return [
                        ge,
                        ...U.map(se, "children"),
                        he
                    ];
                    fe.children = fe.children.map((A)=>Fe(A) ? {
                            type: "JSXText",
                            value: " ",
                            raw: " "
                        } : A);
                    let we = fe.children.some(E), ke = fe.children.filter((A)=>A.type === "JSXExpressionContainer").length > 1, Re = fe.type === "JSXElement" && fe.openingElement.attributes.length > 1, Ne = F(ge) || we || Re || ke, Pe = U.getParentNode().rootMarker === "mdx", oe = Z.singleQuote ? "{' '}" : '{" "}', H = Pe ? " " : g([
                        oe,
                        i
                    ], " "), pe = fe.openingElement && fe.openingElement.name && fe.openingElement.name.name === "fbt", X = v(U, Z, se, H, pe), le = fe.children.some((A)=>ue(A));
                    for(let A = X.length - 2; A >= 0; A--){
                        let G = X[A] === "" && X[A + 1] === "", re = X[A] === u && X[A + 1] === "" && X[A + 2] === u, ye = (X[A] === i || X[A] === u) && X[A + 1] === "" && X[A + 2] === H, Ce = X[A] === H && X[A + 1] === "" && (X[A + 2] === i || X[A + 2] === u), Be = X[A] === H && X[A + 1] === "" && X[A + 2] === H, ve = X[A] === i && X[A + 1] === "" && X[A + 2] === u || X[A] === u && X[A + 1] === "" && X[A + 2] === i;
                        re && le || G || ye || Be || ve ? X.splice(A, 2) : Ce && X.splice(A + 1, 2);
                    }
                    for(; X.length > 0 && o(_(X));)X.pop();
                    for(; X.length > 1 && o(X[0]) && o(X[1]);)X.shift(), X.shift();
                    let Ae = [];
                    for (let [A, G] of X.entries()){
                        if (G === H) {
                            if (A === 1 && X[A - 1] === "") {
                                if (X.length === 2) {
                                    Ae.push(oe);
                                    continue;
                                }
                                Ae.push([
                                    oe,
                                    u
                                ]);
                                continue;
                            } else if (A === X.length - 1) {
                                Ae.push(oe);
                                continue;
                            } else if (X[A - 1] === "" && X[A - 2] === u) {
                                Ae.push(oe);
                                continue;
                            }
                        }
                        Ae.push(G), F(G) && (Ne = !0);
                    }
                    let Ee = le ? h(Ae) : l(Ae, {
                        shouldBreak: !0
                    });
                    if (Pe) return Ee;
                    let De = l([
                        ge,
                        p([
                            u,
                            Ee
                        ]),
                        u,
                        he
                    ]);
                    return Ne ? De : y([
                        l([
                            ge,
                            ...X,
                            he
                        ]),
                        De
                    ]);
                }
                function v(U, Z, se, fe, ge) {
                    let he = [];
                    return U.each((we, ke, Re)=>{
                        let Ne = we.getValue();
                        if (Ne.type === "JSXText") {
                            let Pe = N(Ne);
                            if (ue(Ne)) {
                                let oe = Pe.split(ce);
                                if (oe[0] === "") {
                                    if (he.push(""), oe.shift(), /\n/.test(oe[0])) {
                                        let pe = Re[ke + 1];
                                        he.push(b(ge, oe[1], Ne, pe));
                                    } else he.push(fe);
                                    oe.shift();
                                }
                                let H;
                                if (_(oe) === "" && (oe.pop(), H = oe.pop()), oe.length === 0) return;
                                for (let [pe, X] of oe.entries())pe % 2 === 1 ? he.push(n) : he.push(X);
                                if (H !== void 0) {
                                    if (/\n/.test(H)) {
                                        let pe = Re[ke + 1];
                                        he.push(b(ge, _(he), Ne, pe));
                                    } else he.push(fe);
                                } else {
                                    let pe = Re[ke + 1];
                                    he.push(S(ge, _(he), Ne, pe));
                                }
                            } else /\n/.test(Pe) ? Pe.match(/\n/g).length > 1 && he.push("", u) : he.push("", fe);
                        } else {
                            let Pe = se();
                            he.push(Pe);
                            let oe = Re[ke + 1];
                            if (oe && ue(oe)) {
                                let pe = K(N(oe)).split(ce)[0];
                                he.push(S(ge, pe, Ne, oe));
                            } else he.push(u);
                        }
                    }, "children"), he;
                }
                function S(U, Z, se, fe) {
                    return U ? "" : se.type === "JSXElement" && !se.closingElement || fe && fe.type === "JSXElement" && !fe.closingElement ? Z.length === 1 ? i : u : i;
                }
                function b(U, Z, se, fe) {
                    return U ? u : Z.length === 1 ? se.type === "JSXElement" && !se.closingElement || fe && fe.type === "JSXElement" && !fe.closingElement ? u : i : u;
                }
                function B(U, Z, se) {
                    let fe = U.getParentNode();
                    if (!fe || ({
                        ArrayExpression: !0,
                        JSXAttribute: !0,
                        JSXElement: !0,
                        JSXExpressionContainer: !0,
                        JSXFragment: !0,
                        ExpressionStatement: !0,
                        CallExpression: !0,
                        OptionalCallExpression: !0,
                        ConditionalExpression: !0,
                        JsExpressionRoot: !0
                    })[fe.type]) return Z;
                    let he = U.match(void 0, (ke)=>ke.type === "ArrowFunctionExpression", x, (ke)=>ke.type === "JSXExpressionContainer"), we = m(U, se);
                    return l([
                        we ? "" : g("("),
                        p([
                            i,
                            Z
                        ]),
                        i,
                        we ? "" : g(")")
                    ], {
                        shouldBreak: he
                    });
                }
                function k(U, Z, se) {
                    let fe = U.getValue(), ge = [];
                    if (ge.push(se("name")), fe.value) {
                        let he;
                        if (I(fe.value)) {
                            let ke = N(fe.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: Re, quote: Ne, regex: Pe } = w(ke, Z.jsxSingleQuote ? "'" : '"');
                            ke = ke.replace(Pe, Re);
                            let { leading: oe, trailing: H } = U.call(()=>a(U, Z), "value");
                            he = [
                                oe,
                                Ne,
                                ke,
                                Ne,
                                H
                            ];
                        } else he = se("value");
                        ge.push("=", he);
                    }
                    return ge;
                }
                function M(U, Z, se) {
                    let fe = U.getValue(), ge = (he, we)=>he.type === "JSXEmptyExpression" || !$(he) && (he.type === "ArrayExpression" || he.type === "ObjectExpression" || he.type === "ArrowFunctionExpression" || he.type === "AwaitExpression" && (ge(he.argument, he) || he.argument.type === "JSXElement") || x(he) || he.type === "FunctionExpression" || he.type === "TemplateLiteral" || he.type === "TaggedTemplateExpression" || he.type === "DoExpression" || E(we) && (he.type === "ConditionalExpression" || P(he)));
                    return ge(fe.expression, U.getParentNode(0)) ? l([
                        "{",
                        se("expression"),
                        c,
                        "}"
                    ]) : l([
                        "{",
                        p([
                            i,
                            se("expression")
                        ]),
                        i,
                        c,
                        "}"
                    ]);
                }
                function R(U, Z, se) {
                    let fe = U.getValue(), ge = fe.name && $(fe.name) || fe.typeParameters && $(fe.typeParameters);
                    if (fe.selfClosing && fe.attributes.length === 0 && !ge) return [
                        "<",
                        se("name"),
                        se("typeParameters"),
                        " />"
                    ];
                    if (fe.attributes && fe.attributes.length === 1 && fe.attributes[0].value && I(fe.attributes[0].value) && !fe.attributes[0].value.value.includes(`
`) && !ge && !$(fe.attributes[0])) return l([
                        "<",
                        se("name"),
                        se("typeParameters"),
                        " ",
                        ...U.map(se, "attributes"),
                        fe.selfClosing ? " />" : ">"
                    ]);
                    let he = fe.attributes && fe.attributes.some((ke)=>ke.value && I(ke.value) && ke.value.value.includes(`
`)), we = Z.singleAttributePerLine && fe.attributes.length > 1 ? u : n;
                    return l([
                        "<",
                        se("name"),
                        se("typeParameters"),
                        p(U.map(()=>[
                                we,
                                se()
                            ], "attributes")),
                        ...q(fe, Z, ge)
                    ], {
                        shouldBreak: he
                    });
                }
                function q(U, Z, se) {
                    return U.selfClosing ? [
                        n,
                        "/>"
                    ] : J(U, Z, se) ? [
                        ">"
                    ] : [
                        i,
                        ">"
                    ];
                }
                function J(U, Z, se) {
                    let fe = U.attributes.length > 0 && $(_(U.attributes), D.Trailing);
                    return U.attributes.length === 0 && !se || (Z.bracketSameLine || Z.jsxBracketSameLine) && (!se || U.attributes.length > 0) && !fe;
                }
                function L(U, Z, se) {
                    let fe = U.getValue(), ge = [];
                    ge.push("</");
                    let he = se("name");
                    return $(fe.name, D.Leading | D.Line) ? ge.push(p([
                        u,
                        he
                    ]), u) : $(fe.name, D.Leading | D.Block) ? ge.push(" ", he) : ge.push(he), ge.push(">"), ge;
                }
                function Q(U, Z) {
                    let se = U.getValue(), fe = $(se), ge = $(se, D.Line), he = se.type === "JSXOpeningFragment";
                    return [
                        he ? "<" : "</",
                        p([
                            ge ? u : fe && !he ? " " : "",
                            s(U, Z, !0)
                        ]),
                        ge ? u : "",
                        ">"
                    ];
                }
                function V(U, Z, se) {
                    let fe = t(U, d(U, Z, se), Z);
                    return B(U, fe, Z);
                }
                function j(U, Z) {
                    let se = U.getValue(), fe = $(se, D.Line);
                    return [
                        s(U, Z, !fe),
                        fe ? u : ""
                    ];
                }
                function Y(U, Z, se) {
                    let fe = U.getValue();
                    return [
                        "{",
                        U.call((ge)=>{
                            let he = [
                                "...",
                                se()
                            ], we = ge.getValue();
                            return !$(we) || !C(ge) ? he : [
                                p([
                                    i,
                                    t(ge, he, Z)
                                ]),
                                i
                            ];
                        }, fe.type === "JSXSpreadAttribute" ? "argument" : "expression"),
                        "}"
                    ];
                }
                function ie(U, Z, se) {
                    let fe = U.getValue();
                    if (fe.type.startsWith("JSX")) switch(fe.type){
                        case "JSXAttribute":
                            return k(U, Z, se);
                        case "JSXIdentifier":
                            return String(fe.name);
                        case "JSXNamespacedName":
                            return f(":", [
                                se("namespace"),
                                se("name")
                            ]);
                        case "JSXMemberExpression":
                            return f(".", [
                                se("object"),
                                se("property")
                            ]);
                        case "JSXSpreadAttribute":
                            return Y(U, Z, se);
                        case "JSXSpreadChild":
                            return Y(U, Z, se);
                        case "JSXExpressionContainer":
                            return M(U, Z, se);
                        case "JSXFragment":
                        case "JSXElement":
                            return V(U, Z, se);
                        case "JSXOpeningElement":
                            return R(U, Z, se);
                        case "JSXClosingElement":
                            return L(U, Z, se);
                        case "JSXOpeningFragment":
                        case "JSXClosingFragment":
                            return Q(U, Z);
                        case "JSXEmptyExpression":
                            return j(U, Z);
                        case "JSXText":
                            throw new Error("JSXText should be handled by JSXElement");
                        default:
                            throw new Error(`Unknown JSX node type: ${JSON.stringify(fe.type)}.`);
                    }
                }
                var ee = ` 
\r	`, ce = new RegExp("([" + ee + "]+)"), W = new RegExp("[^" + ee + "]"), K = (U)=>U.replace(new RegExp("(?:^" + ce.source + "|" + ce.source + "$)"), "");
                function de(U) {
                    if (U.children.length === 0) return !0;
                    if (U.children.length > 1) return !1;
                    let Z = U.children[0];
                    return Z.type === "JSXText" && !ue(Z);
                }
                function ue(U) {
                    return U.type === "JSXText" && (W.test(N(U)) || !/\n/.test(N(U)));
                }
                function Fe(U) {
                    return U.type === "JSXExpressionContainer" && I(U.expression) && U.expression.value === " " && !$(U.expression);
                }
                function z(U) {
                    let Z = U.getValue(), se = U.getParentNode();
                    if (!se || !Z || !E(Z) || !E(se)) return !1;
                    let fe = se.children.indexOf(Z), ge = null;
                    for(let he = fe; he > 0; he--){
                        let we = se.children[he - 1];
                        if (!(we.type === "JSXText" && !ue(we))) {
                            ge = we;
                            break;
                        }
                    }
                    return ge && ge.type === "JSXExpressionContainer" && ge.expression.type === "JSXEmptyExpression" && T(ge.expression);
                }
                r.exports = {
                    hasJsxIgnoreComment: z,
                    printJsx: ie
                };
            }
        }), ct = te({
            "src/language-js/print/misc.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t } = Ue(), { builders: { indent: s, join: a, line: n } } = qe(), { isFlowAnnotationComment: u } = Ke();
                function i(_) {
                    let w = _.getValue();
                    return !w.optional || w.type === "Identifier" && w === _.getParentNode().key ? "" : w.type === "OptionalCallExpression" || w.type === "OptionalMemberExpression" && w.computed ? "?." : "?";
                }
                function l(_) {
                    return _.getValue().definite || _.match(void 0, (w, E)=>E === "id" && w.type === "VariableDeclarator" && w.definite) ? "!" : "";
                }
                function p(_, w, E) {
                    let N = _.getValue();
                    return N.typeArguments ? E("typeArguments") : N.typeParameters ? E("typeParameters") : "";
                }
                function y(_, w, E) {
                    let N = _.getValue();
                    if (!N.typeAnnotation) return "";
                    let x = _.getParentNode(), I = x.type === "DeclareFunction" && x.id === N;
                    return u(w.originalText, N.typeAnnotation) ? [
                        " /*: ",
                        E("typeAnnotation"),
                        " */"
                    ] : [
                        I ? "" : ": ",
                        E("typeAnnotation")
                    ];
                }
                function h(_, w, E) {
                    return [
                        "::",
                        E("callee")
                    ];
                }
                function g(_, w, E) {
                    let N = _.getValue();
                    return t(N.modifiers) ? [
                        a(" ", _.map(E, "modifiers")),
                        " "
                    ] : "";
                }
                function c(_, w, E) {
                    return _.type === "EmptyStatement" ? ";" : _.type === "BlockStatement" || E ? [
                        " ",
                        w
                    ] : s([
                        n,
                        w
                    ]);
                }
                function f(_, w, E) {
                    return [
                        "...",
                        E("argument"),
                        y(_, w, E)
                    ];
                }
                function F(_, w) {
                    let E = _.slice(1, -1);
                    if (E.includes('"') || E.includes("'")) return _;
                    let N = w.singleQuote ? "'" : '"';
                    return N + E + N;
                }
                r.exports = {
                    printOptionalToken: i,
                    printDefiniteToken: l,
                    printFunctionTypeParameters: p,
                    printBindExpressionCallee: h,
                    printTypeScriptModifiers: g,
                    printTypeAnnotation: y,
                    printRestSpread: f,
                    adjustClause: c,
                    printDirective: F
                };
            }
        }), er = te({
            "src/language-js/print/array.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { builders: { line: s, softline: a, hardline: n, group: u, indent: i, ifBreak: l, fill: p } } = qe(), { getLast: y, hasNewline: h } = Ue(), { shouldPrintComma: g, hasComment: c, CommentCheckFlags: f, isNextLineEmpty: F, isNumericLiteral: _, isSignedNumericLiteral: w } = Ke(), { locStart: E } = ut(), { printOptionalToken: N, printTypeAnnotation: x } = ct();
                function I(T, m, C) {
                    let o = T.getValue(), d = [], v = o.type === "TupleExpression" ? "#[" : "[", S = "]";
                    if (o.elements.length === 0) c(o, f.Dangling) ? d.push(u([
                        v,
                        t(T, m),
                        a,
                        S
                    ])) : d.push(v, S);
                    else {
                        let b = y(o.elements), B = !(b && b.type === "RestElement"), k = b === null, M = Symbol("array"), R = !m.__inJestEach && o.elements.length > 1 && o.elements.every((L, Q, V)=>{
                            let j = L && L.type;
                            if (j !== "ArrayExpression" && j !== "ObjectExpression") return !1;
                            let Y = V[Q + 1];
                            if (Y && j !== Y.type) return !1;
                            let ie = j === "ArrayExpression" ? "elements" : "properties";
                            return L[ie] && L[ie].length > 1;
                        }), q = P(o, m), J = B ? k ? "," : g(m) ? q ? l(",", "", {
                            groupId: M
                        }) : l(",") : "" : "";
                        d.push(u([
                            v,
                            i([
                                a,
                                q ? D(T, m, C, J) : [
                                    $(T, m, "elements", C),
                                    J
                                ],
                                t(T, m, !0)
                            ]),
                            a,
                            S
                        ], {
                            shouldBreak: R,
                            id: M
                        }));
                    }
                    return d.push(N(T), x(T, m, C)), d;
                }
                function P(T, m) {
                    return T.elements.length > 1 && T.elements.every((C)=>C && (_(C) || w(C) && !c(C.argument)) && !c(C, f.Trailing | f.Line, (o)=>!h(m.originalText, E(o), {
                                backwards: !0
                            })));
                }
                function $(T, m, C, o) {
                    let d = [], v = [];
                    return T.each((S)=>{
                        d.push(v, u(o())), v = [
                            ",",
                            s
                        ], S.getValue() && F(S.getValue(), m) && v.push(a);
                    }, C), d;
                }
                function D(T, m, C, o) {
                    let d = [];
                    return T.each((v, S, b)=>{
                        let B = S === b.length - 1;
                        d.push([
                            C(),
                            B ? o : ","
                        ]), B || d.push(F(v.getValue(), m) ? [
                            n,
                            n
                        ] : c(b[S + 1], f.Leading | f.Line) ? n : s);
                    }, "elements"), p(d);
                }
                r.exports = {
                    printArray: I,
                    printArrayItems: $,
                    isConciselyPrintedArray: P
                };
            }
        }), Ao = te({
            "src/language-js/print/call-arguments.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { getLast: s, getPenultimate: a } = Ue(), { getFunctionParameters: n, hasComment: u, CommentCheckFlags: i, isFunctionCompositionArgs: l, isJsxNode: p, isLongCurriedCallExpression: y, shouldPrintComma: h, getCallArguments: g, iterateCallArgumentsPath: c, isNextLineEmpty: f, isCallExpression: F, isStringLiteral: _, isObjectProperty: w, isTSTypeExpression: E } = Ke(), { builders: { line: N, hardline: x, softline: I, group: P, indent: $, conditionalGroup: D, ifBreak: T, breakParent: m }, utils: { willBreak: C } } = qe(), { ArgExpansionBailout: o } = Qt(), { isConciselyPrintedArray: d } = er();
                function v(q, J, L) {
                    let Q = q.getValue(), V = Q.type === "ImportExpression", j = g(Q);
                    if (j.length === 0) return [
                        "(",
                        t(q, J, !0),
                        ")"
                    ];
                    if (k(j)) return [
                        "(",
                        L([
                            "arguments",
                            0
                        ]),
                        ", ",
                        L([
                            "arguments",
                            1
                        ]),
                        ")"
                    ];
                    let Y = !1, ie = !1, ee = j.length - 1, ce = [];
                    c(q, (z, U)=>{
                        let Z = z.getNode(), se = [
                            L()
                        ];
                        U === ee || (f(Z, J) ? (U === 0 && (ie = !0), Y = !0, se.push(",", x, x)) : se.push(",", N)), ce.push(se);
                    });
                    let W = !(V || Q.callee && Q.callee.type === "Import") && h(J, "all") ? "," : "";
                    function K() {
                        return P([
                            "(",
                            $([
                                N,
                                ...ce
                            ]),
                            W,
                            N,
                            ")"
                        ], {
                            shouldBreak: !0
                        });
                    }
                    if (Y || q.getParentNode().type !== "Decorator" && l(j)) return K();
                    let de = B(j), ue = b(j, J);
                    if (de || ue) {
                        if (de ? ce.slice(1).some(C) : ce.slice(0, -1).some(C)) return K();
                        let z = [];
                        try {
                            q.try(()=>{
                                c(q, (U, Z)=>{
                                    de && Z === 0 && (z = [
                                        [
                                            L([], {
                                                expandFirstArg: !0
                                            }),
                                            ce.length > 1 ? "," : "",
                                            ie ? x : N,
                                            ie ? x : ""
                                        ],
                                        ...ce.slice(1)
                                    ]), ue && Z === ee && (z = [
                                        ...ce.slice(0, -1),
                                        L([], {
                                            expandLastArg: !0
                                        })
                                    ]);
                                });
                            });
                        } catch (U) {
                            if (U instanceof o) return K();
                            throw U;
                        }
                        return [
                            ce.some(C) ? m : "",
                            D([
                                [
                                    "(",
                                    ...z,
                                    ")"
                                ],
                                de ? [
                                    "(",
                                    P(z[0], {
                                        shouldBreak: !0
                                    }),
                                    ...z.slice(1),
                                    ")"
                                ] : [
                                    "(",
                                    ...ce.slice(0, -1),
                                    P(s(z), {
                                        shouldBreak: !0
                                    }),
                                    ")"
                                ],
                                K()
                            ])
                        ];
                    }
                    let Fe = [
                        "(",
                        $([
                            I,
                            ...ce
                        ]),
                        T(W),
                        I,
                        ")"
                    ];
                    return y(q) ? Fe : P(Fe, {
                        shouldBreak: ce.some(C) || Y
                    });
                }
                function S(q) {
                    let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                    return q.type === "ObjectExpression" && (q.properties.length > 0 || u(q)) || q.type === "ArrayExpression" && (q.elements.length > 0 || u(q)) || q.type === "TSTypeAssertion" && S(q.expression) || E(q) && S(q.expression) || q.type === "FunctionExpression" || q.type === "ArrowFunctionExpression" && (!q.returnType || !q.returnType.typeAnnotation || q.returnType.typeAnnotation.type !== "TSTypeReference" || M(q.body)) && (q.body.type === "BlockStatement" || q.body.type === "ArrowFunctionExpression" && S(q.body, !0) || q.body.type === "ObjectExpression" || q.body.type === "ArrayExpression" || !J && (F(q.body) || q.body.type === "ConditionalExpression") || p(q.body)) || q.type === "DoExpression" || q.type === "ModuleExpression";
                }
                function b(q, J) {
                    let L = s(q), Q = a(q);
                    return !u(L, i.Leading) && !u(L, i.Trailing) && S(L) && (!Q || Q.type !== L.type) && (q.length !== 2 || Q.type !== "ArrowFunctionExpression" || L.type !== "ArrayExpression") && !(q.length > 1 && L.type === "ArrayExpression" && d(L, J));
                }
                function B(q) {
                    if (q.length !== 2) return !1;
                    let [J, L] = q;
                    return J.type === "ModuleExpression" && R(L) ? !0 : !u(J) && (J.type === "FunctionExpression" || J.type === "ArrowFunctionExpression" && J.body.type === "BlockStatement") && L.type !== "FunctionExpression" && L.type !== "ArrowFunctionExpression" && L.type !== "ConditionalExpression" && !S(L);
                }
                function k(q) {
                    return q.length === 2 && q[0].type === "ArrowFunctionExpression" && n(q[0]).length === 0 && q[0].body.type === "BlockStatement" && q[1].type === "ArrayExpression" && !q.some((J)=>u(J));
                }
                function M(q) {
                    return q.type === "BlockStatement" && (q.body.some((J)=>J.type !== "EmptyStatement") || u(q, i.Dangling));
                }
                function R(q) {
                    return q.type === "ObjectExpression" && q.properties.length === 1 && w(q.properties[0]) && q.properties[0].key.type === "Identifier" && q.properties[0].key.name === "type" && _(q.properties[0].value) && q.properties[0].value.value === "module";
                }
                r.exports = v;
            }
        }), So = te({
            "src/language-js/print/member.js" (e, r) {
                "use strict";
                ne();
                var { builders: { softline: t, group: s, indent: a, label: n } } = qe(), { isNumericLiteral: u, isMemberExpression: i, isCallExpression: l } = Ke(), { printOptionalToken: p } = ct();
                function y(g, c, f) {
                    let F = g.getValue(), _ = g.getParentNode(), w, E = 0;
                    do w = g.getParentNode(E), E++;
                    while (w && (i(w) || w.type === "TSNonNullExpression"));
                    let N = f("object"), x = h(g, c, f), I = w && (w.type === "NewExpression" || w.type === "BindExpression" || w.type === "AssignmentExpression" && w.left.type !== "Identifier") || F.computed || F.object.type === "Identifier" && F.property.type === "Identifier" && !i(_) || (_.type === "AssignmentExpression" || _.type === "VariableDeclarator") && (l(F.object) && F.object.arguments.length > 0 || F.object.type === "TSNonNullExpression" && l(F.object.expression) && F.object.expression.arguments.length > 0 || N.label === "member-chain");
                    return n(N.label === "member-chain" ? "member-chain" : "member", [
                        N,
                        I ? x : s(a([
                            t,
                            x
                        ]))
                    ]);
                }
                function h(g, c, f) {
                    let F = f("property"), _ = g.getValue(), w = p(g);
                    return _.computed ? !_.property || u(_.property) ? [
                        w,
                        "[",
                        F,
                        "]"
                    ] : s([
                        w,
                        "[",
                        a([
                            t,
                            F
                        ]),
                        t,
                        "]"
                    ]) : [
                        w,
                        ".",
                        F
                    ];
                }
                r.exports = {
                    printMemberExpression: y,
                    printMemberLookup: h
                };
            }
        }), md = te({
            "src/language-js/print/member-chain.js" (e, r) {
                "use strict";
                ne();
                var { printComments: t } = et(), { getLast: s, isNextLineEmptyAfterIndex: a, getNextNonSpaceNonCommentCharacterIndex: n } = Ue(), u = qt(), { isCallExpression: i, isMemberExpression: l, isFunctionOrArrowExpression: p, isLongCurriedCallExpression: y, isMemberish: h, isNumericLiteral: g, isSimpleCallArgument: c, hasComment: f, CommentCheckFlags: F, isNextLineEmpty: _ } = Ke(), { locEnd: w } = ut(), { builders: { join: E, hardline: N, group: x, indent: I, conditionalGroup: P, breakParent: $, label: D }, utils: { willBreak: T } } = qe(), m = Ao(), { printMemberLookup: C } = So(), { printOptionalToken: o, printFunctionTypeParameters: d, printBindExpressionCallee: v } = ct();
                function S(b, B, k) {
                    let M = b.getParentNode(), R = !M || M.type === "ExpressionStatement", q = [];
                    function J(Ne) {
                        let { originalText: Pe } = B, oe = n(Pe, Ne, w);
                        return Pe.charAt(oe) === ")" ? oe !== !1 && a(Pe, oe + 1) : _(Ne, B);
                    }
                    function L(Ne) {
                        let Pe = Ne.getValue();
                        i(Pe) && (h(Pe.callee) || i(Pe.callee)) ? (q.unshift({
                            node: Pe,
                            printed: [
                                t(Ne, [
                                    o(Ne),
                                    d(Ne, B, k),
                                    m(Ne, B, k)
                                ], B),
                                J(Pe) ? N : ""
                            ]
                        }), Ne.call((oe)=>L(oe), "callee")) : h(Pe) ? (q.unshift({
                            node: Pe,
                            needsParens: u(Ne, B),
                            printed: t(Ne, l(Pe) ? C(Ne, B, k) : v(Ne, B, k), B)
                        }), Ne.call((oe)=>L(oe), "object")) : Pe.type === "TSNonNullExpression" ? (q.unshift({
                            node: Pe,
                            printed: t(Ne, "!", B)
                        }), Ne.call((oe)=>L(oe), "expression")) : q.unshift({
                            node: Pe,
                            printed: k()
                        });
                    }
                    let Q = b.getValue();
                    q.unshift({
                        node: Q,
                        printed: [
                            o(b),
                            d(b, B, k),
                            m(b, B, k)
                        ]
                    }), Q.callee && b.call((Ne)=>L(Ne), "callee");
                    let V = [], j = [
                        q[0]
                    ], Y = 1;
                    for(; Y < q.length && (q[Y].node.type === "TSNonNullExpression" || i(q[Y].node) || l(q[Y].node) && q[Y].node.computed && g(q[Y].node.property)); ++Y)j.push(q[Y]);
                    if (!i(q[0].node)) for(; Y + 1 < q.length && h(q[Y].node) && h(q[Y + 1].node); ++Y)j.push(q[Y]);
                    V.push(j), j = [];
                    let ie = !1;
                    for(; Y < q.length; ++Y){
                        if (ie && h(q[Y].node)) {
                            if (q[Y].node.computed && g(q[Y].node.property)) {
                                j.push(q[Y]);
                                continue;
                            }
                            V.push(j), j = [], ie = !1;
                        }
                        (i(q[Y].node) || q[Y].node.type === "ImportExpression") && (ie = !0), j.push(q[Y]), f(q[Y].node, F.Trailing) && (V.push(j), j = [], ie = !1);
                    }
                    j.length > 0 && V.push(j);
                    function ee(Ne) {
                        return /^[A-Z]|^[$_]+$/.test(Ne);
                    }
                    function ce(Ne) {
                        return Ne.length <= B.tabWidth;
                    }
                    function W(Ne) {
                        let Pe = Ne[1].length > 0 && Ne[1][0].node.computed;
                        if (Ne[0].length === 1) {
                            let H = Ne[0][0].node;
                            return H.type === "ThisExpression" || H.type === "Identifier" && (ee(H.name) || R && ce(H.name) || Pe);
                        }
                        let oe = s(Ne[0]).node;
                        return l(oe) && oe.property.type === "Identifier" && (ee(oe.property.name) || Pe);
                    }
                    let K = V.length >= 2 && !f(V[1][0].node) && W(V);
                    function de(Ne) {
                        let Pe = Ne.map((oe)=>oe.printed);
                        return Ne.length > 0 && s(Ne).needsParens ? [
                            "(",
                            ...Pe,
                            ")"
                        ] : Pe;
                    }
                    function ue(Ne) {
                        return Ne.length === 0 ? "" : I(x([
                            N,
                            E(N, Ne.map(de))
                        ]));
                    }
                    let Fe = V.map(de), z = Fe, U = K ? 3 : 2, Z = V.flat(), se = Z.slice(1, -1).some((Ne)=>f(Ne.node, F.Leading)) || Z.slice(0, -1).some((Ne)=>f(Ne.node, F.Trailing)) || V[U] && f(V[U][0].node, F.Leading);
                    if (V.length <= U && !se) return y(b) ? z : x(z);
                    let fe = s(V[K ? 1 : 0]).node, ge = !i(fe) && J(fe), he = [
                        de(V[0]),
                        K ? V.slice(1, 2).map(de) : "",
                        ge ? N : "",
                        ue(V.slice(K ? 2 : 1))
                    ], we = q.map((Ne)=>{
                        let { node: Pe } = Ne;
                        return Pe;
                    }).filter(i);
                    function ke() {
                        let Ne = s(s(V)).node, Pe = s(Fe);
                        return i(Ne) && T(Pe) && we.slice(0, -1).some((oe)=>oe.arguments.some(p));
                    }
                    let Re;
                    return se || we.length > 2 && we.some((Ne)=>!Ne.arguments.every((Pe)=>c(Pe, 0))) || Fe.slice(0, -1).some(T) || ke() ? Re = x(he) : Re = [
                        T(z) || ge ? $ : "",
                        P([
                            z,
                            he
                        ])
                    ], D("member-chain", Re);
                }
                r.exports = S;
            }
        }), xo = te({
            "src/language-js/print/call-expression.js" (e, r) {
                "use strict";
                ne();
                var { builders: { join: t, group: s } } = qe(), a = qt(), { getCallArguments: n, hasFlowAnnotationComment: u, isCallExpression: i, isMemberish: l, isStringLiteral: p, isTemplateOnItsOwnLine: y, isTestCall: h, iterateCallArgumentsPath: g } = Ke(), c = md(), f = Ao(), { printOptionalToken: F, printFunctionTypeParameters: _ } = ct();
                function w(N, x, I) {
                    let P = N.getValue(), $ = N.getParentNode(), D = P.type === "NewExpression", T = P.type === "ImportExpression", m = F(N), C = n(P);
                    if (C.length > 0 && (!T && !D && E(P, $) || C.length === 1 && y(C[0], x.originalText) || !D && h(P, $))) {
                        let v = [];
                        return g(N, ()=>{
                            v.push(I());
                        }), [
                            D ? "new " : "",
                            I("callee"),
                            m,
                            _(N, x, I),
                            "(",
                            t(", ", v),
                            ")"
                        ];
                    }
                    let o = (x.parser === "babel" || x.parser === "babel-flow") && P.callee && P.callee.type === "Identifier" && u(P.callee.trailingComments);
                    if (o && (P.callee.trailingComments[0].printed = !0), !T && !D && l(P.callee) && !N.call((v)=>a(v, x), "callee")) return c(N, x, I);
                    let d = [
                        D ? "new " : "",
                        T ? "import" : I("callee"),
                        m,
                        o ? `/*:: ${P.callee.trailingComments[0].value.slice(2).trim()} */` : "",
                        _(N, x, I),
                        f(N, x, I)
                    ];
                    return T || i(P.callee) ? s(d) : d;
                }
                function E(N, x) {
                    if (N.callee.type !== "Identifier") return !1;
                    if (N.callee.name === "require") return !0;
                    if (N.callee.name === "define") {
                        let I = n(N);
                        return x.type === "ExpressionStatement" && (I.length === 1 || I.length === 2 && I[0].type === "ArrayExpression" || I.length === 3 && p(I[0]) && I[1].type === "ArrayExpression");
                    }
                    return !1;
                }
                r.exports = {
                    printCallExpression: w
                };
            }
        }), tr = te({
            "src/language-js/print/assignment.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t, getStringWidth: s } = Ue(), { builders: { line: a, group: n, indent: u, indentIfBreak: i, lineSuffixBoundary: l }, utils: { cleanDoc: p, willBreak: y, canBreak: h } } = qe(), { hasLeadingOwnLineComment: g, isBinaryish: c, isStringLiteral: f, isLiteral: F, isNumericLiteral: _, isCallExpression: w, isMemberExpression: E, getCallArguments: N, rawText: x, hasComment: I, isSignedNumericLiteral: P, isObjectProperty: $ } = Ke(), { shouldInlineLogicalExpression: D } = ru(), { printCallExpression: T } = xo();
                function m(W, K, de, ue, Fe, z) {
                    let U = d(W, K, de, ue, z), Z = de(z, {
                        assignmentLayout: U
                    });
                    switch(U){
                        case "break-after-operator":
                            return n([
                                n(ue),
                                Fe,
                                n(u([
                                    a,
                                    Z
                                ]))
                            ]);
                        case "never-break-after-operator":
                            return n([
                                n(ue),
                                Fe,
                                " ",
                                Z
                            ]);
                        case "fluid":
                            {
                                let se = Symbol("assignment");
                                return n([
                                    n(ue),
                                    Fe,
                                    n(u(a), {
                                        id: se
                                    }),
                                    l,
                                    i(Z, {
                                        groupId: se
                                    })
                                ]);
                            }
                        case "break-lhs":
                            return n([
                                ue,
                                Fe,
                                " ",
                                n(Z)
                            ]);
                        case "chain":
                            return [
                                n(ue),
                                Fe,
                                a,
                                Z
                            ];
                        case "chain-tail":
                            return [
                                n(ue),
                                Fe,
                                u([
                                    a,
                                    Z
                                ])
                            ];
                        case "chain-tail-arrow-chain":
                            return [
                                n(ue),
                                Fe,
                                Z
                            ];
                        case "only-left":
                            return ue;
                    }
                }
                function C(W, K, de) {
                    let ue = W.getValue();
                    return m(W, K, de, de("left"), [
                        " ",
                        ue.operator
                    ], "right");
                }
                function o(W, K, de) {
                    return m(W, K, de, de("id"), " =", "init");
                }
                function d(W, K, de, ue, Fe) {
                    let z = W.getValue(), U = z[Fe];
                    if (!U) return "only-left";
                    let Z = !b(U);
                    if (W.match(b, B, (he)=>!Z || he.type !== "ExpressionStatement" && he.type !== "VariableDeclaration")) return Z ? U.type === "ArrowFunctionExpression" && U.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
                    if (!Z && b(U.right) || g(K.originalText, U)) return "break-after-operator";
                    if (U.type === "CallExpression" && U.callee.name === "require" || K.parser === "json5" || K.parser === "json") return "never-break-after-operator";
                    if (S(z) || k(z) || q(z) || J(z) && h(ue)) return "break-lhs";
                    let ge = ie(z, ue, K);
                    return W.call(()=>v(W, K, de, ge), Fe) ? "break-after-operator" : ge || U.type === "TemplateLiteral" || U.type === "TaggedTemplateExpression" || U.type === "BooleanLiteral" || _(U) || U.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
                }
                function v(W, K, de, ue) {
                    let Fe = W.getValue();
                    if (c(Fe) && !D(Fe)) return !0;
                    switch(Fe.type){
                        case "StringLiteralTypeAnnotation":
                        case "SequenceExpression":
                            return !0;
                        case "ConditionalExpression":
                            {
                                let { test: Z } = Fe;
                                return c(Z) && !D(Z);
                            }
                        case "ClassExpression":
                            return t(Fe.decorators);
                    }
                    if (ue) return !1;
                    let z = Fe, U = [];
                    for(;;)if (z.type === "UnaryExpression") z = z.argument, U.push("argument");
                    else if (z.type === "TSNonNullExpression") z = z.expression, U.push("expression");
                    else break;
                    return !!(f(z) || W.call(()=>V(W, K, de), ...U));
                }
                function S(W) {
                    if (B(W)) {
                        let K = W.left || W.id;
                        return K.type === "ObjectPattern" && K.properties.length > 2 && K.properties.some((de)=>$(de) && (!de.shorthand || de.value && de.value.type === "AssignmentPattern"));
                    }
                    return !1;
                }
                function b(W) {
                    return W.type === "AssignmentExpression";
                }
                function B(W) {
                    return b(W) || W.type === "VariableDeclarator";
                }
                function k(W) {
                    let K = M(W);
                    if (t(K)) {
                        let de = W.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
                        if (K.length > 1 && K.some((ue)=>ue[de] || ue.default)) return !0;
                    }
                    return !1;
                }
                function M(W) {
                    return R(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
                }
                function R(W) {
                    return W.type === "TSTypeAliasDeclaration" || W.type === "TypeAlias";
                }
                function q(W) {
                    if (W.type !== "VariableDeclarator") return !1;
                    let { typeAnnotation: K } = W.id;
                    if (!K || !K.typeAnnotation) return !1;
                    let de = L(K.typeAnnotation);
                    return t(de) && de.length > 1 && de.some((ue)=>t(L(ue)) || ue.type === "TSConditionalType");
                }
                function J(W) {
                    return W.type === "VariableDeclarator" && W.init && W.init.type === "ArrowFunctionExpression";
                }
                function L(W) {
                    return Q(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
                }
                function Q(W) {
                    return W.type === "TSTypeReference" || W.type === "GenericTypeAnnotation";
                }
                function V(W, K, de) {
                    let ue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, Fe = W.getValue(), z = ()=>V(W, K, de, !0);
                    if (Fe.type === "TSNonNullExpression") return W.call(z, "expression");
                    if (w(Fe)) {
                        if (T(W, K, de).label === "member-chain") return !1;
                        let Z = N(Fe);
                        return !(Z.length === 0 || Z.length === 1 && Y(Z[0], K)) || ee(Fe, de) ? !1 : W.call(z, "callee");
                    }
                    return E(Fe) ? W.call(z, "object") : ue && (Fe.type === "Identifier" || Fe.type === "ThisExpression");
                }
                var j = .25;
                function Y(W, K) {
                    let { printWidth: de } = K;
                    if (I(W)) return !1;
                    let ue = de * j;
                    if (W.type === "ThisExpression" || W.type === "Identifier" && W.name.length <= ue || P(W) && !I(W.argument)) return !0;
                    let Fe = W.type === "Literal" && "regex" in W && W.regex.pattern || W.type === "RegExpLiteral" && W.pattern;
                    return Fe ? Fe.length <= ue : f(W) ? x(W).length <= ue : W.type === "TemplateLiteral" ? W.expressions.length === 0 && W.quasis[0].value.raw.length <= ue && !W.quasis[0].value.raw.includes(`
`) : F(W);
                }
                function ie(W, K, de) {
                    if (!$(W)) return !1;
                    K = p(K);
                    let ue = 3;
                    return typeof K == "string" && s(K) < de.tabWidth + ue;
                }
                function ee(W, K) {
                    let de = ce(W);
                    if (t(de)) {
                        if (de.length > 1) return !0;
                        if (de.length === 1) {
                            let Fe = de[0];
                            if (Fe.type === "TSUnionType" || Fe.type === "UnionTypeAnnotation" || Fe.type === "TSIntersectionType" || Fe.type === "IntersectionTypeAnnotation" || Fe.type === "TSTypeLiteral" || Fe.type === "ObjectTypeAnnotation") return !0;
                        }
                        let ue = W.typeParameters ? "typeParameters" : "typeArguments";
                        if (y(K(ue))) return !0;
                    }
                    return !1;
                }
                function ce(W) {
                    return W.typeParameters && W.typeParameters.params || W.typeArguments && W.typeArguments.params;
                }
                r.exports = {
                    printVariableDeclarator: o,
                    printAssignmentExpression: C,
                    printAssignment: m,
                    isArrowFunctionVariableDeclarator: J
                };
            }
        }), Lr = te({
            "src/language-js/print/function-parameters.js" (e, r) {
                "use strict";
                ne();
                var { getNextNonSpaceNonCommentCharacter: t } = Ue(), { printDanglingComments: s } = et(), { builders: { line: a, hardline: n, softline: u, group: i, indent: l, ifBreak: p }, utils: { removeLines: y, willBreak: h } } = qe(), { getFunctionParameters: g, iterateFunctionParametersPath: c, isSimpleType: f, isTestCall: F, isTypeAnnotationAFunction: _, isObjectType: w, isObjectTypePropertyAFunction: E, hasRestParameter: N, shouldPrintComma: x, hasComment: I, isNextLineEmpty: P } = Ke(), { locEnd: $ } = ut(), { ArgExpansionBailout: D } = Qt(), { printFunctionTypeParameters: T } = ct();
                function m(v, S, b, B, k) {
                    let M = v.getValue(), R = g(M), q = k ? T(v, b, S) : "";
                    if (R.length === 0) return [
                        q,
                        "(",
                        s(v, b, !0, (ie)=>t(b.originalText, ie, $) === ")"),
                        ")"
                    ];
                    let J = v.getParentNode(), L = F(J), Q = C(M), V = [];
                    if (c(v, (ie, ee)=>{
                        let ce = ee === R.length - 1;
                        ce && M.rest && V.push("..."), V.push(S()), !ce && (V.push(","), L || Q ? V.push(" ") : P(R[ee], b) ? V.push(n, n) : V.push(a));
                    }), B) {
                        if (h(q) || h(V)) throw new D;
                        return i([
                            y(q),
                            "(",
                            y(V),
                            ")"
                        ]);
                    }
                    let j = R.every((ie)=>!ie.decorators);
                    return Q && j ? [
                        q,
                        "(",
                        ...V,
                        ")"
                    ] : L ? [
                        q,
                        "(",
                        ...V,
                        ")"
                    ] : (E(J) || _(J) || J.type === "TypeAlias" || J.type === "UnionTypeAnnotation" || J.type === "TSUnionType" || J.type === "IntersectionTypeAnnotation" || J.type === "FunctionTypeAnnotation" && J.returnType === M) && R.length === 1 && R[0].name === null && M.this !== R[0] && R[0].typeAnnotation && M.typeParameters === null && f(R[0].typeAnnotation) && !M.rest ? b.arrowParens === "always" ? [
                        "(",
                        ...V,
                        ")"
                    ] : V : [
                        q,
                        "(",
                        l([
                            u,
                            ...V
                        ]),
                        p(!N(M) && x(b, "all") ? "," : ""),
                        u,
                        ")"
                    ];
                }
                function C(v) {
                    if (!v) return !1;
                    let S = g(v);
                    if (S.length !== 1) return !1;
                    let [b] = S;
                    return !I(b) && (b.type === "ObjectPattern" || b.type === "ArrayPattern" || b.type === "Identifier" && b.typeAnnotation && (b.typeAnnotation.type === "TypeAnnotation" || b.typeAnnotation.type === "TSTypeAnnotation") && w(b.typeAnnotation.typeAnnotation) || b.type === "FunctionTypeParam" && w(b.typeAnnotation) || b.type === "AssignmentPattern" && (b.left.type === "ObjectPattern" || b.left.type === "ArrayPattern") && (b.right.type === "Identifier" || b.right.type === "ObjectExpression" && b.right.properties.length === 0 || b.right.type === "ArrayExpression" && b.right.elements.length === 0));
                }
                function o(v) {
                    let S;
                    return v.returnType ? (S = v.returnType, S.typeAnnotation && (S = S.typeAnnotation)) : v.typeAnnotation && (S = v.typeAnnotation), S;
                }
                function d(v, S) {
                    let b = o(v);
                    if (!b) return !1;
                    let B = v.typeParameters && v.typeParameters.params;
                    if (B) {
                        if (B.length > 1) return !1;
                        if (B.length === 1) {
                            let k = B[0];
                            if (k.constraint || k.default) return !1;
                        }
                    }
                    return g(v).length === 1 && (w(b) || h(S));
                }
                r.exports = {
                    printFunctionParameters: m,
                    shouldHugFunctionParameters: C,
                    shouldGroupFunctionParameters: d
                };
            }
        }), Or = te({
            "src/language-js/print/type-annotation.js" (e, r) {
                "use strict";
                ne();
                var { printComments: t, printDanglingComments: s } = et(), { isNonEmptyArray: a } = Ue(), { builders: { group: n, join: u, line: i, softline: l, indent: p, align: y, ifBreak: h } } = qe(), g = qt(), { locStart: c } = ut(), { isSimpleType: f, isObjectType: F, hasLeadingOwnLineComment: _, isObjectTypePropertyAFunction: w, shouldPrintComma: E } = Ke(), { printAssignment: N } = tr(), { printFunctionParameters: x, shouldGroupFunctionParameters: I } = Lr(), { printArrayItems: P } = er();
                function $(b) {
                    if (f(b) || F(b)) return !0;
                    if (b.type === "UnionTypeAnnotation" || b.type === "TSUnionType") {
                        let B = b.types.filter((M)=>M.type === "VoidTypeAnnotation" || M.type === "TSVoidKeyword" || M.type === "NullLiteralTypeAnnotation" || M.type === "TSNullKeyword").length, k = b.types.some((M)=>M.type === "ObjectTypeAnnotation" || M.type === "TSTypeLiteral" || M.type === "GenericTypeAnnotation" || M.type === "TSTypeReference");
                        if (b.types.length - 1 === B && k) return !0;
                    }
                    return !1;
                }
                function D(b, B, k) {
                    let M = B.semi ? ";" : "", R = b.getValue(), q = [];
                    return q.push("opaque type ", k("id"), k("typeParameters")), R.supertype && q.push(": ", k("supertype")), R.impltype && q.push(" = ", k("impltype")), q.push(M), q;
                }
                function T(b, B, k) {
                    let M = B.semi ? ";" : "", R = b.getValue(), q = [];
                    R.declare && q.push("declare "), q.push("type ", k("id"), k("typeParameters"));
                    let J = R.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
                    return [
                        N(b, B, k, q, " =", J),
                        M
                    ];
                }
                function m(b, B, k) {
                    let M = b.getValue(), R = b.map(k, "types"), q = [], J = !1;
                    for(let L = 0; L < R.length; ++L)L === 0 ? q.push(R[L]) : F(M.types[L - 1]) && F(M.types[L]) ? q.push([
                        " & ",
                        J ? p(R[L]) : R[L]
                    ]) : !F(M.types[L - 1]) && !F(M.types[L]) ? q.push(p([
                        " &",
                        i,
                        R[L]
                    ])) : (L > 1 && (J = !0), q.push(" & ", L > 1 ? p(R[L]) : R[L]));
                    return n(q);
                }
                function C(b, B, k) {
                    let M = b.getValue(), R = b.getParentNode(), q = R.type !== "TypeParameterInstantiation" && R.type !== "TSTypeParameterInstantiation" && R.type !== "GenericTypeAnnotation" && R.type !== "TSTypeReference" && R.type !== "TSTypeAssertion" && R.type !== "TupleTypeAnnotation" && R.type !== "TSTupleType" && !(R.type === "FunctionTypeParam" && !R.name && b.getParentNode(1).this !== R) && !((R.type === "TypeAlias" || R.type === "VariableDeclarator" || R.type === "TSTypeAliasDeclaration") && _(B.originalText, M)), J = $(M), L = b.map((j)=>{
                        let Y = k();
                        return J || (Y = y(2, Y)), t(j, Y, B);
                    }, "types");
                    if (J) return u(" | ", L);
                    let Q = q && !_(B.originalText, M), V = [
                        h([
                            Q ? i : "",
                            "| "
                        ]),
                        u([
                            i,
                            "| "
                        ], L)
                    ];
                    return g(b, B) ? n([
                        p(V),
                        l
                    ]) : R.type === "TupleTypeAnnotation" && R.types.length > 1 || R.type === "TSTupleType" && R.elementTypes.length > 1 ? n([
                        p([
                            h([
                                "(",
                                l
                            ]),
                            V
                        ]),
                        l,
                        h(")")
                    ]) : n(q ? p(V) : V);
                }
                function o(b, B, k) {
                    let M = b.getValue(), R = [], q = b.getParentNode(0), J = b.getParentNode(1), L = b.getParentNode(2), Q = M.type === "TSFunctionType" || !((q.type === "ObjectTypeProperty" || q.type === "ObjectTypeInternalSlot") && !q.variance && !q.optional && c(q) === c(M) || q.type === "ObjectTypeCallProperty" || L && L.type === "DeclareFunction"), V = Q && (q.type === "TypeAnnotation" || q.type === "TSTypeAnnotation"), j = V && Q && (q.type === "TypeAnnotation" || q.type === "TSTypeAnnotation") && J.type === "ArrowFunctionExpression";
                    w(q) && (Q = !0, V = !0), j && R.push("(");
                    let Y = x(b, k, B, !1, !0), ie = M.returnType || M.predicate || M.typeAnnotation ? [
                        Q ? " => " : ": ",
                        k("returnType"),
                        k("predicate"),
                        k("typeAnnotation")
                    ] : "", ee = I(M, ie);
                    return R.push(ee ? n(Y) : Y), ie && R.push(ie), j && R.push(")"), n(R);
                }
                function d(b, B, k) {
                    let M = b.getValue(), R = M.type === "TSTupleType" ? "elementTypes" : "types", q = M[R], J = a(q), L = J ? l : "";
                    return n([
                        "[",
                        p([
                            L,
                            P(b, B, R, k)
                        ]),
                        h(J && E(B, "all") ? "," : ""),
                        s(b, B, !0),
                        L,
                        "]"
                    ]);
                }
                function v(b, B, k) {
                    let M = b.getValue(), R = M.type === "OptionalIndexedAccessType" && M.optional ? "?.[" : "[";
                    return [
                        k("objectType"),
                        R,
                        k("indexType"),
                        "]"
                    ];
                }
                function S(b, B, k) {
                    let M = b.getValue();
                    return [
                        M.postfix ? "" : k,
                        B("typeAnnotation"),
                        M.postfix ? k : ""
                    ];
                }
                r.exports = {
                    printOpaqueType: D,
                    printTypeAlias: T,
                    printIntersectionType: m,
                    printUnionType: C,
                    printFunctionType: o,
                    printTupleType: d,
                    printIndexedAccessType: v,
                    shouldHugType: $,
                    printJSDocType: S
                };
            }
        }), jr = te({
            "src/language-js/print/type-parameters.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { builders: { join: s, line: a, hardline: n, softline: u, group: i, indent: l, ifBreak: p } } = qe(), { isTestCall: y, hasComment: h, CommentCheckFlags: g, isTSXFile: c, shouldPrintComma: f, getFunctionParameters: F, isObjectType: _, getTypeScriptMappedTypeModifier: w } = Ke(), { createGroupIdMapper: E } = Ue(), { shouldHugType: N } = Or(), { isArrowFunctionVariableDeclarator: x } = tr(), I = E("typeParameters");
                function P(T, m, C, o) {
                    let d = T.getValue();
                    if (!d[o]) return "";
                    if (!Array.isArray(d[o])) return C(o);
                    let v = T.getNode(2), S = v && y(v), b = T.match((M)=>!(M[o].length === 1 && _(M[o][0])), void 0, (M, R)=>R === "typeAnnotation", (M)=>M.type === "Identifier", x);
                    if (d[o].length === 0 || !b && (S || d[o].length === 1 && (d[o][0].type === "NullableTypeAnnotation" || N(d[o][0])))) return [
                        "<",
                        s(", ", T.map(C, o)),
                        $(T, m),
                        ">"
                    ];
                    let k = d.type === "TSTypeParameterInstantiation" ? "" : F(d).length === 1 && c(m) && !d[o][0].constraint && T.getParentNode().type === "ArrowFunctionExpression" ? "," : f(m, "all") ? p(",") : "";
                    return i([
                        "<",
                        l([
                            u,
                            s([
                                ",",
                                a
                            ], T.map(C, o))
                        ]),
                        k,
                        u,
                        ">"
                    ], {
                        id: I(d)
                    });
                }
                function $(T, m) {
                    let C = T.getValue();
                    if (!h(C, g.Dangling)) return "";
                    let o = !h(C, g.Line), d = t(T, m, o);
                    return o ? d : [
                        d,
                        n
                    ];
                }
                function D(T, m, C) {
                    let o = T.getValue(), d = [
                        o.type === "TSTypeParameter" && o.const ? "const " : ""
                    ], v = T.getParentNode();
                    return v.type === "TSMappedType" ? (v.readonly && d.push(w(v.readonly, "readonly"), " "), d.push("[", C("name")), o.constraint && d.push(" in ", C("constraint")), v.nameType && d.push(" as ", T.callParent(()=>C("nameType"))), d.push("]"), d) : (o.variance && d.push(C("variance")), o.in && d.push("in "), o.out && d.push("out "), d.push(C("name")), o.bound && d.push(": ", C("bound")), o.constraint && d.push(" extends ", C("constraint")), o.default && d.push(" = ", C("default")), d);
                }
                r.exports = {
                    printTypeParameter: D,
                    printTypeParameters: P,
                    getTypeParametersGroupId: I
                };
            }
        }), rr = te({
            "src/language-js/print/property.js" (e, r) {
                "use strict";
                ne();
                var { printComments: t } = et(), { printString: s, printNumber: a } = Ue(), { isNumericLiteral: n, isSimpleNumber: u, isStringLiteral: i, isStringPropSafeToUnquote: l, rawText: p } = Ke(), { printAssignment: y } = tr(), h = new WeakMap;
                function g(f, F, _) {
                    let w = f.getNode();
                    if (w.computed) return [
                        "[",
                        _("key"),
                        "]"
                    ];
                    let E = f.getParentNode(), { key: N } = w;
                    if (F.quoteProps === "consistent" && !h.has(E)) {
                        let x = (E.properties || E.body || E.members).some((I)=>!I.computed && I.key && i(I.key) && !l(I, F));
                        h.set(E, x);
                    }
                    if ((N.type === "Identifier" || n(N) && u(a(p(N))) && String(N.value) === a(p(N)) && !(F.parser === "typescript" || F.parser === "babel-ts")) && (F.parser === "json" || F.quoteProps === "consistent" && h.get(E))) {
                        let x = s(JSON.stringify(N.type === "Identifier" ? N.name : N.value.toString()), F);
                        return f.call((I)=>t(I, x, F), "key");
                    }
                    return l(w, F) && (F.quoteProps === "as-needed" || F.quoteProps === "consistent" && !h.get(E)) ? f.call((x)=>t(x, /^\d/.test(N.value) ? a(N.value) : N.value, F), "key") : _("key");
                }
                function c(f, F, _) {
                    return f.getValue().shorthand ? _("value") : y(f, F, _, g(f, F, _), ":", "value");
                }
                r.exports = {
                    printProperty: c,
                    printPropertyKey: g
                };
            }
        }), qr = te({
            "src/language-js/print/function.js" (e, r) {
                "use strict";
                ne();
                var t = Zt(), { printDanglingComments: s, printCommentsSeparately: a } = et(), n = lt(), { getNextNonSpaceNonCommentCharacterIndex: u } = Ue(), { builders: { line: i, softline: l, group: p, indent: y, ifBreak: h, hardline: g, join: c, indentIfBreak: f }, utils: { removeLines: F, willBreak: _ } } = qe(), { ArgExpansionBailout: w } = Qt(), { getFunctionParameters: E, hasLeadingOwnLineComment: N, isFlowAnnotationComment: x, isJsxNode: I, isTemplateOnItsOwnLine: P, shouldPrintComma: $, startsWithNoLookaheadToken: D, isBinaryish: T, isLineComment: m, hasComment: C, getComments: o, CommentCheckFlags: d, isCallLikeExpression: v, isCallExpression: S, getCallArguments: b, hasNakedLeftSide: B, getLeftSide: k } = Ke(), { locEnd: M } = ut(), { printFunctionParameters: R, shouldGroupFunctionParameters: q } = Lr(), { printPropertyKey: J } = rr(), { printFunctionTypeParameters: L } = ct();
                function Q(U, Z, se, fe) {
                    let ge = U.getValue(), he = !1;
                    if ((ge.type === "FunctionDeclaration" || ge.type === "FunctionExpression") && fe && fe.expandLastArg) {
                        let Pe = U.getParentNode();
                        S(Pe) && b(Pe).length > 1 && (he = !0);
                    }
                    let we = [];
                    ge.type === "TSDeclareFunction" && ge.declare && we.push("declare "), ge.async && we.push("async "), ge.generator ? we.push("function* ") : we.push("function "), ge.id && we.push(Z("id"));
                    let ke = R(U, Z, se, he), Re = K(U, Z, se), Ne = q(ge, Re);
                    return we.push(L(U, se, Z), p([
                        Ne ? p(ke) : ke,
                        Re
                    ]), ge.body ? " " : "", Z("body")), se.semi && (ge.declare || !ge.body) && we.push(";"), we;
                }
                function V(U, Z, se) {
                    let fe = U.getNode(), { kind: ge } = fe, he = fe.value || fe, we = [];
                    return !ge || ge === "init" || ge === "method" || ge === "constructor" ? he.async && we.push("async ") : (t.ok(ge === "get" || ge === "set"), we.push(ge, " ")), he.generator && we.push("*"), we.push(J(U, Z, se), fe.optional || fe.key.optional ? "?" : ""), fe === he ? we.push(j(U, Z, se)) : he.type === "FunctionExpression" ? we.push(U.call((ke)=>j(ke, Z, se), "value")) : we.push(se("value")), we;
                }
                function j(U, Z, se) {
                    let fe = U.getNode(), ge = R(U, se, Z), he = K(U, se, Z), we = q(fe, he), ke = [
                        L(U, Z, se),
                        p([
                            we ? p(ge) : ge,
                            he
                        ])
                    ];
                    return fe.body ? ke.push(" ", se("body")) : ke.push(Z.semi ? ";" : ""), ke;
                }
                function Y(U, Z, se, fe) {
                    let ge = U.getValue(), he = [];
                    if (ge.async && he.push("async "), W(U, Z)) he.push(se([
                        "params",
                        0
                    ]));
                    else {
                        let ke = fe && (fe.expandLastArg || fe.expandFirstArg), Re = K(U, se, Z);
                        if (ke) {
                            if (_(Re)) throw new w;
                            Re = p(F(Re));
                        }
                        he.push(p([
                            R(U, se, Z, ke, !0),
                            Re
                        ]));
                    }
                    let we = s(U, Z, !0, (ke)=>{
                        let Re = u(Z.originalText, ke, M);
                        return Re !== !1 && Z.originalText.slice(Re, Re + 2) === "=>";
                    });
                    return we && he.push(" ", we), he;
                }
                function ie(U, Z, se, fe, ge, he) {
                    let we = U.getName(), ke = U.getParentNode(), Re = v(ke) && we === "callee", Ne = Boolean(Z && Z.assignmentLayout), Pe = he.body.type !== "BlockStatement" && he.body.type !== "ObjectExpression" && he.body.type !== "SequenceExpression", oe = Re && Pe || Z && Z.assignmentLayout === "chain-tail-arrow-chain", H = Symbol("arrow-chain");
                    return he.body.type === "SequenceExpression" && (ge = p([
                        "(",
                        y([
                            l,
                            ge
                        ]),
                        l,
                        ")"
                    ])), p([
                        p(y([
                            Re || Ne ? l : "",
                            p(c([
                                " =>",
                                i
                            ], se), {
                                shouldBreak: fe
                            })
                        ]), {
                            id: H,
                            shouldBreak: oe
                        }),
                        " =>",
                        f(Pe ? y([
                            i,
                            ge
                        ]) : [
                            " ",
                            ge
                        ], {
                            groupId: H
                        }),
                        Re ? h(l, "", {
                            groupId: H
                        }) : ""
                    ]);
                }
                function ee(U, Z, se, fe) {
                    let ge = U.getValue(), he = [], we = [], ke = !1;
                    if (function H() {
                        let pe = Y(U, Z, se, fe);
                        if (he.length === 0) he.push(pe);
                        else {
                            let { leading: X, trailing: le } = a(U, Z);
                            he.push([
                                X,
                                pe
                            ]), we.unshift(le);
                        }
                        ke = ke || ge.returnType && E(ge).length > 0 || ge.typeParameters || E(ge).some((X)=>X.type !== "Identifier"), ge.body.type !== "ArrowFunctionExpression" || fe && fe.expandLastArg ? we.unshift(se("body", fe)) : (ge = ge.body, U.call(H, "body"));
                    }(), he.length > 1) return ie(U, fe, he, ke, we, ge);
                    let Re = he;
                    if (Re.push(" =>"), !N(Z.originalText, ge.body) && (ge.body.type === "ArrayExpression" || ge.body.type === "ObjectExpression" || ge.body.type === "BlockStatement" || I(ge.body) || P(ge.body, Z.originalText) || ge.body.type === "ArrowFunctionExpression" || ge.body.type === "DoExpression")) return p([
                        ...Re,
                        " ",
                        we
                    ]);
                    if (ge.body.type === "SequenceExpression") return p([
                        ...Re,
                        p([
                            " (",
                            y([
                                l,
                                we
                            ]),
                            l,
                            ")"
                        ])
                    ]);
                    let Ne = (fe && fe.expandLastArg || U.getParentNode().type === "JSXExpressionContainer") && !C(ge), Pe = fe && fe.expandLastArg && $(Z, "all"), oe = ge.body.type === "ConditionalExpression" && !D(ge.body, (H)=>H.type === "ObjectExpression");
                    return p([
                        ...Re,
                        p([
                            y([
                                i,
                                oe ? h("", "(") : "",
                                we,
                                oe ? h("", ")") : ""
                            ]),
                            Ne ? [
                                h(Pe ? "," : ""),
                                l
                            ] : ""
                        ])
                    ]);
                }
                function ce(U) {
                    let Z = E(U);
                    return Z.length === 1 && !U.typeParameters && !C(U, d.Dangling) && Z[0].type === "Identifier" && !Z[0].typeAnnotation && !C(Z[0]) && !Z[0].optional && !U.predicate && !U.returnType;
                }
                function W(U, Z) {
                    if (Z.arrowParens === "always") return !1;
                    if (Z.arrowParens === "avoid") {
                        let se = U.getValue();
                        return ce(se);
                    }
                    return !1;
                }
                function K(U, Z, se) {
                    let fe = U.getValue(), ge = Z("returnType");
                    if (fe.returnType && x(se.originalText, fe.returnType)) return [
                        " /*: ",
                        ge,
                        " */"
                    ];
                    let he = [
                        ge
                    ];
                    return fe.returnType && fe.returnType.typeAnnotation && he.unshift(": "), fe.predicate && he.push(fe.returnType ? " " : ": ", Z("predicate")), he;
                }
                function de(U, Z, se) {
                    let fe = U.getValue(), ge = Z.semi ? ";" : "", he = [];
                    fe.argument && (z(Z, fe.argument) ? he.push([
                        " (",
                        y([
                            g,
                            se("argument")
                        ]),
                        g,
                        ")"
                    ]) : T(fe.argument) || fe.argument.type === "SequenceExpression" ? he.push(p([
                        h(" (", " "),
                        y([
                            l,
                            se("argument")
                        ]),
                        l,
                        h(")")
                    ])) : he.push(" ", se("argument")));
                    let we = o(fe), ke = n(we), Re = ke && m(ke);
                    return Re && he.push(ge), C(fe, d.Dangling) && he.push(" ", s(U, Z, !0)), Re || he.push(ge), he;
                }
                function ue(U, Z, se) {
                    return [
                        "return",
                        de(U, Z, se)
                    ];
                }
                function Fe(U, Z, se) {
                    return [
                        "throw",
                        de(U, Z, se)
                    ];
                }
                function z(U, Z) {
                    if (N(U.originalText, Z)) return !0;
                    if (B(Z)) {
                        let se = Z, fe;
                        for(; fe = k(se);)if (se = fe, N(U.originalText, se)) return !0;
                    }
                    return !1;
                }
                r.exports = {
                    printFunction: Q,
                    printArrowFunction: ee,
                    printMethod: V,
                    printReturnStatement: ue,
                    printThrowStatement: Fe,
                    printMethodInternal: j,
                    shouldPrintParamsWithoutParens: W
                };
            }
        }), nu = te({
            "src/language-js/print/decorators.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t, hasNewline: s } = Ue(), { builders: { line: a, hardline: n, join: u, breakParent: i, group: l } } = qe(), { locStart: p, locEnd: y } = ut(), { getParentExportDeclaration: h } = Ke();
                function g(w, E, N) {
                    let x = w.getValue();
                    return l([
                        u(a, w.map(N, "decorators")),
                        F(x, E) ? n : a
                    ]);
                }
                function c(w, E, N) {
                    return [
                        u(n, w.map(N, "declaration", "decorators")),
                        n
                    ];
                }
                function f(w, E, N) {
                    let x = w.getValue(), { decorators: I } = x;
                    if (!t(I) || _(w.getParentNode())) return;
                    let P = x.type === "ClassExpression" || x.type === "ClassDeclaration" || F(x, E);
                    return [
                        h(w) ? n : P ? i : "",
                        u(a, w.map(N, "decorators")),
                        a
                    ];
                }
                function F(w, E) {
                    return w.decorators.some((N)=>s(E.originalText, y(N)));
                }
                function _(w) {
                    if (w.type !== "ExportDefaultDeclaration" && w.type !== "ExportNamedDeclaration" && w.type !== "DeclareExportDeclaration") return !1;
                    let E = w.declaration && w.declaration.decorators;
                    return t(E) && p(w) === p(E[0]);
                }
                r.exports = {
                    printDecorators: f,
                    printClassMemberDecorators: g,
                    printDecoratorsBeforeExport: c,
                    hasDecoratorsBeforeExport: _
                };
            }
        }), nr = te({
            "src/language-js/print/class.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t, createGroupIdMapper: s } = Ue(), { printComments: a, printDanglingComments: n } = et(), { builders: { join: u, line: i, hardline: l, softline: p, group: y, indent: h, ifBreak: g } } = qe(), { hasComment: c, CommentCheckFlags: f } = Ke(), { getTypeParametersGroupId: F } = jr(), { printMethod: _ } = qr(), { printOptionalToken: w, printTypeAnnotation: E, printDefiniteToken: N } = ct(), { printPropertyKey: x } = rr(), { printAssignment: I } = tr(), { printClassMemberDecorators: P } = nu();
                function $(b, B, k) {
                    let M = b.getValue(), R = [];
                    M.declare && R.push("declare "), M.abstract && R.push("abstract "), R.push("class");
                    let q = M.id && c(M.id, f.Trailing) || M.typeParameters && c(M.typeParameters, f.Trailing) || M.superClass && c(M.superClass) || t(M.extends) || t(M.mixins) || t(M.implements), J = [], L = [];
                    if (M.id && J.push(" ", k("id")), J.push(k("typeParameters")), M.superClass) {
                        let Q = [
                            d(b, B, k),
                            k("superTypeParameters")
                        ], V = b.call((j)=>[
                                "extends ",
                                a(j, Q, B)
                            ], "superClass");
                        q ? L.push(i, y(V)) : L.push(" ", V);
                    } else L.push(o(b, B, k, "extends"));
                    if (L.push(o(b, B, k, "mixins"), o(b, B, k, "implements")), q) {
                        let Q;
                        C(M) ? Q = [
                            ...J,
                            h(L)
                        ] : Q = h([
                            ...J,
                            L
                        ]), R.push(y(Q, {
                            id: D(M)
                        }));
                    } else R.push(...J, ...L);
                    return R.push(" ", k("body")), R;
                }
                var D = s("heritageGroup");
                function T(b) {
                    return g(l, "", {
                        groupId: D(b)
                    });
                }
                function m(b) {
                    return [
                        "superClass",
                        "extends",
                        "mixins",
                        "implements"
                    ].filter((B)=>Boolean(b[B])).length > 1;
                }
                function C(b) {
                    return b.typeParameters && !c(b.typeParameters, f.Trailing | f.Line) && !m(b);
                }
                function o(b, B, k, M) {
                    let R = b.getValue();
                    if (!t(R[M])) return "";
                    let q = n(b, B, !0, (J)=>{
                        let { marker: L } = J;
                        return L === M;
                    });
                    return [
                        C(R) ? g(" ", i, {
                            groupId: F(R.typeParameters)
                        }) : i,
                        q,
                        q && l,
                        M,
                        y(h([
                            i,
                            u([
                                ",",
                                i
                            ], b.map(k, M))
                        ]))
                    ];
                }
                function d(b, B, k) {
                    let M = k("superClass");
                    return b.getParentNode().type === "AssignmentExpression" ? y(g([
                        "(",
                        h([
                            p,
                            M
                        ]),
                        p,
                        ")"
                    ], M)) : M;
                }
                function v(b, B, k) {
                    let M = b.getValue(), R = [];
                    return t(M.decorators) && R.push(P(b, B, k)), M.accessibility && R.push(M.accessibility + " "), M.readonly && R.push("readonly "), M.declare && R.push("declare "), M.static && R.push("static "), (M.type === "TSAbstractMethodDefinition" || M.abstract) && R.push("abstract "), M.override && R.push("override "), R.push(_(b, B, k)), R;
                }
                function S(b, B, k) {
                    let M = b.getValue(), R = [], q = B.semi ? ";" : "";
                    return t(M.decorators) && R.push(P(b, B, k)), M.accessibility && R.push(M.accessibility + " "), M.declare && R.push("declare "), M.static && R.push("static "), (M.type === "TSAbstractPropertyDefinition" || M.type === "TSAbstractAccessorProperty" || M.abstract) && R.push("abstract "), M.override && R.push("override "), M.readonly && R.push("readonly "), M.variance && R.push(k("variance")), (M.type === "ClassAccessorProperty" || M.type === "AccessorProperty" || M.type === "TSAbstractAccessorProperty") && R.push("accessor "), R.push(x(b, B, k), w(b), N(b), E(b, B, k)), [
                        I(b, B, k, R, " =", "value"),
                        q
                    ];
                }
                r.exports = {
                    printClass: $,
                    printClassMethod: v,
                    printClassProperty: S,
                    printHardlineAfterHeritage: T
                };
            }
        }), bo = te({
            "src/language-js/print/interface.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t } = Ue(), { builders: { join: s, line: a, group: n, indent: u, ifBreak: i } } = qe(), { hasComment: l, identity: p, CommentCheckFlags: y } = Ke(), { getTypeParametersGroupId: h } = jr(), { printTypeScriptModifiers: g } = ct();
                function c(f, F, _) {
                    let w = f.getValue(), E = [];
                    w.declare && E.push("declare "), w.type === "TSInterfaceDeclaration" && E.push(w.abstract ? "abstract " : "", g(f, F, _)), E.push("interface");
                    let N = [], x = [];
                    w.type !== "InterfaceTypeAnnotation" && N.push(" ", _("id"), _("typeParameters"));
                    let I = w.typeParameters && !l(w.typeParameters, y.Trailing | y.Line);
                    return t(w.extends) && x.push(I ? i(" ", a, {
                        groupId: h(w.typeParameters)
                    }) : a, "extends ", (w.extends.length === 1 ? p : u)(s([
                        ",",
                        a
                    ], f.map(_, "extends")))), w.id && l(w.id, y.Trailing) || t(w.extends) ? I ? E.push(n([
                        ...N,
                        u(x)
                    ])) : E.push(n(u([
                        ...N,
                        ...x
                    ]))) : E.push(...N, ...x), E.push(" ", _("body")), n(E);
                }
                r.exports = {
                    printInterface: c
                };
            }
        }), To = te({
            "src/language-js/print/module.js" (e, r) {
                "use strict";
                ne();
                var { isNonEmptyArray: t } = Ue(), { builders: { softline: s, group: a, indent: n, join: u, line: i, ifBreak: l, hardline: p } } = qe(), { printDanglingComments: y } = et(), { hasComment: h, CommentCheckFlags: g, shouldPrintComma: c, needsHardlineAfterDanglingComment: f, isStringLiteral: F, rawText: _ } = Ke(), { locStart: w, hasSameLoc: E } = ut(), { hasDecoratorsBeforeExport: N, printDecoratorsBeforeExport: x } = nu();
                function I(S, b, B) {
                    let k = S.getValue(), M = b.semi ? ";" : "", R = [], { importKind: q } = k;
                    return R.push("import"), q && q !== "value" && R.push(" ", q), R.push(m(S, b, B), T(S, b, B), o(S, b, B), M), R;
                }
                function P(S, b, B) {
                    let k = S.getValue(), M = [];
                    N(k) && M.push(x(S, b, B));
                    let { type: R, exportKind: q, declaration: J } = k;
                    return M.push("export"), (k.default || R === "ExportDefaultDeclaration") && M.push(" default"), h(k, g.Dangling) && (M.push(" ", y(S, b, !0)), f(k) && M.push(p)), J ? M.push(" ", B("declaration")) : M.push(q === "type" ? " type" : "", m(S, b, B), T(S, b, B), o(S, b, B)), D(k, b) && M.push(";"), M;
                }
                function $(S, b, B) {
                    let k = S.getValue(), M = b.semi ? ";" : "", R = [], { exportKind: q, exported: J } = k;
                    return R.push("export"), q === "type" && R.push(" type"), R.push(" *"), J && R.push(" as ", B("exported")), R.push(T(S, b, B), o(S, b, B), M), R;
                }
                function D(S, b) {
                    if (!b.semi) return !1;
                    let { type: B, declaration: k } = S, M = S.default || B === "ExportDefaultDeclaration";
                    if (!k) return !0;
                    let { type: R } = k;
                    return !!(M && R !== "ClassDeclaration" && R !== "FunctionDeclaration" && R !== "TSInterfaceDeclaration" && R !== "DeclareClass" && R !== "DeclareFunction" && R !== "TSDeclareFunction" && R !== "EnumDeclaration");
                }
                function T(S, b, B) {
                    let k = S.getValue();
                    if (!k.source) return "";
                    let M = [];
                    return C(k, b) || M.push(" from"), M.push(" ", B("source")), M;
                }
                function m(S, b, B) {
                    let k = S.getValue();
                    if (C(k, b)) return "";
                    let M = [
                        " "
                    ];
                    if (t(k.specifiers)) {
                        let R = [], q = [];
                        S.each(()=>{
                            let J = S.getValue().type;
                            if (J === "ExportNamespaceSpecifier" || J === "ExportDefaultSpecifier" || J === "ImportNamespaceSpecifier" || J === "ImportDefaultSpecifier") R.push(B());
                            else if (J === "ExportSpecifier" || J === "ImportSpecifier") q.push(B());
                            else throw new Error(`Unknown specifier type ${JSON.stringify(J)}`);
                        }, "specifiers"), M.push(u(", ", R)), q.length > 0 && (R.length > 0 && M.push(", "), q.length > 1 || R.length > 0 || k.specifiers.some((L)=>h(L)) ? M.push(a([
                            "{",
                            n([
                                b.bracketSpacing ? i : s,
                                u([
                                    ",",
                                    i
                                ], q)
                            ]),
                            l(c(b) ? "," : ""),
                            b.bracketSpacing ? i : s,
                            "}"
                        ])) : M.push([
                            "{",
                            b.bracketSpacing ? " " : "",
                            ...q,
                            b.bracketSpacing ? " " : "",
                            "}"
                        ]));
                    } else M.push("{}");
                    return M;
                }
                function C(S, b) {
                    let { type: B, importKind: k, source: M, specifiers: R } = S;
                    return B !== "ImportDeclaration" || t(R) || k === "type" ? !1 : !/{\s*}/.test(b.originalText.slice(w(S), w(M)));
                }
                function o(S, b, B) {
                    let k = S.getNode();
                    return t(k.assertions) ? [
                        " assert {",
                        b.bracketSpacing ? " " : "",
                        u(", ", S.map(B, "assertions")),
                        b.bracketSpacing ? " " : "",
                        "}"
                    ] : "";
                }
                function d(S, b, B) {
                    let k = S.getNode(), { type: M } = k, R = [], q = M === "ImportSpecifier" ? k.importKind : k.exportKind;
                    q && q !== "value" && R.push(q, " ");
                    let J = M.startsWith("Import"), L = J ? "imported" : "local", Q = J ? "local" : "exported", V = k[L], j = k[Q], Y = "", ie = "";
                    return M === "ExportNamespaceSpecifier" || M === "ImportNamespaceSpecifier" ? Y = "*" : V && (Y = B(L)), j && !v(k) && (ie = B(Q)), R.push(Y, Y && ie ? " as " : "", ie), R;
                }
                function v(S) {
                    if (S.type !== "ImportSpecifier" && S.type !== "ExportSpecifier") return !1;
                    let { local: b, [S.type === "ImportSpecifier" ? "imported" : "exported"]: B } = S;
                    if (b.type !== B.type || !E(b, B)) return !1;
                    if (F(b)) return b.value === B.value && _(b) === _(B);
                    switch(b.type){
                        case "Identifier":
                            return b.name === B.name;
                        default:
                            return !1;
                    }
                }
                r.exports = {
                    printImportDeclaration: I,
                    printExportDeclaration: P,
                    printExportAllDeclaration: $,
                    printModuleSpecifier: d
                };
            }
        }), uu = te({
            "src/language-js/print/object.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { builders: { line: s, softline: a, group: n, indent: u, ifBreak: i, hardline: l } } = qe(), { getLast: p, hasNewlineInRange: y, hasNewline: h, isNonEmptyArray: g } = Ue(), { shouldPrintComma: c, hasComment: f, getComments: F, CommentCheckFlags: _, isNextLineEmpty: w } = Ke(), { locStart: E, locEnd: N } = ut(), { printOptionalToken: x, printTypeAnnotation: I } = ct(), { shouldHugFunctionParameters: P } = Lr(), { shouldHugType: $ } = Or(), { printHardlineAfterHeritage: D } = nr();
                function T(m, C, o) {
                    let d = C.semi ? ";" : "", v = m.getValue(), S;
                    v.type === "TSTypeLiteral" ? S = "members" : v.type === "TSInterfaceBody" ? S = "body" : S = "properties";
                    let b = v.type === "ObjectTypeAnnotation", B = [
                        S
                    ];
                    b && B.push("indexers", "callProperties", "internalSlots");
                    let k = B.map((W)=>v[W][0]).sort((W, K)=>E(W) - E(K))[0], M = m.getParentNode(0), R = b && M && (M.type === "InterfaceDeclaration" || M.type === "DeclareInterface" || M.type === "DeclareClass") && m.getName() === "body", q = v.type === "TSInterfaceBody" || R || v.type === "ObjectPattern" && M.type !== "FunctionDeclaration" && M.type !== "FunctionExpression" && M.type !== "ArrowFunctionExpression" && M.type !== "ObjectMethod" && M.type !== "ClassMethod" && M.type !== "ClassPrivateMethod" && M.type !== "AssignmentPattern" && M.type !== "CatchClause" && v.properties.some((W)=>W.value && (W.value.type === "ObjectPattern" || W.value.type === "ArrayPattern")) || v.type !== "ObjectPattern" && k && y(C.originalText, E(v), E(k)), J = R ? ";" : v.type === "TSInterfaceBody" || v.type === "TSTypeLiteral" ? i(d, ";") : ",", L = v.type === "RecordExpression" ? "#{" : v.exact ? "{|" : "{", Q = v.exact ? "|}" : "}", V = [];
                    for (let W of B)m.each((K)=>{
                        let de = K.getValue();
                        V.push({
                            node: de,
                            printed: o(),
                            loc: E(de)
                        });
                    }, W);
                    B.length > 1 && V.sort((W, K)=>W.loc - K.loc);
                    let j = [], Y = V.map((W)=>{
                        let K = [
                            ...j,
                            n(W.printed)
                        ];
                        return j = [
                            J,
                            s
                        ], (W.node.type === "TSPropertySignature" || W.node.type === "TSMethodSignature" || W.node.type === "TSConstructSignatureDeclaration") && f(W.node, _.PrettierIgnore) && j.shift(), w(W.node, C) && j.push(l), K;
                    });
                    if (v.inexact) {
                        let W;
                        if (f(v, _.Dangling)) {
                            let K = f(v, _.Line);
                            W = [
                                t(m, C, !0),
                                K || h(C.originalText, N(p(F(v)))) ? l : s,
                                "..."
                            ];
                        } else W = [
                            "..."
                        ];
                        Y.push([
                            ...j,
                            ...W
                        ]);
                    }
                    let ie = p(v[S]), ee = !(v.inexact || ie && ie.type === "RestElement" || ie && (ie.type === "TSPropertySignature" || ie.type === "TSCallSignatureDeclaration" || ie.type === "TSMethodSignature" || ie.type === "TSConstructSignatureDeclaration") && f(ie, _.PrettierIgnore)), ce;
                    if (Y.length === 0) {
                        if (!f(v, _.Dangling)) return [
                            L,
                            Q,
                            I(m, C, o)
                        ];
                        ce = n([
                            L,
                            t(m, C),
                            a,
                            Q,
                            x(m),
                            I(m, C, o)
                        ]);
                    } else ce = [
                        R && g(v.properties) ? D(M) : "",
                        L,
                        u([
                            C.bracketSpacing ? s : a,
                            ...Y
                        ]),
                        i(ee && (J !== "," || c(C)) ? J : ""),
                        C.bracketSpacing ? s : a,
                        Q,
                        x(m),
                        I(m, C, o)
                    ];
                    return m.match((W)=>W.type === "ObjectPattern" && !W.decorators, (W, K, de)=>P(W) && (K === "params" || K === "parameters" || K === "this" || K === "rest") && de === 0) || m.match($, (W, K)=>K === "typeAnnotation", (W, K)=>K === "typeAnnotation", (W, K, de)=>P(W) && (K === "params" || K === "parameters" || K === "this" || K === "rest") && de === 0) || !q && m.match((W)=>W.type === "ObjectPattern", (W)=>W.type === "AssignmentExpression" || W.type === "VariableDeclarator") ? ce : n(ce, {
                        shouldBreak: q
                    });
                }
                r.exports = {
                    printObject: T
                };
            }
        }), dd = te({
            "src/language-js/print/flow.js" (e, r) {
                "use strict";
                ne();
                var t = Zt(), { printDanglingComments: s } = et(), { printString: a, printNumber: n } = Ue(), { builders: { hardline: u, softline: i, group: l, indent: p } } = qe(), { getParentExportDeclaration: y, isFunctionNotation: h, isGetterOrSetter: g, rawText: c, shouldPrintComma: f } = Ke(), { locStart: F, locEnd: _ } = ut(), { replaceTextEndOfLine: w } = Yt(), { printClass: E } = nr(), { printOpaqueType: N, printTypeAlias: x, printIntersectionType: I, printUnionType: P, printFunctionType: $, printTupleType: D, printIndexedAccessType: T } = Or(), { printInterface: m } = bo(), { printTypeParameter: C, printTypeParameters: o } = jr(), { printExportDeclaration: d, printExportAllDeclaration: v } = To(), { printArrayItems: S } = er(), { printObject: b } = uu(), { printPropertyKey: B } = rr(), { printOptionalToken: k, printTypeAnnotation: M, printRestSpread: R } = ct();
                function q(L, Q, V) {
                    let j = L.getValue(), Y = Q.semi ? ";" : "", ie = [];
                    switch(j.type){
                        case "DeclareClass":
                            return J(L, E(L, Q, V));
                        case "DeclareFunction":
                            return J(L, [
                                "function ",
                                V("id"),
                                j.predicate ? " " : "",
                                V("predicate"),
                                Y
                            ]);
                        case "DeclareModule":
                            return J(L, [
                                "module ",
                                V("id"),
                                " ",
                                V("body")
                            ]);
                        case "DeclareModuleExports":
                            return J(L, [
                                "module.exports",
                                ": ",
                                V("typeAnnotation"),
                                Y
                            ]);
                        case "DeclareVariable":
                            return J(L, [
                                "var ",
                                V("id"),
                                Y
                            ]);
                        case "DeclareOpaqueType":
                            return J(L, N(L, Q, V));
                        case "DeclareInterface":
                            return J(L, m(L, Q, V));
                        case "DeclareTypeAlias":
                            return J(L, x(L, Q, V));
                        case "DeclareExportDeclaration":
                            return J(L, d(L, Q, V));
                        case "DeclareExportAllDeclaration":
                            return J(L, v(L, Q, V));
                        case "OpaqueType":
                            return N(L, Q, V);
                        case "TypeAlias":
                            return x(L, Q, V);
                        case "IntersectionTypeAnnotation":
                            return I(L, Q, V);
                        case "UnionTypeAnnotation":
                            return P(L, Q, V);
                        case "FunctionTypeAnnotation":
                            return $(L, Q, V);
                        case "TupleTypeAnnotation":
                            return D(L, Q, V);
                        case "GenericTypeAnnotation":
                            return [
                                V("id"),
                                o(L, Q, V, "typeParameters")
                            ];
                        case "IndexedAccessType":
                        case "OptionalIndexedAccessType":
                            return T(L, Q, V);
                        case "TypeAnnotation":
                            return V("typeAnnotation");
                        case "TypeParameter":
                            return C(L, Q, V);
                        case "TypeofTypeAnnotation":
                            return [
                                "typeof ",
                                V("argument")
                            ];
                        case "ExistsTypeAnnotation":
                            return "*";
                        case "EmptyTypeAnnotation":
                            return "empty";
                        case "MixedTypeAnnotation":
                            return "mixed";
                        case "ArrayTypeAnnotation":
                            return [
                                V("elementType"),
                                "[]"
                            ];
                        case "BooleanLiteralTypeAnnotation":
                            return String(j.value);
                        case "EnumDeclaration":
                            return [
                                "enum ",
                                V("id"),
                                " ",
                                V("body")
                            ];
                        case "EnumBooleanBody":
                        case "EnumNumberBody":
                        case "EnumStringBody":
                        case "EnumSymbolBody":
                            if (j.type === "EnumSymbolBody" || j.explicitType) {
                                let ee = null;
                                switch(j.type){
                                    case "EnumBooleanBody":
                                        ee = "boolean";
                                        break;
                                    case "EnumNumberBody":
                                        ee = "number";
                                        break;
                                    case "EnumStringBody":
                                        ee = "string";
                                        break;
                                    case "EnumSymbolBody":
                                        ee = "symbol";
                                        break;
                                }
                                ie.push("of ", ee, " ");
                            }
                            if (j.members.length === 0 && !j.hasUnknownMembers) ie.push(l([
                                "{",
                                s(L, Q),
                                i,
                                "}"
                            ]));
                            else {
                                let ee = j.members.length > 0 ? [
                                    u,
                                    S(L, Q, "members", V),
                                    j.hasUnknownMembers || f(Q) ? "," : ""
                                ] : [];
                                ie.push(l([
                                    "{",
                                    p([
                                        ...ee,
                                        ...j.hasUnknownMembers ? [
                                            u,
                                            "..."
                                        ] : []
                                    ]),
                                    s(L, Q, !0),
                                    u,
                                    "}"
                                ]));
                            }
                            return ie;
                        case "EnumBooleanMember":
                        case "EnumNumberMember":
                        case "EnumStringMember":
                            return [
                                V("id"),
                                " = ",
                                typeof j.init == "object" ? V("init") : String(j.init)
                            ];
                        case "EnumDefaultedMember":
                            return V("id");
                        case "FunctionTypeParam":
                            {
                                let ee = j.name ? V("name") : L.getParentNode().this === j ? "this" : "";
                                return [
                                    ee,
                                    k(L),
                                    ee ? ": " : "",
                                    V("typeAnnotation")
                                ];
                            }
                        case "InterfaceDeclaration":
                        case "InterfaceTypeAnnotation":
                            return m(L, Q, V);
                        case "ClassImplements":
                        case "InterfaceExtends":
                            return [
                                V("id"),
                                V("typeParameters")
                            ];
                        case "NullableTypeAnnotation":
                            return [
                                "?",
                                V("typeAnnotation")
                            ];
                        case "Variance":
                            {
                                let { kind: ee } = j;
                                return t.ok(ee === "plus" || ee === "minus"), ee === "plus" ? "+" : "-";
                            }
                        case "ObjectTypeCallProperty":
                            return j.static && ie.push("static "), ie.push(V("value")), ie;
                        case "ObjectTypeIndexer":
                            return [
                                j.static ? "static " : "",
                                j.variance ? V("variance") : "",
                                "[",
                                V("id"),
                                j.id ? ": " : "",
                                V("key"),
                                "]: ",
                                V("value")
                            ];
                        case "ObjectTypeProperty":
                            {
                                let ee = "";
                                return j.proto ? ee = "proto " : j.static && (ee = "static "), [
                                    ee,
                                    g(j) ? j.kind + " " : "",
                                    j.variance ? V("variance") : "",
                                    B(L, Q, V),
                                    k(L),
                                    h(j) ? "" : ": ",
                                    V("value")
                                ];
                            }
                        case "ObjectTypeAnnotation":
                            return b(L, Q, V);
                        case "ObjectTypeInternalSlot":
                            return [
                                j.static ? "static " : "",
                                "[[",
                                V("id"),
                                "]]",
                                k(L),
                                j.method ? "" : ": ",
                                V("value")
                            ];
                        case "ObjectTypeSpreadProperty":
                            return R(L, Q, V);
                        case "QualifiedTypeofIdentifier":
                        case "QualifiedTypeIdentifier":
                            return [
                                V("qualification"),
                                ".",
                                V("id")
                            ];
                        case "StringLiteralTypeAnnotation":
                            return w(a(c(j), Q));
                        case "NumberLiteralTypeAnnotation":
                            t.strictEqual(typeof j.value, "number");
                        case "BigIntLiteralTypeAnnotation":
                            return j.extra ? n(j.extra.raw) : n(j.raw);
                        case "TypeCastExpression":
                            return [
                                "(",
                                V("expression"),
                                M(L, Q, V),
                                ")"
                            ];
                        case "TypeParameterDeclaration":
                        case "TypeParameterInstantiation":
                            {
                                let ee = o(L, Q, V, "params");
                                if (Q.parser === "flow") {
                                    let ce = F(j), W = _(j), K = Q.originalText.lastIndexOf("/*", ce), de = Q.originalText.indexOf("*/", W);
                                    if (K !== -1 && de !== -1) {
                                        let ue = Q.originalText.slice(K + 2, de).trim();
                                        if (ue.startsWith("::") && !ue.includes("/*") && !ue.includes("*/")) return [
                                            "/*:: ",
                                            ee,
                                            " */"
                                        ];
                                    }
                                }
                                return ee;
                            }
                        case "InferredPredicate":
                            return "%checks";
                        case "DeclaredPredicate":
                            return [
                                "%checks(",
                                V("value"),
                                ")"
                            ];
                        case "AnyTypeAnnotation":
                            return "any";
                        case "BooleanTypeAnnotation":
                            return "boolean";
                        case "BigIntTypeAnnotation":
                            return "bigint";
                        case "NullLiteralTypeAnnotation":
                            return "null";
                        case "NumberTypeAnnotation":
                            return "number";
                        case "SymbolTypeAnnotation":
                            return "symbol";
                        case "StringTypeAnnotation":
                            return "string";
                        case "VoidTypeAnnotation":
                            return "void";
                        case "ThisTypeAnnotation":
                            return "this";
                        case "Node":
                        case "Printable":
                        case "SourceLocation":
                        case "Position":
                        case "Statement":
                        case "Function":
                        case "Pattern":
                        case "Expression":
                        case "Declaration":
                        case "Specifier":
                        case "NamedSpecifier":
                        case "Comment":
                        case "MemberTypeAnnotation":
                        case "Type":
                            throw new Error("unprintable type: " + JSON.stringify(j.type));
                    }
                }
                function J(L, Q) {
                    let V = y(L);
                    return V ? (t.strictEqual(V.type, "DeclareExportDeclaration"), Q) : [
                        "declare ",
                        Q
                    ];
                }
                r.exports = {
                    printFlow: q
                };
            }
        }), gd = te({
            "src/language-js/utils/is-ts-keyword-type.js" (e, r) {
                "use strict";
                ne();
                function t(s) {
                    let { type: a } = s;
                    return a.startsWith("TS") && a.endsWith("Keyword");
                }
                r.exports = t;
            }
        }), Bo = te({
            "src/language-js/print/ternary.js" (e, r) {
                "use strict";
                ne();
                var { hasNewlineInRange: t } = Ue(), { isJsxNode: s, getComments: a, isCallExpression: n, isMemberExpression: u, isTSTypeExpression: i } = Ke(), { locStart: l, locEnd: p } = ut(), y = Pt(), { builders: { line: h, softline: g, group: c, indent: f, align: F, ifBreak: _, dedent: w, breakParent: E } } = qe();
                function N(D) {
                    let T = [
                        D
                    ];
                    for(let m = 0; m < T.length; m++){
                        let C = T[m];
                        for (let o of [
                            "test",
                            "consequent",
                            "alternate"
                        ]){
                            let d = C[o];
                            if (s(d)) return !0;
                            d.type === "ConditionalExpression" && T.push(d);
                        }
                    }
                    return !1;
                }
                function x(D, T, m) {
                    let C = D.getValue(), o = C.type === "ConditionalExpression", d = o ? "alternate" : "falseType", v = D.getParentNode(), S = o ? m("test") : [
                        m("checkType"),
                        " ",
                        "extends",
                        " ",
                        m("extendsType")
                    ];
                    return v.type === C.type && v[d] === C ? F(2, S) : S;
                }
                var I = new Map([
                    [
                        "AssignmentExpression",
                        "right"
                    ],
                    [
                        "VariableDeclarator",
                        "init"
                    ],
                    [
                        "ReturnStatement",
                        "argument"
                    ],
                    [
                        "ThrowStatement",
                        "argument"
                    ],
                    [
                        "UnaryExpression",
                        "argument"
                    ],
                    [
                        "YieldExpression",
                        "argument"
                    ]
                ]);
                function P(D) {
                    let T = D.getValue();
                    if (T.type !== "ConditionalExpression") return !1;
                    let m, C = T;
                    for(let o = 0; !m; o++){
                        let d = D.getParentNode(o);
                        if (n(d) && d.callee === C || u(d) && d.object === C || d.type === "TSNonNullExpression" && d.expression === C) {
                            C = d;
                            continue;
                        }
                        d.type === "NewExpression" && d.callee === C || i(d) && d.expression === C ? (m = D.getParentNode(o + 1), C = d) : m = d;
                    }
                    return C === T ? !1 : m[I.get(m.type)] === C;
                }
                function $(D, T, m) {
                    let C = D.getValue(), o = C.type === "ConditionalExpression", d = o ? "consequent" : "trueType", v = o ? "alternate" : "falseType", S = o ? [
                        "test"
                    ] : [
                        "checkType",
                        "extendsType"
                    ], b = C[d], B = C[v], k = [], M = !1, R = D.getParentNode(), q = R.type === C.type && S.some((ue)=>R[ue] === C), J = R.type === C.type && !q, L, Q, V = 0;
                    do Q = L || C, L = D.getParentNode(V), V++;
                    while (L && L.type === C.type && S.every((ue)=>L[ue] !== Q));
                    let j = L || R, Y = Q;
                    if (o && (s(C[S[0]]) || s(b) || s(B) || N(Y))) {
                        M = !0, J = !0;
                        let ue = (z)=>[
                                _("("),
                                f([
                                    g,
                                    z
                                ]),
                                g,
                                _(")")
                            ], Fe = (z)=>z.type === "NullLiteral" || z.type === "Literal" && z.value === null || z.type === "Identifier" && z.name === "undefined";
                        k.push(" ? ", Fe(b) ? m(d) : ue(m(d)), " : ", B.type === C.type || Fe(B) ? m(v) : ue(m(v)));
                    } else {
                        let ue = [
                            h,
                            "? ",
                            b.type === C.type ? _("", "(") : "",
                            F(2, m(d)),
                            b.type === C.type ? _("", ")") : "",
                            h,
                            ": ",
                            B.type === C.type ? m(v) : F(2, m(v))
                        ];
                        k.push(R.type !== C.type || R[v] === C || q ? ue : T.useTabs ? w(f(ue)) : F(Math.max(0, T.tabWidth - 2), ue));
                    }
                    let ee = [
                        ...S.map((ue)=>a(C[ue])),
                        a(b),
                        a(B)
                    ].flat().some((ue)=>y(ue) && t(T.originalText, l(ue), p(ue))), ce = (ue)=>R === j ? c(ue, {
                            shouldBreak: ee
                        }) : ee ? [
                            ue,
                            E
                        ] : ue, W = !M && (u(R) || R.type === "NGPipeExpression" && R.left === C) && !R.computed, K = P(D), de = ce([
                        x(D, T, m),
                        J ? k : f(k),
                        o && W && !K ? g : ""
                    ]);
                    return q || K ? c([
                        f([
                            g,
                            de
                        ]),
                        g
                    ]) : de;
                }
                r.exports = {
                    printTernary: $
                };
            }
        }), No = te({
            "src/language-js/print/statement.js" (e, r) {
                "use strict";
                ne();
                var { builders: { hardline: t } } = qe(), s = qt(), { getLeftSidePathName: a, hasNakedLeftSide: n, isJsxNode: u, isTheOnlyJsxElementInMarkdown: i, hasComment: l, CommentCheckFlags: p, isNextLineEmpty: y } = Ke(), { shouldPrintParamsWithoutParens: h } = qr();
                function g(x, I, P, $) {
                    let D = x.getValue(), T = [], m = D.type === "ClassBody", C = c(D[$]);
                    return x.each((o, d, v)=>{
                        let S = o.getValue();
                        if (S.type === "EmptyStatement") return;
                        let b = P();
                        !I.semi && !m && !i(I, o) && f(o, I) ? l(S, p.Leading) ? T.push(P([], {
                            needsSemi: !0
                        })) : T.push(";", b) : T.push(b), !I.semi && m && E(S) && N(S, v[d + 1]) && T.push(";"), S !== C && (T.push(t), y(S, I) && T.push(t));
                    }, $), T;
                }
                function c(x) {
                    for(let I = x.length - 1; I >= 0; I--){
                        let P = x[I];
                        if (P.type !== "EmptyStatement") return P;
                    }
                }
                function f(x, I) {
                    return x.getNode().type !== "ExpressionStatement" ? !1 : x.call(($)=>F($, I), "expression");
                }
                function F(x, I) {
                    let P = x.getValue();
                    switch(P.type){
                        case "ParenthesizedExpression":
                        case "TypeCastExpression":
                        case "ArrayExpression":
                        case "ArrayPattern":
                        case "TemplateLiteral":
                        case "TemplateElement":
                        case "RegExpLiteral":
                            return !0;
                        case "ArrowFunctionExpression":
                            if (!h(x, I)) return !0;
                            break;
                        case "UnaryExpression":
                            {
                                let { prefix: $, operator: D } = P;
                                if ($ && (D === "+" || D === "-")) return !0;
                                break;
                            }
                        case "BindExpression":
                            if (!P.object) return !0;
                            break;
                        case "Literal":
                            if (P.regex) return !0;
                            break;
                        default:
                            if (u(P)) return !0;
                    }
                    return s(x, I) ? !0 : n(P) ? x.call(($)=>F($, I), ...a(x, P)) : !1;
                }
                function _(x, I, P) {
                    return g(x, I, P, "body");
                }
                function w(x, I, P) {
                    return g(x, I, P, "consequent");
                }
                var E = (x)=>{
                    let { type: I } = x;
                    return I === "ClassProperty" || I === "PropertyDefinition" || I === "ClassPrivateProperty" || I === "ClassAccessorProperty" || I === "AccessorProperty" || I === "TSAbstractPropertyDefinition" || I === "TSAbstractAccessorProperty";
                };
                function N(x, I) {
                    let { type: P, name: $ } = x.key;
                    if (!x.computed && P === "Identifier" && ($ === "static" || $ === "get" || $ === "set" || $ === "accessor") && !x.value && !x.typeAnnotation) return !0;
                    if (!I || I.static || I.accessibility) return !1;
                    if (!I.computed) {
                        let D = I.key && I.key.name;
                        if (D === "in" || D === "instanceof") return !0;
                    }
                    if (E(I) && I.variance && !I.static && !I.declare) return !0;
                    switch(I.type){
                        case "ClassProperty":
                        case "PropertyDefinition":
                        case "TSAbstractPropertyDefinition":
                            return I.computed;
                        case "MethodDefinition":
                        case "TSAbstractMethodDefinition":
                        case "ClassMethod":
                        case "ClassPrivateMethod":
                            {
                                if ((I.value ? I.value.async : I.async) || I.kind === "get" || I.kind === "set") return !1;
                                let T = I.value ? I.value.generator : I.generator;
                                return !!(I.computed || T);
                            }
                        case "TSIndexSignature":
                            return !0;
                    }
                    return !1;
                }
                r.exports = {
                    printBody: _,
                    printSwitchCaseConsequent: w
                };
            }
        }), wo = te({
            "src/language-js/print/block.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { isNonEmptyArray: s } = Ue(), { builders: { hardline: a, indent: n } } = qe(), { hasComment: u, CommentCheckFlags: i, isNextLineEmpty: l } = Ke(), { printHardlineAfterHeritage: p } = nr(), { printBody: y } = No();
                function h(c, f, F) {
                    let _ = c.getValue(), w = [];
                    if (_.type === "StaticBlock" && w.push("static "), _.type === "ClassBody" && s(_.body)) {
                        let N = c.getParentNode();
                        w.push(p(N));
                    }
                    w.push("{");
                    let E = g(c, f, F);
                    if (E) w.push(n([
                        a,
                        E
                    ]), a);
                    else {
                        let N = c.getParentNode(), x = c.getParentNode(1);
                        N.type === "ArrowFunctionExpression" || N.type === "FunctionExpression" || N.type === "FunctionDeclaration" || N.type === "ObjectMethod" || N.type === "ClassMethod" || N.type === "ClassPrivateMethod" || N.type === "ForStatement" || N.type === "WhileStatement" || N.type === "DoWhileStatement" || N.type === "DoExpression" || N.type === "CatchClause" && !x.finalizer || N.type === "TSModuleDeclaration" || N.type === "TSDeclareFunction" || _.type === "StaticBlock" || _.type === "ClassBody" || w.push(a);
                    }
                    return w.push("}"), w;
                }
                function g(c, f, F) {
                    let _ = c.getValue(), w = s(_.directives), E = _.body.some((I)=>I.type !== "EmptyStatement"), N = u(_, i.Dangling);
                    if (!w && !E && !N) return "";
                    let x = [];
                    if (w && c.each((I, P, $)=>{
                        x.push(F()), (P < $.length - 1 || E || N) && (x.push(a), l(I.getValue(), f) && x.push(a));
                    }, "directives"), E && x.push(y(c, f, F)), N && x.push(t(c, f, !0)), _.type === "Program") {
                        let I = c.getParentNode();
                        (!I || I.type !== "ModuleExpression") && x.push(a);
                    }
                    return x;
                }
                r.exports = {
                    printBlock: h,
                    printBlockBody: g
                };
            }
        }), yd = te({
            "src/language-js/print/typescript.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { hasNewlineInRange: s } = Ue(), { builders: { join: a, line: n, hardline: u, softline: i, group: l, indent: p, conditionalGroup: y, ifBreak: h } } = qe(), { isStringLiteral: g, getTypeScriptMappedTypeModifier: c, shouldPrintComma: f, isCallExpression: F, isMemberExpression: _ } = Ke(), w = gd(), { locStart: E, locEnd: N } = ut(), { printOptionalToken: x, printTypeScriptModifiers: I } = ct(), { printTernary: P } = Bo(), { printFunctionParameters: $, shouldGroupFunctionParameters: D } = Lr(), { printTemplateLiteral: T } = jt(), { printArrayItems: m } = er(), { printObject: C } = uu(), { printClassProperty: o, printClassMethod: d } = nr(), { printTypeParameter: v, printTypeParameters: S } = jr(), { printPropertyKey: b } = rr(), { printFunction: B, printMethodInternal: k } = qr(), { printInterface: M } = bo(), { printBlock: R } = wo(), { printTypeAlias: q, printIntersectionType: J, printUnionType: L, printFunctionType: Q, printTupleType: V, printIndexedAccessType: j, printJSDocType: Y } = Or();
                function ie(ee, ce, W) {
                    let K = ee.getValue();
                    if (!K.type.startsWith("TS")) return;
                    if (w(K)) return K.type.slice(2, -7).toLowerCase();
                    let de = ce.semi ? ";" : "", ue = [];
                    switch(K.type){
                        case "TSThisType":
                            return "this";
                        case "TSTypeAssertion":
                            {
                                let Fe = !(K.expression.type === "ArrayExpression" || K.expression.type === "ObjectExpression"), z = l([
                                    "<",
                                    p([
                                        i,
                                        W("typeAnnotation")
                                    ]),
                                    i,
                                    ">"
                                ]), U = [
                                    h("("),
                                    p([
                                        i,
                                        W("expression")
                                    ]),
                                    i,
                                    h(")")
                                ];
                                return Fe ? y([
                                    [
                                        z,
                                        W("expression")
                                    ],
                                    [
                                        z,
                                        l(U, {
                                            shouldBreak: !0
                                        })
                                    ],
                                    [
                                        z,
                                        W("expression")
                                    ]
                                ]) : l([
                                    z,
                                    W("expression")
                                ]);
                            }
                        case "TSDeclareFunction":
                            return B(ee, W, ce);
                        case "TSExportAssignment":
                            return [
                                "export = ",
                                W("expression"),
                                de
                            ];
                        case "TSModuleBlock":
                            return R(ee, ce, W);
                        case "TSInterfaceBody":
                        case "TSTypeLiteral":
                            return C(ee, ce, W);
                        case "TSTypeAliasDeclaration":
                            return q(ee, ce, W);
                        case "TSQualifiedName":
                            return a(".", [
                                W("left"),
                                W("right")
                            ]);
                        case "TSAbstractMethodDefinition":
                        case "TSDeclareMethod":
                            return d(ee, ce, W);
                        case "TSAbstractAccessorProperty":
                        case "TSAbstractPropertyDefinition":
                            return o(ee, ce, W);
                        case "TSInterfaceHeritage":
                        case "TSExpressionWithTypeArguments":
                            return ue.push(W("expression")), K.typeParameters && ue.push(W("typeParameters")), ue;
                        case "TSTemplateLiteralType":
                            return T(ee, W, ce);
                        case "TSNamedTupleMember":
                            return [
                                W("label"),
                                K.optional ? "?" : "",
                                ": ",
                                W("elementType")
                            ];
                        case "TSRestType":
                            return [
                                "...",
                                W("typeAnnotation")
                            ];
                        case "TSOptionalType":
                            return [
                                W("typeAnnotation"),
                                "?"
                            ];
                        case "TSInterfaceDeclaration":
                            return M(ee, ce, W);
                        case "TSClassImplements":
                            return [
                                W("expression"),
                                W("typeParameters")
                            ];
                        case "TSTypeParameterDeclaration":
                        case "TSTypeParameterInstantiation":
                            return S(ee, ce, W, "params");
                        case "TSTypeParameter":
                            return v(ee, ce, W);
                        case "TSSatisfiesExpression":
                        case "TSAsExpression":
                            {
                                let Fe = K.type === "TSAsExpression" ? "as" : "satisfies";
                                ue.push(W("expression"), ` ${Fe} `, W("typeAnnotation"));
                                let z = ee.getParentNode();
                                return F(z) && z.callee === K || _(z) && z.object === K ? l([
                                    p([
                                        i,
                                        ...ue
                                    ]),
                                    i
                                ]) : ue;
                            }
                        case "TSArrayType":
                            return [
                                W("elementType"),
                                "[]"
                            ];
                        case "TSPropertySignature":
                            return K.readonly && ue.push("readonly "), ue.push(b(ee, ce, W), x(ee)), K.typeAnnotation && ue.push(": ", W("typeAnnotation")), K.initializer && ue.push(" = ", W("initializer")), ue;
                        case "TSParameterProperty":
                            return K.accessibility && ue.push(K.accessibility + " "), K.export && ue.push("export "), K.static && ue.push("static "), K.override && ue.push("override "), K.readonly && ue.push("readonly "), ue.push(W("parameter")), ue;
                        case "TSTypeQuery":
                            return [
                                "typeof ",
                                W("exprName"),
                                W("typeParameters")
                            ];
                        case "TSIndexSignature":
                            {
                                let Fe = ee.getParentNode(), z = K.parameters.length > 1 ? h(f(ce) ? "," : "") : "", U = l([
                                    p([
                                        i,
                                        a([
                                            ", ",
                                            i
                                        ], ee.map(W, "parameters"))
                                    ]),
                                    z,
                                    i
                                ]);
                                return [
                                    K.export ? "export " : "",
                                    K.accessibility ? [
                                        K.accessibility,
                                        " "
                                    ] : "",
                                    K.static ? "static " : "",
                                    K.readonly ? "readonly " : "",
                                    K.declare ? "declare " : "",
                                    "[",
                                    K.parameters ? U : "",
                                    K.typeAnnotation ? "]: " : "]",
                                    K.typeAnnotation ? W("typeAnnotation") : "",
                                    Fe.type === "ClassBody" ? de : ""
                                ];
                            }
                        case "TSTypePredicate":
                            return [
                                K.asserts ? "asserts " : "",
                                W("parameterName"),
                                K.typeAnnotation ? [
                                    " is ",
                                    W("typeAnnotation")
                                ] : ""
                            ];
                        case "TSNonNullExpression":
                            return [
                                W("expression"),
                                "!"
                            ];
                        case "TSImportType":
                            return [
                                K.isTypeOf ? "typeof " : "",
                                "import(",
                                W(K.parameter ? "parameter" : "argument"),
                                ")",
                                K.qualifier ? [
                                    ".",
                                    W("qualifier")
                                ] : "",
                                S(ee, ce, W, "typeParameters")
                            ];
                        case "TSLiteralType":
                            return W("literal");
                        case "TSIndexedAccessType":
                            return j(ee, ce, W);
                        case "TSConstructSignatureDeclaration":
                        case "TSCallSignatureDeclaration":
                        case "TSConstructorType":
                            if (K.type === "TSConstructorType" && K.abstract && ue.push("abstract "), K.type !== "TSCallSignatureDeclaration" && ue.push("new "), ue.push(l($(ee, W, ce, !1, !0))), K.returnType || K.typeAnnotation) {
                                let Fe = K.type === "TSConstructorType";
                                ue.push(Fe ? " => " : ": ", W("returnType"), W("typeAnnotation"));
                            }
                            return ue;
                        case "TSTypeOperator":
                            return [
                                K.operator,
                                " ",
                                W("typeAnnotation")
                            ];
                        case "TSMappedType":
                            {
                                let Fe = s(ce.originalText, E(K), N(K));
                                return l([
                                    "{",
                                    p([
                                        ce.bracketSpacing ? n : i,
                                        W("typeParameter"),
                                        K.optional ? c(K.optional, "?") : "",
                                        K.typeAnnotation ? ": " : "",
                                        W("typeAnnotation"),
                                        h(de)
                                    ]),
                                    t(ee, ce, !0),
                                    ce.bracketSpacing ? n : i,
                                    "}"
                                ], {
                                    shouldBreak: Fe
                                });
                            }
                        case "TSMethodSignature":
                            {
                                let Fe = K.kind && K.kind !== "method" ? `${K.kind} ` : "";
                                ue.push(K.accessibility ? [
                                    K.accessibility,
                                    " "
                                ] : "", Fe, K.export ? "export " : "", K.static ? "static " : "", K.readonly ? "readonly " : "", K.abstract ? "abstract " : "", K.declare ? "declare " : "", K.computed ? "[" : "", W("key"), K.computed ? "]" : "", x(ee));
                                let z = $(ee, W, ce, !1, !0), U = K.returnType ? "returnType" : "typeAnnotation", Z = K[U], se = Z ? W(U) : "", fe = D(K, se);
                                return ue.push(fe ? l(z) : z), Z && ue.push(": ", l(se)), l(ue);
                            }
                        case "TSNamespaceExportDeclaration":
                            return ue.push("export as namespace ", W("id")), ce.semi && ue.push(";"), l(ue);
                        case "TSEnumDeclaration":
                            return K.declare && ue.push("declare "), K.modifiers && ue.push(I(ee, ce, W)), K.const && ue.push("const "), ue.push("enum ", W("id"), " "), K.members.length === 0 ? ue.push(l([
                                "{",
                                t(ee, ce),
                                i,
                                "}"
                            ])) : ue.push(l([
                                "{",
                                p([
                                    u,
                                    m(ee, ce, "members", W),
                                    f(ce, "es5") ? "," : ""
                                ]),
                                t(ee, ce, !0),
                                u,
                                "}"
                            ])), ue;
                        case "TSEnumMember":
                            return K.computed ? ue.push("[", W("id"), "]") : ue.push(W("id")), K.initializer && ue.push(" = ", W("initializer")), ue;
                        case "TSImportEqualsDeclaration":
                            return K.isExport && ue.push("export "), ue.push("import "), K.importKind && K.importKind !== "value" && ue.push(K.importKind, " "), ue.push(W("id"), " = ", W("moduleReference")), ce.semi && ue.push(";"), l(ue);
                        case "TSExternalModuleReference":
                            return [
                                "require(",
                                W("expression"),
                                ")"
                            ];
                        case "TSModuleDeclaration":
                            {
                                let Fe = ee.getParentNode(), z = g(K.id), U = Fe.type === "TSModuleDeclaration", Z = K.body && K.body.type === "TSModuleDeclaration";
                                if (U) ue.push(".");
                                else {
                                    K.declare && ue.push("declare "), ue.push(I(ee, ce, W));
                                    let se = ce.originalText.slice(E(K), E(K.id));
                                    K.id.type === "Identifier" && K.id.name === "global" && !/namespace|module/.test(se) || ue.push(z || /(?:^|\s)module(?:\s|$)/.test(se) ? "module " : "namespace ");
                                }
                                return ue.push(W("id")), Z ? ue.push(W("body")) : K.body ? ue.push(" ", l(W("body"))) : ue.push(de), ue;
                            }
                        case "TSConditionalType":
                            return P(ee, ce, W);
                        case "TSInferType":
                            return [
                                "infer",
                                " ",
                                W("typeParameter")
                            ];
                        case "TSIntersectionType":
                            return J(ee, ce, W);
                        case "TSUnionType":
                            return L(ee, ce, W);
                        case "TSFunctionType":
                            return Q(ee, ce, W);
                        case "TSTupleType":
                            return V(ee, ce, W);
                        case "TSTypeReference":
                            return [
                                W("typeName"),
                                S(ee, ce, W, "typeParameters")
                            ];
                        case "TSTypeAnnotation":
                            return W("typeAnnotation");
                        case "TSEmptyBodyFunctionExpression":
                            return k(ee, ce, W);
                        case "TSJSDocAllType":
                            return "*";
                        case "TSJSDocUnknownType":
                            return "?";
                        case "TSJSDocNullableType":
                            return Y(ee, W, "?");
                        case "TSJSDocNonNullableType":
                            return Y(ee, W, "!");
                        case "TSInstantiationExpression":
                            return [
                                W("expression"),
                                W("typeParameters")
                            ];
                        default:
                            throw new Error(`Unknown TypeScript node type: ${JSON.stringify(K.type)}.`);
                    }
                }
                r.exports = {
                    printTypescript: ie
                };
            }
        }), hd = te({
            "src/language-js/print/comment.js" (e, r) {
                "use strict";
                ne();
                var { hasNewline: t } = Ue(), { builders: { join: s, hardline: a }, utils: { replaceTextEndOfLine: n } } = qe(), { isLineComment: u } = Ke(), { locStart: i, locEnd: l } = ut(), p = Pt();
                function y(c, f) {
                    let F = c.getValue();
                    if (u(F)) return f.originalText.slice(i(F), l(F)).trimEnd();
                    if (p(F)) {
                        if (h(F)) {
                            let E = g(F);
                            return F.trailing && !t(f.originalText, i(F), {
                                backwards: !0
                            }) ? [
                                a,
                                E
                            ] : E;
                        }
                        let _ = l(F), w = f.originalText.slice(_ - 3, _) === "*-/";
                        return [
                            "/*",
                            n(F.value),
                            w ? "*-/" : "*/"
                        ];
                    }
                    throw new Error("Not a comment: " + JSON.stringify(F));
                }
                function h(c) {
                    let f = `*${c.value}*`.split(`
`);
                    return f.length > 1 && f.every((F)=>F.trim()[0] === "*");
                }
                function g(c) {
                    let f = c.value.split(`
`);
                    return [
                        "/*",
                        s(a, f.map((F, _)=>_ === 0 ? F.trimEnd() : " " + (_ < f.length - 1 ? F.trim() : F.trimStart()))),
                        "*/"
                    ];
                }
                r.exports = {
                    printComment: y
                };
            }
        }), vd = te({
            "src/language-js/print/literal.js" (e, r) {
                "use strict";
                ne();
                var { printString: t, printNumber: s } = Ue(), { replaceTextEndOfLine: a } = Yt(), { printDirective: n } = ct();
                function u(y, h) {
                    let g = y.getNode();
                    switch(g.type){
                        case "RegExpLiteral":
                            return p(g);
                        case "BigIntLiteral":
                            return l(g.bigint || g.extra.raw);
                        case "NumericLiteral":
                            return s(g.extra.raw);
                        case "StringLiteral":
                            return a(t(g.extra.raw, h));
                        case "NullLiteral":
                            return "null";
                        case "BooleanLiteral":
                            return String(g.value);
                        case "DecimalLiteral":
                            return s(g.value) + "m";
                        case "Literal":
                            {
                                if (g.regex) return p(g.regex);
                                if (g.bigint) return l(g.raw);
                                if (g.decimal) return s(g.decimal) + "m";
                                let { value: c } = g;
                                return typeof c == "number" ? s(g.raw) : typeof c == "string" ? i(y) ? n(g.raw, h) : a(t(g.raw, h)) : String(c);
                            }
                    }
                }
                function i(y) {
                    if (y.getName() !== "expression") return;
                    let h = y.getParentNode();
                    return h.type === "ExpressionStatement" && h.directive;
                }
                function l(y) {
                    return y.toLowerCase();
                }
                function p(y) {
                    let { pattern: h, flags: g } = y;
                    return g = [
                        ...g
                    ].sort().join(""), `/${h}/${g}`;
                }
                r.exports = {
                    printLiteral: u
                };
            }
        }), Cd = te({
            "src/language-js/printer-estree.js" (e, r) {
                "use strict";
                ne();
                var { printDanglingComments: t } = et(), { hasNewline: s } = Ue(), { builders: { join: a, line: n, hardline: u, softline: i, group: l, indent: p }, utils: { replaceTextEndOfLine: y } } = qe(), h = td(), g = rd(), { insertPragma: c } = Co(), f = Eo(), F = qt(), _ = Fo(), { hasFlowShorthandAnnotationComment: w, hasComment: E, CommentCheckFlags: N, isTheOnlyJsxElementInMarkdown: x, isLineComment: I, isNextLineEmpty: P, needsHardlineAfterDanglingComment: $, hasIgnoreComment: D, isCallExpression: T, isMemberExpression: m, markerForIfWithoutBlockAndSameLineComment: C } = Ke(), { locStart: o, locEnd: d } = ut(), v = Pt(), { printHtmlBinding: S, isVueEventBindingExpression: b } = pd(), { printAngular: B } = fd(), { printJsx: k, hasJsxIgnoreComment: M } = Dd(), { printFlow: R } = dd(), { printTypescript: q } = yd(), { printOptionalToken: J, printBindExpressionCallee: L, printTypeAnnotation: Q, adjustClause: V, printRestSpread: j, printDefiniteToken: Y, printDirective: ie } = ct(), { printImportDeclaration: ee, printExportDeclaration: ce, printExportAllDeclaration: W, printModuleSpecifier: K } = To(), { printTernary: de } = Bo(), { printTemplateLiteral: ue } = jt(), { printArray: Fe } = er(), { printObject: z } = uu(), { printClass: U, printClassMethod: Z, printClassProperty: se } = nr(), { printProperty: fe } = rr(), { printFunction: ge, printArrowFunction: he, printMethod: we, printReturnStatement: ke, printThrowStatement: Re } = qr(), { printCallExpression: Ne } = xo(), { printVariableDeclarator: Pe, printAssignmentExpression: oe } = tr(), { printBinaryishExpression: H } = ru(), { printSwitchCaseConsequent: pe } = No(), { printMemberExpression: X } = So(), { printBlock: le, printBlockBody: Ae } = wo(), { printComment: Ee } = hd(), { printLiteral: De } = vd(), { printDecorators: A } = nu();
                function G(Ce, Be, ve, ze) {
                    let be = re(Ce, Be, ve, ze);
                    if (!be) return "";
                    let Ye = Ce.getValue(), { type: Se } = Ye;
                    if (Se === "ClassMethod" || Se === "ClassPrivateMethod" || Se === "ClassProperty" || Se === "ClassAccessorProperty" || Se === "AccessorProperty" || Se === "TSAbstractAccessorProperty" || Se === "PropertyDefinition" || Se === "TSAbstractPropertyDefinition" || Se === "ClassPrivateProperty" || Se === "MethodDefinition" || Se === "TSAbstractMethodDefinition" || Se === "TSDeclareMethod") return be;
                    let Ie = [
                        be
                    ], Oe = A(Ce, Be, ve), Je = Ye.type === "ClassExpression" && Oe;
                    if (Oe && (Ie = [
                        ...Oe,
                        be
                    ], !Je)) return l(Ie);
                    if (!F(Ce, Be)) return ze && ze.needsSemi && Ie.unshift(";"), Ie.length === 1 && Ie[0] === be ? be : Ie;
                    if (Je && (Ie = [
                        p([
                            n,
                            ...Ie
                        ])
                    ]), Ie.unshift("("), ze && ze.needsSemi && Ie.unshift(";"), w(Ye)) {
                        let [je] = Ye.trailingComments;
                        Ie.push(" /*", je.value.trimStart(), "*/"), je.printed = !0;
                    }
                    return Je && Ie.push(n), Ie.push(")"), Ie;
                }
                function re(Ce, Be, ve, ze) {
                    let be = Ce.getValue(), Ye = Be.semi ? ";" : "";
                    if (!be) return "";
                    if (typeof be == "string") return be;
                    for (let Ie of [
                        De,
                        S,
                        B,
                        k,
                        R,
                        q
                    ]){
                        let Oe = Ie(Ce, Be, ve);
                        if (typeof Oe < "u") return Oe;
                    }
                    let Se = [];
                    switch(be.type){
                        case "JsExpressionRoot":
                            return ve("node");
                        case "JsonRoot":
                            return [
                                ve("node"),
                                u
                            ];
                        case "File":
                            return be.program && be.program.interpreter && Se.push(ve([
                                "program",
                                "interpreter"
                            ])), Se.push(ve("program")), Se;
                        case "Program":
                            return Ae(Ce, Be, ve);
                        case "EmptyStatement":
                            return "";
                        case "ExpressionStatement":
                            {
                                if (Be.parser === "__vue_event_binding" || Be.parser === "__vue_ts_event_binding") {
                                    let Oe = Ce.getParentNode();
                                    if (Oe.type === "Program" && Oe.body.length === 1 && Oe.body[0] === be) return [
                                        ve("expression"),
                                        b(be.expression) ? ";" : ""
                                    ];
                                }
                                let Ie = t(Ce, Be, !0, (Oe)=>{
                                    let { marker: Je } = Oe;
                                    return Je === C;
                                });
                                return [
                                    ve("expression"),
                                    x(Be, Ce) ? "" : Ye,
                                    Ie ? [
                                        " ",
                                        Ie
                                    ] : ""
                                ];
                            }
                        case "ParenthesizedExpression":
                            return !E(be.expression) && (be.expression.type === "ObjectExpression" || be.expression.type === "ArrayExpression") ? [
                                "(",
                                ve("expression"),
                                ")"
                            ] : l([
                                "(",
                                p([
                                    i,
                                    ve("expression")
                                ]),
                                i,
                                ")"
                            ]);
                        case "AssignmentExpression":
                            return oe(Ce, Be, ve);
                        case "VariableDeclarator":
                            return Pe(Ce, Be, ve);
                        case "BinaryExpression":
                        case "LogicalExpression":
                            return H(Ce, Be, ve);
                        case "AssignmentPattern":
                            return [
                                ve("left"),
                                " = ",
                                ve("right")
                            ];
                        case "OptionalMemberExpression":
                        case "MemberExpression":
                            return X(Ce, Be, ve);
                        case "MetaProperty":
                            return [
                                ve("meta"),
                                ".",
                                ve("property")
                            ];
                        case "BindExpression":
                            return be.object && Se.push(ve("object")), Se.push(l(p([
                                i,
                                L(Ce, Be, ve)
                            ]))), Se;
                        case "Identifier":
                            return [
                                be.name,
                                J(Ce),
                                Y(Ce),
                                Q(Ce, Be, ve)
                            ];
                        case "V8IntrinsicIdentifier":
                            return [
                                "%",
                                be.name
                            ];
                        case "SpreadElement":
                        case "SpreadElementPattern":
                        case "SpreadProperty":
                        case "SpreadPropertyPattern":
                        case "RestElement":
                            return j(Ce, Be, ve);
                        case "FunctionDeclaration":
                        case "FunctionExpression":
                            return ge(Ce, ve, Be, ze);
                        case "ArrowFunctionExpression":
                            return he(Ce, Be, ve, ze);
                        case "YieldExpression":
                            return Se.push("yield"), be.delegate && Se.push("*"), be.argument && Se.push(" ", ve("argument")), Se;
                        case "AwaitExpression":
                            if (Se.push("await"), be.argument) {
                                Se.push(" ", ve("argument"));
                                let Ie = Ce.getParentNode();
                                if (T(Ie) && Ie.callee === be || m(Ie) && Ie.object === be) {
                                    Se = [
                                        p([
                                            i,
                                            ...Se
                                        ]),
                                        i
                                    ];
                                    let Oe = Ce.findAncestor((Je)=>Je.type === "AwaitExpression" || Je.type === "BlockStatement");
                                    if (!Oe || Oe.type !== "AwaitExpression") return l(Se);
                                }
                            }
                            return Se;
                        case "ExportDefaultDeclaration":
                        case "ExportNamedDeclaration":
                            return ce(Ce, Be, ve);
                        case "ExportAllDeclaration":
                            return W(Ce, Be, ve);
                        case "ImportDeclaration":
                            return ee(Ce, Be, ve);
                        case "ImportSpecifier":
                        case "ExportSpecifier":
                        case "ImportNamespaceSpecifier":
                        case "ExportNamespaceSpecifier":
                        case "ImportDefaultSpecifier":
                        case "ExportDefaultSpecifier":
                            return K(Ce, Be, ve);
                        case "ImportAttribute":
                            return [
                                ve("key"),
                                ": ",
                                ve("value")
                            ];
                        case "Import":
                            return "import";
                        case "BlockStatement":
                        case "StaticBlock":
                        case "ClassBody":
                            return le(Ce, Be, ve);
                        case "ThrowStatement":
                            return Re(Ce, Be, ve);
                        case "ReturnStatement":
                            return ke(Ce, Be, ve);
                        case "NewExpression":
                        case "ImportExpression":
                        case "OptionalCallExpression":
                        case "CallExpression":
                            return Ne(Ce, Be, ve);
                        case "ObjectExpression":
                        case "ObjectPattern":
                        case "RecordExpression":
                            return z(Ce, Be, ve);
                        case "ObjectProperty":
                        case "Property":
                            return be.method || be.kind === "get" || be.kind === "set" ? we(Ce, Be, ve) : fe(Ce, Be, ve);
                        case "ObjectMethod":
                            return we(Ce, Be, ve);
                        case "Decorator":
                            return [
                                "@",
                                ve("expression")
                            ];
                        case "ArrayExpression":
                        case "ArrayPattern":
                        case "TupleExpression":
                            return Fe(Ce, Be, ve);
                        case "SequenceExpression":
                            {
                                let Ie = Ce.getParentNode(0);
                                if (Ie.type === "ExpressionStatement" || Ie.type === "ForStatement") {
                                    let Oe = [];
                                    return Ce.each((Je, Te)=>{
                                        Te === 0 ? Oe.push(ve()) : Oe.push(",", p([
                                            n,
                                            ve()
                                        ]));
                                    }, "expressions"), l(Oe);
                                }
                                return l(a([
                                    ",",
                                    n
                                ], Ce.map(ve, "expressions")));
                            }
                        case "ThisExpression":
                            return "this";
                        case "Super":
                            return "super";
                        case "Directive":
                            return [
                                ve("value"),
                                Ye
                            ];
                        case "DirectiveLiteral":
                            return ie(be.extra.raw, Be);
                        case "UnaryExpression":
                            return Se.push(be.operator), /[a-z]$/.test(be.operator) && Se.push(" "), E(be.argument) ? Se.push(l([
                                "(",
                                p([
                                    i,
                                    ve("argument")
                                ]),
                                i,
                                ")"
                            ])) : Se.push(ve("argument")), Se;
                        case "UpdateExpression":
                            return Se.push(ve("argument"), be.operator), be.prefix && Se.reverse(), Se;
                        case "ConditionalExpression":
                            return de(Ce, Be, ve);
                        case "VariableDeclaration":
                            {
                                let Ie = Ce.map(ve, "declarations"), Oe = Ce.getParentNode(), Je = Oe.type === "ForStatement" || Oe.type === "ForInStatement" || Oe.type === "ForOfStatement", Te = be.declarations.some((Me)=>Me.init), je;
                                return Ie.length === 1 && !E(be.declarations[0]) ? je = Ie[0] : Ie.length > 0 && (je = p(Ie[0])), Se = [
                                    be.declare ? "declare " : "",
                                    be.kind,
                                    je ? [
                                        " ",
                                        je
                                    ] : "",
                                    p(Ie.slice(1).map((Me)=>[
                                            ",",
                                            Te && !Je ? u : n,
                                            Me
                                        ]))
                                ], Je && Oe.body !== be || Se.push(Ye), l(Se);
                            }
                        case "WithStatement":
                            return l([
                                "with (",
                                ve("object"),
                                ")",
                                V(be.body, ve("body"))
                            ]);
                        case "IfStatement":
                            {
                                let Ie = V(be.consequent, ve("consequent")), Oe = l([
                                    "if (",
                                    l([
                                        p([
                                            i,
                                            ve("test")
                                        ]),
                                        i
                                    ]),
                                    ")",
                                    Ie
                                ]);
                                if (Se.push(Oe), be.alternate) {
                                    let Je = E(be.consequent, N.Trailing | N.Line) || $(be), Te = be.consequent.type === "BlockStatement" && !Je;
                                    Se.push(Te ? " " : u), E(be, N.Dangling) && Se.push(t(Ce, Be, !0), Je ? u : " "), Se.push("else", l(V(be.alternate, ve("alternate"), be.alternate.type === "IfStatement")));
                                }
                                return Se;
                            }
                        case "ForStatement":
                            {
                                let Ie = V(be.body, ve("body")), Oe = t(Ce, Be, !0), Je = Oe ? [
                                    Oe,
                                    i
                                ] : "";
                                return !be.init && !be.test && !be.update ? [
                                    Je,
                                    l([
                                        "for (;;)",
                                        Ie
                                    ])
                                ] : [
                                    Je,
                                    l([
                                        "for (",
                                        l([
                                            p([
                                                i,
                                                ve("init"),
                                                ";",
                                                n,
                                                ve("test"),
                                                ";",
                                                n,
                                                ve("update")
                                            ]),
                                            i
                                        ]),
                                        ")",
                                        Ie
                                    ])
                                ];
                            }
                        case "WhileStatement":
                            return l([
                                "while (",
                                l([
                                    p([
                                        i,
                                        ve("test")
                                    ]),
                                    i
                                ]),
                                ")",
                                V(be.body, ve("body"))
                            ]);
                        case "ForInStatement":
                            return l([
                                "for (",
                                ve("left"),
                                " in ",
                                ve("right"),
                                ")",
                                V(be.body, ve("body"))
                            ]);
                        case "ForOfStatement":
                            return l([
                                "for",
                                be.await ? " await" : "",
                                " (",
                                ve("left"),
                                " of ",
                                ve("right"),
                                ")",
                                V(be.body, ve("body"))
                            ]);
                        case "DoWhileStatement":
                            {
                                let Ie = V(be.body, ve("body"));
                                return Se = [
                                    l([
                                        "do",
                                        Ie
                                    ])
                                ], be.body.type === "BlockStatement" ? Se.push(" ") : Se.push(u), Se.push("while (", l([
                                    p([
                                        i,
                                        ve("test")
                                    ]),
                                    i
                                ]), ")", Ye), Se;
                            }
                        case "DoExpression":
                            return [
                                be.async ? "async " : "",
                                "do ",
                                ve("body")
                            ];
                        case "BreakStatement":
                            return Se.push("break"), be.label && Se.push(" ", ve("label")), Se.push(Ye), Se;
                        case "ContinueStatement":
                            return Se.push("continue"), be.label && Se.push(" ", ve("label")), Se.push(Ye), Se;
                        case "LabeledStatement":
                            return be.body.type === "EmptyStatement" ? [
                                ve("label"),
                                ":;"
                            ] : [
                                ve("label"),
                                ": ",
                                ve("body")
                            ];
                        case "TryStatement":
                            return [
                                "try ",
                                ve("block"),
                                be.handler ? [
                                    " ",
                                    ve("handler")
                                ] : "",
                                be.finalizer ? [
                                    " finally ",
                                    ve("finalizer")
                                ] : ""
                            ];
                        case "CatchClause":
                            if (be.param) {
                                let Ie = E(be.param, (Je)=>!v(Je) || Je.leading && s(Be.originalText, d(Je)) || Je.trailing && s(Be.originalText, o(Je), {
                                        backwards: !0
                                    })), Oe = ve("param");
                                return [
                                    "catch ",
                                    Ie ? [
                                        "(",
                                        p([
                                            i,
                                            Oe
                                        ]),
                                        i,
                                        ") "
                                    ] : [
                                        "(",
                                        Oe,
                                        ") "
                                    ],
                                    ve("body")
                                ];
                            }
                            return [
                                "catch ",
                                ve("body")
                            ];
                        case "SwitchStatement":
                            return [
                                l([
                                    "switch (",
                                    p([
                                        i,
                                        ve("discriminant")
                                    ]),
                                    i,
                                    ")"
                                ]),
                                " {",
                                be.cases.length > 0 ? p([
                                    u,
                                    a(u, Ce.map((Ie, Oe, Je)=>{
                                        let Te = Ie.getValue();
                                        return [
                                            ve(),
                                            Oe !== Je.length - 1 && P(Te, Be) ? u : ""
                                        ];
                                    }, "cases"))
                                ]) : "",
                                u,
                                "}"
                            ];
                        case "SwitchCase":
                            {
                                be.test ? Se.push("case ", ve("test"), ":") : Se.push("default:"), E(be, N.Dangling) && Se.push(" ", t(Ce, Be, !0));
                                let Ie = be.consequent.filter((Oe)=>Oe.type !== "EmptyStatement");
                                if (Ie.length > 0) {
                                    let Oe = pe(Ce, Be, ve);
                                    Se.push(Ie.length === 1 && Ie[0].type === "BlockStatement" ? [
                                        " ",
                                        Oe
                                    ] : p([
                                        u,
                                        Oe
                                    ]));
                                }
                                return Se;
                            }
                        case "DebuggerStatement":
                            return [
                                "debugger",
                                Ye
                            ];
                        case "ClassDeclaration":
                        case "ClassExpression":
                            return U(Ce, Be, ve);
                        case "ClassMethod":
                        case "ClassPrivateMethod":
                        case "MethodDefinition":
                            return Z(Ce, Be, ve);
                        case "ClassProperty":
                        case "PropertyDefinition":
                        case "ClassPrivateProperty":
                        case "ClassAccessorProperty":
                        case "AccessorProperty":
                            return se(Ce, Be, ve);
                        case "TemplateElement":
                            return y(be.value.raw);
                        case "TemplateLiteral":
                            return ue(Ce, ve, Be);
                        case "TaggedTemplateExpression":
                            return [
                                ve("tag"),
                                ve("typeParameters"),
                                ve("quasi")
                            ];
                        case "PrivateIdentifier":
                            return [
                                "#",
                                ve("name")
                            ];
                        case "PrivateName":
                            return [
                                "#",
                                ve("id")
                            ];
                        case "InterpreterDirective":
                            return Se.push("#!", be.value, u), P(be, Be) && Se.push(u), Se;
                        case "TopicReference":
                            return "%";
                        case "ArgumentPlaceholder":
                            return "?";
                        case "ModuleExpression":
                            {
                                Se.push("module {");
                                let Ie = ve("body");
                                return Ie && Se.push(p([
                                    u,
                                    Ie
                                ]), u), Se.push("}"), Se;
                            }
                        default:
                            throw new Error("unknown type: " + JSON.stringify(be.type));
                    }
                }
                function ye(Ce) {
                    return Ce.type && !v(Ce) && !I(Ce) && Ce.type !== "EmptyStatement" && Ce.type !== "TemplateElement" && Ce.type !== "Import" && Ce.type !== "TSEmptyBodyFunctionExpression";
                }
                r.exports = {
                    preprocess: _,
                    print: G,
                    embed: h,
                    insertPragma: c,
                    massageAstNode: g,
                    hasPrettierIgnore (Ce) {
                        return D(Ce) || M(Ce);
                    },
                    willPrintOwnComments: f.willPrintOwnComments,
                    canAttachComment: ye,
                    printComment: Ee,
                    isBlockComment: v,
                    handleComments: {
                        avoidAstMutation: !0,
                        ownLine: f.handleOwnLineComment,
                        endOfLine: f.handleEndOfLineComment,
                        remaining: f.handleRemainingComment
                    },
                    getCommentChildNodes: f.getCommentChildNodes
                };
            }
        }), Ed = te({
            "src/language-js/printer-estree-json.js" (e, r) {
                "use strict";
                ne();
                var { builders: { hardline: t, indent: s, join: a } } = qe(), n = Fo();
                function u(y, h, g) {
                    let c = y.getValue();
                    switch(c.type){
                        case "JsonRoot":
                            return [
                                g("node"),
                                t
                            ];
                        case "ArrayExpression":
                            {
                                if (c.elements.length === 0) return "[]";
                                let f = y.map(()=>y.getValue() === null ? "null" : g(), "elements");
                                return [
                                    "[",
                                    s([
                                        t,
                                        a([
                                            ",",
                                            t
                                        ], f)
                                    ]),
                                    t,
                                    "]"
                                ];
                            }
                        case "ObjectExpression":
                            return c.properties.length === 0 ? "{}" : [
                                "{",
                                s([
                                    t,
                                    a([
                                        ",",
                                        t
                                    ], y.map(g, "properties"))
                                ]),
                                t,
                                "}"
                            ];
                        case "ObjectProperty":
                            return [
                                g("key"),
                                ": ",
                                g("value")
                            ];
                        case "UnaryExpression":
                            return [
                                c.operator === "+" ? "" : c.operator,
                                g("argument")
                            ];
                        case "NullLiteral":
                            return "null";
                        case "BooleanLiteral":
                            return c.value ? "true" : "false";
                        case "StringLiteral":
                            return JSON.stringify(c.value);
                        case "NumericLiteral":
                            return i(y) ? JSON.stringify(String(c.value)) : JSON.stringify(c.value);
                        case "Identifier":
                            return i(y) ? JSON.stringify(c.name) : c.name;
                        case "TemplateLiteral":
                            return g([
                                "quasis",
                                0
                            ]);
                        case "TemplateElement":
                            return JSON.stringify(c.value.cooked);
                        default:
                            throw new Error("unknown type: " + JSON.stringify(c.type));
                    }
                }
                function i(y) {
                    return y.getName() === "key" && y.getParentNode().type === "ObjectProperty";
                }
                var l = new Set([
                    "start",
                    "end",
                    "extra",
                    "loc",
                    "comments",
                    "leadingComments",
                    "trailingComments",
                    "innerComments",
                    "errors",
                    "range",
                    "tokens"
                ]);
                function p(y, h) {
                    let { type: g } = y;
                    if (g === "ObjectProperty") {
                        let { key: c } = y;
                        c.type === "Identifier" ? h.key = {
                            type: "StringLiteral",
                            value: c.name
                        } : c.type === "NumericLiteral" && (h.key = {
                            type: "StringLiteral",
                            value: String(c.value)
                        });
                        return;
                    }
                    if (g === "UnaryExpression" && y.operator === "+") return h.argument;
                    if (g === "ArrayExpression") {
                        for (let [c, f] of y.elements.entries())f === null && h.elements.splice(c, 0, {
                            type: "NullLiteral"
                        });
                        return;
                    }
                    if (g === "TemplateLiteral") return {
                        type: "StringLiteral",
                        value: y.quasis[0].value.cooked
                    };
                }
                p.ignoredProperties = l, r.exports = {
                    preprocess: n,
                    print: u,
                    massageAstNode: p
                };
            }
        }), Mt = te({
            "src/common/common-options.js" (e, r) {
                "use strict";
                ne();
                var t = "Common";
                r.exports = {
                    bracketSpacing: {
                        since: "0.0.0",
                        category: t,
                        type: "boolean",
                        default: !0,
                        description: "Print spaces between brackets.",
                        oppositeDescription: "Do not print spaces between brackets."
                    },
                    singleQuote: {
                        since: "0.0.0",
                        category: t,
                        type: "boolean",
                        default: !1,
                        description: "Use single quotes instead of double quotes."
                    },
                    proseWrap: {
                        since: "1.8.2",
                        category: t,
                        type: "choice",
                        default: [
                            {
                                since: "1.8.2",
                                value: !0
                            },
                            {
                                since: "1.9.0",
                                value: "preserve"
                            }
                        ],
                        description: "How to wrap prose.",
                        choices: [
                            {
                                since: "1.9.0",
                                value: "always",
                                description: "Wrap prose if it exceeds the print width."
                            },
                            {
                                since: "1.9.0",
                                value: "never",
                                description: "Do not wrap prose."
                            },
                            {
                                since: "1.9.0",
                                value: "preserve",
                                description: "Wrap prose as-is."
                            }
                        ]
                    },
                    bracketSameLine: {
                        since: "2.4.0",
                        category: t,
                        type: "boolean",
                        default: !1,
                        description: "Put > of opening tags on the last line instead of on a new line."
                    },
                    singleAttributePerLine: {
                        since: "2.6.0",
                        category: t,
                        type: "boolean",
                        default: !1,
                        description: "Enforce single attribute per line in HTML, Vue and JSX."
                    }
                };
            }
        }), Fd = te({
            "src/language-js/options.js" (e, r) {
                "use strict";
                ne();
                var t = Mt(), s = "JavaScript";
                r.exports = {
                    arrowParens: {
                        since: "1.9.0",
                        category: s,
                        type: "choice",
                        default: [
                            {
                                since: "1.9.0",
                                value: "avoid"
                            },
                            {
                                since: "2.0.0",
                                value: "always"
                            }
                        ],
                        description: "Include parentheses around a sole arrow function parameter.",
                        choices: [
                            {
                                value: "always",
                                description: "Always include parens. Example: `(x) => x`"
                            },
                            {
                                value: "avoid",
                                description: "Omit parens when possible. Example: `x => x`"
                            }
                        ]
                    },
                    bracketSameLine: t.bracketSameLine,
                    bracketSpacing: t.bracketSpacing,
                    jsxBracketSameLine: {
                        since: "0.17.0",
                        category: s,
                        type: "boolean",
                        description: "Put > on the last line instead of at a new line.",
                        deprecated: "2.4.0"
                    },
                    semi: {
                        since: "1.0.0",
                        category: s,
                        type: "boolean",
                        default: !0,
                        description: "Print semicolons.",
                        oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them."
                    },
                    singleQuote: t.singleQuote,
                    jsxSingleQuote: {
                        since: "1.15.0",
                        category: s,
                        type: "boolean",
                        default: !1,
                        description: "Use single quotes in JSX."
                    },
                    quoteProps: {
                        since: "1.17.0",
                        category: s,
                        type: "choice",
                        default: "as-needed",
                        description: "Change when properties in objects are quoted.",
                        choices: [
                            {
                                value: "as-needed",
                                description: "Only add quotes around object properties where required."
                            },
                            {
                                value: "consistent",
                                description: "If at least one property in an object requires quotes, quote all properties."
                            },
                            {
                                value: "preserve",
                                description: "Respect the input use of quotes in object properties."
                            }
                        ]
                    },
                    trailingComma: {
                        since: "0.0.0",
                        category: s,
                        type: "choice",
                        default: [
                            {
                                since: "0.0.0",
                                value: !1
                            },
                            {
                                since: "0.19.0",
                                value: "none"
                            },
                            {
                                since: "2.0.0",
                                value: "es5"
                            }
                        ],
                        description: "Print trailing commas wherever possible when multi-line.",
                        choices: [
                            {
                                value: "es5",
                                description: "Trailing commas where valid in ES5 (objects, arrays, etc.)"
                            },
                            {
                                value: "none",
                                description: "No trailing commas."
                            },
                            {
                                value: "all",
                                description: "Trailing commas wherever possible (including function arguments)."
                            }
                        ]
                    },
                    singleAttributePerLine: t.singleAttributePerLine
                };
            }
        }), Ad = te({
            "src/language-js/parse/parsers.js" () {
                ne();
            }
        }), Ln = te({
            "node_modules/linguist-languages/data/JavaScript.json" (e, r) {
                r.exports = {
                    name: "JavaScript",
                    type: "programming",
                    tmScope: "source.js",
                    aceMode: "javascript",
                    codemirrorMode: "javascript",
                    codemirrorMimeType: "text/javascript",
                    color: "#f1e05a",
                    aliases: [
                        "js",
                        "node"
                    ],
                    extensions: [
                        ".js",
                        "._js",
                        ".bones",
                        ".cjs",
                        ".es",
                        ".es6",
                        ".frag",
                        ".gs",
                        ".jake",
                        ".javascript",
                        ".jsb",
                        ".jscad",
                        ".jsfl",
                        ".jslib",
                        ".jsm",
                        ".jspre",
                        ".jss",
                        ".jsx",
                        ".mjs",
                        ".njs",
                        ".pac",
                        ".sjs",
                        ".ssjs",
                        ".xsjs",
                        ".xsjslib"
                    ],
                    filenames: [
                        "Jakefile"
                    ],
                    interpreters: [
                        "chakra",
                        "d8",
                        "gjs",
                        "js",
                        "node",
                        "nodejs",
                        "qjs",
                        "rhino",
                        "v8",
                        "v8-shell"
                    ],
                    languageId: 183
                };
            }
        }), Sd = te({
            "node_modules/linguist-languages/data/TypeScript.json" (e, r) {
                r.exports = {
                    name: "TypeScript",
                    type: "programming",
                    color: "#3178c6",
                    aliases: [
                        "ts"
                    ],
                    interpreters: [
                        "deno",
                        "ts-node"
                    ],
                    extensions: [
                        ".ts",
                        ".cts",
                        ".mts"
                    ],
                    tmScope: "source.ts",
                    aceMode: "typescript",
                    codemirrorMode: "javascript",
                    codemirrorMimeType: "application/typescript",
                    languageId: 378
                };
            }
        }), xd = te({
            "node_modules/linguist-languages/data/TSX.json" (e, r) {
                r.exports = {
                    name: "TSX",
                    type: "programming",
                    color: "#3178c6",
                    group: "TypeScript",
                    extensions: [
                        ".tsx"
                    ],
                    tmScope: "source.tsx",
                    aceMode: "javascript",
                    codemirrorMode: "jsx",
                    codemirrorMimeType: "text/jsx",
                    languageId: 94901924
                };
            }
        }), wa = te({
            "node_modules/linguist-languages/data/JSON.json" (e, r) {
                r.exports = {
                    name: "JSON",
                    type: "data",
                    color: "#292929",
                    tmScope: "source.json",
                    aceMode: "json",
                    codemirrorMode: "javascript",
                    codemirrorMimeType: "application/json",
                    aliases: [
                        "geojson",
                        "jsonl",
                        "topojson"
                    ],
                    extensions: [
                        ".json",
                        ".4DForm",
                        ".4DProject",
                        ".avsc",
                        ".geojson",
                        ".gltf",
                        ".har",
                        ".ice",
                        ".JSON-tmLanguage",
                        ".jsonl",
                        ".mcmeta",
                        ".tfstate",
                        ".tfstate.backup",
                        ".topojson",
                        ".webapp",
                        ".webmanifest",
                        ".yy",
                        ".yyp"
                    ],
                    filenames: [
                        ".arcconfig",
                        ".auto-changelog",
                        ".c8rc",
                        ".htmlhintrc",
                        ".imgbotconfig",
                        ".nycrc",
                        ".tern-config",
                        ".tern-project",
                        ".watchmanconfig",
                        "Pipfile.lock",
                        "composer.lock",
                        "mcmod.info"
                    ],
                    languageId: 174
                };
            }
        }), bd = te({
            "node_modules/linguist-languages/data/JSON with Comments.json" (e, r) {
                r.exports = {
                    name: "JSON with Comments",
                    type: "data",
                    color: "#292929",
                    group: "JSON",
                    tmScope: "source.js",
                    aceMode: "javascript",
                    codemirrorMode: "javascript",
                    codemirrorMimeType: "text/javascript",
                    aliases: [
                        "jsonc"
                    ],
                    extensions: [
                        ".jsonc",
                        ".code-snippets",
                        ".sublime-build",
                        ".sublime-commands",
                        ".sublime-completions",
                        ".sublime-keymap",
                        ".sublime-macro",
                        ".sublime-menu",
                        ".sublime-mousemap",
                        ".sublime-project",
                        ".sublime-settings",
                        ".sublime-theme",
                        ".sublime-workspace",
                        ".sublime_metrics",
                        ".sublime_session"
                    ],
                    filenames: [
                        ".babelrc",
                        ".devcontainer.json",
                        ".eslintrc.json",
                        ".jscsrc",
                        ".jshintrc",
                        ".jslintrc",
                        "api-extractor.json",
                        "devcontainer.json",
                        "jsconfig.json",
                        "language-configuration.json",
                        "tsconfig.json",
                        "tslint.json"
                    ],
                    languageId: 423
                };
            }
        }), Td = te({
            "node_modules/linguist-languages/data/JSON5.json" (e, r) {
                r.exports = {
                    name: "JSON5",
                    type: "data",
                    color: "#267CB9",
                    extensions: [
                        ".json5"
                    ],
                    tmScope: "source.js",
                    aceMode: "javascript",
                    codemirrorMode: "javascript",
                    codemirrorMimeType: "application/json",
                    languageId: 175
                };
            }
        }), Bd = te({
            "src/language-js/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = Cd(), a = Ed(), n = Fd(), u = Ad(), i = [
                    t(Ln(), (p)=>({
                            since: "0.0.0",
                            parsers: [
                                "babel",
                                "acorn",
                                "espree",
                                "meriyah",
                                "babel-flow",
                                "babel-ts",
                                "flow",
                                "typescript"
                            ],
                            vscodeLanguageIds: [
                                "javascript",
                                "mongo"
                            ],
                            interpreters: [
                                ...p.interpreters,
                                "zx"
                            ],
                            extensions: [
                                ...p.extensions.filter((y)=>y !== ".jsx"),
                                ".wxs"
                            ]
                        })),
                    t(Ln(), ()=>({
                            name: "Flow",
                            since: "0.0.0",
                            parsers: [
                                "flow",
                                "babel-flow"
                            ],
                            vscodeLanguageIds: [
                                "javascript"
                            ],
                            aliases: [],
                            filenames: [],
                            extensions: [
                                ".js.flow"
                            ]
                        })),
                    t(Ln(), ()=>({
                            name: "JSX",
                            since: "0.0.0",
                            parsers: [
                                "babel",
                                "babel-flow",
                                "babel-ts",
                                "flow",
                                "typescript",
                                "espree",
                                "meriyah"
                            ],
                            vscodeLanguageIds: [
                                "javascriptreact"
                            ],
                            aliases: void 0,
                            filenames: void 0,
                            extensions: [
                                ".jsx"
                            ],
                            group: "JavaScript",
                            interpreters: void 0,
                            tmScope: "source.js.jsx",
                            aceMode: "javascript",
                            codemirrorMode: "jsx",
                            codemirrorMimeType: "text/jsx",
                            color: void 0
                        })),
                    t(Sd(), ()=>({
                            since: "1.4.0",
                            parsers: [
                                "typescript",
                                "babel-ts"
                            ],
                            vscodeLanguageIds: [
                                "typescript"
                            ]
                        })),
                    t(xd(), ()=>({
                            since: "1.4.0",
                            parsers: [
                                "typescript",
                                "babel-ts"
                            ],
                            vscodeLanguageIds: [
                                "typescriptreact"
                            ]
                        })),
                    t(wa(), ()=>({
                            name: "JSON.stringify",
                            since: "1.13.0",
                            parsers: [
                                "json-stringify"
                            ],
                            vscodeLanguageIds: [
                                "json"
                            ],
                            extensions: [
                                ".importmap"
                            ],
                            filenames: [
                                "package.json",
                                "package-lock.json",
                                "composer.json"
                            ]
                        })),
                    t(wa(), (p)=>({
                            since: "1.5.0",
                            parsers: [
                                "json"
                            ],
                            vscodeLanguageIds: [
                                "json"
                            ],
                            extensions: p.extensions.filter((y)=>y !== ".jsonl")
                        })),
                    t(bd(), (p)=>({
                            since: "1.5.0",
                            parsers: [
                                "json"
                            ],
                            vscodeLanguageIds: [
                                "jsonc"
                            ],
                            filenames: [
                                ...p.filenames,
                                ".eslintrc",
                                ".swcrc"
                            ]
                        })),
                    t(Td(), ()=>({
                            since: "1.13.0",
                            parsers: [
                                "json5"
                            ],
                            vscodeLanguageIds: [
                                "json5"
                            ]
                        }))
                ], l = {
                    estree: s,
                    "estree-json": a
                };
                r.exports = {
                    languages: i,
                    options: n,
                    printers: l,
                    parsers: u
                };
            }
        }), Nd = te({
            "src/language-css/clean.js" (e, r) {
                "use strict";
                ne();
                var { isFrontMatterNode: t } = Ue(), s = lt(), a = new Set([
                    "raw",
                    "raws",
                    "sourceIndex",
                    "source",
                    "before",
                    "after",
                    "trailingComma"
                ]);
                function n(i, l, p) {
                    if (t(i) && i.lang === "yaml" && delete l.value, i.type === "css-comment" && p.type === "css-root" && p.nodes.length > 0 && ((p.nodes[0] === i || t(p.nodes[0]) && p.nodes[1] === i) && (delete l.text, /^\*\s*@(?:format|prettier)\s*$/.test(i.text)) || p.type === "css-root" && s(p.nodes) === i)) return null;
                    if (i.type === "value-root" && delete l.text, (i.type === "media-query" || i.type === "media-query-list" || i.type === "media-feature-expression") && delete l.value, i.type === "css-rule" && delete l.params, i.type === "selector-combinator" && (l.value = l.value.replace(/\s+/g, " ")), i.type === "media-feature" && (l.value = l.value.replace(/ /g, "")), (i.type === "value-word" && (i.isColor && i.isHex || [
                        "initial",
                        "inherit",
                        "unset",
                        "revert"
                    ].includes(l.value.replace().toLowerCase())) || i.type === "media-feature" || i.type === "selector-root-invalid" || i.type === "selector-pseudo") && (l.value = l.value.toLowerCase()), i.type === "css-decl" && (l.prop = l.prop.toLowerCase()), (i.type === "css-atrule" || i.type === "css-import") && (l.name = l.name.toLowerCase()), i.type === "value-number" && (l.unit = l.unit.toLowerCase()), (i.type === "media-feature" || i.type === "media-keyword" || i.type === "media-type" || i.type === "media-unknown" || i.type === "media-url" || i.type === "media-value" || i.type === "selector-attribute" || i.type === "selector-string" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "value-string") && l.value && (l.value = u(l.value)), i.type === "selector-attribute" && (l.attribute = l.attribute.trim(), l.namespace && typeof l.namespace == "string" && (l.namespace = l.namespace.trim(), l.namespace.length === 0 && (l.namespace = !0)), l.value && (l.value = l.value.trim().replace(/^["']|["']$/g, ""), delete l.quoted)), (i.type === "media-value" || i.type === "media-type" || i.type === "value-number" || i.type === "selector-root-invalid" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "selector-tag") && l.value && (l.value = l.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (y, h, g)=>{
                        let c = Number(h);
                        return Number.isNaN(c) ? y : c + g.toLowerCase();
                    })), i.type === "selector-tag") {
                        let y = i.value.toLowerCase();
                        [
                            "from",
                            "to"
                        ].includes(y) && (l.value = y);
                    }
                    if (i.type === "css-atrule" && i.name.toLowerCase() === "supports" && delete l.value, i.type === "selector-unknown" && delete l.value, i.type === "value-comma_group") {
                        let y = i.groups.findIndex((h)=>h.type === "value-number" && h.unit === "...");
                        y !== -1 && (l.groups[y].unit = "", l.groups.splice(y + 1, 0, {
                            type: "value-word",
                            value: "...",
                            isColor: !1,
                            isHex: !1
                        }));
                    }
                    if (i.type === "value-comma_group" && i.groups.some((y)=>y.type === "value-atword" && y.value.endsWith("[") || y.type === "value-word" && y.value.startsWith("]"))) return {
                        type: "value-atword",
                        value: i.groups.map((y)=>y.value).join(""),
                        group: {
                            open: null,
                            close: null,
                            groups: [],
                            type: "value-paren_group"
                        }
                    };
                }
                n.ignoredProperties = a;
                function u(i) {
                    return i.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
                }
                r.exports = n;
            }
        }), su = te({
            "src/utils/front-matter/print.js" (e, r) {
                "use strict";
                ne();
                var { builders: { hardline: t, markAsRoot: s } } = qe();
                function a(n, u) {
                    if (n.lang === "yaml") {
                        let i = n.value.trim(), l = i ? u(i, {
                            parser: "yaml"
                        }, {
                            stripTrailingHardline: !0
                        }) : "";
                        return s([
                            n.startDelimiter,
                            t,
                            l,
                            l ? t : "",
                            n.endDelimiter
                        ]);
                    }
                }
                r.exports = a;
            }
        }), wd = te({
            "src/language-css/embed.js" (e, r) {
                "use strict";
                ne();
                var { builders: { hardline: t } } = qe(), s = su();
                function a(n, u, i) {
                    let l = n.getValue();
                    if (l.type === "front-matter") {
                        let p = s(l, i);
                        return p ? [
                            p,
                            t
                        ] : "";
                    }
                }
                r.exports = a;
            }
        }), _o = te({
            "src/utils/front-matter/parse.js" (e, r) {
                "use strict";
                ne();
                var t = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
                function s(a) {
                    let n = a.match(t);
                    if (!n) return {
                        content: a
                    };
                    let { startDelimiter: u, language: i, value: l = "", endDelimiter: p } = n.groups, y = i.trim() || "yaml";
                    if (u === "+++" && (y = "toml"), y !== "yaml" && u !== p) return {
                        content: a
                    };
                    let [h] = n;
                    return {
                        frontMatter: {
                            type: "front-matter",
                            lang: y,
                            value: l,
                            startDelimiter: u,
                            endDelimiter: p,
                            raw: h.replace(/\n$/, "")
                        },
                        content: h.replace(/[^\n]/g, " ") + a.slice(h.length)
                    };
                }
                r.exports = s;
            }
        }), _d = te({
            "src/language-css/pragma.js" (e, r) {
                "use strict";
                ne();
                var t = Co(), s = _o();
                function a(u) {
                    return t.hasPragma(s(u).content);
                }
                function n(u) {
                    let { frontMatter: i, content: l } = s(u);
                    return (i ? i.raw + `

` : "") + t.insertPragma(l);
                }
                r.exports = {
                    hasPragma: a,
                    insertPragma: n
                };
            }
        }), Pd = te({
            "src/language-css/utils/index.js" (e, r) {
                "use strict";
                ne();
                var t = new Set([
                    "red",
                    "green",
                    "blue",
                    "alpha",
                    "a",
                    "rgb",
                    "hue",
                    "h",
                    "saturation",
                    "s",
                    "lightness",
                    "l",
                    "whiteness",
                    "w",
                    "blackness",
                    "b",
                    "tint",
                    "shade",
                    "blend",
                    "blenda",
                    "contrast",
                    "hsl",
                    "hsla",
                    "hwb",
                    "hwba"
                ]);
                function s(z, U) {
                    let Z = Array.isArray(U) ? U : [
                        U
                    ], se = -1, fe;
                    for(; fe = z.getParentNode(++se);)if (Z.includes(fe.type)) return se;
                    return -1;
                }
                function a(z, U) {
                    let Z = s(z, U);
                    return Z === -1 ? null : z.getParentNode(Z);
                }
                function n(z) {
                    var U;
                    let Z = a(z, "css-decl");
                    return Z == null || (U = Z.prop) === null || U === void 0 ? void 0 : U.toLowerCase();
                }
                var u = new Set([
                    "initial",
                    "inherit",
                    "unset",
                    "revert"
                ]);
                function i(z) {
                    return u.has(z.toLowerCase());
                }
                function l(z, U) {
                    let Z = a(z, "css-atrule");
                    return (Z == null ? void 0 : Z.name) && Z.name.toLowerCase().endsWith("keyframes") && [
                        "from",
                        "to"
                    ].includes(U.toLowerCase());
                }
                function p(z) {
                    return z.includes("$") || z.includes("@") || z.includes("#") || z.startsWith("%") || z.startsWith("--") || z.startsWith(":--") || z.includes("(") && z.includes(")") ? z : z.toLowerCase();
                }
                function y(z, U) {
                    var Z;
                    let se = a(z, "value-func");
                    return (se == null || (Z = se.value) === null || Z === void 0 ? void 0 : Z.toLowerCase()) === U;
                }
                function h(z) {
                    var U;
                    let Z = a(z, "css-rule"), se = Z == null || (U = Z.raws) === null || U === void 0 ? void 0 : U.selector;
                    return se && (se.startsWith(":import") || se.startsWith(":export"));
                }
                function g(z, U) {
                    let Z = Array.isArray(U) ? U : [
                        U
                    ], se = a(z, "css-atrule");
                    return se && Z.includes(se.name.toLowerCase());
                }
                function c(z) {
                    let U = z.getValue(), Z = a(z, "css-atrule");
                    return (Z == null ? void 0 : Z.name) === "import" && U.groups[0].value === "url" && U.groups.length === 2;
                }
                function f(z) {
                    return z.type === "value-func" && z.value.toLowerCase() === "url";
                }
                function F(z, U) {
                    var Z;
                    let se = (Z = z.getParentNode()) === null || Z === void 0 ? void 0 : Z.nodes;
                    return se && se.indexOf(U) === se.length - 1;
                }
                function _(z) {
                    let { selector: U } = z;
                    return U ? typeof U == "string" && /^@.+:.*$/.test(U) || U.value && /^@.+:.*$/.test(U.value) : !1;
                }
                function w(z) {
                    return z.type === "value-word" && [
                        "from",
                        "through",
                        "end"
                    ].includes(z.value);
                }
                function E(z) {
                    return z.type === "value-word" && [
                        "and",
                        "or",
                        "not"
                    ].includes(z.value);
                }
                function N(z) {
                    return z.type === "value-word" && z.value === "in";
                }
                function x(z) {
                    return z.type === "value-operator" && z.value === "*";
                }
                function I(z) {
                    return z.type === "value-operator" && z.value === "/";
                }
                function P(z) {
                    return z.type === "value-operator" && z.value === "+";
                }
                function $(z) {
                    return z.type === "value-operator" && z.value === "-";
                }
                function D(z) {
                    return z.type === "value-operator" && z.value === "%";
                }
                function T(z) {
                    return x(z) || I(z) || P(z) || $(z) || D(z);
                }
                function m(z) {
                    return z.type === "value-word" && [
                        "==",
                        "!="
                    ].includes(z.value);
                }
                function C(z) {
                    return z.type === "value-word" && [
                        "<",
                        ">",
                        "<=",
                        ">="
                    ].includes(z.value);
                }
                function o(z) {
                    return z.type === "css-atrule" && [
                        "if",
                        "else",
                        "for",
                        "each",
                        "while"
                    ].includes(z.name);
                }
                function d(z) {
                    var U;
                    return ((U = z.raws) === null || U === void 0 ? void 0 : U.params) && /^\(\s*\)$/.test(z.raws.params);
                }
                function v(z) {
                    return z.name.startsWith("prettier-placeholder");
                }
                function S(z) {
                    return z.prop.startsWith("@prettier-placeholder");
                }
                function b(z, U) {
                    return z.value === "$$" && z.type === "value-func" && (U == null ? void 0 : U.type) === "value-word" && !U.raws.before;
                }
                function B(z) {
                    var U, Z;
                    return ((U = z.value) === null || U === void 0 ? void 0 : U.type) === "value-root" && ((Z = z.value.group) === null || Z === void 0 ? void 0 : Z.type) === "value-value" && z.prop.toLowerCase() === "composes";
                }
                function k(z) {
                    var U, Z, se;
                    return ((U = z.value) === null || U === void 0 || (Z = U.group) === null || Z === void 0 || (se = Z.group) === null || se === void 0 ? void 0 : se.type) === "value-paren_group" && z.value.group.group.open !== null && z.value.group.group.close !== null;
                }
                function M(z) {
                    var U;
                    return ((U = z.raws) === null || U === void 0 ? void 0 : U.before) === "";
                }
                function R(z) {
                    var U, Z;
                    return z.type === "value-comma_group" && ((U = z.groups) === null || U === void 0 || (Z = U[1]) === null || Z === void 0 ? void 0 : Z.type) === "value-colon";
                }
                function q(z) {
                    var U;
                    return z.type === "value-paren_group" && ((U = z.groups) === null || U === void 0 ? void 0 : U[0]) && R(z.groups[0]);
                }
                function J(z) {
                    var U;
                    let Z = z.getValue();
                    if (Z.groups.length === 0) return !1;
                    let se = z.getParentNode(1);
                    if (!q(Z) && !(se && q(se))) return !1;
                    let fe = a(z, "css-decl");
                    return !!(fe != null && (U = fe.prop) !== null && U !== void 0 && U.startsWith("$") || q(se) || se.type === "value-func");
                }
                function L(z) {
                    return z.type === "value-comment" && z.inline;
                }
                function Q(z) {
                    return z.type === "value-word" && z.value === "#";
                }
                function V(z) {
                    return z.type === "value-word" && z.value === "{";
                }
                function j(z) {
                    return z.type === "value-word" && z.value === "}";
                }
                function Y(z) {
                    return [
                        "value-word",
                        "value-atword"
                    ].includes(z.type);
                }
                function ie(z) {
                    return (z == null ? void 0 : z.type) === "value-colon";
                }
                function ee(z, U) {
                    if (!R(U)) return !1;
                    let { groups: Z } = U, se = Z.indexOf(z);
                    return se === -1 ? !1 : ie(Z[se + 1]);
                }
                function ce(z) {
                    return z.value && [
                        "not",
                        "and",
                        "or"
                    ].includes(z.value.toLowerCase());
                }
                function W(z) {
                    return z.type !== "value-func" ? !1 : t.has(z.value.toLowerCase());
                }
                function K(z) {
                    return /\/\//.test(z.split(/[\n\r]/).pop());
                }
                function de(z) {
                    return (z == null ? void 0 : z.type) === "value-atword" && z.value.startsWith("prettier-placeholder-");
                }
                function ue(z, U) {
                    var Z, se;
                    if (((Z = z.open) === null || Z === void 0 ? void 0 : Z.value) !== "(" || ((se = z.close) === null || se === void 0 ? void 0 : se.value) !== ")" || z.groups.some((fe)=>fe.type !== "value-comma_group")) return !1;
                    if (U.type === "value-comma_group") {
                        let fe = U.groups.indexOf(z) - 1, ge = U.groups[fe];
                        if ((ge == null ? void 0 : ge.type) === "value-word" && ge.value === "with") return !0;
                    }
                    return !1;
                }
                function Fe(z) {
                    var U, Z;
                    return z.type === "value-paren_group" && ((U = z.open) === null || U === void 0 ? void 0 : U.value) === "(" && ((Z = z.close) === null || Z === void 0 ? void 0 : Z.value) === ")";
                }
                r.exports = {
                    getAncestorCounter: s,
                    getAncestorNode: a,
                    getPropOfDeclNode: n,
                    maybeToLowerCase: p,
                    insideValueFunctionNode: y,
                    insideICSSRuleNode: h,
                    insideAtRuleNode: g,
                    insideURLFunctionInImportAtRuleNode: c,
                    isKeyframeAtRuleKeywords: l,
                    isWideKeywords: i,
                    isLastNode: F,
                    isSCSSControlDirectiveNode: o,
                    isDetachedRulesetDeclarationNode: _,
                    isRelationalOperatorNode: C,
                    isEqualityOperatorNode: m,
                    isMultiplicationNode: x,
                    isDivisionNode: I,
                    isAdditionNode: P,
                    isSubtractionNode: $,
                    isModuloNode: D,
                    isMathOperatorNode: T,
                    isEachKeywordNode: N,
                    isForKeywordNode: w,
                    isURLFunctionNode: f,
                    isIfElseKeywordNode: E,
                    hasComposesNode: B,
                    hasParensAroundNode: k,
                    hasEmptyRawBefore: M,
                    isDetachedRulesetCallNode: d,
                    isTemplatePlaceholderNode: v,
                    isTemplatePropNode: S,
                    isPostcssSimpleVarNode: b,
                    isKeyValuePairNode: R,
                    isKeyValuePairInParenGroupNode: q,
                    isKeyInValuePairNode: ee,
                    isSCSSMapItemNode: J,
                    isInlineValueCommentNode: L,
                    isHashNode: Q,
                    isLeftCurlyBraceNode: V,
                    isRightCurlyBraceNode: j,
                    isWordNode: Y,
                    isColonNode: ie,
                    isMediaAndSupportsKeywords: ce,
                    isColorAdjusterFuncNode: W,
                    lastLineHasInlineComment: K,
                    isAtWordPlaceholderNode: de,
                    isConfigurationNode: ue,
                    isParenGroupNode: Fe
                };
            }
        }), Id = te({
            "src/utils/line-column-to-index.js" (e, r) {
                "use strict";
                ne(), r.exports = function(t, s) {
                    let a = 0;
                    for(let n = 0; n < t.line - 1; ++n)a = s.indexOf(`
`, a) + 1;
                    return a + t.column;
                };
            }
        }), kd = te({
            "src/language-css/loc.js" (e, r) {
                "use strict";
                ne();
                var { skipEverythingButNewLine: t } = Pr(), s = lt(), a = Id();
                function n(c, f) {
                    return typeof c.sourceIndex == "number" ? c.sourceIndex : c.source ? a(c.source.start, f) - 1 : null;
                }
                function u(c, f) {
                    if (c.type === "css-comment" && c.inline) return t(f, c.source.startOffset);
                    let F = c.nodes && s(c.nodes);
                    return F && c.source && !c.source.end && (c = F), c.source && c.source.end ? a(c.source.end, f) : null;
                }
                function i(c, f) {
                    c.source && (c.source.startOffset = n(c, f), c.source.endOffset = u(c, f));
                    for(let F in c){
                        let _ = c[F];
                        F === "source" || !_ || typeof _ != "object" || (_.type === "value-root" || _.type === "value-unknown" ? l(_, p(c), _.text || _.value) : i(_, f));
                    }
                }
                function l(c, f, F) {
                    c.source && (c.source.startOffset = n(c, F) + f, c.source.endOffset = u(c, F) + f);
                    for(let _ in c){
                        let w = c[_];
                        _ === "source" || !w || typeof w != "object" || l(w, f, F);
                    }
                }
                function p(c) {
                    let f = c.source.startOffset;
                    return typeof c.prop == "string" && (f += c.prop.length), c.type === "css-atrule" && typeof c.name == "string" && (f += 1 + c.name.length + c.raws.afterName.match(/^\s*:?\s*/)[0].length), c.type !== "css-atrule" && c.raws && typeof c.raws.between == "string" && (f += c.raws.between.length), f;
                }
                function y(c) {
                    let f = "initial", F = "initial", _, w = !1, E = [];
                    for(let N = 0; N < c.length; N++){
                        let x = c[N];
                        switch(f){
                            case "initial":
                                if (x === "'") {
                                    f = "single-quotes";
                                    continue;
                                }
                                if (x === '"') {
                                    f = "double-quotes";
                                    continue;
                                }
                                if ((x === "u" || x === "U") && c.slice(N, N + 4).toLowerCase() === "url(") {
                                    f = "url", N += 3;
                                    continue;
                                }
                                if (x === "*" && c[N - 1] === "/") {
                                    f = "comment-block";
                                    continue;
                                }
                                if (x === "/" && c[N - 1] === "/") {
                                    f = "comment-inline", _ = N - 1;
                                    continue;
                                }
                                continue;
                            case "single-quotes":
                                if (x === "'" && c[N - 1] !== "\\" && (f = F, F = "initial"), x === `
` || x === "\r") return c;
                                continue;
                            case "double-quotes":
                                if (x === '"' && c[N - 1] !== "\\" && (f = F, F = "initial"), x === `
` || x === "\r") return c;
                                continue;
                            case "url":
                                if (x === ")" && (f = "initial"), x === `
` || x === "\r") return c;
                                if (x === "'") {
                                    f = "single-quotes", F = "url";
                                    continue;
                                }
                                if (x === '"') {
                                    f = "double-quotes", F = "url";
                                    continue;
                                }
                                continue;
                            case "comment-block":
                                x === "/" && c[N - 1] === "*" && (f = "initial");
                                continue;
                            case "comment-inline":
                                (x === '"' || x === "'" || x === "*") && (w = !0), (x === `
` || x === "\r") && (w && E.push([
                                    _,
                                    N
                                ]), f = "initial", w = !1);
                                continue;
                        }
                    }
                    for (let [N, x] of E)c = c.slice(0, N) + c.slice(N, x).replace(/["'*]/g, " ") + c.slice(x);
                    return c;
                }
                function h(c) {
                    return c.source.startOffset;
                }
                function g(c) {
                    return c.source.endOffset;
                }
                r.exports = {
                    locStart: h,
                    locEnd: g,
                    calculateLoc: i,
                    replaceQuotesInInlineComments: y
                };
            }
        }), Ld = te({
            "src/language-css/utils/is-less-parser.js" (e, r) {
                "use strict";
                ne();
                function t(s) {
                    return s.parser === "css" || s.parser === "less";
                }
                r.exports = t;
            }
        }), Od = te({
            "src/language-css/utils/is-scss.js" (e, r) {
                "use strict";
                ne();
                function t(s, a) {
                    return s === "less" || s === "scss" ? s === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a);
                }
                r.exports = t;
            }
        }), jd = te({
            "src/language-css/utils/css-units.evaluate.js" (e, r) {
                r.exports = {
                    em: "em",
                    rem: "rem",
                    ex: "ex",
                    rex: "rex",
                    cap: "cap",
                    rcap: "rcap",
                    ch: "ch",
                    rch: "rch",
                    ic: "ic",
                    ric: "ric",
                    lh: "lh",
                    rlh: "rlh",
                    vw: "vw",
                    svw: "svw",
                    lvw: "lvw",
                    dvw: "dvw",
                    vh: "vh",
                    svh: "svh",
                    lvh: "lvh",
                    dvh: "dvh",
                    vi: "vi",
                    svi: "svi",
                    lvi: "lvi",
                    dvi: "dvi",
                    vb: "vb",
                    svb: "svb",
                    lvb: "lvb",
                    dvb: "dvb",
                    vmin: "vmin",
                    svmin: "svmin",
                    lvmin: "lvmin",
                    dvmin: "dvmin",
                    vmax: "vmax",
                    svmax: "svmax",
                    lvmax: "lvmax",
                    dvmax: "dvmax",
                    cm: "cm",
                    mm: "mm",
                    q: "Q",
                    in: "in",
                    pt: "pt",
                    pc: "pc",
                    px: "px",
                    deg: "deg",
                    grad: "grad",
                    rad: "rad",
                    turn: "turn",
                    s: "s",
                    ms: "ms",
                    hz: "Hz",
                    khz: "kHz",
                    dpi: "dpi",
                    dpcm: "dpcm",
                    dppx: "dppx",
                    x: "x"
                };
            }
        }), qd = te({
            "src/language-css/utils/print-unit.js" (e, r) {
                "use strict";
                ne();
                var t = jd();
                function s(a) {
                    let n = a.toLowerCase();
                    return Object.prototype.hasOwnProperty.call(t, n) ? t[n] : a;
                }
                r.exports = s;
            }
        }), Md = te({
            "src/language-css/printer-postcss.js" (e, r) {
                "use strict";
                ne();
                var t = lt(), { printNumber: s, printString: a, hasNewline: n, isFrontMatterNode: u, isNextLineEmpty: i, isNonEmptyArray: l } = Ue(), { builders: { join: p, line: y, hardline: h, softline: g, group: c, fill: f, indent: F, dedent: _, ifBreak: w, breakParent: E }, utils: { removeLines: N, getDocParts: x } } = qe(), I = Nd(), P = wd(), { insertPragma: $ } = _d(), { getAncestorNode: D, getPropOfDeclNode: T, maybeToLowerCase: m, insideValueFunctionNode: C, insideICSSRuleNode: o, insideAtRuleNode: d, insideURLFunctionInImportAtRuleNode: v, isKeyframeAtRuleKeywords: S, isWideKeywords: b, isLastNode: B, isSCSSControlDirectiveNode: k, isDetachedRulesetDeclarationNode: M, isRelationalOperatorNode: R, isEqualityOperatorNode: q, isMultiplicationNode: J, isDivisionNode: L, isAdditionNode: Q, isSubtractionNode: V, isMathOperatorNode: j, isEachKeywordNode: Y, isForKeywordNode: ie, isURLFunctionNode: ee, isIfElseKeywordNode: ce, hasComposesNode: W, hasParensAroundNode: K, hasEmptyRawBefore: de, isKeyValuePairNode: ue, isKeyInValuePairNode: Fe, isDetachedRulesetCallNode: z, isTemplatePlaceholderNode: U, isTemplatePropNode: Z, isPostcssSimpleVarNode: se, isSCSSMapItemNode: fe, isInlineValueCommentNode: ge, isHashNode: he, isLeftCurlyBraceNode: we, isRightCurlyBraceNode: ke, isWordNode: Re, isColonNode: Ne, isMediaAndSupportsKeywords: Pe, isColorAdjusterFuncNode: oe, lastLineHasInlineComment: H, isAtWordPlaceholderNode: pe, isConfigurationNode: X, isParenGroupNode: le } = Pd(), { locStart: Ae, locEnd: Ee } = kd(), De = Ld(), A = Od(), G = qd();
                function re(Te) {
                    return Te.trailingComma === "es5" || Te.trailingComma === "all";
                }
                function ye(Te, je, Me) {
                    let ae = Te.getValue();
                    if (!ae) return "";
                    if (typeof ae == "string") return ae;
                    switch(ae.type){
                        case "front-matter":
                            return [
                                ae.raw,
                                h
                            ];
                        case "css-root":
                            {
                                let Ve = Ce(Te, je, Me), We = ae.raws.after.trim();
                                return We.startsWith(";") && (We = We.slice(1).trim()), [
                                    Ve,
                                    We ? ` ${We}` : "",
                                    x(Ve).length > 0 ? h : ""
                                ];
                            }
                        case "css-comment":
                            {
                                let Ve = ae.inline || ae.raws.inline, We = je.originalText.slice(Ae(ae), Ee(ae));
                                return Ve ? We.trimEnd() : We;
                            }
                        case "css-rule":
                            return [
                                Me("selector"),
                                ae.important ? " !important" : "",
                                ae.nodes ? [
                                    ae.selector && ae.selector.type === "selector-unknown" && H(ae.selector.value) ? y : " ",
                                    "{",
                                    ae.nodes.length > 0 ? F([
                                        h,
                                        Ce(Te, je, Me)
                                    ]) : "",
                                    h,
                                    "}",
                                    M(ae) ? ";" : ""
                                ] : ";"
                            ];
                        case "css-decl":
                            {
                                let Ve = Te.getParentNode(), { between: We } = ae.raws, Xe = We.trim(), st = Xe === ":", O = W(ae) ? N(Me("value")) : Me("value");
                                return !st && H(Xe) && (O = F([
                                    h,
                                    _(O)
                                ])), [
                                    ae.raws.before.replace(/[\s;]/g, ""),
                                    Ve.type === "css-atrule" && Ve.variable || o(Te) ? ae.prop : m(ae.prop),
                                    Xe.startsWith("//") ? " " : "",
                                    Xe,
                                    ae.extend ? "" : " ",
                                    De(je) && ae.extend && ae.selector ? [
                                        "extend(",
                                        Me("selector"),
                                        ")"
                                    ] : "",
                                    O,
                                    ae.raws.important ? ae.raws.important.replace(/\s*!\s*important/i, " !important") : ae.important ? " !important" : "",
                                    ae.raws.scssDefault ? ae.raws.scssDefault.replace(/\s*!default/i, " !default") : ae.scssDefault ? " !default" : "",
                                    ae.raws.scssGlobal ? ae.raws.scssGlobal.replace(/\s*!global/i, " !global") : ae.scssGlobal ? " !global" : "",
                                    ae.nodes ? [
                                        " {",
                                        F([
                                            g,
                                            Ce(Te, je, Me)
                                        ]),
                                        g,
                                        "}"
                                    ] : Z(ae) && !Ve.raws.semicolon && je.originalText[Ee(ae) - 1] !== ";" ? "" : je.__isHTMLStyleAttribute && B(Te, ae) ? w(";") : ";"
                                ];
                            }
                        case "css-atrule":
                            {
                                let Ve = Te.getParentNode(), We = U(ae) && !Ve.raws.semicolon && je.originalText[Ee(ae) - 1] !== ";";
                                if (De(je)) {
                                    if (ae.mixin) return [
                                        Me("selector"),
                                        ae.important ? " !important" : "",
                                        We ? "" : ";"
                                    ];
                                    if (ae.function) return [
                                        ae.name,
                                        Me("params"),
                                        We ? "" : ";"
                                    ];
                                    if (ae.variable) return [
                                        "@",
                                        ae.name,
                                        ": ",
                                        ae.value ? Me("value") : "",
                                        ae.raws.between.trim() ? ae.raws.between.trim() + " " : "",
                                        ae.nodes ? [
                                            "{",
                                            F([
                                                ae.nodes.length > 0 ? g : "",
                                                Ce(Te, je, Me)
                                            ]),
                                            g,
                                            "}"
                                        ] : "",
                                        We ? "" : ";"
                                    ];
                                }
                                return [
                                    "@",
                                    z(ae) || ae.name.endsWith(":") ? ae.name : m(ae.name),
                                    ae.params ? [
                                        z(ae) ? "" : U(ae) ? ae.raws.afterName === "" ? "" : ae.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(ae.raws.afterName) ? [
                                            h,
                                            h
                                        ] : /^\s*\n/.test(ae.raws.afterName) ? h : " " : " ",
                                        Me("params")
                                    ] : "",
                                    ae.selector ? F([
                                        " ",
                                        Me("selector")
                                    ]) : "",
                                    ae.value ? c([
                                        " ",
                                        Me("value"),
                                        k(ae) ? K(ae) ? " " : y : ""
                                    ]) : ae.name === "else" ? " " : "",
                                    ae.nodes ? [
                                        k(ae) ? "" : ae.selector && !ae.selector.nodes && typeof ae.selector.value == "string" && H(ae.selector.value) || !ae.selector && typeof ae.params == "string" && H(ae.params) ? y : " ",
                                        "{",
                                        F([
                                            ae.nodes.length > 0 ? g : "",
                                            Ce(Te, je, Me)
                                        ]),
                                        g,
                                        "}"
                                    ] : We ? "" : ";"
                                ];
                            }
                        case "media-query-list":
                            {
                                let Ve = [];
                                return Te.each((We)=>{
                                    let Xe = We.getValue();
                                    Xe.type === "media-query" && Xe.value === "" || Ve.push(Me());
                                }, "nodes"), c(F(p(y, Ve)));
                            }
                        case "media-query":
                            return [
                                p(" ", Te.map(Me, "nodes")),
                                B(Te, ae) ? "" : ","
                            ];
                        case "media-type":
                            return Oe(Se(ae.value, je));
                        case "media-feature-expression":
                            return ae.nodes ? [
                                "(",
                                ...Te.map(Me, "nodes"),
                                ")"
                            ] : ae.value;
                        case "media-feature":
                            return m(Se(ae.value.replace(/ +/g, " "), je));
                        case "media-colon":
                            return [
                                ae.value,
                                " "
                            ];
                        case "media-value":
                            return Oe(Se(ae.value, je));
                        case "media-keyword":
                            return Se(ae.value, je);
                        case "media-url":
                            return Se(ae.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), je);
                        case "media-unknown":
                            return ae.value;
                        case "selector-root":
                            return c([
                                d(Te, "custom-selector") ? [
                                    D(Te, "css-atrule").customSelector,
                                    y
                                ] : "",
                                p([
                                    ",",
                                    d(Te, [
                                        "extend",
                                        "custom-selector",
                                        "nest"
                                    ]) ? y : h
                                ], Te.map(Me, "nodes"))
                            ]);
                        case "selector-selector":
                            return c(F(Te.map(Me, "nodes")));
                        case "selector-comment":
                            return ae.value;
                        case "selector-string":
                            return Se(ae.value, je);
                        case "selector-tag":
                            {
                                let Ve = Te.getParentNode(), We = Ve && Ve.nodes.indexOf(ae), Xe = We && Ve.nodes[We - 1];
                                return [
                                    ae.namespace ? [
                                        ae.namespace === !0 ? "" : ae.namespace.trim(),
                                        "|"
                                    ] : "",
                                    Xe.type === "selector-nesting" ? ae.value : Oe(S(Te, ae.value) ? ae.value.toLowerCase() : ae.value)
                                ];
                            }
                        case "selector-id":
                            return [
                                "#",
                                ae.value
                            ];
                        case "selector-class":
                            return [
                                ".",
                                Oe(Se(ae.value, je))
                            ];
                        case "selector-attribute":
                            var nt;
                            return [
                                "[",
                                ae.namespace ? [
                                    ae.namespace === !0 ? "" : ae.namespace.trim(),
                                    "|"
                                ] : "",
                                ae.attribute.trim(),
                                (nt = ae.operator) !== null && nt !== void 0 ? nt : "",
                                ae.value ? Ie(Se(ae.value.trim(), je), je) : "",
                                ae.insensitive ? " i" : "",
                                "]"
                            ];
                        case "selector-combinator":
                            {
                                if (ae.value === "+" || ae.value === ">" || ae.value === "~" || ae.value === ">>>") {
                                    let Xe = Te.getParentNode();
                                    return [
                                        Xe.type === "selector-selector" && Xe.nodes[0] === ae ? "" : y,
                                        ae.value,
                                        B(Te, ae) ? "" : " "
                                    ];
                                }
                                let Ve = ae.value.trim().startsWith("(") ? y : "", We = Oe(Se(ae.value.trim(), je)) || y;
                                return [
                                    Ve,
                                    We
                                ];
                            }
                        case "selector-universal":
                            return [
                                ae.namespace ? [
                                    ae.namespace === !0 ? "" : ae.namespace.trim(),
                                    "|"
                                ] : "",
                                ae.value
                            ];
                        case "selector-pseudo":
                            return [
                                m(ae.value),
                                l(ae.nodes) ? c([
                                    "(",
                                    F([
                                        g,
                                        p([
                                            ",",
                                            y
                                        ], Te.map(Me, "nodes"))
                                    ]),
                                    g,
                                    ")"
                                ]) : ""
                            ];
                        case "selector-nesting":
                            return ae.value;
                        case "selector-unknown":
                            {
                                let Ve = D(Te, "css-rule");
                                if (Ve && Ve.isSCSSNesterProperty) return Oe(Se(m(ae.value), je));
                                let We = Te.getParentNode();
                                if (We.raws && We.raws.selector) {
                                    let st = Ae(We), O = st + We.raws.selector.length;
                                    return je.originalText.slice(st, O).trim();
                                }
                                let Xe = Te.getParentNode(1);
                                if (We.type === "value-paren_group" && Xe && Xe.type === "value-func" && Xe.value === "selector") {
                                    let st = Ee(We.open) + 1, O = Ae(We.close), me = je.originalText.slice(st, O).trim();
                                    return H(me) ? [
                                        E,
                                        me
                                    ] : me;
                                }
                                return ae.value;
                            }
                        case "value-value":
                        case "value-root":
                            return Me("group");
                        case "value-comment":
                            return je.originalText.slice(Ae(ae), Ee(ae));
                        case "value-comma_group":
                            {
                                let Ve = Te.getParentNode(), We = Te.getParentNode(1), Xe = T(Te), st = Xe && Ve.type === "value-value" && (Xe === "grid" || Xe.startsWith("grid-template")), O = D(Te, "css-atrule"), me = O && k(O), _e = ae.groups.some((at)=>ge(at)), He = Te.map(Me, "groups"), Ge = [], it = C(Te, "url"), Qe = !1, rt = !1;
                                for(let at = 0; at < ae.groups.length; ++at){
                                    var tt;
                                    Ge.push(He[at]);
                                    let Ze = ae.groups[at - 1], Le = ae.groups[at], $e = ae.groups[at + 1], sr = ae.groups[at + 2];
                                    if (it) {
                                        ($e && Q($e) || Q(Le)) && Ge.push(" ");
                                        continue;
                                    }
                                    if (d(Te, "forward") && Le.type === "value-word" && Le.value && Ze !== void 0 && Ze.type === "value-word" && Ze.value === "as" && $e.type === "value-operator" && $e.value === "*" || !$e || Le.type === "value-word" && Le.value.endsWith("-") && pe($e)) continue;
                                    if (Le.type === "value-string" && Le.quoted) {
                                        let $r = Le.value.lastIndexOf("#{"), Vr = Le.value.lastIndexOf("}");
                                        $r !== -1 && Vr !== -1 ? Qe = $r > Vr : $r !== -1 ? Qe = !0 : Vr !== -1 && (Qe = !1);
                                    }
                                    if (Qe || Ne(Le) || Ne($e) || Le.type === "value-atword" && (Le.value === "" || Le.value.endsWith("[")) || $e.type === "value-word" && $e.value.startsWith("]") || Le.value === "~" || Le.value && Le.value.includes("\\") && $e && $e.type !== "value-comment" || Ze && Ze.value && Ze.value.indexOf("\\") === Ze.value.length - 1 && Le.type === "value-operator" && Le.value === "/" || Le.value === "\\" || se(Le, $e) || he(Le) || we(Le) || ke($e) || we($e) && de($e) || ke(Le) && de($e) || Le.value === "--" && he($e)) continue;
                                    let Rr = j(Le), ou = j($e);
                                    if ((Rr && he($e) || ou && ke(Le)) && de($e) || !Ze && L(Le) || C(Te, "calc") && (Q(Le) || Q($e) || V(Le) || V($e)) && de($e)) continue;
                                    let qo = (Q(Le) || V(Le)) && at === 0 && ($e.type === "value-number" || $e.isHex) && We && oe(We) && !de($e), lu = sr && sr.type === "value-func" || sr && Re(sr) || Le.type === "value-func" || Re(Le), cu = $e.type === "value-func" || Re($e) || Ze && Ze.type === "value-func" || Ze && Re(Ze);
                                    if (!(!(J($e) || J(Le)) && !C(Te, "calc") && !qo && (L($e) && !lu || L(Le) && !cu || Q($e) && !lu || Q(Le) && !cu || V($e) || V(Le)) && (de($e) || Rr && (!Ze || Ze && j(Ze)))) && !((je.parser === "scss" || je.parser === "less") && Rr && Le.value === "-" && le($e) && Ee(Le) === Ae($e.open) && $e.open.value === "(")) {
                                        if (ge(Le)) {
                                            if (Ve.type === "value-paren_group") {
                                                Ge.push(_(h));
                                                continue;
                                            }
                                            Ge.push(h);
                                            continue;
                                        }
                                        if (me && (q($e) || R($e) || ce($e) || Y(Le) || ie(Le))) {
                                            Ge.push(" ");
                                            continue;
                                        }
                                        if (O && O.name.toLowerCase() === "namespace") {
                                            Ge.push(" ");
                                            continue;
                                        }
                                        if (st) {
                                            Le.source && $e.source && Le.source.start.line !== $e.source.start.line ? (Ge.push(h), rt = !0) : Ge.push(" ");
                                            continue;
                                        }
                                        if (ou) {
                                            Ge.push(" ");
                                            continue;
                                        }
                                        if (!($e && $e.value === "...") && !(pe(Le) && pe($e) && Ee(Le) === Ae($e))) {
                                            if (pe(Le) && le($e) && Ee(Le) === Ae($e.open)) {
                                                Ge.push(g);
                                                continue;
                                            }
                                            if (Le.value === "with" && le($e)) {
                                                Ge.push(" ");
                                                continue;
                                            }
                                            (tt = Le.value) !== null && tt !== void 0 && tt.endsWith("#") && $e.value === "{" && le($e.group) || Ge.push(y);
                                        }
                                    }
                                }
                                return _e && Ge.push(E), rt && Ge.unshift(h), me ? c(F(Ge)) : v(Te) ? c(f(Ge)) : c(F(f(Ge)));
                            }
                        case "value-paren_group":
                            {
                                let Ve = Te.getParentNode();
                                if (Ve && ee(Ve) && (ae.groups.length === 1 || ae.groups.length > 0 && ae.groups[0].type === "value-comma_group" && ae.groups[0].groups.length > 0 && ae.groups[0].groups[0].type === "value-word" && ae.groups[0].groups[0].value.startsWith("data:"))) return [
                                    ae.open ? Me("open") : "",
                                    p(",", Te.map(Me, "groups")),
                                    ae.close ? Me("close") : ""
                                ];
                                if (!ae.open) {
                                    let it = Te.map(Me, "groups"), Qe = [];
                                    for(let rt = 0; rt < it.length; rt++)rt !== 0 && Qe.push([
                                        ",",
                                        y
                                    ]), Qe.push(it[rt]);
                                    return c(F(f(Qe)));
                                }
                                let We = fe(Te), Xe = t(ae.groups), st = Xe && Xe.type === "value-comment", O = Fe(ae, Ve), me = X(ae, Ve), _e = me || We && !O, He = me || O, Ge = c([
                                    ae.open ? Me("open") : "",
                                    F([
                                        g,
                                        p([
                                            y
                                        ], Te.map((it, Qe)=>{
                                            let rt = it.getValue(), at = Qe === ae.groups.length - 1, Ze = [
                                                Me(),
                                                at ? "" : ","
                                            ];
                                            if (ue(rt) && rt.type === "value-comma_group" && rt.groups && rt.groups[0].type !== "value-paren_group" && rt.groups[2] && rt.groups[2].type === "value-paren_group") {
                                                let Le = x(Ze[0].contents.contents);
                                                Le[1] = c(Le[1]), Ze = [
                                                    c(_(Ze))
                                                ];
                                            }
                                            if (!at && rt.type === "value-comma_group" && l(rt.groups)) {
                                                let Le = t(rt.groups);
                                                !Le.source && Le.close && (Le = Le.close), Le.source && i(je.originalText, Le, Ee) && Ze.push(h);
                                            }
                                            return Ze;
                                        }, "groups"))
                                    ]),
                                    w(!st && A(je.parser, je.originalText) && We && re(je) ? "," : ""),
                                    g,
                                    ae.close ? Me("close") : ""
                                ], {
                                    shouldBreak: _e
                                });
                                return He ? _(Ge) : Ge;
                            }
                        case "value-func":
                            return [
                                ae.value,
                                d(Te, "supports") && Pe(ae) ? " " : "",
                                Me("group")
                            ];
                        case "value-paren":
                            return ae.value;
                        case "value-number":
                            return [
                                Je(ae.value),
                                G(ae.unit)
                            ];
                        case "value-operator":
                            return ae.value;
                        case "value-word":
                            return ae.isColor && ae.isHex || b(ae.value) ? ae.value.toLowerCase() : ae.value;
                        case "value-colon":
                            {
                                let Ve = Te.getParentNode(), We = Ve && Ve.groups.indexOf(ae), Xe = We && Ve.groups[We - 1];
                                return [
                                    ae.value,
                                    Xe && typeof Xe.value == "string" && t(Xe.value) === "\\" || C(Te, "url") ? "" : y
                                ];
                            }
                        case "value-comma":
                            return [
                                ae.value,
                                " "
                            ];
                        case "value-string":
                            return a(ae.raws.quote + ae.value + ae.raws.quote, je);
                        case "value-atword":
                            return [
                                "@",
                                ae.value
                            ];
                        case "value-unicode-range":
                            return ae.value;
                        case "value-unknown":
                            return ae.value;
                        default:
                            throw new Error(`Unknown postcss type ${JSON.stringify(ae.type)}`);
                    }
                }
                function Ce(Te, je, Me) {
                    let ae = [];
                    return Te.each((nt, tt, Ve)=>{
                        let We = Ve[tt - 1];
                        if (We && We.type === "css-comment" && We.text.trim() === "prettier-ignore") {
                            let Xe = nt.getValue();
                            ae.push(je.originalText.slice(Ae(Xe), Ee(Xe)));
                        } else ae.push(Me());
                        tt !== Ve.length - 1 && (Ve[tt + 1].type === "css-comment" && !n(je.originalText, Ae(Ve[tt + 1]), {
                            backwards: !0
                        }) && !u(Ve[tt]) || Ve[tt + 1].type === "css-atrule" && Ve[tt + 1].name === "else" && Ve[tt].type !== "css-comment" ? ae.push(" ") : (ae.push(je.__isHTMLStyleAttribute ? y : h), i(je.originalText, nt.getValue(), Ee) && !u(Ve[tt]) && ae.push(h)));
                    }, "nodes"), ae;
                }
                var Be = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, ve = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, ze = /[A-Za-z]+/g, be = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, Ye = new RegExp(Be.source + `|(${be.source})?(${ve.source})(${ze.source})?`, "g");
                function Se(Te, je) {
                    return Te.replace(Be, (Me)=>a(Me, je));
                }
                function Ie(Te, je) {
                    let Me = je.singleQuote ? "'" : '"';
                    return Te.includes('"') || Te.includes("'") ? Te : Me + Te + Me;
                }
                function Oe(Te) {
                    return Te.replace(Ye, (je, Me, ae, nt, tt)=>!ae && nt ? Je(nt) + m(tt || "") : je);
                }
                function Je(Te) {
                    return s(Te).replace(/\.0(?=$|e)/, "");
                }
                r.exports = {
                    print: ye,
                    embed: P,
                    insertPragma: $,
                    massageAstNode: I
                };
            }
        }), Rd = te({
            "src/language-css/options.js" (e, r) {
                "use strict";
                ne();
                var t = Mt();
                r.exports = {
                    singleQuote: t.singleQuote
                };
            }
        }), $d = te({
            "src/language-css/parsers.js" () {
                ne();
            }
        }), Vd = te({
            "node_modules/linguist-languages/data/CSS.json" (e, r) {
                r.exports = {
                    name: "CSS",
                    type: "markup",
                    tmScope: "source.css",
                    aceMode: "css",
                    codemirrorMode: "css",
                    codemirrorMimeType: "text/css",
                    color: "#563d7c",
                    extensions: [
                        ".css"
                    ],
                    languageId: 50
                };
            }
        }), Wd = te({
            "node_modules/linguist-languages/data/PostCSS.json" (e, r) {
                r.exports = {
                    name: "PostCSS",
                    type: "markup",
                    color: "#dc3a0c",
                    tmScope: "source.postcss",
                    group: "CSS",
                    extensions: [
                        ".pcss",
                        ".postcss"
                    ],
                    aceMode: "text",
                    languageId: 262764437
                };
            }
        }), Hd = te({
            "node_modules/linguist-languages/data/Less.json" (e, r) {
                r.exports = {
                    name: "Less",
                    type: "markup",
                    color: "#1d365d",
                    aliases: [
                        "less-css"
                    ],
                    extensions: [
                        ".less"
                    ],
                    tmScope: "source.css.less",
                    aceMode: "less",
                    codemirrorMode: "css",
                    codemirrorMimeType: "text/css",
                    languageId: 198
                };
            }
        }), Gd = te({
            "node_modules/linguist-languages/data/SCSS.json" (e, r) {
                r.exports = {
                    name: "SCSS",
                    type: "markup",
                    color: "#c6538c",
                    tmScope: "source.css.scss",
                    aceMode: "scss",
                    codemirrorMode: "css",
                    codemirrorMimeType: "text/x-scss",
                    extensions: [
                        ".scss"
                    ],
                    languageId: 329
                };
            }
        }), Ud = te({
            "src/language-css/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = Md(), a = Rd(), n = $d(), u = [
                    t(Vd(), (l)=>({
                            since: "1.4.0",
                            parsers: [
                                "css"
                            ],
                            vscodeLanguageIds: [
                                "css"
                            ],
                            extensions: [
                                ...l.extensions,
                                ".wxss"
                            ]
                        })),
                    t(Wd(), ()=>({
                            since: "1.4.0",
                            parsers: [
                                "css"
                            ],
                            vscodeLanguageIds: [
                                "postcss"
                            ]
                        })),
                    t(Hd(), ()=>({
                            since: "1.4.0",
                            parsers: [
                                "less"
                            ],
                            vscodeLanguageIds: [
                                "less"
                            ]
                        })),
                    t(Gd(), ()=>({
                            since: "1.4.0",
                            parsers: [
                                "scss"
                            ],
                            vscodeLanguageIds: [
                                "scss"
                            ]
                        }))
                ], i = {
                    postcss: s
                };
                r.exports = {
                    languages: u,
                    options: a,
                    printers: i,
                    parsers: n
                };
            }
        }), Jd = te({
            "src/language-handlebars/loc.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return a.loc.start.offset;
                }
                function s(a) {
                    return a.loc.end.offset;
                }
                r.exports = {
                    locStart: t,
                    locEnd: s
                };
            }
        }), zd = te({
            "src/language-handlebars/clean.js" (e, r) {
                "use strict";
                ne();
                function t(s, a) {
                    if (s.type === "TextNode") {
                        let n = s.chars.trim();
                        if (!n) return null;
                        a.chars = n.replace(/[\t\n\f\r ]+/g, " ");
                    }
                    s.type === "AttrNode" && s.name.toLowerCase() === "class" && delete a.value;
                }
                t.ignoredProperties = new Set([
                    "loc",
                    "selfClosing"
                ]), r.exports = t;
            }
        }), Xd = te({
            "src/language-handlebars/html-void-elements.evaluate.js" (e, r) {
                r.exports = [
                    "area",
                    "base",
                    "br",
                    "col",
                    "command",
                    "embed",
                    "hr",
                    "img",
                    "input",
                    "keygen",
                    "link",
                    "meta",
                    "param",
                    "source",
                    "track",
                    "wbr"
                ];
            }
        }), Kd = te({
            "src/language-handlebars/utils.js" (e, r) {
                "use strict";
                ne();
                var t = lt(), s = Xd();
                function a(x) {
                    let I = x.getValue(), P = x.getParentNode(0);
                    return !!(g(x, [
                        "ElementNode"
                    ]) && t(P.children) === I || g(x, [
                        "Block"
                    ]) && t(P.body) === I);
                }
                function n(x) {
                    return x.toUpperCase() === x;
                }
                function u(x) {
                    return h(x, [
                        "ElementNode"
                    ]) && typeof x.tag == "string" && !x.tag.startsWith(":") && (n(x.tag[0]) || x.tag.includes("."));
                }
                var i = new Set(s);
                function l(x) {
                    return i.has(x.toLowerCase()) && !n(x[0]);
                }
                function p(x) {
                    return x.selfClosing === !0 || l(x.tag) || u(x) && x.children.every((I)=>y(I));
                }
                function y(x) {
                    return h(x, [
                        "TextNode"
                    ]) && !/\S/.test(x.chars);
                }
                function h(x, I) {
                    return x && I.includes(x.type);
                }
                function g(x, I) {
                    let P = x.getParentNode(0);
                    return h(P, I);
                }
                function c(x, I) {
                    let P = _(x);
                    return h(P, I);
                }
                function f(x, I) {
                    let P = w(x);
                    return h(P, I);
                }
                function F(x, I) {
                    var P, $, D, T;
                    let m = x.getValue(), C = (P = x.getParentNode(0)) !== null && P !== void 0 ? P : {}, o = ($ = (D = (T = C.children) !== null && T !== void 0 ? T : C.body) !== null && D !== void 0 ? D : C.parts) !== null && $ !== void 0 ? $ : [], d = o.indexOf(m);
                    return d !== -1 && o[d + I];
                }
                function _(x) {
                    let I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
                    return F(x, -I);
                }
                function w(x) {
                    return F(x, 1);
                }
                function E(x) {
                    return h(x, [
                        "MustacheCommentStatement"
                    ]) && typeof x.value == "string" && x.value.trim() === "prettier-ignore";
                }
                function N(x) {
                    let I = x.getValue(), P = _(x, 2);
                    return E(I) || E(P);
                }
                r.exports = {
                    getNextNode: w,
                    getPreviousNode: _,
                    hasPrettierIgnore: N,
                    isLastNodeOfSiblings: a,
                    isNextNodeOfSomeType: f,
                    isNodeOfSomeType: h,
                    isParentOfSomeType: g,
                    isPreviousNodeOfSomeType: c,
                    isVoid: p,
                    isWhitespaceNode: y
                };
            }
        }), Yd = te({
            "src/language-handlebars/printer-glimmer.js" (e, r) {
                "use strict";
                ne();
                var { builders: { dedent: t, fill: s, group: a, hardline: n, ifBreak: u, indent: i, join: l, line: p, softline: y }, utils: { getDocParts: h, replaceTextEndOfLine: g } } = qe(), { getPreferredQuote: c, isNonEmptyArray: f } = Ue(), { locStart: F, locEnd: _ } = Jd(), w = zd(), { getNextNode: E, getPreviousNode: N, hasPrettierIgnore: x, isLastNodeOfSiblings: I, isNextNodeOfSomeType: P, isNodeOfSomeType: $, isParentOfSomeType: D, isPreviousNodeOfSomeType: T, isVoid: m, isWhitespaceNode: C } = Kd(), o = 2;
                function d(H, pe, X) {
                    let le = H.getValue();
                    if (!le) return "";
                    if (x(H)) return pe.originalText.slice(F(le), _(le));
                    let Ae = pe.singleQuote ? "'" : '"';
                    switch(le.type){
                        case "Block":
                        case "Program":
                        case "Template":
                            return a(H.map(X, "body"));
                        case "ElementNode":
                            {
                                let Ee = a(S(H, X)), De = pe.htmlWhitespaceSensitivity === "ignore" && P(H, [
                                    "ElementNode"
                                ]) ? y : "";
                                if (m(le)) return [
                                    Ee,
                                    De
                                ];
                                let A = [
                                    "</",
                                    le.tag,
                                    ">"
                                ];
                                return le.children.length === 0 ? [
                                    Ee,
                                    i(A),
                                    De
                                ] : pe.htmlWhitespaceSensitivity === "ignore" ? [
                                    Ee,
                                    i(b(H, pe, X)),
                                    n,
                                    i(A),
                                    De
                                ] : [
                                    Ee,
                                    i(a(b(H, pe, X))),
                                    i(A),
                                    De
                                ];
                            }
                        case "BlockStatement":
                            {
                                let Ee = H.getParentNode(1);
                                return Ee && Ee.inverse && Ee.inverse.body.length === 1 && Ee.inverse.body[0] === le && Ee.inverse.body[0].path.parts[0] === Ee.path.parts[0] ? [
                                    ie(H, X, Ee.inverse.body[0].path.parts[0]),
                                    de(H, X, pe),
                                    ue(H, X, pe)
                                ] : [
                                    j(H, X),
                                    a([
                                        de(H, X, pe),
                                        ue(H, X, pe),
                                        ee(H, X, pe)
                                    ])
                                ];
                            }
                        case "ElementModifierStatement":
                            return a([
                                "{{",
                                Re(H, X),
                                "}}"
                            ]);
                        case "MustacheStatement":
                            return a([
                                k(le),
                                Re(H, X),
                                M(le)
                            ]);
                        case "SubExpression":
                            return a([
                                "(",
                                ke(H, X),
                                y,
                                ")"
                            ]);
                        case "AttrNode":
                            {
                                let Ee = le.value.type === "TextNode";
                                if (Ee && le.value.chars === "" && F(le.value) === _(le.value)) return le.name;
                                let A = Ee ? c(le.value.chars, Ae).quote : le.value.type === "ConcatStatement" ? c(le.value.parts.filter((re)=>re.type === "TextNode").map((re)=>re.chars).join(""), Ae).quote : "", G = X("value");
                                return [
                                    le.name,
                                    "=",
                                    A,
                                    le.name === "class" && A ? a(i(G)) : G,
                                    A
                                ];
                            }
                        case "ConcatStatement":
                            return H.map(X, "parts");
                        case "Hash":
                            return l(p, H.map(X, "pairs"));
                        case "HashPair":
                            return [
                                le.key,
                                "=",
                                X("value")
                            ];
                        case "TextNode":
                            {
                                let Ee = le.chars.replace(/{{/g, "\\{{"), De = U(H);
                                if (De) {
                                    if (De === "class") {
                                        let Ye = Ee.trim().split(/\s+/).join(" "), Se = !1, Ie = !1;
                                        return D(H, [
                                            "ConcatStatement"
                                        ]) && (T(H, [
                                            "MustacheStatement"
                                        ]) && /^\s/.test(Ee) && (Se = !0), P(H, [
                                            "MustacheStatement"
                                        ]) && /\s$/.test(Ee) && Ye !== "" && (Ie = !0)), [
                                            Se ? p : "",
                                            Ye,
                                            Ie ? p : ""
                                        ];
                                    }
                                    return g(Ee);
                                }
                                let G = /^[\t\n\f\r ]*$/.test(Ee), re = !N(H), ye = !E(H);
                                if (pe.htmlWhitespaceSensitivity !== "ignore") {
                                    let Ye = /^[\t\n\f\r ]*/, Se = /[\t\n\f\r ]*$/, Ie = ye && D(H, [
                                        "Template"
                                    ]), Oe = re && D(H, [
                                        "Template"
                                    ]);
                                    if (G) {
                                        if (Oe || Ie) return "";
                                        let ae = [
                                            p
                                        ], nt = Z(Ee);
                                        return nt && (ae = ge(nt)), I(H) && (ae = ae.map((tt)=>t(tt))), ae;
                                    }
                                    let [Je] = Ee.match(Ye), [Te] = Ee.match(Se), je = [];
                                    if (Je) {
                                        je = [
                                            p
                                        ];
                                        let ae = Z(Je);
                                        ae && (je = ge(ae)), Ee = Ee.replace(Ye, "");
                                    }
                                    let Me = [];
                                    if (Te) {
                                        if (!Ie) {
                                            Me = [
                                                p
                                            ];
                                            let ae = Z(Te);
                                            ae && (Me = ge(ae)), I(H) && (Me = Me.map((nt)=>t(nt)));
                                        }
                                        Ee = Ee.replace(Se, "");
                                    }
                                    return [
                                        ...je,
                                        s(Fe(Ee)),
                                        ...Me
                                    ];
                                }
                                let Ce = Z(Ee), Be = se(Ee), ve = fe(Ee);
                                if ((re || ye) && G && D(H, [
                                    "Block",
                                    "ElementNode",
                                    "Template"
                                ])) return "";
                                G && Ce ? (Be = Math.min(Ce, o), ve = 0) : (P(H, [
                                    "BlockStatement",
                                    "ElementNode"
                                ]) && (ve = Math.max(ve, 1)), T(H, [
                                    "BlockStatement",
                                    "ElementNode"
                                ]) && (Be = Math.max(Be, 1)));
                                let ze = "", be = "";
                                return ve === 0 && P(H, [
                                    "MustacheStatement"
                                ]) && (be = " "), Be === 0 && T(H, [
                                    "MustacheStatement"
                                ]) && (ze = " "), re && (Be = 0, ze = ""), ye && (ve = 0, be = ""), Ee = Ee.replace(/^[\t\n\f\r ]+/g, ze).replace(/[\t\n\f\r ]+$/, be), [
                                    ...ge(Be),
                                    s(Fe(Ee)),
                                    ...ge(ve)
                                ];
                            }
                        case "MustacheCommentStatement":
                            {
                                let Ee = F(le), De = _(le), A = pe.originalText.charAt(Ee + 2) === "~", G = pe.originalText.charAt(De - 3) === "~", re = le.value.includes("}}") ? "--" : "";
                                return [
                                    "{{",
                                    A ? "~" : "",
                                    "!",
                                    re,
                                    le.value,
                                    re,
                                    G ? "~" : "",
                                    "}}"
                                ];
                            }
                        case "PathExpression":
                            return le.original;
                        case "BooleanLiteral":
                            return String(le.value);
                        case "CommentStatement":
                            return [
                                "<!--",
                                le.value,
                                "-->"
                            ];
                        case "StringLiteral":
                            if (we(H)) {
                                let Ee = pe.singleQuote ? '"' : "'";
                                return he(le.value, Ee);
                            }
                            return he(le.value, Ae);
                        case "NumberLiteral":
                            return String(le.value);
                        case "UndefinedLiteral":
                            return "undefined";
                        case "NullLiteral":
                            return "null";
                        default:
                            throw new Error("unknown glimmer type: " + JSON.stringify(le.type));
                    }
                }
                function v(H, pe) {
                    return F(H) - F(pe);
                }
                function S(H, pe) {
                    let X = H.getValue(), le = [
                        "attributes",
                        "modifiers",
                        "comments"
                    ].filter((Ee)=>f(X[Ee])), Ae = le.flatMap((Ee)=>X[Ee]).sort(v);
                    for (let Ee of le)H.each((De)=>{
                        let A = Ae.indexOf(De.getValue());
                        Ae.splice(A, 1, [
                            p,
                            pe()
                        ]);
                    }, Ee);
                    return f(X.blockParams) && Ae.push(p, oe(X)), [
                        "<",
                        X.tag,
                        i(Ae),
                        B(X)
                    ];
                }
                function b(H, pe, X) {
                    let Ae = H.getValue().children.every((Ee)=>C(Ee));
                    return pe.htmlWhitespaceSensitivity === "ignore" && Ae ? "" : H.map((Ee, De)=>{
                        let A = X();
                        return De === 0 && pe.htmlWhitespaceSensitivity === "ignore" ? [
                            y,
                            A
                        ] : A;
                    }, "children");
                }
                function B(H) {
                    return m(H) ? u([
                        y,
                        "/>"
                    ], [
                        " />",
                        y
                    ]) : u([
                        y,
                        ">"
                    ], ">");
                }
                function k(H) {
                    let pe = H.escaped === !1 ? "{{{" : "{{", X = H.strip && H.strip.open ? "~" : "";
                    return [
                        pe,
                        X
                    ];
                }
                function M(H) {
                    let pe = H.escaped === !1 ? "}}}" : "}}";
                    return [
                        H.strip && H.strip.close ? "~" : "",
                        pe
                    ];
                }
                function R(H) {
                    let pe = k(H), X = H.openStrip.open ? "~" : "";
                    return [
                        pe,
                        X,
                        "#"
                    ];
                }
                function q(H) {
                    let pe = M(H);
                    return [
                        H.openStrip.close ? "~" : "",
                        pe
                    ];
                }
                function J(H) {
                    let pe = k(H), X = H.closeStrip.open ? "~" : "";
                    return [
                        pe,
                        X,
                        "/"
                    ];
                }
                function L(H) {
                    let pe = M(H);
                    return [
                        H.closeStrip.close ? "~" : "",
                        pe
                    ];
                }
                function Q(H) {
                    let pe = k(H), X = H.inverseStrip.open ? "~" : "";
                    return [
                        pe,
                        X
                    ];
                }
                function V(H) {
                    let pe = M(H);
                    return [
                        H.inverseStrip.close ? "~" : "",
                        pe
                    ];
                }
                function j(H, pe) {
                    let X = H.getValue(), le = [], Ae = Pe(H, pe);
                    return Ae && le.push(a(Ae)), f(X.program.blockParams) && le.push(oe(X.program)), a([
                        R(X),
                        Ne(H, pe),
                        le.length > 0 ? i([
                            p,
                            l(p, le)
                        ]) : "",
                        y,
                        q(X)
                    ]);
                }
                function Y(H, pe) {
                    return [
                        pe.htmlWhitespaceSensitivity === "ignore" ? n : "",
                        Q(H),
                        "else",
                        V(H)
                    ];
                }
                function ie(H, pe, X) {
                    let le = H.getValue(), Ae = H.getParentNode(1);
                    return a([
                        Q(Ae),
                        [
                            "else",
                            " ",
                            X
                        ],
                        i([
                            p,
                            a(Pe(H, pe)),
                            ...f(le.program.blockParams) ? [
                                p,
                                oe(le.program)
                            ] : []
                        ]),
                        y,
                        V(Ae)
                    ]);
                }
                function ee(H, pe, X) {
                    let le = H.getValue();
                    return X.htmlWhitespaceSensitivity === "ignore" ? [
                        ce(le) ? y : n,
                        J(le),
                        pe("path"),
                        L(le)
                    ] : [
                        J(le),
                        pe("path"),
                        L(le)
                    ];
                }
                function ce(H) {
                    return $(H, [
                        "BlockStatement"
                    ]) && H.program.body.every((pe)=>C(pe));
                }
                function W(H) {
                    return K(H) && H.inverse.body.length === 1 && $(H.inverse.body[0], [
                        "BlockStatement"
                    ]) && H.inverse.body[0].path.parts[0] === H.path.parts[0];
                }
                function K(H) {
                    return $(H, [
                        "BlockStatement"
                    ]) && H.inverse;
                }
                function de(H, pe, X) {
                    let le = H.getValue();
                    if (ce(le)) return "";
                    let Ae = pe("program");
                    return X.htmlWhitespaceSensitivity === "ignore" ? i([
                        n,
                        Ae
                    ]) : i(Ae);
                }
                function ue(H, pe, X) {
                    let le = H.getValue(), Ae = pe("inverse"), Ee = X.htmlWhitespaceSensitivity === "ignore" ? [
                        n,
                        Ae
                    ] : Ae;
                    return W(le) ? Ee : K(le) ? [
                        Y(le, X),
                        i(Ee)
                    ] : "";
                }
                function Fe(H) {
                    return h(l(p, z(H)));
                }
                function z(H) {
                    return H.split(/[\t\n\f\r ]+/);
                }
                function U(H) {
                    for(let pe = 0; pe < 2; pe++){
                        let X = H.getParentNode(pe);
                        if (X && X.type === "AttrNode") return X.name.toLowerCase();
                    }
                }
                function Z(H) {
                    return H = typeof H == "string" ? H : "", H.split(`
`).length - 1;
                }
                function se(H) {
                    H = typeof H == "string" ? H : "";
                    let pe = (H.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
                    return Z(pe);
                }
                function fe(H) {
                    H = typeof H == "string" ? H : "";
                    let pe = (H.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
                    return Z(pe);
                }
                function ge() {
                    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    return Array.from({
                        length: Math.min(H, o)
                    }).fill(n);
                }
                function he(H, pe) {
                    let { quote: X, regex: le } = c(H, pe);
                    return [
                        X,
                        H.replace(le, `\\${X}`),
                        X
                    ];
                }
                function we(H) {
                    let pe = 0, X = H.getParentNode(pe);
                    for(; X && $(X, [
                        "SubExpression"
                    ]);)pe++, X = H.getParentNode(pe);
                    return !!(X && $(H.getParentNode(pe + 1), [
                        "ConcatStatement"
                    ]) && $(H.getParentNode(pe + 2), [
                        "AttrNode"
                    ]));
                }
                function ke(H, pe) {
                    let X = Ne(H, pe), le = Pe(H, pe);
                    return le ? i([
                        X,
                        p,
                        a(le)
                    ]) : X;
                }
                function Re(H, pe) {
                    let X = Ne(H, pe), le = Pe(H, pe);
                    return le ? [
                        i([
                            X,
                            p,
                            le
                        ]),
                        y
                    ] : X;
                }
                function Ne(H, pe) {
                    return pe("path");
                }
                function Pe(H, pe) {
                    let X = H.getValue(), le = [];
                    if (X.params.length > 0) {
                        let Ae = H.map(pe, "params");
                        le.push(...Ae);
                    }
                    if (X.hash && X.hash.pairs.length > 0) {
                        let Ae = pe("hash");
                        le.push(Ae);
                    }
                    return le.length === 0 ? "" : l(p, le);
                }
                function oe(H) {
                    return [
                        "as |",
                        H.blockParams.join(" "),
                        "|"
                    ];
                }
                r.exports = {
                    print: d,
                    massageAstNode: w
                };
            }
        }), Qd = te({
            "src/language-handlebars/parsers.js" () {
                ne();
            }
        }), Zd = te({
            "node_modules/linguist-languages/data/Handlebars.json" (e, r) {
                r.exports = {
                    name: "Handlebars",
                    type: "markup",
                    color: "#f7931e",
                    aliases: [
                        "hbs",
                        "htmlbars"
                    ],
                    extensions: [
                        ".handlebars",
                        ".hbs"
                    ],
                    tmScope: "text.html.handlebars",
                    aceMode: "handlebars",
                    languageId: 155
                };
            }
        }), eg = te({
            "src/language-handlebars/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = Yd(), a = Qd(), n = [
                    t(Zd(), ()=>({
                            since: "2.3.0",
                            parsers: [
                                "glimmer"
                            ],
                            vscodeLanguageIds: [
                                "handlebars"
                            ]
                        }))
                ], u = {
                    glimmer: s
                };
                r.exports = {
                    languages: n,
                    printers: u,
                    parsers: a
                };
            }
        }), tg = te({
            "src/language-graphql/pragma.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a);
                }
                function s(a) {
                    return `# @format

` + a;
                }
                r.exports = {
                    hasPragma: t,
                    insertPragma: s
                };
            }
        }), rg = te({
            "src/language-graphql/loc.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return typeof a.start == "number" ? a.start : a.loc && a.loc.start;
                }
                function s(a) {
                    return typeof a.end == "number" ? a.end : a.loc && a.loc.end;
                }
                r.exports = {
                    locStart: t,
                    locEnd: s
                };
            }
        }), ng = te({
            "src/language-graphql/printer-graphql.js" (e, r) {
                "use strict";
                ne();
                var { builders: { join: t, hardline: s, line: a, softline: n, group: u, indent: i, ifBreak: l } } = qe(), { isNextLineEmpty: p, isNonEmptyArray: y } = Ue(), { insertPragma: h } = tg(), { locStart: g, locEnd: c } = rg();
                function f(P, $, D) {
                    let T = P.getValue();
                    if (!T) return "";
                    if (typeof T == "string") return T;
                    switch(T.kind){
                        case "Document":
                            {
                                let m = [];
                                return P.each((C, o, d)=>{
                                    m.push(D()), o !== d.length - 1 && (m.push(s), p($.originalText, C.getValue(), c) && m.push(s));
                                }, "definitions"), [
                                    ...m,
                                    s
                                ];
                            }
                        case "OperationDefinition":
                            {
                                let m = $.originalText[g(T)] !== "{", C = Boolean(T.name);
                                return [
                                    m ? T.operation : "",
                                    m && C ? [
                                        " ",
                                        D("name")
                                    ] : "",
                                    m && !C && y(T.variableDefinitions) ? " " : "",
                                    y(T.variableDefinitions) ? u([
                                        "(",
                                        i([
                                            n,
                                            t([
                                                l("", ", "),
                                                n
                                            ], P.map(D, "variableDefinitions"))
                                        ]),
                                        n,
                                        ")"
                                    ]) : "",
                                    F(P, D, T),
                                    T.selectionSet ? !m && !C ? "" : " " : "",
                                    D("selectionSet")
                                ];
                            }
                        case "FragmentDefinition":
                            return [
                                "fragment ",
                                D("name"),
                                y(T.variableDefinitions) ? u([
                                    "(",
                                    i([
                                        n,
                                        t([
                                            l("", ", "),
                                            n
                                        ], P.map(D, "variableDefinitions"))
                                    ]),
                                    n,
                                    ")"
                                ]) : "",
                                " on ",
                                D("typeCondition"),
                                F(P, D, T),
                                " ",
                                D("selectionSet")
                            ];
                        case "SelectionSet":
                            return [
                                "{",
                                i([
                                    s,
                                    t(s, _(P, $, D, "selections"))
                                ]),
                                s,
                                "}"
                            ];
                        case "Field":
                            return u([
                                T.alias ? [
                                    D("alias"),
                                    ": "
                                ] : "",
                                D("name"),
                                T.arguments.length > 0 ? u([
                                    "(",
                                    i([
                                        n,
                                        t([
                                            l("", ", "),
                                            n
                                        ], _(P, $, D, "arguments"))
                                    ]),
                                    n,
                                    ")"
                                ]) : "",
                                F(P, D, T),
                                T.selectionSet ? " " : "",
                                D("selectionSet")
                            ]);
                        case "Name":
                            return T.value;
                        case "StringValue":
                            if (T.block) {
                                let m = T.value.replace(/"""/g, "\\$&").split(`
`);
                                return m.length === 1 && (m[0] = m[0].trim()), m.every((C)=>C === "") && (m.length = 0), t(s, [
                                    '"""',
                                    ...m,
                                    '"""'
                                ]);
                            }
                            return [
                                '"',
                                T.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"),
                                '"'
                            ];
                        case "IntValue":
                        case "FloatValue":
                        case "EnumValue":
                            return T.value;
                        case "BooleanValue":
                            return T.value ? "true" : "false";
                        case "NullValue":
                            return "null";
                        case "Variable":
                            return [
                                "$",
                                D("name")
                            ];
                        case "ListValue":
                            return u([
                                "[",
                                i([
                                    n,
                                    t([
                                        l("", ", "),
                                        n
                                    ], P.map(D, "values"))
                                ]),
                                n,
                                "]"
                            ]);
                        case "ObjectValue":
                            return u([
                                "{",
                                $.bracketSpacing && T.fields.length > 0 ? " " : "",
                                i([
                                    n,
                                    t([
                                        l("", ", "),
                                        n
                                    ], P.map(D, "fields"))
                                ]),
                                n,
                                l("", $.bracketSpacing && T.fields.length > 0 ? " " : ""),
                                "}"
                            ]);
                        case "ObjectField":
                        case "Argument":
                            return [
                                D("name"),
                                ": ",
                                D("value")
                            ];
                        case "Directive":
                            return [
                                "@",
                                D("name"),
                                T.arguments.length > 0 ? u([
                                    "(",
                                    i([
                                        n,
                                        t([
                                            l("", ", "),
                                            n
                                        ], _(P, $, D, "arguments"))
                                    ]),
                                    n,
                                    ")"
                                ]) : ""
                            ];
                        case "NamedType":
                            return D("name");
                        case "VariableDefinition":
                            return [
                                D("variable"),
                                ": ",
                                D("type"),
                                T.defaultValue ? [
                                    " = ",
                                    D("defaultValue")
                                ] : "",
                                F(P, D, T)
                            ];
                        case "ObjectTypeExtension":
                        case "ObjectTypeDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                T.kind === "ObjectTypeExtension" ? "extend " : "",
                                "type ",
                                D("name"),
                                T.interfaces.length > 0 ? [
                                    " implements ",
                                    ...N(P, $, D)
                                ] : "",
                                F(P, D, T),
                                T.fields.length > 0 ? [
                                    " {",
                                    i([
                                        s,
                                        t(s, _(P, $, D, "fields"))
                                    ]),
                                    s,
                                    "}"
                                ] : ""
                            ];
                        case "FieldDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                D("name"),
                                T.arguments.length > 0 ? u([
                                    "(",
                                    i([
                                        n,
                                        t([
                                            l("", ", "),
                                            n
                                        ], _(P, $, D, "arguments"))
                                    ]),
                                    n,
                                    ")"
                                ]) : "",
                                ": ",
                                D("type"),
                                F(P, D, T)
                            ];
                        case "DirectiveDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                "directive ",
                                "@",
                                D("name"),
                                T.arguments.length > 0 ? u([
                                    "(",
                                    i([
                                        n,
                                        t([
                                            l("", ", "),
                                            n
                                        ], _(P, $, D, "arguments"))
                                    ]),
                                    n,
                                    ")"
                                ]) : "",
                                T.repeatable ? " repeatable" : "",
                                " on ",
                                t(" | ", P.map(D, "locations"))
                            ];
                        case "EnumTypeExtension":
                        case "EnumTypeDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                T.kind === "EnumTypeExtension" ? "extend " : "",
                                "enum ",
                                D("name"),
                                F(P, D, T),
                                T.values.length > 0 ? [
                                    " {",
                                    i([
                                        s,
                                        t(s, _(P, $, D, "values"))
                                    ]),
                                    s,
                                    "}"
                                ] : ""
                            ];
                        case "EnumValueDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                D("name"),
                                F(P, D, T)
                            ];
                        case "InputValueDefinition":
                            return [
                                D("description"),
                                T.description ? T.description.block ? s : a : "",
                                D("name"),
                                ": ",
                                D("type"),
                                T.defaultValue ? [
                                    " = ",
                                    D("defaultValue")
                                ] : "",
                                F(P, D, T)
                            ];
                        case "InputObjectTypeExtension":
                        case "InputObjectTypeDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                T.kind === "InputObjectTypeExtension" ? "extend " : "",
                                "input ",
                                D("name"),
                                F(P, D, T),
                                T.fields.length > 0 ? [
                                    " {",
                                    i([
                                        s,
                                        t(s, _(P, $, D, "fields"))
                                    ]),
                                    s,
                                    "}"
                                ] : ""
                            ];
                        case "SchemaExtension":
                            return [
                                "extend schema",
                                F(P, D, T),
                                ...T.operationTypes.length > 0 ? [
                                    " {",
                                    i([
                                        s,
                                        t(s, _(P, $, D, "operationTypes"))
                                    ]),
                                    s,
                                    "}"
                                ] : []
                            ];
                        case "SchemaDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                "schema",
                                F(P, D, T),
                                " {",
                                T.operationTypes.length > 0 ? i([
                                    s,
                                    t(s, _(P, $, D, "operationTypes"))
                                ]) : "",
                                s,
                                "}"
                            ];
                        case "OperationTypeDefinition":
                            return [
                                D("operation"),
                                ": ",
                                D("type")
                            ];
                        case "InterfaceTypeExtension":
                        case "InterfaceTypeDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                T.kind === "InterfaceTypeExtension" ? "extend " : "",
                                "interface ",
                                D("name"),
                                T.interfaces.length > 0 ? [
                                    " implements ",
                                    ...N(P, $, D)
                                ] : "",
                                F(P, D, T),
                                T.fields.length > 0 ? [
                                    " {",
                                    i([
                                        s,
                                        t(s, _(P, $, D, "fields"))
                                    ]),
                                    s,
                                    "}"
                                ] : ""
                            ];
                        case "FragmentSpread":
                            return [
                                "...",
                                D("name"),
                                F(P, D, T)
                            ];
                        case "InlineFragment":
                            return [
                                "...",
                                T.typeCondition ? [
                                    " on ",
                                    D("typeCondition")
                                ] : "",
                                F(P, D, T),
                                " ",
                                D("selectionSet")
                            ];
                        case "UnionTypeExtension":
                        case "UnionTypeDefinition":
                            return u([
                                D("description"),
                                T.description ? s : "",
                                u([
                                    T.kind === "UnionTypeExtension" ? "extend " : "",
                                    "union ",
                                    D("name"),
                                    F(P, D, T),
                                    T.types.length > 0 ? [
                                        " =",
                                        l("", " "),
                                        i([
                                            l([
                                                a,
                                                "  "
                                            ]),
                                            t([
                                                a,
                                                "| "
                                            ], P.map(D, "types"))
                                        ])
                                    ] : ""
                                ])
                            ]);
                        case "ScalarTypeExtension":
                        case "ScalarTypeDefinition":
                            return [
                                D("description"),
                                T.description ? s : "",
                                T.kind === "ScalarTypeExtension" ? "extend " : "",
                                "scalar ",
                                D("name"),
                                F(P, D, T)
                            ];
                        case "NonNullType":
                            return [
                                D("type"),
                                "!"
                            ];
                        case "ListType":
                            return [
                                "[",
                                D("type"),
                                "]"
                            ];
                        default:
                            throw new Error("unknown graphql type: " + JSON.stringify(T.kind));
                    }
                }
                function F(P, $, D) {
                    if (D.directives.length === 0) return "";
                    let T = t(a, P.map($, "directives"));
                    return D.kind === "FragmentDefinition" || D.kind === "OperationDefinition" ? u([
                        a,
                        T
                    ]) : [
                        " ",
                        u(i([
                            n,
                            T
                        ]))
                    ];
                }
                function _(P, $, D, T) {
                    return P.map((m, C, o)=>{
                        let d = D();
                        return C < o.length - 1 && p($.originalText, m.getValue(), c) ? [
                            d,
                            s
                        ] : d;
                    }, T);
                }
                function w(P) {
                    return P.kind && P.kind !== "Comment";
                }
                function E(P) {
                    let $ = P.getValue();
                    if ($.kind === "Comment") return "#" + $.value.trimEnd();
                    throw new Error("Not a comment: " + JSON.stringify($));
                }
                function N(P, $, D) {
                    let T = P.getNode(), m = [], { interfaces: C } = T, o = P.map((d)=>D(d), "interfaces");
                    for(let d = 0; d < C.length; d++){
                        let v = C[d];
                        m.push(o[d]);
                        let S = C[d + 1];
                        if (S) {
                            let b = $.originalText.slice(v.loc.end, S.loc.start), B = b.includes("#"), k = b.replace(/#.*/g, "").trim();
                            m.push(k === "," ? "," : " &", B ? a : " ");
                        }
                    }
                    return m;
                }
                function x(P, $) {
                    P.kind === "StringValue" && P.block && !P.value.includes(`
`) && ($.value = $.value.trim());
                }
                x.ignoredProperties = new Set([
                    "loc",
                    "comments"
                ]);
                function I(P) {
                    var $;
                    let D = P.getValue();
                    return D == null || ($ = D.comments) === null || $ === void 0 ? void 0 : $.some((T)=>T.value.trim() === "prettier-ignore");
                }
                r.exports = {
                    print: f,
                    massageAstNode: x,
                    hasPrettierIgnore: I,
                    insertPragma: h,
                    printComment: E,
                    canAttachComment: w
                };
            }
        }), ug = te({
            "src/language-graphql/options.js" (e, r) {
                "use strict";
                ne();
                var t = Mt();
                r.exports = {
                    bracketSpacing: t.bracketSpacing
                };
            }
        }), sg = te({
            "src/language-graphql/parsers.js" () {
                ne();
            }
        }), ig = te({
            "node_modules/linguist-languages/data/GraphQL.json" (e, r) {
                r.exports = {
                    name: "GraphQL",
                    type: "data",
                    color: "#e10098",
                    extensions: [
                        ".graphql",
                        ".gql",
                        ".graphqls"
                    ],
                    tmScope: "source.graphql",
                    aceMode: "text",
                    languageId: 139
                };
            }
        }), ag = te({
            "src/language-graphql/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = ng(), a = ug(), n = sg(), u = [
                    t(ig(), ()=>({
                            since: "1.5.0",
                            parsers: [
                                "graphql"
                            ],
                            vscodeLanguageIds: [
                                "graphql"
                            ]
                        }))
                ], i = {
                    graphql: s
                };
                r.exports = {
                    languages: u,
                    options: a,
                    printers: i,
                    parsers: n
                };
            }
        }), Po = te({
            "node_modules/collapse-white-space/index.js" (e, r) {
                "use strict";
                ne(), r.exports = t;
                function t(s) {
                    return String(s).replace(/\s+/g, " ");
                }
            }
        }), Io = te({
            "src/language-markdown/loc.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return a.position.start.offset;
                }
                function s(a) {
                    return a.position.end.offset;
                }
                r.exports = {
                    locStart: t,
                    locEnd: s
                };
            }
        }), og = te({
            "src/language-markdown/constants.evaluate.js" (e, r) {
                r.exports = {
                    cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?",
                    kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]",
                    punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]"
                };
            }
        }), iu = te({
            "src/language-markdown/utils.js" (e, r) {
                "use strict";
                ne();
                var { getLast: t } = Ue(), { locStart: s, locEnd: a } = Io(), { cjkPattern: n, kPattern: u, punctuationPattern: i } = og(), l = [
                    "liquidNode",
                    "inlineCode",
                    "emphasis",
                    "esComment",
                    "strong",
                    "delete",
                    "wikiLink",
                    "link",
                    "linkReference",
                    "image",
                    "imageReference",
                    "footnote",
                    "footnoteReference",
                    "sentence",
                    "whitespace",
                    "word",
                    "break",
                    "inlineMath"
                ], p = [
                    ...l,
                    "tableCell",
                    "paragraph",
                    "heading"
                ], y = new RegExp(u), h = new RegExp(i);
                function g(E, N) {
                    let x = "non-cjk", I = "cj-letter", P = "k-letter", $ = "cjk-punctuation", D = [], T = (N.proseWrap === "preserve" ? E : E.replace(new RegExp(`(${n})
(${n})`, "g"), "$1$2")).split(/([\t\n ]+)/);
                    for (let [C, o] of T.entries()){
                        if (C % 2 === 1) {
                            D.push({
                                type: "whitespace",
                                value: /\n/.test(o) ? `
` : " "
                            });
                            continue;
                        }
                        if ((C === 0 || C === T.length - 1) && o === "") continue;
                        let d = o.split(new RegExp(`(${n})`));
                        for (let [v, S] of d.entries())if (!((v === 0 || v === d.length - 1) && S === "")) {
                            if (v % 2 === 0) {
                                S !== "" && m({
                                    type: "word",
                                    value: S,
                                    kind: x,
                                    hasLeadingPunctuation: h.test(S[0]),
                                    hasTrailingPunctuation: h.test(t(S))
                                });
                                continue;
                            }
                            m(h.test(S) ? {
                                type: "word",
                                value: S,
                                kind: $,
                                hasLeadingPunctuation: !0,
                                hasTrailingPunctuation: !0
                            } : {
                                type: "word",
                                value: S,
                                kind: y.test(S) ? P : I,
                                hasLeadingPunctuation: !1,
                                hasTrailingPunctuation: !1
                            });
                        }
                    }
                    return D;
                    function m(C) {
                        let o = t(D);
                        o && o.type === "word" && (o.kind === x && C.kind === I && !o.hasTrailingPunctuation || o.kind === I && C.kind === x && !C.hasLeadingPunctuation ? D.push({
                            type: "whitespace",
                            value: " "
                        }) : !d(x, $) && ![
                            o.value,
                            C.value
                        ].some((v)=>/\u3000/.test(v)) && D.push({
                            type: "whitespace",
                            value: ""
                        })), D.push(C);
                        function d(v, S) {
                            return o.kind === v && C.kind === S || o.kind === S && C.kind === v;
                        }
                    }
                }
                function c(E, N) {
                    let [, x, I, P] = N.slice(E.position.start.offset, E.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
                    return {
                        numberText: x,
                        marker: I,
                        leadingSpaces: P
                    };
                }
                function f(E, N) {
                    if (!E.ordered || E.children.length < 2) return !1;
                    let x = Number(c(E.children[0], N.originalText).numberText), I = Number(c(E.children[1], N.originalText).numberText);
                    if (x === 0 && E.children.length > 2) {
                        let P = Number(c(E.children[2], N.originalText).numberText);
                        return I === 1 && P === 1;
                    }
                    return I === 1;
                }
                function F(E, N) {
                    let { value: x } = E;
                    return E.position.end.offset === N.length && x.endsWith(`
`) && N.endsWith(`
`) ? x.slice(0, -1) : x;
                }
                function _(E, N) {
                    return function x(I, P, $) {
                        let D = Object.assign({}, N(I, P, $));
                        return D.children && (D.children = D.children.map((T, m)=>x(T, m, [
                                D,
                                ...$
                            ]))), D;
                    }(E, null, []);
                }
                function w(E) {
                    if ((E == null ? void 0 : E.type) !== "link" || E.children.length !== 1) return !1;
                    let [N] = E.children;
                    return s(E) === s(N) && a(E) === a(N);
                }
                r.exports = {
                    mapAst: _,
                    splitText: g,
                    punctuationPattern: i,
                    getFencedCodeBlockValue: F,
                    getOrderedListItemInfo: c,
                    hasGitDiffFriendlyOrderedList: f,
                    INLINE_NODE_TYPES: l,
                    INLINE_NODE_WRAPPER_TYPES: p,
                    isAutolink: w
                };
            }
        }), lg = te({
            "src/language-markdown/embed.js" (e, r) {
                "use strict";
                ne();
                var { inferParserByLanguage: t, getMaxContinuousCount: s } = Ue(), { builders: { hardline: a, markAsRoot: n }, utils: { replaceEndOfLine: u } } = qe(), i = su(), { getFencedCodeBlockValue: l } = iu();
                function p(y, h, g, c) {
                    let f = y.getValue();
                    if (f.type === "code" && f.lang !== null) {
                        let F = t(f.lang, c);
                        if (F) {
                            let _ = c.__inJsTemplate ? "~" : "`", w = _.repeat(Math.max(3, s(f.value, _) + 1)), E = {
                                parser: F
                            };
                            f.lang === "tsx" && (E.filepath = "dummy.tsx");
                            let N = g(l(f, c.originalText), E, {
                                stripTrailingHardline: !0
                            });
                            return n([
                                w,
                                f.lang,
                                f.meta ? " " + f.meta : "",
                                a,
                                u(N),
                                a,
                                w
                            ]);
                        }
                    }
                    switch(f.type){
                        case "front-matter":
                            return i(f, g);
                        case "importExport":
                            return [
                                g(f.value, {
                                    parser: "babel"
                                }, {
                                    stripTrailingHardline: !0
                                }),
                                a
                            ];
                        case "jsx":
                            return g(`<$>${f.value}</$>`, {
                                parser: "__js_expression",
                                rootMarker: "mdx"
                            }, {
                                stripTrailingHardline: !0
                            });
                    }
                    return null;
                }
                r.exports = p;
            }
        }), ko = te({
            "src/language-markdown/pragma.js" (e, r) {
                "use strict";
                ne();
                var t = _o(), s = [
                    "format",
                    "prettier"
                ];
                function a(n) {
                    let u = `@(${s.join("|")})`, i = new RegExp([
                        `<!--\\s*${u}\\s*-->`,
                        `{\\s*\\/\\*\\s*${u}\\s*\\*\\/\\s*}`,
                        `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*${u}[^\\S
]*($|
)[\\s\\S]*
.*-->`
                    ].join("|"), "m"), l = n.match(i);
                    return (l == null ? void 0 : l.index) === 0;
                }
                r.exports = {
                    startWithPragma: a,
                    hasPragma: (n)=>a(t(n).content.trimStart()),
                    insertPragma: (n)=>{
                        let u = t(n), i = `<!-- @${s[0]} -->`;
                        return u.frontMatter ? `${u.frontMatter.raw}

${i}

${u.content}` : `${i}

${u.content}`;
                    }
                };
            }
        }), cg = te({
            "src/language-markdown/print-preprocess.js" (e, r) {
                "use strict";
                ne();
                var t = lt(), { getOrderedListItemInfo: s, mapAst: a, splitText: n } = iu(), u = /^.$/su;
                function i(w, E) {
                    return w = y(w, E), w = c(w), w = p(w, E), w = F(w, E), w = _(w, E), w = f(w, E), w = l(w), w = h(w), w;
                }
                function l(w) {
                    return a(w, (E)=>E.type !== "import" && E.type !== "export" ? E : Object.assign(Object.assign({}, E), {}, {
                            type: "importExport"
                        }));
                }
                function p(w, E) {
                    return a(w, (N)=>N.type !== "inlineCode" || E.proseWrap === "preserve" ? N : Object.assign(Object.assign({}, N), {}, {
                            value: N.value.replace(/\s+/g, " ")
                        }));
                }
                function y(w, E) {
                    return a(w, (N)=>N.type !== "text" || N.value === "*" || N.value === "_" || !u.test(N.value) || N.position.end.offset - N.position.start.offset === N.value.length ? N : Object.assign(Object.assign({}, N), {}, {
                            value: E.originalText.slice(N.position.start.offset, N.position.end.offset)
                        }));
                }
                function h(w) {
                    return g(w, (E, N)=>E.type === "importExport" && N.type === "importExport", (E, N)=>({
                            type: "importExport",
                            value: E.value + `

` + N.value,
                            position: {
                                start: E.position.start,
                                end: N.position.end
                            }
                        }));
                }
                function g(w, E, N) {
                    return a(w, (x)=>{
                        if (!x.children) return x;
                        let I = x.children.reduce((P, $)=>{
                            let D = t(P);
                            return D && E(D, $) ? P.splice(-1, 1, N(D, $)) : P.push($), P;
                        }, []);
                        return Object.assign(Object.assign({}, x), {}, {
                            children: I
                        });
                    });
                }
                function c(w) {
                    return g(w, (E, N)=>E.type === "text" && N.type === "text", (E, N)=>({
                            type: "text",
                            value: E.value + N.value,
                            position: {
                                start: E.position.start,
                                end: N.position.end
                            }
                        }));
                }
                function f(w, E) {
                    return a(w, (N, x, I)=>{
                        let [P] = I;
                        if (N.type !== "text") return N;
                        let { value: $ } = N;
                        return P.type === "paragraph" && (x === 0 && ($ = $.trimStart()), x === P.children.length - 1 && ($ = $.trimEnd())), {
                            type: "sentence",
                            position: N.position,
                            children: n($, E)
                        };
                    });
                }
                function F(w, E) {
                    return a(w, (N, x, I)=>{
                        if (N.type === "code") {
                            let P = /^\n?(?: {4,}|\t)/.test(E.originalText.slice(N.position.start.offset, N.position.end.offset));
                            if (N.isIndented = P, P) for(let $ = 0; $ < I.length; $++){
                                let D = I[$];
                                if (D.hasIndentedCodeblock) break;
                                D.type === "list" && (D.hasIndentedCodeblock = !0);
                            }
                        }
                        return N;
                    });
                }
                function _(w, E) {
                    return a(w, (I, P, $)=>{
                        if (I.type === "list" && I.children.length > 0) {
                            for(let D = 0; D < $.length; D++){
                                let T = $[D];
                                if (T.type === "list" && !T.isAligned) return I.isAligned = !1, I;
                            }
                            I.isAligned = x(I);
                        }
                        return I;
                    });
                    function N(I) {
                        return I.children.length === 0 ? -1 : I.children[0].position.start.column - 1;
                    }
                    function x(I) {
                        if (!I.ordered) return !0;
                        let [P, $] = I.children;
                        if (s(P, E.originalText).leadingSpaces.length > 1) return !0;
                        let T = N(P);
                        if (T === -1) return !1;
                        if (I.children.length === 1) return T % E.tabWidth === 0;
                        let m = N($);
                        return T !== m ? !1 : T % E.tabWidth === 0 ? !0 : s($, E.originalText).leadingSpaces.length > 1;
                    }
                }
                r.exports = i;
            }
        }), pg = te({
            "src/language-markdown/clean.js" (e, r) {
                "use strict";
                ne();
                var t = Po(), { isFrontMatterNode: s } = Ue(), { startWithPragma: a } = ko(), n = new Set([
                    "position",
                    "raw"
                ]);
                function u(i, l, p) {
                    if ((i.type === "front-matter" || i.type === "code" || i.type === "yaml" || i.type === "import" || i.type === "export" || i.type === "jsx") && delete l.value, i.type === "list" && delete l.isAligned, (i.type === "list" || i.type === "listItem") && (delete l.spread, delete l.loose), i.type === "text" || (i.type === "inlineCode" && (l.value = i.value.replace(/[\t\n ]+/g, " ")), i.type === "wikiLink" && (l.value = i.value.trim().replace(/[\t\n]+/g, " ")), (i.type === "definition" || i.type === "linkReference" || i.type === "imageReference") && (l.label = t(i.label)), (i.type === "definition" || i.type === "link" || i.type === "image") && i.title && (l.title = i.title.replace(/\\(["')])/g, "$1")), p && p.type === "root" && p.children.length > 0 && (p.children[0] === i || s(p.children[0]) && p.children[1] === i) && i.type === "html" && a(i.value))) return null;
                }
                u.ignoredProperties = n, r.exports = u;
            }
        }), fg = te({
            "src/language-markdown/printer-markdown.js" (e, r) {
                "use strict";
                ne();
                var t = Po(), { getLast: s, getMinNotPresentContinuousCount: a, getMaxContinuousCount: n, getStringWidth: u, isNonEmptyArray: i } = Ue(), { builders: { breakParent: l, join: p, line: y, literalline: h, markAsRoot: g, hardline: c, softline: f, ifBreak: F, fill: _, align: w, indent: E, group: N, hardlineWithoutBreakParent: x }, utils: { normalizeDoc: I, replaceTextEndOfLine: P }, printer: { printDocToString: $ } } = qe(), D = lg(), { insertPragma: T } = ko(), { locStart: m, locEnd: C } = Io(), o = cg(), d = pg(), { getFencedCodeBlockValue: v, hasGitDiffFriendlyOrderedList: S, splitText: b, punctuationPattern: B, INLINE_NODE_TYPES: k, INLINE_NODE_WRAPPER_TYPES: M, isAutolink: R } = iu(), q = new Set([
                    "importExport"
                ]), J = [
                    "heading",
                    "tableCell",
                    "link",
                    "wikiLink"
                ], L = new Set([
                    "listItem",
                    "definition",
                    "footnoteDefinition"
                ]);
                function Q(oe, H, pe) {
                    let X = oe.getValue();
                    if (ge(oe)) return b(H.originalText.slice(X.position.start.offset, X.position.end.offset), H).map((le)=>le.type === "word" ? le.value : le.value === "" ? "" : W(oe, le.value, H));
                    switch(X.type){
                        case "front-matter":
                            return H.originalText.slice(X.position.start.offset, X.position.end.offset);
                        case "root":
                            return X.children.length === 0 ? "" : [
                                I(de(oe, H, pe)),
                                q.has(z(X).type) ? "" : c
                            ];
                        case "paragraph":
                            return ue(oe, H, pe, {
                                postprocessor: _
                            });
                        case "sentence":
                            return ue(oe, H, pe);
                        case "word":
                            {
                                let le = X.value.replace(/\*/g, "\\$&").replace(new RegExp([
                                    `(^|${B})(_+)`,
                                    `(_+)(${B}|$)`
                                ].join("|"), "g"), (De, A, G, re, ye)=>(G ? `${A}${G}` : `${re}${ye}`).replace(/_/g, "\\_")), Ae = (De, A, G)=>De.type === "sentence" && G === 0, Ee = (De, A, G)=>R(De.children[G - 1]);
                                return le !== X.value && (oe.match(void 0, Ae, Ee) || oe.match(void 0, Ae, (De, A, G)=>De.type === "emphasis" && G === 0, Ee)) && (le = le.replace(/^(\\?[*_])+/, (De)=>De.replace(/\\/g, ""))), le;
                            }
                        case "whitespace":
                            {
                                let le = oe.getParentNode(), Ae = le.children.indexOf(X), Ee = le.children[Ae + 1], De = Ee && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(Ee.value) ? "never" : H.proseWrap;
                                return W(oe, X.value, {
                                    proseWrap: De
                                });
                            }
                        case "emphasis":
                            {
                                let le;
                                if (R(X.children[0])) le = H.originalText[X.position.start.offset];
                                else {
                                    let Ae = oe.getParentNode(), Ee = Ae.children.indexOf(X), De = Ae.children[Ee - 1], A = Ae.children[Ee + 1];
                                    le = De && De.type === "sentence" && De.children.length > 0 && s(De.children).type === "word" && !s(De.children).hasTrailingPunctuation || A && A.type === "sentence" && A.children.length > 0 && A.children[0].type === "word" && !A.children[0].hasLeadingPunctuation || ce(oe, "emphasis") ? "*" : "_";
                                }
                                return [
                                    le,
                                    ue(oe, H, pe),
                                    le
                                ];
                            }
                        case "strong":
                            return [
                                "**",
                                ue(oe, H, pe),
                                "**"
                            ];
                        case "delete":
                            return [
                                "~~",
                                ue(oe, H, pe),
                                "~~"
                            ];
                        case "inlineCode":
                            {
                                let le = a(X.value, "`"), Ae = "`".repeat(le || 1), Ee = le && !/^\s/.test(X.value) ? " " : "";
                                return [
                                    Ae,
                                    Ee,
                                    X.value,
                                    Ee,
                                    Ae
                                ];
                            }
                        case "wikiLink":
                            {
                                let le = "";
                                return H.proseWrap === "preserve" ? le = X.value : le = X.value.replace(/[\t\n]+/g, " "), [
                                    "[[",
                                    le,
                                    "]]"
                                ];
                            }
                        case "link":
                            switch(H.originalText[X.position.start.offset]){
                                case "<":
                                    {
                                        let le = "mailto:";
                                        return [
                                            "<",
                                            X.url.startsWith(le) && H.originalText.slice(X.position.start.offset + 1, X.position.start.offset + 1 + le.length) !== le ? X.url.slice(le.length) : X.url,
                                            ">"
                                        ];
                                    }
                                case "[":
                                    return [
                                        "[",
                                        ue(oe, H, pe),
                                        "](",
                                        he(X.url, ")"),
                                        we(X.title, H),
                                        ")"
                                    ];
                                default:
                                    return H.originalText.slice(X.position.start.offset, X.position.end.offset);
                            }
                        case "image":
                            return [
                                "![",
                                X.alt || "",
                                "](",
                                he(X.url, ")"),
                                we(X.title, H),
                                ")"
                            ];
                        case "blockquote":
                            return [
                                "> ",
                                w("> ", ue(oe, H, pe))
                            ];
                        case "heading":
                            return [
                                "#".repeat(X.depth) + " ",
                                ue(oe, H, pe)
                            ];
                        case "code":
                            {
                                if (X.isIndented) {
                                    let Ee = " ".repeat(4);
                                    return w(Ee, [
                                        Ee,
                                        ...P(X.value, c)
                                    ]);
                                }
                                let le = H.__inJsTemplate ? "~" : "`", Ae = le.repeat(Math.max(3, n(X.value, le) + 1));
                                return [
                                    Ae,
                                    X.lang || "",
                                    X.meta ? " " + X.meta : "",
                                    c,
                                    ...P(v(X, H.originalText), c),
                                    c,
                                    Ae
                                ];
                            }
                        case "html":
                            {
                                let le = oe.getParentNode(), Ae = le.type === "root" && s(le.children) === X ? X.value.trimEnd() : X.value, Ee = /^<!--.*-->$/s.test(Ae);
                                return P(Ae, Ee ? c : g(h));
                            }
                        case "list":
                            {
                                let le = Y(X, oe.getParentNode()), Ae = S(X, H);
                                return ue(oe, H, pe, {
                                    processor: (Ee, De)=>{
                                        let A = re(), G = Ee.getValue();
                                        if (G.children.length === 2 && G.children[1].type === "html" && G.children[0].position.start.column !== G.children[1].position.start.column) return [
                                            A,
                                            V(Ee, H, pe, A)
                                        ];
                                        return [
                                            A,
                                            w(" ".repeat(A.length), V(Ee, H, pe, A))
                                        ];
                                        function re() {
                                            let ye = X.ordered ? (De === 0 ? X.start : Ae ? 1 : X.start + De) + (le % 2 === 0 ? ". " : ") ") : le % 2 === 0 ? "- " : "* ";
                                            return X.isAligned || X.hasIndentedCodeblock ? j(ye, H) : ye;
                                        }
                                    }
                                });
                            }
                        case "thematicBreak":
                            {
                                let le = ee(oe, "list");
                                return le === -1 ? "---" : Y(oe.getParentNode(le), oe.getParentNode(le + 1)) % 2 === 0 ? "***" : "---";
                            }
                        case "linkReference":
                            return [
                                "[",
                                ue(oe, H, pe),
                                "]",
                                X.referenceType === "full" ? Ne(X) : X.referenceType === "collapsed" ? "[]" : ""
                            ];
                        case "imageReference":
                            switch(X.referenceType){
                                case "full":
                                    return [
                                        "![",
                                        X.alt || "",
                                        "]",
                                        Ne(X)
                                    ];
                                default:
                                    return [
                                        "![",
                                        X.alt,
                                        "]",
                                        X.referenceType === "collapsed" ? "[]" : ""
                                    ];
                            }
                        case "definition":
                            {
                                let le = H.proseWrap === "always" ? y : " ";
                                return N([
                                    Ne(X),
                                    ":",
                                    E([
                                        le,
                                        he(X.url),
                                        X.title === null ? "" : [
                                            le,
                                            we(X.title, H, !1)
                                        ]
                                    ])
                                ]);
                            }
                        case "footnote":
                            return [
                                "[^",
                                ue(oe, H, pe),
                                "]"
                            ];
                        case "footnoteReference":
                            return Pe(X);
                        case "footnoteDefinition":
                            {
                                let le = oe.getParentNode().children[oe.getName() + 1], Ae = X.children.length === 1 && X.children[0].type === "paragraph" && (H.proseWrap === "never" || H.proseWrap === "preserve" && X.children[0].position.start.line === X.children[0].position.end.line);
                                return [
                                    Pe(X),
                                    ": ",
                                    Ae ? ue(oe, H, pe) : N([
                                        w(" ".repeat(4), ue(oe, H, pe, {
                                            processor: (Ee, De)=>De === 0 ? N([
                                                    f,
                                                    pe()
                                                ]) : pe()
                                        })),
                                        le && le.type === "footnoteDefinition" ? f : ""
                                    ])
                                ];
                            }
                        case "table":
                            return K(oe, H, pe);
                        case "tableCell":
                            return ue(oe, H, pe);
                        case "break":
                            return /\s/.test(H.originalText[X.position.start.offset]) ? [
                                "  ",
                                g(h)
                            ] : [
                                "\\",
                                c
                            ];
                        case "liquidNode":
                            return P(X.value, c);
                        case "importExport":
                            return [
                                X.value,
                                c
                            ];
                        case "esComment":
                            return [
                                "{/* ",
                                X.value,
                                " */}"
                            ];
                        case "jsx":
                            return X.value;
                        case "math":
                            return [
                                "$$",
                                c,
                                X.value ? [
                                    ...P(X.value, c),
                                    c
                                ] : "",
                                "$$"
                            ];
                        case "inlineMath":
                            return H.originalText.slice(m(X), C(X));
                        case "tableRow":
                        case "listItem":
                        default:
                            throw new Error(`Unknown markdown type ${JSON.stringify(X.type)}`);
                    }
                }
                function V(oe, H, pe, X) {
                    let le = oe.getValue(), Ae = le.checked === null ? "" : le.checked ? "[x] " : "[ ] ";
                    return [
                        Ae,
                        ue(oe, H, pe, {
                            processor: (Ee, De)=>{
                                if (De === 0 && Ee.getValue().type !== "list") return w(" ".repeat(Ae.length), pe());
                                let A = " ".repeat(ke(H.tabWidth - X.length, 0, 3));
                                return [
                                    A,
                                    w(A, pe())
                                ];
                            }
                        })
                    ];
                }
                function j(oe, H) {
                    let pe = X();
                    return oe + " ".repeat(pe >= 4 ? 0 : pe);
                    function X() {
                        let le = oe.length % H.tabWidth;
                        return le === 0 ? 0 : H.tabWidth - le;
                    }
                }
                function Y(oe, H) {
                    return ie(oe, H, (pe)=>pe.ordered === oe.ordered);
                }
                function ie(oe, H, pe) {
                    let X = -1;
                    for (let le of H.children)if (le.type === oe.type && pe(le) ? X++ : X = -1, le === oe) return X;
                }
                function ee(oe, H) {
                    let pe = Array.isArray(H) ? H : [
                        H
                    ], X = -1, le;
                    for(; le = oe.getParentNode(++X);)if (pe.includes(le.type)) return X;
                    return -1;
                }
                function ce(oe, H) {
                    let pe = ee(oe, H);
                    return pe === -1 ? null : oe.getParentNode(pe);
                }
                function W(oe, H, pe) {
                    if (pe.proseWrap === "preserve" && H === `
`) return c;
                    let X = pe.proseWrap === "always" && !ce(oe, J);
                    return H !== "" ? X ? y : " " : X ? f : "";
                }
                function K(oe, H, pe) {
                    let X = oe.getValue(), le = [], Ae = oe.map((ye)=>ye.map((Ce, Be)=>{
                            let ve = $(pe(), H).formatted, ze = u(ve);
                            return le[Be] = Math.max(le[Be] || 3, ze), {
                                text: ve,
                                width: ze
                            };
                        }, "children"), "children"), Ee = A(!1);
                    if (H.proseWrap !== "never") return [
                        l,
                        Ee
                    ];
                    let De = A(!0);
                    return [
                        l,
                        N(F(De, Ee))
                    ];
                    function A(ye) {
                        let Ce = [
                            re(Ae[0], ye),
                            G(ye)
                        ];
                        return Ae.length > 1 && Ce.push(p(x, Ae.slice(1).map((Be)=>re(Be, ye)))), p(x, Ce);
                    }
                    function G(ye) {
                        return `| ${le.map((Be, ve)=>{
                            let ze = X.align[ve], be = ze === "center" || ze === "left" ? ":" : "-", Ye = ze === "center" || ze === "right" ? ":" : "-", Se = ye ? "-" : "-".repeat(Be - 2);
                            return `${be}${Se}${Ye}`;
                        }).join(" | ")} |`;
                    }
                    function re(ye, Ce) {
                        return `| ${ye.map((ve, ze)=>{
                            let { text: be, width: Ye } = ve;
                            if (Ce) return be;
                            let Se = le[ze] - Ye, Ie = X.align[ze], Oe = 0;
                            Ie === "right" ? Oe = Se : Ie === "center" && (Oe = Math.floor(Se / 2));
                            let Je = Se - Oe;
                            return `${" ".repeat(Oe)}${be}${" ".repeat(Je)}`;
                        }).join(" | ")} |`;
                    }
                }
                function de(oe, H, pe) {
                    let X = [], le = null, { children: Ae } = oe.getValue();
                    for (let [Ee, De] of Ae.entries())switch(U(De)){
                        case "start":
                            le === null && (le = {
                                index: Ee,
                                offset: De.position.end.offset
                            });
                            break;
                        case "end":
                            le !== null && (X.push({
                                start: le,
                                end: {
                                    index: Ee,
                                    offset: De.position.start.offset
                                }
                            }), le = null);
                            break;
                        default:
                            break;
                    }
                    return ue(oe, H, pe, {
                        processor: (Ee, De)=>{
                            if (X.length > 0) {
                                let A = X[0];
                                if (De === A.start.index) return [
                                    Fe(Ae[A.start.index]),
                                    H.originalText.slice(A.start.offset, A.end.offset),
                                    Fe(Ae[A.end.index])
                                ];
                                if (A.start.index < De && De < A.end.index) return !1;
                                if (De === A.end.index) return X.shift(), !1;
                            }
                            return pe();
                        }
                    });
                }
                function ue(oe, H, pe) {
                    let X = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: le } = X, Ae = X.processor || (()=>pe()), Ee = oe.getValue(), De = [], A;
                    return oe.each((G, re)=>{
                        let ye = G.getValue(), Ce = Ae(G, re);
                        if (Ce !== !1) {
                            let Be = {
                                parts: De,
                                prevNode: A,
                                parentNode: Ee,
                                options: H
                            };
                            Z(ye, Be) && (De.push(c), A && q.has(A.type) || (se(ye, Be) || fe(ye, Be)) && De.push(c), fe(ye, Be) && De.push(c)), De.push(Ce), A = ye;
                        }
                    }, "children"), le ? le(De) : De;
                }
                function Fe(oe) {
                    if (oe.type === "html") return oe.value;
                    if (oe.type === "paragraph" && Array.isArray(oe.children) && oe.children.length === 1 && oe.children[0].type === "esComment") return [
                        "{/* ",
                        oe.children[0].value,
                        " */}"
                    ];
                }
                function z(oe) {
                    let H = oe;
                    for(; i(H.children);)H = s(H.children);
                    return H;
                }
                function U(oe) {
                    let H;
                    if (oe.type === "html") H = oe.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
                    else {
                        let pe;
                        oe.type === "esComment" ? pe = oe : oe.type === "paragraph" && oe.children.length === 1 && oe.children[0].type === "esComment" && (pe = oe.children[0]), pe && (H = pe.value.match(/^prettier-ignore(?:-(start|end))?$/));
                    }
                    return H ? H[1] || "next" : !1;
                }
                function Z(oe, H) {
                    let pe = H.parts.length === 0, X = k.includes(oe.type), le = oe.type === "html" && M.includes(H.parentNode.type);
                    return !pe && !X && !le;
                }
                function se(oe, H) {
                    var pe, X, le;
                    let Ee = (H.prevNode && H.prevNode.type) === oe.type && L.has(oe.type), De = H.parentNode.type === "listItem" && !H.parentNode.loose, A = ((pe = H.prevNode) === null || pe === void 0 ? void 0 : pe.type) === "listItem" && H.prevNode.loose, G = U(H.prevNode) === "next", re = oe.type === "html" && ((X = H.prevNode) === null || X === void 0 ? void 0 : X.type) === "html" && H.prevNode.position.end.line + 1 === oe.position.start.line, ye = oe.type === "html" && H.parentNode.type === "listItem" && ((le = H.prevNode) === null || le === void 0 ? void 0 : le.type) === "paragraph" && H.prevNode.position.end.line + 1 === oe.position.start.line;
                    return A || !(Ee || De || G || re || ye);
                }
                function fe(oe, H) {
                    let pe = H.prevNode && H.prevNode.type === "list", X = oe.type === "code" && oe.isIndented;
                    return pe && X;
                }
                function ge(oe) {
                    let H = ce(oe, [
                        "linkReference",
                        "imageReference"
                    ]);
                    return H && (H.type !== "linkReference" || H.referenceType !== "full");
                }
                function he(oe) {
                    let H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], pe = [
                        " ",
                        ...Array.isArray(H) ? H : [
                            H
                        ]
                    ];
                    return new RegExp(pe.map((X)=>`\\${X}`).join("|")).test(oe) ? `<${oe}>` : oe;
                }
                function we(oe, H) {
                    let pe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                    if (!oe) return "";
                    if (pe) return " " + we(oe, H, !1);
                    if (oe = oe.replace(/\\(["')])/g, "$1"), oe.includes('"') && oe.includes("'") && !oe.includes(")")) return `(${oe})`;
                    let X = oe.split("'").length - 1, le = oe.split('"').length - 1, Ae = X > le ? '"' : le > X || H.singleQuote ? "'" : '"';
                    return oe = oe.replace(/\\/, "\\\\"), oe = oe.replace(new RegExp(`(${Ae})`, "g"), "\\$1"), `${Ae}${oe}${Ae}`;
                }
                function ke(oe, H, pe) {
                    return oe < H ? H : oe > pe ? pe : oe;
                }
                function Re(oe) {
                    let H = Number(oe.getName());
                    if (H === 0) return !1;
                    let pe = oe.getParentNode().children[H - 1];
                    return U(pe) === "next";
                }
                function Ne(oe) {
                    return `[${t(oe.label)}]`;
                }
                function Pe(oe) {
                    return `[^${oe.label}]`;
                }
                r.exports = {
                    preprocess: o,
                    print: Q,
                    embed: D,
                    massageAstNode: d,
                    hasPrettierIgnore: Re,
                    insertPragma: T
                };
            }
        }), Dg = te({
            "src/language-markdown/options.js" (e, r) {
                "use strict";
                ne();
                var t = Mt();
                r.exports = {
                    proseWrap: t.proseWrap,
                    singleQuote: t.singleQuote
                };
            }
        }), mg = te({
            "src/language-markdown/parsers.js" () {
                ne();
            }
        }), _a = te({
            "node_modules/linguist-languages/data/Markdown.json" (e, r) {
                r.exports = {
                    name: "Markdown",
                    type: "prose",
                    color: "#083fa1",
                    aliases: [
                        "pandoc"
                    ],
                    aceMode: "markdown",
                    codemirrorMode: "gfm",
                    codemirrorMimeType: "text/x-gfm",
                    wrap: !0,
                    extensions: [
                        ".md",
                        ".livemd",
                        ".markdown",
                        ".mdown",
                        ".mdwn",
                        ".mdx",
                        ".mkd",
                        ".mkdn",
                        ".mkdown",
                        ".ronn",
                        ".scd",
                        ".workbook"
                    ],
                    filenames: [
                        "contents.lr"
                    ],
                    tmScope: "source.gfm",
                    languageId: 222
                };
            }
        }), dg = te({
            "src/language-markdown/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = fg(), a = Dg(), n = mg(), u = [
                    t(_a(), (l)=>({
                            since: "1.8.0",
                            parsers: [
                                "markdown"
                            ],
                            vscodeLanguageIds: [
                                "markdown"
                            ],
                            filenames: [
                                ...l.filenames,
                                "README"
                            ],
                            extensions: l.extensions.filter((p)=>p !== ".mdx")
                        })),
                    t(_a(), ()=>({
                            name: "MDX",
                            since: "1.15.0",
                            parsers: [
                                "mdx"
                            ],
                            vscodeLanguageIds: [
                                "mdx"
                            ],
                            filenames: [],
                            extensions: [
                                ".mdx"
                            ]
                        }))
                ], i = {
                    mdast: s
                };
                r.exports = {
                    languages: u,
                    options: a,
                    printers: i,
                    parsers: n
                };
            }
        }), gg = te({
            "src/language-html/clean.js" (e, r) {
                "use strict";
                ne();
                var { isFrontMatterNode: t } = Ue(), s = new Set([
                    "sourceSpan",
                    "startSourceSpan",
                    "endSourceSpan",
                    "nameSpan",
                    "valueSpan"
                ]);
                function a(n, u) {
                    if (n.type === "text" || n.type === "comment" || t(n) || n.type === "yaml" || n.type === "toml") return null;
                    n.type === "attribute" && delete u.value, n.type === "docType" && delete u.value;
                }
                a.ignoredProperties = s, r.exports = a;
            }
        }), yg = te({
            "src/language-html/constants.evaluate.js" (e, r) {
                r.exports = {
                    CSS_DISPLAY_TAGS: {
                        area: "none",
                        base: "none",
                        basefont: "none",
                        datalist: "none",
                        head: "none",
                        link: "none",
                        meta: "none",
                        noembed: "none",
                        noframes: "none",
                        param: "block",
                        rp: "none",
                        script: "block",
                        source: "block",
                        style: "none",
                        template: "inline",
                        track: "block",
                        title: "none",
                        html: "block",
                        body: "block",
                        address: "block",
                        blockquote: "block",
                        center: "block",
                        div: "block",
                        figure: "block",
                        figcaption: "block",
                        footer: "block",
                        form: "block",
                        header: "block",
                        hr: "block",
                        legend: "block",
                        listing: "block",
                        main: "block",
                        p: "block",
                        plaintext: "block",
                        pre: "block",
                        xmp: "block",
                        slot: "contents",
                        ruby: "ruby",
                        rt: "ruby-text",
                        article: "block",
                        aside: "block",
                        h1: "block",
                        h2: "block",
                        h3: "block",
                        h4: "block",
                        h5: "block",
                        h6: "block",
                        hgroup: "block",
                        nav: "block",
                        section: "block",
                        dir: "block",
                        dd: "block",
                        dl: "block",
                        dt: "block",
                        ol: "block",
                        ul: "block",
                        li: "list-item",
                        table: "table",
                        caption: "table-caption",
                        colgroup: "table-column-group",
                        col: "table-column",
                        thead: "table-header-group",
                        tbody: "table-row-group",
                        tfoot: "table-footer-group",
                        tr: "table-row",
                        td: "table-cell",
                        th: "table-cell",
                        fieldset: "block",
                        button: "inline-block",
                        details: "block",
                        summary: "block",
                        dialog: "block",
                        meter: "inline-block",
                        progress: "inline-block",
                        object: "inline-block",
                        video: "inline-block",
                        audio: "inline-block",
                        select: "inline-block",
                        option: "block",
                        optgroup: "block"
                    },
                    CSS_DISPLAY_DEFAULT: "inline",
                    CSS_WHITE_SPACE_TAGS: {
                        listing: "pre",
                        plaintext: "pre",
                        pre: "pre",
                        xmp: "pre",
                        nobr: "nowrap",
                        table: "initial",
                        textarea: "pre-wrap"
                    },
                    CSS_WHITE_SPACE_DEFAULT: "normal"
                };
            }
        }), hg = te({
            "src/language-html/utils/is-unknown-namespace.js" (e, r) {
                "use strict";
                ne();
                function t(s) {
                    return s.type === "element" && !s.hasExplicitNamespace && ![
                        "html",
                        "svg"
                    ].includes(s.namespace);
                }
                r.exports = t;
            }
        }), Rt = te({
            "src/language-html/utils/index.js" (e, r) {
                "use strict";
                ne();
                var { inferParserByLanguage: t, isFrontMatterNode: s } = Ue(), { builders: { line: a, hardline: n, join: u }, utils: { getDocParts: i, replaceTextEndOfLine: l } } = qe(), { CSS_DISPLAY_TAGS: p, CSS_DISPLAY_DEFAULT: y, CSS_WHITE_SPACE_TAGS: h, CSS_WHITE_SPACE_DEFAULT: g } = yg(), c = hg(), f = new Set([
                    "	",
                    `
`,
                    "\f",
                    "\r",
                    " "
                ]), F = (A)=>A.replace(/^[\t\n\f\r ]+/, ""), _ = (A)=>A.replace(/[\t\n\f\r ]+$/, ""), w = (A)=>F(_(A)), E = (A)=>A.replace(/^[\t\f\r ]*\n/g, ""), N = (A)=>E(_(A)), x = (A)=>A.split(/[\t\n\f\r ]+/), I = (A)=>A.match(/^[\t\n\f\r ]*/)[0], P = (A)=>{
                    let [, G, re, ye] = A.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
                    return {
                        leadingWhitespace: G,
                        trailingWhitespace: ye,
                        text: re
                    };
                }, $ = (A)=>/[\t\n\f\r ]/.test(A);
                function D(A, G) {
                    return !!(A.type === "ieConditionalComment" && A.lastChild && !A.lastChild.isSelfClosing && !A.lastChild.endSourceSpan || A.type === "ieConditionalComment" && !A.complete || se(A) && A.children.some((re)=>re.type !== "text" && re.type !== "interpolation") || X(A, G) && !o(A) && A.type !== "interpolation");
                }
                function T(A) {
                    return A.type === "attribute" || !A.parent || !A.prev ? !1 : m(A.prev);
                }
                function m(A) {
                    return A.type === "comment" && A.value.trim() === "prettier-ignore";
                }
                function C(A) {
                    return A.type === "text" || A.type === "comment";
                }
                function o(A) {
                    return A.type === "element" && (A.fullName === "script" || A.fullName === "style" || A.fullName === "svg:style" || c(A) && (A.name === "script" || A.name === "style"));
                }
                function d(A) {
                    return A.children && !o(A);
                }
                function v(A) {
                    return o(A) || A.type === "interpolation" || S(A);
                }
                function S(A) {
                    return we(A).startsWith("pre");
                }
                function b(A, G) {
                    let re = ye();
                    if (re && !A.prev && A.parent && A.parent.tagDefinition && A.parent.tagDefinition.ignoreFirstLf) return A.type === "interpolation";
                    return re;
                    function ye() {
                        return s(A) ? !1 : (A.type === "text" || A.type === "interpolation") && A.prev && (A.prev.type === "text" || A.prev.type === "interpolation") ? !0 : !A.parent || A.parent.cssDisplay === "none" ? !1 : se(A.parent) ? !0 : !(!A.prev && (A.parent.type === "root" || se(A) && A.parent || o(A.parent) || H(A.parent, G) || !ue(A.parent.cssDisplay)) || A.prev && !U(A.prev.cssDisplay));
                    }
                }
                function B(A, G) {
                    return s(A) ? !1 : (A.type === "text" || A.type === "interpolation") && A.next && (A.next.type === "text" || A.next.type === "interpolation") ? !0 : !A.parent || A.parent.cssDisplay === "none" ? !1 : se(A.parent) ? !0 : !(!A.next && (A.parent.type === "root" || se(A) && A.parent || o(A.parent) || H(A.parent, G) || !Fe(A.parent.cssDisplay)) || A.next && !z(A.next.cssDisplay));
                }
                function k(A) {
                    return Z(A.cssDisplay) && !o(A);
                }
                function M(A) {
                    return s(A) || A.next && A.sourceSpan.end && A.sourceSpan.end.line + 1 < A.next.sourceSpan.start.line;
                }
                function R(A) {
                    return q(A) || A.type === "element" && A.children.length > 0 && ([
                        "body",
                        "script",
                        "style"
                    ].includes(A.name) || A.children.some((G)=>ee(G))) || A.firstChild && A.firstChild === A.lastChild && A.firstChild.type !== "text" && V(A.firstChild) && (!A.lastChild.isTrailingSpaceSensitive || j(A.lastChild));
                }
                function q(A) {
                    return A.type === "element" && A.children.length > 0 && ([
                        "html",
                        "head",
                        "ul",
                        "ol",
                        "select"
                    ].includes(A.name) || A.cssDisplay.startsWith("table") && A.cssDisplay !== "table-cell");
                }
                function J(A) {
                    return Y(A) || A.prev && L(A.prev) || Q(A);
                }
                function L(A) {
                    return Y(A) || A.type === "element" && A.fullName === "br" || Q(A);
                }
                function Q(A) {
                    return V(A) && j(A);
                }
                function V(A) {
                    return A.hasLeadingSpaces && (A.prev ? A.prev.sourceSpan.end.line < A.sourceSpan.start.line : A.parent.type === "root" || A.parent.startSourceSpan.end.line < A.sourceSpan.start.line);
                }
                function j(A) {
                    return A.hasTrailingSpaces && (A.next ? A.next.sourceSpan.start.line > A.sourceSpan.end.line : A.parent.type === "root" || A.parent.endSourceSpan && A.parent.endSourceSpan.start.line > A.sourceSpan.end.line);
                }
                function Y(A) {
                    switch(A.type){
                        case "ieConditionalComment":
                        case "comment":
                        case "directive":
                            return !0;
                        case "element":
                            return [
                                "script",
                                "select"
                            ].includes(A.name);
                    }
                    return !1;
                }
                function ie(A) {
                    return A.lastChild ? ie(A.lastChild) : A;
                }
                function ee(A) {
                    return A.children && A.children.some((G)=>G.type !== "text");
                }
                function ce(A) {
                    let { type: G, lang: re } = A.attrMap;
                    if (G === "module" || G === "text/javascript" || G === "text/babel" || G === "application/javascript" || re === "jsx") return "babel";
                    if (G === "application/x-typescript" || re === "ts" || re === "tsx") return "typescript";
                    if (G === "text/markdown") return "markdown";
                    if (G === "text/html") return "html";
                    if (G && (G.endsWith("json") || G.endsWith("importmap")) || G === "speculationrules") return "json";
                    if (G === "text/x-handlebars-template") return "glimmer";
                }
                function W(A, G) {
                    let { lang: re } = A.attrMap;
                    if (!re || re === "postcss" || re === "css") return "css";
                    if (re === "scss") return "scss";
                    if (re === "less") return "less";
                    if (re === "stylus") return t("stylus", G);
                }
                function K(A, G) {
                    if (A.name === "script" && !A.attrMap.src) return !A.attrMap.lang && !A.attrMap.type ? "babel" : ce(A);
                    if (A.name === "style") return W(A, G);
                    if (G && X(A, G)) return ce(A) || !("src" in A.attrMap) && t(A.attrMap.lang, G);
                }
                function de(A) {
                    return A === "block" || A === "list-item" || A.startsWith("table");
                }
                function ue(A) {
                    return !de(A) && A !== "inline-block";
                }
                function Fe(A) {
                    return !de(A) && A !== "inline-block";
                }
                function z(A) {
                    return !de(A);
                }
                function U(A) {
                    return !de(A);
                }
                function Z(A) {
                    return !de(A) && A !== "inline-block";
                }
                function se(A) {
                    return we(A).startsWith("pre");
                }
                function fe(A, G) {
                    let re = 0;
                    for(let ye = A.stack.length - 1; ye >= 0; ye--){
                        let Ce = A.stack[ye];
                        Ce && typeof Ce == "object" && !Array.isArray(Ce) && G(Ce) && re++;
                    }
                    return re;
                }
                function ge(A, G) {
                    let re = A;
                    for(; re;){
                        if (G(re)) return !0;
                        re = re.parent;
                    }
                    return !1;
                }
                function he(A, G) {
                    if (A.prev && A.prev.type === "comment") {
                        let ye = A.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
                        if (ye) return ye[1];
                    }
                    let re = !1;
                    if (A.type === "element" && A.namespace === "svg") {
                        if (ge(A, (ye)=>ye.fullName === "svg:foreignObject")) re = !0;
                        else return A.name === "svg" ? "inline-block" : "block";
                    }
                    switch(G.htmlWhitespaceSensitivity){
                        case "strict":
                            return "inline";
                        case "ignore":
                            return "block";
                        default:
                            return G.parser === "vue" && A.parent && A.parent.type === "root" ? "block" : A.type === "element" && (!A.namespace || re || c(A)) && p[A.name] || y;
                    }
                }
                function we(A) {
                    return A.type === "element" && (!A.namespace || c(A)) && h[A.name] || g;
                }
                function ke(A) {
                    let G = Number.POSITIVE_INFINITY;
                    for (let re of A.split(`
`)){
                        if (re.length === 0) continue;
                        if (!f.has(re[0])) return 0;
                        let ye = I(re).length;
                        re.length !== ye && ye < G && (G = ye);
                    }
                    return G === Number.POSITIVE_INFINITY ? 0 : G;
                }
                function Re(A) {
                    let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ke(A);
                    return G === 0 ? A : A.split(`
`).map((re)=>re.slice(G)).join(`
`);
                }
                function Ne(A, G) {
                    let re = 0;
                    for(let ye = 0; ye < A.length; ye++)A[ye] === G && re++;
                    return re;
                }
                function Pe(A) {
                    return A.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
                }
                var oe = new Set([
                    "template",
                    "style",
                    "script"
                ]);
                function H(A, G) {
                    return pe(A, G) && !oe.has(A.fullName);
                }
                function pe(A, G) {
                    return G.parser === "vue" && A.type === "element" && A.parent.type === "root" && A.fullName.toLowerCase() !== "html";
                }
                function X(A, G) {
                    return pe(A, G) && (H(A, G) || A.attrMap.lang && A.attrMap.lang !== "html");
                }
                function le(A) {
                    let G = A.fullName;
                    return G.charAt(0) === "#" || G === "slot-scope" || G === "v-slot" || G.startsWith("v-slot:");
                }
                function Ae(A, G) {
                    let re = A.parent;
                    if (!pe(re, G)) return !1;
                    let ye = re.fullName, Ce = A.fullName;
                    return ye === "script" && Ce === "setup" || ye === "style" && Ce === "vars";
                }
                function Ee(A) {
                    let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : A.value;
                    return A.parent.isWhitespaceSensitive ? A.parent.isIndentationSensitive ? l(G) : l(Re(N(G)), n) : i(u(a, x(G)));
                }
                function De(A, G) {
                    return pe(A, G) && A.name === "script";
                }
                r.exports = {
                    htmlTrim: w,
                    htmlTrimPreserveIndentation: N,
                    hasHtmlWhitespace: $,
                    getLeadingAndTrailingHtmlWhitespace: P,
                    canHaveInterpolation: d,
                    countChars: Ne,
                    countParents: fe,
                    dedentString: Re,
                    forceBreakChildren: q,
                    forceBreakContent: R,
                    forceNextEmptyLine: M,
                    getLastDescendant: ie,
                    getNodeCssStyleDisplay: he,
                    getNodeCssStyleWhiteSpace: we,
                    hasPrettierIgnore: T,
                    inferScriptParser: K,
                    isVueCustomBlock: H,
                    isVueNonHtmlBlock: X,
                    isVueScriptTag: De,
                    isVueSlotAttribute: le,
                    isVueSfcBindingsAttribute: Ae,
                    isVueSfcBlock: pe,
                    isDanglingSpaceSensitiveNode: k,
                    isIndentationSensitiveNode: S,
                    isLeadingSpaceSensitiveNode: b,
                    isPreLikeNode: se,
                    isScriptLikeTag: o,
                    isTextLikeNode: C,
                    isTrailingSpaceSensitiveNode: B,
                    isWhitespaceSensitiveNode: v,
                    isUnknownNamespace: c,
                    preferHardlineAsLeadingSpaces: J,
                    preferHardlineAsTrailingSpaces: L,
                    shouldPreserveContent: D,
                    unescapeQuoteEntities: Pe,
                    getTextValueParts: Ee
                };
            }
        }), vg = te({
            "node_modules/angular-html-parser/lib/compiler/src/chars.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
                function r(i) {
                    return i >= e.$TAB && i <= e.$SPACE || i == e.$NBSP;
                }
                e.isWhitespace = r;
                function t(i) {
                    return e.$0 <= i && i <= e.$9;
                }
                e.isDigit = t;
                function s(i) {
                    return i >= e.$a && i <= e.$z || i >= e.$A && i <= e.$Z;
                }
                e.isAsciiLetter = s;
                function a(i) {
                    return i >= e.$a && i <= e.$f || i >= e.$A && i <= e.$F || t(i);
                }
                e.isAsciiHexDigit = a;
                function n(i) {
                    return i === e.$LF || i === e.$CR;
                }
                e.isNewLine = n;
                function u(i) {
                    return e.$0 <= i && i <= e.$7;
                }
                e.isOctalDigit = u;
            }
        }), Cg = te({
            "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = class {
                    constructor(s, a, n){
                        this.filePath = s, this.name = a, this.members = n;
                    }
                    assertNoMembers() {
                        if (this.members.length) throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
                    }
                };
                e.StaticSymbol = r;
                var t = class {
                    constructor(){
                        this.cache = new Map;
                    }
                    get(s, a, n) {
                        n = n || [];
                        let u = n.length ? `.${n.join(".")}` : "", i = `"${s}".${a}${u}`, l = this.cache.get(i);
                        return l || (l = new r(s, a, n), this.cache.set(i, l)), l;
                    }
                };
                e.StaticSymbolCache = t;
            }
        }), Eg = te({
            "node_modules/angular-html-parser/lib/compiler/src/util.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = /-+([a-z0-9])/g;
                function t(o) {
                    return o.replace(r, function() {
                        for(var d = arguments.length, v = new Array(d), S = 0; S < d; S++)v[S] = arguments[S];
                        return v[1].toUpperCase();
                    });
                }
                e.dashCaseToCamelCase = t;
                function s(o, d) {
                    return n(o, ":", d);
                }
                e.splitAtColon = s;
                function a(o, d) {
                    return n(o, ".", d);
                }
                e.splitAtPeriod = a;
                function n(o, d, v) {
                    let S = o.indexOf(d);
                    return S == -1 ? v : [
                        o.slice(0, S).trim(),
                        o.slice(S + 1).trim()
                    ];
                }
                function u(o, d, v) {
                    return Array.isArray(o) ? d.visitArray(o, v) : E(o) ? d.visitStringMap(o, v) : o == null || typeof o == "string" || typeof o == "number" || typeof o == "boolean" ? d.visitPrimitive(o, v) : d.visitOther(o, v);
                }
                e.visitValue = u;
                function i(o) {
                    return o != null;
                }
                e.isDefined = i;
                function l(o) {
                    return o === void 0 ? null : o;
                }
                e.noUndefined = l;
                var p = class {
                    visitArray(o, d) {
                        return o.map((v)=>u(v, this, d));
                    }
                    visitStringMap(o, d) {
                        let v = {};
                        return Object.keys(o).forEach((S)=>{
                            v[S] = u(o[S], this, d);
                        }), v;
                    }
                    visitPrimitive(o, d) {
                        return o;
                    }
                    visitOther(o, d) {
                        return o;
                    }
                };
                e.ValueTransformer = p, e.SyncAsync = {
                    assertSync: (o)=>{
                        if (P(o)) throw new Error("Illegal state: value cannot be a promise");
                        return o;
                    },
                    then: (o, d)=>P(o) ? o.then(d) : d(o),
                    all: (o)=>o.some(P) ? Promise.all(o) : o
                };
                function y(o) {
                    throw new Error(`Internal Error: ${o}`);
                }
                e.error = y;
                function h(o, d) {
                    let v = Error(o);
                    return v[g] = !0, d && (v[c] = d), v;
                }
                e.syntaxError = h;
                var g = "ngSyntaxError", c = "ngParseErrors";
                function f(o) {
                    return o[g];
                }
                e.isSyntaxError = f;
                function F(o) {
                    return o[c] || [];
                }
                e.getParseErrors = F;
                function _(o) {
                    return o.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
                }
                e.escapeRegExp = _;
                var w = Object.getPrototypeOf({});
                function E(o) {
                    return typeof o == "object" && o !== null && Object.getPrototypeOf(o) === w;
                }
                function N(o) {
                    let d = "";
                    for(let v = 0; v < o.length; v++){
                        let S = o.charCodeAt(v);
                        if (S >= 55296 && S <= 56319 && o.length > v + 1) {
                            let b = o.charCodeAt(v + 1);
                            b >= 56320 && b <= 57343 && (v++, S = (S - 55296 << 10) + b - 56320 + 65536);
                        }
                        S <= 127 ? d += String.fromCharCode(S) : S <= 2047 ? d += String.fromCharCode(S >> 6 & 31 | 192, S & 63 | 128) : S <= 65535 ? d += String.fromCharCode(S >> 12 | 224, S >> 6 & 63 | 128, S & 63 | 128) : S <= 2097151 && (d += String.fromCharCode(S >> 18 & 7 | 240, S >> 12 & 63 | 128, S >> 6 & 63 | 128, S & 63 | 128));
                    }
                    return d;
                }
                e.utf8Encode = N;
                function x(o) {
                    if (typeof o == "string") return o;
                    if (o instanceof Array) return "[" + o.map(x).join(", ") + "]";
                    if (o == null) return "" + o;
                    if (o.overriddenName) return `${o.overriddenName}`;
                    if (o.name) return `${o.name}`;
                    if (!o.toString) return "object";
                    let d = o.toString();
                    if (d == null) return "" + d;
                    let v = d.indexOf(`
`);
                    return v === -1 ? d : d.substring(0, v);
                }
                e.stringify = x;
                function I(o) {
                    return typeof o == "function" && o.hasOwnProperty("__forward_ref__") ? o() : o;
                }
                e.resolveForwardRef = I;
                function P(o) {
                    return !!o && typeof o.then == "function";
                }
                e.isPromise = P;
                var $ = class {
                    constructor(o){
                        this.full = o;
                        let d = o.split(".");
                        this.major = d[0], this.minor = d[1], this.patch = d.slice(2).join(".");
                    }
                };
                e.Version = $;
                var D = typeof window < "u" && window, T = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, m = typeof globalThis < "u" && globalThis, C = m || D || T;
                e.global = C;
            }
        }), Fg = te({
            "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = Cg(), t = Eg(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
                function a(v) {
                    return v.replace(/\W/g, "_");
                }
                e.sanitizeIdentifier = a;
                var n = 0;
                function u(v) {
                    if (!v || !v.reference) return null;
                    let S = v.reference;
                    if (S instanceof r.StaticSymbol) return S.name;
                    if (S.__anonymousType) return S.__anonymousType;
                    let b = t.stringify(S);
                    return b.indexOf("(") >= 0 ? (b = `anonymous_${n++}`, S.__anonymousType = b) : b = a(b), b;
                }
                e.identifierName = u;
                function i(v) {
                    let S = v.reference;
                    return S instanceof r.StaticSymbol ? S.filePath : `./${t.stringify(S)}`;
                }
                e.identifierModuleUrl = i;
                function l(v, S) {
                    return `View_${u({
                        reference: v
                    })}_${S}`;
                }
                e.viewClassName = l;
                function p(v) {
                    return `RenderType_${u({
                        reference: v
                    })}`;
                }
                e.rendererTypeName = p;
                function y(v) {
                    return `HostView_${u({
                        reference: v
                    })}`;
                }
                e.hostViewClassName = y;
                function h(v) {
                    return `${u({
                        reference: v
                    })}NgFactory`;
                }
                e.componentFactoryName = h;
                var g;
                (function(v) {
                    v[v.Pipe = 0] = "Pipe", v[v.Directive = 1] = "Directive", v[v.NgModule = 2] = "NgModule", v[v.Injectable = 3] = "Injectable";
                })(g = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
                function c(v) {
                    return v.value != null ? a(v.value) : u(v.identifier);
                }
                e.tokenName = c;
                function f(v) {
                    return v.identifier != null ? v.identifier.reference : v.value;
                }
                e.tokenReference = f;
                var F = class {
                    constructor(){
                        let { moduleUrl: v, styles: S, styleUrls: b } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        this.moduleUrl = v || null, this.styles = P(S), this.styleUrls = P(b);
                    }
                };
                e.CompileStylesheetMetadata = F;
                var _ = class {
                    constructor(v){
                        let { encapsulation: S, template: b, templateUrl: B, htmlAst: k, styles: M, styleUrls: R, externalStylesheets: q, animations: J, ngContentSelectors: L, interpolation: Q, isInline: V, preserveWhitespaces: j } = v;
                        if (this.encapsulation = S, this.template = b, this.templateUrl = B, this.htmlAst = k, this.styles = P(M), this.styleUrls = P(R), this.externalStylesheets = P(q), this.animations = J ? D(J) : [], this.ngContentSelectors = L || [], Q && Q.length != 2) throw new Error("'interpolation' should have a start and an end symbol.");
                        this.interpolation = Q, this.isInline = V, this.preserveWhitespaces = j;
                    }
                    toSummary() {
                        return {
                            ngContentSelectors: this.ngContentSelectors,
                            encapsulation: this.encapsulation,
                            styles: this.styles,
                            animations: this.animations
                        };
                    }
                };
                e.CompileTemplateMetadata = _;
                var w = class {
                    static create(v) {
                        let { isHost: S, type: b, isComponent: B, selector: k, exportAs: M, changeDetection: R, inputs: q, outputs: J, host: L, providers: Q, viewProviders: V, queries: j, guards: Y, viewQueries: ie, entryComponents: ee, template: ce, componentViewType: W, rendererType: K, componentFactory: de } = v, ue = {}, Fe = {}, z = {};
                        L != null && Object.keys(L).forEach((se)=>{
                            let fe = L[se], ge = se.match(s);
                            ge === null ? z[se] = fe : ge[1] != null ? Fe[ge[1]] = fe : ge[2] != null && (ue[ge[2]] = fe);
                        });
                        let U = {};
                        q != null && q.forEach((se)=>{
                            let fe = t.splitAtColon(se, [
                                se,
                                se
                            ]);
                            U[fe[0]] = fe[1];
                        });
                        let Z = {};
                        return J != null && J.forEach((se)=>{
                            let fe = t.splitAtColon(se, [
                                se,
                                se
                            ]);
                            Z[fe[0]] = fe[1];
                        }), new w({
                            isHost: S,
                            type: b,
                            isComponent: !!B,
                            selector: k,
                            exportAs: M,
                            changeDetection: R,
                            inputs: U,
                            outputs: Z,
                            hostListeners: ue,
                            hostProperties: Fe,
                            hostAttributes: z,
                            providers: Q,
                            viewProviders: V,
                            queries: j,
                            guards: Y,
                            viewQueries: ie,
                            entryComponents: ee,
                            template: ce,
                            componentViewType: W,
                            rendererType: K,
                            componentFactory: de
                        });
                    }
                    constructor(v){
                        let { isHost: S, type: b, isComponent: B, selector: k, exportAs: M, changeDetection: R, inputs: q, outputs: J, hostListeners: L, hostProperties: Q, hostAttributes: V, providers: j, viewProviders: Y, queries: ie, guards: ee, viewQueries: ce, entryComponents: W, template: K, componentViewType: de, rendererType: ue, componentFactory: Fe } = v;
                        this.isHost = !!S, this.type = b, this.isComponent = B, this.selector = k, this.exportAs = M, this.changeDetection = R, this.inputs = q, this.outputs = J, this.hostListeners = L, this.hostProperties = Q, this.hostAttributes = V, this.providers = P(j), this.viewProviders = P(Y), this.queries = P(ie), this.guards = ee, this.viewQueries = P(ce), this.entryComponents = P(W), this.template = K, this.componentViewType = de, this.rendererType = ue, this.componentFactory = Fe;
                    }
                    toSummary() {
                        return {
                            summaryKind: g.Directive,
                            type: this.type,
                            isComponent: this.isComponent,
                            selector: this.selector,
                            exportAs: this.exportAs,
                            inputs: this.inputs,
                            outputs: this.outputs,
                            hostListeners: this.hostListeners,
                            hostProperties: this.hostProperties,
                            hostAttributes: this.hostAttributes,
                            providers: this.providers,
                            viewProviders: this.viewProviders,
                            queries: this.queries,
                            guards: this.guards,
                            viewQueries: this.viewQueries,
                            entryComponents: this.entryComponents,
                            changeDetection: this.changeDetection,
                            template: this.template && this.template.toSummary(),
                            componentViewType: this.componentViewType,
                            rendererType: this.rendererType,
                            componentFactory: this.componentFactory
                        };
                    }
                };
                e.CompileDirectiveMetadata = w;
                var E = class {
                    constructor(v){
                        let { type: S, name: b, pure: B } = v;
                        this.type = S, this.name = b, this.pure = !!B;
                    }
                    toSummary() {
                        return {
                            summaryKind: g.Pipe,
                            type: this.type,
                            name: this.name,
                            pure: this.pure
                        };
                    }
                };
                e.CompilePipeMetadata = E;
                var N = class {
                };
                e.CompileShallowModuleMetadata = N;
                var x = class {
                    constructor(v){
                        let { type: S, providers: b, declaredDirectives: B, exportedDirectives: k, declaredPipes: M, exportedPipes: R, entryComponents: q, bootstrapComponents: J, importedModules: L, exportedModules: Q, schemas: V, transitiveModule: j, id: Y } = v;
                        this.type = S || null, this.declaredDirectives = P(B), this.exportedDirectives = P(k), this.declaredPipes = P(M), this.exportedPipes = P(R), this.providers = P(b), this.entryComponents = P(q), this.bootstrapComponents = P(J), this.importedModules = P(L), this.exportedModules = P(Q), this.schemas = P(V), this.id = Y || null, this.transitiveModule = j || null;
                    }
                    toSummary() {
                        let v = this.transitiveModule;
                        return {
                            summaryKind: g.NgModule,
                            type: this.type,
                            entryComponents: v.entryComponents,
                            providers: v.providers,
                            modules: v.modules,
                            exportedDirectives: v.exportedDirectives,
                            exportedPipes: v.exportedPipes
                        };
                    }
                };
                e.CompileNgModuleMetadata = x;
                var I = class {
                    constructor(){
                        this.directivesSet = new Set, this.directives = [], this.exportedDirectivesSet = new Set, this.exportedDirectives = [], this.pipesSet = new Set, this.pipes = [], this.exportedPipesSet = new Set, this.exportedPipes = [], this.modulesSet = new Set, this.modules = [], this.entryComponentsSet = new Set, this.entryComponents = [], this.providers = [];
                    }
                    addProvider(v, S) {
                        this.providers.push({
                            provider: v,
                            module: S
                        });
                    }
                    addDirective(v) {
                        this.directivesSet.has(v.reference) || (this.directivesSet.add(v.reference), this.directives.push(v));
                    }
                    addExportedDirective(v) {
                        this.exportedDirectivesSet.has(v.reference) || (this.exportedDirectivesSet.add(v.reference), this.exportedDirectives.push(v));
                    }
                    addPipe(v) {
                        this.pipesSet.has(v.reference) || (this.pipesSet.add(v.reference), this.pipes.push(v));
                    }
                    addExportedPipe(v) {
                        this.exportedPipesSet.has(v.reference) || (this.exportedPipesSet.add(v.reference), this.exportedPipes.push(v));
                    }
                    addModule(v) {
                        this.modulesSet.has(v.reference) || (this.modulesSet.add(v.reference), this.modules.push(v));
                    }
                    addEntryComponent(v) {
                        this.entryComponentsSet.has(v.componentType) || (this.entryComponentsSet.add(v.componentType), this.entryComponents.push(v));
                    }
                };
                e.TransitiveCompileNgModuleMetadata = I;
                function P(v) {
                    return v || [];
                }
                var $ = class {
                    constructor(v, S){
                        let { useClass: b, useValue: B, useExisting: k, useFactory: M, deps: R, multi: q } = S;
                        this.token = v, this.useClass = b || null, this.useValue = B, this.useExisting = k, this.useFactory = M || null, this.dependencies = R || null, this.multi = !!q;
                    }
                };
                e.ProviderMeta = $;
                function D(v) {
                    return v.reduce((S, b)=>{
                        let B = Array.isArray(b) ? D(b) : b;
                        return S.concat(B);
                    }, []);
                }
                e.flatten = D;
                function T(v) {
                    return v.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
                }
                function m(v, S, b) {
                    let B;
                    return b.isInline ? S.type.reference instanceof r.StaticSymbol ? B = `${S.type.reference.filePath}.${S.type.reference.name}.html` : B = `${u(v)}/${u(S.type)}.html` : B = b.templateUrl, S.type.reference instanceof r.StaticSymbol ? B : T(B);
                }
                e.templateSourceUrl = m;
                function C(v, S) {
                    let b = v.moduleUrl.split(/\/\\/g), B = b[b.length - 1];
                    return T(`css/${S}${B}.ngstyle.js`);
                }
                e.sharedStylesheetJitUrl = C;
                function o(v) {
                    return T(`${u(v.type)}/module.ngfactory.js`);
                }
                e.ngModuleJitUrl = o;
                function d(v, S) {
                    return T(`${u(v)}/${u(S.type)}.ngfactory.js`);
                }
                e.templateJitUrl = d;
            }
        }), Ag = te({
            "node_modules/angular-html-parser/lib/compiler/src/parse_util.js" (e) {
                "use strict";
                ne(), Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = vg(), t = Fg(), s = class {
                    constructor(y, h, g, c){
                        this.file = y, this.offset = h, this.line = g, this.col = c;
                    }
                    toString() {
                        return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
                    }
                    moveBy(y) {
                        let h = this.file.content, g = h.length, c = this.offset, f = this.line, F = this.col;
                        for(; c > 0 && y < 0;)if (c--, y++, h.charCodeAt(c) == r.$LF) {
                            f--;
                            let w = h.substr(0, c - 1).lastIndexOf(String.fromCharCode(r.$LF));
                            F = w > 0 ? c - w : c;
                        } else F--;
                        for(; c < g && y > 0;){
                            let _ = h.charCodeAt(c);
                            c++, y--, _ == r.$LF ? (f++, F = 0) : F++;
                        }
                        return new s(this.file, c, f, F);
                    }
                    getContext(y, h) {
                        let g = this.file.content, c = this.offset;
                        if (c != null) {
                            c > g.length - 1 && (c = g.length - 1);
                            let f = c, F = 0, _ = 0;
                            for(; F < y && c > 0 && (c--, F++, !(g[c] == `
` && ++_ == h)););
                            for(F = 0, _ = 0; F < y && f < g.length - 1 && (f++, F++, !(g[f] == `
` && ++_ == h)););
                            return {
                                before: g.substring(c, this.offset),
                                after: g.substring(this.offset, f + 1)
                            };
                        }
                        return null;
                    }
                };
                e.ParseLocation = s;
                var a = class {
                    constructor(y, h){
                        this.content = y, this.url = h;
                    }
                };
                e.ParseSourceFile = a;
                var n = class {
                    constructor(y, h){
                        let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                        this.start = y, this.end = h, this.details = g;
                    }
                    toString() {
                        return this.start.file.content.substring(this.start.offset, this.end.offset);
                    }
                };
                e.ParseSourceSpan = n, e.EMPTY_PARSE_LOCATION = new s(new a("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new n(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
                var u;
                (function(y) {
                    y[y.WARNING = 0] = "WARNING", y[y.ERROR = 1] = "ERROR";
                })(u = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
                var i = class {
                    constructor(y, h){
                        let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : u.ERROR;
                        this.span = y, this.msg = h, this.level = g;
                    }
                    contextualMessage() {
                        let y = this.span.start.getContext(100, 3);
                        return y ? `${this.msg} ("${y.before}[${u[this.level]} ->]${y.after}")` : this.msg;
                    }
                    toString() {
                        let y = this.span.details ? `, ${this.span.details}` : "";
                        return `${this.contextualMessage()}: ${this.span.start}${y}`;
                    }
                };
                e.ParseError = i;
                function l(y, h) {
                    let g = t.identifierModuleUrl(h), c = g != null ? `in ${y} ${t.identifierName(h)} in ${g}` : `in ${y} ${t.identifierName(h)}`, f = new a("", c);
                    return new n(new s(f, -1, -1, -1), new s(f, -1, -1, -1));
                }
                e.typeSourceSpan = l;
                function p(y, h, g) {
                    let c = `in ${y} ${h} in ${g}`, f = new a("", c);
                    return new n(new s(f, -1, -1, -1), new s(f, -1, -1, -1));
                }
                e.r3JitTypeSourceSpan = p;
            }
        }), Sg = te({
            "src/language-html/print-preprocess.js" (e, r) {
                "use strict";
                ne();
                var { ParseSourceSpan: t } = Ag(), { htmlTrim: s, getLeadingAndTrailingHtmlWhitespace: a, hasHtmlWhitespace: n, canHaveInterpolation: u, getNodeCssStyleDisplay: i, isDanglingSpaceSensitiveNode: l, isIndentationSensitiveNode: p, isLeadingSpaceSensitiveNode: y, isTrailingSpaceSensitiveNode: h, isWhitespaceSensitiveNode: g, isVueScriptTag: c } = Rt(), f = [
                    _,
                    w,
                    N,
                    I,
                    P,
                    T,
                    $,
                    D,
                    m,
                    x,
                    C
                ];
                function F(o, d) {
                    for (let v of f)v(o, d);
                    return o;
                }
                function _(o) {
                    o.walk((d)=>{
                        if (d.type === "element" && d.tagDefinition.ignoreFirstLf && d.children.length > 0 && d.children[0].type === "text" && d.children[0].value[0] === `
`) {
                            let v = d.children[0];
                            v.value.length === 1 ? d.removeChild(v) : v.value = v.value.slice(1);
                        }
                    });
                }
                function w(o) {
                    let d = (v)=>v.type === "element" && v.prev && v.prev.type === "ieConditionalStartComment" && v.prev.sourceSpan.end.offset === v.startSourceSpan.start.offset && v.firstChild && v.firstChild.type === "ieConditionalEndComment" && v.firstChild.sourceSpan.start.offset === v.startSourceSpan.end.offset;
                    o.walk((v)=>{
                        if (v.children) for(let S = 0; S < v.children.length; S++){
                            let b = v.children[S];
                            if (!d(b)) continue;
                            let B = b.prev, k = b.firstChild;
                            v.removeChild(B), S--;
                            let M = new t(B.sourceSpan.start, k.sourceSpan.end), R = new t(M.start, b.sourceSpan.end);
                            b.condition = B.condition, b.sourceSpan = R, b.startSourceSpan = M, b.removeChild(k);
                        }
                    });
                }
                function E(o, d, v) {
                    o.walk((S)=>{
                        if (S.children) for(let b = 0; b < S.children.length; b++){
                            let B = S.children[b];
                            if (B.type !== "text" && !d(B)) continue;
                            B.type !== "text" && (B.type = "text", B.value = v(B));
                            let k = B.prev;
                            !k || k.type !== "text" || (k.value += B.value, k.sourceSpan = new t(k.sourceSpan.start, B.sourceSpan.end), S.removeChild(B), b--);
                        }
                    });
                }
                function N(o) {
                    return E(o, (d)=>d.type === "cdata", (d)=>`<![CDATA[${d.value}]]>`);
                }
                function x(o) {
                    let d = (v)=>v.type === "element" && v.attrs.length === 0 && v.children.length === 1 && v.firstChild.type === "text" && !n(v.children[0].value) && !v.firstChild.hasLeadingSpaces && !v.firstChild.hasTrailingSpaces && v.isLeadingSpaceSensitive && !v.hasLeadingSpaces && v.isTrailingSpaceSensitive && !v.hasTrailingSpaces && v.prev && v.prev.type === "text" && v.next && v.next.type === "text";
                    o.walk((v)=>{
                        if (v.children) for(let S = 0; S < v.children.length; S++){
                            let b = v.children[S];
                            if (!d(b)) continue;
                            let B = b.prev, k = b.next;
                            B.value += `<${b.rawName}>` + b.firstChild.value + `</${b.rawName}>` + k.value, B.sourceSpan = new t(B.sourceSpan.start, k.sourceSpan.end), B.isTrailingSpaceSensitive = k.isTrailingSpaceSensitive, B.hasTrailingSpaces = k.hasTrailingSpaces, v.removeChild(b), S--, v.removeChild(k);
                        }
                    });
                }
                function I(o, d) {
                    if (d.parser === "html") return;
                    let v = /{{(.+?)}}/s;
                    o.walk((S)=>{
                        if (u(S)) for (let b of S.children){
                            if (b.type !== "text") continue;
                            let B = b.sourceSpan.start, k = null, M = b.value.split(v);
                            for(let R = 0; R < M.length; R++, B = k){
                                let q = M[R];
                                if (R % 2 === 0) {
                                    k = B.moveBy(q.length), q.length > 0 && S.insertChildBefore(b, {
                                        type: "text",
                                        value: q,
                                        sourceSpan: new t(B, k)
                                    });
                                    continue;
                                }
                                k = B.moveBy(q.length + 4), S.insertChildBefore(b, {
                                    type: "interpolation",
                                    sourceSpan: new t(B, k),
                                    children: q.length === 0 ? [] : [
                                        {
                                            type: "text",
                                            value: q,
                                            sourceSpan: new t(B.moveBy(2), k.moveBy(-2))
                                        }
                                    ]
                                });
                            }
                            S.removeChild(b);
                        }
                    });
                }
                function P(o) {
                    o.walk((d)=>{
                        if (!d.children) return;
                        if (d.children.length === 0 || d.children.length === 1 && d.children[0].type === "text" && s(d.children[0].value).length === 0) {
                            d.hasDanglingSpaces = d.children.length > 0, d.children = [];
                            return;
                        }
                        let v = g(d), S = p(d);
                        if (!v) for(let b = 0; b < d.children.length; b++){
                            let B = d.children[b];
                            if (B.type !== "text") continue;
                            let { leadingWhitespace: k, text: M, trailingWhitespace: R } = a(B.value), q = B.prev, J = B.next;
                            M ? (B.value = M, B.sourceSpan = new t(B.sourceSpan.start.moveBy(k.length), B.sourceSpan.end.moveBy(-R.length)), k && (q && (q.hasTrailingSpaces = !0), B.hasLeadingSpaces = !0), R && (B.hasTrailingSpaces = !0, J && (J.hasLeadingSpaces = !0))) : (d.removeChild(B), b--, (k || R) && (q && (q.hasTrailingSpaces = !0), J && (J.hasLeadingSpaces = !0)));
                        }
                        d.isWhitespaceSensitive = v, d.isIndentationSensitive = S;
                    });
                }
                function $(o) {
                    o.walk((d)=>{
                        d.isSelfClosing = !d.children || d.type === "element" && (d.tagDefinition.isVoid || d.startSourceSpan === d.endSourceSpan);
                    });
                }
                function D(o, d) {
                    o.walk((v)=>{
                        v.type === "element" && (v.hasHtmComponentClosingTag = v.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(d.originalText.slice(v.endSourceSpan.start.offset, v.endSourceSpan.end.offset)));
                    });
                }
                function T(o, d) {
                    o.walk((v)=>{
                        v.cssDisplay = i(v, d);
                    });
                }
                function m(o, d) {
                    o.walk((v)=>{
                        let { children: S } = v;
                        if (S) {
                            if (S.length === 0) {
                                v.isDanglingSpaceSensitive = l(v);
                                return;
                            }
                            for (let b of S)b.isLeadingSpaceSensitive = y(b, d), b.isTrailingSpaceSensitive = h(b, d);
                            for(let b = 0; b < S.length; b++){
                                let B = S[b];
                                B.isLeadingSpaceSensitive = (b === 0 || B.prev.isTrailingSpaceSensitive) && B.isLeadingSpaceSensitive, B.isTrailingSpaceSensitive = (b === S.length - 1 || B.next.isLeadingSpaceSensitive) && B.isTrailingSpaceSensitive;
                            }
                        }
                    });
                }
                function C(o, d) {
                    if (d.parser === "vue") {
                        let v = o.children.find((b)=>c(b, d));
                        if (!v) return;
                        let { lang: S } = v.attrMap;
                        (S === "ts" || S === "typescript") && (d.__should_parse_vue_template_with_ts = !0);
                    }
                }
                r.exports = F;
            }
        }), xg = te({
            "src/language-html/pragma.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a);
                }
                function s(a) {
                    return `<!-- @format -->

` + a.replace(/^\s*\n/, "");
                }
                r.exports = {
                    hasPragma: t,
                    insertPragma: s
                };
            }
        }), au = te({
            "src/language-html/loc.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return a.sourceSpan.start.offset;
                }
                function s(a) {
                    return a.sourceSpan.end.offset;
                }
                r.exports = {
                    locStart: t,
                    locEnd: s
                };
            }
        }), ur = te({
            "src/language-html/print/tag.js" (e, r) {
                "use strict";
                ne();
                var t = Zt(), { isNonEmptyArray: s } = Ue(), { builders: { indent: a, join: n, line: u, softline: i, hardline: l }, utils: { replaceTextEndOfLine: p } } = qe(), { locStart: y, locEnd: h } = au(), { isTextLikeNode: g, getLastDescendant: c, isPreLikeNode: f, hasPrettierIgnore: F, shouldPreserveContent: _, isVueSfcBlock: w } = Rt();
                function E(L, Q) {
                    return [
                        L.isSelfClosing ? "" : N(L, Q),
                        x(L, Q)
                    ];
                }
                function N(L, Q) {
                    return L.lastChild && o(L.lastChild) ? "" : [
                        I(L, Q),
                        $(L, Q)
                    ];
                }
                function x(L, Q) {
                    return (L.next ? m(L.next) : C(L.parent)) ? "" : [
                        D(L, Q),
                        P(L, Q)
                    ];
                }
                function I(L, Q) {
                    return C(L) ? D(L.lastChild, Q) : "";
                }
                function P(L, Q) {
                    return o(L) ? $(L.parent, Q) : d(L) ? q(L.next) : "";
                }
                function $(L, Q) {
                    if (t(!L.isSelfClosing), T(L, Q)) return "";
                    switch(L.type){
                        case "ieConditionalComment":
                            return "<!";
                        case "element":
                            if (L.hasHtmComponentClosingTag) return "<//";
                        default:
                            return `</${L.rawName}`;
                    }
                }
                function D(L, Q) {
                    if (T(L, Q)) return "";
                    switch(L.type){
                        case "ieConditionalComment":
                        case "ieConditionalEndComment":
                            return "[endif]-->";
                        case "ieConditionalStartComment":
                            return "]><!-->";
                        case "interpolation":
                            return "}}";
                        case "element":
                            if (L.isSelfClosing) return "/>";
                        default:
                            return ">";
                    }
                }
                function T(L, Q) {
                    return !L.isSelfClosing && !L.endSourceSpan && (F(L) || _(L.parent, Q));
                }
                function m(L) {
                    return L.prev && L.prev.type !== "docType" && !g(L.prev) && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
                }
                function C(L) {
                    return L.lastChild && L.lastChild.isTrailingSpaceSensitive && !L.lastChild.hasTrailingSpaces && !g(c(L.lastChild)) && !f(L);
                }
                function o(L) {
                    return !L.next && !L.hasTrailingSpaces && L.isTrailingSpaceSensitive && g(c(L));
                }
                function d(L) {
                    return L.next && !g(L.next) && g(L) && L.isTrailingSpaceSensitive && !L.hasTrailingSpaces;
                }
                function v(L) {
                    let Q = L.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
                    return Q ? Q[1] ? Q[1].split(/\s+/) : !0 : !1;
                }
                function S(L) {
                    return !L.prev && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
                }
                function b(L, Q, V) {
                    let j = L.getValue();
                    if (!s(j.attrs)) return j.isSelfClosing ? " " : "";
                    let Y = j.prev && j.prev.type === "comment" && v(j.prev.value), ie = typeof Y == "boolean" ? ()=>Y : Array.isArray(Y) ? (ue)=>Y.includes(ue.rawName) : ()=>!1, ee = L.map((ue)=>{
                        let Fe = ue.getValue();
                        return ie(Fe) ? p(Q.originalText.slice(y(Fe), h(Fe))) : V();
                    }, "attrs"), ce = j.type === "element" && j.fullName === "script" && j.attrs.length === 1 && j.attrs[0].fullName === "src" && j.children.length === 0, K = Q.singleAttributePerLine && j.attrs.length > 1 && !w(j, Q) ? l : u, de = [
                        a([
                            ce ? " " : u,
                            n(K, ee)
                        ])
                    ];
                    return j.firstChild && S(j.firstChild) || j.isSelfClosing && C(j.parent) || ce ? de.push(j.isSelfClosing ? " " : "") : de.push(Q.bracketSameLine ? j.isSelfClosing ? " " : "" : j.isSelfClosing ? u : i), de;
                }
                function B(L) {
                    return L.firstChild && S(L.firstChild) ? "" : J(L);
                }
                function k(L, Q, V) {
                    let j = L.getValue();
                    return [
                        M(j, Q),
                        b(L, Q, V),
                        j.isSelfClosing ? "" : B(j)
                    ];
                }
                function M(L, Q) {
                    return L.prev && d(L.prev) ? "" : [
                        R(L, Q),
                        q(L)
                    ];
                }
                function R(L, Q) {
                    return S(L) ? J(L.parent) : m(L) ? D(L.prev, Q) : "";
                }
                function q(L) {
                    switch(L.type){
                        case "ieConditionalComment":
                        case "ieConditionalStartComment":
                            return `<!--[if ${L.condition}`;
                        case "ieConditionalEndComment":
                            return "<!--<!";
                        case "interpolation":
                            return "{{";
                        case "docType":
                            return "<!DOCTYPE";
                        case "element":
                            if (L.condition) return `<!--[if ${L.condition}]><!--><${L.rawName}`;
                        default:
                            return `<${L.rawName}`;
                    }
                }
                function J(L) {
                    switch(t(!L.isSelfClosing), L.type){
                        case "ieConditionalComment":
                            return "]>";
                        case "element":
                            if (L.condition) return "><!--<![endif]-->";
                        default:
                            return ">";
                    }
                }
                r.exports = {
                    printClosingTag: E,
                    printClosingTagStart: N,
                    printClosingTagStartMarker: $,
                    printClosingTagEndMarker: D,
                    printClosingTagSuffix: P,
                    printClosingTagEnd: x,
                    needsToBorrowLastChildClosingTagEndMarker: C,
                    needsToBorrowParentClosingTagStartMarker: o,
                    needsToBorrowPrevClosingTagEndMarker: m,
                    printOpeningTag: k,
                    printOpeningTagStart: M,
                    printOpeningTagPrefix: R,
                    printOpeningTagStartMarker: q,
                    printOpeningTagEndMarker: J,
                    needsToBorrowNextOpeningTagStartMarker: d,
                    needsToBorrowParentOpeningTagEndMarker: S
                };
            }
        }), bg = te({
            "node_modules/parse-srcset/src/parse-srcset.js" (e, r) {
                ne(), function(t, s) {
                    typeof define == "function" && define.amd ? define([], s) : typeof r == "object" && r.exports ? r.exports = s() : t.parseSrcset = s();
                }(e, function() {
                    return function(t, s) {
                        var a = s && s.logger || console;
                        function n($) {
                            return $ === " " || $ === "	" || $ === `
` || $ === "\f" || $ === "\r";
                        }
                        function u($) {
                            var D, T = $.exec(t.substring(N));
                            if (T) return D = T[0], N += D.length, D;
                        }
                        for(var i = t.length, l = /^[ \t\n\r\u000c]+/, p = /^[, \t\n\r\u000c]+/, y = /^[^ \t\n\r\u000c]+/, h = /[,]+$/, g = /^\d+$/, c = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f, F, _, w, E, N = 0, x = [];;){
                            if (u(p), N >= i) return x;
                            f = u(y), F = [], f.slice(-1) === "," ? (f = f.replace(h, ""), P()) : I();
                        }
                        function I() {
                            for(u(l), _ = "", w = "in descriptor";;){
                                if (E = t.charAt(N), w === "in descriptor") {
                                    if (n(E)) _ && (F.push(_), _ = "", w = "after descriptor");
                                    else if (E === ",") {
                                        N += 1, _ && F.push(_), P();
                                        return;
                                    } else if (E === "(") _ = _ + E, w = "in parens";
                                    else if (E === "") {
                                        _ && F.push(_), P();
                                        return;
                                    } else _ = _ + E;
                                } else if (w === "in parens") {
                                    if (E === ")") _ = _ + E, w = "in descriptor";
                                    else if (E === "") {
                                        F.push(_), P();
                                        return;
                                    } else _ = _ + E;
                                } else if (w === "after descriptor" && !n(E)) {
                                    if (E === "") {
                                        P();
                                        return;
                                    } else w = "in descriptor", N -= 1;
                                }
                                N += 1;
                            }
                        }
                        function P() {
                            var $ = !1, D, T, m, C, o = {}, d, v, S, b, B;
                            for(C = 0; C < F.length; C++)d = F[C], v = d[d.length - 1], S = d.substring(0, d.length - 1), b = parseInt(S, 10), B = parseFloat(S), g.test(S) && v === "w" ? ((D || T) && ($ = !0), b === 0 ? $ = !0 : D = b) : c.test(S) && v === "x" ? ((D || T || m) && ($ = !0), B < 0 ? $ = !0 : T = B) : g.test(S) && v === "h" ? ((m || T) && ($ = !0), b === 0 ? $ = !0 : m = b) : $ = !0;
                            $ ? a && a.error && a.error("Invalid srcset descriptor found in '" + t + "' at '" + d + "'.") : (o.url = f, D && (o.w = D), T && (o.d = T), m && (o.h = m), x.push(o));
                        }
                    };
                });
            }
        }), Tg = te({
            "src/language-html/syntax-attribute.js" (e, r) {
                "use strict";
                ne();
                var t = bg(), { builders: { ifBreak: s, join: a, line: n } } = qe();
                function u(l) {
                    let p = t(l, {
                        logger: {
                            error (I) {
                                throw new Error(I);
                            }
                        }
                    }), y = p.some((I)=>{
                        let { w: P } = I;
                        return P;
                    }), h = p.some((I)=>{
                        let { h: P } = I;
                        return P;
                    }), g = p.some((I)=>{
                        let { d: P } = I;
                        return P;
                    });
                    if (y + h + g > 1) throw new Error("Mixed descriptor in srcset is not supported");
                    let c = y ? "w" : h ? "h" : "d", f = y ? "w" : h ? "h" : "x", F = (I)=>Math.max(...I), _ = p.map((I)=>I.url), w = F(_.map((I)=>I.length)), E = p.map((I)=>I[c]).map((I)=>I ? I.toString() : ""), N = E.map((I)=>{
                        let P = I.indexOf(".");
                        return P === -1 ? I.length : P;
                    }), x = F(N);
                    return a([
                        ",",
                        n
                    ], _.map((I, P)=>{
                        let $ = [
                            I
                        ], D = E[P];
                        if (D) {
                            let T = w - I.length + 1, m = x - N[P], C = " ".repeat(T + m);
                            $.push(s(C, " "), D + f);
                        }
                        return $;
                    }));
                }
                function i(l) {
                    return l.trim().split(/\s+/).join(" ");
                }
                r.exports = {
                    printImgSrcset: u,
                    printClassNames: i
                };
            }
        }), Bg = te({
            "src/language-html/syntax-vue.js" (e, r) {
                "use strict";
                ne();
                var { builders: { group: t } } = qe();
                function s(i, l) {
                    let { left: p, operator: y, right: h } = a(i);
                    return [
                        t(l(`function _(${p}) {}`, {
                            parser: "babel",
                            __isVueForBindingLeft: !0
                        })),
                        " ",
                        y,
                        " ",
                        l(h, {
                            parser: "__js_expression"
                        }, {
                            stripTrailingHardline: !0
                        })
                    ];
                }
                function a(i) {
                    let l = /(.*?)\s+(in|of)\s+(.*)/s, p = /,([^,\]}]*)(?:,([^,\]}]*))?$/, y = /^\(|\)$/g, h = i.match(l);
                    if (!h) return;
                    let g = {};
                    if (g.for = h[3].trim(), !g.for) return;
                    let c = h[1].trim().replace(y, ""), f = c.match(p);
                    f ? (g.alias = c.replace(p, ""), g.iterator1 = f[1].trim(), f[2] && (g.iterator2 = f[2].trim())) : g.alias = c;
                    let F = [
                        g.alias,
                        g.iterator1,
                        g.iterator2
                    ];
                    if (!F.some((_, w)=>!_ && (w === 0 || F.slice(w + 1).some(Boolean)))) return {
                        left: F.filter(Boolean).join(","),
                        operator: h[2],
                        right: g.for
                    };
                }
                function n(i, l) {
                    return l(`function _(${i}) {}`, {
                        parser: "babel",
                        __isVueBindings: !0
                    });
                }
                function u(i) {
                    let l = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, p = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, y = i.trim();
                    return l.test(y) || p.test(y);
                }
                r.exports = {
                    isVueEventBindingExpression: u,
                    printVueFor: s,
                    printVueBindings: n
                };
            }
        }), Lo = te({
            "src/language-html/get-node-content.js" (e, r) {
                "use strict";
                ne();
                var { needsToBorrowParentClosingTagStartMarker: t, printClosingTagStartMarker: s, needsToBorrowLastChildClosingTagEndMarker: a, printClosingTagEndMarker: n, needsToBorrowParentOpeningTagEndMarker: u, printOpeningTagEndMarker: i } = ur();
                function l(p, y) {
                    let h = p.startSourceSpan.end.offset;
                    p.firstChild && u(p.firstChild) && (h -= i(p).length);
                    let g = p.endSourceSpan.start.offset;
                    return p.lastChild && t(p.lastChild) ? g += s(p, y).length : a(p) && (g -= n(p.lastChild, y).length), y.originalText.slice(h, g);
                }
                r.exports = l;
            }
        }), Ng = te({
            "src/language-html/embed.js" (e, r) {
                "use strict";
                ne();
                var { builders: { breakParent: t, group: s, hardline: a, indent: n, line: u, fill: i, softline: l }, utils: { mapDoc: p, replaceTextEndOfLine: y } } = qe(), h = su(), { printClosingTag: g, printClosingTagSuffix: c, needsToBorrowPrevClosingTagEndMarker: f, printOpeningTagPrefix: F, printOpeningTag: _ } = ur(), { printImgSrcset: w, printClassNames: E } = Tg(), { printVueFor: N, printVueBindings: x, isVueEventBindingExpression: I } = Bg(), { isScriptLikeTag: P, isVueNonHtmlBlock: $, inferScriptParser: D, htmlTrimPreserveIndentation: T, dedentString: m, unescapeQuoteEntities: C, isVueSlotAttribute: o, isVueSfcBindingsAttribute: d, getTextValueParts: v } = Rt(), S = Lo();
                function b(k, M, R) {
                    let q = (ee)=>new RegExp(ee.join("|")).test(k.fullName), J = ()=>C(k.value), L = !1, Q = (ee, ce)=>{
                        let W = ee.type === "NGRoot" ? ee.node.type === "NGMicrosyntax" && ee.node.body.length === 1 && ee.node.body[0].type === "NGMicrosyntaxExpression" ? ee.node.body[0].expression : ee.node : ee.type === "JsExpressionRoot" ? ee.node : ee;
                        W && (W.type === "ObjectExpression" || W.type === "ArrayExpression" || ce.parser === "__vue_expression" && (W.type === "TemplateLiteral" || W.type === "StringLiteral")) && (L = !0);
                    }, V = (ee)=>s(ee), j = function(ee) {
                        let ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                        return s([
                            n([
                                l,
                                ee
                            ]),
                            ce ? l : ""
                        ]);
                    }, Y = (ee)=>L ? V(ee) : j(ee), ie = (ee, ce)=>M(ee, Object.assign({
                            __onHtmlBindingRoot: Q,
                            __embeddedInHtml: !0
                        }, ce));
                    if (k.fullName === "srcset" && (k.parent.fullName === "img" || k.parent.fullName === "source")) return j(w(J()));
                    if (k.fullName === "class" && !R.parentParser) {
                        let ee = J();
                        if (!ee.includes("{{")) return E(ee);
                    }
                    if (k.fullName === "style" && !R.parentParser) {
                        let ee = J();
                        if (!ee.includes("{{")) return j(ie(ee, {
                            parser: "css",
                            __isHTMLStyleAttribute: !0
                        }));
                    }
                    if (R.parser === "vue") {
                        if (k.fullName === "v-for") return N(J(), ie);
                        if (o(k) || d(k, R)) return x(J(), ie);
                        let ee = [
                            "^@",
                            "^v-on:"
                        ], ce = [
                            "^:",
                            "^v-bind:"
                        ], W = [
                            "^v-"
                        ];
                        if (q(ee)) {
                            let K = J(), de = I(K) ? "__js_expression" : R.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
                            return Y(ie(K, {
                                parser: de
                            }));
                        }
                        if (q(ce)) return Y(ie(J(), {
                            parser: "__vue_expression"
                        }));
                        if (q(W)) return Y(ie(J(), {
                            parser: "__js_expression"
                        }));
                    }
                    if (R.parser === "angular") {
                        let ee = (z, U)=>ie(z, Object.assign(Object.assign({}, U), {}, {
                                trailingComma: "none"
                            })), ce = [
                            "^\\*"
                        ], W = [
                            "^\\(.+\\)$",
                            "^on-"
                        ], K = [
                            "^\\[.+\\]$",
                            "^bind(on)?-",
                            "^ng-(if|show|hide|class|style)$"
                        ], de = [
                            "^i18n(-.+)?$"
                        ];
                        if (q(W)) return Y(ee(J(), {
                            parser: "__ng_action"
                        }));
                        if (q(K)) return Y(ee(J(), {
                            parser: "__ng_binding"
                        }));
                        if (q(de)) {
                            let z = J().trim();
                            return j(i(v(k, z)), !z.includes("@@"));
                        }
                        if (q(ce)) return Y(ee(J(), {
                            parser: "__ng_directive"
                        }));
                        let ue = /{{(.+?)}}/s, Fe = J();
                        if (ue.test(Fe)) {
                            let z = [];
                            for (let [U, Z] of Fe.split(ue).entries())if (U % 2 === 0) z.push(y(Z));
                            else try {
                                z.push(s([
                                    "{{",
                                    n([
                                        u,
                                        ee(Z, {
                                            parser: "__ng_interpolation",
                                            __isInHtmlInterpolation: !0
                                        })
                                    ]),
                                    u,
                                    "}}"
                                ]));
                            } catch  {
                                z.push("{{", y(Z), "}}");
                            }
                            return s(z);
                        }
                    }
                    return null;
                }
                function B(k, M, R, q) {
                    let J = k.getValue();
                    switch(J.type){
                        case "element":
                            if (P(J) || J.type === "interpolation") return;
                            if (!J.isSelfClosing && $(J, q)) {
                                let L = D(J, q);
                                if (!L) return;
                                let Q = S(J, q), V = /^\s*$/.test(Q), j = "";
                                return V || (j = R(T(Q), {
                                    parser: L,
                                    __embeddedInHtml: !0
                                }, {
                                    stripTrailingHardline: !0
                                }), V = j === ""), [
                                    F(J, q),
                                    s(_(k, q, M)),
                                    V ? "" : a,
                                    j,
                                    V ? "" : a,
                                    g(J, q),
                                    c(J, q)
                                ];
                            }
                            break;
                        case "text":
                            if (P(J.parent)) {
                                let L = D(J.parent, q);
                                if (L) {
                                    let Q = L === "markdown" ? m(J.value.replace(/^[^\S\n]*\n/, "")) : J.value, V = {
                                        parser: L,
                                        __embeddedInHtml: !0
                                    };
                                    if (q.parser === "html" && L === "babel") {
                                        let j = "script", { attrMap: Y } = J.parent;
                                        Y && (Y.type === "module" || Y.type === "text/babel" && Y["data-type"] === "module") && (j = "module"), V.__babelSourceType = j;
                                    }
                                    return [
                                        t,
                                        F(J, q),
                                        R(Q, V, {
                                            stripTrailingHardline: !0
                                        }),
                                        c(J, q)
                                    ];
                                }
                            } else if (J.parent.type === "interpolation") {
                                let L = {
                                    __isInHtmlInterpolation: !0,
                                    __embeddedInHtml: !0
                                };
                                return q.parser === "angular" ? (L.parser = "__ng_interpolation", L.trailingComma = "none") : q.parser === "vue" ? L.parser = q.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : L.parser = "__js_expression", [
                                    n([
                                        u,
                                        R(J.value, L, {
                                            stripTrailingHardline: !0
                                        })
                                    ]),
                                    J.parent.next && f(J.parent.next) ? " " : u
                                ];
                            }
                            break;
                        case "attribute":
                            {
                                if (!J.value) break;
                                if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(q.originalText.slice(J.valueSpan.start.offset, J.valueSpan.end.offset))) return [
                                    J.rawName,
                                    "=",
                                    J.value
                                ];
                                if (q.parser === "lwc" && /^{.*}$/s.test(q.originalText.slice(J.valueSpan.start.offset, J.valueSpan.end.offset))) return [
                                    J.rawName,
                                    "=",
                                    J.value
                                ];
                                let L = b(J, (Q, V)=>R(Q, Object.assign({
                                        __isInHtmlAttribute: !0,
                                        __embeddedInHtml: !0
                                    }, V), {
                                        stripTrailingHardline: !0
                                    }), q);
                                if (L) return [
                                    J.rawName,
                                    '="',
                                    s(p(L, (Q)=>typeof Q == "string" ? Q.replace(/"/g, "&quot;") : Q)),
                                    '"'
                                ];
                                break;
                            }
                        case "front-matter":
                            return h(J, R);
                    }
                }
                r.exports = B;
            }
        }), Oo = te({
            "src/language-html/print/children.js" (e, r) {
                "use strict";
                ne();
                var { builders: { breakParent: t, group: s, ifBreak: a, line: n, softline: u, hardline: i }, utils: { replaceTextEndOfLine: l } } = qe(), { locStart: p, locEnd: y } = au(), { forceBreakChildren: h, forceNextEmptyLine: g, isTextLikeNode: c, hasPrettierIgnore: f, preferHardlineAsLeadingSpaces: F } = Rt(), { printOpeningTagPrefix: _, needsToBorrowNextOpeningTagStartMarker: w, printOpeningTagStartMarker: E, needsToBorrowPrevClosingTagEndMarker: N, printClosingTagEndMarker: x, printClosingTagSuffix: I, needsToBorrowParentClosingTagStartMarker: P } = ur();
                function $(m, C, o) {
                    let d = m.getValue();
                    return f(d) ? [
                        _(d, C),
                        ...l(C.originalText.slice(p(d) + (d.prev && w(d.prev) ? E(d).length : 0), y(d) - (d.next && N(d.next) ? x(d, C).length : 0))),
                        I(d, C)
                    ] : o();
                }
                function D(m, C) {
                    return c(m) && c(C) ? m.isTrailingSpaceSensitive ? m.hasTrailingSpaces ? F(C) ? i : n : "" : F(C) ? i : u : w(m) && (f(C) || C.firstChild || C.isSelfClosing || C.type === "element" && C.attrs.length > 0) || m.type === "element" && m.isSelfClosing && N(C) ? "" : !C.isLeadingSpaceSensitive || F(C) || N(C) && m.lastChild && P(m.lastChild) && m.lastChild.lastChild && P(m.lastChild.lastChild) ? i : C.hasLeadingSpaces ? n : u;
                }
                function T(m, C, o) {
                    let d = m.getValue();
                    if (h(d)) return [
                        t,
                        ...m.map((S)=>{
                            let b = S.getValue(), B = b.prev ? D(b.prev, b) : "";
                            return [
                                B ? [
                                    B,
                                    g(b.prev) ? i : ""
                                ] : "",
                                $(S, C, o)
                            ];
                        }, "children")
                    ];
                    let v = d.children.map(()=>Symbol(""));
                    return m.map((S, b)=>{
                        let B = S.getValue();
                        if (c(B)) {
                            if (B.prev && c(B.prev)) {
                                let Q = D(B.prev, B);
                                if (Q) return g(B.prev) ? [
                                    i,
                                    i,
                                    $(S, C, o)
                                ] : [
                                    Q,
                                    $(S, C, o)
                                ];
                            }
                            return $(S, C, o);
                        }
                        let k = [], M = [], R = [], q = [], J = B.prev ? D(B.prev, B) : "", L = B.next ? D(B, B.next) : "";
                        return J && (g(B.prev) ? k.push(i, i) : J === i ? k.push(i) : c(B.prev) ? M.push(J) : M.push(a("", u, {
                            groupId: v[b - 1]
                        }))), L && (g(B) ? c(B.next) && q.push(i, i) : L === i ? c(B.next) && q.push(i) : R.push(L)), [
                            ...k,
                            s([
                                ...M,
                                s([
                                    $(S, C, o),
                                    ...R
                                ], {
                                    id: v[b]
                                })
                            ]),
                            ...q
                        ];
                    }, "children");
                }
                r.exports = {
                    printChildren: T
                };
            }
        }), wg = te({
            "src/language-html/print/element.js" (e, r) {
                "use strict";
                ne();
                var { builders: { breakParent: t, dedentToRoot: s, group: a, ifBreak: n, indentIfBreak: u, indent: i, line: l, softline: p }, utils: { replaceTextEndOfLine: y } } = qe(), h = Lo(), { shouldPreserveContent: g, isScriptLikeTag: c, isVueCustomBlock: f, countParents: F, forceBreakContent: _ } = Rt(), { printOpeningTagPrefix: w, printOpeningTag: E, printClosingTagSuffix: N, printClosingTag: x, needsToBorrowPrevClosingTagEndMarker: I, needsToBorrowLastChildClosingTagEndMarker: P } = ur(), { printChildren: $ } = Oo();
                function D(T, m, C) {
                    let o = T.getValue();
                    if (g(o, m)) return [
                        w(o, m),
                        a(E(T, m, C)),
                        ...y(h(o, m)),
                        ...x(o, m),
                        N(o, m)
                    ];
                    let d = o.children.length === 1 && o.firstChild.type === "interpolation" && o.firstChild.isLeadingSpaceSensitive && !o.firstChild.hasLeadingSpaces && o.lastChild.isTrailingSpaceSensitive && !o.lastChild.hasTrailingSpaces, v = Symbol("element-attr-group-id"), S = (M)=>a([
                            a(E(T, m, C), {
                                id: v
                            }),
                            M,
                            x(o, m)
                        ]), b = (M)=>d ? u(M, {
                            groupId: v
                        }) : (c(o) || f(o, m)) && o.parent.type === "root" && m.parser === "vue" && !m.vueIndentScriptAndStyle ? M : i(M), B = ()=>d ? n(p, "", {
                            groupId: v
                        }) : o.firstChild.hasLeadingSpaces && o.firstChild.isLeadingSpaceSensitive ? l : o.firstChild.type === "text" && o.isWhitespaceSensitive && o.isIndentationSensitive ? s(p) : p, k = ()=>(o.next ? I(o.next) : P(o.parent)) ? o.lastChild.hasTrailingSpaces && o.lastChild.isTrailingSpaceSensitive ? " " : "" : d ? n(p, "", {
                            groupId: v
                        }) : o.lastChild.hasTrailingSpaces && o.lastChild.isTrailingSpaceSensitive ? l : (o.lastChild.type === "comment" || o.lastChild.type === "text" && o.isWhitespaceSensitive && o.isIndentationSensitive) && new RegExp(`\\n[\\t ]{${m.tabWidth * F(T, (R)=>R.parent && R.parent.type !== "root")}}$`).test(o.lastChild.value) ? "" : p;
                    return o.children.length === 0 ? S(o.hasDanglingSpaces && o.isDanglingSpaceSensitive ? l : "") : S([
                        _(o) ? t : "",
                        b([
                            B(),
                            $(T, m, C)
                        ]),
                        k()
                    ]);
                }
                r.exports = {
                    printElement: D
                };
            }
        }), _g = te({
            "src/language-html/printer-html.js" (e, r) {
                "use strict";
                ne();
                var { builders: { fill: t, group: s, hardline: a, literalline: n }, utils: { cleanDoc: u, getDocParts: i, isConcat: l, replaceTextEndOfLine: p } } = qe(), y = gg(), { countChars: h, unescapeQuoteEntities: g, getTextValueParts: c } = Rt(), f = Sg(), { insertPragma: F } = xg(), { locStart: _, locEnd: w } = au(), E = Ng(), { printClosingTagSuffix: N, printClosingTagEnd: x, printOpeningTagPrefix: I, printOpeningTagStart: P } = ur(), { printElement: $ } = wg(), { printChildren: D } = Oo();
                function T(m, C, o) {
                    let d = m.getValue();
                    switch(d.type){
                        case "front-matter":
                            return p(d.raw);
                        case "root":
                            return C.__onHtmlRoot && C.__onHtmlRoot(d), [
                                s(D(m, C, o)),
                                a
                            ];
                        case "element":
                        case "ieConditionalComment":
                            return $(m, C, o);
                        case "ieConditionalStartComment":
                        case "ieConditionalEndComment":
                            return [
                                P(d),
                                x(d)
                            ];
                        case "interpolation":
                            return [
                                P(d, C),
                                ...m.map(o, "children"),
                                x(d, C)
                            ];
                        case "text":
                            {
                                if (d.parent.type === "interpolation") {
                                    let S = /\n[^\S\n]*$/, b = S.test(d.value), B = b ? d.value.replace(S, "") : d.value;
                                    return [
                                        ...p(B),
                                        b ? a : ""
                                    ];
                                }
                                let v = u([
                                    I(d, C),
                                    ...c(d),
                                    N(d, C)
                                ]);
                                return l(v) || v.type === "fill" ? t(i(v)) : v;
                            }
                        case "docType":
                            return [
                                s([
                                    P(d, C),
                                    " ",
                                    d.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")
                                ]),
                                x(d, C)
                            ];
                        case "comment":
                            return [
                                I(d, C),
                                ...p(C.originalText.slice(_(d), w(d)), n),
                                N(d, C)
                            ];
                        case "attribute":
                            {
                                if (d.value === null) return d.rawName;
                                let v = g(d.value), S = h(v, "'"), b = h(v, '"'), B = S < b ? "'" : '"';
                                return [
                                    d.rawName,
                                    "=",
                                    B,
                                    ...p(B === '"' ? v.replace(/"/g, "&quot;") : v.replace(/'/g, "&apos;")),
                                    B
                                ];
                            }
                        default:
                            throw new Error(`Unexpected node type ${d.type}`);
                    }
                }
                r.exports = {
                    preprocess: f,
                    print: T,
                    insertPragma: F,
                    massageAstNode: y,
                    embed: E
                };
            }
        }), Pg = te({
            "src/language-html/options.js" (e, r) {
                "use strict";
                ne();
                var t = Mt(), s = "HTML";
                r.exports = {
                    bracketSameLine: t.bracketSameLine,
                    htmlWhitespaceSensitivity: {
                        since: "1.15.0",
                        category: s,
                        type: "choice",
                        default: "css",
                        description: "How to handle whitespaces in HTML.",
                        choices: [
                            {
                                value: "css",
                                description: "Respect the default value of CSS display property."
                            },
                            {
                                value: "strict",
                                description: "Whitespaces are considered sensitive."
                            },
                            {
                                value: "ignore",
                                description: "Whitespaces are considered insensitive."
                            }
                        ]
                    },
                    singleAttributePerLine: t.singleAttributePerLine,
                    vueIndentScriptAndStyle: {
                        since: "1.19.0",
                        category: s,
                        type: "boolean",
                        default: !1,
                        description: "Indent script and style tags in Vue files."
                    }
                };
            }
        }), Ig = te({
            "src/language-html/parsers.js" () {
                ne();
            }
        }), On = te({
            "node_modules/linguist-languages/data/HTML.json" (e, r) {
                r.exports = {
                    name: "HTML",
                    type: "markup",
                    tmScope: "text.html.basic",
                    aceMode: "html",
                    codemirrorMode: "htmlmixed",
                    codemirrorMimeType: "text/html",
                    color: "#e34c26",
                    aliases: [
                        "xhtml"
                    ],
                    extensions: [
                        ".html",
                        ".hta",
                        ".htm",
                        ".html.hl",
                        ".inc",
                        ".xht",
                        ".xhtml"
                    ],
                    languageId: 146
                };
            }
        }), kg = te({
            "node_modules/linguist-languages/data/Vue.json" (e, r) {
                r.exports = {
                    name: "Vue",
                    type: "markup",
                    color: "#41b883",
                    extensions: [
                        ".vue"
                    ],
                    tmScope: "text.html.vue",
                    aceMode: "html",
                    languageId: 391
                };
            }
        }), Lg = te({
            "src/language-html/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = _g(), a = Pg(), n = Ig(), u = [
                    t(On(), ()=>({
                            name: "Angular",
                            since: "1.15.0",
                            parsers: [
                                "angular"
                            ],
                            vscodeLanguageIds: [
                                "html"
                            ],
                            extensions: [
                                ".component.html"
                            ],
                            filenames: []
                        })),
                    t(On(), (l)=>({
                            since: "1.15.0",
                            parsers: [
                                "html"
                            ],
                            vscodeLanguageIds: [
                                "html"
                            ],
                            extensions: [
                                ...l.extensions,
                                ".mjml"
                            ]
                        })),
                    t(On(), ()=>({
                            name: "Lightning Web Components",
                            since: "1.17.0",
                            parsers: [
                                "lwc"
                            ],
                            vscodeLanguageIds: [
                                "html"
                            ],
                            extensions: [],
                            filenames: []
                        })),
                    t(kg(), ()=>({
                            since: "1.10.0",
                            parsers: [
                                "vue"
                            ],
                            vscodeLanguageIds: [
                                "vue"
                            ]
                        }))
                ], i = {
                    html: s
                };
                r.exports = {
                    languages: u,
                    printers: i,
                    options: a,
                    parsers: n
                };
            }
        }), Og = te({
            "src/language-yaml/pragma.js" (e, r) {
                "use strict";
                ne();
                function t(n) {
                    return /^\s*@(?:prettier|format)\s*$/.test(n);
                }
                function s(n) {
                    return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(n);
                }
                function a(n) {
                    return `# @format

${n}`;
                }
                r.exports = {
                    isPragma: t,
                    hasPragma: s,
                    insertPragma: a
                };
            }
        }), jg = te({
            "src/language-yaml/loc.js" (e, r) {
                "use strict";
                ne();
                function t(a) {
                    return a.position.start.offset;
                }
                function s(a) {
                    return a.position.end.offset;
                }
                r.exports = {
                    locStart: t,
                    locEnd: s
                };
            }
        }), qg = te({
            "src/language-yaml/embed.js" (e, r) {
                "use strict";
                ne();
                function t(s, a, n, u) {
                    if (s.getValue().type === "root" && u.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint|lintstaged)rc$/.test(u.filepath)) return n(u.originalText, Object.assign(Object.assign({}, u), {}, {
                        parser: "json"
                    }));
                }
                r.exports = t;
            }
        }), $t = te({
            "src/language-yaml/utils.js" (e, r) {
                "use strict";
                ne();
                var { getLast: t, isNonEmptyArray: s } = Ue();
                function a(D, T) {
                    let m = 0, C = D.stack.length - 1;
                    for(let o = 0; o < C; o++){
                        let d = D.stack[o];
                        n(d) && T(d) && m++;
                    }
                    return m;
                }
                function n(D, T) {
                    return D && typeof D.type == "string" && (!T || T.includes(D.type));
                }
                function u(D, T, m) {
                    return T("children" in D ? Object.assign(Object.assign({}, D), {}, {
                        children: D.children.map((C)=>u(C, T, D))
                    }) : D, m);
                }
                function i(D, T, m) {
                    Object.defineProperty(D, T, {
                        get: m,
                        enumerable: !1
                    });
                }
                function l(D, T) {
                    let m = 0, C = T.length;
                    for(let o = D.position.end.offset - 1; o < C; o++){
                        let d = T[o];
                        if (d === `
` && m++, m === 1 && /\S/.test(d)) return !1;
                        if (m === 2) return !0;
                    }
                    return !1;
                }
                function p(D) {
                    switch(D.getValue().type){
                        case "tag":
                        case "anchor":
                        case "comment":
                            return !1;
                    }
                    let m = D.stack.length;
                    for(let C = 1; C < m; C++){
                        let o = D.stack[C], d = D.stack[C - 1];
                        if (Array.isArray(d) && typeof o == "number" && o !== d.length - 1) return !1;
                    }
                    return !0;
                }
                function y(D) {
                    return s(D.children) ? y(t(D.children)) : D;
                }
                function h(D) {
                    return D.value.trim() === "prettier-ignore";
                }
                function g(D) {
                    let T = D.getValue();
                    if (T.type === "documentBody") {
                        let m = D.getParentNode();
                        return N(m.head) && h(t(m.head.endComments));
                    }
                    return F(T) && h(t(T.leadingComments));
                }
                function c(D) {
                    return !s(D.children) && !f(D);
                }
                function f(D) {
                    return F(D) || _(D) || w(D) || E(D) || N(D);
                }
                function F(D) {
                    return s(D == null ? void 0 : D.leadingComments);
                }
                function _(D) {
                    return s(D == null ? void 0 : D.middleComments);
                }
                function w(D) {
                    return D == null ? void 0 : D.indicatorComment;
                }
                function E(D) {
                    return D == null ? void 0 : D.trailingComment;
                }
                function N(D) {
                    return s(D == null ? void 0 : D.endComments);
                }
                function x(D) {
                    let T = [], m;
                    for (let C of D.split(/( +)/))C !== " " ? m === " " ? T.push(C) : T.push((T.pop() || "") + C) : m === void 0 && T.unshift(""), m = C;
                    return m === " " && T.push((T.pop() || "") + " "), T[0] === "" && (T.shift(), T.unshift(" " + (T.shift() || ""))), T;
                }
                function I(D, T, m) {
                    let C = T.split(`
`).map((o, d, v)=>d === 0 && d === v.length - 1 ? o : d !== 0 && d !== v.length - 1 ? o.trim() : d === 0 ? o.trimEnd() : o.trimStart());
                    return m.proseWrap === "preserve" ? C.map((o)=>o.length === 0 ? [] : [
                            o
                        ]) : C.map((o)=>o.length === 0 ? [] : x(o)).reduce((o, d, v)=>v !== 0 && C[v - 1].length > 0 && d.length > 0 && !(D === "quoteDouble" && t(t(o)).endsWith("\\")) ? [
                            ...o.slice(0, -1),
                            [
                                ...t(o),
                                ...d
                            ]
                        ] : [
                            ...o,
                            d
                        ], []).map((o)=>m.proseWrap === "never" ? [
                            o.join(" ")
                        ] : o);
                }
                function P(D, T) {
                    let { parentIndent: m, isLastDescendant: C, options: o } = T, d = D.position.start.line === D.position.end.line ? "" : o.originalText.slice(D.position.start.offset, D.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], v;
                    if (D.indent === null) {
                        let B = d.match(/^(?<leadingSpace> *)[^\n\r ]/m);
                        v = B ? B.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
                    } else v = D.indent - 1 + m;
                    let S = d.split(`
`).map((B)=>B.slice(v));
                    if (o.proseWrap === "preserve" || D.type === "blockLiteral") return b(S.map((B)=>B.length === 0 ? [] : [
                            B
                        ]));
                    return b(S.map((B)=>B.length === 0 ? [] : x(B)).reduce((B, k, M)=>M !== 0 && S[M - 1].length > 0 && k.length > 0 && !/^\s/.test(k[0]) && !/^\s|\s$/.test(t(B)) ? [
                            ...B.slice(0, -1),
                            [
                                ...t(B),
                                ...k
                            ]
                        ] : [
                            ...B,
                            k
                        ], []).map((B)=>B.reduce((k, M)=>k.length > 0 && /\s$/.test(t(k)) ? [
                                ...k.slice(0, -1),
                                t(k) + " " + M
                            ] : [
                                ...k,
                                M
                            ], [])).map((B)=>o.proseWrap === "never" ? [
                            B.join(" ")
                        ] : B));
                    function b(B) {
                        if (D.chomping === "keep") return t(B).length === 0 ? B.slice(0, -1) : B;
                        let k = 0;
                        for(let M = B.length - 1; M >= 0 && B[M].length === 0; M--)k++;
                        return k === 0 ? B : k >= 2 && !C ? B.slice(0, -(k - 1)) : B.slice(0, -k);
                    }
                }
                function $(D) {
                    if (!D) return !0;
                    switch(D.type){
                        case "plain":
                        case "quoteDouble":
                        case "quoteSingle":
                        case "alias":
                        case "flowMapping":
                        case "flowSequence":
                            return !0;
                        default:
                            return !1;
                    }
                }
                r.exports = {
                    getLast: t,
                    getAncestorCount: a,
                    isNode: n,
                    isEmptyNode: c,
                    isInlineNode: $,
                    mapNode: u,
                    defineShortcut: i,
                    isNextLineEmpty: l,
                    isLastDescendantNode: p,
                    getBlockValueLineContents: P,
                    getFlowScalarLineContents: I,
                    getLastDescendantNode: y,
                    hasPrettierIgnore: g,
                    hasLeadingComments: F,
                    hasMiddleComments: _,
                    hasIndicatorComment: w,
                    hasTrailingComment: E,
                    hasEndComments: N
                };
            }
        }), Mg = te({
            "src/language-yaml/print-preprocess.js" (e, r) {
                "use strict";
                ne();
                var { defineShortcut: t, mapNode: s } = $t();
                function a(u) {
                    return s(u, n);
                }
                function n(u) {
                    switch(u.type){
                        case "document":
                            t(u, "head", ()=>u.children[0]), t(u, "body", ()=>u.children[1]);
                            break;
                        case "documentBody":
                        case "sequenceItem":
                        case "flowSequenceItem":
                        case "mappingKey":
                        case "mappingValue":
                            t(u, "content", ()=>u.children[0]);
                            break;
                        case "mappingItem":
                        case "flowMappingItem":
                            t(u, "key", ()=>u.children[0]), t(u, "value", ()=>u.children[1]);
                            break;
                    }
                    return u;
                }
                r.exports = a;
            }
        }), Mr = te({
            "src/language-yaml/print/misc.js" (e, r) {
                "use strict";
                ne();
                var { builders: { softline: t, align: s } } = qe(), { hasEndComments: a, isNextLineEmpty: n, isNode: u } = $t(), i = new WeakMap;
                function l(h, g) {
                    let c = h.getValue(), f = h.stack[0], F;
                    return i.has(f) ? F = i.get(f) : (F = new Set, i.set(f, F)), !F.has(c.position.end.line) && (F.add(c.position.end.line), n(c, g) && !p(h.getParentNode())) ? t : "";
                }
                function p(h) {
                    return a(h) && !u(h, [
                        "documentHead",
                        "documentBody",
                        "flowMapping",
                        "flowSequence"
                    ]);
                }
                function y(h, g) {
                    return s(" ".repeat(h), g);
                }
                r.exports = {
                    alignWithSpaces: y,
                    shouldPrintEndComments: p,
                    printNextEmptyLine: l
                };
            }
        }), Rg = te({
            "src/language-yaml/print/flow-mapping-sequence.js" (e, r) {
                "use strict";
                ne();
                var { builders: { ifBreak: t, line: s, softline: a, hardline: n, join: u } } = qe(), { isEmptyNode: i, getLast: l, hasEndComments: p } = $t(), { printNextEmptyLine: y, alignWithSpaces: h } = Mr();
                function g(f, F, _) {
                    let w = f.getValue(), E = w.type === "flowMapping", N = E ? "{" : "[", x = E ? "}" : "]", I = a;
                    E && w.children.length > 0 && _.bracketSpacing && (I = s);
                    let P = l(w.children), $ = P && P.type === "flowMappingItem" && i(P.key) && i(P.value);
                    return [
                        N,
                        h(_.tabWidth, [
                            I,
                            c(f, F, _),
                            _.trailingComma === "none" ? "" : t(","),
                            p(w) ? [
                                n,
                                u(n, f.map(F, "endComments"))
                            ] : ""
                        ]),
                        $ ? "" : I,
                        x
                    ];
                }
                function c(f, F, _) {
                    let w = f.getValue();
                    return f.map((N, x)=>[
                            F(),
                            x === w.children.length - 1 ? "" : [
                                ",",
                                s,
                                w.children[x].position.start.line !== w.children[x + 1].position.start.line ? y(N, _.originalText) : ""
                            ]
                        ], "children");
                }
                r.exports = {
                    printFlowMapping: g,
                    printFlowSequence: g
                };
            }
        }), $g = te({
            "src/language-yaml/print/mapping-item.js" (e, r) {
                "use strict";
                ne();
                var { builders: { conditionalGroup: t, group: s, hardline: a, ifBreak: n, join: u, line: i } } = qe(), { hasLeadingComments: l, hasMiddleComments: p, hasTrailingComment: y, hasEndComments: h, isNode: g, isEmptyNode: c, isInlineNode: f } = $t(), { alignWithSpaces: F } = Mr();
                function _(x, I, P, $, D) {
                    let { key: T, value: m } = x, C = c(T), o = c(m);
                    if (C && o) return ": ";
                    let d = $("key"), v = E(x) ? " " : "";
                    if (o) return x.type === "flowMappingItem" && I.type === "flowMapping" ? d : x.type === "mappingItem" && w(T.content, D) && !y(T.content) && (!I.tag || I.tag.value !== "tag:yaml.org,2002:set") ? [
                        d,
                        v,
                        ":"
                    ] : [
                        "? ",
                        F(2, d)
                    ];
                    let S = $("value");
                    if (C) return [
                        ": ",
                        F(2, S)
                    ];
                    if (l(m) || !f(T.content)) return [
                        "? ",
                        F(2, d),
                        a,
                        u("", P.map($, "value", "leadingComments").map((q)=>[
                                q,
                                a
                            ])),
                        ": ",
                        F(2, S)
                    ];
                    if (N(T.content) && !l(T.content) && !p(T.content) && !y(T.content) && !h(T) && !l(m.content) && !p(m.content) && !h(m) && w(m.content, D)) return [
                        d,
                        v,
                        ": ",
                        S
                    ];
                    let b = Symbol("mappingKey"), B = s([
                        n("? "),
                        s(F(2, d), {
                            id: b
                        })
                    ]), k = [
                        a,
                        ": ",
                        F(2, S)
                    ], M = [
                        v,
                        ":"
                    ];
                    l(m.content) || h(m) && m.content && !g(m.content, [
                        "mapping",
                        "sequence"
                    ]) || I.type === "mapping" && y(T.content) && f(m.content) || g(m.content, [
                        "mapping",
                        "sequence"
                    ]) && m.content.tag === null && m.content.anchor === null ? M.push(a) : m.content && M.push(i), M.push(S);
                    let R = F(D.tabWidth, M);
                    return w(T.content, D) && !l(T.content) && !p(T.content) && !h(T) ? t([
                        [
                            d,
                            R
                        ]
                    ]) : t([
                        [
                            B,
                            n(k, R, {
                                groupId: b
                            })
                        ]
                    ]);
                }
                function w(x, I) {
                    if (!x) return !0;
                    switch(x.type){
                        case "plain":
                        case "quoteSingle":
                        case "quoteDouble":
                            break;
                        case "alias":
                            return !0;
                        default:
                            return !1;
                    }
                    if (I.proseWrap === "preserve") return x.position.start.line === x.position.end.line;
                    if (/\\$/m.test(I.originalText.slice(x.position.start.offset, x.position.end.offset))) return !1;
                    switch(I.proseWrap){
                        case "never":
                            return !x.value.includes(`
`);
                        case "always":
                            return !/[\n ]/.test(x.value);
                        default:
                            return !1;
                    }
                }
                function E(x) {
                    return x.key.content && x.key.content.type === "alias";
                }
                function N(x) {
                    if (!x) return !0;
                    switch(x.type){
                        case "plain":
                        case "quoteDouble":
                        case "quoteSingle":
                            return x.position.start.line === x.position.end.line;
                        case "alias":
                            return !0;
                        default:
                            return !1;
                    }
                }
                r.exports = _;
            }
        }), Vg = te({
            "src/language-yaml/print/block.js" (e, r) {
                "use strict";
                ne();
                var { builders: { dedent: t, dedentToRoot: s, fill: a, hardline: n, join: u, line: i, literalline: l, markAsRoot: p }, utils: { getDocParts: y } } = qe(), { getAncestorCount: h, getBlockValueLineContents: g, hasIndicatorComment: c, isLastDescendantNode: f, isNode: F } = $t(), { alignWithSpaces: _ } = Mr();
                function w(E, N, x) {
                    let I = E.getValue(), P = h(E, (C)=>F(C, [
                            "sequence",
                            "mapping"
                        ])), $ = f(E), D = [
                        I.type === "blockFolded" ? ">" : "|"
                    ];
                    I.indent !== null && D.push(I.indent.toString()), I.chomping !== "clip" && D.push(I.chomping === "keep" ? "+" : "-"), c(I) && D.push(" ", N("indicatorComment"));
                    let T = g(I, {
                        parentIndent: P,
                        isLastDescendant: $,
                        options: x
                    }), m = [];
                    for (let [C, o] of T.entries())C === 0 && m.push(n), m.push(a(y(u(i, o)))), C !== T.length - 1 ? m.push(o.length === 0 ? n : p(l)) : I.chomping === "keep" && $ && m.push(s(o.length === 0 ? n : l));
                    return I.indent === null ? D.push(t(_(x.tabWidth, m))) : D.push(s(_(I.indent - 1 + P, m))), D;
                }
                r.exports = w;
            }
        }), Wg = te({
            "src/language-yaml/printer-yaml.js" (e, r) {
                "use strict";
                ne();
                var { builders: { breakParent: t, fill: s, group: a, hardline: n, join: u, line: i, lineSuffix: l, literalline: p }, utils: { getDocParts: y, replaceTextEndOfLine: h } } = qe(), { isPreviousLineEmpty: g } = Ue(), { insertPragma: c, isPragma: f } = Og(), { locStart: F } = jg(), _ = qg(), { getFlowScalarLineContents: w, getLastDescendantNode: E, hasLeadingComments: N, hasMiddleComments: x, hasTrailingComment: I, hasEndComments: P, hasPrettierIgnore: $, isLastDescendantNode: D, isNode: T, isInlineNode: m } = $t(), C = Mg(), { alignWithSpaces: o, printNextEmptyLine: d, shouldPrintEndComments: v } = Mr(), { printFlowMapping: S, printFlowSequence: b } = Rg(), B = $g(), k = Vg();
                function M(j, Y, ie) {
                    let ee = j.getValue(), ce = [];
                    ee.type !== "mappingValue" && N(ee) && ce.push([
                        u(n, j.map(ie, "leadingComments")),
                        n
                    ]);
                    let { tag: W, anchor: K } = ee;
                    W && ce.push(ie("tag")), W && K && ce.push(" "), K && ce.push(ie("anchor"));
                    let de = "";
                    T(ee, [
                        "mapping",
                        "sequence",
                        "comment",
                        "directive",
                        "mappingItem",
                        "sequenceItem"
                    ]) && !D(j) && (de = d(j, Y.originalText)), (W || K) && (T(ee, [
                        "sequence",
                        "mapping"
                    ]) && !x(ee) ? ce.push(n) : ce.push(" ")), x(ee) && ce.push([
                        ee.middleComments.length === 1 ? "" : n,
                        u(n, j.map(ie, "middleComments")),
                        n
                    ]);
                    let ue = j.getParentNode();
                    return $(j) ? ce.push(h(Y.originalText.slice(ee.position.start.offset, ee.position.end.offset).trimEnd(), p)) : ce.push(a(R(ee, ue, j, Y, ie))), I(ee) && !T(ee, [
                        "document",
                        "documentHead"
                    ]) && ce.push(l([
                        ee.type === "mappingValue" && !ee.content ? "" : " ",
                        ue.type === "mappingKey" && j.getParentNode(2).type === "mapping" && m(ee) ? "" : t,
                        ie("trailingComment")
                    ])), v(ee) && ce.push(o(ee.type === "sequenceItem" ? 2 : 0, [
                        n,
                        u(n, j.map((Fe)=>[
                                g(Y.originalText, Fe.getValue(), F) ? n : "",
                                ie()
                            ], "endComments"))
                    ])), ce.push(de), ce;
                }
                function R(j, Y, ie, ee, ce) {
                    switch(j.type){
                        case "root":
                            {
                                let { children: W } = j, K = [];
                                ie.each((ue, Fe)=>{
                                    let z = W[Fe], U = W[Fe + 1];
                                    Fe !== 0 && K.push(n), K.push(ce()), J(z, U) ? (K.push(n, "..."), I(z) && K.push(" ", ce("trailingComment"))) : U && !I(U.head) && K.push(n, "---");
                                }, "children");
                                let de = E(j);
                                return (!T(de, [
                                    "blockLiteral",
                                    "blockFolded"
                                ]) || de.chomping !== "keep") && K.push(n), K;
                            }
                        case "document":
                            {
                                let W = Y.children[ie.getName() + 1], K = [];
                                return L(j, W, Y, ee) === "head" && ((j.head.children.length > 0 || j.head.endComments.length > 0) && K.push(ce("head")), I(j.head) ? K.push([
                                    "---",
                                    " ",
                                    ce([
                                        "head",
                                        "trailingComment"
                                    ])
                                ]) : K.push("---")), q(j) && K.push(ce("body")), u(n, K);
                            }
                        case "documentHead":
                            return u(n, [
                                ...ie.map(ce, "children"),
                                ...ie.map(ce, "endComments")
                            ]);
                        case "documentBody":
                            {
                                let { children: W, endComments: K } = j, de = "";
                                if (W.length > 0 && K.length > 0) {
                                    let ue = E(j);
                                    T(ue, [
                                        "blockFolded",
                                        "blockLiteral"
                                    ]) ? ue.chomping !== "keep" && (de = [
                                        n,
                                        n
                                    ]) : de = n;
                                }
                                return [
                                    u(n, ie.map(ce, "children")),
                                    de,
                                    u(n, ie.map(ce, "endComments"))
                                ];
                            }
                        case "directive":
                            return [
                                "%",
                                u(" ", [
                                    j.name,
                                    ...j.parameters
                                ])
                            ];
                        case "comment":
                            return [
                                "#",
                                j.value
                            ];
                        case "alias":
                            return [
                                "*",
                                j.value
                            ];
                        case "tag":
                            return ee.originalText.slice(j.position.start.offset, j.position.end.offset);
                        case "anchor":
                            return [
                                "&",
                                j.value
                            ];
                        case "plain":
                            return Q(j.type, ee.originalText.slice(j.position.start.offset, j.position.end.offset), ee);
                        case "quoteDouble":
                        case "quoteSingle":
                            {
                                let W = "'", K = '"', de = ee.originalText.slice(j.position.start.offset + 1, j.position.end.offset - 1);
                                if (j.type === "quoteSingle" && de.includes("\\") || j.type === "quoteDouble" && /\\[^"]/.test(de)) {
                                    let Fe = j.type === "quoteDouble" ? K : W;
                                    return [
                                        Fe,
                                        Q(j.type, de, ee),
                                        Fe
                                    ];
                                }
                                if (de.includes(K)) return [
                                    W,
                                    Q(j.type, j.type === "quoteDouble" ? de.replace(/\\"/g, K).replace(/'/g, W.repeat(2)) : de, ee),
                                    W
                                ];
                                if (de.includes(W)) return [
                                    K,
                                    Q(j.type, j.type === "quoteSingle" ? de.replace(/''/g, W) : de, ee),
                                    K
                                ];
                                let ue = ee.singleQuote ? W : K;
                                return [
                                    ue,
                                    Q(j.type, de, ee),
                                    ue
                                ];
                            }
                        case "blockFolded":
                        case "blockLiteral":
                            return k(ie, ce, ee);
                        case "mapping":
                        case "sequence":
                            return u(n, ie.map(ce, "children"));
                        case "sequenceItem":
                            return [
                                "- ",
                                o(2, j.content ? ce("content") : "")
                            ];
                        case "mappingKey":
                        case "mappingValue":
                            return j.content ? ce("content") : "";
                        case "mappingItem":
                        case "flowMappingItem":
                            return B(j, Y, ie, ce, ee);
                        case "flowMapping":
                            return S(ie, ce, ee);
                        case "flowSequence":
                            return b(ie, ce, ee);
                        case "flowSequenceItem":
                            return ce("content");
                        default:
                            throw new Error(`Unexpected node type ${j.type}`);
                    }
                }
                function q(j) {
                    return j.body.children.length > 0 || P(j.body);
                }
                function J(j, Y) {
                    return I(j) || Y && (Y.head.children.length > 0 || P(Y.head));
                }
                function L(j, Y, ie, ee) {
                    return ie.children[0] === j && /---(?:\s|$)/.test(ee.originalText.slice(F(j), F(j) + 4)) || j.head.children.length > 0 || P(j.head) || I(j.head) ? "head" : J(j, Y) ? !1 : Y ? "root" : !1;
                }
                function Q(j, Y, ie) {
                    let ee = w(j, Y, ie);
                    return u(n, ee.map((ce)=>s(y(u(i, ce)))));
                }
                function V(j, Y) {
                    if (T(Y)) switch(delete Y.position, Y.type){
                        case "comment":
                            if (f(Y.value)) return null;
                            break;
                        case "quoteDouble":
                        case "quoteSingle":
                            Y.type = "quote";
                            break;
                    }
                }
                r.exports = {
                    preprocess: C,
                    embed: _,
                    print: M,
                    massageAstNode: V,
                    insertPragma: c
                };
            }
        }), Hg = te({
            "src/language-yaml/options.js" (e, r) {
                "use strict";
                ne();
                var t = Mt();
                r.exports = {
                    bracketSpacing: t.bracketSpacing,
                    singleQuote: t.singleQuote,
                    proseWrap: t.proseWrap
                };
            }
        }), Gg = te({
            "src/language-yaml/parsers.js" () {
                ne();
            }
        }), Ug = te({
            "node_modules/linguist-languages/data/YAML.json" (e, r) {
                r.exports = {
                    name: "YAML",
                    type: "data",
                    color: "#cb171e",
                    tmScope: "source.yaml",
                    aliases: [
                        "yml"
                    ],
                    extensions: [
                        ".yml",
                        ".mir",
                        ".reek",
                        ".rviz",
                        ".sublime-syntax",
                        ".syntax",
                        ".yaml",
                        ".yaml-tmlanguage",
                        ".yaml.sed",
                        ".yml.mysql"
                    ],
                    filenames: [
                        ".clang-format",
                        ".clang-tidy",
                        ".gemrc",
                        "CITATION.cff",
                        "glide.lock",
                        "yarn.lock"
                    ],
                    aceMode: "yaml",
                    codemirrorMode: "yaml",
                    codemirrorMimeType: "text/x-yaml",
                    languageId: 407
                };
            }
        }), Jg = te({
            "src/language-yaml/index.js" (e, r) {
                "use strict";
                ne();
                var t = _t(), s = Wg(), a = Hg(), n = Gg(), u = [
                    t(Ug(), (i)=>({
                            since: "1.14.0",
                            parsers: [
                                "yaml"
                            ],
                            vscodeLanguageIds: [
                                "yaml",
                                "ansible",
                                "home-assistant"
                            ],
                            filenames: [
                                ...i.filenames.filter((l)=>l !== "yarn.lock"),
                                ".prettierrc",
                                ".stylelintrc",
                                ".lintstagedrc"
                            ]
                        }))
                ];
                r.exports = {
                    languages: u,
                    printers: {
                        yaml: s
                    },
                    options: a,
                    parsers: n
                };
            }
        }), zg = te({
            "src/languages.js" (e, r) {
                "use strict";
                ne(), r.exports = [
                    Bd(),
                    Ud(),
                    eg(),
                    ag(),
                    dg(),
                    Lg(),
                    Jg()
                ];
            }
        });
        ne();
        var { version: Xg } = Ia(), Ot = Gm(), { getSupportInfo: Kg } = Xn(), Yg = Um(), Qg = zg(), Zg = qe();
        function Nt(e) {
            let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            return function() {
                for(var t = arguments.length, s = new Array(t), a = 0; a < t; a++)s[a] = arguments[a];
                let n = s[r] || {}, u = n.plugins || [];
                return s[r] = Object.assign(Object.assign({}, n), {}, {
                    plugins: [
                        ...Qg,
                        ...Array.isArray(u) ? u : Object.values(u)
                    ]
                }), e(...s);
            };
        }
        var jn = Nt(Ot.formatWithCursor);
        jo.exports = {
            formatWithCursor: jn,
            format (e, r) {
                return jn(e, r).formatted;
            },
            check (e, r) {
                let { formatted: t } = jn(e, r);
                return t === e;
            },
            doc: Zg,
            getSupportInfo: Nt(Kg, 0),
            version: Xg,
            util: Yg,
            __debug: {
                parse: Nt(Ot.parse),
                formatAST: Nt(Ot.formatAST),
                formatDoc: Nt(Ot.formatDoc),
                printToDoc: Nt(Ot.printToDoc),
                printDocToString: Nt(Ot.printDocToString)
            }
        };
    });
    return e0();
});

},{}],"9q4ta":[function(require,module,exports,__globalThis) {
var global = arguments[3];
(function(e) {
    var i;
    module.exports = e();
})(function() {
    "use strict";
    var E = (l, h)=>()=>(h || l((h = {
                exports: {}
            }).exports, h), h.exports);
    var re = E((xd, Zr)=>{
        var Ct = function(l) {
            return l && l.Math == Math && l;
        };
        Zr.exports = Ct(typeof globalThis == "object" && globalThis) || Ct(typeof window == "object" && window) || Ct(typeof self == "object" && self) || Ct(typeof global == "object" && global) || function() {
            return this;
        }() || Function("return this")();
    });
    var ie = E((gd, ei)=>{
        ei.exports = function(l) {
            try {
                return !!l();
            } catch  {
                return !0;
            }
        };
    });
    var ye = E((Pd, ti)=>{
        var kh = ie();
        ti.exports = !kh(function() {
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] != 7;
        });
    });
    var bt = E((Ad, si)=>{
        var Dh = ie();
        si.exports = !Dh(function() {
            var l = (function() {}).bind();
            return typeof l != "function" || l.hasOwnProperty("prototype");
        });
    });
    var wt = E((Td, ri)=>{
        var Fh = bt(), St = Function.prototype.call;
        ri.exports = Fh ? St.bind(St) : function() {
            return St.apply(St, arguments);
        };
    });
    var oi = E((ni)=>{
        "use strict";
        var ii = {}.propertyIsEnumerable, ai = Object.getOwnPropertyDescriptor, Lh = ai && !ii.call({
            1: 2
        }, 1);
        ni.f = Lh ? function(h) {
            var p = ai(this, h);
            return !!p && p.enumerable;
        } : ii;
    });
    var fs = E((Ed, li)=>{
        li.exports = function(l, h) {
            return {
                enumerable: !(l & 1),
                configurable: !(l & 2),
                writable: !(l & 4),
                value: h
            };
        };
    });
    var ae = E((Cd, ci)=>{
        var hi = bt(), ui = Function.prototype, ds = ui.call, Oh = hi && ui.bind.bind(ds, ds);
        ci.exports = hi ? Oh : function(l) {
            return function() {
                return ds.apply(l, arguments);
            };
        };
    });
    var Ye = E((bd, fi)=>{
        var pi = ae(), Bh = pi({}.toString), Mh = pi("".slice);
        fi.exports = function(l) {
            return Mh(Bh(l), 8, -1);
        };
    });
    var mi = E((Sd, di)=>{
        var _h = ae(), Rh = ie(), jh = Ye(), ms = Object, qh = _h("".split);
        di.exports = Rh(function() {
            return !ms("z").propertyIsEnumerable(0);
        }) ? function(l) {
            return jh(l) == "String" ? qh(l, "") : ms(l);
        } : ms;
    });
    var ys = E((wd, yi)=>{
        yi.exports = function(l) {
            return l == null;
        };
    });
    var xs = E((Id, xi)=>{
        var Uh = ys(), $h = TypeError;
        xi.exports = function(l) {
            if (Uh(l)) throw $h("Can't call method on " + l);
            return l;
        };
    });
    var It = E((Nd, gi)=>{
        var Hh = mi(), zh = xs();
        gi.exports = function(l) {
            return Hh(zh(l));
        };
    });
    var Ps = E((kd, Pi)=>{
        var gs = typeof document == "object" && document.all, Vh = typeof gs > "u" && gs !== void 0;
        Pi.exports = {
            all: gs,
            IS_HTMLDDA: Vh
        };
    });
    var ee = E((Dd, Ti)=>{
        var Ai = Ps(), Kh = Ai.all;
        Ti.exports = Ai.IS_HTMLDDA ? function(l) {
            return typeof l == "function" || l === Kh;
        } : function(l) {
            return typeof l == "function";
        };
    });
    var Ie = E((Fd, Ci)=>{
        var vi = ee(), Ei = Ps(), Wh = Ei.all;
        Ci.exports = Ei.IS_HTMLDDA ? function(l) {
            return typeof l == "object" ? l !== null : vi(l) || l === Wh;
        } : function(l) {
            return typeof l == "object" ? l !== null : vi(l);
        };
    });
    var Qe = E((Ld, bi)=>{
        var As = re(), Gh = ee(), Jh = function(l) {
            return Gh(l) ? l : void 0;
        };
        bi.exports = function(l, h) {
            return arguments.length < 2 ? Jh(As[l]) : As[l] && As[l][h];
        };
    });
    var wi = E((Od, Si)=>{
        var Xh = ae();
        Si.exports = Xh({}.isPrototypeOf);
    });
    var Ni = E((Bd, Ii)=>{
        var Yh = Qe();
        Ii.exports = Yh("navigator", "userAgent") || "";
    });
    var Mi = E((Md, Bi)=>{
        var Oi = re(), Ts = Ni(), ki = Oi.process, Di = Oi.Deno, Fi = ki && ki.versions || Di && Di.version, Li = Fi && Fi.v8, ne, Nt;
        Li && (ne = Li.split("."), Nt = ne[0] > 0 && ne[0] < 4 ? 1 : +(ne[0] + ne[1]));
        !Nt && Ts && (ne = Ts.match(/Edge\/(\d+)/), (!ne || ne[1] >= 74) && (ne = Ts.match(/Chrome\/(\d+)/), ne && (Nt = +ne[1])));
        Bi.exports = Nt;
    });
    var vs = E((_d, Ri)=>{
        var _i = Mi(), Qh = ie();
        Ri.exports = !!Object.getOwnPropertySymbols && !Qh(function() {
            var l = Symbol();
            return !String(l) || !(Object(l) instanceof Symbol) || !Symbol.sham && _i && _i < 41;
        });
    });
    var Es = E((Rd, ji)=>{
        var Zh = vs();
        ji.exports = Zh && !Symbol.sham && typeof Symbol.iterator == "symbol";
    });
    var Cs = E((jd, qi)=>{
        var eu = Qe(), tu = ee(), su = wi(), ru = Es(), iu = Object;
        qi.exports = ru ? function(l) {
            return typeof l == "symbol";
        } : function(l) {
            var h = eu("Symbol");
            return tu(h) && su(h.prototype, iu(l));
        };
    });
    var $i = E((qd, Ui)=>{
        var au = String;
        Ui.exports = function(l) {
            try {
                return au(l);
            } catch  {
                return "Object";
            }
        };
    });
    var kt = E((Ud, Hi)=>{
        var nu = ee(), ou = $i(), lu = TypeError;
        Hi.exports = function(l) {
            if (nu(l)) return l;
            throw lu(ou(l) + " is not a function");
        };
    });
    var Vi = E(($d, zi)=>{
        var hu = kt(), uu = ys();
        zi.exports = function(l, h) {
            var p = l[h];
            return uu(p) ? void 0 : hu(p);
        };
    });
    var Wi = E((Hd, Ki)=>{
        var bs = wt(), Ss = ee(), ws = Ie(), cu = TypeError;
        Ki.exports = function(l, h) {
            var p, d;
            if (h === "string" && Ss(p = l.toString) && !ws(d = bs(p, l)) || Ss(p = l.valueOf) && !ws(d = bs(p, l)) || h !== "string" && Ss(p = l.toString) && !ws(d = bs(p, l))) return d;
            throw cu("Can't convert object to primitive value");
        };
    });
    var Ji = E((zd, Gi)=>{
        Gi.exports = !1;
    });
    var Dt = E((Vd, Yi)=>{
        var Xi = re(), pu = Object.defineProperty;
        Yi.exports = function(l, h) {
            try {
                pu(Xi, l, {
                    value: h,
                    configurable: !0,
                    writable: !0
                });
            } catch  {
                Xi[l] = h;
            }
            return h;
        };
    });
    var Ft = E((Kd, Zi)=>{
        var fu = re(), du = Dt(), Qi = "__core-js_shared__", mu = fu[Qi] || du(Qi, {});
        Zi.exports = mu;
    });
    var Is = E((Wd, ta)=>{
        var yu = Ji(), ea = Ft();
        (ta.exports = function(l, h) {
            return ea[l] || (ea[l] = h !== void 0 ? h : {});
        })("versions", []).push({
            version: "3.26.1",
            mode: yu ? "pure" : "global",
            copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)",
            license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE",
            source: "https://github.com/zloirock/core-js"
        });
    });
    var Ns = E((Gd, sa)=>{
        var xu = xs(), gu = Object;
        sa.exports = function(l) {
            return gu(xu(l));
        };
    });
    var ve = E((Jd, ra)=>{
        var Pu = ae(), Au = Ns(), Tu = Pu({}.hasOwnProperty);
        ra.exports = Object.hasOwn || function(h, p) {
            return Tu(Au(h), p);
        };
    });
    var ks = E((Xd, ia)=>{
        var vu = ae(), Eu = 0, Cu = Math.random(), bu = vu(1..toString);
        ia.exports = function(l) {
            return "Symbol(" + (l === void 0 ? "" : l) + ")_" + bu(++Eu + Cu, 36);
        };
    });
    var Ze = E((Yd, ha)=>{
        var Su = re(), wu = Is(), aa = ve(), Iu = ks(), na = vs(), la = Es(), qe = wu("wks"), Ne = Su.Symbol, oa = Ne && Ne.for, Nu = la ? Ne : Ne && Ne.withoutSetter || Iu;
        ha.exports = function(l) {
            if (!aa(qe, l) || !(na || typeof qe[l] == "string")) {
                var h = "Symbol." + l;
                na && aa(Ne, l) ? qe[l] = Ne[l] : la && oa ? qe[l] = oa(h) : qe[l] = Nu(h);
            }
            return qe[l];
        };
    });
    var fa = E((Qd, pa)=>{
        var ku = wt(), ua = Ie(), ca = Cs(), Du = Vi(), Fu = Wi(), Lu = Ze(), Ou = TypeError, Bu = Lu("toPrimitive");
        pa.exports = function(l, h) {
            if (!ua(l) || ca(l)) return l;
            var p = Du(l, Bu), d;
            if (p) {
                if (h === void 0 && (h = "default"), d = ku(p, l, h), !ua(d) || ca(d)) return d;
                throw Ou("Can't convert object to primitive value");
            }
            return h === void 0 && (h = "number"), Fu(l, h);
        };
    });
    var Ds = E((Zd, da)=>{
        var Mu = fa(), _u = Cs();
        da.exports = function(l) {
            var h = Mu(l, "string");
            return _u(h) ? h : h + "";
        };
    });
    var xa = E((em, ya)=>{
        var Ru = re(), ma = Ie(), Fs = Ru.document, ju = ma(Fs) && ma(Fs.createElement);
        ya.exports = function(l) {
            return ju ? Fs.createElement(l) : {};
        };
    });
    var Ls = E((tm, ga)=>{
        var qu = ye(), Uu = ie(), $u = xa();
        ga.exports = !qu && !Uu(function() {
            return Object.defineProperty($u("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a != 7;
        });
    });
    var Os = E((Aa)=>{
        var Hu = ye(), zu = wt(), Vu = oi(), Ku = fs(), Wu = It(), Gu = Ds(), Ju = ve(), Xu = Ls(), Pa = Object.getOwnPropertyDescriptor;
        Aa.f = Hu ? Pa : function(h, p) {
            if (h = Wu(h), p = Gu(p), Xu) try {
                return Pa(h, p);
            } catch  {}
            if (Ju(h, p)) return Ku(!zu(Vu.f, h, p), h[p]);
        };
    });
    var va = E((rm, Ta)=>{
        var Yu = ye(), Qu = ie();
        Ta.exports = Yu && Qu(function() {
            return Object.defineProperty(function() {}, "prototype", {
                value: 42,
                writable: !1
            }).prototype != 42;
        });
    });
    var Lt = E((im, Ea)=>{
        var Zu = Ie(), ec = String, tc = TypeError;
        Ea.exports = function(l) {
            if (Zu(l)) return l;
            throw tc(ec(l) + " is not an object");
        };
    });
    var et = E((ba)=>{
        var sc = ye(), rc = Ls(), ic = va(), Ot = Lt(), Ca = Ds(), ac = TypeError, Bs = Object.defineProperty, nc = Object.getOwnPropertyDescriptor, Ms = "enumerable", _s = "configurable", Rs = "writable";
        ba.f = sc ? ic ? function(h, p, d) {
            if (Ot(h), p = Ca(p), Ot(d), typeof h == "function" && p === "prototype" && "value" in d && Rs in d && !d[Rs]) {
                var x = nc(h, p);
                x && x[Rs] && (h[p] = d.value, d = {
                    configurable: _s in d ? d[_s] : x[_s],
                    enumerable: Ms in d ? d[Ms] : x[Ms],
                    writable: !1
                });
            }
            return Bs(h, p, d);
        } : Bs : function(h, p, d) {
            if (Ot(h), p = Ca(p), Ot(d), rc) try {
                return Bs(h, p, d);
            } catch  {}
            if ("get" in d || "set" in d) throw ac("Accessors not supported");
            return "value" in d && (h[p] = d.value), h;
        };
    });
    var js = E((nm, Sa)=>{
        var oc = ye(), lc = et(), hc = fs();
        Sa.exports = oc ? function(l, h, p) {
            return lc.f(l, h, hc(1, p));
        } : function(l, h, p) {
            return l[h] = p, l;
        };
    });
    var Na = E((om, Ia)=>{
        var qs = ye(), uc = ve(), wa = Function.prototype, cc = qs && Object.getOwnPropertyDescriptor, Us = uc(wa, "name"), pc = Us && (function() {}).name === "something", fc = Us && (!qs || qs && cc(wa, "name").configurable);
        Ia.exports = {
            EXISTS: Us,
            PROPER: pc,
            CONFIGURABLE: fc
        };
    });
    var Hs = E((lm, ka)=>{
        var dc = ae(), mc = ee(), $s = Ft(), yc = dc(Function.toString);
        mc($s.inspectSource) || ($s.inspectSource = function(l) {
            return yc(l);
        });
        ka.exports = $s.inspectSource;
    });
    var La = E((hm, Fa)=>{
        var xc = re(), gc = ee(), Da = xc.WeakMap;
        Fa.exports = gc(Da) && /native code/.test(String(Da));
    });
    var Ma = E((um, Ba)=>{
        var Pc = Is(), Ac = ks(), Oa = Pc("keys");
        Ba.exports = function(l) {
            return Oa[l] || (Oa[l] = Ac(l));
        };
    });
    var zs = E((cm, _a)=>{
        _a.exports = {};
    });
    var Ua = E((pm, qa)=>{
        var Tc = La(), ja = re(), vc = Ie(), Ec = js(), Vs = ve(), Ks = Ft(), Cc = Ma(), bc = zs(), Ra = "Object already initialized", Ws = ja.TypeError, Sc = ja.WeakMap, Bt, tt, Mt, wc = function(l) {
            return Mt(l) ? tt(l) : Bt(l, {});
        }, Ic = function(l) {
            return function(h) {
                var p;
                if (!vc(h) || (p = tt(h)).type !== l) throw Ws("Incompatible receiver, " + l + " required");
                return p;
            };
        };
        Tc || Ks.state ? (oe = Ks.state || (Ks.state = new Sc), oe.get = oe.get, oe.has = oe.has, oe.set = oe.set, Bt = function(l, h) {
            if (oe.has(l)) throw Ws(Ra);
            return h.facade = l, oe.set(l, h), h;
        }, tt = function(l) {
            return oe.get(l) || {};
        }, Mt = function(l) {
            return oe.has(l);
        }) : (ke = Cc("state"), bc[ke] = !0, Bt = function(l, h) {
            if (Vs(l, ke)) throw Ws(Ra);
            return h.facade = l, Ec(l, ke, h), h;
        }, tt = function(l) {
            return Vs(l, ke) ? l[ke] : {};
        }, Mt = function(l) {
            return Vs(l, ke);
        });
        var oe, ke;
        qa.exports = {
            set: Bt,
            get: tt,
            has: Mt,
            enforce: wc,
            getterFor: Ic
        };
    });
    var Js = E((fm, Ha)=>{
        var Nc = ie(), kc = ee(), _t = ve(), Gs = ye(), Dc = Na().CONFIGURABLE, Fc = Hs(), $a = Ua(), Lc = $a.enforce, Oc = $a.get, Rt = Object.defineProperty, Bc = Gs && !Nc(function() {
            return Rt(function() {}, "length", {
                value: 8
            }).length !== 8;
        }), Mc = String(String).split("String"), _c = Ha.exports = function(l, h, p) {
            String(h).slice(0, 7) === "Symbol(" && (h = "[" + String(h).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), p && p.getter && (h = "get " + h), p && p.setter && (h = "set " + h), (!_t(l, "name") || Dc && l.name !== h) && (Gs ? Rt(l, "name", {
                value: h,
                configurable: !0
            }) : l.name = h), Bc && p && _t(p, "arity") && l.length !== p.arity && Rt(l, "length", {
                value: p.arity
            });
            try {
                p && _t(p, "constructor") && p.constructor ? Gs && Rt(l, "prototype", {
                    writable: !1
                }) : l.prototype && (l.prototype = void 0);
            } catch  {}
            var d = Lc(l);
            return _t(d, "source") || (d.source = Mc.join(typeof h == "string" ? h : "")), l;
        };
        Function.prototype.toString = _c(function() {
            return kc(this) && Oc(this).source || Fc(this);
        }, "toString");
    });
    var Va = E((dm, za)=>{
        var Rc = ee(), jc = et(), qc = Js(), Uc = Dt();
        za.exports = function(l, h, p, d) {
            d || (d = {});
            var x = d.enumerable, P = d.name !== void 0 ? d.name : h;
            if (Rc(p) && qc(p, P, d), d.global) x ? l[h] = p : Uc(h, p);
            else {
                try {
                    d.unsafe ? l[h] && (x = !0) : delete l[h];
                } catch  {}
                x ? l[h] = p : jc.f(l, h, {
                    value: p,
                    enumerable: !1,
                    configurable: !d.nonConfigurable,
                    writable: !d.nonWritable
                });
            }
            return l;
        };
    });
    var Wa = E((mm, Ka)=>{
        var $c = Math.ceil, Hc = Math.floor;
        Ka.exports = Math.trunc || function(h) {
            var p = +h;
            return (p > 0 ? Hc : $c)(p);
        };
    });
    var Xs = E((ym, Ga)=>{
        var zc = Wa();
        Ga.exports = function(l) {
            var h = +l;
            return h !== h || h === 0 ? 0 : zc(h);
        };
    });
    var Xa = E((xm, Ja)=>{
        var Vc = Xs(), Kc = Math.max, Wc = Math.min;
        Ja.exports = function(l, h) {
            var p = Vc(l);
            return p < 0 ? Kc(p + h, 0) : Wc(p, h);
        };
    });
    var Qa = E((gm, Ya)=>{
        var Gc = Xs(), Jc = Math.min;
        Ya.exports = function(l) {
            return l > 0 ? Jc(Gc(l), 9007199254740991) : 0;
        };
    });
    var jt = E((Pm, Za)=>{
        var Xc = Qa();
        Za.exports = function(l) {
            return Xc(l.length);
        };
    });
    var sn = E((Am, tn)=>{
        var Yc = It(), Qc = Xa(), Zc = jt(), en = function(l) {
            return function(h, p, d) {
                var x = Yc(h), P = Zc(x), m = Qc(d, P), v;
                if (l && p != p) {
                    for(; P > m;)if (v = x[m++], v != v) return !0;
                } else for(; P > m; m++)if ((l || m in x) && x[m] === p) return l || m || 0;
                return !l && -1;
            };
        };
        tn.exports = {
            includes: en(!0),
            indexOf: en(!1)
        };
    });
    var nn = E((Tm, an)=>{
        var ep = ae(), Ys = ve(), tp = It(), sp = sn().indexOf, rp = zs(), rn = ep([].push);
        an.exports = function(l, h) {
            var p = tp(l), d = 0, x = [], P;
            for(P in p)!Ys(rp, P) && Ys(p, P) && rn(x, P);
            for(; h.length > d;)Ys(p, P = h[d++]) && (~sp(x, P) || rn(x, P));
            return x;
        };
    });
    var ln = E((vm, on)=>{
        on.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
        ];
    });
    var un = E((hn)=>{
        var ip = nn(), ap = ln(), np = ap.concat("length", "prototype");
        hn.f = Object.getOwnPropertyNames || function(h) {
            return ip(h, np);
        };
    });
    var pn = E((cn)=>{
        cn.f = Object.getOwnPropertySymbols;
    });
    var dn = E((bm, fn)=>{
        var op = Qe(), lp = ae(), hp = un(), up = pn(), cp = Lt(), pp = lp([].concat);
        fn.exports = op("Reflect", "ownKeys") || function(h) {
            var p = hp.f(cp(h)), d = up.f;
            return d ? pp(p, d(h)) : p;
        };
    });
    var xn = E((Sm, yn)=>{
        var mn = ve(), fp = dn(), dp = Os(), mp = et();
        yn.exports = function(l, h, p) {
            for(var d = fp(h), x = mp.f, P = dp.f, m = 0; m < d.length; m++){
                var v = d[m];
                !mn(l, v) && !(p && mn(p, v)) && x(l, v, P(h, v));
            }
        };
    });
    var Pn = E((wm, gn)=>{
        var yp = ie(), xp = ee(), gp = /#|\.prototype\./, st = function(l, h) {
            var p = Ap[Pp(l)];
            return p == vp ? !0 : p == Tp ? !1 : xp(h) ? yp(h) : !!h;
        }, Pp = st.normalize = function(l) {
            return String(l).replace(gp, ".").toLowerCase();
        }, Ap = st.data = {}, Tp = st.NATIVE = "N", vp = st.POLYFILL = "P";
        gn.exports = st;
    });
    var Zs = E((Im, An)=>{
        var Qs = re(), Ep = Os().f, Cp = js(), bp = Va(), Sp = Dt(), wp = xn(), Ip = Pn();
        An.exports = function(l, h) {
            var p = l.target, d = l.global, x = l.stat, P, m, v, S, k, F;
            if (d ? m = Qs : x ? m = Qs[p] || Sp(p, {}) : m = (Qs[p] || {}).prototype, m) for(v in h){
                if (k = h[v], l.dontCallGetSet ? (F = Ep(m, v), S = F && F.value) : S = m[v], P = Ip(d ? v : p + (x ? "." : "#") + v, l.forced), !P && S !== void 0) {
                    if (typeof k == typeof S) continue;
                    wp(k, S);
                }
                (l.sham || S && S.sham) && Cp(k, "sham", !0), bp(m, v, k, l);
            }
        };
    });
    var Tn = E(()=>{
        var Np = Zs(), er = re();
        Np({
            global: !0,
            forced: er.globalThis !== er
        }, {
            globalThis: er
        });
    });
    var vn = E(()=>{
        Tn();
    });
    var bn = E((Lm, Cn)=>{
        var En = Js(), kp = et();
        Cn.exports = function(l, h, p) {
            return p.get && En(p.get, h, {
                getter: !0
            }), p.set && En(p.set, h, {
                setter: !0
            }), kp.f(l, h, p);
        };
    });
    var wn = E((Om, Sn)=>{
        "use strict";
        var Dp = Lt();
        Sn.exports = function() {
            var l = Dp(this), h = "";
            return l.hasIndices && (h += "d"), l.global && (h += "g"), l.ignoreCase && (h += "i"), l.multiline && (h += "m"), l.dotAll && (h += "s"), l.unicode && (h += "u"), l.unicodeSets && (h += "v"), l.sticky && (h += "y"), h;
        };
    });
    var kn = E(()=>{
        var Fp = re(), Lp = ye(), Op = bn(), Bp = wn(), Mp = ie(), In = Fp.RegExp, Nn = In.prototype, _p = Lp && Mp(function() {
            var l = !0;
            try {
                In(".", "d");
            } catch  {
                l = !1;
            }
            var h = {}, p = "", d = l ? "dgimsy" : "gimsy", x = function(S, k) {
                Object.defineProperty(h, S, {
                    get: function() {
                        return p += k, !0;
                    }
                });
            }, P = {
                dotAll: "s",
                global: "g",
                ignoreCase: "i",
                multiline: "m",
                sticky: "y"
            };
            l && (P.hasIndices = "d");
            for(var m in P)x(m, P[m]);
            var v = Object.getOwnPropertyDescriptor(Nn, "flags").get.call(h);
            return v !== d || p !== d;
        });
        _p && Op(Nn, "flags", {
            configurable: !0,
            get: Bp
        });
    });
    var tr = E((_m, Dn)=>{
        var Rp = Ye();
        Dn.exports = Array.isArray || function(h) {
            return Rp(h) == "Array";
        };
    });
    var Ln = E((Rm, Fn)=>{
        var jp = TypeError, qp = 9007199254740991;
        Fn.exports = function(l) {
            if (l > qp) throw jp("Maximum allowed index exceeded");
            return l;
        };
    });
    var Bn = E((jm, On)=>{
        var Up = Ye(), $p = ae();
        On.exports = function(l) {
            if (Up(l) === "Function") return $p(l);
        };
    });
    var Rn = E((qm, _n)=>{
        var Mn = Bn(), Hp = kt(), zp = bt(), Vp = Mn(Mn.bind);
        _n.exports = function(l, h) {
            return Hp(l), h === void 0 ? l : zp ? Vp(l, h) : function() {
                return l.apply(h, arguments);
            };
        };
    });
    var Un = E((Um, qn)=>{
        "use strict";
        var Kp = tr(), Wp = jt(), Gp = Ln(), Jp = Rn(), jn = function(l, h, p, d, x, P, m, v) {
            for(var S = x, k = 0, F = m ? Jp(m, v) : !1, w, L; k < d;)k in p && (w = F ? F(p[k], k, h) : p[k], P > 0 && Kp(w) ? (L = Wp(w), S = jn(l, h, w, L, S, P - 1) - 1) : (Gp(S + 1), l[S] = w), S++), k++;
            return S;
        };
        qn.exports = jn;
    });
    var zn = E(($m, Hn)=>{
        var Xp = Ze(), Yp = Xp("toStringTag"), $n = {};
        $n[Yp] = "z";
        Hn.exports = String($n) === "[object z]";
    });
    var Kn = E((Hm, Vn)=>{
        var Qp = zn(), Zp = ee(), qt = Ye(), ef = Ze(), tf = ef("toStringTag"), sf = Object, rf = qt(function() {
            return arguments;
        }()) == "Arguments", af = function(l, h) {
            try {
                return l[h];
            } catch  {}
        };
        Vn.exports = Qp ? qt : function(l) {
            var h, p, d;
            return l === void 0 ? "Undefined" : l === null ? "Null" : typeof (p = af(h = sf(l), tf)) == "string" ? p : rf ? qt(h) : (d = qt(h)) == "Object" && Zp(h.callee) ? "Arguments" : d;
        };
    });
    var Qn = E((zm, Yn)=>{
        var nf = ae(), of = ie(), Wn = ee(), lf = Kn(), hf = Qe(), uf = Hs(), Gn = function() {}, cf = [], Jn = hf("Reflect", "construct"), sr = /^\s*(?:class|function)\b/, pf = nf(sr.exec), ff = !sr.exec(Gn), rt = function(h) {
            if (!Wn(h)) return !1;
            try {
                return Jn(Gn, cf, h), !0;
            } catch  {
                return !1;
            }
        }, Xn = function(h) {
            if (!Wn(h)) return !1;
            switch(lf(h)){
                case "AsyncFunction":
                case "GeneratorFunction":
                case "AsyncGeneratorFunction":
                    return !1;
            }
            try {
                return ff || !!pf(sr, uf(h));
            } catch  {
                return !0;
            }
        };
        Xn.sham = !0;
        Yn.exports = !Jn || of(function() {
            var l;
            return rt(rt.call) || !rt(Object) || !rt(function() {
                l = !0;
            }) || l;
        }) ? Xn : rt;
    });
    var so = E((Vm, to)=>{
        var Zn = tr(), df = Qn(), mf = Ie(), yf = Ze(), xf = yf("species"), eo = Array;
        to.exports = function(l) {
            var h;
            return Zn(l) && (h = l.constructor, df(h) && (h === eo || Zn(h.prototype)) ? h = void 0 : mf(h) && (h = h[xf], h === null && (h = void 0))), h === void 0 ? eo : h;
        };
    });
    var io = E((Km, ro)=>{
        var gf = so();
        ro.exports = function(l, h) {
            return new (gf(l))(h === 0 ? 0 : h);
        };
    });
    var ao = E(()=>{
        "use strict";
        var Pf = Zs(), Af = Un(), Tf = kt(), vf = Ns(), Ef = jt(), Cf = io();
        Pf({
            target: "Array",
            proto: !0
        }, {
            flatMap: function(h) {
                var p = vf(this), d = Ef(p), x;
                return Tf(h), x = Cf(p, 0), x.length = Af(x, p, p, d, 0, 1, h, arguments.length > 1 ? arguments[1] : void 0), x;
            }
        });
    });
    var md = E((ty, Oo)=>{
        vn();
        kn();
        ao();
        var nr = Object.defineProperty, bf = Object.getOwnPropertyDescriptor, or = Object.getOwnPropertyNames, Sf = Object.prototype.hasOwnProperty, co = (l, h)=>function() {
                return l && (h = (0, l[or(l)[0]])(l = 0)), h;
            }, $ = (l, h)=>function() {
                return h || (0, l[or(l)[0]])((h = {
                    exports: {}
                }).exports, h), h.exports;
            }, wf = (l, h)=>{
            for(var p in h)nr(l, p, {
                get: h[p],
                enumerable: !0
            });
        }, If = (l, h, p, d)=>{
            if (h && typeof h == "object" || typeof h == "function") for (let x of or(h))!Sf.call(l, x) && x !== p && nr(l, x, {
                get: ()=>h[x],
                enumerable: !(d = bf(h, x)) || d.enumerable
            });
            return l;
        }, Nf = (l)=>If(nr({}, "__esModule", {
                value: !0
            }), l), U = co({
            "<define:process>" () {}
        }), kf = $({
            "src/utils/try-combinations.js" (l, h) {
                "use strict";
                U();
                function p() {
                    let d;
                    for(var x = arguments.length, P = new Array(x), m = 0; m < x; m++)P[m] = arguments[m];
                    for (let [v, S] of P.entries())try {
                        return {
                            result: S()
                        };
                    } catch (k) {
                        v === 0 && (d = k);
                    }
                    return {
                        error: d
                    };
                }
                h.exports = p;
            }
        }), po = $({
            "src/language-js/utils/get-shebang.js" (l, h) {
                "use strict";
                U();
                function p(d) {
                    if (!d.startsWith("#!")) return "";
                    let x = d.indexOf(`
`);
                    return x === -1 ? d : d.slice(0, x);
                }
                h.exports = p;
            }
        }), Df = $({
            "src/utils/text/skip-inline-comment.js" (l, h) {
                "use strict";
                U();
                function p(d, x) {
                    if (x === !1) return !1;
                    if (d.charAt(x) === "/" && d.charAt(x + 1) === "*") {
                        for(let P = x + 2; P < d.length; ++P)if (d.charAt(P) === "*" && d.charAt(P + 1) === "/") return P + 2;
                    }
                    return x;
                }
                h.exports = p;
            }
        }), Ff = $({
            "src/utils/text/skip-newline.js" (l, h) {
                "use strict";
                U();
                function p(d, x, P) {
                    let m = P && P.backwards;
                    if (x === !1) return !1;
                    let v = d.charAt(x);
                    if (m) {
                        if (d.charAt(x - 1) === "\r" && v === `
`) return x - 2;
                        if (v === `
` || v === "\r" || v === "\u2028" || v === "\u2029") return x - 1;
                    } else {
                        if (v === "\r" && d.charAt(x + 1) === `
`) return x + 2;
                        if (v === `
` || v === "\r" || v === "\u2028" || v === "\u2029") return x + 1;
                    }
                    return x;
                }
                h.exports = p;
            }
        }), fo = $({
            "src/utils/text/skip.js" (l, h) {
                "use strict";
                U();
                function p(v) {
                    return (S, k, F)=>{
                        let w = F && F.backwards;
                        if (k === !1) return !1;
                        let { length: L } = S, A = k;
                        for(; A >= 0 && A < L;){
                            let _ = S.charAt(A);
                            if (v instanceof RegExp) {
                                if (!v.test(_)) return A;
                            } else if (!v.includes(_)) return A;
                            w ? A-- : A++;
                        }
                        return A === -1 || A === L ? A : !1;
                    };
                }
                var d = p(/\s/), x = p(" 	"), P = p(",; 	"), m = p(/[^\n\r]/);
                h.exports = {
                    skipWhitespace: d,
                    skipSpaces: x,
                    skipToLineEnd: P,
                    skipEverythingButNewLine: m
                };
            }
        }), Lf = $({
            "src/utils/text/skip-trailing-comment.js" (l, h) {
                "use strict";
                U();
                var { skipEverythingButNewLine: p } = fo();
                function d(x, P) {
                    return P === !1 ? !1 : x.charAt(P) === "/" && x.charAt(P + 1) === "/" ? p(x, P) : P;
                }
                h.exports = d;
            }
        }), Of = $({
            "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js" (l, h) {
                "use strict";
                U();
                var p = Df(), d = Ff(), x = Lf(), { skipSpaces: P } = fo();
                function m(v, S) {
                    let k = null, F = S;
                    for(; F !== k;)k = F, F = P(v, F), F = p(v, F), F = x(v, F), F = d(v, F);
                    return F;
                }
                h.exports = m;
            }
        }), mo = {};
        wf(mo, {
            EOL: ()=>ar,
            arch: ()=>Bf,
            cpus: ()=>vo,
            default: ()=>wo,
            endianness: ()=>yo,
            freemem: ()=>Ao,
            getNetworkInterfaces: ()=>So,
            hostname: ()=>xo,
            loadavg: ()=>go,
            networkInterfaces: ()=>bo,
            platform: ()=>Mf,
            release: ()=>Co,
            tmpDir: ()=>rr,
            tmpdir: ()=>ir,
            totalmem: ()=>To,
            type: ()=>Eo,
            uptime: ()=>Po
        });
        function yo() {
            if (typeof Ut > "u") {
                var l = new ArrayBuffer(2), h = new Uint8Array(l), p = new Uint16Array(l);
                if (h[0] = 1, h[1] = 2, p[0] === 258) Ut = "BE";
                else if (p[0] === 513) Ut = "LE";
                else throw new Error("unable to figure out endianess");
            }
            return Ut;
        }
        function xo() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
        }
        function go() {
            return [];
        }
        function Po() {
            return 0;
        }
        function Ao() {
            return Number.MAX_VALUE;
        }
        function To() {
            return Number.MAX_VALUE;
        }
        function vo() {
            return [];
        }
        function Eo() {
            return "Browser";
        }
        function Co() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
        }
        function bo() {}
        function So() {}
        function Bf() {
            return "javascript";
        }
        function Mf() {
            return "browser";
        }
        function rr() {
            return "/tmp";
        }
        var Ut, ir, ar, wo, _f = co({
            "node-modules-polyfills:os" () {
                U(), ir = rr, ar = `
`, wo = {
                    EOL: ar,
                    tmpdir: ir,
                    tmpDir: rr,
                    networkInterfaces: bo,
                    getNetworkInterfaces: So,
                    release: Co,
                    type: Eo,
                    cpus: vo,
                    totalmem: To,
                    freemem: Ao,
                    uptime: Po,
                    loadavg: go,
                    hostname: xo,
                    endianness: yo
                };
            }
        }), Rf = $({
            "node-modules-polyfills-commonjs:os" (l, h) {
                U();
                var p = (_f(), Nf(mo));
                if (p && p.default) {
                    h.exports = p.default;
                    for(let d in p)h.exports[d] = p[d];
                } else p && (h.exports = p);
            }
        }), jf = $({
            "node_modules/detect-newline/index.js" (l, h) {
                "use strict";
                U();
                var p = (d)=>{
                    if (typeof d != "string") throw new TypeError("Expected a string");
                    let x = d.match(/(?:\r?\n)/g) || [];
                    if (x.length === 0) return;
                    let P = x.filter((v)=>v === `\r
`).length, m = x.length - P;
                    return P > m ? `\r
` : `
`;
                };
                h.exports = p, h.exports.graceful = (d)=>typeof d == "string" && p(d) || `
`;
            }
        }), qf = $({
            "node_modules/jest-docblock/build/index.js" (l) {
                "use strict";
                U(), Object.defineProperty(l, "__esModule", {
                    value: !0
                }), l.extract = A, l.parse = G, l.parseWithComments = N, l.print = O, l.strip = _;
                function h() {
                    let R = Rf();
                    return h = function() {
                        return R;
                    }, R;
                }
                function p() {
                    let R = d(jf());
                    return p = function() {
                        return R;
                    }, R;
                }
                function d(R) {
                    return R && R.__esModule ? R : {
                        default: R
                    };
                }
                var x = /\*\/$/, P = /^\/\*\*?/, m = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, v = /(^|\s+)\/\/([^\r\n]*)/g, S = /^(\r?\n)+/, k = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, F = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, w = /(\r?\n|^) *\* ?/g, L = [];
                function A(R) {
                    let z = R.match(m);
                    return z ? z[0].trimLeft() : "";
                }
                function _(R) {
                    let z = R.match(m);
                    return z && z[0] ? R.substring(z[0].length) : R;
                }
                function G(R) {
                    return N(R).pragmas;
                }
                function N(R) {
                    let z = (0, p().default)(R) || h().EOL;
                    R = R.replace(P, "").replace(x, "").replace(w, "$1");
                    let Q = "";
                    for(; Q !== R;)Q = R, R = R.replace(k, `${z}$1 $2${z}`);
                    R = R.replace(S, "").trimRight();
                    let b = Object.create(null), B = R.replace(F, "").replace(S, "").trimRight(), Z;
                    for(; Z = F.exec(R);){
                        let q = Z[2].replace(v, "");
                        typeof b[Z[1]] == "string" || Array.isArray(b[Z[1]]) ? b[Z[1]] = L.concat(b[Z[1]], q) : b[Z[1]] = q;
                    }
                    return {
                        comments: B,
                        pragmas: b
                    };
                }
                function O(R) {
                    let { comments: z = "", pragmas: Q = {} } = R, b = (0, p().default)(z) || h().EOL, B = "/**", Z = " *", q = " */", ue = Object.keys(Q), te = ue.map((se)=>H(se, Q[se])).reduce((se, He)=>se.concat(He), []).map((se)=>`${Z} ${se}${b}`).join("");
                    if (!z) {
                        if (ue.length === 0) return "";
                        if (ue.length === 1 && !Array.isArray(Q[ue[0]])) {
                            let se = Q[ue[0]];
                            return `${B} ${H(ue[0], se)[0]}${q}`;
                        }
                    }
                    let it = z.split(b).map((se)=>`${Z} ${se}`).join(b) + b;
                    return B + b + (z ? it : "") + (z && ue.length ? Z + b : "") + te + q;
                }
                function H(R, z) {
                    return L.concat(z).map((Q)=>`@${R} ${Q}`.trim());
                }
            }
        }), Uf = $({
            "src/common/end-of-line.js" (l, h) {
                "use strict";
                U();
                function p(m) {
                    let v = m.indexOf("\r");
                    return v >= 0 ? m.charAt(v + 1) === `
` ? "crlf" : "cr" : "lf";
                }
                function d(m) {
                    switch(m){
                        case "cr":
                            return "\r";
                        case "crlf":
                            return `\r
`;
                        default:
                            return `
`;
                    }
                }
                function x(m, v) {
                    let S;
                    switch(v){
                        case `
`:
                            S = /\n/g;
                            break;
                        case "\r":
                            S = /\r/g;
                            break;
                        case `\r
`:
                            S = /\r\n/g;
                            break;
                        default:
                            throw new Error(`Unexpected "eol" ${JSON.stringify(v)}.`);
                    }
                    let k = m.match(S);
                    return k ? k.length : 0;
                }
                function P(m) {
                    return m.replace(/\r\n?/g, `
`);
                }
                h.exports = {
                    guessEndOfLine: p,
                    convertEndOfLineToChars: d,
                    countEndOfLineChars: x,
                    normalizeEndOfLine: P
                };
            }
        }), $f = $({
            "src/language-js/pragma.js" (l, h) {
                "use strict";
                U();
                var { parseWithComments: p, strip: d, extract: x, print: P } = qf(), { normalizeEndOfLine: m } = Uf(), v = po();
                function S(w) {
                    let L = v(w);
                    L && (w = w.slice(L.length + 1));
                    let A = x(w), { pragmas: _, comments: G } = p(A);
                    return {
                        shebang: L,
                        text: w,
                        pragmas: _,
                        comments: G
                    };
                }
                function k(w) {
                    let L = Object.keys(S(w).pragmas);
                    return L.includes("prettier") || L.includes("format");
                }
                function F(w) {
                    let { shebang: L, text: A, pragmas: _, comments: G } = S(w), N = d(A), O = P({
                        pragmas: Object.assign({
                            format: ""
                        }, _),
                        comments: G.trimStart()
                    });
                    return (L ? `${L}
` : "") + m(O) + (N.startsWith(`
`) ? `
` : `

`) + N;
                }
                h.exports = {
                    hasPragma: k,
                    insertPragma: F
                };
            }
        }), Io = $({
            "src/utils/is-non-empty-array.js" (l, h) {
                "use strict";
                U();
                function p(d) {
                    return Array.isArray(d) && d.length > 0;
                }
                h.exports = p;
            }
        }), No = $({
            "src/language-js/loc.js" (l, h) {
                "use strict";
                U();
                var p = Io();
                function d(S) {
                    var k, F;
                    let w = S.range ? S.range[0] : S.start, L = (k = (F = S.declaration) === null || F === void 0 ? void 0 : F.decorators) !== null && k !== void 0 ? k : S.decorators;
                    return p(L) ? Math.min(d(L[0]), w) : w;
                }
                function x(S) {
                    return S.range ? S.range[1] : S.end;
                }
                function P(S, k) {
                    let F = d(S);
                    return Number.isInteger(F) && F === d(k);
                }
                function m(S, k) {
                    let F = x(S);
                    return Number.isInteger(F) && F === x(k);
                }
                function v(S, k) {
                    return P(S, k) && m(S, k);
                }
                h.exports = {
                    locStart: d,
                    locEnd: x,
                    hasSameLocStart: P,
                    hasSameLoc: v
                };
            }
        }), ko = $({
            "src/language-js/parse/utils/create-parser.js" (l, h) {
                "use strict";
                U();
                var { hasPragma: p } = $f(), { locStart: d, locEnd: x } = No();
                function P(m) {
                    return m = typeof m == "function" ? {
                        parse: m
                    } : m, Object.assign({
                        astFormat: "estree",
                        hasPragma: p,
                        locStart: d,
                        locEnd: x
                    }, m);
                }
                h.exports = P;
            }
        }), lr = $({
            "src/common/parser-create-error.js" (l, h) {
                "use strict";
                U();
                function p(d, x) {
                    let P = new SyntaxError(d + " (" + x.start.line + ":" + x.start.column + ")");
                    return P.loc = x, P;
                }
                h.exports = p;
            }
        }), Do = $({
            "src/language-js/parse/utils/create-babel-parse-error.js" (l, h) {
                "use strict";
                U();
                var p = lr();
                function d(x) {
                    let { message: P, loc: m } = x;
                    return p(P.replace(/ \(.*\)/, ""), {
                        start: {
                            line: m ? m.line : 0,
                            column: m ? m.column + 1 : 0
                        }
                    });
                }
                h.exports = d;
            }
        }), Hf = $({
            "src/language-js/utils/is-ts-keyword-type.js" (l, h) {
                "use strict";
                U();
                function p(d) {
                    let { type: x } = d;
                    return x.startsWith("TS") && x.endsWith("Keyword");
                }
                h.exports = p;
            }
        }), zf = $({
            "src/language-js/utils/is-block-comment.js" (l, h) {
                "use strict";
                U();
                var p = new Set([
                    "Block",
                    "CommentBlock",
                    "MultiLine"
                ]), d = (x)=>p.has(x == null ? void 0 : x.type);
                h.exports = d;
            }
        }), Vf = $({
            "src/language-js/utils/is-type-cast-comment.js" (l, h) {
                "use strict";
                U();
                var p = zf();
                function d(x) {
                    return p(x) && x.value[0] === "*" && /@(?:type|satisfies)\b/.test(x.value);
                }
                h.exports = d;
            }
        }), Kf = $({
            "src/utils/get-last.js" (l, h) {
                "use strict";
                U();
                var p = (d)=>d[d.length - 1];
                h.exports = p;
            }
        }), Wf = $({
            "src/language-js/parse/postprocess/visit-node.js" (l, h) {
                "use strict";
                U();
                function p(d, x) {
                    if (Array.isArray(d)) {
                        for(let P = 0; P < d.length; P++)d[P] = p(d[P], x);
                        return d;
                    }
                    if (d && typeof d == "object" && typeof d.type == "string") {
                        let P = Object.keys(d);
                        for(let m = 0; m < P.length; m++)d[P[m]] = p(d[P[m]], x);
                        return x(d) || d;
                    }
                    return d;
                }
                h.exports = p;
            }
        }), Gf = $({
            "src/language-js/parse/postprocess/throw-syntax-error.js" (l, h) {
                "use strict";
                U();
                var p = lr();
                function d(x, P) {
                    let { start: m, end: v } = x.loc;
                    throw p(P, {
                        start: {
                            line: m.line,
                            column: m.column + 1
                        },
                        end: {
                            line: v.line,
                            column: v.column + 1
                        }
                    });
                }
                h.exports = d;
            }
        }), Jf = $({
            "src/language-js/parse/postprocess/index.js" (l, h) {
                "use strict";
                U();
                var { locStart: p, locEnd: d } = No(), x = Hf(), P = Vf(), m = Kf(), v = Wf(), S = Gf();
                function k(A, _) {
                    if (_.parser !== "typescript" && _.parser !== "flow" && _.parser !== "acorn" && _.parser !== "espree" && _.parser !== "meriyah") {
                        let N = new Set;
                        A = v(A, (O)=>{
                            O.leadingComments && O.leadingComments.some(P) && N.add(p(O));
                        }), A = v(A, (O)=>{
                            if (O.type === "ParenthesizedExpression") {
                                let { expression: H } = O;
                                if (H.type === "TypeCastExpression") return H.range = O.range, H;
                                let R = p(O);
                                if (!N.has(R)) return H.extra = Object.assign(Object.assign({}, H.extra), {}, {
                                    parenthesized: !0
                                }), H;
                            }
                        });
                    }
                    return A = v(A, (N)=>{
                        switch(N.type){
                            case "ChainExpression":
                                return F(N.expression);
                            case "LogicalExpression":
                                if (w(N)) return L(N);
                                break;
                            case "VariableDeclaration":
                                {
                                    let O = m(N.declarations);
                                    O && O.init && G(N, O);
                                    break;
                                }
                            case "TSParenthesizedType":
                                return x(N.typeAnnotation) || N.typeAnnotation.type === "TSThisType" || (N.typeAnnotation.range = [
                                    p(N),
                                    d(N)
                                ]), N.typeAnnotation;
                            case "TSTypeParameter":
                                if (typeof N.name == "string") {
                                    let O = p(N);
                                    N.name = {
                                        type: "Identifier",
                                        name: N.name,
                                        range: [
                                            O,
                                            O + N.name.length
                                        ]
                                    };
                                }
                                break;
                            case "ObjectExpression":
                                if (_.parser === "typescript") {
                                    let O = N.properties.find((H)=>H.type === "Property" && H.value.type === "TSEmptyBodyFunctionExpression");
                                    O && S(O.value, "Unexpected token.");
                                }
                                break;
                            case "SequenceExpression":
                                {
                                    let O = m(N.expressions);
                                    N.range = [
                                        p(N),
                                        Math.min(d(O), d(N))
                                    ];
                                    break;
                                }
                            case "TopicReference":
                                _.__isUsingHackPipeline = !0;
                                break;
                            case "ExportAllDeclaration":
                                {
                                    let { exported: O } = N;
                                    if (_.parser === "meriyah" && O && O.type === "Identifier") {
                                        let H = _.originalText.slice(p(O), d(O));
                                        (H.startsWith('"') || H.startsWith("'")) && (N.exported = Object.assign(Object.assign({}, N.exported), {}, {
                                            type: "Literal",
                                            value: N.exported.name,
                                            raw: H
                                        }));
                                    }
                                    break;
                                }
                            case "PropertyDefinition":
                                if (_.parser === "meriyah" && N.static && !N.computed && !N.key) {
                                    let O = "static", H = p(N);
                                    Object.assign(N, {
                                        static: !1,
                                        key: {
                                            type: "Identifier",
                                            name: O,
                                            range: [
                                                H,
                                                H + O.length
                                            ]
                                        }
                                    });
                                }
                                break;
                        }
                    }), A;
                    function G(N, O) {
                        _.originalText[d(O)] !== ";" && (N.range = [
                            p(N),
                            d(O)
                        ]);
                    }
                }
                function F(A) {
                    switch(A.type){
                        case "CallExpression":
                            A.type = "OptionalCallExpression", A.callee = F(A.callee);
                            break;
                        case "MemberExpression":
                            A.type = "OptionalMemberExpression", A.object = F(A.object);
                            break;
                        case "TSNonNullExpression":
                            A.expression = F(A.expression);
                            break;
                    }
                    return A;
                }
                function w(A) {
                    return A.type === "LogicalExpression" && A.right.type === "LogicalExpression" && A.operator === A.right.operator;
                }
                function L(A) {
                    return w(A) ? L({
                        type: "LogicalExpression",
                        operator: A.operator,
                        left: L({
                            type: "LogicalExpression",
                            operator: A.operator,
                            left: A.left,
                            right: A.right.left,
                            range: [
                                p(A.left),
                                d(A.right.left)
                            ]
                        }),
                        right: A.right.right,
                        range: [
                            p(A),
                            d(A)
                        ]
                    }) : A;
                }
                h.exports = k;
            }
        }), Fo = $({
            "node_modules/@babel/parser/lib/index.js" (l) {
                "use strict";
                U(), Object.defineProperty(l, "__esModule", {
                    value: !0
                });
                var h = {
                    sourceType: "script",
                    sourceFilename: void 0,
                    startColumn: 0,
                    startLine: 1,
                    allowAwaitOutsideFunction: !1,
                    allowReturnOutsideFunction: !1,
                    allowNewTargetOutsideFunction: !1,
                    allowImportExportEverywhere: !1,
                    allowSuperOutsideMethod: !1,
                    allowUndeclaredExports: !1,
                    plugins: [],
                    strictMode: null,
                    ranges: !1,
                    tokens: !1,
                    createParenthesizedExpressions: !1,
                    errorRecovery: !1,
                    attachComment: !0,
                    annexB: !0
                };
                function p(t) {
                    if (t && t.annexB != null && t.annexB !== !1) throw new Error("The `annexB` option can only be set to `false`.");
                    let r = {};
                    for (let e of Object.keys(h))r[e] = t && t[e] != null ? t[e] : h[e];
                    return r;
                }
                var d = class {
                    constructor(t, r){
                        this.token = void 0, this.preserveSpace = void 0, this.token = t, this.preserveSpace = !!r;
                    }
                }, x = {
                    brace: new d("{"),
                    j_oTag: new d("<tag"),
                    j_cTag: new d("</tag"),
                    j_expr: new d("<tag>...</tag>", !0)
                };
                x.template = new d("`", !0);
                var P = !0, m = !0, v = !0, S = !0, k = !0, F = !0, w = class {
                    constructor(t){
                        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t, this.keyword = r.keyword, this.beforeExpr = !!r.beforeExpr, this.startsExpr = !!r.startsExpr, this.rightAssociative = !!r.rightAssociative, this.isLoop = !!r.isLoop, this.isAssign = !!r.isAssign, this.prefix = !!r.prefix, this.postfix = !!r.postfix, this.binop = r.binop != null ? r.binop : null, this.updateContext = null;
                    }
                }, L = new Map;
                function A(t) {
                    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    r.keyword = t;
                    let e = b(t, r);
                    return L.set(t, e), e;
                }
                function _(t, r) {
                    return b(t, {
                        beforeExpr: P,
                        binop: r
                    });
                }
                var G = -1, N = [], O = [], H = [], R = [], z = [], Q = [];
                function b(t) {
                    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    var e, s, i, a;
                    return ++G, O.push(t), H.push((e = r.binop) != null ? e : -1), R.push((s = r.beforeExpr) != null ? s : !1), z.push((i = r.startsExpr) != null ? i : !1), Q.push((a = r.prefix) != null ? a : !1), N.push(new w(t, r)), G;
                }
                function B(t) {
                    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    var e, s, i, a;
                    return ++G, L.set(t, G), O.push(t), H.push((e = r.binop) != null ? e : -1), R.push((s = r.beforeExpr) != null ? s : !1), z.push((i = r.startsExpr) != null ? i : !1), Q.push((a = r.prefix) != null ? a : !1), N.push(new w("name", r)), G;
                }
                var Z = {
                    bracketL: b("[", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    bracketHashL: b("#[", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    bracketBarL: b("[|", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    bracketR: b("]"),
                    bracketBarR: b("|]"),
                    braceL: b("{", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    braceBarL: b("{|", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    braceHashL: b("#{", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    braceR: b("}"),
                    braceBarR: b("|}"),
                    parenL: b("(", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    parenR: b(")"),
                    comma: b(",", {
                        beforeExpr: P
                    }),
                    semi: b(";", {
                        beforeExpr: P
                    }),
                    colon: b(":", {
                        beforeExpr: P
                    }),
                    doubleColon: b("::", {
                        beforeExpr: P
                    }),
                    dot: b("."),
                    question: b("?", {
                        beforeExpr: P
                    }),
                    questionDot: b("?."),
                    arrow: b("=>", {
                        beforeExpr: P
                    }),
                    template: b("template"),
                    ellipsis: b("...", {
                        beforeExpr: P
                    }),
                    backQuote: b("`", {
                        startsExpr: m
                    }),
                    dollarBraceL: b("${", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    templateTail: b("...`", {
                        startsExpr: m
                    }),
                    templateNonTail: b("...${", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    at: b("@"),
                    hash: b("#", {
                        startsExpr: m
                    }),
                    interpreterDirective: b("#!..."),
                    eq: b("=", {
                        beforeExpr: P,
                        isAssign: S
                    }),
                    assign: b("_=", {
                        beforeExpr: P,
                        isAssign: S
                    }),
                    slashAssign: b("_=", {
                        beforeExpr: P,
                        isAssign: S
                    }),
                    xorAssign: b("_=", {
                        beforeExpr: P,
                        isAssign: S
                    }),
                    moduloAssign: b("_=", {
                        beforeExpr: P,
                        isAssign: S
                    }),
                    incDec: b("++/--", {
                        prefix: k,
                        postfix: F,
                        startsExpr: m
                    }),
                    bang: b("!", {
                        beforeExpr: P,
                        prefix: k,
                        startsExpr: m
                    }),
                    tilde: b("~", {
                        beforeExpr: P,
                        prefix: k,
                        startsExpr: m
                    }),
                    doubleCaret: b("^^", {
                        startsExpr: m
                    }),
                    doubleAt: b("@@", {
                        startsExpr: m
                    }),
                    pipeline: _("|>", 0),
                    nullishCoalescing: _("??", 1),
                    logicalOR: _("||", 1),
                    logicalAND: _("&&", 2),
                    bitwiseOR: _("|", 3),
                    bitwiseXOR: _("^", 4),
                    bitwiseAND: _("&", 5),
                    equality: _("==/!=/===/!==", 6),
                    lt: _("</>/<=/>=", 7),
                    gt: _("</>/<=/>=", 7),
                    relational: _("</>/<=/>=", 7),
                    bitShift: _("<</>>/>>>", 8),
                    bitShiftL: _("<</>>/>>>", 8),
                    bitShiftR: _("<</>>/>>>", 8),
                    plusMin: b("+/-", {
                        beforeExpr: P,
                        binop: 9,
                        prefix: k,
                        startsExpr: m
                    }),
                    modulo: b("%", {
                        binop: 10,
                        startsExpr: m
                    }),
                    star: b("*", {
                        binop: 10
                    }),
                    slash: _("/", 10),
                    exponent: b("**", {
                        beforeExpr: P,
                        binop: 11,
                        rightAssociative: !0
                    }),
                    _in: A("in", {
                        beforeExpr: P,
                        binop: 7
                    }),
                    _instanceof: A("instanceof", {
                        beforeExpr: P,
                        binop: 7
                    }),
                    _break: A("break"),
                    _case: A("case", {
                        beforeExpr: P
                    }),
                    _catch: A("catch"),
                    _continue: A("continue"),
                    _debugger: A("debugger"),
                    _default: A("default", {
                        beforeExpr: P
                    }),
                    _else: A("else", {
                        beforeExpr: P
                    }),
                    _finally: A("finally"),
                    _function: A("function", {
                        startsExpr: m
                    }),
                    _if: A("if"),
                    _return: A("return", {
                        beforeExpr: P
                    }),
                    _switch: A("switch"),
                    _throw: A("throw", {
                        beforeExpr: P,
                        prefix: k,
                        startsExpr: m
                    }),
                    _try: A("try"),
                    _var: A("var"),
                    _const: A("const"),
                    _with: A("with"),
                    _new: A("new", {
                        beforeExpr: P,
                        startsExpr: m
                    }),
                    _this: A("this", {
                        startsExpr: m
                    }),
                    _super: A("super", {
                        startsExpr: m
                    }),
                    _class: A("class", {
                        startsExpr: m
                    }),
                    _extends: A("extends", {
                        beforeExpr: P
                    }),
                    _export: A("export"),
                    _import: A("import", {
                        startsExpr: m
                    }),
                    _null: A("null", {
                        startsExpr: m
                    }),
                    _true: A("true", {
                        startsExpr: m
                    }),
                    _false: A("false", {
                        startsExpr: m
                    }),
                    _typeof: A("typeof", {
                        beforeExpr: P,
                        prefix: k,
                        startsExpr: m
                    }),
                    _void: A("void", {
                        beforeExpr: P,
                        prefix: k,
                        startsExpr: m
                    }),
                    _delete: A("delete", {
                        beforeExpr: P,
                        prefix: k,
                        startsExpr: m
                    }),
                    _do: A("do", {
                        isLoop: v,
                        beforeExpr: P
                    }),
                    _for: A("for", {
                        isLoop: v
                    }),
                    _while: A("while", {
                        isLoop: v
                    }),
                    _as: B("as", {
                        startsExpr: m
                    }),
                    _assert: B("assert", {
                        startsExpr: m
                    }),
                    _async: B("async", {
                        startsExpr: m
                    }),
                    _await: B("await", {
                        startsExpr: m
                    }),
                    _from: B("from", {
                        startsExpr: m
                    }),
                    _get: B("get", {
                        startsExpr: m
                    }),
                    _let: B("let", {
                        startsExpr: m
                    }),
                    _meta: B("meta", {
                        startsExpr: m
                    }),
                    _of: B("of", {
                        startsExpr: m
                    }),
                    _sent: B("sent", {
                        startsExpr: m
                    }),
                    _set: B("set", {
                        startsExpr: m
                    }),
                    _static: B("static", {
                        startsExpr: m
                    }),
                    _using: B("using", {
                        startsExpr: m
                    }),
                    _yield: B("yield", {
                        startsExpr: m
                    }),
                    _asserts: B("asserts", {
                        startsExpr: m
                    }),
                    _checks: B("checks", {
                        startsExpr: m
                    }),
                    _exports: B("exports", {
                        startsExpr: m
                    }),
                    _global: B("global", {
                        startsExpr: m
                    }),
                    _implements: B("implements", {
                        startsExpr: m
                    }),
                    _intrinsic: B("intrinsic", {
                        startsExpr: m
                    }),
                    _infer: B("infer", {
                        startsExpr: m
                    }),
                    _is: B("is", {
                        startsExpr: m
                    }),
                    _mixins: B("mixins", {
                        startsExpr: m
                    }),
                    _proto: B("proto", {
                        startsExpr: m
                    }),
                    _require: B("require", {
                        startsExpr: m
                    }),
                    _satisfies: B("satisfies", {
                        startsExpr: m
                    }),
                    _keyof: B("keyof", {
                        startsExpr: m
                    }),
                    _readonly: B("readonly", {
                        startsExpr: m
                    }),
                    _unique: B("unique", {
                        startsExpr: m
                    }),
                    _abstract: B("abstract", {
                        startsExpr: m
                    }),
                    _declare: B("declare", {
                        startsExpr: m
                    }),
                    _enum: B("enum", {
                        startsExpr: m
                    }),
                    _module: B("module", {
                        startsExpr: m
                    }),
                    _namespace: B("namespace", {
                        startsExpr: m
                    }),
                    _interface: B("interface", {
                        startsExpr: m
                    }),
                    _type: B("type", {
                        startsExpr: m
                    }),
                    _opaque: B("opaque", {
                        startsExpr: m
                    }),
                    name: b("name", {
                        startsExpr: m
                    }),
                    string: b("string", {
                        startsExpr: m
                    }),
                    num: b("num", {
                        startsExpr: m
                    }),
                    bigint: b("bigint", {
                        startsExpr: m
                    }),
                    decimal: b("decimal", {
                        startsExpr: m
                    }),
                    regexp: b("regexp", {
                        startsExpr: m
                    }),
                    privateName: b("#name", {
                        startsExpr: m
                    }),
                    eof: b("eof"),
                    jsxName: b("jsxName"),
                    jsxText: b("jsxText", {
                        beforeExpr: !0
                    }),
                    jsxTagStart: b("jsxTagStart", {
                        startsExpr: !0
                    }),
                    jsxTagEnd: b("jsxTagEnd"),
                    placeholder: b("%%", {
                        startsExpr: !0
                    })
                };
                function q(t) {
                    return t >= 93 && t <= 130;
                }
                function ue(t) {
                    return t <= 92;
                }
                function te(t) {
                    return t >= 58 && t <= 130;
                }
                function it(t) {
                    return t >= 58 && t <= 134;
                }
                function se(t) {
                    return R[t];
                }
                function He(t) {
                    return z[t];
                }
                function Bo(t) {
                    return t >= 29 && t <= 33;
                }
                function hr(t) {
                    return t >= 127 && t <= 129;
                }
                function Mo(t) {
                    return t >= 90 && t <= 92;
                }
                function $t(t) {
                    return t >= 58 && t <= 92;
                }
                function _o(t) {
                    return t >= 39 && t <= 59;
                }
                function Ro(t) {
                    return t === 34;
                }
                function jo(t) {
                    return Q[t];
                }
                function qo(t) {
                    return t >= 119 && t <= 121;
                }
                function Uo(t) {
                    return t >= 122 && t <= 128;
                }
                function xe(t) {
                    return O[t];
                }
                function at(t) {
                    return H[t];
                }
                function $o(t) {
                    return t === 57;
                }
                function nt(t) {
                    return t >= 24 && t <= 25;
                }
                function ce(t) {
                    return N[t];
                }
                N[8].updateContext = (t)=>{
                    t.pop();
                }, N[5].updateContext = N[7].updateContext = N[23].updateContext = (t)=>{
                    t.push(x.brace);
                }, N[22].updateContext = (t)=>{
                    t[t.length - 1] === x.template ? t.pop() : t.push(x.template);
                }, N[140].updateContext = (t)=>{
                    t.push(x.j_expr, x.j_oTag);
                };
                function ot(t, r) {
                    if (t == null) return {};
                    var e = {}, s = Object.keys(t), i, a;
                    for(a = 0; a < s.length; a++)i = s[a], !(r.indexOf(i) >= 0) && (e[i] = t[i]);
                    return e;
                }
                var ge = class {
                    constructor(t, r, e){
                        this.line = void 0, this.column = void 0, this.index = void 0, this.line = t, this.column = r, this.index = e;
                    }
                }, lt = class {
                    constructor(t, r){
                        this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t, this.end = r;
                    }
                };
                function Y(t, r) {
                    let { line: e, column: s, index: i } = t;
                    return new ge(e, s + r, i + r);
                }
                var Ht = {
                    SyntaxError: "BABEL_PARSER_SYNTAX_ERROR",
                    SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED"
                }, Ho = function(t) {
                    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.length - 1;
                    return {
                        get () {
                            return t.reduce((e, s)=>e[s], this);
                        },
                        set (e) {
                            t.reduce((s, i, a)=>a === r ? s[i] = e : s[i], this);
                        }
                    };
                }, zo = (t, r, e)=>Object.keys(e).map((s)=>[
                            s,
                            e[s]
                        ]).filter((s)=>{
                        let [, i] = s;
                        return !!i;
                    }).map((s)=>{
                        let [i, a] = s;
                        return [
                            i,
                            typeof a == "function" ? {
                                value: a,
                                enumerable: !1
                            } : typeof a.reflect == "string" ? Object.assign({}, a, Ho(a.reflect.split("."))) : a
                        ];
                    }).reduce((s, i)=>{
                        let [a, n] = i;
                        return Object.defineProperty(s, a, Object.assign({
                            configurable: !0
                        }, n));
                    }, Object.assign(new t, r)), Vo = {
                    ImportMetaOutsideModule: {
                        message: `import.meta may appear only with 'sourceType: "module"'`,
                        code: Ht.SourceTypeModuleError
                    },
                    ImportOutsideModule: {
                        message: `'import' and 'export' may appear only with 'sourceType: "module"'`,
                        code: Ht.SourceTypeModuleError
                    }
                }, ur = {
                    ArrayPattern: "array destructuring pattern",
                    AssignmentExpression: "assignment expression",
                    AssignmentPattern: "assignment expression",
                    ArrowFunctionExpression: "arrow function expression",
                    ConditionalExpression: "conditional expression",
                    CatchClause: "catch clause",
                    ForOfStatement: "for-of statement",
                    ForInStatement: "for-in statement",
                    ForStatement: "for-loop",
                    FormalParameters: "function parameter list",
                    Identifier: "identifier",
                    ImportSpecifier: "import specifier",
                    ImportDefaultSpecifier: "import default specifier",
                    ImportNamespaceSpecifier: "import namespace specifier",
                    ObjectPattern: "object destructuring pattern",
                    ParenthesizedExpression: "parenthesized expression",
                    RestElement: "rest element",
                    UpdateExpression: {
                        true: "prefix operation",
                        false: "postfix operation"
                    },
                    VariableDeclarator: "variable declaration",
                    YieldExpression: "yield expression"
                }, zt = (t)=>{
                    let { type: r, prefix: e } = t;
                    return r === "UpdateExpression" ? ur.UpdateExpression[String(e)] : ur[r];
                }, Ko = {
                    AccessorIsGenerator: (t)=>{
                        let { kind: r } = t;
                        return `A ${r}ter cannot be a generator.`;
                    },
                    ArgumentsInClass: "'arguments' is only allowed in functions and class methods.",
                    AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.",
                    AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.",
                    AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.",
                    AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.",
                    AwaitInUsingBinding: "'await' is not allowed to be used as a name in 'using' declarations.",
                    AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.",
                    AwaitNotInAsyncFunction: "'await' is only allowed within async functions.",
                    BadGetterArity: "A 'get' accessor must not have any formal parameters.",
                    BadSetterArity: "A 'set' accessor must have exactly one formal parameter.",
                    BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.",
                    ConstructorClassField: "Classes may not have a field named 'constructor'.",
                    ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.",
                    ConstructorIsAccessor: "Class constructor may not be an accessor.",
                    ConstructorIsAsync: "Constructor can't be an async function.",
                    ConstructorIsGenerator: "Constructor can't be a generator.",
                    DeclarationMissingInitializer: (t)=>{
                        let { kind: r } = t;
                        return `Missing initializer in ${r} declaration.`;
                    },
                    DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.",
                    DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.",
                    DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.",
                    DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?",
                    DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.",
                    DecoratorSemicolon: "Decorators must not be followed by a semicolon.",
                    DecoratorStaticBlock: "Decorators can't be used with a static block.",
                    DeletePrivateField: "Deleting a private field is not allowed.",
                    DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.",
                    DuplicateConstructor: "Duplicate constructor in the same class.",
                    DuplicateDefaultExport: "Only one default export allowed per module.",
                    DuplicateExport: (t)=>{
                        let { exportName: r } = t;
                        return `\`${r}\` has already been exported. Exported identifiers must be unique.`;
                    },
                    DuplicateProto: "Redefinition of __proto__ property.",
                    DuplicateRegExpFlags: "Duplicate regular expression flag.",
                    ElementAfterRest: "Rest element must be last element.",
                    EscapedCharNotAnIdentifier: "Invalid Unicode escape.",
                    ExportBindingIsString: (t)=>{
                        let { localName: r, exportName: e } = t;
                        return `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${r}' as '${e}' } from 'some-module'\`?`;
                    },
                    ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.",
                    ForInOfLoopInitializer: (t)=>{
                        let { type: r } = t;
                        return `'${r === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`;
                    },
                    ForInUsing: "For-in loop may not start with 'using' declaration.",
                    ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.",
                    ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.",
                    GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.",
                    IllegalBreakContinue: (t)=>{
                        let { type: r } = t;
                        return `Unsyntactic ${r === "BreakStatement" ? "break" : "continue"}.`;
                    },
                    IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.",
                    IllegalReturn: "'return' outside of function.",
                    ImportBindingIsString: (t)=>{
                        let { importName: r } = t;
                        return `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${r}" as foo }\`?`;
                    },
                    ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.",
                    ImportCallArity: (t)=>{
                        let { maxArgumentCount: r } = t;
                        return `\`import()\` requires exactly ${r === 1 ? "one argument" : "one or two arguments"}.`;
                    },
                    ImportCallNotNewExpression: "Cannot use new with import(...).",
                    ImportCallSpreadArgument: "`...` is not allowed in `import()`.",
                    ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.",
                    ImportReflectionHasAssertion: "`import module x` cannot have assertions.",
                    ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.',
                    IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.",
                    InvalidBigIntLiteral: "Invalid BigIntLiteral.",
                    InvalidCodePoint: "Code point out of bounds.",
                    InvalidCoverInitializedName: "Invalid shorthand property initializer.",
                    InvalidDecimal: "Invalid decimal.",
                    InvalidDigit: (t)=>{
                        let { radix: r } = t;
                        return `Expected number in radix ${r}.`;
                    },
                    InvalidEscapeSequence: "Bad character escape sequence.",
                    InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.",
                    InvalidEscapedReservedWord: (t)=>{
                        let { reservedWord: r } = t;
                        return `Escape sequence in keyword ${r}.`;
                    },
                    InvalidIdentifier: (t)=>{
                        let { identifierName: r } = t;
                        return `Invalid identifier ${r}.`;
                    },
                    InvalidLhs: (t)=>{
                        let { ancestor: r } = t;
                        return `Invalid left-hand side in ${zt(r)}.`;
                    },
                    InvalidLhsBinding: (t)=>{
                        let { ancestor: r } = t;
                        return `Binding invalid left-hand side in ${zt(r)}.`;
                    },
                    InvalidNumber: "Invalid number.",
                    InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.",
                    InvalidOrUnexpectedToken: (t)=>{
                        let { unexpected: r } = t;
                        return `Unexpected character '${r}'.`;
                    },
                    InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.",
                    InvalidPrivateFieldResolution: (t)=>{
                        let { identifierName: r } = t;
                        return `Private name #${r} is not defined.`;
                    },
                    InvalidPropertyBindingPattern: "Binding member expression.",
                    InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.",
                    InvalidRestAssignmentPattern: "Invalid rest operator's argument.",
                    LabelRedeclaration: (t)=>{
                        let { labelName: r } = t;
                        return `Label '${r}' is already declared.`;
                    },
                    LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.",
                    LineTerminatorBeforeArrow: "No line break is allowed before '=>'.",
                    MalformedRegExpFlags: "Invalid regular expression flag.",
                    MissingClassName: "A class name is required.",
                    MissingEqInAssignment: "Only '=' operator can be used for specifying default value.",
                    MissingSemicolon: "Missing semicolon.",
                    MissingPlugin: (t)=>{
                        let { missingPlugin: r } = t;
                        return `This experimental syntax requires enabling the parser plugin: ${r.map((e)=>JSON.stringify(e)).join(", ")}.`;
                    },
                    MissingOneOfPlugins: (t)=>{
                        let { missingPlugin: r } = t;
                        return `This experimental syntax requires enabling one of the following parser plugin(s): ${r.map((e)=>JSON.stringify(e)).join(", ")}.`;
                    },
                    MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.",
                    MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.",
                    ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.",
                    ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.",
                    ModuleAttributesWithDuplicateKeys: (t)=>{
                        let { key: r } = t;
                        return `Duplicate key "${r}" is not allowed in module attributes.`;
                    },
                    ModuleExportNameHasLoneSurrogate: (t)=>{
                        let { surrogateCharCode: r } = t;
                        return `An export name cannot include a lone surrogate, found '\\u${r.toString(16)}'.`;
                    },
                    ModuleExportUndefined: (t)=>{
                        let { localName: r } = t;
                        return `Export '${r}' is not defined.`;
                    },
                    MultipleDefaultsInSwitch: "Multiple default clauses.",
                    NewlineAfterThrow: "Illegal newline after throw.",
                    NoCatchOrFinally: "Missing catch or finally clause.",
                    NumberIdentifier: "Identifier directly after number.",
                    NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.",
                    ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.",
                    OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.",
                    OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.",
                    OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.",
                    ParamDupe: "Argument name clash.",
                    PatternHasAccessor: "Object pattern can't contain getter or setter.",
                    PatternHasMethod: "Object pattern can't contain methods.",
                    PrivateInExpectedIn: (t)=>{
                        let { identifierName: r } = t;
                        return `Private names are only allowed in property accesses (\`obj.#${r}\`) or in \`in\` expressions (\`#${r} in obj\`).`;
                    },
                    PrivateNameRedeclaration: (t)=>{
                        let { identifierName: r } = t;
                        return `Duplicate private name #${r}.`;
                    },
                    RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
                    RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
                    RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
                    RecordNoProto: "'__proto__' is not allowed in Record expressions.",
                    RestTrailingComma: "Unexpected trailing comma after rest element.",
                    SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.",
                    SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.",
                    StaticPrototype: "Classes may not have static property named prototype.",
                    SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?",
                    SuperPrivateField: "Private fields can't be accessed on super.",
                    TrailingDecorator: "Decorators must be attached to a class element.",
                    TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
                    TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
                    TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
                    UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.",
                    UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.',
                    UnexpectedDigitAfterHash: "Unexpected digit after hash token.",
                    UnexpectedImportExport: "'import' and 'export' may only appear at the top level.",
                    UnexpectedKeyword: (t)=>{
                        let { keyword: r } = t;
                        return `Unexpected keyword '${r}'.`;
                    },
                    UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.",
                    UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.",
                    UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.",
                    UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.",
                    UnexpectedPrivateField: "Unexpected private name.",
                    UnexpectedReservedWord: (t)=>{
                        let { reservedWord: r } = t;
                        return `Unexpected reserved word '${r}'.`;
                    },
                    UnexpectedSuper: "'super' is only allowed in object methods and classes.",
                    UnexpectedToken: (t)=>{
                        let { expected: r, unexpected: e } = t;
                        return `Unexpected token${e ? ` '${e}'.` : ""}${r ? `, expected "${r}"` : ""}`;
                    },
                    UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.",
                    UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.",
                    UnsupportedBind: "Binding should be performed on object property.",
                    UnsupportedDecoratorExport: "A decorated export must export a class declaration.",
                    UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.",
                    UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.",
                    UnsupportedMetaProperty: (t)=>{
                        let { target: r, onlyValidPropertyName: e } = t;
                        return `The only valid meta property for ${r} is ${r}.${e}.`;
                    },
                    UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.",
                    UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.",
                    UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).",
                    UnterminatedComment: "Unterminated comment.",
                    UnterminatedRegExp: "Unterminated regular expression.",
                    UnterminatedString: "Unterminated string constant.",
                    UnterminatedTemplate: "Unterminated template.",
                    UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.",
                    VarRedeclaration: (t)=>{
                        let { identifierName: r } = t;
                        return `Identifier '${r}' has already been declared.`;
                    },
                    YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.",
                    YieldInParameter: "Yield expression is not allowed in formal parameters.",
                    ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0."
                }, Wo = {
                    StrictDelete: "Deleting local variable in strict mode.",
                    StrictEvalArguments: (t)=>{
                        let { referenceName: r } = t;
                        return `Assigning to '${r}' in strict mode.`;
                    },
                    StrictEvalArgumentsBinding: (t)=>{
                        let { bindingName: r } = t;
                        return `Binding '${r}' in strict mode.`;
                    },
                    StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.",
                    StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.",
                    StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.",
                    StrictWith: "'with' in strict mode."
                }, Go = new Set([
                    "ArrowFunctionExpression",
                    "AssignmentExpression",
                    "ConditionalExpression",
                    "YieldExpression"
                ]), Jo = {
                    PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.",
                    PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.',
                    PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.",
                    PipeTopicUnconfiguredToken: (t)=>{
                        let { token: r } = t;
                        return `Invalid topic token ${r}. In order to use ${r} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${r}" }.`;
                    },
                    PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.",
                    PipeUnparenthesizedBody: (t)=>{
                        let { type: r } = t;
                        return `Hack-style pipe body cannot be an unparenthesized ${zt({
                            type: r
                        })}; please wrap it in parentheses.`;
                    },
                    PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.',
                    PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.",
                    PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.",
                    PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.",
                    PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.",
                    PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.'
                }, Xo = [
                    "toMessage"
                ], Yo = [
                    "message"
                ];
                function Qo(t) {
                    let { toMessage: r } = t, e = ot(t, Xo);
                    return function s(i) {
                        let { loc: a, details: n } = i;
                        return zo(SyntaxError, Object.assign({}, e, {
                            loc: a
                        }), {
                            clone () {
                                let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = o.loc || {};
                                return s({
                                    loc: new ge("line" in u ? u.line : this.loc.line, "column" in u ? u.column : this.loc.column, "index" in u ? u.index : this.loc.index),
                                    details: Object.assign({}, this.details, o.details)
                                });
                            },
                            details: {
                                value: n,
                                enumerable: !1
                            },
                            message: {
                                get () {
                                    return `${r(this.details)} (${this.loc.line}:${this.loc.column})`;
                                },
                                set (o) {
                                    Object.defineProperty(this, "message", {
                                        value: o
                                    });
                                }
                            },
                            pos: {
                                reflect: "loc.index",
                                enumerable: !0
                            },
                            missingPlugin: "missingPlugin" in n && {
                                reflect: "details.missingPlugin",
                                enumerable: !0
                            }
                        });
                    };
                }
                function pe(t, r) {
                    if (Array.isArray(t)) return (s)=>pe(s, t[0]);
                    let e = {};
                    for (let s of Object.keys(t)){
                        let i = t[s], a = typeof i == "string" ? {
                            message: ()=>i
                        } : typeof i == "function" ? {
                            message: i
                        } : i, { message: n } = a, o = ot(a, Yo), u = typeof n == "string" ? ()=>n : n;
                        e[s] = Qo(Object.assign({
                            code: Ht.SyntaxError,
                            reasonCode: s,
                            toMessage: u
                        }, r ? {
                            syntaxPlugin: r
                        } : {}, o));
                    }
                    return e;
                }
                var f = Object.assign({}, pe(Vo), pe(Ko), pe(Wo), pe`pipelineOperator`(Jo)), { defineProperty: Zo } = Object, cr = (t, r)=>Zo(t, r, {
                        enumerable: !1,
                        value: t[r]
                    });
                function ze(t) {
                    return t.loc.start && cr(t.loc.start, "index"), t.loc.end && cr(t.loc.end, "index"), t;
                }
                var el = (t)=>class extends t {
                        parse() {
                            let e = ze(super.parse());
                            return this.options.tokens && (e.tokens = e.tokens.map(ze)), e;
                        }
                        parseRegExpLiteral(e) {
                            let { pattern: s, flags: i } = e, a = null;
                            try {
                                a = new RegExp(s, i);
                            } catch  {}
                            let n = this.estreeParseLiteral(a);
                            return n.regex = {
                                pattern: s,
                                flags: i
                            }, n;
                        }
                        parseBigIntLiteral(e) {
                            let s;
                            try {
                                s = BigInt(e);
                            } catch  {
                                s = null;
                            }
                            let i = this.estreeParseLiteral(s);
                            return i.bigint = String(i.value || e), i;
                        }
                        parseDecimalLiteral(e) {
                            let i = this.estreeParseLiteral(null);
                            return i.decimal = String(i.value || e), i;
                        }
                        estreeParseLiteral(e) {
                            return this.parseLiteral(e, "Literal");
                        }
                        parseStringLiteral(e) {
                            return this.estreeParseLiteral(e);
                        }
                        parseNumericLiteral(e) {
                            return this.estreeParseLiteral(e);
                        }
                        parseNullLiteral() {
                            return this.estreeParseLiteral(null);
                        }
                        parseBooleanLiteral(e) {
                            return this.estreeParseLiteral(e);
                        }
                        directiveToStmt(e) {
                            let s = e.value;
                            delete e.value, s.type = "Literal", s.raw = s.extra.raw, s.value = s.extra.expressionValue;
                            let i = e;
                            return i.type = "ExpressionStatement", i.expression = s, i.directive = s.extra.rawValue, delete s.extra, i;
                        }
                        initFunction(e, s) {
                            super.initFunction(e, s), e.expression = !1;
                        }
                        checkDeclaration(e) {
                            e != null && this.isObjectProperty(e) ? this.checkDeclaration(e.value) : super.checkDeclaration(e);
                        }
                        getObjectOrClassMethodParams(e) {
                            return e.value.params;
                        }
                        isValidDirective(e) {
                            var s;
                            return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && !((s = e.expression.extra) != null && s.parenthesized);
                        }
                        parseBlockBody(e, s, i, a, n) {
                            super.parseBlockBody(e, s, i, a, n);
                            let o = e.directives.map((u)=>this.directiveToStmt(u));
                            e.body = o.concat(e.body), delete e.directives;
                        }
                        pushClassMethod(e, s, i, a, n, o) {
                            this.parseMethod(s, i, a, n, o, "ClassMethod", !0), s.typeParameters && (s.value.typeParameters = s.typeParameters, delete s.typeParameters), e.body.push(s);
                        }
                        parsePrivateName() {
                            let e = super.parsePrivateName();
                            return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e) : e;
                        }
                        convertPrivateNameToPrivateIdentifier(e) {
                            let s = super.getPrivateNameSV(e);
                            return e, delete e.id, e.name = s, e.type = "PrivateIdentifier", e;
                        }
                        isPrivateName(e) {
                            return this.getPluginOption("estree", "classFeatures") ? e.type === "PrivateIdentifier" : super.isPrivateName(e);
                        }
                        getPrivateNameSV(e) {
                            return this.getPluginOption("estree", "classFeatures") ? e.name : super.getPrivateNameSV(e);
                        }
                        parseLiteral(e, s) {
                            let i = super.parseLiteral(e, s);
                            return i.raw = i.extra.raw, delete i.extra, i;
                        }
                        parseFunctionBody(e, s) {
                            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                            super.parseFunctionBody(e, s, i), e.expression = e.body.type !== "BlockStatement";
                        }
                        parseMethod(e, s, i, a, n, o) {
                            let u = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1, c = this.startNode();
                            return c.kind = e.kind, c = super.parseMethod(c, s, i, a, n, o, u), c.type = "FunctionExpression", delete c.kind, e.value = c, o === "ClassPrivateMethod" && (e.computed = !1), this.finishNode(e, "MethodDefinition");
                        }
                        parseClassProperty() {
                            let e = super.parseClassProperty(...arguments);
                            return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition"), e;
                        }
                        parseClassPrivateProperty() {
                            let e = super.parseClassPrivateProperty(...arguments);
                            return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition", e.computed = !1), e;
                        }
                        parseObjectMethod(e, s, i, a, n) {
                            let o = super.parseObjectMethod(e, s, i, a, n);
                            return o && (o.type = "Property", o.kind === "method" && (o.kind = "init"), o.shorthand = !1), o;
                        }
                        parseObjectProperty(e, s, i, a) {
                            let n = super.parseObjectProperty(e, s, i, a);
                            return n && (n.kind = "init", n.type = "Property"), n;
                        }
                        isValidLVal(e, s, i) {
                            return e === "Property" ? "value" : super.isValidLVal(e, s, i);
                        }
                        isAssignable(e, s) {
                            return e != null && this.isObjectProperty(e) ? this.isAssignable(e.value, s) : super.isAssignable(e, s);
                        }
                        toAssignable(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                            if (e != null && this.isObjectProperty(e)) {
                                let { key: i, value: a } = e;
                                this.isPrivateName(i) && this.classScope.usePrivateName(this.getPrivateNameSV(i), i.loc.start), this.toAssignable(a, s);
                            } else super.toAssignable(e, s);
                        }
                        toAssignableObjectExpressionProp(e, s, i) {
                            e.kind === "get" || e.kind === "set" ? this.raise(f.PatternHasAccessor, {
                                at: e.key
                            }) : e.method ? this.raise(f.PatternHasMethod, {
                                at: e.key
                            }) : super.toAssignableObjectExpressionProp(e, s, i);
                        }
                        finishCallExpression(e, s) {
                            let i = super.finishCallExpression(e, s);
                            if (i.callee.type === "Import") {
                                if (i.type = "ImportExpression", i.source = i.arguments[0], this.hasPlugin("importAssertions")) {
                                    var a;
                                    i.attributes = (a = i.arguments[1]) != null ? a : null;
                                }
                                delete i.arguments, delete i.callee;
                            }
                            return i;
                        }
                        toReferencedArguments(e) {
                            e.type !== "ImportExpression" && super.toReferencedArguments(e);
                        }
                        parseExport(e, s) {
                            let i = this.state.lastTokStartLoc, a = super.parseExport(e, s);
                            switch(a.type){
                                case "ExportAllDeclaration":
                                    a.exported = null;
                                    break;
                                case "ExportNamedDeclaration":
                                    a.specifiers.length === 1 && a.specifiers[0].type === "ExportNamespaceSpecifier" && (a.type = "ExportAllDeclaration", a.exported = a.specifiers[0].exported, delete a.specifiers);
                                case "ExportDefaultDeclaration":
                                    {
                                        var n;
                                        let { declaration: o } = a;
                                        (o == null ? void 0 : o.type) === "ClassDeclaration" && ((n = o.decorators) == null ? void 0 : n.length) > 0 && o.start === a.start && this.resetStartLocation(a, i);
                                    }
                                    break;
                            }
                            return a;
                        }
                        parseSubscript(e, s, i, a) {
                            let n = super.parseSubscript(e, s, i, a);
                            if (a.optionalChainMember) {
                                if ((n.type === "OptionalMemberExpression" || n.type === "OptionalCallExpression") && (n.type = n.type.substring(8)), a.stop) {
                                    let o = this.startNodeAtNode(n);
                                    return o.expression = n, this.finishNode(o, "ChainExpression");
                                }
                            } else (n.type === "MemberExpression" || n.type === "CallExpression") && (n.optional = !1);
                            return n;
                        }
                        hasPropertyAsPrivateName(e) {
                            return e.type === "ChainExpression" && (e = e.expression), super.hasPropertyAsPrivateName(e);
                        }
                        isObjectProperty(e) {
                            return e.type === "Property" && e.kind === "init" && !e.method;
                        }
                        isObjectMethod(e) {
                            return e.method || e.kind === "get" || e.kind === "set";
                        }
                        finishNodeAt(e, s, i) {
                            return ze(super.finishNodeAt(e, s, i));
                        }
                        resetStartLocation(e, s) {
                            super.resetStartLocation(e, s), ze(e);
                        }
                        resetEndLocation(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                            super.resetEndLocation(e, s), ze(e);
                        }
                    }, Vt = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", pr = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", tl = new RegExp("[" + Vt + "]"), sl = new RegExp("[" + Vt + pr + "]");
                Vt = pr = null;
                var fr = [
                    0,
                    11,
                    2,
                    25,
                    2,
                    18,
                    2,
                    1,
                    2,
                    14,
                    3,
                    13,
                    35,
                    122,
                    70,
                    52,
                    268,
                    28,
                    4,
                    48,
                    48,
                    31,
                    14,
                    29,
                    6,
                    37,
                    11,
                    29,
                    3,
                    35,
                    5,
                    7,
                    2,
                    4,
                    43,
                    157,
                    19,
                    35,
                    5,
                    35,
                    5,
                    39,
                    9,
                    51,
                    13,
                    10,
                    2,
                    14,
                    2,
                    6,
                    2,
                    1,
                    2,
                    10,
                    2,
                    14,
                    2,
                    6,
                    2,
                    1,
                    68,
                    310,
                    10,
                    21,
                    11,
                    7,
                    25,
                    5,
                    2,
                    41,
                    2,
                    8,
                    70,
                    5,
                    3,
                    0,
                    2,
                    43,
                    2,
                    1,
                    4,
                    0,
                    3,
                    22,
                    11,
                    22,
                    10,
                    30,
                    66,
                    18,
                    2,
                    1,
                    11,
                    21,
                    11,
                    25,
                    71,
                    55,
                    7,
                    1,
                    65,
                    0,
                    16,
                    3,
                    2,
                    2,
                    2,
                    28,
                    43,
                    28,
                    4,
                    28,
                    36,
                    7,
                    2,
                    27,
                    28,
                    53,
                    11,
                    21,
                    11,
                    18,
                    14,
                    17,
                    111,
                    72,
                    56,
                    50,
                    14,
                    50,
                    14,
                    35,
                    349,
                    41,
                    7,
                    1,
                    79,
                    28,
                    11,
                    0,
                    9,
                    21,
                    43,
                    17,
                    47,
                    20,
                    28,
                    22,
                    13,
                    52,
                    58,
                    1,
                    3,
                    0,
                    14,
                    44,
                    33,
                    24,
                    27,
                    35,
                    30,
                    0,
                    3,
                    0,
                    9,
                    34,
                    4,
                    0,
                    13,
                    47,
                    15,
                    3,
                    22,
                    0,
                    2,
                    0,
                    36,
                    17,
                    2,
                    24,
                    20,
                    1,
                    64,
                    6,
                    2,
                    0,
                    2,
                    3,
                    2,
                    14,
                    2,
                    9,
                    8,
                    46,
                    39,
                    7,
                    3,
                    1,
                    3,
                    21,
                    2,
                    6,
                    2,
                    1,
                    2,
                    4,
                    4,
                    0,
                    19,
                    0,
                    13,
                    4,
                    159,
                    52,
                    19,
                    3,
                    21,
                    2,
                    31,
                    47,
                    21,
                    1,
                    2,
                    0,
                    185,
                    46,
                    42,
                    3,
                    37,
                    47,
                    21,
                    0,
                    60,
                    42,
                    14,
                    0,
                    72,
                    26,
                    38,
                    6,
                    186,
                    43,
                    117,
                    63,
                    32,
                    7,
                    3,
                    0,
                    3,
                    7,
                    2,
                    1,
                    2,
                    23,
                    16,
                    0,
                    2,
                    0,
                    95,
                    7,
                    3,
                    38,
                    17,
                    0,
                    2,
                    0,
                    29,
                    0,
                    11,
                    39,
                    8,
                    0,
                    22,
                    0,
                    12,
                    45,
                    20,
                    0,
                    19,
                    72,
                    264,
                    8,
                    2,
                    36,
                    18,
                    0,
                    50,
                    29,
                    113,
                    6,
                    2,
                    1,
                    2,
                    37,
                    22,
                    0,
                    26,
                    5,
                    2,
                    1,
                    2,
                    31,
                    15,
                    0,
                    328,
                    18,
                    16,
                    0,
                    2,
                    12,
                    2,
                    33,
                    125,
                    0,
                    80,
                    921,
                    103,
                    110,
                    18,
                    195,
                    2637,
                    96,
                    16,
                    1071,
                    18,
                    5,
                    4026,
                    582,
                    8634,
                    568,
                    8,
                    30,
                    18,
                    78,
                    18,
                    29,
                    19,
                    47,
                    17,
                    3,
                    32,
                    20,
                    6,
                    18,
                    689,
                    63,
                    129,
                    74,
                    6,
                    0,
                    67,
                    12,
                    65,
                    1,
                    2,
                    0,
                    29,
                    6135,
                    9,
                    1237,
                    43,
                    8,
                    8936,
                    3,
                    2,
                    6,
                    2,
                    1,
                    2,
                    290,
                    16,
                    0,
                    30,
                    2,
                    3,
                    0,
                    15,
                    3,
                    9,
                    395,
                    2309,
                    106,
                    6,
                    12,
                    4,
                    8,
                    8,
                    9,
                    5991,
                    84,
                    2,
                    70,
                    2,
                    1,
                    3,
                    0,
                    3,
                    1,
                    3,
                    3,
                    2,
                    11,
                    2,
                    0,
                    2,
                    6,
                    2,
                    64,
                    2,
                    3,
                    3,
                    7,
                    2,
                    6,
                    2,
                    27,
                    2,
                    3,
                    2,
                    4,
                    2,
                    0,
                    4,
                    6,
                    2,
                    339,
                    3,
                    24,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    30,
                    2,
                    24,
                    2,
                    7,
                    1845,
                    30,
                    7,
                    5,
                    262,
                    61,
                    147,
                    44,
                    11,
                    6,
                    17,
                    0,
                    322,
                    29,
                    19,
                    43,
                    485,
                    27,
                    757,
                    6,
                    2,
                    3,
                    2,
                    1,
                    2,
                    14,
                    2,
                    196,
                    60,
                    67,
                    8,
                    0,
                    1205,
                    3,
                    2,
                    26,
                    2,
                    1,
                    2,
                    0,
                    3,
                    0,
                    2,
                    9,
                    2,
                    3,
                    2,
                    0,
                    2,
                    0,
                    7,
                    0,
                    5,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    2,
                    2,
                    1,
                    2,
                    0,
                    3,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    0,
                    2,
                    1,
                    2,
                    0,
                    3,
                    3,
                    2,
                    6,
                    2,
                    3,
                    2,
                    3,
                    2,
                    0,
                    2,
                    9,
                    2,
                    16,
                    6,
                    2,
                    2,
                    4,
                    2,
                    16,
                    4421,
                    42719,
                    33,
                    4153,
                    7,
                    221,
                    3,
                    5761,
                    15,
                    7472,
                    3104,
                    541,
                    1507,
                    4938,
                    6,
                    4191
                ], rl = [
                    509,
                    0,
                    227,
                    0,
                    150,
                    4,
                    294,
                    9,
                    1368,
                    2,
                    2,
                    1,
                    6,
                    3,
                    41,
                    2,
                    5,
                    0,
                    166,
                    1,
                    574,
                    3,
                    9,
                    9,
                    370,
                    1,
                    81,
                    2,
                    71,
                    10,
                    50,
                    3,
                    123,
                    2,
                    54,
                    14,
                    32,
                    10,
                    3,
                    1,
                    11,
                    3,
                    46,
                    10,
                    8,
                    0,
                    46,
                    9,
                    7,
                    2,
                    37,
                    13,
                    2,
                    9,
                    6,
                    1,
                    45,
                    0,
                    13,
                    2,
                    49,
                    13,
                    9,
                    3,
                    2,
                    11,
                    83,
                    11,
                    7,
                    0,
                    3,
                    0,
                    158,
                    11,
                    6,
                    9,
                    7,
                    3,
                    56,
                    1,
                    2,
                    6,
                    3,
                    1,
                    3,
                    2,
                    10,
                    0,
                    11,
                    1,
                    3,
                    6,
                    4,
                    4,
                    193,
                    17,
                    10,
                    9,
                    5,
                    0,
                    82,
                    19,
                    13,
                    9,
                    214,
                    6,
                    3,
                    8,
                    28,
                    1,
                    83,
                    16,
                    16,
                    9,
                    82,
                    12,
                    9,
                    9,
                    84,
                    14,
                    5,
                    9,
                    243,
                    14,
                    166,
                    9,
                    71,
                    5,
                    2,
                    1,
                    3,
                    3,
                    2,
                    0,
                    2,
                    1,
                    13,
                    9,
                    120,
                    6,
                    3,
                    6,
                    4,
                    0,
                    29,
                    9,
                    41,
                    6,
                    2,
                    3,
                    9,
                    0,
                    10,
                    10,
                    47,
                    15,
                    406,
                    7,
                    2,
                    7,
                    17,
                    9,
                    57,
                    21,
                    2,
                    13,
                    123,
                    5,
                    4,
                    0,
                    2,
                    1,
                    2,
                    6,
                    2,
                    0,
                    9,
                    9,
                    49,
                    4,
                    2,
                    1,
                    2,
                    4,
                    9,
                    9,
                    330,
                    3,
                    10,
                    1,
                    2,
                    0,
                    49,
                    6,
                    4,
                    4,
                    14,
                    9,
                    5351,
                    0,
                    7,
                    14,
                    13835,
                    9,
                    87,
                    9,
                    39,
                    4,
                    60,
                    6,
                    26,
                    9,
                    1014,
                    0,
                    2,
                    54,
                    8,
                    3,
                    82,
                    0,
                    12,
                    1,
                    19628,
                    1,
                    4706,
                    45,
                    3,
                    22,
                    543,
                    4,
                    4,
                    5,
                    9,
                    7,
                    3,
                    6,
                    31,
                    3,
                    149,
                    2,
                    1418,
                    49,
                    513,
                    54,
                    5,
                    49,
                    9,
                    0,
                    15,
                    0,
                    23,
                    4,
                    2,
                    14,
                    1361,
                    6,
                    2,
                    16,
                    3,
                    6,
                    2,
                    1,
                    2,
                    4,
                    101,
                    0,
                    161,
                    6,
                    10,
                    9,
                    357,
                    0,
                    62,
                    13,
                    499,
                    13,
                    983,
                    6,
                    110,
                    6,
                    6,
                    9,
                    4759,
                    9,
                    787719,
                    239
                ];
                function Kt(t, r) {
                    let e = 65536;
                    for(let s = 0, i = r.length; s < i; s += 2){
                        if (e += r[s], e > t) return !1;
                        if (e += r[s + 1], e >= t) return !0;
                    }
                    return !1;
                }
                function fe(t) {
                    return t < 65 ? t === 36 : t <= 90 ? !0 : t < 97 ? t === 95 : t <= 122 ? !0 : t <= 65535 ? t >= 170 && tl.test(String.fromCharCode(t)) : Kt(t, fr);
                }
                function De(t) {
                    return t < 48 ? t === 36 : t < 58 ? !0 : t < 65 ? !1 : t <= 90 ? !0 : t < 97 ? t === 95 : t <= 122 ? !0 : t <= 65535 ? t >= 170 && sl.test(String.fromCharCode(t)) : Kt(t, fr) || Kt(t, rl);
                }
                var Wt = {
                    keyword: [
                        "break",
                        "case",
                        "catch",
                        "continue",
                        "debugger",
                        "default",
                        "do",
                        "else",
                        "finally",
                        "for",
                        "function",
                        "if",
                        "return",
                        "switch",
                        "throw",
                        "try",
                        "var",
                        "const",
                        "while",
                        "with",
                        "new",
                        "this",
                        "super",
                        "class",
                        "extends",
                        "export",
                        "import",
                        "null",
                        "true",
                        "false",
                        "in",
                        "instanceof",
                        "typeof",
                        "void",
                        "delete"
                    ],
                    strict: [
                        "implements",
                        "interface",
                        "let",
                        "package",
                        "private",
                        "protected",
                        "public",
                        "static",
                        "yield"
                    ],
                    strictBind: [
                        "eval",
                        "arguments"
                    ]
                }, il = new Set(Wt.keyword), al = new Set(Wt.strict), nl = new Set(Wt.strictBind);
                function dr(t, r) {
                    return r && t === "await" || t === "enum";
                }
                function mr(t, r) {
                    return dr(t, r) || al.has(t);
                }
                function yr(t) {
                    return nl.has(t);
                }
                function xr(t, r) {
                    return mr(t, r) || yr(t);
                }
                function ol(t) {
                    return il.has(t);
                }
                function ll(t, r, e) {
                    return t === 64 && r === 64 && fe(e);
                }
                var hl = new Set([
                    "break",
                    "case",
                    "catch",
                    "continue",
                    "debugger",
                    "default",
                    "do",
                    "else",
                    "finally",
                    "for",
                    "function",
                    "if",
                    "return",
                    "switch",
                    "throw",
                    "try",
                    "var",
                    "const",
                    "while",
                    "with",
                    "new",
                    "this",
                    "super",
                    "class",
                    "extends",
                    "export",
                    "import",
                    "null",
                    "true",
                    "false",
                    "in",
                    "instanceof",
                    "typeof",
                    "void",
                    "delete",
                    "implements",
                    "interface",
                    "let",
                    "package",
                    "private",
                    "protected",
                    "public",
                    "static",
                    "yield",
                    "eval",
                    "arguments",
                    "enum",
                    "await"
                ]);
                function ul(t) {
                    return hl.has(t);
                }
                var Fe = 0, Le = 1, de = 2, Gt = 4, gr = 8, ht = 16, Pr = 32, Ee = 64, ut = 128, Oe = 256, ct = Le | de | ut | Oe, le = 1, Ce = 2, Ar = 4, be = 8, pt = 16, Tr = 64, ft = 128, Jt = 256, Xt = 512, Yt = 1024, Qt = 2048, Ve = 4096, dt = 8192, vr = le | Ce | be | ft | dt, Be = le | 0 | be | dt, cl = le | 0 | be | 0, mt = le | 0 | Ar | 0, Er = le | 0 | pt | 0, pl = 0 | Ce | 0 | ft, fl = 0 | Ce | 0, Cr = le | Ce | be | Jt | dt, br = 0 | Yt, Pe = 0 | Tr, dl = le | 0 | Tr, ml = Cr | Xt, yl = 0 | Yt, Sr = 0 | Ce | 0 | Ve, xl = Qt, yt = 4, Zt = 2, es = 1, ts = Zt | es, gl = Zt | yt, Pl = es | yt, Al = Zt, Tl = es, ss = 0, rs = class {
                    constructor(t){
                        this.var = new Set, this.lexical = new Set, this.functions = new Set, this.flags = t;
                    }
                }, is = class {
                    constructor(t, r){
                        this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = new Map, this.parser = t, this.inModule = r;
                    }
                    get inTopLevel() {
                        return (this.currentScope().flags & Le) > 0;
                    }
                    get inFunction() {
                        return (this.currentVarScopeFlags() & de) > 0;
                    }
                    get allowSuper() {
                        return (this.currentThisScopeFlags() & ht) > 0;
                    }
                    get allowDirectSuper() {
                        return (this.currentThisScopeFlags() & Pr) > 0;
                    }
                    get inClass() {
                        return (this.currentThisScopeFlags() & Ee) > 0;
                    }
                    get inClassAndNotInNonArrowFunction() {
                        let t = this.currentThisScopeFlags();
                        return (t & Ee) > 0 && (t & de) === 0;
                    }
                    get inStaticBlock() {
                        for(let t = this.scopeStack.length - 1;; t--){
                            let { flags: r } = this.scopeStack[t];
                            if (r & ut) return !0;
                            if (r & (ct | Ee)) return !1;
                        }
                    }
                    get inNonArrowFunction() {
                        return (this.currentThisScopeFlags() & de) > 0;
                    }
                    get treatFunctionsAsVar() {
                        return this.treatFunctionsAsVarInScope(this.currentScope());
                    }
                    createScope(t) {
                        return new rs(t);
                    }
                    enter(t) {
                        this.scopeStack.push(this.createScope(t));
                    }
                    exit() {
                        return this.scopeStack.pop().flags;
                    }
                    treatFunctionsAsVarInScope(t) {
                        return !!(t.flags & (de | ut) || !this.parser.inModule && t.flags & Le);
                    }
                    declareName(t, r, e) {
                        let s = this.currentScope();
                        if (r & be || r & pt) this.checkRedeclarationInScope(s, t, r, e), r & pt ? s.functions.add(t) : s.lexical.add(t), r & be && this.maybeExportDefined(s, t);
                        else if (r & Ar) for(let i = this.scopeStack.length - 1; i >= 0 && (s = this.scopeStack[i], this.checkRedeclarationInScope(s, t, r, e), s.var.add(t), this.maybeExportDefined(s, t), !(s.flags & ct)); --i);
                        this.parser.inModule && s.flags & Le && this.undefinedExports.delete(t);
                    }
                    maybeExportDefined(t, r) {
                        this.parser.inModule && t.flags & Le && this.undefinedExports.delete(r);
                    }
                    checkRedeclarationInScope(t, r, e, s) {
                        this.isRedeclaredInScope(t, r, e) && this.parser.raise(f.VarRedeclaration, {
                            at: s,
                            identifierName: r
                        });
                    }
                    isRedeclaredInScope(t, r, e) {
                        return e & le ? e & be ? t.lexical.has(r) || t.functions.has(r) || t.var.has(r) : e & pt ? t.lexical.has(r) || !this.treatFunctionsAsVarInScope(t) && t.var.has(r) : t.lexical.has(r) && !(t.flags & gr && t.lexical.values().next().value === r) || !this.treatFunctionsAsVarInScope(t) && t.functions.has(r) : !1;
                    }
                    checkLocalExport(t) {
                        let { name: r } = t, e = this.scopeStack[0];
                        !e.lexical.has(r) && !e.var.has(r) && !e.functions.has(r) && this.undefinedExports.set(r, t.loc.start);
                    }
                    currentScope() {
                        return this.scopeStack[this.scopeStack.length - 1];
                    }
                    currentVarScopeFlags() {
                        for(let t = this.scopeStack.length - 1;; t--){
                            let { flags: r } = this.scopeStack[t];
                            if (r & ct) return r;
                        }
                    }
                    currentThisScopeFlags() {
                        for(let t = this.scopeStack.length - 1;; t--){
                            let { flags: r } = this.scopeStack[t];
                            if (r & (ct | Ee) && !(r & Gt)) return r;
                        }
                    }
                }, vl = class extends rs {
                    constructor(){
                        super(...arguments), this.declareFunctions = new Set;
                    }
                }, El = class extends is {
                    createScope(t) {
                        return new vl(t);
                    }
                    declareName(t, r, e) {
                        let s = this.currentScope();
                        if (r & Qt) {
                            this.checkRedeclarationInScope(s, t, r, e), this.maybeExportDefined(s, t), s.declareFunctions.add(t);
                            return;
                        }
                        super.declareName(t, r, e);
                    }
                    isRedeclaredInScope(t, r, e) {
                        return super.isRedeclaredInScope(t, r, e) ? !0 : e & Qt ? !t.declareFunctions.has(r) && (t.lexical.has(r) || t.functions.has(r)) : !1;
                    }
                    checkLocalExport(t) {
                        this.scopeStack[0].declareFunctions.has(t.name) || super.checkLocalExport(t);
                    }
                }, Cl = class {
                    constructor(){
                        this.sawUnambiguousESM = !1, this.ambiguousScriptDifferentAst = !1;
                    }
                    hasPlugin(t) {
                        if (typeof t == "string") return this.plugins.has(t);
                        {
                            let [r, e] = t;
                            if (!this.hasPlugin(r)) return !1;
                            let s = this.plugins.get(r);
                            for (let i of Object.keys(e))if ((s == null ? void 0 : s[i]) !== e[i]) return !1;
                            return !0;
                        }
                    }
                    getPluginOption(t, r) {
                        var e;
                        return (e = this.plugins.get(t)) == null ? void 0 : e[r];
                    }
                };
                function wr(t, r) {
                    t.trailingComments === void 0 ? t.trailingComments = r : t.trailingComments.unshift(...r);
                }
                function bl(t, r) {
                    t.leadingComments === void 0 ? t.leadingComments = r : t.leadingComments.unshift(...r);
                }
                function Ke(t, r) {
                    t.innerComments === void 0 ? t.innerComments = r : t.innerComments.unshift(...r);
                }
                function We(t, r, e) {
                    let s = null, i = r.length;
                    for(; s === null && i > 0;)s = r[--i];
                    s === null || s.start > e.start ? Ke(t, e.comments) : wr(s, e.comments);
                }
                var Sl = class extends Cl {
                    addComment(t) {
                        this.filename && (t.loc.filename = this.filename), this.state.comments.push(t);
                    }
                    processComment(t) {
                        let { commentStack: r } = this.state, e = r.length;
                        if (e === 0) return;
                        let s = e - 1, i = r[s];
                        i.start === t.end && (i.leadingNode = t, s--);
                        let { start: a } = t;
                        for(; s >= 0; s--){
                            let n = r[s], o = n.end;
                            if (o > a) n.containingNode = t, this.finalizeComment(n), r.splice(s, 1);
                            else {
                                o === a && (n.trailingNode = t);
                                break;
                            }
                        }
                    }
                    finalizeComment(t) {
                        let { comments: r } = t;
                        if (t.leadingNode !== null || t.trailingNode !== null) t.leadingNode !== null && wr(t.leadingNode, r), t.trailingNode !== null && bl(t.trailingNode, r);
                        else {
                            let { containingNode: e, start: s } = t;
                            if (this.input.charCodeAt(s - 1) === 44) switch(e.type){
                                case "ObjectExpression":
                                case "ObjectPattern":
                                case "RecordExpression":
                                    We(e, e.properties, t);
                                    break;
                                case "CallExpression":
                                case "OptionalCallExpression":
                                    We(e, e.arguments, t);
                                    break;
                                case "FunctionDeclaration":
                                case "FunctionExpression":
                                case "ArrowFunctionExpression":
                                case "ObjectMethod":
                                case "ClassMethod":
                                case "ClassPrivateMethod":
                                    We(e, e.params, t);
                                    break;
                                case "ArrayExpression":
                                case "ArrayPattern":
                                case "TupleExpression":
                                    We(e, e.elements, t);
                                    break;
                                case "ExportNamedDeclaration":
                                case "ImportDeclaration":
                                    We(e, e.specifiers, t);
                                    break;
                                default:
                                    Ke(e, r);
                            }
                            else Ke(e, r);
                        }
                    }
                    finalizeRemainingComments() {
                        let { commentStack: t } = this.state;
                        for(let r = t.length - 1; r >= 0; r--)this.finalizeComment(t[r]);
                        this.state.commentStack = [];
                    }
                    resetPreviousNodeTrailingComments(t) {
                        let { commentStack: r } = this.state, { length: e } = r;
                        if (e === 0) return;
                        let s = r[e - 1];
                        s.leadingNode === t && (s.leadingNode = null);
                    }
                    takeSurroundingComments(t, r, e) {
                        let { commentStack: s } = this.state, i = s.length;
                        if (i === 0) return;
                        let a = i - 1;
                        for(; a >= 0; a--){
                            let n = s[a], o = n.end;
                            if (n.start === e) n.leadingNode = t;
                            else if (o === r) n.trailingNode = t;
                            else if (o < r) break;
                        }
                    }
                }, as = /\r\n?|[\n\u2028\u2029]/, xt = new RegExp(as.source, "g");
                function Ge(t) {
                    switch(t){
                        case 10:
                        case 13:
                        case 8232:
                        case 8233:
                            return !0;
                        default:
                            return !1;
                    }
                }
                var ns = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, wl = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, Ir = new RegExp("(?=(" + wl.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
                function Il(t) {
                    switch(t){
                        case 9:
                        case 11:
                        case 12:
                        case 32:
                        case 160:
                        case 5760:
                        case 8192:
                        case 8193:
                        case 8194:
                        case 8195:
                        case 8196:
                        case 8197:
                        case 8198:
                        case 8199:
                        case 8200:
                        case 8201:
                        case 8202:
                        case 8239:
                        case 8287:
                        case 12288:
                        case 65279:
                            return !0;
                        default:
                            return !1;
                    }
                }
                var Nr = class {
                    constructor(){
                        this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = !1, this.inType = !1, this.noAnonFunctionType = !1, this.hasFlowComment = !1, this.isAmbientContext = !1, this.inAbstractClass = !1, this.inDisallowConditionalTypesContext = !1, this.topicContext = {
                            maxNumOfResolvableTopics: 0,
                            maxTopicIndex: null
                        }, this.soloAwait = !1, this.inFSharpPipelineDirectBody = !1, this.labels = [], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 137, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [
                            x.brace
                        ], this.canStartJSXElement = !0, this.containsEsc = !1, this.firstInvalidTemplateEscapePos = null, this.strictErrors = new Map, this.tokensLength = 0;
                    }
                    init(t) {
                        let { strictMode: r, sourceType: e, startLine: s, startColumn: i } = t;
                        this.strict = r === !1 ? !1 : r === !0 ? !0 : e === "module", this.curLine = s, this.lineStart = -i, this.startLoc = this.endLoc = new ge(s, i, 0);
                    }
                    curPosition() {
                        return new ge(this.curLine, this.pos - this.lineStart, this.pos);
                    }
                    clone(t) {
                        let r = new Nr, e = Object.keys(this);
                        for(let s = 0, i = e.length; s < i; s++){
                            let a = e[s], n = this[a];
                            !t && Array.isArray(n) && (n = n.slice()), r[a] = n;
                        }
                        return r;
                    }
                }, Nl = function(r) {
                    return r >= 48 && r <= 57;
                }, kr = {
                    decBinOct: new Set([
                        46,
                        66,
                        69,
                        79,
                        95,
                        98,
                        101,
                        111
                    ]),
                    hex: new Set([
                        46,
                        88,
                        95,
                        120
                    ])
                }, gt = {
                    bin: (t)=>t === 48 || t === 49,
                    oct: (t)=>t >= 48 && t <= 55,
                    dec: (t)=>t >= 48 && t <= 57,
                    hex: (t)=>t >= 48 && t <= 57 || t >= 65 && t <= 70 || t >= 97 && t <= 102
                };
                function Dr(t, r, e, s, i, a) {
                    let n = e, o = s, u = i, c = "", y = null, g = e, { length: T } = r;
                    for(;;){
                        if (e >= T) {
                            a.unterminated(n, o, u), c += r.slice(g, e);
                            break;
                        }
                        let C = r.charCodeAt(e);
                        if (kl(t, C, r, e)) {
                            c += r.slice(g, e);
                            break;
                        }
                        if (C === 92) {
                            c += r.slice(g, e);
                            let M = Dl(r, e, s, i, t === "template", a);
                            M.ch === null && !y ? y = {
                                pos: e,
                                lineStart: s,
                                curLine: i
                            } : c += M.ch, ({ pos: e, lineStart: s, curLine: i } = M), g = e;
                        } else C === 8232 || C === 8233 ? (++e, ++i, s = e) : C === 10 || C === 13 ? t === "template" ? (c += r.slice(g, e) + `
`, ++e, C === 13 && r.charCodeAt(e) === 10 && ++e, ++i, g = s = e) : a.unterminated(n, o, u) : ++e;
                    }
                    return {
                        pos: e,
                        str: c,
                        firstInvalidLoc: y,
                        lineStart: s,
                        curLine: i,
                        containsInvalid: !!y
                    };
                }
                function kl(t, r, e, s) {
                    return t === "template" ? r === 96 || r === 36 && e.charCodeAt(s + 1) === 123 : r === (t === "double" ? 34 : 39);
                }
                function Dl(t, r, e, s, i, a) {
                    let n = !i;
                    r++;
                    let o = (c)=>({
                            pos: r,
                            ch: c,
                            lineStart: e,
                            curLine: s
                        }), u = t.charCodeAt(r++);
                    switch(u){
                        case 110:
                            return o(`
`);
                        case 114:
                            return o("\r");
                        case 120:
                            {
                                let c;
                                return { code: c, pos: r } = os(t, r, e, s, 2, !1, n, a), o(c === null ? null : String.fromCharCode(c));
                            }
                        case 117:
                            {
                                let c;
                                return { code: c, pos: r } = Lr(t, r, e, s, n, a), o(c === null ? null : String.fromCodePoint(c));
                            }
                        case 116:
                            return o("	");
                        case 98:
                            return o("\b");
                        case 118:
                            return o("\v");
                        case 102:
                            return o("\f");
                        case 13:
                            t.charCodeAt(r) === 10 && ++r;
                        case 10:
                            e = r, ++s;
                        case 8232:
                        case 8233:
                            return o("");
                        case 56:
                        case 57:
                            if (i) return o(null);
                            a.strictNumericEscape(r - 1, e, s);
                        default:
                            if (u >= 48 && u <= 55) {
                                let c = r - 1, g = t.slice(c, r + 2).match(/^[0-7]+/)[0], T = parseInt(g, 8);
                                T > 255 && (g = g.slice(0, -1), T = parseInt(g, 8)), r += g.length - 1;
                                let C = t.charCodeAt(r);
                                if (g !== "0" || C === 56 || C === 57) {
                                    if (i) return o(null);
                                    a.strictNumericEscape(c, e, s);
                                }
                                return o(String.fromCharCode(T));
                            }
                            return o(String.fromCharCode(u));
                    }
                }
                function os(t, r, e, s, i, a, n, o) {
                    let u = r, c;
                    return { n: c, pos: r } = Fr(t, r, e, s, 16, i, a, !1, o, !n), c === null && (n ? o.invalidEscapeSequence(u, e, s) : r = u - 1), {
                        code: c,
                        pos: r
                    };
                }
                function Fr(t, r, e, s, i, a, n, o, u, c) {
                    let y = r, g = i === 16 ? kr.hex : kr.decBinOct, T = i === 16 ? gt.hex : i === 10 ? gt.dec : i === 8 ? gt.oct : gt.bin, C = !1, M = 0;
                    for(let j = 0, K = a == null ? 1 / 0 : a; j < K; ++j){
                        let W = t.charCodeAt(r), V;
                        if (W === 95 && o !== "bail") {
                            let X = t.charCodeAt(r - 1), je = t.charCodeAt(r + 1);
                            if (o) {
                                if (Number.isNaN(je) || !T(je) || g.has(X) || g.has(je)) {
                                    if (c) return {
                                        n: null,
                                        pos: r
                                    };
                                    u.unexpectedNumericSeparator(r, e, s);
                                }
                            } else {
                                if (c) return {
                                    n: null,
                                    pos: r
                                };
                                u.numericSeparatorInEscapeSequence(r, e, s);
                            }
                            ++r;
                            continue;
                        }
                        if (W >= 97 ? V = W - 97 + 10 : W >= 65 ? V = W - 65 + 10 : Nl(W) ? V = W - 48 : V = 1 / 0, V >= i) {
                            if (V <= 9 && c) return {
                                n: null,
                                pos: r
                            };
                            if (V <= 9 && u.invalidDigit(r, e, s, i)) V = 0;
                            else if (n) V = 0, C = !0;
                            else break;
                        }
                        ++r, M = M * i + V;
                    }
                    return r === y || a != null && r - y !== a || C ? {
                        n: null,
                        pos: r
                    } : {
                        n: M,
                        pos: r
                    };
                }
                function Lr(t, r, e, s, i, a) {
                    let n = t.charCodeAt(r), o;
                    if (n === 123) {
                        if (++r, { code: o, pos: r } = os(t, r, e, s, t.indexOf("}", r) - r, !0, i, a), ++r, o !== null && o > 1114111) {
                            if (i) a.invalidCodePoint(r, e, s);
                            else return {
                                code: null,
                                pos: r
                            };
                        }
                    } else ({ code: o, pos: r } = os(t, r, e, s, 4, !1, i, a));
                    return {
                        code: o,
                        pos: r
                    };
                }
                var Fl = [
                    "at"
                ], Ll = [
                    "at"
                ];
                function Je(t, r, e) {
                    return new ge(e, t - r, t);
                }
                var Ol = new Set([
                    103,
                    109,
                    115,
                    105,
                    121,
                    117,
                    100,
                    118
                ]), Ae = class {
                    constructor(t){
                        this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, this.loc = new lt(t.startLoc, t.endLoc);
                    }
                }, Bl = class extends Sl {
                    constructor(t, r){
                        super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = {
                            invalidDigit: (e, s, i, a)=>this.options.errorRecovery ? (this.raise(f.InvalidDigit, {
                                    at: Je(e, s, i),
                                    radix: a
                                }), !0) : !1,
                            numericSeparatorInEscapeSequence: this.errorBuilder(f.NumericSeparatorInEscapeSequence),
                            unexpectedNumericSeparator: this.errorBuilder(f.UnexpectedNumericSeparator)
                        }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, {
                            invalidEscapeSequence: this.errorBuilder(f.InvalidEscapeSequence),
                            invalidCodePoint: this.errorBuilder(f.InvalidCodePoint)
                        }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, {
                            strictNumericEscape: (e, s, i)=>{
                                this.recordStrictModeErrors(f.StrictNumericEscape, {
                                    at: Je(e, s, i)
                                });
                            },
                            unterminated: (e, s, i)=>{
                                throw this.raise(f.UnterminatedString, {
                                    at: Je(e - 1, s, i)
                                });
                            }
                        }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, {
                            strictNumericEscape: this.errorBuilder(f.StrictNumericEscape),
                            unterminated: (e, s, i)=>{
                                throw this.raise(f.UnterminatedTemplate, {
                                    at: Je(e, s, i)
                                });
                            }
                        }), this.state = new Nr, this.state.init(t), this.input = r, this.length = r.length, this.isLookahead = !1;
                    }
                    pushToken(t) {
                        this.tokens.length = this.state.tokensLength, this.tokens.push(t), ++this.state.tokensLength;
                    }
                    next() {
                        this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new Ae(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
                    }
                    eat(t) {
                        return this.match(t) ? (this.next(), !0) : !1;
                    }
                    match(t) {
                        return this.state.type === t;
                    }
                    createLookaheadState(t) {
                        return {
                            pos: t.pos,
                            value: null,
                            type: t.type,
                            start: t.start,
                            end: t.end,
                            context: [
                                this.curContext()
                            ],
                            inType: t.inType,
                            startLoc: t.startLoc,
                            lastTokEndLoc: t.lastTokEndLoc,
                            curLine: t.curLine,
                            lineStart: t.lineStart,
                            curPosition: t.curPosition
                        };
                    }
                    lookahead() {
                        let t = this.state;
                        this.state = this.createLookaheadState(t), this.isLookahead = !0, this.nextToken(), this.isLookahead = !1;
                        let r = this.state;
                        return this.state = t, r;
                    }
                    nextTokenStart() {
                        return this.nextTokenStartSince(this.state.pos);
                    }
                    nextTokenStartSince(t) {
                        return ns.lastIndex = t, ns.test(this.input) ? ns.lastIndex : t;
                    }
                    lookaheadCharCode() {
                        return this.input.charCodeAt(this.nextTokenStart());
                    }
                    codePointAtPos(t) {
                        let r = this.input.charCodeAt(t);
                        if ((r & 64512) === 55296 && ++t < this.input.length) {
                            let e = this.input.charCodeAt(t);
                            (e & 64512) === 56320 && (r = 65536 + ((r & 1023) << 10) + (e & 1023));
                        }
                        return r;
                    }
                    setStrict(t) {
                        this.state.strict = t, t && (this.state.strictErrors.forEach((r)=>{
                            let [e, s] = r;
                            return this.raise(e, {
                                at: s
                            });
                        }), this.state.strictErrors.clear());
                    }
                    curContext() {
                        return this.state.context[this.state.context.length - 1];
                    }
                    nextToken() {
                        if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
                            this.finishToken(137);
                            return;
                        }
                        this.getTokenFromCode(this.codePointAtPos(this.state.pos));
                    }
                    skipBlockComment(t) {
                        let r;
                        this.isLookahead || (r = this.state.curPosition());
                        let e = this.state.pos, s = this.input.indexOf(t, e + 2);
                        if (s === -1) throw this.raise(f.UnterminatedComment, {
                            at: this.state.curPosition()
                        });
                        for(this.state.pos = s + t.length, xt.lastIndex = e + 2; xt.test(this.input) && xt.lastIndex <= s;)++this.state.curLine, this.state.lineStart = xt.lastIndex;
                        if (this.isLookahead) return;
                        let i = {
                            type: "CommentBlock",
                            value: this.input.slice(e + 2, s),
                            start: e,
                            end: s + t.length,
                            loc: new lt(r, this.state.curPosition())
                        };
                        return this.options.tokens && this.pushToken(i), i;
                    }
                    skipLineComment(t) {
                        let r = this.state.pos, e;
                        this.isLookahead || (e = this.state.curPosition());
                        let s = this.input.charCodeAt(this.state.pos += t);
                        if (this.state.pos < this.length) for(; !Ge(s) && ++this.state.pos < this.length;)s = this.input.charCodeAt(this.state.pos);
                        if (this.isLookahead) return;
                        let i = this.state.pos, n = {
                            type: "CommentLine",
                            value: this.input.slice(r + t, i),
                            start: r,
                            end: i,
                            loc: new lt(e, this.state.curPosition())
                        };
                        return this.options.tokens && this.pushToken(n), n;
                    }
                    skipSpace() {
                        let t = this.state.pos, r = [];
                        e: for(; this.state.pos < this.length;){
                            let e = this.input.charCodeAt(this.state.pos);
                            switch(e){
                                case 32:
                                case 160:
                                case 9:
                                    ++this.state.pos;
                                    break;
                                case 13:
                                    this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                                case 10:
                                case 8232:
                                case 8233:
                                    ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                                    break;
                                case 47:
                                    switch(this.input.charCodeAt(this.state.pos + 1)){
                                        case 42:
                                            {
                                                let s = this.skipBlockComment("*/");
                                                s !== void 0 && (this.addComment(s), this.options.attachComment && r.push(s));
                                                break;
                                            }
                                        case 47:
                                            {
                                                let s = this.skipLineComment(2);
                                                s !== void 0 && (this.addComment(s), this.options.attachComment && r.push(s));
                                                break;
                                            }
                                        default:
                                            break e;
                                    }
                                    break;
                                default:
                                    if (Il(e)) ++this.state.pos;
                                    else if (e === 45 && !this.inModule && this.options.annexB) {
                                        let s = this.state.pos;
                                        if (this.input.charCodeAt(s + 1) === 45 && this.input.charCodeAt(s + 2) === 62 && (t === 0 || this.state.lineStart > t)) {
                                            let i = this.skipLineComment(3);
                                            i !== void 0 && (this.addComment(i), this.options.attachComment && r.push(i));
                                        } else break e;
                                    } else if (e === 60 && !this.inModule && this.options.annexB) {
                                        let s = this.state.pos;
                                        if (this.input.charCodeAt(s + 1) === 33 && this.input.charCodeAt(s + 2) === 45 && this.input.charCodeAt(s + 3) === 45) {
                                            let i = this.skipLineComment(4);
                                            i !== void 0 && (this.addComment(i), this.options.attachComment && r.push(i));
                                        } else break e;
                                    } else break e;
                            }
                        }
                        if (r.length > 0) {
                            let e = this.state.pos, s = {
                                start: t,
                                end: e,
                                comments: r,
                                leadingNode: null,
                                trailingNode: null,
                                containingNode: null
                            };
                            this.state.commentStack.push(s);
                        }
                    }
                    finishToken(t, r) {
                        this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
                        let e = this.state.type;
                        this.state.type = t, this.state.value = r, this.isLookahead || this.updateContext(e);
                    }
                    replaceToken(t) {
                        this.state.type = t, this.updateContext();
                    }
                    readToken_numberSign() {
                        if (this.state.pos === 0 && this.readToken_interpreter()) return;
                        let t = this.state.pos + 1, r = this.codePointAtPos(t);
                        if (r >= 48 && r <= 57) throw this.raise(f.UnexpectedDigitAfterHash, {
                            at: this.state.curPosition()
                        });
                        if (r === 123 || r === 91 && this.hasPlugin("recordAndTuple")) {
                            if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar") throw this.raise(r === 123 ? f.RecordExpressionHashIncorrectStartSyntaxType : f.TupleExpressionHashIncorrectStartSyntaxType, {
                                at: this.state.curPosition()
                            });
                            this.state.pos += 2, r === 123 ? this.finishToken(7) : this.finishToken(1);
                        } else fe(r) ? (++this.state.pos, this.finishToken(136, this.readWord1(r))) : r === 92 ? (++this.state.pos, this.finishToken(136, this.readWord1())) : this.finishOp(27, 1);
                    }
                    readToken_dot() {
                        let t = this.input.charCodeAt(this.state.pos + 1);
                        if (t >= 48 && t <= 57) {
                            this.readNumber(!0);
                            return;
                        }
                        t === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
                    }
                    readToken_slash() {
                        this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
                    }
                    readToken_interpreter() {
                        if (this.state.pos !== 0 || this.length < 2) return !1;
                        let t = this.input.charCodeAt(this.state.pos + 1);
                        if (t !== 33) return !1;
                        let r = this.state.pos;
                        for(this.state.pos += 1; !Ge(t) && ++this.state.pos < this.length;)t = this.input.charCodeAt(this.state.pos);
                        let e = this.input.slice(r + 2, this.state.pos);
                        return this.finishToken(28, e), !0;
                    }
                    readToken_mult_modulo(t) {
                        let r = t === 42 ? 55 : 54, e = 1, s = this.input.charCodeAt(this.state.pos + 1);
                        t === 42 && s === 42 && (e++, s = this.input.charCodeAt(this.state.pos + 2), r = 57), s === 61 && !this.state.inType && (e++, r = t === 37 ? 33 : 30), this.finishOp(r, e);
                    }
                    readToken_pipe_amp(t) {
                        let r = this.input.charCodeAt(this.state.pos + 1);
                        if (r === t) {
                            this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t === 124 ? 41 : 42, 2);
                            return;
                        }
                        if (t === 124) {
                            if (r === 62) {
                                this.finishOp(39, 2);
                                return;
                            }
                            if (this.hasPlugin("recordAndTuple") && r === 125) {
                                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(f.RecordExpressionBarIncorrectEndSyntaxType, {
                                    at: this.state.curPosition()
                                });
                                this.state.pos += 2, this.finishToken(9);
                                return;
                            }
                            if (this.hasPlugin("recordAndTuple") && r === 93) {
                                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(f.TupleExpressionBarIncorrectEndSyntaxType, {
                                    at: this.state.curPosition()
                                });
                                this.state.pos += 2, this.finishToken(4);
                                return;
                            }
                        }
                        if (r === 61) {
                            this.finishOp(30, 2);
                            return;
                        }
                        this.finishOp(t === 124 ? 43 : 45, 1);
                    }
                    readToken_caret() {
                        let t = this.input.charCodeAt(this.state.pos + 1);
                        t === 61 && !this.state.inType ? this.finishOp(32, 2) : t === 94 && this.hasPlugin([
                            "pipelineOperator",
                            {
                                proposal: "hack",
                                topicToken: "^^"
                            }
                        ]) ? (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94 && this.unexpected()) : this.finishOp(44, 1);
                    }
                    readToken_atSign() {
                        this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin([
                            "pipelineOperator",
                            {
                                proposal: "hack",
                                topicToken: "@@"
                            }
                        ]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
                    }
                    readToken_plus_min(t) {
                        let r = this.input.charCodeAt(this.state.pos + 1);
                        if (r === t) {
                            this.finishOp(34, 2);
                            return;
                        }
                        r === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
                    }
                    readToken_lt() {
                        let { pos: t } = this.state, r = this.input.charCodeAt(t + 1);
                        if (r === 60) {
                            if (this.input.charCodeAt(t + 2) === 61) {
                                this.finishOp(30, 3);
                                return;
                            }
                            this.finishOp(51, 2);
                            return;
                        }
                        if (r === 61) {
                            this.finishOp(49, 2);
                            return;
                        }
                        this.finishOp(47, 1);
                    }
                    readToken_gt() {
                        let { pos: t } = this.state, r = this.input.charCodeAt(t + 1);
                        if (r === 62) {
                            let e = this.input.charCodeAt(t + 2) === 62 ? 3 : 2;
                            if (this.input.charCodeAt(t + e) === 61) {
                                this.finishOp(30, e + 1);
                                return;
                            }
                            this.finishOp(52, e);
                            return;
                        }
                        if (r === 61) {
                            this.finishOp(49, 2);
                            return;
                        }
                        this.finishOp(48, 1);
                    }
                    readToken_eq_excl(t) {
                        let r = this.input.charCodeAt(this.state.pos + 1);
                        if (r === 61) {
                            this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
                            return;
                        }
                        if (t === 61 && r === 62) {
                            this.state.pos += 2, this.finishToken(19);
                            return;
                        }
                        this.finishOp(t === 61 ? 29 : 35, 1);
                    }
                    readToken_question() {
                        let t = this.input.charCodeAt(this.state.pos + 1), r = this.input.charCodeAt(this.state.pos + 2);
                        t === 63 ? r === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t === 46 && !(r >= 48 && r <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
                    }
                    getTokenFromCode(t) {
                        switch(t){
                            case 46:
                                this.readToken_dot();
                                return;
                            case 40:
                                ++this.state.pos, this.finishToken(10);
                                return;
                            case 41:
                                ++this.state.pos, this.finishToken(11);
                                return;
                            case 59:
                                ++this.state.pos, this.finishToken(13);
                                return;
                            case 44:
                                ++this.state.pos, this.finishToken(12);
                                return;
                            case 91:
                                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(f.TupleExpressionBarIncorrectStartSyntaxType, {
                                        at: this.state.curPosition()
                                    });
                                    this.state.pos += 2, this.finishToken(2);
                                } else ++this.state.pos, this.finishToken(0);
                                return;
                            case 93:
                                ++this.state.pos, this.finishToken(3);
                                return;
                            case 123:
                                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(f.RecordExpressionBarIncorrectStartSyntaxType, {
                                        at: this.state.curPosition()
                                    });
                                    this.state.pos += 2, this.finishToken(6);
                                } else ++this.state.pos, this.finishToken(5);
                                return;
                            case 125:
                                ++this.state.pos, this.finishToken(8);
                                return;
                            case 58:
                                this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                                return;
                            case 63:
                                this.readToken_question();
                                return;
                            case 96:
                                this.readTemplateToken();
                                return;
                            case 48:
                                {
                                    let r = this.input.charCodeAt(this.state.pos + 1);
                                    if (r === 120 || r === 88) {
                                        this.readRadixNumber(16);
                                        return;
                                    }
                                    if (r === 111 || r === 79) {
                                        this.readRadixNumber(8);
                                        return;
                                    }
                                    if (r === 98 || r === 66) {
                                        this.readRadixNumber(2);
                                        return;
                                    }
                                }
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                                this.readNumber(!1);
                                return;
                            case 34:
                            case 39:
                                this.readString(t);
                                return;
                            case 47:
                                this.readToken_slash();
                                return;
                            case 37:
                            case 42:
                                this.readToken_mult_modulo(t);
                                return;
                            case 124:
                            case 38:
                                this.readToken_pipe_amp(t);
                                return;
                            case 94:
                                this.readToken_caret();
                                return;
                            case 43:
                            case 45:
                                this.readToken_plus_min(t);
                                return;
                            case 60:
                                this.readToken_lt();
                                return;
                            case 62:
                                this.readToken_gt();
                                return;
                            case 61:
                            case 33:
                                this.readToken_eq_excl(t);
                                return;
                            case 126:
                                this.finishOp(36, 1);
                                return;
                            case 64:
                                this.readToken_atSign();
                                return;
                            case 35:
                                this.readToken_numberSign();
                                return;
                            case 92:
                                this.readWord();
                                return;
                            default:
                                if (fe(t)) {
                                    this.readWord(t);
                                    return;
                                }
                        }
                        throw this.raise(f.InvalidOrUnexpectedToken, {
                            at: this.state.curPosition(),
                            unexpected: String.fromCodePoint(t)
                        });
                    }
                    finishOp(t, r) {
                        let e = this.input.slice(this.state.pos, this.state.pos + r);
                        this.state.pos += r, this.finishToken(t, e);
                    }
                    readRegexp() {
                        let t = this.state.startLoc, r = this.state.start + 1, e, s, { pos: i } = this.state;
                        for(;; ++i){
                            if (i >= this.length) throw this.raise(f.UnterminatedRegExp, {
                                at: Y(t, 1)
                            });
                            let u = this.input.charCodeAt(i);
                            if (Ge(u)) throw this.raise(f.UnterminatedRegExp, {
                                at: Y(t, 1)
                            });
                            if (e) e = !1;
                            else {
                                if (u === 91) s = !0;
                                else if (u === 93 && s) s = !1;
                                else if (u === 47 && !s) break;
                                e = u === 92;
                            }
                        }
                        let a = this.input.slice(r, i);
                        ++i;
                        let n = "", o = ()=>Y(t, i + 2 - r);
                        for(; i < this.length;){
                            let u = this.codePointAtPos(i), c = String.fromCharCode(u);
                            if (Ol.has(u)) u === 118 ? (this.expectPlugin("regexpUnicodeSets", o()), n.includes("u") && this.raise(f.IncompatibleRegExpUVFlags, {
                                at: o()
                            })) : u === 117 && n.includes("v") && this.raise(f.IncompatibleRegExpUVFlags, {
                                at: o()
                            }), n.includes(c) && this.raise(f.DuplicateRegExpFlags, {
                                at: o()
                            });
                            else if (De(u) || u === 92) this.raise(f.MalformedRegExpFlags, {
                                at: o()
                            });
                            else break;
                            ++i, n += c;
                        }
                        this.state.pos = i, this.finishToken(135, {
                            pattern: a,
                            flags: n
                        });
                    }
                    readInt(t, r) {
                        let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, { n: i, pos: a } = Fr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t, r, e, s, this.errorHandlers_readInt, !1);
                        return this.state.pos = a, i;
                    }
                    readRadixNumber(t) {
                        let r = this.state.curPosition(), e = !1;
                        this.state.pos += 2;
                        let s = this.readInt(t);
                        s == null && this.raise(f.InvalidDigit, {
                            at: Y(r, 2),
                            radix: t
                        });
                        let i = this.input.charCodeAt(this.state.pos);
                        if (i === 110) ++this.state.pos, e = !0;
                        else if (i === 109) throw this.raise(f.InvalidDecimal, {
                            at: r
                        });
                        if (fe(this.codePointAtPos(this.state.pos))) throw this.raise(f.NumberIdentifier, {
                            at: this.state.curPosition()
                        });
                        if (e) {
                            let a = this.input.slice(r.index, this.state.pos).replace(/[_n]/g, "");
                            this.finishToken(133, a);
                            return;
                        }
                        this.finishToken(132, s);
                    }
                    readNumber(t) {
                        let r = this.state.pos, e = this.state.curPosition(), s = !1, i = !1, a = !1, n = !1, o = !1;
                        !t && this.readInt(10) === null && this.raise(f.InvalidNumber, {
                            at: this.state.curPosition()
                        });
                        let u = this.state.pos - r >= 2 && this.input.charCodeAt(r) === 48;
                        if (u) {
                            let T = this.input.slice(r, this.state.pos);
                            if (this.recordStrictModeErrors(f.StrictOctalLiteral, {
                                at: e
                            }), !this.state.strict) {
                                let C = T.indexOf("_");
                                C > 0 && this.raise(f.ZeroDigitNumericSeparator, {
                                    at: Y(e, C)
                                });
                            }
                            o = u && !/[89]/.test(T);
                        }
                        let c = this.input.charCodeAt(this.state.pos);
                        if (c === 46 && !o && (++this.state.pos, this.readInt(10), s = !0, c = this.input.charCodeAt(this.state.pos)), (c === 69 || c === 101) && !o && (c = this.input.charCodeAt(++this.state.pos), (c === 43 || c === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(f.InvalidOrMissingExponent, {
                            at: e
                        }), s = !0, n = !0, c = this.input.charCodeAt(this.state.pos)), c === 110 && ((s || u) && this.raise(f.InvalidBigIntLiteral, {
                            at: e
                        }), ++this.state.pos, i = !0), c === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n || u) && this.raise(f.InvalidDecimal, {
                            at: e
                        }), ++this.state.pos, a = !0), fe(this.codePointAtPos(this.state.pos))) throw this.raise(f.NumberIdentifier, {
                            at: this.state.curPosition()
                        });
                        let y = this.input.slice(r, this.state.pos).replace(/[_mn]/g, "");
                        if (i) {
                            this.finishToken(133, y);
                            return;
                        }
                        if (a) {
                            this.finishToken(134, y);
                            return;
                        }
                        let g = o ? parseInt(y, 8) : parseFloat(y);
                        this.finishToken(132, g);
                    }
                    readCodePoint(t) {
                        let { code: r, pos: e } = Lr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t, this.errorHandlers_readCodePoint);
                        return this.state.pos = e, r;
                    }
                    readString(t) {
                        let { str: r, pos: e, curLine: s, lineStart: i } = Dr(t === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
                        this.state.pos = e + 1, this.state.lineStart = i, this.state.curLine = s, this.finishToken(131, r);
                    }
                    readTemplateContinuation() {
                        this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
                    }
                    readTemplateToken() {
                        let t = this.input[this.state.pos], { str: r, firstInvalidLoc: e, pos: s, curLine: i, lineStart: a } = Dr("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
                        this.state.pos = s + 1, this.state.lineStart = a, this.state.curLine = i, e && (this.state.firstInvalidTemplateEscapePos = new ge(e.curLine, e.pos - e.lineStart, e.pos)), this.input.codePointAt(s) === 96 ? this.finishToken(24, e ? null : t + r + "`") : (this.state.pos++, this.finishToken(25, e ? null : t + r + "${"));
                    }
                    recordStrictModeErrors(t, r) {
                        let { at: e } = r, s = e.index;
                        this.state.strict && !this.state.strictErrors.has(s) ? this.raise(t, {
                            at: e
                        }) : this.state.strictErrors.set(s, [
                            t,
                            e
                        ]);
                    }
                    readWord1(t) {
                        this.state.containsEsc = !1;
                        let r = "", e = this.state.pos, s = this.state.pos;
                        for(t !== void 0 && (this.state.pos += t <= 65535 ? 1 : 2); this.state.pos < this.length;){
                            let i = this.codePointAtPos(this.state.pos);
                            if (De(i)) this.state.pos += i <= 65535 ? 1 : 2;
                            else if (i === 92) {
                                this.state.containsEsc = !0, r += this.input.slice(s, this.state.pos);
                                let a = this.state.curPosition(), n = this.state.pos === e ? fe : De;
                                if (this.input.charCodeAt(++this.state.pos) !== 117) {
                                    this.raise(f.MissingUnicodeEscape, {
                                        at: this.state.curPosition()
                                    }), s = this.state.pos - 1;
                                    continue;
                                }
                                ++this.state.pos;
                                let o = this.readCodePoint(!0);
                                o !== null && (n(o) || this.raise(f.EscapedCharNotAnIdentifier, {
                                    at: a
                                }), r += String.fromCodePoint(o)), s = this.state.pos;
                            } else break;
                        }
                        return r + this.input.slice(s, this.state.pos);
                    }
                    readWord(t) {
                        let r = this.readWord1(t), e = L.get(r);
                        e !== void 0 ? this.finishToken(e, xe(e)) : this.finishToken(130, r);
                    }
                    checkKeywordEscapes() {
                        let { type: t } = this.state;
                        $t(t) && this.state.containsEsc && this.raise(f.InvalidEscapedReservedWord, {
                            at: this.state.startLoc,
                            reservedWord: xe(t)
                        });
                    }
                    raise(t, r) {
                        let { at: e } = r, s = ot(r, Fl), i = e instanceof ge ? e : e.loc.start, a = t({
                            loc: i,
                            details: s
                        });
                        if (!this.options.errorRecovery) throw a;
                        return this.isLookahead || this.state.errors.push(a), a;
                    }
                    raiseOverwrite(t, r) {
                        let { at: e } = r, s = ot(r, Ll), i = e instanceof ge ? e : e.loc.start, a = i.index, n = this.state.errors;
                        for(let o = n.length - 1; o >= 0; o--){
                            let u = n[o];
                            if (u.loc.index === a) return n[o] = t({
                                loc: i,
                                details: s
                            });
                            if (u.loc.index < a) break;
                        }
                        return this.raise(t, r);
                    }
                    updateContext(t) {}
                    unexpected(t, r) {
                        throw this.raise(f.UnexpectedToken, {
                            expected: r ? xe(r) : null,
                            at: t != null ? t : this.state.startLoc
                        });
                    }
                    expectPlugin(t, r) {
                        if (this.hasPlugin(t)) return !0;
                        throw this.raise(f.MissingPlugin, {
                            at: r != null ? r : this.state.startLoc,
                            missingPlugin: [
                                t
                            ]
                        });
                    }
                    expectOnePlugin(t) {
                        if (!t.some((r)=>this.hasPlugin(r))) throw this.raise(f.MissingOneOfPlugins, {
                            at: this.state.startLoc,
                            missingPlugin: t
                        });
                    }
                    errorBuilder(t) {
                        return (r, e, s)=>{
                            this.raise(t, {
                                at: Je(r, e, s)
                            });
                        };
                    }
                }, Ml = class {
                    constructor(){
                        this.privateNames = new Set, this.loneAccessors = new Map, this.undefinedPrivateNames = new Map;
                    }
                }, _l = class {
                    constructor(t){
                        this.parser = void 0, this.stack = [], this.undefinedPrivateNames = new Map, this.parser = t;
                    }
                    current() {
                        return this.stack[this.stack.length - 1];
                    }
                    enter() {
                        this.stack.push(new Ml);
                    }
                    exit() {
                        let t = this.stack.pop(), r = this.current();
                        for (let [e, s] of Array.from(t.undefinedPrivateNames))r ? r.undefinedPrivateNames.has(e) || r.undefinedPrivateNames.set(e, s) : this.parser.raise(f.InvalidPrivateFieldResolution, {
                            at: s,
                            identifierName: e
                        });
                    }
                    declarePrivateName(t, r, e) {
                        let { privateNames: s, loneAccessors: i, undefinedPrivateNames: a } = this.current(), n = s.has(t);
                        if (r & ts) {
                            let o = n && i.get(t);
                            if (o) {
                                let u = o & yt, c = r & yt, y = o & ts, g = r & ts;
                                n = y === g || u !== c, n || i.delete(t);
                            } else n || i.set(t, r);
                        }
                        n && this.parser.raise(f.PrivateNameRedeclaration, {
                            at: e,
                            identifierName: t
                        }), s.add(t), a.delete(t);
                    }
                    usePrivateName(t, r) {
                        let e;
                        for (e of this.stack)if (e.privateNames.has(t)) return;
                        e ? e.undefinedPrivateNames.set(t, r) : this.parser.raise(f.InvalidPrivateFieldResolution, {
                            at: r,
                            identifierName: t
                        });
                    }
                }, Rl = 0, Or = 1, ls = 2, Br = 3, Pt = class {
                    constructor(){
                        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Rl;
                        this.type = void 0, this.type = t;
                    }
                    canBeArrowParameterDeclaration() {
                        return this.type === ls || this.type === Or;
                    }
                    isCertainlyParameterDeclaration() {
                        return this.type === Br;
                    }
                }, Mr = class extends Pt {
                    constructor(t){
                        super(t), this.declarationErrors = new Map;
                    }
                    recordDeclarationError(t, r) {
                        let { at: e } = r, s = e.index;
                        this.declarationErrors.set(s, [
                            t,
                            e
                        ]);
                    }
                    clearDeclarationError(t) {
                        this.declarationErrors.delete(t);
                    }
                    iterateErrors(t) {
                        this.declarationErrors.forEach(t);
                    }
                }, jl = class {
                    constructor(t){
                        this.parser = void 0, this.stack = [
                            new Pt
                        ], this.parser = t;
                    }
                    enter(t) {
                        this.stack.push(t);
                    }
                    exit() {
                        this.stack.pop();
                    }
                    recordParameterInitializerError(t, r) {
                        let { at: e } = r, s = {
                            at: e.loc.start
                        }, { stack: i } = this, a = i.length - 1, n = i[a];
                        for(; !n.isCertainlyParameterDeclaration();){
                            if (n.canBeArrowParameterDeclaration()) n.recordDeclarationError(t, s);
                            else return;
                            n = i[--a];
                        }
                        this.parser.raise(t, s);
                    }
                    recordArrowParameterBindingError(t, r) {
                        let { at: e } = r, { stack: s } = this, i = s[s.length - 1], a = {
                            at: e.loc.start
                        };
                        if (i.isCertainlyParameterDeclaration()) this.parser.raise(t, a);
                        else if (i.canBeArrowParameterDeclaration()) i.recordDeclarationError(t, a);
                        else return;
                    }
                    recordAsyncArrowParametersError(t) {
                        let { at: r } = t, { stack: e } = this, s = e.length - 1, i = e[s];
                        for(; i.canBeArrowParameterDeclaration();)i.type === ls && i.recordDeclarationError(f.AwaitBindingIdentifier, {
                            at: r
                        }), i = e[--s];
                    }
                    validateAsPattern() {
                        let { stack: t } = this, r = t[t.length - 1];
                        r.canBeArrowParameterDeclaration() && r.iterateErrors((e)=>{
                            let [s, i] = e;
                            this.parser.raise(s, {
                                at: i
                            });
                            let a = t.length - 2, n = t[a];
                            for(; n.canBeArrowParameterDeclaration();)n.clearDeclarationError(i.index), n = t[--a];
                        });
                    }
                };
                function ql() {
                    return new Pt(Br);
                }
                function Ul() {
                    return new Mr(Or);
                }
                function $l() {
                    return new Mr(ls);
                }
                function _r() {
                    return new Pt;
                }
                var Me = 0, Rr = 1, At = 2, jr = 4, _e = 8, Hl = class {
                    constructor(){
                        this.stacks = [];
                    }
                    enter(t) {
                        this.stacks.push(t);
                    }
                    exit() {
                        this.stacks.pop();
                    }
                    currentFlags() {
                        return this.stacks[this.stacks.length - 1];
                    }
                    get hasAwait() {
                        return (this.currentFlags() & At) > 0;
                    }
                    get hasYield() {
                        return (this.currentFlags() & Rr) > 0;
                    }
                    get hasReturn() {
                        return (this.currentFlags() & jr) > 0;
                    }
                    get hasIn() {
                        return (this.currentFlags() & _e) > 0;
                    }
                };
                function Tt(t, r) {
                    return (t ? At : 0) | (r ? Rr : 0);
                }
                var zl = class extends Bl {
                    addExtra(t, r, e) {
                        let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
                        if (!t) return;
                        let i = t.extra = t.extra || {};
                        s ? i[r] = e : Object.defineProperty(i, r, {
                            enumerable: s,
                            value: e
                        });
                    }
                    isContextual(t) {
                        return this.state.type === t && !this.state.containsEsc;
                    }
                    isUnparsedContextual(t, r) {
                        let e = t + r.length;
                        if (this.input.slice(t, e) === r) {
                            let s = this.input.charCodeAt(e);
                            return !(De(s) || (s & 64512) === 55296);
                        }
                        return !1;
                    }
                    isLookaheadContextual(t) {
                        let r = this.nextTokenStart();
                        return this.isUnparsedContextual(r, t);
                    }
                    eatContextual(t) {
                        return this.isContextual(t) ? (this.next(), !0) : !1;
                    }
                    expectContextual(t, r) {
                        if (!this.eatContextual(t)) {
                            if (r != null) throw this.raise(r, {
                                at: this.state.startLoc
                            });
                            this.unexpected(null, t);
                        }
                    }
                    canInsertSemicolon() {
                        return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
                    }
                    hasPrecedingLineBreak() {
                        return as.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
                    }
                    hasFollowingLineBreak() {
                        return Ir.lastIndex = this.state.end, Ir.test(this.input);
                    }
                    isLineTerminator() {
                        return this.eat(13) || this.canInsertSemicolon();
                    }
                    semicolon() {
                        ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0) ? this.isLineTerminator() : this.eat(13)) || this.raise(f.MissingSemicolon, {
                            at: this.state.lastTokEndLoc
                        });
                    }
                    expect(t, r) {
                        this.eat(t) || this.unexpected(r, t);
                    }
                    tryParse(t) {
                        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), e = {
                            node: null
                        };
                        try {
                            let s = t(function() {
                                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                                throw e.node = i, e;
                            });
                            if (this.state.errors.length > r.errors.length) {
                                let i = this.state;
                                return this.state = r, this.state.tokensLength = i.tokensLength, {
                                    node: s,
                                    error: i.errors[r.errors.length],
                                    thrown: !1,
                                    aborted: !1,
                                    failState: i
                                };
                            }
                            return {
                                node: s,
                                error: null,
                                thrown: !1,
                                aborted: !1,
                                failState: null
                            };
                        } catch (s) {
                            let i = this.state;
                            if (this.state = r, s instanceof SyntaxError) return {
                                node: null,
                                error: s,
                                thrown: !0,
                                aborted: !1,
                                failState: i
                            };
                            if (s === e) return {
                                node: e.node,
                                error: null,
                                thrown: !1,
                                aborted: !0,
                                failState: i
                            };
                            throw s;
                        }
                    }
                    checkExpressionErrors(t, r) {
                        if (!t) return !1;
                        let { shorthandAssignLoc: e, doubleProtoLoc: s, privateKeyLoc: i, optionalParametersLoc: a } = t, n = !!e || !!s || !!a || !!i;
                        if (!r) return n;
                        e != null && this.raise(f.InvalidCoverInitializedName, {
                            at: e
                        }), s != null && this.raise(f.DuplicateProto, {
                            at: s
                        }), i != null && this.raise(f.UnexpectedPrivateField, {
                            at: i
                        }), a != null && this.unexpected(a);
                    }
                    isLiteralPropertyName() {
                        return it(this.state.type);
                    }
                    isPrivateName(t) {
                        return t.type === "PrivateName";
                    }
                    getPrivateNameSV(t) {
                        return t.id.name;
                    }
                    hasPropertyAsPrivateName(t) {
                        return (t.type === "MemberExpression" || t.type === "OptionalMemberExpression") && this.isPrivateName(t.property);
                    }
                    isObjectProperty(t) {
                        return t.type === "ObjectProperty";
                    }
                    isObjectMethod(t) {
                        return t.type === "ObjectMethod";
                    }
                    initializeScopes() {
                        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", r = this.state.labels;
                        this.state.labels = [];
                        let e = this.exportedIdentifiers;
                        this.exportedIdentifiers = new Set;
                        let s = this.inModule;
                        this.inModule = t;
                        let i = this.scope, a = this.getScopeHandler();
                        this.scope = new a(this, t);
                        let n = this.prodParam;
                        this.prodParam = new Hl;
                        let o = this.classScope;
                        this.classScope = new _l(this);
                        let u = this.expressionScope;
                        return this.expressionScope = new jl(this), ()=>{
                            this.state.labels = r, this.exportedIdentifiers = e, this.inModule = s, this.scope = i, this.prodParam = n, this.classScope = o, this.expressionScope = u;
                        };
                    }
                    enterInitialScopes() {
                        let t = Me;
                        this.inModule && (t |= At), this.scope.enter(Le), this.prodParam.enter(t);
                    }
                    checkDestructuringPrivate(t) {
                        let { privateKeyLoc: r } = t;
                        r !== null && this.expectPlugin("destructuringPrivate", r);
                    }
                }, vt = class {
                    constructor(){
                        this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
                    }
                }, Et = class {
                    constructor(t, r, e){
                        this.type = "", this.start = r, this.end = 0, this.loc = new lt(e), t != null && t.options.ranges && (this.range = [
                            r,
                            0
                        ]), t != null && t.filename && (this.loc.filename = t.filename);
                    }
                }, hs = Et.prototype;
                hs.__clone = function() {
                    let t = new Et(void 0, this.start, this.loc.start), r = Object.keys(this);
                    for(let e = 0, s = r.length; e < s; e++){
                        let i = r[e];
                        i !== "leadingComments" && i !== "trailingComments" && i !== "innerComments" && (t[i] = this[i]);
                    }
                    return t;
                };
                function Vl(t) {
                    return me(t);
                }
                function me(t) {
                    let { type: r, start: e, end: s, loc: i, range: a, extra: n, name: o } = t, u = Object.create(hs);
                    return u.type = r, u.start = e, u.end = s, u.loc = i, u.range = a, u.extra = n, u.name = o, r === "Placeholder" && (u.expectedNode = t.expectedNode), u;
                }
                function Kl(t) {
                    let { type: r, start: e, end: s, loc: i, range: a, extra: n } = t;
                    if (r === "Placeholder") return Vl(t);
                    let o = Object.create(hs);
                    return o.type = r, o.start = e, o.end = s, o.loc = i, o.range = a, t.raw !== void 0 ? o.raw = t.raw : o.extra = n, o.value = t.value, o;
                }
                var Wl = class extends zl {
                    startNode() {
                        return new Et(this, this.state.start, this.state.startLoc);
                    }
                    startNodeAt(t) {
                        return new Et(this, t.index, t);
                    }
                    startNodeAtNode(t) {
                        return this.startNodeAt(t.loc.start);
                    }
                    finishNode(t, r) {
                        return this.finishNodeAt(t, r, this.state.lastTokEndLoc);
                    }
                    finishNodeAt(t, r, e) {
                        return t.type = r, t.end = e.index, t.loc.end = e, this.options.ranges && (t.range[1] = e.index), this.options.attachComment && this.processComment(t), t;
                    }
                    resetStartLocation(t, r) {
                        t.start = r.index, t.loc.start = r, this.options.ranges && (t.range[0] = r.index);
                    }
                    resetEndLocation(t) {
                        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                        t.end = r.index, t.loc.end = r, this.options.ranges && (t.range[1] = r.index);
                    }
                    resetStartLocationFromNode(t, r) {
                        this.resetStartLocation(t, r.loc.start);
                    }
                }, Gl = new Set([
                    "_",
                    "any",
                    "bool",
                    "boolean",
                    "empty",
                    "extends",
                    "false",
                    "interface",
                    "mixed",
                    "null",
                    "number",
                    "static",
                    "string",
                    "true",
                    "typeof",
                    "void"
                ]), D = pe`flow`({
                    AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.",
                    AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.",
                    AssignReservedType: (t)=>{
                        let { reservedType: r } = t;
                        return `Cannot overwrite reserved type ${r}.`;
                    },
                    DeclareClassElement: "The `declare` modifier can only appear on class fields.",
                    DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.",
                    DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.",
                    EnumBooleanMemberNotInitialized: (t)=>{
                        let { memberName: r, enumName: e } = t;
                        return `Boolean enum members need to be initialized. Use either \`${r} = true,\` or \`${r} = false,\` in enum \`${e}\`.`;
                    },
                    EnumDuplicateMemberName: (t)=>{
                        let { memberName: r, enumName: e } = t;
                        return `Enum member names need to be unique, but the name \`${r}\` has already been used before in enum \`${e}\`.`;
                    },
                    EnumInconsistentMemberValues: (t)=>{
                        let { enumName: r } = t;
                        return `Enum \`${r}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`;
                    },
                    EnumInvalidExplicitType: (t)=>{
                        let { invalidEnumType: r, enumName: e } = t;
                        return `Enum type \`${r}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${e}\`.`;
                    },
                    EnumInvalidExplicitTypeUnknownSupplied: (t)=>{
                        let { enumName: r } = t;
                        return `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${r}\`.`;
                    },
                    EnumInvalidMemberInitializerPrimaryType: (t)=>{
                        let { enumName: r, memberName: e, explicitType: s } = t;
                        return `Enum \`${r}\` has type \`${s}\`, so the initializer of \`${e}\` needs to be a ${s} literal.`;
                    },
                    EnumInvalidMemberInitializerSymbolType: (t)=>{
                        let { enumName: r, memberName: e } = t;
                        return `Symbol enum members cannot be initialized. Use \`${e},\` in enum \`${r}\`.`;
                    },
                    EnumInvalidMemberInitializerUnknownType: (t)=>{
                        let { enumName: r, memberName: e } = t;
                        return `The enum member initializer for \`${e}\` needs to be a literal (either a boolean, number, or string) in enum \`${r}\`.`;
                    },
                    EnumInvalidMemberName: (t)=>{
                        let { enumName: r, memberName: e, suggestion: s } = t;
                        return `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${e}\`, consider using \`${s}\`, in enum \`${r}\`.`;
                    },
                    EnumNumberMemberNotInitialized: (t)=>{
                        let { enumName: r, memberName: e } = t;
                        return `Number enum members need to be initialized, e.g. \`${e} = 1\` in enum \`${r}\`.`;
                    },
                    EnumStringMemberInconsistentlyInitailized: (t)=>{
                        let { enumName: r } = t;
                        return `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${r}\`.`;
                    },
                    GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.",
                    ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.",
                    ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.",
                    InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.",
                    InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.",
                    InexactVariance: "Explicit inexact syntax cannot have variance.",
                    InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.",
                    MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.",
                    NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.",
                    NestedFlowComment: "Cannot have a flow comment inside another flow comment.",
                    PatternIsOptional: Object.assign({
                        message: "A binding pattern parameter cannot be optional in an implementation signature."
                    }, {
                        reasonCode: "OptionalBindingPattern"
                    }),
                    SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.",
                    SpreadVariance: "Spread properties cannot have variance.",
                    ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.",
                    ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.",
                    ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.",
                    ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.",
                    ThisParamNoDefault: "The `this` parameter may not have a default value.",
                    TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
                    TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.",
                    UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.",
                    UnexpectedReservedType: (t)=>{
                        let { reservedType: r } = t;
                        return `Unexpected reserved type ${r}.`;
                    },
                    UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.",
                    UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.",
                    UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.",
                    UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".',
                    UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.",
                    UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.",
                    UnsupportedDeclareExportKind: (t)=>{
                        let { unsupportedExportKind: r, suggestion: e } = t;
                        return `\`declare export ${r}\` is not supported. Use \`${e}\` instead.`;
                    },
                    UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.",
                    UnterminatedFlowComment: "Unterminated flow-comment."
                });
                function Jl(t) {
                    return t.type === "DeclareExportAllDeclaration" || t.type === "DeclareExportDeclaration" && (!t.declaration || t.declaration.type !== "TypeAlias" && t.declaration.type !== "InterfaceDeclaration");
                }
                function us(t) {
                    return t.importKind === "type" || t.importKind === "typeof";
                }
                function qr(t) {
                    return te(t) && t !== 97;
                }
                var Xl = {
                    const: "declare export var",
                    let: "declare export var",
                    type: "export type",
                    interface: "export interface"
                };
                function Yl(t, r) {
                    let e = [], s = [];
                    for(let i = 0; i < t.length; i++)(r(t[i], i, t) ? e : s).push(t[i]);
                    return [
                        e,
                        s
                    ];
                }
                var Ql = /\*?\s*@((?:no)?flow)\b/, Zl = (t)=>class extends t {
                        constructor(){
                            super(...arguments), this.flowPragma = void 0;
                        }
                        getScopeHandler() {
                            return El;
                        }
                        shouldParseTypes() {
                            return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
                        }
                        shouldParseEnums() {
                            return !!this.getPluginOption("flow", "enums");
                        }
                        finishToken(e, s) {
                            e !== 131 && e !== 13 && e !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e, s);
                        }
                        addComment(e) {
                            if (this.flowPragma === void 0) {
                                let s = Ql.exec(e.value);
                                if (s) {
                                    if (s[1] === "flow") this.flowPragma = "flow";
                                    else if (s[1] === "noflow") this.flowPragma = "noflow";
                                    else throw new Error("Unexpected flow pragma");
                                }
                            }
                            super.addComment(e);
                        }
                        flowParseTypeInitialiser(e) {
                            let s = this.state.inType;
                            this.state.inType = !0, this.expect(e || 14);
                            let i = this.flowParseType();
                            return this.state.inType = s, i;
                        }
                        flowParsePredicate() {
                            let e = this.startNode(), s = this.state.startLoc;
                            return this.next(), this.expectContextual(108), this.state.lastTokStart > s.index + 1 && this.raise(D.UnexpectedSpaceBetweenModuloChecks, {
                                at: s
                            }), this.eat(10) ? (e.value = super.parseExpression(), this.expect(11), this.finishNode(e, "DeclaredPredicate")) : this.finishNode(e, "InferredPredicate");
                        }
                        flowParseTypeAndPredicateInitialiser() {
                            let e = this.state.inType;
                            this.state.inType = !0, this.expect(14);
                            let s = null, i = null;
                            return this.match(54) ? (this.state.inType = e, i = this.flowParsePredicate()) : (s = this.flowParseType(), this.state.inType = e, this.match(54) && (i = this.flowParsePredicate())), [
                                s,
                                i
                            ];
                        }
                        flowParseDeclareClass(e) {
                            return this.next(), this.flowParseInterfaceish(e, !0), this.finishNode(e, "DeclareClass");
                        }
                        flowParseDeclareFunction(e) {
                            this.next();
                            let s = e.id = this.parseIdentifier(), i = this.startNode(), a = this.startNode();
                            this.match(47) ? i.typeParameters = this.flowParseTypeParameterDeclaration() : i.typeParameters = null, this.expect(10);
                            let n = this.flowParseFunctionTypeParams();
                            return i.params = n.params, i.rest = n.rest, i.this = n._this, this.expect(11), [i.returnType, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), a.typeAnnotation = this.finishNode(i, "FunctionTypeAnnotation"), s.typeAnnotation = this.finishNode(a, "TypeAnnotation"), this.resetEndLocation(s), this.semicolon(), this.scope.declareName(e.id.name, xl, e.id.loc.start), this.finishNode(e, "DeclareFunction");
                        }
                        flowParseDeclare(e, s) {
                            if (this.match(80)) return this.flowParseDeclareClass(e);
                            if (this.match(68)) return this.flowParseDeclareFunction(e);
                            if (this.match(74)) return this.flowParseDeclareVariable(e);
                            if (this.eatContextual(125)) return this.match(16) ? this.flowParseDeclareModuleExports(e) : (s && this.raise(D.NestedDeclareModule, {
                                at: this.state.lastTokStartLoc
                            }), this.flowParseDeclareModule(e));
                            if (this.isContextual(128)) return this.flowParseDeclareTypeAlias(e);
                            if (this.isContextual(129)) return this.flowParseDeclareOpaqueType(e);
                            if (this.isContextual(127)) return this.flowParseDeclareInterface(e);
                            if (this.match(82)) return this.flowParseDeclareExportDeclaration(e, s);
                            this.unexpected();
                        }
                        flowParseDeclareVariable(e) {
                            return this.next(), e.id = this.flowParseTypeAnnotatableIdentifier(!0), this.scope.declareName(e.id.name, mt, e.id.loc.start), this.semicolon(), this.finishNode(e, "DeclareVariable");
                        }
                        flowParseDeclareModule(e) {
                            this.scope.enter(Fe), this.match(131) ? e.id = super.parseExprAtom() : e.id = this.parseIdentifier();
                            let s = e.body = this.startNode(), i = s.body = [];
                            for(this.expect(5); !this.match(8);){
                                let o = this.startNode();
                                this.match(83) ? (this.next(), !this.isContextual(128) && !this.match(87) && this.raise(D.InvalidNonTypeImportInDeclareModule, {
                                    at: this.state.lastTokStartLoc
                                }), super.parseImport(o)) : (this.expectContextual(123, D.UnsupportedStatementInDeclareModule), o = this.flowParseDeclare(o, !0)), i.push(o);
                            }
                            this.scope.exit(), this.expect(8), this.finishNode(s, "BlockStatement");
                            let a = null, n = !1;
                            return i.forEach((o)=>{
                                Jl(o) ? (a === "CommonJS" && this.raise(D.AmbiguousDeclareModuleKind, {
                                    at: o
                                }), a = "ES") : o.type === "DeclareModuleExports" && (n && this.raise(D.DuplicateDeclareModuleExports, {
                                    at: o
                                }), a === "ES" && this.raise(D.AmbiguousDeclareModuleKind, {
                                    at: o
                                }), a = "CommonJS", n = !0);
                            }), e.kind = a || "CommonJS", this.finishNode(e, "DeclareModule");
                        }
                        flowParseDeclareExportDeclaration(e, s) {
                            if (this.expect(82), this.eat(65)) return this.match(68) || this.match(80) ? e.declaration = this.flowParseDeclare(this.startNode()) : (e.declaration = this.flowParseType(), this.semicolon()), e.default = !0, this.finishNode(e, "DeclareExportDeclaration");
                            if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !s) {
                                let i = this.state.value;
                                throw this.raise(D.UnsupportedDeclareExportKind, {
                                    at: this.state.startLoc,
                                    unsupportedExportKind: i,
                                    suggestion: Xl[i]
                                });
                            }
                            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129)) return e.declaration = this.flowParseDeclare(this.startNode()), e.default = !1, this.finishNode(e, "DeclareExportDeclaration");
                            if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129)) return e = this.parseExport(e, null), e.type === "ExportNamedDeclaration" && (e.type = "ExportDeclaration", e.default = !1, delete e.exportKind), e.type = "Declare" + e.type, e;
                            this.unexpected();
                        }
                        flowParseDeclareModuleExports(e) {
                            return this.next(), this.expectContextual(109), e.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e, "DeclareModuleExports");
                        }
                        flowParseDeclareTypeAlias(e) {
                            this.next();
                            let s = this.flowParseTypeAlias(e);
                            return s.type = "DeclareTypeAlias", s;
                        }
                        flowParseDeclareOpaqueType(e) {
                            this.next();
                            let s = this.flowParseOpaqueType(e, !0);
                            return s.type = "DeclareOpaqueType", s;
                        }
                        flowParseDeclareInterface(e) {
                            return this.next(), this.flowParseInterfaceish(e, !1), this.finishNode(e, "DeclareInterface");
                        }
                        flowParseInterfaceish(e, s) {
                            if (e.id = this.flowParseRestrictedIdentifier(!s, !0), this.scope.declareName(e.id.name, s ? Er : Be, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.extends = [], e.implements = [], e.mixins = [], this.eat(81)) do e.extends.push(this.flowParseInterfaceExtends());
                            while (!s && this.eat(12));
                            if (s) {
                                if (this.eatContextual(115)) do e.mixins.push(this.flowParseInterfaceExtends());
                                while (this.eat(12));
                                if (this.eatContextual(111)) do e.implements.push(this.flowParseInterfaceExtends());
                                while (this.eat(12));
                            }
                            e.body = this.flowParseObjectType({
                                allowStatic: s,
                                allowExact: !1,
                                allowSpread: !1,
                                allowProto: s,
                                allowInexact: !1
                            });
                        }
                        flowParseInterfaceExtends() {
                            let e = this.startNode();
                            return e.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e.typeParameters = this.flowParseTypeParameterInstantiation() : e.typeParameters = null, this.finishNode(e, "InterfaceExtends");
                        }
                        flowParseInterface(e) {
                            return this.flowParseInterfaceish(e, !1), this.finishNode(e, "InterfaceDeclaration");
                        }
                        checkNotUnderscore(e) {
                            e === "_" && this.raise(D.UnexpectedReservedUnderscore, {
                                at: this.state.startLoc
                            });
                        }
                        checkReservedType(e, s, i) {
                            Gl.has(e) && this.raise(i ? D.AssignReservedType : D.UnexpectedReservedType, {
                                at: s,
                                reservedType: e
                            });
                        }
                        flowParseRestrictedIdentifier(e, s) {
                            return this.checkReservedType(this.state.value, this.state.startLoc, s), this.parseIdentifier(e);
                        }
                        flowParseTypeAlias(e) {
                            return e.id = this.flowParseRestrictedIdentifier(!1, !0), this.scope.declareName(e.id.name, Be, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e, "TypeAlias");
                        }
                        flowParseOpaqueType(e, s) {
                            return this.expectContextual(128), e.id = this.flowParseRestrictedIdentifier(!0, !0), this.scope.declareName(e.id.name, Be, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.supertype = null, this.match(14) && (e.supertype = this.flowParseTypeInitialiser(14)), e.impltype = null, s || (e.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e, "OpaqueType");
                        }
                        flowParseTypeParameter() {
                            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, s = this.state.startLoc, i = this.startNode(), a = this.flowParseVariance(), n = this.flowParseTypeAnnotatableIdentifier();
                            return i.name = n.name, i.variance = a, i.bound = n.typeAnnotation, this.match(29) ? (this.eat(29), i.default = this.flowParseType()) : e && this.raise(D.MissingTypeParamDefault, {
                                at: s
                            }), this.finishNode(i, "TypeParameter");
                        }
                        flowParseTypeParameterDeclaration() {
                            let e = this.state.inType, s = this.startNode();
                            s.params = [], this.state.inType = !0, this.match(47) || this.match(140) ? this.next() : this.unexpected();
                            let i = !1;
                            do {
                                let a = this.flowParseTypeParameter(i);
                                s.params.push(a), a.default && (i = !0), this.match(48) || this.expect(12);
                            }while (!this.match(48));
                            return this.expect(48), this.state.inType = e, this.finishNode(s, "TypeParameterDeclaration");
                        }
                        flowParseTypeParameterInstantiation() {
                            let e = this.startNode(), s = this.state.inType;
                            e.params = [], this.state.inType = !0, this.expect(47);
                            let i = this.state.noAnonFunctionType;
                            for(this.state.noAnonFunctionType = !1; !this.match(48);)e.params.push(this.flowParseType()), this.match(48) || this.expect(12);
                            return this.state.noAnonFunctionType = i, this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
                        }
                        flowParseTypeParameterInstantiationCallOrNew() {
                            let e = this.startNode(), s = this.state.inType;
                            for(e.params = [], this.state.inType = !0, this.expect(47); !this.match(48);)e.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
                            return this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
                        }
                        flowParseInterfaceType() {
                            let e = this.startNode();
                            if (this.expectContextual(127), e.extends = [], this.eat(81)) do e.extends.push(this.flowParseInterfaceExtends());
                            while (this.eat(12));
                            return e.body = this.flowParseObjectType({
                                allowStatic: !1,
                                allowExact: !1,
                                allowSpread: !1,
                                allowProto: !1,
                                allowInexact: !1
                            }), this.finishNode(e, "InterfaceTypeAnnotation");
                        }
                        flowParseObjectPropertyKey() {
                            return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(!0);
                        }
                        flowParseObjectTypeIndexer(e, s, i) {
                            return e.static = s, this.lookahead().type === 14 ? (e.id = this.flowParseObjectPropertyKey(), e.key = this.flowParseTypeInitialiser()) : (e.id = null, e.key = this.flowParseType()), this.expect(3), e.value = this.flowParseTypeInitialiser(), e.variance = i, this.finishNode(e, "ObjectTypeIndexer");
                        }
                        flowParseObjectTypeInternalSlot(e, s) {
                            return e.static = s, e.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e.method = !0, e.optional = !1, e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start))) : (e.method = !1, this.eat(17) && (e.optional = !0), e.value = this.flowParseTypeInitialiser()), this.finishNode(e, "ObjectTypeInternalSlot");
                        }
                        flowParseObjectTypeMethodish(e) {
                            for(e.params = [], e.rest = null, e.typeParameters = null, e.this = null, this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e.this = this.flowParseFunctionTypeParam(!0), e.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21);)e.params.push(this.flowParseFunctionTypeParam(!1)), this.match(11) || this.expect(12);
                            return this.eat(21) && (e.rest = this.flowParseFunctionTypeParam(!1)), this.expect(11), e.returnType = this.flowParseTypeInitialiser(), this.finishNode(e, "FunctionTypeAnnotation");
                        }
                        flowParseObjectTypeCallProperty(e, s) {
                            let i = this.startNode();
                            return e.static = s, e.value = this.flowParseObjectTypeMethodish(i), this.finishNode(e, "ObjectTypeCallProperty");
                        }
                        flowParseObjectType(e) {
                            let { allowStatic: s, allowExact: i, allowSpread: a, allowProto: n, allowInexact: o } = e, u = this.state.inType;
                            this.state.inType = !0;
                            let c = this.startNode();
                            c.callProperties = [], c.properties = [], c.indexers = [], c.internalSlots = [];
                            let y, g, T = !1;
                            for(i && this.match(6) ? (this.expect(6), y = 9, g = !0) : (this.expect(5), y = 8, g = !1), c.exact = g; !this.match(y);){
                                let M = !1, j = null, K = null, W = this.startNode();
                                if (n && this.isContextual(116)) {
                                    let X = this.lookahead();
                                    X.type !== 14 && X.type !== 17 && (this.next(), j = this.state.startLoc, s = !1);
                                }
                                if (s && this.isContextual(104)) {
                                    let X = this.lookahead();
                                    X.type !== 14 && X.type !== 17 && (this.next(), M = !0);
                                }
                                let V = this.flowParseVariance();
                                if (this.eat(0)) j != null && this.unexpected(j), this.eat(0) ? (V && this.unexpected(V.loc.start), c.internalSlots.push(this.flowParseObjectTypeInternalSlot(W, M))) : c.indexers.push(this.flowParseObjectTypeIndexer(W, M, V));
                                else if (this.match(10) || this.match(47)) j != null && this.unexpected(j), V && this.unexpected(V.loc.start), c.callProperties.push(this.flowParseObjectTypeCallProperty(W, M));
                                else {
                                    let X = "init";
                                    if (this.isContextual(98) || this.isContextual(103)) {
                                        let Nh = this.lookahead();
                                        it(Nh.type) && (X = this.state.value, this.next());
                                    }
                                    let je = this.flowParseObjectTypeProperty(W, M, j, V, X, a, o != null ? o : !g);
                                    je === null ? (T = !0, K = this.state.lastTokStartLoc) : c.properties.push(je);
                                }
                                this.flowObjectTypeSemicolon(), K && !this.match(8) && !this.match(9) && this.raise(D.UnexpectedExplicitInexactInObject, {
                                    at: K
                                });
                            }
                            this.expect(y), a && (c.inexact = T);
                            let C = this.finishNode(c, "ObjectTypeAnnotation");
                            return this.state.inType = u, C;
                        }
                        flowParseObjectTypeProperty(e, s, i, a, n, o, u) {
                            if (this.eat(21)) return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (o ? u || this.raise(D.InexactInsideExact, {
                                at: this.state.lastTokStartLoc
                            }) : this.raise(D.InexactInsideNonObject, {
                                at: this.state.lastTokStartLoc
                            }), a && this.raise(D.InexactVariance, {
                                at: a
                            }), null) : (o || this.raise(D.UnexpectedSpreadType, {
                                at: this.state.lastTokStartLoc
                            }), i != null && this.unexpected(i), a && this.raise(D.SpreadVariance, {
                                at: a
                            }), e.argument = this.flowParseType(), this.finishNode(e, "ObjectTypeSpreadProperty"));
                            {
                                e.key = this.flowParseObjectPropertyKey(), e.static = s, e.proto = i != null, e.kind = n;
                                let c = !1;
                                return this.match(47) || this.match(10) ? (e.method = !0, i != null && this.unexpected(i), a && this.unexpected(a.loc.start), e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start)), (n === "get" || n === "set") && this.flowCheckGetterSetterParams(e), !o && e.key.name === "constructor" && e.value.this && this.raise(D.ThisParamBannedInConstructor, {
                                    at: e.value.this
                                })) : (n !== "init" && this.unexpected(), e.method = !1, this.eat(17) && (c = !0), e.value = this.flowParseTypeInitialiser(), e.variance = a), e.optional = c, this.finishNode(e, "ObjectTypeProperty");
                            }
                        }
                        flowCheckGetterSetterParams(e) {
                            let s = e.kind === "get" ? 0 : 1, i = e.value.params.length + (e.value.rest ? 1 : 0);
                            e.value.this && this.raise(e.kind === "get" ? D.GetterMayNotHaveThisParam : D.SetterMayNotHaveThisParam, {
                                at: e.value.this
                            }), i !== s && this.raise(e.kind === "get" ? f.BadGetterArity : f.BadSetterArity, {
                                at: e
                            }), e.kind === "set" && e.value.rest && this.raise(f.BadSetterRestParameter, {
                                at: e
                            });
                        }
                        flowObjectTypeSemicolon() {
                            !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
                        }
                        flowParseQualifiedTypeIdentifier(e, s) {
                            var i;
                            (i = e) != null || (e = this.state.startLoc);
                            let a = s || this.flowParseRestrictedIdentifier(!0);
                            for(; this.eat(16);){
                                let n = this.startNodeAt(e);
                                n.qualification = a, n.id = this.flowParseRestrictedIdentifier(!0), a = this.finishNode(n, "QualifiedTypeIdentifier");
                            }
                            return a;
                        }
                        flowParseGenericType(e, s) {
                            let i = this.startNodeAt(e);
                            return i.typeParameters = null, i.id = this.flowParseQualifiedTypeIdentifier(e, s), this.match(47) && (i.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(i, "GenericTypeAnnotation");
                        }
                        flowParseTypeofType() {
                            let e = this.startNode();
                            return this.expect(87), e.argument = this.flowParsePrimaryType(), this.finishNode(e, "TypeofTypeAnnotation");
                        }
                        flowParseTupleType() {
                            let e = this.startNode();
                            for(e.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e.types.push(this.flowParseType()), !this.match(3));)this.expect(12);
                            return this.expect(3), this.finishNode(e, "TupleTypeAnnotation");
                        }
                        flowParseFunctionTypeParam(e) {
                            let s = null, i = !1, a = null, n = this.startNode(), o = this.lookahead(), u = this.state.type === 78;
                            return o.type === 14 || o.type === 17 ? (u && !e && this.raise(D.ThisParamMustBeFirst, {
                                at: n
                            }), s = this.parseIdentifier(u), this.eat(17) && (i = !0, u && this.raise(D.ThisParamMayNotBeOptional, {
                                at: n
                            })), a = this.flowParseTypeInitialiser()) : a = this.flowParseType(), n.name = s, n.optional = i, n.typeAnnotation = a, this.finishNode(n, "FunctionTypeParam");
                        }
                        reinterpretTypeAsFunctionTypeParam(e) {
                            let s = this.startNodeAt(e.loc.start);
                            return s.name = null, s.optional = !1, s.typeAnnotation = e, this.finishNode(s, "FunctionTypeParam");
                        }
                        flowParseFunctionTypeParams() {
                            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = null, i = null;
                            for(this.match(78) && (i = this.flowParseFunctionTypeParam(!0), i.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21);)e.push(this.flowParseFunctionTypeParam(!1)), this.match(11) || this.expect(12);
                            return this.eat(21) && (s = this.flowParseFunctionTypeParam(!1)), {
                                params: e,
                                rest: s,
                                _this: i
                            };
                        }
                        flowIdentToTypeAnnotation(e, s, i) {
                            switch(i.name){
                                case "any":
                                    return this.finishNode(s, "AnyTypeAnnotation");
                                case "bool":
                                case "boolean":
                                    return this.finishNode(s, "BooleanTypeAnnotation");
                                case "mixed":
                                    return this.finishNode(s, "MixedTypeAnnotation");
                                case "empty":
                                    return this.finishNode(s, "EmptyTypeAnnotation");
                                case "number":
                                    return this.finishNode(s, "NumberTypeAnnotation");
                                case "string":
                                    return this.finishNode(s, "StringTypeAnnotation");
                                case "symbol":
                                    return this.finishNode(s, "SymbolTypeAnnotation");
                                default:
                                    return this.checkNotUnderscore(i.name), this.flowParseGenericType(e, i);
                            }
                        }
                        flowParsePrimaryType() {
                            let e = this.state.startLoc, s = this.startNode(), i, a, n = !1, o = this.state.noAnonFunctionType;
                            switch(this.state.type){
                                case 5:
                                    return this.flowParseObjectType({
                                        allowStatic: !1,
                                        allowExact: !1,
                                        allowSpread: !0,
                                        allowProto: !1,
                                        allowInexact: !0
                                    });
                                case 6:
                                    return this.flowParseObjectType({
                                        allowStatic: !1,
                                        allowExact: !0,
                                        allowSpread: !0,
                                        allowProto: !1,
                                        allowInexact: !1
                                    });
                                case 0:
                                    return this.state.noAnonFunctionType = !1, a = this.flowParseTupleType(), this.state.noAnonFunctionType = o, a;
                                case 47:
                                    return s.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), i = this.flowParseFunctionTypeParams(), s.params = i.params, s.rest = i.rest, s.this = i._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), this.finishNode(s, "FunctionTypeAnnotation");
                                case 10:
                                    if (this.next(), !this.match(11) && !this.match(21)) {
                                        if (q(this.state.type) || this.match(78)) {
                                            let u = this.lookahead().type;
                                            n = u !== 17 && u !== 14;
                                        } else n = !0;
                                    }
                                    if (n) {
                                        if (this.state.noAnonFunctionType = !1, a = this.flowParseType(), this.state.noAnonFunctionType = o, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19)) return this.expect(11), a;
                                        this.eat(12);
                                    }
                                    return a ? i = this.flowParseFunctionTypeParams([
                                        this.reinterpretTypeAsFunctionTypeParam(a)
                                    ]) : i = this.flowParseFunctionTypeParams(), s.params = i.params, s.rest = i.rest, s.this = i._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                                case 131:
                                    return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
                                case 85:
                                case 86:
                                    return s.value = this.match(85), this.next(), this.finishNode(s, "BooleanLiteralTypeAnnotation");
                                case 53:
                                    if (this.state.value === "-") {
                                        if (this.next(), this.match(132)) return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", s);
                                        if (this.match(133)) return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", s);
                                        throw this.raise(D.UnexpectedSubtractionOperand, {
                                            at: this.state.startLoc
                                        });
                                    }
                                    this.unexpected();
                                    return;
                                case 132:
                                    return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
                                case 133:
                                    return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
                                case 88:
                                    return this.next(), this.finishNode(s, "VoidTypeAnnotation");
                                case 84:
                                    return this.next(), this.finishNode(s, "NullLiteralTypeAnnotation");
                                case 78:
                                    return this.next(), this.finishNode(s, "ThisTypeAnnotation");
                                case 55:
                                    return this.next(), this.finishNode(s, "ExistsTypeAnnotation");
                                case 87:
                                    return this.flowParseTypeofType();
                                default:
                                    if ($t(this.state.type)) {
                                        let u = xe(this.state.type);
                                        return this.next(), super.createIdentifier(s, u);
                                    } else if (q(this.state.type)) return this.isContextual(127) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e, s, this.parseIdentifier());
                            }
                            this.unexpected();
                        }
                        flowParsePostfixType() {
                            let e = this.state.startLoc, s = this.flowParsePrimaryType(), i = !1;
                            for(; (this.match(0) || this.match(18)) && !this.canInsertSemicolon();){
                                let a = this.startNodeAt(e), n = this.eat(18);
                                i = i || n, this.expect(0), !n && this.match(3) ? (a.elementType = s, this.next(), s = this.finishNode(a, "ArrayTypeAnnotation")) : (a.objectType = s, a.indexType = this.flowParseType(), this.expect(3), i ? (a.optional = n, s = this.finishNode(a, "OptionalIndexedAccessType")) : s = this.finishNode(a, "IndexedAccessType"));
                            }
                            return s;
                        }
                        flowParsePrefixType() {
                            let e = this.startNode();
                            return this.eat(17) ? (e.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e, "NullableTypeAnnotation")) : this.flowParsePostfixType();
                        }
                        flowParseAnonFunctionWithoutParens() {
                            let e = this.flowParsePrefixType();
                            if (!this.state.noAnonFunctionType && this.eat(19)) {
                                let s = this.startNodeAt(e.loc.start);
                                return s.params = [
                                    this.reinterpretTypeAsFunctionTypeParam(e)
                                ], s.rest = null, s.this = null, s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                            }
                            return e;
                        }
                        flowParseIntersectionType() {
                            let e = this.startNode();
                            this.eat(45);
                            let s = this.flowParseAnonFunctionWithoutParens();
                            for(e.types = [
                                s
                            ]; this.eat(45);)e.types.push(this.flowParseAnonFunctionWithoutParens());
                            return e.types.length === 1 ? s : this.finishNode(e, "IntersectionTypeAnnotation");
                        }
                        flowParseUnionType() {
                            let e = this.startNode();
                            this.eat(43);
                            let s = this.flowParseIntersectionType();
                            for(e.types = [
                                s
                            ]; this.eat(43);)e.types.push(this.flowParseIntersectionType());
                            return e.types.length === 1 ? s : this.finishNode(e, "UnionTypeAnnotation");
                        }
                        flowParseType() {
                            let e = this.state.inType;
                            this.state.inType = !0;
                            let s = this.flowParseUnionType();
                            return this.state.inType = e, s;
                        }
                        flowParseTypeOrImplicitInstantiation() {
                            if (this.state.type === 130 && this.state.value === "_") {
                                let e = this.state.startLoc, s = this.parseIdentifier();
                                return this.flowParseGenericType(e, s);
                            } else return this.flowParseType();
                        }
                        flowParseTypeAnnotation() {
                            let e = this.startNode();
                            return e.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e, "TypeAnnotation");
                        }
                        flowParseTypeAnnotatableIdentifier(e) {
                            let s = e ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
                            return this.match(14) && (s.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s)), s;
                        }
                        typeCastToParameter(e) {
                            return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
                        }
                        flowParseVariance() {
                            let e = null;
                            return this.match(53) ? (e = this.startNode(), this.state.value === "+" ? e.kind = "plus" : e.kind = "minus", this.next(), this.finishNode(e, "Variance")) : e;
                        }
                        parseFunctionBody(e, s) {
                            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                            if (s) {
                                this.forwardNoArrowParamsConversionAt(e, ()=>super.parseFunctionBody(e, !0, i));
                                return;
                            }
                            super.parseFunctionBody(e, !1, i);
                        }
                        parseFunctionBodyAndFinish(e, s) {
                            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                            if (this.match(14)) {
                                let a = this.startNode();
                                [a.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), e.returnType = a.typeAnnotation ? this.finishNode(a, "TypeAnnotation") : null;
                            }
                            return super.parseFunctionBodyAndFinish(e, s, i);
                        }
                        parseStatementLike(e) {
                            if (this.state.strict && this.isContextual(127)) {
                                let i = this.lookahead();
                                if (te(i.type)) {
                                    let a = this.startNode();
                                    return this.next(), this.flowParseInterface(a);
                                }
                            } else if (this.shouldParseEnums() && this.isContextual(124)) {
                                let i = this.startNode();
                                return this.next(), this.flowParseEnumDeclaration(i);
                            }
                            let s = super.parseStatementLike(e);
                            return this.flowPragma === void 0 && !this.isValidDirective(s) && (this.flowPragma = null), s;
                        }
                        parseExpressionStatement(e, s, i) {
                            if (s.type === "Identifier") {
                                if (s.name === "declare") {
                                    if (this.match(80) || q(this.state.type) || this.match(68) || this.match(74) || this.match(82)) return this.flowParseDeclare(e);
                                } else if (q(this.state.type)) {
                                    if (s.name === "interface") return this.flowParseInterface(e);
                                    if (s.name === "type") return this.flowParseTypeAlias(e);
                                    if (s.name === "opaque") return this.flowParseOpaqueType(e, !1);
                                }
                            }
                            return super.parseExpressionStatement(e, s, i);
                        }
                        shouldParseExportDeclaration() {
                            let { type: e } = this.state;
                            return hr(e) || this.shouldParseEnums() && e === 124 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
                        }
                        isExportDefaultSpecifier() {
                            let { type: e } = this.state;
                            return hr(e) || this.shouldParseEnums() && e === 124 ? this.state.containsEsc : super.isExportDefaultSpecifier();
                        }
                        parseExportDefaultExpression() {
                            if (this.shouldParseEnums() && this.isContextual(124)) {
                                let e = this.startNode();
                                return this.next(), this.flowParseEnumDeclaration(e);
                            }
                            return super.parseExportDefaultExpression();
                        }
                        parseConditional(e, s, i) {
                            if (!this.match(17)) return e;
                            if (this.state.maybeInArrowParameters) {
                                let T = this.lookaheadCharCode();
                                if (T === 44 || T === 61 || T === 58 || T === 41) return this.setOptionalParametersError(i), e;
                            }
                            this.expect(17);
                            let a = this.state.clone(), n = this.state.noArrowAt, o = this.startNodeAt(s), { consequent: u, failed: c } = this.tryParseConditionalConsequent(), [y, g] = this.getArrowLikeExpressions(u);
                            if (c || g.length > 0) {
                                let T = [
                                    ...n
                                ];
                                if (g.length > 0) {
                                    this.state = a, this.state.noArrowAt = T;
                                    for(let C = 0; C < g.length; C++)T.push(g[C].start);
                                    ({ consequent: u, failed: c } = this.tryParseConditionalConsequent()), [y, g] = this.getArrowLikeExpressions(u);
                                }
                                c && y.length > 1 && this.raise(D.AmbiguousConditionalArrow, {
                                    at: a.startLoc
                                }), c && y.length === 1 && (this.state = a, T.push(y[0].start), this.state.noArrowAt = T, { consequent: u, failed: c } = this.tryParseConditionalConsequent());
                            }
                            return this.getArrowLikeExpressions(u, !0), this.state.noArrowAt = n, this.expect(14), o.test = e, o.consequent = u, o.alternate = this.forwardNoArrowParamsConversionAt(o, ()=>this.parseMaybeAssign(void 0, void 0)), this.finishNode(o, "ConditionalExpression");
                        }
                        tryParseConditionalConsequent() {
                            this.state.noArrowParamsConversionAt.push(this.state.start);
                            let e = this.parseMaybeAssignAllowIn(), s = !this.match(14);
                            return this.state.noArrowParamsConversionAt.pop(), {
                                consequent: e,
                                failed: s
                            };
                        }
                        getArrowLikeExpressions(e, s) {
                            let i = [
                                e
                            ], a = [];
                            for(; i.length !== 0;){
                                let n = i.pop();
                                n.type === "ArrowFunctionExpression" ? (n.typeParameters || !n.returnType ? this.finishArrowValidation(n) : a.push(n), i.push(n.body)) : n.type === "ConditionalExpression" && (i.push(n.consequent), i.push(n.alternate));
                            }
                            return s ? (a.forEach((n)=>this.finishArrowValidation(n)), [
                                a,
                                []
                            ]) : Yl(a, (n)=>n.params.every((o)=>this.isAssignable(o, !0)));
                        }
                        finishArrowValidation(e) {
                            var s;
                            this.toAssignableList(e.params, (s = e.extra) == null ? void 0 : s.trailingCommaLoc, !1), this.scope.enter(de | Gt), super.checkParams(e, !1, !0), this.scope.exit();
                        }
                        forwardNoArrowParamsConversionAt(e, s) {
                            let i;
                            return this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), i = s(), this.state.noArrowParamsConversionAt.pop()) : i = s(), i;
                        }
                        parseParenItem(e, s) {
                            if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = !0, this.resetEndLocation(e)), this.match(14)) {
                                let i = this.startNodeAt(s);
                                return i.expression = e, i.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(i, "TypeCastExpression");
                            }
                            return e;
                        }
                        assertModuleNodeAllowed(e) {
                            e.type === "ImportDeclaration" && (e.importKind === "type" || e.importKind === "typeof") || e.type === "ExportNamedDeclaration" && e.exportKind === "type" || e.type === "ExportAllDeclaration" && e.exportKind === "type" || super.assertModuleNodeAllowed(e);
                        }
                        parseExport(e, s) {
                            let i = super.parseExport(e, s);
                            return (i.type === "ExportNamedDeclaration" || i.type === "ExportAllDeclaration") && (i.exportKind = i.exportKind || "value"), i;
                        }
                        parseExportDeclaration(e) {
                            if (this.isContextual(128)) {
                                e.exportKind = "type";
                                let s = this.startNode();
                                return this.next(), this.match(5) ? (e.specifiers = this.parseExportSpecifiers(!0), super.parseExportFrom(e), null) : this.flowParseTypeAlias(s);
                            } else if (this.isContextual(129)) {
                                e.exportKind = "type";
                                let s = this.startNode();
                                return this.next(), this.flowParseOpaqueType(s, !1);
                            } else if (this.isContextual(127)) {
                                e.exportKind = "type";
                                let s = this.startNode();
                                return this.next(), this.flowParseInterface(s);
                            } else if (this.shouldParseEnums() && this.isContextual(124)) {
                                e.exportKind = "value";
                                let s = this.startNode();
                                return this.next(), this.flowParseEnumDeclaration(s);
                            } else return super.parseExportDeclaration(e);
                        }
                        eatExportStar(e) {
                            return super.eatExportStar(e) ? !0 : this.isContextual(128) && this.lookahead().type === 55 ? (e.exportKind = "type", this.next(), this.next(), !0) : !1;
                        }
                        maybeParseExportNamespaceSpecifier(e) {
                            let { startLoc: s } = this.state, i = super.maybeParseExportNamespaceSpecifier(e);
                            return i && e.exportKind === "type" && this.unexpected(s), i;
                        }
                        parseClassId(e, s, i) {
                            super.parseClassId(e, s, i), this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration());
                        }
                        parseClassMember(e, s, i) {
                            let { startLoc: a } = this.state;
                            if (this.isContextual(123)) {
                                if (super.parseClassMemberFromModifier(e, s)) return;
                                s.declare = !0;
                            }
                            super.parseClassMember(e, s, i), s.declare && (s.type !== "ClassProperty" && s.type !== "ClassPrivateProperty" && s.type !== "PropertyDefinition" ? this.raise(D.DeclareClassElement, {
                                at: a
                            }) : s.value && this.raise(D.DeclareClassFieldInitializer, {
                                at: s.value
                            }));
                        }
                        isIterator(e) {
                            return e === "iterator" || e === "asyncIterator";
                        }
                        readIterator() {
                            let e = super.readWord1(), s = "@@" + e;
                            (!this.isIterator(e) || !this.state.inType) && this.raise(f.InvalidIdentifier, {
                                at: this.state.curPosition(),
                                identifierName: s
                            }), this.finishToken(130, s);
                        }
                        getTokenFromCode(e) {
                            let s = this.input.charCodeAt(this.state.pos + 1);
                            e === 123 && s === 124 ? this.finishOp(6, 2) : this.state.inType && (e === 62 || e === 60) ? this.finishOp(e === 62 ? 48 : 47, 1) : this.state.inType && e === 63 ? s === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : ll(e, s, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e);
                        }
                        isAssignable(e, s) {
                            return e.type === "TypeCastExpression" ? this.isAssignable(e.expression, s) : super.isAssignable(e, s);
                        }
                        toAssignable(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                            !s && e.type === "AssignmentExpression" && e.left.type === "TypeCastExpression" && (e.left = this.typeCastToParameter(e.left)), super.toAssignable(e, s);
                        }
                        toAssignableList(e, s, i) {
                            for(let a = 0; a < e.length; a++){
                                let n = e[a];
                                (n == null ? void 0 : n.type) === "TypeCastExpression" && (e[a] = this.typeCastToParameter(n));
                            }
                            super.toAssignableList(e, s, i);
                        }
                        toReferencedList(e, s) {
                            for(let a = 0; a < e.length; a++){
                                var i;
                                let n = e[a];
                                n && n.type === "TypeCastExpression" && !((i = n.extra) != null && i.parenthesized) && (e.length > 1 || !s) && this.raise(D.TypeCastInPattern, {
                                    at: n.typeAnnotation
                                });
                            }
                            return e;
                        }
                        parseArrayLike(e, s, i, a) {
                            let n = super.parseArrayLike(e, s, i, a);
                            return s && !this.state.maybeInArrowParameters && this.toReferencedList(n.elements), n;
                        }
                        isValidLVal(e, s, i) {
                            return e === "TypeCastExpression" || super.isValidLVal(e, s, i);
                        }
                        parseClassProperty(e) {
                            return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e);
                        }
                        parseClassPrivateProperty(e) {
                            return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e);
                        }
                        isClassMethod() {
                            return this.match(47) || super.isClassMethod();
                        }
                        isClassProperty() {
                            return this.match(14) || super.isClassProperty();
                        }
                        isNonstaticConstructor(e) {
                            return !this.match(14) && super.isNonstaticConstructor(e);
                        }
                        pushClassMethod(e, s, i, a, n, o) {
                            if (s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e, s, i, a, n, o), s.params && n) {
                                let u = s.params;
                                u.length > 0 && this.isThisParam(u[0]) && this.raise(D.ThisParamBannedInConstructor, {
                                    at: s
                                });
                            } else if (s.type === "MethodDefinition" && n && s.value.params) {
                                let u = s.value.params;
                                u.length > 0 && this.isThisParam(u[0]) && this.raise(D.ThisParamBannedInConstructor, {
                                    at: s
                                });
                            }
                        }
                        pushClassPrivateMethod(e, s, i, a) {
                            s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e, s, i, a);
                        }
                        parseClassSuper(e) {
                            if (super.parseClassSuper(e), e.superClass && this.match(47) && (e.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(111)) {
                                this.next();
                                let s = e.implements = [];
                                do {
                                    let i = this.startNode();
                                    i.id = this.flowParseRestrictedIdentifier(!0), this.match(47) ? i.typeParameters = this.flowParseTypeParameterInstantiation() : i.typeParameters = null, s.push(this.finishNode(i, "ClassImplements"));
                                }while (this.eat(12));
                            }
                        }
                        checkGetterSetterParams(e) {
                            super.checkGetterSetterParams(e);
                            let s = this.getObjectOrClassMethodParams(e);
                            if (s.length > 0) {
                                let i = s[0];
                                this.isThisParam(i) && e.kind === "get" ? this.raise(D.GetterMayNotHaveThisParam, {
                                    at: i
                                }) : this.isThisParam(i) && this.raise(D.SetterMayNotHaveThisParam, {
                                    at: i
                                });
                            }
                        }
                        parsePropertyNamePrefixOperator(e) {
                            e.variance = this.flowParseVariance();
                        }
                        parseObjPropValue(e, s, i, a, n, o, u) {
                            e.variance && this.unexpected(e.variance.loc.start), delete e.variance;
                            let c;
                            this.match(47) && !o && (c = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
                            let y = super.parseObjPropValue(e, s, i, a, n, o, u);
                            return c && ((y.value || y).typeParameters = c), y;
                        }
                        parseAssignableListItemTypes(e) {
                            return this.eat(17) && (e.type !== "Identifier" && this.raise(D.PatternIsOptional, {
                                at: e
                            }), this.isThisParam(e) && this.raise(D.ThisParamMayNotBeOptional, {
                                at: e
                            }), e.optional = !0), this.match(14) ? e.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e) && this.raise(D.ThisParamAnnotationRequired, {
                                at: e
                            }), this.match(29) && this.isThisParam(e) && this.raise(D.ThisParamNoDefault, {
                                at: e
                            }), this.resetEndLocation(e), e;
                        }
                        parseMaybeDefault(e, s) {
                            let i = super.parseMaybeDefault(e, s);
                            return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(D.TypeBeforeInitializer, {
                                at: i.typeAnnotation
                            }), i;
                        }
                        shouldParseDefaultImport(e) {
                            return us(e) ? qr(this.state.type) : super.shouldParseDefaultImport(e);
                        }
                        checkImportReflection(e) {
                            super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(D.ImportReflectionHasImportType, {
                                at: e.specifiers[0].loc.start
                            });
                        }
                        parseImportSpecifierLocal(e, s, i) {
                            s.local = us(e) ? this.flowParseRestrictedIdentifier(!0, !0) : this.parseIdentifier(), e.specifiers.push(this.finishImportSpecifier(s, i));
                        }
                        maybeParseDefaultImportSpecifier(e) {
                            e.importKind = "value";
                            let s = null;
                            if (this.match(87) ? s = "typeof" : this.isContextual(128) && (s = "type"), s) {
                                let i = this.lookahead(), { type: a } = i;
                                s === "type" && a === 55 && this.unexpected(null, i.type), (qr(a) || a === 5 || a === 55) && (this.next(), e.importKind = s);
                            }
                            return super.maybeParseDefaultImportSpecifier(e);
                        }
                        parseImportSpecifier(e, s, i, a, n) {
                            let o = e.imported, u = null;
                            o.type === "Identifier" && (o.name === "type" ? u = "type" : o.name === "typeof" && (u = "typeof"));
                            let c = !1;
                            if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
                                let g = this.parseIdentifier(!0);
                                u !== null && !te(this.state.type) ? (e.imported = g, e.importKind = u, e.local = me(g)) : (e.imported = o, e.importKind = null, e.local = this.parseIdentifier());
                            } else {
                                if (u !== null && te(this.state.type)) e.imported = this.parseIdentifier(!0), e.importKind = u;
                                else {
                                    if (s) throw this.raise(f.ImportBindingIsString, {
                                        at: e,
                                        importName: o.value
                                    });
                                    e.imported = o, e.importKind = null;
                                }
                                this.eatContextual(93) ? e.local = this.parseIdentifier() : (c = !0, e.local = me(e.imported));
                            }
                            let y = us(e);
                            return i && y && this.raise(D.ImportTypeShorthandOnlyInPureImport, {
                                at: e
                            }), (i || y) && this.checkReservedType(e.local.name, e.local.loc.start, !0), c && !i && !y && this.checkReservedWord(e.local.name, e.loc.start, !0, !0), this.finishImportSpecifier(e, "ImportSpecifier");
                        }
                        parseBindingAtom() {
                            switch(this.state.type){
                                case 78:
                                    return this.parseIdentifier(!0);
                                default:
                                    return super.parseBindingAtom();
                            }
                        }
                        parseFunctionParams(e, s) {
                            let i = e.kind;
                            i !== "get" && i !== "set" && this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e, s);
                        }
                        parseVarId(e, s) {
                            super.parseVarId(e, s), this.match(14) && (e.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e.id));
                        }
                        parseAsyncArrowFromCallExpression(e, s) {
                            if (this.match(14)) {
                                let i = this.state.noAnonFunctionType;
                                this.state.noAnonFunctionType = !0, e.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = i;
                            }
                            return super.parseAsyncArrowFromCallExpression(e, s);
                        }
                        shouldParseAsyncArrow() {
                            return this.match(14) || super.shouldParseAsyncArrow();
                        }
                        parseMaybeAssign(e, s) {
                            var i;
                            let a = null, n;
                            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
                                if (a = this.state.clone(), n = this.tryParse(()=>super.parseMaybeAssign(e, s), a), !n.error) return n.node;
                                let { context: c } = this.state, y = c[c.length - 1];
                                (y === x.j_oTag || y === x.j_expr) && c.pop();
                            }
                            if ((i = n) != null && i.error || this.match(47)) {
                                var o, u;
                                a = a || this.state.clone();
                                let c, y = this.tryParse((T)=>{
                                    var C;
                                    c = this.flowParseTypeParameterDeclaration();
                                    let M = this.forwardNoArrowParamsConversionAt(c, ()=>{
                                        let K = super.parseMaybeAssign(e, s);
                                        return this.resetStartLocationFromNode(K, c), K;
                                    });
                                    (C = M.extra) != null && C.parenthesized && T();
                                    let j = this.maybeUnwrapTypeCastExpression(M);
                                    return j.type !== "ArrowFunctionExpression" && T(), j.typeParameters = c, this.resetStartLocationFromNode(j, c), M;
                                }, a), g = null;
                                if (y.node && this.maybeUnwrapTypeCastExpression(y.node).type === "ArrowFunctionExpression") {
                                    if (!y.error && !y.aborted) return y.node.async && this.raise(D.UnexpectedTypeParameterBeforeAsyncArrowFunction, {
                                        at: c
                                    }), y.node;
                                    g = y.node;
                                }
                                if ((o = n) != null && o.node) return this.state = n.failState, n.node;
                                if (g) return this.state = y.failState, g;
                                throw (u = n) != null && u.thrown ? n.error : y.thrown ? y.error : this.raise(D.UnexpectedTokenAfterTypeParameter, {
                                    at: c
                                });
                            }
                            return super.parseMaybeAssign(e, s);
                        }
                        parseArrow(e) {
                            if (this.match(14)) {
                                let s = this.tryParse(()=>{
                                    let i = this.state.noAnonFunctionType;
                                    this.state.noAnonFunctionType = !0;
                                    let a = this.startNode();
                                    return [a.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = i, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), a;
                                });
                                if (s.thrown) return null;
                                s.error && (this.state = s.failState), e.returnType = s.node.typeAnnotation ? this.finishNode(s.node, "TypeAnnotation") : null;
                            }
                            return super.parseArrow(e);
                        }
                        shouldParseArrow(e) {
                            return this.match(14) || super.shouldParseArrow(e);
                        }
                        setArrowFunctionParameters(e, s) {
                            this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? e.params = s : super.setArrowFunctionParameters(e, s);
                        }
                        checkParams(e, s, i) {
                            let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
                            if (!(i && this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1)) {
                                for(let n = 0; n < e.params.length; n++)this.isThisParam(e.params[n]) && n > 0 && this.raise(D.ThisParamMustBeFirst, {
                                    at: e.params[n]
                                });
                                super.checkParams(e, s, i, a);
                            }
                        }
                        parseParenAndDistinguishExpression(e) {
                            return super.parseParenAndDistinguishExpression(e && this.state.noArrowAt.indexOf(this.state.start) === -1);
                        }
                        parseSubscripts(e, s, i) {
                            if (e.type === "Identifier" && e.name === "async" && this.state.noArrowAt.indexOf(s.index) !== -1) {
                                this.next();
                                let a = this.startNodeAt(s);
                                a.callee = e, a.arguments = super.parseCallExpressionArguments(11, !1), e = this.finishNode(a, "CallExpression");
                            } else if (e.type === "Identifier" && e.name === "async" && this.match(47)) {
                                let a = this.state.clone(), n = this.tryParse((u)=>this.parseAsyncArrowWithTypeParameters(s) || u(), a);
                                if (!n.error && !n.aborted) return n.node;
                                let o = this.tryParse(()=>super.parseSubscripts(e, s, i), a);
                                if (o.node && !o.error) return o.node;
                                if (n.node) return this.state = n.failState, n.node;
                                if (o.node) return this.state = o.failState, o.node;
                                throw n.error || o.error;
                            }
                            return super.parseSubscripts(e, s, i);
                        }
                        parseSubscript(e, s, i, a) {
                            if (this.match(18) && this.isLookaheadToken_lt()) {
                                if (a.optionalChainMember = !0, i) return a.stop = !0, e;
                                this.next();
                                let n = this.startNodeAt(s);
                                return n.callee = e, n.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), n.arguments = this.parseCallExpressionArguments(11, !1), n.optional = !0, this.finishCallExpression(n, !0);
                            } else if (!i && this.shouldParseTypes() && this.match(47)) {
                                let n = this.startNodeAt(s);
                                n.callee = e;
                                let o = this.tryParse(()=>(n.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), n.arguments = super.parseCallExpressionArguments(11, !1), a.optionalChainMember && (n.optional = !1), this.finishCallExpression(n, a.optionalChainMember)));
                                if (o.node) return o.error && (this.state = o.failState), o.node;
                            }
                            return super.parseSubscript(e, s, i, a);
                        }
                        parseNewCallee(e) {
                            super.parseNewCallee(e);
                            let s = null;
                            this.shouldParseTypes() && this.match(47) && (s = this.tryParse(()=>this.flowParseTypeParameterInstantiationCallOrNew()).node), e.typeArguments = s;
                        }
                        parseAsyncArrowWithTypeParameters(e) {
                            let s = this.startNodeAt(e);
                            if (this.parseFunctionParams(s, !1), !!this.parseArrow(s)) return super.parseArrowExpression(s, void 0, !0);
                        }
                        readToken_mult_modulo(e) {
                            let s = this.input.charCodeAt(this.state.pos + 1);
                            if (e === 42 && s === 47 && this.state.hasFlowComment) {
                                this.state.hasFlowComment = !1, this.state.pos += 2, this.nextToken();
                                return;
                            }
                            super.readToken_mult_modulo(e);
                        }
                        readToken_pipe_amp(e) {
                            let s = this.input.charCodeAt(this.state.pos + 1);
                            if (e === 124 && s === 125) {
                                this.finishOp(9, 2);
                                return;
                            }
                            super.readToken_pipe_amp(e);
                        }
                        parseTopLevel(e, s) {
                            let i = super.parseTopLevel(e, s);
                            return this.state.hasFlowComment && this.raise(D.UnterminatedFlowComment, {
                                at: this.state.curPosition()
                            }), i;
                        }
                        skipBlockComment() {
                            if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
                                if (this.state.hasFlowComment) throw this.raise(D.NestedFlowComment, {
                                    at: this.state.startLoc
                                });
                                this.hasFlowCommentCompletion();
                                let e = this.skipFlowComment();
                                e && (this.state.pos += e, this.state.hasFlowComment = !0);
                                return;
                            }
                            return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
                        }
                        skipFlowComment() {
                            let { pos: e } = this.state, s = 2;
                            for(; [
                                32,
                                9
                            ].includes(this.input.charCodeAt(e + s));)s++;
                            let i = this.input.charCodeAt(s + e), a = this.input.charCodeAt(s + e + 1);
                            return i === 58 && a === 58 ? s + 2 : this.input.slice(s + e, s + e + 12) === "flow-include" ? s + 12 : i === 58 && a !== 58 ? s : !1;
                        }
                        hasFlowCommentCompletion() {
                            if (this.input.indexOf("*/", this.state.pos) === -1) throw this.raise(f.UnterminatedComment, {
                                at: this.state.curPosition()
                            });
                        }
                        flowEnumErrorBooleanMemberNotInitialized(e, s) {
                            let { enumName: i, memberName: a } = s;
                            this.raise(D.EnumBooleanMemberNotInitialized, {
                                at: e,
                                memberName: a,
                                enumName: i
                            });
                        }
                        flowEnumErrorInvalidMemberInitializer(e, s) {
                            return this.raise(s.explicitType ? s.explicitType === "symbol" ? D.EnumInvalidMemberInitializerSymbolType : D.EnumInvalidMemberInitializerPrimaryType : D.EnumInvalidMemberInitializerUnknownType, Object.assign({
                                at: e
                            }, s));
                        }
                        flowEnumErrorNumberMemberNotInitialized(e, s) {
                            let { enumName: i, memberName: a } = s;
                            this.raise(D.EnumNumberMemberNotInitialized, {
                                at: e,
                                enumName: i,
                                memberName: a
                            });
                        }
                        flowEnumErrorStringMemberInconsistentlyInitailized(e, s) {
                            let { enumName: i } = s;
                            this.raise(D.EnumStringMemberInconsistentlyInitailized, {
                                at: e,
                                enumName: i
                            });
                        }
                        flowEnumMemberInit() {
                            let e = this.state.startLoc, s = ()=>this.match(12) || this.match(8);
                            switch(this.state.type){
                                case 132:
                                    {
                                        let i = this.parseNumericLiteral(this.state.value);
                                        return s() ? {
                                            type: "number",
                                            loc: i.loc.start,
                                            value: i
                                        } : {
                                            type: "invalid",
                                            loc: e
                                        };
                                    }
                                case 131:
                                    {
                                        let i = this.parseStringLiteral(this.state.value);
                                        return s() ? {
                                            type: "string",
                                            loc: i.loc.start,
                                            value: i
                                        } : {
                                            type: "invalid",
                                            loc: e
                                        };
                                    }
                                case 85:
                                case 86:
                                    {
                                        let i = this.parseBooleanLiteral(this.match(85));
                                        return s() ? {
                                            type: "boolean",
                                            loc: i.loc.start,
                                            value: i
                                        } : {
                                            type: "invalid",
                                            loc: e
                                        };
                                    }
                                default:
                                    return {
                                        type: "invalid",
                                        loc: e
                                    };
                            }
                        }
                        flowEnumMemberRaw() {
                            let e = this.state.startLoc, s = this.parseIdentifier(!0), i = this.eat(29) ? this.flowEnumMemberInit() : {
                                type: "none",
                                loc: e
                            };
                            return {
                                id: s,
                                init: i
                            };
                        }
                        flowEnumCheckExplicitTypeMismatch(e, s, i) {
                            let { explicitType: a } = s;
                            a !== null && a !== i && this.flowEnumErrorInvalidMemberInitializer(e, s);
                        }
                        flowEnumMembers(e) {
                            let { enumName: s, explicitType: i } = e, a = new Set, n = {
                                booleanMembers: [],
                                numberMembers: [],
                                stringMembers: [],
                                defaultedMembers: []
                            }, o = !1;
                            for(; !this.match(8);){
                                if (this.eat(21)) {
                                    o = !0;
                                    break;
                                }
                                let u = this.startNode(), { id: c, init: y } = this.flowEnumMemberRaw(), g = c.name;
                                if (g === "") continue;
                                /^[a-z]/.test(g) && this.raise(D.EnumInvalidMemberName, {
                                    at: c,
                                    memberName: g,
                                    suggestion: g[0].toUpperCase() + g.slice(1),
                                    enumName: s
                                }), a.has(g) && this.raise(D.EnumDuplicateMemberName, {
                                    at: c,
                                    memberName: g,
                                    enumName: s
                                }), a.add(g);
                                let T = {
                                    enumName: s,
                                    explicitType: i,
                                    memberName: g
                                };
                                switch(u.id = c, y.type){
                                    case "boolean":
                                        this.flowEnumCheckExplicitTypeMismatch(y.loc, T, "boolean"), u.init = y.value, n.booleanMembers.push(this.finishNode(u, "EnumBooleanMember"));
                                        break;
                                    case "number":
                                        this.flowEnumCheckExplicitTypeMismatch(y.loc, T, "number"), u.init = y.value, n.numberMembers.push(this.finishNode(u, "EnumNumberMember"));
                                        break;
                                    case "string":
                                        this.flowEnumCheckExplicitTypeMismatch(y.loc, T, "string"), u.init = y.value, n.stringMembers.push(this.finishNode(u, "EnumStringMember"));
                                        break;
                                    case "invalid":
                                        throw this.flowEnumErrorInvalidMemberInitializer(y.loc, T);
                                    case "none":
                                        switch(i){
                                            case "boolean":
                                                this.flowEnumErrorBooleanMemberNotInitialized(y.loc, T);
                                                break;
                                            case "number":
                                                this.flowEnumErrorNumberMemberNotInitialized(y.loc, T);
                                                break;
                                            default:
                                                n.defaultedMembers.push(this.finishNode(u, "EnumDefaultedMember"));
                                        }
                                }
                                this.match(8) || this.expect(12);
                            }
                            return {
                                members: n,
                                hasUnknownMembers: o
                            };
                        }
                        flowEnumStringMembers(e, s, i) {
                            let { enumName: a } = i;
                            if (e.length === 0) return s;
                            if (s.length === 0) return e;
                            if (s.length > e.length) {
                                for (let n of e)this.flowEnumErrorStringMemberInconsistentlyInitailized(n, {
                                    enumName: a
                                });
                                return s;
                            } else {
                                for (let n of s)this.flowEnumErrorStringMemberInconsistentlyInitailized(n, {
                                    enumName: a
                                });
                                return e;
                            }
                        }
                        flowEnumParseExplicitType(e) {
                            let { enumName: s } = e;
                            if (!this.eatContextual(101)) return null;
                            if (!q(this.state.type)) throw this.raise(D.EnumInvalidExplicitTypeUnknownSupplied, {
                                at: this.state.startLoc,
                                enumName: s
                            });
                            let { value: i } = this.state;
                            return this.next(), i !== "boolean" && i !== "number" && i !== "string" && i !== "symbol" && this.raise(D.EnumInvalidExplicitType, {
                                at: this.state.startLoc,
                                enumName: s,
                                invalidEnumType: i
                            }), i;
                        }
                        flowEnumBody(e, s) {
                            let i = s.name, a = s.loc.start, n = this.flowEnumParseExplicitType({
                                enumName: i
                            });
                            this.expect(5);
                            let { members: o, hasUnknownMembers: u } = this.flowEnumMembers({
                                enumName: i,
                                explicitType: n
                            });
                            switch(e.hasUnknownMembers = u, n){
                                case "boolean":
                                    return e.explicitType = !0, e.members = o.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                                case "number":
                                    return e.explicitType = !0, e.members = o.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                                case "string":
                                    return e.explicitType = !0, e.members = this.flowEnumStringMembers(o.stringMembers, o.defaultedMembers, {
                                        enumName: i
                                    }), this.expect(8), this.finishNode(e, "EnumStringBody");
                                case "symbol":
                                    return e.members = o.defaultedMembers, this.expect(8), this.finishNode(e, "EnumSymbolBody");
                                default:
                                    {
                                        let c = ()=>(e.members = [], this.expect(8), this.finishNode(e, "EnumStringBody"));
                                        e.explicitType = !1;
                                        let y = o.booleanMembers.length, g = o.numberMembers.length, T = o.stringMembers.length, C = o.defaultedMembers.length;
                                        if (!y && !g && !T && !C) return c();
                                        if (!y && !g) return e.members = this.flowEnumStringMembers(o.stringMembers, o.defaultedMembers, {
                                            enumName: i
                                        }), this.expect(8), this.finishNode(e, "EnumStringBody");
                                        if (!g && !T && y >= C) {
                                            for (let M of o.defaultedMembers)this.flowEnumErrorBooleanMemberNotInitialized(M.loc.start, {
                                                enumName: i,
                                                memberName: M.id.name
                                            });
                                            return e.members = o.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                                        } else if (!y && !T && g >= C) {
                                            for (let M of o.defaultedMembers)this.flowEnumErrorNumberMemberNotInitialized(M.loc.start, {
                                                enumName: i,
                                                memberName: M.id.name
                                            });
                                            return e.members = o.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                                        } else return this.raise(D.EnumInconsistentMemberValues, {
                                            at: a,
                                            enumName: i
                                        }), c();
                                    }
                            }
                        }
                        flowParseEnumDeclaration(e) {
                            let s = this.parseIdentifier();
                            return e.id = s, e.body = this.flowEnumBody(this.startNode(), s), this.finishNode(e, "EnumDeclaration");
                        }
                        isLookaheadToken_lt() {
                            let e = this.nextTokenStart();
                            if (this.input.charCodeAt(e) === 60) {
                                let s = this.input.charCodeAt(e + 1);
                                return s !== 60 && s !== 61;
                            }
                            return !1;
                        }
                        maybeUnwrapTypeCastExpression(e) {
                            return e.type === "TypeCastExpression" ? e.expression : e;
                        }
                    }, eh = {
                    __proto__: null,
                    quot: '"',
                    amp: "&",
                    apos: "'",
                    lt: "<",
                    gt: ">",
                    nbsp: "\xA0",
                    iexcl: "\xA1",
                    cent: "\xA2",
                    pound: "\xA3",
                    curren: "\xA4",
                    yen: "\xA5",
                    brvbar: "\xA6",
                    sect: "\xA7",
                    uml: "\xA8",
                    copy: "\xA9",
                    ordf: "\xAA",
                    laquo: "\xAB",
                    not: "\xAC",
                    shy: "\xAD",
                    reg: "\xAE",
                    macr: "\xAF",
                    deg: "\xB0",
                    plusmn: "\xB1",
                    sup2: "\xB2",
                    sup3: "\xB3",
                    acute: "\xB4",
                    micro: "\xB5",
                    para: "\xB6",
                    middot: "\xB7",
                    cedil: "\xB8",
                    sup1: "\xB9",
                    ordm: "\xBA",
                    raquo: "\xBB",
                    frac14: "\xBC",
                    frac12: "\xBD",
                    frac34: "\xBE",
                    iquest: "\xBF",
                    Agrave: "\xC0",
                    Aacute: "\xC1",
                    Acirc: "\xC2",
                    Atilde: "\xC3",
                    Auml: "\xC4",
                    Aring: "\xC5",
                    AElig: "\xC6",
                    Ccedil: "\xC7",
                    Egrave: "\xC8",
                    Eacute: "\xC9",
                    Ecirc: "\xCA",
                    Euml: "\xCB",
                    Igrave: "\xCC",
                    Iacute: "\xCD",
                    Icirc: "\xCE",
                    Iuml: "\xCF",
                    ETH: "\xD0",
                    Ntilde: "\xD1",
                    Ograve: "\xD2",
                    Oacute: "\xD3",
                    Ocirc: "\xD4",
                    Otilde: "\xD5",
                    Ouml: "\xD6",
                    times: "\xD7",
                    Oslash: "\xD8",
                    Ugrave: "\xD9",
                    Uacute: "\xDA",
                    Ucirc: "\xDB",
                    Uuml: "\xDC",
                    Yacute: "\xDD",
                    THORN: "\xDE",
                    szlig: "\xDF",
                    agrave: "\xE0",
                    aacute: "\xE1",
                    acirc: "\xE2",
                    atilde: "\xE3",
                    auml: "\xE4",
                    aring: "\xE5",
                    aelig: "\xE6",
                    ccedil: "\xE7",
                    egrave: "\xE8",
                    eacute: "\xE9",
                    ecirc: "\xEA",
                    euml: "\xEB",
                    igrave: "\xEC",
                    iacute: "\xED",
                    icirc: "\xEE",
                    iuml: "\xEF",
                    eth: "\xF0",
                    ntilde: "\xF1",
                    ograve: "\xF2",
                    oacute: "\xF3",
                    ocirc: "\xF4",
                    otilde: "\xF5",
                    ouml: "\xF6",
                    divide: "\xF7",
                    oslash: "\xF8",
                    ugrave: "\xF9",
                    uacute: "\xFA",
                    ucirc: "\xFB",
                    uuml: "\xFC",
                    yacute: "\xFD",
                    thorn: "\xFE",
                    yuml: "\xFF",
                    OElig: "\u0152",
                    oelig: "\u0153",
                    Scaron: "\u0160",
                    scaron: "\u0161",
                    Yuml: "\u0178",
                    fnof: "\u0192",
                    circ: "\u02C6",
                    tilde: "\u02DC",
                    Alpha: "\u0391",
                    Beta: "\u0392",
                    Gamma: "\u0393",
                    Delta: "\u0394",
                    Epsilon: "\u0395",
                    Zeta: "\u0396",
                    Eta: "\u0397",
                    Theta: "\u0398",
                    Iota: "\u0399",
                    Kappa: "\u039A",
                    Lambda: "\u039B",
                    Mu: "\u039C",
                    Nu: "\u039D",
                    Xi: "\u039E",
                    Omicron: "\u039F",
                    Pi: "\u03A0",
                    Rho: "\u03A1",
                    Sigma: "\u03A3",
                    Tau: "\u03A4",
                    Upsilon: "\u03A5",
                    Phi: "\u03A6",
                    Chi: "\u03A7",
                    Psi: "\u03A8",
                    Omega: "\u03A9",
                    alpha: "\u03B1",
                    beta: "\u03B2",
                    gamma: "\u03B3",
                    delta: "\u03B4",
                    epsilon: "\u03B5",
                    zeta: "\u03B6",
                    eta: "\u03B7",
                    theta: "\u03B8",
                    iota: "\u03B9",
                    kappa: "\u03BA",
                    lambda: "\u03BB",
                    mu: "\u03BC",
                    nu: "\u03BD",
                    xi: "\u03BE",
                    omicron: "\u03BF",
                    pi: "\u03C0",
                    rho: "\u03C1",
                    sigmaf: "\u03C2",
                    sigma: "\u03C3",
                    tau: "\u03C4",
                    upsilon: "\u03C5",
                    phi: "\u03C6",
                    chi: "\u03C7",
                    psi: "\u03C8",
                    omega: "\u03C9",
                    thetasym: "\u03D1",
                    upsih: "\u03D2",
                    piv: "\u03D6",
                    ensp: "\u2002",
                    emsp: "\u2003",
                    thinsp: "\u2009",
                    zwnj: "\u200C",
                    zwj: "\u200D",
                    lrm: "\u200E",
                    rlm: "\u200F",
                    ndash: "\u2013",
                    mdash: "\u2014",
                    lsquo: "\u2018",
                    rsquo: "\u2019",
                    sbquo: "\u201A",
                    ldquo: "\u201C",
                    rdquo: "\u201D",
                    bdquo: "\u201E",
                    dagger: "\u2020",
                    Dagger: "\u2021",
                    bull: "\u2022",
                    hellip: "\u2026",
                    permil: "\u2030",
                    prime: "\u2032",
                    Prime: "\u2033",
                    lsaquo: "\u2039",
                    rsaquo: "\u203A",
                    oline: "\u203E",
                    frasl: "\u2044",
                    euro: "\u20AC",
                    image: "\u2111",
                    weierp: "\u2118",
                    real: "\u211C",
                    trade: "\u2122",
                    alefsym: "\u2135",
                    larr: "\u2190",
                    uarr: "\u2191",
                    rarr: "\u2192",
                    darr: "\u2193",
                    harr: "\u2194",
                    crarr: "\u21B5",
                    lArr: "\u21D0",
                    uArr: "\u21D1",
                    rArr: "\u21D2",
                    dArr: "\u21D3",
                    hArr: "\u21D4",
                    forall: "\u2200",
                    part: "\u2202",
                    exist: "\u2203",
                    empty: "\u2205",
                    nabla: "\u2207",
                    isin: "\u2208",
                    notin: "\u2209",
                    ni: "\u220B",
                    prod: "\u220F",
                    sum: "\u2211",
                    minus: "\u2212",
                    lowast: "\u2217",
                    radic: "\u221A",
                    prop: "\u221D",
                    infin: "\u221E",
                    ang: "\u2220",
                    and: "\u2227",
                    or: "\u2228",
                    cap: "\u2229",
                    cup: "\u222A",
                    int: "\u222B",
                    there4: "\u2234",
                    sim: "\u223C",
                    cong: "\u2245",
                    asymp: "\u2248",
                    ne: "\u2260",
                    equiv: "\u2261",
                    le: "\u2264",
                    ge: "\u2265",
                    sub: "\u2282",
                    sup: "\u2283",
                    nsub: "\u2284",
                    sube: "\u2286",
                    supe: "\u2287",
                    oplus: "\u2295",
                    otimes: "\u2297",
                    perp: "\u22A5",
                    sdot: "\u22C5",
                    lceil: "\u2308",
                    rceil: "\u2309",
                    lfloor: "\u230A",
                    rfloor: "\u230B",
                    lang: "\u2329",
                    rang: "\u232A",
                    loz: "\u25CA",
                    spades: "\u2660",
                    clubs: "\u2663",
                    hearts: "\u2665",
                    diams: "\u2666"
                }, Se = pe`jsx`({
                    AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.",
                    MissingClosingTagElement: (t)=>{
                        let { openingTagName: r } = t;
                        return `Expected corresponding JSX closing tag for <${r}>.`;
                    },
                    MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.",
                    UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?",
                    UnexpectedToken: (t)=>{
                        let { unexpected: r, HTMLEntity: e } = t;
                        return `Unexpected token \`${r}\`. Did you mean \`${e}\` or \`{'${r}'}\`?`;
                    },
                    UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.",
                    UnterminatedJsxContent: "Unterminated JSX contents.",
                    UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?"
                });
                function Te(t) {
                    return t ? t.type === "JSXOpeningFragment" || t.type === "JSXClosingFragment" : !1;
                }
                function Re(t) {
                    if (t.type === "JSXIdentifier") return t.name;
                    if (t.type === "JSXNamespacedName") return t.namespace.name + ":" + t.name.name;
                    if (t.type === "JSXMemberExpression") return Re(t.object) + "." + Re(t.property);
                    throw new Error("Node had unexpected type: " + t.type);
                }
                var th = (t)=>class extends t {
                        jsxReadToken() {
                            let e = "", s = this.state.pos;
                            for(;;){
                                if (this.state.pos >= this.length) throw this.raise(Se.UnterminatedJsxContent, {
                                    at: this.state.startLoc
                                });
                                let i = this.input.charCodeAt(this.state.pos);
                                switch(i){
                                    case 60:
                                    case 123:
                                        if (this.state.pos === this.state.start) {
                                            i === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(i);
                                            return;
                                        }
                                        e += this.input.slice(s, this.state.pos), this.finishToken(139, e);
                                        return;
                                    case 38:
                                        e += this.input.slice(s, this.state.pos), e += this.jsxReadEntity(), s = this.state.pos;
                                        break;
                                    case 62:
                                    case 125:
                                    default:
                                        Ge(i) ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadNewLine(!0), s = this.state.pos) : ++this.state.pos;
                                }
                            }
                        }
                        jsxReadNewLine(e) {
                            let s = this.input.charCodeAt(this.state.pos), i;
                            return ++this.state.pos, s === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, i = e ? `
` : `\r
`) : i = String.fromCharCode(s), ++this.state.curLine, this.state.lineStart = this.state.pos, i;
                        }
                        jsxReadString(e) {
                            let s = "", i = ++this.state.pos;
                            for(;;){
                                if (this.state.pos >= this.length) throw this.raise(f.UnterminatedString, {
                                    at: this.state.startLoc
                                });
                                let a = this.input.charCodeAt(this.state.pos);
                                if (a === e) break;
                                a === 38 ? (s += this.input.slice(i, this.state.pos), s += this.jsxReadEntity(), i = this.state.pos) : Ge(a) ? (s += this.input.slice(i, this.state.pos), s += this.jsxReadNewLine(!1), i = this.state.pos) : ++this.state.pos;
                            }
                            s += this.input.slice(i, this.state.pos++), this.finishToken(131, s);
                        }
                        jsxReadEntity() {
                            let e = ++this.state.pos;
                            if (this.codePointAtPos(this.state.pos) === 35) {
                                ++this.state.pos;
                                let s = 10;
                                this.codePointAtPos(this.state.pos) === 120 && (s = 16, ++this.state.pos);
                                let i = this.readInt(s, void 0, !1, "bail");
                                if (i !== null && this.codePointAtPos(this.state.pos) === 59) return ++this.state.pos, String.fromCodePoint(i);
                            } else {
                                let s = 0, i = !1;
                                for(; s++ < 10 && this.state.pos < this.length && !(i = this.codePointAtPos(this.state.pos) == 59);)++this.state.pos;
                                if (i) {
                                    let a = this.input.slice(e, this.state.pos), n = eh[a];
                                    if (++this.state.pos, n) return n;
                                }
                            }
                            return this.state.pos = e, "&";
                        }
                        jsxReadWord() {
                            let e, s = this.state.pos;
                            do e = this.input.charCodeAt(++this.state.pos);
                            while (De(e) || e === 45);
                            this.finishToken(138, this.input.slice(s, this.state.pos));
                        }
                        jsxParseIdentifier() {
                            let e = this.startNode();
                            return this.match(138) ? e.name = this.state.value : $t(this.state.type) ? e.name = xe(this.state.type) : this.unexpected(), this.next(), this.finishNode(e, "JSXIdentifier");
                        }
                        jsxParseNamespacedName() {
                            let e = this.state.startLoc, s = this.jsxParseIdentifier();
                            if (!this.eat(14)) return s;
                            let i = this.startNodeAt(e);
                            return i.namespace = s, i.name = this.jsxParseIdentifier(), this.finishNode(i, "JSXNamespacedName");
                        }
                        jsxParseElementName() {
                            let e = this.state.startLoc, s = this.jsxParseNamespacedName();
                            if (s.type === "JSXNamespacedName") return s;
                            for(; this.eat(16);){
                                let i = this.startNodeAt(e);
                                i.object = s, i.property = this.jsxParseIdentifier(), s = this.finishNode(i, "JSXMemberExpression");
                            }
                            return s;
                        }
                        jsxParseAttributeValue() {
                            let e;
                            switch(this.state.type){
                                case 5:
                                    return e = this.startNode(), this.setContext(x.brace), this.next(), e = this.jsxParseExpressionContainer(e, x.j_oTag), e.expression.type === "JSXEmptyExpression" && this.raise(Se.AttributeIsEmpty, {
                                        at: e
                                    }), e;
                                case 140:
                                case 131:
                                    return this.parseExprAtom();
                                default:
                                    throw this.raise(Se.UnsupportedJsxValue, {
                                        at: this.state.startLoc
                                    });
                            }
                        }
                        jsxParseEmptyExpression() {
                            let e = this.startNodeAt(this.state.lastTokEndLoc);
                            return this.finishNodeAt(e, "JSXEmptyExpression", this.state.startLoc);
                        }
                        jsxParseSpreadChild(e) {
                            return this.next(), e.expression = this.parseExpression(), this.setContext(x.j_expr), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(e, "JSXSpreadChild");
                        }
                        jsxParseExpressionContainer(e, s) {
                            if (this.match(8)) e.expression = this.jsxParseEmptyExpression();
                            else {
                                let i = this.parseExpression();
                                e.expression = i;
                            }
                            return this.setContext(s), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(e, "JSXExpressionContainer");
                        }
                        jsxParseAttribute() {
                            let e = this.startNode();
                            return this.match(5) ? (this.setContext(x.brace), this.next(), this.expect(21), e.argument = this.parseMaybeAssignAllowIn(), this.setContext(x.j_oTag), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(e, "JSXSpreadAttribute")) : (e.name = this.jsxParseNamespacedName(), e.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e, "JSXAttribute"));
                        }
                        jsxParseOpeningElementAt(e) {
                            let s = this.startNodeAt(e);
                            return this.eat(141) ? this.finishNode(s, "JSXOpeningFragment") : (s.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s));
                        }
                        jsxParseOpeningElementAfterName(e) {
                            let s = [];
                            for(; !this.match(56) && !this.match(141);)s.push(this.jsxParseAttribute());
                            return e.attributes = s, e.selfClosing = this.eat(56), this.expect(141), this.finishNode(e, "JSXOpeningElement");
                        }
                        jsxParseClosingElementAt(e) {
                            let s = this.startNodeAt(e);
                            return this.eat(141) ? this.finishNode(s, "JSXClosingFragment") : (s.name = this.jsxParseElementName(), this.expect(141), this.finishNode(s, "JSXClosingElement"));
                        }
                        jsxParseElementAt(e) {
                            let s = this.startNodeAt(e), i = [], a = this.jsxParseOpeningElementAt(e), n = null;
                            if (!a.selfClosing) {
                                e: for(;;)switch(this.state.type){
                                    case 140:
                                        if (e = this.state.startLoc, this.next(), this.eat(56)) {
                                            n = this.jsxParseClosingElementAt(e);
                                            break e;
                                        }
                                        i.push(this.jsxParseElementAt(e));
                                        break;
                                    case 139:
                                        i.push(this.parseExprAtom());
                                        break;
                                    case 5:
                                        {
                                            let o = this.startNode();
                                            this.setContext(x.brace), this.next(), this.match(21) ? i.push(this.jsxParseSpreadChild(o)) : i.push(this.jsxParseExpressionContainer(o, x.j_expr));
                                            break;
                                        }
                                    default:
                                        this.unexpected();
                                }
                                Te(a) && !Te(n) && n !== null ? this.raise(Se.MissingClosingTagFragment, {
                                    at: n
                                }) : !Te(a) && Te(n) ? this.raise(Se.MissingClosingTagElement, {
                                    at: n,
                                    openingTagName: Re(a.name)
                                }) : !Te(a) && !Te(n) && Re(n.name) !== Re(a.name) && this.raise(Se.MissingClosingTagElement, {
                                    at: n,
                                    openingTagName: Re(a.name)
                                });
                            }
                            if (Te(a) ? (s.openingFragment = a, s.closingFragment = n) : (s.openingElement = a, s.closingElement = n), s.children = i, this.match(47)) throw this.raise(Se.UnwrappedAdjacentJSXElements, {
                                at: this.state.startLoc
                            });
                            return Te(a) ? this.finishNode(s, "JSXFragment") : this.finishNode(s, "JSXElement");
                        }
                        jsxParseElement() {
                            let e = this.state.startLoc;
                            return this.next(), this.jsxParseElementAt(e);
                        }
                        setContext(e) {
                            let { context: s } = this.state;
                            s[s.length - 1] = e;
                        }
                        parseExprAtom(e) {
                            return this.match(139) ? this.parseLiteral(this.state.value, "JSXText") : this.match(140) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(140), this.jsxParseElement()) : super.parseExprAtom(e);
                        }
                        skipSpace() {
                            this.curContext().preserveSpace || super.skipSpace();
                        }
                        getTokenFromCode(e) {
                            let s = this.curContext();
                            if (s === x.j_expr) {
                                this.jsxReadToken();
                                return;
                            }
                            if (s === x.j_oTag || s === x.j_cTag) {
                                if (fe(e)) {
                                    this.jsxReadWord();
                                    return;
                                }
                                if (e === 62) {
                                    ++this.state.pos, this.finishToken(141);
                                    return;
                                }
                                if ((e === 34 || e === 39) && s === x.j_oTag) {
                                    this.jsxReadString(e);
                                    return;
                                }
                            }
                            if (e === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
                                ++this.state.pos, this.finishToken(140);
                                return;
                            }
                            super.getTokenFromCode(e);
                        }
                        updateContext(e) {
                            let { context: s, type: i } = this.state;
                            if (i === 56 && e === 140) s.splice(-2, 2, x.j_cTag), this.state.canStartJSXElement = !1;
                            else if (i === 140) s.push(x.j_oTag);
                            else if (i === 141) {
                                let a = s[s.length - 1];
                                a === x.j_oTag && e === 56 || a === x.j_cTag ? (s.pop(), this.state.canStartJSXElement = s[s.length - 1] === x.j_expr) : (this.setContext(x.j_expr), this.state.canStartJSXElement = !0);
                            } else this.state.canStartJSXElement = se(i);
                        }
                    }, sh = class extends rs {
                    constructor(){
                        super(...arguments), this.types = new Set, this.enums = new Set, this.constEnums = new Set, this.classes = new Set, this.exportOnlyBindings = new Set;
                    }
                }, rh = class extends is {
                    constructor(){
                        super(...arguments), this.importsStack = [];
                    }
                    createScope(t) {
                        return this.importsStack.push(new Set), new sh(t);
                    }
                    enter(t) {
                        t == Oe && this.importsStack.push(new Set), super.enter(t);
                    }
                    exit() {
                        let t = super.exit();
                        return t == Oe && this.importsStack.pop(), t;
                    }
                    hasImport(t, r) {
                        let e = this.importsStack.length;
                        if (this.importsStack[e - 1].has(t)) return !0;
                        if (!r && e > 1) {
                            for(let s = 0; s < e - 1; s++)if (this.importsStack[s].has(t)) return !0;
                        }
                        return !1;
                    }
                    declareName(t, r, e) {
                        if (r & Ve) {
                            this.hasImport(t, !0) && this.parser.raise(f.VarRedeclaration, {
                                at: e,
                                identifierName: t
                            }), this.importsStack[this.importsStack.length - 1].add(t);
                            return;
                        }
                        let s = this.currentScope();
                        if (r & Yt) {
                            this.maybeExportDefined(s, t), s.exportOnlyBindings.add(t);
                            return;
                        }
                        super.declareName(t, r, e), r & Ce && (r & le || (this.checkRedeclarationInScope(s, t, r, e), this.maybeExportDefined(s, t)), s.types.add(t)), r & Jt && s.enums.add(t), r & Xt && s.constEnums.add(t), r & ft && s.classes.add(t);
                    }
                    isRedeclaredInScope(t, r, e) {
                        if (t.enums.has(r)) {
                            if (e & Jt) {
                                let s = !!(e & Xt), i = t.constEnums.has(r);
                                return s !== i;
                            }
                            return !0;
                        }
                        return e & ft && t.classes.has(r) ? t.lexical.has(r) ? !!(e & le) : !1 : e & Ce && t.types.has(r) ? !0 : super.isRedeclaredInScope(t, r, e);
                    }
                    checkLocalExport(t) {
                        let { name: r } = t;
                        if (this.hasImport(r)) return;
                        let e = this.scopeStack.length;
                        for(let s = e - 1; s >= 0; s--){
                            let i = this.scopeStack[s];
                            if (i.types.has(r) || i.exportOnlyBindings.has(r)) return;
                        }
                        super.checkLocalExport(t);
                    }
                }, ih = (t, r)=>Object.hasOwnProperty.call(t, r) && t[r], Ur = (t)=>t.type === "ParenthesizedExpression" ? Ur(t.expression) : t, ah = class extends Wl {
                    toAssignable(t) {
                        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                        var e, s;
                        let i;
                        switch((t.type === "ParenthesizedExpression" || (e = t.extra) != null && e.parenthesized) && (i = Ur(t), r ? i.type === "Identifier" ? this.expressionScope.recordArrowParameterBindingError(f.InvalidParenthesizedAssignment, {
                            at: t
                        }) : i.type !== "MemberExpression" && this.raise(f.InvalidParenthesizedAssignment, {
                            at: t
                        }) : this.raise(f.InvalidParenthesizedAssignment, {
                            at: t
                        })), t.type){
                            case "Identifier":
                            case "ObjectPattern":
                            case "ArrayPattern":
                            case "AssignmentPattern":
                            case "RestElement":
                                break;
                            case "ObjectExpression":
                                t.type = "ObjectPattern";
                                for(let n = 0, o = t.properties.length, u = o - 1; n < o; n++){
                                    var a;
                                    let c = t.properties[n], y = n === u;
                                    this.toAssignableObjectExpressionProp(c, y, r), y && c.type === "RestElement" && (a = t.extra) != null && a.trailingCommaLoc && this.raise(f.RestTrailingComma, {
                                        at: t.extra.trailingCommaLoc
                                    });
                                }
                                break;
                            case "ObjectProperty":
                                {
                                    let { key: n, value: o } = t;
                                    this.isPrivateName(n) && this.classScope.usePrivateName(this.getPrivateNameSV(n), n.loc.start), this.toAssignable(o, r);
                                    break;
                                }
                            case "SpreadElement":
                                throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
                            case "ArrayExpression":
                                t.type = "ArrayPattern", this.toAssignableList(t.elements, (s = t.extra) == null ? void 0 : s.trailingCommaLoc, r);
                                break;
                            case "AssignmentExpression":
                                t.operator !== "=" && this.raise(f.MissingEqInAssignment, {
                                    at: t.left.loc.end
                                }), t.type = "AssignmentPattern", delete t.operator, this.toAssignable(t.left, r);
                                break;
                            case "ParenthesizedExpression":
                                this.toAssignable(i, r);
                                break;
                        }
                    }
                    toAssignableObjectExpressionProp(t, r, e) {
                        if (t.type === "ObjectMethod") this.raise(t.kind === "get" || t.kind === "set" ? f.PatternHasAccessor : f.PatternHasMethod, {
                            at: t.key
                        });
                        else if (t.type === "SpreadElement") {
                            t.type = "RestElement";
                            let s = t.argument;
                            this.checkToRestConversion(s, !1), this.toAssignable(s, e), r || this.raise(f.RestTrailingComma, {
                                at: t
                            });
                        } else this.toAssignable(t, e);
                    }
                    toAssignableList(t, r, e) {
                        let s = t.length - 1;
                        for(let i = 0; i <= s; i++){
                            let a = t[i];
                            if (a) {
                                if (a.type === "SpreadElement") {
                                    a.type = "RestElement";
                                    let n = a.argument;
                                    this.checkToRestConversion(n, !0), this.toAssignable(n, e);
                                } else this.toAssignable(a, e);
                                a.type === "RestElement" && (i < s ? this.raise(f.RestTrailingComma, {
                                    at: a
                                }) : r && this.raise(f.RestTrailingComma, {
                                    at: r
                                }));
                            }
                        }
                    }
                    isAssignable(t, r) {
                        switch(t.type){
                            case "Identifier":
                            case "ObjectPattern":
                            case "ArrayPattern":
                            case "AssignmentPattern":
                            case "RestElement":
                                return !0;
                            case "ObjectExpression":
                                {
                                    let e = t.properties.length - 1;
                                    return t.properties.every((s, i)=>s.type !== "ObjectMethod" && (i === e || s.type !== "SpreadElement") && this.isAssignable(s));
                                }
                            case "ObjectProperty":
                                return this.isAssignable(t.value);
                            case "SpreadElement":
                                return this.isAssignable(t.argument);
                            case "ArrayExpression":
                                return t.elements.every((e)=>e === null || this.isAssignable(e));
                            case "AssignmentExpression":
                                return t.operator === "=";
                            case "ParenthesizedExpression":
                                return this.isAssignable(t.expression);
                            case "MemberExpression":
                            case "OptionalMemberExpression":
                                return !r;
                            default:
                                return !1;
                        }
                    }
                    toReferencedList(t, r) {
                        return t;
                    }
                    toReferencedListDeep(t, r) {
                        this.toReferencedList(t, r);
                        for (let e of t)(e == null ? void 0 : e.type) === "ArrayExpression" && this.toReferencedListDeep(e.elements);
                    }
                    parseSpread(t) {
                        let r = this.startNode();
                        return this.next(), r.argument = this.parseMaybeAssignAllowIn(t, void 0), this.finishNode(r, "SpreadElement");
                    }
                    parseRestBinding() {
                        let t = this.startNode();
                        return this.next(), t.argument = this.parseBindingAtom(), this.finishNode(t, "RestElement");
                    }
                    parseBindingAtom() {
                        switch(this.state.type){
                            case 0:
                                {
                                    let t = this.startNode();
                                    return this.next(), t.elements = this.parseBindingList(3, 93, 1), this.finishNode(t, "ArrayPattern");
                                }
                            case 5:
                                return this.parseObjectLike(8, !0);
                        }
                        return this.parseIdentifier();
                    }
                    parseBindingList(t, r, e) {
                        let s = e & 1, i = [], a = !0;
                        for(; !this.eat(t);)if (a ? a = !1 : this.expect(12), s && this.match(12)) i.push(null);
                        else {
                            if (this.eat(t)) break;
                            if (this.match(21)) {
                                if (i.push(this.parseAssignableListItemTypes(this.parseRestBinding(), e)), !this.checkCommaAfterRest(r)) {
                                    this.expect(t);
                                    break;
                                }
                            } else {
                                let n = [];
                                for(this.match(26) && this.hasPlugin("decorators") && this.raise(f.UnsupportedParameterDecorator, {
                                    at: this.state.startLoc
                                }); this.match(26);)n.push(this.parseDecorator());
                                i.push(this.parseAssignableListItem(e, n));
                            }
                        }
                        return i;
                    }
                    parseBindingRestProperty(t) {
                        return this.next(), t.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t, "RestElement");
                    }
                    parseBindingProperty() {
                        let t = this.startNode(), { type: r, startLoc: e } = this.state;
                        return r === 21 ? this.parseBindingRestProperty(t) : (r === 136 ? (this.expectPlugin("destructuringPrivate", e), this.classScope.usePrivateName(this.state.value, e), t.key = this.parsePrivateName()) : this.parsePropertyName(t), t.method = !1, this.parseObjPropValue(t, e, !1, !1, !0, !1));
                    }
                    parseAssignableListItem(t, r) {
                        let e = this.parseMaybeDefault();
                        this.parseAssignableListItemTypes(e, t);
                        let s = this.parseMaybeDefault(e.loc.start, e);
                        return r.length && (e.decorators = r), s;
                    }
                    parseAssignableListItemTypes(t, r) {
                        return t;
                    }
                    parseMaybeDefault(t, r) {
                        var e, s;
                        if ((e = t) != null || (t = this.state.startLoc), r = (s = r) != null ? s : this.parseBindingAtom(), !this.eat(29)) return r;
                        let i = this.startNodeAt(t);
                        return i.left = r, i.right = this.parseMaybeAssignAllowIn(), this.finishNode(i, "AssignmentPattern");
                    }
                    isValidLVal(t, r, e) {
                        return ih({
                            AssignmentPattern: "left",
                            RestElement: "argument",
                            ObjectProperty: "value",
                            ParenthesizedExpression: "expression",
                            ArrayPattern: "elements",
                            ObjectPattern: "properties"
                        }, t);
                    }
                    checkLVal(t, r) {
                        let { in: e, binding: s = Pe, checkClashes: i = !1, strictModeChanged: a = !1, hasParenthesizedAncestor: n = !1 } = r;
                        var o;
                        let u = t.type;
                        if (this.isObjectMethod(t)) return;
                        if (u === "MemberExpression") {
                            s !== Pe && this.raise(f.InvalidPropertyBindingPattern, {
                                at: t
                            });
                            return;
                        }
                        if (u === "Identifier") {
                            this.checkIdentifier(t, s, a);
                            let { name: C } = t;
                            i && (i.has(C) ? this.raise(f.ParamDupe, {
                                at: t
                            }) : i.add(C));
                            return;
                        }
                        let c = this.isValidLVal(u, !(n || (o = t.extra) != null && o.parenthesized) && e.type === "AssignmentExpression", s);
                        if (c === !0) return;
                        if (c === !1) {
                            let C = s === Pe ? f.InvalidLhs : f.InvalidLhsBinding;
                            this.raise(C, {
                                at: t,
                                ancestor: e
                            });
                            return;
                        }
                        let [y, g] = Array.isArray(c) ? c : [
                            c,
                            u === "ParenthesizedExpression"
                        ], T = u === "ArrayPattern" || u === "ObjectPattern" || u === "ParenthesizedExpression" ? {
                            type: u
                        } : e;
                        for (let C of [].concat(t[y]))C && this.checkLVal(C, {
                            in: T,
                            binding: s,
                            checkClashes: i,
                            strictModeChanged: a,
                            hasParenthesizedAncestor: g
                        });
                    }
                    checkIdentifier(t, r) {
                        let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                        this.state.strict && (e ? xr(t.name, this.inModule) : yr(t.name)) && (r === Pe ? this.raise(f.StrictEvalArguments, {
                            at: t,
                            referenceName: t.name
                        }) : this.raise(f.StrictEvalArgumentsBinding, {
                            at: t,
                            bindingName: t.name
                        })), r & dt && t.name === "let" && this.raise(f.LetInLexicalBinding, {
                            at: t
                        }), r & Pe || this.declareNameFromIdentifier(t, r);
                    }
                    declareNameFromIdentifier(t, r) {
                        this.scope.declareName(t.name, r, t.loc.start);
                    }
                    checkToRestConversion(t, r) {
                        switch(t.type){
                            case "ParenthesizedExpression":
                                this.checkToRestConversion(t.expression, r);
                                break;
                            case "Identifier":
                            case "MemberExpression":
                                break;
                            case "ArrayExpression":
                            case "ObjectExpression":
                                if (r) break;
                            default:
                                this.raise(f.InvalidRestAssignmentPattern, {
                                    at: t
                                });
                        }
                    }
                    checkCommaAfterRest(t) {
                        return this.match(12) ? (this.raise(this.lookaheadCharCode() === t ? f.RestTrailingComma : f.ElementAfterRest, {
                            at: this.state.startLoc
                        }), !0) : !1;
                    }
                }, nh = (t, r)=>Object.hasOwnProperty.call(t, r) && t[r];
                function oh(t) {
                    if (t == null) throw new Error(`Unexpected ${t} value.`);
                    return t;
                }
                function $r(t) {
                    if (!t) throw new Error("Assert fail");
                }
                var I = pe`typescript`({
                    AbstractMethodHasImplementation: (t)=>{
                        let { methodName: r } = t;
                        return `Method '${r}' cannot have an implementation because it is marked abstract.`;
                    },
                    AbstractPropertyHasInitializer: (t)=>{
                        let { propertyName: r } = t;
                        return `Property '${r}' cannot have an initializer because it is marked abstract.`;
                    },
                    AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.",
                    AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.",
                    AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.",
                    ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.",
                    ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.",
                    ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.",
                    ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.",
                    DeclareAccessor: (t)=>{
                        let { kind: r } = t;
                        return `'declare' is not allowed in ${r}ters.`;
                    },
                    DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.",
                    DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.",
                    DuplicateAccessibilityModifier: (t)=>{
                        let { modifier: r } = t;
                        return "Accessibility modifier already seen.";
                    },
                    DuplicateModifier: (t)=>{
                        let { modifier: r } = t;
                        return `Duplicate modifier: '${r}'.`;
                    },
                    EmptyHeritageClauseType: (t)=>{
                        let { token: r } = t;
                        return `'${r}' list cannot be empty.`;
                    },
                    EmptyTypeArguments: "Type argument list cannot be empty.",
                    EmptyTypeParameters: "Type parameter list cannot be empty.",
                    ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.",
                    ImportAliasHasImportType: "An import alias can not use 'import type'.",
                    ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier",
                    IncompatibleModifiers: (t)=>{
                        let { modifiers: r } = t;
                        return `'${r[0]}' modifier cannot be used with '${r[1]}' modifier.`;
                    },
                    IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.",
                    IndexSignatureHasAccessibility: (t)=>{
                        let { modifier: r } = t;
                        return `Index signatures cannot have an accessibility modifier ('${r}').`;
                    },
                    IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.",
                    IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.",
                    IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.",
                    InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.",
                    InvalidModifierOnTypeMember: (t)=>{
                        let { modifier: r } = t;
                        return `'${r}' modifier cannot appear on a type member.`;
                    },
                    InvalidModifierOnTypeParameter: (t)=>{
                        let { modifier: r } = t;
                        return `'${r}' modifier cannot appear on a type parameter.`;
                    },
                    InvalidModifierOnTypeParameterPositions: (t)=>{
                        let { modifier: r } = t;
                        return `'${r}' modifier can only appear on a type parameter of a class, interface or type alias.`;
                    },
                    InvalidModifiersOrder: (t)=>{
                        let { orderedModifiers: r } = t;
                        return `'${r[0]}' modifier must precede '${r[1]}' modifier.`;
                    },
                    InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.",
                    InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.",
                    MissingInterfaceName: "'interface' declarations must be followed by an identifier.",
                    MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.",
                    NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.",
                    NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.",
                    OptionalTypeBeforeRequired: "A required element cannot follow an optional element.",
                    OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.",
                    PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.",
                    PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.",
                    PrivateElementHasAccessibility: (t)=>{
                        let { modifier: r } = t;
                        return `Private elements cannot have an accessibility modifier ('${r}').`;
                    },
                    ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.",
                    ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.",
                    ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.",
                    SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.",
                    SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.",
                    SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.",
                    SingleTypeParameterWithoutTrailingComma: (t)=>{
                        let { typeParameterName: r } = t;
                        return `Single type parameter ${r} should have a trailing comma. Example usage: <${r},>.`;
                    },
                    StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.",
                    TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).",
                    TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
                    TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.",
                    TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.",
                    TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.",
                    UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.",
                    UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.",
                    UnexpectedTypeAnnotation: "Did not expect a type annotation here.",
                    UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.",
                    UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.",
                    UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.",
                    UnsupportedSignatureParameterKind: (t)=>{
                        let { type: r } = t;
                        return `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${r}.`;
                    }
                });
                function lh(t) {
                    switch(t){
                        case "any":
                            return "TSAnyKeyword";
                        case "boolean":
                            return "TSBooleanKeyword";
                        case "bigint":
                            return "TSBigIntKeyword";
                        case "never":
                            return "TSNeverKeyword";
                        case "number":
                            return "TSNumberKeyword";
                        case "object":
                            return "TSObjectKeyword";
                        case "string":
                            return "TSStringKeyword";
                        case "symbol":
                            return "TSSymbolKeyword";
                        case "undefined":
                            return "TSUndefinedKeyword";
                        case "unknown":
                            return "TSUnknownKeyword";
                        default:
                            return;
                    }
                }
                function Hr(t) {
                    return t === "private" || t === "public" || t === "protected";
                }
                function hh(t) {
                    return t === "in" || t === "out";
                }
                var uh = (t)=>class extends t {
                        constructor(){
                            super(...arguments), this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, {
                                allowedModifiers: [
                                    "in",
                                    "out"
                                ],
                                disallowedModifiers: [
                                    "const",
                                    "public",
                                    "private",
                                    "protected",
                                    "readonly",
                                    "declare",
                                    "abstract",
                                    "override"
                                ],
                                errorTemplate: I.InvalidModifierOnTypeParameter
                            }), this.tsParseConstModifier = this.tsParseModifiers.bind(this, {
                                allowedModifiers: [
                                    "const"
                                ],
                                disallowedModifiers: [
                                    "in",
                                    "out"
                                ],
                                errorTemplate: I.InvalidModifierOnTypeParameterPositions
                            }), this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, {
                                allowedModifiers: [
                                    "in",
                                    "out",
                                    "const"
                                ],
                                disallowedModifiers: [
                                    "public",
                                    "private",
                                    "protected",
                                    "readonly",
                                    "declare",
                                    "abstract",
                                    "override"
                                ],
                                errorTemplate: I.InvalidModifierOnTypeParameter
                            });
                        }
                        getScopeHandler() {
                            return rh;
                        }
                        tsIsIdentifier() {
                            return q(this.state.type);
                        }
                        tsTokenCanFollowModifier() {
                            return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
                        }
                        tsNextTokenCanFollowModifier() {
                            return this.next(), this.tsTokenCanFollowModifier();
                        }
                        tsParseModifier(e, s) {
                            if (!q(this.state.type) && this.state.type !== 58 && this.state.type !== 75) return;
                            let i = this.state.value;
                            if (e.indexOf(i) !== -1) {
                                if (s && this.tsIsStartOfStaticBlocks()) return;
                                if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this))) return i;
                            }
                        }
                        tsParseModifiers(e, s) {
                            let { allowedModifiers: i, disallowedModifiers: a, stopOnStartOfClassStaticBlock: n, errorTemplate: o = I.InvalidModifierOnTypeMember } = e, u = (y, g, T, C)=>{
                                g === T && s[C] && this.raise(I.InvalidModifiersOrder, {
                                    at: y,
                                    orderedModifiers: [
                                        T,
                                        C
                                    ]
                                });
                            }, c = (y, g, T, C)=>{
                                (s[T] && g === C || s[C] && g === T) && this.raise(I.IncompatibleModifiers, {
                                    at: y,
                                    modifiers: [
                                        T,
                                        C
                                    ]
                                });
                            };
                            for(;;){
                                let { startLoc: y } = this.state, g = this.tsParseModifier(i.concat(a != null ? a : []), n);
                                if (!g) break;
                                Hr(g) ? s.accessibility ? this.raise(I.DuplicateAccessibilityModifier, {
                                    at: y,
                                    modifier: g
                                }) : (u(y, g, g, "override"), u(y, g, g, "static"), u(y, g, g, "readonly"), s.accessibility = g) : hh(g) ? (s[g] && this.raise(I.DuplicateModifier, {
                                    at: y,
                                    modifier: g
                                }), s[g] = !0, u(y, g, "in", "out")) : (Object.hasOwnProperty.call(s, g) ? this.raise(I.DuplicateModifier, {
                                    at: y,
                                    modifier: g
                                }) : (u(y, g, "static", "readonly"), u(y, g, "static", "override"), u(y, g, "override", "readonly"), u(y, g, "abstract", "override"), c(y, g, "declare", "override"), c(y, g, "static", "abstract")), s[g] = !0), a != null && a.includes(g) && this.raise(o, {
                                    at: y,
                                    modifier: g
                                });
                            }
                        }
                        tsIsListTerminator(e) {
                            switch(e){
                                case "EnumMembers":
                                case "TypeMembers":
                                    return this.match(8);
                                case "HeritageClauseElement":
                                    return this.match(5);
                                case "TupleElementTypes":
                                    return this.match(3);
                                case "TypeParametersOrArguments":
                                    return this.match(48);
                            }
                        }
                        tsParseList(e, s) {
                            let i = [];
                            for(; !this.tsIsListTerminator(e);)i.push(s());
                            return i;
                        }
                        tsParseDelimitedList(e, s, i) {
                            return oh(this.tsParseDelimitedListWorker(e, s, !0, i));
                        }
                        tsParseDelimitedListWorker(e, s, i, a) {
                            let n = [], o = -1;
                            for(; !this.tsIsListTerminator(e);){
                                o = -1;
                                let u = s();
                                if (u == null) return;
                                if (n.push(u), this.eat(12)) {
                                    o = this.state.lastTokStart;
                                    continue;
                                }
                                if (this.tsIsListTerminator(e)) break;
                                i && this.expect(12);
                                return;
                            }
                            return a && (a.value = o), n;
                        }
                        tsParseBracketedList(e, s, i, a, n) {
                            a || (i ? this.expect(0) : this.expect(47));
                            let o = this.tsParseDelimitedList(e, s, n);
                            return i ? this.expect(3) : this.expect(48), o;
                        }
                        tsParseImportType() {
                            let e = this.startNode();
                            return this.expect(83), this.expect(10), this.match(131) || this.raise(I.UnsupportedImportTypeArgument, {
                                at: this.state.startLoc
                            }), e.argument = super.parseExprAtom(), this.expect(11), this.eat(16) && (e.qualifier = this.tsParseEntityName()), this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSImportType");
                        }
                        tsParseEntityName() {
                            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, s = this.parseIdentifier(e);
                            for(; this.eat(16);){
                                let i = this.startNodeAtNode(s);
                                i.left = s, i.right = this.parseIdentifier(e), s = this.finishNode(i, "TSQualifiedName");
                            }
                            return s;
                        }
                        tsParseTypeReference() {
                            let e = this.startNode();
                            return e.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeReference");
                        }
                        tsParseThisTypePredicate(e) {
                            this.next();
                            let s = this.startNodeAtNode(e);
                            return s.parameterName = e, s.typeAnnotation = this.tsParseTypeAnnotation(!1), s.asserts = !1, this.finishNode(s, "TSTypePredicate");
                        }
                        tsParseThisTypeNode() {
                            let e = this.startNode();
                            return this.next(), this.finishNode(e, "TSThisType");
                        }
                        tsParseTypeQuery() {
                            let e = this.startNode();
                            return this.expect(87), this.match(83) ? e.exprName = this.tsParseImportType() : e.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeQuery");
                        }
                        tsParseTypeParameter(e) {
                            let s = this.startNode();
                            return e(s), s.name = this.tsParseTypeParameterName(), s.constraint = this.tsEatThenParseType(81), s.default = this.tsEatThenParseType(29), this.finishNode(s, "TSTypeParameter");
                        }
                        tsTryParseTypeParameters(e) {
                            if (this.match(47)) return this.tsParseTypeParameters(e);
                        }
                        tsParseTypeParameters(e) {
                            let s = this.startNode();
                            this.match(47) || this.match(140) ? this.next() : this.unexpected();
                            let i = {
                                value: -1
                            };
                            return s.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e), !1, !0, i), s.params.length === 0 && this.raise(I.EmptyTypeParameters, {
                                at: s
                            }), i.value !== -1 && this.addExtra(s, "trailingComma", i.value), this.finishNode(s, "TSTypeParameterDeclaration");
                        }
                        tsFillSignature(e, s) {
                            let i = e === 19, a = "parameters", n = "typeAnnotation";
                            s.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier), this.expect(10), s[a] = this.tsParseBindingListForSignature(), i ? s[n] = this.tsParseTypeOrTypePredicateAnnotation(e) : this.match(e) && (s[n] = this.tsParseTypeOrTypePredicateAnnotation(e));
                        }
                        tsParseBindingListForSignature() {
                            return super.parseBindingList(11, 41, 2).map((e)=>(e.type !== "Identifier" && e.type !== "RestElement" && e.type !== "ObjectPattern" && e.type !== "ArrayPattern" && this.raise(I.UnsupportedSignatureParameterKind, {
                                    at: e,
                                    type: e.type
                                }), e));
                        }
                        tsParseTypeMemberSemicolon() {
                            !this.eat(12) && !this.isLineTerminator() && this.expect(13);
                        }
                        tsParseSignatureMember(e, s) {
                            return this.tsFillSignature(14, s), this.tsParseTypeMemberSemicolon(), this.finishNode(s, e);
                        }
                        tsIsUnambiguouslyIndexSignature() {
                            return this.next(), q(this.state.type) ? (this.next(), this.match(14)) : !1;
                        }
                        tsTryParseIndexSignature(e) {
                            if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this)))) return;
                            this.expect(0);
                            let s = this.parseIdentifier();
                            s.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s), this.expect(3), e.parameters = [
                                s
                            ];
                            let i = this.tsTryParseTypeAnnotation();
                            return i && (e.typeAnnotation = i), this.tsParseTypeMemberSemicolon(), this.finishNode(e, "TSIndexSignature");
                        }
                        tsParsePropertyOrMethodSignature(e, s) {
                            this.eat(17) && (e.optional = !0);
                            let i = e;
                            if (this.match(10) || this.match(47)) {
                                s && this.raise(I.ReadonlyForMethodSignature, {
                                    at: e
                                });
                                let a = i;
                                a.kind && this.match(47) && this.raise(I.AccesorCannotHaveTypeParameters, {
                                    at: this.state.curPosition()
                                }), this.tsFillSignature(14, a), this.tsParseTypeMemberSemicolon();
                                let n = "parameters", o = "typeAnnotation";
                                if (a.kind === "get") a[n].length > 0 && (this.raise(f.BadGetterArity, {
                                    at: this.state.curPosition()
                                }), this.isThisParam(a[n][0]) && this.raise(I.AccesorCannotDeclareThisParameter, {
                                    at: this.state.curPosition()
                                }));
                                else if (a.kind === "set") {
                                    if (a[n].length !== 1) this.raise(f.BadSetterArity, {
                                        at: this.state.curPosition()
                                    });
                                    else {
                                        let u = a[n][0];
                                        this.isThisParam(u) && this.raise(I.AccesorCannotDeclareThisParameter, {
                                            at: this.state.curPosition()
                                        }), u.type === "Identifier" && u.optional && this.raise(I.SetAccesorCannotHaveOptionalParameter, {
                                            at: this.state.curPosition()
                                        }), u.type === "RestElement" && this.raise(I.SetAccesorCannotHaveRestParameter, {
                                            at: this.state.curPosition()
                                        });
                                    }
                                    a[o] && this.raise(I.SetAccesorCannotHaveReturnType, {
                                        at: a[o]
                                    });
                                } else a.kind = "method";
                                return this.finishNode(a, "TSMethodSignature");
                            } else {
                                let a = i;
                                s && (a.readonly = !0);
                                let n = this.tsTryParseTypeAnnotation();
                                return n && (a.typeAnnotation = n), this.tsParseTypeMemberSemicolon(), this.finishNode(a, "TSPropertySignature");
                            }
                        }
                        tsParseTypeMember() {
                            let e = this.startNode();
                            if (this.match(10) || this.match(47)) return this.tsParseSignatureMember("TSCallSignatureDeclaration", e);
                            if (this.match(77)) {
                                let i = this.startNode();
                                return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e) : (e.key = this.createIdentifier(i, "new"), this.tsParsePropertyOrMethodSignature(e, !1));
                            }
                            this.tsParseModifiers({
                                allowedModifiers: [
                                    "readonly"
                                ],
                                disallowedModifiers: [
                                    "declare",
                                    "abstract",
                                    "private",
                                    "protected",
                                    "public",
                                    "static",
                                    "override"
                                ]
                            }, e);
                            let s = this.tsTryParseIndexSignature(e);
                            return s || (super.parsePropertyName(e), !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.tsTokenCanFollowModifier() && (e.kind = e.key.name, super.parsePropertyName(e)), this.tsParsePropertyOrMethodSignature(e, !!e.readonly));
                        }
                        tsParseTypeLiteral() {
                            let e = this.startNode();
                            return e.members = this.tsParseObjectTypeMembers(), this.finishNode(e, "TSTypeLiteral");
                        }
                        tsParseObjectTypeMembers() {
                            this.expect(5);
                            let e = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
                            return this.expect(8), e;
                        }
                        tsIsStartOfMappedType() {
                            return this.next(), this.eat(53) ? this.isContextual(120) : (this.isContextual(120) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? !1 : (this.next(), this.match(58)));
                        }
                        tsParseMappedTypeParameter() {
                            let e = this.startNode();
                            return e.name = this.tsParseTypeParameterName(), e.constraint = this.tsExpectThenParseType(58), this.finishNode(e, "TSTypeParameter");
                        }
                        tsParseMappedType() {
                            let e = this.startNode();
                            return this.expect(5), this.match(53) ? (e.readonly = this.state.value, this.next(), this.expectContextual(120)) : this.eatContextual(120) && (e.readonly = !0), this.expect(0), e.typeParameter = this.tsParseMappedTypeParameter(), e.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e.optional = !0), e.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e, "TSMappedType");
                        }
                        tsParseTupleType() {
                            let e = this.startNode();
                            e.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), !0, !1);
                            let s = !1, i = null;
                            return e.elementTypes.forEach((a)=>{
                                var n;
                                let { type: o } = a;
                                s && o !== "TSRestType" && o !== "TSOptionalType" && !(o === "TSNamedTupleMember" && a.optional) && this.raise(I.OptionalTypeBeforeRequired, {
                                    at: a
                                }), s || (s = o === "TSNamedTupleMember" && a.optional || o === "TSOptionalType");
                                let u = o;
                                o === "TSRestType" && (a = a.typeAnnotation, u = a.type);
                                let c = u === "TSNamedTupleMember";
                                (n = i) != null || (i = c), i !== c && this.raise(I.MixedLabeledAndUnlabeledElements, {
                                    at: a
                                });
                            }), this.finishNode(e, "TSTupleType");
                        }
                        tsParseTupleElementType() {
                            let { startLoc: e } = this.state, s = this.eat(21), i, a, n, o, c = te(this.state.type) ? this.lookaheadCharCode() : null;
                            if (c === 58) i = !0, n = !1, a = this.parseIdentifier(!0), this.expect(14), o = this.tsParseType();
                            else if (c === 63) {
                                n = !0;
                                let y = this.state.startLoc, g = this.state.value, T = this.tsParseNonArrayType();
                                this.lookaheadCharCode() === 58 ? (i = !0, a = this.createIdentifier(this.startNodeAt(y), g), this.expect(17), this.expect(14), o = this.tsParseType()) : (i = !1, o = T, this.expect(17));
                            } else o = this.tsParseType(), n = this.eat(17), i = this.eat(14);
                            if (i) {
                                let y;
                                a ? (y = this.startNodeAtNode(a), y.optional = n, y.label = a, y.elementType = o, this.eat(17) && (y.optional = !0, this.raise(I.TupleOptionalAfterType, {
                                    at: this.state.lastTokStartLoc
                                }))) : (y = this.startNodeAtNode(o), y.optional = n, this.raise(I.InvalidTupleMemberLabel, {
                                    at: o
                                }), y.label = o, y.elementType = this.tsParseType()), o = this.finishNode(y, "TSNamedTupleMember");
                            } else if (n) {
                                let y = this.startNodeAtNode(o);
                                y.typeAnnotation = o, o = this.finishNode(y, "TSOptionalType");
                            }
                            if (s) {
                                let y = this.startNodeAt(e);
                                y.typeAnnotation = o, o = this.finishNode(y, "TSRestType");
                            }
                            return o;
                        }
                        tsParseParenthesizedType() {
                            let e = this.startNode();
                            return this.expect(10), e.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e, "TSParenthesizedType");
                        }
                        tsParseFunctionOrConstructorType(e, s) {
                            let i = this.startNode();
                            return e === "TSConstructorType" && (i.abstract = !!s, s && this.next(), this.next()), this.tsInAllowConditionalTypesContext(()=>this.tsFillSignature(19, i)), this.finishNode(i, e);
                        }
                        tsParseLiteralTypeNode() {
                            let e = this.startNode();
                            return e.literal = (()=>{
                                switch(this.state.type){
                                    case 132:
                                    case 133:
                                    case 131:
                                    case 85:
                                    case 86:
                                        return super.parseExprAtom();
                                    default:
                                        this.unexpected();
                                }
                            })(), this.finishNode(e, "TSLiteralType");
                        }
                        tsParseTemplateLiteralType() {
                            let e = this.startNode();
                            return e.literal = super.parseTemplate(!1), this.finishNode(e, "TSLiteralType");
                        }
                        parseTemplateSubstitution() {
                            return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
                        }
                        tsParseThisTypeOrThisTypePredicate() {
                            let e = this.tsParseThisTypeNode();
                            return this.isContextual(114) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e) : e;
                        }
                        tsParseNonArrayType() {
                            switch(this.state.type){
                                case 131:
                                case 132:
                                case 133:
                                case 85:
                                case 86:
                                    return this.tsParseLiteralTypeNode();
                                case 53:
                                    if (this.state.value === "-") {
                                        let e = this.startNode(), s = this.lookahead();
                                        return s.type !== 132 && s.type !== 133 && this.unexpected(), e.literal = this.parseMaybeUnary(), this.finishNode(e, "TSLiteralType");
                                    }
                                    break;
                                case 78:
                                    return this.tsParseThisTypeOrThisTypePredicate();
                                case 87:
                                    return this.tsParseTypeQuery();
                                case 83:
                                    return this.tsParseImportType();
                                case 5:
                                    return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
                                case 0:
                                    return this.tsParseTupleType();
                                case 10:
                                    return this.tsParseParenthesizedType();
                                case 25:
                                case 24:
                                    return this.tsParseTemplateLiteralType();
                                default:
                                    {
                                        let { type: e } = this.state;
                                        if (q(e) || e === 88 || e === 84) {
                                            let s = e === 88 ? "TSVoidKeyword" : e === 84 ? "TSNullKeyword" : lh(this.state.value);
                                            if (s !== void 0 && this.lookaheadCharCode() !== 46) {
                                                let i = this.startNode();
                                                return this.next(), this.finishNode(i, s);
                                            }
                                            return this.tsParseTypeReference();
                                        }
                                    }
                            }
                            this.unexpected();
                        }
                        tsParseArrayTypeOrHigher() {
                            let e = this.tsParseNonArrayType();
                            for(; !this.hasPrecedingLineBreak() && this.eat(0);)if (this.match(3)) {
                                let s = this.startNodeAtNode(e);
                                s.elementType = e, this.expect(3), e = this.finishNode(s, "TSArrayType");
                            } else {
                                let s = this.startNodeAtNode(e);
                                s.objectType = e, s.indexType = this.tsParseType(), this.expect(3), e = this.finishNode(s, "TSIndexedAccessType");
                            }
                            return e;
                        }
                        tsParseTypeOperator() {
                            let e = this.startNode(), s = this.state.value;
                            return this.next(), e.operator = s, e.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e), this.finishNode(e, "TSTypeOperator");
                        }
                        tsCheckTypeAnnotationForReadOnly(e) {
                            switch(e.typeAnnotation.type){
                                case "TSTupleType":
                                case "TSArrayType":
                                    return;
                                default:
                                    this.raise(I.UnexpectedReadonly, {
                                        at: e
                                    });
                            }
                        }
                        tsParseInferType() {
                            let e = this.startNode();
                            this.expectContextual(113);
                            let s = this.startNode();
                            return s.name = this.tsParseTypeParameterName(), s.constraint = this.tsTryParse(()=>this.tsParseConstraintForInferType()), e.typeParameter = this.finishNode(s, "TSTypeParameter"), this.finishNode(e, "TSInferType");
                        }
                        tsParseConstraintForInferType() {
                            if (this.eat(81)) {
                                let e = this.tsInDisallowConditionalTypesContext(()=>this.tsParseType());
                                if (this.state.inDisallowConditionalTypesContext || !this.match(17)) return e;
                            }
                        }
                        tsParseTypeOperatorOrHigher() {
                            return qo(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(()=>this.tsParseArrayTypeOrHigher());
                        }
                        tsParseUnionOrIntersectionType(e, s, i) {
                            let a = this.startNode(), n = this.eat(i), o = [];
                            do o.push(s());
                            while (this.eat(i));
                            return o.length === 1 && !n ? o[0] : (a.types = o, this.finishNode(a, e));
                        }
                        tsParseIntersectionTypeOrHigher() {
                            return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
                        }
                        tsParseUnionTypeOrHigher() {
                            return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
                        }
                        tsIsStartOfFunctionType() {
                            return this.match(47) ? !0 : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
                        }
                        tsSkipParameterStart() {
                            if (q(this.state.type) || this.match(78)) return this.next(), !0;
                            if (this.match(5)) {
                                let { errors: e } = this.state, s = e.length;
                                try {
                                    return this.parseObjectLike(8, !0), e.length === s;
                                } catch  {
                                    return !1;
                                }
                            }
                            if (this.match(0)) {
                                this.next();
                                let { errors: e } = this.state, s = e.length;
                                try {
                                    return super.parseBindingList(3, 93, 1), e.length === s;
                                } catch  {
                                    return !1;
                                }
                            }
                            return !1;
                        }
                        tsIsUnambiguouslyStartOfFunctionType() {
                            return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
                        }
                        tsParseTypeOrTypePredicateAnnotation(e) {
                            return this.tsInType(()=>{
                                let s = this.startNode();
                                this.expect(e);
                                let i = this.startNode(), a = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
                                if (a && this.match(78)) {
                                    let u = this.tsParseThisTypeOrThisTypePredicate();
                                    return u.type === "TSThisType" ? (i.parameterName = u, i.asserts = !0, i.typeAnnotation = null, u = this.finishNode(i, "TSTypePredicate")) : (this.resetStartLocationFromNode(u, i), u.asserts = !0), s.typeAnnotation = u, this.finishNode(s, "TSTypeAnnotation");
                                }
                                let n = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
                                if (!n) return a ? (i.parameterName = this.parseIdentifier(), i.asserts = a, i.typeAnnotation = null, s.typeAnnotation = this.finishNode(i, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(!1, s);
                                let o = this.tsParseTypeAnnotation(!1);
                                return i.parameterName = n, i.typeAnnotation = o, i.asserts = a, s.typeAnnotation = this.finishNode(i, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation");
                            });
                        }
                        tsTryParseTypeOrTypePredicateAnnotation() {
                            return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
                        }
                        tsTryParseTypeAnnotation() {
                            return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
                        }
                        tsTryParseType() {
                            return this.tsEatThenParseType(14);
                        }
                        tsParseTypePredicatePrefix() {
                            let e = this.parseIdentifier();
                            if (this.isContextual(114) && !this.hasPrecedingLineBreak()) return this.next(), e;
                        }
                        tsParseTypePredicateAsserts() {
                            if (this.state.type !== 107) return !1;
                            let e = this.state.containsEsc;
                            return this.next(), !q(this.state.type) && !this.match(78) ? !1 : (e && this.raise(f.InvalidEscapedReservedWord, {
                                at: this.state.lastTokStartLoc,
                                reservedWord: "asserts"
                            }), !0);
                        }
                        tsParseTypeAnnotation() {
                            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
                            return this.tsInType(()=>{
                                e && this.expect(14), s.typeAnnotation = this.tsParseType();
                            }), this.finishNode(s, "TSTypeAnnotation");
                        }
                        tsParseType() {
                            $r(this.state.inType);
                            let e = this.tsParseNonConditionalType();
                            if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81)) return e;
                            let s = this.startNodeAtNode(e);
                            return s.checkType = e, s.extendsType = this.tsInDisallowConditionalTypesContext(()=>this.tsParseNonConditionalType()), this.expect(17), s.trueType = this.tsInAllowConditionalTypesContext(()=>this.tsParseType()), this.expect(14), s.falseType = this.tsInAllowConditionalTypesContext(()=>this.tsParseType()), this.finishNode(s, "TSConditionalType");
                        }
                        isAbstractConstructorSignature() {
                            return this.isContextual(122) && this.lookahead().type === 77;
                        }
                        tsParseNonConditionalType() {
                            return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", !0) : this.tsParseUnionTypeOrHigher();
                        }
                        tsParseTypeAssertion() {
                            this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(I.ReservedTypeAssertion, {
                                at: this.state.startLoc
                            });
                            let e = this.startNode();
                            return e.typeAnnotation = this.tsInType(()=>(this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), e.expression = this.parseMaybeUnary(), this.finishNode(e, "TSTypeAssertion");
                        }
                        tsParseHeritageClause(e) {
                            let s = this.state.startLoc, i = this.tsParseDelimitedList("HeritageClauseElement", ()=>{
                                let a = this.startNode();
                                return a.expression = this.tsParseEntityName(), this.match(47) && (a.typeParameters = this.tsParseTypeArguments()), this.finishNode(a, "TSExpressionWithTypeArguments");
                            });
                            return i.length || this.raise(I.EmptyHeritageClauseType, {
                                at: s,
                                token: e
                            }), i;
                        }
                        tsParseInterfaceDeclaration(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                            if (this.hasFollowingLineBreak()) return null;
                            this.expectContextual(127), s.declare && (e.declare = !0), q(this.state.type) ? (e.id = this.parseIdentifier(), this.checkIdentifier(e.id, pl)) : (e.id = null, this.raise(I.MissingInterfaceName, {
                                at: this.state.startLoc
                            })), e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers), this.eat(81) && (e.extends = this.tsParseHeritageClause("extends"));
                            let i = this.startNode();
                            return i.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e.body = this.finishNode(i, "TSInterfaceBody"), this.finishNode(e, "TSInterfaceDeclaration");
                        }
                        tsParseTypeAliasDeclaration(e) {
                            return e.id = this.parseIdentifier(), this.checkIdentifier(e.id, fl), e.typeAnnotation = this.tsInType(()=>{
                                if (e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers), this.expect(29), this.isContextual(112) && this.lookahead().type !== 16) {
                                    let s = this.startNode();
                                    return this.next(), this.finishNode(s, "TSIntrinsicKeyword");
                                }
                                return this.tsParseType();
                            }), this.semicolon(), this.finishNode(e, "TSTypeAliasDeclaration");
                        }
                        tsInNoContext(e) {
                            let s = this.state.context;
                            this.state.context = [
                                s[0]
                            ];
                            try {
                                return e();
                            } finally{
                                this.state.context = s;
                            }
                        }
                        tsInType(e) {
                            let s = this.state.inType;
                            this.state.inType = !0;
                            try {
                                return e();
                            } finally{
                                this.state.inType = s;
                            }
                        }
                        tsInDisallowConditionalTypesContext(e) {
                            let s = this.state.inDisallowConditionalTypesContext;
                            this.state.inDisallowConditionalTypesContext = !0;
                            try {
                                return e();
                            } finally{
                                this.state.inDisallowConditionalTypesContext = s;
                            }
                        }
                        tsInAllowConditionalTypesContext(e) {
                            let s = this.state.inDisallowConditionalTypesContext;
                            this.state.inDisallowConditionalTypesContext = !1;
                            try {
                                return e();
                            } finally{
                                this.state.inDisallowConditionalTypesContext = s;
                            }
                        }
                        tsEatThenParseType(e) {
                            return this.match(e) ? this.tsNextThenParseType() : void 0;
                        }
                        tsExpectThenParseType(e) {
                            return this.tsDoThenParseType(()=>this.expect(e));
                        }
                        tsNextThenParseType() {
                            return this.tsDoThenParseType(()=>this.next());
                        }
                        tsDoThenParseType(e) {
                            return this.tsInType(()=>(e(), this.tsParseType()));
                        }
                        tsParseEnumMember() {
                            let e = this.startNode();
                            return e.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(!0), this.eat(29) && (e.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(e, "TSEnumMember");
                        }
                        tsParseEnumDeclaration(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                            return s.const && (e.const = !0), s.declare && (e.declare = !0), this.expectContextual(124), e.id = this.parseIdentifier(), this.checkIdentifier(e.id, e.const ? ml : Cr), this.expect(5), e.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e, "TSEnumDeclaration");
                        }
                        tsParseModuleBlock() {
                            let e = this.startNode();
                            return this.scope.enter(Fe), this.expect(5), super.parseBlockOrModuleBlockBody(e.body = [], void 0, !0, 8), this.scope.exit(), this.finishNode(e, "TSModuleBlock");
                        }
                        tsParseModuleOrNamespaceDeclaration(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                            if (e.id = this.parseIdentifier(), s || this.checkIdentifier(e.id, yl), this.eat(16)) {
                                let i = this.startNode();
                                this.tsParseModuleOrNamespaceDeclaration(i, !0), e.body = i;
                            } else this.scope.enter(Oe), this.prodParam.enter(Me), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
                            return this.finishNode(e, "TSModuleDeclaration");
                        }
                        tsParseAmbientExternalModuleDeclaration(e) {
                            return this.isContextual(110) ? (e.global = !0, e.id = this.parseIdentifier()) : this.match(131) ? e.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(Oe), this.prodParam.enter(Me), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e, "TSModuleDeclaration");
                        }
                        tsParseImportEqualsDeclaration(e, s) {
                            e.isExport = s || !1, e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Ve), this.expect(29);
                            let i = this.tsParseModuleReference();
                            return e.importKind === "type" && i.type !== "TSExternalModuleReference" && this.raise(I.ImportAliasHasImportType, {
                                at: i
                            }), e.moduleReference = i, this.semicolon(), this.finishNode(e, "TSImportEqualsDeclaration");
                        }
                        tsIsExternalModuleReference() {
                            return this.isContextual(117) && this.lookaheadCharCode() === 40;
                        }
                        tsParseModuleReference() {
                            return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(!1);
                        }
                        tsParseExternalModuleReference() {
                            let e = this.startNode();
                            return this.expectContextual(117), this.expect(10), this.match(131) || this.unexpected(), e.expression = super.parseExprAtom(), this.expect(11), this.finishNode(e, "TSExternalModuleReference");
                        }
                        tsLookAhead(e) {
                            let s = this.state.clone(), i = e();
                            return this.state = s, i;
                        }
                        tsTryParseAndCatch(e) {
                            let s = this.tryParse((i)=>e() || i());
                            if (!(s.aborted || !s.node)) return s.error && (this.state = s.failState), s.node;
                        }
                        tsTryParse(e) {
                            let s = this.state.clone(), i = e();
                            if (i !== void 0 && i !== !1) return i;
                            this.state = s;
                        }
                        tsTryParseDeclare(e) {
                            if (this.isLineTerminator()) return;
                            let s = this.state.type, i;
                            return this.isContextual(99) && (s = 74, i = "let"), this.tsInAmbientContext(()=>{
                                if (s === 68) return e.declare = !0, super.parseFunctionStatement(e, !1, !1);
                                if (s === 80) return e.declare = !0, this.parseClass(e, !0, !1);
                                if (s === 124) return this.tsParseEnumDeclaration(e, {
                                    declare: !0
                                });
                                if (s === 110) return this.tsParseAmbientExternalModuleDeclaration(e);
                                if (s === 75 || s === 74) return !this.match(75) || !this.isLookaheadContextual("enum") ? (e.declare = !0, this.parseVarStatement(e, i || this.state.value, !0)) : (this.expect(75), this.tsParseEnumDeclaration(e, {
                                    const: !0,
                                    declare: !0
                                }));
                                if (s === 127) {
                                    let a = this.tsParseInterfaceDeclaration(e, {
                                        declare: !0
                                    });
                                    if (a) return a;
                                }
                                if (q(s)) return this.tsParseDeclaration(e, this.state.value, !0, null);
                            });
                        }
                        tsTryParseExportDeclaration() {
                            return this.tsParseDeclaration(this.startNode(), this.state.value, !0, null);
                        }
                        tsParseExpressionStatement(e, s, i) {
                            switch(s.name){
                                case "declare":
                                    {
                                        let a = this.tsTryParseDeclare(e);
                                        if (a) return a.declare = !0, a;
                                        break;
                                    }
                                case "global":
                                    if (this.match(5)) {
                                        this.scope.enter(Oe), this.prodParam.enter(Me);
                                        let a = e;
                                        return a.global = !0, a.id = s, a.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(a, "TSModuleDeclaration");
                                    }
                                    break;
                                default:
                                    return this.tsParseDeclaration(e, s.name, !1, i);
                            }
                        }
                        tsParseDeclaration(e, s, i, a) {
                            switch(s){
                                case "abstract":
                                    if (this.tsCheckLineTerminator(i) && (this.match(80) || q(this.state.type))) return this.tsParseAbstractDeclaration(e, a);
                                    break;
                                case "module":
                                    if (this.tsCheckLineTerminator(i)) {
                                        if (this.match(131)) return this.tsParseAmbientExternalModuleDeclaration(e);
                                        if (q(this.state.type)) return this.tsParseModuleOrNamespaceDeclaration(e);
                                    }
                                    break;
                                case "namespace":
                                    if (this.tsCheckLineTerminator(i) && q(this.state.type)) return this.tsParseModuleOrNamespaceDeclaration(e);
                                    break;
                                case "type":
                                    if (this.tsCheckLineTerminator(i) && q(this.state.type)) return this.tsParseTypeAliasDeclaration(e);
                                    break;
                            }
                        }
                        tsCheckLineTerminator(e) {
                            return e ? this.hasFollowingLineBreak() ? !1 : (this.next(), !0) : !this.isLineTerminator();
                        }
                        tsTryParseGenericAsyncArrowFunction(e) {
                            if (!this.match(47)) return;
                            let s = this.state.maybeInArrowParameters;
                            this.state.maybeInArrowParameters = !0;
                            let i = this.tsTryParseAndCatch(()=>{
                                let a = this.startNodeAt(e);
                                return a.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier), super.parseFunctionParams(a), a.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), a;
                            });
                            if (this.state.maybeInArrowParameters = s, !!i) return super.parseArrowExpression(i, null, !0);
                        }
                        tsParseTypeArgumentsInExpression() {
                            if (this.reScan_lt() === 47) return this.tsParseTypeArguments();
                        }
                        tsParseTypeArguments() {
                            let e = this.startNode();
                            return e.params = this.tsInType(()=>this.tsInNoContext(()=>(this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e.params.length === 0 && this.raise(I.EmptyTypeArguments, {
                                at: e
                            }), this.expect(48), this.finishNode(e, "TSTypeParameterInstantiation");
                        }
                        tsIsDeclarationStart() {
                            return Uo(this.state.type);
                        }
                        isExportDefaultSpecifier() {
                            return this.tsIsDeclarationStart() ? !1 : super.isExportDefaultSpecifier();
                        }
                        parseAssignableListItem(e, s) {
                            let i = this.state.startLoc, a = {};
                            this.tsParseModifiers({
                                allowedModifiers: [
                                    "public",
                                    "private",
                                    "protected",
                                    "override",
                                    "readonly"
                                ]
                            }, a);
                            let n = a.accessibility, o = a.override, u = a.readonly;
                            !(e & 4) && (n || u || o) && this.raise(I.UnexpectedParameterModifier, {
                                at: i
                            });
                            let c = this.parseMaybeDefault();
                            this.parseAssignableListItemTypes(c, e);
                            let y = this.parseMaybeDefault(c.loc.start, c);
                            if (n || u || o) {
                                let g = this.startNodeAt(i);
                                return s.length && (g.decorators = s), n && (g.accessibility = n), u && (g.readonly = u), o && (g.override = o), y.type !== "Identifier" && y.type !== "AssignmentPattern" && this.raise(I.UnsupportedParameterPropertyKind, {
                                    at: g
                                }), g.parameter = y, this.finishNode(g, "TSParameterProperty");
                            }
                            return s.length && (c.decorators = s), y;
                        }
                        isSimpleParameter(e) {
                            return e.type === "TSParameterProperty" && super.isSimpleParameter(e.parameter) || super.isSimpleParameter(e);
                        }
                        tsDisallowOptionalPattern(e) {
                            for (let s of e.params)s.type !== "Identifier" && s.optional && !this.state.isAmbientContext && this.raise(I.PatternIsOptional, {
                                at: s
                            });
                        }
                        setArrowFunctionParameters(e, s, i) {
                            super.setArrowFunctionParameters(e, s, i), this.tsDisallowOptionalPattern(e);
                        }
                        parseFunctionBodyAndFinish(e, s) {
                            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                            this.match(14) && (e.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
                            let a = s === "FunctionDeclaration" ? "TSDeclareFunction" : s === "ClassMethod" || s === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
                            return a && !this.match(5) && this.isLineTerminator() ? this.finishNode(e, a) : a === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(I.DeclareFunctionHasImplementation, {
                                at: e
                            }), e.declare) ? super.parseFunctionBodyAndFinish(e, a, i) : (this.tsDisallowOptionalPattern(e), super.parseFunctionBodyAndFinish(e, s, i));
                        }
                        registerFunctionStatementId(e) {
                            !e.body && e.id ? this.checkIdentifier(e.id, br) : super.registerFunctionStatementId(e);
                        }
                        tsCheckForInvalidTypeCasts(e) {
                            e.forEach((s)=>{
                                (s == null ? void 0 : s.type) === "TSTypeCastExpression" && this.raise(I.UnexpectedTypeAnnotation, {
                                    at: s.typeAnnotation
                                });
                            });
                        }
                        toReferencedList(e, s) {
                            return this.tsCheckForInvalidTypeCasts(e), e;
                        }
                        parseArrayLike(e, s, i, a) {
                            let n = super.parseArrayLike(e, s, i, a);
                            return n.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(n.elements), n;
                        }
                        parseSubscript(e, s, i, a) {
                            if (!this.hasPrecedingLineBreak() && this.match(35)) {
                                this.state.canStartJSXElement = !1, this.next();
                                let o = this.startNodeAt(s);
                                return o.expression = e, this.finishNode(o, "TSNonNullExpression");
                            }
                            let n = !1;
                            if (this.match(18) && this.lookaheadCharCode() === 60) {
                                if (i) return a.stop = !0, e;
                                a.optionalChainMember = n = !0, this.next();
                            }
                            if (this.match(47) || this.match(51)) {
                                let o, u = this.tsTryParseAndCatch(()=>{
                                    if (!i && this.atPossibleAsyncArrow(e)) {
                                        let T = this.tsTryParseGenericAsyncArrowFunction(s);
                                        if (T) return T;
                                    }
                                    let c = this.tsParseTypeArgumentsInExpression();
                                    if (!c) return;
                                    if (n && !this.match(10)) {
                                        o = this.state.curPosition();
                                        return;
                                    }
                                    if (nt(this.state.type)) {
                                        let T = super.parseTaggedTemplateExpression(e, s, a);
                                        return T.typeParameters = c, T;
                                    }
                                    if (!i && this.eat(10)) {
                                        let T = this.startNodeAt(s);
                                        return T.callee = e, T.arguments = this.parseCallExpressionArguments(11, !1), this.tsCheckForInvalidTypeCasts(T.arguments), T.typeParameters = c, a.optionalChainMember && (T.optional = n), this.finishCallExpression(T, a.optionalChainMember);
                                    }
                                    let y = this.state.type;
                                    if (y === 48 || y === 52 || y !== 10 && He(y) && !this.hasPrecedingLineBreak()) return;
                                    let g = this.startNodeAt(s);
                                    return g.expression = e, g.typeParameters = c, this.finishNode(g, "TSInstantiationExpression");
                                });
                                if (o && this.unexpected(o, 10), u) return u.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(I.InvalidPropertyAccessAfterInstantiationExpression, {
                                    at: this.state.startLoc
                                }), u;
                            }
                            return super.parseSubscript(e, s, i, a);
                        }
                        parseNewCallee(e) {
                            var s;
                            super.parseNewCallee(e);
                            let { callee: i } = e;
                            i.type === "TSInstantiationExpression" && !((s = i.extra) != null && s.parenthesized) && (e.typeParameters = i.typeParameters, e.callee = i.expression);
                        }
                        parseExprOp(e, s, i) {
                            let a;
                            if (at(58) > i && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (a = this.isContextual(118)))) {
                                let n = this.startNodeAt(s);
                                return n.expression = e, n.typeAnnotation = this.tsInType(()=>(this.next(), this.match(75) ? (a && this.raise(f.UnexpectedKeyword, {
                                        at: this.state.startLoc,
                                        keyword: "const"
                                    }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(n, a ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(n, s, i);
                            }
                            return super.parseExprOp(e, s, i);
                        }
                        checkReservedWord(e, s, i, a) {
                            this.state.isAmbientContext || super.checkReservedWord(e, s, i, a);
                        }
                        checkImportReflection(e) {
                            super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(I.ImportReflectionHasImportType, {
                                at: e.specifiers[0].loc.start
                            });
                        }
                        checkDuplicateExports() {}
                        parseImport(e) {
                            if (e.importKind = "value", q(this.state.type) || this.match(55) || this.match(5)) {
                                let i = this.lookahead();
                                if (this.isContextual(128) && i.type !== 12 && i.type !== 97 && i.type !== 29 && (e.importKind = "type", this.next(), i = this.lookahead()), q(this.state.type) && i.type === 29) return this.tsParseImportEqualsDeclaration(e);
                            }
                            let s = super.parseImport(e);
                            return s.importKind === "type" && s.specifiers.length > 1 && s.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(I.TypeImportCannotSpecifyDefaultAndNamed, {
                                at: s
                            }), s;
                        }
                        parseExport(e, s) {
                            if (this.match(83)) return this.next(), this.isContextual(128) && this.lookaheadCharCode() !== 61 ? (e.importKind = "type", this.next()) : e.importKind = "value", this.tsParseImportEqualsDeclaration(e, !0);
                            if (this.eat(29)) {
                                let i = e;
                                return i.expression = super.parseExpression(), this.semicolon(), this.finishNode(i, "TSExportAssignment");
                            } else if (this.eatContextual(93)) {
                                let i = e;
                                return this.expectContextual(126), i.id = this.parseIdentifier(), this.semicolon(), this.finishNode(i, "TSNamespaceExportDeclaration");
                            } else {
                                if (e.exportKind = "value", this.isContextual(128)) {
                                    let i = this.lookaheadCharCode();
                                    (i === 123 || i === 42) && (this.next(), e.exportKind = "type");
                                }
                                return super.parseExport(e, s);
                            }
                        }
                        isAbstractClass() {
                            return this.isContextual(122) && this.lookahead().type === 80;
                        }
                        parseExportDefaultExpression() {
                            if (this.isAbstractClass()) {
                                let e = this.startNode();
                                return this.next(), e.abstract = !0, this.parseClass(e, !0, !0);
                            }
                            if (this.match(127)) {
                                let e = this.tsParseInterfaceDeclaration(this.startNode());
                                if (e) return e;
                            }
                            return super.parseExportDefaultExpression();
                        }
                        parseVarStatement(e, s) {
                            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, { isAmbientContext: a } = this.state, n = super.parseVarStatement(e, s, i || a);
                            if (!a) return n;
                            for (let { id: o, init: u } of n.declarations)u && (s !== "const" || o.typeAnnotation ? this.raise(I.InitializerNotAllowedInAmbientContext, {
                                at: u
                            }) : ph(u, this.hasPlugin("estree")) || this.raise(I.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, {
                                at: u
                            }));
                            return n;
                        }
                        parseStatementContent(e, s) {
                            if (this.match(75) && this.isLookaheadContextual("enum")) {
                                let i = this.startNode();
                                return this.expect(75), this.tsParseEnumDeclaration(i, {
                                    const: !0
                                });
                            }
                            if (this.isContextual(124)) return this.tsParseEnumDeclaration(this.startNode());
                            if (this.isContextual(127)) {
                                let i = this.tsParseInterfaceDeclaration(this.startNode());
                                if (i) return i;
                            }
                            return super.parseStatementContent(e, s);
                        }
                        parseAccessModifier() {
                            return this.tsParseModifier([
                                "public",
                                "protected",
                                "private"
                            ]);
                        }
                        tsHasSomeModifiers(e, s) {
                            return s.some((i)=>Hr(i) ? e.accessibility === i : !!e[i]);
                        }
                        tsIsStartOfStaticBlocks() {
                            return this.isContextual(104) && this.lookaheadCharCode() === 123;
                        }
                        parseClassMember(e, s, i) {
                            let a = [
                                "declare",
                                "private",
                                "public",
                                "protected",
                                "override",
                                "abstract",
                                "readonly",
                                "static"
                            ];
                            this.tsParseModifiers({
                                allowedModifiers: a,
                                disallowedModifiers: [
                                    "in",
                                    "out"
                                ],
                                stopOnStartOfClassStaticBlock: !0,
                                errorTemplate: I.InvalidModifierOnTypeParameterPositions
                            }, s);
                            let n = ()=>{
                                this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s, a) && this.raise(I.StaticBlockCannotHaveModifier, {
                                    at: this.state.curPosition()
                                }), super.parseClassStaticBlock(e, s)) : this.parseClassMemberWithIsStatic(e, s, i, !!s.static);
                            };
                            s.declare ? this.tsInAmbientContext(n) : n();
                        }
                        parseClassMemberWithIsStatic(e, s, i, a) {
                            let n = this.tsTryParseIndexSignature(s);
                            if (n) {
                                e.body.push(n), s.abstract && this.raise(I.IndexSignatureHasAbstract, {
                                    at: s
                                }), s.accessibility && this.raise(I.IndexSignatureHasAccessibility, {
                                    at: s,
                                    modifier: s.accessibility
                                }), s.declare && this.raise(I.IndexSignatureHasDeclare, {
                                    at: s
                                }), s.override && this.raise(I.IndexSignatureHasOverride, {
                                    at: s
                                });
                                return;
                            }
                            !this.state.inAbstractClass && s.abstract && this.raise(I.NonAbstractClassHasAbstractMethod, {
                                at: s
                            }), s.override && (i.hadSuperClass || this.raise(I.OverrideNotInSubClass, {
                                at: s
                            })), super.parseClassMemberWithIsStatic(e, s, i, a);
                        }
                        parsePostMemberNameModifiers(e) {
                            this.eat(17) && (e.optional = !0), e.readonly && this.match(10) && this.raise(I.ClassMethodHasReadonly, {
                                at: e
                            }), e.declare && this.match(10) && this.raise(I.ClassMethodHasDeclare, {
                                at: e
                            });
                        }
                        parseExpressionStatement(e, s, i) {
                            return (s.type === "Identifier" ? this.tsParseExpressionStatement(e, s, i) : void 0) || super.parseExpressionStatement(e, s, i);
                        }
                        shouldParseExportDeclaration() {
                            return this.tsIsDeclarationStart() ? !0 : super.shouldParseExportDeclaration();
                        }
                        parseConditional(e, s, i) {
                            if (!this.state.maybeInArrowParameters || !this.match(17)) return super.parseConditional(e, s, i);
                            let a = this.tryParse(()=>super.parseConditional(e, s));
                            return a.node ? (a.error && (this.state = a.failState), a.node) : (a.error && super.setOptionalParametersError(i, a.error), e);
                        }
                        parseParenItem(e, s) {
                            if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = !0, this.resetEndLocation(e)), this.match(14)) {
                                let i = this.startNodeAt(s);
                                return i.expression = e, i.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(i, "TSTypeCastExpression");
                            }
                            return e;
                        }
                        parseExportDeclaration(e) {
                            if (!this.state.isAmbientContext && this.isContextual(123)) return this.tsInAmbientContext(()=>this.parseExportDeclaration(e));
                            let s = this.state.startLoc, i = this.eatContextual(123);
                            if (i && (this.isContextual(123) || !this.shouldParseExportDeclaration())) throw this.raise(I.ExpectedAmbientAfterExportDeclare, {
                                at: this.state.startLoc
                            });
                            let n = q(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e);
                            return n ? ((n.type === "TSInterfaceDeclaration" || n.type === "TSTypeAliasDeclaration" || i) && (e.exportKind = "type"), i && (this.resetStartLocation(n, s), n.declare = !0), n) : null;
                        }
                        parseClassId(e, s, i, a) {
                            if ((!s || i) && this.isContextual(111)) return;
                            super.parseClassId(e, s, i, e.declare ? br : vr);
                            let n = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
                            n && (e.typeParameters = n);
                        }
                        parseClassPropertyAnnotation(e) {
                            e.optional || (this.eat(35) ? e.definite = !0 : this.eat(17) && (e.optional = !0));
                            let s = this.tsTryParseTypeAnnotation();
                            s && (e.typeAnnotation = s);
                        }
                        parseClassProperty(e) {
                            if (this.parseClassPropertyAnnotation(e), this.state.isAmbientContext && !(e.readonly && !e.typeAnnotation) && this.match(29) && this.raise(I.DeclareClassFieldHasInitializer, {
                                at: this.state.startLoc
                            }), e.abstract && this.match(29)) {
                                let { key: s } = e;
                                this.raise(I.AbstractPropertyHasInitializer, {
                                    at: this.state.startLoc,
                                    propertyName: s.type === "Identifier" && !e.computed ? s.name : `[${this.input.slice(s.start, s.end)}]`
                                });
                            }
                            return super.parseClassProperty(e);
                        }
                        parseClassPrivateProperty(e) {
                            return e.abstract && this.raise(I.PrivateElementHasAbstract, {
                                at: e
                            }), e.accessibility && this.raise(I.PrivateElementHasAccessibility, {
                                at: e,
                                modifier: e.accessibility
                            }), this.parseClassPropertyAnnotation(e), super.parseClassPrivateProperty(e);
                        }
                        parseClassAccessorProperty(e) {
                            return this.parseClassPropertyAnnotation(e), e.optional && this.raise(I.AccessorCannotBeOptional, {
                                at: e
                            }), super.parseClassAccessorProperty(e);
                        }
                        pushClassMethod(e, s, i, a, n, o) {
                            let u = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                            u && n && this.raise(I.ConstructorHasTypeParameters, {
                                at: u
                            });
                            let { declare: c = !1, kind: y } = s;
                            c && (y === "get" || y === "set") && this.raise(I.DeclareAccessor, {
                                at: s,
                                kind: y
                            }), u && (s.typeParameters = u), super.pushClassMethod(e, s, i, a, n, o);
                        }
                        pushClassPrivateMethod(e, s, i, a) {
                            let n = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                            n && (s.typeParameters = n), super.pushClassPrivateMethod(e, s, i, a);
                        }
                        declareClassPrivateMethodInScope(e, s) {
                            e.type !== "TSDeclareMethod" && (e.type === "MethodDefinition" && !e.value.body || super.declareClassPrivateMethodInScope(e, s));
                        }
                        parseClassSuper(e) {
                            super.parseClassSuper(e), e.superClass && (this.match(47) || this.match(51)) && (e.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(111) && (e.implements = this.tsParseHeritageClause("implements"));
                        }
                        parseObjPropValue(e, s, i, a, n, o, u) {
                            let c = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                            return c && (e.typeParameters = c), super.parseObjPropValue(e, s, i, a, n, o, u);
                        }
                        parseFunctionParams(e, s) {
                            let i = this.tsTryParseTypeParameters(this.tsParseConstModifier);
                            i && (e.typeParameters = i), super.parseFunctionParams(e, s);
                        }
                        parseVarId(e, s) {
                            super.parseVarId(e, s), e.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e.definite = !0);
                            let i = this.tsTryParseTypeAnnotation();
                            i && (e.id.typeAnnotation = i, this.resetEndLocation(e.id));
                        }
                        parseAsyncArrowFromCallExpression(e, s) {
                            return this.match(14) && (e.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e, s);
                        }
                        parseMaybeAssign(e, s) {
                            var i, a, n, o, u, c, y;
                            let g, T, C;
                            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
                                if (g = this.state.clone(), T = this.tryParse(()=>super.parseMaybeAssign(e, s), g), !T.error) return T.node;
                                let { context: K } = this.state, W = K[K.length - 1];
                                (W === x.j_oTag || W === x.j_expr) && K.pop();
                            }
                            if (!((i = T) != null && i.error) && !this.match(47)) return super.parseMaybeAssign(e, s);
                            (!g || g === this.state) && (g = this.state.clone());
                            let M, j = this.tryParse((K)=>{
                                var W, V;
                                M = this.tsParseTypeParameters(this.tsParseConstModifier);
                                let X = super.parseMaybeAssign(e, s);
                                return (X.type !== "ArrowFunctionExpression" || (W = X.extra) != null && W.parenthesized) && K(), ((V = M) == null ? void 0 : V.params.length) !== 0 && this.resetStartLocationFromNode(X, M), X.typeParameters = M, X;
                            }, g);
                            if (!j.error && !j.aborted) return M && this.reportReservedArrowTypeParam(M), j.node;
                            if (!T && ($r(!this.hasPlugin("jsx")), C = this.tryParse(()=>super.parseMaybeAssign(e, s), g), !C.error)) return C.node;
                            if ((a = T) != null && a.node) return this.state = T.failState, T.node;
                            if (j.node) return this.state = j.failState, M && this.reportReservedArrowTypeParam(M), j.node;
                            if ((n = C) != null && n.node) return this.state = C.failState, C.node;
                            throw (o = T) != null && o.thrown ? T.error : j.thrown ? j.error : (u = C) != null && u.thrown ? C.error : ((c = T) == null ? void 0 : c.error) || j.error || ((y = C) == null ? void 0 : y.error);
                        }
                        reportReservedArrowTypeParam(e) {
                            var s;
                            e.params.length === 1 && !e.params[0].constraint && !((s = e.extra) != null && s.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(I.ReservedArrowTypeParam, {
                                at: e
                            });
                        }
                        parseMaybeUnary(e, s) {
                            return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e, s);
                        }
                        parseArrow(e) {
                            if (this.match(14)) {
                                let s = this.tryParse((i)=>{
                                    let a = this.tsParseTypeOrTypePredicateAnnotation(14);
                                    return (this.canInsertSemicolon() || !this.match(19)) && i(), a;
                                });
                                if (s.aborted) return;
                                s.thrown || (s.error && (this.state = s.failState), e.returnType = s.node);
                            }
                            return super.parseArrow(e);
                        }
                        parseAssignableListItemTypes(e, s) {
                            if (!(s & 2)) return e;
                            this.eat(17) && (e.optional = !0);
                            let i = this.tsTryParseTypeAnnotation();
                            return i && (e.typeAnnotation = i), this.resetEndLocation(e), e;
                        }
                        isAssignable(e, s) {
                            switch(e.type){
                                case "TSTypeCastExpression":
                                    return this.isAssignable(e.expression, s);
                                case "TSParameterProperty":
                                    return !0;
                                default:
                                    return super.isAssignable(e, s);
                            }
                        }
                        toAssignable(e) {
                            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                            switch(e.type){
                                case "ParenthesizedExpression":
                                    this.toAssignableParenthesizedExpression(e, s);
                                    break;
                                case "TSAsExpression":
                                case "TSSatisfiesExpression":
                                case "TSNonNullExpression":
                                case "TSTypeAssertion":
                                    s ? this.expressionScope.recordArrowParameterBindingError(I.UnexpectedTypeCastInParameter, {
                                        at: e
                                    }) : this.raise(I.UnexpectedTypeCastInParameter, {
                                        at: e
                                    }), this.toAssignable(e.expression, s);
                                    break;
                                case "AssignmentExpression":
                                    !s && e.left.type === "TSTypeCastExpression" && (e.left = this.typeCastToParameter(e.left));
                                default:
                                    super.toAssignable(e, s);
                            }
                        }
                        toAssignableParenthesizedExpression(e, s) {
                            switch(e.expression.type){
                                case "TSAsExpression":
                                case "TSSatisfiesExpression":
                                case "TSNonNullExpression":
                                case "TSTypeAssertion":
                                case "ParenthesizedExpression":
                                    this.toAssignable(e.expression, s);
                                    break;
                                default:
                                    super.toAssignable(e, s);
                            }
                        }
                        checkToRestConversion(e, s) {
                            switch(e.type){
                                case "TSAsExpression":
                                case "TSSatisfiesExpression":
                                case "TSTypeAssertion":
                                case "TSNonNullExpression":
                                    this.checkToRestConversion(e.expression, !1);
                                    break;
                                default:
                                    super.checkToRestConversion(e, s);
                            }
                        }
                        isValidLVal(e, s, i) {
                            return nh({
                                TSTypeCastExpression: !0,
                                TSParameterProperty: "parameter",
                                TSNonNullExpression: "expression",
                                TSAsExpression: (i !== Pe || !s) && [
                                    "expression",
                                    !0
                                ],
                                TSSatisfiesExpression: (i !== Pe || !s) && [
                                    "expression",
                                    !0
                                ],
                                TSTypeAssertion: (i !== Pe || !s) && [
                                    "expression",
                                    !0
                                ]
                            }, e) || super.isValidLVal(e, s, i);
                        }
                        parseBindingAtom() {
                            switch(this.state.type){
                                case 78:
                                    return this.parseIdentifier(!0);
                                default:
                                    return super.parseBindingAtom();
                            }
                        }
                        parseMaybeDecoratorArguments(e) {
                            if (this.match(47) || this.match(51)) {
                                let s = this.tsParseTypeArgumentsInExpression();
                                if (this.match(10)) {
                                    let i = super.parseMaybeDecoratorArguments(e);
                                    return i.typeParameters = s, i;
                                }
                                this.unexpected(null, 10);
                            }
                            return super.parseMaybeDecoratorArguments(e);
                        }
                        checkCommaAfterRest(e) {
                            return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e ? (this.next(), !1) : super.checkCommaAfterRest(e);
                        }
                        isClassMethod() {
                            return this.match(47) || super.isClassMethod();
                        }
                        isClassProperty() {
                            return this.match(35) || this.match(14) || super.isClassProperty();
                        }
                        parseMaybeDefault(e, s) {
                            let i = super.parseMaybeDefault(e, s);
                            return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(I.TypeAnnotationAfterAssign, {
                                at: i.typeAnnotation
                            }), i;
                        }
                        getTokenFromCode(e) {
                            if (this.state.inType) {
                                if (e === 62) {
                                    this.finishOp(48, 1);
                                    return;
                                }
                                if (e === 60) {
                                    this.finishOp(47, 1);
                                    return;
                                }
                            }
                            super.getTokenFromCode(e);
                        }
                        reScan_lt_gt() {
                            let { type: e } = this.state;
                            e === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e === 48 && (this.state.pos -= 1, this.readToken_gt());
                        }
                        reScan_lt() {
                            let { type: e } = this.state;
                            return e === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e;
                        }
                        toAssignableList(e, s, i) {
                            for(let a = 0; a < e.length; a++){
                                let n = e[a];
                                (n == null ? void 0 : n.type) === "TSTypeCastExpression" && (e[a] = this.typeCastToParameter(n));
                            }
                            super.toAssignableList(e, s, i);
                        }
                        typeCastToParameter(e) {
                            return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
                        }
                        shouldParseArrow(e) {
                            return this.match(14) ? e.every((s)=>this.isAssignable(s, !0)) : super.shouldParseArrow(e);
                        }
                        shouldParseAsyncArrow() {
                            return this.match(14) || super.shouldParseAsyncArrow();
                        }
                        canHaveLeadingDecorator() {
                            return super.canHaveLeadingDecorator() || this.isAbstractClass();
                        }
                        jsxParseOpeningElementAfterName(e) {
                            if (this.match(47) || this.match(51)) {
                                let s = this.tsTryParseAndCatch(()=>this.tsParseTypeArgumentsInExpression());
                                s && (e.typeParameters = s);
                            }
                            return super.jsxParseOpeningElementAfterName(e);
                        }
                        getGetterSetterExpectedParamCount(e) {
                            let s = super.getGetterSetterExpectedParamCount(e), a = this.getObjectOrClassMethodParams(e)[0];
                            return a && this.isThisParam(a) ? s + 1 : s;
                        }
                        parseCatchClauseParam() {
                            let e = super.parseCatchClauseParam(), s = this.tsTryParseTypeAnnotation();
                            return s && (e.typeAnnotation = s, this.resetEndLocation(e)), e;
                        }
                        tsInAmbientContext(e) {
                            let s = this.state.isAmbientContext;
                            this.state.isAmbientContext = !0;
                            try {
                                return e();
                            } finally{
                                this.state.isAmbientContext = s;
                            }
                        }
                        parseClass(e, s, i) {
                            let a = this.state.inAbstractClass;
                            this.state.inAbstractClass = !!e.abstract;
                            try {
                                return super.parseClass(e, s, i);
                            } finally{
                                this.state.inAbstractClass = a;
                            }
                        }
                        tsParseAbstractDeclaration(e, s) {
                            if (this.match(80)) return e.abstract = !0, this.maybeTakeDecorators(s, this.parseClass(e, !0, !1));
                            if (this.isContextual(127)) {
                                if (!this.hasFollowingLineBreak()) return e.abstract = !0, this.raise(I.NonClassMethodPropertyHasAbstractModifer, {
                                    at: e
                                }), this.tsParseInterfaceDeclaration(e);
                            } else this.unexpected(null, 80);
                        }
                        parseMethod(e, s, i, a, n, o, u) {
                            let c = super.parseMethod(e, s, i, a, n, o, u);
                            if (c.abstract && (this.hasPlugin("estree") ? !!c.value.body : !!c.body)) {
                                let { key: g } = c;
                                this.raise(I.AbstractMethodHasImplementation, {
                                    at: c,
                                    methodName: g.type === "Identifier" && !c.computed ? g.name : `[${this.input.slice(g.start, g.end)}]`
                                });
                            }
                            return c;
                        }
                        tsParseTypeParameterName() {
                            return this.parseIdentifier().name;
                        }
                        shouldParseAsAmbientContext() {
                            return !!this.getPluginOption("typescript", "dts");
                        }
                        parse() {
                            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = !0), super.parse();
                        }
                        getExpression() {
                            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = !0), super.getExpression();
                        }
                        parseExportSpecifier(e, s, i, a) {
                            return !s && a ? (this.parseTypeOnlyImportExportSpecifier(e, !1, i), this.finishNode(e, "ExportSpecifier")) : (e.exportKind = "value", super.parseExportSpecifier(e, s, i, a));
                        }
                        parseImportSpecifier(e, s, i, a, n) {
                            return !s && a ? (this.parseTypeOnlyImportExportSpecifier(e, !0, i), this.finishNode(e, "ImportSpecifier")) : (e.importKind = "value", super.parseImportSpecifier(e, s, i, a, i ? Sr : Ve));
                        }
                        parseTypeOnlyImportExportSpecifier(e, s, i) {
                            let a = s ? "imported" : "local", n = s ? "local" : "exported", o = e[a], u, c = !1, y = !0, g = o.loc.start;
                            if (this.isContextual(93)) {
                                let C = this.parseIdentifier();
                                if (this.isContextual(93)) {
                                    let M = this.parseIdentifier();
                                    te(this.state.type) ? (c = !0, o = C, u = s ? this.parseIdentifier() : this.parseModuleExportName(), y = !1) : (u = M, y = !1);
                                } else te(this.state.type) ? (y = !1, u = s ? this.parseIdentifier() : this.parseModuleExportName()) : (c = !0, o = C);
                            } else te(this.state.type) && (c = !0, s ? (o = this.parseIdentifier(!0), this.isContextual(93) || this.checkReservedWord(o.name, o.loc.start, !0, !0)) : o = this.parseModuleExportName());
                            c && i && this.raise(s ? I.TypeModifierIsUsedInTypeImports : I.TypeModifierIsUsedInTypeExports, {
                                at: g
                            }), e[a] = o, e[n] = u;
                            let T = s ? "importKind" : "exportKind";
                            e[T] = c ? "type" : "value", y && this.eatContextual(93) && (e[n] = s ? this.parseIdentifier() : this.parseModuleExportName()), e[n] || (e[n] = me(e[a])), s && this.checkIdentifier(e[n], c ? Sr : Ve);
                        }
                    };
                function ch(t) {
                    if (t.type !== "MemberExpression") return !1;
                    let { computed: r, property: e } = t;
                    return r && e.type !== "StringLiteral" && (e.type !== "TemplateLiteral" || e.expressions.length > 0) ? !1 : Vr(t.object);
                }
                function ph(t, r) {
                    var e;
                    let { type: s } = t;
                    if ((e = t.extra) != null && e.parenthesized) return !1;
                    if (r) {
                        if (s === "Literal") {
                            let { value: i } = t;
                            if (typeof i == "string" || typeof i == "boolean") return !0;
                        }
                    } else if (s === "StringLiteral" || s === "BooleanLiteral") return !0;
                    return !!(zr(t, r) || fh(t, r) || s === "TemplateLiteral" && t.expressions.length === 0 || ch(t));
                }
                function zr(t, r) {
                    return r ? t.type === "Literal" && (typeof t.value == "number" || "bigint" in t) : t.type === "NumericLiteral" || t.type === "BigIntLiteral";
                }
                function fh(t, r) {
                    if (t.type === "UnaryExpression") {
                        let { operator: e, argument: s } = t;
                        if (e === "-" && zr(s, r)) return !0;
                    }
                    return !1;
                }
                function Vr(t) {
                    return t.type === "Identifier" ? !0 : t.type !== "MemberExpression" || t.computed ? !1 : Vr(t.object);
                }
                var Kr = pe`placeholders`({
                    ClassNameIsRequired: "A class name is required.",
                    UnexpectedSpace: "Unexpected space in placeholder."
                }), dh = (t)=>class extends t {
                        parsePlaceholder(e) {
                            if (this.match(142)) {
                                let s = this.startNode();
                                return this.next(), this.assertNoSpace(), s.name = super.parseIdentifier(!0), this.assertNoSpace(), this.expect(142), this.finishPlaceholder(s, e);
                            }
                        }
                        finishPlaceholder(e, s) {
                            let i = !!(e.expectedNode && e.type === "Placeholder");
                            return e.expectedNode = s, i ? e : this.finishNode(e, "Placeholder");
                        }
                        getTokenFromCode(e) {
                            e === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(142, 2) : super.getTokenFromCode(e);
                        }
                        parseExprAtom(e) {
                            return this.parsePlaceholder("Expression") || super.parseExprAtom(e);
                        }
                        parseIdentifier(e) {
                            return this.parsePlaceholder("Identifier") || super.parseIdentifier(e);
                        }
                        checkReservedWord(e, s, i, a) {
                            e !== void 0 && super.checkReservedWord(e, s, i, a);
                        }
                        parseBindingAtom() {
                            return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
                        }
                        isValidLVal(e, s, i) {
                            return e === "Placeholder" || super.isValidLVal(e, s, i);
                        }
                        toAssignable(e, s) {
                            e && e.type === "Placeholder" && e.expectedNode === "Expression" ? e.expectedNode = "Pattern" : super.toAssignable(e, s);
                        }
                        chStartsBindingIdentifier(e, s) {
                            return !!(super.chStartsBindingIdentifier(e, s) || this.lookahead().type === 142);
                        }
                        verifyBreakContinue(e, s) {
                            e.label && e.label.type === "Placeholder" || super.verifyBreakContinue(e, s);
                        }
                        parseExpressionStatement(e, s) {
                            if (s.type !== "Placeholder" || s.extra && s.extra.parenthesized) return super.parseExpressionStatement(e, s);
                            if (this.match(14)) {
                                let i = e;
                                return i.label = this.finishPlaceholder(s, "Identifier"), this.next(), i.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration(), this.finishNode(i, "LabeledStatement");
                            }
                            return this.semicolon(), e.name = s.name, this.finishPlaceholder(e, "Statement");
                        }
                        parseBlock(e, s, i) {
                            return this.parsePlaceholder("BlockStatement") || super.parseBlock(e, s, i);
                        }
                        parseFunctionId(e) {
                            return this.parsePlaceholder("Identifier") || super.parseFunctionId(e);
                        }
                        parseClass(e, s, i) {
                            let a = s ? "ClassDeclaration" : "ClassExpression";
                            this.next();
                            let n = this.state.strict, o = this.parsePlaceholder("Identifier");
                            if (o) {
                                if (this.match(81) || this.match(142) || this.match(5)) e.id = o;
                                else {
                                    if (i || !s) return e.id = null, e.body = this.finishPlaceholder(o, "ClassBody"), this.finishNode(e, a);
                                    throw this.raise(Kr.ClassNameIsRequired, {
                                        at: this.state.startLoc
                                    });
                                }
                            } else this.parseClassId(e, s, i);
                            return super.parseClassSuper(e), e.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!e.superClass, n), this.finishNode(e, a);
                        }
                        parseExport(e, s) {
                            let i = this.parsePlaceholder("Identifier");
                            if (!i) return super.parseExport(e, s);
                            if (!this.isContextual(97) && !this.match(12)) return e.specifiers = [], e.source = null, e.declaration = this.finishPlaceholder(i, "Declaration"), this.finishNode(e, "ExportNamedDeclaration");
                            this.expectPlugin("exportDefaultFrom");
                            let a = this.startNode();
                            return a.exported = i, e.specifiers = [
                                this.finishNode(a, "ExportDefaultSpecifier")
                            ], super.parseExport(e, s);
                        }
                        isExportDefaultSpecifier() {
                            if (this.match(65)) {
                                let e = this.nextTokenStart();
                                if (this.isUnparsedContextual(e, "from") && this.input.startsWith(xe(142), this.nextTokenStartSince(e + 4))) return !0;
                            }
                            return super.isExportDefaultSpecifier();
                        }
                        maybeParseExportDefaultSpecifier(e) {
                            return e.specifiers && e.specifiers.length > 0 ? !0 : super.maybeParseExportDefaultSpecifier(e);
                        }
                        checkExport(e) {
                            let { specifiers: s } = e;
                            s != null && s.length && (e.specifiers = s.filter((i)=>i.exported.type === "Placeholder")), super.checkExport(e), e.specifiers = s;
                        }
                        parseImport(e) {
                            let s = this.parsePlaceholder("Identifier");
                            if (!s) return super.parseImport(e);
                            if (e.specifiers = [], !this.isContextual(97) && !this.match(12)) return e.source = this.finishPlaceholder(s, "StringLiteral"), this.semicolon(), this.finishNode(e, "ImportDeclaration");
                            let i = this.startNodeAtNode(s);
                            return i.local = s, e.specifiers.push(this.finishNode(i, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(e) || this.parseNamedImportSpecifiers(e)), this.expectContextual(97), e.source = this.parseImportSource(), this.semicolon(), this.finishNode(e, "ImportDeclaration");
                        }
                        parseImportSource() {
                            return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
                        }
                        assertNoSpace() {
                            this.state.start > this.state.lastTokEndLoc.index && this.raise(Kr.UnexpectedSpace, {
                                at: this.state.lastTokEndLoc
                            });
                        }
                    }, mh = (t)=>class extends t {
                        parseV8Intrinsic() {
                            if (this.match(54)) {
                                let e = this.state.startLoc, s = this.startNode();
                                if (this.next(), q(this.state.type)) {
                                    let i = this.parseIdentifierName(), a = this.createIdentifier(s, i);
                                    if (a.type = "V8IntrinsicIdentifier", this.match(10)) return a;
                                }
                                this.unexpected(e);
                            }
                        }
                        parseExprAtom(e) {
                            return this.parseV8Intrinsic() || super.parseExprAtom(e);
                        }
                    };
                function J(t, r) {
                    let [e, s] = typeof r == "string" ? [
                        r,
                        {}
                    ] : r, i = Object.keys(s), a = i.length === 0;
                    return t.some((n)=>{
                        if (typeof n == "string") return a && n === e;
                        {
                            let [o, u] = n;
                            if (o !== e) return !1;
                            for (let c of i)if (u[c] !== s[c]) return !1;
                            return !0;
                        }
                    });
                }
                function we(t, r, e) {
                    let s = t.find((i)=>Array.isArray(i) ? i[0] === r : i === r);
                    return s && Array.isArray(s) && s.length > 1 ? s[1][e] : null;
                }
                var Wr = [
                    "minimal",
                    "fsharp",
                    "hack",
                    "smart"
                ], Gr = [
                    "^^",
                    "@@",
                    "^",
                    "%",
                    "#"
                ], Jr = [
                    "hash",
                    "bar"
                ];
                function yh(t) {
                    if (J(t, "decorators")) {
                        if (J(t, "decorators-legacy")) throw new Error("Cannot use the decorators and decorators-legacy plugin together");
                        let r = we(t, "decorators", "decoratorsBeforeExport");
                        if (r != null && typeof r != "boolean") throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
                        let e = we(t, "decorators", "allowCallParenthesized");
                        if (e != null && typeof e != "boolean") throw new Error("'allowCallParenthesized' must be a boolean.");
                    }
                    if (J(t, "flow") && J(t, "typescript")) throw new Error("Cannot combine flow and typescript plugins.");
                    if (J(t, "placeholders") && J(t, "v8intrinsic")) throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
                    if (J(t, "pipelineOperator")) {
                        let r = we(t, "pipelineOperator", "proposal");
                        if (!Wr.includes(r)) {
                            let s = Wr.map((i)=>`"${i}"`).join(", ");
                            throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${s}.`);
                        }
                        let e = J(t, [
                            "recordAndTuple",
                            {
                                syntaxType: "hash"
                            }
                        ]);
                        if (r === "hack") {
                            if (J(t, "placeholders")) throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
                            if (J(t, "v8intrinsic")) throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
                            let s = we(t, "pipelineOperator", "topicToken");
                            if (!Gr.includes(s)) {
                                let i = Gr.map((a)=>`"${a}"`).join(", ");
                                throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${i}.`);
                            }
                            if (s === "#" && e) throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
                        } else if (r === "smart" && e) throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
                    }
                    if (J(t, "moduleAttributes")) {
                        if (J(t, "importAssertions")) throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
                        if (we(t, "moduleAttributes", "version") !== "may-2020") throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
                    }
                    if (J(t, "recordAndTuple") && we(t, "recordAndTuple", "syntaxType") != null && !Jr.includes(we(t, "recordAndTuple", "syntaxType"))) throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + Jr.map((r)=>`'${r}'`).join(", "));
                    if (J(t, "asyncDoExpressions") && !J(t, "doExpressions")) {
                        let r = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
                        throw r.missingPlugins = "doExpressions", r;
                    }
                }
                var Xr = {
                    estree: el,
                    jsx: th,
                    flow: Zl,
                    typescript: uh,
                    v8intrinsic: mh,
                    placeholders: dh
                }, xh = Object.keys(Xr), gh = class extends ah {
                    checkProto(t, r, e, s) {
                        if (t.type === "SpreadElement" || this.isObjectMethod(t) || t.computed || t.shorthand) return;
                        let i = t.key;
                        if ((i.type === "Identifier" ? i.name : i.value) === "__proto__") {
                            if (r) {
                                this.raise(f.RecordNoProto, {
                                    at: i
                                });
                                return;
                            }
                            e.used && (s ? s.doubleProtoLoc === null && (s.doubleProtoLoc = i.loc.start) : this.raise(f.DuplicateProto, {
                                at: i
                            })), e.used = !0;
                        }
                    }
                    shouldExitDescending(t, r) {
                        return t.type === "ArrowFunctionExpression" && t.start === r;
                    }
                    getExpression() {
                        this.enterInitialScopes(), this.nextToken();
                        let t = this.parseExpression();
                        return this.match(137) || this.unexpected(), this.finalizeRemainingComments(), t.comments = this.state.comments, t.errors = this.state.errors, this.options.tokens && (t.tokens = this.tokens), t;
                    }
                    parseExpression(t, r) {
                        return t ? this.disallowInAnd(()=>this.parseExpressionBase(r)) : this.allowInAnd(()=>this.parseExpressionBase(r));
                    }
                    parseExpressionBase(t) {
                        let r = this.state.startLoc, e = this.parseMaybeAssign(t);
                        if (this.match(12)) {
                            let s = this.startNodeAt(r);
                            for(s.expressions = [
                                e
                            ]; this.eat(12);)s.expressions.push(this.parseMaybeAssign(t));
                            return this.toReferencedList(s.expressions), this.finishNode(s, "SequenceExpression");
                        }
                        return e;
                    }
                    parseMaybeAssignDisallowIn(t, r) {
                        return this.disallowInAnd(()=>this.parseMaybeAssign(t, r));
                    }
                    parseMaybeAssignAllowIn(t, r) {
                        return this.allowInAnd(()=>this.parseMaybeAssign(t, r));
                    }
                    setOptionalParametersError(t, r) {
                        var e;
                        t.optionalParametersLoc = (e = r == null ? void 0 : r.loc) != null ? e : this.state.startLoc;
                    }
                    parseMaybeAssign(t, r) {
                        let e = this.state.startLoc;
                        if (this.isContextual(106) && this.prodParam.hasYield) {
                            let n = this.parseYield();
                            return r && (n = r.call(this, n, e)), n;
                        }
                        let s;
                        t ? s = !1 : (t = new vt, s = !0);
                        let { type: i } = this.state;
                        (i === 10 || q(i)) && (this.state.potentialArrowAt = this.state.start);
                        let a = this.parseMaybeConditional(t);
                        if (r && (a = r.call(this, a, e)), Bo(this.state.type)) {
                            let n = this.startNodeAt(e), o = this.state.value;
                            if (n.operator = o, this.match(29)) {
                                this.toAssignable(a, !0), n.left = a;
                                let u = e.index;
                                t.doubleProtoLoc != null && t.doubleProtoLoc.index >= u && (t.doubleProtoLoc = null), t.shorthandAssignLoc != null && t.shorthandAssignLoc.index >= u && (t.shorthandAssignLoc = null), t.privateKeyLoc != null && t.privateKeyLoc.index >= u && (this.checkDestructuringPrivate(t), t.privateKeyLoc = null);
                            } else n.left = a;
                            return this.next(), n.right = this.parseMaybeAssign(), this.checkLVal(a, {
                                in: this.finishNode(n, "AssignmentExpression")
                            }), n;
                        } else s && this.checkExpressionErrors(t, !0);
                        return a;
                    }
                    parseMaybeConditional(t) {
                        let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseExprOps(t);
                        return this.shouldExitDescending(s, e) ? s : this.parseConditional(s, r, t);
                    }
                    parseConditional(t, r, e) {
                        if (this.eat(17)) {
                            let s = this.startNodeAt(r);
                            return s.test = t, s.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), s.alternate = this.parseMaybeAssign(), this.finishNode(s, "ConditionalExpression");
                        }
                        return t;
                    }
                    parseMaybeUnaryOrPrivate(t) {
                        return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(t);
                    }
                    parseExprOps(t) {
                        let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseMaybeUnaryOrPrivate(t);
                        return this.shouldExitDescending(s, e) ? s : this.parseExprOp(s, r, -1);
                    }
                    parseExprOp(t, r, e) {
                        if (this.isPrivateName(t)) {
                            let i = this.getPrivateNameSV(t);
                            (e >= at(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(f.PrivateInExpectedIn, {
                                at: t,
                                identifierName: i
                            }), this.classScope.usePrivateName(i, t.loc.start);
                        }
                        let s = this.state.type;
                        if (_o(s) && (this.prodParam.hasIn || !this.match(58))) {
                            let i = at(s);
                            if (i > e) {
                                if (s === 39) {
                                    if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody) return t;
                                    this.checkPipelineAtInfixOperator(t, r);
                                }
                                let a = this.startNodeAt(r);
                                a.left = t, a.operator = this.state.value;
                                let n = s === 41 || s === 42, o = s === 40;
                                if (o && (i = at(42)), this.next(), s === 39 && this.hasPlugin([
                                    "pipelineOperator",
                                    {
                                        proposal: "minimal"
                                    }
                                ]) && this.state.type === 96 && this.prodParam.hasAwait) throw this.raise(f.UnexpectedAwaitAfterPipelineBody, {
                                    at: this.state.startLoc
                                });
                                a.right = this.parseExprOpRightExpr(s, i);
                                let u = this.finishNode(a, n || o ? "LogicalExpression" : "BinaryExpression"), c = this.state.type;
                                if (o && (c === 41 || c === 42) || n && c === 40) throw this.raise(f.MixingCoalesceWithLogical, {
                                    at: this.state.startLoc
                                });
                                return this.parseExprOp(u, r, e);
                            }
                        }
                        return t;
                    }
                    parseExprOpRightExpr(t, r) {
                        let e = this.state.startLoc;
                        switch(t){
                            case 39:
                                switch(this.getPluginOption("pipelineOperator", "proposal")){
                                    case "hack":
                                        return this.withTopicBindingContext(()=>this.parseHackPipeBody());
                                    case "smart":
                                        return this.withTopicBindingContext(()=>{
                                            if (this.prodParam.hasYield && this.isContextual(106)) throw this.raise(f.PipeBodyIsTighter, {
                                                at: this.state.startLoc
                                            });
                                            return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t, r), e);
                                        });
                                    case "fsharp":
                                        return this.withSoloAwaitPermittingContext(()=>this.parseFSharpPipelineBody(r));
                                }
                            default:
                                return this.parseExprOpBaseRightExpr(t, r);
                        }
                    }
                    parseExprOpBaseRightExpr(t, r) {
                        let e = this.state.startLoc;
                        return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e, $o(t) ? r - 1 : r);
                    }
                    parseHackPipeBody() {
                        var t;
                        let { startLoc: r } = this.state, e = this.parseMaybeAssign();
                        return Go.has(e.type) && !((t = e.extra) != null && t.parenthesized) && this.raise(f.PipeUnparenthesizedBody, {
                            at: r,
                            type: e.type
                        }), this.topicReferenceWasUsedInCurrentContext() || this.raise(f.PipeTopicUnused, {
                            at: r
                        }), e;
                    }
                    checkExponentialAfterUnary(t) {
                        this.match(57) && this.raise(f.UnexpectedTokenUnaryExponentiation, {
                            at: t.argument
                        });
                    }
                    parseMaybeUnary(t, r) {
                        let e = this.state.startLoc, s = this.isContextual(96);
                        if (s && this.isAwaitAllowed()) {
                            this.next();
                            let o = this.parseAwait(e);
                            return r || this.checkExponentialAfterUnary(o), o;
                        }
                        let i = this.match(34), a = this.startNode();
                        if (jo(this.state.type)) {
                            a.operator = this.state.value, a.prefix = !0, this.match(72) && this.expectPlugin("throwExpressions");
                            let o = this.match(89);
                            if (this.next(), a.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(t, !0), this.state.strict && o) {
                                let u = a.argument;
                                u.type === "Identifier" ? this.raise(f.StrictDelete, {
                                    at: a
                                }) : this.hasPropertyAsPrivateName(u) && this.raise(f.DeletePrivateField, {
                                    at: a
                                });
                            }
                            if (!i) return r || this.checkExponentialAfterUnary(a), this.finishNode(a, "UnaryExpression");
                        }
                        let n = this.parseUpdate(a, i, t);
                        if (s) {
                            let { type: o } = this.state;
                            if ((this.hasPlugin("v8intrinsic") ? He(o) : He(o) && !this.match(54)) && !this.isAmbiguousAwait()) return this.raiseOverwrite(f.AwaitNotInAsyncContext, {
                                at: e
                            }), this.parseAwait(e);
                        }
                        return n;
                    }
                    parseUpdate(t, r, e) {
                        if (r) {
                            let a = t;
                            return this.checkLVal(a.argument, {
                                in: this.finishNode(a, "UpdateExpression")
                            }), t;
                        }
                        let s = this.state.startLoc, i = this.parseExprSubscripts(e);
                        if (this.checkExpressionErrors(e, !1)) return i;
                        for(; Ro(this.state.type) && !this.canInsertSemicolon();){
                            let a = this.startNodeAt(s);
                            a.operator = this.state.value, a.prefix = !1, a.argument = i, this.next(), this.checkLVal(i, {
                                in: i = this.finishNode(a, "UpdateExpression")
                            });
                        }
                        return i;
                    }
                    parseExprSubscripts(t) {
                        let r = this.state.startLoc, e = this.state.potentialArrowAt, s = this.parseExprAtom(t);
                        return this.shouldExitDescending(s, e) ? s : this.parseSubscripts(s, r);
                    }
                    parseSubscripts(t, r, e) {
                        let s = {
                            optionalChainMember: !1,
                            maybeAsyncArrow: this.atPossibleAsyncArrow(t),
                            stop: !1
                        };
                        do t = this.parseSubscript(t, r, e, s), s.maybeAsyncArrow = !1;
                        while (!s.stop);
                        return t;
                    }
                    parseSubscript(t, r, e, s) {
                        let { type: i } = this.state;
                        if (!e && i === 15) return this.parseBind(t, r, e, s);
                        if (nt(i)) return this.parseTaggedTemplateExpression(t, r, s);
                        let a = !1;
                        if (i === 18) {
                            if (e && (this.raise(f.OptionalChainingNoNew, {
                                at: this.state.startLoc
                            }), this.lookaheadCharCode() === 40)) return s.stop = !0, t;
                            s.optionalChainMember = a = !0, this.next();
                        }
                        if (!e && this.match(10)) return this.parseCoverCallAndAsyncArrowHead(t, r, s, a);
                        {
                            let n = this.eat(0);
                            return n || a || this.eat(16) ? this.parseMember(t, r, s, n, a) : (s.stop = !0, t);
                        }
                    }
                    parseMember(t, r, e, s, i) {
                        let a = this.startNodeAt(r);
                        return a.object = t, a.computed = s, s ? (a.property = this.parseExpression(), this.expect(3)) : this.match(136) ? (t.type === "Super" && this.raise(f.SuperPrivateField, {
                            at: r
                        }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), a.property = this.parsePrivateName()) : a.property = this.parseIdentifier(!0), e.optionalChainMember ? (a.optional = i, this.finishNode(a, "OptionalMemberExpression")) : this.finishNode(a, "MemberExpression");
                    }
                    parseBind(t, r, e, s) {
                        let i = this.startNodeAt(r);
                        return i.object = t, this.next(), i.callee = this.parseNoCallExpr(), s.stop = !0, this.parseSubscripts(this.finishNode(i, "BindExpression"), r, e);
                    }
                    parseCoverCallAndAsyncArrowHead(t, r, e, s) {
                        let i = this.state.maybeInArrowParameters, a = null;
                        this.state.maybeInArrowParameters = !0, this.next();
                        let n = this.startNodeAt(r);
                        n.callee = t;
                        let { maybeAsyncArrow: o, optionalChainMember: u } = e;
                        o && (this.expressionScope.enter($l()), a = new vt), u && (n.optional = s), s ? n.arguments = this.parseCallExpressionArguments(11) : n.arguments = this.parseCallExpressionArguments(11, t.type === "Import", t.type !== "Super", n, a);
                        let c = this.finishCallExpression(n, u);
                        return o && this.shouldParseAsyncArrow() && !s ? (e.stop = !0, this.checkDestructuringPrivate(a), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), c = this.parseAsyncArrowFromCallExpression(this.startNodeAt(r), c)) : (o && (this.checkExpressionErrors(a, !0), this.expressionScope.exit()), this.toReferencedArguments(c)), this.state.maybeInArrowParameters = i, c;
                    }
                    toReferencedArguments(t, r) {
                        this.toReferencedListDeep(t.arguments, r);
                    }
                    parseTaggedTemplateExpression(t, r, e) {
                        let s = this.startNodeAt(r);
                        return s.tag = t, s.quasi = this.parseTemplate(!0), e.optionalChainMember && this.raise(f.OptionalChainingNoTemplate, {
                            at: r
                        }), this.finishNode(s, "TaggedTemplateExpression");
                    }
                    atPossibleAsyncArrow(t) {
                        return t.type === "Identifier" && t.name === "async" && this.state.lastTokEndLoc.index === t.end && !this.canInsertSemicolon() && t.end - t.start === 5 && t.start === this.state.potentialArrowAt;
                    }
                    finishCallExpression(t, r) {
                        if (t.callee.type === "Import") {
                            if (t.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t.arguments.length === 0 || t.arguments.length > 2) this.raise(f.ImportCallArity, {
                                at: t,
                                maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1
                            });
                            else for (let e of t.arguments)e.type === "SpreadElement" && this.raise(f.ImportCallSpreadArgument, {
                                at: e
                            });
                        }
                        return this.finishNode(t, r ? "OptionalCallExpression" : "CallExpression");
                    }
                    parseCallExpressionArguments(t, r, e, s, i) {
                        let a = [], n = !0, o = this.state.inFSharpPipelineDirectBody;
                        for(this.state.inFSharpPipelineDirectBody = !1; !this.eat(t);){
                            if (n) n = !1;
                            else if (this.expect(12), this.match(t)) {
                                r && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(f.ImportCallArgumentTrailingComma, {
                                    at: this.state.lastTokStartLoc
                                }), s && this.addTrailingCommaExtraToNode(s), this.next();
                                break;
                            }
                            a.push(this.parseExprListItem(!1, i, e));
                        }
                        return this.state.inFSharpPipelineDirectBody = o, a;
                    }
                    shouldParseAsyncArrow() {
                        return this.match(19) && !this.canInsertSemicolon();
                    }
                    parseAsyncArrowFromCallExpression(t, r) {
                        var e;
                        return this.resetPreviousNodeTrailingComments(r), this.expect(19), this.parseArrowExpression(t, r.arguments, !0, (e = r.extra) == null ? void 0 : e.trailingCommaLoc), r.innerComments && Ke(t, r.innerComments), r.callee.trailingComments && Ke(t, r.callee.trailingComments), t;
                    }
                    parseNoCallExpr() {
                        let t = this.state.startLoc;
                        return this.parseSubscripts(this.parseExprAtom(), t, !0);
                    }
                    parseExprAtom(t) {
                        let r, e = null, { type: s } = this.state;
                        switch(s){
                            case 79:
                                return this.parseSuper();
                            case 83:
                                return r = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(r) : (this.match(10) || this.raise(f.UnsupportedImport, {
                                    at: this.state.lastTokStartLoc
                                }), this.finishNode(r, "Import"));
                            case 78:
                                return r = this.startNode(), this.next(), this.finishNode(r, "ThisExpression");
                            case 90:
                                return this.parseDo(this.startNode(), !1);
                            case 56:
                            case 31:
                                return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
                            case 132:
                                return this.parseNumericLiteral(this.state.value);
                            case 133:
                                return this.parseBigIntLiteral(this.state.value);
                            case 134:
                                return this.parseDecimalLiteral(this.state.value);
                            case 131:
                                return this.parseStringLiteral(this.state.value);
                            case 84:
                                return this.parseNullLiteral();
                            case 85:
                                return this.parseBooleanLiteral(!0);
                            case 86:
                                return this.parseBooleanLiteral(!1);
                            case 10:
                                {
                                    let i = this.state.potentialArrowAt === this.state.start;
                                    return this.parseParenAndDistinguishExpression(i);
                                }
                            case 2:
                            case 1:
                                return this.parseArrayLike(this.state.type === 2 ? 4 : 3, !1, !0);
                            case 0:
                                return this.parseArrayLike(3, !0, !1, t);
                            case 6:
                            case 7:
                                return this.parseObjectLike(this.state.type === 6 ? 9 : 8, !1, !0);
                            case 5:
                                return this.parseObjectLike(8, !1, !1, t);
                            case 68:
                                return this.parseFunctionOrFunctionSent();
                            case 26:
                                e = this.parseDecorators();
                            case 80:
                                return this.parseClass(this.maybeTakeDecorators(e, this.startNode()), !1);
                            case 77:
                                return this.parseNewOrNewTarget();
                            case 25:
                            case 24:
                                return this.parseTemplate(!1);
                            case 15:
                                {
                                    r = this.startNode(), this.next(), r.object = null;
                                    let i = r.callee = this.parseNoCallExpr();
                                    if (i.type === "MemberExpression") return this.finishNode(r, "BindExpression");
                                    throw this.raise(f.UnsupportedBind, {
                                        at: i
                                    });
                                }
                            case 136:
                                return this.raise(f.PrivateInExpectedIn, {
                                    at: this.state.startLoc,
                                    identifierName: this.state.value
                                }), this.parsePrivateName();
                            case 33:
                                return this.parseTopicReferenceThenEqualsSign(54, "%");
                            case 32:
                                return this.parseTopicReferenceThenEqualsSign(44, "^");
                            case 37:
                            case 38:
                                return this.parseTopicReference("hack");
                            case 44:
                            case 54:
                            case 27:
                                {
                                    let i = this.getPluginOption("pipelineOperator", "proposal");
                                    if (i) return this.parseTopicReference(i);
                                    this.unexpected();
                                    break;
                                }
                            case 47:
                                {
                                    let i = this.input.codePointAt(this.nextTokenStart());
                                    fe(i) || i === 62 ? this.expectOnePlugin([
                                        "jsx",
                                        "flow",
                                        "typescript"
                                    ]) : this.unexpected();
                                    break;
                                }
                            default:
                                if (q(s)) {
                                    if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak()) return this.parseModuleExpression();
                                    let i = this.state.potentialArrowAt === this.state.start, a = this.state.containsEsc, n = this.parseIdentifier();
                                    if (!a && n.name === "async" && !this.canInsertSemicolon()) {
                                        let { type: o } = this.state;
                                        if (o === 68) return this.resetPreviousNodeTrailingComments(n), this.next(), this.parseAsyncFunctionExpression(this.startNodeAtNode(n));
                                        if (q(o)) return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(n)) : n;
                                        if (o === 90) return this.resetPreviousNodeTrailingComments(n), this.parseDo(this.startNodeAtNode(n), !0);
                                    }
                                    return i && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(n), [
                                        n
                                    ], !1)) : n;
                                } else this.unexpected();
                        }
                    }
                    parseTopicReferenceThenEqualsSign(t, r) {
                        let e = this.getPluginOption("pipelineOperator", "proposal");
                        if (e) return this.state.type = t, this.state.value = r, this.state.pos--, this.state.end--, this.state.endLoc = Y(this.state.endLoc, -1), this.parseTopicReference(e);
                        this.unexpected();
                    }
                    parseTopicReference(t) {
                        let r = this.startNode(), e = this.state.startLoc, s = this.state.type;
                        return this.next(), this.finishTopicReference(r, e, t, s);
                    }
                    finishTopicReference(t, r, e, s) {
                        if (this.testTopicReferenceConfiguration(e, r, s)) {
                            let i = e === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
                            return this.topicReferenceIsAllowedInCurrentContext() || this.raise(e === "smart" ? f.PrimaryTopicNotAllowed : f.PipeTopicUnbound, {
                                at: r
                            }), this.registerTopicReference(), this.finishNode(t, i);
                        } else throw this.raise(f.PipeTopicUnconfiguredToken, {
                            at: r,
                            token: xe(s)
                        });
                    }
                    testTopicReferenceConfiguration(t, r, e) {
                        switch(t){
                            case "hack":
                                return this.hasPlugin([
                                    "pipelineOperator",
                                    {
                                        topicToken: xe(e)
                                    }
                                ]);
                            case "smart":
                                return e === 27;
                            default:
                                throw this.raise(f.PipeTopicRequiresHackPipes, {
                                    at: r
                                });
                        }
                    }
                    parseAsyncArrowUnaryFunction(t) {
                        this.prodParam.enter(Tt(!0, this.prodParam.hasYield));
                        let r = [
                            this.parseIdentifier()
                        ];
                        return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(f.LineTerminatorBeforeArrow, {
                            at: this.state.curPosition()
                        }), this.expect(19), this.parseArrowExpression(t, r, !0);
                    }
                    parseDo(t, r) {
                        this.expectPlugin("doExpressions"), r && this.expectPlugin("asyncDoExpressions"), t.async = r, this.next();
                        let e = this.state.labels;
                        return this.state.labels = [], r ? (this.prodParam.enter(At), t.body = this.parseBlock(), this.prodParam.exit()) : t.body = this.parseBlock(), this.state.labels = e, this.finishNode(t, "DoExpression");
                    }
                    parseSuper() {
                        let t = this.startNode();
                        return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(f.SuperNotAllowed, {
                            at: t
                        }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(f.UnexpectedSuper, {
                            at: t
                        }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(f.UnsupportedSuper, {
                            at: t
                        }), this.finishNode(t, "Super");
                    }
                    parsePrivateName() {
                        let t = this.startNode(), r = this.startNodeAt(Y(this.state.startLoc, 1)), e = this.state.value;
                        return this.next(), t.id = this.createIdentifier(r, e), this.finishNode(t, "PrivateName");
                    }
                    parseFunctionOrFunctionSent() {
                        let t = this.startNode();
                        if (this.next(), this.prodParam.hasYield && this.match(16)) {
                            let r = this.createIdentifier(this.startNodeAtNode(t), "function");
                            return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t, r, "sent");
                        }
                        return this.parseFunction(t);
                    }
                    parseMetaProperty(t, r, e) {
                        t.meta = r;
                        let s = this.state.containsEsc;
                        return t.property = this.parseIdentifier(!0), (t.property.name !== e || s) && this.raise(f.UnsupportedMetaProperty, {
                            at: t.property,
                            target: r.name,
                            onlyValidPropertyName: e
                        }), this.finishNode(t, "MetaProperty");
                    }
                    parseImportMetaProperty(t) {
                        let r = this.createIdentifier(this.startNodeAtNode(t), "import");
                        return this.next(), this.isContextual(100) && (this.inModule || this.raise(f.ImportMetaOutsideModule, {
                            at: r
                        }), this.sawUnambiguousESM = !0), this.parseMetaProperty(t, r, "meta");
                    }
                    parseLiteralAtNode(t, r, e) {
                        return this.addExtra(e, "rawValue", t), this.addExtra(e, "raw", this.input.slice(e.start, this.state.end)), e.value = t, this.next(), this.finishNode(e, r);
                    }
                    parseLiteral(t, r) {
                        let e = this.startNode();
                        return this.parseLiteralAtNode(t, r, e);
                    }
                    parseStringLiteral(t) {
                        return this.parseLiteral(t, "StringLiteral");
                    }
                    parseNumericLiteral(t) {
                        return this.parseLiteral(t, "NumericLiteral");
                    }
                    parseBigIntLiteral(t) {
                        return this.parseLiteral(t, "BigIntLiteral");
                    }
                    parseDecimalLiteral(t) {
                        return this.parseLiteral(t, "DecimalLiteral");
                    }
                    parseRegExpLiteral(t) {
                        let r = this.parseLiteral(t.value, "RegExpLiteral");
                        return r.pattern = t.pattern, r.flags = t.flags, r;
                    }
                    parseBooleanLiteral(t) {
                        let r = this.startNode();
                        return r.value = t, this.next(), this.finishNode(r, "BooleanLiteral");
                    }
                    parseNullLiteral() {
                        let t = this.startNode();
                        return this.next(), this.finishNode(t, "NullLiteral");
                    }
                    parseParenAndDistinguishExpression(t) {
                        let r = this.state.startLoc, e;
                        this.next(), this.expressionScope.enter(Ul());
                        let s = this.state.maybeInArrowParameters, i = this.state.inFSharpPipelineDirectBody;
                        this.state.maybeInArrowParameters = !0, this.state.inFSharpPipelineDirectBody = !1;
                        let a = this.state.startLoc, n = [], o = new vt, u = !0, c, y;
                        for(; !this.match(11);){
                            if (u) u = !1;
                            else if (this.expect(12, o.optionalParametersLoc === null ? null : o.optionalParametersLoc), this.match(11)) {
                                y = this.state.startLoc;
                                break;
                            }
                            if (this.match(21)) {
                                let C = this.state.startLoc;
                                if (c = this.state.startLoc, n.push(this.parseParenItem(this.parseRestBinding(), C)), !this.checkCommaAfterRest(41)) break;
                            } else n.push(this.parseMaybeAssignAllowIn(o, this.parseParenItem));
                        }
                        let g = this.state.lastTokEndLoc;
                        this.expect(11), this.state.maybeInArrowParameters = s, this.state.inFSharpPipelineDirectBody = i;
                        let T = this.startNodeAt(r);
                        return t && this.shouldParseArrow(n) && (T = this.parseArrow(T)) ? (this.checkDestructuringPrivate(o), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(T, n, !1), T) : (this.expressionScope.exit(), n.length || this.unexpected(this.state.lastTokStartLoc), y && this.unexpected(y), c && this.unexpected(c), this.checkExpressionErrors(o, !0), this.toReferencedListDeep(n, !0), n.length > 1 ? (e = this.startNodeAt(a), e.expressions = n, this.finishNode(e, "SequenceExpression"), this.resetEndLocation(e, g)) : e = n[0], this.wrapParenthesis(r, e));
                    }
                    wrapParenthesis(t, r) {
                        if (!this.options.createParenthesizedExpressions) return this.addExtra(r, "parenthesized", !0), this.addExtra(r, "parenStart", t.index), this.takeSurroundingComments(r, t.index, this.state.lastTokEndLoc.index), r;
                        let e = this.startNodeAt(t);
                        return e.expression = r, this.finishNode(e, "ParenthesizedExpression");
                    }
                    shouldParseArrow(t) {
                        return !this.canInsertSemicolon();
                    }
                    parseArrow(t) {
                        if (this.eat(19)) return t;
                    }
                    parseParenItem(t, r) {
                        return t;
                    }
                    parseNewOrNewTarget() {
                        let t = this.startNode();
                        if (this.next(), this.match(16)) {
                            let r = this.createIdentifier(this.startNodeAtNode(t), "new");
                            this.next();
                            let e = this.parseMetaProperty(t, r, "target");
                            return !this.scope.inNonArrowFunction && !this.scope.inClass && !this.options.allowNewTargetOutsideFunction && this.raise(f.UnexpectedNewTarget, {
                                at: e
                            }), e;
                        }
                        return this.parseNew(t);
                    }
                    parseNew(t) {
                        if (this.parseNewCallee(t), this.eat(10)) {
                            let r = this.parseExprList(11);
                            this.toReferencedList(r), t.arguments = r;
                        } else t.arguments = [];
                        return this.finishNode(t, "NewExpression");
                    }
                    parseNewCallee(t) {
                        t.callee = this.parseNoCallExpr(), t.callee.type === "Import" && this.raise(f.ImportCallNotNewExpression, {
                            at: t.callee
                        });
                    }
                    parseTemplateElement(t) {
                        let { start: r, startLoc: e, end: s, value: i } = this.state, a = r + 1, n = this.startNodeAt(Y(e, 1));
                        i === null && (t || this.raise(f.InvalidEscapeSequenceTemplate, {
                            at: Y(this.state.firstInvalidTemplateEscapePos, 1)
                        }));
                        let o = this.match(24), u = o ? -1 : -2, c = s + u;
                        n.value = {
                            raw: this.input.slice(a, c).replace(/\r\n?/g, `
`),
                            cooked: i === null ? null : i.slice(1, u)
                        }, n.tail = o, this.next();
                        let y = this.finishNode(n, "TemplateElement");
                        return this.resetEndLocation(y, Y(this.state.lastTokEndLoc, u)), y;
                    }
                    parseTemplate(t) {
                        let r = this.startNode();
                        r.expressions = [];
                        let e = this.parseTemplateElement(t);
                        for(r.quasis = [
                            e
                        ]; !e.tail;)r.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), r.quasis.push(e = this.parseTemplateElement(t));
                        return this.finishNode(r, "TemplateLiteral");
                    }
                    parseTemplateSubstitution() {
                        return this.parseExpression();
                    }
                    parseObjectLike(t, r, e, s) {
                        e && this.expectPlugin("recordAndTuple");
                        let i = this.state.inFSharpPipelineDirectBody;
                        this.state.inFSharpPipelineDirectBody = !1;
                        let a = Object.create(null), n = !0, o = this.startNode();
                        for(o.properties = [], this.next(); !this.match(t);){
                            if (n) n = !1;
                            else if (this.expect(12), this.match(t)) {
                                this.addTrailingCommaExtraToNode(o);
                                break;
                            }
                            let c;
                            r ? c = this.parseBindingProperty() : (c = this.parsePropertyDefinition(s), this.checkProto(c, e, a, s)), e && !this.isObjectProperty(c) && c.type !== "SpreadElement" && this.raise(f.InvalidRecordProperty, {
                                at: c
                            }), c.shorthand && this.addExtra(c, "shorthand", !0), o.properties.push(c);
                        }
                        this.next(), this.state.inFSharpPipelineDirectBody = i;
                        let u = "ObjectExpression";
                        return r ? u = "ObjectPattern" : e && (u = "RecordExpression"), this.finishNode(o, u);
                    }
                    addTrailingCommaExtraToNode(t) {
                        this.addExtra(t, "trailingComma", this.state.lastTokStart), this.addExtra(t, "trailingCommaLoc", this.state.lastTokStartLoc, !1);
                    }
                    maybeAsyncOrAccessorProp(t) {
                        return !t.computed && t.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
                    }
                    parsePropertyDefinition(t) {
                        let r = [];
                        if (this.match(26)) for(this.hasPlugin("decorators") && this.raise(f.UnsupportedPropertyDecorator, {
                            at: this.state.startLoc
                        }); this.match(26);)r.push(this.parseDecorator());
                        let e = this.startNode(), s = !1, i = !1, a;
                        if (this.match(21)) return r.length && this.unexpected(), this.parseSpread();
                        r.length && (e.decorators = r, r = []), e.method = !1, t && (a = this.state.startLoc);
                        let n = this.eat(55);
                        this.parsePropertyNamePrefixOperator(e);
                        let o = this.state.containsEsc, u = this.parsePropertyName(e, t);
                        if (!n && !o && this.maybeAsyncOrAccessorProp(e)) {
                            let c = u.name;
                            c === "async" && !this.hasPrecedingLineBreak() && (s = !0, this.resetPreviousNodeTrailingComments(u), n = this.eat(55), this.parsePropertyName(e)), (c === "get" || c === "set") && (i = !0, this.resetPreviousNodeTrailingComments(u), e.kind = c, this.match(55) && (n = !0, this.raise(f.AccessorIsGenerator, {
                                at: this.state.curPosition(),
                                kind: c
                            }), this.next()), this.parsePropertyName(e));
                        }
                        return this.parseObjPropValue(e, a, n, s, !1, i, t);
                    }
                    getGetterSetterExpectedParamCount(t) {
                        return t.kind === "get" ? 0 : 1;
                    }
                    getObjectOrClassMethodParams(t) {
                        return t.params;
                    }
                    checkGetterSetterParams(t) {
                        var r;
                        let e = this.getGetterSetterExpectedParamCount(t), s = this.getObjectOrClassMethodParams(t);
                        s.length !== e && this.raise(t.kind === "get" ? f.BadGetterArity : f.BadSetterArity, {
                            at: t
                        }), t.kind === "set" && ((r = s[s.length - 1]) == null ? void 0 : r.type) === "RestElement" && this.raise(f.BadSetterRestParameter, {
                            at: t
                        });
                    }
                    parseObjectMethod(t, r, e, s, i) {
                        if (i) {
                            let a = this.parseMethod(t, r, !1, !1, !1, "ObjectMethod");
                            return this.checkGetterSetterParams(a), a;
                        }
                        if (e || r || this.match(10)) return s && this.unexpected(), t.kind = "method", t.method = !0, this.parseMethod(t, r, e, !1, !1, "ObjectMethod");
                    }
                    parseObjectProperty(t, r, e, s) {
                        if (t.shorthand = !1, this.eat(14)) return t.value = e ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(s), this.finishNode(t, "ObjectProperty");
                        if (!t.computed && t.key.type === "Identifier") {
                            if (this.checkReservedWord(t.key.name, t.key.loc.start, !0, !1), e) t.value = this.parseMaybeDefault(r, me(t.key));
                            else if (this.match(29)) {
                                let i = this.state.startLoc;
                                s != null ? s.shorthandAssignLoc === null && (s.shorthandAssignLoc = i) : this.raise(f.InvalidCoverInitializedName, {
                                    at: i
                                }), t.value = this.parseMaybeDefault(r, me(t.key));
                            } else t.value = me(t.key);
                            return t.shorthand = !0, this.finishNode(t, "ObjectProperty");
                        }
                    }
                    parseObjPropValue(t, r, e, s, i, a, n) {
                        let o = this.parseObjectMethod(t, e, s, i, a) || this.parseObjectProperty(t, r, i, n);
                        return o || this.unexpected(), o;
                    }
                    parsePropertyName(t, r) {
                        if (this.eat(0)) t.computed = !0, t.key = this.parseMaybeAssignAllowIn(), this.expect(3);
                        else {
                            let { type: e, value: s } = this.state, i;
                            if (te(e)) i = this.parseIdentifier(!0);
                            else switch(e){
                                case 132:
                                    i = this.parseNumericLiteral(s);
                                    break;
                                case 131:
                                    i = this.parseStringLiteral(s);
                                    break;
                                case 133:
                                    i = this.parseBigIntLiteral(s);
                                    break;
                                case 134:
                                    i = this.parseDecimalLiteral(s);
                                    break;
                                case 136:
                                    {
                                        let a = this.state.startLoc;
                                        r != null ? r.privateKeyLoc === null && (r.privateKeyLoc = a) : this.raise(f.UnexpectedPrivateField, {
                                            at: a
                                        }), i = this.parsePrivateName();
                                        break;
                                    }
                                default:
                                    this.unexpected();
                            }
                            t.key = i, e !== 136 && (t.computed = !1);
                        }
                        return t.key;
                    }
                    initFunction(t, r) {
                        t.id = null, t.generator = !1, t.async = r;
                    }
                    parseMethod(t, r, e, s, i, a) {
                        let n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1;
                        this.initFunction(t, e), t.generator = r, this.scope.enter(de | ht | (n ? Ee : 0) | (i ? Pr : 0)), this.prodParam.enter(Tt(e, t.generator)), this.parseFunctionParams(t, s);
                        let o = this.parseFunctionBodyAndFinish(t, a, !0);
                        return this.prodParam.exit(), this.scope.exit(), o;
                    }
                    parseArrayLike(t, r, e, s) {
                        e && this.expectPlugin("recordAndTuple");
                        let i = this.state.inFSharpPipelineDirectBody;
                        this.state.inFSharpPipelineDirectBody = !1;
                        let a = this.startNode();
                        return this.next(), a.elements = this.parseExprList(t, !e, s, a), this.state.inFSharpPipelineDirectBody = i, this.finishNode(a, e ? "TupleExpression" : "ArrayExpression");
                    }
                    parseArrowExpression(t, r, e, s) {
                        this.scope.enter(de | Gt);
                        let i = Tt(e, !1);
                        !this.match(5) && this.prodParam.hasIn && (i |= _e), this.prodParam.enter(i), this.initFunction(t, e);
                        let a = this.state.maybeInArrowParameters;
                        return r && (this.state.maybeInArrowParameters = !0, this.setArrowFunctionParameters(t, r, s)), this.state.maybeInArrowParameters = !1, this.parseFunctionBody(t, !0), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a, this.finishNode(t, "ArrowFunctionExpression");
                    }
                    setArrowFunctionParameters(t, r, e) {
                        this.toAssignableList(r, e, !1), t.params = r;
                    }
                    parseFunctionBodyAndFinish(t, r) {
                        let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                        return this.parseFunctionBody(t, !1, e), this.finishNode(t, r);
                    }
                    parseFunctionBody(t, r) {
                        let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, s = r && !this.match(5);
                        if (this.expressionScope.enter(_r()), s) t.body = this.parseMaybeAssign(), this.checkParams(t, !1, r, !1);
                        else {
                            let i = this.state.strict, a = this.state.labels;
                            this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | jr), t.body = this.parseBlock(!0, !1, (n)=>{
                                let o = !this.isSimpleParamList(t.params);
                                n && o && this.raise(f.IllegalLanguageModeDirective, {
                                    at: (t.kind === "method" || t.kind === "constructor") && t.key ? t.key.loc.end : t
                                });
                                let u = !i && this.state.strict;
                                this.checkParams(t, !this.state.strict && !r && !e && !o, r, u), this.state.strict && t.id && this.checkIdentifier(t.id, dl, u);
                            }), this.prodParam.exit(), this.state.labels = a;
                        }
                        this.expressionScope.exit();
                    }
                    isSimpleParameter(t) {
                        return t.type === "Identifier";
                    }
                    isSimpleParamList(t) {
                        for(let r = 0, e = t.length; r < e; r++)if (!this.isSimpleParameter(t[r])) return !1;
                        return !0;
                    }
                    checkParams(t, r, e) {
                        let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, i = !r && new Set, a = {
                            type: "FormalParameters"
                        };
                        for (let n of t.params)this.checkLVal(n, {
                            in: a,
                            binding: mt,
                            checkClashes: i,
                            strictModeChanged: s
                        });
                    }
                    parseExprList(t, r, e, s) {
                        let i = [], a = !0;
                        for(; !this.eat(t);){
                            if (a) a = !1;
                            else if (this.expect(12), this.match(t)) {
                                s && this.addTrailingCommaExtraToNode(s), this.next();
                                break;
                            }
                            i.push(this.parseExprListItem(r, e));
                        }
                        return i;
                    }
                    parseExprListItem(t, r, e) {
                        let s;
                        if (this.match(12)) t || this.raise(f.UnexpectedToken, {
                            at: this.state.curPosition(),
                            unexpected: ","
                        }), s = null;
                        else if (this.match(21)) {
                            let i = this.state.startLoc;
                            s = this.parseParenItem(this.parseSpread(r), i);
                        } else if (this.match(17)) {
                            this.expectPlugin("partialApplication"), e || this.raise(f.UnexpectedArgumentPlaceholder, {
                                at: this.state.startLoc
                            });
                            let i = this.startNode();
                            this.next(), s = this.finishNode(i, "ArgumentPlaceholder");
                        } else s = this.parseMaybeAssignAllowIn(r, this.parseParenItem);
                        return s;
                    }
                    parseIdentifier(t) {
                        let r = this.startNode(), e = this.parseIdentifierName(t);
                        return this.createIdentifier(r, e);
                    }
                    createIdentifier(t, r) {
                        return t.name = r, t.loc.identifierName = r, this.finishNode(t, "Identifier");
                    }
                    parseIdentifierName(t) {
                        let r, { startLoc: e, type: s } = this.state;
                        te(s) ? r = this.state.value : this.unexpected();
                        let i = ue(s);
                        return t ? i && this.replaceToken(130) : this.checkReservedWord(r, e, i, !1), this.next(), r;
                    }
                    checkReservedWord(t, r, e, s) {
                        if (t.length > 10 || !ul(t)) return;
                        if (e && ol(t)) {
                            this.raise(f.UnexpectedKeyword, {
                                at: r,
                                keyword: t
                            });
                            return;
                        }
                        if ((this.state.strict ? s ? xr : mr : dr)(t, this.inModule)) {
                            this.raise(f.UnexpectedReservedWord, {
                                at: r,
                                reservedWord: t
                            });
                            return;
                        } else if (t === "yield") {
                            if (this.prodParam.hasYield) {
                                this.raise(f.YieldBindingIdentifier, {
                                    at: r
                                });
                                return;
                            }
                        } else if (t === "await") {
                            if (this.prodParam.hasAwait) {
                                this.raise(f.AwaitBindingIdentifier, {
                                    at: r
                                });
                                return;
                            }
                            if (this.scope.inStaticBlock) {
                                this.raise(f.AwaitBindingIdentifierInStaticBlock, {
                                    at: r
                                });
                                return;
                            }
                            this.expressionScope.recordAsyncArrowParametersError({
                                at: r
                            });
                        } else if (t === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
                            this.raise(f.ArgumentsInClass, {
                                at: r
                            });
                            return;
                        }
                    }
                    isAwaitAllowed() {
                        return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
                    }
                    parseAwait(t) {
                        let r = this.startNodeAt(t);
                        return this.expressionScope.recordParameterInitializerError(f.AwaitExpressionFormalParameter, {
                            at: r
                        }), this.eat(55) && this.raise(f.ObsoleteAwaitStar, {
                            at: r
                        }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = !0 : this.sawUnambiguousESM = !0), this.state.soloAwait || (r.argument = this.parseMaybeUnary(null, !0)), this.finishNode(r, "AwaitExpression");
                    }
                    isAmbiguousAwait() {
                        if (this.hasPrecedingLineBreak()) return !0;
                        let { type: t } = this.state;
                        return t === 53 || t === 10 || t === 0 || nt(t) || t === 101 && !this.state.containsEsc || t === 135 || t === 56 || this.hasPlugin("v8intrinsic") && t === 54;
                    }
                    parseYield() {
                        let t = this.startNode();
                        this.expressionScope.recordParameterInitializerError(f.YieldInParameter, {
                            at: t
                        }), this.next();
                        let r = !1, e = null;
                        if (!this.hasPrecedingLineBreak()) switch(r = this.eat(55), this.state.type){
                            case 13:
                            case 137:
                            case 8:
                            case 11:
                            case 3:
                            case 9:
                            case 14:
                            case 12:
                                if (!r) break;
                            default:
                                e = this.parseMaybeAssign();
                        }
                        return t.delegate = r, t.argument = e, this.finishNode(t, "YieldExpression");
                    }
                    checkPipelineAtInfixOperator(t, r) {
                        this.hasPlugin([
                            "pipelineOperator",
                            {
                                proposal: "smart"
                            }
                        ]) && t.type === "SequenceExpression" && this.raise(f.PipelineHeadSequenceExpression, {
                            at: r
                        });
                    }
                    parseSmartPipelineBodyInStyle(t, r) {
                        if (this.isSimpleReference(t)) {
                            let e = this.startNodeAt(r);
                            return e.callee = t, this.finishNode(e, "PipelineBareFunction");
                        } else {
                            let e = this.startNodeAt(r);
                            return this.checkSmartPipeTopicBodyEarlyErrors(r), e.expression = t, this.finishNode(e, "PipelineTopicExpression");
                        }
                    }
                    isSimpleReference(t) {
                        switch(t.type){
                            case "MemberExpression":
                                return !t.computed && this.isSimpleReference(t.object);
                            case "Identifier":
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    checkSmartPipeTopicBodyEarlyErrors(t) {
                        if (this.match(19)) throw this.raise(f.PipelineBodyNoArrow, {
                            at: this.state.startLoc
                        });
                        this.topicReferenceWasUsedInCurrentContext() || this.raise(f.PipelineTopicUnused, {
                            at: t
                        });
                    }
                    withTopicBindingContext(t) {
                        let r = this.state.topicContext;
                        this.state.topicContext = {
                            maxNumOfResolvableTopics: 1,
                            maxTopicIndex: null
                        };
                        try {
                            return t();
                        } finally{
                            this.state.topicContext = r;
                        }
                    }
                    withSmartMixTopicForbiddingContext(t) {
                        if (this.hasPlugin([
                            "pipelineOperator",
                            {
                                proposal: "smart"
                            }
                        ])) {
                            let r = this.state.topicContext;
                            this.state.topicContext = {
                                maxNumOfResolvableTopics: 0,
                                maxTopicIndex: null
                            };
                            try {
                                return t();
                            } finally{
                                this.state.topicContext = r;
                            }
                        } else return t();
                    }
                    withSoloAwaitPermittingContext(t) {
                        let r = this.state.soloAwait;
                        this.state.soloAwait = !0;
                        try {
                            return t();
                        } finally{
                            this.state.soloAwait = r;
                        }
                    }
                    allowInAnd(t) {
                        let r = this.prodParam.currentFlags();
                        if (_e & ~r) {
                            this.prodParam.enter(r | _e);
                            try {
                                return t();
                            } finally{
                                this.prodParam.exit();
                            }
                        }
                        return t();
                    }
                    disallowInAnd(t) {
                        let r = this.prodParam.currentFlags();
                        if (_e & r) {
                            this.prodParam.enter(r & ~_e);
                            try {
                                return t();
                            } finally{
                                this.prodParam.exit();
                            }
                        }
                        return t();
                    }
                    registerTopicReference() {
                        this.state.topicContext.maxTopicIndex = 0;
                    }
                    topicReferenceIsAllowedInCurrentContext() {
                        return this.state.topicContext.maxNumOfResolvableTopics >= 1;
                    }
                    topicReferenceWasUsedInCurrentContext() {
                        return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
                    }
                    parseFSharpPipelineBody(t) {
                        let r = this.state.startLoc;
                        this.state.potentialArrowAt = this.state.start;
                        let e = this.state.inFSharpPipelineDirectBody;
                        this.state.inFSharpPipelineDirectBody = !0;
                        let s = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), r, t);
                        return this.state.inFSharpPipelineDirectBody = e, s;
                    }
                    parseModuleExpression() {
                        this.expectPlugin("moduleBlocks");
                        let t = this.startNode();
                        this.next(), this.match(5) || this.unexpected(null, 5);
                        let r = this.startNodeAt(this.state.endLoc);
                        this.next();
                        let e = this.initializeScopes(!0);
                        this.enterInitialScopes();
                        try {
                            t.body = this.parseProgram(r, 8, "module");
                        } finally{
                            e();
                        }
                        return this.finishNode(t, "ModuleExpression");
                    }
                    parsePropertyNamePrefixOperator(t) {}
                }, cs = {
                    kind: "loop"
                }, Ph = {
                    kind: "switch"
                }, Ah = /[\uD800-\uDFFF]/u, ps = /in(?:stanceof)?/y;
                function Th(t, r) {
                    for(let e = 0; e < t.length; e++){
                        let s = t[e], { type: i } = s;
                        if (typeof i == "number") {
                            if (i === 136) {
                                let { loc: a, start: n, value: o, end: u } = s, c = n + 1, y = Y(a.start, 1);
                                t.splice(e, 1, new Ae({
                                    type: ce(27),
                                    value: "#",
                                    start: n,
                                    end: c,
                                    startLoc: a.start,
                                    endLoc: y
                                }), new Ae({
                                    type: ce(130),
                                    value: o,
                                    start: c,
                                    end: u,
                                    startLoc: y,
                                    endLoc: a.end
                                })), e++;
                                continue;
                            }
                            if (nt(i)) {
                                let { loc: a, start: n, value: o, end: u } = s, c = n + 1, y = Y(a.start, 1), g;
                                r.charCodeAt(n) === 96 ? g = new Ae({
                                    type: ce(22),
                                    value: "`",
                                    start: n,
                                    end: c,
                                    startLoc: a.start,
                                    endLoc: y
                                }) : g = new Ae({
                                    type: ce(8),
                                    value: "}",
                                    start: n,
                                    end: c,
                                    startLoc: a.start,
                                    endLoc: y
                                });
                                let T, C, M, j;
                                i === 24 ? (C = u - 1, M = Y(a.end, -1), T = o === null ? null : o.slice(1, -1), j = new Ae({
                                    type: ce(22),
                                    value: "`",
                                    start: C,
                                    end: u,
                                    startLoc: M,
                                    endLoc: a.end
                                })) : (C = u - 2, M = Y(a.end, -2), T = o === null ? null : o.slice(1, -2), j = new Ae({
                                    type: ce(23),
                                    value: "${",
                                    start: C,
                                    end: u,
                                    startLoc: M,
                                    endLoc: a.end
                                })), t.splice(e, 1, g, new Ae({
                                    type: ce(20),
                                    value: T,
                                    start: c,
                                    end: C,
                                    startLoc: y,
                                    endLoc: M
                                }), j), e += 2;
                                continue;
                            }
                            s.type = ce(i);
                        }
                    }
                    return t;
                }
                var vh = class extends gh {
                    parseTopLevel(t, r) {
                        return t.program = this.parseProgram(r), t.comments = this.state.comments, this.options.tokens && (t.tokens = Th(this.tokens, this.input)), this.finishNode(t, "File");
                    }
                    parseProgram(t) {
                        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 137, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
                        if (t.sourceType = e, t.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t, !0, !0, r), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0) for (let [i, a] of Array.from(this.scope.undefinedExports))this.raise(f.ModuleExportUndefined, {
                            at: a,
                            localName: i
                        });
                        let s;
                        return r === 137 ? s = this.finishNode(t, "Program") : s = this.finishNodeAt(t, "Program", Y(this.state.startLoc, -1)), s;
                    }
                    stmtToDirective(t) {
                        let r = t;
                        r.type = "Directive", r.value = r.expression, delete r.expression;
                        let e = r.value, s = e.value, i = this.input.slice(e.start, e.end), a = e.value = i.slice(1, -1);
                        return this.addExtra(e, "raw", i), this.addExtra(e, "rawValue", a), this.addExtra(e, "expressionValue", s), e.type = "DirectiveLiteral", r;
                    }
                    parseInterpreterDirective() {
                        if (!this.match(28)) return null;
                        let t = this.startNode();
                        return t.value = this.state.value, this.next(), this.finishNode(t, "InterpreterDirective");
                    }
                    isLet() {
                        return this.isContextual(99) ? this.hasFollowingBindingAtom() : !1;
                    }
                    chStartsBindingIdentifier(t, r) {
                        if (fe(t)) {
                            if (ps.lastIndex = r, ps.test(this.input)) {
                                let e = this.codePointAtPos(ps.lastIndex);
                                if (!De(e) && e !== 92) return !1;
                            }
                            return !0;
                        } else return t === 92;
                    }
                    chStartsBindingPattern(t) {
                        return t === 91 || t === 123;
                    }
                    hasFollowingBindingAtom() {
                        let t = this.nextTokenStart(), r = this.codePointAtPos(t);
                        return this.chStartsBindingPattern(r) || this.chStartsBindingIdentifier(r, t);
                    }
                    hasFollowingBindingIdentifier() {
                        let t = this.nextTokenStart(), r = this.codePointAtPos(t);
                        return this.chStartsBindingIdentifier(r, t);
                    }
                    startsUsingForOf() {
                        let t = this.lookahead();
                        return t.type === 101 && !t.containsEsc ? !1 : (this.expectPlugin("explicitResourceManagement"), !0);
                    }
                    parseModuleItem() {
                        return this.parseStatementLike(15);
                    }
                    parseStatementListItem() {
                        return this.parseStatementLike(6 | (!this.options.annexB || this.state.strict ? 0 : 8));
                    }
                    parseStatementOrSloppyAnnexBFunctionDeclaration() {
                        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r = 0;
                        return this.options.annexB && !this.state.strict && (r |= 4, t && (r |= 8)), this.parseStatementLike(r);
                    }
                    parseStatement() {
                        return this.parseStatementLike(0);
                    }
                    parseStatementLike(t) {
                        let r = null;
                        return this.match(26) && (r = this.parseDecorators(!0)), this.parseStatementContent(t, r);
                    }
                    parseStatementContent(t, r) {
                        let e = this.state.type, s = this.startNode(), i = !!(t & 2), a = !!(t & 4), n = t & 1;
                        switch(e){
                            case 60:
                                return this.parseBreakContinueStatement(s, !0);
                            case 63:
                                return this.parseBreakContinueStatement(s, !1);
                            case 64:
                                return this.parseDebuggerStatement(s);
                            case 90:
                                return this.parseDoWhileStatement(s);
                            case 91:
                                return this.parseForStatement(s);
                            case 68:
                                if (this.lookaheadCharCode() === 46) break;
                                return a || this.raise(this.state.strict ? f.StrictFunction : this.options.annexB ? f.SloppyFunctionAnnexB : f.SloppyFunction, {
                                    at: this.state.startLoc
                                }), this.parseFunctionStatement(s, !1, !i && a);
                            case 80:
                                return i || this.unexpected(), this.parseClass(this.maybeTakeDecorators(r, s), !0);
                            case 69:
                                return this.parseIfStatement(s);
                            case 70:
                                return this.parseReturnStatement(s);
                            case 71:
                                return this.parseSwitchStatement(s);
                            case 72:
                                return this.parseThrowStatement(s);
                            case 73:
                                return this.parseTryStatement(s);
                            case 105:
                                if (this.hasFollowingLineBreak() || this.state.containsEsc || !this.hasFollowingBindingIdentifier()) break;
                                return this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel ? this.raise(f.UnexpectedUsingDeclaration, {
                                    at: this.state.startLoc
                                }) : i || this.raise(f.UnexpectedLexicalDeclaration, {
                                    at: this.state.startLoc
                                }), this.parseVarStatement(s, "using");
                            case 99:
                                {
                                    if (this.state.containsEsc) break;
                                    let c = this.nextTokenStart(), y = this.codePointAtPos(c);
                                    if (y !== 91 && (!i && this.hasFollowingLineBreak() || !this.chStartsBindingIdentifier(y, c) && y !== 123)) break;
                                }
                            case 75:
                                i || this.raise(f.UnexpectedLexicalDeclaration, {
                                    at: this.state.startLoc
                                });
                            case 74:
                                {
                                    let c = this.state.value;
                                    return this.parseVarStatement(s, c);
                                }
                            case 92:
                                return this.parseWhileStatement(s);
                            case 76:
                                return this.parseWithStatement(s);
                            case 5:
                                return this.parseBlock();
                            case 13:
                                return this.parseEmptyStatement(s);
                            case 83:
                                {
                                    let c = this.lookaheadCharCode();
                                    if (c === 40 || c === 46) break;
                                }
                            case 82:
                                {
                                    !this.options.allowImportExportEverywhere && !n && this.raise(f.UnexpectedImportExport, {
                                        at: this.state.startLoc
                                    }), this.next();
                                    let c;
                                    return e === 83 ? (c = this.parseImport(s), c.type === "ImportDeclaration" && (!c.importKind || c.importKind === "value") && (this.sawUnambiguousESM = !0)) : (c = this.parseExport(s, r), (c.type === "ExportNamedDeclaration" && (!c.exportKind || c.exportKind === "value") || c.type === "ExportAllDeclaration" && (!c.exportKind || c.exportKind === "value") || c.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = !0)), this.assertModuleNodeAllowed(c), c;
                                }
                            default:
                                if (this.isAsyncFunction()) return i || this.raise(f.AsyncFunctionInSingleStatementContext, {
                                    at: this.state.startLoc
                                }), this.next(), this.parseFunctionStatement(s, !0, !i && a);
                        }
                        let o = this.state.value, u = this.parseExpression();
                        return q(e) && u.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(s, o, u, t) : this.parseExpressionStatement(s, u, r);
                    }
                    assertModuleNodeAllowed(t) {
                        !this.options.allowImportExportEverywhere && !this.inModule && this.raise(f.ImportOutsideModule, {
                            at: t
                        });
                    }
                    decoratorsEnabledBeforeExport() {
                        return this.hasPlugin("decorators-legacy") ? !0 : this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== !1;
                    }
                    maybeTakeDecorators(t, r, e) {
                        return t && (r.decorators && r.decorators.length > 0 ? (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") != "boolean" && this.raise(f.DecoratorsBeforeAfterExport, {
                            at: r.decorators[0]
                        }), r.decorators.unshift(...t)) : r.decorators = t, this.resetStartLocationFromNode(r, t[0]), e && this.resetStartLocationFromNode(e, r)), r;
                    }
                    canHaveLeadingDecorator() {
                        return this.match(80);
                    }
                    parseDecorators(t) {
                        let r = [];
                        do r.push(this.parseDecorator());
                        while (this.match(26));
                        if (this.match(82)) t || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(f.DecoratorExportClass, {
                            at: this.state.startLoc
                        });
                        else if (!this.canHaveLeadingDecorator()) throw this.raise(f.UnexpectedLeadingDecorator, {
                            at: this.state.startLoc
                        });
                        return r;
                    }
                    parseDecorator() {
                        this.expectOnePlugin([
                            "decorators",
                            "decorators-legacy"
                        ]);
                        let t = this.startNode();
                        if (this.next(), this.hasPlugin("decorators")) {
                            let r = this.state.startLoc, e;
                            if (this.match(10)) {
                                let s = this.state.startLoc;
                                this.next(), e = this.parseExpression(), this.expect(11), e = this.wrapParenthesis(s, e);
                                let i = this.state.startLoc;
                                t.expression = this.parseMaybeDecoratorArguments(e), this.getPluginOption("decorators", "allowCallParenthesized") === !1 && t.expression !== e && this.raise(f.DecoratorArgumentsOutsideParentheses, {
                                    at: i
                                });
                            } else {
                                for(e = this.parseIdentifier(!1); this.eat(16);){
                                    let s = this.startNodeAt(r);
                                    s.object = e, this.match(136) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), s.property = this.parsePrivateName()) : s.property = this.parseIdentifier(!0), s.computed = !1, e = this.finishNode(s, "MemberExpression");
                                }
                                t.expression = this.parseMaybeDecoratorArguments(e);
                            }
                        } else t.expression = this.parseExprSubscripts();
                        return this.finishNode(t, "Decorator");
                    }
                    parseMaybeDecoratorArguments(t) {
                        if (this.eat(10)) {
                            let r = this.startNodeAtNode(t);
                            return r.callee = t, r.arguments = this.parseCallExpressionArguments(11, !1), this.toReferencedList(r.arguments), this.finishNode(r, "CallExpression");
                        }
                        return t;
                    }
                    parseBreakContinueStatement(t, r) {
                        return this.next(), this.isLineTerminator() ? t.label = null : (t.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t, r), this.finishNode(t, r ? "BreakStatement" : "ContinueStatement");
                    }
                    verifyBreakContinue(t, r) {
                        let e;
                        for(e = 0; e < this.state.labels.length; ++e){
                            let s = this.state.labels[e];
                            if ((t.label == null || s.name === t.label.name) && (s.kind != null && (r || s.kind === "loop") || t.label && r)) break;
                        }
                        if (e === this.state.labels.length) {
                            let s = r ? "BreakStatement" : "ContinueStatement";
                            this.raise(f.IllegalBreakContinue, {
                                at: t,
                                type: s
                            });
                        }
                    }
                    parseDebuggerStatement(t) {
                        return this.next(), this.semicolon(), this.finishNode(t, "DebuggerStatement");
                    }
                    parseHeaderExpression() {
                        this.expect(10);
                        let t = this.parseExpression();
                        return this.expect(11), t;
                    }
                    parseDoWhileStatement(t) {
                        return this.next(), this.state.labels.push(cs), t.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement()), this.state.labels.pop(), this.expect(92), t.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t, "DoWhileStatement");
                    }
                    parseForStatement(t) {
                        this.next(), this.state.labels.push(cs);
                        let r = null;
                        if (this.isAwaitAllowed() && this.eatContextual(96) && (r = this.state.lastTokStartLoc), this.scope.enter(Fe), this.expect(10), this.match(13)) return r !== null && this.unexpected(r), this.parseFor(t, null);
                        let e = this.isContextual(99), s = this.isContextual(105) && !this.hasFollowingLineBreak(), i = e && this.hasFollowingBindingAtom() || s && this.hasFollowingBindingIdentifier() && this.startsUsingForOf();
                        if (this.match(74) || this.match(75) || i) {
                            let c = this.startNode(), y = this.state.value;
                            this.next(), this.parseVar(c, !0, y);
                            let g = this.finishNode(c, "VariableDeclaration"), T = this.match(58);
                            return T && s && this.raise(f.ForInUsing, {
                                at: g
                            }), (T || this.isContextual(101)) && g.declarations.length === 1 ? this.parseForIn(t, g, r) : (r !== null && this.unexpected(r), this.parseFor(t, g));
                        }
                        let a = this.isContextual(95), n = new vt, o = this.parseExpression(!0, n), u = this.isContextual(101);
                        if (u && (e && this.raise(f.ForOfLet, {
                            at: o
                        }), r === null && a && o.type === "Identifier" && this.raise(f.ForOfAsync, {
                            at: o
                        })), u || this.match(58)) {
                            this.checkDestructuringPrivate(n), this.toAssignable(o, !0);
                            let c = u ? "ForOfStatement" : "ForInStatement";
                            return this.checkLVal(o, {
                                in: {
                                    type: c
                                }
                            }), this.parseForIn(t, o, r);
                        } else this.checkExpressionErrors(n, !0);
                        return r !== null && this.unexpected(r), this.parseFor(t, o);
                    }
                    parseFunctionStatement(t, r, e) {
                        return this.next(), this.parseFunction(t, 1 | (e ? 2 : 0) | (r ? 8 : 0));
                    }
                    parseIfStatement(t) {
                        return this.next(), t.test = this.parseHeaderExpression(), t.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration(), t.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null, this.finishNode(t, "IfStatement");
                    }
                    parseReturnStatement(t) {
                        return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(f.IllegalReturn, {
                            at: this.state.startLoc
                        }), this.next(), this.isLineTerminator() ? t.argument = null : (t.argument = this.parseExpression(), this.semicolon()), this.finishNode(t, "ReturnStatement");
                    }
                    parseSwitchStatement(t) {
                        this.next(), t.discriminant = this.parseHeaderExpression();
                        let r = t.cases = [];
                        this.expect(5), this.state.labels.push(Ph), this.scope.enter(Fe);
                        let e;
                        for(let s; !this.match(8);)if (this.match(61) || this.match(65)) {
                            let i = this.match(61);
                            e && this.finishNode(e, "SwitchCase"), r.push(e = this.startNode()), e.consequent = [], this.next(), i ? e.test = this.parseExpression() : (s && this.raise(f.MultipleDefaultsInSwitch, {
                                at: this.state.lastTokStartLoc
                            }), s = !0, e.test = null), this.expect(14);
                        } else e ? e.consequent.push(this.parseStatementListItem()) : this.unexpected();
                        return this.scope.exit(), e && this.finishNode(e, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t, "SwitchStatement");
                    }
                    parseThrowStatement(t) {
                        return this.next(), this.hasPrecedingLineBreak() && this.raise(f.NewlineAfterThrow, {
                            at: this.state.lastTokEndLoc
                        }), t.argument = this.parseExpression(), this.semicolon(), this.finishNode(t, "ThrowStatement");
                    }
                    parseCatchClauseParam() {
                        let t = this.parseBindingAtom();
                        return this.scope.enter(this.options.annexB && t.type === "Identifier" ? gr : 0), this.checkLVal(t, {
                            in: {
                                type: "CatchClause"
                            },
                            binding: cl
                        }), t;
                    }
                    parseTryStatement(t) {
                        if (this.next(), t.block = this.parseBlock(), t.handler = null, this.match(62)) {
                            let r = this.startNode();
                            this.next(), this.match(10) ? (this.expect(10), r.param = this.parseCatchClauseParam(), this.expect(11)) : (r.param = null, this.scope.enter(Fe)), r.body = this.withSmartMixTopicForbiddingContext(()=>this.parseBlock(!1, !1)), this.scope.exit(), t.handler = this.finishNode(r, "CatchClause");
                        }
                        return t.finalizer = this.eat(67) ? this.parseBlock() : null, !t.handler && !t.finalizer && this.raise(f.NoCatchOrFinally, {
                            at: t
                        }), this.finishNode(t, "TryStatement");
                    }
                    parseVarStatement(t, r) {
                        let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                        return this.next(), this.parseVar(t, !1, r, e), this.semicolon(), this.finishNode(t, "VariableDeclaration");
                    }
                    parseWhileStatement(t) {
                        return this.next(), t.test = this.parseHeaderExpression(), this.state.labels.push(cs), t.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement()), this.state.labels.pop(), this.finishNode(t, "WhileStatement");
                    }
                    parseWithStatement(t) {
                        return this.state.strict && this.raise(f.StrictWith, {
                            at: this.state.startLoc
                        }), this.next(), t.object = this.parseHeaderExpression(), t.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement()), this.finishNode(t, "WithStatement");
                    }
                    parseEmptyStatement(t) {
                        return this.next(), this.finishNode(t, "EmptyStatement");
                    }
                    parseLabeledStatement(t, r, e, s) {
                        for (let a of this.state.labels)a.name === r && this.raise(f.LabelRedeclaration, {
                            at: e,
                            labelName: r
                        });
                        let i = Mo(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
                        for(let a = this.state.labels.length - 1; a >= 0; a--){
                            let n = this.state.labels[a];
                            if (n.statementStart === t.start) n.statementStart = this.state.start, n.kind = i;
                            else break;
                        }
                        return this.state.labels.push({
                            name: r,
                            kind: i,
                            statementStart: this.state.start
                        }), t.body = s & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(!0) : this.parseStatement(), this.state.labels.pop(), t.label = e, this.finishNode(t, "LabeledStatement");
                    }
                    parseExpressionStatement(t, r, e) {
                        return t.expression = r, this.semicolon(), this.finishNode(t, "ExpressionStatement");
                    }
                    parseBlock() {
                        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, e = arguments.length > 2 ? arguments[2] : void 0, s = this.startNode();
                        return t && this.state.strictErrors.clear(), this.expect(5), r && this.scope.enter(Fe), this.parseBlockBody(s, t, !1, 8, e), r && this.scope.exit(), this.finishNode(s, "BlockStatement");
                    }
                    isValidDirective(t) {
                        return t.type === "ExpressionStatement" && t.expression.type === "StringLiteral" && !t.expression.extra.parenthesized;
                    }
                    parseBlockBody(t, r, e, s, i) {
                        let a = t.body = [], n = t.directives = [];
                        this.parseBlockOrModuleBlockBody(a, r ? n : void 0, e, s, i);
                    }
                    parseBlockOrModuleBlockBody(t, r, e, s, i) {
                        let a = this.state.strict, n = !1, o = !1;
                        for(; !this.match(s);){
                            let u = e ? this.parseModuleItem() : this.parseStatementListItem();
                            if (r && !o) {
                                if (this.isValidDirective(u)) {
                                    let c = this.stmtToDirective(u);
                                    r.push(c), !n && c.value.value === "use strict" && (n = !0, this.setStrict(!0));
                                    continue;
                                }
                                o = !0, this.state.strictErrors.clear();
                            }
                            t.push(u);
                        }
                        i && i.call(this, n), a || this.setStrict(!1), this.next();
                    }
                    parseFor(t, r) {
                        return t.init = r, this.semicolon(!1), t.test = this.match(13) ? null : this.parseExpression(), this.semicolon(!1), t.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t, "ForStatement");
                    }
                    parseForIn(t, r, e) {
                        let s = this.match(58);
                        return this.next(), s ? e !== null && this.unexpected(e) : t.await = e !== null, r.type === "VariableDeclaration" && r.declarations[0].init != null && (!s || !this.options.annexB || this.state.strict || r.kind !== "var" || r.declarations[0].id.type !== "Identifier") && this.raise(f.ForInOfLoopInitializer, {
                            at: r,
                            type: s ? "ForInStatement" : "ForOfStatement"
                        }), r.type === "AssignmentPattern" && this.raise(f.InvalidLhs, {
                            at: r,
                            ancestor: {
                                type: "ForStatement"
                            }
                        }), t.left = r, t.right = s ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t.body = this.withSmartMixTopicForbiddingContext(()=>this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t, s ? "ForInStatement" : "ForOfStatement");
                    }
                    parseVar(t, r, e) {
                        let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, i = t.declarations = [];
                        for(t.kind = e;;){
                            let a = this.startNode();
                            if (this.parseVarId(a, e), a.init = this.eat(29) ? r ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a.init === null && !s && (a.id.type !== "Identifier" && !(r && (this.match(58) || this.isContextual(101))) ? this.raise(f.DeclarationMissingInitializer, {
                                at: this.state.lastTokEndLoc,
                                kind: "destructuring"
                            }) : e === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(f.DeclarationMissingInitializer, {
                                at: this.state.lastTokEndLoc,
                                kind: "const"
                            })), i.push(this.finishNode(a, "VariableDeclarator")), !this.eat(12)) break;
                        }
                        return t;
                    }
                    parseVarId(t, r) {
                        r === "using" && !this.inModule && this.match(96) && this.raise(f.AwaitInUsingBinding, {
                            at: this.state.startLoc
                        });
                        let e = this.parseBindingAtom();
                        this.checkLVal(e, {
                            in: {
                                type: "VariableDeclarator"
                            },
                            binding: r === "var" ? mt : Be
                        }), t.id = e;
                    }
                    parseAsyncFunctionExpression(t) {
                        return this.parseFunction(t, 8);
                    }
                    parseFunction(t) {
                        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = r & 2, s = !!(r & 1), i = s && !(r & 4), a = !!(r & 8);
                        this.initFunction(t, a), this.match(55) && (e && this.raise(f.GeneratorInSingleStatementContext, {
                            at: this.state.startLoc
                        }), this.next(), t.generator = !0), s && (t.id = this.parseFunctionId(i));
                        let n = this.state.maybeInArrowParameters;
                        return this.state.maybeInArrowParameters = !1, this.scope.enter(de), this.prodParam.enter(Tt(a, t.generator)), s || (t.id = this.parseFunctionId()), this.parseFunctionParams(t, !1), this.withSmartMixTopicForbiddingContext(()=>{
                            this.parseFunctionBodyAndFinish(t, s ? "FunctionDeclaration" : "FunctionExpression");
                        }), this.prodParam.exit(), this.scope.exit(), s && !e && this.registerFunctionStatementId(t), this.state.maybeInArrowParameters = n, t;
                    }
                    parseFunctionId(t) {
                        return t || q(this.state.type) ? this.parseIdentifier() : null;
                    }
                    parseFunctionParams(t, r) {
                        this.expect(10), this.expressionScope.enter(ql()), t.params = this.parseBindingList(11, 41, 2 | (r ? 4 : 0)), this.expressionScope.exit();
                    }
                    registerFunctionStatementId(t) {
                        t.id && this.scope.declareName(t.id.name, !this.options.annexB || this.state.strict || t.generator || t.async ? this.scope.treatFunctionsAsVar ? mt : Be : Er, t.id.loc.start);
                    }
                    parseClass(t, r, e) {
                        this.next();
                        let s = this.state.strict;
                        return this.state.strict = !0, this.parseClassId(t, r, e), this.parseClassSuper(t), t.body = this.parseClassBody(!!t.superClass, s), this.finishNode(t, r ? "ClassDeclaration" : "ClassExpression");
                    }
                    isClassProperty() {
                        return this.match(29) || this.match(13) || this.match(8);
                    }
                    isClassMethod() {
                        return this.match(10);
                    }
                    isNonstaticConstructor(t) {
                        return !t.computed && !t.static && (t.key.name === "constructor" || t.key.value === "constructor");
                    }
                    parseClassBody(t, r) {
                        this.classScope.enter();
                        let e = {
                            hadConstructor: !1,
                            hadSuperClass: t
                        }, s = [], i = this.startNode();
                        if (i.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(()=>{
                            for(; !this.match(8);){
                                if (this.eat(13)) {
                                    if (s.length > 0) throw this.raise(f.DecoratorSemicolon, {
                                        at: this.state.lastTokEndLoc
                                    });
                                    continue;
                                }
                                if (this.match(26)) {
                                    s.push(this.parseDecorator());
                                    continue;
                                }
                                let a = this.startNode();
                                s.length && (a.decorators = s, this.resetStartLocationFromNode(a, s[0]), s = []), this.parseClassMember(i, a, e), a.kind === "constructor" && a.decorators && a.decorators.length > 0 && this.raise(f.DecoratorConstructor, {
                                    at: a
                                });
                            }
                        }), this.state.strict = r, this.next(), s.length) throw this.raise(f.TrailingDecorator, {
                            at: this.state.startLoc
                        });
                        return this.classScope.exit(), this.finishNode(i, "ClassBody");
                    }
                    parseClassMemberFromModifier(t, r) {
                        let e = this.parseIdentifier(!0);
                        if (this.isClassMethod()) {
                            let s = r;
                            return s.kind = "method", s.computed = !1, s.key = e, s.static = !1, this.pushClassMethod(t, s, !1, !1, !1, !1), !0;
                        } else if (this.isClassProperty()) {
                            let s = r;
                            return s.computed = !1, s.key = e, s.static = !1, t.body.push(this.parseClassProperty(s)), !0;
                        }
                        return this.resetPreviousNodeTrailingComments(e), !1;
                    }
                    parseClassMember(t, r, e) {
                        let s = this.isContextual(104);
                        if (s) {
                            if (this.parseClassMemberFromModifier(t, r)) return;
                            if (this.eat(5)) {
                                this.parseClassStaticBlock(t, r);
                                return;
                            }
                        }
                        this.parseClassMemberWithIsStatic(t, r, e, s);
                    }
                    parseClassMemberWithIsStatic(t, r, e, s) {
                        let i = r, a = r, n = r, o = r, u = r, c = i, y = i;
                        if (r.static = s, this.parsePropertyNamePrefixOperator(r), this.eat(55)) {
                            c.kind = "method";
                            let j = this.match(136);
                            if (this.parseClassElementName(c), j) {
                                this.pushClassPrivateMethod(t, a, !0, !1);
                                return;
                            }
                            this.isNonstaticConstructor(i) && this.raise(f.ConstructorIsGenerator, {
                                at: i.key
                            }), this.pushClassMethod(t, i, !0, !1, !1, !1);
                            return;
                        }
                        let g = q(this.state.type) && !this.state.containsEsc, T = this.match(136), C = this.parseClassElementName(r), M = this.state.startLoc;
                        if (this.parsePostMemberNameModifiers(y), this.isClassMethod()) {
                            if (c.kind = "method", T) {
                                this.pushClassPrivateMethod(t, a, !1, !1);
                                return;
                            }
                            let j = this.isNonstaticConstructor(i), K = !1;
                            j && (i.kind = "constructor", e.hadConstructor && !this.hasPlugin("typescript") && this.raise(f.DuplicateConstructor, {
                                at: C
                            }), j && this.hasPlugin("typescript") && r.override && this.raise(f.OverrideOnConstructor, {
                                at: C
                            }), e.hadConstructor = !0, K = e.hadSuperClass), this.pushClassMethod(t, i, !1, !1, j, K);
                        } else if (this.isClassProperty()) T ? this.pushClassPrivateProperty(t, o) : this.pushClassProperty(t, n);
                        else if (g && C.name === "async" && !this.isLineTerminator()) {
                            this.resetPreviousNodeTrailingComments(C);
                            let j = this.eat(55);
                            y.optional && this.unexpected(M), c.kind = "method";
                            let K = this.match(136);
                            this.parseClassElementName(c), this.parsePostMemberNameModifiers(y), K ? this.pushClassPrivateMethod(t, a, j, !0) : (this.isNonstaticConstructor(i) && this.raise(f.ConstructorIsAsync, {
                                at: i.key
                            }), this.pushClassMethod(t, i, j, !0, !1, !1));
                        } else if (g && (C.name === "get" || C.name === "set") && !(this.match(55) && this.isLineTerminator())) {
                            this.resetPreviousNodeTrailingComments(C), c.kind = C.name;
                            let j = this.match(136);
                            this.parseClassElementName(i), j ? this.pushClassPrivateMethod(t, a, !1, !1) : (this.isNonstaticConstructor(i) && this.raise(f.ConstructorIsAccessor, {
                                at: i.key
                            }), this.pushClassMethod(t, i, !1, !1, !1, !1)), this.checkGetterSetterParams(i);
                        } else if (g && C.name === "accessor" && !this.isLineTerminator()) {
                            this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(C);
                            let j = this.match(136);
                            this.parseClassElementName(n), this.pushClassAccessorProperty(t, u, j);
                        } else this.isLineTerminator() ? T ? this.pushClassPrivateProperty(t, o) : this.pushClassProperty(t, n) : this.unexpected();
                    }
                    parseClassElementName(t) {
                        let { type: r, value: e } = this.state;
                        if ((r === 130 || r === 131) && t.static && e === "prototype" && this.raise(f.StaticPrototype, {
                            at: this.state.startLoc
                        }), r === 136) {
                            e === "constructor" && this.raise(f.ConstructorClassPrivateField, {
                                at: this.state.startLoc
                            });
                            let s = this.parsePrivateName();
                            return t.key = s, s;
                        }
                        return this.parsePropertyName(t);
                    }
                    parseClassStaticBlock(t, r) {
                        var e;
                        this.scope.enter(Ee | ut | ht);
                        let s = this.state.labels;
                        this.state.labels = [], this.prodParam.enter(Me);
                        let i = r.body = [];
                        this.parseBlockOrModuleBlockBody(i, void 0, !1, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = s, t.body.push(this.finishNode(r, "StaticBlock")), (e = r.decorators) != null && e.length && this.raise(f.DecoratorStaticBlock, {
                            at: r
                        });
                    }
                    pushClassProperty(t, r) {
                        !r.computed && (r.key.name === "constructor" || r.key.value === "constructor") && this.raise(f.ConstructorClassField, {
                            at: r.key
                        }), t.body.push(this.parseClassProperty(r));
                    }
                    pushClassPrivateProperty(t, r) {
                        let e = this.parseClassPrivateProperty(r);
                        t.body.push(e), this.classScope.declarePrivateName(this.getPrivateNameSV(e.key), ss, e.key.loc.start);
                    }
                    pushClassAccessorProperty(t, r, e) {
                        if (!e && !r.computed) {
                            let i = r.key;
                            (i.name === "constructor" || i.value === "constructor") && this.raise(f.ConstructorClassField, {
                                at: i
                            });
                        }
                        let s = this.parseClassAccessorProperty(r);
                        t.body.push(s), e && this.classScope.declarePrivateName(this.getPrivateNameSV(s.key), ss, s.key.loc.start);
                    }
                    pushClassMethod(t, r, e, s, i, a) {
                        t.body.push(this.parseMethod(r, e, s, i, a, "ClassMethod", !0));
                    }
                    pushClassPrivateMethod(t, r, e, s) {
                        let i = this.parseMethod(r, e, s, !1, !1, "ClassPrivateMethod", !0);
                        t.body.push(i);
                        let a = i.kind === "get" ? i.static ? gl : Al : i.kind === "set" ? i.static ? Pl : Tl : ss;
                        this.declareClassPrivateMethodInScope(i, a);
                    }
                    declareClassPrivateMethodInScope(t, r) {
                        this.classScope.declarePrivateName(this.getPrivateNameSV(t.key), r, t.key.loc.start);
                    }
                    parsePostMemberNameModifiers(t) {}
                    parseClassPrivateProperty(t) {
                        return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassPrivateProperty");
                    }
                    parseClassProperty(t) {
                        return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassProperty");
                    }
                    parseClassAccessorProperty(t) {
                        return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassAccessorProperty");
                    }
                    parseInitializer(t) {
                        this.scope.enter(Ee | ht), this.expressionScope.enter(_r()), this.prodParam.enter(Me), t.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
                    }
                    parseClassId(t, r, e) {
                        let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : vr;
                        if (q(this.state.type)) t.id = this.parseIdentifier(), r && this.declareNameFromIdentifier(t.id, s);
                        else if (e || !r) t.id = null;
                        else throw this.raise(f.MissingClassName, {
                            at: this.state.startLoc
                        });
                    }
                    parseClassSuper(t) {
                        t.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
                    }
                    parseExport(t, r) {
                        let e = this.maybeParseExportDefaultSpecifier(t), s = !e || this.eat(12), i = s && this.eatExportStar(t), a = i && this.maybeParseExportNamespaceSpecifier(t), n = s && (!a || this.eat(12)), o = e || i;
                        if (i && !a) {
                            if (e && this.unexpected(), r) throw this.raise(f.UnsupportedDecoratorExport, {
                                at: t
                            });
                            return this.parseExportFrom(t, !0), this.finishNode(t, "ExportAllDeclaration");
                        }
                        let u = this.maybeParseExportNamedSpecifiers(t);
                        e && s && !i && !u && this.unexpected(null, 5), a && n && this.unexpected(null, 97);
                        let c;
                        if (o || u) {
                            if (c = !1, r) throw this.raise(f.UnsupportedDecoratorExport, {
                                at: t
                            });
                            this.parseExportFrom(t, o);
                        } else c = this.maybeParseExportDeclaration(t);
                        if (o || u || c) {
                            var y;
                            let g = t;
                            if (this.checkExport(g, !0, !1, !!g.source), ((y = g.declaration) == null ? void 0 : y.type) === "ClassDeclaration") this.maybeTakeDecorators(r, g.declaration, g);
                            else if (r) throw this.raise(f.UnsupportedDecoratorExport, {
                                at: t
                            });
                            return this.finishNode(g, "ExportNamedDeclaration");
                        }
                        if (this.eat(65)) {
                            let g = t, T = this.parseExportDefaultExpression();
                            if (g.declaration = T, T.type === "ClassDeclaration") this.maybeTakeDecorators(r, T, g);
                            else if (r) throw this.raise(f.UnsupportedDecoratorExport, {
                                at: t
                            });
                            return this.checkExport(g, !0, !0), this.finishNode(g, "ExportDefaultDeclaration");
                        }
                        this.unexpected(null, 5);
                    }
                    eatExportStar(t) {
                        return this.eat(55);
                    }
                    maybeParseExportDefaultSpecifier(t) {
                        if (this.isExportDefaultSpecifier()) {
                            this.expectPlugin("exportDefaultFrom");
                            let r = this.startNode();
                            return r.exported = this.parseIdentifier(!0), t.specifiers = [
                                this.finishNode(r, "ExportDefaultSpecifier")
                            ], !0;
                        }
                        return !1;
                    }
                    maybeParseExportNamespaceSpecifier(t) {
                        if (this.isContextual(93)) {
                            t.specifiers || (t.specifiers = []);
                            let r = this.startNodeAt(this.state.lastTokStartLoc);
                            return this.next(), r.exported = this.parseModuleExportName(), t.specifiers.push(this.finishNode(r, "ExportNamespaceSpecifier")), !0;
                        }
                        return !1;
                    }
                    maybeParseExportNamedSpecifiers(t) {
                        if (this.match(5)) {
                            t.specifiers || (t.specifiers = []);
                            let r = t.exportKind === "type";
                            return t.specifiers.push(...this.parseExportSpecifiers(r)), t.source = null, t.declaration = null, this.hasPlugin("importAssertions") && (t.assertions = []), !0;
                        }
                        return !1;
                    }
                    maybeParseExportDeclaration(t) {
                        return this.shouldParseExportDeclaration() ? (t.specifiers = [], t.source = null, this.hasPlugin("importAssertions") && (t.assertions = []), t.declaration = this.parseExportDeclaration(t), !0) : !1;
                    }
                    isAsyncFunction() {
                        if (!this.isContextual(95)) return !1;
                        let t = this.nextTokenStart();
                        return !as.test(this.input.slice(this.state.pos, t)) && this.isUnparsedContextual(t, "function");
                    }
                    parseExportDefaultExpression() {
                        let t = this.startNode();
                        if (this.match(68)) return this.next(), this.parseFunction(t, 5);
                        if (this.isAsyncFunction()) return this.next(), this.next(), this.parseFunction(t, 13);
                        if (this.match(80)) return this.parseClass(t, !0, !0);
                        if (this.match(26)) return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === !0 && this.raise(f.DecoratorBeforeExport, {
                            at: this.state.startLoc
                        }), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(!1), this.startNode()), !0, !0);
                        if (this.match(75) || this.match(74) || this.isLet()) throw this.raise(f.UnsupportedDefaultExport, {
                            at: this.state.startLoc
                        });
                        let r = this.parseMaybeAssignAllowIn();
                        return this.semicolon(), r;
                    }
                    parseExportDeclaration(t) {
                        return this.match(80) ? this.parseClass(this.startNode(), !0, !1) : this.parseStatementListItem();
                    }
                    isExportDefaultSpecifier() {
                        let { type: t } = this.state;
                        if (q(t)) {
                            if (t === 95 && !this.state.containsEsc || t === 99) return !1;
                            if ((t === 128 || t === 127) && !this.state.containsEsc) {
                                let { type: s } = this.lookahead();
                                if (q(s) && s !== 97 || s === 5) return this.expectOnePlugin([
                                    "flow",
                                    "typescript"
                                ]), !1;
                            }
                        } else if (!this.match(65)) return !1;
                        let r = this.nextTokenStart(), e = this.isUnparsedContextual(r, "from");
                        if (this.input.charCodeAt(r) === 44 || q(this.state.type) && e) return !0;
                        if (this.match(65) && e) {
                            let s = this.input.charCodeAt(this.nextTokenStartSince(r + 4));
                            return s === 34 || s === 39;
                        }
                        return !1;
                    }
                    parseExportFrom(t, r) {
                        if (this.eatContextual(97)) {
                            t.source = this.parseImportSource(), this.checkExport(t);
                            let e = this.maybeParseImportAssertions();
                            e && (t.assertions = e, this.checkJSONModuleImport(t));
                        } else r && this.unexpected();
                        this.semicolon();
                    }
                    shouldParseExportDeclaration() {
                        let { type: t } = this.state;
                        return t === 26 && (this.expectOnePlugin([
                            "decorators",
                            "decorators-legacy"
                        ]), this.hasPlugin("decorators")) ? (this.getPluginOption("decorators", "decoratorsBeforeExport") === !0 && this.raise(f.DecoratorBeforeExport, {
                            at: this.state.startLoc
                        }), !0) : t === 74 || t === 75 || t === 68 || t === 80 || this.isLet() || this.isAsyncFunction();
                    }
                    checkExport(t, r, e, s) {
                        if (r) {
                            if (e) {
                                if (this.checkDuplicateExports(t, "default"), this.hasPlugin("exportDefaultFrom")) {
                                    var i;
                                    let a = t.declaration;
                                    a.type === "Identifier" && a.name === "from" && a.end - a.start === 4 && !((i = a.extra) != null && i.parenthesized) && this.raise(f.ExportDefaultFromAsIdentifier, {
                                        at: a
                                    });
                                }
                            } else if (t.specifiers && t.specifiers.length) for (let a of t.specifiers){
                                let { exported: n } = a, o = n.type === "Identifier" ? n.name : n.value;
                                if (this.checkDuplicateExports(a, o), !s && a.local) {
                                    let { local: u } = a;
                                    u.type !== "Identifier" ? this.raise(f.ExportBindingIsString, {
                                        at: a,
                                        localName: u.value,
                                        exportName: o
                                    }) : (this.checkReservedWord(u.name, u.loc.start, !0, !1), this.scope.checkLocalExport(u));
                                }
                            }
                            else if (t.declaration) {
                                if (t.declaration.type === "FunctionDeclaration" || t.declaration.type === "ClassDeclaration") {
                                    let a = t.declaration.id;
                                    if (!a) throw new Error("Assertion failure");
                                    this.checkDuplicateExports(t, a.name);
                                } else if (t.declaration.type === "VariableDeclaration") for (let a of t.declaration.declarations)this.checkDeclaration(a.id);
                            }
                        }
                    }
                    checkDeclaration(t) {
                        if (t.type === "Identifier") this.checkDuplicateExports(t, t.name);
                        else if (t.type === "ObjectPattern") for (let r of t.properties)this.checkDeclaration(r);
                        else if (t.type === "ArrayPattern") for (let r of t.elements)r && this.checkDeclaration(r);
                        else t.type === "ObjectProperty" ? this.checkDeclaration(t.value) : t.type === "RestElement" ? this.checkDeclaration(t.argument) : t.type === "AssignmentPattern" && this.checkDeclaration(t.left);
                    }
                    checkDuplicateExports(t, r) {
                        this.exportedIdentifiers.has(r) && (r === "default" ? this.raise(f.DuplicateDefaultExport, {
                            at: t
                        }) : this.raise(f.DuplicateExport, {
                            at: t,
                            exportName: r
                        })), this.exportedIdentifiers.add(r);
                    }
                    parseExportSpecifiers(t) {
                        let r = [], e = !0;
                        for(this.expect(5); !this.eat(8);){
                            if (e) e = !1;
                            else if (this.expect(12), this.eat(8)) break;
                            let s = this.isContextual(128), i = this.match(131), a = this.startNode();
                            a.local = this.parseModuleExportName(), r.push(this.parseExportSpecifier(a, i, t, s));
                        }
                        return r;
                    }
                    parseExportSpecifier(t, r, e, s) {
                        return this.eatContextual(93) ? t.exported = this.parseModuleExportName() : r ? t.exported = Kl(t.local) : t.exported || (t.exported = me(t.local)), this.finishNode(t, "ExportSpecifier");
                    }
                    parseModuleExportName() {
                        if (this.match(131)) {
                            let t = this.parseStringLiteral(this.state.value), r = t.value.match(Ah);
                            return r && this.raise(f.ModuleExportNameHasLoneSurrogate, {
                                at: t,
                                surrogateCharCode: r[0].charCodeAt(0)
                            }), t;
                        }
                        return this.parseIdentifier(!0);
                    }
                    isJSONModuleImport(t) {
                        return t.assertions != null ? t.assertions.some((r)=>{
                            let { key: e, value: s } = r;
                            return s.value === "json" && (e.type === "Identifier" ? e.name === "type" : e.value === "type");
                        }) : !1;
                    }
                    checkImportReflection(t) {
                        if (t.module) {
                            var r;
                            (t.specifiers.length !== 1 || t.specifiers[0].type !== "ImportDefaultSpecifier") && this.raise(f.ImportReflectionNotBinding, {
                                at: t.specifiers[0].loc.start
                            }), ((r = t.assertions) == null ? void 0 : r.length) > 0 && this.raise(f.ImportReflectionHasAssertion, {
                                at: t.specifiers[0].loc.start
                            });
                        }
                    }
                    checkJSONModuleImport(t) {
                        if (this.isJSONModuleImport(t) && t.type !== "ExportAllDeclaration") {
                            let { specifiers: r } = t;
                            if (r != null) {
                                let e = r.find((s)=>{
                                    let i;
                                    if (s.type === "ExportSpecifier" ? i = s.local : s.type === "ImportSpecifier" && (i = s.imported), i !== void 0) return i.type === "Identifier" ? i.name !== "default" : i.value !== "default";
                                });
                                e !== void 0 && this.raise(f.ImportJSONBindingNotDefault, {
                                    at: e.loc.start
                                });
                            }
                        }
                    }
                    parseMaybeImportReflection(t) {
                        let r = !1;
                        if (this.isContextual(125)) {
                            let e = this.lookahead(), s = e.type;
                            q(s) ? (s !== 97 || this.input.charCodeAt(this.nextTokenStartSince(e.end)) === 102) && (r = !0) : s !== 12 && (r = !0);
                        }
                        r ? (this.expectPlugin("importReflection"), this.next(), t.module = !0) : this.hasPlugin("importReflection") && (t.module = !1);
                    }
                    parseImport(t) {
                        if (t.specifiers = [], !this.match(131)) {
                            this.parseMaybeImportReflection(t);
                            let s = !this.maybeParseDefaultImportSpecifier(t) || this.eat(12), i = s && this.maybeParseStarImportSpecifier(t);
                            s && !i && this.parseNamedImportSpecifiers(t), this.expectContextual(97);
                        }
                        t.source = this.parseImportSource();
                        let r = this.maybeParseImportAssertions();
                        if (r) t.assertions = r;
                        else {
                            let e = this.maybeParseModuleAttributes();
                            e && (t.attributes = e);
                        }
                        return this.checkImportReflection(t), this.checkJSONModuleImport(t), this.semicolon(), this.finishNode(t, "ImportDeclaration");
                    }
                    parseImportSource() {
                        return this.match(131) || this.unexpected(), this.parseExprAtom();
                    }
                    shouldParseDefaultImport(t) {
                        return q(this.state.type);
                    }
                    parseImportSpecifierLocal(t, r, e) {
                        r.local = this.parseIdentifier(), t.specifiers.push(this.finishImportSpecifier(r, e));
                    }
                    finishImportSpecifier(t, r) {
                        let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Be;
                        return this.checkLVal(t.local, {
                            in: {
                                type: r
                            },
                            binding: e
                        }), this.finishNode(t, r);
                    }
                    parseAssertEntries() {
                        let t = [], r = new Set;
                        do {
                            if (this.match(8)) break;
                            let e = this.startNode(), s = this.state.value;
                            if (r.has(s) && this.raise(f.ModuleAttributesWithDuplicateKeys, {
                                at: this.state.startLoc,
                                key: s
                            }), r.add(s), this.match(131) ? e.key = this.parseStringLiteral(s) : e.key = this.parseIdentifier(!0), this.expect(14), !this.match(131)) throw this.raise(f.ModuleAttributeInvalidValue, {
                                at: this.state.startLoc
                            });
                            e.value = this.parseStringLiteral(this.state.value), t.push(this.finishNode(e, "ImportAttribute"));
                        }while (this.eat(12));
                        return t;
                    }
                    maybeParseModuleAttributes() {
                        if (this.match(76) && !this.hasPrecedingLineBreak()) this.expectPlugin("moduleAttributes"), this.next();
                        else return this.hasPlugin("moduleAttributes") ? [] : null;
                        let t = [], r = new Set;
                        do {
                            let e = this.startNode();
                            if (e.key = this.parseIdentifier(!0), e.key.name !== "type" && this.raise(f.ModuleAttributeDifferentFromType, {
                                at: e.key
                            }), r.has(e.key.name) && this.raise(f.ModuleAttributesWithDuplicateKeys, {
                                at: e.key,
                                key: e.key.name
                            }), r.add(e.key.name), this.expect(14), !this.match(131)) throw this.raise(f.ModuleAttributeInvalidValue, {
                                at: this.state.startLoc
                            });
                            e.value = this.parseStringLiteral(this.state.value), this.finishNode(e, "ImportAttribute"), t.push(e);
                        }while (this.eat(12));
                        return t;
                    }
                    maybeParseImportAssertions() {
                        if (this.isContextual(94) && !this.hasPrecedingLineBreak()) this.expectPlugin("importAssertions"), this.next();
                        else return this.hasPlugin("importAssertions") ? [] : null;
                        this.eat(5);
                        let t = this.parseAssertEntries();
                        return this.eat(8), t;
                    }
                    maybeParseDefaultImportSpecifier(t) {
                        return this.shouldParseDefaultImport(t) ? (this.parseImportSpecifierLocal(t, this.startNode(), "ImportDefaultSpecifier"), !0) : !1;
                    }
                    maybeParseStarImportSpecifier(t) {
                        if (this.match(55)) {
                            let r = this.startNode();
                            return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t, r, "ImportNamespaceSpecifier"), !0;
                        }
                        return !1;
                    }
                    parseNamedImportSpecifiers(t) {
                        let r = !0;
                        for(this.expect(5); !this.eat(8);){
                            if (r) r = !1;
                            else {
                                if (this.eat(14)) throw this.raise(f.DestructureNamedImport, {
                                    at: this.state.startLoc
                                });
                                if (this.expect(12), this.eat(8)) break;
                            }
                            let e = this.startNode(), s = this.match(131), i = this.isContextual(128);
                            e.imported = this.parseModuleExportName();
                            let a = this.parseImportSpecifier(e, s, t.importKind === "type" || t.importKind === "typeof", i, void 0);
                            t.specifiers.push(a);
                        }
                    }
                    parseImportSpecifier(t, r, e, s, i) {
                        if (this.eatContextual(93)) t.local = this.parseIdentifier();
                        else {
                            let { imported: a } = t;
                            if (r) throw this.raise(f.ImportBindingIsString, {
                                at: t,
                                importName: a.value
                            });
                            this.checkReservedWord(a.name, t.loc.start, !0, !0), t.local || (t.local = me(a));
                        }
                        return this.finishImportSpecifier(t, "ImportSpecifier", i);
                    }
                    isThisParam(t) {
                        return t.type === "Identifier" && t.name === "this";
                    }
                }, Yr = class extends vh {
                    constructor(t, r){
                        t = p(t), super(t, r), this.options = t, this.initializeScopes(), this.plugins = Eh(this.options.plugins), this.filename = t.sourceFilename;
                    }
                    getScopeHandler() {
                        return is;
                    }
                    parse() {
                        this.enterInitialScopes();
                        let t = this.startNode(), r = this.startNode();
                        return this.nextToken(), t.errors = null, this.parseTopLevel(t, r), t.errors = this.state.errors, t;
                    }
                };
                function Eh(t) {
                    let r = new Map;
                    for (let e of t){
                        let [s, i] = Array.isArray(e) ? e : [
                            e,
                            {}
                        ];
                        r.has(s) || r.set(s, i || {});
                    }
                    return r;
                }
                function Ch(t, r) {
                    var e;
                    if (((e = r) == null ? void 0 : e.sourceType) === "unambiguous") {
                        r = Object.assign({}, r);
                        try {
                            r.sourceType = "module";
                            let s = Xe(r, t), i = s.parse();
                            if (s.sawUnambiguousESM) return i;
                            if (s.ambiguousScriptDifferentAst) try {
                                return r.sourceType = "script", Xe(r, t).parse();
                            } catch  {}
                            else i.program.sourceType = "script";
                            return i;
                        } catch (s) {
                            try {
                                return r.sourceType = "script", Xe(r, t).parse();
                            } catch  {}
                            throw s;
                        }
                    } else return Xe(r, t).parse();
                }
                function bh(t, r) {
                    let e = Xe(r, t);
                    return e.options.strictMode && (e.state.strict = !0), e.getExpression();
                }
                function Sh(t) {
                    let r = {};
                    for (let e of Object.keys(t))r[e] = ce(t[e]);
                    return r;
                }
                var wh = Sh(Z);
                function Xe(t, r) {
                    let e = Yr;
                    return t != null && t.plugins && (yh(t.plugins), e = Ih(t.plugins)), new e(t, r);
                }
                var Qr = {};
                function Ih(t) {
                    let r = xh.filter((i)=>J(t, i)), e = r.join("/"), s = Qr[e];
                    if (!s) {
                        s = Yr;
                        for (let i of r)s = Xr[i](s);
                        Qr[e] = s;
                    }
                    return s;
                }
                l.parse = Ch, l.parseExpression = bh, l.tokTypes = wh;
            }
        }), Xf = $({
            "src/language-js/parse/json.js" (l, h) {
                "use strict";
                U();
                var p = Io(), d = lr(), x = ko(), P = Do();
                function m() {
                    let w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: L = !0 } = w;
                    return function(_) {
                        let { parseExpression: G } = Fo(), N;
                        try {
                            N = G(_, {
                                tokens: !0,
                                ranges: !0
                            });
                        } catch (O) {
                            throw P(O);
                        }
                        if (!L && p(N.comments)) throw v(N.comments[0], "Comment");
                        return S(N), N;
                    };
                }
                function v(w, L) {
                    let [A, _] = [
                        w.loc.start,
                        w.loc.end
                    ].map((G)=>{
                        let { line: N, column: O } = G;
                        return {
                            line: N,
                            column: O + 1
                        };
                    });
                    return d(`${L} is not allowed in JSON.`, {
                        start: A,
                        end: _
                    });
                }
                function S(w) {
                    switch(w.type){
                        case "ArrayExpression":
                            for (let L of w.elements)L !== null && S(L);
                            return;
                        case "ObjectExpression":
                            for (let L of w.properties)S(L);
                            return;
                        case "ObjectProperty":
                            if (w.computed) throw v(w.key, "Computed key");
                            if (w.shorthand) throw v(w.key, "Shorthand property");
                            w.key.type !== "Identifier" && S(w.key), S(w.value);
                            return;
                        case "UnaryExpression":
                            {
                                let { operator: L, argument: A } = w;
                                if (L !== "+" && L !== "-") throw v(w, `Operator '${w.operator}'`);
                                if (A.type === "NumericLiteral" || A.type === "Identifier" && (A.name === "Infinity" || A.name === "NaN")) return;
                                throw v(A, `Operator '${L}' before '${A.type}'`);
                            }
                        case "Identifier":
                            if (w.name !== "Infinity" && w.name !== "NaN" && w.name !== "undefined") throw v(w, `Identifier '${w.name}'`);
                            return;
                        case "TemplateLiteral":
                            if (p(w.expressions)) throw v(w.expressions[0], "'TemplateLiteral' with expression");
                            for (let L of w.quasis)S(L);
                            return;
                        case "NullLiteral":
                        case "BooleanLiteral":
                        case "NumericLiteral":
                        case "StringLiteral":
                        case "TemplateElement":
                            return;
                        default:
                            throw v(w, `'${w.type}'`);
                    }
                }
                var k = m(), F = {
                    json: x({
                        parse: k,
                        hasPragma () {
                            return !0;
                        }
                    }),
                    json5: x(k),
                    "json-stringify": x({
                        parse: m({
                            allowComments: !1
                        }),
                        astFormat: "estree-json"
                    })
                };
                h.exports = F;
            }
        });
        U();
        var Yf = kf(), Qf = po(), Zf = Of(), Ue = ko(), ed = Do(), td = Jf(), sd = Xf(), rd = {
            sourceType: "module",
            allowImportExportEverywhere: !0,
            allowReturnOutsideFunction: !0,
            allowSuperOutsideMethod: !0,
            allowUndeclaredExports: !0,
            errorRecovery: !0,
            createParenthesizedExpressions: !0,
            plugins: [
                "doExpressions",
                "exportDefaultFrom",
                "functionBind",
                "functionSent",
                "throwExpressions",
                "partialApplication",
                [
                    "decorators",
                    {
                        decoratorsBeforeExport: !1
                    }
                ],
                "importAssertions",
                "decimal",
                "moduleBlocks",
                "asyncDoExpressions",
                "regexpUnicodeSets",
                "destructuringPrivate",
                "decoratorAutoAccessors"
            ],
            tokens: !0,
            ranges: !0
        }, id = [
            "recordAndTuple",
            {
                syntaxType: "hash"
            }
        ], no = "v8intrinsic", oo = [
            [
                "pipelineOperator",
                {
                    proposal: "hack",
                    topicToken: "%"
                }
            ],
            [
                "pipelineOperator",
                {
                    proposal: "minimal"
                }
            ],
            [
                "pipelineOperator",
                {
                    proposal: "fsharp"
                }
            ]
        ], he = function(l) {
            let h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : rd;
            return Object.assign(Object.assign({}, h), {}, {
                plugins: [
                    ...h.plugins,
                    ...l
                ]
            });
        }, ad = /@(?:no)?flow\b/;
        function nd(l, h) {
            if (h.filepath && h.filepath.endsWith(".js.flow")) return !0;
            let p = Qf(l);
            p && (l = l.slice(p.length));
            let d = Zf(l, 0);
            return d !== !1 && (l = l.slice(0, d)), ad.test(l);
        }
        function od(l, h, p) {
            let d = Fo()[l], x = d(h, p), P = x.errors.find((m)=>!fd.has(m.reasonCode));
            if (P) throw P;
            return x;
        }
        function $e(l) {
            for(var h = arguments.length, p = new Array(h > 1 ? h - 1 : 0), d = 1; d < h; d++)p[d - 1] = arguments[d];
            return function(x, P) {
                let m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if ((m.parser === "babel" || m.parser === "__babel_estree") && nd(x, m)) return m.parser = "babel-flow", Lo(x, P, m);
                let v = p;
                m.__babelSourceType === "script" && (v = v.map((w)=>Object.assign(Object.assign({}, w), {}, {
                        sourceType: "script"
                    }))), /#[[{]/.test(x) && (v = v.map((w)=>he([
                        id
                    ], w)));
                let S = /%[A-Z]/.test(x);
                x.includes("|>") ? v = (S ? [
                    ...oo,
                    no
                ] : oo).flatMap((L)=>v.map((A)=>he([
                            L
                        ], A))) : S && (v = v.map((w)=>he([
                        no
                    ], w)));
                let { result: k, error: F } = Yf(...v.map((w)=>()=>od(l, x, w)));
                if (!k) throw ed(F);
                return m.originalText = x, td(k, m);
            };
        }
        var ld = $e("parse", he([
            "jsx",
            "flow"
        ])), Lo = $e("parse", he([
            "jsx",
            [
                "flow",
                {
                    all: !0,
                    enums: !0
                }
            ]
        ])), hd = $e("parse", he([
            "jsx",
            "typescript"
        ]), he([
            "typescript"
        ])), ud = $e("parse", he([
            "jsx",
            "flow",
            "estree"
        ])), cd = $e("parseExpression", he([
            "jsx"
        ])), pd = $e("parseExpression", he([
            "typescript"
        ])), fd = new Set([
            "StrictNumericEscape",
            "StrictWith",
            "StrictOctalLiteral",
            "StrictDelete",
            "StrictEvalArguments",
            "StrictEvalArgumentsBinding",
            "StrictFunction",
            "EmptyTypeArguments",
            "EmptyTypeParameters",
            "ConstructorHasTypeParameters",
            "UnsupportedParameterPropertyKind",
            "UnexpectedParameterModifier",
            "MixedLabeledAndUnlabeledElements",
            "InvalidTupleMemberLabel",
            "NonClassMethodPropertyHasAbstractModifer",
            "ReadonlyForMethodSignature",
            "ClassMethodHasDeclare",
            "ClassMethodHasReadonly",
            "InvalidModifierOnTypeMember",
            "DuplicateAccessibilityModifier",
            "IndexSignatureHasDeclare",
            "DecoratorExportClass",
            "ParamDupe",
            "InvalidDecimal",
            "RestTrailingComma",
            "UnsupportedParameterDecorator",
            "UnterminatedJsxContent",
            "UnexpectedReservedWord",
            "ModuleAttributesWithDuplicateKeys",
            "LineTerminatorBeforeArrow",
            "InvalidEscapeSequenceTemplate",
            "NonAbstractClassHasAbstractMethod",
            "UnsupportedPropertyDecorator",
            "OptionalTypeBeforeRequired",
            "PatternIsOptional",
            "OptionalBindingPattern",
            "DeclareClassFieldHasInitializer",
            "TypeImportCannotSpecifyDefaultAndNamed",
            "DeclareFunctionHasImplementation",
            "ConstructorClassField",
            "VarRedeclaration",
            "InvalidPrivateFieldResolution",
            "DuplicateExport"
        ]), lo = Ue(ld), ho = Ue(hd), uo = Ue(cd), dd = Ue(pd);
        Oo.exports = {
            parsers: Object.assign(Object.assign({
                babel: lo,
                "babel-flow": Ue(Lo),
                "babel-ts": ho
            }, sd), {}, {
                __js_expression: uo,
                __vue_expression: uo,
                __vue_ts_expression: dd,
                __vue_event_binding: lo,
                __vue_ts_event_binding: ho,
                __babel_estree: Ue(ud)
            })
        };
    });
    return md();
});

},{}],"Y6Xna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "measureText", ()=>measureText);
var _cytoscapeStyleJs = require("./cytoscapeStyle.js");
const ctx = document.createElement('canvas').getContext('2d');
ctx.font = `${0, _cytoscapeStyleJs.fontSize} ${0, _cytoscapeStyleJs.fontFamily}`;
function measureText(label) {
    const metrics = ctx.measureText(label);
    return {
        width: metrics.width,
        height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
    };
}

},{"./cytoscapeStyle.js":"gLnUw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gLnUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontFamily", ()=>fontFamily);
parcelHelpers.export(exports, "fontSize", ()=>fontSize);
parcelHelpers.export(exports, "nodePaddingPx", ()=>nodePaddingPx);
parcelHelpers.export(exports, "style", ()=>style);
var _vegaScale = require("vega-scale");
var _graphJs = require("./graph.js");
// Use these color schemes for the nodes
// https://vega.github.io/vega/docs/schemes/#categorical
const colorScheme = [
    ...(0, _vegaScale.scheme)('tableau20'),
    ...(0, _vegaScale.scheme)('category20b')
];
const fontFamily = '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
const fontSize = '16px';
const nodePaddingPx = 8;
const style = [
    {
        selector: 'node, edge',
        style: {
            'font-family': fontFamily,
            'font-size': fontSize,
            'min-zoomed-font-size': 10,
            'overlay-padding': 10
        }
    },
    {
        // Increase active opacity so more visible
        selector: ':active',
        style: {
            'overlay-opacity': 0.5
        }
    },
    {
        selector: 'node',
        style: {
            // Labels
            'text-wrap': 'wrap',
            'text-valign': 'center',
            'text-halign': 'center',
            'background-opacity': 0.6,
            shape: 'round-rectangle',
            width: 'data(width)',
            height: 'data(height)',
            label: 'data(label)',
            padding: `${nodePaddingPx}px`,
            color: 'black'
        }
    },
    {
        selector: ':parent',
        style: {
            'text-valign': 'top',
            'background-opacity': 0.05
        }
    },
    {
        selector: ':selected',
        style: {
            'overlay-opacity': 0.25
        }
    },
    {
        selector: 'edge',
        style: {
            'target-arrow-shape': 'triangle',
            'curve-style': 'bezier',
            'text-background-padding': '5',
            'text-background-shape': 'round-rectangle',
            'text-background-color': 'white',
            'text-background-opacity': 1,
            'text-rotation': 'autorotate',
            width: 1
        }
    },
    {
        selector: 'edge[label]',
        style: {
            label: 'data(label)'
        }
    },
    {
        selector: 'edge[primary="true"]',
        style: {
            color: 'black',
            'line-color': 'black',
            'target-arrow-color': 'black'
        }
    },
    {
        selector: 'edge[primary="false"]',
        style: {
            color: '#ddd',
            'line-color': '#ddd',
            'target-arrow-color': '#ddd'
        }
    },
    // Add types for operator types as well as other types
    ...(0, _graphJs.colorKeys).map((t, i)=>({
            selector: `node[colorKey=${JSON.stringify(t)}]`,
            style: {
                'background-color': colorScheme[i % colorScheme.length]
            }
        }))
];

},{"vega-scale":"fMau0","./graph.js":"l0ZC0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l0ZC0":[function(require,module,exports,__globalThis) {
/**
 * Denormalized graph represenation, that provides efficient filtering
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>types);
parcelHelpers.export(exports, "colorKeys", ()=>colorKeys);
// Filters a graphs edges to only include thos related to the selected nodes
parcelHelpers.export(exports, "filterEdges", ()=>filterEdges);
/**
 * Returns all nodes ID that are associated to the IDs passed in, plus all their parents.
 */ parcelHelpers.export(exports, "associatedWith", ()=>associatedWith);
/**
 * Returns the intersection of the passed in IDs, or null if all are null.
 */ parcelHelpers.export(exports, "intersectIDs", ()=>intersectIDs);
var _vegaEmbed = require("vega-embed");
const types = {
    binding: {
        label: 'Bindings',
        default: true
    },
    stream: {
        label: 'Streams',
        default: true
    },
    update: {
        label: 'Updates',
        default: true
    },
    operator: {
        label: 'Operators',
        default: true
    },
    data: {
        label: 'Data',
        default: true
    },
    signal: {
        label: 'Signals',
        default: true
    }
};
const colorKeys = [
    ...Object.keys(types),
    ...Object.keys((0, _vegaEmbed.vega).transforms).map((t)=>`operator:${t}`)
];
function filterEdges(graph, nodes) {
    return new Set(Object.entries(graph.edges).filter(([, { source, target }])=>nodes.has(source) && nodes.has(target)).map(([id])=>id));
}
function associatedWith({ nodes }, ids) {
    const results = new Set();
    for (const [key, node] of Object.entries(nodes))if (node.associated.some((id)=>ids.includes(id))) {
        results.add(key);
        let parent = node.parent;
        while(parent){
            results.add(parent);
            parent = nodes[parent].parent;
        }
    }
    return results;
}
function intersectIDs(...listIDS) {
    const nonNull = listIDS.filter((ids)=>ids !== null);
    switch(nonNull.length){
        case 0:
            return null;
        case 1:
            return nonNull[0];
    }
    // Iterate through each item in first, only including it if in all the other sets
    const [first, ...rest] = nonNull;
    return new Set([
        ...first
    ].filter((id)=>rest.every((ids)=>ids.has(id))));
}

},{"vega-embed":"aAWYH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5jMZ7":[function(require,module,exports,__globalThis) {
// Trim all arrays to a maximum length, to minimize the size of the state
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sanitizes the value of an operator, to make it suitable for storing in redux.
 */ parcelHelpers.export(exports, "sanitizeValue", ()=>sanitizeValue);
const MAX_ARRAY_LENGTH = 20;
// Sentinal value to add at end of clipped arrays
const CLIPPED_SENTINAL = 'CLIPPED';
function sanitizeValue(v) {
    if (typeof v === 'function') return {
        type: 'function',
        functionName: v.name
    };
    try {
        // If we can't stringify, it probably has cyclical references, so we'll just skip it
        return {
            type: 'value',
            value: JSON.parse(JSON.stringify(v, replacer))
        };
    } catch (e) {
        return {
            type: 'error',
            error: e.toString()
        };
    }
}
/**
 * Replace long arrays with shorter ones, to minimze the size of the state
 */ function replacer(_key, value) {
    if (Array.isArray(value) && value.length > MAX_ARRAY_LENGTH) {
        const trimmed = value.slice(0, MAX_ARRAY_LENGTH);
        trimmed.push(CLIPPED_SENTINAL);
        return trimmed;
    }
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bBSOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setSelectedPulse", ()=>setSelectedPulse);
parcelHelpers.export(exports, "setSelectedElements", ()=>setSelectedElements);
parcelHelpers.export(exports, "setSelectedType", ()=>setSelectedType);
parcelHelpers.export(exports, "selectionSlice", ()=>selectionSlice);
parcelHelpers.export(exports, "selectionSelector", ()=>selectionSelector);
parcelHelpers.export(exports, "selectedPulseSelector", ()=>selectedPulseSelector);
parcelHelpers.export(exports, "selectedElementsSelector", ()=>selectedElementsSelector);
parcelHelpers.export(exports, "selectedTypesSelector", ()=>selectedTypesSelector);
parcelHelpers.export(exports, "elementsSelectedSelector", ()=>elementsSelectedSelector);
parcelHelpers.export(exports, "selectedValuesSelector", ()=>selectedValuesSelector);
parcelHelpers.export(exports, "visibleNodesFromPulseSelector", ()=>visibleNodesFromPulseSelector);
parcelHelpers.export(exports, "visibleNodesFromElementsSelector", ()=>visibleNodesFromElementsSelector);
parcelHelpers.export(exports, "visibleNodesFromTypesSelector", ()=>visibleNodesFromTypesSelector);
parcelHelpers.export(exports, "visibleNodesSelector", ()=>visibleNodesSelector);
parcelHelpers.export(exports, "filteredEdgesSelector", ()=>filteredEdgesSelector);
parcelHelpers.export(exports, "visibleElementsSelector", ()=>visibleElementsSelector);
var _toolkit = require("@reduxjs/toolkit");
var _runtimeSliceJs = require("./runtimeSlice.js");
var _pulsesSliceJs = require("./pulsesSlice.js");
var _allRelatedJs = require("./utils/allRelated.js");
var _graphJs = require("./utils/graph.js");
var _createSliceSelectorJs = require("./utils/createSliceSelector.js");
var _mapValuesJs = require("./utils/mapValues.js");
const initialState = {
    pulse: null,
    elements: null,
    types: (0, _mapValuesJs.mapValues)((0, _graphJs.types), (props)=>props.default)
};
const setSelectedPulse = (0, _toolkit.createAction)('setSelectedPulse');
const setSelectedElements = (0, _toolkit.createAction)('setSelectedElements');
const setSelectedType = (0, _toolkit.createAction)('setSelectedType');
const selectionSlice = (0, _toolkit.createSlice)({
    name: 'selection',
    initialState,
    reducers: {},
    extraReducers: (builder)=>builder.addCase((0, _runtimeSliceJs.setRuntime), ()=>initialState).addCase((0, _pulsesSliceJs.resetPulses), (state)=>{
            state.pulse = null;
        }).addCase(setSelectedPulse, (state, { payload })=>{
            state.pulse = payload;
        }).addCase(setSelectedElements, (state, { payload })=>{
            // Sort them, to aid in easy equality checking
            state.elements = payload === null ? null : {
                nodes: payload.nodes.slice().sort(),
                edges: payload.edges.slice().sort()
            };
        }).addCase(setSelectedType, (state, { payload })=>{
            state.types[payload.type] = payload.enabled;
        })
});
const selectionSelector = (0, _createSliceSelectorJs.createSliceSelector)(selectionSlice);
const selectedPulseSelector = (0, _toolkit.createSelector)(selectionSelector, (state)=>state.pulse);
const selectedElementsSelector = (0, _toolkit.createSelector)(selectionSelector, (state)=>state.elements);
const selectedTypesSelector = (0, _toolkit.createSelector)(selectionSelector, (state)=>state.types);
const elementsSelectedSelector = (0, _toolkit.createSelector)(selectedElementsSelector, (selected)=>selected !== null);
const selectedValuesSelector = (0, _toolkit.createSelector)((0, _pulsesSliceJs.pulsesSelector), selectedPulseSelector, (pulses, selected)=>selected === null ? null : pulses.find((p)=>p.clock === selected).values);
const visibleNodesFromPulseSelector = (0, _toolkit.createSelector)((0, _runtimeSliceJs.graphSelector), selectedValuesSelector, (graph, values)=>values === null || graph === null ? null : (0, _graphJs.associatedWith)(graph, Object.keys(values)));
const visibleNodesFromElementsSelector = (0, _toolkit.createSelector)((0, _runtimeSliceJs.graphSelector), selectedElementsSelector, (graph, elements)=>elements === null || graph === null ? null : (0, _allRelatedJs.allRelated)(graph, elements));
const visibleNodesFromTypesSelector = (0, _toolkit.createSelector)((0, _runtimeSliceJs.graphSelector), selectedTypesSelector, (graph, selectedTypes)=>graph === null ? null : new Set(Object.entries(graph.nodes).filter(([, { type }])=>selectedTypes[type]).map(([id])=>id)));
const visibleNodesSelector = (0, _toolkit.createSelector)(visibleNodesFromPulseSelector, visibleNodesFromElementsSelector, visibleNodesFromTypesSelector, (0, _graphJs.intersectIDs));
const filteredEdgesSelector = (0, _toolkit.createSelector)((0, _runtimeSliceJs.graphSelector), visibleNodesSelector, (graph, nodes)=>nodes === null || graph === null ? null : (0, _graphJs.filterEdges)(graph, nodes));
const visibleElementsSelector = (0, _toolkit.createSelector)(visibleNodesSelector, filteredEdgesSelector, (nodes, edges)=>nodes === null ? null : {
        nodes,
        edges
    });

},{"@reduxjs/toolkit":"6q4uk","./runtimeSlice.js":"iZrZf","./pulsesSlice.js":"eeulL","./utils/allRelated.js":"2vVOt","./utils/graph.js":"l0ZC0","./utils/createSliceSelector.js":"fnXHV","./utils/mapValues.js":"4Wtbe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2vVOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns all related nodes to the passed in nodes and edges. This includes all ancestor parents and children.
 *
 * It treats compound relationships as both parents and children.
 */ parcelHelpers.export(exports, "allRelated", ()=>allRelated);
function allRelated({ nodes, edges }, selected) {
    return new Set([
        'up',
        'down'
    ].flatMap((direction)=>{
        // Map from ID to node
        const fromEdges = selected.edges.map((id)=>{
            const { source, target } = edges[id];
            return direction === 'up' ? source : target;
        });
        const toProcess = new Set([
            ...selected.nodes,
            ...fromEdges
        ]);
        const processed = new Set();
        // Pop off node and all it's parents
        while(toProcess.size > 0){
            const id = pop(toProcess);
            processed.add(id);
            // Mark the compound node relations as visited
            // and add their immediate parents to the queue
            const node = nodes[id];
            // if the user inputs an invalid node, just ignore it
            if (node === undefined) continue;
            const parents = node.parent !== undefined ? [
                node.parent
            ] : [];
            const relatedCompound = [
                ...parents,
                ...node.children
            ];
            relatedCompound.forEach((i)=>processed.add(i));
            for (const relatedID of [
                ...relatedCompound,
                id
            ].flatMap((i)=>direction === 'up' ? nodes[i].incoming : nodes[i].outgoing)){
                if (processed.has(relatedID)) continue;
                toProcess.add(relatedID);
            }
        }
        return [
            ...processed
        ];
    }));
}
/**
 * Pops the first value from the set, throwing an error if it's empty.
 */ function pop(m) {
    const { done, value } = m[Symbol.iterator]().next();
    if (done) throw new Error('Cannot pop from empty set');
    m.delete(value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Wtbe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
function mapValues(obj, fn) {
    return Object.fromEntries(Object.entries(obj).map(([k, v])=>[
            k,
            fn(v, k)
        ]));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"67Uyo":[function(require,module,exports,__globalThis) {
/**
 * Computes layouts for graphs with ELK js and caches them.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Try recomputing layout, when either runtime or selections change
 */ parcelHelpers.export(exports, "useRecomputeLayout", ()=>useRecomputeLayout);
parcelHelpers.export(exports, "layoutSlice", ()=>layoutSlice);
parcelHelpers.export(exports, "currentLayoutSelector", ()=>currentLayoutSelector);
parcelHelpers.export(exports, "currentPositionsSelector", ()=>currentPositionsSelector);
var _toolkit = require("@reduxjs/toolkit");
var _elkjs = require("elkjs");
var _elkjsDefault = parcelHelpers.interopDefault(_elkjs);
var _react = require("react");
var _reactRedux = require("react-redux");
var _hooksJs = require("../../hooks.js");
var _runtimeSliceJs = require("./runtimeSlice.js");
var _selectionSliceJs = require("./selectionSlice.js");
var _elktoPositionsJs = require("./utils/ELKToPositions.js");
var _createSliceSelectorJs = require("./utils/createSliceSelector.js");
var _toELKGraphJs = require("./utils/toELKGraph.js");
var _elkWorkerJs = require("elkjs/lib/elk-worker.js");
const initialState = {};
const elk = new (0, _elkjsDefault.default)({
    // @ts-expect-error Worker types broken
    workerFactory: (url)=>new (0, _elkWorkerJs.Worker)(url)
});
const computeLayout = (0, _toolkit.createAsyncThunk)('computeLayout', (_, { getState })=>elk.layout(elkGraphSelector(getState())), {
    // Add key to pending metadata
    getPendingMeta: ({ requestId }, { getState })=>({
            requestId,
            key: currentLayoutKeySelector(getState())
        }),
    // Only run if we can't find a layout already for this key
    condition: (_node, { getState })=>!hasLayoutSelector(getState())
});
function useRecomputeLayout() {
    const dispatch = (0, _reactRedux.useDispatch)();
    const layoutKey = (0, _hooksJs.useAppSelector)(currentLayoutKeySelector);
    // Recompute layout whenever any key for computing it changes
    _react.useEffect(()=>{
        // FIXME: remove as any
        dispatch(computeLayout());
    }, [
        layoutKey
    ]);
}
const layoutSlice = (0, _toolkit.createSlice)({
    name: 'layout',
    initialState,
    reducers: {},
    // Avoid returning builder to prevent cyclical types
    // https://github.com/reduxjs/redux-toolkit/issues/324#issuecomment-615391051
    extraReducers: (builder)=>{
        builder.addCase((0, _runtimeSliceJs.setRuntime), ()=>initialState).addCase(computeLayout.pending, (state, action)=>{
            state[action.meta.requestId] = {
                value: {
                    type: 'loading'
                },
                key: action.meta.key
            };
        }).addCase(computeLayout.fulfilled, (state, action)=>{
            state[action.meta.requestId].value = {
                positions: (0, _elktoPositionsJs.ELKToPositions)(action.payload),
                type: 'done'
            };
        }).addCase(computeLayout.rejected, (state, action)=>{
            state[action.meta.requestId].value = {
                type: 'error',
                error: action.error
            };
        });
    }
});
const layoutSelector = (0, _createSliceSelectorJs.createSliceSelector)(layoutSlice);
const elkGraphSelector = (0, _toolkit.createSelector)((0, _runtimeSliceJs.graphSelector), (0, _selectionSliceJs.visibleElementsSelector), (graph, visible)=>graph === null ? null : (0, _toELKGraphJs.toELKGraph)(graph, visible));
function idsToString(ids) {
    return [
        ...ids
    ].sort().join(',');
}
const visibleNodesStringSelector = (0, _toolkit.createSelector)((0, _selectionSliceJs.visibleNodesSelector), (nodes)=>nodes === null ? null : idsToString(nodes));
const currentLayoutKeySelector = (0, _toolkit.createSelector)((0, _runtimeSliceJs.graphSelector), visibleNodesStringSelector, (graph, visibleNodesString)=>({
        graph,
        visibleNodesString
    }));
const currentLayoutStatusSelector = (0, _toolkit.createSelector)(layoutSelector, currentLayoutKeySelector, (layout, { graph, visibleNodesString })=>// Compare graph by identity, to speed up comparison
    Object.values(layout).find(({ key })=>graph === key.graph && visibleNodesString === key.visibleNodesString) ?? null);
const hasLayoutSelector = (0, _toolkit.createSelector)(currentLayoutStatusSelector, (status)=>status !== null);
const currentLayoutSelector = (0, _toolkit.createSelector)(currentLayoutStatusSelector, (status)=>status?.value ?? null);
const currentPositionsSelector = (0, _toolkit.createSelector)(currentLayoutSelector, (value)=>value?.type === 'done' ? value.positions : null);

},{"@reduxjs/toolkit":"6q4uk","elkjs":"i7xDV","react":"bmhQu","react-redux":"dwYd3","../../hooks.js":"cg1kA","./runtimeSlice.js":"iZrZf","./selectionSlice.js":"bBSOy","./utils/ELKToPositions.js":"6MHvA","./utils/createSliceSelector.js":"fnXHV","./utils/toELKGraph.js":"1Klpl","elkjs/lib/elk-worker.js":"l3vNX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i7xDV":[function(require,module,exports,__globalThis) {
"use strict";
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
/*******************************************************************************
 * Copyright (c) 2021 Kiel University and others.
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 * 
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = require("72f2332b9ea2fd22")["default"];
var ELKNode = /*#__PURE__*/ function(_ELK) {
    function ELKNode() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, ELKNode);
        var optionsClone = Object.assign({}, options);
        var workerThreadsExist = false;
        try {
            undefined('web-worker');
            workerThreadsExist = true;
        } catch (e) {}
        // user requested a worker
        if (options.workerUrl) {
            if (workerThreadsExist) {
                var Worker = require("5c5bf0537a95f911");
                optionsClone.workerFactory = function(url) {
                    return new Worker(url);
                };
            } else console.warn("Web worker requested but 'web-worker' package not installed. \nConsider installing the package or pass your own 'workerFactory' to ELK's constructor.\n... Falling back to non-web worker version.");
        }
        // unless no other workerFactory is registered, use the fake worker
        if (!optionsClone.workerFactory) {
            var _require = require("4c5c140a920f02f6"), _Worker = _require.Worker;
            optionsClone.workerFactory = function(url) {
                return new _Worker(url);
            };
        }
        return _callSuper(this, ELKNode, [
            optionsClone
        ]);
    }
    _inherits(ELKNode, _ELK);
    return _createClass(ELKNode);
}(ELK);
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports = ELKNode;
ELKNode["default"] = ELKNode;

},{"72f2332b9ea2fd22":"cInzv","5c5bf0537a95f911":"e833c","4c5c140a920f02f6":"97i8b"}],"cInzv":[function(require,module,exports,__globalThis) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /*******************************************************************************
 * Copyright (c) 2017 Kiel University and others.
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = exports["default"] = /*#__PURE__*/ function() {
                    function ELK() {
                        var _this = this;
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$defaultLayoutOpt = _ref.defaultLayoutOptions, defaultLayoutOptions = _ref$defaultLayoutOpt === void 0 ? {} : _ref$defaultLayoutOpt, _ref$algorithms = _ref.algorithms, algorithms = _ref$algorithms === void 0 ? [
                            'layered',
                            'stress',
                            'mrtree',
                            'radial',
                            'force',
                            'disco',
                            'sporeOverlap',
                            'sporeCompaction',
                            'rectpacking'
                        ] : _ref$algorithms, workerFactory = _ref.workerFactory, workerUrl = _ref.workerUrl;
                        _classCallCheck(this, ELK);
                        this.defaultLayoutOptions = defaultLayoutOptions;
                        this.initialized = false;
                        // check valid worker construction possible
                        if (typeof workerUrl === 'undefined' && typeof workerFactory === 'undefined') throw new Error("Cannot construct an ELK without both 'workerUrl' and 'workerFactory'.");
                        var factory = workerFactory;
                        if (typeof workerUrl !== 'undefined' && typeof workerFactory === 'undefined') // use default Web Worker
                        factory = function factory(url) {
                            return new Worker(url);
                        };
                        // create the worker
                        var worker = factory(workerUrl);
                        if (typeof worker.postMessage !== 'function') throw new TypeError("Created worker does not provide the required 'postMessage' function.");
                        // wrap the worker to return promises
                        this.worker = new PromisedWorker(worker);
                        // initially register algorithms
                        this.worker.postMessage({
                            cmd: 'register',
                            algorithms: algorithms
                        }).then(function(r) {
                            return _this.initialized = true;
                        })["catch"](console.err);
                    }
                    return _createClass(ELK, [
                        {
                            key: "layout",
                            value: function layout(graph) {
                                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$layoutOptions = _ref2.layoutOptions, layoutOptions = _ref2$layoutOptions === void 0 ? this.defaultLayoutOptions : _ref2$layoutOptions, _ref2$logging = _ref2.logging, logging = _ref2$logging === void 0 ? false : _ref2$logging, _ref2$measureExecutio = _ref2.measureExecutionTime, measureExecutionTime = _ref2$measureExecutio === void 0 ? false : _ref2$measureExecutio;
                                if (!graph) return Promise.reject(new Error("Missing mandatory parameter 'graph'."));
                                return this.worker.postMessage({
                                    cmd: 'layout',
                                    graph: graph,
                                    layoutOptions: layoutOptions,
                                    options: {
                                        logging: logging,
                                        measureExecutionTime: measureExecutionTime
                                    }
                                });
                            }
                        },
                        {
                            key: "knownLayoutAlgorithms",
                            value: function knownLayoutAlgorithms() {
                                return this.worker.postMessage({
                                    cmd: 'algorithms'
                                });
                            }
                        },
                        {
                            key: "knownLayoutOptions",
                            value: function knownLayoutOptions() {
                                return this.worker.postMessage({
                                    cmd: 'options'
                                });
                            }
                        },
                        {
                            key: "knownLayoutCategories",
                            value: function knownLayoutCategories() {
                                return this.worker.postMessage({
                                    cmd: 'categories'
                                });
                            }
                        },
                        {
                            key: "terminateWorker",
                            value: function terminateWorker() {
                                if (this.worker) this.worker.terminate();
                            }
                        }
                    ]);
                }();
                var PromisedWorker = /*#__PURE__*/ function() {
                    function PromisedWorker(worker) {
                        var _this2 = this;
                        _classCallCheck(this, PromisedWorker);
                        if (worker === undefined) throw new Error("Missing mandatory parameter 'worker'.");
                        this.resolvers = {};
                        this.worker = worker;
                        this.worker.onmessage = function(answer) {
                            // why is this necessary?
                            setTimeout(function() {
                                _this2.receive(_this2, answer);
                            }, 0);
                        };
                    }
                    return _createClass(PromisedWorker, [
                        {
                            key: "postMessage",
                            value: function postMessage(msg) {
                                var id = this.id || 0;
                                this.id = id + 1;
                                msg.id = id;
                                var self = this;
                                return new Promise(function(resolve, reject) {
                                    // prepare the resolver
                                    self.resolvers[id] = function(err, res) {
                                        if (err) {
                                            self.convertGwtStyleError(err);
                                            reject(err);
                                        } else resolve(res);
                                    };
                                    // post the message
                                    self.worker.postMessage(msg);
                                });
                            }
                        },
                        {
                            key: "receive",
                            value: function receive(self, answer) {
                                var json = answer.data;
                                var resolver = self.resolvers[json.id];
                                if (resolver) {
                                    delete self.resolvers[json.id];
                                    if (json.error) resolver(json.error);
                                    else resolver(null, json.data);
                                }
                            }
                        },
                        {
                            key: "terminate",
                            value: function terminate() {
                                if (this.worker) this.worker.terminate();
                            }
                        },
                        {
                            key: "convertGwtStyleError",
                            value: function convertGwtStyleError(err) {
                                if (!err) return;
                                // Somewhat flatten the way GWT stores nested exception(s)
                                var javaException = err['__java$exception'];
                                if (javaException) {
                                    // Note that the property name of the nested exception is different
                                    // in the non-minified ('cause') and the minified (not deterministic) version.
                                    // Hence, the version below only works for the non-minified version.
                                    // However, as the minified stack trace is not of much use anyway, one
                                    // should switch the used version for debugging in such a case.
                                    if (javaException.cause && javaException.cause.backingJsObject) {
                                        err.cause = javaException.cause.backingJsObject;
                                        this.convertGwtStyleError(err.cause);
                                    }
                                    delete err['__java$exception'];
                                }
                            }
                        }
                    ]);
                }();
            },
            {}
        ],
        2: [
            function(require, module1, exports) {
                "use strict";
                /*******************************************************************************
 * Copyright (c) 2021 Kiel University and others.
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 * 
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = require('./elk-api.js')["default"];
                Object.defineProperty(module1.exports, "__esModule", {
                    value: true
                });
                module1.exports = ELK;
                ELK["default"] = ELK;
            },
            {
                "./elk-api.js": 1
            }
        ]
    }, {}, [
        2
    ])(2);
});

},{}],"e833c":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = typeof Worker !== 'undefined' ? Worker : undefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"97i8b":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
// --------------    FAKE ELEMENTS GWT ASSUMES EXIST   -------------- 
var $wnd;
if (typeof window !== 'undefined') $wnd = window;
else if (typeof global !== 'undefined') $wnd = global // nodejs
;
else if (typeof self !== 'undefined') $wnd = self // web worker
;
var $moduleName, $moduleBase;
// --------------    WORKAROUND STRICT MODE, SEE #127    -------------- 
var g, i, o;
// --------------    GENERATED CODE    -------------- 
function nb() {}
function xb() {}
function Fd() {}
function fh() {}
function fx() {}
function nx() {}
function ox() {}
function hq() {}
function Jq() {}
function er() {}
function eA() {}
function lA() {}
function UA() {}
function XA() {}
function XB() {}
function bB() {}
function Ss() {}
function Vw() {}
function Vz() {}
function Ey() {}
function bdb() {}
function fdb() {}
function Zcb() {}
function _mb() {}
function _nb() {}
function Anb() {}
function Inb() {}
function Tnb() {}
function cqb() {}
function lqb() {}
function qqb() {}
function Eqb() {}
function asb() {}
function gub() {}
function lub() {}
function nub() {}
function Owb() {}
function uyb() {}
function Bzb() {}
function Jzb() {}
function JCb() {}
function ECb() {}
function HCb() {}
function LCb() {}
function fAb() {}
function tAb() {}
function vAb() {}
function xAb() {}
function zAb() {}
function BAb() {}
function FAb() {}
function fDb() {}
function EDb() {}
function IDb() {}
function wEb() {}
function zEb() {}
function XEb() {}
function nFb() {}
function sFb() {}
function wFb() {}
function BFb() {}
function BIb() {}
function vIb() {}
function xIb() {}
function zIb() {}
function QIb() {}
function UIb() {}
function MGb() {}
function VJb() {}
function XJb() {}
function ZJb() {}
function ZKb() {}
function hKb() {}
function XKb() {}
function lLb() {}
function pLb() {}
function QLb() {}
function lMb() {}
function qMb() {}
function uMb() {}
function CMb() {}
function EMb() {}
function $Mb() {}
function MOb() {}
function rPb() {}
function wPb() {}
function rQb() {}
function PQb() {}
function PRb() {}
function fRb() {}
function iRb() {}
function lRb() {}
function vRb() {}
function fSb() {}
function kSb() {}
function aTb() {}
function hTb() {}
function lTb() {}
function pTb() {}
function tTb() {}
function xTb() {}
function tUb() {}
function UUb() {}
function dVb() {}
function hVb() {}
function lVb() {}
function vVb() {}
function fXb() {}
function jXb() {}
function JYb() {}
function DZb() {}
function IZb() {}
function MZb() {}
function QZb() {}
function UZb() {}
function YZb() {}
function A$b() {}
function C$b() {}
function I$b() {}
function M$b() {}
function Q$b() {}
function t_b() {}
function v_b() {}
function x_b() {}
function C_b() {}
function H_b() {}
function K_b() {}
function S_b() {}
function W_b() {}
function Z_b() {}
function __b() {}
function b0b() {}
function n0b() {}
function r0b() {}
function v0b() {}
function z0b() {}
function O0b() {}
function T0b() {}
function V0b() {}
function X0b() {}
function Z0b() {}
function _0b() {}
function m1b() {}
function o1b() {}
function q1b() {}
function s1b() {}
function u1b() {}
function y1b() {}
function j2b() {}
function r2b() {}
function u2b() {}
function A2b() {}
function O2b() {}
function R2b() {}
function W2b() {}
function a3b() {}
function m3b() {}
function n3b() {}
function q3b() {}
function y3b() {}
function B3b() {}
function D3b() {}
function F3b() {}
function J3b() {}
function M3b() {}
function P3b() {}
function U3b() {}
function $3b() {}
function $5b() {}
function F5b() {}
function L5b() {}
function N5b() {}
function P5b() {}
function e4b() {}
function f6b() {}
function h6b() {}
function L6b() {}
function N6b() {}
function T6b() {}
function Y6b() {}
function k7b() {}
function s7b() {}
function Q7b() {}
function T7b() {}
function X7b() {}
function r8b() {}
function w8b() {}
function A8b() {}
function O8b() {}
function W8b() {}
function Z8b() {}
function d9b() {}
function g9b() {}
function l9b() {}
function q9b() {}
function s9b() {}
function u9b() {}
function w9b() {}
function y9b() {}
function R9b() {}
function T9b() {}
function V9b() {}
function Z9b() {}
function bac() {}
function hac() {}
function kac() {}
function qac() {}
function sac() {}
function uac() {}
function wac() {}
function Aac() {}
function Fac() {}
function Iac() {}
function Kac() {}
function Mac() {}
function Oac() {}
function Qac() {}
function Uac() {}
function _ac() {}
function bbc() {}
function dbc() {}
function fbc() {}
function mbc() {}
function obc() {}
function qbc() {}
function sbc() {}
function xbc() {}
function Bbc() {}
function Dbc() {}
function Fbc() {}
function Jbc() {}
function Mbc() {}
function Sbc() {}
function Scc() {}
function ecc() {}
function mcc() {}
function qcc() {}
function scc() {}
function ycc() {}
function Ccc() {}
function Gcc() {}
function Icc() {}
function Occ() {}
function Ucc() {}
function $cc() {}
function cdc() {}
function edc() {}
function udc() {}
function _dc() {}
function bec() {}
function dec() {}
function fec() {}
function hec() {}
function jec() {}
function lec() {}
function tec() {}
function vec() {}
function Bec() {}
function Dec() {}
function Fec() {}
function Hec() {}
function Lec() {}
function Nec() {}
function Vec() {}
function Xec() {}
function Zec() {}
function gfc() {}
function gic() {}
function cic() {}
function eic() {}
function iic() {}
function kic() {}
function mic() {}
function Jic() {}
function Lic() {}
function Nic() {}
function Pic() {}
function Pgc() {}
function Tgc() {}
function Tic() {}
function Xic() {}
function _ic() {}
function Ohc() {}
function Qhc() {}
function Shc() {}
function Uhc() {}
function $hc() {}
function jjc() {}
function njc() {}
function Cjc() {}
function Ijc() {}
function Zjc() {}
function bkc() {}
function dkc() {}
function pkc() {}
function zkc() {}
function Lkc() {}
function Nkc() {}
function Pkc() {}
function Plc() {}
function hlc() {}
function jlc() {}
function rlc() {}
function Nlc() {}
function Rlc() {}
function Wlc() {}
function Ylc() {}
function kmc() {}
function mmc() {}
function omc() {}
function umc() {}
function xmc() {}
function Cmc() {}
function Fwc() {}
function wAc() {}
function dBc() {}
function jBc() {}
function qCc() {}
function SDc() {}
function $Ec() {}
function iFc() {}
function kFc() {}
function oFc() {}
function hHc() {}
function LIc() {}
function PIc() {}
function ZIc() {}
function _Ic() {}
function bJc() {}
function fJc() {}
function lJc() {}
function pJc() {}
function rJc() {}
function tJc() {}
function vJc() {}
function zJc() {}
function DJc() {}
function IJc() {}
function KJc() {}
function QJc() {}
function SJc() {}
function WJc() {}
function YJc() {}
function aKc() {}
function cKc() {}
function eKc() {}
function gKc() {}
function VKc() {}
function kLc() {}
function KLc() {}
function KMc() {}
function sMc() {}
function AMc() {}
function CMc() {}
function EMc() {}
function GMc() {}
function IMc() {}
function FNc() {}
function LNc() {}
function NNc() {}
function PNc() {}
function $Nc() {}
function aOc() {}
function mPc() {}
function oPc() {}
function CPc() {}
function LPc() {}
function NPc() {}
function NQc() {}
function xQc() {}
function AQc() {}
function DQc() {}
function TQc() {}
function XQc() {}
function tRc() {}
function NRc() {}
function RRc() {}
function VRc() {}
function bSc() {}
function pSc() {}
function uSc() {}
function CSc() {}
function GSc() {}
function ISc() {}
function KSc() {}
function MSc() {}
function fTc() {}
function jTc() {}
function lTc() {}
function sTc() {}
function wTc() {}
function yTc() {}
function DTc() {}
function JTc() {}
function oVc() {}
function oXc() {}
function aXc() {}
function eXc() {}
function gXc() {}
function kXc() {}
function qXc() {}
function uXc() {}
function yXc() {}
function AXc() {}
function GXc() {}
function KXc() {}
function OXc() {}
function UXc() {}
function YXc() {}
function dWc() {}
function fWc() {}
function hWc() {}
function nWc() {}
function rWc() {}
function aYc() {}
function eYc() {}
function oYc() {}
function sYc() {}
function _Yc() {}
function cZc() {}
function DZc() {}
function IZc() {}
function LZc() {}
function NZc() {}
function PZc() {}
function TZc() {}
function XZc() {}
function f_c() {}
function G_c() {}
function J_c() {}
function M_c() {}
function Q_c() {}
function Y_c() {}
function s0c() {}
function v0c() {}
function L0c() {}
function O0c() {}
function R0c() {}
function W0c() {}
function o2c() {}
function w2c() {}
function y2c() {}
function D2c() {}
function G2c() {}
function J2c() {}
function e3c() {}
function k3c() {}
function D3c() {}
function H3c() {}
function M3c() {}
function e5c() {}
function H6c() {}
function l7c() {}
function K7c() {}
function K8c() {}
function g8c() {}
function o8c() {}
function F8c() {}
function I8c() {}
function W8c() {}
function m9c() {}
function q9c() {}
function x9c() {}
function V9c() {}
function X9c() {}
function Xad() {}
function pad() {}
function sad() {}
function Ead() {}
function Wad() {}
function Zad() {}
function _ad() {}
function bbd() {}
function dbd() {}
function fbd() {}
function hbd() {}
function jbd() {}
function lbd() {}
function nbd() {}
function pbd() {}
function rbd() {}
function tbd() {}
function vbd() {}
function xbd() {}
function zbd() {}
function Bbd() {}
function Dbd() {}
function Fbd() {}
function Hbd() {}
function fcd() {}
function yed() {}
function ymd() {}
function umd() {}
function Cmd() {}
function Gmd() {}
function Kmd() {}
function Kod() {}
function hod() {}
function $hd() {}
function ikd() {}
function Tld() {}
function Tnd() {}
function tnd() {}
function Lnd() {}
function Nnd() {}
function Ynd() {}
function Cpd() {}
function Ctd() {}
function Vtd() {}
function Bsd() {}
function tud() {}
function mvd() {}
function Lwd() {}
function Dxd() {}
function dyd() {}
function vDd() {}
function $Dd() {}
function gEd() {}
function EGd() {}
function ELd() {}
function XLd() {}
function AKd() {}
function hOd() {}
function uOd() {}
function FPd() {}
function oQd() {}
function KQd() {}
function pWd() {}
function sWd() {}
function vWd() {}
function DWd() {}
function QWd() {}
function TWd() {}
function AYd() {}
function e1d() {}
function Q1d() {}
function w3d() {}
function z3d() {}
function C3d() {}
function F3d() {}
function I3d() {}
function L3d() {}
function O3d() {}
function R3d() {}
function U3d() {}
function q5d() {}
function u5d() {}
function f6d() {}
function x6d() {}
function z6d() {}
function C6d() {}
function F6d() {}
function I6d() {}
function L6d() {}
function O6d() {}
function R6d() {}
function U6d() {}
function X6d() {}
function $6d() {}
function b7d() {}
function e7d() {}
function h7d() {}
function k7d() {}
function n7d() {}
function q7d() {}
function t7d() {}
function w7d() {}
function z7d() {}
function C7d() {}
function F7d() {}
function I7d() {}
function L7d() {}
function O7d() {}
function R7d() {}
function U7d() {}
function X7d() {}
function $7d() {}
function b8d() {}
function e8d() {}
function h8d() {}
function k8d() {}
function n8d() {}
function q8d() {}
function t8d() {}
function w8d() {}
function z8d() {}
function C8d() {}
function F8d() {}
function I8d() {}
function L8d() {}
function O8d() {}
function R8d() {}
function aee() {}
function Mfe() {}
function Mie() {}
function Zie() {}
function _ie() {}
function The() {}
function cje() {}
function fje() {}
function ije() {}
function lje() {}
function oje() {}
function rje() {}
function uje() {}
function xje() {}
function Aje() {}
function Dje() {}
function Gje() {}
function Jje() {}
function Mje() {}
function Pje() {}
function Sje() {}
function Vje() {}
function Yje() {}
function _je() {}
function cke() {}
function fke() {}
function ike() {}
function lke() {}
function oke() {}
function rke() {}
function uke() {}
function xke() {}
function Ake() {}
function Dke() {}
function Gke() {}
function Jke() {}
function Mke() {}
function Pke() {}
function Ske() {}
function Vke() {}
function Yke() {}
function _ke() {}
function cle() {}
function fle() {}
function ile() {}
function lle() {}
function ole() {}
function rle() {}
function ule() {}
function xle() {}
function Ale() {}
function Dle() {}
function Gle() {}
function Jle() {}
function Mle() {}
function Ple() {}
function mme() {}
function Npe() {}
function Ype() {}
function KXb(a) {}
function c_d(a) {}
function xl() {
    wb();
}
function ZNb() {
    YNb();
}
function Z$b() {
    T$b();
}
function KOb() {
    IOb();
}
function _Ob() {
    $Ob();
}
function pPb() {
    nPb();
}
function L0b() {
    E0b();
}
function L9b() {
    G9b();
}
function k3b() {
    e3b();
}
function Y5b() {
    U5b();
}
function C6b() {
    k6b();
}
function C7b() {
    v7b();
}
function Ahc() {
    jhc();
}
function mAc() {
    jAc();
}
function fAc() {
    cAc();
}
function sAc() {
    qAc();
}
function _Ac() {
    VAc();
}
function Xjc() {
    Ljc();
}
function Ptc() {
    Otc();
}
function Dwc() {
    Bwc();
}
function Qzc() {
    Nzc();
}
function sBc() {
    oBc();
}
function ABc() {
    wBc();
}
function LBc() {
    FBc();
}
function $Bc() {
    UBc();
}
function YVc() {
    UVc();
}
function mVc() {
    kVc();
}
function QVc() {
    KVc();
}
function dEc() {
    _Dc();
}
function d_c() {
    b_c();
}
function IFc() {
    GFc();
}
function H$c() {
    G$c();
}
function GHc() {
    DHc();
}
function WHc() {
    MHc();
}
function lKc() {
    jKc();
}
function ZLc() {
    WLc();
}
function FUc() {
    EUc();
}
function MWc() {
    EWc();
}
function AWc() {
    uWc();
}
function J1c() {
    I1c();
}
function m2c() {
    k2c();
}
function F6c() {
    D6c();
}
function _6c() {
    $6c();
}
function j7c() {
    h7c();
}
function Q9c() {
    P9c();
}
function wed() {
    ued();
}
function Mgd() {
    Lgd();
}
function Yhd() {
    Whd();
}
function gkd() {
    ekd();
}
function avd() {
    Uud();
}
function aUd() {
    GTd();
}
function APd() {
    mPd();
}
function Bfe() {
    Mpe();
}
function Mwb(a) {
    tDb(a);
}
function Yb(a) {
    this.a = a;
}
function cc(a) {
    this.a = a;
}
function bf(a) {
    this.a = a;
}
function hf(a) {
    this.a = a;
}
function hh(a) {
    this.a = a;
}
function rh(a) {
    this.a = a;
}
function zh(a) {
    this.a = a;
}
function Vh(a) {
    this.a = a;
}
function Bi(a) {
    this.a = a;
}
function Ii(a) {
    this.a = a;
}
function ij(a) {
    this.a = a;
}
function oj(a) {
    this.a = a;
}
function Jj(a) {
    this.a = a;
}
function yj(a) {
    this.c = a;
}
function Gk(a) {
    this.a = a;
}
function Ok(a) {
    this.a = a;
}
function Tn(a) {
    this.a = a;
}
function ip(a) {
    this.a = a;
}
function Hp(a) {
    this.a = a;
}
function eq(a) {
    this.a = a;
}
function Aq(a) {
    this.a = a;
}
function Rq(a) {
    this.a = a;
}
function Kr(a) {
    this.a = a;
}
function Wr(a) {
    this.b = a;
}
function ru(a) {
    this.a = a;
}
function rw(a) {
    this.a = a;
}
function cw(a) {
    this.a = a;
}
function hw(a) {
    this.a = a;
}
function Ew(a) {
    this.a = a;
}
function Jw(a) {
    this.a = a;
}
function Ow(a) {
    this.a = a;
}
function ax(a) {
    this.a = a;
}
function bx(a) {
    this.a = a;
}
function hx(a) {
    this.a = a;
}
function hy(a) {
    this.a = a;
}
function Gy(a) {
    this.a = a;
}
function FB(a) {
    this.a = a;
}
function PB(a) {
    this.a = a;
}
function _B(a) {
    this.a = a;
}
function nC(a) {
    this.a = a;
}
function EB() {
    this.a = [];
}
function GCb(a, b) {
    a.a = b;
}
function OXb(a, b) {
    a.a = b;
}
function PXb(a, b) {
    a.b = b;
}
function QXb(a, b) {
    a.c = b;
}
function jNb(a, b) {
    a.c = b;
}
function kNb(a, b) {
    a.d = b;
}
function RXb(a, b) {
    a.d = b;
}
function _Gb(a, b) {
    a.j = b;
}
function rYb(a, b) {
    a.k = b;
}
function $Yb(a, b) {
    a.c = b;
}
function qgc(a, b) {
    a.c = b;
}
function pgc(a, b) {
    a.a = b;
}
function GDc(a, b) {
    a.a = b;
}
function HDc(a, b) {
    a.f = b;
}
function QMc(a, b) {
    a.a = b;
}
function RMc(a, b) {
    a.b = b;
}
function SMc(a, b) {
    a.d = b;
}
function TMc(a, b) {
    a.i = b;
}
function UMc(a, b) {
    a.o = b;
}
function VMc(a, b) {
    a.r = b;
}
function BOc(a, b) {
    a.a = b;
}
function COc(a, b) {
    a.b = b;
}
function tZc(a, b) {
    a.e = b;
}
function uZc(a, b) {
    a.f = b;
}
function vZc(a, b) {
    a.g = b;
}
function m4c(a, b) {
    a.e = b;
}
function n4c(a, b) {
    a.f = b;
}
function A4c(a, b) {
    a.f = b;
}
function vod(a, b) {
    a.a = b;
}
function wod(a, b) {
    a.b = b;
}
function WRd(a, b) {
    a.n = b;
}
function tae(a, b) {
    a.a = b;
}
function Cae(a, b) {
    a.a = b;
}
function Yae(a, b) {
    a.a = b;
}
function uae(a, b) {
    a.c = b;
}
function Dae(a, b) {
    a.c = b;
}
function Zae(a, b) {
    a.c = b;
}
function Eae(a, b) {
    a.d = b;
}
function $ae(a, b) {
    a.d = b;
}
function Fae(a, b) {
    a.e = b;
}
function _ae(a, b) {
    a.e = b;
}
function Gae(a, b) {
    a.g = b;
}
function abe(a, b) {
    a.f = b;
}
function bbe(a, b) {
    a.j = b;
}
function Rhe(a, b) {
    a.a = b;
}
function $he(a, b) {
    a.a = b;
}
function She(a, b) {
    a.b = b;
}
function Ffc(a) {
    a.b = a.a;
}
function Jg(a) {
    a.c = a.d.d;
}
function Jdb(a) {
    this.a = a;
}
function idb(a) {
    this.a = a;
}
function Udb(a) {
    this.a = a;
}
function Ujb(a) {
    this.a = a;
}
function djb(a) {
    this.a = a;
}
function Ojb(a) {
    this.a = a;
}
function Ofb(a) {
    this.a = a;
}
function qfb(a) {
    this.a = a;
}
function Keb(a) {
    this.a = a;
}
function Yeb(a) {
    this.a = a;
}
function Zjb(a) {
    this.a = a;
}
function ujb(a) {
    this.d = a;
}
function ckb(a) {
    this.a = a;
}
function Lkb(a) {
    this.a = a;
}
function Skb(a) {
    this.a = a;
}
function Spb(a) {
    this.a = a;
}
function Npb(a) {
    this.a = a;
}
function dob(a) {
    this.a = a;
}
function oob(a) {
    this.b = a;
}
function Fob(a) {
    this.b = a;
}
function Gkb(a) {
    this.b = a;
}
function rmb(a) {
    this.c = a;
}
function kpb(a) {
    this.c = a;
}
function ktb(a) {
    this.a = a;
}
function uqb(a) {
    this.a = a;
}
function Yqb(a) {
    this.a = a;
}
function Trb(a) {
    this.a = a;
}
function Qvb(a) {
    this.a = a;
}
function Svb(a) {
    this.a = a;
}
function Uvb(a) {
    this.a = a;
}
function Wvb(a) {
    this.a = a;
}
function nvb(a) {
    this.c = a;
}
function nzb(a) {
    this.a = a;
}
function xzb(a) {
    this.a = a;
}
function zzb(a) {
    this.a = a;
}
function Dzb(a) {
    this.a = a;
}
function aBb(a) {
    this.a = a;
}
function cBb(a) {
    this.a = a;
}
function eBb(a) {
    this.a = a;
}
function tBb(a) {
    this.a = a;
}
function ZBb(a) {
    this.a = a;
}
function _Bb(a) {
    this.a = a;
}
function dCb(a) {
    this.a = a;
}
function NCb(a) {
    this.a = a;
}
function RCb(a) {
    this.a = a;
}
function RDb(a) {
    this.a = a;
}
function GDb(a) {
    this.a = a;
}
function MDb(a) {
    this.a = a;
}
function VEb(a) {
    this.a = a;
}
function SGb(a) {
    this.a = a;
}
function $Gb(a) {
    this.a = a;
}
function vKb(a) {
    this.a = a;
}
function ELb(a) {
    this.a = a;
}
function SLb(a) {
    this.a = a;
}
function QPb(a) {
    this.a = a;
}
function cQb(a) {
    this.a = a;
}
function eQb(a) {
    this.a = a;
}
function pQb(a) {
    this.a = a;
}
function tQb(a) {
    this.a = a;
}
function WVb(a) {
    this.a = a;
}
function BWb(a) {
    this.a = a;
}
function NWb(a) {
    this.e = a;
}
function dZb(a) {
    this.a = a;
}
function gZb(a) {
    this.a = a;
}
function lZb(a) {
    this.a = a;
}
function oZb(a) {
    this.a = a;
}
function E$b(a) {
    this.a = a;
}
function G$b(a) {
    this.a = a;
}
function K$b(a) {
    this.a = a;
}
function O$b(a) {
    this.a = a;
}
function a_b(a) {
    this.a = a;
}
function c_b(a) {
    this.a = a;
}
function e_b(a) {
    this.a = a;
}
function g_b(a) {
    this.a = a;
}
function x0b(a) {
    this.a = a;
}
function B0b(a) {
    this.a = a;
}
function w1b(a) {
    this.a = a;
}
function X1b(a) {
    this.a = a;
}
function b4b(a) {
    this.a = a;
}
function h4b(a) {
    this.a = a;
}
function k4b(a) {
    this.a = a;
}
function n4b(a) {
    this.a = a;
}
function P6b(a) {
    this.a = a;
}
function R6b(a) {
    this.a = a;
}
function D8b(a) {
    this.a = a;
}
function G8b(a) {
    this.a = a;
}
function i9b(a) {
    this.a = a;
}
function icc(a) {
    this.a = a;
}
function ucc(a) {
    this.a = a;
}
function Ecc(a) {
    this.a = a;
}
function yac(a) {
    this.a = a;
}
function Sac(a) {
    this.a = a;
}
function Wac(a) {
    this.a = a;
}
function Ubc(a) {
    this.a = a;
}
function rdc(a) {
    this.a = a;
}
function wdc(a) {
    this.a = a;
}
function nec(a) {
    this.a = a;
}
function pec(a) {
    this.a = a;
}
function rec(a) {
    this.a = a;
}
function xec(a) {
    this.a = a;
}
function zec(a) {
    this.a = a;
}
function Jec(a) {
    this.a = a;
}
function Pec(a) {
    this.a = a;
}
function Rec(a) {
    this.a = a;
}
function _ec(a) {
    this.a = a;
}
function Whc(a) {
    this.a = a;
}
function Yhc(a) {
    this.a = a;
}
function Ric(a) {
    this.a = a;
}
function skc(a) {
    this.a = a;
}
function ukc(a) {
    this.a = a;
}
function qmc(a) {
    this.a = a;
}
function smc(a) {
    this.a = a;
}
function MAc(a) {
    this.a = a;
}
function QAc(a) {
    this.a = a;
}
function PBc(a) {
    this.a = a;
}
function MCc(a) {
    this.a = a;
}
function iDc(a) {
    this.a = a;
}
function EDc(a) {
    this.a = a;
}
function gDc(a) {
    this.c = a;
}
function Dlc(a) {
    this.b = a;
}
function hEc(a) {
    this.a = a;
}
function LEc(a) {
    this.a = a;
}
function NEc(a) {
    this.a = a;
}
function PEc(a) {
    this.a = a;
}
function BFc(a) {
    this.a = a;
}
function KGc(a) {
    this.a = a;
}
function OGc(a) {
    this.a = a;
}
function SGc(a) {
    this.a = a;
}
function WGc(a) {
    this.a = a;
}
function $Gc(a) {
    this.a = a;
}
function aHc(a) {
    this.a = a;
}
function dHc(a) {
    this.a = a;
}
function mHc(a) {
    this.a = a;
}
function dJc(a) {
    this.a = a;
}
function jJc(a) {
    this.a = a;
}
function nJc(a) {
    this.a = a;
}
function BJc(a) {
    this.a = a;
}
function FJc(a) {
    this.a = a;
}
function MJc(a) {
    this.a = a;
}
function UJc(a) {
    this.a = a;
}
function $Jc(a) {
    this.a = a;
}
function pLc(a) {
    this.a = a;
}
function ANc(a) {
    this.a = a;
}
function FQc(a) {
    this.a = a;
}
function HQc(a) {
    this.a = a;
}
function LQc(a) {
    this.a = a;
}
function RQc(a) {
    this.a = a;
}
function gRc(a) {
    this.a = a;
}
function jRc(a) {
    this.a = a;
}
function HRc(a) {
    this.a = a;
}
function ZRc(a) {
    this.a = a;
}
function _Rc(a) {
    this.a = a;
}
function dSc(a) {
    this.a = a;
}
function fSc(a) {
    this.a = a;
}
function hSc(a) {
    this.a = a;
}
function lSc(a) {
    this.a = a;
}
function lWc(a) {
    this.a = a;
}
function jWc(a) {
    this.a = a;
}
function SXc(a) {
    this.a = a;
}
function g5c(a) {
    this.a = a;
}
function i5c(a) {
    this.a = a;
}
function k5c(a) {
    this.a = a;
}
function m5c(a) {
    this.a = a;
}
function s5c(a) {
    this.a = a;
}
function N7c(a) {
    this.a = a;
}
function Z7c(a) {
    this.a = a;
}
function _7c(a) {
    this.a = a;
}
function o9c(a) {
    this.a = a;
}
function s9c(a) {
    this.a = a;
}
function Z9c(a) {
    this.a = a;
}
function Zld(a) {
    this.a = a;
}
function Imd(a) {
    this.a = a;
}
function Mmd(a) {
    this.a = a;
}
function Cnd(a) {
    this.a = a;
}
function Dod(a) {
    this.a = a;
}
function apd(a) {
    this.a = a;
}
function vpd(a) {
    this.f = a;
}
function Fzd(a) {
    this.a = a;
}
function Xzd(a) {
    this.a = a;
}
function Zzd(a) {
    this.a = a;
}
function _zd(a) {
    this.a = a;
}
function bAd(a) {
    this.a = a;
}
function dAd(a) {
    this.a = a;
}
function fAd(a) {
    this.a = a;
}
function hAd(a) {
    this.a = a;
}
function jAd(a) {
    this.a = a;
}
function lAd(a) {
    this.a = a;
}
function tAd(a) {
    this.a = a;
}
function xAd(a) {
    this.a = a;
}
function zAd(a) {
    this.a = a;
}
function BAd(a) {
    this.a = a;
}
function DAd(a) {
    this.a = a;
}
function FAd(a) {
    this.a = a;
}
function HAd(a) {
    this.a = a;
}
function PAd(a) {
    this.a = a;
}
function VAd(a) {
    this.a = a;
}
function XAd(a) {
    this.a = a;
}
function ZAd(a) {
    this.a = a;
}
function _Ad(a) {
    this.a = a;
}
function bBd(a) {
    this.a = a;
}
function lBd(a) {
    this.a = a;
}
function nBd(a) {
    this.a = a;
}
function pBd(a) {
    this.a = a;
}
function rBd(a) {
    this.a = a;
}
function VBd(a) {
    this.a = a;
}
function KBd(a) {
    this.b = a;
}
function nCd(a) {
    this.a = a;
}
function uKd(a) {
    this.a = a;
}
function CKd(a) {
    this.a = a;
}
function IKd(a) {
    this.a = a;
}
function OKd(a) {
    this.a = a;
}
function eLd(a) {
    this.a = a;
}
function RVd(a) {
    this.a = a;
}
function zWd(a) {
    this.a = a;
}
function xYd(a) {
    this.a = a;
}
function xZd(a) {
    this.a = a;
}
function G0d(a) {
    this.a = a;
}
function b5d(a) {
    this.a = a;
}
function K5d(a) {
    this.a = a;
}
function S5d(a) {
    this.a = a;
}
function jXd(a) {
    this.b = a;
}
function e2d(a) {
    this.c = a;
}
function O2d(a) {
    this.e = a;
}
function l9d(a) {
    this.d = a;
}
function s9d(a) {
    this.a = a;
}
function H9d(a) {
    this.a = a;
}
function Pee(a) {
    this.a = a;
}
function Woe(a) {
    this.a = a;
}
function poe(a) {
    this.e = a;
}
function Fnd() {
    this.a = 0;
}
function Ulb() {
    Glb(this);
}
function Irb() {
    Tib(this);
}
function bFb() {
    aFb(this);
}
function SXb() {
    KXb(this);
}
function NZd() {
    this.c = yZd;
}
function zlc(a, b) {
    a.b += b;
}
function nfe(a, b) {
    b.Wb(a);
}
function fC(a) {
    return a.a;
}
function tC(a) {
    return a.a;
}
function MC(a) {
    return a.a;
}
function LB(a) {
    return a.a;
}
function TB(a) {
    return a.a;
}
function scb(a) {
    return a.e;
}
function $B() {
    return null;
}
function EC() {
    return null;
}
function cdb() {
    jEd();
    lEd();
}
function BJb(a) {
    a.b.Mf(a.e);
}
function KTb(a) {
    a.b = new Pi;
}
function M1b(a, b) {
    a.b = b - a.b;
}
function J1b(a, b) {
    a.a = b - a.a;
}
function sic(a, b) {
    aZb(b, a);
}
function T_c(a, b) {
    b.gd(a.a);
}
function YCb(a, b) {
    a.push(b);
}
function aDb(a, b) {
    a.sort(b);
}
function pp(a, b, c) {
    a.Wd(c, b);
}
function Os(a, b) {
    a.e = b;
    b.b = a;
}
function fm(a) {
    Yl();
    this.a = a;
}
function tq(a) {
    Yl();
    this.a = a;
}
function Cq(a) {
    Yl();
    this.a = a;
}
function Tq(a) {
    qm();
    this.a = a;
}
function $z(a) {
    Zz();
    Yz.je(a);
}
function pz() {
    ez.call(this);
}
function pdb() {
    pz.call(this);
}
function ldb() {
    pz.call(this);
}
function tdb() {
    ez.call(this);
}
function yeb() {
    pz.call(this);
}
function Seb() {
    pz.call(this);
}
function Veb() {
    pz.call(this);
}
function Efb() {
    pz.call(this);
}
function ahb() {
    pz.call(this);
}
function yqb() {
    pz.call(this);
}
function Hqb() {
    pz.call(this);
}
function qub() {
    pz.call(this);
}
function X8c() {
    pz.call(this);
}
function kZd() {
    this.a = this;
}
function FYd() {
    this.Bb |= 256;
}
function FPb() {
    this.b = new At;
}
function nA() {
    nA = Zcb;
    new Irb;
}
function ndb() {
    ldb.call(this);
}
function Twb(a, b) {
    Ilb(a.a, b);
}
function uKb(a, b) {
    WHb(a.c, b);
}
function tLc(a, b) {
    Nrb(a.b, b);
}
function rKd(a, b) {
    rJd(a.a, b);
}
function sKd(a, b) {
    sJd(a.a, b);
}
function zUd(a, b) {
    Wpd(a.e, b);
}
function Xfe(a) {
    wbe(a.c, a.b);
}
function sj(a, b) {
    a.kc().Nb(b);
}
function _Cb(a, b) {
    a.length = b;
}
function Qrb() {
    this.a = new Irb;
}
function Ozb() {
    this.a = new Irb;
}
function lzb() {
    this.a = new Txb;
}
function Wwb() {
    this.a = new Ulb;
}
function NFb() {
    this.a = new Ulb;
}
function SFb() {
    this.a = new Ulb;
}
function IFb() {
    this.a = new BFb;
}
function rGb() {
    this.a = new PFb;
}
function iEb() {
    this.a = new eEb;
}
function pEb() {
    this.a = new jEb;
}
function SMb() {
    this.a = new CMb;
}
function vQb() {
    this.a = new _Pb;
}
function OSb() {
    this.a = new Ulb;
}
function OUb() {
    this.a = new Ulb;
}
function AUb() {
    this.a = new Ulb;
}
function TTb() {
    this.a = new Ulb;
}
function hLb() {
    this.d = new Ulb;
}
function IUb() {
    this.a = new Qrb;
}
function w$b() {
    this.a = new Irb;
}
function OVb() {
    this.b = new Irb;
}
function mBc() {
    this.b = new Ulb;
}
function aIc() {
    this.e = new Ulb;
}
function oac() {
    this.a = new Ahc;
}
function XKc() {
    this.d = new Ulb;
}
function Leb(a) {
    this.a = Qeb(a);
}
function LYb() {
    SXb.call(this);
}
function ZXb() {
    SXb.call(this);
}
function bYb() {
    ZXb.call(this);
}
function OYb() {
    LYb.call(this);
}
function txb() {
    Wwb.call(this);
}
function qHb() {
    aHb.call(this);
}
function XTb() {
    TTb.call(this);
}
function YIc() {
    Ulb.call(this);
}
function xLc() {
    wLc.call(this);
}
function ELc() {
    wLc.call(this);
}
function fOc() {
    dOc.call(this);
}
function kOc() {
    dOc.call(this);
}
function pOc() {
    dOc.call(this);
}
function W7c() {
    S7c.call(this);
}
function Rdd() {
    Mtb.call(this);
}
function cxd() {
    Ctd.call(this);
}
function rxd() {
    Ctd.call(this);
}
function gMd() {
    TLd.call(this);
}
function HMd() {
    TLd.call(this);
}
function fOd() {
    Irb.call(this);
}
function oOd() {
    Irb.call(this);
}
function zOd() {
    Irb.call(this);
}
function HSd() {
    aSd.call(this);
}
function DYd() {
    Qrb.call(this);
}
function VYd() {
    FYd.call(this);
}
function L_d() {
    yRd.call(this);
}
function h1d() {
    Irb.call(this);
}
function k1d() {
    yRd.call(this);
}
function G5d() {
    Irb.call(this);
}
function X5d() {
    Irb.call(this);
}
function Jhe() {
    FPd.call(this);
}
function aie() {
    Jhe.call(this);
}
function gie() {
    FPd.call(this);
}
function _me() {
    mme.call(this);
}
function dOc() {
    this.a = new Qrb;
}
function qTc() {
    this.a = new Irb;
}
function S7c() {
    this.a = new Irb;
}
function GTc() {
    this.a = new Ulb;
}
function b9c() {
    this.j = new Ulb;
}
function U_c() {
    this.a = new Y_c;
}
function E5c() {
    this.a = new D5c;
}
function wld() {
    this.a = new Mtb;
}
function TLd() {
    this.a = new XLd;
}
function wb() {
    wb = Zcb;
    vb = new xb;
}
function Uk() {
    Uk = Zcb;
    Tk = new Vk;
}
function il() {
    il = Zcb;
    hl = new jl;
}
function jl() {
    Ok.call(this, '');
}
function Vk() {
    Ok.call(this, '');
}
function Dd(a) {
    yd.call(this, a);
}
function Hd(a) {
    yd.call(this, a);
}
function vh(a) {
    rh.call(this, a);
}
function Yh(a) {
    Wc.call(this, a);
}
function Oi(a) {
    Wc.call(this, a);
}
function ui(a) {
    Yh.call(this, a);
}
function Op(a) {
    Yh.call(this, a);
}
function Fs(a) {
    Yh.call(this, a);
}
function Fp(a) {
    To.call(this, a);
}
function Mp(a) {
    To.call(this, a);
}
function _p(a) {
    co.call(this, a);
}
function Bv(a) {
    qv.call(this, a);
}
function Yv(a) {
    Pr.call(this, a);
}
function $v(a) {
    Pr.call(this, a);
}
function Xw(a) {
    Pr.call(this, a);
}
function Ix(a) {
    Cn.call(this, a);
}
function Jx(a) {
    Ix.call(this, a);
}
function qz(a) {
    fz.call(this, a);
}
function UB(a) {
    qz.call(this, a);
}
function mC() {
    nC.call(this, {});
}
function Cub(a) {
    yub();
    this.a = a;
}
function zxb(a) {
    a.b = null;
    a.c = 0;
}
function cz(a, b) {
    a.e = b;
    _y(a, b);
}
function XRb(a, b) {
    a.a = b;
    ZRb(a);
}
function nIb(a, b, c) {
    a.a[b.g] = c;
}
function hnd(a, b, c) {
    pnd(c, a, b);
}
function Gac(a, b) {
    ugc(b.i, a.n);
}
function Kwc(a, b) {
    Lwc(a).Ad(b);
}
function KNb(a, b) {
    return a * a / b;
}
function js(a, b) {
    return a.g - b.g;
}
function uw(a, b) {
    a.a.ec().Kc(b);
}
function BC(a) {
    return new _B(a);
}
function DC(a) {
    return new GC(a);
}
function sz() {
    sz = Zcb;
    rz = new nb;
}
function Sz() {
    Sz = Zcb;
    Rz = new Vz;
}
function SA() {
    SA = Zcb;
    RA = new UA;
}
function vs() {
    vs = Zcb;
    us = new ws;
}
function WB() {
    WB = Zcb;
    VB = new XB;
}
function IEc(a) {
    mEc();
    this.a = a;
}
function X8d(a) {
    hId();
    this.a = a;
}
function dpd(a) {
    Tod();
    this.f = a;
}
function fpd(a) {
    Tod();
    this.f = a;
}
function kdb(a) {
    qz.call(this, a);
}
function mdb(a) {
    qz.call(this, a);
}
function qdb(a) {
    qz.call(this, a);
}
function rdb(a) {
    fz.call(this, a);
}
function zeb(a) {
    qz.call(this, a);
}
function Teb(a) {
    qz.call(this, a);
}
function Web(a) {
    qz.call(this, a);
}
function Dfb(a) {
    qz.call(this, a);
}
function Ffb(a) {
    qz.call(this, a);
}
function bhb(a) {
    qz.call(this, a);
}
function dnb(a) {
    tDb(a);
    this.a = a;
}
function Emb(a) {
    Jmb(a, a.length);
}
function IRb(a) {
    CRb(a);
    return a;
}
function ydb(a) {
    return tDb(a), a;
}
function Beb(a) {
    return tDb(a), a;
}
function Deb(a) {
    return tDb(a), a;
}
function jgb(a) {
    return tDb(a), a;
}
function tgb(a) {
    return tDb(a), a;
}
function elb(a) {
    return a.b == a.c;
}
function Jxb(a) {
    return !!a && a.b;
}
function rIb(a) {
    return !!a && a.k;
}
function sIb(a) {
    return !!a && a.j;
}
function Y8c(a) {
    qz.call(this, a);
}
function Z8c(a) {
    qz.call(this, a);
}
function eyd(a) {
    qz.call(this, a);
}
function eme(a) {
    qz.call(this, a);
}
function fhe(a) {
    qz.call(this, a);
}
function pc(a) {
    qc.call(this, a, 0);
}
function Pi() {
    Qi.call(this, 12, 3);
}
function Gb() {
    this.a = OD(Qb(Lqe));
}
function xy(a) {
    Yl();
    this.a = Qb(a);
}
function Ps(a, b) {
    a._d(b);
    b.$d(a);
}
function PUb(a, b, c) {
    a.c.Cf(b, c);
}
function OC(a, b) {
    return oeb(a, b);
}
function Idb(a, b) {
    return a.a - b.a;
}
function Tdb(a, b) {
    return a.a - b.a;
}
function hC(b, a) {
    return a in b.a;
}
function Nfb(a, b) {
    return a.a - b.a;
}
function Mfb(a) {
    Teb.call(this, a);
}
function odb(a) {
    mdb.call(this, a);
}
function Hgb() {
    idb.call(this, '');
}
function Igb() {
    idb.call(this, '');
}
function Ugb() {
    idb.call(this, '');
}
function Vgb() {
    idb.call(this, '');
}
function Xgb(a) {
    mdb.call(this, a);
}
function Apb(a) {
    oob.call(this, a);
}
function Zpb(a) {
    Kob.call(this, a);
}
function Hpb(a) {
    Apb.call(this, a);
}
function tsb() {
    tsb = Zcb;
    ssb = vsb();
}
function Iz() {
    Iz = Zcb;
    Zz(), Yz;
}
function jc() {
    throw scb(new ahb);
}
function Fh() {
    throw scb(new ahb);
}
function Vi() {
    throw scb(new ahb);
}
function Vj() {
    throw scb(new ahb);
}
function Wj() {
    throw scb(new ahb);
}
function fn() {
    throw scb(new ahb);
}
function bDb(a, b) {
    return XC(a, b);
}
function Jub(a) {
    return a.a ? a.b : 0;
}
function Sub(a) {
    return a.a ? a.b : 0;
}
function SEb(a, b) {
    a.g = b;
    return a;
}
function PEb(a, b) {
    a.b = b;
    return a;
}
function QEb(a, b) {
    a.c = b;
    return a;
}
function REb(a, b) {
    a.f = b;
    return a;
}
function KGb(a, b) {
    a.f = b;
    return a;
}
function JGb(a, b) {
    a.a = b;
    return a;
}
function LGb(a, b) {
    a.k = b;
    return a;
}
function LRb(a, b) {
    a.e = b;
    return a;
}
function gLb(a, b) {
    a.e = b;
    return a;
}
function fLb(a, b) {
    a.a = b;
    return a;
}
function MRb(a, b) {
    a.f = b;
    return a;
}
function FHb(a, b) {
    a.b = new Fdd(b);
}
function ywb(a, b, c) {
    b.Ne(a.a[c]);
}
function twb(a, b, c) {
    b.Ad(a.a[c]);
}
function Zdc(a, b) {
    Adc();
    b.n.a += a;
}
function Bhc(a, b) {
    jhc();
    _Yb(b, a);
}
function ZHc(a, b) {
    return a.b - b.b;
}
function NMc(a, b) {
    return a.g - b.g;
}
function xPc(a, b) {
    return a.s - b.s;
}
function Ofc(a, b) {
    return a ? 0 : b - 1;
}
function tEc(a, b) {
    return a ? 0 : b - 1;
}
function sEc(a, b) {
    return a ? b - 1 : 0;
}
function k9c(a, b) {
    return b.pg(a);
}
function kad(a, b) {
    a.b = b;
    return a;
}
function jad(a, b) {
    a.a = b;
    return a;
}
function Bad(a, b) {
    a.a = b;
    return a;
}
function lad(a, b) {
    a.c = b;
    return a;
}
function Dad(a, b) {
    a.c = b;
    return a;
}
function mad(a, b) {
    a.d = b;
    return a;
}
function nad(a, b) {
    a.e = b;
    return a;
}
function oad(a, b) {
    a.f = b;
    return a;
}
function Cad(a, b) {
    a.b = b;
    return a;
}
function Ybd(a, b) {
    a.b = b;
    return a;
}
function Zbd(a, b) {
    a.c = b;
    return a;
}
function $bd(a, b) {
    a.d = b;
    return a;
}
function _bd(a, b) {
    a.e = b;
    return a;
}
function acd(a, b) {
    a.f = b;
    return a;
}
function bcd(a, b) {
    a.g = b;
    return a;
}
function ccd(a, b) {
    a.a = b;
    return a;
}
function dcd(a, b) {
    a.i = b;
    return a;
}
function ecd(a, b) {
    a.j = b;
    return a;
}
function tld(a, b) {
    a.j = b;
    return a;
}
function sld(a, b) {
    a.k = b;
    return a;
}
function sFc(a) {
    FCc.call(this, a);
}
function LFc(a) {
    FCc.call(this, a);
}
function Sdd(a) {
    Ntb.call(this, a);
}
function FGd(a) {
    wDd.call(this, a);
}
function _Kd(a) {
    VKd.call(this, a);
}
function bLd(a) {
    VKd.call(this, a);
}
function HXb() {
    IXb.call(this, '');
}
function Cdd() {
    this.a = 0;
    this.b = 0;
}
function DNc() {
    this.b = 0;
    this.a = 0;
}
function GSd(a, b) {
    a.b = 0;
    wRd(a, b);
}
function Qae(a, b) {
    a.c = b;
    a.b = true;
}
function r5c(a, b, c) {
    p5c(a.a, b, c);
}
function Oc(a, b) {
    return a.c._b(b);
}
function deb(a) {
    return a.e && a.e();
}
function Vd(a) {
    return !a ? null : a.d;
}
function An(a, b) {
    return Sv(a.b, b);
}
function Rv(a) {
    return !a ? null : a.g;
}
function Wv(a) {
    return !a ? null : a.i;
}
function eeb(a) {
    ceb(a);
    return a.o;
}
function Psb() {
    throw scb(new ahb);
}
function hhe() {
    hhe = Zcb;
    ghe = Qie();
}
function jhe() {
    jhe = Zcb;
    ihe = Xie();
}
function jEd() {
    jEd = Zcb;
    iEd = Nad();
}
function Hpd() {
    Hpd = Zcb;
    Gpd = qvd();
}
function Jpd() {
    Jpd = Zcb;
    Ipd = Ewd();
}
function EOd() {
    EOd = Zcb;
    DOd = j6d();
}
function hob() {
    throw scb(new ahb);
}
function iob() {
    throw scb(new ahb);
}
function job() {
    throw scb(new ahb);
}
function mob() {
    throw scb(new ahb);
}
function Eob() {
    throw scb(new ahb);
}
function Rrb(a) {
    this.a = new Jrb(a);
}
function shb(a) {
    khb();
    mhb(this, a);
}
function mzb(a) {
    this.a = new Uxb(a);
}
function Yvb(a, b) {
    while(a.Pe(b));
}
function Pvb(a, b) {
    while(a.zd(b));
}
function Bgb(a, b) {
    a.a += b;
    return a;
}
function Cgb(a, b) {
    a.a += b;
    return a;
}
function Fgb(a, b) {
    a.a += b;
    return a;
}
function Lgb(a, b) {
    a.a += b;
    return a;
}
function PBb(a) {
    KAb(a);
    return a.a;
}
function Ttb(a) {
    return a.b != a.d.c;
}
function xD(a) {
    return a.l | a.m << 22;
}
function DGc(a, b) {
    return a.d[b.p];
}
function H8c(a, b) {
    return C8c(a, b);
}
function ZCb(a, b, c) {
    a.splice(b, c);
}
function YHb(a) {
    a.c ? XHb(a) : ZHb(a);
}
function WYc(a) {
    this.a = 0;
    this.b = a;
}
function KYc() {
    this.a = new j9c(g_);
}
function o0c() {
    this.a = new j9c(J_);
}
function o5c() {
    this.b = new j9c(y0);
}
function D5c() {
    this.b = new j9c(y0);
}
function WPc() {
    this.b = new j9c(vZ);
}
function JLd() {
    throw scb(new ahb);
}
function KLd() {
    throw scb(new ahb);
}
function LLd() {
    throw scb(new ahb);
}
function MLd() {
    throw scb(new ahb);
}
function NLd() {
    throw scb(new ahb);
}
function OLd() {
    throw scb(new ahb);
}
function PLd() {
    throw scb(new ahb);
}
function QLd() {
    throw scb(new ahb);
}
function RLd() {
    throw scb(new ahb);
}
function SLd() {
    throw scb(new ahb);
}
function Vpe() {
    throw scb(new qub);
}
function Wpe() {
    throw scb(new qub);
}
function Jpe(a) {
    this.a = new Yoe(a);
}
function pf(a) {
    this.b = JD(Qb(a), 91);
}
function Ff(a, b) {
    this.b = a;
    this.c = b;
}
function me(a, b) {
    this.e = a;
    this.d = b;
}
function Wc(a) {
    Lb(a.dc());
    this.c = a;
}
function Lj(a, b) {
    this.a = a;
    this.b = b;
}
function fk(a, b) {
    this.a = a;
    this.b = b;
}
function lk(a, b) {
    this.a = a;
    this.b = b;
}
function nk(a, b) {
    this.a = a;
    this.b = b;
}
function vk(a, b) {
    this.a = a;
    this.b = b;
}
function xk(a, b) {
    this.a = a;
    this.b = b;
}
function Ik(a, b) {
    this.a = a;
    this.b = b;
}
function $o(a, b) {
    this.b = a;
    this.a = b;
}
function cp(a, b) {
    this.g = a;
    this.i = b;
}
function yp(a, b) {
    this.b = a;
    this.a = b;
}
function cg(a, b) {
    xf.call(this, a, b);
}
function eg(a, b) {
    cg.call(this, a, b);
}
function mr(a, b) {
    this.b = a;
    this.a = b;
}
function Nr(a, b) {
    this.b = a;
    this.a = b;
}
function rr(a, b) {
    this.a = a;
    this.b = b;
}
function ms(a, b) {
    this.f = a;
    this.g = b;
}
function Pr(a) {
    this.b = JD(Qb(a), 49);
}
function ou(a, b) {
    this.a = a;
    this.b = b;
}
function Du(a, b) {
    this.a = a;
    this.f = b;
}
function lv(a) {
    this.a = JD(Qb(a), 15);
}
function qv(a) {
    this.a = JD(Qb(a), 15);
}
function Cv(a, b) {
    this.b = a;
    this.c = b;
}
function jw(a) {
    this.a = JD(Qb(a), 91);
}
function Ax(a, b) {
    this.a = a;
    this.b = b;
}
function ay(a, b) {
    this.a = a;
    this.b = b;
}
function xt(a, b) {
    return Lib(a.b, b);
}
function Tp(a, b) {
    return a > b && b < Cre;
}
function Xle(a) {
    return Sle[a] != -1;
}
function yqe(a) {
    return !a || xqe(a);
}
function Uib(a) {
    return a.f.c + a.i.c;
}
function AC(a) {
    return OB(), a ? NB : MB;
}
function kob(a, b) {
    return a.b.Gc(b);
}
function lob(a, b) {
    return a.b.Hc(b);
}
function nob(a, b) {
    return a.b.Oc(b);
}
function fpb(a, b) {
    return a.c.uc(b);
}
function hpb(a, b) {
    return pb(a.c, b);
}
function Epb(a, b) {
    return a.b.Gc(b);
}
function HWd(a, b) {
    OGd(STd(a.a), b);
}
function MWd(a, b) {
    OGd(STd(a.a), b);
}
function Orb(a, b) {
    return a.a._b(b);
}
function Yoe(a) {
    Xoe(this, a, Nne());
}
function Jrb(a) {
    Vib.call(this, a, 0);
}
function Drb(a) {
    this.c = a;
    Arb(this);
}
function Mtb() {
    ztb(this);
    Ltb(this);
}
function Ucb() {
    Scb == null && (Scb = []);
}
function Txb() {
    Uxb.call(this, null);
}
function uC(a, b) {
    this.a = a;
    this.b = b;
}
function mB() {
    this.q = new $wnd.Date;
}
function Qz() {
    Fz != 0 && (Fz = 0);
    Hz = -1;
}
function Gzb() {
    Gzb = Zcb;
    Fzb = new Jzb;
}
function Zgb() {
    Zgb = Zcb;
    Ygb = new fdb;
}
function Hnb() {
    Hnb = Zcb;
    Gnb = new Inb;
}
function Hub() {
    Hub = Zcb;
    Gub = new Lub;
}
function Rub() {
    Rub = Zcb;
    Qub = new Tub;
}
function wBb() {
    wBb = Zcb;
    vBb = new JCb;
}
function qBb() {
    MAb.call(this, null);
}
function EBb(a, b) {
    KAb(a);
    a.a.Nb(b);
}
function gzb(a, b) {
    return a.a.Vc(b);
}
function hzb(a, b) {
    return a.a.Wc(b);
}
function izb(a, b) {
    return a.a.Yc(b);
}
function jzb(a, b) {
    return a.a.Zc(b);
}
function sAb(a, b) {
    return a.Fc(b), a;
}
function gEb(a, b) {
    a.a.f = b;
    return a;
}
function mEb(a, b) {
    a.a.d = b;
    return a;
}
function nEb(a, b) {
    a.a.g = b;
    return a;
}
function oEb(a, b) {
    a.a.j = b;
    return a;
}
function EFb(a, b) {
    a.a.a = b;
    return a;
}
function FFb(a, b) {
    a.a.d = b;
    return a;
}
function GFb(a, b) {
    a.a.e = b;
    return a;
}
function HFb(a, b) {
    a.a.g = b;
    return a;
}
function qGb(a, b) {
    a.a.f = b;
    return a;
}
function VGb(a) {
    a.b = false;
    return a;
}
function XSb() {
    XSb = Zcb;
    WSb = new aTb;
}
function vEb() {
    vEb = Zcb;
    uEb = new wEb;
}
function JQb() {
    JQb = Zcb;
    IQb = new PQb;
}
function uRb() {
    uRb = Zcb;
    tRb = new vRb;
}
function zRb() {
    zRb = Zcb;
    yRb = new $Rb;
}
function U5b() {
    U5b = Zcb;
    T5b = new $5b;
}
function qVb() {
    qVb = Zcb;
    pVb = new vVb;
}
function sWb() {
    sWb = Zcb;
    rWb = new fXb;
}
function E0b() {
    E0b = Zcb;
    D0b = new O0b;
}
function T$b() {
    T$b = Zcb;
    S$b = new Cdd;
}
function Jwc() {
    Jwc = Zcb;
    Iwc = new Gmd;
}
function jdc() {
    jdc = Zcb;
    idc = new gfc;
}
function Ljc() {
    Ljc = Zcb;
    Kjc = new Zjc;
}
function I5c() {
    I5c = Zcb;
    H5c = new K5c;
}
function S5c() {
    S5c = Zcb;
    R5c = new T5c;
}
function p7c() {
    p7c = Zcb;
    o7c = new r7c;
}
function JAc() {
    BAc();
    this.c = new Pi;
}
function K5c() {
    ms.call(this, qwe, 0);
}
function I5b(a, b, c, d) {
    J5b(d, a, b, c);
}
function f0b(a, b, c, d) {
    k0b(d, a, b, c);
}
function mKb(a, b, c, d) {
    lKb(a, d, b, c);
}
function _9c(a, b, c) {
    Rib(a.d, b.f, c);
}
function Rad(a, b) {
    Usb(a.c.b, b.c, b);
}
function Sad(a, b) {
    Usb(a.c.c, b.b, b);
}
function G9c(a, b) {
    a.a = b.g;
    return a;
}
function DSc(a) {
    return a.e.a + a.f.a;
}
function ESc(a) {
    return a.e.b + a.f.b;
}
function BNc(a) {
    return (a.c + a.a) / 2;
}
function gZd(a) {
    return a.b ? a.b : a.a;
}
function wZd(a, b) {
    return yA(a.a, b);
}
function Rod() {
    Rod = Zcb;
    Qod = new Cpd;
}
function tOd() {
    tOd = Zcb;
    sOd = new uOd;
}
function mOd() {
    mOd = Zcb;
    lOd = new oOd;
}
function xOd() {
    xOd = Zcb;
    wOd = new zOd;
}
function rOd() {
    rOd = Zcb;
    qOd = new h1d;
}
function COd() {
    COd = Zcb;
    BOd = new X5d;
}
function iNd() {
    iNd = Zcb;
    hNd = new Irb;
}
function m6d() {
    m6d = Zcb;
    k6d = new Ulb;
}
function g$d() {
    g$d = Zcb;
    f$d = new nde;
}
function E$d() {
    E$d = Zcb;
    D$d = new rde;
}
function _de() {
    _de = Zcb;
    $de = new aee;
}
function Ife() {
    Ife = Zcb;
    Hfe = new Mfe;
}
function Qpe() {
    Qpe = Zcb;
    Ppe = new Ype;
}
function Pz(a) {
    $wnd.clearTimeout(a);
}
function Mx(a) {
    Lx();
    co.call(this, a);
}
function sdb(a, b) {
    gz.call(this, a, b);
}
function okb(a, b) {
    this.d = a;
    this.e = b;
}
function Cmb(a, b) {
    Gmb(a, a.length, b);
}
function Dmb(a, b) {
    Imb(a, a.length, b);
}
function Jqb(a, b) {
    return qrb(a.a, b);
}
function Acb(a, b) {
    return vcb(a, b) > 0;
}
function Dcb(a, b) {
    return vcb(a, b) < 0;
}
function Ssb(a, b) {
    return Lib(a.e, b);
}
function zsb(a, b) {
    return a.a.get(b);
}
function ddb(b, a) {
    return a.split(b);
}
function rjb(a) {
    return a.b < a.d.gc();
}
function Nwb(a) {
    return tDb(a), false;
}
function Xv(a) {
    return JD(a, 43).jd();
}
function vw(a) {
    this.a = JD(Qb(a), 228);
}
function Ovb(a) {
    Gvb.call(this, a, 21);
}
function Tyb(a, b) {
    ms.call(this, a, b);
}
function mAb(a, b) {
    ms.call(this, a, b);
}
function hrb(a, b) {
    this.b = a;
    this.a = b;
}
function iCb(a, b) {
    this.a = a;
    this.b = b;
}
function oCb(a, b) {
    this.a = a;
    this.b = b;
}
function uCb(a, b) {
    this.a = a;
    this.b = b;
}
function ACb(a, b) {
    this.a = a;
    this.b = b;
}
function SDb(a, b) {
    this.a = a;
    this.b = b;
}
function PCb(a, b) {
    this.b = a;
    this.a = b;
}
function rFb(a, b) {
    this.b = a;
    this.a = b;
}
function jHb(a, b) {
    ms.call(this, a, b);
}
function QHb(a, b) {
    ms.call(this, a, b);
}
function HIb(a, b) {
    ms.call(this, a, b);
}
function yLb(a, b) {
    ms.call(this, a, b);
}
function pMb(a, b) {
    this.b = a;
    this.a = b;
}
function NMb(a, b) {
    this.b = a;
    this.a = b;
}
function cOb(a, b) {
    ms.call(this, a, b);
}
function LPb(a, b) {
    ms.call(this, a, b);
}
function DQb(a, b) {
    ms.call(this, a, b);
}
function WCb(a, b, c) {
    a.splice(b, 0, c);
}
function lr(a, b, c) {
    a.Mb(c) && b.Ad(c);
}
function kCb(a, b, c) {
    b.Ne(a.a.We(c));
}
function qCb(a, b, c) {
    b.Bd(a.a.Xe(c));
}
function wCb(a, b, c) {
    b.Ad(a.a.Kb(c));
}
function oRb(a, b) {
    return rrb(a.c, b);
}
function bEb(a, b) {
    return rrb(a.e, b);
}
function ASb(a, b) {
    ms.call(this, a, b);
}
function dUb(a, b) {
    ms.call(this, a, b);
}
function EYb(a, b) {
    ms.call(this, a, b);
}
function a2b(a, b) {
    ms.call(this, a, b);
}
function v5b(a, b) {
    ms.call(this, a, b);
}
function K7b(a, b) {
    ms.call(this, a, b);
}
function jSb(a, b) {
    this.b = a;
    this.a = b;
}
function oSb(a, b) {
    this.c = a;
    this.d = b;
}
function $Wb(a, b) {
    this.e = a;
    this.d = b;
}
function tZb(a, b) {
    this.a = a;
    this.b = b;
}
function ubc(a, b) {
    this.a = a;
    this.b = b;
}
function kcc(a, b) {
    this.a = a;
    this.b = b;
}
function Kcc(a, b) {
    this.a = a;
    this.b = b;
}
function Mcc(a, b) {
    this.a = a;
    this.b = b;
}
function Wcc(a, b) {
    this.a = a;
    this.b = b;
}
function gdc(a, b) {
    this.a = a;
    this.b = b;
}
function Tec(a, b) {
    this.a = a;
    this.b = b;
}
function bfc(a, b) {
    this.a = a;
    this.b = b;
}
function wcc(a, b) {
    this.b = a;
    this.a = b;
}
function Ycc(a, b) {
    this.b = a;
    this.a = b;
}
function Ejc(a, b) {
    this.b = a;
    this.a = b;
}
function Rfc(a, b) {
    this.b = b;
    this.c = a;
}
function Egc(a, b) {
    ms.call(this, a, b);
}
function _gc(a, b) {
    ms.call(this, a, b);
}
function Jhc(a, b) {
    ms.call(this, a, b);
}
function Omc(a, b) {
    ms.call(this, a, b);
}
function Wmc(a, b) {
    ms.call(this, a, b);
}
function enc(a, b) {
    ms.call(this, a, b);
}
function pnc(a, b) {
    ms.call(this, a, b);
}
function Bnc(a, b) {
    ms.call(this, a, b);
}
function Lnc(a, b) {
    ms.call(this, a, b);
}
function Unc(a, b) {
    ms.call(this, a, b);
}
function foc(a, b) {
    ms.call(this, a, b);
}
function noc(a, b) {
    ms.call(this, a, b);
}
function zoc(a, b) {
    ms.call(this, a, b);
}
function Loc(a, b) {
    ms.call(this, a, b);
}
function _oc(a, b) {
    ms.call(this, a, b);
}
function ipc(a, b) {
    ms.call(this, a, b);
}
function rpc(a, b) {
    ms.call(this, a, b);
}
function zpc(a, b) {
    ms.call(this, a, b);
}
function Pqc(a, b) {
    ms.call(this, a, b);
}
function Xqc(a, b) {
    ms.call(this, a, b);
}
function exc(a, b) {
    ms.call(this, a, b);
}
function qxc(a, b) {
    ms.call(this, a, b);
}
function Bxc(a, b) {
    ms.call(this, a, b);
}
function Oxc(a, b) {
    ms.call(this, a, b);
}
function Oyc(a, b) {
    ms.call(this, a, b);
}
function eyc(a, b) {
    ms.call(this, a, b);
}
function oyc(a, b) {
    ms.call(this, a, b);
}
function wyc(a, b) {
    ms.call(this, a, b);
}
function Fyc(a, b) {
    ms.call(this, a, b);
}
function Xyc(a, b) {
    ms.call(this, a, b);
}
function pzc(a, b) {
    ms.call(this, a, b);
}
function yzc(a, b) {
    ms.call(this, a, b);
}
function Hzc(a, b) {
    ms.call(this, a, b);
}
function VEc(a, b) {
    ms.call(this, a, b);
}
function wHc(a, b) {
    ms.call(this, a, b);
}
function fHc(a, b) {
    this.b = a;
    this.a = b;
}
function TIc(a, b) {
    this.a = a;
    this.b = b;
}
function hJc(a, b) {
    this.a = a;
    this.b = b;
}
function OJc(a, b) {
    this.a = a;
    this.b = b;
}
function AKc(a, b) {
    ms.call(this, a, b);
}
function IKc(a, b) {
    ms.call(this, a, b);
}
function PKc(a, b) {
    this.a = a;
    this.b = b;
}
function ALc(a, b) {
    this.b = a;
    this.d = b;
}
function dLc() {
    ZKc();
    this.b = new Qrb;
}
function oMc() {
    gMc();
    this.a = new Qrb;
}
function m8b() {
    c8b();
    this.a = new q_b;
}
function xsb() {
    tsb();
    return new ssb;
}
function Iub(a) {
    rDb(a.a);
    return a.b;
}
function ARb(a) {
    BRb(a, a.c);
    return a;
}
function IGc(a, b) {
    gGc();
    return b != a;
}
function qkc(a, b) {
    return rrb(b.b, a);
}
function cHc(a, b) {
    JGc(a.a, JD(b, 11));
}
function jNc(a, b) {
    ms.call(this, a, b);
}
function hPc(a, b) {
    ms.call(this, a, b);
}
function bQc(a, b) {
    ms.call(this, a, b);
}
function $Sc(a, b) {
    ms.call(this, a, b);
}
function PTc(a, b) {
    ms.call(this, a, b);
}
function wVc(a, b) {
    ms.call(this, a, b);
}
function EVc(a, b) {
    ms.call(this, a, b);
}
function CYc(a, b) {
    ms.call(this, a, b);
}
function kZc(a, b) {
    ms.call(this, a, b);
}
function b$c(a, b) {
    ms.call(this, a, b);
}
function l$c(a, b) {
    ms.call(this, a, b);
}
function o_c(a, b) {
    ms.call(this, a, b);
}
function y_c(a, b) {
    ms.call(this, a, b);
}
function j0c(a, b) {
    ms.call(this, a, b);
}
function E0c(a, b) {
    ms.call(this, a, b);
}
function m1c(a, b) {
    ms.call(this, a, b);
}
function Q2c(a, b) {
    ms.call(this, a, b);
}
function s3c(a, b) {
    ms.call(this, a, b);
}
function sPc(a, b) {
    this.a = a;
    this.b = b;
}
function qPc(a, b) {
    this.a = a;
    this.b = b;
}
function JQc(a, b) {
    this.a = a;
    this.b = b;
}
function B3c(a, b) {
    this.a = a;
    this.b = b;
}
function LRc(a, b) {
    this.b = a;
    this.a = b;
}
function CXc(a, b) {
    this.b = a;
    this.a = b;
}
function EXc(a, b) {
    this.b = a;
    this.a = b;
}
function gYc(a, b) {
    this.b = a;
    this.a = b;
}
function iYc(a, b) {
    this.b = a;
    this.a = b;
}
function M8c(a, b) {
    this.a = a;
    this.b = b;
}
function u9c(a, b) {
    this.a = a;
    this.b = b;
}
function T3c(a, b) {
    ms.call(this, a, b);
}
function J4c(a, b) {
    ms.call(this, a, b);
}
function x5c(a, b) {
    ms.call(this, a, b);
}
function b6c(a, b) {
    ms.call(this, a, b);
}
function m6c(a, b) {
    ms.call(this, a, b);
}
function C7c(a, b) {
    ms.call(this, a, b);
}
function mcd(a, b) {
    ms.call(this, a, b);
}
function Acd(a, b) {
    ms.call(this, a, b);
}
function ded(a, b) {
    ms.call(this, a, b);
}
function Ied(a, b) {
    ms.call(this, a, b);
}
function Xgd(a, b) {
    ms.call(this, a, b);
}
function fhd(a, b) {
    ms.call(this, a, b);
}
function ohd(a, b) {
    ms.call(this, a, b);
}
function yhd(a, b) {
    ms.call(this, a, b);
}
function Khd(a, b) {
    ms.call(this, a, b);
}
function fid(a, b) {
    ms.call(this, a, b);
}
function qid(a, b) {
    ms.call(this, a, b);
}
function Fid(a, b) {
    ms.call(this, a, b);
}
function Rid(a, b) {
    ms.call(this, a, b);
}
function djd(a, b) {
    ms.call(this, a, b);
}
function pjd(a, b) {
    ms.call(this, a, b);
}
function Vjd(a, b) {
    ms.call(this, a, b);
}
function pkd(a, b) {
    ms.call(this, a, b);
}
function zkd(a, b) {
    ms.call(this, a, b);
}
function Okd(a, b) {
    ms.call(this, a, b);
}
function Xkd(a, b) {
    ms.call(this, a, b);
}
function dld(a, b) {
    ms.call(this, a, b);
}
function pmd(a, b) {
    ms.call(this, a, b);
}
function Omd(a, b) {
    this.a = a;
    this.b = b;
}
function Qmd(a, b) {
    this.a = a;
    this.b = b;
}
function Smd(a, b) {
    this.a = a;
    this.b = b;
}
function Edd(a, b) {
    this.a = a;
    this.b = b;
}
function wnd(a, b) {
    this.a = a;
    this.b = b;
}
function ynd(a, b) {
    this.a = a;
    this.b = b;
}
function And(a, b) {
    this.a = a;
    this.b = b;
}
function xod(a, b) {
    this.a = a;
    this.b = b;
}
function Bzd(a, b) {
    this.a = a;
    this.b = b;
}
function Dzd(a, b) {
    this.a = a;
    this.b = b;
}
function Hzd(a, b) {
    this.a = a;
    this.b = b;
}
function Jzd(a, b) {
    this.a = a;
    this.b = b;
}
function Pzd(a, b) {
    this.a = a;
    this.b = b;
}
function Rzd(a, b) {
    this.a = a;
    this.b = b;
}
function Tzd(a, b) {
    this.b = a;
    this.a = b;
}
function Vzd(a, b) {
    this.b = a;
    this.a = b;
}
function nAd(a, b) {
    this.b = a;
    this.a = b;
}
function pAd(a, b) {
    this.b = a;
    this.a = b;
}
function rAd(a, b) {
    this.a = a;
    this.b = b;
}
function vAd(a, b) {
    this.a = a;
    this.b = b;
}
function NAd(a, b) {
    this.a = a;
    this.b = b;
}
function RAd(a, b) {
    this.a = a;
    this.b = b;
}
function TDd(a, b) {
    this.f = a;
    this.c = b;
}
function YId(a, b) {
    this.i = a;
    this.g = b;
}
function dPd(a, b) {
    this.a = a;
    this.b = b;
}
function gPd(a, b) {
    this.a = a;
    this.b = b;
}
function cod(a, b) {
    ms.call(this, a, b);
}
function CBd(a, b) {
    ms.call(this, a, b);
}
function W0d(a, b) {
    this.a = a;
    this.b = b;
}
function s2d(a, b) {
    this.a = a;
    this.b = b;
}
function FUd(a, b) {
    this.d = a;
    this.e = b;
}
function vae(a, b) {
    this.d = a;
    this.b = b;
}
function Rae(a, b) {
    this.e = a;
    this.a = b;
}
function Zfe(a, b) {
    this.b = a;
    this.c = b;
}
function Wge(a, b) {
    this.a = a;
    this.b = b;
}
function TRd(a, b) {
    a.i = null;
    URd(a, b);
}
function fEd(a, b) {
    !!a && Qib(_Dd, a, b);
}
function dLd(a, b) {
    return nJd(a.a, b);
}
function bad(a, b) {
    return rrb(a.g, b);
}
function X7c(a, b) {
    return -a.b.$e(b);
}
function Yfe(a) {
    return Kbe(a.c, a.b);
}
function Wd(a) {
    return !a ? null : a.kd();
}
function XD(a) {
    return a == null ? null : a;
}
function SD(a) {
    return typeof a === Dqe;
}
function TD(a) {
    return typeof a === Eqe;
}
function VD(a) {
    return typeof a === Fqe;
}
function Nm(a, b) {
    return a.Pd().Xb(b);
}
function Yq(a, b) {
    return vr(a.Jc(), b);
}
function ycb(a, b) {
    return vcb(a, b) == 0;
}
function Bcb(a, b) {
    return vcb(a, b) >= 0;
}
function Hcb(a, b) {
    return vcb(a, b) != 0;
}
function Geb(a) {
    return '' + (tDb(a), a);
}
function wqe(a, b) {
    Aqe(new CHd(a), b);
}
function $yd(a, b, c) {
    Txd(b, xyd(a, c));
}
function _yd(a, b, c) {
    Txd(b, xyd(a, c));
}
function _zc() {
    Uzc();
    Xzc.call(this);
}
function ig(a) {
    gg(a);
    return a.d.gc();
}
function ZD(a) {
    BDb(a == null);
    return a;
}
function znb(a) {
    sDb(a, 0);
    return null;
}
function Dgb(a, b) {
    a.a += '' + b;
    return a;
}
function Egb(a, b) {
    a.a += '' + b;
    return a;
}
function Ngb(a, b) {
    a.a += '' + b;
    return a;
}
function Pgb(a, b) {
    a.a += '' + b;
    return a;
}
function Qgb(a, b) {
    a.a += '' + b;
    return a;
}
function Mgb(a, b) {
    return a.a += '' + b, a;
}
function Btb(a, b) {
    Dtb(a, b, a.a, a.a.a);
}
function Ctb(a, b) {
    Dtb(a, b, a.c.b, a.c);
}
function dwb(a, b) {
    $vb.call(this, a, b);
}
function hwb(a, b) {
    $vb.call(this, a, b);
}
function lwb(a, b) {
    $vb.call(this, a, b);
}
function Krb(a) {
    Tib(this);
    Ld(this, a);
}
function Lub() {
    this.b = 0;
    this.a = false;
}
function Tub() {
    this.b = 0;
    this.a = false;
}
function At() {
    this.b = new Jrb(Ov(12));
}
function kB(a, b) {
    a.q.setTime(Ocb(b));
}
function MBd(a, b) {
    LBd.call(this, a, b);
}
function XId(a, b) {
    zHd.call(this, a, b);
}
function gWd(a, b) {
    YId.call(this, a, b);
}
function pde(a, b) {
    j$d.call(this, a, b);
}
function lde(a, b) {
    ide.call(this, a, b);
}
function kNd(a, b) {
    iNd();
    Qib(hNd, a, b);
}
function mb(a, b) {
    return XD(a) === XD(b);
}
function $q(a) {
    return Qb(a), new Bl(a);
}
function Iw(a, b) {
    return a.a.a.a.cc(b);
}
function qIc(a, b) {
    return a.j[b.p] == 2;
}
function Wy(a, b) {
    return a == b ? 0 : a ? 1 : -1;
}
function sB(a) {
    return a < 10 ? '0' + a : '' + a;
}
function $C(a) {
    return _C(a.l, a.m, a.h);
}
function Ccb(a) {
    return typeof a === Eqe;
}
function hdb(a, b) {
    return qgb(a.a, 0, b);
}
function Eeb(a) {
    return YD((tDb(a), a));
}
function Feb(a) {
    return YD((tDb(a), a));
}
function Jeb(a, b) {
    return Heb(a.a, b.a);
}
function Xeb(a, b) {
    return $eb(a.a, b.a);
}
function pfb(a, b) {
    return rfb(a.a, b.a);
}
function hgb(a, b) {
    return a.indexOf(b);
}
function Qmb(a, b) {
    Nmb(a, 0, a.length, b);
}
function F9c(a, b) {
    a.a = b.g + 1;
    return a;
}
function vdd(a) {
    a.a = 0;
    a.b = 0;
    return a;
}
function isb(a) {
    this.a = xsb();
    this.b = a;
}
function Csb(a) {
    this.a = xsb();
    this.b = a;
}
function Bl(a) {
    this.a = a;
    xl.call(this);
}
function El(a) {
    this.a = a;
    xl.call(this);
}
function dTc() {
    dTc = Zcb;
    cTc = os(bTc());
}
function AJb() {
    AJb = Zcb;
    zJb = os(yJb());
}
function A5b() {
    A5b = Zcb;
    z5b = os(y5b());
}
function Ry() {
    Ry = Zcb;
    $wnd.Math.log(2);
}
function OA() {
    OA = Zcb;
    nA();
    NA = new Irb;
}
function wtb() {
    Trb.call(this, new Xsb);
}
function $Xb() {
    TXb.call(this, 0, 0, 0, 0);
}
function a$b(a) {
    return Nlb(a.b.b, a, 0);
}
function PIb(a, b) {
    return $eb(a.g, b.g);
}
function alc(a, b) {
    return $eb(a.g, b.g);
}
function Q0c(a, b) {
    return Heb(b.f, a.f);
}
function K9c(a) {
    return D9c(new J9c, a);
}
function Axc(a) {
    return a == wxc || a == vxc;
}
function ySb(a) {
    return a == tSb || a == wSb;
}
function zSb(a) {
    return a == tSb || a == uSb;
}
function Ugd(a) {
    return a == Pgd || a == Qgd;
}
function Vgd(a) {
    return a == Sgd || a == Ogd;
}
function cjd(a) {
    return a != $id && a != _id;
}
function qqd(a) {
    return a.rh() && a.sh();
}
function snd(a) {
    return Osd(JD(a, 124));
}
function dtd(a, b, c) {
    gtd(a, b);
    etd(a, c);
}
function ftd(a, b, c) {
    htd(a, b);
    itd(a, c);
}
function ysd(a, b, c) {
    zsd(a, b);
    Asd(a, c);
}
function iud(a, b, c) {
    jud(a, b);
    kud(a, c);
}
function pud(a, b, c) {
    qud(a, b);
    rud(a, c);
}
function bTd(a, b) {
    TSd(a, b);
    USd(a, a.D);
}
function sxb(a, b) {
    Ilb(a.a, b);
    return b;
}
function x8c(a, b) {
    Ilb(a.c, b);
    return a;
}
function c9c(a, b) {
    D9c(a.a, b);
    return a;
}
function Vdc(a, b) {
    Adc();
    return b.a += a;
}
function Xdc(a, b) {
    Adc();
    return b.a += a;
}
function Wdc(a, b) {
    Adc();
    return b.c += a;
}
function rbe(a, b) {
    return new ide(b, a);
}
function sbe(a, b) {
    return new ide(b, a);
}
function hr(a) {
    return zr(a.b.Jc(), a.a);
}
function uub(a) {
    return a != null ? tb(a) : 0;
}
function XAb(a, b) {
    return a[a.length] = b;
}
function $Ab(a, b) {
    return a[a.length] = b;
}
function aAb(a, b) {
    if (Tzb) return;
    a.b = b;
}
function Fdd(a) {
    this.a = a.a;
    this.b = a.b;
}
function YDd(a) {
    TDd.call(this, a, true);
}
function MYb(a) {
    TXb.call(this, a, a, a, a);
}
function Yyb() {
    Tyb.call(this, 'Head', 1);
}
function bzb() {
    Tyb.call(this, 'Tail', 3);
}
function fdd() {
    gdd.call(this, 0, 0, 0, 0);
}
function bh(a, b, c) {
    _g.call(this, a, b, c);
}
function Xhb(a) {
    Ghb();
    Yhb.call(this, a);
}
function OGb(a) {
    Llb(a.Qf(), new SGb(a));
}
function ILc() {
    ILc = Zcb;
    HLc = new Oqb(l2);
}
function Glb(a) {
    a.c = SC(aJ, Nqe, 1, 0, 5, 1);
}
function hzc(a, b, c) {
    VC(a.c[b.g], b.g, c);
}
function UQd(a, b, c) {
    JD(a.c, 71).Di(b, c);
}
function ind(a, b, c) {
    ftd(c, c.i + a, c.j + b);
}
function NBd(a, b) {
    LBd.call(this, a.b, b);
}
function NXd(a, b) {
    tCd(OTd(a.a), QXd(b));
}
function W_d(a, b) {
    tCd(J_d(a.a), Z_d(b));
}
function x$b(a, b) {
    return kCd(b, oxd(a));
}
function y$b(a, b) {
    return kCd(b, oxd(a));
}
function jyd(a, b) {
    return hp(yo(a.f), b);
}
function kyd(a, b) {
    return hp(yo(a.n), b);
}
function lyd(a, b) {
    return hp(yo(a.p), b);
}
function zJd(a) {
    return a == null ? 0 : tb(a);
}
function Dpe(a) {
    ooe();
    poe.call(this, a);
}
function Sg(a) {
    this.a = a;
    Mg.call(this, a);
}
function Cp(a) {
    this.a = a;
    pf.call(this, a);
}
function Jp(a) {
    this.a = a;
    pf.call(this, a);
}
function Oq(a, b) {
    qm();
    this.a = a;
    this.b = b;
}
function Hh(a, b) {
    Qb(b);
    Gh(a).Ic(new fx);
}
function iId(a, b, c) {
    VC(a, b, c);
    return c;
}
function _C(a, b, c) {
    return {
        l: a,
        m: b,
        h: c
    };
}
function $eb(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function Bfb(a, b) {
    return vcb(a, b) > 0 ? a : b;
}
function omb(a) {
    return a.a < a.c.c.length;
}
function Brb(a) {
    return a.a < a.c.a.length;
}
function Slb(a, b) {
    Pmb(a.c, a.c.length, b);
}
function Aub(a, b) {
    a.a != null && cHc(b, a.a);
}
function Kub(a, b) {
    return a.a ? a.b : b.Ue();
}
function Upe() {
    throw scb(new bhb(cHe));
}
function Xpe() {
    throw scb(new bhb(dHe));
}
function kqe() {
    throw scb(new bhb(dHe));
}
function hqe() {
    throw scb(new bhb(cHe));
}
function b9d() {
    new Irb;
    new Irb;
    new Irb;
}
function a9d() {
    a9d = Zcb;
    new b9d;
    new Ulb;
}
function N2d() {
    N2d = Zcb;
    M2d = (tOd(), sOd);
}
function Yy(a) {
    a.j = SC(dJ, hre, 320, 0, 0, 1);
}
function $yb() {
    Tyb.call(this, 'Range', 2);
}
function vNb(a) {
    dNb.call(this);
    this.b = a;
}
function IXb(a) {
    FXb.call(this);
    this.a = a;
}
function eMb(a) {
    this.b = new qMb;
    this.a = a;
}
function ZDb(a) {
    this.b = a;
    this.a = new Ulb;
}
function nQb() {
    jQb();
    this.a = new j9c(AO);
}
function ztb(a) {
    a.a = new gub;
    a.c = new gub;
}
function Rkc(a) {
    a.a = new Irb;
    a.d = new Irb;
}
function R7c(a, b) {
    return Qib(a.a, b.a, b);
}
function Ndc(a, b, c) {
    return Qib(a.g, c, b);
}
function mIc(a, b, c) {
    return Qib(a.k, c, b);
}
function ezc(a, b, c) {
    return czc(b, c, a.c);
}
function vyd(a, b) {
    return MD(Nib(a.i, b));
}
function wyd(a, b) {
    return MD(Nib(a.j, b));
}
function bdd(a) {
    return new Edd(a.c, a.d);
}
function cdd(a) {
    return new Edd(a.c, a.d);
}
function odd(a) {
    return new Edd(a.a, a.b);
}
function vZd(a, b) {
    return pA(a.a, b, null);
}
function Zac(a) {
    gWb(a, null);
    hWb(a, null);
}
function bNc(a) {
    cNc(a, null);
    dNc(a, null);
}
function nde() {
    j$d.call(this, null, null);
}
function rde() {
    K$d.call(this, null, null);
}
function Ufe(a) {
    this.a = a;
    Irb.call(this);
}
function Xp(a) {
    this.b = (pnb(), new kpb(a));
}
function Dr(a) {
    return a.Ob() ? a.Pb() : null;
}
function Nv(a, b) {
    return new aw(a.Jc(), b);
}
function Zq(a, b) {
    return Fr(a.Jc(), b) != -1;
}
function Vfe(a, b) {
    return mbe(a.c, a.b, b);
}
function RD(a, b) {
    return a != null && ID(a, b);
}
function gB(a, b) {
    a.q.setHours(b);
    eB(a, b);
}
function IIc(a, b) {
    gIc();
    return b.n.b += a;
}
function sIc(a, b, c) {
    tIc(a, b, c);
    return c;
}
function Ilb(a, b) {
    YCb(a.c, b);
    return true;
}
function Vsb(a, b) {
    if (a.c) {
        gtb(b);
        ftb(b);
    }
}
function lJd(a, b, c) {
    a.c._c(b, JD(c, 135));
}
function DJd(a, b, c) {
    a.c.Ri(b, JD(c, 135));
}
function CUd(a, b) {
    RGd(a);
    a.Fc(JD(b, 15));
}
function Prb(a, b) {
    return a.a.Ac(b) != null;
}
function kzb(a, b) {
    return a.a.Ac(b) != null;
}
function zHb(a, b, c) {
    return a.a[b.g][c.g];
}
function DCc(a, b) {
    return a.e[b.c.p][b.p];
}
function WCc(a, b) {
    return a.c[b.c.p][b.p];
}
function sDc(a, b) {
    return a.a[b.c.p][b.p];
}
function pIc(a, b) {
    return a.j[b.p] = DIc(b);
}
function zRc(a, b) {
    return Beb(MD(b.a)) <= a;
}
function ARc(a, b) {
    return Beb(MD(b.a)) >= a;
}
function Kbd(a, b) {
    return agb(a.f, b.Ng());
}
function ygb(a) {
    return zgb(a, 0, a.length);
}
function qdd(a, b) {
    return a.a * b.a + a.b * b.b;
}
function End(a, b) {
    return a.a < Hdb(b) ? -1 : 1;
}
function HBd(a, b) {
    return agb(a.b, b.Ng());
}
function ACc(a, b, c) {
    return c ? b != 0 : b != a - 1;
}
function Avb(a, b, c) {
    a.a = b ^ 1502;
    a.b = c ^ gte;
}
function ydd(a, b, c) {
    a.a = b;
    a.b = c;
    return a;
}
function wdd(a, b) {
    a.a *= b;
    a.b *= b;
    return a;
}
function jDd(a, b, c) {
    VC(a.g, b, c);
    return c;
}
function EHb(a, b, c, d) {
    VC(a.a[b.g], c.g, d);
}
function qVd(a, b, c) {
    iVd.call(this, a, b, c);
}
function uVd(a, b, c) {
    qVd.call(this, a, b, c);
}
function vde(a, b, c) {
    dbe.call(this, a, b, c);
}
function zde(a, b, c) {
    dbe.call(this, a, b, c);
}
function Bde(a, b, c) {
    vde.call(this, a, b, c);
}
function Dde(a, b, c) {
    qVd.call(this, a, b, c);
}
function Gde(a, b, c) {
    uVd.call(this, a, b, c);
}
function Qde(a, b, c) {
    iVd.call(this, a, b, c);
}
function Ude(a, b, c) {
    iVd.call(this, a, b, c);
}
function Xde(a, b, c) {
    Qde.call(this, a, b, c);
}
function ws() {
    ms.call(this, 'INSTANCE', 0);
}
function nlb() {
    this.a = SC(aJ, Nqe, 1, 8, 5, 1);
}
function yRd() {
    this.Bb |= 256;
    this.Bb |= 512;
}
function CHd(a) {
    this.i = a;
    this.f = this.i.j;
}
function lqe(a) {
    this.c = a;
    this.a = this.c.a;
}
function xf(a, b) {
    this.a = a;
    pf.call(this, b);
}
function Eb(a, b) {
    return Db(a, new Ugb, b).a;
}
function Lb(a) {
    if (!a) throw scb(new Seb);
}
function Ub(a) {
    if (!a) throw scb(new Veb);
}
function Hwb() {
    Hwb = Zcb;
    Hwb();
    Gwb = new Owb;
}
function Afe() {
    Afe = Zcb;
    _de();
    zfe = new Bfe;
}
function yub() {
    yub = Zcb;
    xub = new Cub(null);
}
function lCd(a) {
    wub(a, JDe);
    Ttd(a, fCd(a));
}
function LId(a) {
    a.a = JD(Crd(a.b.a, 4), 128);
}
function TId(a) {
    a.a = JD(Crd(a.b.a, 4), 128);
}
function Kg(a) {
    a.b.Qb();
    --a.d.f.d;
    hg(a.d);
}
function Xj(a) {
    this.a = a;
    yj.call(this, a.d);
}
function gj(a, b) {
    this.a = a;
    pc.call(this, b);
}
function qj(a, b) {
    this.a = a;
    pc.call(this, b);
}
function Pj(a, b) {
    this.a = a;
    pc.call(this, b);
}
function Gl(a, b) {
    this.a = b;
    pc.call(this, a);
}
function Yo(a, b) {
    this.a = b;
    To.call(this, a);
}
function wp(a, b) {
    this.a = a;
    To.call(this, b);
}
function Ur(a, b) {
    this.a = b;
    Pr.call(this, a);
}
function aw(a, b) {
    this.a = b;
    Pr.call(this, a);
}
function Ir(a, b) {
    Qb(b);
    return new Ur(a, b);
}
function nu(a, b) {
    return new Ku(a.a, a.b, b);
}
function kgb(a, b) {
    return a.lastIndexOf(b);
}
function igb(a, b, c) {
    return a.indexOf(b, c);
}
function xgb(a) {
    return a == null ? Rqe : adb(a);
}
function wz(a) {
    return a == null ? null : a.name;
}
function iD(a) {
    return a.l + a.m * Cse + a.h * Dse;
}
function Cr(a) {
    return Ttb(a.a) ? Br(a) : null;
}
function bl(a) {
    Ok.call(this, JD(Qb(a), 34));
}
function rl(a) {
    Ok.call(this, JD(Qb(a), 34));
}
function Jgb(a) {
    idb.call(this, (tDb(a), a));
}
function Wgb(a) {
    idb.call(this, (tDb(a), a));
}
function xtb(a) {
    Trb.call(this, new Ysb(a));
}
function Kob(a) {
    oob.call(this, a);
    this.a = a;
}
function Zob(a) {
    Fob.call(this, a);
    this.a = a;
}
function $pb(a) {
    Apb.call(this, a);
    this.a = a;
}
function ez() {
    Yy(this);
    $y(this);
    this.he();
}
function ryb(a) {
    this.a = a;
    Gkb.call(this, a);
}
function zub(a) {
    rDb(a.a != null);
    return a.a;
}
function fEb(a, b) {
    Ilb(b.a, a.a);
    return a.a;
}
function lEb(a, b) {
    Ilb(b.b, a.a);
    return a.a;
}
function pGb(a, b) {
    Ilb(b.a, a.a);
    return a.a;
}
function Tgb(a, b, c) {
    gdb(a, b, b, c);
    return a;
}
function QFb(a, b) {
    ++a.b;
    return Ilb(a.a, b);
}
function RFb(a, b) {
    ++a.b;
    return Plb(a.a, b);
}
function YKb(a, b) {
    return Heb(a.c.d, b.c.d);
}
function iLb(a, b) {
    return Heb(a.c.c, b.c.c);
}
function Q2b(a, b) {
    return Heb(a.n.a, b.n.a);
}
function LTb(a, b) {
    return JD(Qc(a.b, b), 15);
}
function V3b(a, b) {
    return a.n.b = (tDb(b), b);
}
function W3b(a, b) {
    return a.n.b = (tDb(b), b);
}
function rrb(a, b) {
    return !!b && a.b[b.g] == b;
}
function wZb(a) {
    return omb(a.a) || omb(a.b);
}
function jDb(a) {
    return a.$H || (a.$H = ++hDb);
}
function Bub(a) {
    return a.a != null ? a.a : null;
}
function xRc(a, b) {
    return Heb(a.e.b, b.e.b);
}
function FRc(a, b) {
    return Heb(a.e.a, b.e.a);
}
function azc(a, b, c) {
    return bzc(a, b, c, a.b);
}
function dzc(a, b, c) {
    return bzc(a, b, c, a.c);
}
function I9c(a, b, c) {
    JD(_8c(a, b), 22).Ec(c);
}
function SQb(a, b) {
    TQb.call(this, a, b, null);
}
function jpd(a, b) {
    Tod();
    this.f = b;
    this.d = a;
}
function ldc() {
    jdc();
    this.b = new rdc(this);
}
function Ydc(a) {
    Adc();
    return !!a && !a.dc();
}
function Eud(a) {
    RD(a, 157) && JD(a, 157).li();
}
function tKd(a, b, c) {
    sJd(a.a, c);
    rJd(a.a, b);
}
function j$d(a, b) {
    g$d();
    this.a = a;
    this.b = b;
}
function K$d(a, b) {
    E$d();
    this.b = a;
    this.c = b;
}
function qc(a, b) {
    Sb(b, a);
    this.d = a;
    this.c = b;
}
function Q1b(a) {
    var b;
    b = a.a;
    a.a = a.b;
    a.b = b;
}
function xdb() {
    xdb = Zcb;
    vdb = false;
    wdb = true;
}
function EKb() {
    EKb = Zcb;
    DKb = new LBd(jue, 0);
}
function soe(a) {
    ++noe;
    return new dpe(3, a);
}
function Bs(a) {
    vs();
    return ss((Es(), Ds), a);
}
function rm(a, b) {
    return new bq(a, a.gc(), b);
}
function xj(a, b) {
    return en(a.c).Kd().Xb(b);
}
function ggb(a, b, c) {
    return igb(a, wgb(b), c);
}
function Ig(a, b, c, d) {
    wg.call(this, a, b, c, d);
}
function LHd(a) {
    this.d = a;
    CHd.call(this, a);
}
function XHd(a) {
    this.c = a;
    CHd.call(this, a);
}
function $Hd(a) {
    this.c = a;
    LHd.call(this, a);
}
function htb(a) {
    itb.call(this, a, null, null);
}
function qlb(a) {
    if (!a) throw scb(new yqb);
}
function av(a) {
    bk(a, Dre);
    return new Vlb(a);
}
function Ftb(a) {
    rDb(a.b != 0);
    return a.c.b.c;
}
function Etb(a) {
    rDb(a.b != 0);
    return a.a.a.c;
}
function Ggb(a, b) {
    gdb(a, b, b + 1, '');
    return a;
}
function du(a, b, c) {
    var d;
    d = a.dd(b);
    d.Rb(c);
}
function jyb(a) {
    return a.b = JD(sjb(a.a), 43);
}
function ks(a) {
    return a.f != null ? a.f : '' + a.g;
}
function ls(a) {
    return a.f != null ? a.f : '' + a.g;
}
function INb(a, b) {
    return a > 0 ? b / (a * a) : b * 100;
}
function PNb(a, b) {
    return a > 0 ? b * b / a : b * b * 100;
}
function XMb(a, b) {
    return !!a.q && Lib(a.q, b);
}
function k_b(a, b) {
    return JD(Tsb(a.a, b), 34);
}
function bA(a) {
    Zz();
    return parseInt(a) || -1;
}
function Chc(a, b) {
    jhc();
    return Rc(a, b.e, b);
}
function Qwc(a, b, c) {
    Jwc();
    return c.Kg(a, b);
}
function OWc(a) {
    EWc();
    return a.e.a + a.f.a / 2;
}
function QWc(a, b, c) {
    EWc();
    return c.e.a - a * b;
}
function YWc(a) {
    EWc();
    return a.e.b + a.f.b / 2;
}
function $Wc(a, b, c) {
    EWc();
    return c.e.b - a * b;
}
function kDb(a) {
    if (!a) throw scb(new Seb);
}
function xDb(a) {
    if (!a) throw scb(new Veb);
}
function oDb(a) {
    if (!a) throw scb(new pdb);
}
function rDb(a) {
    if (!a) throw scb(new qub);
}
function Qsb(a) {
    a.d = new htb(a);
    a.e = new Irb;
}
function AZc() {
    this.a = new Pp;
    this.b = new Pp;
}
function Gfc(a) {
    this.c = a;
    this.a = 1;
    this.b = 1;
}
function Mub(a) {
    Hub();
    this.b = a;
    this.a = true;
}
function Uub(a) {
    Rub();
    this.b = a;
    this.a = true;
}
function MTb(a) {
    JTb();
    KTb(this);
    this.Df(a);
}
function Tdd(a) {
    Mtb.call(this);
    Mdd(this, a);
}
function T5c() {
    ms.call(this, 'GROW_TREE', 0);
}
function imd(a) {
    this.c = a;
    htd(a, 0);
    itd(a, 0);
}
function tdd(a) {
    a.a = -a.a;
    a.b = -a.b;
    return a;
}
function zdd(a, b) {
    a.a = b.a;
    a.b = b.b;
    return a;
}
function ldd(a, b, c) {
    a.a += b;
    a.b += c;
    return a;
}
function Add(a, b, c) {
    a.a -= b;
    a.b -= c;
    return a;
}
function T9c(a, b, c) {
    P9c();
    a.nf(b) && c.Ad(a);
}
function e9c(a, b, c) {
    return Ilb(b, g9c(a, c));
}
function mJd(a, b) {
    return a.c.Ec(JD(b, 135));
}
function myd(a, b) {
    return JD(Nib(a.e, b), 27);
}
function nyd(a, b) {
    return JD(Nib(a.e, b), 27);
}
function lRd(a, b, c) {
    YQd.call(this, a, b, c, 2);
}
function $$d(a, b) {
    E$d();
    Y$d.call(this, a, b);
}
function Y$d(a, b) {
    E$d();
    K$d.call(this, a, b);
}
function a_d(a, b) {
    E$d();
    K$d.call(this, a, b);
}
function z$d(a, b) {
    g$d();
    j$d.call(this, a, b);
}
function s4d(a, b) {
    N2d();
    g4d.call(this, a, b);
}
function I4d(a, b) {
    N2d();
    g4d.call(this, a, b);
}
function Q4d(a, b) {
    N2d();
    g4d.call(this, a, b);
}
function u4d(a, b) {
    N2d();
    s4d.call(this, a, b);
}
function w4d(a, b) {
    N2d();
    s4d.call(this, a, b);
}
function y4d(a, b) {
    N2d();
    w4d.call(this, a, b);
}
function K4d(a, b) {
    N2d();
    I4d.call(this, a, b);
}
function MXd(a, b, c) {
    sCd(OTd(a.a), b, QXd(c));
}
function V_d(a, b, c) {
    sCd(J_d(a.a), b, Z_d(c));
}
function pae(a, b, c) {
    return Oae(iae(a, b), c);
}
function Gbe(a, b, c) {
    return b.wl(a.e, a.c, c);
}
function Ibe(a, b, c) {
    return b.xl(a.e, a.c, c);
}
function Vbe(a, b) {
    return zqd(a.e, JD(b, 52));
}
function Ope(a, b) {
    return (tDb(a), a) + Hdb(b);
}
function Bie(a) {
    return a == null ? null : adb(a);
}
function Cie(a) {
    return a == null ? null : adb(a);
}
function uie(a) {
    return a == null ? null : Wle(a);
}
function yie(a) {
    return a == null ? null : bme(a);
}
function ceb(a) {
    if (a.o != null) return;
    seb(a);
}
function LD(a) {
    BDb(a == null || SD(a));
    return a;
}
function MD(a) {
    BDb(a == null || TD(a));
    return a;
}
function OD(a) {
    BDb(a == null || VD(a));
    return a;
}
function oB(a) {
    this.q = new $wnd.Date(Ocb(a));
}
function Kf(a, b) {
    this.c = a;
    me.call(this, a, b);
}
function Sf(a, b) {
    this.a = a;
    Kf.call(this, a, b);
}
function Ng(a, b) {
    this.d = a;
    Jg(this);
    this.b = b;
}
function VAb(a, b) {
    MAb.call(this, a);
    this.a = b;
}
function nBb(a, b) {
    MAb.call(this, a);
    this.a = b;
}
function y1d() {
    aSd.call(this);
    this.Bb |= Pse;
}
function _g(a, b, c) {
    jg.call(this, a, b, c, null);
}
function dh(a, b, c) {
    jg.call(this, a, b, c, null);
}
function vzb(a, b, c) {
    return a.Le(b, c) <= 0 ? c : b;
}
function wzb(a, b, c) {
    return a.Le(b, c) <= 0 ? b : c;
}
function Adb(a) {
    return (tDb(a), a) ? 1231 : 1237;
}
function zfc(a) {
    return JD(Mlb(a.a, a.b), 292);
}
function Gad(a, b) {
    return JD(Tsb(a.b, b), 149);
}
function Iad(a, b) {
    return JD(Tsb(a.c, b), 232);
}
function Zcd(a) {
    return new Edd(a.c, a.d + a.a);
}
function HJc(a) {
    return gIc(), Axc(JD(a, 203));
}
function aKb() {
    aKb = Zcb;
    _Jb = mrb((ykd(), xkd));
}
function xYc() {
    xYc = Zcb;
    wYc = new KBd('root');
}
function GLd() {
    GLd = Zcb;
    FLd = new gMd;
    new HMd;
}
function Mtd(a, b, c) {
    c = bqd(a, b, 3, c);
    return c;
}
function dud(a, b, c) {
    c = bqd(a, b, 6, c);
    return c;
}
function mxd(a, b, c) {
    c = bqd(a, b, 9, c);
    return c;
}
function bIb(a, b) {
    wub(b, bue);
    a.f = b;
    return a;
}
function _$b(a, b) {
    T$b();
    return xXb(b.d.i, a);
}
function D6b(a, b) {
    k6b();
    return new K6b(b, a);
}
function Yzb(a, b) {
    if (Tzb) return;
    Ilb(a.a, b);
}
function gMb(a, b) {
    b.a ? hMb(a, b) : kzb(a.a, b.b);
}
function zEd(a, b, c) {
    ++a.j;
    a.qj();
    xCd(a, b, c);
}
function xEd(a, b, c) {
    ++a.j;
    a.nj(b, a.Wi(b, c));
}
function WZd(a, b, c) {
    var d;
    d = a.dd(b);
    d.Rb(c);
}
function Wfe(a, b, c) {
    return vbe(a.c, a.b, b, c);
}
function uyd(a, b) {
    return JD(Nib(a.b, b), 275);
}
function AJd(a, b) {
    return (b & Hqe) % a.d.length;
}
function n2d(a, b) {
    e2d.call(this, a);
    this.a = b;
}
function l5d(a, b) {
    e2d.call(this, a);
    this.a = b;
}
function LBd(a, b) {
    KBd.call(this, a);
    this.a = b;
}
function wHd(a, b) {
    this.c = a;
    wDd.call(this, b);
}
function RXd(a, b) {
    this.a = a;
    jXd.call(this, b);
}
function $_d(a, b) {
    this.a = a;
    jXd.call(this, b);
}
function dq(a) {
    this.a = (bk(a, Dre), new Vlb(a));
}
function kq(a) {
    this.a = (bk(a, Dre), new Vlb(a));
}
function wfb(a) {
    return Pcb(Lcb(a, 32)) ^ Pcb(a);
}
function PD(a) {
    return String.fromCharCode(a);
}
function vz(a) {
    return a == null ? null : a.message;
}
function Jz(a, b, c) {
    var d;
    return a.apply(b, c);
}
function Mqb(a, b, c) {
    return Lqb(a, JD(b, 23), c);
}
function Sgb(a, b, c) {
    a.a += zgb(b, 0, c);
    return a;
}
function hkb(a, b) {
    var c;
    c = a.e;
    a.e = b;
    return c;
}
function tkb(a, b) {
    var c;
    c = b;
    return !!a.De(c);
}
function qsb(a, b) {
    var c;
    c = a[dte];
    c.call(a, b);
}
function rsb(a, b) {
    var c;
    c = a[dte];
    c.call(a, b);
}
function zjb(a, b) {
    a.a._c(a.b, b);
    ++a.b;
    a.c = -1;
}
function Rsb(a) {
    Tib(a.e);
    a.d.b = a.d;
    a.d.a = a.d;
}
function fg(a) {
    a.b ? fg(a.b) : a.f.c.yc(a.e, a.d);
}
function TA(a) {
    !a.a && (a.a = new bB);
    return a.a;
}
function mNb() {
    this.a = new Ulb;
    this.b = new Ulb;
}
function uPb() {
    this.a = new CMb;
    this.b = new FPb;
}
function jEb() {
    this.b = new Cdd;
    this.c = new Ulb;
}
function FXb() {
    this.n = new Cdd;
    this.o = new Cdd;
}
function aHb() {
    this.n = new LYb;
    this.i = new fdd;
}
function q_b() {
    this.b = new Xsb;
    this.a = new Xsb;
}
function kbc() {
    this.a = new Xjc;
    this.b = new pkc;
}
function mCc() {
    this.b = new Qrb;
    this.a = new Qrb;
}
function oHc() {
    this.a = new Ulb;
    this.d = new Ulb;
}
function iQc() {
    this.b = new WPc;
    this.a = new LPc;
}
function ySc() {
    this.b = new Irb;
    this.a = new Irb;
}
function cHb() {
    aHb.call(this);
    this.a = new Cdd;
}
function _Xb(a, b, c, d) {
    TXb.call(this, a, b, c, d);
}
function UBb(a, b, c) {
    wBb();
    GCb(a, b.Te(a.a, c));
}
function $$b(a, b) {
    T$b();
    return !xXb(b.d.i, a);
}
function Bdb(a, b) {
    xdb();
    return a == b ? 0 : a ? 1 : -1;
}
function X3b(a, b) {
    return a.n.a = (tDb(b), b) + 10;
}
function Y3b(a, b) {
    return a.n.a = (tDb(b), b) + 10;
}
function VCb(a, b) {
    return bDb(new Array(b), a);
}
function YTd(a, b) {
    return b == a || mDd(NTd(b), a);
}
function SGd(a) {
    return a < 100 ? null : new FGd(a);
}
function I5d(a, b) {
    return Qib(a.a, b, '') == null;
}
function aae(a, b) {
    var c;
    c = b.mi(a.a);
    return c;
}
function mdd(a, b) {
    a.a += b.a;
    a.b += b.b;
    return a;
}
function Bdd(a, b) {
    a.a -= b.a;
    a.b -= b.b;
    return a;
}
function Vwd(a, b, c) {
    c = bqd(a, b, 11, c);
    return c;
}
function H9c(a) {
    _Cb(a.j.c, 0);
    a.a = -1;
    return a;
}
function ugc(a, b) {
    Ugd(a.f) ? vgc(a, b) : wgc(a, b);
}
function Gyd(a, b, c) {
    c != null && mud(b, lzd(a, c));
}
function Hyd(a, b, c) {
    c != null && nud(b, lzd(a, c));
}
function _0d(a, b, c, d) {
    X0d.call(this, a, b, c, d);
}
function Jde(a, b, c, d) {
    X0d.call(this, a, b, c, d);
}
function Nde(a, b, c, d) {
    Jde.call(this, a, b, c, d);
}
function gee(a, b, c, d) {
    bee.call(this, a, b, c, d);
}
function iee(a, b, c, d) {
    bee.call(this, a, b, c, d);
}
function oee(a, b, c, d) {
    bee.call(this, a, b, c, d);
}
function mee(a, b, c, d) {
    iee.call(this, a, b, c, d);
}
function tee(a, b, c, d) {
    iee.call(this, a, b, c, d);
}
function ree(a, b, c, d) {
    oee.call(this, a, b, c, d);
}
function wee(a, b, c, d) {
    tee.call(this, a, b, c, d);
}
function Yee(a, b, c, d) {
    Ree.call(this, a, b, c, d);
}
function zHd(a, b) {
    mdb.call(this, IEe + a + ODe + b);
}
function zwb(a, b) {
    Awb.call(this, a, a.length, b);
}
function afe(a, b) {
    return a.gk().si().ni(a, b);
}
function bfe(a, b) {
    return a.gk().si().pi(a, b);
}
function lCb(a, b) {
    return a.b.zd(new oCb(a, b));
}
function rCb(a, b) {
    return a.b.zd(new uCb(a, b));
}
function xCb(a, b) {
    return a.b.zd(new ACb(a, b));
}
function zk(a, b) {
    return a.e = JD(a.d.Kb(b), 158);
}
function lgb(a, b, c) {
    return a.lastIndexOf(b, c);
}
function GPb(a, b, c) {
    return Heb(a[b.a], a[c.a]);
}
function hjc(a, b) {
    return $eb(a.a.d.p, b.a.d.p);
}
function ijc(a, b) {
    return $eb(b.a.d.p, a.a.d.p);
}
function bQb(a, b) {
    return ZMb(b, (Bwc(), guc), a);
}
function Ceb(a, b) {
    return tDb(a), XD(a) === XD(b);
}
function cgb(a, b) {
    return tDb(a), XD(a) === XD(b);
}
function tQc(a, b) {
    return Heb(a.b.e.a, b.b.e.a);
}
function vQc(a, b) {
    return Heb(a.c.e.a, b.c.e.a);
}
function CNc(a, b) {
    return Heb(a.c - a.s, b.c - b.s);
}
function iYb(a) {
    return !a.c ? -1 : Nlb(a.c.a, a, 0);
}
function wJd(a, b) {
    return RD(b, 15) && yCd(a.c, b);
}
function bAb(a, b) {
    if (Tzb) return;
    !!b && (a.d = b);
}
function _Hd(a, b) {
    this.c = a;
    MHd.call(this, a, b);
}
function bq(a, b, c) {
    this.a = a;
    qc.call(this, b, c);
}
function XBb(a) {
    this.c = a;
    lwb.call(this, mre, 0);
}
function pk(a, b, c) {
    this.c = b;
    this.b = c;
    this.a = a;
}
function GGc(a) {
    gGc();
    this.d = a;
    this.a = new nlb;
}
function co(a) {
    Yl();
    this.a = (pnb(), new Apb(a));
}
function hId() {
    hId = Zcb;
    gId = SC(aJ, Nqe, 1, 0, 5, 1);
}
function mPd() {
    mPd = Zcb;
    lPd = SC(aJ, Nqe, 1, 0, 5, 1);
}
function TPd() {
    TPd = Zcb;
    SPd = SC(aJ, Nqe, 1, 0, 5, 1);
}
function Yl() {
    Yl = Zcb;
    new fm((pnb(), pnb(), mnb));
}
function Vb(a) {
    if (!a) throw scb(new Web(Pqe));
}
function Mb(a, b) {
    if (!a) throw scb(new Teb(b));
}
function VQd(a, b, c) {
    return JD(a.c, 71).Tk(b, c);
}
function WQd(a, b, c) {
    return JD(a.c, 71).Uk(b, c);
}
function Hbe(a, b, c) {
    return Gbe(a, JD(b, 339), c);
}
function Jbe(a, b, c) {
    return Ibe(a, JD(b, 339), c);
}
function bce(a, b, c) {
    return ace(a, JD(b, 339), c);
}
function dce(a, b, c) {
    return cce(a, JD(b, 339), c);
}
function Bn(a, b) {
    return b == null ? null : Tv(a.b, b);
}
function bjd(a) {
    return a == Wid || a == Yid || a == Xid;
}
function Hdb(a) {
    return TD(a) ? (tDb(a), a) : a.se();
}
function Ieb(a) {
    return !isNaN(a) && !isFinite(a);
}
function Ntb(a) {
    ztb(this);
    Ltb(this);
    xe(this, a);
}
function Wlb(a) {
    Glb(this);
    XCb(this.c, 0, a.Nc());
}
function kyb(a) {
    tjb(a.a);
    Mxb(a.c, a.b);
    a.b = null;
}
function Qzb(a) {
    this.a = a;
    Zgb();
    zcb(Date.now());
}
function urb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function Ksb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function Xtb(a, b, c) {
    this.d = a;
    this.b = c;
    this.a = b;
}
function TBb(a, b, c) {
    wBb();
    a.a.Wd(b, c);
    return b;
}
function NGb(a) {
    var b;
    b = new MGb;
    b.e = a;
    return b;
}
function kLb(a) {
    var b;
    b = new hLb;
    b.b = a;
    return b;
}
function kub() {
    kub = Zcb;
    iub = new lub;
    jub = new nub;
}
function qDb(a, b) {
    if (a != b) throw scb(new yqb);
}
function kHb(a) {
    iHb();
    return ss((nHb(), mHb), a);
}
function RHb(a) {
    PHb();
    return ss((UHb(), THb), a);
}
function Wyb(a) {
    Syb();
    return ss((ezb(), dzb), a);
}
function nAb(a) {
    lAb();
    return ss((qAb(), pAb), a);
}
function IIb(a) {
    GIb();
    return ss((LIb(), KIb), a);
}
function xJb(a) {
    sJb();
    return ss((AJb(), zJb), a);
}
function zLb(a) {
    xLb();
    return ss((CLb(), BLb), a);
}
function DSb(a) {
    xSb();
    return ss((GSb(), FSb), a);
}
function dOb(a) {
    bOb();
    return ss((gOb(), fOb), a);
}
function MPb(a) {
    KPb();
    return ss((PPb(), OPb), a);
}
function EQb(a) {
    CQb();
    return ss((HQb(), GQb), a);
}
function eUb(a) {
    cUb();
    return ss((hUb(), gUb), a);
}
function FYb(a) {
    DYb();
    return ss((IYb(), HYb), a);
}
function b2b(a) {
    _1b();
    return ss((e2b(), d2b), a);
}
function x5b(a) {
    u5b();
    return ss((A5b(), z5b), a);
}
function aYb(a) {
    TXb.call(this, a.d, a.c, a.a, a.b);
}
function NYb(a) {
    TXb.call(this, a.d, a.c, a.a, a.b);
}
function L7b(a) {
    I7b();
    return ss((O7b(), N7b), a);
}
function e3b() {
    e3b = Zcb;
    c3b = new n3b;
    d3b = new q3b;
}
function c8b() {
    c8b = Zcb;
    b8b = new r8b;
    a8b = new w8b;
}
function Adc() {
    Adc = Zcb;
    ydc = new bec;
    zdc = new dec;
}
function PWb(a, b, c) {
    this.e = b;
    this.b = a;
    this.d = c;
}
function ULb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function t0b(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function A3b(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function TVb(a, b, c) {
    this.b = a;
    this.a = b;
    this.c = c;
}
function R5b(a, b, c) {
    this.b = a;
    this.a = b;
    this.c = c;
}
function oKb(a, b, c) {
    this.b = a;
    this.c = b;
    this.a = c;
}
function bhc(a) {
    $gc();
    return ss((ehc(), dhc), a);
}
function Khc(a) {
    Ihc();
    return ss((Nhc(), Mhc), a);
}
function Fgc(a) {
    Dgc();
    return ss((Igc(), Hgc), a);
}
function Fic(a) {
    Dic();
    return ss((Iic(), Hic), a);
}
function Pmc(a) {
    Nmc();
    return ss((Smc(), Rmc), a);
}
function Xmc(a) {
    Vmc();
    return ss(($mc(), Zmc), a);
}
function hnc(a) {
    cnc();
    return ss((knc(), jnc), a);
}
function qnc(a) {
    onc();
    return ss((tnc(), snc), a);
}
function Enc(a) {
    znc();
    return ss((Hnc(), Gnc), a);
}
function Mnc(a) {
    Knc();
    return ss((Pnc(), Onc), a);
}
function Vnc(a) {
    Tnc();
    return ss((Ync(), Xnc), a);
}
function goc(a) {
    doc();
    return ss((joc(), ioc), a);
}
function ooc(a) {
    moc();
    return ss((roc(), qoc), a);
}
function Aoc(a) {
    yoc();
    return ss((Doc(), Coc), a);
}
function Moc(a) {
    Koc();
    return ss((Poc(), Ooc), a);
}
function apc(a) {
    $oc();
    return ss((dpc(), cpc), a);
}
function jpc(a) {
    hpc();
    return ss((mpc(), lpc), a);
}
function spc(a) {
    qpc();
    return ss((vpc(), upc), a);
}
function Apc(a) {
    ypc();
    return ss((Dpc(), Cpc), a);
}
function Qqc(a) {
    Oqc();
    return ss((Tqc(), Sqc), a);
}
function Yqc(a) {
    Wqc();
    return ss((_qc(), $qc), a);
}
function hxc(a) {
    cxc();
    return ss((kxc(), jxc), a);
}
function rxc(a) {
    oxc();
    return ss((uxc(), txc), a);
}
function Dxc(a) {
    zxc();
    return ss((Gxc(), Fxc), a);
}
function Rxc(a) {
    Mxc();
    return ss((Uxc(), Txc), a);
}
function fyc(a) {
    dyc();
    return ss((iyc(), hyc), a);
}
function pyc(a) {
    nyc();
    return ss((syc(), ryc), a);
}
function xyc(a) {
    vyc();
    return ss((Ayc(), zyc), a);
}
function Gyc(a) {
    Eyc();
    return ss((Jyc(), Iyc), a);
}
function Pyc(a) {
    Nyc();
    return ss((Syc(), Ryc), a);
}
function Yyc(a) {
    Wyc();
    return ss((_yc(), $yc), a);
}
function qzc(a) {
    ozc();
    return ss((tzc(), szc), a);
}
function zzc(a) {
    xzc();
    return ss((Czc(), Bzc), a);
}
function Izc(a) {
    Gzc();
    return ss((Lzc(), Kzc), a);
}
function WEc(a) {
    UEc();
    return ss((ZEc(), YEc), a);
}
function xHc(a) {
    vHc();
    return ss((AHc(), zHc), a);
}
function BKc(a) {
    zKc();
    return ss((EKc(), DKc), a);
}
function JKc(a) {
    HKc();
    return ss((MKc(), LKc), a);
}
function kNc(a) {
    iNc();
    return ss((nNc(), mNc), a);
}
function iPc(a) {
    gPc();
    return ss((lPc(), kPc), a);
}
function eQc(a) {
    _Pc();
    return ss((hQc(), gQc), a);
}
function aTc(a) {
    ZSc();
    return ss((dTc(), cTc), a);
}
function QTc(a) {
    OTc();
    return ss((TTc(), STc), a);
}
function xVc(a) {
    vVc();
    return ss((AVc(), zVc), a);
}
function FVc(a) {
    DVc();
    return ss((IVc(), HVc), a);
}
function FYc(a) {
    AYc();
    return ss((IYc(), HYc), a);
}
function mZc(a) {
    jZc();
    return ss((pZc(), oZc), a);
}
function m$c(a) {
    j$c();
    return ss((p$c(), o$c), a);
}
function c$c(a) {
    _Zc();
    return ss((f$c(), e$c), a);
}
function p_c(a) {
    m_c();
    return ss((s_c(), r_c), a);
}
function z_c(a) {
    w_c();
    return ss((C_c(), B_c), a);
}
function k0c(a) {
    i0c();
    return ss((n0c(), m0c), a);
}
function G0c(a) {
    D0c();
    return ss((J0c(), I0c), a);
}
function n1c(a) {
    l1c();
    return ss((q1c(), p1c), a);
}
function T2c(a) {
    O2c();
    return ss((W2c(), V2c), a);
}
function v3c(a) {
    q3c();
    return ss((y3c(), x3c), a);
}
function W3c(a) {
    R3c();
    return ss((Z3c(), Y3c), a);
}
function W5c(a) {
    S5c();
    return ss((Z5c(), Y5c), a);
}
function y5c(a) {
    w5c();
    return ss((B5c(), A5c), a);
}
function N5c(a) {
    I5c();
    return ss((Q5c(), P5c), a);
}
function K4c(a) {
    I4c();
    return ss((N4c(), M4c), a);
}
function c6c(a) {
    a6c();
    return ss((f6c(), e6c), a);
}
function n6c(a) {
    l6c();
    return ss((q6c(), p6c), a);
}
function u7c(a) {
    p7c();
    return ss((x7c(), w7c), a);
}
function F7c(a) {
    A7c();
    return ss((I7c(), H7c), a);
}
function ncd(a) {
    lcd();
    return ss((qcd(), pcd), a);
}
function Bcd(a) {
    zcd();
    return ss((Ecd(), Dcd), a);
}
function eed(a) {
    ced();
    return ss((hed(), ged), a);
}
function Jed(a) {
    Hed();
    return ss((Med(), Led), a);
}
function Ygd(a) {
    Tgd();
    return ss((_gd(), $gd), a);
}
function ghd(a) {
    ehd();
    return ss((jhd(), ihd), a);
}
function phd(a) {
    nhd();
    return ss((shd(), rhd), a);
}
function zhd(a) {
    xhd();
    return ss((Chd(), Bhd), a);
}
function Lhd(a) {
    Jhd();
    return ss((Ohd(), Nhd), a);
}
function gid(a) {
    eid();
    return ss((jid(), iid), a);
}
function rid(a) {
    oid();
    return ss((uid(), tid), a);
}
function Hid(a) {
    Eid();
    return ss((Kid(), Jid), a);
}
function Sid(a) {
    Qid();
    return ss((Vid(), Uid), a);
}
function ejd(a) {
    ajd();
    return ss((hjd(), gjd), a);
}
function sjd(a) {
    ojd();
    return ss((vjd(), ujd), a);
}
function Xjd(a) {
    Rjd();
    return ss(($jd(), Zjd), a);
}
function qkd(a) {
    okd();
    return ss((tkd(), skd), a);
}
function Akd(a) {
    ykd();
    return ss((Dkd(), Ckd), a);
}
function Pkd(a) {
    Nkd();
    return ss((Skd(), Rkd), a);
}
function Ykd(a) {
    Wkd();
    return ss((_kd(), $kd), a);
}
function eld(a) {
    cld();
    return ss((mld(), lld), a);
}
function qmd(a) {
    omd();
    return ss((tmd(), smd), a);
}
function dod(a) {
    bod();
    return ss((god(), fod), a);
}
function jmc(a, b) {
    return (tDb(a), a) + (tDb(b), b);
}
function ENc(a, b) {
    this.c = a;
    this.a = b;
    this.b = b - a;
}
function v2c(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function j8c(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function r8c(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function Mod(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function TAd(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function uLd(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function LAd(a, b, c) {
    this.a = a;
    this.c = b;
    this.b = c;
}
function B2d(a, b, c) {
    this.e = a;
    this.a = b;
    this.c = c;
}
function A4d(a, b, c) {
    N2d();
    h4d.call(this, a, b, c);
}
function M4d(a, b, c) {
    N2d();
    h4d.call(this, a, b, c);
}
function C4d(a, b, c) {
    N2d();
    A4d.call(this, a, b, c);
}
function E4d(a, b, c) {
    N2d();
    A4d.call(this, a, b, c);
}
function G4d(a, b, c) {
    N2d();
    E4d.call(this, a, b, c);
}
function O4d(a, b, c) {
    N2d();
    M4d.call(this, a, b, c);
}
function S4d(a, b, c) {
    N2d();
    h4d.call(this, a, b, c);
}
function U4d(a, b, c) {
    N2d();
    S4d.call(this, a, b, c);
}
function d3d(a, b, c) {
    N2d();
    X2d.call(this, a, b, c);
}
function DBd(a) {
    BBd();
    return ss((GBd(), FBd), a);
}
function ek(a, b) {
    Qb(a);
    Qb(b);
    return new fk(a, b);
}
function _q(a, b) {
    Qb(a);
    Qb(b);
    return new ir(a, b);
}
function dr(a, b) {
    Qb(a);
    Qb(b);
    return new or(a, b);
}
function zr(a, b) {
    Qb(a);
    Qb(b);
    return new Nr(a, b);
}
function JD(a, b) {
    BDb(a == null || ID(a, b));
    return a;
}
function $u(a) {
    var b;
    b = new Ulb;
    tr(b, a);
    return b;
}
function Rx(a) {
    var b;
    b = new Qrb;
    tr(b, a);
    return b;
}
function Ux(a) {
    var b;
    b = new lzb;
    Xq(b, a);
    return b;
}
function cv(a) {
    var b;
    b = new Mtb;
    Xq(b, a);
    return b;
}
function zDc(a) {
    !a.e && (a.e = new Ulb);
    return a.e;
}
function LVd(a) {
    !a.c && (a.c = new q5d);
    return a.c;
}
function cld() {
    cld = Zcb;
    ald = new hld;
    bld = new jld;
}
function gGc() {
    gGc = Zcb;
    eGc = (Rjd(), Qjd);
    fGc = wjd;
}
function Awb(a, b, c) {
    owb.call(this, b, c);
    this.a = a;
}
function cB(a, b) {
    this.c = a;
    this.b = b;
    this.a = false;
}
function Mg(a) {
    this.d = a;
    Jg(this);
    this.b = ed(a.d);
}
function DAb() {
    this.a = ';,;';
    this.b = '';
    this.c = '';
}
function ZAb(a, b, c) {
    this.b = a;
    dwb.call(this, b, c);
}
function itb(a, b, c) {
    this.c = a;
    okb.call(this, b, c);
}
function XCb(a, b, c) {
    UCb(c, 0, a, b, c.length, false);
}
function pSb(a, b, c) {
    oSb.call(this, a, b);
    this.b = c;
}
function NXb(a, b, c, d, e) {
    a.d = b;
    a.c = c;
    a.a = d;
    a.b = e;
}
function TRb(a, b, c, d, e) {
    a.b = b;
    a.c = c;
    a.d = d;
    a.a = e;
}
function WBb(a, b) {
    if (b) {
        a.b = b;
        a.a = (KAb(b), b.a);
    }
}
function lDb(a, b) {
    if (!a) throw scb(new Teb(b));
}
function yDb(a, b) {
    if (!a) throw scb(new Web(b));
}
function pDb(a, b) {
    if (!a) throw scb(new qdb(b));
}
function Yjc(a, b) {
    Ljc();
    return $eb(a.d.p, b.d.p);
}
function WWc(a, b) {
    EWc();
    return Heb(a.e.b, b.e.b);
}
function XWc(a, b) {
    EWc();
    return Heb(a.e.a, b.e.a);
}
function Itb(a) {
    rDb(a.b != 0);
    return Ktb(a, a.a.a);
}
function Jtb(a) {
    rDb(a.b != 0);
    return Ktb(a, a.c.b);
}
function K1b(a) {
    var b, c;
    b = a.b;
    c = a.c;
    a.b = c;
    a.c = b;
}
function N1b(a) {
    var b, c;
    c = a.d;
    b = a.a;
    a.d = b;
    a.a = c;
}
function ddd(a, b, c, d, e) {
    a.c = b;
    a.d = c;
    a.b = d;
    a.a = e;
}
function xdd(a, b) {
    udd(a);
    a.a *= b;
    a.b *= b;
    return a;
}
function vld(a, b) {
    b < 0 ? a.g = -1 : a.g = b;
    return a;
}
function iVd(a, b, c) {
    FUd.call(this, a, b);
    this.c = c;
}
function UPd(a) {
    TPd();
    FPd.call(this);
    this.$h(a);
}
function IWd(a, b, c) {
    this.a = a;
    gWd.call(this, b, c);
}
function NWd(a, b, c) {
    this.a = a;
    gWd.call(this, b, c);
}
function Wxd(a, b, c) {
    var d;
    d = new GC(c);
    kC(a, b, d);
}
function P1d(a, b) {
    var c;
    c = a.c;
    O1d(a, b);
    return c;
}
function dbe(a, b, c) {
    FUd.call(this, a, b);
    this.c = c;
}
function rae() {
    M9d();
    sae.call(this, (rOd(), qOd));
}
function JNb() {
    this.b = Beb(MD(JBd((IOb(), COb))));
}
function Lq(a) {
    this.b = a;
    this.a = dn(this.b.a).Md();
}
function ir(a, b) {
    this.b = a;
    this.a = b;
    xl.call(this);
}
function or(a, b) {
    this.a = a;
    this.b = b;
    xl.call(this);
}
function uic(a, b) {
    return $eb(ZYb(a.d), ZYb(b.d));
}
function wyb(a, b) {
    return !!b && xyb(a, b.d) ? b : null;
}
function xfc(a, b) {
    return b == (Rjd(), Qjd) ? a.c : a.d;
}
function $cd(a) {
    return new Edd(a.c + a.b, a.d + a.a);
}
function _Nd(a) {
    return a != null && !HNd(a, vNd, wNd);
}
function Cfb(a) {
    return a == 0 || isNaN(a) ? a : a < 0 ? -1 : 1;
}
function tn(a, b) {
    return cn(), ak(a, b), new ry(a, b);
}
function YNd(a, b) {
    return (cOd(a) << 4 | cOd(b)) & Wre;
}
function Atb(a, b) {
    Dtb(a, b, a.c.b, a.c);
    return true;
}
function TCb(a) {
    var b;
    b = a.slice();
    return XC(b, a);
}
function bHb(a) {
    var b;
    b = a.n;
    return a.a.b + b.d + b.a;
}
function $Hb(a) {
    var b;
    b = a.n;
    return a.e.b + b.d + b.a;
}
function _Hb(a) {
    var b;
    b = a.n;
    return a.e.a + b.b + b.c;
}
function roe(a) {
    ooe();
    ++noe;
    return new ape(0, a);
}
function Pfe() {
    Pfe = Zcb;
    Ofe = (pnb(), new dob(fGe));
}
function lfb() {
    lfb = Zcb;
    kfb = SC(UI, hre, 17, 256, 0, 1);
}
function qx() {
    qx = Zcb;
    new sx((il(), hl), (Uk(), Tk));
}
function URb() {
    TRb(this, false, false, false, false);
}
function gtb(a) {
    a.a.b = a.b;
    a.b.a = a.a;
    a.a = a.b = null;
}
function XYb(a) {
    return a.e.c.length + a.g.c.length;
}
function ZYb(a) {
    return a.e.c.length - a.g.c.length;
}
function Rgc(a) {
    return a.b.c.length - a.e.c.length;
}
function Efc(a, b) {
    return a.c < b.c ? -1 : a.c == b.c ? 0 : 1;
}
function vUb(a, b) {
    return uUb(a, new oSb(b.a, b.b));
}
function VOc(a, b, c) {
    return Qib(a.b, JD(c.b, 18), b);
}
function WOc(a, b, c) {
    return Qib(a.b, JD(c.b, 18), b);
}
function ZWc(a, b, c) {
    EWc();
    return c.e.b + c.f.b + a * b;
}
function PWc(a, b, c) {
    EWc();
    return c.e.a + c.f.a + a * b;
}
function GIc(a) {
    gIc();
    return (Rjd(), Bjd).Gc(a.j);
}
function GXb(a) {
    if (a.a) return a.a;
    return _Vb(a);
}
function BDb(a) {
    if (!a) throw scb(new zeb(null));
}
function jnd(a, b) {
    return Ilb(a, new Edd(b.a, b.b));
}
function dWb(a) {
    return !eWb(a) && a.c.i.c == a.d.i.c;
}
function cWc(a) {
    return UVc(), SC(NZ, Ize, 39, a, 0, 1);
}
function B4c(a, b, c, d) {
    C4c.call(this, a, b, c, d, 0, 0);
}
function Jge(a, b) {
    Zfe.call(this, a, b);
    this.a = this;
}
function uwb(a, b) {
    owb.call(this, b, 1040);
    this.a = a;
}
function eQd(a) {
    TPd();
    UPd.call(this, a);
    this.a = -1;
}
function hld() {
    dld.call(this, 'COUNT_CHILDREN', 0);
}
function kf(a) {
    this.c = a;
    this.b = this.c.d.vc().Jc();
}
function bj(a) {
    return a.e.Pd().gc() * a.c.Pd().gc();
}
function dk(a, b, c) {
    return new pk(gBb(a).Ze(), c, b);
}
function $Cb(a, b, c) {
    var d;
    d = a[b];
    a[b] = c;
    return d;
}
function leb(a, b) {
    var c;
    c = ieb(a, b);
    c.i = 2;
    return c;
}
function BEd(a, b) {
    var c;
    ++a.j;
    c = a.zj(b);
    return c;
}
function E9c(a, b, c) {
    a.a = -1;
    I9c(a, b.g, c);
    return a;
}
function QC(a, b, c, d, e, f) {
    return RC(a, b, c, d, e, 0, f);
}
function HQd(a, b) {
    IQd(a, b == null ? null : (tDb(b), b));
}
function L1d(a, b) {
    N1d(a, b == null ? null : (tDb(b), b));
}
function M1d(a, b) {
    N1d(a, b == null ? null : (tDb(b), b));
}
function pt(a) {
    if (a.c.e != a.a) throw scb(new yqb);
}
function wu(a) {
    if (a.e.c != a.b) throw scb(new yqb);
}
function wr(a) {
    Qb(a);
    while(a.Ob()){
        a.Pb();
        a.Qb();
    }
}
function vy(a) {
    qm();
    this.a = (pnb(), new dob(Qb(a)));
}
function dx(a) {
    a.a.jd();
    JD(a.a.kd(), 16).gc();
    Fh();
}
function kqb(a, b) {
    return tDb(a), Cdb(a, (tDb(b), b));
}
function pqb(a, b) {
    return tDb(b), Cdb(b, (tDb(a), a));
}
function Rgb(a, b) {
    a.a += zgb(b, 0, b.length);
    return a;
}
function Mlb(a, b) {
    sDb(b, a.c.length);
    return a.c[b];
}
function bnb(a, b) {
    sDb(b, a.a.length);
    return a.a[b];
}
function RBb(a, b) {
    wBb();
    MAb.call(this, a);
    this.a = b;
}
function ytb(a) {
    Trb.call(this, new Xsb);
    xe(this, a);
}
function crb(a) {
    this.c = a;
    this.a = new Drb(this.c.a);
}
function hgc(a) {
    this.a = a;
    this.c = new Irb;
    bgc(this);
}
function Srb(a) {
    this.a = new Jrb(a.gc());
    xe(this, a);
}
function VMb(a) {
    return !a.q ? (pnb(), pnb(), nnb) : a.q;
}
function yfc(a) {
    return a.c - JD(Mlb(a.a, a.b), 292).b;
}
function VCc(a, b) {
    return a ? 0 : $wnd.Math.max(0, b - 1);
}
function rkc(a, b, c) {
    return $eb(b.d[a.g], c.d[a.g]);
}
function zGc(a, b, c) {
    return $eb(a.d[b.p], a.d[c.p]);
}
function AGc(a, b, c) {
    return $eb(a.d[b.p], a.d[c.p]);
}
function BGc(a, b, c) {
    return $eb(a.d[b.p], a.d[c.p]);
}
function CGc(a, b, c) {
    return $eb(a.d[b.p], a.d[c.p]);
}
function Q4c(a, b, c) {
    return $wnd.Math.min(c / a, 1 / b);
}
function bmd(a) {
    if (a.c) return a.c.f;
    return a.e.b;
}
function cmd(a) {
    if (a.c) return a.c.g;
    return a.e.a;
}
function gmc(a, b) {
    a.a == null && emc(a);
    return a.a[b];
}
function OYc(a) {
    var b;
    b = UYc(a);
    return !b ? a : OYc(b);
}
function Hmb(a, b) {
    var c;
    for(c = 0; c < b; ++c)a[c] = -1;
}
function TXb(a, b, c, d) {
    KXb(this);
    NXb(this, a, b, c, d);
}
function iOd(a) {
    wDd.call(this, a.gc());
    vCd(this, a);
}
function g4d(a, b) {
    N2d();
    O2d.call(this, b);
    this.a = a;
}
function D5d(a, b, c) {
    this.a = a;
    qVd.call(this, b, c, 2);
}
function ape(a, b) {
    ooe();
    poe.call(this, a);
    this.a = b;
}
function Xnd(a) {
    this.b = new Mtb;
    this.a = a;
    this.c = -1;
}
function $r() {
    $r = Zcb;
    Zr = new _r(SC(aJ, Nqe, 1, 0, 5, 1));
}
function Afb() {
    Afb = Zcb;
    zfb = SC(XI, hre, 190, 256, 0, 1);
}
function Wfb() {
    Wfb = Zcb;
    Vfb = SC(cJ, hre, 191, 256, 0, 1);
}
function Qdb() {
    Qdb = Zcb;
    Pdb = SC(HI, hre, 219, 256, 0, 1);
}
function aeb() {
    aeb = Zcb;
    _db = SC(II, hre, 179, 128, 0, 1);
}
function Tod() {
    Tod = Zcb;
    Sod = new NBd((Lgd(), Xfd), 0);
}
function toe(a, b) {
    ooe();
    ++noe;
    return new jpe(a, b);
}
function LNd(a, b) {
    return a == null ? b == null : cgb(a, b);
}
function MNd(a, b) {
    return a == null ? b == null : dgb(a, b);
}
function qrb(a, b) {
    return RD(b, 23) && rrb(a, JD(b, 23));
}
function srb(a, b) {
    return RD(b, 23) && trb(a, JD(b, 23));
}
function fsb(a, b) {
    return dsb(a, b, esb(a, a.b.Ae(b)));
}
function ysb(a, b) {
    return !(a.a.get(b) === undefined);
}
function wvb(a) {
    return yvb(a, 26) * ete + yvb(a, 27) * fte;
}
function UC(a) {
    return Array.isArray(a) && a.Qm === bdb;
}
function hg(a) {
    a.b ? hg(a.b) : a.d.dc() && a.f.c.Ac(a.e);
}
function Pcb(a) {
    if (Ccb(a)) return a | 0;
    return xD(a);
}
function nrb(a, b) {
    var c;
    c = mrb(a);
    qnb(c, b);
    return c;
}
function Wz(a, b) {
    !a && (a = []);
    a[a.length] = b;
    return a;
}
function Hlb(a, b, c) {
    vDb(b, a.c.length);
    WCb(a.c, b, c);
}
function Pmb(a, b, c) {
    mDb(0, b, a.length);
    Nmb(a, 0, b, c);
}
function $Lb(a, b) {
    _Lb(a, Bdd(new Edd(b.a, b.b), a.c));
}
function _Lb(a, b) {
    mdd(a.c, b);
    a.b.c += b.a;
    a.b.d += b.b;
}
function DLb(a, b) {
    this.b = new Mtb;
    this.a = a;
    this.c = b;
}
function $Rb() {
    this.b = new kSb;
    this.c = new cSb(this);
}
function eFb() {
    this.d = new sFb;
    this.e = new kFb(this);
}
function Xzc() {
    Uzc();
    this.f = new Mtb;
    this.e = new Mtb;
}
function BIc() {
    gIc();
    this.k = new Irb;
    this.d = new Qrb;
}
function _r(a) {
    qc.call(this, 0, 0);
    this.a = a;
    this.b = 0;
}
function jld() {
    dld.call(this, 'LOOKAHEAD_LAYOUT', 1);
}
function acc(a, b, c) {
    Xbc(c, a, 1);
    Ilb(b, new Ycc(c, a));
}
function _bc(a, b, c) {
    Wbc(c, a, 1);
    Ilb(b, new Mcc(c, a));
}
function p5c(a, b, c) {
    return Nrb(a, new SDb(b.a, c.a));
}
function GAc(a, b, c) {
    return -$eb(a.f[b.p], a.f[c.p]);
}
function Gmb(a, b, c) {
    var d;
    for(d = 0; d < b; ++d)a[d] = c;
}
function pHb(a, b, c) {
    var d;
    if (a) {
        d = a.i;
        d.d = b;
        d.a = c;
    }
}
function oHb(a, b, c) {
    var d;
    if (a) {
        d = a.i;
        d.c = b;
        d.b = c;
    }
}
function C9c(a, b, c) {
    a.a = -1;
    I9c(a, b.g + 1, c);
    return a;
}
function CQd(a, b, c) {
    c = bqd(a, JD(b, 52), 3, c);
    return c;
}
function Fwd(a, b, c) {
    c = bqd(a, JD(b, 52), 7, c);
    return c;
}
function CVd(a, b, c) {
    this.a = a;
    uVd.call(this, b, c, 22);
}
function N0d(a, b, c) {
    this.a = a;
    uVd.call(this, b, c, 14);
}
function Z3d(a, b, c, d) {
    N2d();
    g3d.call(this, a, b, c, d);
}
function e4d(a, b, c, d) {
    N2d();
    g3d.call(this, a, b, c, d);
}
function yWd(a, b) {
    (b.Bb & RCe) != 0 && !a.a.o && (a.a.o = b);
}
function UD(a) {
    return a != null && WD(a) && !(a.Qm === bdb);
}
function QD(a) {
    return !Array.isArray(a) && a.Qm === bdb;
}
function ed(a) {
    return RD(a, 15) ? JD(a, 15).cd() : a.Jc();
}
function Ce(a) {
    return a.Oc(SC(aJ, Nqe, 1, a.gc(), 5, 1));
}
function nae(a, b) {
    return Pae(iae(a, b)) ? b.vi() : null;
}
function rx(a, b) {
    return Qb(b), a.a.Hd(b) && !a.b.Hd(b);
}
function dn(a) {
    if (a.c) return a.c;
    return a.c = a.Qd();
}
function en(a) {
    if (a.d) return a.d;
    return a.d = a.Rd();
}
function ee(a) {
    var b;
    b = a.f;
    return !b ? a.f = a.Cc() : b;
}
function Ec(a) {
    var b;
    b = a.i;
    return !b ? a.i = a.bc() : b;
}
function xoe(a) {
    ooe();
    ++noe;
    return new zpe(10, a, 0);
}
function Rpe(a) {
    Qpe();
    this.a = 0;
    this.b = a - 1;
    this.c = 1;
}
function fz(a) {
    Yy(this);
    this.g = a;
    $y(this);
    this.he();
}
function wg(a, b, c, d) {
    this.a = a;
    jg.call(this, a, b, c, d);
}
function es(a) {
    this.a = ($r(), Zr);
    this.d = JD(Qb(a), 49);
}
function Vce(a) {
    if (a.e.j != a.d) throw scb(new yqb);
}
function Qcb(a) {
    if (Ccb(a)) return '' + a;
    return yD(a);
}
function Jcb(a, b) {
    return wcb(sD(Ccb(a) ? Ncb(a) : a, b));
}
function Kcb(a, b) {
    return wcb(tD(Ccb(a) ? Ncb(a) : a, b));
}
function Lcb(a, b) {
    return wcb(uD(Ccb(a) ? Ncb(a) : a, b));
}
function zdb(a, b) {
    return Bdb((tDb(a), a), (tDb(b), b));
}
function Aeb(a, b) {
    return Heb((tDb(a), a), (tDb(b), b));
}
function lD(a, b) {
    return _C(a.l & b.l, a.m & b.m, a.h & b.h);
}
function rD(a, b) {
    return _C(a.l | b.l, a.m | b.m, a.h | b.h);
}
function zD(a, b) {
    return _C(a.l ^ b.l, a.m ^ b.m, a.h ^ b.h);
}
function IBb(a, b) {
    return LBb(a, (tDb(b), new xzb(b)));
}
function JBb(a, b) {
    return LBb(a, (tDb(b), new zzb(b)));
}
function CZb(a) {
    return VYb(), JD(a, 11).g.c.length != 0;
}
function HZb(a) {
    return VYb(), JD(a, 11).e.c.length != 0;
}
function F6b(a, b) {
    k6b();
    return Heb(b.a.o.a, a.a.o.a);
}
function Ukc(a, b, c) {
    return Vkc(a, JD(b, 11), JD(c, 11));
}
function xlc(a) {
    if (a.e) return Clc(a.e);
    return null;
}
function Evb(a) {
    if (!a.d) {
        a.d = a.b.Jc();
        a.c = a.b.gc();
    }
}
function fCb(a, b, c) {
    if (a.a.Mb(c)) {
        a.b = true;
        b.Ad(c);
    }
}
function _wb(a, b) {
    if (a < 0 || a >= b) throw scb(new ndb);
}
function QFc(a) {
    this.a = OFc(a.a);
    this.b = new Wlb(a.b);
}
function dvb(a) {
    this.b = new Vlb(11);
    this.a = (jqb(), a);
}
function Uxb(a) {
    this.b = null;
    this.a = (jqb(), !a ? gqb : a);
}
function $vb(a, b) {
    this.e = a;
    this.d = (b & 64) != 0 ? b | ire : b;
}
function owb(a, b) {
    this.c = 0;
    this.d = a;
    this.b = b | 64 | ire;
}
function MId(a) {
    this.b = a;
    LHd.call(this, a);
    LId(this);
}
function UId(a) {
    this.b = a;
    $Hd.call(this, a);
    TId(this);
}
function g_d(a, b, c, d, e) {
    h_d.call(this, a, b, c, d, e, -1);
}
function w_d(a, b, c, d, e) {
    x_d.call(this, a, b, c, d, e, -1);
}
function X0d(a, b, c, d) {
    qVd.call(this, a, b, c);
    this.b = d;
}
function djc(a, b, c, d) {
    var e;
    e = a.i;
    e.i = b;
    e.a = c;
    e.b = d;
}
function $Hc(a) {
    var b;
    b = a;
    while(b.f)b = b.f;
    return b;
}
function _cd(a) {
    return new Edd(a.c + a.b / 2, a.d + a.a / 2);
}
function hXd(a, b) {
    return b.Rh() ? zqd(a.b, JD(b, 52)) : b;
}
function qjd(a) {
    ojd();
    return !a.Gc(kjd) && !a.Gc(mjd);
}
function Ncd(a, b, c) {
    Icd();
    return Mcd(a, b) && Mcd(a, c);
}
function Pwc(a, b, c) {
    b.of(c, Beb(MD(Nib(a.b, c))) * a.a);
}
function WZc(a, b) {
    b.Sg("General 'Rotator", 1);
    VZc(a);
}
function Ree(a, b, c, d) {
    this.b = a;
    qVd.call(this, b, c, d);
}
function c1d(a, b, c) {
    this.a = a;
    _0d.call(this, b, c, 5, 6);
}
function Rj(a, b) {
    this.b = a;
    yj.call(this, a.b);
    this.a = b;
}
function bee(a, b, c, d) {
    iVd.call(this, a, b, c);
    this.b = d;
}
function q9d(a) {
    TDd.call(this, a, false);
    this.a = false;
}
function Bx(a, b) {
    qm();
    Ax.call(this, a, Mm(new dnb(b)));
}
function uoe(a, b) {
    ooe();
    ++noe;
    return new vpe(a, b, 0);
}
function woe(a, b) {
    ooe();
    ++noe;
    return new vpe(6, a, b);
}
function ngb(a, b) {
    return cgb(a.substr(0, b.length), b);
}
function Lib(a, b) {
    return VD(b) ? Pib(a, b) : !!fsb(a.f, b);
}
function Osb(a, b) {
    tDb(b);
    while(a.Ob())b.Ad(a.Pb());
}
function Vhb(a, b, c) {
    Ghb();
    this.e = a;
    this.d = b;
    this.a = c;
}
function Bmb(a, b, c, d) {
    mDb(b, c, a.length);
    Fmb(a, b, c, d);
}
function Fmb(a, b, c, d) {
    var e;
    for(e = b; e < c; ++e)a[e] = d;
}
function Jmb(a, b) {
    var c;
    for(c = 0; c < b; ++c)a[c] = false;
}
function pv(a, b) {
    var c;
    c = a.a.gc();
    Sb(b, c);
    return c - b;
}
function jlb(a) {
    var b;
    b = flb(a);
    rDb(b != null);
    return b;
}
function klb(a) {
    var b;
    b = glb(a);
    rDb(b != null);
    return b;
}
function Nrb(a, b) {
    var c;
    c = a.a.yc(b, a);
    return c == null;
}
function fzb(a, b) {
    return a.a.yc(b, (xdb(), vdb)) == null;
}
function Smb(a) {
    return new RBb(null, Rmb(a, a.length));
}
function Dl(a) {
    return new es(new Gl(a.a.length, a.a));
}
function qD(a) {
    return _C(~a.l & zse, ~a.m & zse, ~a.h & Ase);
}
function WD(a) {
    return typeof a === Cqe || typeof a === Gqe;
}
function ENb(a, b) {
    return a > 0 ? $wnd.Math.log(a / b) : -100;
}
function Tlc(a, b) {
    if (!b) return false;
    return xe(a, b);
}
function Bkb(a) {
    if (!a) throw scb(new qub);
    return a.d;
}
function uDb(a, b) {
    if (a == null) throw scb(new Ffb(b));
}
function Lqb(a, b, c) {
    orb(a.a, b);
    return $Cb(a.b, b.g, c);
}
function Vwb(a, b, c) {
    _wb(c, a.a.c.length);
    Rlb(a.a, c, b);
}
function JAd(a, b, c) {
    Yyd(a.a, a.b, a.d, a.c, JD(b, 168), c);
}
function Ybe(a, b) {
    CUd(a, RD(b, 159) ? b : JD(b, 1982).Ol());
}
function i9c(a, b, c) {
    a9c(a, b.g, c);
    orb(a.c, b);
    return a;
}
function HRb(a) {
    FRb(a, (Tgd(), Pgd));
    a.d = true;
    return a;
}
function Xae(a) {
    !a.j && bbe(a, Y9d(a.g, a.b));
    return a.j;
}
function CB(a, b, c) {
    var d;
    d = BB(a, b);
    DB(a, b, c);
    return d;
}
function rAb(a, b, c) {
    this.c = a;
    this.a = b;
    pnb();
    this.b = c;
}
function MHd(a, b) {
    this.d = a;
    CHd.call(this, a);
    this.e = b;
}
function jpe(a, b) {
    poe.call(this, 1);
    this.a = a;
    this.b = b;
}
function qmb(a) {
    xDb(a.b != -1);
    Olb(a.c, a.a = a.b);
    a.b = -1;
}
function Tib(a) {
    a.f = new isb(a);
    a.i = new Csb(a);
    ++a.g;
}
function wt(a) {
    a.a = null;
    a.e = null;
    Tib(a.b);
    a.d = 0;
    ++a.c;
}
function Ohb(a) {
    return a.e == 0 ? a : new Vhb(-a.e, a.d, a.a);
}
function vie(a) {
    return a == Kse ? nGe : a == Lse ? '-INF' : '' + a;
}
function xie(a) {
    return a == Kse ? nGe : a == Lse ? '-INF' : '' + a;
}
function Rmb(a, b) {
    return Zvb(b, a.length), new uwb(a, b);
}
function jLb(a, b) {
    return Heb(a.c.c + a.c.b, b.c.c + b.c.b);
}
function rfb(a, b) {
    return vcb(a, b) < 0 ? -1 : vcb(a, b) > 0 ? 1 : 0;
}
function IAb(a, b) {
    !a.c ? Ilb(a.b, b) : IAb(a.c, b);
    return a;
}
function Stb(a, b) {
    Dtb(a.d, b, a.b.b, a.b);
    ++a.a;
    a.c = null;
}
function Hvb(a) {
    this.d = (tDb(a), a);
    this.a = 0;
    this.c = mre;
}
function eNb(a) {
    dNb.call(this);
    this.a = a;
    Ilb(a.a, this);
}
function WNc(a, b) {
    this.d = eOc(a);
    this.c = b;
    this.a = 0.5 * b;
}
function Hkc(a, b, c) {
    Gkc.call(this, b, c, false);
    this.e = a;
}
function nhc(a, b, c, d, e) {
    mhc(a, JD(Qc(b.k, c), 15), c, d, e);
}
function egb(a, b, c, d, e) {
    while(b < c)d[e++] = _fb(a, b++);
}
function Imb(a, b, c) {
    var d;
    for(d = 0; d < b; ++d)VC(a, d, c);
}
function vCd(a, b) {
    a.Pi() && (b = ACd(a, b));
    return a.Ci(b);
}
function khc(a, b) {
    EBb(FBb(a.Mc(), new Uhc), new Whc(b));
}
function wRc(a, b) {
    return Heb(a.e.a + a.f.a, b.e.a + b.f.a);
}
function yRc(a, b) {
    return Heb(a.e.b + a.f.b, b.e.b + b.f.b);
}
function JIc(a) {
    return $wnd.Math.abs(a.d.e - a.e.e) - a.a;
}
function VTd(a) {
    return (a.i == null && MTd(a), a.i).length;
}
function JJd(a, b, c) {
    return JD(a.c.fd(b, JD(c, 135)), 43);
}
function Cs() {
    vs();
    return WC(OC(JG, 1), Ere, 534, 0, [
        us
    ]);
}
function OB() {
    OB = Zcb;
    MB = new PB(false);
    NB = new PB(true);
}
function GOd() {
    GOd = Zcb;
    FOd = u6d();
    !!(cPd(), IOd) && w6d();
}
function OMc(a) {
    a.s = NaN;
    a.c = NaN;
    PMc(a, a.e);
    PMc(a, a.j);
}
function rEd(a) {
    a ? az(a, (Zgb(), Ygb), '') : edb((Zgb(), a));
}
function pbe(a, b) {
    ++a.j;
    mce(a, a.i, b);
    obe(a, JD(b, 339));
}
function oRd(a, b) {
    b = a.Vk(null, b);
    return nRd(a, null, b);
}
function voe(a, b, c) {
    ooe();
    ++noe;
    return new rpe(a, b, c);
}
function Fc(a) {
    var b;
    b = a.j;
    return !b ? a.j = new Ow(a) : b;
}
function _i(a) {
    var b;
    b = a.f;
    return !b ? a.f = new Xj(a) : b;
}
function ii(a) {
    var b;
    return b = a.k, !b ? a.k = new zh(a) : b;
}
function Uc(a) {
    var b;
    return b = a.k, !b ? a.k = new zh(a) : b;
}
function Pc(a) {
    var b;
    return b = a.g, !b ? a.g = new rh(a) : b;
}
function cj(a) {
    var b;
    return b = a.i, !b ? a.i = new Ii(a) : b;
}
function yo(a) {
    var b;
    b = a.d;
    return !b ? a.d = new ip(a) : b;
}
function ieb(a, b) {
    var c;
    c = new geb;
    c.j = a;
    c.d = b;
    return c;
}
function jeb(a, b, c) {
    var d;
    d = ieb(a, b);
    web(c, d);
    return d;
}
function ov(a, b) {
    var c;
    c = a.a.gc();
    Pb(b, c);
    return c - 1 - b;
}
function wj(a, b) {
    Pb(b, a.c.b.c.gc());
    return new Lj(a, b);
}
function Vx(a) {
    if (RD(a, 601)) return a;
    return new ly(a);
}
function Qb(a) {
    if (a == null) throw scb(new Efb);
    return a;
}
function GC(a) {
    if (a == null) throw scb(new Efb);
    this.a = a;
}
function PA(a) {
    nA();
    this.b = new Ulb;
    this.a = a;
    AA(this, a);
}
function Vs(a) {
    this.b = a;
    this.a = JD(vub(this.b.a.e), 226);
}
function sfe() {
    Xsb.call(this);
    this.a = true;
    this.b = true;
}
function pgb(a, b) {
    ADb(b, a.length + 1);
    return a.substr(b);
}
function VC(a, b, c) {
    oDb(c == null || NC(a, c));
    return a[b] = c;
}
function Agb(a, b) {
    a.a += String.fromCharCode(b);
    return a;
}
function Kgb(a, b) {
    a.a += String.fromCharCode(b);
    return a;
}
function mwb(a, b) {
    tDb(b);
    while(a.c < a.d)a.Qe(b, a.c++);
}
function sq(a, b) {
    return JD(dn(a.a).Kd().Xb(b), 43).jd();
}
function Nib(a, b) {
    return VD(b) ? Oib(a, b) : Wd(fsb(a.f, b));
}
function E6b(a, b) {
    k6b();
    return JD(Kqb(a, b.d), 15).Ec(b);
}
function BPb(a, b, c, d) {
    return c == 0 || (c - d) / c < a.e || b >= a.g;
}
function oGc(a, b, c) {
    var d;
    d = uGc(a, b, c);
    return nGc(a, d);
}
function dDb(a, b) {
    var c;
    c = console[a];
    c.call(console, b);
}
function c8c(a, b, c) {
    JD(b.b, 68);
    Llb(b.a, new j8c(a, c, b));
}
function hBd(a, b) {
    Sxd(a, new GC(b.f != null ? b.f : '' + b.g));
}
function jBd(a, b) {
    Sxd(a, new GC(b.f != null ? b.f : '' + b.g));
}
function yEd(a, b) {
    var c;
    ++a.j;
    c = a.Bj();
    a.oj(a.Wi(c, b));
}
function Sxd(a, b) {
    var c;
    c = a.a.length;
    BB(a, c);
    DB(a, c, b);
}
function EQd(a) {
    !a.a && (a.a = new qVd(j6, a, 4));
    return a.a;
}
function EZd(a) {
    !a.d && (a.d = new qVd(g6, a, 1));
    return a.d;
}
function h$d(a) {
    return RD(a, 101) && (JD(a, 19).Bb & RCe) != 0;
}
function sdd(a) {
    return $wnd.Math.sqrt(a.a * a.a + a.b * a.b);
}
function rtb(a) {
    this.d = a;
    this.c = a.a.d.a;
    this.b = a.a.e.g;
}
function Vad(a) {
    this.c = a;
    this.a = new Mtb;
    this.b = new Mtb;
}
function b$b(a) {
    this.c = new Cdd;
    this.a = new Ulb;
    this.b = a;
}
function pRb(a) {
    this.b = new Ulb;
    this.a = new Ulb;
    this.c = a;
}
function Y4d(a, b, c) {
    this.a = a;
    e2d.call(this, b);
    this.b = c;
}
function $8d(a, b, c) {
    this.a = a;
    jGd.call(this, 8, b, null, c);
}
function vpe(a, b, c) {
    poe.call(this, a);
    this.a = b;
    this.b = c;
}
function h4d(a, b, c) {
    O2d.call(this, b);
    this.a = a;
    this.b = c;
}
function qt(a) {
    this.c = a;
    this.b = this.c.a;
    this.a = this.c.e;
}
function sae(a) {
    this.a = (tDb(rFe), rFe);
    this.b = a;
    new h1d;
}
function tjb(a) {
    xDb(a.c != -1);
    a.d.ed(a.c);
    a.b = a.c;
    a.c = -1;
}
function Iqb(a) {
    ze(a.a);
    a.b = SC(aJ, Nqe, 1, a.b.length, 5, 1);
}
function xyb(a, b) {
    return Hxb(a.c, a.f, b, a.b, a.a, a.e, a.d);
}
function Uwb(a, b) {
    return _wb(b, a.a.c.length), Mlb(a.a, b);
}
function Hb(a, b) {
    return XD(a) === XD(b) || a != null && pb(a, b);
}
function Fb(a) {
    vub(a);
    return RD(a, 470) ? JD(a, 470) : adb(a);
}
function xqe(a) {
    if (a) return a.dc();
    return !a.Jc().Ob();
}
function Foe(a) {
    if (!Vne) return false;
    return Pib(Vne, a);
}
function gBb(a) {
    if (0 >= a) return new qBb;
    return hBb(a - 1);
}
function gYb(a) {
    if (!a.a && !!a.c) return a.c.b;
    return a.a;
}
function vub(a) {
    if (a == null) throw scb(new Efb);
    return a;
}
function tDb(a) {
    if (a == null) throw scb(new Efb);
    return a;
}
function HAb(a) {
    if (!a.c) {
        a.d = true;
        JAb(a);
    } else a.c.Ye();
}
function KAb(a) {
    if (!a.c) {
        LAb(a);
        a.d = true;
    } else KAb(a.c);
}
function aFb(a) {
    a.b = false;
    a.c = false;
    a.d = false;
    a.a = false;
}
function xGc(a) {
    var b, c;
    b = a.c.i.c;
    c = a.d.i.c;
    return b == c;
}
function Fqd(a, b) {
    var c;
    c = a.Eh(b);
    c >= 0 ? a.gi(c) : xqd(a, b);
}
function Wnd(a, b) {
    a.c < 0 || a.b.b < a.c ? Ctb(a.b, b) : a.a.vf(b);
}
function Evd(a, b) {
    tCd((!a.a && (a.a = new $_d(a, a)), a.a), b);
}
function qm() {
    qm = Zcb;
    Yl();
    pm = new Gx((pnb(), pnb(), mnb));
}
function Lx() {
    Lx = Zcb;
    Yl();
    Kx = new Mx((pnb(), pnb(), onb));
}
function D8c(a, b, c) {
    w8c();
    return c.Jg(a, JD(b.jd(), 144));
}
function tic(a, b) {
    return $eb(b.j.c.length, a.j.c.length);
}
function NId(a, b) {
    this.b = a;
    MHd.call(this, a, b);
    LId(this);
}
function VId(a, b) {
    this.b = a;
    _Hd.call(this, a, b);
    TId(this);
}
function NLb(a, b) {
    _Lb(JD(b.b, 68), a);
    Llb(b.a, new SLb(a));
}
function SFd(a) {
    if (a.p != 3) throw scb(new Veb);
    return a.e;
}
function TFd(a) {
    if (a.p != 4) throw scb(new Veb);
    return a.e;
}
function VFd(a) {
    if (a.p != 6) throw scb(new Veb);
    return a.f;
}
function _Fd(a) {
    if (a.p != 3) throw scb(new Veb);
    return a.j;
}
function aGd(a) {
    if (a.p != 4) throw scb(new Veb);
    return a.j;
}
function cGd(a) {
    if (a.p != 6) throw scb(new Veb);
    return a.k;
}
function t5d(a) {
    !a.b && (a.b = new K5d(new G5d));
    return a.b;
}
function Tae(a) {
    a.c == -2 && Zae(a, Q9d(a.g, a.b));
    return a.c;
}
function meb(a, b) {
    var c;
    c = ieb('', a);
    c.n = b;
    c.i = 1;
    return c;
}
function gp(a, b, c, d) {
    cp.call(this, a, c);
    this.a = b;
    this.f = d;
}
function $s(a, b, c, d) {
    cp.call(this, a, b);
    this.d = c;
    this.a = d;
}
function ry(a, b) {
    Xp.call(this, xnb(Qb(a), Qb(b)));
    this.a = b;
}
function J9c() {
    b9c.call(this);
    _Cb(this.j.c, 0);
    this.a = -1;
}
function Wie() {
    hwd.call(this, eGe, (hhe(), ghe));
    Sie(this);
}
function t6d() {
    hwd.call(this, BFe, (EOd(), DOd));
    n6d(this);
}
function r7c() {
    ms.call(this, 'DELAUNAY_TRIANGULATION', 0);
}
function vgb(a) {
    return String.fromCharCode.apply(null, a);
}
function Qib(a, b, c) {
    return VD(b) ? Rib(a, b, c) : gsb(a.f, b, c);
}
function wnb(a) {
    pnb();
    return !a ? (jqb(), jqb(), iqb) : a.Me();
}
function Vu(a) {
    bk(a, Gre);
    return Xy(tcb(tcb(5, a), a / 10 | 0));
}
function ux(a, b) {
    qx();
    return new sx(new rl(a), new bl(b));
}
function tub(a, b) {
    return XD(a) === XD(b) || a != null && pb(a, b);
}
function Kqb(a, b) {
    return qrb(a.a, b) ? a.b[JD(b, 23).g] : null;
}
function QJb(a, b) {
    a.u.Gc((ojd(), kjd)) && OJb(a, b);
    SJb(a, b);
}
function EAc(a, b) {
    var c;
    c = new b$b(a);
    YCb(b.c, c);
    return c;
}
function gpb(a) {
    !a.a && (a.a = new Hpb(a.c.vc()));
    return a.a;
}
function ipb(a) {
    !a.b && (a.b = new Apb(a.c.ec()));
    return a.b;
}
function jpb(a) {
    !a.d && (a.d = new oob(a.c.Bc()));
    return a.d;
}
function Osd(a) {
    !a.n && (a.n = new X0d(z3, a, 1, 7));
    return a.n;
}
function Ptd(a) {
    !a.b && (a.b = new ree(v3, a, 4, 7));
    return a.b;
}
function Qtd(a) {
    !a.c && (a.c = new ree(v3, a, 5, 8));
    return a.c;
}
function f9c(a) {
    a.j.c.length = 0;
    ze(a.c);
    H9c(a.a);
    return a;
}
function _vd(a, b, c, d) {
    $vd(a, b, c, false);
    EYd(a, d);
    return a;
}
function hfb(a, b) {
    while(b-- > 0)a = a << 1 | (a < 0 ? 1 : 0);
    return a;
}
function $wd(a) {
    !a.c && (a.c = new X0d(B3, a, 9, 9));
    return a.c;
}
function cn() {
    cn = Zcb;
    bn = new Jx(WC(OC(LK, 1), tre, 43, 0, []));
}
function X5c() {
    S5c();
    return WC(OC(D0, 1), Ere, 543, 0, [
        R5c
    ]);
}
function O5c() {
    I5c();
    return WC(OC(C0, 1), Ere, 475, 0, [
        H5c
    ]);
}
function v7c() {
    p7c();
    return WC(OC(L0, 1), Ere, 524, 0, [
        o7c
    ]);
}
function Byd(a, b) {
    bCd(a, Beb(Zxd(b, 'x')), Beb(Zxd(b, 'y')));
}
function Oyd(a, b) {
    bCd(a, Beb(Zxd(b, 'x')), Beb(Zxd(b, 'y')));
}
function _fb(a, b) {
    ADb(b, a.length);
    return a.charCodeAt(b);
}
function jy(a, b) {
    this.b = a;
    this.c = b;
    this.a = new Drb(this.b);
}
function Blb(a) {
    this.d = a;
    this.a = this.d.b;
    this.b = this.d.c;
}
function Xfb(a, b, c) {
    this.a = Tre;
    this.d = a;
    this.b = b;
    this.c = c;
}
function Ivb(a, b) {
    this.d = (tDb(a), a);
    this.a = 16449;
    this.c = b;
}
function Wae(a) {
    a.f == gGe && abe(a, W9d(a.g, a.b));
    return a.f;
}
function Vae(a) {
    a.e == gGe && _ae(a, V9d(a.g, a.b));
    return a.e;
}
function Gh(a) {
    var b;
    b = a.b;
    !b && (a.b = b = new Vh(a));
    return b;
}
function ze(a) {
    var b;
    for(b = a.Jc(); b.Ob();){
        b.Pb();
        b.Qb();
    }
}
function Ak(a, b, c) {
    var d;
    d = JD(a.d.Kb(c), 158);
    !!d && d.Nb(b);
}
function Ly(a, b) {
    return new Jy(JD(Qb(a), 51), JD(Qb(b), 51));
}
function _Sb(a, b) {
    XSb();
    return Heb((tDb(a), a), (tDb(b), b));
}
function BBb(a, b) {
    LAb(a);
    return new RBb(a, new gCb(b, a.a));
}
function FBb(a, b) {
    LAb(a);
    return new RBb(a, new yCb(b, a.a));
}
function HBb(a, b) {
    LAb(a);
    return new nBb(a, new sCb(b, a.a));
}
function GBb(a, b) {
    LAb(a);
    return new VAb(a, new mCb(b, a.a));
}
function mFb(a, b) {
    return Heb(a.d.c + a.d.b / 2, b.d.c + b.d.b / 2);
}
function eSb(a, b) {
    return Heb(a.g.c + a.g.b / 2, b.g.c + b.g.b / 2);
}
function Tdc(a) {
    Adc();
    var b;
    b = JD(a.g, 9);
    b.n.a = a.d.c + b.d.b;
}
function _Vb(a) {
    var b;
    b = j_b(a);
    if (b) return b;
    return null;
}
function rub() {
    qz.call(this, 'There is no more element.');
}
function Eic(a, b, c, d) {
    ms.call(this, a, b);
    this.a = c;
    this.b = d;
}
function UIc(a, b, c, d) {
    this.c = a;
    this.b = b;
    this.a = c;
    this.d = d;
}
function xJc(a, b, c, d) {
    this.c = a;
    this.b = b;
    this.d = c;
    this.a = d;
}
function gdd(a, b, c, d) {
    this.c = a;
    this.d = b;
    this.b = c;
    this.a = d;
}
function rHc(a, b, c, d) {
    this.a = a;
    this.c = b;
    this.b = c;
    this.d = d;
}
function JNc(a, b, c, d) {
    this.a = a;
    this.d = b;
    this.c = c;
    this.b = d;
}
function DWb(a, b, c, d) {
    this.a = a;
    this.e = b;
    this.d = c;
    this.c = d;
}
function FCc(a) {
    this.a = new Ulb;
    this.e = SC(cE, hre, 54, a, 0, 2);
}
function RNd(a) {
    return a != null && kob(zNd, a.toLowerCase());
}
function Vld(a, b) {
    return Heb(cmd(a) * bmd(a), cmd(b) * bmd(b));
}
function Wld(a, b) {
    return Heb(cmd(a) * bmd(a), cmd(b) * bmd(b));
}
function hbc(a, b, c) {
    Sjc(a.a, c);
    gjc(c);
    hkc(a.b, c);
    Ajc(b, c);
}
function Rqd(a, b, c) {
    var d, e;
    d = JNd(a);
    e = b.pi(c, d);
    return e;
}
function Pvd(a) {
    var b, c;
    c = (b = new NZd, b);
    GZd(c, a);
    return c;
}
function Qvd(a) {
    var b, c;
    c = (b = new NZd, b);
    KZd(c, a);
    return c;
}
function Ywd(a) {
    !a.b && (a.b = new X0d(x3, a, 12, 3));
    return a.b;
}
function Lg(a) {
    gg(a.d);
    if (a.d.d != a.c) throw scb(new yqb);
}
function S2d(a, b, c, d) {
    this.a = a;
    this.c = b;
    this.d = c;
    this.b = d;
}
function KAd(a, b, c, d) {
    this.a = a;
    this.b = b;
    this.d = c;
    this.c = d;
}
function Lzd(a, b, c, d) {
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
}
function Nzd(a, b, c, d) {
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
}
function C2d(a, b, c, d) {
    this.e = a;
    this.a = b;
    this.c = c;
    this.d = d;
}
function X3d(a, b, c, d) {
    N2d();
    f3d.call(this, b, c, d);
    this.a = a;
}
function c4d(a, b, c, d) {
    N2d();
    f3d.call(this, b, c, d);
    this.a = a;
}
function Tg(a, b) {
    this.a = a;
    Ng.call(this, a, JD(a.d, 15).dd(b));
}
function VKd(a) {
    this.f = a;
    this.c = this.f.e;
    a.f > 0 && UKd(this);
}
function bCb(a, b, c, d) {
    this.b = a;
    this.c = d;
    lwb.call(this, b, c);
}
function Ltb(a) {
    a.a.a = a.c;
    a.c.b = a.a;
    a.a.b = a.c.a = null;
    a.b = 0;
}
function MXb(a, b) {
    a.b = b.b;
    a.c = b.c;
    a.d = b.d;
    a.a = b.a;
    return a;
}
function $y(a) {
    if (a.n) {
        a.e !== Mre && a.he();
        a.j = null;
    }
    return a;
}
function ND(a) {
    BDb(a == null || WD(a) && !(a.Qm === bdb));
    return a;
}
function sjb(a) {
    rDb(a.b < a.d.gc());
    return a.d.Xb(a.c = a.b++);
}
function zbc(a, b) {
    JD(WMb(a, (Iqc(), aqc)), 15).Ec(b);
    return b;
}
function e9b(a, b) {
    return Rc(a, JD(WMb(b, (Bwc(), wvc)), 17), b);
}
function z$b(a) {
    return Std(a) && ydb(LD(ksd(a, (Bwc(), Ouc))));
}
function nd(a) {
    var b;
    return b = a.f, !b ? a.f = new me(a, a.c) : b;
}
function pdc(a, b, c) {
    jdc();
    return $Eb(JD(Nib(a.e, b), 514), c);
}
function rfc(a, b, c) {
    a.i = 0;
    a.e = 0;
    if (b == c) return;
    nfc(a, b, c);
}
function sfc(a, b, c) {
    a.i = 0;
    a.e = 0;
    if (b == c) return;
    ofc(a, b, c);
}
function Blc(a, b) {
    if (!!a.e && !a.e.a) {
        zlc(a.e, b);
        Blc(a.e, b);
    }
}
function Alc(a, b) {
    if (!!a.d && !a.d.a) {
        zlc(a.d, b);
        Alc(a.d, b);
    }
}
function BDc(a, b) {
    this.g = a;
    this.d = WC(OC(RP, 1), Jve, 9, 0, [
        b
    ]);
}
function ZQc(a, b) {
    new Mtb;
    this.a = new Rdd;
    this.b = a;
    this.c = b;
}
function S0b(a) {
    this.b = new Ulb;
    Klb(this.b, this.b);
    this.a = a;
}
function gwd() {
    dwd(this, new avd);
    this.wb = (GOd(), FOd);
    EOd();
}
function Qnd(a) {
    return JD(a.jd(), 144).Ng() + ':' + adb(a.kd());
}
function qNc(a, b) {
    return YNc(a.j, b.s, b.c) + YNc(b.e, a.s, a.c);
}
function Uld(a, b) {
    return -Heb(cmd(a) * bmd(a), cmd(b) * bmd(b));
}
function Uxd(a, b, c) {
    var d, e;
    d = Hdb(c);
    e = new _B(d);
    kC(a, b, e);
}
function w9c(a, b) {
    rb(a);
    rb(b);
    return js(JD(a, 23), JD(b, 23));
}
function HFc(a) {
    a.Sg('No crossing minimization', 1);
    a.Tg();
}
function Oz(a) {
    Iz();
    $wnd.setTimeout(function() {
        throw a;
    }, 0);
}
function STd(a) {
    !a.s && (a.s = new X0d(q6, a, 21, 17));
    return a.s;
}
function PTd(a) {
    !a.q && (a.q = new X0d(k6, a, 11, 10));
    return a.q;
}
function Xwd(a) {
    !a.a && (a.a = new X0d(A3, a, 10, 11));
    return a.a;
}
function Rb(a, b) {
    if (a == null) throw scb(new Ffb(b));
    return a;
}
function pnb() {
    pnb = Zcb;
    mnb = new Anb;
    nnb = new Tnb;
    onb = new _nb;
}
function jqb() {
    jqb = Zcb;
    gqb = new lqb;
    hqb = new lqb;
    iqb = new qqb;
}
function EEb() {
    EEb = Zcb;
    BEb = new zEb;
    DEb = new eFb;
    CEb = new XEb;
}
function Zz() {
    Zz = Zcb;
    var a, b;
    b = !dA();
    a = new lA;
    Yz = b ? new eA : a;
}
function ar(a) {
    Qb(a);
    return Ar(new es(Ir(a.a.Jc(), new er)));
}
function Ti(a) {
    return new gj(a, a.e.Pd().gc() * a.c.Pd().gc());
}
function dj(a) {
    return new qj(a, a.e.Pd().gc() * a.c.Pd().gc());
}
function Qx(a) {
    return RD(a, 16) ? new Srb(JD(a, 16)) : Rx(a.Jc());
}
function ynb(a) {
    pnb();
    return RD(a, 59) ? new Zpb(a) : new Kob(a);
}
function Pib(a, b) {
    return b == null ? !!fsb(a.f, null) : ysb(a.i, b);
}
function Az(a) {
    return !!a && !!a.hashCode ? a.hashCode() : jDb(a);
}
function Cu(a) {
    this.b = a;
    this.c = a;
    a.e = null;
    a.c = null;
    this.a = 1;
}
function iMb(a) {
    this.b = a;
    this.a = new mzb(JD(Qb(new lMb), 51));
}
function kFb(a) {
    this.c = a;
    this.b = new mzb(JD(Qb(new nFb), 51));
}
function cSb(a) {
    this.c = a;
    this.b = new mzb(JD(Qb(new fSb), 51));
}
function kWb() {
    this.a = new Rdd;
    this.b = (bk(3, Dre), new Vlb(3));
}
function dNb() {
    this.c = new Cdd;
    this.d = new Cdd;
    this.e = new Cdd;
}
function wLc() {
    this.b = new Qrb;
    this.d = new Mtb;
    this.e = new txb;
}
function hdd(a) {
    this.c = a.c;
    this.d = a.d;
    this.b = a.b;
    this.a = a.a;
}
function Nee(a, b, c, d) {
    FUd.call(this, b, c);
    this.b = a;
    this.a = d;
}
function Jy(a, b) {
    ui.call(this, new Uxb(a));
    this.a = a;
    this.b = b;
}
function zGd(a, b, c, d, e, f) {
    this.a = a;
    kGd.call(this, b, c, d, e, f);
}
function sHd(a, b, c, d, e, f) {
    this.a = a;
    kGd.call(this, b, c, d, e, f);
}
function y_d(a, b, c, d, e, f) {
    x_d.call(this, a, b, c, d, e, f ? -2 : -1);
}
function LEb(a, b, c) {
    if (a.f) return a.f.cf(b, c);
    return false;
}
function UTd(a) {
    if (!a.u) {
        TTd(a);
        a.u = new RXd(a, a);
    }
    return a.u;
}
function rRb(a, b) {
    var c;
    c = Prb(a.a, b);
    c && (b.d = null);
    return c;
}
function yrd(a) {
    var b;
    b = JD(Crd(a, 16), 29);
    return !b ? a.ei() : b;
}
function dz(a, b) {
    var c;
    c = eeb(a.Om);
    return b == null ? c : c + ': ' + b;
}
function D2d(a, b) {
    this.e = a;
    this.a = aJ;
    this.b = Kee(b);
    this.c = b;
}
function IBd(a, b) {
    return RD(b, 144) && cgb(a.b, JD(b, 144).Ng());
}
function m9d(a, b) {
    return a.a ? b.Ch().Jc() : JD(b.Ch(), 71).Fi();
}
function vRc(a, b, c) {
    return Beb(MD(c.a)) <= a && Beb(MD(c.b)) >= b;
}
function ogb(a, b, c) {
    return c >= 0 && cgb(a.substr(c, b.length), b);
}
function Abe(a, b, c, d, e, f, g) {
    return new Gge(a.e, b, c, d, e, f, g);
}
function izc(a, b, c, d) {
    VC(a.c[b.g], b.g, c);
    VC(a.b[b.g], b.g, d);
}
function fzc(a, b, c, d) {
    VC(a.c[b.g], c.g, d);
    VC(a.c[c.g], b.g, d);
}
function qgb(a, b, c) {
    zDb(b, c, a.length);
    return a.substr(b, c - b);
}
function Fpb(a, b) {
    var c;
    c = a.b.Oc(b);
    Gpb(c, a.b.gc());
    return c;
}
function wub(a, b) {
    if (a == null) throw scb(new Ffb(b));
    return a;
}
function Gx(a) {
    this.a = (pnb(), RD(a, 59) ? new Zpb(a) : new Kob(a));
}
function edb(a) {
    !a ? Rqe : dz(a, a.ge());
    String.fromCharCode(10);
}
function eIb(a, b) {
    aHb.call(this);
    VHb(this);
    this.a = a;
    this.c = b;
}
function eOb() {
    bOb();
    return WC(OC(hO, 1), Ere, 421, 0, [
        _Nb,
        aOb
    ]);
}
function c2b() {
    _1b();
    return WC(OC(bR, 1), Ere, 501, 0, [
        $1b,
        Z1b
    ]);
}
function CKc() {
    zKc();
    return WC(OC(tY, 1), Ere, 507, 0, [
        yKc,
        xKc
    ]);
}
function KKc() {
    HKc();
    return WC(OC(uY, 1), Ere, 506, 0, [
        FKc,
        GKc
    ]);
}
function yHc() {
    vHc();
    return WC(OC(AX, 1), Ere, 516, 0, [
        uHc,
        tHc
    ]);
}
function yyc() {
    vyc();
    return WC(OC(lW, 1), Ere, 418, 0, [
        tyc,
        uyc
    ]);
}
function Ymc() {
    Vmc();
    return WC(OC(NV, 1), Ere, 419, 0, [
        Tmc,
        Umc
    ]);
}
function Nnc() {
    Knc();
    return WC(OC(RV, 1), Ere, 416, 0, [
        Inc,
        Jnc
    ]);
}
function Bpc() {
    ypc();
    return WC(OC($V, 1), Ere, 417, 0, [
        wpc,
        xpc
    ]);
}
function poc() {
    moc();
    return WC(OC(UV, 1), Ere, 474, 0, [
        loc,
        koc
    ]);
}
function U2c() {
    O2c();
    return WC(OC(b0, 1), Ere, 476, 0, [
        M2c,
        N2c
    ]);
}
function Zqc() {
    Wqc();
    return WC(OC(aW, 1), Ere, 420, 0, [
        Vqc,
        Uqc
    ]);
}
function GVc() {
    DVc();
    return WC(OC(y$, 1), Ere, 422, 0, [
        CVc,
        BVc
    ]);
}
function GYc() {
    AYc();
    return WC(OC(g_, 1), Ere, 485, 0, [
        yYc,
        zYc
    ]);
}
function G7c() {
    A7c();
    return WC(OC(M0, 1), Ere, 424, 0, [
        z7c,
        y7c
    ]);
}
function d6c() {
    a6c();
    return WC(OC(E0, 1), Ere, 425, 0, [
        _5c,
        $5c
    ]);
}
function d$c() {
    _Zc();
    return WC(OC(v_, 1), Ere, 423, 0, [
        ZZc,
        $Zc
    ]);
}
function lNc() {
    iNc();
    return WC(OC(RY, 1), Ere, 513, 0, [
        hNc,
        gNc
    ]);
}
function jPc() {
    gPc();
    return WC(OC(kZ, 1), Ere, 451, 0, [
        ePc,
        fPc
    ]);
}
function fld() {
    cld();
    return WC(OC(E2, 1), Ere, 343, 0, [
        ald,
        bld
    ]);
}
function nqd(a, b, c, d) {
    return c >= 0 ? a.Qh(b, c, d) : a.yh(null, c, d);
}
function Vnd(a) {
    if (a.b.b == 0) return a.a.uf();
    return Itb(a.b);
}
function UFd(a) {
    if (a.p != 5) throw scb(new Veb);
    return Pcb(a.f);
}
function bGd(a) {
    if (a.p != 5) throw scb(new Veb);
    return Pcb(a.k);
}
function iWd(a) {
    XD(a.a) === XD((GTd(), FTd)) && jWd(a);
    return a.a;
}
function Px(a, b) {
    Rb(a, 'set1');
    Rb(b, 'set2');
    return new ay(a, b);
}
function EOc(a, b) {
    BOc(this, new Edd(a.a, a.b));
    COc(this, cv(b));
}
function Pp() {
    Op.call(this, new Jrb(Ov(12)));
    Lb(true);
    this.a = 2;
}
function zpe(a, b, c) {
    ooe();
    poe.call(this, a);
    this.b = b;
    this.a = c;
}
function X2d(a, b, c) {
    N2d();
    O2d.call(this, b);
    this.a = a;
    this.b = c;
}
function ftb(a) {
    var b;
    b = a.c.d.b;
    a.b = b;
    a.a = a.c.d;
    b.a = a.c.d.b = a;
}
function y4c(a, b) {
    a.b = b;
    a.c > 0 && a.b > 0 && (a.g = Q4c(a.c, a.b, a.a));
}
function z4c(a, b) {
    a.c = b;
    a.c > 0 && a.b > 0 && (a.g = Q4c(a.c, a.b, a.a));
}
function Htb(a) {
    return a.b == 0 ? null : (rDb(a.b != 0), Ktb(a, a.a.a));
}
function Oib(a, b) {
    return b == null ? Wd(fsb(a.f, null)) : zsb(a.i, b);
}
function Rxb(a, b, c, d, e) {
    return new yyb(a, (Syb(), Qyb), b, c, d, e);
}
function wmb(a, b) {
    nDb(b);
    return ymb(a, SC(cE, ise, 30, b, 15, 1), b);
}
function kKb(a, b) {
    jKb(a, true);
    Llb(a.e.Pf(), new oKb(a, true, b));
}
function QDb(a) {
    var b;
    PGb(a.a);
    OGb(a.a);
    b = new $Gb(a.a);
    WGb(b);
}
function aRb(a, b) {
    var c;
    c = LQb(a.f, b);
    return mdd(tdd(c), a.f.d);
}
function Lxb(a, b) {
    var c, d;
    c = b;
    d = new uyb;
    Nxb(a, c, d);
    return d.d;
}
function PJb(a, b, c, d) {
    var e;
    e = new cHb;
    b.a[c.g] = e;
    Lqb(a.b, d, e);
}
function p4c(a, b, c) {
    this.c = new Ulb;
    this.e = a;
    this.f = b;
    this.b = c;
}
function x4c(a, b, c) {
    this.a = new Ulb;
    this.e = a;
    this.f = b;
    this.c = c;
}
function G5c(a, b, c) {
    this.i = new Ulb;
    this.b = a;
    this.g = b;
    this.a = c;
}
function cIb(a) {
    aHb.call(this);
    VHb(this);
    this.a = a;
    this.c = true;
}
function ly(a) {
    this.a = JD(Qb(a), 274);
    this.b = (pnb(), new $pb(a));
}
function Bqd(a, b, c) {
    var d;
    d = a.Eh(b);
    d >= 0 ? a.Zh(d, c) : wqd(a, b, c);
}
function eEd(a, b, c) {
    bEd();
    !!a && Qib(aEd, a, b);
    !!a && Qib(_Dd, a, c);
}
function UWc(a, b) {
    EWc();
    return JD(WMb(b, (kVc(), iVc)), 17).a == a;
}
function YD(a) {
    return Math.max(Math.min(a, Hqe), -2147483648) | 0;
}
function Cz(a, b) {
    var c = Bz[a.charCodeAt(0)];
    return c == null ? a : c;
}
function Otd(a) {
    if (a.Db >> 16 != 3) return null;
    return JD(a.Cb, 27);
}
function oxd(a) {
    if (a.Db >> 16 != 9) return null;
    return JD(a.Cb, 27);
}
function hud(a) {
    if (a.Db >> 16 != 6) return null;
    return JD(a.Cb, 85);
}
function qeb(a) {
    if (a.ye()) return null;
    var b = a.n;
    return Xcb[b];
}
function iC(a, b) {
    if (b == null) throw scb(new Efb);
    return jC(a, b);
}
function hlb(a, b) {
    if (blb(a, b)) {
        Alb(a);
        return true;
    }
    return false;
}
function _cb(a) {
    function b() {}
    b.prototype = a || {};
    return new b;
}
function Sx(a) {
    var b;
    b = new Rrb(Ov(a.length));
    qnb(b, a);
    return b;
}
function LXb(a, b) {
    a.b += b.b;
    a.c += b.c;
    a.d += b.d;
    a.a += b.a;
    return a;
}
function vo(a, b) {
    var c;
    Qb(b);
    for(c = a.a; c; c = c.c)b.Wd(c.g, c.i);
}
function fB(a, b) {
    var c;
    c = a.q.getHours();
    a.q.setDate(b);
    eB(a, c);
}
function b1b(a, b) {
    return $wnd.Math.abs(a) < $wnd.Math.abs(b) ? a : b;
}
function o8b(a, b) {
    c8b();
    return xdb(), JD(b.a, 17).a < a ? true : false;
}
function n8b(a, b) {
    c8b();
    return xdb(), JD(b.b, 17).a < a ? true : false;
}
function pqd(a, b) {
    var c;
    c = a.Eh(b);
    return c >= 0 ? a.Sh(c) : vqd(a, b);
}
function sGc(a, b, c) {
    var d;
    d = tGc(a, b, c);
    a.b = new cGc(d.c.length);
}
function zKc() {
    zKc = Zcb;
    yKc = new AKc(aue, 0);
    xKc = new AKc(_te, 1);
}
function HKc() {
    HKc = Zcb;
    FKc = new IKc(lue, 0);
    GKc = new IKc('UP', 1);
}
function gPc() {
    gPc = Zcb;
    ePc = new hPc(_te, 0);
    fPc = new hPc(aue, 1);
}
function ACd(a, b) {
    var c;
    c = new ytb(b);
    Te(c, a);
    return new Wlb(c);
}
function RDd(a) {
    var b;
    b = a.d;
    b = a.$i(a.f);
    tCd(a, b);
    return b.Ob();
}
function PFd(a) {
    if (a.p != 0) throw scb(new Veb);
    return Hcb(a.f, 0);
}
function YFd(a) {
    if (a.p != 0) throw scb(new Veb);
    return Hcb(a.k, 0);
}
function Kvd(a) {
    if (a.Db >> 16 != 7) return null;
    return JD(a.Cb, 240);
}
function Hwd(a) {
    if (a.Db >> 16 != 7) return null;
    return JD(a.Cb, 173);
}
function Zwd(a) {
    if (a.Db >> 16 != 11) return null;
    return JD(a.Cb, 27);
}
function PRd(a) {
    if (a.Db >> 16 != 17) return null;
    return JD(a.Cb, 29);
}
function SSd(a) {
    if (a.Db >> 16 != 6) return null;
    return JD(a.Cb, 240);
}
function FQd(a) {
    if (a.Db >> 16 != 3) return null;
    return JD(a.Cb, 154);
}
function oeb(a, b) {
    var c = a.a = a.a || [];
    return c[b] || (c[b] = a.te(b));
}
function iB(a, b) {
    var c;
    c = a.q.getHours();
    a.q.setMonth(b);
    eB(a, c);
}
function ABb(a) {
    var b;
    LAb(a);
    b = new Qrb;
    return BBb(a, new _Bb(b));
}
function bEd() {
    bEd = Zcb;
    aEd = new Irb;
    _Dd = new Irb;
    fEd(qK, new gEd);
}
function eEb() {
    this.a = new wtb;
    this.e = new Qrb;
    this.g = 0;
    this.i = 0;
}
function gz(a, b) {
    Yy(this);
    this.f = b;
    this.g = a;
    $y(this);
    this.he();
}
function bMb(a, b) {
    this.a = a;
    this.c = odd(this.a);
    this.b = new hdd(b);
}
function _Db(a, b, c) {
    this.a = b;
    this.c = a;
    this.b = (Qb(c), new Wlb(c));
}
function CTb(a, b, c) {
    this.a = b;
    this.c = a;
    this.b = (Qb(c), new Wlb(c));
}
function cFc(a) {
    this.a = a;
    this.b = SC(eX, hre, 1989, a.e.length, 0, 2);
}
function _wd(a) {
    return !a.a && (a.a = new X0d(A3, a, 10, 11)), a.a.i > 0;
}
function yUd(a, b, c, d, e, f) {
    return new i_d(a.e, b, a.Ij(), c, d, e, f);
}
function Rib(a, b, c) {
    return b == null ? gsb(a.f, null, c) : Asb(a.i, b, c);
}
function gWb(a, b) {
    !!a.c && Plb(a.c.g, a);
    a.c = b;
    !!a.c && Ilb(a.c.g, a);
}
function qYb(a, b) {
    !!a.c && Plb(a.c.a, a);
    a.c = b;
    !!a.c && Ilb(a.c.a, a);
}
function _Yb(a, b) {
    !!a.i && Plb(a.i.j, a);
    a.i = b;
    !!a.i && Ilb(a.i.j, a);
}
function hWb(a, b) {
    !!a.d && Plb(a.d.e, a);
    a.d = b;
    !!a.d && Ilb(a.d.e, a);
}
function vDb(a, b) {
    if (a < 0 || a > b) throw scb(new mdb(yte + a + zte + b));
}
function jq(a, b, c) {
    Ilb(a.a, (cn(), ak(b, c), new cp(b, c)));
    return a;
}
function cNc(a, b) {
    !!a.a && Plb(a.a.k, a);
    a.a = b;
    !!a.a && Ilb(a.a.k, a);
}
function dNc(a, b) {
    !!a.b && Plb(a.b.f, a);
    a.b = b;
    !!a.b && Ilb(a.b.f, a);
}
function eNc(a, b, c, d) {
    this.c = a;
    this.d = d;
    cNc(this, b);
    dNc(this, c);
}
function jAc() {
    jAc = Zcb;
    iAc = C9c(new J9c, (CQb(), BQb), (u5b(), l5b));
}
function Nzc() {
    Nzc = Zcb;
    Mzc = C9c(new J9c, (CQb(), BQb), (u5b(), l5b));
}
function Uzc() {
    Uzc = Zcb;
    Tzc = C9c(new J9c, (CQb(), BQb), (u5b(), l5b));
}
function DHc() {
    DHc = Zcb;
    CHc = E9c(new J9c, (CQb(), BQb), (u5b(), L4b));
}
function gIc() {
    gIc = Zcb;
    fIc = E9c(new J9c, (CQb(), BQb), (u5b(), L4b));
}
function jKc() {
    jKc = Zcb;
    iKc = E9c(new J9c, (CQb(), BQb), (u5b(), L4b));
}
function ZKc() {
    ZKc = Zcb;
    YKc = E9c(new J9c, (CQb(), BQb), (u5b(), L4b));
}
function KVc() {
    KVc = Zcb;
    JVc = C9c(new J9c, (_Pc(), ZPc), (ZSc(), PSc));
}
function Es() {
    Es = Zcb;
    Ds = os((vs(), WC(OC(JG, 1), Ere, 534, 0, [
        us
    ])));
}
function gRb(a) {
    XQb();
    return xdb(), JD(a.a, 82).d.e != 0 ? true : false;
}
function mYc(a, b) {
    return Heb(JD(a.c, 65).c.e.b, JD(b.c, 65).c.e.b);
}
function nYc(a, b) {
    return Heb(JD(a.c, 65).c.e.a, JD(b.c, 65).c.e.a);
}
function b8c(a, b) {
    c8c(a, a.b, a.c);
    JD(a.b.b, 68);
    !!b && JD(b.b, 68).b;
}
function u1d(a, b) {
    v1d(a, b);
    RD(a.Cb, 88) && QVd(TTd(JD(a.Cb, 88)), 2);
}
function XRd(a, b) {
    RD(a.Cb, 88) && QVd(TTd(JD(a.Cb, 88)), 4);
    rvd(a, b);
}
function eTd(a, b) {
    RD(a.Cb, 184) && (JD(a.Cb, 184).tb = null);
    rvd(a, b);
}
function Mw(a, b) {
    var c;
    c = JD(Tv(nd(a.a), b), 16);
    return !c ? 0 : c.gc();
}
function iBd(a, b) {
    var c, d;
    c = b.c;
    d = c != null;
    d && Sxd(a, new GC(b.c));
}
function QXd(a) {
    var b, c;
    c = (EOd(), b = new NZd, b);
    GZd(c, a);
    return c;
}
function Z_d(a) {
    var b, c;
    c = (EOd(), b = new NZd, b);
    GZd(c, a);
    return c;
}
function Br(a) {
    var b;
    while(true){
        b = a.Pb();
        if (!a.Ob()) return b;
    }
}
function fib(a) {
    Ghb();
    return vcb(a, 0) >= 0 ? aib(a) : Ohb(aib(Gcb(a)));
}
function Bvb(a, b) {
    Avb(a, Pcb(ucb(Kcb(b, 24), jte)), Pcb(ucb(b, jte)));
}
function Qlb(a, b, c) {
    var d;
    wDb(b, c, a.c.length);
    d = c - b;
    ZCb(a.c, b, d);
}
function Ijb(a, b, c) {
    wDb(b, c, a.gc());
    this.c = a;
    this.a = b;
    this.b = c - b;
}
function uad(a) {
    this.c = new Mtb;
    this.b = a.b;
    this.d = a.c;
    this.a = a.a;
}
function Ddd(a) {
    this.a = $wnd.Math.cos(a);
    this.b = $wnd.Math.sin(a);
}
function Gvb(a, b) {
    this.b = (tDb(a), a);
    this.a = (b & Mse) == 0 ? b | 64 | ire : b;
}
function sDb(a, b) {
    if (a < 0 || a >= b) throw scb(new mdb(yte + a + zte + b));
}
function ADb(a, b) {
    if (a < 0 || a >= b) throw scb(new Xgb(yte + a + zte + b));
}
function Mbe(a, b) {
    return Ife(), RRd(b) ? new Jge(b, a) : new Zfe(b, a);
}
function Fxb(a, b, c) {
    return new yyb(a, (Syb(), Pyb), null, false, b, c);
}
function Sxb(a, b, c) {
    return new yyb(a, (Syb(), Ryb), b, c, null, false);
}
function MMb(a, b, c) {
    var d;
    d = new Fdd(c.d);
    mdd(d, a);
    bCd(b, d.a, d.b);
}
function NBb(a) {
    var b;
    LAb(a);
    b = (jqb(), jqb(), hqb);
    return OBb(a, b);
}
function mdc(a) {
    jdc();
    if (RD(a.g, 9)) return JD(a.g, 9);
    return null;
}
function inc() {
    cnc();
    return WC(OC(OV, 1), Ere, 323, 0, [
        anc,
        _mc,
        bnc
    ]);
}
function rnc() {
    onc();
    return WC(OC(PV, 1), Ere, 347, 0, [
        lnc,
        nnc,
        mnc
    ]);
}
function Wnc() {
    Tnc();
    return WC(OC(SV, 1), Ere, 446, 0, [
        Rnc,
        Qnc,
        Snc
    ]);
}
function kpc() {
    hpc();
    return WC(OC(YV, 1), Ere, 298, 0, [
        fpc,
        gpc,
        epc
    ]);
}
function tpc() {
    qpc();
    return WC(OC(ZV, 1), Ere, 312, 0, [
        opc,
        ppc,
        npc
    ]);
}
function sxc() {
    oxc();
    return WC(OC(gW, 1), Ere, 349, 0, [
        lxc,
        mxc,
        nxc
    ]);
}
function Hyc() {
    Eyc();
    return WC(OC(mW, 1), Ere, 449, 0, [
        Dyc,
        Byc,
        Cyc
    ]);
}
function Qyc() {
    Nyc();
    return WC(OC(nW, 1), Ere, 379, 0, [
        Kyc,
        Lyc,
        Myc
    ]);
}
function Zyc() {
    Wyc();
    return WC(OC(oW, 1), Ere, 345, 0, [
        Vyc,
        Tyc,
        Uyc
    ]);
}
function rzc() {
    ozc();
    return WC(OC(qW, 1), Ere, 346, 0, [
        lzc,
        mzc,
        nzc
    ]);
}
function Azc() {
    xzc();
    return WC(OC(rW, 1), Ere, 348, 0, [
        wzc,
        uzc,
        vzc
    ]);
}
function Jzc() {
    Gzc();
    return WC(OC(sW, 1), Ere, 380, 0, [
        Ezc,
        Fzc,
        Dzc
    ]);
}
function Lhc() {
    Ihc();
    return WC(OC(EU, 1), Ere, 365, 0, [
        Hhc,
        Ghc,
        Fhc
    ]);
}
function RTc() {
    OTc();
    return WC(OC(t$, 1), Ere, 383, 0, [
        NTc,
        MTc,
        LTc
    ]);
}
function XEc() {
    UEc();
    return WC(OC(bX, 1), Ere, 450, 0, [
        REc,
        SEc,
        TEc
    ]);
}
function n$c() {
    j$c();
    return WC(OC(w_, 1), Ere, 384, 0, [
        g$c,
        h$c,
        i$c
    ]);
}
function A_c() {
    w_c();
    return WC(OC(B_, 1), Ere, 299, 0, [
        u_c,
        v_c,
        t_c
    ]);
}
function l0c() {
    i0c();
    return WC(OC(J_, 1), Ere, 433, 0, [
        f0c,
        g0c,
        h0c
    ]);
}
function lHb() {
    iHb();
    return WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ]);
}
function SHb() {
    PHb();
    return WC(OC(kN, 1), Ere, 457, 0, [
        NHb,
        MHb,
        OHb
    ]);
}
function JIb() {
    GIb();
    return WC(OC(rN, 1), Ere, 458, 0, [
        FIb,
        EIb,
        DIb
    ]);
}
function oAb() {
    lAb();
    return WC(OC(HL, 1), Ere, 131, 0, [
        iAb,
        jAb,
        kAb
    ]);
}
function NPb() {
    KPb();
    return WC(OC(pO, 1), Ere, 382, 0, [
        IPb,
        HPb,
        JPb
    ]);
}
function o1c() {
    l1c();
    return WC(OC(S_, 1), Ere, 385, 0, [
        j1c,
        k1c,
        i1c
    ]);
}
function w3c() {
    q3c();
    return WC(OC(e0, 1), Ere, 426, 0, [
        n3c,
        p3c,
        o3c
    ]);
}
function X3c() {
    R3c();
    return WC(OC(j0, 1), Ere, 427, 0, [
        O3c,
        Q3c,
        P3c
    ]);
}
function z5c() {
    w5c();
    return WC(OC(y0, 1), Ere, 432, 0, [
        t5c,
        u5c,
        v5c
    ]);
}
function hid() {
    eid();
    return WC(OC(p2, 1), Ere, 342, 0, [
        cid,
        bid,
        did
    ]);
}
function qhd() {
    nhd();
    return WC(OC(k2, 1), Ere, 276, 0, [
        khd,
        lhd,
        mhd
    ]);
}
function Zkd() {
    Wkd();
    return WC(OC(B2, 1), Ere, 278, 0, [
        Ukd,
        Tkd,
        Vkd
    ]);
}
function rkd() {
    okd();
    return WC(OC(y2, 1), Ere, 297, 0, [
        lkd,
        mkd,
        nkd
    ]);
}
function WYb(a) {
    return Kdd(WC(OC(b2, 1), hre, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ]));
}
function Sae(a) {
    a.a == (M9d(), L9d) && Yae(a, N9d(a.g, a.b));
    return a.a;
}
function Uae(a) {
    a.d == (M9d(), L9d) && $ae(a, R9d(a.g, a.b));
    return a.d;
}
function ts(a, b) {
    var c;
    c = (tDb(a), a).g;
    kDb(!!c);
    tDb(b);
    return c(b);
}
function Qi(a, b) {
    Oi.call(this, new Jrb(Ov(a)));
    bk(b, gre);
    this.a = b;
}
function rpe(a, b, c) {
    poe.call(this, 25);
    this.b = a;
    this.a = b;
    this.c = c;
}
function Soe(a) {
    ooe();
    poe.call(this, a);
    this.c = false;
    this.a = false;
}
function RFd(a) {
    if (a.p != 2) throw scb(new Veb);
    return Pcb(a.f) & Wre;
}
function $Fd(a) {
    if (a.p != 2) throw scb(new Veb);
    return Pcb(a.k) & Wre;
}
function XSd(a) {
    if (a.Db >> 16 != 6) return null;
    return JD(cqd(a), 240);
}
function nv(a, b) {
    var c, d;
    d = pv(a, b);
    c = a.a.dd(d);
    return new Cv(a, c);
}
function f4c(a, b, c) {
    var d;
    d = g4c(a, b, false);
    return d.b <= b && d.a <= c;
}
function WKc(a, b, c) {
    var d;
    d = new VKc;
    d.b = b;
    d.a = c;
    ++b.b;
    Ilb(a.d, d);
}
function prb(a) {
    var b;
    b = JD(TCb(a.b), 10);
    return new urb(a.a, b, a.c);
}
function zvb(a) {
    return tcb(Jcb(zcb(yvb(a, 32)), 32), zcb(yvb(a, 32)));
}
function ucb(a, b) {
    return wcb(lD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b));
}
function Icb(a, b) {
    return wcb(rD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b));
}
function Rcb(a, b) {
    return wcb(zD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b));
}
function Nqb(a, b) {
    return srb(a.a, b) ? $Cb(a.b, JD(b, 23).g, null) : null;
}
function Zu(a) {
    Qb(a);
    return RD(a, 16) ? new Wlb(JD(a, 16)) : $u(a.Jc());
}
function QSb(a, b) {
    MSb();
    return a.c == b.c ? Heb(b.d, a.d) : Heb(a.c, b.c);
}
function RSb(a, b) {
    MSb();
    return a.c == b.c ? Heb(a.d, b.d) : Heb(a.c, b.c);
}
function SSb(a, b) {
    MSb();
    return a.c == b.c ? Heb(b.d, a.d) : Heb(b.c, a.c);
}
function TSb(a, b) {
    MSb();
    return a.c == b.c ? Heb(a.d, b.d) : Heb(b.c, a.c);
}
function ZEb(a, b) {
    a.b = a.b | b.b;
    a.c = a.c | b.c;
    a.d = a.d | b.d;
    a.a = a.a | b.a;
}
function pmb(a) {
    rDb(a.a < a.c.c.length);
    a.b = a.a++;
    return a.c.c[a.b];
}
function uNb(a) {
    return a.b == null || a.b.length == 0 ? 'n_' + a.a : 'n_' + a.b;
}
function DXb(a) {
    return JD(Tlb(a, SC(RP, Jve, 9, a.c.length, 0, 1)), 199);
}
function zz(a, b) {
    return !!a && !!a.equals ? a.equals(b) : XD(a) === XD(b);
}
function dRc(a) {
    return a.c == null || a.c.length == 0 ? 'n_' + a.g : 'n_' + a.c;
}
function zSc(a, b) {
    var c;
    c = a + '';
    while(c.length < b)c = '0' + c;
    return c;
}
function Kdc(a, b) {
    var c;
    c = JD(Nib(a.g, b), 60);
    Llb(b.d, new Tec(a, c));
}
function YGb(a, b) {
    var c;
    c = Beb(MD(a.a.mf((Lgd(), tgd))));
    ZGb(a, b, c);
}
function TUb(a, b) {
    var c, d;
    c = vXb(a);
    d = vXb(b);
    return c < d ? -1 : c > d ? 1 : 0;
}
function egc(a, b) {
    var c, d;
    c = dgc(b);
    d = c;
    return JD(Nib(a.c, d), 17).a;
}
function FGc(a, b, c) {
    var d;
    d = a.d[b.p];
    a.d[b.p] = a.d[c.p];
    a.d[c.p] = d;
}
function rld(a, b, c) {
    var d;
    if (a.n && !!b && !!c) {
        d = new Ynd;
        Ilb(a.e, d);
    }
}
function qRb(a, b) {
    Nrb(a.a, b);
    if (b.d) throw scb(new qz(Fte));
    b.d = a;
}
function X4c(a, b) {
    this.a = new Ulb;
    this.d = new Ulb;
    this.f = a;
    this.c = b;
}
function _Pb() {
    this.c = new nQb;
    this.a = new SUb;
    this.b = new OVb;
    qVb();
}
function B8c() {
    w8c();
    this.b = new Irb;
    this.a = new Irb;
    this.c = new Ulb;
}
function hGd(a, b, c) {
    this.d = a;
    this.j = b;
    this.e = c;
    this.o = -1;
    this.p = 3;
}
function iGd(a, b, c) {
    this.d = a;
    this.k = b;
    this.f = c;
    this.o = -1;
    this.p = 5;
}
function t_d(a, b, c, d, e, f) {
    s_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function l_d(a, b, c, d, e, f) {
    k_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function n_d(a, b, c, d, e, f) {
    m_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function p_d(a, b, c, d, e, f) {
    o_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function r_d(a, b, c, d, e, f) {
    q_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function v_d(a, b, c, d, e, f) {
    u_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function A_d(a, b, c, d, e, f) {
    z_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function C_d(a, b, c, d, e, f) {
    B_d.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function g3d(a, b, c, d) {
    O2d.call(this, c);
    this.b = a;
    this.c = b;
    this.d = d;
}
function Hae(a, b) {
    this.f = a;
    this.a = (M9d(), K9d);
    this.c = K9d;
    this.b = b;
}
function cbe(a, b) {
    this.g = a;
    this.d = (M9d(), L9d);
    this.a = L9d;
    this.b = b;
}
function Uhb(a, b) {
    Vhb.call(this, 1, 2, WC(OC(cE, 1), ise, 30, 15, [
        a,
        b
    ]));
}
function _he(a, b) {
    !a.c && (a.c = new nce(a, 0));
    $be(a.c, (Ihe(), Ahe), b);
}
function hce(a, b) {
    return ice(a, b, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0);
}
function dB(a, b) {
    return rfb(zcb(a.q.getTime()), zcb(b.q.getTime()));
}
function ej(a) {
    return dk(a.e.Pd().gc() * a.c.Pd().gc(), 16, new oj(a));
}
function XTd(a) {
    return !!a.u && OTd(a.u.a).i != 0 && !(!!a.n && yVd(a.n));
}
function K_d(a) {
    return !!a.a && J_d(a.a.a).i != 0 && !(!!a.b && J0d(a.b));
}
function gsd(a, b) {
    if (b == 0) return !!a.o && a.o.f != 0;
    return oqd(a, b);
}
function Vtb(a) {
    rDb(a.b.b != a.d.a);
    a.c = a.b = a.b.b;
    --a.a;
    return a.c.c;
}
function wxb(a) {
    return !a.a ? a.c : a.e.length == 0 ? a.a.a : a.a.a + ('' + a.e);
}
function Ihb(a) {
    while(a.d > 0 && a.a[--a.d] == 0);
    a.a[a.d++] == 0 && (a.e = 0);
}
function Ajb(a, b) {
    this.a = a;
    ujb.call(this, a);
    vDb(b, a.gc());
    this.b = b;
}
function olb(a) {
    this.a = SC(aJ, Nqe, 1, dfb($wnd.Math.max(8, a)) << 1, 5, 1);
}
function lyb(a) {
    myb.call(this, a, (Syb(), Oyb), null, false, null, false);
}
function Pxb(a, b) {
    var c;
    c = 1 - b;
    a.a[c] = Qxb(a.a[c], c);
    return Qxb(a, b);
}
function CDb(a, b) {
    var c, d;
    d = ucb(a, Use);
    c = Jcb(b, 32);
    return Icb(c, d);
}
function Cc(a, b, c) {
    var d;
    d = JD(a.Zb().xc(b), 16);
    return !!d && d.Gc(c);
}
function Gc(a, b, c) {
    var d;
    d = JD(a.Zb().xc(b), 16);
    return !!d && d.Kc(c);
}
function aEb(a, b, c) {
    var d;
    d = (Qb(a), new Wlb(a));
    $Db(new _Db(d, b, c));
}
function DTb(a, b, c) {
    var d;
    d = (Qb(a), new Wlb(a));
    BTb(new CTb(d, b, c));
}
function vLc(a, b, c) {
    a.a = b;
    a.c = c;
    a.b.a.$b();
    Ltb(a.d);
    _Cb(a.e.a.c, 0);
}
function a0c(a, b) {
    var c;
    a.e = new U_c;
    c = TYc(b);
    Slb(c, a.c);
    b0c(a, c, 0);
}
function BRc(a, b) {
    return new Mod(b, Add(odd(b.e), a, a), (xdb(), true));
}
function _Vc(a, b) {
    UVc();
    return JD(WMb(b, (kVc(), ZUc)), 17).a >= a.gc();
}
function FIc(a) {
    gIc();
    return !eWb(a) && !(!eWb(a) && a.c.i.c == a.d.i.c);
}
function CXb(a) {
    return JD(Tlb(a, SC(CP, Ive, 18, a.c.length, 0, 1)), 469);
}
function V0c(a) {
    ILd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a), new R0c);
}
function o6d() {
    var a, b, c;
    b = (c = (a = new NZd, a), c);
    Ilb(k6d, b);
    return b;
}
function Zvd(a, b, c, d, e, f) {
    $vd(a, b, c, f);
    ZTd(a, d);
    $Td(a, e);
    return a;
}
function Ogb(a, b, c, d) {
    a.a += '' + qgb(b == null ? Rqe : adb(b), c, d);
    return a;
}
function Pb(a, b) {
    if (a < 0 || a >= b) throw scb(new mdb(Ib(a, b)));
    return a;
}
function Tb(a, b, c) {
    if (a < 0 || b < a || b > c) throw scb(new mdb(Kb(a, b, c)));
}
function Pad(a, b, c, d) {
    var e;
    e = new Wad;
    e.a = b;
    e.b = c;
    e.c = d;
    Atb(a.b, e);
}
function Oad(a, b, c, d) {
    var e;
    e = new Wad;
    e.a = b;
    e.b = c;
    e.c = d;
    Atb(a.a, e);
}
function Mz(a, b, c) {
    var d;
    d = Kz();
    try {
        return Jz(a, b, c);
    } finally{
        Nz(d);
    }
}
function Ocb(a) {
    var b;
    if (Ccb(a)) {
        b = a;
        return b == -0 ? 0 : b;
    }
    return wD(a);
}
function cjb(a, b) {
    if (RD(b, 43)) return Jd(a.a, JD(b, 43));
    return false;
}
function Xqb(a, b) {
    if (RD(b, 43)) return Jd(a.a, JD(b, 43));
    return false;
}
function jtb(a, b) {
    if (RD(b, 43)) return Jd(a.a, JD(b, 43));
    return false;
}
function jx(a) {
    if (Gh(a).dc()) return false;
    Hh(a, new nx);
    return true;
}
function lBb(a) {
    var b;
    KAb(a);
    b = new asb;
    Yvb(a.a, new tBb(b));
    return b;
}
function QAb(a) {
    var b;
    KAb(a);
    b = new Eqb;
    Yvb(a.a, new eBb(b));
    return b;
}
function iz(b) {
    if (!('stack' in b)) try {
        throw b;
    } catch (a) {}
    return b;
}
function iBb(a, b) {
    if (a.a <= a.b) {
        b.Bd(a.a++);
        return true;
    }
    return false;
}
function iWb(a, b, c) {
    !!a.d && Plb(a.d.e, a);
    a.d = b;
    !!a.d && Hlb(a.d.e, c, a);
}
function XCc(a, b, c) {
    this.d = new iDc(this);
    this.e = a;
    this.i = b;
    this.f = c;
}
function Ykc(a, b, c, d) {
    Rkc(this);
    this.c = a;
    this.e = b;
    this.f = c;
    this.b = d;
}
function C1b(a, b) {
    I1b(b, a);
    K1b(a.d);
    K1b(JD(WMb(a, (Bwc(), fvc)), 213));
}
function D1b(a, b) {
    L1b(b, a);
    N1b(a.d);
    N1b(JD(WMb(a, (Bwc(), fvc)), 213));
}
function $xd(a, b) {
    var c, d;
    c = iC(a, b);
    d = null;
    !!c && (d = c.ne());
    return d;
}
function _xd(a, b) {
    var c, d;
    c = BB(a, b);
    d = null;
    !!c && (d = c.qe());
    return d;
}
function ayd(a, b) {
    var c, d;
    c = iC(a, b);
    d = null;
    !!c && (d = c.qe());
    return d;
}
function byd(a, b) {
    var c, d;
    c = iC(a, b);
    d = null;
    !!c && (d = cyd(c));
    return d;
}
function hzd(a, b, c) {
    var d;
    d = Yxd(c);
    zo(a.n, d, b);
    zo(a.o, b, c);
    return b;
}
function jGd(a, b, c, d) {
    this.d = a;
    this.n = b;
    this.g = c;
    this.o = d;
    this.p = -1;
}
function ufe(a) {
    var b;
    b = a.Ch();
    this.a = RD(b, 71) ? JD(b, 71).Fi() : b.Jc();
}
function Ui(a) {
    return dk(a.e.Pd().gc() * a.c.Pd().gc(), 273, new ij(a));
}
function bv(a) {
    return new Vlb((bk(a, Gre), Xy(tcb(tcb(5, a), a / 10 | 0))));
}
function EXb(a) {
    return JD(Tlb(a, SC(dQ, Kve, 11, a.c.length, 0, 1)), 1988);
}
function Vc(a, b, c, d) {
    return RD(c, 59) ? new Ig(a, b, c, d) : new wg(a, b, c, d);
}
function DVc() {
    DVc = Zcb;
    CVc = new EVc('DFS', 0);
    BVc = new EVc('BFS', 1);
}
function ypc() {
    ypc = Zcb;
    wpc = new zpc(Yte, 0);
    xpc = new zpc('TOP_LEFT', 1);
}
function x7c() {
    x7c = Zcb;
    w7c = os((p7c(), WC(OC(L0, 1), Ere, 524, 0, [
        o7c
    ])));
}
function Z5c() {
    Z5c = Zcb;
    Y5c = os((S5c(), WC(OC(D0, 1), Ere, 543, 0, [
        R5c
    ])));
}
function Q5c() {
    Q5c = Zcb;
    P5c = os((I5c(), WC(OC(C0, 1), Ere, 475, 0, [
        H5c
    ])));
}
function FBc() {
    FBc = Zcb;
    EBc = ux(jfb(1), jfb(4));
    DBc = ux(jfb(1), jfb(2));
}
function ALb() {
    xLb();
    return WC(OC(HN, 1), Ere, 406, 0, [
        wLb,
        tLb,
        uLb,
        vLb
    ]);
}
function ESb() {
    xSb();
    return WC(OC(TO, 1), Ere, 405, 0, [
        tSb,
        wSb,
        uSb,
        vSb
    ]);
}
function Xyb() {
    Syb();
    return WC(OC(rL, 1), Ere, 305, 0, [
        Oyb,
        Pyb,
        Qyb,
        Ryb
    ]);
}
function fUb() {
    cUb();
    return WC(OC(iP, 1), Ere, 381, 0, [
        bUb,
        _Tb,
        $Tb,
        aUb
    ]);
}
function M7b() {
    I7b();
    return WC(OC(YR, 1), Ere, 364, 0, [
        H7b,
        F7b,
        G7b,
        E7b
    ]);
}
function cr(a) {
    if (RD(a, 16)) return JD(a, 16).dc();
    return !a.Jc().Ob();
}
function ndc(a) {
    jdc();
    if (RD(a.g, 152)) return JD(a.g, 152);
    return null;
}
function So(a) {
    if (a.e.g != a.b) throw scb(new yqb);
    return !!a.c && a.d > 0;
}
function Utb(a) {
    rDb(a.b != a.d.c);
    a.c = a.b;
    a.b = a.b.a;
    ++a.a;
    return a.c.c;
}
function _kb(a, b) {
    tDb(b);
    VC(a.a, a.c, b);
    a.c = a.c + 1 & a.a.length - 1;
    dlb(a);
}
function $kb(a, b) {
    tDb(b);
    a.b = a.b - 1 & a.a.length - 1;
    VC(a.a, a.b, b);
    dlb(a);
}
function Eac(a, b) {
    var c;
    c = b.a;
    gWb(c, b.c.d);
    hWb(c, b.d.d);
    Pdd(c.a, a.n);
}
function l_b(a, b) {
    var c;
    c = JD(Tsb(a.b, b), 67);
    !c && (c = new Mtb);
    return c;
}
function rhc(a) {
    var b;
    return a.j == (Rjd(), Ojd) && (b = shc(a), rrb(b, wjd));
}
function Ggc() {
    Dgc();
    return WC(OC(vU, 1), Ere, 410, 0, [
        zgc,
        Agc,
        Bgc,
        Cgc
    ]);
}
function Exc() {
    zxc();
    return WC(OC(hW, 1), Ere, 203, 0, [
        xxc,
        yxc,
        wxc,
        vxc
    ]);
}
function qyc() {
    nyc();
    return WC(OC(kW, 1), Ere, 266, 0, [
        kyc,
        jyc,
        lyc,
        myc
    ]);
}
function fQc() {
    _Pc();
    return WC(OC(vZ, 1), Ere, 396, 0, [
        XPc,
        YPc,
        ZPc,
        $Pc
    ]);
}
function Vjc(a, b) {
    return JD(zub(IBb(JD(Qc(a.k, b), 15).Mc(), Kjc)), 112);
}
function Wjc(a, b) {
    return JD(zub(JBb(JD(Qc(a.k, b), 15).Mc(), Kjc)), 112);
}
function lx(a) {
    return new Gvb(unb(JD(a.a.kd(), 16).gc(), a.a.jd()), 16);
}
function qQc(a, b) {
    return qdd(new Edd(b.e.a + b.f.a / 2, b.e.b + b.f.b / 2), a);
}
function $8c(a, b) {
    var c;
    for(c = a.j.c.length; c < b; c++)Ilb(a.j, a.Lg());
}
function bzc(a, b, c, d) {
    var e;
    e = d[b.g][c.g];
    return Beb(MD(WMb(a.a, e)));
}
function Kk(a, b, c, d) {
    this.e = null;
    this.c = a;
    this.d = b;
    this.a = c;
    this.b = d;
}
function tlc(a, b, c, d, e) {
    this.i = a;
    this.a = b;
    this.e = c;
    this.j = d;
    this.f = e;
}
function jLc(a) {
    a.a = null;
    a.e = null;
    _Cb(a.b.c, 0);
    _Cb(a.f.c, 0);
    a.c = null;
}
function vHc() {
    vHc = Zcb;
    uHc = new wHc('UPPER', 0);
    tHc = new wHc('LOWER', 1);
}
function yVc() {
    vVc();
    return WC(OC(x$, 1), Ere, 350, 0, [
        uVc,
        sVc,
        tVc,
        rVc
    ]);
}
function q_c() {
    m_c();
    return WC(OC(A_, 1), Ere, 351, 0, [
        l_c,
        j_c,
        k_c,
        i_c
    ]);
}
function H0c() {
    D0c();
    return WC(OC(N_, 1), Ere, 398, 0, [
        C0c,
        z0c,
        B0c,
        A0c
    ]);
}
function Bkd() {
    ykd();
    return WC(OC(z2, 1), Ere, 378, 0, [
        wkd,
        xkd,
        vkd,
        ukd
    ]);
}
function hhd() {
    ehd();
    return WC(OC(j2, 1), Ere, 275, 0, [
        bhd,
        ahd,
        chd,
        dhd
    ]);
}
function Ahd() {
    xhd();
    return WC(OC(l2, 1), Ere, 220, 0, [
        whd,
        uhd,
        thd,
        vhd
    ]);
}
function sid() {
    oid();
    return WC(OC(q2, 1), Ere, 289, 0, [
        nid,
        kid,
        lid,
        mid
    ]);
}
function rmd() {
    omd();
    return WC(OC(J2, 1), Ere, 321, 0, [
        nmd,
        kmd,
        mmd,
        lmd
    ]);
}
function eod() {
    bod();
    return WC(OC(f3, 1), Ere, 404, 0, [
        $nd,
        _nd,
        Znd,
        aod
    ]);
}
function dEd(a) {
    bEd();
    return Lib(aEd, a) ? JD(Nib(aEd, a), 337).Og() : null;
}
function eqd(a, b, c) {
    return b < 0 ? vqd(a, c) : JD(c, 69).tk().yk(a, a.di(), b);
}
function gzd(a, b, c) {
    var d;
    d = Yxd(c);
    zo(a.f, d, b);
    Qib(a.g, b, c);
    return b;
}
function izd(a, b, c) {
    var d;
    d = Yxd(c);
    zo(a.p, d, b);
    Qib(a.q, b, c);
    return b;
}
function cCd(a) {
    var b, c;
    b = (Hpd(), c = new Vtd, c);
    !!a && Ttd(b, a);
    return b;
}
function tDd(a) {
    var b;
    b = a.Zi(a.i);
    a.i > 0 && $gb(a.g, 0, b, 0, a.i);
    return b;
}
function Gr(a) {
    var b;
    b = 0;
    while(a.Ob()){
        a.Pb();
        b = tcb(b, 1);
    }
    return Xy(b);
}
function zx(a, b) {
    var c;
    c = new Vgb;
    a.Ed(c);
    c.a += '..';
    b.Fd(c);
    return c.a;
}
function jNd(a, b) {
    iNd();
    var c;
    c = JD(Nib(hNd, a), 58);
    return !c || c.ck(b);
}
function QFd(a) {
    if (a.p != 1) throw scb(new Veb);
    return Pcb(a.f) << 24 >> 24;
}
function ZFd(a) {
    if (a.p != 1) throw scb(new Veb);
    return Pcb(a.k) << 24 >> 24;
}
function WFd(a) {
    if (a.p != 7) throw scb(new Veb);
    return Pcb(a.f) << 16 >> 16;
}
function dGd(a) {
    if (a.p != 7) throw scb(new Veb);
    return Pcb(a.k) << 16 >> 16;
}
function Nhb(a, b) {
    if (b.e == 0 || a.e == 0) return Fhb;
    return Cib(), Dib(a, b);
}
function pfc(a, b, c) {
    a.i = 0;
    a.e = 0;
    if (b == c) return;
    ofc(a, b, c);
    nfc(a, b, c);
}
function uNc(a, b, c, d, e) {
    var f;
    f = pNc(e, c, d);
    Ilb(b, WMc(e, f));
    yNc(a, e, b);
}
function Mdc(a, b, c) {
    var d;
    d = JD(Nib(a.g, c), 60);
    Ilb(a.a.c, new xod(b, d));
}
function LDb(a, b, c) {
    return Aeb(MD(Wd(fsb(a.f, b))), MD(Wd(fsb(a.f, c))));
}
function dOd(a, b) {
    return JD(b == null ? Wd(fsb(a.f, null)) : zsb(a.i, b), 286);
}
function Nd(a, b) {
    return XD(b) === XD(a) ? '(this Map)' : b == null ? Rqe : adb(b);
}
function kIc(a, b) {
    return a == (DYb(), AYb) && b == AYb ? 4 : a == AYb || b == AYb ? 8 : 32;
}
function xbe(a, b, c) {
    return ybe(a, b, c, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0);
}
function Ebe(a, b, c) {
    return Fbe(a, b, c, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0);
}
function jce(a, b, c) {
    return kce(a, b, c, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0);
}
function Jfe(a, b) {
    Ife();
    var c;
    c = JD(a, 69).sk();
    d2d(c, b);
    return c.ul(b);
}
function nnd(a, b) {
    var c;
    c = b;
    while(c){
        ldd(a, c.i, c.j);
        c = Zwd(c);
    }
    return a;
}
function Gpb(a, b) {
    var c;
    for(c = 0; c < b; ++c)VC(a, c, new Spb(JD(a[c], 43)));
}
function Thb(a, b) {
    Ghb();
    Vhb.call(this, a, 1, WC(OC(cE, 1), ise, 30, 15, [
        b
    ]));
}
function dpe(a, b) {
    ooe();
    poe.call(this, a);
    this.a = b;
    this.c = -1;
    this.b = -1;
}
function sNb(a, b) {
    dNb.call(this);
    this.a = a;
    this.b = b;
    Ilb(this.a.b, this);
}
function Crb(a) {
    rDb(a.a < a.c.a.length);
    a.b = a.a;
    Arb(a);
    return a.c.b[a.b];
}
function OTd(a) {
    if (!a.n) {
        TTd(a);
        a.n = new CVd(a, g6, a);
        UTd(a);
    }
    return a.n;
}
function nDb(a) {
    if (a < 0) throw scb(new Dfb('Negative array size: ' + a));
}
function DB(d, a, b) {
    if (b) {
        var c = b.me();
        b = c(b);
    } else b = undefined;
    d.a[a] = b;
}
function lC(d, a, b) {
    if (b) {
        var c = b.me();
        d.a[a] = c(b);
    } else delete d.a[a];
}
function M9b(a, b) {
    G9b();
    var c;
    c = a.j.g - b.j.g;
    if (c != 0) return c;
    return 0;
}
function GWd(a, b) {
    Zgb();
    String.fromCharCode(10);
    return tCd(STd(a.a), b);
}
function LWd(a, b) {
    Zgb();
    String.fromCharCode(10);
    return tCd(STd(a.a), b);
}
function lB(a, b) {
    var c;
    c = a.q.getHours();
    a.q.setFullYear(b + hse);
    eB(a, c);
}
function nOd(a, b) {
    var c;
    return c = b != null ? Oib(a, b) : Wd(fsb(a.f, b)), ZD(c);
}
function yOd(a, b) {
    var c;
    return c = b != null ? Oib(a, b) : Wd(fsb(a.f, b)), ZD(c);
}
function lNb(a) {
    return !!a.c && !!a.d ? uNb(a.c) + '->' + uNb(a.d) : 'e_' + jDb(a);
}
function alb(a) {
    if (a.b == a.c) return;
    a.a = SC(aJ, Nqe, 1, 8, 5, 1);
    a.b = 0;
    a.c = 0;
}
function Tx(a) {
    var b;
    if (a) return new ytb(a);
    b = new wtb;
    Xq(b, a);
    return b;
}
function xmb(a, b) {
    var c;
    nDb(b);
    return c = a.slice(0, b), c.length = b, XC(c, a);
}
function Khb(a, b) {
    var c;
    for(c = a.d - 1; c >= 0 && a.a[c] === b[c]; c--);
    return c < 0;
}
function e_d(a, b, c, d) {
    hGd.call(this, 1, c, d);
    c_d(this);
    this.c = a;
    this.b = b;
}
function f_d(a, b, c, d) {
    iGd.call(this, 1, c, d);
    c_d(this);
    this.c = a;
    this.b = b;
}
function Gge(a, b, c, d, e, f, g) {
    kGd.call(this, b, d, e, f, g);
    this.c = a;
    this.a = c;
}
function E2d(a, b, c) {
    this.e = a;
    this.a = aJ;
    this.b = Kee(b);
    this.c = b;
    this.d = c;
}
function To(a) {
    this.e = a;
    this.c = this.e.a;
    this.b = this.e.g;
    this.d = this.e.i;
}
function Fsb(a) {
    this.d = a;
    this.b = this.d.a.entries();
    this.a = this.b.next();
}
function g5d(a) {
    this.c = a;
    this.a = JD(pRd(a), 155);
    this.b = this.a.gk().si();
}
function Xsb() {
    Irb.call(this);
    Qsb(this);
    this.d.b = this.d;
    this.d.a = this.d;
}
function Dtb(a, b, c, d) {
    var e;
    e = new gub;
    e.c = b;
    e.b = c;
    e.a = d;
    d.b = c.a = e;
    ++a.b;
}
function yBb(a, b) {
    var c;
    return b.b.Kb(KBb(a, b.c.Ve(), (c = new NCb(b), c)));
}
function Dvb(a) {
    vvb();
    Avb(this, Pcb(ucb(Kcb(a, 24), jte)), Pcb(ucb(a, jte)));
}
function gOb() {
    gOb = Zcb;
    fOb = os((bOb(), WC(OC(hO, 1), Ere, 421, 0, [
        _Nb,
        aOb
    ])));
}
function e2b() {
    e2b = Zcb;
    d2b = os((_1b(), WC(OC(bR, 1), Ere, 501, 0, [
        $1b,
        Z1b
    ])));
}
function $mc() {
    $mc = Zcb;
    Zmc = os((Vmc(), WC(OC(NV, 1), Ere, 419, 0, [
        Tmc,
        Umc
    ])));
}
function Pnc() {
    Pnc = Zcb;
    Onc = os((Knc(), WC(OC(RV, 1), Ere, 416, 0, [
        Inc,
        Jnc
    ])));
}
function Dpc() {
    Dpc = Zcb;
    Cpc = os((ypc(), WC(OC($V, 1), Ere, 417, 0, [
        wpc,
        xpc
    ])));
}
function roc() {
    roc = Zcb;
    qoc = os((moc(), WC(OC(UV, 1), Ere, 474, 0, [
        loc,
        koc
    ])));
}
function _qc() {
    _qc = Zcb;
    $qc = os((Wqc(), WC(OC(aW, 1), Ere, 420, 0, [
        Vqc,
        Uqc
    ])));
}
function Ayc() {
    Ayc = Zcb;
    zyc = os((vyc(), WC(OC(lW, 1), Ere, 418, 0, [
        tyc,
        uyc
    ])));
}
function AHc() {
    AHc = Zcb;
    zHc = os((vHc(), WC(OC(AX, 1), Ere, 516, 0, [
        uHc,
        tHc
    ])));
}
function MKc() {
    MKc = Zcb;
    LKc = os((HKc(), WC(OC(uY, 1), Ere, 506, 0, [
        FKc,
        GKc
    ])));
}
function EKc() {
    EKc = Zcb;
    DKc = os((zKc(), WC(OC(tY, 1), Ere, 507, 0, [
        yKc,
        xKc
    ])));
}
function nNc() {
    nNc = Zcb;
    mNc = os((iNc(), WC(OC(RY, 1), Ere, 513, 0, [
        hNc,
        gNc
    ])));
}
function lPc() {
    lPc = Zcb;
    kPc = os((gPc(), WC(OC(kZ, 1), Ere, 451, 0, [
        ePc,
        fPc
    ])));
}
function IVc() {
    IVc = Zcb;
    HVc = os((DVc(), WC(OC(y$, 1), Ere, 422, 0, [
        CVc,
        BVc
    ])));
}
function IYc() {
    IYc = Zcb;
    HYc = os((AYc(), WC(OC(g_, 1), Ere, 485, 0, [
        yYc,
        zYc
    ])));
}
function f$c() {
    f$c = Zcb;
    e$c = os((_Zc(), WC(OC(v_, 1), Ere, 423, 0, [
        ZZc,
        $Zc
    ])));
}
function f6c() {
    f6c = Zcb;
    e6c = os((a6c(), WC(OC(E0, 1), Ere, 425, 0, [
        _5c,
        $5c
    ])));
}
function I7c() {
    I7c = Zcb;
    H7c = os((A7c(), WC(OC(M0, 1), Ere, 424, 0, [
        z7c,
        y7c
    ])));
}
function W2c() {
    W2c = Zcb;
    V2c = os((O2c(), WC(OC(b0, 1), Ere, 476, 0, [
        M2c,
        N2c
    ])));
}
function Wqc() {
    Wqc = Zcb;
    Vqc = new Xqc(yve, 0);
    Uqc = new Xqc('ALTERNATING', 1);
}
function O2c() {
    O2c = Zcb;
    M2c = new Q2c(pwe, 0);
    N2c = new Q2c('TARGET_WIDTH', 1);
}
function Wzb() {
    Wzb = Zcb;
    Tzb = true;
    Rzb = false;
    Szb = false;
    Vzb = false;
    Uzb = false;
}
function mld() {
    mld = Zcb;
    lld = os((cld(), WC(OC(E2, 1), Ere, 343, 0, [
        ald,
        bld
    ])));
}
function Zgd() {
    Tgd();
    return WC(OC(i2, 1), Ere, 86, 0, [
        Rgd,
        Qgd,
        Pgd,
        Ogd,
        Sgd
    ]);
}
function Yjd() {
    Rjd();
    return WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ]);
}
function eOd(a, b, c) {
    return JD(b == null ? gsb(a.f, null, c) : Asb(a.i, b, c), 286);
}
function X_b(a) {
    return (a.k == (DYb(), AYb) || a.k == wYb) && XMb(a, (Iqc(), Opc));
}
function le(a, b) {
    var c;
    c = b.jd();
    return new cp(c, a.e.pc(c, JD(b.kd(), 16)));
}
function skb(a, b) {
    var c, d;
    c = b.jd();
    d = a.De(c);
    return !!d && tub(d.e, b.kd());
}
function ofb(a, b) {
    var c, d;
    tDb(b);
    for(d = a.Jc(); d.Ob();){
        c = d.Pb();
        b.Ad(c);
    }
}
function Mfc(a, b) {
    var c, d;
    d = false;
    do {
        c = Pfc(a, b);
        d = d | c;
    }while (c);
    return d;
}
function aGc(a, b) {
    var c, d;
    c = b;
    d = 0;
    while(c > 0){
        d += a.a[c];
        c -= c & -c;
    }
    return d;
}
function ond(a, b) {
    var c;
    c = b;
    while(c){
        ldd(a, -c.i, -c.j);
        c = Zwd(c);
    }
    return a;
}
function Rlb(a, b, c) {
    var d;
    d = (sDb(b, a.c.length), a.c[b]);
    a.c[b] = c;
    return d;
}
function xCc(a, b, c) {
    a.a.c.length = 0;
    BCc(a, b, c);
    a.a.c.length == 0 || uCc(a, b);
}
function so(a) {
    a.i = 0;
    Dmb(a.b, null);
    Dmb(a.c, null);
    a.a = null;
    a.e = null;
    ++a.g;
}
function esb(a, b) {
    var c;
    c = a.a.get(b);
    return c == null ? SC(aJ, Nqe, 1, 0, 5, 1) : c;
}
function eWb(a) {
    if (!a.c || !a.d) return false;
    return !!a.c.i && a.c.i == a.d.i;
}
function cAb(a) {
    Wzb();
    if (Tzb) return;
    this.c = a;
    this.e = true;
    this.a = new Ulb;
}
function aVb(a) {
    ZUb();
    KTb(this);
    this.a = new Mtb;
    $Ub(this, a);
    Atb(this.a, a);
}
function wUb() {
    Glb(this);
    this.b = new Edd(Kse, Kse);
    this.a = new Edd(Lse, Lse);
}
function jBb(a, b) {
    this.c = 0;
    this.b = b;
    hwb.call(this, a, 17493);
    this.a = this.c;
}
function udb(a) {
    sdb.call(this, a == null ? Rqe : adb(a), RD(a, 80) ? JD(a, 80) : null);
}
function Nz(a) {
    a && Uz((Sz(), Rz));
    --Fz;
    if (a) {
        if (Hz != -1) {
            Pz(Hz);
            Hz = -1;
        }
    }
}
function xBb(a, b) {
    return (LAb(a), PBb(new RBb(a, new gCb(b, a.a)))).zd(vBb);
}
function FQb() {
    CQb();
    return WC(OC(AO, 1), Ere, 360, 0, [
        xQb,
        yQb,
        zQb,
        AQb,
        BQb
    ]);
}
function chc() {
    $gc();
    return WC(OC(DU, 1), Ere, 368, 0, [
        Wgc,
        Ygc,
        Zgc,
        Xgc,
        Vgc
    ]);
}
function nZc() {
    jZc();
    return WC(OC(l_, 1), Ere, 361, 0, [
        hZc,
        eZc,
        iZc,
        fZc,
        gZc
    ]);
}
function L4c() {
    I4c();
    return WC(OC(n0, 1), Ere, 366, 0, [
        E4c,
        D4c,
        G4c,
        F4c,
        H4c
    ]);
}
function o6c() {
    l6c();
    return WC(OC(F0, 1), Ere, 325, 0, [
        g6c,
        h6c,
        k6c,
        i6c,
        j6c
    ]);
}
function Sxc() {
    Mxc();
    return WC(OC(iW, 1), Ere, 324, 0, [
        Lxc,
        Ixc,
        Jxc,
        Hxc,
        Kxc
    ]);
}
function Fnc() {
    znc();
    return WC(OC(QV, 1), Ere, 344, 0, [
        vnc,
        unc,
        xnc,
        ync,
        wnc
    ]);
}
function Rqc() {
    Oqc();
    return WC(OC(_V, 1), Ere, 171, 0, [
        Nqc,
        Jqc,
        Kqc,
        Lqc,
        Mqc
    ]);
}
function ocd() {
    lcd();
    return WC(OC(V1, 1), Ere, 170, 0, [
        jcd,
        icd,
        gcd,
        kcd,
        hcd
    ]);
}
function Tid() {
    Qid();
    return WC(OC(s2, 1), Ere, 255, 0, [
        Nid,
        Pid,
        Lid,
        Mid,
        Oid
    ]);
}
function Lz(b) {
    Iz();
    return function() {
        var a;
        return Mz(b, this, arguments);
    };
}
function aad(a, b) {
    if (RD(b, 149)) return cgb(a.c, JD(b, 149).c);
    return false;
}
function r1d(a) {
    var b;
    if (!a.c) {
        b = a.r;
        RD(b, 88) && (a.c = JD(b, 29));
    }
    return a.c;
}
function TTd(a) {
    if (!a.t) {
        a.t = new RVd(a);
        sCd(new X8d(a), 0, a.t);
    }
    return a.t;
}
function zc(a) {
    a.e = 3;
    a.d = a.Yb();
    if (a.e != 2) {
        a.e = 0;
        return true;
    }
    return false;
}
function Jad(a, b) {
    var c;
    c = JD(Tsb(a.d, b), 21);
    return c ? c : JD(Tsb(a.e, b), 21);
}
function Tc(a, b) {
    var c, d;
    c = JD(Uv(a.c, b), 16);
    if (c) {
        d = c.gc();
        c.$b();
        a.d -= d;
    }
}
function Cy(a) {
    var b, c, d, e;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        HAb(b);
    }
}
function ZC(a) {
    var b, c, d;
    b = a & zse;
    c = a >> 22 & zse;
    d = a < 0 ? Ase : 0;
    return _C(b, c, d);
}
function bgb(a) {
    var b;
    b = a.length;
    return cgb(Ose.substr(Ose.length - b, b), a);
}
function ds(a) {
    if (cs(a)) {
        a.c = a.a;
        return a.a.Pb();
    } else throw scb(new qub);
}
function Qhb(a, b) {
    if (b == 0 || a.e == 0) return a;
    return b > 0 ? hib(a, b) : kib(a, -b);
}
function Rhb(a, b) {
    if (b == 0 || a.e == 0) return a;
    return b > 0 ? kib(a, b) : hib(a, -b);
}
function RId(a) {
    this.b = a;
    XHd.call(this, a);
    this.a = JD(Crd(this.b.a, 4), 128);
}
function IId(a) {
    this.b = a;
    CHd.call(this, a);
    this.a = JD(Crd(this.b.a, 4), 128);
}
function j_d(a, b, c, d, e) {
    lGd.call(this, b, d, e);
    c_d(this);
    this.c = a;
    this.b = c;
}
function B_d(a, b, c, d, e) {
    lGd.call(this, b, d, e);
    c_d(this);
    this.c = a;
    this.a = c;
}
function o_d(a, b, c, d, e) {
    hGd.call(this, b, d, e);
    c_d(this);
    this.c = a;
    this.a = c;
}
function s_d(a, b, c, d, e) {
    iGd.call(this, b, d, e);
    c_d(this);
    this.c = a;
    this.a = c;
}
function xHb(a, b, c, d) {
    var e;
    for(e = 0; e < uHb; e++)oHb(a.a[e][b.g], c, d[b.g]);
}
function wHb(a, b, c, d) {
    var e;
    for(e = 0; e < tHb; e++)pHb(a.a[b.g][e], c, d[b.g]);
}
function jqd(a, b, c) {
    var d;
    return d = a.Eh(b), d >= 0 ? a.Hh(d, c, true) : uqd(a, b, c);
}
function DRc(a, b, c) {
    return Heb(qdd(mQc(a), odd(b.b)), qdd(mQc(a), odd(c.b)));
}
function ERc(a, b, c) {
    return Heb(qdd(mQc(a), odd(b.e)), qdd(mQc(a), odd(c.e)));
}
function $4c(a, b) {
    return $wnd.Math.min(pdd(b.a, a.d.d.c), pdd(b.b, a.d.d.c));
}
function Tfe(a, b, c) {
    var d;
    d = new Ufe(a.a);
    Ld(d, a.a.a);
    gsb(d.f, b, c);
    a.a.a = d;
}
function CVb(a) {
    var b;
    b = new kWb;
    UMb(b, a);
    ZMb(b, (Bwc(), Ruc), null);
    return b;
}
function y7b(a) {
    var b, c;
    b = a.c.i;
    c = a.d.i;
    return b.k == (DYb(), wYb) && c.k == wYb;
}
function lDd(a) {
    var b, c;
    ++a.j;
    b = a.g;
    c = a.i;
    a.g = null;
    a.i = 0;
    a.Li(c, b);
    a.Ki();
}
function iDd(a, b) {
    a.Yi(a.i + 1);
    jDd(a, a.i, a.Wi(a.i, b));
    a.Ji(a.i++, b);
    a.Ki();
}
function Qc(a, b) {
    var c;
    c = JD(a.c.xc(b), 16);
    !c && (c = a.ic(b));
    return a.pc(b, c);
}
function agb(a, b) {
    var c, d;
    c = (tDb(a), a);
    d = (tDb(b), b);
    return c == d ? 0 : c < d ? -1 : 1;
}
function hB(a, b) {
    var c;
    c = a.q.getHours() + (b / 60 | 0);
    a.q.setMinutes(b);
    eB(a, c);
}
function sm(a) {
    var b;
    b = (Qb(a), a ? new Wlb(a) : $u(a.Jc()));
    vnb(b);
    return Mm(b);
}
function _u(a) {
    var b, c;
    Qb(a);
    b = Vu(a.length);
    c = new Vlb(b);
    qnb(c, a);
    return c;
}
function Olb(a, b) {
    var c;
    c = (sDb(b, a.c.length), a.c[b]);
    ZCb(a.c, b, 1);
    return c;
}
function uxb(a, b) {
    !a.a ? a.a = new Wgb(a.d) : Qgb(a.a, a.b);
    Ngb(a.a, b);
    return a;
}
function Sb(a, b) {
    if (a < 0 || a > b) throw scb(new mdb(Jb(a, b, 'index')));
    return a;
}
function yib(a, b, c, d) {
    var e;
    e = SC(cE, ise, 30, b, 15, 1);
    zib(e, a, b, c, d);
    return e;
}
function Dqb(a) {
    var b;
    b = a.e + a.f;
    if (isNaN(b) && Ieb(a.d)) return a.d;
    return b;
}
function M9d() {
    M9d = Zcb;
    var a, b;
    K9d = (EOd(), b = new FYd, b);
    L9d = (a = new HSd, a);
}
function Gcd() {
    Gcd = Zcb;
    Fcd = new KBd('org.eclipse.elk.labels.labelManager');
}
function iNc() {
    iNc = Zcb;
    hNc = new jNc('REGULAR', 0);
    gNc = new jNc('CRITICAL', 1);
}
function xZb(a) {
    this.c = a;
    this.a = new rmb(this.c.a);
    this.b = new rmb(this.c.b);
}
function lGd(a, b, c) {
    this.d = a;
    this.k = b ? 1 : 0;
    this.f = c ? 1 : 0;
    this.o = -1;
    this.p = 0;
}
function f3d(a, b, c) {
    O2d.call(this, c);
    this.b = a;
    this.c = b;
    this.d = (v3d(), t3d);
}
function Jgc(a, b, c) {
    this.a = a;
    this.c = b;
    this.d = c;
    Ilb(b.e, this);
    Ilb(c.b, this);
}
function qNb() {
    this.e = new Ulb;
    this.c = new Ulb;
    this.d = new Ulb;
    this.b = new Ulb;
}
function PFb() {
    this.g = new SFb;
    this.b = new SFb;
    this.a = new Ulb;
    this.k = new Ulb;
}
function SUb() {
    this.a = new TTb;
    this.b = new XTb;
    this.d = new hVb;
    this.e = new dVb;
}
function sCb(a, b) {
    hwb.call(this, b.xd(), b.wd() & -6);
    tDb(a);
    this.a = a;
    this.b = b;
}
function mCb(a, b) {
    dwb.call(this, b.xd(), b.wd() & -6);
    tDb(a);
    this.a = a;
    this.b = b;
}
function yCb(a, b) {
    lwb.call(this, b.xd(), b.wd() & -6);
    tDb(a);
    this.a = a;
    this.b = b;
}
function cPc(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
    Ilb(a.t, this);
    Ilb(b.i, this);
}
function _Qc() {
    this.b = new Mtb;
    this.a = new Mtb;
    this.b = new Mtb;
    this.a = new Mtb;
}
function qGc(a, b) {
    var c;
    c = wGc(a, b);
    a.b = new cGc(c.c.length);
    return pGc(a, c);
}
function HJd(a, b, c) {
    var d;
    ++a.e;
    --a.f;
    d = JD(a.d[b].ed(c), 135);
    return d.kd();
}
function CSd(a) {
    var b;
    if (!a.a) {
        b = a.r;
        RD(b, 155) && (a.a = JD(b, 155));
    }
    return a.a;
}
function Clc(a) {
    if (a.a) {
        if (a.e) return Clc(a.e);
    } else return a;
    return null;
}
function pCc(a, b) {
    if (a.p < b.p) return 1;
    else if (a.p > b.p) return -1;
    return 0;
}
function J5d(a, b) {
    if (Lib(a.a, b)) {
        Sib(a.a, b);
        return true;
    } else return false;
}
function cRc(a) {
    var b;
    b = a.b;
    if (b.b == 0) return null;
    return JD(fu(b, 0), 65).b;
}
function fd(a) {
    var b, c;
    b = a.jd();
    c = JD(a.kd(), 16);
    return ek(c.Lc(), new hh(b));
}
function nwb(a, b) {
    tDb(b);
    if (a.c < a.d) {
        a.Qe(b, a.c++);
        return true;
    }
    return false;
}
function TAb(a) {
    var b;
    LAb(a);
    b = new ZAb(a, a.a.e, a.a.d | 4);
    return new VAb(a, b);
}
function zBb(a) {
    var b;
    KAb(a);
    b = 0;
    while(a.a.zd(new LCb))b = tcb(b, 1);
    return b;
}
function Sib(a, b) {
    return VD(b) ? b == null ? hsb(a.f, null) : Bsb(a.i, b) : hsb(a.f, b);
}
function X6b(a, b) {
    b.Sg('Label management', 1);
    ZD(WMb(a, (Gcd(), Fcd)));
    b.Tg();
}
function Si(a, b, c) {
    Pb(b, a.e.Pd().gc());
    Pb(c, a.c.Pd().gc());
    return a.a[b][c];
}
function vCc(a, b, c) {
    var d, e;
    d = 0;
    for(e = 0; e < b.length; e++)d += a.rg(b[e], d, c);
}
function SJb(a, b) {
    var c;
    if (a.C) {
        c = JD(Kqb(a.b, b), 126).n;
        c.d = a.C.d;
        c.a = a.C.a;
    }
}
function R1b(a) {
    var b, c, d, e;
    e = a.d;
    b = a.a;
    c = a.b;
    d = a.c;
    a.d = c;
    a.a = d;
    a.b = e;
    a.c = b;
}
function jg(a, b, c, d) {
    this.f = a;
    this.e = b;
    this.d = c;
    this.b = d;
    this.c = !d ? null : d.d;
}
function Vlb(a) {
    Glb(this);
    lDb(a >= 0, 'Initial capacity must not be negative');
}
function v7b() {
    v7b = Zcb;
    u7b = new LBd('separateLayerConnections', (I7b(), H7b));
}
function a6c() {
    a6c = Zcb;
    _5c = new b6c('FIXED', 0);
    $5c = new b6c('CENTER_NODE', 1);
}
function Vmc() {
    Vmc = Zcb;
    Tmc = new Wmc('QUADRATIC', 0);
    Umc = new Wmc('SCANLINE', 1);
}
function Nhc() {
    Nhc = Zcb;
    Mhc = os((Ihc(), WC(OC(EU, 1), Ere, 365, 0, [
        Hhc,
        Ghc,
        Fhc
    ])));
}
function knc() {
    knc = Zcb;
    jnc = os((cnc(), WC(OC(OV, 1), Ere, 323, 0, [
        anc,
        _mc,
        bnc
    ])));
}
function tnc() {
    tnc = Zcb;
    snc = os((onc(), WC(OC(PV, 1), Ere, 347, 0, [
        lnc,
        nnc,
        mnc
    ])));
}
function Ync() {
    Ync = Zcb;
    Xnc = os((Tnc(), WC(OC(SV, 1), Ere, 446, 0, [
        Rnc,
        Qnc,
        Snc
    ])));
}
function Jyc() {
    Jyc = Zcb;
    Iyc = os((Eyc(), WC(OC(mW, 1), Ere, 449, 0, [
        Dyc,
        Byc,
        Cyc
    ])));
}
function Syc() {
    Syc = Zcb;
    Ryc = os((Nyc(), WC(OC(nW, 1), Ere, 379, 0, [
        Kyc,
        Lyc,
        Myc
    ])));
}
function _yc() {
    _yc = Zcb;
    $yc = os((Wyc(), WC(OC(oW, 1), Ere, 345, 0, [
        Vyc,
        Tyc,
        Uyc
    ])));
}
function uxc() {
    uxc = Zcb;
    txc = os((oxc(), WC(OC(gW, 1), Ere, 349, 0, [
        lxc,
        mxc,
        nxc
    ])));
}
function tzc() {
    tzc = Zcb;
    szc = os((ozc(), WC(OC(qW, 1), Ere, 346, 0, [
        lzc,
        mzc,
        nzc
    ])));
}
function Czc() {
    Czc = Zcb;
    Bzc = os((xzc(), WC(OC(rW, 1), Ere, 348, 0, [
        wzc,
        uzc,
        vzc
    ])));
}
function Lzc() {
    Lzc = Zcb;
    Kzc = os((Gzc(), WC(OC(sW, 1), Ere, 380, 0, [
        Ezc,
        Fzc,
        Dzc
    ])));
}
function TTc() {
    TTc = Zcb;
    STc = os((OTc(), WC(OC(t$, 1), Ere, 383, 0, [
        NTc,
        MTc,
        LTc
    ])));
}
function p$c() {
    p$c = Zcb;
    o$c = os((j$c(), WC(OC(w_, 1), Ere, 384, 0, [
        g$c,
        h$c,
        i$c
    ])));
}
function vpc() {
    vpc = Zcb;
    upc = os((qpc(), WC(OC(ZV, 1), Ere, 312, 0, [
        opc,
        ppc,
        npc
    ])));
}
function mpc() {
    mpc = Zcb;
    lpc = os((hpc(), WC(OC(YV, 1), Ere, 298, 0, [
        fpc,
        gpc,
        epc
    ])));
}
function C_c() {
    C_c = Zcb;
    B_c = os((w_c(), WC(OC(B_, 1), Ere, 299, 0, [
        u_c,
        v_c,
        t_c
    ])));
}
function n0c() {
    n0c = Zcb;
    m0c = os((i0c(), WC(OC(J_, 1), Ere, 433, 0, [
        f0c,
        g0c,
        h0c
    ])));
}
function B5c() {
    B5c = Zcb;
    A5c = os((w5c(), WC(OC(y0, 1), Ere, 432, 0, [
        t5c,
        u5c,
        v5c
    ])));
}
function y3c() {
    y3c = Zcb;
    x3c = os((q3c(), WC(OC(e0, 1), Ere, 426, 0, [
        n3c,
        p3c,
        o3c
    ])));
}
function Z3c() {
    Z3c = Zcb;
    Y3c = os((R3c(), WC(OC(j0, 1), Ere, 427, 0, [
        O3c,
        Q3c,
        P3c
    ])));
}
function ZEc() {
    ZEc = Zcb;
    YEc = os((UEc(), WC(OC(bX, 1), Ere, 450, 0, [
        REc,
        SEc,
        TEc
    ])));
}
function q1c() {
    q1c = Zcb;
    p1c = os((l1c(), WC(OC(S_, 1), Ere, 385, 0, [
        j1c,
        k1c,
        i1c
    ])));
}
function qAb() {
    qAb = Zcb;
    pAb = os((lAb(), WC(OC(HL, 1), Ere, 131, 0, [
        iAb,
        jAb,
        kAb
    ])));
}
function nHb() {
    nHb = Zcb;
    mHb = os((iHb(), WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ])));
}
function UHb() {
    UHb = Zcb;
    THb = os((PHb(), WC(OC(kN, 1), Ere, 457, 0, [
        NHb,
        MHb,
        OHb
    ])));
}
function LIb() {
    LIb = Zcb;
    KIb = os((GIb(), WC(OC(rN, 1), Ere, 458, 0, [
        FIb,
        EIb,
        DIb
    ])));
}
function PPb() {
    PPb = Zcb;
    OPb = os((KPb(), WC(OC(pO, 1), Ere, 382, 0, [
        IPb,
        HPb,
        JPb
    ])));
}
function jid() {
    jid = Zcb;
    iid = os((eid(), WC(OC(p2, 1), Ere, 342, 0, [
        cid,
        bid,
        did
    ])));
}
function shd() {
    shd = Zcb;
    rhd = os((nhd(), WC(OC(k2, 1), Ere, 276, 0, [
        khd,
        lhd,
        mhd
    ])));
}
function _kd() {
    _kd = Zcb;
    $kd = os((Wkd(), WC(OC(B2, 1), Ere, 278, 0, [
        Ukd,
        Tkd,
        Vkd
    ])));
}
function tkd() {
    tkd = Zcb;
    skd = os((okd(), WC(OC(y2, 1), Ere, 297, 0, [
        lkd,
        mkd,
        nkd
    ])));
}
function lsd(a, b) {
    return !a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), nJd(a.o, b);
}
function KJd(a) {
    !a.g && (a.g = new ELd);
    !a.g.d && (a.g.d = new IKd(a));
    return a.g.d;
}
function vJd(a) {
    !a.g && (a.g = new ELd);
    !a.g.a && (a.g.a = new OKd(a));
    return a.g.a;
}
function BJd(a) {
    !a.g && (a.g = new ELd);
    !a.g.b && (a.g.b = new CKd(a));
    return a.g.b;
}
function CJd(a) {
    !a.g && (a.g = new ELd);
    !a.g.c && (a.g.c = new eLd(a));
    return a.g.c;
}
function W4d(a, b, c, d) {
    !!c && (d = c.Nh(b, WTd(c.zh(), a.c.rk()), null, d));
    return d;
}
function X4d(a, b, c, d) {
    !!c && (d = c.Ph(b, WTd(c.zh(), a.c.rk()), null, d));
    return d;
}
function tib(a, b, c, d) {
    var e;
    e = SC(cE, ise, 30, b + 1, 15, 1);
    uib(e, a, b, c, d);
    return e;
}
function SC(a, b, c, d, e, f) {
    var g;
    g = TC(e, d);
    e != 10 && WC(OC(a, f), b, c, e, g);
    return g;
}
function tbe(a, b, c) {
    var d, e;
    e = new ide(b, a);
    for(d = 0; d < c; ++d)Yce(e);
    return e;
}
function xCd(a, b, c) {
    var d, e;
    if (c != null) for(d = 0; d < b; ++d){
        e = c[d];
        a.Ni(d, e);
    }
}
function Mxb(a, b) {
    var c;
    c = new uyb;
    c.c = true;
    c.d = b.kd();
    return Nxb(a, b.jd(), c);
}
function jB(a, b) {
    var c;
    c = a.q.getHours() + (b / 3600 | 0);
    a.q.setSeconds(b);
    eB(a, c);
}
function yt(a, b) {
    var c, d;
    c = b;
    d = ynb($u(new Ju(a, c)));
    wr(new Ju(a, c));
    return d;
}
function Rbe(a, b, c, d) {
    Qbe(a, b, c, Fbe(a, b, d, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0));
}
function LLb(a, b, c) {
    JD(a.b, 68);
    JD(a.b, 68);
    JD(a.b, 68);
    Llb(a.a, new ULb(c, b, a));
}
function zDb(a, b, c) {
    if (a < 0 || b > c || b < a) throw scb(new Xgb(vte + a + xte + b + kte + c));
}
function MAb(a) {
    if (!a) {
        this.c = null;
        this.b = new Ulb;
    } else {
        this.c = a;
        this.b = null;
    }
}
function Ysb(a) {
    Vib.call(this, a, 0);
    Qsb(this);
    this.d.b = this.d;
    this.d.a = this.d;
}
function tyb(a, b) {
    okb.call(this, a, b);
    this.a = SC(mL, tre, 435, 2, 0, 1);
    this.b = true;
}
function lsb(a) {
    this.e = a;
    this.b = this.e.a.entries();
    this.a = SC(aJ, Nqe, 1, 0, 5, 1);
}
function cAc() {
    cAc = Zcb;
    bAc = C9c(E9c(new J9c, (CQb(), xQb), (u5b(), R4b)), BQb, l5b);
}
function Boc() {
    yoc();
    return WC(OC(VV, 1), Ere, 279, 0, [
        voc,
        uoc,
        xoc,
        toc,
        woc,
        soc
    ]);
}
function Noc() {
    Koc();
    return WC(OC(WV, 1), Ere, 280, 0, [
        Ioc,
        Foc,
        Joc,
        Hoc,
        Goc,
        Eoc
    ]);
}
function hoc() {
    doc();
    return WC(OC(TV, 1), Ere, 281, 0, [
        $nc,
        Znc,
        aoc,
        _nc,
        coc,
        boc
    ]);
}
function Qmc() {
    Nmc();
    return WC(OC(MV, 1), Ere, 231, 0, [
        Jmc,
        Lmc,
        Imc,
        Kmc,
        Mmc,
        Hmc
    ]);
}
function fed() {
    ced();
    return WC(OC(d2, 1), Ere, 254, 0, [
        Ydd,
        _dd,
        aed,
        bed,
        Zdd,
        $dd
    ]);
}
function Ked() {
    Hed();
    return WC(OC(g2, 1), Ere, 296, 0, [
        Ged,
        Fed,
        Eed,
        Ced,
        Bed,
        Ded
    ]);
}
function Mhd() {
    Jhd();
    return WC(OC(m2, 1), Ere, 322, 0, [
        Hhd,
        Fhd,
        Ihd,
        Dhd,
        Ghd,
        Ehd
    ]);
}
function fjd() {
    ajd();
    return WC(OC(t2, 1), Ere, 100, 0, [
        _id,
        $id,
        Zid,
        Wid,
        Yid,
        Xid
    ]);
}
function tjd() {
    ojd();
    return WC(OC(u2, 1), Ere, 277, 0, [
        mjd,
        kjd,
        ljd,
        jjd,
        ijd,
        njd
    ]);
}
function Doe(a, b, c) {
    ooe();
    var d;
    d = Coe(a, b);
    c && !!d && Foe(a) && (d = null);
    return d;
}
function aIb(a, b) {
    wub(b, 'Horizontal alignment cannot be null');
    a.b = b;
    return a;
}
function tCd(a, b) {
    if (a.Pi() && a.Gc(b)) return false;
    else {
        a.Ei(b);
        return true;
    }
}
function d_d(a) {
    var b;
    if (!a.a && a.b != -1) {
        b = a.c.zh();
        a.a = QTd(b, a.b);
    }
    return a.a;
}
function pdd(a, b) {
    var c, d;
    c = a.a - b.a;
    d = a.b - b.b;
    return $wnd.Math.sqrt(c * c + d * d);
}
function rgc(a, b, c) {
    var d;
    a.d[b.g] = c;
    d = a.g.c;
    d[b.g] = $wnd.Math.max(d[b.g], c + 1);
}
function aFc(a, b, c) {
    var d;
    d = a.b[c.c.p][c.p];
    d.b += b.b;
    d.c += b.c;
    d.a += b.a;
    ++d.a;
}
function HTb(a, b, c) {
    var d, e;
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 36);
        GTb(d, b, c);
    }
}
function FTb(a, b) {
    var c, d;
    for(d = b.Jc(); d.Ob();){
        c = JD(d.Pb(), 36);
        ETb(a, c, 0, 0);
    }
}
function JWc(a) {
    var b, c;
    for(c = Gtb(a.a, 0); c.b != c.d.c;){
        b = JD(Utb(c), 65);
        KWc(b);
    }
}
function ryd(a, b) {
    var c;
    c = Nib(a.k, b);
    ezd(a, b);
    dzd(a, b);
    ozd(a, b, c);
    return null;
}
function iqd(a, b) {
    var c;
    return c = a.Eh(b), c >= 0 ? a.Hh(c, true, true) : uqd(a, b, true);
}
function e4c(a, b) {
    var c, d, e;
    e = a.r;
    d = a.d;
    c = g4c(a, b, true);
    return c.b != e || c.a != d;
}
function Mgc(a, b) {
    Ssb(a.e, b) || Usb(a.e, b, new Sgc(b));
    return JD(Tsb(a.e, b), 112);
}
function hAb(a, b, c, d) {
    tDb(a);
    tDb(b);
    tDb(c);
    tDb(d);
    return new rAb(a, b, new Bzb);
}
function oae(a, b, c) {
    var d, e;
    e = (d = g1d(a.b, b), d);
    return !e ? null : Oae(iae(a, e), c);
}
function Pyd(a, b, c) {
    var d, e, f;
    d = iC(a, c);
    e = null;
    !!d && (e = cyd(d));
    f = e;
    jzd(b, c, f);
}
function Qyd(a, b, c) {
    var d, e, f;
    d = iC(a, c);
    e = null;
    !!d && (e = cyd(d));
    f = e;
    jzd(b, c, f);
}
function YQd(a, b, c, d) {
    this.Zj();
    this.a = b;
    this.b = a;
    this.c = new Ree(this, b, c, d);
}
function h_d(a, b, c, d, e, f) {
    jGd.call(this, b, d, e, f);
    c_d(this);
    this.c = a;
    this.b = c;
}
function x_d(a, b, c, d, e, f) {
    jGd.call(this, b, d, e, f);
    c_d(this);
    this.c = a;
    this.a = c;
}
function gCb(a, b) {
    lwb.call(this, b.xd(), b.wd() & -16449);
    tDb(a);
    this.a = a;
    this.c = b;
}
function YSb(a, b) {
    if (a.a.Le(b.d, a.b) > 0) {
        Ilb(a.c, new pSb(b.c, b.d, a.d));
        a.b = b.d;
    }
}
function _Fc(a) {
    a.a = SC(cE, ise, 30, a.b + 1, 15, 1);
    a.c = SC(cE, ise, 30, a.b, 15, 1);
    a.d = 0;
}
function R9c(a) {
    P9c();
    JD(a.mf((Lgd(), agd)), 181).Ec((ojd(), ljd));
    a.of(_fd, null);
}
function P9c() {
    P9c = Zcb;
    M9c = new V9c;
    O9c = new X9c;
    N9c = un((Lgd(), _fd), M9c, Gfd, O9c);
}
function _Zc() {
    _Zc = Zcb;
    ZZc = new b$c('LEAF_NUMBER', 0);
    $Zc = new b$c('NODE_SIZE', 1);
}
function Jr(a) {
    var b;
    Qb(a);
    if (RD(a, 204)) {
        b = JD(a, 204);
        return b;
    }
    return new Kr(a);
}
function VBb(a) {
    while(!a.a){
        if (!xCb(a.c, new ZBb(a))) return false;
    }
    return true;
}
function mCd(a) {
    var b;
    if (!a.a) throw scb(new rub);
    b = a.a;
    a.a = Zwd(a.a);
    return b;
}
function jqe(a) {
    if (a.b <= 0) throw scb(new qub);
    --a.b;
    a.a -= a.c.c;
    return jfb(a.a);
}
function kDd(a, b) {
    if (a.g == null || b >= a.i) throw scb(new XId(b, a.i));
    return a.g[b];
}
function iXd(a, b, c) {
    FCd(a, c);
    if (c != null && !a.ck(c)) throw scb(new pdb);
    return c;
}
function jGc(a, b, c) {
    var d;
    d = tGc(a, b, c);
    a.b = new cGc(d.c.length);
    return lGc(a, d);
}
function Zi(a, b) {
    var c, d;
    d = b / a.c.Pd().gc() | 0;
    c = b % a.c.Pd().gc();
    return Si(a, d, c);
}
function Nmb(a, b, c, d) {
    var e;
    d = (jqb(), !d ? gqb : d);
    e = a.slice(b, c);
    Omb(e, a, b, c, -b, d);
}
function dqd(a, b, c, d, e) {
    return b < 0 ? uqd(a, c, d) : JD(c, 69).tk().vk(a, a.di(), b, d, e);
}
function V2b(a, b) {
    return Heb(Beb(MD(WMb(a, (Iqc(), tqc)))), Beb(MD(WMb(b, tqc))));
}
function ezb() {
    ezb = Zcb;
    dzb = os((Syb(), WC(OC(rL, 1), Ere, 305, 0, [
        Oyb,
        Pyb,
        Qyb,
        Ryb
    ])));
}
function Syb() {
    Syb = Zcb;
    Oyb = new Tyb('All', 0);
    Pyb = new Yyb;
    Qyb = new $yb;
    Ryb = new bzb;
}
function PHb() {
    PHb = Zcb;
    NHb = new QHb(_te, 0);
    MHb = new QHb(Yte, 1);
    OHb = new QHb(aue, 2);
}
function sie() {
    sie = Zcb;
    Uud();
    pie = Kse;
    oie = Lse;
    rie = new Keb(Kse);
    qie = new Keb(Lse);
}
function hUb() {
    hUb = Zcb;
    gUb = os((cUb(), WC(OC(iP, 1), Ere, 381, 0, [
        bUb,
        _Tb,
        $Tb,
        aUb
    ])));
}
function O7b() {
    O7b = Zcb;
    N7b = os((I7b(), WC(OC(YR, 1), Ere, 364, 0, [
        H7b,
        F7b,
        G7b,
        E7b
    ])));
}
function CLb() {
    CLb = Zcb;
    BLb = os((xLb(), WC(OC(HN, 1), Ere, 406, 0, [
        wLb,
        tLb,
        uLb,
        vLb
    ])));
}
function GSb() {
    GSb = Zcb;
    FSb = os((xSb(), WC(OC(TO, 1), Ere, 405, 0, [
        tSb,
        wSb,
        uSb,
        vSb
    ])));
}
function Igc() {
    Igc = Zcb;
    Hgc = os((Dgc(), WC(OC(vU, 1), Ere, 410, 0, [
        zgc,
        Agc,
        Bgc,
        Cgc
    ])));
}
function Gxc() {
    Gxc = Zcb;
    Fxc = os((zxc(), WC(OC(hW, 1), Ere, 203, 0, [
        xxc,
        yxc,
        wxc,
        vxc
    ])));
}
function syc() {
    syc = Zcb;
    ryc = os((nyc(), WC(OC(kW, 1), Ere, 266, 0, [
        kyc,
        jyc,
        lyc,
        myc
    ])));
}
function moc() {
    moc = Zcb;
    loc = new noc(yve, 0);
    koc = new noc('IMPROVE_STRAIGHTNESS', 1);
}
function Mlc(a) {
    var b;
    for(b = a.p + 1; b < a.c.a.c.length; ++b)--JD(Mlb(a.c.a, b), 9).p;
}
function DUd(a) {
    var b;
    if (a.kl()) for(b = a.i - 1; b >= 0; --b)nDd(a, b);
    return tDd(a);
}
function Bxb(a) {
    var b, c;
    if (!a.b) return null;
    c = a.b;
    while(b = c.a[0])c = b;
    return c;
}
function Cxb(a) {
    var b, c;
    if (!a.b) return null;
    c = a.b;
    while(b = c.a[1])c = b;
    return c;
}
function a6d(a) {
    if (RD(a, 179)) return '' + JD(a, 179).a;
    return a == null ? null : adb(a);
}
function b6d(a) {
    if (RD(a, 179)) return '' + JD(a, 179).a;
    return a == null ? null : adb(a);
}
function dEb(a, b) {
    if (b.a) throw scb(new qz(Fte));
    Nrb(a.a, b);
    b.a = a;
    !a.j && (a.j = b);
}
function HGc(a, b) {
    gGc();
    return Ilb(a, new xod(b, jfb(b.e.c.length + b.g.c.length)));
}
function JGc(a, b) {
    gGc();
    return Ilb(a, new xod(b, jfb(b.e.c.length + b.g.c.length)));
}
function CRc(a, b) {
    return new Mod(b, ldd(odd(b.e), b.f.a + a, b.f.b + a), (xdb(), false));
}
function XC(a, b) {
    PC(b) != 10 && WC(rb(b), b.Pm, b.__elementTypeId$, PC(b), a);
    return a;
}
function s_c() {
    s_c = Zcb;
    r_c = os((m_c(), WC(OC(A_, 1), Ere, 351, 0, [
        l_c,
        j_c,
        k_c,
        i_c
    ])));
}
function AVc() {
    AVc = Zcb;
    zVc = os((vVc(), WC(OC(x$, 1), Ere, 350, 0, [
        uVc,
        sVc,
        tVc,
        rVc
    ])));
}
function hQc() {
    hQc = Zcb;
    gQc = os((_Pc(), WC(OC(vZ, 1), Ere, 396, 0, [
        XPc,
        YPc,
        ZPc,
        $Pc
    ])));
}
function J0c() {
    J0c = Zcb;
    I0c = os((D0c(), WC(OC(N_, 1), Ere, 398, 0, [
        C0c,
        z0c,
        B0c,
        A0c
    ])));
}
function Dkd() {
    Dkd = Zcb;
    Ckd = os((ykd(), WC(OC(z2, 1), Ere, 378, 0, [
        wkd,
        xkd,
        vkd,
        ukd
    ])));
}
function jhd() {
    jhd = Zcb;
    ihd = os((ehd(), WC(OC(j2, 1), Ere, 275, 0, [
        bhd,
        ahd,
        chd,
        dhd
    ])));
}
function Chd() {
    Chd = Zcb;
    Bhd = os((xhd(), WC(OC(l2, 1), Ere, 220, 0, [
        whd,
        uhd,
        thd,
        vhd
    ])));
}
function uid() {
    uid = Zcb;
    tid = os((oid(), WC(OC(q2, 1), Ere, 289, 0, [
        nid,
        kid,
        lid,
        mid
    ])));
}
function tmd() {
    tmd = Zcb;
    smd = os((omd(), WC(OC(J2, 1), Ere, 321, 0, [
        nmd,
        kmd,
        mmd,
        lmd
    ])));
}
function god() {
    god = Zcb;
    fod = os((bod(), WC(OC(f3, 1), Ere, 404, 0, [
        $nd,
        _nd,
        Znd,
        aod
    ])));
}
function q3c() {
    q3c = Zcb;
    n3c = new s3c(dAe, 0);
    p3c = new s3c(fze, 1);
    o3c = new s3c(yve, 2);
}
function gAb(a, b, c, d, e) {
    tDb(a);
    tDb(b);
    tDb(c);
    tDb(d);
    tDb(e);
    return new rAb(a, b, d);
}
function Wsb(a, b) {
    var c;
    c = JD(Sib(a.e, b), 391);
    if (c) {
        gtb(c);
        return c.e;
    }
    return null;
}
function Plb(a, b) {
    var c;
    c = Nlb(a, b, 0);
    if (c == -1) return false;
    Olb(a, c);
    return true;
}
function KBb(a, b, c) {
    var d;
    KAb(a);
    d = new HCb;
    d.a = b;
    a.a.Nb(new PCb(d, c));
    return d.a;
}
function UAb(a) {
    var b;
    KAb(a);
    b = SC(aE, Rse, 30, 0, 15, 1);
    Yvb(a.a, new cBb(b));
    return b;
}
function yc(a) {
    var b;
    if (!xc(a)) throw scb(new qub);
    a.e = 1;
    b = a.d;
    a.d = null;
    return b;
}
function Gcb(a) {
    var b;
    if (Ccb(a)) {
        b = 0 - a;
        if (!isNaN(b)) return b;
    }
    return wcb(pD(a));
}
function Nlb(a, b, c) {
    for(; c < a.c.length; ++c){
        if (tub(b, a.c[c])) return c;
    }
    return -1;
}
function dgc(a) {
    var b, c;
    c = JD(Mlb(a.j, 0), 11);
    b = JD(WMb(c, (Iqc(), kqc)), 11);
    return b;
}
function Ju(a, b) {
    var c;
    this.f = a;
    this.b = b;
    c = JD(Nib(a.b, b), 260);
    this.c = !c ? null : c.b;
}
function Sdc() {
    Adc();
    this.b = new Irb;
    this.f = new Irb;
    this.g = new Irb;
    this.e = new Irb;
}
function kOd(a) {
    Yy(this);
    this.g = !a ? null : dz(a, a.ge());
    this.f = a;
    $y(this);
    this.he();
}
function OFd(a) {
    var b;
    b = a.gj();
    b != null && a.d != -1 && JD(b, 93).th(a);
    !!a.i && a.i.lj();
}
function ljb(a) {
    xDb(!!a.c);
    qDb(a.f.g, a.d);
    a.c.Qb();
    a.c = null;
    a.b = jjb(a);
    a.d = a.f.g;
}
function J_d(a) {
    if (!a.b) {
        a.b = new N0d(a, g6, a);
        !a.a && (a.a = new $_d(a, a));
    }
    return a.b;
}
function iae(a, b) {
    var c, d;
    c = JD(b, 675);
    d = c.ti();
    !d && c.wi(d = new Rae(a, b));
    return d;
}
function jae(a, b) {
    var c, d;
    c = JD(b, 677);
    d = c.Xk();
    !d && c._k(d = new cbe(a, b));
    return d;
}
function odc(a, b) {
    jdc();
    var c, d;
    c = ndc(a);
    d = ndc(b);
    return !!c && !!d && !rnb(c.k, d.k);
}
function _8c(a, b) {
    if (b < 0) throw scb(new mdb(wBe + b));
    $8c(a, b + 1);
    return Mlb(a.j, b);
}
function Ob(a, b, c, d) {
    if (!a) throw scb(new Teb(hc(b, WC(OC(aJ, 1), Nqe, 1, 5, [
        c,
        d
    ]))));
}
function VDb(a, b) {
    return tub(b, Mlb(a.f, 0)) || tub(b, Mlb(a.f, 1)) || tub(b, Mlb(a.f, 2));
}
function KPb() {
    KPb = Zcb;
    IPb = new LPb('XY', 0);
    HPb = new LPb('X', 1);
    JPb = new LPb('Y', 2);
}
function vyc() {
    vyc = Zcb;
    tyc = new wyc('INPUT_ORDER', 0);
    uyc = new wyc('PORT_DEGREE', 1);
}
function GIb() {
    GIb = Zcb;
    FIb = new HIb('TOP', 0);
    EIb = new HIb(Yte, 1);
    DIb = new HIb(cue, 2);
}
function JLb(a, b) {
    ILb = new uMb;
    GLb = b;
    HLb = a;
    JD(HLb.b, 68);
    LLb(HLb, ILb, null);
    KLb(HLb);
}
function rgb(a) {
    var b, c;
    c = a.length;
    b = SC(_D, Ure, 30, c, 15, 1);
    egb(a, 0, c, b, 0);
    return b;
}
function Rdb(a) {
    Qdb();
    var b, c;
    b = a + 128;
    c = Pdb[b];
    !c && (c = Pdb[b] = new Jdb(a));
    return c;
}
function qtb(a) {
    qDb(a.d.a.e.g, a.b);
    rDb(a.c != a.d.a.d);
    a.a = a.c;
    a.c = a.c.a;
    return a.a;
}
function Ond(a) {
    (!this.q ? (pnb(), pnb(), nnb) : this.q).zc(!a.q ? (pnb(), pnb(), nnb) : a.q);
}
function Cqd(a) {
    var b;
    if (!a.Kh()) {
        b = VTd(a.zh()) - a.fi();
        a.Wh().Jk(b);
    }
    return a.vh();
}
function zrd(a) {
    var b;
    b = KD(Crd(a, 32));
    if (b == null) {
        Ard(a);
        b = KD(Crd(a, 32));
    }
    return b;
}
function kqd(a, b) {
    var c;
    c = WTd(a.d, b);
    return c >= 0 ? hqd(a, c, true, true) : uqd(a, b, true);
}
function ipd(a, b) {
    bjd(JD(JD(a.f, 27).mf((Lgd(), Yfd)), 100)) && ILd($wd(JD(a.f, 27)), b);
}
function Uyd(a, b) {
    htd(a, b == null || Ieb((tDb(b), b)) || isNaN((tDb(b), b)) ? 0 : (tDb(b), b));
}
function Vyd(a, b) {
    itd(a, b == null || Ieb((tDb(b), b)) || isNaN((tDb(b), b)) ? 0 : (tDb(b), b));
}
function Wyd(a, b) {
    gtd(a, b == null || Ieb((tDb(b), b)) || isNaN((tDb(b), b)) ? 0 : (tDb(b), b));
}
function Xyd(a, b) {
    etd(a, b == null || Ieb((tDb(b), b)) || isNaN((tDb(b), b)) ? 0 : (tDb(b), b));
}
function CA(a, b) {
    while(b[0] < a.length && hgb(' \t\r\n', wgb(_fb(a, b[0]))) >= 0)++b[0];
}
function npe(a, b, c, d) {
    ooe();
    poe.call(this, 26);
    this.c = a;
    this.a = b;
    this.d = c;
    this.b = d;
}
function i_d(a, b, c, d, e, f, g) {
    kGd.call(this, b, d, e, f, g);
    c_d(this);
    this.c = a;
    this.b = c;
}
function rDd(a, b, c) {
    var d;
    d = a.g[b];
    jDd(a, b, a.Wi(b, c));
    a.Oi(b, c, d);
    a.Ki();
    return d;
}
function CCd(a, b) {
    var c;
    c = a.bd(b);
    if (c >= 0) {
        a.ed(c);
        return true;
    } else return false;
}
function Tsb(a, b) {
    var c;
    c = JD(Nib(a.e, b), 391);
    if (c) {
        Vsb(a, c);
        return c.e;
    }
    return null;
}
function RRd(a) {
    var b;
    if (a.d != a.r) {
        b = pRd(a);
        a.e = !!b && b.ik() == cFe;
        a.d = b;
    }
    return a.e;
}
function tr(a, b) {
    var c;
    Qb(a);
    Qb(b);
    c = false;
    while(b.Ob())c = c | a.Ec(b.Pb());
    return c;
}
function avb(a) {
    var b;
    b = a.b.c.length == 0 ? null : Mlb(a.b, 0);
    b != null && cvb(a, 0);
    return b;
}
function DBb(a, b) {
    var c, d;
    LAb(a);
    d = new yCb(b, a.a);
    c = new XBb(d);
    return new RBb(a, c);
}
function qpc() {
    qpc = Zcb;
    opc = new rpc(yve, 0);
    ppc = new rpc('TOP', 1);
    npc = new rpc(cue, 2);
}
function MSb() {
    MSb = Zcb;
    JSb = new hTb;
    KSb = new lTb;
    HSb = new pTb;
    ISb = new tTb;
    LSb = new xTb;
}
function PC(a) {
    return a.__elementTypeCategory$ == null ? 10 : a.__elementTypeCategory$;
}
function rQc(a, b, c) {
    return qdd(new Edd(c.e.a + c.f.a / 2, c.e.b + c.f.b / 2), a) == (tDb(b), b);
}
function Jdc(a, b) {
    var c, d, e;
    e = b.c.i;
    c = JD(Nib(a.f, e), 60);
    d = c.d.c - c.e.c;
    Odd(b.a, d, 0);
}
function $Fc(a, b) {
    var c;
    ++a.d;
    ++a.c[b];
    c = b + 1;
    while(c < a.a.length){
        ++a.a[c];
        c += c & -c;
    }
}
function MA(a, b, c) {
    var d, e;
    d = 10;
    for(e = 0; e < c - 1; e++){
        b < d && (a.a += '0', a);
        d *= 10;
    }
    a.a += b;
}
function Aqe(a, b) {
    var c;
    c = 0;
    while(a.e != a.i.gc()){
        JAd(b, AHd(a), jfb(c));
        c != Hqe && ++c;
    }
}
function aB(a) {
    var b, c;
    b = a / 60 | 0;
    c = a % 60;
    if (c == 0) return '' + b;
    return '' + b + ':' + ('' + c);
}
function BB(d, a) {
    var b = d.a[a];
    var c = (zC(), yC)[typeof b];
    return c ? c(b) : FC(typeof b);
}
function pxc(a) {
    switch(a.g){
        case 0:
            return Hqe;
        case 1:
            return Lre;
        default:
            return 0;
    }
}
function wD(a) {
    if (mD(a, (ED(), DD)) < 0) return -iD(pD(a));
    return a.l + a.m * Cse + a.h * Dse;
}
function Hu(a) {
    if (!a.c) throw scb(new qub);
    a.e = a.a = a.c;
    a.c = a.c.c;
    ++a.d;
    return a.a.f;
}
function Iu(a) {
    if (!a.e) throw scb(new qub);
    a.c = a.a = a.e;
    a.e = a.e.e;
    --a.d;
    return a.a.f;
}
function Arb(a) {
    var b;
    ++a.a;
    for(b = a.c.a.length; a.a < b; ++a.a){
        if (a.c.b[a.a]) return;
    }
}
function Tz(a) {
    var b, c;
    if (a.a) {
        c = null;
        do {
            b = a.a;
            a.a = null;
            c = Xz(b, c);
        }while (a.a);
        a.a = c;
    }
}
function Uz(a) {
    var b, c;
    if (a.b) {
        c = null;
        do {
            b = a.b;
            a.b = null;
            c = Xz(b, c);
        }while (a.b);
        a.b = c;
    }
}
function u6b(a, b) {
    var c, d;
    d = b.c;
    for(c = d + 1; c <= b.f; c++)a.a[c] > a.a[d] && (d = c);
    return d;
}
function ifc(a, b) {
    var c;
    c = Sy(a.e.c, b.e.c);
    if (c == 0) return Heb(a.e.d, b.e.d);
    return c;
}
function sgb(a, b) {
    return b == (kub(), kub(), jub) ? a.toLocaleLowerCase() : a.toLowerCase();
}
function Lbe(a, b) {
    return RD(b, 101) && (JD(b, 19).Bb & Pse) != 0 ? new lde(b, a) : new ide(b, a);
}
function Nbe(a, b) {
    return RD(b, 101) && (JD(b, 19).Bb & Pse) != 0 ? new lde(b, a) : new ide(b, a);
}
function HQb() {
    HQb = Zcb;
    GQb = os((CQb(), WC(OC(AO, 1), Ere, 360, 0, [
        xQb,
        yQb,
        zQb,
        AQb,
        BQb
    ])));
}
function Hnc() {
    Hnc = Zcb;
    Gnc = os((znc(), WC(OC(QV, 1), Ere, 344, 0, [
        vnc,
        unc,
        xnc,
        ync,
        wnc
    ])));
}
function ehc() {
    ehc = Zcb;
    dhc = os(($gc(), WC(OC(DU, 1), Ere, 368, 0, [
        Wgc,
        Ygc,
        Zgc,
        Xgc,
        Vgc
    ])));
}
function Uxc() {
    Uxc = Zcb;
    Txc = os((Mxc(), WC(OC(iW, 1), Ere, 324, 0, [
        Lxc,
        Ixc,
        Jxc,
        Hxc,
        Kxc
    ])));
}
function Tqc() {
    Tqc = Zcb;
    Sqc = os((Oqc(), WC(OC(_V, 1), Ere, 171, 0, [
        Nqc,
        Jqc,
        Kqc,
        Lqc,
        Mqc
    ])));
}
function pZc() {
    pZc = Zcb;
    oZc = os((jZc(), WC(OC(l_, 1), Ere, 361, 0, [
        hZc,
        eZc,
        iZc,
        fZc,
        gZc
    ])));
}
function N4c() {
    N4c = Zcb;
    M4c = os((I4c(), WC(OC(n0, 1), Ere, 366, 0, [
        E4c,
        D4c,
        G4c,
        F4c,
        H4c
    ])));
}
function q6c() {
    q6c = Zcb;
    p6c = os((l6c(), WC(OC(F0, 1), Ere, 325, 0, [
        g6c,
        h6c,
        k6c,
        i6c,
        j6c
    ])));
}
function _gd() {
    _gd = Zcb;
    $gd = os((Tgd(), WC(OC(i2, 1), Ere, 86, 0, [
        Rgd,
        Qgd,
        Pgd,
        Ogd,
        Sgd
    ])));
}
function $jd() {
    $jd = Zcb;
    Zjd = os((Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])));
}
function Vid() {
    Vid = Zcb;
    Uid = os((Qid(), WC(OC(s2, 1), Ere, 255, 0, [
        Nid,
        Pid,
        Lid,
        Mid,
        Oid
    ])));
}
function qcd() {
    qcd = Zcb;
    pcd = os((lcd(), WC(OC(V1, 1), Ere, 170, 0, [
        jcd,
        icd,
        gcd,
        kcd,
        hcd
    ])));
}
function Knc() {
    Knc = Zcb;
    Inc = new Lnc('READING_DIRECTION', 0);
    Jnc = new Lnc('ROTATION', 1);
}
function bOb() {
    bOb = Zcb;
    _Nb = new cOb('EADES', 0);
    aOb = new cOb('FRUCHTERMAN_REINGOLD', 1);
}
function ED() {
    ED = Zcb;
    AD = _C(zse, zse, 524287);
    BD = _C(0, 0, Bse);
    CD = ZC(1);
    ZC(2);
    DD = ZC(0);
}
function z8c(a, b) {
    var c;
    c = JD(Nib(a.a, b), 148);
    if (!c) {
        c = new $Mb;
        Qib(a.a, b, c);
    }
    return c;
}
function ulc(a) {
    var b;
    b = JD(WMb(a, (Iqc(), Gpc)), 314);
    if (b) return b.a == a;
    return false;
}
function vlc(a) {
    var b;
    b = JD(WMb(a, (Iqc(), Gpc)), 314);
    if (b) return b.i == a;
    return false;
}
function Fvb(a, b) {
    tDb(b);
    Evb(a);
    if (a.d.Ob()) {
        b.Ad(a.d.Pb());
        return true;
    }
    return false;
}
function Xy(a) {
    if (vcb(a, Hqe) > 0) return Hqe;
    if (vcb(a, Lre) < 0) return Lre;
    return Pcb(a);
}
function Ov(a) {
    if (a < 3) {
        bk(a, Bre);
        return a + 1;
    }
    if (a < Cre) return YD(a / 0.75 + 1);
    return Hqe;
}
function kC(a, b, c) {
    var d;
    if (b == null) throw scb(new Efb);
    d = iC(a, b);
    lC(a, b, c);
    return d;
}
function p_b(a, b, c) {
    var d, e;
    for(e = new rmb(c); e.a < e.c.c.length;){
        d = pmb(e);
        o_b(a, b, d);
    }
}
function oLc(a, b, c) {
    var d;
    d = a.a.e[JD(b.a, 9).p] - a.a.e[JD(c.a, 9).p];
    return YD(Cfb(d));
}
function QTd(a, b) {
    var c;
    c = (a.i == null && MTd(a), a.i);
    return b >= 0 && b < c.length ? c[b] : null;
}
function old(a, b) {
    var c;
    c = b > 0 ? b - 1 : b;
    return sld(tld(uld(vld(new wld, c), a.n), a.j), a.k);
}
function Rvd(a) {
    var b, c;
    c = (b = new L_d, b);
    tCd((!a.q && (a.q = new X0d(k6, a, 11, 10)), a.q), c);
}
function fTb(a) {
    this.g = a;
    this.f = new Ulb;
    this.a = $wnd.Math.min(this.g.c.c, this.g.d.c);
}
function cEb(a) {
    this.b = new Ulb;
    this.a = new Ulb;
    this.c = new Ulb;
    this.d = new Ulb;
    this.e = a;
}
function dIb(a, b, c) {
    aHb.call(this);
    VHb(this);
    this.a = a;
    this.c = c;
    this.b = b.d;
    this.f = b.e;
}
function yd(a) {
    this.d = a;
    this.c = a.c.vc().Jc();
    this.b = null;
    this.a = null;
    this.e = (vs(), us);
}
function wDd(a) {
    if (a < 0) throw scb(new Teb('Illegal Capacity: ' + a));
    this.g = this.Zi(a);
}
function Gic() {
    Dic();
    return WC(OC(TU, 1), Ere, 272, 0, [
        wic,
        zic,
        vic,
        Cic,
        yic,
        xic,
        Bic,
        Aic
    ]);
}
function GYb() {
    DYb();
    return WC(OC(PP, 1), Ere, 247, 0, [
        AYb,
        yYb,
        wYb,
        BYb,
        xYb,
        vYb,
        CYb,
        zYb
    ]);
}
function EBd() {
    BBd();
    return WC(OC(L4, 1), Ere, 243, 0, [
        ABd,
        xBd,
        yBd,
        wBd,
        zBd,
        uBd,
        tBd,
        vBd
    ]);
}
function Ccd() {
    zcd();
    return WC(OC(W1, 1), Ere, 282, 0, [
        ycd,
        rcd,
        vcd,
        xcd,
        scd,
        tcd,
        ucd,
        wcd
    ]);
}
function aWc(a, b) {
    UVc();
    return -$eb(JD(WMb(a, (kVc(), ZUc)), 17).a, JD(WMb(b, ZUc), 17).a);
}
function to(a, b) {
    return !!Do(a, b, Pcb(Fcb(yre, hfb(Pcb(Fcb(b == null ? 0 : tb(b), zre)), 15))));
}
function feb(a) {
    return ((a.i & 2) != 0 ? 'interface ' : (a.i & 1) != 0 ? '' : 'class ') + (ceb(a), a.o);
}
function OBb(a, b) {
    var c;
    LAb(a);
    c = new bCb(a, a.a.xd(), a.a.wd() | 4, b);
    return new RBb(a, c);
}
function je(a, b) {
    var c, d;
    c = JD(Tv(a.d, b), 16);
    if (!c) return null;
    d = b;
    return a.e.pc(d, c);
}
function _6b(a, b) {
    var c, d;
    for(d = a.Jc(); d.Ob();){
        c = JD(d.Pb(), 72);
        ZMb(c, (Iqc(), cqc), b);
    }
}
function X5b(a) {
    var b;
    b = Beb(MD(WMb(a, (Bwc(), Fuc))));
    if (b < 0) {
        b = 0;
        ZMb(a, Fuc, b);
    }
    return b;
}
function OWb(a, b) {
    bjd(JD(WMb(JD(a.e, 9), (Bwc(), Evc)), 100)) && (pnb(), Slb(JD(a.e, 9).j, b));
}
function c3c(a, b) {
    msd(a, (h1c(), d1c), b.f);
    msd(a, a1c, b.e);
    msd(a, c1c, b.d);
    msd(a, _0c, b.c);
}
function Wtb(a) {
    var b;
    xDb(!!a.c);
    b = a.c.a;
    Ktb(a.d, a.c);
    a.b == a.c ? a.b = b : --a.a;
    a.c = null;
}
function Hjc(a) {
    a.a >= -0.01 && a.a <= fue && (a.a = 0);
    a.b >= -0.01 && a.b <= fue && (a.b = 0);
    return a;
}
function Ucd(a) {
    Icd();
    var b, c;
    c = Fze;
    for(b = 0; b < a.length; b++)a[b] > c && (c = a[b]);
    return c;
}
function Dqd(a, b) {
    var c;
    c = RTd(a.zh(), b);
    if (!c) throw scb(new Teb(LCe + b + OCe));
    return c;
}
function kCd(a, b) {
    var c;
    c = a;
    while(Zwd(c)){
        c = Zwd(c);
        if (c == b) return true;
    }
    return false;
}
function trb(a, b) {
    if (!!b && a.b[b.g] == b) {
        VC(a.b, b.g, null);
        --a.c;
        return true;
    }
    return false;
}
function Ktb(a, b) {
    var c;
    c = b.c;
    b.a.b = b.b;
    b.b.a = b.a;
    b.a = b.b = null;
    b.c = null;
    --a.b;
    return c;
}
function Llb(a, b) {
    var c, d, e, f;
    tDb(b);
    for(d = a.c, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        b.Ad(c);
    }
}
function ex(a, b) {
    var c, d, e;
    d = b.a.jd();
    c = JD(b.a.kd(), 16).gc();
    for(e = 0; e < c; e++)a.Ad(d);
}
function bcc(a, b, c) {
    var d;
    d = $wnd.Math.max(0, a.b / 2 - 0.5);
    Xbc(c, d, 1);
    Ilb(b, new kcc(c, d));
}
function nbe(a, b, c, d) {
    var e;
    a.j = -1;
    NGd(a, Bbe(a, b, c), (Ife(), e = JD(b, 69).sk(), e.ul(d)));
}
function AVb(a, b, c, d, e, f) {
    var g;
    g = CVb(d);
    gWb(g, e);
    hWb(g, f);
    Rc(a.a, d, new TVb(g, b, c.f));
}
function ADc(a, b) {
    var c, d, e, f;
    for(d = a.d, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        sDc(a.g, c).a = b;
    }
}
function ECc(a, b, c) {
    var d, e, f;
    e = b[c];
    for(d = 0; d < e.length; d++){
        f = e[d];
        a.e[f.c.p][f.p] = d;
    }
}
function Mjc(a) {
    var b;
    for(b = 0; b < a.c.length; b++)(sDb(b, a.c.length), JD(a.c[b], 11)).p = b;
}
function Pjc(a) {
    var b, c;
    b = a.a.d.j;
    c = a.c.d.j;
    while(b != c){
        orb(a.b, b);
        b = Ujd(b);
    }
    orb(a.b, b);
}
function udd(a) {
    var b;
    b = $wnd.Math.sqrt(a.a * a.a + a.b * a.b);
    if (b > 0) {
        a.a /= b;
        a.b /= b;
    }
    return a;
}
function uKc(a, b, c) {
    var d, e;
    d = b;
    do {
        e = Beb(a.p[d.p]) + c;
        a.p[d.p] = e;
        d = a.a[d.p];
    }while (d != b);
}
function Zvb(a, b) {
    if (0 > a || a > b) throw scb(new odb('fromIndex: 0, toIndex: ' + a + kte + b));
}
function nDd(a, b) {
    if (a.g == null || b >= a.i) throw scb(new XId(b, a.i));
    return a.Ti(b, a.g[b]);
}
function nhd() {
    nhd = Zcb;
    khd = new ohd(Yte, 0);
    lhd = new ohd('HEAD', 1);
    mhd = new ohd('TAIL', 2);
}
function iHb() {
    iHb = Zcb;
    fHb = new jHb('BEGIN', 0);
    gHb = new jHb(Yte, 1);
    hHb = new jHb('END', 2);
}
function vHb() {
    vHb = Zcb;
    uHb = (iHb(), WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ])).length;
    tHb = uHb;
}
function VHb(a) {
    a.b = (PHb(), MHb);
    a.f = (GIb(), EIb);
    a.d = (bk(2, Dre), new Vlb(2));
    a.e = new Cdd;
}
function hmd(a) {
    this.b = (Qb(a), new Wlb(a));
    this.a = new Ulb;
    this.d = new Ulb;
    this.e = new Cdd;
}
function WSd(a) {
    var b;
    if (a.w) return a.w;
    else {
        b = XSd(a);
        !!b && !b.Rh() && (a.w = b);
        return b;
    }
}
function _5d(a) {
    var b;
    if (a == null) return null;
    else {
        b = JD(a, 195);
        return Wud(b, b.length);
    }
}
function KD(a) {
    var b;
    BDb(a == null || Array.isArray(a) && (b = PC(a), !(b >= 14 && b <= 16)));
    return a;
}
function LQb(a, b) {
    var c;
    c = Bdd(odd(JD(Nib(a.g, b), 8)), bdd(JD(Nib(a.f, b), 456).b));
    return c;
}
function $cb(a, b, c) {
    var d = function() {
        return a.apply(d, arguments);
    };
    b.apply(d, c);
    return d;
}
function Dhc(a, b) {
    jhc();
    return $eb(a.b.c.length - a.e.c.length, b.b.c.length - b.e.c.length);
}
function wo(a, b) {
    return Wv(Co(a, b, Pcb(Fcb(yre, hfb(Pcb(Fcb(b == null ? 0 : tb(b), zre)), 15)))));
}
function qEb(a, b) {
    return Ry(), Vy(Kre), $wnd.Math.abs(a - b) <= Kre || a == b || isNaN(a) && isNaN(b);
}
function Ty(a, b) {
    Ry();
    Vy(Kre);
    return $wnd.Math.abs(a - b) <= Kre || a == b || isNaN(a) && isNaN(b);
}
function unb(a, b) {
    pnb();
    var c, d;
    d = new Ulb;
    for(c = 0; c < a; ++c)YCb(d.c, b);
    return new Zpb(d);
}
function MBb(a) {
    LAb(a);
    yDb(true, 'n may not be negative');
    return new RBb(a, new CCb(a.a));
}
function EWc() {
    EWc = Zcb;
    DWc = B9c(B9c(B9c(G9c(new J9c, (_Pc(), $Pc)), (ZSc(), TSc)), OSc), SSc);
}
function UVc() {
    UVc = Zcb;
    TVc = B9c(B9c(B9c(G9c(new J9c, (_Pc(), YPc)), (ZSc(), YSc)), RSc), VSc);
}
function joc() {
    joc = Zcb;
    ioc = os((doc(), WC(OC(TV, 1), Ere, 281, 0, [
        $nc,
        Znc,
        aoc,
        _nc,
        coc,
        boc
    ])));
}
function Poc() {
    Poc = Zcb;
    Ooc = os((Koc(), WC(OC(WV, 1), Ere, 280, 0, [
        Ioc,
        Foc,
        Joc,
        Hoc,
        Goc,
        Eoc
    ])));
}
function Doc() {
    Doc = Zcb;
    Coc = os((yoc(), WC(OC(VV, 1), Ere, 279, 0, [
        voc,
        uoc,
        xoc,
        toc,
        woc,
        soc
    ])));
}
function Smc() {
    Smc = Zcb;
    Rmc = os((Nmc(), WC(OC(MV, 1), Ere, 231, 0, [
        Jmc,
        Lmc,
        Imc,
        Kmc,
        Mmc,
        Hmc
    ])));
}
function hed() {
    hed = Zcb;
    ged = os((ced(), WC(OC(d2, 1), Ere, 254, 0, [
        Ydd,
        _dd,
        aed,
        bed,
        Zdd,
        $dd
    ])));
}
function Med() {
    Med = Zcb;
    Led = os((Hed(), WC(OC(g2, 1), Ere, 296, 0, [
        Ged,
        Fed,
        Eed,
        Ced,
        Bed,
        Ded
    ])));
}
function Ohd() {
    Ohd = Zcb;
    Nhd = os((Jhd(), WC(OC(m2, 1), Ere, 322, 0, [
        Hhd,
        Fhd,
        Ihd,
        Dhd,
        Ghd,
        Ehd
    ])));
}
function hjd() {
    hjd = Zcb;
    gjd = os((ajd(), WC(OC(t2, 1), Ere, 100, 0, [
        _id,
        $id,
        Zid,
        Wid,
        Yid,
        Xid
    ])));
}
function vjd() {
    vjd = Zcb;
    ujd = os((ojd(), WC(OC(u2, 1), Ere, 277, 0, [
        mjd,
        kjd,
        ljd,
        jjd,
        ijd,
        njd
    ])));
}
function Iid() {
    Eid();
    return WC(OC(r2, 1), Ere, 94, 0, [
        wid,
        vid,
        yid,
        Did,
        Cid,
        Bid,
        zid,
        Aid,
        xid
    ]);
}
function okd() {
    okd = Zcb;
    lkd = new pkd(pCe, 0);
    mkd = new pkd('PARENT', 1);
    nkd = new pkd('ROOT', 2);
}
function uld(a, b) {
    a.n = b;
    if (a.n) {
        a.f = new Ulb;
        a.e = new Ulb;
    } else {
        a.f = null;
        a.e = null;
    }
    return a;
}
function etd(a, b) {
    var c;
    c = a.f;
    a.f = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 3, c, a.f));
}
function gtd(a, b) {
    var c;
    c = a.g;
    a.g = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 4, c, a.g));
}
function htd(a, b) {
    var c;
    c = a.i;
    a.i = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 5, c, a.i));
}
function itd(a, b) {
    var c;
    c = a.j;
    a.j = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 6, c, a.j));
}
function qud(a, b) {
    var c;
    c = a.j;
    a.j = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 1, c, a.j));
}
function Asd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 1, c, a.b));
}
function jud(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 3, c, a.b));
}
function kud(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 4, c, a.c));
}
function rud(a, b) {
    var c;
    c = a.k;
    a.k = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 2, c, a.k));
}
function zsd(a, b) {
    var c;
    c = a.a;
    a.a = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new e_d(a, 0, c, a.a));
}
function tRd(a, b) {
    var c;
    c = a.s;
    a.s = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new f_d(a, 4, c, a.s));
}
function wRd(a, b) {
    var c;
    c = a.t;
    a.t = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new f_d(a, 5, c, a.t));
}
function jZd(a, b) {
    var c;
    c = a.d;
    a.d = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new f_d(a, 2, c, a.d));
}
function USd(a, b) {
    var c;
    c = a.F;
    a.F = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 5, c, b));
}
function GZd(a, b) {
    var c, d;
    d = a.a;
    c = HZd(a, b, null);
    d != b && !a.e && (c = JZd(a, b, c));
    !!c && c.lj();
}
function eCd(a, b) {
    var c, d, e;
    c = (d = (Hpd(), e = new Lwd, e), !!b && Iwd(d, b), d);
    Jwd(c, a);
    return c;
}
function fzd(a, b, c) {
    var d;
    d = Yxd(c);
    Qib(a.c, d, b);
    Qib(a.d, b, c);
    Qib(a.e, b, Otd(b));
    return b;
}
function Zxd(a, b) {
    var c, d;
    c = b in a.a;
    if (c) {
        d = iC(a, b).pe();
        if (d) return d.a;
    }
    return null;
}
function web(a, b) {
    var c;
    if (!a) return;
    b.n = a;
    var d = qeb(b);
    if (!d) {
        Xcb[a] = [
            b
        ];
        return;
    }
    d.Om = b;
}
function EUd(a, b, c) {
    FCd(a, c);
    if (!a.hl() && c != null && !a.ck(c)) throw scb(new pdb);
    return c;
}
function ss(a, b) {
    var c;
    tDb(b);
    c = a[':' + b];
    lDb(!!c, 'Enum constant undefined: ' + b);
    return c;
}
function keb(a, b, c, d, e, f) {
    var g;
    g = ieb(a, b);
    web(c, g);
    g.i = e ? 8 : 0;
    g.f = d;
    g.e = e;
    g.g = f;
    return g;
}
function k_d(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 1;
    this.c = a;
    this.a = c;
}
function m_d(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 2;
    this.c = a;
    this.a = c;
}
function u_d(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 6;
    this.c = a;
    this.a = c;
}
function z_d(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 7;
    this.c = a;
    this.a = c;
}
function q_d(a, b, c, d, e) {
    this.d = b;
    this.j = d;
    this.e = e;
    this.o = -1;
    this.p = 4;
    this.c = a;
    this.a = c;
}
function hEb(a, b) {
    var c, d, e, f;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        dEb(a.a, c);
    }
    return a;
}
function yl(a) {
    var b, c, d, e;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        Qb(b);
    }
    return new El(a);
}
function hNb(a) {
    var b;
    b = Bdd(odd(a.d.d), a.c.d);
    Lcd(b, a.c.e.a, a.c.e.b);
    return mdd(b, a.c.d);
}
function iNb(a) {
    var b;
    b = Bdd(odd(a.c.d), a.d.d);
    Lcd(b, a.d.e.a, a.d.e.b);
    return mdd(b, a.d.d);
}
function aA(a) {
    var b = /function(?:\s+([\w$]+))?\s*\(/;
    var c = b.exec(a);
    return c && c[1] || Rre;
}
function fId(a, b) {
    var c;
    c = JD(Nib((iNd(), hNd), a), 58);
    return c ? c.dk(b) : SC(aJ, Nqe, 1, b, 5, 1);
}
function ymb(a, b, c) {
    var d, e;
    e = a.length;
    d = $wnd.Math.min(c, e);
    UCb(a, 0, b, 0, d, true);
    return b;
}
function sKc(a, b) {
    var c, d;
    c = a.c;
    d = b.e[a.p];
    if (d > 0) return JD(Mlb(c.a, d - 1), 9);
    return null;
}
function S4c(a, b) {
    a.b = $wnd.Math.max(a.b, b.d);
    a.e += b.r + (a.a.c.length == 0 ? 0 : a.c);
    Ilb(a.a, b);
}
function Alb(a) {
    xDb(a.c >= 0);
    if (ilb(a.d, a.c) < 0) {
        a.a = a.a - 1 & a.d.a.length - 1;
        a.b = a.d.c;
    }
    a.c = -1;
}
function Mdd(a, b) {
    var c, d, e, f;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        Dtb(a, c, a.c.b, a.c);
    }
}
function Tcb() {
    Ucb();
    var a = Scb;
    for(var b = 0; b < arguments.length; b++)a.push(arguments[b]);
}
function n2b(a, b) {
    b.Sg('Hierarchical port constraint processing', 1);
    o2b(a);
    q2b(a);
    b.Tg();
}
function wCd(a, b) {
    var c;
    c = a.gc();
    if (b < 0 || b > c) throw scb(new zHd(b, c));
    return new _Hd(a, b);
}
function awd(a, b, c) {
    rRd(a, b);
    rvd(a, c);
    tRd(a, 0);
    wRd(a, 1);
    vRd(a, true);
    uRd(a, true);
    return a;
}
function GJd(a, b) {
    var c;
    if (RD(b, 43)) return a.c.Kc(b);
    else {
        c = nJd(a, b);
        IJd(a, b);
        return c;
    }
}
function Vy(a) {
    if (!(a >= 0)) throw scb(new Teb('tolerance (' + a + ') must be >= 0'));
    return a;
}
function Nad() {
    if (!Fad) {
        Fad = new Mad;
        Lad(Fad, WC(OC(r1, 1), Nqe, 146, 0, [
            new Mgd
        ]));
    }
    return Fad;
}
function xzc() {
    xzc = Zcb;
    wzc = new yzc('NO', 0);
    uzc = new yzc(pwe, 1);
    vzc = new yzc('LOOK_BACK', 2);
}
function onc() {
    onc = Zcb;
    lnc = new pnc('ARD', 0);
    nnc = new pnc('MSD', 1);
    mnc = new pnc('MANUAL', 2);
}
function Eyc() {
    Eyc = Zcb;
    Dyc = new Fyc(eue, 0);
    Byc = new Fyc('INPUT', 1);
    Cyc = new Fyc('OUTPUT', 2);
}
function UEc() {
    UEc = Zcb;
    REc = new VEc('BARYCENTER', 0);
    SEc = new VEc(Yve, 1);
    TEc = new VEc(Zve, 2);
}
function ixc() {
    cxc();
    return WC(OC(fW, 1), Ere, 265, 0, [
        axc,
        Zwc,
        $wc,
        Wwc,
        Ywc,
        bxc,
        _wc,
        Vwc,
        Xwc
    ]);
}
function Qkd() {
    Nkd();
    return WC(OC(A2, 1), Ere, 264, 0, [
        Gkd,
        Ikd,
        Fkd,
        Jkd,
        Kkd,
        Mkd,
        Lkd,
        Hkd,
        Ekd
    ]);
}
function hp(a, b) {
    return Rv(Do(a.a, b, Pcb(Fcb(yre, hfb(Pcb(Fcb(b == null ? 0 : tb(b), zre)), 15)))));
}
function Xi(a) {
    var b, c, d, e;
    for(c = a.a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        Imb(b, b.length, null);
    }
}
function Nc(a) {
    var b, c;
    for(c = a.c.Bc().Jc(); c.Ob();){
        b = JD(c.Pb(), 16);
        b.$b();
    }
    a.c.$b();
    a.d = 0;
}
function PGb(a) {
    var b, c;
    for(c = new rmb(cpd(a)); c.a < c.c.c.length;){
        b = JD(pmb(c), 680);
        b.Zf();
    }
}
function Ot(a, b) {
    var c, d;
    for(c = 0, d = a.gc(); c < d; ++c){
        if (tub(b, a.Xb(c))) return c;
    }
    return -1;
}
function ffb(a) {
    var b, c;
    if (a == 0) return 32;
    else {
        c = 0;
        for(b = 1; (b & a) == 0; b <<= 1)++c;
        return c;
    }
}
function bk(a, b) {
    if (a < 0) throw scb(new Teb(b + ' cannot be negative but was: ' + a));
    return a;
}
function OQb(a) {
    JQb();
    this.g = new Irb;
    this.f = new Irb;
    this.b = new Irb;
    this.c = new Pp;
    this.i = a;
}
function nWb() {
    this.f = new Cdd;
    this.d = new OYb;
    this.c = new Cdd;
    this.a = new Ulb;
    this.b = new Ulb;
}
function Xee(a, b, c, d) {
    this.Zj();
    this.a = b;
    this.b = a;
    this.c = null;
    this.c = new Yee(this, b, c, d);
}
function kGd(a, b, c, d, e) {
    this.d = a;
    this.n = b;
    this.g = c;
    this.o = d;
    this.p = -1;
    e || (this.o = -2 - d - 1);
}
function aSd() {
    yRd.call(this);
    this.n = -1;
    this.g = null;
    this.i = null;
    this.j = null;
    this.Bb |= NEe;
}
function CCb(a) {
    lwb.call(this, a.yd(64) ? Bfb(0, Mcb(a.xd(), 1)) : mre, a.wd());
    this.b = 1;
    this.a = a;
}
function Ldc(a, b) {
    var c, d, e;
    e = b.c.i;
    c = JD(Nib(a.f, e), 60);
    d = c.d.c - c.e.c;
    Llb(b.b, new Rec(d));
}
function cnc() {
    cnc = Zcb;
    anc = new enc('LAYER_SWEEP', 0);
    _mc = new enc(owe, 1);
    bnc = new enc(yve, 2);
}
function qAc() {
    qAc = Zcb;
    pAc = E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
}
function BAc() {
    BAc = Zcb;
    AAc = E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
}
function VAc() {
    VAc = Zcb;
    UAc = E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
}
function oBc() {
    oBc = Zcb;
    nBc = E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
}
function wBc() {
    wBc = Zcb;
    vBc = E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
}
function UBc() {
    UBc = Zcb;
    TBc = E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
}
function _Dc() {
    _Dc = Zcb;
    $Dc = C9c(E9c(E9c(new J9c, (CQb(), zQb), (u5b(), b5b)), AQb, T4b), BQb, a5b);
}
function nfb() {
    nfb = Zcb;
    mfb = WC(OC(cE, 1), ise, 30, 15, [
        0,
        8,
        4,
        12,
        2,
        10,
        6,
        14,
        1,
        9,
        5,
        13,
        3,
        11,
        7,
        15
    ]);
}
function Bxd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 0, c, a.b));
}
function Cxd(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 1, c, a.c));
}
function iZd(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 4, c, a.c));
}
function Psd(a, b) {
    var c;
    c = a.k;
    a.k = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 2, c, a.k));
}
function cTd(a, b) {
    var c;
    c = a.D;
    a.D = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 2, c, a.D));
}
function mud(a, b) {
    var c;
    c = a.f;
    a.f = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 8, c, a.f));
}
function nud(a, b) {
    var c;
    c = a.i;
    a.i = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 7, c, a.i));
}
function Jwd(a, b) {
    var c;
    c = a.a;
    a.a = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 8, c, a.a));
}
function IQd(a, b) {
    var c;
    c = a.d;
    a.d = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 1, c, a.d));
}
function O1d(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 1, c, a.c));
}
function N1d(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 0, c, a.b));
}
function Xoe(a, b, c) {
    var d;
    a.b = b;
    a.a = c;
    d = (a.a & 512) == 512 ? new _me : new mme;
    a.c = gme(d, a.b, a.a);
}
function _be(a, b) {
    return Lfe(a.e, b) ? (Ife(), RRd(b) ? new Jge(b, a) : new Zfe(b, a)) : new Wge(b, a);
}
function $Vc(a, b) {
    UVc();
    return JD(WMb(b, (kVc(), ZUc)), 17).a < a.gc() && JD(WMb(b, ZUc), 17).a >= 0;
}
function xnb(a, b) {
    pnb();
    var c;
    c = new Jrb(1);
    VD(a) ? Rib(c, a, b) : gsb(c.f, a, b);
    return new kpb(c);
}
function hBb(a) {
    var b, c;
    if (0 > a) return new qBb;
    b = a + 1;
    c = new jBb(b, a);
    return new nBb(null, c);
}
function TOb() {
    TOb = Zcb;
    ROb = new KBd(eve);
    SOb = new KBd(fve);
    QOb = new KBd(gve);
    POb = new KBd(hve);
}
function AYc() {
    AYc = Zcb;
    yYc = new CYc('P1_NODE_PLACEMENT', 0);
    zYc = new CYc('P2_EDGE_ROUTING', 1);
}
function Ihc() {
    Ihc = Zcb;
    Hhc = new Jhc('START', 0);
    Ghc = new Jhc('MIDDLE', 1);
    Fhc = new Jhc('END', 2);
}
function l8c(a, b) {
    var c;
    c = new uMb;
    JD(b.b, 68);
    JD(b.b, 68);
    JD(b.b, 68);
    Llb(b.a, new r8c(a, c, b));
}
function FJd(a, b) {
    var c, d;
    for(d = b.vc().Jc(); d.Ob();){
        c = JD(d.Pb(), 43);
        EJd(a, c.jd(), c.kd());
    }
}
function lud(a, b) {
    var c;
    c = a.d;
    a.d = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 11, c, a.d));
}
function URd(a, b) {
    var c;
    c = a.j;
    a.j = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 13, c, a.j));
}
function w1d(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 21, c, a.b));
}
function qld(a, b) {
    if (a.r > 0 && a.c < a.r) {
        a.c += b;
        !!a.i && a.i.d > 0 && a.g != 0 && qld(a.i, b / a.r * a.i.d);
    }
}
function rdd(a, b) {
    var c;
    if (RD(b, 8)) {
        c = JD(b, 8);
        return a.a == c.a && a.b == c.b;
    } else return false;
}
function j_b(a) {
    var b;
    b = WMb(a, (Iqc(), kqc));
    if (RD(b, 173)) return i_b(JD(b, 173));
    return null;
}
function Sp(a) {
    var b;
    a = $wnd.Math.max(a, 2);
    b = dfb(a);
    if (a > b) {
        b <<= 1;
        return b > 0 ? b : Cre;
    }
    return b;
}
function kjb(a) {
    var b;
    qDb(a.f.g, a.d);
    rDb(a.b);
    a.c = a.a;
    b = JD(a.a.Pb(), 43);
    a.b = jjb(a);
    return b;
}
function i$d(a) {
    var b;
    if (a.b == null) return E$d(), E$d(), D$d;
    b = a.rl() ? a.ql() : a.pl();
    return b;
}
function bvb(a, b) {
    var c;
    c = b == null ? -1 : Nlb(a.b, b, 0);
    if (c < 0) return false;
    cvb(a, c);
    return true;
}
function orb(a, b) {
    var c;
    tDb(b);
    c = b.g;
    if (!a.b[c]) {
        VC(a.b, c, b);
        ++a.c;
        return true;
    }
    return false;
}
function Qxb(a, b) {
    var c, d;
    c = 1 - b;
    d = a.a[c];
    a.a[c] = d.a[b];
    d.a[b] = a;
    a.b = true;
    d.b = false;
    return d;
}
function cvb(a, b) {
    var c;
    c = Olb(a.b, a.b.c.length - 1);
    if (b < a.b.c.length) {
        Rlb(a.b, b, c);
        $ub(a, b);
    }
}
function Mzb(a, b) {
    ((Wzb(), Tzb) ? null : b.c).length == 0 && Yzb(b, new fAb);
    Rib(a.a, Tzb ? null : b.c, b);
}
function Nwc(a, b) {
    EBb(BBb(new RBb(null, new Gvb(new Ojb(a.b), 1)), new Omd(a, b)), new Smd(a, b));
}
function yFc(a, b, c) {
    XCc.call(this, a, b, c);
    this.a = new Irb;
    this.b = new Irb;
    this.d = new BFc(this);
}
function ccc(a) {
    eFb.call(this);
    this.b = Beb(MD(WMb(a, (Bwc(), Wvc))));
    this.a = JD(WMb(a, yuc), 220);
}
function ybc(a, b) {
    var c, d;
    c = JD(WMb(a, (Bwc(), Lvc)), 8);
    d = JD(WMb(b, Lvc), 8);
    return Heb(c.b, d.b);
}
function SOc(a, b) {
    var c, d;
    d = new Ulb;
    c = b;
    do {
        YCb(d.c, c);
        c = JD(Nib(a.k, c), 18);
    }while (c);
    return d;
}
function uGc(a, b, c) {
    var d;
    d = new Ulb;
    vGc(a, b, d, c, true, true);
    a.b = new cGc(d.c.length);
    return d;
}
function QKc(a, b) {
    var c;
    c = JD(Nib(a.c, b), 453);
    if (!c) {
        c = new XKc;
        c.c = b;
        Qib(a.c, c.c, c);
    }
    return c;
}
function gC(e, a) {
    var b = e.a;
    var c = 0;
    for(var d in b)b.hasOwnProperty(d) && (a[c++] = d);
    return a;
}
function xc(a) {
    Ub(a.e != 3);
    switch(a.e){
        case 2:
            return false;
        case 0:
            return true;
    }
    return zc(a);
}
function Xq(a, b) {
    var c;
    if (RD(b, 16)) {
        c = JD(b, 16);
        return a.Fc(c);
    }
    return tr(a, JD(Qb(b), 20).Jc());
}
function R4c(a) {
    var b, c;
    for(c = new CHd(a); c.e != c.i.gc();){
        b = JD(AHd(c), 27);
        htd(b, 0);
        itd(b, 0);
    }
}
function hub(a, b) {
    var c, d;
    c = a.Nc();
    Nmb(c, 0, c.length, b);
    for(d = 0; d < c.length; d++)a.fd(d, c[d]);
}
function clb(a, b, c) {
    var d, e, f;
    f = a.a.length - 1;
    for(e = a.b, d = 0; d < c; e = e + 1 & f, ++d)VC(b, d, a.a[e]);
}
function AEc(a) {
    var b, c;
    for(c = a.c.a.ec().Jc(); c.Ob();){
        b = JD(c.Pb(), 217);
        GDc(b, new QFc(b.f));
    }
}
function BEc(a) {
    var b, c;
    for(c = a.c.a.ec().Jc(); c.Ob();){
        b = JD(c.Pb(), 217);
        HDc(b, new RFc(b.e));
    }
}
function tb(a) {
    return VD(a) ? fgb(a) : TD(a) ? Eeb(a) : SD(a) ? Adb(a) : QD(a) ? a.Hb() : UC(a) ? jDb(a) : Az(a);
}
function r_b(a, b) {
    b.Sg(Xve, 1);
    EBb(DBb(new RBb(null, new Gvb(a.b, 16)), new v_b), new x_b);
    b.Tg();
}
function Mvd(a, b) {
    var c, d;
    c = (d = new HSd, d);
    c.n = b;
    tCd((!a.s && (a.s = new X0d(q6, a, 21, 17)), a.s), c);
}
function Svd(a, b) {
    var c, d;
    d = (c = new y1d, c);
    d.n = b;
    tCd((!a.s && (a.s = new X0d(q6, a, 21, 17)), a.s), d);
}
function rvd(a, b) {
    var c;
    c = a.zb;
    a.zb = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 1, c, a.zb));
}
function ewd(a, b) {
    var c;
    c = a.xb;
    a.xb = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 3, c, a.xb));
}
function fwd(a, b) {
    var c;
    c = a.yb;
    a.yb = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 2, c, a.yb));
}
function cGc(a) {
    this.b = a;
    this.a = SC(cE, ise, 30, a + 1, 15, 1);
    this.c = SC(cE, ise, 30, a, 15, 1);
    this.d = 0;
}
function xu(a) {
    this.e = a;
    this.d = new Rrb(Ov(Ec(this.e).gc()));
    this.c = this.e.a;
    this.b = this.e.c;
}
function c0c() {
    this.c = new WYc(0);
    this.b = new WYc(Aze);
    this.d = new WYc(yze);
    this.a = new WYc(zze);
}
function _1b() {
    _1b = Zcb;
    $1b = new a2b('TO_INTERNAL_LTR', 0);
    Z1b = new a2b('TO_INPUT_DIRECTION', 1);
}
function k6b() {
    k6b = Zcb;
    j6b = new LBd('edgelabelcenterednessanalysis.includelabel', (xdb(), vdb));
}
function ohb(a) {
    if (a.a < 54) return a.f < 0 ? -1 : a.f > 0 ? 1 : 0;
    return (!a.c && (a.c = fib(zcb(a.f))), a.c).e;
}
function _Sd(a, b) {
    if (b) {
        if (a.B == null) {
            a.B = a.D;
            a.D = null;
        }
    } else if (a.B != null) {
        a.D = a.B;
        a.B = null;
    }
}
function Wcb(a, b) {
    typeof window === Cqe && typeof window['$gwt'] === Cqe && (window['$gwt'][a] = b);
}
function BSb(a, b) {
    xSb();
    return a == tSb && b == wSb || a == wSb && b == tSb || a == vSb && b == uSb || a == uSb && b == vSb;
}
function CSb(a, b) {
    xSb();
    return a == tSb && b == uSb || a == tSb && b == vSb || a == wSb && b == vSb || a == wSb && b == uSb;
}
function KJb(a, b) {
    return Ry(), Vy(fue), $wnd.Math.abs(0 - b) <= fue || 0 == b || isNaN(0) && isNaN(b) ? 0 : a / b;
}
function amc(a, b) {
    return Beb(MD(zub(LBb(FBb(new RBb(null, new Gvb(a.c.b, 16)), new smc(a)), b))));
}
function dmc(a, b) {
    return Beb(MD(zub(LBb(FBb(new RBb(null, new Gvb(a.c.b, 16)), new qmc(a)), b))));
}
function bpc() {
    $oc();
    return WC(OC(XV, 1), Ere, 259, 0, [
        Roc,
        Toc,
        Uoc,
        Voc,
        Woc,
        Xoc,
        Zoc,
        Qoc,
        Soc,
        Yoc
    ]);
}
function gyc() {
    dyc();
    return WC(OC(jW, 1), Ere, 242, 0, [
        byc,
        Yxc,
        _xc,
        Zxc,
        $xc,
        Vxc,
        ayc,
        cyc,
        Wxc,
        Xxc
    ]);
}
function Xvd(a, b, c, d, e, f, g, h, i, j, k, l, m) {
    cwd(a, b, c, d, e, f, g, h, i, j, k, l, m);
    FSd(a, false);
    return a;
}
function myb(a, b, c, d, e, f) {
    var g;
    this.c = a;
    g = new Ulb;
    Gxb(a, g, b, a.b, c, d, e, f);
    this.a = new Ajb(g, 0);
}
function Zyd(a, b, c, d) {
    var e;
    e = new mC;
    Uxd(e, 'x', syd(a, b, d.a));
    Uxd(e, 'y', tyd(a, b, d.b));
    Sxd(c, e);
}
function azd(a, b, c, d) {
    var e;
    e = new mC;
    Uxd(e, 'x', syd(a, b, d.a));
    Uxd(e, 'y', tyd(a, b, d.b));
    Sxd(c, e);
}
function Odd(a, b, c) {
    var d, e;
    for(e = Gtb(a, 0); e.b != e.d.c;){
        d = JD(Utb(e), 8);
        d.a += b;
        d.b += c;
    }
    return a;
}
function Co(a, b, c) {
    var d;
    for(d = a.b[c & a.f]; d; d = d.b){
        if (c == d.a && Hb(b, d.g)) return d;
    }
    return null;
}
function Do(a, b, c) {
    var d;
    for(d = a.c[c & a.f]; d; d = d.d){
        if (c == d.f && Hb(b, d.i)) return d;
    }
    return null;
}
function Ox(a) {
    var b, c, d;
    b = 0;
    for(d = a.Jc(); d.Ob();){
        c = d.Pb();
        b += c != null ? tb(c) : 0;
        b = ~~b;
    }
    return b;
}
function xe(a, b) {
    var c, d, e;
    tDb(b);
    c = false;
    for(e = b.Jc(); e.Ob();){
        d = e.Pb();
        c = c | a.Ec(d);
    }
    return c;
}
function W_c(a, b) {
    var c, d;
    c = JD(ksd(a, (b_c(), S$c)), 17);
    d = JD(ksd(b, S$c), 17);
    return $eb(c.a, d.a);
}
function CZc(a, b) {
    var c;
    b.Sg('General Compactor', 1);
    c = k$c(JD(ksd(a, (b_c(), L$c)), 384));
    c.Ag(a);
}
function PVc(a, b, c) {
    c.Sg('DFS Treeifying phase', 1);
    OVc(a, b);
    MVc(a, b);
    a.a = null;
    a.b = null;
    c.Tg();
}
function vJb(a, b, c, d, e, f, g) {
    ms.call(this, a, b);
    this.d = c;
    this.e = d;
    this.c = e;
    this.b = f;
    this.a = _u(g);
}
function jib(a, b, c) {
    var d, e, f;
    d = 0;
    for(e = 0; e < c; e++){
        f = b[e];
        a[e] = f << 1 | d;
        d = f >>> 31;
    }
    d != 0 && (a[c] = d);
}
function $A(a) {
    var b;
    if (a == 0) return 'UTC';
    if (a < 0) {
        a = -a;
        b = 'UTC+';
    } else b = 'UTC-';
    return b + aB(a);
}
function RAb(a) {
    var b;
    b = QAb(a);
    if (ycb(b.a, 0)) return Hub(), Hub(), Gub;
    return Hub(), new Mub(b.b);
}
function SAb(a) {
    var b;
    b = QAb(a);
    if (ycb(b.a, 0)) return Hub(), Hub(), Gub;
    return Hub(), new Mub(b.c);
}
function mBb(a) {
    var b;
    b = lBb(a);
    if (ycb(b.a, 0)) return Rub(), Rub(), Qub;
    return Rub(), new Uub(b.b);
}
function RVb(a) {
    if (a.b.c.i.k == (DYb(), wYb)) return JD(WMb(a.b.c.i, (Iqc(), kqc)), 11);
    return a.b.c;
}
function SVb(a) {
    if (a.b.d.i.k == (DYb(), wYb)) return JD(WMb(a.b.d.i, (Iqc(), kqc)), 11);
    return a.b.d;
}
function A1b(a) {
    switch(a.g){
        case 2:
            return Rjd(), Qjd;
        case 4:
            return Rjd(), wjd;
        default:
            return a;
    }
}
function B1b(a) {
    switch(a.g){
        case 1:
            return Rjd(), Ojd;
        case 3:
            return Rjd(), xjd;
        default:
            return a;
    }
}
function _md(a, b) {
    var c;
    c = end(a);
    return $md(new Edd(c.c, c.d), new Edd(c.b, c.a), a.Kf(), b, a.$f());
}
function O3b(a, b) {
    b.Sg(Xve, 1);
    WGb(VGb(new $Gb((sWb(), new DWb(a, false, false, new jXb)))));
    b.Tg();
}
function VYb() {
    VYb = Zcb;
    SYb = new DZb;
    QYb = new IZb;
    RYb = new MZb;
    PYb = new QZb;
    TYb = new UZb;
    UYb = new YZb;
}
function GTd() {
    GTd = Zcb;
    DTd = new DYd;
    FTd = WC(OC(q6, 1), mFe, 178, 0, []);
    ETd = WC(OC(k6, 1), nFe, 62, 0, []);
}
function GFc() {
    GFc = Zcb;
    FFc = B9c(F9c(E9c(E9c(new J9c, (CQb(), zQb), (u5b(), b5b)), AQb, T4b), BQb), a5b);
}
function mEc() {
    mEc = Zcb;
    lEc = B9c(F9c(E9c(E9c(new J9c, (CQb(), zQb), (u5b(), b5b)), AQb, T4b), BQb), a5b);
}
function Cdb(a, b) {
    xdb();
    return VD(a) ? agb(a, OD(b)) : TD(a) ? Aeb(a, MD(b)) : SD(a) ? zdb(a, LD(b)) : a.Dd(b);
}
function Ld(a, b) {
    var c, d;
    tDb(b);
    for(d = b.vc().Jc(); d.Ob();){
        c = JD(d.Pb(), 43);
        a.yc(c.jd(), c.kd());
    }
}
function zbe(a, b, c) {
    var d;
    for(d = c.Jc(); d.Ob();){
        if (!xbe(a, b, d.Pb())) return false;
    }
    return true;
}
function vr(a, b) {
    var c;
    Qb(b);
    while(a.Ob()){
        c = a.Pb();
        if (!rMc(JD(c, 9))) return false;
    }
    return true;
}
function l2d(a, b, c, d, e) {
    var f;
    if (c) {
        f = WTd(b.zh(), a.c);
        e = c.Nh(b, -1 - (f == -1 ? d : f), null, e);
    }
    return e;
}
function m2d(a, b, c, d, e) {
    var f;
    if (c) {
        f = WTd(b.zh(), a.c);
        e = c.Ph(b, -1 - (f == -1 ? d : f), null, e);
    }
    return e;
}
function Lhb(a) {
    var b;
    if (a.b == -2) {
        if (a.e == 0) b = -1;
        else {
            for(b = 0; a.a[b] == 0; b++);
        }
        a.b = b;
    }
    return a.b;
}
function Yhb(a) {
    tDb(a);
    if (a.length == 0) throw scb(new Mfb('Zero length BigInteger'));
    dib(this, a);
}
function xDd(a) {
    this.i = a.gc();
    if (this.i > 0) {
        this.g = this.Zi(this.i + (this.i / 8 | 0) + 1);
        a.Oc(this.g);
    }
}
function Cfc(a, b, c) {
    this.g = a;
    this.d = b;
    this.e = c;
    this.a = new Ulb;
    Afc(this);
    pnb();
    Slb(this.a, null);
}
function Gkc(a, b, c) {
    this.b = new Irb;
    this.f = new Irb;
    this.c = (oxc(), nxc);
    this.d = a;
    this.c = b;
    this.a = c;
}
function Fkc(a, b, c, d) {
    Gkc.call(this, b, c, d);
    this.e = SC(RP, Jve, 9, a.a.c.length, 0, 1);
    Tlb(a.a, this.e);
}
function q4c(a, b) {
    b.q = a;
    a.d = $wnd.Math.max(a.d, b.r);
    a.b += b.d + (a.a.c.length == 0 ? 0 : a.c);
    Ilb(a.a, b);
}
function Mcd(a, b) {
    var c, d, e, f;
    e = a.c;
    c = a.c + a.b;
    f = a.d;
    d = a.d + a.a;
    return b.a > e && b.a < c && b.b > f && b.b < d;
}
function Pdd(a, b) {
    var c, d;
    for(d = Gtb(a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 8);
        c.a += b.a;
        c.b += b.b;
    }
    return a;
}
function l6b(a) {
    var b, c, d;
    d = 0;
    for(c = new rmb(a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        b.p = d;
        ++d;
    }
}
function qhc(a) {
    var b, c, d;
    return a.j == (Rjd(), xjd) && (b = shc(a), c = rrb(b, wjd), d = rrb(b, Qjd), d || d && c);
}
function pub(a, b) {
    var c, d;
    tDb(b);
    for(d = a.vc().Jc(); d.Ob();){
        c = JD(d.Pb(), 43);
        b.Wd(c.jd(), c.kd());
    }
}
function XQd(a, b) {
    var c;
    if (RD(b, 91)) {
        JD(a.c, 76).Dk();
        c = JD(b, 91);
        FJd(a, c);
    } else JD(a.c, 76).Wb(b);
}
function $vd(a, b, c, d) {
    RD(a.Cb, 184) && (JD(a.Cb, 184).tb = null);
    rvd(a, c);
    !!b && aTd(a, b);
    d && a.dl(true);
}
function J6b(a, b) {
    return b < a.b.gc() ? JD(a.b.Xb(b), 9) : b == a.b.gc() ? a.a : JD(Mlb(a.e, b - a.b.gc() - 1), 9);
}
function gdb(a, b, c, d) {
    var e;
    e = a.a.length;
    c > e ? c = e : ADb(b, c + 1);
    a.a = qgb(a.a, 0, b) + ('' + d) + pgb(a.a, c);
}
function Q_b(a, b) {
    var c;
    b.Sg('Edge and layer constraint edge reversal', 1);
    c = P_b(a);
    O_b(c);
    b.Tg();
}
function o6b(a, b) {
    var c, d;
    for(d = new rmb(b.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        a.a[c.p] = rXb(c);
    }
}
function mjb(a) {
    this.f = a;
    this.e = new Fsb(this.f.i);
    this.a = this.e;
    this.b = jjb(this);
    this.d = this.f.g;
}
function nce(a, b) {
    dbe.call(this, Aab, a, b);
    this.b = this;
    this.a = Kfe(a.zh(), QTd(this.e.zh(), this.c));
}
function rad(a, b) {
    var c;
    c = Had(Nad(), a);
    if (c) {
        msd(b, (Lgd(), igd), c);
        return true;
    } else return false;
}
function Yi(a, b, c) {
    var d, e;
    e = JD(Bn(a.d, b), 17);
    d = JD(Bn(a.b, c), 17);
    return !e || !d ? null : Si(a, e.a, d.a);
}
function D9c(a, b) {
    var c;
    for(c = 0; c < b.j.c.length; c++)JD(_8c(a, c), 22).Fc(JD(_8c(b, c), 16));
    return a;
}
function Pzb() {
    var a;
    if (!Lzb) {
        Lzb = new Ozb;
        a = new cAb('');
        aAb(a, (Gzb(), Fzb));
        Mzb(Lzb, a);
    }
    return Lzb;
}
function cKb(a) {
    aKb();
    if (a.A.Gc((ykd(), ukd))) {
        if (!a.B.Gc((Nkd(), Ikd))) return bKb(a);
    }
    return null;
}
function DNb() {
    this.a = JD(JBd((IOb(), kOb)), 17).a;
    this.c = Beb(MD(JBd(BOb)));
    this.b = Beb(MD(JBd(xOb)));
}
function IYb() {
    IYb = Zcb;
    HYb = os((DYb(), WC(OC(PP, 1), Ere, 247, 0, [
        AYb,
        yYb,
        wYb,
        BYb,
        xYb,
        vYb,
        CYb,
        zYb
    ])));
}
function Iic() {
    Iic = Zcb;
    Hic = os((Dic(), WC(OC(TU, 1), Ere, 272, 0, [
        wic,
        zic,
        vic,
        Cic,
        yic,
        xic,
        Bic,
        Aic
    ])));
}
function Ecd() {
    Ecd = Zcb;
    Dcd = os((zcd(), WC(OC(W1, 1), Ere, 282, 0, [
        ycd,
        rcd,
        vcd,
        xcd,
        scd,
        tcd,
        ucd,
        wcd
    ])));
}
function GBd() {
    GBd = Zcb;
    FBd = os((BBd(), WC(OC(L4, 1), Ere, 243, 0, [
        ABd,
        xBd,
        yBd,
        wBd,
        zBd,
        uBd,
        tBd,
        vBd
    ])));
}
function bTc() {
    ZSc();
    return WC(OC(i$, 1), Ere, 262, 0, [
        YSc,
        RSc,
        VSc,
        WSc,
        USc,
        QSc,
        XSc,
        OSc,
        TSc,
        SSc,
        PSc
    ]);
}
function uRc(a, b, c) {
    return Heb(qdd(mQc(a), new Edd(b.e.a, b.e.b)), qdd(mQc(a), new Edd(c.e.a, c.e.b)));
}
function ZDc(a, b, c) {
    return a == (UEc(), TEc) ? new SDc : yvb(b, 1) != 0 ? new LFc(c.length) : new sFc(c.length);
}
function Wpd(a, b) {
    var c, d, e;
    c = a.ph();
    if (c != null && a.sh()) for(d = 0, e = c.length; d < e; ++d)c[d].aj(b);
}
function xXb(a, b) {
    var c, d;
    c = a;
    d = gYb(c).e;
    while(d){
        c = d;
        if (c == b) return true;
        d = gYb(c).e;
    }
    return false;
}
function wcb(a) {
    var b;
    b = a.h;
    if (b == 0) return a.l + a.m * Cse;
    if (b == Ase) return a.l + a.m * Cse - Dse;
    return a;
}
function OBc(a, b, c) {
    var d, e;
    d = a.a.f[b.p];
    e = a.a.f[c.p];
    if (d < e) return -1;
    if (d == e) return 0;
    return 1;
}
function tgc(a, b) {
    var c, d;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 72);
        Ilb(a.d, c);
        xgc(a, c);
    }
}
function qJd(a) {
    var b;
    if (a.d == null) {
        ++a.e;
        a.f = 0;
        pJd(null);
    } else {
        ++a.e;
        b = a.d;
        a.d = null;
        a.f = 0;
        pJd(b);
    }
}
function Us(a) {
    var b;
    if (a.a == a.b.a) throw scb(new qub);
    b = a.a;
    a.c = b;
    a.a = JD(vub(a.a.e), 226);
    return b;
}
function NLc(a) {
    ILc();
    var b;
    if (!Jqb(HLc, a)) {
        b = new KLc;
        b.a = a;
        Mqb(HLc, a, b);
    }
    return JD(Kqb(HLc, a), 630);
}
function w_c() {
    w_c = Zcb;
    u_c = new y_c(yve, 0);
    v_c = new y_c('POLAR_COORDINATE', 1);
    t_c = new y_c('ID', 2);
}
function hpc() {
    hpc = Zcb;
    fpc = new ipc('ONE_SIDED', 0);
    gpc = new ipc('TWO_SIDED', 1);
    epc = new ipc('OFF', 2);
}
function YLb() {
    YLb = Zcb;
    WLb = new LBd('debugSVG', (xdb(), false));
    XLb = new LBd('overlapsExisted', true);
}
function Kid() {
    Kid = Zcb;
    Jid = os((Eid(), WC(OC(r2, 1), Ere, 94, 0, [
        wid,
        vid,
        yid,
        Did,
        Cid,
        Bid,
        zid,
        Aid,
        xid
    ])));
}
function p0c(a, b) {
    var c, d;
    for(d = new CHd(a); d.e != d.i.gc();){
        c = JD(AHd(d), 27);
        ftd(c, c.i + b.b, c.j + b.d);
    }
}
function Nvd(a, b) {
    var c, d;
    c = (d = new aUd, d);
    c.G = b;
    !a.rb && (a.rb = new c1d(a, a6, a));
    tCd(a.rb, c);
    return c;
}
function Ovd(a, b) {
    var c, d;
    c = (d = new FYd, d);
    c.G = b;
    !a.rb && (a.rb = new c1d(a, a6, a));
    tCd(a.rb, c);
    return c;
}
function _x(a) {
    var b, c, d;
    d = 0;
    for(c = new Drb(a.a); c.a < c.c.a.length;){
        b = Crb(c);
        a.b.Gc(b) && ++d;
    }
    return d;
}
function Xu(a) {
    var b, c, d;
    b = 1;
    for(d = a.Jc(); d.Ob();){
        c = d.Pb();
        b = 31 * b + (c == null ? 0 : tb(c));
        b = ~~b;
    }
    return b;
}
function $db(a) {
    var b;
    if (a < 128) return aeb(), b = _db[a], !b && (b = _db[a] = new Udb(a)), b;
    return new Udb(a);
}
function zcb(a) {
    if (Fse < a && a < Dse) return a < 0 ? $wnd.Math.ceil(a) : $wnd.Math.floor(a);
    return wcb(nD(a));
}
function _rb(a, b) {
    a.a = tcb(a.a, 1);
    a.c = $wnd.Math.min(a.c, b);
    a.b = $wnd.Math.max(a.b, b);
    a.d = tcb(a.d, b);
}
function Bsb(a, b) {
    var c;
    c = a.a.get(b);
    if (c === undefined) ++a.d;
    else {
        rsb(a.a, b);
        --a.c;
        ++a.b.g;
    }
    return c;
}
function Crd(a, b) {
    var c;
    if ((a.Db & b) != 0) {
        c = Brd(a, b);
        return c == -1 ? a.Eb : KD(a.Eb)[c];
    } else return null;
}
function F$d(a) {
    var b;
    if (a.g > 1 || a.Ob()) {
        ++a.a;
        a.g = 0;
        b = a.i;
        a.Ob();
        return b;
    } else throw scb(new qub);
}
function OAb(b, c) {
    var d;
    try {
        c.be();
    } catch (a) {
        a = rcb(a);
        if (RD(a, 80)) {
            d = a;
            YCb(b.c, d);
        } else throw scb(a);
    }
}
function UMb(a, b) {
    var c;
    if (!b) return a;
    c = b.lf();
    c.dc() || (!a.q ? a.q = new Krb(c) : Ld(a.q, c));
    return a;
}
function kVb(a, b) {
    var c, d, e;
    c = b.p - a.p;
    if (c == 0) {
        d = a.f.a * a.f.b;
        e = b.f.a * b.f.b;
        return Heb(d, e);
    }
    return c;
}
function Ncb(a) {
    var b, c, d, e;
    e = a;
    d = 0;
    if (e < 0) {
        e += Dse;
        d = Ase;
    }
    c = YD(e / Cse);
    b = YD(e - c * Cse);
    return _C(b, c, d);
}
function aWb(a) {
    if (a.b.c.length != 0 && !!JD(Mlb(a.b, 0), 72).a) return JD(Mlb(a.b, 0), 72).a;
    return _Vb(a);
}
function Lsd(a, b) {
    switch(b){
        case 1:
            return !!a.n && a.n.i != 0;
        case 2:
            return a.k != null;
    }
    return gsd(a, b);
}
function JLc(a) {
    switch(a.a.g){
        case 1:
            return new oMc;
        case 3:
            return new YOc;
        default:
            return new ZLc;
    }
}
function qDc(a, b) {
    if (a.c) {
        rDc(a, b, true);
        EBb(new RBb(null, new Gvb(b, 16)), new EDc(a));
    }
    rDc(a, b, false);
}
function xxb(a, b, c) {
    this.b = (tDb(a), a);
    this.d = (tDb(b), b);
    this.e = (tDb(c), c);
    this.c = this.d + ('' + this.e);
}
function ide(a, b) {
    this.b = a;
    this.e = b;
    this.d = b.j;
    this.f = (Ife(), JD(a, 69).uk());
    this.k = Kfe(b.e.zh(), a);
}
function XMc(a) {
    this.n = new Ulb;
    this.e = new Mtb;
    this.j = new Mtb;
    this.k = new Ulb;
    this.f = new Ulb;
    this.p = a;
}
function uPc(a) {
    a.r = new Qrb;
    a.w = new Qrb;
    a.t = new Ulb;
    a.i = new Ulb;
    a.d = new Qrb;
    a.a = new fdd;
    a.c = new Irb;
}
function xLb() {
    xLb = Zcb;
    wLb = new yLb('UP', 0);
    tLb = new yLb(lue, 1);
    uLb = new yLb(_te, 2);
    vLb = new yLb(aue, 3);
}
function Nyc() {
    Nyc = Zcb;
    Kyc = new Oyc('EQUALLY', 0);
    Lyc = new Oyc('NORTH', 1);
    Myc = new Oyc('NORTH_SOUTH', 2);
}
function kxc() {
    kxc = Zcb;
    jxc = os((cxc(), WC(OC(fW, 1), Ere, 265, 0, [
        axc,
        Zwc,
        $wc,
        Wwc,
        Ywc,
        bxc,
        _wc,
        Vwc,
        Xwc
    ])));
}
function Skd() {
    Skd = Zcb;
    Rkd = os((Nkd(), WC(OC(A2, 1), Ere, 264, 0, [
        Gkd,
        Ikd,
        Fkd,
        Jkd,
        Kkd,
        Mkd,
        Lkd,
        Hkd,
        Ekd
    ])));
}
function Dgc() {
    Dgc = Zcb;
    zgc = new Egc(Yte, 0);
    Agc = new Egc(_te, 1);
    Bgc = new Egc(aue, 2);
    Cgc = new Egc('TOP', 3);
}
function Gzc() {
    Gzc = Zcb;
    Ezc = new Hzc('OFF', 0);
    Fzc = new Hzc('SINGLE_EDGE', 1);
    Dzc = new Hzc('MULTI_EDGE', 2);
}
function gzc(a, b, c, d, e) {
    VC(a.c[b.g], c.g, d);
    VC(a.c[c.g], b.g, d);
    VC(a.b[b.g], c.g, e);
    VC(a.b[c.g], b.g, e);
}
function cYb(a, b, c) {
    var d, e, f, g;
    g = gYb(a);
    d = g.d;
    e = g.c;
    f = a.n;
    b && (f.a = f.a - d.b - e.a);
    c && (f.b = f.b - d.d - e.b);
}
function X8b(a, b) {
    var c, d;
    c = a.j;
    d = b.j;
    return c != d ? c.g - d.g : a.p == b.p ? 0 : c == (Rjd(), xjd) ? a.p - b.p : b.p - a.p;
}
function gjc(a) {
    var b, c;
    ejc(a);
    for(c = new rmb(a.d); c.a < c.c.c.length;){
        b = JD(pmb(c), 105);
        !!b.i && fjc(b);
    }
}
function rMc(a) {
    var b;
    b = JD(WMb(a, (Iqc(), Tpc)), 64);
    return a.k == (DYb(), wYb) && (b == (Rjd(), Qjd) || b == wjd);
}
function tVb(a, b, c) {
    var d, e;
    e = JD(WMb(a, (Bwc(), Ruc)), 77);
    if (e) {
        d = new Rdd;
        Ndd(d, 0, e);
        Pdd(d, c);
        xe(b, d);
    }
}
function pzd(a, b, c) {
    var d, e, f, g;
    f = null;
    g = b;
    e = $xd(g, jDe);
    d = new Bzd(a, c);
    f = (zyd(d.a, d.b, e), e);
    return f;
}
function Ivd(a, b) {
    var c, d;
    d = (c = new u5d, c);
    rvd(d, b);
    tCd((!a.A && (a.A = new Dde(r6, a, 7)), a.A), d);
    return d;
}
function Ksd(a, b, c, d) {
    if (c == 1) return !a.n && (a.n = new X0d(z3, a, 1, 7)), QGd(a.n, b, d);
    return fsd(a, b, c, d);
}
function e8c(a, b, c, d) {
    JD(c.b, 68);
    JD(c.b, 68);
    JD(d.b, 68);
    JD(d.b, 68);
    JD(d.b, 68);
    Llb(d.a, new j8c(a, b, d));
}
function MEb(a, b) {
    a.d == (Tgd(), Pgd) || a.d == Sgd ? JD(b.a, 60).c.Ec(JD(b.b, 60)) : JD(b.b, 60).c.Ec(JD(b.a, 60));
}
function Ae(a, b) {
    var c, d;
    tDb(b);
    for(d = b.Jc(); d.Ob();){
        c = d.Pb();
        if (!a.Gc(c)) return false;
    }
    return true;
}
function kD(a, b) {
    var c, d, e;
    c = a.l + b.l;
    d = a.m + b.m + (c >> 22);
    e = a.h + b.h + (d >> 22);
    return _C(c & zse, d & zse, e & Ase);
}
function vD(a, b) {
    var c, d, e;
    c = a.l - b.l;
    d = a.m - b.m + (c >> 22);
    e = a.h - b.h + (d >> 22);
    return _C(c & zse, d & zse, e & Ase);
}
function br(a) {
    var b;
    if (a) {
        b = a;
        if (b.dc()) throw scb(new qub);
        return b.Xb(b.gc() - 1);
    }
    return Br(a.Jc());
}
function DSd(a) {
    var b;
    if (!a.a || (a.Bb & 1) == 0 && a.a.Rh()) {
        b = pRd(a);
        RD(b, 155) && (a.a = JD(b, 155));
    }
    return a.a;
}
function rcb(a) {
    var b;
    if (RD(a, 80)) return a;
    b = a && a.__java$exception;
    if (!b) {
        b = new uz(a);
        $z(b);
    }
    return b;
}
function aCd(a) {
    if (RD(a, 193)) return JD(a, 124);
    else if (!a) throw scb(new Ffb(IDe));
    else return null;
}
function S3c(a) {
    switch(a.g){
        case 0:
            return new H3c;
        case 1:
            return new M3c;
        case 2:
        default:
            return null;
    }
}
function z7b(a) {
    switch(JD(WMb(a, (Bwc(), Uuc)), 171).g){
        case 2:
        case 4:
            return true;
        default:
            return false;
    }
}
function blb(a, b) {
    if (b == null) return false;
    while(a.a != a.b){
        if (pb(b, zlb(a))) return true;
    }
    return false;
}
function jjb(a) {
    if (a.a.Ob()) return true;
    if (a.a != a.e) return false;
    a.a = new lsb(a.f.f);
    return a.a.Ob();
}
function Klb(a, b) {
    var c, d;
    c = b.Nc();
    d = c.length;
    if (d == 0) return false;
    XCb(a.c, a.c.length, c);
    return true;
}
function rKc(a, b) {
    var c, d;
    c = a.c;
    d = b.e[a.p];
    if (d < c.a.c.length - 1) return JD(Mlb(c.a, d + 1), 9);
    return null;
}
function a7b(a, b) {
    var c, d;
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 72);
        ZMb(c, (Iqc(), cqc), b);
    }
}
function _3c(a, b, c) {
    var d, e;
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 27);
        ftd(d, d.i + b, d.j + c);
    }
}
function bRc(a) {
    var b, c, d;
    b = new Mtb;
    for(d = Gtb(a.d, 0); d.b != d.d.c;){
        c = JD(Utb(d), 65);
        Atb(b, c.c);
    }
    return b;
}
function BCd(a) {
    var b, c, d, e;
    b = 1;
    for(c = 0, e = a.gc(); c < e; ++c){
        d = a.Si(c);
        b = 31 * b + (d == null ? 0 : tb(d));
    }
    return b;
}
function Jvd(a) {
    var b, c;
    c = (b = new u5d, b);
    rvd(c, 'T');
    tCd((!a.d && (a.d = new Dde(r6, a, 11)), a.d), c);
    return c;
}
function h9c(a, b) {
    var c;
    c = av(b.a.gc());
    EBb(OBb(new RBb(null, new Gvb(b, 1)), a.i), new u9c(a, c));
    return c;
}
function aj(a, b, c, d) {
    var e;
    Pb(b, a.e.Pd().gc());
    Pb(c, a.c.Pd().gc());
    e = a.a[b][c];
    VC(a.a[b], c, d);
    return e;
}
function WC(a, b, c, d, e) {
    e.Om = a;
    e.Pm = b;
    e.Qm = bdb;
    e.__elementTypeId$ = c;
    e.__elementTypeCategory$ = d;
    return e;
}
function Ocd(a, b, c, d, e) {
    Icd();
    return $wnd.Math.min(Ycd(a, b, c, d, e), Ycd(c, d, a, b, tdd(new Edd(e.a, e.b))));
}
function cFb(a, b) {
    if (!a || !b || a == b) return false;
    return sEb(a.d.c, b.d.c + b.d.b) && sEb(b.d.c, a.d.c + a.d.b);
}
function dAb() {
    Wzb();
    if (Tzb) return new cAb(null);
    return Nzb(Pzb(), 'com.google.common.base.Strings');
}
function Nb(a, b) {
    if (!a) throw scb(new Teb(hc('value already present: %s', WC(OC(aJ, 1), Nqe, 1, 5, [
        b
    ]))));
}
function Q7c(a, b, c) {
    var d;
    Tib(a.a);
    Llb(c.i, new _7c(a));
    d = new ZDb(JD(Nib(a.a, b.b), 68));
    P7c(a, d, b);
    c.f = d;
}
function p9b(a) {
    var b;
    fWb(a, true);
    b = Vre;
    XMb(a, (Bwc(), Nvc)) && (b += JD(WMb(a, Nvc), 17).a);
    ZMb(a, Nvc, jfb(b));
}
function QYc(a) {
    var b, c, d, e;
    e = new Ulb;
    for(d = a.Jc(); d.Ob();){
        c = JD(d.Pb(), 27);
        b = TYc(c);
        Klb(e, b);
    }
    return e;
}
function SNd(a, b) {
    var c, d;
    d = 0;
    if (a < 64 && a <= b) {
        b = b < 64 ? b : 63;
        for(c = a; c <= b; c++)d = Icb(d, Jcb(1, c));
    }
    return d;
}
function Fr(a, b) {
    var c, d;
    Rb(b, 'predicate');
    for(d = 0; a.Ob(); d++){
        c = a.Pb();
        if (b.Lb(c)) return d;
    }
    return -1;
}
function isd(a, b) {
    switch(b){
        case 0:
            !a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0));
            a.o.c.$b();
            return;
    }
    Eqd(a, b);
}
function pid(a) {
    switch(a.g){
        case 1:
            return lid;
        case 2:
            return kid;
        case 3:
            return mid;
        default:
            return nid;
    }
}
function dCd(a) {
    var b, c;
    c = (Hpd(), b = new tud, b);
    !!a && tCd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), c);
    return c;
}
function _A(a) {
    var b;
    b = new XA;
    b.a = a;
    b.b = ZA(a);
    b.c = SC(hJ, hre, 2, 2, 6, 1);
    b.c[0] = $A(a);
    b.c[1] = $A(a);
    return b;
}
function snb(a) {
    pnb();
    var b, c, d;
    d = 0;
    for(c = a.Jc(); c.Ob();){
        b = c.Pb();
        d = d + (b != null ? tb(b) : 0);
        d = d | 0;
    }
    return d;
}
function j1b(a) {
    var b, c, d;
    c = a.n;
    d = a.o;
    b = a.d;
    return new gdd(c.a - b.b, c.b - b.d, d.a + (b.b + b.c), d.b + (b.d + b.a));
}
function cMb(a, b) {
    if (!a || !b || a == b) return false;
    return Sy(a.b.c, b.b.c + b.b.b) < 0 && Sy(b.b.c, a.b.c + a.b.b) < 0;
}
function _Eb(a, b, c) {
    switch(c.g){
        case 2:
            a.b = b;
            break;
        case 1:
            a.c = b;
            break;
        case 4:
            a.d = b;
            break;
        case 3:
            a.a = b;
    }
}
function nj(a, b) {
    this.c = a;
    this.d = b;
    this.b = this.d / this.c.c.Pd().gc() | 0;
    this.a = this.d % this.c.c.Pd().gc();
}
function Vib(a, b) {
    lDb(a >= 0, 'Negative initial capacity');
    lDb(b >= 0, 'Non-positive load factor');
    Tib(this);
}
function a5c(a, b) {
    var c, d;
    c = JD(JD(Nib(a.g, b.a), 47).a, 68);
    d = JD(JD(Nib(a.g, b.b), 47).a, 68);
    return aMb(c, d);
}
function Jcd(a) {
    Icd();
    var b, c, d;
    c = SC(b2, hre, 8, 2, 0, 1);
    d = 0;
    for(b = 0; b < 2; b++){
        d += 0.5;
        c[b] = Qcd(d, a);
    }
    return c;
}
function uCd(a, b, c) {
    var d;
    d = a.gc();
    if (b > d) throw scb(new zHd(b, d));
    a.Pi() && (c = ACd(a, c));
    return a.Bi(b, c);
}
function UNd(a, b, c) {
    if (a >= 128) return false;
    return a < 64 ? Hcb(ucb(Jcb(1, a), c), 0) : Hcb(ucb(Jcb(1, a - 64), b), 0);
}
function zqe(a, b) {
    while(a.g == null && !a.c ? RDd(a) : a.g == null || a.i != 0 && JD(a.g[a.i - 1], 49).Ob())b.Ai(SDd(a));
}
function geb() {
    ++beb;
    this.o = null;
    this.k = null;
    this.j = null;
    this.d = null;
    this.b = null;
    this.n = null;
    this.a = null;
}
function xSb() {
    xSb = Zcb;
    tSb = new ASb('Q1', 0);
    wSb = new ASb('Q4', 1);
    uSb = new ASb('Q2', 2);
    vSb = new ASb('Q3', 3);
}
function I7b() {
    I7b = Zcb;
    H7b = new K7b(yve, 0);
    F7b = new K7b(bwe, 1);
    G7b = new K7b(cwe, 2);
    E7b = new K7b('BOTH', 3);
}
function Tnc() {
    Tnc = Zcb;
    Rnc = new Unc(yve, 0);
    Qnc = new Unc('INCOMING_ONLY', 1);
    Snc = new Unc('OUTGOING_ONLY', 2);
}
function A7c() {
    A7c = Zcb;
    z7c = new C7c('MINIMUM_SPANNING_TREE', 0);
    y7c = new C7c('MAXIMUM_SPANNING_TREE', 1);
}
function w8c() {
    w8c = Zcb;
    new KBd('org.eclipse.elk.addLayoutConfig');
    u8c = new K8c;
    t8c = new F8c;
    v8c = new I8c;
}
function dpc() {
    dpc = Zcb;
    cpc = os(($oc(), WC(OC(XV, 1), Ere, 259, 0, [
        Roc,
        Toc,
        Uoc,
        Voc,
        Woc,
        Xoc,
        Zoc,
        Qoc,
        Soc,
        Yoc
    ])));
}
function iyc() {
    iyc = Zcb;
    hyc = os((dyc(), WC(OC(jW, 1), Ere, 242, 0, [
        byc,
        Yxc,
        _xc,
        Zxc,
        $xc,
        Vxc,
        ayc,
        cyc,
        Wxc,
        Xxc
    ])));
}
function zC() {
    zC = Zcb;
    yC = {
        'boolean': AC,
        'number': BC,
        'string': DC,
        'object': CC,
        'function': CC,
        'undefined': EC
    };
}
function bgc(a) {
    var b, c, d, e;
    for(c = a.a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        ggc(a, b, (Rjd(), Ojd));
        ggc(a, b, xjd);
    }
}
function Pfc(a, b) {
    var c, d, e, f;
    c = false;
    d = a.a[b].length;
    for(f = 0; f < d - 1; f++){
        e = f + 1;
        c = c | Qfc(a, b, f, e);
    }
    return c;
}
function t1d(a) {
    var b;
    if (!a.c || (a.Bb & 1) == 0 && (a.c.Db & 64) != 0) {
        b = pRd(a);
        RD(b, 88) && (a.c = JD(b, 29));
    }
    return a.c;
}
function dfb(a) {
    var b;
    if (a < 0) return Lre;
    else if (a == 0) return 0;
    else {
        for(b = Cre; (b & a) == 0; b >>= 1);
        return b;
    }
}
function ZA(a) {
    var b;
    if (a == 0) return 'Etc/GMT';
    if (a < 0) {
        a = -a;
        b = 'Etc/GMT-';
    } else b = 'Etc/GMT+';
    return b + aB(a);
}
function pD(a) {
    var b, c, d;
    b = ~a.l + 1 & zse;
    c = ~a.m + (b == 0 ? 1 : 0) & zse;
    d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & Ase;
    return _C(b, c, d);
}
function fD(a) {
    var b, c, d;
    b = ~a.l + 1 & zse;
    c = ~a.m + (b == 0 ? 1 : 0) & zse;
    d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & Ase;
    a.l = b;
    a.m = c;
    a.h = d;
}
function fCc(a) {
    var b, c;
    b = a.t - a.k[a.o.p] * a.d + a.j[a.o.p] > a.f;
    c = a.u + a.e[a.o.p] * a.d > a.f * a.s * a.d;
    return b || c;
}
function flb(a) {
    var b;
    b = a.a[a.b];
    if (b == null) return null;
    VC(a.a, a.b, null);
    a.b = a.b + 1 & a.a.length - 1;
    return b;
}
function JMb(a) {
    var b, c;
    c = new qNb;
    UMb(c, a);
    ZMb(c, (TOb(), ROb), a);
    b = new Irb;
    LMb(a, c, b);
    KMb(a, c, b);
    return c;
}
function ZMb(a, b, c) {
    c == null ? (!a.q && (a.q = new Irb), Sib(a.q, b)) : (!a.q && (a.q = new Irb), Qib(a.q, b, c));
    return a;
}
function YMb(a, b, c) {
    return c == null ? (!a.q && (a.q = new Irb), Sib(a.q, b)) : (!a.q && (a.q = new Irb), Qib(a.q, b, c)), a;
}
function pQc(a, b) {
    return qdd(mQc(JD(WMb(b, (kVc(), KUc)), 86)), new Edd(a.c.e.a - a.b.e.a, a.c.e.b - a.b.e.b)) <= 0;
}
function Kxb(a, b, c) {
    var d, e;
    d = new tyb(b, c);
    e = new uyb;
    a.b = Ixb(a, a.b, d, e);
    e.b || ++a.c;
    a.b.b = false;
    return e.d;
}
function gD(a) {
    var b, c;
    c = efb(a.h);
    if (c == 32) {
        b = efb(a.m);
        return b == 32 ? efb(a.l) + 32 : b + 20 - 10;
    } else return c - 12;
}
function JRb(a) {
    var b, c;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        b.g.c = -b.g.c - b.g.b;
    }
    ERb(a);
}
function NEb(a) {
    var b, c;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        b.d.c = -b.d.c - b.d.b;
    }
    HEb(a);
}
function lrb(a) {
    var b, c, d;
    b = JD(a.e && a.e(), 10);
    d = (c = b.slice(), JD(XC(c, b), 10));
    return new urb(b, d, b.length);
}
function ggc(a, b, c) {
    var d, e, f, g;
    g = dGc(b, c);
    f = 0;
    for(e = g.Jc(); e.Ob();){
        d = JD(e.Pb(), 11);
        Qib(a.c, d, jfb(f++));
    }
}
function qnb(a, b) {
    pnb();
    var c, d, e, f, g;
    g = false;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        g = g | a.Ec(c);
    }
    return g;
}
function Kdd(a) {
    var b, c, d, e, f;
    b = new Cdd;
    for(d = a, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        b.a += c.a;
        b.b += c.b;
    }
    return b;
}
function uzd(a, b, c) {
    var d, e, f, g;
    f = null;
    g = b;
    e = $xd(g, 'labels');
    d = new rAd(a, c);
    f = (Ryd(d.a, d.b, e), e);
    return f;
}
function tGc(a, b, c) {
    var d;
    d = new Ulb;
    vGc(a, b, d, (Rjd(), wjd), true, false);
    vGc(a, c, d, Qjd, false, false);
    return d;
}
function fae(a, b, c, d) {
    var e;
    e = lae(a, b, c, d);
    if (!e) {
        e = eae(a, c, d);
        if (!!e && !Z9d(a, b, e)) return null;
    }
    return e;
}
function cae(a, b, c, d) {
    var e;
    e = kae(a, b, c, d);
    if (!e) {
        e = bae(a, c, d);
        if (!!e && !Z9d(a, b, e)) return null;
    }
    return e;
}
function Xb(a, b) {
    var c;
    for(c = 0; c < a.a.a.length; c++){
        if (!JD(bnb(a.a, c), 177).Lb(b)) return false;
    }
    return true;
}
function Cb(a, b, c) {
    Qb(b);
    if (c.Ob()) {
        Mgb(b, Fb(c.Pb()));
        while(c.Ob()){
            Mgb(b, a.a);
            Mgb(b, Fb(c.Pb()));
        }
    }
    return b;
}
function cD(a, b, c, d, e) {
    var f;
    f = tD(a, b);
    c && fD(f);
    if (e) {
        a = eD(a, b);
        d ? YC = pD(a) : YC = _C(a.l, a.m, a.h);
    }
    return f;
}
function tnb(a) {
    pnb();
    var b, c, d;
    d = 1;
    for(c = a.Jc(); c.Ob();){
        b = c.Pb();
        d = 31 * d + (b != null ? tb(b) : 0);
        d = d | 0;
    }
    return d;
}
function CBb(a) {
    var b;
    KAb(a);
    b = new HCb;
    if (a.a.zd(b)) return yub(), new Cub(tDb(b.a));
    return yub(), yub(), xub;
}
function CRb(a) {
    var b, c;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        b.f.$b();
    }
    XRb(a.b, a);
    DRb(a);
}
function RMb(a, b) {
    switch(b.g){
        case 0:
            RD(a.b, 626) || (a.b = new DNb);
            break;
        case 1:
            RD(a.b, 627) || (a.b = new JNb);
    }
}
function ztd(a, b) {
    switch(b){
        case 7:
            return !!a.e && a.e.i != 0;
        case 8:
            return !!a.d && a.d.i != 0;
    }
    return atd(a, b);
}
function nfc(a, b, c) {
    a.g = tfc(a, b, (Rjd(), wjd), a.b);
    a.d = tfc(a, c, wjd, a.b);
    if (a.g.c == 0 || a.d.c == 0) return;
    qfc(a);
}
function ofc(a, b, c) {
    a.g = tfc(a, b, (Rjd(), Qjd), a.j);
    a.d = tfc(a, c, Qjd, a.j);
    if (a.g.c == 0 || a.d.c == 0) return;
    qfc(a);
}
function Owc(a, b, c) {
    return !PBb(BBb(new RBb(null, new Gvb(a.c, 16)), new Dzb(new Qmd(b, c)))).zd((wBb(), vBb));
}
function G9b() {
    G9b = Zcb;
    E9b = new R9b;
    F9b = new T9b;
    D9b = new V9b;
    C9b = new Z9b;
    B9b = new bac;
    A9b = (tDb(B9b), new cqb);
}
function eRc(a, b, c) {
    this.g = a;
    this.e = new Cdd;
    this.f = new Cdd;
    this.d = new Mtb;
    this.b = new Mtb;
    this.a = b;
    this.c = c;
}
function j4c(a, b, c, d) {
    this.b = new Ulb;
    this.n = new Ulb;
    this.i = d;
    this.j = c;
    this.s = a;
    this.t = b;
    this.r = 0;
    this.d = 0;
}
function nB(a, b, c) {
    this.q = new $wnd.Date;
    this.q.setFullYear(a + hse, b, c);
    this.q.setHours(0, 0, 0, 0);
    eB(this, 0);
}
function kWd(a, b) {
    this.b = a;
    gWd.call(this, (JD(nDd(STd((GOd(), FOd).o), 10), 19), b.i), b.g);
    this.a = (GTd(), FTd);
}
function hsd(a, b, c) {
    switch(b){
        case 0:
            !a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0));
            XQd(a.o, c);
            return;
    }
    Aqd(a, b, c);
}
function J5c(a) {
    switch(a.g){
        case 0:
            return new o8c;
        default:
            throw scb(new Teb(bBe + (a.f != null ? a.f : '' + a.g)));
    }
}
function q7c(a) {
    switch(a.g){
        case 0:
            return new K7c;
        default:
            throw scb(new Teb(bBe + (a.f != null ? a.f : '' + a.g)));
    }
}
function Aoe() {
    ooe();
    var a;
    if (Xne) return Xne;
    a = soe(Coe('M', true));
    a = toe(Coe('M', false), a);
    Xne = a;
    return Xne;
}
function vA(a) {
    var b;
    if (a.b <= 0) return false;
    b = hgb('MLydhHmsSDkK', wgb(_fb(a.c, 0)));
    return b > 1 || b >= 0 && a.b < 3;
}
function $zb(a) {
    if (Tzb) return SC(AL, rte, 563, 0, 0, 1);
    return JD(Tlb(a.a, SC(AL, rte, 563, a.a.c.length, 0, 1)), 835);
}
function G_b(a) {
    var b, c;
    b = JD(WMb(a, (Iqc(), sqc)), 9);
    if (b) {
        c = b.c;
        Plb(c.a, b);
        c.a.c.length == 0 && Plb(gYb(b).b, c);
    }
}
function fgb(a) {
    var b, c;
    b = 0;
    for(c = 0; c < a.length; c++)b = (b << 5) - b + (ADb(c, a.length), a.charCodeAt(c)) | 0;
    return b;
}
function Vdd(a) {
    var b, c, d;
    b = new Rdd;
    for(d = Gtb(a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 8);
        du(b, 0, new Fdd(c));
    }
    return b;
}
function Axb(a, b) {
    var c, d, e;
    e = a.b;
    while(e){
        c = a.a.Le(b, e.d);
        if (c == 0) return e;
        d = c < 0 ? 0 : 1;
        e = e.a[d];
    }
    return null;
}
function Lad(a, b) {
    var c, d, e, f, g;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        g = new Vad(a);
        c.tf(g);
        Qad(g);
    }
    Tib(a.f);
}
function _gb(a, b, c, d, e) {
    var f, g;
    g = a.length;
    f = c.length;
    if (b < 0 || d < 0 || e < 0 || b + e > g || d + e > f) throw scb(new ldb);
}
function t0c(a, b) {
    var c, d;
    c = JD(ksd(a, (k2c(), O1c)), 17).a;
    d = JD(ksd(b, O1c), 17).a;
    return c == d ? -1 : c < d ? -1 : c > d ? 1 : 0;
}
function Lwc(a) {
    Ilb(a.c, (w8c(), u8c));
    if (Ty(a.a, Beb(MD(JBd((Twc(), Rwc)))))) return new Kmd;
    return new Mmd(a);
}
function bs(a) {
    while(!a.d || !a.d.Ob()){
        if (!!a.b && !elb(a.b)) a.d = JD(jlb(a.b), 49);
        else return null;
    }
    return a.d;
}
function EPc(a) {
    switch(a.g){
        case 1:
            return yze;
        default:
        case 2:
            return 0;
        case 3:
            return zze;
        case 4:
            return Aze;
    }
}
function $Ub(a, b) {
    if (_Ub(a, b)) {
        Rc(a.b, JD(WMb(b, (Iqc(), Qpc)), 22), b);
        Atb(a.a, b);
        return true;
    } else return false;
}
function tw(a, b) {
    var c;
    if (b === a) return true;
    if (RD(b, 228)) {
        c = JD(b, 228);
        return pb(a.Zb(), c.Zb());
    }
    return false;
}
function q8b(a, b) {
    if (XMb(a, (Iqc(), jqc)) && XMb(b, jqc)) return JD(WMb(b, jqc), 17).a - JD(WMb(a, jqc), 17).a;
    return 0;
}
function v8b(a, b) {
    if (XMb(a, (Iqc(), jqc)) && XMb(b, jqc)) return JD(WMb(a, jqc), 17).a - JD(WMb(b, jqc), 17).a;
    return 0;
}
function FCd(a, b) {
    if (!a.Ii() && b == null) throw scb(new Teb("The 'no null' constraint is violated"));
    return b;
}
function Fvd(a, b, c) {
    var d, e;
    e = (d = new L_d, d);
    awd(e, b, c);
    tCd((!a.q && (a.q = new X0d(k6, a, 11, 10)), a.q), e);
    return e;
}
function _ud(a) {
    var b, c, d, e;
    e = ddb(Tud, a);
    c = e.length;
    d = SC(hJ, hre, 2, c, 6, 1);
    for(b = 0; b < c; ++b)d[b] = e[b];
    return d;
}
function et(a, b, c) {
    var d, e;
    this.g = a;
    this.c = b;
    this.a = this;
    this.d = this;
    e = Sp(c);
    d = SC(MG, Are, 226, e, 0, 1);
    this.b = d;
}
function vib(a, b, c) {
    var d;
    for(d = c - 1; d >= 0 && a[d] === b[d]; d--);
    return d < 0 ? 0 : Dcb(ucb(a[d], Use), ucb(b[d], Use)) ? -1 : 1;
}
function Zub(a, b) {
    var c;
    if (b * 2 + 1 >= a.b.c.length) return;
    Zub(a, 2 * b + 1);
    c = 2 * b + 2;
    c < a.b.c.length && Zub(a, c);
    $ub(a, b);
}
function vEc(a, b) {
    var c, d;
    for(d = Gtb(a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 217);
        if (c.e.length > 0) {
            b.Ad(c);
            c.i && CEc(c);
        }
    }
}
function yGc(a, b) {
    var c;
    if (!a || a == b || !XMb(b, (Iqc(), _pc))) return false;
    c = JD(WMb(b, (Iqc(), _pc)), 9);
    return c != a;
}
function Wce(a) {
    switch(a.i){
        case 2:
            return true;
        case 1:
            return false;
        case -1:
            ++a.c;
        default:
            return a.Xl();
    }
}
function Kfc(a, b, c) {
    if (!a.d[b.p][c.p]) {
        Jfc(a, b, c);
        a.d[b.p][c.p] = true;
        a.d[c.p][b.p] = true;
    }
    return a.a[b.p][c.p];
}
function TSd(a, b) {
    if (a.D == null && a.B != null) {
        a.D = a.B;
        a.B = null;
    }
    cTd(a, b == null ? null : (tDb(b), b));
    !!a.C && a.el(null);
}
function CNd(a, b) {
    var c;
    c = new GNd((a.f & 256) != 0, a.i, a.a, a.d, (a.f & 16) != 0, a.j, a.g, b);
    a.e != null || (c.c = a);
    return c;
}
function kId(a, b) {
    var c, d;
    d = JD(Crd(a.a, 4), 128);
    c = SC(X4, JEe, 412, b, 0, 1);
    d != null && $gb(d, 0, c, 0, d.length);
    return c;
}
function Dc(a, b) {
    var c, d;
    for(d = a.Zb().Bc().Jc(); d.Ob();){
        c = JD(d.Pb(), 16);
        if (c.Gc(b)) return true;
    }
    return false;
}
function eu(a, b, c) {
    var d, e, f, g;
    tDb(c);
    g = false;
    f = a.dd(b);
    for(e = c.Jc(); e.Ob();){
        d = e.Pb();
        f.Rb(d);
        g = true;
    }
    return g;
}
function Pv(a, b) {
    var c;
    if (a === b) return true;
    else if (RD(b, 91)) {
        c = JD(b, 91);
        return Nx(dn(a), c.vc());
    }
    return false;
}
function Mib(a, b, c) {
    var d, e;
    for(e = c.Jc(); e.Ob();){
        d = JD(e.Pb(), 43);
        if (a.ze(b, d.kd())) return true;
    }
    return false;
}
function un(a, b, c, d) {
    cn();
    return new Jx(WC(OC(LK, 1), tre, 43, 0, [
        (ak(a, b), new cp(a, b)),
        (ak(c, d), new cp(c, d))
    ]));
}
function XQb() {
    XQb = Zcb;
    VQb = Sx(WC(OC(i2, 1), Ere, 86, 0, [
        (Tgd(), Pgd),
        Qgd
    ]));
    WQb = Sx(WC(OC(i2, 1), Ere, 86, 0, [
        Sgd,
        Ogd
    ]));
}
function Whd() {
    Whd = Zcb;
    Uhd = new MYb(15);
    Thd = new NBd((Lgd(), Kfd), Uhd);
    Vhd = fgd;
    Phd = Red;
    Qhd = Bfd;
    Shd = Efd;
    Rhd = Dfd;
}
function bod() {
    bod = Zcb;
    $nd = new cod('ELK', 0);
    _nd = new cod('JSON', 1);
    Znd = new cod('DOT', 2);
    aod = new cod('SVG', 3);
}
function vVc() {
    vVc = Zcb;
    uVc = new wVc(zve, 0);
    sVc = new wVc(Lze, 1);
    tVc = new wVc('FAN', 2);
    rVc = new wVc('CONSTRAINT', 3);
}
function OTc() {
    OTc = Zcb;
    NTc = new PTc(yve, 0);
    MTc = new PTc('MIDDLE_TO_MIDDLE', 1);
    LTc = new PTc('AVOID_OVERLAP', 2);
}
function j$c() {
    j$c = Zcb;
    g$c = new l$c(yve, 0);
    h$c = new l$c('RADIAL_COMPACTION', 1);
    i$c = new l$c('WEDGE_COMPACTION', 2);
}
function Wyc() {
    Wyc = Zcb;
    Vyc = new Xyc('STACKED', 0);
    Tyc = new Xyc('REVERSE_STACKED', 1);
    Uyc = new Xyc('SEQUENCED', 2);
}
function lAb() {
    lAb = Zcb;
    iAb = new mAb('CONCURRENT', 0);
    jAb = new mAb('IDENTITY_FINISH', 1);
    kAb = new mAb('UNORDERED', 2);
}
function eid() {
    eid = Zcb;
    cid = new fid(pCe, 0);
    bid = new fid('INCLUDE_CHILDREN', 1);
    did = new fid('SEPARATE_CHILDREN', 2);
}
function Ndd(a, b, c) {
    var d, e, f;
    d = new Mtb;
    for(f = Gtb(c, 0); f.b != f.d.c;){
        e = JD(Utb(f), 8);
        Atb(d, new Fdd(e));
    }
    eu(a, b, d);
}
function Qdd(a) {
    var b, c, d;
    b = 0;
    d = SC(b2, hre, 8, a.b, 0, 1);
    c = Gtb(a, 0);
    while(c.b != c.d.c)d[b++] = JD(Utb(c), 8);
    return d;
}
function ke(a, b) {
    var c, d;
    c = JD(a.d.Ac(b), 16);
    if (!c) return null;
    d = a.e.hc();
    d.Fc(c);
    a.e.d -= c.gc();
    c.$b();
    return d;
}
function rxb(a) {
    var b;
    b = a.a.c.length;
    if (b > 0) return _wb(b - 1, a.a.c.length), Olb(a.a, b - 1);
    else throw scb(new Hqb);
}
function bGc(a, b) {
    var c, d;
    d = a.c[b];
    if (d == 0) return;
    a.c[b] = 0;
    a.d -= d;
    c = b + 1;
    while(c < a.a.length){
        a.a[c] -= d;
        c += c & -c;
    }
}
function N0c(a, b) {
    var c;
    b.Sg('Min Size Preprocessing', 1);
    c = dnd(a);
    msd(a, (h1c(), e1c), c.a);
    msd(a, b1c, c.b);
    b.Tg();
}
function Mwc(a, b) {
    var c;
    c = JBd((Twc(), Rwc)) != null && b.Qg() != null ? Beb(MD(b.Qg())) / Beb(MD(JBd(Rwc))) : 1;
    Qib(a.b, b, c);
}
function Uy(a, b) {
    var c;
    c = tcb(a, b);
    if (Dcb(Rcb(a, b), 0) | Bcb(Rcb(a, c), 0)) return c;
    return tcb(mre, Rcb(Lcb(c, 63), 1));
}
function TYd(a) {
    var b;
    b = (!a.a && (a.a = new X0d(d6, a, 9, 5)), a.a);
    if (b.i != 0) return gZd(JD(nDd(b, 0), 679));
    return null;
}
function sDd(a) {
    var b;
    ++a.j;
    if (a.i == 0) a.g = null;
    else if (a.i < a.g.length) {
        b = a.g;
        a.g = a.Zi(a.i);
        $gb(b, 0, a.g, 0, a.i);
    }
}
function a9c(a, b, c) {
    if (b < 0) throw scb(new mdb(wBe + b));
    if (b < a.j.c.length) Rlb(a.j, b, c);
    else {
        $8c(a, b);
        Ilb(a.j, c);
    }
}
function mDb(a, b, c) {
    if (a > b) throw scb(new Teb(vte + a + wte + b));
    if (a < 0 || b > c) throw scb(new odb(vte + a + xte + b + kte + c));
}
function Jbd(a) {
    if (!a.a || (a.a.i & 8) == 0) throw scb(new Web('Enumeration class expected for layout option ' + a.f));
}
function Ueb(a) {
    gz.call(this, 'The given string does not match the expected format for individual spacings.', a);
}
function Gs() {
    Fs.call(this, new Ysb(Ov(16)));
    bk(2, gre);
    this.b = 2;
    this.a = new $s(null, null, 0, null);
    Os(this.a, this.a);
}
function uz(a) {
    sz();
    Yy(this);
    $y(this);
    this.e = a;
    _y(this, a);
    this.g = a == null ? Rqe : adb(a);
    this.a = '';
    this.b = a;
    this.a = '';
}
function Xkc(a, b, c, d) {
    Rkc(this);
    this.c = SC(RP, Jve, 9, a.a.c.length, 0, 1);
    this.e = b;
    Tlb(a.a, this.c);
    this.f = c;
    this.b = d;
}
function Jlb(a, b, c) {
    var d, e;
    vDb(b, a.c.length);
    d = c.Nc();
    e = d.length;
    if (e == 0) return false;
    XCb(a.c, b, d);
    return true;
}
function mlb(a, b) {
    var c, d;
    c = a.a.length - 1;
    while(b != a.b){
        d = b - 1 & c;
        VC(a.a, b, a.a[d]);
        b = d;
    }
    VC(a.a, a.b, null);
    a.b = a.b + 1 & c;
}
function llb(a, b) {
    var c, d;
    c = a.a.length - 1;
    a.c = a.c - 1 & c;
    while(b != a.c){
        d = b + 1 & c;
        VC(a.a, b, a.a[d]);
        b = d;
    }
    VC(a.a, a.c, null);
}
function ONd(a) {
    var b, c;
    if (a == null) return null;
    for(b = 0, c = a.length; b < c; b++){
        if (!_Nd(a[b])) return a[b];
    }
    return null;
}
function Kmb(a) {
    var b, c, d, e, f;
    f = 1;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        f = 31 * f + (b != null ? tb(b) : 0);
        f = f | 0;
    }
    return f;
}
function os(a) {
    var b, c, d, e, f;
    b = {};
    for(d = a, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        b[':' + (c.f != null ? c.f : '' + c.g)] = c;
    }
    return b;
}
function dsb(a, b, c) {
    var d, e, f, g;
    for(e = c, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        if (a.b.ze(b, d.jd())) return d;
    }
    return null;
}
function rHb(a, b) {
    if (!a) return 0;
    if (b && !a.j) return 0;
    if (RD(a, 126)) {
        if (JD(a, 126).a.b == 0) return 0;
    }
    return a.ff();
}
function sHb(a, b) {
    if (!a) return 0;
    if (b && !a.k) return 0;
    if (RD(a, 126)) {
        if (JD(a, 126).a.a == 0) return 0;
    }
    return a.gf();
}
function OFb(a) {
    if (a.c != a.b.b || a.i != a.g.b) {
        _Cb(a.a.c, 0);
        Klb(a.a, a.b);
        Klb(a.a, a.g);
        a.c = a.b.b;
        a.i = a.g.b;
    }
    return a.a;
}
function HBc(a) {
    var b, c, d;
    d = 0;
    for(c = new es(Ir(a.a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        b.c.i == b.d.i || ++d;
    }
    return d;
}
function ur(a) {
    var b;
    Qb(a);
    Mb(true, 'numberToAdvance must be nonnegative');
    for(b = 0; b < 0 && cs(a); b++)ds(a);
    return b;
}
function Skc(a, b) {
    if (XMb(a, (Iqc(), jqc)) && XMb(b, jqc)) return $eb(JD(WMb(a, jqc), 17).a, JD(WMb(b, jqc), 17).a);
    return 0;
}
function ZVb(a, b) {
    var c, d, e;
    c = a;
    e = 0;
    do {
        if (c == b) return e;
        d = c.e;
        if (!d) throw scb(new Seb);
        c = gYb(d);
        ++e;
    }while (true);
}
function W4c(a, b) {
    var c, d, e;
    e = b - a.f;
    for(d = new rmb(a.d); d.a < d.c.c.length;){
        c = JD(pmb(d), 316);
        v4c(c, c.e, c.f + e);
    }
    a.f = b;
}
function rRd(a, b) {
    var c, d, e;
    d = a.Vk(b, null);
    e = null;
    if (b) {
        e = (EOd(), c = new NZd, c);
        GZd(e, a.r);
    }
    d = qRd(a, e, d);
    !!d && d.lj();
}
function NSb(a) {
    var b;
    b = new fTb(a);
    DTb(a.a, LSb, new dnb(WC(OC(cP, 1), Nqe, 374, 0, [
        b
    ])));
    !!b.d && Ilb(b.f, b.d);
    return b.f;
}
function WXb(a, b) {
    var c;
    for(c = 0; c < b.length; c++){
        if (a == (ADb(c, b.length), b.charCodeAt(c))) return true;
    }
    return false;
}
function WNd(a, b) {
    return b < a.length && (ADb(b, a.length), a.charCodeAt(b) != 63) && (ADb(b, a.length), a.charCodeAt(b) != 35);
}
function rb(a) {
    return VD(a) ? hJ : TD(a) ? LI : SD(a) ? GI : QD(a) ? a.Om : UC(a) ? a.Om : a.Om || Array.isArray(a) && OC(ZH, 1) || ZH;
}
function jfe(a) {
    return !a ? null : (a.i & 1) != 0 ? a == pcb ? GI : a == cE ? UI : a == bE ? QI : a == aE ? LI : a == dE ? XI : a == ocb ? cJ : a == $D ? HI : II : a;
}
function wEc(a, b) {
    var c, d;
    d = yvb(a.d, 1) != 0;
    c = true;
    while(c){
        c = false;
        c = b.c.kg(b.e, d);
        c = c | GEc(a, b, d, false);
        d = !d;
    }
    BEc(a);
}
function Nfc(a, b, c, d) {
    var e, f;
    a.a = b;
    f = d ? 0 : 1;
    a.f = (e = new Lfc(a.c, a.a, c, f), new mgc(c, a.a, e, a.e, a.b, a.c == (UEc(), SEc)));
}
function _2c(a, b) {
    var c, d, e;
    d = false;
    c = b.q.d;
    if (b.d < a.b) {
        e = t4c(b.q, a.b);
        if (b.q.d > e) {
            u4c(b.q, e);
            d = c != b.q.d;
        }
    }
    return d;
}
function FZc(a, b) {
    var c, d, e, f, g, h, i, j;
    i = b.i;
    j = b.j;
    d = a.f;
    e = d.i;
    f = d.j;
    g = i - e;
    h = j - f;
    c = $wnd.Math.sqrt(g * g + h * h);
    return c;
}
function Idd(a, b) {
    var c;
    for(c = 0; c < b.length; c++){
        if (a == (ADb(c, b.length), b.charCodeAt(c))) return true;
    }
    return false;
}
function kCc(a) {
    var b, c;
    for(c = new rmb(a.r); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        if (a.n[b.p] <= 0) return b;
    }
    return null;
}
function aOd(a) {
    var b, c;
    if (a == null) return false;
    for(b = 0, c = a.length; b < c; b++){
        if (!_Nd(a[b])) return false;
    }
    return true;
}
function iqe(a) {
    var b;
    if (!(a.c.c < 0 ? a.a >= a.c.b : a.a <= a.c.b)) throw scb(new qub);
    b = a.a;
    a.a += a.c.c;
    ++a.b;
    return jfb(b);
}
function Sc(a, b) {
    var c, d;
    c = JD(a.c.Ac(b), 16);
    if (!c) return a.jc();
    d = a.hc();
    d.Fc(c);
    a.d -= c.gc();
    c.$b();
    return a.mc(d);
}
function Tvd(a, b) {
    var c, d;
    d = lqd(a);
    if (!d) {
        !Cvd && (Cvd = new e1d);
        c = (BNd(), INd(b));
        d = new l9d(c);
        tCd(d.Bl(), a);
    }
    return d;
}
function ehd() {
    ehd = Zcb;
    bhd = new fhd(pCe, 0);
    ahd = new fhd('CONTAINER', 1);
    chd = new fhd('PARENT', 2);
    dhd = new fhd('ROOT', 3);
}
function ozc() {
    ozc = Zcb;
    lzc = new pzc('CONSERVATIVE', 0);
    mzc = new pzc('CONSERVATIVE_SOFT', 1);
    nzc = new pzc('SLOPPY', 2);
}
function oxc() {
    oxc = Zcb;
    lxc = new qxc('DUMMY_NODE_OVER', 0);
    mxc = new qxc('DUMMY_NODE_UNDER', 1);
    nxc = new qxc('EQUAL', 2);
}
function d5c() {
    this.a = new e5c;
    this.f = new g5c(this);
    this.b = new i5c(this);
    this.i = new k5c(this);
    this.e = new m5c(this);
}
function FC(a) {
    zC();
    throw scb(new UB("Unexpected typeof result '" + a + "'; please report this bug to the GWT team"));
}
function Xce(a) {
    switch(a.i){
        case -2:
            return true;
        case -1:
            return false;
        case 1:
            --a.c;
        default:
            return a.Yl();
    }
}
function Mhb(a) {
    var b;
    if (a.c != 0) return a.c;
    for(b = 0; b < a.a.length; b++)a.c = a.c * 33 + (a.a[b] & -1);
    a.c = a.c * a.e;
    return a.c;
}
function zlb(a) {
    var b;
    rDb(a.a != a.b);
    b = a.d.a[a.a];
    qlb(a.b == a.d.c && b != null);
    a.c = a.a;
    a.a = a.a + 1 & a.d.a.length - 1;
    return b;
}
function t$b(a) {
    var b;
    b = new IXb(a.a);
    UMb(b, a);
    ZMb(b, (Iqc(), kqc), a);
    b.o.a = a.g;
    b.o.b = a.f;
    b.n.a = a.i;
    b.n.b = a.j;
    return b;
}
function aEc(a) {
    var b;
    b = K9c($Dc);
    JD(WMb(a, (Iqc(), Wpc)), 22).Gc(($oc(), Woc)) && E9c(b, (CQb(), zQb), (u5b(), j5b));
    return b;
}
function PYc(a) {
    var b, c, d, e;
    e = new Qrb;
    for(d = new rmb(a); d.a < d.c.c.length;){
        c = JD(pmb(d), 27);
        b = SYc(c);
        xe(e, b);
    }
    return e;
}
function KEb(a, b, c) {
    var d, e;
    for(e = b.a.a.ec().Jc(); e.Ob();){
        d = JD(e.Pb(), 60);
        if (LEb(a, d, c)) return true;
    }
    return false;
}
function c6b(a, b, c, d) {
    var e, f;
    for(f = a.Jc(); f.Ob();){
        e = JD(f.Pb(), 72);
        e.n.a = b.a + (d.a - e.o.a) / 2;
        e.n.b = b.b;
        b.b += e.o.b + c;
    }
}
function sKb(a, b, c) {
    var d;
    d = new CJb(a, b);
    Rc(a.r, b.$f(), d);
    if (c && !qjd(a.u)) {
        d.c = new cIb(a.d);
        Llb(b.Pf(), new vKb(d));
    }
}
function vcb(a, b) {
    var c;
    if (Ccb(a) && Ccb(b)) {
        c = a - b;
        if (!isNaN(c)) return c;
    }
    return mD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b);
}
function DPc(a, b, c) {
    if ($wnd.Math.abs(b - a) < xze || $wnd.Math.abs(c - a) < xze) return true;
    return b - a > xze ? a - c > xze : c - a > xze;
}
function Tv(b, c) {
    Qb(b);
    try {
        return b.xc(c);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 211) || RD(a, 169)) return null;
        else throw scb(a);
    }
}
function Uv(b, c) {
    Qb(b);
    try {
        return b.Ac(c);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 211) || RD(a, 169)) return null;
        else throw scb(a);
    }
}
function r3c(a) {
    switch(a.g){
        case 0:
            return new e3c;
        case 1:
            return new D3c;
        case 2:
            return new k3c;
        default:
            return null;
    }
}
function Vcd(a, b) {
    var c, d, e;
    e = 1;
    c = a;
    d = b >= 0 ? b : -b;
    while(d > 0)if (d % 2 == 0) {
        c *= c;
        d = d / 2 | 0;
    } else {
        e *= c;
        d -= 1;
    }
    return b < 0 ? 1 / e : e;
}
function Wcd(a, b) {
    var c, d, e;
    e = 1;
    c = a;
    d = b >= 0 ? b : -b;
    while(d > 0)if (d % 2 == 0) {
        c *= c;
        d = d / 2 | 0;
    } else {
        e *= c;
        d -= 1;
    }
    return b < 0 ? 1 / e : e;
}
function zqd(a, b) {
    var c, d, e, f;
    f = (e = a ? lqd(a) : null, ife((d = b, e && e.Dl(), d)));
    if (f == b) {
        c = lqd(a);
        !!c && c.Dl();
    }
    return f;
}
function zZd(a, b, c) {
    var d, e;
    e = a.b;
    a.b = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 3, e, b);
        !c ? c = d : c.kj(d);
    }
    return c;
}
function BZd(a, b, c) {
    var d, e;
    e = a.f;
    a.f = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 0, e, b);
        !c ? c = d : c.kj(d);
    }
    return c;
}
function Vud(a, b, c) {
    var d, e;
    e = a.a;
    a.a = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 1, e, b);
        !c ? c = d : c.kj(d);
    }
    return c;
}
function Tkc(a, b, c) {
    var d, e;
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 9);
        if (d == b) return -1;
        else if (d == c) return 1;
    }
    return 0;
}
function blc(a, b) {
    var c;
    c = new tYb(a);
    rYb(c, (DYb(), yYb));
    ZMb(c, (Iqc(), kqc), b);
    ZMb(c, (Bwc(), Evc), (ajd(), Xid));
    return c;
}
function wPc(a) {
    return (Rjd(), Ijd).Gc(a.j) ? Beb(MD(WMb(a, (Iqc(), Cqc)))) : Kdd(WC(OC(b2, 1), hre, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ])).b;
}
function Eib(a, b, c, d, e) {
    if (b == 0 || d == 0) return;
    b == 1 ? e[d] = Gib(e, c, d, a[0]) : d == 1 ? e[b] = Gib(e, a, b, c[0]) : Fib(a, c, e, b, d);
}
function Mmb(a, b, c, d, e, f, g, h) {
    var i;
    i = c;
    while(f < g)i >= d || b < c && h.Le(a[b], a[i]) <= 0 ? VC(e, f++, a[b++]) : VC(e, f++, a[i++]);
}
function L3c(a, b, c) {
    var d, e, f, g;
    d = c / a.gc();
    e = 0;
    for(g = a.Jc(); g.Ob();){
        f = JD(g.Pb(), 186);
        W4c(f, f.f + d * e);
        T4c(f, b, d);
        ++e;
    }
}
function s4c(a) {
    var b, c, d;
    d = 0;
    for(c = new rmb(a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 172);
        d = $wnd.Math.max(d, b.g);
    }
    return d;
}
function HEc(a) {
    var b, c, d;
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 217);
        b = c.c.ig() ? c.f : c.a;
        !!b && PFc(b, c.j);
    }
}
function pJd(a) {
    var b, c, d, e;
    if (a != null) for(c = 0; c < a.length; ++c){
        b = a[c];
        if (b) {
            JD(b.g, 371);
            e = b.i;
            for(d = 0; d < e; ++d);
        }
    }
}
function Mm(a) {
    var b;
    switch(a.gc()){
        case 0:
            return pm;
        case 1:
            return new vy(Qb(a.Xb(0)));
        default:
            b = a;
            return new Gx(b);
    }
}
function bo(a) {
    Yl();
    switch(a.gc()){
        case 0:
            return Lx(), Kx;
        case 1:
            return new xy(a.Jc().Pb());
        default:
            return new Mx(a);
    }
}
function aq(a) {
    Yl();
    switch(a.c){
        case 0:
            return Lx(), Kx;
        case 1:
            return new xy(Er(new Drb(a)));
        default:
            return new _p(a);
    }
}
function jfb(a) {
    var b, c;
    if (a > -129 && a < 128) return lfb(), b = a + 128, c = kfb[b], !c && (c = kfb[b] = new Yeb(a)), c;
    return new Yeb(a);
}
function Ufb(a) {
    var b, c;
    if (a > -129 && a < 128) return Wfb(), b = a + 128, c = Vfb[b], !c && (c = Vfb[b] = new Ofb(a)), c;
    return new Ofb(a);
}
function F2b(a, b) {
    var c;
    if (a.c.length == 0) return;
    c = JD(Tlb(a, SC(RP, Jve, 9, a.c.length, 0, 1)), 199);
    Qmb(c, new R2b);
    C2b(c, b);
}
function L2b(a, b) {
    var c;
    if (a.c.length == 0) return;
    c = JD(Tlb(a, SC(RP, Jve, 9, a.c.length, 0, 1)), 199);
    Qmb(c, new W2b);
    C2b(c, b);
}
function WTb(a, b) {
    var c;
    if (a.a.c.length > 0) {
        c = JD(Mlb(a.a, a.a.c.length - 1), 561);
        if ($Ub(c, b)) return;
    }
    Ilb(a.a, new aVb(b));
}
function Udc(a) {
    Adc();
    var b, c;
    b = a.d.c - a.e.c;
    c = JD(a.g, 152);
    Llb(c.b, new nec(b));
    Llb(c.c, new pec(b));
    ofb(c.i, new rec(b));
}
function jfc(a) {
    var b;
    b = new Ugb;
    b.a += 'VerticalSegment ';
    Pgb(b, a.e);
    b.a += ' ';
    Qgb(b, Eb(new Gb, new rmb(a.k)));
    return b.a;
}
function nhb(a, b) {
    var c;
    a.c = b;
    a.a = gib(b);
    a.a < 54 && (a.f = (c = b.d > 1 ? CDb(b.a[0], b.a[1]) : CDb(b.a[0], 0), Ocb(b.e > 0 ? c : Gcb(c))));
}
function cgc(a, b) {
    var c, d, e;
    c = 0;
    for(e = lYb(a, b).Jc(); e.Ob();){
        d = JD(e.Pb(), 11);
        c += WMb(d, (Iqc(), sqc)) != null ? 1 : 0;
    }
    return c;
}
function YNc(a, b, c) {
    var d, e, f;
    d = 0;
    for(f = Gtb(a, 0); f.b != f.d.c;){
        e = Beb(MD(Utb(f)));
        if (e > c) break;
        else e >= b && ++d;
    }
    return d;
}
function Uad(a) {
    var b;
    b = JD(Tsb(a.c.c, ''), 232);
    if (!b) {
        b = new uad(Dad(Cad(new Ead, ''), 'Other'));
        Usb(a.c.c, '', b);
    }
    return b;
}
function svd(a) {
    var b;
    if ((a.Db & 64) != 0) return Gqd(a);
    b = new Jgb(Gqd(a));
    b.a += ' (name: ';
    Egb(b, a.zb);
    b.a += ')';
    return b.a;
}
function Lvd(a, b, c) {
    var d, e;
    e = a.sb;
    a.sb = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 4, e, b);
        !c ? c = d : c.kj(d);
    }
    return c;
}
function hDd(a, b, c) {
    var d;
    a.Yi(a.i + 1);
    d = a.Wi(b, c);
    b != a.i && $gb(a.g, b, a.g, b + 1, a.i - b);
    VC(a.g, b, d);
    ++a.i;
    a.Ji(b, c);
    a.Ki();
}
function sRd(a, b, c) {
    var d, e;
    e = a.r;
    a.r = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 8, e, a.r);
        !c ? c = d : c.kj(d);
    }
    return c;
}
function K0d(a, b, c) {
    var d, e;
    d = new i_d(a.e, 3, 13, null, (e = b.c, e ? e : (cPd(), ROd)), AUd(a, b), false);
    !c ? c = d : c.kj(d);
    return c;
}
function L0d(a, b, c) {
    var d, e;
    d = new i_d(a.e, 4, 13, (e = b.c, e ? e : (cPd(), ROd)), null, AUd(a, b), false);
    !c ? c = d : c.kj(d);
    return c;
}
function U8d(a, b) {
    var c, d, e, f;
    b.bj(a.a);
    f = JD(Crd(a.a, 8), 1981);
    if (f != null) for(c = f, d = 0, e = c.length; d < e; ++d)null.Rm();
}
function hae(a, b) {
    var c, d;
    c = JD(b, 676);
    d = c.bl();
    !d && c.cl(d = RD(b, 88) ? new vae(a, JD(b, 29)) : new Hae(a, JD(b, 155)));
    return d;
}
function Zeb(a) {
    a -= a >> 1 & 1431655765;
    a = (a >> 2 & 858993459) + (a & 858993459);
    a = (a >> 4) + a & 252645135;
    a += a >> 8;
    a += a >> 16;
    return a & 63;
}
function Nsd(a, b) {
    switch(b){
        case 1:
            !a.n && (a.n = new X0d(z3, a, 1, 7));
            RGd(a.n);
            return;
        case 2:
            Psd(a, null);
            return;
    }
    isd(a, b);
}
function dGc(a, b) {
    switch(b.g){
        case 2:
        case 1:
            return lYb(a, b);
        case 3:
        case 4:
            return dv(lYb(a, b));
    }
    return pnb(), pnb(), mnb;
}
function LBb(a, b) {
    var c;
    c = new HCb;
    if (!a.a.zd(c)) {
        KAb(a);
        return yub(), yub(), xub;
    }
    return yub(), new Cub(tDb(KBb(a, c.a, b)));
}
function uhb(a) {
    var b;
    vcb(a, 0) < 0 && (a = wcb(qD(Ccb(a) ? Ncb(a) : a)));
    return b = Pcb(Lcb(a, 32)), 64 - (b != 0 ? efb(b) : efb(Pcb(a)) + 32);
}
function pb(a, b) {
    return VD(a) ? cgb(a, b) : TD(a) ? Ceb(a, b) : SD(a) ? (tDb(a), XD(a) === XD(b)) : QD(a) ? a.Fb(b) : UC(a) ? mb(a, b) : zz(a, b);
}
function vxb(a, b) {
    var c;
    if (b.a) {
        c = b.a.a.length;
        !a.a ? a.a = new Wgb(a.d) : Qgb(a.a, a.b);
        Ogb(a.a, b.a, b.d.length, c);
    }
    return a;
}
function wJb(a) {
    sJb();
    var b, c, d, e;
    for(c = yJb(), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        if (Nlb(b.a, a, 0) != -1) return b;
    }
    return rJb;
}
function Sv(b, c) {
    Qb(b);
    try {
        return b._b(c);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 211) || RD(a, 169)) return false;
        else throw scb(a);
    }
}
function Lk(b, c) {
    Qb(b);
    try {
        return b.Gc(c);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 211) || RD(a, 169)) return false;
        else throw scb(a);
    }
}
function Mk(b, c) {
    Qb(b);
    try {
        return b.Kc(c);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 211) || RD(a, 169)) return false;
        else throw scb(a);
    }
}
function Isd(a, b, c, d) {
    switch(b){
        case 1:
            return !a.n && (a.n = new X0d(z3, a, 1, 7)), a.n;
        case 2:
            return a.k;
    }
    return esd(a, b, c, d);
}
function gqd(a, b, c) {
    if (b < 0) xqd(a, c);
    else {
        if (!c.ok()) throw scb(new Teb(LCe + c.ve() + MCe));
        JD(c, 69).tk().Bk(a, a.di(), b);
    }
}
function wDb(a, b, c) {
    if (a < 0 || b > c) throw scb(new mdb(vte + a + xte + b + ', size: ' + c));
    if (a > b) throw scb(new Teb(vte + a + wte + b));
}
function uRd(a, b) {
    var c;
    c = (a.Bb & 256) != 0;
    b ? a.Bb |= 256 : a.Bb &= -257;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 2, c, b));
}
function ZTd(a, b) {
    var c;
    c = (a.Bb & 256) != 0;
    b ? a.Bb |= 256 : a.Bb &= -257;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 8, c, b));
}
function $Td(a, b) {
    var c;
    c = (a.Bb & 512) != 0;
    b ? a.Bb |= 512 : a.Bb &= -513;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 9, c, b));
}
function vRd(a, b) {
    var c;
    c = (a.Bb & 512) != 0;
    b ? a.Bb |= 512 : a.Bb &= -513;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 3, c, b));
}
function EYd(a, b) {
    var c;
    c = (a.Bb & 256) != 0;
    b ? a.Bb |= 256 : a.Bb &= -257;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 8, c, b));
}
function HZd(a, b, c) {
    var d, e;
    e = a.a;
    a.a = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 5, e, a.a);
        !c ? c = d : NFd(c, d);
    }
    return c;
}
function JQd(a) {
    var b;
    if ((a.Db & 64) != 0) return Gqd(a);
    b = new Jgb(Gqd(a));
    b.a += ' (source: ';
    Egb(b, a.d);
    b.a += ')';
    return b.a;
}
function Fge(a, b) {
    var c;
    if (a.b == -1 && !!a.a) {
        c = a.a.mk();
        a.b = !c ? WTd(a.c.zh(), a.a) : a.c.Dh(a.a.Ij(), c);
    }
    return a.c.uh(a.b, b);
}
function OXd(a, b) {
    var c, d;
    for(d = new CHd(a); d.e != d.i.gc();){
        c = JD(AHd(d), 29);
        if (XD(b) === XD(c)) return true;
    }
    return false;
}
function m2b(a) {
    var b, c;
    b = a.k;
    if (b == (DYb(), wYb)) {
        c = JD(WMb(a, (Iqc(), Tpc)), 64);
        return c == (Rjd(), xjd) || c == Ojd;
    }
    return false;
}
function PAb(a) {
    var b;
    b = QAb(a);
    if (ycb(b.a, 0)) return Hub(), Hub(), Gub;
    return Hub(), new Mub(Acb(b.a, 0) ? Dqb(b) / Ocb(b.a) : 0);
}
function rhb(a, b) {
    this.e = b;
    this.a = uhb(a);
    this.a < 54 ? this.f = Ocb(a) : this.c = (Ghb(), vcb(a, 0) >= 0 ? aib(a) : Ohb(aib(Gcb(a))));
}
function QVb(a, b, c, d, e, f) {
    this.e = new Ulb;
    this.f = (Eyc(), Dyc);
    Ilb(this.e, a);
    this.d = b;
    this.a = c;
    this.b = d;
    this.f = e;
    this.c = f;
}
function sCd(a, b, c) {
    var d;
    d = a.gc();
    if (b > d) throw scb(new zHd(b, d));
    if (a.Pi() && a.Gc(c)) throw scb(new Teb(MDe));
    a.Di(b, c);
}
function X_d(a, b) {
    var c, d;
    for(d = new CHd(a); d.e != d.i.gc();){
        c = JD(AHd(d), 141);
        if (XD(b) === XD(c)) return true;
    }
    return false;
}
function bae(a, b, c) {
    var d, e, f;
    f = (e = g1d(a.b, b), e);
    if (f) {
        d = JD(Oae(iae(a, f), ''), 29);
        if (d) return kae(a, d, b, c);
    }
    return null;
}
function eae(a, b, c) {
    var d, e, f;
    f = (e = g1d(a.b, b), e);
    if (f) {
        d = JD(Oae(iae(a, f), ''), 29);
        if (d) return lae(a, d, b, c);
    }
    return null;
}
function Yle(a) {
    var b, c, d;
    d = 0;
    c = a.length;
    for(b = 0; b < c; b++)a[b] == 32 || a[b] == 13 || a[b] == 10 || a[b] == 9 || (a[d++] = a[b]);
    return d;
}
function CEc(a) {
    var b;
    if (a.g) {
        b = a.c.ig() ? a.f : a.a;
        EEc(b.a, a.o, true);
        EEc(b.a, a.o, false);
        ZMb(a.o, (Bwc(), Evc), (ajd(), Wid));
    }
}
function glb(a) {
    var b;
    b = a.a[a.c - 1 & a.a.length - 1];
    if (b == null) return null;
    a.c = a.c - 1 & a.a.length - 1;
    VC(a.a, a.c, null);
    return b;
}
function BGb(a) {
    var b, c;
    for(c = a.p.a.ec().Jc(); c.Ob();){
        b = JD(c.Pb(), 216);
        if (b.f && a.b[b.c] < -0.0000000001) return b;
    }
    return null;
}
function cOd(a) {
    if (a >= 65 && a <= 70) return a - 65 + 10;
    if (a >= 97 && a <= 102) return a - 97 + 10;
    if (a >= 48 && a <= 57) return a - 48;
    return 0;
}
function Heb(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    if (a == b) return a == 0 ? Heb(1 / a, 1 / b) : 0;
    return isNaN(a) ? isNaN(b) ? 0 : 1 : -1;
}
function aqd(a, b) {
    var c;
    c = RTd(a, b);
    if (RD(c, 330)) return JD(c, 35);
    throw scb(new Teb(LCe + b + "' is not a valid attribute"));
}
function dLb(a, b) {
    switch(a.b.g){
        case 0:
        case 1:
            return b;
        case 2:
        case 3:
            return new gdd(b.d, 0, b.a, b.b);
        default:
            return null;
    }
}
function eOc(a) {
    switch(a){
        case 0:
            return new pOc;
        case 1:
            return new fOc;
        case 2:
            return new kOc;
        default:
            throw scb(new Seb);
    }
}
function Wgd(a) {
    switch(a.g){
        case 2:
            return Qgd;
        case 1:
            return Pgd;
        case 4:
            return Ogd;
        case 3:
            return Sgd;
        default:
            return Rgd;
    }
}
function E1b(a) {
    switch(JD(WMb(a, (Iqc(), $pc)), 312).g){
        case 1:
            ZMb(a, $pc, (qpc(), npc));
            break;
        case 2:
            ZMb(a, $pc, (qpc(), ppc));
    }
}
function uWc() {
    uWc = Zcb;
    tWc = B9c(B9c(G9c(B9c(B9c(G9c(E9c(new J9c, (_Pc(), YPc), (ZSc(), YSc)), ZPc), USc), WSc), $Pc), QSc), XSc);
}
function w5c() {
    w5c = Zcb;
    t5c = new x5c('P1_STRUCTURE', 0);
    u5c = new x5c('P2_PROCESSING_ORDER', 1);
    v5c = new x5c('P3_EXECUTION', 2);
}
function R3c() {
    R3c = Zcb;
    O3c = new T3c('EQUAL_BETWEEN_STRUCTURES', 0);
    Q3c = new T3c('TO_ASPECT_RATIO', 1);
    P3c = new T3c(yve, 2);
}
function Wkd() {
    Wkd = Zcb;
    Ukd = new Xkd('PARALLEL_NODE', 0);
    Tkd = new Xkd('HIERARCHICAL_NODE', 1);
    Vkd = new Xkd('ROOT_NODE', 2);
}
function xhd() {
    xhd = Zcb;
    whd = new yhd(eue, 0);
    uhd = new yhd('POLYLINE', 1);
    thd = new yhd('ORTHOGONAL', 2);
    vhd = new yhd('SPLINES', 3);
}
function Tgd() {
    Tgd = Zcb;
    Rgd = new Xgd(eue, 0);
    Qgd = new Xgd(aue, 1);
    Pgd = new Xgd(_te, 2);
    Ogd = new Xgd(lue, 3);
    Sgd = new Xgd('UP', 4);
}
function I0b(a, b) {
    b.Sg('Sort end labels', 1);
    EBb(BBb(DBb(new RBb(null, new Gvb(a.b, 16)), new T0b), new V0b), new X0b);
    b.Tg();
}
function SRd(a, b) {
    var c;
    c = (a.Bb & NEe) != 0;
    b ? a.Bb |= NEe : a.Bb &= -1025;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 10, c, b));
}
function YRd(a, b) {
    var c;
    c = (a.Bb & Mse) != 0;
    b ? a.Bb |= Mse : a.Bb &= -4097;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 12, c, b));
}
function $Rd(a, b) {
    var c;
    c = (a.Bb & wse) != 0;
    b ? a.Bb |= wse : a.Bb &= -2049;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 11, c, b));
}
function ZRd(a, b) {
    var c;
    c = (a.Bb & dFe) != 0;
    b ? a.Bb |= dFe : a.Bb &= -8193;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 15, c, b));
}
function sJd(a, b) {
    var c, d, e;
    if (a.d == null) {
        ++a.e;
        --a.f;
    } else {
        e = b.jd();
        c = b.xi();
        d = (c & Hqe) % a.d.length;
        HJd(a, d, uJd(a, d, c, e));
    }
}
function TGd(a, b, c) {
    var d, e;
    if (a.Mj()) {
        e = a.Nj();
        d = pDd(a, b, c);
        a.Gj(a.Fj(7, jfb(c), d, b, e));
        return d;
    } else return pDd(a, b, c);
}
function cfe(a) {
    var b, c;
    for(c = dfe(WSd(a)).Jc(); c.Ob();){
        b = OD(c.Pb());
        if (Fud(a, b)) return nOd((mOd(), lOd), b);
    }
    return null;
}
function yUb(a) {
    var b, c, d;
    b = new Ulb;
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 586);
        Klb(b, JD(c.Af(), 16));
    }
    return b;
}
function bRb(a, b) {
    var c, d;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 47);
        Plb(a.b.b, c.b);
        rRb(JD(c.a, 194), JD(c.b, 82));
    }
}
function Hr(a) {
    var b, c;
    c = Kgb(new Ugb, 91);
    b = true;
    while(a.Ob()){
        b || (c.a += Lqe, c);
        b = false;
        Pgb(c, a.Pb());
    }
    return (c.a += ']', c).a;
}
function kMb(a, b) {
    var c;
    c = Heb(a.b.c, b.b.c);
    if (c != 0) return c;
    c = Heb(a.a.a, b.a.a);
    if (c != 0) return c;
    return Heb(a.a.b, b.a.b);
}
function sXb(a) {
    var b, c;
    c = JD(WMb(a, (Bwc(), ruc)), 86);
    if (c == (Tgd(), Rgd)) {
        b = Beb(MD(WMb(a, Ttc)));
        return b >= 1 ? Qgd : Ogd;
    }
    return c;
}
function jbc(a) {
    switch(JD(WMb(a, (Bwc(), yuc)), 220).g){
        case 1:
            return new Ijc;
        case 3:
            return new zkc;
        default:
            return new Cjc;
    }
}
function Sjd(a) {
    switch(a.g){
        case 1:
            return Qjd;
        case 2:
            return xjd;
        case 3:
            return wjd;
        case 4:
            return Ojd;
        default:
            return Pjd;
    }
}
function Tjd(a) {
    switch(a.g){
        case 1:
            return Ojd;
        case 2:
            return Qjd;
        case 3:
            return xjd;
        case 4:
            return wjd;
        default:
            return Pjd;
    }
}
function Ujd(a) {
    switch(a.g){
        case 1:
            return wjd;
        case 2:
            return Ojd;
        case 3:
            return Qjd;
        case 4:
            return xjd;
        default:
            return Pjd;
    }
}
function LAb(a) {
    if (a.c) LAb(a.c);
    else if (a.d) throw scb(new Web("Stream already terminated, can't be modified or used"));
}
function ylc(a) {
    var b;
    if (!a.a) throw scb(new Web('Cannot offset an unassigned cut.'));
    b = a.c - a.b;
    a.b += b;
    Alc(a, b);
    Blc(a, b);
}
function gmd(a, b, c) {
    var d, e;
    if (a.c) qnd(a.c, b, c);
    else for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 162);
        gmd(d, b, c);
    }
}
function Be(a, b) {
    var c, d, e;
    tDb(b);
    c = false;
    for(d = new rmb(a); d.a < d.c.c.length;){
        e = pmb(d);
        if (b.Gc(e)) {
            qmb(d);
            c = true;
        }
    }
    return c;
}
function gce(a, b) {
    var c, d, e, f, g;
    g = Kfe(a.e.zh(), b);
    f = 0;
    c = JD(a.g, 122);
    for(e = 0; e < a.i; ++e){
        d = c[e];
        g.Zl(d.Ik()) && ++f;
    }
    return f;
}
function Asb(a, b, c) {
    var d;
    d = a.a.get(b);
    a.a.set(b, c === undefined ? null : c);
    if (d === undefined) {
        ++a.c;
        ++a.b.g;
    } else ++a.d;
    return d;
}
function KBc(a, b, c) {
    var d, e;
    for(e = a.a.ec().Jc(); e.Ob();){
        d = JD(e.Pb(), 9);
        if (Ae(c, JD(Mlb(b, d.p), 16))) return d;
    }
    return null;
}
function Obe(a, b, c) {
    var d, e;
    e = RD(b, 101) && (JD(b, 19).Bb & Pse) != 0 ? new lde(b, a) : new ide(b, a);
    for(d = 0; d < c; ++d)Yce(e);
    return e;
}
function xWc(a, b, c) {
    var d;
    d = 0;
    !!b && (Vgd(a.a) ? d += b.f.a / 2 : d += b.f.b / 2);
    !!c && (Vgd(a.a) ? d += c.f.a / 2 : d += c.f.b / 2);
    return d;
}
function VPb(a, b, c) {
    var d;
    d = c;
    !d && (d = vld(new wld, 0));
    d.Sg(rve, 2);
    IVb(a.b, b, d.bh(1));
    XPb(a, b, d.bh(1));
    rVb(b, d.bh(1));
    d.Tg();
}
function bCd(a, b, c) {
    var d, e;
    d = (Hpd(), e = new Bsd, e);
    zsd(d, b);
    Asd(d, c);
    !!a && tCd((!a.a && (a.a = new qVd(u3, a, 5)), a.a), d);
    return d;
}
function UBd(a, b, c) {
    var d, e;
    d = JD(b.mf(a.a), 34);
    e = JD(c.mf(a.a), 34);
    return d != null && e != null ? Cdb(d, e) : d != null ? -1 : e != null ? 1 : 0;
}
function lYb(a, b) {
    var c;
    a.i || dYb(a);
    c = JD(Kqb(a.g, b), 47);
    return !c ? (pnb(), pnb(), mnb) : new Ijb(a.j, JD(c.a, 17).a, JD(c.b, 17).a);
}
function tcb(a, b) {
    var c;
    if (Ccb(a) && Ccb(b)) {
        c = a + b;
        if (Fse < c && c < Dse) return c;
    }
    return wcb(kD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b));
}
function Fcb(a, b) {
    var c;
    if (Ccb(a) && Ccb(b)) {
        c = a * b;
        if (Fse < c && c < Dse) return c;
    }
    return wcb(oD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b));
}
function Mcb(a, b) {
    var c;
    if (Ccb(a) && Ccb(b)) {
        c = a - b;
        if (Fse < c && c < Dse) return c;
    }
    return wcb(vD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b));
}
function Db(b, c, d) {
    var e;
    try {
        Cb(b, c, d);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 590)) {
            e = a;
            throw scb(new udb(e));
        } else throw scb(a);
    }
    return c;
}
function Lne(a) {
    var b;
    b = SC(_D, Ure, 30, 2, 15, 1);
    a -= Pse;
    b[0] = (a >> 10) + Qse & Wre;
    b[1] = (a & 1023) + 56320 & Wre;
    return zgb(b, 0, b.length);
}
function VRd(a, b) {
    var c;
    c = (a.Bb & ire) != 0;
    b ? a.Bb |= ire : a.Bb &= -16385;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 16, c, b));
}
function FSd(a, b) {
    var c;
    c = (a.Bb & RCe) != 0;
    b ? a.Bb |= RCe : a.Bb &= -32769;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 18, c, b));
}
function v1d(a, b) {
    var c;
    c = (a.Bb & RCe) != 0;
    b ? a.Bb |= RCe : a.Bb &= -32769;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 18, c, b));
}
function x1d(a, b) {
    var c;
    c = (a.Bb & Pse) != 0;
    b ? a.Bb |= Pse : a.Bb &= -65537;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new j_d(a, 1, 20, c, b));
}
function Qsd(a) {
    var b;
    if ((a.Db & 64) != 0) return Gqd(a);
    b = new Jgb(Gqd(a));
    b.a += ' (identifier: ';
    Egb(b, a.k);
    b.a += ')';
    return b.a;
}
function eYb(a) {
    var b, c, d;
    b = new Ulb;
    for(d = new rmb(a.j); d.a < d.c.c.length;){
        c = JD(pmb(d), 11);
        Ilb(b, c.b);
    }
    return Qb(b), new Bl(b);
}
function hYb(a) {
    var b, c, d;
    b = new Ulb;
    for(d = new rmb(a.j); d.a < d.c.c.length;){
        c = JD(pmb(d), 11);
        Ilb(b, c.e);
    }
    return Qb(b), new Bl(b);
}
function kYb(a) {
    var b, c, d;
    b = new Ulb;
    for(d = new rmb(a.j); d.a < d.c.c.length;){
        c = JD(pmb(d), 11);
        Ilb(b, c.g);
    }
    return Qb(b), new Bl(b);
}
function ffe(a) {
    var b, c;
    for(c = gfe(WSd(PRd(a))).Jc(); c.Ob();){
        b = OD(c.Pb());
        if (Fud(a, b)) return yOd((xOd(), wOd), b);
    }
    return null;
}
function Fm(a) {
    var b, c, d;
    for(c = 0, d = a.length; c < d; c++){
        if (a[c] == null) throw scb(new Ffb('at index ' + c));
    }
    b = a;
    return new dnb(b);
}
function Qv(a) {
    var b, c, d, e;
    b = new kq(a.Pd().gc());
    e = 0;
    for(d = Jr(a.Pd().Jc()); d.Ob();){
        c = d.Pb();
        jq(b, c, jfb(e++));
    }
    return pn(b.a);
}
function Qeb(a) {
    var b;
    b = Edb(a);
    if (b > 3.4028234663852886E38) return Kse;
    else if (b < -340282346638528860000000000000000000000) return Lse;
    return b;
}
function mrb(a) {
    var b, c, d, e;
    c = (b = JD(deb((d = a.Om, e = d.f, e == MI ? d : e)), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    orb(c, a);
    return c;
}
function $3c(a, b) {
    a.n.c.length == 0 && Ilb(a.n, new p4c(a.s, a.t, a.i));
    Ilb(a.b, b);
    k4c(JD(Mlb(a.n, a.n.c.length - 1), 208), b);
    a4c(a, b);
}
function O_c(a, b, c) {
    var d;
    c.Sg('Straight Line Edge Routing', 1);
    c.ah(b, _ze);
    d = JD(ksd(b, (xYc(), wYc)), 27);
    P_c(a, d);
    c.ah(b, bAe);
}
function Q9b(a, b) {
    var c, d, e;
    e = 0;
    for(d = JD(b.Kb(a), 20).Jc(); d.Ob();){
        c = JD(d.Pb(), 18);
        ydb(LD(WMb(c, (Iqc(), xqc)))) || ++e;
    }
    return e;
}
function Zbc(a, b) {
    var c, d, e;
    d = mdc(b);
    e = Beb(MD(kzc(d, (Bwc(), Wvc))));
    c = $wnd.Math.max(0, e / 2 - 0.5);
    Xbc(b, c, 1);
    Ilb(a, new wcc(b, c));
}
function sQc(a, b) {
    return cgb(!!b.b && !!b.c ? dRc(b.b) + '->' + dRc(b.c) : 'e_' + tb(b), !!a.b && !!a.c ? dRc(a.b) + '->' + dRc(a.c) : 'e_' + tb(a));
}
function uQc(a, b) {
    return cgb(!!b.b && !!b.c ? dRc(b.b) + '->' + dRc(b.c) : 'e_' + tb(b), !!a.b && !!a.c ? dRc(a.b) + '->' + dRc(a.c) : 'e_' + tb(a));
}
function Sy(a, b) {
    Ry();
    return Vy(Kre), $wnd.Math.abs(a - b) <= Kre || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : Wy(isNaN(a), isNaN(b));
}
function hRb(a) {
    XQb();
    return xdb(), SRb(JD(a.a, 82).j, JD(a.b, 86)) || JD(a.a, 82).d.e != 0 && SRb(JD(a.a, 82).j, JD(a.b, 86)) ? true : false;
}
function Cvb() {
    vvb();
    var a, b, c;
    c = uvb++ + Date.now();
    a = YD($wnd.Math.floor(c * hte)) & jte;
    b = YD(c - a * ite);
    this.a = a ^ 1502;
    this.b = b ^ gte;
}
function Lmb(a, b, c, d) {
    var e, f, g;
    for(e = b + 1; e < c; ++e)for(f = e; f > b && d.Le(a[f - 1], a[f]) > 0; --f){
        g = a[f];
        VC(a, f, a[f - 1]);
        VC(a, f - 1, g);
    }
}
function Tad(a, b) {
    var c, d, e, f, g;
    c = b.f;
    Usb(a.c.d, c, b);
    if (b.g != null) for(e = b.g, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        Usb(a.c.e, d, b);
    }
}
function _Mc(a, b) {
    var c, d;
    c = Gtb(a, 0);
    while(c.b != c.d.c){
        d = Deb(MD(Utb(c)));
        if (d == b) return;
        else if (d > b) {
            Vtb(c);
            break;
        }
    }
    Stb(c, b);
}
function yqd(a, b) {
    var c;
    c = RTd(a.zh(), b);
    if (RD(c, 101)) return JD(c, 19);
    throw scb(new Teb(LCe + b + "' is not a valid reference"));
}
function AFb(a, b) {
    if (b == a.d) return a.e;
    else if (b == a.e) return a.d;
    else throw scb(new Teb('Node ' + b + ' not part of edge ' + a));
}
function $Eb(a, b) {
    switch(b.g){
        case 2:
            return a.b;
        case 1:
            return a.c;
        case 4:
            return a.d;
        case 3:
            return a.a;
        default:
            return false;
    }
}
function SRb(a, b) {
    switch(b.g){
        case 2:
            return a.b;
        case 1:
            return a.c;
        case 4:
            return a.d;
        case 3:
            return a.a;
        default:
            return false;
    }
}
function _sd(a, b, c, d) {
    switch(b){
        case 3:
            return a.f;
        case 4:
            return a.g;
        case 5:
            return a.i;
        case 6:
            return a.j;
    }
    return Isd(a, b, c, d);
}
function fqd(a, b, c, d) {
    if (b < 0) wqd(a, c, d);
    else {
        if (!c.ok()) throw scb(new Teb(LCe + c.ve() + MCe));
        JD(c, 69).tk().zk(a, a.di(), b, d);
    }
}
function gg(a) {
    var b;
    if (a.b) {
        gg(a.b);
        if (a.b.d != a.c) throw scb(new yqb);
    } else if (a.d.dc()) {
        b = JD(a.f.c.xc(a.e), 16);
        !!b && (a.d = b);
    }
}
function Ogc(a) {
    if (a.k != (DYb(), AYb)) return false;
    return xBb(new RBb(null, new Hvb(new es(Ir(kYb(a).a.Jc(), new er)))), new Pgc);
}
function FNd(a) {
    if (a.e == null) return a;
    else !a.c && (a.c = new GNd((a.f & 256) != 0, a.i, a.a, a.d, (a.f & 16) != 0, a.j, a.g, null));
    return a.c;
}
function bD(a, b) {
    if (a.h == Bse && a.m == 0 && a.l == 0) {
        b && (YC = _C(0, 0, 0));
        return $C((ED(), CD));
    }
    b && (YC = _C(a.l, a.m, a.h));
    return _C(0, 0, 0);
}
function adb(a) {
    var b;
    if (Array.isArray(a) && a.Qm === bdb) return eeb(rb(a)) + '@' + (b = tb(a) >>> 0, b.toString(16));
    return a.toString();
}
function Oqb(a) {
    var b;
    this.a = (b = JD(a.e && a.e(), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    this.b = SC(aJ, Nqe, 1, this.a.a.length, 5, 1);
}
function Uwc(a) {
    Twc();
    this.c = _u(WC(OC(Y0, 1), Nqe, 824, 0, [
        Iwc
    ]));
    this.b = new Irb;
    this.a = a;
    Qib(this.b, Rwc, 1);
    Llb(Swc, new Imd(this));
}
function Oqc() {
    Oqc = Zcb;
    Nqc = new Pqc(yve, 0);
    Jqc = new Pqc('FIRST', 1);
    Kqc = new Pqc(bwe, 2);
    Lqc = new Pqc('LAST', 3);
    Mqc = new Pqc(cwe, 4);
}
function omd() {
    omd = Zcb;
    nmd = new pmd(fze, 0);
    kmd = new pmd('GROUP_DEC', 1);
    mmd = new pmd('GROUP_MIXED', 2);
    lmd = new pmd('GROUP_INC', 3);
}
function l1c() {
    l1c = Zcb;
    j1c = new m1c('ASPECT_RATIO_DRIVEN', 0);
    k1c = new m1c('MAX_SCALE_DRIVEN', 1);
    i1c = new m1c('AREA_DRIVEN', 2);
}
function rGc(a, b, c, d, e) {
    var f, g, h;
    g = e;
    while(b.b != b.c){
        f = JD(jlb(b), 9);
        h = JD(lYb(f, d).Xb(0), 11);
        a.d[h.p] = g++;
        YCb(c.c, h);
    }
    return g;
}
function eBd(a) {
    var b, c, d, e, f;
    f = gBd(a);
    c = yqe(a.c);
    d = !c;
    if (d) {
        e = new EB;
        kC(f, 'knownLayouters', e);
        b = new pBd(e);
        ofb(a.c, b);
    }
    return f;
}
function GHb(a, b) {
    var c, d, e, f, g, h;
    d = 0;
    c = 0;
    for(f = b, g = 0, h = f.length; g < h; ++g){
        e = f[g];
        if (e > 0) {
            d += e;
            ++c;
        }
    }
    c > 1 && (d += a.d * (c - 1));
    return d;
}
function ECd(a) {
    var b, c, d;
    d = new Hgb;
    d.a += '[';
    for(b = 0, c = a.gc(); b < c;){
        Egb(d, xgb(a.Si(b)));
        ++b < c && (d.a += Lqe, d);
    }
    d.a += ']';
    return d.a;
}
function HNd(a, b, c) {
    var d, e;
    for(d = 0, e = a.length; d < e; d++){
        if (UNd((ADb(d, a.length), a.charCodeAt(d)), b, c)) return true;
    }
    return false;
}
function $Nd(a) {
    var b;
    if (a == null) return true;
    b = a.length;
    return b > 0 && (ADb(b - 1, a.length), a.charCodeAt(b - 1) == 58) && !HNd(a, vNd, wNd);
}
function Jhb(a, b) {
    var c;
    if (XD(a) === XD(b)) return true;
    if (RD(b, 90)) {
        c = JD(b, 90);
        return a.e == c.e && a.d == c.d && Khb(a, c.a);
    }
    return false;
}
function Wjd(a) {
    Rjd();
    switch(a.g){
        case 4:
            return xjd;
        case 1:
            return wjd;
        case 3:
            return Ojd;
        case 2:
            return Qjd;
        default:
            return Pjd;
    }
}
function Zzb(a) {
    var b, c;
    if (a.b) return a.b;
    c = Tzb ? null : a.d;
    while(c){
        b = Tzb ? null : c.b;
        if (b) return b;
        c = Tzb ? null : c.d;
    }
    return Gzb(), Fzb;
}
function s6b(a, b) {
    var c, d, e;
    d = p6b(a, b);
    e = d[d.length - 1] / 2;
    for(c = 0; c < d.length; c++){
        if (d[c] >= e) return b.c + c;
    }
    return b.c + b.b.gc();
}
function ILd(a, b) {
    GLd();
    var c, d, e, f;
    d = DUd(a);
    e = b;
    Nmb(d, 0, d.length, e);
    for(c = 0; c < d.length; c++){
        f = HLd(a, d[c], c);
        c != f && TGd(a, c, f);
    }
}
function WGb(a) {
    var b, c, d;
    d = Beb(MD(a.a.mf((Lgd(), tgd))));
    for(c = new rmb(a.a.Qf()); c.a < c.c.c.length;){
        b = JD(pmb(c), 680);
        ZGb(a, b, d);
    }
}
function eKb(a) {
    aKb();
    var b, c, d, e;
    b = a.o.b;
    for(d = JD(JD(Qc(a.r, (Rjd(), Ojd)), 22), 83).Jc(); d.Ob();){
        c = JD(d.Pb(), 115);
        e = c.e;
        e.b += b;
    }
}
function qBc(a, b, c) {
    var d, e;
    e = a.a.b;
    for(d = e.c.length; d < c; d++)Hlb(e, 0, new b$b(a.a));
    qYb(b, JD(Mlb(e, e.c.length - c), 25));
    a.b[b.p] = c;
}
function YQb(a, b) {
    var c, d;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 47);
        Ilb(a.b.b, JD(c.b, 82));
        qRb(JD(c.a, 194), JD(c.b, 82));
    }
}
function g9c(a, b) {
    var c;
    if (a.d) {
        if (Lib(a.b, b)) return JD(Nib(a.b, b), 44);
        else {
            c = b.bg();
            Qib(a.b, b, c);
            return c;
        }
    } else return b.bg();
}
function gDb(b) {
    var c = b.e;
    function d(a) {
        if (!a || a.length == 0) return '';
        return '\t' + a.join('\n\t');
    }
    return c && (c.stack || d(b[Sre]));
}
function dv(a) {
    var b, c;
    if (RD(a, 308)) {
        c = sm(JD(a, 308));
        b = c;
        return b;
    } else return RD(a, 429) ? JD(a, 429).a : RD(a, 59) ? new Bv(a) : new qv(a);
}
function HIc(a, b, c, d, e) {
    gIc();
    DFb(GFb(FFb(EFb(HFb(new IFb, 0), e.d.e - a), b), e.d));
    DFb(GFb(FFb(EFb(HFb(new IFb, 0), c - e.a.e), e.a), d));
}
function Syd(a, b) {
    var c, d, e, f;
    if (b) {
        e = Zxd(b, 'x');
        c = new PAd(a);
        qud(c.a, (tDb(e), e));
        f = Zxd(b, 'y');
        d = new VAd(a);
        rud(d.a, (tDb(f), f));
    }
}
function bzd(a, b) {
    var c, d, e, f;
    if (b) {
        e = Zxd(b, 'x');
        c = new ZAd(a);
        jud(c.a, (tDb(e), e));
        f = Zxd(b, 'y');
        d = new _Ad(a);
        kud(d.a, (tDb(f), f));
    }
}
function lfe(a, b) {
    var c, d, e, f;
    e = new Vlb(b.gc());
    for(d = b.Jc(); d.Ob();){
        c = d.Pb();
        f = kfe(a, JD(c, 57));
        !!f && YCb(e.c, f);
    }
    return e;
}
function ye(a, b, c) {
    var d, e;
    for(e = a.Jc(); e.Ob();){
        d = e.Pb();
        if (XD(b) === XD(d) || b != null && pb(b, d)) {
            c && e.Qb();
            return true;
        }
    }
    return false;
}
function wEd(a, b, c) {
    var d, e;
    ++a.j;
    if (c.dc()) return false;
    else {
        for(e = c.Jc(); e.Ob();){
            d = e.Pb();
            a.nj(b, a.Wi(b, d));
            ++b;
        }
        return true;
    }
}
function GA(a, b, c, d) {
    var e, f;
    f = c - b;
    if (f < 3) while(f < 3){
        a *= 10;
        ++f;
    }
    else {
        e = 1;
        while(f > 3){
            e *= 10;
            --f;
        }
        a = (a + (e >> 1)) / e | 0;
    }
    d.i = a;
    return true;
}
function gib(a) {
    var b, c, d;
    if (a.e == 0) return 0;
    b = a.d << 5;
    c = a.a[a.d - 1];
    if (a.e < 0) {
        d = Lhb(a);
        if (d == a.d - 1) {
            --c;
            c = c | 0;
        }
    }
    b -= efb(c);
    return b;
}
function bib(a) {
    var b, c, d;
    if (a < Ehb.length) return Ehb[a];
    c = a >> 5;
    b = a & 31;
    d = SC(cE, ise, 30, c + 1, 15, 1);
    d[c] = 1 << b;
    return new Vhb(1, c + 1, d);
}
function i_b(a) {
    var b, c, d;
    c = a.hh();
    if (c) {
        b = a.Ah();
        if (RD(b, 173)) {
            d = i_b(JD(b, 173));
            if (d != null) return d + '.' + c;
        }
        return c;
    }
    return null;
}
function eLb(a) {
    var b;
    !a.c && (a.c = new XKb);
    Slb(a.d, new lLb);
    bLb(a);
    b = WKb(a);
    EBb(new RBb(null, new Gvb(a.d, 16)), new ELb(a));
    return b;
}
function U_b(a, b) {
    b.Sg('End label post-processing', 1);
    EBb(BBb(DBb(new RBb(null, new Gvb(a.b, 16)), new Z_b), new __b), new b0b);
    b.Tg();
}
function bz(a) {
    var b, c, d, e;
    for(b = (a.j == null && (a.j = (Zz(), e = Yz.ke(a), _z(e))), a.j), c = 0, d = b.length; c < d; ++c)String.fromCharCode(10);
}
function mEd(a) {
    var b, c, d, e;
    b = new EB;
    for(e = new Fob(a.b.Jc()); e.b.Ob();){
        d = JD(e.b.Pb(), 685);
        c = kBd(d);
        CB(b, b.a.length, c);
    }
    return b.a;
}
function DGd(a, b) {
    var c, d;
    if (!b) return false;
    else {
        for(c = 0; c < a.i; ++c){
            d = JD(a.g[c], 370);
            if (d.jj(b)) return false;
        }
        return tCd(a, b);
    }
}
function atd(a, b) {
    switch(b){
        case 3:
            return a.f != 0;
        case 4:
            return a.g != 0;
        case 5:
            return a.i != 0;
        case 6:
            return a.j != 0;
    }
    return Lsd(a, b);
}
function ctd(a, b) {
    switch(b){
        case 3:
            etd(a, 0);
            return;
        case 4:
            gtd(a, 0);
            return;
        case 5:
            htd(a, 0);
            return;
        case 6:
            itd(a, 0);
            return;
    }
    Nsd(a, b);
}
function BYc(a) {
    switch(a.g){
        case 0:
            return new G_c;
        case 1:
            return new Q_c;
        default:
            throw scb(new Teb($ve + (a.f != null ? a.f : '' + a.g)));
    }
}
function a$c(a) {
    switch(a.g){
        case 0:
            return new J_c;
        case 1:
            return new M_c;
        default:
            throw scb(new Teb(hAe + (a.f != null ? a.f : '' + a.g)));
    }
}
function k$c(a) {
    switch(a.g){
        case 1:
            return new IZc;
        case 2:
            return new AZc;
        default:
            throw scb(new Teb(hAe + (a.f != null ? a.f : '' + a.g)));
    }
}
function B7c(a) {
    switch(a.g){
        case 0:
            return new S7c;
        case 1:
            return new W7c;
        default:
            throw scb(new Teb(bBe + (a.f != null ? a.f : '' + a.g)));
    }
}
function wm(a) {
    qm();
    var b;
    b = a.Nc();
    switch(b.length){
        case 0:
            return pm;
        case 1:
            return new vy(Qb(b[0]));
        default:
            return new Gx(Fm(b));
    }
}
function mYb(a, b) {
    switch(b.g){
        case 1:
            return _q(a.j, (VYb(), QYb));
        case 2:
            return _q(a.j, (VYb(), SYb));
        default:
            return pnb(), pnb(), mnb;
    }
}
function QBb(a, b) {
    var c;
    c = JD(yBb(a, hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    return c.Oc(cWc(c.gc()));
}
function qRc(a, b) {
    var c, d;
    d = new nzb(a.a.$c(b, true));
    if (d.a.gc() <= 1) throw scb(new Efb);
    c = d.a.ec().Jc();
    c.Pb();
    return JD(c.Pb(), 39);
}
function WTd(a, b) {
    var c, d, e;
    c = (a.i == null && MTd(a), a.i);
    d = b.Ij();
    if (d != -1) for(e = c.length; d < e; ++d){
        if (c[d] == b) return d;
    }
    return -1;
}
function nJd(a, b) {
    var c, d, e;
    if (a.f > 0) {
        a.Yj();
        d = b == null ? 0 : tb(b);
        e = (d & Hqe) % a.d.length;
        c = uJd(a, e, d, b);
        return c != -1;
    } else return false;
}
function uDd(a, b) {
    var c;
    if (a.i > 0) {
        if (b.length < a.i) {
            c = fId(rb(b).c, a.i);
            b = c;
        }
        $gb(a.g, 0, b, 0, a.i);
    }
    b.length > a.i && VC(b, a.i, null);
    return b;
}
function fTd(a) {
    var b;
    if ((a.Db & 64) != 0) return svd(a);
    b = new Jgb(svd(a));
    b.a += ' (instanceClassName: ';
    Egb(b, a.D);
    b.a += ')';
    return b.a;
}
function A6b(a) {
    var b, c;
    b = a.d == (Nmc(), Imc);
    c = w6b(a);
    b && !c || !b && c ? ZMb(a.a, (Bwc(), Rtc), (ced(), aed)) : ZMb(a.a, (Bwc(), Rtc), (ced(), _dd));
}
function S9c(a) {
    P9c();
    if (JD(a.mf((Lgd(), Gfd)), 181).Gc((Nkd(), Lkd))) {
        JD(a.mf(agd), 181).Ec((ojd(), njd));
        JD(a.mf(Gfd), 181).Kc(Lkd);
    }
}
function Twc() {
    Twc = Zcb;
    Jwc();
    Rwc = (Bwc(), ewc);
    Swc = _u(WC(OC(N4, 1), dze, 144, 0, [
        Vvc,
        Wvc,
        Yvc,
        Zvc,
        awc,
        bwc,
        cwc,
        dwc,
        gwc,
        iwc,
        Xvc,
        $vc,
        fwc
    ]));
}
function mWd(a) {
    var b, c, d, e, f;
    c = JD(a.g, 674);
    for(d = a.i - 1; d >= 0; --d){
        b = c[d];
        for(e = 0; e < d; ++e){
            f = c[e];
            if (nWd(a, b, f)) {
                qDd(a, d);
                break;
            }
        }
    }
}
function Kbe(a, b) {
    var c, d, e, f;
    f = Kfe(a.e.zh(), b);
    c = JD(a.g, 122);
    for(e = 0; e < a.i; ++e){
        d = c[e];
        if (f.Zl(d.Ik())) return false;
    }
    return true;
}
function oKc(a, b, c) {
    var d, e;
    d = Beb(a.p[b.i.p]) + Beb(a.d[b.i.p]) + b.n.b + b.a.b;
    e = Beb(a.p[c.i.p]) + Beb(a.d[c.i.p]) + c.n.b + c.a.b;
    return e - d;
}
function wib(a, b, c) {
    var d, e;
    d = ucb(c, Use);
    for(e = 0; vcb(d, 0) != 0 && e < b; e++){
        d = tcb(d, ucb(a[e], Use));
        a[e] = Pcb(d);
        d = Kcb(d, 32);
    }
    return Pcb(d);
}
function TNd(a) {
    var b, c, d, e;
    e = 0;
    for(c = 0, d = a.length; c < d; c++){
        b = (ADb(c, a.length), a.charCodeAt(c));
        b < 64 && (e = Icb(e, Jcb(1, b)));
    }
    return e;
}
function PGd(a, b, c) {
    var d, e, f;
    if (a.Mj()) {
        d = a.i;
        f = a.Nj();
        hDd(a, d, b);
        e = a.Fj(3, null, b, d, f);
        !c ? c = e : c.kj(e);
    } else hDd(a, a.i, b);
    return c;
}
function zVd(a, b, c) {
    var d, e;
    d = new i_d(a.e, 3, 10, null, (e = b.c, RD(e, 88) ? JD(e, 29) : (cPd(), UOd)), AUd(a, b), false);
    !c ? c = d : c.kj(d);
    return c;
}
function AVd(a, b, c) {
    var d, e;
    d = new i_d(a.e, 4, 10, (e = b.c, RD(e, 88) ? JD(e, 29) : (cPd(), UOd)), null, AUd(a, b), false);
    !c ? c = d : c.kj(d);
    return c;
}
function bKb(a) {
    aKb();
    var b;
    b = new Fdd(JD(a.e.mf((Lgd(), Efd)), 8));
    if (a.B.Gc((Nkd(), Gkd))) {
        b.a <= 0 && (b.a = 20);
        b.b <= 0 && (b.b = 20);
    }
    return b;
}
function QA(a, b) {
    OA();
    var c, d;
    c = TA((SA(), SA(), RA));
    d = null;
    b == c && (d = JD(Oib(NA, a), 609));
    if (!d) {
        d = new PA(a);
        b == c && Rib(NA, a, d);
    }
    return d;
}
function Cxc(a) {
    zxc();
    var b;
    (!a.q ? (pnb(), pnb(), nnb) : a.q)._b((Bwc(), lvc)) ? b = JD(WMb(a, lvc), 203) : b = JD(WMb(gYb(a), mvc), 203);
    return b;
}
function aib(a) {
    Ghb();
    var b, c;
    c = Pcb(a);
    b = Pcb(Lcb(a, 32));
    if (b != 0) return new Uhb(c, b);
    if (c > 10 || c < 0) return new Thb(1, c);
    return Chb[c];
}
function xJd(a, b) {
    var c, d, e;
    if (a.f > 0) {
        a.Yj();
        d = b == null ? 0 : tb(b);
        e = (d & Hqe) % a.d.length;
        c = tJd(a, e, d, b);
        if (c) return c.kd();
    }
    return null;
}
function Xe(a, b) {
    var c, d, e;
    if (RD(b, 43)) {
        c = JD(b, 43);
        d = c.jd();
        e = Tv(a.Pc(), d);
        return Hb(e, c.kd()) && (e != null || a.Pc()._b(d));
    }
    return false;
}
function tfe(a) {
    if (a.b == null) {
        while(a.a.Ob()){
            a.b = a.a.Pb();
            if (!JD(a.b, 52).Fh()) return true;
        }
        a.b = null;
        return false;
    } else return true;
}
function HHb(a, b, c) {
    vHb();
    qHb.call(this);
    this.a = QC(gN, [
        hre,
        $te
    ], [
        587,
        215
    ], 0, [
        uHb,
        tHb
    ], 2);
    this.c = new fdd;
    this.g = a;
    this.f = b;
    this.d = c;
}
function UFc(a) {
    this.e = SC(cE, ise, 30, a.length, 15, 1);
    this.c = SC(pcb, Vte, 30, a.length, 16, 1);
    this.b = SC(pcb, Vte, 30, a.length, 16, 1);
    this.f = 0;
}
function cCc(a) {
    var b, c;
    a.j = SC(aE, Rse, 30, a.p.c.length, 15, 1);
    for(c = new rmb(a.p); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        a.j[b.p] = b.o.b / a.i;
    }
}
function K0b(a) {
    var b, c, d, e;
    d = F0b(a);
    Slb(d, D0b);
    e = a.d;
    e.c.length = 0;
    for(c = new rmb(d); c.a < c.c.c.length;){
        b = JD(pmb(c), 452);
        Klb(e, b.b);
    }
}
function Jne(a, b) {
    var c, d;
    d = b.length;
    for(c = 0; c < d; c += 2)Moe(a, (ADb(c, b.length), b.charCodeAt(c)), (ADb(c + 1, b.length), b.charCodeAt(c + 1)));
}
function Cqb(a, b) {
    var c, d;
    a.a = tcb(a.a, 1);
    a.c = $wnd.Math.min(a.c, b);
    a.b = $wnd.Math.max(a.b, b);
    a.d += b;
    c = b - a.f;
    d = a.e + c;
    a.f = d - a.e - c;
    a.e = d;
}
function K0c(a, b) {
    b.Sg('Min Size Postprocessing', 1);
    msd(a, (h1c(), g1c), $wnd.Math.max(Beb(MD(ksd(a, g1c))), Beb(MD(ksd(a, e1c)))));
    b.Tg();
}
function JHd(b, c) {
    b.Uj();
    try {
        b.d._c(b.e++, c);
        b.f = b.d.j;
        b.g = -1;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) throw scb(new yqb);
        else throw scb(a);
    }
}
function v3d() {
    v3d = Zcb;
    t3d = new w3d;
    m3d = new z3d;
    n3d = new C3d;
    o3d = new F3d;
    p3d = new I3d;
    q3d = new L3d;
    r3d = new O3d;
    s3d = new R3d;
    u3d = new U3d;
}
function ekd() {
    ekd = Zcb;
    bkd = new MYb(15);
    akd = new NBd((Lgd(), Kfd), bkd);
    dkd = new NBd(wgd, 15);
    ckd = new NBd(hgd, jfb(0));
    _jd = new NBd(Qed, Jue);
}
function dA() {
    if (Error.stackTraceLimit > 0) {
        $wnd.Error.stackTraceLimit = Error.stackTraceLimit = 64;
        return true;
    }
    return 'stack' in new Error;
}
function Ecb(a, b) {
    var c;
    if (Ccb(a) && Ccb(b)) {
        c = a % b;
        if (Fse < c && c < Dse) return c;
    }
    return wcb((aD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b, true), YC));
}
function S1b(a, b) {
    var c;
    P1b(b);
    c = JD(WMb(a, (Bwc(), xuc)), 281);
    !!c && ZMb(a, xuc, eoc(c));
    Q1b(a.c);
    Q1b(a.f);
    R1b(a.d);
    R1b(JD(WMb(a, fvc), 213));
}
function kzc(a, b) {
    var c, d;
    d = null;
    if (XMb(a, (Bwc(), _vc))) {
        c = JD(WMb(a, _vc), 102);
        c.nf(b) && (d = c.mf(b));
    }
    d == null && (d = WMb(gYb(a), b));
    return d;
}
function OVc(a, b) {
    var c, d, e, f;
    f = b.b.b;
    a.a = new Mtb;
    a.b = SC(cE, ise, 30, f, 15, 1);
    c = 0;
    for(e = Gtb(b.b, 0); e.b != e.d.c;){
        d = JD(Utb(e), 39);
        d.g = c++;
    }
}
function v4c(a, b, c) {
    var d, e, f, g;
    f = b - a.e;
    g = c - a.f;
    for(e = new rmb(a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 172);
        i4c(d, d.s + f, d.t + g);
    }
    a.e = b;
    a.f = c;
}
function czc(a, b, c) {
    var d, e, f, g, h;
    g = a.k;
    h = b.k;
    d = c[g.g][h.g];
    e = MD(kzc(a, d));
    f = MD(kzc(b, d));
    return $wnd.Math.max((tDb(e), e), (tDb(f), f));
}
function Goe(a, b, c) {
    var d, e;
    d = JD(Oib(Rne, b), 121);
    e = JD(Oib(Sne, b), 121);
    if (c) {
        Rib(Rne, a, d);
        Rib(Sne, a, e);
    } else {
        Rib(Sne, a, d);
        Rib(Rne, a, e);
    }
}
function hib(a, b) {
    var c, d, e, f;
    c = b >> 5;
    b &= 31;
    e = a.d + c + (b == 0 ? 0 : 1);
    d = SC(cE, ise, 30, e, 15, 1);
    iib(d, a.a, c, b);
    f = new Vhb(a.e, e, d);
    Ihb(f);
    return f;
}
function Dxb(a, b, c) {
    var d, e, f;
    e = null;
    f = a.b;
    while(f){
        d = a.a.Le(b, f.d);
        if (c && d == 0) return f;
        if (d >= 0) f = f.a[1];
        else {
            e = f;
            f = f.a[0];
        }
    }
    return e;
}
function Exb(a, b, c) {
    var d, e, f;
    e = null;
    f = a.b;
    while(f){
        d = a.a.Le(b, f.d);
        if (c && d == 0) return f;
        if (d <= 0) f = f.a[0];
        else {
            e = f;
            f = f.a[1];
        }
    }
    return e;
}
function Qfc(a, b, c, d) {
    var e, f, g;
    e = false;
    if (igc(a.f, c, d)) {
        lgc(a.f, a.a[b][c], a.a[b][d]);
        f = a.a[b];
        g = f[d];
        f[d] = f[c];
        f[c] = g;
        e = true;
    }
    return e;
}
function kkc(a, b, c) {
    var d, e, f, g;
    e = JD(Nib(a.b, c), 183);
    d = 0;
    for(g = new rmb(b.j); g.a < g.c.c.length;){
        f = JD(pmb(g), 112);
        e[f.d.p] && ++d;
    }
    return d;
}
function veb(a, b) {
    var c = 0;
    while(!b[c] || b[c] == '')c++;
    var d = b[c++];
    for(; c < b.length; c++){
        if (!b[c] || b[c] == '') continue;
        d += a + b[c];
    }
    return d;
}
function rEb(a, b) {
    return Ry(), Ry(), Vy(Kre), ($wnd.Math.abs(a - b) <= Kre || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : Wy(isNaN(a), isNaN(b))) > 0;
}
function tEb(a, b) {
    return Ry(), Ry(), Vy(Kre), ($wnd.Math.abs(a - b) <= Kre || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : Wy(isNaN(a), isNaN(b))) < 0;
}
function sEb(a, b) {
    return Ry(), Ry(), Vy(Kre), ($wnd.Math.abs(a - b) <= Kre || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : Wy(isNaN(a), isNaN(b))) <= 0;
}
function I6b(a) {
    var b;
    b = a.a;
    do {
        b = JD(ds(new es(Ir(kYb(b).a.Jc(), new er))), 18).d.i;
        b.k == (DYb(), yYb) && Ilb(a.e, b);
    }while (b.k == (DYb(), yYb));
}
function CAc(a, b) {
    var c, d, e;
    for(d = new es(Ir(kYb(a).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        e = c.d.i;
        if (e.c == b) return false;
    }
    return true;
}
function jId(a) {
    var b, c;
    b = JD(Crd(a.a, 4), 128);
    if (b != null) {
        c = SC(X4, JEe, 412, b.length, 0, 1);
        $gb(b, 0, c, 0, b.length);
        return c;
    } else return gId;
}
function Fie(a) {
    var b, c, d, e, f;
    if (a == null) return null;
    f = new Ulb;
    for(c = _ud(a), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        Ilb(f, Ipe(b, true));
    }
    return f;
}
function Iie(a) {
    var b, c, d, e, f;
    if (a == null) return null;
    f = new Ulb;
    for(c = _ud(a), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        Ilb(f, Ipe(b, true));
    }
    return f;
}
function Jie(a) {
    var b, c, d, e, f;
    if (a == null) return null;
    f = new Ulb;
    for(c = _ud(a), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        Ilb(f, Ipe(b, true));
    }
    return f;
}
function zgb(a, b, c) {
    var d, e, f, g;
    f = b + c;
    zDb(b, f, a.length);
    g = '';
    for(e = b; e < f;){
        d = $wnd.Math.min(e + 10000, f);
        g += vgb(a.slice(e, d));
        e = d;
    }
    return g;
}
function Bfc(a) {
    var b;
    if (a.c == 0) return;
    b = JD(Mlb(a.a, a.b), 292);
    b.b == 1 ? (++a.b, a.b < a.a.c.length && Ffc(JD(Mlb(a.a, a.b), 292))) : --b.b;
    --a.c;
}
function i0c() {
    i0c = Zcb;
    f0c = new j0c('P1_WIDTH_APPROXIMATION', 0);
    g0c = new j0c('P2_PACKING', 1);
    h0c = new j0c('P3_WHITESPACE_ELIMINATION', 2);
}
function nyc() {
    nyc = Zcb;
    kyc = new oyc(yve, 0);
    jyc = new oyc('NODES_AND_EDGES', 1);
    lyc = new oyc('PREFER_EDGES', 2);
    myc = new oyc('PREFER_NODES', 3);
}
function ykd() {
    ykd = Zcb;
    wkd = new zkd('PORTS', 0);
    xkd = new zkd('PORT_LABELS', 1);
    vkd = new zkd('NODE_LABELS', 2);
    ukd = new zkd('MINIMUM_SIZE', 3);
}
function znc() {
    znc = Zcb;
    vnc = new Bnc(pwe, 0);
    unc = new Bnc(qwe, 1);
    xnc = new Bnc(owe, 2);
    ync = new Bnc(zve, 3);
    wnc = new Bnc('GREEDY_MODEL_ORDER', 4);
}
function uJb(a) {
    switch(a.g){
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
            return true;
        default:
            return false;
    }
}
function C4c(a, b, c, d, e, f) {
    this.a = a;
    this.c = b;
    this.b = c;
    this.f = d;
    this.d = e;
    this.e = f;
    this.c > 0 && this.b > 0 && (this.g = Q4c(this.c, this.b, this.a));
}
function jC(f, a) {
    var b = f.a;
    var c;
    a = String(a);
    b.hasOwnProperty(a) && (c = b[a]);
    var d = (zC(), yC)[typeof c];
    var e = d ? d(c) : FC(typeof c);
    return e;
}
function Yxd(a) {
    var b, c, d;
    d = null;
    b = vDe in a.a;
    c = !b;
    if (c) throw scb(new eyd('Every element must have an id.'));
    d = Xxd(iC(a, vDe));
    return d;
}
function jme(a) {
    var b, c;
    c = kme(a);
    b = null;
    while(a.c == 2){
        fme(a);
        if (!b) {
            b = (ooe(), ooe(), ++noe, new Dpe(2));
            Cpe(b, c);
            c = b;
        }
        c.Gm(kme(a));
    }
    return c;
}
function IJd(a, b) {
    var c, d, e;
    a.Yj();
    d = b == null ? 0 : tb(b);
    e = (d & Hqe) % a.d.length;
    c = tJd(a, e, d, b);
    if (c) {
        GJd(a, c);
        return c.kd();
    } else return null;
}
function emd(a, b) {
    var c, d, e;
    if (a.c) gtd(a.c, b);
    else {
        c = b - cmd(a);
        for(e = new rmb(a.d); e.a < e.c.c.length;){
            d = JD(pmb(e), 162);
            emd(d, cmd(d) + c);
        }
    }
}
function dmd(a, b) {
    var c, d, e;
    if (a.c) etd(a.c, b);
    else {
        c = b - bmd(a);
        for(e = new rmb(a.a); e.a < e.c.c.length;){
            d = JD(pmb(e), 162);
            dmd(d, bmd(d) + c);
        }
    }
}
function wNc(a, b, c, d) {
    var e, f;
    if (b.c.length == 0) return;
    e = sNc(c, d);
    f = rNc(b);
    EBb(OBb(new RBb(null, new Gvb(f, 1)), new FNc), new JNc(a, c, e, d));
}
function XBc(a, b) {
    if (b.c == a) return b.d;
    else if (b.d == a) return b.c;
    throw scb(new Teb('Input edge is not connected to the input port.'));
}
function Hhb(a, b) {
    if (a.e > b.e) return 1;
    if (a.e < b.e) return -1;
    if (a.d > b.d) return a.e;
    if (a.d < b.d) return -b.e;
    return a.e * vib(a.a, b.a, a.d);
}
function Wdb(a) {
    if (a >= 48 && a < 48 + $wnd.Math.min(10, 10)) return a - 48;
    if (a >= 97 && a < 97) return a - 97 + 10;
    if (a >= 65 && a < 65) return a - 65 + 10;
    return -1;
}
function B9c(a, b) {
    if (a.a < 0) throw scb(new Web('Did not call before(...) or after(...) before calling add(...).'));
    I9c(a, a.a, b);
    return a;
}
function cEd(a) {
    bEd();
    if (RD(a, 161)) return JD(Nib(_Dd, qK), 293).Pg(a);
    if (Lib(_Dd, rb(a))) return JD(Nib(_Dd, rb(a)), 293).Pg(a);
    return null;
}
function Ard(a) {
    var b, c;
    if ((a.Db & 32) == 0) {
        c = (b = JD(Crd(a, 16), 29), VTd(!b ? a.ei() : b) - VTd(a.ei()));
        c != 0 && Erd(a, 32, SC(aJ, Nqe, 1, c, 5, 1));
    }
    return a;
}
function Erd(a, b, c) {
    var d;
    if ((a.Db & b) != 0) {
        if (c == null) Drd(a, b);
        else {
            d = Brd(a, b);
            d == -1 ? a.Eb = c : VC(KD(a.Eb), d, c);
        }
    } else c != null && xrd(a, b, c);
}
function yfb(a) {
    var b, c;
    if (vcb(a, -129) > 0 && vcb(a, 128) < 0) return Afb(), b = Pcb(a) + 128, c = zfb[b], !c && (c = zfb[b] = new qfb(a)), c;
    return new qfb(a);
}
function Se(a, b) {
    var c;
    if (XD(b) === XD(a)) return true;
    if (!RD(b, 22)) return false;
    c = JD(b, 22);
    if (c.gc() != a.gc()) return false;
    return a.Hc(c);
}
function lqd(a) {
    var b, c, d;
    d = a.Fh();
    if (!d) {
        b = 0;
        for(c = a.Lh(); c; c = c.Lh()){
            if (++b > Sse) return c.Mh();
            d = c.Fh();
            if (!!d || c == a) break;
        }
    }
    return d;
}
function ilb(a, b) {
    var c, d, e, f;
    d = a.a.length - 1;
    c = b - a.b & d;
    f = a.c - b & d;
    e = a.c - a.b & d;
    qlb(c < e);
    if (c >= f) {
        llb(a, b);
        return -1;
    } else {
        mlb(a, b);
        return 1;
    }
}
function Y_d(a, b, c) {
    var d, e, f;
    d = JD(nDd(J_d(a.a), b), 87);
    f = (e = d.c, e ? e : (cPd(), ROd));
    (f.Rh() ? zqd(a.b, JD(f, 52)) : f) == c ? DZd(d) : GZd(d, c);
    return f;
}
function iDb(a) {
    switch(typeof a){
        case Fqe:
            return fgb(a);
        case Eqe:
            return Eeb(a);
        case Dqe:
            return Adb(a);
        default:
            return a == null ? 0 : jDb(a);
    }
}
function nHc(a, b) {
    if (a.e < b.e) return -1;
    else if (a.e > b.e) return 1;
    else if (a.f < b.f) return -1;
    else if (a.f > b.f) return 1;
    return tb(a) - tb(b);
}
function dgb(a, b) {
    tDb(a);
    if (b == null) return false;
    if (cgb(a, b)) return true;
    return a.length == b.length && cgb(a.toLowerCase(), b.toLowerCase());
}
function $5d(a) {
    if (dgb(CBe, a)) return xdb(), wdb;
    else if (dgb(DBe, a)) return xdb(), vdb;
    else throw scb(new Teb('Expecting true or false'));
}
function cUb() {
    cUb = Zcb;
    bUb = new dUb(yve, 0);
    _Tb = new dUb('INSIDE_PORT_SIDE_GROUPS', 1);
    $Tb = new dUb('GROUP_MODEL_ORDER', 2);
    aUb = new dUb(zve, 3);
}
function Pae(a) {
    var b;
    a.b || Qae(a, (b = aae(a.e, a.a), !b || !cgb(DBe, xJd((!b.b && (b.b = new lRd((cPd(), $Od), u7, b)), b.b), 'qualified'))));
    return a.c;
}
function tA(a, b) {
    var c, d;
    c = (ADb(b, a.length), a.charCodeAt(b));
    d = b + 1;
    while(d < a.length && (ADb(d, a.length), a.charCodeAt(d) == c))++d;
    return d - b;
}
function cDb(a, b) {
    (!b && console.groupCollapsed != null ? console.groupCollapsed : console.group != null ? console.group : console.log).call(console, a);
}
function OLb(a, b, c, d) {
    d == a ? (JD(c.b, 68), JD(c.b, 68), JD(d.b, 68), JD(d.b, 68).c.b) : (JD(c.b, 68), JD(c.b, 68), JD(d.b, 68), JD(d.b, 68).c.b);
    LLb(d, b, a);
}
function Bjc(a, b, c) {
    b.b = $wnd.Math.max(b.b, -c.a);
    b.c = $wnd.Math.max(b.c, c.a - a.a);
    b.d = $wnd.Math.max(b.d, -c.b);
    b.a = $wnd.Math.max(b.a, c.b - a.b);
}
function TQb(a, b, c) {
    this.c = a;
    this.f = new Ulb;
    this.e = new Cdd;
    this.j = new URb;
    this.n = new URb;
    this.b = b;
    this.g = new gdd(b.c, b.d, b.b, b.a);
    this.a = c;
}
function sRb(a) {
    var b, c, d, e;
    this.a = new wtb;
    this.d = new Qrb;
    this.e = 0;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !this.f && (this.f = b);
        qRb(this, b);
    }
}
function Whb(a) {
    Ghb();
    if (a.length == 0) {
        this.e = 0;
        this.d = 1;
        this.a = WC(OC(cE, 1), ise, 30, 15, [
            0
        ]);
    } else {
        this.e = 1;
        this.d = a.length;
        this.a = a;
        Ihb(this);
    }
}
function M8b(a) {
    var b, c, d, e, f, g;
    g = JD(WMb(a, (Iqc(), kqc)), 11);
    ZMb(g, Cqc, a.i.n.b);
    b = CXb(a.e);
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        hWb(c, g);
    }
}
function N8b(a) {
    var b, c, d, e, f, g;
    c = JD(WMb(a, (Iqc(), kqc)), 11);
    ZMb(c, Cqc, a.i.n.b);
    b = CXb(a.g);
    for(e = b, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        gWb(d, c);
    }
}
function pDc(a, b, c) {
    var d, e, f;
    d = b.c.p;
    f = b.p;
    a.b[d][f] = new BDc(a, b);
    if (c) {
        a.a[d][f] = new gDc(b);
        e = JD(WMb(b, (Iqc(), _pc)), 9);
        !!e && Rc(a.d, e, b);
    }
}
function P7c(a, b, c) {
    var d, e, f;
    for(f = new rmb(c.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 224);
        d = new ZDb(JD(Nib(a.a, e.b), 68));
        Ilb(b.a, d);
        P7c(a, d, e);
    }
}
function gLc(a, b) {
    ZKc();
    var c, d;
    for(d = new es(Ir(eYb(a).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        if (c.d.i == b || c.c.i == b) return c;
    }
    return null;
}
function U9d(a, b) {
    var c, d;
    c = b.mi(a.a);
    if (c) {
        d = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), HDe));
        if (d != null) return d;
    }
    return b.ve();
}
function V9d(a, b) {
    var c, d;
    c = b.mi(a.a);
    if (c) {
        d = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), HDe));
        if (d != null) return d;
    }
    return b.ve();
}
function N0b(a, b) {
    var c, d;
    c = $eb(a.a.c.p, b.a.c.p);
    if (c != 0) return c;
    d = $eb(a.a.d.i.p, b.a.d.i.p);
    if (d != 0) return d;
    return $eb(b.a.d.p, a.a.d.p);
}
function pfe(a, b) {
    var c, d, e, f;
    for(d = 0, e = b.gc(); d < e; ++d){
        c = b.Ql(d);
        if (RD(c, 101) && (JD(c, 19).Bb & RCe) != 0) {
            f = b.Rl(d);
            f != null && kfe(a, JD(f, 57));
        }
    }
}
function Kz() {
    var a;
    if (Fz != 0) {
        a = Date.now();
        if (a - Gz > 2000) {
            Gz = a;
            Hz = $wnd.setTimeout(Qz, 10);
        }
    }
    if (Fz++ == 0) {
        Tz((Sz(), Rz));
        return true;
    }
    return false;
}
function _zb(a, b, c) {
    var d;
    (Rzb ? (Zzb(a), true) : Szb ? (Gzb(), true) : Vzb ? (Gzb(), true) : Uzb && (Gzb(), false)) && (d = new Qzb(b), d.b = c, Xzb(a, d), undefined);
}
function oIb(a, b, c) {
    qHb.call(this);
    this.a = SC(gN, $te, 215, (iHb(), WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ])).length, 0, 1);
    this.b = a;
    this.d = b;
    this.c = c;
}
function Ngc(a) {
    this.d = new Ulb;
    this.e = new Xsb;
    this.c = SC(cE, ise, 30, (Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])).length, 15, 1);
    this.b = a;
}
function ygc(a) {
    var b;
    this.d = new Ulb;
    this.j = new Cdd;
    this.g = new Cdd;
    b = a.g.b;
    this.f = JD(WMb(gYb(b), (Bwc(), ruc)), 86);
    this.e = Beb(MD(uXb(b, awc)));
}
function zKb(a, b) {
    var c;
    c = !a.A.Gc((ykd(), xkd)) || a.q == (ajd(), Xid);
    a.u.Gc((ojd(), kjd)) ? c ? xKb(a, b) : BKb(a, b) : a.u.Gc(mjd) && (c ? yKb(a, b) : CKb(a, b));
}
function Q8c(a) {
    var b;
    if (XD(ksd(a, (Lgd(), ifd))) === XD((eid(), cid))) {
        if (!Zwd(a)) msd(a, ifd, did);
        else {
            b = JD(ksd(Zwd(a), ifd), 342);
            msd(a, ifd, b);
        }
    }
}
function lgc(a, b, c) {
    var d, e;
    EGc(a.e, b, c, (Rjd(), Qjd));
    EGc(a.i, b, c, wjd);
    if (a.a) {
        e = JD(WMb(b, (Iqc(), kqc)), 11);
        d = JD(WMb(c, kqc), 11);
        FGc(a.g, e, d);
    }
}
function n9b(a) {
    var b, c;
    if (XMb(a.d.i, (Bwc(), wvc))) {
        b = JD(WMb(a.c.i, wvc), 17);
        c = JD(WMb(a.d.i, wvc), 17);
        return $eb(b.a, c.a) > 0;
    } else return false;
}
function qUb(a, b, c) {
    return new gdd($wnd.Math.min(a.a, b.a) - c / 2, $wnd.Math.min(a.b, b.b) - c / 2, $wnd.Math.abs(a.a - b.a) + c, $wnd.Math.abs(a.b - b.b) + c);
}
function xjc(a, b, c) {
    var d;
    d = c[a.g][b];
    switch(a.g){
        case 1:
        case 3:
            return new Edd(0, d);
        case 2:
        case 4:
            return new Edd(d, 0);
        default:
            return null;
    }
}
function oyd(a, b) {
    var c;
    c = wo(a.o, b);
    if (c == null) throw scb(new eyd('Node did not exist in input.'));
    ezd(a, b);
    dzd(a, b);
    ozd(a, b, c);
    return null;
}
function W8d(a, b) {
    var c, d;
    ++a.j;
    if (b != null) {
        c = (d = a.a.Cb, RD(d, 98) ? JD(d, 98).ph() : null);
        if (Amb(b, c)) {
            Erd(a.a, 4, c);
            return;
        }
    }
    Erd(a.a, 4, JD(b, 128));
}
function CCc(a, b, c) {
    var d, e, f, g;
    f = b.j;
    g = c.j;
    if (f != g) return f.g - g.g;
    else {
        d = a.f[b.p];
        e = a.f[c.p];
        return d == 0 && e == 0 ? 0 : d == 0 ? -1 : e == 0 ? 1 : Heb(d, e);
    }
}
function KFb(a, b, c) {
    var d, e, f;
    if (c[b.d]) return;
    c[b.d] = true;
    for(e = new rmb(OFb(b)); e.a < e.c.c.length;){
        d = JD(pmb(e), 216);
        f = AFb(d, b);
        KFb(a, f, c);
    }
}
function cmc(a, b) {
    var c, d, e, f;
    c = 0;
    for(e = new rmb(b.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        f = d.o.a + d.d.c + d.d.b + a.j;
        c = $wnd.Math.max(c, f);
    }
    return c;
}
function cnb(a, b) {
    var c, d;
    d = a.a.length;
    b.length < d && (b = bDb(new Array(d), b));
    for(c = 0; c < d; ++c)VC(b, c, a.a[c]);
    b.length > d && VC(b, d, null);
    return b;
}
function Tlb(a, b) {
    var c, d;
    d = a.c.length;
    b.length < d && (b = bDb(new Array(d), b));
    for(c = 0; c < d; ++c)VC(b, c, a.c[c]);
    b.length > d && VC(b, d, null);
    return b;
}
function NNd(a, b, c, d) {
    var e;
    e = a.length;
    if (b >= e) return e;
    for(b = b > 0 ? b : 0; b < e; b++){
        if (UNd((ADb(b, a.length), a.charCodeAt(b)), c, d)) break;
    }
    return b;
}
function M0d(a, b, c, d) {
    var e, f, g;
    e = new i_d(a.e, 1, 13, (g = b.c, g ? g : (cPd(), ROd)), (f = c.c, f ? f : (cPd(), ROd)), AUd(a, b), false);
    !d ? d = e : d.kj(e);
    return d;
}
function jzd(a, b, c) {
    var d, e, f, g, h, i;
    d = null;
    h = Kad(Nad(), b);
    f = null;
    if (h) {
        e = null;
        i = Obd(h, c);
        g = null;
        i != null && (g = a.of(h, i));
        e = g;
        f = e;
    }
    d = f;
    return d;
}
function Usb(a, b, c) {
    var d, e, f;
    e = JD(Nib(a.e, b), 391);
    if (!e) {
        d = new itb(a, b, c);
        Qib(a.e, b, d);
        ftb(d);
        return null;
    } else {
        f = hkb(e, c);
        Vsb(a, e);
        return f;
    }
}
function pyd(a, b) {
    var c;
    c = Nib(a.q, b);
    if (c == null) throw scb(new eyd('Port did not exist in input.'));
    ezd(a, b);
    dzd(a, b);
    ozd(a, b, c);
    return null;
}
function R8c(b, c, d) {
    var e, f;
    f = JD(Vnd(c.f), 222);
    try {
        f.kf(b, d);
        Wnd(c.f, f);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            e = a;
            throw scb(e);
        } else throw scb(a);
    }
}
function Hie(a) {
    var b;
    if (a == null) return null;
    b = ame(Ipe(a, true));
    if (b == null) throw scb(new fhe("Invalid hexBinary value: '" + a + "'"));
    return b;
}
function oA(a, b, c) {
    var d;
    if (b.a.length > 0) {
        Ilb(a.b, new cB(b.a, c));
        d = b.a.length;
        0 < d ? b.a = qgb(b.a, 0, 0) : 0 > d && (b.a += ygb(SC(_D, Ure, 30, -d, 15, 1)));
    }
}
function yJb() {
    sJb();
    return WC(OC(vN, 1), Ere, 166, 0, [
        pJb,
        oJb,
        qJb,
        gJb,
        fJb,
        hJb,
        kJb,
        jJb,
        iJb,
        nJb,
        mJb,
        lJb,
        dJb,
        cJb,
        eJb,
        aJb,
        _Ib,
        bJb,
        ZIb,
        YIb,
        $Ib,
        rJb
    ]);
}
function mQc(a) {
    switch(a.g){
        case 4:
            return new Edd(0, -1);
        case 1:
            return new Edd(1, 0);
        case 2:
            return new Edd(-1, 0);
        default:
            return new Edd(0, 1);
    }
}
function pUb(a) {
    switch(a.g){
        case 1:
            return Tgd(), Sgd;
        case 4:
            return Tgd(), Pgd;
        case 2:
            return Tgd(), Qgd;
        case 3:
            return Tgd(), Ogd;
    }
    return Tgd(), Rgd;
}
function NVd(a) {
    var b;
    b = a.ej(null);
    switch(b){
        case 10:
            return 0;
        case 15:
            return 1;
        case 14:
            return 2;
        case 11:
            return 3;
        case 21:
            return 4;
    }
    return -1;
}
function lcd() {
    lcd = Zcb;
    jcd = new mcd('PARENTS', 0);
    icd = new mcd('NODES', 1);
    gcd = new mcd('EDGES', 2);
    kcd = new mcd('PORTS', 3);
    hcd = new mcd('LABELS', 4);
}
function Qid() {
    Qid = Zcb;
    Nid = new Rid('DISTRIBUTED', 0);
    Pid = new Rid('JUSTIFIED', 1);
    Lid = new Rid('BEGIN', 2);
    Mid = new Rid(Yte, 3);
    Oid = new Rid('END', 4);
}
function sA(a, b, c) {
    var d;
    d = c.q.getFullYear() - hse + hse;
    d < 0 && (d = -d);
    switch(b){
        case 1:
            a.a += d;
            break;
        case 2:
            MA(a, d % 100, 2);
            break;
        default:
            MA(a, d, b);
    }
}
function Gtb(a, b) {
    var c, d;
    vDb(b, a.b);
    if (b >= a.b >> 1) {
        d = a.c;
        for(c = a.b; c > b; --c)d = d.b;
    } else {
        d = a.a.a;
        for(c = 0; c < b; ++c)d = d.a;
    }
    return new Xtb(a, b, d);
}
function Sgc(a) {
    this.b = new Ulb;
    this.e = new Ulb;
    this.d = a;
    this.a = !PBb(BBb(new RBb(null, new Hvb(new xZb(a.b))), new Dzb(new Tgc))).zd((wBb(), vBb));
}
function ROc(a, b) {
    var c, d, e;
    e = b.d.i;
    d = e.k;
    if (d == (DYb(), AYb) || d == vYb) return;
    c = new es(Ir(kYb(e).a.Jc(), new er));
    cs(c) && Qib(a.k, b, JD(ds(c), 18));
}
function RWc(a, b) {
    EWc();
    return Heb((a.a.b == 0 ? new Edd(a.c.e.a, a.c.e.b) : JD(Etb(a.a), 8)).b, (b.a.b == 0 ? new Edd(b.c.e.a, b.c.e.b) : JD(Etb(b.a), 8)).b);
}
function SWc(a, b) {
    EWc();
    return Heb((a.a.b == 0 ? new Edd(a.c.e.a, a.c.e.b) : JD(Etb(a.a), 8)).a, (b.a.b == 0 ? new Edd(b.c.e.a, b.c.e.b) : JD(Etb(b.a), 8)).a);
}
function VWc(a, b) {
    EWc();
    return Heb((a.a.b == 0 ? new Edd(a.b.e.a, a.b.e.b) : JD(Ftb(a.a), 8)).a, (b.a.b == 0 ? new Edd(b.b.e.a, b.b.e.b) : JD(Ftb(b.a), 8)).a);
}
function TWc(a, b) {
    EWc();
    return Heb((a.a.b == 0 ? new Edd(a.b.e.a, a.b.e.b) : JD(Ftb(a.a), 8)).b, (b.a.b == 0 ? new Edd(b.b.e.a, b.b.e.b) : JD(Ftb(b.a), 8)).b);
}
function oqd(a, b) {
    var c, d, e;
    d = QTd(a.zh(), b);
    c = b - a.fi();
    return c < 0 ? (e = a.Eh(d), e >= 0 ? a.Sh(e) : vqd(a, d)) : c < 0 ? vqd(a, d) : JD(d, 69).tk().yk(a, a.di(), c);
}
function jsd(a) {
    var b, c, d;
    d = (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), a.o);
    for(c = d.c.Jc(); c.e != c.i.gc();){
        b = JD(c.Vj(), 43);
        b.kd();
    }
    return CJd(d);
}
function JBd(a) {
    var b;
    if (RD(a.a, 4)) {
        b = cEd(a.a);
        if (b == null) throw scb(new Web(EBe + a.b + "'. " + ABe + (ceb(V4), V4.k) + BBe));
        return b;
    } else return a.a;
}
function Die(a) {
    var b;
    if (a == null) return null;
    b = Vle(Ipe(a, true));
    if (b == null) throw scb(new fhe("Invalid base64Binary value: '" + a + "'"));
    return b;
}
function AHd(b) {
    var c;
    try {
        c = b.i.Xb(b.e);
        b.Uj();
        b.g = b.e++;
        return c;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) {
            b.Uj();
            throw scb(new qub);
        } else throw scb(a);
    }
}
function WHd(b) {
    var c;
    try {
        c = b.c.Si(b.e);
        b.Uj();
        b.g = b.e++;
        return c;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) {
            b.Uj();
            throw scb(new qub);
        } else throw scb(a);
    }
}
function QNd(a) {
    var b, c, d, e;
    e = 0;
    for(c = 0, d = a.length; c < d; c++){
        b = (ADb(c, a.length), a.charCodeAt(c));
        b >= 64 && b < 128 && (e = Icb(e, Jcb(1, b - 64)));
    }
    return e;
}
function uXb(a, b) {
    var c, d;
    d = null;
    if (XMb(a, (Lgd(), rgd))) {
        c = JD(WMb(a, rgd), 102);
        c.nf(b) && (d = c.mf(b));
    }
    d == null && !!gYb(a) && (d = WMb(gYb(a), b));
    return d;
}
function x6b(a, b) {
    var c, d, e;
    e = new Vlb(b.gc());
    for(d = b.Jc(); d.Ob();){
        c = JD(d.Pb(), 291);
        c.c == c.f ? m6b(a, c, c.c) : n6b(a, c) || YCb(e.c, c);
    }
    return e;
}
function LKb(a, b) {
    var c, d, e;
    c = a.o;
    for(e = JD(JD(Qc(a.r, b), 22), 83).Jc(); e.Ob();){
        d = JD(e.Pb(), 115);
        d.e.a = FKb(d, c.a);
        d.e.b = c.b * Beb(MD(d.b.mf(DKb)));
    }
}
function t2b(a, b) {
    var c, d, e, f;
    e = a.k;
    c = Beb(MD(WMb(a, (Iqc(), tqc))));
    f = b.k;
    d = Beb(MD(WMb(b, tqc)));
    return f != (DYb(), wYb) ? -1 : e != wYb ? 1 : c == d ? 0 : c < d ? -1 : 1;
}
function _4c(a, b) {
    var c, d;
    c = JD(JD(Nib(a.g, b.a), 47).a, 68);
    d = JD(JD(Nib(a.g, b.b), 47).a, 68);
    return pdd(b.a, b.b) - pdd(b.a, bdd(c.b)) - pdd(b.b, bdd(d.b));
}
function ZSb(a) {
    XSb();
    this.c = new Ulb;
    this.d = a;
    switch(a.g){
        case 0:
        case 2:
            this.a = wnb(WSb);
            this.b = Kse;
            break;
        case 3:
        case 1:
            this.a = WSb;
            this.b = Lse;
    }
}
function o2b(a) {
    var b;
    if (!bjd(JD(WMb(a, (Bwc(), Evc)), 100))) return;
    b = a.b;
    p2b((sDb(0, b.c.length), JD(b.c[0], 25)));
    p2b(JD(Mlb(b, b.c.length - 1), 25));
}
function Cac(a, b) {
    b.Sg('Self-Loop post-processing', 1);
    EBb(BBb(BBb(DBb(new RBb(null, new Gvb(a.b, 16)), new Iac), new Kac), new Mac), new Oac);
    b.Tg();
}
function fmd(a, b, c) {
    var d, e;
    if (a.c) {
        htd(a.c, a.c.i + b);
        itd(a.c, a.c.j + c);
    } else for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 162);
        fmd(d, b, c);
    }
}
function dCc(a) {
    var b, c, d;
    d = a.c.a;
    a.p = (Qb(d), new Wlb(d));
    for(c = new rmb(d); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        b.p = hCc(b).a;
    }
    pnb();
    Slb(a.p, new qCc);
}
function DNd(a, b) {
    var c, d;
    if (a.j.length != b.j.length) return false;
    for(c = 0, d = a.j.length; c < d; c++){
        if (!cgb(a.j[c], b.j[c])) return false;
    }
    return true;
}
function rnb(a, b) {
    pnb();
    var c, d, e, f;
    c = a;
    f = b;
    if (RD(a, 22) && !RD(b, 22)) {
        c = b;
        f = a;
    }
    for(e = c.Jc(); e.Ob();){
        d = e.Pb();
        if (f.Gc(d)) return false;
    }
    return true;
}
function tNc(a, b, c, d) {
    if (b.a < d.a) return true;
    else if (b.a == d.a) {
        if (b.b < d.b) return true;
        else if (b.b == d.b) {
            if (a.b > c.b) return true;
        }
    }
    return false;
}
function sVb(a, b) {
    var c;
    c = JD(WMb(a, (Bwc(), Ruc)), 77);
    if (Zq(b, pVb)) {
        if (!c) {
            c = new Rdd;
            ZMb(a, Ruc, c);
        } else Ltb(c);
    } else !!c && ZMb(a, Ruc, null);
    return c;
}
function sYb(a) {
    var b;
    b = new Ugb;
    b.a += 'n';
    a.k != (DYb(), AYb) && Qgb(Qgb((b.a += '(', b), ls(a.k).toLowerCase()), ')');
    Qgb((b.a += '_', b), fYb(a));
    return b.a;
}
function Mxc() {
    Mxc = Zcb;
    Lxc = new Oxc(fze, 0);
    Ixc = new Oxc(owe, 1);
    Jxc = new Oxc('LINEAR_SEGMENTS', 2);
    Hxc = new Oxc('BRANDES_KOEPF', 3);
    Kxc = new Oxc(eze, 4);
}
function mqd(a, b, c, d) {
    var e;
    if (c >= 0) return a.Oh(b, c, d);
    else {
        !!a.Lh() && (d = (e = a.Bh(), e >= 0 ? a.wh(d) : a.Lh().Ph(a, -1 - e, null, d)));
        return a.yh(b, c, d);
    }
}
function Btd(a, b) {
    switch(b){
        case 7:
            !a.e && (a.e = new ree(x3, a, 7, 4));
            RGd(a.e);
            return;
        case 8:
            !a.d && (a.d = new ree(x3, a, 8, 5));
            RGd(a.d);
            return;
    }
    ctd(a, b);
}
function msd(a, b, c) {
    c == null ? (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), IJd(a.o, b)) : (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), EJd(a.o, b, c));
    return a;
}
function fu(b, c) {
    var d;
    d = b.dd(c);
    try {
        return d.Pb();
    } catch (a) {
        a = rcb(a);
        if (RD(a, 111)) throw scb(new mdb("Can't get element " + c));
        else throw scb(a);
    }
}
function RJb(a, b) {
    var c;
    c = JD(Kqb(a.b, b), 126).n;
    switch(b.g){
        case 1:
            a.t >= 0 && (c.d = a.t);
            break;
        case 3:
            a.t >= 0 && (c.a = a.t);
    }
    if (a.C) {
        c.b = a.C.b;
        c.c = a.C.c;
    }
}
function H6b(a) {
    var b;
    b = a.a;
    do {
        b = JD(ds(new es(Ir(hYb(b).a.Jc(), new er))), 18).c.i;
        b.k == (DYb(), yYb) && a.b.Ec(b);
    }while (b.k == (DYb(), yYb));
    a.b = dv(a.b);
}
function XAc(a, b) {
    var c, d, e;
    e = a;
    for(d = new es(Ir(hYb(b).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        !!c.c.i.c && (e = $wnd.Math.max(e, c.c.i.c.p));
    }
    return e;
}
function TKb(a, b) {
    var c, d, e;
    e = 0;
    d = JD(JD(Qc(a.r, b), 22), 83).Jc();
    while(d.Ob()){
        c = JD(d.Pb(), 115);
        e += c.d.d + c.b.Kf().b + c.d.a;
        d.Ob() && (e += a.w);
    }
    return e;
}
function LJb(a, b) {
    var c, d, e;
    e = 0;
    d = JD(JD(Qc(a.r, b), 22), 83).Jc();
    while(d.Ob()){
        c = JD(d.Pb(), 115);
        e += c.d.b + c.b.Kf().a + c.d.c;
        d.Ob() && (e += a.w);
    }
    return e;
}
function RYc(a) {
    var b, c, d, e;
    d = 0;
    e = TYc(a);
    if (e.c.length == 0) return 1;
    else for(c = new rmb(e); c.a < c.c.c.length;){
        b = JD(pmb(c), 27);
        d += RYc(b);
    }
    return d;
}
function zUb(a) {
    var b, c;
    this.b = new Ulb;
    this.c = a;
    this.a = false;
    for(c = new rmb(a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        this.a = this.a | b.k == (DYb(), AYb);
    }
}
function rFd(a, b, c) {
    var d, e, f, g;
    d = a.bd(b);
    if (d != -1) {
        if (a.Mj()) {
            f = a.Nj();
            g = BEd(a, d);
            e = a.Fj(4, g, null, d, f);
            !c ? c = e : c.kj(e);
        } else BEd(a, d);
    }
    return c;
}
function QGd(a, b, c) {
    var d, e, f, g;
    d = a.bd(b);
    if (d != -1) {
        if (a.Mj()) {
            f = a.Nj();
            g = qDd(a, d);
            e = a.Fj(4, g, null, d, f);
            !c ? c = e : c.kj(e);
        } else qDd(a, d);
    }
    return c;
}
function mfe(a, b, c, d) {
    var e, f, g;
    if (c.Th(b)) {
        Ife();
        if (RRd(b)) {
            e = JD(c.Ih(b), 159);
            pfe(a, e);
        } else {
            f = (g = b, !g ? null : JD(d, 52).ci(g));
            !!f && nfe(c.Ih(b), f);
        }
    }
}
function hqd(a, b, c, d) {
    var e, f, g;
    f = QTd(a.zh(), b);
    e = b - a.fi();
    return e < 0 ? (g = a.Eh(f), g >= 0 ? a.Hh(g, c, true) : uqd(a, f, c)) : JD(f, 69).tk().vk(a, a.di(), e, c, d);
}
function lKb(a, b, c, d) {
    var e, f;
    f = b.nf((Lgd(), zfd)) ? JD(b.mf(zfd), 22) : a.j;
    e = wJb(f);
    if (e == (sJb(), rJb)) return;
    if (c && !uJb(e)) return;
    WHb(nKb(a, e, d), b);
}
function ID(a, b) {
    if (VD(a)) return !!HD[b];
    else if (a.Pm) return !!a.Pm[b];
    else if (TD(a)) return !!GD[b];
    else if (SD(a)) return !!FD[b];
    return false;
}
function i0b(a) {
    switch(a.g){
        case 1:
            return xLb(), wLb;
        case 3:
            return xLb(), tLb;
        case 2:
            return xLb(), vLb;
        case 4:
            return xLb(), uLb;
        default:
            return null;
    }
}
function Jfc(a, b, c) {
    if (a.e) switch(a.b){
        case 1:
            rfc(a.c, b, c);
            break;
        case 0:
            sfc(a.c, b, c);
    }
    else pfc(a.c, b, c);
    a.a[b.p][c.p] = a.c.i;
    a.a[c.p][b.p] = a.c.e;
}
function OFc(a) {
    var b, c;
    if (a == null) return null;
    c = SC(RP, hre, 199, a.length, 0, 2);
    for(b = 0; b < c.length; b++)c[b] = JD(xmb(a[b], a[b].length), 199);
    return c;
}
function FPc(a) {
    var b;
    b = JD(WMb(a, (kVc(), WUc)), 107);
    ZMb(a, (tUc(), VTc), new Edd(0, 0));
    IPc(new _Qc, a, b.b - Beb(MD(WMb(a, aUc))), b.d - Beb(MD(WMb(a, cUc))));
}
function Yce(a) {
    var b;
    if (Wce(a)) {
        Vce(a);
        if (a.rl()) {
            b = Wbe(a.e, a.b, a.c, a.a, a.j);
            a.j = b;
        }
        a.g = a.a;
        ++a.a;
        ++a.c;
        a.i = 0;
        return a.j;
    } else throw scb(new qub);
}
function IVb(a, b, c) {
    c.Sg('Compound graph preprocessor', 1);
    a.a = new Pp;
    NVb(a, b, null);
    HVb(a, b);
    MVb(a);
    ZMb(b, (Iqc(), Lpc), a.a);
    a.a = null;
    Tib(a.b);
    c.Tg();
}
function n7b(a, b, c) {
    var d, e, f;
    for(e = new es(Ir((b ? hYb(a) : kYb(a)).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        f = b ? d.c.i : d.d.i;
        f.k == (DYb(), xYb) && qYb(f, c);
    }
}
function zxc() {
    zxc = Zcb;
    xxc = new Bxc(yve, 0);
    yxc = new Bxc('PORT_POSITION', 1);
    wxc = new Bxc('NODE_SIZE_WHERE_SPACE_PERMITS', 2);
    vxc = new Bxc('NODE_SIZE', 3);
}
function ITc(a, b) {
    var c, d, e;
    b.Sg('Untreeify', 1);
    c = JD(WMb(a, (tUc(), nUc)), 15);
    for(e = c.Jc(); e.Ob();){
        d = JD(e.Pb(), 65);
        Atb(d.b.d, d);
        Atb(d.c.b, d);
    }
    b.Tg();
}
function ced() {
    ced = Zcb;
    Ydd = new ded('AUTOMATIC', 0);
    _dd = new ded(_te, 1);
    aed = new ded(aue, 2);
    bed = new ded('TOP', 3);
    Zdd = new ded(cue, 4);
    $dd = new ded(Yte, 5);
}
function DCd(a, b, c) {
    var d, e;
    e = a.gc();
    if (b >= e) throw scb(new zHd(b, e));
    if (a.Pi()) {
        d = a.bd(c);
        if (d >= 0 && d != b) throw scb(new Teb(MDe));
    }
    return a.Ui(b, c);
}
function AUd(a, b) {
    var c, d, e;
    e = oDd(a, b);
    if (e >= 0) return e;
    if (a.ll()) for(d = 0; d < a.i; ++d){
        c = a.ml(JD(a.g[d], 57));
        if (XD(c) === XD(b)) return d;
    }
    return -1;
}
function sx(a, b) {
    this.a = JD(Qb(a), 252);
    this.b = JD(Qb(b), 252);
    if (a.Cd(b) > 0 || a == (Uk(), Tk) || b == (il(), hl)) throw scb(new Teb('Invalid range: ' + zx(a, b)));
}
function Gib(a, b, c, d) {
    Cib();
    var e, f;
    e = 0;
    for(f = 0; f < c; f++){
        e = tcb(Fcb(ucb(b[f], Use), ucb(d, Use)), ucb(Pcb(e), Use));
        a[f] = Pcb(e);
        e = Lcb(e, 32);
    }
    return Pcb(e);
}
function BHb(a, b, c) {
    var d, e;
    e = 0;
    for(d = 0; d < tHb; d++)e = $wnd.Math.max(e, rHb(a.a[b.g][d], c));
    b == (iHb(), gHb) && !!a.b && (e = $wnd.Math.max(e, a.b.b));
    return e;
}
function xvb(a, b) {
    var c, d;
    kDb(b > 0);
    if ((b & -b) == b) return YD(b * yvb(a, 31) * 4.6566128730773926E-10);
    do {
        c = yvb(a, 31);
        d = c % b;
    }while (c - d + (b - 1) < 0);
    return YD(d);
}
function JFb(a, b) {
    var c, d, e;
    c = pGb(new rGb, a);
    for(e = new rmb(b); e.a < e.c.c.length;){
        d = JD(pmb(e), 123);
        DFb(GFb(FFb(HFb(EFb(new IFb, 0), 0), c), d));
    }
    return c;
}
function i4c(a, b, c) {
    var d, e;
    _3c(a, b - a.s, c - a.t);
    for(e = new rmb(a.n); e.a < e.c.c.length;){
        d = JD(pmb(e), 208);
        m4c(d, d.e + b - a.s);
        n4c(d, d.f + c - a.t);
    }
    a.s = b;
    a.t = c;
}
function nXb(a, b, c) {
    switch(c.g){
        case 1:
            a.a = b.a / 2;
            a.b = 0;
            break;
        case 2:
            a.a = b.a;
            a.b = b.b / 2;
            break;
        case 3:
            a.a = b.a / 2;
            a.b = b.b;
            break;
        case 4:
            a.a = 0;
            a.b = b.b / 2;
    }
}
function lhc(a, b, c, d) {
    var e, f;
    for(e = b; e < a.c.length; e++){
        f = (sDb(e, a.c.length), JD(a.c[e], 11));
        if (c.Mb(f)) YCb(d.c, f);
        else return e;
    }
    return a.c.length;
}
function whc(a) {
    var b, c, d;
    for(d = JD(Qc(a.a, ($gc(), Ygc)), 15).Jc(); d.Ob();){
        c = JD(d.Pb(), 105);
        b = Ehc(c);
        nhc(a, c, b[0], (Ihc(), Fhc), 0);
        nhc(a, c, b[1], Hhc, 1);
    }
}
function xhc(a) {
    var b, c, d;
    for(d = JD(Qc(a.a, ($gc(), Zgc)), 15).Jc(); d.Ob();){
        c = JD(d.Pb(), 105);
        b = Ehc(c);
        nhc(a, c, b[0], (Ihc(), Fhc), 0);
        nhc(a, c, b[1], Hhc, 1);
    }
}
function x_c(a) {
    switch(a.g){
        case 0:
            return null;
        case 1:
            return new c0c;
        case 2:
            return new U_c;
        default:
            throw scb(new Teb(hAe + (a.f != null ? a.f : '' + a.g)));
    }
}
function gld(a) {
    var b;
    b = Beb(MD(ksd(a, (Lgd(), Cgd)))) * $wnd.Math.sqrt((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a).i);
    return new Edd(b, b / Beb(MD(ksd(a, Bgd))));
}
function fud(a) {
    var b;
    if (!!a.f && a.f.Rh()) {
        b = JD(a.f, 52);
        a.f = JD(zqd(a, b), 84);
        a.f != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 9, 8, b, a.f));
    }
    return a.f;
}
function gud(a) {
    var b;
    if (!!a.i && a.i.Rh()) {
        b = JD(a.i, 52);
        a.i = JD(zqd(a, b), 84);
        a.i != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 9, 7, b, a.i));
    }
    return a.i;
}
function s1d(a) {
    var b;
    if (!!a.b && (a.b.Db & 64) != 0) {
        b = a.b;
        a.b = JD(zqd(a, b), 19);
        a.b != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 9, 21, b, a.b));
    }
    return a.b;
}
function rJd(a, b) {
    var c, d, e;
    if (a.d == null) {
        ++a.e;
        ++a.f;
    } else {
        d = b.xi();
        yJd(a, a.f + 1);
        e = (d & Hqe) % a.d.length;
        c = a.d[e];
        !c && (c = a.d[e] = a.ak());
        c.Ec(b);
        ++a.f;
    }
}
function fce(a, b, c) {
    var d;
    if (b.qk()) return false;
    else if (b.Fk() != -2) {
        d = b.fk();
        return d == null ? c == null : pb(d, c);
    } else return b.nk() == a.e.zh() && c == null;
}
function Eo() {
    var a;
    bk(16, Bre);
    a = Sp(16);
    this.b = SC(PF, Are, 304, a, 0, 1);
    this.c = SC(PF, Are, 304, a, 0, 1);
    this.a = null;
    this.e = null;
    this.i = 0;
    this.f = a - 1;
    this.g = 0;
}
function tYb(a) {
    FXb.call(this);
    this.k = (DYb(), AYb);
    this.j = (bk(6, Dre), new Vlb(6));
    this.b = (bk(2, Dre), new Vlb(2));
    this.d = new bYb;
    this.f = new OYb;
    this.a = a;
}
function MFb(a) {
    var b, c, d, e, f;
    c = 0;
    for(e = new rmb(a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 123);
        d.d = c++;
    }
    b = LFb(a);
    f = null;
    b.c.length > 1 && (f = JFb(a, b));
    return f;
}
function gCc(a) {
    var b, c, d;
    b = 0;
    for(d = new rmb(a.c.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        b += Gr(new es(Ir(kYb(c).a.Jc(), new er)));
    }
    return b / a.c.a.c.length;
}
function NVc(a, b) {
    var c, d, e;
    a.b[b.g] = 1;
    for(d = Gtb(b.d, 0); d.b != d.d.c;){
        c = JD(Utb(d), 65);
        e = c.c;
        a.b[e.g] == 1 ? Atb(a.a, c) : a.b[e.g] == 2 ? a.b[e.g] = 1 : NVc(a, e);
    }
}
function K9b(a) {
    var b, c;
    if (a.c.length <= 1) return;
    b = H9b(a, (Rjd(), Ojd));
    J9b(a, JD(b.a, 17).a, JD(b.b, 17).a);
    c = H9b(a, Qjd);
    J9b(a, JD(c.a, 17).a, JD(c.b, 17).a);
}
function yBc(a, b, c) {
    var d, e;
    e = a.a.b;
    for(d = e.c.length; d < c; d++)Hlb(e, e.c.length, new b$b(a.a));
    qYb(b, (sDb(c - 1, e.c.length), JD(e.c[c - 1], 25)));
    a.b[b.p] = c;
}
function xZc(a, b, c, d) {
    var e, f, g;
    e = d ? JD(Qc(a.a, b), 22) : JD(Qc(a.b, b), 22);
    for(g = e.Jc(); g.Ob();){
        f = JD(g.Pb(), 27);
        if (rZc(a, c, f)) return true;
    }
    return false;
}
function yVd(a) {
    var b, c;
    for(c = new CHd(a); c.e != c.i.gc();){
        b = JD(AHd(c), 87);
        if (!!b.e || (!b.d && (b.d = new qVd(g6, b, 1)), b.d).i != 0) return true;
    }
    return false;
}
function J0d(a) {
    var b, c;
    for(c = new CHd(a); c.e != c.i.gc();){
        b = JD(AHd(c), 87);
        if (!!b.e || (!b.d && (b.d = new qVd(g6, b, 1)), b.d).i != 0) return true;
    }
    return false;
}
function h7c() {
    h7c = Zcb;
    g7c = ($6c(), Z6c);
    e7c = new MYb(8);
    new NBd((Lgd(), Kfd), e7c);
    new NBd(wgd, 8);
    f7c = X6c;
    c7c = N6c;
    d7c = O6c;
    b7c = new NBd(Zed, (xdb(), false));
}
function n8c(a, b, c) {
    var d;
    c.Sg('Shrinking tree compaction', 1);
    if (ydb(LD(WMb(b, (YLb(), WLb))))) {
        l8c(a, b.f);
        JLb(b.f, (d = b.c, d));
    } else JLb(b.f, b.c);
    c.Tg();
}
function wtd(a, b, c, d) {
    switch(b){
        case 7:
            return !a.e && (a.e = new ree(x3, a, 7, 4)), a.e;
        case 8:
            return !a.d && (a.d = new ree(x3, a, 8, 5)), a.d;
    }
    return _sd(a, b, c, d);
}
function CZd(a) {
    var b;
    if (!!a.a && a.a.Rh()) {
        b = JD(a.a, 52);
        a.a = JD(zqd(a, b), 141);
        a.a != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 9, 5, b, a.a));
    }
    return a.a;
}
function qme(a) {
    if (a < 48) return -1;
    if (a > 102) return -1;
    if (a <= 57) return a - 48;
    if (a < 65) return -1;
    if (a <= 70) return a - 65 + 10;
    if (a < 97) return -1;
    return a - 97 + 10;
}
function ak(a, b) {
    if (a == null) throw scb(new Ffb('null key in entry: null=' + b));
    else if (b == null) throw scb(new Ffb('null value in entry: ' + a + '=null'));
}
function yr(a, b) {
    var c, d;
    while(a.Ob()){
        if (!b.Ob()) return false;
        c = a.Pb();
        d = b.Pb();
        if (!(XD(c) === XD(d) || c != null && pb(c, d))) return false;
    }
    return !b.Ob();
}
function lIb(a, b) {
    var c;
    c = WC(OC(aE, 1), Rse, 30, 15, [
        rHb(a.a[0], b),
        rHb(a.a[1], b),
        rHb(a.a[2], b)
    ]);
    if (a.d) {
        c[0] = $wnd.Math.max(c[0], c[2]);
        c[2] = c[0];
    }
    return c;
}
function mIb(a, b) {
    var c;
    c = WC(OC(aE, 1), Rse, 30, 15, [
        sHb(a.a[0], b),
        sHb(a.a[1], b),
        sHb(a.a[2], b)
    ]);
    if (a.d) {
        c[0] = $wnd.Math.max(c[0], c[2]);
        c[2] = c[0];
    }
    return c;
}
function yCc(a, b, c) {
    if (!bjd(JD(WMb(b, (Bwc(), Evc)), 100))) {
        xCc(a, b, oYb(b, c));
        xCc(a, b, oYb(b, (Rjd(), Ojd)));
        xCc(a, b, oYb(b, xjd));
        pnb();
        Slb(b.j, new MCc(a));
    }
}
function vOc(a) {
    var b, c;
    a.c || yOc(a);
    c = new Rdd;
    b = new rmb(a.a);
    pmb(b);
    while(b.a < b.c.c.length)Atb(c, JD(pmb(b), 407).a);
    rDb(c.b != 0);
    Ktb(c, c.c.b);
    return c;
}
function c4c(a, b, c) {
    var d, e, f, g, h;
    h = a.r + b;
    a.r += b;
    a.d += c;
    d = c / a.n.c.length;
    e = 0;
    for(g = new rmb(a.n); g.a < g.c.c.length;){
        f = JD(pmb(g), 208);
        l4c(f, h, d, e);
        ++e;
    }
}
function jFb(a) {
    var b, c, d;
    a.b.a.$b();
    a.a = SC(LM, Nqe, 60, a.c.c.a.b.c.length, 0, 1);
    b = 0;
    for(d = new rmb(a.c.c.a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 60);
        c.f = b++;
    }
}
function bSb(a) {
    var b, c, d;
    a.b.a.$b();
    a.a = SC(JO, Nqe, 82, a.c.a.a.b.c.length, 0, 1);
    b = 0;
    for(d = new rmb(a.c.a.a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 82);
        c.i = b++;
    }
}
function i1b(a) {
    var b, c, d, e, f;
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        b = 0;
        for(f = new rmb(c.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            e.p = b++;
        }
    }
}
function r4c(a, b, c) {
    var d, e, f, g;
    g = 0;
    d = c / a.a.c.length;
    for(f = new rmb(a.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 172);
        i4c(e, e.s, e.t + g * d);
        c4c(e, a.d - e.r + b, d);
        ++g;
    }
}
function Ar(a) {
    var b;
    b = ur(a);
    if (!cs(a)) throw scb(new mdb('position (0) must be less than the number of elements that remained (' + b + ')'));
    return ds(a);
}
function YAb(a, b) {
    var c;
    if (!a.a) {
        c = SC(aE, Rse, 30, 0, 15, 1);
        Yvb(a.b.a, new aBb(c));
        aDb(c, $cb(_mb.prototype.Ke, _mb, []));
        a.a = new zwb(c, a.d);
    }
    return nwb(a.a, b);
}
function V1b(a) {
    switch(a.g){
        case 1:
            return Rjd(), Qjd;
        case 4:
            return Rjd(), xjd;
        case 3:
            return Rjd(), wjd;
        case 2:
            return Rjd(), Ojd;
        default:
            return Rjd(), Pjd;
    }
}
function fgc(a, b, c) {
    if (b.k == (DYb(), AYb) && c.k == yYb) {
        a.d = cgc(b, (Rjd(), Ojd));
        a.b = cgc(b, xjd);
    }
    if (c.k == AYb && b.k == yYb) {
        a.d = cgc(c, (Rjd(), xjd));
        a.b = cgc(c, Ojd);
    }
}
function jgc(a, b) {
    var c, d, e;
    e = lYb(a, b);
    for(d = e.Jc(); d.Ob();){
        c = JD(d.Pb(), 11);
        if (WMb(c, (Iqc(), sqc)) != null || wZb(new xZb(c.b))) return true;
    }
    return false;
}
function UHc(a, b, c) {
    c.Sg('Linear segments node placement', 1);
    a.b = JD(WMb(b, (Iqc(), Aqc)), 313);
    VHc(a, b);
    QHc(a, b);
    NHc(a, b);
    THc(a);
    a.a = null;
    a.b = null;
    c.Tg();
}
function k4c(a, b) {
    htd(b, a.e + a.d + (a.c.c.length == 0 ? 0 : a.b));
    itd(b, a.f);
    a.a = $wnd.Math.max(a.a, b.f);
    a.d += b.g + (a.c.c.length == 0 ? 0 : a.b);
    Ilb(a.c, b);
    return true;
}
function Qcd(a, b) {
    var c, d, e, f, g, h;
    e = b.length - 1;
    g = 0;
    h = 0;
    for(d = 0; d <= e; d++){
        f = b[d];
        c = Kcd(e, d) * Vcd(1 - a, e - d) * Vcd(a, d);
        g += f.a * c;
        h += f.b * c;
    }
    return new Edd(g, h);
}
function gDd(a, b) {
    var c, d, e, f, g;
    c = b.gc();
    a.Yi(a.i + c);
    f = b.Jc();
    g = a.i;
    a.i += c;
    for(d = g; d < a.i; ++d){
        e = f.Pb();
        jDd(a, d, a.Wi(d, e));
        a.Ji(d, e);
        a.Ki();
    }
    return c != 0;
}
function qFd(a, b, c) {
    var d, e, f;
    if (a.Mj()) {
        d = a.Bj();
        f = a.Nj();
        ++a.j;
        a.nj(d, a.Wi(d, b));
        e = a.Fj(3, null, b, d, f);
        !c ? c = e : c.kj(e);
    } else xEd(a, a.Bj(), b);
    return c;
}
function PXd(a, b, c) {
    var d, e, f;
    d = JD(nDd(OTd(a.a), b), 87);
    f = (e = d.c, RD(e, 88) ? JD(e, 29) : (cPd(), UOd));
    ((f.Db & 64) != 0 ? zqd(a.b, f) : f) == c ? DZd(d) : GZd(d, c);
    return f;
}
function Kie(a) {
    var b;
    return a == null ? null : new Xhb((b = Ipe(a, true), b.length > 0 && (ADb(0, b.length), b.charCodeAt(0) == 43) ? (ADb(1, b.length + 1), b.substr(1)) : b));
}
function Lie(a) {
    var b;
    return a == null ? null : new Xhb((b = Ipe(a, true), b.length > 0 && (ADb(0, b.length), b.charCodeAt(0) == 43) ? (ADb(1, b.length + 1), b.substr(1)) : b));
}
function Gxb(a, b, c, d, e, f, g, h) {
    var i, j;
    if (!d) return;
    i = d.a[0];
    !!i && Gxb(a, b, c, i, e, f, g, h);
    Hxb(a, c, d.d, e, f, g, h) && b.Ec(d);
    j = d.a[1];
    !!j && Gxb(a, b, c, j, e, f, g, h);
}
function De(a, b) {
    var c, d, e, f;
    f = a.gc();
    b.length < f && (b = bDb(new Array(f), b));
    e = b;
    d = a.Jc();
    for(c = 0; c < f; ++c)VC(e, c, d.Pb());
    b.length > f && VC(b, f, null);
    return b;
}
function Yu(a, b) {
    var c, d;
    d = a.gc();
    if (b == null) for(c = 0; c < d; c++){
        if (a.Xb(c) == null) return c;
    }
    else for(c = 0; c < d; c++){
        if (pb(b, a.Xb(c))) return c;
    }
    return -1;
}
function Jd(a, b) {
    var c, d, e;
    c = b.jd();
    e = b.kd();
    d = a.xc(c);
    if (!(XD(e) === XD(d) || e != null && pb(e, d))) return false;
    if (d == null && !a._b(c)) return false;
    return true;
}
function eD(a, b) {
    var c, d, e;
    if (b <= 22) {
        c = a.l & (1 << b) - 1;
        d = e = 0;
    } else if (b <= 44) {
        c = a.l;
        d = a.m & (1 << b - 22) - 1;
        e = 0;
    } else {
        c = a.l;
        d = a.m;
        e = a.h & (1 << b - 44) - 1;
    }
    return _C(c, d, e);
}
function AKb(a, b) {
    switch(b.g){
        case 1:
            return a.f.n.d + a.t;
        case 3:
            return a.f.n.a + a.t;
        case 2:
            return a.f.n.c + a.s;
        case 4:
            return a.f.n.b + a.s;
        default:
            return 0;
    }
}
function cLb(a, b) {
    var c, d;
    d = b.c;
    c = b.a;
    switch(a.b.g){
        case 0:
            c.d = a.e - d.a - d.d;
            break;
        case 1:
            c.d += a.e;
            break;
        case 2:
            c.c = a.e - d.a - d.d;
            break;
        case 3:
            c.c = a.e + d.d;
    }
}
function m_c() {
    m_c = Zcb;
    l_c = new o_c(yve, 0);
    j_c = new o_c(rwe, 1);
    k_c = new o_c('EDGE_LENGTH_BY_POSITION', 2);
    i_c = new o_c('CROSSING_MINIMIZATION_BY_POSITION', 3);
}
function lzd(a, b) {
    var c, d;
    c = JD(wo(a.n, b), 27);
    if (c) return c;
    d = JD(wo(a.p, b), 124);
    if (d) return d;
    throw scb(new eyd('Referenced shape does not exist: ' + b));
}
function KHd(b, c) {
    if (b.g == -1) throw scb(new Veb);
    b.Uj();
    try {
        b.d.fd(b.g, c);
        b.f = b.d.j;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) throw scb(new yqb);
        else throw scb(a);
    }
}
function Nk(b, c) {
    var d, e;
    if (RD(c, 252)) {
        e = JD(c, 252);
        try {
            d = b.Cd(e);
            return d == 0;
        } catch (a) {
            a = rcb(a);
            if (RD(a, 211)) return false;
            else throw scb(a);
        }
    }
    return false;
}
function DPb(a, b) {
    if (a.c == b) return a.d;
    else if (a.d == b) return a.c;
    else throw scb(new Teb("Node 'one' must be either source or target of edge 'edge'."));
}
function uLc(a, b) {
    if (a.c.i == b) return a.d.i;
    else if (a.d.i == b) return a.c.i;
    else throw scb(new Teb('Node ' + b + ' is neither source nor target of edge ' + a));
}
function mac(a, b, c) {
    c.Sg('Self-Loop ordering', 1);
    EBb(FBb(BBb(BBb(DBb(new RBb(null, new Gvb(b.b, 16)), new qac), new sac), new uac), new wac), new yac(a));
    c.Tg();
}
function cjc(a, b) {
    var c;
    switch(b.g){
        case 2:
        case 4:
            c = a.a;
            a.c.d.n.b < c.d.n.b && (c = a.c);
            djc(a, b, (Dgc(), Cgc), c);
            break;
        case 1:
        case 3:
            djc(a, b, (Dgc(), zgc), null);
    }
}
function vjc(a, b, c, d, e, f) {
    var g, h, i, j, k;
    g = tjc(b, c, f);
    h = c == (Rjd(), xjd) || c == Qjd ? -1 : 1;
    j = a[c.g];
    for(k = 0; k < j.length; k++){
        i = j[k];
        i > 0 && (i += e);
        j[k] = g;
        g += h * (i + d);
    }
}
function fmc(a) {
    var b, c, d;
    d = a.f;
    a.n = SC(aE, Rse, 30, d, 15, 1);
    a.d = SC(aE, Rse, 30, d, 15, 1);
    for(b = 0; b < d; b++){
        c = JD(Mlb(a.c.b, b), 25);
        a.n[b] = cmc(a, c);
        a.d[b] = bmc(a, c);
    }
}
function lYc(a, b, c, d) {
    var e;
    this.c = a;
    this.d = b;
    e = new Mtb;
    Dtb(e, c, e.c.b, e.c);
    this.a = e;
    this.b = JD(WMb(d, (kVc(), KUc)), 86);
    this.e = Beb(MD(WMb(d, bVc)));
    kYc(this);
}
function Brd(a, b) {
    var c, d, e;
    e = 0;
    for(d = 2; d < b; d <<= 1)(a.Db & d) != 0 && ++e;
    if (e == 0) {
        for(c = b <<= 1; c <= 128; c <<= 1){
            if ((a.Db & c) != 0) return 0;
        }
        return -1;
    } else return e;
}
function lce(a, b) {
    var c, d, e, f, g;
    g = Kfe(a.e.zh(), b);
    f = null;
    c = JD(a.g, 122);
    for(e = 0; e < a.i; ++e){
        d = c[e];
        if (g.Zl(d.Ik())) {
            !f && (f = new vDd);
            tCd(f, d);
        }
    }
    !!f && VGd(a, f);
}
function zie(a) {
    var b, c, d;
    if (!a) return null;
    if (a.dc()) return '';
    d = new Hgb;
    for(c = a.Jc(); c.Ob();){
        b = c.Pb();
        Egb(d, OD(b));
        d.a += ' ';
    }
    return hdb(d, d.a.length - 1);
}
function TC(a, b) {
    var c = new Array(b);
    var d;
    switch(a){
        case 14:
        case 15:
            d = 0;
            break;
        case 16:
            d = false;
            break;
        default:
            return c;
    }
    for(var e = 0; e < b; ++e)c[e] = d;
    return c;
}
function FEb(a) {
    var b, c, d;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        b.c.$b();
    }
    Ugd(a.d) ? d = a.a.c : d = a.a.d;
    Llb(d, new VEb(a));
    a.c.bf(a);
    GEb(a);
}
function yNb(a) {
    var b, c, d, e;
    for(c = new rmb(a.e.c); c.a < c.c.c.length;){
        b = JD(pmb(c), 288);
        for(e = new rmb(b.b); e.a < e.c.c.length;){
            d = JD(pmb(e), 442);
            rNb(d);
        }
        gNb(b);
    }
}
function vXb(a) {
    var b, c, d;
    d = Hqe;
    for(c = new rmb(a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        XMb(b, (Iqc(), jqc)) && (d = $wnd.Math.min(d, JD(WMb(b, jqc), 17).a));
    }
    return d;
}
function w4c(a) {
    var b, c, d, e, f;
    d = 0;
    f = 0;
    e = 0;
    for(c = new rmb(a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 172);
        f = $wnd.Math.max(f, b.r);
        d += b.d + (e > 0 ? a.c : 0);
        ++e;
    }
    a.b = d;
    a.d = f;
}
function CHb(a, b) {
    var c;
    c = WC(OC(aE, 1), Rse, 30, 15, [
        BHb(a, (iHb(), fHb), b),
        BHb(a, gHb, b),
        BHb(a, hHb, b)
    ]);
    if (a.f) {
        c[0] = $wnd.Math.max(c[0], c[2]);
        c[2] = c[0];
    }
    return c;
}
function G1b(a) {
    var b;
    if (!XMb(a, (Bwc(), gvc))) return;
    b = JD(WMb(a, gvc), 22);
    if (b.Gc((Eid(), wid))) {
        b.Kc(wid);
        b.Ec(yid);
    } else if (b.Gc(yid)) {
        b.Kc(yid);
        b.Ec(wid);
    }
}
function H1b(a) {
    var b;
    if (!XMb(a, (Bwc(), gvc))) return;
    b = JD(WMb(a, gvc), 22);
    if (b.Gc((Eid(), Did))) {
        b.Kc(Did);
        b.Ec(Bid);
    } else if (b.Gc(Bid)) {
        b.Kc(Bid);
        b.Ec(Did);
    }
}
function Njc(a, b, c, d) {
    var e, f, g, h;
    a.a == null && Qjc(a, b);
    g = b.b.j.c.length;
    f = c.d.p;
    h = d.d.p;
    e = h - 1;
    e < 0 && (e = g - 1);
    return f <= e ? a.a[e] - a.a[f] : a.a[g - 1] - a.a[f] + a.a[e];
}
function dlc(a) {
    var b;
    for(b = 0; b < a.a.c.length; b++)if (XMb(JD(Mlb(a.a, b), 9), (Bwc(), avc))) {
        if (!ydb(LD(WMb(JD(Mlb(a.a, b), 9), avc)))) return false;
    }
    return true;
}
function Hlc(a, b, c) {
    var d, e, f, g, h;
    f = a.c;
    h = c ? b : a;
    d = c ? a : b;
    for(e = h.p + 1; e < d.p; ++e){
        g = JD(Mlb(f.a, e), 9);
        if (!(g.k == (DYb(), vYb) || Ilc(g))) return false;
    }
    return true;
}
function gpd(a) {
    var b, c;
    if (!a.b) {
        a.b = bv(JD(a.f, 27).ih().i);
        for(c = new CHd(JD(a.f, 27).ih()); c.e != c.i.gc();){
            b = JD(AHd(c), 153);
            Ilb(a.b, new fpd(b));
        }
    }
    return a.b;
}
function hpd(a) {
    var b, c;
    if (!a.e) {
        a.e = bv($wd(JD(a.f, 27)).i);
        for(c = new CHd($wd(JD(a.f, 27))); c.e != c.i.gc();){
            b = JD(AHd(c), 124);
            Ilb(a.e, new vpd(b));
        }
    }
    return a.e;
}
function cpd(a) {
    var b, c;
    if (!a.a) {
        a.a = bv(Xwd(JD(a.f, 27)).i);
        for(c = new CHd(Xwd(JD(a.f, 27))); c.e != c.i.gc();){
            b = JD(AHd(c), 27);
            Ilb(a.a, new jpd(a, b));
        }
    }
    return a.a;
}
function YSd(b) {
    var c;
    if (!b.C && (b.D != null || b.B != null)) {
        c = ZSd(b);
        if (c) b.el(c);
        else try {
            b.el(null);
        } catch (a) {
            a = rcb(a);
            if (!RD(a, 63)) throw scb(a);
        }
    }
    return b.C;
}
function IJb(a) {
    switch(a.q.g){
        case 5:
            FJb(a, (Rjd(), xjd));
            FJb(a, Ojd);
            break;
        case 4:
            GJb(a, (Rjd(), xjd));
            GJb(a, Ojd);
            break;
        default:
            HJb(a, (Rjd(), xjd));
            HJb(a, Ojd);
    }
}
function RKb(a) {
    switch(a.q.g){
        case 5:
            OKb(a, (Rjd(), wjd));
            OKb(a, Qjd);
            break;
        case 4:
            PKb(a, (Rjd(), wjd));
            PKb(a, Qjd);
            break;
        default:
            QKb(a, (Rjd(), wjd));
            QKb(a, Qjd);
    }
}
function QTb(a, b) {
    var c, d, e;
    e = new Cdd;
    for(d = a.Jc(); d.Ob();){
        c = JD(d.Pb(), 36);
        GTb(c, e.a, 0);
        e.a += c.f.a + b;
        e.b = $wnd.Math.max(e.b, c.f.b);
    }
    e.b > 0 && (e.b += b);
    return e;
}
function STb(a, b) {
    var c, d, e;
    e = new Cdd;
    for(d = a.Jc(); d.Ob();){
        c = JD(d.Pb(), 36);
        GTb(c, 0, e.b);
        e.b += c.f.b + b;
        e.a = $wnd.Math.max(e.a, c.f.a);
    }
    e.a > 0 && (e.a += b);
    return e;
}
function SFc(a, b) {
    var c, d;
    if (b.length == 0) return 0;
    c = oGc(a.a, b[0], (Rjd(), Qjd));
    c += oGc(a.a, b[b.length - 1], wjd);
    for(d = 0; d < b.length; d++)c += TFc(a, d, b);
    return c;
}
function YOc() {
    KOc();
    this.c = new Ulb;
    this.i = new Ulb;
    this.e = new wtb;
    this.f = new wtb;
    this.g = new wtb;
    this.j = new Ulb;
    this.a = new Ulb;
    this.b = new Irb;
    this.k = new Irb;
}
function VSd(a, b) {
    var c, d;
    if (a.Db >> 16 == 6) return a.Cb.Ph(a, 5, l6, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? a.ei() : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function cA(a) {
    Zz();
    var b = a.e;
    if (b && b.stack) {
        var c = b.stack;
        var d = b + '\n';
        c.substring(0, d.length) == d && (c = c.substring(d.length));
        return c.split('\n');
    }
    return [];
}
function gfb(a) {
    var b;
    b = (nfb(), mfb);
    return b[a >>> 28] | b[a >> 24 & 15] << 4 | b[a >> 20 & 15] << 8 | b[a >> 16 & 15] << 12 | b[a >> 12 & 15] << 16 | b[a >> 8 & 15] << 20 | b[a >> 4 & 15] << 24 | b[a & 15] << 28;
}
function dlb(a) {
    var b, c, d;
    if (a.b != a.c) return;
    d = a.a.length;
    c = dfb($wnd.Math.max(8, d)) << 1;
    if (a.b != 0) {
        b = VCb(a.a, c);
        clb(a, b, d);
        a.a = b;
        a.b = 0;
    } else _Cb(a.a, c);
    a.c = d;
}
function FKb(a, b) {
    var c;
    c = a.b;
    return c.nf((Lgd(), Xfd)) ? c.$f() == (Rjd(), Qjd) ? -c.Kf().a - Beb(MD(c.mf(Xfd))) : b + Beb(MD(c.mf(Xfd))) : c.$f() == (Rjd(), Qjd) ? -c.Kf().a : b;
}
function fYb(a) {
    var b;
    if (a.b.c.length != 0 && !!JD(Mlb(a.b, 0), 72).a) return JD(Mlb(a.b, 0), 72).a;
    b = _Vb(a);
    if (b != null) return b;
    return '' + (!a.c ? -1 : Nlb(a.c.a, a, 0));
}
function YYb(a) {
    var b;
    if (a.f.c.length != 0 && !!JD(Mlb(a.f, 0), 72).a) return JD(Mlb(a.f, 0), 72).a;
    b = _Vb(a);
    if (b != null) return b;
    return '' + (!a.i ? -1 : Nlb(a.i.j, a, 0));
}
function Hdc(a, b) {
    var c, d;
    if (b < 0 || b >= a.gc()) return null;
    for(c = b; c < a.gc(); ++c){
        d = JD(a.Xb(c), 132);
        if (c == a.gc() - 1 || !d.o) return new xod(jfb(c), d);
    }
    return null;
}
function U4c(a) {
    var b, c, d, e, f;
    f = 0;
    e = Lse;
    d = 0;
    for(c = new rmb(a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 172);
        f += b.r + (d > 0 ? a.c : 0);
        e = $wnd.Math.max(e, b.d);
        ++d;
    }
    a.e = f;
    a.b = e;
}
function upd(a) {
    var b, c;
    if (!a.b) {
        a.b = bv(JD(a.f, 124).ih().i);
        for(c = new CHd(JD(a.f, 124).ih()); c.e != c.i.gc();){
            b = JD(AHd(c), 153);
            Ilb(a.b, new fpd(b));
        }
    }
    return a.b;
}
function zCd(a, b) {
    var c, d, e;
    if (b.dc()) return GLd(), GLd(), FLd;
    else {
        c = new wHd(a, b.gc());
        for(e = new CHd(a); e.e != e.i.gc();){
            d = AHd(e);
            b.Gc(d) && tCd(c, d);
        }
        return c;
    }
}
function esd(a, b, c, d) {
    if (b == 0) return d ? (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), a.o) : (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), CJd(a.o));
    return hqd(a, b, c, d);
}
function Vvd(a) {
    var b, c;
    if (a.rb) for(b = 0, c = a.rb.i; b < c; ++b)Eud(nDd(a.rb, b));
    if (a.vb) for(b = 0, c = a.vb.i; b < c; ++b)Eud(nDd(a.vb, b));
    nae((Gfe(), Efe), a);
    a.Bb |= 1;
}
function bwd(a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
    cwd(a, b, d, null, e, f, g, h, i, j, m, true, n);
    v1d(a, k);
    RD(a.Cb, 88) && QVd(TTd(JD(a.Cb, 88)), 2);
    !!c && w1d(a, c);
    x1d(a, l);
    return a;
}
function c6d(b) {
    var c, d;
    if (b == null) return null;
    d = 0;
    try {
        d = Fdb(b, Lre, Hqe) & Wre;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 130)) {
            c = rgb(b);
            d = c[0];
        } else throw scb(a);
    }
    return $db(d);
}
function d6d(b) {
    var c, d;
    if (b == null) return null;
    d = 0;
    try {
        d = Fdb(b, Lre, Hqe) & Wre;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 130)) {
            c = rgb(b);
            d = c[0];
        } else throw scb(a);
    }
    return $db(d);
}
function jD(a, b) {
    var c, d, e;
    e = a.h - b.h;
    if (e < 0) return false;
    c = a.l - b.l;
    d = a.m - b.m + (c >> 22);
    e += d >> 22;
    if (e < 0) return false;
    a.l = c & zse;
    a.m = d & zse;
    a.h = e & Ase;
    return true;
}
function Hxb(a, b, c, d, e, f, g) {
    var h, i;
    if (b.Re() && (i = a.a.Le(c, d), i < 0 || !e && i == 0)) return false;
    if (b.Se() && (h = a.a.Le(c, f), h > 0 || !g && h == 0)) return false;
    return true;
}
function N9b(a, b) {
    G9b();
    var c;
    c = a.j.g - b.j.g;
    if (c != 0) return 0;
    switch(a.j.g){
        case 2:
            return Q9b(b, F9b) - Q9b(a, F9b);
        case 4:
            return Q9b(a, E9b) - Q9b(b, E9b);
    }
    return 0;
}
function eoc(a) {
    switch(a.g){
        case 0:
            return Znc;
        case 1:
            return $nc;
        case 2:
            return _nc;
        case 3:
            return aoc;
        case 4:
            return boc;
        case 5:
            return coc;
        default:
            return null;
    }
}
function Gvd(a, b, c) {
    var d, e;
    d = (e = new k1d, rRd(e, b), rvd(e, c), tCd((!a.c && (a.c = new X0d(m6, a, 12, 10)), a.c), e), e);
    tRd(d, 0);
    wRd(d, 1);
    vRd(d, true);
    uRd(d, true);
    return d;
}
function qDd(a, b) {
    var c, d;
    if (b >= a.i) throw scb(new XId(b, a.i));
    ++a.j;
    c = a.g[b];
    d = a.i - b - 1;
    d > 0 && $gb(a.g, b + 1, a.g, b, d);
    VC(a.g, --a.i, null);
    a.Ni(b, c);
    a.Ki();
    return c;
}
function NRd(a, b) {
    var c, d;
    if (a.Db >> 16 == 17) return a.Cb.Ph(a, 21, _5, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? a.ei() : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function $Db(a) {
    var b, c, d, e;
    pnb();
    Slb(a.c, a.a);
    for(e = new rmb(a.c); e.a < e.c.c.length;){
        d = pmb(e);
        for(c = new rmb(a.b); c.a < c.c.c.length;){
            b = JD(pmb(c), 678);
            b._e(d);
        }
    }
}
function BTb(a) {
    var b, c, d, e;
    pnb();
    Slb(a.c, a.a);
    for(e = new rmb(a.c); e.a < e.c.c.length;){
        d = pmb(e);
        for(c = new rmb(a.b); c.a < c.c.c.length;){
            b = JD(pmb(c), 374);
            b._e(d);
        }
    }
}
function CGb(a) {
    var b, c, d, e, f;
    e = Hqe;
    f = null;
    for(d = new rmb(a.d); d.a < d.c.c.length;){
        c = JD(pmb(d), 216);
        if (c.d.j ^ c.e.j) {
            b = c.e.e - c.d.e - c.a;
            if (b < e) {
                e = b;
                f = c;
            }
        }
    }
    return f;
}
function $Ob() {
    $Ob = Zcb;
    YOb = new MBd(ive, (xdb(), false));
    UOb = new MBd(jve, 100);
    WOb = (KPb(), IPb);
    VOb = new MBd(kve, WOb);
    XOb = new MBd(lve, Fue);
    ZOb = new MBd(mve, jfb(Hqe));
}
function S3b(a, b) {
    var c, d, e;
    for(d = new es(Ir(eYb(a).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        e = JD(b.Kb(c), 9);
        return new cc(Qb(e.n.b + e.o.b / 2));
    }
    return wb(), wb(), vb;
}
function ufc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    j = 0;
    for(e = a.a[b], f = 0, g = e.length; f < g; ++f){
        d = e[f];
        k = dGc(d, c);
        for(i = k.Jc(); i.Ob();){
            h = JD(i.Pb(), 11);
            Qib(a.f, h, jfb(j++));
        }
    }
}
function Iyd(a, b, c) {
    var d, e, f, g;
    if (c) {
        e = c.a.length;
        d = new Rpe(e);
        for(g = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); g.Ob();){
            f = JD(g.Pb(), 17);
            Rc(a, b, Xxd(BB(c, f.a)));
        }
    }
}
function Jyd(a, b, c) {
    var d, e, f, g;
    if (c) {
        e = c.a.length;
        d = new Rpe(e);
        for(g = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); g.Ob();){
            f = JD(g.Pb(), 17);
            Rc(a, b, Xxd(BB(c, f.a)));
        }
    }
}
function Ehc(a) {
    jhc();
    var b;
    b = JD(De(Ec(a.k), SC(v2, Ave, 64, 2, 0, 1)), 125);
    Nmb(b, 0, b.length, null);
    if (b[0] == (Rjd(), xjd) && b[1] == Qjd) {
        VC(b, 0, Qjd);
        VC(b, 1, xjd);
    }
    return b;
}
function kGc(a, b, c) {
    var d, e, f;
    e = iGc(a, b, c);
    f = lGc(a, e);
    _Fc(a.b);
    FGc(a, b, c);
    pnb();
    Slb(e, new KGc(a));
    d = lGc(a, e);
    _Fc(a.b);
    FGc(a, c, b);
    return new xod(jfb(f), jfb(d));
}
function MHc() {
    MHc = Zcb;
    JHc = E9c(new J9c, (CQb(), BQb), (u5b(), L4b));
    KHc = new LBd('linearSegments.inputPrio', jfb(0));
    LHc = new LBd('linearSegments.outputPrio', jfb(0));
}
function _Pc() {
    _Pc = Zcb;
    XPc = new bQc('P1_TREEIFICATION', 0);
    YPc = new bQc('P2_NODE_ORDERING', 1);
    ZPc = new bQc('P3_NODE_PLACEMENT', 2);
    $Pc = new bQc('P4_EDGE_ROUTING', 3);
}
function O4c(a) {
    var b, c, d, e;
    c = 0;
    b = 0;
    for(e = new CHd(a); e.e != e.i.gc();){
        d = JD(AHd(e), 27);
        c = $wnd.Math.max(d.g + d.i, c);
        b = $wnd.Math.max(d.f + d.j, b);
    }
    return new Edd(c, b);
}
function Kld(a, b) {
    var c, d, e, f;
    f = 0;
    for(d = new rmb(a); d.a < d.c.c.length;){
        c = JD(pmb(d), 27);
        f += $wnd.Math.pow(c.g * c.f - b, 2);
    }
    e = $wnd.Math.sqrt(f / (a.c.length - 1));
    return e;
}
function oid() {
    oid = Zcb;
    nid = new qid('UNKNOWN', 0);
    kid = new qid('ABOVE', 1);
    lid = new qid('BELOW', 2);
    mid = new qid('INLINE', 3);
    new LBd('org.eclipse.elk.labelSide', nid);
}
function kzd(a, b) {
    if (RD(b, 268)) return nyd(a, JD(b, 85));
    else if (RD(b, 273)) return JD(b, 273);
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b
    ])))));
}
function oDd(a, b) {
    var c;
    if (a.Vi() && b != null) for(c = 0; c < a.i; ++c){
        if (pb(b, a.g[c])) return c;
    }
    else for(c = 0; c < a.i; ++c){
        if (XD(a.g[c]) === XD(b)) return c;
    }
    return -1;
}
function VVb(a, b, c) {
    var d, e;
    if (b.c == (Eyc(), Cyc) && c.c == Byc) return -1;
    else if (b.c == Byc && c.c == Cyc) return 1;
    d = ZVb(b.a, a.a);
    e = ZVb(c.a, a.a);
    return b.c == Cyc ? e - d : d - e;
}
function pYb(a, b, c) {
    if (!!c && (b < 0 || b > c.a.c.length)) throw scb(new Teb('index must be >= 0 and <= layer node count'));
    !!a.c && Plb(a.c.a, a);
    a.c = c;
    !!c && Hlb(c.a, b, a);
}
function UKc(a, b) {
    this.c = new Irb;
    this.a = a;
    this.b = b;
    this.d = JD(WMb(a, (Iqc(), Aqc)), 313);
    XD(WMb(a, (Bwc(), hvc))) === XD((moc(), koc)) ? this.e = new ELc : this.e = new xLc;
}
function gu(b, c) {
    var d, e;
    d = b.dd(c);
    try {
        e = d.Pb();
        d.Qb();
        return e;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 111)) throw scb(new mdb("Can't remove element " + c));
        else throw scb(a);
    }
}
function yA(a, b) {
    var c, d, e;
    d = new mB;
    e = new nB(d.q.getFullYear() - hse, d.q.getMonth(), d.q.getDate());
    c = xA(a, b, e);
    if (c == 0 || c < b.length) throw scb(new Teb(b));
    return e;
}
function Yub(a, b) {
    var c, d, e;
    tDb(b);
    kDb(b != a);
    e = a.b.c.length;
    for(d = b.Jc(); d.Ob();){
        c = d.Pb();
        Ilb(a.b, tDb(c));
    }
    if (e != a.b.c.length) {
        Zub(a, 0);
        return true;
    }
    return false;
}
function nPb() {
    nPb = Zcb;
    fPb = (Lgd(), nfd);
    new NBd(afd, (xdb(), true));
    iPb = Bfd;
    jPb = Efd;
    kPb = Gfd;
    hPb = zfd;
    lPb = Jfd;
    mPb = agd;
    ePb = ($Ob(), YOb);
    cPb = VOb;
    dPb = XOb;
    gPb = ZOb;
    bPb = UOb;
}
function cWb(a, b) {
    if (b == a.c) return a.d;
    else if (b == a.d) return a.c;
    else throw scb(new Teb("'port' must be either the source port or target port of the edge."));
}
function d0b(a, b, c) {
    var d, e;
    e = a.o;
    d = a.d;
    switch(b.g){
        case 1:
            return -d.d - c;
        case 3:
            return e.b + d.a + c;
        case 2:
            return e.a + d.c + c;
        case 4:
            return -d.b - c;
        default:
            return 0;
    }
}
function i3b(a, b, c, d) {
    var e, f, g, h;
    qYb(b, JD(d.Xb(0), 25));
    h = d.hd(1, d.gc());
    for(f = JD(c.Kb(b), 20).Jc(); f.Ob();){
        e = JD(f.Pb(), 18);
        g = e.c.i == b ? e.d.i : e.c.i;
        i3b(a, g, c, h);
    }
}
function Qbc(a) {
    var b;
    b = new Irb;
    if (XMb(a, (Iqc(), Fqc))) return JD(WMb(a, Fqc), 91);
    EBb(BBb(new RBb(null, new Gvb(a.j, 16)), new Sbc), new Ubc(b));
    ZMb(a, Fqc, b);
    return b;
}
function P4c(a, b) {
    var c, d, e, f, g;
    d = 0;
    e = 0;
    c = 0;
    for(g = new rmb(a); g.a < g.c.c.length;){
        f = JD(pmb(g), 186);
        d = $wnd.Math.max(d, f.e);
        e += f.b + (c > 0 ? b : 0);
        ++c;
    }
    return new Edd(d, e);
}
function Pnd(a, b) {
    var c, d;
    d = null;
    if (a.nf((Lgd(), rgd))) {
        c = JD(a.mf(rgd), 102);
        c.nf(b) && (d = c.mf(b));
    }
    d == null && !!a.Rf() && (d = a.Rf().mf(b));
    d == null && (d = JBd(b));
    return d;
}
function eud(a, b) {
    var c, d;
    if (a.Db >> 16 == 6) return a.Cb.Ph(a, 6, x3, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (Vpd(), Npd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function Gwd(a, b) {
    var c, d;
    if (a.Db >> 16 == 7) return a.Cb.Ph(a, 1, y3, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (Vpd(), Ppd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function nxd(a, b) {
    var c, d;
    if (a.Db >> 16 == 9) return a.Cb.Ph(a, 9, A3, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (Vpd(), Rpd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function fZd(a, b) {
    var c, d;
    if (a.Db >> 16 == 5) return a.Cb.Ph(a, 9, e6, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (cPd(), OOd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function Uvd(a, b) {
    var c, d;
    if (a.Db >> 16 == 7) return a.Cb.Ph(a, 6, l6, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (cPd(), XOd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function DQd(a, b) {
    var c, d;
    if (a.Db >> 16 == 3) return a.Cb.Ph(a, 0, h6, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (cPd(), HOd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function Ntd(a, b) {
    var c, d;
    if (a.Db >> 16 == 3) return a.Cb.Ph(a, 12, A3, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (Vpd(), Mpd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function HLd(a, b, c) {
    var d, e, f;
    c < 0 && (c = 0);
    f = a.i;
    for(e = c; e < f; e++){
        d = nDd(a, e);
        if (b == null) {
            if (d == null) return e;
        } else if (XD(b) === XD(d) || pb(b, d)) return e;
    }
    return -1;
}
function W9d(a, b) {
    var c, d;
    c = b.mi(a.a);
    if (!c) return null;
    else {
        d = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), aGe));
        return cgb(bGe, d) ? nae(a, WSd(b.nk())) : d;
    }
}
function hfe(a, b) {
    var c, d;
    if (b) {
        if (b == a) return true;
        c = 0;
        for(d = JD(b, 52).Lh(); !!d && d != b; d = d.Lh()){
            if (++c > Sse) return hfe(a, d);
            if (d == a) return true;
        }
    }
    return false;
}
function JKb(a) {
    EKb();
    switch(a.q.g){
        case 5:
            GKb(a, (Rjd(), xjd));
            GKb(a, Ojd);
            break;
        case 4:
            HKb(a, (Rjd(), xjd));
            HKb(a, Ojd);
            break;
        default:
            IKb(a, (Rjd(), xjd));
            IKb(a, Ojd);
    }
}
function NKb(a) {
    EKb();
    switch(a.q.g){
        case 5:
            KKb(a, (Rjd(), wjd));
            KKb(a, Qjd);
            break;
        case 4:
            LKb(a, (Rjd(), wjd));
            LKb(a, Qjd);
            break;
        default:
            MKb(a, (Rjd(), wjd));
            MKb(a, Qjd);
    }
}
function QMb(a) {
    var b, c;
    b = JD(WMb(a, (IOb(), wOb)), 17);
    if (b) {
        c = b.a;
        c == 0 ? ZMb(a, (TOb(), SOb), new Cvb) : ZMb(a, (TOb(), SOb), new Dvb(c));
    } else ZMb(a, (TOb(), SOb), new Dvb(1));
}
function lXb(a, b) {
    var c;
    c = a.i;
    switch(b.g){
        case 1:
            return -(a.n.b + a.o.b);
        case 2:
            return a.n.a - c.o.a;
        case 3:
            return a.n.b - c.o.b;
        case 4:
            return -(a.n.a + a.o.a);
    }
    return 0;
}
function J7b(a, b) {
    switch(a.g){
        case 0:
            return b == (Oqc(), Kqc) ? F7b : G7b;
        case 1:
            return b == (Oqc(), Kqc) ? F7b : E7b;
        case 2:
            return b == (Oqc(), Kqc) ? E7b : G7b;
        default:
            return E7b;
    }
}
function V4c(a, b) {
    var c, d, e;
    Plb(a.a, b);
    a.e -= b.r + (a.a.c.length == 0 ? 0 : a.c);
    e = aAe;
    for(d = new rmb(a.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 172);
        e = $wnd.Math.max(e, c.d);
    }
    a.b = e;
}
function gyd(a, b, c) {
    var d, e, f;
    f = JD(Nib(a.r, b), 297);
    e = null;
    if (f) switch(f.g){
        case 2:
            d = MD(Nib(a.i, b));
            e = (tDb(c), c) + (tDb(d), d);
            break;
        default:
            e = c;
    }
    else e = c;
    return e;
}
function iyd(a, b, c) {
    var d, e, f;
    f = JD(Nib(a.r, b), 297);
    e = null;
    if (f) switch(f.g){
        case 2:
            d = MD(Nib(a.j, b));
            e = (tDb(c), c) + (tDb(d), d);
            break;
        default:
            e = c;
    }
    else e = c;
    return e;
}
function pRd(a) {
    var b;
    if ((a.Bb & 1) == 0 && !!a.r && a.r.Rh()) {
        b = JD(a.r, 52);
        a.r = JD(zqd(a, b), 141);
        a.r != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 9, 8, b, a.r));
    }
    return a.r;
}
function AHb(a, b, c) {
    var d;
    d = WC(OC(aE, 1), Rse, 30, 15, [
        DHb(a, (iHb(), fHb), b, c),
        DHb(a, gHb, b, c),
        DHb(a, hHb, b, c)
    ]);
    if (a.f) {
        d[0] = $wnd.Math.max(d[0], d[2]);
        d[2] = d[0];
    }
    return d;
}
function q6b(a, b) {
    var c, d, e;
    e = x6b(a, b);
    if (e.c.length == 0) return;
    Slb(e, new T6b);
    c = e.c.length;
    for(d = 0; d < c; d++)m6b(a, (sDb(d, e.c.length), JD(e.c[d], 291)), t6b(a, e, d));
}
function Xbc(a, b, c) {
    var d, e;
    d = b * c;
    if (RD(a.g, 152)) {
        e = ndc(a);
        if (e.f.d) e.f.a || (a.d.a += d + fue);
        else {
            a.d.d -= d + fue;
            a.d.a += d + fue;
        }
    } else if (RD(a.g, 9)) {
        a.d.d -= d;
        a.d.a += 2 * d;
    }
}
function thc(a) {
    var b, c, d, e;
    for(e = JD(Qc(a.a, ($gc(), Vgc)), 15).Jc(); e.Ob();){
        d = JD(e.Pb(), 105);
        for(c = Ec(d.k).Jc(); c.Ob();){
            b = JD(c.Pb(), 64);
            nhc(a, d, b, (Ihc(), Ghc), 1);
        }
    }
}
function Ilc(a) {
    var b, c;
    if (a.k == (DYb(), yYb)) for(c = new es(Ir(eYb(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        if (!eWb(b) && a.c == bWb(b, a).c) return true;
    }
    return false;
}
function kMc(a) {
    var b, c;
    if (a.k == (DYb(), yYb)) for(c = new es(Ir(eYb(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        if (!eWb(b) && b.c.i.c == b.d.i.c) return true;
    }
    return false;
}
function Wwd(a, b) {
    var c, d;
    if (a.Db >> 16 == 11) return a.Cb.Ph(a, 10, A3, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (Vpd(), Qpd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function I_d(a, b) {
    var c, d;
    if (a.Db >> 16 == 10) return a.Cb.Ph(a, 11, _5, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (cPd(), VOd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function j1d(a, b) {
    var c, d;
    if (a.Db >> 16 == 10) return a.Cb.Ph(a, 12, k6, b);
    return d = s1d(JD(QTd((c = JD(Crd(a, 16), 29), !c ? (cPd(), YOd) : c), a.Db >> 16), 19)), a.Cb.Ph(a, d.n, d.f, b);
}
function Lyd(a, b) {
    var c, d, e, f, g;
    if (b) {
        e = b.a.length;
        c = new Rpe(e);
        for(g = (c.b - c.a) * c.c < 0 ? (Qpe(), Ppe) : new lqe(c); g.Ob();){
            f = JD(g.Pb(), 17);
            d = _xd(b, f.a);
            !!d && szd(a, d);
        }
    }
}
function w6d() {
    m6d();
    var a, b;
    q6d((GOd(), FOd));
    p6d(FOd);
    Vvd(FOd);
    yZd = (cPd(), ROd);
    for(b = new rmb(k6d); b.a < b.c.c.length;){
        a = JD(pmb(b), 246);
        JZd(a, ROd, null);
    }
    return true;
}
function mD(a, b) {
    var c, d, e, f, g, h, i, j;
    i = a.h >> 19;
    j = b.h >> 19;
    if (i != j) return j - i;
    e = a.h;
    h = b.h;
    if (e != h) return e - h;
    d = a.m;
    g = b.m;
    if (d != g) return d - g;
    c = a.l;
    f = b.l;
    return c - f;
}
function yjc(a, b, c) {
    var d, e, f, g, h;
    e = a[c.g];
    for(h = new rmb(b.d); h.a < h.c.c.length;){
        g = JD(pmb(h), 105);
        f = g.i;
        if (!!f && f.i == c) {
            d = g.d[c.g];
            e[d] = $wnd.Math.max(e[d], f.j.b);
        }
    }
}
function z3c(a, b) {
    var c, d, e, f, g;
    d = 0;
    e = 0;
    c = 0;
    for(g = new rmb(b.d); g.a < g.c.c.length;){
        f = JD(pmb(g), 316);
        w4c(f);
        d = $wnd.Math.max(d, f.b);
        e += f.d + (c > 0 ? a.b : 0);
        ++c;
    }
    b.b = d;
    b.e = e;
}
function Bo(a) {
    var b, c, d;
    d = a.b;
    if (Tp(a.i, d.length)) {
        c = d.length * 2;
        a.b = SC(PF, Are, 304, c, 0, 1);
        a.c = SC(PF, Are, 304, c, 0, 1);
        a.f = c - 1;
        a.i = 0;
        for(b = a.a; b; b = b.c)xo(a, b, b);
        ++a.g;
    }
}
function uUb(a, b) {
    a.b.a = $wnd.Math.min(a.b.a, b.c);
    a.b.b = $wnd.Math.min(a.b.b, b.d);
    a.a.a = $wnd.Math.max(a.a.a, b.c);
    a.a.b = $wnd.Math.max(a.a.b, b.d);
    return YCb(a.c, b), true;
}
function _lc(a, b, c) {
    var d;
    d = b.c.i;
    if (d.k == (DYb(), yYb)) {
        ZMb(a, (Iqc(), fqc), JD(WMb(d, fqc), 11));
        ZMb(a, gqc, JD(WMb(d, gqc), 11));
    } else {
        ZMb(a, (Iqc(), fqc), b.c);
        ZMb(a, gqc, c.d);
    }
}
function Lcd(a, b, c) {
    Icd();
    var d, e, f, g, h, i;
    g = b / 2;
    f = c / 2;
    d = $wnd.Math.abs(a.a);
    e = $wnd.Math.abs(a.b);
    h = 1;
    i = 1;
    d > g && (h = g / d);
    e > f && (i = f / e);
    wdd(a, $wnd.Math.min(h, i));
    return a;
}
function qvd() {
    Uud();
    var b, c;
    try {
        c = JD(f1d((rOd(), qOd), _Ce), 2059);
        if (c) return c;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            b = a;
            rEd((a9d(), b));
        } else throw scb(a);
    }
    return new mvd;
}
function j6d() {
    Uud();
    var b, c;
    try {
        c = JD(f1d((rOd(), qOd), BFe), 1986);
        if (c) return c;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            b = a;
            rEd((a9d(), b));
        } else throw scb(a);
    }
    return new f6d;
}
function Qie() {
    sie();
    var b, c;
    try {
        c = JD(f1d((rOd(), qOd), eGe), 2068);
        if (c) return c;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            b = a;
            rEd((a9d(), b));
        } else throw scb(a);
    }
    return new Mie;
}
function AZd(a, b, c) {
    var d, e;
    e = a.e;
    a.e = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 4, e, b);
        !c ? c = d : c.kj(d);
    }
    e != b && (b ? c = JZd(a, FZd(a, b), c) : c = JZd(a, a.a, c));
    return c;
}
function vB() {
    mB.call(this);
    this.e = -1;
    this.a = false;
    this.p = Lre;
    this.k = -1;
    this.c = -1;
    this.b = -1;
    this.g = false;
    this.f = -1;
    this.j = -1;
    this.n = -1;
    this.i = -1;
    this.d = -1;
    this.o = Lre;
}
function gFb(a, b) {
    var c, d, e;
    d = a.b.d.d;
    a.a || (d += a.b.d.a);
    e = b.b.d.d;
    b.a || (e += b.b.d.a);
    c = Heb(d, e);
    if (c == 0) {
        if (!a.a && b.a) return -1;
        else if (!b.a && a.a) return 1;
    }
    return c;
}
function fMb(a, b) {
    var c, d, e;
    d = a.b.b.d;
    a.a || (d += a.b.b.a);
    e = b.b.b.d;
    b.a || (e += b.b.b.a);
    c = Heb(d, e);
    if (c == 0) {
        if (!a.a && b.a) return -1;
        else if (!b.a && a.a) return 1;
    }
    return c;
}
function _Rb(a, b) {
    var c, d, e;
    d = a.b.g.d;
    a.a || (d += a.b.g.a);
    e = b.b.g.d;
    b.a || (e += b.b.g.a);
    c = Heb(d, e);
    if (c == 0) {
        if (!a.a && b.a) return -1;
        else if (!b.a && a.a) return 1;
    }
    return c;
}
function jQb() {
    jQb = Zcb;
    gQb = C9c(E9c(E9c(E9c(new J9c, (CQb(), AQb), (u5b(), Q4b)), AQb, U4b), BQb, _4b), BQb, E4b);
    iQb = E9c(E9c(new J9c, AQb, u4b), AQb, F4b);
    hQb = C9c(new J9c, BQb, H4b);
}
function V_b(a) {
    var b, c, d, e, f;
    b = JD(WMb(a, (Iqc(), Opc)), 91);
    f = a.n;
    for(d = b.Bc().Jc(); d.Ob();){
        c = JD(d.Pb(), 315);
        e = c.i;
        e.c += f.a;
        e.d += f.b;
        c.c ? XHb(c) : ZHb(c);
    }
    ZMb(a, Opc, null);
}
function tjc(a, b, c) {
    var d, e;
    e = a.b;
    d = e.d;
    switch(b.g){
        case 1:
            return -d.d - c;
        case 2:
            return e.o.a + d.c + c;
        case 3:
            return e.o.b + d.a + c;
        case 4:
            return -d.b - c;
        default:
            return -1;
    }
}
function UCc(a, b) {
    var c, d;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        a.c[c.c.p][c.p].a = wvb(a.i);
        a.c[c.c.p][c.p].d = Beb(a.c[c.c.p][c.p].a);
        a.c[c.c.p][c.p].b = 1;
    }
}
function Lld(a, b) {
    var c, d, e, f;
    f = 0;
    for(d = new rmb(a); d.a < d.c.c.length;){
        c = JD(pmb(d), 162);
        f += $wnd.Math.pow(cmd(c) * bmd(c) - b, 2);
    }
    e = $wnd.Math.sqrt(f / (a.c.length - 1));
    return e;
}
function FHc(a, b, c) {
    var d, e;
    c.Sg('Interactive node placement', 1);
    a.a = JD(WMb(b, (Iqc(), Aqc)), 313);
    for(e = new rmb(b.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        EHc(a, d);
    }
    c.Tg();
}
function F_c(a) {
    var b, c, d, e, f;
    d = 0;
    e = mze;
    if (a.b) for(b = 0; b < 360; b++){
        c = b * 0.017453292519943295;
        D_c(a, a.d, 0, 0, $ze, c);
        f = a.b.Bg(a.d);
        if (f < e) {
            d = c;
            e = f;
        }
    }
    D_c(a, a.d, 0, 0, $ze, d);
}
function c5c(a, b) {
    var c, d, e, f;
    f = new Irb;
    b.e = null;
    b.f = null;
    for(d = new rmb(b.i); d.a < d.c.c.length;){
        c = JD(pmb(d), 68);
        e = JD(Nib(a.g, c.a), 47);
        c.a = _cd(c.b);
        Qib(f, c.a, e);
    }
    a.g = f;
}
function T4c(a, b, c) {
    var d, e, f, g, h, i;
    e = b - a.e;
    f = e / a.d.c.length;
    g = 0;
    for(i = new rmb(a.d); i.a < i.c.c.length;){
        h = JD(pmb(i), 316);
        d = a.b - h.b + c;
        v4c(h, h.e + g * f, h.f);
        r4c(h, f, d);
        ++g;
    }
}
function UKd(a) {
    var b;
    a.f.Yj();
    if (a.b != -1) {
        ++a.b;
        b = a.f.d[a.a];
        if (a.b < b.i) return;
        ++a.a;
    }
    for(; a.a < a.f.d.length; ++a.a){
        b = a.f.d[a.a];
        if (!!b && b.i != 0) {
            a.b = 0;
            return;
        }
    }
    a.b = -1;
}
function c9d(a, b) {
    var c, d, e;
    e = b.c.length;
    c = e9d(a, e == 0 ? '' : (sDb(0, b.c.length), OD(b.c[0])));
    for(d = 1; d < e && !!c; ++d)c = JD(c, 52).Vh((sDb(d, b.c.length), OD(b.c[d])));
    return c;
}
function mGc(a, b, c, d) {
    var e, f, g;
    f = hGc(a, b, c, d);
    g = nGc(a, f);
    EGc(a, b, c, d);
    _Fc(a.b);
    pnb();
    Slb(f, new OGc(a));
    e = nGc(a, f);
    EGc(a, c, b, d);
    _Fc(a.b);
    return new xod(jfb(g), jfb(e));
}
function J7c(a, b) {
    var c;
    b.Sg('Delaunay triangulation', 1);
    c = new Ulb;
    Llb(a.i, new N7c(c));
    ydb(LD(WMb(a, (YLb(), WLb))));
    !a.e ? a.e = DDb(c) : xe(a.e, DDb(c));
    b.Tg();
}
function pnd(a, b, c) {
    var d, e;
    pud(a, a.j + b, a.k + c);
    for(e = new CHd((!a.a && (a.a = new qVd(u3, a, 5)), a.a)); e.e != e.i.gc();){
        d = JD(AHd(e), 369);
        ysd(d, d.a + b, d.b + c);
    }
    iud(a, a.b + b, a.c + c);
}
function xtd(a, b, c, d) {
    switch(c){
        case 7:
            return !a.e && (a.e = new ree(x3, a, 7, 4)), PGd(a.e, b, d);
        case 8:
            return !a.d && (a.d = new ree(x3, a, 8, 5)), PGd(a.d, b, d);
    }
    return Jsd(a, b, c, d);
}
function ytd(a, b, c, d) {
    switch(c){
        case 7:
            return !a.e && (a.e = new ree(x3, a, 7, 4)), QGd(a.e, b, d);
        case 8:
            return !a.d && (a.d = new ree(x3, a, 8, 5)), QGd(a.d, b, d);
    }
    return Ksd(a, b, c, d);
}
function zyd(a, b, c) {
    var d, e, f, g, h;
    if (c) {
        f = c.a.length;
        d = new Rpe(f);
        for(h = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); h.Ob();){
            g = JD(h.Pb(), 17);
            e = _xd(c, g.a);
            !!e && vzd(a, e, b);
        }
    }
}
function EJd(a, b, c) {
    var d, e, f, g, h;
    a.Yj();
    f = b == null ? 0 : tb(b);
    if (a.f > 0) {
        g = (f & Hqe) % a.d.length;
        e = tJd(a, g, f, b);
        if (e) {
            h = e.ld(c);
            return h;
        }
    }
    d = a._j(f, b, c);
    a.c.Ec(d);
    return null;
}
function mae(a, b) {
    var c, d, e, f;
    switch(hae(a, b).Hl()){
        case 3:
        case 2:
            c = HTd(b);
            for(e = 0, f = c.i; e < f; ++e){
                d = JD(nDd(c, e), 35);
                if (Tae(jae(a, d)) == 5) return d;
            }
            break;
    }
    return null;
}
function ct(a) {
    var b, c, d, e, f;
    if (Tp(a.f, a.b.length)) {
        d = SC(MG, Are, 226, a.b.length * 2, 0, 1);
        a.b = d;
        e = d.length - 1;
        for(c = a.a; c != a; c = c.Zd()){
            f = JD(c, 226);
            b = f.d & e;
            f.a = d[b];
            d[b] = f;
        }
    }
}
function FJb(a, b) {
    var c, d, e, f;
    f = 0;
    for(e = JD(JD(Qc(a.r, b), 22), 83).Jc(); e.Ob();){
        d = JD(e.Pb(), 115);
        f = $wnd.Math.max(f, d.e.a + d.b.Kf().a);
    }
    c = JD(Kqb(a.b, b), 126);
    c.n.b = 0;
    c.a.a = f;
}
function OKb(a, b) {
    var c, d, e, f;
    c = 0;
    for(f = JD(JD(Qc(a.r, b), 22), 83).Jc(); f.Ob();){
        e = JD(f.Pb(), 115);
        c = $wnd.Math.max(c, e.e.b + e.b.Kf().b);
    }
    d = JD(Kqb(a.b, b), 126);
    d.n.d = 0;
    d.a.b = c;
}
function iCc(a) {
    var b, c, d;
    for(c = new rmb(a.p); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        if (b.k != (DYb(), AYb)) continue;
        d = b.o.b;
        a.i = $wnd.Math.min(a.i, d);
        a.g = $wnd.Math.max(a.g, d);
    }
}
function RCc(a, b, c) {
    var d, e, f;
    for(f = new rmb(b); f.a < f.c.c.length;){
        d = JD(pmb(f), 9);
        a.c[d.c.p][d.p].e = false;
    }
    for(e = new rmb(b); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        QCc(a, d, c);
    }
}
function jMc(a) {
    var b, c;
    c = JD(WMb(a, (Iqc(), Wpc)), 22);
    b = K9c(aMc);
    c.Gc(($oc(), Xoc)) && D9c(b, dMc);
    c.Gc(Zoc) && D9c(b, fMc);
    c.Gc(Qoc) && D9c(b, bMc);
    c.Gc(Soc) && D9c(b, cMc);
    return b;
}
function Pcd(a) {
    if (a < 0) throw scb(new Teb('The input must be positive'));
    else return a < Hcd.length ? Ocb(Hcd[a]) : $wnd.Math.sqrt($ze * a) * (Wcd(a, a) / Vcd(2.718281828459045, a));
}
function mDd(a, b) {
    var c;
    if (a.Vi() && b != null) for(c = 0; c < a.i; ++c){
        if (pb(b, a.g[c])) return true;
    }
    else for(c = 0; c < a.i; ++c){
        if (XD(a.g[c]) === XD(b)) return true;
    }
    return false;
}
function xr(a, b) {
    if (b == null) while(a.a.Ob()){
        if (JD(a.a.Pb(), 43).kd() == null) return true;
    }
    else while(a.a.Ob()){
        if (pb(b, JD(a.a.Pb(), 43).kd())) return true;
    }
    return false;
}
function Iy(a, b) {
    var c, d, e;
    if (b === a) return true;
    else if (RD(b, 663)) {
        e = JD(b, 1992);
        return Se((d = a.g, !d ? a.g = new Bi(a) : d), (c = e.g, !c ? e.g = new Bi(e) : c));
    } else return false;
}
function _z(a) {
    var b, c, d, e;
    b = '$z';
    c = 'nz';
    e = $wnd.Math.min(a.length, 5);
    for(d = e - 1; d >= 0; d--)if (cgb(a[d].d, b) || cgb(a[d].d, c)) {
        a.length >= d + 1 && a.splice(0, d + 1);
        break;
    }
    return a;
}
function xcb(a, b) {
    var c;
    if (Ccb(a) && Ccb(b)) {
        c = a / b;
        if (Fse < c && c < Dse) return c < 0 ? $wnd.Math.ceil(c) : $wnd.Math.floor(c);
    }
    return wcb(aD(Ccb(a) ? Ncb(a) : a, Ccb(b) ? Ncb(b) : b, false));
}
function bWb(a, b) {
    if (b == a.c.i) return a.d.i;
    else if (b == a.d.i) return a.c.i;
    else throw scb(new Teb("'node' must either be the source node or target node of the edge."));
}
function Y$b(a) {
    var b, c, d, e;
    e = JD(WMb(a, (Iqc(), Jpc)), 36);
    if (e) {
        d = new Cdd;
        b = gYb(a.c.i);
        while(b != e){
            c = b.e;
            b = gYb(c);
            ldd(mdd(mdd(d, c.n), b.c), b.d.b, b.d.d);
        }
        return d;
    }
    return S$b;
}
function Dac(a) {
    var b;
    b = JD(WMb(a, (Iqc(), zqc)), 333);
    EBb(DBb(new RBb(null, new Gvb(b.d, 16)), new Qac), new Sac(a));
    EBb(BBb(new RBb(null, new Gvb(b.d, 16)), new Uac), new Wac(a));
}
function Jlc(a, b) {
    var c, d, e, f;
    e = b ? kYb(a) : hYb(a);
    for(d = new es(Ir(e.a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        f = bWb(c, a);
        if (f.k == (DYb(), yYb) && f.c != a.c) return f;
    }
    return null;
}
function xNc(a, b, c) {
    var d, e;
    d = YNc(b.j, c.s, c.c) + YNc(c.e, b.s, b.c);
    e = YNc(c.j, b.s, b.c) + YNc(b.e, c.s, c.c);
    if (d == e) {
        if (d > 0) {
            a.b += 2;
            a.a += d;
        }
    } else {
        a.b += 1;
        a.a += $wnd.Math.min(d, e);
    }
}
function Txd(a, b) {
    var c, d;
    d = false;
    if (VD(b)) {
        d = true;
        Sxd(a, new GC(OD(b)));
    }
    if (!d) {
        if (RD(b, 241)) {
            d = true;
            Sxd(a, (c = Hdb(JD(b, 241)), new _B(c)));
        }
    }
    if (!d) throw scb(new rdb(uDe));
}
function BVd(a, b, c, d) {
    var e, f, g;
    e = new i_d(a.e, 1, 10, (g = b.c, RD(g, 88) ? JD(g, 29) : (cPd(), UOd)), (f = c.c, RD(f, 88) ? JD(f, 29) : (cPd(), UOd)), AUd(a, b), false);
    !d ? d = e : d.kj(e);
    return d;
}
function jYb(a) {
    var b, c;
    switch(JD(WMb(gYb(a), (Bwc(), Quc)), 417).g){
        case 0:
            b = a.n;
            c = a.o;
            return new Edd(b.a + c.a / 2, b.b + c.b / 2);
        case 1:
            return new Fdd(a.n);
        default:
            return null;
    }
}
function yoc() {
    yoc = Zcb;
    voc = new zoc(yve, 0);
    uoc = new zoc('LEFTUP', 1);
    xoc = new zoc('RIGHTUP', 2);
    toc = new zoc('LEFTDOWN', 3);
    woc = new zoc('RIGHTDOWN', 4);
    soc = new zoc('BALANCED', 5);
}
function gEc(a, b, c) {
    var d, e, f;
    d = Heb(a.a[b.p], a.a[c.p]);
    if (d == 0) {
        e = JD(WMb(b, (Iqc(), aqc)), 15);
        f = JD(WMb(c, aqc), 15);
        if (e.Gc(c)) return -1;
        else if (f.Gc(b)) return 1;
    }
    return d;
}
function n_c(a) {
    switch(a.g){
        case 1:
            return new NZc;
        case 2:
            return new PZc;
        case 3:
            return new LZc;
        case 0:
            return null;
        default:
            throw scb(new Teb(hAe + (a.f != null ? a.f : '' + a.g)));
    }
}
function Msd(a, b, c) {
    switch(b){
        case 1:
            !a.n && (a.n = new X0d(z3, a, 1, 7));
            RGd(a.n);
            !a.n && (a.n = new X0d(z3, a, 1, 7));
            vCd(a.n, JD(c, 16));
            return;
        case 2:
            Psd(a, OD(c));
            return;
    }
    hsd(a, b, c);
}
function btd(a, b, c) {
    switch(b){
        case 3:
            etd(a, Beb(MD(c)));
            return;
        case 4:
            gtd(a, Beb(MD(c)));
            return;
        case 5:
            htd(a, Beb(MD(c)));
            return;
        case 6:
            itd(a, Beb(MD(c)));
            return;
    }
    Msd(a, b, c);
}
function Hvd(a, b, c) {
    var d, e, f;
    f = (d = new k1d, d);
    e = qRd(f, b, null);
    !!e && e.lj();
    rvd(f, c);
    tCd((!a.c && (a.c = new X0d(m6, a, 12, 10)), a.c), f);
    tRd(f, 0);
    wRd(f, 1);
    vRd(f, true);
    uRd(f, true);
}
function f1d(a, b) {
    var c, d, e;
    c = zsb(a.i, b);
    if (RD(c, 240)) {
        e = JD(c, 240);
        e.vi() == null && undefined;
        return e.si();
    } else if (RD(c, 491)) {
        d = JD(c, 1983);
        e = d.b;
        return e;
    } else return null;
}
function $i(a, b, c, d) {
    var e, f;
    Qb(b);
    Qb(c);
    f = JD(Bn(a.d, b), 17);
    Ob(!!f, 'Row %s not in %s', b, a.e);
    e = JD(Bn(a.b, c), 17);
    Ob(!!e, 'Column %s not in %s', c, a.c);
    return aj(a, f.a, e.a, d);
}
function RC(a, b, c, d, e, f, g) {
    var h, i, j, k, l;
    k = e[f];
    j = f == g - 1;
    h = j ? d : 0;
    l = TC(h, k);
    d != 10 && WC(OC(a, g - f), b[f], c[f], h, l);
    if (!j) {
        ++f;
        for(i = 0; i < k; ++i)l[i] = RC(a, b, c, d, e, f, g);
    }
    return l;
}
function Ddc(a) {
    var b, c, d, e, f;
    for(d = new mjb(new djb(a.b).a); d.b;){
        c = kjb(d);
        b = JD(c.jd(), 9);
        f = JD(JD(c.kd(), 47).a, 9);
        e = JD(JD(c.kd(), 47).b, 8);
        mdd(vdd(b.n), mdd(odd(f.n), e));
    }
}
function IAc(a, b) {
    var c, d, e, f;
    for(f = new rmb(b.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        Emb(a.d);
        for(d = new es(Ir(kYb(e).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            FAc(a, e, c.d.i);
        }
    }
}
function BHd(b) {
    if (b.g == -1) throw scb(new Veb);
    b.Uj();
    try {
        b.i.ed(b.g);
        b.f = b.i.j;
        b.g < b.e && --b.e;
        b.g = -1;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) throw scb(new yqb);
        else throw scb(a);
    }
}
function FVb(a) {
    var b, c, d, e;
    e = -1;
    d = 0;
    for(c = new rmb(a); c.a < c.c.c.length;){
        b = JD(pmb(c), 248);
        if (b.c == (Eyc(), Byc)) {
            e = d == 0 ? 0 : d - 1;
            break;
        } else d == a.c.length - 1 && (e = d);
        d += 1;
    }
    return e;
}
function o4c(a) {
    var b, c, d, e;
    e = 0;
    b = 0;
    for(d = new rmb(a.c); d.a < d.c.c.length;){
        c = JD(pmb(d), 27);
        htd(c, a.e + e);
        itd(c, a.f);
        e += c.g + a.b;
        b = $wnd.Math.max(b, c.f + a.b);
    }
    a.d = e - a.b;
    a.a = b - a.b;
}
function TEb(a) {
    var b, c, d;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        d = b.d.c;
        b.d.c = b.d.d;
        b.d.d = d;
        d = b.d.b;
        b.d.b = b.d.a;
        b.d.a = d;
        d = b.b.a;
        b.b.a = b.b.b;
        b.b.b = d;
    }
    HEb(a);
}
function NRb(a) {
    var b, c, d;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        d = b.g.c;
        b.g.c = b.g.d;
        b.g.d = d;
        d = b.g.b;
        b.g.b = b.g.a;
        b.g.a = d;
        d = b.e.a;
        b.e.a = b.e.b;
        b.e.b = d;
    }
    ERb(a);
}
function Ojc(a) {
    var b, c, d, e, f;
    f = Ec(a.k);
    for(c = (Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        if (b != Pjd && !f.Gc(b)) return b;
    }
    return null;
}
function Ckc(a, b) {
    var c, d;
    d = JD(Bub(CBb(BBb(new RBb(null, new Gvb(b.j, 16)), new Lkc))), 11);
    if (d) {
        c = JD(Mlb(d.e, 0), 18);
        if (c) return JD(WMb(c, (Iqc(), jqc)), 17).a;
    }
    return pxc(a.c);
}
function UYc(a) {
    var b, c;
    c = ZBd(a);
    if (cr(c)) return null;
    else {
        b = (Qb(c), JD(Ar(new es(Ir(c.a.Jc(), new er))), 85));
        return _Bd(JD(nDd((!b.b && (b.b = new ree(v3, b, 4, 7)), b.b), 0), 84));
    }
}
function QRd(a) {
    var b;
    if (!a.o) {
        b = a.rk();
        b ? a.o = new Y4d(a, a, null) : a.Zk() ? a.o = new n2d(a, null) : Tae(jae((Gfe(), Efe), a)) == 1 ? a.o = new g5d(a) : a.o = new l5d(a, null);
    }
    return a.o;
}
function ofe(a, b, c, d) {
    var e, f, g, h, i;
    if (c.Th(b)) {
        e = (g = b, !g ? null : JD(d, 52).ci(g));
        if (e) {
            i = c.Ih(b);
            h = b.t;
            if (h > 1 || h == -1) {
                f = JD(i, 15);
                e.Wb(lfe(a, f));
            } else e.Wb(kfe(a, JD(i, 57)));
        }
    }
}
function Vcb(b, c, d, e) {
    Ucb();
    var f = Scb;
    $moduleName = c;
    $moduleBase = d;
    qcb = e;
    function g() {
        for(var a = 0; a < f.length; a++)f[a]();
    }
    if (b) try {
        Bqe(g)();
    } catch (a) {
        b(c, a);
    }
    else Bqe(g)();
}
function m_b(a, b) {
    var c, d, e, f;
    for(e = (f = new Ojb(a.b).a.vc().Jc(), new Ujb(f)); e.a.Ob();){
        d = (c = JD(e.a.Pb(), 43), JD(c.jd(), 34));
        if (Xeb(b, JD(d, 17)) < 0) return false;
    }
    return true;
}
function n_b(a, b) {
    var c, d, e, f;
    for(e = (f = new Ojb(a.b).a.vc().Jc(), new Ujb(f)); e.a.Ob();){
        d = (c = JD(e.a.Pb(), 43), JD(c.jd(), 34));
        if (Xeb(b, JD(d, 17)) > 0) return false;
    }
    return true;
}
function oic(a) {
    switch(JD(WMb(a.b, (Bwc(), Buc)), 379).g){
        case 1:
            EBb(FBb(DBb(new RBb(null, new Gvb(a.d, 16)), new Jic), new Lic), new Nic);
            break;
        case 2:
            qic(a);
            break;
        case 0:
            pic(a);
    }
}
function VPc(a, b, c) {
    var d, e, f;
    d = c;
    !d && (d = new wld);
    d.Sg('Layout', a.a.c.length);
    for(f = new rmb(a.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 44);
        if (d.Yg()) return;
        e.If(b, d.bh(1));
    }
    d.Tg();
}
function h4c(a, b) {
    var c, d;
    Plb(a.b, b);
    for(d = new rmb(a.n); d.a < d.c.c.length;){
        c = JD(pmb(d), 208);
        if (Nlb(c.c, b, 0) != -1) {
            Plb(c.c, b);
            o4c(c);
            c.c.c.length == 0 && Plb(a.n, c);
            break;
        }
    }
    b4c(a);
}
function u4c(a, b) {
    var c, d, e, f, g;
    g = a.f;
    e = 0;
    f = 0;
    for(d = new rmb(a.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 172);
        i4c(c, a.e, g);
        e4c(c, b);
        f = $wnd.Math.max(f, c.r);
        g += c.d + a.c;
        e = g;
    }
    a.d = f;
    a.b = e;
}
function Hed() {
    Hed = Zcb;
    Ged = new Ied('V_TOP', 0);
    Fed = new Ied('V_CENTER', 1);
    Eed = new Ied('V_BOTTOM', 2);
    Ced = new Ied('H_LEFT', 3);
    Bed = new Ied('H_CENTER', 4);
    Ded = new Ied('H_RIGHT', 5);
}
function _Td(a) {
    var b;
    if ((a.Db & 64) != 0) return fTd(a);
    b = new Jgb(fTd(a));
    b.a += ' (abstract: ';
    Fgb(b, (a.Bb & 256) != 0);
    b.a += ', interface: ';
    Fgb(b, (a.Bb & 512) != 0);
    b.a += ')';
    return b.a;
}
function tz(a) {
    var b;
    if (a.c == null) {
        b = XD(a.b) === XD(rz) ? null : a.b;
        a.d = b == null ? Rqe : UD(b) ? wz(ND(b)) : VD(b) ? Pre : eeb(rb(b));
        a.a = a.a + ': ' + (UD(b) ? vz(ND(b)) : b + '');
        a.c = '(' + a.d + ') ' + a.a;
    }
}
function vsb() {
    function b() {
        try {
            return (new Map).entries().next().done;
        } catch (a) {
            return false;
        }
    }
    if (typeof Map === Gqe && Map.prototype.entries && b()) return Map;
    else return wsb();
}
function wOc(a, b) {
    var c, d, e, f;
    f = new Ajb(a.e, 0);
    c = 0;
    while(f.b < f.d.gc()){
        d = Beb((rDb(f.b < f.d.gc()), MD(f.d.Xb(f.c = f.b++))));
        e = d - b;
        if (e > uze) return c;
        else e > -0.000001 && ++c;
    }
    return c;
}
function syd(a, b, c) {
    if (RD(b, 268)) return fyd(a, JD(b, 85), c);
    else if (RD(b, 273)) return gyd(a, JD(b, 273), c);
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b,
        c
    ])))));
}
function tyd(a, b, c) {
    if (RD(b, 268)) return hyd(a, JD(b, 85), c);
    else if (RD(b, 273)) return iyd(a, JD(b, 273), c);
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b,
        c
    ])))));
}
function IZd(a, b) {
    var c;
    if (b != a.b) {
        c = null;
        !!a.b && (c = nqd(a.b, a, -4, c));
        !!b && (c = mqd(b, a, -4, c));
        c = zZd(a, b, c);
        !!c && c.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 3, b, b));
}
function LZd(a, b) {
    var c;
    if (b != a.f) {
        c = null;
        !!a.f && (c = nqd(a.f, a, -1, c));
        !!b && (c = mqd(b, a, -1, c));
        c = BZd(a, b, c);
        !!c && c.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 0, b, b));
}
function ece(a, b, c, d) {
    var e, f, g, h;
    if (qqd(a.e)) {
        e = b.Ik();
        h = b.kd();
        f = c.kd();
        g = Abe(a, 1, e, h, f, e.Gk() ? Fbe(a, e, f, RD(e, 101) && (JD(e, 19).Bb & Pse) != 0) : -1, true);
        d ? d.kj(g) : d = g;
    }
    return d;
}
function wie(a) {
    var b, c, d;
    if (a == null) return null;
    c = JD(a, 15);
    if (c.dc()) return '';
    d = new Hgb;
    for(b = c.Jc(); b.Ob();){
        Egb(d, (Ihe(), OD(b.Pb())));
        d.a += ' ';
    }
    return hdb(d, d.a.length - 1);
}
function Aie(a) {
    var b, c, d;
    if (a == null) return null;
    c = JD(a, 15);
    if (c.dc()) return '';
    d = new Hgb;
    for(b = c.Jc(); b.Ob();){
        Egb(d, (Ihe(), OD(b.Pb())));
        d.a += ' ';
    }
    return hdb(d, d.a.length - 1);
}
function lCc(a, b) {
    var c, d, e, f, g;
    for(f = new rmb(b.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        for(d = new es(Ir(hYb(e).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            g = c.c.i.p;
            a.n[g] = a.n[g] - 1;
        }
    }
}
function TCc(a, b, c) {
    var d, e;
    d = a.c[b.c.p][b.p];
    e = a.c[c.c.p][c.p];
    if (d.a != null && e.a != null) return Aeb(d.a, e.a);
    else if (d.a != null) return -1;
    else if (e.a != null) return 1;
    return 0;
}
function UPc(a, b, c) {
    c.Sg('Tree layout', 1);
    f9c(a.b);
    i9c(a.b, (_Pc(), XPc), XPc);
    i9c(a.b, YPc, YPc);
    i9c(a.b, ZPc, ZPc);
    i9c(a.b, $Pc, $Pc);
    a.a = d9c(a.b, b);
    VPc(a, b, c.bh(1));
    c.Tg();
    return b;
}
function Nyd(a, b) {
    var c, d, e, f, g, h;
    if (b) {
        f = b.a.length;
        c = new Rpe(f);
        for(h = (c.b - c.a) * c.c < 0 ? (Qpe(), Ppe) : new lqe(c); h.Ob();){
            g = JD(h.Pb(), 17);
            e = _xd(b, g.a);
            d = new lAd(a);
            Oyd(d.a, e);
        }
    }
}
function czd(a, b) {
    var c, d, e, f, g, h;
    if (b) {
        f = b.a.length;
        c = new Rpe(f);
        for(h = (c.b - c.a) * c.c < 0 ? (Qpe(), Ppe) : new lqe(c); h.Ob();){
            g = JD(h.Pb(), 17);
            e = _xd(b, g.a);
            d = new Fzd(a);
            Byd(d.a, e);
        }
    }
}
function ZNd(b) {
    var c;
    if (b != null && b.length > 0 && _fb(b, b.length - 1) == 33) try {
        c = INd(qgb(b, 0, b.length - 1));
        return c.e == null;
    } catch (a) {
        a = rcb(a);
        if (!RD(a, 32)) throw scb(a);
    }
    return false;
}
function EVb(a, b, c) {
    var d, e, f;
    d = gYb(b);
    e = sXb(d);
    f = new bZb;
    _Yb(f, b);
    switch(c.g){
        case 1:
            aZb(f, Tjd(Wjd(e)));
            break;
        case 2:
            aZb(f, Wjd(e));
    }
    ZMb(f, (Bwc(), Dvc), MD(WMb(a, Dvc)));
    return f;
}
function w6b(a) {
    var b, c;
    b = JD(ds(new es(Ir(hYb(a.a).a.Jc(), new er))), 18);
    c = JD(ds(new es(Ir(kYb(a.a).a.Jc(), new er))), 18);
    return ydb(LD(WMb(b, (Iqc(), xqc)))) || ydb(LD(WMb(c, xqc)));
}
function $gc() {
    $gc = Zcb;
    Wgc = new _gc('ONE_SIDE', 0);
    Ygc = new _gc('TWO_SIDES_CORNER', 1);
    Zgc = new _gc('TWO_SIDES_OPPOSING', 2);
    Xgc = new _gc('THREE_SIDES', 3);
    Vgc = new _gc('FOUR_SIDES', 4);
}
function Emc(a, b) {
    var c, d, e, f;
    f = new Ulb;
    e = 0;
    d = b.Jc();
    while(d.Ob()){
        c = jfb(JD(d.Pb(), 17).a + e);
        while(c.a < a.f && !gmc(a, c.a)){
            c = jfb(c.a + 1);
            ++e;
        }
        if (c.a >= a.f) break;
        YCb(f.c, c);
    }
    return f;
}
function iIc(a) {
    var b, c;
    for(c = new rmb(a.e.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        zIc(a, b);
    }
    EBb(BBb(DBb(DBb(new RBb(null, new Gvb(a.e.b, 16)), new zJc), new WJc), new YJc), new $Jc(a));
}
function NFd(a, b) {
    if (!b) return false;
    else {
        if (a.jj(b)) return false;
        if (!a.i) {
            if (RD(b, 150)) {
                a.i = JD(b, 150);
                return true;
            } else {
                a.i = new EGd;
                return a.i.kj(b);
            }
        } else return a.i.kj(b);
    }
}
function ace(a, b, c) {
    var d, e, f;
    d = b.Ik();
    f = b.kd();
    e = d.Gk() ? Abe(a, 3, d, null, f, Fbe(a, d, f, RD(d, 101) && (JD(d, 19).Bb & Pse) != 0), true) : Abe(a, 1, d, d.fk(), f, -1, true);
    c ? c.kj(e) : c = e;
    return c;
}
function tie(a) {
    a = Ipe(a, true);
    if (cgb(CBe, a) || cgb('1', a)) return xdb(), wdb;
    else if (cgb(DBe, a) || cgb('0', a)) return xdb(), vdb;
    throw scb(new fhe("Invalid boolean value: '" + a + "'"));
}
function Kd(a, b, c) {
    var d, e, f;
    for(e = a.vc().Jc(); e.Ob();){
        d = JD(e.Pb(), 43);
        f = d.jd();
        if (XD(b) === XD(f) || b != null && pb(b, f)) {
            if (c) {
                d = new okb(d.jd(), d.kd());
                e.Qb();
            }
            return d;
        }
    }
    return null;
}
function fKb(a) {
    aKb();
    var b, c, d;
    if (!a.B.Gc((Nkd(), Fkd))) return;
    d = a.f.i;
    b = new hdd(a.a.c);
    c = new LYb;
    c.b = b.c - d.c;
    c.d = b.d - d.d;
    c.c = d.c + d.b - (b.c + b.b);
    c.a = d.d + d.a - (b.d + b.a);
    a.e.Yf(c);
}
function MLb(a, b, c, d) {
    var e, f, g;
    g = $wnd.Math.min(c, PLb(JD(a.b, 68), b, c, d));
    for(f = new rmb(a.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 224);
        e != b && (g = $wnd.Math.min(g, MLb(e, b, g, d)));
    }
    return g;
}
function mWb(a) {
    var b, c, d, e;
    e = SC(RP, hre, 199, a.b.c.length, 0, 2);
    d = new Ajb(a.b, 0);
    while(d.b < d.d.gc()){
        b = (rDb(d.b < d.d.gc()), JD(d.d.Xb(d.c = d.b++), 25));
        c = d.b - 1;
        e[c] = DXb(b.a);
    }
    return e;
}
function o_b(a, b, c) {
    var d, e, f;
    d = JD(Tsb(a.a, c), 34);
    if (d != null) {
        f = JD(Tsb(a.b, d), 67);
        ye(f, c, true);
    }
    e = JD(Tsb(a.b, b), 67);
    if (!e) {
        e = new Mtb;
        Usb(a.b, b, e);
    }
    Dtb(e, c, e.c.b, e.c);
    Usb(a.a, c, b);
}
function l0b(a, b, c, d, e) {
    var f, g, h, i;
    g = gLb(fLb(kLb(i0b(c)), d), d0b(a, c, e));
    for(i = oYb(a, c).Jc(); i.Ob();){
        h = JD(i.Pb(), 11);
        if (b[h.p]) {
            f = b[h.p].i;
            Ilb(g.d, new DLb(f, dLb(g, f)));
        }
    }
    eLb(g);
}
function vfc(a, b) {
    this.f = new Irb;
    this.b = new Irb;
    this.j = new Irb;
    this.a = a;
    this.c = b;
    this.c > 0 && ufc(this, this.c - 1, (Rjd(), wjd));
    this.c < this.a.length - 1 && ufc(this, this.c + 1, (Rjd(), Qjd));
}
function fkc(a, b) {
    var c, d, e, f, g;
    for(f = new rmb(b.d); f.a < f.c.c.length;){
        e = JD(pmb(f), 105);
        g = JD(Nib(a.c, e), 116).o;
        for(d = new Drb(e.b); d.a < d.c.a.length;){
            c = JD(Crb(d), 64);
            rgc(e, c, g);
        }
    }
}
function tDc(a) {
    a.length > 0 && a[0].length > 0 && (this.c = ydb(LD(WMb(gYb(a[0][0]), (Iqc(), bqc)))));
    this.a = SC(QW, hre, 2063, a.length, 0, 2);
    this.b = SC(TW, hre, 2064, a.length, 0, 2);
    this.d = new Gs;
}
function WIc(a) {
    if (a.c.length == 0) return false;
    if ((sDb(0, a.c.length), JD(a.c[0], 18)).c.i.k == (DYb(), yYb)) return true;
    return xBb(FBb(new RBb(null, new Gvb(a, 16)), new ZIc), new _Ic);
}
function L_c(a, b) {
    var c, d, e, f, g, h, i;
    h = TYc(b);
    f = b.f;
    i = b.g;
    g = $wnd.Math.sqrt(f * f + i * i);
    e = 0;
    for(d = new rmb(h); d.a < d.c.c.length;){
        c = JD(pmb(d), 27);
        e += L_c(a, c);
    }
    return $wnd.Math.max(e, g);
}
function ajd() {
    ajd = Zcb;
    _id = new djd(eue, 0);
    $id = new djd('FREE', 1);
    Zid = new djd('FIXED_SIDE', 2);
    Wid = new djd('FIXED_ORDER', 3);
    Yid = new djd('FIXED_RATIO', 4);
    Xid = new djd('FIXED_POS', 5);
}
function X9d(a, b) {
    var c, d, e;
    c = b.mi(a.a);
    if (c) {
        e = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), cGe));
        for(d = 1; d < (Gfe(), Ffe).length; ++d){
            if (cgb(Ffe[d], e)) return d;
        }
    }
    return 0;
}
function Tmb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        uxb(f, '' + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function Zmb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        uxb(f, '' + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function Md(a) {
    var b, c, d;
    d = new xxb(Lqe, '{', '}');
    for(c = a.vc().Jc(); c.Ob();){
        b = JD(c.Pb(), 43);
        uxb(d, Nd(a, b.jd()) + '=' + Nd(a, b.kd()));
    }
    return !d.a ? d.c : d.e.length == 0 ? d.a.a : d.a.a + ('' + d.e);
}
function GGb(a) {
    var b, c, d, e;
    while(!elb(a.o)){
        c = JD(jlb(a.o), 47);
        d = JD(c.a, 123);
        b = JD(c.b, 216);
        e = AFb(b, d);
        if (b.e == d) {
            QFb(e.g, b);
            d.e = e.e + b.a;
        } else {
            QFb(e.b, b);
            d.e = e.e - b.a;
        }
        Ilb(a.e.a, d);
    }
}
function g3b(a, b) {
    var c, d, e;
    c = null;
    for(e = JD(b.Kb(a), 20).Jc(); e.Ob();){
        d = JD(e.Pb(), 18);
        if (!c) c = d.c.i == a ? d.d.i : d.c.i;
        else {
            if ((d.c.i == a ? d.d.i : d.c.i) != c) return false;
        }
    }
    return true;
}
function XNc(a, b) {
    var c, d, e, f, g;
    c = xMc(a, false, b);
    for(e = new rmb(c); e.a < e.c.c.length;){
        d = JD(pmb(e), 133);
        d.d == 0 ? (cNc(d, null), dNc(d, null)) : (f = d.a, g = d.b, cNc(d, g), dNc(d, f), undefined);
    }
}
function TOc(a) {
    var b, c;
    b = new J9c;
    D9c(b, FOc);
    c = JD(WMb(a, (Iqc(), Wpc)), 22);
    c.Gc(($oc(), Zoc)) && D9c(b, JOc);
    c.Gc(Qoc) && D9c(b, GOc);
    c.Gc(Xoc) && D9c(b, IOc);
    c.Gc(Soc) && D9c(b, HOc);
    return b;
}
function az(a, b, c) {
    var d, e, f, g, h;
    String.fromCharCode(10);
    bz(a);
    for(e = (a.k == null && (a.k = SC(iJ, hre, 80, 0, 0, 1)), a.k), f = 0, g = e.length; f < g; ++f){
        d = e[f];
        az(d, b, '\t' + c);
    }
    h = a.f;
    !!h && az(h, b, c);
}
function x7b(a) {
    var b, c, d, e;
    w7b(a);
    for(c = new es(Ir(eYb(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        d = b.c.i == a;
        e = d ? b.d : b.c;
        d ? hWb(b, null) : gWb(b, null);
        ZMb(b, (Iqc(), oqc), e);
        B7b(a, e.i);
    }
}
function zjc(a, b, c, d) {
    var e, f;
    f = b.i;
    e = c[f.g][a.d[f.g]];
    switch(f.g){
        case 1:
            e -= d + b.j.b;
            b.g.b = e;
            break;
        case 3:
            e += d;
            b.g.b = e;
            break;
        case 4:
            e -= d + b.j.a;
            b.g.a = e;
            break;
        case 2:
            e += d;
            b.g.a = e;
    }
}
function _Hc(a, b, c) {
    var d, e, f, g;
    g = Nlb(a.e, b, 0);
    f = new aIc;
    f.b = c;
    d = new Ajb(a.e, g);
    while(d.b < d.d.gc()){
        e = (rDb(d.b < d.d.gc()), JD(d.d.Xb(d.c = d.b++), 9));
        e.p = c;
        Ilb(f.e, e);
        tjb(d);
    }
    return f;
}
function NYc(a) {
    var b, c, d;
    for(c = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 27);
        d = ZBd(b);
        if (!cs(new es(Ir(d.a.Jc(), new er)))) return b;
    }
    return null;
}
function jZc() {
    jZc = Zcb;
    hZc = new kZc('OVERLAP_REMOVAL', 0);
    eZc = new kZc(dAe, 1);
    iZc = new kZc('ROTATION', 2);
    fZc = new kZc('GRAPH_SIZE_CALCULATION', 3);
    gZc = new kZc('OUTGOING_EDGE_ANGLES', 4);
}
function Ewd() {
    var a;
    if (Awd) return JD(g1d((rOd(), qOd), _Ce), 2061);
    a = JD(RD(Oib((rOd(), qOd), _Ce), 552) ? Oib(qOd, _Ce) : new Dwd, 552);
    Awd = true;
    Bwd(a);
    Cwd(a);
    Vvd(a);
    Rib(qOd, _Ce, a);
    return a;
}
function mce(a, b, c) {
    var d, e;
    if (a.j == 0) return c;
    e = JD(EUd(a, b, c), 74);
    d = c.Ik();
    if (!d.ok() || !a.a.Zl(d)) throw scb(new qz("Invalid entry feature '" + d.nk().zb + '.' + d.ve() + "'"));
    return e;
}
function Wi(a, b) {
    var c, d, e, f, g, h, i, j;
    for(h = a.a, i = 0, j = h.length; i < j; ++i){
        g = h[i];
        for(d = g, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (XD(b) === XD(c) || b != null && pb(b, c)) return true;
        }
    }
    return false;
}
function pib(a) {
    var b, c, d;
    if (vcb(a, 0) >= 0) {
        c = xcb(a, Ese);
        d = Ecb(a, Ese);
    } else {
        b = Lcb(a, 1);
        c = xcb(b, 500000000);
        d = Ecb(b, 500000000);
        d = tcb(Jcb(d, 1), ucb(a, 1));
    }
    return Icb(Jcb(d, 32), ucb(c, Use));
}
function sjc(a, b, c, d) {
    var e, f, g, h, i;
    i = a.b;
    f = b.d;
    g = f.j;
    h = xjc(g, i.d[g.g], c);
    e = mdd(odd(f.n), f.a);
    switch(f.j.g){
        case 1:
        case 3:
            h.a += e.a;
            break;
        case 2:
        case 4:
            h.b += e.b;
    }
    Dtb(d, h, d.c.b, d.c);
}
function A2c(a, b, c, d) {
    var e, f, g, h, i;
    e = null;
    f = 0;
    for(h = new rmb(b); h.a < h.c.c.length;){
        g = JD(pmb(h), 27);
        i = g.i + g.g;
        if (a < g.j + g.f + d) {
            !e ? e = g : c.i - i < c.i - f && (e = g);
            f = e.i + e.g;
        }
    }
    return !e ? 0 : f + d;
}
function B2c(a, b, c, d) {
    var e, f, g, h, i;
    f = null;
    e = 0;
    for(h = new rmb(b); h.a < h.c.c.length;){
        g = JD(pmb(h), 27);
        i = g.j + g.f;
        if (a < g.i + g.g + d) {
            !f ? f = g : c.j - i < c.j - e && (f = g);
            e = f.j + f.f;
        }
    }
    return !f ? 0 : e + d;
}
function uA(a) {
    var b, c, d;
    b = false;
    d = a.b.c.length;
    for(c = 0; c < d; c++){
        if (vA(JD(Mlb(a.b, c), 431))) {
            if (!b && c + 1 < d && vA(JD(Mlb(a.b, c + 1), 431))) {
                b = true;
                JD(Mlb(a.b, c), 431).a = true;
            }
        } else b = false;
    }
}
function zib(a, b, c, d, e) {
    var f, g;
    f = 0;
    for(g = 0; g < e; g++){
        f = tcb(f, Mcb(ucb(b[g], Use), ucb(d[g], Use)));
        a[g] = Pcb(f);
        f = Kcb(f, 32);
    }
    for(; g < c; g++){
        f = tcb(f, ucb(b[g], Use));
        a[g] = Pcb(f);
        f = Kcb(f, 32);
    }
}
function Iib(a, b) {
    Cib();
    var c, d;
    d = (Ghb(), Bhb);
    c = a;
    for(; b > 1; b >>= 1){
        (b & 1) != 0 && (d = Nhb(d, c));
        c.d == 1 ? c = Nhb(c, c) : c = new Whb(Kib(c.a, c.d, SC(cE, ise, 30, c.d << 1, 15, 1)));
    }
    d = Nhb(d, c);
    return d;
}
function vvb() {
    vvb = Zcb;
    var a, b, c, d;
    svb = SC(aE, Rse, 30, 25, 15, 1);
    tvb = SC(aE, Rse, 30, 33, 15, 1);
    d = 1.52587890625E-5;
    for(b = 32; b >= 0; b--){
        tvb[b] = d;
        d *= 0.5;
    }
    c = 1;
    for(a = 24; a >= 0; a--){
        svb[a] = c;
        c *= 0.5;
    }
}
function m$b(a) {
    var b, c;
    if (ydb(LD(ksd(a, (Bwc(), Nuc))))) for(c = new es(Ir($Bd(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 85);
        if (Std(b)) {
            if (ydb(LD(ksd(b, Ouc)))) return true;
        }
    }
    return false;
}
function T8b(a) {
    var b, c, d, e;
    b = new Mtb;
    c = new Mtb;
    for(e = Gtb(a, 0); e.b != e.d.c;){
        d = JD(Utb(e), 11);
        d.e.c.length == 0 ? Dtb(c, d, c.c.b, c.c) : Dtb(b, d, b.c.b, b.c);
    }
    dv(b).Fc(c);
    return b;
}
function ngc(a, b) {
    var c, d, e;
    if (Nrb(a.f, b)) {
        b.b = a;
        d = b.c;
        Nlb(a.j, d, 0) != -1 || Ilb(a.j, d);
        e = b.d;
        Nlb(a.j, e, 0) != -1 || Ilb(a.j, e);
        c = b.a.b;
        if (c.c.length != 0) {
            !a.i && (a.i = new ygc(a));
            tgc(a.i, c);
        }
    }
}
function ujc(a) {
    var b, c, d, e, f;
    c = a.c.d;
    d = c.j;
    e = a.d.d;
    f = e.j;
    if (d == f) return c.p < e.p ? 0 : 1;
    else if (Ujd(d) == f) return 0;
    else if (Sjd(d) == f) return 1;
    else {
        b = a.b;
        return rrb(b.b, Ujd(d)) ? 0 : 1;
    }
}
function yzd(a, b) {
    var c, d, e, f, g, h;
    e = a;
    g = ayd(e, 'layoutOptions');
    !g && (g = ayd(e, dDe));
    if (g) {
        h = g;
        d = null;
        !!h && (d = (f = gC(h, SC(hJ, hre, 2, 0, 6, 1)), new uC(h, f)));
        if (d) {
            c = new nAd(h, b);
            ofb(d, c);
        }
    }
}
function _Bd(a) {
    if (RD(a, 206)) return JD(a, 27);
    else if (RD(a, 193)) return oxd(JD(a, 124));
    else if (!a) throw scb(new Ffb(IDe));
    else throw scb(new bhb('Only support nodes and ports.'));
}
function KA(a, b, c, d) {
    if (b >= 0 && cgb(a.substr(b, 3), 'GMT')) {
        c[0] = b + 3;
        return BA(a, c, d);
    }
    if (b >= 0 && cgb(a.substr(b, 3), 'UTC')) {
        c[0] = b + 3;
        return BA(a, c, d);
    }
    return BA(a, c, d);
}
function wgc(a, b) {
    var c, d, e, f, g;
    f = a.g.a;
    g = a.g.b;
    for(d = new rmb(a.d); d.a < d.c.c.length;){
        c = JD(pmb(d), 72);
        e = c.n;
        e.a = f;
        a.i == (Rjd(), xjd) ? e.b = g + a.j.b - c.o.b : e.b = g;
        mdd(e, b);
        f += c.o.a + a.e;
    }
}
function nld(a, b, c) {
    if (a.b) throw scb(new Web('The task is already done.'));
    else if (a.p != null) return false;
    else {
        a.p = b;
        a.r = c;
        a.k && (a.o = (Zgb(), Fcb(zcb(Date.now()), Vre)));
        return true;
    }
}
function gBd(a) {
    var b, c, d, e, f, g, h;
    h = new mC;
    c = a.Ng();
    e = c != null;
    e && Wxd(h, vDe, a.Ng());
    d = a.ve();
    f = d != null;
    f && Wxd(h, HDe, a.ve());
    b = a.Mg();
    g = b != null;
    g && Wxd(h, 'description', a.Mg());
    return h;
}
function nRd(a, b, c) {
    var d, e, f;
    f = a.q;
    a.q = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        e = new g_d(a, 1, 9, f, b);
        !c ? c = e : c.kj(e);
    }
    if (!b) !!a.r && (c = a.Vk(null, c));
    else {
        d = b.c;
        d != a.r && (c = a.Vk(d, c));
    }
    return c;
}
function B5d(a, b, c) {
    var d, e, f, g, h;
    c = (h = b, mqd(h, a.e, -1 - a.c, c));
    g = t5d(a.a);
    for(f = (d = new mjb(new djb(g.a).a), new S5d(d)); f.a.b;){
        e = JD(kjb(f.a).jd(), 87);
        c = JZd(e, FZd(e, a.a), c);
    }
    return c;
}
function C5d(a, b, c) {
    var d, e, f, g, h;
    c = (h = b, nqd(h, a.e, -1 - a.c, c));
    g = t5d(a.a);
    for(f = (d = new mjb(new djb(g.a).a), new S5d(d)); f.a.b;){
        e = JD(kjb(f.a).jd(), 87);
        c = JZd(e, FZd(e, a.a), c);
    }
    return c;
}
function iib(a, b, c, d) {
    var e, f, g;
    if (d == 0) $gb(b, 0, a, c, a.length - c);
    else {
        g = 32 - d;
        a[a.length - 1] = 0;
        for(f = a.length - 1; f > c; f--){
            a[f] |= b[f - c - 1] >>> g;
            a[f - 1] = b[f - c - 1] << d;
        }
    }
    for(e = 0; e < c; e++)a[e] = 0;
}
function NJb(a) {
    var b, c, d, e, f;
    b = 0;
    c = 0;
    for(f = a.Jc(); f.Ob();){
        d = JD(f.Pb(), 115);
        b = $wnd.Math.max(b, d.d.b);
        c = $wnd.Math.max(c, d.d.c);
    }
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 115);
        d.d.b = b;
        d.d.c = c;
    }
}
function VKb(a) {
    var b, c, d, e, f;
    c = 0;
    b = 0;
    for(f = a.Jc(); f.Ob();){
        d = JD(f.Pb(), 115);
        c = $wnd.Math.max(c, d.d.d);
        b = $wnd.Math.max(b, d.d.a);
    }
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 115);
        d.d.d = c;
        d.d.a = b;
    }
}
function mhc(a, b, c, d, e) {
    var f, g;
    f = JD(yBb(BBb(b.Mc(), new cic), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    vnb(f);
    g = JD(Yi(a.b, c, d), 15);
    e == 0 ? g.ad(0, f) : g.Fc(f);
}
function f8c(a, b, c) {
    c.Sg('Grow Tree', 1);
    a.b = b.f;
    if (ydb(LD(WMb(b, (YLb(), WLb))))) {
        a.c = new uMb;
        b8c(a, null);
    } else a.c = new uMb;
    a.a = false;
    d8c(a, b.f);
    ZMb(b, XLb, (xdb(), a.a ? true : false));
    c.Tg();
}
function cad(a) {
    var b;
    this.d = new Irb;
    this.c = a.c;
    this.e = a.d;
    this.b = a.b;
    this.f = new Xnd(a.e);
    this.a = a.a;
    !a.f ? this.g = (b = JD(deb(L4), 10), new urb(b, JD(VCb(b, b.length), 10), 0)) : this.g = a.f;
}
function end(a) {
    var b, c, d, e;
    b = null;
    for(e = new rmb(a.Pf()); e.a < e.c.c.length;){
        d = JD(pmb(e), 187);
        c = new gdd(d.Jf().a, d.Jf().b, d.Kf().a, d.Kf().b);
        !b ? b = c : edd(b, c);
    }
    !b && (b = new fdd);
    return b;
}
function Jsd(a, b, c, d) {
    var e, f;
    if (c == 1) return !a.n && (a.n = new X0d(z3, a, 1, 7)), PGd(a.n, b, d);
    return f = JD(QTd((e = JD(Crd(a, 16), 29), !e ? a.ei() : e), c), 69), f.tk().wk(a, Ard(a), c - VTd(a.ei()), b, d);
}
function fDd(a, b, c) {
    var d, e, f, g, h;
    d = c.gc();
    a.Yi(a.i + d);
    h = a.i - b;
    h > 0 && $gb(a.g, b, a.g, b + d, h);
    g = c.Jc();
    a.i += d;
    for(e = 0; e < d; ++e){
        f = g.Pb();
        jDd(a, b, a.Wi(b, f));
        a.Ji(b, f);
        a.Ki();
        ++b;
    }
    return d != 0;
}
function qRd(a, b, c) {
    var d;
    if (b != a.q) {
        !!a.q && (c = nqd(a.q, a, -10, c));
        !!b && (c = mqd(b, a, -10, c));
        c = nRd(a, b, c);
    } else if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new g_d(a, 1, 9, b, b);
        !c ? c = d : c.kj(d);
    }
    return c;
}
function ck(a, b, c, d) {
    Mb((c & ire) == 0, 'flatMap does not support SUBSIZED characteristic');
    Mb((c & 4) == 0, 'flatMap does not support SORTED characteristic');
    Qb(a);
    Qb(b);
    return new Kk(a, b, c, d);
}
function Zy(a, b) {
    uDb(b, 'Cannot suppress a null exception.');
    lDb(b != a, 'Exception can not suppress itself.');
    if (a.i) return;
    a.k == null ? a.k = WC(OC(iJ, 1), hre, 80, 0, [
        b
    ]) : a.k[a.k.length] = b;
}
function OIb(a, b) {
    var c;
    c = PIb(a.b.$f(), b.b.$f());
    if (c != 0) return c;
    switch(a.b.$f().g){
        case 1:
        case 2:
            return $eb(a.b.Lf(), b.b.Lf());
        case 3:
        case 4:
            return $eb(b.b.Lf(), a.b.Lf());
    }
    return 0;
}
function oNb(a) {
    var b, c, d;
    d = a.e.c.length;
    a.a = QC(cE, [
        hre,
        ise
    ], [
        54,
        30
    ], 15, [
        d,
        d
    ], 2);
    for(c = new rmb(a.c); c.a < c.c.c.length;){
        b = JD(pmb(c), 288);
        a.a[b.c.a][b.d.a] += JD(WMb(b, (IOb(), vOb)), 17).a;
    }
}
function Wud(a, b) {
    var c, d, e, f, g;
    if (a == null) return null;
    else {
        g = SC(_D, Ure, 30, 2 * b, 15, 1);
        for(d = 0, e = 0; d < b; ++d){
            c = a[d] >> 4 & 15;
            f = a[d] & 15;
            g[e++] = Sud[c];
            g[e++] = Sud[f];
        }
        return zgb(g, 0, g.length);
    }
}
function wgb(a) {
    var b, c;
    if (a >= Pse) {
        b = Qse + (a - Pse >> 10 & 1023) & Wre;
        c = 56320 + (a - Pse & 1023) & Wre;
        return String.fromCharCode(b) + ('' + String.fromCharCode(c));
    } else return String.fromCharCode(a & Wre);
}
function dKb(a, b) {
    aKb();
    var c, d, e, f;
    e = JD(JD(Qc(a.r, b), 22), 83);
    if (e.gc() >= 2) {
        d = JD(e.Jc().Pb(), 115);
        c = a.u.Gc((ojd(), jjd));
        f = a.u.Gc(njd);
        return !d.a && !c && (e.gc() == 2 || f);
    } else return false;
}
function yZc(a, b, c, d, e) {
    var f, g, h;
    f = zZc(a, b, c, d, e);
    h = false;
    while(!f){
        qZc(a, e, true);
        h = true;
        f = zZc(a, b, c, d, e);
    }
    h && qZc(a, e, false);
    g = QYc(e);
    if (g.c.length != 0) {
        !!a.d && a.d.Eg(g);
        yZc(a, e, c, d, g);
    }
}
function D0c() {
    D0c = Zcb;
    C0c = new E0c('NODE_SIZE_REORDERER', 0);
    z0c = new E0c('INTERACTIVE_NODE_REORDERER', 1);
    B0c = new E0c('MIN_SIZE_PRE_PROCESSOR', 2);
    A0c = new E0c('MIN_SIZE_POST_PROCESSOR', 3);
}
function Jhd() {
    Jhd = Zcb;
    Hhd = new Khd(yve, 0);
    Fhd = new Khd('DIRECTED', 1);
    Ihd = new Khd('UNDIRECTED', 2);
    Dhd = new Khd('ASSOCIATION', 3);
    Ghd = new Khd('GENERALIZATION', 4);
    Ehd = new Khd('DEPENDENCY', 5);
}
function Xmd(a, b) {
    var c;
    if (!oxd(a)) throw scb(new Web(tCe));
    c = oxd(a);
    switch(b.g){
        case 1:
            return -(a.j + a.f);
        case 2:
            return a.i - c.g;
        case 3:
            return a.j - c.f;
        case 4:
            return -(a.i + a.g);
    }
    return 0;
}
function cce(a, b, c) {
    var d, e, f;
    d = b.Ik();
    f = b.kd();
    e = d.Gk() ? Abe(a, 4, d, f, null, Fbe(a, d, f, RD(d, 101) && (JD(d, 19).Bb & Pse) != 0), true) : Abe(a, d.qk() ? 2 : 1, d, f, d.fk(), -1, true);
    c ? c.kj(e) : c = e;
    return c;
}
function _ub(a, b) {
    var c, d;
    tDb(b);
    d = a.b.c.length;
    Ilb(a.b, b);
    while(d > 0){
        c = d;
        d = (d - 1) / 2 | 0;
        if (a.a.Le(Mlb(a.b, d), b) <= 0) {
            Rlb(a.b, c, b);
            return true;
        }
        Rlb(a.b, c, Mlb(a.b, d));
    }
    Rlb(a.b, d, b);
    return true;
}
function DHb(a, b, c, d) {
    var e, f;
    e = 0;
    if (!c) for(f = 0; f < uHb; f++)e = $wnd.Math.max(e, sHb(a.a[f][b.g], d));
    else e = sHb(a.a[c.g][b.g], d);
    b == (iHb(), gHb) && !!a.b && (e = $wnd.Math.max(e, a.b.a));
    return e;
}
function nkc(a, b) {
    var c, d, e, f, g, h;
    e = a.i;
    f = b.i;
    if (!e || !f) return false;
    if (e.i != f.i || e.i == (Rjd(), wjd) || e.i == (Rjd(), Qjd)) return false;
    g = e.g.a;
    c = g + e.j.a;
    h = f.g.a;
    d = h + f.j.a;
    return g <= d && c >= h;
}
function P2c(a) {
    switch(a.g){
        case 0:
            return new D2c;
        case 1:
            return new J2c;
        default:
            throw scb(new Teb('No implementation is available for the width approximator ' + (a.f != null ? a.f : '' + a.g)));
    }
}
function Vxd(a, b, c, d) {
    var e;
    e = false;
    if (VD(d)) {
        e = true;
        Wxd(b, c, OD(d));
    }
    if (!e) {
        if (SD(d)) {
            e = true;
            Vxd(a, b, c, d);
        }
    }
    if (!e) {
        if (RD(d, 241)) {
            e = true;
            Uxd(b, c, JD(d, 241));
        }
    }
    if (!e) throw scb(new rdb(uDe));
}
function P9d(a, b) {
    var c, d, e;
    c = b.mi(a.a);
    if (c) {
        e = xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), sFe);
        if (e != null) for(d = 1; d < (Gfe(), Cfe).length; ++d){
            if (cgb(Cfe[d], e)) return d;
        }
    }
    return 0;
}
function Q9d(a, b) {
    var c, d, e;
    c = b.mi(a.a);
    if (c) {
        e = xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), sFe);
        if (e != null) for(d = 1; d < (Gfe(), Dfe).length; ++d){
            if (cgb(Dfe[d], e)) return d;
        }
    }
    return 0;
}
function Te(a, b) {
    var c, d, e, f;
    tDb(b);
    f = a.a.gc();
    if (f < b.gc()) for(c = a.a.ec().Jc(); c.Ob();){
        d = c.Pb();
        b.Gc(d) && c.Qb();
    }
    else for(e = b.Jc(); e.Ob();){
        d = e.Pb();
        a.a.Ac(d);
    }
    return f != a.a.gc();
}
function oUb(a) {
    var b, c;
    c = odd(Kdd(WC(OC(b2, 1), hre, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ])));
    b = a.i.d;
    switch(a.j.g){
        case 1:
            c.b -= b.d;
            break;
        case 2:
            c.a += b.c;
            break;
        case 3:
            c.b += b.a;
            break;
        case 4:
            c.a -= b.b;
    }
    return c;
}
function r6b(a) {
    var b;
    b = (k6b(), JD(ds(new es(Ir(hYb(a).a.Jc(), new er))), 18).c.i);
    while(b.k == (DYb(), yYb)){
        ZMb(b, (Iqc(), dqc), (xdb(), true));
        b = JD(ds(new es(Ir(hYb(b).a.Jc(), new er))), 18).c.i;
    }
}
function EGc(a, b, c, d) {
    var e, f, g, h;
    h = dGc(b, d);
    for(g = h.Jc(); g.Ob();){
        e = JD(g.Pb(), 11);
        a.d[e.p] = a.d[e.p] + a.c[c.p];
    }
    h = dGc(c, d);
    for(f = h.Jc(); f.Ob();){
        e = JD(f.Pb(), 11);
        a.d[e.p] = a.d[e.p] - a.c[b.p];
    }
}
function qnd(a, b, c) {
    var d, e;
    for(e = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); e.e != e.i.gc();){
        d = JD(AHd(e), 27);
        ftd(d, d.i + b, d.j + c);
    }
    ofb((!a.b && (a.b = new X0d(x3, a, 12, 3)), a.b), new wnd(b, c));
}
function Oxb(a, b, c, d) {
    var e, f;
    f = b;
    e = f.d == null || a.a.Le(c.d, f.d) > 0 ? 1 : 0;
    while(f.a[e] != c){
        f = f.a[e];
        e = a.a.Le(c.d, f.d) > 0 ? 1 : 0;
    }
    f.a[e] = d;
    d.b = c.b;
    d.a[0] = c.a[0];
    d.a[1] = c.a[1];
    c.a[0] = null;
    c.a[1] = null;
}
function LFb(a) {
    var b, c, d, e;
    b = new Ulb;
    c = SC(pcb, Vte, 30, a.a.c.length, 16, 1);
    Jmb(c, c.length);
    for(e = new rmb(a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 123);
        if (!c[d.d]) {
            YCb(b.c, d);
            KFb(a, d, c);
        }
    }
    return b;
}
function cRb(a, b) {
    var c, d, e, f, g;
    e = b == 1 ? WQb : VQb;
    for(d = e.a.ec().Jc(); d.Ob();){
        c = JD(d.Pb(), 86);
        for(g = JD(Qc(a.f.c, c), 22).Jc(); g.Ob();){
            f = JD(g.Pb(), 47);
            Plb(a.b.b, f.b);
            Plb(a.b.a, JD(f.b, 82).d);
        }
    }
}
function _2b(a, b) {
    var c;
    b.Sg('Hierarchical port position processing', 1);
    c = a.b;
    c.c.length > 0 && $2b((sDb(0, c.c.length), JD(c.c[0], 25)), a);
    c.c.length > 1 && $2b(JD(Mlb(c, c.c.length - 1), 25), a);
    b.Tg();
}
function rjd(a) {
    ojd();
    var b, c;
    b = nrb(kjd, WC(OC(u2, 1), Ere, 277, 0, [
        mjd
    ]));
    if (_x(Px(b, a)) > 1) return false;
    c = nrb(jjd, WC(OC(u2, 1), Ere, 277, 0, [
        ijd,
        njd
    ]));
    if (_x(Px(c, a)) > 1) return false;
    return true;
}
function hwd(a, b) {
    var c;
    c = Oib((rOd(), qOd), a);
    RD(c, 491) ? Rib(qOd, a, new W0d(this, b)) : Rib(qOd, a, this);
    dwd(this, b);
    if (b == (EOd(), DOd)) {
        this.wb = JD(this, 1984);
        JD(b, 1986);
    } else this.wb = (GOd(), FOd);
}
function e6d(b) {
    var c, d, e;
    if (b == null) return null;
    c = null;
    for(d = 0; d < Rud.length; ++d)try {
        return wZd(Rud[d], b);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 32)) {
            e = a;
            c = e;
        } else throw scb(a);
    }
    throw scb(new kOd(c));
}
function Bqb() {
    Bqb = Zcb;
    zqb = WC(OC(hJ, 1), hre, 2, 6, [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]);
    Aqb = WC(OC(hJ, 1), hre, 2, 6, [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        _re,
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ]);
}
function WMb(a, b) {
    var c, d;
    d = (!a.q && (a.q = new Irb), Nib(a.q, b));
    if (d != null) return d;
    c = b.Qg();
    RD(c, 4) && (c == null ? (!a.q && (a.q = new Irb), Sib(a.q, b)) : (!a.q && (a.q = new Irb), Qib(a.q, b, c)), a);
    return c;
}
function CQb() {
    CQb = Zcb;
    xQb = new DQb('P1_CYCLE_BREAKING', 0);
    yQb = new DQb('P2_LAYERING', 1);
    zQb = new DQb('P3_NODE_ORDERING', 2);
    AQb = new DQb('P4_NODE_PLACEMENT', 3);
    BQb = new DQb('P5_EDGE_ROUTING', 4);
}
function USb(a, b) {
    MSb();
    var c;
    if (a.c == b.c) {
        if (a.b == b.b || BSb(a.b, b.b)) {
            c = ySb(a.b) ? 1 : -1;
            if (a.a && !b.a) return c;
            else if (!a.a && b.a) return -c;
        }
        return $eb(a.b.g, b.b.g);
    } else return Heb(a.c, b.c);
}
function RDc(a, b, c, d) {
    var e, f, g, h, i;
    g = kGc(a.a, b, c);
    h = JD(g.a, 17).a;
    f = JD(g.b, 17).a;
    if (d) {
        i = JD(WMb(b, (Iqc(), sqc)), 9);
        e = JD(WMb(c, sqc), 9);
        if (!!i && !!e) {
            pfc(a.b, i, e);
            h += a.b.i;
            f += a.b.e;
        }
    }
    return h > f;
}
function HZc(a, b) {
    var c, d, e;
    if (sZc(a, b)) return true;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 27);
        e = UYc(c);
        if (rZc(a, c, e)) return true;
        if (FZc(a, c) - a.g <= a.a) return true;
    }
    return false;
}
function D6c() {
    D6c = Zcb;
    C6c = ($6c(), Z6c);
    z6c = V6c;
    y6c = T6c;
    w6c = P6c;
    x6c = R6c;
    v6c = new MYb(8);
    u6c = new NBd((Lgd(), Kfd), v6c);
    A6c = new NBd(wgd, 8);
    B6c = X6c;
    r6c = K6c;
    s6c = M6c;
    t6c = new NBd(Zed, (xdb(), false));
}
function ued() {
    ued = Zcb;
    red = new MYb(15);
    qed = new NBd((Lgd(), Kfd), red);
    ted = new NBd(wgd, 15);
    sed = new NBd(ggd, jfb(0));
    led = hfd;
    ned = Bfd;
    ped = Gfd;
    ied = new NBd(Qed, HBe);
    med = nfd;
    oed = Efd;
    jed = Sed;
    ked = Xed;
}
function mzd(a, b) {
    if (RD(b, 206)) return oyd(a, JD(b, 27));
    else if (RD(b, 193)) return pyd(a, JD(b, 124));
    else if (b) return null;
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b
    ])))));
}
function nzd(a, b) {
    if (RD(b, 359)) return ryd(a, JD(b, 153));
    else if (RD(b, 268)) return qyd(a, JD(b, 85));
    else if (b) return null;
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b
    ])))));
}
function iCd(a) {
    if ((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c).i != 1) throw scb(new Teb(KDe));
    return _Bd(JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84));
}
function jCd(a) {
    if ((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c).i != 1) throw scb(new Teb(KDe));
    return _Bd(JD(nDd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c), 0), 84));
}
function AEd(a, b, c) {
    var d, e, f;
    ++a.j;
    e = a.Bj();
    if (b >= e || b < 0) throw scb(new mdb(NDe + b + ODe + e));
    if (c >= e || c < 0) throw scb(new mdb(PDe + c + ODe + e));
    b != c ? d = (f = a.zj(c), a.nj(b, f), f) : d = a.uj(c);
    return d;
}
function efe(a) {
    var b, c, d;
    d = a;
    if (a) {
        b = 0;
        for(c = a.Ah(); c; c = c.Ah()){
            if (++b > Sse) return efe(c);
            d = c;
            if (c == a) throw scb(new Web('There is a cycle in the containment hierarchy of ' + a));
        }
    }
    return d;
}
function Ee(a) {
    var b, c, d;
    d = new xxb(Lqe, '[', ']');
    for(c = a.Jc(); c.Ob();){
        b = c.Pb();
        uxb(d, XD(b) === XD(a) ? '(this Collection)' : b == null ? Rqe : adb(b));
    }
    return !d.a ? d.c : d.e.length == 0 ? d.a.a : d.a.a + ('' + d.e);
}
function sZc(a, b) {
    var c, d;
    d = false;
    if (b.gc() < 2) return false;
    for(c = 0; c < b.gc(); c++)c < b.gc() - 1 ? d = d | rZc(a, JD(b.Xb(c), 27), JD(b.Xb(c + 1), 27)) : d = d | rZc(a, JD(b.Xb(c), 27), JD(b.Xb(0), 27));
    return d;
}
function $ud(a, b) {
    var c;
    if (b != a.a) {
        c = null;
        !!a.a && (c = JD(a.a, 52).Ph(a, 4, l6, c));
        !!b && (c = JD(b, 52).Nh(a, 4, l6, c));
        c = Vud(a, b, c);
        !!c && c.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 1, b, b));
}
function KZd(a, b) {
    var c;
    if (b != a.e) {
        !!a.e && J5d(t5d(a.e), a);
        !!b && (!b.b && (b.b = new K5d(new G5d)), I5d(b.b, a));
        c = AZd(a, b, null);
        !!c && c.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 4, b, b));
}
function rXb(a) {
    var b, c, d, e;
    if (Vgd(JD(WMb(a.b, (Bwc(), ruc)), 86))) return 0;
    b = 0;
    for(d = new rmb(a.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        if (c.k == (DYb(), AYb)) {
            e = c.o.a;
            b = $wnd.Math.max(b, e);
        }
    }
    return b;
}
function xgc(a, b) {
    var c;
    c = b.o;
    if (Ugd(a.f)) {
        a.j.a = $wnd.Math.max(a.j.a, c.a);
        a.j.b += c.b;
        a.d.c.length > 1 && (a.j.b += a.e);
    } else {
        a.j.a += c.a;
        a.j.b = $wnd.Math.max(a.j.b, c.b);
        a.d.c.length > 1 && (a.j.a += a.e);
    }
}
function jhc() {
    jhc = Zcb;
    ghc = WC(OC(v2, 1), Ave, 64, 0, [
        (Rjd(), xjd),
        wjd,
        Ojd
    ]);
    fhc = WC(OC(v2, 1), Ave, 64, 0, [
        wjd,
        Ojd,
        Qjd
    ]);
    hhc = WC(OC(v2, 1), Ave, 64, 0, [
        Ojd,
        Qjd,
        xjd
    ]);
    ihc = WC(OC(v2, 1), Ave, 64, 0, [
        Qjd,
        xjd,
        wjd
    ]);
}
function rjc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    g = a.c.d;
    h = a.d.d;
    if (g.j == h.j) return;
    k = a.b;
    e = g.j;
    i = null;
    while(e != h.j){
        i = b == 0 ? Ujd(e) : Sjd(e);
        f = xjc(e, k.d[e.g], c);
        j = xjc(i, k.d[i.g], c);
        Atb(d, mdd(f, j));
        e = i;
    }
}
function RFc(a) {
    var b, c, d, e, f, g, h, i, j;
    this.a = OFc(a);
    this.b = new Ulb;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        f = new Ulb;
        Ilb(this.b, f);
        for(h = b, i = 0, j = h.length; i < j; ++i){
            g = h[i];
            Ilb(f, new Wlb(g.j));
        }
    }
}
function TFc(a, b, c) {
    var d, e, f;
    f = 0;
    d = c[b];
    if (b < c.length - 1) {
        e = c[b + 1];
        if (a.b[b]) {
            f = lHc(a.d, d, e);
            f += oGc(a.a, d, (Rjd(), wjd));
            f += oGc(a.a, e, Qjd);
        } else f = jGc(a.a, d, e);
    }
    a.c[b] && (f += qGc(a.a, d));
    return f;
}
function BVb(a, b, c, d, e) {
    var f, g, h, i;
    i = null;
    for(h = new rmb(d); h.a < h.c.c.length;){
        g = JD(pmb(h), 441);
        if (g != c && Nlb(g.e, e, 0) != -1) {
            i = g;
            break;
        }
    }
    f = CVb(e);
    gWb(f, c.b);
    hWb(f, i.b);
    Rc(a.a, e, new TVb(f, b, c.f));
}
function qfc(a) {
    while(a.g.c != 0 && a.d.c != 0){
        if (zfc(a.g).c > zfc(a.d).c) {
            a.i += a.g.c;
            Bfc(a.d);
        } else if (zfc(a.d).c > zfc(a.g).c) {
            a.e += a.d.c;
            Bfc(a.g);
        } else {
            a.i += yfc(a.g);
            a.e += yfc(a.d);
            Bfc(a.g);
            Bfc(a.d);
        }
    }
}
function yNc(a, b, c) {
    var d, e, f, g;
    f = b.q;
    g = b.r;
    new eNc((iNc(), gNc), b, f, 1);
    new eNc(gNc, f, g, 1);
    for(e = new rmb(c); e.a < e.c.c.length;){
        d = JD(pmb(e), 116);
        if (d != f && d != b && d != g) {
            SNc(a.a, d, b);
            SNc(a.a, d, g);
        }
    }
}
function yPc(a, b, c, d) {
    a.a.d = $wnd.Math.min(b, c);
    a.a.a = $wnd.Math.max(b, d) - a.a.d;
    if (b < c) {
        a.b = 0.5 * (b + c);
        a.g = wze * a.b + 0.9 * b;
        a.f = wze * a.b + 0.9 * c;
    } else {
        a.b = 0.5 * (b + d);
        a.g = wze * a.b + 0.9 * d;
        a.f = wze * a.b + 0.9 * b;
    }
}
function CTc(a) {
    var b, c, d, e;
    if (a.b != 0) {
        b = new Mtb;
        for(e = Gtb(a, 0); e.b != e.d.c;){
            d = JD(Utb(e), 39);
            xe(b, bRc(d));
            c = d.e;
            c.a = JD(WMb(d, (tUc(), rUc)), 17).a;
            c.b = JD(WMb(d, sUc), 17).a;
        }
        return b;
    }
    return new Mtb;
}
function F1b(a) {
    switch(JD(WMb(a, (Bwc(), Uuc)), 171).g){
        case 1:
            ZMb(a, Uuc, (Oqc(), Lqc));
            break;
        case 2:
            ZMb(a, Uuc, (Oqc(), Mqc));
            break;
        case 3:
            ZMb(a, Uuc, (Oqc(), Jqc));
            break;
        case 4:
            ZMb(a, Uuc, (Oqc(), Kqc));
    }
}
function ibc(a, b, c) {
    var d;
    c.Sg('Self-Loop routing', 1);
    d = jbc(b);
    ZD(WMb(b, (Gcd(), Fcd)));
    EBb(FBb(BBb(BBb(DBb(new RBb(null, new Gvb(b.b, 16)), new mbc), new obc), new qbc), new sbc), new ubc(a, d));
    c.Tg();
}
function Koc() {
    Koc = Zcb;
    Ioc = new Loc(yve, 0);
    Foc = new Loc(_te, 1);
    Joc = new Loc(aue, 2);
    Hoc = new Loc('LEFT_RIGHT_CONSTRAINT_LOCKING', 3);
    Goc = new Loc('LEFT_RIGHT_CONNECTION_LOCKING', 4);
    Eoc = new Loc(rwe, 5);
}
function wQc(a, b, c) {
    var d, e, f, g, h, i, j;
    h = c.a / 2;
    f = c.b / 2;
    d = $wnd.Math.abs(b.a - a.a);
    e = $wnd.Math.abs(b.b - a.b);
    i = 1;
    j = 1;
    d > h && (i = h / d);
    e > f && (j = f / e);
    g = $wnd.Math.min(i, j);
    a.a += g * (b.a - a.a);
    a.b += g * (b.b - a.b);
}
function X2c(a, b, c, d, e) {
    var f, g;
    g = false;
    f = JD(Mlb(c.b, 0), 27);
    while(i3c(a, b, f, d, e)){
        g = true;
        h4c(c, f);
        if (c.b.c.length == 0) break;
        f = JD(Mlb(c.b, 0), 27);
    }
    c.b.c.length == 0 && V4c(c.j, c);
    g && w4c(b.q);
    return g;
}
function fsd(a, b, c, d) {
    var e, f;
    if (c == 0) return !a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), WQd(a.o, b, d);
    return f = JD(QTd((e = JD(Crd(a, 16), 29), !e ? a.ei() : e), c), 69), f.tk().xk(a, Ard(a), c - VTd(a.ei()), b, d);
}
function dwd(a, b) {
    var c;
    if (b != a.sb) {
        c = null;
        !!a.sb && (c = JD(a.sb, 52).Ph(a, 1, f6, c));
        !!b && (c = JD(b, 52).Nh(a, 1, f6, c));
        c = Lvd(a, b, c);
        !!c && c.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 4, b, b));
}
function Myd(a, b) {
    var c, d, e, f;
    if (b) {
        e = Zxd(b, 'x');
        c = new fAd(a);
        jud(c.a, (tDb(e), e));
        f = Zxd(b, 'y');
        d = new hAd(a);
        kud(d.a, (tDb(f), f));
    } else throw scb(new eyd('All edge sections need an end point.'));
}
function Kyd(a, b) {
    var c, d, e, f;
    if (b) {
        e = Zxd(b, 'x');
        c = new _zd(a);
        qud(c.a, (tDb(e), e));
        f = Zxd(b, 'y');
        d = new bAd(a);
        rud(d.a, (tDb(f), f));
    } else throw scb(new eyd('All edge sections need a start point.'));
}
function Xzb(a, b) {
    var c, d, e, f, g, h, i;
    for(d = $zb(a), f = 0, h = d.length; f < h; ++f)eAb(b);
    i = !Tzb && a.e ? Tzb ? null : a.d : null;
    while(i){
        for(c = $zb(i), e = 0, g = c.length; e < g; ++e)eAb(b);
        i = !Tzb && i.e ? Tzb ? null : i.d : null;
    }
}
function kQb(a, b) {
    var c, d;
    d = JD(WMb(b, (Bwc(), Evc)), 100);
    ZMb(b, (Iqc(), pqc), d);
    c = b.e;
    !!c && (EBb(new RBb(null, new Gvb(c.a, 16)), new pQb(a)), EBb(DBb(new RBb(null, new Gvb(c.b, 16)), new rQb), new tQb(a)));
}
function J0b(a) {
    var b, c, d, e;
    b = false;
    if (XMb(a, (Iqc(), Opc))) {
        c = JD(WMb(a, Opc), 91);
        for(e = new rmb(a.j); e.a < e.c.c.length;){
            d = JD(pmb(e), 11);
            if (H0b(d)) {
                if (!b) {
                    G0b(gYb(a));
                    b = true;
                }
                K0b(JD(c.xc(d), 315));
            }
        }
    }
}
function fBd(a) {
    var b, c, d, e, f, g, h, i, j;
    j = gBd(a);
    c = a.e;
    f = c != null;
    f && Wxd(j, GDe, a.e);
    h = a.k;
    g = !!h;
    g && Wxd(j, 'type', ls(a.k));
    d = yqe(a.j);
    e = !d;
    if (e) {
        i = new EB;
        kC(j, mDe, i);
        b = new rBd(i);
        ofb(a.j, b);
    }
    return j;
}
function Vv(a) {
    var b, c, d, e;
    e = Kgb((bk(a.gc(), 'size'), new Vgb), 123);
    d = true;
    for(c = dn(a).Jc(); c.Ob();){
        b = JD(c.Pb(), 43);
        d || (e.a += Lqe, e);
        d = false;
        Pgb(Kgb(Pgb(e, b.jd()), 61), b.kd());
    }
    return (e.a += '}', e).a;
}
function sD(a, b) {
    var c, d, e;
    b &= 63;
    if (b < 22) {
        c = a.l << b;
        d = a.m << b | a.l >> 22 - b;
        e = a.h << b | a.m >> 22 - b;
    } else if (b < 44) {
        c = 0;
        d = a.l << b - 22;
        e = a.m << b - 22 | a.l >> 44 - b;
    } else {
        c = 0;
        d = 0;
        e = a.l << b - 44;
    }
    return _C(c & zse, d & zse, e & Ase);
}
function Edb(a) {
    Ddb == null && (Ddb = new RegExp('^\\s*[+-]?(NaN|Infinity|((\\d+\\.?\\d*)|(\\.\\d+))([eE][+-]?\\d+)?[dDfF]?)\\s*$'));
    if (!Ddb.test(a)) throw scb(new Mfb(Jse + a + '"'));
    return parseFloat(a);
}
function eAb(a) {
    var b, c, d;
    b = cgb(typeof console, ste) ? null : new fDb;
    if (!b) return;
    Gzb();
    c = (d = 900, d >= Vre ? 'error' : d >= 900 ? 'warn' : d >= 800 ? 'info' : 'log');
    dDb(c, a.a);
    !!a.b && eDb(b, c, a.b, 'Exception: ', true);
}
function ZQb(a, b) {
    var c, d, e, f, g;
    e = b == 1 ? WQb : VQb;
    for(d = e.a.ec().Jc(); d.Ob();){
        c = JD(d.Pb(), 86);
        for(g = JD(Qc(a.f.c, c), 22).Jc(); g.Ob();){
            f = JD(g.Pb(), 47);
            Ilb(a.b.b, JD(f.b, 82));
            Ilb(a.b.a, JD(f.b, 82).d);
        }
    }
}
function Qjc(a, b) {
    var c, d, e, f;
    f = b.b.j;
    a.a = SC(cE, ise, 30, f.c.length, 15, 1);
    e = 0;
    for(d = 0; d < f.c.length; d++){
        c = (sDb(d, f.c.length), JD(f.c[d], 11));
        c.e.c.length == 0 && c.g.c.length == 0 ? e += 1 : e += 3;
        a.a[d] = e;
    }
}
function doc() {
    doc = Zcb;
    $nc = new foc('ALWAYS_UP', 0);
    Znc = new foc('ALWAYS_DOWN', 1);
    aoc = new foc('DIRECTION_UP', 2);
    _nc = new foc('DIRECTION_DOWN', 3);
    coc = new foc('SMART_UP', 4);
    boc = new foc('SMART_DOWN', 5);
}
function Kcd(a, b) {
    if (a < 0 || b < 0) throw scb(new Teb('k and n must be positive'));
    else if (b > a) throw scb(new Teb('k must be smaller than n'));
    else return b == 0 || b == a ? 1 : a == 0 ? 0 : Pcd(a) / (Pcd(b) * Pcd(a - b));
}
function Wmd(a, b) {
    var c, d, e, f;
    c = new YDd(a);
    while(c.g == null && !c.c ? RDd(c) : c.g == null || c.i != 0 && JD(c.g[c.i - 1], 49).Ob()){
        f = JD(SDd(c), 57);
        if (RD(f, 173)) {
            d = JD(f, 173);
            for(e = 0; e < b.length; e++)b[e].Ig(d);
        }
    }
}
function jtd(a) {
    var b;
    if ((a.Db & 64) != 0) return Qsd(a);
    b = new Jgb(Qsd(a));
    b.a += ' (height: ';
    Bgb(b, a.f);
    b.a += ', width: ';
    Bgb(b, a.g);
    b.a += ', x: ';
    Bgb(b, a.i);
    b.a += ', y: ';
    Bgb(b, a.j);
    b.a += ')';
    return b.a;
}
function Cn(a) {
    var b, c, d, e, f, g, h;
    b = new Xsb;
    for(d = a, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        g = Qb(c.jd());
        h = Usb(b, g, Qb(c.kd()));
        if (h != null) throw scb(new Teb('duplicate key: ' + g));
    }
    this.b = (pnb(), new kpb(b));
}
function Umb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        uxb(f, String.fromCharCode(b));
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function YNb() {
    YNb = Zcb;
    SNb = (bOb(), aOb);
    RNb = new MBd(Bue, SNb);
    jfb(1);
    QNb = new MBd(Cue, jfb(300));
    jfb(0);
    VNb = new MBd(Due, jfb(0));
    new Fnd;
    WNb = new MBd(Eue, Fue);
    new Fnd;
    TNb = new MBd(Gue, 5);
    XNb = aOb;
    UNb = _Nb;
}
function d2d(a, b) {
    var c;
    if (b != null && !a.c.Ek().ck(b)) {
        c = RD(b, 57) ? JD(b, 57).zh().zb : eeb(rb(b));
        throw scb(new zeb(LCe + a.c.ve() + "'s type '" + a.c.Ek().ve() + "' does not permit a value of type '" + c + "'"));
    }
}
function uVb(a, b, c) {
    var d, e;
    e = new Ajb(a.b, 0);
    while(e.b < e.d.gc()){
        d = (rDb(e.b < e.d.gc()), JD(e.d.Xb(e.c = e.b++), 72));
        if (XD(WMb(d, (Iqc(), nqc))) !== XD(b)) continue;
        oXb(d.n, gYb(a.c.i), c);
        tjb(e);
        Ilb(b.b, d);
    }
}
function klc(a) {
    var b, c;
    c = $wnd.Math.sqrt((a.k == null && (a.k = dmc(a, new omc)), Beb(a.k) / (a.b * (a.g == null && (a.g = amc(a, new mmc)), Beb(a.g)))));
    b = Pcb(zcb($wnd.Math.round(c)));
    b = $wnd.Math.min(b, a.f);
    return b;
}
function Nne() {
    var a, b, c;
    b = 0;
    for(a = 0; a < 1; a++){
        c = Mne((ADb(a, 1), 'X'.charCodeAt(a)));
        if (c == 0) throw scb(new eme((ADb(a, 2), 'Unknown Option: ' + 'X'.substr(a))));
        b |= c;
    }
    return b;
}
function UPb(a) {
    var b, c, d, e, f, g;
    b = new nlb;
    c = new nlb;
    $kb(b, a);
    $kb(c, a);
    while(c.b != c.c){
        e = JD(jlb(c), 36);
        for(g = new rmb(e.a); g.a < g.c.c.length;){
            f = JD(pmb(g), 9);
            if (f.e) {
                d = f.e;
                $kb(b, d);
                $kb(c, d);
            }
        }
    }
    return b;
}
function bZb() {
    VYb();
    FXb.call(this);
    this.j = (Rjd(), Pjd);
    this.a = new Cdd;
    new bYb;
    this.f = (bk(2, Dre), new Vlb(2));
    this.e = (bk(4, Dre), new Vlb(4));
    this.g = (bk(4, Dre), new Vlb(4));
    this.b = new tZb(this.e, this.g);
}
function M_b(a, b) {
    var c, d;
    if (ydb(LD(WMb(b, (Iqc(), xqc))))) return false;
    d = b.c.i;
    if (a == (Oqc(), Jqc)) {
        if (d.k == (DYb(), xYb)) return false;
    }
    c = JD(WMb(d, (Bwc(), Uuc)), 171);
    if (c == Kqc) return false;
    return true;
}
function N_b(a, b) {
    var c, d;
    if (ydb(LD(WMb(b, (Iqc(), xqc))))) return false;
    d = b.d.i;
    if (a == (Oqc(), Lqc)) {
        if (d.k == (DYb(), xYb)) return false;
    }
    c = JD(WMb(d, (Bwc(), Uuc)), 171);
    if (c == Mqc) return false;
    return true;
}
function m0b(a, b) {
    var c, d, e, f, g, h, i;
    g = a.d;
    i = a.o;
    h = new gdd(-g.b, -g.d, g.b + i.a + g.c, g.d + i.b + g.a);
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        !!c && edd(h, c.i);
    }
    g.b = -h.c;
    g.d = -h.d;
    g.c = h.b - g.b - i.a;
    g.a = h.a - g.d - i.b;
}
function nac(a, b) {
    if (b.a) switch(JD(WMb(b.b, (Iqc(), pqc)), 100).g){
        case 0:
        case 1:
            oic(b);
        case 2:
            EBb(new RBb(null, new Gvb(b.d, 16)), new Aac);
            zhc(a.a, b);
    }
    else EBb(new RBb(null, new Gvb(b.d, 16)), new Aac);
}
function l6c() {
    l6c = Zcb;
    g6c = new m6c('CENTER_DISTANCE', 0);
    h6c = new m6c('CIRCLE_UNDERLAP', 1);
    k6c = new m6c('RECTANGLE_UNDERLAP', 2);
    i6c = new m6c('INVERTED_OVERLAP', 3);
    j6c = new m6c('MINIMUM_ROOT_DISTANCE', 4);
}
function bme(a) {
    _le();
    var b, c, d, e, f;
    if (a == null) return null;
    d = a.length;
    e = d * 2;
    b = SC(_D, Ure, 30, e, 15, 1);
    for(c = 0; c < d; c++){
        f = a[c];
        f < 0 && (f += 256);
        b[c * 2] = $le[f >> 4];
        b[c * 2 + 1] = $le[f & 15];
    }
    return zgb(b, 0, b.length);
}
function pn(a) {
    cn();
    var b, c, d;
    d = a.c.length;
    switch(d){
        case 0:
            return bn;
        case 1:
            b = JD(Er(new rmb(a)), 43);
            return tn(b.jd(), b.kd());
        default:
            c = JD(Tlb(a, SC(LK, tre, 43, a.c.length, 0, 1)), 174);
            return new Ix(c);
    }
}
function oYb(a, b) {
    switch(b.g){
        case 1:
            return _q(a.j, (VYb(), RYb));
        case 2:
            return _q(a.j, (VYb(), PYb));
        case 3:
            return _q(a.j, (VYb(), TYb));
        case 4:
            return _q(a.j, (VYb(), UYb));
        default:
            return pnb(), pnb(), mnb;
    }
}
function wfc(a, b) {
    var c, d, e;
    c = xfc(b, a.e);
    d = JD(Nib(a.g.f, c), 17).a;
    e = a.a.c.length - 1;
    if (a.a.c.length != 0 && JD(Mlb(a.a, e), 292).c == d) {
        ++JD(Mlb(a.a, e), 292).a;
        ++JD(Mlb(a.a, e), 292).b;
    } else Ilb(a.a, new Gfc(d));
}
function wFc(a, b, c) {
    var d, e;
    d = vFc(a, b, c);
    if (d != 0) return d;
    if (XMb(b, (Iqc(), jqc)) && XMb(c, jqc)) {
        e = $eb(JD(WMb(b, jqc), 17).a, JD(WMb(c, jqc), 17).a);
        e < 0 ? xFc(a, b, c) : e > 0 && xFc(a, c, b);
        return e;
    }
    return uFc(a, b, c);
}
function b_c() {
    b_c = Zcb;
    U$c = (Lgd(), fgd);
    _$c = wgd;
    N$c = Bfd;
    O$c = Efd;
    P$c = Gfd;
    M$c = zfd;
    Q$c = Jfd;
    T$c = agd;
    K$c = (G$c(), r$c);
    L$c = s$c;
    W$c = y$c;
    Z$c = B$c;
    X$c = z$c;
    Y$c = A$c;
    R$c = u$c;
    S$c = w$c;
    V$c = x$c;
    $$c = C$c;
    a_c = E$c;
    J$c = q$c;
}
function d4c(a, b) {
    var c, d, e, f, g;
    if (a.e <= b) return a.g;
    if (f4c(a, a.g, b)) return a.g;
    f = a.r;
    d = a.g;
    g = a.r;
    e = (f - d) / 2 + d;
    while(d + 1 < f){
        c = g4c(a, e, false);
        if (c.b <= e && c.a <= b) {
            g = e;
            f = e;
        } else d = e;
        e = (f - d) / 2 + d;
    }
    return g;
}
function T8c(a, b, c) {
    var d;
    d = O8c(a, b, true);
    nld(c, 'Recursive Graph Layout', d);
    Wmd(b, WC(OC(b3, 1), Nqe, 521, 0, [
        new Q9c
    ]));
    lsd(b, (Lgd(), igd)) || Wmd(b, WC(OC(b3, 1), Nqe, 521, 0, [
        new sad
    ]));
    U8c(a, b, null, c);
    pld(c);
}
function pld(a) {
    var b;
    if (a.p == null) throw scb(new Web('The task has not begun yet.'));
    if (!a.b) {
        if (a.k) {
            b = (Zgb(), Fcb(zcb(Date.now()), Vre));
            a.q = Ocb(Mcb(b, a.o)) * 1.0E-9;
        }
        a.c < a.r && qld(a, a.r - a.c);
        a.b = true;
    }
}
function and(a) {
    var b, c, d;
    d = new Rdd;
    Atb(d, new Edd(a.j, a.k));
    for(c = new CHd((!a.a && (a.a = new qVd(u3, a, 5)), a.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 369);
        Atb(d, new Edd(b.a, b.b));
    }
    Atb(d, new Edd(a.b, a.c));
    return d;
}
function Eyd(a, b, c, d, e) {
    var f, g, h, i, j, k;
    if (e) {
        i = e.a.length;
        f = new Rpe(i);
        for(k = (f.b - f.a) * f.c < 0 ? (Qpe(), Ppe) : new lqe(f); k.Ob();){
            j = JD(k.Pb(), 17);
            h = _xd(e, j.a);
            g = new Nzd(a, b, c, d);
            Fyd(g.a, g.b, g.c, g.d, h);
        }
    }
}
function Nx(b, c) {
    var d;
    if (XD(b) === XD(c)) return true;
    if (RD(c, 22)) {
        d = JD(c, 22);
        try {
            return b.gc() == d.gc() && b.Hc(d);
        } catch (a) {
            a = rcb(a);
            if (RD(a, 169) || RD(a, 211)) return false;
            else throw scb(a);
        }
    }
    return false;
}
function yyb(a, b, c, d, e, f) {
    this.c = a;
    switch(b.g){
        case 2:
            if (a.a.Le(e, c) < 0) throw scb(new Teb(mte + e + nte + c));
            break;
        case 1:
            a.a.Le(e, e);
            break;
        case 3:
            a.a.Le(c, c);
    }
    this.f = b;
    this.b = c;
    this.a = d;
    this.e = e;
    this.d = f;
}
function WHb(a, b) {
    var c;
    Ilb(a.d, b);
    c = b.Kf();
    if (a.c) {
        a.e.a = $wnd.Math.max(a.e.a, c.a);
        a.e.b += c.b;
        a.d.c.length > 1 && (a.e.b += a.a);
    } else {
        a.e.a += c.a;
        a.e.b = $wnd.Math.max(a.e.b, c.b);
        a.d.c.length > 1 && (a.e.a += a.a);
    }
}
function fjc(a) {
    var b, c, d, e;
    e = a.i;
    b = e.b;
    d = e.j;
    c = e.g;
    switch(e.a.g){
        case 0:
            c.a = (a.g.b.o.a - d.a) / 2;
            break;
        case 1:
            c.a = b.d.n.a + b.d.a.a;
            break;
        case 2:
            c.a = b.d.n.a + b.d.a.a - d.a;
            break;
        case 3:
            c.b = b.d.n.b + b.d.a.b;
    }
}
function rIc(a, b, c) {
    var d, e, f;
    for(e = new es(Ir(eYb(c).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        if (!(!eWb(d) && !(!eWb(d) && d.c.i.c == d.d.i.c))) continue;
        f = jIc(a, d, c, new YIc);
        f.c.length > 1 && YCb(b.c, f);
    }
}
function ndd(a, b, c, d, e) {
    if (d < b || e < c) throw scb(new Teb('The highx must be bigger then lowx and the highy must be bigger then lowy'));
    a.a < b ? a.a = b : a.a > d && (a.a = d);
    a.b < c ? a.b = c : a.b > e && (a.b = e);
    return a;
}
function kBd(a) {
    if (RD(a, 149)) return dBd(JD(a, 149));
    else if (RD(a, 232)) return eBd(JD(a, 232));
    else if (RD(a, 21)) return fBd(JD(a, 21));
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        a
    ])))));
}
function lib(a, b, c, d, e) {
    var f, g, h;
    f = true;
    for(g = 0; g < d; g++)f = f & c[g] == 0;
    if (e == 0) {
        $gb(c, d, a, 0, b);
        g = b;
    } else {
        h = 32 - e;
        f = f & c[g] << h == 0;
        for(g = 0; g < b - 1; g++)a[g] = c[g + d] >>> e | c[g + d + 1] << h;
        a[g] = c[g + d] >>> e;
        ++g;
    }
    return f;
}
function aLc(a, b, c, d) {
    var e, f, g;
    if (b.k == (DYb(), yYb)) for(f = new es(Ir(hYb(b).a.Jc(), new er)); cs(f);){
        e = JD(ds(f), 18);
        g = e.c.i.k;
        if (g == yYb && a.c.a[e.c.i.c.p] == d && a.c.a[b.c.p] == c) return true;
    }
    return false;
}
function uD(a, b) {
    var c, d, e, f;
    b &= 63;
    c = a.h & Ase;
    if (b < 22) {
        f = c >>> b;
        e = a.m >> b | c << 22 - b;
        d = a.l >> b | a.m << 22 - b;
    } else if (b < 44) {
        f = 0;
        e = c >>> b - 22;
        d = a.m >> b - 22 | a.h << 44 - b;
    } else {
        f = 0;
        e = 0;
        d = c >>> b - 44;
    }
    return _C(d & zse, e & zse, f & Ase);
}
function Lfc(a, b, c, d) {
    var e;
    this.b = d;
    this.e = a == (UEc(), SEc);
    e = b[c];
    this.d = QC(pcb, [
        hre,
        Vte
    ], [
        183,
        30
    ], 16, [
        e.length,
        e.length
    ], 2);
    this.a = QC(cE, [
        hre,
        ise
    ], [
        54,
        30
    ], 15, [
        e.length,
        e.length
    ], 2);
    this.c = new vfc(b, c);
}
function ogc(a) {
    var b, c, d;
    a.k = new Qi((Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])).length, a.j.c.length);
    for(d = new rmb(a.j); d.a < d.c.c.length;){
        c = JD(pmb(d), 112);
        b = c.d.j;
        Rc(a.k, b, c);
    }
    a.e = ahc(Ec(a.k));
}
function vPc(a, b) {
    var c, d, e;
    Nrb(a.d, b);
    c = new CPc;
    Qib(a.c, b, c);
    c.f = wPc(b.c);
    c.a = wPc(b.d);
    c.d = (KOc(), e = b.c.i.k, e == (DYb(), AYb) || e == vYb);
    c.e = (d = b.d.i.k, d == AYb || d == vYb);
    c.b = b.c.j == (Rjd(), Qjd);
    c.c = b.d.j == wjd;
}
function DGb(a) {
    var b, c, d, e, f;
    f = Hqe;
    e = Hqe;
    for(d = new rmb(OFb(a)); d.a < d.c.c.length;){
        c = JD(pmb(d), 216);
        b = c.e.e - c.d.e;
        c.e == a && b < e ? e = b : b < f && (f = b);
    }
    e == Hqe && (e = -1);
    f == Hqe && (f = -1);
    return new xod(jfb(e), jfb(f));
}
function n6b(a, b) {
    var c, d, e, f;
    c = b.a.o.a;
    f = new Ijb(gYb(b.a).b, b.c, b.f + 1);
    for(e = new ujb(f); e.b < e.d.gc();){
        d = (rDb(e.b < e.d.gc()), JD(e.d.Xb(e.c = e.b++), 25));
        if (d.c.a >= c) {
            m6b(a, b, d.p);
            return true;
        }
    }
    return false;
}
function wA(a, b, c, d) {
    var e, f, g, h, i, j;
    g = c.length;
    f = 0;
    e = -1;
    j = sgb((ADb(b, a.length + 1), a.substr(b)), (kub(), iub));
    for(h = 0; h < g; ++h){
        i = c[h].length;
        if (i > f && ngb(j, sgb(c[h], iub))) {
            e = h;
            f = i;
        }
    }
    e >= 0 && (d[0] = b + f);
    return e;
}
function kgc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    f = a.d.p;
    h = f.e;
    i = f.r;
    a.g = new GGc(i);
    g = a.d.o.c.p;
    d = g > 0 ? h[g - 1] : SC(RP, Jve, 9, 0, 0, 1);
    e = h[g];
    j = g < h.length - 1 ? h[g + 1] : SC(RP, Jve, 9, 0, 0, 1);
    k = b == c - 1;
    k ? sGc(a.g, e, j) : sGc(a.g, d, e);
}
function Kwd(a) {
    var b;
    if ((a.Db & 64) != 0) return jtd(a);
    b = new Wgb(GCe);
    !a.a || Qgb(Qgb((b.a += ' "', b), a.a), '"');
    Qgb(Lgb(Qgb(Lgb(Qgb(Lgb(Qgb(Lgb((b.a += ' (', b), a.i), ','), a.j), ' | '), a.g), ','), a.f), ')');
    return b.a;
}
function Sbe(a, b, c) {
    var d, e, f, g, h;
    h = Kfe(a.e.zh(), b);
    e = JD(a.g, 122);
    d = 0;
    for(g = 0; g < a.i; ++g){
        f = e[g];
        if (h.Zl(f.Ik())) {
            if (d == c) {
                UGd(a, g);
                return Ife(), JD(b, 69).uk() ? f : f.kd();
            }
            ++d;
        }
    }
    throw scb(new mdb(IEe + c + ODe + d));
}
function kme(a) {
    var b, c, d;
    b = a.c;
    if (b == 2 || b == 7 || b == 1) return ooe(), ooe(), Zne;
    else {
        d = ime(a);
        c = null;
        while((b = a.c) != 2 && b != 7 && b != 1){
            if (!c) {
                c = (ooe(), ooe(), ++noe, new Dpe(1));
                Cpe(c, d);
                d = c;
            }
            Cpe(c, ime(a));
        }
        return d;
    }
}
function Kb(a, b, c) {
    if (a < 0 || a > c) return Jb(a, c, 'start index');
    if (b < 0 || b > c) return Jb(b, c, 'end index');
    return hc('end index (%s) must not be less than start index (%s)', WC(OC(aJ, 1), Nqe, 1, 5, [
        jfb(b),
        jfb(a)
    ]));
}
function Xz(b, c) {
    var d, e, f, g;
    for(e = 0, f = b.length; e < f; e++){
        g = b[e];
        try {
            g[1] ? g[0].Rm() && (c = Wz(c, g)) : g[0].Rm();
        } catch (a) {
            a = rcb(a);
            if (RD(a, 80)) {
                d = a;
                Iz();
                Oz(RD(d, 472) ? JD(d, 472).ie() : d);
            } else throw scb(a);
        }
    }
    return c;
}
function m6b(a, b, c) {
    var d, e, f;
    c != b.c + b.b.gc() && B6b(b.a, J6b(b, c - b.c));
    f = b.a.c.p;
    a.a[f] = $wnd.Math.max(a.a[f], b.a.o.a);
    for(e = JD(WMb(b.a, (Iqc(), wqc)), 15).Jc(); e.Ob();){
        d = JD(e.Pb(), 72);
        ZMb(d, j6b, (xdb(), true));
    }
}
function Pbc(a, b) {
    var c, d, e;
    e = Nbc(b);
    ZMb(b, (Iqc(), hqc), e);
    if (e) {
        d = Hqe;
        !!fsb(a.f, e) && (d = JD(Wd(fsb(a.f, e)), 17).a);
        c = JD(Mlb(b.g, 0), 18);
        ydb(LD(WMb(c, xqc))) || Qib(a, e, jfb($wnd.Math.min(JD(WMb(c, jqc), 17).a, d)));
    }
}
function clc(a) {
    var b, c, d, e;
    c = Hqe;
    e = true;
    for(b = 0; b < a.a.c.length; b++)if (XMb(JD(Mlb(a.a, b), 9), (Bwc(), _uc))) {
        e = false;
        d = JD(WMb(JD(Mlb(a.a, b), 9), _uc), 17).a;
        c = c < d ? c : d;
    }
    e && (c = JD(JBd((Bwc(), _uc)), 17).a);
    return c;
}
function dAc(a, b, c) {
    var d, e, f, g, h;
    b.p = -1;
    for(h = mYb(b, (Eyc(), Cyc)).Jc(); h.Ob();){
        g = JD(h.Pb(), 11);
        for(e = new rmb(g.g); e.a < e.c.c.length;){
            d = JD(pmb(e), 18);
            f = d.d.i;
            b != f && (f.p < 0 ? c.Ec(d) : f.p > 0 && dAc(a, f, c));
        }
    }
    b.p = 0;
}
function Wb(a) {
    var b, c, d, e;
    b = Kgb(Qgb(new Wgb('Predicates.'), 'and'), 40);
    c = true;
    for(e = new ujb(a); e.b < e.d.gc();){
        d = (rDb(e.b < e.d.gc()), e.d.Xb(e.c = e.b++));
        c || (b.a += ',', b);
        b.a += '' + d;
        c = false;
    }
    return (b.a += ')', b).a;
}
function J9b(a, b, c) {
    var d, e, f;
    if (c <= b + 2) return;
    e = (c - b) / 2 | 0;
    for(d = 0; d < e; ++d){
        f = (sDb(b + d, a.c.length), JD(a.c[b + d], 11));
        Rlb(a, b + d, (sDb(c - d - 1, a.c.length), JD(a.c[c - d - 1], 11)));
        sDb(c - d - 1, a.c.length);
        a.c[c - d - 1] = f;
    }
}
function GZc(a, b) {
    var c, d, e;
    if (b.c.length != 0) {
        c = HZc(a, b);
        e = false;
        while(!c){
            qZc(a, b, true);
            e = true;
            c = HZc(a, b);
        }
        e && qZc(a, b, false);
        d = QYc(b);
        !!a.b && a.b.Eg(d);
        a.a = FZc(a, (sDb(0, b.c.length), JD(b.c[0], 27)));
        GZc(a, d);
    }
}
function Eqd(a, b) {
    var c, d, e;
    d = QTd(a.zh(), b);
    c = b - a.fi();
    if (c < 0) {
        if (!d) throw scb(new Teb(PCe + b + QCe));
        else if (d.ok()) {
            e = a.Eh(d);
            e >= 0 ? a.gi(e) : xqd(a, d);
        } else throw scb(new Teb(LCe + d.ve() + MCe));
    } else gqd(a, c, d);
}
function cyd(a) {
    var b, c;
    c = null;
    b = false;
    if (RD(a, 210)) {
        b = true;
        c = JD(a, 210).a;
    }
    if (!b) {
        if (RD(a, 263)) {
            b = true;
            c = '' + JD(a, 263).a;
        }
    }
    if (!b) {
        if (RD(a, 477)) {
            b = true;
            c = '' + JD(a, 477).a;
        }
    }
    if (!b) throw scb(new rdb(uDe));
    return c;
}
function Bbe(a, b, c) {
    var d, e, f, g, h, i;
    i = Kfe(a.e.zh(), b);
    d = 0;
    h = a.i;
    e = JD(a.g, 122);
    for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.Zl(f.Ik())) {
            if (c == d) return g;
            ++d;
            h = g + 1;
        }
    }
    if (c == d) return h;
    else throw scb(new mdb(IEe + c + ODe + d));
}
function H5b(a, b) {
    var c, d, e, f;
    if (a.f.c.length == 0) return null;
    else {
        f = new fdd;
        for(d = new rmb(a.f); d.a < d.c.c.length;){
            c = JD(pmb(d), 72);
            e = c.o;
            f.b = $wnd.Math.max(f.b, e.a);
            f.a += e.b;
        }
        f.a += (a.f.c.length - 1) * b;
        return f;
    }
}
function ZAc(a) {
    var b, c, d, e;
    a.e = 0;
    for(e = Gtb(a.f, 0); e.b != e.d.c;){
        d = JD(Utb(e), 9);
        if (d.p >= a.d.b.c.length) {
            b = new b$b(a.d);
            b.p = d.p - 1;
            Ilb(a.d.b, b);
            c = new b$b(a.d);
            c.p = d.p;
            Ilb(a.d.b, c);
        }
        qYb(d, JD(Mlb(a.d.b, d.p), 25));
    }
}
function uIc(a) {
    var b, c, d, e;
    c = new Mtb;
    xe(c, a.o);
    d = new txb;
    while(c.b != 0){
        b = JD(c.b == 0 ? null : (rDb(c.b != 0), Ktb(c, c.a.a)), 499);
        e = lIc(a, b, true);
        e && Ilb(d.a, b);
    }
    while(d.a.c.length != 0){
        b = JD(rxb(d), 499);
        lIc(a, b, false);
    }
}
function Pbd(a) {
    var b;
    this.c = new Mtb;
    this.f = a.e;
    this.e = a.d;
    this.i = a.g;
    this.d = a.c;
    this.b = a.b;
    this.k = a.j;
    this.a = a.a;
    !a.i ? this.j = (b = JD(deb(V1), 10), new urb(b, JD(VCb(b, b.length), 10), 0)) : this.j = a.i;
    this.g = a.f;
}
function zcd() {
    zcd = Zcb;
    ycd = new Acd(eue, 0);
    rcd = new Acd('BOOLEAN', 1);
    vcd = new Acd('INT', 2);
    xcd = new Acd('STRING', 3);
    scd = new Acd('DOUBLE', 4);
    tcd = new Acd('ENUM', 5);
    ucd = new Acd('ENUMSET', 6);
    wcd = new Acd('OBJECT', 7);
}
function edd(a, b) {
    var c, d, e, f, g;
    d = $wnd.Math.min(a.c, b.c);
    f = $wnd.Math.min(a.d, b.d);
    e = $wnd.Math.max(a.c + a.b, b.c + b.b);
    g = $wnd.Math.max(a.d + a.a, b.d + b.a);
    if (e < d) {
        c = d;
        d = e;
        e = c;
    }
    if (g < f) {
        c = f;
        f = g;
        g = c;
    }
    ddd(a, d, f, e - d, g - f);
}
function H$d(a, b) {
    var c, d;
    if (a.f) {
        while(b.Ob()){
            c = JD(b.Pb(), 74);
            d = c.Ik();
            if (RD(d, 101) && (JD(d, 19).Bb & RCe) != 0 && (!a.e || d.mk() != t3 || d.Ij() != 0) && c.kd() != null) {
                b.Ub();
                return true;
            }
        }
        return false;
    } else return b.Ob();
}
function J$d(a, b) {
    var c, d;
    if (a.f) {
        while(b.Sb()){
            c = JD(b.Ub(), 74);
            d = c.Ik();
            if (RD(d, 101) && (JD(d, 19).Bb & RCe) != 0 && (!a.e || d.mk() != t3 || d.Ij() != 0) && c.kd() != null) {
                b.Pb();
                return true;
            }
        }
        return false;
    } else return b.Sb();
}
function Gfe() {
    Gfe = Zcb;
    Dfe = WC(OC(hJ, 1), hre, 2, 6, [
        UFe,
        VFe,
        WFe,
        XFe,
        YFe,
        ZFe,
        GDe
    ]);
    Cfe = WC(OC(hJ, 1), hre, 2, 6, [
        UFe,
        'empty',
        VFe,
        qFe,
        'elementOnly'
    ]);
    Ffe = WC(OC(hJ, 1), hre, 2, 6, [
        UFe,
        'preserve',
        'replace',
        $Fe
    ]);
    Efe = new rae;
}
function oXb(a, b, c) {
    var d, e, f;
    if (b == c) return;
    d = b;
    do {
        mdd(a, d.c);
        e = d.e;
        if (e) {
            f = d.d;
            ldd(a, f.b, f.d);
            mdd(a, e.n);
            d = gYb(e);
        }
    }while (e);
    d = c;
    do {
        Bdd(a, d.c);
        e = d.e;
        if (e) {
            f = d.d;
            Add(a, f.b, f.d);
            Bdd(a, e.n);
            d = gYb(e);
        }
    }while (e);
}
function tfc(a, b, c, d) {
    var e, f, g, h, i;
    if (d.f.c + d.i.c == 0) for(g = a.a[a.c], h = 0, i = g.length; h < i; ++h){
        f = g[h];
        Qib(d, f, new Cfc(a, f, c));
    }
    e = JD(Wd(fsb(d.f, b)), 662);
    e.b = 0;
    e.c = e.f;
    e.c == 0 || Ffc(JD(Mlb(e.a, e.b), 292));
    return e;
}
function sgc(a) {
    var b;
    this.j = new Ulb;
    this.f = new Qrb;
    this.b = (b = JD(deb(v2), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    this.d = SC(cE, ise, 30, (Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])).length, 15, 1);
    this.g = a;
}
function Nmc() {
    Nmc = Zcb;
    Jmc = new Omc('MEDIAN_LAYER', 0);
    Lmc = new Omc('TAIL_LAYER', 1);
    Imc = new Omc('HEAD_LAYER', 2);
    Kmc = new Omc('SPACE_EFFICIENT_LAYER', 3);
    Mmc = new Omc('WIDEST_LAYER', 4);
    Hmc = new Omc('CENTER_LAYER', 5);
}
function GPc(a, b, c) {
    var d, e, f;
    if (!a.b[b.g]) {
        a.b[b.g] = true;
        d = c;
        !d && (d = new _Qc);
        Atb(d.b, b);
        for(f = a.a[b.g].Jc(); f.Ob();){
            e = JD(f.Pb(), 65);
            e.b != b && GPc(a, e.b, d);
            e.c != b && GPc(a, e.c, d);
            Atb(d.a, e);
        }
        return d;
    }
    return null;
}
function tJb(a) {
    switch(a.g){
        case 0:
        case 1:
        case 2:
            return Rjd(), xjd;
        case 3:
        case 4:
        case 5:
            return Rjd(), Ojd;
        case 6:
        case 7:
        case 8:
            return Rjd(), Qjd;
        case 9:
        case 10:
        case 11:
            return Rjd(), wjd;
        default:
            return Rjd(), Pjd;
    }
}
function VIc(a, b) {
    var c;
    if (a.c.length == 0) return false;
    c = Cxc((sDb(0, a.c.length), JD(a.c[0], 18)).c.i);
    gIc();
    if (c == (zxc(), wxc) || c == vxc) return true;
    return xBb(FBb(new RBb(null, new Gvb(a, 16)), new bJc), new dJc(b));
}
function xyd(a, b) {
    if (RD(b, 206)) return kyd(a, JD(b, 27));
    else if (RD(b, 193)) return lyd(a, JD(b, 124));
    else if (RD(b, 440)) return jyd(a, JD(b, 168));
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b
    ])))));
}
function Ku(a, b, c) {
    var d, e;
    this.f = a;
    d = JD(Nib(a.b, b), 260);
    e = !d ? 0 : d.a;
    Sb(c, e);
    if (c >= (e / 2 | 0)) {
        this.e = !d ? null : d.c;
        this.d = e;
        while(c++ < e)Iu(this);
    } else {
        this.c = !d ? null : d.b;
        while(c-- > 0)Hu(this);
    }
    this.b = b;
    this.a = null;
}
function hFb(a, b) {
    var c, d;
    b.a ? iFb(a, b) : (c = JD(jzb(a.b, b.b), 60), !!c && c == a.a[b.b.f] && !!c.a && c.a != b.b.a && c.c.Ec(b.b), d = JD(izb(a.b, b.b), 60), !!d && a.a[d.f] == b.b && !!d.a && d.a != b.b.a && b.b.c.Ec(d), kzb(a.b, b.b), undefined);
}
function HJb(a, b) {
    var c, d;
    c = JD(Kqb(a.b, b), 126);
    if (JD(JD(Qc(a.r, b), 22), 83).dc()) {
        c.n.b = 0;
        c.n.c = 0;
        return;
    }
    c.n.b = a.C.b;
    c.n.c = a.C.c;
    a.A.Gc((ykd(), xkd)) && MJb(a, b);
    d = LJb(a, b);
    MIb(a, b) == (Qid(), Nid) && (d += 2 * a.w);
    c.a.a = d;
}
function QKb(a, b) {
    var c, d;
    c = JD(Kqb(a.b, b), 126);
    if (JD(JD(Qc(a.r, b), 22), 83).dc()) {
        c.n.d = 0;
        c.n.a = 0;
        return;
    }
    c.n.d = a.C.d;
    c.n.a = a.C.a;
    a.A.Gc((ykd(), xkd)) && UKb(a, b);
    d = TKb(a, b);
    MIb(a, b) == (Qid(), Nid) && (d += 2 * a.w);
    c.a.b = d;
}
function dMb(a, b) {
    var c, d, e, f;
    f = new Ulb;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 68);
        Ilb(f, new pMb(c, true));
        Ilb(f, new pMb(c, false));
    }
    e = new iMb(a);
    e.a.a.$b();
    aEb(f, a.b, new dnb(WC(OC(FM, 1), Nqe, 678, 0, [
        e
    ])));
}
function j0b(a, b) {
    var c, d, e;
    b.Sg('End label pre-processing', 1);
    c = Beb(MD(WMb(a, (Bwc(), Yvc))));
    d = Beb(MD(WMb(a, awc)));
    e = Vgd(JD(WMb(a, ruc), 86));
    EBb(DBb(new RBb(null, new Gvb(a.b, 16)), new r0b), new t0b(c, d, e));
    b.Tg();
}
function Ozc(a, b) {
    var c, d, e;
    if (a.d[b.p]) return;
    a.d[b.p] = true;
    a.a[b.p] = true;
    for(d = new es(Ir(kYb(b).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        if (eWb(c)) continue;
        e = c.d.i;
        a.a[e.p] ? Ilb(a.b, c) : Ozc(a, e);
    }
    a.a[b.p] = false;
}
function kAc(a, b, c) {
    var d;
    d = 0;
    switch(JD(WMb(b, (Bwc(), Uuc)), 171).g){
        case 2:
            d = 2 * -c + a.a;
            ++a.a;
            break;
        case 1:
            d = -c;
            break;
        case 3:
            d = c;
            break;
        case 4:
            d = 2 * c + a.b;
            ++a.b;
    }
    XMb(b, (Iqc(), jqc)) && (d += JD(WMb(b, jqc), 17).a);
    return d;
}
function MMc(a, b, c) {
    var d, e, f;
    c.yc(b, a);
    Ilb(a.n, b);
    f = a.p.xg(b);
    b.j == a.p.yg() ? _Mc(a.e, f) : _Mc(a.j, f);
    OMc(a);
    for(e = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        new dZb(b),
        new lZb(b)
    ]))); cs(e);){
        d = JD(ds(e), 11);
        c._b(d) || MMc(a, d, c);
    }
}
function uTc(a, b, c) {
    var d, e, f;
    c.Sg('Processor set neighbors', 1);
    a.a = b.b.b == 0 ? 1 : b.b.b;
    e = null;
    d = Gtb(b.b, 0);
    while(!e && d.b != d.d.c){
        f = JD(Utb(d), 39);
        ydb(LD(WMb(f, (tUc(), qUc)))) && (e = f);
    }
    !!e && vTc(a, new gRc(e), c);
    c.Tg();
}
function dnd(a) {
    var b, c, d;
    c = JD(ksd(a, (Lgd(), Bfd)), 22);
    if (c.Gc((ykd(), ukd))) {
        d = JD(ksd(a, Gfd), 22);
        b = new Fdd(JD(ksd(a, Efd), 8));
        if (d.Gc((Nkd(), Gkd))) {
            b.a <= 0 && (b.a = 20);
            b.b <= 0 && (b.b = 20);
        }
        return b;
    } else return new Cdd;
}
function ITd(a) {
    var b, c, d;
    if (!a.b) {
        d = new TWd;
        for(c = new XHd(LTd(a)); c.e != c.i.gc();){
            b = JD(WHd(c), 19);
            (b.Bb & RCe) != 0 && tCd(d, b);
        }
        sDd(d);
        a.b = new gWd((JD(nDd(STd((GOd(), FOd).o), 8), 19), d.i), d.g);
        TTd(a).b &= -9;
    }
    return a.b;
}
function ugb(a) {
    var b, c, d;
    c = a.length;
    d = 0;
    while(d < c && (ADb(d, a.length), a.charCodeAt(d) <= 32))++d;
    b = c;
    while(b > d && (ADb(b - 1, a.length), a.charCodeAt(b - 1) <= 32))--b;
    return d > 0 || b < c ? (zDb(d, b, a.length), a.substr(d, b - d)) : a;
}
function Ujc(a, b) {
    var c, d, e, f, g, h, i, j;
    i = JD(De(Ec(b.k), SC(v2, Ave, 64, 2, 0, 1)), 125);
    j = b.g;
    c = Wjc(b, i[0]);
    e = Vjc(b, i[1]);
    d = Njc(a, j, c, e);
    f = Wjc(b, i[1]);
    h = Vjc(b, i[0]);
    g = Njc(a, j, f, h);
    if (d <= g) {
        b.a = c;
        b.c = e;
    } else {
        b.a = f;
        b.c = h;
    }
}
function TNc(a, b, c, d, e) {
    var f, g, h, i, j;
    if (b) for(h = b.Jc(); h.Ob();){
        g = JD(h.Pb(), 9);
        for(j = nYb(g, (Eyc(), Cyc), c).Jc(); j.Ob();){
            i = JD(j.Pb(), 11);
            f = JD(Wd(fsb(e.f, i)), 116);
            if (!f) {
                f = new XMc(a.d);
                YCb(d.c, f);
                MMc(f, i, e);
            }
        }
    }
}
function vnb(a) {
    var h;
    pnb();
    var b, c, d, e, f, g;
    if (RD(a, 59)) for(e = 0, d = a.gc() - 1; e < d; ++e, --d){
        h = a.Xb(e);
        a.fd(e, a.Xb(d));
        a.fd(d, h);
    }
    else {
        b = a.cd();
        f = a.dd(a.gc());
        while(b.Tb() < f.Vb()){
            c = b.Pb();
            g = f.Ub();
            b.Wb(g);
            f.Wb(c);
        }
    }
}
function oEc(a, b) {
    var c, d, e, f, g, h;
    h = 0;
    f = new nlb;
    $kb(f, b);
    while(f.b != f.c){
        g = JD(jlb(f), 217);
        h += SFc(g.d, g.e);
        for(e = new rmb(g.b); e.a < e.c.c.length;){
            d = JD(pmb(e), 36);
            c = JD(Mlb(a.b, d.p), 217);
            c.s || (h += oEc(a, c));
        }
    }
    return h;
}
function zPc(a, b, c) {
    var d, e;
    uPc(this);
    b == (gPc(), ePc) ? Nrb(this.r, a.c) : Nrb(this.w, a.c);
    c == ePc ? Nrb(this.r, a.d) : Nrb(this.w, a.d);
    vPc(this, a);
    d = wPc(a.c);
    e = wPc(a.d);
    yPc(this, d, e, e);
    this.o = (KOc(), $wnd.Math.abs(d - e) < 0.2);
}
function V8d(a, b, c) {
    var d, e, f, g, h, i;
    h = JD(Crd(a.a, 8), 1981);
    if (h != null) for(e = h, f = 0, g = e.length; f < g; ++f)null.Rm();
    d = c;
    if ((a.a.Db & 1) == 0) {
        i = new $8d(a, c, b);
        d.aj(i);
    }
    RD(d, 671) ? JD(d, 671).cj(a.a) : d._i() == a.a && d.bj(null);
}
function Xie() {
    var a;
    if (Rie) return JD(g1d((rOd(), qOd), eGe), 1990);
    Yie();
    a = JD(RD(Oib((rOd(), qOd), eGe), 577) ? Oib(qOd, eGe) : new Wie, 577);
    Rie = true;
    Uie(a);
    Vie(a);
    Qib((COd(), BOd), a, new Zie);
    Vvd(a);
    Rib(qOd, eGe, a);
    return a;
}
function FA(a, b, c, d) {
    var e;
    e = wA(a, c, WC(OC(hJ, 1), hre, 2, 6, [
        lse,
        mse,
        nse,
        ose,
        pse,
        qse,
        rse
    ]), b);
    e < 0 && (e = wA(a, c, WC(OC(hJ, 1), hre, 2, 6, [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]), b));
    if (e < 0) return false;
    d.d = e;
    return true;
}
function IA(a, b, c, d) {
    var e;
    e = wA(a, c, WC(OC(hJ, 1), hre, 2, 6, [
        lse,
        mse,
        nse,
        ose,
        pse,
        qse,
        rse
    ]), b);
    e < 0 && (e = wA(a, c, WC(OC(hJ, 1), hre, 2, 6, [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]), b));
    if (e < 0) return false;
    d.d = e;
    return true;
}
function gsb(a, b, c) {
    var d, e, f, g;
    g = a.b.Ae(b);
    e = (d = a.a.get(g), d == null ? SC(aJ, Nqe, 1, 0, 5, 1) : d);
    if (e.length == 0) a.a.set(g, e);
    else {
        f = dsb(a, b, e);
        if (f) return f.ld(c);
    }
    VC(e, e.length, new okb(b, c));
    ++a.c;
    ++a.b.g;
    return null;
}
function ZRb(a) {
    var b, c, d;
    WRb(a);
    d = new Ulb;
    for(c = new rmb(a.a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        Ilb(d, new jSb(b, true));
        Ilb(d, new jSb(b, false));
    }
    bSb(a.c);
    DTb(d, a.b, new dnb(WC(OC(cP, 1), Nqe, 374, 0, [
        a.c
    ])));
    YRb(a);
}
function dFb(a, b) {
    var c, d, e;
    e = new Ulb;
    for(d = new rmb(a.c.a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 60);
        if (b.Lb(c)) {
            Ilb(e, new rFb(c, true));
            Ilb(e, new rFb(c, false));
        }
    }
    jFb(a.e);
    aEb(e, a.d, new dnb(WC(OC(FM, 1), Nqe, 678, 0, [
        a.e
    ])));
}
function F0b(a) {
    var b, c, d, e;
    c = new Irb;
    for(e = new rmb(a.d); e.a < e.c.c.length;){
        d = JD(pmb(e), 187);
        b = JD(d.mf((Iqc(), Ppc)), 18);
        !!fsb(c.f, b) || Qib(c, b, new S0b(b));
        Ilb(JD(Wd(fsb(c.f, b)), 452).b, d);
    }
    return new Wlb(new Zjb(c));
}
function i7b(a, b) {
    var c, d, e, f, g;
    d = new olb(a.j.c.length);
    c = null;
    for(f = new rmb(a.j); f.a < f.c.c.length;){
        e = JD(pmb(f), 11);
        if (e.j != c) {
            d.b == d.c || j7b(d, c, b);
            alb(d);
            c = e.j;
        }
        g = o0b(e);
        !!g && _kb(d, g);
    }
    d.b == d.c || j7b(d, c, b);
}
function Y7b(a, b) {
    var c, d, e;
    d = new Ajb(a.b, 0);
    while(d.b < d.d.gc()){
        c = (rDb(d.b < d.d.gc()), JD(d.d.Xb(d.c = d.b++), 72));
        e = JD(WMb(c, (Bwc(), wuc)), 276);
        if (e == (nhd(), lhd)) {
            tjb(d);
            Ilb(b.b, c);
            XMb(c, (Iqc(), Ppc)) || ZMb(c, Ppc, a);
        }
    }
}
function hCc(a) {
    var b, c, d, e, f;
    b = Gr(new es(Ir(kYb(a).a.Jc(), new er)));
    for(e = new es(Ir(hYb(a).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        c = d.c.i;
        f = Gr(new es(Ir(kYb(c).a.Jc(), new er)));
        b = $wnd.Math.max(b, f);
    }
    return jfb(b);
}
function rnd(a, b, c) {
    var d, e, f;
    d = JD(ksd(a, (Lgd(), Xed)), 22);
    e = 0;
    f = 0;
    b.a > c.a && (d.Gc((Hed(), Bed)) ? e = (b.a - c.a) / 2 : d.Gc(Ded) && (e = b.a - c.a));
    b.b > c.b && (d.Gc((Hed(), Fed)) ? f = (b.b - c.b) / 2 : d.Gc(Eed) && (f = b.b - c.b));
    qnd(a, e, f);
}
function cwd(a, b, c, d, e, f, g, h, i, j, k, l, m) {
    RD(a.Cb, 88) && QVd(TTd(JD(a.Cb, 88)), 4);
    rvd(a, c);
    a.f = g;
    YRd(a, h);
    $Rd(a, i);
    SRd(a, j);
    ZRd(a, k);
    vRd(a, l);
    VRd(a, m);
    uRd(a, true);
    tRd(a, e);
    a.Wk(f);
    rRd(a, b);
    d != null && (a.i = null, URd(a, d));
}
function Jb(a, b, c) {
    if (a < 0) return hc(Mqe, WC(OC(aJ, 1), Nqe, 1, 5, [
        c,
        jfb(a)
    ]));
    else if (b < 0) throw scb(new Teb(Oqe + b));
    else return hc('%s (%s) must not be greater than size (%s)', WC(OC(aJ, 1), Nqe, 1, 5, [
        c,
        jfb(a),
        jfb(b)
    ]));
}
function Omb(a, b, c, d, e, f) {
    var g, h, i, j;
    g = d - c;
    if (g < 7) {
        Lmb(b, c, d, f);
        return;
    }
    i = c + e;
    h = d + e;
    j = i + (h - i >> 1);
    Omb(b, a, i, j, -e, f);
    Omb(b, a, j, h, -e, f);
    if (f.Le(a[j - 1], a[j]) <= 0) {
        while(c < d)VC(b, c++, a[i++]);
        return;
    }
    Mmb(a, i, j, h, b, c, d, f);
}
function jkc(a, b) {
    var c, d, e, f, g, h, i;
    i = b.d;
    e = b.b.j;
    for(h = new rmb(i); h.a < h.c.c.length;){
        g = JD(pmb(h), 105);
        f = SC(pcb, Vte, 30, e.c.length, 16, 1);
        Qib(a.b, g, f);
        c = g.a.d.p - 1;
        d = g.c.d.p;
        while(c != d){
            c = (c + 1) % e.c.length;
            f[c] = true;
        }
    }
}
function uAc(a, b) {
    qAc();
    if (XMb(a, (Iqc(), jqc)) && XMb(b, jqc)) return $eb(JD(WMb(a, jqc), 17).a, JD(WMb(b, jqc), 17).a);
    throw scb(new Z8c('The BF model order layer assigner requires all real nodes to have a model order.'));
}
function bBc(a, b) {
    VAc();
    if (XMb(a, (Iqc(), jqc)) && XMb(b, jqc)) return $eb(JD(WMb(a, jqc), 17).a, JD(WMb(b, jqc), 17).a);
    throw scb(new Z8c('The DF model order layer assigner requires all real nodes to have a model order.'));
}
function WMc(a, b) {
    a.r = new XMc(a.p);
    VMc(a.r, a);
    xe(a.r.j, a.j);
    Ltb(a.j);
    Atb(a.j, b);
    Atb(a.r.e, b);
    OMc(a);
    OMc(a.r);
    while(a.f.c.length != 0)bNc(JD(Mlb(a.f, 0), 133));
    while(a.k.c.length != 0)bNc(JD(Mlb(a.k, 0), 133));
    return a.r;
}
function Aqd(a, b, c) {
    var d, e, f;
    e = QTd(a.zh(), b);
    d = b - a.fi();
    if (d < 0) {
        if (!e) throw scb(new Teb(PCe + b + QCe));
        else if (e.ok()) {
            f = a.Eh(e);
            f >= 0 ? a.Zh(f, c) : wqd(a, e, c);
        } else throw scb(new Teb(LCe + e.ve() + MCe));
    } else fqd(a, d, e, c);
}
function I$d(a) {
    var b, c;
    if (a.f) {
        while(a.n > 0){
            b = JD(a.k.Xb(a.n - 1), 74);
            c = b.Ik();
            if (RD(c, 101) && (JD(c, 19).Bb & RCe) != 0 && (!a.e || c.mk() != t3 || c.Ij() != 0) && b.kd() != null) return true;
            else --a.n;
        }
        return false;
    } else return a.n > 0;
}
function ife(b) {
    var c, d, e, f;
    d = JD(b, 52).Xh();
    if (d) try {
        e = null;
        c = g1d((rOd(), qOd), ENd(FNd(d)));
        if (c) {
            f = c.Yh();
            !!f && (e = f.Cl(tgb(d.e)));
        }
        if (!!e && e != b) return ife(e);
    } catch (a) {
        a = rcb(a);
        if (!RD(a, 63)) throw scb(a);
    }
    return b;
}
function SZc(a, b, c) {
    var d, e, f;
    c.Sg('Remove overlaps', 1);
    c.ah(b, _ze);
    d = JD(ksd(b, (xYc(), wYc)), 27);
    a.f = d;
    a.a = x_c(JD(ksd(b, (b_c(), $$c)), 299));
    e = MD(ksd(b, (Lgd(), wgd)));
    vZc(a, (tDb(e), e));
    f = TYc(d);
    RZc(a, b, f, c);
    c.ah(b, bAe);
}
function S8c(a) {
    var b, c, d;
    if (ydb(LD(ksd(a, (Lgd(), lfd))))) {
        d = new Ulb;
        for(c = new es(Ir($Bd(a).a.Jc(), new er)); cs(c);){
            b = JD(ds(c), 85);
            Std(b) && ydb(LD(ksd(b, mfd))) && YCb(d.c, b);
        }
        return d;
    } else return pnb(), pnb(), mnb;
}
function CC(a) {
    if (!a) return WB(), VB;
    var b = a.valueOf ? a.valueOf() : a;
    if (b !== a) {
        var c = yC[typeof b];
        return c ? c(b) : FC(typeof b);
    } else if (a instanceof Array || a instanceof $wnd.Array) return new FB(a);
    else return new nC(a);
}
function TJb(a, b, c) {
    var d, e, f;
    f = a.o;
    d = JD(Kqb(a.p, c), 251);
    e = d.i;
    e.b = iIb(d);
    e.a = hIb(d);
    e.b = $wnd.Math.max(e.b, f.a);
    e.b > f.a && !b && (e.b = f.a);
    e.c = -(e.b - f.a) / 2;
    switch(c.g){
        case 1:
            e.d = -e.a;
            break;
        case 3:
            e.d = f.b;
    }
    jIb(d);
    kIb(d);
}
function UJb(a, b, c) {
    var d, e, f;
    f = a.o;
    d = JD(Kqb(a.p, c), 251);
    e = d.i;
    e.b = iIb(d);
    e.a = hIb(d);
    e.a = $wnd.Math.max(e.a, f.b);
    e.a > f.b && !b && (e.a = f.b);
    e.d = -(e.a - f.b) / 2;
    switch(c.g){
        case 4:
            e.c = -e.b;
            break;
        case 2:
            e.c = f.a;
    }
    jIb(d);
    kIb(d);
}
function Ybc(a, b) {
    var c, d, e;
    if (RD(b.g, 9) && JD(b.g, 9).k == (DYb(), wYb)) return Kse;
    e = ndc(b);
    if (e) return $wnd.Math.max(0, a.b / 2 - 0.5);
    c = mdc(b);
    if (c) {
        d = Beb(MD(kzc(c, (Bwc(), ewc))));
        return $wnd.Math.max(0, d / 2 - 0.5);
    }
    return Kse;
}
function $bc(a, b) {
    var c, d, e;
    if (RD(b.g, 9) && JD(b.g, 9).k == (DYb(), wYb)) return Kse;
    e = ndc(b);
    if (e) return $wnd.Math.max(0, a.b / 2 - 0.5);
    c = mdc(b);
    if (c) {
        d = Beb(MD(kzc(c, (Bwc(), ewc))));
        return $wnd.Math.max(0, d / 2 - 0.5);
    }
    return Kse;
}
function Cdc(a, b) {
    var c, d, e, f, g;
    if (b.dc()) return;
    e = JD(b.Xb(0), 132);
    if (b.gc() == 1) {
        Bdc(a, e, e, 1, 0, b);
        return;
    }
    c = 1;
    while(c < b.gc())if (e.j || !e.o) {
        f = Hdc(b, c);
        if (f) {
            d = JD(f.a, 17).a;
            g = JD(f.b, 132);
            Bdc(a, e, g, c, d, b);
            c = d + 1;
            e = g;
        }
    }
}
function pic(a) {
    var b, c, d, e, f, g;
    g = new Wlb(a.d);
    Slb(g, new Tic);
    b = (Dic(), WC(OC(TU, 1), Ere, 272, 0, [
        wic,
        zic,
        vic,
        Cic,
        yic,
        xic,
        Bic,
        Aic
    ]));
    c = 0;
    for(f = new rmb(g); f.a < f.c.c.length;){
        e = JD(pmb(f), 105);
        d = b[c % b.length];
        ric(e, d);
        ++c;
    }
}
function zzd(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = null;
    l = a;
    g = Zxd(l, 'x');
    c = new xAd(b);
    Uyd(c.a, g);
    h = Zxd(l, 'y');
    d = new zAd(b);
    Vyd(d.a, h);
    i = Zxd(l, gDe);
    e = new BAd(b);
    Wyd(e.a, i);
    j = Zxd(l, fDe);
    f = new DAd(b);
    k = (Xyd(f.a, j), j);
    return k;
}
function QVd(a, b) {
    MVd(a, b);
    (a.b & 1) != 0 && (a.a.a = null);
    (a.b & 2) != 0 && (a.a.f = null);
    if ((a.b & 4) != 0) {
        a.a.g = null;
        a.a.i = null;
    }
    if ((a.b & 16) != 0) {
        a.a.d = null;
        a.a.e = null;
    }
    (a.b & 8) != 0 && (a.a.b = null);
    if ((a.b & 32) != 0) {
        a.a.j = null;
        a.a.c = null;
    }
}
function e9d(b, c) {
    var d, e, f;
    f = 0;
    if (c.length > 0) try {
        f = Fdb(c, Lre, Hqe);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 130)) {
            e = a;
            throw scb(new kOd(e));
        } else throw scb(a);
    }
    d = (!b.a && (b.a = new s9d(b)), b.a);
    return f < d.i && f >= 0 ? JD(nDd(d, f), 57) : null;
}
function Ib(a, b) {
    if (a < 0) return hc(Mqe, WC(OC(aJ, 1), Nqe, 1, 5, [
        'index',
        jfb(a)
    ]));
    else if (b < 0) throw scb(new Teb(Oqe + b));
    else return hc('%s (%s) must be less than size (%s)', WC(OC(aJ, 1), Nqe, 1, 5, [
        'index',
        jfb(a),
        jfb(b)
    ]));
}
function Vmb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new Wgb(f.d) : Qgb(f.a, f.b);
        Ngb(f.a, '' + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function Wmb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new Wgb(f.d) : Qgb(f.a, f.b);
        Ngb(f.a, '' + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function Xmb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new Wgb(f.d) : Qgb(f.a, f.b);
        Ngb(f.a, '' + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function $mb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new Wgb(f.d) : Qgb(f.a, f.b);
        Ngb(f.a, '' + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function $ub(a, b) {
    var c, d, e, f, g, h;
    c = a.b.c.length;
    e = Mlb(a.b, b);
    while(b * 2 + 1 < c){
        d = (f = 2 * b + 1, g = f + 1, h = f, g < c && a.a.Le(Mlb(a.b, g), Mlb(a.b, f)) < 0 && (h = g), h);
        if (a.a.Le(e, Mlb(a.b, d)) < 0) break;
        Rlb(a.b, b, Mlb(a.b, d));
        b = d;
    }
    Rlb(a.b, b, e);
}
function zGb(a, b, c) {
    var d, e;
    d = c.d;
    e = c.e;
    if (a.g[d.d] <= a.i[b.d] && a.i[b.d] <= a.i[d.d] && a.g[e.d] <= a.i[b.d] && a.i[b.d] <= a.i[e.d]) {
        if (a.i[d.d] < a.i[e.d]) return false;
        return true;
    }
    if (a.i[d.d] < a.i[e.d]) return true;
    return false;
}
function aQb(a, b) {
    var c;
    c = JD(WMb(b, (Bwc(), ouc)), 323);
    if (c != a) throw scb(new Z8c('The hierarchy aware processor ' + c + ' in child node ' + b + ' is only allowed if the root node specifies the same hierarchical processor.'));
}
function dae(a, b) {
    var c, d, e, f, g;
    d = (!b.s && (b.s = new X0d(q6, b, 21, 17)), b.s);
    f = null;
    for(e = 0, g = d.i; e < g; ++e){
        c = JD(nDd(d, e), 178);
        switch(Tae(jae(a, c))){
            case 2:
            case 3:
                !f && (f = new Ulb);
                YCb(f.c, c);
        }
    }
    return !f ? (pnb(), pnb(), mnb) : f;
}
function ZLb(a, b, c) {
    var d, e, f, g, h, i;
    i = Kse;
    for(f = new rmb(vMb(a.b)); f.a < f.c.c.length;){
        e = JD(pmb(f), 176);
        for(h = new rmb(vMb(b.b)); h.a < h.c.c.length;){
            g = JD(pmb(h), 176);
            d = Ocd(e.a, e.b, g.a, g.b, c);
            i = $wnd.Math.min(i, d);
        }
    }
    return i;
}
function aZb(a, b) {
    if (!b) throw scb(new Efb);
    a.j = b;
    if (!a.d) switch(a.j.g){
        case 1:
            a.a.a = a.o.a / 2;
            a.a.b = 0;
            break;
        case 2:
            a.a.a = a.o.a;
            a.a.b = a.o.b / 2;
            break;
        case 3:
            a.a.a = a.o.a / 2;
            a.a.b = a.o.b;
            break;
        case 4:
            a.a.a = 0;
            a.a.b = a.o.b / 2;
    }
}
function G0b(a) {
    var b, c, d, e, f, g, h;
    d = 0;
    for(c = new rmb(a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        for(f = new rmb(b.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            e.p = d++;
            for(h = new rmb(e.j); h.a < h.c.c.length;){
                g = JD(pmb(h), 11);
                g.p = d++;
            }
        }
    }
}
function $dc(a, b) {
    Adc();
    var c, d, e, f, g, h;
    c = null;
    for(g = b.Jc(); g.Ob();){
        f = JD(g.Pb(), 132);
        if (f.o) continue;
        d = cdd(f.a);
        e = $cd(f.a);
        h = new kfc(d, e, null, JD(f.d.a.ec().Jc().Pb(), 18));
        Ilb(h.c, f.a);
        YCb(a.c, h);
        !!c && Ilb(c.d, h);
        c = h;
    }
}
function Afc(a) {
    var b, c, d, e, f, g;
    g = dGc(a.d, a.e);
    for(f = g.Jc(); f.Ob();){
        e = JD(f.Pb(), 11);
        d = a.e == (Rjd(), Qjd) ? e.e : e.g;
        for(c = new rmb(d); c.a < c.c.c.length;){
            b = JD(pmb(c), 18);
            if (!eWb(b) && b.c.i.c != b.d.i.c) {
                wfc(a, b);
                ++a.f;
                ++a.c;
            }
        }
    }
}
function Gmc(a, b) {
    var c, d;
    if (b.dc()) return pnb(), pnb(), mnb;
    d = new Ulb;
    Ilb(d, jfb(Lre));
    for(c = 1; c < a.f; ++c){
        a.a == null && emc(a);
        a.a[c] && Ilb(d, jfb(c));
    }
    if (d.c.length == 1) return pnb(), pnb(), mnb;
    Ilb(d, jfb(Hqe));
    return Fmc(b, d);
}
function nIc(a, b) {
    var c, d, e, f, g, h, i;
    g = b.c.i.k != (DYb(), AYb);
    i = g ? b.d : b.c;
    c = cWb(b, i).i;
    e = JD(Nib(a.k, i), 123);
    d = a.i[c.p].a;
    if (iYb(i.i) < (!c.c ? -1 : Nlb(c.c.a, c, 0))) {
        f = e;
        h = d;
    } else {
        f = d;
        h = e;
    }
    DFb(GFb(FFb(HFb(EFb(new IFb, 0), 4), f), h));
}
function Cyd(a, b, c) {
    var d, e, f, g, h, i;
    if (c) {
        e = c.a.length;
        d = new Rpe(e);
        for(h = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); h.Ob();){
            g = JD(h.Pb(), 17);
            i = lzd(a, Xxd(BB(c, g.a)));
            if (i) {
                f = (!b.b && (b.b = new ree(v3, b, 4, 7)), b.b);
                tCd(f, i);
            }
        }
    }
}
function Dyd(a, b, c) {
    var d, e, f, g, h, i;
    if (c) {
        e = c.a.length;
        d = new Rpe(e);
        for(h = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); h.Ob();){
            g = JD(h.Pb(), 17);
            i = lzd(a, Xxd(BB(c, g.a)));
            if (i) {
                f = (!b.c && (b.c = new ree(v3, b, 5, 8)), b.c);
                tCd(f, i);
            }
        }
    }
}
function xo(a, b, c) {
    var d, e;
    d = b.a & a.f;
    b.b = a.b[d];
    a.b[d] = b;
    e = b.f & a.f;
    b.d = a.c[e];
    a.c[e] = b;
    if (!c) {
        b.e = a.e;
        b.c = null;
        !a.e ? a.a = b : a.e.c = b;
        a.e = b;
    } else {
        b.e = c.e;
        !b.e ? a.a = b : b.e.c = b;
        b.c = c.c;
        !b.c ? a.e = b : b.c.e = b;
    }
    ++a.i;
    ++a.g;
}
function Er(a) {
    var b, c, d;
    b = a.Pb();
    if (!a.Ob()) return b;
    d = Pgb(Qgb(new Ugb, 'expected one element but was: <'), b);
    for(c = 0; c < 4 && a.Ob(); c++)Pgb((d.a += Lqe, d), a.Pb());
    a.Ob() && (d.a += ', ...', d);
    d.a += '>';
    throw scb(new Teb(d.a));
}
function WA(a) {
    var b, c;
    c = -a.a;
    b = WC(OC(_D, 1), Ure, 30, 15, [
        43,
        48,
        48,
        48,
        48
    ]);
    if (c < 0) {
        b[0] = 45;
        c = -c;
    }
    b[1] = b[1] + ((c / 60 | 0) / 10 | 0) & Wre;
    b[2] = b[2] + (c / 60 | 0) % 10 & Wre;
    b[3] = b[3] + (c % 60 / 10 | 0) & Wre;
    b[4] = b[4] + c % 10 & Wre;
    return zgb(b, 0, b.length);
}
function dYb(a) {
    var b, c, d, e;
    a.g = new Oqb(JD(Qb(v2), 295));
    d = 0;
    c = (Rjd(), xjd);
    b = 0;
    for(; b < a.j.c.length; b++){
        e = JD(Mlb(a.j, b), 11);
        if (e.j != c) {
            d != b && Lqb(a.g, c, new xod(jfb(d), jfb(b)));
            c = e.j;
            d = b;
        }
    }
    Lqb(a.g, c, new xod(jfb(d), jfb(b)));
}
function xqd(a, b) {
    var c, d, e;
    e = Z9d((Gfe(), Efe), a.zh(), b);
    if (e) {
        Ife();
        JD(e, 69).uk() || (e = Uae(jae(Efe, e)));
        d = (c = a.Eh(e), JD(c >= 0 ? a.Hh(c, true, true) : uqd(a, e, true), 159));
        JD(d, 218).Wl(b);
    } else throw scb(new Teb(LCe + b.ve() + MCe));
}
function thb(a) {
    var b, c;
    if (a > -140737488355328 && a < 140737488355328) {
        if (a == 0) return 0;
        b = a < 0;
        b && (a = -a);
        c = YD($wnd.Math.floor($wnd.Math.log(a) / 0.6931471805599453));
        (!b || a != $wnd.Math.pow(2, c)) && ++c;
        return c;
    }
    return uhb(zcb(a));
}
function rNc(a) {
    var b, c, d, e, f, g, h;
    f = new wtb;
    for(c = new rmb(a); c.a < c.c.c.length;){
        b = JD(pmb(c), 133);
        g = b.a;
        h = b.b;
        if (f.a._b(g) || f.a._b(h)) continue;
        e = g;
        d = h;
        if (g.e.b + g.j.b > 2 && h.e.b + h.j.b <= 2) {
            e = h;
            d = g;
        }
        f.a.yc(e, f);
        e.q = d;
    }
    return f;
}
function E_c(a, b, c) {
    c.Sg('Eades radial', 1);
    c.ah(b, bAe);
    a.d = JD(ksd(b, (xYc(), wYc)), 27);
    a.c = Beb(MD(ksd(b, (b_c(), V$c))));
    a.e = x_c(JD(ksd(b, $$c), 299));
    a.a = a$c(JD(ksd(b, a_c), 423));
    a.b = n_c(JD(ksd(b, R$c), 351));
    F_c(a);
    c.ah(b, bAe);
}
function I2c(a, b) {
    b.Sg('Target Width Setter', 1);
    if (lsd(a, (k2c(), j2c))) msd(a, (h1c(), g1c), MD(ksd(a, j2c)));
    else throw scb(new Y8c('A target width has to be set if the TargetWidthWidthApproximator should be used.'));
    b.Tg();
}
function l2b(a, b) {
    var c, d, e;
    d = new tYb(a);
    UMb(d, b);
    ZMb(d, (Iqc(), Spc), b);
    ZMb(d, (Bwc(), Evc), (ajd(), Xid));
    ZMb(d, Rtc, (ced(), $dd));
    rYb(d, (DYb(), wYb));
    c = new bZb;
    _Yb(c, d);
    aZb(c, (Rjd(), Qjd));
    e = new bZb;
    _Yb(e, d);
    aZb(e, wjd);
    return d;
}
function dnc(a) {
    switch(a.g){
        case 0:
            return new IEc((UEc(), REc));
        case 1:
            return new dEc;
        case 2:
            return new IFc;
        default:
            throw scb(new Teb('No implementation is available for the crossing minimizer ' + (a.f != null ? a.f : '' + a.g)));
    }
}
function WBc(a, b) {
    var c, d, e, f, g;
    a.c[b.p] = true;
    Ilb(a.a, b);
    for(g = new rmb(b.j); g.a < g.c.c.length;){
        f = JD(pmb(g), 11);
        for(d = new xZb(f.b); omb(d.a) || omb(d.b);){
            c = JD(omb(d.a) ? pmb(d.a) : pmb(d.b), 18);
            e = XBc(f, c).i;
            a.c[e.p] || WBc(a, e);
        }
    }
}
function MYc(a) {
    var b, c, d, e, f, g, h;
    g = 0;
    for(c = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 27);
        h = b.g;
        e = b.f;
        d = $wnd.Math.sqrt(h * h + e * e);
        g = $wnd.Math.max(d, g);
        f = MYc(b);
        g = $wnd.Math.max(f, g);
    }
    return g;
}
function ojd() {
    ojd = Zcb;
    mjd = new pjd('OUTSIDE', 0);
    kjd = new pjd('INSIDE', 1);
    ljd = new pjd('NEXT_TO_PORT_IF_POSSIBLE', 2);
    jjd = new pjd('ALWAYS_SAME_SIDE', 3);
    ijd = new pjd('ALWAYS_OTHER_SAME_SIDE', 4);
    njd = new pjd('SPACE_EFFICIENT', 5);
}
function vzd(a, b, c) {
    var d, e, f, h, i, j;
    d = hzd(a, (e = (Hpd(), f = new cxd, f), !!c && axd(e, c), e), b);
    Psd(d, byd(b, vDe));
    yzd(b, d);
    tzd(b, d);
    zzd(b, d);
    g = null;
    h = b;
    i = $xd(h, 'ports');
    j = new vAd(a, d);
    Tyd(j.a, j.b, i);
    uzd(a, b, d);
    pzd(a, b, d);
    return d;
}
function VA(a) {
    var b, c;
    c = -a.a;
    b = WC(OC(_D, 1), Ure, 30, 15, [
        43,
        48,
        48,
        58,
        48,
        48
    ]);
    if (c < 0) {
        b[0] = 45;
        c = -c;
    }
    b[1] = b[1] + ((c / 60 | 0) / 10 | 0) & Wre;
    b[2] = b[2] + (c / 60 | 0) % 10 & Wre;
    b[4] = b[4] + (c % 60 / 10 | 0) & Wre;
    b[5] = b[5] + c % 10 & Wre;
    return zgb(b, 0, b.length);
}
function YA(a) {
    var b;
    b = WC(OC(_D, 1), Ure, 30, 15, [
        71,
        77,
        84,
        45,
        48,
        48,
        58,
        48,
        48
    ]);
    if (a <= 0) {
        b[3] = 43;
        a = -a;
    }
    b[4] = b[4] + ((a / 60 | 0) / 10 | 0) & Wre;
    b[5] = b[5] + (a / 60 | 0) % 10 & Wre;
    b[7] = b[7] + (a % 60 / 10 | 0) & Wre;
    b[8] = b[8] + a % 10 & Wre;
    return zgb(b, 0, b.length);
}
function Ymb(a) {
    var b, c, d, e, f;
    if (a == null) return Rqe;
    f = new xxb(Lqe, '[', ']');
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new Wgb(f.d) : Qgb(f.a, f.b);
        Ngb(f.a, '' + Qcb(b));
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ('' + f.e);
}
function FGb(a, b) {
    var c, d, e;
    e = Hqe;
    for(d = new rmb(OFb(b)); d.a < d.c.c.length;){
        c = JD(pmb(d), 216);
        if (c.f && !a.c[c.c]) {
            a.c[c.c] = true;
            e = $wnd.Math.min(e, FGb(a, AFb(c, b)));
        }
    }
    a.i[b.d] = a.j;
    a.g[b.d] = $wnd.Math.min(e, a.j++);
    return a.g[b.d];
}
function GKb(a, b) {
    var c, d, e;
    for(e = JD(JD(Qc(a.r, b), 22), 83).Jc(); e.Ob();){
        d = JD(e.Pb(), 115);
        d.e.b = (c = d.b, c.nf((Lgd(), Xfd)) ? c.$f() == (Rjd(), xjd) ? -c.Kf().b - Beb(MD(c.mf(Xfd))) : Beb(MD(c.mf(Xfd))) : c.$f() == (Rjd(), xjd) ? -c.Kf().b : 0);
    }
}
function KWc(a) {
    var b, c, d, e, f;
    b = a.a;
    c = a.b;
    e = a.c;
    d = new Edd(c.e.a + c.f.a / 2, c.e.b + c.f.b / 2);
    f = new Edd(e.e.a + e.f.a / 2, e.e.b + e.f.b / 2);
    Dtb(b, d, b.a, b.a.a);
    Dtb(b, f, b.c.b, b.c);
    wQc(d, JD(fu(b, 1), 8), a.b.f);
    wQc(f, JD(fu(b, b.b - 2), 8), a.c.f);
}
function Xxd(a) {
    var b, c;
    c = false;
    if (RD(a, 210)) {
        c = true;
        return JD(a, 210).a;
    }
    if (!c) {
        if (RD(a, 263)) {
            b = JD(a, 263).a % 1 == 0;
            if (b) {
                c = true;
                return jfb(Feb(JD(a, 263).a));
            }
        }
    }
    throw scb(new eyd("Id must be a string or an integer: '" + a + "'."));
}
function d9d(a, b) {
    var c, d, e, f, g, h;
    f = null;
    for(e = new q9d((!a.a && (a.a = new s9d(a)), a.a)); n9d(e);){
        c = JD(SDd(e), 57);
        d = (g = c.zh(), h = (HTd(g), g.o), !h || !c.Th(h) ? null : afe(DSd(h), c.Ih(h)));
        if (d != null) {
            if (cgb(d, b)) {
                f = c;
                break;
            }
        }
    }
    return f;
}
function Nw(a, b, c) {
    var d, e, f, g, h;
    bk(c, 'occurrences');
    if (c == 0) return h = JD(Tv(nd(a.a), b), 16), !h ? 0 : h.gc();
    g = JD(Tv(nd(a.a), b), 16);
    if (!g) return 0;
    f = g.gc();
    if (c >= f) g.$b();
    else {
        e = g.Jc();
        for(d = 0; d < c; d++){
            e.Pb();
            e.Qb();
        }
    }
    return f;
}
function mx(a, b, c) {
    var d, e, f, g;
    bk(c, 'oldCount');
    bk(0, 'newCount');
    d = JD(Tv(nd(a.a), b), 16);
    if ((!d ? 0 : d.gc()) == c) {
        bk(0, 'count');
        e = (f = JD(Tv(nd(a.a), b), 16), !f ? 0 : f.gc());
        g = -e;
        g > 0 ? Fh() : g < 0 && Nw(a, b, -g);
        return true;
    } else return false;
}
function hIb(a) {
    var b, c, d, e, f, g, h;
    h = 0;
    if (a.b == 0) {
        g = lIb(a, true);
        b = 0;
        for(d = g, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (c > 0) {
                h += c;
                ++b;
            }
        }
        b > 1 && (h += a.c * (b - 1));
    } else h = Jub(RAb(GBb(BBb(Smb(a.a), new zIb), new BIb)));
    return h > 0 ? h + a.n.d + a.n.a : 0;
}
function iIb(a) {
    var b, c, d, e, f, g, h;
    h = 0;
    if (a.b == 0) h = Jub(RAb(GBb(BBb(Smb(a.a), new vIb), new xIb)));
    else {
        g = mIb(a, true);
        b = 0;
        for(d = g, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (c > 0) {
                h += c;
                ++b;
            }
        }
        b > 1 && (h += a.c * (b - 1));
    }
    return h > 0 ? h + a.n.b + a.n.c : 0;
}
function XIc(a) {
    var b, c;
    if (a.c.length != 2) throw scb(new Web('Order only allowed for two paths.'));
    b = (sDb(0, a.c.length), JD(a.c[0], 18));
    c = (sDb(1, a.c.length), JD(a.c[1], 18));
    if (b.d.i != c.c.i) {
        a.c.length = 0;
        YCb(a.c, c);
        YCb(a.c, b);
    }
}
function b3c(a, b, c) {
    var d;
    dtd(c, b.g, b.f);
    ftd(c, b.i, b.j);
    for(d = 0; d < (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i; d++)b3c(a, JD(nDd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a), d), 27), JD(nDd((!c.a && (c.a = new X0d(A3, c, 10, 11)), c.a), d), 27));
}
function OJb(a, b) {
    var c, d, e, f;
    f = JD(Kqb(a.b, b), 126);
    c = f.a;
    for(e = JD(JD(Qc(a.r, b), 22), 83).Jc(); e.Ob();){
        d = JD(e.Pb(), 115);
        !!d.c && (c.a = $wnd.Math.max(c.a, _Hb(d.c)));
    }
    if (c.a > 0) switch(b.g){
        case 2:
            f.n.c = a.s;
            break;
        case 4:
            f.n.b = a.s;
    }
}
function DMb(a, b) {
    var c, d, e;
    c = JD(WMb(b, (IOb(), vOb)), 17).a - JD(WMb(a, vOb), 17).a;
    if (c == 0) {
        d = Bdd(odd(JD(WMb(a, (TOb(), POb)), 8)), JD(WMb(a, QOb), 8));
        e = Bdd(odd(JD(WMb(b, POb), 8)), JD(WMb(b, QOb), 8));
        return Heb(d.a * d.b, e.a * e.b);
    }
    return c;
}
function MPc(a, b) {
    var c, d, e;
    c = JD(WMb(b, (kVc(), $Uc)), 17).a - JD(WMb(a, $Uc), 17).a;
    if (c == 0) {
        d = Bdd(odd(JD(WMb(a, (tUc(), UTc)), 8)), JD(WMb(a, VTc), 8));
        e = Bdd(odd(JD(WMb(b, UTc), 8)), JD(WMb(b, VTc), 8));
        return Heb(d.a * d.b, e.a * e.b);
    }
    return c;
}
function jWb(a) {
    var b, c;
    c = new Ugb;
    c.a += 'e_';
    b = aWb(a);
    b != null && (c.a += '' + b, c);
    if (!!a.c && !!a.d) {
        Qgb((c.a += ' ', c), YYb(a.c));
        Qgb(Pgb((c.a += '[', c), a.c.i), ']');
        Qgb((c.a += Fve, c), YYb(a.d));
        Qgb(Pgb((c.a += '[', c), a.d.i), ']');
    }
    return c.a;
}
function aQc(a) {
    switch(a.g){
        case 0:
            return new QVc;
        case 1:
            return new YVc;
        case 2:
            return new AWc;
        case 3:
            return new MWc;
        default:
            throw scb(new Teb('No implementation is available for the layout phase ' + (a.f != null ? a.f : '' + a.g)));
    }
}
function $md(a, b, c, d, e) {
    var f;
    f = 0;
    switch(e.g){
        case 1:
            f = $wnd.Math.max(0, b.b + a.b - (c.b + d));
            break;
        case 3:
            f = $wnd.Math.max(0, -a.b - d);
            break;
        case 2:
            f = $wnd.Math.max(0, -a.a - d);
            break;
        case 4:
            f = $wnd.Math.max(0, b.a + a.a - (c.a + d));
    }
    return f;
}
function Ayd(a, b, c) {
    var d, e, f, g, h;
    if (c) {
        e = c.a.length;
        d = new Rpe(e);
        for(h = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); h.Ob();){
            g = JD(h.Pb(), 17);
            f = _xd(c, g.a);
            lDe in f.a || mDe in f.a ? qzd(a, f, b) : wzd(a, f, b);
            lCd(JD(Nib(a.c, Yxd(f)), 85));
        }
    }
}
function ESd(a) {
    var b, c;
    switch(a.b){
        case -1:
            return true;
        case 0:
            c = a.t;
            if (c > 1 || c == -1) {
                a.b = -1;
                return true;
            } else {
                b = pRd(a);
                if (!!b && (Ife(), b.ik() == cFe)) {
                    a.b = -1;
                    return true;
                } else {
                    a.b = 1;
                    return false;
                }
            }
        default:
        case 1:
            return false;
    }
}
function lme(a, b) {
    var c, d, e, f;
    fme(a);
    if (a.c != 0 || a.a != 123) throw scb(new eme(qEd((a9d(), fEe))));
    f = b == 112;
    d = a.d;
    c = ggb(a.i, 125, d);
    if (c < 0) throw scb(new eme(qEd((a9d(), gEe))));
    e = qgb(a.i, d, c);
    a.d = c + 1;
    return Doe(e, f, (a.e & 512) == 512);
}
function IBc(a) {
    var b, c, d, e, f, g, h;
    h = av(a.c.length);
    for(e = new rmb(a); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        g = new Qrb;
        f = kYb(d);
        for(c = new es(Ir(f.a.Jc(), new er)); cs(c);){
            b = JD(ds(c), 18);
            b.c.i == b.d.i || Nrb(g, b.d.i);
        }
        YCb(h.c, g);
    }
    return h;
}
function aTd(a, b) {
    var c, d, e;
    if (!b) {
        cTd(a, null);
        USd(a, null);
    } else if ((b.i & 4) != 0) {
        d = '[]';
        for(c = b.c;; c = c.c){
            if ((c.i & 4) == 0) {
                e = jgb((ceb(c), c.o + d));
                cTd(a, e);
                USd(a, e);
                break;
            }
            d += '[]';
        }
    } else {
        e = jgb((ceb(b), b.o));
        cTd(a, e);
        USd(a, e);
    }
    a.el(b);
}
function Wbe(a, b, c, d, e) {
    var f, g, h, i;
    i = Vbe(a, JD(e, 57));
    if (XD(i) !== XD(e)) {
        h = JD(a.g[c], 74);
        f = Jfe(b, i);
        jDd(a, c, mce(a, c, f));
        if (qqd(a.e)) {
            g = Abe(a, 9, f.Ik(), e, i, d, false);
            NFd(g, new i_d(a.e, 9, a.c, h, f, d, false));
            OFd(g);
        }
        return i;
    }
    return e;
}
function DAc(a, b, c) {
    var d, e, f, g, h, i;
    d = JD(Qc(a.c, b), 15);
    e = JD(Qc(a.c, c), 15);
    f = d.dd(d.gc());
    g = e.dd(e.gc());
    while(f.Sb() && g.Sb()){
        h = JD(f.Ub(), 17);
        i = JD(g.Ub(), 17);
        if (h != i) return $eb(h.a, i.a);
    }
    return !f.Ob() && !g.Ob() ? 0 : f.Ob() ? 1 : -1;
}
function Mbd(c, d) {
    var e, f, g;
    try {
        g = ts(c.a, d);
        return g;
    } catch (b) {
        b = rcb(b);
        if (RD(b, 32)) {
            try {
                f = Fdb(d, Lre, Hqe);
                e = deb(c.a);
                if (f >= 0 && f < e.length) return e[f];
            } catch (a) {
                a = rcb(a);
                if (!RD(a, 130)) throw scb(a);
            }
            return null;
        } else throw scb(b);
    }
}
function vqd(a, b) {
    var c, d, e;
    e = Z9d((Gfe(), Efe), a.zh(), b);
    if (e) {
        Ife();
        JD(e, 69).uk() || (e = Uae(jae(Efe, e)));
        d = (c = a.Eh(e), JD(c >= 0 ? a.Hh(c, true, true) : uqd(a, e, true), 159));
        return JD(d, 218).Tl(b);
    } else throw scb(new Teb(LCe + b.ve() + OCe));
}
function u6d() {
    m6d();
    var a;
    if (l6d) return JD(g1d((rOd(), qOd), BFe), 1984);
    kNd(LK, new C8d);
    v6d();
    a = JD(RD(Oib((rOd(), qOd), BFe), 545) ? Oib(qOd, BFe) : new t6d, 545);
    l6d = true;
    r6d(a);
    s6d(a);
    Qib((COd(), BOd), a, new x6d);
    Rib(qOd, BFe, a);
    return a;
}
function obe(a, b) {
    var c, d, e, f;
    a.j = -1;
    if (qqd(a.e)) {
        c = a.i;
        f = a.i != 0;
        iDd(a, b);
        d = new i_d(a.e, 3, a.c, null, b, c, f);
        e = b.wl(a.e, a.c, null);
        e = ace(a, b, e);
        if (!e) Wpd(a.e, d);
        else {
            e.kj(d);
            e.lj();
        }
    } else {
        iDd(a, b);
        e = b.wl(a.e, a.c, null);
        !!e && e.lj();
    }
}
function zA(a, b) {
    var c, d, e;
    e = 0;
    d = b[0];
    if (d >= a.length) return -1;
    c = (ADb(d, a.length), a.charCodeAt(d));
    while(c >= 48 && c <= 57){
        e = e * 10 + (c - 48);
        ++d;
        if (d >= a.length) break;
        c = (ADb(d, a.length), a.charCodeAt(d));
    }
    d > b[0] ? b[0] = d : e = -1;
    return e;
}
function mMc(a, b, c) {
    var d, e, f, g, h;
    g = a.c;
    h = a.d;
    f = Kdd(WC(OC(b2, 1), hre, 8, 0, [
        g.i.n,
        g.n,
        g.a
    ])).b;
    e = (f + Kdd(WC(OC(b2, 1), hre, 8, 0, [
        h.i.n,
        h.n,
        h.a
    ])).b) / 2;
    d = null;
    g.j == (Rjd(), wjd) ? d = new Edd(b + g.i.c.c.a + c, e) : d = new Edd(b - c, e);
    du(a.a, 0, d);
}
function Std(a) {
    var b, c, d, e;
    b = null;
    for(d = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        (!a.b && (a.b = new ree(v3, a, 4, 7)), a.b),
        (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c)
    ]))); cs(d);){
        c = JD(ds(d), 84);
        e = _Bd(c);
        if (!b) b = e;
        else if (b != e) return false;
    }
    return true;
}
function pDd(a, b, c) {
    var d;
    ++a.j;
    if (b >= a.i) throw scb(new mdb(NDe + b + ODe + a.i));
    if (c >= a.i) throw scb(new mdb(PDe + c + ODe + a.i));
    d = a.g[c];
    if (b != c) {
        b < c ? $gb(a.g, b, a.g, b + 1, c - b) : $gb(a.g, c + 1, a.g, c, b - c);
        VC(a.g, b, d);
        a.Mi(b, d, c);
        a.Ki();
    }
    return d;
}
function Rc(a, b, c) {
    var d;
    d = JD(a.c.xc(b), 16);
    if (!d) {
        d = a.ic(b);
        if (d.Ec(c)) {
            ++a.d;
            a.c.yc(b, d);
            return true;
        } else throw scb(new udb('New Collection violated the Collection spec'));
    } else if (d.Ec(c)) {
        ++a.d;
        return true;
    } else return false;
}
function efb(a) {
    var b, c, d;
    if (a < 0) return 0;
    else if (a == 0) return 32;
    else {
        d = -(a >> 16);
        b = d >> 16 & 16;
        c = 16 - b;
        a = a >> b;
        d = a - 256;
        b = d >> 16 & 8;
        c += b;
        a <<= b;
        d = a - Mse;
        b = d >> 16 & 4;
        c += b;
        a <<= b;
        d = a - ire;
        b = d >> 16 & 2;
        c += b;
        a <<= b;
        d = a >> 14;
        b = d & ~(d >> 1);
        return c + 2 - b;
    }
}
function kQc(a, b) {
    var c, d, e;
    e = new Ulb;
    for(d = Gtb(b.a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 65);
        c.c.g == a.g && XD(WMb(c.b, (kVc(), iVc))) !== XD(WMb(c.c, iVc)) && !xBb(new RBb(null, new Gvb(e, 16)), new LQc(c)) && YCb(e.c, c);
    }
    Slb(e, new NQc);
    return e;
}
function pNb(a, b, c) {
    var d, e, f, g;
    if (RD(b, 151) && RD(c, 151)) {
        f = JD(b, 151);
        g = JD(c, 151);
        return a.a[f.a][g.a] + a.a[g.a][f.a];
    } else if (RD(b, 249) && RD(c, 249)) {
        d = JD(b, 249);
        e = JD(c, 249);
        if (d.a == e.a) return JD(WMb(e.a, (IOb(), vOb)), 17).a;
    }
    return 0;
}
function C2b(a, b) {
    var c, d, e, f, g, h, i, j;
    j = Beb(MD(WMb(b, (Bwc(), iwc))));
    i = a[0].n.a + a[0].o.a + a[0].d.c + j;
    for(h = 1; h < a.length; h++){
        d = a[h].n;
        e = a[h].o;
        c = a[h].d;
        f = d.a - c.b - i;
        f < 0 && (d.a -= f);
        g = b.f;
        g.a = $wnd.Math.max(g.a, d.a + e.a);
        i = d.a + e.a + c.c + j;
    }
}
function b5c(a, b) {
    var c, d, e, f, g, h;
    d = JD(JD(Nib(a.g, b.a), 47).a, 68);
    e = JD(JD(Nib(a.g, b.b), 47).a, 68);
    f = d.b;
    g = e.b;
    c = Xcd(f, g);
    if (c >= 0) return c;
    h = sdd(Bdd(new Edd(g.c + g.b / 2, g.d + g.a / 2), new Edd(f.c + f.b / 2, f.d + f.a / 2)));
    return -(wMb(f, g) - 1) * h;
}
function gnd(a, b, c) {
    var d;
    EBb(new RBb(null, (!c.a && (c.a = new X0d(w3, c, 6, 6)), new Gvb(c.a, 16))), new ynd(a, b));
    EBb(new RBb(null, (!c.n && (c.n = new X0d(z3, c, 1, 7)), new Gvb(c.n, 16))), new And(a, b));
    d = JD(ksd(c, (Lgd(), tfd)), 77);
    !!d && Odd(d, a, b);
}
function uqd(a, b, c) {
    var d, e, f;
    f = Z9d((Gfe(), Efe), a.zh(), b);
    if (f) {
        Ife();
        JD(f, 69).uk() || (f = Uae(jae(Efe, f)));
        e = (d = a.Eh(f), JD(d >= 0 ? a.Hh(d, true, true) : uqd(a, f, true), 159));
        return JD(e, 218).Pl(b, c);
    } else throw scb(new Teb(LCe + b.ve() + OCe));
}
function tJd(a, b, c, d) {
    var e, f, g, h, i;
    e = a.d[b];
    if (e) {
        f = e.g;
        i = e.i;
        if (d != null) for(h = 0; h < i; ++h){
            g = JD(f[h], 135);
            if (g.xi() == c && pb(d, g.jd())) return g;
        }
        else for(h = 0; h < i; ++h){
            g = JD(f[h], 135);
            if (XD(g.jd()) === XD(d)) return g;
        }
    }
    return null;
}
function gae(a, b) {
    var c, d, e, f, g;
    d = (!b.s && (b.s = new X0d(q6, b, 21, 17)), b.s);
    f = null;
    for(e = 0, g = d.i; e < g; ++e){
        c = JD(nDd(d, e), 178);
        switch(Tae(jae(a, c))){
            case 4:
            case 5:
            case 6:
                !f && (f = new Ulb);
                YCb(f.c, c);
                break;
        }
    }
    return !f ? (pnb(), pnb(), mnb) : f;
}
function Phb(a, b) {
    var c;
    if (b < 0) throw scb(new kdb('Negative exponent'));
    if (b == 0) return Bhb;
    else if (b == 1 || Jhb(a, Bhb) || Jhb(a, Fhb)) return a;
    if (!Shb(a, 0)) {
        c = 1;
        while(!Shb(a, c))++c;
        return Nhb(bib(c * b), Phb(Rhb(a, c), b));
    }
    return Iib(a, b);
}
function Amb(a, b) {
    var c, d, e;
    if (XD(a) === XD(b)) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;
    for(c = 0; c < a.length; ++c){
        d = a[c];
        e = b[c];
        if (!(XD(d) === XD(e) || d != null && pb(d, e))) return false;
    }
    return true;
}
function ORb(a) {
    zRb();
    var b, c, d;
    this.b = yRb;
    this.c = (Tgd(), Rgd);
    this.f = (uRb(), tRb);
    this.a = a;
    LRb(this, new PRb);
    ERb(this);
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 82);
        if (!c.d) {
            b = new sRb(WC(OC(JO, 1), Nqe, 82, 0, [
                c
            ]));
            Ilb(a.a, b);
        }
    }
}
function e0b(a, b, c) {
    var d, e, f, g, h, i;
    if (!a || a.c.length == 0) return null;
    f = new eIb(b, !c);
    for(e = new rmb(a); e.a < e.c.c.length;){
        d = JD(pmb(e), 72);
        WHb(f, (sWb(), new NWb(d)));
    }
    g = f.i;
    g.a = (i = f.n, f.e.b + i.d + i.a);
    g.b = (h = f.n, f.e.a + h.b + h.c);
    return f;
}
function p2b(a) {
    var b, c, d, e, f, g, h;
    h = DXb(a.a);
    Qmb(h, new u2b);
    c = null;
    for(e = h, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        if (d.k != (DYb(), wYb)) break;
        b = JD(WMb(d, (Iqc(), Tpc)), 64);
        if (b != (Rjd(), Qjd) && b != wjd) continue;
        !!c && JD(WMb(c, aqc), 15).Ec(d);
        c = d;
    }
}
function zNc(a, b, c) {
    var d, e, f, g, h, i, j;
    i = (sDb(b, a.c.length), JD(a.c[b], 335));
    Olb(a, b);
    if (i.b / 2 >= c) {
        d = b;
        j = (i.c + i.a) / 2;
        g = j - c;
        if (i.c <= j - c) {
            e = new ENc(i.c, g);
            Hlb(a, d++, e);
        }
        h = j + c;
        if (h <= i.a) {
            f = new ENc(h, i.a);
            vDb(d, a.c.length);
            WCb(a.c, d, f);
        }
    }
}
function pTc(a, b, c) {
    var d, e, f, g, h, i;
    if (!b.dc()) {
        e = new Mtb;
        for(i = b.Jc(); i.Ob();){
            h = JD(i.Pb(), 39);
            Qib(a.a, jfb(h.g), jfb(c));
            for(g = (d = Gtb(new gRc(h).a.d, 0), new jRc(d)); Ttb(g.a);){
                f = JD(Utb(g.a), 65).c;
                Dtb(e, f, e.c.b, e.c);
            }
        }
        pTc(a, e, c + 1);
    }
}
function n9d(a) {
    var b;
    if (!a.c && a.g == null) {
        a.d = a.$i(a.f);
        tCd(a, a.d);
        b = a.d;
    } else {
        if (a.g == null) return true;
        else if (a.i == 0) return false;
        else b = JD(a.g[a.i - 1], 49);
    }
    if (b == a.b && null.Sm >= null.Rm()) {
        SDd(a);
        return n9d(a);
    } else return b.Ob();
}
function DUb(a) {
    this.a = a;
    if (a.c.i.k == (DYb(), wYb)) {
        this.c = a.c;
        this.d = JD(WMb(a.c.i, (Iqc(), Tpc)), 64);
    } else if (a.d.i.k == wYb) {
        this.c = a.d;
        this.d = JD(WMb(a.d.i, (Iqc(), Tpc)), 64);
    } else throw scb(new Teb('Edge ' + a + ' is not an external edge.'));
}
function hZd(a, b) {
    var c, d, e;
    e = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 3, e, a.b));
    if (!b) {
        rvd(a, null);
        jZd(a, 0);
        iZd(a, null);
    } else if (b != a) {
        rvd(a, b.zb);
        jZd(a, b.d);
        c = (d = b.c, d == null ? b.zb : d);
        iZd(a, c == null || cgb(c, b.zb) ? null : c);
    }
}
function fj(a, b) {
    var c;
    this.e = (qm(), Qb(a), qm(), wm(a));
    this.c = (Qb(b), wm(b));
    Lb(this.e.Pd().dc() == this.c.Pd().dc());
    this.d = Qv(this.e);
    this.b = Qv(this.c);
    c = QC(aJ, [
        hre,
        Nqe
    ], [
        5,
        1
    ], 5, [
        this.e.Pd().gc(),
        this.c.Pd().gc()
    ], 2);
    this.a = c;
    Xi(this);
}
function Dz(b) {
    var c = (!Bz && (Bz = Ez()), Bz);
    var d = b.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g, function(a) {
        return Cz(a, c);
    });
    return '"' + d + '"';
}
function UCb(a, b, c, d, e, f) {
    var g, h, i, j, k;
    if (e == 0) return;
    if (XD(a) === XD(c)) {
        a = a.slice(b, b + e);
        b = 0;
    }
    i = c;
    for(h = b, j = b + e; h < j;){
        g = $wnd.Math.min(h + 10000, j);
        e = g - h;
        k = a.slice(h, g);
        k.splice(0, 0, d, f ? e : 0);
        Array.prototype.splice.apply(i, k);
        h = g;
        d += e;
    }
}
function UEb(a) {
    EEb();
    var b, c;
    this.b = BEb;
    this.c = DEb;
    this.g = (vEb(), uEb);
    this.d = (Tgd(), Rgd);
    this.a = a;
    HEb(this);
    for(c = new rmb(a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        !b.a && fEb(hEb(new iEb, WC(OC(LM, 1), Nqe, 60, 0, [
            b
        ])), a);
        b.e = new hdd(b.d);
    }
}
function xMb(a) {
    var b, c, d, e, f, g;
    e = a.e.c.length;
    d = SC(HK, nue, 15, e, 0, 1);
    for(g = new rmb(a.e); g.a < g.c.c.length;){
        f = JD(pmb(g), 151);
        d[f.a] = new Mtb;
    }
    for(c = new rmb(a.c); c.a < c.c.c.length;){
        b = JD(pmb(c), 288);
        d[b.c.a].Ec(b);
        d[b.d.a].Ec(b);
    }
    return d;
}
function lId(a, b) {
    var c, d, e, f, g;
    c = JD(Crd(a.a, 4), 128);
    g = c == null ? 0 : c.length;
    if (b >= g) throw scb(new zHd(b, g));
    e = c[b];
    if (g == 1) d = null;
    else {
        d = SC(X4, JEe, 412, g - 1, 0, 1);
        $gb(c, 0, d, 0, b);
        f = g - b - 1;
        f > 0 && $gb(c, b + 1, d, b, f);
    }
    W8d(a, d);
    V8d(a, b, e);
    return e;
}
function G$d(a) {
    var b, c;
    if (a.f) {
        while(a.n < a.o){
            b = JD(!a.j ? a.k.Xb(a.n) : a.j.Xi(a.n), 74);
            c = b.Ik();
            if (RD(c, 101) && (JD(c, 19).Bb & RCe) != 0 && (!a.e || c.mk() != t3 || c.Ij() != 0) && b.kd() != null) return true;
            else ++a.n;
        }
        return false;
    } else return a.n < a.o;
}
function ehe() {
    ehe = Zcb;
    che = JD(nDd(STd((jhe(), ihe).qb), 6), 35);
    _ge = JD(nDd(STd(ihe.qb), 3), 35);
    ahe = JD(nDd(STd(ihe.qb), 4), 35);
    bhe = JD(nDd(STd(ihe.qb), 5), 19);
    QRd(che);
    QRd(_ge);
    QRd(ahe);
    QRd(bhe);
    dhe = new dnb(WC(OC(q6, 1), mFe, 178, 0, [
        che,
        _ge
    ]));
}
function CJb(a, b) {
    var c;
    this.d = new ZXb;
    this.b = b;
    this.e = new Fdd(b.Jf());
    c = a.u.Gc((ojd(), ljd));
    a.u.Gc(kjd) ? a.F ? this.a = c && !b._f() : this.a = true : a.u.Gc(mjd) ? c ? this.a = !(b.Sf().Jc().Ob() || b.Uf().Jc().Ob()) : this.a = false : this.a = false;
}
function KKb(a, b) {
    var c, d, e, f;
    c = a.o.a;
    for(f = JD(JD(Qc(a.r, b), 22), 83).Jc(); f.Ob();){
        e = JD(f.Pb(), 115);
        e.e.a = (d = e.b, d.nf((Lgd(), Xfd)) ? d.$f() == (Rjd(), Qjd) ? -d.Kf().a - Beb(MD(d.mf(Xfd))) : c + Beb(MD(d.mf(Xfd))) : d.$f() == (Rjd(), Qjd) ? -d.Kf().a : c);
    }
}
function gNb(a) {
    var b, c, d, e, f, g, h;
    d = a.a.c.length;
    if (d > 0) {
        g = a.c.d;
        h = a.d.d;
        e = wdd(Bdd(new Edd(h.a, h.b), g), 1 / (d + 1));
        f = new Edd(g.a, g.b);
        for(c = new rmb(a.a); c.a < c.c.c.length;){
            b = JD(pmb(c), 249);
            b.d.a = f.a + e.a;
            b.d.b = f.b + e.b;
            f.a += e.a;
            f.b += e.b;
        }
    }
}
function k$b(a, b) {
    var c, d, e, f;
    c = JD(WMb(a, (Bwc(), ruc)), 86);
    f = JD(ksd(b, Jvc), 64);
    e = JD(WMb(a, Evc), 100);
    if (e != (ajd(), $id) && e != _id) {
        if (f == (Rjd(), Pjd)) {
            f = Ymd(b, c);
            f == Pjd && (f = Wjd(c));
        }
    } else {
        d = g$b(b);
        d > 0 ? f = Wjd(c) : f = Tjd(Wjd(c));
    }
    msd(b, Jvc, f);
}
function c7b(a, b) {
    var c, d;
    if (a.c.length != 0) {
        if (a.c.length == 2) {
            b7b((sDb(0, a.c.length), JD(a.c[0], 9)), (oid(), kid));
            b7b((sDb(1, a.c.length), JD(a.c[1], 9)), lid);
        } else for(d = new rmb(a); d.a < d.c.c.length;){
            c = JD(pmb(d), 9);
            b7b(c, b);
        }
        a.c.length = 0;
    }
}
function o9b(a, b) {
    var c;
    b.Sg('Partition preprocessing', 1);
    c = JD(yBb(BBb(DBb(BBb(new RBb(null, new Gvb(a.a, 16)), new s9b), new u9b), new w9b), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    EBb(c.Mc(), new y9b);
    b.Tg();
}
function ric(a, b) {
    var c, d, e, f, g;
    g = a.j;
    b.a != b.b && Slb(g, new Xic);
    e = g.c.length / 2 | 0;
    for(d = 0; d < e; d++){
        f = (sDb(d, g.c.length), JD(g.c[d], 112));
        f.c && aZb(f.d, b.a);
    }
    for(c = e; c < g.c.length; c++){
        f = (sDb(c, g.c.length), JD(g.c[c], 112));
        f.c && aZb(f.d, b.b);
    }
}
function uFc(a, b, c) {
    var d, e, f;
    d = a.c[b.c.p][b.p];
    e = a.c[c.c.p][c.p];
    if (d.a != null && e.a != null) {
        f = Aeb(d.a, e.a);
        f < 0 ? xFc(a, b, c) : f > 0 && xFc(a, c, b);
        return f;
    } else if (d.a != null) {
        xFc(a, b, c);
        return -1;
    } else if (e.a != null) {
        xFc(a, c, b);
        return 1;
    }
    return 0;
}
function eLc(a) {
    ZKc();
    var b, c, d, e, f, g, h;
    c = new Xsb;
    for(e = new rmb(a.e.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        for(g = new rmb(d.a); g.a < g.c.c.length;){
            f = JD(pmb(g), 9);
            h = a.g[f.p];
            b = JD(Tsb(c, h), 15);
            if (!b) {
                b = new Ulb;
                Usb(c, h, b);
            }
            b.Ec(f);
        }
    }
    return c;
}
function HPc(a, b) {
    var c, d, e, f, g;
    e = b.b.b;
    a.a = SC(HK, nue, 15, e, 0, 1);
    a.b = SC(pcb, Vte, 30, e, 16, 1);
    for(g = Gtb(b.b, 0); g.b != g.d.c;){
        f = JD(Utb(g), 39);
        a.a[f.g] = new Mtb;
    }
    for(d = Gtb(b.a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 65);
        a.a[c.b.g].Ec(c);
        a.a[c.c.g].Ec(c);
    }
}
function pFd(a, b) {
    var c, d, e, f;
    if (a.Mj()) {
        c = a.Bj();
        f = a.Nj();
        ++a.j;
        a.nj(c, a.Wi(c, b));
        d = a.Fj(3, null, b, c, f);
        if (a.Jj()) {
            e = a.Kj(b, null);
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        } else a.Gj(d);
    } else {
        yEd(a, b);
        if (a.Jj()) {
            e = a.Kj(b, null);
            !!e && e.lj();
        }
    }
}
function NGd(a, b, c) {
    var d, e, f;
    if (a.Mj()) {
        f = a.Nj();
        hDd(a, b, c);
        d = a.Fj(3, null, c, b, f);
        if (a.Jj()) {
            e = a.Kj(c, null);
            a.Qj() && (e = a.Rj(c, e));
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        } else a.Gj(d);
    } else {
        hDd(a, b, c);
        if (a.Jj()) {
            e = a.Kj(c, null);
            !!e && e.lj();
        }
    }
}
function wbe(a, b) {
    var c, d, e, f, g;
    g = Kfe(a.e.zh(), b);
    e = new vDd;
    c = JD(a.g, 122);
    for(f = a.i; --f >= 0;){
        d = c[f];
        g.Zl(d.Ik()) && tCd(e, d);
    }
    !VGd(a, e) && qqd(a.e) && zUd(a, b.Gk() ? Abe(a, 6, b, (pnb(), mnb), null, -1, false) : Abe(a, b.qk() ? 2 : 1, b, null, null, -1, false));
}
function l1b(a, b) {
    var c, d, e, f, g;
    if (a.a == (Koc(), Ioc)) return true;
    f = b.a.c;
    c = b.a.c + b.a.b;
    if (b.j) {
        d = b.A;
        g = d.c.c.a - d.o.a / 2;
        e = f - (d.n.a + d.o.a);
        if (e > g) return false;
    }
    if (b.q) {
        d = b.C;
        g = d.c.c.a - d.o.a / 2;
        e = d.n.a - c;
        if (e > g) return false;
    }
    return true;
}
function z2b(a, b, c) {
    var d, e, f, g, h, i;
    d = 0;
    i = c;
    if (!b) {
        d = c * (a.c.length - 1);
        i *= -1;
    }
    for(f = new rmb(a); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        ZMb(e, (Bwc(), Rtc), (ced(), $dd));
        e.o.a = d;
        for(h = oYb(e, (Rjd(), wjd)).Jc(); h.Ob();){
            g = JD(h.Pb(), 11);
            g.n.a = d;
        }
        d += i;
    }
}
function sud(a) {
    var b;
    if ((a.Db & 64) != 0) return Gqd(a);
    b = new Jgb(Gqd(a));
    b.a += ' (startX: ';
    Bgb(b, a.j);
    b.a += ', startY: ';
    Bgb(b, a.k);
    b.a += ', endX: ';
    Bgb(b, a.b);
    b.a += ', endY: ';
    Bgb(b, a.c);
    b.a += ', identifier: ';
    Egb(b, a.d);
    b.a += ')';
    return b.a;
}
function xRd(a) {
    var b;
    if ((a.Db & 64) != 0) return svd(a);
    b = new Jgb(svd(a));
    b.a += ' (ordered: ';
    Fgb(b, (a.Bb & 256) != 0);
    b.a += ', unique: ';
    Fgb(b, (a.Bb & 512) != 0);
    b.a += ', lowerBound: ';
    Cgb(b, a.s);
    b.a += ', upperBound: ';
    Cgb(b, a.t);
    b.a += ')';
    return b.a;
}
function Yvd(a, b, c, d, e, f, g, h) {
    var i;
    RD(a.Cb, 88) && QVd(TTd(JD(a.Cb, 88)), 4);
    rvd(a, c);
    a.f = d;
    YRd(a, e);
    $Rd(a, f);
    SRd(a, g);
    ZRd(a, false);
    vRd(a, true);
    VRd(a, h);
    uRd(a, true);
    tRd(a, 0);
    a.b = 0;
    wRd(a, 1);
    i = qRd(a, b, null);
    !!i && i.lj();
    FSd(a, false);
    return a;
}
function Nzb(a, b) {
    var c, d, e, f;
    c = JD(Oib(a.a, b), 509);
    if (!c) {
        d = new cAb(b);
        e = (Wzb(), Tzb) ? null : d.c;
        f = qgb(e, 0, $wnd.Math.max(0, kgb(e, wgb(46))));
        bAb(d, Nzb(a, f));
        (Tzb ? null : d.c).length == 0 && Yzb(d, new fAb);
        Rib(a.a, Tzb ? null : d.c, d);
        return d;
    }
    return c;
}
function Azd() {
    this.a = new dyd;
    this.n = new Eo;
    this.p = new Eo;
    this.c = new Irb;
    this.f = new Eo;
    this.o = new Eo;
    this.q = new Irb;
    this.d = new Irb;
    this.g = new Irb;
    this.k = new Irb;
    this.e = new Irb;
    this.i = new Irb;
    this.j = new Irb;
    this.r = new Irb;
    this.b = new Irb;
}
function BUd(a, b, c) {
    var d, e, f, g, h, i;
    h = a.ml(c);
    if (h != c) {
        g = a.g[b];
        i = h;
        jDd(a, b, a.Wi(b, i));
        f = g;
        a.Oi(b, i, f);
        if (a.Zk()) {
            d = c;
            e = a.Lj(d, null);
            !JD(h, 52).Lh() && (e = a.Kj(i, e));
            !!e && e.lj();
        }
        qqd(a.e) && zUd(a, a.Fj(9, c, h, b, false));
        return h;
    } else return c;
}
function BRb(a, b) {
    var c, d, e, f;
    for(d = new rmb(a.a.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 194);
        c.g = true;
    }
    for(f = new rmb(a.a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 82);
        e.k = ydb(LD(a.e.Kb(new xod(e, b))));
        e.d.g = e.d.g & ydb(LD(a.e.Kb(new xod(e, b))));
    }
    return a;
}
function FAc(a, b, c) {
    var d, e, f, g, h;
    if (a.d[c.p]) return;
    for(e = new es(Ir(kYb(c).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        h = d.d.i;
        for(g = new es(Ir(hYb(h).a.Jc(), new er)); cs(g);){
            f = JD(ds(g), 18);
            f.c.i == b && (a.a[f.p] = true);
        }
        FAc(a, b, h);
    }
    a.d[c.p] = true;
}
function Drd(a, b) {
    var c, d, e, f, g, h, i;
    d = Zeb(a.Db & 254);
    if (d == 1) a.Eb = null;
    else {
        f = KD(a.Eb);
        if (d == 2) {
            e = Brd(a, b);
            a.Eb = f[e == 0 ? 1 : 0];
        } else {
            g = SC(aJ, Nqe, 1, d - 1, 5, 1);
            for(c = 2, h = 0, i = 0; c <= 128; c <<= 1)c == b ? ++h : (a.Db & c) != 0 && (g[i++] = f[h++]);
            a.Eb = g;
        }
    }
    a.Db &= ~b;
}
function Mne(a) {
    var b;
    b = 0;
    switch(a){
        case 105:
            b = 2;
            break;
        case 109:
            b = 8;
            break;
        case 115:
            b = 4;
            break;
        case 120:
            b = 16;
            break;
        case 117:
            b = 32;
            break;
        case 119:
            b = 64;
            break;
        case 70:
            b = 256;
            break;
        case 72:
            b = 128;
            break;
        case 88:
            b = 512;
            break;
        case 44:
            b = NEe;
    }
    return b;
}
function Fib(a, b, c, d, e) {
    var f, g, h, i;
    if (XD(a) === XD(b) && d == e) {
        Kib(a, d, c);
        return;
    }
    for(h = 0; h < d; h++){
        g = 0;
        f = a[h];
        for(i = 0; i < e; i++){
            g = tcb(tcb(Fcb(ucb(f, Use), ucb(b[i], Use)), ucb(c[h + i], Use)), ucb(Pcb(g), Use));
            c[h + i] = Pcb(g);
            g = Lcb(g, 32);
        }
        c[h + e] = Pcb(g);
    }
}
function shc(a) {
    var b, c, d, e, f;
    c = (b = JD(deb(v2), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    f = JD(WMb(a, (Iqc(), sqc)), 9);
    if (f) for(e = new rmb(f.j); e.a < e.c.c.length;){
        d = JD(pmb(e), 11);
        XD(WMb(d, kqc)) === XD(a) && wZb(new xZb(d.b)) && orb(c, d.j);
    }
    return c;
}
function PMc(a, b) {
    if (b.b != 0) {
        isNaN(a.s) ? a.s = Beb((rDb(b.b != 0), MD(b.a.a.c))) : a.s = $wnd.Math.min(a.s, Beb((rDb(b.b != 0), MD(b.a.a.c))));
        isNaN(a.c) ? a.c = Beb((rDb(b.b != 0), MD(b.c.b.c))) : a.c = $wnd.Math.max(a.c, Beb((rDb(b.b != 0), MD(b.c.b.c))));
    }
}
function Rtd(a) {
    var b, c, d, e;
    b = null;
    for(d = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        (!a.b && (a.b = new ree(v3, a, 4, 7)), a.b),
        (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c)
    ]))); cs(d);){
        c = JD(ds(d), 84);
        e = _Bd(c);
        if (!b) b = Zwd(e);
        else if (b != Zwd(e)) return true;
    }
    return false;
}
function OGd(a, b) {
    var c, d, e, f;
    if (a.Mj()) {
        c = a.i;
        f = a.Nj();
        iDd(a, b);
        d = a.Fj(3, null, b, c, f);
        if (a.Jj()) {
            e = a.Kj(b, null);
            a.Qj() && (e = a.Rj(b, e));
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        } else a.Gj(d);
    } else {
        iDd(a, b);
        if (a.Jj()) {
            e = a.Kj(b, null);
            !!e && e.lj();
        }
    }
}
function hMb(a, b) {
    var c, d, e, f;
    f = fzb(a.a, b.b);
    if (!f) throw scb(new Web('Invalid hitboxes for scanline overlap calculation.'));
    e = false;
    for(d = a.a.a.ec().Jc(); d.Ob();){
        c = JD(d.Pb(), 68);
        if (cMb(b.b, c)) {
            r5c(a.b.a, b.b, c);
            e = true;
        } else {
            if (e) break;
        }
    }
}
function Lbd(a) {
    var b;
    if (!a.a) throw scb(new Web('IDataType class expected for layout option ' + a.f));
    b = dEd(a.a);
    if (b == null) throw scb(new Web("Couldn't create new instance of property '" + a.f + "'. " + ABe + (ceb(V4), V4.k) + BBe));
    return JD(b, 411);
}
function cqd(a) {
    var b, c, d, e, f;
    f = a.Lh();
    if (f) {
        if (f.Rh()) {
            e = zqd(a, f);
            if (e != f) {
                c = a.Bh();
                d = (b = a.Bh(), b >= 0 ? a.wh(null) : a.Lh().Ph(a, -1 - b, null, null));
                a.xh(JD(e, 52), c);
                !!d && d.lj();
                a.rh() && a.sh() && c > -1 && Wpd(a, new g_d(a, 9, c, f, e));
                return e;
            }
        }
    }
    return f;
}
function hsb(a, b) {
    var c, d, e, f, g;
    f = a.b.Ae(b);
    d = (c = a.a.get(f), c == null ? SC(aJ, Nqe, 1, 0, 5, 1) : c);
    for(g = 0; g < d.length; g++){
        e = d[g];
        if (a.b.ze(b, e.jd())) {
            if (d.length == 1) {
                d.length = 0;
                qsb(a.a, f);
            } else d.splice(g, 1);
            --a.c;
            ++a.b.g;
            return e.kd();
        }
    }
    return null;
}
function zPb(a) {
    var b, c, d, e, f, g, h, i;
    g = 0;
    f = a.f.e;
    for(d = 0; d < f.c.length; ++d){
        h = (sDb(d, f.c.length), JD(f.c[d], 151));
        for(e = d + 1; e < f.c.length; ++e){
            i = (sDb(e, f.c.length), JD(f.c[e], 151));
            c = pdd(h.d, i.d);
            b = c - a.a[h.a][i.a];
            g += a.i[h.a][i.a] * b * b;
        }
    }
    return g;
}
function B7b(a, b) {
    var c;
    if (XMb(b, (Bwc(), Uuc))) return;
    c = J7b(JD(WMb(b, u7b), 364), JD(WMb(a, Uuc), 171));
    ZMb(b, u7b, c);
    if (cs(new es(Ir(eYb(b).a.Jc(), new er)))) return;
    switch(c.g){
        case 1:
            ZMb(b, Uuc, (Oqc(), Jqc));
            break;
        case 2:
            ZMb(b, Uuc, (Oqc(), Lqc));
    }
}
function zhc(a, b) {
    var c;
    phc(a);
    a.a = (c = new Pi, EBb(new RBb(null, new Gvb(b.d, 16)), new Yhc(c)), c);
    uhc(a, JD(WMb(b.b, (Bwc(), Cuc)), 345));
    whc(a);
    vhc(a);
    thc(a);
    xhc(a);
    yhc(a, b);
    EBb(DBb(new RBb(null, ej(cj(a.b).a)), new Ohc), new Qhc);
    b.a = false;
    a.a = null;
}
function EUc() {
    EUc = Zcb;
    uUc = new MBd(Mze, (xdb(), false));
    vUc = new MBd(Nze, 7);
    jfb(0);
    BUc = new MBd(Oze, jfb(0));
    yUc = new MBd(Pze, jfb(-1));
    DUc = (vVc(), uVc);
    CUc = new MBd(Qze, DUc);
    xUc = (OTc(), LTc);
    wUc = new MBd(Rze, xUc);
    AUc = (DVc(), CVc);
    zUc = new MBd(Sze, AUc);
}
function Dwd() {
    hwd.call(this, _Ce, (Hpd(), Gpd));
    this.p = null;
    this.a = null;
    this.f = null;
    this.n = null;
    this.g = null;
    this.c = null;
    this.i = null;
    this.j = null;
    this.d = null;
    this.b = null;
    this.e = null;
    this.k = null;
    this.o = null;
    this.s = null;
    this.q = false;
    this.r = false;
}
function BBd() {
    BBd = Zcb;
    ABd = new CBd(swe, 0);
    xBd = new CBd('INSIDE_SELF_LOOPS', 1);
    yBd = new CBd('MULTI_EDGES', 2);
    wBd = new CBd('EDGE_LABELS', 3);
    zBd = new CBd('PORTS', 4);
    uBd = new CBd('COMPOUND', 5);
    tBd = new CBd('CLUSTERS', 6);
    vBd = new CBd('DISCONNECTED', 7);
}
function oFd(a, b, c) {
    var d, e, f;
    if (a.Mj()) {
        f = a.Nj();
        ++a.j;
        a.nj(b, a.Wi(b, c));
        d = a.Fj(3, null, c, b, f);
        if (a.Jj()) {
            e = a.Kj(c, null);
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        } else a.Gj(d);
    } else {
        ++a.j;
        a.nj(b, a.Wi(b, c));
        if (a.Jj()) {
            e = a.Kj(c, null);
            !!e && e.lj();
        }
    }
}
function Shb(a, b) {
    var c, d, e;
    if (b == 0) return (a.a[0] & 1) != 0;
    if (b < 0) throw scb(new kdb('Negative bit address'));
    e = b >> 5;
    if (e >= a.d) return a.e < 0;
    c = a.a[e];
    b = 1 << (b & 31);
    if (a.e < 0) {
        d = Lhb(a);
        if (e < d) return false;
        else d == e ? c = -c : c = ~c;
    }
    return (c & b) != 0;
}
function o0b(a) {
    var b, c, d, e, f;
    e = new Ulb;
    f = p0b(a, e);
    b = JD(WMb(a, (Iqc(), sqc)), 9);
    if (b) for(d = new rmb(b.j); d.a < d.c.c.length;){
        c = JD(pmb(d), 11);
        XD(WMb(c, kqc)) === XD(a) && (f = $wnd.Math.max(f, p0b(c, e)));
    }
    e.c.length == 0 || ZMb(a, iqc, f);
    return f != -1 ? e : null;
}
function m8c(a, b, c, d) {
    var e;
    JD(c.b, 68);
    JD(c.b, 68);
    JD(d.b, 68);
    JD(d.b, 68);
    e = Bdd(odd(JD(c.b, 68).c), JD(d.b, 68).c);
    xdd(e, ZLb(JD(c.b, 68), JD(d.b, 68), e));
    JD(d.b, 68);
    JD(d.b, 68);
    JD(d.b, 68).c.a, e.a;
    JD(d.b, 68).c.b, e.b;
    JD(d.b, 68);
    Llb(d.a, new r8c(a, b, d));
}
function oWd(a, b) {
    var c, d, e, f, g, h, i;
    f = b.e;
    if (f) {
        c = cqd(f);
        d = JD(a.g, 674);
        for(g = 0; g < a.i; ++g){
            i = d[g];
            if (CZd(i) == c) {
                e = (!i.d && (i.d = new qVd(g6, i, 1)), i.d);
                h = JD(c.Ih(Pqd(f, f.Cb, f.Db >> 16)), 15).bd(f);
                if (h < e.i) return oWd(a, JD(nDd(e, h), 87));
            }
        }
    }
    return b;
}
function Ycb(a, b, c) {
    var d = Xcb, h;
    var e = d[a];
    var f = e instanceof Array ? e[0] : null;
    if (e && !f) _ = e;
    else {
        _ = (h = b && b.prototype, !h && (h = Xcb[b]), _cb(h));
        _.Pm = c;
        !b && (_.Qm = bdb);
        d[a] = _;
    }
    for(var g = 3; g < arguments.length; ++g)arguments[g].prototype = _;
    f && (_.Om = f);
}
function cs(a) {
    var b;
    while(!JD(Qb(a.a), 49).Ob()){
        a.d = bs(a);
        if (!a.d) return false;
        a.a = JD(a.d.Pb(), 49);
        if (RD(a.a, 37)) {
            b = JD(a.a, 37);
            a.a = b.a;
            !a.b && (a.b = new nlb);
            $kb(a.b, a.d);
            if (b.b) while(!elb(b.b))$kb(a.b, JD(klb(b.b), 49));
            a.d = b.d;
        }
    }
    return true;
}
function IGb(a, b) {
    var c, d, e, f;
    e = 1;
    b.j = true;
    f = null;
    for(d = new rmb(OFb(b)); d.a < d.c.c.length;){
        c = JD(pmb(d), 216);
        if (!a.c[c.c]) {
            a.c[c.c] = true;
            f = AFb(c, b);
            if (c.f) e += IGb(a, f);
            else if (!f.j && c.a == c.e.e - c.d.e) {
                c.f = true;
                Nrb(a.p, c);
                e += IGb(a, f);
            }
        }
    }
    return e;
}
function YRb(a) {
    var b, c, d;
    for(c = new rmb(a.a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        d = (tDb(0), 0);
        if (d > 0) {
            !(Ugd(a.a.c) && b.n.d) && !(Vgd(a.a.c) && b.n.b) && (b.g.d += $wnd.Math.max(0, d / 2 - 0.5));
            !(Ugd(a.a.c) && b.n.a) && !(Vgd(a.a.c) && b.n.c) && (b.g.a -= d - 1);
        }
    }
}
function E5b(a, b, c) {
    var d, e, f, g, h, i;
    f = JD(Mlb(b.e, 0), 18).c;
    d = f.i;
    e = d.k;
    i = JD(Mlb(c.g, 0), 18).d;
    g = i.i;
    h = g.k;
    e == (DYb(), yYb) ? ZMb(a, (Iqc(), fqc), JD(WMb(d, fqc), 11)) : ZMb(a, (Iqc(), fqc), f);
    h == yYb ? ZMb(a, (Iqc(), gqc), JD(WMb(g, gqc), 11)) : ZMb(a, (Iqc(), gqc), i);
}
function f7b(a, b) {
    var c, d, e, f, g, h;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            g.k == (DYb(), xYb) && b7b(g, b);
            for(d = new es(Ir(kYb(g).a.Jc(), new er)); cs(d);){
                c = JD(ds(d), 18);
                a7b(c, b);
            }
        }
    }
}
function A7b(a, b) {
    var c, d, e;
    b.Sg('Layer constraint preprocessing', 1);
    c = new Ulb;
    e = new Ajb(a.a, 0);
    while(e.b < e.d.gc()){
        d = (rDb(e.b < e.d.gc()), JD(e.d.Xb(e.c = e.b++), 9));
        if (z7b(d)) {
            x7b(d);
            YCb(c.c, d);
            tjb(e);
        }
    }
    c.c.length == 0 || ZMb(a, (Iqc(), Xpc), c);
    b.Tg();
}
function imc(a) {
    var b, c, d;
    this.c = a;
    d = JD(WMb(a, (Bwc(), ruc)), 86);
    b = Beb(MD(WMb(a, Ttc)));
    c = Beb(MD(WMb(a, rwc)));
    d == (Tgd(), Pgd) || d == Qgd || d == Rgd ? this.b = b * c : this.b = 1 / (b * c);
    this.j = Beb(MD(WMb(a, fwc)));
    this.e = Beb(MD(WMb(a, ewc)));
    this.f = a.b.c.length;
}
function bCc(a) {
    var b, c;
    a.e = SC(cE, ise, 30, a.p.c.length, 15, 1);
    a.k = SC(cE, ise, 30, a.p.c.length, 15, 1);
    for(c = new rmb(a.p); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        a.e[b.p] = Gr(new es(Ir(hYb(b).a.Jc(), new er)));
        a.k[b.p] = Gr(new es(Ir(kYb(b).a.Jc(), new er)));
    }
}
function eCc(a) {
    var b, c, d, e, f, g;
    e = 0;
    a.q = new Ulb;
    b = new Qrb;
    for(g = new rmb(a.p); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        f.p = e;
        for(d = new es(Ir(kYb(f).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            Nrb(b, c.d.i);
        }
        b.a.Ac(f);
        Ilb(a.q, new Srb(b));
        b.a.$b();
        ++e;
    }
}
function tD(a, b) {
    var c, d, e, f, g;
    b &= 63;
    c = a.h;
    d = (c & Bse) != 0;
    d && (c |= -1048576);
    if (b < 22) {
        g = c >> b;
        f = a.m >> b | c << 22 - b;
        e = a.l >> b | a.m << 22 - b;
    } else if (b < 44) {
        g = d ? Ase : 0;
        f = c >> b - 22;
        e = a.m >> b - 22 | c << 44 - b;
    } else {
        g = d ? Ase : 0;
        f = d ? zse : 0;
        e = c >> b - 44;
    }
    return _C(e & zse, f & zse, g & Ase);
}
function NKd(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (a.a.f > 0 && RD(b, 43)) {
        a.a.Yj();
        j = JD(b, 43);
        i = j.jd();
        f = i == null ? 0 : tb(i);
        g = AJd(a.a, f);
        c = a.a.d[g];
        if (c) {
            d = JD(c.g, 371);
            k = c.i;
            for(h = 0; h < k; ++h){
                e = d[h];
                if (e.xi() == f && e.Fb(j)) {
                    NKd(a, j);
                    return true;
                }
            }
        }
    }
    return false;
}
function gfe(a) {
    var b, c, d, e, f, g, h;
    b = a.mi(BFe);
    if (b) {
        h = OD(xJd((!b.b && (b.b = new lRd((cPd(), $Od), u7, b)), b.b), 'settingDelegates'));
        if (h != null) {
            c = new Ulb;
            for(e = mgb(h, '\\w+'), f = 0, g = e.length; f < g; ++f){
                d = e[f];
                YCb(c.c, d);
            }
            return c;
        }
    }
    return pnb(), pnb(), mnb;
}
function vhc(a) {
    var b, c, d, e;
    for(e = JD(Qc(a.a, ($gc(), Xgc)), 15).Jc(); e.Ob();){
        d = JD(e.Pb(), 105);
        c = (b = Ec(d.k), b.Gc((Rjd(), xjd)) ? b.Gc(wjd) ? b.Gc(Ojd) ? b.Gc(Qjd) ? null : ghc : ihc : hhc : fhc);
        nhc(a, d, c[0], (Ihc(), Fhc), 0);
        nhc(a, d, c[1], Ghc, 1);
        nhc(a, d, c[2], Hhc, 1);
    }
}
function hkc(a, b) {
    var c, d;
    c = ikc(b);
    lkc(a, b, c);
    XNc(a.a, JD(WMb(gYb(b.b), (Iqc(), vqc)), 233));
    gkc(a);
    fkc(a, b);
    d = SC(cE, ise, 30, b.b.j.c.length, 15, 1);
    okc(a, b, (Rjd(), xjd), d, c);
    okc(a, b, wjd, d, c);
    okc(a, b, Ojd, d, c);
    okc(a, b, Qjd, d, c);
    a.a = null;
    a.c = null;
    a.b = null;
}
function Atd(a, b, c) {
    switch(b){
        case 7:
            !a.e && (a.e = new ree(x3, a, 7, 4));
            RGd(a.e);
            !a.e && (a.e = new ree(x3, a, 7, 4));
            vCd(a.e, JD(c, 16));
            return;
        case 8:
            !a.d && (a.d = new ree(x3, a, 8, 5));
            RGd(a.d);
            !a.d && (a.d = new ree(x3, a, 8, 5));
            vCd(a.d, JD(c, 16));
            return;
    }
    btd(a, b, c);
}
function Nt(a, b) {
    var c, d, e, f, g;
    if (XD(b) === XD(a)) return true;
    if (!RD(b, 15)) return false;
    g = JD(b, 15);
    if (a.gc() != g.gc()) return false;
    f = g.Jc();
    for(d = a.Jc(); d.Ob();){
        c = d.Pb();
        e = f.Pb();
        if (!(XD(c) === XD(e) || c != null && pb(c, e))) return false;
    }
    return true;
}
function v3b(a, b) {
    var c, d, e, f;
    f = JD(yBb(DBb(DBb(new RBb(null, new Gvb(b.b, 16)), new B3b), new D3b), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    f.Ic(new F3b);
    c = 0;
    for(e = f.Jc(); e.Ob();){
        d = JD(e.Pb(), 11);
        d.p == -1 && u3b(a, d, c++);
    }
}
function fac(a, b) {
    var c, d, e, f, g;
    b.Sg('Port side processing', 1);
    for(g = new rmb(a.a); g.a < g.c.c.length;){
        e = JD(pmb(g), 9);
        gac(e);
    }
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        for(f = new rmb(c.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            gac(e);
        }
    }
    b.Tg();
}
function Nxc(a) {
    switch(a.g){
        case 0:
            return new lKc;
        case 1:
            return new GHc;
        case 2:
            return new WHc;
        case 3:
            return new dLc;
        case 4:
            return new BIc;
        default:
            throw scb(new Teb('No implementation is available for the node placer ' + (a.f != null ? a.f : '' + a.g)));
    }
}
function Anc(a) {
    switch(a.g){
        case 0:
            return new Xzc;
        case 1:
            return new Qzc;
        case 2:
            return new fAc;
        case 3:
            return new mAc;
        case 4:
            return new _zc;
        default:
            throw scb(new Teb('No implementation is available for the cycle breaker ' + (a.f != null ? a.f : '' + a.g)));
    }
}
function fLc(a, b) {
    var c, d, e, f, g, h;
    d = new Xsb;
    g = Tx(new dnb(a.g));
    for(f = g.a.ec().Jc(); f.Ob();){
        e = JD(f.Pb(), 9);
        if (!e) {
            b._g('There are no classes in a balanced layout.');
            break;
        }
        h = a.j[e.p];
        c = JD(Tsb(d, h), 15);
        if (!c) {
            c = new Ulb;
            Usb(d, h, c);
        }
        c.Ec(e);
    }
    return d;
}
function LVc(a, b) {
    var c, d, e, f, g;
    d = new Mtb;
    Dtb(d, b, d.c.b, d.c);
    do {
        c = (rDb(d.b != 0), JD(Ktb(d, d.a.a), 39));
        a.b[c.g] = 1;
        for(f = Gtb(c.d, 0); f.b != f.d.c;){
            e = JD(Utb(f), 65);
            g = e.c;
            a.b[g.g] == 1 ? Atb(a.a, e) : a.b[g.g] == 2 ? a.b[g.g] = 1 : Dtb(d, g, d.c.b, d.c);
        }
    }while (d.b != 0);
}
function yyd(a, b) {
    if (RD(b, 206)) return Zwd(JD(b, 27));
    else if (RD(b, 193)) return oxd(JD(b, 124));
    else if (RD(b, 359)) return Hwd(JD(b, 153));
    else if (RD(b, 268)) return myd(a, JD(b, 85));
    else throw scb(new Teb(xDe + Ee(new dnb(WC(OC(aJ, 1), Nqe, 1, 5, [
        b
    ])))));
}
function iUb(a, b, c) {
    var d;
    d = null;
    !!b && (d = b.d);
    uUb(a, new oSb(b.n.a - d.b + c.a, b.n.b - d.d + c.b));
    uUb(a, new oSb(b.n.a - d.b + c.a, b.n.b + b.o.b + d.a + c.b));
    uUb(a, new oSb(b.n.a + b.o.a + d.c + c.a, b.n.b - d.d + c.b));
    uUb(a, new oSb(b.n.a + b.o.a + d.c + c.a, b.n.b + b.o.b + d.a + c.b));
}
function u3b(a, b, c) {
    var d, e, f;
    b.p = c;
    for(f = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        new dZb(b),
        new lZb(b)
    ]))); cs(f);){
        d = JD(ds(f), 11);
        d.p == -1 && u3b(a, d, c);
    }
    if (b.i.k == (DYb(), yYb)) for(e = new rmb(b.i.j); e.a < e.c.c.length;){
        d = JD(pmb(e), 11);
        d != b && d.p == -1 && u3b(a, d, c);
    }
}
function UNc(a) {
    var b, c, d, e, f;
    e = JD(yBb(ABb(NBb(a)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    d = mze;
    if (e.gc() >= 2) {
        c = e.Jc();
        b = MD(c.Pb());
        while(c.Ob()){
            f = b;
            b = MD(c.Pb());
            d = $wnd.Math.min(d, (tDb(b), b) - (tDb(f), f));
        }
    }
    return d;
}
function lQc(a, b) {
    var c, d, e;
    e = new Ulb;
    for(d = Gtb(b.a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 65);
        c.b.g == a.g && !cgb(c.b.c, Dze) && XD(WMb(c.b, (kVc(), iVc))) !== XD(WMb(c.c, iVc)) && !xBb(new RBb(null, new Gvb(e, 16)), new RQc(c)) && YCb(e.c, c);
    }
    Slb(e, new TQc);
    return e;
}
function Wu(a, b) {
    var c, d, e;
    if (XD(b) === XD(Qb(a))) return true;
    if (!RD(b, 15)) return false;
    d = JD(b, 15);
    e = a.gc();
    if (e != d.gc()) return false;
    if (RD(d, 59)) {
        for(c = 0; c < e; c++){
            if (!Hb(a.Xb(c), d.Xb(c))) return false;
        }
        return true;
    } else return yr(a.Jc(), d.Jc());
}
function d6b(a, b, c, d, e, f) {
    var g, h, i, j;
    h = !PBb(BBb(a.Mc(), new Dzb(new h6b))).zd((wBb(), vBb));
    g = a;
    f == (Tgd(), Sgd) && (g = dv(g));
    for(j = g.Jc(); j.Ob();){
        i = JD(j.Pb(), 72);
        i.n.a = b.a;
        h ? i.n.b = b.b + (d.b - i.o.b) / 2 : e ? i.n.b = b.b : i.n.b = b.b + d.b - i.o.b;
        b.a += i.o.a + c;
    }
}
function Ryd(a, b, c) {
    var d, e, f, g, h, i, j;
    if (c) {
        f = c.a.length;
        d = new Rpe(f);
        for(h = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); h.Ob();){
            g = JD(h.Pb(), 17);
            i = _xd(c, g.a);
            if (i) {
                j = eCd(byd(i, iDe), b);
                Qib(a.k, j, i);
                e = vDe in i.a;
                e && Psd(j, byd(i, vDe));
                yzd(i, j);
                zzd(i, j);
            }
        }
    }
}
function WPb(a, b, c) {
    var d, e, f, g, h;
    h = c;
    !h && (h = vld(new wld, 0));
    h.Sg(rve, 1);
    mQb(a.c, b);
    g = RUb(a.a, b);
    if (g.gc() == 1) YPb(JD(g.Xb(0), 36), h);
    else {
        f = 1 / g.gc();
        for(e = g.Jc(); e.Ob();){
            d = JD(e.Pb(), 36);
            if (c.Yg()) return;
            YPb(d, h.bh(f));
        }
    }
    PUb(a.a, g, b);
    ZPb(b);
    h.Tg();
}
function Wbc(a, b, c) {
    var d, e, f, g, h;
    e = a.f;
    !e && (e = JD(a.a.a.ec().Jc().Pb(), 60));
    Xbc(e, b, c);
    if (a.a.a.gc() == 1) return;
    d = b * c;
    for(g = a.a.a.ec().Jc(); g.Ob();){
        f = JD(g.Pb(), 60);
        if (f != e) {
            h = ndc(f);
            if (h.f.d) {
                f.d.d += d + fue;
                f.d.a -= d + fue;
            } else h.f.a && (f.d.a -= d + fue);
        }
    }
}
function pKc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    e = c;
    k = b;
    f = k;
    do {
        f = a.a[f.p];
        h = (l = a.g[f.p], Beb(a.p[l.p]) + Beb(a.d[f.p]) - f.d.d);
        i = sKc(f, d);
        if (i) {
            g = (j = a.g[i.p], Beb(a.p[j.p]) + Beb(a.d[i.p]) + i.o.b + i.d.a);
            e = $wnd.Math.min(e, h - (g + ezc(a.k, f, i)));
        }
    }while (k != f);
    return e;
}
function qKc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    e = c;
    k = b;
    f = k;
    do {
        f = a.a[f.p];
        g = (l = a.g[f.p], Beb(a.p[l.p]) + Beb(a.d[f.p]) + f.o.b + f.d.a);
        i = rKc(f, d);
        if (i) {
            h = (j = a.g[i.p], Beb(a.p[j.p]) + Beb(a.d[i.p]) - i.d.d);
            e = $wnd.Math.min(e, h - (g + ezc(a.k, f, i)));
        }
    }while (k != f);
    return e;
}
function G3c(a, b) {
    var c;
    b.Sg('Equal Whitespace Eliminator', 1);
    if (lsd(a, (h1c(), f1c))) L3c(JD(ksd(a, f1c), 15), Beb(MD(ksd(a, $0c))), (c = Beb(MD(ksd(a, Y0c))), Beb(MD(ksd(a, (k2c(), d2c)))), c));
    else throw scb(new Y8c('The graph does not contain rows.'));
    b.Tg();
}
function ksd(a, b) {
    var c, d;
    d = (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), xJd(a.o, b));
    if (d != null) return d;
    c = b.Qg();
    RD(c, 4) && (c == null ? (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), IJd(a.o, b)) : (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), EJd(a.o, b, c)), a);
    return c;
}
function Eid() {
    Eid = Zcb;
    wid = new Fid('H_LEFT', 0);
    vid = new Fid('H_CENTER', 1);
    yid = new Fid('H_RIGHT', 2);
    Did = new Fid('V_TOP', 3);
    Cid = new Fid('V_CENTER', 4);
    Bid = new Fid('V_BOTTOM', 5);
    zid = new Fid('INSIDE', 6);
    Aid = new Fid('OUTSIDE', 7);
    xid = new Fid('H_PRIORITY', 8);
}
function uGb(a, b) {
    var c, d, e, f, g, h, i;
    if (!b.f) throw scb(new Teb('The input edge is not a tree edge.'));
    f = null;
    e = Hqe;
    for(d = new rmb(a.d); d.a < d.c.c.length;){
        c = JD(pmb(d), 216);
        h = c.d;
        i = c.e;
        if (zGb(a, h, b) && !zGb(a, i, b)) {
            g = i.e - h.e - c.a;
            if (g < e) {
                e = g;
                f = c;
            }
        }
    }
    return f;
}
function CPb(a) {
    var b, c, d, e, f, g;
    if (a.f.e.c.length <= 1) return;
    b = 0;
    e = zPb(a);
    c = Kse;
    do {
        b > 0 && (e = c);
        for(g = new rmb(a.f.e); g.a < g.c.c.length;){
            f = JD(pmb(g), 151);
            if (ydb(LD(WMb(f, (nPb(), ePb))))) continue;
            d = yPb(a, f);
            mdd(vdd(f.d), d);
        }
        c = zPb(a);
    }while (!BPb(a, b++, e, c));
}
function vgc(a, b) {
    var c, d, e, f, g;
    f = a.g.a;
    g = a.g.b;
    for(d = new rmb(a.d); d.a < d.c.c.length;){
        c = JD(pmb(d), 72);
        e = c.n;
        a.a == (Dgc(), Agc) || a.i == (Rjd(), wjd) ? e.a = f : a.a == Bgc || a.i == (Rjd(), Qjd) ? e.a = f + a.j.a - c.o.a : e.a = f + (a.j.a - c.o.a) / 2;
        e.b = g;
        mdd(e, b);
        g += c.o.b + a.e;
    }
}
function tzd(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    j = a;
    i = ayd(j, 'individualSpacings');
    if (i) {
        d = lsd(b, (Lgd(), rgd));
        g = !d;
        if (g) {
            e = new Nnd;
            msd(b, rgd, e);
        }
        h = JD(ksd(b, rgd), 377);
        l = i;
        f = null;
        !!l && (f = (k = gC(l, SC(hJ, hre, 2, 0, 6, 1)), new uC(l, k)));
        if (f) {
            c = new pAd(l, h);
            ofb(f, c);
        }
    }
}
function xzd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    i = null;
    l = a;
    k = null;
    if (EDe in l.a || FDe in l.a || oDe in l.a) {
        j = null;
        m = dCd(b);
        g = ayd(l, EDe);
        c = new tAd(m);
        Syd(c.a, g);
        h = ayd(l, FDe);
        d = new XAd(m);
        bzd(d.a, h);
        f = $xd(l, oDe);
        e = new bBd(m);
        j = (czd(e.a, f), f);
        k = j;
    }
    i = k;
    return i;
}
function kx(a, b) {
    var c, d, e;
    if (b === a) return true;
    if (RD(b, 537)) {
        e = JD(b, 828);
        if (a.a.d != e.a.d || Gh(a).gc() != Gh(e).gc()) return false;
        for(d = Gh(e).Jc(); d.Ob();){
            c = JD(d.Pb(), 413);
            if (Mw(a, c.a.jd()) != JD(c.a.kd(), 16).gc()) return false;
        }
        return true;
    }
    return false;
}
function qHc(a, b) {
    if (a.c < b.c) return -1;
    else if (a.c > b.c) return 1;
    else if (a.b < b.b) return -1;
    else if (a.b > b.b) return 1;
    else if (a.a != b.a) return tb(a.a) - tb(b.a);
    else if (a.d == (vHc(), uHc) && b.d == tHc) return -1;
    else if (a.d == tHc && b.d == uHc) return 1;
    return 0;
}
function tKc(a) {
    var b, c, d, e, f, g, h, i;
    e = Kse;
    d = Lse;
    for(c = new rmb(a.e.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        for(g = new rmb(b.a); g.a < g.c.c.length;){
            f = JD(pmb(g), 9);
            i = Beb(a.p[f.p]);
            h = i + Beb(a.b[a.g[f.p].p]);
            e = $wnd.Math.min(e, i);
            d = $wnd.Math.max(d, h);
        }
    }
    return d - e;
}
function DLc(a, b) {
    var c, d, e, f, g;
    f = b.a;
    f.c.i == b.b ? g = f.d : g = f.c;
    f.c.i == b.b ? d = f.c : d = f.d;
    e = oKc(a.a, g, d);
    if (e > 0 && e < mze) {
        c = pKc(a.a, d.i, e, a.c);
        uKc(a.a, d.i, -c);
        return c > 0;
    } else if (e < 0 && -e < mze) {
        c = qKc(a.a, d.i, -e, a.c);
        uKc(a.a, d.i, c);
        return c > 0;
    }
    return false;
}
function l4c(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    e = (b - a.d) / a.c.c.length;
    f = 0;
    a.a += c;
    a.d = b;
    for(l = new rmb(a.c); l.a < l.c.c.length;){
        k = JD(pmb(l), 27);
        j = k.g;
        i = k.f;
        htd(k, k.i + f * e);
        itd(k, k.j + d * c);
        gtd(k, k.g + e);
        etd(k, a.a);
        ++f;
        h = k.g;
        g = k.f;
        rnd(k, new Edd(h, g), new Edd(j, i));
    }
}
function Zud(a) {
    var b, c, d, e, f, g, h;
    if (a == null) return null;
    h = a.length;
    e = (h + 1) / 2 | 0;
    g = SC($D, ZCe, 30, e, 15, 1);
    h % 2 != 0 && (g[--e] = lvd((ADb(h - 1, a.length), a.charCodeAt(h - 1))));
    for(c = 0, d = 0; c < e; ++c){
        b = lvd(_fb(a, d++));
        f = lvd(_fb(a, d++));
        g[c] = (b << 4 | f) << 24 >> 24;
    }
    return g;
}
function seb(a) {
    if (a.xe()) {
        var b = a.c;
        b.ye() ? a.o = '[' + b.n : !b.xe() ? a.o = '[L' + b.ve() + ';' : a.o = '[' + b.ve();
        a.b = b.ue() + '[]';
        a.k = b.we() + '[]';
        return;
    }
    var c = a.j;
    var d = a.d;
    d = d.split('/');
    a.o = veb('.', [
        c,
        veb('$', d)
    ]);
    a.b = veb('.', [
        c,
        veb('.', d)
    ]);
    a.k = d[d.length - 1];
}
function sGb(a, b) {
    var c, d, e, f, g;
    g = null;
    for(f = new rmb(a.e.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 123);
        if (e.b.a.c.length == e.g.a.c.length) {
            d = e.e;
            g = DGb(e);
            for(c = e.e - JD(g.a, 17).a + 1; c < e.e + JD(g.b, 17).a; c++)b[c] < b[d] && (d = c);
            if (b[d] < b[e.e]) {
                --b[e.e];
                ++b[d];
                e.e = d;
            }
        }
    }
}
function ozd(a, b, c) {
    var d, e, f, g, h, i, j, k;
    j = JD(c, 147);
    k = yyd(a, b);
    f = null;
    d = null;
    !!k && (d = syd(a, k, b.i));
    if (d != null) f = d;
    else {
        h = b.i;
        f = h;
    }
    Uxd(j, 'x', f);
    g = null;
    e = null;
    !!k && (e = tyd(a, k, b.j));
    if (e != null) g = e;
    else {
        i = b.j;
        g = i;
    }
    Uxd(j, 'y', g);
    Uxd(j, gDe, b.g);
    Uxd(j, fDe, b.f);
}
function INd(a) {
    BNd();
    var b, c, d, e;
    d = hgb(a, wgb(35));
    b = d == -1 ? a : (zDb(0, d, a.length), a.substr(0, d));
    c = d == -1 ? null : (ADb(d + 1, a.length + 1), a.substr(d + 1));
    e = dOd(ANd, b);
    if (!e) {
        e = VNd(b);
        eOd(ANd, b, e);
        c != null && (e = CNd(e, c));
    } else c != null && (e = CNd(e, (tDb(c), c)));
    return e;
}
function kae(a, b, c, d) {
    var e, f, g, h, i, j;
    i = null;
    e = $9d(a, b);
    for(h = 0, j = e.gc(); h < j; ++h){
        f = JD(e.Xb(h), 178);
        if (cgb(d, Vae(jae(a, f)))) {
            g = Wae(jae(a, f));
            if (c == null) {
                if (g == null) return f;
                else !i && (i = f);
            } else if (cgb(c, g)) return f;
            else g == null && !i && (i = f);
        }
    }
    return null;
}
function lae(a, b, c, d) {
    var e, f, g, h, i, j;
    i = null;
    e = _9d(a, b);
    for(h = 0, j = e.gc(); h < j; ++h){
        f = JD(e.Xb(h), 178);
        if (cgb(d, Vae(jae(a, f)))) {
            g = Wae(jae(a, f));
            if (c == null) {
                if (g == null) return f;
                else !i && (i = f);
            } else if (cgb(c, g)) return f;
            else g == null && !i && (i = f);
        }
    }
    return null;
}
function ice(a, b, c) {
    var d, e, f, g, h, i;
    g = new vDd;
    h = Kfe(a.e.zh(), b);
    d = JD(a.g, 122);
    Ife();
    if (JD(b, 69).uk()) for(f = 0; f < a.i; ++f){
        e = d[f];
        h.Zl(e.Ik()) && tCd(g, e);
    }
    else for(f = 0; f < a.i; ++f){
        e = d[f];
        if (h.Zl(e.Ik())) {
            i = e.kd();
            tCd(g, c ? Wbe(a, b, f, g.i, i) : i);
        }
    }
    return tDd(g);
}
function dfe(a) {
    var b, c, d, e, f, g, h;
    if (a) {
        b = a.mi(BFe);
        if (b) {
            g = OD(xJd((!b.b && (b.b = new lRd((cPd(), $Od), u7, b)), b.b), 'conversionDelegates'));
            if (g != null) {
                h = new Ulb;
                for(d = mgb(g, '\\w+'), e = 0, f = d.length; e < f; ++e){
                    c = d[e];
                    YCb(h.c, c);
                }
                return h;
            }
        }
    }
    return pnb(), pnb(), mnb;
}
function eRb(a, b) {
    var c, d, e, f, g, h, i, j;
    g = b == 1 ? WQb : VQb;
    for(f = g.a.ec().Jc(); f.Ob();){
        e = JD(f.Pb(), 86);
        for(i = JD(Qc(a.f.c, e), 22).Jc(); i.Ob();){
            h = JD(i.Pb(), 47);
            d = JD(h.b, 82);
            j = JD(h.a, 194);
            c = j.c;
            switch(e.g){
                case 2:
                case 1:
                    d.g.d += c;
                    break;
                case 4:
                case 3:
                    d.g.c += c;
            }
        }
    }
}
function v6b(a, b) {
    var c, d, e, f, g;
    c = new Oqb(MV);
    for(e = (Nmc(), WC(OC(MV, 1), Ere, 231, 0, [
        Jmc,
        Lmc,
        Imc,
        Kmc,
        Mmc,
        Hmc
    ])), f = 0, g = e.length; f < g; ++f){
        d = e[f];
        Mqb(c, d, new Ulb);
    }
    EBb(FBb(BBb(DBb(new RBb(null, new Gvb(a.b, 16)), new L6b), new N6b), new P6b(b)), new R6b(c));
    return c;
}
function Obc(a, b) {
    var c, d, e;
    for(c = 1; c < a.c.length; c++){
        e = (sDb(c, a.c.length), JD(a.c[c], 9));
        d = c;
        while(d > 0 && Bkc(b, (sDb(d - 1, a.c.length), JD(a.c[d - 1], 9)), e) > 0){
            Rlb(a, d, (sDb(d - 1, a.c.length), JD(a.c[d - 1], 9)));
            --d;
        }
        sDb(d, a.c.length);
        a.c[d] = e;
    }
    b.b = new Irb;
    b.f = new Irb;
}
function zFc(a, b, c) {
    var d, e, f;
    for(d = 1; d < a.c.length; d++){
        f = (sDb(d, a.c.length), JD(a.c[d], 9));
        e = d;
        while(e > 0 && b.Le((sDb(e - 1, a.c.length), JD(a.c[e - 1], 9)), f) > 0){
            Rlb(a, e, (sDb(e - 1, a.c.length), JD(a.c[e - 1], 9)));
            --e;
        }
        sDb(e, a.c.length);
        a.c[e] = f;
    }
    c.a = new Irb;
    c.b = new Irb;
}
function qZc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    for(f = b.Jc(); f.Ob();){
        e = JD(f.Pb(), 27);
        k = e.i + e.g / 2;
        m = e.j + e.f / 2;
        i = a.f;
        g = i.i + i.g / 2;
        h = i.j + i.f / 2;
        j = k - g;
        l = m - h;
        d = $wnd.Math.sqrt(j * j + l * l);
        j *= a.e / d;
        l *= a.e / d;
        if (c) {
            k -= j;
            m -= l;
        } else {
            k += j;
            m += l;
        }
        htd(e, k - e.g / 2);
        itd(e, m - e.f / 2);
    }
}
function Qoe(a) {
    var b, c, d;
    if (a.c) return;
    if (a.b == null) return;
    for(b = a.b.length - 4; b >= 0; b -= 2){
        for(c = 0; c <= b; c += 2)if (a.b[c] > a.b[c + 2] || a.b[c] === a.b[c + 2] && a.b[c + 1] > a.b[c + 3]) {
            d = a.b[c + 2];
            a.b[c + 2] = a.b[c];
            a.b[c] = d;
            d = a.b[c + 3];
            a.b[c + 3] = a.b[c + 1];
            a.b[c + 1] = d;
        }
    }
    a.c = true;
}
function qEc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = -1;
    k = 0;
    for(g = a, h = 0, i = g.length; h < i; ++h){
        f = g[h];
        c = new Hkc(j == -1 ? a[0] : a[j], b, (oxc(), nxc));
        for(d = 0; d < f.length; d++)for(e = d + 1; e < f.length; e++)XMb(f[d], (Iqc(), jqc)) && XMb(f[e], jqc) && Bkc(c, f[d], f[e]) > 0 && ++k;
        ++j;
    }
    return k;
}
function Gqd(a) {
    var b, c;
    c = new Wgb(eeb(a.Om));
    c.a += '@';
    Qgb(c, (b = tb(a) >>> 0, b.toString(16)));
    if (a.Rh()) {
        c.a += ' (eProxyURI: ';
        Pgb(c, a.Xh());
        if (a.Gh()) {
            c.a += ' eClass: ';
            Pgb(c, a.Gh());
        }
        c.a += ')';
    } else if (a.Gh()) {
        c.a += ' (eClass: ';
        Pgb(c, a.Gh());
        c.a += ')';
    }
    return c.a;
}
function JEb(a) {
    var b, c, d, e;
    if (a.e) throw scb(new Web((ceb(PM), Hte + PM.k + Ite)));
    a.d == (Tgd(), Rgd) && IEb(a, Pgd);
    for(c = new rmb(a.a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 317);
        b.g = b.i;
    }
    for(e = new rmb(a.a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 60);
        d.i = Lse;
    }
    a.b.af(a);
    return a;
}
function $6b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    i = av(a.c - a.b & a.a.length - 1);
    j = null;
    k = null;
    for(f = new Blb(a); f.a != f.b;){
        e = JD(zlb(f), 9);
        c = (h = JD(WMb(e, (Iqc(), fqc)), 11), !h ? null : h.i);
        d = (g = JD(WMb(e, gqc), 11), !g ? null : g.i);
        if (j != c || k != d) {
            c7b(i, b);
            j = c;
            k = d;
        }
        YCb(i.c, e);
    }
    c7b(i, b);
}
function uOc(a, b) {
    var c, d, e, f, g;
    if (b < 2 * a.b) throw scb(new Teb('The knot vector must have at least two time the dimension elements.'));
    a.f = 1;
    for(e = 0; e < a.b; e++)Ilb(a.e, 0);
    g = b + 1 - 2 * a.b;
    c = g;
    for(f = 1; f < g; f++)Ilb(a.e, f / c);
    if (a.d) for(d = 0; d < a.b; d++)Ilb(a.e, 1);
}
function szd(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = b;
    k = JD(hp(yo(a.o), j), 27);
    if (!k) {
        e = byd(j, vDe);
        h = "Unable to find elk node for json object '" + e;
        i = h + "' Panic!";
        throw scb(new eyd(i));
    }
    f = $xd(j, 'edges');
    c = new Dzd(a, k);
    Ayd(c.a, c.b, f);
    g = $xd(j, jDe);
    d = new Zzd(a);
    Lyd(d.a, g);
}
function uJd(a, b, c, d) {
    var e, f, g, h, i;
    if (d != null) {
        e = a.d[b];
        if (e) {
            f = e.g;
            i = e.i;
            for(h = 0; h < i; ++h){
                g = JD(f[h], 135);
                if (g.xi() == c && pb(d, g.jd())) return h;
            }
        }
    } else {
        e = a.d[b];
        if (e) {
            f = e.g;
            i = e.i;
            for(h = 0; h < i; ++h){
                g = JD(f[h], 135);
                if (XD(g.jd()) === XD(d)) return h;
            }
        }
    }
    return -1;
}
function g1d(a, b) {
    var c, d, e;
    c = b == null ? Wd(fsb(a.f, null)) : zsb(a.i, b);
    if (RD(c, 240)) {
        e = JD(c, 240);
        e.vi() == null && undefined;
        return e;
    } else if (RD(c, 491)) {
        d = JD(c, 1983);
        e = d.a;
        !!e && (e.yb == null ? undefined : b == null ? gsb(a.f, null, e) : Asb(a.i, b, e));
        return e;
    } else return null;
}
function ame(a) {
    _le();
    var b, c, d, e, f, g, h;
    if (a == null) return null;
    e = a.length;
    if (e % 2 != 0) return null;
    b = rgb(a);
    f = e / 2 | 0;
    c = SC($D, ZCe, 30, f, 15, 1);
    for(d = 0; d < f; d++){
        g = Zle[b[d * 2]];
        if (g == -1) return null;
        h = Zle[b[d * 2 + 1]];
        if (h == -1) return null;
        c[d] = (g << 4 | h) << 24 >> 24;
    }
    return c;
}
function nKb(a, b, c) {
    var d, e, f;
    e = JD(Kqb(a.i, b), 315);
    if (!e) {
        e = new dIb(a.d, b, c);
        Lqb(a.i, b, e);
        if (uJb(b)) EHb(a.a, b.c, b.b, e);
        else {
            f = tJb(b);
            d = JD(Kqb(a.p, f), 251);
            switch(f.g){
                case 1:
                case 3:
                    e.j = true;
                    nIb(d, b.b, e);
                    break;
                case 4:
                case 2:
                    e.k = true;
                    nIb(d, b.c, e);
            }
        }
    }
    return e;
}
function kce(a, b, c, d) {
    var e, f, g, h, i, j;
    h = new vDd;
    i = Kfe(a.e.zh(), b);
    e = JD(a.g, 122);
    Ife();
    if (JD(b, 69).uk()) for(g = 0; g < a.i; ++g){
        f = e[g];
        i.Zl(f.Ik()) && tCd(h, f);
    }
    else for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.Zl(f.Ik())) {
            j = f.kd();
            tCd(h, d ? Wbe(a, b, g, h.i, j) : j);
        }
    }
    return uDd(h, c);
}
function rBc(a, b) {
    var c, d, e, f, g, h, i, j;
    e = a.b[b.p];
    if (e >= 0) return e;
    else {
        f = 1;
        for(h = new rmb(b.j); h.a < h.c.c.length;){
            g = JD(pmb(h), 11);
            for(d = new rmb(g.g); d.a < d.c.c.length;){
                c = JD(pmb(d), 18);
                j = c.d.i;
                if (b != j) {
                    i = rBc(a, j);
                    f = $wnd.Math.max(f, i + 1);
                }
            }
        }
        qBc(a, b, f);
        return f;
    }
}
function zBc(a, b) {
    var c, d, e, f, g, h, i, j;
    e = a.b[b.p];
    if (e >= 0) return e;
    else {
        f = 1;
        for(h = new rmb(b.j); h.a < h.c.c.length;){
            g = JD(pmb(h), 11);
            for(d = new rmb(g.e); d.a < d.c.c.length;){
                c = JD(pmb(d), 18);
                j = c.c.i;
                if (b != j) {
                    i = zBc(a, j);
                    f = $wnd.Math.max(f, i + 1);
                }
            }
        }
        yBc(a, b, f);
        return f;
    }
}
function One(a) {
    var b, c, d, e;
    e = a.length;
    b = null;
    for(d = 0; d < e; d++){
        c = (ADb(d, a.length), a.charCodeAt(d));
        if (hgb('.*+?{[()|\\^$', wgb(c)) >= 0) {
            if (!b) {
                b = new Igb;
                d > 0 && Egb(b, (zDb(0, d, a.length), a.substr(0, d)));
            }
            b.a += '\\';
            Agb(b, c & Wre);
        } else !!b && Agb(b, c & Wre);
    }
    return b ? b.a : a;
}
function WRb(a) {
    var b, c, d;
    for(c = new rmb(a.a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        d = (tDb(0), 0);
        if (d > 0) {
            !(Ugd(a.a.c) && b.n.d) && !(Vgd(a.a.c) && b.n.b) && (b.g.d -= $wnd.Math.max(0, d / 2 - 0.5));
            !(Ugd(a.a.c) && b.n.a) && !(Vgd(a.a.c) && b.n.c) && (b.g.a += $wnd.Math.max(0, d - 1));
        }
    }
}
function j7b(a, b, c) {
    var d, e;
    if ((a.c - a.b & a.a.length - 1) == 2) {
        if (b == (Rjd(), xjd) || b == wjd) {
            _6b(JD(flb(a), 15), (oid(), kid));
            _6b(JD(flb(a), 15), lid);
        } else {
            _6b(JD(flb(a), 15), (oid(), lid));
            _6b(JD(flb(a), 15), kid);
        }
    } else for(e = new Blb(a); e.a != e.b;){
        d = JD(zlb(e), 15);
        _6b(d, c);
    }
}
function gCd(a, b) {
    var c, d, e, f, g, h, i;
    e = $u(new nCd(a));
    h = new Ajb(e, e.c.length);
    f = $u(new nCd(b));
    i = new Ajb(f, f.c.length);
    g = null;
    while(h.b > 0 && i.b > 0){
        c = (rDb(h.b > 0), JD(h.a.Xb(h.c = --h.b), 27));
        d = (rDb(i.b > 0), JD(i.a.Xb(i.c = --i.b), 27));
        if (c == d) g = c;
        else break;
    }
    return g;
}
function $ac(a, b) {
    var c, d, e, f;
    b.Sg('Self-Loop pre-processing', 1);
    for(d = new rmb(a.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        if (Ogc(c)) {
            e = (f = new Ngc(c), ZMb(c, (Iqc(), zqc), f), Kgc(f), f);
            EBb(FBb(DBb(new RBb(null, new Gvb(e.d, 16)), new bbc), new dbc), new fbc);
            Yac(e);
        }
    }
    b.Tg();
}
function agc(a, b, c) {
    var d, e, f, g;
    if (egc(a, b) > egc(a, c)) {
        d = lYb(c, (Rjd(), wjd));
        a.d = d.dc() ? 0 : XYb(JD(d.Xb(0), 11));
        g = lYb(b, Qjd);
        a.b = g.dc() ? 0 : XYb(JD(g.Xb(0), 11));
    } else {
        e = lYb(c, (Rjd(), Qjd));
        a.d = e.dc() ? 0 : XYb(JD(e.Xb(0), 11));
        f = lYb(b, wjd);
        a.b = f.dc() ? 0 : XYb(JD(f.Xb(0), 11));
    }
}
function hmc(a) {
    var b, c, d, e, f, g, h, i;
    b = true;
    e = null;
    f = null;
    j: for(i = new rmb(a.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 9);
        for(d = new es(Ir(hYb(h).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            if (!!e && e != h) {
                b = false;
                break j;
            }
            e = h;
            g = c.c.i;
            if (!!f && f != g) {
                b = false;
                break j;
            }
            f = g;
        }
    }
    return b;
}
function Nbd(a, b, c) {
    var d, e, f, g, h, i, j, k;
    k = (d = JD(b.e && b.e(), 10), new urb(d, JD(VCb(d, d.length), 10), 0));
    i = mgb(c, '[\\[\\]\\s,]+');
    for(f = i, g = 0, h = f.length; g < h; ++g){
        e = f[g];
        if (ugb(e).length == 0) continue;
        j = Mbd(a, e);
        if (j == null) return null;
        else orb(k, JD(j, 23));
    }
    return k;
}
function HKb(a, b) {
    var c, d, e, f;
    c = a.o.a;
    for(f = JD(JD(Qc(a.r, b), 22), 83).Jc(); f.Ob();){
        e = JD(f.Pb(), 115);
        e.e.a = c * Beb(MD(e.b.mf(DKb)));
        e.e.b = (d = e.b, d.nf((Lgd(), Xfd)) ? d.$f() == (Rjd(), xjd) ? -d.Kf().b - Beb(MD(d.mf(Xfd))) : Beb(MD(d.mf(Xfd))) : d.$f() == (Rjd(), xjd) ? -d.Kf().b : 0);
    }
}
function pNc(a, b, c) {
    var d, e, f, g, h, i;
    f = -1;
    h = -1;
    for(g = 0; g < b.c.length; g++){
        e = (sDb(g, b.c.length), JD(b.c[g], 335));
        if (e.c > a.c) break;
        else if (e.a >= a.s) {
            f < 0 && (f = g);
            h = g;
        }
    }
    i = (a.s + a.c) / 2;
    if (f >= 0) {
        d = oNc(a, b, f, h);
        i = BNc((sDb(d, b.c.length), JD(b.c[d], 335)));
        zNc(b, d, c);
    }
    return i;
}
function Dvd(a, b, c) {
    var d, e, f, g, h, i, j;
    g = (f = new KQd, f);
    IQd(g, (tDb(b), b));
    j = (!g.b && (g.b = new lRd((cPd(), $Od), u7, g)), g.b);
    for(i = 1; i < c.length; i += 2)EJd(j, c[i - 1], c[i]);
    d = (!a.Ab && (a.Ab = new X0d(Z5, a, 0, 3)), a.Ab);
    for(h = 0; h < 0; ++h){
        e = EQd(JD(nDd(d, d.i - 1), 582));
        d = e;
    }
    tCd(d, g);
}
function yMb(a, b, c, d, e, f) {
    var g, h, i;
    if (!e[b.a]) {
        e[b.a] = true;
        g = d;
        !g && (g = new qNb);
        Ilb(g.e, b);
        for(i = f[b.a].Jc(); i.Ob();){
            h = JD(i.Pb(), 288);
            if (h.d == c || h.c == c) continue;
            h.c != b && yMb(a, h.c, b, g, e, f);
            h.d != b && yMb(a, h.d, b, g, e, f);
            Ilb(g.c, h);
            Klb(g.d, h.b);
        }
        return g;
    }
    return null;
}
function H0b(a) {
    var b, c, d, e, f, g, h;
    b = 0;
    for(e = new rmb(a.e); e.a < e.c.c.length;){
        d = JD(pmb(e), 18);
        c = xBb(new RBb(null, new Gvb(d.b, 16)), new Z0b);
        c && ++b;
    }
    for(g = new rmb(a.g); g.a < g.c.c.length;){
        f = JD(pmb(g), 18);
        h = xBb(new RBb(null, new Gvb(f.b, 16)), new _0b);
        h && ++b;
    }
    return b >= 2;
}
function ykc(a, b, c, d, e) {
    var f, g, h, i, j, k;
    f = a.c.d.j;
    g = JD(fu(c, 0), 8);
    for(k = 1; k < c.b; k++){
        j = JD(fu(c, k), 8);
        Dtb(d, g, d.c.b, d.c);
        h = wdd(mdd(new Fdd(g), j), 0.5);
        i = wdd(new Ddd(EPc(f)), e);
        mdd(h, i);
        Dtb(d, h, d.c.b, d.c);
        g = j;
        f = b == 0 ? Ujd(f) : Sjd(f);
    }
    Atb(d, (rDb(c.b != 0), JD(c.c.b.c, 8)));
}
function Gid(a) {
    Eid();
    var b, c, d;
    c = nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
        Aid
    ]));
    if (_x(Px(c, a)) > 1) return false;
    b = nrb(wid, WC(OC(r2, 1), Ere, 94, 0, [
        vid,
        yid
    ]));
    if (_x(Px(b, a)) > 1) return false;
    d = nrb(Did, WC(OC(r2, 1), Ere, 94, 0, [
        Cid,
        Bid
    ]));
    if (_x(Px(d, a)) > 1) return false;
    return true;
}
function iMc(a) {
    var b, c, d, e, f, g, h;
    b = 0;
    for(d = new rmb(a.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        for(f = new es(Ir(kYb(c).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            if (a == e.d.i.c && e.c.j == (Rjd(), Qjd)) {
                g = WYb(e.c).b;
                h = WYb(e.d).b;
                b = $wnd.Math.max(b, $wnd.Math.abs(h - g));
            }
        }
    }
    return b;
}
function bPc(a, b, c) {
    var d, e, f;
    for(f = new rmb(a.t); f.a < f.c.c.length;){
        d = JD(pmb(f), 270);
        if (d.b.s < 0 && d.c > 0) {
            d.b.n -= d.c;
            d.b.n <= 0 && d.b.u > 0 && Atb(b, d.b);
        }
    }
    for(e = new rmb(a.i); e.a < e.c.c.length;){
        d = JD(pmb(e), 270);
        if (d.a.s < 0 && d.c > 0) {
            d.a.u -= d.c;
            d.a.u <= 0 && d.a.n > 0 && Atb(c, d.a);
        }
    }
}
function SDd(a) {
    var b, c, d, e, f;
    if (a.g == null) {
        a.d = a.$i(a.f);
        tCd(a, a.d);
        if (a.c) {
            f = a.f;
            return f;
        }
    }
    b = JD(a.g[a.i - 1], 49);
    e = b.Pb();
    a.e = b;
    c = a.$i(e);
    if (c.Ob()) {
        a.d = c;
        tCd(a, c);
    } else {
        a.d = null;
        while(!b.Ob()){
            VC(a.g, --a.i, null);
            if (a.i == 0) break;
            d = JD(a.g[a.i - 1], 49);
            b = d;
        }
    }
    return e;
}
function kbe(a, b) {
    var c, d, e, f, g, h;
    d = b;
    e = d.Ik();
    if (Lfe(a.e, e)) {
        if (e.Pi() && xbe(a, e, d.kd())) return false;
    } else {
        h = Kfe(a.e.zh(), e);
        c = JD(a.g, 122);
        for(f = 0; f < a.i; ++f){
            g = c[f];
            if (h.Zl(g.Ik())) {
                if (pb(g, d)) return false;
                else {
                    JD(DCd(a, f, b), 74);
                    return true;
                }
            }
        }
    }
    return tCd(a, b);
}
function DYb() {
    DYb = Zcb;
    AYb = new EYb('NORMAL', 0);
    yYb = new EYb('LONG_EDGE', 1);
    wYb = new EYb('EXTERNAL_PORT', 2);
    BYb = new EYb('NORTH_SOUTH_PORT', 3);
    xYb = new EYb('LABEL', 4);
    vYb = new EYb('BREAKING_POINT', 5);
    CYb = new EYb('PLACEHOLDER', 6);
    zYb = new EYb('NONSHIFTING_PLACEHOLDER', 7);
}
function V5b(a, b, c, d) {
    var e, f, g, h;
    e = new tYb(a);
    rYb(e, (DYb(), xYb));
    ZMb(e, (Iqc(), kqc), b);
    ZMb(e, wqc, d);
    ZMb(e, (Bwc(), Evc), (ajd(), Xid));
    ZMb(e, fqc, b.c);
    ZMb(e, gqc, b.d);
    _7b(b, e);
    h = $wnd.Math.floor(c / 2);
    for(g = new rmb(e.j); g.a < g.c.c.length;){
        f = JD(pmb(g), 11);
        f.n.b = h;
    }
    return e;
}
function PMb(a, b, c) {
    var d, e, f, g, h;
    c.Sg('ELK Force', 1);
    ydb(LD(ksd(b, (IOb(), qOb)))) || QDb((d = new RDb((Rod(), new dpd(b))), d));
    h = JMb(b);
    QMb(h);
    RMb(a, JD(WMb(h, lOb), 421));
    g = BMb(a.a, h);
    for(f = g.Jc(); f.Ob();){
        e = JD(f.Pb(), 234);
        zNb(a.b, e, c.bh(1 / g.gc()));
    }
    h = AMb(g);
    IMb(h);
    c.Tg();
}
function nUb(a, b, c) {
    switch(c.g){
        case 1:
            return new Edd(b.a, $wnd.Math.min(a.d.b, b.b));
        case 2:
            return new Edd($wnd.Math.max(a.c.a, b.a), b.b);
        case 3:
            return new Edd(b.a, $wnd.Math.max(a.c.b, b.b));
        case 4:
            return new Edd($wnd.Math.min(b.a, a.d.a), b.b);
    }
    return new Edd(b.a, b.b);
}
function Llc(a, b) {
    var c, d, e, f, g;
    b.Sg('Breaking Point Processor', 1);
    Klc(a);
    if (ydb(LD(WMb(a, (Bwc(), xwc))))) {
        for(e = new rmb(a.b); e.a < e.c.c.length;){
            d = JD(pmb(e), 25);
            c = 0;
            for(g = new rmb(d.a); g.a < g.c.c.length;){
                f = JD(pmb(g), 9);
                f.p = c++;
            }
        }
        Flc(a);
        Glc(a, true);
        Glc(a, false);
    }
    b.Tg();
}
function ZBd(a) {
    var b, c, d;
    b = av(1 + (!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c).i);
    Ilb(b, (!a.d && (a.d = new ree(x3, a, 8, 5)), a.d));
    for(d = new CHd((!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c)); d.e != d.i.gc();){
        c = JD(AHd(d), 124);
        Ilb(b, (!c.d && (c.d = new ree(x3, c, 8, 5)), c.d));
    }
    return Qb(b), new Bl(b);
}
function $Bd(a) {
    var b, c, d;
    b = av(1 + (!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c).i);
    Ilb(b, (!a.e && (a.e = new ree(x3, a, 7, 4)), a.e));
    for(d = new CHd((!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c)); d.e != d.i.gc();){
        c = JD(AHd(d), 124);
        Ilb(b, (!c.e && (c.e = new ree(x3, c, 7, 4)), c.e));
    }
    return Qb(b), new Bl(b);
}
function Eie(a) {
    var b, c, d, e;
    if (a == null) return null;
    else {
        d = Ipe(a, true);
        e = nGe.length;
        if (cgb(d.substr(d.length - e, e), nGe)) {
            c = d.length;
            if (c == 4) {
                b = (ADb(0, d.length), d.charCodeAt(0));
                if (b == 43) return pie;
                else if (b == 45) return oie;
            } else if (c == 3) return pie;
        }
        return Edb(d);
    }
}
function PDc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    l = d ? (Rjd(), Qjd) : (Rjd(), wjd);
    e = false;
    for(i = b[c], j = 0, k = i.length; j < k; ++j){
        h = i[j];
        if (bjd(JD(WMb(h, (Bwc(), Evc)), 100))) continue;
        g = h.e;
        m = !lYb(h, l).dc() && !!g;
        if (m) {
            f = mWb(g);
            a.b = new vfc(f, d ? 0 : f.length - 1);
        }
        e = e | QDc(a, h, l, m);
    }
    return e;
}
function jIc(a, b, c, d) {
    var e, f, g;
    g = bWb(b, c);
    YCb(d.c, b);
    if (a.j[g.p] == -1 || a.j[g.p] == 2 || a.a[b.p]) return d;
    a.j[g.p] = -1;
    for(f = new es(Ir(eYb(g).a.Jc(), new er)); cs(f);){
        e = JD(ds(f), 18);
        if (!(!eWb(e) && !(!eWb(e) && e.c.i.c == e.d.i.c)) || e == b) continue;
        return jIc(a, e, g, d);
    }
    return d;
}
function DIc(a) {
    var b, c, d, e;
    b = 0;
    c = 0;
    for(e = new rmb(a.j); e.a < e.c.c.length;){
        d = JD(pmb(e), 11);
        b = Pcb(tcb(b, zBb(BBb(new RBb(null, new Gvb(d.e, 16)), new QJc))));
        c = Pcb(tcb(c, zBb(BBb(new RBb(null, new Gvb(d.g, 16)), new SJc))));
        if (b > 1 || c > 1) return 2;
    }
    if (b + c == 1) return 2;
    return 0;
}
function yvb(a, b) {
    var c, d, e, f, g, h;
    f = a.a * gte + a.b * 1502;
    h = a.b * gte + 11;
    c = $wnd.Math.floor(h * hte);
    f += c;
    h -= c * ite;
    f %= ite;
    a.a = f;
    a.b = h;
    if (b <= 24) return $wnd.Math.floor(a.a * svb[b]);
    else {
        e = a.a * (1 << b - 24);
        g = $wnd.Math.floor(a.b * tvb[b]);
        d = e + g;
        d >= 2147483648 && (d -= 4294967296);
        return d;
    }
}
function xMc(a, b, c) {
    var d, e, f, g, h, i, j;
    f = new Ulb;
    j = new Mtb;
    g = new Mtb;
    yMc(a, j, g, b);
    wMc(a, j, g, b, c);
    for(i = new rmb(a); i.a < i.c.c.length;){
        h = JD(pmb(i), 116);
        for(e = new rmb(h.k); e.a < e.c.c.length;){
            d = JD(pmb(e), 133);
            (!b || d.c == (iNc(), gNc)) && h.g > d.b.g && YCb(f.c, d);
        }
    }
    return f;
}
function y8c(a, b, c) {
    var d, e, f, g, h, i;
    h = a.c;
    for(g = (!c.q ? (pnb(), pnb(), nnb) : c.q).vc().Jc(); g.Ob();){
        f = JD(g.Pb(), 43);
        d = !PBb(BBb(new RBb(null, new Gvb(h, 16)), new Dzb(new M8c(b, f)))).zd((wBb(), vBb));
        if (d) {
            i = f.kd();
            if (RD(i, 4)) {
                e = cEd(i);
                e != null && (i = e);
            }
            b.of(JD(f.jd(), 144), i);
        }
    }
}
function g2b(a, b) {
    var c, d, e, f;
    b.Sg('Resize child graph to fit parent.', 1);
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        Klb(a.a, c.a);
        c.a.c.length = 0;
    }
    for(f = new rmb(a.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        qYb(e, null);
    }
    a.b.c.length = 0;
    h2b(a);
    !!a.e && f2b(a.e, a);
    b.Tg();
}
function S7b(a, b) {
    var c, d, e, f, g;
    b.Sg('Edge joining', 1);
    c = ydb(LD(WMb(a, (Bwc(), pwc))));
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        g = new Ajb(d.a, 0);
        while(g.b < g.d.gc()){
            f = (rDb(g.b < g.d.gc()), JD(g.d.Xb(g.c = g.b++), 9));
            if (f.k == (DYb(), yYb)) {
                U7b(f, c);
                tjb(g);
            }
        }
    }
    b.Tg();
}
function C5c(a, b, c) {
    var d, e;
    f9c(a.b);
    i9c(a.b, (w5c(), t5c), (p7c(), o7c));
    i9c(a.b, u5c, b.g);
    i9c(a.b, v5c, b.a);
    a.a = d9c(a.b, b);
    c.Sg('Compaction by shrinking a tree', a.a.c.length);
    if (b.i.c.length > 1) for(e = new rmb(a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 44);
        d.If(b, c.bh(1));
    }
    c.Tg();
}
function wqd(a, b, c) {
    var d, e, f;
    f = Z9d((Gfe(), Efe), a.zh(), b);
    if (f) {
        Ife();
        if (!JD(f, 69).uk()) {
            f = Uae(jae(Efe, f));
            if (!f) throw scb(new Teb(LCe + b.ve() + MCe));
        }
        e = (d = a.Eh(f), JD(d >= 0 ? a.Hh(d, true, true) : uqd(a, f, true), 159));
        JD(e, 218).Ul(b, c);
    } else throw scb(new Teb(LCe + b.ve() + MCe));
}
function fyd(a, b, c) {
    var d, e, f, g, h, i;
    i = uyd(a, JD(Nib(a.e, b), 27));
    h = null;
    if (i) switch(i.g){
        case 3:
            d = vyd(a, Otd(b));
            h = (tDb(c), c) + (tDb(d), d);
            break;
        case 2:
            e = vyd(a, Otd(b));
            g = (tDb(c), c) + (tDb(e), e);
            f = vyd(a, JD(Nib(a.e, b), 27));
            h = g - (tDb(f), f);
            break;
        default:
            h = c;
    }
    else h = c;
    return h;
}
function hyd(a, b, c) {
    var d, e, f, g, h, i;
    i = uyd(a, JD(Nib(a.e, b), 27));
    h = null;
    if (i) switch(i.g){
        case 3:
            d = wyd(a, Otd(b));
            h = (tDb(c), c) + (tDb(d), d);
            break;
        case 2:
            e = wyd(a, Otd(b));
            g = (tDb(c), c) + (tDb(e), e);
            f = wyd(a, JD(Nib(a.e, b), 27));
            h = g - (tDb(f), f);
            break;
        default:
            h = c;
    }
    else h = c;
    return h;
}
function FZd(a, b) {
    var c, d, e, f, g;
    if (!b) return null;
    else {
        f = RD(a.Cb, 88) || RD(a.Cb, 101);
        g = !f && RD(a.Cb, 330);
        for(d = new CHd((!b.a && (b.a = new D5d(b, g6, b)), b.a)); d.e != d.i.gc();){
            c = JD(AHd(d), 87);
            e = DZd(c);
            if (f ? RD(e, 88) : g ? RD(e, 155) : !!e) return e;
        }
        return f ? (cPd(), UOd) : (cPd(), ROd);
    }
}
function sNc(a, b) {
    var c, d, e, f, g;
    c = new Ulb;
    e = DBb(new RBb(null, new Gvb(a, 16)), new LNc);
    f = DBb(new RBb(null, new Gvb(a, 16)), new NNc);
    g = UAb(TAb(GBb(Dy(WC(OC(sM, 1), Nqe, 827, 0, [
        e,
        f
    ])), new PNc)));
    for(d = 1; d < g.length; d++)g[d] - g[d - 1] >= 2 * b && Ilb(c, new ENc(g[d - 1] + b, g[d] - b));
    return c;
}
function Tyd(a, b, c) {
    var d, e, f, g, h, j, k, l;
    if (c) {
        f = c.a.length;
        d = new Rpe(f);
        for(h = (d.b - d.a) * d.c < 0 ? (Qpe(), Ppe) : new lqe(d); h.Ob();){
            g = JD(h.Pb(), 17);
            e = _xd(c, g.a);
            !!e && (i = null, j = izd(a, (k = (Hpd(), l = new rxd, l), !!b && pxd(k, b), k), e), Psd(j, byd(e, vDe)), yzd(e, j), zzd(e, j), uzd(a, e, j));
        }
    }
}
function NTd(a) {
    var b, c, d, e, f, g;
    if (!a.j) {
        g = new AYd;
        b = DTd;
        f = b.a.yc(a, b);
        if (f == null) {
            for(d = new CHd(UTd(a)); d.e != d.i.gc();){
                c = JD(AHd(d), 29);
                e = NTd(c);
                vCd(g, e);
                tCd(g, c);
            }
            b.a.Ac(a);
        }
        sDd(g);
        a.j = new gWd((JD(nDd(STd((GOd(), FOd).o), 11), 19), g.i), g.g);
        TTd(a).b &= -33;
    }
    return a.j;
}
function Gie(a) {
    var b, c, d, e;
    if (a == null) return null;
    else {
        d = Ipe(a, true);
        e = nGe.length;
        if (cgb(d.substr(d.length - e, e), nGe)) {
            c = d.length;
            if (c == 4) {
                b = (ADb(0, d.length), d.charCodeAt(0));
                if (b == 43) return rie;
                else if (b == 45) return qie;
            } else if (c == 3) return rie;
        }
        return new Leb(d);
    }
}
function hD(a) {
    var b, c, d;
    c = a.l;
    if ((c & c - 1) != 0) return -1;
    d = a.m;
    if ((d & d - 1) != 0) return -1;
    b = a.h;
    if ((b & b - 1) != 0) return -1;
    if (b == 0 && d == 0 && c == 0) return -1;
    if (b == 0 && d == 0 && c != 0) return ffb(c);
    if (b == 0 && d != 0 && c == 0) return ffb(d) + 22;
    if (b != 0 && d == 0 && c == 0) return ffb(b) + 44;
    return -1;
}
function uo(a, b) {
    var c, d, e, f, g;
    e = b.a & a.f;
    f = null;
    for(d = a.b[e];; d = d.b){
        if (d == b) {
            !f ? a.b[e] = b.b : f.b = b.b;
            break;
        }
        f = d;
    }
    g = b.f & a.f;
    f = null;
    for(c = a.c[g];; c = c.d){
        if (c == b) {
            !f ? a.c[g] = b.d : f.d = b.d;
            break;
        }
        f = c;
    }
    !b.e ? a.a = b.c : b.e.c = b.c;
    !b.c ? a.e = b.e : b.c.e = b.e;
    --a.i;
    ++a.g;
}
function zt(a, b) {
    var c;
    b.d ? b.d.b = b.b : a.a = b.b;
    b.b ? b.b.d = b.d : a.e = b.d;
    if (!b.e && !b.c) {
        c = JD(vub(JD(Sib(a.b, b.a), 260)), 260);
        c.a = 0;
        ++a.c;
    } else {
        c = JD(vub(JD(Nib(a.b, b.a), 260)), 260);
        --c.a;
        !b.e ? c.b = JD(vub(b.c), 495) : b.e.c = b.c;
        !b.c ? c.c = JD(vub(b.e), 495) : b.c.e = b.e;
    }
    --a.d;
}
function PSb(a, b) {
    var c, d, e, f;
    f = new Ajb(a, 0);
    c = (rDb(f.b < f.d.gc()), JD(f.d.Xb(f.c = f.b++), 143));
    while(f.b < f.d.gc()){
        d = (rDb(f.b < f.d.gc()), JD(f.d.Xb(f.c = f.b++), 143));
        e = new pSb(d.c, c.d, b);
        rDb(f.b > 0);
        f.a.Xb(f.c = --f.b);
        zjb(f, e);
        rDb(f.b < f.d.gc());
        f.d.Xb(f.c = f.b++);
        e.a = false;
        c = d;
    }
}
function z_b(a) {
    var b, c, d, e, f, g;
    e = JD(WMb(a, (Iqc(), Hpc)), 11);
    for(g = new rmb(a.j); g.a < g.c.c.length;){
        f = JD(pmb(g), 11);
        for(d = new rmb(f.g); d.a < d.c.c.length;){
            b = JD(pmb(d), 18);
            hWb(b, e);
            return f;
        }
        for(c = new rmb(f.e); c.a < c.c.c.length;){
            b = JD(pmb(c), 18);
            gWb(b, e);
            return f;
        }
    }
    return null;
}
function i8b(a, b, c) {
    var d, e, f, g, h, i;
    i = JD(k_b(a.a, b), 17).a;
    c ? o_b(a.a, jfb(i + 1), b) : o_b(a.a, jfb(i - 1), b);
    g = new wtb;
    for(e = new es(Ir((c ? kYb(b) : hYb(b)).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        c ? f = d.d.i : f = d.c.i;
        XD(k_b(a.a, f)) === XD(k_b(a.a, b)) && (h = g.a.yc(f, g), h);
    }
    return g;
}
function qA(a, b, c) {
    var d, e;
    d = zcb(c.q.getTime());
    if (vcb(d, 0) < 0) {
        e = Vre - Pcb(Ecb(Gcb(d), Vre));
        e == Vre && (e = 0);
    } else e = Pcb(Ecb(d, Vre));
    if (b == 1) {
        e = $wnd.Math.min((e + 50) / 100 | 0, 9);
        Kgb(a, 48 + e & Wre);
    } else if (b == 2) {
        e = $wnd.Math.min((e + 5) / 10 | 0, 99);
        MA(a, e, 2);
    } else {
        MA(a, e, 3);
        b > 3 && MA(a, 0, b - 3);
    }
}
function oQb(a) {
    var b, c, d, e;
    if (XD(WMb(a, (Bwc(), Iuc))) === XD((eid(), bid))) return !a.e && XD(WMb(a, guc)) !== XD((hpc(), epc));
    d = JD(WMb(a, huc), 298);
    e = ydb(LD(WMb(a, nuc))) || XD(WMb(a, ouc)) === XD((cnc(), _mc));
    b = JD(WMb(a, fuc), 17).a;
    c = a.a.c.length;
    return !e && d != (hpc(), epc) && (b == 0 || b > c);
}
function b9b(a, b) {
    var c, d, e, f, g, h, i;
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 9);
        h = new bZb;
        _Yb(h, d);
        aZb(h, (Rjd(), wjd));
        ZMb(h, (Iqc(), rqc), (xdb(), true));
        for(g = b.Jc(); g.Ob();){
            f = JD(g.Pb(), 9);
            i = new bZb;
            _Yb(i, f);
            aZb(i, Qjd);
            ZMb(i, rqc, true);
            c = new kWb;
            ZMb(c, rqc, true);
            gWb(c, h);
            hWb(c, i);
        }
    }
}
function ohc(a) {
    var b, c;
    c = 0;
    for(; c < a.c.length; c++){
        if (Rgc((sDb(c, a.c.length), JD(a.c[c], 112))) > 0) break;
    }
    if (c > 0 && c < a.c.length - 1) return c;
    b = 0;
    for(; b < a.c.length; b++){
        if (Rgc((sDb(b, a.c.length), JD(a.c[b], 112))) > 0) break;
    }
    if (b > 0 && c < a.c.length - 1) return b;
    return a.c.length / 2 | 0;
}
function bmc(a, b) {
    var c, d, e, f, g, h, i;
    e = 0;
    for(g = new rmb(b.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        e += f.o.b + f.d.a + f.d.d + a.e;
        for(d = new es(Ir(hYb(f).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            if (c.c.i.k == (DYb(), BYb)) {
                i = c.c.i;
                h = JD(WMb(i, (Iqc(), kqc)), 9);
                e += h.o.b + h.d.a + h.d.d;
            }
        }
    }
    return e;
}
function oud(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 6 && !!b) {
        if (hfe(a, b)) throw scb(new Teb(VCe + sud(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? eud(a, d) : a.Cb.Ph(a, -1 - c, null, d)));
        !!b && (d = mqd(b, a, 6, d));
        d = dud(a, b, d);
        !!d && d.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 6, b, b));
}
function pxd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 9 && !!b) {
        if (hfe(a, b)) throw scb(new Teb(VCe + qxd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? nxd(a, d) : a.Cb.Ph(a, -1 - c, null, d)));
        !!b && (d = mqd(b, a, 9, d));
        d = mxd(a, b, d);
        !!d && d.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 9, b, b));
}
function Ttd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 3 && !!b) {
        if (hfe(a, b)) throw scb(new Teb(VCe + Utd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? Ntd(a, d) : a.Cb.Ph(a, -1 - c, null, d)));
        !!b && (d = mqd(b, a, 12, d));
        d = Mtd(a, b, d);
        !!d && d.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 3, b, b));
}
function axd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 11 && !!b) {
        if (hfe(a, b)) throw scb(new Teb(VCe + bxd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? Wwd(a, d) : a.Cb.Ph(a, -1 - c, null, d)));
        !!b && (d = mqd(b, a, 10, d));
        d = Vwd(a, b, d);
        !!d && d.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 11, b, b));
}
function ORd(b) {
    var c, d, e, f, g;
    e = pRd(b);
    g = b.j;
    if (g == null && !!e) return b.Gk() ? null : e.fk();
    else if (RD(e, 155)) {
        d = e.gk();
        if (d) {
            f = d.si();
            if (f != b.i) {
                c = JD(e, 155);
                if (c.kk()) try {
                    b.g = f.pi(c, g);
                } catch (a) {
                    a = rcb(a);
                    if (RD(a, 80)) b.g = null;
                    else throw scb(a);
                }
                b.i = f;
            }
        }
        return b.g;
    }
    return null;
}
function vMb(a) {
    var b;
    b = new Ulb;
    Ilb(b, new SDb(new Edd(a.c, a.d), new Edd(a.c + a.b, a.d)));
    Ilb(b, new SDb(new Edd(a.c, a.d), new Edd(a.c, a.d + a.a)));
    Ilb(b, new SDb(new Edd(a.c + a.b, a.d + a.a), new Edd(a.c + a.b, a.d)));
    Ilb(b, new SDb(new Edd(a.c + a.b, a.d + a.a), new Edd(a.c, a.d + a.a)));
    return b;
}
function ic(b) {
    var c, d, e;
    if (b == null) return Rqe;
    try {
        return adb(b);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            c = a;
            e = eeb(rb(b)) + '@' + (d = (Zgb(), iDb(b)) >>> 0, d.toString(16));
            _zb(dAb(), (Gzb(), 'Exception during lenientFormat for ' + e), c);
            return '<' + e + ' threw ' + eeb(c.Om) + '>';
        } else throw scb(a);
    }
}
function mkc(a, b, c, d) {
    var e, f, g, h;
    e = kkc(a, b, c);
    f = kkc(a, c, b);
    g = JD(Nib(a.c, b), 116);
    h = JD(Nib(a.c, c), 116);
    if (e < f) new eNc((iNc(), hNc), g, h, f - e);
    else if (f < e) new eNc((iNc(), hNc), h, g, e - f);
    else if (e != 0 || !(!b.i || !c.i) && d[b.i.c][c.i.c]) {
        new eNc((iNc(), hNc), g, h, 0);
        new eNc(hNc, h, g, 0);
    }
}
function Ulc(a, b, c) {
    var d, e, f, g, h;
    c.Sg('Breaking Point Removing', 1);
    a.a = JD(WMb(b, (Bwc(), yuc)), 220);
    for(f = new rmb(b.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        for(h = new rmb(Zu(e.a)); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            if (ulc(g)) {
                d = JD(WMb(g, (Iqc(), Gpc)), 314);
                !d.d && Vlc(a, d);
            }
        }
    }
    c.Tg();
}
function I4c() {
    I4c = Zcb;
    E4c = new J4c('CANDIDATE_POSITION_LAST_PLACED_RIGHT', 0);
    D4c = new J4c('CANDIDATE_POSITION_LAST_PLACED_BELOW', 1);
    G4c = new J4c('CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT', 2);
    F4c = new J4c('CANDIDATE_POSITION_WHOLE_DRAWING_BELOW', 3);
    H4c = new J4c('WHOLE_DRAWING', 4);
}
function MVb(a) {
    var b, c, d, e;
    for(d = new mjb(new djb(a.b).a); d.b;){
        c = kjb(d);
        e = JD(c.jd(), 11);
        b = JD(c.kd(), 9);
        ZMb(b, (Iqc(), kqc), e);
        ZMb(e, sqc, b);
        ZMb(e, Zpc, (xdb(), true));
        aZb(e, JD(WMb(b, Tpc), 64));
        WMb(b, Tpc);
        ZMb(e.i, (Bwc(), Evc), (ajd(), Zid));
        JD(WMb(gYb(e.i), Wpc), 22).Ec(($oc(), Woc));
    }
}
function dfc(a) {
    var b, c, d, e, f, g, h;
    f = new Mtb;
    for(e = new rmb(a.d.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 123);
        d.b.a.c.length == 0 && Dtb(f, d, f.c.b, f.c);
    }
    if (f.b > 1) {
        b = pGb((c = new rGb, ++a.b, c), a.d);
        for(h = Gtb(f, 0); h.b != h.d.c;){
            g = JD(Utb(h), 123);
            DFb(GFb(FFb(HFb(EFb(new IFb, 1), 0), b), g));
        }
    }
}
function h1b(a, b, c) {
    var d, e, f, g, h, i;
    f = 0;
    g = 0;
    if (a.c) for(i = new rmb(a.d.i.j); i.a < i.c.c.length;){
        h = JD(pmb(i), 11);
        f += h.e.c.length;
    }
    else f = 1;
    if (a.d) for(i = new rmb(a.c.i.j); i.a < i.c.c.length;){
        h = JD(pmb(i), 11);
        g += h.g.c.length;
    }
    else g = 1;
    e = YD(Cfb(g - f));
    d = (c + b) / 2 + (c - b) * (0.4 * e);
    return d;
}
function k9b(a, b) {
    var c, d, e, f, g, h;
    b.Sg('Partition postprocessing', 1);
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        for(f = new rmb(c.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            h = new rmb(e.j);
            while(h.a < h.c.c.length){
                g = JD(pmb(h), 11);
                ydb(LD(WMb(g, (Iqc(), rqc)))) && qmb(h);
            }
        }
    }
    b.Tg();
}
function ahc(a) {
    $gc();
    var b, c;
    if (a.Gc((Rjd(), Pjd))) throw scb(new Teb('Port sides must not contain UNDEFINED'));
    switch(a.gc()){
        case 1:
            return Wgc;
        case 2:
            b = a.Gc(wjd) && a.Gc(Qjd);
            c = a.Gc(xjd) && a.Gc(Ojd);
            return b || c ? Zgc : Ygc;
        case 3:
            return Xgc;
        case 4:
            return Vgc;
        default:
            return null;
    }
}
function Rcd(a, b, c) {
    Icd();
    if (Mcd(a, b) && Mcd(a, c)) return false;
    return Scd(new Edd(a.c, a.d), new Edd(a.c + a.b, a.d), b, c) || Scd(new Edd(a.c + a.b, a.d), new Edd(a.c + a.b, a.d + a.a), b, c) || Scd(new Edd(a.c + a.b, a.d + a.a), new Edd(a.c, a.d + a.a), b, c) || Scd(new Edd(a.c, a.d + a.a), new Edd(a.c, a.d), b, c);
}
function qae(a, b) {
    var c, d, e, f;
    if (!a.dc()) for(c = 0, d = a.gc(); c < d; ++c){
        f = OD(a.Xb(c));
        if (f == null ? b == null : cgb(f.substr(0, 3), '!##') ? b != null && (e = b.length, !cgb(f.substr(f.length - e, e), b) || f.length != b.length + 3) && !cgb(eGe, b) : cgb(f, fGe) && !cgb(eGe, b) || cgb(f, b)) return true;
    }
    return false;
}
function k0b(a, b, c, d) {
    var e, f, g, h, i, j;
    g = a.j.c.length;
    i = SC(lN, $te, 315, g, 0, 1);
    for(h = 0; h < g; h++){
        f = JD(Mlb(a.j, h), 11);
        f.p = h;
        i[h] = e0b(o0b(f), c, d);
    }
    g0b(a, i, c, b, d);
    j = new Irb;
    for(e = 0; e < i.length; e++)!!i[e] && Qib(j, JD(Mlb(a.j, e), 11), i[e]);
    if (j.f.c + j.i.c != 0) {
        ZMb(a, (Iqc(), Opc), j);
        m0b(a, i);
    }
}
function Edc(a, b, c) {
    var d, e, f;
    for(e = new rmb(a.a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 60);
        f = mdc(d);
        if (f) {
            if (f.k == (DYb(), wYb)) switch(JD(WMb(f, (Iqc(), Tpc)), 64).g){
                case 4:
                    f.n.a = b.a;
                    break;
                case 2:
                    f.n.a = c.a - (f.o.a + f.d.c);
                    break;
                case 1:
                    f.n.b = b.b;
                    break;
                case 3:
                    f.n.b = c.b - (f.o.b + f.d.a);
            }
        }
    }
}
function hTc(a, b, c) {
    var d, e, f;
    c.Sg('Processor determine the height for each level', 1);
    a.a = b.b.b == 0 ? 1 : b.b.b;
    e = null;
    d = Gtb(b.b, 0);
    while(!e && d.b != d.d.c){
        f = JD(Utb(d), 39);
        ydb(LD(WMb(f, (tUc(), qUc)))) && (e = f);
    }
    !!e && iTc(a, _u(WC(OC(NZ, 1), Ize, 39, 0, [
        e
    ])), c, JD(WMb(b, (kVc(), KUc)), 86));
    c.Tg();
}
function a3c(a) {
    var b, c, d, e, f, g;
    d = (Hpd(), f = new cxd, f);
    dsd(d, a);
    for(c = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 27);
        g = (e = new cxd, e);
        axd(g, d);
        dtd(g, b.g, b.f);
        Psd(g, b.k);
        ftd(g, b.i, b.j);
        tCd((!d.a && (d.a = new X0d(A3, d, 10, 11)), d.a), g);
        dsd(g, b);
    }
    return d;
}
function Yld(a, b, c) {
    var d, e, f, g, h;
    e = JD(ksd(b, (ued(), sed)), 17);
    !e && (e = jfb(0));
    f = JD(ksd(c, sed), 17);
    !f && (f = jfb(0));
    if (e.a > f.a) return -1;
    else if (e.a < f.a) return 1;
    else {
        if (a.a) {
            d = Heb(b.j, c.j);
            if (d != 0) return d;
            d = Heb(b.i, c.i);
            if (d != 0) return d;
        }
        g = b.g * b.f;
        h = c.g * c.f;
        return Heb(g, h);
    }
}
function yJd(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    ++a.e;
    i = a.d == null ? 0 : a.d.length;
    if (b > i) {
        k = a.d;
        a.d = SC(v5, LEe, 66, 2 * i + 4, 0, 1);
        for(f = 0; f < i; ++f){
            j = k[f];
            if (j) {
                d = j.g;
                l = j.i;
                for(h = 0; h < l; ++h){
                    e = JD(d[h], 135);
                    g = AJd(a, e.xi());
                    c = a.d[g];
                    !c && (c = a.d[g] = a.ak());
                    c.Ec(e);
                }
            }
        }
        return true;
    } else return false;
}
function hbe(a, b, c) {
    var d, e, f, g, h, i;
    e = c;
    f = e.Ik();
    if (Lfe(a.e, f)) {
        if (f.Pi()) {
            d = JD(a.g, 122);
            for(g = 0; g < a.i; ++g){
                h = d[g];
                if (pb(h, e) && g != b) throw scb(new Teb(MDe));
            }
        }
    } else {
        i = Kfe(a.e.zh(), f);
        d = JD(a.g, 122);
        for(g = 0; g < a.i; ++g){
            h = d[g];
            if (i.Zl(h.Ik())) throw scb(new Teb(hGe));
        }
    }
    sCd(a, b, c);
}
function _Ub(a, b) {
    var c, d, e, f, g, h;
    c = JD(WMb(b, (Iqc(), Qpc)), 22);
    g = JD(Qc((JTb(), ITb), c), 22);
    h = JD(Qc(YUb, c), 22);
    for(f = g.Jc(); f.Ob();){
        d = JD(f.Pb(), 22);
        if (!JD(Qc(a.b, d), 15).dc()) return false;
    }
    for(e = h.Jc(); e.Ob();){
        d = JD(e.Pb(), 22);
        if (!JD(Qc(a.b, d), 15).dc()) return false;
    }
    return true;
}
function _fc(a, b, c) {
    a.d = 0;
    a.b = 0;
    b.k == (DYb(), BYb) && c.k == BYb && JD(WMb(b, (Iqc(), kqc)), 9) == JD(WMb(c, kqc), 9) && (dgc(b).j == (Rjd(), xjd) ? agc(a, b, c) : agc(a, c, b));
    b.k == BYb && c.k == yYb ? dgc(b).j == (Rjd(), xjd) ? a.d = 1 : a.b = 1 : c.k == BYb && b.k == yYb && (dgc(c).j == (Rjd(), xjd) ? a.b = 1 : a.d = 1);
    fgc(a, b, c);
}
function t4c(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (a.a.c.length == 1) return d4c(JD(Mlb(a.a, 0), 172), b);
    g = s4c(a);
    i = 0;
    j = a.d;
    f = g;
    k = a.d;
    h = (j - f) / 2 + f;
    while(f + 1 < j){
        i = 0;
        for(d = new rmb(a.a); d.a < d.c.c.length;){
            c = JD(pmb(d), 172);
            i += (e = g4c(c, h, false), e.a);
        }
        if (i < b) {
            k = h;
            j = h;
        } else f = h;
        h = (j - f) / 2 + f;
    }
    return k;
}
function dsd(a, b) {
    var c, d, e, f, g;
    if (!b) return a;
    if (RD(b, 338)) {
        e = JD(b, 338);
        f = (!a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0)), a.o);
        for(d = e.eh().c.Jc(); d.e != d.i.gc();){
            c = JD(d.Vj(), 43);
            g = c.kd();
            EJd(f, JD(c.jd(), 144), g);
        }
    } else {
        !a.o && (a.o = new YQd((Vpd(), Spd), O3, a, 0));
        FJd(a.o, b.lf());
    }
    return a;
}
function ezd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    k = null;
    o = yyd(a, b);
    i = null;
    !!o && (i = kzd(a, o));
    p = i;
    c = null;
    e = MD(Nib(a.i, p));
    e != null ? c = e : c = jfb(0);
    m = c;
    d = null;
    f = MD(Nib(a.j, p));
    f != null ? d = f : d = jfb(0);
    n = d;
    j = b.i;
    g = Ope(j, m);
    Qib(a.i, b, g);
    l = b.j;
    h = Ope(l, n);
    k = MD(Qib(a.j, b, h));
    return k;
}
function nD(a) {
    var b, c, d, e, f;
    if (isNaN(a)) return ED(), DD;
    if (a < -9223372036854776000) return ED(), BD;
    if (a >= 9223372036854775807) return ED(), AD;
    e = false;
    if (a < 0) {
        e = true;
        a = -a;
    }
    d = 0;
    if (a >= Dse) {
        d = YD(a / Dse);
        a -= d * Dse;
    }
    c = 0;
    if (a >= Cse) {
        c = YD(a / Cse);
        a -= c * Cse;
    }
    b = YD(a);
    f = _C(b, c, d);
    e && fD(f);
    return f;
}
function JAb(a) {
    var b, c, d, e, f;
    f = new Ulb;
    Llb(a.b, new RCb(f));
    a.b.c.length = 0;
    if (f.c.length != 0) {
        b = (sDb(0, f.c.length), JD(f.c[0], 80));
        for(c = 1, d = f.c.length; c < d; ++c){
            e = (sDb(c, f.c.length), JD(f.c[c], 80));
            e != b && Zy(b, e);
        }
        if (RD(b, 63)) throw scb(JD(b, 63));
        if (RD(b, 294)) throw scb(JD(b, 294));
    }
}
function tKb(a, b) {
    var c, d, e, f;
    c = !b || !a.u.Gc((ojd(), kjd));
    f = 0;
    for(e = new rmb(a.e.Vf()); e.a < e.c.c.length;){
        d = JD(pmb(e), 831);
        if (d.$f() == (Rjd(), Pjd)) throw scb(new Teb('Label and node size calculator can only be used with ports that have port sides assigned.'));
        d.Of(f++);
        sKb(a, d, c);
    }
}
function HEb(a) {
    var b, c, d, e, f;
    for(c = new rmb(a.a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 317);
        b.j = null;
        for(f = b.a.a.ec().Jc(); f.Ob();){
            d = JD(f.Pb(), 60);
            vdd(d.b);
            (!b.j || d.d.c < b.j.d.c) && (b.j = d);
        }
        for(e = b.a.a.ec().Jc(); e.Ob();){
            d = JD(e.Pb(), 60);
            d.b.a = d.d.c - b.j.d.c;
            d.b.b = d.d.d - b.j.d.d;
        }
    }
    return a;
}
function ERb(a) {
    var b, c, d, e, f;
    for(c = new rmb(a.a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 194);
        b.f = null;
        for(f = b.a.a.ec().Jc(); f.Ob();){
            d = JD(f.Pb(), 82);
            vdd(d.e);
            (!b.f || d.g.c < b.f.g.c) && (b.f = d);
        }
        for(e = b.a.a.ec().Jc(); e.Ob();){
            d = JD(e.Pb(), 82);
            d.e.a = d.g.c - b.f.g.c;
            d.e.b = d.g.d - b.f.g.d;
        }
    }
    return a;
}
function DEc(a, b, c) {
    var d, e, f, g, h;
    g = dGc(a, c);
    h = SC(RP, Jve, 9, b.length, 0, 1);
    d = 0;
    for(f = g.Jc(); f.Ob();){
        e = JD(f.Pb(), 11);
        ydb(LD(WMb(e, (Iqc(), Zpc)))) && (h[d++] = JD(WMb(e, sqc), 9));
    }
    if (d < b.length) throw scb(new Web('Expected ' + b.length + ' hierarchical ports, but found only ' + d + '.'));
    return h;
}
function dBd(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    l = gBd(a);
    b = a.a;
    i = b != null;
    i && Wxd(l, 'category', a.a);
    e = yqe(new Ojb(a.d));
    g = !e;
    if (g) {
        j = new EB;
        kC(l, 'knownOptions', j);
        c = new lBd(j);
        ofb(new Ojb(a.d), c);
    }
    f = yqe(a.g);
    h = !f;
    if (h) {
        k = new EB;
        kC(l, 'supportedFeatures', k);
        d = new nBd(k);
        ofb(a.g, d);
    }
    return l;
}
function Dy(a) {
    var b, c, d, e, f, g, h, i, j;
    d = false;
    b = 336;
    c = 0;
    f = new dq(a.length);
    for(h = a, i = 0, j = h.length; i < j; ++i){
        g = h[i];
        d = d | (LAb(g), false);
        e = (KAb(g), g.a);
        Ilb(f.a, Qb(e));
        b &= e.wd();
        c = Uy(c, e.xd());
    }
    return JD(JD(IAb(new RBb(null, ck(new Gvb((qm(), wm(f.a)), 16), new Ey, b, c)), new Gy(a)), 672), 827);
}
function eTb(a, b) {
    var c;
    if (!!a.d && (b.c != a.e.c || CSb(a.e.b, b.b))) {
        Ilb(a.f, a.d);
        a.a = a.d.c + a.d.b;
        a.d = null;
        a.e = null;
    }
    zSb(b.b) ? a.c = b : a.b = b;
    if (b.b == (xSb(), tSb) && !b.a || b.b == uSb && b.a || b.b == vSb && b.a || b.b == wSb && !b.a) {
        if (!!a.c && !!a.b) {
            c = new gdd(a.a, a.c.d, b.c - a.a, a.b.d - a.c.d);
            a.d = c;
            a.e = b;
        }
    }
}
function Iwd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 7 && !!b) {
        if (hfe(a, b)) throw scb(new Teb(VCe + Kwd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? Gwd(a, d) : a.Cb.Ph(a, -1 - c, null, d)));
        !!b && (d = JD(b, 52).Nh(a, 1, y3, d));
        d = Fwd(a, b, d);
        !!d && d.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 7, b, b));
}
function GQd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 3 && !!b) {
        if (hfe(a, b)) throw scb(new Teb(VCe + JQd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? DQd(a, d) : a.Cb.Ph(a, -1 - c, null, d)));
        !!b && (d = JD(b, 52).Nh(a, 0, h6, d));
        d = CQd(a, b, d);
        !!d && d.lj();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 3, b, b));
}
function Dib(a, b) {
    Cib();
    var c, d, e, f, g, h, i, j, k;
    if (b.d > a.d) {
        h = a;
        a = b;
        b = h;
    }
    if (b.d < 63) return Hib(a, b);
    g = (a.d & -2) << 4;
    j = Rhb(a, g);
    k = Rhb(b, g);
    d = xib(a, Qhb(j, g));
    e = xib(b, Qhb(k, g));
    i = Dib(j, k);
    c = Dib(d, e);
    f = Dib(xib(j, d), xib(e, k));
    f = sib(sib(f, i), c);
    f = Qhb(f, g);
    i = Qhb(i, g << 1);
    return sib(sib(i, f), c);
}
function cxc() {
    cxc = Zcb;
    axc = new exc(eze, 0);
    Zwc = new exc('LONGEST_PATH', 1);
    $wc = new exc('LONGEST_PATH_SOURCE', 2);
    Wwc = new exc('COFFMAN_GRAHAM', 3);
    Ywc = new exc(owe, 4);
    bxc = new exc('STRETCH_WIDTH', 5);
    _wc = new exc('MIN_WIDTH', 6);
    Vwc = new exc('BF_MODEL_ORDER', 7);
    Xwc = new exc('DF_MODEL_ORDER', 8);
}
function Wvd(a, b) {
    var c, d, e, f, g, h;
    if (!a.tb) {
        f = (!a.rb && (a.rb = new c1d(a, a6, a)), a.rb);
        h = new Jrb(f.i);
        for(e = new CHd(f); e.e != e.i.gc();){
            d = JD(AHd(e), 141);
            g = d.ve();
            c = JD(g == null ? gsb(h.f, null, d) : Asb(h.i, g, d), 141);
            !!c && (g == null ? gsb(h.f, null, c) : Asb(h.i, g, c));
        }
        a.tb = h;
    }
    return JD(Oib(a.tb, b), 141);
}
function RTd(a, b) {
    var c, d, e, f, g;
    (a.i == null && MTd(a), a.i).length;
    if (!a.p) {
        g = new Jrb((3 * a.g.i / 2 | 0) + 1);
        for(e = new XHd(a.g); e.e != e.i.gc();){
            d = JD(WHd(e), 178);
            f = d.ve();
            c = JD(f == null ? gsb(g.f, null, d) : Asb(g.i, f, d), 178);
            !!c && (f == null ? gsb(g.f, null, c) : Asb(g.i, f, c));
        }
        a.p = g;
    }
    return JD(Oib(a.p, b), 178);
}
function eDb(a, b, c, d, e) {
    var f, g, h, i, j;
    cDb(d + dz(c, c.ge()), e);
    dDb(b, gDb(c));
    f = c.f;
    !!f && eDb(a, b, f, 'Caused by: ', false);
    for(h = (c.k == null && (c.k = SC(iJ, hre, 80, 0, 0, 1)), c.k), i = 0, j = h.length; i < j; ++i){
        g = h[i];
        eDb(a, b, g, 'Suppressed: ', false);
    }
    console.groupEnd != null && console.groupEnd.call(console);
}
function GEc(a, b, c, d) {
    var e, f, g, h, i;
    i = b.e;
    h = i.length;
    g = b.q.sg(i, c ? 0 : h - 1, c);
    e = i[c ? 0 : h - 1];
    g = g | FEc(a, e, c, d);
    for(f = c ? 1 : h - 2; c ? f < h : f >= 0; f += c ? 1 : -1){
        g = g | b.c.jg(i, f, c, d && !ydb(LD(WMb(b.j, (Iqc(), Vpc)))) && !ydb(LD(WMb(b.j, (Iqc(), yqc)))));
        g = g | b.q.sg(i, f, c);
        g = g | FEc(a, i[f], c, d);
    }
    Nrb(a.c, b);
    return g;
}
function R_b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    for(k = EXb(a.j), l = 0, m = k.length; l < m; ++l){
        j = k[l];
        if (c == (Eyc(), Byc) || c == Dyc) {
            i = CXb(j.g);
            for(e = i, f = 0, g = e.length; f < g; ++f){
                d = e[f];
                N_b(b, d) && fWb(d, true);
            }
        }
        if (c == Cyc || c == Dyc) {
            h = CXb(j.e);
            for(e = h, f = 0, g = e.length; f < g; ++f){
                d = e[f];
                M_b(b, d) && fWb(d, true);
            }
        }
    }
}
function y5b() {
    u5b();
    return WC(OC(ER, 1), Ere, 79, 0, [
        A4b,
        x4b,
        B4b,
        R4b,
        i5b,
        V4b,
        o5b,
        $4b,
        g5b,
        M4b,
        c5b,
        Z4b,
        h5b,
        I4b,
        q5b,
        r4b,
        b5b,
        k5b,
        S4b,
        j5b,
        s5b,
        e5b,
        s4b,
        f5b,
        t5b,
        m5b,
        q4b,
        r5b,
        T4b,
        F4b,
        U4b,
        Q4b,
        p5b,
        v4b,
        D4b,
        X4b,
        u4b,
        Y4b,
        O4b,
        J4b,
        _4b,
        L4b,
        y4b,
        w4b,
        P4b,
        K4b,
        a5b,
        n5b,
        t4b,
        d5b,
        N4b,
        W4b,
        G4b,
        E4b,
        l5b,
        C4b,
        H4b,
        z4b
    ]);
}
function Tjc(a) {
    var b, c;
    b = null;
    c = null;
    switch(Ojc(a).g){
        case 1:
            b = (Rjd(), wjd);
            c = Qjd;
            break;
        case 2:
            b = (Rjd(), Ojd);
            c = xjd;
            break;
        case 3:
            b = (Rjd(), Qjd);
            c = wjd;
            break;
        case 4:
            b = (Rjd(), xjd);
            c = Ojd;
    }
    pgc(a, JD(zub(JBb(JD(Qc(a.k, b), 15).Mc(), Kjc)), 112));
    qgc(a, JD(zub(IBb(JD(Qc(a.k, c), 15).Mc(), Kjc)), 112));
}
function j9c(a) {
    var b;
    b9c.call(this);
    this.i = new x9c;
    this.g = a;
    this.f = JD(a.e && a.e(), 10).length;
    if (this.f == 0) throw scb(new Teb('There must be at least one phase in the phase enumeration.'));
    this.c = (b = JD(deb(this.g), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    this.a = new J9c;
    this.b = new Irb;
}
function D2b(a) {
    var b, c, d, e, f, g;
    e = JD(Mlb(a.j, 0), 11);
    if (e.e.c.length + e.g.c.length == 0) a.n.a = 0;
    else {
        g = 0;
        for(d = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
            new dZb(e),
            new lZb(e)
        ]))); cs(d);){
            c = JD(ds(d), 11);
            g += c.i.n.a + c.n.a + c.a.a;
        }
        b = JD(WMb(a, (Bwc(), Cvc)), 8);
        f = !b ? 0 : b.a;
        a.n.a = g / (e.e.c.length + e.g.c.length) - f;
    }
}
function d8c(a, b) {
    var c, d, e;
    for(d = new rmb(b.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 224);
        _Lb(JD(c.b, 68), Bdd(odd(JD(b.b, 68).c), JD(b.b, 68).a));
        e = wMb(JD(b.b, 68).b, JD(c.b, 68).b);
        e > 1 && (a.a = true);
        $Lb(JD(c.b, 68), mdd(odd(JD(b.b, 68).c), wdd(Bdd(odd(JD(c.b, 68).a), JD(b.b, 68).a), e)));
        b8c(a, b);
        d8c(a, c);
    }
}
function DRb(a) {
    var b, c, d, e, f, g, h;
    for(f = new rmb(a.a.a); f.a < f.c.c.length;){
        d = JD(pmb(f), 194);
        d.e = 0;
        d.d.a.$b();
    }
    for(e = new rmb(a.a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 194);
        for(c = d.a.a.ec().Jc(); c.Ob();){
            b = JD(c.Pb(), 82);
            for(h = b.f.Jc(); h.Ob();){
                g = JD(h.Pb(), 82);
                if (g.d != d) {
                    Nrb(d.d, g);
                    ++g.d.e;
                }
            }
        }
    }
}
function J_b(a, b) {
    var c, d, e, f, g, h, i;
    b.Sg('Constraints Postprocessor', 1);
    g = 0;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        i = 0;
        h = false;
        for(d = new rmb(e.a); d.a < d.c.c.length;){
            c = JD(pmb(d), 9);
            if (c.k == (DYb(), AYb)) {
                h = true;
                ZMb(c, (Bwc(), Vuc), jfb(g));
                ZMb(c, muc, jfb(i));
                ++i;
            }
        }
        h && ++g;
    }
    b.Tg();
}
function V8b(a) {
    var b, c, d, e, f, g, h, i;
    i = a.j.c.length;
    c = 0;
    b = i;
    e = 2 * i;
    for(h = new rmb(a.j); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        switch(g.j.g){
            case 2:
            case 4:
                g.p = -1;
                break;
            case 1:
            case 3:
                d = g.e.c.length;
                f = g.g.c.length;
                d > 0 && f > 0 ? g.p = b++ : d > 0 ? g.p = c++ : f > 0 ? g.p = e++ : g.p = c++;
        }
    }
    pnb();
    Slb(a.j, new Z8b);
}
function Nbc(a) {
    var b, c;
    c = null;
    b = JD(Mlb(a.g, 0), 18);
    do {
        c = b.d.i;
        if (XMb(c, (Iqc(), gqc))) return JD(WMb(c, gqc), 11).i;
        if (c.k != (DYb(), AYb) && cs(new es(Ir(kYb(c).a.Jc(), new er)))) b = JD(ds(new es(Ir(kYb(c).a.Jc(), new er))), 18);
        else if (c.k != AYb) return null;
    }while (!!c && c.k != (DYb(), AYb));
    return c;
}
function Rjc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    h = b.j;
    g = b.g;
    i = JD(Mlb(h, h.c.length - 1), 112);
    k = (sDb(0, h.c.length), JD(h.c[0], 112));
    j = Njc(a, g, i, k);
    for(f = 1; f < h.c.length; f++){
        c = (sDb(f - 1, h.c.length), JD(h.c[f - 1], 112));
        e = (sDb(f, h.c.length), JD(h.c[f], 112));
        d = Njc(a, g, c, e);
        if (d > j) {
            i = c;
            k = e;
            j = d;
        }
    }
    b.a = k;
    b.c = i;
}
function iGc(a, b, c) {
    var d, e, f, g, h, i, j;
    j = new mzb(new WGc(a));
    for(g = WC(OC(dQ, 1), Kve, 11, 0, [
        b,
        c
    ]), h = 0, i = g.length; h < i; ++h){
        f = g[h];
        j.a.yc(f, (xdb(), vdb));
        for(e = new xZb(f.b); omb(e.a) || omb(e.b);){
            d = JD(omb(e.a) ? pmb(e.a) : pmb(e.b), 18);
            d.c == d.d || fzb(j, f == d.c ? d.d : d.c);
        }
    }
    return Qb(j), new Wlb(j);
}
function DFb(a) {
    if (!a.a.d || !a.a.e) throw scb(new Web((ceb(ZM), ZM.k + ' must have a source and target ' + (ceb(bN), bN.k) + ' specified.')));
    if (a.a.d == a.a.e) throw scb(new Web('Network simplex does not support self-loops: ' + a.a + ' ' + a.a.d + ' ' + a.a.e));
    QFb(a.a.d.g, a.a);
    QFb(a.a.e.b, a.a);
    return a.a;
}
function pBc(a, b, c) {
    var d, e, f, g, h;
    c.Sg('Longest path layering', 1);
    a.a = b;
    h = a.a.a;
    a.b = SC(cE, ise, 30, h.c.length, 15, 1);
    d = 0;
    for(g = new rmb(h); g.a < g.c.c.length;){
        e = JD(pmb(g), 9);
        e.p = d;
        a.b[d] = -1;
        ++d;
    }
    for(f = new rmb(h); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        rBc(a, e);
    }
    h.c.length = 0;
    a.a = null;
    a.b = null;
    c.Tg();
}
function RNc(a, b, c) {
    var d, e, f, g, h, i;
    d = 0;
    if (b.b != 0 && c.b != 0) {
        f = Gtb(b, 0);
        g = Gtb(c, 0);
        h = Beb(MD(Utb(f)));
        i = Beb(MD(Utb(g)));
        e = true;
        do {
            if (h > i - a.b && h < i + a.b) return -1;
            else h > i - a.a && h < i + a.a && ++d;
            h <= i && f.b != f.d.c ? h = Beb(MD(Utb(f))) : i <= h && g.b != g.d.c ? i = Beb(MD(Utb(g))) : e = false;
        }while (e);
    }
    return d;
}
function JYc(a, b) {
    var c, d;
    f9c(a.a);
    i9c(a.a, (AYc(), yYc), yYc);
    i9c(a.a, zYc, zYc);
    d = new J9c;
    E9c(d, zYc, (jZc(), hZc));
    XD(ksd(b, (b_c(), L$c))) !== XD((j$c(), g$c)) && E9c(d, zYc, eZc);
    ydb(LD(ksd(b, W$c))) && E9c(d, zYc, iZc);
    E9c(d, zYc, fZc);
    ydb(LD(ksd(b, Y$c))) && C9c(d, zYc, gZc);
    c9c(a.a, d);
    c = d9c(a.a, b);
    return c;
}
function MOc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    i = 0;
    for(k = new rmb(a.a); k.a < k.c.c.length;){
        j = JD(pmb(k), 9);
        h = 0;
        for(f = new es(Ir(hYb(j).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            l = WYb(e.c).b;
            m = WYb(e.d).b;
            h = $wnd.Math.max(h, $wnd.Math.abs(m - l));
        }
        i = $wnd.Math.max(i, h);
    }
    g = d * $wnd.Math.min(1, b / c) * i;
    return g;
}
function r7b(a) {
    var b, c;
    for(c = new es(Ir(kYb(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        if (b.d.i.k != (DYb(), xYb)) throw scb(new Y8c(awe + fYb(a) + "' has its layer constraint set to LAST, but has at least one outgoing edge that " + ' does not go to a LAST_SEPARATE node. That must not happen.'));
    }
}
function MVc(a, b) {
    var c, d, e, f, g;
    g = JD(WMb(b, (kVc(), _Uc)), 422);
    for(f = Gtb(b.b, 0); f.b != f.d.c;){
        e = JD(Utb(f), 39);
        if (a.b[e.g] == 0) {
            switch(g.g){
                case 0:
                    NVc(a, e);
                    break;
                case 1:
                    LVc(a, e);
            }
            a.b[e.g] = 2;
        }
    }
    for(d = Gtb(a.a, 0); d.b != d.d.c;){
        c = JD(Utb(d), 65);
        ye(c.b.d, c, true);
        ye(c.c.b, c, true);
    }
    ZMb(b, (tUc(), nUc), a.a);
}
function Kne(a) {
    var b;
    b = new Igb;
    (a & 256) != 0 && (b.a += 'F', b);
    (a & 128) != 0 && (b.a += 'H', b);
    (a & 512) != 0 && (b.a += 'X', b);
    (a & 2) != 0 && (b.a += 'i', b);
    (a & 8) != 0 && (b.a += 'm', b);
    (a & 4) != 0 && (b.a += 's', b);
    (a & 32) != 0 && (b.a += 'u', b);
    (a & 64) != 0 && (b.a += 'w', b);
    (a & 16) != 0 && (b.a += 'x', b);
    (a & NEe) != 0 && (b.a += ',', b);
    return jgb(b.a);
}
function g0b(a, b, c, d, e) {
    var f, g, h, i;
    i = (f = JD(deb(v2), 10), new urb(f, JD(VCb(f, f.length), 10), 0));
    for(h = new rmb(a.j); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        if (b[g.p]) {
            h0b(g, b[g.p], d);
            orb(i, g.j);
        }
    }
    if (e) {
        l0b(a, b, (Rjd(), wjd), 2 * c, d);
        l0b(a, b, Qjd, 2 * c, d);
    } else {
        l0b(a, b, (Rjd(), xjd), 2 * c, d);
        l0b(a, b, Ojd, 2 * c, d);
    }
}
function k8b(a, b) {
    var c, d, e, f, g, h, i;
    e = new Ulb;
    for(c = 0; c <= a.j; c++){
        d = new b$b(b);
        d.p = a.j - c;
        YCb(e.c, d);
    }
    for(h = new rmb(a.p); h.a < h.c.c.length;){
        g = JD(pmb(h), 9);
        qYb(g, JD(Mlb(e, a.j - a.g[g.p]), 25));
    }
    f = new rmb(e);
    while(f.a < f.c.c.length){
        i = JD(pmb(f), 25);
        i.a.c.length == 0 && qmb(f);
    }
    b.b.c.length = 0;
    Klb(b.b, e);
}
function j3c(a, b) {
    var c, d, e, f, g, h;
    b.Sg($Ae, 1);
    e = JD(ksd(a, (k2c(), a2c)), 107);
    f = (!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a);
    g = O4c(f);
    h = $wnd.Math.max(g.a, Beb(MD(ksd(a, (h1c(), e1c)))) - (e.b + e.c));
    d = $wnd.Math.max(g.b, Beb(MD(ksd(a, b1c))) - (e.d + e.a));
    c = d - g.b;
    msd(a, Y0c, c);
    msd(a, $0c, h);
    msd(a, Z0c, d + c);
    b.Tg();
}
function hCd(a) {
    var b, c;
    if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i == 0) return dCd(a);
    else {
        b = JD(nDd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), 0), 168);
        RGd((!b.a && (b.a = new qVd(u3, b, 5)), b.a));
        qud(b, 0);
        rud(b, 0);
        jud(b, 0);
        kud(b, 0);
        c = (!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a);
        while(c.i > 1)UGd(c, c.i - 1);
        return b;
    }
}
function Kfe(a, b) {
    Ife();
    var c, d, e, f;
    if (!b) return Hfe;
    else if (b == (Ihe(), Fhe) || (b == nhe || b == lhe || b == mhe) && a != khe) return new Rfe(a, b);
    else {
        d = JD(b, 677);
        c = d.Xk();
        if (!c) {
            Vae(jae((Gfe(), Efe), b));
            c = d.Xk();
        }
        f = (!c.i && (c.i = new Irb), c.i);
        e = JD(Wd(fsb(f.f, a)), 1987);
        !e && Qib(f, a, e = new Rfe(a, b));
        return e;
    }
}
function iFb(a, b) {
    var c, d;
    d = fzb(a.b, b.b);
    if (!d) throw scb(new Web('Invalid hitboxes for scanline constraint calculation.'));
    (cFb(b.b, JD(hzb(a.b, b.b), 60)) || cFb(b.b, JD(gzb(a.b, b.b), 60))) && (Zgb(), String.fromCharCode(10));
    a.a[b.b.f] = JD(jzb(a.b, b.b), 60);
    c = JD(izb(a.b, b.b), 60);
    !!c && (a.a[c.f] = b.b);
}
function K8b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    i = JD(WMb(a, (Iqc(), kqc)), 11);
    j = Kdd(WC(OC(b2, 1), hre, 8, 0, [
        i.i.n,
        i.n,
        i.a
    ])).a;
    k = a.i.n.b;
    c = CXb(a.e);
    for(e = c, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        hWb(d, i);
        Ctb(d.a, new Edd(j, k));
        if (b) {
            h = JD(WMb(d, (Bwc(), Ruc)), 77);
            if (!h) {
                h = new Rdd;
                ZMb(d, Ruc, h);
            }
            Atb(h, new Edd(j, k));
        }
    }
}
function L8b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    e = JD(WMb(a, (Iqc(), kqc)), 11);
    j = Kdd(WC(OC(b2, 1), hre, 8, 0, [
        e.i.n,
        e.n,
        e.a
    ])).a;
    k = a.i.n.b;
    c = CXb(a.g);
    for(g = c, h = 0, i = g.length; h < i; ++h){
        f = g[h];
        gWb(f, e);
        Btb(f.a, new Edd(j, k));
        if (b) {
            d = JD(WMb(f, (Bwc(), Ruc)), 77);
            if (!d) {
                d = new Rdd;
                ZMb(f, Ruc, d);
            }
            Atb(d, new Edd(j, k));
        }
    }
}
function Yac(a) {
    var b, c, d, e, f, g, h, i, j;
    d = a.b;
    f = d.e;
    g = bjd(JD(WMb(d, (Bwc(), Evc)), 100));
    c = !!f && JD(WMb(f, (Iqc(), Wpc)), 22).Gc(($oc(), Toc));
    if (g || c) return;
    for(j = (h = new Zjb(a.e).a.vc().Jc(), new ckb(h)); j.a.Ob();){
        i = (b = JD(j.a.Pb(), 43), JD(b.kd(), 112));
        if (i.a) {
            e = i.d;
            _Yb(e, null);
            i.c = true;
            a.a = true;
        }
    }
}
function wbc(a, b) {
    var c, d, e, f;
    b.Sg('Semi-Interactive Crossing Minimization Processor', 1);
    c = false;
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        f = LBb(OBb(BBb(BBb(new RBb(null, new Gvb(d.a, 16)), new Bbc), new Dbc), new Fbc), new Jbc);
        c = c | f.a != null;
    }
    c && ZMb(a, (Iqc(), bqc), (xdb(), true));
    b.Tg();
}
function uEc(a, b) {
    var c, d, e, f, g, h;
    a.b = new Ulb;
    a.d = JD(WMb(b, (Iqc(), vqc)), 233);
    a.e = zvb(a.d);
    f = new Mtb;
    e = _u(WC(OC(MP, 1), Bve, 36, 0, [
        b
    ]));
    g = 0;
    while(g < e.c.length){
        d = (sDb(g, e.c.length), JD(e.c[g], 36));
        d.p = g++;
        c = new IDc(d, a.a, a.b);
        Klb(e, c.b);
        Ilb(a.b, c);
        c.s && (h = Gtb(f, 0), Stb(h, c));
    }
    a.c = new Qrb;
    return f;
}
function JJb(a, b) {
    var c, d, e, f, g, h;
    for(g = JD(JD(Qc(a.r, b), 22), 83).Jc(); g.Ob();){
        f = JD(g.Pb(), 115);
        c = f.c ? _Hb(f.c) : 0;
        if (c > 0) {
            if (f.a) {
                h = f.b.Kf().a;
                if (c > h) {
                    e = (c - h) / 2;
                    f.d.b = e;
                    f.d.c = e;
                }
            } else f.d.c = a.s + c;
        } else if (qjd(a.u)) {
            d = end(f.b);
            d.c < 0 && (f.d.b = -d.c);
            d.c + d.b > f.b.Kf().a && (f.d.c = d.c + d.b - f.b.Kf().a);
        }
    }
}
function UOc(a, b) {
    var c, d, e, f, g;
    g = new Ulb;
    c = b;
    do {
        f = JD(Nib(a.b, c), 132);
        f.B = c.c;
        f.D = c.d;
        YCb(g.c, f);
        c = JD(Nib(a.k, c), 18);
    }while (c);
    d = (sDb(0, g.c.length), JD(g.c[0], 132));
    d.j = true;
    d.A = JD(d.d.a.ec().Jc().Pb(), 18).c.i;
    e = JD(Mlb(g, g.c.length - 1), 132);
    e.q = true;
    e.C = JD(e.d.a.ec().Jc().Pb(), 18).d.i;
    return g;
}
function T1b(a) {
    var b, c;
    c = JD(WMb(a, (Bwc(), Uuc)), 171);
    b = JD(WMb(a, (Iqc(), $pc)), 312);
    if (c == (Oqc(), Kqc)) {
        ZMb(a, Uuc, Nqc);
        ZMb(a, $pc, (qpc(), ppc));
    } else if (c == Mqc) {
        ZMb(a, Uuc, Nqc);
        ZMb(a, $pc, (qpc(), npc));
    } else if (b == (qpc(), ppc)) {
        ZMb(a, Uuc, Kqc);
        ZMb(a, $pc, opc);
    } else if (b == npc) {
        ZMb(a, Uuc, Mqc);
        ZMb(a, $pc, opc);
    }
}
function gMc() {
    gMc = Zcb;
    eMc = new sMc;
    aMc = E9c(new J9c, (CQb(), zQb), (u5b(), S4b));
    dMc = C9c(E9c(new J9c, zQb, e5b), BQb, d5b);
    fMc = B9c(B9c(G9c(C9c(E9c(new J9c, xQb, o5b), BQb, n5b), AQb), m5b), p5b);
    bMc = C9c(E9c(E9c(E9c(new J9c, yQb, V4b), AQb, X4b), AQb, Y4b), BQb, W4b);
    cMc = C9c(E9c(E9c(new J9c, AQb, Y4b), AQb, D4b), BQb, C4b);
}
function KOc() {
    KOc = Zcb;
    FOc = E9c(C9c(new J9c, (CQb(), BQb), (u5b(), G4b)), zQb, S4b);
    JOc = B9c(B9c(G9c(C9c(E9c(new J9c, xQb, o5b), BQb, n5b), AQb), m5b), p5b);
    GOc = C9c(E9c(E9c(E9c(new J9c, yQb, V4b), AQb, X4b), AQb, Y4b), BQb, W4b);
    IOc = E9c(E9c(new J9c, zQb, e5b), BQb, d5b);
    HOc = C9c(E9c(E9c(new J9c, AQb, Y4b), AQb, D4b), BQb, C4b);
}
function hMc(a, b, c, d, e) {
    var f, g;
    if ((!eWb(b) && b.c.i.c == b.d.i.c || !rdd(Kdd(WC(OC(b2, 1), hre, 8, 0, [
        e.i.n,
        e.n,
        e.a
    ])), c)) && !eWb(b)) {
        b.c == e ? du(b.a, 0, new Fdd(c)) : Atb(b.a, new Fdd(c));
        if (d && !Orb(a.a, c)) {
            g = JD(WMb(b, (Bwc(), Ruc)), 77);
            if (!g) {
                g = new Rdd;
                ZMb(b, Ruc, g);
            }
            f = new Fdd(c);
            Dtb(g, f, g.c.b, g.c);
            Nrb(a.a, f);
        }
    }
}
function dt(a, b) {
    var c, d, e, f;
    f = Pcb(Fcb(yre, hfb(Pcb(Fcb(b == null ? 0 : tb(b), zre)), 15)));
    c = f & a.b.length - 1;
    e = null;
    for(d = a.b[c]; d; e = d, d = d.a)if (d.d == f && Hb(d.i, b)) {
        !e ? a.b[c] = d.a : e.a = d.a;
        Ps(JD(vub(d.c), 588), JD(vub(d.f), 588));
        Os(JD(vub(d.b), 226), JD(vub(d.e), 226));
        --a.f;
        ++a.e;
        return true;
    }
    return false;
}
function q7b(a) {
    var b, c;
    for(c = new es(Ir(hYb(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        if (b.c.i.k != (DYb(), xYb)) throw scb(new Y8c(awe + fYb(a) + "' has its layer constraint set to FIRST, but has at least one incoming edge that " + ' does not come from a FIRST_SEPARATE node. That must not happen.'));
    }
}
function Glc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    e = b ? new Plc : new Rlc;
    f = false;
    do {
        f = false;
        j = b ? dv(a.b) : a.b;
        for(i = j.Jc(); i.Ob();){
            h = JD(i.Pb(), 25);
            m = Zu(h.a);
            b || dv(m);
            for(l = new rmb(m); l.a < l.c.c.length;){
                k = JD(pmb(l), 9);
                if (e.Mb(k)) {
                    d = k;
                    c = JD(WMb(k, (Iqc(), Gpc)), 314);
                    g = b ? c.b : c.k;
                    f = Elc(d, g, b, false);
                }
            }
        }
    }while (f);
}
function xrd(a, b, c) {
    var d, e, f, g, h, i, j;
    e = Zeb(a.Db & 254);
    if (e == 0) a.Eb = c;
    else {
        if (e == 1) {
            h = SC(aJ, Nqe, 1, 2, 5, 1);
            f = Brd(a, b);
            if (f == 0) {
                h[0] = c;
                h[1] = a.Eb;
            } else {
                h[0] = a.Eb;
                h[1] = c;
            }
        } else {
            h = SC(aJ, Nqe, 1, e + 1, 5, 1);
            g = KD(a.Eb);
            for(d = 2, i = 0, j = 0; d <= 128; d <<= 1)d == b ? h[j++] = c : (a.Db & d) != 0 && (h[j++] = g[i++]);
        }
        a.Eb = h;
    }
    a.Db |= b;
}
function Bdc(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r;
    k = d;
    if (b.j && b.o) {
        n = JD(Nib(a.f, b.A), 60);
        p = n.d.c + n.d.b;
        --k;
    } else p = b.a.c + b.a.b;
    l = e;
    if (c.q && c.o) {
        n = JD(Nib(a.f, c.C), 60);
        j = n.d.c;
        ++l;
    } else j = c.a.c;
    q = j - p;
    i = $wnd.Math.max(2, l - k);
    h = q / i;
    o = p + h;
    for(m = k; m < l; ++m){
        g = JD(f.Xb(m), 132);
        r = g.a.b;
        g.a.c = o - r / 2;
        o += h;
    }
}
function vGc(a, b, c, d, e, f) {
    var g, h, i, j, k, l;
    j = c.c.length;
    f && (a.c = SC(cE, ise, 30, b.length, 15, 1));
    for(g = e ? 0 : b.length - 1; e ? g < b.length : g >= 0; g += e ? 1 : -1){
        h = b[g];
        i = d == (Rjd(), wjd) ? e ? lYb(h, d) : dv(lYb(h, d)) : e ? dv(lYb(h, d)) : lYb(h, d);
        f && (a.c[h.p] = i.gc());
        for(l = i.Jc(); l.Ob();){
            k = JD(l.Pb(), 11);
            a.d[k.p] = j++;
        }
        Klb(c, i);
    }
}
function DOc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    f = Beb(MD(a.b.Jc().Pb()));
    j = Beb(MD(br(b.b)));
    d = wdd(odd(a.a), j - c);
    e = wdd(odd(b.a), c - f);
    k = mdd(d, e);
    wdd(k, 1 / (j - f));
    this.a = k;
    this.b = new Ulb;
    h = true;
    g = a.b.Jc();
    g.Pb();
    while(g.Ob()){
        i = Beb(MD(g.Pb()));
        if (h && i - c > uze) {
            this.b.Ec(c);
            h = false;
        }
        this.b.Ec(i);
    }
    h && this.b.Ec(c);
}
function xGb(a) {
    var b, c, d, e;
    AGb(a, a.n);
    if (a.d.c.length > 0) {
        Emb(a.c);
        while(IGb(a, JD(pmb(new rmb(a.e.a)), 123)) < a.e.a.c.length){
            b = CGb(a);
            e = b.e.e - b.d.e - b.a;
            b.e.j && (e = -e);
            for(d = new rmb(a.e.a); d.a < d.c.c.length;){
                c = JD(pmb(d), 123);
                c.j && (c.e += e);
            }
            Emb(a.c);
        }
        Emb(a.c);
        FGb(a, JD(pmb(new rmb(a.e.a)), 123));
        tGb(a);
    }
}
function xBc(a, b, c) {
    var d, e, f, g, h;
    c.Sg('Longest path to source layering', 1);
    a.a = b;
    h = a.a.a;
    a.b = SC(cE, ise, 30, h.c.length, 15, 1);
    d = 0;
    for(g = new rmb(h); g.a < g.c.c.length;){
        e = JD(pmb(g), 9);
        e.p = d;
        a.b[d] = -1;
        ++d;
    }
    for(f = new rmb(h); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        zBc(a, e);
    }
    h.c.length = 0;
    a.a = null;
    a.b = null;
    c.Tg();
}
function C8c(a, b) {
    w8c();
    var c, d;
    c = Jad(Nad(), b.Ng());
    if (c) {
        d = c.j;
        if (RD(a, 206)) return _wd(JD(a, 27)) ? rrb(d, (lcd(), icd)) || rrb(d, jcd) : rrb(d, (lcd(), icd));
        else if (RD(a, 268)) return rrb(d, (lcd(), gcd));
        else if (RD(a, 193)) return rrb(d, (lcd(), kcd));
        else if (RD(a, 359)) return rrb(d, (lcd(), hcd));
    }
    return true;
}
function Xbe(a, b, c) {
    var d, e, f, g, h, i;
    e = c;
    f = e.Ik();
    if (Lfe(a.e, f)) {
        if (f.Pi()) {
            d = JD(a.g, 122);
            for(g = 0; g < a.i; ++g){
                h = d[g];
                if (pb(h, e) && g != b) throw scb(new Teb(MDe));
            }
        }
    } else {
        i = Kfe(a.e.zh(), f);
        d = JD(a.g, 122);
        for(g = 0; g < a.i; ++g){
            h = d[g];
            if (i.Zl(h.Ik()) && g != b) throw scb(new Teb(hGe));
        }
    }
    return JD(DCd(a, b, c), 74);
}
function _y(d, b) {
    if (b instanceof Object) try {
        b.__java$exception = d;
        if (navigator.userAgent.toLowerCase().indexOf('msie') != -1 && $doc.documentMode < 9) return;
        var c = d;
        Object.defineProperties(b, {
            cause: {
                get: function() {
                    var a = c.fe();
                    return a && a.de();
                }
            },
            suppressed: {
                get: function() {
                    return c.ee();
                }
            }
        });
    } catch (a) {}
}
function kib(a, b) {
    var c, d, e, f, g;
    d = b >> 5;
    b &= 31;
    if (d >= a.d) return a.e < 0 ? (Ghb(), Ahb) : (Ghb(), Fhb);
    f = a.d - d;
    e = SC(cE, ise, 30, f + 1, 15, 1);
    lib(e, f, a.a, d, b);
    if (a.e < 0) {
        for(c = 0; c < d && a.a[c] == 0; c++);
        if (c < d || b > 0 && a.a[c] << 32 - b != 0) {
            for(c = 0; c < f && e[c] == -1; c++)e[c] = 0;
            c == f && ++f;
            ++e[c];
        }
    }
    g = new Vhb(a.e, f, e);
    Ihb(g);
    return g;
}
function l$b(a, b, c, d) {
    var e, f, g, h, i;
    h = _Bd(JD(nDd((!b.b && (b.b = new ree(v3, b, 4, 7)), b.b), 0), 84));
    i = _Bd(JD(nDd((!b.c && (b.c = new ree(v3, b, 5, 8)), b.c), 0), 84));
    if (Zwd(h) == Zwd(i)) return null;
    if (kCd(i, h)) return null;
    g = Otd(b);
    if (g == c) return d;
    else {
        f = JD(Nib(a.a, g), 9);
        if (f) {
            e = f.e;
            if (e) return e;
        }
    }
    return null;
}
function e7b(a, b) {
    var c;
    c = JD(WMb(a, (Bwc(), xuc)), 281);
    b.Sg('Label side selection (' + c + ')', 1);
    switch(c.g){
        case 0:
            f7b(a, (oid(), kid));
            break;
        case 1:
            f7b(a, (oid(), lid));
            break;
        case 2:
            d7b(a, (oid(), kid));
            break;
        case 3:
            d7b(a, (oid(), lid));
            break;
        case 4:
            g7b(a, (oid(), kid));
            break;
        case 5:
            g7b(a, (oid(), lid));
    }
    b.Tg();
}
function Lfe(a, b) {
    Ife();
    var c, d, e;
    if (b.Gk()) return true;
    else if (b.Fk() == -2) {
        if (b == (ehe(), che) || b == _ge || b == ahe || b == bhe) return true;
        else {
            e = a.zh();
            if (WTd(e, b) >= 0) return false;
            else {
                c = Z9d((Gfe(), Efe), e, b);
                if (!c) return true;
                else {
                    d = c.Fk();
                    return (d > 1 || d == -1) && Tae(jae(Efe, c)) != 3;
                }
            }
        }
    } else return false;
}
function EEc(a, b, c) {
    var d, e, f, g, h, i;
    d = sEc(c, a.length);
    g = a[d];
    f = tEc(c, g.length);
    if (g[f].k != (DYb(), wYb)) return;
    i = b.j;
    for(e = 0; e < i.c.length; e++){
        h = (sDb(e, i.c.length), JD(i.c[e], 11));
        if ((c ? h.j == (Rjd(), wjd) : h.j == (Rjd(), Qjd)) && ydb(LD(WMb(h, (Iqc(), Zpc))))) {
            Rlb(i, e, JD(WMb(g[f], (Iqc(), kqc)), 11));
            f += c ? 1 : -1;
        }
    }
}
function C2c(a, b) {
    var c, d, e, f, g, h, i, j;
    b.Sg('Greedy Width Approximator', 1);
    c = Beb(MD(ksd(a, (k2c(), L1c))));
    i = JD(ksd(a, a2c), 107);
    f = JD(ksd(a, h2c), 385);
    g = ydb(LD(ksd(a, g2c)));
    h = Beb(MD(ksd(a, d2c)));
    j = (!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a);
    R4c(j);
    e = new v2c(c, f, g);
    d = r2c(e, j, h, i);
    msd(a, (h1c(), g1c), d.c);
    b.Tg();
}
function XFd(a) {
    if (a.g == null) switch(a.p){
        case 0:
            a.g = PFd(a) ? (xdb(), wdb) : (xdb(), vdb);
            break;
        case 1:
            a.g = Rdb(QFd(a));
            break;
        case 2:
            a.g = $db(RFd(a));
            break;
        case 3:
            a.g = SFd(a);
            break;
        case 4:
            a.g = new Keb(TFd(a));
            break;
        case 6:
            a.g = yfb(VFd(a));
            break;
        case 5:
            a.g = jfb(UFd(a));
            break;
        case 7:
            a.g = Ufb(WFd(a));
    }
    return a.g;
}
function eGd(a) {
    if (a.n == null) switch(a.p){
        case 0:
            a.n = YFd(a) ? (xdb(), wdb) : (xdb(), vdb);
            break;
        case 1:
            a.n = Rdb(ZFd(a));
            break;
        case 2:
            a.n = $db($Fd(a));
            break;
        case 3:
            a.n = _Fd(a);
            break;
        case 4:
            a.n = new Keb(aGd(a));
            break;
        case 6:
            a.n = yfb(cGd(a));
            break;
        case 5:
            a.n = jfb(bGd(a));
            break;
        case 7:
            a.n = Ufb(dGd(a));
    }
    return a.n;
}
function ibe(a, b, c, d) {
    var e, f, g, h, i;
    h = (Ife(), JD(b, 69).uk());
    if (Lfe(a.e, b)) {
        if (b.Pi() && ybe(a, b, d, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0)) throw scb(new Teb(MDe));
    } else {
        i = Kfe(a.e.zh(), b);
        e = JD(a.g, 122);
        for(g = 0; g < a.i; ++g){
            f = e[g];
            if (i.Zl(f.Ik())) throw scb(new Teb(hGe));
        }
    }
    sCd(a, Bbe(a, b, c), h ? JD(d, 74) : Jfe(b, d));
}
function GEb(a) {
    var b, c, d, e, f, g, h;
    for(f = new rmb(a.a.a); f.a < f.c.c.length;){
        d = JD(pmb(f), 317);
        d.g = 0;
        d.i = 0;
        d.e.a.$b();
    }
    for(e = new rmb(a.a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 317);
        for(c = d.a.a.ec().Jc(); c.Ob();){
            b = JD(c.Pb(), 60);
            for(h = b.c.Jc(); h.Ob();){
                g = JD(h.Pb(), 60);
                if (g.a != d) {
                    Nrb(d.e, g);
                    ++g.a.g;
                    ++g.a.i;
                }
            }
        }
    }
}
function h2b(a) {
    var b, c, d, e, f;
    e = JD(WMb(a, (Bwc(), ovc)), 22);
    f = JD(WMb(a, rvc), 22);
    c = new Edd(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
    b = new Fdd(c);
    if (e.Gc((ykd(), ukd))) {
        d = JD(WMb(a, qvc), 8);
        if (f.Gc((Nkd(), Gkd))) {
            d.a <= 0 && (d.a = 20);
            d.b <= 0 && (d.b = 20);
        }
        b.a = $wnd.Math.max(c.a, d.a);
        b.b = $wnd.Math.max(c.b, d.b);
    }
    i2b(a, c, b);
}
function aSb(a, b) {
    var c, d, e;
    b.a ? (fzb(a.b, b.b), a.a[b.b.i] = JD(jzb(a.b, b.b), 82), c = JD(izb(a.b, b.b), 82), !!c && (a.a[c.i] = b.b), undefined) : (d = JD(jzb(a.b, b.b), 82), !!d && d == a.a[b.b.i] && !!d.d && d.d != b.b.d && d.f.Ec(b.b), e = JD(izb(a.b, b.b), 82), !!e && a.a[e.i] == b.b && !!e.d && e.d != b.b.d && b.b.f.Ec(e), kzb(a.b, b.b), undefined);
}
function _7b(a, b) {
    var c, d, e, f, g, h;
    f = a.d;
    h = Beb(MD(WMb(a, (Bwc(), Fuc))));
    if (h < 0) {
        h = 0;
        ZMb(a, Fuc, h);
    }
    b.o.b = h;
    g = $wnd.Math.floor(h / 2);
    d = new bZb;
    aZb(d, (Rjd(), Qjd));
    _Yb(d, b);
    d.n.b = g;
    e = new bZb;
    aZb(e, wjd);
    _Yb(e, b);
    e.n.b = g;
    hWb(a, d);
    c = new kWb;
    UMb(c, a);
    ZMb(c, Ruc, null);
    gWb(c, e);
    hWb(c, f);
    $7b(b, a, c);
    Y7b(a, c);
    return c;
}
function XLc(a) {
    var b, c;
    c = JD(WMb(a, (Iqc(), Wpc)), 22);
    b = new J9c;
    if (c.Gc(($oc(), Uoc))) {
        D9c(b, RLc);
        D9c(b, TLc);
    }
    if (c.Gc(Woc) || ydb(LD(WMb(a, (Bwc(), Guc))))) {
        D9c(b, TLc);
        c.Gc(Xoc) && D9c(b, ULc);
    }
    c.Gc(Toc) && D9c(b, QLc);
    c.Gc(Zoc) && D9c(b, VLc);
    c.Gc(Voc) && D9c(b, SLc);
    c.Gc(Qoc) && D9c(b, OLc);
    c.Gc(Soc) && D9c(b, PLc);
    return b;
}
function Hib(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    d = a.d;
    f = b.d;
    h = d + f;
    i = a.e != b.e ? -1 : 1;
    if (h == 2) {
        k = Fcb(ucb(a.a[0], Use), ucb(b.a[0], Use));
        m = Pcb(k);
        l = Pcb(Lcb(k, 32));
        return l == 0 ? new Thb(i, m) : new Vhb(i, 2, WC(OC(cE, 1), ise, 30, 15, [
            m,
            l
        ]));
    }
    c = a.a;
    e = b.a;
    g = SC(cE, ise, 30, h, 15, 1);
    Eib(c, d, e, f, g);
    j = new Vhb(i, h, g);
    Ihb(j);
    return j;
}
function Ixb(a, b, c, d) {
    var e, f;
    if (!b) return c;
    else {
        e = a.a.Le(c.d, b.d);
        if (e == 0) {
            d.d = hkb(b, c.e);
            d.b = true;
            return b;
        }
        f = e < 0 ? 0 : 1;
        b.a[f] = Ixb(a, b.a[f], c, d);
        if (Jxb(b.a[f])) {
            if (Jxb(b.a[1 - f])) {
                b.b = true;
                b.a[0].b = false;
                b.a[1].b = false;
            } else Jxb(b.a[f].a[f]) ? b = Qxb(b, 1 - f) : Jxb(b.a[f].a[1 - f]) && (b = Pxb(b, 1 - f));
        }
    }
    return b;
}
function yHb(a, b, c) {
    var d, e, f, g;
    e = a.i;
    d = a.n;
    xHb(a, (iHb(), fHb), e.c + d.b, c);
    xHb(a, hHb, e.c + e.b - d.c - c[2], c);
    g = e.b - d.b - d.c;
    if (c[0] > 0) {
        c[0] += a.d;
        g -= c[0];
    }
    if (c[2] > 0) {
        c[2] += a.d;
        g -= c[2];
    }
    f = $wnd.Math.max(0, g);
    c[1] = $wnd.Math.max(c[1], g);
    xHb(a, gHb, e.c + d.b + c[0] - (c[1] - g) / 2, c);
    if (b == gHb) {
        a.c.b = f;
        a.c.c = e.c + d.b + (f - g) / 2;
    }
}
function NUb() {
    this.c = SC(aE, Rse, 30, (Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])).length, 15, 1);
    this.b = SC(aE, Rse, 30, WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ]).length, 15, 1);
    this.a = SC(aE, Rse, 30, WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ]).length, 15, 1);
    Cmb(this.c, Kse);
    Cmb(this.b, Lse);
    Cmb(this.a, Lse);
}
function Moe(a, b, c) {
    var d, e, f, g;
    if (b <= c) {
        e = b;
        f = c;
    } else {
        e = c;
        f = b;
    }
    d = 0;
    if (a.b == null) {
        a.b = SC(cE, ise, 30, 2, 15, 1);
        a.b[0] = e;
        a.b[1] = f;
        a.c = true;
    } else {
        d = a.b.length;
        if (a.b[d - 1] + 1 == e) {
            a.b[d - 1] = f;
            return;
        }
        g = SC(cE, ise, 30, d + 2, 15, 1);
        $gb(a.b, 0, g, 0, d);
        a.b = g;
        a.b[d - 1] >= e && (a.c = false, a.a = false);
        a.b[d++] = e;
        a.b[d] = f;
        a.c || Qoe(a);
    }
}
function lkc(a, b, c) {
    var d, e, f, g, h, i, j;
    j = b.d;
    a.a = new Vlb(j.c.length);
    a.c = new Irb;
    for(h = new rmb(j); h.a < h.c.c.length;){
        g = JD(pmb(h), 105);
        f = new XMc(null);
        Ilb(a.a, f);
        Qib(a.c, g, f);
    }
    a.b = new Irb;
    jkc(a, b);
    for(d = 0; d < j.c.length - 1; d++){
        i = JD(Mlb(b.d, d), 105);
        for(e = d + 1; e < j.c.length; e++)mkc(a, i, JD(Mlb(b.d, e), 105), c);
    }
}
function EHc(a, b) {
    var c, d, e, f, g, h, i;
    c = Lse;
    h = (DYb(), AYb);
    for(e = new rmb(b.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        f = d.k;
        if (f != AYb) {
            g = MD(WMb(d, (Iqc(), mqc)));
            if (g == null) {
                c = $wnd.Math.max(c, 0);
                d.n.b = c + dzc(a.a, f, h);
            } else d.n.b = (tDb(g), g);
        }
        i = dzc(a.a, f, h);
        d.n.b < c + i + d.d.d && (d.n.b = c + i + d.d.d);
        c = d.n.b + d.o.b + d.d.a;
        h = f;
    }
}
function TYc(a) {
    var b, c, d, e, f;
    e = new Ulb;
    b = new Srb((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a));
    for(d = new es(Ir($Bd(a).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 85);
        if (!RD(nDd((!c.b && (c.b = new ree(v3, c, 4, 7)), c.b), 0), 193)) {
            f = _Bd(JD(nDd((!c.c && (c.c = new ree(v3, c, 5, 8)), c.c), 0), 84));
            b.a._b(f) || YCb(e.c, f);
        }
    }
    return e;
}
function gme(a, b, c) {
    var d, e, f;
    a.e = c;
    a.d = 0;
    a.b = 0;
    a.f = 1;
    a.i = b;
    (a.e & 16) == 16 && (a.i = Pne(a.i));
    a.j = a.i.length;
    fme(a);
    f = jme(a);
    if (a.d != a.j) throw scb(new eme(qEd((a9d(), UDe))));
    if (a.g) {
        for(d = 0; d < a.g.a.c.length; d++){
            e = JD(Uwb(a.g, d), 575);
            if (a.f <= e.a) throw scb(new eme(qEd((a9d(), VDe))));
        }
        a.g.a.c.length = 0;
    }
    return f;
}
function A_b(a, b) {
    var c, d, e, f, g, h, i;
    b.Sg('Comment post-processing', 1);
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        d = new Ulb;
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            i = JD(WMb(g, (Iqc(), Hqc)), 15);
            c = JD(WMb(g, Fpc), 15);
            if (!!i || !!c) {
                B_b(g, i, c);
                !!i && Klb(d, i);
                !!c && Klb(d, c);
            }
        }
        Klb(e.a, d);
    }
    b.Tg();
}
function zZc(a, b, c, d, e) {
    var f, g, h, i, j, k;
    !!a.d && a.d.Eg(e);
    f = JD(e.Xb(0), 27);
    if (xZc(a, c, f, false)) return true;
    g = JD(e.Xb(e.gc() - 1), 27);
    if (xZc(a, d, g, true)) return true;
    if (sZc(a, e)) return true;
    for(k = e.Jc(); k.Ob();){
        j = JD(k.Pb(), 27);
        for(i = b.Jc(); i.Ob();){
            h = JD(i.Pb(), 27);
            if (rZc(a, j, h)) return true;
        }
    }
    return false;
}
function sqd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    m = b.c.length;
    l = (j = a.Eh(c), JD(j >= 0 ? a.Hh(j, false, true) : uqd(a, c, false), 61));
    n: for(f = l.Jc(); f.Ob();){
        e = JD(f.Pb(), 57);
        for(k = 0; k < m; ++k){
            g = (sDb(k, b.c.length), JD(b.c[k], 74));
            i = g.kd();
            h = g.Ik();
            d = e.Jh(h, false);
            if (i == null ? d != null : !pb(i, d)) continue n;
        }
        return e;
    }
    return null;
}
function w3b(a, b, c, d) {
    var e, f, g, h;
    e = JD(oYb(b, (Rjd(), Qjd)).Jc().Pb(), 11);
    f = JD(oYb(b, wjd).Jc().Pb(), 11);
    for(h = new rmb(a.j); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        while(g.e.c.length != 0)hWb(JD(Mlb(g.e, 0), 18), e);
        while(g.g.c.length != 0)gWb(JD(Mlb(g.g, 0), 18), f);
    }
    c || ZMb(b, (Iqc(), fqc), null);
    d || ZMb(b, (Iqc(), gqc), null);
}
function g7b(a, b) {
    var c, d, e, f, g, h, i;
    c = new nlb;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        i = true;
        d = 0;
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            switch(g.k.g){
                case 4:
                    ++d;
                case 1:
                    _kb(c, g);
                    break;
                case 0:
                    i7b(g, b);
                default:
                    c.b == c.c || h7b(c, d, i, false, b);
                    i = false;
                    d = 0;
            }
        }
        c.b == c.c || h7b(c, d, i, true, b);
    }
}
function f8b(a) {
    var b, c, d, e, f, g, h, i, j;
    a.a = new q_b;
    j = 0;
    e = 0;
    for(d = new rmb(a.i.b); d.a < d.c.c.length;){
        b = JD(pmb(d), 25);
        b.p = e;
        for(i = new rmb(b.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            h.p = j;
            ++j;
        }
        ++e;
    }
    f = a.r == (dyc(), Wxc);
    g = f ? b8b : a8b;
    for(c = new rmb(a.i.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        Slb(b.a, g);
        p_b(a.a, jfb(b.p), b.a);
    }
}
function lGc(a, b) {
    var c, d, e, f, g, h;
    c = 0;
    for(h = new rmb(b); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        bGc(a.b, a.d[g.p]);
        for(e = new xZb(g.b); omb(e.a) || omb(e.b);){
            d = JD(omb(e.a) ? pmb(e.a) : pmb(e.b), 18);
            f = DGc(a, g == d.c ? d.d : d.c);
            if (f > a.d[g.p]) {
                c += aGc(a.b, f);
                $kb(a.a, jfb(f));
            }
        }
        while(!elb(a.a))$Fc(a.b, JD(jlb(a.a), 17).a);
    }
    return c;
}
function O8c(a, b, c) {
    var d, e, f, g;
    f = (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i;
    for(e = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); e.e != e.i.gc();){
        d = JD(AHd(e), 27);
        (!d.a && (d.a = new X0d(A3, d, 10, 11)), d.a).i == 0 || (f += O8c(a, d, false));
    }
    if (c) {
        g = Zwd(b);
        while(g){
            f += (!g.a && (g.a = new X0d(A3, g, 10, 11)), g.a).i;
            g = Zwd(g);
        }
    }
    return f;
}
function UGd(a, b) {
    var c, d, e, f;
    if (a.Mj()) {
        d = null;
        e = a.Nj();
        a.Qj() && (d = a.Sj(a.Xi(b), null));
        c = a.Fj(4, f = qDd(a, b), null, b, e);
        if (a.Jj() && f != null) {
            d = a.Lj(f, d);
            if (!d) a.Gj(c);
            else {
                d.kj(c);
                d.lj();
            }
        } else if (!d) a.Gj(c);
        else {
            d.kj(c);
            d.lj();
        }
        return f;
    } else {
        f = qDd(a, b);
        if (a.Jj() && f != null) {
            d = a.Lj(f, null);
            !!d && d.lj();
        }
        return f;
    }
}
function WKb(a) {
    var b, c, d, e, f, g, h, i, j, k;
    j = a.a;
    b = new Qrb;
    i = 0;
    for(d = new rmb(a.d); d.a < d.c.c.length;){
        c = JD(pmb(d), 225);
        k = 0;
        hub(c.b, new ZKb);
        for(g = Gtb(c.b, 0); g.b != g.d.c;){
            f = JD(Utb(g), 225);
            if (b.a._b(f)) {
                e = c.c;
                h = f.c;
                k < h.d + h.a + j && k + e.a + j > h.d && (k = h.d + h.a + j);
            }
        }
        c.c.d = k;
        b.a.yc(c, b);
        i = $wnd.Math.max(i, c.c.d + c.c.a);
    }
    return i;
}
function p7b(a, b, c) {
    var d, e, f, g, h, i;
    for(g = JD(WMb(a, (Iqc(), Xpc)), 15).Jc(); g.Ob();){
        f = JD(g.Pb(), 9);
        switch(JD(WMb(f, (Bwc(), Uuc)), 171).g){
            case 2:
                qYb(f, b);
                break;
            case 4:
                qYb(f, c);
        }
        for(e = new es(Ir(eYb(f).a.Jc(), new er)); cs(e);){
            d = JD(ds(e), 18);
            if (!!d.c && !!d.d) continue;
            h = !d.d;
            i = JD(WMb(d, oqc), 11);
            h ? hWb(d, i) : gWb(d, i);
        }
    }
}
function $oc() {
    $oc = Zcb;
    Roc = new _oc('COMMENTS', 0);
    Toc = new _oc('EXTERNAL_PORTS', 1);
    Uoc = new _oc('HYPEREDGES', 2);
    Voc = new _oc('HYPERNODES', 3);
    Woc = new _oc('NON_FREE_PORTS', 4);
    Xoc = new _oc('NORTH_SOUTH_PORTS', 5);
    Zoc = new _oc(swe, 6);
    Qoc = new _oc('CENTER_LABELS', 7);
    Soc = new _oc('END_LABELS', 8);
    Yoc = new _oc('PARTITIONS', 9);
}
function HA(a, b, c, d, e) {
    if (d < 0) {
        d = wA(a, e, WC(OC(hJ, 1), hre, 2, 6, [
            Xre,
            Yre,
            Zre,
            $re,
            _re,
            ase,
            bse,
            cse,
            dse,
            ese,
            fse,
            gse
        ]), b);
        d < 0 && (d = wA(a, e, WC(OC(hJ, 1), hre, 2, 6, [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            _re,
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ]), b));
        if (d < 0) return false;
        c.k = d;
        return true;
    } else if (d > 0) {
        c.k = d - 1;
        return true;
    }
    return false;
}
function JA(a, b, c, d, e) {
    if (d < 0) {
        d = wA(a, e, WC(OC(hJ, 1), hre, 2, 6, [
            Xre,
            Yre,
            Zre,
            $re,
            _re,
            ase,
            bse,
            cse,
            dse,
            ese,
            fse,
            gse
        ]), b);
        d < 0 && (d = wA(a, e, WC(OC(hJ, 1), hre, 2, 6, [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            _re,
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ]), b));
        if (d < 0) return false;
        c.k = d;
        return true;
    } else if (d > 0) {
        c.k = d - 1;
        return true;
    }
    return false;
}
function LA(a, b, c, d, e, f) {
    var g, h, i, j;
    h = 32;
    if (d < 0) {
        if (b[0] >= a.length) return false;
        h = _fb(a, b[0]);
        if (h != 43 && h != 45) return false;
        ++b[0];
        d = zA(a, b);
        if (d < 0) return false;
        h == 45 && (d = -d);
    }
    if (h == 32 && b[0] - c == 2 && e.b == 2) {
        i = new mB;
        j = i.q.getFullYear() - hse + hse - 80;
        g = j % 100;
        f.a = d == g;
        d += (j / 100 | 0) * 100 + (d < g ? 100 : 0);
    }
    f.p = d;
    return true;
}
function f$b(a, b) {
    var c, d, e, f, g;
    if (!Zwd(a)) return;
    g = JD(WMb(b, (Bwc(), ovc)), 181);
    XD(ksd(a, Evc)) === XD((ajd(), _id)) && msd(a, Evc, $id);
    d = (Rod(), new dpd(Zwd(a)));
    f = new jpd(!Zwd(a) ? null : new dpd(Zwd(a)), a);
    e = RGb(d, f, false, true);
    orb(g, (ykd(), ukd));
    c = JD(WMb(b, qvc), 8);
    c.a = $wnd.Math.max(e.a, c.a);
    c.b = $wnd.Math.max(e.b, c.b);
}
function SYc(a) {
    var b, c, d, e, f, g;
    f = new Qrb;
    b = new Srb((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a));
    for(e = new es(Ir($Bd(a).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 85);
        if (!RD(nDd((!d.b && (d.b = new ree(v3, d, 4, 7)), d.b), 0), 193)) {
            g = _Bd(JD(nDd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c), 0), 84));
            b.a._b(g) || (c = f.a.yc(g, f), c);
        }
    }
    return f;
}
function Icd() {
    Icd = Zcb;
    Hcd = WC(OC(dE, 1), Nse, 30, 14, [
        1,
        1,
        2,
        6,
        24,
        120,
        720,
        5040,
        40320,
        362880,
        3628800,
        39916800,
        479001600,
        6227020800,
        87178291200,
        1307674368000,
        {
            l: 3506176,
            m: 794077,
            h: 1
        },
        {
            l: 884736,
            m: 916411,
            h: 20
        },
        {
            l: 3342336,
            m: 3912489,
            h: 363
        },
        {
            l: 589824,
            m: 3034138,
            h: 6914
        },
        {
            l: 3407872,
            m: 1962506,
            h: 138294
        }
    ]);
    $wnd.Math.pow(2, -65);
}
function Cib() {
    Cib = Zcb;
    var a, b;
    Aib = SC(lJ, hre, 90, 32, 0, 1);
    Bib = SC(lJ, hre, 90, 32, 0, 1);
    a = 1;
    for(b = 0; b <= 18; b++){
        Aib[b] = (Ghb(), vcb(a, 0) >= 0 ? aib(a) : Ohb(aib(Gcb(a))));
        Bib[b] = Bcb(Jcb(a, b), 0) ? aib(Jcb(a, b)) : Ohb(aib(Gcb(Jcb(a, b))));
        a = Fcb(a, 5);
    }
    for(; b < Bib.length; b++){
        Aib[b] = Nhb(Aib[b - 1], Aib[1]);
        Bib[b] = Nhb(Bib[b - 1], (Ghb(), Dhb));
    }
}
function H9b(a, b) {
    var c, d, e, f, g;
    if (a.c.length == 0) return new xod(jfb(0), jfb(0));
    c = (sDb(0, a.c.length), JD(a.c[0], 11)).j;
    g = 0;
    f = b.g;
    d = b.g + 1;
    while(g < a.c.length - 1 && c.g < f){
        ++g;
        c = (sDb(g, a.c.length), JD(a.c[g], 11)).j;
    }
    e = g;
    while(e < a.c.length - 1 && c.g < d){
        ++e;
        c = (sDb(g, a.c.length), JD(a.c[g], 11)).j;
    }
    return new xod(jfb(g), jfb(e));
}
function QDc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    i = lYb(b, c);
    (c == (Rjd(), Ojd) || c == Qjd) && (i = dv(i));
    g = false;
    do {
        e = false;
        for(f = 0; f < i.gc() - 1; f++){
            j = JD(i.Xb(f), 11);
            h = JD(i.Xb(f + 1), 11);
            if (RDc(a, j, h, d)) {
                g = true;
                FGc(a.a, JD(i.Xb(f), 11), JD(i.Xb(f + 1), 11));
                k = JD(i.Xb(f + 1), 11);
                i.fd(f + 1, JD(i.Xb(f), 11));
                i.fd(f, k);
                e = true;
            }
        }
    }while (e);
    return g;
}
function oTc(a, b, c) {
    var d, e, f, g;
    c.Sg(Hze, 1);
    e = JD(yBb(BBb(new RBb(null, new Gvb(b.b, 16)), new sTc), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    pTc(a, e, 0);
    for(g = Gtb(b.b, 0); g.b != g.d.c;){
        f = JD(Utb(g), 39);
        d = Nib(a.a, jfb(f.g)) != null ? JD(Nib(a.a, jfb(f.g)), 17).a : 0;
        ZMb(f, (kVc(), iVc), jfb(d));
    }
    c.Tg();
}
function rZc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    h = b.i - a.g / 2;
    i = c.i - a.g / 2;
    j = b.j - a.g / 2;
    k = c.j - a.g / 2;
    f = b.g + a.g;
    g = c.g + a.g;
    d = b.f + a.g;
    e = c.f + a.g;
    if (h < i + g && i < h && j < k + e && k < j) return true;
    else if (i < h + f && h < i && k < j + d && j < k) return true;
    else if (h < i + g && i < h && j < k && k < j + d) return true;
    else if (i < h + f && h < i && j < k + e && k < j) return true;
    return false;
}
function t6b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = b.c.length;
    g = (sDb(c, b.c.length), JD(b.c[c], 291));
    h = g.a.o.a;
    l = g.c;
    m = 0;
    for(j = g.c; j <= g.f; j++){
        if (h <= a.a[j]) return j;
        k = a.a[j];
        i = null;
        for(e = c + 1; e < f; e++){
            d = (sDb(e, b.c.length), JD(b.c[e], 291));
            d.c <= j && d.f >= j && (i = d);
        }
        !!i && (k = $wnd.Math.max(k, i.a.o.a));
        if (k > m) {
            l = j;
            m = k;
        }
    }
    return l;
}
function flc(a) {
    var b, c, d, e, f, g;
    for(c = new rmb(a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        f = false;
        g = false;
        for(e = new rmb(b.a); e.a < e.c.c.length;){
            d = JD(pmb(e), 9);
            if (!f && XMb(d, (Bwc(), _uc))) {
                ZMb(b, (Bwc(), _uc), JD(WMb(d, _uc), 17));
                f = true;
            }
            if (!g && XMb(d, (Bwc(), avc))) {
                ZMb(b, (Bwc(), avc), LD(WMb(d, avc)));
                g = true;
            }
            if (f && g) return;
        }
    }
}
function bLb(a) {
    var b, c, d, e, f, g, h;
    f = new mzb(JD(Qb(new pLb), 51));
    h = Lse;
    for(c = new rmb(a.d); c.a < c.c.c.length;){
        b = JD(pmb(c), 225);
        h = b.c.c;
        while(f.a.gc() != 0){
            g = JD(f.a.Rc(), 225);
            if (g.c.c + g.c.b < h) f.a.Ac(g);
            else break;
        }
        for(e = f.a.ec().Jc(); e.Ob();){
            d = JD(e.Pb(), 225);
            Atb(d.b, b);
            Atb(b.b, d);
        }
        f.a.yc(b, (xdb(), vdb));
    }
}
function vTc(a, b, c) {
    var d, e, f, g, h;
    if (!cr(b)) {
        h = c.bh((RD(b, 16) ? JD(b, 16).gc() : Gr(b.Jc())) / a.a | 0);
        h.Sg(Jze, 1);
        g = new yTc;
        f = null;
        for(e = b.Jc(); e.Ob();){
            d = JD(e.Pb(), 39);
            g = yl(WC(OC(VI, 1), Nqe, 20, 0, [
                g,
                new gRc(d)
            ]));
            if (f) {
                ZMb(f, (tUc(), oUc), d);
                ZMb(d, eUc, f);
                if (cRc(d) == cRc(f)) {
                    ZMb(f, pUc, d);
                    ZMb(d, fUc, f);
                }
            }
            f = d;
        }
        h.Tg();
        vTc(a, g, c);
    }
}
function UYd(a, b) {
    var c, d, e;
    if (b == null) for(d = (!a.a && (a.a = new X0d(d6, a, 9, 5)), new CHd(a.a)); d.e != d.i.gc();){
        c = JD(AHd(d), 679);
        e = c.c;
        if ((e == null ? c.zb : e) == null) return c;
    }
    else for(d = (!a.a && (a.a = new X0d(d6, a, 9, 5)), new CHd(a.a)); d.e != d.i.gc();){
        c = JD(AHd(d), 679);
        if (cgb(b, (e = c.c, e == null ? c.zb : e))) return c;
    }
    return null;
}
function MIb(a, b) {
    var c;
    c = null;
    switch(b.g){
        case 1:
            a.e.nf((Lgd(), Tfd)) && (c = JD(a.e.mf(Tfd), 255));
            break;
        case 3:
            a.e.nf((Lgd(), Ufd)) && (c = JD(a.e.mf(Ufd), 255));
            break;
        case 2:
            a.e.nf((Lgd(), Sfd)) && (c = JD(a.e.mf(Sfd), 255));
            break;
        case 4:
            a.e.nf((Lgd(), Vfd)) && (c = JD(a.e.mf(Vfd), 255));
    }
    !c && (c = JD(a.e.mf((Lgd(), Qfd)), 255));
    return c;
}
function b0c(a, b, c) {
    var d, e, f, g, h, i;
    e = c;
    f = 0;
    for(h = new rmb(b); h.a < h.c.c.length;){
        g = JD(pmb(h), 27);
        msd(g, (b_c(), S$c), jfb(e++));
        i = TYc(g);
        d = $wnd.Math.atan2(g.j + g.f / 2, g.i + g.g / 2);
        d += d < 0 ? $ze : 0;
        d < 0.7853981633974483 || d > BAe ? Slb(i, a.b) : d <= BAe && d > CAe ? Slb(i, a.d) : d <= CAe && d > DAe ? Slb(i, a.c) : d <= DAe && Slb(i, a.a);
        f = b0c(a, i, f);
    }
    return e;
}
function vNc(a, b, c, d) {
    var e, f, g, h, i, j;
    e = (d.c + d.a) / 2;
    Ltb(b.j);
    Atb(b.j, e);
    Ltb(c.e);
    Atb(c.e, e);
    j = new DNc;
    for(h = new rmb(a.f); h.a < h.c.c.length;){
        f = JD(pmb(h), 133);
        i = f.a;
        xNc(j, b, i);
        xNc(j, c, i);
    }
    for(g = new rmb(a.k); g.a < g.c.c.length;){
        f = JD(pmb(g), 133);
        i = f.b;
        xNc(j, b, i);
        xNc(j, c, i);
    }
    j.b += 2;
    j.a += qNc(b, a.q);
    j.a += qNc(a.q, c);
    return j;
}
function XVc(a, b, c) {
    var d;
    c.Sg('Processor arrange node', 1);
    ydb(LD(WMb(b, (kVc(), JUc))));
    d = JD(zub(CBb(BBb(new RBb(null, new Gvb(b.b, 16)), new fWc))), 39);
    a.a = JD(WMb(b, jVc), 350);
    a.a == (vVc(), tVc) || a.a == sVc ? WVc(a, new dnb(WC(OC(NZ, 1), Ize, 39, 0, [
        d
    ])), c.bh(1)) : a.a == rVc && VVc(a, new dnb(WC(OC(NZ, 1), Ize, 39, 0, [
        d
    ])), c.bh(1));
    c.Tg();
}
function XHb(a) {
    var b, c, d, e, f, g, h;
    c = a.i;
    b = a.n;
    h = c.d;
    a.f == (GIb(), EIb) ? h += (c.a - a.e.b) / 2 : a.f == DIb && (h += c.a - a.e.b);
    for(e = new rmb(a.d); e.a < e.c.c.length;){
        d = JD(pmb(e), 187);
        g = d.Kf();
        f = new Cdd;
        f.b = h;
        h += g.b + a.a;
        switch(a.b.g){
            case 0:
                f.a = c.c + b.b;
                break;
            case 1:
                f.a = c.c + b.b + (c.b - g.a) / 2;
                break;
            case 2:
                f.a = c.c + c.b - b.c - g.a;
        }
        d.Mf(f);
    }
}
function ZHb(a) {
    var b, c, d, e, f, g, h;
    c = a.i;
    b = a.n;
    h = c.c;
    a.b == (PHb(), MHb) ? h += (c.b - a.e.a) / 2 : a.b == OHb && (h += c.b - a.e.a);
    for(e = new rmb(a.d); e.a < e.c.c.length;){
        d = JD(pmb(e), 187);
        g = d.Kf();
        f = new Cdd;
        f.a = h;
        h += g.a + a.a;
        switch(a.f.g){
            case 0:
                f.b = c.d + b.d;
                break;
            case 1:
                f.b = c.d + b.d + (c.a - g.b) / 2;
                break;
            case 2:
                f.b = c.d + c.a - b.a - g.b;
        }
        d.Mf(f);
    }
}
function e1b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    k = c.a.c;
    g = c.a.c + c.a.b;
    f = JD(Nib(c.c, b), 454);
    n = f.f;
    o = f.a;
    i = new Edd(k, n);
    l = new Edd(g, o);
    e = k;
    c.p || (e += a.c);
    e += c.F + c.v * a.b;
    j = new Edd(e, n);
    m = new Edd(e, o);
    Mdd(b.a, WC(OC(b2, 1), hre, 8, 0, [
        i,
        j
    ]));
    h = c.d.a.gc() > 1;
    if (h) {
        d = new Edd(e, c.b);
        Atb(b.a, d);
    }
    Mdd(b.a, WC(OC(b2, 1), hre, 8, 0, [
        m,
        l
    ]));
}
function WAc(a, b, c) {
    var d, e;
    if (b < a.d.b.c.length) {
        a.b = JD(Mlb(a.d.b, b), 25);
        a.a = JD(Mlb(a.d.b, b - 1), 25);
        a.c = b;
    } else {
        a.a = new b$b(a.d);
        a.a.p = b - 1;
        Ilb(a.d.b, a.a);
        a.b = new b$b(a.d);
        a.b.p = b;
        Ilb(a.d.b, a.b);
        a.c = b;
    }
    qYb(c, a.b);
    for(e = new es(Ir(hYb(c).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        !d.c.i.c && d.c.i.k == (DYb(), xYb) && qYb(d.c.i, a.a);
    }
}
function oIc(a, b) {
    var c, d, e, f;
    for(f = lYb(b, (Rjd(), Ojd)).Jc(); f.Ob();){
        d = JD(f.Pb(), 11);
        c = JD(WMb(d, (Iqc(), sqc)), 9);
        !!c && DFb(GFb(FFb(HFb(EFb(new IFb, 0), 0.1), a.i[b.p].d), a.i[c.p].a));
    }
    for(e = lYb(b, xjd).Jc(); e.Ob();){
        d = JD(e.Pb(), 11);
        c = JD(WMb(d, (Iqc(), sqc)), 9);
        !!c && DFb(GFb(FFb(HFb(EFb(new IFb, 0), 0.1), a.i[c.p].d), a.i[b.p].a));
    }
}
function fkd(a) {
    Rad(a, new cad(nad(kad(mad(lad(new pad, rCe), 'ELK Randomizer'), 'Distributes the nodes randomly on the plane, leading to very obfuscating layouts. Can be useful to demonstrate the power of "real" layout algorithms.'), new ikd)));
    Pad(a, rCe, Rue, bkd);
    Pad(a, rCe, Mue, 15);
    Pad(a, rCe, Pue, jfb(0));
    Pad(a, rCe, Oue, Jue);
}
function _le() {
    _le = Zcb;
    var a, b, c, d, e, f;
    Zle = SC($D, ZCe, 30, 255, 15, 1);
    $le = SC(_D, Ure, 30, 16, 15, 1);
    for(b = 0; b < 255; b++)Zle[b] = -1;
    for(c = 57; c >= 48; c--)Zle[c] = c - 48 << 24 >> 24;
    for(d = 70; d >= 65; d--)Zle[d] = d - 65 + 10 << 24 >> 24;
    for(e = 102; e >= 97; e--)Zle[e] = e - 97 + 10 << 24 >> 24;
    for(f = 0; f < 10; f++)$le[f] = 48 + f & Wre;
    for(a = 10; a <= 15; a++)$le[a] = 65 + a - 10 & Wre;
}
function BSc(a, b) {
    b.Sg('Process graph bounds', 1);
    ZMb(a, (tUc(), aUc), Iub(SAb(GBb(new RBb(null, new Gvb(a.b, 16)), new GSc))));
    ZMb(a, cUc, Iub(SAb(GBb(new RBb(null, new Gvb(a.b, 16)), new ISc))));
    ZMb(a, _Tc, Iub(RAb(GBb(new RBb(null, new Gvb(a.b, 16)), new KSc))));
    ZMb(a, bUc, Iub(RAb(GBb(new RBb(null, new Gvb(a.b, 16)), new MSc))));
    b.Tg();
}
function ZPb(a) {
    var b, c, d, e, f;
    e = JD(WMb(a, (Bwc(), ovc)), 22);
    f = JD(WMb(a, rvc), 22);
    c = new Edd(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
    b = new Fdd(c);
    if (e.Gc((ykd(), ukd))) {
        d = JD(WMb(a, qvc), 8);
        if (f.Gc((Nkd(), Gkd))) {
            d.a <= 0 && (d.a = 20);
            d.b <= 0 && (d.b = 20);
        }
        b.a = $wnd.Math.max(c.a, d.a);
        b.b = $wnd.Math.max(c.b, d.b);
    }
    ydb(LD(WMb(a, pvc))) || $Pb(a, c, b);
}
function Idc(a) {
    var b, c, d, e, f, g, h;
    b = false;
    c = 0;
    for(e = new rmb(a.d.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        d.p = c++;
        for(g = new rmb(d.a); g.a < g.c.c.length;){
            f = JD(pmb(g), 9);
            !b && !cr(eYb(f)) && (b = true);
        }
    }
    h = nrb((Tgd(), Rgd), WC(OC(i2, 1), Ere, 86, 0, [
        Pgd,
        Qgd
    ]));
    if (!b) {
        orb(h, Sgd);
        orb(h, Ogd);
    }
    a.a = new cEb(h);
    Tib(a.f);
    Tib(a.b);
    Tib(a.e);
    Tib(a.g);
}
function JTd(a) {
    var b, c, d, e, f, g;
    if (!a.c) {
        g = new pWd;
        b = DTd;
        f = b.a.yc(a, b);
        if (f == null) {
            for(d = new CHd(OTd(a)); d.e != d.i.gc();){
                c = JD(AHd(d), 87);
                e = DZd(c);
                RD(e, 88) && vCd(g, JTd(JD(e, 29)));
                tCd(g, c);
            }
            b.a.Ac(a);
            b.a.gc() == 0 && undefined;
        }
        mWd(g);
        sDd(g);
        a.c = new gWd((JD(nDd(STd((GOd(), FOd).o), 15), 19), g.i), g.g);
        TTd(a).b &= -33;
    }
    return a.c;
}
function Yme(a) {
    var b;
    if (a.c != 10) throw scb(new eme(qEd((a9d(), WDe))));
    b = a.a;
    switch(b){
        case 110:
            b = 10;
            break;
        case 114:
            b = 13;
            break;
        case 116:
            b = 9;
            break;
        case 92:
        case 124:
        case 46:
        case 94:
        case 45:
        case 63:
        case 42:
        case 43:
        case 123:
        case 125:
        case 40:
        case 41:
        case 91:
        case 93:
            break;
        default:
            throw scb(new eme(qEd((a9d(), yEe))));
    }
    return b;
}
function yD(a) {
    var b, c, d, e, f;
    if (a.l == 0 && a.m == 0 && a.h == 0) return '0';
    if (a.h == Bse && a.m == 0 && a.l == 0) return '-9223372036854775808';
    if (a.h >> 19 != 0) return '-' + yD(pD(a));
    c = a;
    d = '';
    while(!(c.l == 0 && c.m == 0 && c.h == 0)){
        e = ZC(Ese);
        c = aD(c, e, true);
        b = '' + xD(YC);
        if (!(c.l == 0 && c.m == 0 && c.h == 0)) {
            f = 9 - b.length;
            for(; f > 0; f--)b = '0' + b;
        }
        d = b + d;
    }
    return d;
}
function usb() {
    if (!Object.create || !Object.getOwnPropertyNames) return false;
    var a = '__proto__';
    var b = Object.create(null);
    if (b[a] !== undefined) return false;
    var c = Object.getOwnPropertyNames(b);
    if (c.length != 0) return false;
    b[a] = 42;
    if (b[a] !== 42) return false;
    if (Object.getOwnPropertyNames(b).length == 0) return false;
    return true;
}
function mUb(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    d = c.c;
    e = c.d;
    h = WYb(b.c);
    i = WYb(b.d);
    if (d == b.c) {
        h = nUb(a, h, e);
        i = oUb(b.d);
    } else {
        h = oUb(b.c);
        i = nUb(a, i, e);
    }
    j = new Sdd(b.a);
    Dtb(j, h, j.a, j.a.a);
    Dtb(j, i, j.c.b, j.c);
    g = b.c == d;
    l = new OUb;
    for(f = 0; f < j.b - 1; ++f){
        k = new xod(JD(fu(j, f), 8), JD(fu(j, f + 1), 8));
        g && f == 0 || !g && f == j.b - 2 ? l.b = k : Ilb(l.a, k);
    }
    return l;
}
function eXb(a, b) {
    var c, d, e, f;
    f = a.j.g - b.j.g;
    if (f != 0) return f;
    c = JD(WMb(a, (Bwc(), Fvc)), 17);
    d = JD(WMb(b, Fvc), 17);
    if (!!c && !!d) {
        e = c.a - d.a;
        if (e != 0) return e;
    }
    switch(a.j.g){
        case 1:
            return Heb(a.n.a, b.n.a);
        case 2:
            return Heb(a.n.b, b.n.b);
        case 3:
            return Heb(b.n.a, a.n.a);
        case 4:
            return Heb(b.n.b, a.n.b);
        default:
            throw scb(new Web(Hve));
    }
}
function h3b(a, b, c, d) {
    var e, f, g, h, i;
    if (Gr((e3b(), new es(Ir(eYb(b).a.Jc(), new er)))) >= a.a) return -1;
    if (!g3b(b, c)) return -1;
    if (cr(JD(d.Kb(b), 20))) return 1;
    e = 0;
    for(g = JD(d.Kb(b), 20).Jc(); g.Ob();){
        f = JD(g.Pb(), 18);
        i = f.c.i == b ? f.d.i : f.c.i;
        h = h3b(a, i, c, d);
        if (h == -1) return -1;
        e = $wnd.Math.max(e, h);
        if (e > a.c - 1) return -1;
    }
    return e + 1;
}
function k2c() {
    k2c = Zcb;
    L1c = new NBd((Lgd(), Qed), 1.3);
    U1c = new NBd(Dfd, (xdb(), false));
    b2c = new MYb(15);
    a2c = new NBd(Kfd, b2c);
    d2c = new NBd(wgd, 15);
    M1c = Xed;
    T1c = Bfd;
    V1c = Efd;
    W1c = Gfd;
    S1c = zfd;
    X1c = Jfd;
    c2c = agd;
    h2c = (I1c(), D1c);
    g2c = C1c;
    j2c = H1c;
    i2c = F1c;
    _1c = x1c;
    $1c = w1c;
    Z1c = v1c;
    f2c = A1c;
    P1c = nfd;
    Q1c = ofd;
    O1c = s1c;
    N1c = r1c;
    R1c = t1c;
    e2c = z1c;
    Y1c = u1c;
}
function yCd(a, b) {
    var c, d, e, f, g, h;
    if (XD(b) === XD(a)) return true;
    if (!RD(b, 15)) return false;
    d = JD(b, 15);
    h = a.gc();
    if (d.gc() != h) return false;
    g = d.Jc();
    if (a.Vi()) for(c = 0; c < h; ++c){
        e = a.Si(c);
        f = g.Pb();
        if (e == null ? f != null : !pb(e, f)) return false;
    }
    else for(c = 0; c < h; ++c){
        e = a.Si(c);
        f = g.Pb();
        if (XD(e) !== XD(f)) return false;
    }
    return true;
}
function oJd(a, b) {
    var c, d, e, f, g, h;
    if (a.f > 0) {
        a.Yj();
        if (b != null) for(f = 0; f < a.d.length; ++f){
            c = a.d[f];
            if (c) {
                d = JD(c.g, 371);
                h = c.i;
                for(g = 0; g < h; ++g){
                    e = d[g];
                    if (pb(b, e.kd())) return true;
                }
            }
        }
        else for(f = 0; f < a.d.length; ++f){
            c = a.d[f];
            if (c) {
                d = JD(c.g, 371);
                h = c.i;
                for(g = 0; g < h; ++g){
                    e = d[g];
                    if (XD(b) === XD(e.kd())) return true;
                }
            }
        }
    }
    return false;
}
function N9d(a, b) {
    var c, d, e;
    c = b.mi(a.a);
    if (c) {
        e = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), 'affiliation'));
        if (e != null) {
            d = kgb(e, wgb(35));
            return d == -1 ? eae(a, nae(a, WSd(b.nk())), e) : d == 0 ? eae(a, null, (ADb(1, e.length + 1), e.substr(1))) : eae(a, (zDb(0, d, e.length), e.substr(0, d)), (ADb(d + 1, e.length + 1), e.substr(d + 1)));
        }
    }
    return null;
}
function Dic() {
    Dic = Zcb;
    wic = new Eic('NORTH', 0, (Rjd(), xjd), xjd);
    zic = new Eic('SOUTH', 1, Ojd, Ojd);
    vic = new Eic('EAST', 2, wjd, wjd);
    Cic = new Eic('WEST', 3, Qjd, Qjd);
    yic = new Eic('NORTH_WEST_CORNER', 4, Qjd, xjd);
    xic = new Eic('NORTH_EAST_CORNER', 5, xjd, wjd);
    Bic = new Eic('SOUTH_WEST_CORNER', 6, Ojd, Qjd);
    Aic = new Eic('SOUTH_EAST_CORNER', 7, wjd, Ojd);
}
function H2b(a, b, c) {
    var d, e, f, g;
    c.Sg('Orthogonally routing hierarchical port edges', 1);
    a.a = 0;
    d = K2b(b);
    N2b(b, d);
    M2b(a, b, d);
    I2b(b);
    e = JD(WMb(b, (Bwc(), Evc)), 100);
    f = b.b;
    G2b((sDb(0, f.c.length), JD(f.c[0], 25)), e, b);
    G2b(JD(Mlb(f, f.c.length - 1), 25), e, b);
    g = b.b;
    E2b((sDb(0, g.c.length), JD(g.c[0], 25)));
    E2b(JD(Mlb(g, g.c.length - 1), 25));
    c.Tg();
}
function lvd(a) {
    switch(a){
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return a - 48 << 24 >> 24;
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
            return a - 97 + 10 << 24 >> 24;
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
            return a - 65 + 10 << 24 >> 24;
        default:
            throw scb(new Mfb('Invalid hexadecimal'));
    }
}
function Elc(a, b, c, d) {
    var e, f, g, h, i, j;
    i = Jlc(a, c);
    j = Jlc(b, c);
    e = false;
    while(!!i && !!j){
        if (d || Hlc(i, j, c)) {
            g = Jlc(i, c);
            h = Jlc(j, c);
            Mlc(b);
            Mlc(a);
            f = i.c;
            U7b(i, false);
            U7b(j, false);
            if (c) {
                pYb(b, j.p, f);
                b.p = j.p;
                pYb(a, i.p + 1, f);
                a.p = i.p;
            } else {
                pYb(a, i.p, f);
                a.p = i.p;
                pYb(b, j.p + 1, f);
                b.p = j.p;
            }
            qYb(i, null);
            qYb(j, null);
            i = g;
            j = h;
            e = true;
        } else break;
    }
    return e;
}
function dxc(a) {
    switch(a.g){
        case 0:
            return new $Bc;
        case 1:
            return new sBc;
        case 3:
            return new JAc;
        case 4:
            return new jBc;
        case 5:
            return new mCc;
        case 6:
            return new LBc;
        case 2:
            return new ABc;
        case 7:
            return new sAc;
        case 8:
            return new _Ac;
        default:
            throw scb(new Teb('No implementation is available for the layerer ' + (a.f != null ? a.f : '' + a.g)));
    }
}
function wCc(a, b, c, d) {
    var e, f, g, h, i;
    e = false;
    f = false;
    for(h = new rmb(d.j); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        XD(WMb(g, (Iqc(), kqc))) === XD(c) && (g.g.c.length == 0 ? g.e.c.length == 0 || (e = true) : f = true);
    }
    i = 0;
    e && e ^ f ? i = c.j == (Rjd(), xjd) ? -a.e[d.c.p][d.p] : b - a.e[d.c.p][d.p] : f && e ^ f ? i = a.e[d.c.p][d.p] + 1 : e && f && (i = c.j == (Rjd(), xjd) ? 0 : b / 2);
    return i;
}
function GNd(a, b, c, d, e, f, g, h) {
    var i, j, k;
    i = 0;
    b != null && (i ^= fgb(b.toLowerCase()));
    c != null && (i ^= fgb(c));
    d != null && (i ^= fgb(d));
    g != null && (i ^= fgb(g));
    h != null && (i ^= fgb(h));
    for(j = 0, k = f.length; j < k; j++)i ^= fgb(f[j]);
    a ? i |= 256 : i &= -257;
    e ? i |= 16 : i &= -17;
    this.f = i;
    this.i = b == null ? null : (tDb(b), b);
    this.a = c;
    this.d = d;
    this.j = f;
    this.g = g;
    this.e = h;
}
function nYb(a, b, c) {
    var d, e;
    e = null;
    switch(b.g){
        case 1:
            e = (VYb(), QYb);
            break;
        case 2:
            e = (VYb(), SYb);
    }
    d = null;
    switch(c.g){
        case 1:
            d = (VYb(), RYb);
            break;
        case 2:
            d = (VYb(), PYb);
            break;
        case 3:
            d = (VYb(), TYb);
            break;
        case 4:
            d = (VYb(), UYb);
    }
    return !!e && !!d ? _q(a.j, new Yb(new dnb(WC(OC(hE, 1), Nqe, 177, 0, [
        JD(Qb(e), 177),
        JD(Qb(d), 177)
    ])))) : (pnb(), pnb(), mnb);
}
function W1b(a) {
    var b, c, d;
    b = JD(WMb(a, (Bwc(), qvc)), 8);
    ZMb(a, qvc, new Edd(b.b, b.a));
    switch(JD(WMb(a, Rtc), 254).g){
        case 1:
            ZMb(a, Rtc, (ced(), bed));
            break;
        case 2:
            ZMb(a, Rtc, (ced(), Zdd));
            break;
        case 3:
            ZMb(a, Rtc, (ced(), _dd));
            break;
        case 4:
            ZMb(a, Rtc, (ced(), aed));
    }
    if ((!a.q ? (pnb(), pnb(), nnb) : a.q)._b(Lvc)) {
        c = JD(WMb(a, Lvc), 8);
        d = c.a;
        c.a = c.b;
        c.b = d;
    }
}
function mgc(a, b, c, d, e, f) {
    this.b = c;
    this.d = e;
    if (a >= b.length) throw scb(new mdb('Greedy SwitchDecider: Free layer not in graph.'));
    this.c = b[a];
    this.e = new GGc(d);
    uGc(this.e, this.c, (Rjd(), Qjd));
    this.i = new GGc(d);
    uGc(this.i, this.c, wjd);
    this.f = new hgc(this.c);
    this.a = !f && e.i && !e.s && this.c[0].k == (DYb(), wYb);
    this.a && kgc(this, a, b.length);
}
function jKb(a, b) {
    var c, d, e, f, g, h;
    f = !a.B.Gc((Nkd(), Ekd));
    g = a.B.Gc(Hkd);
    a.a = new HHb(g, f, a.c);
    !!a.n && MXb(a.a.n, a.n);
    nIb(a.g, (iHb(), gHb), a.a);
    if (!b) {
        d = new oIb(1, f, a.c);
        d.n.a = a.k;
        Lqb(a.p, (Rjd(), xjd), d);
        e = new oIb(1, f, a.c);
        e.n.d = a.k;
        Lqb(a.p, Ojd, e);
        h = new oIb(0, f, a.c);
        h.n.c = a.k;
        Lqb(a.p, Qjd, h);
        c = new oIb(0, f, a.c);
        c.n.b = a.k;
        Lqb(a.p, wjd, c);
    }
}
function Pdc(a) {
    var b, c, d;
    b = JD(WMb(a.d, (Bwc(), yuc)), 220);
    switch(b.g){
        case 2:
            c = Gdc(a);
            break;
        case 3:
            c = (d = new Ulb, EBb(BBb(FBb(DBb(DBb(new RBb(null, new Gvb(a.d.b, 16)), new Vec), new Xec), new Zec), new _dc), new _ec(d)), d);
            break;
        default:
            throw scb(new Web('Compaction not supported for ' + b + ' edges.'));
    }
    Odc(a, c);
    ofb(new Ojb(a.g), new zec(a));
}
function tSc(a, b) {
    var c, d, e, f, g, h, i;
    b.Sg('Process directions', 1);
    c = JD(WMb(a, (kVc(), KUc)), 86);
    if (c != (Tgd(), Ogd)) for(e = Gtb(a.b, 0); e.b != e.d.c;){
        d = JD(Utb(e), 39);
        h = JD(WMb(d, (tUc(), rUc)), 17).a;
        i = JD(WMb(d, sUc), 17).a;
        switch(c.g){
            case 4:
                i *= -1;
                break;
            case 1:
                f = h;
                h = i;
                i = f;
                break;
            case 2:
                g = h;
                h = -i;
                i = g;
        }
        ZMb(d, rUc, jfb(h));
        ZMb(d, sUc, jfb(i));
    }
    b.Tg();
}
function kUb(a) {
    var b, c, d, e, f, g, h, i;
    i = new wUb;
    for(h = new rmb(a.a); h.a < h.c.c.length;){
        g = JD(pmb(h), 9);
        if (g.k == (DYb(), wYb)) continue;
        iUb(i, g, new Cdd);
        for(f = new es(Ir(kYb(g).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            if (e.c.i.k == wYb || e.d.i.k == wYb) continue;
            for(d = Gtb(e.a, 0); d.b != d.d.c;){
                c = JD(Utb(d), 8);
                b = c;
                uUb(i, new oSb(b.a, b.b));
            }
        }
    }
    return i;
}
function $6c() {
    $6c = Zcb;
    Z6c = new KBd(fBe);
    Y6c = (p7c(), o7c);
    X6c = new MBd(kBe, Y6c);
    W6c = (A7c(), z7c);
    V6c = new MBd(gBe, W6c);
    U6c = (l6c(), h6c);
    T6c = new MBd(hBe, U6c);
    P6c = new MBd(iBe, null);
    S6c = (a6c(), $5c);
    R6c = new MBd(jBe, S6c);
    L6c = (I5c(), H5c);
    K6c = new MBd(lBe, L6c);
    M6c = new MBd(mBe, (xdb(), false));
    N6c = new MBd(nBe, jfb(64));
    O6c = new MBd(oBe, true);
    Q6c = _5c;
}
function hBc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    a.p = 1;
    e = a.c;
    l = new wtb;
    for(k = mYb(a, (Eyc(), Cyc)).Jc(); k.Ob();){
        j = JD(k.Pb(), 11);
        for(d = new rmb(j.g); d.a < d.c.c.length;){
            c = JD(pmb(d), 18);
            i = c.d.i;
            if (a != i) {
                f = i.c;
                if (f.p <= e.p) {
                    g = e.p + 1;
                    if (g == b.b.c.length) {
                        h = new b$b(b);
                        h.p = g;
                        Ilb(b.b, h);
                        qYb(i, h);
                    } else {
                        h = JD(Mlb(b.b, g), 25);
                        qYb(i, h);
                    }
                    l.a.yc(i, l);
                }
            }
        }
    }
    return l;
}
function pRc(a, b) {
    var c, d;
    c = JD(WMb(a, (tUc(), WTc)), 15);
    if (!c || c.gc() < 1) return null;
    else if (c.gc() == 1) return JD(c.Xb(0), 39);
    d = null;
    switch(b.g){
        case 2:
            d = JD(zub(JBb(c.Mc(), new pSc)), 39);
            break;
        case 1:
            d = JD(zub(IBb(c.Mc(), new NRc)), 39);
            break;
        case 4:
            d = JD(zub(JBb(c.Mc(), new RRc)), 39);
            break;
        case 3:
            d = JD(zub(IBb(c.Mc(), new VRc)), 39);
    }
    return d;
}
function emc(a) {
    var b, c, d, e, f, g;
    if (a.a != null) return;
    a.a = SC(pcb, Vte, 30, a.c.b.c.length, 16, 1);
    a.a[0] = false;
    if (XMb(a.c, (Bwc(), zwc))) {
        d = JD(WMb(a.c, zwc), 15);
        for(c = d.Jc(); c.Ob();){
            b = JD(c.Pb(), 17).a;
            b > 0 && b < a.a.length && (a.a[b] = false);
        }
    } else {
        g = new rmb(a.c.b);
        g.a < g.c.c.length && pmb(g);
        e = 1;
        while(g.a < g.c.c.length){
            f = JD(pmb(g), 25);
            a.a[e++] = hmc(f);
        }
    }
}
function h1c() {
    h1c = Zcb;
    Y0c = new KBd('additionalHeight');
    Z0c = new KBd('drawingHeight');
    $0c = new KBd('drawingWidth');
    b1c = new KBd('minHeight');
    e1c = new KBd('minWidth');
    f1c = new KBd('rows');
    g1c = new KBd('targetWidth');
    d1c = new LBd('minRowIncrease', 0);
    a1c = new LBd('maxRowIncrease', 0);
    c1c = new LBd('minRowDecrease', 0);
    _0c = new LBd('maxRowDecrease', 0);
}
function MVd(a, b) {
    var c, d, e, f;
    e = a.b;
    switch(b){
        case 1:
            a.b |= 1;
            a.b |= 4;
            a.b |= 8;
            break;
        case 2:
            a.b |= 2;
            a.b |= 4;
            a.b |= 8;
            break;
        case 4:
            a.b |= 1;
            a.b |= 2;
            a.b |= 4;
            a.b |= 8;
            break;
        case 3:
            a.b |= 16;
            a.b |= 8;
            break;
        case 0:
            a.b |= 32;
            a.b |= 16;
            a.b |= 8;
            a.b |= 1;
            a.b |= 2;
            a.b |= 4;
            break;
    }
    if (a.b != e && !!a.c) for(d = new CHd(a.c); d.e != d.i.gc();){
        f = JD(AHd(d), 468);
        c = TTd(f);
        QVd(c, b);
    }
}
function FEc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    e = false;
    for(g = b, h = 0, i = g.length; h < i; ++h){
        f = g[h];
        ydb((xdb(), f.e ? true : false)) && !JD(Mlb(a.b, f.e.p), 217).s && (e = e | (j = f.e, k = JD(Mlb(a.b, j.p), 217), l = k.e, m = tEc(c, l.length), n = l[m][0], n.k == (DYb(), wYb) ? l[m] = DEc(f, l[m], c ? (Rjd(), Qjd) : (Rjd(), wjd)) : k.c.kg(l, c), o = GEc(a, k, c, d), EEc(k.e, k.o, c), o));
    }
    return e;
}
function P8c(a, b) {
    var c, d, e, f, g;
    f = (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i;
    for(e = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); e.e != e.i.gc();){
        d = JD(AHd(e), 27);
        if (XD(ksd(d, (Lgd(), ifd))) !== XD((eid(), did))) {
            g = JD(ksd(b, igd), 149);
            c = JD(ksd(d, igd), 149);
            (g == c || !!g && aad(g, c)) && (!d.a && (d.a = new X0d(A3, d, 10, 11)), d.a).i != 0 && (f += P8c(a, d));
        }
    }
    return f;
}
function P_b(a) {
    var b, c, d, e, f;
    f = new Vlb(a.a.c.length);
    for(e = new rmb(a.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        c = JD(WMb(d, (Bwc(), Uuc)), 171);
        b = null;
        switch(c.g){
            case 1:
            case 2:
                b = (Tnc(), Snc);
                break;
            case 3:
            case 4:
                b = (Tnc(), Qnc);
        }
        if (b) {
            ZMb(d, (Iqc(), Npc), (Tnc(), Snc));
            b == Qnc ? R_b(d, c, (Eyc(), Byc)) : b == Snc && R_b(d, c, (Eyc(), Cyc));
        } else YCb(f.c, d);
    }
    return f;
}
function qic(a) {
    var b, c, d, e, f, g, h;
    d = 0;
    h = 0;
    for(g = new rmb(a.d); g.a < g.c.c.length;){
        f = JD(pmb(g), 105);
        e = JD(yBb(BBb(new RBb(null, new Gvb(f.j, 16)), new _ic), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
            (lAb(), jAb)
        ]))), 15);
        c = null;
        if (d <= h) {
            c = (Rjd(), xjd);
            d += e.gc();
        } else if (h < d) {
            c = (Rjd(), Ojd);
            h += e.gc();
        }
        b = c;
        EBb(FBb(e.Mc(), new Pic), new Ric(b));
    }
}
function A8c(a, b) {
    var c;
    c = new $Mb;
    !!b && UMb(c, JD(Nib(a.a, y3), 102));
    RD(b, 273) && UMb(c, JD(Nib(a.a, C3), 102));
    if (RD(b, 359)) {
        UMb(c, JD(Nib(a.a, z3), 102));
        return c;
    }
    RD(b, 84) && UMb(c, JD(Nib(a.a, v3), 102));
    if (RD(b, 206)) {
        UMb(c, JD(Nib(a.a, A3), 102));
        return c;
    }
    if (RD(b, 193)) {
        UMb(c, JD(Nib(a.a, B3), 102));
        return c;
    }
    RD(b, 268) && UMb(c, JD(Nib(a.a, x3), 102));
    return c;
}
function phc(a) {
    var b, c, d, e, f, g, h, i;
    a.b = new fj(new dnb((Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ]))), new dnb((Ihc(), WC(OC(EU, 1), Ere, 365, 0, [
        Hhc,
        Ghc,
        Fhc
    ]))));
    for(g = WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ]), h = 0, i = g.length; h < i; ++h){
        f = g[h];
        for(c = WC(OC(EU, 1), Ere, 365, 0, [
            Hhc,
            Ghc,
            Fhc
        ]), d = 0, e = c.length; d < e; ++d){
            b = c[d];
            $i(a.b, f, b, new Ulb);
        }
    }
}
function MJb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    g = JD(JD(Qc(a.r, b), 22), 83);
    h = a.u.Gc((ojd(), mjd));
    c = a.u.Gc(jjd);
    d = a.u.Gc(ijd);
    j = a.u.Gc(njd);
    l = a.B.Gc((Nkd(), Mkd));
    k = !c && !d && (j || g.gc() == 2);
    JJb(a, b);
    e = null;
    i = null;
    if (h) {
        f = g.Jc();
        e = JD(f.Pb(), 115);
        i = e;
        while(f.Ob())i = JD(f.Pb(), 115);
        e.d.b = 0;
        i.d.c = 0;
        k && !e.a && (e.d.c = 0);
    }
    if (l) {
        NJb(g);
        if (h) {
            e.d.b = 0;
            i.d.c = 0;
        }
    }
}
function UKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    g = JD(JD(Qc(a.r, b), 22), 83);
    h = a.u.Gc((ojd(), mjd));
    c = a.u.Gc(jjd);
    d = a.u.Gc(ijd);
    i = a.u.Gc(njd);
    l = a.B.Gc((Nkd(), Mkd));
    j = !c && !d && (i || g.gc() == 2);
    SKb(a, b);
    k = null;
    e = null;
    if (h) {
        f = g.Jc();
        k = JD(f.Pb(), 115);
        e = k;
        while(f.Ob())e = JD(f.Pb(), 115);
        k.d.d = 0;
        e.d.a = 0;
        j && !k.a && (k.d.a = 0);
    }
    if (l) {
        VKb(g);
        if (h) {
            k.d.d = 0;
            e.d.a = 0;
        }
    }
}
function RHc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    e = b.k;
    if (b.p >= 0) return false;
    else {
        b.p = c.b;
        Ilb(c.e, b);
    }
    if (e == (DYb(), yYb) || e == BYb) for(g = new rmb(b.j); g.a < g.c.c.length;){
        f = JD(pmb(g), 11);
        for(k = (d = new rmb(new lZb(f).a.g), new oZb(d)); omb(k.a);){
            j = JD(pmb(k.a), 18).d;
            h = j.i;
            i = h.k;
            if (b.c != h.c) {
                if (i == yYb || i == BYb) {
                    if (RHc(a, h, c)) return true;
                }
            }
        }
    }
    return true;
}
function _Rd(a) {
    var b;
    if ((a.Db & 64) != 0) return xRd(a);
    b = new Jgb(xRd(a));
    b.a += ' (changeable: ';
    Fgb(b, (a.Bb & NEe) != 0);
    b.a += ', volatile: ';
    Fgb(b, (a.Bb & wse) != 0);
    b.a += ', transient: ';
    Fgb(b, (a.Bb & Mse) != 0);
    b.a += ', defaultValueLiteral: ';
    Egb(b, a.j);
    b.a += ', unsettable: ';
    Fgb(b, (a.Bb & dFe) != 0);
    b.a += ', derived: ';
    Fgb(b, (a.Bb & ire) != 0);
    b.a += ')';
    return b.a;
}
function O9d(a, b) {
    var c, d, e, f, g;
    e = b.mi(a.a);
    if (e) {
        d = (!e.b && (e.b = new lRd((cPd(), $Od), u7, e)), e.b);
        c = OD(xJd(d, EFe));
        if (c != null) {
            f = c.lastIndexOf('#');
            g = f == -1 ? pae(a, b.gk(), c) : f == 0 ? oae(a, null, (ADb(1, c.length + 1), c.substr(1))) : oae(a, (zDb(0, f, c.length), c.substr(0, f)), (ADb(f + 1, c.length + 1), c.substr(f + 1)));
            if (RD(g, 155)) return JD(g, 155);
        }
    }
    return null;
}
function S9d(a, b) {
    var c, d, e, f, g;
    d = b.mi(a.a);
    if (d) {
        c = (!d.b && (d.b = new lRd((cPd(), $Od), u7, d)), d.b);
        f = OD(xJd(c, _Fe));
        if (f != null) {
            e = f.lastIndexOf('#');
            g = e == -1 ? pae(a, b.gk(), f) : e == 0 ? oae(a, null, (ADb(1, f.length + 1), f.substr(1))) : oae(a, (zDb(0, e, f.length), f.substr(0, e)), (ADb(e + 1, f.length + 1), f.substr(e + 1)));
            if (RD(g, 155)) return JD(g, 155);
        }
    }
    return null;
}
function jac(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    b.Sg('Restoring reversed edges', 1);
    for(i = new rmb(a.b); i.a < i.c.c.length;){
        h = JD(pmb(i), 25);
        for(k = new rmb(h.a); k.a < k.c.c.length;){
            j = JD(pmb(k), 9);
            for(m = new rmb(j.j); m.a < m.c.c.length;){
                l = JD(pmb(m), 11);
                g = CXb(l.g);
                for(d = g, e = 0, f = d.length; e < f; ++e){
                    c = d[e];
                    ydb(LD(WMb(c, (Iqc(), xqc)))) && fWb(c, false);
                }
            }
        }
    }
    b.Tg();
}
function wjc(a, b, c, d) {
    var e, f, g, h, i;
    i = SC(aE, hre, 108, (Rjd(), WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ])).length, 0, 2);
    for(f = WC(OC(v2, 1), Ave, 64, 0, [
        Pjd,
        xjd,
        wjd,
        Ojd,
        Qjd
    ]), g = 0, h = f.length; g < h; ++g){
        e = f[g];
        i[e.g] = SC(aE, Rse, 30, a.c[e.g], 15, 1);
    }
    yjc(i, a, xjd);
    yjc(i, a, Ojd);
    vjc(i, a, xjd, b, c, d);
    vjc(i, a, wjd, b, c, d);
    vjc(i, a, Ojd, b, c, d);
    vjc(i, a, Qjd, b, c, d);
    return i;
}
function vFc(a, b, c) {
    if (Lib(a.a, b)) {
        if (Orb(JD(Nib(a.a, b), 50), c)) return 1;
    } else Qib(a.a, b, new Qrb);
    if (Lib(a.a, c)) {
        if (Orb(JD(Nib(a.a, c), 50), b)) return -1;
    } else Qib(a.a, c, new Qrb);
    if (Lib(a.b, b)) {
        if (Orb(JD(Nib(a.b, b), 50), c)) return -1;
    } else Qib(a.b, b, new Qrb);
    if (Lib(a.b, c)) {
        if (Orb(JD(Nib(a.b, c), 50), b)) return 1;
    } else Qib(a.b, c, new Qrb);
    return 0;
}
function EJb(a) {
    var b, c, d, e, f, g;
    if (a.q == (ajd(), Yid) || a.q == Xid) return;
    e = a.f.n.d + bHb(JD(Kqb(a.b, (Rjd(), xjd)), 126)) + a.c;
    b = a.f.n.a + bHb(JD(Kqb(a.b, Ojd), 126)) + a.c;
    d = JD(Kqb(a.b, wjd), 126);
    g = JD(Kqb(a.b, Qjd), 126);
    f = $wnd.Math.max(0, d.n.d - e);
    f = $wnd.Math.max(f, g.n.d - e);
    c = $wnd.Math.max(0, d.n.a - b);
    c = $wnd.Math.max(c, g.n.a - b);
    d.n.d = f;
    g.n.d = f;
    d.n.a = c;
    g.n.a = c;
}
function qbe(a, b, c, d) {
    var e, f, g, h, i, j;
    if (c == null) {
        e = JD(a.g, 122);
        for(h = 0; h < a.i; ++h){
            g = e[h];
            if (g.Ik() == b) return QGd(a, g, d);
        }
    }
    f = (Ife(), JD(b, 69).uk() ? JD(c, 74) : Jfe(b, c));
    if (qqd(a.e)) {
        j = !Kbe(a, b);
        d = PGd(a, f, d);
        i = b.Gk() ? Abe(a, 3, b, null, c, Fbe(a, b, c, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0), j) : Abe(a, 1, b, b.fk(), c, -1, j);
        d ? d.kj(i) : d = i;
    } else d = PGd(a, f, d);
    return d;
}
function Mad() {
    this.b = new Xsb;
    this.d = new Xsb;
    this.e = new Xsb;
    this.c = new Xsb;
    this.a = new Irb;
    this.f = new Irb;
    eEd(b2, new Xad, new Zad);
    eEd(a2, new tbd, new vbd);
    eEd(Z1, new xbd, new zbd);
    eEd($1, new Bbd, new Dbd);
    eEd(d3, new Fbd, new Hbd);
    eEd(MJ, new _ad, new bbd);
    eEd(GK, new dbd, new fbd);
    eEd(sK, new hbd, new jbd);
    eEd(DK, new lbd, new nbd);
    eEd(uL, new pbd, new rbd);
}
function hc(a, b) {
    var c, d, e, f, g;
    a = a == null ? Rqe : (tDb(a), a);
    for(e = 0; e < b.length; e++)b[e] = ic(b[e]);
    c = new Vgb;
    g = 0;
    d = 0;
    while(d < b.length){
        f = a.indexOf('%s', g);
        if (f == -1) break;
        c.a += '' + qgb(a == null ? Rqe : (tDb(a), a), g, f);
        Pgb(c, b[d++]);
        g = f + 2;
    }
    Ogb(c, a, g, a.length);
    if (d < b.length) {
        c.a += ' [';
        Pgb(c, b[d++]);
        while(d < b.length){
            c.a += Lqe;
            Pgb(c, b[d++]);
        }
        c.a += ']';
    }
    return c.a;
}
function nGc(a, b) {
    var c, d, e, f, g, h, i;
    c = 0;
    for(i = new rmb(b); i.a < i.c.c.length;){
        h = JD(pmb(i), 11);
        bGc(a.b, a.d[h.p]);
        g = 0;
        for(e = new xZb(h.b); omb(e.a) || omb(e.b);){
            d = JD(omb(e.a) ? pmb(e.a) : pmb(e.b), 18);
            if (xGc(d)) {
                f = DGc(a, h == d.c ? d.d : d.c);
                if (f > a.d[h.p]) {
                    c += aGc(a.b, f);
                    $kb(a.a, jfb(f));
                }
            } else ++g;
        }
        c += a.b.d * g;
        while(!elb(a.a))$Fc(a.b, JD(jlb(a.a), 17).a);
    }
    return c;
}
function Kee(a) {
    var b, c, d, e, f, g;
    f = 0;
    b = pRd(a);
    !!b.hk() && (f |= 4);
    (a.Bb & dFe) != 0 && (f |= 2);
    if (RD(a, 101)) {
        c = JD(a, 19);
        e = s1d(c);
        (c.Bb & RCe) != 0 && (f |= 32);
        if (e) {
            VTd(PRd(e));
            f |= 8;
            g = e.t;
            (g > 1 || g == -1) && (f |= 16);
            (e.Bb & RCe) != 0 && (f |= 64);
        }
        (c.Bb & Pse) != 0 && (f |= wse);
        f |= NEe;
    } else if (RD(b, 455)) f |= 512;
    else {
        d = b.hk();
        !!d && (d.i & 1) != 0 && (f |= 256);
    }
    (a.Bb & 512) != 0 && (f |= 128);
    return f;
}
function Qfe(a, b) {
    var c;
    if (a.f == Ofe) {
        c = Tae(jae((Gfe(), Efe), b));
        return a.e ? c == 4 && b != (ehe(), che) && b != (ehe(), _ge) && b != (ehe(), ahe) && b != (ehe(), bhe) : c == 2;
    }
    if (!!a.d && (a.d.Gc(b) || a.d.Gc(Uae(jae((Gfe(), Efe), b))) || a.d.Gc(Z9d((Gfe(), Efe), a.b, b)))) return true;
    if (a.f) {
        if (qae((Gfe(), a.f), Wae(jae(Efe, b)))) {
            c = Tae(jae(Efe, b));
            return a.e ? c == 4 : c == 2;
        }
    }
    return false;
}
function l8b(a, b) {
    var c, d, e, f, g, h, i, j;
    f = new Ulb;
    b.b.c.length = 0;
    c = JD(yBb(NBb(new RBb(null, new Gvb(new Ojb(a.a.b), 1))), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    for(e = c.Jc(); e.Ob();){
        d = JD(e.Pb(), 17);
        g = l_b(a.a, d);
        if (g.b != 0) {
            h = new b$b(b);
            YCb(f.c, h);
            h.p = d.a;
            for(j = Gtb(g, 0); j.b != j.d.c;){
                i = JD(Utb(j), 9);
                qYb(i, h);
            }
        }
    }
    Klb(b.b, f);
}
function rEc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    m = -1;
    n = 0;
    for(j = a, k = 0, l = j.length; k < l; ++k){
        i = j[k];
        for(f = i, g = 0, h = f.length; g < h; ++g){
            e = f[g];
            b = new Ykc(m == -1 ? a[0] : a[m], JD(WMb(gYb(e), (Bwc(), cuc)), 266), Qbc(e), ydb(LD(WMb(gYb(e), buc))));
            for(c = 0; c < e.j.c.length; c++)for(d = c + 1; d < e.j.c.length; d++)Ukc(b, JD(Mlb(e.j, c), 11), JD(Mlb(e.j, d), 11)) > 0 && ++n;
        }
        ++m;
    }
    return n;
}
function VYc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    g = JD(ksd(c, (Lgd(), fgd)), 8);
    i = g.a;
    k = g.b + a;
    e = $wnd.Math.atan2(k, i);
    e < 0 && (e += $ze);
    e += b;
    e > $ze && (e -= $ze);
    h = JD(ksd(d, fgd), 8);
    j = h.a;
    l = h.b + a;
    f = $wnd.Math.atan2(l, j);
    f < 0 && (f += $ze);
    f += b;
    f > $ze && (f -= $ze);
    return Ry(), Vy(1.0E-10), $wnd.Math.abs(e - f) <= 1.0E-10 || e == f || isNaN(e) && isNaN(f) ? 0 : e < f ? -1 : e > f ? 1 : Wy(isNaN(e), isNaN(f));
}
function OEb(a) {
    var b, c, d, e, f, g, h;
    h = new Irb;
    for(d = new rmb(a.a.b); d.a < d.c.c.length;){
        b = JD(pmb(d), 60);
        Qib(h, b, new Ulb);
    }
    for(e = new rmb(a.a.b); e.a < e.c.c.length;){
        b = JD(pmb(e), 60);
        b.i = Lse;
        for(g = b.c.Jc(); g.Ob();){
            f = JD(g.Pb(), 60);
            JD(Wd(fsb(h.f, f)), 15).Ec(b);
        }
    }
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        b.c.$b();
        b.c = JD(Wd(fsb(h.f, b)), 15);
    }
    GEb(a);
}
function KRb(a) {
    var b, c, d, e, f, g, h;
    h = new Irb;
    for(d = new rmb(a.a.b); d.a < d.c.c.length;){
        b = JD(pmb(d), 82);
        Qib(h, b, new Ulb);
    }
    for(e = new rmb(a.a.b); e.a < e.c.c.length;){
        b = JD(pmb(e), 82);
        b.o = Lse;
        for(g = b.f.Jc(); g.Ob();){
            f = JD(g.Pb(), 82);
            JD(Wd(fsb(h.f, f)), 15).Ec(b);
        }
    }
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        b.f.$b();
        b.f = JD(Wd(fsb(h.f, b)), 15);
    }
    DRb(a);
}
function p6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    i = gYb(b.a);
    e = Beb(MD(WMb(i, (Bwc(), $vc)))) * 2;
    k = Beb(MD(WMb(i, fwc)));
    j = $wnd.Math.max(e, k);
    f = SC(aE, Rse, 30, b.f - b.c + 1, 15, 1);
    d = -j;
    c = 0;
    for(h = b.b.Jc(); h.Ob();){
        g = JD(h.Pb(), 9);
        d += a.a[g.c.p] + j;
        f[c++] = d;
    }
    d += a.a[b.a.c.p] + j;
    f[c++] = d;
    for(m = new rmb(b.e); m.a < m.c.c.length;){
        l = JD(pmb(m), 9);
        d += a.a[l.c.p] + j;
        f[c++] = d;
    }
    return f;
}
function hGc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    m = new mzb(new SGc(a));
    for(h = WC(OC(RP, 1), Jve, 9, 0, [
        b,
        c
    ]), i = 0, j = h.length; i < j; ++i){
        g = h[i];
        for(l = dGc(g, d).Jc(); l.Ob();){
            k = JD(l.Pb(), 11);
            for(f = new xZb(k.b); omb(f.a) || omb(f.b);){
                e = JD(omb(f.a) ? pmb(f.a) : pmb(f.b), 18);
                if (!eWb(e)) {
                    m.a.yc(k, (xdb(), vdb));
                    xGc(e) && fzb(m, k == e.c ? e.d : e.c);
                }
            }
        }
    }
    return Qb(m), new Wlb(m);
}
function zWc(a, b, c, d) {
    var e, f, g;
    if (b) {
        f = Beb(MD(WMb(b, (tUc(), mUc)))) + d;
        g = c + Beb(MD(WMb(b, gUc))) / 2;
        ZMb(b, rUc, jfb(Pcb(zcb($wnd.Math.round(f)))));
        ZMb(b, sUc, jfb(Pcb(zcb($wnd.Math.round(g)))));
        b.d.b == 0 || zWc(a, JD(Dr((e = Gtb(new gRc(b).a.d, 0), new jRc(e))), 39), c + Beb(MD(WMb(b, gUc))) + a.b, d + Beb(MD(WMb(b, jUc))));
        WMb(b, pUc) != null && zWc(a, JD(WMb(b, pUc), 39), c, d);
    }
}
function Bpd(a, b) {
    var c, d, e, f;
    f = JD(ksd(a, (Lgd(), dgd)), 64).g - JD(ksd(b, dgd), 64).g;
    if (f != 0) return f;
    c = JD(ksd(a, $fd), 17);
    d = JD(ksd(b, $fd), 17);
    if (!!c && !!d) {
        e = c.a - d.a;
        if (e != 0) return e;
    }
    switch(JD(ksd(a, dgd), 64).g){
        case 1:
            return Heb(a.i, b.i);
        case 2:
            return Heb(a.j, b.j);
        case 3:
            return Heb(b.i, a.i);
        case 4:
            return Heb(b.j, a.j);
        default:
            throw scb(new Web(Hve));
    }
}
function bxd(a) {
    var b, c, d;
    if ((a.Db & 64) != 0) return jtd(a);
    b = new Wgb(HCe);
    c = a.k;
    if (!c) {
        !a.n && (a.n = new X0d(z3, a, 1, 7));
        if (a.n.i > 0) {
            d = (!a.n && (a.n = new X0d(z3, a, 1, 7)), JD(nDd(a.n, 0), 153)).a;
            !d || Qgb(Qgb((b.a += ' "', b), d), '"');
        }
    } else Qgb(Qgb((b.a += ' "', b), c), '"');
    Qgb(Lgb(Qgb(Lgb(Qgb(Lgb(Qgb(Lgb((b.a += ' (', b), a.i), ','), a.j), ' | '), a.g), ','), a.f), ')');
    return b.a;
}
function qxd(a) {
    var b, c, d;
    if ((a.Db & 64) != 0) return jtd(a);
    b = new Wgb(ICe);
    c = a.k;
    if (!c) {
        !a.n && (a.n = new X0d(z3, a, 1, 7));
        if (a.n.i > 0) {
            d = (!a.n && (a.n = new X0d(z3, a, 1, 7)), JD(nDd(a.n, 0), 153)).a;
            !d || Qgb(Qgb((b.a += ' "', b), d), '"');
        }
    } else Qgb(Qgb((b.a += ' "', b), c), '"');
    Qgb(Lgb(Qgb(Lgb(Qgb(Lgb(Qgb(Lgb((b.a += ' (', b), a.i), ','), a.j), ' | '), a.g), ','), a.f), ')');
    return b.a;
}
function uhc(a, b) {
    var c, d, e, f, g;
    b == (Wyc(), Tyc) && vnb(JD(Qc(a.a, ($gc(), Wgc)), 15));
    for(e = JD(Qc(a.a, ($gc(), Wgc)), 15).Jc(); e.Ob();){
        d = JD(e.Pb(), 105);
        c = JD(Mlb(d.j, 0), 112).d.j;
        f = new Wlb(d.j);
        Slb(f, new $hc);
        switch(b.g){
            case 2:
                mhc(a, f, c, (Ihc(), Ghc), 1);
                break;
            case 1:
            case 0:
                g = ohc(f);
                mhc(a, new Ijb(f, 0, g), c, (Ihc(), Ghc), 0);
                mhc(a, new Ijb(f, g, f.c.length), c, Ghc, 1);
        }
    }
}
function NFc(a) {
    var b, c, d, e, f, g, h;
    e = JD(WMb(a, (Iqc(), _pc)), 9);
    d = a.j;
    c = (sDb(0, d.c.length), JD(d.c[0], 11));
    for(g = new rmb(e.j); g.a < g.c.c.length;){
        f = JD(pmb(g), 11);
        if (XD(f) === XD(WMb(c, kqc))) {
            if (f.j == (Rjd(), xjd) && a.p > e.p) {
                aZb(f, Ojd);
                if (f.d) {
                    h = f.o.b;
                    b = f.a.b;
                    f.a.b = h - b;
                }
            } else if (f.j == Ojd && e.p > a.p) {
                aZb(f, xjd);
                if (f.d) {
                    h = f.o.b;
                    b = f.a.b;
                    f.a.b = -(h - b);
                }
            }
            break;
        }
    }
    return e;
}
function Had(a, b) {
    var c, d, e, f, g, h, i;
    if (b == null || b.length == 0) return null;
    e = JD(Oib(a.a, b), 149);
    if (!e) {
        for(d = (h = new Zjb(a.b).a.vc().Jc(), new ckb(h)); d.a.Ob();){
            c = (f = JD(d.a.Pb(), 43), JD(f.kd(), 149));
            g = c.c;
            i = b.length;
            if (cgb(g.substr(g.length - i, i), b) && (b.length == g.length || _fb(g, g.length - b.length - 1) == 46)) {
                if (e) return null;
                e = c;
            }
        }
        !!e && Rib(a.a, b, e);
    }
    return e;
}
function GTb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = new Edd(b, c);
    for(k = new rmb(a.a); k.a < k.c.c.length;){
        j = JD(pmb(k), 9);
        mdd(j.n, f);
        for(m = new rmb(j.j); m.a < m.c.c.length;){
            l = JD(pmb(m), 11);
            for(e = new rmb(l.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                Pdd(d.a, f);
                g = JD(WMb(d, (Bwc(), Ruc)), 77);
                !!g && Pdd(g, f);
                for(i = new rmb(d.b); i.a < i.c.c.length;){
                    h = JD(pmb(i), 72);
                    mdd(h.n, f);
                }
            }
        }
    }
}
function yXb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = new Edd(b, c);
    for(k = new rmb(a.a); k.a < k.c.c.length;){
        j = JD(pmb(k), 9);
        mdd(j.n, f);
        for(m = new rmb(j.j); m.a < m.c.c.length;){
            l = JD(pmb(m), 11);
            for(e = new rmb(l.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                Pdd(d.a, f);
                g = JD(WMb(d, (Bwc(), Ruc)), 77);
                !!g && Pdd(g, f);
                for(i = new rmb(d.b); i.a < i.c.c.length;){
                    h = JD(pmb(i), 72);
                    mdd(h.n, f);
                }
            }
        }
    }
}
function h$b(a) {
    if ((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b).i == 0) throw scb(new Z8c('Edges must have a source.'));
    else if ((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c).i == 0) throw scb(new Z8c('Edges must have a target.'));
    else {
        !a.b && (a.b = new ree(v3, a, 4, 7));
        if (!(a.b.i <= 1 && (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c.i <= 1))) throw scb(new Z8c('Hyperedges are not supported.'));
    }
}
function pEc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    l = 0;
    f = new nlb;
    $kb(f, b);
    while(f.b != f.c){
        i = JD(jlb(f), 217);
        j = 0;
        k = JD(WMb(b.j, (Bwc(), cuc)), 266);
        g = Beb(MD(WMb(b.j, Ztc)));
        h = Beb(MD(WMb(b.j, $tc)));
        if (k != (nyc(), kyc)) {
            j += g * qEc(i.e, k);
            j += h * rEc(i.e);
        }
        l += SFc(i.d, i.e) + j;
        for(e = new rmb(i.b); e.a < e.c.c.length;){
            d = JD(pmb(e), 36);
            c = JD(Mlb(a.b, d.p), 217);
            c.s || (l += oEc(a, c));
        }
    }
    return l;
}
function U1b(a) {
    var b, c, d;
    if (!XMb(a, (Bwc(), gvc))) return;
    d = JD(WMb(a, gvc), 22);
    if (d.dc()) return;
    c = (b = JD(deb(r2), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    d.Gc((Eid(), zid)) ? orb(c, zid) : orb(c, Aid);
    d.Gc(xid) || orb(c, xid);
    d.Gc(wid) ? orb(c, Did) : d.Gc(vid) ? orb(c, Cid) : d.Gc(yid) && orb(c, Bid);
    d.Gc(Did) ? orb(c, wid) : d.Gc(Cid) ? orb(c, vid) : d.Gc(Bid) && orb(c, yid);
    ZMb(a, gvc, c);
}
function K6b(a, b) {
    var c, d;
    this.b = new Ulb;
    this.e = new Ulb;
    this.a = a;
    this.d = b;
    H6b(this);
    I6b(this);
    this.b.dc() ? this.c = a.c.p : this.c = JD(this.b.Xb(0), 9).c.p;
    this.e.c.length == 0 ? this.f = a.c.p : this.f = JD(Mlb(this.e, this.e.c.length - 1), 9).c.p;
    for(d = JD(WMb(a, (Iqc(), wqc)), 15).Jc(); d.Ob();){
        c = JD(d.Pb(), 72);
        if (XMb(c, (Bwc(), uuc))) {
            this.d = JD(WMb(c, uuc), 231);
            break;
        }
    }
}
function Ekc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = JD(Nib(a.b, b), 50);
    f = JD(Nib(a.b, c), 50);
    e = JD(Nib(a.f, b), 50);
    g = JD(Nib(a.f, c), 50);
    d.a.yc(c, d);
    g.a.yc(b, g);
    for(k = f.a.ec().Jc(); k.Ob();){
        j = JD(k.Pb(), 9);
        d.a.yc(j, d);
        Nrb(JD(Nib(a.f, j), 50), b);
        xe(JD(Nib(a.f, j), 50), e);
    }
    for(i = e.a.ec().Jc(); i.Ob();){
        h = JD(i.Pb(), 9);
        g.a.yc(h, g);
        Nrb(JD(Nib(a.b, h), 50), c);
        xe(JD(Nib(a.b, h), 50), f);
    }
}
function xFc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = JD(Nib(a.a, b), 50);
    f = JD(Nib(a.a, c), 50);
    e = JD(Nib(a.b, b), 50);
    g = JD(Nib(a.b, c), 50);
    d.a.yc(c, d);
    g.a.yc(b, g);
    for(k = f.a.ec().Jc(); k.Ob();){
        j = JD(k.Pb(), 9);
        d.a.yc(j, d);
        Nrb(JD(Nib(a.b, j), 50), b);
        xe(JD(Nib(a.b, j), 50), e);
    }
    for(i = e.a.ec().Jc(); i.Ob();){
        h = JD(i.Pb(), 9);
        g.a.yc(h, g);
        Nrb(JD(Nib(a.a, h), 50), c);
        xe(JD(Nib(a.a, h), 50), f);
    }
}
function Ghb() {
    Ghb = Zcb;
    var a;
    Bhb = new Thb(1, 1);
    Dhb = new Thb(1, 10);
    Fhb = new Thb(0, 0);
    Ahb = new Thb(-1, 1);
    Chb = WC(OC(lJ, 1), hre, 90, 0, [
        Fhb,
        Bhb,
        new Thb(1, 2),
        new Thb(1, 3),
        new Thb(1, 4),
        new Thb(1, 5),
        new Thb(1, 6),
        new Thb(1, 7),
        new Thb(1, 8),
        new Thb(1, 9),
        Dhb
    ]);
    Ehb = SC(lJ, hre, 90, 32, 0, 1);
    for(a = 0; a < Ehb.length; a++)Ehb[a] = Bcb(Jcb(1, a), 0) ? aib(Jcb(1, a)) : Ohb(aib(Gcb(Jcb(1, a))));
}
function UGb(a, b, c, d, e, f, g) {
    a.c = d.Jf().a;
    a.d = d.Jf().b;
    if (e) {
        a.c += e.Jf().a;
        a.d += e.Jf().b;
    }
    a.b = b.Kf().a;
    a.a = b.Kf().b;
    if (!e) c ? a.c -= g + b.Kf().a : a.c += d.Kf().a + g;
    else switch(e.$f().g){
        case 0:
        case 2:
            a.c += e.Kf().a + g + f.a + g;
            break;
        case 4:
            a.c -= g + f.a + g + b.Kf().a;
            break;
        case 1:
            a.c += e.Kf().a + g;
            a.d -= g + f.b + g + b.Kf().b;
            break;
        case 3:
            a.c += e.Kf().a + g;
            a.d += e.Kf().b + g + f.b + g;
    }
}
function oNc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    f = c;
    if (c < d) {
        m = (n = new XMc(a.p), o = new XMc(a.p), xe(n.e, a.e), n.q = a.q, n.r = o, OMc(n), xe(o.j, a.j), o.r = n, OMc(o), new xod(n, o));
        l = JD(m.a, 116);
        k = JD(m.b, 116);
        e = (sDb(f, b.c.length), JD(b.c[f], 335));
        g = vNc(a, l, k, e);
        for(j = c + 1; j <= d; j++){
            h = (sDb(j, b.c.length), JD(b.c[j], 335));
            i = vNc(a, l, k, h);
            if (tNc(h, i, e, g)) {
                e = h;
                g = i;
                f = j;
            }
        }
    }
    return f;
}
function r2c(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    g = JD(nDd(b, 0), 27);
    htd(g, 0);
    itd(g, 0);
    m = new Ulb;
    YCb(m.c, g);
    h = g;
    f = new B4c(a.a, g.g, g.f, (I4c(), H4c));
    for(n = 1; n < b.i; n++){
        o = JD(nDd(b, n), 27);
        i = s2c(a, E4c, o, h, f, m, c);
        j = s2c(a, D4c, o, h, f, m, c);
        k = s2c(a, G4c, o, h, f, m, c);
        l = s2c(a, F4c, o, h, f, m, c);
        e = u2c(a, i, j, k, l, o, h, d);
        htd(o, e.d);
        itd(o, e.e);
        A4c(e, H4c);
        f = e;
        h = o;
        YCb(m.c, o);
    }
    return f;
}
function qzd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    k = null;
    m = b;
    l = fzd(a, cCd(c), m);
    Psd(l, byd(m, vDe));
    g = $xd(m, lDe);
    d = new Hzd(a, l);
    Cyd(d.a, d.b, g);
    h = $xd(m, mDe);
    e = new Jzd(a, l);
    Dyd(e.a, e.b, h);
    if ((!l.b && (l.b = new ree(v3, l, 4, 7)), l.b).i == 0 || (!l.c && (l.c = new ree(v3, l, 5, 8)), l.c).i == 0) {
        f = byd(m, vDe);
        i = zDe + f;
        j = i + ADe;
        throw scb(new eyd(j));
    }
    yzd(m, l);
    rzd(a, m, l);
    k = uzd(a, m, l);
    return k;
}
function AGb(a, b) {
    var c, d, e, f, g, h, i;
    e = SC(cE, ise, 30, a.e.a.c.length, 15, 1);
    for(g = new rmb(a.e.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 123);
        e[f.d] += f.b.a.c.length;
    }
    h = cv(b);
    while(h.b != 0){
        f = JD(h.b == 0 ? null : (rDb(h.b != 0), Ktb(h, h.a.a)), 123);
        for(d = Jr(new rmb(f.g.a)); d.Ob();){
            c = JD(d.Pb(), 216);
            i = c.e;
            i.e = $wnd.Math.max(i.e, f.e + c.a);
            --e[i.d];
            e[i.d] == 0 && Dtb(h, i, h.c.b, h.c);
        }
    }
}
function EGb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    c = Lre;
    e = Hqe;
    for(h = new rmb(a.e.a); h.a < h.c.c.length;){
        f = JD(pmb(h), 123);
        e = $wnd.Math.min(e, f.e);
        c = $wnd.Math.max(c, f.e);
    }
    b = SC(cE, ise, 30, c - e + 1, 15, 1);
    for(g = new rmb(a.e.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 123);
        f.e -= e;
        ++b[f.e];
    }
    d = 0;
    if (a.k != null) for(j = a.k, k = 0, l = j.length; k < l; ++k){
        i = j[k];
        b[d++] += i;
        if (b.length == d) break;
    }
    return b;
}
function LWc(a, b) {
    var c, d, e, f, g, h;
    b.Sg('Edge routing', 1);
    e = JD(WMb(a, (kVc(), NUc)), 383);
    if (e == (OTc(), MTc)) JWc(a);
    else if (e == LTc) {
        JD(zub(CBb(BBb(new RBb(null, new Gvb(a.b, 16)), new DQc))), 39);
        f = Beb(MD(WMb(a, bVc)));
        g = Beb(MD(WMb(a, MUc)));
        h = JD(WMb(a, KUc), 86);
        HWc(a, h, f);
        IWc(a, h, f, g);
        GWc(a, h, f, g);
        for(d = Gtb(a.a, 0); d.b != d.d.c;){
            c = JD(Utb(d), 65);
            c.a.b < 2 && KWc(c);
        }
    }
    b.Tg();
}
function fGd(a) {
    switch(a.d){
        case 9:
        case 8:
            return true;
        case 3:
        case 5:
        case 4:
        case 6:
            return false;
        case 7:
            return JD(eGd(a), 17).a == a.o;
        case 1:
        case 2:
            if (a.o == -2) return false;
            else switch(a.p){
                case 0:
                case 1:
                case 2:
                case 6:
                case 5:
                case 7:
                    return ycb(a.k, a.f);
                case 3:
                case 4:
                    return a.j == a.e;
                default:
                    return a.n == null ? a.g == null : pb(a.n, a.g);
            }
        default:
            return false;
    }
}
function rDc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    f = new Vlb(b.c.length);
    for(j = new rmb(b); j.a < j.c.c.length;){
        g = JD(pmb(j), 9);
        Ilb(f, a.b[g.c.p][g.p]);
    }
    mDc(a, f, c);
    l = null;
    while(l = nDc(f))oDc(a, JD(l.a, 238), JD(l.b, 238), f);
    b.c.length = 0;
    for(e = new rmb(f); e.a < e.c.c.length;){
        d = JD(pmb(e), 238);
        for(h = d.d, i = 0, k = h.length; i < k; ++i){
            g = h[i];
            YCb(b.c, g);
            a.a[g.c.p][g.p].a = sDc(d.g, d.d[0]).a;
        }
    }
}
function qlc(a, b) {
    var c, d, e;
    b.Sg('Breaking Point Insertion', 1);
    d = new imc(a);
    switch(JD(WMb(a, (Bwc(), uwc)), 347).g){
        case 2:
            e = new umc;
            break;
        case 0:
            e = new jlc;
            break;
        default:
            e = new xmc;
    }
    c = e.mg(a, d);
    ydb(LD(WMb(a, wwc))) && (c = plc(a, c));
    if (!e.ng() && XMb(a, Awc)) switch(JD(WMb(a, Awc), 348).g){
        case 2:
            c = Gmc(d, c);
            break;
        case 1:
            c = Emc(d, c);
    }
    if (c.dc()) {
        b.Tg();
        return;
    }
    nlc(a, c);
    b.Tg();
}
function Xhd(a) {
    Rad(a, new cad(nad(kad(mad(lad(new pad, qCe), 'ELK Fixed'), 'Keeps the current layout as it is, without any automatic modification. Optional coordinates can be given for nodes and edge bend points.'), new $hd)));
    Pad(a, qCe, Rue, Uhd);
    Pad(a, qCe, $ye, JBd(Vhd));
    Pad(a, qCe, NBe, JBd(Phd));
    Pad(a, qCe, Yue, JBd(Qhd));
    Pad(a, qCe, pve, JBd(Shd));
    Pad(a, qCe, Wue, JBd(Rhd));
}
function zo(a, b, c) {
    var d, e, f, g, h;
    d = Pcb(Fcb(yre, hfb(Pcb(Fcb(b == null ? 0 : tb(b), zre)), 15)));
    h = Pcb(Fcb(yre, hfb(Pcb(Fcb(c == null ? 0 : tb(c), zre)), 15)));
    f = Co(a, b, d);
    if (!!f && h == f.f && Hb(c, f.i)) return c;
    g = Do(a, c, h);
    if (g) throw scb(new Teb('value already present: ' + c));
    e = new gp(b, d, c, h);
    if (f) {
        uo(a, f);
        xo(a, e, f);
        f.e = null;
        f.c = null;
        return f.i;
    } else {
        xo(a, e, null);
        Bo(a);
        return null;
    }
}
function f1b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    k = c.a.c;
    g = c.a.c + c.a.b;
    f = JD(Nib(c.c, b), 454);
    n = f.f;
    o = f.a;
    f.b ? i = new Edd(g, n) : i = new Edd(k, n);
    f.c ? l = new Edd(k, o) : l = new Edd(g, o);
    e = k;
    c.p || (e += a.c);
    e += c.F + c.v * a.b;
    j = new Edd(e, n);
    m = new Edd(e, o);
    Mdd(b.a, WC(OC(b2, 1), hre, 8, 0, [
        i,
        j
    ]));
    h = c.d.a.gc() > 1;
    if (h) {
        d = new Edd(e, c.b);
        Atb(b.a, d);
    }
    Mdd(b.a, WC(OC(b2, 1), hre, 8, 0, [
        m,
        l
    ]));
}
function dyc() {
    dyc = Zcb;
    byc = new eyc(yve, 0);
    Yxc = new eyc('NIKOLOV', 1);
    _xc = new eyc('NIKOLOV_PIXEL', 2);
    Zxc = new eyc('NIKOLOV_IMPROVED', 3);
    $xc = new eyc('NIKOLOV_IMPROVED_PIXEL', 4);
    Vxc = new eyc('DUMMYNODE_PERCENTAGE', 5);
    ayc = new eyc('NODECOUNT_PERCENTAGE', 6);
    cyc = new eyc('NO_BOUNDARY', 7);
    Wxc = new eyc('MODEL_ORDER_LEFT_TO_RIGHT', 8);
    Xxc = new eyc('MODEL_ORDER_RIGHT_TO_LEFT', 9);
}
function dzd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    k = null;
    m = yyd(a, b);
    d = null;
    h = JD(ksd(b, (Lgd(), rfd)), 297);
    h ? d = h : d = (okd(), lkd);
    n = d;
    if (n == (okd(), lkd)) {
        e = null;
        j = JD(Nib(a.r, m), 297);
        j ? e = j : e = mkd;
        n = e;
    }
    Qib(a.r, b, n);
    f = null;
    i = JD(ksd(b, pfd), 275);
    i ? f = i : f = (ehd(), bhd);
    l = f;
    if (l == (ehd(), bhd)) {
        g = null;
        c = JD(Nib(a.b, m), 275);
        c ? g = c : g = ahd;
        l = g;
    }
    k = JD(Qib(a.b, b, l), 275);
    return k;
}
function Pne(a) {
    var b, c, d, e, f;
    d = a.length;
    b = new Igb;
    f = 0;
    while(f < d){
        c = _fb(a, f++);
        if (c == 9 || c == 10 || c == 12 || c == 13 || c == 32) continue;
        if (c == 35) {
            while(f < d){
                c = _fb(a, f++);
                if (c == 13 || c == 10) break;
            }
            continue;
        }
        if (c == 92 && f < d) {
            if ((e = (ADb(f, a.length), a.charCodeAt(f))) == 35 || e == 9 || e == 10 || e == 12 || e == 13 || e == 32) {
                Agb(b, e & Wre);
                ++f;
            } else {
                b.a += '\\';
                Agb(b, e & Wre);
                ++f;
            }
        } else Agb(b, c & Wre);
    }
    return b.a;
}
function G$c() {
    G$c = Zcb;
    q$c = new MBd(kAe, (xdb(), false));
    w$c = new MBd(lAe, jfb(0));
    x$c = new MBd(mAe, 0);
    y$c = new MBd(nAe, false);
    t$c = (j$c(), g$c);
    s$c = new MBd(oAe, t$c);
    jfb(0);
    r$c = new MBd(pAe, jfb(1));
    D$c = (w_c(), u_c);
    C$c = new MBd(qAe, D$c);
    F$c = (_Zc(), $Zc);
    E$c = new MBd(rAe, F$c);
    v$c = (m_c(), l_c);
    u$c = new MBd(sAe, v$c);
    B$c = new MBd(tAe, 0);
    z$c = new MBd(uAe, false);
    A$c = new MBd(vAe, false);
}
function wZc(a, b) {
    var c, d, e;
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 27);
        Rc(a.a, c, c);
        Rc(a.b, c, c);
        e = TYc(c);
        if (e.c.length != 0) {
            !!a.d && a.d.Eg(e);
            Rc(a.a, c, (sDb(0, e.c.length), JD(e.c[0], 27)));
            Rc(a.b, c, JD(Mlb(e, e.c.length - 1), 27));
            while(QYc(e).c.length != 0){
                e = QYc(e);
                !!a.d && a.d.Eg(e);
                Rc(a.a, c, (sDb(0, e.c.length), JD(e.c[0], 27)));
                Rc(a.b, c, JD(Mlb(e, e.c.length - 1), 27));
            }
        }
    }
}
function Pqd(a, b, c) {
    var d, e, f, g, h, i;
    if (!b) return null;
    else {
        if (c <= -1) {
            d = QTd(b.zh(), -1 - c);
            if (RD(d, 101)) return JD(d, 19);
            else {
                g = JD(b.Ih(d), 159);
                for(h = 0, i = g.gc(); h < i; ++h)if (XD(g.Rl(h)) === XD(a)) {
                    e = g.Ql(h);
                    if (RD(e, 101)) {
                        f = JD(e, 19);
                        if ((f.Bb & RCe) != 0) return f;
                    }
                }
                throw scb(new Web('The containment feature could not be located'));
            }
        } else return s1d(JD(QTd(a.zh(), c), 19));
    }
}
function ikc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    c = 0;
    for(h = new rmb(a.d); h.a < h.c.c.length;){
        g = JD(pmb(h), 105);
        !!g.i && (g.i.c = c++);
    }
    b = QC(pcb, [
        hre,
        Vte
    ], [
        183,
        30
    ], 16, [
        c,
        c
    ], 2);
    k = a.d;
    for(e = 0; e < k.c.length; e++){
        i = (sDb(e, k.c.length), JD(k.c[e], 105));
        if (i.i) for(f = e + 1; f < k.c.length; f++){
            j = (sDb(f, k.c.length), JD(k.c[f], 105));
            if (j.i) {
                d = nkc(i, j);
                b[i.i.c][j.i.c] = d;
                b[j.i.c][i.i.c] = d;
            }
        }
    }
    return b;
}
function ZSc() {
    ZSc = Zcb;
    YSc = new $Sc('ROOT_PROC', 0);
    RSc = new $Sc('FAN_PROC', 1);
    VSc = new $Sc('LEVEL_PROC', 2);
    WSc = new $Sc('NEIGHBORS_PROC', 3);
    USc = new $Sc('LEVEL_HEIGHT', 4);
    QSc = new $Sc('DIRECTION_PROC', 5);
    XSc = new $Sc('NODE_POSITION_PROC', 6);
    OSc = new $Sc('COMPACTION_PROC', 7);
    TSc = new $Sc('LEVEL_COORDS', 8);
    SSc = new $Sc('GRAPH_BOUNDS_PROC', 9);
    PSc = new $Sc('DETREEIFYING_PROC', 10);
}
function $9d(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    l = UTd(b);
    j = null;
    e = false;
    for(h = 0, k = OTd(l.a).i; h < k; ++h){
        g = JD(gXd(l, h, (f = JD(nDd(OTd(l.a), h), 87), i = f.c, RD(i, 88) ? JD(i, 29) : (cPd(), UOd))), 29);
        c = $9d(a, g);
        if (!c.dc()) {
            if (!j) j = c;
            else {
                if (!e) {
                    e = true;
                    j = new iOd(j);
                }
                j.Fc(c);
            }
        }
    }
    d = dae(a, b);
    if (d.dc()) return !j ? (pnb(), pnb(), mnb) : j;
    else {
        if (!j) return d;
        else {
            e || (j = new iOd(j));
            j.Fc(d);
            return j;
        }
    }
}
function _9d(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    l = UTd(b);
    j = null;
    d = false;
    for(h = 0, k = OTd(l.a).i; h < k; ++h){
        f = JD(gXd(l, h, (e = JD(nDd(OTd(l.a), h), 87), i = e.c, RD(i, 88) ? JD(i, 29) : (cPd(), UOd))), 29);
        c = _9d(a, f);
        if (!c.dc()) {
            if (!j) j = c;
            else {
                if (!d) {
                    d = true;
                    j = new iOd(j);
                }
                j.Fc(c);
            }
        }
    }
    g = gae(a, b);
    if (g.dc()) return !j ? (pnb(), pnb(), mnb) : j;
    else {
        if (!j) return g;
        else {
            d || (j = new iOd(j));
            j.Fc(g);
            return j;
        }
    }
}
function VBc(a, b) {
    var c, d, e, f, g;
    a.c == null || a.c.length < b.c.length ? a.c = SC(pcb, Vte, 30, b.c.length, 16, 1) : Emb(a.c);
    a.a = new Ulb;
    d = 0;
    for(g = new rmb(b); g.a < g.c.c.length;){
        e = JD(pmb(g), 9);
        e.p = d++;
    }
    c = new Mtb;
    for(f = new rmb(b); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        if (!a.c[e.p]) {
            WBc(a, e);
            c.b == 0 || (rDb(c.b != 0), JD(c.a.a.c, 15)).gc() < a.a.c.length ? Btb(c, a.a) : Ctb(c, a.a);
            a.a = new Ulb;
        }
    }
    return c;
}
function ube(a, b, c) {
    var d, e, f, g, h, i;
    if (RD(b, 74)) return QGd(a, b, c);
    else {
        h = null;
        f = null;
        d = JD(a.g, 122);
        for(g = 0; g < a.i; ++g){
            e = d[g];
            if (pb(b, e.kd())) {
                f = e.Ik();
                if (RD(f, 101) && (JD(f, 19).Bb & RCe) != 0) {
                    h = e;
                    break;
                }
            }
        }
        if (h) {
            if (qqd(a.e)) {
                i = f.Gk() ? Abe(a, 4, f, b, null, Fbe(a, f, b, RD(f, 101) && (JD(f, 19).Bb & Pse) != 0), true) : Abe(a, f.qk() ? 2 : 1, f, b, f.fk(), -1, true);
                c ? c.kj(i) : c = i;
            }
            c = ube(a, h, c);
        }
        return c;
    }
}
function Tbe(a, b, c) {
    var d, e, f, g;
    g = Kfe(a.e.zh(), b);
    d = JD(a.g, 122);
    Ife();
    if (JD(b, 69).uk()) for(f = 0; f < a.i; ++f){
        e = d[f];
        if (g.Zl(e.Ik())) {
            if (pb(e, c)) {
                UGd(a, f);
                return true;
            }
        }
    }
    else if (c != null) for(f = 0; f < a.i; ++f){
        e = d[f];
        if (g.Zl(e.Ik())) {
            if (pb(c, e.kd())) {
                UGd(a, f);
                return true;
            }
        }
    }
    else for(f = 0; f < a.i; ++f){
        e = d[f];
        if (g.Zl(e.Ik())) {
            if (e.kd() == null) {
                UGd(a, f);
                return true;
            }
        }
    }
    return false;
}
function ETb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    g = ldd(b.c, c, d);
    for(l = new rmb(b.a); l.a < l.c.c.length;){
        k = JD(pmb(l), 9);
        mdd(k.n, g);
        for(n = new rmb(k.j); n.a < n.c.c.length;){
            m = JD(pmb(n), 11);
            for(f = new rmb(m.g); f.a < f.c.c.length;){
                e = JD(pmb(f), 18);
                Pdd(e.a, g);
                h = JD(WMb(e, (Bwc(), Ruc)), 77);
                !!h && Pdd(h, g);
                for(j = new rmb(e.b); j.a < j.c.c.length;){
                    i = JD(pmb(j), 72);
                    mdd(i.n, g);
                }
            }
        }
        Ilb(a.a, k);
        k.a = a;
    }
}
function K5b(a, b) {
    var c, d, e, f, g;
    b.Sg('Node and Port Label Placement and Node Sizing', 1);
    OGb((sWb(), new DWb(a, true, true, new N5b)));
    if (JD(WMb(a, (Iqc(), Wpc)), 22).Gc(($oc(), Toc))) {
        f = JD(WMb(a, (Bwc(), Hvc)), 22);
        e = f.Gc((ojd(), ljd));
        g = ydb(LD(WMb(a, Ivc)));
        for(d = new rmb(a.b); d.a < d.c.c.length;){
            c = JD(pmb(d), 25);
            EBb(BBb(new RBb(null, new Gvb(c.a, 16)), new P5b), new R5b(f, e, g));
        }
    }
    b.Tg();
}
function i7c(a) {
    Rad(a, new cad(nad(kad(mad(lad(new pad, rBe), 'ELK SPOrE Overlap Removal'), 'A node overlap removal algorithm proposed by Nachmanson et al. in "Node overlap removal by growing a tree".'), new l7c)));
    Pad(a, rBe, fBe, JBd(g7c));
    Pad(a, rBe, Rue, e7c);
    Pad(a, rBe, Mue, 8);
    Pad(a, rBe, kBe, JBd(f7c));
    Pad(a, rBe, nBe, JBd(c7c));
    Pad(a, rBe, oBe, JBd(d7c));
    Pad(a, rBe, Dye, (xdb(), false));
}
function Y9d(a, b) {
    var c, d, e, f, g, h, i;
    c = b.mi(a.a);
    if (c) {
        i = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), dGe));
        if (i != null) {
            d = new Ulb;
            for(f = mgb(i, '\\w'), g = 0, h = f.length; g < h; ++g){
                e = f[g];
                cgb(e, '##other') ? Ilb(d, '!##' + nae(a, WSd(b.nk()))) : cgb(e, '##local') ? (d.c.push(null), undefined) : cgb(e, bGe) ? Ilb(d, nae(a, WSd(b.nk()))) : YCb(d.c, e);
            }
            return d;
        }
    }
    return pnb(), pnb(), mnb;
}
function vKc(a, b, c, d) {
    this.e = a;
    this.k = JD(WMb(a, (Iqc(), Aqc)), 313);
    this.g = SC(RP, Jve, 9, b, 0, 1);
    this.b = SC(LI, hre, 341, b, 7, 1);
    this.a = SC(RP, Jve, 9, b, 0, 1);
    this.d = SC(LI, hre, 341, b, 7, 1);
    this.j = SC(RP, Jve, 9, b, 0, 1);
    this.i = SC(LI, hre, 341, b, 7, 1);
    this.p = SC(LI, hre, 341, b, 7, 1);
    this.n = SC(GI, hre, 471, b, 8, 1);
    Dmb(this.n, (xdb(), false));
    this.f = SC(GI, hre, 471, b, 8, 1);
    Dmb(this.f, true);
    this.o = c;
    this.c = d;
}
function GRb(a) {
    var b, c, d, e, f, g, h, i;
    if (a.d) throw scb(new Web((ceb(MO), Hte + MO.k + Ite)));
    a.c == (Tgd(), Rgd) && FRb(a, Pgd);
    for(c = new rmb(a.a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 194);
        b.e = 0;
    }
    for(g = new rmb(a.a.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 82);
        f.o = Lse;
        for(e = f.f.Jc(); e.Ob();){
            d = JD(e.Pb(), 82);
            ++d.d.e;
        }
    }
    VRb(a);
    for(i = new rmb(a.a.b); i.a < i.c.c.length;){
        h = JD(pmb(i), 82);
        h.k = true;
    }
    return a;
}
function Lgc(a, b) {
    var c, d, e, f, g, h, i, j;
    h = new sgc(a);
    c = new Mtb;
    Dtb(c, b, c.c.b, c.c);
    while(c.b != 0){
        d = JD(c.b == 0 ? null : (rDb(c.b != 0), Ktb(c, c.a.a)), 112);
        d.d.p = 1;
        for(g = new rmb(d.e); g.a < g.c.c.length;){
            e = JD(pmb(g), 336);
            ngc(h, e);
            j = e.d;
            j.d.p == 0 && Dtb(c, j, c.c.b, c.c);
        }
        for(f = new rmb(d.b); f.a < f.c.c.length;){
            e = JD(pmb(f), 336);
            ngc(h, e);
            i = e.c;
            i.d.p == 0 && Dtb(c, i, c.c.b, c.c);
        }
    }
    return h;
}
function Umd(a) {
    var b, c, d, e, f;
    d = Beb(MD(ksd(a, (Lgd(), jgd))));
    if (d == 1) return;
    dtd(a, d * a.g, d * a.f);
    c = $q(dr((!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c), new tnd));
    for(f = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        (!a.n && (a.n = new X0d(z3, a, 1, 7)), a.n),
        (!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c),
        c
    ]))); cs(f);){
        e = JD(ds(f), 273);
        e.oh(d * e.lh(), d * e.mh());
        e.nh(d * e.kh(), d * e.jh());
        b = JD(e.mf(Wfd), 8);
        if (b) {
            b.a *= d;
            b.b *= d;
        }
    }
}
function jbe(a, b, c) {
    var d, e, f, g, h;
    g = (Ife(), JD(b, 69).uk());
    if (Lfe(a.e, b)) {
        if (b.Pi() && ybe(a, b, c, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0)) return false;
    } else {
        h = Kfe(a.e.zh(), b);
        d = JD(a.g, 122);
        for(f = 0; f < a.i; ++f){
            e = d[f];
            if (h.Zl(e.Ik())) {
                if (g ? pb(e, c) : c == null ? e.kd() == null : pb(c, e.kd())) return false;
                else {
                    JD(DCd(a, f, g ? JD(c, 74) : Jfe(b, c)), 74);
                    return true;
                }
            }
        }
    }
    return tCd(a, g ? JD(c, 74) : Jfe(b, c));
}
function m7b(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m;
    for(g = new rmb(a.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        m = DXb(f.a);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            switch(JD(WMb(i, (Bwc(), Uuc)), 171).g){
                case 1:
                    q7b(i);
                    qYb(i, b);
                    n7b(i, true, d);
                    break;
                case 3:
                    r7b(i);
                    qYb(i, c);
                    n7b(i, false, e);
            }
        }
    }
    h = new Ajb(a.b, 0);
    while(h.b < h.d.gc())(rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 25)).a.c.length == 0 && tjb(h);
}
function dib(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    n = b.length;
    i = n;
    ADb(0, b.length);
    if (b.charCodeAt(0) == 45) {
        l = -1;
        m = 1;
        --n;
    } else {
        l = 1;
        m = 0;
    }
    f = (oib(), nib)[10];
    e = n / f | 0;
    q = n % f;
    q != 0 && ++e;
    h = SC(cE, ise, 30, e, 15, 1);
    c = mib[8];
    g = 0;
    o = m + (q == 0 ? f : q);
    for(p = m; p < i; p = o, o = p + f){
        d = Fdb((zDb(p, o, b.length), b.substr(p, o - p)), Lre, Hqe);
        j = (Cib(), Gib(h, h, g, c));
        j += wib(h, g, d);
        h[g++] = j;
    }
    k = g;
    a.e = l;
    a.d = k;
    a.a = h;
    Ihb(a);
}
function zVb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    h = a.i;
    e = ydb(LD(WMb(h, (Bwc(), Nuc))));
    k = 0;
    d = 0;
    for(j = new rmb(a.g); j.a < j.c.c.length;){
        i = JD(pmb(j), 18);
        g = eWb(i);
        f = g && e && ydb(LD(WMb(i, Ouc)));
        m = i.d.i;
        g && f ? ++d : g && !f ? ++k : gYb(m).e == h ? ++d : ++k;
    }
    for(c = new rmb(a.e); c.a < c.c.c.length;){
        b = JD(pmb(c), 18);
        g = eWb(b);
        f = g && e && ydb(LD(WMb(b, Ouc)));
        l = b.c.i;
        g && f ? ++k : g && !f ? ++d : gYb(l).e == h ? ++k : ++d;
    }
    return k - d;
}
function z6b(a, b) {
    var c, d, e, f, g, h;
    if (b.dc()) return;
    if (JD(b.Xb(0), 291).d == (Nmc(), Kmc)) q6b(a, b);
    else for(d = b.Jc(); d.Ob();){
        c = JD(d.Pb(), 291);
        switch(c.d.g){
            case 5:
                m6b(a, c, s6b(a, c));
                break;
            case 0:
                m6b(a, c, (g = c.f - c.c + 1, h = (g - 1) / 2 | 0, c.c + h));
                break;
            case 4:
                m6b(a, c, u6b(a, c));
                break;
            case 2:
                A6b(c);
                m6b(a, c, (f = w6b(c), f ? c.c : c.f));
                break;
            case 1:
                A6b(c);
                m6b(a, c, (e = w6b(c), e ? c.f : c.c));
        }
        r6b(c.a);
    }
}
function vt(a, b, c, d) {
    var e, f, g;
    g = new Du(b, c);
    if (!a.a) {
        a.a = a.e = g;
        Qib(a.b, b, new Cu(g));
        ++a.c;
    } else if (!d) {
        JD(vub(a.e), 495).b = g;
        g.d = a.e;
        a.e = g;
        e = JD(Nib(a.b, b), 260);
        if (!e) {
            Qib(a.b, b, e = new Cu(g));
            ++a.c;
        } else {
            ++e.a;
            f = e.c;
            f.c = g;
            g.e = f;
            e.c = g;
        }
    } else {
        e = JD(vub(JD(Nib(a.b, b), 260)), 260);
        ++e.a;
        g.d = d.d;
        g.e = d.e;
        g.b = d;
        g.c = d;
        !d.e ? e.b = g : d.e.c = g;
        !d.d ? a.a = g : d.d.b = g;
        d.d = g;
        d.e = g;
    }
    ++a.d;
    return g;
}
function wGb(a, b) {
    var c, d, e, f, g;
    b.Sg('Network simplex', 1);
    if (a.e.a.c.length < 1) {
        b.Tg();
        return;
    }
    for(f = new rmb(a.e.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 123);
        e.e = 0;
    }
    g = a.e.a.c.length >= 40;
    g && HGb(a);
    yGb(a);
    xGb(a);
    c = BGb(a);
    d = 0;
    while(!!c && d < a.f){
        vGb(a, c, uGb(a, c));
        c = BGb(a);
        ++d;
    }
    g && GGb(a);
    a.a ? sGb(a, EGb(a)) : EGb(a);
    a.b = null;
    a.d = null;
    a.p = null;
    a.c = null;
    a.g = null;
    a.i = null;
    a.n = null;
    a.o = null;
    b.Tg();
}
function d1b(a, b) {
    var c, d, e, f, g, h, i;
    if (b.e) return;
    b.e = true;
    for(d = b.d.a.ec().Jc(); d.Ob();){
        c = JD(d.Pb(), 18);
        if (b.o && b.d.a.gc() <= 1) {
            g = b.a.c;
            h = b.a.c + b.a.b;
            i = new Edd(g + (h - g) / 2, b.b);
            Atb(JD(b.d.a.ec().Jc().Pb(), 18).a, i);
            continue;
        }
        e = JD(Nib(b.c, c), 454);
        if (e.b || e.c) {
            f1b(a, c, b);
            continue;
        }
        f = a.d == (ozc(), nzc) && (e.d || e.e) && l1b(a, b) && b.d.a.gc() <= 1;
        f ? g1b(c, b) : e1b(a, c, b);
    }
    b.k && ofb(b.d, new y1b);
}
function D_c(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = f;
    h = (d + e) / 2 + m;
    q = c * $wnd.Math.cos(h);
    r = c * $wnd.Math.sin(h);
    s = q - b.g / 2;
    t = r - b.f / 2;
    htd(b, s);
    itd(b, t);
    l = a.a.Cg(b);
    p = 2 * $wnd.Math.acos(c / c + a.c);
    if (p < e - d) {
        n = p / l;
        g = (d + e - p) / 2;
    } else {
        n = (e - d) / l;
        g = d;
    }
    o = TYc(b);
    if (a.e) {
        a.e.Dg(a.d);
        a.e.Eg(o);
    }
    for(j = new rmb(o); j.a < j.c.c.length;){
        i = JD(pmb(j), 27);
        k = a.a.Cg(i);
        D_c(a, i, c + a.c, g, g + n * k, f);
        g += n * k;
    }
}
function rA(a, b, c) {
    var d;
    d = c.q.getMonth();
    switch(b){
        case 5:
            Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'J',
                'F',
                'M',
                'A',
                'M',
                'J',
                'J',
                'A',
                'S',
                'O',
                'N',
                'D'
            ])[d]);
            break;
        case 4:
            Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                Xre,
                Yre,
                Zre,
                $re,
                _re,
                ase,
                bse,
                cse,
                dse,
                ese,
                fse,
                gse
            ])[d]);
            break;
        case 3:
            Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                _re,
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ])[d]);
            break;
        default:
            MA(a, d + 1, b);
    }
}
function zMb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    i = new Edd(c, d);
    Bdd(i, JD(WMb(b, (TOb(), QOb)), 8));
    for(m = new rmb(b.e); m.a < m.c.c.length;){
        l = JD(pmb(m), 151);
        mdd(l.d, i);
        Ilb(a.e, l);
    }
    for(h = new rmb(b.c); h.a < h.c.c.length;){
        g = JD(pmb(h), 288);
        for(f = new rmb(g.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 249);
            mdd(e.d, i);
        }
        Ilb(a.c, g);
    }
    for(k = new rmb(b.d); k.a < k.c.c.length;){
        j = JD(pmb(k), 442);
        mdd(j.d, i);
        Ilb(a.d, j);
    }
}
function Wzc(a, b) {
    var c, d, e, f, g, h, i, j;
    for(i = new rmb(b.j); i.a < i.c.c.length;){
        h = JD(pmb(i), 11);
        for(e = new xZb(h.b); omb(e.a) || omb(e.b);){
            d = JD(omb(e.a) ? pmb(e.a) : pmb(e.b), 18);
            c = d.c == h ? d.d : d.c;
            f = c.i;
            if (b == f) continue;
            j = JD(WMb(d, (Bwc(), Nvc)), 17).a;
            j < 0 && (j = 0);
            g = f.p;
            if (a.b[g] == 0) {
                if (d.d == c) {
                    a.a[g] -= j + 1;
                    a.a[g] <= 0 && a.c[g] > 0 && Atb(a.f, f);
                } else {
                    a.c[g] -= j + 1;
                    a.c[g] <= 0 && a.a[g] > 0 && Atb(a.e, f);
                }
            }
        }
    }
}
function IPc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    i = new Edd(c, d);
    Bdd(i, JD(WMb(b, (tUc(), VTc)), 8));
    for(k = Gtb(b.b, 0); k.b != k.d.c;){
        j = JD(Utb(k), 39);
        mdd(j.e, i);
        Atb(a.b, j);
    }
    for(h = JD(yBb(ABb(new RBb(null, new Gvb(b.a, 16))), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15).Jc(); h.Ob();){
        g = JD(h.Pb(), 65);
        for(f = Gtb(g.a, 0); f.b != f.d.c;){
            e = JD(Utb(f), 8);
            e.a += i.a;
            e.b += i.b;
        }
        Atb(a.a, g);
    }
}
function nQc(a, b) {
    var c, d, e, f;
    if (0 < (RD(a, 16) ? JD(a, 16).gc() : Gr(a.Jc()))) {
        e = b;
        if (1 < e) {
            --e;
            f = new xQc;
            for(d = a.Jc(); d.Ob();){
                c = JD(d.Pb(), 39);
                f = yl(WC(OC(VI, 1), Nqe, 20, 0, [
                    f,
                    new gRc(c)
                ]));
            }
            return nQc(f, e);
        }
        if (e < 0) {
            f = new AQc;
            for(d = a.Jc(); d.Ob();){
                c = JD(d.Pb(), 39);
                f = yl(WC(OC(VI, 1), Nqe, 20, 0, [
                    f,
                    new gRc(c)
                ]));
            }
            if (0 < (RD(f, 16) ? JD(f, 16).gc() : Gr(f.Jc()))) return nQc(f, e);
        }
    }
    return JD(Dr(a.Jc()), 39);
}
function yWc(a, b, c) {
    var d, e, f, g;
    c.Sg('Processor order nodes', 2);
    a.b = Beb(MD(WMb(b, (kVc(), cVc))));
    a.a = JD(WMb(b, KUc), 86);
    if (a.a == (Tgd(), Rgd)) {
        a.a = Ogd;
        ZMb(b, KUc, a.a);
    }
    e = new Mtb;
    for(g = Gtb(b.b, 0); g.b != g.d.c;){
        f = JD(Utb(g), 39);
        ydb(LD(WMb(f, (tUc(), qUc)))) && Dtb(e, f, e.c.b, e.c);
    }
    d = (rDb(e.b != 0), JD(e.a.a.c, 39));
    wWc(a, d);
    c.dh(1);
    zWc(a, d, 0 - Beb(MD(WMb(d, (tUc(), gUc)))) / 2, 0);
    c.dh(1);
    c.Tg();
}
function Nkd() {
    Nkd = Zcb;
    Gkd = new Okd('DEFAULT_MINIMUM_SIZE', 0);
    Ikd = new Okd('MINIMUM_SIZE_ACCOUNTS_FOR_PADDING', 1);
    Fkd = new Okd('COMPUTE_PADDING', 2);
    Jkd = new Okd('OUTSIDE_NODE_LABELS_OVERHANG', 3);
    Kkd = new Okd('PORTS_OVERHANG', 4);
    Mkd = new Okd('UNIFORM_PORT_SPACING', 5);
    Lkd = new Okd('SPACE_EFFICIENT_PORT_LABELS', 6);
    Hkd = new Okd('FORCE_TABULAR_NODE_LABELS', 7);
    Ekd = new Okd('ASYMMETRICAL', 8);
}
function kfe(a, b) {
    var c, d, e, f, g, h, i, j;
    if (!b) return null;
    else {
        c = (f = b.zh(), !f ? null : WSd(f).si().oi(f));
        if (c) {
            Usb(a, b, c);
            e = b.zh();
            for(i = 0, j = (e.i == null && MTd(e), e.i).length; i < j; ++i){
                h = (d = (e.i == null && MTd(e), e.i), i >= 0 && i < d.length ? d[i] : null);
                if (h.ok() && !h.pk()) {
                    if (RD(h, 330)) mfe(a, JD(h, 35), b, c);
                    else {
                        g = JD(h, 19);
                        (g.Bb & RCe) != 0 && ofe(a, g, b, c);
                    }
                }
            }
            b.Rh() && JD(c, 52).ai(JD(b, 52).Xh());
        }
        return c;
    }
}
function vGb(a, b, c) {
    var d, e, f;
    if (!b.f) throw scb(new Teb('Given leave edge is no tree edge.'));
    if (c.f) throw scb(new Teb('Given enter edge is a tree edge already.'));
    b.f = false;
    Prb(a.p, b);
    c.f = true;
    Nrb(a.p, c);
    d = c.e.e - c.d.e - c.a;
    zGb(a, c.e, b) || (d = -d);
    for(f = new rmb(a.e.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 123);
        zGb(a, e, b) || (e.e += d);
    }
    a.j = 1;
    Emb(a.c);
    FGb(a, JD(pmb(new rmb(a.e.a)), 123));
    tGb(a);
}
function $2b(a, b) {
    var c, d, e, f, g, h;
    h = JD(WMb(b, (Bwc(), Evc)), 100);
    if (!(h == (ajd(), Yid) || h == Xid)) return;
    e = new Edd(b.f.a + b.d.b + b.d.c, b.f.b + b.d.d + b.d.a).b;
    for(g = new rmb(a.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        if (f.k != (DYb(), wYb)) continue;
        c = JD(WMb(f, (Iqc(), Tpc)), 64);
        if (c != (Rjd(), wjd) && c != Qjd) continue;
        d = Beb(MD(WMb(f, tqc)));
        h == Yid && (d *= e);
        f.n.b = d - JD(WMb(f, Cvc), 8).b;
        cYb(f, false, true);
    }
}
function h7b(a, b, c, d, e) {
    if (c && (!d || (a.c - a.b & a.a.length - 1) > 1) && b == 1 && JD(a.a[a.b], 9).k == (DYb(), xYb)) b7b(JD(a.a[a.b], 9), (oid(), kid));
    else if (d && (!c || (a.c - a.b & a.a.length - 1) > 1) && b == 1 && JD(a.a[a.c - 1 & a.a.length - 1], 9).k == (DYb(), xYb)) b7b(JD(a.a[a.c - 1 & a.a.length - 1], 9), (oid(), lid));
    else if ((a.c - a.b & a.a.length - 1) == 2) {
        b7b(JD(flb(a), 9), (oid(), kid));
        b7b(JD(flb(a), 9), lid);
    } else $6b(a, e);
    alb(a);
}
function YBc(a) {
    var b, c, d, e, f, g, h, i;
    i = new Irb;
    b = new NFb;
    for(g = a.Jc(); g.Ob();){
        e = JD(g.Pb(), 9);
        h = pGb(qGb(new rGb, e), b);
        gsb(i.f, e, h);
    }
    for(f = a.Jc(); f.Ob();){
        e = JD(f.Pb(), 9);
        for(d = new es(Ir(kYb(e).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            if (eWb(c)) continue;
            DFb(GFb(FFb(EFb(HFb(new IFb, $wnd.Math.max(1, JD(WMb(c, (Bwc(), Ovc)), 17).a)), 1), JD(Nib(i, c.c.i), 123)), JD(Nib(i, c.d.i), 123)));
        }
    }
    return b;
}
function zCc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    ECc(a, b, c);
    f = b[c];
    n = d ? (Rjd(), Qjd) : (Rjd(), wjd);
    if (ACc(b.length, c, d)) {
        e = b[d ? c - 1 : c + 1];
        vCc(a, e, d ? (Eyc(), Cyc) : (Eyc(), Byc));
        for(i = f, k = 0, m = i.length; k < m; ++k){
            g = i[k];
            yCc(a, g, n);
        }
        vCc(a, f, d ? (Eyc(), Byc) : (Eyc(), Cyc));
        for(h = e, j = 0, l = h.length; j < l; ++j){
            g = h[j];
            !!g.e || yCc(a, g, Tjd(n));
        }
    } else for(h = f, j = 0, l = h.length; j < l; ++j){
        g = h[j];
        yCc(a, g, n);
    }
    return false;
}
function Old(a, b, c, d, e) {
    var f, g, h, i, j, k, l;
    pnb();
    Slb(a, new Cmd);
    h = new Ajb(a, 0);
    l = new Ulb;
    f = 0;
    while(h.b < h.d.gc()){
        g = (rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 162));
        if (l.c.length != 0 && cmd(g) * bmd(g) > f * 2) {
            k = new hmd(l);
            j = cmd(g) / bmd(g);
            i = Sld(k, b, new LYb, c, d, e, j);
            mdd(vdd(k.e), i);
            l.c.length = 0;
            f = 0;
            YCb(l.c, k);
            YCb(l.c, g);
            f = cmd(k) * bmd(k) + cmd(g) * bmd(g);
        } else {
            YCb(l.c, g);
            f += cmd(g) * bmd(g);
        }
    }
    return l;
}
function I9b(a, b) {
    var c, d, e, f, g, h, i;
    b.Sg('Port order processing', 1);
    i = JD(WMb(a, (Bwc(), Kvc)), 418);
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        for(f = new rmb(c.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            g = JD(WMb(e, Evc), 100);
            h = e.j;
            if (g == (ajd(), Wid) || g == Yid || g == Xid) {
                pnb();
                Slb(h, A9b);
            } else if (g != $id && g != _id) {
                pnb();
                Slb(h, D9b);
                K9b(h);
                i == (vyc(), uyc) && Slb(h, C9b);
            }
            e.i = true;
            dYb(e);
        }
    }
    b.Tg();
}
function Pbe(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    if (qqd(a.e)) {
        if (b != c) {
            e = JD(a.g, 122);
            n = e[c];
            g = n.Ik();
            if (Lfe(a.e, g)) {
                o = Kfe(a.e.zh(), g);
                i = -1;
                h = -1;
                d = 0;
                for(j = 0, l = b > c ? b : c; j <= l; ++j)if (j == c) h = d++;
                else {
                    f = e[j];
                    k = o.Zl(f.Ik());
                    j == b && (i = j == l && !k ? d - 1 : d);
                    k && ++d;
                }
                m = JD(TGd(a, b, c), 74);
                h != i && zUd(a, new x_d(a.e, 7, g, jfb(h), n.kd(), i));
                return m;
            }
        }
    } else return JD(pDd(a, b, c), 74);
    return JD(TGd(a, b, c), 74);
}
function WLc() {
    WLc = Zcb;
    RLc = E9c(new J9c, (CQb(), AQb), (u5b(), O4b));
    TLc = E9c(new J9c, zQb, S4b);
    ULc = C9c(E9c(new J9c, zQb, e5b), BQb, d5b);
    QLc = C9c(E9c(E9c(new J9c, zQb, I4b), AQb, J4b), BQb, K4b);
    VLc = B9c(B9c(G9c(C9c(E9c(new J9c, xQb, o5b), BQb, n5b), AQb), m5b), p5b);
    SLc = C9c(new J9c, BQb, P4b);
    OLc = C9c(E9c(E9c(E9c(new J9c, yQb, V4b), AQb, X4b), AQb, Y4b), BQb, W4b);
    PLc = C9c(E9c(E9c(new J9c, AQb, Y4b), AQb, D4b), BQb, C4b);
}
function dD(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m;
    j = gD(b) - gD(a);
    g = sD(b, j);
    i = _C(0, 0, 0);
    while(j >= 0){
        h = jD(a, g);
        if (h) {
            j < 22 ? (i.l |= 1 << j, undefined) : j < 44 ? (i.m |= 1 << j - 22, undefined) : (i.h |= 1 << j - 44, undefined);
            if (a.l == 0 && a.m == 0 && a.h == 0) break;
        }
        k = g.m;
        l = g.h;
        m = g.l;
        g.h = l >>> 1;
        g.m = k >>> 1 | (l & 1) << 21;
        g.l = m >>> 1 | (k & 1) << 21;
        --j;
    }
    c && fD(i);
    if (f) {
        if (d) {
            YC = pD(a);
            e && (YC = vD(YC, (ED(), CD)));
        } else YC = _C(a.l, a.m, a.h);
    }
    return i;
}
function uCc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    j = a.e[b.c.p][b.p] + 1;
    i = b.c.a.c.length + 1;
    for(h = new rmb(a.a); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        l = 0;
        f = 0;
        for(e = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
            new dZb(g),
            new lZb(g)
        ]))); cs(e);){
            d = JD(ds(e), 11);
            if (d.i.c == b.c) {
                l += DCc(a, d.i) + 1;
                ++f;
            }
        }
        c = l / f;
        k = g.j;
        k == (Rjd(), wjd) ? c < j ? a.f[g.p] = a.c - c : a.f[g.p] = a.b + (i - c) : k == Qjd && (c < j ? a.f[g.p] = a.b + c : a.f[g.p] = a.c - (i - c));
    }
}
function Fdb(a, b, c) {
    var d, e, f, g, h;
    if (a == null) throw scb(new Mfb(Rqe));
    f = a.length;
    g = f > 0 && (ADb(0, a.length), a.charCodeAt(0) == 45 || (ADb(0, a.length), a.charCodeAt(0) == 43)) ? 1 : 0;
    for(d = g; d < f; d++){
        if (Wdb((ADb(d, a.length), a.charCodeAt(d))) == -1) throw scb(new Mfb(Jse + a + '"'));
    }
    h = parseInt(a, 10);
    e = h < b;
    if (isNaN(h)) throw scb(new Mfb(Jse + a + '"'));
    else if (e || h > c) throw scb(new Mfb(Jse + a + '"'));
    return h;
}
function gkc(a) {
    var b, c, d, e, f, g, h;
    g = new Mtb;
    for(f = new rmb(a.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 116);
        SMc(e, e.f.c.length);
        TMc(e, e.k.c.length);
        if (e.i == 0) {
            e.o = 0;
            Dtb(g, e, g.c.b, g.c);
        }
    }
    while(g.b != 0){
        e = JD(g.b == 0 ? null : (rDb(g.b != 0), Ktb(g, g.a.a)), 116);
        d = e.o + 1;
        for(c = new rmb(e.f); c.a < c.c.c.length;){
            b = JD(pmb(c), 133);
            h = b.a;
            UMc(h, $wnd.Math.max(h.o, d));
            TMc(h, h.i - 1);
            h.i == 0 && Dtb(g, h, g.c.b, g.c);
        }
    }
}
function V8c(a) {
    var b, c, d, e, f, g, h, i;
    for(g = new rmb(a); g.a < g.c.c.length;){
        f = JD(pmb(g), 85);
        d = _Bd(JD(nDd((!f.b && (f.b = new ree(v3, f, 4, 7)), f.b), 0), 84));
        h = d.i;
        i = d.j;
        e = JD(nDd((!f.a && (f.a = new X0d(w3, f, 6, 6)), f.a), 0), 168);
        pud(e, e.j + h, e.k + i);
        iud(e, e.b + h, e.c + i);
        for(c = new CHd((!e.a && (e.a = new qVd(u3, e, 5)), e.a)); c.e != c.i.gc();){
            b = JD(AHd(c), 369);
            ysd(b, b.a + h, b.b + i);
        }
        Odd(JD(ksd(f, (Lgd(), tfd)), 77), h, i);
    }
}
function Zme(a) {
    var b;
    switch(a){
        case 100:
            return cne(PGe, true);
        case 68:
            return cne(PGe, false);
        case 119:
            return cne(QGe, true);
        case 87:
            return cne(QGe, false);
        case 115:
            return cne(RGe, true);
        case 83:
            return cne(RGe, false);
        case 99:
            return cne(SGe, true);
        case 67:
            return cne(SGe, false);
        case 105:
            return cne(TGe, true);
        case 73:
            return cne(TGe, false);
        default:
            throw scb(new qz((b = a, OGe + b.toString(16))));
    }
}
function lUb(a) {
    var b, c, d, e, f;
    e = JD(Mlb(a.a, 0), 9);
    b = new tYb(a);
    Ilb(a.a, b);
    b.o.a = $wnd.Math.max(1, e.o.a);
    b.o.b = $wnd.Math.max(1, e.o.b);
    b.n.a = e.n.a;
    b.n.b = e.n.b;
    switch(JD(WMb(e, (Iqc(), Tpc)), 64).g){
        case 4:
            b.n.a += 2;
            break;
        case 1:
            b.n.b += 2;
            break;
        case 2:
            b.n.a -= 2;
            break;
        case 3:
            b.n.b -= 2;
    }
    d = new bZb;
    _Yb(d, b);
    c = new kWb;
    f = JD(Mlb(e.j, 0), 11);
    gWb(c, f);
    hWb(c, d);
    mdd(vdd(d.n), f.n);
    mdd(vdd(d.a), f.a);
    return b;
}
function Wkc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    e = b;
    h = c;
    if (d < 0) {
        e = c;
        h = b;
    }
    f = JD(Nib(a.a, e), 50);
    i = JD(Nib(a.a, h), 50);
    g = JD(Nib(a.d, e), 50);
    j = JD(Nib(a.d, h), 50);
    f.a.yc(h, f);
    j.a.yc(e, j);
    for(n = i.a.ec().Jc(); n.Ob();){
        m = JD(n.Pb(), 11);
        f.a.yc(m, f);
        Nrb(JD(Nib(a.d, m), 50), e);
        xe(JD(Nib(a.d, m), 50), g);
    }
    for(l = g.a.ec().Jc(); l.Ob();){
        k = JD(l.Pb(), 11);
        j.a.yc(k, j);
        Nrb(JD(Nib(a.a, k), 50), h);
        xe(JD(Nib(a.a, k), 50), i);
    }
}
function TPc(a, b, c) {
    var d, e, f, g, h;
    f = 0;
    for(e = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); e.e != e.i.gc();){
        d = JD(AHd(e), 27);
        g = '';
        (!d.n && (d.n = new X0d(z3, d, 1, 7)), d.n).i == 0 || (g = JD(nDd((!d.n && (d.n = new X0d(z3, d, 1, 7)), d.n), 0), 153).a);
        h = new eRc(f++, b, g);
        UMb(h, d);
        ZMb(h, (tUc(), kUc), d);
        h.e.b = d.j + d.f / 2;
        h.f.a = $wnd.Math.max(d.g, 1);
        h.e.a = d.i + d.g / 2;
        h.f.b = $wnd.Math.max(d.f, 1);
        Atb(b.b, h);
        gsb(c.f, d, h);
    }
}
function BA(a, b, c) {
    var d, e, f, g;
    if (b[0] >= a.length) {
        c.o = 0;
        return true;
    }
    switch(_fb(a, b[0])){
        case 43:
            e = 1;
            break;
        case 45:
            e = -1;
            break;
        default:
            c.o = 0;
            return true;
    }
    ++b[0];
    f = b[0];
    g = zA(a, b);
    if (g == 0 && b[0] == f) return false;
    if (b[0] < a.length && _fb(a, b[0]) == 58) {
        d = g * 60;
        ++b[0];
        f = b[0];
        g = zA(a, b);
        if (g == 0 && b[0] == f) return false;
        d += g;
    } else {
        d = g;
        d < 24 && b[0] - f <= 2 ? d *= 60 : d = d % 100 + (d / 100 | 0) * 60;
    }
    d *= e;
    c.o = -d;
    return true;
}
function Kgc(a) {
    var b, c, d, e, f, g, h, i, j;
    g = new Ulb;
    for(d = new es(Ir(kYb(a.b).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        eWb(c) && Ilb(g, new Jgc(c, Mgc(a, c.c), Mgc(a, c.d)));
    }
    for(j = (f = new Zjb(a.e).a.vc().Jc(), new ckb(f)); j.a.Ob();){
        h = (b = JD(j.a.Pb(), 43), JD(b.kd(), 112));
        h.d.p = 0;
    }
    for(i = (e = new Zjb(a.e).a.vc().Jc(), new ckb(e)); i.a.Ob();){
        h = (b = JD(i.a.Pb(), 43), JD(b.kd(), 112));
        h.d.p == 0 && Ilb(a.d, Lgc(a, h));
    }
}
function mLc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    for(g = new rmb(b.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        for(j = new rmb(f.a); j.a < j.c.c.length;){
            i = JD(pmb(j), 9);
            k = new Ulb;
            h = 0;
            for(d = new es(Ir(hYb(i).a.Jc(), new er)); cs(d);){
                c = JD(ds(d), 18);
                if (eWb(c) || !eWb(c) && c.c.i.c == c.d.i.c) continue;
                e = JD(WMb(c, (Bwc(), Pvc)), 17).a;
                if (e > h) {
                    h = e;
                    k.c.length = 0;
                }
                e == h && Ilb(k, new xod(c.c.i, c));
            }
            pnb();
            Slb(k, a.c);
            Hlb(a.b, i.p, k);
        }
    }
}
function nLc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    for(g = new rmb(b.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        for(j = new rmb(f.a); j.a < j.c.c.length;){
            i = JD(pmb(j), 9);
            k = new Ulb;
            h = 0;
            for(d = new es(Ir(kYb(i).a.Jc(), new er)); cs(d);){
                c = JD(ds(d), 18);
                if (eWb(c) || !eWb(c) && c.c.i.c == c.d.i.c) continue;
                e = JD(WMb(c, (Bwc(), Pvc)), 17).a;
                if (e > h) {
                    h = e;
                    k.c.length = 0;
                }
                e == h && Ilb(k, new xod(c.d.i, c));
            }
            pnb();
            Slb(k, a.c);
            Hlb(a.f, i.p, k);
        }
    }
}
function q$b(a) {
    var b, c, d, e, f, g, h;
    f = oxd(a);
    for(e = new CHd((!a.e && (a.e = new ree(x3, a, 7, 4)), a.e)); e.e != e.i.gc();){
        d = JD(AHd(e), 85);
        h = _Bd(JD(nDd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c), 0), 84));
        if (!kCd(h, f)) return true;
    }
    for(c = new CHd((!a.d && (a.d = new ree(x3, a, 8, 5)), a.d)); c.e != c.i.gc();){
        b = JD(AHd(c), 85);
        g = _Bd(JD(nDd((!b.b && (b.b = new ree(v3, b, 4, 7)), b.b), 0), 84));
        if (!kCd(g, f)) return true;
    }
    return false;
}
function X$b(a) {
    var b, c, d, e, f;
    d = JD(WMb(a, (Iqc(), kqc)), 27);
    f = JD(ksd(d, (Bwc(), ovc)), 181).Gc((ykd(), xkd));
    if (!a.e) {
        e = JD(WMb(a, Wpc), 22);
        b = new Edd(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
        if (e.Gc(($oc(), Toc))) {
            msd(d, Evc, (ajd(), Xid));
            mnd(d, b.a, b.b, false, true);
        } else ydb(LD(ksd(d, pvc))) || mnd(d, b.a, b.b, true, true);
    }
    f ? msd(d, ovc, mrb(xkd)) : msd(d, ovc, (c = JD(deb(z2), 10), new urb(c, JD(VCb(c, c.length), 10), 0)));
}
function KPc(a, b) {
    var c, d, e, f, g, h, i, j;
    j = LD(WMb(b, (kVc(), aVc)));
    if (j == null || (tDb(j), j)) {
        HPc(a, b);
        e = new Ulb;
        for(i = Gtb(b.b, 0); i.b != i.d.c;){
            g = JD(Utb(i), 39);
            c = GPc(a, g, null);
            if (c) {
                UMb(c, b);
                YCb(e.c, c);
            }
        }
        a.a = null;
        a.b = null;
        if (e.c.length > 1) for(d = new rmb(e); d.a < d.c.c.length;){
            c = JD(pmb(d), 120);
            f = 0;
            for(h = Gtb(c.b, 0); h.b != h.d.c;){
                g = JD(Utb(h), 39);
                g.g = f++;
            }
        }
        return e;
    }
    return _u(WC(OC(KZ, 1), oue, 120, 0, [
        b
    ]));
}
function f2b(a, b) {
    var c, d, e, f, g, h;
    for(e = new rmb(b.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        f = WMb(d, (Iqc(), kqc));
        if (RD(f, 11)) {
            g = JD(f, 11);
            h = tXb(b, d, g.o.a, g.o.b);
            g.n.a = h.a;
            g.n.b = h.b;
            aZb(g, JD(WMb(d, Tpc), 64));
        }
    }
    c = new Edd(b.f.a + b.d.b + b.d.c, b.f.b + b.d.d + b.d.a);
    if (JD(WMb(b, (Iqc(), Wpc)), 22).Gc(($oc(), Toc))) {
        ZMb(a, (Bwc(), Evc), (ajd(), Xid));
        JD(WMb(gYb(a), Wpc), 22).Ec(Woc);
        BXb(a, c, false);
    } else BXb(a, c, true);
}
function Gjc(a) {
    var b, c, d, e, f, g, h, i;
    i = new Rdd;
    b = Gtb(a, 0);
    h = null;
    c = JD(Utb(b), 8);
    e = JD(Utb(b), 8);
    while(b.b != b.d.c){
        h = c;
        c = e;
        e = JD(Utb(b), 8);
        f = Hjc(Bdd(new Edd(h.a, h.b), c));
        g = Hjc(Bdd(new Edd(e.a, e.b), c));
        d = 10;
        d = $wnd.Math.min(d, $wnd.Math.abs(f.a + f.b) / 2);
        d = $wnd.Math.min(d, $wnd.Math.abs(g.a + g.b) / 2);
        f.a = Cfb(f.a) * d;
        f.b = Cfb(f.b) * d;
        g.a = Cfb(g.a) * d;
        g.b = Cfb(g.b) * d;
        Atb(i, mdd(f, c));
        Atb(i, mdd(g, c));
    }
    return i;
}
function zEc(a, b, c) {
    var d, e, f, g, h, i;
    c.Sg('Minimize Crossings ' + a.a, 1);
    d = b.b.c.length == 0 || !PBb(BBb(new RBb(null, new Gvb(b.b, 16)), new Dzb(new $Ec))).zd((wBb(), vBb));
    i = b.b.c.length == 1 && JD(Mlb(b.b, 0), 25).a.c.length == 1;
    f = XD(WMb(b, (Bwc(), Iuc))) === XD((eid(), bid));
    if (d || i && !f) {
        c.Tg();
        return;
    }
    e = uEc(a, b);
    g = (h = JD(fu(e, 0), 217), h.c.ig() ? h.c.cg() ? new NEc(a) : new PEc(a) : new LEc(a));
    vEc(e, g);
    HEc(a);
    c.Tg();
}
function bqd(a, b, c, d) {
    var e, f, g, h, i;
    g = a.Lh();
    i = a.Fh();
    e = null;
    if (i) {
        if (!!b && (Pqd(a, b, c).Bb & Pse) == 0) {
            d = QGd(i.Bl(), a, d);
            a._h(null);
            e = b.Mh();
        } else i = null;
    } else {
        !!g && (i = g.Mh());
        !!b && (e = b.Mh());
    }
    i != e && !!i && i.Fl(a);
    h = a.Bh();
    a.xh(b, c);
    i != e && !!e && e.El(a);
    if (a.rh() && a.sh()) {
        if (!!g && h >= 0 && h != c) {
            f = new g_d(a, 1, h, g, null);
            !d ? d = f : d.kj(f);
        }
        if (c >= 0) {
            f = new g_d(a, 1, c, h == c ? g : null, b);
            !d ? d = f : d.kj(f);
        }
    }
    return d;
}
function ENd(a) {
    var b, c, d;
    if (a.b == null) {
        d = new Hgb;
        if (a.i != null) {
            Egb(d, a.i);
            d.a += ':';
        }
        if ((a.f & 256) != 0) {
            if ((a.f & 256) != 0 && a.a != null) {
                RNd(a.i) || (d.a += '//', d);
                Egb(d, a.a);
            }
            if (a.d != null) {
                d.a += '/';
                Egb(d, a.d);
            }
            (a.f & 16) != 0 && (d.a += '/', d);
            for(b = 0, c = a.j.length; b < c; b++){
                b != 0 && (d.a += '/', d);
                Egb(d, a.j[b]);
            }
            if (a.g != null) {
                d.a += '?';
                Egb(d, a.g);
            }
        } else Egb(d, a.a);
        if (a.e != null) {
            d.a += '#';
            Egb(d, a.e);
        }
        a.b = d.a;
    }
    return a.b;
}
function S8b(a, b, c, d, e) {
    var f, g, h, i;
    f = new tYb(a);
    rYb(f, (DYb(), BYb));
    ZMb(f, (Bwc(), Evc), (ajd(), Xid));
    ZMb(f, (Iqc(), kqc), b.c.i);
    g = new bZb;
    ZMb(g, kqc, b.c);
    aZb(g, e);
    _Yb(g, f);
    ZMb(b.c, sqc, f);
    h = new tYb(a);
    rYb(h, BYb);
    ZMb(h, Evc, Xid);
    ZMb(h, kqc, b.d.i);
    i = new bZb;
    ZMb(i, kqc, b.d);
    aZb(i, e);
    _Yb(i, h);
    ZMb(b.d, sqc, h);
    gWb(b, g);
    hWb(b, i);
    vDb(0, c.c.length);
    WCb(c.c, 0, f);
    YCb(d.c, h);
    ZMb(f, Kpc, jfb(1));
    ZMb(h, Kpc, jfb(1));
}
function Ao(a, b, c, d) {
    var e, f, g, h, i;
    i = Pcb(Fcb(yre, hfb(Pcb(Fcb(b == null ? 0 : tb(b), zre)), 15)));
    e = Pcb(Fcb(yre, hfb(Pcb(Fcb(c == null ? 0 : tb(c), zre)), 15)));
    h = Do(a, b, i);
    g = Co(a, c, e);
    if (!!h && e == h.a && Hb(c, h.g)) return c;
    else if (!!g && !d) throw scb(new Teb('key already present: ' + c));
    !!h && uo(a, h);
    !!g && uo(a, g);
    f = new gp(c, e, b, i);
    xo(a, f, g);
    if (g) {
        g.e = null;
        g.c = null;
    }
    if (h) {
        h.e = null;
        h.c = null;
    }
    Bo(a);
    return !h ? null : h.g;
}
function Kib(a, b, c) {
    var d, e, f, g, h;
    for(f = 0; f < b; f++){
        d = 0;
        for(h = f + 1; h < b; h++){
            d = tcb(tcb(Fcb(ucb(a[f], Use), ucb(a[h], Use)), ucb(c[f + h], Use)), ucb(Pcb(d), Use));
            c[f + h] = Pcb(d);
            d = Lcb(d, 32);
        }
        c[f + b] = Pcb(d);
    }
    jib(c, c, b << 1);
    d = 0;
    for(e = 0, g = 0; e < b; ++e, g++){
        d = tcb(tcb(Fcb(ucb(a[e], Use), ucb(a[e], Use)), ucb(c[g], Use)), ucb(Pcb(d), Use));
        c[g] = Pcb(d);
        d = Lcb(d, 32);
        ++g;
        d = tcb(d, ucb(c[g], Use));
        c[g] = Pcb(d);
        d = Lcb(d, 32);
    }
    return c;
}
function AIc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (cr(b)) return;
    i = Beb(MD(kzc(c.c, (Bwc(), iwc))));
    j = JD(kzc(c.c, hwc), 139);
    !j && (j = new ZXb);
    d = c.a;
    e = null;
    for(h = b.Jc(); h.Ob();){
        g = JD(h.Pb(), 11);
        k = 0;
        if (!e) k = j.d;
        else {
            k = i;
            k += e.o.b;
        }
        f = pGb(qGb(new rGb, g), a.f);
        Qib(a.k, g, f);
        DFb(GFb(FFb(EFb(HFb(new IFb, 0), YD($wnd.Math.ceil(k))), d), f));
        e = g;
        d = f;
    }
    DFb(GFb(FFb(EFb(HFb(new IFb, 0), YD($wnd.Math.ceil(j.a + e.o.b))), d), c.d));
}
function Z2c(a, b, c, d, e, f, g, h) {
    var i, j, k, l, m, n;
    n = false;
    m = f - c.s;
    k = c.t - b.f + (j = g4c(c, m, false), j.a);
    if (d.g + h > m) return false;
    l = (i = g4c(d, m, false), i.a);
    if (k + h + l <= b.b) {
        e4c(c, f - c.s);
        c.c = true;
        e4c(d, f - c.s);
        i4c(d, c.s, c.t + c.d + h);
        d.k = true;
        q4c(c.q, d);
        n = true;
        if (e) {
            S4c(b, d);
            d.j = b;
            if (a.c.length > g) {
                V4c((sDb(g, a.c.length), JD(a.c[g], 186)), d);
                (sDb(g, a.c.length), JD(a.c[g], 186)).a.c.length == 0 && Olb(a, g);
            }
        }
    }
    return n;
}
function c9b(a, b) {
    var c, d, e, f, g, h;
    b.Sg('Partition midprocessing', 1);
    e = new Pp;
    EBb(BBb(new RBb(null, new Gvb(a.a, 16)), new g9b), new i9b(e));
    if (e.d == 0) return;
    h = JD(yBb(NBb((f = e.i, new RBb(null, (!f ? e.i = new xf(e, e.c) : f).Lc()))), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    d = h.Jc();
    c = JD(d.Pb(), 17);
    while(d.Ob()){
        g = JD(d.Pb(), 17);
        b9b(JD(Qc(e, c), 22), JD(Qc(e, g), 22));
        c = g;
    }
    b.Tg();
}
function Fud(a, b) {
    var c, d, e, f, g;
    if (a.Ab) {
        if (a.Ab) {
            g = a.Ab.i;
            if (g > 0) {
                e = JD(a.Ab.g, 1979);
                if (b == null) for(f = 0; f < g; ++f){
                    c = e[f];
                    if (c.d == null) return c;
                }
                else for(f = 0; f < g; ++f){
                    c = e[f];
                    if (cgb(b, c.d)) return c;
                }
            }
        } else {
            if (b == null) for(d = new CHd(a.Ab); d.e != d.i.gc();){
                c = JD(AHd(d), 582);
                if (c.d == null) return c;
            }
            else for(d = new CHd(a.Ab); d.e != d.i.gc();){
                c = JD(AHd(d), 582);
                if (cgb(b, c.d)) return c;
            }
        }
    }
    return null;
}
function Fyd(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, p, q, r, s, t, u, v;
    n = gzd(a, dCd(b), e);
    lud(n, byd(e, vDe));
    o = null;
    p = e;
    q = ayd(p, yDe);
    r = new Xzd(n);
    Kyd(r.a, q);
    s = ayd(p, 'endPoint');
    t = new dAd(n);
    Myd(t.a, s);
    u = $xd(p, oDe);
    v = new jAd(n);
    Nyd(v.a, u);
    l = byd(e, qDe);
    f = new Pzd(a, n);
    Gyd(f.a, f.b, l);
    m = byd(e, pDe);
    g = new Rzd(a, n);
    Hyd(g.a, g.b, m);
    j = $xd(e, sDe);
    h = new Tzd(c, n);
    Iyd(h.b, h.a, j);
    k = $xd(e, rDe);
    i = new Vzd(d, n);
    Jyd(i.b, i.a, k);
}
function QUb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (b.p == 0) {
        b.p = 1;
        g = c;
        if (!g) {
            e = new Ulb;
            f = (d = JD(deb(v2), 10), new urb(d, JD(VCb(d, d.length), 10), 0));
            g = new xod(e, f);
        }
        JD(g.a, 15).Ec(b);
        b.k == (DYb(), wYb) && JD(g.b, 22).Ec(JD(WMb(b, (Iqc(), Tpc)), 64));
        for(i = new rmb(b.j); i.a < i.c.c.length;){
            h = JD(pmb(i), 11);
            for(k = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
                new dZb(h),
                new lZb(h)
            ]))); cs(k);){
                j = JD(ds(k), 11);
                QUb(a, j.i, g);
            }
        }
        return g;
    }
    return null;
}
function AXb(a, b, c) {
    var d, e, f, g, h;
    h = null;
    switch(b.g){
        case 1:
            for(e = new rmb(a.j); e.a < e.c.c.length;){
                d = JD(pmb(e), 11);
                if (ydb(LD(WMb(d, (Iqc(), Ypc))))) return d;
            }
            h = new bZb;
            ZMb(h, (Iqc(), Ypc), (xdb(), true));
            break;
        case 2:
            for(g = new rmb(a.j); g.a < g.c.c.length;){
                f = JD(pmb(g), 11);
                if (ydb(LD(WMb(f, (Iqc(), qqc))))) return f;
            }
            h = new bZb;
            ZMb(h, (Iqc(), qqc), (xdb(), true));
    }
    if (h) {
        _Yb(h, a);
        aZb(h, c);
        nXb(h.n, a.o, c);
    }
    return h;
}
function p0b(a, b) {
    var c, d, e, f, g, h;
    h = -1;
    g = new Mtb;
    for(d = new xZb(a.b); omb(d.a) || omb(d.b);){
        c = JD(omb(d.a) ? pmb(d.a) : pmb(d.b), 18);
        h = $wnd.Math.max(h, Beb(MD(WMb(c, (Bwc(), Fuc)))));
        c.c == a ? EBb(BBb(new RBb(null, new Gvb(c.b, 16)), new v0b), new x0b(g)) : EBb(BBb(new RBb(null, new Gvb(c.b, 16)), new z0b), new B0b(g));
        for(f = Gtb(g, 0); f.b != f.d.c;){
            e = JD(Utb(f), 72);
            XMb(e, (Iqc(), Ppc)) || ZMb(e, Ppc, c);
        }
        Klb(b, g);
        Ltb(g);
    }
    return h;
}
function cOc(a, b, c, d, e) {
    var f, g, h, i, j;
    h = e ? d.b : d.a;
    if (Orb(a.a, d)) return;
    j = h > c.s && h < c.c;
    i = false;
    if (c.e.b != 0 && c.j.b != 0) {
        i = i | ($wnd.Math.abs(h - Beb(MD(Etb(c.e)))) < Fue && $wnd.Math.abs(h - Beb(MD(Etb(c.j)))) < Fue);
        i = i | ($wnd.Math.abs(h - Beb(MD(Ftb(c.e)))) < Fue && $wnd.Math.abs(h - Beb(MD(Ftb(c.j)))) < Fue);
    }
    if (j || i) {
        g = JD(WMb(b, (Bwc(), Ruc)), 77);
        if (!g) {
            g = new Rdd;
            ZMb(b, Ruc, g);
        }
        f = new Fdd(d);
        Dtb(g, f, g.c.b, g.c);
        Nrb(a.a, f);
    }
}
function BTc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    c.Sg('Processor set coordinates', 1);
    a.a = b.b.b == 0 ? 1 : b.b.b;
    j = null;
    d = Gtb(b.b, 0);
    while(!j && d.b != d.d.c){
        l = JD(Utb(d), 39);
        if (ydb(LD(WMb(l, (tUc(), qUc))))) {
            j = l;
            i = l.e;
            i.a = JD(WMb(l, rUc), 17).a;
            i.b = JD(WMb(l, sUc), 17).a;
        }
    }
    h = bRc(j);
    k = 1;
    do {
        h = CTc((e = h, c.bh(k), e));
        k = h.b / a.a | 0;
    }while (h.b != 0);
    for(g = Gtb(b.b, 0); g.b != g.d.c;){
        f = JD(Utb(g), 39);
        Bdd(f.e, new Edd(f.f.a / 2, f.f.b / 2));
    }
    c.Tg();
}
function SHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    c = false;
    k = Beb(MD(WMb(b, (Bwc(), ewc))));
    o = Kre * k;
    for(e = new rmb(b.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        j = new rmb(d.a);
        f = JD(pmb(j), 9);
        l = $Hc(a.a[f.p]);
        while(j.a < j.c.c.length){
            h = JD(pmb(j), 9);
            m = $Hc(a.a[h.p]);
            if (l != m) {
                n = ezc(a.b, f, h);
                g = f.n.b + f.o.b + f.d.a + l.a + n;
                i = h.n.b - h.d.d + m.a;
                if (g > i + o) {
                    p = l.g + m.g;
                    m.a = (m.g * m.a + l.g * l.a) / p;
                    m.g = p;
                    l.f = m;
                    c = true;
                }
            }
            f = h;
            l = m;
        }
    }
    return c;
}
function xSc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    c.Sg(Hze, 1);
    Tib(a.b);
    Tib(a.a);
    h = null;
    f = Gtb(b.b, 0);
    while(!h && f.b != f.d.c){
        j = JD(Utb(f), 39);
        ydb(LD(WMb(j, (tUc(), qUc)))) && (h = j);
    }
    i = new Mtb;
    Dtb(i, h, i.c.b, i.c);
    wSc(a, i);
    for(k = Gtb(b.b, 0); k.b != k.d.c;){
        j = JD(Utb(k), 39);
        g = OD(WMb(j, (tUc(), dUc)));
        e = Oib(a.b, g) != null ? JD(Oib(a.b, g), 17).a : 0;
        ZMb(j, $Tc, jfb(e));
        d = 1 + (Oib(a.a, g) != null ? JD(Oib(a.a, g), 17).a : 0);
        ZMb(j, YTc, jfb(d));
    }
    c.Tg();
}
function ved(a) {
    Rad(a, new cad(nad(kad(mad(lad(new pad, IBe), 'ELK Box'), 'Algorithm for packing of unconnected boxes, i.e. graphs without edges.'), new yed)));
    Pad(a, IBe, Rue, red);
    Pad(a, IBe, Mue, 15);
    Pad(a, IBe, Lue, jfb(0));
    Pad(a, IBe, JBe, JBd(led));
    Pad(a, IBe, Yue, JBd(ned));
    Pad(a, IBe, Xue, JBd(ped));
    Pad(a, IBe, Oue, HBe);
    Pad(a, IBe, Sue, JBd(med));
    Pad(a, IBe, pve, JBd(oed));
    Pad(a, IBe, KBe, JBd(jed));
    Pad(a, IBe, Qye, JBd(ked));
}
function mXb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    e = a.i;
    g = e.o.a;
    f = e.o.b;
    if (g <= 0 && f <= 0) return Rjd(), Pjd;
    j = a.n.a;
    k = a.n.b;
    h = a.o.a;
    c = a.o.b;
    switch(b.g){
        case 2:
        case 1:
            if (j < 0) return Rjd(), Qjd;
            else if (j + h > g) return Rjd(), wjd;
            break;
        case 4:
        case 3:
            if (k < 0) return Rjd(), xjd;
            else if (k + c > f) return Rjd(), Ojd;
    }
    i = (j + h / 2) / g;
    d = (k + c / 2) / f;
    return i + d <= 1 && i - d <= 0 ? (Rjd(), Qjd) : i + d >= 1 && i - d >= 0 ? (Rjd(), wjd) : d < 0.5 ? (Rjd(), xjd) : (Rjd(), Ojd);
}
function XGb(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m;
    m = new fdd;
    for(j = b.Jc(); j.Ob();){
        h = JD(j.Pb(), 832);
        for(l = new rmb(h.Pf()); l.a < l.c.c.length;){
            k = JD(pmb(l), 187);
            if (XD(k.mf((Lgd(), bfd))) === XD((nhd(), mhd))) {
                UGb(m, k, false, d, e, f, g);
                edd(a, m);
            }
        }
    }
    for(i = c.Jc(); i.Ob();){
        h = JD(i.Pb(), 832);
        for(l = new rmb(h.Pf()); l.a < l.c.c.length;){
            k = JD(pmb(l), 187);
            if (XD(k.mf((Lgd(), bfd))) === XD((nhd(), lhd))) {
                UGb(m, k, true, d, e, f, g);
                edd(a, m);
            }
        }
    }
}
function SPc(a, b, c) {
    var d, e, f, g, h, i, j;
    for(g = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); g.e != g.i.gc();){
        f = JD(AHd(g), 27);
        for(e = new es(Ir($Bd(f).a.Jc(), new er)); cs(e);){
            d = JD(ds(e), 85);
            if (!Rtd(d) && !Rtd(d) && !Std(d)) {
                i = JD(Wd(fsb(c.f, f)), 39);
                j = JD(Nib(c, _Bd(JD(nDd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c), 0), 84))), 39);
                if (!!i && !!j) {
                    h = new ZQc(i, j);
                    ZMb(h, (tUc(), kUc), d);
                    UMb(h, d);
                    Atb(i.d, h);
                    Atb(j.b, h);
                    Atb(b.a, h);
                }
            }
        }
    }
}
function SKb(a, b) {
    var c, d, e, f, g, h, i, j;
    for(i = JD(JD(Qc(a.r, b), 22), 83).Jc(); i.Ob();){
        h = JD(i.Pb(), 115);
        e = h.c ? $Hb(h.c) : 0;
        if (e > 0) {
            if (h.a) {
                j = h.b.Kf().b;
                if (e > j) {
                    if (a.v || h.c.d.c.length == 1) {
                        g = (e - j) / 2;
                        h.d.d = g;
                        h.d.a = g;
                    } else {
                        c = JD(Mlb(h.c.d, 0), 187).Kf().b;
                        d = (c - j) / 2;
                        h.d.d = $wnd.Math.max(0, d);
                        h.d.a = e - d - j;
                    }
                }
            } else h.d.a = a.t + e;
        } else if (qjd(a.u)) {
            f = end(h.b);
            f.d < 0 && (h.d.d = -f.d);
            f.d + f.a > h.b.Kf().b && (h.d.a = f.d + f.a - h.b.Kf().b);
        }
    }
}
function IOb() {
    IOb = Zcb;
    vOb = new NBd((Lgd(), ggd), jfb(1));
    BOb = new NBd(wgd, 80);
    AOb = new NBd(pgd, 5);
    hOb = new NBd(Qed, Jue);
    wOb = new NBd(hgd, jfb(1));
    zOb = new NBd(kgd, (xdb(), true));
    sOb = new MYb(50);
    rOb = new NBd(Kfd, sOb);
    jOb = nfd;
    tOb = Yfd;
    iOb = new NBd(afd, false);
    qOb = Jfd;
    oOb = Dfd;
    pOb = Gfd;
    nOb = Bfd;
    mOb = zfd;
    uOb = agd;
    lOb = (YNb(), RNb);
    COb = WNb;
    kOb = QNb;
    xOb = TNb;
    yOb = VNb;
    FOb = Dgd;
    HOb = Hgd;
    EOb = Cgd;
    DOb = Bgd;
    GOb = (Wkd(), Tkd);
    new NBd(Egd, GOb);
}
function NC(a, b) {
    var c;
    switch(PC(a)){
        case 6:
            return VD(b);
        case 7:
            return TD(b);
        case 8:
            return SD(b);
        case 3:
            return Array.isArray(b) && (c = PC(b), !(c >= 14 && c <= 16));
        case 11:
            return b != null && typeof b === Gqe;
        case 12:
            return b != null && (typeof b === Cqe || typeof b == Gqe);
        case 0:
            return ID(b, a.__elementTypeId$);
        case 2:
            return WD(b) && !(b.Qm === bdb);
        case 1:
            return WD(b) && !(b.Qm === bdb) || ID(b, a.__elementTypeId$);
        default:
            return true;
    }
}
function rKb(a) {
    var b, c, d, e;
    d = a.o;
    aKb();
    if (a.A.dc() || pb(a.A, _Jb)) e = d.a;
    else {
        a.D ? e = $wnd.Math.max(d.a, iIb(a.f)) : e = iIb(a.f);
        if (a.A.Gc((ykd(), vkd)) && !a.B.Gc((Nkd(), Jkd))) {
            e = $wnd.Math.max(e, iIb(JD(Kqb(a.p, (Rjd(), xjd)), 251)));
            e = $wnd.Math.max(e, iIb(JD(Kqb(a.p, Ojd), 251)));
        }
        b = cKb(a);
        !!b && (e = $wnd.Math.max(e, b.a));
    }
    ydb(LD(a.e.Rf().mf((Lgd(), Dfd)))) ? d.a = $wnd.Math.max(d.a, e) : d.a = e;
    c = a.f.i;
    c.c = 0;
    c.b = e;
    jIb(a.f);
}
function wMb(a, b) {
    var c, d, e, f;
    d = $wnd.Math.min($wnd.Math.abs(a.c - (b.c + b.b)), $wnd.Math.abs(a.c + a.b - b.c));
    f = $wnd.Math.min($wnd.Math.abs(a.d - (b.d + b.a)), $wnd.Math.abs(a.d + a.a - b.d));
    c = $wnd.Math.abs(a.c + a.b / 2 - (b.c + b.b / 2));
    if (c > a.b / 2 + b.b / 2) return 1;
    e = $wnd.Math.abs(a.d + a.a / 2 - (b.d + b.a / 2));
    if (e > a.a / 2 + b.a / 2) return 1;
    if (c == 0 && e == 0) return 0;
    if (c == 0) return f / e + 1;
    if (e == 0) return d / c + 1;
    return $wnd.Math.min(d / c, f / e) + 1;
}
function yPb(a, b) {
    var c, d, e, f, g, h, i;
    f = 0;
    h = 0;
    i = 0;
    for(e = new rmb(a.f.e); e.a < e.c.c.length;){
        d = JD(pmb(e), 151);
        if (b == d) continue;
        g = a.i[b.a][d.a];
        f += g;
        c = pdd(b.d, d.d);
        c > 0 && a.d != (KPb(), JPb) && (h += g * (d.d.a + a.a[b.a][d.a] * (b.d.a - d.d.a) / c));
        c > 0 && a.d != (KPb(), HPb) && (i += g * (d.d.b + a.a[b.a][d.a] * (b.d.b - d.d.b) / c));
    }
    switch(a.d.g){
        case 1:
            return new Edd(h / f, b.d.b);
        case 2:
            return new Edd(b.d.a, i / f);
        default:
            return new Edd(h / f, i / f);
    }
}
function fnd(a) {
    var b, c, d, e, f, g;
    c = (!a.a && (a.a = new qVd(u3, a, 5)), a.a).i + 2;
    g = new Vlb(c);
    Ilb(g, new Edd(a.j, a.k));
    EBb(new RBb(null, (!a.a && (a.a = new qVd(u3, a, 5)), new Gvb(a.a, 16))), new Cnd(g));
    Ilb(g, new Edd(a.b, a.c));
    b = 1;
    while(b < g.c.length - 1){
        d = (sDb(b - 1, g.c.length), JD(g.c[b - 1], 8));
        e = (sDb(b, g.c.length), JD(g.c[b], 8));
        f = (sDb(b + 1, g.c.length), JD(g.c[b + 1], 8));
        d.a == e.a && e.a == f.a || d.b == e.b && e.b == f.b ? Olb(g, b) : ++b;
    }
    return g;
}
function O9b(a, b) {
    G9b();
    var c, d, e, f, g;
    g = JD(WMb(a.i, (Bwc(), Evc)), 100);
    f = a.j.g - b.j.g;
    if (f != 0 || !(g == (ajd(), Wid) || g == Yid || g == Xid)) return 0;
    if (g == (ajd(), Wid)) {
        c = JD(WMb(a, Fvc), 17);
        d = JD(WMb(b, Fvc), 17);
        if (!!c && !!d) {
            e = c.a - d.a;
            if (e != 0) return e;
        }
    }
    switch(a.j.g){
        case 1:
            return Heb(a.n.a, b.n.a);
        case 2:
            return Heb(a.n.b, b.n.b);
        case 3:
            return Heb(b.n.a, a.n.a);
        case 4:
            return Heb(b.n.b, a.n.b);
        default:
            throw scb(new Web(Hve));
    }
}
function Rdc(a, b) {
    var c, d, e, f, g, h, i;
    c = lEb(oEb(mEb(nEb(new pEb, b), new hdd(b.e)), zdc), a.a);
    b.j.c.length == 0 || dEb(JD(Mlb(b.j, 0), 60).a, c);
    i = new bFb;
    Qib(a.e, c, i);
    g = new Qrb;
    h = new Qrb;
    for(f = new rmb(b.k); f.a < f.c.c.length;){
        e = JD(pmb(f), 18);
        Nrb(g, e.c);
        Nrb(h, e.d);
    }
    d = g.a.gc() - h.a.gc();
    if (d < 0) {
        _Eb(i, true, (Tgd(), Pgd));
        _Eb(i, false, Qgd);
    } else if (d > 0) {
        _Eb(i, false, (Tgd(), Pgd));
        _Eb(i, true, Qgd);
    }
    Llb(b.g, new bfc(a, c));
    Qib(a.g, b, c);
}
function I1c() {
    I1c = Zcb;
    z1c = new MBd(HAe, (xdb(), false));
    jfb(-1);
    r1c = new MBd(IAe, jfb(-1));
    jfb(-1);
    s1c = new MBd(JAe, jfb(-1));
    t1c = new MBd(KAe, false);
    u1c = new MBd(LAe, false);
    G1c = (O2c(), M2c);
    F1c = new MBd(MAe, G1c);
    H1c = new MBd(NAe, -1);
    E1c = (l1c(), k1c);
    D1c = new MBd(OAe, E1c);
    C1c = new MBd(PAe, true);
    y1c = (q3c(), n3c);
    x1c = new MBd(QAe, y1c);
    w1c = new MBd(RAe, false);
    jfb(1);
    v1c = new MBd(SAe, jfb(1));
    B1c = (R3c(), P3c);
    A1c = new MBd(TAe, B1c);
}
function Lfb() {
    Lfb = Zcb;
    var a;
    Hfb = WC(OC(cE, 1), ise, 30, 15, [
        -1,
        -1,
        30,
        19,
        15,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5
    ]);
    Ifb = SC(cE, ise, 30, 37, 15, 1);
    Jfb = WC(OC(cE, 1), ise, 30, 15, [
        -1,
        -1,
        63,
        40,
        32,
        28,
        25,
        23,
        21,
        20,
        19,
        19,
        18,
        18,
        17,
        17,
        16,
        16,
        16,
        15,
        15,
        15,
        15,
        14,
        14,
        14,
        14,
        14,
        14,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13
    ]);
    Kfb = SC(dE, Nse, 30, 37, 14, 1);
    for(a = 2; a <= 36; a++){
        Ifb[a] = YD($wnd.Math.pow(a, Hfb[a]));
        Kfb[a] = xcb(mre, Ifb[a]);
    }
}
function bnd(a) {
    var b;
    if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i != 1) throw scb(new Teb(uCe + (!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i));
    b = new Rdd;
    !!aCd(JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84)) && xe(b, cnd(a, aCd(JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84)), false));
    !!aCd(JD(nDd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c), 0), 84)) && xe(b, cnd(a, aCd(JD(nDd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c), 0), 84)), true));
    return b;
}
function CLc(a, b) {
    var c, d, e, f, g;
    b.d ? e = a.a.c == (zKc(), yKc) ? hYb(b.b) : kYb(b.b) : e = a.a.c == (zKc(), xKc) ? hYb(b.b) : kYb(b.b);
    f = false;
    for(d = new es(Ir(e.a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 18);
        g = ydb(a.a.f[a.a.g[b.b.p].p]);
        if (!g && !eWb(c) && c.c.i.c == c.d.i.c) continue;
        if (ydb(a.a.n[a.a.g[b.b.p].p]) || ydb(a.a.n[a.a.g[b.b.p].p])) continue;
        f = true;
        if (Orb(a.b, a.a.g[uLc(c, b.b).p])) {
            b.c = true;
            b.a = c;
            return b;
        }
    }
    b.c = f;
    b.a = null;
    return b;
}
function nFd(a, b, c) {
    var d, e, f, g, h, i, j;
    d = c.gc();
    if (d == 0) return false;
    else {
        if (a.Mj()) {
            i = a.Nj();
            wEd(a, b, c);
            g = d == 1 ? a.Fj(3, null, c.Jc().Pb(), b, i) : a.Fj(5, null, c, b, i);
            if (a.Jj()) {
                h = d < 100 ? null : new FGd(d);
                f = b + d;
                for(e = b; e < f; ++e){
                    j = a.uj(e);
                    h = a.Kj(j, h);
                    h;
                }
                if (!h) a.Gj(g);
                else {
                    h.kj(g);
                    h.lj();
                }
            } else a.Gj(g);
        } else {
            wEd(a, b, c);
            if (a.Jj()) {
                h = d < 100 ? null : new FGd(d);
                f = b + d;
                for(e = b; e < f; ++e)h = a.Kj(a.uj(e), h);
                !!h && h.lj();
            }
        }
        return true;
    }
}
function tFd(a, b, c) {
    var d, e, f, g, h;
    if (a.Mj()) {
        e = null;
        f = a.Nj();
        d = a.Fj(1, h = (g = a.Aj(b, a.Wi(b, c)), g), c, b, f);
        if (a.Jj() && !(a.Vi() && !!h ? pb(h, c) : XD(h) === XD(c))) {
            !!h && (e = a.Lj(h, e));
            e = a.Kj(c, e);
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        } else if (!e) a.Gj(d);
        else {
            e.kj(d);
            e.lj();
        }
        return h;
    } else {
        h = (g = a.Aj(b, a.Wi(b, c)), g);
        if (a.Jj() && !(a.Vi() && !!h ? pb(h, c) : XD(h) === XD(c))) {
            e = null;
            !!h && (e = a.Lj(h, null));
            e = a.Kj(c, e);
            !!e && e.lj();
        }
        return h;
    }
}
function xNb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    a.e = b;
    a.f = JD(WMb(b, (TOb(), SOb)), 233);
    oNb(b);
    a.d = $wnd.Math.max(b.e.c.length * 16 + b.c.c.length, 256);
    if (!ydb(LD(WMb(b, (IOb(), jOb))))) {
        k = a.e.e.c.length;
        for(i = new rmb(b.e); i.a < i.c.c.length;){
            h = JD(pmb(i), 151);
            j = h.d;
            j.a = wvb(a.f) * k;
            j.b = wvb(a.f) * k;
        }
    }
    c = b.b;
    for(f = new rmb(b.c); f.a < f.c.c.length;){
        e = JD(pmb(f), 288);
        d = JD(WMb(e, yOb), 17).a;
        if (d > 0) {
            for(g = 0; g < d; g++)Ilb(c, new eNb(e));
            gNb(e);
        }
    }
}
function I3b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    b.Sg('Hypernodes processing', 1);
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        for(h = new rmb(d.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            if (ydb(LD(WMb(g, (Bwc(), Muc)))) && g.j.c.length <= 2) {
                l = 0;
                k = 0;
                c = 0;
                f = 0;
                for(j = new rmb(g.j); j.a < j.c.c.length;){
                    i = JD(pmb(j), 11);
                    switch(i.j.g){
                        case 1:
                            ++l;
                            break;
                        case 2:
                            ++k;
                            break;
                        case 3:
                            ++c;
                            break;
                        case 4:
                            ++f;
                    }
                }
                l == 0 && c == 0 && H3b(a, g, f <= k);
            }
        }
    }
    b.Tg();
}
function kEd(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    m = new GC(a.Xg());
    kC(b, HDe, m);
    if (c && !a.Vg().a.dc()) {
        k = new EB;
        kC(b, 'logs', k);
        h = 0;
        for(o = new Fob(a.Vg().b.Jc()); o.b.Ob();){
            n = OD(o.b.Pb());
            l = new GC(n);
            BB(k, h);
            DB(k, h, l);
            ++h;
        }
    }
    if (d) {
        j = new _B(a.Ug());
        kC(b, 'executionTime', j);
    }
    if (!a.Wg().a.dc()) {
        g = new EB;
        kC(b, jDe, g);
        h = 0;
        for(f = new Fob(a.Wg().b.Jc()); f.b.Ob();){
            e = JD(f.b.Pb(), 847);
            i = new mC;
            BB(g, h);
            DB(g, h, i);
            kEd(e, i, c, d);
            ++h;
        }
    }
}
function Mpe() {
    Mpe = Zcb;
    _de();
    Lpe = new Npe;
    WC(OC(t6, 2), hre, 373, 0, [
        WC(OC(t6, 1), aHe, 584, 0, [
            new Jpe(xGe)
        ])
    ]);
    WC(OC(t6, 2), hre, 373, 0, [
        WC(OC(t6, 1), aHe, 584, 0, [
            new Jpe(yGe)
        ])
    ]);
    WC(OC(t6, 2), hre, 373, 0, [
        WC(OC(t6, 1), aHe, 584, 0, [
            new Jpe(zGe)
        ]),
        WC(OC(t6, 1), aHe, 584, 0, [
            new Jpe(yGe)
        ])
    ]);
    new Xhb('-1');
    WC(OC(t6, 2), hre, 373, 0, [
        WC(OC(t6, 1), aHe, 584, 0, [
            new Jpe('\\c+')
        ])
    ]);
    new Xhb('0');
    new Xhb('0');
    new Xhb('1');
    new Xhb('0');
    new Xhb(JGe);
}
function x3b(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    c.Sg('Hyperedge merging', 1);
    v3b(a, b);
    i = new Ajb(b.b, 0);
    while(i.b < i.d.gc()){
        h = (rDb(i.b < i.d.gc()), JD(i.d.Xb(i.c = i.b++), 25));
        k = h.a;
        if (k.c.length == 0) continue;
        d = null;
        e = null;
        f = null;
        g = null;
        for(j = 0; j < k.c.length; j++){
            d = (sDb(j, k.c.length), JD(k.c[j], 9));
            e = d.k;
            if (e == (DYb(), yYb) && g == yYb) {
                l = t3b(d, f);
                if (l.a) {
                    w3b(d, f, l.b, l.c);
                    sDb(j, k.c.length);
                    ZCb(k.c, j, 1);
                    --j;
                    d = f;
                    e = g;
                }
            }
            f = d;
            g = e;
        }
    }
    c.Tg();
}
function POc(a, b, c, d, e) {
    var f, g, h, i, j, k, l;
    for(g = new rmb(b); g.a < g.c.c.length;){
        f = JD(pmb(g), 18);
        i = f.c;
        if (c.a._b(i)) j = (gPc(), ePc);
        else if (d.a._b(i)) j = (gPc(), fPc);
        else throw scb(new Teb('Source port must be in one of the port sets.'));
        k = f.d;
        if (c.a._b(k)) l = (gPc(), ePc);
        else if (d.a._b(k)) l = (gPc(), fPc);
        else throw scb(new Teb('Target port must be in one of the port sets.'));
        h = new zPc(f, j, l);
        Qib(a.b, f, h);
        YCb(e.c, h);
    }
}
function DZd(a) {
    var b, c;
    if (!!a.c && a.c.Rh()) {
        c = JD(a.c, 52);
        a.c = JD(zqd(a, c), 141);
        if (a.c != c) {
            (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 9, 2, c, a.c));
            if (RD(a.Cb, 400)) a.Db >> 16 == -15 && a.Cb.Uh() && OFd(new h_d(a.Cb, 9, 13, c, a.c, AUd(J_d(JD(a.Cb, 62)), a)));
            else if (RD(a.Cb, 88)) {
                if (a.Db >> 16 == -23 && a.Cb.Uh()) {
                    b = a.c;
                    RD(b, 88) || (b = (cPd(), UOd));
                    RD(c, 88) || (c = (cPd(), UOd));
                    OFd(new h_d(a.Cb, 9, 10, c, b, AUd(OTd(JD(a.Cb, 29)), a)));
                }
            }
        }
    }
    return a.c;
}
function nWd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    if (b == c) return true;
    else {
        b = oWd(a, b);
        c = oWd(a, c);
        d = CZd(b);
        if (d) {
            k = CZd(c);
            if (k != d) {
                if (!k) return false;
                else {
                    i = d.jk();
                    o = k.jk();
                    return i == o && i != null;
                }
            } else {
                g = (!b.d && (b.d = new qVd(g6, b, 1)), b.d);
                f = g.i;
                m = (!c.d && (c.d = new qVd(g6, c, 1)), c.d);
                if (f == m.i) for(j = 0; j < f; ++j){
                    e = JD(nDd(g, j), 87);
                    l = JD(nDd(m, j), 87);
                    if (!nWd(a, e, l)) return false;
                }
                return true;
            }
        } else {
            h = b.e;
            n = c.e;
            return h == n;
        }
    }
}
function Qbe(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    if (Lfe(a.e, b)) {
        l = Kfe(a.e.zh(), b);
        f = JD(a.g, 122);
        k = null;
        i = -1;
        h = -1;
        e = 0;
        for(j = 0; j < a.i; ++j){
            g = f[j];
            if (l.Zl(g.Ik())) {
                e == c && (i = j);
                if (e == d) {
                    h = j;
                    k = g.kd();
                }
                ++e;
            }
        }
        if (i == -1) throw scb(new mdb(NDe + c + ODe + e));
        if (h == -1) throw scb(new mdb(PDe + d + ODe + e));
        TGd(a, i, h);
        qqd(a.e) && zUd(a, Abe(a, 7, b, jfb(d), k, c, true));
        return k;
    } else throw scb(new Teb('The feature must be many-valued to support move'));
}
function tXb(a, b, c, d) {
    var e, f, g, h, i;
    i = new Fdd(b.n);
    i.a += b.o.a / 2;
    i.b += b.o.b / 2;
    h = Beb(MD(WMb(b, (Bwc(), Dvc))));
    f = a.f;
    g = a.d;
    e = a.c;
    switch(JD(WMb(b, (Iqc(), Tpc)), 64).g){
        case 1:
            i.a += g.b + e.a - c / 2;
            i.b = -d - h;
            b.n.b = -(g.d + h + e.b);
            break;
        case 2:
            i.a = f.a + g.b + g.c + h;
            i.b += g.d + e.b - d / 2;
            b.n.a = f.a + g.c + h - e.a;
            break;
        case 3:
            i.a += g.b + e.a - c / 2;
            i.b = f.b + g.d + g.a + h;
            b.n.b = f.b + g.a + h - e.b;
            break;
        case 4:
            i.a = -c - h;
            i.b += g.d + e.b - d / 2;
            b.n.a = -(g.b + h + e.a);
    }
    return i;
}
function $7b(a, b, c) {
    var d, e;
    d = b.c.i;
    e = c.d.i;
    if (d.k == (DYb(), yYb)) {
        ZMb(a, (Iqc(), fqc), JD(WMb(d, fqc), 11));
        ZMb(a, gqc, JD(WMb(d, gqc), 11));
        ZMb(a, eqc, LD(WMb(d, eqc)));
    } else if (d.k == xYb) {
        ZMb(a, (Iqc(), fqc), JD(WMb(d, fqc), 11));
        ZMb(a, gqc, JD(WMb(d, gqc), 11));
        ZMb(a, eqc, (xdb(), true));
    } else if (e.k == xYb) {
        ZMb(a, (Iqc(), fqc), JD(WMb(e, fqc), 11));
        ZMb(a, gqc, JD(WMb(e, gqc), 11));
        ZMb(a, eqc, (xdb(), true));
    } else {
        ZMb(a, (Iqc(), fqc), b.c);
        ZMb(a, gqc, c.d);
    }
}
function HGb(a) {
    var b, c, d, e, f, g, h;
    a.o = new nlb;
    d = new Mtb;
    for(g = new rmb(a.e.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 123);
        OFb(f).c.length == 1 && Dtb(d, f, d.c.b, d.c);
    }
    while(d.b != 0){
        f = JD(d.b == 0 ? null : (rDb(d.b != 0), Ktb(d, d.a.a)), 123);
        if (OFb(f).c.length == 0) continue;
        b = JD(Mlb(OFb(f), 0), 216);
        c = f.g.a.c.length > 0;
        h = AFb(b, f);
        c ? RFb(h.b, b) : RFb(h.g, b);
        OFb(h).c.length == 1 && Dtb(d, h, d.c.b, d.c);
        e = new xod(f, b);
        $kb(a.o, e);
        Plb(a.e.a, f);
    }
}
function aMb(a, b) {
    var c, d, e, f, g, h, i;
    d = $wnd.Math.abs(_cd(a.b).a - _cd(b.b).a);
    h = $wnd.Math.abs(_cd(a.b).b - _cd(b.b).b);
    e = 0;
    i = 0;
    c = 1;
    g = 1;
    if (d > a.b.b / 2 + b.b.b / 2) {
        e = $wnd.Math.min($wnd.Math.abs(a.b.c - (b.b.c + b.b.b)), $wnd.Math.abs(a.b.c + a.b.b - b.b.c));
        c = 1 - e / d;
    }
    if (h > a.b.a / 2 + b.b.a / 2) {
        i = $wnd.Math.min($wnd.Math.abs(a.b.d - (b.b.d + b.b.a)), $wnd.Math.abs(a.b.d + a.b.a - b.b.d));
        g = 1 - i / h;
    }
    f = $wnd.Math.min(c, g);
    return (1 - f) * $wnd.Math.sqrt(d * d + h * h);
}
function OOc(a) {
    var b, c, d, e;
    QOc(a, a.e, a.f, (gPc(), ePc), true, a.c, a.i);
    QOc(a, a.e, a.f, ePc, false, a.c, a.i);
    QOc(a, a.e, a.f, fPc, true, a.c, a.i);
    QOc(a, a.e, a.f, fPc, false, a.c, a.i);
    POc(a, a.c, a.e, a.f, a.i);
    d = new Ajb(a.i, 0);
    while(d.b < d.d.gc()){
        b = (rDb(d.b < d.d.gc()), JD(d.d.Xb(d.c = d.b++), 132));
        e = new Ajb(a.i, d.b);
        while(e.b < e.d.gc()){
            c = (rDb(e.b < e.d.gc()), JD(e.d.Xb(e.c = e.b++), 132));
            NOc(b, c);
        }
    }
    ZOc(a.i, JD(WMb(a.d, (Iqc(), vqc)), 233));
    aPc(a.i);
}
function $Sd(a, b) {
    var c, d;
    if (b != null) {
        d = YSd(a);
        if (d) {
            if ((d.i & 1) != 0) {
                if (d == pcb) return SD(b);
                else if (d == cE) return RD(b, 17);
                else if (d == bE) return RD(b, 160);
                else if (d == $D) return RD(b, 219);
                else if (d == _D) return RD(b, 179);
                else if (d == aE) return TD(b);
                else if (d == ocb) return RD(b, 191);
                else if (d == dE) return RD(b, 190);
            } else return iNd(), c = JD(Nib(hNd, d), 58), !c || c.ck(b);
        } else if (RD(b, 57)) return a.al(JD(b, 57));
    }
    return false;
}
function Ule() {
    Ule = Zcb;
    var a, b, c, d, e, f, g, h, i;
    Sle = SC($D, ZCe, 30, 255, 15, 1);
    Tle = SC(_D, Ure, 30, 64, 15, 1);
    for(b = 0; b < 255; b++)Sle[b] = -1;
    for(c = 90; c >= 65; c--)Sle[c] = c - 65 << 24 >> 24;
    for(d = 122; d >= 97; d--)Sle[d] = d - 97 + 26 << 24 >> 24;
    for(e = 57; e >= 48; e--)Sle[e] = e - 48 + 52 << 24 >> 24;
    Sle[43] = 62;
    Sle[47] = 63;
    for(f = 0; f <= 25; f++)Tle[f] = 65 + f & Wre;
    for(g = 26, i = 0; g <= 51; ++g, i++)Tle[g] = 97 + i & Wre;
    for(a = 52, h = 0; a <= 61; ++a, h++)Tle[a] = 48 + h & Wre;
    Tle[62] = 43;
    Tle[63] = 47;
}
function lhb(a, b) {
    var c, d, e, f, g, h;
    e = ohb(a);
    h = ohb(b);
    if (e == h) {
        if (a.e == b.e && a.a < 54 && b.a < 54) return a.f < b.f ? -1 : a.f > b.f ? 1 : 0;
        d = a.e - b.e;
        c = (a.d > 0 ? a.d : $wnd.Math.floor((a.a - 1) * Tse) + 1) - (b.d > 0 ? b.d : $wnd.Math.floor((b.a - 1) * Tse) + 1);
        if (c > d + 1) return e;
        else if (c < d - 1) return -e;
        else {
            f = (!a.c && (a.c = fib(zcb(a.f))), a.c);
            g = (!b.c && (b.c = fib(zcb(b.f))), b.c);
            d < 0 ? f = Nhb(f, Jib(-d)) : d > 0 && (g = Nhb(g, Jib(d)));
            return Hhb(f, g);
        }
    } else return e < h ? -1 : 1;
}
function j$b(a) {
    var b, c, d, e, f, g;
    d = new nWb;
    UMb(d, a);
    XD(WMb(d, (Bwc(), ruc))) === XD((Tgd(), Rgd)) && ZMb(d, ruc, sXb(d));
    if (WMb(d, (Gcd(), Fcd)) == null) {
        g = JD(efe(a), 173);
        ZMb(d, Fcd, ZD(g.mf(Fcd)));
    }
    ZMb(d, (Iqc(), kqc), a);
    ZMb(d, Wpc, (b = JD(deb(XV), 10), new urb(b, JD(VCb(b, b.length), 10), 0)));
    e = QGb((!Zwd(a) || (Rod(), new dpd(Zwd(a))), Rod(), new jpd(!Zwd(a) ? null : new dpd(Zwd(a)), a)), Qgd);
    f = JD(WMb(d, tvc), 107);
    c = d.d;
    LXb(c, f);
    LXb(c, e);
    return d;
}
function zNb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    c.Sg(yue, 1);
    a.qf(b);
    f = 0;
    while(a.sf(f) && !c.Yg()){
        a.rf();
        for(k = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
            b.e,
            b.d,
            b.b
        ]))); cs(k);){
            i = JD(ds(k), 310);
            for(h = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
                b.e,
                b.d,
                b.b
            ]))); cs(h);){
                g = JD(ds(h), 310);
                if (g != i) {
                    e = a.pf(g, i);
                    !!e && mdd(i.c, e);
                }
            }
        }
        for(j = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
            b.e,
            b.d,
            b.b
        ]))); cs(j);){
            i = JD(ds(j), 310);
            d = i.c;
            ndd(d, -a.d, -a.d, a.d, a.d);
            mdd(i.d, d);
            d.a = 0;
            d.b = 0;
        }
        ++f;
    }
    c.Tg();
}
function RTb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    if (a.dc()) return new Cdd;
    j = 0;
    l = 0;
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 36);
        f = d.f;
        j = $wnd.Math.max(j, f.a);
        l += f.a * f.b;
    }
    j = $wnd.Math.max(j, $wnd.Math.sqrt(l) * Beb(MD(WMb(JD(a.Jc().Pb(), 36), (Bwc(), Ttc)))));
    m = 0;
    n = 0;
    i = 0;
    c = b;
    for(h = a.Jc(); h.Ob();){
        g = JD(h.Pb(), 36);
        k = g.f;
        if (m + k.a > j) {
            m = 0;
            n += i + b;
            i = 0;
        }
        GTb(g, m, n);
        c = $wnd.Math.max(c, m + k.a);
        i = $wnd.Math.max(i, k.b);
        m += k.a + b;
    }
    return new Edd(c + b, n + i + b);
}
function Ymd(a, b) {
    var c, d, e, f, g, h, i;
    if (!oxd(a)) throw scb(new Web(tCe));
    d = oxd(a);
    f = d.g;
    e = d.f;
    if (f <= 0 && e <= 0) return Rjd(), Pjd;
    h = a.i;
    i = a.j;
    switch(b.g){
        case 2:
        case 1:
            if (h < 0) return Rjd(), Qjd;
            else if (h + a.g > f) return Rjd(), wjd;
            break;
        case 4:
        case 3:
            if (i < 0) return Rjd(), xjd;
            else if (i + a.f > e) return Rjd(), Ojd;
    }
    g = (h + a.g / 2) / f;
    c = (i + a.f / 2) / e;
    return g + c <= 1 && g - c <= 0 ? (Rjd(), Qjd) : g + c >= 1 && g - c >= 0 ? (Rjd(), wjd) : c < 0.5 ? (Rjd(), xjd) : (Rjd(), Ojd);
}
function uib(a, b, c, d, e) {
    var f, g;
    f = tcb(ucb(b[0], Use), ucb(d[0], Use));
    a[0] = Pcb(f);
    f = Kcb(f, 32);
    if (c >= e) {
        for(g = 1; g < e; g++){
            f = tcb(f, tcb(ucb(b[g], Use), ucb(d[g], Use)));
            a[g] = Pcb(f);
            f = Kcb(f, 32);
        }
        for(; g < c; g++){
            f = tcb(f, ucb(b[g], Use));
            a[g] = Pcb(f);
            f = Kcb(f, 32);
        }
    } else {
        for(g = 1; g < c; g++){
            f = tcb(f, tcb(ucb(b[g], Use), ucb(d[g], Use)));
            a[g] = Pcb(f);
            f = Kcb(f, 32);
        }
        for(; g < e; g++){
            f = tcb(f, ucb(d[g], Use));
            a[g] = Pcb(f);
            f = Kcb(f, 32);
        }
    }
    vcb(f, 0) != 0 && (a[g] = Pcb(f));
}
function L3b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    b.Sg('Layer constraint edge reversal', 1);
    for(g = new rmb(a.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        k = -1;
        c = new Ulb;
        j = DXb(f.a);
        for(e = 0; e < j.length; e++){
            d = JD(WMb(j[e], (Iqc(), $pc)), 312);
            if (k == -1) d != (qpc(), ppc) && (k = e);
            else if (d == (qpc(), ppc)) {
                qYb(j[e], null);
                pYb(j[e], k++, f);
            }
            d == (qpc(), npc) && YCb(c.c, j[e]);
        }
        for(i = new rmb(c); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            qYb(h, null);
            qYb(h, f);
        }
    }
    b.Tg();
}
function Toe(a) {
    ooe();
    var b, c, d, e, f, g;
    if (a.e != 4 && a.e != 5) throw scb(new Teb('Token#complementRanges(): must be RANGE: ' + a.e));
    f = a;
    Qoe(f);
    Noe(f);
    d = f.b.length + 2;
    f.b[0] == 0 && (d -= 2);
    c = f.b[f.b.length - 1];
    c == NGe && (d -= 2);
    e = (++noe, new Soe(4));
    e.b = SC(cE, ise, 30, d, 15, 1);
    g = 0;
    if (f.b[0] > 0) {
        e.b[g++] = 0;
        e.b[g++] = f.b[0] - 1;
    }
    for(b = 1; b < f.b.length - 2; b += 2){
        e.b[g++] = f.b[b] + 1;
        e.b[g++] = f.b[b + 1] - 1;
    }
    if (c != NGe) {
        e.b[g++] = c + 1;
        e.b[g] = NGe;
    }
    e.a = true;
    return e;
}
function y2b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    b.Sg('Hierarchical port dummy size processing', 1);
    i = new Ulb;
    k = new Ulb;
    d = Beb(MD(WMb(a, (Bwc(), Xvc))));
    c = d * 2;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        i.c.length = 0;
        k.c.length = 0;
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            if (g.k == (DYb(), wYb)) {
                j = JD(WMb(g, (Iqc(), Tpc)), 64);
                j == (Rjd(), xjd) ? YCb(i.c, g) : j == Ojd && YCb(k.c, g);
            }
        }
        z2b(i, true, c);
        z2b(k, false, c);
    }
    b.Tg();
}
function MGd(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = c.gc();
    if (d == 0) return false;
    else {
        if (a.Mj()) {
            j = a.Nj();
            fDd(a, b, c);
            g = d == 1 ? a.Fj(3, null, c.Jc().Pb(), b, j) : a.Fj(5, null, c, b, j);
            if (a.Jj()) {
                h = d < 100 ? null : new FGd(d);
                f = b + d;
                for(e = b; e < f; ++e){
                    k = a.g[e];
                    h = a.Kj(k, h);
                    h = a.Rj(k, h);
                }
                if (!h) a.Gj(g);
                else {
                    h.kj(g);
                    h.lj();
                }
            } else a.Gj(g);
        } else {
            fDd(a, b, c);
            if (a.Jj()) {
                h = d < 100 ? null : new FGd(d);
                f = b + d;
                for(e = b; e < f; ++e){
                    i = a.g[e];
                    h = a.Kj(i, h);
                }
                !!h && h.lj();
            }
        }
        return true;
    }
}
function zMc(a, b, c, d) {
    var e, f, g, h, i;
    for(g = new rmb(a.k); g.a < g.c.c.length;){
        e = JD(pmb(g), 133);
        if (!d || e.c == (iNc(), gNc)) {
            i = e.b;
            if (i.g < 0 && e.d > 0) {
                SMc(i, i.d - e.d);
                e.c == (iNc(), gNc) && QMc(i, i.a - e.d);
                i.d <= 0 && i.i > 0 && Dtb(b, i, b.c.b, b.c);
            }
        }
    }
    for(f = new rmb(a.f); f.a < f.c.c.length;){
        e = JD(pmb(f), 133);
        if (!d || e.c == (iNc(), gNc)) {
            h = e.a;
            if (h.g < 0 && e.d > 0) {
                TMc(h, h.i - e.d);
                e.c == (iNc(), gNc) && RMc(h, h.b - e.d);
                h.i <= 0 && h.d > 0 && Dtb(c, h, c.c.b, c.c);
            }
        }
    }
}
function Nld(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n;
    pnb();
    Slb(a, new umd);
    g = cv(a);
    n = new Ulb;
    m = new Ulb;
    h = null;
    i = 0;
    while(g.b != 0){
        f = JD(g.b == 0 ? null : (rDb(g.b != 0), Ktb(g, g.a.a)), 162);
        if (!h || cmd(h) * bmd(h) / 2 < cmd(f) * bmd(f)) {
            h = f;
            YCb(n.c, f);
        } else {
            i += cmd(f) * bmd(f);
            YCb(m.c, f);
            if (m.c.length > 1 && (i > cmd(h) * bmd(h) / 2 || g.b == 0)) {
                l = new hmd(m);
                k = cmd(h) / bmd(h);
                j = Sld(l, b, new LYb, c, d, e, k);
                mdd(vdd(l.e), j);
                h = l;
                YCb(n.c, l);
                i = 0;
                m.c.length = 0;
            }
        }
    }
    Klb(n, m);
    return n;
}
function $gb(a, b, c, d, e) {
    Zgb();
    var f, g, h, i, j, k, l;
    uDb(a, 'src');
    uDb(c, 'dest');
    l = rb(a);
    i = rb(c);
    pDb((l.i & 4) != 0, 'srcType is not an array');
    pDb((i.i & 4) != 0, 'destType is not an array');
    k = l.c;
    g = i.c;
    pDb((k.i & 1) != 0 ? k == g : (g.i & 1) == 0, "Array types don't match");
    _gb(a, b, c, d, e);
    if ((k.i & 1) == 0 && l != i) {
        j = KD(a);
        f = KD(c);
        if (XD(a) === XD(c) && b < d) {
            b += e;
            for(h = d + e; h-- > d;)VC(f, h, j[--b]);
        } else for(h = d + e; d < h;)VC(f, d++, j[b++]);
    } else UCb(a, b, c, d, e, true);
}
function Mld(a, b) {
    var c, d, e, f, g, h, i, j, k;
    b.Sg('Box layout', 2);
    e = Deb(MD(ksd(a, (ued(), ted))));
    f = JD(ksd(a, qed), 107);
    c = ydb(LD(ksd(a, led)));
    d = ydb(LD(ksd(a, med)));
    switch(JD(ksd(a, jed), 321).g){
        case 0:
            g = (k = new Wlb((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)), pnb(), Slb(k, new Zld(d)), k);
            h = dnd(a);
            i = MD(ksd(a, ied));
            (i == null || (tDb(i), i) <= 0) && (i = 1.3);
            j = Qld(g, e, f, h.a, h.b, c, (tDb(i), i));
            mnd(a, j.a, j.b, false, true);
            break;
        default:
            Rld(a, e, f, c);
    }
    b.Tg();
}
function xOc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o;
    m = wOc(a, c);
    for(i = 0; i < b; i++){
        zjb(e, c);
        n = new Ulb;
        o = (rDb(d.b < d.d.gc()), JD(d.d.Xb(d.c = d.b++), 407));
        for(k = m + i; k < a.b; k++){
            h = o;
            o = (rDb(d.b < d.d.gc()), JD(d.d.Xb(d.c = d.b++), 407));
            Ilb(n, new DOc(h, o, c));
        }
        for(l = m + i; l < a.b; l++){
            rDb(d.b > 0);
            d.a.Xb(d.c = --d.b);
            l > m + i && tjb(d);
        }
        for(g = new rmb(n); g.a < g.c.c.length;){
            f = JD(pmb(g), 407);
            zjb(d, f);
        }
        if (i < b - 1) for(j = m + i; j < a.b; j++){
            rDb(d.b > 0);
            d.a.Xb(d.c = --d.b);
        }
    }
}
function Boe() {
    ooe();
    var a, b, c, d, e, f;
    if ($ne) return $ne;
    a = (++noe, new Soe(4));
    Poe(a, Coe(XGe, true));
    Roe(a, Coe('M', true));
    Roe(a, Coe('C', true));
    f = (++noe, new Soe(4));
    for(d = 0; d < 11; d++)Moe(f, d, d);
    b = (++noe, new Soe(4));
    Poe(b, Coe('M', true));
    Moe(b, 4448, 4607);
    Moe(b, 65438, 65439);
    e = (++noe, new Dpe(2));
    Cpe(e, a);
    Cpe(e, Zne);
    c = (++noe, new Dpe(2));
    c.Gm(toe(f, Coe('L', true)));
    c.Gm(b);
    c = (++noe, new dpe(3, c));
    c = (++noe, new jpe(e, c));
    $ne = c;
    return $ne;
}
function mgb(a, b) {
    var c, d, e, f, g, h, i, j;
    c = new RegExp(b, 'g');
    i = SC(hJ, hre, 2, 0, 6, 1);
    d = 0;
    j = a;
    f = null;
    while(true){
        h = c.exec(j);
        if (h == null || j == '') {
            i[d] = j;
            break;
        } else {
            g = h.index;
            i[d] = (zDb(0, g, j.length), j.substr(0, g));
            j = qgb(j, g + h[0].length, j.length);
            c.lastIndex = 0;
            if (f == j) {
                i[d] = (zDb(0, 1, j.length), j.substr(0, 1));
                j = (ADb(1, j.length + 1), j.substr(1));
            }
            f = j;
            ++d;
        }
    }
    if (a.length > 0) {
        e = i.length;
        while(e > 0 && i[e - 1] == '')--e;
        e < i.length && (i.length = e);
    }
    return i;
}
function kVc() {
    kVc = Zcb;
    XUc = new MYb(20);
    WUc = new NBd((Lgd(), Kfd), XUc);
    cVc = new NBd(wgd, 20);
    bVc = new NBd(qgd, 3);
    HUc = new NBd(Qed, Jue);
    $Uc = new NBd(ggd, jfb(1));
    aVc = new NBd(kgd, (xdb(), true));
    JUc = Zed;
    LUc = (Tgd(), Rgd);
    KUc = new NBd($ed, LUc);
    OUc = nfd;
    PUc = ofd;
    RUc = Bfd;
    SUc = Dfd;
    TUc = Efd;
    UUc = Gfd;
    QUc = zfd;
    VUc = Jfd;
    YUc = agd;
    jVc = (EUc(), CUc);
    _Uc = zUc;
    fVc = Dgd;
    hVc = Hgd;
    eVc = Cgd;
    dVc = Bgd;
    gVc = (Wkd(), Tkd);
    new NBd(Egd, gVc);
    ZUc = yUc;
    NUc = wUc;
    iVc = BUc;
    IUc = uUc;
    MUc = vUc;
}
function lLc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    l = new kLc;
    l.d = 0;
    for(g = new rmb(a.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        l.d += f.a.c.length;
    }
    d = 0;
    e = 0;
    l.a = SC(cE, ise, 30, a.b.c.length, 15, 1);
    j = 0;
    k = 0;
    l.e = SC(cE, ise, 30, l.d, 15, 1);
    for(c = new rmb(a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 25);
        b.p = d++;
        l.a[b.p] = e++;
        k = 0;
        for(i = new rmb(b.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            h.p = j++;
            l.e[h.p] = k++;
        }
    }
    l.c = new pLc(l);
    l.b = av(l.d);
    mLc(l, a);
    l.f = av(l.d);
    nLc(l, a);
    return l;
}
function qad(a) {
    var b, c;
    b = OD(ksd(a, (Lgd(), Ned)));
    if (rad(b, a)) return;
    if (!lsd(a, igd) && ((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a).i != 0 || ydb(LD(ksd(a, lfd))))) {
        if (b == null || ugb(b).length == 0) {
            if (!rad(Ose, a)) {
                c = Qgb(Qgb(new Wgb('Unable to load default layout algorithm '), Ose), ' for unconfigured node ');
                knd(a, c);
                throw scb(new Y8c(c.a));
            }
        } else {
            c = Qgb(Qgb(new Wgb("Layout algorithm '"), b), "' not found for ");
            knd(a, c);
            throw scb(new Y8c(c.a));
        }
    }
}
function jIb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    c = a.i;
    b = a.n;
    if (a.b == 0) {
        n = c.c + b.b;
        m = c.b - b.b - b.c;
        for(g = a.a, i = 0, k = g.length; i < k; ++i){
            e = g[i];
            oHb(e, n, m);
        }
    } else {
        d = mIb(a, false);
        oHb(a.a[0], c.c + b.b, d[0]);
        oHb(a.a[2], c.c + c.b - b.c - d[2], d[2]);
        l = c.b - b.b - b.c;
        if (d[0] > 0) {
            l -= d[0] + a.c;
            d[0] += a.c;
        }
        d[2] > 0 && (l -= d[2] + a.c);
        d[1] = $wnd.Math.max(d[1], l);
        oHb(a.a[1], c.c + b.b + d[0] - (d[1] - l) / 2, d[1]);
    }
    for(f = a.a, h = 0, j = f.length; h < j; ++h){
        e = f[h];
        RD(e, 332) && JD(e, 332).hf();
    }
}
function olc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    k = SC(cE, ise, 30, a.b.c.length + 1, 15, 1);
    j = new Qrb;
    d = 0;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        k[d++] = j.a.gc();
        for(i = new rmb(e.a); i.a < i.c.c.length;){
            g = JD(pmb(i), 9);
            for(c = new es(Ir(kYb(g).a.Jc(), new er)); cs(c);){
                b = JD(ds(c), 18);
                j.a.yc(b, j);
            }
        }
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            for(c = new es(Ir(hYb(g).a.Jc(), new er)); cs(c);){
                b = JD(ds(c), 18);
                j.a.Ac(b);
            }
        }
    }
    return k;
}
function a4c(a, b) {
    var c, d, e, f;
    f = JD(Mlb(a.n, a.n.c.length - 1), 208).d;
    a.p = $wnd.Math.min(a.p, b.g);
    a.r = $wnd.Math.max(a.r, f);
    a.g = $wnd.Math.max(a.g, b.g + (a.b.c.length == 1 ? 0 : a.i));
    a.o = $wnd.Math.min(a.o, b.f);
    a.e += b.f + (a.b.c.length == 1 ? 0 : a.i);
    a.f = $wnd.Math.max(a.f, b.f);
    e = a.n.c.length > 0 ? (a.n.c.length - 1) * a.i : 0;
    for(d = new rmb(a.n); d.a < d.c.c.length;){
        c = JD(pmb(d), 208);
        e += c.a;
    }
    a.d = e;
    a.a = a.e / a.b.c.length - a.i * ((a.b.c.length - 1) / a.b.c.length);
    U4c(a.j);
}
function BMb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = LD(WMb(b, (IOb(), zOb)));
    if (k == null || (tDb(k), k)) {
        l = SC(pcb, Vte, 30, b.e.c.length, 16, 1);
        g = xMb(b);
        e = new Mtb;
        for(j = new rmb(b.e); j.a < j.c.c.length;){
            h = JD(pmb(j), 151);
            c = yMb(a, h, null, null, l, g);
            if (c) {
                UMb(c, b);
                Dtb(e, c, e.c.b, e.c);
            }
        }
        if (e.b > 1) for(d = Gtb(e, 0); d.b != d.d.c;){
            c = JD(Utb(d), 234);
            f = 0;
            for(i = new rmb(c.e); i.a < i.c.c.length;){
                h = JD(pmb(i), 151);
                h.a = f++;
            }
        }
        return e;
    }
    return _u(WC(OC(_N, 1), oue, 234, 0, [
        b
    ]));
}
function MTd(a) {
    var b, c, d, e, f, g, h;
    if (!a.g) {
        h = new sWd;
        b = DTd;
        g = b.a.yc(a, b);
        if (g == null) {
            for(d = new CHd(UTd(a)); d.e != d.i.gc();){
                c = JD(AHd(d), 29);
                vCd(h, MTd(c));
            }
            b.a.Ac(a);
            b.a.gc() == 0 && undefined;
        }
        e = h.i;
        for(f = (!a.s && (a.s = new X0d(q6, a, 21, 17)), new CHd(a.s)); f.e != f.i.gc(); ++e)WRd(JD(AHd(f), 448), e);
        vCd(h, (!a.s && (a.s = new X0d(q6, a, 21, 17)), a.s));
        sDd(h);
        a.g = new kWd(a, h);
        a.i = JD(h.g, 253);
        a.i == null && (a.i = FTd);
        a.p = null;
        TTd(a).b &= -5;
    }
    return a.g;
}
function T9d(a, b) {
    var c, d, e, f, g, h, i, j, k;
    c = b.mi(a.a);
    if (c) {
        i = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), 'memberTypes'));
        if (i != null) {
            j = new Ulb;
            for(f = mgb(i, '\\w'), g = 0, h = f.length; g < h; ++g){
                e = f[g];
                d = e.lastIndexOf('#');
                k = d == -1 ? pae(a, b.gk(), e) : d == 0 ? oae(a, null, (ADb(1, e.length + 1), e.substr(1))) : oae(a, (zDb(0, d, e.length), e.substr(0, d)), (ADb(d + 1, e.length + 1), e.substr(d + 1)));
                RD(k, 155) && Ilb(j, JD(k, 155));
            }
            return j;
        }
    }
    return pnb(), pnb(), mnb;
}
function kIb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    d = a.i;
    c = a.n;
    if (a.b == 0) {
        b = lIb(a, false);
        pHb(a.a[0], d.d + c.d, b[0]);
        pHb(a.a[2], d.d + d.a - c.a - b[2], b[2]);
        m = d.a - c.d - c.a;
        l = m;
        if (b[0] > 0) {
            b[0] += a.c;
            l -= b[0];
        }
        b[2] > 0 && (l -= b[2] + a.c);
        b[1] = $wnd.Math.max(b[1], l);
        pHb(a.a[1], d.d + c.d + b[0] - (b[1] - l) / 2, b[1]);
    } else {
        o = d.d + c.d;
        n = d.a - c.d - c.a;
        for(g = a.a, i = 0, k = g.length; i < k; ++i){
            e = g[i];
            pHb(e, o, n);
        }
    }
    for(f = a.a, h = 0, j = f.length; h < j; ++h){
        e = f[h];
        RD(e, 332) && JD(e, 332).jf();
    }
}
function ybe(a, b, c, d) {
    var e, f, g, h, i;
    i = Kfe(a.e.zh(), b);
    e = JD(a.g, 122);
    Ife();
    if (JD(b, 69).uk()) for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.Zl(f.Ik()) && pb(f, c)) return true;
    }
    else if (c != null) {
        for(h = 0; h < a.i; ++h){
            f = e[h];
            if (i.Zl(f.Ik()) && pb(c, f.kd())) return true;
        }
        if (d) for(g = 0; g < a.i; ++g){
            f = e[g];
            if (i.Zl(f.Ik()) && XD(c) === XD(Vbe(a, JD(f.kd(), 57)))) return true;
        }
    } else for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.Zl(f.Ik()) && f.kd() == null) return false;
    }
    return false;
}
function R9d(a, b) {
    var c, d, e, f, g, h;
    c = b.mi(a.a);
    if (c) {
        h = OD(xJd((!c.b && (c.b = new lRd((cPd(), $Od), u7, c)), c.b), GDe));
        if (h != null) {
            e = kgb(h, wgb(35));
            d = b.nk();
            if (e == -1) {
                g = nae(a, WSd(d));
                f = h;
            } else if (e == 0) {
                g = null;
                f = (ADb(1, h.length + 1), h.substr(1));
            } else {
                g = (zDb(0, e, h.length), h.substr(0, e));
                f = (ADb(e + 1, h.length + 1), h.substr(e + 1));
            }
            switch(Tae(jae(a, b))){
                case 2:
                case 3:
                    return cae(a, d, g, f);
                case 0:
                case 4:
                case 5:
                case 6:
                    return fae(a, d, g, f);
            }
        }
    }
    return null;
}
function PLb(a, b, c, d) {
    var e, f, g, h;
    h = c;
    for(g = new rmb(b.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 224);
        e = JD(f.b, 68);
        if (Sy(a.b.c, e.b.c + e.b.b) <= 0 && Sy(e.b.c, a.b.c + a.b.b) <= 0 && Sy(a.b.d, e.b.d + e.b.a) <= 0 && Sy(e.b.d, a.b.d + a.b.a) <= 0) {
            if (Sy(e.b.c, a.b.c + a.b.b) == 0 && d.a < 0 || Sy(e.b.c + e.b.b, a.b.c) == 0 && d.a > 0 || Sy(e.b.d, a.b.d + a.b.a) == 0 && d.b < 0 || Sy(e.b.d + e.b.a, a.b.d) == 0 && d.b > 0) {
                h = 0;
                break;
            }
        } else h = $wnd.Math.min(h, ZLb(a, e, d));
        h = $wnd.Math.min(h, PLb(a, f, h, d));
    }
    return h;
}
function Vmd(a, b) {
    var c, d, e, f, g, h, i;
    if (a.b < 2) throw scb(new Teb('The vector chain must contain at least a source and a target point.'));
    e = (rDb(a.b != 0), JD(a.a.a.c, 8));
    pud(b, e.a, e.b);
    i = new LHd((!b.a && (b.a = new qVd(u3, b, 5)), b.a));
    g = Gtb(a, 1);
    while(g.a < a.b - 1){
        h = JD(Utb(g), 8);
        if (i.e != i.i.gc()) c = JD(AHd(i), 369);
        else {
            c = (Hpd(), d = new Bsd, d);
            JHd(i, c);
        }
        ysd(c, h.a, h.b);
    }
    while(i.e != i.i.gc()){
        AHd(i);
        BHd(i);
    }
    f = (rDb(a.b != 0), JD(a.c.b.c, 8));
    iud(b, f.a, f.b);
}
function Zbe(a, b, c, d) {
    var e, f, g, h, i, j;
    j = Kfe(a.e.zh(), b);
    g = JD(a.g, 122);
    if (Lfe(a.e, b)) {
        if (b.Pi()) {
            f = Fbe(a, b, d, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0);
            if (f >= 0 && f != c) throw scb(new Teb(MDe));
        }
        e = 0;
        for(i = 0; i < a.i; ++i){
            h = g[i];
            if (j.Zl(h.Ik())) {
                if (e == c) return JD(DCd(a, i, (Ife(), JD(b, 69).uk() ? JD(d, 74) : Jfe(b, d))), 74);
                ++e;
            }
        }
        throw scb(new mdb(IEe + c + ODe + e));
    } else {
        for(i = 0; i < a.i; ++i){
            h = g[i];
            if (j.Zl(h.Ik())) return Ife(), JD(b, 69).uk() ? h : h.kd();
        }
        return null;
    }
}
function bjc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    c = 0;
    for(e = new rmb((sDb(0, a.c.length), JD(a.c[0], 105)).g.b.j); e.a < e.c.c.length;){
        d = JD(pmb(e), 11);
        d.p = c++;
    }
    b == (Rjd(), xjd) ? Slb(a, new jjc) : Slb(a, new njc);
    h = 0;
    k = a.c.length - 1;
    while(h < k){
        g = (sDb(h, a.c.length), JD(a.c[h], 105));
        j = (sDb(k, a.c.length), JD(a.c[k], 105));
        f = b == xjd ? g.c : g.a;
        i = b == xjd ? j.a : j.c;
        djc(g, b, (Dgc(), Bgc), f);
        djc(j, b, Agc, i);
        ++h;
        --k;
    }
    h == k && djc((sDb(h, a.c.length), JD(a.c[h], 105)), b, (Dgc(), zgc), null);
}
function oDc(a, b, c, d) {
    var e, f, g, h, i, j;
    g = new CDc(a, b, c);
    i = new Ajb(d, 0);
    e = false;
    while(i.b < i.d.gc()){
        h = (rDb(i.b < i.d.gc()), JD(i.d.Xb(i.c = i.b++), 238));
        if (h == b || h == c) tjb(i);
        else if (!e && Beb(sDc(h.g, h.d[0]).a) > Beb(sDc(g.g, g.d[0]).a)) {
            rDb(i.b > 0);
            i.a.Xb(i.c = --i.b);
            zjb(i, g);
            e = true;
        } else if (!!h.e && h.e.gc() > 0) {
            f = (!h.e && (h.e = new Ulb), h.e).Kc(b);
            j = (!h.e && (h.e = new Ulb), h.e).Kc(c);
            if (f || j) {
                (!h.e && (h.e = new Ulb), h.e).Ec(g);
                ++g.c;
            }
        }
    }
    e || YCb(d.c, g);
}
function KZc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    l = a.a.i + a.a.g / 2;
    m = a.a.i + a.a.g / 2;
    o = b.i + b.g / 2;
    q = b.j + b.f / 2;
    h = new Edd(o, q);
    j = JD(ksd(b, (Lgd(), fgd)), 8);
    j.a = j.a + l;
    j.b = j.b + m;
    f = (h.b - j.b) / (h.a - j.a);
    d = h.b - f * h.a;
    p = c.i + c.g / 2;
    r = c.j + c.f / 2;
    i = new Edd(p, r);
    k = JD(ksd(c, fgd), 8);
    k.a = k.a + l;
    k.b = k.b + m;
    g = (i.b - k.b) / (i.a - k.a);
    e = i.b - g * i.a;
    n = (d - e) / (g - f);
    if (j.a < n && h.a < n || n < j.a && n < h.a) return false;
    else if (k.a < n && i.a < n || n < k.a && n < i.a) return false;
    return true;
}
function iTc(a, b, c, d) {
    var e, f, g, h, i, j;
    if (!cr(b)) {
        j = c.bh((RD(b, 16) ? JD(b, 16).gc() : Gr(b.Jc())) / a.a | 0);
        j.Sg(Jze, 1);
        i = new lTc;
        h = 0;
        if (d == (Tgd(), Pgd) || d == Qgd) for(g = b.Jc(); g.Ob();){
            e = JD(g.Pb(), 39);
            i = yl(WC(OC(VI, 1), Nqe, 20, 0, [
                i,
                new gRc(e)
            ]));
            h < e.f.a && (h = e.f.a);
        }
        else for(g = b.Jc(); g.Ob();){
            e = JD(g.Pb(), 39);
            i = yl(WC(OC(VI, 1), Nqe, 20, 0, [
                i,
                new gRc(e)
            ]));
            h < e.f.b && (h = e.f.b);
        }
        for(f = b.Jc(); f.Ob();){
            e = JD(f.Pb(), 39);
            ZMb(e, (tUc(), gUc), h);
        }
        j.Tg();
        iTc(a, i, c, d);
    }
}
function WDb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    this.a = a;
    this.b = b;
    this.c = c;
    this.e = _u(WC(OC(CM, 1), Nqe, 176, 0, [
        new SDb(a, b),
        new SDb(b, c),
        new SDb(c, a)
    ]));
    this.f = _u(WC(OC(b2, 1), hre, 8, 0, [
        a,
        b,
        c
    ]));
    this.d = (d = Bdd(odd(this.b), this.a), e = Bdd(odd(this.c), this.a), f = Bdd(odd(this.c), this.b), g = d.a * (this.a.a + this.b.a) + d.b * (this.a.b + this.b.b), h = e.a * (this.a.a + this.c.a) + e.b * (this.a.b + this.c.b), i = 2 * (d.a * f.b - d.b * f.a), j = (e.b * g - d.b * h) / i, k = (d.a * h - e.a * g) / i, new Edd(j, k));
}
function fWb(a, b) {
    var c, d, e, f, g, h;
    f = a.c;
    g = a.d;
    gWb(a, null);
    hWb(a, null);
    b && ydb(LD(WMb(g, (Iqc(), Ypc)))) ? gWb(a, AXb(g.i, (Eyc(), Cyc), (Rjd(), wjd))) : gWb(a, g);
    b && ydb(LD(WMb(f, (Iqc(), qqc)))) ? hWb(a, AXb(f.i, (Eyc(), Byc), (Rjd(), Qjd))) : hWb(a, f);
    for(d = new rmb(a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 72);
        e = JD(WMb(c, (Bwc(), wuc)), 276);
        e == (nhd(), mhd) ? ZMb(c, wuc, lhd) : e == lhd && ZMb(c, wuc, mhd);
    }
    h = ydb(LD(WMb(a, (Iqc(), xqc))));
    ZMb(a, xqc, (xdb(), h ? false : true));
    a.a = Vdd(a.a);
}
function oQc(a, b) {
    var c, d, e, f, g;
    c = mQc(JD(WMb(b, (kVc(), KUc)), 86));
    if (a.b.b == 0) return null;
    g = JD(yBb(FBb(new RBb(null, new Gvb(a.b, 16)), new XQc), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    f = JD(yBb(BBb(new RBb(null, new Gvb(b.b, 16)), new FQc(g)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        jAb
    ]))), 15);
    e = MD(zub(IBb(FBb(f.Mc(), new HQc(c)), (jqb(), jqb(), hqb))));
    d = JD(zub(CBb(BBb(f.Mc(), new JQc(c, e)))), 39);
    return d;
}
function yIc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    c = pGb(new rGb, a.f);
    j = a.i[b.c.i.p];
    n = a.i[b.d.i.p];
    i = b.c;
    m = b.d;
    h = i.a.b;
    l = m.a.b;
    j.b || (h += i.n.b);
    n.b || (l += m.n.b);
    k = YD($wnd.Math.max(0, h - l));
    g = YD($wnd.Math.max(0, l - h));
    o = (p = $wnd.Math.max(1, JD(WMb(b, (Bwc(), Pvc)), 17).a), q = kIc(b.c.i.k, b.d.i.k), p * q);
    e = DFb(GFb(FFb(EFb(HFb(new IFb, o), g), c), JD(Nib(a.k, b.c), 123)));
    f = DFb(GFb(FFb(EFb(HFb(new IFb, o), k), c), JD(Nib(a.k, b.d), 123)));
    d = new TIc(e, f);
    a.c[b.p] = d;
}
function LMb(a, b, c) {
    var d, e, f, g, h, i;
    d = 0;
    for(f = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); f.e != f.i.gc();){
        e = JD(AHd(f), 27);
        g = '';
        (!e.n && (e.n = new X0d(z3, e, 1, 7)), e.n).i == 0 || (g = JD(nDd((!e.n && (e.n = new X0d(z3, e, 1, 7)), e.n), 0), 153).a);
        h = new vNb(g);
        UMb(h, e);
        ZMb(h, (TOb(), ROb), e);
        h.a = d++;
        h.d.a = e.i + e.g / 2;
        h.d.b = e.j + e.f / 2;
        h.e.a = $wnd.Math.max(e.g, 1);
        h.e.b = $wnd.Math.max(e.f, 1);
        Ilb(b.e, h);
        gsb(c.f, e, h);
        i = JD(ksd(e, (IOb(), tOb)), 100);
        i == (ajd(), _id) && (i = $id);
    }
}
function gac(a) {
    var b, c, d;
    if (cjd(JD(WMb(a, (Bwc(), Evc)), 100))) for(c = new rmb(a.j); c.a < c.c.c.length;){
        b = JD(pmb(c), 11);
        b.j == (Rjd(), Pjd) && (d = JD(WMb(b, (Iqc(), sqc)), 9), d ? aZb(b, JD(WMb(d, Tpc), 64)) : b.e.c.length - b.g.c.length < 0 ? aZb(b, wjd) : aZb(b, Qjd));
    }
    else {
        for(c = new rmb(a.j); c.a < c.c.c.length;){
            b = JD(pmb(c), 11);
            d = JD(WMb(b, (Iqc(), sqc)), 9);
            d ? aZb(b, JD(WMb(d, Tpc), 64)) : b.e.c.length - b.g.c.length < 0 ? aZb(b, (Rjd(), wjd)) : aZb(b, (Rjd(), Qjd));
        }
        ZMb(a, Evc, (ajd(), Zid));
    }
}
function o7b(a, b) {
    var c, d, e, f, g, h, i;
    b.Sg('Layer constraint postprocessing', 1);
    i = a.b;
    if (i.c.length != 0) {
        d = (sDb(0, i.c.length), JD(i.c[0], 25));
        g = JD(Mlb(i, i.c.length - 1), 25);
        c = new b$b(a);
        f = new b$b(a);
        m7b(a, d, g, c, f);
        c.a.c.length == 0 || (vDb(0, i.c.length), WCb(i.c, 0, c));
        f.a.c.length == 0 || YCb(i.c, f);
    }
    if (XMb(a, (Iqc(), Xpc))) {
        e = new b$b(a);
        h = new b$b(a);
        p7b(a, e, h);
        e.a.c.length == 0 || (vDb(0, i.c.length), WCb(i.c, 0, e));
        h.a.c.length == 0 || YCb(i.c, h);
    }
    b.Tg();
}
function Uoe(a) {
    var b, c, d;
    switch(a){
        case 91:
        case 93:
        case 45:
        case 94:
        case 44:
        case 92:
            d = '\\' + String.fromCharCode(a & Wre);
            break;
        case 12:
            d = '\\f';
            break;
        case 10:
            d = '\\n';
            break;
        case 13:
            d = '\\r';
            break;
        case 9:
            d = '\\t';
            break;
        case 27:
            d = '\\e';
            break;
        default:
            if (a < 32) {
                c = (b = a >>> 0, '0' + b.toString(16));
                d = '\\x' + qgb(c, c.length - 2, c.length);
            } else if (a >= Pse) {
                c = (b = a >>> 0, '0' + b.toString(16));
                d = '\\v' + qgb(c, c.length - 6, c.length);
            } else d = '' + String.fromCharCode(a & Wre);
    }
    return d;
}
function d7b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            if (g.k == (DYb(), xYb)) {
                i = (j = JD(ds(new es(Ir(hYb(g).a.Jc(), new er))), 18), k = JD(ds(new es(Ir(kYb(g).a.Jc(), new er))), 18), !ydb(LD(WMb(j, (Iqc(), xqc)))) || !ydb(LD(WMb(k, xqc)))) ? b : pid(b);
                b7b(g, i);
            }
            for(d = new es(Ir(kYb(g).a.Jc(), new er)); cs(d);){
                c = JD(ds(d), 18);
                i = ydb(LD(WMb(c, (Iqc(), xqc)))) ? pid(b) : b;
                a7b(c, i);
            }
        }
    }
}
function zOc(a) {
    var b, c, d, e, f, g;
    this.e = new Ulb;
    this.a = new Ulb;
    for(c = a.b - 1; c < 3; c++)du(a, 0, JD(fu(a, 0), 8));
    if (a.b < 4) throw scb(new Teb('At (least dimension + 1) control points are necessary!'));
    else {
        this.b = 3;
        this.d = true;
        this.c = false;
        uOc(this, a.b + this.b - 1);
        g = new Ulb;
        f = new rmb(this.e);
        for(b = 0; b < this.b - 1; b++)Ilb(g, MD(pmb(f)));
        for(e = Gtb(a, 0); e.b != e.d.c;){
            d = JD(Utb(e), 8);
            Ilb(g, MD(pmb(f)));
            Ilb(this.a, new EOc(d, g));
            sDb(0, g.c.length);
            g.c.splice(0, 1);
        }
    }
}
function i3c(a, b, c, d, e) {
    var f, g, h;
    if (c.f >= b.o && c.f <= b.f || b.a * 0.5 <= c.f && b.a * 1.5 >= c.f) {
        g = JD(Mlb(b.n, b.n.c.length - 1), 208);
        if (g.e + g.d + c.g + e <= d && (f = JD(Mlb(b.n, b.n.c.length - 1), 208), f.f - a.f + c.f <= a.b || a.a.c.length == 1)) {
            $3c(b, c);
            return true;
        } else if (b.s + c.g <= d && (b.t + b.d + c.f + e <= a.b || a.a.c.length == 1)) {
            Ilb(b.b, c);
            h = JD(Mlb(b.n, b.n.c.length - 1), 208);
            Ilb(b.n, new p4c(b.s, h.f + h.a + b.i, b.i));
            k4c(JD(Mlb(b.n, b.n.c.length - 1), 208), c);
            a4c(b, c);
            return true;
        }
    }
    return false;
}
function WGd(a, b, c) {
    var d, e, f, g;
    if (a.Mj()) {
        e = null;
        f = a.Nj();
        d = a.Fj(1, g = rDd(a, b, c), c, b, f);
        if (a.Jj() && !(a.Vi() && g != null ? pb(g, c) : XD(g) === XD(c))) {
            g != null && (e = a.Lj(g, e));
            e = a.Kj(c, e);
            a.Qj() && (e = a.Tj(g, c, e));
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        } else {
            a.Qj() && (e = a.Tj(g, c, e));
            if (!e) a.Gj(d);
            else {
                e.kj(d);
                e.lj();
            }
        }
        return g;
    } else {
        g = rDd(a, b, c);
        if (a.Jj() && !(a.Vi() && g != null ? pb(g, c) : XD(g) === XD(c))) {
            e = null;
            g != null && (e = a.Lj(g, null));
            e = a.Kj(c, e);
            !!e && e.lj();
        }
        return g;
    }
}
function Bmc(a, b) {
    var c, d, e, f, g;
    b.Sg('Path-Like Graph Wrapping', 1);
    if (a.b.c.length == 0) {
        b.Tg();
        return;
    }
    e = new imc(a);
    g = (e.i == null && (e.i = dmc(e, new kmc)), Beb(e.i) * e.f);
    c = g / (e.i == null && (e.i = dmc(e, new kmc)), Beb(e.i));
    if (e.b > c) {
        b.Tg();
        return;
    }
    switch(JD(WMb(a, (Bwc(), uwc)), 347).g){
        case 2:
            f = new umc;
            break;
        case 0:
            f = new jlc;
            break;
        default:
            f = new xmc;
    }
    d = f.mg(a, e);
    if (!f.ng()) switch(JD(WMb(a, Awc), 348).g){
        case 2:
            d = Gmc(e, d);
            break;
        case 1:
            d = Emc(e, d);
    }
    Amc(a, e, d);
    b.Tg();
}
function eB(a, b) {
    var c, d, e, f, g, h, i, j;
    b %= 24;
    if (a.q.getHours() != b) {
        d = new $wnd.Date(a.q.getTime());
        d.setDate(d.getDate() + 1);
        h = a.q.getTimezoneOffset() - d.getTimezoneOffset();
        if (h > 0) {
            i = h / 60 | 0;
            j = h % 60;
            e = a.q.getDate();
            c = a.q.getHours();
            c + i >= 24 && ++e;
            f = new $wnd.Date(a.q.getFullYear(), a.q.getMonth(), e, b + i, a.q.getMinutes() + j, a.q.getSeconds(), a.q.getMilliseconds());
            a.q.setTime(f.getTime());
        }
    }
    g = a.q.getTime();
    a.q.setTime(g + 3600000);
    a.q.getHours() != b && a.q.setTime(g);
}
function nEc(a, b) {
    var c, d, e, f;
    Bvb(a.d, a.e);
    a.c.a.$b();
    if (Beb(MD(WMb(b.j, (Bwc(), Ztc)))) != 0 || Beb(MD(WMb(b.j, Ztc))) != 0) {
        c = mze;
        XD(WMb(b.j, cuc)) !== XD((nyc(), kyc)) && ZMb(b.j, (Iqc(), Vpc), (xdb(), true));
        f = JD(WMb(b.j, jwc), 17).a;
        for(e = 0; e < f; e++){
            d = xEc(a, b);
            if (d < c) {
                c = d;
                AEc(a);
                if (c == 0) break;
            }
        }
    } else {
        c = Hqe;
        XD(WMb(b.j, cuc)) !== XD((nyc(), kyc)) && ZMb(b.j, (Iqc(), Vpc), (xdb(), true));
        f = JD(WMb(b.j, jwc), 17).a;
        for(e = 0; e < f; e++){
            d = yEc(a, b);
            if (d < c) {
                c = d;
                AEc(a);
                if (c == 0) break;
            }
        }
    }
}
function Fmc(a, b) {
    var c, d, e, f, g, h, i, j;
    g = new Ulb;
    h = 0;
    c = 0;
    i = 0;
    while(h < b.c.length - 1 && c < a.gc()){
        d = JD(a.Xb(c), 17).a + i;
        while((sDb(h + 1, b.c.length), JD(b.c[h + 1], 17)).a < d)++h;
        j = 0;
        f = d - (sDb(h, b.c.length), JD(b.c[h], 17)).a;
        e = (sDb(h + 1, b.c.length), JD(b.c[h + 1], 17)).a - d;
        f > e && ++j;
        Ilb(g, (sDb(h + j, b.c.length), JD(b.c[h + j], 17)));
        i += (sDb(h + j, b.c.length), JD(b.c[h + j], 17)).a - d;
        ++c;
        while(c < a.gc() && JD(a.Xb(c), 17).a + i <= (sDb(h + j, b.c.length), JD(b.c[h + j], 17)).a)++c;
        h += 1 + j;
    }
    return g;
}
function YAc(a, b) {
    var c, d, e, f, g;
    for(g = new es(Ir(hYb(b).a.Jc(), new er)); cs(g);){
        f = JD(ds(g), 18);
        if (a.f.b == 0) {
            e = f.c.i.k == (DYb(), AYb) && !!f.c.i.c && f.c.i.c.p == a.c;
            if (cs(new es(Ir(hYb(f.c.i).a.Jc(), new er)))) {
                c = JD(ds(new es(Ir(hYb(f.c.i).a.Jc(), new er))), 18).c.i.c;
                d = f.c.i.k == xYb && !!c && c.p == a.c;
            } else d = false;
        } else {
            e = f.c.i.k == (DYb(), AYb) && f.c.i.p == a.c;
            d = f.c.i.k == xYb && JD(ds(new es(Ir(hYb(f.c.i).a.Jc(), new er))), 18).c.i.p == a.c;
        }
        if (e || d) return true;
    }
    return false;
}
function GBc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = new Ulb;
    r = Tx(d);
    q = b * a.a;
    l = 0;
    o = 0;
    f = new Qrb;
    g = new Qrb;
    h = new Ulb;
    s = 0;
    t = 0;
    n = 0;
    p = 0;
    j = 0;
    k = 0;
    while(r.a.gc() != 0){
        i = KBc(r, e, g);
        if (i) {
            r.a.Ac(i);
            YCb(h.c, i);
            f.a.yc(i, f);
            o = a.f[i.p];
            s += a.e[i.p] - o * a.b;
            l = a.c[i.p];
            t += l * a.b;
            k += o * a.b;
            p += a.e[i.p];
        }
        if (!i || r.a.gc() == 0 || s >= q && a.e[i.p] > o * a.b || t >= c * q) {
            YCb(m.c, h);
            h = new Ulb;
            xe(g, f);
            f.a.$b();
            j -= k;
            n = $wnd.Math.max(n, j * a.b + p);
            j += t;
            s = t;
            t = 0;
            k = 0;
            p = 0;
        }
    }
    return new xod(n, m);
}
function KTd(a) {
    var b, c, d, e, f, g, h;
    if (!a.d) {
        h = new QWd;
        b = DTd;
        f = b.a.yc(a, b);
        if (f == null) {
            for(d = new CHd(UTd(a)); d.e != d.i.gc();){
                c = JD(AHd(d), 29);
                vCd(h, KTd(c));
            }
            b.a.Ac(a);
            b.a.gc() == 0 && undefined;
        }
        g = h.i;
        for(e = (!a.q && (a.q = new X0d(k6, a, 11, 10)), new CHd(a.q)); e.e != e.i.gc(); ++g)JD(AHd(e), 400);
        vCd(h, (!a.q && (a.q = new X0d(k6, a, 11, 10)), a.q));
        sDd(h);
        a.d = new gWd((JD(nDd(STd((GOd(), FOd).o), 9), 19), h.i), h.g);
        a.e = JD(h.g, 673);
        a.e == null && (a.e = ETd);
        TTd(a).b &= -17;
    }
    return a.d;
}
function Fbe(a, b, c, d) {
    var e, f, g, h, i, j;
    j = Kfe(a.e.zh(), b);
    i = 0;
    e = JD(a.g, 122);
    Ife();
    if (JD(b, 69).uk()) for(g = 0; g < a.i; ++g){
        f = e[g];
        if (j.Zl(f.Ik())) {
            if (pb(f, c)) return i;
            ++i;
        }
    }
    else if (c != null) {
        for(h = 0; h < a.i; ++h){
            f = e[h];
            if (j.Zl(f.Ik())) {
                if (pb(c, f.kd())) return i;
                ++i;
            }
        }
        if (d) {
            i = 0;
            for(g = 0; g < a.i; ++g){
                f = e[g];
                if (j.Zl(f.Ik())) {
                    if (XD(c) === XD(Vbe(a, JD(f.kd(), 57)))) return i;
                    ++i;
                }
            }
        }
    } else for(g = 0; g < a.i; ++g){
        f = e[g];
        if (j.Zl(f.Ik())) {
            if (f.kd() == null) return i;
            ++i;
        }
    }
    return -1;
}
function qfe(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p;
    if (c.Th(b)) {
        k = (n = b, !n ? null : JD(d, 52).ci(n));
        if (k) {
            p = c.Jh(b, a.a);
            o = b.t;
            if (o > 1 || o == -1) {
                l = JD(p, 71);
                m = JD(k, 71);
                if (l.dc()) m.$b();
                else {
                    g = !!s1d(b);
                    f = 0;
                    for(h = a.a ? l.Jc() : l.Fi(); h.Ob();){
                        j = JD(h.Pb(), 57);
                        e = JD(Tsb(a, j), 57);
                        if (!e) {
                            if (a.b && !g) {
                                m.Di(f, j);
                                ++f;
                            }
                        } else {
                            if (g) {
                                i = m.bd(e);
                                i == -1 ? m.Di(f, e) : f != i && m.Ri(f, e);
                            } else m.Di(f, e);
                            ++f;
                        }
                    }
                }
            } else if (p == null) k.Wb(null);
            else {
                e = Tsb(a, p);
                e == null ? a.b && !s1d(b) && k.Wb(p) : k.Wb(e);
            }
        }
    }
}
function f3b(a, b) {
    var c, d, e, f, g, h, i, j;
    c = new m3b;
    for(e = new es(Ir(hYb(b).a.Jc(), new er)); cs(e);){
        d = JD(ds(e), 18);
        if (eWb(d)) continue;
        h = d.c.i;
        if (g3b(h, d3b)) {
            j = h3b(a, h, d3b, c3b);
            if (j == -1) continue;
            c.b = $wnd.Math.max(c.b, j);
            !c.a && (c.a = new Ulb);
            Ilb(c.a, h);
        }
    }
    for(g = new es(Ir(kYb(b).a.Jc(), new er)); cs(g);){
        f = JD(ds(g), 18);
        if (eWb(f)) continue;
        i = f.d.i;
        if (g3b(i, c3b)) {
            j = h3b(a, i, c3b, d3b);
            if (j == -1) continue;
            c.d = $wnd.Math.max(c.d, j);
            !c.c && (c.c = new Ulb);
            Ilb(c.c, i);
        }
    }
    return c;
}
function C5b(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if (c.d.i == b.i) return;
    e = new tYb(a);
    rYb(e, (DYb(), yYb));
    ZMb(e, (Iqc(), kqc), c);
    ZMb(e, (Bwc(), Evc), (ajd(), Xid));
    YCb(d.c, e);
    g = new bZb;
    _Yb(g, e);
    aZb(g, (Rjd(), Qjd));
    h = new bZb;
    _Yb(h, e);
    aZb(h, wjd);
    k = c.d;
    hWb(c, g);
    f = new kWb;
    UMb(f, c);
    ZMb(f, Ruc, null);
    gWb(f, h);
    hWb(f, k);
    j = new Ajb(c.b, 0);
    while(j.b < j.d.gc()){
        i = (rDb(j.b < j.d.gc()), JD(j.d.Xb(j.c = j.b++), 72));
        if (XD(WMb(i, wuc)) === XD((nhd(), lhd))) {
            ZMb(i, Ppc, c);
            tjb(j);
            Ilb(f.b, i);
        }
    }
    E5b(e, g, h);
}
function B5b(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if (c.c.i == b.i) return;
    e = new tYb(a);
    rYb(e, (DYb(), yYb));
    ZMb(e, (Iqc(), kqc), c);
    ZMb(e, (Bwc(), Evc), (ajd(), Xid));
    YCb(d.c, e);
    g = new bZb;
    _Yb(g, e);
    aZb(g, (Rjd(), Qjd));
    h = new bZb;
    _Yb(h, e);
    aZb(h, wjd);
    hWb(c, g);
    f = new kWb;
    UMb(f, c);
    ZMb(f, Ruc, null);
    gWb(f, h);
    hWb(f, b);
    E5b(e, g, h);
    j = new Ajb(c.b, 0);
    while(j.b < j.d.gc()){
        i = (rDb(j.b < j.d.gc()), JD(j.d.Xb(j.c = j.b++), 72));
        k = JD(WMb(i, wuc), 276);
        if (k == (nhd(), lhd)) {
            XMb(i, Ppc) || ZMb(i, Ppc, c);
            tjb(j);
            Ilb(f.b, i);
        }
    }
}
function Jib(a) {
    Cib();
    var b, c, d, e;
    b = YD(a);
    if (a < Bib.length) return Bib[b];
    else if (a <= 50) return Phb((Ghb(), Dhb), b);
    else if (a <= Vre) return Qhb(Phb(Aib[1], b), b);
    if (a > 1000000) throw scb(new kdb('power of ten too big'));
    if (a <= Hqe) return Qhb(Phb(Aib[1], b), b);
    d = Phb(Aib[1], Hqe);
    e = d;
    c = zcb(a - Hqe);
    b = YD(a % Hqe);
    while(vcb(c, Hqe) > 0){
        e = Nhb(e, d);
        c = Mcb(c, Hqe);
    }
    e = Nhb(e, Phb(Aib[1], b));
    e = Qhb(e, Hqe);
    c = zcb(a - Hqe);
    while(vcb(c, Hqe) > 0){
        e = Qhb(e, Hqe);
        c = Mcb(c, Hqe);
    }
    e = Qhb(e, b);
    return e;
}
function E2b(a) {
    var b, c, d, e, f, g, h, i, j, k;
    for(i = new rmb(a.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 9);
        if (h.k != (DYb(), wYb)) continue;
        e = JD(WMb(h, (Iqc(), Tpc)), 64);
        if (e == (Rjd(), wjd) || e == Qjd) for(d = new es(Ir(eYb(h).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 18);
            b = c.a;
            if (b.b == 0) continue;
            j = c.c;
            if (j.i == h) {
                f = (rDb(b.b != 0), JD(b.a.a.c, 8));
                f.b = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    j.i.n,
                    j.n,
                    j.a
                ])).b;
            }
            k = c.d;
            if (k.i == h) {
                g = (rDb(b.b != 0), JD(b.c.b.c, 8));
                g.b = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    k.i.n,
                    k.n,
                    k.a
                ])).b;
            }
        }
    }
}
function kfc(a, b, c, d) {
    var e, f, g;
    this.j = new Ulb;
    this.k = new Ulb;
    this.b = new Ulb;
    this.c = new Ulb;
    this.e = new fdd;
    this.i = new Rdd;
    this.f = new bFb;
    this.d = new Ulb;
    this.g = new Ulb;
    Ilb(this.b, a);
    Ilb(this.b, b);
    this.e.c = $wnd.Math.min(a.a, b.a);
    this.e.d = $wnd.Math.min(a.b, b.b);
    this.e.b = $wnd.Math.abs(a.a - b.a);
    this.e.a = $wnd.Math.abs(a.b - b.b);
    e = JD(WMb(d, (Bwc(), Ruc)), 77);
    if (e) for(g = Gtb(e, 0); g.b != g.d.c;){
        f = JD(Utb(g), 8);
        qEb(f.a, a.a) && Atb(this.i, f);
    }
    !!c && Ilb(this.j, c);
    Ilb(this.k, d);
}
function yMc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    h = -1;
    for(k = new rmb(a); k.a < k.c.c.length;){
        j = JD(pmb(k), 116);
        j.g = h--;
        e = Pcb(lBb(HBb(BBb(new RBb(null, new Gvb(j.f, 16)), new AMc), new CMc)).d);
        f = Pcb(lBb(HBb(BBb(new RBb(null, new Gvb(j.k, 16)), new EMc), new GMc)).d);
        g = e;
        i = f;
        if (!d) {
            g = Pcb(lBb(HBb(new RBb(null, new Gvb(j.f, 16)), new IMc)).d);
            i = Pcb(lBb(HBb(new RBb(null, new Gvb(j.k, 16)), new KMc)).d);
        }
        j.d = g;
        j.a = e;
        j.i = i;
        j.b = f;
        i == 0 ? Dtb(c, j, c.c.b, c.c) : g == 0 && Dtb(b, j, b.c.b, b.c);
    }
}
function b7b(a, b) {
    var c, d, e, f, g, h;
    if (a.k == (DYb(), xYb)) {
        c = a.k == xYb && !PBb(BBb(JD(WMb(a, (Iqc(), wqc)), 15).Mc(), new Dzb(new JYb))).zd((wBb(), vBb)) ? (oid(), mid) : b;
        ZMb(a, (Iqc(), cqc), c);
        if (c != (oid(), lid)) {
            d = JD(WMb(a, kqc), 18);
            h = Beb(MD(WMb(d, (Bwc(), Fuc))));
            g = 0;
            if (c == kid) g = a.o.b - $wnd.Math.ceil(h / 2);
            else if (c == mid) {
                g = $wnd.Math.ceil(a.o.b - Beb(MD(WMb(gYb(a), Yvc))) - h) / 2;
                a.o.b -= Beb(MD(WMb(gYb(a), Yvc)));
                a.o.b -= h;
            }
            for(f = new rmb(a.j); f.a < f.c.c.length;){
                e = JD(pmb(f), 11);
                e.n.b = g;
            }
        }
    }
}
function $Kc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    e = true;
    for(g = new rmb(a.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        j = Lse;
        k = null;
        for(i = new rmb(f.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            l = Beb(b.p[h.p]) + Beb(b.d[h.p]) - h.d.d;
            d = Beb(b.p[h.p]) + Beb(b.d[h.p]) + h.o.b + h.d.a;
            if (l > j && d > j) {
                k = h;
                j = Beb(b.p[h.p]) + Beb(b.d[h.p]) + h.o.b + h.d.a;
            } else {
                e = false;
                c.Zg() && c._g('bk node placement breaks on ' + h + ' which should have been after ' + k);
                break;
            }
        }
        if (!e) break;
    }
    c.Zg() && c._g(b + ' is feasible: ' + e);
    return e;
}
function Q8b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    f = new tYb(a);
    rYb(f, (DYb(), BYb));
    ZMb(f, (Bwc(), Evc), (ajd(), Xid));
    e = 0;
    if (b) {
        g = new bZb;
        ZMb(g, (Iqc(), kqc), b);
        ZMb(f, kqc, b.i);
        aZb(g, (Rjd(), Qjd));
        _Yb(g, f);
        m = CXb(b.e);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            hWb(i, g);
        }
        ZMb(b, sqc, f);
        ++e;
    }
    if (c) {
        h = new bZb;
        ZMb(f, (Iqc(), kqc), c.i);
        ZMb(h, kqc, c);
        aZb(h, (Rjd(), wjd));
        _Yb(h, f);
        m = CXb(c.g);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            gWb(i, h);
        }
        ZMb(c, sqc, f);
        ++e;
    }
    ZMb(f, (Iqc(), Kpc), jfb(e));
    YCb(d.c, f);
    return f;
}
function Qad(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    for(c = (j = new Zjb(a.c.b).a.vc().Jc(), new ckb(j)); c.a.Ob();){
        b = (h = JD(c.a.Pb(), 43), JD(h.kd(), 149));
        e = b.a;
        e == null && (e = '');
        d = Iad(a.c, e);
        !d && e.length == 0 && (d = Uad(a));
        !!d && !ye(d.c, b, false) && Atb(d.c, b);
    }
    for(g = Gtb(a.a, 0); g.b != g.d.c;){
        f = JD(Utb(g), 473);
        k = Jad(a.c, f.a);
        n = Jad(a.c, f.b);
        !!k && !!n && Atb(k.c, new xod(n, f.c));
    }
    Ltb(a.a);
    for(m = Gtb(a.b, 0); m.b != m.d.c;){
        l = JD(Utb(m), 473);
        b = Gad(a.c, l.a);
        i = Jad(a.c, l.b);
        !!b && !!i && _9c(b, i, l.c);
    }
    Ltb(a.b);
}
function xA(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    g = new vB;
    j = WC(OC(cE, 1), ise, 30, 15, [
        0
    ]);
    e = -1;
    f = 0;
    d = 0;
    for(i = 0; i < a.b.c.length; ++i){
        k = JD(Mlb(a.b, i), 431);
        if (k.b > 0) {
            if (e < 0 && k.a) {
                e = i;
                f = j[0];
                d = 0;
            }
            if (e >= 0) {
                h = k.b;
                if (i == e) {
                    h -= d++;
                    if (h == 0) return 0;
                }
                if (!EA(b, j, k, h, g)) {
                    i = e - 1;
                    j[0] = f;
                    continue;
                }
            } else {
                e = -1;
                if (!EA(b, j, k, 0, g)) return 0;
            }
        } else {
            e = -1;
            if (_fb(k.c, 0) == 32) {
                l = j[0];
                CA(b, j);
                if (j[0] > l) continue;
            } else if (ogb(b, k.c, j[0])) {
                j[0] += k.c.length;
                continue;
            }
            return 0;
        }
    }
    if (!uB(g, c)) return 0;
    return j[0];
}
function APb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    k = new dvb(new QPb(c));
    h = SC(pcb, Vte, 30, a.f.e.c.length, 16, 1);
    Jmb(h, h.length);
    c[b.a] = 0;
    for(j = new rmb(a.f.e); j.a < j.c.c.length;){
        i = JD(pmb(j), 151);
        i.a != b.a && (c[i.a] = Hqe);
        yDb(_ub(k, i), Xse);
    }
    while(k.b.c.length != 0){
        l = JD(avb(k), 151);
        h[l.a] = true;
        for(f = nu(new ou(a.b, l), 0); f.c;){
            e = JD(Hu(f), 288);
            m = DPb(e, l);
            if (h[m.a]) continue;
            XMb(e, (nPb(), bPb)) ? g = Beb(MD(WMb(e, bPb))) : g = a.c;
            d = c[l.a] + g;
            if (d < c[m.a]) {
                c[m.a] = d;
                bvb(k, m);
                yDb(_ub(k, m), Xse);
            }
        }
    }
}
function rNb(a) {
    var b, c, d, e, f, g, h, i;
    c = ydb(LD(WMb(a, (IOb(), iOb))));
    f = a.a.c.d;
    h = a.a.d.d;
    if (c) {
        g = wdd(Bdd(new Edd(h.a, h.b), f), 0.5);
        i = wdd(odd(a.e), 0.5);
        b = Bdd(mdd(new Edd(f.a, f.b), g), i);
        zdd(a.d, b);
    } else {
        e = Beb(MD(WMb(a.a, AOb)));
        d = a.d;
        if (f.a >= h.a) {
            if (f.b >= h.b) {
                d.a = h.a + (f.a - h.a) / 2 + e;
                d.b = h.b + (f.b - h.b) / 2 - e - a.e.b;
            } else {
                d.a = h.a + (f.a - h.a) / 2 + e;
                d.b = f.b + (h.b - f.b) / 2 + e;
            }
        } else if (f.b >= h.b) {
            d.a = f.a + (h.a - f.a) / 2 + e;
            d.b = h.b + (f.b - h.b) / 2 + e;
        } else {
            d.a = f.a + (h.a - f.a) / 2 + e;
            d.b = f.b + (h.b - f.b) / 2 - e - a.e.b;
        }
    }
}
function LTd(a) {
    var b, c, d, e, f, g, h, i;
    if (!a.f) {
        i = new vWd;
        h = new vWd;
        b = DTd;
        g = b.a.yc(a, b);
        if (g == null) {
            for(f = new CHd(UTd(a)); f.e != f.i.gc();){
                e = JD(AHd(f), 29);
                vCd(i, LTd(e));
            }
            b.a.Ac(a);
            b.a.gc() == 0 && undefined;
        }
        for(d = (!a.s && (a.s = new X0d(q6, a, 21, 17)), new CHd(a.s)); d.e != d.i.gc();){
            c = JD(AHd(d), 178);
            RD(c, 101) && tCd(h, JD(c, 19));
        }
        sDd(h);
        a.r = new NWd(a, (JD(nDd(STd((GOd(), FOd).o), 6), 19), h.i), h.g);
        vCd(i, a.r);
        sDd(i);
        a.f = new gWd((JD(nDd(STd(FOd.o), 5), 19), i.i), i.g);
        TTd(a).b &= -3;
    }
    return a.f;
}
function HTd(a) {
    var b, c, d, e, f, g, h, i;
    if (!a.a) {
        a.o = null;
        i = new zWd(a);
        b = new DWd;
        c = DTd;
        h = c.a.yc(a, c);
        if (h == null) {
            for(g = new CHd(UTd(a)); g.e != g.i.gc();){
                f = JD(AHd(g), 29);
                vCd(i, HTd(f));
            }
            c.a.Ac(a);
            c.a.gc() == 0 && undefined;
        }
        for(e = (!a.s && (a.s = new X0d(q6, a, 21, 17)), new CHd(a.s)); e.e != e.i.gc();){
            d = JD(AHd(e), 178);
            RD(d, 330) && tCd(b, JD(d, 35));
        }
        sDd(b);
        a.k = new IWd(a, (JD(nDd(STd((GOd(), FOd).o), 7), 19), b.i), b.g);
        vCd(i, a.k);
        sDd(i);
        a.a = new gWd((JD(nDd(STd(FOd.o), 4), 19), i.i), i.g);
        TTd(a).b &= -2;
    }
    return a.a;
}
function Uud() {
    Uud = Zcb;
    Sud = WC(OC(_D, 1), Ure, 30, 15, [
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        65,
        66,
        67,
        68,
        69,
        70
    ]);
    Tud = new RegExp('[ \t\n\r\f]+');
    try {
        Rud = WC(OC(_6, 1), Nqe, 2060, 0, [
            new xZd((OA(), QA("yyyy-MM-dd'T'HH:mm:ss'.'SSSZ", TA((SA(), SA(), RA))))),
            new xZd(QA("yyyy-MM-dd'T'HH:mm:ss'.'SSS", TA(RA))),
            new xZd(QA("yyyy-MM-dd'T'HH:mm:ss", TA(RA))),
            new xZd(QA("yyyy-MM-dd'T'HH:mm", TA(RA))),
            new xZd(QA('yyyy-MM-dd', TA(RA)))
        ]);
    } catch (a) {
        a = rcb(a);
        if (!RD(a, 80)) throw scb(a);
    }
}
function xEc(a, b) {
    var c, d, e, f;
    e = yvb(a.d, 1) != 0;
    d = pEc(a, b);
    if (d == 0 && ydb(LD(WMb(b.j, (Iqc(), Vpc))))) return 0;
    !ydb(LD(WMb(b.j, (Iqc(), Vpc)))) && !ydb(LD(WMb(b.j, yqc))) || XD(WMb(b.j, (Bwc(), cuc))) === XD((nyc(), kyc)) ? b.c.kg(b.e, e) : e = ydb(LD(WMb(b.j, Vpc)));
    GEc(a, b, e, true);
    ydb(LD(WMb(b.j, yqc))) && ZMb(b.j, yqc, (xdb(), false));
    if (ydb(LD(WMb(b.j, Vpc)))) {
        ZMb(b.j, Vpc, (xdb(), false));
        ZMb(b.j, yqc, true);
    }
    c = pEc(a, b);
    do {
        BEc(a);
        if (c == 0) return 0;
        e = !e;
        f = c;
        GEc(a, b, e, false);
        c = pEc(a, b);
    }while (f > c);
    return f;
}
function yEc(a, b) {
    var c, d, e, f;
    e = yvb(a.d, 1) != 0;
    d = oEc(a, b);
    if (d == 0 && ydb(LD(WMb(b.j, (Iqc(), Vpc))))) return 0;
    !ydb(LD(WMb(b.j, (Iqc(), Vpc)))) && !ydb(LD(WMb(b.j, yqc))) || XD(WMb(b.j, (Bwc(), cuc))) === XD((nyc(), kyc)) ? b.c.kg(b.e, e) : e = ydb(LD(WMb(b.j, Vpc)));
    GEc(a, b, e, true);
    ydb(LD(WMb(b.j, yqc))) && ZMb(b.j, yqc, (xdb(), false));
    if (ydb(LD(WMb(b.j, Vpc)))) {
        ZMb(b.j, Vpc, (xdb(), false));
        ZMb(b.j, yqc, true);
    }
    c = oEc(a, b);
    do {
        BEc(a);
        if (c == 0) return 0;
        e = !e;
        f = c;
        GEc(a, b, e, false);
        c = oEc(a, b);
    }while (f > c);
    return f;
}
function $Pb(a, b, c) {
    var d, e, f, g, h;
    d = JD(WMb(a, (Bwc(), duc)), 22);
    c.a > b.a && (d.Gc((Hed(), Bed)) ? a.c.a += (c.a - b.a) / 2 : d.Gc(Ded) && (a.c.a += c.a - b.a));
    c.b > b.b && (d.Gc((Hed(), Fed)) ? a.c.b += (c.b - b.b) / 2 : d.Gc(Eed) && (a.c.b += c.b - b.b));
    if (JD(WMb(a, (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) && (c.a > b.a || c.b > b.b)) for(h = new rmb(a.a); h.a < h.c.c.length;){
        g = JD(pmb(h), 9);
        if (g.k == (DYb(), wYb)) {
            e = JD(WMb(g, Tpc), 64);
            e == (Rjd(), wjd) ? g.n.a += c.a - b.a : e == Ojd && (g.n.b += c.b - b.b);
        }
    }
    f = a.d;
    a.f.a = c.a - f.b - f.c;
    a.f.b = c.b - f.d - f.a;
}
function i2b(a, b, c) {
    var d, e, f, g, h;
    d = JD(WMb(a, (Bwc(), duc)), 22);
    c.a > b.a && (d.Gc((Hed(), Bed)) ? a.c.a += (c.a - b.a) / 2 : d.Gc(Ded) && (a.c.a += c.a - b.a));
    c.b > b.b && (d.Gc((Hed(), Fed)) ? a.c.b += (c.b - b.b) / 2 : d.Gc(Eed) && (a.c.b += c.b - b.b));
    if (JD(WMb(a, (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) && (c.a > b.a || c.b > b.b)) for(g = new rmb(a.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        if (f.k == (DYb(), wYb)) {
            e = JD(WMb(f, Tpc), 64);
            e == (Rjd(), wjd) ? f.n.a += c.a - b.a : e == Ojd && (f.n.b += c.b - b.b);
        }
    }
    h = a.d;
    a.f.a = c.a - h.b - h.c;
    a.f.b = c.b - h.d - h.a;
}
function NKc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    b = eLc(a);
    for(k = (h = new Ojb(b).a.vc().Jc(), new Ujb(h)); k.a.Ob();){
        j = (e = JD(k.a.Pb(), 43), JD(e.jd(), 9));
        l = 0;
        m = 0;
        l = j.d.d;
        m = j.o.b + j.d.a;
        a.d[j.p] = 0;
        c = j;
        while((f = a.a[c.p]) != j){
            d = gLc(c, f);
            i = 0;
            a.c == (zKc(), xKc) ? i = d.d.n.b + d.d.a.b - d.c.n.b - d.c.a.b : i = d.c.n.b + d.c.a.b - d.d.n.b - d.d.a.b;
            g = Beb(a.d[c.p]) + i;
            a.d[f.p] = g;
            l = $wnd.Math.max(l, f.d.d - g);
            m = $wnd.Math.max(m, g + f.o.b + f.d.a);
            c = f;
        }
        c = j;
        do {
            a.d[c.p] = Beb(a.d[c.p]) + l;
            c = a.a[c.p];
        }while (c != j);
        a.b[j.p] = l + m;
    }
}
function Tcd(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    i = Bdd(new Edd(c.a, c.b), a);
    j = i.a * b.b - i.b * b.a;
    k = b.a * d.b - b.b * d.a;
    l = (i.a * d.b - i.b * d.a) / k;
    m = j / k;
    if (k == 0) {
        if (j == 0) {
            e = mdd(new Edd(c.a, c.b), wdd(new Edd(d.a, d.b), 0.5));
            f = pdd(a, e);
            g = pdd(mdd(new Edd(a.a, a.b), b), e);
            h = $wnd.Math.sqrt(d.a * d.a + d.b * d.b) * 0.5;
            if (f < g && f <= h) return new Edd(a.a, a.b);
            if (g <= h) return mdd(new Edd(a.a, a.b), b);
            return null;
        } else return null;
    } else return l >= 0 && l <= 1 && m >= 0 && m <= 1 ? mdd(new Edd(a.a, a.b), wdd(new Edd(b.a, b.b), l)) : null;
}
function g4c(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = 0;
    g = a.t;
    e = 0;
    d = 0;
    i = 0;
    m = 0;
    l = 0;
    if (c) {
        a.n.c.length = 0;
        Ilb(a.n, new p4c(a.s, a.t, a.i));
    }
    h = 0;
    for(k = new rmb(a.b); k.a < k.c.c.length;){
        j = JD(pmb(k), 27);
        if (f + j.g + (h > 0 ? a.i : 0) > b && i > 0) {
            f = 0;
            g += i + a.i;
            e = $wnd.Math.max(e, m);
            d += i + a.i;
            i = 0;
            m = 0;
            if (c) {
                ++l;
                Ilb(a.n, new p4c(a.s, g, a.i));
            }
            h = 0;
        }
        m += j.g + (h > 0 ? a.i : 0);
        i = $wnd.Math.max(i, j.f);
        c && k4c(JD(Mlb(a.n, l), 208), j);
        f += j.g + (h > 0 ? a.i : 0);
        ++h;
    }
    e = $wnd.Math.max(e, m);
    d += i;
    if (c) {
        a.r = e;
        a.d = d;
        U4c(a.j);
    }
    return new gdd(a.s, a.t, e, d);
}
function s_b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    h = a.d;
    l = JD(WMb(a, (Iqc(), Hqc)), 15);
    b = JD(WMb(a, Fpc), 15);
    if (!l && !b) return;
    f = Beb(MD(kzc(a, (Bwc(), Tvc))));
    g = Beb(MD(kzc(a, Uvc)));
    m = 0;
    if (l) {
        j = 0;
        for(e = l.Jc(); e.Ob();){
            d = JD(e.Pb(), 9);
            j = $wnd.Math.max(j, d.o.b);
            m += d.o.a;
        }
        m += f * (l.gc() - 1);
        h.d += j + g;
    }
    c = 0;
    if (b) {
        j = 0;
        for(e = b.Jc(); e.Ob();){
            d = JD(e.Pb(), 9);
            j = $wnd.Math.max(j, d.o.b);
            c += d.o.a;
        }
        c += f * (b.gc() - 1);
        h.a += j + g;
    }
    i = $wnd.Math.max(m, c);
    if (i > a.o.a) {
        k = (i - a.o.a) / 2;
        h.b = $wnd.Math.max(h.b, k);
        h.c = $wnd.Math.max(h.c, k);
    }
}
function vbe(a, b, c, d) {
    var e, f, g, h, i, j, k;
    k = Kfe(a.e.zh(), b);
    e = 0;
    f = JD(a.g, 122);
    i = null;
    Ife();
    if (JD(b, 69).uk()) for(h = 0; h < a.i; ++h){
        g = f[h];
        if (k.Zl(g.Ik())) {
            if (pb(g, c)) {
                i = g;
                break;
            }
            ++e;
        }
    }
    else if (c != null) for(h = 0; h < a.i; ++h){
        g = f[h];
        if (k.Zl(g.Ik())) {
            if (pb(c, g.kd())) {
                i = g;
                break;
            }
            ++e;
        }
    }
    else for(h = 0; h < a.i; ++h){
        g = f[h];
        if (k.Zl(g.Ik())) {
            if (g.kd() == null) {
                i = g;
                break;
            }
            ++e;
        }
    }
    if (i) {
        if (qqd(a.e)) {
            j = b.Gk() ? new Gge(a.e, 4, b, c, null, e, true) : Abe(a, b.qk() ? 2 : 1, b, c, b.fk(), -1, true);
            d ? d.kj(j) : d = j;
        }
        d = ube(a, i, d);
    }
    return d;
}
function s2c(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p;
    o = 0;
    p = 0;
    i = e.c;
    h = e.b;
    k = c.f;
    n = c.g;
    switch(b.g){
        case 0:
            o = d.i + d.g + g;
            a.c ? p = B2c(o, f, d, g) : p = d.j;
            m = $wnd.Math.max(i, o + n);
            j = $wnd.Math.max(h, p + k);
            break;
        case 1:
            p = d.j + d.f + g;
            a.c ? o = A2c(p, f, d, g) : o = d.i;
            m = $wnd.Math.max(i, o + n);
            j = $wnd.Math.max(h, p + k);
            break;
        case 2:
            o = i + g;
            p = 0;
            m = i + g + n;
            j = $wnd.Math.max(h, k);
            break;
        case 3:
            o = 0;
            p = h + g;
            m = $wnd.Math.max(i, n);
            j = h + g + k;
            break;
        default:
            throw scb(new Teb('IllegalPlacementOption.'));
    }
    l = new C4c(a.a, m, j, b, o, p);
    return l;
}
function oEd(a) {
    var b, c, d, e, f, g, h, i;
    f = new B8c;
    x8c(f, (w8c(), t8c));
    for(d = (e = gC(a, SC(hJ, hre, 2, 0, 6, 1)), new ujb(new dnb(new uC(a, e).b))); d.b < d.d.gc();){
        c = (rDb(d.b < d.d.gc()), OD(d.d.Xb(d.c = d.b++)));
        g = Kad(iEd, c);
        if (g) {
            b = iC(a, c);
            b.re() ? h = b.re().a : b.oe() ? h = '' + b.oe().a : b.pe() ? h = '' + b.pe().a : h = b.Ib();
            i = Obd(g, h);
            if (i != null) {
                (rrb(g.j, (lcd(), icd)) || rrb(g.j, jcd)) && YMb(z8c(f, A3), g, i);
                rrb(g.j, gcd) && YMb(z8c(f, x3), g, i);
                rrb(g.j, kcd) && YMb(z8c(f, B3), g, i);
                rrb(g.j, hcd) && YMb(z8c(f, z3), g, i);
            }
        }
    }
    return f;
}
function Dbe(a, b, c) {
    var d, e, f, g, h, i, j, k;
    e = JD(a.g, 122);
    if (Lfe(a.e, b)) return Ife(), JD(b, 69).uk() ? new Jge(b, a) : new Zfe(b, a);
    else {
        j = Kfe(a.e.zh(), b);
        d = 0;
        for(h = 0; h < a.i; ++h){
            f = e[h];
            g = f.Ik();
            if (j.Zl(g)) {
                Ife();
                if (JD(b, 69).uk()) return f;
                else if (g == (ehe(), che) || g == _ge) {
                    i = new Wgb(adb(f.kd()));
                    while(++h < a.i){
                        f = e[h];
                        g = f.Ik();
                        (g == che || g == _ge) && Qgb(i, adb(f.kd()));
                    }
                    return bfe(JD(b.Ek(), 155), i.a);
                } else {
                    k = f.kd();
                    k != null && c && RD(b, 101) && (JD(b, 19).Bb & Pse) != 0 && (k = Wbe(a, b, h, d, k));
                    return k;
                }
            }
            ++d;
        }
        return b.fk();
    }
}
function Flc(a) {
    var b, c, d, e, f, g, h, i;
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        for(g = new rmb(Zu(d.a)); g.a < g.c.c.length;){
            f = JD(pmb(g), 9);
            if (vlc(f)) {
                c = JD(WMb(f, (Iqc(), Gpc)), 314);
                if (!c.g && !!c.d) {
                    b = c;
                    i = c.d;
                    while(i){
                        Elc(i.i, i.k, false, true);
                        Mlc(b.a);
                        Mlc(i.i);
                        Mlc(i.k);
                        Mlc(i.b);
                        hWb(i.c, b.c.d);
                        hWb(b.c, null);
                        qYb(b.a, null);
                        qYb(i.i, null);
                        qYb(i.k, null);
                        qYb(i.b, null);
                        h = new tlc(b.i, i.a, b.e, i.j, i.f);
                        h.k = b.k;
                        h.n = b.n;
                        h.b = b.b;
                        h.c = i.c;
                        h.g = b.g;
                        h.d = i.d;
                        ZMb(b.i, Gpc, h);
                        ZMb(i.a, Gpc, h);
                        i = i.d;
                        b = h;
                    }
                }
            }
        }
    }
}
function Cbe(a, b, c, d) {
    var e, f, g, h, i, j;
    i = Kfe(a.e.zh(), b);
    f = JD(a.g, 122);
    if (Lfe(a.e, b)) {
        e = 0;
        for(h = 0; h < a.i; ++h){
            g = f[h];
            if (i.Zl(g.Ik())) {
                if (e == c) {
                    Ife();
                    if (JD(b, 69).uk()) return g;
                    else {
                        j = g.kd();
                        j != null && d && RD(b, 101) && (JD(b, 19).Bb & Pse) != 0 && (j = Wbe(a, b, h, e, j));
                        return j;
                    }
                }
                ++e;
            }
        }
        throw scb(new mdb(IEe + c + ODe + e));
    } else {
        e = 0;
        for(h = 0; h < a.i; ++h){
            g = f[h];
            if (i.Zl(g.Ik())) {
                Ife();
                if (JD(b, 69).uk()) return g;
                else {
                    j = g.kd();
                    j != null && d && RD(b, 101) && (JD(b, 19).Bb & Pse) != 0 && (j = Wbe(a, b, h, e, j));
                    return j;
                }
            }
            ++e;
        }
        return b.fk();
    }
}
function oib() {
    oib = Zcb;
    mib = WC(OC(cE, 1), ise, 30, 15, [
        Lre,
        1162261467,
        Cre,
        1220703125,
        362797056,
        1977326743,
        Cre,
        387420489,
        Ese,
        214358881,
        429981696,
        815730721,
        1475789056,
        170859375,
        268435456,
        410338673,
        612220032,
        893871739,
        1280000000,
        1801088541,
        113379904,
        148035889,
        191102976,
        244140625,
        308915776,
        387420489,
        481890304,
        594823321,
        729000000,
        887503681,
        Cre,
        1291467969,
        1544804416,
        1838265625,
        60466176
    ]);
    nib = WC(OC(cE, 1), ise, 30, 15, [
        -1,
        -1,
        31,
        19,
        15,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5
    ]);
}
function xib(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    g = a.e;
    i = b.e;
    if (i == 0) return a;
    if (g == 0) return b.e == 0 ? b : new Vhb(-b.e, b.d, b.a);
    f = a.d;
    h = b.d;
    if (f + h == 2) {
        c = ucb(a.a[0], Use);
        d = ucb(b.a[0], Use);
        g < 0 && (c = Gcb(c));
        i < 0 && (d = Gcb(d));
        return Ghb(), Bcb(Mcb(c, d), 0) ? aib(Mcb(c, d)) : Ohb(aib(Gcb(Mcb(c, d))));
    }
    e = f != h ? f > h ? 1 : -1 : vib(a.a, b.a, f);
    if (e == -1) {
        l = -i;
        k = g == i ? yib(b.a, h, a.a, f) : tib(b.a, h, a.a, f);
    } else {
        l = g;
        if (g == i) {
            if (e == 0) return Ghb(), Fhb;
            k = yib(a.a, f, b.a, h);
        } else k = tib(a.a, f, b.a, h);
    }
    j = new Vhb(l, k.length, k);
    Ihb(j);
    return j;
}
function o$b(a, b) {
    var c, d, e, f;
    f = j$b(b);
    !b.c && (b.c = new X0d(B3, b, 9, 9));
    EBb(new RBb(null, (!b.c && (b.c = new X0d(B3, b, 9, 9)), new Gvb(b.c, 16))), new E$b(f));
    e = JD(WMb(f, (Iqc(), Wpc)), 22);
    i$b(b, e);
    if (e.Gc(($oc(), Toc))) for(d = new CHd((!b.c && (b.c = new X0d(B3, b, 9, 9)), b.c)); d.e != d.i.gc();){
        c = JD(AHd(d), 124);
        s$b(a, b, f, c);
    }
    JD(ksd(b, (Bwc(), ovc)), 181).gc() != 0 && f$b(b, f);
    ydb(LD(WMb(f, vvc))) && e.Ec(Yoc);
    XMb(f, Svc) && Kwc(new Uwc(Beb(MD(WMb(f, Svc)))), f);
    XD(ksd(b, Iuc)) === XD((eid(), bid)) ? p$b(a, b, f) : n$b(a, b, f);
    return f;
}
function Ipe(a, b) {
    var c, d, e, f, g, h, i;
    if (a == null) return null;
    f = a.length;
    if (f == 0) return '';
    i = SC(_D, Ure, 30, f, 15, 1);
    zDb(0, f, a.length);
    zDb(0, f, i.length);
    egb(a, 0, f, i, 0);
    c = null;
    h = b;
    for(e = 0, g = 0; e < f; e++){
        d = i[e];
        dme();
        if (d <= 32 && (cme[d] & 2) != 0) {
            if (h) {
                !c && (c = new Jgb(a));
                Ggb(c, e - g++);
            } else {
                h = b;
                if (d != 32) {
                    !c && (c = new Jgb(a));
                    gdb(c, e - g, e - g + 1, String.fromCharCode(32));
                }
            }
        } else h = false;
    }
    if (h) {
        if (!c) return zDb(0, f - 1, a.length), a.substr(0, f - 1);
        else {
            f = c.a.length;
            return f > 0 ? qgb(c.a, 0, f - 1) : '';
        }
    } else return !c ? a : c.a;
}
function P_c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    for(d = new es(Ir($Bd(b).a.Jc(), new er)); cs(d);){
        c = JD(ds(d), 85);
        if (!RD(nDd((!c.b && (c.b = new ree(v3, c, 4, 7)), c.b), 0), 193)) {
            i = _Bd(JD(nDd((!c.c && (c.c = new ree(v3, c, 5, 8)), c.c), 0), 84));
            if (!Rtd(c)) {
                g = b.i + b.g / 2;
                h = b.j + b.f / 2;
                k = i.i + i.g / 2;
                l = i.j + i.f / 2;
                m = new Cdd;
                m.a = k - g;
                m.b = l - h;
                f = new Edd(m.a, m.b);
                Lcd(f, b.g, b.f);
                m.a -= f.a;
                m.b -= f.b;
                g = k - m.a;
                h = l - m.b;
                j = new Edd(m.a, m.b);
                Lcd(j, i.g, i.f);
                m.a -= j.a;
                m.b -= j.b;
                k = g + m.a;
                l = h + m.b;
                e = hCd(c);
                qud(e, g);
                rud(e, h);
                jud(e, k);
                kud(e, l);
                P_c(a, i);
            }
        }
    }
}
function Poe(a, b) {
    var c, d, e, f, g;
    g = JD(b, 136);
    Qoe(a);
    Qoe(g);
    if (g.b == null) return;
    a.c = true;
    if (a.b == null) {
        a.b = SC(cE, ise, 30, g.b.length, 15, 1);
        $gb(g.b, 0, a.b, 0, g.b.length);
        return;
    }
    f = SC(cE, ise, 30, a.b.length + g.b.length, 15, 1);
    for(c = 0, d = 0, e = 0; c < a.b.length || d < g.b.length;){
        if (c >= a.b.length) {
            f[e++] = g.b[d++];
            f[e++] = g.b[d++];
        } else if (d >= g.b.length) {
            f[e++] = a.b[c++];
            f[e++] = a.b[c++];
        } else if (g.b[d] < a.b[c] || g.b[d] === a.b[c] && g.b[d + 1] < a.b[c + 1]) {
            f[e++] = g.b[d++];
            f[e++] = g.b[d++];
        } else {
            f[e++] = a.b[c++];
            f[e++] = a.b[c++];
        }
    }
    a.b = f;
}
function t3b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    c = ydb(LD(WMb(a, (Iqc(), eqc))));
    h = ydb(LD(WMb(b, eqc)));
    d = JD(WMb(a, fqc), 11);
    i = JD(WMb(b, fqc), 11);
    e = JD(WMb(a, gqc), 11);
    j = JD(WMb(b, gqc), 11);
    k = !!d && d == i;
    l = !!e && e == j;
    if (!c && !h) return new A3b(JD(pmb(new rmb(a.j)), 11).p == JD(pmb(new rmb(b.j)), 11).p, k, l);
    f = (!ydb(LD(WMb(a, eqc))) || ydb(LD(WMb(a, dqc)))) && (!ydb(LD(WMb(b, eqc))) || ydb(LD(WMb(b, dqc))));
    g = (!ydb(LD(WMb(a, eqc))) || !ydb(LD(WMb(a, dqc)))) && (!ydb(LD(WMb(b, eqc))) || !ydb(LD(WMb(b, dqc))));
    return new A3b(k && f || l && g, k, l);
}
function b4c(a) {
    var b, c, d, e, f, g, h, i;
    d = 0;
    c = 0;
    i = new Mtb;
    b = 0;
    for(h = new rmb(a.n); h.a < h.c.c.length;){
        g = JD(pmb(h), 208);
        if (g.c.c.length == 0) Dtb(i, g, i.c.b, i.c);
        else {
            d = $wnd.Math.max(d, g.d);
            c += g.a + (b > 0 ? a.i : 0);
        }
        ++b;
    }
    Be(a.n, i);
    a.d = c;
    a.r = d;
    a.g = 0;
    a.f = 0;
    a.e = 0;
    a.o = Kse;
    a.p = Kse;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 27);
        a.p = $wnd.Math.min(a.p, e.g);
        a.g = $wnd.Math.max(a.g, e.g);
        a.f = $wnd.Math.max(a.f, e.f);
        a.o = $wnd.Math.min(a.o, e.f);
        a.e += e.f + a.i;
    }
    a.a = a.e / a.b.c.length - a.i * ((a.b.c.length - 1) / a.b.c.length);
    U4c(a.j);
}
function Utd(a) {
    var b, c, d, e;
    if ((a.Db & 64) != 0) return Qsd(a);
    b = new Wgb(CCe);
    d = a.k;
    if (!d) {
        !a.n && (a.n = new X0d(z3, a, 1, 7));
        if (a.n.i > 0) {
            e = (!a.n && (a.n = new X0d(z3, a, 1, 7)), JD(nDd(a.n, 0), 153)).a;
            !e || Qgb(Qgb((b.a += ' "', b), e), '"');
        }
    } else Qgb(Qgb((b.a += ' "', b), d), '"');
    c = (!a.b && (a.b = new ree(v3, a, 4, 7)), !(a.b.i <= 1 && (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c.i <= 1)));
    c ? (b.a += ' [', b) : (b.a += ' ', b);
    Qgb(b, Eb(new Gb, new CHd(a.b)));
    c && (b.a += ']', b);
    b.a += Fve;
    c && (b.a += '[', b);
    Qgb(b, Eb(new Gb, new CHd(a.c)));
    c && (b.a += ']', b);
    return b.a;
}
function B6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    v = a.c;
    w = b.c;
    c = Nlb(v.a, a, 0);
    d = Nlb(w.a, b, 0);
    t = JD(mYb(a, (Eyc(), Byc)).Jc().Pb(), 11);
    C = JD(mYb(a, Cyc).Jc().Pb(), 11);
    u = JD(mYb(b, Byc).Jc().Pb(), 11);
    D = JD(mYb(b, Cyc).Jc().Pb(), 11);
    r = CXb(t.e);
    A = CXb(C.g);
    s = CXb(u.e);
    B = CXb(D.g);
    pYb(a, d, w);
    for(g = s, k = 0, o = g.length; k < o; ++k){
        e = g[k];
        hWb(e, t);
    }
    for(h = B, l = 0, p = h.length; l < p; ++l){
        e = h[l];
        gWb(e, C);
    }
    pYb(b, c, v);
    for(i = r, m = 0, q = i.length; m < q; ++m){
        e = i[m];
        hWb(e, u);
    }
    for(f = A, j = 0, n = f.length; j < n; ++j){
        e = f[j];
        gWb(e, D);
    }
}
function bZc(a) {
    var b, c, d, e, f, g, h;
    g = JD(ksd(a, (xYc(), wYc)), 27);
    for(d = new CHd((!g.e && (g.e = new ree(x3, g, 7, 4)), g.e)); d.e != d.i.gc();){
        c = JD(AHd(d), 85);
        h = new Edd(JD(nDd((!c.a && (c.a = new X0d(w3, c, 6, 6)), c.a), 0), 168).j, JD(nDd((!c.a && (c.a = new X0d(w3, c, 6, 6)), c.a), 0), 168).k);
        f = new Edd(JD(nDd((!c.a && (c.a = new X0d(w3, c, 6, 6)), c.a), 0), 168).b, JD(nDd((!c.a && (c.a = new X0d(w3, c, 6, 6)), c.a), 0), 168).c);
        e = new Edd(f.a - h.a, f.b - h.b);
        b = $wnd.Math.atan2(e.b, e.a);
        JD(nDd((!c.c && (c.c = new ree(v3, c, 5, 8)), c.c), 0), 84).of((b_c(), Z$c), b);
    }
}
function r0c(a, b) {
    var c, d, e, f, g, h, i, j, k;
    b.Sg('Interactive Node Reorderer', 1);
    k = (!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a);
    h = new Ulb;
    for(e = new CHd(k); e.e != e.i.gc();){
        c = JD(AHd(e), 27);
        lsd(c, (k2c(), O1c)) && YCb(h.c, c);
    }
    for(f = new rmb(h); f.a < f.c.c.length;){
        c = JD(pmb(f), 27);
        CCd(k, c);
    }
    pnb();
    Slb(h, new v0c);
    for(g = new rmb(h); g.a < g.c.c.length;){
        c = JD(pmb(g), 27);
        j = JD(ksd(c, (k2c(), O1c)), 17).a;
        j = $wnd.Math.min(j, k.i);
        sCd(k, j, c);
    }
    i = 0;
    for(d = new CHd(k); d.e != d.i.gc();){
        c = JD(AHd(d), 27);
        msd(c, (k2c(), N1c), jfb(i));
        ++i;
    }
    b.Tg();
}
function QHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    h = SC(cE, ise, 30, b.b.c.length, 15, 1);
    j = SC(PP, Ere, 247, b.b.c.length, 0, 1);
    i = SC(RP, Jve, 9, b.b.c.length, 0, 1);
    for(l = a.a, m = 0, n = l.length; m < n; ++m){
        k = l[m];
        p = 0;
        for(g = new rmb(k.e); g.a < g.c.c.length;){
            e = JD(pmb(g), 9);
            d = a$b(e.c);
            ++h[d];
            o = Beb(MD(WMb(b, (Bwc(), Wvc))));
            h[d] > 0 && !!i[d] && (o = ezc(a.b, i[d], e));
            p = $wnd.Math.max(p, e.c.c.b + o);
        }
        for(f = new rmb(k.e); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            e.n.b = p + e.d.d;
            c = e.c;
            c.c.b = p + e.d.d + e.o.b + e.d.a;
            j[Nlb(c.b.b, c, 0)] = e.k;
            i[Nlb(c.b.b, c, 0)] = e;
        }
    }
}
function SNc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if ($wnd.Math.abs(b.s - b.c) < Fue || $wnd.Math.abs(c.s - c.c) < Fue) return 0;
    d = RNc(a, b.j, c.e);
    e = RNc(a, c.j, b.e);
    f = d == -1 || e == -1;
    g = 0;
    if (f) {
        if (d == -1) {
            new eNc((iNc(), gNc), c, b, 1);
            ++g;
        }
        if (e == -1) {
            new eNc((iNc(), gNc), b, c, 1);
            ++g;
        }
    } else {
        h = YNc(b.j, c.s, c.c);
        h += YNc(c.e, b.s, b.c);
        i = YNc(c.j, b.s, b.c);
        i += YNc(b.e, c.s, c.c);
        j = d + 16 * h;
        k = e + 16 * i;
        if (j < k) new eNc((iNc(), hNc), b, c, k - j);
        else if (j > k) new eNc((iNc(), hNc), c, b, j - k);
        else if (j > 0 && k > 0) {
            new eNc((iNc(), hNc), b, c, 0);
            new eNc(hNc, c, b, 0);
        }
    }
    return g;
}
function sRc(a, b, c) {
    var d, e, f;
    a.a = new Ulb;
    for(f = Gtb(b.b, 0); f.b != f.d.c;){
        e = JD(Utb(f), 39);
        while(JD(WMb(e, (kVc(), iVc)), 17).a > a.a.c.length - 1)Ilb(a.a, new xod(mze, Fze));
        d = JD(WMb(e, iVc), 17).a;
        if (c == (Tgd(), Pgd) || c == Qgd) {
            e.e.a < Beb(MD(JD(Mlb(a.a, d), 47).a)) && vod(JD(Mlb(a.a, d), 47), e.e.a);
            e.e.a + e.f.a > Beb(MD(JD(Mlb(a.a, d), 47).b)) && wod(JD(Mlb(a.a, d), 47), e.e.a + e.f.a);
        } else {
            e.e.b < Beb(MD(JD(Mlb(a.a, d), 47).a)) && vod(JD(Mlb(a.a, d), 47), e.e.b);
            e.e.b + e.f.b > Beb(MD(JD(Mlb(a.a, d), 47).b)) && wod(JD(Mlb(a.a, d), 47), e.e.b + e.f.b);
        }
    }
}
function qXb(a, b, c, d) {
    var e, f, g, h, i, j, k;
    f = sXb(d);
    h = ydb(LD(WMb(d, (Bwc(), dvc))));
    if ((h || ydb(LD(WMb(a, Muc)))) && !cjd(JD(WMb(a, Evc), 100))) {
        e = Wjd(f);
        i = AXb(a, c, c == (Eyc(), Cyc) ? e : Tjd(e));
    } else {
        i = new bZb;
        _Yb(i, a);
        if (b) {
            k = i.n;
            k.a = b.a - a.n.a;
            k.b = b.b - a.n.b;
            ndd(k, 0, 0, a.o.a, a.o.b);
            aZb(i, mXb(i, f));
        } else {
            e = Wjd(f);
            aZb(i, c == (Eyc(), Cyc) ? e : Tjd(e));
        }
        g = JD(WMb(d, (Iqc(), Wpc)), 22);
        j = i.j;
        switch(f.g){
            case 2:
            case 1:
                (j == (Rjd(), xjd) || j == Ojd) && g.Ec(($oc(), Xoc));
                break;
            case 4:
            case 3:
                (j == (Rjd(), wjd) || j == Qjd) && g.Ec(($oc(), Xoc));
        }
    }
    return i;
}
function dRb(a, b) {
    var c, d, e, f, g, h;
    for(g = new mjb(new djb(a.f.b).a); g.b;){
        f = kjb(g);
        e = JD(f.jd(), 586);
        if (b == 1) {
            if (e.yf() != (Tgd(), Sgd) && e.yf() != Ogd) continue;
        } else {
            if (e.yf() != (Tgd(), Pgd) && e.yf() != Qgd) continue;
        }
        d = JD(JD(f.kd(), 47).b, 82);
        h = JD(JD(f.kd(), 47).a, 194);
        c = h.c;
        switch(e.yf().g){
            case 2:
                d.g.c = a.e.a;
                d.g.b = $wnd.Math.max(1, d.g.b + c);
                break;
            case 1:
                d.g.c = d.g.c + c;
                d.g.b = $wnd.Math.max(1, d.g.b - c);
                break;
            case 4:
                d.g.d = a.e.b;
                d.g.a = $wnd.Math.max(1, d.g.a + c);
                break;
            case 3:
                d.g.d = d.g.d + c;
                d.g.a = $wnd.Math.max(1, d.g.a - c);
        }
    }
}
function kKc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    b.Sg('Simple node placement', 1);
    l = JD(WMb(a, (Iqc(), Aqc)), 313);
    h = 0;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        d = JD(pmb(f), 25);
        g = d.c;
        g.b = 0;
        c = null;
        for(j = new rmb(d.a); j.a < j.c.c.length;){
            i = JD(pmb(j), 9);
            !!c && (g.b += czc(i, c, l.c));
            g.b += i.d.d + i.o.b + i.d.a;
            c = i;
        }
        h = $wnd.Math.max(h, g.b);
    }
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        g = d.c;
        k = (h - g.b) / 2;
        c = null;
        for(j = new rmb(d.a); j.a < j.c.c.length;){
            i = JD(pmb(j), 9);
            !!c && (k += czc(i, c, l.c));
            k += i.d.d;
            i.n.b = k;
            k += i.o.b + i.d.a;
            c = i;
        }
    }
    b.Tg();
}
function E6c(a) {
    Rad(a, new cad(nad(kad(mad(lad(new pad, eBe), 'ELK SPOrE Compaction'), 'ShrinkTree is a compaction algorithm that maintains the topology of a layout. The relocation of diagram elements is based on contracting a spanning tree.'), new H6c)));
    Pad(a, eBe, fBe, JBd(C6c));
    Pad(a, eBe, gBe, JBd(z6c));
    Pad(a, eBe, hBe, JBd(y6c));
    Pad(a, eBe, iBe, JBd(w6c));
    Pad(a, eBe, jBe, JBd(x6c));
    Pad(a, eBe, Rue, v6c);
    Pad(a, eBe, Mue, 8);
    Pad(a, eBe, kBe, JBd(B6c));
    Pad(a, eBe, lBe, JBd(r6c));
    Pad(a, eBe, mBe, JBd(s6c));
    Pad(a, eBe, Dye, (xdb(), false));
}
function Sjc(a, b) {
    var c, d, e, f;
    Mjc(b.b.j);
    EBb(FBb(new RBb(null, new Gvb(b.d, 16)), new bkc), new dkc);
    for(f = new rmb(b.d); f.a < f.c.c.length;){
        e = JD(pmb(f), 105);
        switch(e.e.g){
            case 0:
                c = JD(Mlb(e.j, 0), 112).d.j;
                pgc(e, JD(zub(JBb(JD(Qc(e.k, c), 15).Mc(), Kjc)), 112));
                qgc(e, JD(zub(IBb(JD(Qc(e.k, c), 15).Mc(), Kjc)), 112));
                break;
            case 1:
                d = Ehc(e);
                pgc(e, JD(zub(JBb(JD(Qc(e.k, d[0]), 15).Mc(), Kjc)), 112));
                qgc(e, JD(zub(IBb(JD(Qc(e.k, d[1]), 15).Mc(), Kjc)), 112));
                break;
            case 2:
                Ujc(a, e);
                break;
            case 3:
                Tjc(e);
                break;
            case 4:
                Rjc(a, e);
        }
        Pjc(e);
    }
    a.a = null;
}
function BLc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = a.a.o == (HKc(), GKc) ? Kse : Lse;
    h = CLc(a, new ALc(b, c));
    if (!h.a && h.c) {
        Atb(a.d, h);
        return d;
    } else if (h.a) {
        e = h.a.c;
        i = h.a.d;
        if (c) {
            j = a.a.c == (zKc(), yKc) ? i : e;
            f = a.a.c == yKc ? e : i;
            g = a.a.g[f.i.p];
            k = Beb(a.a.p[g.p]) + Beb(a.a.d[f.i.p]) + f.n.b + f.a.b - Beb(a.a.d[j.i.p]) - j.n.b - j.a.b;
        } else {
            j = a.a.c == (zKc(), xKc) ? i : e;
            f = a.a.c == xKc ? e : i;
            k = Beb(a.a.p[a.a.g[f.i.p].p]) + Beb(a.a.d[f.i.p]) + f.n.b + f.a.b - Beb(a.a.d[j.i.p]) - j.n.b - j.a.b;
        }
        a.a.n[a.a.g[e.i.p].p] = (xdb(), true);
        a.a.n[a.a.g[i.i.p].p] = true;
        return k;
    }
    return d;
}
function lbe(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    if (d.gc() == 0) return false;
    i = (Ife(), JD(b, 69).uk());
    g = i ? d : new wDd(d.gc());
    if (Lfe(a.e, b)) {
        if (b.Pi()) for(k = d.Jc(); k.Ob();){
            j = k.Pb();
            if (!ybe(a, b, j, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0)) {
                f = Jfe(b, j);
                g.Ec(f);
            }
        }
        else if (!i) for(k = d.Jc(); k.Ob();){
            j = k.Pb();
            f = Jfe(b, j);
            g.Ec(f);
        }
    } else {
        l = Kfe(a.e.zh(), b);
        e = JD(a.g, 122);
        for(h = 0; h < a.i; ++h){
            f = e[h];
            if (l.Zl(f.Ik())) throw scb(new Teb(hGe));
        }
        if (d.gc() > 1) throw scb(new Teb(hGe));
        if (!i) {
            f = Jfe(b, d.Jc().Pb());
            g.Ec(f);
        }
    }
    return uCd(a, Bbe(a, b, c), g);
}
function $be(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (Lfe(a.e, b)) {
        i = (Ife(), JD(b, 69).uk() ? new Jge(b, a) : new Zfe(b, a));
        wbe(i.c, i.b);
        Vfe(i, JD(c, 16));
    } else {
        k = Kfe(a.e.zh(), b);
        d = JD(a.g, 122);
        for(g = 0; g < a.i; ++g){
            e = d[g];
            f = e.Ik();
            if (k.Zl(f)) {
                if (f == (ehe(), che) || f == _ge) {
                    j = fce(a, b, c);
                    h = g;
                    j ? UGd(a, g) : ++g;
                    while(g < a.i){
                        e = d[g];
                        f = e.Ik();
                        f == che || f == _ge ? UGd(a, g) : ++g;
                    }
                    j || JD(DCd(a, h, Jfe(b, c)), 74);
                } else fce(a, b, c) ? UGd(a, g) : JD(DCd(a, g, (Ife(), JD(b, 69).uk() ? JD(c, 74) : Jfe(b, c))), 74);
                return;
            }
        }
        fce(a, b, c) || tCd(a, (Ife(), JD(b, 69).uk() ? JD(c, 74) : Jfe(b, c)));
    }
}
function BHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    for(l = 0; l < b.length; l++){
        for(h = a.Jc(); h.Ob();){
            f = JD(h.Pb(), 229);
            f.fg(l, b);
        }
        for(m = 0; m < b[l].length; m++){
            for(i = a.Jc(); i.Ob();){
                f = JD(i.Pb(), 229);
                f.gg(l, m, b);
            }
            p = b[l][m].j;
            for(n = 0; n < p.c.length; n++){
                for(j = a.Jc(); j.Ob();){
                    f = JD(j.Pb(), 229);
                    f.hg(l, m, n, b);
                }
                o = (sDb(n, p.c.length), JD(p.c[n], 11));
                c = 0;
                for(e = new xZb(o.b); omb(e.a) || omb(e.b);){
                    d = JD(omb(e.a) ? pmb(e.a) : pmb(e.b), 18);
                    for(k = a.Jc(); k.Ob();){
                        f = JD(k.Pb(), 229);
                        f.eg(l, m, n, c++, d, b);
                    }
                }
            }
        }
    }
    for(g = a.Jc(); g.Ob();){
        f = JD(g.Pb(), 229);
        f.dg();
    }
}
function qyd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    o = JD(Nib(a.d, b), 147);
    if (!o) throw scb(new eyd('Edge did not exist in input.'));
    dzd(a, b);
    l = Yxd(o);
    g = yqe((!b.a && (b.a = new X0d(w3, b, 6, 6)), b.a));
    i = !g;
    if (i) {
        p = new EB;
        d = new KAd(a, l, p, b);
        wqe((!b.a && (b.a = new X0d(w3, b, 6, 6)), b.a), d);
        kC(o, nDe, null);
        kC(o, nDe, p);
    }
    f = lsd(b, (Lgd(), tfd));
    if (f) {
        m = JD(ksd(b, tfd), 77);
        h = !m || xqe(m);
        j = !h;
        if (j) {
            n = new EB;
            e = new TAd(a, b, n);
            ofb(m, e);
            kC(o, 'junctionPoints', n);
        }
    }
    c = uyd(a, JD(Nib(a.e, b), 27));
    k = c == (ehd(), ahd);
    k && Wxd(o, 'container', Otd(b).k);
    return null;
}
function k1b(a, b) {
    var c, d, e, f, g, h, i;
    a.b = Beb(MD(WMb(b, (Bwc(), Xvc))));
    a.c = Beb(MD(WMb(b, $vc)));
    a.d = JD(WMb(b, Duc), 346);
    a.a = JD(WMb(b, Xtc), 280);
    i1b(b);
    h = JD(yBb(BBb(BBb(DBb(DBb(new RBb(null, new Gvb(b.b, 16)), new o1b), new q1b), new s1b), new u1b), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    for(e = h.Jc(); e.Ob();){
        c = JD(e.Pb(), 18);
        g = JD(WMb(c, (Iqc(), Dqc)), 15);
        g.Ic(new w1b(a));
        ZMb(c, Dqc, null);
    }
    for(d = h.Jc(); d.Ob();){
        c = JD(d.Pb(), 18);
        i = JD(WMb(c, (Iqc(), Eqc)), 18);
        f = JD(WMb(c, Bqc), 15);
        c1b(a, f, i);
        ZMb(c, Bqc, null);
    }
}
function MZd(a, b) {
    var c, d, e, f, g, h, i;
    if (a.a) {
        h = a.a.ve();
        i = null;
        if (h != null) b.a += '' + h;
        else {
            g = a.a.jk();
            if (g != null) {
                f = hgb(g, wgb(91));
                if (f != -1) {
                    i = (ADb(f, g.length + 1), g.substr(f));
                    b.a += '' + qgb(g == null ? Rqe : (tDb(g), g), 0, f);
                } else b.a += '' + g;
            }
        }
        if (!!a.d && a.d.i != 0) {
            e = true;
            b.a += '<';
            for(d = new CHd(a.d); d.e != d.i.gc();){
                c = JD(AHd(d), 87);
                e ? e = false : (b.a += Lqe, b);
                MZd(c, b);
            }
            b.a += '>';
        }
        i != null && (b.a += '' + i, b);
    } else if (a.e) {
        h = a.e.zb;
        h != null && (b.a += '' + h, b);
    } else {
        b.a += '?';
        if (a.b) {
            b.a += ' super ';
            MZd(a.b, b);
        } else if (a.f) {
            b.a += ' extends ';
            MZd(a.f, b);
        }
    }
}
function n6d(a) {
    a.b = null;
    a.a = null;
    a.o = null;
    a.q = null;
    a.v = null;
    a.w = null;
    a.B = null;
    a.p = null;
    a.Q = null;
    a.R = null;
    a.S = null;
    a.T = null;
    a.U = null;
    a.V = null;
    a.W = null;
    a.bb = null;
    a.eb = null;
    a.ab = null;
    a.H = null;
    a.db = null;
    a.c = null;
    a.d = null;
    a.f = null;
    a.n = null;
    a.r = null;
    a.s = null;
    a.u = null;
    a.G = null;
    a.J = null;
    a.e = null;
    a.j = null;
    a.i = null;
    a.g = null;
    a.k = null;
    a.t = null;
    a.F = null;
    a.I = null;
    a.L = null;
    a.M = null;
    a.O = null;
    a.P = null;
    a.$ = null;
    a.N = null;
    a.Z = null;
    a.cb = null;
    a.K = null;
    a.D = null;
    a.A = null;
    a.C = null;
    a._ = null;
    a.fb = null;
    a.X = null;
    a.Y = null;
    a.gb = false;
    a.hb = false;
}
function phb(a) {
    var b, c, d, e;
    d = rib((!a.c && (a.c = fib(zcb(a.f))), a.c), 0);
    if (a.e == 0 || a.a == 0 && a.f != -1 && a.e < 0) return d;
    b = ohb(a) < 0 ? 1 : 0;
    c = a.e;
    e = (d.length, $wnd.Math.abs(YD(a.e)), new Vgb);
    b == 1 && (e.a += '-', e);
    if (a.e > 0) {
        c -= d.length - b;
        if (c >= 0) {
            e.a += '0.';
            for(; c > dhb.length; c -= dhb.length)Rgb(e, dhb);
            Sgb(e, dhb, YD(c));
            Qgb(e, (ADb(b, d.length + 1), d.substr(b)));
        } else {
            c = b - c;
            Qgb(e, qgb(d, b, YD(c)));
            e.a += '.';
            Qgb(e, pgb(d, YD(c)));
        }
    } else {
        Qgb(e, (ADb(b, d.length + 1), d.substr(b)));
        for(; c < -dhb.length; c += dhb.length)Rgb(e, dhb);
        Sgb(e, dhb, YD(-c));
    }
    return e.a;
}
function EIc(a) {
    var b, c, d, e, f, g, h, i, j;
    if (a.k != (DYb(), AYb)) return false;
    if (a.j.c.length <= 1) return false;
    f = JD(WMb(a, (Bwc(), Evc)), 100);
    if (f == (ajd(), Xid)) return false;
    e = (zxc(), (!a.q ? (pnb(), pnb(), nnb) : a.q)._b(lvc) ? d = JD(WMb(a, lvc), 203) : d = JD(WMb(gYb(a), mvc), 203), d);
    if (e == xxc) return false;
    if (!(e == wxc || e == vxc)) {
        g = Beb(MD(kzc(a, iwc)));
        b = JD(WMb(a, hwc), 139);
        !b && (b = new _Xb(g, g, g, g));
        j = lYb(a, (Rjd(), Qjd));
        i = b.d + b.a + (j.gc() - 1) * g;
        if (i > a.o.b) return false;
        c = lYb(a, wjd);
        h = b.d + b.a + (c.gc() - 1) * g;
        if (h > a.o.b) return false;
    }
    return true;
}
function YLc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    b.Sg('Orthogonal edge routing', 1);
    j = Beb(MD(WMb(a, (Bwc(), fwc))));
    c = Beb(MD(WMb(a, Xvc)));
    d = Beb(MD(WMb(a, $vc)));
    m = new WNc(0, c);
    q = 0;
    g = new Ajb(a.b, 0);
    h = null;
    k = null;
    i = null;
    l = null;
    do {
        k = g.b < g.d.gc() ? (rDb(g.b < g.d.gc()), JD(g.d.Xb(g.c = g.b++), 25)) : null;
        l = !k ? null : k.a;
        if (h) {
            zXb(h, q);
            q += h.c.a;
        }
        p = !h ? q : q + d;
        o = VNc(m, a, i, l, p);
        e = !h || Yq(i, (gMc(), eMc));
        f = !k || Yq(l, (gMc(), eMc));
        if (o > 0) {
            n = (o - 1) * c;
            !!h && (n += d);
            !!k && (n += d);
            n < j && !e && !f && (n = j);
            q += n;
        } else !e && !f && (q += j);
        h = k;
        i = l;
    }while (k);
    a.f.a = q;
    b.Tg();
}
function Oae(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = null;
    !!a.d && (k = JD(Oib(a.d, b), 141));
    if (!k) {
        f = a.a.ri();
        l = f.i;
        if (!a.d || Uib(a.d) != l) {
            i = new Irb;
            !!a.d && Ld(i, a.d);
            j = i.f.c + i.i.c;
            for(h = j; h < l; ++h){
                d = JD(nDd(f, h), 141);
                e = hae(a.e, d).ve();
                c = JD(e == null ? gsb(i.f, null, d) : Asb(i.i, e, d), 141);
                !!c && c != d && (e == null ? gsb(i.f, null, c) : Asb(i.i, e, c));
            }
            if (i.f.c + i.i.c != l) for(g = 0; g < j; ++g){
                d = JD(nDd(f, g), 141);
                e = hae(a.e, d).ve();
                c = JD(e == null ? gsb(i.f, null, d) : Asb(i.i, e, d), 141);
                !!c && c != d && (e == null ? gsb(i.f, null, c) : Asb(i.i, e, c));
            }
            a.d = i;
        }
        k = JD(Oib(a.d, b), 141);
    }
    return k;
}
function GVb(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n;
    l = ydb(LD(WMb(b, (Bwc(), evc))));
    m = null;
    f == (Eyc(), Byc) && d.c.i == c ? m = d.c : f == Cyc && d.d.i == c && (m = d.d);
    j = g;
    if (!j || !l || !!m) {
        k = (Rjd(), Pjd);
        m ? k = m.j : cjd(JD(WMb(c, Evc), 100)) && (k = f == Byc ? Qjd : wjd);
        i = DVb(a, b, c, f, k, d);
        h = CVb((gYb(c), d));
        if (f == Byc) {
            gWb(h, JD(Mlb(i.j, 0), 11));
            hWb(h, e);
        } else {
            gWb(h, e);
            hWb(h, JD(Mlb(i.j, 0), 11));
        }
        j = new QVb(d, h, i, JD(WMb(i, (Iqc(), kqc)), 11), f, !m);
    } else {
        Ilb(j.e, d);
        n = $wnd.Math.max(Beb(MD(WMb(j.d, Fuc))), Beb(MD(WMb(d, Fuc))));
        ZMb(j.d, Fuc, n);
    }
    Rc(a.a, d, new TVb(j.d, b, f));
    return j;
}
function BNd() {
    BNd = Zcb;
    var a;
    ANd = new fOd;
    uNd = SC(hJ, hre, 2, 0, 6, 1);
    nNd = Icb(SNd(33, 58), SNd(1, 26));
    oNd = Icb(SNd(97, 122), SNd(65, 90));
    pNd = SNd(48, 57);
    lNd = Icb(nNd, 0);
    mNd = Icb(oNd, pNd);
    qNd = Icb(Icb(0, SNd(1, 6)), SNd(33, 38));
    rNd = Icb(Icb(pNd, SNd(65, 70)), SNd(97, 102));
    xNd = Icb(lNd, QNd("-_.!~*'()"));
    yNd = Icb(mNd, TNd("-_.!~*'()"));
    QNd(OEe);
    TNd(OEe);
    Icb(xNd, QNd(';:@&=+$,'));
    Icb(yNd, TNd(';:@&=+$,'));
    sNd = QNd(':/?#');
    tNd = TNd(':/?#');
    vNd = QNd('/?#');
    wNd = TNd('/?#');
    a = new Qrb;
    a.a.yc('jar', a);
    a.a.yc('zip', a);
    a.a.yc('archive', a);
    zNd = (pnb(), new Apb(a));
}
function DVb(a, b, c, d, e, f) {
    var g, h, i, j, k, l;
    g = null;
    j = d == (Eyc(), Byc) ? f.c : f.d;
    i = sXb(b);
    if (j.i == c) {
        g = JD(Nib(a.b, j), 9);
        if (!g) {
            g = pXb(j, JD(WMb(c, (Bwc(), Evc)), 100), e, zVb(j), null, j.n, j.o, i, b);
            ZMb(g, (Iqc(), kqc), j);
            Qib(a.b, j, g);
        }
    } else {
        g = pXb((k = new $Mb, l = Beb(MD(WMb(b, (Bwc(), Wvc)))) / 2, YMb(k, Dvc, l), k), JD(WMb(c, Evc), 100), e, d == Byc ? -1 : 1, null, new Cdd, new Edd(0, 0), i, b);
        h = EVb(g, c, d);
        ZMb(g, (Iqc(), kqc), h);
        Qib(a.b, h, g);
    }
    JD(WMb(b, (Iqc(), Wpc)), 22).Ec(($oc(), Toc));
    cjd(JD(WMb(b, (Bwc(), Evc)), 100)) ? ZMb(b, Evc, (ajd(), Zid)) : ZMb(b, Evc, (ajd(), $id));
    return g;
}
function j8b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    h = 0;
    o = 0;
    i = wmb(a.g, a.g.length);
    f = a.e;
    g = a.j;
    d = a.b;
    e = a.c;
    do {
        n = 0;
        for(k = new rmb(a.q); k.a < k.c.c.length;){
            j = JD(pmb(k), 9);
            m = h8b(a, j);
            c = true;
            (a.r == (dyc(), Yxc) || a.r == _xc) && (c = ydb(LD(m.b)));
            if (JD(m.a, 17).a < 0 && c) {
                ++n;
                i = wmb(a.g, a.g.length);
                a.e = a.e + JD(m.a, 17).a;
                o += f - a.e;
                f = a.e + JD(m.a, 17).a;
                g = a.j;
                d = Zu(a.b);
                e = Zu(a.c);
            } else {
                a.g = wmb(i, i.length);
                a.e = f;
                a.b = (Qb(d), d ? new Wlb(d) : $u(new rmb(d)));
                a.c = (Qb(e), e ? new Wlb(e) : $u(new rmb(e)));
                a.j = g;
            }
        }
        ++h;
        l = n != 0 && ydb(LD(b.Kb(new xod(jfb(o), jfb(h)))));
    }while (l);
}
function t2c(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    g = a.f;
    m = b.f;
    h = g == (I4c(), D4c) || g == F4c;
    n = m == D4c || m == F4c;
    i = g == E4c || g == G4c;
    o = m == E4c || m == G4c;
    j = g == E4c || g == D4c;
    p = m == E4c || m == D4c;
    if (h && n) return a.f == F4c ? a : b;
    else if (i && o) return a.f == G4c ? a : b;
    else if (j && p) {
        if (g == E4c) {
            l = a;
            k = b;
        } else {
            l = b;
            k = a;
        }
        f = (q = c.j + c.f, r = l.e + d.f, s = $wnd.Math.max(q, r), t = s - $wnd.Math.min(c.j, l.e), u = l.d + d.g - c.i, u * t);
        e = (v = c.i + c.g, w = k.d + d.g, A = $wnd.Math.max(v, w), B = A - $wnd.Math.min(c.i, k.d), C = k.e + d.f - c.j, B * C);
        return f <= e ? a.f == E4c ? a : b : a.f == D4c ? a : b;
    }
    return a;
}
function wWc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    ZMb(b, (tUc(), jUc), 0);
    i = JD(WMb(b, fUc), 39);
    if (b.d.b == 0) {
        if (i) {
            k = Beb(MD(WMb(i, mUc))) + a.b + xWc(a, i, b);
            ZMb(b, mUc, k);
        } else ZMb(b, mUc, 0);
    } else {
        for(d = (f = Gtb(new gRc(b).a.d, 0), new jRc(f)); Ttb(d.a);){
            c = JD(Utb(d.a), 65).c;
            wWc(a, c);
        }
        h = JD(Dr((g = Gtb(new gRc(b).a.d, 0), new jRc(g))), 39);
        l = JD(Cr((e = Gtb(new gRc(b).a.d, 0), new jRc(e))), 39);
        j = (Beb(MD(WMb(l, mUc))) + Beb(MD(WMb(h, mUc)))) / 2;
        if (i) {
            k = Beb(MD(WMb(i, mUc))) + a.b + xWc(a, i, b);
            ZMb(b, mUc, k);
            ZMb(b, jUc, Beb(MD(WMb(b, mUc))) - j);
            vWc(a, b);
        } else ZMb(b, mUc, j);
    }
}
function K2b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    j = new Ulb;
    if (!XMb(a, (Iqc(), Rpc))) return j;
    for(d = JD(WMb(a, Rpc), 15).Jc(); d.Ob();){
        b = JD(d.Pb(), 9);
        J2b(b, a);
        YCb(j.c, b);
    }
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        for(h = new rmb(e.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            if (g.k != (DYb(), wYb)) continue;
            i = JD(WMb(g, Spc), 9);
            !!i && (k = new bZb, _Yb(k, g), l = JD(WMb(g, Tpc), 64), aZb(k, l), m = JD(Mlb(i.j, 0), 11), n = new kWb, gWb(n, k), hWb(n, m), undefined);
        }
    }
    for(c = new rmb(j); c.a < c.c.c.length;){
        b = JD(pmb(c), 9);
        qYb(b, JD(Mlb(a.b, a.b.c.length - 1), 25));
    }
    return j;
}
function yGb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    k = a.e.a.c.length;
    for(g = new rmb(a.e.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 123);
        f.j = false;
    }
    a.i = SC(cE, ise, 30, k, 15, 1);
    a.g = SC(cE, ise, 30, k, 15, 1);
    a.n = new Ulb;
    e = 0;
    l = new Ulb;
    for(i = new rmb(a.e.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 123);
        h.d = e++;
        h.b.a.c.length == 0 && Ilb(a.n, h);
        Klb(l, h.g);
    }
    b = 0;
    for(d = new rmb(l); d.a < d.c.c.length;){
        c = JD(pmb(d), 216);
        c.c = b++;
        c.f = false;
    }
    j = l.c.length;
    if (a.b == null || a.b.length < j) {
        a.b = SC(aE, Rse, 30, j, 15, 1);
        a.c = SC(pcb, Vte, 30, j, 16, 1);
    } else Emb(a.c);
    a.d = l;
    a.p = new xtb(Ov(a.d.c.length));
    a.j = 1;
}
function EPb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (b.e.c.length <= 1) return;
    a.f = b;
    a.d = JD(WMb(a.f, (nPb(), cPb)), 382);
    a.g = JD(WMb(a.f, gPb), 17).a;
    a.e = Beb(MD(WMb(a.f, dPb)));
    a.c = Beb(MD(WMb(a.f, bPb)));
    wt(a.b);
    for(e = new rmb(a.f.c); e.a < e.c.c.length;){
        d = JD(pmb(e), 288);
        vt(a.b, d.c, d, null);
        vt(a.b, d.d, d, null);
    }
    h = a.f.e.c.length;
    a.a = QC(aE, [
        hre,
        Rse
    ], [
        108,
        30
    ], 15, [
        h,
        h
    ], 2);
    for(j = new rmb(a.f.e); j.a < j.c.c.length;){
        i = JD(pmb(j), 151);
        APb(a, i, a.a[i.a]);
    }
    a.i = QC(aE, [
        hre,
        Rse
    ], [
        108,
        30
    ], 15, [
        h,
        h
    ], 2);
    for(f = 0; f < h; ++f)for(g = 0; g < h; ++g){
        c = a.a[f][g];
        k = 1 / (c * c);
        a.i[f][g] = k;
    }
}
function YPb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    h = b.$g();
    h || b.Sg(yue, 1);
    c = JD(WMb(a, (Iqc(), uqc)), 15);
    g = 1 / c.gc();
    if (b.Zg()) {
        b._g('ELK Layered uses the following ' + c.gc() + ' modules:');
        n = 0;
        for(m = c.Jc(); m.Ob();){
            k = JD(m.Pb(), 44);
            d = (n < 10 ? '0' : '') + n++;
            b._g('   Slot ' + d + ': ' + eeb(rb(k)));
        }
    }
    o = 0;
    for(l = c.Jc(); l.Ob();){
        k = JD(l.Pb(), 44);
        if (b.Yg()) return;
        k.If(a, b.bh(g));
        ++o;
    }
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        Klb(a.a, e.a);
        e.a.c.length = 0;
    }
    for(j = new rmb(a.a); j.a < j.c.c.length;){
        i = JD(pmb(j), 9);
        qYb(i, null);
    }
    a.b.c.length = 0;
    h || b.Tg();
}
function h3c(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    l = new Ulb;
    k = new X4c(0, c);
    f = 0;
    S4c(k, new j4c(0, 0, k, c));
    e = 0;
    for(j = new CHd(a); j.e != j.i.gc();){
        i = JD(AHd(j), 27);
        d = JD(Mlb(k.a, k.a.c.length - 1), 172);
        h = e + i.g + (JD(Mlb(k.a, 0), 172).b.c.length == 0 ? 0 : c);
        if (h > b || ydb(LD(ksd(i, (k2c(), R1c))))) {
            e = 0;
            f += k.b + c;
            YCb(l.c, k);
            k = new X4c(f, c);
            d = new j4c(0, k.f, k, c);
            S4c(k, d);
            e = 0;
        }
        if (d.b.c.length == 0 || !ydb(LD(ksd(Zwd(i), (k2c(), $1c)))) && (i.f >= d.o && i.f <= d.f || d.a * 0.5 <= i.f && d.a * 1.5 >= i.f)) $3c(d, i);
        else {
            g = new j4c(d.s + d.r + c, k.f, k, c);
            S4c(k, g);
            $3c(g, i);
        }
        e = i.i + i.g;
    }
    YCb(l.c, k);
    return l;
}
function Noe(a) {
    var b, c, d, e;
    if (a.b == null || a.b.length <= 2) return;
    if (a.a) return;
    b = 0;
    e = 0;
    while(e < a.b.length){
        if (b != e) {
            a.b[b] = a.b[e++];
            a.b[b + 1] = a.b[e++];
        } else e += 2;
        c = a.b[b + 1];
        while(e < a.b.length){
            if (c + 1 < a.b[e]) break;
            if (c + 1 == a.b[e]) {
                a.b[b + 1] = a.b[e + 1];
                c = a.b[b + 1];
                e += 2;
            } else if (c >= a.b[e + 1]) e += 2;
            else if (c < a.b[e + 1]) {
                a.b[b + 1] = a.b[e + 1];
                c = a.b[b + 1];
                e += 2;
            } else throw scb(new qz('Token#compactRanges(): Internel Error: [' + a.b[b] + ',' + a.b[b + 1] + '] [' + a.b[e] + ',' + a.b[e + 1] + ']'));
        }
        b += 2;
    }
    if (b != a.b.length) {
        d = SC(cE, ise, 30, b, 15, 1);
        $gb(a.b, 0, d, 0, b);
        a.b = d;
    }
    a.a = true;
}
function HVb(a, b) {
    var c, d, e, f, g, h, i;
    for(g = Ec(a.a).Jc(); g.Ob();){
        f = JD(g.Pb(), 18);
        if (f.b.c.length > 0) {
            d = new Wlb(JD(Qc(a.a, f), 22));
            pnb();
            Slb(d, new WVb(b));
            e = new Ajb(f.b, 0);
            while(e.b < e.d.gc()){
                c = (rDb(e.b < e.d.gc()), JD(e.d.Xb(e.c = e.b++), 72));
                h = -1;
                switch(JD(WMb(c, (Bwc(), wuc)), 276).g){
                    case 1:
                        h = d.c.length - 1;
                        break;
                    case 0:
                        h = FVb(d);
                        break;
                    case 2:
                        h = 0;
                }
                if (h != -1) {
                    i = (sDb(h, d.c.length), JD(d.c[h], 248));
                    Ilb(i.b.b, c);
                    JD(WMb(gYb(i.b.c.i), (Iqc(), Wpc)), 22).Ec(($oc(), Soc));
                    JD(WMb(gYb(i.b.c.i), Wpc), 22).Ec(Qoc);
                    tjb(e);
                    ZMb(c, nqc, f);
                }
            }
        }
        gWb(f, null);
        hWb(f, null);
    }
}
function PFc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    k = new Ulb;
    m = new Qrb;
    g = b.b;
    for(e = 0; e < g.c.length; e++){
        j = (sDb(e, g.c.length), JD(g.c[e], 25)).a;
        k.c.length = 0;
        for(f = 0; f < j.c.length; f++){
            h = a.a[e][f];
            h.p = f;
            h.k == (DYb(), BYb) && YCb(k.c, h);
            Rlb(JD(Mlb(b.b, e), 25).a, f, h);
            h.j.c.length = 0;
            Klb(h.j, JD(JD(Mlb(a.b, e), 15).Xb(f), 16));
            bjd(JD(WMb(h, (Bwc(), Evc)), 100)) || ZMb(h, Evc, (ajd(), Wid));
        }
        for(d = new rmb(k); d.a < d.c.c.length;){
            c = JD(pmb(d), 9);
            l = NFc(c);
            m.a.yc(l, m);
            m.a.yc(c, m);
        }
    }
    for(i = m.a.ec().Jc(); i.Ob();){
        h = JD(i.Pb(), 9);
        pnb();
        Slb(h.j, (G9b(), A9b));
        h.i = true;
        dYb(h);
    }
}
function W7b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    b.Sg('Edge splitting', 1);
    if (a.b.c.length <= 2) {
        b.Tg();
        return;
    }
    f = new Ajb(a.b, 0);
    g = (rDb(f.b < f.d.gc()), JD(f.d.Xb(f.c = f.b++), 25));
    while(f.b < f.d.gc()){
        e = g;
        g = (rDb(f.b < f.d.gc()), JD(f.d.Xb(f.c = f.b++), 25));
        for(i = new rmb(e.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            for(k = new rmb(h.j); k.a < k.c.c.length;){
                j = JD(pmb(k), 11);
                for(d = new rmb(j.g); d.a < d.c.c.length;){
                    c = JD(pmb(d), 18);
                    m = c.d;
                    l = m.i.c;
                    l != e && l != g && _7b(c, (n = new tYb(a), rYb(n, (DYb(), yYb)), ZMb(n, (Iqc(), kqc), c), ZMb(n, (Bwc(), Evc), (ajd(), Xid)), qYb(n, g), n));
                }
            }
        }
    }
    b.Tg();
}
function g$b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    b = oxd(a);
    f = ydb(LD(ksd(b, (Bwc(), Nuc))));
    k = 0;
    e = 0;
    for(j = new CHd((!a.e && (a.e = new ree(x3, a, 7, 4)), a.e)); j.e != j.i.gc();){
        i = JD(AHd(j), 85);
        h = Std(i);
        g = h && f && ydb(LD(ksd(i, Ouc)));
        m = _Bd(JD(nDd((!i.c && (i.c = new ree(v3, i, 5, 8)), i.c), 0), 84));
        h && g ? ++e : h && !g ? ++k : Zwd(m) == b || m == b ? ++e : ++k;
    }
    for(d = new CHd((!a.d && (a.d = new ree(x3, a, 8, 5)), a.d)); d.e != d.i.gc();){
        c = JD(AHd(d), 85);
        h = Std(c);
        g = h && f && ydb(LD(ksd(c, Ouc)));
        l = _Bd(JD(nDd((!c.b && (c.b = new ree(v3, c, 4, 7)), c.b), 0), 84));
        h && g ? ++k : h && !g ? ++e : Zwd(l) == b || l == b ? ++k : ++e;
    }
    return k - e;
}
function Pzc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    c.Sg('Depth-first cycle removal', 1);
    l = b.a;
    k = l.c.length;
    a.c = new Ulb;
    a.d = SC(pcb, Vte, 30, k, 16, 1);
    a.a = SC(pcb, Vte, 30, k, 16, 1);
    a.b = new Ulb;
    g = 0;
    for(j = new rmb(l); j.a < j.c.c.length;){
        i = JD(pmb(j), 9);
        i.p = g;
        cr(hYb(i)) && Ilb(a.c, i);
        ++g;
    }
    for(n = new rmb(a.c); n.a < n.c.c.length;){
        m = JD(pmb(n), 9);
        Ozc(a, m);
    }
    for(f = 0; f < k; f++)if (!a.d[f]) {
        h = (sDb(f, l.c.length), JD(l.c[f], 9));
        Ozc(a, h);
    }
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 18);
        fWb(d, true);
        ZMb(b, (Iqc(), Mpc), (xdb(), true));
    }
    a.c = null;
    a.d = null;
    a.a = null;
    a.b = null;
    c.Tg();
}
function qhb(a) {
    var b, c, d, e, f;
    if (a.g != null) return a.g;
    if (a.a < 32) {
        a.g = qib(zcb(a.f), YD(a.e));
        return a.g;
    }
    e = rib((!a.c && (a.c = fib(zcb(a.f))), a.c), 0);
    if (a.e == 0) return e;
    b = (!a.c && (a.c = fib(zcb(a.f))), a.c).e < 0 ? 2 : 1;
    c = e.length;
    d = -a.e + c - b;
    f = new Ugb;
    f.a += '' + e;
    if (a.e > 0 && d >= -6) {
        if (d >= 0) Tgb(f, c - YD(a.e), String.fromCharCode(46));
        else {
            gdb(f, b - 1, b - 1, '0.');
            Tgb(f, b + 1, zgb(dhb, 0, -YD(d) - 1));
        }
    } else {
        if (c - b >= 1) {
            Tgb(f, b, String.fromCharCode(46));
            ++c;
        }
        Tgb(f, c, String.fromCharCode(69));
        d > 0 && Tgb(f, ++c, String.fromCharCode(43));
        Tgb(f, ++c, '' + Qcb(zcb(d)));
    }
    a.g = f.a;
    return a.g;
}
function NHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
    d = Beb(MD(WMb(b, (Bwc(), kvc))));
    v = JD(WMb(b, jwc), 17).a;
    m = 4;
    e = 3;
    w = 20 / v;
    n = false;
    i = 0;
    g = Hqe;
    do {
        f = i != 1;
        l = i != 0;
        A = 0;
        for(q = a.a, s = 0, u = q.length; s < u; ++s){
            o = q[s];
            o.f = null;
            OHc(a, o, f, l, d);
            A += $wnd.Math.abs(o.a);
        }
        do h = SHc(a, b);
        while (h);
        for(p = a.a, r = 0, t = p.length; r < t; ++r){
            o = p[r];
            c = $Hc(o).a;
            if (c != 0) for(k = new rmb(o.e); k.a < k.c.c.length;){
                j = JD(pmb(k), 9);
                j.n.b += c;
            }
        }
        if (i == 0 || i == 1) {
            --m;
            if (m <= 0 && (A < g || -m > v)) {
                i = 2;
                g = Hqe;
            } else if (i == 0) {
                i = 1;
                g = A;
            } else {
                i = 0;
                g = A;
            }
        } else {
            n = A >= g || g - A < w;
            g = A;
            n && --e;
        }
    }while (!(n && e <= 0));
}
function KDb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    o = new Irb;
    for(f = a.a.ec().Jc(); f.Ob();){
        d = JD(f.Pb(), 176);
        Qib(o, d, c.$e(d));
    }
    g = (Qb(a), a ? new Wlb(a) : $u(a.a.ec().Jc()));
    Slb(g, new MDb(o));
    h = Tx(g);
    i = new ZDb(b);
    n = new Irb;
    gsb(n.f, b, i);
    while(h.a.gc() != 0){
        j = null;
        k = null;
        l = null;
        for(e = h.a.ec().Jc(); e.Ob();){
            d = JD(e.Pb(), 176);
            if (Beb(MD(Wd(fsb(o.f, d)))) <= Kse) {
                if (Lib(n, d.a) && !Lib(n, d.b)) {
                    k = d.b;
                    l = d.a;
                    j = d;
                    break;
                }
                if (Lib(n, d.b)) {
                    if (!Lib(n, d.a)) {
                        k = d.a;
                        l = d.b;
                        j = d;
                        break;
                    }
                }
            }
        }
        if (!j) break;
        m = new ZDb(k);
        Ilb(JD(Wd(fsb(n.f, l)), 224).a, m);
        gsb(n.f, k, m);
        h.a.Ac(j);
    }
    return i;
}
function Xcd(a, b) {
    Icd();
    var c, d, e, f, g, h;
    f = b.c - (a.c + a.b);
    e = a.c - (b.c + b.b);
    g = a.d - (b.d + b.a);
    c = b.d - (a.d + a.a);
    d = $wnd.Math.max(e, f);
    h = $wnd.Math.max(g, c);
    Ry();
    Vy(pze);
    if (($wnd.Math.abs(d) <= pze || d == 0 || isNaN(d) && isNaN(0) ? 0 : d < 0 ? -1 : d > 0 ? 1 : Wy(isNaN(d), isNaN(0))) >= 0 ^ (Vy(pze), ($wnd.Math.abs(h) <= pze || h == 0 || isNaN(h) && isNaN(0) ? 0 : h < 0 ? -1 : h > 0 ? 1 : Wy(isNaN(h), isNaN(0))) >= 0)) return $wnd.Math.max(h, d);
    Vy(pze);
    if (($wnd.Math.abs(d) <= pze || d == 0 || isNaN(d) && isNaN(0) ? 0 : d < 0 ? -1 : d > 0 ? 1 : Wy(isNaN(d), isNaN(0))) > 0) return $wnd.Math.sqrt(h * h + d * d);
    return -$wnd.Math.sqrt(h * h + d * d);
}
function Cpe(a, b) {
    var c, d, e, f, g, h;
    if (!b) return;
    !a.a && (a.a = new Wwb);
    if (a.e == 2) {
        Twb(a.a, b);
        return;
    }
    if (b.e == 1) {
        for(e = 0; e < b.Mm(); e++)Cpe(a, b.Im(e));
        return;
    }
    h = a.a.a.c.length;
    if (h == 0) {
        Twb(a.a, b);
        return;
    }
    g = JD(Uwb(a.a, h - 1), 121);
    if (!((g.e == 0 || g.e == 10) && (b.e == 0 || b.e == 10))) {
        Twb(a.a, b);
        return;
    }
    f = b.e == 0 ? 2 : b.Jm().length;
    if (g.e == 0) {
        c = new Igb;
        d = g.Hm();
        d >= Pse ? Egb(c, Lne(d)) : Agb(c, d & Wre);
        g = (++noe, new zpe(10, null, 0));
        Vwb(a.a, g, h - 1);
    } else {
        c = (g.Jm().length, new Igb);
        Egb(c, g.Jm());
    }
    if (b.e == 0) {
        d = b.Hm();
        d >= Pse ? Egb(c, Lne(d)) : Agb(c, d & Wre);
    } else Egb(c, b.Jm());
    JD(g, 515).b = c.a;
}
function Amc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (c.dc()) return;
    h = 0;
    m = 0;
    d = c.Jc();
    o = JD(d.Pb(), 17).a;
    while(h < b.f){
        if (h == o) {
            m = 0;
            d.Ob() ? o = JD(d.Pb(), 17).a : o = b.f + 1;
        }
        if (h != m) {
            q = JD(Mlb(a.b, h), 25);
            n = JD(Mlb(a.b, m), 25);
            p = Zu(q.a);
            for(l = new rmb(p); l.a < l.c.c.length;){
                k = JD(pmb(l), 9);
                pYb(k, n.a.c.length, n);
                if (m == 0) {
                    g = Zu(hYb(k));
                    for(f = new rmb(g); f.a < f.c.c.length;){
                        e = JD(pmb(f), 18);
                        fWb(e, true);
                        ZMb(a, (Iqc(), Mpc), (xdb(), true));
                        $lc(a, e, 1);
                    }
                }
            }
        }
        ++m;
        ++h;
    }
    i = new Ajb(a.b, 0);
    while(i.b < i.d.gc()){
        j = (rDb(i.b < i.d.gc()), JD(i.d.Xb(i.c = i.b++), 25));
        j.a.c.length == 0 && tjb(i);
    }
}
function kdc(a, b, c) {
    var d, e, f;
    e = JD(WMb(b, (Bwc(), Xtc)), 280);
    if (e == (Koc(), Ioc)) return;
    c.Sg('Horizontal Compaction', 1);
    a.a = b;
    f = new Sdc;
    d = new UEb((f.d = b, f.c = JD(WMb(f.d, yuc), 220), Idc(f), Qdc(f), Pdc(f), f.a));
    SEb(d, a.b);
    switch(JD(WMb(b, Wtc), 419).g){
        case 1:
            QEb(d, new ccc(a.a));
            break;
        default:
            QEb(d, (EEb(), CEb));
    }
    switch(e.g){
        case 1:
            JEb(d);
            break;
        case 2:
            JEb(IEb(d, (Tgd(), Qgd)));
            break;
        case 3:
            JEb(REb(IEb(JEb(d), (Tgd(), Qgd)), new udc));
            break;
        case 4:
            JEb(REb(IEb(JEb(d), (Tgd(), Qgd)), new wdc(f)));
            break;
        case 5:
            JEb(PEb(d, idc));
    }
    IEb(d, (Tgd(), Pgd));
    d.e = true;
    Fdc(f);
    c.Tg();
}
function Ajc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    g = b.b;
    k = g.o;
    i = g.d;
    d = Beb(MD(uXb(g, (Bwc(), Wvc))));
    e = Beb(MD(uXb(g, Yvc)));
    j = Beb(MD(uXb(g, gwc)));
    h = new bYb;
    NXb(h, i.d, i.c, i.a, i.b);
    m = wjc(b, d, e, j);
    for(r = new rmb(b.d); r.a < r.c.c.length;){
        q = JD(pmb(r), 105);
        for(o = q.f.a.ec().Jc(); o.Ob();){
            n = JD(o.Pb(), 336);
            f = n.a;
            l = ujc(n);
            c = (s = new Rdd, sjc(n, n.c, m, s), rjc(n, l, m, s), sjc(n, n.d, m, s), s);
            c = a.lg(n, l, c);
            Ltb(f.a);
            xe(f.a, c);
            EBb(new RBb(null, new Gvb(c, 16)), new Ejc(k, h));
        }
        p = q.i;
        if (p) {
            zjc(q, p, m, e);
            t = new Fdd(p.g);
            Bjc(k, h, t);
            mdd(t, p.j);
            Bjc(k, h, t);
        }
    }
    NXb(i, h.d, h.c, h.a, h.b);
}
function qKb(a) {
    var b, c, d, e;
    e = a.o;
    aKb();
    if (a.A.dc() || pb(a.A, _Jb)) b = e.b;
    else {
        a.D ? b = $wnd.Math.max(e.b, hIb(a.f)) : b = hIb(a.f);
        if (a.A.Gc((ykd(), vkd)) && !a.B.Gc((Nkd(), Jkd))) {
            b = $wnd.Math.max(b, hIb(JD(Kqb(a.p, (Rjd(), wjd)), 251)));
            b = $wnd.Math.max(b, hIb(JD(Kqb(a.p, Qjd), 251)));
        }
        c = cKb(a);
        !!c && (b = $wnd.Math.max(b, c.b));
        if (a.A.Gc(wkd)) {
            if (a.q == (ajd(), Yid) || a.q == Xid) {
                b = $wnd.Math.max(b, bHb(JD(Kqb(a.b, (Rjd(), wjd)), 126)));
                b = $wnd.Math.max(b, bHb(JD(Kqb(a.b, Qjd), 126)));
            }
        }
    }
    ydb(LD(a.e.Rf().mf((Lgd(), Dfd)))) ? e.b = $wnd.Math.max(e.b, b) : e.b = b;
    d = a.f.i;
    d.d = 0;
    d.a = b;
    kIb(a.f);
}
function u2c(a, b, c, d, e, f, g, h) {
    var i, j, k, l;
    i = _u(WC(OC(o0, 1), Nqe, 237, 0, [
        b,
        c,
        d,
        e
    ]));
    l = null;
    switch(a.b.g){
        case 1:
            l = _u(WC(OC(Z_, 1), Nqe, 520, 0, [
                new G2c,
                new w2c,
                new y2c
            ]));
            break;
        case 0:
            l = _u(WC(OC(Z_, 1), Nqe, 520, 0, [
                new y2c,
                new w2c,
                new G2c
            ]));
            break;
        case 2:
            l = _u(WC(OC(Z_, 1), Nqe, 520, 0, [
                new w2c,
                new G2c,
                new y2c
            ]));
    }
    for(k = new rmb(l); k.a < k.c.c.length;){
        j = JD(pmb(k), 520);
        i.c.length > 1 && (i = j.Fg(i, a.a, h));
    }
    if (i.c.length == 1) return JD(Mlb(i, i.c.length - 1), 237);
    if (i.c.length == 2) return t2c((sDb(0, i.c.length), JD(i.c[0], 237)), (sDb(1, i.c.length), JD(i.c[1], 237)), g, f);
    return null;
}
function nEd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    e = new nC(a);
    f = new Azd;
    d = (so(f.n), so(f.p), Tib(f.c), so(f.f), so(f.o), Tib(f.q), Tib(f.d), Tib(f.g), Tib(f.k), Tib(f.e), Tib(f.i), Tib(f.j), Tib(f.r), Tib(f.b), m = vzd(f, e, null), szd(f, e), m);
    if (b) {
        i = new nC(b);
        g = oEd(i);
        Wmd(d, WC(OC(b3, 1), Nqe, 521, 0, [
            g
        ]));
    }
    l = false;
    k = false;
    if (c) {
        i = new nC(c);
        SDe in i.a && (l = iC(i, SDe).oe().a);
        TDe in i.a && (k = iC(i, TDe).oe().a);
    }
    j = sld(uld(new wld, l), k);
    T8c(new W8c, d, j);
    SDe in e.a && kC(e, SDe, null);
    if (l || k) {
        h = new mC;
        kEd(j, h, l, k);
        kC(e, SDe, h);
    }
    n = new FAd(f);
    zqe(new YDd(d), n);
    o = new HAd(f);
    zqe(new YDd(d), o);
}
function FTc(a, b, c) {
    var d, e, f, g, h, i, j;
    c.Sg('Find roots', 1);
    a.a.c.length = 0;
    for(e = Gtb(b.b, 0); e.b != e.d.c;){
        d = JD(Utb(e), 39);
        if (d.b.b == 0) {
            ZMb(d, (tUc(), qUc), (xdb(), true));
            Ilb(a.a, d);
        }
    }
    switch(a.a.c.length){
        case 0:
            f = new eRc(0, b, 'DUMMY_ROOT');
            ZMb(f, (tUc(), qUc), (xdb(), true));
            ZMb(f, ZTc, true);
            Atb(b.b, f);
            break;
        case 1:
            break;
        default:
            g = new eRc(0, b, Dze);
            for(i = new rmb(a.a); i.a < i.c.c.length;){
                h = JD(pmb(i), 39);
                j = new ZQc(g, h);
                ZMb(j, (tUc(), ZTc), (xdb(), true));
                Atb(g.a.a, j);
                Atb(g.d, j);
                Atb(h.b, j);
                ZMb(h, qUc, false);
            }
            ZMb(g, (tUc(), qUc), (xdb(), true));
            ZMb(g, ZTc, true);
            Atb(b.b, g);
    }
    c.Tg();
}
function KLb(a) {
    var b, c, d, e, f, g;
    Llb(a.a, new QLb);
    for(c = new rmb(a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 224);
        d = Bdd(odd(JD(a.b, 68).c), JD(b.b, 68).c);
        if (GLb) {
            g = JD(a.b, 68).b;
            f = JD(b.b, 68).b;
            if ($wnd.Math.abs(d.a) >= $wnd.Math.abs(d.b)) {
                d.b = 0;
                f.d + f.a > g.d && f.d < g.d + g.a && xdd(d, $wnd.Math.max(g.c - (f.c + f.b), f.c - (g.c + g.b)));
            } else {
                d.a = 0;
                f.c + f.b > g.c && f.c < g.c + g.b && xdd(d, $wnd.Math.max(g.d - (f.d + f.a), f.d - (g.d + g.a)));
            }
        } else xdd(d, aMb(JD(a.b, 68), JD(b.b, 68)));
        e = $wnd.Math.sqrt(d.a * d.a + d.b * d.b);
        e = MLb(HLb, b, e, d);
        xdd(d, e);
        _Lb(JD(b.b, 68), d);
        Llb(b.a, new SLb(d));
        JD(HLb.b, 68);
        LLb(HLb, ILb, b);
    }
}
function wIc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    a.f = new NFb;
    j = 0;
    e = 0;
    for(g = new rmb(a.e.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        for(i = new rmb(f.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            h.p = j++;
            for(d = new es(Ir(kYb(h).a.Jc(), new er)); cs(d);){
                c = JD(ds(d), 18);
                c.p = e++;
            }
            b = EIc(h);
            for(m = new rmb(h.j); m.a < m.c.c.length;){
                l = JD(pmb(m), 11);
                if (b) {
                    o = l.a.b;
                    if (o != $wnd.Math.floor(o)) {
                        k = o - Ocb(zcb($wnd.Math.round(o)));
                        l.a.b -= k;
                    }
                }
                n = l.n.b + l.a.b;
                if (n != $wnd.Math.floor(n)) {
                    k = n - Ocb(zcb($wnd.Math.round(n)));
                    l.n.b -= k;
                }
            }
        }
    }
    a.g = j;
    a.b = e;
    a.i = SC(LX, Nqe, 401, j, 0, 1);
    a.c = SC(KX, Nqe, 639, e, 0, 1);
    a.d.a.$b();
}
function RGd(a) {
    var b, c, d, e, f, g, h, i, j;
    if (a.Mj()) {
        i = a.Nj();
        if (a.i > 0) {
            b = new YId(a.i, a.g);
            c = a.i;
            f = c < 100 ? null : new FGd(c);
            if (a.Qj()) for(d = 0; d < a.i; ++d){
                g = a.g[d];
                f = a.Sj(g, f);
            }
            lDd(a);
            e = c == 1 ? a.Fj(4, nDd(b, 0), null, 0, i) : a.Fj(6, b, null, -1, i);
            if (a.Jj()) {
                for(d = new XHd(b); d.e != d.i.gc();)f = a.Lj(WHd(d), f);
                if (!f) a.Gj(e);
                else {
                    f.kj(e);
                    f.lj();
                }
            } else if (!f) a.Gj(e);
            else {
                f.kj(e);
                f.lj();
            }
        } else {
            lDd(a);
            a.Gj(a.Fj(6, (pnb(), mnb), null, -1, i));
        }
    } else if (a.Jj()) {
        if (a.i > 0) {
            h = a.g;
            j = a.i;
            lDd(a);
            f = j < 100 ? null : new FGd(j);
            for(d = 0; d < j; ++d){
                g = h[d];
                f = a.Lj(g, f);
            }
            !!f && f.lj();
        } else lDd(a);
    } else lDd(a);
}
function APc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    uPc(this);
    c == (gPc(), ePc) ? Nrb(this.r, a) : Nrb(this.w, a);
    k = Kse;
    j = Lse;
    for(g = b.a.ec().Jc(); g.Ob();){
        e = JD(g.Pb(), 47);
        h = JD(e.a, 451);
        d = JD(e.b, 18);
        i = d.c;
        i == a && (i = d.d);
        h == ePc ? Nrb(this.r, i) : Nrb(this.w, i);
        m = (Rjd(), Ijd).Gc(i.j) ? Beb(MD(WMb(i, (Iqc(), Cqc)))) : Kdd(WC(OC(b2, 1), hre, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).b;
        k = $wnd.Math.min(k, m);
        j = $wnd.Math.max(j, m);
    }
    l = (Rjd(), Ijd).Gc(a.j) ? Beb(MD(WMb(a, (Iqc(), Cqc)))) : Kdd(WC(OC(b2, 1), hre, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ])).b;
    yPc(this, l, k, j);
    for(f = b.a.ec().Jc(); f.Ob();){
        e = JD(f.Pb(), 47);
        vPc(this, JD(e.b, 18));
    }
    this.o = false;
}
function oD(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    c = a.l & 8191;
    d = a.l >> 13 | (a.m & 15) << 9;
    e = a.m >> 4 & 8191;
    f = a.m >> 17 | (a.h & 255) << 5;
    g = (a.h & 1048320) >> 8;
    h = b.l & 8191;
    i = b.l >> 13 | (b.m & 15) << 9;
    j = b.m >> 4 & 8191;
    k = b.m >> 17 | (b.h & 255) << 5;
    l = (b.h & 1048320) >> 8;
    B = c * h;
    C = d * h;
    D = e * h;
    F = f * h;
    G = g * h;
    if (i != 0) {
        C += c * i;
        D += d * i;
        F += e * i;
        G += f * i;
    }
    if (j != 0) {
        D += c * j;
        F += d * j;
        G += e * j;
    }
    if (k != 0) {
        F += c * k;
        G += d * k;
    }
    l != 0 && (G += c * l);
    n = B & zse;
    o = (C & 511) << 13;
    m = n + o;
    q = B >> 22;
    r = C >> 9;
    s = (D & 262143) << 4;
    t = (F & 31) << 17;
    p = q + r + s + t;
    v = D >> 18;
    w = F >> 5;
    A = (G & 4095) << 8;
    u = v + w + A;
    p += m >> 22;
    m &= zse;
    u += p >> 22;
    p &= zse;
    u &= Ase;
    return _C(m, p, u);
}
function R3b(a) {
    var b, c, d, e, f, g, h;
    h = JD(Mlb(a.j, 0), 11);
    if (h.g.c.length != 0 && h.e.c.length != 0) throw scb(new Web('Interactive layout does not support NORTH/SOUTH ports with incoming _and_ outgoing edges.'));
    if (h.g.c.length != 0) {
        f = Kse;
        for(c = new rmb(h.g); c.a < c.c.c.length;){
            b = JD(pmb(c), 18);
            g = b.d.i;
            d = JD(WMb(g, (Bwc(), cvc)), 139);
            f = $wnd.Math.min(f, g.n.a - d.b);
        }
        return new cc(Qb(f));
    }
    if (h.e.c.length != 0) {
        e = Lse;
        for(c = new rmb(h.e); c.a < c.c.c.length;){
            b = JD(pmb(c), 18);
            g = b.c.i;
            d = JD(WMb(g, (Bwc(), cvc)), 139);
            e = $wnd.Math.max(e, g.n.a + g.o.a + d.c);
        }
        return new cc(Qb(e));
    }
    return wb(), wb(), vb;
}
function eAc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    c.Sg('Interactive cycle breaking', 1);
    l = new Ulb;
    for(n = new rmb(b.a); n.a < n.c.c.length;){
        m = JD(pmb(n), 9);
        m.p = 1;
        o = jYb(m).a;
        for(k = mYb(m, (Eyc(), Cyc)).Jc(); k.Ob();){
            j = JD(k.Pb(), 11);
            for(f = new rmb(j.g); f.a < f.c.c.length;){
                d = JD(pmb(f), 18);
                p = d.d.i;
                if (p != m) {
                    q = jYb(p).a;
                    q < o && YCb(l.c, d);
                }
            }
        }
    }
    for(g = new rmb(l); g.a < g.c.c.length;){
        d = JD(pmb(g), 18);
        fWb(d, true);
    }
    l.c.length = 0;
    for(i = new rmb(b.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 9);
        h.p > 0 && dAc(a, h, l);
    }
    for(e = new rmb(l); e.a < e.c.c.length;){
        d = JD(pmb(e), 18);
        fWb(d, true);
    }
    l.c.length = 0;
    c.Tg();
}
function xUd(a, b) {
    var c, d, e, f, g, h, i;
    if (a.ll()) {
        if (a.i > 4) {
            if (a.ck(b)) {
                if (a.Zk()) {
                    e = JD(b, 52);
                    d = e.Ah();
                    i = d == a.e && (a.jl() ? e.uh(e.Bh(), a.fl()) == a.gl() : -1 - e.Bh() == a.Ij());
                    if (a.kl() && !i && !d && !!e.Fh()) for(f = 0; f < a.i; ++f){
                        c = a.ml(JD(a.g[f], 57));
                        if (XD(c) === XD(b)) return true;
                    }
                    return i;
                } else if (a.jl() && !a.il()) {
                    g = JD(b, 57).Ih(s1d(JD(a.Ik(), 19)));
                    if (XD(g) === XD(a.e)) return true;
                    else if (g == null || !JD(g, 57).Rh()) return false;
                }
            } else return false;
        }
        h = mDd(a, b);
        if (a.kl() && !h) for(f = 0; f < a.i; ++f){
            e = a.ml(JD(a.g[f], 57));
            if (XD(e) === XD(b)) return true;
        }
        return h;
    } else return mDd(a, b);
}
function pGc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    c = 0;
    k = new Ulb;
    for(h = new rmb(b); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        bGc(a.b, a.d[g.p]);
        k.c.length = 0;
        switch(g.i.k.g){
            case 0:
                d = JD(WMb(g, (Iqc(), sqc)), 9);
                Llb(d.j, new $Gc(k));
                break;
            case 1:
                Aub(CBb(BBb(new RBb(null, new Gvb(g.i.j, 16)), new aHc(g))), new dHc(k));
                break;
            case 3:
                e = JD(WMb(g, (Iqc(), kqc)), 11);
                Ilb(k, new xod(e, jfb(g.e.c.length + g.g.c.length)));
        }
        for(j = new rmb(k); j.a < j.c.c.length;){
            i = JD(pmb(j), 47);
            f = DGc(a, JD(i.a, 11));
            if (f > a.d[g.p]) {
                c += aGc(a.b, f) * JD(i.b, 17).a;
                $kb(a.a, jfb(f));
            }
        }
        while(!elb(a.a))$Fc(a.b, JD(jlb(a.a), 17).a);
    }
    return c;
}
function pEd(a) {
    var b, c, d;
    Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
        new Mgd
    ]));
    c = new FB(a);
    for(d = 0; d < c.a.length; ++d){
        b = BB(c, d).re().a;
        cgb(b, 'layered') ? Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new Ptc
        ])) : cgb(b, 'force') ? Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new ZNb
        ])) : cgb(b, 'stress') ? Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new _Ob
        ])) : cgb(b, 'mrtree') ? Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new FUc
        ])) : cgb(b, 'radial') ? Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new H$c
        ])) : cgb(b, 'sporeOverlap') || cgb(b, 'sporeCompaction') ? Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new _6c
        ])) : cgb(b, 'rectpacking') && Lad(iEd, WC(OC(r1, 1), Nqe, 146, 0, [
            new J1c
        ]));
    }
}
function J2b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = JD(WMb(a, (Iqc(), Tpc)), 64);
    d = JD(Mlb(a.j, 0), 11);
    k == (Rjd(), xjd) ? aZb(d, Ojd) : k == Ojd && aZb(d, xjd);
    if (JD(WMb(b, (Bwc(), ovc)), 181).Gc((ykd(), xkd))) {
        i = Beb(MD(WMb(a, cwc)));
        j = Beb(MD(WMb(a, dwc)));
        g = Beb(MD(WMb(a, awc)));
        h = JD(WMb(b, Hvc), 22);
        if (h.Gc((ojd(), kjd))) {
            c = j;
            l = a.o.a / 2 - d.n.a;
            for(f = new rmb(d.f); f.a < f.c.c.length;){
                e = JD(pmb(f), 72);
                e.n.b = c;
                e.n.a = l - e.o.a / 2;
                c += e.o.b + g;
            }
        } else if (h.Gc(mjd)) for(f = new rmb(d.f); f.a < f.c.c.length;){
            e = JD(pmb(f), 72);
            e.n.a = i + a.o.a - d.n.a;
        }
        YGb(new $Gb((sWb(), new DWb(b, false, false, new jXb))), new PWb(null, a, false));
    }
}
function Odc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (b.c.length == 0) return;
    pnb();
    Pmb(b.c, b.c.length, null);
    e = new rmb(b);
    d = JD(pmb(e), 152);
    while(e.a < e.c.c.length){
        c = JD(pmb(e), 152);
        if (qEb(d.e.c, c.e.c) && !(tEb(Zcd(d.e).b, c.e.d) || tEb(Zcd(c.e).b, d.e.d))) d = (Klb(d.k, c.k), Klb(d.b, c.b), Klb(d.c, c.c), xe(d.i, c.i), Klb(d.d, c.d), Klb(d.j, c.j), f = $wnd.Math.min(d.e.c, c.e.c), g = $wnd.Math.min(d.e.d, c.e.d), h = $wnd.Math.max(d.e.c + d.e.b, c.e.c + c.e.b), i = h - f, j = $wnd.Math.max(d.e.d + d.e.a, c.e.d + c.e.a), k = j - g, ddd(d.e, f, g, i, k), ZEb(d.f, c.f), !d.a && (d.a = c.a), Klb(d.g, c.g), Ilb(d.g, c), d);
        else {
            Rdc(a, d);
            d = c;
        }
    }
    Rdc(a, d);
}
function LVb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    i = new Ulb;
    for(f = new rmb(b.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 9);
        for(h = new rmb(e.j); h.a < h.c.c.length;){
            g = JD(pmb(h), 11);
            k = null;
            for(t = CXb(g.g), u = 0, v = t.length; u < v; ++u){
                s = t[u];
                if (!xXb(s.d.i, c)) {
                    r = GVb(a, b, c, s, s.c, (Eyc(), Cyc), k);
                    r != k && YCb(i.c, r);
                    r.c && (k = r);
                }
            }
            j = null;
            for(o = CXb(g.e), p = 0, q = o.length; p < q; ++p){
                n = o[p];
                if (!xXb(n.c.i, c)) {
                    r = GVb(a, b, c, n, n.d, (Eyc(), Byc), j);
                    r != j && YCb(i.c, r);
                    r.c && (j = r);
                }
            }
        }
    }
    for(m = new rmb(i); m.a < m.c.c.length;){
        l = JD(pmb(m), 441);
        Nlb(b.a, l.a, 0) != -1 || Ilb(b.a, l.a);
        l.c && YCb(d.c, l);
    }
}
function mDc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    for(h = new rmb(b); h.a < h.c.c.length;){
        f = JD(pmb(h), 238);
        f.e = null;
        f.c = 0;
    }
    i = null;
    for(g = new rmb(b); g.a < g.c.c.length;){
        f = JD(pmb(g), 238);
        l = f.d[0];
        if (c && l.k != (DYb(), AYb)) continue;
        for(n = JD(WMb(l, (Iqc(), aqc)), 15).Jc(); n.Ob();){
            m = JD(n.Pb(), 9);
            if (!c || m.k == (DYb(), AYb)) {
                (!f.e && (f.e = new Ulb), f.e).Ec(a.b[m.c.p][m.p]);
                ++a.b[m.c.p][m.p].c;
            }
        }
        if (!c && l.k == (DYb(), AYb)) {
            if (i) for(k = JD(Qc(a.d, i), 22).Jc(); k.Ob();){
                j = JD(k.Pb(), 9);
                for(e = JD(Qc(a.d, l), 22).Jc(); e.Ob();){
                    d = JD(e.Pb(), 9);
                    zDc(a.b[j.c.p][j.p]).Ec(a.b[d.c.p][d.p]);
                    ++a.b[d.c.p][d.p].c;
                }
            }
            i = l;
        }
    }
}
function Rld(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q;
    l = new Fdd(JD(ksd(a, (ued(), oed)), 8));
    l.a = $wnd.Math.max(l.a - c.b - c.c, 0);
    l.b = $wnd.Math.max(l.b - c.d - c.a, 0);
    e = MD(ksd(a, ied));
    (e == null || (tDb(e), e) <= 0) && (e = 1.3);
    h = new Ulb;
    for(o = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); o.e != o.i.gc();){
        n = JD(AHd(o), 27);
        g = new imd(n);
        YCb(h.c, g);
    }
    m = JD(ksd(a, jed), 321);
    switch(m.g){
        case 3:
            q = Old(h, b, l.a, l.b, (j = d, tDb(e), e, j));
            break;
        case 1:
            q = Nld(h, b, l.a, l.b, (k = d, tDb(e), e, k));
            break;
        default:
            q = Pld(h, b, l.a, l.b, (i = d, tDb(e), e, i));
    }
    f = new hmd(q);
    p = Sld(f, b, c, l.a, l.b, d, (tDb(e), e));
    mnd(a, p.a, p.b, false, true);
}
function wXb(a, b, c, d) {
    var e, f, g, h, i, j;
    h = a.j;
    if (h == (Rjd(), Pjd) && b != (ajd(), $id) && b != (ajd(), _id)) {
        h = mXb(a, c);
        aZb(a, h);
        !(!a.q ? (pnb(), pnb(), nnb) : a.q)._b((Bwc(), Dvc)) && h != Pjd && (a.n.a != 0 || a.n.b != 0) && ZMb(a, Dvc, lXb(a, h));
    }
    if (b == (ajd(), Yid)) {
        j = 0;
        switch(h.g){
            case 1:
            case 3:
                f = a.i.o.a;
                f > 0 && (j = a.n.a / f);
                break;
            case 2:
            case 4:
                e = a.i.o.b;
                e > 0 && (j = a.n.b / e);
        }
        ZMb(a, (Iqc(), tqc), j);
    }
    i = a.o;
    g = a.a;
    if (d) {
        g.a = d.a;
        g.b = d.b;
        a.d = true;
    } else if (b != $id && b != _id && h != Pjd) switch(h.g){
        case 1:
            g.a = i.a / 2;
            break;
        case 2:
            g.a = i.a;
            g.b = i.b / 2;
            break;
        case 3:
            g.a = i.a / 2;
            g.b = i.b;
            break;
        case 4:
            g.b = i.b / 2;
    }
    else {
        g.a = i.a / 2;
        g.b = i.b / 2;
    }
}
function sFd(a) {
    var b, c, d, e, f, g, h, i, j, k;
    if (a.Mj()) {
        k = a.Bj();
        i = a.Nj();
        if (k > 0) {
            b = new xDd(a.mj());
            c = k;
            f = c < 100 ? null : new FGd(c);
            zEd(a, c, b.g);
            e = c == 1 ? a.Fj(4, nDd(b, 0), null, 0, i) : a.Fj(6, b, null, -1, i);
            if (a.Jj()) {
                for(d = new CHd(b); d.e != d.i.gc();)f = a.Lj(AHd(d), f);
                if (!f) a.Gj(e);
                else {
                    f.kj(e);
                    f.lj();
                }
            } else if (!f) a.Gj(e);
            else {
                f.kj(e);
                f.lj();
            }
        } else {
            zEd(a, a.Bj(), a.Cj());
            a.Gj(a.Fj(6, (pnb(), mnb), null, -1, i));
        }
    } else if (a.Jj()) {
        k = a.Bj();
        if (k > 0) {
            h = a.Cj();
            j = k;
            zEd(a, k, h);
            f = j < 100 ? null : new FGd(j);
            for(d = 0; d < j; ++d){
                g = h[d];
                f = a.Lj(g, f);
            }
            !!f && f.lj();
        } else zEd(a, a.Bj(), a.Cj());
    } else zEd(a, a.Bj(), a.Cj());
}
function Lbc(a, b) {
    var c, d, e, f, g, h, i, j;
    b.Sg('Sort By Input Model ' + WMb(a, (Bwc(), cuc)), 1);
    f = 0;
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        d.p = f;
        j = f == 0 ? 0 : f - 1;
        i = JD(Mlb(a.b, j), 25);
        c = new Fkc(i, JD(WMb(a, cuc), 266), JD(WMb(a, _tc), 349), true);
        Obc(d.a, c);
        for(h = new rmb(d.a); h.a < h.c.c.length;){
            g = JD(pmb(h), 9);
            if (XD(WMb(g, Evc)) !== XD((ajd(), Wid)) && XD(WMb(g, Evc)) !== XD(Xid)) {
                pnb();
                Slb(g.j, new Xkc(i, JD(WMb(a, cuc), 266), Qbc(g), ydb(LD(WMb(a, buc)))));
                b._g('Node ' + g + ' ports: ' + g.j);
            }
        }
        c = new Fkc(i, JD(WMb(a, cuc), 266), JD(WMb(a, _tc), 349), false);
        Obc(d.a, c);
        b._g('Layer ' + f + ': ' + d);
        ++f;
    }
    b.Tg();
}
function Pld(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q;
    h = SC(aE, Rse, 30, a.c.length, 15, 1);
    m = new dvb(new ymd);
    Yub(m, a);
    j = 0;
    p = new Ulb;
    while(m.b.c.length != 0){
        g = JD(m.b.c.length == 0 ? null : Mlb(m.b, 0), 162);
        if (j > 1 && cmd(g) * bmd(g) / 2 > h[0]) {
            f = 0;
            while(f < p.c.length - 1 && cmd(g) * bmd(g) / 2 > h[f])++f;
            o = new Ijb(p, 0, f + 1);
            l = new hmd(o);
            k = cmd(g) / bmd(g);
            i = Sld(l, b, new LYb, c, d, e, k);
            mdd(vdd(l.e), i);
            yDb(_ub(m, l), Xse);
            n = new Ijb(p, f + 1, p.c.length);
            Yub(m, n);
            p.c.length = 0;
            j = 0;
            Gmb(h, h.length, 0);
        } else {
            q = m.b.c.length == 0 ? null : Mlb(m.b, 0);
            q != null && cvb(m, 0);
            j > 0 && (h[j] = h[j - 1]);
            h[j] += cmd(g) * bmd(g);
            ++j;
            YCb(p.c, g);
        }
    }
    return p;
}
function yhc(a, b) {
    var c, d, e, f;
    c = b.b;
    f = new Wlb(c.j);
    e = 0;
    d = c.j;
    d.c.length = 0;
    khc(JD(Yi(a.b, (Rjd(), xjd), (Ihc(), Hhc)), 15), c);
    e = lhc(f, e, new eic, d);
    khc(JD(Yi(a.b, xjd, Ghc), 15), c);
    e = lhc(f, e, new gic, d);
    khc(JD(Yi(a.b, xjd, Fhc), 15), c);
    khc(JD(Yi(a.b, wjd, Hhc), 15), c);
    khc(JD(Yi(a.b, wjd, Ghc), 15), c);
    e = lhc(f, e, new iic, d);
    khc(JD(Yi(a.b, wjd, Fhc), 15), c);
    khc(JD(Yi(a.b, Ojd, Hhc), 15), c);
    e = lhc(f, e, new kic, d);
    khc(JD(Yi(a.b, Ojd, Ghc), 15), c);
    e = lhc(f, e, new mic, d);
    khc(JD(Yi(a.b, Ojd, Fhc), 15), c);
    khc(JD(Yi(a.b, Qjd, Hhc), 15), c);
    e = lhc(f, e, new Shc, d);
    khc(JD(Yi(a.b, Qjd, Ghc), 15), c);
    khc(JD(Yi(a.b, Qjd, Fhc), 15), c);
}
function lAc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    c.Sg('Model order cycle breaking', 1);
    a.a = 0;
    a.b = 0;
    n = new Ulb;
    k = b.a.c.length;
    for(j = new rmb(b.a); j.a < j.c.c.length;){
        i = JD(pmb(j), 9);
        XMb(i, (Iqc(), jqc)) && (k = $wnd.Math.max(k, JD(WMb(i, jqc), 17).a + 1));
    }
    for(p = new rmb(b.a); p.a < p.c.c.length;){
        o = JD(pmb(p), 9);
        g = kAc(a, o, k);
        for(m = mYb(o, (Eyc(), Cyc)).Jc(); m.Ob();){
            l = JD(m.Pb(), 11);
            for(f = new rmb(l.g); f.a < f.c.c.length;){
                d = JD(pmb(f), 18);
                q = d.d.i;
                h = kAc(a, q, k);
                h < g && YCb(n.c, d);
            }
        }
    }
    for(e = new rmb(n); e.a < e.c.c.length;){
        d = JD(pmb(e), 18);
        fWb(d, true);
        ZMb(b, (Iqc(), Mpc), (xdb(), true));
    }
    n.c.length = 0;
    c.Tg();
}
function P7b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    b.Sg('Layer size calculation', 1);
    k = Kse;
    j = Lse;
    e = false;
    for(h = new rmb(a.b); h.a < h.c.c.length;){
        g = JD(pmb(h), 25);
        i = g.c;
        i.a = 0;
        i.b = 0;
        if (g.a.c.length == 0) continue;
        e = true;
        for(m = new rmb(g.a); m.a < m.c.c.length;){
            l = JD(pmb(m), 9);
            o = l.o;
            n = l.d;
            i.a = $wnd.Math.max(i.a, o.a + n.b + n.c);
        }
        d = JD(Mlb(g.a, 0), 9);
        p = d.n.b - d.d.d;
        d.k == (DYb(), wYb) && (p -= JD(WMb(a, (Bwc(), hwc)), 139).d);
        f = JD(Mlb(g.a, g.a.c.length - 1), 9);
        c = f.n.b + f.o.b + f.d.a;
        f.k == wYb && (c += JD(WMb(a, (Bwc(), hwc)), 139).a);
        i.b = c - p;
        k = $wnd.Math.min(k, p);
        j = $wnd.Math.max(j, c);
    }
    if (!e) {
        k = 0;
        j = 0;
    }
    a.f.b = j - k;
    a.c.b -= k;
    b.Tg();
}
function ANb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    g = b.d;
    h = c.d;
    while(g.a - h.a == 0 && g.b - h.b == 0){
        i = false;
        if (RD(b, 249) && RD(c, 249) && !i) {
            j = JD(b, 249).a;
            k = Bdd(new Fdd(iNb(j)), hNb(j));
            d = 2;
            e = new Edd(k.a / $wnd.Math.sqrt(k.a * k.a + k.b * k.b) * d, -k.b / $wnd.Math.sqrt(k.a * k.a + k.b * k.b) * d);
            mdd(g, e);
            l = JD(c, 249).a;
            m = Bdd(new Fdd(iNb(l)), hNb(l));
            d = k == m ? -2 : 2;
            f = new Edd(m.a / $wnd.Math.sqrt(m.a * m.a + m.b * m.b) * d, -(m.b / $wnd.Math.sqrt(m.a * m.a + m.b * m.b)) * d);
            mdd(g, f);
            i = true;
        } else {
            g.a += yvb(a, 26) * ete + yvb(a, 27) * fte - 0.5;
            g.b += yvb(a, 26) * ete + yvb(a, 27) * fte - 0.5;
            h.a += yvb(a, 26) * ete + yvb(a, 27) * fte - 0.5;
            h.b += yvb(a, 26) * ete + yvb(a, 27) * fte - 0.5;
        }
    }
}
function XPb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    j = UPb(b);
    q = JD(WMb(b, (Bwc(), ouc)), 323);
    ofb(j, new cQb(q));
    r = JD(WMb(b, guc), 298);
    ofb(j, new eQb(r));
    p = 0;
    k = new Ulb;
    for(f = new Blb(j); f.a != f.b;){
        e = JD(zlb(f), 36);
        mQb(a.c, e);
        m = JD(WMb(e, (Iqc(), uqc)), 15);
        p += m.gc();
        d = m.Jc();
        Ilb(k, new xod(e, d));
    }
    c.Sg('Recursive hierarchical layout', p);
    o = 0;
    n = JD(JD(Mlb(k, k.c.length - 1), 47).b, 49);
    while(n.Ob())for(i = new rmb(k); i.a < i.c.c.length;){
        h = JD(pmb(i), 47);
        m = JD(h.b, 49);
        g = JD(h.a, 36);
        while(m.Ob()){
            l = JD(m.Pb(), 44);
            if (RD(l, 498)) {
                if (!g.e) {
                    l.If(g, c.bh(1));
                    ++o;
                    break;
                } else break;
            } else {
                l.If(g, c.bh(1));
                ++o;
            }
        }
    }
    c.Tg();
}
function zXb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    f = 0;
    g = 0;
    for(j = new rmb(a.a); j.a < j.c.c.length;){
        h = JD(pmb(j), 9);
        f = $wnd.Math.max(f, h.d.b);
        g = $wnd.Math.max(g, h.d.c);
    }
    for(i = new rmb(a.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 9);
        c = JD(WMb(h, (Bwc(), Rtc)), 254);
        switch(c.g){
            case 1:
                o = 0;
                break;
            case 2:
                o = 1;
                break;
            case 5:
                o = 0.5;
                break;
            default:
                d = 0;
                l = 0;
                for(n = new rmb(h.j); n.a < n.c.c.length;){
                    m = JD(pmb(n), 11);
                    m.e.c.length == 0 || ++d;
                    m.g.c.length == 0 || ++l;
                }
                d + l == 0 ? o = 0.5 : o = l / (d + l);
        }
        q = a.c;
        k = h.o.a;
        r = (q.a - k) * o;
        o > 0.5 ? r -= g * 2 * (o - 0.5) : o < 0.5 && (r += f * 2 * (0.5 - o));
        e = h.d.b;
        r < e && (r = e);
        p = h.d.c;
        r > q.a - p - k && (r = q.a - p - k);
        h.n.a = b + r;
    }
}
function w7b(a) {
    var b, c, d, e, f;
    d = JD(WMb(a, (Bwc(), Uuc)), 171);
    if (d == (Oqc(), Kqc)) for(c = new es(Ir(hYb(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 18);
        if (!y7b(b)) throw scb(new Y8c(awe + fYb(a) + "' has its layer constraint set to FIRST_SEPARATE, but has at least one incoming edge. " + 'FIRST_SEPARATE nodes must not have incoming edges.'));
    }
    else if (d == Mqc) for(f = new es(Ir(kYb(a).a.Jc(), new er)); cs(f);){
        e = JD(ds(f), 18);
        if (!y7b(e)) throw scb(new Y8c(awe + fYb(a) + "' has its layer constraint set to LAST_SEPARATE, but has at least one outgoing edge. " + 'LAST_SEPARATE nodes must not have outgoing edges.'));
    }
}
function plc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    m = new Ulb;
    e = new Ulb;
    p = null;
    for(h = b.Jc(); h.Ob();){
        g = JD(h.Pb(), 17);
        f = new Dlc(g.a);
        YCb(e.c, f);
        if (p) {
            f.d = p;
            p.e = f;
        }
        p = f;
    }
    t = olc(a);
    for(k = 0; k < e.c.length; ++k){
        n = null;
        q = Clc((sDb(0, e.c.length), JD(e.c[0], 645)));
        c = null;
        d = Kse;
        for(l = 1; l < a.b.c.length; ++l){
            r = q ? $wnd.Math.abs(q.b - l) : $wnd.Math.abs(l - n.b) + 1;
            o = n ? $wnd.Math.abs(l - n.b) : r + 1;
            if (o < r) {
                j = n;
                i = o;
            } else {
                j = q;
                i = r;
            }
            s = (u = Beb(MD(WMb(a, (Bwc(), vwc)))), t[l] + $wnd.Math.pow(i, u));
            if (s < d) {
                d = s;
                c = j;
                c.c = l;
            }
            if (!!q && l == q.b) {
                n = q;
                q = xlc(q);
            }
        }
        if (c) {
            Ilb(m, jfb(c.c));
            c.a = true;
            ylc(c);
        }
    }
    pnb();
    Pmb(m.c, m.c.length, null);
    return m;
}
function d9c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if (a.e && a.c.c < a.f) throw scb(new Web('Expected ' + a.f + ' phases to be configured; ' + 'only found ' + a.c.c));
    k = JD(deb(a.g), 10);
    n = av(a.f);
    for(f = k, h = 0, j = f.length; h < j; ++h){
        d = f[h];
        l = JD(_8c(a, d.g), 188);
        l ? Ilb(n, JD(g9c(a, l), 106)) : (n.c.push(null), undefined);
    }
    o = new J9c;
    EBb(BBb(FBb(BBb(new RBb(null, new Gvb(n, 16)), new m9c), new o9c(b)), new q9c), new s9c(o));
    D9c(o, a.a);
    c = new Ulb;
    for(e = k, g = 0, i = e.length; g < i; ++g){
        d = e[g];
        Klb(c, h9c(a, Qx(JD(_8c(o, d.g), 20))));
        m = JD(Mlb(n, d.g), 106);
        !!m && YCb(c.c, m);
    }
    Klb(c, h9c(a, Qx(JD(_8c(o, k[k.length - 1].g + 1), 20))));
    return c;
}
function aD(a, b, c) {
    var d, e, f, g, h, i;
    if (b.l == 0 && b.m == 0 && b.h == 0) throw scb(new kdb('divide by zero'));
    if (a.l == 0 && a.m == 0 && a.h == 0) {
        c && (YC = _C(0, 0, 0));
        return _C(0, 0, 0);
    }
    if (b.h == Bse && b.m == 0 && b.l == 0) return bD(a, c);
    i = false;
    if (b.h >> 19 != 0) {
        b = pD(b);
        i = !i;
    }
    g = hD(b);
    f = false;
    e = false;
    d = false;
    if (a.h == Bse && a.m == 0 && a.l == 0) {
        e = true;
        f = true;
        if (g == -1) {
            a = $C((ED(), AD));
            d = true;
            i = !i;
        } else {
            h = tD(a, g);
            i && fD(h);
            c && (YC = _C(0, 0, 0));
            return h;
        }
    } else if (a.h >> 19 != 0) {
        f = true;
        a = pD(a);
        d = true;
        i = !i;
    }
    if (g != -1) return cD(a, g, i, f, c);
    if (mD(a, b) < 0) {
        c && (f ? YC = pD(a) : YC = _C(a.l, a.m, a.h));
        return _C(0, 0, 0);
    }
    return dD(d ? a : _C(a.l, a.m, a.h), b, i, f, e, c);
}
function sib(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    g = a.e;
    i = b.e;
    if (g == 0) return b;
    if (i == 0) return a;
    f = a.d;
    h = b.d;
    if (f + h == 2) {
        c = ucb(a.a[0], Use);
        d = ucb(b.a[0], Use);
        if (g == i) {
            k = tcb(c, d);
            o = Pcb(k);
            n = Pcb(Lcb(k, 32));
            return n == 0 ? new Thb(g, o) : new Vhb(g, 2, WC(OC(cE, 1), ise, 30, 15, [
                o,
                n
            ]));
        }
        return Ghb(), Bcb(g < 0 ? Mcb(d, c) : Mcb(c, d), 0) ? aib(g < 0 ? Mcb(d, c) : Mcb(c, d)) : Ohb(aib(Gcb(g < 0 ? Mcb(d, c) : Mcb(c, d))));
    } else if (g == i) {
        m = g;
        l = f >= h ? tib(a.a, f, b.a, h) : tib(b.a, h, a.a, f);
    } else {
        e = f != h ? f > h ? 1 : -1 : vib(a.a, b.a, f);
        if (e == 0) return Ghb(), Fhb;
        if (e == 1) {
            m = g;
            l = yib(a.a, f, b.a, h);
        } else {
            m = i;
            l = yib(b.a, h, a.a, f);
        }
    }
    j = new Vhb(m, l.length, l);
    Ihb(j);
    return j;
}
function NOc(a, b) {
    var c, d, e, f, g, h, i;
    if (a.g > b.f || b.g > a.f) return;
    c = 0;
    d = 0;
    for(g = a.w.a.ec().Jc(); g.Ob();){
        e = JD(g.Pb(), 11);
        DPc(Kdd(WC(OC(b2, 1), hre, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, b.g, b.f) && ++c;
    }
    for(h = a.r.a.ec().Jc(); h.Ob();){
        e = JD(h.Pb(), 11);
        DPc(Kdd(WC(OC(b2, 1), hre, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, b.g, b.f) && --c;
    }
    for(i = b.w.a.ec().Jc(); i.Ob();){
        e = JD(i.Pb(), 11);
        DPc(Kdd(WC(OC(b2, 1), hre, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, a.g, a.f) && ++d;
    }
    for(f = b.r.a.ec().Jc(); f.Ob();){
        e = JD(f.Pb(), 11);
        DPc(Kdd(WC(OC(b2, 1), hre, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, a.g, a.f) && --d;
    }
    if (c < d) new cPc(a, b, d - c);
    else if (d < c) new cPc(b, a, c - d);
    else {
        new cPc(b, a, 0);
        new cPc(a, b, 0);
    }
}
function jWd(a) {
    var b, c, d, e, f, g, h, i, j, k;
    b = new sWd;
    c = new sWd;
    j = cgb(qFe, (e = Fud(a.b, rFe), !e ? null : OD(xJd((!e.b && (e.b = new lRd((cPd(), $Od), u7, e)), e.b), sFe))));
    for(i = 0; i < a.i; ++i){
        h = JD(a.g[i], 178);
        if (RD(h, 101)) {
            g = JD(h, 19);
            (g.Bb & RCe) != 0 ? ((g.Bb & ire) == 0 || !j && (f = Fud(g, rFe), (!f ? null : OD(xJd((!f.b && (f.b = new lRd((cPd(), $Od), u7, f)), f.b), GDe))) == null)) && tCd(b, g) : (k = s1d(g), !!k && (k.Bb & RCe) != 0 || ((g.Bb & ire) == 0 || !j && (d = Fud(g, rFe), (!d ? null : OD(xJd((!d.b && (d.b = new lRd((cPd(), $Od), u7, d)), d.b), GDe))) == null)) && tCd(c, g));
        } else {
            Ife();
            if (JD(h, 69).uk()) {
                if (!h.pk()) {
                    tCd(b, h);
                    tCd(c, h);
                }
            }
        }
    }
    sDd(b);
    sDd(c);
    a.a = JD(b.g, 253);
    JD(c.g, 253);
}
function Z9d(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    if (WTd(b, c) >= 0) return c;
    switch(Tae(jae(a, c))){
        case 2:
            if (cgb('', hae(a, c.nk()).ve())) {
                i = Wae(jae(a, c));
                h = Vae(jae(a, c));
                k = kae(a, b, i, h);
                if (k) return k;
                e = $9d(a, b);
                for(g = 0, l = e.gc(); g < l; ++g){
                    k = JD(e.Xb(g), 178);
                    if (qae(Xae(jae(a, k)), i)) return k;
                }
            }
            return null;
        case 4:
            if (cgb('', hae(a, c.nk()).ve())) {
                for(d = c; d; d = Sae(jae(a, d))){
                    j = Wae(jae(a, d));
                    h = Vae(jae(a, d));
                    k = lae(a, b, j, h);
                    if (k) return k;
                }
                i = Wae(jae(a, c));
                if (cgb(eGe, i)) return mae(a, b);
                else {
                    f = _9d(a, b);
                    for(g = 0, l = f.gc(); g < l; ++g){
                        k = JD(f.Xb(g), 178);
                        if (qae(Xae(jae(a, k)), i)) return k;
                    }
                }
            }
            return null;
        default:
            return null;
    }
}
function mbe(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (c.gc() == 0) return false;
    h = (Ife(), JD(b, 69).uk());
    f = h ? c : new wDd(c.gc());
    if (Lfe(a.e, b)) {
        if (b.Pi()) for(j = c.Jc(); j.Ob();){
            i = j.Pb();
            if (!ybe(a, b, i, RD(b, 101) && (JD(b, 19).Bb & Pse) != 0)) {
                e = Jfe(b, i);
                f.Gc(e) || f.Ec(e);
            }
        }
        else if (!h) for(j = c.Jc(); j.Ob();){
            i = j.Pb();
            e = Jfe(b, i);
            f.Ec(e);
        }
    } else {
        if (c.gc() > 1) throw scb(new Teb(hGe));
        k = Kfe(a.e.zh(), b);
        d = JD(a.g, 122);
        for(g = 0; g < a.i; ++g){
            e = d[g];
            if (k.Zl(e.Ik())) {
                if (c.Gc(h ? e : e.kd())) return false;
                else {
                    for(j = c.Jc(); j.Ob();){
                        i = j.Pb();
                        JD(DCd(a, g, h ? JD(i, 74) : Jfe(b, i)), 74);
                    }
                    return true;
                }
            }
        }
        if (!h) {
            e = Jfe(b, c.Jc().Pb());
            f.Ec(e);
        }
    }
    return vCd(a, f);
}
function TKc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    k = new Mtb;
    for(h = (j = new Zjb(a.c).a.vc().Jc(), new ckb(j)); h.a.Ob();){
        f = (e = JD(h.a.Pb(), 43), JD(e.kd(), 453));
        f.b == 0 && Dtb(k, f, k.c.b, k.c);
    }
    while(k.b != 0){
        f = JD(k.b == 0 ? null : (rDb(k.b != 0), Ktb(k, k.a.a)), 453);
        f.a == null && (f.a = 0);
        for(d = new rmb(f.d); d.a < d.c.c.length;){
            c = JD(pmb(d), 647);
            c.b.a == null ? c.b.a = Beb(f.a) + c.a : b.o == (HKc(), FKc) ? c.b.a = $wnd.Math.min(Beb(c.b.a), Beb(f.a) + c.a) : c.b.a = $wnd.Math.max(Beb(c.b.a), Beb(f.a) + c.a);
            --c.b.b;
            c.b.b == 0 && Atb(k, c.b);
        }
    }
    for(g = (i = new Zjb(a.c).a.vc().Jc(), new ckb(i)); g.a.Ob();){
        f = (e = JD(g.a.Pb(), 43), JD(e.kd(), 453));
        b.i[f.c.p] = f.a;
    }
}
function nMc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    k = c + b.c.c.a;
    for(n = new rmb(b.j); n.a < n.c.c.length;){
        m = JD(pmb(n), 11);
        e = Kdd(WC(OC(b2, 1), hre, 8, 0, [
            m.i.n,
            m.n,
            m.a
        ]));
        if (b.k == (DYb(), BYb)) {
            h = JD(WMb(m, (Iqc(), kqc)), 11);
            e.a = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                h.i.n,
                h.n,
                h.a
            ])).a;
            b.n.a = e.a;
        }
        g = new Edd(0, e.b);
        if (m.j == (Rjd(), wjd)) g.a = k;
        else if (m.j == Qjd) g.a = c;
        else continue;
        o = $wnd.Math.abs(e.a - g.a);
        if (o <= d && !kMc(b)) continue;
        f = m.g.c.length + m.e.c.length > 1;
        for(j = new xZb(m.b); omb(j.a) || omb(j.b);){
            i = JD(omb(j.a) ? pmb(j.a) : pmb(j.b), 18);
            l = i.c == m ? i.d : i.c;
            $wnd.Math.abs(Kdd(WC(OC(b2, 1), hre, 8, 0, [
                l.i.n,
                l.n,
                l.a
            ])).b - g.b) > 1 && hMc(a, i, g, f, m);
        }
    }
}
function yOc(a) {
    var b, c, d, e, f, g;
    e = new Ajb(a.e, 0);
    d = new Ajb(a.a, 0);
    if (a.d) for(c = 0; c < a.b; c++){
        rDb(e.b < e.d.gc());
        e.d.Xb(e.c = e.b++);
    }
    else for(c = 0; c < a.b - 1; c++){
        rDb(e.b < e.d.gc());
        e.d.Xb(e.c = e.b++);
        tjb(e);
    }
    b = Beb((rDb(e.b < e.d.gc()), MD(e.d.Xb(e.c = e.b++))));
    while(a.f - b > uze){
        f = b;
        g = 0;
        while($wnd.Math.abs(b - f) < uze){
            ++g;
            b = Beb((rDb(e.b < e.d.gc()), MD(e.d.Xb(e.c = e.b++))));
            rDb(d.b < d.d.gc());
            d.d.Xb(d.c = d.b++);
        }
        if (g < a.b) {
            rDb(e.b > 0);
            e.a.Xb(e.c = --e.b);
            xOc(a, a.b - g, f, d, e);
            rDb(e.b < e.d.gc());
            e.d.Xb(e.c = e.b++);
        }
        rDb(d.b > 0);
        d.a.Xb(d.c = --d.b);
    }
    if (!a.d) for(c = 0; c < a.b - 1; c++){
        rDb(e.b < e.d.gc());
        e.d.Xb(e.c = e.b++);
        tjb(e);
    }
    a.d = true;
    a.c = true;
}
function Ihe() {
    Ihe = Zcb;
    khe = (jhe(), ihe).b;
    nhe = JD(nDd(STd(ihe.b), 0), 35);
    lhe = JD(nDd(STd(ihe.b), 1), 35);
    mhe = JD(nDd(STd(ihe.b), 2), 35);
    xhe = ihe.bb;
    JD(nDd(STd(ihe.bb), 0), 35);
    JD(nDd(STd(ihe.bb), 1), 35);
    zhe = ihe.fb;
    Ahe = JD(nDd(STd(ihe.fb), 0), 35);
    JD(nDd(STd(ihe.fb), 1), 35);
    JD(nDd(STd(ihe.fb), 2), 19);
    Che = ihe.qb;
    Fhe = JD(nDd(STd(ihe.qb), 0), 35);
    JD(nDd(STd(ihe.qb), 1), 19);
    JD(nDd(STd(ihe.qb), 2), 19);
    Dhe = JD(nDd(STd(ihe.qb), 3), 35);
    Ehe = JD(nDd(STd(ihe.qb), 4), 35);
    Hhe = JD(nDd(STd(ihe.qb), 6), 35);
    Ghe = JD(nDd(STd(ihe.qb), 5), 19);
    ohe = ihe.j;
    phe = ihe.k;
    qhe = ihe.q;
    rhe = ihe.w;
    she = ihe.B;
    the = ihe.A;
    uhe = ihe.C;
    vhe = ihe.D;
    whe = ihe._;
    yhe = ihe.cb;
    Bhe = ihe.hb;
}
function BCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    a.c = 0;
    a.b = 0;
    d = 2 * b.c.a.c.length + 1;
    o: for(l = c.Jc(); l.Ob();){
        k = JD(l.Pb(), 11);
        h = k.j == (Rjd(), xjd) || k.j == Ojd;
        n = 0;
        if (h) {
            m = JD(WMb(k, (Iqc(), sqc)), 9);
            if (!m) continue;
            n += wCc(a, d, k, m);
        } else {
            for(j = new rmb(k.g); j.a < j.c.c.length;){
                i = JD(pmb(j), 18);
                e = i.d;
                if (e.i.c == b.c) {
                    Ilb(a.a, k);
                    continue o;
                } else n += a.g[e.p];
            }
            for(g = new rmb(k.e); g.a < g.c.c.length;){
                f = JD(pmb(g), 18);
                e = f.c;
                if (e.i.c == b.c) {
                    Ilb(a.a, k);
                    continue o;
                } else n -= a.g[e.p];
            }
        }
        if (k.e.c.length + k.g.c.length > 0) {
            a.f[k.p] = n / (k.e.c.length + k.g.c.length);
            a.c = $wnd.Math.min(a.c, a.f[k.p]);
            a.b = $wnd.Math.max(a.b, a.f[k.p]);
        } else h && (a.f[k.p] = n);
    }
}
function Sie(a) {
    a.b = null;
    a.bb = null;
    a.fb = null;
    a.qb = null;
    a.a = null;
    a.c = null;
    a.d = null;
    a.e = null;
    a.f = null;
    a.n = null;
    a.M = null;
    a.L = null;
    a.Q = null;
    a.R = null;
    a.K = null;
    a.db = null;
    a.eb = null;
    a.g = null;
    a.i = null;
    a.j = null;
    a.k = null;
    a.gb = null;
    a.o = null;
    a.p = null;
    a.q = null;
    a.r = null;
    a.$ = null;
    a.ib = null;
    a.S = null;
    a.T = null;
    a.t = null;
    a.s = null;
    a.u = null;
    a.v = null;
    a.w = null;
    a.B = null;
    a.A = null;
    a.C = null;
    a.D = null;
    a.F = null;
    a.G = null;
    a.H = null;
    a.I = null;
    a.J = null;
    a.P = null;
    a.Z = null;
    a.U = null;
    a.V = null;
    a.W = null;
    a.X = null;
    a.Y = null;
    a._ = null;
    a.ab = null;
    a.cb = null;
    a.hb = null;
    a.nb = null;
    a.lb = null;
    a.mb = null;
    a.ob = null;
    a.pb = null;
    a.jb = null;
    a.kb = null;
    a.N = false;
    a.O = false;
}
function O1b(a, b, c) {
    var d, e, f, g;
    c.Sg('Graph transformation (' + a.a + ')', 1);
    g = Zu(b.a);
    for(f = new rmb(b.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        Klb(g, e.a);
    }
    d = JD(WMb(b, (Bwc(), suc)), 416);
    if (d == (Knc(), Inc)) switch(JD(WMb(b, ruc), 86).g){
        case 2:
            C1b(b, g);
            break;
        case 3:
            S1b(b, g);
            break;
        case 4:
            if (a.a == (_1b(), $1b)) {
                S1b(b, g);
                D1b(b, g);
            } else {
                D1b(b, g);
                S1b(b, g);
            }
    }
    else if (a.a == (_1b(), $1b)) switch(JD(WMb(b, ruc), 86).g){
        case 2:
            C1b(b, g);
            D1b(b, g);
            break;
        case 3:
            S1b(b, g);
            C1b(b, g);
            break;
        case 4:
            C1b(b, g);
            S1b(b, g);
    }
    else switch(JD(WMb(b, ruc), 86).g){
        case 2:
            C1b(b, g);
            D1b(b, g);
            break;
        case 3:
            C1b(b, g);
            S1b(b, g);
            break;
        case 4:
            S1b(b, g);
            C1b(b, g);
    }
    c.Tg();
}
function KQb(a) {
    var b, c, d, e, f, g, h, i;
    for(f = new rmb(a.a.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 82);
        e.b.c = e.g.c;
        e.b.d = e.g.d;
    }
    i = new Edd(Kse, Kse);
    b = new Edd(Lse, Lse);
    for(d = new rmb(a.a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 82);
        i.a = $wnd.Math.min(i.a, c.g.c);
        i.b = $wnd.Math.min(i.b, c.g.d);
        b.a = $wnd.Math.max(b.a, c.g.c + c.g.b);
        b.b = $wnd.Math.max(b.b, c.g.d + c.g.a);
    }
    for(h = Uc(a.c).a.nc(); h.Ob();){
        g = JD(h.Pb(), 47);
        c = JD(g.b, 82);
        i.a = $wnd.Math.min(i.a, c.g.c);
        i.b = $wnd.Math.min(i.b, c.g.d);
        b.a = $wnd.Math.max(b.a, c.g.c + c.g.b);
        b.b = $wnd.Math.max(b.b, c.g.d + c.g.a);
    }
    a.d = tdd(new Edd(i.a, i.b));
    a.e = Bdd(new Edd(b.a, b.b), i);
    a.a.a.c.length = 0;
    a.a.b.c.length = 0;
}
function VSb(a) {
    MSb();
    var b, c, d, e, f, g, h;
    h = new OSb;
    for(c = new rmb(a); c.a < c.c.c.length;){
        b = JD(pmb(c), 143);
        (!h.b || b.c >= h.b.c) && (h.b = b);
        if (!h.c || b.c <= h.c.c) {
            h.d = h.c;
            h.c = b;
        }
        (!h.e || b.d >= h.e.d) && (h.e = b);
        (!h.f || b.d <= h.f.d) && (h.f = b);
    }
    d = new ZSb((xSb(), tSb));
    DTb(a, KSb, new dnb(WC(OC(cP, 1), Nqe, 374, 0, [
        d
    ])));
    g = new ZSb(wSb);
    DTb(a, JSb, new dnb(WC(OC(cP, 1), Nqe, 374, 0, [
        g
    ])));
    e = new ZSb(uSb);
    DTb(a, ISb, new dnb(WC(OC(cP, 1), Nqe, 374, 0, [
        e
    ])));
    f = new ZSb(vSb);
    DTb(a, HSb, new dnb(WC(OC(cP, 1), Nqe, 374, 0, [
        f
    ])));
    PSb(d.c, tSb);
    PSb(e.c, uSb);
    PSb(f.c, vSb);
    PSb(g.c, wSb);
    h.a.c.length = 0;
    Klb(h.a, d.c);
    Klb(h.a, dv(e.c));
    Klb(h.a, f.c);
    Klb(h.a, dv(g.c));
    return h;
}
function C3c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    b.Sg($Ae, 1);
    n = Beb(MD(ksd(a, (h1c(), g1c))));
    g = Beb(MD(ksd(a, (k2c(), d2c))));
    h = JD(ksd(a, a2c), 107);
    R4c((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a));
    k = h3c((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a), n, g);
    !a.a && (a.a = new X0d(A3, a, 10, 11));
    for(j = new rmb(k); j.a < j.c.c.length;){
        i = JD(pmb(j), 186);
        for(e = new rmb(i.a); e.a < e.c.c.length;){
            d = JD(pmb(e), 172);
            m = new x4c(d.s, d.t, Beb(MD(ksd(a, d2c))));
            q4c(m, d);
            Ilb(i.d, m);
        }
    }
    l = P4c(k, g);
    o = $wnd.Math.max(l.a, Beb(MD(ksd(a, e1c))) - (h.b + h.c));
    f = $wnd.Math.max(l.b, Beb(MD(ksd(a, b1c))) - (h.d + h.a));
    c = f - l.b;
    msd(a, Y0c, c);
    msd(a, $0c, o);
    msd(a, Z0c, f + c);
    msd(a, f1c, k);
    b.Tg();
}
function M2b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    j = new wtb;
    k = new wtb;
    o = new wtb;
    p = new wtb;
    i = Beb(MD(WMb(b, (Bwc(), ewc))));
    f = Beb(MD(WMb(b, Wvc)));
    for(h = new rmb(c); h.a < h.c.c.length;){
        g = JD(pmb(h), 9);
        l = JD(WMb(g, (Iqc(), Tpc)), 64);
        if (l == (Rjd(), xjd)) {
            k.a.yc(g, k);
            for(e = new es(Ir(hYb(g).a.Jc(), new er)); cs(e);){
                d = JD(ds(e), 18);
                Nrb(j, d.c.i);
            }
        } else if (l == Ojd) {
            p.a.yc(g, p);
            for(e = new es(Ir(hYb(g).a.Jc(), new er)); cs(e);){
                d = JD(ds(e), 18);
                Nrb(o, d.c.i);
            }
        }
    }
    if (j.a.gc() != 0) {
        m = new WNc(2, f);
        n = VNc(m, b, j, k, -i - b.c.b);
        if (n > 0) {
            a.a = i + (n - 1) * f;
            b.c.b += a.a;
            b.f.b += a.a;
        }
    }
    if (o.a.gc() != 0) {
        m = new WNc(1, f);
        n = VNc(m, b, o, p, b.f.b + i - b.c.b);
        n > 0 && (b.f.b += i + (n - 1) * f);
    }
}
function $lc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    k = Beb(MD(WMb(a, (Bwc(), Zvc))));
    d = Beb(MD(WMb(a, qwc)));
    m = new Nnd;
    ZMb(m, Zvc, k + d);
    j = b;
    r = j.d;
    p = j.c.i;
    s = j.d.i;
    q = a$b(p.c);
    t = a$b(s.c);
    e = new Ulb;
    for(l = q; l <= t; l++){
        h = new tYb(a);
        rYb(h, (DYb(), yYb));
        ZMb(h, (Iqc(), kqc), j);
        ZMb(h, Evc, (ajd(), Xid));
        ZMb(h, _vc, m);
        n = JD(Mlb(a.b, l), 25);
        l == q ? pYb(h, n.a.c.length - c, n) : qYb(h, n);
        u = Beb(MD(WMb(j, Fuc)));
        if (u < 0) {
            u = 0;
            ZMb(j, Fuc, u);
        }
        h.o.b = u;
        o = $wnd.Math.floor(u / 2);
        g = new bZb;
        aZb(g, (Rjd(), Qjd));
        _Yb(g, h);
        g.n.b = o;
        i = new bZb;
        aZb(i, wjd);
        _Yb(i, h);
        i.n.b = o;
        hWb(j, g);
        f = new kWb;
        UMb(f, j);
        ZMb(f, Ruc, null);
        gWb(f, i);
        hWb(f, r);
        _lc(h, j, f);
        YCb(e.c, f);
        j = f;
    }
    return e;
}
function bLc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    p = b.b.c.length;
    if (p < 3) return;
    n = SC(cE, ise, 30, p, 15, 1);
    l = 0;
    for(k = new rmb(b.b); k.a < k.c.c.length;){
        j = JD(pmb(k), 25);
        n[l++] = j.a.c.length;
    }
    m = new Ajb(b.b, 2);
    for(d = 1; d < p - 1; d++){
        c = (rDb(m.b < m.d.gc()), JD(m.d.Xb(m.c = m.b++), 25));
        o = new rmb(c.a);
        f = 0;
        h = 0;
        for(i = 0; i < n[d + 1]; i++){
            t = JD(pmb(o), 9);
            if (i == n[d + 1] - 1 || aLc(a, t, d + 1, d)) {
                g = n[d] - 1;
                aLc(a, t, d + 1, d) && (g = a.c.e[JD(JD(JD(Mlb(a.c.b, t.p), 15).Xb(0), 47).a, 9).p]);
                while(h <= i){
                    s = JD(Mlb(c.a, h), 9);
                    if (!aLc(a, s, d + 1, d)) for(r = JD(Mlb(a.c.b, s.p), 15).Jc(); r.Ob();){
                        q = JD(r.Pb(), 47);
                        e = a.c.e[JD(q.a, 9).p];
                        (e < f || e > g) && Nrb(a.b, JD(q.b, 18));
                    }
                    ++h;
                }
                f = g;
            }
        }
    }
}
function U7b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    i = JD(oYb(a, (Rjd(), Qjd)).Jc().Pb(), 11).e;
    n = JD(oYb(a, wjd).Jc().Pb(), 11).g;
    h = i.c.length;
    t = WYb(JD(Mlb(a.j, 0), 11));
    while(h-- > 0){
        p = (sDb(0, i.c.length), JD(i.c[0], 18));
        e = (sDb(0, n.c.length), JD(n.c[0], 18));
        s = e.d.e;
        f = Nlb(s, e, 0);
        iWb(p, e.d, f);
        gWb(e, null);
        hWb(e, null);
        o = p.a;
        b && Atb(o, new Fdd(t));
        for(d = Gtb(e.a, 0); d.b != d.d.c;){
            c = JD(Utb(d), 8);
            Atb(o, new Fdd(c));
        }
        r = p.b;
        for(m = new rmb(e.b); m.a < m.c.c.length;){
            l = JD(pmb(m), 72);
            YCb(r.c, l);
        }
        q = JD(WMb(p, (Bwc(), Ruc)), 77);
        g = JD(WMb(e, Ruc), 77);
        if (g) {
            if (!q) {
                q = new Rdd;
                ZMb(p, Ruc, q);
            }
            for(k = Gtb(g, 0); k.b != k.d.c;){
                j = JD(Utb(k), 8);
                Atb(q, new Fdd(j));
            }
        }
    }
}
function Obd(b, c) {
    var d;
    if (c == null || cgb(c, Rqe)) return null;
    if (c.length == 0 && b.k != (zcd(), ucd)) return null;
    switch(b.k.g){
        case 1:
            return dgb(c, CBe) ? (xdb(), wdb) : dgb(c, DBe) ? (xdb(), vdb) : null;
        case 2:
            try {
                return jfb(Fdb(c, Lre, Hqe));
            } catch (a) {
                a = rcb(a);
                if (RD(a, 130)) return null;
                else throw scb(a);
            }
        case 4:
            try {
                return Edb(c);
            } catch (a) {
                a = rcb(a);
                if (RD(a, 130)) return null;
                else throw scb(a);
            }
        case 3:
            return c;
        case 5:
            Jbd(b);
            return Mbd(b, c);
        case 6:
            Jbd(b);
            return Nbd(b, b.a, c);
        case 7:
            try {
                d = Lbd(b);
                d.ag(c);
                return d;
            } catch (a) {
                a = rcb(a);
                if (RD(a, 32)) return null;
                else throw scb(a);
            }
        default:
            throw scb(new Web('Invalid type set for this layout option.'));
    }
}
function gGd(a) {
    var b;
    switch(a.d){
        case 1:
            if (a.Pj()) return a.o != -2;
            break;
        case 2:
            if (a.Pj()) return a.o == -2;
            break;
        case 3:
        case 5:
        case 4:
        case 6:
        case 7:
            return a.o > -2;
        default:
            return false;
    }
    b = a.Oj();
    switch(a.p){
        case 0:
            return b != null && ydb(LD(b)) != Hcb(a.k, 0);
        case 1:
            return b != null && JD(b, 219).a != Pcb(a.k) << 24 >> 24;
        case 2:
            return b != null && JD(b, 179).a != (Pcb(a.k) & Wre);
        case 6:
            return b != null && Hcb(JD(b, 190).a, a.k);
        case 5:
            return b != null && JD(b, 17).a != Pcb(a.k);
        case 7:
            return b != null && JD(b, 191).a != Pcb(a.k) << 16 >> 16;
        case 3:
            return b != null && Beb(MD(b)) != a.j;
        case 4:
            return b != null && JD(b, 160).a != a.j;
        default:
            return b == null ? a.n != null : !pb(b, a.n);
    }
}
function gXd(a, b, c) {
    var d, e, f, g;
    if (a.ll() && a.kl()) {
        g = hXd(a, JD(c, 57));
        if (XD(g) !== XD(c)) {
            a.uj(b);
            a.Aj(b, iXd(a, b, g));
            if (a.Zk()) {
                f = (e = JD(c, 52), a.jl() ? a.hl() ? e.Ph(a.b, s1d(JD(QTd(yrd(a.b), a.Ij()), 19)).n, JD(QTd(yrd(a.b), a.Ij()).Ek(), 29).hk(), null) : e.Ph(a.b, WTd(e.zh(), s1d(JD(QTd(yrd(a.b), a.Ij()), 19))), null, null) : e.Ph(a.b, -1 - a.Ij(), null, null));
                !JD(g, 52).Lh() && (f = (d = JD(g, 52), a.jl() ? a.hl() ? d.Nh(a.b, s1d(JD(QTd(yrd(a.b), a.Ij()), 19)).n, JD(QTd(yrd(a.b), a.Ij()).Ek(), 29).hk(), f) : d.Nh(a.b, WTd(d.zh(), s1d(JD(QTd(yrd(a.b), a.Ij()), 19))), null, f) : d.Nh(a.b, -1 - a.Ij(), null, f)));
                !!f && f.lj();
            }
            qqd(a.b) && a.Gj(a.Fj(9, c, g, b, false));
            return g;
        }
    }
    return c;
}
function tGb(a) {
    var b, c, d, e, f, g, h, i, j, k;
    d = new Ulb;
    for(g = new rmb(a.e.a); g.a < g.c.c.length;){
        e = JD(pmb(g), 123);
        k = 0;
        e.k.c.length = 0;
        for(c = new rmb(OFb(e)); c.a < c.c.c.length;){
            b = JD(pmb(c), 216);
            if (b.f) {
                Ilb(e.k, b);
                ++k;
            }
        }
        k == 1 && YCb(d.c, e);
    }
    for(f = new rmb(d); f.a < f.c.c.length;){
        e = JD(pmb(f), 123);
        while(e.k.c.length == 1){
            j = JD(pmb(new rmb(e.k)), 216);
            a.b[j.c] = j.g;
            h = j.d;
            i = j.e;
            for(c = new rmb(OFb(e)); c.a < c.c.c.length;){
                b = JD(pmb(c), 216);
                pb(b, j) || (b.f ? h == b.d || i == b.e ? a.b[j.c] -= a.b[b.c] - b.g : a.b[j.c] += a.b[b.c] - b.g : e == h ? b.d == e ? a.b[j.c] += b.g : a.b[j.c] -= b.g : b.d == e ? a.b[j.c] -= b.g : a.b[j.c] += b.g);
            }
            Plb(h.k, j);
            Plb(i.k, j);
            h == e ? e = j.e : e = j.d;
        }
    }
}
function GJb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    c = JD(Kqb(a.b, b), 126);
    i = JD(JD(Qc(a.r, b), 22), 83);
    if (i.dc()) {
        c.n.b = 0;
        c.n.c = 0;
        return;
    }
    j = a.u.Gc((ojd(), kjd));
    g = 0;
    h = i.Jc();
    k = null;
    l = 0;
    m = 0;
    while(h.Ob()){
        d = JD(h.Pb(), 115);
        e = Beb(MD(d.b.mf((EKb(), DKb))));
        f = d.b.Kf().a;
        a.A.Gc((ykd(), xkd)) && MJb(a, b);
        if (!k) !!a.C && a.C.b > 0 && (g = $wnd.Math.max(g, KJb(a.C.b + d.d.b, e)));
        else {
            n = m + k.d.c + a.w + d.d.b;
            g = $wnd.Math.max(g, (Ry(), Vy(fue), $wnd.Math.abs(l - e) <= fue || l == e || isNaN(l) && isNaN(e) ? 0 : n / (e - l)));
        }
        k = d;
        l = e;
        m = f;
    }
    if (!!a.C && a.C.c > 0) {
        n = m + a.C.c;
        j && (n += k.d.c);
        g = $wnd.Math.max(g, (Ry(), Vy(fue), $wnd.Math.abs(l - 1) <= fue || l == 1 || isNaN(l) && isNaN(1) ? 0 : n / (1 - l)));
    }
    c.n.b = 0;
    c.a.a = g;
}
function PKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    c = JD(Kqb(a.b, b), 126);
    i = JD(JD(Qc(a.r, b), 22), 83);
    if (i.dc()) {
        c.n.d = 0;
        c.n.a = 0;
        return;
    }
    j = a.u.Gc((ojd(), kjd));
    g = 0;
    a.A.Gc((ykd(), xkd)) && UKb(a, b);
    h = i.Jc();
    k = null;
    m = 0;
    l = 0;
    while(h.Ob()){
        d = JD(h.Pb(), 115);
        f = Beb(MD(d.b.mf((EKb(), DKb))));
        e = d.b.Kf().b;
        if (!k) !!a.C && a.C.d > 0 && (g = $wnd.Math.max(g, KJb(a.C.d + d.d.d, f)));
        else {
            n = l + k.d.a + a.w + d.d.d;
            g = $wnd.Math.max(g, (Ry(), Vy(fue), $wnd.Math.abs(m - f) <= fue || m == f || isNaN(m) && isNaN(f) ? 0 : n / (f - m)));
        }
        k = d;
        m = f;
        l = e;
    }
    if (!!a.C && a.C.a > 0) {
        n = l + a.C.a;
        j && (n += k.d.a);
        g = $wnd.Math.max(g, (Ry(), Vy(fue), $wnd.Math.abs(m - 1) <= fue || m == 1 || isNaN(m) && isNaN(1) ? 0 : n / (1 - m)));
    }
    c.n.d = 0;
    c.a.b = g;
}
function CDc(a, b, c) {
    var d, e, f, g, h, i;
    this.g = a;
    h = b.d.length;
    i = c.d.length;
    this.d = SC(RP, Jve, 9, h + i, 0, 1);
    for(g = 0; g < h; g++)this.d[g] = b.d[g];
    for(f = 0; f < i; f++)this.d[h + f] = c.d[f];
    if (b.e) {
        this.e = cv(b.e);
        this.e.Kc(c);
        if (c.e) for(e = c.e.Jc(); e.Ob();){
            d = JD(e.Pb(), 238);
            if (d == b) continue;
            else this.e.Gc(d) ? --d.c : this.e.Ec(d);
        }
    } else if (c.e) {
        this.e = cv(c.e);
        this.e.Kc(b);
    }
    this.f = b.f + c.f;
    this.a = b.a + c.a;
    this.a > 0 ? ADc(this, this.f / this.a) : sDc(b.g, b.d[0]).a != null && sDc(c.g, c.d[0]).a != null ? ADc(this, (Beb(sDc(b.g, b.d[0]).a) + Beb(sDc(c.g, c.d[0]).a)) / 2) : sDc(b.g, b.d[0]).a != null ? ADc(this, sDc(b.g, b.d[0]).a) : sDc(c.g, c.d[0]).a != null && ADc(this, sDc(c.g, c.d[0]).a);
}
function $2c(a, b, c, d, e, f, g, h) {
    var i, j, k, l, m, n, o, p, q, r;
    o = false;
    j = t4c(c.q, b.f + b.b - c.q.f);
    n = d.f > b.b && h;
    r = e - (c.q.e + j - g);
    l = (i = g4c(d, r, false), i.a);
    if (n && l > d.f) return false;
    if (n) {
        m = 0;
        for(q = new rmb(b.d); q.a < q.c.c.length;){
            p = JD(pmb(q), 316);
            m += t4c(p, d.f) + g;
        }
        r = e - m;
    }
    if (r < d.g) return false;
    k = f == a.c.length - 1 && r >= (sDb(f, a.c.length), JD(a.c[f], 186)).e;
    if (!n && l > b.b && !k) return false;
    if (k || n || l <= b.b) {
        if (k && l > b.b) {
            c.d = l;
            e4c(c, d4c(c, l));
        } else {
            u4c(c.q, j);
            c.c = true;
        }
        e4c(d, e - (c.s + c.r));
        i4c(d, c.q.e + c.q.d, b.f);
        S4c(b, d);
        if (a.c.length > f) {
            V4c((sDb(f, a.c.length), JD(a.c[f], 186)), d);
            (sDb(f, a.c.length), JD(a.c[f], 186)).a.c.length == 0 && Olb(a, f);
        }
        o = true;
    }
    return o;
}
function NQb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    a.a = new pRb(lrb(i2));
    for(d = new rmb(b.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 834);
        h = new sRb(WC(OC(JO, 1), Nqe, 82, 0, []));
        Ilb(a.a.a, h);
        for(j = new rmb(c.d); j.a < j.c.c.length;){
            i = JD(pmb(j), 119);
            k = new SQb(a, i);
            MQb(k, JD(WMb(c.c, (Iqc(), Qpc)), 22));
            if (!Lib(a.g, c)) {
                Qib(a.g, c, new Edd(i.c, i.d));
                Qib(a.f, c, k);
            }
            Ilb(a.a.b, k);
            qRb(h, k);
        }
        for(g = new rmb(c.b); g.a < g.c.c.length;){
            f = JD(pmb(g), 586);
            k = new SQb(a, f.Bf());
            Qib(a.b, f, new xod(h, k));
            MQb(k, JD(WMb(c.c, (Iqc(), Qpc)), 22));
            if (f.zf()) {
                l = new TQb(a, f.zf(), 1);
                MQb(l, JD(WMb(c.c, Qpc), 22));
                e = new sRb(WC(OC(JO, 1), Nqe, 82, 0, []));
                qRb(e, l);
                Rc(a.c, f.yf(), new xod(h, l));
            }
        }
    }
    return a.a;
}
function Ube(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    g = c.Ik();
    if (RD(g, 101) && (JD(g, 19).Bb & Pse) != 0) {
        m = JD(c.kd(), 52);
        p = zqd(a.e, m);
        if (p != m) {
            k = Jfe(g, p);
            jDd(a, b, mce(a, b, k));
            l = null;
            if (qqd(a.e)) {
                d = Z9d((Gfe(), Efe), a.e.zh(), g);
                if (d != QTd(a.e.zh(), a.c)) {
                    q = Kfe(a.e.zh(), g);
                    h = 0;
                    f = JD(a.g, 122);
                    for(i = 0; i < b; ++i){
                        e = f[i];
                        q.Zl(e.Ik()) && ++h;
                    }
                    l = new Gge(a.e, 9, d, m, p, h, false);
                    l.kj(new i_d(a.e, 9, a.c, c, k, b, false));
                }
            }
            o = JD(g, 19);
            n = s1d(o);
            if (n) {
                l = m.Ph(a.e, WTd(m.zh(), n), null, l);
                l = JD(p, 52).Nh(a.e, WTd(p.zh(), n), null, l);
            } else if ((o.Bb & RCe) != 0) {
                j = -1 - WTd(a.e.zh(), o);
                l = m.Ph(a.e, j, null, null);
                !JD(p, 52).Lh() && (l = JD(p, 52).Nh(a.e, j, null, l));
            }
            !!l && l.lj();
            return k;
        }
    }
    return c;
}
function jzc(a) {
    var b;
    this.a = a;
    b = (DYb(), WC(OC(PP, 1), Ere, 247, 0, [
        AYb,
        yYb,
        wYb,
        BYb,
        xYb,
        vYb,
        CYb,
        zYb
    ])).length;
    this.b = QC(N4, [
        hre,
        dze
    ], [
        585,
        144
    ], 0, [
        b,
        b
    ], 2);
    this.c = QC(N4, [
        hre,
        dze
    ], [
        585,
        144
    ], 0, [
        b,
        b
    ], 2);
    izc(this, AYb, (Bwc(), ewc), fwc);
    gzc(this, AYb, yYb, Zvc, $vc);
    fzc(this, AYb, BYb, Zvc);
    fzc(this, AYb, wYb, Zvc);
    gzc(this, AYb, xYb, ewc, fwc);
    izc(this, yYb, Wvc, Xvc);
    fzc(this, yYb, BYb, Wvc);
    fzc(this, yYb, wYb, Wvc);
    gzc(this, yYb, xYb, Zvc, $vc);
    hzc(this, BYb, Wvc);
    fzc(this, BYb, wYb, Wvc);
    fzc(this, BYb, xYb, bwc);
    hzc(this, wYb, iwc);
    gzc(this, wYb, xYb, dwc, cwc);
    izc(this, xYb, Wvc, Wvc);
    izc(this, vYb, Wvc, Xvc);
    gzc(this, vYb, AYb, Zvc, $vc);
    gzc(this, vYb, xYb, Zvc, $vc);
    gzc(this, vYb, yYb, Zvc, $vc);
}
function bOd(a, b, c, d, e, f) {
    var g;
    if (!(b == null || !HNd(b, sNd, tNd))) throw scb(new Teb('invalid scheme: ' + b));
    if (!a && !(c != null && hgb(c, wgb(35)) == -1 && c.length > 0 && (ADb(0, c.length), c.charCodeAt(0) != 47))) throw scb(new Teb('invalid opaquePart: ' + c));
    if (a && !(b != null && kob(zNd, b.toLowerCase())) && !(c == null || !HNd(c, vNd, wNd))) throw scb(new Teb(PEe + c));
    if (a && b != null && kob(zNd, b.toLowerCase()) && !ZNd(c)) throw scb(new Teb(PEe + c));
    if (!$Nd(d)) throw scb(new Teb('invalid device: ' + d));
    if (!aOd(e)) {
        g = e == null ? 'invalid segments: null' : 'invalid segment: ' + ONd(e);
        throw scb(new Teb(g));
    }
    if (!(f == null || hgb(f, wgb(35)) == -1)) throw scb(new Teb('invalid query: ' + f));
}
function BXb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    m = new Fdd(a.o);
    r = b.a / m.a;
    h = b.b / m.b;
    p = b.a - m.a;
    f = b.b - m.b;
    if (c) {
        e = XD(WMb(a, (Bwc(), Evc))) === XD((ajd(), Xid));
        for(o = new rmb(a.j); o.a < o.c.c.length;){
            n = JD(pmb(o), 11);
            switch(n.j.g){
                case 1:
                    e || (n.n.a *= r);
                    break;
                case 2:
                    n.n.a += p;
                    e || (n.n.b *= h);
                    break;
                case 3:
                    e || (n.n.a *= r);
                    n.n.b += f;
                    break;
                case 4:
                    e || (n.n.b *= h);
            }
        }
    }
    for(j = new rmb(a.b); j.a < j.c.c.length;){
        i = JD(pmb(j), 72);
        k = i.n.a + i.o.a / 2;
        l = i.n.b + i.o.b / 2;
        q = k / m.a;
        g = l / m.b;
        if (q + g >= 1) {
            if (q - g > 0 && l >= 0) {
                i.n.a += p;
                i.n.b += f * g;
            } else if (q - g < 0 && k >= 0) {
                i.n.a += p * q;
                i.n.b += f;
            }
        }
    }
    a.o.a = b.a;
    a.o.b = b.b;
    ZMb(a, (Bwc(), ovc), (ykd(), d = JD(deb(z2), 10), new urb(d, JD(VCb(d, d.length), 10), 0)));
}
function ZBc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    c.Sg('Network simplex layering', 1);
    a.b = b;
    r = JD(WMb(b, (Bwc(), jwc)), 17).a * 4;
    q = a.b.a;
    if (q.c.length < 1) {
        c.Tg();
        return;
    }
    f = VBc(a, q);
    p = null;
    for(e = Gtb(f, 0); e.b != e.d.c;){
        d = JD(Utb(e), 15);
        h = r * YD($wnd.Math.sqrt(d.gc()));
        g = YBc(d);
        wGb(JGb(LGb(KGb(NGb(g), h), p), true), c.bh(1));
        m = a.b.b;
        for(o = new rmb(g.a); o.a < o.c.c.length;){
            n = JD(pmb(o), 123);
            while(m.c.length <= n.e)Hlb(m, m.c.length, new b$b(a.b));
            k = JD(n.f, 9);
            qYb(k, JD(Mlb(m, n.e), 25));
        }
        if (f.b > 1) {
            p = SC(cE, ise, 30, a.b.b.c.length, 15, 1);
            l = 0;
            for(j = new rmb(a.b.b); j.a < j.c.c.length;){
                i = JD(pmb(j), 25);
                p[l++] = i.a.c.length;
            }
        }
    }
    q.c.length = 0;
    a.a = null;
    a.b = null;
    a.c = null;
    c.Tg();
}
function wGc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = new Ulb;
    l = new nlb;
    f = null;
    e = 0;
    for(d = 0; d < b.length; ++d){
        c = b[d];
        yGc(f, c) && (e = rGc(a, l, k, fGc, e));
        XMb(c, (Iqc(), _pc)) && (f = JD(WMb(c, _pc), 9));
        switch(c.k.g){
            case 0:
                for(i = hr(_q(lYb(c, (Rjd(), xjd)), new hHc)); xc(i);){
                    g = JD(yc(i), 11);
                    a.d[g.p] = e++;
                    YCb(k.c, g);
                }
                e = rGc(a, l, k, fGc, e);
                for(j = hr(_q(lYb(c, Ojd), new hHc)); xc(j);){
                    g = JD(yc(j), 11);
                    a.d[g.p] = e++;
                    YCb(k.c, g);
                }
                break;
            case 3:
                if (!lYb(c, eGc).dc()) {
                    g = JD(lYb(c, eGc).Xb(0), 11);
                    a.d[g.p] = e++;
                    YCb(k.c, g);
                }
                lYb(c, fGc).dc() || $kb(l, c);
                break;
            case 1:
                for(h = lYb(c, (Rjd(), Qjd)).Jc(); h.Ob();){
                    g = JD(h.Pb(), 11);
                    a.d[g.p] = e++;
                    YCb(k.c, g);
                }
                lYb(c, wjd).Ic(new fHc(l, c));
        }
    }
    rGc(a, l, k, fGc, e);
    return k;
}
function Kad(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if (b == null || b.length == 0) return null;
    f = JD(Oib(a.f, b), 21);
    if (!f) {
        for(e = (n = new Zjb(a.d).a.vc().Jc(), new ckb(n)); e.a.Ob();){
            c = (g = JD(e.a.Pb(), 43), JD(g.kd(), 21));
            h = c.f;
            o = b.length;
            if (cgb(h.substr(h.length - o, o), b) && (b.length == h.length || _fb(h, h.length - b.length - 1) == 46)) {
                if (f) return null;
                f = c;
            }
        }
        if (!f) for(d = (m = new Zjb(a.d).a.vc().Jc(), new ckb(m)); d.a.Ob();){
            c = (g = JD(d.a.Pb(), 43), JD(g.kd(), 21));
            l = c.g;
            if (l != null) for(i = l, j = 0, k = i.length; j < k; ++j){
                h = i[j];
                o = b.length;
                if (cgb(h.substr(h.length - o, o), b) && (b.length == h.length || _fb(h, h.length - b.length - 1) == 46)) {
                    if (f) return null;
                    f = c;
                }
            }
        }
        !!f && Rib(a.f, b, f);
    }
    return f;
}
function AA(a, b) {
    var c, d, e, f, g;
    c = new Vgb;
    g = false;
    for(f = 0; f < b.length; f++){
        d = (ADb(f, b.length), b.charCodeAt(f));
        if (d == 32) {
            oA(a, c, 0);
            c.a += ' ';
            oA(a, c, 0);
            while(f + 1 < b.length && (ADb(f + 1, b.length), b.charCodeAt(f + 1) == 32))++f;
            continue;
        }
        if (g) {
            if (d == 39) {
                if (f + 1 < b.length && (ADb(f + 1, b.length), b.charCodeAt(f + 1) == 39)) {
                    c.a += String.fromCharCode(d);
                    ++f;
                } else g = false;
            } else c.a += String.fromCharCode(d);
            continue;
        }
        if (hgb('GyMLdkHmsSEcDahKzZv', wgb(d)) > 0) {
            oA(a, c, 0);
            c.a += String.fromCharCode(d);
            e = tA(b, f);
            oA(a, c, e);
            f += e - 1;
            continue;
        }
        if (d == 39) {
            if (f + 1 < b.length && (ADb(f + 1, b.length), b.charCodeAt(f + 1) == 39)) {
                c.a += "'";
                ++f;
            } else g = true;
        } else c.a += String.fromCharCode(d);
    }
    oA(a, c, 0);
    uA(a);
}
function wMc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    t = Ux(a);
    i = new Ulb;
    f = a.c.length;
    j = f - 1;
    k = f + 1;
    while(t.a.gc() != 0){
        while(c.b != 0){
            r = (rDb(c.b != 0), JD(Ktb(c, c.a.a), 116));
            t.a.Ac(r);
            r.g = j--;
            zMc(r, b, c, d);
        }
        while(b.b != 0){
            s = (rDb(b.b != 0), JD(Ktb(b, b.a.a), 116));
            t.a.Ac(s);
            s.g = k++;
            zMc(s, b, c, d);
        }
        h = Lre;
        for(p = t.a.ec().Jc(); p.Ob();){
            o = JD(p.Pb(), 116);
            if (!d && o.b > 0 && o.a <= 0) {
                i.c.length = 0;
                YCb(i.c, o);
                break;
            }
            n = o.i - o.d;
            if (n >= h) {
                if (n > h) {
                    i.c.length = 0;
                    h = n;
                }
                YCb(i.c, o);
            }
        }
        if (i.c.length != 0) {
            g = JD(Mlb(i, xvb(e, i.c.length)), 116);
            t.a.Ac(g);
            g.g = k++;
            zMc(g, b, c, d);
            i.c.length = 0;
        }
    }
    q = a.c.length + 1;
    for(m = new rmb(a); m.a < m.c.c.length;){
        l = JD(pmb(m), 116);
        l.g < f && (l.g = l.g + q);
    }
}
function IDc(a, b, c) {
    var d, e, f, g;
    this.j = a;
    this.e = mWb(a);
    this.o = this.j.e;
    this.i = !!this.o;
    this.p = this.i ? JD(Mlb(c, gYb(this.o).p), 217) : null;
    e = JD(WMb(a, (Iqc(), Wpc)), 22);
    this.g = e.Gc(($oc(), Toc));
    this.b = new Ulb;
    this.d = new UFc(this.e);
    g = JD(WMb(this.j, vqc), 233);
    this.q = ZDc(b, g, this.e);
    this.k = new cFc(this);
    f = _u(WC(OC(EX, 1), Nqe, 229, 0, [
        this,
        this.d,
        this.k,
        this.q
    ]));
    if (b == (UEc(), REc) && !ydb(LD(WMb(a, (Bwc(), euc))))) {
        d = new tDc(this.e);
        YCb(f.c, d);
        this.c = new XCc(d, g, JD(this.q, 402));
    } else if (b == REc && ydb(LD(WMb(a, (Bwc(), euc))))) {
        d = new tDc(this.e);
        YCb(f.c, d);
        this.c = new yFc(d, g, JD(this.q, 402));
    } else this.c = new Rfc(b, this);
    Ilb(f, this.c);
    BHc(f, this.e);
    this.s = bFc(this.k);
}
function RKc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    for(e = new rmb(a.a.b); e.a < e.c.c.length;){
        c = JD(pmb(e), 25);
        for(i = new rmb(c.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            b.j[h.p] = h;
            b.i[h.p] = b.o == (HKc(), GKc) ? Lse : Kse;
        }
    }
    Tib(a.c);
    g = a.a.b;
    b.c == (zKc(), xKc) && (g = dv(g));
    vLc(a.e, b, a.b);
    Dmb(b.p, null);
    for(f = g.Jc(); f.Ob();){
        c = JD(f.Pb(), 25);
        j = c.a;
        b.o == (HKc(), GKc) && (j = dv(j));
        for(m = j.Jc(); m.Ob();){
            l = JD(m.Pb(), 9);
            b.g[l.p] == l && SKc(a, l, b);
        }
    }
    TKc(a, b);
    for(d = g.Jc(); d.Ob();){
        c = JD(d.Pb(), 25);
        for(m = new rmb(c.a); m.a < m.c.c.length;){
            l = JD(pmb(m), 9);
            b.p[l.p] = b.p[b.g[l.p].p];
            if (l == b.g[l.p]) {
                k = Beb(b.i[b.j[l.p].p]);
                (b.o == (HKc(), GKc) && k > Lse || b.o == FKc && k < Kse) && (b.p[l.p] = Beb(b.p[l.p]) + k);
            }
        }
    }
    a.e.vg();
}
function KVb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (!ydb(LD(WMb(c, (Bwc(), Nuc))))) return;
    for(h = new rmb(c.j); h.a < h.c.c.length;){
        g = JD(pmb(h), 11);
        m = CXb(g.g);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            f = i.d.i == c;
            e = f && ydb(LD(WMb(i, Ouc)));
            if (e) {
                o = i.c;
                n = JD(Nib(a.b, o), 9);
                if (!n) {
                    n = pXb(o, (ajd(), $id), o.j, -1, null, null, o.o, JD(WMb(b, ruc), 86), b);
                    ZMb(n, (Iqc(), kqc), o);
                    Qib(a.b, o, n);
                    Ilb(b.a, n);
                }
                q = i.d;
                p = JD(Nib(a.b, q), 9);
                if (!p) {
                    p = pXb(q, (ajd(), $id), q.j, 1, null, null, q.o, JD(WMb(b, ruc), 86), b);
                    ZMb(p, (Iqc(), kqc), q);
                    Qib(a.b, q, p);
                    Ilb(b.a, p);
                }
                d = CVb(i);
                gWb(d, JD(Mlb(n.j, 0), 11));
                hWb(d, JD(Mlb(p.j, 0), 11));
                Rc(a.a, i, new TVb(d, b, (Eyc(), Cyc)));
                JD(WMb(b, (Iqc(), Wpc)), 22).Ec(($oc(), Toc));
            }
        }
    }
}
function JVb(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q;
    f = new Ulb;
    for(j = new rmb(d); j.a < j.c.c.length;){
        h = JD(pmb(j), 441);
        g = null;
        if (h.f == (Eyc(), Cyc)) for(o = new rmb(h.e); o.a < o.c.c.length;){
            n = JD(pmb(o), 18);
            q = n.d.i;
            if (gYb(q) == b) AVb(a, b, h, n, h.b, n.d);
            else if (!c || xXb(q, c)) BVb(a, b, h, d, n);
            else {
                m = GVb(a, b, c, n, h.b, Cyc, g);
                m != g && YCb(f.c, m);
                m.c && (g = m);
            }
        }
        else for(l = new rmb(h.e); l.a < l.c.c.length;){
            k = JD(pmb(l), 18);
            p = k.c.i;
            if (gYb(p) == b) AVb(a, b, h, k, k.c, h.b);
            else if (!c || xXb(p, c)) continue;
            else {
                m = GVb(a, b, c, k, h.b, Byc, g);
                m != g && YCb(f.c, m);
                m.c && (g = m);
            }
        }
    }
    for(i = new rmb(f); i.a < i.c.c.length;){
        h = JD(pmb(i), 441);
        Nlb(b.a, h.a, 0) != -1 || Ilb(b.a, h.a);
        h.c && YCb(e.c, h);
    }
}
function RPc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    e = JD(WMb(a, (tUc(), kUc)), 27);
    j = Hqe;
    k = Hqe;
    h = Lre;
    i = Lre;
    for(t = Gtb(a.b, 0); t.b != t.d.c;){
        r = JD(Utb(t), 39);
        n = r.e;
        o = r.f;
        j = $wnd.Math.min(j, n.a - o.a / 2);
        k = $wnd.Math.min(k, n.b - o.b / 2);
        h = $wnd.Math.max(h, n.a + o.a / 2);
        i = $wnd.Math.max(i, n.b + o.b / 2);
    }
    m = JD(ksd(e, (kVc(), WUc)), 107);
    for(s = Gtb(a.b, 0); s.b != s.d.c;){
        r = JD(Utb(s), 39);
        l = WMb(r, kUc);
        if (RD(l, 206)) {
            f = JD(l, 27);
            ftd(f, r.e.a, r.e.b);
            dsd(f, r);
        }
    }
    for(q = Gtb(a.a, 0); q.b != q.d.c;){
        p = JD(Utb(q), 65);
        d = JD(WMb(p, kUc), 85);
        if (d) {
            b = p.a;
            c = hCd(d);
            Vmd(b, c);
        }
    }
    u = h - j + (m.b + m.c);
    g = i - k + (m.d + m.a);
    ydb(LD(ksd(e, (Lgd(), Dfd)))) || mnd(e, u, g, false, false);
    msd(e, Ved, u - (m.b + m.c));
    msd(e, Ued, g - (m.d + m.a));
}
function $Qb(a) {
    var b, c, d, e, f, g, h;
    b = 0;
    for(f = new rmb(a.b.a); f.a < f.c.c.length;){
        d = JD(pmb(f), 194);
        d.b = 0;
        d.c = 0;
    }
    ZQb(a, 0);
    YQb(a, a.g);
    ERb(a.c);
    IRb(a.c);
    c = (Tgd(), Pgd);
    GRb(ARb(FRb(GRb(ARb(FRb(GRb(FRb(a.c, c)), Wgd(c)))), c)));
    FRb(a.c, Pgd);
    bRb(a, a.g);
    cRb(a, 0);
    dRb(a, 0);
    eRb(a, 1);
    ZQb(a, 1);
    YQb(a, a.d);
    ERb(a.c);
    for(g = new rmb(a.b.a); g.a < g.c.c.length;){
        d = JD(pmb(g), 194);
        b += $wnd.Math.abs(d.c);
    }
    for(h = new rmb(a.b.a); h.a < h.c.c.length;){
        d = JD(pmb(h), 194);
        d.b = 0;
        d.c = 0;
    }
    c = Sgd;
    GRb(ARb(FRb(GRb(ARb(FRb(GRb(IRb(FRb(a.c, c))), Wgd(c)))), c)));
    FRb(a.c, Pgd);
    bRb(a, a.d);
    cRb(a, 1);
    dRb(a, 1);
    eRb(a, 0);
    IRb(a.c);
    for(e = new rmb(a.b.a); e.a < e.c.c.length;){
        d = JD(pmb(e), 194);
        b += $wnd.Math.abs(d.c);
    }
    return b;
}
function N2b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    c = JD(WMb(a, (Bwc(), Evc)), 100);
    g = a.f;
    f = a.d;
    h = g.a + f.b + f.c;
    i = 0 - f.d - a.c.b;
    k = g.b + f.d + f.a - a.c.b;
    j = new Ulb;
    l = new Ulb;
    for(e = new rmb(b); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        switch(c.g){
            case 1:
            case 2:
            case 3:
                D2b(d);
                break;
            case 4:
                m = JD(WMb(d, Cvc), 8);
                n = !m ? 0 : m.a;
                d.n.a = h * Beb(MD(WMb(d, (Iqc(), tqc)))) - n;
                cYb(d, true, false);
                break;
            case 5:
                o = JD(WMb(d, Cvc), 8);
                p = !o ? 0 : o.a;
                d.n.a = Beb(MD(WMb(d, (Iqc(), tqc)))) - p;
                cYb(d, true, false);
                g.a = $wnd.Math.max(g.a, d.n.a + d.o.a / 2);
        }
        switch(JD(WMb(d, (Iqc(), Tpc)), 64).g){
            case 1:
                d.n.b = i;
                YCb(j.c, d);
                break;
            case 3:
                d.n.b = k;
                YCb(l.c, d);
        }
    }
    switch(c.g){
        case 1:
        case 2:
            F2b(j, a);
            F2b(l, a);
            break;
        case 3:
            L2b(j, a);
            L2b(l, a);
    }
}
function y6b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    c.Sg('Label dummy switching', 1);
    d = JD(WMb(b, (Bwc(), uuc)), 231);
    l6b(b);
    e = v6b(b, d);
    a.a = SC(aE, Rse, 30, b.b.c.length, 15, 1);
    for(h = (Nmc(), WC(OC(MV, 1), Ere, 231, 0, [
        Jmc,
        Lmc,
        Imc,
        Kmc,
        Mmc,
        Hmc
    ])), k = 0, n = h.length; k < n; ++k){
        f = h[k];
        if ((f == Mmc || f == Hmc || f == Kmc) && !JD(rrb(e.a, f) ? e.b[f.g] : null, 15).dc()) {
            o6b(a, b);
            break;
        }
    }
    for(i = WC(OC(MV, 1), Ere, 231, 0, [
        Jmc,
        Lmc,
        Imc,
        Kmc,
        Mmc,
        Hmc
    ]), l = 0, o = i.length; l < o; ++l){
        f = i[l];
        f == Mmc || f == Hmc || f == Kmc || z6b(a, JD(rrb(e.a, f) ? e.b[f.g] : null, 15));
    }
    for(g = WC(OC(MV, 1), Ere, 231, 0, [
        Jmc,
        Lmc,
        Imc,
        Kmc,
        Mmc,
        Hmc
    ]), j = 0, m = g.length; j < m; ++j){
        f = g[j];
        (f == Mmc || f == Hmc || f == Kmc) && z6b(a, JD(rrb(e.a, f) ? e.b[f.g] : null, 15));
    }
    a.a = null;
    c.Tg();
}
function Ooe(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = b;
    if (j.b == null || a.b == null) return;
    Qoe(a);
    Noe(a);
    Qoe(j);
    Noe(j);
    c = SC(cE, ise, 30, a.b.length + j.b.length, 15, 1);
    k = 0;
    d = 0;
    g = 0;
    while(d < a.b.length && g < j.b.length){
        e = a.b[d];
        f = a.b[d + 1];
        h = j.b[g];
        i = j.b[g + 1];
        if (f < h) d += 2;
        else if (f >= h && e <= i) {
            if (h <= e && f <= i) {
                c[k++] = e;
                c[k++] = f;
                d += 2;
            } else if (h <= e) {
                c[k++] = e;
                c[k++] = i;
                a.b[d] = i + 1;
                g += 2;
            } else if (f <= i) {
                c[k++] = h;
                c[k++] = f;
                d += 2;
            } else {
                c[k++] = h;
                c[k++] = i;
                a.b[d] = i + 1;
            }
        } else if (i < e) g += 2;
        else throw scb(new qz('Token#intersectRanges(): Internal Error: [' + a.b[d] + ',' + a.b[d + 1] + '] & [' + j.b[g] + ',' + j.b[g + 1] + ']'));
    }
    while(d < a.b.length){
        c[k++] = a.b[d++];
        c[k++] = a.b[d++];
    }
    a.b = SC(cE, ise, 30, k, 15, 1);
    $gb(c, 0, a.b, 0, k);
}
function _Qb(a) {
    var b, c, d, e, f, g, h;
    b = new Ulb;
    a.g = new Ulb;
    a.d = new Ulb;
    for(g = new mjb(new djb(a.f.b).a); g.b;){
        f = kjb(g);
        Ilb(b, JD(JD(f.kd(), 47).b, 82));
        Ugd(JD(f.jd(), 586).yf()) ? Ilb(a.d, JD(f.kd(), 47)) : Ilb(a.g, JD(f.kd(), 47));
    }
    YQb(a, a.d);
    YQb(a, a.g);
    a.c = new ORb(a.b);
    MRb(a.c, (JQb(), IQb));
    bRb(a, a.d);
    bRb(a, a.g);
    Klb(b, a.c.a.b);
    a.e = new Edd(Kse, Kse);
    a.a = new Edd(Lse, Lse);
    for(d = new rmb(b); d.a < d.c.c.length;){
        c = JD(pmb(d), 82);
        a.e.a = $wnd.Math.min(a.e.a, c.g.c);
        a.e.b = $wnd.Math.min(a.e.b, c.g.d);
        a.a.a = $wnd.Math.max(a.a.a, c.g.c + c.g.b);
        a.a.b = $wnd.Math.max(a.a.b, c.g.d + c.g.a);
    }
    LRb(a.c, new iRb);
    h = 0;
    do {
        e = $Qb(a);
        ++h;
    }while ((h < 2 || e > Kre) && h < 10);
    LRb(a.c, new lRb);
    $Qb(a);
    HRb(a.c);
    KQb(a.f);
}
function bEc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    switch(a.k.g){
        case 1:
            d = JD(WMb(a, (Iqc(), kqc)), 18);
            c = JD(WMb(d, lqc), 77);
            !c ? c = new Rdd : ydb(LD(WMb(d, xqc))) && (c = Vdd(c));
            j = JD(WMb(a, fqc), 11);
            if (j) {
                k = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    j.i.n,
                    j.n,
                    j.a
                ]));
                if (b <= k.a) return k.b;
                Dtb(c, k, c.a, c.a.a);
            }
            l = JD(WMb(a, gqc), 11);
            if (l) {
                m = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    l.i.n,
                    l.n,
                    l.a
                ]));
                if (m.a <= b) return m.b;
                Dtb(c, m, c.c.b, c.c);
            }
            if (c.b >= 2) {
                i = Gtb(c, 0);
                g = JD(Utb(i), 8);
                h = JD(Utb(i), 8);
                while(h.a < b && i.b != i.d.c){
                    g = h;
                    h = JD(Utb(i), 8);
                }
                return g.b + (b - g.a) / (h.a - g.a) * (h.b - g.b);
            }
            break;
        case 3:
            f = JD(WMb(JD(Mlb(a.j, 0), 11), (Iqc(), kqc)), 11);
            e = f.i;
            switch(f.j.g){
                case 1:
                    return e.n.b;
                case 3:
                    return e.n.b + e.o.b;
            }
    }
    return jYb(a).b;
}
function Qdc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    for(g = new rmb(a.d.b); g.a < g.c.c.length;){
        f = JD(pmb(g), 25);
        for(i = new rmb(f.a); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            if (ydb(LD(WMb(h, (Bwc(), Utc))))) {
                if (!cr(eYb(h))) {
                    d = JD(ar(eYb(h)), 18);
                    k = d.c.i;
                    k == h && (k = d.d.i);
                    l = new xod(k, Bdd(odd(h.n), k.n));
                    Qib(a.b, h, l);
                    continue;
                }
            }
            e = new gdd(h.n.a - h.d.b, h.n.b - h.d.d, h.o.a + h.d.b + h.d.c, h.o.b + h.d.d + h.d.a);
            b = lEb(oEb(mEb(nEb(new pEb, h), e), ydc), a.a);
            fEb(gEb(hEb(new iEb, WC(OC(LM, 1), Nqe, 60, 0, [
                b
            ])), b), a.a);
            j = new bFb;
            Qib(a.e, b, j);
            c = Gr(new es(Ir(hYb(h).a.Jc(), new er))) - Gr(new es(Ir(kYb(h).a.Jc(), new er)));
            c < 0 ? _Eb(j, true, (Tgd(), Pgd)) : c > 0 && _Eb(j, true, (Tgd(), Qgd));
            h.k == (DYb(), wYb) && aFb(j);
            Qib(a.f, h, b);
        }
    }
}
function Y4c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    j = Kse;
    k = Kse;
    h = Lse;
    i = Lse;
    for(m = new rmb(b.i); m.a < m.c.c.length;){
        l = JD(pmb(m), 68);
        e = JD(JD(Nib(a.g, l.a), 47).b, 27);
        ftd(e, l.b.c, l.b.d);
        j = $wnd.Math.min(j, e.i);
        k = $wnd.Math.min(k, e.j);
        h = $wnd.Math.max(h, e.i + e.g);
        i = $wnd.Math.max(i, e.j + e.f);
    }
    n = JD(ksd(a.c, (D6c(), u6c)), 107);
    mnd(a.c, h - j + (n.b + n.c), i - k + (n.d + n.a), true, true);
    qnd(a.c, -j + n.b, -k + n.d);
    for(d = new CHd(Ywd(a.c)); d.e != d.i.gc();){
        c = JD(AHd(d), 85);
        g = hCd(c);
        o = iCd(c);
        q = jCd(c);
        p = new Edd(o.i + o.g / 2, o.j + o.f / 2);
        f = new Edd(q.i + q.g / 2, q.j + q.f / 2);
        r = Bdd(new Edd(f.a, f.b), p);
        Lcd(r, o.g, o.f);
        mdd(p, r);
        s = Bdd(new Edd(p.a, p.b), f);
        Lcd(s, q.g, q.f);
        mdd(f, s);
        pud(g, p.a, p.b);
        iud(g, f.a, f.b);
    }
}
function h8b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    i = true;
    e = 0;
    j = a.g[b.p];
    k = b.o.b + a.o;
    c = a.d[b.p][2];
    Rlb(a.b, j, jfb(JD(Mlb(a.b, j), 17).a - 1 + c));
    Rlb(a.c, j, Beb(MD(Mlb(a.c, j))) - k + c * a.f);
    ++j;
    if (j >= a.j) {
        ++a.j;
        Ilb(a.b, jfb(1));
        Ilb(a.c, k);
    } else {
        d = a.d[b.p][1];
        Rlb(a.b, j, jfb(JD(Mlb(a.b, j), 17).a + 1 - d));
        Rlb(a.c, j, Beb(MD(Mlb(a.c, j))) + k - d * a.f);
    }
    (a.r == (dyc(), Yxc) && (JD(Mlb(a.b, j), 17).a > a.k || JD(Mlb(a.b, j - 1), 17).a > a.k) || a.r == _xc && (Beb(MD(Mlb(a.c, j))) > a.n || Beb(MD(Mlb(a.c, j - 1))) > a.n)) && (i = false);
    for(g = new es(Ir(hYb(b).a.Jc(), new er)); cs(g);){
        f = JD(ds(g), 18);
        h = f.c.i;
        if (a.g[h.p] == j) {
            l = h8b(a, h);
            e = e + JD(l.a, 17).a;
            i = i && ydb(LD(l.b));
        }
    }
    a.g[b.p] = j;
    e = e + a.d[b.p][0];
    return new xod(jfb(e), (xdb(), i ? true : false));
}
function igc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    if (m = a.c[b], n = a.c[c], (o = JD(WMb(m, (Iqc(), aqc)), 15), !!o && o.gc() != 0 && o.Gc(n)) || (p = m.k != (DYb(), yYb) && n.k != yYb, q = JD(WMb(m, _pc), 9), r = JD(WMb(n, _pc), 9), s = q != r, t = !!q && q != m || !!r && r != n, u = jgc(m, (Rjd(), xjd)), v = jgc(n, Ojd), t = t | (jgc(m, Ojd) || jgc(n, xjd)), w = t && s || u || v, p && w) || m.k == (DYb(), BYb) && n.k == AYb || n.k == (DYb(), BYb) && m.k == AYb) return false;
    k = a.c[b];
    f = a.c[c];
    e = mGc(a.e, k, f, (Rjd(), Qjd));
    i = mGc(a.i, k, f, wjd);
    _fc(a.f, k, f);
    j = Kfc(a.b, k, f) + JD(e.a, 17).a + JD(i.a, 17).a + a.f.d;
    h = Kfc(a.b, f, k) + JD(e.b, 17).a + JD(i.b, 17).a + a.f.b;
    if (a.a) {
        l = JD(WMb(k, kqc), 11);
        g = JD(WMb(f, kqc), 11);
        d = kGc(a.g, l, g);
        j += JD(d.a, 17).a;
        h += JD(d.b, 17).a;
    }
    return j > h;
}
function mQb(a, b) {
    var c, d, e, f, g;
    c = Beb(MD(WMb(b, (Bwc(), Wvc))));
    c < 2 && ZMb(b, Wvc, 2);
    d = JD(WMb(b, ruc), 86);
    d == (Tgd(), Rgd) && ZMb(b, ruc, sXb(b));
    e = JD(WMb(b, Qvc), 17);
    e.a == 0 ? ZMb(b, (Iqc(), vqc), new Cvb) : ZMb(b, (Iqc(), vqc), new Dvb(e.a));
    f = LD(WMb(b, jvc));
    f == null && ZMb(b, jvc, (xdb(), XD(WMb(b, yuc)) === XD((xhd(), thd)) ? true : false));
    EBb(new RBb(null, new Gvb(b.a, 16)), new pQb(a));
    EBb(DBb(new RBb(null, new Gvb(b.b, 16)), new rQb), new tQb(a));
    g = new jzc(b);
    ZMb(b, (Iqc(), Aqc), g);
    f9c(a.a);
    i9c(a.a, (CQb(), xQb), JD(WMb(b, puc), 188));
    i9c(a.a, yQb, JD(WMb(b, $uc), 188));
    i9c(a.a, zQb, JD(WMb(b, ouc), 188));
    i9c(a.a, AQb, JD(WMb(b, nvc), 188));
    i9c(a.a, BQb, NLc(JD(WMb(b, yuc), 220)));
    c9c(a.a, lQb(b));
    ZMb(b, uqc, d9c(a.a, b));
}
function VNc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r;
    l = new Irb;
    g = new Ulb;
    TNc(a, c, a.d.yg(), g, l);
    TNc(a, d, a.d.zg(), g, l);
    a.b = 0.2 * (p = UNc(DBb(new RBb(null, new Gvb(g, 16)), new $Nc)), q = UNc(DBb(new RBb(null, new Gvb(g, 16)), new aOc)), $wnd.Math.min(p, q));
    f = 0;
    for(h = 0; h < g.c.length - 1; h++){
        i = (sDb(h, g.c.length), JD(g.c[h], 116));
        for(o = h + 1; o < g.c.length; o++)f += SNc(a, i, (sDb(o, g.c.length), JD(g.c[o], 116)));
    }
    m = JD(WMb(b, (Iqc(), vqc)), 233);
    f >= 2 && (r = xMc(g, true, m), !a.e && (a.e = new ANc(a)), wNc(a.e, r, g, a.b), undefined);
    XNc(g, m);
    ZNc(g);
    n = -1;
    for(k = new rmb(g); k.a < k.c.c.length;){
        j = JD(pmb(k), 116);
        if ($wnd.Math.abs(j.s - j.c) < Fue) continue;
        n = $wnd.Math.max(n, j.o);
        a.d.wg(j, e, a.c);
    }
    a.d.a.a.$b();
    return n + 1;
}
function vWc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    l = JD(Dr((g = Gtb(new gRc(b).a.d, 0), new jRc(g))), 39);
    o = l ? JD(WMb(l, (tUc(), eUc)), 39) : null;
    e = 1;
    while(!!l && !!o){
        i = 0;
        u = 0;
        c = l;
        d = o;
        for(h = 0; h < e; h++){
            c = cRc(c);
            d = cRc(d);
            u += Beb(MD(WMb(c, (tUc(), jUc))));
            i += Beb(MD(WMb(d, jUc)));
        }
        t = Beb(MD(WMb(o, (tUc(), mUc))));
        s = Beb(MD(WMb(l, mUc)));
        m = xWc(a, l, o);
        n = t + i + a.b + m - s - u;
        if (0 < n) {
            j = b;
            k = 0;
            while(!!j && j != d){
                ++k;
                j = JD(WMb(j, fUc), 39);
            }
            if (j) {
                r = n / k;
                j = b;
                while(j != d){
                    q = Beb(MD(WMb(j, mUc))) + n;
                    ZMb(j, mUc, q);
                    p = Beb(MD(WMb(j, jUc))) + n;
                    ZMb(j, jUc, p);
                    n -= r;
                    j = JD(WMb(j, fUc), 39);
                }
            } else return;
        }
        ++e;
        l.d.b == 0 ? l = nQc(new gRc(b), e) : l = JD(Dr((f = Gtb(new gRc(l).a.d, 0), new jRc(f))), 39);
        o = l ? JD(WMb(l, eUc), 39) : null;
    }
}
function e6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    b.Sg('Label dummy removal', 1);
    d = Beb(MD(WMb(a, (Bwc(), Yvc))));
    e = Beb(MD(WMb(a, awc)));
    j = JD(WMb(a, ruc), 86);
    for(i = new rmb(a.b); i.a < i.c.c.length;){
        h = JD(pmb(i), 25);
        l = new Ajb(h.a, 0);
        while(l.b < l.d.gc()){
            k = (rDb(l.b < l.d.gc()), JD(l.d.Xb(l.c = l.b++), 9));
            if (k.k == (DYb(), xYb)) {
                m = JD(WMb(k, (Iqc(), kqc)), 18);
                o = Beb(MD(WMb(m, Fuc)));
                g = XD(WMb(k, cqc)) === XD((oid(), lid));
                c = new Fdd(k.n);
                g && (c.b += o + d);
                f = new Edd(k.o.a, k.o.b + (k.k == xYb && !PBb(BBb(JD(WMb(k, wqc), 15).Mc(), new Dzb(new JYb))).zd((wBb(), vBb)) ? 0 : -o - d));
                n = JD(WMb(k, wqc), 15);
                j == (Tgd(), Sgd) || j == Ogd ? d6b(n, c, e, f, g, j) : c6b(n, c, e, f);
                Klb(m.b, n);
                U7b(k, XD(WMb(a, yuc)) === XD((xhd(), uhd)));
                tjb(l);
            }
        }
    }
    b.Tg();
}
function Bwd(a) {
    if (a.q) return;
    a.q = true;
    a.p = Nvd(a, 0);
    a.a = Nvd(a, 1);
    Svd(a.a, 0);
    a.f = Nvd(a, 2);
    Svd(a.f, 1);
    Mvd(a.f, 2);
    a.n = Nvd(a, 3);
    Mvd(a.n, 3);
    Mvd(a.n, 4);
    Mvd(a.n, 5);
    Mvd(a.n, 6);
    a.g = Nvd(a, 4);
    Svd(a.g, 7);
    Mvd(a.g, 8);
    a.c = Nvd(a, 5);
    Svd(a.c, 7);
    Svd(a.c, 8);
    a.i = Nvd(a, 6);
    Svd(a.i, 9);
    Svd(a.i, 10);
    Svd(a.i, 11);
    Svd(a.i, 12);
    Mvd(a.i, 13);
    a.j = Nvd(a, 7);
    Svd(a.j, 9);
    a.d = Nvd(a, 8);
    Svd(a.d, 3);
    Svd(a.d, 4);
    Svd(a.d, 5);
    Svd(a.d, 6);
    Mvd(a.d, 7);
    Mvd(a.d, 8);
    Mvd(a.d, 9);
    Mvd(a.d, 10);
    a.b = Nvd(a, 9);
    Mvd(a.b, 0);
    Mvd(a.b, 1);
    a.e = Nvd(a, 10);
    Mvd(a.e, 1);
    Mvd(a.e, 2);
    Mvd(a.e, 3);
    Mvd(a.e, 4);
    Svd(a.e, 5);
    Svd(a.e, 6);
    Svd(a.e, 7);
    Svd(a.e, 8);
    Svd(a.e, 9);
    Svd(a.e, 10);
    Mvd(a.e, 11);
    a.k = Nvd(a, 11);
    Mvd(a.k, 0);
    Mvd(a.k, 1);
    a.o = Ovd(a, 12);
    a.s = Ovd(a, 13);
}
function MQb(a, b) {
    b.dc() && TRb(a.j, true, true, true, true);
    pb(b, (Rjd(), Djd)) && TRb(a.j, true, true, true, false);
    pb(b, yjd) && TRb(a.j, false, true, true, true);
    pb(b, Ljd) && TRb(a.j, true, true, false, true);
    pb(b, Njd) && TRb(a.j, true, false, true, true);
    pb(b, Ejd) && TRb(a.j, false, true, true, false);
    pb(b, zjd) && TRb(a.j, false, true, false, true);
    pb(b, Mjd) && TRb(a.j, true, false, false, true);
    pb(b, Kjd) && TRb(a.j, true, false, true, false);
    pb(b, Ijd) && TRb(a.j, true, true, true, true);
    pb(b, Bjd) && TRb(a.j, true, true, true, true);
    pb(b, Ijd) && TRb(a.j, true, true, true, true);
    pb(b, Ajd) && TRb(a.j, true, true, true, true);
    pb(b, Jjd) && TRb(a.j, true, true, true, true);
    pb(b, Hjd) && TRb(a.j, true, true, true, true);
    pb(b, Gjd) && TRb(a.j, true, true, true, true);
}
function Xud(b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    if (b.a != c.gk()) throw scb(new Teb(WCe + c.ve() + XCe));
    e = hae((Gfe(), Efe), c).Gl();
    if (e) return e.gk().si().ni(e, d);
    h = hae(Efe, c).Il();
    if (h) {
        if (d == null) return null;
        i = JD(d, 15);
        if (i.dc()) return '';
        m = new Hgb;
        for(g = i.Jc(); g.Ob();){
            f = g.Pb();
            Egb(m, h.gk().si().ni(h, f));
            m.a += ' ';
        }
        return hdb(m, m.a.length - 1);
    }
    l = hae(Efe, c).Jl();
    if (!l.dc()) {
        for(k = l.Jc(); k.Ob();){
            j = JD(k.Pb(), 155);
            if (j.ck(d)) try {
                m = j.gk().si().ni(j, d);
                if (m != null) return m;
            } catch (a) {
                a = rcb(a);
                if (!RD(a, 103)) throw scb(a);
            }
        }
        throw scb(new Teb("Invalid value: '" + d + "' for datatype :" + c.ve()));
    }
    JD(c, 826).lk();
    return d == null ? null : RD(d, 179) ? '' + JD(d, 179).a : rb(d) == hK ? vZd(Rud[0], JD(d, 205)) : adb(d);
}
function cEc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    b.Sg('Interactive crossing minimization', 1);
    g = 0;
    for(f = new rmb(a.b); f.a < f.c.c.length;){
        d = JD(pmb(f), 25);
        d.p = g++;
    }
    m = mWb(a);
    q = new LFc(m.length);
    BHc(new dnb(WC(OC(EX, 1), Nqe, 229, 0, [
        q
    ])), m);
    p = 0;
    g = 0;
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        c = 0;
        l = 0;
        for(k = new rmb(d.a); k.a < k.c.c.length;){
            i = JD(pmb(k), 9);
            if (i.n.a > 0) {
                c += i.n.a + i.o.a / 2;
                ++l;
            }
            for(o = new rmb(i.j); o.a < o.c.c.length;){
                n = JD(pmb(o), 11);
                n.p = p++;
            }
        }
        l > 0 && (c /= l);
        r = SC(aE, Rse, 30, d.a.c.length, 15, 1);
        h = 0;
        for(j = new rmb(d.a); j.a < j.c.c.length;){
            i = JD(pmb(j), 9);
            i.p = h++;
            r[i.p] = bEc(i, c);
            i.k == (DYb(), yYb) && ZMb(i, (Iqc(), mqc), r[i.p]);
        }
        pnb();
        Slb(d.a, new hEc(r));
        zCc(q, m, g, true);
        ++g;
    }
    b.Tg();
}
function aPc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    j = new Mtb;
    h = new Mtb;
    for(f = new rmb(a); f.a < f.c.c.length;){
        d = JD(pmb(f), 132);
        d.v = 0;
        d.n = d.i.c.length;
        d.u = d.t.c.length;
        d.n == 0 && Dtb(j, d, j.c.b, j.c);
        d.u == 0 && d.r.a.gc() == 0 && Dtb(h, d, h.c.b, h.c);
    }
    g = -1;
    while(j.b != 0){
        d = JD(gu(j, 0), 132);
        for(c = new rmb(d.t); c.a < c.c.c.length;){
            b = JD(pmb(c), 270);
            k = b.b;
            k.v = $wnd.Math.max(k.v, d.v + 1);
            g = $wnd.Math.max(g, k.v);
            --k.n;
            k.n == 0 && Dtb(j, k, j.c.b, j.c);
        }
    }
    if (g > -1) {
        for(e = Gtb(h, 0); e.b != e.d.c;){
            d = JD(Utb(e), 132);
            d.v = g;
        }
        while(h.b != 0){
            d = JD(gu(h, 0), 132);
            for(c = new rmb(d.i); c.a < c.c.c.length;){
                b = JD(pmb(c), 270);
                i = b.a;
                if (i.r.a.gc() != 0) continue;
                i.v = $wnd.Math.min(i.v, d.v - 1);
                --i.u;
                i.u == 0 && Dtb(h, i, h.c.b, h.c);
            }
        }
    }
}
function ZNc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    j = new Ulb;
    h = new Ulb;
    for(g = new rmb(a); g.a < g.c.c.length;){
        e = JD(pmb(g), 116);
        SMc(e, e.f.c.length);
        TMc(e, e.k.c.length);
        e.d == 0 && YCb(j.c, e);
        e.i == 0 && e.e.b == 0 && YCb(h.c, e);
    }
    d = -1;
    while(j.c.length != 0){
        e = JD(Olb(j, 0), 116);
        for(c = new rmb(e.k); c.a < c.c.c.length;){
            b = JD(pmb(c), 133);
            k = b.b;
            UMc(k, $wnd.Math.max(k.o, e.o + 1));
            d = $wnd.Math.max(d, k.o);
            SMc(k, k.d - 1);
            k.d == 0 && YCb(j.c, k);
        }
    }
    if (d > -1) {
        for(f = new rmb(h); f.a < f.c.c.length;){
            e = JD(pmb(f), 116);
            e.o = d;
        }
        while(h.c.length != 0){
            e = JD(Olb(h, 0), 116);
            for(c = new rmb(e.f); c.a < c.c.c.length;){
                b = JD(pmb(c), 133);
                i = b.a;
                if (i.e.b > 0) continue;
                UMc(i, $wnd.Math.min(i.o, e.o - 1));
                TMc(i, i.i - 1);
                i.i == 0 && YCb(h.c, i);
            }
        }
    }
}
function Ycd(a, b, c, d, e) {
    var f, g, h, i;
    i = Kse;
    g = false;
    h = Tcd(a, Bdd(new Edd(b.a, b.b), a), mdd(new Edd(c.a, c.b), e), Bdd(new Edd(d.a, d.b), c));
    f = !!h && !($wnd.Math.abs(h.a - a.a) <= FBe && $wnd.Math.abs(h.b - a.b) <= FBe || $wnd.Math.abs(h.a - b.a) <= FBe && $wnd.Math.abs(h.b - b.b) <= FBe);
    h = Tcd(a, Bdd(new Edd(b.a, b.b), a), c, e);
    !!h && (($wnd.Math.abs(h.a - a.a) <= FBe && $wnd.Math.abs(h.b - a.b) <= FBe) == ($wnd.Math.abs(h.a - b.a) <= FBe && $wnd.Math.abs(h.b - b.b) <= FBe) || f ? i = $wnd.Math.min(i, sdd(Bdd(h, c))) : g = true);
    h = Tcd(a, Bdd(new Edd(b.a, b.b), a), d, e);
    !!h && (g || ($wnd.Math.abs(h.a - a.a) <= FBe && $wnd.Math.abs(h.b - a.b) <= FBe) == ($wnd.Math.abs(h.a - b.a) <= FBe && $wnd.Math.abs(h.b - b.b) <= FBe) || f) && (i = $wnd.Math.min(i, sdd(Bdd(h, d))));
    return i;
}
function oPb(a) {
    Rad(a, new cad(jad(nad(kad(mad(lad(new pad, nve), ove), "Minimizes the stress within a layout using stress majorization. Stress exists if the euclidean distance between a pair of nodes doesn't match their graph theoretic distance, that is, the shortest path between the two nodes. The method allows to specify individual edge lengths."), new rPb), Kue)));
    Pad(a, nve, Sue, JBd(fPb));
    Pad(a, nve, Uue, (xdb(), true));
    Pad(a, nve, Yue, JBd(iPb));
    Pad(a, nve, pve, JBd(jPb));
    Pad(a, nve, Xue, JBd(kPb));
    Pad(a, nve, Zue, JBd(hPb));
    Pad(a, nve, Vue, JBd(lPb));
    Pad(a, nve, $ue, JBd(mPb));
    Pad(a, nve, ive, JBd(ePb));
    Pad(a, nve, kve, JBd(cPb));
    Pad(a, nve, lve, JBd(dPb));
    Pad(a, nve, mve, JBd(gPb));
    Pad(a, nve, jve, JBd(bPb));
}
function nDc(a) {
    var b, c, d, e, f, g, h, i;
    b = null;
    for(d = new rmb(a); d.a < d.c.c.length;){
        c = JD(pmb(d), 238);
        Beb(sDc(c.g, c.d[0]).a);
        c.b = null;
        if (!!c.e && c.e.gc() > 0 && c.c == 0) {
            !b && (b = new Ulb);
            YCb(b.c, c);
        }
    }
    if (b) while(b.c.length != 0){
        c = JD(Olb(b, 0), 238);
        if (!!c.b && c.b.c.length > 0) for(f = (!c.b && (c.b = new Ulb), new rmb(c.b)); f.a < f.c.c.length;){
            e = JD(pmb(f), 238);
            if (Deb(sDc(e.g, e.d[0]).a) == Deb(sDc(c.g, c.d[0]).a)) {
                if (Nlb(a, e, 0) > Nlb(a, c, 0)) return new xod(e, c);
            } else if (Beb(sDc(e.g, e.d[0]).a) > Beb(sDc(c.g, c.d[0]).a)) return new xod(e, c);
        }
        for(h = (!c.e && (c.e = new Ulb), c.e).Jc(); h.Ob();){
            g = JD(h.Pb(), 238);
            i = (!g.b && (g.b = new Ulb), g.b);
            vDb(0, i.c.length);
            WCb(i.c, 0, c);
            g.c == i.c.length && YCb(b.c, g);
        }
    }
    return null;
}
function Roe(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (b.e == 5) {
        Ooe(a, b);
        return;
    }
    j = b;
    if (j.b == null || a.b == null) return;
    Qoe(a);
    Noe(a);
    Qoe(j);
    Noe(j);
    c = SC(cE, ise, 30, a.b.length + j.b.length, 15, 1);
    k = 0;
    d = 0;
    g = 0;
    while(d < a.b.length && g < j.b.length){
        e = a.b[d];
        f = a.b[d + 1];
        h = j.b[g];
        i = j.b[g + 1];
        if (f < h) {
            c[k++] = a.b[d++];
            c[k++] = a.b[d++];
        } else if (f >= h && e <= i) {
            if (h <= e && f <= i) d += 2;
            else if (h <= e) {
                a.b[d] = i + 1;
                g += 2;
            } else if (f <= i) {
                c[k++] = e;
                c[k++] = h - 1;
                d += 2;
            } else {
                c[k++] = e;
                c[k++] = h - 1;
                a.b[d] = i + 1;
                g += 2;
            }
        } else if (i < e) g += 2;
        else throw scb(new qz('Token#subtractRanges(): Internal Error: [' + a.b[d] + ',' + a.b[d + 1] + '] - [' + j.b[g] + ',' + j.b[g + 1] + ']'));
    }
    while(d < a.b.length){
        c[k++] = a.b[d++];
        c[k++] = a.b[d++];
    }
    a.b = SC(cE, ise, 30, k, 15, 1);
    $gb(c, 0, a.b, 0, k);
}
function hIc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    for(d = new rmb(a.e.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 25);
        for(f = new rmb(c.a); f.a < f.c.c.length;){
            e = JD(pmb(f), 9);
            n = a.i[e.p];
            j = n.a.e;
            i = n.d.e;
            e.n.b = j;
            r = i - j - e.o.b;
            b = EIc(e);
            m = (zxc(), (!e.q ? (pnb(), pnb(), nnb) : e.q)._b((Bwc(), lvc)) ? l = JD(WMb(e, lvc), 203) : l = JD(WMb(gYb(e), mvc), 203), l);
            b && (m == wxc || m == vxc) && (e.o.b += r);
            if (b && (m == yxc || m == wxc || m == vxc)) {
                for(p = new rmb(e.j); p.a < p.c.c.length;){
                    o = JD(pmb(p), 11);
                    if ((Rjd(), Bjd).Gc(o.j)) {
                        k = JD(Nib(a.k, o), 123);
                        o.n.b = k.e - j;
                    }
                }
                for(h = new rmb(e.b); h.a < h.c.c.length;){
                    g = JD(pmb(h), 72);
                    q = JD(WMb(e, gvc), 22);
                    q.Gc((Eid(), Bid)) ? g.n.b += r : q.Gc(Cid) && (g.n.b += r / 2);
                }
                (m == wxc || m == vxc) && lYb(e, (Rjd(), Ojd)).Ic(new BJc(r));
            }
        }
    }
}
function DJb(a) {
    var b, c, d, e, f, g, h;
    if (a.A.dc()) return;
    if (a.A.Gc((ykd(), wkd))) {
        JD(Kqb(a.b, (Rjd(), xjd)), 126).k = true;
        JD(Kqb(a.b, Ojd), 126).k = true;
        b = a.q != (ajd(), Yid) && a.q != Xid;
        _Gb(JD(Kqb(a.b, wjd), 126), b);
        _Gb(JD(Kqb(a.b, Qjd), 126), b);
        _Gb(a.g, b);
        if (a.A.Gc(xkd)) {
            JD(Kqb(a.b, xjd), 126).j = true;
            JD(Kqb(a.b, Ojd), 126).j = true;
            JD(Kqb(a.b, wjd), 126).k = true;
            JD(Kqb(a.b, Qjd), 126).k = true;
            a.g.k = true;
        }
    }
    if (a.A.Gc(vkd)) {
        a.a.j = true;
        a.a.k = true;
        a.g.j = true;
        a.g.k = true;
        h = a.B.Gc((Nkd(), Jkd));
        for(e = yJb(), f = 0, g = e.length; f < g; ++f){
            d = e[f];
            c = JD(Kqb(a.i, d), 315);
            if (c) {
                if (uJb(d)) {
                    c.j = true;
                    c.k = true;
                } else {
                    c.j = !h;
                    c.k = !h;
                }
            }
        }
    }
    if (a.A.Gc(ukd) && a.B.Gc((Nkd(), Ikd))) {
        a.g.j = true;
        a.g.j = true;
        if (!a.a.j) {
            a.a.j = true;
            a.a.k = true;
            a.a.e = true;
        }
    }
}
function tIc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    j = new Ulb;
    for(i = new rmb(b.a); i.a < i.c.c.length;){
        g = JD(pmb(i), 9);
        for(m = lYb(g, (Rjd(), wjd)).Jc(); m.Ob();){
            l = JD(m.Pb(), 11);
            for(e = new rmb(l.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                if (!eWb(d) && d.c.i.c == d.d.i.c || eWb(d) || d.d.i.c != c) continue;
                YCb(j.c, d);
            }
        }
    }
    for(h = dv(c.a).Jc(); h.Ob();){
        g = JD(h.Pb(), 9);
        for(m = lYb(g, (Rjd(), Qjd)).Jc(); m.Ob();){
            l = JD(m.Pb(), 11);
            for(e = new rmb(l.e); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                if (!eWb(d) && d.c.i.c == d.d.i.c || eWb(d) || d.c.i.c != b) continue;
                if (j.c.length != 0) {
                    k = new Ajb(j, j.c.length);
                    f = (rDb(k.b > 0), JD(k.a.Xb(k.c = --k.b), 18));
                    while(f != d && k.b > 0){
                        a.a[f.p] = true;
                        a.a[d.p] = true;
                        f = (rDb(k.b > 0), JD(k.a.Xb(k.c = --k.b), 18));
                    }
                    k.b > 0 && tjb(k);
                }
            }
        }
    }
}
function SCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    if (c) {
        d = -1;
        k = new Ajb(b, 0);
        while(k.b < k.d.gc()){
            h = (rDb(k.b < k.d.gc()), JD(k.d.Xb(k.c = k.b++), 9));
            l = a.c[h.c.p][h.p].a;
            if (l == null) {
                g = d + 1;
                f = new Ajb(b, k.b);
                while(f.b < f.d.gc()){
                    m = WCc(a, (rDb(f.b < f.d.gc()), JD(f.d.Xb(f.c = f.b++), 9))).a;
                    if (m != null) {
                        g = (tDb(m), m);
                        break;
                    }
                }
                l = (d + g) / 2;
                a.c[h.c.p][h.p].a = l;
                a.c[h.c.p][h.p].d = (tDb(l), l);
                a.c[h.c.p][h.p].b = 1;
            }
            d = (tDb(l), l);
        }
    } else {
        e = 0;
        for(j = new rmb(b); j.a < j.c.c.length;){
            h = JD(pmb(j), 9);
            a.c[h.c.p][h.p].a != null && (e = $wnd.Math.max(e, Beb(a.c[h.c.p][h.p].a)));
        }
        e += 2;
        for(i = new rmb(b); i.a < i.c.c.length;){
            h = JD(pmb(i), 9);
            if (a.c[h.c.p][h.p].a == null) {
                l = yvb(a.i, 24) * hte * e - 1;
                a.c[h.c.p][h.p].a = l;
                a.c[h.c.p][h.p].d = l;
                a.c[h.c.p][h.p].b = 1;
            }
        }
    }
}
function ffc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    for(e = new rmb(a.a.a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 60);
        for(i = d.c.Jc(); i.Ob();){
            h = JD(i.Pb(), 60);
            if (d.a == h.a) continue;
            Ugd(a.a.d) ? l = a.a.g.df(d, h) : l = a.a.g.ef(d, h);
            f = d.b.a + d.d.b + l - h.b.a;
            f = $wnd.Math.ceil(f);
            f = $wnd.Math.max(0, f);
            if (odc(d, h)) {
                g = pGb(new rGb, a.d);
                j = YD($wnd.Math.ceil(h.b.a - d.b.a));
                b = j - (h.b.a - d.b.a);
                k = ndc(d).a;
                c = d;
                if (!k) {
                    k = ndc(h).a;
                    b = -b;
                    c = h;
                }
                if (k) {
                    c.b.a -= b;
                    k.n.a -= b;
                }
                DFb(GFb(FFb(HFb(EFb(new IFb, $wnd.Math.max(0, j)), 1), g), a.c[d.a.d]));
                DFb(GFb(FFb(HFb(EFb(new IFb, $wnd.Math.max(0, -j)), 1), g), a.c[h.a.d]));
            } else {
                m = 1;
                (RD(d.g, 152) && RD(h.g, 9) || RD(h.g, 152) && RD(d.g, 9)) && (m = 2);
                DFb(GFb(FFb(HFb(EFb(new IFb, YD(f)), m), a.c[d.a.d]), a.c[h.a.d]));
            }
        }
    }
}
function Nxb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    if (!a.b) return false;
    g = null;
    m = null;
    i = new tyb(null, null);
    e = 1;
    i.a[1] = a.b;
    l = i;
    while(l.a[e]){
        j = e;
        h = m;
        m = l;
        l = l.a[e];
        d = a.a.Le(b, l.d);
        e = d < 0 ? 0 : 1;
        d == 0 && (!c.c || tub(l.e, c.d)) && (g = l);
        if (!(!!l && l.b) && !Jxb(l.a[e])) {
            if (Jxb(l.a[1 - e])) m = m.a[j] = Qxb(l, e);
            else if (!Jxb(l.a[1 - e])) {
                n = m.a[1 - j];
                if (n) {
                    if (!Jxb(n.a[1 - j]) && !Jxb(n.a[j])) {
                        m.b = false;
                        n.b = true;
                        l.b = true;
                    } else {
                        f = h.a[1] == m ? 1 : 0;
                        Jxb(n.a[j]) ? h.a[f] = Pxb(m, j) : Jxb(n.a[1 - j]) && (h.a[f] = Qxb(m, j));
                        l.b = h.a[f].b = true;
                        h.a[f].a[0].b = false;
                        h.a[f].a[1].b = false;
                    }
                }
            }
        }
    }
    if (g) {
        c.b = true;
        c.d = g.e;
        if (l != g) {
            k = new tyb(l.d, l.e);
            Oxb(a, i, g, k);
            m == g && (m = k);
        }
        m.a[m.a[1] == l ? 1 : 0] = l.a[!l.a[0] ? 1 : 0];
        --a.c;
    }
    a.b = i.a[1];
    !!a.b && (a.b.b = false);
    return c.b;
}
function pA(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    !c && (c = _A(b.q.getTimezoneOffset()));
    e = (b.q.getTimezoneOffset() - c.a) * 60000;
    h = new oB(tcb(zcb(b.q.getTime()), e));
    i = h;
    if (h.q.getTimezoneOffset() != b.q.getTimezoneOffset()) {
        e > 0 ? e -= 86400000 : e += 86400000;
        i = new oB(tcb(zcb(b.q.getTime()), e));
    }
    k = new Vgb;
    j = a.a.length;
    for(f = 0; f < j;){
        d = _fb(a.a, f);
        if (d >= 97 && d <= 122 || d >= 65 && d <= 90) {
            for(g = f + 1; g < j && _fb(a.a, g) == d; ++g);
            DA(k, d, g - f, h, i, c);
            f = g;
        } else if (d == 39) {
            ++f;
            if (f < j && _fb(a.a, f) == 39) {
                k.a += "'";
                ++f;
                continue;
            }
            l = false;
            while(!l){
                g = f;
                while(g < j && _fb(a.a, g) != 39)++g;
                if (g >= j) throw scb(new Teb("Missing trailing '"));
                g + 1 < j && _fb(a.a, g + 1) == 39 ? ++g : l = true;
                Qgb(k, qgb(a.a, f, g));
                f = g + 1;
            }
        } else {
            k.a += String.fromCharCode(d);
            ++f;
        }
    }
    return k.a;
}
function v6d() {
    kNd($5, new b7d);
    kNd(Z5, new I7d);
    kNd(_5, new n8d);
    kNd(a6, new F8d);
    kNd(c6, new I8d);
    kNd(e6, new L8d);
    kNd(d6, new O8d);
    kNd(f6, new R8d);
    kNd(h6, new z6d);
    kNd(i6, new C6d);
    kNd(j6, new F6d);
    kNd(k6, new I6d);
    kNd(l6, new L6d);
    kNd(m6, new O6d);
    kNd(n6, new R6d);
    kNd(q6, new U6d);
    kNd(s6, new X6d);
    kNd(u7, new $6d);
    kNd(g6, new e7d);
    kNd(r6, new h7d);
    kNd(GI, new k7d);
    kNd(OC($D, 1), new n7d);
    kNd(HI, new q7d);
    kNd(II, new t7d);
    kNd(hK, new w7d);
    kNd(L5, new z7d);
    kNd(LI, new C7d);
    kNd(Q5, new F7d);
    kNd(R5, new L7d);
    kNd(Lab, new O7d);
    kNd(Bab, new R7d);
    kNd(QI, new U7d);
    kNd(UI, new X7d);
    kNd(KI, new $7d);
    kNd(XI, new b8d);
    kNd(MK, new e8d);
    kNd(s9, new h8d);
    kNd(r9, new k8d);
    kNd(cJ, new q8d);
    kNd(hJ, new t8d);
    kNd(U5, new w8d);
    kNd(S5, new z8d);
}
function zmb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (a == null) return Rqe;
    i = b.a.yc(a, b);
    if (i != null) return '[...]';
    c = new xxb(Lqe, '[', ']');
    for(e = a, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        if (d != null && (rb(d).i & 4) != 0) {
            if (Array.isArray(d) && (k = PC(d), !(k >= 14 && k <= 16))) {
                if (b.a._b(d)) {
                    !c.a ? c.a = new Wgb(c.d) : Qgb(c.a, c.b);
                    Ngb(c.a, '[...]');
                } else {
                    h = KD(d);
                    j = new Srb(b);
                    uxb(c, zmb(h, j));
                }
            } else RD(d, 183) ? uxb(c, $mb(JD(d, 183))) : RD(d, 195) ? uxb(c, Tmb(JD(d, 195))) : RD(d, 201) ? uxb(c, Umb(JD(d, 201))) : RD(d, 2057) ? uxb(c, Zmb(JD(d, 2057))) : RD(d, 54) ? uxb(c, Xmb(JD(d, 54))) : RD(d, 579) ? uxb(c, Ymb(JD(d, 579))) : RD(d, 825) ? uxb(c, Wmb(JD(d, 825))) : RD(d, 108) && uxb(c, Vmb(JD(d, 108)));
        } else uxb(c, d == null ? Rqe : adb(d));
    }
    return !c.a ? c.c : c.e.length == 0 ? c.a.a : c.a.a + ('' + c.e);
}
function dTd(a, b) {
    var c, d, e, f;
    f = a.F;
    if (b == null) {
        a.F = null;
        TSd(a, null);
    } else {
        a.F = (tDb(b), b);
        d = hgb(b, wgb(60));
        if (d != -1) {
            e = (zDb(0, d, b.length), b.substr(0, d));
            hgb(b, wgb(46)) == -1 && !cgb(e, Dqe) && !cgb(e, eFe) && !cgb(e, fFe) && !cgb(e, gFe) && !cgb(e, hFe) && !cgb(e, iFe) && !cgb(e, jFe) && !cgb(e, kFe) && (e = lFe);
            c = kgb(b, wgb(62));
            c != -1 && (e += '' + (ADb(c + 1, b.length + 1), b.substr(c + 1)));
            TSd(a, e);
        } else {
            e = b;
            if (hgb(b, wgb(46)) == -1) {
                d = hgb(b, wgb(91));
                d != -1 && (e = (zDb(0, d, b.length), b.substr(0, d)));
                if (!cgb(e, Dqe) && !cgb(e, eFe) && !cgb(e, fFe) && !cgb(e, gFe) && !cgb(e, hFe) && !cgb(e, iFe) && !cgb(e, jFe) && !cgb(e, kFe)) {
                    e = lFe;
                    d != -1 && (e += '' + (ADb(d, b.length + 1), b.substr(d)));
                } else e = b;
            }
            TSd(a, e);
            e == b && (a.F = a.D);
        }
    }
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && Wpd(a, new g_d(a, 1, 5, f, b));
}
function RUb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    a.c = a.e;
    o = LD(WMb(b, (Bwc(), Rvc)));
    n = o == null || (tDb(o), o);
    f = JD(WMb(b, (Iqc(), Wpc)), 22).Gc(($oc(), Toc));
    e = JD(WMb(b, Evc), 100);
    c = !(e == (ajd(), Wid) || e == Yid || e == Xid);
    if (n && (c || !f)) {
        for(l = new rmb(b.a); l.a < l.c.c.length;){
            j = JD(pmb(l), 9);
            j.p = 0;
        }
        m = new Ulb;
        for(k = new rmb(b.a); k.a < k.c.c.length;){
            j = JD(pmb(k), 9);
            d = QUb(a, j, null);
            if (d) {
                i = new nWb;
                UMb(i, b);
                ZMb(i, Qpc, JD(d.b, 22));
                MXb(i.d, b.d);
                ZMb(i, qvc, null);
                for(h = JD(d.a, 15).Jc(); h.Ob();){
                    g = JD(h.Pb(), 9);
                    Ilb(i.a, g);
                    g.a = i;
                }
                m.Ec(i);
            }
        }
        f && (XD(WMb(b, Ytc)) === XD((cUb(), $Tb)) ? a.c = a.b : XD(WMb(b, Ytc)) === XD(aUb) ? a.c = a.d : a.c = a.a);
    } else m = new dnb(WC(OC(MP, 1), Bve, 36, 0, [
        b
    ]));
    XD(WMb(b, Ytc)) !== XD((cUb(), bUb)) && (pnb(), m.gd(new UUb));
    return m;
}
function tqd(b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    j = c.length - 1;
    i = (ADb(j, c.length), c.charCodeAt(j));
    if (i == 93) {
        h = hgb(c, wgb(91));
        if (h >= 0) {
            f = yqd(b, (zDb(1, h, c.length), c.substr(1, h - 1)));
            l = (zDb(h + 1, j, c.length), c.substr(h + 1, j - (h + 1)));
            return rqd(b, l, f);
        }
    } else {
        d = -1;
        Sdb == null && (Sdb = new RegExp('\\d'));
        if (Sdb.test(String.fromCharCode(i))) {
            d = lgb(c, wgb(46), j - 1);
            if (d >= 0) {
                e = JD(jqd(b, Dqd(b, (zDb(1, d, c.length), c.substr(1, d - 1))), false), 61);
                k = 0;
                try {
                    k = Fdb((ADb(d + 1, c.length + 1), c.substr(d + 1)), Lre, Hqe);
                } catch (a) {
                    a = rcb(a);
                    if (RD(a, 130)) {
                        g = a;
                        throw scb(new kOd(g));
                    } else throw scb(a);
                }
                if (k < e.gc()) {
                    m = e.Xb(k);
                    RD(m, 74) && (m = JD(m, 74).kd());
                    return JD(m, 57);
                }
            }
        }
        if (d < 0) return JD(jqd(b, Dqd(b, (ADb(1, c.length + 1), c.substr(1))), false), 57);
    }
    return null;
}
function W5b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    b.Sg('Label dummy insertions', 1);
    l = new Ulb;
    g = Beb(MD(WMb(a, (Bwc(), Yvc))));
    j = Beb(MD(WMb(a, awc)));
    k = JD(WMb(a, ruc), 86);
    for(n = new rmb(a.a); n.a < n.c.c.length;){
        m = JD(pmb(n), 9);
        for(f = new es(Ir(kYb(m).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            if (e.c.i != e.d.i && Zq(e.b, T5b)) {
                p = X5b(e);
                o = av(e.b.c.length);
                c = V5b(a, e, p, o);
                YCb(l.c, c);
                d = c.o;
                h = new Ajb(e.b, 0);
                while(h.b < h.d.gc()){
                    i = (rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 72));
                    if (XD(WMb(i, wuc)) === XD((nhd(), khd))) {
                        if (k == (Tgd(), Sgd) || k == Ogd) {
                            d.a += i.o.a + j;
                            d.b = $wnd.Math.max(d.b, i.o.b);
                        } else {
                            d.a = $wnd.Math.max(d.a, i.o.a);
                            d.b += i.o.b + j;
                        }
                        YCb(o.c, i);
                        tjb(h);
                    }
                }
                if (k == (Tgd(), Sgd) || k == Ogd) {
                    d.a -= j;
                    d.b += g + p;
                } else d.b += g - j + p;
            }
        }
    }
    Klb(a.a, l);
    b.Tg();
}
function JZd(a, b, c) {
    var d, e, f, g, h, i, j;
    j = a.c;
    !b && (b = yZd);
    a.c = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        i = new g_d(a, 1, 2, j, a.c);
        !c ? c = i : c.kj(i);
    }
    if (j != b) {
        if (RD(a.Cb, 290)) {
            if (a.Db >> 16 == -10) c = JD(a.Cb, 290).Vk(b, c);
            else if (a.Db >> 16 == -15) {
                !b && (b = (cPd(), ROd));
                !j && (j = (cPd(), ROd));
                if (a.Cb.Uh()) {
                    i = new i_d(a.Cb, 1, 13, j, b, AUd(J_d(JD(a.Cb, 62)), a), false);
                    !c ? c = i : c.kj(i);
                }
            }
        } else if (RD(a.Cb, 88)) {
            if (a.Db >> 16 == -23) {
                RD(b, 88) || (b = (cPd(), UOd));
                RD(j, 88) || (j = (cPd(), UOd));
                if (a.Cb.Uh()) {
                    i = new i_d(a.Cb, 1, 10, j, b, AUd(OTd(JD(a.Cb, 29)), a), false);
                    !c ? c = i : c.kj(i);
                }
            }
        } else if (RD(a.Cb, 443)) {
            h = JD(a.Cb, 829);
            g = (!h.b && (h.b = new K5d(new G5d)), h.b);
            for(f = (d = new mjb(new djb(g.a).a), new S5d(d)); f.a.b;){
                e = JD(kjb(f.a).jd(), 87);
                c = JZd(e, FZd(e, h), c);
            }
        }
    }
    return c;
}
function i$b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    g = ydb(LD(ksd(a, (Bwc(), Nuc))));
    m = JD(ksd(a, Hvc), 22);
    i = false;
    j = false;
    l = new CHd((!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c));
    while(l.e != l.i.gc() && (!i || !j)){
        f = JD(AHd(l), 124);
        h = 0;
        for(e = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
            (!f.d && (f.d = new ree(x3, f, 8, 5)), f.d),
            (!f.e && (f.e = new ree(x3, f, 7, 4)), f.e)
        ]))); cs(e);){
            d = JD(ds(e), 85);
            k = g && Std(d) && ydb(LD(ksd(d, Ouc)));
            c = xUd((!d.b && (d.b = new ree(v3, d, 4, 7)), d.b), f) ? a == Zwd(_Bd(JD(nDd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c), 0), 84))) : a == Zwd(_Bd(JD(nDd((!d.b && (d.b = new ree(v3, d, 4, 7)), d.b), 0), 84)));
            if (k || c) {
                ++h;
                if (h > 1) break;
            }
        }
        h > 0 ? i = true : m.Gc((ojd(), kjd)) && (!f.n && (f.n = new X0d(z3, f, 1, 7)), f.n).i > 0 && (i = true);
        h > 1 && (j = true);
    }
    i && b.Ec(($oc(), Toc));
    j && b.Ec(($oc(), Uoc));
}
function lnd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    m = JD(ksd(a, (Lgd(), Bfd)), 22);
    if (m.dc()) return null;
    h = 0;
    g = 0;
    if (m.Gc((ykd(), wkd))) {
        k = JD(ksd(a, Yfd), 100);
        d = 2;
        c = 2;
        e = 2;
        f = 2;
        b = !Zwd(a) ? JD(ksd(a, $ed), 86) : JD(ksd(Zwd(a), $ed), 86);
        for(j = new CHd((!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c)); j.e != j.i.gc();){
            i = JD(AHd(j), 124);
            l = JD(ksd(i, dgd), 64);
            if (l == (Rjd(), Pjd)) {
                l = Ymd(i, b);
                msd(i, dgd, l);
            }
            if (k == (ajd(), Xid)) switch(l.g){
                case 1:
                    d = $wnd.Math.max(d, i.i + i.g);
                    break;
                case 2:
                    c = $wnd.Math.max(c, i.j + i.f);
                    break;
                case 3:
                    e = $wnd.Math.max(e, i.i + i.g);
                    break;
                case 4:
                    f = $wnd.Math.max(f, i.j + i.f);
            }
            else switch(l.g){
                case 1:
                    d += i.g + 2;
                    break;
                case 2:
                    c += i.f + 2;
                    break;
                case 3:
                    e += i.g + 2;
                    break;
                case 4:
                    f += i.f + 2;
            }
        }
        h = $wnd.Math.max(d, e);
        g = $wnd.Math.max(c, f);
    }
    return mnd(a, h, g, true, true);
}
function zIc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    e = null;
    for(d = new rmb(b.a); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        EIc(c) ? f = (h = pGb(qGb(new rGb, c), a.f), i = pGb(qGb(new rGb, c), a.f), j = new UIc(c, true, h, i), k = c.o.b, l = (zxc(), (!c.q ? (pnb(), pnb(), nnb) : c.q)._b((Bwc(), lvc)) ? m = JD(WMb(c, lvc), 203) : m = JD(WMb(gYb(c), mvc), 203), m), n = 10000, l == vxc && (n = 1), o = DFb(GFb(FFb(EFb(HFb(new IFb, n), YD($wnd.Math.ceil(k))), h), i)), l == wxc && Nrb(a.d, o), AIc(a, dv(lYb(c, (Rjd(), Qjd))), j), AIc(a, lYb(c, wjd), j), j) : f = (p = pGb(qGb(new rGb, c), a.f), EBb(BBb(new RBb(null, new Gvb(c.j, 16)), new fJc), new hJc(a, p)), new UIc(c, false, p, p));
        a.i[c.p] = f;
        if (e) {
            g = e.c.d.a + ezc(a.n, e.c, c) + c.d.d;
            e.b || (g += e.c.o.b);
            DFb(GFb(FFb(HFb(EFb(new IFb, YD($wnd.Math.ceil(g))), 0), e.d), f.a));
        }
        e = f;
    }
}
function okc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    s = JD(yBb(OBb(BBb(new RBb(null, new Gvb(b.d, 16)), new skc(c)), new ukc(c)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    l = Hqe;
    k = Lre;
    for(i = new rmb(b.b.j); i.a < i.c.c.length;){
        h = JD(pmb(i), 11);
        if (h.j == c) {
            l = $wnd.Math.min(l, h.p);
            k = $wnd.Math.max(k, h.p);
        }
    }
    if (l == Hqe) for(g = 0; g < s.gc(); g++)rgc(JD(s.Xb(g), 105), c, g);
    else {
        t = SC(cE, ise, 30, e.length, 15, 1);
        Hmb(t, t.length);
        for(r = s.Jc(); r.Ob();){
            q = JD(r.Pb(), 105);
            f = JD(Nib(a.b, q), 183);
            j = 0;
            for(p = l; p <= k; p++)f[p] && (j = $wnd.Math.max(j, d[p]));
            if (q.i) {
                n = q.i.c;
                u = new Qrb;
                for(m = 0; m < e.length; m++)e[n][m] && Nrb(u, jfb(t[m]));
                while(Orb(u, jfb(j)))++j;
            }
            rgc(q, c, j);
            for(o = l; o <= k; o++)f[o] && (d[o] = j + 1);
            !!q.i && (t[q.i.c] = j);
        }
    }
}
function rUb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    f = new DUb(b);
    l = mUb(a, b, f);
    n = $wnd.Math.max(Beb(MD(WMb(b, (Bwc(), Fuc)))), 1);
    for(k = new rmb(l.a); k.a < k.c.c.length;){
        j = JD(pmb(k), 47);
        i = qUb(JD(j.a, 8), JD(j.b, 8), n);
        o = true;
        o = o & vUb(c, new Edd(i.c, i.d));
        o = o & vUb(c, ldd(new Edd(i.c, i.d), i.b, 0));
        o = o & vUb(c, ldd(new Edd(i.c, i.d), 0, i.a));
        vUb(c, ldd(new Edd(i.c, i.d), i.b, i.a));
    }
    m = f.d;
    h = qUb(JD(l.b.a, 8), JD(l.b.b, 8), n);
    if (m == (Rjd(), Qjd) || m == wjd) {
        d.c[m.g] = $wnd.Math.min(d.c[m.g], h.d);
        d.b[m.g] = $wnd.Math.max(d.b[m.g], h.d + h.a);
    } else {
        d.c[m.g] = $wnd.Math.min(d.c[m.g], h.c);
        d.b[m.g] = $wnd.Math.max(d.b[m.g], h.c + h.b);
    }
    e = Lse;
    g = f.c.i.d;
    switch(m.g){
        case 4:
            e = g.c;
            break;
        case 2:
            e = g.b;
            break;
        case 1:
            e = g.a;
            break;
        case 3:
            e = g.d;
    }
    d.a[m.g] = $wnd.Math.max(d.a[m.g], e);
    return f;
}
function U$b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    f = JD(WMb(a, (Iqc(), kqc)), 85);
    if (!f) return;
    d = a.a;
    e = new Fdd(c);
    mdd(e, Y$b(a));
    if (xXb(a.d.i, a.c.i)) {
        m = a.c;
        l = Kdd(WC(OC(b2, 1), hre, 8, 0, [
            m.n,
            m.a
        ]));
        Bdd(l, c);
    } else l = WYb(a.c);
    Dtb(d, l, d.a, d.a.a);
    n = WYb(a.d);
    WMb(a, Gqc) != null && mdd(n, JD(WMb(a, Gqc), 8));
    Dtb(d, n, d.c.b, d.c);
    Pdd(d, e);
    g = hCd(f);
    mud(g, JD(nDd((!f.b && (f.b = new ree(v3, f, 4, 7)), f.b), 0), 84));
    nud(g, JD(nDd((!f.c && (f.c = new ree(v3, f, 5, 8)), f.c), 0), 84));
    Vmd(d, g);
    for(k = new rmb(a.b); k.a < k.c.c.length;){
        j = JD(pmb(k), 72);
        h = JD(WMb(j, kqc), 153);
        gtd(h, j.o.a);
        etd(h, j.o.b);
        ftd(h, j.n.a + e.a, j.n.b + e.b);
        msd(h, (k6b(), j6b), LD(WMb(j, j6b)));
    }
    i = JD(WMb(a, (Bwc(), Ruc)), 77);
    if (i) {
        Pdd(i, e);
        msd(f, Ruc, i);
    } else msd(f, Ruc, null);
    b == (xhd(), vhd) ? msd(f, yuc, vhd) : msd(f, yuc, null);
}
function PHc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    n = b.c.length;
    m = 0;
    for(l = new rmb(a.b); l.a < l.c.c.length;){
        k = JD(pmb(l), 25);
        r = k.a;
        if (r.c.length == 0) continue;
        q = new rmb(r);
        j = 0;
        s = null;
        e = JD(pmb(q), 9);
        f = null;
        while(e){
            f = JD(Mlb(b, e.p), 261);
            if (f.c >= 0) {
                i = null;
                h = new Ajb(k.a, j + 1);
                while(h.b < h.d.gc()){
                    g = (rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 9));
                    i = JD(Mlb(b, g.p), 261);
                    if (i.d == f.d && i.c < f.c) break;
                    else i = null;
                }
                if (i) {
                    if (s) {
                        Rlb(d, e.p, jfb(JD(Mlb(d, e.p), 17).a - 1));
                        JD(Mlb(c, s.p), 15).Kc(f);
                    }
                    f = _Hc(f, e, n++);
                    YCb(b.c, f);
                    Ilb(c, new Ulb);
                    if (s) {
                        JD(Mlb(c, s.p), 15).Ec(f);
                        Ilb(d, jfb(1));
                    } else Ilb(d, jfb(0));
                }
            }
            o = null;
            if (q.a < q.c.c.length) {
                o = JD(pmb(q), 9);
                p = JD(Mlb(b, o.p), 261);
                JD(Mlb(c, e.p), 15).Ec(p);
                Rlb(d, o.p, jfb(JD(Mlb(d, o.p), 17).a + 1));
            }
            f.d = m;
            f.c = j++;
            s = e;
            e = o;
        }
        ++m;
    }
}
function g1b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    h = JD(Nib(b.c, a), 454);
    s = b.a.c;
    i = b.a.c + b.a.b;
    C = h.f;
    D = h.a;
    g = C < D;
    p = new Edd(s, C);
    t = new Edd(i, D);
    e = (s + i) / 2;
    q = new Edd(e, C);
    u = new Edd(e, D);
    f = h1b(a, C, D);
    w = WYb(b.B);
    A = new Edd(e, f);
    B = WYb(b.D);
    c = Jcd(WC(OC(b2, 1), hre, 8, 0, [
        w,
        A,
        B
    ]));
    n = false;
    r = b.B.i;
    if (!!r && !!r.c && h.d) {
        j = g && r.p < r.c.a.c.length - 1 || !g && r.p > 0;
        if (j) {
            if (j) {
                m = r.p;
                g ? ++m : --m;
                l = JD(Mlb(r.c.a, m), 9);
                d = j1b(l);
                n = !(Rcd(d, w, c[0]) || Ncd(d, w, c[0]));
            }
        } else n = true;
    }
    o = false;
    v = b.D.i;
    if (!!v && !!v.c && h.e) {
        k = g && v.p > 0 || !g && v.p < v.c.a.c.length - 1;
        if (k) {
            m = v.p;
            g ? --m : ++m;
            l = JD(Mlb(v.c.a, m), 9);
            d = j1b(l);
            o = !(Rcd(d, c[0], B) || Ncd(d, c[0], B));
        } else o = true;
    }
    n && o && Atb(a.a, A);
    n || Mdd(a.a, WC(OC(b2, 1), hre, 8, 0, [
        p,
        q
    ]));
    o || Mdd(a.a, WC(OC(b2, 1), hre, 8, 0, [
        u,
        t
    ]));
}
function RZc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    if (c.c.length != 0) {
        o = new Ulb;
        for(n = new rmb(c); n.a < n.c.c.length;){
            m = JD(pmb(n), 27);
            Ilb(o, new Edd(m.i, m.j));
        }
        d.ah(b, 'Before removing overlaps');
        while(sZc(a, c))qZc(a, c, false);
        d.ah(b, 'After removing overlaps');
        h = 0;
        i = 0;
        e = null;
        if (c.c.length != 0) {
            e = (sDb(0, c.c.length), JD(c.c[0], 27));
            h = e.i - (sDb(0, o.c.length), JD(o.c[0], 8)).a;
            i = e.j - (sDb(0, o.c.length), JD(o.c[0], 8)).b;
        }
        g = $wnd.Math.sqrt(h * h + i * i);
        l = PYc(c);
        f = 1;
        if (l.a.gc() != 0) {
            for(k = l.a.ec().Jc(); k.Ob();){
                j = JD(k.Pb(), 27);
                p = a.f;
                q = p.i + p.g / 2;
                r = p.j + p.f / 2;
                s = j.i + j.g / 2;
                t = j.j + j.f / 2;
                u = s - q;
                v = t - r;
                w = $wnd.Math.sqrt(u * u + v * v);
                A = u / w;
                B = v / w;
                htd(j, j.i + A * g);
                itd(j, j.j + B * g);
            }
            d.ah(b, 'Child movement ' + f);
            ++f;
        }
        !!a.a && a.a.Eg(new Wlb(l));
        RZc(a, b, new Wlb(l), d);
    }
}
function Scd(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    i = a;
    k = Bdd(new Edd(b.a, b.b), a);
    j = c;
    l = Bdd(new Edd(d.a, d.b), c);
    m = i.a;
    q = i.b;
    o = j.a;
    s = j.b;
    n = k.a;
    r = k.b;
    p = l.a;
    t = l.b;
    e = p * r - n * t;
    Ry();
    Vy(pze);
    if ($wnd.Math.abs(0 - e) <= pze || 0 == e || isNaN(0) && isNaN(e)) return false;
    g = 1 / e * ((m - o) * r - (q - s) * n);
    h = 1 / e * -(-(m - o) * t + (q - s) * p);
    f = (Vy(pze), ($wnd.Math.abs(0 - g) <= pze || 0 == g || isNaN(0) && isNaN(g) ? 0 : 0 < g ? -1 : 0 > g ? 1 : Wy(isNaN(0), isNaN(g))) < 0 && (Vy(pze), ($wnd.Math.abs(g - 1) <= pze || g == 1 || isNaN(g) && isNaN(1) ? 0 : g < 1 ? -1 : g > 1 ? 1 : Wy(isNaN(g), isNaN(1))) < 0) && (Vy(pze), ($wnd.Math.abs(0 - h) <= pze || 0 == h || isNaN(0) && isNaN(h) ? 0 : 0 < h ? -1 : 0 > h ? 1 : Wy(isNaN(0), isNaN(h))) < 0) && (Vy(pze), ($wnd.Math.abs(h - 1) <= pze || h == 1 || isNaN(h) && isNaN(1) ? 0 : h < 1 ? -1 : h > 1 ? 1 : Wy(isNaN(h), isNaN(1))) < 0));
    return f;
}
function ZSd(b) {
    var c, d, e, f;
    d = b.D != null ? b.D : b.B;
    c = hgb(d, wgb(91));
    if (c != -1) {
        e = (zDb(0, c, d.length), d.substr(0, c));
        f = new Hgb;
        do f.a += '[';
        while ((c = ggb(d, 91, ++c)) != -1);
        if (cgb(e, Dqe)) f.a += 'Z';
        else if (cgb(e, eFe)) f.a += 'B';
        else if (cgb(e, fFe)) f.a += 'C';
        else if (cgb(e, gFe)) f.a += 'D';
        else if (cgb(e, hFe)) f.a += 'F';
        else if (cgb(e, iFe)) f.a += 'I';
        else if (cgb(e, jFe)) f.a += 'J';
        else if (cgb(e, kFe)) f.a += 'S';
        else {
            f.a += 'L';
            f.a += '' + e;
            f.a += ';';
        }
        try {
            return null;
        } catch (a) {
            a = rcb(a);
            if (!RD(a, 63)) throw scb(a);
        }
    } else if (hgb(d, wgb(46)) == -1) {
        if (cgb(d, Dqe)) return pcb;
        else if (cgb(d, eFe)) return $D;
        else if (cgb(d, fFe)) return _D;
        else if (cgb(d, gFe)) return aE;
        else if (cgb(d, hFe)) return bE;
        else if (cgb(d, iFe)) return cE;
        else if (cgb(d, jFe)) return dE;
        else if (cgb(d, kFe)) return ocb;
    }
    return null;
}
function rfe(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    for(l = new rtb(new ktb(a)); l.c != l.d.a.d;){
        k = qtb(l);
        h = JD(k.d, 57);
        b = JD(k.e, 57);
        g = h.zh();
        for(p = 0, u = (g.i == null && MTd(g), g.i).length; p < u; ++p){
            j = (f = (g.i == null && MTd(g), g.i), p >= 0 && p < f.length ? f[p] : null);
            if (j.ok() && !j.pk()) {
                if (RD(j, 101)) {
                    i = JD(j, 19);
                    (i.Bb & RCe) == 0 && (w = s1d(i), !(!!w && (w.Bb & RCe) != 0)) && qfe(a, i, h, b);
                } else {
                    Ife();
                    if (JD(j, 69).uk()) {
                        c = (v = j, JD(!v ? null : JD(b, 52).ci(v), 159));
                        if (c) {
                            n = JD(h.Ih(j), 159);
                            d = c.gc();
                            for(q = 0, o = n.gc(); q < o; ++q){
                                m = n.Ql(q);
                                if (RD(m, 101)) {
                                    t = n.Rl(q);
                                    e = Tsb(a, t);
                                    if (e == null && t != null) {
                                        s = JD(m, 19);
                                        if (!a.b || (s.Bb & RCe) != 0 || !!s1d(s)) continue;
                                        e = t;
                                    }
                                    if (!c.Ll(m, e)) {
                                        for(r = 0; r < d; ++r)if (c.Ql(r) == m && XD(c.Rl(r)) === XD(e)) {
                                            c.Qi(c.gc() - 1, r);
                                            --d;
                                            break;
                                        }
                                    }
                                } else c.Ll(n.Ql(q), n.Rl(q));
                            }
                        }
                    }
                }
            }
        }
    }
}
function jCc(a, b, c) {
    var d;
    c.Sg('StretchWidth layering', 1);
    if (b.a.c.length == 0) {
        c.Tg();
        return;
    }
    a.c = b;
    a.t = 0;
    a.u = 0;
    a.i = Kse;
    a.g = Lse;
    a.d = Beb(MD(WMb(b, (Bwc(), Wvc))));
    dCc(a);
    eCc(a);
    bCc(a);
    iCc(a);
    cCc(a);
    a.i = $wnd.Math.max(1, a.i);
    a.g = $wnd.Math.max(1, a.g);
    a.d = a.d / a.i;
    a.f = a.g / a.i;
    a.s = gCc(a);
    d = new b$b(a.c);
    Ilb(a.c.b, d);
    a.r = Zu(a.p);
    a.n = wmb(a.k, a.k.length);
    while(a.r.c.length != 0){
        a.o = kCc(a);
        if (!a.o || fCc(a) && a.b.a.gc() != 0) {
            lCc(a, d);
            d = new b$b(a.c);
            Ilb(a.c.b, d);
            xe(a.a, a.b);
            a.b.a.$b();
            a.t = a.u;
            a.u = 0;
        } else if (fCc(a)) {
            a.c.b.c.length = 0;
            d = new b$b(a.c);
            Ilb(a.c.b, d);
            a.t = 0;
            a.u = 0;
            a.b.a.$b();
            a.a.a.$b();
            ++a.f;
            a.r = Zu(a.p);
            a.n = wmb(a.k, a.k.length);
        } else {
            qYb(a.o, d);
            Plb(a.r, a.o);
            Nrb(a.b, a.o);
            a.t = a.t - a.k[a.o.p] * a.d + a.j[a.o.p];
            a.u += a.e[a.o.p] * a.d;
        }
    }
    b.a.c.length = 0;
    vnb(b.b);
    c.Tg();
}
function vIc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    a.j = SC(cE, ise, 30, a.g, 15, 1);
    a.o = new Ulb;
    EBb(DBb(new RBb(null, new Gvb(a.e.b, 16)), new DJc), new FJc(a));
    a.a = SC(pcb, Vte, 30, a.b, 16, 1);
    LBb(new RBb(null, new Gvb(a.e.b, 16)), new UJc(a));
    d = (l = new Ulb, EBb(BBb(DBb(new RBb(null, new Gvb(a.e.b, 16)), new KJc), new MJc(a)), new OJc(a, l)), l);
    for(i = new rmb(d); i.a < i.c.c.length;){
        h = JD(pmb(i), 499);
        if (h.c.length <= 1) continue;
        if (h.c.length == 2) {
            XIc(h);
            EIc((sDb(0, h.c.length), JD(h.c[0], 18)).d.i) || Ilb(a.o, h);
            continue;
        }
        if (WIc(h) || VIc(h, new IJc)) continue;
        j = new rmb(h);
        e = null;
        while(j.a < j.c.c.length){
            b = JD(pmb(j), 18);
            c = a.c[b.p];
            !e || j.a >= j.c.c.length ? k = kIc((DYb(), AYb), yYb) : k = kIc((DYb(), yYb), yYb);
            k *= 2;
            f = c.a.g;
            c.a.g = $wnd.Math.max(f, f + (k - f));
            g = c.b.g;
            c.b.g = $wnd.Math.max(g, g + (k - g));
            e = b;
        }
    }
}
function IEb(a, b) {
    var c;
    if (a.e) throw scb(new Web((ceb(PM), Hte + PM.k + Ite)));
    if (!bEb(a.a, b)) throw scb(new qz(Jte + b + Kte));
    if (b == a.d) return a;
    c = a.d;
    a.d = b;
    switch(c.g){
        case 0:
            switch(b.g){
                case 2:
                    FEb(a);
                    break;
                case 1:
                    NEb(a);
                    FEb(a);
                    break;
                case 4:
                    TEb(a);
                    FEb(a);
                    break;
                case 3:
                    TEb(a);
                    NEb(a);
                    FEb(a);
            }
            break;
        case 2:
            switch(b.g){
                case 1:
                    NEb(a);
                    OEb(a);
                    break;
                case 4:
                    TEb(a);
                    FEb(a);
                    break;
                case 3:
                    TEb(a);
                    NEb(a);
                    FEb(a);
            }
            break;
        case 1:
            switch(b.g){
                case 2:
                    NEb(a);
                    OEb(a);
                    break;
                case 4:
                    NEb(a);
                    TEb(a);
                    FEb(a);
                    break;
                case 3:
                    NEb(a);
                    TEb(a);
                    NEb(a);
                    FEb(a);
            }
            break;
        case 4:
            switch(b.g){
                case 2:
                    TEb(a);
                    FEb(a);
                    break;
                case 1:
                    TEb(a);
                    NEb(a);
                    FEb(a);
                    break;
                case 3:
                    NEb(a);
                    OEb(a);
            }
            break;
        case 3:
            switch(b.g){
                case 2:
                    NEb(a);
                    TEb(a);
                    FEb(a);
                    break;
                case 1:
                    NEb(a);
                    TEb(a);
                    NEb(a);
                    FEb(a);
                    break;
                case 4:
                    NEb(a);
                    OEb(a);
            }
    }
    return a;
}
function FRb(a, b) {
    var c;
    if (a.d) throw scb(new Web((ceb(MO), Hte + MO.k + Ite)));
    if (!oRb(a.a, b)) throw scb(new qz(Jte + b + Kte));
    if (b == a.c) return a;
    c = a.c;
    a.c = b;
    switch(c.g){
        case 0:
            switch(b.g){
                case 2:
                    CRb(a);
                    break;
                case 1:
                    JRb(a);
                    CRb(a);
                    break;
                case 4:
                    NRb(a);
                    CRb(a);
                    break;
                case 3:
                    NRb(a);
                    JRb(a);
                    CRb(a);
            }
            break;
        case 2:
            switch(b.g){
                case 1:
                    JRb(a);
                    KRb(a);
                    break;
                case 4:
                    NRb(a);
                    CRb(a);
                    break;
                case 3:
                    NRb(a);
                    JRb(a);
                    CRb(a);
            }
            break;
        case 1:
            switch(b.g){
                case 2:
                    JRb(a);
                    KRb(a);
                    break;
                case 4:
                    JRb(a);
                    NRb(a);
                    CRb(a);
                    break;
                case 3:
                    JRb(a);
                    NRb(a);
                    JRb(a);
                    CRb(a);
            }
            break;
        case 4:
            switch(b.g){
                case 2:
                    NRb(a);
                    CRb(a);
                    break;
                case 1:
                    NRb(a);
                    JRb(a);
                    CRb(a);
                    break;
                case 3:
                    JRb(a);
                    KRb(a);
            }
            break;
        case 3:
            switch(b.g){
                case 2:
                    JRb(a);
                    NRb(a);
                    CRb(a);
                    break;
                case 1:
                    JRb(a);
                    NRb(a);
                    JRb(a);
                    CRb(a);
                    break;
                case 4:
                    JRb(a);
                    KRb(a);
            }
    }
    return a;
}
function Klc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    l = a.b;
    k = new Ajb(l, 0);
    zjb(k, new b$b(a));
    s = false;
    g = 1;
    while(k.b < k.d.gc()){
        j = (rDb(k.b < k.d.gc()), JD(k.d.Xb(k.c = k.b++), 25));
        p = (sDb(g, l.c.length), JD(l.c[g], 25));
        q = Zu(j.a);
        r = q.c.length;
        for(o = new rmb(q); o.a < o.c.c.length;){
            m = JD(pmb(o), 9);
            qYb(m, p);
        }
        if (s) {
            for(n = dv(q).Jc(); n.Ob();){
                m = JD(n.Pb(), 9);
                for(f = new rmb(Zu(hYb(m))); f.a < f.c.c.length;){
                    e = JD(pmb(f), 18);
                    fWb(e, true);
                    ZMb(a, (Iqc(), Mpc), (xdb(), true));
                    d = $lc(a, e, r);
                    c = JD(WMb(m, Gpc), 314);
                    t = JD(Mlb(d, d.c.length - 1), 18);
                    c.k = t.c.i;
                    c.n = t;
                    c.b = e.d.i;
                    c.c = e;
                }
            }
            s = false;
        } else if (q.c.length != 0) {
            b = (sDb(0, q.c.length), JD(q.c[0], 9));
            if (b.k == (DYb(), vYb)) {
                s = true;
                g = -1;
            }
        }
        ++g;
    }
    h = new Ajb(a.b, 0);
    while(h.b < h.d.gc()){
        i = (rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 25));
        i.a.c.length == 0 && tjb(h);
    }
}
function knd(a, b) {
    var c, d, e, f, g, h, i, j;
    if (RD(a.Ah(), 173)) {
        knd(JD(a.Ah(), 173), b);
        b.a += ' > ';
    } else b.a += 'Root ';
    c = a.zh().zb;
    cgb(c.substr(0, 3), 'Elk') ? Qgb(b, (ADb(3, c.length + 1), c.substr(3))) : (b.a += '' + c, b);
    e = a.hh();
    if (e) {
        Qgb((b.a += ' ', b), e);
        return;
    }
    if (RD(a, 359)) {
        j = JD(a, 153).a;
        if (j) {
            Qgb((b.a += ' ', b), j);
            return;
        }
    }
    for(g = new CHd(a.ih()); g.e != g.i.gc();){
        f = JD(AHd(g), 153);
        j = f.a;
        if (j) {
            Qgb((b.a += ' ', b), j);
            return;
        }
    }
    if (RD(a, 268)) {
        d = JD(a, 85);
        !d.b && (d.b = new ree(v3, d, 4, 7));
        if (d.b.i != 0 && (!d.c && (d.c = new ree(v3, d, 5, 8)), d.c.i != 0)) {
            b.a += ' (';
            h = new LHd((!d.b && (d.b = new ree(v3, d, 4, 7)), d.b));
            while(h.e != h.i.gc()){
                h.e > 0 && (b.a += Lqe, b);
                knd(JD(AHd(h), 173), b);
            }
            b.a += Fve;
            i = new LHd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c));
            while(i.e != i.i.gc()){
                i.e > 0 && (b.a += Lqe, b);
                knd(JD(AHd(i), 173), b);
            }
            b.a += ')';
        }
    }
}
function KMb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    for(i = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); i.e != i.i.gc();){
        h = JD(AHd(i), 27);
        for(e = new es(Ir($Bd(h).a.Jc(), new er)); cs(e);){
            d = JD(ds(e), 85);
            !d.b && (d.b = new ree(v3, d, 4, 7));
            if (!(d.b.i <= 1 && (!d.c && (d.c = new ree(v3, d, 5, 8)), d.c.i <= 1))) throw scb(new Z8c('Graph must not contain hyperedges.'));
            if (!Rtd(d) && h != _Bd(JD(nDd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c), 0), 84))) {
                j = new mNb;
                UMb(j, d);
                ZMb(j, (TOb(), ROb), d);
                jNb(j, JD(Wd(fsb(c.f, h)), 151));
                kNb(j, JD(Nib(c, _Bd(JD(nDd((!d.c && (d.c = new ree(v3, d, 5, 8)), d.c), 0), 84))), 151));
                Ilb(b.c, j);
                for(g = new CHd((!d.n && (d.n = new X0d(z3, d, 1, 7)), d.n)); g.e != g.i.gc();){
                    f = JD(AHd(g), 153);
                    k = new sNb(j, f.a);
                    UMb(k, f);
                    ZMb(k, ROb, f);
                    k.e.a = $wnd.Math.max(f.g, 1);
                    k.e.b = $wnd.Math.max(f.f, 1);
                    rNb(k);
                    Ilb(b.d, k);
                }
            }
        }
    }
}
function g8b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    c.Sg('Node promotion heuristic', 1);
    a.i = b;
    a.r = JD(WMb(b, (Bwc(), Zuc)), 242);
    a.r != (dyc(), Wxc) && a.r != Xxc ? e8b(a) : f8b(a);
    k = JD(WMb(a.i, Yuc), 17).a;
    f = new A8b;
    switch(a.r.g){
        case 2:
        case 1:
            j8b(a, f);
            break;
        case 3:
            a.r = cyc;
            j8b(a, f);
            i = 0;
            for(h = new rmb(a.b); h.a < h.c.c.length;){
                g = JD(pmb(h), 17);
                i = $wnd.Math.max(i, g.a);
            }
            if (i > a.k) {
                a.r = Yxc;
                j8b(a, f);
            }
            break;
        case 4:
            a.r = cyc;
            j8b(a, f);
            j = 0;
            for(e = new rmb(a.c); e.a < e.c.c.length;){
                d = MD(pmb(e));
                j = $wnd.Math.max(j, (tDb(d), d));
            }
            if (j > a.n) {
                a.r = _xc;
                j8b(a, f);
            }
            break;
        case 6:
            m = YD($wnd.Math.ceil(a.g.length * k / 100));
            j8b(a, new D8b(m));
            break;
        case 5:
            l = YD($wnd.Math.ceil(a.e * k / 100));
            j8b(a, new G8b(l));
            break;
        case 8:
            d8b(a, true);
            break;
        case 9:
            d8b(a, false);
            break;
        default:
            j8b(a, f);
    }
    a.r != Wxc && a.r != Xxc ? k8b(a, b) : l8b(a, b);
    c.Tg();
}
function QGb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    l = new NIb(a);
    kKb(l, !(b == (Tgd(), Sgd) || b == Ogd));
    k = l.a;
    m = new LYb;
    for(e = (iHb(), WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ])), g = 0, i = e.length; g < i; ++g){
        c = e[g];
        j = zHb(k, fHb, c);
        !!j && (m.d = $wnd.Math.max(m.d, j.ff()));
    }
    for(d = WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ]), f = 0, h = d.length; f < h; ++f){
        c = d[f];
        j = zHb(k, hHb, c);
        !!j && (m.a = $wnd.Math.max(m.a, j.ff()));
    }
    for(p = WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ]), r = 0, t = p.length; r < t; ++r){
        n = p[r];
        j = zHb(k, n, fHb);
        !!j && (m.b = $wnd.Math.max(m.b, j.gf()));
    }
    for(o = WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ]), q = 0, s = o.length; q < s; ++q){
        n = o[q];
        j = zHb(k, n, hHb);
        !!j && (m.c = $wnd.Math.max(m.c, j.gf()));
    }
    if (m.d > 0) {
        m.d += k.n.d;
        m.d += k.d;
    }
    if (m.a > 0) {
        m.a += k.n.a;
        m.a += k.d;
    }
    if (m.b > 0) {
        m.b += k.n.b;
        m.b += k.d;
    }
    if (m.c > 0) {
        m.c += k.n.c;
        m.c += k.d;
    }
    return m;
}
function G2b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    m = c.d;
    l = c.c;
    f = new Edd(c.f.a + c.d.b + c.d.c, c.f.b + c.d.d + c.d.a);
    g = f.b;
    for(j = new rmb(a.a); j.a < j.c.c.length;){
        h = JD(pmb(j), 9);
        if (h.k != (DYb(), wYb)) continue;
        d = JD(WMb(h, (Iqc(), Tpc)), 64);
        e = JD(WMb(h, Upc), 8);
        k = h.n;
        switch(d.g){
            case 2:
                k.a = c.f.a + m.c - l.a;
                break;
            case 4:
                k.a = -l.a - m.b;
        }
        o = 0;
        switch(d.g){
            case 2:
            case 4:
                if (b == (ajd(), Yid)) {
                    n = Beb(MD(WMb(h, tqc)));
                    k.b = f.b * n - JD(WMb(h, (Bwc(), Cvc)), 8).b;
                    o = k.b + e.b;
                    cYb(h, false, true);
                } else if (b == Xid) {
                    k.b = Beb(MD(WMb(h, tqc))) - JD(WMb(h, (Bwc(), Cvc)), 8).b;
                    o = k.b + e.b;
                    cYb(h, false, true);
                }
        }
        g = $wnd.Math.max(g, o);
    }
    c.f.b += g - f.b;
    for(i = new rmb(a.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 9);
        if (h.k != (DYb(), wYb)) continue;
        d = JD(WMb(h, (Iqc(), Tpc)), 64);
        k = h.n;
        switch(d.g){
            case 1:
                k.b = -l.b - m.d;
                break;
            case 3:
                k.b = c.f.b + m.a - l.b;
        }
    }
}
function yKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    k = JD(JD(Qc(a.r, b), 22), 83);
    if (k.gc() <= 2 || b == (Rjd(), wjd) || b == (Rjd(), Qjd)) {
        CKb(a, b);
        return;
    }
    p = a.u.Gc((ojd(), njd));
    c = b == (Rjd(), xjd) ? (xLb(), wLb) : (xLb(), tLb);
    r = b == xjd ? (GIb(), DIb) : (GIb(), FIb);
    d = fLb(kLb(c), a.s);
    q = b == xjd ? Kse : Lse;
    for(j = k.Jc(); j.Ob();){
        h = JD(j.Pb(), 115);
        if (!h.c || h.c.d.c.length <= 0) continue;
        o = h.b.Kf();
        n = h.e;
        l = h.c;
        m = l.i;
        m.b = (f = l.n, l.e.a + f.b + f.c);
        m.a = (g = l.n, l.e.b + g.d + g.a);
        if (p) {
            m.c = n.a - (e = l.n, l.e.a + e.b + e.c) - a.s;
            p = false;
        } else m.c = n.a + o.a + a.s;
        wub(r, bue);
        l.f = r;
        aIb(l, (PHb(), OHb));
        Ilb(d.d, new DLb(m, dLb(d, m)));
        q = b == xjd ? $wnd.Math.min(q, n.b) : $wnd.Math.max(q, n.b + h.b.Kf().b);
    }
    q += b == xjd ? -a.t : a.t;
    eLb((d.e = q, d));
    for(i = k.Jc(); i.Ob();){
        h = JD(i.Pb(), 115);
        if (!h.c || h.c.d.c.length <= 0) continue;
        m = h.c.i;
        m.c -= h.e.a;
        m.d -= h.e.b;
    }
}
function elc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    flc(a);
    d = 1;
    k = new Ulb;
    for(c = 0; c < a.b.c.length; c++){
        b = clc(JD(Mlb(a.b, c), 25));
        p = dlc(JD(Mlb(a.b, c), 25));
        if (JD(Mlb(a.b, c), 25).a.c.length > b) {
            q = new Ulb;
            Ilb(q, JD(Mlb(a.b, c), 25));
            for(f = 0; f < b - 1; f++){
                i = new b$b(a);
                Ilb(k, new xod(i, jfb(c + f + d)));
                YCb(q.c, i);
            }
            d += b - 1;
            o = (sDb(0, q.c.length), JD(q.c[0], 25)).a.c.length;
            for(e = 0, m = 0, r = 0; e < o; ++e, ++m, r++){
                l = JD(Mlb((sDb(0, q.c.length), JD(q.c[0], 25)).a, m), 9);
                if (l.k != (DYb(), zYb)) m += glc(a, q, r % b, m);
                else {
                    e -= 1;
                    r -= 1;
                }
                p && l.k == yYb && (r = -1);
            }
        }
    }
    for(j = new rmb(k); j.a < j.c.c.length;){
        i = JD(pmb(j), 47);
        Hlb(a.b, JD(i.b, 17).a, JD(i.a, 25));
    }
    for(h = new rmb(a.b); h.a < h.c.c.length;){
        g = JD(pmb(h), 25);
        n = new Ajb(g.a, 0);
        while(n.b < n.d.gc()){
            l = (rDb(n.b < n.d.gc()), JD(n.d.Xb(n.c = n.b++), 9));
            (l.k == (DYb(), CYb) || l.k == zYb) && tjb(n);
        }
    }
}
function NVb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    e = new Ulb;
    for(p = new rmb(b.a); p.a < p.c.c.length;){
        o = JD(pmb(p), 9);
        n = o.e;
        if (n) {
            d = NVb(a, n, o);
            Klb(e, d);
            KVb(a, n, o);
            if (JD(WMb(n, (Iqc(), Wpc)), 22).Gc(($oc(), Toc))) {
                s = JD(WMb(o, (Bwc(), Evc)), 100);
                m = JD(WMb(o, Hvc), 181).Gc((ojd(), kjd));
                for(r = new rmb(o.j); r.a < r.c.c.length;){
                    q = JD(pmb(r), 11);
                    f = JD(Nib(a.b, q), 9);
                    if (!f) {
                        f = pXb(q, s, q.j, -(q.e.c.length - q.g.c.length), null, new Cdd, q.o, JD(WMb(n, ruc), 86), n);
                        ZMb(f, kqc, q);
                        Qib(a.b, q, f);
                        Ilb(n.a, f);
                    }
                    g = JD(Mlb(f.j, 0), 11);
                    for(k = new rmb(q.f); k.a < k.c.c.length;){
                        j = JD(pmb(k), 72);
                        h = new HXb;
                        h.o.a = j.o.a;
                        h.o.b = j.o.b;
                        Ilb(g.f, h);
                        if (!m) {
                            t = q.j;
                            l = 0;
                            qjd(JD(WMb(o, Hvc), 22)) && (l = $md(j.n, j.o, q.o, 0, t));
                            s == (ajd(), $id) || (Rjd(), Bjd).Gc(t) ? h.o.a = l : h.o.b = l;
                        }
                    }
                }
            }
        }
    }
    i = new Ulb;
    JVb(a, b, c, e, i);
    !!c && LVb(a, b, c, i);
    return i;
}
function QCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    if (a.c[b.c.p][b.p].e) return;
    else a.c[b.c.p][b.p].e = true;
    a.c[b.c.p][b.p].b = 0;
    a.c[b.c.p][b.p].d = 0;
    a.c[b.c.p][b.p].a = null;
    for(k = new rmb(b.j); k.a < k.c.c.length;){
        j = JD(pmb(k), 11);
        l = c ? new dZb(j) : new lZb(j);
        for(i = l.Jc(); i.Ob();){
            h = JD(i.Pb(), 11);
            g = h.i;
            if (g.c == b.c) {
                if (g != b) {
                    QCc(a, g, c);
                    a.c[b.c.p][b.p].b += a.c[g.c.p][g.p].b;
                    a.c[b.c.p][b.p].d += a.c[g.c.p][g.p].d;
                }
            } else {
                a.c[b.c.p][b.p].d += a.g[h.p];
                ++a.c[b.c.p][b.p].b;
            }
        }
    }
    f = JD(WMb(b, (Iqc(), Epc)), 15);
    if (f) for(e = f.Jc(); e.Ob();){
        d = JD(e.Pb(), 9);
        if (b.c == d.c) {
            QCc(a, d, c);
            a.c[b.c.p][b.p].b += a.c[d.c.p][d.p].b;
            a.c[b.c.p][b.p].d += a.c[d.c.p][d.p].d;
        }
    }
    if (a.c[b.c.p][b.p].b > 0) {
        a.c[b.c.p][b.p].d += yvb(a.i, 24) * hte * 0.07000000029802322 - 0.03500000014901161;
        a.c[b.c.p][b.p].a = a.c[b.c.p][b.p].d / a.c[b.c.p][b.p].b;
    }
}
function P1b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    for(o = new rmb(a); o.a < o.c.c.length;){
        n = JD(pmb(o), 9);
        Q1b(n.n);
        Q1b(n.o);
        R1b(n.f);
        U1b(n);
        W1b(n);
        for(q = new rmb(n.j); q.a < q.c.c.length;){
            p = JD(pmb(q), 11);
            Q1b(p.n);
            Q1b(p.a);
            Q1b(p.o);
            aZb(p, V1b(p.j));
            f = JD(WMb(p, (Bwc(), Fvc)), 17);
            !!f && ZMb(p, Fvc, jfb(-f.a));
            for(e = new rmb(p.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                for(c = Gtb(d.a, 0); c.b != c.d.c;){
                    b = JD(Utb(c), 8);
                    Q1b(b);
                }
                i = JD(WMb(d, Ruc), 77);
                if (i) for(h = Gtb(i, 0); h.b != h.d.c;){
                    g = JD(Utb(h), 8);
                    Q1b(g);
                }
                for(l = new rmb(d.b); l.a < l.c.c.length;){
                    j = JD(pmb(l), 72);
                    Q1b(j.n);
                    Q1b(j.o);
                }
            }
            for(m = new rmb(p.f); m.a < m.c.c.length;){
                j = JD(pmb(m), 72);
                Q1b(j.n);
                Q1b(j.o);
            }
        }
        if (n.k == (DYb(), wYb)) {
            ZMb(n, (Iqc(), Tpc), V1b(JD(WMb(n, Tpc), 64)));
            T1b(n);
        }
        for(k = new rmb(n.b); k.a < k.c.c.length;){
            j = JD(pmb(k), 72);
            U1b(j);
            Q1b(j.o);
            Q1b(j.n);
        }
    }
}
function gKb(a) {
    aKb();
    var b, c, d, e, f, g, h;
    d = a.f.n;
    for(g = ii(a.r).a.nc(); g.Ob();){
        f = JD(g.Pb(), 115);
        e = 0;
        if (f.b.nf((Lgd(), Xfd))) {
            e = Beb(MD(f.b.mf(Xfd)));
            if (e < 0) switch(f.b.$f().g){
                case 1:
                    d.d = $wnd.Math.max(d.d, -e);
                    break;
                case 3:
                    d.a = $wnd.Math.max(d.a, -e);
                    break;
                case 2:
                    d.c = $wnd.Math.max(d.c, -e);
                    break;
                case 4:
                    d.b = $wnd.Math.max(d.b, -e);
            }
        }
        if (qjd(a.u)) {
            b = _md(f.b, e);
            h = !JD(a.e.mf(Gfd), 181).Gc((Nkd(), Ekd));
            c = false;
            switch(f.b.$f().g){
                case 1:
                    c = b > d.d;
                    d.d = $wnd.Math.max(d.d, b);
                    if (h && c) {
                        d.d = $wnd.Math.max(d.d, d.a);
                        d.a = d.d + e;
                    }
                    break;
                case 3:
                    c = b > d.a;
                    d.a = $wnd.Math.max(d.a, b);
                    if (h && c) {
                        d.a = $wnd.Math.max(d.a, d.d);
                        d.d = d.a + e;
                    }
                    break;
                case 2:
                    c = b > d.c;
                    d.c = $wnd.Math.max(d.c, b);
                    if (h && c) {
                        d.c = $wnd.Math.max(d.b, d.c);
                        d.b = d.c + e;
                    }
                    break;
                case 4:
                    c = b > d.b;
                    d.b = $wnd.Math.max(d.b, b);
                    if (h && c) {
                        d.b = $wnd.Math.max(d.b, d.c);
                        d.c = d.b + e;
                    }
            }
        }
    }
}
function hA(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = '';
    if (b.length == 0) return a.le(Tre, Rre, -1, -1);
    k = ugb(b);
    cgb(k.substr(0, 3), 'at ') && (k = (ADb(3, k.length + 1), k.substr(3)));
    k = k.replace(/\[.*?\]/g, '');
    g = k.indexOf('(');
    if (g == -1) {
        g = k.indexOf('@');
        if (g == -1) {
            j = k;
            k = '';
        } else {
            j = ugb((ADb(g + 1, k.length + 1), k.substr(g + 1)));
            k = ugb((zDb(0, g, k.length), k.substr(0, g)));
        }
    } else {
        c = k.indexOf(')', g);
        j = (zDb(g + 1, c, k.length), k.substr(g + 1, c - (g + 1)));
        k = ugb((zDb(0, g, k.length), k.substr(0, g)));
    }
    g = hgb(k, wgb(46));
    g != -1 && (k = (ADb(g + 1, k.length + 1), k.substr(g + 1)));
    (k.length == 0 || cgb(k, 'Anonymous function')) && (k = Rre);
    h = kgb(j, wgb(58));
    e = lgb(j, wgb(58), h - 1);
    i = -1;
    d = -1;
    f = Tre;
    if (h != -1 && e != -1) {
        f = (zDb(0, e, j.length), j.substr(0, e));
        i = bA((zDb(e + 1, h, j.length), j.substr(e + 1, h - (e + 1))));
        d = bA((ADb(h + 1, j.length + 1), j.substr(h + 1)));
    }
    return a.le(f, k, i, d);
}
function O_b(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    for(j = new rmb(a); j.a < j.c.c.length;){
        i = JD(pmb(j), 9);
        g = JD(WMb(i, (Bwc(), Uuc)), 171);
        f = null;
        switch(g.g){
            case 1:
            case 2:
                f = (Tnc(), Snc);
                break;
            case 3:
            case 4:
                f = (Tnc(), Qnc);
        }
        if (f) {
            ZMb(i, (Iqc(), Npc), (Tnc(), Snc));
            f == Qnc ? R_b(i, g, (Eyc(), Byc)) : f == Snc && R_b(i, g, (Eyc(), Cyc));
        } else if (cjd(JD(WMb(i, Evc), 100)) && i.j.c.length != 0) {
            b = true;
            for(l = new rmb(i.j); l.a < l.c.c.length;){
                k = JD(pmb(l), 11);
                if (!(k.j == (Rjd(), wjd) && k.e.c.length - k.g.c.length > 0 || k.j == Qjd && k.e.c.length - k.g.c.length < 0)) {
                    b = false;
                    break;
                }
                for(e = new rmb(k.g); e.a < e.c.c.length;){
                    c = JD(pmb(e), 18);
                    h = JD(WMb(c.d.i, Uuc), 171);
                    if (h == (Oqc(), Lqc) || h == Mqc) {
                        b = false;
                        break;
                    }
                }
                for(d = new rmb(k.e); d.a < d.c.c.length;){
                    c = JD(pmb(d), 18);
                    h = JD(WMb(c.c.i, Uuc), 171);
                    if (h == (Oqc(), Jqc) || h == Kqc) {
                        b = false;
                        break;
                    }
                }
            }
            b && R_b(i, g, (Eyc(), Dyc));
        }
    }
}
function OHc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    w = 0;
    n = 0;
    for(l = new rmb(b.e); l.a < l.c.c.length;){
        k = JD(pmb(l), 9);
        m = 0;
        h = 0;
        i = c ? JD(WMb(k, KHc), 17).a : Lre;
        r = d ? JD(WMb(k, LHc), 17).a : Lre;
        j = $wnd.Math.max(i, r);
        for(t = new rmb(k.j); t.a < t.c.c.length;){
            s = JD(pmb(t), 11);
            u = k.n.b + s.n.b + s.a.b;
            if (d) for(g = new rmb(s.g); g.a < g.c.c.length;){
                f = JD(pmb(g), 18);
                p = f.d;
                o = p.i;
                if (b != a.a[o.p]) {
                    q = $wnd.Math.max(JD(WMb(o, KHc), 17).a, JD(WMb(o, LHc), 17).a);
                    v = JD(WMb(f, (Bwc(), Pvc)), 17).a;
                    if (v >= j && v >= q) {
                        m += o.n.b + p.n.b + p.a.b - u;
                        ++h;
                    }
                }
            }
            if (c) for(g = new rmb(s.e); g.a < g.c.c.length;){
                f = JD(pmb(g), 18);
                p = f.c;
                o = p.i;
                if (b != a.a[o.p]) {
                    q = $wnd.Math.max(JD(WMb(o, KHc), 17).a, JD(WMb(o, LHc), 17).a);
                    v = JD(WMb(f, (Bwc(), Pvc)), 17).a;
                    if (v >= j && v >= q) {
                        m += o.n.b + p.n.b + p.a.b - u;
                        ++h;
                    }
                }
            }
        }
        if (h > 0) {
            w += m / h;
            ++n;
        }
    }
    if (n > 0) {
        b.a = e * w / n;
        b.g = n;
    } else {
        b.a = 0;
        b.g = 0;
    }
}
function RGb(a, b, c, d) {
    var e, f, g, h, i;
    h = new NIb(b);
    tKb(h, d);
    e = true;
    if (!!a && a.nf((Lgd(), $ed))) {
        f = JD(a.mf((Lgd(), $ed)), 86);
        e = f == (Tgd(), Rgd) || f == Pgd || f == Qgd;
    }
    jKb(h, false);
    Llb(h.e.Pf(), new oKb(h, false, e));
    PJb(h, h.f, (iHb(), fHb), (Rjd(), xjd));
    PJb(h, h.f, hHb, Ojd);
    PJb(h, h.g, fHb, Qjd);
    PJb(h, h.g, hHb, wjd);
    RJb(h, xjd);
    RJb(h, Ojd);
    QJb(h, wjd);
    QJb(h, Qjd);
    aKb();
    g = h.A.Gc((ykd(), ukd)) && h.B.Gc((Nkd(), Ikd)) ? bKb(h) : null;
    !!g && FHb(h.a, g);
    gKb(h);
    IJb(h);
    RKb(h);
    DJb(h);
    rKb(h);
    JKb(h);
    zKb(h, xjd);
    zKb(h, Ojd);
    EJb(h);
    qKb(h);
    if (!c) return h.o;
    eKb(h);
    NKb(h);
    zKb(h, wjd);
    zKb(h, Qjd);
    i = h.B.Gc((Nkd(), Jkd));
    TJb(h, i, xjd);
    TJb(h, i, Ojd);
    UJb(h, i, wjd);
    UJb(h, i, Qjd);
    EBb(new RBb(null, new Gvb(new Zjb(h.i), 0)), new VJb);
    EBb(BBb(new RBb(null, ii(h.r).a.oc()), new XJb), new ZJb);
    fKb(h);
    h.e.Nf(h.o);
    EBb(new RBb(null, ii(h.r).a.oc()), new hKb);
    return h.o;
}
function VRb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    j = Kse;
    for(d = new rmb(a.a.b); d.a < d.c.c.length;){
        b = JD(pmb(d), 82);
        j = $wnd.Math.min(j, b.d.f.g.c + b.e.a);
    }
    n = new Mtb;
    for(g = new rmb(a.a.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 194);
        f.i = j;
        f.e == 0 && Dtb(n, f, n.c.b, n.c);
    }
    while(n.b != 0){
        f = JD(n.b == 0 ? null : (rDb(n.b != 0), Ktb(n, n.a.a)), 194);
        e = f.f.g.c;
        for(m = f.a.a.ec().Jc(); m.Ob();){
            k = JD(m.Pb(), 82);
            p = f.i + k.e.a;
            k.d.g || k.g.c < p ? k.o = p : k.o = k.g.c;
        }
        e -= f.f.o;
        f.b += e;
        a.c == (Tgd(), Qgd) || a.c == Ogd ? f.c += e : f.c -= e;
        for(l = f.a.a.ec().Jc(); l.Ob();){
            k = JD(l.Pb(), 82);
            for(i = k.f.Jc(); i.Ob();){
                h = JD(i.Pb(), 82);
                Ugd(a.c) ? o = a.f.wf(k, h) : o = a.f.xf(k, h);
                h.d.i = $wnd.Math.max(h.d.i, k.o + k.g.b + o - h.e.a);
                h.k || (h.d.i = $wnd.Math.max(h.d.i, h.g.c - h.e.a));
                --h.d.e;
                h.d.e == 0 && Atb(n, h.d);
            }
        }
    }
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 82);
        b.g.c = b.o;
    }
}
function WVc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    c.Sg(Wze, 1);
    m = (tUc(), $Tc);
    a.a == (vVc(), sVc) && (m = YTc);
    k = 0;
    pnb();
    b.gd(new VBd(m));
    f = b.gc();
    h = b.dd(b.gc());
    j = true;
    while(j && h.Sb()){
        s = JD(h.Ub(), 39);
        JD(WMb(s, m), 17).a == 0 ? --f : j = false;
    }
    w = b.hd(0, f);
    g = new Ntb(w);
    w = b.hd(f, b.gc());
    i = new Ntb(w);
    if (g.b == 0) for(p = Gtb(i, 0); p.b != p.d.c;){
        o = JD(Utb(p), 39);
        ZMb(o, lUc, jfb(k++));
    }
    else {
        l = g.b;
        for(v = Gtb(g, 0); v.b != v.d.c;){
            u = JD(Utb(v), 39);
            ZMb(u, lUc, jfb(k++));
            d = bRc(u);
            WVc(a, d, c.bh(1 / l | 0));
            hub(d, wnb(new VBd(lUc)));
            n = new Mtb;
            for(t = Gtb(d, 0); t.b != t.d.c;){
                s = JD(Utb(t), 39);
                for(r = Gtb(u.d, 0); r.b != r.d.c;){
                    q = JD(Utb(r), 65);
                    q.c == s && Dtb(n, q, n.c.b, n.c);
                }
            }
            Ltb(u.d);
            xe(u.d, n);
            h = Gtb(i, i.b);
            e = u.d.b;
            j = true;
            while(0 < e && j && h.Sb()){
                s = JD(h.Ub(), 39);
                if (JD(WMb(s, m), 17).a == 0) {
                    ZMb(s, lUc, jfb(k++));
                    --e;
                    h.Qb();
                } else j = false;
            }
        }
    }
    c.Tg();
}
function D5b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    b.Sg('Inverted port preprocessing', 1);
    k = a.b;
    j = new Ajb(k, 0);
    c = null;
    t = new Ulb;
    while(j.b < j.d.gc()){
        s = c;
        c = (rDb(j.b < j.d.gc()), JD(j.d.Xb(j.c = j.b++), 25));
        for(n = new rmb(t); n.a < n.c.c.length;){
            l = JD(pmb(n), 9);
            qYb(l, s);
        }
        t.c.length = 0;
        for(o = new rmb(c.a); o.a < o.c.c.length;){
            l = JD(pmb(o), 9);
            if (l.k != (DYb(), AYb)) continue;
            if (!cjd(JD(WMb(l, (Bwc(), Evc)), 100))) continue;
            for(r = nYb(l, (Eyc(), Byc), (Rjd(), wjd)).Jc(); r.Ob();){
                p = JD(r.Pb(), 11);
                i = p.e;
                h = JD(Tlb(i, SC(CP, Ive, 18, i.c.length, 0, 1)), 469);
                for(e = h, f = 0, g = e.length; f < g; ++f){
                    d = e[f];
                    B5b(a, p, d, t);
                }
            }
            for(q = nYb(l, Cyc, Qjd).Jc(); q.Ob();){
                p = JD(q.Pb(), 11);
                i = p.g;
                h = JD(Tlb(i, SC(CP, Ive, 18, i.c.length, 0, 1)), 469);
                for(e = h, f = 0, g = e.length; f < g; ++f){
                    d = e[f];
                    C5b(a, p, d, t);
                }
            }
        }
    }
    for(m = new rmb(t); m.a < m.c.c.length;){
        l = JD(pmb(m), 9);
        qYb(l, c);
    }
    b.Tg();
}
function VZc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    l = Beb(MD(ksd(a, (b_c(), Z$c))));
    if (ydb(LD(ksd(a, X$c)))) {
        k = JD(ksd(a, (xYc(), wYc)), 27);
        f = JD(nDd(Qtd(JD(nDd((!k.e && (k.e = new ree(x3, k, 7, 4)), k.e), (!k.e && (k.e = new ree(x3, k, 7, 4)), k.e).i - 1), 85)), 0), 27);
        d = JD(nDd(Qtd(JD(nDd((!k.e && (k.e = new ree(x3, k, 7, 4)), k.e), 0), 85)), 0), 27);
        g = new Edd(f.i + f.g / 2, f.j + f.f / 2);
        e = new Edd(d.i + d.g / 2, d.j + d.f / 2);
        c = l;
        c <= 0 && (c += $ze);
        m = $wnd.Math.acos((g.a * e.a + g.b * e.b) / ($wnd.Math.sqrt(g.a * g.a + g.b * g.b) * $wnd.Math.sqrt(e.a * e.a + e.b * e.b)));
        m <= 0 && (m += $ze);
        b = $wnd.Math.atan2(g.b, g.a);
        b <= 0 && (b += $ze);
        l = Aze - (b - c + m / 2);
    }
    for(i = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); i.e != i.i.gc();){
        h = JD(AHd(i), 27);
        j = new Edd(h.i + h.g / 2, h.j + h.f / 2);
        n = j.a * $wnd.Math.cos(l) - j.b * $wnd.Math.sin(l);
        j.b = j.a * $wnd.Math.sin(l) + j.b * $wnd.Math.cos(l);
        j.a = n;
        ftd(h, j.a - h.g / 2, j.b - h.f / 2);
    }
}
function B_b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    p = a.n;
    q = a.o;
    m = a.d;
    l = Beb(MD(kzc(a, (Bwc(), Tvc))));
    if (b) {
        k = l * (b.gc() - 1);
        n = 0;
        for(i = b.Jc(); i.Ob();){
            g = JD(i.Pb(), 9);
            k += g.o.a;
            n = $wnd.Math.max(n, g.o.b);
        }
        r = p.a - (k - q.a) / 2;
        f = p.b - m.d + n;
        d = q.a / (b.gc() + 1);
        e = d;
        for(h = b.Jc(); h.Ob();){
            g = JD(h.Pb(), 9);
            g.n.a = r;
            g.n.b = f - g.o.b;
            r += g.o.a + l;
            j = z_b(g);
            j.n.a = g.o.a / 2 - j.a.a;
            j.n.b = g.o.b;
            o = JD(WMb(g, (Iqc(), Hpc)), 11);
            if (o.e.c.length + o.g.c.length == 1) {
                o.n.a = e - o.a.a;
                o.n.b = 0;
                _Yb(o, a);
            }
            e += d;
        }
    }
    if (c) {
        k = l * (c.gc() - 1);
        n = 0;
        for(i = c.Jc(); i.Ob();){
            g = JD(i.Pb(), 9);
            k += g.o.a;
            n = $wnd.Math.max(n, g.o.b);
        }
        r = p.a - (k - q.a) / 2;
        f = p.b + q.b + m.a - n;
        d = q.a / (c.gc() + 1);
        e = d;
        for(h = c.Jc(); h.Ob();){
            g = JD(h.Pb(), 9);
            g.n.a = r;
            g.n.b = f;
            r += g.o.a + l;
            j = z_b(g);
            j.n.a = g.o.a / 2 - j.a.a;
            j.n.b = 0;
            o = JD(WMb(g, (Iqc(), Hpc)), 11);
            if (o.e.c.length + o.g.c.length == 1) {
                o.n.a = e - o.a.a;
                o.n.b = q.b;
                _Yb(o, a);
            }
            e += d;
        }
    }
}
function QOc(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = null;
    d == (gPc(), ePc) ? m = b : d == fPc && (m = c);
    for(p = m.a.ec().Jc(); p.Ob();){
        o = JD(p.Pb(), 11);
        q = Kdd(WC(OC(b2, 1), hre, 8, 0, [
            o.i.n,
            o.n,
            o.a
        ])).b;
        t = new Qrb;
        h = new Qrb;
        for(j = new xZb(o.b); omb(j.a) || omb(j.b);){
            i = JD(omb(j.a) ? pmb(j.a) : pmb(j.b), 18);
            if (ydb(LD(WMb(i, (Iqc(), xqc)))) != e) continue;
            if (Nlb(f, i, 0) != -1) {
                i.d == o ? r = i.c : r = i.d;
                s = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    r.i.n,
                    r.n,
                    r.a
                ])).b;
                if ($wnd.Math.abs(s - q) < 0.2) continue;
                s < q ? b.a._b(r) ? Nrb(t, new xod(ePc, i)) : Nrb(t, new xod(fPc, i)) : b.a._b(r) ? Nrb(h, new xod(ePc, i)) : Nrb(h, new xod(fPc, i));
            }
        }
        if (t.a.gc() > 1) {
            n = new APc(o, t, d);
            ofb(t, new qPc(a, n));
            YCb(g.c, n);
            for(l = t.a.ec().Jc(); l.Ob();){
                k = JD(l.Pb(), 47);
                Plb(f, k.b);
            }
        }
        if (h.a.gc() > 1) {
            n = new APc(o, h, d);
            ofb(h, new sPc(a, n));
            YCb(g.c, n);
            for(l = h.a.ec().Jc(); l.Ob();){
                k = JD(l.Pb(), 47);
                Plb(f, k.b);
            }
        }
    }
}
function T3b(a, b) {
    var c, d, e, f, g, h;
    if (!JD(WMb(b, (Iqc(), Wpc)), 22).Gc(($oc(), Toc))) return;
    for(h = new rmb(b.a); h.a < h.c.c.length;){
        f = JD(pmb(h), 9);
        if (f.k == (DYb(), AYb)) {
            e = JD(WMb(f, (Bwc(), cvc)), 139);
            a.c = $wnd.Math.min(a.c, f.n.a - e.b);
            a.a = $wnd.Math.max(a.a, f.n.a + f.o.a + e.c);
            a.d = $wnd.Math.min(a.d, f.n.b - e.d);
            a.b = $wnd.Math.max(a.b, f.n.b + f.o.b + e.a);
        }
    }
    for(g = new rmb(b.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        if (f.k != (DYb(), AYb)) switch(f.k.g){
            case 2:
                d = JD(WMb(f, (Bwc(), Uuc)), 171);
                if (d == (Oqc(), Kqc)) {
                    f.n.a = a.c - 10;
                    S3b(f, new $3b).Jb(new b4b(f));
                    break;
                }
                if (d == Mqc) {
                    f.n.a = a.a + 10;
                    S3b(f, new e4b).Jb(new h4b(f));
                    break;
                }
                c = JD(WMb(f, $pc), 312);
                if (c == (qpc(), ppc)) {
                    R3b(f).Jb(new k4b(f));
                    f.n.b = a.d - 10;
                    break;
                }
                if (c == npc) {
                    R3b(f).Jb(new n4b(f));
                    f.n.b = a.b + 10;
                    break;
                }
                break;
            default:
                throw scb(new Teb('The node type ' + f.k + ' is not supported by the ' + DR));
        }
    }
}
function s$b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q;
    i = new Edd(d.i + d.g / 2, d.j + d.f / 2);
    n = g$b(d);
    o = JD(ksd(b, (Bwc(), Evc)), 100);
    q = JD(ksd(d, Jvc), 64);
    if (!dLd(jsd(d), Dvc)) {
        d.i == 0 && d.j == 0 ? p = 0 : p = Xmd(d, q);
        msd(d, Dvc, p);
    }
    j = new Edd(b.g, b.f);
    e = pXb(d, o, q, n, j, i, new Edd(d.g, d.f), JD(WMb(c, ruc), 86), c);
    ZMb(e, (Iqc(), kqc), d);
    f = JD(Mlb(e.j, 0), 11);
    $Yb(f, q$b(d));
    ZMb(e, Hvc, (ojd(), mrb(mjd)));
    l = JD(ksd(b, Hvc), 181).Gc(kjd);
    for(h = new CHd((!d.n && (d.n = new X0d(z3, d, 1, 7)), d.n)); h.e != h.i.gc();){
        g = JD(AHd(h), 153);
        if (!ydb(LD(ksd(g, svc))) && !!g.a) {
            m = t$b(g);
            Ilb(f.f, m);
            if (!l) {
                k = 0;
                qjd(JD(ksd(b, Hvc), 22)) && (k = $md(new Edd(g.i, g.j), new Edd(g.g, g.f), new Edd(d.g, d.f), 0, q));
                switch(q.g){
                    case 2:
                    case 4:
                        m.o.a = k;
                        break;
                    case 1:
                    case 3:
                        m.o.b = k;
                }
            }
        }
    }
    ZMb(e, cwc, MD(ksd(Zwd(b), cwc)));
    ZMb(e, dwc, MD(ksd(Zwd(b), dwc)));
    ZMb(e, awc, MD(ksd(Zwd(b), awc)));
    Ilb(c.a, e);
    Qib(a.a, d, e);
}
function v$b(a, b, c, d, e, f) {
    var g, h, i, j, k, l;
    j = new bZb;
    UMb(j, b);
    aZb(j, JD(ksd(b, (Bwc(), Jvc)), 64));
    ZMb(j, (Iqc(), kqc), b);
    _Yb(j, c);
    l = j.o;
    l.a = b.g;
    l.b = b.f;
    k = j.n;
    k.a = b.i;
    k.b = b.j;
    Qib(a.a, b, j);
    g = xBb(FBb(DBb(new RBb(null, (!b.e && (b.e = new ree(x3, b, 7, 4)), new Gvb(b.e, 16))), new I$b), new A$b), new K$b(b));
    g || (g = xBb(FBb(DBb(new RBb(null, (!b.d && (b.d = new ree(x3, b, 8, 5)), new Gvb(b.d, 16))), new M$b), new C$b), new O$b(b)));
    g || (g = xBb(new RBb(null, (!b.e && (b.e = new ree(x3, b, 7, 4)), new Gvb(b.e, 16))), new Q$b));
    ZMb(j, Zpc, (xdb(), g ? true : false));
    wXb(j, f, e, JD(ksd(b, Cvc), 8));
    for(i = new CHd((!b.n && (b.n = new X0d(z3, b, 1, 7)), b.n)); i.e != i.i.gc();){
        h = JD(AHd(i), 153);
        !ydb(LD(ksd(h, svc))) && !!h.a && Ilb(j.f, t$b(h));
    }
    switch(e.g){
        case 2:
        case 1:
            (j.j == (Rjd(), xjd) || j.j == Ojd) && d.Ec(($oc(), Xoc));
            break;
        case 4:
        case 3:
            (j.j == (Rjd(), wjd) || j.j == Qjd) && d.Ec(($oc(), Xoc));
    }
    return j;
}
function Yyd(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    F = Nib(a.g, e);
    if (F == null) {
        F = new mC;
        o = JD(F, 147);
        t = b + '_s';
        u = t + f;
        n = new GC(u);
        kC(o, vDe, n);
    }
    D = JD(F, 147);
    Sxd(c, D);
    H = new mC;
    Uxd(H, 'x', syd(a, d, e.j));
    Uxd(H, 'y', tyd(a, d, e.k));
    kC(D, yDe, H);
    B = new mC;
    Uxd(B, 'x', syd(a, d, e.b));
    Uxd(B, 'y', tyd(a, d, e.c));
    kC(D, 'endPoint', B);
    m = yqe((!e.a && (e.a = new qVd(u3, e, 5)), e.a));
    p = !m;
    if (p) {
        A = new EB;
        g = new LAd(a, d, A);
        ofb((!e.a && (e.a = new qVd(u3, e, 5)), e.a), g);
        kC(D, oDe, A);
    }
    j = fud(e);
    v = !!j;
    v && Vxd(a.a, D, qDe, xyd(a, fud(e)));
    s = gud(e);
    w = !!s;
    w && Vxd(a.a, D, pDe, xyd(a, gud(e)));
    k = (!e.e && (e.e = new ree(w3, e, 10, 9)), e.e).i == 0;
    q = !k;
    if (q) {
        C = new EB;
        h = new NAd(a, C);
        ofb((!e.e && (e.e = new ree(w3, e, 10, 9)), e.e), h);
        kC(D, sDe, C);
    }
    l = (!e.g && (e.g = new ree(w3, e, 9, 10)), e.g).i == 0;
    r = !l;
    if (r) {
        G = new EB;
        i = new RAd(a, G);
        ofb((!e.g && (e.g = new ree(w3, e, 9, 10)), e.g), i);
        kC(D, rDe, G);
    }
}
function E_b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    b.Sg('Comment pre-processing', 1);
    c = 0;
    i = new rmb(a.a);
    while(i.a < i.c.c.length){
        h = JD(pmb(i), 9);
        if (ydb(LD(WMb(h, (Bwc(), Utc))))) {
            ++c;
            e = 0;
            d = null;
            j = null;
            for(o = new rmb(h.j); o.a < o.c.c.length;){
                m = JD(pmb(o), 11);
                e += m.e.c.length + m.g.c.length;
                if (m.e.c.length == 1) {
                    d = JD(Mlb(m.e, 0), 18);
                    j = d.c;
                }
                if (m.g.c.length == 1) {
                    d = JD(Mlb(m.g, 0), 18);
                    j = d.d;
                }
            }
            if (e == 1 && j.e.c.length + j.g.c.length == 1 && !ydb(LD(WMb(j.i, Utc)))) {
                F_b(h, d, j, j.i);
                qmb(i);
            } else {
                r = new Ulb;
                for(n = new rmb(h.j); n.a < n.c.c.length;){
                    m = JD(pmb(n), 11);
                    for(l = new rmb(m.g); l.a < l.c.c.length;){
                        k = JD(pmb(l), 18);
                        k.d.g.c.length == 0 || YCb(r.c, k);
                    }
                    for(g = new rmb(m.e); g.a < g.c.c.length;){
                        f = JD(pmb(g), 18);
                        f.c.e.c.length == 0 || YCb(r.c, f);
                    }
                }
                for(q = new rmb(r); q.a < q.c.c.length;){
                    p = JD(pmb(q), 18);
                    fWb(p, true);
                }
            }
        }
    }
    b.Zg() && b._g('Found ' + c + ' comment boxes');
    b.Tg();
}
function Jod(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    t = 0;
    o = 0;
    n = 0;
    m = 1;
    for(s = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); s.e != s.i.gc();){
        q = JD(AHd(s), 27);
        m += Gr(new es(Ir($Bd(q).a.Jc(), new er)));
        B = q.g;
        o = $wnd.Math.max(o, B);
        l = q.f;
        n = $wnd.Math.max(n, l);
        t += B * l;
    }
    p = (!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a).i;
    g = t + 2 * d * d * m * p;
    f = $wnd.Math.sqrt(g);
    i = $wnd.Math.max(f * c, o);
    h = $wnd.Math.max(f / c, n);
    for(r = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); r.e != r.i.gc();){
        q = JD(AHd(r), 27);
        C = e.b + (yvb(b, 26) * ete + yvb(b, 27) * fte) * (i - q.g);
        D = e.b + (yvb(b, 26) * ete + yvb(b, 27) * fte) * (h - q.f);
        htd(q, C);
        itd(q, D);
    }
    A = i + (e.b + e.c);
    w = h + (e.d + e.a);
    for(v = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); v.e != v.i.gc();){
        u = JD(AHd(v), 27);
        for(k = new es(Ir($Bd(u).a.Jc(), new er)); cs(k);){
            j = JD(ds(k), 85);
            Rtd(j) || Iod(j, b, A, w);
        }
    }
    A += e.b + e.c;
    w += e.d + e.a;
    mnd(a, A, w, false, true);
}
function Fdc(a) {
    var b, c, d, e;
    EBb(BBb(new RBb(null, new Gvb(a.a.b, 16)), new fec), new hec);
    Ddc(a);
    EBb(BBb(new RBb(null, new Gvb(a.a.b, 16)), new jec), new lec);
    if (a.c == (xhd(), vhd)) {
        EBb(BBb(DBb(new RBb(null, new Gvb(new Ojb(a.f), 1)), new tec), new vec), new xec(a));
        EBb(BBb(FBb(DBb(DBb(new RBb(null, new Gvb(a.d.b, 16)), new Bec), new Dec), new Fec), new Hec), new Jec(a));
    }
    EBb(BBb(DBb(new RBb(null, new Gvb(new Ojb(a.f), 1)), new Lec), new Nec), new Pec(a));
    e = new Edd(Kse, Kse);
    b = new Edd(Lse, Lse);
    for(d = new rmb(a.a.b); d.a < d.c.c.length;){
        c = JD(pmb(d), 60);
        e.a = $wnd.Math.min(e.a, c.d.c);
        e.b = $wnd.Math.min(e.b, c.d.d);
        b.a = $wnd.Math.max(b.a, c.d.c + c.d.b);
        b.b = $wnd.Math.max(b.b, c.d.d + c.d.a);
    }
    mdd(vdd(a.d.c), tdd(new Edd(e.a, e.b)));
    mdd(vdd(a.d.f), Bdd(new Edd(b.a, b.b), e));
    Edc(a, e, b);
    Tib(a.f);
    Tib(a.b);
    Tib(a.g);
    Tib(a.e);
    a.a.a.c.length = 0;
    a.a.b.c.length = 0;
    a.a = null;
    a.d = null;
}
function Rfe(a, b) {
    Pfe();
    var c, d, e, f, g, h, i;
    this.a = new Ufe(this);
    this.b = a;
    this.c = b;
    this.f = Xae(jae((Gfe(), Efe), b));
    if (this.f.dc()) {
        if ((h = mae(Efe, a)) == b) {
            this.e = true;
            this.d = new Ulb;
            this.f = new hOd;
            this.f.Ec(eGe);
            JD(Oae(iae(Efe, WSd(a)), ''), 29) == a && this.f.Ec(nae(Efe, WSd(a)));
            for(e = _9d(Efe, a).Jc(); e.Ob();){
                d = JD(e.Pb(), 178);
                switch(Tae(jae(Efe, d))){
                    case 4:
                        this.d.Ec(d);
                        break;
                    case 5:
                        this.f.Fc(Xae(jae(Efe, d)));
                        break;
                }
            }
        } else {
            Ife();
            if (JD(b, 69).uk()) {
                this.e = true;
                this.f = null;
                this.d = new Ulb;
                for(g = 0, i = (a.i == null && MTd(a), a.i).length; g < i; ++g){
                    d = (c = (a.i == null && MTd(a), a.i), g >= 0 && g < c.length ? c[g] : null);
                    for(f = Uae(jae(Efe, d)); f; f = Uae(jae(Efe, f)))f == b && this.d.Ec(d);
                }
            } else if (Tae(jae(Efe, b)) == 1 && !!h) {
                this.f = null;
                this.d = (ehe(), dhe);
            } else {
                this.f = null;
                this.e = true;
                this.d = (pnb(), new dob(b));
            }
        }
    } else {
        this.e = Tae(jae(Efe, b)) == 5;
        this.f.Fb(Ofe) && (this.f = Ofe);
    }
}
function BKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    c = 0;
    d = AKb(a, b);
    m = a.s;
    n = a.t;
    for(j = JD(JD(Qc(a.r, b), 22), 83).Jc(); j.Ob();){
        i = JD(j.Pb(), 115);
        if (!i.c || i.c.d.c.length <= 0) continue;
        o = i.b.Kf();
        h = i.b.nf((Lgd(), Xfd)) ? Beb(MD(i.b.mf(Xfd))) : 0;
        k = i.c;
        l = k.i;
        l.b = (g = k.n, k.e.a + g.b + g.c);
        l.a = (f = k.n, k.e.b + f.d + f.a);
        switch(b.g){
            case 1:
                l.c = i.a ? (o.a - l.b) / 2 : o.a + m;
                l.d = o.b + h + d;
                aIb(k, (PHb(), MHb));
                bIb(k, (GIb(), FIb));
                break;
            case 3:
                l.c = i.a ? (o.a - l.b) / 2 : o.a + m;
                l.d = -h - d - l.a;
                aIb(k, (PHb(), MHb));
                bIb(k, (GIb(), DIb));
                break;
            case 2:
                l.c = -h - d - l.b;
                if (i.a) {
                    e = a.v ? l.a : JD(Mlb(k.d, 0), 187).Kf().b;
                    l.d = (o.b - e) / 2;
                } else l.d = o.b + n;
                aIb(k, (PHb(), OHb));
                bIb(k, (GIb(), EIb));
                break;
            case 4:
                l.c = o.a + h + d;
                if (i.a) {
                    e = a.v ? l.a : JD(Mlb(k.d, 0), 187).Kf().b;
                    l.d = (o.b - e) / 2;
                } else l.d = o.b + n;
                aIb(k, (PHb(), NHb));
                bIb(k, (GIb(), EIb));
        }
        (b == (Rjd(), xjd) || b == Ojd) && (c = $wnd.Math.max(c, l.a));
    }
    c > 0 && (JD(Kqb(a.b, b), 126).a.b = c);
}
function I2b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    w = new Ulb;
    for(o = new rmb(a.b); o.a < o.c.c.length;){
        n = JD(pmb(o), 25);
        for(r = new rmb(n.a); r.a < r.c.c.length;){
            p = JD(pmb(r), 9);
            if (p.k != (DYb(), wYb)) continue;
            if (!XMb(p, (Iqc(), Spc))) continue;
            s = null;
            u = null;
            t = null;
            for(C = new rmb(p.j); C.a < C.c.c.length;){
                B = JD(pmb(C), 11);
                switch(B.j.g){
                    case 4:
                        s = B;
                        break;
                    case 2:
                        u = B;
                        break;
                    default:
                        t = B;
                }
            }
            v = JD(Mlb(t.g, 0), 18);
            k = new Sdd(v.a);
            j = new Fdd(t.n);
            mdd(j, p.n);
            l = Gtb(k, 0);
            Stb(l, j);
            A = Vdd(v.a);
            m = new Fdd(t.n);
            mdd(m, p.n);
            Dtb(A, m, A.c.b, A.c);
            D = JD(WMb(p, Spc), 9);
            F = JD(Mlb(D.j, 0), 11);
            i = JD(Tlb(s.e, SC(CP, Ive, 18, 0, 0, 1)), 469);
            for(d = i, f = 0, h = d.length; f < h; ++f){
                b = d[f];
                hWb(b, F);
                Ndd(b.a, b.a.b, k);
            }
            i = CXb(u.g);
            for(c = i, e = 0, g = c.length; e < g; ++e){
                b = c[e];
                gWb(b, F);
                Ndd(b.a, 0, A);
            }
            gWb(v, null);
            hWb(v, null);
            YCb(w.c, p);
        }
    }
    for(q = new rmb(w); q.a < q.c.c.length;){
        p = JD(pmb(q), 9);
        qYb(p, null);
    }
}
function J5b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p;
    m = Beb(MD(WMb(a, (Bwc(), cwc))));
    n = Beb(MD(WMb(a, dwc)));
    l = Beb(MD(WMb(a, awc)));
    h = a.o;
    f = JD(Mlb(a.j, 0), 11);
    g = f.n;
    p = H5b(f, l);
    if (!p) return;
    if (b.Gc((ojd(), kjd))) switch(JD(WMb(a, (Iqc(), Tpc)), 64).g){
        case 1:
            p.c = (h.a - p.b) / 2 - g.a;
            p.d = n;
            break;
        case 3:
            p.c = (h.a - p.b) / 2 - g.a;
            p.d = -n - p.a;
            break;
        case 2:
            if (c && f.e.c.length == 0 && f.g.c.length == 0) {
                k = d ? p.a : JD(Mlb(f.f, 0), 72).o.b;
                p.d = (h.b - k) / 2 - g.b;
            } else p.d = h.b + n - g.b;
            p.c = -m - p.b;
            break;
        case 4:
            if (c && f.e.c.length == 0 && f.g.c.length == 0) {
                k = d ? p.a : JD(Mlb(f.f, 0), 72).o.b;
                p.d = (h.b - k) / 2 - g.b;
            } else p.d = h.b + n - g.b;
            p.c = m;
    }
    else if (b.Gc(mjd)) switch(JD(WMb(a, (Iqc(), Tpc)), 64).g){
        case 1:
        case 3:
            p.c = g.a + m;
            break;
        case 2:
        case 4:
            if (c && !f.c) {
                k = d ? p.a : JD(Mlb(f.f, 0), 72).o.b;
                p.d = (h.b - k) / 2 - g.b;
            } else p.d = g.b + n;
    }
    e = p.d;
    for(j = new rmb(f.f); j.a < j.c.c.length;){
        i = JD(pmb(j), 72);
        o = i.n;
        o.a = p.c;
        o.b = e;
        e += i.o.b + l;
    }
}
function NIb(a) {
    var b;
    this.r = Ly(new QIb, new UIb);
    this.b = new Oqb(JD(Qb(v2), 295));
    this.p = new Oqb(JD(Qb(v2), 295));
    this.i = new Oqb(JD(Qb(vN), 295));
    this.e = a;
    this.o = new Fdd(a.Kf());
    this.D = ydb(LD(a.mf((Lgd(), Dgd))));
    this.F = a.Wf() || ydb(LD(a.mf(lfd)));
    this.A = JD(a.mf(Bfd), 22);
    this.B = JD(a.mf(Gfd), 22);
    this.q = JD(a.mf(Yfd), 100);
    this.u = JD(a.mf(agd), 22);
    if (!rjd(this.u)) throw scb(new Y8c('Invalid port label placement: ' + this.u));
    this.v = ydb(LD(a.mf(cgd)));
    this.j = JD(a.mf(zfd), 22);
    if (!Gid(this.j)) throw scb(new Y8c('Invalid node label placement: ' + this.j));
    this.n = JD(Pnd(a, xfd), 107);
    this.k = Beb(MD(Pnd(a, tgd)));
    this.d = Beb(MD(Pnd(a, sgd)));
    this.w = Beb(MD(Pnd(a, Agd)));
    this.s = Beb(MD(Pnd(a, ugd)));
    this.t = Beb(MD(Pnd(a, vgd)));
    this.C = JD(Pnd(a, ygd), 139);
    this.c = 2 * this.d;
    b = !this.B.Gc((Nkd(), Ekd));
    this.f = new oIb(0, b, 0);
    this.g = new oIb(1, b, 0);
    nIb(this.f, (iHb(), gHb), this.g);
}
function Yie() {
    kNd(Nab, new Dje);
    kNd(Pab, new ike);
    kNd(Qab, new Pke);
    kNd(Rab, new ule);
    kNd(hJ, new Gle);
    kNd(OC($D, 1), new Jle);
    kNd(GI, new Mle);
    kNd(HI, new Ple);
    kNd(hJ, new _ie);
    kNd(hJ, new cje);
    kNd(hJ, new fje);
    kNd(LI, new ije);
    kNd(hJ, new lje);
    kNd(HK, new oje);
    kNd(HK, new rje);
    kNd(hJ, new uje);
    kNd(QI, new xje);
    kNd(hJ, new Aje);
    kNd(hJ, new Gje);
    kNd(hJ, new Jje);
    kNd(hJ, new Mje);
    kNd(hJ, new Pje);
    kNd(OC($D, 1), new Sje);
    kNd(hJ, new Vje);
    kNd(hJ, new Yje);
    kNd(HK, new _je);
    kNd(HK, new cke);
    kNd(hJ, new fke);
    kNd(UI, new lke);
    kNd(hJ, new oke);
    kNd(XI, new rke);
    kNd(hJ, new uke);
    kNd(hJ, new xke);
    kNd(hJ, new Ake);
    kNd(hJ, new Dke);
    kNd(HK, new Gke);
    kNd(HK, new Jke);
    kNd(hJ, new Mke);
    kNd(hJ, new Ske);
    kNd(hJ, new Vke);
    kNd(hJ, new Yke);
    kNd(hJ, new _ke);
    kNd(hJ, new cle);
    kNd(cJ, new fle);
    kNd(hJ, new ile);
    kNd(hJ, new lle);
    kNd(hJ, new ole);
    kNd(cJ, new rle);
    kNd(XI, new xle);
    kNd(hJ, new Ale);
    kNd(UI, new Dle);
}
function Vlc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    k = new Rdd;
    switch(a.a.g){
        case 3:
            m = JD(WMb(b.e, (Iqc(), Dqc)), 15);
            n = JD(WMb(b.j, Dqc), 15);
            o = JD(WMb(b.f, Dqc), 15);
            c = JD(WMb(b.e, Bqc), 15);
            d = JD(WMb(b.j, Bqc), 15);
            e = JD(WMb(b.f, Bqc), 15);
            g = new Ulb;
            Klb(g, m);
            n.Ic(new Ylc);
            Klb(g, dv(n));
            Klb(g, o);
            f = new Ulb;
            Klb(f, c);
            Klb(f, dv(d));
            Klb(f, e);
            ZMb(b.f, Dqc, g);
            ZMb(b.f, Bqc, f);
            ZMb(b.f, Eqc, b.f);
            ZMb(b.e, Dqc, null);
            ZMb(b.e, Bqc, null);
            ZMb(b.j, Dqc, null);
            ZMb(b.j, Bqc, null);
            break;
        case 1:
            xe(k, b.e.a);
            Atb(k, b.i.n);
            xe(k, dv(b.j.a));
            Atb(k, b.a.n);
            xe(k, b.f.a);
            break;
        default:
            xe(k, b.e.a);
            xe(k, dv(b.j.a));
            xe(k, b.f.a);
    }
    Ltb(b.f.a);
    xe(b.f.a, k);
    gWb(b.f, b.e.c);
    h = JD(WMb(b.e, (Bwc(), Ruc)), 77);
    j = JD(WMb(b.j, Ruc), 77);
    i = JD(WMb(b.f, Ruc), 77);
    if (!!h || !!j || !!i) {
        l = new Rdd;
        Tlc(l, i);
        Tlc(l, j);
        Tlc(l, h);
        ZMb(b.f, Ruc, l);
    }
    gWb(b.j, null);
    hWb(b.j, null);
    gWb(b.e, null);
    hWb(b.e, null);
    qYb(b.a, null);
    qYb(b.i, null);
    !!b.g && Vlc(a, b.g);
}
function khb() {
    khb = Zcb;
    var a, b, c;
    new rhb(1, 0);
    new rhb(10, 0);
    new rhb(0, 0);
    chb = SC(kJ, hre, 245, 11, 0, 1);
    dhb = SC(_D, Ure, 30, 100, 15, 1);
    ehb = WC(OC(aE, 1), Rse, 30, 15, [
        1,
        5,
        25,
        125,
        625,
        3125,
        15625,
        78125,
        390625,
        1953125,
        9765625,
        48828125,
        244140625,
        1220703125,
        6103515625,
        30517578125,
        152587890625,
        762939453125,
        3814697265625,
        19073486328125,
        95367431640625,
        476837158203125,
        2384185791015625
    ]);
    fhb = SC(cE, ise, 30, ehb.length, 15, 1);
    ghb = WC(OC(aE, 1), Rse, 30, 15, [
        1,
        10,
        100,
        Vre,
        10000,
        Sse,
        1000000,
        10000000,
        100000000,
        Ese,
        10000000000,
        100000000000,
        1000000000000,
        10000000000000,
        100000000000000,
        1000000000000000,
        10000000000000000
    ]);
    hhb = SC(cE, ise, 30, ghb.length, 15, 1);
    ihb = SC(kJ, hre, 245, 11, 0, 1);
    a = 0;
    for(; a < ihb.length; a++){
        chb[a] = new rhb(a, 0);
        ihb[a] = new rhb(0, a);
        dhb[a] = 48;
    }
    for(; a < dhb.length; a++)dhb[a] = 48;
    for(c = 0; c < fhb.length; c++)fhb[c] = thb(ehb[c]);
    for(b = 0; b < hhb.length; b++)hhb[b] = thb(ghb[b]);
    Cib();
}
function wsb() {
    function e() {
        this.obj = this.createObject();
    }
    e.prototype.createObject = function(a) {
        return Object.create(null);
    };
    e.prototype.get = function(a) {
        return this.obj[a];
    };
    e.prototype.set = function(a, b) {
        this.obj[a] = b;
    };
    e.prototype[dte] = function(a) {
        delete this.obj[a];
    };
    e.prototype.keys = function() {
        return Object.getOwnPropertyNames(this.obj);
    };
    e.prototype.entries = function() {
        var b = this.keys();
        var c = this;
        var d = 0;
        return {
            next: function() {
                if (d >= b.length) return {
                    done: true
                };
                var a = b[d++];
                return {
                    value: [
                        a,
                        c.get(a)
                    ],
                    done: false
                };
            }
        };
    };
    if (!usb()) {
        e.prototype.createObject = function() {
            return {};
        };
        e.prototype.get = function(a) {
            return this.obj[':' + a];
        };
        e.prototype.set = function(a, b) {
            this.obj[':' + a] = b;
        };
        e.prototype[dte] = function(a) {
            delete this.obj[':' + a];
        };
        e.prototype.keys = function() {
            var a = [];
            for(var b in this.obj)b.charCodeAt(0) == 58 && a.push(b.substring(1));
            return a;
        };
    }
    return e;
}
function tUc() {
    tUc = Zcb;
    kUc = new KBd(eve);
    new KBd(fve);
    new LBd('DEPTH', jfb(0));
    $Tc = new LBd('FAN', jfb(0));
    YTc = new LBd(Lze, jfb(0));
    qUc = new LBd('ROOT', (xdb(), false));
    eUc = new LBd('LEFTNEIGHBOR', null);
    oUc = new LBd('RIGHTNEIGHBOR', null);
    fUc = new LBd('LEFTSIBLING', null);
    pUc = new LBd('RIGHTSIBLING', null);
    ZTc = new LBd('DUMMY', false);
    new LBd('LEVEL', jfb(0));
    nUc = new LBd('REMOVABLE_EDGES', new Mtb);
    rUc = new LBd('XCOOR', jfb(0));
    sUc = new LBd('YCOOR', jfb(0));
    gUc = new LBd('LEVELHEIGHT', 0);
    iUc = new LBd('LEVELMIN', 0);
    hUc = new LBd('LEVELMAX', 0);
    aUc = new LBd('GRAPH_XMIN', 0);
    cUc = new LBd('GRAPH_YMIN', 0);
    _Tc = new LBd('GRAPH_XMAX', 0);
    bUc = new LBd('GRAPH_YMAX', 0);
    XTc = new LBd('COMPACT_LEVEL_ASCENSION', false);
    WTc = new LBd('COMPACT_CONSTRAINTS', new Ulb);
    dUc = new LBd('ID', '');
    lUc = new LBd('POSITION', jfb(0));
    mUc = new LBd('PRELIM', 0);
    jUc = new LBd('MODIFIER', 0);
    VTc = new KBd(gve);
    UTc = new KBd(hve);
}
function Wle(a) {
    Ule();
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (a == null) return null;
    l = a.length * 8;
    if (l == 0) return '';
    h = l % 24;
    n = l / 24 | 0;
    m = h != 0 ? n + 1 : n;
    f = null;
    f = SC(_D, Ure, 30, m * 4, 15, 1);
    j = 0;
    k = 0;
    b = 0;
    c = 0;
    d = 0;
    g = 0;
    e = 0;
    for(i = 0; i < n; i++){
        b = a[e++];
        c = a[e++];
        d = a[e++];
        k = (c & 15) << 24 >> 24;
        j = (b & 3) << 24 >> 24;
        o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
        p = (c & -128) == 0 ? c >> 4 << 24 >> 24 : (c >> 4 ^ 240) << 24 >> 24;
        q = (d & -128) == 0 ? d >> 6 << 24 >> 24 : (d >> 6 ^ 252) << 24 >> 24;
        f[g++] = Tle[o];
        f[g++] = Tle[p | j << 4];
        f[g++] = Tle[k << 2 | q];
        f[g++] = Tle[d & 63];
    }
    if (h == 8) {
        b = a[e];
        j = (b & 3) << 24 >> 24;
        o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
        f[g++] = Tle[o];
        f[g++] = Tle[j << 4];
        f[g++] = 61;
        f[g++] = 61;
    } else if (h == 16) {
        b = a[e];
        c = a[e + 1];
        k = (c & 15) << 24 >> 24;
        j = (b & 3) << 24 >> 24;
        o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
        p = (c & -128) == 0 ? c >> 4 << 24 >> 24 : (c >> 4 ^ 240) << 24 >> 24;
        f[g++] = Tle[o];
        f[g++] = Tle[p | j << 4];
        f[g++] = Tle[k << 2];
        f[g++] = 61;
    }
    return zgb(f, 0, f.length);
}
function uB(a, b) {
    var c, d, e, f, g, h, i;
    a.e == 0 && a.p > 0 && (a.p = -(a.p - 1));
    a.p > Lre && lB(b, a.p - hse);
    g = b.q.getDate();
    fB(b, 1);
    a.k >= 0 && iB(b, a.k);
    if (a.c >= 0) fB(b, a.c);
    else if (a.k >= 0) {
        i = new nB(b.q.getFullYear() - hse, b.q.getMonth(), 35);
        d = 35 - i.q.getDate();
        fB(b, $wnd.Math.min(d, g));
    } else fB(b, g);
    a.f < 0 && (a.f = b.q.getHours());
    a.b > 0 && a.f < 12 && (a.f += 12);
    gB(b, a.f == 24 && a.g ? 0 : a.f);
    a.j >= 0 && hB(b, a.j);
    a.n >= 0 && jB(b, a.n);
    a.i >= 0 && kB(b, tcb(Fcb(xcb(zcb(b.q.getTime()), Vre), Vre), a.i));
    if (a.a) {
        e = new mB;
        lB(e, e.q.getFullYear() - hse - 80);
        Dcb(zcb(b.q.getTime()), zcb(e.q.getTime())) && lB(b, e.q.getFullYear() - hse + 100);
    }
    if (a.d >= 0) {
        if (a.c == -1) {
            c = (7 + a.d - b.q.getDay()) % 7;
            c > 3 && (c -= 7);
            h = b.q.getMonth();
            fB(b, b.q.getDate() + c);
            b.q.getMonth() != h && fB(b, b.q.getDate() + (c > 0 ? -7 : 7));
        } else {
            if (b.q.getDay() != a.d) return false;
        }
    }
    if (a.o > Lre) {
        f = b.q.getTimezoneOffset();
        kB(b, tcb(zcb(b.q.getTime()), (a.o - f) * 60 * Vre));
    }
    return true;
}
function V$b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    e = WMb(b, (Iqc(), kqc));
    if (!RD(e, 206)) return;
    o = JD(e, 27);
    p = b.e;
    m = new Fdd(b.c);
    f = b.d;
    m.a += f.b;
    m.b += f.d;
    u = JD(ksd(o, (Bwc(), rvc)), 181);
    if (rrb(u, (Nkd(), Fkd))) {
        n = JD(ksd(o, tvc), 107);
        OXb(n, f.a);
        RXb(n, f.d);
        PXb(n, f.b);
        QXb(n, f.c);
    }
    c = new Ulb;
    for(k = new rmb(b.a); k.a < k.c.c.length;){
        i = JD(pmb(k), 9);
        if (RD(WMb(i, kqc), 206)) W$b(i, m);
        else if (RD(WMb(i, kqc), 193) && !p) {
            d = JD(WMb(i, kqc), 124);
            s = tXb(b, i, d.g, d.f);
            ftd(d, s.a, s.b);
        }
        for(r = new rmb(i.j); r.a < r.c.c.length;){
            q = JD(pmb(r), 11);
            EBb(BBb(new RBb(null, new Gvb(q.g, 16)), new a_b(i)), new c_b(c));
        }
    }
    if (p) for(r = new rmb(p.j); r.a < r.c.c.length;){
        q = JD(pmb(r), 11);
        EBb(BBb(new RBb(null, new Gvb(q.g, 16)), new e_b(p)), new g_b(c));
    }
    t = JD(ksd(o, yuc), 220);
    for(h = new rmb(c); h.a < h.c.c.length;){
        g = JD(pmb(h), 18);
        U$b(g, t, m);
    }
    X$b(b);
    for(j = new rmb(b.a); j.a < j.c.c.length;){
        i = JD(pmb(j), 9);
        l = i.e;
        !!l && V$b(a, l);
    }
}
function IKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    if (JD(JD(Qc(a.r, b), 22), 83).dc()) return;
    g = JD(Kqb(a.b, b), 126);
    i = g.i;
    h = g.n;
    k = MIb(a, b);
    d = i.b - h.b - h.c;
    e = g.a.a;
    f = i.c + h.b;
    n = a.w;
    if ((k == (Qid(), Nid) || k == Pid) && JD(JD(Qc(a.r, b), 22), 83).gc() == 1) {
        e = k == Nid ? e - 2 * a.w : e;
        k = Mid;
    }
    if (d < e && !a.B.Gc((Nkd(), Kkd))) {
        if (k == Nid) {
            n += (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() + 1);
            f += n;
        } else n += (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() - 1);
    } else {
        if (d < e) {
            e = k == Nid ? e - 2 * a.w : e;
            k = Mid;
        }
        switch(k.g){
            case 3:
                f += (d - e) / 2;
                break;
            case 4:
                f += d - e;
                break;
            case 0:
                c = (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() + 1);
                n += $wnd.Math.max(0, c);
                f += n;
                break;
            case 1:
                c = (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() - 1);
                n += $wnd.Math.max(0, c);
        }
    }
    for(m = JD(JD(Qc(a.r, b), 22), 83).Jc(); m.Ob();){
        l = JD(m.Pb(), 115);
        l.e.a = f + l.d.b;
        l.e.b = (j = l.b, j.nf((Lgd(), Xfd)) ? j.$f() == (Rjd(), xjd) ? -j.Kf().b - Beb(MD(j.mf(Xfd))) : Beb(MD(j.mf(Xfd))) : j.$f() == (Rjd(), xjd) ? -j.Kf().b : 0);
        f += l.d.b + l.b.Kf().a + l.d.c + n;
    }
}
function MKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if (JD(JD(Qc(a.r, b), 22), 83).dc()) return;
    g = JD(Kqb(a.b, b), 126);
    i = g.i;
    h = g.n;
    l = MIb(a, b);
    d = i.a - h.d - h.a;
    e = g.a.b;
    f = i.d + h.d;
    o = a.w;
    j = a.o.a;
    if ((l == (Qid(), Nid) || l == Pid) && JD(JD(Qc(a.r, b), 22), 83).gc() == 1) {
        e = l == Nid ? e - 2 * a.w : e;
        l = Mid;
    }
    if (d < e && !a.B.Gc((Nkd(), Kkd))) {
        if (l == Nid) {
            o += (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() + 1);
            f += o;
        } else o += (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() - 1);
    } else {
        if (d < e) {
            e = l == Nid ? e - 2 * a.w : e;
            l = Mid;
        }
        switch(l.g){
            case 3:
                f += (d - e) / 2;
                break;
            case 4:
                f += d - e;
                break;
            case 0:
                c = (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() + 1);
                o += $wnd.Math.max(0, c);
                f += o;
                break;
            case 1:
                c = (d - e) / (JD(JD(Qc(a.r, b), 22), 83).gc() - 1);
                o += $wnd.Math.max(0, c);
        }
    }
    for(n = JD(JD(Qc(a.r, b), 22), 83).Jc(); n.Ob();){
        m = JD(n.Pb(), 115);
        m.e.a = (k = m.b, k.nf((Lgd(), Xfd)) ? k.$f() == (Rjd(), Qjd) ? -k.Kf().a - Beb(MD(k.mf(Xfd))) : j + Beb(MD(k.mf(Xfd))) : k.$f() == (Rjd(), Qjd) ? -k.Kf().a : j);
        m.e.b = f + m.d.d;
        f += m.d.d + m.b.Kf().b + m.d.a + o;
    }
}
function eTc(a, b) {
    var c, d, e, f, g;
    b.Sg('Processor determine the coords for each level', 1);
    d = new Ulb;
    for(g = Gtb(a.b, 0); g.b != g.d.c;){
        e = JD(Utb(g), 39);
        while(JD(WMb(e, (kVc(), iVc)), 17).a > d.c.length - 1)Ilb(d, new xod(mze, Fze));
        c = JD(WMb(e, iVc), 17).a;
        if (Ugd(JD(WMb(a, KUc), 86))) {
            e.e.a < Beb(MD((sDb(c, d.c.length), JD(d.c[c], 47)).a)) && vod((sDb(c, d.c.length), JD(d.c[c], 47)), e.e.a);
            e.e.a + e.f.a > Beb(MD((sDb(c, d.c.length), JD(d.c[c], 47)).b)) && wod((sDb(c, d.c.length), JD(d.c[c], 47)), e.e.a + e.f.a);
        } else {
            e.e.b < Beb(MD((sDb(c, d.c.length), JD(d.c[c], 47)).a)) && vod((sDb(c, d.c.length), JD(d.c[c], 47)), e.e.b);
            e.e.b + e.f.b > Beb(MD((sDb(c, d.c.length), JD(d.c[c], 47)).b)) && wod((sDb(c, d.c.length), JD(d.c[c], 47)), e.e.b + e.f.b);
        }
    }
    for(f = Gtb(a.b, 0); f.b != f.d.c;){
        e = JD(Utb(f), 39);
        c = JD(WMb(e, (kVc(), iVc)), 17).a;
        ZMb(e, (tUc(), iUc), MD((sDb(c, d.c.length), JD(d.c[c], 47)).a));
        ZMb(e, hUc, MD((sDb(c, d.c.length), JD(d.c[c], 47)).b));
    }
    b.Tg();
}
function e8b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    a.o = Beb(MD(WMb(a.i, (Bwc(), ewc))));
    a.f = Beb(MD(WMb(a.i, $vc)));
    a.j = a.i.b.c.length;
    h = a.j - 1;
    m = 0;
    a.k = 0;
    a.n = 0;
    a.b = _u(SC(UI, hre, 17, a.j, 0, 1));
    a.c = _u(SC(LI, hre, 341, a.j, 7, 1));
    for(g = new rmb(a.i.b); g.a < g.c.c.length;){
        e = JD(pmb(g), 25);
        e.p = h;
        for(l = new rmb(e.a); l.a < l.c.c.length;){
            k = JD(pmb(l), 9);
            k.p = m;
            ++m;
        }
        --h;
    }
    a.g = SC(cE, ise, 30, m, 15, 1);
    a.d = QC(cE, [
        hre,
        ise
    ], [
        54,
        30
    ], 15, [
        m,
        3
    ], 2);
    a.p = new Ulb;
    a.q = new Ulb;
    b = 0;
    a.e = 0;
    for(f = new rmb(a.i.b); f.a < f.c.c.length;){
        e = JD(pmb(f), 25);
        h = e.p;
        d = 0;
        p = 0;
        i = e.a.c.length;
        j = 0;
        for(l = new rmb(e.a); l.a < l.c.c.length;){
            k = JD(pmb(l), 9);
            m = k.p;
            a.g[m] = k.c.p;
            j += k.o.b + a.o;
            c = Gr(new es(Ir(hYb(k).a.Jc(), new er)));
            o = Gr(new es(Ir(kYb(k).a.Jc(), new er)));
            a.d[m][0] = o - c;
            a.d[m][1] = c;
            a.d[m][2] = o;
            d += c;
            p += o;
            c > 0 && Ilb(a.q, k);
            Ilb(a.p, k);
        }
        b -= d;
        n = i + b;
        j += b * a.f;
        Rlb(a.b, h, jfb(n));
        Rlb(a.c, h, j);
        a.k = $wnd.Math.max(a.k, n);
        a.n = $wnd.Math.max(a.n, j);
        a.e += b;
        b += p;
    }
}
function wSc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    if (b.b != 0) {
        n = new Mtb;
        h = null;
        o = null;
        d = YD($wnd.Math.floor($wnd.Math.log(b.b) * $wnd.Math.LOG10E) + 1);
        i = 0;
        for(t = Gtb(b, 0); t.b != t.d.c;){
            r = JD(Utb(t), 39);
            if (XD(o) !== XD(WMb(r, (tUc(), dUc)))) {
                o = OD(WMb(r, dUc));
                i = 0;
            }
            o != null ? h = o + zSc(i++, d) : h = zSc(i++, d);
            ZMb(r, dUc, h);
            for(q = (e = Gtb(new gRc(r).a.d, 0), new jRc(e)); Ttb(q.a);){
                p = JD(Utb(q.a), 65).c;
                Dtb(n, p, n.c.b, n.c);
                ZMb(p, dUc, h);
            }
        }
        m = new Irb;
        for(g = 0; g < h.length - d; g++)for(s = Gtb(b, 0); s.b != s.d.c;){
            r = JD(Utb(s), 39);
            j = qgb(OD(WMb(r, (tUc(), dUc))), 0, g + 1);
            c = (j == null ? Wd(fsb(m.f, null)) : zsb(m.i, j)) != null ? JD(j == null ? Wd(fsb(m.f, null)) : zsb(m.i, j), 17).a + 1 : 1;
            Rib(m, j, jfb(c));
        }
        for(l = new mjb(new djb(m).a); l.b;){
            k = kjb(l);
            f = jfb(Nib(a.a, k.jd()) != null ? JD(Nib(a.a, k.jd()), 17).a : 0);
            Rib(a.a, OD(k.jd()), jfb(JD(k.kd(), 17).a + f.a));
            f = JD(Nib(a.b, k.jd()), 17);
            (!f || f.a < JD(k.kd(), 17).a) && Rib(a.b, OD(k.jd()), JD(k.kd(), 17));
        }
        wSc(a, n);
    }
}
function ejc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    c = null;
    i = null;
    e = JD(WMb(a.b, (Bwc(), Cuc)), 345);
    if (e == (Wyc(), Uyc)) {
        c = new Ulb;
        i = new Ulb;
    }
    for(h = new rmb(a.d); h.a < h.c.c.length;){
        g = JD(pmb(h), 105);
        f = g.i;
        if (!f) continue;
        switch(g.e.g){
            case 0:
                b = JD(Crb(new Drb(g.b)), 64);
                e == Uyc && b == (Rjd(), xjd) ? YCb(c.c, g) : e == Uyc && b == (Rjd(), Ojd) ? YCb(i.c, g) : cjc(g, b);
                break;
            case 1:
                j = g.a.d.j;
                k = g.c.d.j;
                j == (Rjd(), xjd) ? djc(g, xjd, (Dgc(), Agc), g.a) : k == xjd ? djc(g, xjd, (Dgc(), Bgc), g.c) : j == Ojd ? djc(g, Ojd, (Dgc(), Bgc), g.a) : k == Ojd && djc(g, Ojd, (Dgc(), Agc), g.c);
                break;
            case 2:
            case 3:
                d = g.b;
                rrb(d, (Rjd(), xjd)) ? rrb(d, Ojd) ? rrb(d, Qjd) ? rrb(d, wjd) || djc(g, xjd, (Dgc(), Bgc), g.c) : djc(g, xjd, (Dgc(), Agc), g.a) : djc(g, xjd, (Dgc(), zgc), null) : djc(g, Ojd, (Dgc(), zgc), null);
                break;
            case 4:
                l = g.a.d.j;
                m = g.a.d.j;
                l == (Rjd(), xjd) || m == xjd ? djc(g, Ojd, (Dgc(), zgc), null) : djc(g, xjd, (Dgc(), zgc), null);
        }
    }
    if (c) {
        c.c.length == 0 || bjc(c, (Rjd(), xjd));
        i.c.length == 0 || bjc(i, (Rjd(), Ojd));
    }
}
function rAc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    c.Sg('Breadth first model order layering', 1);
    a.a = b;
    q = new Ulb;
    for(p = new rmb(a.a.a); p.a < p.c.c.length;){
        n = JD(pmb(p), 9);
        n.k == (DYb(), AYb) && YCb(q.c, n);
    }
    pnb();
    Slb(q, new wAc);
    i = true;
    e = new b$b(a.a);
    d = null;
    Ilb(a.a.b, e);
    for(o = new rmb(q); o.a < o.c.c.length;){
        n = JD(pmb(o), 9);
        if (i) {
            qYb(n, e);
            i = false;
        } else {
            for(h = new es(Ir(hYb(n).a.Jc(), new er)); cs(h);){
                f = JD(ds(h), 18);
                if (f.c.i.k == (DYb(), AYb) && f.c.i.c == e || f.c.i.k == xYb && JD(ds(new es(Ir(hYb(f.c.i).a.Jc(), new er))), 18).c.i.c == e) {
                    d = new b$b(a.a);
                    Ilb(a.a.b, d);
                    e = new b$b(a.a);
                    Ilb(a.a.b, e);
                }
            }
            for(g = new es(Ir(hYb(n).a.Jc(), new er)); cs(g);){
                f = JD(ds(g), 18);
                f.c.i.k == (DYb(), xYb) && !f.c.i.c && qYb(f.c.i, d);
            }
            qYb(n, e);
        }
    }
    a.a.a.c.length = 0;
    r = new Ulb;
    for(l = new rmb(a.a.b); l.a < l.c.c.length;){
        j = JD(pmb(l), 25);
        j.a.c.length == 0 && YCb(r.c, j);
    }
    Be(a.a.b, r);
    m = 0;
    for(k = new rmb(a.a.b); k.a < k.c.c.length;){
        j = JD(pmb(k), 25);
        j.p = m;
        ++m;
    }
    c.Tg();
}
function Rjd() {
    Rjd = Zcb;
    var a;
    Pjd = new Vjd(eue, 0);
    xjd = new Vjd('NORTH', 1);
    wjd = new Vjd('EAST', 2);
    Ojd = new Vjd('SOUTH', 3);
    Qjd = new Vjd('WEST', 4);
    Cjd = (pnb(), new Apb((a = JD(deb(v2), 10), new urb(a, JD(VCb(a, a.length), 10), 0))));
    Djd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [])));
    yjd = aq(nrb(wjd, WC(OC(v2, 1), Ave, 64, 0, [])));
    Ljd = aq(nrb(Ojd, WC(OC(v2, 1), Ave, 64, 0, [])));
    Njd = aq(nrb(Qjd, WC(OC(v2, 1), Ave, 64, 0, [])));
    Ijd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        Ojd
    ])));
    Bjd = aq(nrb(wjd, WC(OC(v2, 1), Ave, 64, 0, [
        Qjd
    ])));
    Kjd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        Qjd
    ])));
    Ejd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        wjd
    ])));
    Mjd = aq(nrb(Ojd, WC(OC(v2, 1), Ave, 64, 0, [
        Qjd
    ])));
    zjd = aq(nrb(wjd, WC(OC(v2, 1), Ave, 64, 0, [
        Ojd
    ])));
    Hjd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        wjd,
        Qjd
    ])));
    Ajd = aq(nrb(wjd, WC(OC(v2, 1), Ave, 64, 0, [
        Ojd,
        Qjd
    ])));
    Jjd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        Ojd,
        Qjd
    ])));
    Fjd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        wjd,
        Ojd
    ])));
    Gjd = aq(nrb(xjd, WC(OC(v2, 1), Ave, 64, 0, [
        wjd,
        Ojd,
        Qjd
    ])));
}
function W$b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    d = JD(WMb(a, (Iqc(), kqc)), 27);
    o = JD(WMb(a, (Bwc(), muc)), 17).a;
    f = JD(WMb(a, Vuc), 17).a;
    msd(d, muc, jfb(o));
    msd(d, Vuc, jfb(f));
    htd(d, a.n.a + b.a);
    itd(d, a.n.b + b.b);
    if (JD(ksd(d, ovc), 181).gc() != 0 || !!a.e || XD(WMb(gYb(a), nvc)) === XD((Mxc(), Kxc)) && Axc((zxc(), (!a.q ? (pnb(), pnb(), nnb) : a.q)._b(lvc) ? m = JD(WMb(a, lvc), 203) : m = JD(WMb(gYb(a), mvc), 203), m))) {
        gtd(d, a.o.a);
        etd(d, a.o.b);
    }
    for(l = new rmb(a.j); l.a < l.c.c.length;){
        j = JD(pmb(l), 11);
        p = WMb(j, kqc);
        if (RD(p, 193)) {
            e = JD(p, 124);
            ftd(e, j.n.a, j.n.b);
            msd(e, Jvc, j.j);
        }
    }
    n = JD(WMb(a, gvc), 181).gc() != 0;
    for(i = new rmb(a.b); i.a < i.c.c.length;){
        g = JD(pmb(i), 72);
        if (n || JD(WMb(g, gvc), 181).gc() != 0) {
            c = JD(WMb(g, kqc), 153);
            dtd(c, g.o.a, g.o.b);
            ftd(c, g.n.a, g.n.b);
        }
    }
    if (!qjd(JD(WMb(a, Hvc), 22))) for(k = new rmb(a.j); k.a < k.c.c.length;){
        j = JD(pmb(k), 11);
        for(h = new rmb(j.f); h.a < h.c.c.length;){
            g = JD(pmb(h), 72);
            c = JD(WMb(g, kqc), 153);
            gtd(c, g.o.a);
            etd(c, g.o.b);
            ftd(c, g.n.a, g.n.b);
        }
    }
}
function $Yc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    b.Sg('Calculate Graph Size', 1);
    b.ah(a, _ze);
    l = mze;
    m = mze;
    j = aAe;
    k = aAe;
    for(p = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); p.e != p.i.gc();){
        n = JD(AHd(p), 27);
        s = n.i;
        t = n.j;
        C = n.g;
        h = n.f;
        i = JD(ksd(n, (Lgd(), vfd)), 139);
        l = $wnd.Math.min(l, s - i.b);
        m = $wnd.Math.min(m, t - i.d);
        j = $wnd.Math.max(j, s + C + i.c);
        k = $wnd.Math.max(k, t + h + i.a);
    }
    r = JD(ksd(a, (Lgd(), Kfd)), 107);
    q = new Edd(l - r.b, m - r.d);
    B = j - l + (r.b + r.c);
    g = k - m + (r.d + r.a);
    if (ydb(LD(ksd(a, (b_c(), J$c))))) {
        u = JD(ksd(a, (xYc(), wYc)), 27);
        v = JD(ksd(u, vfd), 139);
        w = u.i + u.g / 2 + (v.b + v.c) / 2 - q.a;
        A = u.j + u.f / 2 + (v.d + v.a) / 2 - q.b;
        e = B - w;
        f = g - A;
        if (e < B / 2) {
            c = e - w;
            B += c;
            q.a -= c;
        } else {
            c = w - e;
            B += c;
        }
        if (f < g / 2) {
            d = f - A;
            g += d;
            q.b -= d;
        } else {
            d = A - f;
            g += d;
        }
    }
    for(o = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); o.e != o.i.gc();){
        n = JD(AHd(o), 27);
        htd(n, n.i - q.a);
        itd(n, n.j - q.b);
    }
    if (!ydb(LD(ksd(a, Dfd)))) {
        gtd(a, B);
        etd(a, g);
    }
    msd(a, Ved, B - (r.b + r.c));
    msd(a, Ued, g - (r.d + r.a));
    b.ah(a, bAe);
}
function LOc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    a.e.a.$b();
    a.f.a.$b();
    a.c.c.length = 0;
    a.i.c.length = 0;
    a.g.a.$b();
    if (b) for(g = new rmb(b.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        for(l = oYb(f, (Rjd(), wjd)).Jc(); l.Ob();){
            k = JD(l.Pb(), 11);
            Nrb(a.e, k);
            for(e = new rmb(k.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                if (eWb(d)) continue;
                Ilb(a.c, d);
                ROc(a, d);
                h = d.c.i.k;
                (h == (DYb(), AYb) || h == BYb || h == wYb || h == vYb) && Ilb(a.j, d);
                n = d.d;
                m = n.i.c;
                m == c ? Nrb(a.f, n) : m == b ? Nrb(a.e, n) : Plb(a.c, d);
            }
        }
    }
    if (c) for(g = new rmb(c.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 9);
        for(j = new rmb(f.j); j.a < j.c.c.length;){
            i = JD(pmb(j), 11);
            for(e = new rmb(i.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                eWb(d) && Nrb(a.g, d);
            }
        }
        for(l = oYb(f, (Rjd(), Qjd)).Jc(); l.Ob();){
            k = JD(l.Pb(), 11);
            Nrb(a.f, k);
            for(e = new rmb(k.g); e.a < e.c.c.length;){
                d = JD(pmb(e), 18);
                if (eWb(d)) continue;
                Ilb(a.c, d);
                ROc(a, d);
                h = d.c.i.k;
                (h == (DYb(), AYb) || h == BYb || h == wYb || h == vYb) && Ilb(a.j, d);
                n = d.d;
                m = n.i.c;
                m == c ? Nrb(a.f, n) : m == b ? Nrb(a.e, n) : Plb(a.c, d);
            }
        }
    }
}
function lMc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    c.Sg('Polyline edge routing', 1);
    q = Beb(MD(WMb(b, (Bwc(), Auc))));
    n = Beb(MD(WMb(b, fwc)));
    e = Beb(MD(WMb(b, Xvc)));
    d = $wnd.Math.min(1, e / n);
    t = 0;
    i = 0;
    if (b.b.c.length != 0) {
        u = iMc(JD(Mlb(b.b, 0), 25));
        t = 0.4 * d * u;
    }
    h = new Ajb(b.b, 0);
    while(h.b < h.d.gc()){
        g = (rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 25));
        f = Yq(g, eMc);
        f && t > 0 && (t -= n);
        zXb(g, t);
        k = 0;
        for(m = new rmb(g.a); m.a < m.c.c.length;){
            l = JD(pmb(m), 9);
            j = 0;
            for(p = new es(Ir(kYb(l).a.Jc(), new er)); cs(p);){
                o = JD(ds(p), 18);
                r = WYb(o.c).b;
                s = WYb(o.d).b;
                if (g == o.d.i.c && !eWb(o)) {
                    mMc(o, t, 0.4 * d * $wnd.Math.abs(r - s));
                    if (o.c.j == (Rjd(), Qjd)) {
                        r = 0;
                        s = 0;
                    }
                }
                j = $wnd.Math.max(j, $wnd.Math.abs(s - r));
            }
            switch(l.k.g){
                case 0:
                case 4:
                case 1:
                case 3:
                case 5:
                    nMc(a, l, t, q);
            }
            k = $wnd.Math.max(k, j);
        }
        if (h.b < h.d.gc()) {
            u = iMc((rDb(h.b < h.d.gc()), JD(h.d.Xb(h.c = h.b++), 25)));
            k = $wnd.Math.max(k, u);
            rDb(h.b > 0);
            h.a.Xb(h.c = --h.b);
        }
        i = 0.4 * d * k;
        !f && h.b < h.d.gc() && (i += n);
        t += g.c.a + i;
    }
    a.a.a.$b();
    b.f.a = t;
    c.Tg();
}
function fCd(a) {
    var b, c, d, e, f;
    wub(a, JDe);
    switch((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b).i + (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c).i){
        case 0:
            throw scb(new Teb('The edge must have at least one source or target.'));
        case 1:
            return (!a.b && (a.b = new ree(v3, a, 4, 7)), a.b).i == 0 ? Zwd(_Bd(JD(nDd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c), 0), 84))) : Zwd(_Bd(JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84)));
    }
    if ((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b).i == 1 && (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c).i == 1) {
        e = _Bd(JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84));
        f = _Bd(JD(nDd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c), 0), 84));
        if (Zwd(e) == Zwd(f)) return Zwd(e);
        else if (e == Zwd(f)) return e;
        else if (f == Zwd(e)) return f;
    }
    d = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        (!a.b && (a.b = new ree(v3, a, 4, 7)), a.b),
        (!a.c && (a.c = new ree(v3, a, 5, 8)), a.c)
    ])));
    b = _Bd(JD(ds(d), 84));
    while(cs(d)){
        c = _Bd(JD(ds(d), 84));
        if (c != b && !kCd(c, b)) {
            if (Zwd(c) == Zwd(b)) b = Zwd(c);
            else {
                b = gCd(b, c);
                if (!b) return null;
            }
        }
    }
    return b;
}
function Dud(b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    n = c.length;
    if (n > 0) {
        j = (ADb(0, c.length), c.charCodeAt(0));
        if (j != 64) {
            if (j == 37) {
                m = c.lastIndexOf('%');
                k = false;
                if (m != 0 && (m == n - 1 || (k = (ADb(m + 1, c.length), c.charCodeAt(m + 1) == 46)))) {
                    h = (zDb(1, m, c.length), c.substr(1, m - 1));
                    u = cgb('%', h) ? null : JNd(h);
                    e = 0;
                    if (k) try {
                        e = Fdb((ADb(m + 2, c.length + 1), c.substr(m + 2)), Lre, Hqe);
                    } catch (a) {
                        a = rcb(a);
                        if (RD(a, 130)) {
                            i = a;
                            throw scb(new kOd(i));
                        } else throw scb(a);
                    }
                    for(r = i$d(b.Ch()); r.Ob();){
                        p = F$d(r);
                        if (RD(p, 503)) {
                            f = JD(p, 582);
                            t = f.d;
                            if ((u == null ? t == null : cgb(u, t)) && e-- == 0) return f;
                        }
                    }
                    return null;
                }
            }
            l = c.lastIndexOf('.');
            o = l == -1 ? c : (zDb(0, l, c.length), c.substr(0, l));
            d = 0;
            if (l != -1) try {
                d = Fdb((ADb(l + 1, c.length + 1), c.substr(l + 1)), Lre, Hqe);
            } catch (a) {
                a = rcb(a);
                if (RD(a, 130)) o = c;
                else throw scb(a);
            }
            o = cgb('%', o) ? null : JNd(o);
            for(q = i$d(b.Ch()); q.Ob();){
                p = F$d(q);
                if (RD(p, 197)) {
                    g = JD(p, 197);
                    s = g.ve();
                    if ((o == null ? s == null : cgb(o, s)) && d-- == 0) return g;
                }
            }
            return null;
        }
    }
    return tqd(b, c);
}
function efc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    k = new Irb;
    i = new Pp;
    for(d = new rmb(a.a.a.b); d.a < d.c.c.length;){
        b = JD(pmb(d), 60);
        j = mdc(b);
        if (j) gsb(k.f, j, b);
        else {
            s = ndc(b);
            if (s) for(f = new rmb(s.k); f.a < f.c.c.length;){
                e = JD(pmb(f), 18);
                Rc(i, e, b);
            }
        }
    }
    for(c = new rmb(a.a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        j = mdc(b);
        if (j) for(h = new es(Ir(kYb(j).a.Jc(), new er)); cs(h);){
            g = JD(ds(h), 18);
            if (eWb(g)) continue;
            o = g.c;
            r = g.d;
            if ((Rjd(), Ijd).Gc(g.c.j) && Ijd.Gc(g.d.j)) continue;
            p = JD(Nib(k, g.d.i), 60);
            DFb(GFb(FFb(HFb(EFb(new IFb, 0), 100), a.c[b.a.d]), a.c[p.a.d]));
            if (o.j == Qjd && CZb((VYb(), SYb, o))) for(m = JD(Qc(i, g), 22).Jc(); m.Ob();){
                l = JD(m.Pb(), 60);
                if (l.d.c < b.d.c) {
                    n = a.c[l.a.d];
                    q = a.c[b.a.d];
                    if (n == q) continue;
                    DFb(GFb(FFb(HFb(EFb(new IFb, 1), 100), n), q));
                }
            }
            if (r.j == wjd && HZb((VYb(), QYb, r))) for(m = JD(Qc(i, g), 22).Jc(); m.Ob();){
                l = JD(m.Pb(), 60);
                if (l.d.c > b.d.c) {
                    n = a.c[b.a.d];
                    q = a.c[l.a.d];
                    if (n == q) continue;
                    DFb(GFb(FFb(HFb(EFb(new IFb, 1), 100), n), q));
                }
            }
        }
    }
}
function xKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    m = JD(JD(Qc(a.r, b), 22), 83);
    if (b == (Rjd(), wjd) || b == Qjd) {
        BKb(a, b);
        return;
    }
    f = b == xjd ? (xLb(), tLb) : (xLb(), wLb);
    u = b == xjd ? (GIb(), FIb) : (GIb(), DIb);
    c = JD(Kqb(a.b, b), 126);
    d = c.i;
    e = d.c + Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        c.n.b,
        a.C.b,
        a.k
    ]));
    r = d.c + d.b - Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        c.n.c,
        a.C.c,
        a.k
    ]));
    g = fLb(kLb(f), a.t);
    s = b == xjd ? Lse : Kse;
    for(l = m.Jc(); l.Ob();){
        j = JD(l.Pb(), 115);
        if (!j.c || j.c.d.c.length <= 0) continue;
        q = j.b.Kf();
        p = j.e;
        n = j.c;
        o = n.i;
        o.b = (i = n.n, n.e.a + i.b + i.c);
        o.a = (h = n.n, n.e.b + h.d + h.a);
        wub(u, bue);
        n.f = u;
        aIb(n, (PHb(), OHb));
        o.c = p.a - (o.b - q.a) / 2;
        v = $wnd.Math.min(e, p.a);
        w = $wnd.Math.max(r, p.a + q.a);
        o.c < v ? o.c = v : o.c + o.b > w && (o.c = w - o.b);
        Ilb(g.d, new DLb(o, dLb(g, o)));
        s = b == xjd ? $wnd.Math.max(s, p.b + j.b.Kf().b) : $wnd.Math.min(s, p.b);
    }
    s += b == xjd ? a.t : -a.t;
    t = eLb((g.e = s, g));
    t > 0 && (JD(Kqb(a.b, b), 126).a.b = t);
    for(k = m.Jc(); k.Ob();){
        j = JD(k.Pb(), 115);
        if (!j.c || j.c.d.c.length <= 0) continue;
        o = j.c.i;
        o.c -= j.e.a;
        o.d -= j.e.b;
    }
}
function qib(a, b) {
    oib();
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    i = vcb(a, 0) < 0;
    i && (a = Gcb(a));
    if (vcb(a, 0) == 0) switch(b){
        case 0:
            return '0';
        case 1:
            return Vse;
        case 2:
            return '0.00';
        case 3:
            return '0.000';
        case 4:
            return '0.0000';
        case 5:
            return '0.00000';
        case 6:
            return '0.000000';
        default:
            n = new Ugb;
            b < 0 ? (n.a += '0E+', n) : (n.a += '0E', n);
            n.a += b == Lre ? '2147483648' : '' + -b;
            return n.a;
    }
    k = 18;
    l = SC(_D, Ure, 30, k + 1, 15, 1);
    c = k;
    p = a;
    do {
        j = p;
        p = xcb(p, 10);
        l[--c] = Pcb(tcb(48, Mcb(j, Fcb(p, 10)))) & Wre;
    }while (vcb(p, 0) != 0);
    e = Mcb(Mcb(Mcb(k, c), b), 1);
    if (b == 0) {
        i && (l[--c] = 45);
        return zgb(l, c, k - c);
    }
    if (b > 0 && vcb(e, -6) >= 0) {
        if (vcb(e, 0) >= 0) {
            f = c + Pcb(e);
            for(h = k - 1; h >= f; h--)l[h + 1] = l[h];
            l[++f] = 46;
            i && (l[--c] = 45);
            return zgb(l, c, k - c + 1);
        }
        for(g = 2; Dcb(g, tcb(Gcb(e), 1)); g++)l[--c] = 48;
        l[--c] = 46;
        l[--c] = 48;
        i && (l[--c] = 45);
        return zgb(l, c, k - c);
    }
    o = c + 1;
    d = k;
    m = new Vgb;
    i && (m.a += '-', m);
    if (d - o >= 1) {
        Kgb(m, l[c]);
        m.a += '.';
        m.a += zgb(l, c + 1, k - c - 1);
    } else m.a += zgb(l, c, k - c);
    m.a += 'E';
    vcb(e, 0) > 0 && (m.a += '+', m);
    m.a += '' + Qcb(e);
    return m.a;
}
function c_c(a) {
    Rad(a, new cad(jad(nad(kad(mad(lad(new pad, yAe), 'ELK Radial'), 'A radial layout provider which is based on the algorithm of Peter Eades published in "Drawing free trees.", published by International Institute for Advanced Study of Social Information Science, Fujitsu Limited in 1991. The radial layouter takes a tree and places the nodes in radial order around the root. The nodes of the same tree level are placed on the same radius.'), new f_c), yAe)));
    Pad(a, yAe, $ye, JBd(U$c));
    Pad(a, yAe, Mue, JBd(_$c));
    Pad(a, yAe, Yue, JBd(N$c));
    Pad(a, yAe, pve, JBd(O$c));
    Pad(a, yAe, Xue, JBd(P$c));
    Pad(a, yAe, Zue, JBd(M$c));
    Pad(a, yAe, Vue, JBd(Q$c));
    Pad(a, yAe, $ue, JBd(T$c));
    Pad(a, yAe, pAe, JBd(K$c));
    Pad(a, yAe, oAe, JBd(L$c));
    Pad(a, yAe, nAe, JBd(W$c));
    Pad(a, yAe, tAe, JBd(Z$c));
    Pad(a, yAe, uAe, JBd(X$c));
    Pad(a, yAe, vAe, JBd(Y$c));
    Pad(a, yAe, sAe, JBd(R$c));
    Pad(a, yAe, lAe, JBd(S$c));
    Pad(a, yAe, mAe, JBd(V$c));
    Pad(a, yAe, qAe, JBd($$c));
    Pad(a, yAe, rAe, JBd(a_c));
    Pad(a, yAe, kAe, JBd(J$c));
}
function mnd(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    q = new Edd(a.g, a.f);
    p = dnd(a);
    p.a = $wnd.Math.max(p.a, b);
    p.b = $wnd.Math.max(p.b, c);
    w = p.a / q.a;
    k = p.b / q.b;
    u = p.a - q.a;
    i = p.b - q.b;
    if (d) {
        g = !Zwd(a) ? JD(ksd(a, (Lgd(), $ed)), 86) : JD(ksd(Zwd(a), (Lgd(), $ed)), 86);
        h = XD(ksd(a, (Lgd(), Yfd))) === XD((ajd(), Xid));
        for(s = new CHd((!a.c && (a.c = new X0d(B3, a, 9, 9)), a.c)); s.e != s.i.gc();){
            r = JD(AHd(s), 124);
            t = JD(ksd(r, dgd), 64);
            if (t == (Rjd(), Pjd)) {
                t = Ymd(r, g);
                msd(r, dgd, t);
            }
            switch(t.g){
                case 1:
                    h || htd(r, r.i * w);
                    break;
                case 2:
                    htd(r, r.i + u);
                    h || itd(r, r.j * k);
                    break;
                case 3:
                    h || htd(r, r.i * w);
                    itd(r, r.j + i);
                    break;
                case 4:
                    h || itd(r, r.j * k);
            }
        }
    }
    dtd(a, p.a, p.b);
    if (e) for(m = new CHd((!a.n && (a.n = new X0d(z3, a, 1, 7)), a.n)); m.e != m.i.gc();){
        l = JD(AHd(m), 153);
        n = l.i + l.g / 2;
        o = l.j + l.f / 2;
        v = n / q.a;
        j = o / q.b;
        if (v + j >= 1) {
            if (v - j > 0 && o >= 0) {
                htd(l, l.i + u);
                itd(l, l.j + i * j);
            } else if (v - j < 0 && n >= 0) {
                htd(l, l.i + u * v);
                itd(l, l.j + i);
            }
        }
    }
    msd(a, (Lgd(), Bfd), (ykd(), f = JD(deb(z2), 10), new urb(f, JD(VCb(f, f.length), 10), 0)));
    return new Edd(w, k);
}
function Gdb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    if (a == null) throw scb(new Mfb(Rqe));
    j = a;
    f = a.length;
    i = false;
    if (f > 0) {
        b = (ADb(0, a.length), a.charCodeAt(0));
        if (b == 45 || b == 43) {
            a = (ADb(1, a.length + 1), a.substr(1));
            --f;
            i = b == 45;
        }
    }
    if (f == 0) throw scb(new Mfb(Jse + j + '"'));
    while(a.length > 0 && (ADb(0, a.length), a.charCodeAt(0) == 48)){
        a = (ADb(1, a.length + 1), a.substr(1));
        --f;
    }
    if (f > (Lfb(), Jfb)[10]) throw scb(new Mfb(Jse + j + '"'));
    for(e = 0; e < f; e++){
        if (Wdb((ADb(e, a.length), a.charCodeAt(e))) == -1) throw scb(new Mfb(Jse + j + '"'));
    }
    l = 0;
    g = Hfb[10];
    k = Ifb[10];
    h = Gcb(Kfb[10]);
    c = true;
    d = f % g;
    if (d > 0) {
        l = -parseInt((zDb(0, d, a.length), a.substr(0, d)), 10);
        a = (ADb(d, a.length + 1), a.substr(d));
        f -= d;
        c = false;
    }
    while(f >= g){
        d = parseInt((zDb(0, g, a.length), a.substr(0, g)), 10);
        a = (ADb(g, a.length + 1), a.substr(g));
        f -= g;
        if (c) c = false;
        else {
            if (vcb(l, h) < 0) throw scb(new Mfb(Jse + j + '"'));
            l = Fcb(l, k);
        }
        l = Mcb(l, d);
    }
    if (vcb(l, 0) > 0) throw scb(new Mfb(Jse + j + '"'));
    if (!i) {
        l = Gcb(l);
        if (vcb(l, 0) < 0) throw scb(new Mfb(Jse + j + '"'));
    }
    return l;
}
function JNd(a) {
    BNd();
    var b, c, d, e, f, g, h, i;
    if (a == null) return null;
    e = hgb(a, wgb(37));
    if (e < 0) return a;
    else {
        i = new Wgb((zDb(0, e, a.length), a.substr(0, e)));
        b = SC($D, ZCe, 30, 4, 15, 1);
        h = 0;
        d = 0;
        for(g = a.length; e < g; e++){
            ADb(e, a.length);
            if (a.charCodeAt(e) == 37 && a.length > e + 2 && UNd((ADb(e + 1, a.length), a.charCodeAt(e + 1)), qNd, rNd) && UNd((ADb(e + 2, a.length), a.charCodeAt(e + 2)), qNd, rNd)) {
                c = YNd((ADb(e + 1, a.length), a.charCodeAt(e + 1)), (ADb(e + 2, a.length), a.charCodeAt(e + 2)));
                e += 2;
                if (d > 0) (c & 192) == 128 ? b[h++] = c << 24 >> 24 : d = 0;
                else if (c >= 128) {
                    if ((c & 224) == 192) {
                        b[h++] = c << 24 >> 24;
                        d = 2;
                    } else if ((c & 240) == 224) {
                        b[h++] = c << 24 >> 24;
                        d = 3;
                    } else if ((c & 248) == 240) {
                        b[h++] = c << 24 >> 24;
                        d = 4;
                    }
                }
                if (d > 0) {
                    if (h == d) {
                        switch(h){
                            case 2:
                                Kgb(i, ((b[0] & 31) << 6 | b[1] & 63) & Wre);
                                break;
                            case 3:
                                Kgb(i, ((b[0] & 15) << 12 | (b[1] & 63) << 6 | b[2] & 63) & Wre);
                                break;
                        }
                        h = 0;
                        d = 0;
                    }
                } else {
                    for(f = 0; f < h; ++f)Kgb(i, b[f] & Wre);
                    h = 0;
                    i.a += String.fromCharCode(c);
                }
            } else {
                for(f = 0; f < h; ++f)Kgb(i, b[f] & Wre);
                h = 0;
                Kgb(i, (ADb(e, a.length), a.charCodeAt(e)));
            }
        }
        return i.a;
    }
}
function Knd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    n = Zwd(_Bd(JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84)));
    o = Zwd(_Bd(JD(nDd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c), 0), 84)));
    l = n == o;
    h = new Cdd;
    b = JD(ksd(a, (Whd(), Phd)), 77);
    if (!!b && b.b >= 2) {
        if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i == 0) {
            c = (Hpd(), e = new tud, e);
            tCd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), c);
        } else if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i > 1) {
            m = new LHd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a));
            while(m.e != m.i.gc())BHd(m);
        }
        Vmd(b, JD(nDd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), 0), 168));
    }
    if (l) for(d = new CHd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a)); d.e != d.i.gc();){
        c = JD(AHd(d), 168);
        for(j = new CHd((!c.a && (c.a = new qVd(u3, c, 5)), c.a)); j.e != j.i.gc();){
            i = JD(AHd(j), 369);
            h.a = $wnd.Math.max(h.a, i.a);
            h.b = $wnd.Math.max(h.b, i.b);
        }
    }
    for(g = new CHd((!a.n && (a.n = new X0d(z3, a, 1, 7)), a.n)); g.e != g.i.gc();){
        f = JD(AHd(g), 153);
        k = JD(ksd(f, Vhd), 8);
        !!k && ftd(f, k.a, k.b);
        if (l) {
            h.a = $wnd.Math.max(h.a, f.i + f.g);
            h.b = $wnd.Math.max(h.b, f.j + f.f);
        }
    }
    return h;
}
function EA(a, b, c, d, e) {
    var f, g, h;
    CA(a, b);
    g = b[0];
    f = _fb(c.c, 0);
    h = -1;
    if (vA(c)) {
        if (d > 0) {
            if (g + d > a.length) return false;
            h = zA((zDb(0, g + d, a.length), a.substr(0, g + d)), b);
        } else h = zA(a, b);
    }
    switch(f){
        case 71:
            h = wA(a, g, WC(OC(hJ, 1), hre, 2, 6, [
                jse,
                kse
            ]), b);
            e.e = h;
            return true;
        case 77:
            return HA(a, b, e, h, g);
        case 76:
            return JA(a, b, e, h, g);
        case 69:
            return FA(a, b, g, e);
        case 99:
            return IA(a, b, g, e);
        case 97:
            h = wA(a, g, WC(OC(hJ, 1), hre, 2, 6, [
                'AM',
                'PM'
            ]), b);
            e.b = h;
            return true;
        case 121:
            return LA(a, b, g, h, c, e);
        case 100:
            if (h <= 0) return false;
            e.c = h;
            return true;
        case 83:
            if (h < 0) return false;
            return GA(h, g, b[0], e);
        case 104:
            h == 12 && (h = 0);
        case 75:
        case 72:
            if (h < 0) return false;
            e.f = h;
            e.g = false;
            return true;
        case 107:
            if (h < 0) return false;
            e.f = h;
            e.g = true;
            return true;
        case 109:
            if (h < 0) return false;
            e.j = h;
            return true;
        case 115:
            if (h < 0) return false;
            e.n = h;
            return true;
        case 90:
            if (g < a.length && (ADb(g, a.length), a.charCodeAt(g) == 90)) {
                ++b[0];
                e.o = 0;
                return true;
            }
        case 122:
        case 118:
            return KA(a, g, b, e);
        default:
            return false;
    }
}
function _Kc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    t = b.c.length;
    e = new vKc(a.a, c, null, null);
    B = SC(aE, Rse, 30, t, 15, 1);
    p = SC(aE, Rse, 30, t, 15, 1);
    o = SC(aE, Rse, 30, t, 15, 1);
    q = 0;
    for(h = 0; h < t; h++){
        p[h] = Hqe;
        o[h] = Lre;
    }
    for(i = 0; i < t; i++){
        d = (sDb(i, b.c.length), JD(b.c[i], 185));
        B[i] = tKc(d);
        B[q] > B[i] && (q = i);
        for(l = new rmb(a.a.b); l.a < l.c.c.length;){
            k = JD(pmb(l), 25);
            for(s = new rmb(k.a); s.a < s.c.c.length;){
                r = JD(pmb(s), 9);
                w = Beb(d.p[r.p]) + Beb(d.d[r.p]);
                p[i] = $wnd.Math.min(p[i], w);
                o[i] = $wnd.Math.max(o[i], w + r.o.b);
            }
        }
    }
    A = SC(aE, Rse, 30, t, 15, 1);
    for(j = 0; j < t; j++)(sDb(j, b.c.length), JD(b.c[j], 185)).o == (HKc(), FKc) ? A[j] = p[q] - p[j] : A[j] = o[q] - o[j];
    f = SC(aE, Rse, 30, t, 15, 1);
    for(n = new rmb(a.a.b); n.a < n.c.c.length;){
        m = JD(pmb(n), 25);
        for(v = new rmb(m.a); v.a < v.c.c.length;){
            u = JD(pmb(v), 9);
            for(g = 0; g < t; g++)f[g] = Beb((sDb(g, b.c.length), JD(b.c[g], 185)).p[u.p]) + Beb((sDb(g, b.c.length), JD(b.c[g], 185)).d[u.p]) + A[g];
            aDb(f, $cb(_mb.prototype.Ke, _mb, []));
            e.p[u.p] = (f[1] + f[2]) / 2;
            e.d[u.p] = 0;
        }
    }
    return e;
}
function h0b(a, b, c) {
    var d, e, f, g, h;
    d = b.i;
    f = a.i.o;
    e = a.i.d;
    h = a.n;
    g = Kdd(WC(OC(b2, 1), hre, 8, 0, [
        h,
        a.a
    ]));
    switch(a.j.g){
        case 1:
            bIb(b, (GIb(), DIb));
            d.d = -e.d - c - d.a;
            if (JD(JD(Mlb(b.d, 0), 187).mf((Iqc(), cqc)), 289) == (oid(), kid)) {
                aIb(b, (PHb(), OHb));
                d.c = g.a - Beb(MD(WMb(a, iqc))) - c - d.b;
            } else {
                aIb(b, (PHb(), NHb));
                d.c = g.a + Beb(MD(WMb(a, iqc))) + c;
            }
            break;
        case 2:
            aIb(b, (PHb(), NHb));
            d.c = f.a + e.c + c;
            if (JD(JD(Mlb(b.d, 0), 187).mf((Iqc(), cqc)), 289) == (oid(), kid)) {
                bIb(b, (GIb(), DIb));
                d.d = g.b - Beb(MD(WMb(a, iqc))) - c - d.a;
            } else {
                bIb(b, (GIb(), FIb));
                d.d = g.b + Beb(MD(WMb(a, iqc))) + c;
            }
            break;
        case 3:
            bIb(b, (GIb(), FIb));
            d.d = f.b + e.a + c;
            if (JD(JD(Mlb(b.d, 0), 187).mf((Iqc(), cqc)), 289) == (oid(), kid)) {
                aIb(b, (PHb(), OHb));
                d.c = g.a - Beb(MD(WMb(a, iqc))) - c - d.b;
            } else {
                aIb(b, (PHb(), NHb));
                d.c = g.a + Beb(MD(WMb(a, iqc))) + c;
            }
            break;
        case 4:
            aIb(b, (PHb(), OHb));
            d.c = -e.b - c - d.b;
            if (JD(JD(Mlb(b.d, 0), 187).mf((Iqc(), cqc)), 289) == (oid(), kid)) {
                bIb(b, (GIb(), DIb));
                d.d = g.b - Beb(MD(WMb(a, iqc))) - c - d.a;
            } else {
                bIb(b, (GIb(), FIb));
                d.d = g.b + Beb(MD(WMb(a, iqc))) + c;
            }
    }
}
function iBc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    b.Sg('Interactive node layering', 1);
    c = new Ulb;
    for(m = new rmb(a.a); m.a < m.c.c.length;){
        k = JD(pmb(m), 9);
        i = k.n.a;
        h = i + k.o.a;
        h = $wnd.Math.max(i + 1, h);
        s = new Ajb(c, 0);
        d = null;
        while(s.b < s.d.gc()){
            q = (rDb(s.b < s.d.gc()), JD(s.d.Xb(s.c = s.b++), 560));
            if (q.c >= h) {
                rDb(s.b > 0);
                s.a.Xb(s.c = --s.b);
                break;
            } else if (q.a > i) {
                if (!d) {
                    Ilb(q.b, k);
                    q.c = $wnd.Math.min(q.c, i);
                    q.a = $wnd.Math.max(q.a, h);
                    d = q;
                } else {
                    Klb(d.b, q.b);
                    d.a = $wnd.Math.max(d.a, q.a);
                    tjb(s);
                }
            }
        }
        if (!d) {
            d = new mBc;
            d.c = i;
            d.a = h;
            zjb(s, d);
            Ilb(d.b, k);
        }
    }
    g = a.b;
    j = 0;
    for(r = new rmb(c); r.a < r.c.c.length;){
        q = JD(pmb(r), 560);
        e = new b$b(a);
        e.p = j++;
        YCb(g.c, e);
        for(n = new rmb(q.b); n.a < n.c.c.length;){
            k = JD(pmb(n), 9);
            qYb(k, e);
            k.p = 0;
        }
    }
    for(l = new rmb(a.a); l.a < l.c.c.length;){
        k = JD(pmb(l), 9);
        if (k.p == 0) {
            p = hBc(k, a);
            while(p.a.gc() != 0){
                o = JD(p.a.ec().Jc().Pb(), 9);
                p.a.Ac(o);
                xe(p, hBc(o, a));
            }
        }
    }
    f = new Ajb(g, 0);
    while(f.b < f.d.gc())(rDb(f.b < f.d.gc()), JD(f.d.Xb(f.c = f.b++), 25)).a.c.length == 0 && tjb(f);
    a.a.c.length = 0;
    b.Tg();
}
function d3c(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    c.Sg(wAe, 1);
    !b.a && (b.a = new X0d(A3, b, 10, 11));
    d = Beb(MD(ksd(b, (k2c(), L1c))));
    k = Beb(MD(ksd(b, d2c)));
    m = JD(ksd(b, a2c), 107);
    n = new B3c(d, k);
    f = A3c(n, b, m);
    c3c(b, n);
    h = JD(ksd(b, Z1c), 17).a;
    while(h > 1){
        e = a3c(b);
        l = f.g;
        o = JD(ksd(b, a2c), 107);
        p = Beb(MD(ksd(b, L1c)));
        (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i > 1 && Beb(MD(ksd(b, (h1c(), d1c)))) != Kse && (f.c + (o.b + o.c)) / (f.b + (o.d + o.a)) < p ? msd(e, (h1c(), g1c), Beb(MD(ksd(b, g1c))) + Beb(MD(ksd(b, d1c)))) : (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i > 1 && Beb(MD(ksd(b, (h1c(), c1c)))) != Kse && (f.c + (o.b + o.c)) / (f.b + (o.d + o.a)) > p && msd(e, (h1c(), g1c), $wnd.Math.max(Beb(MD(ksd(b, e1c))), Beb(MD(ksd(e, g1c))) - Beb(MD(ksd(b, c1c)))));
        n = new B3c(d, k);
        i = A3c(n, e, m);
        j = i.g;
        if (j >= l && j == j) {
            for(g = 0; g < (!e.a && (e.a = new X0d(A3, e, 10, 11)), e.a).i; g++)b3c(a, JD(nDd((!e.a && (e.a = new X0d(A3, e, 10, 11)), e.a), g), 27), JD(nDd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a), g), 27));
            c3c(b, n);
            z4c(f, i.c);
            y4c(f, i.b);
        }
        --h;
    }
    msd(b, (h1c(), Z0c), f.b);
    msd(b, $0c, f.c);
    c.Tg();
}
function Qld(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    n = 0;
    D = 0;
    for(i = new rmb(a); i.a < i.c.c.length;){
        h = JD(pmb(i), 27);
        lnd(h);
        n = $wnd.Math.max(n, h.g);
        D += h.g * h.f;
    }
    o = D / a.c.length;
    C = Kld(a, o);
    D += a.c.length * C;
    n = $wnd.Math.max(n, $wnd.Math.sqrt(D * g)) + c.b;
    H = c.b;
    I = c.d;
    m = 0;
    k = c.b + c.c;
    B = new Mtb;
    Atb(B, jfb(0));
    w = new Mtb;
    j = new Ajb(a, 0);
    while(j.b < j.d.gc()){
        h = (rDb(j.b < j.d.gc()), JD(j.d.Xb(j.c = j.b++), 27));
        G = h.g;
        l = h.f;
        if (H + G > n) {
            if (f) {
                Ctb(w, m);
                Ctb(B, jfb(j.b - 1));
            }
            H = c.b;
            I += m + b;
            m = 0;
            k = $wnd.Math.max(k, c.b + c.c + G);
        }
        htd(h, H);
        itd(h, I);
        k = $wnd.Math.max(k, H + G + c.c);
        m = $wnd.Math.max(m, l);
        H += G + b;
    }
    k = $wnd.Math.max(k, d);
    F = I + m + c.a;
    if (F < e) {
        m += e - F;
        F = e;
    }
    if (f) {
        H = c.b;
        j = new Ajb(a, 0);
        Ctb(B, jfb(a.c.length));
        A = Gtb(B, 0);
        r = JD(Utb(A), 17).a;
        Ctb(w, m);
        v = Gtb(w, 0);
        u = 0;
        while(j.b < j.d.gc()){
            if (j.b == r) {
                H = c.b;
                u = Beb(MD(Utb(v)));
                r = JD(Utb(A), 17).a;
            }
            h = (rDb(j.b < j.d.gc()), JD(j.d.Xb(j.c = j.b++), 27));
            s = h.f;
            etd(h, u);
            p = u;
            if (j.b == r) {
                q = k - H - c.c;
                t = h.g;
                gtd(h, q);
                rnd(h, new Edd(q, p), new Edd(t, s));
            }
            H += h.g + b;
        }
    }
    return new Edd(k, F);
}
function rVb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    b.Sg('Compound graph postprocessor', 1);
    c = ydb(LD(WMb(a, (Bwc(), pwc))));
    h = JD(WMb(a, (Iqc(), Lpc)), 228);
    k = new Qrb;
    for(r = h.ec().Jc(); r.Ob();){
        q = JD(r.Pb(), 18);
        g = new Wlb(h.cc(q));
        pnb();
        Slb(g, new WVb(a));
        v = RVb((sDb(0, g.c.length), JD(g.c[0], 248)));
        A = SVb(JD(Mlb(g, g.c.length - 1), 248));
        t = v.i;
        xXb(A.i, t) ? s = t.e : s = gYb(t);
        l = sVb(q, g);
        Ltb(q.a);
        m = null;
        for(f = new rmb(g); f.a < f.c.c.length;){
            e = JD(pmb(f), 248);
            p = new Cdd;
            oXb(p, e.a, s);
            n = e.b;
            d = new Rdd;
            Ndd(d, 0, n.a);
            Pdd(d, p);
            u = new Fdd(WYb(n.c));
            w = new Fdd(WYb(n.d));
            mdd(u, p);
            mdd(w, p);
            if (m) {
                d.b == 0 ? o = w : o = (rDb(d.b != 0), JD(d.a.a.c, 8));
                B = $wnd.Math.abs(m.a - o.a) > Fue;
                C = $wnd.Math.abs(m.b - o.b) > Fue;
                (!c && B && C || c && (B || C)) && Atb(q.a, u);
            }
            xe(q.a, d);
            d.b == 0 ? m = u : m = (rDb(d.b != 0), JD(d.c.b.c, 8));
            tVb(n, l, p);
            if (SVb(e) == A) {
                if (gYb(A.i) != e.a) {
                    p = new Cdd;
                    oXb(p, gYb(A.i), s);
                }
                ZMb(q, Gqc, p);
            }
            uVb(n, q, s);
            k.a.yc(n, k);
        }
        gWb(q, v);
        hWb(q, A);
    }
    for(j = k.a.ec().Jc(); j.Ob();){
        i = JD(j.Pb(), 18);
        gWb(i, null);
        hWb(i, null);
    }
    b.Tg();
}
function oRc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    e = JD(WMb(a, (kVc(), KUc)), 86);
    k = e == (Tgd(), Pgd) || e == Qgd ? Ogd : Qgd;
    c = JD(yBb(BBb(new RBb(null, new Gvb(a.b, 16)), new bSc), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    i = JD(yBb(FBb(c.Mc(), new dSc(b)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        jAb
    ]))), 15);
    i.Fc(JD(yBb(FBb(c.Mc(), new fSc(b)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        jAb
    ]))), 16));
    i.gd(new hSc(k));
    m = new mzb(new lSc(e));
    d = new Irb;
    for(h = i.Jc(); h.Ob();){
        g = JD(h.Pb(), 239);
        j = JD(g.a, 39);
        if (ydb(LD(g.c))) {
            m.a.yc(j, (xdb(), vdb));
            new nzb(m.a.Xc(j, false)).a.gc() > 0 && Qib(d, j, JD(new nzb(m.a.Xc(j, false)).a.Tc(), 39));
            new nzb(m.a.$c(j, true)).a.gc() > 1 && Qib(d, qRc(m, j), j);
        } else {
            if (new nzb(m.a.Xc(j, false)).a.gc() > 0) {
                f = JD(new nzb(m.a.Xc(j, false)).a.Tc(), 39);
                XD(f) === XD(Wd(fsb(d.f, j))) && JD(WMb(j, (tUc(), WTc)), 15).Ec(f);
            }
            if (new nzb(m.a.$c(j, true)).a.gc() > 1) {
                l = qRc(m, j);
                XD(Wd(fsb(d.f, l))) === XD(j) && JD(WMb(l, (tUc(), WTc)), 15).Ec(j);
            }
            m.a.Ac(j);
        }
    }
}
function AMb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    if (a.gc() == 1) return JD(a.Xb(0), 234);
    else if (a.gc() <= 0) return new qNb;
    for(e = a.Jc(); e.Ob();){
        c = JD(e.Pb(), 234);
        o = 0;
        k = Hqe;
        l = Hqe;
        i = Lre;
        j = Lre;
        for(n = new rmb(c.e); n.a < n.c.c.length;){
            m = JD(pmb(n), 151);
            o += JD(WMb(m, (IOb(), vOb)), 17).a;
            k = $wnd.Math.min(k, m.d.a - m.e.a / 2);
            l = $wnd.Math.min(l, m.d.b - m.e.b / 2);
            i = $wnd.Math.max(i, m.d.a + m.e.a / 2);
            j = $wnd.Math.max(j, m.d.b + m.e.b / 2);
        }
        ZMb(c, (IOb(), vOb), jfb(o));
        ZMb(c, (TOb(), QOb), new Edd(k, l));
        ZMb(c, POb, new Edd(i, j));
    }
    pnb();
    a.gd(new EMb);
    p = new qNb;
    UMb(p, JD(a.Xb(0), 102));
    h = 0;
    s = 0;
    for(f = a.Jc(); f.Ob();){
        c = JD(f.Pb(), 234);
        q = Bdd(odd(JD(WMb(c, (TOb(), POb)), 8)), JD(WMb(c, QOb), 8));
        h = $wnd.Math.max(h, q.a);
        s += q.a * q.b;
    }
    h = $wnd.Math.max(h, $wnd.Math.sqrt(s) * Beb(MD(WMb(p, (IOb(), hOb)))));
    r = Beb(MD(WMb(p, BOb)));
    t = 0;
    u = 0;
    g = 0;
    b = r;
    for(d = a.Jc(); d.Ob();){
        c = JD(d.Pb(), 234);
        q = Bdd(odd(JD(WMb(c, (TOb(), POb)), 8)), JD(WMb(c, QOb), 8));
        if (t + q.a > h) {
            t = 0;
            u += g + r;
            g = 0;
        }
        zMb(p, c, t, u);
        b = $wnd.Math.max(b, t + q.a);
        g = $wnd.Math.max(g, q.b);
        t += q.a + r;
    }
    return p;
}
function Vle(a) {
    Ule();
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (a == null) return null;
    f = rgb(a);
    o = Yle(f);
    if (o % 4 != 0) return null;
    p = o / 4 | 0;
    if (p == 0) return SC($D, ZCe, 30, 0, 15, 1);
    l = null;
    b = 0;
    c = 0;
    d = 0;
    e = 0;
    g = 0;
    h = 0;
    i = 0;
    j = 0;
    n = 0;
    m = 0;
    k = 0;
    l = SC($D, ZCe, 30, p * 3, 15, 1);
    for(; n < p - 1; n++){
        if (!Xle(g = f[k++]) || !Xle(h = f[k++]) || !Xle(i = f[k++]) || !Xle(j = f[k++])) return null;
        b = Sle[g];
        c = Sle[h];
        d = Sle[i];
        e = Sle[j];
        l[m++] = (b << 2 | c >> 4) << 24 >> 24;
        l[m++] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
        l[m++] = (d << 6 | e) << 24 >> 24;
    }
    if (!Xle(g = f[k++]) || !Xle(h = f[k++])) return null;
    b = Sle[g];
    c = Sle[h];
    i = f[k++];
    j = f[k++];
    if (Sle[i] == -1 || Sle[j] == -1) {
        if (i == 61 && j == 61) {
            if ((c & 15) != 0) return null;
            q = SC($D, ZCe, 30, n * 3 + 1, 15, 1);
            $gb(l, 0, q, 0, n * 3);
            q[m] = (b << 2 | c >> 4) << 24 >> 24;
            return q;
        } else if (i != 61 && j == 61) {
            d = Sle[i];
            if ((d & 3) != 0) return null;
            q = SC($D, ZCe, 30, n * 3 + 2, 15, 1);
            $gb(l, 0, q, 0, n * 3);
            q[m++] = (b << 2 | c >> 4) << 24 >> 24;
            q[m] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
            return q;
        } else return null;
    } else {
        d = Sle[i];
        e = Sle[j];
        l[m++] = (b << 2 | c >> 4) << 24 >> 24;
        l[m++] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
        l[m++] = (d << 6 | e) << 24 >> 24;
    }
    return l;
}
function J8b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    b.Sg(dwe, 1);
    o = JD(WMb(a, (Bwc(), yuc)), 220);
    for(e = new rmb(a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 25);
        j = DXb(d.a);
        for(g = j, h = 0, i = g.length; h < i; ++h){
            f = g[h];
            if (f.k != (DYb(), BYb)) continue;
            if (o == (xhd(), vhd)) for(l = new rmb(f.j); l.a < l.c.c.length;){
                k = JD(pmb(l), 11);
                k.e.c.length == 0 || M8b(k);
                k.g.c.length == 0 || N8b(k);
            }
            else if (RD(WMb(f, (Iqc(), kqc)), 18)) {
                q = JD(WMb(f, kqc), 18);
                r = JD(oYb(f, (Rjd(), Qjd)).Jc().Pb(), 11);
                s = JD(oYb(f, wjd).Jc().Pb(), 11);
                t = JD(WMb(r, kqc), 11);
                u = JD(WMb(s, kqc), 11);
                gWb(q, u);
                hWb(q, t);
                v = new Fdd(s.i.n);
                v.a = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    u.i.n,
                    u.n,
                    u.a
                ])).a;
                Atb(q.a, v);
                v = new Fdd(r.i.n);
                v.a = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    t.i.n,
                    t.n,
                    t.a
                ])).a;
                Atb(q.a, v);
            } else {
                if (f.j.c.length >= 2) {
                    p = true;
                    m = new rmb(f.j);
                    c = JD(pmb(m), 11);
                    n = null;
                    while(m.a < m.c.c.length){
                        n = c;
                        c = JD(pmb(m), 11);
                        if (!pb(WMb(n, kqc), WMb(c, kqc))) {
                            p = false;
                            break;
                        }
                    }
                } else p = false;
                for(l = new rmb(f.j); l.a < l.c.c.length;){
                    k = JD(pmb(l), 11);
                    k.e.c.length == 0 || K8b(k, p);
                    k.g.c.length == 0 || L8b(k, p);
                }
            }
            qYb(f, null);
        }
    }
    b.Tg();
}
function OKc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    for(h = new rmb(a.a.b); h.a < h.c.c.length;){
        f = JD(pmb(h), 25);
        for(t = new rmb(f.a); t.a < t.c.c.length;){
            s = JD(pmb(t), 9);
            b.g[s.p] = s;
            b.a[s.p] = s;
            b.d[s.p] = 0;
        }
    }
    i = a.a.b;
    b.c == (zKc(), xKc) && (i = dv(i));
    for(g = i.Jc(); g.Ob();){
        f = JD(g.Pb(), 25);
        n = -1;
        m = f.a;
        if (b.o == (HKc(), GKc)) {
            n = Hqe;
            m = dv(m);
        }
        for(v = m.Jc(); v.Ob();){
            u = JD(v.Pb(), 9);
            l = null;
            b.c == xKc ? l = JD(Mlb(a.b.f, u.p), 15) : l = JD(Mlb(a.b.b, u.p), 15);
            if (l.gc() > 0) {
                d = l.gc();
                j = YD($wnd.Math.floor((d + 1) / 2)) - 1;
                e = YD($wnd.Math.ceil((d + 1) / 2)) - 1;
                if (b.o == GKc) {
                    for(k = e; k >= j; k--)if (b.a[u.p] == u) {
                        p = JD(l.Xb(k), 47);
                        o = JD(p.a, 9);
                        if (!Orb(c, p.b) && n > a.b.e[o.p]) {
                            b.a[o.p] = u;
                            b.g[u.p] = b.g[o.p];
                            b.a[u.p] = b.g[u.p];
                            b.f[b.g[u.p].p] = (xdb(), ydb(b.f[b.g[u.p].p]) & u.k == (DYb(), yYb) ? true : false);
                            n = a.b.e[o.p];
                        }
                    }
                } else {
                    for(k = j; k <= e; k++)if (b.a[u.p] == u) {
                        r = JD(l.Xb(k), 47);
                        q = JD(r.a, 9);
                        if (!Orb(c, r.b) && n < a.b.e[q.p]) {
                            b.a[q.p] = u;
                            b.g[u.p] = b.g[q.p];
                            b.a[u.p] = b.g[u.p];
                            b.f[b.g[u.p].p] = (xdb(), ydb(b.f[b.g[u.p].p]) & u.k == (DYb(), yYb) ? true : false);
                            n = a.b.e[q.p];
                        }
                    }
                }
            }
        }
    }
}
function lIc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    t = a.c[(sDb(0, b.c.length), JD(b.c[0], 18)).p];
    A = a.c[(sDb(1, b.c.length), JD(b.c[1], 18)).p];
    if (t.a.e.e - t.a.a - (t.b.e.e - t.b.a) == 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) == 0) return false;
    r = t.b.e.f;
    if (!RD(r, 9)) return false;
    q = JD(r, 9);
    v = a.i[q.p];
    w = !q.c ? -1 : Nlb(q.c.a, q, 0);
    f = Kse;
    if (w > 0) {
        e = JD(Mlb(q.c.a, w - 1), 9);
        g = a.i[e.p];
        B = $wnd.Math.ceil(ezc(a.n, e, q));
        f = v.a.e - q.d.d - (g.a.e + e.o.b + e.d.a) - B;
    }
    j = Kse;
    if (w < q.c.a.c.length - 1) {
        i = JD(Mlb(q.c.a, w + 1), 9);
        k = a.i[i.p];
        B = $wnd.Math.ceil(ezc(a.n, i, q));
        j = k.a.e - i.d.d - (v.a.e + q.o.b + q.d.a) - B;
    }
    if (c && (Ry(), Vy(pze), $wnd.Math.abs(f - j) <= pze || f == j || isNaN(f) && isNaN(j))) return true;
    d = JIc(t.a);
    h = -JIc(t.b);
    l = -JIc(A.a);
    s = JIc(A.b);
    p = t.a.e.e - t.a.a - (t.b.e.e - t.b.a) > 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) < 0;
    o = t.a.e.e - t.a.a - (t.b.e.e - t.b.a) < 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) > 0;
    n = t.a.e.e + t.b.a < A.b.e.e + A.a.a;
    m = t.a.e.e + t.b.a > A.b.e.e + A.a.a;
    u = 0;
    !p && !o && (m ? f + l > 0 ? u = l : j - d > 0 && (u = d) : n && (f + h > 0 ? u = h : j - s > 0 && (u = s)));
    v.a.e += u;
    v.b && (v.d.e += u);
    return false;
}
function ZGb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    d = new gdd(b.Jf().a, b.Jf().b, b.Kf().a, b.Kf().b);
    e = new fdd;
    if (a.c) for(g = new rmb(b.Pf()); g.a < g.c.c.length;){
        f = JD(pmb(g), 187);
        e.c = f.Jf().a + b.Jf().a;
        e.d = f.Jf().b + b.Jf().b;
        e.b = f.Kf().a;
        e.a = f.Kf().b;
        edd(d, e);
    }
    for(j = new rmb(b.Vf()); j.a < j.c.c.length;){
        i = JD(pmb(j), 831);
        k = i.Jf().a + b.Jf().a;
        l = i.Jf().b + b.Jf().b;
        if (a.e) {
            e.c = k;
            e.d = l;
            e.b = i.Kf().a;
            e.a = i.Kf().b;
            edd(d, e);
        }
        if (a.d) for(g = new rmb(i.Pf()); g.a < g.c.c.length;){
            f = JD(pmb(g), 187);
            e.c = f.Jf().a + k;
            e.d = f.Jf().b + l;
            e.b = f.Kf().a;
            e.a = f.Kf().b;
            edd(d, e);
        }
        if (a.b) {
            m = new Edd(-c, -c);
            if (JD(b.mf((Lgd(), agd)), 181).Gc((ojd(), mjd))) for(g = new rmb(i.Pf()); g.a < g.c.c.length;){
                f = JD(pmb(g), 187);
                m.a += f.Kf().a + c;
                m.b += f.Kf().b + c;
            }
            m.a = $wnd.Math.max(m.a, 0);
            m.b = $wnd.Math.max(m.b, 0);
            XGb(d, i.Uf(), i.Sf(), b, i, m, c);
        }
    }
    a.b && XGb(d, b.Uf(), b.Sf(), b, null, null, c);
    h = new aYb(b.Tf());
    h.d = $wnd.Math.max(0, b.Jf().b - d.d);
    h.a = $wnd.Math.max(0, d.d + d.a - (b.Jf().b + b.Kf().b));
    h.b = $wnd.Math.max(0, b.Jf().a - d.c);
    h.c = $wnd.Math.max(0, d.c + d.b - (b.Jf().a + b.Kf().a));
    b.Xf(h);
}
function Ez() {
    var a = [
        '\\u0000',
        '\\u0001',
        '\\u0002',
        '\\u0003',
        '\\u0004',
        '\\u0005',
        '\\u0006',
        '\\u0007',
        '\\b',
        '\\t',
        '\\n',
        '\\u000B',
        '\\f',
        '\\r',
        '\\u000E',
        '\\u000F',
        '\\u0010',
        '\\u0011',
        '\\u0012',
        '\\u0013',
        '\\u0014',
        '\\u0015',
        '\\u0016',
        '\\u0017',
        '\\u0018',
        '\\u0019',
        '\\u001A',
        '\\u001B',
        '\\u001C',
        '\\u001D',
        '\\u001E',
        '\\u001F'
    ];
    a[34] = '\\"';
    a[92] = '\\\\';
    a[173] = '\\u00ad';
    a[1536] = '\\u0600';
    a[1537] = '\\u0601';
    a[1538] = '\\u0602';
    a[1539] = '\\u0603';
    a[1757] = '\\u06dd';
    a[1807] = '\\u070f';
    a[6068] = '\\u17b4';
    a[6069] = '\\u17b5';
    a[8203] = '\\u200b';
    a[8204] = '\\u200c';
    a[8205] = '\\u200d';
    a[8206] = '\\u200e';
    a[8207] = '\\u200f';
    a[8232] = '\\u2028';
    a[8233] = '\\u2029';
    a[8234] = '\\u202a';
    a[8235] = '\\u202b';
    a[8236] = '\\u202c';
    a[8237] = '\\u202d';
    a[8238] = '\\u202e';
    a[8288] = '\\u2060';
    a[8289] = '\\u2061';
    a[8290] = '\\u2062';
    a[8291] = '\\u2063';
    a[8292] = '\\u2064';
    a[8298] = '\\u206a';
    a[8299] = '\\u206b';
    a[8300] = '\\u206c';
    a[8301] = '\\u206d';
    a[8302] = '\\u206e';
    a[8303] = '\\u206f';
    a[65279] = '\\ufeff';
    a[65529] = '\\ufff9';
    a[65530] = '\\ufffa';
    a[65531] = '\\ufffb';
    return a;
}
function JOb(a) {
    Rad(a, new cad(oad(jad(nad(kad(mad(lad(new pad, Kue), 'ELK Force'), 'Force-based algorithm provided by the Eclipse Layout Kernel. Implements methods that follow physical analogies by simulating forces that move the nodes into a balanced distribution. Currently the original Eades model and the Fruchterman - Reingold model are supported.'), new MOb), Kue), nrb((BBd(), yBd), WC(OC(L4, 1), Ere, 243, 0, [
        wBd
    ])))));
    Pad(a, Kue, Lue, jfb(1));
    Pad(a, Kue, Mue, 80);
    Pad(a, Kue, Nue, 5);
    Pad(a, Kue, Oue, Jue);
    Pad(a, Kue, Pue, jfb(1));
    Pad(a, Kue, Que, (xdb(), true));
    Pad(a, Kue, Rue, sOb);
    Pad(a, Kue, Sue, JBd(jOb));
    Pad(a, Kue, Tue, JBd(tOb));
    Pad(a, Kue, Uue, false);
    Pad(a, Kue, Vue, JBd(qOb));
    Pad(a, Kue, Wue, JBd(oOb));
    Pad(a, Kue, Xue, JBd(pOb));
    Pad(a, Kue, Yue, JBd(nOb));
    Pad(a, Kue, Zue, JBd(mOb));
    Pad(a, Kue, $ue, JBd(uOb));
    Pad(a, Kue, Bue, JBd(lOb));
    Pad(a, Kue, Eue, JBd(COb));
    Pad(a, Kue, Cue, JBd(kOb));
    Pad(a, Kue, Gue, JBd(xOb));
    Pad(a, Kue, Due, JBd(yOb));
    Pad(a, Kue, _ue, JBd(FOb));
    Pad(a, Kue, ave, JBd(HOb));
    Pad(a, Kue, bve, JBd(EOb));
    Pad(a, Kue, cve, JBd(DOb));
    Pad(a, Kue, dve, GOb);
}
function glc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    n = JD(Mlb((sDb(0, b.c.length), JD(b.c[0], 25)).a, d), 9);
    c > 0 && qYb(n, (sDb(c, b.c.length), JD(b.c[c], 25)));
    f = 0;
    m = true;
    r = dv(Zu(hYb(n)));
    for(i = r.Jc(); i.Ob();){
        h = JD(i.Pb(), 18);
        m = false;
        l = h;
        for(j = 0; j < c; j++){
            e = blc(a, l);
            d + f > (sDb(j, b.c.length), JD(b.c[j], 25)).a.c.length ? qYb(e, (sDb(j, b.c.length), JD(b.c[j], 25))) : pYb(e, d + f, (sDb(j, b.c.length), JD(b.c[j], 25)));
            l = _7b(l, e);
        }
        c > 0 && (f += 1);
    }
    if (m) {
        for(j = 0; j < c; j++){
            e = new tYb(a);
            rYb(e, (DYb(), CYb));
            d + f > (sDb(j, b.c.length), JD(b.c[j], 25)).a.c.length ? qYb(e, (sDb(j, b.c.length), JD(b.c[j], 25))) : pYb(e, d + f, (sDb(j, b.c.length), JD(b.c[j], 25)));
        }
        c > 0 && (f += 1);
    }
    g = false;
    for(p = new es(Ir(kYb(n).a.Jc(), new er)); cs(p);){
        o = JD(ds(p), 18);
        l = o;
        for(k = c + 1; k < b.c.length; k++){
            e = blc(a, l);
            qYb(e, (sDb(k, b.c.length), JD(b.c[k], 25)));
            l = _7b(l, e);
        }
        for(j = 0; j <= c; j++)if (g) {
            q = new tYb(a);
            rYb(q, (DYb(), zYb));
            d + 1 > (sDb(j, b.c.length), JD(b.c[j], 25)).a.c.length ? qYb(q, (sDb(j, b.c.length), JD(b.c[j], 25))) : pYb(q, d + 1, (sDb(j, b.c.length), JD(b.c[j], 25)));
        }
        g && (f += 1);
        g = true;
    }
    return f > 0 ? f - 1 : 0;
}
function Coe(a, b) {
    ooe();
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if (Uib(Rne) == 0) {
        l = SC(icb, hre, 121, Tne.length, 0, 1);
        for(g = 0; g < l.length; g++)l[g] = (++noe, new Soe(4));
        d = new Igb;
        for(f = 0; f < Qne.length; f++){
            k = (++noe, new Soe(4));
            if (f < 84) {
                h = f * 2;
                n = (ADb(h, YGe.length), YGe.charCodeAt(h));
                m = (ADb(h + 1, YGe.length), YGe.charCodeAt(h + 1));
                Moe(k, n, m);
            } else {
                h = (f - 84) * 2;
                Moe(k, Une[h], Une[h + 1]);
            }
            i = Qne[f];
            cgb(i, 'Specials') && Moe(k, 65520, 65533);
            if (cgb(i, WGe)) {
                Moe(k, 983040, 1048573);
                Moe(k, 1048576, 1114109);
            }
            Rib(Rne, i, k);
            Rib(Sne, i, Toe(k));
            j = d.a.length;
            0 < j ? d.a = qgb(d.a, 0, 0) : 0 > j && (d.a += ygb(SC(_D, Ure, 30, -j, 15, 1)));
            d.a += 'Is';
            if (hgb(i, wgb(32)) >= 0) for(e = 0; e < i.length; e++){
                ADb(e, i.length);
                i.charCodeAt(e) != 32 && Agb(d, (ADb(e, i.length), i.charCodeAt(e)));
            }
            else d.a += '' + i;
            Goe(d.a, i, true);
        }
        Goe(XGe, 'Cn', false);
        Goe(ZGe, 'Cn', true);
        c = (++noe, new Soe(4));
        Moe(c, 0, NGe);
        Rib(Rne, 'ALL', c);
        Rib(Sne, 'ALL', Toe(c));
        !Vne && (Vne = new Irb);
        Rib(Vne, XGe, XGe);
        !Vne && (Vne = new Irb);
        Rib(Vne, ZGe, ZGe);
        !Vne && (Vne = new Irb);
        Rib(Vne, 'ALL', 'ALL');
    }
    o = b ? JD(Oib(Rne, a), 136) : JD(Oib(Sne, a), 136);
    return o;
}
function lVc(a) {
    Rad(a, new cad(oad(jad(nad(kad(mad(lad(new pad, Uze), 'ELK Mr. Tree'), "Tree-based algorithm provided by the Eclipse Layout Kernel. Computes a spanning tree of the input graph and arranges all nodes according to the resulting parent-children hierarchy. I pity the fool who doesn't use Mr. Tree Layout."), new oVc), Vze), mrb((BBd(), vBd)))));
    Pad(a, Uze, Rue, XUc);
    Pad(a, Uze, Mue, 20);
    Pad(a, Uze, sye, 3);
    Pad(a, Uze, Oue, Jue);
    Pad(a, Uze, Lue, jfb(1));
    Pad(a, Uze, Que, (xdb(), true));
    Pad(a, Uze, Dye, JBd(JUc));
    Pad(a, Uze, Hye, LUc);
    Pad(a, Uze, Sue, JBd(OUc));
    Pad(a, Uze, bze, JBd(PUc));
    Pad(a, Uze, Yue, JBd(RUc));
    Pad(a, Uze, Wue, JBd(SUc));
    Pad(a, Uze, pve, JBd(TUc));
    Pad(a, Uze, Xue, JBd(UUc));
    Pad(a, Uze, Zue, JBd(QUc));
    Pad(a, Uze, Vue, JBd(VUc));
    Pad(a, Uze, $ue, JBd(YUc));
    Pad(a, Uze, Qze, JBd(jVc));
    Pad(a, Uze, Sze, JBd(_Uc));
    Pad(a, Uze, _ue, JBd(fVc));
    Pad(a, Uze, ave, JBd(hVc));
    Pad(a, Uze, bve, JBd(eVc));
    Pad(a, Uze, cve, JBd(dVc));
    Pad(a, Uze, dve, gVc);
    Pad(a, Uze, Pze, JBd(ZUc));
    Pad(a, Uze, Rze, JBd(NUc));
    Pad(a, Uze, Oze, JBd(iVc));
    Pad(a, Uze, Mze, JBd(IUc));
    Pad(a, Uze, Nze, JBd(MUc));
}
function CKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    j = JD(JD(Qc(a.r, b), 22), 83);
    g = dKb(a, b);
    c = a.u.Gc((ojd(), ijd));
    for(i = j.Jc(); i.Ob();){
        h = JD(i.Pb(), 115);
        if (!h.c || h.c.d.c.length <= 0) continue;
        m = h.b.Kf();
        k = h.c;
        l = k.i;
        l.b = (f = k.n, k.e.a + f.b + f.c);
        l.a = (e = k.n, k.e.b + e.d + e.a);
        switch(b.g){
            case 1:
                if (h.a) {
                    l.c = (m.a - l.b) / 2;
                    aIb(k, (PHb(), MHb));
                } else if (g || c) {
                    l.c = -l.b - a.s;
                    aIb(k, (PHb(), OHb));
                } else {
                    l.c = m.a + a.s;
                    aIb(k, (PHb(), NHb));
                }
                l.d = -l.a - a.t;
                bIb(k, (GIb(), DIb));
                break;
            case 3:
                if (h.a) {
                    l.c = (m.a - l.b) / 2;
                    aIb(k, (PHb(), MHb));
                } else if (g || c) {
                    l.c = -l.b - a.s;
                    aIb(k, (PHb(), OHb));
                } else {
                    l.c = m.a + a.s;
                    aIb(k, (PHb(), NHb));
                }
                l.d = m.b + a.t;
                bIb(k, (GIb(), FIb));
                break;
            case 2:
                if (h.a) {
                    d = a.v ? l.a : JD(Mlb(k.d, 0), 187).Kf().b;
                    l.d = (m.b - d) / 2;
                    bIb(k, (GIb(), EIb));
                } else if (g || c) {
                    l.d = -l.a - a.t;
                    bIb(k, (GIb(), DIb));
                } else {
                    l.d = m.b + a.t;
                    bIb(k, (GIb(), FIb));
                }
                l.c = m.a + a.s;
                aIb(k, (PHb(), NHb));
                break;
            case 4:
                if (h.a) {
                    d = a.v ? l.a : JD(Mlb(k.d, 0), 187).Kf().b;
                    l.d = (m.b - d) / 2;
                    bIb(k, (GIb(), EIb));
                } else if (g || c) {
                    l.d = -l.a - a.t;
                    bIb(k, (GIb(), DIb));
                } else {
                    l.d = m.b + a.t;
                    bIb(k, (GIb(), FIb));
                }
                l.c = -l.b - a.s;
                aIb(k, (PHb(), OHb));
        }
        g = false;
    }
}
function F_b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    m = false;
    l = false;
    if (cjd(JD(WMb(d, (Bwc(), Evc)), 100))) {
        g = false;
        h = false;
        t: for(o = new rmb(d.j); o.a < o.c.c.length;){
            n = JD(pmb(o), 11);
            for(q = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
                new dZb(n),
                new lZb(n)
            ]))); cs(q);){
                p = JD(ds(q), 11);
                if (!ydb(LD(WMb(p.i, Utc)))) {
                    if (n.j == (Rjd(), xjd)) {
                        g = true;
                        break t;
                    }
                    if (n.j == Ojd) {
                        h = true;
                        break t;
                    }
                }
            }
        }
        m = h && !g;
        l = g && !h;
    }
    if (!m && !l && d.b.c.length != 0) {
        k = 0;
        for(j = new rmb(d.b); j.a < j.c.c.length;){
            i = JD(pmb(j), 72);
            k += i.n.b + i.o.b / 2;
        }
        k /= d.b.c.length;
        s = k >= d.o.b / 2;
    } else s = !l;
    if (s) {
        r = JD(WMb(d, (Iqc(), Hqc)), 15);
        if (!r) {
            f = new Ulb;
            ZMb(d, Hqc, f);
        } else if (m) f = r;
        else {
            e = JD(WMb(d, Fpc), 15);
            if (!e) {
                f = new Ulb;
                ZMb(d, Fpc, f);
            } else r.gc() <= e.gc() ? f = r : f = e;
        }
    } else {
        e = JD(WMb(d, (Iqc(), Fpc)), 15);
        if (!e) {
            f = new Ulb;
            ZMb(d, Fpc, f);
        } else if (l) f = e;
        else {
            r = JD(WMb(d, Hqc), 15);
            if (!r) {
                f = new Ulb;
                ZMb(d, Hqc, f);
            } else e.gc() <= r.gc() ? f = e : f = r;
        }
    }
    f.Ec(a);
    ZMb(a, (Iqc(), Hpc), c);
    if (b.d == c) {
        hWb(b, null);
        c.e.c.length + c.g.c.length == 0 && _Yb(c, null);
        G_b(c);
    } else {
        gWb(b, null);
        c.e.c.length + c.g.c.length == 0 && _Yb(c, null);
    }
    Ltb(b.a);
}
function JBc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    c.Sg('MinWidth layering', 1);
    n = b.b;
    A = b.a;
    I = JD(WMb(b, (Bwc(), Wuc)), 17).a;
    h = JD(WMb(b, Xuc), 17).a;
    a.b = Beb(MD(WMb(b, Wvc)));
    a.d = Kse;
    for(u = new rmb(A); u.a < u.c.c.length;){
        s = JD(pmb(u), 9);
        if (s.k != (DYb(), AYb)) continue;
        D = s.o.b;
        a.d = $wnd.Math.min(a.d, D);
    }
    a.d = $wnd.Math.max(1, a.d);
    B = A.c.length;
    a.c = SC(cE, ise, 30, B, 15, 1);
    a.f = SC(cE, ise, 30, B, 15, 1);
    a.e = SC(aE, Rse, 30, B, 15, 1);
    j = 0;
    a.a = 0;
    for(v = new rmb(A); v.a < v.c.c.length;){
        s = JD(pmb(v), 9);
        s.p = j++;
        a.c[s.p] = HBc(hYb(s));
        a.f[s.p] = HBc(kYb(s));
        a.e[s.p] = s.o.b / a.d;
        a.a += a.e[s.p];
    }
    a.b /= a.d;
    a.a /= B;
    w = IBc(A);
    Slb(A, wnb(new PBc(a)));
    p = Kse;
    o = Hqe;
    g = null;
    H = I;
    G = I;
    f = h;
    e = h;
    if (I < 0) {
        H = JD(EBc.a.Gd(), 17).a;
        G = JD(EBc.b.Gd(), 17).a;
    }
    if (h < 0) {
        f = JD(DBc.a.Gd(), 17).a;
        e = JD(DBc.b.Gd(), 17).a;
    }
    for(F = H; F <= G; F++)for(d = f; d <= e; d++){
        C = GBc(a, F, d, A, w);
        r = Beb(MD(C.a));
        m = JD(C.b, 15);
        q = m.gc();
        if (r < p || r == p && q < o) {
            p = r;
            o = q;
            g = m;
        }
    }
    for(l = g.Jc(); l.Ob();){
        k = JD(l.Pb(), 15);
        i = new b$b(b);
        for(t = k.Jc(); t.Ob();){
            s = JD(t.Pb(), 9);
            qYb(s, i);
        }
        YCb(n.c, i);
    }
    vnb(n);
    A.c.length = 0;
    c.Tg();
}
function U8b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
    b.Sg(dwe, 1);
    p = new Ulb;
    w = new Ulb;
    for(j = new rmb(a.b); j.a < j.c.c.length;){
        i = JD(pmb(j), 25);
        r = -1;
        o = DXb(i.a);
        for(l = o, m = 0, n = l.length; m < n; ++m){
            k = l[m];
            ++r;
            if (!(k.k == (DYb(), AYb) && cjd(JD(WMb(k, (Bwc(), Evc)), 100)))) continue;
            !bjd(JD(WMb(k, (Bwc(), Evc)), 100)) && XD(WMb(gYb(k), cuc)) === XD((nyc(), kyc)) && V8b(k);
            ZMb(k, (Iqc(), _pc), k);
            p.c.length = 0;
            w.c.length = 0;
            c = new Ulb;
            u = new Mtb;
            Xq(u, oYb(k, (Rjd(), xjd)));
            XD(WMb(gYb(k), cuc)) !== XD((nyc(), kyc)) && (u = T8b(u));
            R8b(a, u, p, w, c);
            h = r;
            A = k;
            for(f = new rmb(p); f.a < f.c.c.length;){
                d = JD(pmb(f), 9);
                pYb(d, h, i);
                ++r;
                ZMb(d, _pc, k);
                g = JD(Mlb(d.j, 0), 11);
                q = JD(WMb(g, kqc), 11);
                ydb(LD(WMb(q, Stc))) || JD(WMb(d, aqc), 15).Ec(A);
            }
            Ltb(u);
            for(t = oYb(k, Ojd).Jc(); t.Ob();){
                s = JD(t.Pb(), 11);
                Dtb(u, s, u.a, u.a.a);
            }
            XD(WMb(gYb(k), cuc)) !== XD(kyc) && (u = T8b(u));
            R8b(a, u, w, null, c);
            v = k;
            for(e = new rmb(w); e.a < e.c.c.length;){
                d = JD(pmb(e), 9);
                pYb(d, ++r, i);
                ZMb(d, _pc, k);
                g = JD(Mlb(d.j, 0), 11);
                q = JD(WMb(g, kqc), 11);
                ydb(LD(WMb(q, Stc))) || JD(WMb(v, aqc), 15).Ec(d);
            }
            c.c.length == 0 || ZMb(k, Epc, c);
        }
    }
    b.Tg();
}
function XOc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    c.Sg('Spline edge routing', 1);
    if (b.b.c.length == 0) {
        b.f.a = 0;
        c.Tg();
        return;
    }
    s = Beb(MD(WMb(b, (Bwc(), fwc))));
    h = Beb(MD(WMb(b, $vc)));
    g = Beb(MD(WMb(b, Xvc)));
    r = JD(WMb(b, Duc), 346);
    B = r == (ozc(), nzc);
    A = Beb(MD(WMb(b, Euc)));
    a.d = b;
    a.j.c.length = 0;
    a.a.c.length = 0;
    Tib(a.k);
    i = JD(Mlb(b.b, 0), 25);
    k = Yq(i.a, (gMc(), eMc));
    o = JD(Mlb(b.b, b.b.c.length - 1), 25);
    l = Yq(o.a, eMc);
    p = new rmb(b.b);
    q = null;
    G = 0;
    do {
        t = p.a < p.c.c.length ? JD(pmb(p), 25) : null;
        LOc(a, q, t);
        OOc(a);
        C = Sub(mBb(HBb(BBb(new RBb(null, new Gvb(a.i, 16)), new mPc), new oPc)));
        F = 0;
        u = G;
        m = !q || k && q == i;
        n = !t || l && t == o;
        if (C > 0) {
            j = 0;
            !!q && (j += h);
            j += (C - 1) * g;
            !!t && (j += h);
            B && !!t && (j = $wnd.Math.max(j, MOc(t, g, s, A)));
            if (j < s && !m && !n) {
                F = (s - j) / 2;
                j = s;
            }
            u += j;
        } else !m && !n && (u += s);
        !!t && zXb(t, u);
        for(w = new rmb(a.i); w.a < w.c.c.length;){
            v = JD(pmb(w), 132);
            v.a.c = G;
            v.a.b = u - G;
            v.F = F;
            v.p = !q;
        }
        Klb(a.a, a.i);
        G = u;
        !!t && (G += t.c.a);
        q = t;
        m = n;
    }while (t);
    for(e = new rmb(a.j); e.a < e.c.c.length;){
        d = JD(pmb(e), 18);
        f = SOc(a, d);
        ZMb(d, (Iqc(), Bqc), f);
        D = UOc(a, d);
        ZMb(d, Dqc, D);
    }
    b.f.a = G;
    a.d = null;
    c.Tg();
}
function j3b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    a.b = b;
    a.a = JD(WMb(b, (Bwc(), Juc)), 17).a;
    a.c = JD(WMb(b, Luc), 17).a;
    a.c == 0 && (a.c = Hqe);
    q = new Ajb(b.b, 0);
    while(q.b < q.d.gc()){
        p = (rDb(q.b < q.d.gc()), JD(q.d.Xb(q.c = q.b++), 25));
        h = new Ulb;
        k = -1;
        u = -1;
        for(t = new rmb(p.a); t.a < t.c.c.length;){
            s = JD(pmb(t), 9);
            if (Gr((e3b(), new es(Ir(eYb(s).a.Jc(), new er)))) >= a.a) {
                d = f3b(a, s);
                k = $wnd.Math.max(k, d.b);
                u = $wnd.Math.max(u, d.d);
                Ilb(h, new xod(s, d));
            }
        }
        B = new Ulb;
        for(j = 0; j < k; ++j)Hlb(B, 0, (rDb(q.b > 0), q.a.Xb(q.c = --q.b), C = new b$b(a.b), zjb(q, C), rDb(q.b < q.d.gc()), q.d.Xb(q.c = q.b++), C));
        for(g = new rmb(h); g.a < g.c.c.length;){
            e = JD(pmb(g), 47);
            n = JD(e.b, 562).a;
            if (!n) continue;
            for(m = new rmb(n); m.a < m.c.c.length;){
                l = JD(pmb(m), 9);
                i3b(a, l, c3b, B);
            }
        }
        c = new Ulb;
        for(i = 0; i < u; ++i)Ilb(c, (D = new b$b(a.b), zjb(q, D), D));
        for(f = new rmb(h); f.a < f.c.c.length;){
            e = JD(pmb(f), 47);
            A = JD(e.b, 562).c;
            if (!A) continue;
            for(w = new rmb(A); w.a < w.c.c.length;){
                v = JD(pmb(w), 9);
                i3b(a, v, d3b, c);
            }
        }
    }
    r = new Ajb(b.b, 0);
    while(r.b < r.d.gc()){
        o = (rDb(r.b < r.d.gc()), JD(r.d.Xb(r.c = r.b++), 25));
        o.a.c.length == 0 && tjb(r);
    }
}
function VGd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    p = a.i != 0;
    t = false;
    r = null;
    if (qqd(a.e)) {
        k = b.gc();
        if (k > 0) {
            m = k < 100 ? null : new FGd(k);
            j = new xDd(b);
            o = j.g;
            r = SC(cE, ise, 30, k, 15, 1);
            d = 0;
            u = new wDd(k);
            for(e = 0; e < a.i; ++e){
                h = a.g[e];
                n = h;
                v: for(s = 0; s < 2; ++s){
                    for(i = k; --i >= 0;)if (n != null ? pb(n, o[i]) : XD(n) === XD(o[i])) {
                        if (r.length <= d) {
                            q = r;
                            r = SC(cE, ise, 30, 2 * r.length, 15, 1);
                            $gb(q, 0, r, 0, d);
                        }
                        r[d++] = e;
                        tCd(u, o[i]);
                        break v;
                    }
                    n;
                    if (XD(n) === XD(h)) break;
                }
            }
            j = u;
            o = u.g;
            k = d;
            if (d > r.length) {
                q = r;
                r = SC(cE, ise, 30, d, 15, 1);
                $gb(q, 0, r, 0, d);
            }
            if (d > 0) {
                t = true;
                for(f = 0; f < d; ++f){
                    n = o[f];
                    m = dce(a, JD(n, 74), m);
                }
                for(g = d; --g >= 0;)qDd(a, r[g]);
                if (d != k) {
                    for(e = k; --e >= d;)qDd(j, e);
                    q = r;
                    r = SC(cE, ise, 30, d, 15, 1);
                    $gb(q, 0, r, 0, d);
                }
                b = j;
            }
        }
    } else {
        b = zCd(a, b);
        for(e = a.i; --e >= 0;)if (b.Gc(a.g[e])) {
            qDd(a, e);
            t = true;
        }
    }
    if (t) {
        if (r != null) {
            c = b.gc();
            l = c == 1 ? yUd(a, 4, b.Jc().Pb(), null, r[0], p) : yUd(a, 6, b, r, r[0], p);
            m = c < 100 ? null : new FGd(c);
            for(e = b.Jc(); e.Ob();){
                n = e.Pb();
                m = Jbe(a, JD(n, 74), m);
            }
            if (!m) Wpd(a.e, l);
            else {
                m.kj(l);
                m.lj();
            }
        } else {
            m = SGd(b.gc());
            for(e = b.Jc(); e.Ob();){
                n = e.Pb();
                m = Jbe(a, JD(n, 74), m);
            }
            !!m && m.lj();
        }
        return true;
    } else return false;
}
function sUb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    c = new zUb(b);
    c.a || lUb(b);
    j = kUb(b);
    i = new Pp;
    q = new NUb;
    for(p = new rmb(b.a); p.a < p.c.c.length;){
        o = JD(pmb(p), 9);
        for(e = new es(Ir(kYb(o).a.Jc(), new er)); cs(e);){
            d = JD(ds(e), 18);
            if (d.c.i.k == (DYb(), wYb) || d.d.i.k == wYb) {
                k = rUb(a, d, j, q);
                Rc(i, pUb(k.d), k.a);
            }
        }
    }
    g = new Ulb;
    for(t = JD(WMb(c.c, (Iqc(), Qpc)), 22).Jc(); t.Ob();){
        s = JD(t.Pb(), 64);
        n = q.c[s.g];
        m = q.b[s.g];
        h = q.a[s.g];
        f = null;
        r = null;
        switch(s.g){
            case 4:
                f = new gdd(a.d.a, n, j.b.a - a.d.a, m - n);
                r = new gdd(a.d.a, n, h, m - n);
                vUb(j, new Edd(f.c + f.b, f.d));
                vUb(j, new Edd(f.c + f.b, f.d + f.a));
                break;
            case 2:
                f = new gdd(j.a.a, n, a.c.a - j.a.a, m - n);
                r = new gdd(a.c.a - h, n, h, m - n);
                vUb(j, new Edd(f.c, f.d));
                vUb(j, new Edd(f.c, f.d + f.a));
                break;
            case 1:
                f = new gdd(n, a.d.b, m - n, j.b.b - a.d.b);
                r = new gdd(n, a.d.b, m - n, h);
                vUb(j, new Edd(f.c, f.d + f.a));
                vUb(j, new Edd(f.c + f.b, f.d + f.a));
                break;
            case 3:
                f = new gdd(n, j.a.b, m - n, a.c.b - j.a.b);
                r = new gdd(n, a.c.b - h, m - n, h);
                vUb(j, new Edd(f.c, f.d));
                vUb(j, new Edd(f.c + f.b, f.d));
        }
        if (f) {
            l = new IUb;
            l.d = s;
            l.b = f;
            l.c = r;
            l.a = Qx(JD(Qc(i, pUb(s)), 22));
            YCb(g.c, l);
        }
    }
    Klb(c.b, g);
    c.d = NSb(VSb(j));
    return c;
}
function SKc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (c.p[b.p] != null) return;
    h = true;
    c.p[b.p] = 0;
    g = b;
    p = c.o == (HKc(), FKc) ? Lse : Kse;
    do {
        e = a.b.e[g.p];
        f = g.c.a.c.length;
        if (c.o == FKc && e > 0 || c.o == GKc && e < f - 1) {
            i = null;
            j = null;
            c.o == GKc ? i = JD(Mlb(g.c.a, e + 1), 9) : i = JD(Mlb(g.c.a, e - 1), 9);
            j = c.g[i.p];
            SKc(a, j, c);
            p = a.e.ug(p, b, g);
            c.j[b.p] == b && (c.j[b.p] = c.j[j.p]);
            if (c.j[b.p] == c.j[j.p]) {
                o = ezc(a.d, g, i);
                if (c.o == GKc) {
                    d = Beb(c.p[b.p]);
                    l = Beb(c.p[j.p]) + Beb(c.d[i.p]) - i.d.d - o - g.d.a - g.o.b - Beb(c.d[g.p]);
                    if (h) {
                        h = false;
                        c.p[b.p] = $wnd.Math.min(l, p);
                    } else c.p[b.p] = $wnd.Math.min(d, $wnd.Math.min(l, p));
                } else {
                    d = Beb(c.p[b.p]);
                    l = Beb(c.p[j.p]) + Beb(c.d[i.p]) + i.o.b + i.d.a + o + g.d.d - Beb(c.d[g.p]);
                    if (h) {
                        h = false;
                        c.p[b.p] = $wnd.Math.max(l, p);
                    } else c.p[b.p] = $wnd.Math.max(d, $wnd.Math.max(l, p));
                }
            } else {
                o = Beb(MD(WMb(a.a, (Bwc(), ewc))));
                n = QKc(a, c.j[b.p]);
                k = QKc(a, c.j[j.p]);
                if (c.o == GKc) {
                    m = Beb(c.p[b.p]) + Beb(c.d[g.p]) + g.o.b + g.d.a + o - (Beb(c.p[j.p]) + Beb(c.d[i.p]) - i.d.d);
                    WKc(n, k, m);
                } else {
                    m = Beb(c.p[b.p]) + Beb(c.d[g.p]) - g.d.d - Beb(c.p[j.p]) - Beb(c.d[i.p]) - i.o.b - i.d.a - o;
                    WKc(n, k, m);
                }
            }
        } else p = a.e.ug(p, b, g);
        g = c.a[g.p];
    }while (g != b);
    tLc(a.e, b);
}
function bFc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    c = Beb(MD(WMb(a.a.j, (Bwc(), iuc))));
    if (c < -1 || !a.a.i || bjd(JD(WMb(a.a.o, Evc), 100)) || lYb(a.a.o, (Rjd(), wjd)).gc() < 2 && lYb(a.a.o, Qjd).gc() < 2) return true;
    if (a.a.c.ig()) return false;
    v = 0;
    u = 0;
    t = new Ulb;
    for(i = a.a.e, j = 0, k = i.length; j < k; ++j){
        h = i[j];
        for(m = h, n = 0, p = m.length; n < p; ++n){
            l = m[n];
            if (l.k == (DYb(), BYb)) {
                YCb(t.c, l);
                continue;
            }
            d = a.b[l.c.p][l.p];
            if (l.k == wYb) {
                d.b = 1;
                JD(WMb(l, (Iqc(), kqc)), 11).j == (Rjd(), wjd) && (u += d.a);
            } else {
                C = lYb(l, (Rjd(), Qjd));
                C.dc() || !Zq(C, new oFc) ? d.c = 1 : (e = lYb(l, wjd), (e.dc() || !Zq(e, new kFc)) && (v += d.a));
            }
            for(g = new es(Ir(kYb(l).a.Jc(), new er)); cs(g);){
                f = JD(ds(g), 18);
                v += d.c;
                u += d.b;
                B = f.d.i;
                aFc(a, d, B);
            }
            r = yl(WC(OC(VI, 1), Nqe, 20, 0, [
                lYb(l, (Rjd(), xjd)),
                lYb(l, Ojd)
            ]));
            for(A = new es(new Gl(r.a.length, r.a)); cs(A);){
                w = JD(ds(A), 11);
                s = JD(WMb(w, (Iqc(), sqc)), 9);
                if (s) {
                    v += d.c;
                    u += d.b;
                    aFc(a, d, s);
                }
            }
        }
        for(o = new rmb(t); o.a < o.c.c.length;){
            l = JD(pmb(o), 9);
            d = a.b[l.c.p][l.p];
            for(g = new es(Ir(kYb(l).a.Jc(), new er)); cs(g);){
                f = JD(ds(g), 18);
                v += d.c;
                u += d.b;
                B = f.d.i;
                aFc(a, d, B);
            }
        }
        t.c.length = 0;
    }
    b = v + u;
    q = b == 0 ? Kse : (v - u) / b;
    return q >= c;
}
function THc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    for(t = a.a, u = 0, v = t.length; u < v; ++u){
        s = t[u];
        j = Hqe;
        k = Hqe;
        for(o = new rmb(s.e); o.a < o.c.c.length;){
            m = JD(pmb(o), 9);
            g = !m.c ? -1 : Nlb(m.c.a, m, 0);
            if (g > 0) {
                l = JD(Mlb(m.c.a, g - 1), 9);
                B = ezc(a.b, m, l);
                q = m.n.b - m.d.d - (l.n.b + l.o.b + l.d.a + B);
            } else q = m.n.b - m.d.d;
            j = $wnd.Math.min(q, j);
            if (g < m.c.a.c.length - 1) {
                l = JD(Mlb(m.c.a, g + 1), 9);
                B = ezc(a.b, m, l);
                r = l.n.b - l.d.d - (m.n.b + m.o.b + m.d.a + B);
            } else r = 2 * m.n.b;
            k = $wnd.Math.min(r, k);
        }
        i = Hqe;
        f = false;
        e = JD(Mlb(s.e, 0), 9);
        for(D = new rmb(e.j); D.a < D.c.c.length;){
            C = JD(pmb(D), 11);
            p = e.n.b + C.n.b + C.a.b;
            for(d = new rmb(C.e); d.a < d.c.c.length;){
                c = JD(pmb(d), 18);
                w = c.c;
                b = w.i.n.b + w.n.b + w.a.b - p;
                if ($wnd.Math.abs(b) < $wnd.Math.abs(i) && $wnd.Math.abs(b) < (b < 0 ? j : k)) {
                    i = b;
                    f = true;
                }
            }
        }
        h = JD(Mlb(s.e, s.e.c.length - 1), 9);
        for(A = new rmb(h.j); A.a < A.c.c.length;){
            w = JD(pmb(A), 11);
            p = h.n.b + w.n.b + w.a.b;
            for(d = new rmb(w.g); d.a < d.c.c.length;){
                c = JD(pmb(d), 18);
                C = c.d;
                b = C.i.n.b + C.n.b + C.a.b - p;
                if ($wnd.Math.abs(b) < $wnd.Math.abs(i) && $wnd.Math.abs(b) < (b < 0 ? j : k)) {
                    i = b;
                    f = true;
                }
            }
        }
        if (f && i != 0) for(n = new rmb(s.e); n.a < n.c.c.length;){
            m = JD(pmb(n), 9);
            m.n.b += i;
        }
    }
}
function rzd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    t = b;
    s = new Pp;
    u = new Pp;
    k = $xd(t, nDe);
    d = new Lzd(a, c, s, u);
    Eyd(d.a, d.b, d.c, d.d, k);
    i = (A = s.i, !A ? s.i = new xf(s, s.c) : A);
    for(C = i.Jc(); C.Ob();){
        B = JD(C.Pb(), 168);
        e = JD(Qc(s, B), 22);
        for(p = e.Jc(); p.Ob();){
            o = p.Pb();
            v = JD(wo(a.f, o), 168);
            if (v) {
                h = (!B.e && (B.e = new ree(w3, B, 10, 9)), B.e);
                tCd(h, v);
            } else {
                g = byd(t, vDe);
                m = BDe + o + CDe + g;
                n = m + ADe;
                throw scb(new eyd(n));
            }
        }
    }
    j = (w = u.i, !w ? u.i = new xf(u, u.c) : w);
    for(F = j.Jc(); F.Ob();){
        D = JD(F.Pb(), 168);
        f = JD(Qc(u, D), 22);
        for(r = f.Jc(); r.Ob();){
            q = r.Pb();
            v = JD(wo(a.f, q), 168);
            if (v) {
                l = (!D.g && (D.g = new ree(w3, D, 9, 10)), D.g);
                tCd(l, v);
            } else {
                g = byd(t, vDe);
                m = BDe + q + CDe + g;
                n = m + ADe;
                throw scb(new eyd(n));
            }
        }
    }
    !c.b && (c.b = new ree(v3, c, 4, 7));
    if (c.b.i != 0 && (!c.c && (c.c = new ree(v3, c, 5, 8)), c.c.i != 0) && (!c.b && (c.b = new ree(v3, c, 4, 7)), c.b.i <= 1 && (!c.c && (c.c = new ree(v3, c, 5, 8)), c.c.i <= 1)) && (!c.a && (c.a = new X0d(w3, c, 6, 6)), c.a).i == 1) {
        G = JD(nDd((!c.a && (c.a = new X0d(w3, c, 6, 6)), c.a), 0), 168);
        if (!fud(G) && !gud(G)) {
            mud(G, JD(nDd((!c.b && (c.b = new ree(v3, c, 4, 7)), c.b), 0), 84));
            nud(G, JD(nDd((!c.c && (c.c = new ree(v3, c, 5, 8)), c.c), 0), 84));
        }
    }
}
function H3b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    d = new Ulb;
    e = Hqe;
    f = Hqe;
    g = Hqe;
    if (c) {
        e = a.f.a;
        for(p = new rmb(b.j); p.a < p.c.c.length;){
            o = JD(pmb(p), 11);
            for(i = new rmb(o.g); i.a < i.c.c.length;){
                h = JD(pmb(i), 18);
                if (h.a.b != 0) {
                    k = JD(Etb(h.a), 8);
                    if (k.a < e) {
                        f = e - k.a;
                        g = Hqe;
                        d.c.length = 0;
                        e = k.a;
                    }
                    if (k.a <= e) {
                        YCb(d.c, h);
                        h.a.b > 1 && (g = $wnd.Math.min(g, $wnd.Math.abs(JD(fu(h.a, 1), 8).b - k.b)));
                    }
                }
            }
        }
    } else for(p = new rmb(b.j); p.a < p.c.c.length;){
        o = JD(pmb(p), 11);
        for(i = new rmb(o.e); i.a < i.c.c.length;){
            h = JD(pmb(i), 18);
            if (h.a.b != 0) {
                m = JD(Ftb(h.a), 8);
                if (m.a > e) {
                    f = m.a - e;
                    g = Hqe;
                    d.c.length = 0;
                    e = m.a;
                }
                if (m.a >= e) {
                    YCb(d.c, h);
                    h.a.b > 1 && (g = $wnd.Math.min(g, $wnd.Math.abs(JD(fu(h.a, h.a.b - 2), 8).b - m.b)));
                }
            }
        }
    }
    if (d.c.length != 0 && f > b.o.a / 2 && g > b.o.b / 2) {
        n = new bZb;
        _Yb(n, b);
        aZb(n, (Rjd(), xjd));
        n.n.a = b.o.a / 2;
        r = new bZb;
        _Yb(r, b);
        aZb(r, Ojd);
        r.n.a = b.o.a / 2;
        r.n.b = b.o.b;
        for(i = new rmb(d); i.a < i.c.c.length;){
            h = JD(pmb(i), 18);
            if (c) {
                j = JD(Itb(h.a), 8);
                q = h.a.b == 0 ? WYb(h.d) : JD(Etb(h.a), 8);
                q.b >= j.b ? gWb(h, r) : gWb(h, n);
            } else {
                j = JD(Jtb(h.a), 8);
                q = h.a.b == 0 ? WYb(h.c) : JD(Ftb(h.a), 8);
                q.b >= j.b ? hWb(h, r) : hWb(h, n);
            }
            l = JD(WMb(h, (Bwc(), Ruc)), 77);
            !!l && ye(l, j, true);
        }
        b.n.a = e - b.o.a / 2;
    }
}
function HWc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    for(h = Gtb(a.b, 0); h.b != h.d.c;){
        g = JD(Utb(h), 39);
        if (cgb(g.c, Dze)) continue;
        j = lQc(g, a);
        b == (Tgd(), Pgd) || b == Qgd ? Slb(j, new GXc) : Slb(j, new KXc);
        i = j.c.length;
        for(d = 0; d < i; d++){
            k = (sDb(d, j.c.length), JD(j.c[d], 65)).c;
            cgb(k.c, 'n11') && c_;
            if (ydb(LD(WMb(g, (tUc(), XTc)))) && !pQc((sDb(d, j.c.length), JD(j.c[d], 65)), a)) continue;
            e = i == 1 ? 0.5 : (d + 1) / (i + 1);
            if (b == Pgd) {
                f = Beb(MD(WMb(g, iUc)));
                m = g.e.b + g.f.b * e;
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd($wnd.Math.min(f, g.e.a - c), m));
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(g.e.a, m));
            } else if (b == Qgd) {
                f = Beb(MD(WMb(g, hUc))) + c;
                m = g.e.b + g.f.b * e;
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(f, m));
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(g.e.a + g.f.a, m));
            } else if (b == Sgd) {
                f = Beb(MD(WMb(g, iUc)));
                l = g.e.a + g.f.a * e;
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(l, $wnd.Math.min(g.e.b - c, f)));
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(l, g.e.b));
            } else {
                f = Beb(MD(WMb(g, hUc))) + c;
                l = g.e.a + g.f.a * e;
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(l, f));
                Btb((sDb(d, j.c.length), JD(j.c[d], 65)).a, new Edd(l, g.e.b + g.f.b));
            }
        }
    }
}
function pXb(a, b, c, d, e, f, g, h, i) {
    var j, k, l, m, n, o, p;
    n = c;
    k = new tYb(i);
    rYb(k, (DYb(), wYb));
    ZMb(k, (Iqc(), Upc), g);
    ZMb(k, (Bwc(), Evc), (ajd(), Xid));
    p = Beb(MD(a.mf(Dvc)));
    ZMb(k, Dvc, p);
    l = new bZb;
    _Yb(l, k);
    if (!(b != $id && b != _id)) {
        d >= 0 ? n = Wjd(h) : n = Tjd(Wjd(h));
        a.of(Jvc, n);
    }
    j = new Cdd;
    m = false;
    if (a.nf(Cvc)) {
        zdd(j, JD(a.mf(Cvc), 8));
        m = true;
    } else ydd(j, g.a / 2, g.b / 2);
    switch(n.g){
        case 4:
            ZMb(k, Uuc, (Oqc(), Kqc));
            ZMb(k, Npc, (Tnc(), Snc));
            k.o.b = g.b;
            p < 0 && (k.o.a = -p);
            aZb(l, (Rjd(), wjd));
            m || (j.a = g.a);
            j.a -= g.a;
            break;
        case 2:
            ZMb(k, Uuc, (Oqc(), Mqc));
            ZMb(k, Npc, (Tnc(), Qnc));
            k.o.b = g.b;
            p < 0 && (k.o.a = -p);
            aZb(l, (Rjd(), Qjd));
            m || (j.a = 0);
            break;
        case 1:
            ZMb(k, $pc, (qpc(), ppc));
            k.o.a = g.a;
            p < 0 && (k.o.b = -p);
            aZb(l, (Rjd(), Ojd));
            m || (j.b = g.b);
            j.b -= g.b;
            break;
        case 3:
            ZMb(k, $pc, (qpc(), npc));
            k.o.a = g.a;
            p < 0 && (k.o.b = -p);
            aZb(l, (Rjd(), xjd));
            m || (j.b = 0);
    }
    zdd(l.n, j);
    ZMb(k, Cvc, j);
    if (b == Wid || b == Yid || b == Xid) {
        o = 0;
        if (b == Wid && a.nf(Fvc)) switch(n.g){
            case 1:
            case 2:
                o = JD(a.mf(Fvc), 17).a;
                break;
            case 3:
            case 4:
                o = -JD(a.mf(Fvc), 17).a;
        }
        else switch(n.g){
            case 4:
            case 2:
                o = f.b;
                b == Yid && (o /= e.b);
                break;
            case 1:
            case 3:
                o = f.a;
                b == Yid && (o /= e.a);
        }
        ZMb(k, tqc, o);
    }
    ZMb(k, Tpc, n);
    return k;
}
function lEd() {
    jEd();
    function h(f) {
        var g = this;
        this.dispatch = function(a) {
            var b = a.data;
            switch(b.cmd){
                case 'algorithms':
                    var c = mEd((pnb(), new oob(new Zjb(iEd.b))));
                    f.postMessage({
                        id: b.id,
                        data: c
                    });
                    break;
                case 'categories':
                    var d = mEd((pnb(), new oob(new Zjb(iEd.c))));
                    f.postMessage({
                        id: b.id,
                        data: d
                    });
                    break;
                case 'options':
                    var e = mEd((pnb(), new oob(new Zjb(iEd.d))));
                    f.postMessage({
                        id: b.id,
                        data: e
                    });
                    break;
                case 'register':
                    pEd(b.algorithms);
                    f.postMessage({
                        id: b.id
                    });
                    break;
                case 'layout':
                    nEd(b.graph, b.layoutOptions || {}, b.options || {});
                    f.postMessage({
                        id: b.id,
                        data: b.graph
                    });
                    break;
            }
        };
        this.saveDispatch = function(b) {
            try {
                g.dispatch(b);
            } catch (a) {
                f.postMessage({
                    id: b.data.id,
                    error: a
                });
            }
        };
    }
    function j(b) {
        var c = this;
        this.dispatcher = new h({
            postMessage: function(a) {
                c.onmessage({
                    data: a
                });
            }
        });
        this.postMessage = function(a) {
            setTimeout(function() {
                c.dispatcher.saveDispatch({
                    data: a
                });
            }, 0);
        };
    }
    if (typeof document === ste && typeof self !== ste) {
        var i = new h(self);
        self.onmessage = i.saveDispatch;
    } else if ("object" !== ste && module.exports) {
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        module.exports = {
            'default': j,
            Worker: j
        };
    }
}
function u$b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    k = new tYb(c);
    UMb(k, b);
    ZMb(k, (Iqc(), kqc), b);
    k.o.a = b.g;
    k.o.b = b.f;
    k.n.a = b.i;
    k.n.b = b.j;
    Ilb(c.a, k);
    Qib(a.a, b, k);
    ((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i != 0 || ydb(LD(ksd(b, (Bwc(), Nuc))))) && ZMb(k, Ipc, (xdb(), true));
    j = JD(WMb(c, Wpc), 22);
    l = JD(WMb(k, (Bwc(), Evc)), 100);
    l == (ajd(), _id) ? ZMb(k, Evc, $id) : l != $id && j.Ec(($oc(), Woc));
    m = 0;
    d = JD(WMb(c, ruc), 86);
    for(i = new CHd((!b.c && (b.c = new X0d(B3, b, 9, 9)), b.c)); i.e != i.i.gc();){
        h = JD(AHd(i), 124);
        e = Zwd(b);
        (XD(ksd(e, cuc)) !== XD((nyc(), kyc)) || XD(ksd(e, puc)) === XD((znc(), ync)) || XD(ksd(e, puc)) === XD((znc(), wnc)) || ydb(LD(ksd(e, euc))) || XD(ksd(e, Ytc)) !== XD((cUb(), bUb)) || XD(ksd(e, Zuc)) === XD((dyc(), Wxc)) || XD(ksd(e, Zuc)) === XD((dyc(), Xxc)) || XD(ksd(e, $uc)) === XD((cxc(), Vwc)) || XD(ksd(e, $uc)) === XD((cxc(), Xwc))) && !ydb(LD(ksd(b, auc))) && msd(h, jqc, jfb(m++));
        ydb(LD(ksd(h, svc))) || v$b(a, h, k, j, d, l);
    }
    for(g = new CHd((!b.n && (b.n = new X0d(z3, b, 1, 7)), b.n)); g.e != g.i.gc();){
        f = JD(AHd(g), 153);
        !ydb(LD(ksd(f, svc))) && !!f.a && Ilb(k.b, t$b(f));
    }
    ydb(LD(WMb(k, Utc))) && j.Ec(($oc(), Roc));
    if (ydb(LD(WMb(k, Muc)))) {
        j.Ec(($oc(), Voc));
        j.Ec(Uoc);
        ZMb(k, Evc, $id);
    }
    return k;
}
function Sld(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    p = 0;
    D = 0;
    for(j = new rmb(a.b); j.a < j.c.c.length;){
        i = JD(pmb(j), 162);
        !!i.c && lnd(i.c);
        p = $wnd.Math.max(p, cmd(i));
        D += cmd(i) * bmd(i);
    }
    q = D / a.b.c.length;
    C = Lld(a.b, q);
    D += a.b.c.length * C;
    p = $wnd.Math.max(p, $wnd.Math.sqrt(D * g)) + c.b;
    H = c.b;
    I = c.d;
    n = 0;
    l = c.b + c.c;
    B = new Mtb;
    Atb(B, jfb(0));
    w = new Mtb;
    k = new Ajb(a.b, 0);
    o = null;
    h = new Ulb;
    while(k.b < k.d.gc()){
        i = (rDb(k.b < k.d.gc()), JD(k.d.Xb(k.c = k.b++), 162));
        G = cmd(i);
        m = bmd(i);
        if (H + G > p) {
            if (f) {
                Ctb(w, n);
                Ctb(B, jfb(k.b - 1));
                Ilb(a.d, o);
                h.c.length = 0;
            }
            H = c.b;
            I += n + b;
            n = 0;
            l = $wnd.Math.max(l, c.b + c.c + G);
        }
        YCb(h.c, i);
        fmd(i, H, I);
        l = $wnd.Math.max(l, H + G + c.c);
        n = $wnd.Math.max(n, m);
        H += G + b;
        o = i;
    }
    Klb(a.a, h);
    Ilb(a.d, JD(Mlb(h, h.c.length - 1), 162));
    l = $wnd.Math.max(l, d);
    F = I + n + c.a;
    if (F < e) {
        n += e - F;
        F = e;
    }
    if (f) {
        H = c.b;
        k = new Ajb(a.b, 0);
        Ctb(B, jfb(a.b.c.length));
        A = Gtb(B, 0);
        s = JD(Utb(A), 17).a;
        Ctb(w, n);
        v = Gtb(w, 0);
        u = 0;
        while(k.b < k.d.gc()){
            if (k.b == s) {
                H = c.b;
                u = Beb(MD(Utb(v)));
                s = JD(Utb(A), 17).a;
            }
            i = (rDb(k.b < k.d.gc()), JD(k.d.Xb(k.c = k.b++), 162));
            dmd(i, u);
            if (k.b == s) {
                r = l - H - c.c;
                t = cmd(i);
                emd(i, r);
                gmd(i, (r - t) / 2, 0);
            }
            H += cmd(i) + b;
        }
    }
    return new Edd(l, F);
}
function Uie(a) {
    if (a.N) return;
    a.N = true;
    a.b = Nvd(a, 0);
    Mvd(a.b, 0);
    Mvd(a.b, 1);
    Mvd(a.b, 2);
    a.bb = Nvd(a, 1);
    Mvd(a.bb, 0);
    Mvd(a.bb, 1);
    a.fb = Nvd(a, 2);
    Mvd(a.fb, 3);
    Mvd(a.fb, 4);
    Svd(a.fb, 5);
    a.qb = Nvd(a, 3);
    Mvd(a.qb, 0);
    Svd(a.qb, 1);
    Svd(a.qb, 2);
    Mvd(a.qb, 3);
    Mvd(a.qb, 4);
    Svd(a.qb, 5);
    Mvd(a.qb, 6);
    a.a = Ovd(a, 4);
    a.c = Ovd(a, 5);
    a.d = Ovd(a, 6);
    a.e = Ovd(a, 7);
    a.f = Ovd(a, 8);
    a.g = Ovd(a, 9);
    a.i = Ovd(a, 10);
    a.j = Ovd(a, 11);
    a.k = Ovd(a, 12);
    a.n = Ovd(a, 13);
    a.o = Ovd(a, 14);
    a.p = Ovd(a, 15);
    a.q = Ovd(a, 16);
    a.s = Ovd(a, 17);
    a.r = Ovd(a, 18);
    a.t = Ovd(a, 19);
    a.u = Ovd(a, 20);
    a.v = Ovd(a, 21);
    a.w = Ovd(a, 22);
    a.B = Ovd(a, 23);
    a.A = Ovd(a, 24);
    a.C = Ovd(a, 25);
    a.D = Ovd(a, 26);
    a.F = Ovd(a, 27);
    a.G = Ovd(a, 28);
    a.H = Ovd(a, 29);
    a.J = Ovd(a, 30);
    a.I = Ovd(a, 31);
    a.K = Ovd(a, 32);
    a.M = Ovd(a, 33);
    a.L = Ovd(a, 34);
    a.P = Ovd(a, 35);
    a.Q = Ovd(a, 36);
    a.R = Ovd(a, 37);
    a.S = Ovd(a, 38);
    a.T = Ovd(a, 39);
    a.U = Ovd(a, 40);
    a.V = Ovd(a, 41);
    a.X = Ovd(a, 42);
    a.W = Ovd(a, 43);
    a.Y = Ovd(a, 44);
    a.Z = Ovd(a, 45);
    a.$ = Ovd(a, 46);
    a._ = Ovd(a, 47);
    a.ab = Ovd(a, 48);
    a.cb = Ovd(a, 49);
    a.db = Ovd(a, 50);
    a.eb = Ovd(a, 51);
    a.gb = Ovd(a, 52);
    a.hb = Ovd(a, 53);
    a.ib = Ovd(a, 54);
    a.jb = Ovd(a, 55);
    a.kb = Ovd(a, 56);
    a.lb = Ovd(a, 57);
    a.mb = Ovd(a, 58);
    a.nb = Ovd(a, 59);
    a.ob = Ovd(a, 60);
    a.pb = Ovd(a, 61);
}
function I1b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    s = 0;
    if (b.f.a == 0) for(q = new rmb(a); q.a < q.c.c.length;){
        o = JD(pmb(q), 9);
        s = $wnd.Math.max(s, o.n.a + o.o.a + o.d.c);
    }
    else s = b.f.a - b.c.a;
    s -= b.c.a;
    for(p = new rmb(a); p.a < p.c.c.length;){
        o = JD(pmb(p), 9);
        J1b(o.n, s - o.o.a);
        K1b(o.f);
        G1b(o);
        (!o.q ? (pnb(), pnb(), nnb) : o.q)._b((Bwc(), Lvc)) && J1b(JD(WMb(o, Lvc), 8), s - o.o.a);
        switch(JD(WMb(o, Rtc), 254).g){
            case 1:
                ZMb(o, Rtc, (ced(), aed));
                break;
            case 2:
                ZMb(o, Rtc, (ced(), _dd));
        }
        r = o.o;
        for(u = new rmb(o.j); u.a < u.c.c.length;){
            t = JD(pmb(u), 11);
            J1b(t.n, r.a - t.o.a);
            J1b(t.a, t.o.a);
            aZb(t, A1b(t.j));
            g = JD(WMb(t, Fvc), 17);
            !!g && ZMb(t, Fvc, jfb(-g.a));
            for(f = new rmb(t.g); f.a < f.c.c.length;){
                e = JD(pmb(f), 18);
                for(d = Gtb(e.a, 0); d.b != d.d.c;){
                    c = JD(Utb(d), 8);
                    c.a = s - c.a;
                }
                j = JD(WMb(e, Ruc), 77);
                if (j) for(i = Gtb(j, 0); i.b != i.d.c;){
                    h = JD(Utb(i), 8);
                    h.a = s - h.a;
                }
                for(m = new rmb(e.b); m.a < m.c.c.length;){
                    k = JD(pmb(m), 72);
                    J1b(k.n, s - k.o.a);
                }
            }
            for(n = new rmb(t.f); n.a < n.c.c.length;){
                k = JD(pmb(n), 72);
                J1b(k.n, t.o.a - k.o.a);
            }
        }
        if (o.k == (DYb(), wYb)) {
            ZMb(o, (Iqc(), Tpc), A1b(JD(WMb(o, Tpc), 64)));
            F1b(o);
        }
        for(l = new rmb(o.b); l.a < l.c.c.length;){
            k = JD(pmb(l), 72);
            G1b(k);
            J1b(k.n, r.a - k.o.a);
        }
    }
}
function L1b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    s = 0;
    if (b.f.b == 0) for(q = new rmb(a); q.a < q.c.c.length;){
        o = JD(pmb(q), 9);
        s = $wnd.Math.max(s, o.n.b + o.o.b + o.d.a);
    }
    else s = b.f.b - b.c.b;
    s -= b.c.b;
    for(p = new rmb(a); p.a < p.c.c.length;){
        o = JD(pmb(p), 9);
        M1b(o.n, s - o.o.b);
        N1b(o.f);
        H1b(o);
        (!o.q ? (pnb(), pnb(), nnb) : o.q)._b((Bwc(), Lvc)) && M1b(JD(WMb(o, Lvc), 8), s - o.o.b);
        switch(JD(WMb(o, Rtc), 254).g){
            case 3:
                ZMb(o, Rtc, (ced(), Zdd));
                break;
            case 4:
                ZMb(o, Rtc, (ced(), bed));
        }
        r = o.o;
        for(u = new rmb(o.j); u.a < u.c.c.length;){
            t = JD(pmb(u), 11);
            M1b(t.n, r.b - t.o.b);
            M1b(t.a, t.o.b);
            aZb(t, B1b(t.j));
            g = JD(WMb(t, Fvc), 17);
            !!g && ZMb(t, Fvc, jfb(-g.a));
            for(f = new rmb(t.g); f.a < f.c.c.length;){
                e = JD(pmb(f), 18);
                for(d = Gtb(e.a, 0); d.b != d.d.c;){
                    c = JD(Utb(d), 8);
                    c.b = s - c.b;
                }
                j = JD(WMb(e, Ruc), 77);
                if (j) for(i = Gtb(j, 0); i.b != i.d.c;){
                    h = JD(Utb(i), 8);
                    h.b = s - h.b;
                }
                for(m = new rmb(e.b); m.a < m.c.c.length;){
                    k = JD(pmb(m), 72);
                    M1b(k.n, s - k.o.b);
                }
            }
            for(n = new rmb(t.f); n.a < n.c.c.length;){
                k = JD(pmb(n), 72);
                M1b(k.n, t.o.b - k.o.b);
            }
        }
        if (o.k == (DYb(), wYb)) {
            ZMb(o, (Iqc(), Tpc), B1b(JD(WMb(o, Tpc), 64)));
            E1b(o);
        }
        for(l = new rmb(o.b); l.a < l.c.c.length;){
            k = JD(pmb(l), 72);
            H1b(k);
            M1b(k.n, r.b - k.o.b);
        }
    }
}
function nlc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    s = new Ajb(a.b, 0);
    k = b.Jc();
    o = 0;
    j = JD(k.Pb(), 17).a;
    v = 0;
    c = new Qrb;
    A = new wtb;
    while(s.b < s.d.gc()){
        r = (rDb(s.b < s.d.gc()), JD(s.d.Xb(s.c = s.b++), 25));
        for(u = new rmb(r.a); u.a < u.c.c.length;){
            t = JD(pmb(u), 9);
            for(n = new es(Ir(kYb(t).a.Jc(), new er)); cs(n);){
                l = JD(ds(n), 18);
                A.a.yc(l, A);
            }
            for(m = new es(Ir(hYb(t).a.Jc(), new er)); cs(m);){
                l = JD(ds(m), 18);
                A.a.Ac(l);
            }
        }
        if (o + 1 == j) {
            e = new b$b(a);
            zjb(s, e);
            f = new b$b(a);
            zjb(s, f);
            for(C = A.a.ec().Jc(); C.Ob();){
                B = JD(C.Pb(), 18);
                if (!c.a._b(B)) {
                    ++v;
                    c.a.yc(B, c);
                }
                g = new tYb(a);
                ZMb(g, (Bwc(), Evc), (ajd(), Zid));
                qYb(g, e);
                rYb(g, (DYb(), vYb));
                p = new bZb;
                _Yb(p, g);
                aZb(p, (Rjd(), Qjd));
                D = new bZb;
                _Yb(D, g);
                aZb(D, wjd);
                d = new tYb(a);
                ZMb(d, Evc, Zid);
                qYb(d, f);
                rYb(d, vYb);
                q = new bZb;
                _Yb(q, d);
                aZb(q, Qjd);
                F = new bZb;
                _Yb(F, d);
                aZb(F, wjd);
                w = new kWb;
                gWb(w, B.c);
                hWb(w, p);
                ZMb(w, (Iqc(), jqc), JD(WMb(B, jqc), 17));
                H = new kWb;
                gWb(H, D);
                hWb(H, q);
                ZMb(H, jqc, JD(WMb(B, jqc), 17));
                gWb(B, F);
                h = new tlc(g, d, w, H, B);
                ZMb(g, Gpc, h);
                ZMb(d, Gpc, h);
                G = w.c.i;
                if (G.k == vYb) {
                    i = JD(WMb(G, Gpc), 314);
                    i.d = h;
                    h.g = i;
                }
            }
            if (k.Ob()) j = JD(k.Pb(), 17).a;
            else break;
        }
        ++o;
    }
    return jfb(v);
}
function Gdc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    p = new Ulb;
    for(m = new rmb(a.d.b); m.a < m.c.c.length;){
        l = JD(pmb(m), 25);
        for(o = new rmb(l.a); o.a < o.c.c.length;){
            n = JD(pmb(o), 9);
            e = JD(Nib(a.f, n), 60);
            for(i = new es(Ir(kYb(n).a.Jc(), new er)); cs(i);){
                g = JD(ds(i), 18);
                d = Gtb(g.a, 0);
                j = true;
                k = null;
                if (d.b != d.d.c) {
                    b = JD(Utb(d), 8);
                    c = null;
                    if (g.c.j == (Rjd(), xjd)) {
                        q = new kfc(b, new Edd(b.a, e.d.d), e, g);
                        q.f.a = true;
                        q.a = g.c;
                        YCb(p.c, q);
                    }
                    if (g.c.j == Ojd) {
                        q = new kfc(b, new Edd(b.a, e.d.d + e.d.a), e, g);
                        q.f.d = true;
                        q.a = g.c;
                        YCb(p.c, q);
                    }
                    while(d.b != d.d.c){
                        c = JD(Utb(d), 8);
                        if (!qEb(b.b, c.b)) {
                            k = new kfc(b, c, null, g);
                            YCb(p.c, k);
                            if (j) {
                                j = false;
                                if (c.b < e.d.d) k.f.a = true;
                                else if (c.b > e.d.d + e.d.a) k.f.d = true;
                                else {
                                    k.f.d = true;
                                    k.f.a = true;
                                }
                            }
                        }
                        d.b != d.d.c && (b = c);
                    }
                    if (k) {
                        f = JD(Nib(a.f, g.d.i), 60);
                        if (b.b < f.d.d) k.f.a = true;
                        else if (b.b > f.d.d + f.d.a) k.f.d = true;
                        else {
                            k.f.d = true;
                            k.f.a = true;
                        }
                    }
                }
            }
            for(h = new es(Ir(hYb(n).a.Jc(), new er)); cs(h);){
                g = JD(ds(h), 18);
                if (g.a.b != 0) {
                    b = JD(Ftb(g.a), 8);
                    if (g.d.j == (Rjd(), xjd)) {
                        q = new kfc(b, new Edd(b.a, e.d.d), e, g);
                        q.f.a = true;
                        q.a = g.d;
                        YCb(p.c, q);
                    }
                    if (g.d.j == Ojd) {
                        q = new kfc(b, new Edd(b.a, e.d.d + e.d.a), e, g);
                        q.f.d = true;
                        q.a = g.d;
                        YCb(p.c, q);
                    }
                }
            }
        }
    }
    return p;
}
function rqd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    i = new Ulb;
    l = b.length;
    g = t1d(c);
    for(j = 0; j < l; ++j){
        k = igb(b, wgb(61), j);
        d = aqd(g, (zDb(j, k, b.length), b.substr(j, k - j)));
        e = DSd(d);
        f = e.gk().si();
        switch(_fb(b, ++k)){
            case 39:
                h = ggb(b, 39, ++k);
                Ilb(i, new dPd(d, Rqd((zDb(k, h, b.length), b.substr(k, h - k)), f, e)));
                j = h + 1;
                break;
            case 34:
                h = ggb(b, 34, ++k);
                Ilb(i, new dPd(d, Rqd((zDb(k, h, b.length), b.substr(k, h - k)), f, e)));
                j = h + 1;
                break;
            case 91:
                m = new Ulb;
                Ilb(i, new dPd(d, m));
                n: for(;;){
                    switch(_fb(b, ++k)){
                        case 39:
                            h = ggb(b, 39, ++k);
                            Ilb(m, Rqd((zDb(k, h, b.length), b.substr(k, h - k)), f, e));
                            k = h + 1;
                            break;
                        case 34:
                            h = ggb(b, 34, ++k);
                            Ilb(m, Rqd((zDb(k, h, b.length), b.substr(k, h - k)), f, e));
                            k = h + 1;
                            break;
                        case 110:
                            ++k;
                            if (b.indexOf('ull', k) == k) m.c.push(null);
                            else throw scb(new qz(NCe));
                            k += 3;
                            break;
                    }
                    if (k < l) switch(ADb(k, b.length), b.charCodeAt(k)){
                        case 44:
                            break;
                        case 93:
                            break n;
                        default:
                            throw scb(new qz('Expecting , or ]'));
                    }
                    else break;
                }
                j = k + 1;
                break;
            case 110:
                ++k;
                if (b.indexOf('ull', k) == k) Ilb(i, new dPd(d, null));
                else throw scb(new qz(NCe));
                j = k + 3;
                break;
        }
        if (j < l) {
            ADb(j, b.length);
            if (b.charCodeAt(j) != 44) throw scb(new qz('Expecting ,'));
        } else break;
    }
    return sqd(a, i, c);
}
function hme(a) {
    var b, c, d, e, f;
    b = a.c;
    f = null;
    switch(b){
        case 6:
            return a.Bm();
        case 13:
            return a.Cm();
        case 23:
            return a.tm();
        case 22:
            return a.ym();
        case 18:
            return a.vm();
        case 8:
            fme(a);
            f = (ooe(), Yne);
            break;
        case 9:
            return a.bm(true);
        case 19:
            return a.cm();
        case 10:
            switch(a.a){
                case 100:
                case 68:
                case 119:
                case 87:
                case 115:
                case 83:
                    f = a.am(a.a);
                    fme(a);
                    return f;
                case 101:
                case 102:
                case 110:
                case 114:
                case 116:
                case 117:
                case 118:
                case 120:
                    c = a._l();
                    c < Pse ? f = (ooe(), ooe(), ++noe, new ape(0, c)) : f = xoe(Lne(c));
                    break;
                case 99:
                    return a.lm();
                case 67:
                    return a.gm();
                case 105:
                    return a.om();
                case 73:
                    return a.hm();
                case 103:
                    return a.mm();
                case 88:
                    return a.im();
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    return a.dm();
                case 80:
                case 112:
                    f = lme(a, a.a);
                    if (!f) throw scb(new eme(qEd((a9d(), iEe))));
                    break;
                default:
                    f = roe(a.a);
            }
            fme(a);
            break;
        case 0:
            if (a.a == 93 || a.a == 123 || a.a == 125) throw scb(new eme(qEd((a9d(), hEe))));
            f = roe(a.a);
            d = a.a;
            fme(a);
            if ((d & 64512) == Qse && a.c == 0 && (a.a & 64512) == 56320) {
                e = SC(_D, Ure, 30, 2, 15, 1);
                e[0] = d & Wre;
                e[1] = a.a & Wre;
                f = woe(xoe(zgb(e, 0, e.length)), 0);
                fme(a);
            }
            break;
        default:
            throw scb(new eme(qEd((a9d(), hEe))));
    }
    return f;
}
function ZOc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    C = new Mtb;
    w = new Mtb;
    q = -1;
    for(i = new rmb(a); i.a < i.c.c.length;){
        g = JD(pmb(i), 132);
        g.s = q--;
        k = 0;
        t = 0;
        for(f = new rmb(g.t); f.a < f.c.c.length;){
            d = JD(pmb(f), 270);
            t += d.c;
        }
        for(e = new rmb(g.i); e.a < e.c.c.length;){
            d = JD(pmb(e), 270);
            k += d.c;
        }
        g.n = k;
        g.u = t;
        t == 0 ? Dtb(w, g, w.c.b, w.c) : k == 0 && Dtb(C, g, C.c.b, C.c);
    }
    F = Tx(a);
    l = a.c.length;
    p = l + 1;
    r = l - 1;
    n = new Ulb;
    while(F.a.gc() != 0){
        while(w.b != 0){
            v = (rDb(w.b != 0), JD(Ktb(w, w.a.a), 132));
            F.a.Ac(v);
            v.s = r--;
            bPc(v, C, w);
        }
        while(C.b != 0){
            A = (rDb(C.b != 0), JD(Ktb(C, C.a.a), 132));
            F.a.Ac(A);
            A.s = p++;
            bPc(A, C, w);
        }
        o = Lre;
        for(j = F.a.ec().Jc(); j.Ob();){
            g = JD(j.Pb(), 132);
            s = g.u - g.n;
            if (s >= o) {
                if (s > o) {
                    n.c.length = 0;
                    o = s;
                }
                YCb(n.c, g);
            }
        }
        if (n.c.length != 0) {
            m = JD(Mlb(n, xvb(b, n.c.length)), 132);
            F.a.Ac(m);
            m.s = p++;
            bPc(m, C, w);
            n.c.length = 0;
        }
    }
    u = a.c.length + 1;
    for(h = new rmb(a); h.a < h.c.c.length;){
        g = JD(pmb(h), 132);
        g.s < l && (g.s += u);
    }
    for(B = new rmb(a); B.a < B.c.c.length;){
        A = JD(pmb(B), 132);
        c = new Ajb(A.t, 0);
        while(c.b < c.d.gc()){
            d = (rDb(c.b < c.d.gc()), JD(c.d.Xb(c.c = c.b++), 270));
            D = d.b;
            if (A.s > D.s) {
                tjb(c);
                Plb(D.i, d);
                if (d.c > 0) {
                    d.a = D;
                    Ilb(D.t, d);
                    d.b = A;
                    Ilb(A.i, d);
                }
            }
        }
    }
}
function R8b(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    p = new Vlb(b.b);
    u = new Vlb(b.b);
    m = new Vlb(b.b);
    B = new Vlb(b.b);
    q = new Vlb(b.b);
    for(A = Gtb(b, 0); A.b != A.d.c;){
        v = JD(Utb(A), 11);
        for(h = new rmb(v.g); h.a < h.c.c.length;){
            f = JD(pmb(h), 18);
            if (f.c.i == f.d.i) {
                if (v.j == f.d.j) {
                    YCb(B.c, f);
                    continue;
                } else if (v.j == (Rjd(), xjd) && f.d.j == Ojd) {
                    YCb(q.c, f);
                    continue;
                }
            }
        }
    }
    for(i = new rmb(q); i.a < i.c.c.length;){
        f = JD(pmb(i), 18);
        S8b(a, f, c, d, (Rjd(), wjd));
    }
    for(g = new rmb(B); g.a < g.c.c.length;){
        f = JD(pmb(g), 18);
        C = new tYb(a);
        rYb(C, (DYb(), BYb));
        ZMb(C, (Bwc(), Evc), (ajd(), Xid));
        ZMb(C, (Iqc(), kqc), f);
        D = new bZb;
        ZMb(D, kqc, f.d);
        aZb(D, (Rjd(), Qjd));
        _Yb(D, C);
        F = new bZb;
        ZMb(F, kqc, f.c);
        aZb(F, wjd);
        _Yb(F, C);
        ZMb(f.c, sqc, C);
        ZMb(f.d, sqc, C);
        gWb(f, null);
        hWb(f, null);
        YCb(c.c, C);
        ZMb(C, Kpc, jfb(2));
    }
    for(w = Gtb(b, 0); w.b != w.d.c;){
        v = JD(Utb(w), 11);
        j = v.e.c.length > 0;
        r = v.g.c.length > 0;
        j && r ? YCb(m.c, v) : j ? YCb(p.c, v) : r && YCb(u.c, v);
    }
    for(o = new rmb(p); o.a < o.c.c.length;){
        n = JD(pmb(o), 11);
        Ilb(e, Q8b(a, n, null, c));
    }
    for(t = new rmb(u); t.a < t.c.c.length;){
        s = JD(pmb(t), 11);
        Ilb(e, Q8b(a, null, s, c));
    }
    for(l = new rmb(m); l.a < l.c.c.length;){
        k = JD(pmb(l), 11);
        Ilb(e, Q8b(a, k, k, c));
    }
}
function Zmd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = Kse;
    n = Kse;
    k = 0;
    l = 0;
    i = new Ulb;
    for(h = new CHd((!a.b && (a.b = new X0d(x3, a, 12, 3)), a.b)); h.e != h.i.gc();){
        f = JD(AHd(h), 85);
        i = yl(WC(OC(VI, 1), Nqe, 20, 0, [
            i,
            (!f.n && (f.n = new X0d(z3, f, 1, 7)), f.n)
        ]));
    }
    for(t = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        (!a.n && (a.n = new X0d(z3, a, 1, 7)), a.n),
        (!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a),
        i
    ]))); cs(t);){
        s = JD(ds(t), 273);
        j = JD(s.mf((Lgd(), vfd)), 139);
        m > s.lh() - j.b && (m = s.lh() - j.b);
        n > s.mh() - j.d && (n = s.mh() - j.d);
        k < s.lh() + s.kh() + j.c && (k = s.lh() + s.kh() + j.c);
        l < s.mh() + s.jh() + j.a && (l = s.mh() + s.jh() + j.a);
    }
    for(g = new CHd((!a.b && (a.b = new X0d(x3, a, 12, 3)), a.b)); g.e != g.i.gc();){
        f = JD(AHd(g), 85);
        for(r = new CHd((!f.a && (f.a = new X0d(w3, f, 6, 6)), f.a)); r.e != r.i.gc();){
            q = JD(AHd(r), 168);
            o = q.j;
            d = q.b;
            p = q.k;
            e = q.c;
            m = $wnd.Math.min(m, o);
            m = $wnd.Math.min(m, d);
            k = $wnd.Math.max(k, o);
            k = $wnd.Math.max(k, d);
            n = $wnd.Math.min(n, p);
            n = $wnd.Math.min(n, e);
            l = $wnd.Math.max(l, p);
            l = $wnd.Math.max(l, e);
            for(c = new CHd((!q.a && (q.a = new qVd(u3, q, 5)), q.a)); c.e != c.i.gc();){
                b = JD(AHd(c), 369);
                m = $wnd.Math.min(m, b.a);
                k = $wnd.Math.max(k, b.a);
                n = $wnd.Math.min(n, b.b);
                l = $wnd.Math.max(l, b.b);
            }
        }
    }
    msd(a, (Lgd(), Ved), k - m);
    msd(a, Ued, l - n);
}
function IMb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    n = JD(WMb(a, (TOb(), ROb)), 27);
    t = Hqe;
    u = Hqe;
    r = Lre;
    s = Lre;
    for(w = new rmb(a.e); w.a < w.c.c.length;){
        v = JD(pmb(w), 151);
        F = v.d;
        G = v.e;
        t = $wnd.Math.min(t, F.a - G.a / 2);
        u = $wnd.Math.min(u, F.b - G.b / 2);
        r = $wnd.Math.max(r, F.a + G.a / 2);
        s = $wnd.Math.max(s, F.b + G.b / 2);
    }
    for(c = new rmb(a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 249);
        F = b.d;
        G = b.e;
        t = $wnd.Math.min(t, F.a - G.a / 2);
        u = $wnd.Math.min(u, F.b - G.b / 2);
        r = $wnd.Math.max(r, F.a + G.a / 2);
        s = $wnd.Math.max(s, F.b + G.b / 2);
    }
    D = JD(ksd(n, (IOb(), rOb)), 107);
    C = new Edd(D.b - t, D.d - u);
    for(j = new rmb(a.e); j.a < j.c.c.length;){
        i = JD(pmb(j), 151);
        B = WMb(i, ROb);
        if (RD(B, 206)) {
            p = JD(B, 27);
            A = mdd(new Fdd(i.d), C);
            ftd(p, A.a - p.g / 2, A.b - p.f / 2);
        }
    }
    for(f = new rmb(a.c); f.a < f.c.c.length;){
        e = JD(pmb(f), 288);
        l = JD(WMb(e, ROb), 85);
        m = hCd(l);
        H = new Fdd(hNb(e));
        mdd(H, C);
        pud(m, H.a, H.b);
        Llb(e.a, new NMb(C, m));
        d = new Fdd(iNb(e));
        mdd(d, C);
        iud(m, d.a, d.b);
    }
    for(h = new rmb(a.d); h.a < h.c.c.length;){
        g = JD(pmb(h), 442);
        o = JD(WMb(g, ROb), 153);
        q = mdd(new Fdd(g.d), C);
        ftd(o, q.a, q.b);
    }
    I = r - t + (D.b + D.c);
    k = s - u + (D.d + D.a);
    ydb(LD(ksd(n, (Lgd(), Dfd)))) || mnd(n, I, k, false, true);
    msd(n, Ved, I - (D.b + D.c));
    msd(n, Ued, k - (D.d + D.a));
}
function $Ac(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    c.Sg('Depth first model order layering', 1);
    a.d = b;
    q = new Ulb;
    for(p = new rmb(a.d.a); p.a < p.c.c.length;){
        n = JD(pmb(p), 9);
        n.k == (DYb(), AYb) && YCb(q.c, n);
    }
    pnb();
    Slb(q, new dBc);
    g = true;
    a.b = new b$b(a.d);
    a.a = null;
    Ilb(a.d.b, a.b);
    a.b.p = 0;
    a.c = 0;
    a.f = new Mtb;
    for(o = new rmb(q); o.a < o.c.c.length;){
        n = JD(pmb(o), 9);
        if (g) {
            qYb(n, a.b);
            g = false;
        } else if (YAc(a, n)) {
            m = a.c;
            m = XAc(m, n);
            d = m + 2;
            k = m - a.c;
            if (a.f.b == 0) WAc(a, d, n);
            else if (k > 0) {
                for(t = Gtb(a.f, 0); t.b != t.d.c;){
                    s = JD(Utb(t), 9);
                    s.p += m - a.e;
                }
                ZAc(a);
                Ltb(a.f);
                WAc(a, d, n);
            } else {
                Atb(a.f, n);
                n.p = d;
                a.e = $wnd.Math.max(a.e, d);
                for(f = new es(Ir(hYb(n).a.Jc(), new er)); cs(f);){
                    e = JD(ds(f), 18);
                    if (!e.c.i.c && e.c.i.k == (DYb(), xYb)) {
                        Atb(a.f, e.c.i);
                        e.c.i.p = d - 1;
                    }
                }
                a.c = d;
            }
        } else {
            ZAc(a);
            Ltb(a.f);
            d = 0;
            if (cs(new es(Ir(hYb(n).a.Jc(), new er)))) {
                m = 0;
                m = XAc(m, n);
                d = m + 2;
                WAc(a, d, n);
            } else {
                Atb(a.f, n);
                n.p = 0;
                a.e = $wnd.Math.max(a.e, 0);
                a.b = JD(Mlb(a.d.b, 0), 25);
                a.c = 0;
            }
        }
    }
    a.f.b == 0 || ZAc(a);
    a.d.a.c.length = 0;
    r = new Ulb;
    for(j = new rmb(a.d.b); j.a < j.c.c.length;){
        h = JD(pmb(j), 25);
        h.a.c.length == 0 && YCb(r.c, h);
    }
    Be(a.d.b, r);
    l = 0;
    for(i = new rmb(a.d.b); i.a < i.c.c.length;){
        h = JD(pmb(i), 25);
        h.p = l;
        ++l;
    }
    c.Tg();
}
function xIc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    c.Sg('Network simplex node placement', 1);
    a.e = b;
    a.n = JD(WMb(b, (Iqc(), Aqc)), 313);
    wIc(a);
    iIc(a);
    EBb(DBb(new RBb(null, new Gvb(a.e.b, 16)), new lJc), new nJc(a));
    EBb(BBb(DBb(BBb(DBb(new RBb(null, new Gvb(a.e.b, 16)), new aKc), new cKc), new eKc), new gKc), new jJc(a));
    if (ydb(LD(WMb(a.e, (Bwc(), jvc))))) {
        g = c.bh(1);
        g.Sg('Straight Edges Pre-Processing', 1);
        vIc(a);
        g.Tg();
    }
    MFb(a.f);
    f = JD(WMb(b, jwc), 17).a * a.f.a.c.length;
    wGb(JGb(KGb(NGb(a.f), f), false), c.bh(1));
    if (a.d.a.gc() != 0) {
        g = c.bh(1);
        g.Sg('Flexible Where Space Processing', 1);
        h = JD(zub(JBb(FBb(new RBb(null, new Gvb(a.f.a, 16)), new pJc), new LIc)), 17).a;
        i = JD(zub(IBb(FBb(new RBb(null, new Gvb(a.f.a, 16)), new rJc), new PIc)), 17).a;
        j = i - h;
        k = pGb(new rGb, a.f);
        l = pGb(new rGb, a.f);
        DFb(GFb(FFb(EFb(HFb(new IFb, 20000), j), k), l));
        EBb(BBb(BBb(Smb(a.i), new tJc), new vJc), new xJc(h, k, j, l));
        for(e = a.d.a.ec().Jc(); e.Ob();){
            d = JD(e.Pb(), 216);
            d.g = 1;
        }
        wGb(JGb(KGb(NGb(a.f), f), false), g.bh(1));
        g.Tg();
    }
    if (ydb(LD(WMb(b, jvc)))) {
        g = c.bh(1);
        g.Sg('Straight Edges Post-Processing', 1);
        uIc(a);
        g.Tg();
    }
    hIc(a);
    a.e = null;
    a.f = null;
    a.i = null;
    a.c = null;
    Tib(a.k);
    a.j = null;
    a.a = null;
    a.o = null;
    a.d.a.$b();
    c.Tg();
}
function wzd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
    D = null;
    G = b;
    F = fzd(a, cCd(c), G);
    Psd(F, byd(G, vDe));
    H = JD(wo(a.n, Xxd(iC(G, cDe))), 27);
    m = iC(G, 'sourcePort');
    d = null;
    !!m && (d = Xxd(m));
    I = JD(wo(a.p, d), 124);
    if (!H) {
        h = Yxd(G);
        o = "An edge must have a source node (edge id: '" + h;
        p = o + ADe;
        throw scb(new eyd(p));
    }
    if (!!I && !Hb(oxd(I), H)) {
        i = byd(G, vDe);
        q = "The source port of an edge must be a port of the edge's source node (edge id: '" + i;
        r = q + ADe;
        throw scb(new eyd(r));
    }
    B = (!F.b && (F.b = new ree(v3, F, 4, 7)), F.b);
    f = null;
    I ? f = I : f = H;
    tCd(B, f);
    J = JD(wo(a.n, Xxd(iC(G, DDe))), 27);
    n = iC(G, 'targetPort');
    e = null;
    !!n && (e = Xxd(n));
    K = JD(wo(a.p, e), 124);
    if (!J) {
        l = Yxd(G);
        s = "An edge must have a target node (edge id: '" + l;
        t = s + ADe;
        throw scb(new eyd(t));
    }
    if (!!K && !Hb(oxd(K), J)) {
        j = byd(G, vDe);
        u = "The target port of an edge must be a port of the edge's target node (edge id: '" + j;
        v = u + ADe;
        throw scb(new eyd(v));
    }
    C = (!F.c && (F.c = new ree(v3, F, 5, 8)), F.c);
    g = null;
    K ? g = K : g = J;
    tCd(C, g);
    if ((!F.b && (F.b = new ree(v3, F, 4, 7)), F.b).i == 0 || (!F.c && (F.c = new ree(v3, F, 5, 8)), F.c).i == 0) {
        k = byd(G, vDe);
        w = zDe + k;
        A = w + ADe;
        throw scb(new eyd(A));
    }
    yzd(G, F);
    xzd(G, F);
    D = uzd(a, G, F);
    return D;
}
function PTb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    l = RTb(LTb(a, (Rjd(), Cjd)), b);
    o = QTb(LTb(a, Djd), b);
    u = QTb(LTb(a, Ljd), b);
    B = STb(LTb(a, Njd), b);
    m = STb(LTb(a, yjd), b);
    s = QTb(LTb(a, Kjd), b);
    p = QTb(LTb(a, Ejd), b);
    w = QTb(LTb(a, Mjd), b);
    v = QTb(LTb(a, zjd), b);
    C = STb(LTb(a, Bjd), b);
    r = QTb(LTb(a, Ijd), b);
    t = QTb(LTb(a, Hjd), b);
    A = QTb(LTb(a, Ajd), b);
    D = STb(LTb(a, Jjd), b);
    n = STb(LTb(a, Fjd), b);
    q = QTb(LTb(a, Gjd), b);
    c = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        s.a,
        B.a,
        w.a,
        D.a
    ]));
    d = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        o.a,
        l.a,
        u.a,
        q.a
    ]));
    e = r.a;
    f = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        p.a,
        m.a,
        v.a,
        n.a
    ]));
    j = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        s.b,
        o.b,
        p.b,
        t.b
    ]));
    i = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        B.b,
        l.b,
        m.b,
        q.b
    ]));
    k = C.b;
    h = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        w.b,
        u.b,
        v.b,
        A.b
    ]));
    HTb(LTb(a, Cjd), c + e, j + k);
    HTb(LTb(a, Gjd), c + e, j + k);
    HTb(LTb(a, Djd), c + e, 0);
    HTb(LTb(a, Ljd), c + e, j + k + i);
    HTb(LTb(a, Njd), 0, j + k);
    HTb(LTb(a, yjd), c + e + d, j + k);
    HTb(LTb(a, Ejd), c + e + d, 0);
    HTb(LTb(a, Mjd), 0, j + k + i);
    HTb(LTb(a, zjd), c + e + d, j + k + i);
    HTb(LTb(a, Bjd), 0, j);
    HTb(LTb(a, Ijd), c, 0);
    HTb(LTb(a, Ajd), 0, j + k + i);
    HTb(LTb(a, Fjd), c + e + d, 0);
    g = new Cdd;
    g.a = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        c + d + e + f,
        C.a,
        t.a,
        A.a
    ]));
    g.b = Ucd(WC(OC(aE, 1), Rse, 30, 15, [
        j + i + k + h,
        r.b,
        D.b,
        n.b
    ]));
    return g;
}
function DDb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    s = new Edd(Kse, Kse);
    b = new Edd(Lse, Lse);
    for(B = new rmb(a); B.a < B.c.c.length;){
        A = JD(pmb(B), 8);
        s.a = $wnd.Math.min(s.a, A.a);
        s.b = $wnd.Math.min(s.b, A.b);
        b.a = $wnd.Math.max(b.a, A.a);
        b.b = $wnd.Math.max(b.b, A.b);
    }
    m = new Edd(b.a - s.a, b.b - s.b);
    j = new Edd(s.a - 50, s.b - m.a - 50);
    k = new Edd(s.a - 50, b.b + m.a + 50);
    l = new Edd(b.a + m.b / 2 + 50, s.b + m.b / 2);
    n = new WDb(j, k, l);
    w = new Qrb;
    f = new Ulb;
    c = new Ulb;
    w.a.yc(n, w);
    for(D = new rmb(a); D.a < D.c.c.length;){
        C = JD(pmb(D), 8);
        f.c.length = 0;
        for(v = w.a.ec().Jc(); v.Ob();){
            t = JD(v.Pb(), 318);
            d = t.d;
            pdd(d, t.a);
            Sy(pdd(t.d, C), pdd(t.d, t.a)) < 0 && YCb(f.c, t);
        }
        c.c.length = 0;
        for(u = new rmb(f); u.a < u.c.c.length;){
            t = JD(pmb(u), 318);
            for(q = new rmb(t.e); q.a < q.c.c.length;){
                o = JD(pmb(q), 176);
                g = true;
                for(i = new rmb(f); i.a < i.c.c.length;){
                    h = JD(pmb(i), 318);
                    h != t && (tub(o, Mlb(h.e, 0)) || tub(o, Mlb(h.e, 1)) || tub(o, Mlb(h.e, 2))) && (g = false);
                }
                g && YCb(c.c, o);
            }
        }
        Te(w, f);
        ofb(w, new EDb);
        for(p = new rmb(c); p.a < p.c.c.length;){
            o = JD(pmb(p), 176);
            Nrb(w, new WDb(C, o.a, o.b));
        }
    }
    r = new Qrb;
    ofb(w, new GDb(r));
    e = r.a.ec().Jc();
    while(e.Ob()){
        o = JD(e.Pb(), 176);
        (VDb(n, o.a) || VDb(n, o.b)) && e.Qb();
    }
    ofb(r, new IDb);
    return r;
}
function Vpd() {
    Vpd = Zcb;
    Jpd();
    Upd = Ipd.a;
    JD(nDd(STd(Ipd.a), 0), 19);
    Opd = Ipd.f;
    JD(nDd(STd(Ipd.f), 0), 19);
    JD(nDd(STd(Ipd.f), 1), 35);
    Tpd = Ipd.n;
    JD(nDd(STd(Ipd.n), 0), 35);
    JD(nDd(STd(Ipd.n), 1), 35);
    JD(nDd(STd(Ipd.n), 2), 35);
    JD(nDd(STd(Ipd.n), 3), 35);
    Ppd = Ipd.g;
    JD(nDd(STd(Ipd.g), 0), 19);
    JD(nDd(STd(Ipd.g), 1), 35);
    Lpd = Ipd.c;
    JD(nDd(STd(Ipd.c), 0), 19);
    JD(nDd(STd(Ipd.c), 1), 19);
    Qpd = Ipd.i;
    JD(nDd(STd(Ipd.i), 0), 19);
    JD(nDd(STd(Ipd.i), 1), 19);
    JD(nDd(STd(Ipd.i), 2), 19);
    JD(nDd(STd(Ipd.i), 3), 19);
    JD(nDd(STd(Ipd.i), 4), 35);
    Rpd = Ipd.j;
    JD(nDd(STd(Ipd.j), 0), 19);
    Mpd = Ipd.d;
    JD(nDd(STd(Ipd.d), 0), 19);
    JD(nDd(STd(Ipd.d), 1), 19);
    JD(nDd(STd(Ipd.d), 2), 19);
    JD(nDd(STd(Ipd.d), 3), 19);
    JD(nDd(STd(Ipd.d), 4), 35);
    JD(nDd(STd(Ipd.d), 5), 35);
    JD(nDd(STd(Ipd.d), 6), 35);
    JD(nDd(STd(Ipd.d), 7), 35);
    Kpd = Ipd.b;
    JD(nDd(STd(Ipd.b), 0), 35);
    JD(nDd(STd(Ipd.b), 1), 35);
    Npd = Ipd.e;
    JD(nDd(STd(Ipd.e), 0), 35);
    JD(nDd(STd(Ipd.e), 1), 35);
    JD(nDd(STd(Ipd.e), 2), 35);
    JD(nDd(STd(Ipd.e), 3), 35);
    JD(nDd(STd(Ipd.e), 4), 19);
    JD(nDd(STd(Ipd.e), 5), 19);
    JD(nDd(STd(Ipd.e), 6), 19);
    JD(nDd(STd(Ipd.e), 7), 19);
    JD(nDd(STd(Ipd.e), 8), 19);
    JD(nDd(STd(Ipd.e), 9), 19);
    JD(nDd(STd(Ipd.e), 10), 35);
    Spd = Ipd.k;
    JD(nDd(STd(Ipd.k), 0), 35);
    JD(nDd(STd(Ipd.k), 1), 35);
}
function ime(a) {
    var b, c, d, e, f;
    b = a.c;
    switch(b){
        case 11:
            return a.sm();
        case 12:
            return a.um();
        case 14:
            return a.wm();
        case 15:
            return a.zm();
        case 16:
            return a.xm();
        case 17:
            return a.Am();
        case 21:
            fme(a);
            return ooe(), ooe(), Zne;
        case 10:
            switch(a.a){
                case 65:
                    return a.em();
                case 90:
                    return a.jm();
                case 122:
                    return a.qm();
                case 98:
                    return a.km();
                case 66:
                    return a.fm();
                case 60:
                    return a.pm();
                case 62:
                    return a.nm();
            }
    }
    f = hme(a);
    b = a.c;
    switch(b){
        case 3:
            return a.Fm(f);
        case 4:
            return a.Dm(f);
        case 5:
            return a.Em(f);
        case 0:
            if (a.a == 123 && a.d < a.j) {
                e = a.d;
                d = 0;
                c = -1;
                if ((b = _fb(a.i, e++)) >= 48 && b <= 57) {
                    d = b - 48;
                    while(e < a.j && (b = _fb(a.i, e++)) >= 48 && b <= 57){
                        d = d * 10 + b - 48;
                        if (d < 0) throw scb(new eme(qEd((a9d(), DEe))));
                    }
                } else throw scb(new eme(qEd((a9d(), zEe))));
                c = d;
                if (b == 44) {
                    if (e >= a.j) throw scb(new eme(qEd((a9d(), BEe))));
                    else if ((b = _fb(a.i, e++)) >= 48 && b <= 57) {
                        c = b - 48;
                        while(e < a.j && (b = _fb(a.i, e++)) >= 48 && b <= 57){
                            c = c * 10 + b - 48;
                            if (c < 0) throw scb(new eme(qEd((a9d(), DEe))));
                        }
                        if (d > c) throw scb(new eme(qEd((a9d(), CEe))));
                    } else c = -1;
                }
                if (b != 125) throw scb(new eme(qEd((a9d(), AEe))));
                if (a.$l(e)) {
                    f = (ooe(), ooe(), ++noe, new dpe(9, f));
                    a.d = e + 1;
                } else {
                    f = (ooe(), ooe(), ++noe, new dpe(3, f));
                    a.d = e;
                }
                f.Lm(d);
                f.Km(c);
                fme(a);
            }
    }
    return f;
}
function Yud(b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    if (d == null) return null;
    if (b.a != c.gk()) throw scb(new Teb(WCe + c.ve() + XCe));
    if (RD(c, 455)) {
        r = UYd(JD(c, 670), d);
        if (!r) throw scb(new Teb(YCe + d + "' is not a valid enumerator of '" + c.ve() + "'"));
        return r;
    }
    switch(hae((Gfe(), Efe), c).Kl()){
        case 2:
            d = Ipe(d, false);
            break;
        case 3:
            d = Ipe(d, true);
            break;
    }
    e = hae(Efe, c).Gl();
    if (e) return e.gk().si().pi(e, d);
    n = hae(Efe, c).Il();
    if (n) {
        r = new Ulb;
        for(k = _ud(d), l = 0, m = k.length; l < m; ++l){
            j = k[l];
            Ilb(r, n.gk().si().pi(n, j));
        }
        return r;
    }
    q = hae(Efe, c).Jl();
    if (!q.dc()) {
        for(p = q.Jc(); p.Ob();){
            o = JD(p.Pb(), 155);
            try {
                r = o.gk().si().pi(o, d);
                if (r != null) return r;
            } catch (a) {
                a = rcb(a);
                if (!RD(a, 63)) throw scb(a);
            }
        }
        throw scb(new Teb(YCe + d + "' does not match any member types of the union datatype '" + c.ve() + "'"));
    }
    JD(c, 826).lk();
    f = jfe(c.hk());
    if (!f) return null;
    if (f == II) {
        h = 0;
        try {
            h = Fdb(d, Lre, Hqe) & Wre;
        } catch (a) {
            a = rcb(a);
            if (RD(a, 130)) {
                g = rgb(d);
                h = g[0];
            } else throw scb(a);
        }
        return $db(h);
    }
    if (f == hK) {
        for(i = 0; i < Rud.length; ++i)try {
            return wZd(Rud[i], d);
        } catch (a) {
            a = rcb(a);
            if (!RD(a, 32)) throw scb(a);
        }
        throw scb(new Teb(YCe + d + "' is not a date formatted string of the form yyyy-MM-dd'T'HH:mm:ss'.'SSSZ or a valid subset thereof"));
    }
    throw scb(new Teb(YCe + d + "' is invalid. "));
}
function JTb() {
    JTb = Zcb;
    ITb = new Pp;
    Rc(ITb, (Rjd(), Cjd), Gjd);
    Rc(ITb, Njd, Gjd);
    Rc(ITb, Njd, Jjd);
    Rc(ITb, yjd, Fjd);
    Rc(ITb, yjd, Gjd);
    Rc(ITb, Djd, Gjd);
    Rc(ITb, Djd, Hjd);
    Rc(ITb, Ljd, Ajd);
    Rc(ITb, Ljd, Gjd);
    Rc(ITb, Ijd, Bjd);
    Rc(ITb, Ijd, Gjd);
    Rc(ITb, Ijd, Hjd);
    Rc(ITb, Ijd, Ajd);
    Rc(ITb, Bjd, Ijd);
    Rc(ITb, Bjd, Jjd);
    Rc(ITb, Bjd, Fjd);
    Rc(ITb, Bjd, Gjd);
    Rc(ITb, Kjd, Kjd);
    Rc(ITb, Kjd, Hjd);
    Rc(ITb, Kjd, Jjd);
    Rc(ITb, Ejd, Ejd);
    Rc(ITb, Ejd, Hjd);
    Rc(ITb, Ejd, Fjd);
    Rc(ITb, Mjd, Mjd);
    Rc(ITb, Mjd, Ajd);
    Rc(ITb, Mjd, Jjd);
    Rc(ITb, zjd, zjd);
    Rc(ITb, zjd, Ajd);
    Rc(ITb, zjd, Fjd);
    Rc(ITb, Hjd, Djd);
    Rc(ITb, Hjd, Ijd);
    Rc(ITb, Hjd, Kjd);
    Rc(ITb, Hjd, Ejd);
    Rc(ITb, Hjd, Gjd);
    Rc(ITb, Hjd, Hjd);
    Rc(ITb, Hjd, Jjd);
    Rc(ITb, Hjd, Fjd);
    Rc(ITb, Ajd, Ljd);
    Rc(ITb, Ajd, Ijd);
    Rc(ITb, Ajd, Mjd);
    Rc(ITb, Ajd, zjd);
    Rc(ITb, Ajd, Ajd);
    Rc(ITb, Ajd, Jjd);
    Rc(ITb, Ajd, Fjd);
    Rc(ITb, Ajd, Gjd);
    Rc(ITb, Jjd, Njd);
    Rc(ITb, Jjd, Bjd);
    Rc(ITb, Jjd, Kjd);
    Rc(ITb, Jjd, Mjd);
    Rc(ITb, Jjd, Hjd);
    Rc(ITb, Jjd, Ajd);
    Rc(ITb, Jjd, Jjd);
    Rc(ITb, Jjd, Gjd);
    Rc(ITb, Fjd, yjd);
    Rc(ITb, Fjd, Bjd);
    Rc(ITb, Fjd, Ejd);
    Rc(ITb, Fjd, zjd);
    Rc(ITb, Fjd, Hjd);
    Rc(ITb, Fjd, Ajd);
    Rc(ITb, Fjd, Fjd);
    Rc(ITb, Fjd, Gjd);
    Rc(ITb, Gjd, Cjd);
    Rc(ITb, Gjd, Njd);
    Rc(ITb, Gjd, yjd);
    Rc(ITb, Gjd, Djd);
    Rc(ITb, Gjd, Ljd);
    Rc(ITb, Gjd, Ijd);
    Rc(ITb, Gjd, Bjd);
    Rc(ITb, Gjd, Hjd);
    Rc(ITb, Gjd, Ajd);
    Rc(ITb, Gjd, Jjd);
    Rc(ITb, Gjd, Fjd);
    Rc(ITb, Gjd, Gjd);
}
function jUb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    a.d = new Edd(Kse, Kse);
    a.c = new Edd(Lse, Lse);
    for(m = b.Jc(); m.Ob();){
        k = JD(m.Pb(), 36);
        for(t = new rmb(k.a); t.a < t.c.c.length;){
            s = JD(pmb(t), 9);
            a.d.a = $wnd.Math.min(a.d.a, s.n.a - s.d.b);
            a.d.b = $wnd.Math.min(a.d.b, s.n.b - s.d.d);
            a.c.a = $wnd.Math.max(a.c.a, s.n.a + s.o.a + s.d.c);
            a.c.b = $wnd.Math.max(a.c.b, s.n.b + s.o.b + s.d.a);
        }
    }
    h = new AUb;
    for(l = b.Jc(); l.Ob();){
        k = JD(l.Pb(), 36);
        d = sUb(a, k);
        Ilb(h.a, d);
        d.a = d.a | !JD(WMb(d.c, (Iqc(), Qpc)), 22).dc();
    }
    a.b = (XQb(), B = new fRb, B.f = new OQb(c), B.b = NQb(B.f, h), B);
    _Qb((o = a.b, new wld, o));
    a.e = new Cdd;
    a.a = a.b.f.e;
    for(g = new rmb(h.a); g.a < g.c.c.length;){
        e = JD(pmb(g), 834);
        u = aRb(a.b, e);
        yXb(e.c, u.a, u.b);
        for(q = new rmb(e.c.a); q.a < q.c.c.length;){
            p = JD(pmb(q), 9);
            if (p.k == (DYb(), wYb)) {
                r = nUb(a, p.n, JD(WMb(p, (Iqc(), Tpc)), 64));
                mdd(vdd(p.n), r);
            }
        }
    }
    for(f = new rmb(h.a); f.a < f.c.c.length;){
        e = JD(pmb(f), 834);
        for(j = new rmb(yUb(e)); j.a < j.c.c.length;){
            i = JD(pmb(j), 18);
            A = new Sdd(i.a);
            du(A, 0, WYb(i.c));
            Atb(A, WYb(i.d));
            n = null;
            for(w = Gtb(A, 0); w.b != w.d.c;){
                v = JD(Utb(w), 8);
                if (!n) {
                    n = v;
                    continue;
                }
                if (Ty(n.a, v.a)) {
                    a.e.a = $wnd.Math.min(a.e.a, n.a);
                    a.a.a = $wnd.Math.max(a.a.a, n.a);
                } else if (Ty(n.b, v.b)) {
                    a.e.b = $wnd.Math.min(a.e.b, n.b);
                    a.a.b = $wnd.Math.max(a.a.b, n.b);
                }
                n = v;
            }
        }
    }
    tdd(a.e);
    mdd(a.a, a.e);
}
function mhb(a, b) {
    var c, d, e, f, g, h, i, j;
    c = 0;
    g = 0;
    f = b.length;
    h = null;
    j = new Vgb;
    if (g < f && (ADb(g, b.length), b.charCodeAt(g) == 43)) {
        ++g;
        ++c;
        if (g < f && (ADb(g, b.length), b.charCodeAt(g) == 43 || (ADb(g, b.length), b.charCodeAt(g) == 45))) throw scb(new Mfb(Jse + b + '"'));
    }
    while(g < f && (ADb(g, b.length), b.charCodeAt(g) != 46) && (ADb(g, b.length), b.charCodeAt(g) != 101) && (ADb(g, b.length), b.charCodeAt(g) != 69))++g;
    j.a += '' + qgb(b == null ? Rqe : (tDb(b), b), c, g);
    if (g < f && (ADb(g, b.length), b.charCodeAt(g) == 46)) {
        ++g;
        c = g;
        while(g < f && (ADb(g, b.length), b.charCodeAt(g) != 101) && (ADb(g, b.length), b.charCodeAt(g) != 69))++g;
        a.e = g - c;
        j.a += '' + qgb(b == null ? Rqe : (tDb(b), b), c, g);
    } else a.e = 0;
    if (g < f && (ADb(g, b.length), b.charCodeAt(g) == 101 || (ADb(g, b.length), b.charCodeAt(g) == 69))) {
        ++g;
        c = g;
        if (g < f && (ADb(g, b.length), b.charCodeAt(g) == 43)) {
            ++g;
            g < f && (ADb(g, b.length), b.charCodeAt(g) != 45) && ++c;
        }
        h = (zDb(c, f, b.length), b.substr(c, f - c));
        a.e = a.e - Fdb(h, Lre, Hqe);
        if (a.e != YD(a.e)) throw scb(new Mfb('Scale out of range.'));
    }
    i = j.a;
    if (i.length < 16) {
        a.f = (jhb == null && (jhb = new RegExp('^[+-]?\\d*$', 'i')), jhb.test(i) ? parseInt(i, 10) : NaN);
        if (isNaN(a.f)) throw scb(new Mfb(Jse + b + '"'));
        a.a = thb(a.f);
    } else nhb(a, new Xhb(i));
    a.d = j.a.length;
    for(e = 0; e < j.a.length; ++e){
        d = _fb(j.a, e);
        if (d != 45 && d != 48) break;
        --a.d;
    }
    a.d == 0 && (a.d = 1);
}
function p6d(a) {
    Dvd(a.b, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'ConsistentTransient'
    ]));
    Dvd(a.a, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'WellFormedSourceURI'
    ]));
    Dvd(a.o, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'InterfaceIsAbstract AtMostOneID UniqueFeatureNames UniqueOperationSignatures NoCircularSuperTypes WellFormedMapEntryClass ConsistentSuperTypes DisjointFeatureAndOperationSignatures'
    ]));
    Dvd(a.p, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'WellFormedInstanceTypeName UniqueTypeParameterNames'
    ]));
    Dvd(a.v, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'UniqueEnumeratorNames UniqueEnumeratorLiterals'
    ]));
    Dvd(a.R, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'WellFormedName'
    ]));
    Dvd(a.T, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'UniqueParameterNames UniqueTypeParameterNames NoRepeatingVoid'
    ]));
    Dvd(a.U, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'WellFormedNsURI WellFormedNsPrefix UniqueSubpackageNames UniqueClassifierNames UniqueNsURIs'
    ]));
    Dvd(a.W, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'ConsistentOpposite SingleContainer ConsistentKeys ConsistentUnique ConsistentContainer'
    ]));
    Dvd(a.bb, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'ValidDefaultValueLiteral'
    ]));
    Dvd(a.eb, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'ValidLowerBound ValidUpperBound ConsistentBounds ValidType'
    ]));
    Dvd(a.H, BFe, WC(OC(hJ, 1), hre, 2, 6, [
        DFe,
        'ConsistentType ConsistentBounds ConsistentArguments'
    ]));
}
function lQb(a) {
    var b, c, d, e, f;
    c = JD(WMb(a, (Iqc(), Wpc)), 22);
    b = K9c(gQb);
    e = JD(WMb(a, (Bwc(), Iuc)), 342);
    e == (eid(), bid) && D9c(b, hQb);
    ydb(LD(WMb(a, Guc))) ? E9c(b, (CQb(), xQb), (u5b(), k5b)) : E9c(b, (CQb(), zQb), (u5b(), k5b));
    WMb(a, (Gcd(), Fcd)) != null && D9c(b, iQb);
    (ydb(LD(WMb(a, Puc))) || ydb(LD(WMb(a, Huc)))) && C9c(b, (CQb(), BQb), (u5b(), y4b));
    switch(JD(WMb(a, ruc), 86).g){
        case 2:
        case 3:
        case 4:
            C9c(E9c(b, (CQb(), xQb), (u5b(), A4b)), BQb, z4b);
    }
    c.Gc(($oc(), Roc)) && C9c(E9c(E9c(b, (CQb(), xQb), (u5b(), x4b)), AQb, v4b), BQb, w4b);
    XD(WMb(a, Zuc)) !== XD((dyc(), byc)) && E9c(b, (CQb(), zQb), (u5b(), c5b));
    if (c.Gc(Yoc)) {
        E9c(b, (CQb(), xQb), (u5b(), i5b));
        E9c(b, yQb, g5b);
        E9c(b, zQb, h5b);
    }
    XD(WMb(a, Xtc)) !== XD((Koc(), Ioc)) && XD(WMb(a, yuc)) !== XD((xhd(), uhd)) && C9c(b, (CQb(), BQb), (u5b(), N4b));
    ydb(LD(WMb(a, Kuc))) && E9c(b, (CQb(), zQb), (u5b(), M4b));
    ydb(LD(WMb(a, nuc))) && E9c(b, (CQb(), zQb), (u5b(), q5b));
    if (oQb(a)) {
        XD(WMb(a, Iuc)) === XD(bid) ? d = JD(WMb(a, guc), 298) : d = JD(WMb(a, huc), 298);
        f = d == (hpc(), fpc) ? (u5b(), f5b) : (u5b(), t5b);
        E9c(b, (CQb(), AQb), f);
    }
    JD(WMb(a, bvc), 420).g == 1 && E9c(b, (CQb(), AQb), (u5b(), q4b));
    switch(JD(WMb(a, ywc), 380).g){
        case 1:
            E9c(b, (CQb(), AQb), (u5b(), r5b));
            break;
        case 2:
            C9c(E9c(E9c(b, (CQb(), zQb), (u5b(), r4b)), AQb, s4b), BQb, t4b);
    }
    XD(WMb(a, cuc)) !== XD((nyc(), kyc)) && E9c(b, (CQb(), zQb), (u5b(), s5b));
    return b;
}
function c1b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    if (b.dc()) return;
    e = new Rdd;
    h = c ? c : JD(b.Xb(0), 18);
    o = h.c;
    KOc();
    m = o.i.k;
    if (!(m == (DYb(), AYb) || m == BYb || m == wYb || m == vYb)) throw scb(new Teb('The target node of the edge must be a normal node or a northSouthPort.'));
    Ctb(e, Kdd(WC(OC(b2, 1), hre, 8, 0, [
        o.i.n,
        o.n,
        o.a
    ])));
    if ((Rjd(), Ijd).Gc(o.j)) {
        q = Beb(MD(WMb(o, (Iqc(), Cqc))));
        l = new Edd(Kdd(WC(OC(b2, 1), hre, 8, 0, [
            o.i.n,
            o.n,
            o.a
        ])).a, q);
        Dtb(e, l, e.c.b, e.c);
    }
    k = null;
    d = false;
    i = b.Jc();
    while(i.Ob()){
        g = JD(i.Pb(), 18);
        f = g.a;
        if (f.b != 0) {
            if (d) {
                j = wdd(mdd(k, (rDb(f.b != 0), JD(f.a.a.c, 8))), 0.5);
                Dtb(e, j, e.c.b, e.c);
                d = false;
            } else d = true;
            k = odd((rDb(f.b != 0), JD(f.c.b.c, 8)));
            xe(e, f);
            Ltb(f);
        }
    }
    p = h.d;
    if (Ijd.Gc(p.j)) {
        q = Beb(MD(WMb(p, (Iqc(), Cqc))));
        l = new Edd(Kdd(WC(OC(b2, 1), hre, 8, 0, [
            p.i.n,
            p.n,
            p.a
        ])).a, q);
        Dtb(e, l, e.c.b, e.c);
    }
    Ctb(e, Kdd(WC(OC(b2, 1), hre, 8, 0, [
        p.i.n,
        p.n,
        p.a
    ])));
    a.d == (ozc(), lzc) && (r = (rDb(e.b != 0), JD(e.a.a.c, 8)), s = JD(fu(e, 1), 8), t = new Ddd(EPc(o.j)), t.a *= 5, t.b *= 5, u = Bdd(new Edd(s.a, s.b), r), v = new Edd(b1b(t.a, u.a), b1b(t.b, u.b)), mdd(v, r), w = Gtb(e, 1), Stb(w, v), A = (rDb(e.b != 0), JD(e.c.b.c, 8)), B = JD(fu(e, e.b - 2), 8), t = new Ddd(EPc(p.j)), t.a *= 5, t.b *= 5, u = Bdd(new Edd(B.a, B.b), A), C = new Edd(b1b(t.a, u.a), b1b(t.b, u.b)), mdd(C, A), du(e, e.b - 1, C), undefined);
    n = new zOc(e);
    xe(h.a, vOc(n));
}
function Iod(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P;
    t = JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84);
    v = t.lh();
    w = t.mh();
    u = t.kh() / 2;
    p = t.jh() / 2;
    if (RD(t, 193)) {
        s = JD(t, 124);
        v += oxd(s).i;
        v += oxd(s).i;
    }
    v += u;
    w += p;
    F = JD(nDd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b), 0), 84);
    H = F.lh();
    I = F.mh();
    G = F.kh() / 2;
    A = F.jh() / 2;
    if (RD(F, 193)) {
        D = JD(F, 124);
        H += oxd(D).i;
        H += oxd(D).i;
    }
    H += G;
    I += A;
    if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i == 0) {
        h = (Hpd(), j = new tud, j);
        tCd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), h);
    } else if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i > 1) {
        o = new LHd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a));
        while(o.e != o.i.gc())BHd(o);
    }
    g = JD(nDd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), 0), 168);
    q = H;
    H > v + u ? q = v + u : H < v - u && (q = v - u);
    r = I;
    I > w + p ? r = w + p : I < w - p && (r = w - p);
    q > v - u && q < v + u && r > w - p && r < w + p && (q = v + u);
    qud(g, q);
    rud(g, r);
    B = v;
    v > H + G ? B = H + G : v < H - G && (B = H - G);
    C = w;
    w > I + A ? C = I + A : w < I - A && (C = I - A);
    B > H - G && B < H + G && C > I - A && C < I + A && (C = I + A);
    jud(g, B);
    kud(g, C);
    RGd((!g.a && (g.a = new qVd(u3, g, 5)), g.a));
    f = xvb(b, 5);
    t == F && ++f;
    L = B - q;
    O = C - r;
    J = $wnd.Math.sqrt(L * L + O * O);
    l = J * 0.20000000298023224;
    M = L / (f + 1);
    P = O / (f + 1);
    K = q;
    N = r;
    for(k = 0; k < f; k++){
        K += M;
        N += P;
        m = K + yvb(b, 24) * hte * l - l / 2;
        m < 0 ? m = 1 : m > c && (m = c - 1);
        n = N + yvb(b, 24) * hte * l - l / 2;
        n < 0 ? n = 1 : n > d && (n = d - 1);
        e = (Hpd(), i = new Bsd, i);
        zsd(e, m);
        Asd(e, n);
        tCd((!g.a && (g.a = new qVd(u3, g, 5)), g.a), e);
    }
}
function rib(a, b) {
    oib();
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    B = a.e;
    o = a.d;
    e = a.a;
    if (B == 0) switch(b){
        case 0:
            return '0';
        case 1:
            return Vse;
        case 2:
            return '0.00';
        case 3:
            return '0.000';
        case 4:
            return '0.0000';
        case 5:
            return '0.00000';
        case 6:
            return '0.000000';
        default:
            w = new Ugb;
            b < 0 ? (w.a += '0E+', w) : (w.a += '0E', w);
            w.a += -b;
            return w.a;
    }
    t = o * 10 + 1 + 7;
    u = SC(_D, Ure, 30, t + 1, 15, 1);
    c = t;
    if (o == 1) {
        h = e[0];
        if (h < 0) {
            H = ucb(h, Use);
            do {
                p = H;
                H = xcb(H, 10);
                u[--c] = 48 + Pcb(Mcb(p, Fcb(H, 10))) & Wre;
            }while (vcb(H, 0) != 0);
        } else {
            H = h;
            do {
                p = H;
                H = H / 10 | 0;
                u[--c] = 48 + (p - H * 10) & Wre;
            }while (H != 0);
        }
    } else {
        D = SC(cE, ise, 30, o, 15, 1);
        G = o;
        $gb(e, 0, D, 0, G);
        I: while(true){
            A = 0;
            for(j = G - 1; j >= 0; j--){
                F = tcb(Jcb(A, 32), ucb(D[j], Use));
                r = pib(F);
                D[j] = Pcb(r);
                A = Pcb(Kcb(r, 32));
            }
            s = Pcb(A);
            q = c;
            do u[--c] = 48 + s % 10 & Wre;
            while ((s = s / 10 | 0) != 0 && c != 0);
            d = 9 - q + c;
            for(i = 0; i < d && c > 0; i++)u[--c] = 48;
            l = G - 1;
            for(; D[l] == 0; l--){
                if (l == 0) break I;
            }
            G = l + 1;
        }
        while(u[c] == 48)++c;
    }
    n = B < 0;
    g = t - c - b - 1;
    if (b == 0) {
        n && (u[--c] = 45);
        return zgb(u, c, t - c);
    }
    if (b > 0 && g >= -6) {
        if (g >= 0) {
            k = c + g;
            for(m = t - 1; m >= k; m--)u[m + 1] = u[m];
            u[++k] = 46;
            n && (u[--c] = 45);
            return zgb(u, c, t - c + 1);
        }
        for(l = 2; l < -g + 1; l++)u[--c] = 48;
        u[--c] = 46;
        u[--c] = 48;
        n && (u[--c] = 45);
        return zgb(u, c, t - c);
    }
    C = c + 1;
    f = t;
    v = new Vgb;
    n && (v.a += '-', v);
    if (f - C >= 1) {
        Kgb(v, u[c]);
        v.a += '.';
        v.a += zgb(u, c + 1, t - c - 1);
    } else v.a += zgb(u, c, t - c);
    v.a += 'E';
    g > 0 && (v.a += '+', v);
    v.a += '' + g;
    return v.a;
}
function Z4c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    a.c = b;
    a.g = new Irb;
    c = (Rod(), new dpd(a.c));
    d = new $Gb(c);
    WGb(d);
    t = OD(ksd(a.c, (D6c(), w6c)));
    i = JD(ksd(a.c, y6c), 325);
    v = JD(ksd(a.c, z6c), 424);
    g = JD(ksd(a.c, r6c), 475);
    u = JD(ksd(a.c, x6c), 425);
    a.j = Beb(MD(ksd(a.c, A6c)));
    h = a.a;
    switch(i.g){
        case 0:
            h = a.a;
            break;
        case 1:
            h = a.b;
            break;
        case 2:
            h = a.i;
            break;
        case 3:
            h = a.e;
            break;
        case 4:
            h = a.f;
            break;
        default:
            throw scb(new Teb(bBe + (i.f != null ? i.f : '' + i.g)));
    }
    a.d = new G5c(h, v, g);
    ZMb(a.d, (YLb(), WLb), LD(ksd(a.c, t6c)));
    a.d.c = ydb(LD(ksd(a.c, s6c)));
    if (Xwd(a.c).i == 0) return a.d;
    for(l = new CHd(Xwd(a.c)); l.e != l.i.gc();){
        k = JD(AHd(l), 27);
        n = k.g / 2;
        m = k.f / 2;
        w = new Edd(k.i + n, k.j + m);
        while(Lib(a.g, w))ldd(w, ($wnd.Math.random() - 0.5) * Fue, ($wnd.Math.random() - 0.5) * Fue);
        p = JD(ksd(k, (Lgd(), vfd)), 139);
        q = new bMb(w, new gdd(w.a - n - a.j / 2 - p.b, w.b - m - a.j / 2 - p.d, k.g + a.j + (p.b + p.c), k.f + a.j + (p.d + p.a)));
        Ilb(a.d.i, q);
        Qib(a.g, w, new xod(q, k));
    }
    switch(u.g){
        case 0:
            if (t == null) a.d.d = JD(Mlb(a.d.i, 0), 68);
            else for(s = new rmb(a.d.i); s.a < s.c.c.length;){
                q = JD(pmb(s), 68);
                o = JD(JD(Nib(a.g, q.a), 47).b, 27).hh();
                o != null && cgb(o, t) && (a.d.d = q);
            }
            break;
        case 1:
            e = new Edd(a.c.g, a.c.f);
            e.a *= 0.5;
            e.b *= 0.5;
            ldd(e, a.c.i, a.c.j);
            f = Kse;
            for(r = new rmb(a.d.i); r.a < r.c.c.length;){
                q = JD(pmb(r), 68);
                j = pdd(q.a, e);
                if (j < f) {
                    f = j;
                    a.d.d = q;
                }
            }
            break;
        default:
            throw scb(new Teb(bBe + (u.f != null ? u.f : '' + u.g)));
    }
    return a.d;
}
function l2c(a) {
    Rad(a, new cad(nad(kad(mad(lad(new pad, XAe), 'ELK Rectangle Packing'), 'Algorithm for packing of unconnected boxes, i.e. graphs without edges. The given order of the boxes is always preserved and the main reading direction of the boxes is left to right. The algorithm is divided into two phases. One phase approximates the width in which the rectangles can be placed. The next phase places the rectangles in rows using the previously calculated width as bounding width and bundles rectangles with a similar height in blocks. A compaction step reduces the size of the drawing. Finally, the rectangles are expanded to fill their bounding box and eliminate empty unused spaces.'), new o2c)));
    Pad(a, XAe, Oue, 1.3);
    Pad(a, XAe, Wue, (xdb(), false));
    Pad(a, XAe, Rue, b2c);
    Pad(a, XAe, Mue, 15);
    Pad(a, XAe, Qye, JBd(M1c));
    Pad(a, XAe, Yue, JBd(T1c));
    Pad(a, XAe, pve, JBd(V1c));
    Pad(a, XAe, Xue, JBd(W1c));
    Pad(a, XAe, Zue, JBd(S1c));
    Pad(a, XAe, Vue, JBd(X1c));
    Pad(a, XAe, $ue, JBd(c2c));
    Pad(a, XAe, OAe, JBd(h2c));
    Pad(a, XAe, PAe, JBd(g2c));
    Pad(a, XAe, NAe, JBd(j2c));
    Pad(a, XAe, MAe, JBd(i2c));
    Pad(a, XAe, QAe, JBd(_1c));
    Pad(a, XAe, RAe, JBd($1c));
    Pad(a, XAe, SAe, JBd(Z1c));
    Pad(a, XAe, TAe, JBd(f2c));
    Pad(a, XAe, Sue, JBd(P1c));
    Pad(a, XAe, bze, JBd(Q1c));
    Pad(a, XAe, JAe, JBd(O1c));
    Pad(a, XAe, IAe, JBd(N1c));
    Pad(a, XAe, KAe, JBd(R1c));
    Pad(a, XAe, HAe, JBd(e2c));
    Pad(a, XAe, LAe, JBd(Y1c));
}
function Vzc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L;
    c.Sg('Greedy cycle removal', 1);
    t = b.a;
    L = t.c.length;
    a.a = SC(cE, ise, 30, L, 15, 1);
    a.c = SC(cE, ise, 30, L, 15, 1);
    a.b = SC(cE, ise, 30, L, 15, 1);
    j = 0;
    for(r = new rmb(t); r.a < r.c.c.length;){
        p = JD(pmb(r), 9);
        p.p = j;
        for(C = new rmb(p.j); C.a < C.c.c.length;){
            w = JD(pmb(C), 11);
            for(h = new rmb(w.e); h.a < h.c.c.length;){
                d = JD(pmb(h), 18);
                if (d.c.i == p) continue;
                G = JD(WMb(d, (Bwc(), Nvc)), 17).a;
                a.a[j] += G > 0 ? G + 1 : 1;
            }
            for(g = new rmb(w.g); g.a < g.c.c.length;){
                d = JD(pmb(g), 18);
                if (d.d.i == p) continue;
                G = JD(WMb(d, (Bwc(), Nvc)), 17).a;
                a.c[j] += G > 0 ? G + 1 : 1;
            }
        }
        a.c[j] == 0 ? Atb(a.e, p) : a.a[j] == 0 && Atb(a.f, p);
        ++j;
    }
    o = -1;
    n = 1;
    l = new Ulb;
    a.d = JD(WMb(b, (Iqc(), vqc)), 233);
    while(L > 0){
        while(a.e.b != 0){
            I = JD(Itb(a.e), 9);
            a.b[I.p] = o--;
            Wzc(a, I);
            --L;
        }
        while(a.f.b != 0){
            J = JD(Itb(a.f), 9);
            a.b[J.p] = n++;
            Wzc(a, J);
            --L;
        }
        if (L > 0) {
            m = Lre;
            for(s = new rmb(t); s.a < s.c.c.length;){
                p = JD(pmb(s), 9);
                if (a.b[p.p] == 0) {
                    u = a.c[p.p] - a.a[p.p];
                    if (u >= m) {
                        if (u > m) {
                            l.c.length = 0;
                            m = u;
                        }
                        YCb(l.c, p);
                    }
                }
            }
            k = a.qg(l);
            a.b[k.p] = n++;
            Wzc(a, k);
            --L;
        }
    }
    H = t.c.length + 1;
    for(j = 0; j < t.c.length; j++)a.b[j] < 0 && (a.b[j] += H);
    for(q = new rmb(t); q.a < q.c.c.length;){
        p = JD(pmb(q), 9);
        F = EXb(p.j);
        for(A = F, B = 0, D = A.length; B < D; ++B){
            w = A[B];
            v = CXb(w.g);
            for(e = v, f = 0, i = e.length; f < i; ++f){
                d = e[f];
                K = d.d.i.p;
                if (a.b[p.p] > a.b[K]) {
                    fWb(d, true);
                    ZMb(b, Mpc, (xdb(), true));
                }
            }
        }
    }
    a.a = null;
    a.c = null;
    a.b = null;
    Ltb(a.f);
    Ltb(a.e);
    c.Tg();
}
function n$b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    m = 0;
    for(e = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); e.e != e.i.gc();){
        d = JD(AHd(e), 27);
        if (!ydb(LD(ksd(d, (Bwc(), svc))))) {
            k = Zwd(d);
            if ((XD(ksd(k, cuc)) !== XD((nyc(), kyc)) || XD(ksd(k, puc)) === XD((znc(), ync)) || XD(ksd(k, puc)) === XD((znc(), wnc)) || ydb(LD(ksd(k, euc))) || XD(ksd(k, Ytc)) !== XD((cUb(), bUb)) || XD(ksd(k, Zuc)) === XD((dyc(), Wxc)) || XD(ksd(k, Zuc)) === XD((dyc(), Xxc)) || XD(ksd(k, $uc)) === XD((cxc(), Vwc)) || XD(ksd(k, $uc)) === XD((cxc(), Xwc))) && !ydb(LD(ksd(d, auc)))) {
                msd(d, (Iqc(), jqc), jfb(m));
                ++m;
            }
            u$b(a, d, c);
        }
    }
    m = 0;
    for(j = new CHd((!b.b && (b.b = new X0d(x3, b, 12, 3)), b.b)); j.e != j.i.gc();){
        h = JD(AHd(j), 85);
        if (XD(ksd(b, (Bwc(), cuc))) !== XD((nyc(), kyc)) || XD(ksd(b, puc)) === XD((znc(), ync)) || XD(ksd(b, puc)) === XD((znc(), wnc)) || ydb(LD(ksd(b, euc))) || XD(ksd(b, Ytc)) !== XD((cUb(), bUb)) || XD(ksd(b, Zuc)) === XD((dyc(), Wxc)) || XD(ksd(b, Zuc)) === XD((dyc(), Xxc)) || XD(ksd(b, $uc)) === XD((cxc(), Vwc)) || XD(ksd(b, $uc)) === XD((cxc(), Xwc))) {
            msd(h, (Iqc(), jqc), jfb(m));
            ++m;
        }
        p = iCd(h);
        q = jCd(h);
        l = ydb(LD(ksd(p, Nuc)));
        o = !ydb(LD(ksd(h, svc)));
        n = l && Std(h) && ydb(LD(ksd(h, Ouc)));
        f = Zwd(p) == b && Zwd(p) == Zwd(q);
        g = (Zwd(p) == b && q == b) ^ (Zwd(q) == b && p == b);
        o && !n && (g || f) && r$b(a, h, b, c);
    }
    if (Zwd(b)) for(i = new CHd(Ywd(Zwd(b))); i.e != i.i.gc();){
        h = JD(AHd(i), 85);
        p = iCd(h);
        if (p == b && Std(h)) {
            n = ydb(LD(ksd(p, (Bwc(), Nuc)))) && ydb(LD(ksd(h, Ouc)));
            n && r$b(a, h, b, c);
        }
    }
}
function cnd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    v = JD(nDd((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a), 0), 168);
    k = new Rdd;
    u = new Irb;
    w = fnd(v);
    gsb(u.f, v, w);
    m = new Irb;
    d = new Mtb;
    for(o = Dl(yl(WC(OC(VI, 1), Nqe, 20, 0, [
        (!b.d && (b.d = new ree(x3, b, 8, 5)), b.d),
        (!b.e && (b.e = new ree(x3, b, 7, 4)), b.e)
    ]))); cs(o);){
        n = JD(ds(o), 85);
        if ((!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i != 1) throw scb(new Teb(uCe + (!a.a && (a.a = new X0d(w3, a, 6, 6)), a.a).i));
        if (n != a) {
            q = JD(nDd((!n.a && (n.a = new X0d(w3, n, 6, 6)), n.a), 0), 168);
            Dtb(d, q, d.c.b, d.c);
            p = JD(Wd(fsb(u.f, q)), 13);
            if (!p) {
                p = fnd(q);
                gsb(u.f, q, p);
            }
            l = c ? Bdd(new Fdd(JD(Mlb(w, w.c.length - 1), 8)), JD(Mlb(p, p.c.length - 1), 8)) : Bdd(new Fdd((sDb(0, w.c.length), JD(w.c[0], 8))), (sDb(0, p.c.length), JD(p.c[0], 8)));
            gsb(m.f, q, l);
        }
    }
    if (d.b != 0) {
        r = JD(Mlb(w, c ? w.c.length - 1 : 0), 8);
        for(j = 1; j < w.c.length; j++){
            s = JD(Mlb(w, c ? w.c.length - 1 - j : j), 8);
            e = Gtb(d, 0);
            while(e.b != e.d.c){
                q = JD(Utb(e), 168);
                p = JD(Wd(fsb(u.f, q)), 13);
                if (p.c.length <= j) Wtb(e);
                else {
                    t = mdd(new Fdd(JD(Mlb(p, c ? p.c.length - 1 - j : j), 8)), JD(Wd(fsb(m.f, q)), 8));
                    if (s.a != t.a || s.b != t.b) {
                        f = s.a - r.a;
                        h = s.b - r.b;
                        g = t.a - r.a;
                        i = t.b - r.b;
                        g * h == i * f && (f == 0 || isNaN(f) ? f : f < 0 ? -1 : 1) == (g == 0 || isNaN(g) ? g : g < 0 ? -1 : 1) && (h == 0 || isNaN(h) ? h : h < 0 ? -1 : 1) == (i == 0 || isNaN(i) ? i : i < 0 ? -1 : 1) ? ($wnd.Math.abs(f) < $wnd.Math.abs(g) || $wnd.Math.abs(h) < $wnd.Math.abs(i)) && Dtb(k, s, k.c.b, k.c) : j > 1 && Dtb(k, r, k.c.b, k.c);
                        Wtb(e);
                    }
                }
            }
            r = s;
        }
    }
    return k;
}
function VVc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    c.Sg(Wze, 1);
    D = JD(yBb(BBb(new RBb(null, new Gvb(b, 16)), new hWc), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    k = JD(yBb(BBb(new RBb(null, new Gvb(b, 16)), new jWc(b)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        jAb
    ]))), 15);
    o = JD(yBb(BBb(new RBb(null, new Gvb(b, 16)), new lWc(b)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        jAb
    ]))), 15);
    p = SC(NZ, Ize, 39, b.gc(), 0, 1);
    for(g = 0; g < k.gc(); g++){
        e = JD(k.Xb(g), 39);
        C = JD(WMb(e, (kVc(), ZUc)), 17).a;
        if (C >= 0 && C < k.gc() && !p[C]) {
            p[C] = e;
            k.ed(g);
            --g;
        }
    }
    for(h = 0; h < k.gc(); h++){
        e = JD(k.Xb(h), 39);
        C = JD(WMb(e, (kVc(), ZUc)), 17).a;
        for(m = 0;; m++){
            n = C + m;
            if (n < p.length && n >= 0 && !p[n]) {
                p[n] = e;
                k.ed(h);
                --h;
                break;
            }
            n = C - m;
            if (n < p.length && n >= 0 && !p[n]) {
                p[n] = e;
                k.ed(h);
                --h;
                break;
            }
        }
    }
    o.gd(new nWc);
    for(i = p.length - 1; i >= 0; i--)if (!p[i] && !o.dc()) {
        p[i] = JD(o.Xb(0), 39);
        o.ed(0);
    }
    for(j = 0; j < p.length; j++)if (!p[j] && !D.dc()) {
        p[j] = JD(D.Xb(0), 39);
        D.ed(0);
    }
    for(f = 0; f < p.length; f++)ZMb(p[f], (tUc(), lUc), jfb(f));
    l = JD(QBb(BBb(new RBb(null, new Gvb(b, 16)), new rWc), new dWc), 519);
    for(w = l, A = 0, B = w.length; A < B; ++A){
        v = w[A];
        d = bRc(v);
        VVc(a, d, c.bh(1 / l.length | 0));
        pnb();
        hub(d, new VBd((tUc(), lUc)));
        q = new Mtb;
        for(u = Gtb(d, 0); u.b != u.d.c;){
            t = JD(Utb(u), 39);
            for(s = Gtb(v.d, 0); s.b != s.d.c;){
                r = JD(Utb(s), 65);
                r.c == t && Dtb(q, r, q.c.b, q.c);
            }
        }
        Ltb(v.d);
        xe(v.d, q);
    }
    c.Tg();
}
function A3c(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    t = Beb(MD(ksd(b, (h1c(), g1c))));
    n = Beb(MD(ksd(b, e1c)));
    m = Beb(MD(ksd(b, b1c)));
    R4c((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a));
    r = h3c((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a), t, a.b);
    for(q = 0; q < r.c.length; q++){
        i = (sDb(q, r.c.length), JD(r.c[q], 186));
        if (q != 0) {
            o = (sDb(q - 1, r.c.length), JD(r.c[q - 1], 186));
            W4c(i, o.f + o.b + a.b);
        }
        p = Y2c(q, r, t, a.b, ydb(LD(ksd(b, (k2c(), $1c)))));
        if (ydb(LD(p.b))) {
            for(f = new rmb(i.a); f.a < f.c.c.length;){
                e = JD(pmb(f), 172);
                e.c = false;
                e.k = false;
                b4c(e);
            }
            i.d = new Ulb;
            i.e = t;
            --q;
        } else {
            z3c(a, i);
            if (q + 1 < r.c.length) {
                a.e = $wnd.Math.max(i.e + a.b + JD(Mlb((sDb(q + 1, r.c.length), JD(r.c[q + 1], 186)).a, 0), 172).r - t, a.c);
                a.f = $wnd.Math.min(i.e + a.b + JD(Mlb((sDb(q + 1, r.c.length), JD(r.c[q + 1], 186)).a, 0), 172).r - t, a.d);
                if (i.d.c.length != 0) {
                    a.c = $wnd.Math.max(a.c, JD(Mlb(i.d, i.d.c.length - 1), 316).d + (i.d.c.length <= 1 ? 0 : a.b));
                    a.d = $wnd.Math.min(a.c, JD(Mlb(i.d, i.d.c.length - 1), 316).d + (i.d.c.length <= 1 ? 0 : a.b));
                }
            }
            if (r.c.length == 1) {
                l = JD(Mlb(i.d, i.d.c.length - 1), 316);
                k = JD(Mlb(l.a, l.a.c.length - 1), 172);
                for(h = new rmb(k.n); h.a < h.c.c.length;){
                    g = JD(pmb(h), 208);
                    a.c = $wnd.Math.max(a.c, k.r - g.d);
                    a.d = $wnd.Math.min(a.d, k.r - g.d);
                    a.e = $wnd.Math.max(a.e, g.d + a.b);
                    a.f = $wnd.Math.min(a.f, g.d + a.b);
                }
            }
        }
    }
    s = P4c(r, a.b);
    u = $wnd.Math.max(s.a, n - (c.b + c.c));
    j = $wnd.Math.max(s.b, m - (c.d + c.a));
    d = j - s.b;
    msd(b, Y0c, d);
    msd(b, f1c, r);
    return new B4c(a.a, u, s.b + d, (I4c(), H4c));
}
function q2b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    A = JD(WMb(a, (Bwc(), Evc)), 100);
    if (!(A != (ajd(), $id) && A != _id)) return;
    o = a.b;
    n = o.c.length;
    k = new Vlb((bk(n + 2, Gre), Xy(tcb(tcb(5, n + 2), (n + 2) / 10 | 0))));
    p = new Vlb((bk(n + 2, Gre), Xy(tcb(tcb(5, n + 2), (n + 2) / 10 | 0))));
    Ilb(k, new Irb);
    Ilb(k, new Irb);
    Ilb(p, new Ulb);
    Ilb(p, new Ulb);
    w = new Ulb;
    for(b = 0; b < n; b++){
        c = (sDb(b, o.c.length), JD(o.c[b], 25));
        B = (sDb(b, k.c.length), JD(k.c[b], 91));
        q = new Irb;
        YCb(k.c, q);
        D = (sDb(b, p.c.length), JD(p.c[b], 15));
        s = new Ulb;
        YCb(p.c, s);
        for(e = new rmb(c.a); e.a < e.c.c.length;){
            d = JD(pmb(e), 9);
            if (m2b(d)) {
                YCb(w.c, d);
                continue;
            }
            for(j = new es(Ir(hYb(d).a.Jc(), new er)); cs(j);){
                h = JD(ds(j), 18);
                F = h.c.i;
                if (!m2b(F)) continue;
                C = JD(B.xc(WMb(F, (Iqc(), kqc))), 9);
                if (!C) {
                    C = l2b(a, F);
                    B.yc(WMb(F, kqc), C);
                    D.Ec(C);
                }
                gWb(h, JD(Mlb(C.j, 1), 11));
            }
            for(i = new es(Ir(kYb(d).a.Jc(), new er)); cs(i);){
                h = JD(ds(i), 18);
                G = h.d.i;
                if (!m2b(G)) continue;
                r = JD(Nib(q, WMb(G, (Iqc(), kqc))), 9);
                if (!r) {
                    r = l2b(a, G);
                    Qib(q, WMb(G, kqc), r);
                    YCb(s.c, r);
                }
                hWb(h, JD(Mlb(r.j, 0), 11));
            }
        }
    }
    for(l = 0; l < p.c.length; l++){
        t = (sDb(l, p.c.length), JD(p.c[l], 15));
        if (t.dc()) continue;
        m = null;
        if (l == 0) {
            m = new b$b(a);
            vDb(0, o.c.length);
            WCb(o.c, 0, m);
        } else if (l == k.c.length - 1) {
            m = new b$b(a);
            YCb(o.c, m);
        } else m = (sDb(l - 1, o.c.length), JD(o.c[l - 1], 25));
        for(g = t.Jc(); g.Ob();){
            f = JD(g.Pb(), 9);
            qYb(f, m);
        }
    }
    for(v = new rmb(w); v.a < v.c.c.length;){
        u = JD(pmb(v), 9);
        qYb(u, null);
    }
    ZMb(a, (Iqc(), Rpc), w);
}
function VHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
    I = new Ulb;
    for(o = new rmb(b.b); o.a < o.c.c.length;){
        m = JD(pmb(o), 25);
        for(v = new rmb(m.a); v.a < v.c.c.length;){
            u = JD(pmb(v), 9);
            u.p = -1;
            l = Lre;
            B = Lre;
            for(D = new rmb(u.j); D.a < D.c.c.length;){
                C = JD(pmb(D), 11);
                for(e = new rmb(C.e); e.a < e.c.c.length;){
                    c = JD(pmb(e), 18);
                    F = JD(WMb(c, (Bwc(), Pvc)), 17).a;
                    l = $wnd.Math.max(l, F);
                }
                for(d = new rmb(C.g); d.a < d.c.c.length;){
                    c = JD(pmb(d), 18);
                    F = JD(WMb(c, (Bwc(), Pvc)), 17).a;
                    B = $wnd.Math.max(B, F);
                }
            }
            ZMb(u, KHc, jfb(l));
            ZMb(u, LHc, jfb(B));
        }
    }
    r = 0;
    for(n = new rmb(b.b); n.a < n.c.c.length;){
        m = JD(pmb(n), 25);
        for(v = new rmb(m.a); v.a < v.c.c.length;){
            u = JD(pmb(v), 9);
            if (u.p < 0) {
                H = new aIc;
                H.b = r++;
                RHc(a, u, H);
                YCb(I.c, H);
            }
        }
    }
    A = av(I.c.length);
    k = av(I.c.length);
    for(g = 0; g < I.c.length; g++){
        Ilb(A, new Ulb);
        Ilb(k, jfb(0));
    }
    PHc(b, I, A, k);
    J = JD(Tlb(I, SC(GX, oze, 261, I.c.length, 0, 1)), 833);
    w = JD(Tlb(A, SC(HK, nue, 15, A.c.length, 0, 1)), 198);
    j = SC(cE, ise, 30, k.c.length, 15, 1);
    for(h = 0; h < j.length; h++)j[h] = (sDb(h, k.c.length), JD(k.c[h], 17)).a;
    s = 0;
    t = new Ulb;
    for(i = 0; i < J.length; i++)j[i] == 0 && YCb(t.c, J[i]);
    q = SC(cE, ise, 30, J.length, 15, 1);
    while(t.c.length != 0){
        H = JD(Olb(t, 0), 261);
        q[H.b] = s++;
        while(!w[H.b].dc()){
            K = JD(w[H.b].ed(0), 261);
            --j[K.b];
            j[K.b] == 0 && YCb(t.c, K);
        }
    }
    a.a = SC(GX, oze, 261, J.length, 0, 1);
    for(f = 0; f < J.length; f++){
        p = J[f];
        G = q[f];
        a.a[G] = p;
        p.b = G;
        for(v = new rmb(p.e); v.a < v.c.c.length;){
            u = JD(pmb(v), 9);
            u.p = G;
        }
    }
    return a.a;
}
function Y2c(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r;
    p = false;
    i = false;
    m = a + 1;
    o = (sDb(a, b.c.length), JD(b.c[a], 186));
    h = o.a;
    j = null;
    for(g = 0; g < o.a.c.length; g++){
        f = (sDb(g, h.c.length), JD(h.c[g], 172));
        if (f.c) continue;
        if (f.b.c.length == 0) {
            Zgb();
            String.fromCharCode(10);
            V4c(o, f);
            --g;
            p = true;
            continue;
        }
        if (!f.k) {
            !!j && w4c(j);
            j = new x4c(!j ? 0 : j.e + j.d + d, o.f, d);
            i4c(f, j.e + j.d, o.f);
            Ilb(o.d, j);
            q4c(j, f);
            f.k = true;
        }
        k = null;
        k = (r = null, g < o.a.c.length - 1 ? r = JD(Mlb(o.a, g + 1), 172) : m < b.c.length && (sDb(m, b.c.length), JD(b.c[m], 186)).a.c.length != 0 && (r = JD(Mlb((sDb(m, b.c.length), JD(b.c[m], 186)).a, 0), 172)), r);
        q = false;
        !!k && (q = !pb(k.j, o));
        if (k) {
            if (k.b.c.length != 0 && !ydb(LD(JD(Mlb(k.b, 0), 27).mf((k2c(), R1c))))) {
                e4c(f, c - f.s);
                w4c(f.q);
                p = p | X2c(o, f, k, c, d);
            } else {
                V4c(o, k);
                break;
            }
            if (k.b.c.length == 0) {
                b.c.length > m && V4c((sDb(m, b.c.length), JD(b.c[m], 186)), k);
                k = null;
                while(b.c.length > m && (sDb(m, b.c.length), JD(b.c[m], 186)).a.c.length == 0)Plb(b, (sDb(m, b.c.length), b.c[m]));
            }
            if (!k) {
                --g;
                continue;
            }
            if (!ydb(LD(JD(Mlb(k.b, 0), 27).mf((k2c(), R1c)))) && Z2c(b, o, f, k, q, c, m, d)) {
                p = true;
                continue;
            }
            if (q) {
                n = o.b;
                l = k.f;
                if (!ydb(LD(JD(Mlb(k.b, 0), 27).mf(R1c))) && $2c(b, o, f, k, c, m, d, e)) {
                    p = true;
                    if (n < l) {
                        i = true;
                        k.j = o;
                        break;
                    }
                    continue;
                } else if (_2c(o, f)) {
                    f.c = true;
                    p = true;
                    continue;
                }
            } else if (_2c(o, f)) {
                f.c = true;
                p = true;
                continue;
            }
            if (p) continue;
        }
        if (_2c(o, f)) {
            f.c = true;
            p = true;
            !!k && (k.k = false);
            continue;
        } else w4c(f.q);
    }
    return new xod((xdb(), p ? true : false), i ? true : false);
}
function fme(a) {
    var b, c, d;
    if (a.d >= a.j) {
        a.a = -1;
        a.c = 1;
        return;
    }
    b = _fb(a.i, a.d++);
    a.a = b;
    if (a.b == 1) {
        switch(b){
            case 92:
                d = 10;
                if (a.d >= a.j) throw scb(new eme(qEd((a9d(), WDe))));
                a.a = _fb(a.i, a.d++);
                break;
            case 45:
                if ((a.e & 512) == 512 && a.d < a.j && _fb(a.i, a.d) == 91) {
                    ++a.d;
                    d = 24;
                } else d = 0;
                break;
            case 91:
                if ((a.e & 512) != 512 && a.d < a.j && _fb(a.i, a.d) == 58) {
                    ++a.d;
                    d = 20;
                    break;
                }
            default:
                if ((b & 64512) == Qse && a.d < a.j) {
                    c = _fb(a.i, a.d);
                    if ((c & 64512) == 56320) {
                        a.a = Pse + (b - Qse << 10) + c - 56320;
                        ++a.d;
                    }
                }
                d = 0;
        }
        a.c = d;
        return;
    }
    switch(b){
        case 124:
            d = 2;
            break;
        case 42:
            d = 3;
            break;
        case 43:
            d = 4;
            break;
        case 63:
            d = 5;
            break;
        case 41:
            d = 7;
            break;
        case 46:
            d = 8;
            break;
        case 91:
            d = 9;
            break;
        case 94:
            d = 11;
            break;
        case 36:
            d = 12;
            break;
        case 40:
            d = 6;
            if (a.d >= a.j) break;
            if (_fb(a.i, a.d) != 63) break;
            if (++a.d >= a.j) throw scb(new eme(qEd((a9d(), XDe))));
            b = _fb(a.i, a.d++);
            switch(b){
                case 58:
                    d = 13;
                    break;
                case 61:
                    d = 14;
                    break;
                case 33:
                    d = 15;
                    break;
                case 91:
                    d = 19;
                    break;
                case 62:
                    d = 18;
                    break;
                case 60:
                    if (a.d >= a.j) throw scb(new eme(qEd((a9d(), XDe))));
                    b = _fb(a.i, a.d++);
                    if (b == 61) d = 16;
                    else if (b == 33) d = 17;
                    else throw scb(new eme(qEd((a9d(), YDe))));
                    break;
                case 35:
                    while(a.d < a.j){
                        b = _fb(a.i, a.d++);
                        if (b == 41) break;
                    }
                    if (b != 41) throw scb(new eme(qEd((a9d(), ZDe))));
                    d = 21;
                    break;
                default:
                    if (b == 45 || 97 <= b && b <= 122 || 65 <= b && b <= 90) {
                        --a.d;
                        d = 22;
                        break;
                    } else if (b == 40) {
                        d = 23;
                        break;
                    }
                    throw scb(new eme(qEd((a9d(), XDe))));
            }
            break;
        case 92:
            d = 10;
            if (a.d >= a.j) throw scb(new eme(qEd((a9d(), WDe))));
            a.a = _fb(a.i, a.d++);
            break;
        default:
            d = 0;
    }
    a.c = d;
}
function rRc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    c.Sg('Process compaction', 1);
    if (!ydb(LD(WMb(b, (kVc(), IUc))))) return;
    e = JD(WMb(b, KUc), 86);
    n = Beb(MD(WMb(b, cVc)));
    sRc(a, b, e);
    oRc(b, n / 2 / 2);
    o = b.b;
    hub(o, new HRc(e));
    for(j = Gtb(o, 0); j.b != j.d.c;){
        i = JD(Utb(j), 39);
        if (!ydb(LD(WMb(i, (tUc(), qUc))))) {
            d = pRc(i, e);
            p = oQc(i, b);
            l = 0;
            m = 0;
            if (d) {
                q = d.e;
                switch(e.g){
                    case 2:
                        l = q.a - n - i.f.a;
                        p.e.a - n - i.f.a < l && (l = p.e.a - n - i.f.a);
                        m = l + i.f.a;
                        break;
                    case 1:
                        l = q.a + d.f.a + n;
                        p.e.a + n > l && (l = p.e.a + p.f.a + n);
                        m = l + i.f.a;
                        break;
                    case 4:
                        l = q.b - n - i.f.b;
                        p.e.b - n - i.f.b < l && (l = p.e.b - n - i.f.b);
                        m = l + i.f.b;
                        break;
                    case 3:
                        l = q.b + d.f.b + n;
                        p.e.b + n > l && (l = p.e.b + p.f.b + n);
                        m = l + i.f.b;
                }
            } else if (p) switch(e.g){
                case 2:
                    l = p.e.a - n - i.f.a;
                    m = l + i.f.a;
                    break;
                case 1:
                    l = p.e.a + p.f.a + n;
                    m = l + i.f.a;
                    break;
                case 4:
                    l = p.e.b - n - i.f.b;
                    m = l + i.f.b;
                    break;
                case 3:
                    l = p.e.b + p.f.b + n;
                    m = l + i.f.b;
            }
            if (XD(WMb(b, NUc)) === XD((OTc(), LTc))) {
                f = l;
                g = m;
                h = CBb(BBb(new RBb(null, new Gvb(a.a, 16)), new LRc(f, g)));
                if (h.a != null) e == (Tgd(), Pgd) || e == Qgd ? i.e.a = l : i.e.b = l;
                else {
                    e == (Tgd(), Pgd) || e == Sgd ? h = CBb(BBb(MBb(new RBb(null, new Gvb(a.a, 16))), new ZRc(f))) : h = CBb(BBb(MBb(new RBb(null, new Gvb(a.a, 16))), new _Rc(f)));
                    h.a != null && (e == Pgd || e == Qgd ? i.e.a = Beb(MD((rDb(h.a != null), JD(h.a, 47)).a)) : i.e.b = Beb(MD((rDb(h.a != null), JD(h.a, 47)).a)));
                }
                if (h.a != null) {
                    k = Nlb(a.a, (rDb(h.a != null), h.a), 0);
                    if (k > 0 && k != JD(WMb(i, iVc), 17).a) {
                        ZMb(i, XTc, (xdb(), true));
                        ZMb(i, iVc, jfb(k));
                    }
                }
            } else e == (Tgd(), Pgd) || e == Qgd ? i.e.a = l : i.e.b = l;
        }
    }
    c.Tg();
}
function Bwc() {
    Bwc = Zcb;
    Tvc = (Lgd(), lgd);
    Uvc = mgd;
    Vvc = ngd;
    Wvc = ogd;
    Yvc = pgd;
    Zvc = qgd;
    awc = sgd;
    cwc = ugd;
    dwc = vgd;
    bwc = tgd;
    ewc = wgd;
    gwc = xgd;
    iwc = Agd;
    _vc = rgd;
    Svc = (Otc(), etc);
    Xvc = ftc;
    $vc = gtc;
    fwc = htc;
    Mvc = new NBd(ggd, jfb(0));
    Nvc = btc;
    Ovc = ctc;
    Pvc = dtc;
    ywc = Ftc;
    qwc = ktc;
    rwc = ntc;
    uwc = vtc;
    swc = qtc;
    twc = stc;
    Awc = Ktc;
    zwc = Htc;
    wwc = Btc;
    vwc = ztc;
    xwc = Dtc;
    bvc = Fsc;
    _uc = Asc;
    avc = Csc;
    lvc = Usc;
    mvc = Vsc;
    Duc = Yrc;
    Euc = _rc;
    mwc = Dgd;
    owc = Hgd;
    lwc = Cgd;
    kwc = Bgd;
    nwc = (Wkd(), Tkd);
    new NBd(Egd, nwc);
    uvc = new MYb(12);
    tvc = new NBd(Kfd, uvc);
    zuc = (xhd(), thd);
    yuc = new NBd(dfd, zuc);
    Dvc = new NBd(Xfd, 0);
    Qvc = new NBd(hgd, jfb(1));
    Ttc = new NBd(Qed, Jue);
    svc = Ifd;
    Evc = Yfd;
    Jvc = dgd;
    quc = Zed;
    Rtc = Oed;
    Iuc = ifd;
    Rvc = new NBd(kgd, (xdb(), true));
    Nuc = lfd;
    Ouc = mfd;
    ovc = Bfd;
    rvc = Gfd;
    pvc = Dfd;
    tuc = (Tgd(), Rgd);
    ruc = new NBd($ed, tuc);
    gvc = zfd;
    fvc = xfd;
    Hvc = agd;
    Gvc = _fd;
    Ivc = cgd;
    xvc = (Qid(), Pid);
    new NBd(Qfd, xvc);
    zvc = Tfd;
    Avc = Ufd;
    Bvc = Vfd;
    yvc = Sfd;
    pwc = jtc;
    $uc = ysc;
    Zuc = wsc;
    jwc = itc;
    Uuc = osc;
    puc = Krc;
    ouc = Irc;
    euc = qrc;
    fuc = rrc;
    huc = xrc;
    guc = trc;
    nuc = Grc;
    dvc = Hsc;
    evc = Isc;
    Quc = hsc;
    nvc = Zsc;
    ivc = Msc;
    Guc = csc;
    kvc = Ssc;
    Buc = Urc;
    Cuc = Wrc;
    duc = Xed;
    hvc = Jsc;
    Xtc = erc;
    Wtc = crc;
    Vtc = brc;
    Kuc = fsc;
    Juc = esc;
    Luc = gsc;
    qvc = Efd;
    Ruc = tfd;
    Fuc = ffd;
    wuc = bfd;
    vuc = afd;
    iuc = Arc;
    Fvc = $fd;
    Utc = Wed;
    Muc = kfd;
    Cvc = Wfd;
    vvc = Mfd;
    wvc = Ofd;
    Wuc = rsc;
    Xuc = tsc;
    Lvc = fgd;
    Stc = arc;
    Yuc = vsc;
    xuc = Qrc;
    uuc = Orc;
    cvc = vfd;
    Suc = lsc;
    jvc = Psc;
    hwc = ygd;
    suc = Mrc;
    Kvc = _sc;
    Auc = Src;
    juc = Crc;
    kuc = Drc;
    Tuc = nsc;
    luc = Erc;
    Puc = ofd;
    Vuc = qsc;
    muc = Frc;
    cuc = orc;
    _tc = krc;
    Ztc = irc;
    $tc = jrc;
    auc = mrc;
    Ytc = grc;
    buc = nrc;
    Huc = dsc;
}
function HAc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    c.Sg('Coffman-Graham Layering', 1);
    if (b.a.c.length == 0) {
        c.Tg();
        return;
    }
    v = JD(WMb(b, (Bwc(), Suc)), 17).a;
    i = 0;
    g = 0;
    for(m = new rmb(b.a); m.a < m.c.c.length;){
        l = JD(pmb(m), 9);
        l.p = i++;
        for(f = new es(Ir(kYb(l).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            e.p = g++;
        }
    }
    a.d = SC(pcb, Vte, 30, i, 16, 1);
    a.a = SC(pcb, Vte, 30, g, 16, 1);
    a.b = SC(cE, ise, 30, i, 15, 1);
    a.e = SC(cE, ise, 30, i, 15, 1);
    a.f = SC(cE, ise, 30, i, 15, 1);
    Nc(a.c);
    IAc(a, b);
    o = new dvb(new MAc(a));
    for(u = new rmb(b.a); u.a < u.c.c.length;){
        s = JD(pmb(u), 9);
        for(f = new es(Ir(hYb(s).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            a.a[e.p] || ++a.b[s.p];
        }
        a.b[s.p] == 0 && yDb(_ub(o, s), Xse);
    }
    h = 0;
    while(o.b.c.length != 0){
        s = JD(avb(o), 9);
        a.f[s.p] = h++;
        for(f = new es(Ir(kYb(s).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            if (a.a[e.p]) continue;
            q = e.d.i;
            --a.b[q.p];
            Rc(a.c, q, jfb(a.f[s.p]));
            a.b[q.p] == 0 && yDb(_ub(o, q), Xse);
        }
    }
    n = new dvb(new QAc(a));
    for(t = new rmb(b.a); t.a < t.c.c.length;){
        s = JD(pmb(t), 9);
        for(f = new es(Ir(kYb(s).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            a.a[e.p] || ++a.e[s.p];
        }
        a.e[s.p] == 0 && yDb(_ub(n, s), Xse);
    }
    k = new Ulb;
    d = EAc(b, k);
    while(n.b.c.length != 0){
        r = JD(avb(n), 9);
        (d.a.c.length >= v || !CAc(r, d)) && (d = EAc(b, k));
        qYb(r, d);
        for(f = new es(Ir(hYb(r).a.Jc(), new er)); cs(f);){
            e = JD(ds(f), 18);
            if (a.a[e.p]) continue;
            p = e.c.i;
            --a.e[p.p];
            a.e[p.p] == 0 && yDb(_ub(n, p), Xse);
        }
    }
    for(j = k.c.length - 1; j >= 0; --j)Ilb(b.b, (sDb(j, k.c.length), JD(k.c[j], 25)));
    b.a.c.length = 0;
    c.Tg();
}
function $me(a) {
    var b, c, d, e, f, g, h, i, j;
    a.b = 1;
    fme(a);
    b = null;
    if (a.c == 0 && a.a == 94) {
        fme(a);
        b = (ooe(), ooe(), ++noe, new Soe(4));
        Moe(b, 0, NGe);
        h = (++noe, new Soe(4));
    } else h = (ooe(), ooe(), ++noe, new Soe(4));
    e = true;
    while((j = a.c) != 1){
        if (j == 0 && a.a == 93 && !e) {
            if (b) {
                Roe(b, h);
                h = b;
            }
            break;
        }
        c = a.a;
        d = false;
        if (j == 10) switch(c){
            case 100:
            case 68:
            case 119:
            case 87:
            case 115:
            case 83:
                Poe(h, Zme(c));
                d = true;
                break;
            case 105:
            case 73:
            case 99:
            case 67:
                c = (Poe(h, Zme(c)), -1);
                c < 0 && (d = true);
                break;
            case 112:
            case 80:
                i = lme(a, c);
                if (!i) throw scb(new eme(qEd((a9d(), iEe))));
                Poe(h, i);
                d = true;
                break;
            default:
                c = Yme(a);
        }
        else if (j == 24 && !e) {
            if (b) {
                Roe(b, h);
                h = b;
            }
            f = $me(a);
            Roe(h, f);
            if (a.c != 0 || a.a != 93) throw scb(new eme(qEd((a9d(), mEe))));
            break;
        }
        fme(a);
        if (!d) {
            if (j == 0) {
                if (c == 91) throw scb(new eme(qEd((a9d(), nEe))));
                if (c == 93) throw scb(new eme(qEd((a9d(), oEe))));
                if (c == 45 && !e && a.a != 93) throw scb(new eme(qEd((a9d(), pEe))));
            }
            if (a.c != 0 || a.a != 45 || c == 45 && e) Moe(h, c, c);
            else {
                fme(a);
                if ((j = a.c) == 1) throw scb(new eme(qEd((a9d(), kEe))));
                if (j == 0 && a.a == 93) {
                    Moe(h, c, c);
                    Moe(h, 45, 45);
                } else if (j == 0 && a.a == 93 || j == 24) throw scb(new eme(qEd((a9d(), pEe))));
                else {
                    g = a.a;
                    if (j == 0) {
                        if (g == 91) throw scb(new eme(qEd((a9d(), nEe))));
                        if (g == 93) throw scb(new eme(qEd((a9d(), oEe))));
                        if (g == 45) throw scb(new eme(qEd((a9d(), pEe))));
                    } else j == 10 && (g = Yme(a));
                    fme(a);
                    if (c > g) throw scb(new eme(qEd((a9d(), sEe))));
                    Moe(h, c, g);
                }
            }
        }
        e = false;
    }
    if (a.c == 1) throw scb(new eme(qEd((a9d(), kEe))));
    Qoe(h);
    Noe(h);
    a.b = 0;
    fme(a);
    return h;
}
function d8b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    u = false;
    do {
        u = false;
        for(f = b ? new Ojb(a.a.b).a.gc() - 2 : 1; b ? f >= 0 : f < new Ojb(a.a.b).a.gc(); f += b ? -1 : 1){
            e = l_b(a.a, jfb(f));
            for(n = 0; n < e.b; n++){
                l = JD(fu(e, n), 9);
                if (!XMb(l, (Iqc(), jqc))) continue;
                if (m_b(a.a, jfb(f)) && a.r == (dyc(), Wxc) || n_b(a.a, jfb(f)) && a.r == (dyc(), Xxc)) continue;
                t = true;
                for(r = 0; r < e.b; r++){
                    q = JD(fu(e, r), 9);
                    XMb(q, jqc) && (b && JD(WMb(l, jqc), 17).a < JD(WMb(q, jqc), 17).a || !b && JD(WMb(l, jqc), 17).a > JD(WMb(q, jqc), 17).a) && (t = false);
                }
                if (!t) continue;
                i = b ? f + 1 : f - 1;
                h = l_b(a.a, jfb(i));
                g = false;
                s = true;
                d = false;
                for(k = Gtb(h, 0); k.b != k.d.c;){
                    j = JD(Utb(k), 9);
                    if (XMb(j, jqc)) {
                        if (j.p != l.p) {
                            g = g | (b ? JD(WMb(j, jqc), 17).a < JD(WMb(l, jqc), 17).a : JD(WMb(j, jqc), 17).a > JD(WMb(l, jqc), 17).a);
                            s = false;
                        }
                    } else if (!g && s) {
                        if (j.k == (DYb(), xYb)) {
                            d = true;
                            b ? m = JD(ds(new es(Ir(hYb(j).a.Jc(), new er))), 18).c.i : m = JD(ds(new es(Ir(kYb(j).a.Jc(), new er))), 18).d.i;
                            if (m == l) {
                                b ? c = JD(ds(new es(Ir(kYb(j).a.Jc(), new er))), 18).d.i : c = JD(ds(new es(Ir(hYb(j).a.Jc(), new er))), 18).c.i;
                                (b ? JD(k_b(a.a, c), 17).a - JD(k_b(a.a, m), 17).a : JD(k_b(a.a, m), 17).a - JD(k_b(a.a, c), 17).a) <= 2 && (s = false);
                            }
                        }
                    }
                }
                if (d && s) {
                    b ? c = JD(ds(new es(Ir(kYb(l).a.Jc(), new er))), 18).d.i : c = JD(ds(new es(Ir(hYb(l).a.Jc(), new er))), 18).c.i;
                    (b ? JD(k_b(a.a, c), 17).a - JD(k_b(a.a, l), 17).a : JD(k_b(a.a, l), 17).a - JD(k_b(a.a, c), 17).a) <= 2 && c.k == (DYb(), AYb) && (s = false);
                }
                if (g || s) {
                    p = i8b(a, l, b);
                    while(p.a.gc() != 0){
                        o = JD(p.a.ec().Jc().Pb(), 9);
                        p.a.Ac(o);
                        xe(p, i8b(a, o, b));
                    }
                    --n;
                    u = true;
                }
            }
        }
    }while (u);
}
function q6d(a) {
    Dvd(a.c, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#decimal'
    ]));
    Dvd(a.d, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#integer'
    ]));
    Dvd(a.e, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#boolean'
    ]));
    Dvd(a.f, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EBoolean',
        HDe,
        'EBoolean:Object'
    ]));
    Dvd(a.i, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#byte'
    ]));
    Dvd(a.g, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#hexBinary'
    ]));
    Dvd(a.j, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EByte',
        HDe,
        'EByte:Object'
    ]));
    Dvd(a.n, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EChar',
        HDe,
        'EChar:Object'
    ]));
    Dvd(a.t, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#double'
    ]));
    Dvd(a.u, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EDouble',
        HDe,
        'EDouble:Object'
    ]));
    Dvd(a.F, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#float'
    ]));
    Dvd(a.G, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EFloat',
        HDe,
        'EFloat:Object'
    ]));
    Dvd(a.I, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#int'
    ]));
    Dvd(a.J, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EInt',
        HDe,
        'EInt:Object'
    ]));
    Dvd(a.N, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#long'
    ]));
    Dvd(a.O, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'ELong',
        HDe,
        'ELong:Object'
    ]));
    Dvd(a.Z, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#short'
    ]));
    Dvd(a.$, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'EShort',
        HDe,
        'EShort:Object'
    ]));
    Dvd(a._, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        EFe,
        'http://www.w3.org/2001/XMLSchema#string'
    ]));
}
function FWc(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o;
    m = JD(d.a, 17).a;
    n = JD(d.b, 17).a;
    l = a.b;
    o = a.c;
    h = 0;
    k = 0;
    if (b == (Tgd(), Pgd) || b == Qgd) {
        k = Iub(PAb(GBb(FBb(new RBb(null, new Gvb(c.b, 16)), new eYc), new eXc)));
        if (l.e.b + l.f.b / 2 > k) {
            j = ++n;
            h = Beb(MD(zub(IBb(FBb(new RBb(null, new Gvb(c.b, 16)), new gYc(e, j)), new gXc))));
        } else {
            i = ++m;
            h = Beb(MD(zub(JBb(FBb(new RBb(null, new Gvb(c.b, 16)), new iYc(e, i)), new kXc))));
        }
    } else {
        k = Iub(PAb(GBb(FBb(new RBb(null, new Gvb(c.b, 16)), new AXc), new oXc)));
        if (l.e.a + l.f.a / 2 > k) {
            j = ++n;
            h = Beb(MD(zub(IBb(FBb(new RBb(null, new Gvb(c.b, 16)), new CXc(e, j)), new qXc))));
        } else {
            i = ++m;
            h = Beb(MD(zub(JBb(FBb(new RBb(null, new Gvb(c.b, 16)), new EXc(e, i)), new uXc))));
        }
    }
    if (b == Pgd) {
        Ctb(a.a, new Edd(Beb(MD(WMb(l, (tUc(), iUc)))) - e, h));
        Ctb(a.a, new Edd(o.e.a + o.f.a + e + f, h));
        Ctb(a.a, new Edd(o.e.a + o.f.a + e + f, o.e.b + o.f.b / 2));
        Ctb(a.a, new Edd(o.e.a + o.f.a, o.e.b + o.f.b / 2));
    } else if (b == Qgd) {
        Ctb(a.a, new Edd(Beb(MD(WMb(l, (tUc(), hUc)))) + e, l.e.b + l.f.b / 2));
        Ctb(a.a, new Edd(l.e.a + l.f.a + e, h));
        Ctb(a.a, new Edd(o.e.a - e - f, h));
        Ctb(a.a, new Edd(o.e.a - e - f, o.e.b + o.f.b / 2));
        Ctb(a.a, new Edd(o.e.a, o.e.b + o.f.b / 2));
    } else if (b == Sgd) {
        Ctb(a.a, new Edd(h, Beb(MD(WMb(l, (tUc(), iUc)))) - e));
        Ctb(a.a, new Edd(h, o.e.b + o.f.b + e + f));
        Ctb(a.a, new Edd(o.e.a + o.f.a / 2, o.e.b + o.f.b + e + f));
        Ctb(a.a, new Edd(o.e.a + o.f.a / 2, o.e.b + o.f.b + e));
    } else {
        a.a.b == 0 || (JD(Ftb(a.a), 8).b = Beb(MD(WMb(l, (tUc(), hUc)))) + e * JD(g.b, 17).a);
        Ctb(a.a, new Edd(h, Beb(MD(WMb(l, (tUc(), hUc)))) + e * JD(g.b, 17).a));
        Ctb(a.a, new Edd(h, o.e.b - e * JD(g.a, 17).a - f));
    }
    return new xod(jfb(m), jfb(n));
}
function Bkc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    if (Lib(a.b, b)) {
        if (Orb(JD(Nib(a.b, b), 50), c)) return 1;
    } else Qib(a.b, b, new Qrb);
    if (Lib(a.b, c)) {
        if (Orb(JD(Nib(a.b, c), 50), b)) return -1;
    } else Qib(a.b, c, new Qrb);
    if (Lib(a.f, b)) {
        if (Orb(JD(Nib(a.f, b), 50), c)) return -1;
    } else Qib(a.f, b, new Qrb);
    if (Lib(a.f, c)) {
        if (Orb(JD(Nib(a.b, c), 50), b)) return 1;
    } else Qib(a.f, c, new Qrb);
    if (a.d == (nyc(), lyc) || !XMb(b, (Iqc(), jqc)) || !XMb(c, (Iqc(), jqc))) {
        m = null;
        for(k = new rmb(b.j); k.a < k.c.c.length;){
            i = JD(pmb(k), 11);
            i.e.c.length == 0 || JD(Mlb(i.e, 0), 18).c.i.c.p == b.c.p - 1 && (m = JD(Mlb(i.e, 0), 18).c);
        }
        o = null;
        for(j = new rmb(c.j); j.a < j.c.c.length;){
            i = JD(pmb(j), 11);
            i.e.c.length == 0 || JD(Mlb(i.e, 0), 18).c.i.c.p == c.c.p - 1 && (o = JD(Mlb(i.e, 0), 18).c);
        }
        if (!!m && !!o) {
            l = m.i;
            n = o.i;
            if (!!l && l == n) {
                for(q = new rmb(l.j); q.a < q.c.c.length;){
                    p = JD(pmb(q), 11);
                    if (p == m) {
                        Ekc(a, c, b);
                        return -1;
                    } else if (p == o) {
                        Ekc(a, b, c);
                        return 1;
                    }
                }
                e = Ckc(a, b);
                g = Ckc(a, c);
                if (e > g) {
                    Ekc(a, b, c);
                    return 1;
                } else {
                    Ekc(a, c, b);
                    return -1;
                }
            }
            for(s = a.e, t = 0, u = s.length; t < u; ++t){
                r = s[t];
                if (r == l) {
                    Ekc(a, c, b);
                    return -1;
                } else if (r == n) {
                    Ekc(a, b, c);
                    return 1;
                }
            }
        }
        if (!!m && !o || !m && !!o) {
            d = Dkc(a, b, c);
            if (d != 0) {
                d > 0 ? Ekc(a, b, c) : Ekc(a, c, b);
                return d;
            }
            if (!XMb(b, (Iqc(), jqc)) || !XMb(c, jqc)) {
                f = Ckc(a, b);
                h = Ckc(a, c);
                if (f > h) {
                    Ekc(a, b, c);
                    return 1;
                } else {
                    Ekc(a, c, b);
                    return -1;
                }
            }
        }
        if (!m && !o) {
            d = Dkc(a, b, c);
            if (d != 0) {
                d > 0 ? Ekc(a, b, c) : Ekc(a, c, b);
                return d;
            }
        }
    }
    if (XMb(b, (Iqc(), jqc)) && XMb(c, jqc)) {
        f = JD(WMb(b, jqc), 17).a;
        h = JD(WMb(c, jqc), 17).a;
        if (f > h) {
            Ekc(a, b, c);
            return 1;
        } else {
            Ekc(a, c, b);
            return -1;
        }
    } else {
        Ekc(a, c, b);
        return -1;
    }
}
function VNd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    g = true;
    l = null;
    d = null;
    e = null;
    b = false;
    n = uNd;
    j = null;
    f = null;
    h = 0;
    i = NNd(a, h, sNd, tNd);
    if (i < a.length && (ADb(i, a.length), a.charCodeAt(i) == 58)) {
        l = (zDb(h, i, a.length), a.substr(h, i - h));
        h = i + 1;
    }
    c = l != null && kob(zNd, l.toLowerCase());
    if (c) {
        i = a.lastIndexOf('!/');
        if (i == -1) throw scb(new Teb('no archive separator'));
        g = true;
        d = qgb(a, h, ++i);
        h = i;
    } else if (h >= 0 && cgb(a.substr(h, 2), '//')) {
        h += 2;
        i = NNd(a, h, vNd, wNd);
        d = (zDb(h, i, a.length), a.substr(h, i - h));
        h = i;
    } else if (l != null && (h == a.length || (ADb(h, a.length), a.charCodeAt(h) != 47))) {
        g = false;
        i = igb(a, wgb(35), h);
        i == -1 && (i = a.length);
        d = (zDb(h, i, a.length), a.substr(h, i - h));
        h = i;
    }
    if (!c && h < a.length && (ADb(h, a.length), a.charCodeAt(h) == 47)) {
        i = NNd(a, h + 1, vNd, wNd);
        k = (zDb(h + 1, i, a.length), a.substr(h + 1, i - (h + 1)));
        if (k.length > 0 && _fb(k, k.length - 1) == 58) {
            e = k;
            h = i;
        }
    }
    if (h < a.length && (ADb(h, a.length), a.charCodeAt(h) == 47)) {
        ++h;
        b = true;
    }
    if (h < a.length && (ADb(h, a.length), a.charCodeAt(h) != 63) && (ADb(h, a.length), a.charCodeAt(h) != 35)) {
        m = new Ulb;
        while(h < a.length && (ADb(h, a.length), a.charCodeAt(h) != 63) && (ADb(h, a.length), a.charCodeAt(h) != 35)){
            i = NNd(a, h, vNd, wNd);
            Ilb(m, (zDb(h, i, a.length), a.substr(h, i - h)));
            h = i;
            h < a.length && (ADb(h, a.length), a.charCodeAt(h) == 47) && (WNd(a, ++h) || (m.c.push(''), undefined));
        }
        n = SC(hJ, hre, 2, m.c.length, 6, 1);
        Tlb(m, n);
    }
    if (h < a.length && (ADb(h, a.length), a.charCodeAt(h) == 63)) {
        i = ggb(a, 35, ++h);
        i == -1 && (i = a.length);
        j = (zDb(h, i, a.length), a.substr(h, i - h));
        h = i;
    }
    h < a.length && (f = pgb(a, ++h));
    bOd(g, l, d, e, n, j);
    return new GNd(g, l, d, e, b, n, j, f);
}
function ZUb() {
    ZUb = Zcb;
    JTb();
    YUb = new Pp;
    Rc(YUb, (Rjd(), Djd), Cjd);
    Rc(YUb, Njd, Cjd);
    Rc(YUb, Ejd, Cjd);
    Rc(YUb, Kjd, Cjd);
    Rc(YUb, Jjd, Cjd);
    Rc(YUb, Hjd, Cjd);
    Rc(YUb, Kjd, Djd);
    Rc(YUb, Cjd, yjd);
    Rc(YUb, Djd, yjd);
    Rc(YUb, Njd, yjd);
    Rc(YUb, Ejd, yjd);
    Rc(YUb, Ijd, yjd);
    Rc(YUb, Kjd, yjd);
    Rc(YUb, Jjd, yjd);
    Rc(YUb, Hjd, yjd);
    Rc(YUb, Bjd, yjd);
    Rc(YUb, Cjd, Ljd);
    Rc(YUb, Djd, Ljd);
    Rc(YUb, yjd, Ljd);
    Rc(YUb, Njd, Ljd);
    Rc(YUb, Ejd, Ljd);
    Rc(YUb, Ijd, Ljd);
    Rc(YUb, Kjd, Ljd);
    Rc(YUb, Bjd, Ljd);
    Rc(YUb, Mjd, Ljd);
    Rc(YUb, Jjd, Ljd);
    Rc(YUb, Fjd, Ljd);
    Rc(YUb, Hjd, Ljd);
    Rc(YUb, Djd, Njd);
    Rc(YUb, Ejd, Njd);
    Rc(YUb, Kjd, Njd);
    Rc(YUb, Hjd, Njd);
    Rc(YUb, Djd, Ejd);
    Rc(YUb, Njd, Ejd);
    Rc(YUb, Kjd, Ejd);
    Rc(YUb, Ejd, Ejd);
    Rc(YUb, Jjd, Ejd);
    Rc(YUb, Cjd, zjd);
    Rc(YUb, Djd, zjd);
    Rc(YUb, yjd, zjd);
    Rc(YUb, Ljd, zjd);
    Rc(YUb, Njd, zjd);
    Rc(YUb, Ejd, zjd);
    Rc(YUb, Ijd, zjd);
    Rc(YUb, Kjd, zjd);
    Rc(YUb, Mjd, zjd);
    Rc(YUb, Bjd, zjd);
    Rc(YUb, Hjd, zjd);
    Rc(YUb, Jjd, zjd);
    Rc(YUb, Gjd, zjd);
    Rc(YUb, Cjd, Mjd);
    Rc(YUb, Djd, Mjd);
    Rc(YUb, yjd, Mjd);
    Rc(YUb, Njd, Mjd);
    Rc(YUb, Ejd, Mjd);
    Rc(YUb, Ijd, Mjd);
    Rc(YUb, Kjd, Mjd);
    Rc(YUb, Bjd, Mjd);
    Rc(YUb, Hjd, Mjd);
    Rc(YUb, Fjd, Mjd);
    Rc(YUb, Gjd, Mjd);
    Rc(YUb, Djd, Bjd);
    Rc(YUb, Njd, Bjd);
    Rc(YUb, Ejd, Bjd);
    Rc(YUb, Kjd, Bjd);
    Rc(YUb, Mjd, Bjd);
    Rc(YUb, Hjd, Bjd);
    Rc(YUb, Jjd, Bjd);
    Rc(YUb, Cjd, Ajd);
    Rc(YUb, Djd, Ajd);
    Rc(YUb, yjd, Ajd);
    Rc(YUb, Njd, Ajd);
    Rc(YUb, Ejd, Ajd);
    Rc(YUb, Ijd, Ajd);
    Rc(YUb, Kjd, Ajd);
    Rc(YUb, Bjd, Ajd);
    Rc(YUb, Hjd, Ajd);
    Rc(YUb, Djd, Jjd);
    Rc(YUb, yjd, Jjd);
    Rc(YUb, Ljd, Jjd);
    Rc(YUb, Ejd, Jjd);
    Rc(YUb, Cjd, Fjd);
    Rc(YUb, Djd, Fjd);
    Rc(YUb, Ljd, Fjd);
    Rc(YUb, Njd, Fjd);
    Rc(YUb, Ejd, Fjd);
    Rc(YUb, Ijd, Fjd);
    Rc(YUb, Kjd, Fjd);
    Rc(YUb, Kjd, Gjd);
    Rc(YUb, Ejd, Gjd);
    Rc(YUb, Bjd, Cjd);
    Rc(YUb, Bjd, Njd);
    Rc(YUb, Bjd, yjd);
    Rc(YUb, Ijd, Cjd);
    Rc(YUb, Ijd, Djd);
    Rc(YUb, Ijd, Ljd);
}
function cLc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    c.Sg('Brandes & Koepf node placement', 1);
    a.a = b;
    a.c = lLc(b);
    d = JD(WMb(b, (Bwc(), ivc)), 279);
    n = ydb(LD(WMb(b, jvc)));
    a.d = d == (yoc(), voc) && !n || d == soc;
    bLc(a, b);
    v = null;
    w = null;
    r = null;
    s = null;
    q = (bk(4, Dre), new Vlb(4));
    switch(JD(WMb(b, ivc), 279).g){
        case 3:
            r = new vKc(b, a.c.d, (HKc(), FKc), (zKc(), xKc));
            YCb(q.c, r);
            break;
        case 1:
            s = new vKc(b, a.c.d, (HKc(), GKc), (zKc(), xKc));
            YCb(q.c, s);
            break;
        case 4:
            v = new vKc(b, a.c.d, (HKc(), FKc), (zKc(), yKc));
            YCb(q.c, v);
            break;
        case 2:
            w = new vKc(b, a.c.d, (HKc(), GKc), (zKc(), yKc));
            YCb(q.c, w);
            break;
        default:
            r = new vKc(b, a.c.d, (HKc(), FKc), (zKc(), xKc));
            s = new vKc(b, a.c.d, GKc, xKc);
            v = new vKc(b, a.c.d, FKc, yKc);
            w = new vKc(b, a.c.d, GKc, yKc);
            YCb(q.c, v);
            YCb(q.c, w);
            YCb(q.c, r);
            YCb(q.c, s);
    }
    e = new PKc(b, a.c);
    for(h = new rmb(q); h.a < h.c.c.length;){
        f = JD(pmb(h), 185);
        OKc(e, f, a.b);
        NKc(f);
    }
    m = new UKc(b, a.c);
    for(i = new rmb(q); i.a < i.c.c.length;){
        f = JD(pmb(i), 185);
        RKc(m, f);
    }
    if (c.Zg()) for(j = new rmb(q); j.a < j.c.c.length;){
        f = JD(pmb(j), 185);
        c._g(f + ' size is ' + tKc(f));
    }
    l = null;
    if (a.d) {
        k = _Kc(a, q, a.c.d);
        $Kc(b, k, c) && (l = k);
    }
    if (!l) for(j = new rmb(q); j.a < j.c.c.length;){
        f = JD(pmb(j), 185);
        $Kc(b, f, c) && (!l || tKc(l) > tKc(f)) && (l = f);
    }
    !l && (l = (sDb(0, q.c.length), JD(q.c[0], 185)));
    for(p = new rmb(b.b); p.a < p.c.c.length;){
        o = JD(pmb(p), 25);
        for(u = new rmb(o.a); u.a < u.c.c.length;){
            t = JD(pmb(u), 9);
            t.n.b = Beb(l.p[t.p]) + Beb(l.d[t.p]);
        }
    }
    if (c.Zg()) {
        c._g('Chosen node placement: ' + l);
        c._g('Blocks: ' + eLc(l));
        c._g('Classes: ' + fLc(l, c));
        c._g('Marked edges: ' + a.b);
    }
    for(g = new rmb(q); g.a < g.c.c.length;){
        f = JD(pmb(g), 185);
        f.g = null;
        f.b = null;
        f.a = null;
        f.d = null;
        f.j = null;
        f.i = null;
        f.p = null;
    }
    jLc(a.c);
    a.b.a.$b();
    c.Tg();
}
function Dkc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    if (b.k == (DYb(), yYb) && c.k == AYb) {
        f = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(b.j, 16)), new Nkc))), 11).e, 0), 18).c;
        e = f.i;
        h = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(b.j, 16)), new Pkc))), 11).g, 0), 18).d;
        g = h.i;
        d = b.c.p;
        if (e.c.p != d && g.c.p != d) return 0;
        if (e == c) {
            Ekc(a, b, c);
            return 1;
        } else {
            if (g == c) {
                Ekc(a, b, c);
                return 1;
            }
            return Bkc(a, e, c);
        }
    } else if (b.k == AYb && c.k == yYb) {
        f = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(c.j, 16)), new Nkc))), 11).e, 0), 18).c;
        e = f.i;
        h = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(c.j, 16)), new Pkc))), 11).g, 0), 18).d;
        g = h.i;
        d = b.c.p;
        if (e.c.p != d && g.c.p != d) return 0;
        if (e == b) {
            Ekc(a, c, b);
            return -1;
        } else {
            if (g == b) {
                Ekc(a, c, b);
                return -1;
            }
            return Bkc(a, b, e);
        }
    } else if (b.k == yYb && c.k == yYb) {
        m = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(b.j, 16)), new Nkc))), 11).e, 0), 18).c;
        n = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(b.j, 16)), new Pkc))), 11).g, 0), 18).d;
        o = m.i;
        p = n.i;
        i = b.c.p;
        k = false;
        l = false;
        u = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(c.j, 16)), new Nkc))), 11).e, 0), 18).c;
        v = JD(Mlb(JD(Bub(CBb(BBb(new RBb(null, new Gvb(c.j, 16)), new Pkc))), 11).g, 0), 18).d;
        w = u.i;
        A = v.i;
        q = c.c.p;
        s = false;
        t = false;
        j = b;
        r = c;
        if (o.c.p == i) {
            k = true;
            j = o;
        } else if (p.c.p == i) {
            l = true;
            j = p;
        }
        if (w.c.p == q) {
            s = true;
            r = w;
        } else if (A.c.p == q) {
            t = true;
            r = A;
        }
        if (j == r) {
            if (a.a) {
                if (k && s) {
                    D = Vkc(new Ykc(a.e, a.d, null, t), m, u);
                    if (D > 0) {
                        Ekc(a, c, b);
                        return 1;
                    } else {
                        Ekc(a, b, c);
                        return -1;
                    }
                } else if (k && t) {
                    Ekc(a, c, b);
                    return 1;
                } else if (l && s) {
                    Ekc(a, b, c);
                    return -1;
                } else if (l && t) return 0;
            } else for(C = new rmb(j.j); C.a < C.c.c.length;){
                B = JD(pmb(C), 11);
                if (m == B) {
                    Ekc(a, c, b);
                    return -1;
                } else if (u == B) {
                    Ekc(a, b, c);
                    return 1;
                }
            }
        }
        return Bkc(a, j, r);
    } else return 0;
}
function JPc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    if (a.c.length == 1) {
        FPc((sDb(0, a.c.length), JD(a.c[0], 120)));
        return sDb(0, a.c.length), JD(a.c[0], 120);
    } else if (a.c.length <= 0) return new _Qc;
    for(i = new rmb(a); i.a < i.c.c.length;){
        g = JD(pmb(i), 120);
        s = 0;
        o = Hqe;
        p = Hqe;
        m = Lre;
        n = Lre;
        for(r = Gtb(g.b, 0); r.b != r.d.c;){
            q = JD(Utb(r), 39);
            s += JD(WMb(q, (kVc(), $Uc)), 17).a;
            o = $wnd.Math.min(o, q.e.a);
            p = $wnd.Math.min(p, q.e.b);
            m = $wnd.Math.max(m, q.e.a + q.f.a);
            n = $wnd.Math.max(n, q.e.b + q.f.b);
        }
        ZMb(g, (kVc(), $Uc), jfb(s));
        ZMb(g, (tUc(), VTc), new Edd(o, p));
        ZMb(g, UTc, new Edd(m, n));
    }
    pnb();
    Slb(a, new NPc);
    v = new _Qc;
    UMb(v, (sDb(0, a.c.length), JD(a.c[0], 102)));
    l = 0;
    D = 0;
    for(j = new rmb(a); j.a < j.c.c.length;){
        g = JD(pmb(j), 120);
        w = Bdd(odd(JD(WMb(g, (tUc(), UTc)), 8)), JD(WMb(g, VTc), 8));
        l = $wnd.Math.max(l, w.a);
        D += w.a * w.b;
    }
    l = $wnd.Math.max(l, $wnd.Math.sqrt(D) * Beb(MD(WMb(v, (kVc(), HUc)))));
    A = Beb(MD(WMb(v, cVc)));
    F = 0;
    G = 0;
    k = 0;
    b = A;
    for(h = new rmb(a); h.a < h.c.c.length;){
        g = JD(pmb(h), 120);
        w = Bdd(odd(JD(WMb(g, (tUc(), UTc)), 8)), JD(WMb(g, VTc), 8));
        if (F + w.a > l) {
            F = 0;
            G += k + A;
            k = 0;
        }
        IPc(v, g, F, G);
        b = $wnd.Math.max(b, F + w.a);
        k = $wnd.Math.max(k, w.b);
        F += w.a + A;
    }
    u = new Irb;
    c = new Irb;
    for(C = new rmb(a); C.a < C.c.c.length;){
        B = JD(pmb(C), 120);
        d = ydb(LD(WMb(B, (Lgd(), Zed))));
        t = !B.q ? nnb : B.q;
        for(f = t.vc().Jc(); f.Ob();){
            e = JD(f.Pb(), 43);
            if (Lib(u, e.jd())) {
                if (XD(JD(e.jd(), 144).Qg()) !== XD(e.kd())) {
                    if (d && Lib(c, e.jd())) {
                        Zgb();
                        JD(e.jd(), 144).Ng();
                        String.fromCharCode(10);
                    } else {
                        Qib(u, JD(e.jd(), 144), e.kd());
                        ZMb(v, JD(e.jd(), 144), e.kd());
                        d && Qib(c, JD(e.jd(), 144), e.kd());
                    }
                }
            } else {
                Qib(u, JD(e.jd(), 144), e.kd());
                ZMb(v, JD(e.jd(), 144), e.kd());
            }
        }
    }
    FPc(v);
    return v;
}
function A2d(a, b) {
    switch(a.e){
        case 0:
        case 2:
        case 4:
        case 6:
        case 42:
        case 44:
        case 46:
        case 48:
        case 8:
        case 10:
        case 12:
        case 14:
        case 16:
        case 18:
        case 20:
        case 22:
        case 24:
        case 26:
        case 28:
        case 30:
        case 32:
        case 34:
        case 36:
        case 38:
            return new Nee(a.b, a.a, b, a.c);
        case 1:
            return new uVd(a.a, b, WTd(b.zh(), a.c));
        case 43:
            return new Gde(a.a, b, WTd(b.zh(), a.c));
        case 3:
            return new qVd(a.a, b, WTd(b.zh(), a.c));
        case 45:
            return new Dde(a.a, b, WTd(b.zh(), a.c));
        case 41:
            return new YQd(JD(pRd(a.c), 29), a.a, b, WTd(b.zh(), a.c));
        case 50:
            return new Xee(JD(pRd(a.c), 29), a.a, b, WTd(b.zh(), a.c));
        case 5:
            return new Jde(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 47:
            return new Nde(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 7:
            return new X0d(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 49:
            return new _0d(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 9:
            return new Bde(a.a, b, WTd(b.zh(), a.c));
        case 11:
            return new zde(a.a, b, WTd(b.zh(), a.c));
        case 13:
            return new vde(a.a, b, WTd(b.zh(), a.c));
        case 15:
            return new dbe(a.a, b, WTd(b.zh(), a.c));
        case 17:
            return new Xde(a.a, b, WTd(b.zh(), a.c));
        case 19:
            return new Ude(a.a, b, WTd(b.zh(), a.c));
        case 21:
            return new Qde(a.a, b, WTd(b.zh(), a.c));
        case 23:
            return new iVd(a.a, b, WTd(b.zh(), a.c));
        case 25:
            return new wee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 27:
            return new ree(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 29:
            return new mee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 31:
            return new gee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 33:
            return new tee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 35:
            return new oee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 37:
            return new iee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 39:
            return new bee(a.a, b, WTd(b.zh(), a.c), a.d.n);
        case 40:
            return new nce(b, WTd(b.zh(), a.c));
        default:
            throw scb(new qz('Unknown feature style: ' + a.e));
    }
}
function kYc(a) {
    var b, c, d, e, f, g, h, i;
    f = 0;
    e = a.a.b;
    for(i = Gtb(a.a, 0); i.b != i.d.c;){
        h = JD(Utb(i), 239);
        g = (f + 1) / (e + 1);
        if (!a.c && !a.d) return;
        else if (!!a.c && !a.d) {
            a.g = true;
            if (a.b == (Tgd(), Pgd)) {
                d = a.c.e.b + a.c.f.b + a.e * (f + 1);
                b = new Edd(Beb(MD(WMb(a.c, (tUc(), hUc)))) + a.e, d);
                c = new Edd(Beb(MD(WMb(a.c, iUc))) - a.e, d);
            } else if (a.b == Qgd) {
                d = a.c.e.b + a.c.f.b + a.e * (f + 1);
                b = new Edd(Beb(MD(WMb(a.c, (tUc(), iUc)))) - a.e, d);
                c = new Edd(Beb(MD(WMb(a.c, hUc))) + a.e, d);
            } else if (a.b == Sgd) {
                d = a.c.e.a + a.c.f.a + a.e * (f + 1);
                b = new Edd(d, Beb(MD(WMb(a.c, (tUc(), hUc)))) + a.e);
                c = new Edd(d, Beb(MD(WMb(a.c, iUc))) - a.e);
            } else {
                d = a.c.e.a + a.c.f.a + a.e * (f + 1);
                b = new Edd(d, Beb(MD(WMb(a.c, (tUc(), iUc)))) - a.e);
                c = new Edd(d, Beb(MD(WMb(a.c, hUc))) + a.e);
            }
        } else if (!!a.c && !!a.d) {
            if (a.b == (Tgd(), Pgd)) {
                d = a.d.e.b * g + (a.c.e.b + a.c.f.b) * (1 - g);
                b = new Edd(Beb(MD(WMb(a.c, (tUc(), hUc)))) + a.e, d);
                c = new Edd(Beb(MD(WMb(a.c, iUc))) - a.e, d);
            } else if (a.b == Qgd) {
                d = a.d.e.b * g + (a.c.e.b + a.c.f.b) * (1 - g);
                b = new Edd(Beb(MD(WMb(a.c, (tUc(), iUc)))) - a.e, d);
                c = new Edd(Beb(MD(WMb(a.c, hUc))) + a.e, d);
            } else if (a.b == Sgd) {
                d = a.d.e.a * g + (a.c.e.a + a.c.f.a) * (1 - g);
                b = new Edd(d, Beb(MD(WMb(a.c, (tUc(), hUc)))) + a.e);
                c = new Edd(d, Beb(MD(WMb(a.c, iUc))) - a.e);
            } else {
                d = a.d.e.a * g + (a.c.e.a + a.c.f.a) * (1 - g);
                b = new Edd(d, Beb(MD(WMb(a.c, (tUc(), iUc)))) - a.e);
                c = new Edd(d, Beb(MD(WMb(a.c, hUc))) + a.e);
            }
        } else {
            a.f = true;
            if (a.b == (Tgd(), Pgd)) {
                d = a.d.e.b - a.e * (f + 1);
                b = new Edd(Beb(MD(WMb(a.d, (tUc(), hUc)))) + a.e, d);
                c = new Edd(Beb(MD(WMb(a.d, iUc))) - a.e, d);
            } else if (a.b == Qgd) {
                d = a.d.e.b - a.e * (f + 1);
                b = new Edd(Beb(MD(WMb(a.d, (tUc(), iUc)))) - a.e, d);
                c = new Edd(Beb(MD(WMb(a.d, hUc))) + a.e, d);
            } else if (a.b == Sgd) {
                d = a.d.e.a - a.e * (f + 1);
                b = new Edd(d, Beb(MD(WMb(a.d, (tUc(), hUc)))) + a.e);
                c = new Edd(d, Beb(MD(WMb(a.d, iUc))) - a.e);
            } else {
                d = a.d.e.a - a.e * (f + 1);
                b = new Edd(d, Beb(MD(WMb(a.d, (tUc(), iUc)))) - a.e);
                c = new Edd(d, Beb(MD(WMb(a.d, hUc))) + a.e);
            }
        }
        JD(h.a, 8).a = b.a;
        JD(h.a, 8).b = b.b;
        h.b.a = c.a;
        h.b.b = c.b;
        ++f;
    }
}
function DA(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r;
    switch(b){
        case 71:
            h = d.q.getFullYear() - hse >= -1900 ? 1 : 0;
            c >= 4 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                jse,
                kse
            ])[h]) : Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'BC',
                'AD'
            ])[h]);
            break;
        case 121:
            sA(a, c, d);
            break;
        case 77:
            rA(a, c, d);
            break;
        case 107:
            i = e.q.getHours();
            i == 0 ? MA(a, 24, c) : MA(a, i, c);
            break;
        case 83:
            qA(a, c, e);
            break;
        case 69:
            k = d.q.getDay();
            c == 5 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'S',
                'M',
                'T',
                'W',
                'T',
                'F',
                'S'
            ])[k]) : c == 4 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                lse,
                mse,
                nse,
                ose,
                pse,
                qse,
                rse
            ])[k]) : Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ])[k]);
            break;
        case 97:
            e.q.getHours() >= 12 && e.q.getHours() < 24 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'AM',
                'PM'
            ])[1]) : Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'AM',
                'PM'
            ])[0]);
            break;
        case 104:
            l = e.q.getHours() % 12;
            l == 0 ? MA(a, 12, c) : MA(a, l, c);
            break;
        case 75:
            m = e.q.getHours() % 12;
            MA(a, m, c);
            break;
        case 72:
            n = e.q.getHours();
            MA(a, n, c);
            break;
        case 99:
            o = d.q.getDay();
            c == 5 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'S',
                'M',
                'T',
                'W',
                'T',
                'F',
                'S'
            ])[o]) : c == 4 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                lse,
                mse,
                nse,
                ose,
                pse,
                qse,
                rse
            ])[o]) : c == 3 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ])[o]) : MA(a, o, 1);
            break;
        case 76:
            p = d.q.getMonth();
            c == 5 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'J',
                'F',
                'M',
                'A',
                'M',
                'J',
                'J',
                'A',
                'S',
                'O',
                'N',
                'D'
            ])[p]) : c == 4 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                Xre,
                Yre,
                Zre,
                $re,
                _re,
                ase,
                bse,
                cse,
                dse,
                ese,
                fse,
                gse
            ])[p]) : c == 3 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                _re,
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ])[p]) : MA(a, p + 1, c);
            break;
        case 81:
            q = d.q.getMonth() / 3 | 0;
            c < 4 ? Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                'Q1',
                'Q2',
                'Q3',
                'Q4'
            ])[q]) : Qgb(a, WC(OC(hJ, 1), hre, 2, 6, [
                '1st quarter',
                '2nd quarter',
                '3rd quarter',
                '4th quarter'
            ])[q]);
            break;
        case 100:
            r = d.q.getDate();
            MA(a, r, c);
            break;
        case 109:
            j = e.q.getMinutes();
            MA(a, j, c);
            break;
        case 115:
            g = e.q.getSeconds();
            MA(a, g, c);
            break;
        case 122:
            c < 4 ? Qgb(a, f.c[0]) : Qgb(a, f.c[1]);
            break;
        case 118:
            Qgb(a, f.b);
            break;
        case 90:
            c < 3 ? Qgb(a, WA(f)) : c == 3 ? Qgb(a, VA(f)) : Qgb(a, YA(f.a));
            break;
        default:
            return false;
    }
    return true;
}
function r$b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    h$b(b);
    i = JD(nDd((!b.b && (b.b = new ree(v3, b, 4, 7)), b.b), 0), 84);
    k = JD(nDd((!b.c && (b.c = new ree(v3, b, 5, 8)), b.c), 0), 84);
    h = _Bd(i);
    j = _Bd(k);
    g = (!b.a && (b.a = new X0d(w3, b, 6, 6)), b.a).i == 0 ? null : JD(nDd((!b.a && (b.a = new X0d(w3, b, 6, 6)), b.a), 0), 168);
    A = JD(Nib(a.a, h), 9);
    F = JD(Nib(a.a, j), 9);
    B = null;
    G = null;
    if (RD(i, 193)) {
        w = JD(Nib(a.a, i), 306);
        if (RD(w, 11)) B = JD(w, 11);
        else if (RD(w, 9)) {
            A = JD(w, 9);
            B = JD(Mlb(A.j, 0), 11);
        }
    }
    if (RD(k, 193)) {
        D = JD(Nib(a.a, k), 306);
        if (RD(D, 11)) G = JD(D, 11);
        else if (RD(D, 9)) {
            F = JD(D, 9);
            G = JD(Mlb(F.j, 0), 11);
        }
    }
    if (!A || !F) throw scb(new Z8c('The source or the target of edge ' + b + ' could not be found. ' + 'This usually happens when an edge connects a node laid out by ELK Layered to a node in ' + 'another level of hierarchy laid out by either another instance of ELK Layered or another ' + 'layout algorithm alltogether. The former can be solved by setting the hierarchyHandling ' + 'option to INCLUDE_CHILDREN.'));
    p = new kWb;
    UMb(p, b);
    ZMb(p, (Iqc(), kqc), b);
    ZMb(p, (Bwc(), Ruc), null);
    n = JD(WMb(d, Wpc), 22);
    A == F && n.Ec(($oc(), Zoc));
    if (!B) {
        v = (Eyc(), Cyc);
        C = null;
        if (!!g && cjd(JD(WMb(A, Evc), 100))) {
            C = new Edd(g.j, g.k);
            nnd(C, Otd(b));
            ond(C, c);
            if (kCd(j, h)) {
                v = Byc;
                mdd(C, A.n);
            }
        }
        B = qXb(A, C, v, d);
    }
    if (!G) {
        v = (Eyc(), Byc);
        H = null;
        if (!!g && cjd(JD(WMb(F, Evc), 100))) {
            H = new Edd(g.b, g.c);
            nnd(H, Otd(b));
            ond(H, c);
        }
        G = qXb(F, H, v, gYb(F));
    }
    gWb(p, B);
    hWb(p, G);
    (B.e.c.length > 1 || B.g.c.length > 1 || G.e.c.length > 1 || G.g.c.length > 1) && n.Ec(($oc(), Uoc));
    for(m = new CHd((!b.n && (b.n = new X0d(z3, b, 1, 7)), b.n)); m.e != m.i.gc();){
        l = JD(AHd(m), 153);
        if (!ydb(LD(ksd(l, svc))) && !!l.a) {
            q = t$b(l);
            Ilb(p.b, q);
            switch(JD(WMb(q, wuc), 276).g){
                case 1:
                case 2:
                    n.Ec(($oc(), Soc));
                    break;
                case 0:
                    n.Ec(($oc(), Qoc));
                    ZMb(q, wuc, (nhd(), khd));
            }
        }
    }
    f = JD(WMb(d, ouc), 323);
    r = JD(WMb(d, nvc), 324);
    e = f == (cnc(), _mc) || r == (Mxc(), Ixc);
    if (!!g && (!g.a && (g.a = new qVd(u3, g, 5)), g.a).i != 0 && e) {
        s = and(g);
        o = new Rdd;
        for(u = Gtb(s, 0); u.b != u.d.c;){
            t = JD(Utb(u), 8);
            Atb(o, new Fdd(t));
        }
        ZMb(p, lqc, o);
    }
    return p;
}
function IWc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    C = 0;
    D = 0;
    A = new Irb;
    v = JD(zub(IBb(FBb(new RBb(null, new Gvb(a.b, 16)), new yXc), new aXc)), 17).a + 1;
    B = SC(cE, ise, 30, v, 15, 1);
    q = SC(cE, ise, 30, v, 15, 1);
    for(p = 0; p < v; p++){
        B[p] = 0;
        q[p] = 0;
    }
    i = JD(yBb(ABb(new RBb(null, new Gvb(a.a, 16))), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
        (lAb(), jAb)
    ]))), 15);
    for(k = i.Jc(); k.Ob();){
        j = JD(k.Pb(), 65);
        G = JD(WMb(j.b, (kVc(), iVc)), 17).a;
        I = JD(WMb(j.c, iVc), 17).a;
        u = I - G;
        if (u > 1) for(h = G + 1; h < I; h++){
            l = h;
            w = JD(yBb(BBb(new RBb(null, new Gvb(a.b, 16)), new SXc(l)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
                jAb
            ]))), 15);
            o = 0;
            if (b == (Tgd(), Pgd) || b == Qgd) {
                w.gd(new YXc);
                for(o = 0; o < w.gc(); o++){
                    r = (h - G) / (I - G);
                    if (JD(w.Xb(o), 39).e.b > j.b.e.b * (1 - r) + j.c.e.b * r) break;
                }
                if (w.gc() > 0) {
                    H = j.a.b == 0 ? odd(j.b.e) : JD(Ftb(j.a), 8);
                    t = mdd(odd(JD(w.Xb(w.gc() - 1), 39).e), JD(w.Xb(w.gc() - 1), 39).f);
                    m = mdd(odd(JD(w.Xb(0), 39).e), JD(w.Xb(0), 39).f);
                    if (o >= w.gc() - 1 && H.b > t.b && j.c.e.b > t.b) continue;
                    if (o <= 0 && H.b < m.a && j.c.e.b < m.b) continue;
                }
            } else {
                w.gd(new aYc);
                for(o = 0; o < w.gc(); o++){
                    r = (h - G) / (I - G);
                    if (JD(w.Xb(o), 39).e.a > j.b.e.a * (1 - r) + j.c.e.a * r) break;
                }
                if (w.gc() > 0) {
                    H = j.a.b == 0 ? odd(j.b.e) : JD(Ftb(j.a), 8);
                    t = mdd(odd(JD(w.Xb(w.gc() - 1), 39).e), JD(w.Xb(w.gc() - 1), 39).f);
                    m = mdd(odd(JD(w.Xb(0), 39).e), JD(w.Xb(0), 39).f);
                    if (o >= w.gc() - 1 && H.a > t.a && j.c.e.a > t.a) continue;
                    if (o <= 0 && H.a < m.a && j.c.e.a < m.a) continue;
                }
            }
            e = new Cdd;
            f = new Cdd;
            Atb(j.a, e);
            Atb(j.a, f);
            g = new Mod(e, f, j);
            s = Icb(Jcb(h, 32), ucb(o, Use));
            if (Lib(A, yfb(s))) {
                n = JD(Nib(A, yfb(s)), 660);
                Atb(n.a, g);
                Ugd(n.b) ? hub(n.a, new oYc) : hub(n.a, new sYc);
                kYc(n);
            } else {
                n = new lYc(o == 0 ? null : JD(w.Xb(o - 1), 39), o == w.gc() ? null : JD(w.Xb(o), 39), g, a);
                Qib(A, yfb(s), n);
            }
            if (b == Pgd || b == Qgd) {
                n.f && n.d.e.b <= Beb(MD(WMb(a, (tUc(), cUc)))) && ++C;
                n.g && n.c.e.b + n.c.f.b >= Beb(MD(WMb(a, (tUc(), bUc)))) && ++D;
            } else {
                n.f && n.d.e.a <= Beb(MD(WMb(a, (tUc(), aUc)))) && ++C;
                n.g && n.c.e.a + n.c.f.a >= Beb(MD(WMb(a, (tUc(), _Tc)))) && ++D;
            }
        }
        else if (u == 0) KWc(j);
        else if (u < 0) {
            ++B[G];
            ++q[I];
            F = FWc(j, b, a, new xod(jfb(C), jfb(D)), c, d, new xod(jfb(q[I]), jfb(B[G])));
            C = JD(F.a, 17).a;
            D = JD(F.b, 17).a;
        }
    }
}
function r6d(a) {
    if (a.gb) return;
    a.gb = true;
    a.b = Nvd(a, 0);
    Mvd(a.b, 18);
    Svd(a.b, 19);
    a.a = Nvd(a, 1);
    Mvd(a.a, 1);
    Svd(a.a, 2);
    Svd(a.a, 3);
    Svd(a.a, 4);
    Svd(a.a, 5);
    a.o = Nvd(a, 2);
    Mvd(a.o, 8);
    Mvd(a.o, 9);
    Svd(a.o, 10);
    Svd(a.o, 11);
    Svd(a.o, 12);
    Svd(a.o, 13);
    Svd(a.o, 14);
    Svd(a.o, 15);
    Svd(a.o, 16);
    Svd(a.o, 17);
    Svd(a.o, 18);
    Svd(a.o, 19);
    Svd(a.o, 20);
    Svd(a.o, 21);
    Svd(a.o, 22);
    Svd(a.o, 23);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    Rvd(a.o);
    a.p = Nvd(a, 3);
    Mvd(a.p, 2);
    Mvd(a.p, 3);
    Mvd(a.p, 4);
    Mvd(a.p, 5);
    Svd(a.p, 6);
    Svd(a.p, 7);
    Rvd(a.p);
    Rvd(a.p);
    a.q = Nvd(a, 4);
    Mvd(a.q, 8);
    a.v = Nvd(a, 5);
    Svd(a.v, 9);
    Rvd(a.v);
    Rvd(a.v);
    Rvd(a.v);
    a.w = Nvd(a, 6);
    Mvd(a.w, 2);
    Mvd(a.w, 3);
    Mvd(a.w, 4);
    Svd(a.w, 5);
    a.B = Nvd(a, 7);
    Svd(a.B, 1);
    Rvd(a.B);
    Rvd(a.B);
    Rvd(a.B);
    a.Q = Nvd(a, 8);
    Svd(a.Q, 0);
    Rvd(a.Q);
    a.R = Nvd(a, 9);
    Mvd(a.R, 1);
    a.S = Nvd(a, 10);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    Rvd(a.S);
    a.T = Nvd(a, 11);
    Svd(a.T, 10);
    Svd(a.T, 11);
    Svd(a.T, 12);
    Svd(a.T, 13);
    Svd(a.T, 14);
    Rvd(a.T);
    Rvd(a.T);
    a.U = Nvd(a, 12);
    Mvd(a.U, 2);
    Mvd(a.U, 3);
    Svd(a.U, 4);
    Svd(a.U, 5);
    Svd(a.U, 6);
    Svd(a.U, 7);
    Rvd(a.U);
    a.V = Nvd(a, 13);
    Svd(a.V, 10);
    a.W = Nvd(a, 14);
    Mvd(a.W, 18);
    Mvd(a.W, 19);
    Mvd(a.W, 20);
    Svd(a.W, 21);
    Svd(a.W, 22);
    Svd(a.W, 23);
    a.bb = Nvd(a, 15);
    Mvd(a.bb, 10);
    Mvd(a.bb, 11);
    Mvd(a.bb, 12);
    Mvd(a.bb, 13);
    Mvd(a.bb, 14);
    Mvd(a.bb, 15);
    Mvd(a.bb, 16);
    Svd(a.bb, 17);
    Rvd(a.bb);
    Rvd(a.bb);
    a.eb = Nvd(a, 16);
    Mvd(a.eb, 2);
    Mvd(a.eb, 3);
    Mvd(a.eb, 4);
    Mvd(a.eb, 5);
    Mvd(a.eb, 6);
    Mvd(a.eb, 7);
    Svd(a.eb, 8);
    Svd(a.eb, 9);
    a.ab = Nvd(a, 17);
    Mvd(a.ab, 0);
    Mvd(a.ab, 1);
    a.H = Nvd(a, 18);
    Svd(a.H, 0);
    Svd(a.H, 1);
    Svd(a.H, 2);
    Svd(a.H, 3);
    Svd(a.H, 4);
    Svd(a.H, 5);
    Rvd(a.H);
    a.db = Nvd(a, 19);
    Svd(a.db, 2);
    a.c = Ovd(a, 20);
    a.d = Ovd(a, 21);
    a.e = Ovd(a, 22);
    a.f = Ovd(a, 23);
    a.i = Ovd(a, 24);
    a.g = Ovd(a, 25);
    a.j = Ovd(a, 26);
    a.k = Ovd(a, 27);
    a.n = Ovd(a, 28);
    a.r = Ovd(a, 29);
    a.s = Ovd(a, 30);
    a.t = Ovd(a, 31);
    a.u = Ovd(a, 32);
    a.fb = Ovd(a, 33);
    a.A = Ovd(a, 34);
    a.C = Ovd(a, 35);
    a.D = Ovd(a, 36);
    a.F = Ovd(a, 37);
    a.G = Ovd(a, 38);
    a.I = Ovd(a, 39);
    a.J = Ovd(a, 40);
    a.L = Ovd(a, 41);
    a.M = Ovd(a, 42);
    a.N = Ovd(a, 43);
    a.O = Ovd(a, 44);
    a.P = Ovd(a, 45);
    a.X = Ovd(a, 46);
    a.Y = Ovd(a, 47);
    a.Z = Ovd(a, 48);
    a.$ = Ovd(a, 49);
    a._ = Ovd(a, 50);
    a.cb = Ovd(a, 51);
    a.K = Ovd(a, 52);
}
function p$b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    g = new Mtb;
    w = JD(WMb(c, (Bwc(), ruc)), 86);
    p = 0;
    xe(g, (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a));
    while(g.b != 0){
        k = JD(g.b == 0 ? null : (rDb(g.b != 0), Ktb(g, g.a.a)), 27);
        j = Zwd(k);
        (XD(ksd(j, cuc)) !== XD((nyc(), kyc)) || XD(ksd(j, puc)) === XD((znc(), ync)) || XD(ksd(j, puc)) === XD((znc(), wnc)) || ydb(LD(ksd(j, euc))) || XD(ksd(j, Ytc)) !== XD((cUb(), bUb)) || XD(ksd(j, Zuc)) === XD((dyc(), Wxc)) || XD(ksd(j, Zuc)) === XD((dyc(), Xxc)) || XD(ksd(j, $uc)) === XD((cxc(), Vwc)) || XD(ksd(j, $uc)) === XD((cxc(), Xwc))) && !ydb(LD(ksd(k, auc))) && msd(k, (Iqc(), jqc), jfb(p++));
        r = !ydb(LD(ksd(k, svc)));
        if (r) {
            m = (!k.a && (k.a = new X0d(A3, k, 10, 11)), k.a).i != 0;
            o = m$b(k);
            n = XD(ksd(k, Iuc)) === XD((eid(), bid));
            G = !lsd(k, (Lgd(), Ned)) || bgb(OD(ksd(k, Ned)));
            u = null;
            if (G && n && (m || o)) {
                u = j$b(k);
                ZMb(u, ruc, w);
                XMb(u, Svc) && Kwc(new Uwc(Beb(MD(WMb(u, Svc)))), u);
                if (JD(ksd(k, ovc), 181).gc() != 0) {
                    l = u;
                    EBb(new RBb(null, (!k.c && (k.c = new X0d(B3, k, 9, 9)), new Gvb(k.c, 16))), new G$b(l));
                    f$b(k, u);
                }
            }
            A = c;
            B = JD(Nib(a.a, Zwd(k)), 9);
            !!B && (A = B.e);
            t = u$b(a, k, A);
            if (u) {
                t.e = u;
                u.e = t;
                xe(g, (!k.a && (k.a = new X0d(A3, k, 10, 11)), k.a));
            }
        }
    }
    p = 0;
    Dtb(g, b, g.c.b, g.c);
    while(g.b != 0){
        f = JD(g.b == 0 ? null : (rDb(g.b != 0), Ktb(g, g.a.a)), 27);
        for(i = new CHd((!f.b && (f.b = new X0d(x3, f, 12, 3)), f.b)); i.e != i.i.gc();){
            h = JD(AHd(i), 85);
            h$b(h);
            (XD(ksd(b, cuc)) !== XD((nyc(), kyc)) || XD(ksd(b, puc)) === XD((znc(), ync)) || XD(ksd(b, puc)) === XD((znc(), wnc)) || ydb(LD(ksd(b, euc))) || XD(ksd(b, Ytc)) !== XD((cUb(), bUb)) || XD(ksd(b, Zuc)) === XD((dyc(), Wxc)) || XD(ksd(b, Zuc)) === XD((dyc(), Xxc)) || XD(ksd(b, $uc)) === XD((cxc(), Vwc)) || XD(ksd(b, $uc)) === XD((cxc(), Xwc))) && msd(h, (Iqc(), jqc), jfb(p++));
            D = _Bd(JD(nDd((!h.b && (h.b = new ree(v3, h, 4, 7)), h.b), 0), 84));
            F = _Bd(JD(nDd((!h.c && (h.c = new ree(v3, h, 5, 8)), h.c), 0), 84));
            if (ydb(LD(ksd(h, svc))) || ydb(LD(ksd(D, svc))) || ydb(LD(ksd(F, svc)))) continue;
            q = Std(h) && ydb(LD(ksd(D, Nuc))) && ydb(LD(ksd(h, Ouc)));
            v = f;
            q || kCd(F, D) ? v = D : kCd(D, F) && (v = F);
            A = c;
            B = JD(Nib(a.a, v), 9);
            !!B && (A = B.e);
            s = r$b(a, h, v, A);
            ZMb(s, (Iqc(), Jpc), l$b(a, h, b, c));
        }
        n = XD(ksd(f, Iuc)) === XD((eid(), bid));
        if (n) for(e = new CHd((!f.a && (f.a = new X0d(A3, f, 10, 11)), f.a)); e.e != e.i.gc();){
            d = JD(AHd(e), 27);
            G = !lsd(d, (Lgd(), Ned)) || bgb(OD(ksd(d, Ned)));
            C = XD(ksd(d, Iuc)) === XD(bid);
            G && C && Dtb(g, d, g.c.b, g.c);
        }
    }
}
function Iqc() {
    Iqc = Zcb;
    var a, b;
    kqc = new KBd(eve);
    Jpc = new KBd('coordinateOrigin');
    uqc = new KBd('processors');
    Ipc = new LBd('compoundNode', (xdb(), false));
    Zpc = new LBd('insideConnections', false);
    lqc = new KBd('originalBendpoints');
    mqc = new KBd('originalDummyNodePosition');
    nqc = new KBd('originalLabelEdge');
    wqc = new KBd('representedLabels');
    Opc = new KBd('endLabels');
    Ppc = new KBd('endLabel.origin');
    cqc = new LBd('labelSide', (oid(), nid));
    iqc = new LBd('maxEdgeThickness', 0);
    xqc = new LBd('reversed', false);
    vqc = new KBd(fve);
    fqc = new LBd('longEdgeSource', null);
    gqc = new LBd('longEdgeTarget', null);
    eqc = new LBd('longEdgeHasLabelDummies', false);
    dqc = new LBd('longEdgeBeforeLabelDummy', false);
    Npc = new LBd('edgeConstraint', (Tnc(), Rnc));
    _pc = new KBd('inLayerLayoutUnit');
    $pc = new LBd('inLayerConstraint', (qpc(), opc));
    aqc = new LBd('inLayerSuccessorConstraint', new Ulb);
    bqc = new LBd('inLayerSuccessorConstraintBetweenNonDummies', false);
    sqc = new KBd('portDummy');
    Kpc = new LBd('crossingHint', jfb(0));
    Wpc = new LBd('graphProperties', (b = JD(deb(XV), 10), new urb(b, JD(VCb(b, b.length), 10), 0)));
    Tpc = new LBd('externalPortSide', (Rjd(), Pjd));
    Upc = new LBd('externalPortSize', new Cdd);
    Rpc = new KBd('externalPortReplacedDummies');
    Spc = new KBd('externalPortReplacedDummy');
    Qpc = new LBd('externalPortConnections', (a = JD(deb(v2), 10), new urb(a, JD(VCb(a, a.length), 10), 0)));
    tqc = new LBd(jue, 0);
    Epc = new KBd('barycenterAssociates');
    Hqc = new KBd('TopSideComments');
    Fpc = new KBd('BottomSideComments');
    Hpc = new KBd('CommentConnectionPort');
    Ypc = new LBd('inputCollect', false);
    qqc = new LBd('outputCollect', false);
    Mpc = new LBd('cyclic', false);
    Lpc = new KBd('crossHierarchyMap');
    Gqc = new KBd('targetOffset');
    new LBd('splineLabelSize', new Cdd);
    Aqc = new KBd('spacings');
    rqc = new LBd('partitionConstraint', false);
    Gpc = new KBd('breakingPoint.info');
    Eqc = new KBd('splines.survivingEdge');
    Dqc = new KBd('splines.route.start');
    Bqc = new KBd('splines.edgeChain');
    pqc = new KBd('originalPortConstraints');
    zqc = new KBd('selfLoopHolder');
    Cqc = new KBd('splines.nsPortY');
    jqc = new KBd('modelOrder');
    hqc = new KBd('longEdgeTargetNode');
    Vpc = new LBd(twe, false);
    yqc = new LBd(twe, false);
    Xpc = new KBd('layerConstraints.hiddenNodes');
    oqc = new KBd('layerConstraints.opposidePort');
    Fqc = new KBd('targetNode.modelOrder');
}
function Vkc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    f = b;
    l = c;
    if (Lib(a.a, f)) {
        if (Orb(JD(Nib(a.a, f), 50), l)) return 1;
    } else Qib(a.a, f, new Qrb);
    if (Lib(a.a, l)) {
        if (Orb(JD(Nib(a.a, l), 50), f)) return -1;
    } else Qib(a.a, l, new Qrb);
    if (Lib(a.d, f)) {
        if (Orb(JD(Nib(a.d, f), 50), l)) return -1;
    } else Qib(a.d, f, new Qrb);
    if (Lib(a.d, l)) {
        if (Orb(JD(Nib(a.a, l), 50), f)) return 1;
    } else Qib(a.d, l, new Qrb);
    if (f.j != l.j) {
        u = alc(f.j, l.j);
        u > 0 ? Wkc(a, f, l, 1) : Wkc(a, l, f, 1);
        return u;
    }
    v = 1;
    if (f.e.c.length != 0 && l.e.c.length != 0) {
        (f.j == (Rjd(), Qjd) && l.j == Qjd || f.j == xjd && l.j == xjd || f.j == Ojd && l.j == Ojd) && (v = -v);
        j = JD(Mlb(f.e, 0), 18).c;
        p = JD(Mlb(l.e, 0), 18).c;
        h = j.i;
        n = p.i;
        if (h == n) for(s = new rmb(h.j); s.a < s.c.c.length;){
            r = JD(pmb(s), 11);
            if (j == r) {
                Wkc(a, l, f, v);
                return -v;
            } else if (p == r) {
                Wkc(a, f, l, v);
                return v;
            }
        }
        if (j.i.k == (DYb(), yYb) && p.i.k == yYb && h.c.p == n.c.p && h.c.p == f.i.c.p) {
            t = h.c;
            e = Tkc(t, h, n);
            if (e != 0) {
                f.j == wjd && l.j == wjd && (v = -v);
                if (e > 0) {
                    Wkc(a, f, l, v);
                    return v;
                } else {
                    Wkc(a, l, f, v);
                    return -v;
                }
            }
        }
        d = Tkc(JD(yBb(Smb(a.c), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
            (lAb(), jAb)
        ]))), 20), h, n);
        if (d != 0) {
            if (d > 0) {
                Wkc(a, f, l, v);
                return v;
            } else {
                Wkc(a, l, f, v);
                return -v;
            }
        }
        if (a.b) {
            u = Skc(f, l);
            if (u != 0) {
                if (u > 0) {
                    Wkc(a, f, l, v);
                    return v;
                } else {
                    Wkc(a, l, f, v);
                    return -v;
                }
            }
        }
    }
    if (f.g.c.length != 0 && l.g.c.length != 0) {
        (f.j == (Rjd(), Qjd) && l.j == Qjd || f.j == Ojd && l.j == Ojd) && (v = -v);
        k = JD(WMb(f, (Iqc(), hqc)), 9);
        q = JD(WMb(l, hqc), 9);
        if (a.e == (nyc(), myc) && !!k && !!q && XMb(k, jqc) && XMb(q, jqc)) {
            g = JD(WMb(k, jqc), 17).a;
            m = JD(WMb(q, jqc), 17).a;
            if (g > m) {
                Wkc(a, f, l, v);
                return v;
            } else {
                Wkc(a, l, f, v);
                return -v;
            }
        }
        if (a.b) {
            u = Skc(f, l);
            if (u != 0) {
                if (u > 0) {
                    Wkc(a, f, l, v);
                    return v;
                } else {
                    Wkc(a, l, f, v);
                    return -v;
                }
            }
        }
        i = 0;
        o = 0;
        XMb(JD(Mlb(f.g, 0), 18), jqc) && (i = JD(WMb(JD(Mlb(f.g, 0), 18), jqc), 17).a);
        XMb(JD(Mlb(l.g, 0), 18), jqc) && (o = JD(WMb(JD(Mlb(l.g, 0), 18), jqc), 17).a);
        if (!!k && k == q) {
            if (i > o) {
                Wkc(a, f, l, v);
                return v;
            } else {
                Wkc(a, l, f, v);
                return -v;
            }
        }
        if (a.f) {
            a.f._b(k) && (i = JD(a.f.xc(k), 17).a);
            a.f._b(q) && (o = JD(a.f.xc(q), 17).a);
        }
        if (i > o) {
            Wkc(a, f, l, v);
            return v;
        } else {
            Wkc(a, l, f, v);
            return -v;
        }
    }
    if (f.e.c.length != 0 && l.g.c.length != 0) {
        Wkc(a, f, l, v);
        return 1;
    } else if (f.g.c.length != 0 && l.e.c.length != 0) {
        Wkc(a, l, f, v);
        return -1;
    } else if (XMb(f, (Iqc(), jqc)) && XMb(l, jqc)) {
        g = JD(WMb(f, jqc), 17).a;
        m = JD(WMb(l, jqc), 17).a;
        (f.j == (Rjd(), Qjd) && l.j == Qjd || f.j == Ojd && l.j == Ojd) && (v = -v);
        if (g > m) {
            Wkc(a, f, l, v);
            return v;
        } else {
            Wkc(a, l, f, v);
            return -v;
        }
    } else {
        Wkc(a, l, f, v);
        return -v;
    }
}
function GWc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    for(l = Gtb(a.b, 0); l.b != l.d.c;){
        k = JD(Utb(l), 39);
        if (cgb(k.c, Dze)) continue;
        f = JD(yBb(new RBb(null, new Gvb(kQc(k, a), 16)), hAb(new zAb, new xAb, new FAb, WC(OC(HL, 1), Ere, 131, 0, [
            (lAb(), jAb)
        ]))), 15);
        b == (Tgd(), Pgd) || b == Qgd ? f.gd(new OXc) : f.gd(new UXc);
        o = f.gc();
        for(e = 0; e < o; e++){
            g = o == 1 ? 0.5 : (1 + e) / (o + 1);
            if (b == Pgd) {
                j = Beb(MD(WMb(k, (tUc(), hUc))));
                if (k.e.a + k.f.a + d < j) Ctb(JD(f.Xb(e), 65).a, new Edd(j + c, k.e.b + k.f.b * g));
                else if (JD(f.Xb(e), 65).a.b > 0) {
                    h = JD(Ftb(JD(f.Xb(e), 65).a), 8).a;
                    m = k.e.a + k.f.a / 2;
                    i = JD(Ftb(JD(f.Xb(e), 65).a), 8).b;
                    n = k.e.b + k.f.b / 2;
                    d > 0 && $wnd.Math.abs(i - n) / ($wnd.Math.abs(h - m) / 40) > 50 && (n > i ? Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a + d / 5.3, k.e.b + k.f.b * g - d / 2)) : Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a + d / 5.3, k.e.b + k.f.b * g + d / 2)));
                }
                Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a, k.e.b + k.f.b * g));
            } else if (b == Qgd) {
                j = Beb(MD(WMb(k, (tUc(), iUc))));
                if (k.e.a - d > j) Ctb(JD(f.Xb(e), 65).a, new Edd(j - c, k.e.b + k.f.b * g));
                else if (JD(f.Xb(e), 65).a.b > 0) {
                    h = JD(Ftb(JD(f.Xb(e), 65).a), 8).a;
                    m = k.e.a + k.f.a / 2;
                    i = JD(Ftb(JD(f.Xb(e), 65).a), 8).b;
                    n = k.e.b + k.f.b / 2;
                    d > 0 && $wnd.Math.abs(i - n) / ($wnd.Math.abs(h - m) / 40) > 50 && (n > i ? Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a - d / 5.3, k.e.b + k.f.b * g - d / 2)) : Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a - d / 5.3, k.e.b + k.f.b * g + d / 2)));
                }
                Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a, k.e.b + k.f.b * g));
            } else if (b == Sgd) {
                j = Beb(MD(WMb(k, (tUc(), hUc))));
                if (k.e.b + k.f.b + d < j) Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g, j + c));
                else if (JD(f.Xb(e), 65).a.b > 0) {
                    h = JD(Ftb(JD(f.Xb(e), 65).a), 8).a;
                    m = k.e.a + k.f.a / 2;
                    i = JD(Ftb(JD(f.Xb(e), 65).a), 8).b;
                    n = k.e.b + k.f.b / 2;
                    d > 0 && $wnd.Math.abs(h - m) / ($wnd.Math.abs(i - n) / 40) > 50 && (m > h ? Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g - d / 2, k.e.b + d / 5.3 + k.f.b)) : Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g + d / 2, k.e.b + d / 5.3 + k.f.b)));
                }
                Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g, k.e.b + k.f.b));
            } else {
                j = Beb(MD(WMb(k, (tUc(), iUc))));
                if (pQc(JD(f.Xb(e), 65), a)) Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g, JD(Ftb(JD(f.Xb(e), 65).a), 8).b));
                else if (k.e.b - d > j) Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g, j - c));
                else if (JD(f.Xb(e), 65).a.b > 0) {
                    h = JD(Ftb(JD(f.Xb(e), 65).a), 8).a;
                    m = k.e.a + k.f.a / 2;
                    i = JD(Ftb(JD(f.Xb(e), 65).a), 8).b;
                    n = k.e.b + k.f.b / 2;
                    d > 0 && $wnd.Math.abs(h - m) / ($wnd.Math.abs(i - n) / 40) > 50 && (m > h ? Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g - d / 2, k.e.b - d / 5.3)) : Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g + d / 2, k.e.b - d / 5.3)));
                }
                Ctb(JD(f.Xb(e), 65).a, new Edd(k.e.a + k.f.a * g, k.e.b));
            }
        }
    }
}
function Lgd() {
    Lgd = Zcb;
    var a, b;
    Ned = new KBd(LBe);
    igd = new KBd(MBe);
    Ped = (ced(), Ydd);
    Oed = new MBd(Eye, Ped);
    new Fnd;
    Qed = new MBd(Oue, null);
    Red = new KBd(NBe);
    Yed = (Hed(), nrb(Ged, WC(OC(g2, 1), Ere, 296, 0, [
        Ced
    ])));
    Xed = new MBd(Qye, Yed);
    Zed = new MBd(Dye, (xdb(), false));
    _ed = (Tgd(), Rgd);
    $ed = new MBd(Hye, _ed);
    efd = (xhd(), whd);
    dfd = new MBd(aye, efd);
    hfd = new MBd(JBe, false);
    jfd = (eid(), cid);
    ifd = new MBd(Xxe, jfd);
    Lfd = new MYb(12);
    Kfd = new MBd(Rue, Lfd);
    nfd = new MBd(Sue, false);
    ofd = new MBd(bze, false);
    Jfd = new MBd(Vue, false);
    Zfd = (ajd(), _id);
    Yfd = new MBd(Tue, Zfd);
    fgd = new KBd($ye);
    ggd = new KBd(Lue);
    hgd = new KBd(Pue);
    kgd = new KBd(Que);
    ufd = new Rdd;
    tfd = new MBd(Rye, ufd);
    Wed = new MBd(Vye, false);
    kfd = new MBd(Wye, false);
    new KBd(OBe);
    new MBd(PBe, 0);
    wfd = new ZXb;
    vfd = new MBd(_ye, wfd);
    Ifd = new MBd(Bye, false);
    new Fnd;
    jgd = new MBd(QBe, 1);
    Ved = new KBd(RBe);
    Ued = new KBd(SBe);
    Dgd = new MBd(_ue, false);
    new MBd(TBe, true);
    jfb(0);
    new MBd(UBe, jfb(100));
    new MBd(VBe, false);
    jfb(0);
    new MBd(WBe, jfb(4000));
    jfb(0);
    new MBd(XBe, jfb(400));
    new MBd(YBe, false);
    new MBd(ZBe, false);
    new MBd($Be, true);
    new MBd(_Be, false);
    Ted = (omd(), nmd);
    Sed = new MBd(KBe, Ted);
    sfd = (okd(), lkd);
    rfd = new MBd(aCe, sfd);
    qfd = (ehd(), bhd);
    pfd = new MBd(bCe, qfd);
    lgd = new MBd(oye, 10);
    mgd = new MBd(pye, 10);
    ngd = new MBd(qye, 20);
    ogd = new MBd(rye, 10);
    pgd = new MBd(Nue, 2);
    qgd = new MBd(sye, 10);
    sgd = new MBd(tye, 0);
    tgd = new MBd(wye, 5);
    ugd = new MBd(uye, 1);
    vgd = new MBd(vye, 1);
    wgd = new MBd(Mue, 20);
    xgd = new MBd(xye, 10);
    Agd = new MBd(yye, 10);
    rgd = new KBd(zye);
    zgd = new $Xb;
    ygd = new MBd(aze, zgd);
    Ofd = new KBd(Zye);
    Nfd = false;
    Mfd = new MBd(Yye, Nfd);
    yfd = new MYb(5);
    xfd = new MBd(Iye, yfd);
    Afd = (Eid(), b = JD(deb(r2), 10), new urb(b, JD(VCb(b, b.length), 10), 0));
    zfd = new MBd(Zue, Afd);
    Rfd = (Qid(), Nid);
    Qfd = new MBd(Lye, Rfd);
    Tfd = new KBd(Mye);
    Ufd = new KBd(Nye);
    Vfd = new KBd(Oye);
    Sfd = new KBd(Pye);
    Cfd = (a = JD(deb(z2), 10), new urb(a, JD(VCb(a, a.length), 10), 0));
    Bfd = new MBd(Yue, Cfd);
    Hfd = mrb((Nkd(), Gkd));
    Gfd = new MBd(Xue, Hfd);
    Ffd = new Edd(0, 0);
    Efd = new MBd(pve, Ffd);
    Dfd = new MBd(Wue, false);
    cfd = (nhd(), khd);
    bfd = new MBd(Tye, cfd);
    afd = new MBd(Uue, false);
    new KBd(cCe);
    jfb(1);
    new MBd(dCe, null);
    Wfd = new KBd(Xye);
    $fd = new KBd(Uye);
    egd = (Rjd(), Pjd);
    dgd = new MBd(Cye, egd);
    Xfd = new KBd(Aye);
    bgd = (ojd(), mrb(mjd));
    agd = new MBd($ue, bgd);
    _fd = new MBd(Jye, false);
    cgd = new MBd(Kye, true);
    new Fnd;
    Hgd = new MBd(ave, 1);
    Jgd = new MBd(eCe, null);
    Cgd = new MBd(bve, 150);
    Bgd = new MBd(cve, 1.414);
    Egd = new MBd(dve, null);
    Fgd = new MBd(fCe, 1);
    lfd = new MBd(Fye, false);
    mfd = new MBd(Gye, false);
    ffd = new MBd(Sye, 1);
    gfd = (Jhd(), Hhd);
    new MBd(gCe, gfd);
    Pfd = true;
    Igd = (Wkd(), Tkd);
    Kgd = Tkd;
    Ggd = Tkd;
}
function u5b() {
    u5b = Zcb;
    A4b = new v5b('DIRECTION_PREPROCESSOR', 0);
    x4b = new v5b('COMMENT_PREPROCESSOR', 1);
    B4b = new v5b('EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER', 2);
    R4b = new v5b('INTERACTIVE_EXTERNAL_PORT_POSITIONER', 3);
    i5b = new v5b('PARTITION_PREPROCESSOR', 4);
    V4b = new v5b('LABEL_DUMMY_INSERTER', 5);
    o5b = new v5b('SELF_LOOP_PREPROCESSOR', 6);
    $4b = new v5b('LAYER_CONSTRAINT_PREPROCESSOR', 7);
    g5b = new v5b('PARTITION_MIDPROCESSOR', 8);
    M4b = new v5b('HIGH_DEGREE_NODE_LAYER_PROCESSOR', 9);
    c5b = new v5b('NODE_PROMOTION', 10);
    Z4b = new v5b('LAYER_CONSTRAINT_POSTPROCESSOR', 11);
    h5b = new v5b('PARTITION_POSTPROCESSOR', 12);
    I4b = new v5b('HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR', 13);
    q5b = new v5b('SEMI_INTERACTIVE_CROSSMIN_PROCESSOR', 14);
    r4b = new v5b('BREAKING_POINT_INSERTER', 15);
    b5b = new v5b('LONG_EDGE_SPLITTER', 16);
    k5b = new v5b('PORT_SIDE_PROCESSOR', 17);
    S4b = new v5b('INVERTED_PORT_PROCESSOR', 18);
    j5b = new v5b('PORT_LIST_SORTER', 19);
    s5b = new v5b('SORT_BY_INPUT_ORDER_OF_MODEL', 20);
    e5b = new v5b('NORTH_SOUTH_PORT_PREPROCESSOR', 21);
    s4b = new v5b('BREAKING_POINT_PROCESSOR', 22);
    f5b = new v5b(Yve, 23);
    t5b = new v5b(Zve, 24);
    m5b = new v5b('SELF_LOOP_PORT_RESTORER', 25);
    q4b = new v5b('ALTERNATING_LAYER_UNZIPPER', 26);
    r5b = new v5b('SINGLE_EDGE_GRAPH_WRAPPER', 27);
    T4b = new v5b('IN_LAYER_CONSTRAINT_PROCESSOR', 28);
    F4b = new v5b('END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR', 29);
    U4b = new v5b('LABEL_AND_NODE_SIZE_PROCESSOR', 30);
    Q4b = new v5b('INNERMOST_NODE_MARGIN_CALCULATOR', 31);
    p5b = new v5b('SELF_LOOP_ROUTER', 32);
    v4b = new v5b('COMMENT_NODE_MARGIN_CALCULATOR', 33);
    D4b = new v5b('END_LABEL_PREPROCESSOR', 34);
    X4b = new v5b('LABEL_DUMMY_SWITCHER', 35);
    u4b = new v5b('CENTER_LABEL_MANAGEMENT_PROCESSOR', 36);
    Y4b = new v5b('LABEL_SIDE_SELECTOR', 37);
    O4b = new v5b('HYPEREDGE_DUMMY_MERGER', 38);
    J4b = new v5b('HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR', 39);
    _4b = new v5b('LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR', 40);
    L4b = new v5b('HIERARCHICAL_PORT_POSITION_PROCESSOR', 41);
    y4b = new v5b('CONSTRAINTS_POSTPROCESSOR', 42);
    w4b = new v5b('COMMENT_POSTPROCESSOR', 43);
    P4b = new v5b('HYPERNODE_PROCESSOR', 44);
    K4b = new v5b('HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER', 45);
    a5b = new v5b('LONG_EDGE_JOINER', 46);
    n5b = new v5b('SELF_LOOP_POSTPROCESSOR', 47);
    t4b = new v5b('BREAKING_POINT_REMOVER', 48);
    d5b = new v5b('NORTH_SOUTH_PORT_POSTPROCESSOR', 49);
    N4b = new v5b('HORIZONTAL_COMPACTOR', 50);
    W4b = new v5b('LABEL_DUMMY_REMOVER', 51);
    G4b = new v5b('FINAL_SPLINE_BENDPOINTS_CALCULATOR', 52);
    E4b = new v5b('END_LABEL_SORTER', 53);
    l5b = new v5b('REVERSED_EDGE_RESTORER', 54);
    C4b = new v5b('END_LABEL_POSTPROCESSOR', 55);
    H4b = new v5b('HIERARCHICAL_NODE_RESIZER', 56);
    z4b = new v5b('DIRECTION_POSTPROCESSOR', 57);
}
function lHc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab, bb, cb, db, eb, fb, gb, hb, ib, jb, kb, lb;
    cb = 0;
    for(H = b, K = 0, N = H.length; K < N; ++K){
        F = H[K];
        for(V = new rmb(F.j); V.a < V.c.c.length;){
            U = JD(pmb(V), 11);
            X = 0;
            for(h = new rmb(U.g); h.a < h.c.c.length;){
                g = JD(pmb(h), 18);
                F.c != g.d.i.c && ++X;
            }
            X > 0 && (a.a[U.p] = cb++);
        }
    }
    hb = 0;
    for(I = c, L = 0, O = I.length; L < O; ++L){
        F = I[L];
        P = 0;
        for(V = new rmb(F.j); V.a < V.c.c.length;){
            U = JD(pmb(V), 11);
            if (U.j == (Rjd(), xjd)) for(h = new rmb(U.e); h.a < h.c.c.length;){
                g = JD(pmb(h), 18);
                if (F.c != g.c.i.c) {
                    ++P;
                    break;
                }
            }
            else break;
        }
        R = 0;
        Y = new Ajb(F.j, F.j.c.length);
        while(Y.b > 0){
            U = (rDb(Y.b > 0), JD(Y.a.Xb(Y.c = --Y.b), 11));
            X = 0;
            for(h = new rmb(U.e); h.a < h.c.c.length;){
                g = JD(pmb(h), 18);
                F.c != g.c.i.c && ++X;
            }
            if (X > 0) {
                if (U.j == (Rjd(), xjd)) {
                    a.a[U.p] = hb;
                    ++hb;
                } else {
                    a.a[U.p] = hb + P + R;
                    ++R;
                }
            }
        }
        hb += R;
    }
    W = new Irb;
    o = new wtb;
    for(G = b, J = 0, M = G.length; J < M; ++J){
        F = G[J];
        for(fb = new rmb(F.j); fb.a < fb.c.c.length;){
            eb = JD(pmb(fb), 11);
            for(h = new rmb(eb.g); h.a < h.c.c.length;){
                g = JD(pmb(h), 18);
                jb = g.d;
                if (F.c != jb.i.c) {
                    db = JD(Wd(fsb(W.f, eb)), 464);
                    ib = JD(Wd(fsb(W.f, jb)), 464);
                    if (!db && !ib) {
                        n = new oHc;
                        o.a.yc(n, o);
                        Ilb(n.a, g);
                        Ilb(n.d, eb);
                        gsb(W.f, eb, n);
                        Ilb(n.d, jb);
                        gsb(W.f, jb, n);
                    } else if (!db) {
                        Ilb(ib.a, g);
                        Ilb(ib.d, eb);
                        gsb(W.f, eb, ib);
                    } else if (!ib) {
                        Ilb(db.a, g);
                        Ilb(db.d, jb);
                        gsb(W.f, jb, db);
                    } else if (db == ib) Ilb(db.a, g);
                    else {
                        Ilb(db.a, g);
                        for(T = new rmb(ib.d); T.a < T.c.c.length;){
                            S = JD(pmb(T), 11);
                            gsb(W.f, S, db);
                        }
                        Klb(db.a, ib.a);
                        Klb(db.d, ib.d);
                        o.a.Ac(ib);
                    }
                }
            }
        }
    }
    p = JD(De(o, SC(CX, {
        3: 1,
        4: 1,
        5: 1,
        1991: 1
    }, 464, o.a.gc(), 0, 1)), 1991);
    D = b[0].c;
    bb = c[0].c;
    for(k = p, l = 0, m = k.length; l < m; ++l){
        j = k[l];
        j.e = cb;
        j.f = hb;
        for(V = new rmb(j.d); V.a < V.c.c.length;){
            U = JD(pmb(V), 11);
            Z = a.a[U.p];
            if (U.i.c == D) {
                Z < j.e && (j.e = Z);
                Z > j.b && (j.b = Z);
            } else if (U.i.c == bb) {
                Z < j.f && (j.f = Z);
                Z > j.c && (j.c = Z);
            }
        }
    }
    Nmb(p, 0, p.length, null);
    gb = SC(cE, ise, 30, p.length, 15, 1);
    d = SC(cE, ise, 30, hb + 1, 15, 1);
    for(r = 0; r < p.length; r++){
        gb[r] = p[r].f;
        d[gb[r]] = 1;
    }
    f = 0;
    for(s = 0; s < d.length; s++)d[s] == 1 ? d[s] = f : --f;
    $ = 0;
    for(t = 0; t < gb.length; t++){
        gb[t] += d[gb[t]];
        $ = $wnd.Math.max($, gb[t] + 1);
    }
    i = 1;
    while(i < $)i *= 2;
    lb = 2 * i - 1;
    i -= 1;
    kb = SC(cE, ise, 30, lb, 15, 1);
    e = 0;
    for(B = 0; B < gb.length; B++){
        A = gb[B] + i;
        ++kb[A];
        while(A > 0){
            A % 2 > 0 && (e += kb[A + 1]);
            A = (A - 1) / 2 | 0;
            ++kb[A];
        }
    }
    C = SC(BX, Nqe, 367, p.length * 2, 0, 1);
    for(u = 0; u < p.length; u++){
        C[2 * u] = new rHc(p[u], p[u].e, p[u].b, (vHc(), uHc));
        C[2 * u + 1] = new rHc(p[u], p[u].b, p[u].e, tHc);
    }
    Nmb(C, 0, C.length, null);
    Q = 0;
    for(v = 0; v < C.length; v++)switch(C[v].d.g){
        case 0:
            ++Q;
            break;
        case 1:
            --Q;
            e += Q;
    }
    ab = SC(BX, Nqe, 367, p.length * 2, 0, 1);
    for(w = 0; w < p.length; w++){
        ab[2 * w] = new rHc(p[w], p[w].f, p[w].c, (vHc(), uHc));
        ab[2 * w + 1] = new rHc(p[w], p[w].c, p[w].f, tHc);
    }
    Nmb(ab, 0, ab.length, null);
    Q = 0;
    for(q = 0; q < ab.length; q++)switch(ab[q].d.g){
        case 0:
            ++Q;
            break;
        case 1:
            --Q;
            e += Q;
    }
    return e;
}
function Otc() {
    Otc = Zcb;
    Nrc = (Knc(), Inc);
    Mrc = new MBd(uwe, Nrc);
    csc = new MBd(vwe, (xdb(), false));
    isc = (ypc(), wpc);
    hsc = new MBd(wwe, isc);
    Hsc = new MBd(xwe, false);
    Isc = new MBd(ywe, true);
    arc = new MBd(zwe, false);
    atc = (vyc(), tyc);
    _sc = new MBd(Awe, atc);
    jfb(1);
    itc = new MBd(Bwe, jfb(7));
    jtc = new MBd(Cwe, false);
    dsc = new MBd(Dwe, false);
    Lrc = (znc(), vnc);
    Krc = new MBd(Ewe, Lrc);
    zsc = (cxc(), axc);
    ysc = new MBd(Fwe, zsc);
    psc = (Oqc(), Nqc);
    osc = new MBd(Gwe, psc);
    jfb(-1);
    nsc = new MBd(Hwe, null);
    jfb(-1);
    qsc = new MBd(Iwe, jfb(-1));
    jfb(-1);
    rsc = new MBd(Jwe, jfb(4));
    jfb(-1);
    tsc = new MBd(Kwe, jfb(2));
    xsc = (dyc(), byc);
    wsc = new MBd(Lwe, xsc);
    jfb(0);
    vsc = new MBd(Mwe, jfb(0));
    lsc = new MBd(Nwe, jfb(Hqe));
    Jrc = (cnc(), anc);
    Irc = new MBd(Owe, Jrc);
    qrc = new MBd(Pwe, false);
    Arc = new MBd(Qwe, 0.1);
    Grc = new MBd(Rwe, false);
    Crc = new MBd(Swe, null);
    Drc = new MBd(Twe, null);
    jfb(-1);
    Erc = new MBd(Uwe, null);
    jfb(-1);
    Frc = new MBd(Vwe, jfb(-1));
    jfb(0);
    rrc = new MBd(Wwe, jfb(40));
    yrc = (hpc(), gpc);
    xrc = new MBd(Xwe, yrc);
    urc = epc;
    trc = new MBd(Ywe, urc);
    $sc = (Mxc(), Hxc);
    Zsc = new MBd(Zwe, $sc);
    Psc = new KBd($we);
    Ksc = (moc(), koc);
    Jsc = new MBd(_we, Ksc);
    Nsc = (yoc(), voc);
    Msc = new MBd(axe, Nsc);
    new Fnd;
    Ssc = new MBd(bxe, 0.3);
    Usc = new KBd(cxe);
    Wsc = (zxc(), xxc);
    Vsc = new MBd(dxe, Wsc);
    Vrc = (Nyc(), Lyc);
    Urc = new MBd(exe, Vrc);
    Xrc = (Wyc(), Vyc);
    Wrc = new MBd(fxe, Xrc);
    Zrc = (ozc(), nzc);
    Yrc = new MBd(gxe, Zrc);
    _rc = new MBd(hxe, 0.2);
    Src = new MBd(ixe, 2);
    etc = new MBd(jxe, null);
    gtc = new MBd(kxe, 10);
    ftc = new MBd(lxe, 10);
    htc = new MBd(mxe, 20);
    jfb(0);
    btc = new MBd(nxe, jfb(0));
    jfb(0);
    ctc = new MBd(oxe, jfb(0));
    jfb(0);
    dtc = new MBd(pxe, jfb(0));
    brc = new MBd(qxe, false);
    frc = (Koc(), Ioc);
    erc = new MBd(rxe, frc);
    drc = (Vmc(), Umc);
    crc = new MBd(sxe, drc);
    fsc = new MBd(txe, false);
    jfb(0);
    esc = new MBd(uxe, jfb(16));
    jfb(0);
    gsc = new MBd(vxe, jfb(5));
    Gtc = (Gzc(), Ezc);
    Ftc = new MBd(wxe, Gtc);
    ktc = new MBd(xxe, 10);
    ntc = new MBd(yxe, 1);
    wtc = (onc(), nnc);
    vtc = new MBd(zxe, wtc);
    qtc = new KBd(Axe);
    ttc = jfb(1);
    jfb(0);
    stc = new MBd(Bxe, ttc);
    Ltc = (xzc(), uzc);
    Ktc = new MBd(Cxe, Ltc);
    Htc = new KBd(Dxe);
    Btc = new MBd(Exe, true);
    ztc = new MBd(Fxe, 2);
    Dtc = new MBd(Gxe, true);
    Gsc = (Wqc(), Vqc);
    Fsc = new MBd(Hxe, Gsc);
    Bsc = jfb(2);
    jfb(1);
    Asc = new MBd(Ixe, Bsc);
    Dsc = true;
    Csc = new MBd(Jxe, Dsc);
    Rrc = (doc(), boc);
    Qrc = new MBd(Kxe, Rrc);
    Prc = (Nmc(), Jmc);
    Orc = new MBd(Lxe, Prc);
    prc = (nyc(), kyc);
    orc = new MBd(Mxe, prc);
    nrc = new MBd(Nxe, false);
    mrc = new MBd(Oxe, false);
    hrc = (cUb(), bUb);
    grc = new MBd(Pxe, hrc);
    lrc = (oxc(), lxc);
    krc = new MBd(Qxe, lrc);
    irc = new MBd(Rxe, 0);
    jrc = new MBd(Sxe, 0);
    ksc = xnc;
    jsc = _mc;
    ssc = _wc;
    usc = _wc;
    msc = Wwc;
    Brc = (eid(), bid);
    Hrc = anc;
    zrc = anc;
    vrc = anc;
    wrc = bid;
    Qsc = Kxc;
    Rsc = Hxc;
    Lsc = Hxc;
    Osc = Hxc;
    Tsc = Jxc;
    Ysc = Kxc;
    Xsc = Kxc;
    $rc = (xhd(), vhd);
    asc = vhd;
    bsc = nzc;
    Trc = uhd;
    ltc = Fzc;
    mtc = Dzc;
    otc = Fzc;
    ptc = Dzc;
    xtc = Fzc;
    ytc = Dzc;
    rtc = mnc;
    utc = nnc;
    Mtc = Fzc;
    Ntc = Dzc;
    Itc = Fzc;
    Jtc = Dzc;
    Ctc = Dzc;
    Atc = Dzc;
    Etc = Dzc;
    Esc = Uqc;
}
function ooe() {
    ooe = Zcb;
    Zne = new poe(7);
    _ne = (++noe, new ape(8, 94));
    ++noe;
    new ape(8, 64);
    aoe = (++noe, new ape(8, 36));
    goe = (++noe, new ape(8, 65));
    hoe = (++noe, new ape(8, 122));
    ioe = (++noe, new ape(8, 90));
    loe = (++noe, new ape(8, 98));
    eoe = (++noe, new ape(8, 66));
    joe = (++noe, new ape(8, 60));
    moe = (++noe, new ape(8, 62));
    Yne = new poe(11);
    Wne = (++noe, new Soe(4));
    Moe(Wne, 48, 57);
    koe = (++noe, new Soe(4));
    Moe(koe, 48, 57);
    Moe(koe, 65, 90);
    Moe(koe, 95, 95);
    Moe(koe, 97, 122);
    foe = (++noe, new Soe(4));
    Moe(foe, 9, 9);
    Moe(foe, 10, 10);
    Moe(foe, 12, 12);
    Moe(foe, 13, 13);
    Moe(foe, 32, 32);
    boe = Toe(Wne);
    doe = Toe(koe);
    coe = Toe(foe);
    Rne = new Irb;
    Sne = new Irb;
    Tne = WC(OC(hJ, 1), hre, 2, 6, [
        'Cn',
        'Lu',
        'Ll',
        'Lt',
        'Lm',
        'Lo',
        'Mn',
        'Me',
        'Mc',
        'Nd',
        'Nl',
        'No',
        'Zs',
        'Zl',
        'Zp',
        'Cc',
        'Cf',
        null,
        'Co',
        'Cs',
        'Pd',
        'Ps',
        'Pe',
        'Pc',
        'Po',
        'Sm',
        'Sc',
        'Sk',
        'So',
        'Pi',
        'Pf',
        'L',
        'M',
        'N',
        'Z',
        'C',
        'P',
        'S'
    ]);
    Qne = WC(OC(hJ, 1), hre, 2, 6, [
        'Basic Latin',
        'Latin-1 Supplement',
        'Latin Extended-A',
        'Latin Extended-B',
        'IPA Extensions',
        'Spacing Modifier Letters',
        'Combining Diacritical Marks',
        'Greek',
        'Cyrillic',
        'Armenian',
        'Hebrew',
        'Arabic',
        'Syriac',
        'Thaana',
        'Devanagari',
        'Bengali',
        'Gurmukhi',
        'Gujarati',
        'Oriya',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhala',
        'Thai',
        'Lao',
        'Tibetan',
        'Myanmar',
        'Georgian',
        'Hangul Jamo',
        'Ethiopic',
        'Cherokee',
        'Unified Canadian Aboriginal Syllabics',
        'Ogham',
        'Runic',
        'Khmer',
        'Mongolian',
        'Latin Extended Additional',
        'Greek Extended',
        'General Punctuation',
        'Superscripts and Subscripts',
        'Currency Symbols',
        'Combining Marks for Symbols',
        'Letterlike Symbols',
        'Number Forms',
        'Arrows',
        'Mathematical Operators',
        'Miscellaneous Technical',
        'Control Pictures',
        'Optical Character Recognition',
        'Enclosed Alphanumerics',
        'Box Drawing',
        'Block Elements',
        'Geometric Shapes',
        'Miscellaneous Symbols',
        'Dingbats',
        'Braille Patterns',
        'CJK Radicals Supplement',
        'Kangxi Radicals',
        'Ideographic Description Characters',
        'CJK Symbols and Punctuation',
        'Hiragana',
        'Katakana',
        'Bopomofo',
        'Hangul Compatibility Jamo',
        'Kanbun',
        'Bopomofo Extended',
        'Enclosed CJK Letters and Months',
        'CJK Compatibility',
        'CJK Unified Ideographs Extension A',
        'CJK Unified Ideographs',
        'Yi Syllables',
        'Yi Radicals',
        'Hangul Syllables',
        WGe,
        'CJK Compatibility Ideographs',
        'Alphabetic Presentation Forms',
        'Arabic Presentation Forms-A',
        'Combining Half Marks',
        'CJK Compatibility Forms',
        'Small Form Variants',
        'Arabic Presentation Forms-B',
        'Specials',
        'Halfwidth and Fullwidth Forms',
        'Old Italic',
        'Gothic',
        'Deseret',
        'Byzantine Musical Symbols',
        'Musical Symbols',
        'Mathematical Alphanumeric Symbols',
        'CJK Unified Ideographs Extension B',
        'CJK Compatibility Ideographs Supplement',
        'Tags'
    ]);
    Une = WC(OC(cE, 1), ise, 30, 15, [
        66304,
        66351,
        66352,
        66383,
        66560,
        66639,
        118784,
        119039,
        119040,
        119295,
        119808,
        120831,
        131072,
        173782,
        194560,
        195103,
        917504,
        917631
    ]);
}
function sJb() {
    sJb = Zcb;
    pJb = new vJb('OUT_T_L', 0, (PHb(), NHb), (GIb(), DIb), (iHb(), fHb), fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb((Eid(), Aid), WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            wid
        ]))
    ]));
    oJb = new vJb('OUT_T_C', 1, MHb, DIb, fHb, gHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            vid
        ])),
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            vid,
            xid
        ]))
    ]));
    qJb = new vJb('OUT_T_R', 2, OHb, DIb, fHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            yid
        ]))
    ]));
    gJb = new vJb('OUT_B_L', 3, NHb, FIb, hHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            wid
        ]))
    ]));
    fJb = new vJb('OUT_B_C', 4, MHb, FIb, hHb, gHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            vid
        ])),
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            vid,
            xid
        ]))
    ]));
    hJb = new vJb('OUT_B_R', 5, OHb, FIb, hHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            yid
        ]))
    ]));
    kJb = new vJb('OUT_L_T', 6, OHb, FIb, fHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            wid,
            Did,
            xid
        ]))
    ]));
    jJb = new vJb('OUT_L_C', 7, OHb, EIb, gHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            wid,
            Cid
        ])),
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            wid,
            Cid,
            xid
        ]))
    ]));
    iJb = new vJb('OUT_L_B', 8, OHb, DIb, hHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            wid,
            Bid,
            xid
        ]))
    ]));
    nJb = new vJb('OUT_R_T', 9, NHb, FIb, fHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            yid,
            Did,
            xid
        ]))
    ]));
    mJb = new vJb('OUT_R_C', 10, NHb, EIb, gHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            yid,
            Cid
        ])),
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            yid,
            Cid,
            xid
        ]))
    ]));
    lJb = new vJb('OUT_R_B', 11, NHb, DIb, hHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(Aid, WC(OC(r2, 1), Ere, 94, 0, [
            yid,
            Bid,
            xid
        ]))
    ]));
    dJb = new vJb('IN_T_L', 12, NHb, FIb, fHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            wid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            wid,
            xid
        ]))
    ]));
    cJb = new vJb('IN_T_C', 13, MHb, FIb, fHb, gHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            vid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            vid,
            xid
        ]))
    ]));
    eJb = new vJb('IN_T_R', 14, OHb, FIb, fHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            yid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Did,
            yid,
            xid
        ]))
    ]));
    aJb = new vJb('IN_C_L', 15, NHb, EIb, gHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Cid,
            wid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Cid,
            wid,
            xid
        ]))
    ]));
    _Ib = new vJb('IN_C_C', 16, MHb, EIb, gHb, gHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Cid,
            vid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Cid,
            vid,
            xid
        ]))
    ]));
    bJb = new vJb('IN_C_R', 17, OHb, EIb, gHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Cid,
            yid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Cid,
            yid,
            xid
        ]))
    ]));
    ZIb = new vJb('IN_B_L', 18, NHb, DIb, hHb, fHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            wid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            wid,
            xid
        ]))
    ]));
    YIb = new vJb('IN_B_C', 19, MHb, DIb, hHb, gHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            vid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            vid,
            xid
        ]))
    ]));
    $Ib = new vJb('IN_B_R', 20, OHb, DIb, hHb, hHb, WC(OC(UK, 1), Nqe, 22, 0, [
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            yid
        ])),
        nrb(zid, WC(OC(r2, 1), Ere, 94, 0, [
            Bid,
            yid,
            xid
        ]))
    ]));
    rJb = new vJb(eue, 21, null, null, null, null, WC(OC(UK, 1), Nqe, 22, 0, []));
}
function cPd() {
    cPd = Zcb;
    IOd = (GOd(), FOd).b;
    JD(nDd(STd(FOd.b), 0), 35);
    JD(nDd(STd(FOd.b), 1), 19);
    HOd = FOd.a;
    JD(nDd(STd(FOd.a), 0), 35);
    JD(nDd(STd(FOd.a), 1), 19);
    JD(nDd(STd(FOd.a), 2), 19);
    JD(nDd(STd(FOd.a), 3), 19);
    JD(nDd(STd(FOd.a), 4), 19);
    JOd = FOd.o;
    JD(nDd(STd(FOd.o), 0), 35);
    JD(nDd(STd(FOd.o), 1), 35);
    LOd = JD(nDd(STd(FOd.o), 2), 19);
    JD(nDd(STd(FOd.o), 3), 19);
    JD(nDd(STd(FOd.o), 4), 19);
    JD(nDd(STd(FOd.o), 5), 19);
    JD(nDd(STd(FOd.o), 6), 19);
    JD(nDd(STd(FOd.o), 7), 19);
    JD(nDd(STd(FOd.o), 8), 19);
    JD(nDd(STd(FOd.o), 9), 19);
    JD(nDd(STd(FOd.o), 10), 19);
    JD(nDd(STd(FOd.o), 11), 19);
    JD(nDd(STd(FOd.o), 12), 19);
    JD(nDd(STd(FOd.o), 13), 19);
    JD(nDd(STd(FOd.o), 14), 19);
    JD(nDd(STd(FOd.o), 15), 19);
    JD(nDd(PTd(FOd.o), 0), 62);
    JD(nDd(PTd(FOd.o), 1), 62);
    JD(nDd(PTd(FOd.o), 2), 62);
    JD(nDd(PTd(FOd.o), 3), 62);
    JD(nDd(PTd(FOd.o), 4), 62);
    JD(nDd(PTd(FOd.o), 5), 62);
    JD(nDd(PTd(FOd.o), 6), 62);
    JD(nDd(PTd(FOd.o), 7), 62);
    JD(nDd(PTd(FOd.o), 8), 62);
    JD(nDd(PTd(FOd.o), 9), 62);
    KOd = FOd.p;
    JD(nDd(STd(FOd.p), 0), 35);
    JD(nDd(STd(FOd.p), 1), 35);
    JD(nDd(STd(FOd.p), 2), 35);
    JD(nDd(STd(FOd.p), 3), 35);
    JD(nDd(STd(FOd.p), 4), 19);
    JD(nDd(STd(FOd.p), 5), 19);
    JD(nDd(PTd(FOd.p), 0), 62);
    JD(nDd(PTd(FOd.p), 1), 62);
    MOd = FOd.q;
    JD(nDd(STd(FOd.q), 0), 35);
    NOd = FOd.v;
    JD(nDd(STd(FOd.v), 0), 19);
    JD(nDd(PTd(FOd.v), 0), 62);
    JD(nDd(PTd(FOd.v), 1), 62);
    JD(nDd(PTd(FOd.v), 2), 62);
    OOd = FOd.w;
    JD(nDd(STd(FOd.w), 0), 35);
    JD(nDd(STd(FOd.w), 1), 35);
    JD(nDd(STd(FOd.w), 2), 35);
    JD(nDd(STd(FOd.w), 3), 19);
    POd = FOd.B;
    JD(nDd(STd(FOd.B), 0), 19);
    JD(nDd(PTd(FOd.B), 0), 62);
    JD(nDd(PTd(FOd.B), 1), 62);
    JD(nDd(PTd(FOd.B), 2), 62);
    SOd = FOd.Q;
    JD(nDd(STd(FOd.Q), 0), 19);
    JD(nDd(PTd(FOd.Q), 0), 62);
    TOd = FOd.R;
    JD(nDd(STd(FOd.R), 0), 35);
    UOd = FOd.S;
    JD(nDd(PTd(FOd.S), 0), 62);
    JD(nDd(PTd(FOd.S), 1), 62);
    JD(nDd(PTd(FOd.S), 2), 62);
    JD(nDd(PTd(FOd.S), 3), 62);
    JD(nDd(PTd(FOd.S), 4), 62);
    JD(nDd(PTd(FOd.S), 5), 62);
    JD(nDd(PTd(FOd.S), 6), 62);
    JD(nDd(PTd(FOd.S), 7), 62);
    JD(nDd(PTd(FOd.S), 8), 62);
    JD(nDd(PTd(FOd.S), 9), 62);
    JD(nDd(PTd(FOd.S), 10), 62);
    JD(nDd(PTd(FOd.S), 11), 62);
    JD(nDd(PTd(FOd.S), 12), 62);
    JD(nDd(PTd(FOd.S), 13), 62);
    JD(nDd(PTd(FOd.S), 14), 62);
    VOd = FOd.T;
    JD(nDd(STd(FOd.T), 0), 19);
    JD(nDd(STd(FOd.T), 2), 19);
    WOd = JD(nDd(STd(FOd.T), 3), 19);
    JD(nDd(STd(FOd.T), 4), 19);
    JD(nDd(PTd(FOd.T), 0), 62);
    JD(nDd(PTd(FOd.T), 1), 62);
    JD(nDd(STd(FOd.T), 1), 19);
    XOd = FOd.U;
    JD(nDd(STd(FOd.U), 0), 35);
    JD(nDd(STd(FOd.U), 1), 35);
    JD(nDd(STd(FOd.U), 2), 19);
    JD(nDd(STd(FOd.U), 3), 19);
    JD(nDd(STd(FOd.U), 4), 19);
    JD(nDd(STd(FOd.U), 5), 19);
    JD(nDd(PTd(FOd.U), 0), 62);
    YOd = FOd.V;
    JD(nDd(STd(FOd.V), 0), 19);
    ZOd = FOd.W;
    JD(nDd(STd(FOd.W), 0), 35);
    JD(nDd(STd(FOd.W), 1), 35);
    JD(nDd(STd(FOd.W), 2), 35);
    JD(nDd(STd(FOd.W), 3), 19);
    JD(nDd(STd(FOd.W), 4), 19);
    JD(nDd(STd(FOd.W), 5), 19);
    _Od = FOd.bb;
    JD(nDd(STd(FOd.bb), 0), 35);
    JD(nDd(STd(FOd.bb), 1), 35);
    JD(nDd(STd(FOd.bb), 2), 35);
    JD(nDd(STd(FOd.bb), 3), 35);
    JD(nDd(STd(FOd.bb), 4), 35);
    JD(nDd(STd(FOd.bb), 5), 35);
    JD(nDd(STd(FOd.bb), 6), 35);
    JD(nDd(STd(FOd.bb), 7), 19);
    JD(nDd(PTd(FOd.bb), 0), 62);
    JD(nDd(PTd(FOd.bb), 1), 62);
    aPd = FOd.eb;
    JD(nDd(STd(FOd.eb), 0), 35);
    JD(nDd(STd(FOd.eb), 1), 35);
    JD(nDd(STd(FOd.eb), 2), 35);
    JD(nDd(STd(FOd.eb), 3), 35);
    JD(nDd(STd(FOd.eb), 4), 35);
    JD(nDd(STd(FOd.eb), 5), 35);
    JD(nDd(STd(FOd.eb), 6), 19);
    JD(nDd(STd(FOd.eb), 7), 19);
    $Od = FOd.ab;
    JD(nDd(STd(FOd.ab), 0), 35);
    JD(nDd(STd(FOd.ab), 1), 35);
    QOd = FOd.H;
    JD(nDd(STd(FOd.H), 0), 19);
    JD(nDd(STd(FOd.H), 1), 19);
    JD(nDd(STd(FOd.H), 2), 19);
    JD(nDd(STd(FOd.H), 3), 19);
    JD(nDd(STd(FOd.H), 4), 19);
    JD(nDd(STd(FOd.H), 5), 19);
    JD(nDd(PTd(FOd.H), 0), 62);
    bPd = FOd.db;
    JD(nDd(STd(FOd.db), 0), 19);
    ROd = FOd.M;
}
function Vie(a) {
    var b;
    if (a.O) return;
    a.O = true;
    rvd(a, 'type');
    ewd(a, 'ecore.xml.type');
    fwd(a, eGe);
    b = JD(g1d((rOd(), qOd), eGe), 1990);
    tCd(UTd(a.fb), a.b);
    Zvd(a.b, Nab, 'AnyType', false, false, true);
    Xvd(JD(nDd(STd(a.b), 0), 35), a.wb.D, qFe, null, 0, -1, Nab, false, false, true, false, false, false);
    Xvd(JD(nDd(STd(a.b), 1), 35), a.wb.D, 'any', null, 0, -1, Nab, true, true, true, false, false, true);
    Xvd(JD(nDd(STd(a.b), 2), 35), a.wb.D, 'anyAttribute', null, 0, -1, Nab, false, false, true, false, false, false);
    Zvd(a.bb, Pab, jGe, false, false, true);
    Xvd(JD(nDd(STd(a.bb), 0), 35), a.gb, 'data', null, 0, 1, Pab, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.bb), 1), 35), a.gb, DDe, null, 1, 1, Pab, false, false, true, false, true, false);
    Zvd(a.fb, Qab, kGe, false, false, true);
    Xvd(JD(nDd(STd(a.fb), 0), 35), b.gb, 'rawValue', null, 0, 1, Qab, true, true, true, false, true, true);
    Xvd(JD(nDd(STd(a.fb), 1), 35), b.a, bDe, null, 0, 1, Qab, true, true, true, false, true, true);
    bwd(JD(nDd(STd(a.fb), 2), 19), a.wb.q, null, 'instanceType', 1, 1, Qab, false, false, true, false, false, false, false);
    Zvd(a.qb, Rab, lGe, false, false, true);
    Xvd(JD(nDd(STd(a.qb), 0), 35), a.wb.D, qFe, null, 0, -1, null, false, false, true, false, false, false);
    bwd(JD(nDd(STd(a.qb), 1), 19), a.wb.ab, null, 'xMLNSPrefixMap', 0, -1, null, true, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.qb), 2), 19), a.wb.ab, null, 'xSISchemaLocation', 0, -1, null, true, false, true, true, false, false, false);
    Xvd(JD(nDd(STd(a.qb), 3), 35), a.gb, 'cDATA', null, 0, -2, null, true, true, true, false, false, true);
    Xvd(JD(nDd(STd(a.qb), 4), 35), a.gb, 'comment', null, 0, -2, null, true, true, true, false, false, true);
    bwd(JD(nDd(STd(a.qb), 5), 19), a.bb, null, LGe, 0, -2, null, true, true, true, true, false, false, true);
    Xvd(JD(nDd(STd(a.qb), 6), 35), a.gb, iDe, null, 0, -2, null, true, true, true, false, false, true);
    _vd(a.a, aJ, 'AnySimpleType', true);
    _vd(a.c, hJ, 'AnyURI', true);
    _vd(a.d, OC($D, 1), 'Base64Binary', true);
    _vd(a.e, pcb, 'Boolean', true);
    _vd(a.f, GI, 'BooleanObject', true);
    _vd(a.g, $D, 'Byte', true);
    _vd(a.i, HI, 'ByteObject', true);
    _vd(a.j, hJ, 'Date', true);
    _vd(a.k, hJ, 'DateTime', true);
    _vd(a.n, kJ, 'Decimal', true);
    _vd(a.o, aE, 'Double', true);
    _vd(a.p, LI, 'DoubleObject', true);
    _vd(a.q, hJ, 'Duration', true);
    _vd(a.s, HK, 'ENTITIES', true);
    _vd(a.r, HK, 'ENTITIESBase', true);
    _vd(a.t, hJ, rGe, true);
    _vd(a.u, bE, 'Float', true);
    _vd(a.v, QI, 'FloatObject', true);
    _vd(a.w, hJ, 'GDay', true);
    _vd(a.B, hJ, 'GMonth', true);
    _vd(a.A, hJ, 'GMonthDay', true);
    _vd(a.C, hJ, 'GYear', true);
    _vd(a.D, hJ, 'GYearMonth', true);
    _vd(a.F, OC($D, 1), 'HexBinary', true);
    _vd(a.G, hJ, 'ID', true);
    _vd(a.H, hJ, 'IDREF', true);
    _vd(a.J, HK, 'IDREFS', true);
    _vd(a.I, HK, 'IDREFSBase', true);
    _vd(a.K, cE, 'Int', true);
    _vd(a.M, lJ, 'Integer', true);
    _vd(a.L, UI, 'IntObject', true);
    _vd(a.P, hJ, 'Language', true);
    _vd(a.Q, dE, 'Long', true);
    _vd(a.R, XI, 'LongObject', true);
    _vd(a.S, hJ, 'Name', true);
    _vd(a.T, hJ, sGe, true);
    _vd(a.U, lJ, 'NegativeInteger', true);
    _vd(a.V, hJ, CGe, true);
    _vd(a.X, HK, 'NMTOKENS', true);
    _vd(a.W, HK, 'NMTOKENSBase', true);
    _vd(a.Y, lJ, 'NonNegativeInteger', true);
    _vd(a.Z, lJ, 'NonPositiveInteger', true);
    _vd(a.$, hJ, 'NormalizedString', true);
    _vd(a._, hJ, 'NOTATION', true);
    _vd(a.ab, hJ, 'PositiveInteger', true);
    _vd(a.cb, hJ, 'QName', true);
    _vd(a.db, ocb, 'Short', true);
    _vd(a.eb, cJ, 'ShortObject', true);
    _vd(a.gb, hJ, Pre, true);
    _vd(a.hb, hJ, 'Time', true);
    _vd(a.ib, hJ, 'Token', true);
    _vd(a.jb, ocb, 'UnsignedByte', true);
    _vd(a.kb, cJ, 'UnsignedByteObject', true);
    _vd(a.lb, dE, 'UnsignedInt', true);
    _vd(a.mb, XI, 'UnsignedIntObject', true);
    _vd(a.nb, lJ, 'UnsignedLong', true);
    _vd(a.ob, cE, 'UnsignedShort', true);
    _vd(a.pb, UI, 'UnsignedShortObject', true);
    Tvd(a, eGe);
    Tie(a);
}
function U8c(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab, bb;
    if (d.Yg()) return pnb(), pnb(), mnb;
    if (ydb(LD(ksd(b, (Lgd(), Ifd))))) return pnb(), pnb(), mnb;
    A = (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i != 0;
    C = S8c(b);
    B = !C.dc();
    if (A || B) {
        e = JD(ksd(b, igd), 149);
        if (!e) throw scb(new Y8c('Resolved algorithm is not set; apply a LayoutAlgorithmResolver before computing layout.'));
        Z = bad(e, (BBd(), xBd));
        Q8c(b);
        if (!A && B && !Z) return pnb(), pnb(), mnb;
        t = new Ulb;
        if (XD(ksd(b, ifd)) === XD((eid(), bid)) && (bad(e, uBd) || bad(e, tBd))) {
            if (ydb(LD(ksd(b, Dgd)))) throw scb(new Y8c('Topdown layout cannot be used together with hierarchy handling.'));
            M = P8c(a, b);
            N = new Mtb;
            xe(N, (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a));
            while(N.b != 0){
                K = JD(N.b == 0 ? null : (rDb(N.b != 0), Ktb(N, N.a.a)), 27);
                Q8c(K);
                Y = XD(ksd(K, ifd)) === XD(did);
                if (Y || lsd(K, Ned) && !aad(e, ksd(K, igd))) {
                    q = U8c(a, K, c, d);
                    Klb(t, q);
                    msd(K, ifd, did);
                    Umd(K);
                } else xe(N, (!K.a && (K.a = new X0d(A3, K, 10, 11)), K.a));
            }
        } else {
            M = (!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a).i;
            if (ydb(LD(ksd(b, Dgd)))) {
                $ = d.bh(1);
                $.Sg(vBe, 1);
                if (ksd(b, Egd) == null) throw scb(new Y8c(b.k + ' has not been assigned a top-down node type.'));
                if (JD(ksd(b, Egd), 278) == (Wkd(), Tkd) || JD(ksd(b, Egd), 278) == Vkd) for(s = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); s.e != s.i.gc();){
                    r = JD(AHd(s), 27);
                    J = JD(ksd(r, igd), 149);
                    (!r.a && (r.a = new X0d(A3, r, 10, 11)), r.a).i > 0 && Vnd(J.f);
                    if (ksd(r, Jgd) != null) {
                        h = JD(ksd(r, Jgd), 343);
                        X = h.Rg(r);
                        P = JD(ksd(r, Kfd), 107);
                        dtd(r, $wnd.Math.max(r.g, X.a + P.b + P.c), $wnd.Math.max(r.f, X.b + P.d + P.a));
                    } else (!r.a && (r.a = new X0d(A3, r, 10, 11)), r.a).i != 0 && dtd(r, Beb(MD(ksd(r, Cgd))), Beb(MD(ksd(r, Cgd))) / Beb(MD(ksd(r, Bgd))));
                }
                O = JD(ksd(b, Kfd), 107);
                n = b.g - (O.b + O.c);
                m = b.f - (O.d + O.a);
                $._g('Available Child Area: (' + n + '|' + m + ')');
                msd(b, Qed, n / m);
                R8c(b, e, d.bh(M));
                if (JD(ksd(b, Egd), 278) == Vkd) {
                    Zmd(b);
                    dtd(b, O.b + Beb(MD(ksd(b, Ved))) + O.c, O.d + Beb(MD(ksd(b, Ued))) + O.a);
                }
                $._g('Executed layout algorithm: ' + OD(ksd(b, Ned)) + ' on node ' + b.k);
                if (JD(ksd(b, Egd), 278) == Tkd) {
                    if (n < 0 || m < 0) throw scb(new Y8c('The size defined by the parent parallel node is too small for the space provided by the paddings of the child hierarchical node. ' + b.k));
                    lsd(b, Ved) || lsd(b, Ued) || Zmd(b);
                    p = Beb(MD(ksd(b, Ved)));
                    o = Beb(MD(ksd(b, Ued)));
                    $._g('Desired Child Area: (' + p + '|' + o + ')');
                    R = n / p;
                    S = m / o;
                    Q = $wnd.Math.min(R, $wnd.Math.min(S, Beb(MD(ksd(b, Fgd)))));
                    msd(b, Hgd, Q);
                    $._g(b.k + ' -- Local Scale Factor (X|Y): (' + R + '|' + S + ')');
                    u = JD(ksd(b, Xed), 22);
                    f = 0;
                    g = 0;
                    Q < R && (u.Gc((Hed(), Bed)) ? f = (n / 2 - p * Q / 2) / Q : u.Gc(Ded) && (f = (n - p * Q) / Q));
                    Q < S && (u.Gc((Hed(), Fed)) ? g = (m / 2 - o * Q / 2) / Q : u.Gc(Eed) && (g = (m - o * Q) / Q));
                    ab = f + (O.b / Q - O.b);
                    bb = g + (O.d / Q - O.d);
                    $._g('Shift: (' + ab + '|' + bb + ')');
                    for(L = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); L.e != L.i.gc();){
                        K = JD(AHd(L), 27);
                        htd(K, K.i + ab);
                        itd(K, K.j + bb);
                    }
                    for(w = new CHd((!b.b && (b.b = new X0d(x3, b, 12, 3)), b.b)); w.e != w.i.gc();){
                        v = JD(AHd(w), 85);
                        for(U = new CHd((!v.a && (v.a = new X0d(w3, v, 6, 6)), v.a)); U.e != U.i.gc();){
                            T = JD(AHd(U), 168);
                            pud(T, T.j + ab, T.k + bb);
                            iud(T, T.b + ab, T.c + bb);
                            for(j = new CHd((!T.a && (T.a = new qVd(u3, T, 5)), T.a)); j.e != j.i.gc();){
                                i = JD(AHd(j), 369);
                                ysd(i, i.a + ab, i.b + bb);
                            }
                        }
                        for(I = new CHd((!v.n && (v.n = new X0d(z3, v, 1, 7)), v.n)); I.e != I.i.gc();){
                            H = JD(AHd(I), 153);
                            ftd(H, H.i + ab, H.j + bb);
                        }
                        G = JD(ksd(v, tfd), 77);
                        for(F = Gtb(G, 0); F.b != F.d.c;){
                            D = JD(Utb(F), 8);
                            D.a += ab;
                            D.b += bb;
                        }
                        msd(v, tfd, G);
                    }
                }
                $.Tg();
            }
            for(l = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); l.e != l.i.gc();){
                k = JD(AHd(l), 27);
                q = U8c(a, k, c, d);
                Klb(t, q);
                Umd(k);
            }
        }
        if (d.Yg()) return pnb(), pnb(), mnb;
        for(W = new rmb(t); W.a < W.c.c.length;){
            V = JD(pmb(W), 85);
            msd(V, Ifd, (xdb(), true));
        }
        ydb(LD(ksd(b, Dgd))) || R8c(b, e, d.bh(M));
        V8c(t);
        return B && Z ? C : (pnb(), pnb(), mnb);
    } else return pnb(), pnb(), mnb;
}
function cne(a, b) {
    var c, d;
    if (!Wme) {
        Wme = new Irb;
        Xme = new Irb;
        d = (ooe(), ooe(), ++noe, new Soe(4));
        Jne(d, '\t\n\r\r  ');
        Rib(Wme, RGe, d);
        Rib(Xme, RGe, Toe(d));
        d = (++noe, new Soe(4));
        Jne(d, UGe);
        Rib(Wme, PGe, d);
        Rib(Xme, PGe, Toe(d));
        d = (++noe, new Soe(4));
        Jne(d, UGe);
        Rib(Wme, PGe, d);
        Rib(Xme, PGe, Toe(d));
        d = (++noe, new Soe(4));
        Jne(d, VGe);
        Poe(d, JD(Oib(Wme, PGe), 121));
        Rib(Wme, QGe, d);
        Rib(Xme, QGe, Toe(d));
        d = (++noe, new Soe(4));
        Jne(d, '-.0:AZ__az\xB7\xB7\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u02D0\u02D1\u0300\u0345\u0360\u0361\u0386\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0483\u0486\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u0591\u05A1\u05A3\u05B9\u05BB\u05BD\u05BF\u05BF\u05C1\u05C2\u05C4\u05C4\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0640\u0652\u0660\u0669\u0670\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06E8\u06EA\u06ED\u06F0\u06F9\u0901\u0903\u0905\u0939\u093C\u094D\u0951\u0954\u0958\u0963\u0966\u096F\u0981\u0983\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09BC\u09BC\u09BE\u09C4\u09C7\u09C8\u09CB\u09CD\u09D7\u09D7\u09DC\u09DD\u09DF\u09E3\u09E6\u09F1\u0A02\u0A02\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3C\u0A3E\u0A42\u0A47\u0A48\u0A4B\u0A4D\u0A59\u0A5C\u0A5E\u0A5E\u0A66\u0A74\u0A81\u0A83\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABC\u0AC5\u0AC7\u0AC9\u0ACB\u0ACD\u0AE0\u0AE0\u0AE6\u0AEF\u0B01\u0B03\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3C\u0B43\u0B47\u0B48\u0B4B\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F\u0B61\u0B66\u0B6F\u0B82\u0B83\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0BBE\u0BC2\u0BC6\u0BC8\u0BCA\u0BCD\u0BD7\u0BD7\u0BE7\u0BEF\u0C01\u0C03\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C3E\u0C44\u0C46\u0C48\u0C4A\u0C4D\u0C55\u0C56\u0C60\u0C61\u0C66\u0C6F\u0C82\u0C83\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CBE\u0CC4\u0CC6\u0CC8\u0CCA\u0CCD\u0CD5\u0CD6\u0CDE\u0CDE\u0CE0\u0CE1\u0CE6\u0CEF\u0D02\u0D03\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D3E\u0D43\u0D46\u0D48\u0D4A\u0D4D\u0D57\u0D57\u0D60\u0D61\u0D66\u0D6F\u0E01\u0E2E\u0E30\u0E3A\u0E40\u0E4E\u0E50\u0E59\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB9\u0EBB\u0EBD\u0EC0\u0EC4\u0EC6\u0EC6\u0EC8\u0ECD\u0ED0\u0ED9\u0F18\u0F19\u0F20\u0F29\u0F35\u0F35\u0F37\u0F37\u0F39\u0F39\u0F3E\u0F47\u0F49\u0F69\u0F71\u0F84\u0F86\u0F8B\u0F90\u0F95\u0F97\u0F97\u0F99\u0FAD\u0FB1\u0FB7\u0FB9\u0FB9\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u20D0\u20DC\u20E1\u20E1\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3005\u3005\u3007\u3007\u3021\u302F\u3031\u3035\u3041\u3094\u3099\u309A\u309D\u309E\u30A1\u30FA\u30FC\u30FE\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3');
        Rib(Wme, SGe, d);
        Rib(Xme, SGe, Toe(d));
        d = (++noe, new Soe(4));
        Jne(d, VGe);
        Moe(d, 95, 95);
        Moe(d, 58, 58);
        Rib(Wme, TGe, d);
        Rib(Xme, TGe, Toe(d));
    }
    c = b ? JD(Oib(Wme, a), 136) : JD(Oib(Xme, a), 136);
    return c;
}
function Cwc(a) {
    Rad(a, new cad(oad(jad(nad(kad(mad(lad(new pad, Ose), 'ELK Layered'), 'Layer-based algorithm provided by the Eclipse Layout Kernel. Arranges as many edges as possible into one direction by placing nodes into subsequent layers. This implementation supports different routing styles (straight, orthogonal, splines); if orthogonal routing is selected, arbitrary port constraints are respected, thus enabling the layout of block diagrams such as actor-oriented models or circuit schematics. Furthermore, full layout of compound graphs with cross-hierarchy edges is supported when the respective option is activated on the top level.'), new Fwc), Ose), nrb((BBd(), ABd), WC(OC(L4, 1), Ere, 243, 0, [
        xBd,
        yBd,
        wBd,
        zBd,
        uBd,
        tBd
    ])))));
    Pad(a, Ose, oye, JBd(Tvc));
    Pad(a, Ose, pye, JBd(Uvc));
    Pad(a, Ose, qye, JBd(Vvc));
    Pad(a, Ose, rye, JBd(Wvc));
    Pad(a, Ose, Nue, JBd(Yvc));
    Pad(a, Ose, sye, JBd(Zvc));
    Pad(a, Ose, tye, JBd(awc));
    Pad(a, Ose, uye, JBd(cwc));
    Pad(a, Ose, vye, JBd(dwc));
    Pad(a, Ose, wye, JBd(bwc));
    Pad(a, Ose, Mue, JBd(ewc));
    Pad(a, Ose, xye, JBd(gwc));
    Pad(a, Ose, yye, JBd(iwc));
    Pad(a, Ose, zye, JBd(_vc));
    Pad(a, Ose, jxe, JBd(Svc));
    Pad(a, Ose, lxe, JBd(Xvc));
    Pad(a, Ose, kxe, JBd($vc));
    Pad(a, Ose, mxe, JBd(fwc));
    Pad(a, Ose, Lue, jfb(0));
    Pad(a, Ose, nxe, JBd(Nvc));
    Pad(a, Ose, oxe, JBd(Ovc));
    Pad(a, Ose, pxe, JBd(Pvc));
    Pad(a, Ose, wxe, JBd(ywc));
    Pad(a, Ose, xxe, JBd(qwc));
    Pad(a, Ose, yxe, JBd(rwc));
    Pad(a, Ose, zxe, JBd(uwc));
    Pad(a, Ose, Axe, JBd(swc));
    Pad(a, Ose, Bxe, JBd(twc));
    Pad(a, Ose, Cxe, JBd(Awc));
    Pad(a, Ose, Dxe, JBd(zwc));
    Pad(a, Ose, Exe, JBd(wwc));
    Pad(a, Ose, Fxe, JBd(vwc));
    Pad(a, Ose, Gxe, JBd(xwc));
    Pad(a, Ose, Hxe, JBd(bvc));
    Pad(a, Ose, Ixe, JBd(_uc));
    Pad(a, Ose, Jxe, JBd(avc));
    Pad(a, Ose, cxe, JBd(lvc));
    Pad(a, Ose, dxe, JBd(mvc));
    Pad(a, Ose, gxe, JBd(Duc));
    Pad(a, Ose, hxe, JBd(Euc));
    Pad(a, Ose, _ue, JBd(mwc));
    Pad(a, Ose, ave, JBd(owc));
    Pad(a, Ose, bve, JBd(lwc));
    Pad(a, Ose, cve, JBd(kwc));
    Pad(a, Ose, dve, nwc);
    Pad(a, Ose, Rue, uvc);
    Pad(a, Ose, aye, zuc);
    Pad(a, Ose, Aye, 0);
    Pad(a, Ose, Pue, jfb(1));
    Pad(a, Ose, Oue, Jue);
    Pad(a, Ose, Bye, JBd(svc));
    Pad(a, Ose, Tue, JBd(Evc));
    Pad(a, Ose, Cye, JBd(Jvc));
    Pad(a, Ose, Dye, JBd(quc));
    Pad(a, Ose, Eye, JBd(Rtc));
    Pad(a, Ose, Xxe, JBd(Iuc));
    Pad(a, Ose, Que, (xdb(), true));
    Pad(a, Ose, Fye, JBd(Nuc));
    Pad(a, Ose, Gye, JBd(Ouc));
    Pad(a, Ose, Yue, JBd(ovc));
    Pad(a, Ose, Xue, JBd(rvc));
    Pad(a, Ose, Wue, JBd(pvc));
    Pad(a, Ose, Hye, tuc);
    Pad(a, Ose, Zue, JBd(gvc));
    Pad(a, Ose, Iye, JBd(fvc));
    Pad(a, Ose, $ue, JBd(Hvc));
    Pad(a, Ose, Jye, JBd(Gvc));
    Pad(a, Ose, Kye, JBd(Ivc));
    Pad(a, Ose, Lye, xvc);
    Pad(a, Ose, Mye, JBd(zvc));
    Pad(a, Ose, Nye, JBd(Avc));
    Pad(a, Ose, Oye, JBd(Bvc));
    Pad(a, Ose, Pye, JBd(yvc));
    Pad(a, Ose, Cwe, JBd(pwc));
    Pad(a, Ose, Fwe, JBd($uc));
    Pad(a, Ose, Lwe, JBd(Zuc));
    Pad(a, Ose, Bwe, JBd(jwc));
    Pad(a, Ose, Gwe, JBd(Uuc));
    Pad(a, Ose, Ewe, JBd(puc));
    Pad(a, Ose, Owe, JBd(ouc));
    Pad(a, Ose, Pwe, JBd(euc));
    Pad(a, Ose, Wwe, JBd(fuc));
    Pad(a, Ose, Xwe, JBd(huc));
    Pad(a, Ose, Ywe, JBd(guc));
    Pad(a, Ose, Rwe, JBd(nuc));
    Pad(a, Ose, xwe, JBd(dvc));
    Pad(a, Ose, ywe, JBd(evc));
    Pad(a, Ose, wwe, JBd(Quc));
    Pad(a, Ose, Zwe, JBd(nvc));
    Pad(a, Ose, axe, JBd(ivc));
    Pad(a, Ose, vwe, JBd(Guc));
    Pad(a, Ose, bxe, JBd(kvc));
    Pad(a, Ose, exe, JBd(Buc));
    Pad(a, Ose, fxe, JBd(Cuc));
    Pad(a, Ose, Qye, JBd(duc));
    Pad(a, Ose, _we, JBd(hvc));
    Pad(a, Ose, rxe, JBd(Xtc));
    Pad(a, Ose, sxe, JBd(Wtc));
    Pad(a, Ose, qxe, JBd(Vtc));
    Pad(a, Ose, txe, JBd(Kuc));
    Pad(a, Ose, uxe, JBd(Juc));
    Pad(a, Ose, vxe, JBd(Luc));
    Pad(a, Ose, pve, JBd(qvc));
    Pad(a, Ose, Rye, JBd(Ruc));
    Pad(a, Ose, Sye, JBd(Fuc));
    Pad(a, Ose, Tye, JBd(wuc));
    Pad(a, Ose, Uue, JBd(vuc));
    Pad(a, Ose, Qwe, JBd(iuc));
    Pad(a, Ose, Uye, JBd(Fvc));
    Pad(a, Ose, Vye, JBd(Utc));
    Pad(a, Ose, Wye, JBd(Muc));
    Pad(a, Ose, Xye, JBd(Cvc));
    Pad(a, Ose, Yye, JBd(vvc));
    Pad(a, Ose, Zye, JBd(wvc));
    Pad(a, Ose, Jwe, JBd(Wuc));
    Pad(a, Ose, Kwe, JBd(Xuc));
    Pad(a, Ose, $ye, JBd(Lvc));
    Pad(a, Ose, zwe, JBd(Stc));
    Pad(a, Ose, Mwe, JBd(Yuc));
    Pad(a, Ose, Kxe, JBd(xuc));
    Pad(a, Ose, Lxe, JBd(uuc));
    Pad(a, Ose, _ye, JBd(cvc));
    Pad(a, Ose, Nwe, JBd(Suc));
    Pad(a, Ose, $we, JBd(jvc));
    Pad(a, Ose, aze, JBd(hwc));
    Pad(a, Ose, uwe, JBd(suc));
    Pad(a, Ose, Awe, JBd(Kvc));
    Pad(a, Ose, ixe, JBd(Auc));
    Pad(a, Ose, Swe, JBd(juc));
    Pad(a, Ose, Twe, JBd(kuc));
    Pad(a, Ose, Hwe, JBd(Tuc));
    Pad(a, Ose, Uwe, JBd(luc));
    Pad(a, Ose, bze, JBd(Puc));
    Pad(a, Ose, Iwe, JBd(Vuc));
    Pad(a, Ose, Vwe, JBd(muc));
    Pad(a, Ose, Mxe, JBd(cuc));
    Pad(a, Ose, Qxe, JBd(_tc));
    Pad(a, Ose, Rxe, JBd(Ztc));
    Pad(a, Ose, Sxe, JBd($tc));
    Pad(a, Ose, Oxe, JBd(auc));
    Pad(a, Ose, Pxe, JBd(Ytc));
    Pad(a, Ose, Nxe, JBd(buc));
    Pad(a, Ose, Dwe, JBd(Huc));
}
function Tie(a) {
    Dvd(a.a, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'anySimpleType'
    ]));
    Dvd(a.b, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'anyType',
        sFe,
        qFe
    ]));
    Dvd(JD(nDd(STd(a.b), 0), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        ZFe,
        HDe,
        ':mixed'
    ]));
    Dvd(JD(nDd(STd(a.b), 1), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        ZFe,
        dGe,
        fGe,
        HDe,
        ':1',
        oGe,
        'lax'
    ]));
    Dvd(JD(nDd(STd(a.b), 2), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        XFe,
        dGe,
        fGe,
        HDe,
        ':2',
        oGe,
        'lax'
    ]));
    Dvd(a.c, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'anyURI',
        cGe,
        $Fe
    ]));
    Dvd(a.d, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'base64Binary',
        cGe,
        $Fe
    ]));
    Dvd(a.e, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        Dqe,
        cGe,
        $Fe
    ]));
    Dvd(a.f, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'boolean:Object',
        EFe,
        Dqe
    ]));
    Dvd(a.g, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        eFe
    ]));
    Dvd(a.i, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'byte:Object',
        EFe,
        eFe
    ]));
    Dvd(a.j, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'date',
        cGe,
        $Fe
    ]));
    Dvd(a.k, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'dateTime',
        cGe,
        $Fe
    ]));
    Dvd(a.n, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'decimal',
        cGe,
        $Fe
    ]));
    Dvd(a.o, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        gFe,
        cGe,
        $Fe
    ]));
    Dvd(a.p, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'double:Object',
        EFe,
        gFe
    ]));
    Dvd(a.q, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'duration',
        cGe,
        $Fe
    ]));
    Dvd(a.s, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'ENTITIES',
        EFe,
        pGe,
        qGe,
        '1'
    ]));
    Dvd(a.r, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        pGe,
        _Fe,
        rGe
    ]));
    Dvd(a.t, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        rGe,
        EFe,
        sGe
    ]));
    Dvd(a.u, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        hFe,
        cGe,
        $Fe
    ]));
    Dvd(a.v, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'float:Object',
        EFe,
        hFe
    ]));
    Dvd(a.w, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'gDay',
        cGe,
        $Fe
    ]));
    Dvd(a.B, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'gMonth',
        cGe,
        $Fe
    ]));
    Dvd(a.A, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'gMonthDay',
        cGe,
        $Fe
    ]));
    Dvd(a.C, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'gYear',
        cGe,
        $Fe
    ]));
    Dvd(a.D, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'gYearMonth',
        cGe,
        $Fe
    ]));
    Dvd(a.F, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'hexBinary',
        cGe,
        $Fe
    ]));
    Dvd(a.G, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'ID',
        EFe,
        sGe
    ]));
    Dvd(a.H, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'IDREF',
        EFe,
        sGe
    ]));
    Dvd(a.J, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'IDREFS',
        EFe,
        tGe,
        qGe,
        '1'
    ]));
    Dvd(a.I, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        tGe,
        _Fe,
        'IDREF'
    ]));
    Dvd(a.K, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        iFe
    ]));
    Dvd(a.M, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        uGe
    ]));
    Dvd(a.L, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'int:Object',
        EFe,
        iFe
    ]));
    Dvd(a.P, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'language',
        EFe,
        vGe,
        wGe,
        xGe
    ]));
    Dvd(a.Q, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        jFe
    ]));
    Dvd(a.R, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'long:Object',
        EFe,
        jFe
    ]));
    Dvd(a.S, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'Name',
        EFe,
        vGe,
        wGe,
        yGe
    ]));
    Dvd(a.T, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        sGe,
        EFe,
        'Name',
        wGe,
        zGe
    ]));
    Dvd(a.U, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'negativeInteger',
        EFe,
        AGe,
        BGe,
        '-1'
    ]));
    Dvd(a.V, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        CGe,
        EFe,
        vGe,
        wGe,
        '\\c+'
    ]));
    Dvd(a.X, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'NMTOKENS',
        EFe,
        DGe,
        qGe,
        '1'
    ]));
    Dvd(a.W, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        DGe,
        _Fe,
        CGe
    ]));
    Dvd(a.Y, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        EGe,
        EFe,
        uGe,
        FGe,
        '0'
    ]));
    Dvd(a.Z, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        AGe,
        EFe,
        uGe,
        BGe,
        '0'
    ]));
    Dvd(a.$, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        GGe,
        EFe,
        Fqe,
        cGe,
        'replace'
    ]));
    Dvd(a._, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'NOTATION',
        cGe,
        $Fe
    ]));
    Dvd(a.ab, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'positiveInteger',
        EFe,
        EGe,
        FGe,
        '1'
    ]));
    Dvd(a.bb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'processingInstruction_._type',
        sFe,
        'empty'
    ]));
    Dvd(JD(nDd(STd(a.bb), 0), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        WFe,
        HDe,
        'data'
    ]));
    Dvd(JD(nDd(STd(a.bb), 1), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        WFe,
        HDe,
        DDe
    ]));
    Dvd(a.cb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'QName',
        cGe,
        $Fe
    ]));
    Dvd(a.db, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        kFe
    ]));
    Dvd(a.eb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'short:Object',
        EFe,
        kFe
    ]));
    Dvd(a.fb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'simpleAnyType',
        sFe,
        VFe
    ]));
    Dvd(JD(nDd(STd(a.fb), 0), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        ':3',
        sFe,
        VFe
    ]));
    Dvd(JD(nDd(STd(a.fb), 1), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        ':4',
        sFe,
        VFe
    ]));
    Dvd(JD(nDd(STd(a.fb), 2), 19), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        ':5',
        sFe,
        VFe
    ]));
    Dvd(a.gb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        Fqe,
        cGe,
        'preserve'
    ]));
    Dvd(a.hb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'time',
        cGe,
        $Fe
    ]));
    Dvd(a.ib, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        vGe,
        EFe,
        GGe,
        cGe,
        $Fe
    ]));
    Dvd(a.jb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        HGe,
        BGe,
        '255',
        FGe,
        '0'
    ]));
    Dvd(a.kb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'unsignedByte:Object',
        EFe,
        HGe
    ]));
    Dvd(a.lb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        IGe,
        BGe,
        '4294967295',
        FGe,
        '0'
    ]));
    Dvd(a.mb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'unsignedInt:Object',
        EFe,
        IGe
    ]));
    Dvd(a.nb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'unsignedLong',
        EFe,
        EGe,
        BGe,
        JGe,
        FGe,
        '0'
    ]));
    Dvd(a.ob, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        KGe,
        BGe,
        '65535',
        FGe,
        '0'
    ]));
    Dvd(a.pb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        'unsignedShort:Object',
        EFe,
        KGe
    ]));
    Dvd(a.qb, rFe, WC(OC(hJ, 1), hre, 2, 6, [
        HDe,
        '',
        sFe,
        qFe
    ]));
    Dvd(JD(nDd(STd(a.qb), 0), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        ZFe,
        HDe,
        ':mixed'
    ]));
    Dvd(JD(nDd(STd(a.qb), 1), 19), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        WFe,
        HDe,
        'xmlns:prefix'
    ]));
    Dvd(JD(nDd(STd(a.qb), 2), 19), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        WFe,
        HDe,
        'xsi:schemaLocation'
    ]));
    Dvd(JD(nDd(STd(a.qb), 3), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        YFe,
        HDe,
        'cDATA',
        aGe,
        bGe
    ]));
    Dvd(JD(nDd(STd(a.qb), 4), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        YFe,
        HDe,
        'comment',
        aGe,
        bGe
    ]));
    Dvd(JD(nDd(STd(a.qb), 5), 19), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        YFe,
        HDe,
        LGe,
        aGe,
        bGe
    ]));
    Dvd(JD(nDd(STd(a.qb), 6), 35), rFe, WC(OC(hJ, 1), hre, 2, 6, [
        sFe,
        YFe,
        HDe,
        iDe,
        aGe,
        bGe
    ]));
}
function qEd(a) {
    return cgb('_UI_EMFDiagnostic_marker', a) ? 'EMF Problem' : cgb('_UI_CircularContainment_diagnostic', a) ? 'An object may not circularly contain itself' : cgb(UDe, a) ? 'Wrong character.' : cgb(VDe, a) ? 'Invalid reference number.' : cgb(WDe, a) ? 'A character is required after \\.' : cgb(XDe, a) ? "'?' is not expected.  '(?:' or '(?=' or '(?!' or '(?<' or '(?#' or '(?>'?" : cgb(YDe, a) ? "'(?<' or '(?<!' is expected." : cgb(ZDe, a) ? 'A comment is not terminated.' : cgb($De, a) ? "')' is expected." : cgb(_De, a) ? 'Unexpected end of the pattern in a modifier group.' : cgb(aEe, a) ? "':' is expected." : cgb(bEe, a) ? 'Unexpected end of the pattern in a conditional group.' : cgb(cEe, a) ? 'A back reference or an anchor or a lookahead or a look-behind is expected in a conditional pattern.' : cgb(dEe, a) ? 'There are more than three choices in a conditional group.' : cgb(eEe, a) ? 'A character in U+0040-U+005f must follow \\c.' : cgb(fEe, a) ? "A '{' is required before a character category." : cgb(gEe, a) ? "A property name is not closed by '}'." : cgb(hEe, a) ? 'Unexpected meta character.' : cgb(iEe, a) ? 'Unknown property.' : cgb(jEe, a) ? "A POSIX character class must be closed by ':]'." : cgb(kEe, a) ? 'Unexpected end of the pattern in a character class.' : cgb(lEe, a) ? 'Unknown name for a POSIX character class.' : cgb('parser.cc.4', a) ? "'-' is invalid here." : cgb(mEe, a) ? "']' is expected." : cgb(nEe, a) ? "'[' is invalid in a character class.  Write '\\['." : cgb(oEe, a) ? "']' is invalid in a character class.  Write '\\]'." : cgb(pEe, a) ? "'-' is an invalid character range. Write '\\-'." : cgb(qEe, a) ? "'[' is expected." : cgb(rEe, a) ? "')' or '-[' or '+[' or '&[' is expected." : cgb(sEe, a) ? 'The range end code point is less than the start code point.' : cgb(tEe, a) ? 'Invalid Unicode hex notation.' : cgb(uEe, a) ? 'Overflow in a hex notation.' : cgb(vEe, a) ? "'\\x{' must be closed by '}'." : cgb(wEe, a) ? 'Invalid Unicode code point.' : cgb(xEe, a) ? 'An anchor must not be here.' : cgb(yEe, a) ? 'This expression is not supported in the current option setting.' : cgb(zEe, a) ? 'Invalid quantifier. A digit is expected.' : cgb(AEe, a) ? "Invalid quantifier. Invalid quantity or a '}' is missing." : cgb(BEe, a) ? "Invalid quantifier. A digit or '}' is expected." : cgb(CEe, a) ? 'Invalid quantifier. A min quantity must be <= a max quantity.' : cgb(DEe, a) ? 'Invalid quantifier. A quantity value overflow.' : cgb('_UI_PackageRegistry_extensionpoint', a) ? 'Ecore Package Registry for Generated Packages' : cgb('_UI_DynamicPackageRegistry_extensionpoint', a) ? 'Ecore Package Registry for Dynamic Packages' : cgb('_UI_FactoryRegistry_extensionpoint', a) ? 'Ecore Factory Override Registry' : cgb('_UI_URIExtensionParserRegistry_extensionpoint', a) ? 'URI Extension Parser Registry' : cgb('_UI_URIProtocolParserRegistry_extensionpoint', a) ? 'URI Protocol Parser Registry' : cgb('_UI_URIContentParserRegistry_extensionpoint', a) ? 'URI Content Parser Registry' : cgb('_UI_ContentHandlerRegistry_extensionpoint', a) ? 'Content Handler Registry' : cgb('_UI_URIMappingRegistry_extensionpoint', a) ? 'URI Converter Mapping Registry' : cgb('_UI_PackageRegistryImplementation_extensionpoint', a) ? 'Ecore Package Registry Implementation' : cgb('_UI_ValidationDelegateRegistry_extensionpoint', a) ? 'Validation Delegate Registry' : cgb('_UI_SettingDelegateRegistry_extensionpoint', a) ? 'Feature Setting Delegate Factory Registry' : cgb('_UI_InvocationDelegateRegistry_extensionpoint', a) ? 'Operation Invocation Delegate Factory Registry' : cgb('_UI_EClassInterfaceNotAbstract_diagnostic', a) ? 'A class that is an interface must also be abstract' : cgb('_UI_EClassNoCircularSuperTypes_diagnostic', a) ? 'A class may not be a super type of itself' : cgb('_UI_EClassNotWellFormedMapEntryNoInstanceClassName_diagnostic', a) ? "A class that inherits from a map entry class must have instance class name 'java.util.Map$Entry'" : cgb('_UI_EReferenceOppositeOfOppositeInconsistent_diagnostic', a) ? 'The opposite of the opposite may not be a reference different from this one' : cgb('_UI_EReferenceOppositeNotFeatureOfType_diagnostic', a) ? "The opposite must be a feature of the reference's type" : cgb('_UI_EReferenceTransientOppositeNotTransient_diagnostic', a) ? 'The opposite of a transient reference must be transient if it is proxy resolving' : cgb('_UI_EReferenceOppositeBothContainment_diagnostic', a) ? 'The opposite of a containment reference must not be a containment reference' : cgb('_UI_EReferenceConsistentUnique_diagnostic', a) ? 'A containment or bidirectional reference must be unique if its upper bound is different from 1' : cgb('_UI_ETypedElementNoType_diagnostic', a) ? 'The typed element must have a type' : cgb('_UI_EAttributeNoDataType_diagnostic', a) ? 'The generic attribute type must not refer to a class' : cgb('_UI_EReferenceNoClass_diagnostic', a) ? 'The generic reference type must not refer to a data type' : cgb('_UI_EGenericTypeNoTypeParameterAndClassifier_diagnostic', a) ? "A generic type can't refer to both a type parameter and a classifier" : cgb('_UI_EGenericTypeNoClass_diagnostic', a) ? 'A generic super type must refer to a class' : cgb('_UI_EGenericTypeNoTypeParameterOrClassifier_diagnostic', a) ? 'A generic type in this context must refer to a classifier or a type parameter' : cgb('_UI_EGenericTypeBoundsOnlyForTypeArgument_diagnostic', a) ? 'A generic type may have bounds only when used as a type argument' : cgb('_UI_EGenericTypeNoUpperAndLowerBound_diagnostic', a) ? 'A generic type must not have both a lower and an upper bound' : cgb('_UI_EGenericTypeNoTypeParameterOrClassifierAndBound_diagnostic', a) ? 'A generic type with bounds must not also refer to a type parameter or classifier' : cgb('_UI_EGenericTypeNoArguments_diagnostic', a) ? 'A generic type may have arguments only if it refers to a classifier' : cgb('_UI_EGenericTypeOutOfScopeTypeParameter_diagnostic', a) ? 'A generic type may only refer to a type parameter that is in scope' : a;
}
function Cwd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (a.r) return;
    a.r = true;
    rvd(a, 'graph');
    ewd(a, 'graph');
    fwd(a, _Ce);
    Ivd(a.o, 'T');
    tCd(UTd(a.a), a.p);
    tCd(UTd(a.f), a.a);
    tCd(UTd(a.n), a.f);
    tCd(UTd(a.g), a.n);
    tCd(UTd(a.c), a.n);
    tCd(UTd(a.i), a.c);
    tCd(UTd(a.j), a.c);
    tCd(UTd(a.d), a.f);
    tCd(UTd(a.e), a.a);
    Zvd(a.p, M4, wue, true, true, false);
    o = Fvd(a.p, a.p, 'setProperty');
    p = Jvd(o);
    j = Pvd(a.o);
    k = (c = (d = new NZd, d), c);
    tCd((!j.d && (j.d = new qVd(g6, j, 1)), j.d), k);
    l = Qvd(p);
    IZd(k, l);
    Hvd(o, j, aDe);
    j = Qvd(p);
    Hvd(o, j, bDe);
    o = Fvd(a.p, null, 'getProperty');
    p = Jvd(o);
    j = Pvd(a.o);
    k = Qvd(p);
    tCd((!j.d && (j.d = new qVd(g6, j, 1)), j.d), k);
    Hvd(o, j, aDe);
    j = Qvd(p);
    n = qRd(o, j, null);
    !!n && n.lj();
    o = Fvd(a.p, a.wb.e, 'hasProperty');
    j = Pvd(a.o);
    k = (e = (f = new NZd, f), e);
    tCd((!j.d && (j.d = new qVd(g6, j, 1)), j.d), k);
    Hvd(o, j, aDe);
    o = Fvd(a.p, a.p, 'copyProperties');
    Gvd(o, a.p, cDe);
    o = Fvd(a.p, null, 'getAllProperties');
    j = Pvd(a.wb.P);
    k = Pvd(a.o);
    tCd((!j.d && (j.d = new qVd(g6, j, 1)), j.d), k);
    l = (g = (h = new NZd, h), g);
    tCd((!k.d && (k.d = new qVd(g6, k, 1)), k.d), l);
    k = Pvd(a.wb.M);
    tCd((!j.d && (j.d = new qVd(g6, j, 1)), j.d), k);
    m = qRd(o, j, null);
    !!m && m.lj();
    Zvd(a.a, t3, yCe, true, false, true);
    bwd(JD(nDd(STd(a.a), 0), 19), a.k, null, dDe, 0, -1, t3, false, false, true, true, false, false, false);
    Zvd(a.f, y3, ACe, true, false, true);
    bwd(JD(nDd(STd(a.f), 0), 19), a.g, JD(nDd(STd(a.g), 0), 19), 'labels', 0, -1, y3, false, false, true, true, false, false, false);
    Xvd(JD(nDd(STd(a.f), 1), 35), a.wb._, eDe, null, 0, 1, y3, false, false, true, false, true, false);
    Zvd(a.n, C3, 'ElkShape', true, false, true);
    Xvd(JD(nDd(STd(a.n), 0), 35), a.wb.t, fDe, Vse, 1, 1, C3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.n), 1), 35), a.wb.t, gDe, Vse, 1, 1, C3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.n), 2), 35), a.wb.t, 'x', Vse, 1, 1, C3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.n), 3), 35), a.wb.t, 'y', Vse, 1, 1, C3, false, false, true, false, true, false);
    o = Fvd(a.n, null, 'setDimensions');
    Gvd(o, a.wb.t, gDe);
    Gvd(o, a.wb.t, fDe);
    o = Fvd(a.n, null, 'setLocation');
    Gvd(o, a.wb.t, 'x');
    Gvd(o, a.wb.t, 'y');
    Zvd(a.g, z3, GCe, false, false, true);
    bwd(JD(nDd(STd(a.g), 0), 19), a.f, JD(nDd(STd(a.f), 0), 19), hDe, 0, 1, z3, false, false, true, false, false, false, false);
    Xvd(JD(nDd(STd(a.g), 1), 35), a.wb._, iDe, '', 0, 1, z3, false, false, true, false, true, false);
    Zvd(a.c, v3, BCe, true, false, true);
    bwd(JD(nDd(STd(a.c), 0), 19), a.d, JD(nDd(STd(a.d), 1), 19), 'outgoingEdges', 0, -1, v3, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.c), 1), 19), a.d, JD(nDd(STd(a.d), 2), 19), 'incomingEdges', 0, -1, v3, false, false, true, false, true, false, false);
    Zvd(a.i, A3, HCe, false, false, true);
    bwd(JD(nDd(STd(a.i), 0), 19), a.j, JD(nDd(STd(a.j), 0), 19), 'ports', 0, -1, A3, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.i), 1), 19), a.i, JD(nDd(STd(a.i), 2), 19), jDe, 0, -1, A3, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.i), 2), 19), a.i, JD(nDd(STd(a.i), 1), 19), hDe, 0, 1, A3, false, false, true, false, false, false, false);
    bwd(JD(nDd(STd(a.i), 3), 19), a.d, JD(nDd(STd(a.d), 0), 19), 'containedEdges', 0, -1, A3, false, false, true, true, false, false, false);
    Xvd(JD(nDd(STd(a.i), 4), 35), a.wb.e, kDe, null, 0, 1, A3, true, true, false, false, true, true);
    Zvd(a.j, B3, ICe, false, false, true);
    bwd(JD(nDd(STd(a.j), 0), 19), a.i, JD(nDd(STd(a.i), 0), 19), hDe, 0, 1, B3, false, false, true, false, false, false, false);
    Zvd(a.d, x3, CCe, false, false, true);
    bwd(JD(nDd(STd(a.d), 0), 19), a.i, JD(nDd(STd(a.i), 3), 19), 'containingNode', 0, 1, x3, false, false, true, false, false, false, false);
    bwd(JD(nDd(STd(a.d), 1), 19), a.c, JD(nDd(STd(a.c), 0), 19), lDe, 0, -1, x3, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.d), 2), 19), a.c, JD(nDd(STd(a.c), 1), 19), mDe, 0, -1, x3, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.d), 3), 19), a.e, JD(nDd(STd(a.e), 5), 19), nDe, 0, -1, x3, false, false, true, true, false, false, false);
    Xvd(JD(nDd(STd(a.d), 4), 35), a.wb.e, 'hyperedge', null, 0, 1, x3, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.d), 5), 35), a.wb.e, kDe, null, 0, 1, x3, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.d), 6), 35), a.wb.e, 'selfloop', null, 0, 1, x3, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.d), 7), 35), a.wb.e, 'connected', null, 0, 1, x3, true, true, false, false, true, true);
    Zvd(a.b, u3, zCe, false, false, true);
    Xvd(JD(nDd(STd(a.b), 0), 35), a.wb.t, 'x', Vse, 1, 1, u3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.b), 1), 35), a.wb.t, 'y', Vse, 1, 1, u3, false, false, true, false, true, false);
    o = Fvd(a.b, null, 'set');
    Gvd(o, a.wb.t, 'x');
    Gvd(o, a.wb.t, 'y');
    Zvd(a.e, w3, DCe, false, false, true);
    Xvd(JD(nDd(STd(a.e), 0), 35), a.wb.t, 'startX', null, 0, 1, w3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.e), 1), 35), a.wb.t, 'startY', null, 0, 1, w3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.e), 2), 35), a.wb.t, 'endX', null, 0, 1, w3, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.e), 3), 35), a.wb.t, 'endY', null, 0, 1, w3, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.e), 4), 19), a.b, null, oDe, 0, -1, w3, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.e), 5), 19), a.d, JD(nDd(STd(a.d), 3), 19), hDe, 0, 1, w3, false, false, true, false, false, false, false);
    bwd(JD(nDd(STd(a.e), 6), 19), a.c, null, pDe, 0, 1, w3, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.e), 7), 19), a.c, null, qDe, 0, 1, w3, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.e), 8), 19), a.e, JD(nDd(STd(a.e), 9), 19), rDe, 0, -1, w3, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.e), 9), 19), a.e, JD(nDd(STd(a.e), 8), 19), sDe, 0, -1, w3, false, false, true, false, true, false, false);
    Xvd(JD(nDd(STd(a.e), 10), 35), a.wb._, eDe, null, 0, 1, w3, false, false, true, false, true, false);
    o = Fvd(a.e, null, 'setStartLocation');
    Gvd(o, a.wb.t, 'x');
    Gvd(o, a.wb.t, 'y');
    o = Fvd(a.e, null, 'setEndLocation');
    Gvd(o, a.wb.t, 'x');
    Gvd(o, a.wb.t, 'y');
    Zvd(a.k, LK, 'ElkPropertyToValueMapEntry', false, false, false);
    j = Pvd(a.o);
    k = (i = (b = new NZd, b), i);
    tCd((!j.d && (j.d = new qVd(g6, j, 1)), j.d), k);
    Yvd(JD(nDd(STd(a.k), 0), 35), j, 'key', LK, false, false, true, false);
    Xvd(JD(nDd(STd(a.k), 1), 35), a.s, bDe, null, 0, 1, LK, false, false, true, false, true, false);
    _vd(a.o, N4, 'IProperty', true);
    _vd(a.s, aJ, 'PropertyValue', true);
    Tvd(a, _Ce);
}
function dme() {
    dme = Zcb;
    cme = SC($D, ZCe, 30, Pse, 15, 1);
    cme[9] = 35;
    cme[10] = 19;
    cme[13] = 19;
    cme[32] = 51;
    cme[33] = 49;
    cme[34] = 33;
    Bmb(cme, 35, 38, 49);
    cme[38] = 1;
    Bmb(cme, 39, 45, 49);
    Bmb(cme, 45, 47, -71);
    cme[47] = 49;
    Bmb(cme, 48, 58, -71);
    cme[58] = 61;
    cme[59] = 49;
    cme[60] = 1;
    cme[61] = 49;
    cme[62] = 33;
    Bmb(cme, 63, 65, 49);
    Bmb(cme, 65, 91, -3);
    Bmb(cme, 91, 93, 33);
    cme[93] = 1;
    cme[94] = 33;
    cme[95] = -3;
    cme[96] = 33;
    Bmb(cme, 97, 123, -3);
    Bmb(cme, 123, 183, 33);
    cme[183] = -87;
    Bmb(cme, 184, 192, 33);
    Bmb(cme, 192, 215, -19);
    cme[215] = 33;
    Bmb(cme, 216, 247, -19);
    cme[247] = 33;
    Bmb(cme, 248, 306, -19);
    Bmb(cme, 306, 308, 33);
    Bmb(cme, 308, 319, -19);
    Bmb(cme, 319, 321, 33);
    Bmb(cme, 321, 329, -19);
    cme[329] = 33;
    Bmb(cme, 330, 383, -19);
    cme[383] = 33;
    Bmb(cme, 384, 452, -19);
    Bmb(cme, 452, 461, 33);
    Bmb(cme, 461, 497, -19);
    Bmb(cme, 497, 500, 33);
    Bmb(cme, 500, 502, -19);
    Bmb(cme, 502, 506, 33);
    Bmb(cme, 506, 536, -19);
    Bmb(cme, 536, 592, 33);
    Bmb(cme, 592, 681, -19);
    Bmb(cme, 681, 699, 33);
    Bmb(cme, 699, 706, -19);
    Bmb(cme, 706, 720, 33);
    Bmb(cme, 720, 722, -87);
    Bmb(cme, 722, 768, 33);
    Bmb(cme, 768, 838, -87);
    Bmb(cme, 838, 864, 33);
    Bmb(cme, 864, 866, -87);
    Bmb(cme, 866, 902, 33);
    cme[902] = -19;
    cme[903] = -87;
    Bmb(cme, 904, 907, -19);
    cme[907] = 33;
    cme[908] = -19;
    cme[909] = 33;
    Bmb(cme, 910, 930, -19);
    cme[930] = 33;
    Bmb(cme, 931, 975, -19);
    cme[975] = 33;
    Bmb(cme, 976, 983, -19);
    Bmb(cme, 983, 986, 33);
    cme[986] = -19;
    cme[987] = 33;
    cme[988] = -19;
    cme[989] = 33;
    cme[990] = -19;
    cme[991] = 33;
    cme[992] = -19;
    cme[993] = 33;
    Bmb(cme, 994, 1012, -19);
    Bmb(cme, 1012, 1025, 33);
    Bmb(cme, 1025, 1037, -19);
    cme[1037] = 33;
    Bmb(cme, 1038, 1104, -19);
    cme[1104] = 33;
    Bmb(cme, 1105, 1117, -19);
    cme[1117] = 33;
    Bmb(cme, 1118, 1154, -19);
    cme[1154] = 33;
    Bmb(cme, 1155, 1159, -87);
    Bmb(cme, 1159, 1168, 33);
    Bmb(cme, 1168, 1221, -19);
    Bmb(cme, 1221, 1223, 33);
    Bmb(cme, 1223, 1225, -19);
    Bmb(cme, 1225, 1227, 33);
    Bmb(cme, 1227, 1229, -19);
    Bmb(cme, 1229, 1232, 33);
    Bmb(cme, 1232, 1260, -19);
    Bmb(cme, 1260, 1262, 33);
    Bmb(cme, 1262, 1270, -19);
    Bmb(cme, 1270, 1272, 33);
    Bmb(cme, 1272, 1274, -19);
    Bmb(cme, 1274, 1329, 33);
    Bmb(cme, 1329, 1367, -19);
    Bmb(cme, 1367, 1369, 33);
    cme[1369] = -19;
    Bmb(cme, 1370, 1377, 33);
    Bmb(cme, 1377, 1415, -19);
    Bmb(cme, 1415, 1425, 33);
    Bmb(cme, 1425, 1442, -87);
    cme[1442] = 33;
    Bmb(cme, 1443, 1466, -87);
    cme[1466] = 33;
    Bmb(cme, 1467, 1470, -87);
    cme[1470] = 33;
    cme[1471] = -87;
    cme[1472] = 33;
    Bmb(cme, 1473, 1475, -87);
    cme[1475] = 33;
    cme[1476] = -87;
    Bmb(cme, 1477, 1488, 33);
    Bmb(cme, 1488, 1515, -19);
    Bmb(cme, 1515, 1520, 33);
    Bmb(cme, 1520, 1523, -19);
    Bmb(cme, 1523, 1569, 33);
    Bmb(cme, 1569, 1595, -19);
    Bmb(cme, 1595, 1600, 33);
    cme[1600] = -87;
    Bmb(cme, 1601, 1611, -19);
    Bmb(cme, 1611, 1619, -87);
    Bmb(cme, 1619, 1632, 33);
    Bmb(cme, 1632, 1642, -87);
    Bmb(cme, 1642, 1648, 33);
    cme[1648] = -87;
    Bmb(cme, 1649, 1720, -19);
    Bmb(cme, 1720, 1722, 33);
    Bmb(cme, 1722, 1727, -19);
    cme[1727] = 33;
    Bmb(cme, 1728, 1743, -19);
    cme[1743] = 33;
    Bmb(cme, 1744, 1748, -19);
    cme[1748] = 33;
    cme[1749] = -19;
    Bmb(cme, 1750, 1765, -87);
    Bmb(cme, 1765, 1767, -19);
    Bmb(cme, 1767, 1769, -87);
    cme[1769] = 33;
    Bmb(cme, 1770, 1774, -87);
    Bmb(cme, 1774, 1776, 33);
    Bmb(cme, 1776, 1786, -87);
    Bmb(cme, 1786, 2305, 33);
    Bmb(cme, 2305, 2308, -87);
    cme[2308] = 33;
    Bmb(cme, 2309, 2362, -19);
    Bmb(cme, 2362, 2364, 33);
    cme[2364] = -87;
    cme[2365] = -19;
    Bmb(cme, 2366, 2382, -87);
    Bmb(cme, 2382, 2385, 33);
    Bmb(cme, 2385, 2389, -87);
    Bmb(cme, 2389, 2392, 33);
    Bmb(cme, 2392, 2402, -19);
    Bmb(cme, 2402, 2404, -87);
    Bmb(cme, 2404, 2406, 33);
    Bmb(cme, 2406, 2416, -87);
    Bmb(cme, 2416, 2433, 33);
    Bmb(cme, 2433, 2436, -87);
    cme[2436] = 33;
    Bmb(cme, 2437, 2445, -19);
    Bmb(cme, 2445, 2447, 33);
    Bmb(cme, 2447, 2449, -19);
    Bmb(cme, 2449, 2451, 33);
    Bmb(cme, 2451, 2473, -19);
    cme[2473] = 33;
    Bmb(cme, 2474, 2481, -19);
    cme[2481] = 33;
    cme[2482] = -19;
    Bmb(cme, 2483, 2486, 33);
    Bmb(cme, 2486, 2490, -19);
    Bmb(cme, 2490, 2492, 33);
    cme[2492] = -87;
    cme[2493] = 33;
    Bmb(cme, 2494, 2501, -87);
    Bmb(cme, 2501, 2503, 33);
    Bmb(cme, 2503, 2505, -87);
    Bmb(cme, 2505, 2507, 33);
    Bmb(cme, 2507, 2510, -87);
    Bmb(cme, 2510, 2519, 33);
    cme[2519] = -87;
    Bmb(cme, 2520, 2524, 33);
    Bmb(cme, 2524, 2526, -19);
    cme[2526] = 33;
    Bmb(cme, 2527, 2530, -19);
    Bmb(cme, 2530, 2532, -87);
    Bmb(cme, 2532, 2534, 33);
    Bmb(cme, 2534, 2544, -87);
    Bmb(cme, 2544, 2546, -19);
    Bmb(cme, 2546, 2562, 33);
    cme[2562] = -87;
    Bmb(cme, 2563, 2565, 33);
    Bmb(cme, 2565, 2571, -19);
    Bmb(cme, 2571, 2575, 33);
    Bmb(cme, 2575, 2577, -19);
    Bmb(cme, 2577, 2579, 33);
    Bmb(cme, 2579, 2601, -19);
    cme[2601] = 33;
    Bmb(cme, 2602, 2609, -19);
    cme[2609] = 33;
    Bmb(cme, 2610, 2612, -19);
    cme[2612] = 33;
    Bmb(cme, 2613, 2615, -19);
    cme[2615] = 33;
    Bmb(cme, 2616, 2618, -19);
    Bmb(cme, 2618, 2620, 33);
    cme[2620] = -87;
    cme[2621] = 33;
    Bmb(cme, 2622, 2627, -87);
    Bmb(cme, 2627, 2631, 33);
    Bmb(cme, 2631, 2633, -87);
    Bmb(cme, 2633, 2635, 33);
    Bmb(cme, 2635, 2638, -87);
    Bmb(cme, 2638, 2649, 33);
    Bmb(cme, 2649, 2653, -19);
    cme[2653] = 33;
    cme[2654] = -19;
    Bmb(cme, 2655, 2662, 33);
    Bmb(cme, 2662, 2674, -87);
    Bmb(cme, 2674, 2677, -19);
    Bmb(cme, 2677, 2689, 33);
    Bmb(cme, 2689, 2692, -87);
    cme[2692] = 33;
    Bmb(cme, 2693, 2700, -19);
    cme[2700] = 33;
    cme[2701] = -19;
    cme[2702] = 33;
    Bmb(cme, 2703, 2706, -19);
    cme[2706] = 33;
    Bmb(cme, 2707, 2729, -19);
    cme[2729] = 33;
    Bmb(cme, 2730, 2737, -19);
    cme[2737] = 33;
    Bmb(cme, 2738, 2740, -19);
    cme[2740] = 33;
    Bmb(cme, 2741, 2746, -19);
    Bmb(cme, 2746, 2748, 33);
    cme[2748] = -87;
    cme[2749] = -19;
    Bmb(cme, 2750, 2758, -87);
    cme[2758] = 33;
    Bmb(cme, 2759, 2762, -87);
    cme[2762] = 33;
    Bmb(cme, 2763, 2766, -87);
    Bmb(cme, 2766, 2784, 33);
    cme[2784] = -19;
    Bmb(cme, 2785, 2790, 33);
    Bmb(cme, 2790, 2800, -87);
    Bmb(cme, 2800, 2817, 33);
    Bmb(cme, 2817, 2820, -87);
    cme[2820] = 33;
    Bmb(cme, 2821, 2829, -19);
    Bmb(cme, 2829, 2831, 33);
    Bmb(cme, 2831, 2833, -19);
    Bmb(cme, 2833, 2835, 33);
    Bmb(cme, 2835, 2857, -19);
    cme[2857] = 33;
    Bmb(cme, 2858, 2865, -19);
    cme[2865] = 33;
    Bmb(cme, 2866, 2868, -19);
    Bmb(cme, 2868, 2870, 33);
    Bmb(cme, 2870, 2874, -19);
    Bmb(cme, 2874, 2876, 33);
    cme[2876] = -87;
    cme[2877] = -19;
    Bmb(cme, 2878, 2884, -87);
    Bmb(cme, 2884, 2887, 33);
    Bmb(cme, 2887, 2889, -87);
    Bmb(cme, 2889, 2891, 33);
    Bmb(cme, 2891, 2894, -87);
    Bmb(cme, 2894, 2902, 33);
    Bmb(cme, 2902, 2904, -87);
    Bmb(cme, 2904, 2908, 33);
    Bmb(cme, 2908, 2910, -19);
    cme[2910] = 33;
    Bmb(cme, 2911, 2914, -19);
    Bmb(cme, 2914, 2918, 33);
    Bmb(cme, 2918, 2928, -87);
    Bmb(cme, 2928, 2946, 33);
    Bmb(cme, 2946, 2948, -87);
    cme[2948] = 33;
    Bmb(cme, 2949, 2955, -19);
    Bmb(cme, 2955, 2958, 33);
    Bmb(cme, 2958, 2961, -19);
    cme[2961] = 33;
    Bmb(cme, 2962, 2966, -19);
    Bmb(cme, 2966, 2969, 33);
    Bmb(cme, 2969, 2971, -19);
    cme[2971] = 33;
    cme[2972] = -19;
    cme[2973] = 33;
    Bmb(cme, 2974, 2976, -19);
    Bmb(cme, 2976, 2979, 33);
    Bmb(cme, 2979, 2981, -19);
    Bmb(cme, 2981, 2984, 33);
    Bmb(cme, 2984, 2987, -19);
    Bmb(cme, 2987, 2990, 33);
    Bmb(cme, 2990, 2998, -19);
    cme[2998] = 33;
    Bmb(cme, 2999, 3002, -19);
    Bmb(cme, 3002, 3006, 33);
    Bmb(cme, 3006, 3011, -87);
    Bmb(cme, 3011, 3014, 33);
    Bmb(cme, 3014, 3017, -87);
    cme[3017] = 33;
    Bmb(cme, 3018, 3022, -87);
    Bmb(cme, 3022, 3031, 33);
    cme[3031] = -87;
    Bmb(cme, 3032, 3047, 33);
    Bmb(cme, 3047, 3056, -87);
    Bmb(cme, 3056, 3073, 33);
    Bmb(cme, 3073, 3076, -87);
    cme[3076] = 33;
    Bmb(cme, 3077, 3085, -19);
    cme[3085] = 33;
    Bmb(cme, 3086, 3089, -19);
    cme[3089] = 33;
    Bmb(cme, 3090, 3113, -19);
    cme[3113] = 33;
    Bmb(cme, 3114, 3124, -19);
    cme[3124] = 33;
    Bmb(cme, 3125, 3130, -19);
    Bmb(cme, 3130, 3134, 33);
    Bmb(cme, 3134, 3141, -87);
    cme[3141] = 33;
    Bmb(cme, 3142, 3145, -87);
    cme[3145] = 33;
    Bmb(cme, 3146, 3150, -87);
    Bmb(cme, 3150, 3157, 33);
    Bmb(cme, 3157, 3159, -87);
    Bmb(cme, 3159, 3168, 33);
    Bmb(cme, 3168, 3170, -19);
    Bmb(cme, 3170, 3174, 33);
    Bmb(cme, 3174, 3184, -87);
    Bmb(cme, 3184, 3202, 33);
    Bmb(cme, 3202, 3204, -87);
    cme[3204] = 33;
    Bmb(cme, 3205, 3213, -19);
    cme[3213] = 33;
    Bmb(cme, 3214, 3217, -19);
    cme[3217] = 33;
    Bmb(cme, 3218, 3241, -19);
    cme[3241] = 33;
    Bmb(cme, 3242, 3252, -19);
    cme[3252] = 33;
    Bmb(cme, 3253, 3258, -19);
    Bmb(cme, 3258, 3262, 33);
    Bmb(cme, 3262, 3269, -87);
    cme[3269] = 33;
    Bmb(cme, 3270, 3273, -87);
    cme[3273] = 33;
    Bmb(cme, 3274, 3278, -87);
    Bmb(cme, 3278, 3285, 33);
    Bmb(cme, 3285, 3287, -87);
    Bmb(cme, 3287, 3294, 33);
    cme[3294] = -19;
    cme[3295] = 33;
    Bmb(cme, 3296, 3298, -19);
    Bmb(cme, 3298, 3302, 33);
    Bmb(cme, 3302, 3312, -87);
    Bmb(cme, 3312, 3330, 33);
    Bmb(cme, 3330, 3332, -87);
    cme[3332] = 33;
    Bmb(cme, 3333, 3341, -19);
    cme[3341] = 33;
    Bmb(cme, 3342, 3345, -19);
    cme[3345] = 33;
    Bmb(cme, 3346, 3369, -19);
    cme[3369] = 33;
    Bmb(cme, 3370, 3386, -19);
    Bmb(cme, 3386, 3390, 33);
    Bmb(cme, 3390, 3396, -87);
    Bmb(cme, 3396, 3398, 33);
    Bmb(cme, 3398, 3401, -87);
    cme[3401] = 33;
    Bmb(cme, 3402, 3406, -87);
    Bmb(cme, 3406, 3415, 33);
    cme[3415] = -87;
    Bmb(cme, 3416, 3424, 33);
    Bmb(cme, 3424, 3426, -19);
    Bmb(cme, 3426, 3430, 33);
    Bmb(cme, 3430, 3440, -87);
    Bmb(cme, 3440, 3585, 33);
    Bmb(cme, 3585, 3631, -19);
    cme[3631] = 33;
    cme[3632] = -19;
    cme[3633] = -87;
    Bmb(cme, 3634, 3636, -19);
    Bmb(cme, 3636, 3643, -87);
    Bmb(cme, 3643, 3648, 33);
    Bmb(cme, 3648, 3654, -19);
    Bmb(cme, 3654, 3663, -87);
    cme[3663] = 33;
    Bmb(cme, 3664, 3674, -87);
    Bmb(cme, 3674, 3713, 33);
    Bmb(cme, 3713, 3715, -19);
    cme[3715] = 33;
    cme[3716] = -19;
    Bmb(cme, 3717, 3719, 33);
    Bmb(cme, 3719, 3721, -19);
    cme[3721] = 33;
    cme[3722] = -19;
    Bmb(cme, 3723, 3725, 33);
    cme[3725] = -19;
    Bmb(cme, 3726, 3732, 33);
    Bmb(cme, 3732, 3736, -19);
    cme[3736] = 33;
    Bmb(cme, 3737, 3744, -19);
    cme[3744] = 33;
    Bmb(cme, 3745, 3748, -19);
    cme[3748] = 33;
    cme[3749] = -19;
    cme[3750] = 33;
    cme[3751] = -19;
    Bmb(cme, 3752, 3754, 33);
    Bmb(cme, 3754, 3756, -19);
    cme[3756] = 33;
    Bmb(cme, 3757, 3759, -19);
    cme[3759] = 33;
    cme[3760] = -19;
    cme[3761] = -87;
    Bmb(cme, 3762, 3764, -19);
    Bmb(cme, 3764, 3770, -87);
    cme[3770] = 33;
    Bmb(cme, 3771, 3773, -87);
    cme[3773] = -19;
    Bmb(cme, 3774, 3776, 33);
    Bmb(cme, 3776, 3781, -19);
    cme[3781] = 33;
    cme[3782] = -87;
    cme[3783] = 33;
    Bmb(cme, 3784, 3790, -87);
    Bmb(cme, 3790, 3792, 33);
    Bmb(cme, 3792, 3802, -87);
    Bmb(cme, 3802, 3864, 33);
    Bmb(cme, 3864, 3866, -87);
    Bmb(cme, 3866, 3872, 33);
    Bmb(cme, 3872, 3882, -87);
    Bmb(cme, 3882, 3893, 33);
    cme[3893] = -87;
    cme[3894] = 33;
    cme[3895] = -87;
    cme[3896] = 33;
    cme[3897] = -87;
    Bmb(cme, 3898, 3902, 33);
    Bmb(cme, 3902, 3904, -87);
    Bmb(cme, 3904, 3912, -19);
    cme[3912] = 33;
    Bmb(cme, 3913, 3946, -19);
    Bmb(cme, 3946, 3953, 33);
    Bmb(cme, 3953, 3973, -87);
    cme[3973] = 33;
    Bmb(cme, 3974, 3980, -87);
    Bmb(cme, 3980, 3984, 33);
    Bmb(cme, 3984, 3990, -87);
    cme[3990] = 33;
    cme[3991] = -87;
    cme[3992] = 33;
    Bmb(cme, 3993, 4014, -87);
    Bmb(cme, 4014, 4017, 33);
    Bmb(cme, 4017, 4024, -87);
    cme[4024] = 33;
    cme[4025] = -87;
    Bmb(cme, 4026, 4256, 33);
    Bmb(cme, 4256, 4294, -19);
    Bmb(cme, 4294, 4304, 33);
    Bmb(cme, 4304, 4343, -19);
    Bmb(cme, 4343, 4352, 33);
    cme[4352] = -19;
    cme[4353] = 33;
    Bmb(cme, 4354, 4356, -19);
    cme[4356] = 33;
    Bmb(cme, 4357, 4360, -19);
    cme[4360] = 33;
    cme[4361] = -19;
    cme[4362] = 33;
    Bmb(cme, 4363, 4365, -19);
    cme[4365] = 33;
    Bmb(cme, 4366, 4371, -19);
    Bmb(cme, 4371, 4412, 33);
    cme[4412] = -19;
    cme[4413] = 33;
    cme[4414] = -19;
    cme[4415] = 33;
    cme[4416] = -19;
    Bmb(cme, 4417, 4428, 33);
    cme[4428] = -19;
    cme[4429] = 33;
    cme[4430] = -19;
    cme[4431] = 33;
    cme[4432] = -19;
    Bmb(cme, 4433, 4436, 33);
    Bmb(cme, 4436, 4438, -19);
    Bmb(cme, 4438, 4441, 33);
    cme[4441] = -19;
    Bmb(cme, 4442, 4447, 33);
    Bmb(cme, 4447, 4450, -19);
    cme[4450] = 33;
    cme[4451] = -19;
    cme[4452] = 33;
    cme[4453] = -19;
    cme[4454] = 33;
    cme[4455] = -19;
    cme[4456] = 33;
    cme[4457] = -19;
    Bmb(cme, 4458, 4461, 33);
    Bmb(cme, 4461, 4463, -19);
    Bmb(cme, 4463, 4466, 33);
    Bmb(cme, 4466, 4468, -19);
    cme[4468] = 33;
    cme[4469] = -19;
    Bmb(cme, 4470, 4510, 33);
    cme[4510] = -19;
    Bmb(cme, 4511, 4520, 33);
    cme[4520] = -19;
    Bmb(cme, 4521, 4523, 33);
    cme[4523] = -19;
    Bmb(cme, 4524, 4526, 33);
    Bmb(cme, 4526, 4528, -19);
    Bmb(cme, 4528, 4535, 33);
    Bmb(cme, 4535, 4537, -19);
    cme[4537] = 33;
    cme[4538] = -19;
    cme[4539] = 33;
    Bmb(cme, 4540, 4547, -19);
    Bmb(cme, 4547, 4587, 33);
    cme[4587] = -19;
    Bmb(cme, 4588, 4592, 33);
    cme[4592] = -19;
    Bmb(cme, 4593, 4601, 33);
    cme[4601] = -19;
    Bmb(cme, 4602, 7680, 33);
    Bmb(cme, 7680, 7836, -19);
    Bmb(cme, 7836, 7840, 33);
    Bmb(cme, 7840, 7930, -19);
    Bmb(cme, 7930, 7936, 33);
    Bmb(cme, 7936, 7958, -19);
    Bmb(cme, 7958, 7960, 33);
    Bmb(cme, 7960, 7966, -19);
    Bmb(cme, 7966, 7968, 33);
    Bmb(cme, 7968, 8006, -19);
    Bmb(cme, 8006, 8008, 33);
    Bmb(cme, 8008, 8014, -19);
    Bmb(cme, 8014, 8016, 33);
    Bmb(cme, 8016, 8024, -19);
    cme[8024] = 33;
    cme[8025] = -19;
    cme[8026] = 33;
    cme[8027] = -19;
    cme[8028] = 33;
    cme[8029] = -19;
    cme[8030] = 33;
    Bmb(cme, 8031, 8062, -19);
    Bmb(cme, 8062, 8064, 33);
    Bmb(cme, 8064, 8117, -19);
    cme[8117] = 33;
    Bmb(cme, 8118, 8125, -19);
    cme[8125] = 33;
    cme[8126] = -19;
    Bmb(cme, 8127, 8130, 33);
    Bmb(cme, 8130, 8133, -19);
    cme[8133] = 33;
    Bmb(cme, 8134, 8141, -19);
    Bmb(cme, 8141, 8144, 33);
    Bmb(cme, 8144, 8148, -19);
    Bmb(cme, 8148, 8150, 33);
    Bmb(cme, 8150, 8156, -19);
    Bmb(cme, 8156, 8160, 33);
    Bmb(cme, 8160, 8173, -19);
    Bmb(cme, 8173, 8178, 33);
    Bmb(cme, 8178, 8181, -19);
    cme[8181] = 33;
    Bmb(cme, 8182, 8189, -19);
    Bmb(cme, 8189, 8400, 33);
    Bmb(cme, 8400, 8413, -87);
    Bmb(cme, 8413, 8417, 33);
    cme[8417] = -87;
    Bmb(cme, 8418, 8486, 33);
    cme[8486] = -19;
    Bmb(cme, 8487, 8490, 33);
    Bmb(cme, 8490, 8492, -19);
    Bmb(cme, 8492, 8494, 33);
    cme[8494] = -19;
    Bmb(cme, 8495, 8576, 33);
    Bmb(cme, 8576, 8579, -19);
    Bmb(cme, 8579, 12293, 33);
    cme[12293] = -87;
    cme[12294] = 33;
    cme[12295] = -19;
    Bmb(cme, 12296, 12321, 33);
    Bmb(cme, 12321, 12330, -19);
    Bmb(cme, 12330, 12336, -87);
    cme[12336] = 33;
    Bmb(cme, 12337, 12342, -87);
    Bmb(cme, 12342, 12353, 33);
    Bmb(cme, 12353, 12437, -19);
    Bmb(cme, 12437, 12441, 33);
    Bmb(cme, 12441, 12443, -87);
    Bmb(cme, 12443, 12445, 33);
    Bmb(cme, 12445, 12447, -87);
    Bmb(cme, 12447, 12449, 33);
    Bmb(cme, 12449, 12539, -19);
    cme[12539] = 33;
    Bmb(cme, 12540, 12543, -87);
    Bmb(cme, 12543, 12549, 33);
    Bmb(cme, 12549, 12589, -19);
    Bmb(cme, 12589, 19968, 33);
    Bmb(cme, 19968, 40870, -19);
    Bmb(cme, 40870, 44032, 33);
    Bmb(cme, 44032, 55204, -19);
    Bmb(cme, 55204, Qse, 33);
    Bmb(cme, 57344, 65534, 33);
}
function s6d(a) {
    var b, c, d, e, f, g, h;
    if (a.hb) return;
    a.hb = true;
    rvd(a, 'ecore');
    ewd(a, 'ecore');
    fwd(a, BFe);
    Ivd(a.fb, 'E');
    Ivd(a.L, 'T');
    Ivd(a.P, 'K');
    Ivd(a.P, 'V');
    Ivd(a.cb, 'E');
    tCd(UTd(a.b), a.bb);
    tCd(UTd(a.a), a.Q);
    tCd(UTd(a.o), a.p);
    tCd(UTd(a.p), a.R);
    tCd(UTd(a.q), a.p);
    tCd(UTd(a.v), a.q);
    tCd(UTd(a.w), a.R);
    tCd(UTd(a.B), a.Q);
    tCd(UTd(a.R), a.Q);
    tCd(UTd(a.T), a.eb);
    tCd(UTd(a.U), a.R);
    tCd(UTd(a.V), a.eb);
    tCd(UTd(a.W), a.bb);
    tCd(UTd(a.bb), a.eb);
    tCd(UTd(a.eb), a.R);
    tCd(UTd(a.db), a.R);
    Zvd(a.b, $5, TEe, false, false, true);
    Xvd(JD(nDd(STd(a.b), 0), 35), a.e, 'iD', null, 0, 1, $5, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.b), 1), 19), a.q, null, 'eAttributeType', 1, 1, $5, true, true, false, false, true, false, true);
    Zvd(a.a, Z5, QEe, false, false, true);
    Xvd(JD(nDd(STd(a.a), 0), 35), a._, cDe, null, 0, 1, Z5, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.a), 1), 19), a.ab, null, 'details', 0, -1, Z5, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.a), 2), 19), a.Q, JD(nDd(STd(a.Q), 0), 19), 'eModelElement', 0, 1, Z5, true, false, true, false, false, false, false);
    bwd(JD(nDd(STd(a.a), 3), 19), a.S, null, 'contents', 0, -1, Z5, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.a), 4), 19), a.S, null, 'references', 0, -1, Z5, false, false, true, false, true, false, false);
    Zvd(a.o, _5, 'EClass', false, false, true);
    Xvd(JD(nDd(STd(a.o), 0), 35), a.e, 'abstract', null, 0, 1, _5, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.o), 1), 35), a.e, 'interface', null, 0, 1, _5, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.o), 2), 19), a.o, null, 'eSuperTypes', 0, -1, _5, false, false, true, false, true, true, false);
    bwd(JD(nDd(STd(a.o), 3), 19), a.T, JD(nDd(STd(a.T), 0), 19), 'eOperations', 0, -1, _5, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.o), 4), 19), a.b, null, 'eAllAttributes', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 5), 19), a.W, null, 'eAllReferences', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 6), 19), a.W, null, 'eReferences', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 7), 19), a.b, null, 'eAttributes', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 8), 19), a.W, null, 'eAllContainments', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 9), 19), a.T, null, 'eAllOperations', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 10), 19), a.bb, null, 'eAllStructuralFeatures', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 11), 19), a.o, null, 'eAllSuperTypes', 0, -1, _5, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.o), 12), 19), a.b, null, 'eIDAttribute', 0, 1, _5, true, true, false, false, false, false, true);
    bwd(JD(nDd(STd(a.o), 13), 19), a.bb, JD(nDd(STd(a.bb), 7), 19), 'eStructuralFeatures', 0, -1, _5, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.o), 14), 19), a.H, null, 'eGenericSuperTypes', 0, -1, _5, false, false, true, true, false, true, false);
    bwd(JD(nDd(STd(a.o), 15), 19), a.H, null, 'eAllGenericSuperTypes', 0, -1, _5, true, true, false, false, true, false, true);
    h = awd(JD(nDd(PTd(a.o), 0), 62), a.e, 'isSuperTypeOf');
    Gvd(h, a.o, 'someClass');
    awd(JD(nDd(PTd(a.o), 1), 62), a.I, 'getFeatureCount');
    h = awd(JD(nDd(PTd(a.o), 2), 62), a.bb, FFe);
    Gvd(h, a.I, 'featureID');
    h = awd(JD(nDd(PTd(a.o), 3), 62), a.I, GFe);
    Gvd(h, a.bb, HFe);
    h = awd(JD(nDd(PTd(a.o), 4), 62), a.bb, FFe);
    Gvd(h, a._, 'featureName');
    awd(JD(nDd(PTd(a.o), 5), 62), a.I, 'getOperationCount');
    h = awd(JD(nDd(PTd(a.o), 6), 62), a.T, 'getEOperation');
    Gvd(h, a.I, 'operationID');
    h = awd(JD(nDd(PTd(a.o), 7), 62), a.I, IFe);
    Gvd(h, a.T, JFe);
    h = awd(JD(nDd(PTd(a.o), 8), 62), a.T, 'getOverride');
    Gvd(h, a.T, JFe);
    h = awd(JD(nDd(PTd(a.o), 9), 62), a.H, 'getFeatureType');
    Gvd(h, a.bb, HFe);
    Zvd(a.p, a6, UEe, true, false, true);
    Xvd(JD(nDd(STd(a.p), 0), 35), a._, 'instanceClassName', null, 0, 1, a6, false, true, true, true, true, false);
    b = Pvd(a.L);
    c = o6d();
    tCd((!b.d && (b.d = new qVd(g6, b, 1)), b.d), c);
    Yvd(JD(nDd(STd(a.p), 1), 35), b, 'instanceClass', a6, true, true, false, true);
    Xvd(JD(nDd(STd(a.p), 2), 35), a.M, KFe, null, 0, 1, a6, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.p), 3), 35), a._, 'instanceTypeName', null, 0, 1, a6, false, true, true, true, true, false);
    bwd(JD(nDd(STd(a.p), 4), 19), a.U, JD(nDd(STd(a.U), 3), 19), 'ePackage', 0, 1, a6, true, false, false, false, true, false, false);
    bwd(JD(nDd(STd(a.p), 5), 19), a.db, null, LFe, 0, -1, a6, false, false, true, true, true, false, false);
    h = awd(JD(nDd(PTd(a.p), 0), 62), a.e, MFe);
    Gvd(h, a.M, Cqe);
    awd(JD(nDd(PTd(a.p), 1), 62), a.I, 'getClassifierID');
    Zvd(a.q, c6, 'EDataType', false, false, true);
    Xvd(JD(nDd(STd(a.q), 0), 35), a.e, 'serializable', CBe, 0, 1, c6, false, false, true, false, true, false);
    Zvd(a.v, e6, 'EEnum', false, false, true);
    bwd(JD(nDd(STd(a.v), 0), 19), a.w, JD(nDd(STd(a.w), 3), 19), 'eLiterals', 0, -1, e6, false, false, true, true, false, false, false);
    h = awd(JD(nDd(PTd(a.v), 0), 62), a.w, NFe);
    Gvd(h, a._, HDe);
    h = awd(JD(nDd(PTd(a.v), 1), 62), a.w, NFe);
    Gvd(h, a.I, bDe);
    h = awd(JD(nDd(PTd(a.v), 2), 62), a.w, 'getEEnumLiteralByLiteral');
    Gvd(h, a._, 'literal');
    Zvd(a.w, d6, VEe, false, false, true);
    Xvd(JD(nDd(STd(a.w), 0), 35), a.I, bDe, null, 0, 1, d6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.w), 1), 35), a.A, 'instance', null, 0, 1, d6, true, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.w), 2), 35), a._, 'literal', null, 0, 1, d6, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.w), 3), 19), a.v, JD(nDd(STd(a.v), 0), 19), 'eEnum', 0, 1, d6, true, false, false, false, false, false, false);
    Zvd(a.B, f6, 'EFactory', false, false, true);
    bwd(JD(nDd(STd(a.B), 0), 19), a.U, JD(nDd(STd(a.U), 2), 19), 'ePackage', 1, 1, f6, true, false, true, false, false, false, false);
    h = awd(JD(nDd(PTd(a.B), 0), 62), a.S, 'create');
    Gvd(h, a.o, 'eClass');
    h = awd(JD(nDd(PTd(a.B), 1), 62), a.M, 'createFromString');
    Gvd(h, a.q, 'eDataType');
    Gvd(h, a._, 'literalValue');
    h = awd(JD(nDd(PTd(a.B), 2), 62), a._, 'convertToString');
    Gvd(h, a.q, 'eDataType');
    Gvd(h, a.M, 'instanceValue');
    Zvd(a.Q, h6, ECe, true, false, true);
    bwd(JD(nDd(STd(a.Q), 0), 19), a.a, JD(nDd(STd(a.a), 2), 19), 'eAnnotations', 0, -1, h6, false, false, true, true, false, false, false);
    h = awd(JD(nDd(PTd(a.Q), 0), 62), a.a, 'getEAnnotation');
    Gvd(h, a._, cDe);
    Zvd(a.R, i6, FCe, true, false, true);
    Xvd(JD(nDd(STd(a.R), 0), 35), a._, HDe, null, 0, 1, i6, false, false, true, false, true, false);
    Zvd(a.S, j6, 'EObject', false, false, true);
    awd(JD(nDd(PTd(a.S), 0), 62), a.o, 'eClass');
    awd(JD(nDd(PTd(a.S), 1), 62), a.e, 'eIsProxy');
    awd(JD(nDd(PTd(a.S), 2), 62), a.X, 'eResource');
    awd(JD(nDd(PTd(a.S), 3), 62), a.S, 'eContainer');
    awd(JD(nDd(PTd(a.S), 4), 62), a.bb, 'eContainingFeature');
    awd(JD(nDd(PTd(a.S), 5), 62), a.W, 'eContainmentFeature');
    h = awd(JD(nDd(PTd(a.S), 6), 62), null, 'eContents');
    b = Pvd(a.fb);
    c = Pvd(a.S);
    tCd((!b.d && (b.d = new qVd(g6, b, 1)), b.d), c);
    e = qRd(h, b, null);
    !!e && e.lj();
    h = awd(JD(nDd(PTd(a.S), 7), 62), null, 'eAllContents');
    b = Pvd(a.cb);
    c = Pvd(a.S);
    tCd((!b.d && (b.d = new qVd(g6, b, 1)), b.d), c);
    f = qRd(h, b, null);
    !!f && f.lj();
    h = awd(JD(nDd(PTd(a.S), 8), 62), null, 'eCrossReferences');
    b = Pvd(a.fb);
    c = Pvd(a.S);
    tCd((!b.d && (b.d = new qVd(g6, b, 1)), b.d), c);
    g = qRd(h, b, null);
    !!g && g.lj();
    h = awd(JD(nDd(PTd(a.S), 9), 62), a.M, 'eGet');
    Gvd(h, a.bb, HFe);
    h = awd(JD(nDd(PTd(a.S), 10), 62), a.M, 'eGet');
    Gvd(h, a.bb, HFe);
    Gvd(h, a.e, 'resolve');
    h = awd(JD(nDd(PTd(a.S), 11), 62), null, 'eSet');
    Gvd(h, a.bb, HFe);
    Gvd(h, a.M, 'newValue');
    h = awd(JD(nDd(PTd(a.S), 12), 62), a.e, 'eIsSet');
    Gvd(h, a.bb, HFe);
    h = awd(JD(nDd(PTd(a.S), 13), 62), null, 'eUnset');
    Gvd(h, a.bb, HFe);
    h = awd(JD(nDd(PTd(a.S), 14), 62), a.M, 'eInvoke');
    Gvd(h, a.T, JFe);
    b = Pvd(a.fb);
    c = o6d();
    tCd((!b.d && (b.d = new qVd(g6, b, 1)), b.d), c);
    Hvd(h, b, 'arguments');
    Evd(h, a.K);
    Zvd(a.T, k6, XEe, false, false, true);
    bwd(JD(nDd(STd(a.T), 0), 19), a.o, JD(nDd(STd(a.o), 3), 19), OFe, 0, 1, k6, true, false, false, false, false, false, false);
    bwd(JD(nDd(STd(a.T), 1), 19), a.db, null, LFe, 0, -1, k6, false, false, true, true, true, false, false);
    bwd(JD(nDd(STd(a.T), 2), 19), a.V, JD(nDd(STd(a.V), 0), 19), 'eParameters', 0, -1, k6, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.T), 3), 19), a.p, null, 'eExceptions', 0, -1, k6, false, false, true, false, true, true, false);
    bwd(JD(nDd(STd(a.T), 4), 19), a.H, null, 'eGenericExceptions', 0, -1, k6, false, false, true, true, false, true, false);
    awd(JD(nDd(PTd(a.T), 0), 62), a.I, IFe);
    h = awd(JD(nDd(PTd(a.T), 1), 62), a.e, 'isOverrideOf');
    Gvd(h, a.T, 'someOperation');
    Zvd(a.U, l6, 'EPackage', false, false, true);
    Xvd(JD(nDd(STd(a.U), 0), 35), a._, 'nsURI', null, 0, 1, l6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.U), 1), 35), a._, 'nsPrefix', null, 0, 1, l6, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.U), 2), 19), a.B, JD(nDd(STd(a.B), 0), 19), 'eFactoryInstance', 1, 1, l6, true, false, true, false, false, false, false);
    bwd(JD(nDd(STd(a.U), 3), 19), a.p, JD(nDd(STd(a.p), 4), 19), 'eClassifiers', 0, -1, l6, false, false, true, true, true, false, false);
    bwd(JD(nDd(STd(a.U), 4), 19), a.U, JD(nDd(STd(a.U), 5), 19), 'eSubpackages', 0, -1, l6, false, false, true, true, true, false, false);
    bwd(JD(nDd(STd(a.U), 5), 19), a.U, JD(nDd(STd(a.U), 4), 19), 'eSuperPackage', 0, 1, l6, true, false, false, false, true, false, false);
    h = awd(JD(nDd(PTd(a.U), 0), 62), a.p, 'getEClassifier');
    Gvd(h, a._, HDe);
    Zvd(a.V, m6, YEe, false, false, true);
    bwd(JD(nDd(STd(a.V), 0), 19), a.T, JD(nDd(STd(a.T), 2), 19), 'eOperation', 0, 1, m6, true, false, false, false, false, false, false);
    Zvd(a.W, n6, ZEe, false, false, true);
    Xvd(JD(nDd(STd(a.W), 0), 35), a.e, 'containment', null, 0, 1, n6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.W), 1), 35), a.e, 'container', null, 0, 1, n6, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.W), 2), 35), a.e, 'resolveProxies', CBe, 0, 1, n6, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.W), 3), 19), a.W, null, 'eOpposite', 0, 1, n6, false, false, true, false, true, false, false);
    bwd(JD(nDd(STd(a.W), 4), 19), a.o, null, 'eReferenceType', 1, 1, n6, true, true, false, false, true, false, true);
    bwd(JD(nDd(STd(a.W), 5), 19), a.b, null, 'eKeys', 0, -1, n6, false, false, true, false, true, false, false);
    Zvd(a.bb, q6, SEe, true, false, true);
    Xvd(JD(nDd(STd(a.bb), 0), 35), a.e, 'changeable', CBe, 0, 1, q6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.bb), 1), 35), a.e, 'volatile', null, 0, 1, q6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.bb), 2), 35), a.e, 'transient', null, 0, 1, q6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.bb), 3), 35), a._, 'defaultValueLiteral', null, 0, 1, q6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.bb), 4), 35), a.M, KFe, null, 0, 1, q6, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.bb), 5), 35), a.e, 'unsettable', null, 0, 1, q6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.bb), 6), 35), a.e, 'derived', null, 0, 1, q6, false, false, true, false, true, false);
    bwd(JD(nDd(STd(a.bb), 7), 19), a.o, JD(nDd(STd(a.o), 13), 19), OFe, 0, 1, q6, true, false, false, false, false, false, false);
    awd(JD(nDd(PTd(a.bb), 0), 62), a.I, GFe);
    h = awd(JD(nDd(PTd(a.bb), 1), 62), null, 'getContainerClass');
    b = Pvd(a.L);
    c = o6d();
    tCd((!b.d && (b.d = new qVd(g6, b, 1)), b.d), c);
    d = qRd(h, b, null);
    !!d && d.lj();
    Zvd(a.eb, s6, REe, true, false, true);
    Xvd(JD(nDd(STd(a.eb), 0), 35), a.e, 'ordered', CBe, 0, 1, s6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.eb), 1), 35), a.e, 'unique', CBe, 0, 1, s6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.eb), 2), 35), a.I, 'lowerBound', null, 0, 1, s6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.eb), 3), 35), a.I, 'upperBound', '1', 0, 1, s6, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.eb), 4), 35), a.e, 'many', null, 0, 1, s6, true, true, false, false, true, true);
    Xvd(JD(nDd(STd(a.eb), 5), 35), a.e, 'required', null, 0, 1, s6, true, true, false, false, true, true);
    bwd(JD(nDd(STd(a.eb), 6), 19), a.p, null, 'eType', 0, 1, s6, false, true, true, false, true, true, false);
    bwd(JD(nDd(STd(a.eb), 7), 19), a.H, null, 'eGenericType', 0, 1, s6, false, true, true, true, false, true, false);
    Zvd(a.ab, LK, 'EStringToStringMapEntry', false, false, false);
    Xvd(JD(nDd(STd(a.ab), 0), 35), a._, 'key', null, 0, 1, LK, false, false, true, false, true, false);
    Xvd(JD(nDd(STd(a.ab), 1), 35), a._, bDe, null, 0, 1, LK, false, false, true, false, true, false);
    Zvd(a.H, g6, WEe, false, false, true);
    bwd(JD(nDd(STd(a.H), 0), 19), a.H, null, 'eUpperBound', 0, 1, g6, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.H), 1), 19), a.H, null, 'eTypeArguments', 0, -1, g6, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.H), 2), 19), a.p, null, 'eRawType', 1, 1, g6, true, false, false, false, true, false, true);
    bwd(JD(nDd(STd(a.H), 3), 19), a.H, null, 'eLowerBound', 0, 1, g6, false, false, true, true, false, false, false);
    bwd(JD(nDd(STd(a.H), 4), 19), a.db, null, 'eTypeParameter', 0, 1, g6, false, false, true, false, false, false, false);
    bwd(JD(nDd(STd(a.H), 5), 19), a.p, null, 'eClassifier', 0, 1, g6, false, false, true, false, true, false, false);
    h = awd(JD(nDd(PTd(a.H), 0), 62), a.e, MFe);
    Gvd(h, a.M, Cqe);
    Zvd(a.db, r6, $Ee, false, false, true);
    bwd(JD(nDd(STd(a.db), 0), 19), a.H, null, 'eBounds', 0, -1, r6, false, false, true, true, false, false, false);
    _vd(a.c, kJ, 'EBigDecimal', true);
    _vd(a.d, lJ, 'EBigInteger', true);
    _vd(a.e, pcb, 'EBoolean', true);
    _vd(a.f, GI, 'EBooleanObject', true);
    _vd(a.i, $D, 'EByte', true);
    _vd(a.g, OC($D, 1), 'EByteArray', true);
    _vd(a.j, HI, 'EByteObject', true);
    _vd(a.k, _D, 'EChar', true);
    _vd(a.n, II, 'ECharacterObject', true);
    _vd(a.r, hK, 'EDate', true);
    _vd(a.s, L5, 'EDiagnosticChain', false);
    _vd(a.t, aE, 'EDouble', true);
    _vd(a.u, LI, 'EDoubleObject', true);
    _vd(a.fb, Q5, 'EEList', false);
    _vd(a.A, R5, 'EEnumerator', false);
    _vd(a.C, Lab, 'EFeatureMap', false);
    _vd(a.D, Bab, 'EFeatureMapEntry', false);
    _vd(a.F, bE, 'EFloat', true);
    _vd(a.G, QI, 'EFloatObject', true);
    _vd(a.I, cE, 'EInt', true);
    _vd(a.J, UI, 'EIntegerObject', true);
    _vd(a.L, KI, 'EJavaClass', true);
    _vd(a.M, aJ, 'EJavaObject', true);
    _vd(a.N, dE, 'ELong', true);
    _vd(a.O, XI, 'ELongObject', true);
    _vd(a.P, MK, 'EMap', false);
    _vd(a.X, s9, 'EResource', false);
    _vd(a.Y, r9, 'EResourceSet', false);
    _vd(a.Z, ocb, 'EShort', true);
    _vd(a.$, cJ, 'EShortObject', true);
    _vd(a._, hJ, 'EString', true);
    _vd(a.cb, U5, 'ETreeIterator', false);
    _vd(a.K, S5, 'EInvocationTargetException', false);
    Tvd(a, BFe);
}
var Cqe = 'object', Dqe = 'boolean', Eqe = 'number', Fqe = 'string', Gqe = 'function', Hqe = 2147483647, Iqe = 'java.lang', Jqe = {
    3: 1
}, Kqe = 'com.google.common.base', Lqe = ', ', Mqe = '%s (%s) must not be negative', Nqe = {
    3: 1,
    4: 1,
    5: 1
}, Oqe = 'negative size: ', Pqe = 'no calls to next() since the last call to remove()', Qqe = 'Optional.of(', Rqe = 'null', Sqe = {
    204: 1,
    49: 1
}, Tqe = 'com.google.common.collect', Uqe = {
    204: 1,
    49: 1,
    127: 1
}, Vqe = {
    228: 1,
    3: 1
}, Wqe = {
    49: 1
}, Xqe = 'java.util', Yqe = {
    91: 1
}, Zqe = {
    20: 1,
    31: 1,
    16: 1
}, $qe = 2009, _qe = {
    20: 1,
    31: 1,
    16: 1,
    22: 1
}, are = {
    91: 1,
    137: 1,
    134: 1
}, bre = {
    20: 1,
    31: 1,
    16: 1,
    22: 1,
    83: 1
}, cre = {
    20: 1,
    31: 1,
    16: 1,
    274: 1,
    22: 1,
    83: 1
}, dre = {
    49: 1,
    127: 1
}, ere = {
    355: 1,
    43: 1
}, fre = 'AbstractMapEntry', gre = 'expectedValuesPerKey', hre = {
    3: 1,
    6: 1,
    4: 1,
    5: 1
}, ire = 16384, jre = {
    158: 1
}, kre = {
    40: 1
}, lre = {
    202: 1
}, mre = {
    l: 4194303,
    m: 4194303,
    h: 524287
}, nre = {
    252: 1,
    3: 1,
    34: 1
}, ore = 'range unbounded on this side', pre = {
    20: 1
}, qre = {
    20: 1,
    16: 1
}, rre = {
    3: 1,
    20: 1,
    31: 1,
    16: 1
}, sre = {
    308: 1,
    3: 1,
    20: 1,
    31: 1,
    16: 1,
    15: 1,
    59: 1
}, tre = {
    3: 1,
    4: 1,
    5: 1,
    174: 1
}, ure = {
    3: 1,
    91: 1
}, vre = {
    20: 1,
    16: 1,
    22: 1
}, wre = {
    3: 1,
    20: 1,
    31: 1,
    16: 1,
    22: 1
}, xre = {
    20: 1,
    16: 1,
    22: 1,
    83: 1
}, yre = 461845907, zre = -862048943, Are = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    174: 1
}, Bre = 'expectedSize', Cre = 1073741824, Dre = 'initialArraySize', Ere = {
    3: 1,
    6: 1,
    4: 1,
    10: 1,
    5: 1
}, Fre = {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1
}, Gre = 'arraySize', Hre = {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, Ire = {
    48: 1
}, Jre = {
    372: 1
}, Kre = 1.0E-4, Lre = -2147483648, Mre = '__noinit__', Nre = {
    3: 1,
    103: 1,
    63: 1,
    80: 1
}, Ore = 'com.google.gwt.core.client.impl', Pre = 'String', Qre = 'com.google.gwt.core.client', Rre = 'anonymous', Sre = 'fnStack', Tre = 'Unknown', Ure = {
    201: 1,
    3: 1,
    4: 1
}, Vre = 1000, Wre = 65535, Xre = 'January', Yre = 'February', Zre = 'March', $re = 'April', _re = 'May', ase = 'June', bse = 'July', cse = 'August', dse = 'September', ese = 'October', fse = 'November', gse = 'December', hse = 1900, ise = {
    54: 1,
    3: 1,
    4: 1
}, jse = 'Before Christ', kse = 'Anno Domini', lse = 'Sunday', mse = 'Monday', nse = 'Tuesday', ose = 'Wednesday', pse = 'Thursday', qse = 'Friday', rse = 'Saturday', sse = 'com.google.gwt.i18n.shared', tse = 'DateTimeFormat', use = 'com.google.gwt.i18n.client', vse = 'DefaultDateTimeFormatInfo', wse = 2048, xse = {
    3: 1,
    4: 1,
    34: 1,
    205: 1
}, yse = 'com.google.gwt.json.client', zse = 4194303, Ase = 1048575, Bse = 524288, Cse = 4194304, Dse = 17592186044416, Ese = 1000000000, Fse = -17592186044416, Gse = 'java.io', Hse = {
    3: 1,
    103: 1,
    97: 1,
    63: 1,
    80: 1
}, Ise = {
    3: 1,
    294: 1,
    80: 1
}, Jse = 'For input string: "', Kse = Infinity, Lse = -Infinity, Mse = 4096, Nse = {
    3: 1,
    4: 1,
    579: 1
}, Ose = 'org.eclipse.elk.layered', Pse = 65536, Qse = 55296, Rse = {
    108: 1,
    3: 1,
    4: 1
}, Sse = 100000, Tse = 0.3010299956639812, Use = 4294967295, Vse = '0.0', Wse = {
    43: 1
}, Xse = 'Unable to add element to queue', Yse = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    13: 1,
    16: 1,
    15: 1,
    59: 1
}, Zse = {
    3: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, $se = {
    20: 1,
    16: 1,
    15: 1
}, _se = {
    3: 1,
    51: 1
}, ate = {
    189: 1
}, bte = {
    3: 1,
    4: 1,
    91: 1
}, cte = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    16: 1,
    50: 1,
    22: 1
}, dte = 'delete', ete = 1.4901161193847656E-8, fte = 1.1102230246251565E-16, gte = 15525485, hte = 5.9604644775390625E-8, ite = 16777216, jte = 16777215, kte = ', length: ', lte = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, mte = 'subMap: ', nte = ' less than ', ote = {
    3: 1,
    34: 1,
    23: 1,
    305: 1
}, pte = 'java.util.function', qte = 'java.util.logging', rte = {
    3: 1,
    4: 1,
    5: 1,
    835: 1
}, ste = 'undefined', tte = 'java.util.stream', ute = {
    518: 1,
    672: 1
}, vte = 'fromIndex: ', wte = ' > toIndex: ', xte = ', toIndex: ', yte = 'Index: ', zte = ', Size: ', Ate = 'org.eclipse.elk.alg.common', Bte = {
    51: 1
}, Cte = 'org.eclipse.elk.alg.common.compaction', Dte = 'Scanline/EventHandler', Ete = 'org.eclipse.elk.alg.common.compaction.oned', Fte = 'CNode belongs to another CGroup.', Gte = 'ISpacingsHandler/1', Hte = 'The ', Ite = ' instance has been finished already.', Jte = 'The direction ', Kte = ' is not supported by the CGraph instance.', Lte = 'OneDimensionalCompactor', Mte = 'OneDimensionalCompactor/lambda$0$Type', Nte = 'Quadruplet', Ote = 'ScanlineConstraintCalculator', Pte = 'ScanlineConstraintCalculator/ConstraintsScanlineHandler', Qte = 'ScanlineConstraintCalculator/ConstraintsScanlineHandler/lambda$0$Type', Rte = 'ScanlineConstraintCalculator/Timestamp', Ste = 'ScanlineConstraintCalculator/lambda$0$Type', Tte = {
    177: 1,
    48: 1
}, Ute = 'org.eclipse.elk.alg.common.networksimplex', Vte = {
    183: 1,
    3: 1,
    4: 1
}, Wte = 'org.eclipse.elk.alg.common.nodespacing', Xte = 'org.eclipse.elk.alg.common.nodespacing.cellsystem', Yte = 'CENTER', Zte = {
    215: 1,
    332: 1
}, $te = {
    3: 1,
    4: 1,
    5: 1,
    587: 1
}, _te = 'LEFT', aue = 'RIGHT', bue = 'Vertical alignment cannot be null', cue = 'BOTTOM', due = 'org.eclipse.elk.alg.common.nodespacing.internal', eue = 'UNDEFINED', fue = 0.01, gue = 'org.eclipse.elk.alg.common.nodespacing.internal.algorithm', hue = 'LabelPlacer/lambda$0$Type', iue = 'LabelPlacer/lambda$1$Type', jue = 'portRatioOrPosition', kue = 'org.eclipse.elk.alg.common.overlaps', lue = 'DOWN', mue = 'org.eclipse.elk.alg.common.spore', nue = {
    3: 1,
    4: 1,
    5: 1,
    198: 1
}, oue = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    99: 1,
    114: 1
}, pue = 'org.eclipse.elk.alg.force', que = 'ComponentsProcessor', rue = 'ComponentsProcessor/1', sue = 'ElkGraphImporter/lambda$0$Type', tue = {
    222: 1
}, uue = 'org.eclipse.elk.core', vue = 'org.eclipse.elk.graph.properties', wue = 'IPropertyHolder', xue = 'org.eclipse.elk.alg.force.graph', yue = 'Component Layout', zue = 'org.eclipse.elk.alg.force.model', Aue = 'org.eclipse.elk.core.data', Bue = 'org.eclipse.elk.force.model', Cue = 'org.eclipse.elk.force.iterations', Due = 'org.eclipse.elk.force.repulsivePower', Eue = 'org.eclipse.elk.force.temperature', Fue = 0.001, Gue = 'org.eclipse.elk.force.repulsion', Hue = {
    146: 1
}, Iue = 'org.eclipse.elk.alg.force.options', Jue = 1.600000023841858, Kue = 'org.eclipse.elk.force', Lue = 'org.eclipse.elk.priority', Mue = 'org.eclipse.elk.spacing.nodeNode', Nue = 'org.eclipse.elk.spacing.edgeLabel', Oue = 'org.eclipse.elk.aspectRatio', Pue = 'org.eclipse.elk.randomSeed', Que = 'org.eclipse.elk.separateConnectedComponents', Rue = 'org.eclipse.elk.padding', Sue = 'org.eclipse.elk.interactive', Tue = 'org.eclipse.elk.portConstraints', Uue = 'org.eclipse.elk.edgeLabels.inline', Vue = 'org.eclipse.elk.omitNodeMicroLayout', Wue = 'org.eclipse.elk.nodeSize.fixedGraphSize', Xue = 'org.eclipse.elk.nodeSize.options', Yue = 'org.eclipse.elk.nodeSize.constraints', Zue = 'org.eclipse.elk.nodeLabels.placement', $ue = 'org.eclipse.elk.portLabels.placement', _ue = 'org.eclipse.elk.topdownLayout', ave = 'org.eclipse.elk.topdown.scaleFactor', bve = 'org.eclipse.elk.topdown.hierarchicalNodeWidth', cve = 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', dve = 'org.eclipse.elk.topdown.nodeType', eve = 'origin', fve = 'random', gve = 'boundingBox.upLeft', hve = 'boundingBox.lowRight', ive = 'org.eclipse.elk.stress.fixed', jve = 'org.eclipse.elk.stress.desiredEdgeLength', kve = 'org.eclipse.elk.stress.dimension', lve = 'org.eclipse.elk.stress.epsilon', mve = 'org.eclipse.elk.stress.iterationLimit', nve = 'org.eclipse.elk.stress', ove = 'ELK Stress', pve = 'org.eclipse.elk.nodeSize.minimum', qve = 'org.eclipse.elk.alg.force.stress', rve = 'Layered layout', sve = 'org.eclipse.elk.alg.layered', tve = 'org.eclipse.elk.alg.layered.compaction.components', uve = 'org.eclipse.elk.alg.layered.compaction.oned', vve = 'org.eclipse.elk.alg.layered.compaction.oned.algs', wve = 'org.eclipse.elk.alg.layered.compaction.recthull', xve = 'org.eclipse.elk.alg.layered.components', yve = 'NONE', zve = 'MODEL_ORDER', Ave = {
    3: 1,
    6: 1,
    4: 1,
    10: 1,
    5: 1,
    125: 1
}, Bve = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    145: 1,
    99: 1,
    114: 1
}, Cve = 'org.eclipse.elk.alg.layered.compound', Dve = {
    44: 1
}, Eve = 'org.eclipse.elk.alg.layered.graph', Fve = ' -> ', Gve = 'Not supported by LGraph', Hve = 'Port side is undefined', Ive = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    469: 1,
    145: 1,
    99: 1,
    114: 1
}, Jve = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    145: 1,
    199: 1,
    209: 1,
    99: 1,
    114: 1
}, Kve = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    145: 1,
    1988: 1,
    209: 1,
    99: 1,
    114: 1
}, Lve = '([{"\' \t\r\n', Mve = ')]}"\' \t\r\n', Nve = 'The given string contains parts that cannot be parsed as numbers.', Ove = 'org.eclipse.elk.core.math', Pve = {
    3: 1,
    4: 1,
    139: 1,
    213: 1,
    411: 1
}, Qve = {
    3: 1,
    4: 1,
    107: 1,
    213: 1,
    411: 1
}, Rve = 'org.eclipse.elk.alg.layered.graph.transform', Sve = 'ElkGraphImporter', Tve = 'ElkGraphImporter/lambda$1$Type', Uve = 'ElkGraphImporter/lambda$2$Type', Vve = 'ElkGraphImporter/lambda$4$Type', Wve = 'org.eclipse.elk.alg.layered.intermediate', Xve = 'Node margin calculation', Yve = 'ONE_SIDED_GREEDY_SWITCH', Zve = 'TWO_SIDED_GREEDY_SWITCH', $ve = 'No implementation is available for the layout processor ', _ve = 'IntermediateProcessorStrategy', awe = "Node '", bwe = 'FIRST_SEPARATE', cwe = 'LAST_SEPARATE', dwe = 'Odd port side processing', ewe = 'org.eclipse.elk.alg.layered.intermediate.compaction', fwe = 'org.eclipse.elk.alg.layered.intermediate.greedyswitch', gwe = 'org.eclipse.elk.alg.layered.p3order.counting', hwe = {
    229: 1
}, iwe = 'org.eclipse.elk.alg.layered.intermediate.loops', jwe = 'org.eclipse.elk.alg.layered.intermediate.loops.ordering', kwe = 'org.eclipse.elk.alg.layered.intermediate.loops.routing', lwe = 'org.eclipse.elk.alg.layered.intermediate.preserveorder', mwe = 'org.eclipse.elk.alg.layered.intermediate.wrapping', nwe = 'org.eclipse.elk.alg.layered.options', owe = 'INTERACTIVE', pwe = 'GREEDY', qwe = 'DEPTH_FIRST', rwe = 'EDGE_LENGTH', swe = 'SELF_LOOPS', twe = 'firstTryWithInitialOrder', uwe = 'org.eclipse.elk.layered.directionCongruency', vwe = 'org.eclipse.elk.layered.feedbackEdges', wwe = 'org.eclipse.elk.layered.interactiveReferencePoint', xwe = 'org.eclipse.elk.layered.mergeEdges', ywe = 'org.eclipse.elk.layered.mergeHierarchyEdges', zwe = 'org.eclipse.elk.layered.allowNonFlowPortsToSwitchSides', Awe = 'org.eclipse.elk.layered.portSortingStrategy', Bwe = 'org.eclipse.elk.layered.thoroughness', Cwe = 'org.eclipse.elk.layered.unnecessaryBendpoints', Dwe = 'org.eclipse.elk.layered.generatePositionAndLayerIds', Ewe = 'org.eclipse.elk.layered.cycleBreaking.strategy', Fwe = 'org.eclipse.elk.layered.layering.strategy', Gwe = 'org.eclipse.elk.layered.layering.layerConstraint', Hwe = 'org.eclipse.elk.layered.layering.layerChoiceConstraint', Iwe = 'org.eclipse.elk.layered.layering.layerId', Jwe = 'org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth', Kwe = 'org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor', Lwe = 'org.eclipse.elk.layered.layering.nodePromotion.strategy', Mwe = 'org.eclipse.elk.layered.layering.nodePromotion.maxIterations', Nwe = 'org.eclipse.elk.layered.layering.coffmanGraham.layerBound', Owe = 'org.eclipse.elk.layered.crossingMinimization.strategy', Pwe = 'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder', Qwe = 'org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness', Rwe = 'org.eclipse.elk.layered.crossingMinimization.semiInteractive', Swe = 'org.eclipse.elk.layered.crossingMinimization.inLayerPredOf', Twe = 'org.eclipse.elk.layered.crossingMinimization.inLayerSuccOf', Uwe = 'org.eclipse.elk.layered.crossingMinimization.positionChoiceConstraint', Vwe = 'org.eclipse.elk.layered.crossingMinimization.positionId', Wwe = 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.activationThreshold', Xwe = 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.type', Ywe = 'org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type', Zwe = 'org.eclipse.elk.layered.nodePlacement.strategy', $we = 'org.eclipse.elk.layered.nodePlacement.favorStraightEdges', _we = 'org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening', axe = 'org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment', bxe = 'org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening', cxe = 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility', dxe = 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default', exe = 'org.eclipse.elk.layered.edgeRouting.selfLoopDistribution', fxe = 'org.eclipse.elk.layered.edgeRouting.selfLoopOrdering', gxe = 'org.eclipse.elk.layered.edgeRouting.splines.mode', hxe = 'org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor', ixe = 'org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth', jxe = 'org.eclipse.elk.layered.spacing.baseValue', kxe = 'org.eclipse.elk.layered.spacing.edgeNodeBetweenLayers', lxe = 'org.eclipse.elk.layered.spacing.edgeEdgeBetweenLayers', mxe = 'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers', nxe = 'org.eclipse.elk.layered.priority.direction', oxe = 'org.eclipse.elk.layered.priority.shortness', pxe = 'org.eclipse.elk.layered.priority.straightness', qxe = 'org.eclipse.elk.layered.compaction.connectedComponents', rxe = 'org.eclipse.elk.layered.compaction.postCompaction.strategy', sxe = 'org.eclipse.elk.layered.compaction.postCompaction.constraints', txe = 'org.eclipse.elk.layered.highDegreeNodes.treatment', uxe = 'org.eclipse.elk.layered.highDegreeNodes.threshold', vxe = 'org.eclipse.elk.layered.highDegreeNodes.treeHeight', wxe = 'org.eclipse.elk.layered.wrapping.strategy', xxe = 'org.eclipse.elk.layered.wrapping.additionalEdgeSpacing', yxe = 'org.eclipse.elk.layered.wrapping.correctionFactor', zxe = 'org.eclipse.elk.layered.wrapping.cutting.strategy', Axe = 'org.eclipse.elk.layered.wrapping.cutting.cuts', Bxe = 'org.eclipse.elk.layered.wrapping.cutting.msd.freedom', Cxe = 'org.eclipse.elk.layered.wrapping.validify.strategy', Dxe = 'org.eclipse.elk.layered.wrapping.validify.forbiddenIndices', Exe = 'org.eclipse.elk.layered.wrapping.multiEdge.improveCuts', Fxe = 'org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty', Gxe = 'org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges', Hxe = 'org.eclipse.elk.layered.layerUnzipping.strategy', Ixe = 'org.eclipse.elk.layered.layerUnzipping.layerSplit', Jxe = 'org.eclipse.elk.layered.layerUnzipping.resetOnLongEdges', Kxe = 'org.eclipse.elk.layered.edgeLabels.sideSelection', Lxe = 'org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy', Mxe = 'org.eclipse.elk.layered.considerModelOrder.strategy', Nxe = 'org.eclipse.elk.layered.considerModelOrder.portModelOrder', Oxe = 'org.eclipse.elk.layered.considerModelOrder.noModelOrder', Pxe = 'org.eclipse.elk.layered.considerModelOrder.components', Qxe = 'org.eclipse.elk.layered.considerModelOrder.longEdgeStrategy', Rxe = 'org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence', Sxe = 'org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence', Txe = 'layering', Uxe = 'layering.minWidth', Vxe = 'layering.nodePromotion', Wxe = 'crossingMinimization', Xxe = 'org.eclipse.elk.hierarchyHandling', Yxe = 'crossingMinimization.greedySwitch', Zxe = 'nodePlacement', $xe = 'nodePlacement.bk', _xe = 'edgeRouting', aye = 'org.eclipse.elk.edgeRouting', bye = 'spacing', cye = 'priority', dye = 'compaction', eye = 'compaction.postCompaction', fye = 'Specifies whether and how post-process compaction is applied.', gye = 'highDegreeNodes', hye = 'wrapping', iye = 'wrapping.cutting', jye = 'wrapping.validify', kye = 'wrapping.multiEdge', lye = 'layerUnzipping', mye = 'edgeLabels', nye = 'considerModelOrder', oye = 'org.eclipse.elk.spacing.commentComment', pye = 'org.eclipse.elk.spacing.commentNode', qye = 'org.eclipse.elk.spacing.componentComponent', rye = 'org.eclipse.elk.spacing.edgeEdge', sye = 'org.eclipse.elk.spacing.edgeNode', tye = 'org.eclipse.elk.spacing.labelLabel', uye = 'org.eclipse.elk.spacing.labelPortHorizontal', vye = 'org.eclipse.elk.spacing.labelPortVertical', wye = 'org.eclipse.elk.spacing.labelNode', xye = 'org.eclipse.elk.spacing.nodeSelfLoop', yye = 'org.eclipse.elk.spacing.portPort', zye = 'org.eclipse.elk.spacing.individual', Aye = 'org.eclipse.elk.port.borderOffset', Bye = 'org.eclipse.elk.noLayout', Cye = 'org.eclipse.elk.port.side', Dye = 'org.eclipse.elk.debugMode', Eye = 'org.eclipse.elk.alignment', Fye = 'org.eclipse.elk.insideSelfLoops.activate', Gye = 'org.eclipse.elk.insideSelfLoops.yo', Hye = 'org.eclipse.elk.direction', Iye = 'org.eclipse.elk.nodeLabels.padding', Jye = 'org.eclipse.elk.portLabels.nextToPortIfPossible', Kye = 'org.eclipse.elk.portLabels.treatAsGroup', Lye = 'org.eclipse.elk.portAlignment.default', Mye = 'org.eclipse.elk.portAlignment.north', Nye = 'org.eclipse.elk.portAlignment.south', Oye = 'org.eclipse.elk.portAlignment.west', Pye = 'org.eclipse.elk.portAlignment.east', Qye = 'org.eclipse.elk.contentAlignment', Rye = 'org.eclipse.elk.junctionPoints', Sye = 'org.eclipse.elk.edge.thickness', Tye = 'org.eclipse.elk.edgeLabels.placement', Uye = 'org.eclipse.elk.port.index', Vye = 'org.eclipse.elk.commentBox', Wye = 'org.eclipse.elk.hypernode', Xye = 'org.eclipse.elk.port.anchor', Yye = 'org.eclipse.elk.partitioning.activate', Zye = 'org.eclipse.elk.partitioning.partition', $ye = 'org.eclipse.elk.position', _ye = 'org.eclipse.elk.margins', aze = 'org.eclipse.elk.spacing.portsSurrounding', bze = 'org.eclipse.elk.interactiveLayout', cze = 'org.eclipse.elk.core.util', dze = {
    3: 1,
    4: 1,
    5: 1,
    585: 1
}, eze = 'NETWORK_SIMPLEX', fze = 'SIMPLE', gze = {
    106: 1,
    44: 1
}, hze = 'org.eclipse.elk.alg.layered.p1cycles', ize = 'org.eclipse.elk.alg.layered.p2layers', jze = {
    402: 1,
    229: 1
}, kze = {
    825: 1,
    3: 1,
    4: 1
}, lze = 'org.eclipse.elk.alg.layered.p3order', mze = 1.7976931348623157E308, nze = 'org.eclipse.elk.alg.layered.p4nodes', oze = {
    3: 1,
    4: 1,
    5: 1,
    833: 1
}, pze = 1.0E-5, qze = 'org.eclipse.elk.alg.layered.p4nodes.bk', rze = 'org.eclipse.elk.alg.layered.p5edges', sze = 'org.eclipse.elk.alg.layered.p5edges.orthogonal', tze = 'org.eclipse.elk.alg.layered.p5edges.orthogonal.direction', uze = 1.0E-6, vze = 'org.eclipse.elk.alg.layered.p5edges.splines', wze = 0.09999999999999998, xze = 1.0E-8, yze = 4.71238898038469, zze = 1.5707963267948966, Aze = 3.141592653589793, Bze = 'org.eclipse.elk.alg.mrtree', Cze = 0.10000000149011612, Dze = 'SUPER_ROOT', Eze = 'org.eclipse.elk.alg.mrtree.graph', Fze = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, Gze = 'org.eclipse.elk.alg.mrtree.intermediate', Hze = 'Processor compute fanout', Ize = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    519: 1,
    99: 1,
    114: 1
}, Jze = 'Set neighbors in level', Kze = 'org.eclipse.elk.alg.mrtree.options', Lze = 'DESCENDANTS', Mze = 'org.eclipse.elk.mrtree.compaction', Nze = 'org.eclipse.elk.mrtree.edgeEndTextureLength', Oze = 'org.eclipse.elk.mrtree.treeLevel', Pze = 'org.eclipse.elk.mrtree.positionConstraint', Qze = 'org.eclipse.elk.mrtree.weighting', Rze = 'org.eclipse.elk.mrtree.edgeRoutingMode', Sze = 'org.eclipse.elk.mrtree.searchOrder', Tze = 'Position Constraint', Uze = 'org.eclipse.elk.mrtree', Vze = 'org.eclipse.elk.tree', Wze = 'Processor arrange level', Xze = 'org.eclipse.elk.alg.mrtree.p2order', Yze = 'org.eclipse.elk.alg.mrtree.p4route', Zze = 'org.eclipse.elk.alg.radial', $ze = 6.283185307179586, _ze = 'Before', aAe = 4.9E-324, bAe = 'After', cAe = 'org.eclipse.elk.alg.radial.intermediate', dAe = 'COMPACTION', eAe = 'org.eclipse.elk.alg.radial.intermediate.compaction', fAe = {
    3: 1,
    4: 1,
    5: 1,
    99: 1
}, gAe = 'org.eclipse.elk.alg.radial.intermediate.optimization', hAe = 'No implementation is available for the layout option ', iAe = 'org.eclipse.elk.alg.radial.options', jAe = 'CompactionStrategy', kAe = 'org.eclipse.elk.radial.centerOnRoot', lAe = 'org.eclipse.elk.radial.orderId', mAe = 'org.eclipse.elk.radial.radius', nAe = 'org.eclipse.elk.radial.rotate', oAe = 'org.eclipse.elk.radial.compactor', pAe = 'org.eclipse.elk.radial.compactionStepSize', qAe = 'org.eclipse.elk.radial.sorter', rAe = 'org.eclipse.elk.radial.wedgeCriteria', sAe = 'org.eclipse.elk.radial.optimizationCriteria', tAe = 'org.eclipse.elk.radial.rotation.targetAngle', uAe = 'org.eclipse.elk.radial.rotation.computeAdditionalWedgeSpace', vAe = 'org.eclipse.elk.radial.rotation.outgoingEdgeAngles', wAe = 'Compaction', xAe = 'rotation', yAe = 'org.eclipse.elk.radial', zAe = 'org.eclipse.elk.alg.radial.p1position.wedge', AAe = 'org.eclipse.elk.alg.radial.sorting', BAe = 5.497787143782138, CAe = 3.9269908169872414, DAe = 2.356194490192345, EAe = 'org.eclipse.elk.alg.rectpacking', FAe = 'org.eclipse.elk.alg.rectpacking.intermediate', GAe = 'org.eclipse.elk.alg.rectpacking.options', HAe = 'org.eclipse.elk.rectpacking.trybox', IAe = 'org.eclipse.elk.rectpacking.currentPosition', JAe = 'org.eclipse.elk.rectpacking.desiredPosition', KAe = 'org.eclipse.elk.rectpacking.inNewRow', LAe = 'org.eclipse.elk.rectpacking.orderBySize', MAe = 'org.eclipse.elk.rectpacking.widthApproximation.strategy', NAe = 'org.eclipse.elk.rectpacking.widthApproximation.targetWidth', OAe = 'org.eclipse.elk.rectpacking.widthApproximation.optimizationGoal', PAe = 'org.eclipse.elk.rectpacking.widthApproximation.lastPlaceShift', QAe = 'org.eclipse.elk.rectpacking.packing.strategy', RAe = 'org.eclipse.elk.rectpacking.packing.compaction.rowHeightReevaluation', SAe = 'org.eclipse.elk.rectpacking.packing.compaction.iterations', TAe = 'org.eclipse.elk.rectpacking.whiteSpaceElimination.strategy', UAe = 'widthApproximation', VAe = 'Compaction Strategy', WAe = 'packing.compaction', XAe = 'org.eclipse.elk.rectpacking', YAe = 'org.eclipse.elk.alg.rectpacking.p1widthapproximation', ZAe = 'org.eclipse.elk.alg.rectpacking.p2packing', $Ae = 'No Compaction', _Ae = 'org.eclipse.elk.alg.rectpacking.p3whitespaceelimination', aBe = 'org.eclipse.elk.alg.rectpacking.util', bBe = 'No implementation available for ', cBe = 'org.eclipse.elk.alg.spore', dBe = 'org.eclipse.elk.alg.spore.options', eBe = 'org.eclipse.elk.sporeCompaction', fBe = 'org.eclipse.elk.underlyingLayoutAlgorithm', gBe = 'org.eclipse.elk.processingOrder.treeConstruction', hBe = 'org.eclipse.elk.processingOrder.spanningTreeCostFunction', iBe = 'org.eclipse.elk.processingOrder.preferredRoot', jBe = 'org.eclipse.elk.processingOrder.rootSelection', kBe = 'org.eclipse.elk.structure.structureExtractionStrategy', lBe = 'org.eclipse.elk.compaction.compactionStrategy', mBe = 'org.eclipse.elk.compaction.orthogonal', nBe = 'org.eclipse.elk.overlapRemoval.maxIterations', oBe = 'org.eclipse.elk.overlapRemoval.runScanline', pBe = 'processingOrder', qBe = 'overlapRemoval', rBe = 'org.eclipse.elk.sporeOverlap', sBe = 'org.eclipse.elk.alg.spore.p1structure', tBe = 'org.eclipse.elk.alg.spore.p2processingorder', uBe = 'org.eclipse.elk.alg.spore.p3execution', vBe = 'Topdown Layout', wBe = 'Invalid index: ', xBe = 'org.eclipse.elk.core.alg', yBe = {
    337: 1
}, zBe = {
    293: 1
}, ABe = 'Make sure its type is registered with the ', BBe = ' utility class.', CBe = 'true', DBe = 'false', EBe = "Couldn't clone property '", FBe = 0.05, GBe = 'org.eclipse.elk.core.options', HBe = 1.2999999523162842, IBe = 'org.eclipse.elk.box', JBe = 'org.eclipse.elk.expandNodes', KBe = 'org.eclipse.elk.box.packingMode', LBe = 'org.eclipse.elk.algorithm', MBe = 'org.eclipse.elk.resolvedAlgorithm', NBe = 'org.eclipse.elk.bendPoints', OBe = 'org.eclipse.elk.labelManager', PBe = 'org.eclipse.elk.softwrappingFuzziness', QBe = 'org.eclipse.elk.scaleFactor', RBe = 'org.eclipse.elk.childAreaWidth', SBe = 'org.eclipse.elk.childAreaHeight', TBe = 'org.eclipse.elk.animate', UBe = 'org.eclipse.elk.animTimeFactor', VBe = 'org.eclipse.elk.layoutAncestors', WBe = 'org.eclipse.elk.maxAnimTime', XBe = 'org.eclipse.elk.minAnimTime', YBe = 'org.eclipse.elk.progressBar', ZBe = 'org.eclipse.elk.validateGraph', $Be = 'org.eclipse.elk.validateOptions', _Be = 'org.eclipse.elk.zoomToFit', aCe = 'org.eclipse.elk.json.shapeCoords', bCe = 'org.eclipse.elk.json.edgeCoords', cCe = 'org.eclipse.elk.font.name', dCe = 'org.eclipse.elk.font.size', eCe = 'org.eclipse.elk.topdown.sizeApproximator', fCe = 'org.eclipse.elk.topdown.scaleCap', gCe = 'org.eclipse.elk.edge.type', hCe = 'partitioning', iCe = 'nodeLabels', jCe = 'portAlignment', kCe = 'nodeSize', lCe = 'port', mCe = 'portLabels', nCe = 'topdown', oCe = 'insideSelfLoops', pCe = 'INHERIT', qCe = 'org.eclipse.elk.fixed', rCe = 'org.eclipse.elk.random', sCe = {
    3: 1,
    34: 1,
    23: 1,
    343: 1
}, tCe = 'port must have a parent node to calculate the port side', uCe = 'The edge needs to have exactly one edge section. Found: ', vCe = 'org.eclipse.elk.core.util.adapters', wCe = 'org.eclipse.emf.ecore', xCe = 'org.eclipse.elk.graph', yCe = 'EMapPropertyHolder', zCe = 'ElkBendPoint', ACe = 'ElkGraphElement', BCe = 'ElkConnectableShape', CCe = 'ElkEdge', DCe = 'ElkEdgeSection', ECe = 'EModelElement', FCe = 'ENamedElement', GCe = 'ElkLabel', HCe = 'ElkNode', ICe = 'ElkPort', JCe = {
    93: 1,
    92: 1
}, KCe = 'org.eclipse.emf.common.notify.impl', LCe = "The feature '", MCe = "' is not a valid changeable feature", NCe = 'Expecting null', OCe = "' is not a valid feature", PCe = 'The feature ID', QCe = ' is not a valid feature ID', RCe = 32768, SCe = {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1
}, TCe = 'org.eclipse.emf.ecore.impl', UCe = 'org.eclipse.elk.graph.impl', VCe = 'Recursive containment not allowed for ', WCe = "The datatype '", XCe = "' is not a valid classifier", YCe = "The value '", ZCe = {
    195: 1,
    3: 1,
    4: 1
}, $Ce = "The class '", _Ce = 'http://www.eclipse.org/elk/ElkGraph', aDe = 'property', bDe = 'value', cDe = 'source', dDe = 'properties', eDe = 'identifier', fDe = 'height', gDe = 'width', hDe = 'parent', iDe = 'text', jDe = 'children', kDe = 'hierarchical', lDe = 'sources', mDe = 'targets', nDe = 'sections', oDe = 'bendPoints', pDe = 'outgoingShape', qDe = 'incomingShape', rDe = 'outgoingSections', sDe = 'incomingSections', tDe = 'org.eclipse.emf.common.util', uDe = 'Severe implementation error in the Json to ElkGraph importer.', vDe = 'id', wDe = 'org.eclipse.elk.graph.json', xDe = 'Unhandled parameter types: ', yDe = 'startPoint', zDe = "An edge must have at least one source and one target (edge id: '", ADe = "').", BDe = 'Referenced edge section does not exist: ', CDe = " (edge id: '", DDe = 'target', EDe = 'sourcePoint', FDe = 'targetPoint', GDe = 'group', HDe = 'name', IDe = 'connectableShape cannot be null', JDe = 'edge cannot be null', KDe = "Passed edge is not 'simple'.", LDe = 'org.eclipse.elk.graph.util', MDe = "The 'no duplicates' constraint is violated", NDe = 'targetIndex=', ODe = ', size=', PDe = 'sourceIndex=', QDe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1
}, RDe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    49: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    580: 1
}, SDe = 'logging', TDe = 'measureExecutionTime', UDe = 'parser.parse.1', VDe = 'parser.parse.2', WDe = 'parser.next.1', XDe = 'parser.next.2', YDe = 'parser.next.3', ZDe = 'parser.next.4', $De = 'parser.factor.1', _De = 'parser.factor.2', aEe = 'parser.factor.3', bEe = 'parser.factor.4', cEe = 'parser.factor.5', dEe = 'parser.factor.6', eEe = 'parser.atom.1', fEe = 'parser.atom.2', gEe = 'parser.atom.3', hEe = 'parser.atom.4', iEe = 'parser.atom.5', jEe = 'parser.cc.1', kEe = 'parser.cc.2', lEe = 'parser.cc.3', mEe = 'parser.cc.5', nEe = 'parser.cc.6', oEe = 'parser.cc.7', pEe = 'parser.cc.8', qEe = 'parser.ope.1', rEe = 'parser.ope.2', sEe = 'parser.ope.3', tEe = 'parser.descape.1', uEe = 'parser.descape.2', vEe = 'parser.descape.3', wEe = 'parser.descape.4', xEe = 'parser.descape.5', yEe = 'parser.process.1', zEe = 'parser.quantifier.1', AEe = 'parser.quantifier.2', BEe = 'parser.quantifier.3', CEe = 'parser.quantifier.4', DEe = 'parser.quantifier.5', EEe = 'org.eclipse.emf.common.notify', FEe = {
    412: 1,
    671: 1
}, GEe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1
}, HEe = {
    370: 1,
    150: 1
}, IEe = 'index=', JEe = {
    3: 1,
    4: 1,
    5: 1,
    128: 1
}, KEe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    61: 1
}, LEe = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    198: 1
}, MEe = {
    3: 1,
    4: 1,
    5: 1,
    174: 1,
    371: 1
}, NEe = 1024, OEe = ';/?:@&=+$,', PEe = 'invalid authority: ', QEe = 'EAnnotation', REe = 'ETypedElement', SEe = 'EStructuralFeature', TEe = 'EAttribute', UEe = 'EClassifier', VEe = 'EEnumLiteral', WEe = 'EGenericType', XEe = 'EOperation', YEe = 'EParameter', ZEe = 'EReference', $Ee = 'ETypeParameter', _Ee = 'org.eclipse.emf.ecore.util', aFe = {
    76: 1
}, bFe = {
    3: 1,
    20: 1,
    16: 1,
    15: 1,
    61: 1,
    581: 1,
    76: 1,
    71: 1,
    96: 1
}, cFe = 'org.eclipse.emf.ecore.util.FeatureMap$Entry', dFe = 8192, eFe = 'byte', fFe = 'char', gFe = 'double', hFe = 'float', iFe = 'int', jFe = 'long', kFe = 'short', lFe = 'java.lang.Object', mFe = {
    3: 1,
    4: 1,
    5: 1,
    253: 1
}, nFe = {
    3: 1,
    4: 1,
    5: 1,
    673: 1
}, oFe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    71: 1
}, pFe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    76: 1,
    71: 1,
    96: 1
}, qFe = 'mixed', rFe = 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', sFe = 'kind', tFe = {
    3: 1,
    4: 1,
    5: 1,
    674: 1
}, uFe = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1,
    76: 1,
    71: 1,
    96: 1
}, vFe = {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    61: 1,
    71: 1
}, wFe = {
    49: 1,
    127: 1,
    284: 1
}, xFe = {
    74: 1,
    339: 1
}, yFe = "The value of type '", zFe = "' must be of type '", AFe = 1291, BFe = 'http://www.eclipse.org/emf/2002/Ecore', CFe = -32768, DFe = 'constraints', EFe = 'baseType', FFe = 'getEStructuralFeature', GFe = 'getFeatureID', HFe = 'feature', IFe = 'getOperationID', JFe = 'operation', KFe = 'defaultValue', LFe = 'eTypeParameters', MFe = 'isInstance', NFe = 'getEEnumLiteral', OFe = 'eContainingClass', PFe = {
    58: 1
}, QFe = {
    3: 1,
    4: 1,
    5: 1,
    122: 1
}, RFe = 'org.eclipse.emf.ecore.resource', SFe = {
    93: 1,
    92: 1,
    583: 1,
    1980: 1
}, TFe = 'org.eclipse.emf.ecore.resource.impl', UFe = 'unspecified', VFe = 'simple', WFe = 'attribute', XFe = 'attributeWildcard', YFe = 'element', ZFe = 'elementWildcard', $Fe = 'collapse', _Fe = 'itemType', aGe = 'namespace', bGe = '##targetNamespace', cGe = 'whiteSpace', dGe = 'wildcards', eGe = 'http://www.eclipse.org/emf/2003/XMLType', fGe = '##any', gGe = 'uninitialized', hGe = 'The multiplicity constraint is violated', iGe = 'org.eclipse.emf.ecore.xml.type', jGe = 'ProcessingInstruction', kGe = 'SimpleAnyType', lGe = 'XMLTypeDocumentRoot', mGe = 'org.eclipse.emf.ecore.xml.type.impl', nGe = 'INF', oGe = 'processing', pGe = 'ENTITIES_._base', qGe = 'minLength', rGe = 'ENTITY', sGe = 'NCName', tGe = 'IDREFS_._base', uGe = 'integer', vGe = 'token', wGe = 'pattern', xGe = '[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*', yGe = '\\i\\c*', zGe = '[\\i-[:]][\\c-[:]]*', AGe = 'nonPositiveInteger', BGe = 'maxInclusive', CGe = 'NMTOKEN', DGe = 'NMTOKENS_._base', EGe = 'nonNegativeInteger', FGe = 'minInclusive', GGe = 'normalizedString', HGe = 'unsignedByte', IGe = 'unsignedInt', JGe = '18446744073709551615', KGe = 'unsignedShort', LGe = 'processingInstruction', MGe = 'org.eclipse.emf.ecore.xml.type.internal', NGe = 1114111, OGe = 'Internal Error: shorthands: \\u', PGe = 'xml:isDigit', QGe = 'xml:isWord', RGe = 'xml:isSpace', SGe = 'xml:isNameChar', TGe = 'xml:isInitialNameChar', UGe = '09\u0660\u0669\u06F0\u06F9\u0966\u096F\u09E6\u09EF\u0A66\u0A6F\u0AE6\u0AEF\u0B66\u0B6F\u0BE7\u0BEF\u0C66\u0C6F\u0CE6\u0CEF\u0D66\u0D6F\u0E50\u0E59\u0ED0\u0ED9\u0F20\u0F29', VGe = 'AZaz\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u0386\u0386\u0388\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0641\u064A\u0671\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06D5\u06E5\u06E6\u0905\u0939\u093D\u093D\u0958\u0961\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09DC\u09DD\u09DF\u09E1\u09F0\u09F1\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59\u0A5C\u0A5E\u0A5E\u0A72\u0A74\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABD\u0ABD\u0AE0\u0AE0\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3D\u0B3D\u0B5C\u0B5D\u0B5F\u0B61\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C60\u0C61\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CDE\u0CDE\u0CE0\u0CE1\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D60\u0D61\u0E01\u0E2E\u0E30\u0E30\u0E32\u0E33\u0E40\u0E45\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB0\u0EB2\u0EB3\u0EBD\u0EBD\u0EC0\u0EC4\u0F40\u0F47\u0F49\u0F69\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3007\u3007\u3021\u3029\u3041\u3094\u30A1\u30FA\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3', WGe = 'Private Use', XGe = 'ASSIGNED', YGe = '\x00\x7F\x80\xFF\u0100\u017F\u0180\u024F\u0250\u02AF\u02B0\u02FF\u0300\u036F\u0370\u03FF\u0400\u04FF\u0530\u058F\u0590\u05FF\u0600\u06FF\u0700\u074F\u0780\u07BF\u0900\u097F\u0980\u09FF\u0A00\u0A7F\u0A80\u0AFF\u0B00\u0B7F\u0B80\u0BFF\u0C00\u0C7F\u0C80\u0CFF\u0D00\u0D7F\u0D80\u0DFF\u0E00\u0E7F\u0E80\u0EFF\u0F00\u0FFF\u1000\u109F\u10A0\u10FF\u1100\u11FF\u1200\u137F\u13A0\u13FF\u1400\u167F\u1680\u169F\u16A0\u16FF\u1780\u17FF\u1800\u18AF\u1E00\u1EFF\u1F00\u1FFF\u2000\u206F\u2070\u209F\u20A0\u20CF\u20D0\u20FF\u2100\u214F\u2150\u218F\u2190\u21FF\u2200\u22FF\u2300\u23FF\u2400\u243F\u2440\u245F\u2460\u24FF\u2500\u257F\u2580\u259F\u25A0\u25FF\u2600\u26FF\u2700\u27BF\u2800\u28FF\u2E80\u2EFF\u2F00\u2FDF\u2FF0\u2FFF\u3000\u303F\u3040\u309F\u30A0\u30FF\u3100\u312F\u3130\u318F\u3190\u319F\u31A0\u31BF\u3200\u32FF\u3300\u33FF\u3400\u4DB5\u4E00\u9FFF\uA000\uA48F\uA490\uA4CF\uAC00\uD7A3\uE000\uF8FF\uF900\uFAFF\uFB00\uFB4F\uFB50\uFDFF\uFE20\uFE2F\uFE30\uFE4F\uFE50\uFE6F\uFE70\uFEFE\uFEFF\uFEFF\uFF00\uFFEF', ZGe = 'UNASSIGNED', $Ge = {
    3: 1,
    121: 1
}, _Ge = 'org.eclipse.emf.ecore.xml.type.util', aHe = {
    3: 1,
    4: 1,
    5: 1,
    373: 1
}, bHe = 'org.eclipse.xtext.xbase.lib', cHe = 'Cannot add elements to a Range', dHe = 'Cannot set elements in a Range', eHe = 'Cannot remove elements from a Range', fHe = 'user.agent';
var _, Xcb, Scb, qcb = -1;
$wnd.goog = $wnd.goog || {};
$wnd.goog.global = $wnd.goog.global || $wnd;
Xcb = {};
Ycb(1, null, {}, nb);
_.Fb = function ob(a) {
    return mb(this, a);
};
_.Gb = function qb() {
    return this.Om;
};
_.Hb = function sb() {
    return jDb(this);
};
_.Ib = function ub() {
    var a;
    return eeb(rb(this)) + '@' + (a = tb(this) >>> 0, a.toString(16));
};
_.equals = function(a) {
    return this.Fb(a);
};
_.hashCode = function() {
    return this.Hb();
};
_.toString = function() {
    return this.Ib();
};
var FD, GD, HD;
Ycb(295, 1, {
    295: 1,
    2070: 1
}, geb);
_.te = function heb(a) {
    var b;
    b = new geb;
    b.i = 4;
    a > 1 ? b.c = oeb(this, a - 1) : b.c = this;
    return b;
};
_.ue = function neb() {
    ceb(this);
    return this.b;
};
_.ve = function peb() {
    return eeb(this);
};
_.we = function reb() {
    return ceb(this), this.k;
};
_.xe = function teb() {
    return (this.i & 4) != 0;
};
_.ye = function ueb() {
    return (this.i & 1) != 0;
};
_.Ib = function xeb() {
    return feb(this);
};
_.i = 0;
var beb = 1;
var aJ = jeb(Iqe, 'Object', 1);
var KI = jeb(Iqe, 'Class', 295);
Ycb(2042, 1, Jqe);
var gE = jeb(Kqe, 'Optional', 2042);
Ycb(1155, 2042, Jqe, xb);
_.Fb = function yb(a) {
    return a === this;
};
_.Hb = function zb() {
    return 2040732332;
};
_.Ib = function Ab() {
    return 'Optional.absent()';
};
_.Jb = function Bb(a) {
    Qb(a);
    return wb(), vb;
};
var vb;
var eE = jeb(Kqe, 'Absent', 1155);
Ycb(621, 1, {}, Gb);
var fE = jeb(Kqe, 'Joiner', 621);
var hE = leb(Kqe, 'Predicate');
Ycb(572, 1, {
    177: 1,
    572: 1,
    3: 1,
    48: 1
}, Yb);
_.Mb = function ac(a) {
    return Xb(this, a);
};
_.Lb = function Zb(a) {
    return Xb(this, a);
};
_.Fb = function $b(a) {
    var b;
    if (RD(a, 572)) {
        b = JD(a, 572);
        return Nt(this.a, b.a);
    }
    return false;
};
_.Hb = function _b() {
    return tnb(this.a) + 306654252;
};
_.Ib = function bc() {
    return Wb(this.a);
};
var iE = jeb(Kqe, 'Predicates/AndPredicate', 572);
Ycb(408, 2042, {
    408: 1,
    3: 1
}, cc);
_.Fb = function dc(a) {
    var b;
    if (RD(a, 408)) {
        b = JD(a, 408);
        return pb(this.a, b.a);
    }
    return false;
};
_.Hb = function ec() {
    return 1502476572 + tb(this.a);
};
_.Ib = function fc() {
    return Qqe + this.a + ')';
};
_.Jb = function gc(a) {
    return new cc(Rb(a.Kb(this.a), 'the Function passed to Optional.transform() must not return null.'));
};
var jE = jeb(Kqe, 'Present', 408);
Ycb(204, 1, Sqe);
_.Nb = function kc(a) {
    Osb(this, a);
};
_.Qb = function lc() {
    jc();
};
var WH = jeb(Tqe, 'UnmodifiableIterator', 204);
Ycb(2022, 204, Uqe);
_.Qb = function nc() {
    jc();
};
_.Rb = function mc(a) {
    throw scb(new ahb);
};
_.Wb = function oc(a) {
    throw scb(new ahb);
};
var XH = jeb(Tqe, 'UnmodifiableListIterator', 2022);
Ycb(390, 2022, Uqe);
_.Ob = function rc() {
    return this.c < this.d;
};
_.Sb = function sc() {
    return this.c > 0;
};
_.Pb = function tc() {
    if (this.c >= this.d) throw scb(new qub);
    return this.Xb(this.c++);
};
_.Tb = function uc() {
    return this.c;
};
_.Ub = function vc() {
    if (this.c <= 0) throw scb(new qub);
    return this.Xb(--this.c);
};
_.Vb = function wc() {
    return this.c - 1;
};
_.c = 0;
_.d = 0;
var kE = jeb(Tqe, 'AbstractIndexedListIterator', 390);
Ycb(697, 204, Sqe);
_.Ob = function Ac() {
    return xc(this);
};
_.Pb = function Bc() {
    return yc(this);
};
_.e = 1;
var lE = jeb(Tqe, 'AbstractIterator', 697);
Ycb(2030, 1, {
    228: 1
});
_.Zb = function Hc() {
    var a;
    return a = this.f, !a ? this.f = this.ac() : a;
};
_.Fb = function Ic(a) {
    return tw(this, a);
};
_.Hb = function Jc() {
    return tb(this.Zb());
};
_.dc = function Kc() {
    return this.gc() == 0;
};
_.ec = function Lc() {
    return Ec(this);
};
_.Ib = function Mc() {
    return adb(this.Zb());
};
var QE = jeb(Tqe, 'AbstractMultimap', 2030);
Ycb(725, 2030, Vqe);
_.$b = function Xc() {
    Nc(this);
};
_._b = function Yc(a) {
    return Oc(this, a);
};
_.ac = function Zc() {
    return new me(this, this.c);
};
_.ic = function $c(a) {
    return this.hc();
};
_.bc = function _c() {
    return new xf(this, this.c);
};
_.jc = function ad() {
    return this.mc(this.hc());
};
_.kc = function bd() {
    return new Hd(this);
};
_.lc = function cd() {
    return ck(this.c.vc().Lc(), new fh, 64, this.d);
};
_.cc = function dd(a) {
    return Qc(this, a);
};
_.fc = function gd(a) {
    return Sc(this, a);
};
_.gc = function hd() {
    return this.d;
};
_.mc = function jd(a) {
    return pnb(), new oob(a);
};
_.nc = function kd() {
    return new Dd(this);
};
_.oc = function ld() {
    return ck(this.c.Bc().Lc(), new Fd, 64, this.d);
};
_.pc = function md(a, b) {
    return new jg(this, a, b, null);
};
_.d = 0;
var LE = jeb(Tqe, 'AbstractMapBasedMultimap', 725);
Ycb(1637, 725, Vqe);
_.hc = function pd() {
    return new Vlb(this.a);
};
_.jc = function qd() {
    return pnb(), pnb(), mnb;
};
_.cc = function sd(a) {
    return JD(Qc(this, a), 15);
};
_.fc = function ud(a) {
    return JD(Sc(this, a), 15);
};
_.Zb = function od() {
    return nd(this);
};
_.Fb = function rd(a) {
    return tw(this, a);
};
_.qc = function td(a) {
    return JD(Qc(this, a), 15);
};
_.rc = function vd(a) {
    return JD(Sc(this, a), 15);
};
_.mc = function wd(a) {
    return ynb(JD(a, 15));
};
_.pc = function xd(a, b) {
    return Vc(this, a, JD(b, 15), null);
};
var mE = jeb(Tqe, 'AbstractListMultimap', 1637);
Ycb(731, 1, Wqe);
_.Nb = function zd(a) {
    Osb(this, a);
};
_.Ob = function Ad() {
    return this.c.Ob() || this.e.Ob();
};
_.Pb = function Bd() {
    var a;
    if (!this.e.Ob()) {
        a = JD(this.c.Pb(), 43);
        this.b = a.jd();
        this.a = JD(a.kd(), 16);
        this.e = this.a.Jc();
    }
    return this.sc(this.b, this.e.Pb());
};
_.Qb = function Cd() {
    this.e.Qb();
    JD(vub(this.a), 16).dc() && this.c.Qb();
    --this.d.d;
};
var uE = jeb(Tqe, 'AbstractMapBasedMultimap/Itr', 731);
Ycb(1093, 731, Wqe, Dd);
_.sc = function Ed(a, b) {
    return b;
};
var nE = jeb(Tqe, 'AbstractMapBasedMultimap/1', 1093);
Ycb(1094, 1, {}, Fd);
_.Kb = function Gd(a) {
    return JD(a, 16).Lc();
};
var oE = jeb(Tqe, 'AbstractMapBasedMultimap/1methodref$spliterator$Type', 1094);
Ycb(1095, 731, Wqe, Hd);
_.sc = function Id(a, b) {
    return new cp(a, b);
};
var pE = jeb(Tqe, 'AbstractMapBasedMultimap/2', 1095);
var MK = leb(Xqe, 'Map');
Ycb(2011, 1, Yqe);
_.wc = function Td(a) {
    pub(this, a);
};
_.$b = function Od() {
    this.vc().$b();
};
_.tc = function Pd(a) {
    return Jd(this, a);
};
_._b = function Qd(a) {
    return !!Kd(this, a, false);
};
_.uc = function Rd(a) {
    var b, c, d;
    for(c = this.vc().Jc(); c.Ob();){
        b = JD(c.Pb(), 43);
        d = b.kd();
        if (XD(a) === XD(d) || a != null && pb(a, d)) return true;
    }
    return false;
};
_.Fb = function Sd(a) {
    var b, c, d;
    if (a === this) return true;
    if (!RD(a, 91)) return false;
    d = JD(a, 91);
    if (this.gc() != d.gc()) return false;
    for(c = d.vc().Jc(); c.Ob();){
        b = JD(c.Pb(), 43);
        if (!this.tc(b)) return false;
    }
    return true;
};
_.xc = function Ud(a) {
    return Wd(Kd(this, a, false));
};
_.Hb = function Xd() {
    return snb(this.vc());
};
_.dc = function Yd() {
    return this.gc() == 0;
};
_.ec = function Zd() {
    return new Ojb(this);
};
_.yc = function $d(a, b) {
    throw scb(new bhb('Put not supported on this map'));
};
_.zc = function _d(a) {
    Ld(this, a);
};
_.Ac = function ae(a) {
    return Wd(Kd(this, a, true));
};
_.gc = function be() {
    return this.vc().gc();
};
_.Ib = function ce() {
    return Md(this);
};
_.Bc = function de() {
    return new Zjb(this);
};
var BJ = jeb(Xqe, 'AbstractMap', 2011);
Ycb(2031, 2011, Yqe);
_.bc = function fe() {
    return new pf(this);
};
_.vc = function ge() {
    return ee(this);
};
_.ec = function he() {
    var a;
    a = this.g;
    return !a ? this.g = this.bc() : a;
};
_.Bc = function ie() {
    var a;
    a = this.i;
    return !a ? this.i = new jw(this) : a;
};
var mH = jeb(Tqe, 'Maps/ViewCachingAbstractMap', 2031);
Ycb(393, 2031, Yqe, me);
_.xc = function re(a) {
    return je(this, a);
};
_.Ac = function ue(a) {
    return ke(this, a);
};
_.$b = function ne() {
    this.d == this.e.c ? this.e.$b() : wr(new kf(this));
};
_._b = function oe(a) {
    return Sv(this.d, a);
};
_.Dc = function pe() {
    return new bf(this);
};
_.Cc = function() {
    return this.Dc();
};
_.Fb = function qe(a) {
    return this === a || pb(this.d, a);
};
_.Hb = function se() {
    return tb(this.d);
};
_.ec = function te() {
    return this.e.ec();
};
_.gc = function ve() {
    return this.d.gc();
};
_.Ib = function we() {
    return adb(this.d);
};
var tE = jeb(Tqe, 'AbstractMapBasedMultimap/AsMap', 393);
var VI = leb(Iqe, 'Iterable');
Ycb(31, 1, Zqe);
_.Ic = function Ke(a) {
    ofb(this, a);
};
_.Lc = function Ne() {
    return new Gvb(this, 0);
};
_.Mc = function Oe() {
    return new RBb(null, this.Lc());
};
_.Ec = function Fe(a) {
    throw scb(new bhb('Add not supported on this collection'));
};
_.Fc = function Ge(a) {
    return xe(this, a);
};
_.$b = function He() {
    ze(this);
};
_.Gc = function Ie(a) {
    return ye(this, a, false);
};
_.Hc = function Je(a) {
    return Ae(this, a);
};
_.dc = function Le() {
    return this.gc() == 0;
};
_.Kc = function Me(a) {
    return ye(this, a, true);
};
_.Nc = function Pe() {
    return Ce(this);
};
_.Oc = function Qe(a) {
    return De(this, a);
};
_.Ib = function Re() {
    return Ee(this);
};
var mJ = jeb(Xqe, 'AbstractCollection', 31);
var UK = leb(Xqe, 'Set');
Ycb($qe, 31, _qe);
_.Lc = function We() {
    return new Gvb(this, 1);
};
_.Fb = function Ue(a) {
    return Se(this, a);
};
_.Hb = function Ve() {
    return snb(this);
};
var IJ = jeb(Xqe, 'AbstractSet', $qe);
Ycb(2014, $qe, _qe);
var LH = jeb(Tqe, 'Sets/ImprovedAbstractSet', 2014);
Ycb(2015, 2014, _qe);
_.$b = function Ye() {
    this.Pc().$b();
};
_.Gc = function Ze(a) {
    return Xe(this, a);
};
_.dc = function $e() {
    return this.Pc().dc();
};
_.Kc = function _e(a) {
    var b;
    if (this.Gc(a) && RD(a, 43)) {
        b = JD(a, 43);
        return this.Pc().ec().Kc(b.jd());
    }
    return false;
};
_.gc = function af() {
    return this.Pc().gc();
};
var fH = jeb(Tqe, 'Maps/EntrySet', 2015);
Ycb(1091, 2015, _qe, bf);
_.Gc = function cf(a) {
    return Lk(this.a.d.vc(), a);
};
_.Jc = function df() {
    return new kf(this.a);
};
_.Pc = function ef() {
    return this.a;
};
_.Kc = function ff(a) {
    var b;
    if (!Lk(this.a.d.vc(), a)) return false;
    b = JD(vub(JD(a, 43)), 43);
    Tc(this.a.e, b.jd());
    return true;
};
_.Lc = function gf() {
    return ek(this.a.d.vc().Lc(), new hf(this.a));
};
var rE = jeb(Tqe, 'AbstractMapBasedMultimap/AsMap/AsMapEntries', 1091);
Ycb(1092, 1, {}, hf);
_.Kb = function jf(a) {
    return le(this.a, JD(a, 43));
};
var qE = jeb(Tqe, 'AbstractMapBasedMultimap/AsMap/AsMapEntries/0methodref$wrapEntry$Type', 1092);
Ycb(729, 1, Wqe, kf);
_.Nb = function lf(a) {
    Osb(this, a);
};
_.Pb = function nf() {
    var a;
    return a = JD(this.b.Pb(), 43), this.a = JD(a.kd(), 16), le(this.c, a);
};
_.Ob = function mf() {
    return this.b.Ob();
};
_.Qb = function of() {
    Vb(!!this.a);
    this.b.Qb();
    this.c.e.d -= this.a.gc();
    this.a.$b();
    this.a = null;
};
var sE = jeb(Tqe, 'AbstractMapBasedMultimap/AsMap/AsMapIterator', 729);
Ycb(527, 2014, _qe, pf);
_.$b = function qf() {
    this.b.$b();
};
_.Gc = function rf(a) {
    return this.b._b(a);
};
_.Ic = function sf(a) {
    Qb(a);
    this.b.wc(new hw(a));
};
_.dc = function tf() {
    return this.b.dc();
};
_.Jc = function uf() {
    return new Yv(this.b.vc().Jc());
};
_.Kc = function vf(a) {
    if (this.b._b(a)) {
        this.b.Ac(a);
        return true;
    }
    return false;
};
_.gc = function wf() {
    return this.b.gc();
};
var jH = jeb(Tqe, 'Maps/KeySet', 527);
Ycb(327, 527, _qe, xf);
_.$b = function yf() {
    var a;
    wr((a = this.b.vc().Jc(), new Ff(this, a)));
};
_.Hc = function zf(a) {
    return this.b.ec().Hc(a);
};
_.Fb = function Af(a) {
    return this === a || pb(this.b.ec(), a);
};
_.Hb = function Bf() {
    return tb(this.b.ec());
};
_.Jc = function Cf() {
    var a;
    return a = this.b.vc().Jc(), new Ff(this, a);
};
_.Kc = function Df(a) {
    var b, c;
    c = 0;
    b = JD(this.b.Ac(a), 16);
    if (b) {
        c = b.gc();
        b.$b();
        this.a.d -= c;
    }
    return c > 0;
};
_.Lc = function Ef() {
    return this.b.ec().Lc();
};
var wE = jeb(Tqe, 'AbstractMapBasedMultimap/KeySet', 327);
Ycb(730, 1, Wqe, Ff);
_.Nb = function Gf(a) {
    Osb(this, a);
};
_.Ob = function Hf() {
    return this.c.Ob();
};
_.Pb = function If() {
    this.a = JD(this.c.Pb(), 43);
    return this.a.jd();
};
_.Qb = function Jf() {
    var a;
    Vb(!!this.a);
    a = JD(this.a.kd(), 16);
    this.c.Qb();
    this.b.a.d -= a.gc();
    a.$b();
    this.a = null;
};
var vE = jeb(Tqe, 'AbstractMapBasedMultimap/KeySet/1', 730);
Ycb(487, 393, {
    91: 1,
    134: 1
}, Kf);
_.bc = function Lf() {
    return this.Qc();
};
_.ec = function Of() {
    return this.Sc();
};
_.Qc = function Mf() {
    return new cg(this.c, this.Uc());
};
_.Rc = function Nf() {
    return this.Uc().Rc();
};
_.Sc = function Pf() {
    var a;
    return a = this.b, !a ? this.b = this.Qc() : a;
};
_.Tc = function Qf() {
    return this.Uc().Tc();
};
_.Uc = function Rf() {
    return JD(this.d, 134);
};
var AE = jeb(Tqe, 'AbstractMapBasedMultimap/SortedAsMap', 487);
Ycb(434, 487, are, Sf);
_.bc = function Uf() {
    return new eg(this.a, JD(JD(this.d, 134), 137));
};
_.Qc = function Vf() {
    return new eg(this.a, JD(JD(this.d, 134), 137));
};
_.ec = function Zf() {
    var a;
    return a = this.b, JD(!a ? this.b = new eg(this.a, JD(JD(this.d, 134), 137)) : a, 274);
};
_.Sc = function $f() {
    var a;
    return a = this.b, JD(!a ? this.b = new eg(this.a, JD(JD(this.d, 134), 137)) : a, 274);
};
_.Uc = function ag() {
    return JD(JD(this.d, 134), 137);
};
_.Vc = function Tf(a) {
    return JD(JD(this.d, 134), 137).Vc(a);
};
_.Wc = function Wf(a) {
    return JD(JD(this.d, 134), 137).Wc(a);
};
_.Xc = function Xf(a, b) {
    return new Sf(this.a, JD(JD(this.d, 134), 137).Xc(a, b));
};
_.Yc = function Yf(a) {
    return JD(JD(this.d, 134), 137).Yc(a);
};
_.Zc = function _f(a) {
    return JD(JD(this.d, 134), 137).Zc(a);
};
_.$c = function bg(a, b) {
    return new Sf(this.a, JD(JD(this.d, 134), 137).$c(a, b));
};
var xE = jeb(Tqe, 'AbstractMapBasedMultimap/NavigableAsMap', 434);
Ycb(486, 327, bre, cg);
_.Lc = function dg() {
    return this.b.ec().Lc();
};
var BE = jeb(Tqe, 'AbstractMapBasedMultimap/SortedKeySet', 486);
Ycb(392, 486, cre, eg);
var yE = jeb(Tqe, 'AbstractMapBasedMultimap/NavigableKeySet', 392);
Ycb(536, 31, Zqe, jg);
_.Ec = function kg(a) {
    var b, c;
    gg(this);
    c = this.d.dc();
    b = this.d.Ec(a);
    if (b) {
        ++this.f.d;
        c && fg(this);
    }
    return b;
};
_.Fc = function lg(a) {
    var b, c, d;
    if (a.dc()) return false;
    d = (gg(this), this.d.gc());
    b = this.d.Fc(a);
    if (b) {
        c = this.d.gc();
        this.f.d += c - d;
        d == 0 && fg(this);
    }
    return b;
};
_.$b = function mg() {
    var a;
    a = (gg(this), this.d.gc());
    if (a == 0) return;
    this.d.$b();
    this.f.d -= a;
    hg(this);
};
_.Gc = function ng(a) {
    gg(this);
    return this.d.Gc(a);
};
_.Hc = function og(a) {
    gg(this);
    return this.d.Hc(a);
};
_.Fb = function pg(a) {
    if (a === this) return true;
    gg(this);
    return pb(this.d, a);
};
_.Hb = function qg() {
    gg(this);
    return tb(this.d);
};
_.Jc = function rg() {
    gg(this);
    return new Mg(this);
};
_.Kc = function sg(a) {
    var b;
    gg(this);
    b = this.d.Kc(a);
    if (b) {
        --this.f.d;
        hg(this);
    }
    return b;
};
_.gc = function tg() {
    return ig(this);
};
_.Lc = function ug() {
    return gg(this), this.d.Lc();
};
_.Ib = function vg() {
    gg(this);
    return adb(this.d);
};
var DE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedCollection', 536);
var HK = leb(Xqe, 'List');
Ycb(727, 536, {
    20: 1,
    31: 1,
    16: 1,
    15: 1
}, wg);
_.gd = function Fg(a) {
    hub(this, a);
};
_.Lc = function Gg() {
    return gg(this), this.d.Lc();
};
_._c = function xg(a, b) {
    var c;
    gg(this);
    c = this.d.dc();
    JD(this.d, 15)._c(a, b);
    ++this.a.d;
    c && fg(this);
};
_.ad = function yg(a, b) {
    var c, d, e;
    if (b.dc()) return false;
    e = (gg(this), this.d.gc());
    c = JD(this.d, 15).ad(a, b);
    if (c) {
        d = this.d.gc();
        this.a.d += d - e;
        e == 0 && fg(this);
    }
    return c;
};
_.Xb = function zg(a) {
    gg(this);
    return JD(this.d, 15).Xb(a);
};
_.bd = function Ag(a) {
    gg(this);
    return JD(this.d, 15).bd(a);
};
_.cd = function Bg() {
    gg(this);
    return new Sg(this);
};
_.dd = function Cg(a) {
    gg(this);
    return new Tg(this, a);
};
_.ed = function Dg(a) {
    var b;
    gg(this);
    b = JD(this.d, 15).ed(a);
    --this.a.d;
    hg(this);
    return b;
};
_.fd = function Eg(a, b) {
    gg(this);
    return JD(this.d, 15).fd(a, b);
};
_.hd = function Hg(a, b) {
    gg(this);
    return Vc(this.a, this.e, JD(this.d, 15).hd(a, b), !this.b ? this : this.b);
};
var FE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedList', 727);
Ycb(1090, 727, {
    20: 1,
    31: 1,
    16: 1,
    15: 1,
    59: 1
}, Ig);
var zE = jeb(Tqe, 'AbstractMapBasedMultimap/RandomAccessWrappedList', 1090);
Ycb(613, 1, Wqe, Mg);
_.Nb = function Og(a) {
    Osb(this, a);
};
_.Ob = function Pg() {
    Lg(this);
    return this.b.Ob();
};
_.Pb = function Qg() {
    Lg(this);
    return this.b.Pb();
};
_.Qb = function Rg() {
    Kg(this);
};
var CE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedCollection/WrappedIterator', 613);
Ycb(728, 613, dre, Sg, Tg);
_.Qb = function Zg() {
    Kg(this);
};
_.Rb = function Ug(a) {
    var b;
    b = ig(this.a) == 0;
    (Lg(this), JD(this.b, 127)).Rb(a);
    ++this.a.a.d;
    b && fg(this.a);
};
_.Sb = function Vg() {
    return (Lg(this), JD(this.b, 127)).Sb();
};
_.Tb = function Wg() {
    return (Lg(this), JD(this.b, 127)).Tb();
};
_.Ub = function Xg() {
    return (Lg(this), JD(this.b, 127)).Ub();
};
_.Vb = function Yg() {
    return (Lg(this), JD(this.b, 127)).Vb();
};
_.Wb = function $g(a) {
    (Lg(this), JD(this.b, 127)).Wb(a);
};
var EE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedList/WrappedListIterator', 728);
Ycb(726, 536, bre, _g);
_.Lc = function ah() {
    return gg(this), this.d.Lc();
};
var IE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedSortedSet', 726);
Ycb(1089, 726, cre, bh);
var GE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedNavigableSet', 1089);
Ycb(1088, 536, _qe, dh);
_.Lc = function eh() {
    return gg(this), this.d.Lc();
};
var HE = jeb(Tqe, 'AbstractMapBasedMultimap/WrappedSet', 1088);
Ycb(1097, 1, {}, fh);
_.Kb = function gh(a) {
    return fd(JD(a, 43));
};
var JE = jeb(Tqe, 'AbstractMapBasedMultimap/lambda$1$Type', 1097);
Ycb(1096, 1, {}, hh);
_.Kb = function ih(a) {
    return new cp(this.a, a);
};
var KE = jeb(Tqe, 'AbstractMapBasedMultimap/lambda$2$Type', 1096);
var LK = leb(Xqe, 'Map/Entry');
Ycb(355, 1, ere);
_.Fb = function jh(a) {
    var b;
    if (RD(a, 43)) {
        b = JD(a, 43);
        return Hb(this.jd(), b.jd()) && Hb(this.kd(), b.kd());
    }
    return false;
};
_.Hb = function kh() {
    var a, b;
    a = this.jd();
    b = this.kd();
    return (a == null ? 0 : tb(a)) ^ (b == null ? 0 : tb(b));
};
_.ld = function lh(a) {
    throw scb(new ahb);
};
_.Ib = function mh() {
    return this.jd() + '=' + this.kd();
};
var ME = jeb(Tqe, fre, 355);
Ycb(2032, 31, Zqe);
_.$b = function nh() {
    this.md().$b();
};
_.Gc = function oh(a) {
    var b;
    if (RD(a, 43)) {
        b = JD(a, 43);
        return Cc(this.md(), b.jd(), b.kd());
    }
    return false;
};
_.Kc = function ph(a) {
    var b;
    if (RD(a, 43)) {
        b = JD(a, 43);
        return Gc(this.md(), b.jd(), b.kd());
    }
    return false;
};
_.gc = function qh() {
    return this.md().d;
};
var qH = jeb(Tqe, 'Multimaps/Entries', 2032);
Ycb(732, 2032, Zqe, rh);
_.Jc = function sh() {
    return this.a.kc();
};
_.md = function th() {
    return this.a;
};
_.Lc = function uh() {
    return this.a.lc();
};
var NE = jeb(Tqe, 'AbstractMultimap/Entries', 732);
Ycb(733, 732, _qe, vh);
_.Lc = function yh() {
    return this.a.lc();
};
_.Fb = function wh(a) {
    return Nx(this, a);
};
_.Hb = function xh() {
    return Ox(this);
};
var OE = jeb(Tqe, 'AbstractMultimap/EntrySet', 733);
Ycb(734, 31, Zqe, zh);
_.$b = function Ah() {
    this.a.$b();
};
_.Gc = function Bh(a) {
    return Dc(this.a, a);
};
_.Jc = function Ch() {
    return this.a.nc();
};
_.gc = function Dh() {
    return this.a.d;
};
_.Lc = function Eh() {
    return this.a.oc();
};
var PE = jeb(Tqe, 'AbstractMultimap/Values', 734);
Ycb(2033, 31, {
    828: 1,
    20: 1,
    31: 1,
    16: 1
});
_.Ic = function Mh(a) {
    Qb(a);
    Gh(this).Ic(new hx(a));
};
_.Lc = function Qh() {
    var a;
    return a = Gh(this).Lc(), ck(a, new ox, 64 | a.wd() & 1296, this.a.d);
};
_.Ec = function Ih(a) {
    Fh();
    return true;
};
_.Fc = function Jh(a) {
    return Qb(this), Qb(a), RD(a, 537) ? jx(JD(a, 828)) : !a.dc() && tr(this, a.Jc());
};
_.Gc = function Kh(a) {
    var b;
    return b = JD(Tv(nd(this.a), a), 16), (!b ? 0 : b.gc()) > 0;
};
_.Fb = function Lh(a) {
    return kx(this, a);
};
_.Hb = function Nh() {
    return tb(Gh(this));
};
_.dc = function Oh() {
    return Gh(this).dc();
};
_.Kc = function Ph(a) {
    return Nw(this, a, 1) > 0;
};
_.Ib = function Rh() {
    return adb(Gh(this));
};
var SE = jeb(Tqe, 'AbstractMultiset', 2033);
Ycb(2035, 2014, _qe);
_.$b = function Sh() {
    Nc(this.a.a);
};
_.Gc = function Th(a) {
    var b, c;
    if (RD(a, 488)) {
        c = JD(a, 413);
        if (JD(c.a.kd(), 16).gc() <= 0) return false;
        b = Mw(this.a, c.a.jd());
        return b == JD(c.a.kd(), 16).gc();
    }
    return false;
};
_.Kc = function Uh(a) {
    var b, c, d, e;
    if (RD(a, 488)) {
        c = JD(a, 413);
        b = c.a.jd();
        d = JD(c.a.kd(), 16).gc();
        if (d != 0) {
            e = this.a;
            return mx(e, b, d);
        }
    }
    return false;
};
var AH = jeb(Tqe, 'Multisets/EntrySet', 2035);
Ycb(1103, 2035, _qe, Vh);
_.Jc = function Wh() {
    return new Xw(ee(nd(this.a.a)).Jc());
};
_.gc = function Xh() {
    return nd(this.a.a).gc();
};
var RE = jeb(Tqe, 'AbstractMultiset/EntrySet', 1103);
Ycb(612, 725, Vqe);
_.hc = function $h() {
    return this.nd();
};
_.jc = function _h() {
    return this.od();
};
_.cc = function ci(a) {
    return this.pd(a);
};
_.fc = function ei(a) {
    return this.qd(a);
};
_.Zb = function Zh() {
    var a;
    return a = this.f, !a ? this.f = this.ac() : a;
};
_.od = function ai() {
    return pnb(), pnb(), onb;
};
_.Fb = function bi(a) {
    return tw(this, a);
};
_.pd = function di(a) {
    return JD(Qc(this, a), 22);
};
_.qd = function fi(a) {
    return JD(Sc(this, a), 22);
};
_.mc = function gi(a) {
    return pnb(), new Apb(JD(a, 22));
};
_.pc = function hi(a, b) {
    return new dh(this, a, JD(b, 22));
};
var TE = jeb(Tqe, 'AbstractSetMultimap', 612);
Ycb(1665, 612, Vqe);
_.hc = function ki() {
    return new mzb(this.b);
};
_.nd = function li() {
    return new mzb(this.b);
};
_.jc = function mi() {
    return Vx(new mzb(this.b));
};
_.od = function ni() {
    return Vx(new mzb(this.b));
};
_.cc = function oi(a) {
    return JD(JD(Qc(this, a), 22), 83);
};
_.pd = function pi(a) {
    return JD(JD(Qc(this, a), 22), 83);
};
_.fc = function qi(a) {
    return JD(JD(Sc(this, a), 22), 83);
};
_.qd = function ri(a) {
    return JD(JD(Sc(this, a), 22), 83);
};
_.mc = function si(a) {
    return RD(a, 274) ? Vx(JD(a, 274)) : (pnb(), new $pb(JD(a, 83)));
};
_.Zb = function ji() {
    var a;
    return a = this.f, !a ? this.f = RD(this.c, 137) ? new Sf(this, JD(this.c, 137)) : RD(this.c, 134) ? new Kf(this, JD(this.c, 134)) : new me(this, this.c) : a;
};
_.pc = function ti(a, b) {
    return RD(b, 274) ? new bh(this, a, JD(b, 274)) : new _g(this, a, JD(b, 83));
};
var VE = jeb(Tqe, 'AbstractSortedSetMultimap', 1665);
Ycb(1666, 1665, Vqe);
_.Zb = function vi() {
    var a;
    return a = this.f, JD(JD(!a ? this.f = RD(this.c, 137) ? new Sf(this, JD(this.c, 137)) : RD(this.c, 134) ? new Kf(this, JD(this.c, 134)) : new me(this, this.c) : a, 134), 137);
};
_.ec = function xi() {
    var a;
    return a = this.i, JD(JD(!a ? this.i = RD(this.c, 137) ? new eg(this, JD(this.c, 137)) : RD(this.c, 134) ? new cg(this, JD(this.c, 134)) : new xf(this, this.c) : a, 83), 274);
};
_.bc = function wi() {
    return RD(this.c, 137) ? new eg(this, JD(this.c, 137)) : RD(this.c, 134) ? new cg(this, JD(this.c, 134)) : new xf(this, this.c);
};
var UE = jeb(Tqe, 'AbstractSortedKeySortedSetMultimap', 1666);
Ycb(2055, 1, {
    1992: 1
});
_.Fb = function yi(a) {
    return Iy(this, a);
};
_.Hb = function zi() {
    var a;
    return snb((a = this.g, !a ? this.g = new Bi(this) : a));
};
_.Ib = function Ai() {
    var a;
    return Md((a = this.f, !a ? this.f = new Xj(this) : a));
};
var YE = jeb(Tqe, 'AbstractTable', 2055);
Ycb(664, $qe, _qe, Bi);
_.$b = function Ci() {
    Vi();
};
_.Gc = function Di(a) {
    var b, c;
    if (RD(a, 465)) {
        b = JD(a, 682);
        c = JD(Tv(_i(this.a), Nm(b.c.e, b.b)), 91);
        return !!c && Lk(c.vc(), new cp(Nm(b.c.c, b.a), Si(b.c, b.b, b.a)));
    }
    return false;
};
_.Jc = function Ei() {
    return Ti(this.a);
};
_.Kc = function Fi(a) {
    var b, c;
    if (RD(a, 465)) {
        b = JD(a, 682);
        c = JD(Tv(_i(this.a), Nm(b.c.e, b.b)), 91);
        return !!c && Mk(c.vc(), new cp(Nm(b.c.c, b.a), Si(b.c, b.b, b.a)));
    }
    return false;
};
_.gc = function Gi() {
    return bj(this.a);
};
_.Lc = function Hi() {
    return Ui(this.a);
};
var WE = jeb(Tqe, 'AbstractTable/CellSet', 664);
Ycb(1971, 31, Zqe, Ii);
_.$b = function Ji() {
    Vi();
};
_.Gc = function Ki(a) {
    return Wi(this.a, a);
};
_.Jc = function Li() {
    return dj(this.a);
};
_.gc = function Mi() {
    return bj(this.a);
};
_.Lc = function Ni() {
    return ej(this.a);
};
var XE = jeb(Tqe, 'AbstractTable/Values', 1971);
Ycb(1638, 1637, Vqe);
var ZE = jeb(Tqe, 'ArrayListMultimapGwtSerializationDependencies', 1638);
Ycb(504, 1638, Vqe, Pi, Qi);
_.hc = function Ri() {
    return new Vlb(this.a);
};
_.a = 0;
var $E = jeb(Tqe, 'ArrayListMultimap', 504);
Ycb(663, 2055, {
    663: 1,
    1992: 1,
    3: 1
}, fj);
var kF = jeb(Tqe, 'ArrayTable', 663);
Ycb(1967, 390, Uqe, gj);
_.Xb = function hj(a) {
    return new nj(this.a, a);
};
var _E = jeb(Tqe, 'ArrayTable/1', 1967);
Ycb(1968, 1, {}, ij);
_.rd = function jj(a) {
    return new nj(this.a, a);
};
var aF = jeb(Tqe, 'ArrayTable/1methodref$getCell$Type', 1968);
Ycb(2056, 1, {
    682: 1
});
_.Fb = function kj(a) {
    var b;
    if (a === this) return true;
    if (RD(a, 465)) {
        b = JD(a, 682);
        return Hb(Nm(this.c.e, this.b), Nm(b.c.e, b.b)) && Hb(Nm(this.c.c, this.a), Nm(b.c.c, b.a)) && Hb(Si(this.c, this.b, this.a), Si(b.c, b.b, b.a));
    }
    return false;
};
_.Hb = function lj() {
    return Kmb(WC(OC(aJ, 1), Nqe, 1, 5, [
        Nm(this.c.e, this.b),
        Nm(this.c.c, this.a),
        Si(this.c, this.b, this.a)
    ]));
};
_.Ib = function mj() {
    return '(' + Nm(this.c.e, this.b) + ',' + Nm(this.c.c, this.a) + ')=' + Si(this.c, this.b, this.a);
};
var TH = jeb(Tqe, 'Tables/AbstractCell', 2056);
Ycb(465, 2056, {
    465: 1,
    682: 1
}, nj);
_.a = 0;
_.b = 0;
_.d = 0;
var bF = jeb(Tqe, 'ArrayTable/2', 465);
Ycb(1970, 1, {}, oj);
_.rd = function pj(a) {
    return Zi(this.a, a);
};
var cF = jeb(Tqe, 'ArrayTable/2methodref$getValue$Type', 1970);
Ycb(1969, 390, Uqe, qj);
_.Xb = function rj(a) {
    return Zi(this.a, a);
};
var dF = jeb(Tqe, 'ArrayTable/3', 1969);
Ycb(2023, 2011, Yqe);
_.$b = function tj() {
    wr(this.kc());
};
_.vc = function uj() {
    return new cw(this);
};
_.lc = function vj() {
    return new Ivb(this.kc(), this.gc());
};
var hH = jeb(Tqe, 'Maps/IteratorBasedAbstractMap', 2023);
Ycb(821, 2023, Yqe);
_.$b = function zj() {
    throw scb(new ahb);
};
_._b = function Aj(a) {
    return An(this.c, a);
};
_.kc = function Bj() {
    return new Pj(this, this.c.b.c.gc());
};
_.lc = function Cj() {
    return dk(this.c.b.c.gc(), 16, new Jj(this));
};
_.xc = function Dj(a) {
    var b;
    b = JD(Bn(this.c, a), 17);
    return !b ? null : this.td(b.a);
};
_.dc = function Ej() {
    return this.c.b.c.dc();
};
_.ec = function Fj() {
    return en(this.c);
};
_.yc = function Gj(a, b) {
    var c;
    c = JD(Bn(this.c, a), 17);
    if (!c) throw scb(new Teb(this.sd() + ' ' + a + ' not in ' + en(this.c)));
    return this.ud(c.a, b);
};
_.Ac = function Hj(a) {
    throw scb(new ahb);
};
_.gc = function Ij() {
    return this.c.b.c.gc();
};
var hF = jeb(Tqe, 'ArrayTable/ArrayMap', 821);
Ycb(1966, 1, {}, Jj);
_.rd = function Kj(a) {
    return wj(this.a, a);
};
var eF = jeb(Tqe, 'ArrayTable/ArrayMap/0methodref$getEntry$Type', 1966);
Ycb(1964, 355, ere, Lj);
_.jd = function Mj() {
    return xj(this.a, this.b);
};
_.kd = function Nj() {
    return this.a.td(this.b);
};
_.ld = function Oj(a) {
    return this.a.ud(this.b, a);
};
_.b = 0;
var fF = jeb(Tqe, 'ArrayTable/ArrayMap/1', 1964);
Ycb(1965, 390, Uqe, Pj);
_.Xb = function Qj(a) {
    return wj(this.a, a);
};
var gF = jeb(Tqe, 'ArrayTable/ArrayMap/2', 1965);
Ycb(1963, 821, Yqe, Rj);
_.sd = function Sj() {
    return 'Column';
};
_.td = function Tj(a) {
    return Si(this.b, this.a, a);
};
_.ud = function Uj(a, b) {
    return aj(this.b, this.a, a, b);
};
_.a = 0;
var jF = jeb(Tqe, 'ArrayTable/Row', 1963);
Ycb(822, 821, Yqe, Xj);
_.td = function Zj(a) {
    return new Rj(this.a, a);
};
_.yc = function $j(a, b) {
    return JD(b, 91), Vj();
};
_.ud = function _j(a, b) {
    return JD(b, 91), Wj();
};
_.sd = function Yj() {
    return 'Row';
};
var iF = jeb(Tqe, 'ArrayTable/RowMap', 822);
Ycb(1121, 1, jre, fk);
_.yd = function jk(a) {
    return (this.a.wd() & -262 & a) != 0;
};
_.wd = function gk() {
    return this.a.wd() & -262;
};
_.xd = function hk() {
    return this.a.xd();
};
_.Nb = function ik(a) {
    this.a.Nb(new nk(a, this.b));
};
_.zd = function kk(a) {
    return this.a.zd(new lk(a, this.b));
};
var qF = jeb(Tqe, 'CollectSpliterators/1', 1121);
Ycb(1122, 1, kre, lk);
_.Ad = function mk(a) {
    this.a.Ad(this.b.Kb(a));
};
var lF = jeb(Tqe, 'CollectSpliterators/1/lambda$0$Type', 1122);
Ycb(1123, 1, kre, nk);
_.Ad = function ok(a) {
    this.a.Ad(this.b.Kb(a));
};
var mF = jeb(Tqe, 'CollectSpliterators/1/lambda$1$Type', 1123);
Ycb(1118, 1, jre, pk);
_.yd = function tk(a) {
    return ((16464 | this.b) & a) != 0;
};
_.wd = function qk() {
    return 16464 | this.b;
};
_.xd = function rk() {
    return this.a.xd();
};
_.Nb = function sk(a) {
    this.a.Oe(new xk(a, this.c));
};
_.zd = function uk(a) {
    return this.a.Pe(new vk(a, this.c));
};
_.b = 0;
var pF = jeb(Tqe, 'CollectSpliterators/1WithCharacteristics', 1118);
Ycb(1119, 1, lre, vk);
_.Bd = function wk(a) {
    this.a.Ad(this.b.rd(a));
};
var nF = jeb(Tqe, 'CollectSpliterators/1WithCharacteristics/lambda$0$Type', 1119);
Ycb(1120, 1, lre, xk);
_.Bd = function yk(a) {
    this.a.Ad(this.b.rd(a));
};
var oF = jeb(Tqe, 'CollectSpliterators/1WithCharacteristics/lambda$1$Type', 1120);
Ycb(1114, 1, jre);
_.yd = function Ek(a) {
    return (this.a & a) != 0;
};
_.wd = function Bk() {
    return this.a;
};
_.xd = function Ck() {
    !!this.e && (this.b = Bfb(this.b, this.e.xd()));
    return Bfb(this.b, 0);
};
_.Nb = function Dk(a) {
    if (this.e) {
        this.e.Nb(a);
        this.e = null;
    }
    this.c.Nb(new Ik(this, a));
    this.b = 0;
};
_.zd = function Fk(a) {
    while(true){
        if (!!this.e && this.e.zd(a)) {
            Hcb(this.b, mre) && (this.b = Mcb(this.b, 1));
            return true;
        } else this.e = null;
        if (!this.c.zd(new Gk(this))) return false;
    }
};
_.a = 0;
_.b = 0;
var uF = jeb(Tqe, 'CollectSpliterators/FlatMapSpliterator', 1114);
Ycb(1116, 1, kre, Gk);
_.Ad = function Hk(a) {
    zk(this.a, a);
};
var rF = jeb(Tqe, 'CollectSpliterators/FlatMapSpliterator/lambda$0$Type', 1116);
Ycb(1117, 1, kre, Ik);
_.Ad = function Jk(a) {
    Ak(this.a, this.b, a);
};
var sF = jeb(Tqe, 'CollectSpliterators/FlatMapSpliterator/lambda$1$Type', 1117);
Ycb(1115, 1114, jre, Kk);
var tF = jeb(Tqe, 'CollectSpliterators/FlatMapSpliteratorOfObject', 1115);
Ycb(252, 1, nre);
_.Dd = function Qk(a) {
    return this.Cd(JD(a, 252));
};
_.Cd = function Pk(a) {
    var b;
    if (a == (il(), hl)) return 1;
    if (a == (Uk(), Tk)) return -1;
    b = (qx(), Cdb(this.a, a.a));
    if (b != 0) return b;
    return RD(this, 511) == RD(a, 511) ? 0 : RD(this, 511) ? 1 : -1;
};
_.Gd = function Rk() {
    return this.a;
};
_.Fb = function Sk(a) {
    return Nk(this, a);
};
var zF = jeb(Tqe, 'Cut', 252);
Ycb(1769, 252, nre, Vk);
_.Cd = function Wk(a) {
    return a == this ? 0 : 1;
};
_.Ed = function Xk(a) {
    throw scb(new tdb);
};
_.Fd = function Yk(a) {
    a.a += '+\u221E)';
};
_.Gd = function Zk() {
    throw scb(new Web(ore));
};
_.Hb = function $k() {
    return Zgb(), iDb(this);
};
_.Hd = function _k(a) {
    return false;
};
_.Ib = function al() {
    return '+\u221E';
};
var Tk;
var vF = jeb(Tqe, 'Cut/AboveAll', 1769);
Ycb(511, 252, {
    252: 1,
    511: 1,
    3: 1,
    34: 1
}, bl);
_.Ed = function cl(a) {
    Pgb((a.a += '(', a), this.a);
};
_.Fd = function dl(a) {
    Kgb(Pgb(a, this.a), 93);
};
_.Hb = function el() {
    return ~tb(this.a);
};
_.Hd = function fl(a) {
    return qx(), Cdb(this.a, a) < 0;
};
_.Ib = function gl() {
    return '/' + this.a + '\\';
};
var wF = jeb(Tqe, 'Cut/AboveValue', 511);
Ycb(1768, 252, nre, jl);
_.Cd = function kl(a) {
    return a == this ? 0 : -1;
};
_.Ed = function ll(a) {
    a.a += '(-\u221E';
};
_.Fd = function ml(a) {
    throw scb(new tdb);
};
_.Gd = function nl() {
    throw scb(new Web(ore));
};
_.Hb = function ol() {
    return Zgb(), iDb(this);
};
_.Hd = function pl(a) {
    return true;
};
_.Ib = function ql() {
    return '-\u221E';
};
var hl;
var xF = jeb(Tqe, 'Cut/BelowAll', 1768);
Ycb(1770, 252, nre, rl);
_.Ed = function sl(a) {
    Pgb((a.a += '[', a), this.a);
};
_.Fd = function tl(a) {
    Kgb(Pgb(a, this.a), 41);
};
_.Hb = function ul() {
    return tb(this.a);
};
_.Hd = function vl(a) {
    return qx(), Cdb(this.a, a) <= 0;
};
_.Ib = function wl() {
    return '\\' + this.a + '/';
};
var yF = jeb(Tqe, 'Cut/BelowValue', 1770);
Ycb(532, 1, pre);
_.Ic = function zl(a) {
    ofb(this, a);
};
_.Ib = function Al() {
    return Hr(JD(Rb(this, 'use Optional.orNull() instead of Optional.or(null)'), 20).Jc());
};
var DF = jeb(Tqe, 'FluentIterable', 532);
Ycb(430, 532, pre, Bl);
_.Jc = function Cl() {
    return new es(Ir(this.a.Jc(), new er));
};
var AF = jeb(Tqe, 'FluentIterable/2', 430);
Ycb(1034, 532, pre, El);
_.Jc = function Fl() {
    return Dl(this);
};
var CF = jeb(Tqe, 'FluentIterable/3', 1034);
Ycb(708, 390, Uqe, Gl);
_.Xb = function Hl(a) {
    return this.a[a].Jc();
};
var BF = jeb(Tqe, 'FluentIterable/3/1', 708);
Ycb(2016, 1, {});
_.Ib = function Il() {
    return adb(this.Id().b);
};
var KF = jeb(Tqe, 'ForwardingObject', 2016);
Ycb(2017, 2016, qre);
_.Id = function Ol() {
    return this.Jd();
};
_.Ic = function Pl(a) {
    ofb(this, a);
};
_.Lc = function Ul() {
    return new Gvb(this, 0);
};
_.Mc = function Vl() {
    return new RBb(null, this.Lc());
};
_.Ec = function Jl(a) {
    return this.Jd(), hob();
};
_.Fc = function Kl(a) {
    return this.Jd(), iob();
};
_.$b = function Ll() {
    this.Jd(), job();
};
_.Gc = function Ml(a) {
    return this.Jd().Gc(a);
};
_.Hc = function Nl(a) {
    return this.Jd().Hc(a);
};
_.dc = function Ql() {
    return this.Jd().b.dc();
};
_.Jc = function Rl() {
    return this.Jd().Jc();
};
_.Kc = function Sl(a) {
    return this.Jd(), mob();
};
_.gc = function Tl() {
    return this.Jd().b.gc();
};
_.Nc = function Wl() {
    return this.Jd().Nc();
};
_.Oc = function Xl(a) {
    return this.Jd().Oc(a);
};
var EF = jeb(Tqe, 'ForwardingCollection', 2017);
Ycb(2024, 31, rre);
_.Jc = function dm() {
    return this.Md();
};
_.Ec = function Zl(a) {
    throw scb(new ahb);
};
_.Fc = function $l(a) {
    throw scb(new ahb);
};
_.Kd = function _l() {
    var a;
    a = this.c;
    return !a ? this.c = this.Ld() : a;
};
_.$b = function am() {
    throw scb(new ahb);
};
_.Gc = function bm(a) {
    return a != null && ye(this, a, false);
};
_.Ld = function cm() {
    switch(this.gc()){
        case 0:
            return qm(), qm(), pm;
        case 1:
            return qm(), new vy(Qb(this.Md().Pb()));
        default:
            return new Bx(this, this.Nc());
    }
};
_.Kc = function em(a) {
    throw scb(new ahb);
};
var dG = jeb(Tqe, 'ImmutableCollection', 2024);
Ycb(711, 2024, rre, fm);
_.Jc = function km() {
    return Jr(this.a.Jc());
};
_.Gc = function gm(a) {
    return a != null && this.a.Gc(a);
};
_.Hc = function hm(a) {
    return this.a.Hc(a);
};
_.dc = function im() {
    return this.a.dc();
};
_.Md = function jm() {
    return Jr(this.a.Jc());
};
_.gc = function lm() {
    return this.a.gc();
};
_.Nc = function mm() {
    return this.a.Nc();
};
_.Oc = function nm(a) {
    return this.a.Oc(a);
};
_.Ib = function om() {
    return adb(this.a);
};
var FF = jeb(Tqe, 'ForwardingImmutableCollection', 711);
Ycb(308, 2024, sre);
_.Jc = function Bm() {
    return this.Md();
};
_.cd = function Cm() {
    return this.Nd(0);
};
_.dd = function Em(a) {
    return this.Nd(a);
};
_.gd = function Im(a) {
    hub(this, a);
};
_.Lc = function Jm() {
    return new Gvb(this, 16);
};
_.hd = function Lm(a, b) {
    return this.Od(a, b);
};
_._c = function tm(a, b) {
    throw scb(new ahb);
};
_.ad = function um(a, b) {
    throw scb(new ahb);
};
_.Kd = function vm() {
    return this;
};
_.Fb = function xm(a) {
    return Wu(this, a);
};
_.Hb = function ym() {
    return Xu(this);
};
_.bd = function zm(a) {
    return a == null ? -1 : Yu(this, a);
};
_.Md = function Am() {
    return this.Nd(0);
};
_.Nd = function Dm(a) {
    return rm(this, a);
};
_.ed = function Gm(a) {
    throw scb(new ahb);
};
_.fd = function Hm(a, b) {
    throw scb(new ahb);
};
_.Od = function Km(a, b) {
    var c;
    return Mm((c = new lv(this), new Ijb(c, a, b)));
};
var pm;
var iG = jeb(Tqe, 'ImmutableList', 308);
Ycb(2051, 308, sre);
_.Jc = function Wm() {
    return Jr(this.Pd().Jc());
};
_.hd = function Zm(a, b) {
    return Mm(this.Pd().hd(a, b));
};
_.Gc = function Om(a) {
    return a != null && this.Pd().Gc(a);
};
_.Hc = function Pm(a) {
    return this.Pd().Hc(a);
};
_.Fb = function Qm(a) {
    return pb(this.Pd(), a);
};
_.Xb = function Rm(a) {
    return Nm(this, a);
};
_.Hb = function Sm() {
    return tb(this.Pd());
};
_.bd = function Tm(a) {
    return this.Pd().bd(a);
};
_.dc = function Um() {
    return this.Pd().dc();
};
_.Md = function Vm() {
    return Jr(this.Pd().Jc());
};
_.gc = function Xm() {
    return this.Pd().gc();
};
_.Od = function Ym(a, b) {
    return Mm(this.Pd().hd(a, b));
};
_.Nc = function $m() {
    return this.Pd().Oc(SC(aJ, Nqe, 1, this.Pd().gc(), 5, 1));
};
_.Oc = function _m(a) {
    return this.Pd().Oc(a);
};
_.Ib = function an() {
    return adb(this.Pd());
};
var GF = jeb(Tqe, 'ForwardingImmutableList', 2051);
Ycb(712, 1, ure);
_.vc = function mn() {
    return dn(this);
};
_.wc = function on(a) {
    pub(this, a);
};
_.ec = function sn() {
    return en(this);
};
_.Bc = function zn() {
    return this.Td();
};
_.$b = function gn() {
    throw scb(new ahb);
};
_._b = function hn(a) {
    return this.xc(a) != null;
};
_.uc = function jn(a) {
    return this.Td().Gc(a);
};
_.Rd = function kn() {
    return new tq(this);
};
_.Sd = function ln() {
    return new Cq(this);
};
_.Fb = function nn(a) {
    return Pv(this, a);
};
_.Hb = function qn() {
    return dn(this).Hb();
};
_.dc = function rn() {
    return this.gc() == 0;
};
_.yc = function vn(a, b) {
    return fn();
};
_.Ac = function wn(a) {
    throw scb(new ahb);
};
_.Ib = function xn() {
    return Vv(this);
};
_.Td = function yn() {
    if (this.e) return this.e;
    return this.e = this.Sd();
};
_.c = null;
_.d = null;
_.e = null;
var bn;
var sG = jeb(Tqe, 'ImmutableMap', 712);
Ycb(713, 712, ure);
_._b = function Dn(a) {
    return An(this, a);
};
_.uc = function En(a) {
    return fpb(this.b, a);
};
_.Qd = function Fn() {
    return bo(new Tn(this));
};
_.Rd = function Gn() {
    return bo(ipb(this.b));
};
_.Sd = function Hn() {
    return Yl(), new fm(jpb(this.b));
};
_.Fb = function In(a) {
    return hpb(this.b, a);
};
_.xc = function Jn(a) {
    return Bn(this, a);
};
_.Hb = function Kn() {
    return tb(this.b.c);
};
_.dc = function Ln() {
    return this.b.c.dc();
};
_.gc = function Mn() {
    return this.b.c.gc();
};
_.Ib = function Nn() {
    return adb(this.b.c);
};
var IF = jeb(Tqe, 'ForwardingImmutableMap', 713);
Ycb(2018, 2017, vre);
_.Id = function On() {
    return this.Ud();
};
_.Jd = function Pn() {
    return this.Ud();
};
_.Lc = function Sn() {
    return new Gvb(this, 1);
};
_.Fb = function Qn(a) {
    return a === this || this.Ud().Fb(a);
};
_.Hb = function Rn() {
    return this.Ud().Hb();
};
var LF = jeb(Tqe, 'ForwardingSet', 2018);
Ycb(1050, 2018, vre, Tn);
_.Id = function Vn() {
    return gpb(this.a.b);
};
_.Jd = function Wn() {
    return gpb(this.a.b);
};
_.Gc = function Un(b) {
    if (RD(b, 43) && JD(b, 43).jd() == null) return false;
    try {
        return Epb(gpb(this.a.b), b);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 211)) return false;
        else throw scb(a);
    }
};
_.Ud = function Xn() {
    return gpb(this.a.b);
};
_.Oc = function Yn(a) {
    var b;
    b = Fpb(gpb(this.a.b), a);
    gpb(this.a.b).b.gc() < b.length && VC(b, gpb(this.a.b).b.gc(), null);
    return b;
};
var HF = jeb(Tqe, 'ForwardingImmutableMap/1', 1050);
Ycb(2025, 2024, wre);
_.Jc = function _n() {
    return this.Md();
};
_.Lc = function ao() {
    return new Gvb(this, 1);
};
_.Fb = function Zn(a) {
    return Nx(this, a);
};
_.Hb = function $n() {
    return Ox(this);
};
var uG = jeb(Tqe, 'ImmutableSet', 2025);
Ycb(703, 2025, wre);
_.Jc = function jo() {
    return Jr(new Fob(this.a.b.Jc()));
};
_.Gc = function eo(a) {
    return a != null && kob(this.a, a);
};
_.Hc = function fo(a) {
    return lob(this.a, a);
};
_.Hb = function go() {
    return tb(this.a.b);
};
_.dc = function ho() {
    return this.a.b.dc();
};
_.Md = function io() {
    return Jr(new Fob(this.a.b.Jc()));
};
_.gc = function ko() {
    return this.a.b.gc();
};
_.Nc = function lo() {
    return this.a.b.Nc();
};
_.Oc = function mo(a) {
    return nob(this.a, a);
};
_.Ib = function no() {
    return adb(this.a.b);
};
var JF = jeb(Tqe, 'ForwardingImmutableSet', 703);
Ycb(2019, 2018, xre);
_.Id = function oo() {
    return this.b;
};
_.Jd = function po() {
    return this.b;
};
_.Ud = function qo() {
    return this.b;
};
_.Lc = function ro() {
    return new Ovb(this);
};
var MF = jeb(Tqe, 'ForwardingSortedSet', 2019);
Ycb(528, 2023, ure, Eo);
_.zc = function No(a) {
    Ld(this, a);
};
_.Bc = function Qo() {
    var a;
    return a = this.d, new Cp(!a ? this.d = new ip(this) : a);
};
_.$b = function Fo() {
    so(this);
};
_._b = function Go(a) {
    return !!Co(this, a, Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15))));
};
_.uc = function Ho(a) {
    return to(this, a);
};
_.kc = function Io() {
    return new Yo(this, this);
};
_.wc = function Jo(a) {
    vo(this, a);
};
_.xc = function Ko(a) {
    return wo(this, a);
};
_.ec = function Lo() {
    return new Jp(this);
};
_.yc = function Mo(a, b) {
    return zo(this, a, b);
};
_.Ac = function Oo(a) {
    var b;
    b = Co(this, a, Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15))));
    if (!b) return null;
    else {
        uo(this, b);
        b.e = null;
        b.c = null;
        return b.i;
    }
};
_.gc = function Po() {
    return this.i;
};
_.vd = function Ro() {
    var a;
    return a = this.d, new Cp(!a ? this.d = new ip(this) : a);
};
_.f = 0;
_.g = 0;
_.i = 0;
var ZF = jeb(Tqe, 'HashBiMap', 528);
Ycb(529, 1, Wqe);
_.Nb = function Uo(a) {
    Osb(this, a);
};
_.Ob = function Vo() {
    return So(this);
};
_.Pb = function Wo() {
    var a;
    if (!So(this)) throw scb(new qub);
    a = JD(vub(this.c), 304);
    this.c = a.c;
    this.f = a;
    --this.d;
    return this.Vd(a);
};
_.Qb = function Xo() {
    if (this.e.g != this.b) throw scb(new yqb);
    if (!this.f) throw scb(new Web(Pqe));
    uo(this.e, this.f);
    this.b = this.e.g;
    this.f = null;
};
_.b = 0;
_.d = 0;
_.f = null;
var WF = jeb(Tqe, 'HashBiMap/Itr', 529);
Ycb(998, 529, Wqe, Yo);
_.Vd = function Zo(a) {
    return new $o(this, a);
};
var OF = jeb(Tqe, 'HashBiMap/1', 998);
Ycb(999, 355, ere, $o);
_.jd = function _o() {
    return this.a.g;
};
_.kd = function ap() {
    return this.a.i;
};
_.ld = function bp(a) {
    var b, c, d;
    c = this.a.i;
    d = Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15)));
    if (d == this.a.f && (XD(a) === XD(c) || a != null && pb(a, c))) return a;
    Nb(!Do(this.b.a, a, d), a);
    uo(this.b.a, this.a);
    b = new gp(this.a.g, this.a.a, a, d);
    xo(this.b.a, b, this.a);
    this.a.e = null;
    this.a.c = null;
    this.b.b = this.b.a.g;
    this.b.f == this.a && (this.b.f = b);
    this.a = b;
    return c;
};
var NF = jeb(Tqe, 'HashBiMap/1/MapEntry', 999);
Ycb(244, 355, {
    355: 1,
    244: 1,
    3: 1,
    43: 1
}, cp);
_.jd = function dp() {
    return this.g;
};
_.kd = function ep() {
    return this.i;
};
_.ld = function fp(a) {
    throw scb(new ahb);
};
var eG = jeb(Tqe, 'ImmutableEntry', 244);
Ycb(304, 244, {
    355: 1,
    304: 1,
    244: 1,
    3: 1,
    43: 1
}, gp);
_.a = 0;
_.f = 0;
var PF = jeb(Tqe, 'HashBiMap/BiEntry', 304);
Ycb(604, 2023, ure, ip);
_.zc = function rp(a) {
    Ld(this, a);
};
_.Bc = function up() {
    return new Jp(this.a);
};
_.$b = function jp() {
    so(this.a);
};
_._b = function kp(a) {
    return to(this.a, a);
};
_.kc = function lp() {
    return new wp(this, this.a);
};
_.wc = function mp(a) {
    Qb(a);
    vo(this.a, new Hp(a));
};
_.xc = function np(a) {
    return hp(this, a);
};
_.ec = function op() {
    return new Cp(this);
};
_.yc = function qp(a, b) {
    return Ao(this.a, a, b, false);
};
_.Ac = function sp(a) {
    var b;
    b = Do(this.a, a, Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15))));
    if (!b) return null;
    else {
        uo(this.a, b);
        b.e = null;
        b.c = null;
        return b.g;
    }
};
_.gc = function tp() {
    return this.a.i;
};
_.vd = function vp() {
    return new Jp(this.a);
};
var VF = jeb(Tqe, 'HashBiMap/Inverse', 604);
Ycb(995, 529, Wqe, wp);
_.Vd = function xp(a) {
    return new yp(this, a);
};
var RF = jeb(Tqe, 'HashBiMap/Inverse/1', 995);
Ycb(996, 355, ere, yp);
_.jd = function zp() {
    return this.a.i;
};
_.kd = function Ap() {
    return this.a.g;
};
_.ld = function Bp(a) {
    var b, c, d;
    d = this.a.g;
    b = Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15)));
    if (b == this.a.a && (XD(a) === XD(d) || a != null && pb(a, d))) return a;
    Nb(!Co(this.b.a.a, a, b), a);
    uo(this.b.a.a, this.a);
    c = new gp(a, b, this.a.i, this.a.f);
    this.a = c;
    xo(this.b.a.a, c, null);
    this.b.b = this.b.a.a.g;
    return d;
};
var QF = jeb(Tqe, 'HashBiMap/Inverse/1/InverseEntry', 996);
Ycb(605, 527, _qe, Cp);
_.Jc = function Dp() {
    return new Fp(this.a.a);
};
_.Kc = function Ep(a) {
    var b;
    b = Do(this.a.a, a, Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15))));
    if (!b) return false;
    else {
        uo(this.a.a, b);
        return true;
    }
};
var TF = jeb(Tqe, 'HashBiMap/Inverse/InverseKeySet', 605);
Ycb(994, 529, Wqe, Fp);
_.Vd = function Gp(a) {
    return a.i;
};
var SF = jeb(Tqe, 'HashBiMap/Inverse/InverseKeySet/1', 994);
Ycb(997, 1, {}, Hp);
_.Wd = function Ip(a, b) {
    pp(this.a, a, b);
};
var UF = jeb(Tqe, 'HashBiMap/Inverse/lambda$0$Type', 997);
Ycb(603, 527, _qe, Jp);
_.Jc = function Kp() {
    return new Mp(this.a);
};
_.Kc = function Lp(a) {
    var b;
    b = Co(this.a, a, Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15))));
    if (!b) return false;
    else {
        uo(this.a, b);
        b.e = null;
        b.c = null;
        return true;
    }
};
var YF = jeb(Tqe, 'HashBiMap/KeySet', 603);
Ycb(993, 529, Wqe, Mp);
_.Vd = function Np(a) {
    return a.g;
};
var XF = jeb(Tqe, 'HashBiMap/KeySet/1', 993);
Ycb(1087, 612, Vqe);
var $F = jeb(Tqe, 'HashMultimapGwtSerializationDependencies', 1087);
Ycb(269, 1087, Vqe, Pp);
_.hc = function Qp() {
    return new Rrb(Ov(this.a));
};
_.nd = function Rp() {
    return new Rrb(Ov(this.a));
};
_.a = 2;
var _F = jeb(Tqe, 'HashMultimap', 269);
Ycb(2043, 308, sre);
_.Gc = function Up(a) {
    return this.Xd().Gc(a);
};
_.dc = function Vp() {
    return this.Xd().dc();
};
_.gc = function Wp() {
    return this.Xd().gc();
};
var aG = jeb(Tqe, 'ImmutableAsList', 2043);
Ycb(1976, 713, ure);
_.Td = function Yp() {
    return Yl(), new xy(this.a);
};
_.Bc = function Zp() {
    return Yl(), new xy(this.a);
};
_.vd = function $p() {
    return Yl(), new xy(this.a);
};
var bG = jeb(Tqe, 'ImmutableBiMap', 1976);
Ycb(2021, 1, {});
var cG = jeb(Tqe, 'ImmutableCollection/Builder', 2021);
Ycb(1010, 703, wre, _p);
var fG = jeb(Tqe, 'ImmutableEnumSet', 1010);
Ycb(957, 390, Uqe, bq);
_.Xb = function cq(a) {
    return this.a.Xb(a);
};
var gG = jeb(Tqe, 'ImmutableList/1', 957);
Ycb(956, 2021, {}, dq);
var hG = jeb(Tqe, 'ImmutableList/Builder', 956);
Ycb(608, 204, Sqe, eq);
_.Ob = function fq() {
    return this.a.Ob();
};
_.Pb = function gq() {
    return JD(this.a.Pb(), 43).jd();
};
var jG = jeb(Tqe, 'ImmutableMap/1', 608);
Ycb(1029, 1, {}, hq);
_.Kb = function iq(a) {
    return JD(a, 43).jd();
};
var kG = jeb(Tqe, 'ImmutableMap/2methodref$getKey$Type', 1029);
Ycb(1028, 1, {}, kq);
var lG = jeb(Tqe, 'ImmutableMap/Builder', 1028);
Ycb(2044, 2025, wre);
_.Kd = function lq() {
    var a;
    return a = this.b, !a ? this.b = new Tq(this) : a;
};
_.Ld = function mq() {
    return new Bx(this, De(this, SC(aJ, Nqe, 1, this.gc(), 5, 1)));
};
var tG = jeb(Tqe, 'ImmutableSet/CachingAsList', 2044);
Ycb(2045, 2044, wre);
_.Jc = function qq() {
    var a;
    return a = dn(this.a).Md(), new eq(a);
};
_.Ld = function nq() {
    return new Tq(this);
};
_.Ic = function oq(a) {
    var b, c;
    Qb(a);
    c = this.gc();
    for(b = 0; b < c; b++)a.Ad(JD(dn(this.a).Kd().Xb(b), 43).jd());
};
_.Md = function pq() {
    var a;
    return a = this.b, rm(!a ? this.b = new Tq(this) : a, 0);
};
_.Lc = function rq() {
    return dk(this.gc(), 1296, new Rq(this));
};
var xG = jeb(Tqe, 'IndexedImmutableSet', 2045);
Ycb(1190, 2045, wre, tq);
_.Jc = function xq() {
    var a;
    return a = dn(this.a).Md(), new eq(a);
};
_.Gc = function uq(a) {
    return this.a._b(a);
};
_.Ic = function vq(a) {
    Qb(a);
    pub(this.a, new Aq(a));
};
_.Md = function wq() {
    var a;
    return a = dn(this.a).Md(), new eq(a);
};
_.gc = function yq() {
    return this.a.gc();
};
_.Lc = function zq() {
    return ek(dn(this.a).Lc(), new hq);
};
var nG = jeb(Tqe, 'ImmutableMapKeySet', 1190);
Ycb(1191, 1, {}, Aq);
_.Wd = function Bq(a, b) {
    Yl();
    this.a.Ad(a);
};
var mG = jeb(Tqe, 'ImmutableMapKeySet/lambda$0$Type', 1191);
Ycb(1187, 2024, rre, Cq);
_.Jc = function Gq() {
    return new Lq(this);
};
_.Kd = function Dq() {
    var a;
    a = dn(this.a).Kd();
    return new Oq(this, a);
};
_.Gc = function Eq(a) {
    return a != null && xr(new Lq(this), a);
};
_.Md = function Fq() {
    return new Lq(this);
};
_.gc = function Hq() {
    return this.a.gc();
};
_.Lc = function Iq() {
    return ek(dn(this.a).Lc(), new Jq);
};
var rG = jeb(Tqe, 'ImmutableMapValues', 1187);
Ycb(1188, 1, {}, Jq);
_.Kb = function Kq(a) {
    return JD(a, 43).kd();
};
var oG = jeb(Tqe, 'ImmutableMapValues/0methodref$getValue$Type', 1188);
Ycb(622, 204, Sqe, Lq);
_.Ob = function Mq() {
    return this.a.Ob();
};
_.Pb = function Nq() {
    return JD(this.a.Pb(), 43).kd();
};
var pG = jeb(Tqe, 'ImmutableMapValues/1', 622);
Ycb(1189, 2043, sre, Oq);
_.Xd = function Pq() {
    return this.a;
};
_.Xb = function Qq(a) {
    return JD(this.b.Xb(a), 43).kd();
};
var qG = jeb(Tqe, 'ImmutableMapValues/2', 1189);
Ycb(1192, 1, {}, Rq);
_.rd = function Sq(a) {
    return sq(this.a, a);
};
var vG = jeb(Tqe, 'IndexedImmutableSet/0methodref$get$Type', 1192);
Ycb(623, 2043, sre, Tq);
_.Xd = function Uq() {
    return this.a;
};
_.Xb = function Vq(a) {
    return sq(this.a, a);
};
_.gc = function Wq() {
    return this.a.a.gc();
};
var wG = jeb(Tqe, 'IndexedImmutableSet/1', 623);
Ycb(41, 1, {}, er);
_.Kb = function fr(a) {
    return JD(a, 20).Jc();
};
_.Fb = function gr(a) {
    return this === a;
};
var yG = jeb(Tqe, 'Iterables/10', 41);
Ycb(1030, 532, pre, ir);
_.Ic = function jr(a) {
    Qb(a);
    this.b.Ic(new mr(this.a, a));
};
_.Jc = function kr() {
    return hr(this);
};
var AG = jeb(Tqe, 'Iterables/4', 1030);
Ycb(1031, 1, kre, mr);
_.Ad = function nr(a) {
    lr(this.b, this.a, a);
};
var zG = jeb(Tqe, 'Iterables/4/lambda$0$Type', 1031);
Ycb(1032, 532, pre, or);
_.Ic = function pr(a) {
    Qb(a);
    ofb(this.a, new rr(a, this.b));
};
_.Jc = function qr() {
    return Ir(new CHd(this.a), this.b);
};
var CG = jeb(Tqe, 'Iterables/5', 1032);
Ycb(1033, 1, kre, rr);
_.Ad = function sr(a) {
    this.a.Ad(snd(a));
};
var BG = jeb(Tqe, 'Iterables/5/lambda$0$Type', 1033);
Ycb(1052, 204, Sqe, Kr);
_.Ob = function Lr() {
    return this.a.Ob();
};
_.Pb = function Mr() {
    return this.a.Pb();
};
var DG = jeb(Tqe, 'Iterators/1', 1052);
Ycb(1053, 697, Sqe, Nr);
_.Yb = function Or() {
    var a;
    while(this.b.Ob()){
        a = this.b.Pb();
        if (this.a.Lb(a)) return a;
    }
    return this.e = 2, null;
};
var EG = jeb(Tqe, 'Iterators/5', 1053);
Ycb(481, 1, Wqe);
_.Nb = function Qr(a) {
    Osb(this, a);
};
_.Ob = function Rr() {
    return this.b.Ob();
};
_.Pb = function Sr() {
    return this.Yd(this.b.Pb());
};
_.Qb = function Tr() {
    this.b.Qb();
};
var UH = jeb(Tqe, 'TransformedIterator', 481);
Ycb(1054, 481, Wqe, Ur);
_.Yd = function Vr(a) {
    return this.a.Kb(a);
};
var FG = jeb(Tqe, 'Iterators/6', 1054);
Ycb(715, 204, Sqe, Wr);
_.Ob = function Xr() {
    return !this.a;
};
_.Pb = function Yr() {
    if (this.a) throw scb(new qub);
    this.a = true;
    return this.b;
};
_.a = false;
var GG = jeb(Tqe, 'Iterators/9', 715);
Ycb(1051, 390, Uqe, _r);
_.Xb = function as(a) {
    return this.a[this.b + a];
};
_.b = 0;
var Zr;
var HG = jeb(Tqe, 'Iterators/ArrayItr', 1051);
Ycb(37, 1, {
    37: 1,
    49: 1
}, es);
_.Nb = function fs(a) {
    Osb(this, a);
};
_.Ob = function gs() {
    return cs(this);
};
_.Pb = function hs() {
    return ds(this);
};
_.Qb = function is() {
    if (!this.c) throw scb(new Web(Pqe));
    this.c.Qb();
    this.c = null;
};
var IG = jeb(Tqe, 'Iterators/ConcatenatedIterator', 37);
Ycb(23, 1, {
    3: 1,
    34: 1,
    23: 1
});
_.Dd = function ns(a) {
    return js(this, JD(a, 23));
};
_.Fb = function ps(a) {
    return this === a;
};
_.Hb = function qs() {
    return jDb(this);
};
_.Ib = function rs() {
    return ls(this);
};
_.g = 0;
var MI = jeb(Iqe, 'Enum', 23);
Ycb(534, 23, {
    534: 1,
    3: 1,
    34: 1,
    23: 1,
    49: 1
}, ws);
_.Nb = function xs(a) {
    Osb(this, a);
};
_.Ob = function ys() {
    return false;
};
_.Pb = function zs() {
    throw scb(new qub);
};
_.Qb = function As() {
    Vb(false);
};
var us;
var JG = keb(Tqe, 'Iterators/EmptyModifiableIterator', 534, MI, Cs, Bs);
var Ds;
Ycb(1853, 612, Vqe);
var PG = jeb(Tqe, 'LinkedHashMultimapGwtSerializationDependencies', 1853);
Ycb(1854, 1853, Vqe, Gs);
_.hc = function Is() {
    return new xtb(Ov(this.b));
};
_.$b = function Hs() {
    Nc(this);
    Os(this.a, this.a);
};
_.nd = function Js() {
    return new xtb(Ov(this.b));
};
_.ic = function Ks(a) {
    return new et(this, a, this.b);
};
_.kc = function Ls() {
    return new Vs(this);
};
_.lc = function Ms() {
    var a;
    return new Gvb((a = this.g, JD(!a ? this.g = new vh(this) : a, 22)), 17);
};
_.ec = function Ns() {
    var a;
    return a = this.i, !a ? this.i = new xf(this, this.c) : a;
};
_.nc = function Qs() {
    return new $v(new Vs(this));
};
_.oc = function Rs() {
    var a;
    return ek(new Gvb((a = this.g, JD(!a ? this.g = new vh(this) : a, 22)), 17), new Ss);
};
_.b = 2;
var QG = jeb(Tqe, 'LinkedHashMultimap', 1854);
Ycb(1857, 1, {}, Ss);
_.Kb = function Ts(a) {
    return JD(a, 43).kd();
};
var KG = jeb(Tqe, 'LinkedHashMultimap/0methodref$getValue$Type', 1857);
Ycb(813, 1, Wqe, Vs);
_.Nb = function Ws(a) {
    Osb(this, a);
};
_.Pb = function Ys() {
    return Us(this);
};
_.Ob = function Xs() {
    return this.a != this.b.a;
};
_.Qb = function Zs() {
    Vb(!!this.c);
    Gc(this.b, this.c.g, this.c.i);
    this.c = null;
};
var LG = jeb(Tqe, 'LinkedHashMultimap/1', 813);
Ycb(226, 244, {
    355: 1,
    244: 1,
    226: 1,
    588: 1,
    3: 1,
    43: 1
}, $s);
_.Zd = function _s() {
    return JD(vub(this.f), 588);
};
_.$d = function at(a) {
    this.c = a;
};
_._d = function bt(a) {
    this.f = a;
};
_.d = 0;
var MG = jeb(Tqe, 'LinkedHashMultimap/ValueEntry', 226);
Ycb(1855, 2014, {
    588: 1,
    20: 1,
    31: 1,
    16: 1,
    22: 1
}, et);
_.Ec = function ft(a) {
    var b, c, d, e, f;
    f = Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15)));
    b = f & this.b.length - 1;
    e = this.b[b];
    for(c = e; c; c = c.a){
        if (c.d == f && Hb(c.i, a)) return false;
    }
    d = new $s(this.c, a, f, e);
    Ps(this.d, d);
    d.f = this;
    this.d = d;
    Os(JD(vub(this.g.a.b), 226), d);
    Os(d, this.g.a);
    this.b[b] = d;
    ++this.f;
    ++this.e;
    ct(this);
    return true;
};
_.$b = function gt() {
    var a, b;
    Dmb(this.b, null);
    this.f = 0;
    for(a = this.a; a != this; a = a.Zd()){
        b = JD(a, 226);
        Os(JD(vub(b.b), 226), JD(vub(b.e), 226));
    }
    this.a = this;
    this.d = this;
    ++this.e;
};
_.Gc = function ht(a) {
    var b, c;
    c = Pcb(Fcb(yre, hfb(Pcb(Fcb(a == null ? 0 : tb(a), zre)), 15)));
    for(b = this.b[c & this.b.length - 1]; b; b = b.a){
        if (b.d == c && Hb(b.i, a)) return true;
    }
    return false;
};
_.Ic = function it(a) {
    var b;
    Qb(a);
    for(b = this.a; b != this; b = b.Zd())a.Ad(JD(b, 226).i);
};
_.Zd = function jt() {
    return this.a;
};
_.Jc = function kt() {
    return new qt(this);
};
_.Kc = function lt(a) {
    return dt(this, a);
};
_.$d = function mt(a) {
    this.d = a;
};
_._d = function nt(a) {
    this.a = a;
};
_.gc = function ot() {
    return this.f;
};
_.e = 0;
_.f = 0;
var OG = jeb(Tqe, 'LinkedHashMultimap/ValueSet', 1855);
Ycb(1856, 1, Wqe, qt);
_.Nb = function rt(a) {
    Osb(this, a);
};
_.Ob = function st() {
    return pt(this), this.b != this.c;
};
_.Pb = function tt() {
    var a, b;
    pt(this);
    if (this.b == this.c) throw scb(new qub);
    a = JD(this.b, 226);
    b = a.i;
    this.d = a;
    this.b = JD(vub(a.f), 588);
    return b;
};
_.Qb = function ut() {
    pt(this);
    Vb(!!this.d);
    dt(this.c, this.d.i);
    this.a = this.c.e;
    this.d = null;
};
_.a = 0;
var NG = jeb(Tqe, 'LinkedHashMultimap/ValueSet/1', 1856);
Ycb(762, 2030, Vqe, At);
_.Zb = function Bt() {
    var a;
    return a = this.f, !a ? this.f = new vw(this) : a;
};
_.Fb = function Gt(a) {
    return tw(this, a);
};
_.cc = function Ht(a) {
    return new ou(this, a);
};
_.fc = function Kt(a) {
    return yt(this, a);
};
_.$b = function Ct() {
    wt(this);
};
_._b = function Dt(a) {
    return xt(this, a);
};
_.ac = function Et() {
    return new vw(this);
};
_.bc = function Ft() {
    return new ru(this);
};
_.qc = function It(a) {
    return new ou(this, a);
};
_.dc = function Jt() {
    return !this.a;
};
_.rc = function Lt(a) {
    return yt(this, a);
};
_.gc = function Mt() {
    return this.d;
};
_.c = 0;
_.d = 0;
var XG = jeb(Tqe, 'LinkedListMultimap', 762);
Ycb(55, 31, Fre);
_.gd = function au(a) {
    hub(this, a);
};
_.Lc = function bu() {
    return new Gvb(this, 16);
};
_._c = function Pt(a, b) {
    throw scb(new bhb('Add not supported on this list'));
};
_.Ec = function Qt(a) {
    this._c(this.gc(), a);
    return true;
};
_.ad = function Rt(a, b) {
    var c, d, e;
    tDb(b);
    c = false;
    for(e = b.Jc(); e.Ob();){
        d = e.Pb();
        this._c(a++, d);
        c = true;
    }
    return c;
};
_.$b = function St() {
    this.ae(0, this.gc());
};
_.Fb = function Tt(a) {
    return Nt(this, a);
};
_.Hb = function Ut() {
    return tnb(this);
};
_.bd = function Vt(a) {
    return Ot(this, a);
};
_.Jc = function Wt() {
    return new ujb(this);
};
_.cd = function Xt() {
    return this.dd(0);
};
_.dd = function Yt(a) {
    return new Ajb(this, a);
};
_.ed = function Zt(a) {
    throw scb(new bhb('Remove not supported on this list'));
};
_.ae = function $t(a, b) {
    var c, d;
    d = this.dd(a);
    for(c = a; c < b; ++c){
        d.Pb();
        d.Qb();
    }
};
_.fd = function _t(a, b) {
    throw scb(new bhb('Set not supported on this list'));
};
_.hd = function cu(a, b) {
    return new Ijb(this, a, b);
};
_.j = 0;
var tJ = jeb(Xqe, 'AbstractList', 55);
Ycb(2008, 55, Fre);
_._c = function hu(a, b) {
    du(this, a, b);
};
_.ad = function iu(a, b) {
    return eu(this, a, b);
};
_.Xb = function ju(a) {
    return fu(this, a);
};
_.Jc = function ku() {
    return this.dd(0);
};
_.ed = function lu(a) {
    return gu(this, a);
};
_.fd = function mu(b, c) {
    var d, e;
    d = this.dd(b);
    try {
        e = d.Pb();
        d.Wb(c);
        return e;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 111)) throw scb(new mdb("Can't set element " + b));
        else throw scb(a);
    }
};
var HJ = jeb(Xqe, 'AbstractSequentialList', 2008);
Ycb(631, 2008, Fre, ou);
_.dd = function pu(a) {
    return nu(this, a);
};
_.gc = function qu() {
    var a;
    a = JD(Nib(this.a.b, this.b), 260);
    return !a ? 0 : a.a;
};
var SG = jeb(Tqe, 'LinkedListMultimap/1', 631);
Ycb(1269, 2014, _qe, ru);
_.Gc = function su(a) {
    return xt(this.a, a);
};
_.Jc = function tu() {
    return new xu(this.a);
};
_.Kc = function uu(a) {
    return !yt(this.a, a).a.dc();
};
_.gc = function vu() {
    return Uib(this.a.b);
};
var RG = jeb(Tqe, 'LinkedListMultimap/1KeySetImpl', 1269);
Ycb(1268, 1, Wqe, xu);
_.Nb = function yu(a) {
    Osb(this, a);
};
_.Ob = function zu() {
    wu(this);
    return !!this.c;
};
_.Pb = function Au() {
    wu(this);
    if (!this.c) throw scb(new qub);
    this.a = this.c;
    Nrb(this.d, this.a.a);
    do this.c = this.c.b;
    while (!!this.c && !Nrb(this.d, this.c.a));
    return this.a.a;
};
_.Qb = function Bu() {
    wu(this);
    Vb(!!this.a);
    wr(new Ju(this.e, this.a.a));
    this.a = null;
    this.b = this.e.c;
};
_.b = 0;
var TG = jeb(Tqe, 'LinkedListMultimap/DistinctKeyIterator', 1268);
Ycb(260, 1, {
    260: 1
}, Cu);
_.a = 0;
var UG = jeb(Tqe, 'LinkedListMultimap/KeyList', 260);
Ycb(495, 355, {
    355: 1,
    495: 1,
    43: 1
}, Du);
_.jd = function Eu() {
    return this.a;
};
_.kd = function Fu() {
    return this.f;
};
_.ld = function Gu(a) {
    var b;
    b = this.f;
    this.f = a;
    return b;
};
var VG = jeb(Tqe, 'LinkedListMultimap/Node', 495);
Ycb(551, 1, dre, Ju, Ku);
_.Nb = function Mu(a) {
    Osb(this, a);
};
_.Rb = function Lu(a) {
    this.e = vt(this.f, this.b, a, this.c);
    ++this.d;
    this.a = null;
};
_.Ob = function Nu() {
    return !!this.c;
};
_.Sb = function Ou() {
    return !!this.e;
};
_.Pb = function Pu() {
    return Hu(this);
};
_.Tb = function Qu() {
    return this.d;
};
_.Ub = function Ru() {
    return Iu(this);
};
_.Vb = function Su() {
    return this.d - 1;
};
_.Qb = function Tu() {
    Vb(!!this.a);
    if (this.a != this.c) {
        this.e = this.a.e;
        --this.d;
    } else this.c = this.a.c;
    zt(this.f, this.a);
    this.a = null;
};
_.Wb = function Uu(a) {
    Ub(!!this.a);
    this.a.f = a;
};
_.d = 0;
var WG = jeb(Tqe, 'LinkedListMultimap/ValueForKeyIterator', 551);
Ycb(1006, 55, Fre);
_._c = function ev(a, b) {
    this.a._c(a, b);
};
_.ad = function fv(a, b) {
    return this.a.ad(a, b);
};
_.Gc = function gv(a) {
    return this.a.Gc(a);
};
_.Xb = function hv(a) {
    return this.a.Xb(a);
};
_.ed = function iv(a) {
    return this.a.ed(a);
};
_.fd = function jv(a, b) {
    return this.a.fd(a, b);
};
_.gc = function kv() {
    return this.a.gc();
};
var ZG = jeb(Tqe, 'Lists/AbstractListWrapper', 1006);
Ycb(1007, 1006, Hre);
var $G = jeb(Tqe, 'Lists/RandomAccessListWrapper', 1007);
Ycb(1009, 1007, Hre, lv);
_.dd = function mv(a) {
    return this.a.dd(a);
};
var YG = jeb(Tqe, 'Lists/1', 1009);
Ycb(429, 55, {
    429: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1
}, qv);
_._c = function rv(a, b) {
    this.a._c(pv(this, a), b);
};
_.$b = function sv() {
    this.a.$b();
};
_.Xb = function tv(a) {
    return this.a.Xb(ov(this, a));
};
_.Jc = function uv() {
    return nv(this, 0);
};
_.dd = function vv(a) {
    return nv(this, a);
};
_.ed = function wv(a) {
    return this.a.ed(ov(this, a));
};
_.ae = function xv(a, b) {
    (Tb(a, b, this.a.gc()), dv(this.a.hd(pv(this, b), pv(this, a)))).$b();
};
_.fd = function yv(a, b) {
    return this.a.fd(ov(this, a), b);
};
_.gc = function zv() {
    return this.a.gc();
};
_.hd = function Av(a, b) {
    return Tb(a, b, this.a.gc()), dv(this.a.hd(pv(this, b), pv(this, a)));
};
var bH = jeb(Tqe, 'Lists/ReverseList', 429);
Ycb(1005, 429, {
    429: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, Bv);
var _G = jeb(Tqe, 'Lists/RandomAccessReverseList', 1005);
Ycb(1008, 1, dre, Cv);
_.Nb = function Ev(a) {
    Osb(this, a);
};
_.Rb = function Dv(a) {
    this.c.Rb(a);
    this.c.Ub();
    this.a = false;
};
_.Ob = function Fv() {
    return this.c.Sb();
};
_.Sb = function Gv() {
    return this.c.Ob();
};
_.Pb = function Hv() {
    if (!this.c.Sb()) throw scb(new qub);
    this.a = true;
    return this.c.Ub();
};
_.Tb = function Iv() {
    return pv(this.b, this.c.Tb());
};
_.Ub = function Jv() {
    if (!this.c.Ob()) throw scb(new qub);
    this.a = true;
    return this.c.Pb();
};
_.Vb = function Kv() {
    return pv(this.b, this.c.Tb()) - 1;
};
_.Qb = function Lv() {
    Vb(this.a);
    this.c.Qb();
    this.a = false;
};
_.Wb = function Mv(a) {
    Ub(this.a);
    this.c.Wb(a);
};
_.a = false;
var aH = jeb(Tqe, 'Lists/ReverseList/1', 1008);
Ycb(428, 481, Wqe, Yv);
_.Yd = function Zv(a) {
    return Xv(a);
};
var cH = jeb(Tqe, 'Maps/1', 428);
Ycb(696, 481, Wqe, $v);
_.Yd = function _v(a) {
    return JD(a, 43).kd();
};
var dH = jeb(Tqe, 'Maps/2', 696);
Ycb(953, 481, Wqe, aw);
_.Yd = function bw(a) {
    return new cp(a, Iw(this.a, a));
};
var eH = jeb(Tqe, 'Maps/3', 953);
Ycb(950, 2015, _qe, cw);
_.Ic = function dw(a) {
    sj(this.a, a);
};
_.Jc = function ew() {
    return this.a.kc();
};
_.Pc = function fw() {
    return this.a;
};
_.Lc = function gw() {
    return this.a.lc();
};
var gH = jeb(Tqe, 'Maps/IteratorBasedAbstractMap/1', 950);
Ycb(951, 1, {}, hw);
_.Wd = function iw(a, b) {
    this.a.Ad(a);
};
var iH = jeb(Tqe, 'Maps/KeySet/lambda$0$Type', 951);
Ycb(949, 31, Zqe, jw);
_.$b = function kw() {
    this.a.$b();
};
_.Gc = function lw(a) {
    return this.a.uc(a);
};
_.Ic = function mw(a) {
    Qb(a);
    this.a.wc(new rw(a));
};
_.dc = function nw() {
    return this.a.dc();
};
_.Jc = function ow() {
    return new $v(this.a.vc().Jc());
};
_.Kc = function pw(b) {
    var c, d;
    try {
        return ye(this, b, true);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 46)) {
            for(d = this.a.vc().Jc(); d.Ob();){
                c = JD(d.Pb(), 43);
                if (Hb(b, c.kd())) {
                    this.a.Ac(c.jd());
                    return true;
                }
            }
            return false;
        } else throw scb(a);
    }
};
_.gc = function qw() {
    return this.a.gc();
};
var lH = jeb(Tqe, 'Maps/Values', 949);
Ycb(952, 1, {}, rw);
_.Wd = function sw(a, b) {
    this.a.Ad(b);
};
var kH = jeb(Tqe, 'Maps/Values/lambda$0$Type', 952);
Ycb(735, 2031, Yqe, vw);
_.xc = function zw(a) {
    return this.a._b(a) ? this.a.cc(a) : null;
};
_.Ac = function Cw(a) {
    return this.a._b(a) ? this.a.fc(a) : null;
};
_.$b = function ww() {
    this.a.$b();
};
_._b = function xw(a) {
    return this.a._b(a);
};
_.Dc = function yw() {
    return new Ew(this);
};
_.Cc = function() {
    return this.Dc();
};
_.dc = function Aw() {
    return this.a.dc();
};
_.ec = function Bw() {
    return this.a.ec();
};
_.gc = function Dw() {
    return this.a.ec().gc();
};
var pH = jeb(Tqe, 'Multimaps/AsMap', 735);
Ycb(1098, 2015, _qe, Ew);
_.Jc = function Fw() {
    return Nv(this.a.a.ec(), new Jw(this));
};
_.Pc = function Gw() {
    return this.a;
};
_.Kc = function Hw(a) {
    var b;
    if (!Xe(this, a)) return false;
    b = JD(vub(JD(a, 43)), 43);
    uw(this.a, b.jd());
    return true;
};
var oH = jeb(Tqe, 'Multimaps/AsMap/EntrySet', 1098);
Ycb(1102, 1, {}, Jw);
_.Kb = function Kw(a) {
    return Iw(this, a);
};
_.Fb = function Lw(a) {
    return this === a;
};
var nH = jeb(Tqe, 'Multimaps/AsMap/EntrySet/1', 1102);
Ycb(537, 2033, {
    537: 1,
    828: 1,
    20: 1,
    31: 1,
    16: 1
}, Ow);
_.$b = function Pw() {
    Nc(this.a);
};
_.Gc = function Qw(a) {
    return Oc(this.a, a);
};
_.Ic = function Rw(a) {
    Qb(a);
    ofb(Pc(this.a), new bx(a));
};
_.Jc = function Sw() {
    return new Yv(Pc(this.a).a.kc());
};
_.gc = function Tw() {
    return this.a.d;
};
_.Lc = function Uw() {
    return ek(Pc(this.a).Lc(), new Vw);
};
var vH = jeb(Tqe, 'Multimaps/Keys', 537);
Ycb(1100, 1, {}, Vw);
_.Kb = function Ww(a) {
    return JD(a, 43).jd();
};
var rH = jeb(Tqe, 'Multimaps/Keys/0methodref$getKey$Type', 1100);
Ycb(1099, 481, Wqe, Xw);
_.Yd = function Yw(a) {
    return new ax(JD(a, 43));
};
var tH = jeb(Tqe, 'Multimaps/Keys/1', 1099);
Ycb(2034, 1, {
    413: 1
});
_.Fb = function Zw(a) {
    var b;
    if (RD(a, 488)) {
        b = JD(a, 413);
        return JD(this.a.kd(), 16).gc() == JD(b.a.kd(), 16).gc() && Hb(this.a.jd(), b.a.jd());
    }
    return false;
};
_.Hb = function $w() {
    var a;
    a = this.a.jd();
    return (a == null ? 0 : tb(a)) ^ JD(this.a.kd(), 16).gc();
};
_.Ib = function _w() {
    var a, b;
    b = xgb(this.a.jd());
    a = JD(this.a.kd(), 16).gc();
    return a == 1 ? b : b + ' x ' + a;
};
var zH = jeb(Tqe, 'Multisets/AbstractEntry', 2034);
Ycb(488, 2034, {
    488: 1,
    413: 1
}, ax);
var sH = jeb(Tqe, 'Multimaps/Keys/1/1', 488);
Ycb(1101, 1, kre, bx);
_.Ad = function cx(a) {
    this.a.Ad(JD(a, 43).jd());
};
var uH = jeb(Tqe, 'Multimaps/Keys/lambda$1$Type', 1101);
Ycb(1104, 1, kre, fx);
_.Ad = function gx(a) {
    dx(JD(a, 413));
};
var wH = jeb(Tqe, 'Multiset/lambda$0$Type', 1104);
Ycb(736, 1, kre, hx);
_.Ad = function ix(a) {
    ex(this.a, JD(a, 413));
};
var xH = jeb(Tqe, 'Multiset/lambda$1$Type', 736);
Ycb(1105, 1, {}, nx);
var yH = jeb(Tqe, 'Multisets/0methodref$add$Type', 1105);
Ycb(737, 1, {}, ox);
_.Kb = function px(a) {
    return lx(JD(a, 413));
};
var BH = jeb(Tqe, 'Multisets/lambda$1$Type', 737);
Ycb(2052, 1, Jqe);
var CH = jeb(Tqe, 'RangeGwtSerializationDependencies', 2052);
Ycb(505, 2052, {
    177: 1,
    505: 1,
    3: 1,
    48: 1
}, sx);
_.Lb = function tx(a) {
    return rx(this, JD(a, 34));
};
_.Mb = function xx(a) {
    return rx(this, JD(a, 34));
};
_.Fb = function vx(a) {
    var b;
    if (RD(a, 505)) {
        b = JD(a, 505);
        return Nk(this.a, b.a) && Nk(this.b, b.b);
    }
    return false;
};
_.Hb = function wx() {
    return this.a.Hb() * 31 + this.b.Hb();
};
_.Ib = function yx() {
    return zx(this.a, this.b);
};
var DH = jeb(Tqe, 'Range', 505);
Ycb(637, 2043, sre, Bx);
_.dd = function Fx(a) {
    return rm(this.b, a);
};
_.Xd = function Cx() {
    return this.a;
};
_.Xb = function Dx(a) {
    return Nm(this.b, a);
};
_.Nd = function Ex(a) {
    return rm(this.b, a);
};
var EH = jeb(Tqe, 'RegularImmutableAsList', 637);
Ycb(640, 2051, sre, Gx);
_.Pd = function Hx() {
    return this.a;
};
var FH = jeb(Tqe, 'RegularImmutableList', 640);
Ycb(533, 713, ure, Ix, Jx);
var GH = jeb(Tqe, 'RegularImmutableMap', 533);
Ycb(714, 703, wre, Mx);
var Kx;
var HH = jeb(Tqe, 'RegularImmutableSet', 714);
Ycb(2020, $qe, _qe);
_.Jc = function Zx() {
    return new jy(this.a, this.b);
};
_.Ec = function Wx(a) {
    throw scb(new ahb);
};
_.Fc = function Xx(a) {
    throw scb(new ahb);
};
_.$b = function Yx() {
    throw scb(new ahb);
};
_.Kc = function $x(a) {
    throw scb(new ahb);
};
var MH = jeb(Tqe, 'Sets/SetView', 2020);
Ycb(954, 2020, _qe, ay);
_.Jc = function ey() {
    return new jy(this.a, this.b);
};
_.Gc = function by(a) {
    return qrb(this.a, a) && this.b.Gc(a);
};
_.Hc = function cy(a) {
    return Ae(this.a, a) && this.b.Hc(a);
};
_.dc = function dy() {
    return rnb(this.b, this.a);
};
_.gc = function fy() {
    return _x(this);
};
_.Mc = function gy() {
    return BBb(new RBb(null, new Gvb(this.a, 1)), new hy(this.b));
};
var KH = jeb(Tqe, 'Sets/2', 954);
Ycb(955, 1, Ire, hy);
_.Mb = function iy(a) {
    return this.a.Gc(a);
};
var IH = jeb(Tqe, 'Sets/2/0methodref$contains$Type', 955);
Ycb(698, 697, Sqe, jy);
_.Yb = function ky() {
    var a;
    while(Brb(this.a)){
        a = Crb(this.a);
        if (this.c.Gc(a)) return a;
    }
    return this.e = 2, null;
};
var JH = jeb(Tqe, 'Sets/2/1', 698);
Ycb(601, 2019, {
    601: 1,
    3: 1,
    20: 1,
    16: 1,
    274: 1,
    22: 1,
    83: 1
}, ly);
_.Id = function my() {
    return this.b;
};
_.Jd = function ny() {
    return this.b;
};
_.Ud = function oy() {
    return this.b;
};
_.Ic = function py(a) {
    this.a.Ic(a);
};
_.Mc = function qy() {
    return this.a.Mc();
};
var NH = jeb(Tqe, 'Sets/UnmodifiableNavigableSet', 601);
Ycb(1977, 1976, ure, ry);
_.Td = function sy() {
    return Yl(), new xy(this.a);
};
_.Bc = function ty() {
    return Yl(), new xy(this.a);
};
_.vd = function uy() {
    return Yl(), new xy(this.a);
};
var OH = jeb(Tqe, 'SingletonImmutableBiMap', 1977);
Ycb(641, 2051, sre, vy);
_.Pd = function wy() {
    return this.a;
};
var PH = jeb(Tqe, 'SingletonImmutableList', 641);
Ycb(356, 2025, wre, xy);
_.Jc = function Ay() {
    return new Wr(this.a);
};
_.Gc = function yy(a) {
    return pb(this.a, a);
};
_.Md = function zy() {
    return new Wr(this.a);
};
_.gc = function By() {
    return 1;
};
var QH = jeb(Tqe, 'SingletonImmutableSet', 356);
Ycb(1112, 1, {}, Ey);
_.Kb = function Fy(a) {
    return JD(a, 158);
};
var RH = jeb(Tqe, 'Streams/lambda$0$Type', 1112);
Ycb(1113, 1, Jre, Gy);
_.be = function Hy() {
    Cy(this.a);
};
var SH = jeb(Tqe, 'Streams/lambda$1$Type', 1113);
Ycb(1667, 1666, Vqe, Jy);
_.Zb = function Ky() {
    var a;
    return a = this.f, JD(JD(!a ? this.f = RD(this.c, 137) ? new Sf(this, JD(this.c, 137)) : RD(this.c, 134) ? new Kf(this, JD(this.c, 134)) : new me(this, this.c) : a, 134), 137);
};
_.hc = function Ny() {
    return new mzb(this.b);
};
_.nd = function Oy() {
    return new mzb(this.b);
};
_.ec = function Qy() {
    var a;
    return a = this.i, JD(JD(!a ? this.i = RD(this.c, 137) ? new eg(this, JD(this.c, 137)) : RD(this.c, 134) ? new cg(this, JD(this.c, 134)) : new xf(this, this.c) : a, 83), 274);
};
_.ac = function My() {
    return RD(this.c, 137) ? new Sf(this, JD(this.c, 137)) : RD(this.c, 134) ? new Kf(this, JD(this.c, 134)) : new me(this, this.c);
};
_.ic = function Py(a) {
    a == null && this.a.Le(a, a);
    return new mzb(this.b);
};
var VH = jeb(Tqe, 'TreeMultimap', 1667);
Ycb(80, 1, {
    3: 1,
    80: 1
});
_.ce = function hz(a) {
    return new Error(a);
};
_.de = function jz() {
    return this.e;
};
_.ee = function kz() {
    var a, b, c;
    c = (this.k == null && (this.k = SC(iJ, hre, 80, 0, 0, 1)), this.k);
    b = SC(aJ, Nqe, 1, c.length, 5, 1);
    for(a = 0; a < c.length; a++)b[a] = c[a].e;
    return b;
};
_.fe = function lz() {
    return this.f;
};
_.ge = function mz() {
    return this.g;
};
_.he = function nz() {
    cz(this, iz(this.ce(dz(this, this.g))));
    $z(this);
};
_.Ib = function oz() {
    return dz(this, this.ge());
};
_.e = Mre;
_.i = false;
_.n = true;
var iJ = jeb(Iqe, 'Throwable', 80);
Ycb(103, 80, {
    3: 1,
    103: 1,
    80: 1
});
var OI = jeb(Iqe, 'Exception', 103);
Ycb(63, 103, Nre, pz, qz);
var bJ = jeb(Iqe, 'RuntimeException', 63);
Ycb(591, 63, Nre);
var WI = jeb(Iqe, 'JsException', 591);
Ycb(851, 591, Nre);
var aI = jeb(Ore, 'JavaScriptExceptionBase', 851);
Ycb(472, 851, {
    472: 1,
    3: 1,
    103: 1,
    63: 1,
    80: 1
}, uz);
_.ge = function xz() {
    tz(this);
    return this.c;
};
_.ie = function yz() {
    return XD(this.b) === XD(rz) ? null : this.b;
};
var rz;
var YH = jeb(Qre, 'JavaScriptException', 472);
var ZH = jeb(Qre, 'JavaScriptObject$', 0);
var Bz;
Ycb(1993, 1, {});
var _H = jeb(Qre, 'Scheduler', 1993);
var Fz = 0, Gz = 0, Hz = -1;
Ycb(878, 1993, {}, Vz);
var Rz;
var bI = jeb(Ore, 'SchedulerImpl', 878);
var Yz;
Ycb(2004, 1, {});
var fI = jeb(Ore, 'StackTraceCreator/Collector', 2004);
Ycb(852, 2004, {}, eA);
_.je = function fA(a) {
    var b = {}, j;
    var c = [];
    a[Sre] = c;
    var d = arguments.callee.caller;
    while(d){
        var e = (Zz(), d.name || (d.name = aA(d.toString())));
        c.push(e);
        var f = ':' + e;
        var g = b[f];
        if (g) {
            var h, i;
            for(h = 0, i = g.length; h < i; h++){
                if (g[h] === d) return;
            }
        }
        (g || (b[f] = [])).push(d);
        d = d.caller;
    }
};
_.ke = function gA(a) {
    var b, c, d, e;
    d = (Zz(), a && a[Sre] ? a[Sre] : []);
    c = d.length;
    e = SC(dJ, hre, 320, c, 0, 1);
    for(b = 0; b < c; b++)e[b] = new Xfb(d[b], null, -1);
    return e;
};
var cI = jeb(Ore, 'StackTraceCreator/CollectorLegacy', 852);
Ycb(2005, 2004, {});
_.je = function iA(a) {};
_.le = function jA(a, b, c, d) {
    return new Xfb(b, a + '@' + d, c < 0 ? -1 : c);
};
_.ke = function kA(a) {
    var b, c, d, e, f, g;
    e = cA(a);
    f = SC(dJ, hre, 320, 0, 0, 1);
    b = 0;
    d = e.length;
    if (d == 0) return f;
    g = hA(this, e[0]);
    cgb(g.d, Rre) || (f[b++] = g);
    for(c = 1; c < d; c++)f[b++] = hA(this, e[c]);
    return f;
};
var eI = jeb(Ore, 'StackTraceCreator/CollectorModern', 2005);
Ycb(853, 2005, {}, lA);
_.le = function mA(a, b, c, d) {
    return new Xfb(b, a, -1);
};
var dI = jeb(Ore, 'StackTraceCreator/CollectorModernNoSourceMap', 853);
Ycb(1039, 1, {});
var mI = jeb(sse, tse, 1039);
Ycb(609, 1039, {
    609: 1
}, PA);
var NA;
var gI = jeb(use, tse, 609);
Ycb(2047, 1, {});
var nI = jeb(sse, vse, 2047);
Ycb(wse, 2047, {});
var hI = jeb(use, vse, wse);
Ycb(1084, 1, {}, UA);
var RA;
var iI = jeb(use, 'LocaleInfo', 1084);
Ycb(1973, 1, {}, XA);
_.a = 0;
var jI = jeb(use, 'TimeZone', 1973);
Ycb(1246, wse, {}, bB);
var kI = jeb('com.google.gwt.i18n.client.impl.cldr', 'DateTimeFormatInfoImpl', 1246);
Ycb(431, 1, {
    431: 1
}, cB);
_.a = false;
_.b = 0;
var lI = jeb(sse, 'DateTimeFormat/PatternPart', 431);
Ycb(205, 1, xse, mB, nB, oB);
_.Dd = function pB(a) {
    return dB(this, JD(a, 205));
};
_.Fb = function qB(a) {
    return RD(a, 205) && ycb(zcb(this.q.getTime()), zcb(JD(a, 205).q.getTime()));
};
_.Hb = function rB() {
    var a;
    a = zcb(this.q.getTime());
    return Pcb(Rcb(a, Lcb(a, 32)));
};
_.Ib = function tB() {
    var a, b, c;
    c = -this.q.getTimezoneOffset();
    a = (c >= 0 ? '+' : '') + (c / 60 | 0);
    b = sB($wnd.Math.abs(c) % 60);
    return (Bqb(), zqb)[this.q.getDay()] + ' ' + Aqb[this.q.getMonth()] + ' ' + sB(this.q.getDate()) + ' ' + sB(this.q.getHours()) + ':' + sB(this.q.getMinutes()) + ':' + sB(this.q.getSeconds()) + ' GMT' + a + b + ' ' + this.q.getFullYear();
};
var hK = jeb(Xqe, 'Date', 205);
Ycb(1961, 205, xse, vB);
_.a = false;
_.b = 0;
_.c = 0;
_.d = 0;
_.e = 0;
_.f = 0;
_.g = false;
_.i = 0;
_.j = 0;
_.k = 0;
_.n = 0;
_.o = 0;
_.p = 0;
var oI = jeb('com.google.gwt.i18n.shared.impl', 'DateRecord', 1961);
Ycb(2010, 1, {});
_.ne = function wB() {
    return null;
};
_.oe = function xB() {
    return null;
};
_.pe = function yB() {
    return null;
};
_.qe = function zB() {
    return null;
};
_.re = function AB() {
    return null;
};
var xI = jeb(yse, 'JSONValue', 2010);
Ycb(138, 2010, {
    138: 1
}, EB, FB);
_.Fb = function GB(a) {
    if (!RD(a, 138)) return false;
    return zz(this.a, JD(a, 138).a);
};
_.me = function HB() {
    return LB;
};
_.Hb = function IB() {
    return Az(this.a);
};
_.ne = function JB() {
    return this;
};
_.Ib = function KB() {
    var a, b, c;
    c = new Wgb('[');
    for(b = 0, a = this.a.length; b < a; b++){
        b > 0 && (c.a += ',', c);
        Pgb(c, BB(this, b));
    }
    c.a += ']';
    return c.a;
};
var pI = jeb(yse, 'JSONArray', 138);
Ycb(477, 2010, {
    477: 1
}, PB);
_.me = function QB() {
    return TB;
};
_.oe = function RB() {
    return this;
};
_.Ib = function SB() {
    return xdb(), '' + this.a;
};
_.a = false;
var MB, NB;
var qI = jeb(yse, 'JSONBoolean', 477);
Ycb(974, 63, Nre, UB);
var rI = jeb(yse, 'JSONException', 974);
Ycb(1011, 2010, {}, XB);
_.me = function YB() {
    return $B;
};
_.Ib = function ZB() {
    return Rqe;
};
var VB;
var sI = jeb(yse, 'JSONNull', 1011);
Ycb(263, 2010, {
    263: 1
}, _B);
_.Fb = function aC(a) {
    if (!RD(a, 263)) return false;
    return this.a == JD(a, 263).a;
};
_.me = function bC() {
    return fC;
};
_.Hb = function cC() {
    return Eeb(this.a);
};
_.pe = function dC() {
    return this;
};
_.Ib = function eC() {
    return this.a + '';
};
_.a = 0;
var tI = jeb(yse, 'JSONNumber', 263);
Ycb(147, 2010, {
    147: 1
}, mC, nC);
_.Fb = function oC(a) {
    if (!RD(a, 147)) return false;
    return zz(this.a, JD(a, 147).a);
};
_.me = function pC() {
    return tC;
};
_.Hb = function qC() {
    return Az(this.a);
};
_.qe = function rC() {
    return this;
};
_.Ib = function sC() {
    var a, b, c, d, e, f, g;
    g = new Wgb('{');
    a = true;
    f = gC(this, SC(hJ, hre, 2, 0, 6, 1));
    for(c = f, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        a ? a = false : (g.a += Lqe, g);
        Qgb(g, Dz(b));
        g.a += ':';
        Pgb(g, iC(this, b));
    }
    g.a += '}';
    return g.a;
};
var vI = jeb(yse, 'JSONObject', 147);
Ycb(589, $qe, _qe, uC);
_.Gc = function vC(a) {
    return VD(a) && hC(this.a, OD(a));
};
_.Jc = function wC() {
    return new ujb(new dnb(this.b));
};
_.gc = function xC() {
    return this.b.length;
};
var uI = jeb(yse, 'JSONObject/1', 589);
var yC;
Ycb(210, 2010, {
    210: 1
}, GC);
_.Fb = function HC(a) {
    if (!RD(a, 210)) return false;
    return cgb(this.a, JD(a, 210).a);
};
_.me = function IC() {
    return MC;
};
_.Hb = function JC() {
    return fgb(this.a);
};
_.re = function KC() {
    return this;
};
_.Ib = function LC() {
    return Dz(this.a);
};
var wI = jeb(yse, 'JSONString', 210);
var YC;
var AD, BD, CD, DD;
Ycb(2006, 1, {
    518: 1
});
var zI = jeb(Gse, 'OutputStream', 2006);
Ycb(2007, 2006, {
    518: 1
});
var yI = jeb(Gse, 'FilterOutputStream', 2007);
Ycb(854, 2007, {
    518: 1
}, fdb);
var AI = jeb(Gse, 'PrintStream', 854);
Ycb(415, 1, {
    470: 1
});
_.Ib = function jdb() {
    return this.a;
};
var BI = jeb(Iqe, 'AbstractStringBuilder', 415);
Ycb(523, 63, Nre, kdb);
var CI = jeb(Iqe, 'ArithmeticException', 523);
Ycb(97, 63, Hse, ldb, mdb);
var TI = jeb(Iqe, 'IndexOutOfBoundsException', 97);
Ycb(638, 97, Hse, ndb, odb);
var DI = jeb(Iqe, 'ArrayIndexOutOfBoundsException', 638);
Ycb(522, 63, Nre, pdb, qdb);
var EI = jeb(Iqe, 'ArrayStoreException', 522);
Ycb(294, 80, Ise, rdb);
var NI = jeb(Iqe, 'Error', 294);
Ycb(200, 294, Ise, tdb, udb);
var FI = jeb(Iqe, 'AssertionError', 200);
FD = {
    3: 1,
    471: 1,
    34: 1
};
var vdb, wdb;
var GI = jeb(Iqe, 'Boolean', 471);
Ycb(241, 1, {
    3: 1,
    241: 1
});
var Ddb;
var _I = jeb(Iqe, 'Number', 241);
Ycb(219, 241, {
    3: 1,
    219: 1,
    34: 1,
    241: 1
}, Jdb);
_.Dd = function Kdb(a) {
    return Idb(this, JD(a, 219));
};
_.se = function Ldb() {
    return this.a;
};
_.Fb = function Mdb(a) {
    return RD(a, 219) && JD(a, 219).a == this.a;
};
_.Hb = function Ndb() {
    return this.a;
};
_.Ib = function Odb() {
    return '' + this.a;
};
_.a = 0;
var HI = jeb(Iqe, 'Byte', 219);
var Pdb;
Ycb(179, 1, {
    3: 1,
    179: 1,
    34: 1
}, Udb);
_.Dd = function Vdb(a) {
    return Tdb(this, JD(a, 179));
};
_.Fb = function Xdb(a) {
    return RD(a, 179) && JD(a, 179).a == this.a;
};
_.Hb = function Ydb() {
    return this.a;
};
_.Ib = function Zdb() {
    return String.fromCharCode(this.a);
};
_.a = 0;
var Sdb;
var II = jeb(Iqe, 'Character', 179);
var _db;
Ycb(211, 63, {
    3: 1,
    211: 1,
    103: 1,
    63: 1,
    80: 1
}, yeb, zeb);
var JI = jeb(Iqe, 'ClassCastException', 211);
GD = {
    3: 1,
    34: 1,
    341: 1,
    241: 1
};
var LI = jeb(Iqe, 'Double', 341);
Ycb(160, 241, {
    3: 1,
    34: 1,
    160: 1,
    241: 1
}, Keb, Leb);
_.Dd = function Meb(a) {
    return Jeb(this, JD(a, 160));
};
_.se = function Neb() {
    return this.a;
};
_.Fb = function Oeb(a) {
    return RD(a, 160) && Ceb(this.a, JD(a, 160).a);
};
_.Hb = function Peb() {
    return YD(this.a);
};
_.Ib = function Reb() {
    return '' + this.a;
};
_.a = 0;
var QI = jeb(Iqe, 'Float', 160);
Ycb(32, 63, {
    3: 1,
    103: 1,
    32: 1,
    63: 1,
    80: 1
}, Seb, Teb, Ueb);
var RI = jeb(Iqe, 'IllegalArgumentException', 32);
Ycb(73, 63, Nre, Veb, Web);
var SI = jeb(Iqe, 'IllegalStateException', 73);
Ycb(17, 241, {
    3: 1,
    34: 1,
    17: 1,
    241: 1
}, Yeb);
_.Dd = function _eb(a) {
    return Xeb(this, JD(a, 17));
};
_.se = function afb() {
    return this.a;
};
_.Fb = function bfb(a) {
    return RD(a, 17) && JD(a, 17).a == this.a;
};
_.Hb = function cfb() {
    return this.a;
};
_.Ib = function ifb() {
    return '' + this.a;
};
_.a = 0;
var UI = jeb(Iqe, 'Integer', 17);
var kfb;
var mfb;
Ycb(190, 241, {
    3: 1,
    34: 1,
    190: 1,
    241: 1
}, qfb);
_.Dd = function sfb(a) {
    return pfb(this, JD(a, 190));
};
_.se = function tfb() {
    return Ocb(this.a);
};
_.Fb = function ufb(a) {
    return RD(a, 190) && ycb(JD(a, 190).a, this.a);
};
_.Hb = function vfb() {
    return wfb(this.a);
};
_.Ib = function xfb() {
    return '' + Qcb(this.a);
};
_.a = 0;
var XI = jeb(Iqe, 'Long', 190);
var zfb;
Ycb(2086, 1, {});
Ycb(1850, 63, Nre, Dfb);
var YI = jeb(Iqe, 'NegativeArraySizeException', 1850);
Ycb(169, 591, {
    3: 1,
    103: 1,
    169: 1,
    63: 1,
    80: 1
}, Efb, Ffb);
_.ce = function Gfb(a) {
    return new TypeError(a);
};
var ZI = jeb(Iqe, 'NullPointerException', 169);
var Hfb, Ifb, Jfb, Kfb;
Ycb(130, 32, {
    3: 1,
    103: 1,
    32: 1,
    130: 1,
    63: 1,
    80: 1
}, Mfb);
var $I = jeb(Iqe, 'NumberFormatException', 130);
Ycb(191, 241, {
    3: 1,
    34: 1,
    241: 1,
    191: 1
}, Ofb);
_.Dd = function Pfb(a) {
    return Nfb(this, JD(a, 191));
};
_.se = function Qfb() {
    return this.a;
};
_.Fb = function Rfb(a) {
    return RD(a, 191) && JD(a, 191).a == this.a;
};
_.Hb = function Sfb() {
    return this.a;
};
_.Ib = function Tfb() {
    return '' + this.a;
};
_.a = 0;
var cJ = jeb(Iqe, 'Short', 191);
var Vfb;
Ycb(320, 1, {
    3: 1,
    320: 1
}, Xfb);
_.Fb = function Yfb(a) {
    var b;
    if (RD(a, 320)) {
        b = JD(a, 320);
        return this.c == b.c && this.d == b.d && this.a == b.a && this.b == b.b;
    }
    return false;
};
_.Hb = function Zfb() {
    return Kmb(WC(OC(aJ, 1), Nqe, 1, 5, [
        jfb(this.c),
        this.a,
        this.d,
        this.b
    ]));
};
_.Ib = function $fb() {
    return this.a + '.' + this.d + '(' + (this.b != null ? this.b : 'Unknown Source') + (this.c >= 0 ? ':' + this.c : '') + ')';
};
_.c = 0;
var dJ = jeb(Iqe, 'StackTraceElement', 320);
HD = {
    3: 1,
    470: 1,
    34: 1,
    2: 1
};
var hJ = jeb(Iqe, Pre, 2);
Ycb(110, 415, {
    470: 1
}, Hgb, Igb, Jgb);
var eJ = jeb(Iqe, 'StringBuffer', 110);
Ycb(104, 415, {
    470: 1
}, Ugb, Vgb, Wgb);
var fJ = jeb(Iqe, 'StringBuilder', 104);
Ycb(686, 97, Hse, Xgb);
var gJ = jeb(Iqe, 'StringIndexOutOfBoundsException', 686);
Ycb(2091, 1, {});
var Ygb;
Ycb(46, 63, {
    3: 1,
    103: 1,
    63: 1,
    80: 1,
    46: 1
}, ahb, bhb);
var jJ = jeb(Iqe, 'UnsupportedOperationException', 46);
Ycb(245, 241, {
    3: 1,
    34: 1,
    241: 1,
    245: 1
}, rhb, shb);
_.Dd = function vhb(a) {
    return lhb(this, JD(a, 245));
};
_.se = function whb() {
    return Edb(qhb(this));
};
_.Fb = function xhb(a) {
    var b;
    if (this === a) return true;
    if (RD(a, 245)) {
        b = JD(a, 245);
        return this.e == b.e && lhb(this, b) == 0;
    }
    return false;
};
_.Hb = function yhb() {
    var a;
    if (this.b != 0) return this.b;
    if (this.a < 54) {
        a = zcb(this.f);
        this.b = Pcb(ucb(a, -1));
        this.b = 33 * this.b + Pcb(ucb(Kcb(a, 32), -1));
        this.b = 17 * this.b + YD(this.e);
        return this.b;
    }
    this.b = 17 * Mhb(this.c) + YD(this.e);
    return this.b;
};
_.Ib = function zhb() {
    return qhb(this);
};
_.a = 0;
_.b = 0;
_.d = 0;
_.e = 0;
_.f = 0;
var chb, dhb, ehb, fhb, ghb, hhb, ihb, jhb;
var kJ = jeb('java.math', 'BigDecimal', 245);
Ycb(90, 241, {
    3: 1,
    34: 1,
    241: 1,
    90: 1
}, Thb, Uhb, Vhb, Whb, Xhb);
_.Dd = function Zhb(a) {
    return Hhb(this, JD(a, 90));
};
_.se = function $hb() {
    return Edb(rib(this, 0));
};
_.Fb = function _hb(a) {
    return Jhb(this, a);
};
_.Hb = function cib() {
    return Mhb(this);
};
_.Ib = function eib() {
    return rib(this, 0);
};
_.b = -2;
_.c = 0;
_.d = 0;
_.e = 0;
var Ahb, Bhb, Chb, Dhb, Ehb, Fhb;
var lJ = jeb('java.math', 'BigInteger', 90);
var mib, nib;
var Aib, Bib;
Ycb(482, 2011, Yqe);
_.$b = function Wib() {
    Tib(this);
};
_._b = function Xib(a) {
    return Lib(this, a);
};
_.uc = function Yib(a) {
    return Mib(this, a, this.i) || Mib(this, a, this.f);
};
_.vc = function Zib() {
    return new djb(this);
};
_.xc = function $ib(a) {
    return Nib(this, a);
};
_.yc = function _ib(a, b) {
    return Qib(this, a, b);
};
_.Ac = function ajb(a) {
    return Sib(this, a);
};
_.gc = function bjb() {
    return Uib(this);
};
_.g = 0;
var pJ = jeb(Xqe, 'AbstractHashMap', 482);
Ycb(302, $qe, _qe, djb);
_.$b = function ejb() {
    this.a.$b();
};
_.Gc = function fjb(a) {
    return cjb(this, a);
};
_.Jc = function gjb() {
    return new mjb(this.a);
};
_.Kc = function hjb(a) {
    var b;
    if (cjb(this, a)) {
        b = JD(a, 43).jd();
        this.a.Ac(b);
        return true;
    }
    return false;
};
_.gc = function ijb() {
    return this.a.gc();
};
var oJ = jeb(Xqe, 'AbstractHashMap/EntrySet', 302);
Ycb(303, 1, Wqe, mjb);
_.Nb = function njb(a) {
    Osb(this, a);
};
_.Pb = function pjb() {
    return kjb(this);
};
_.Ob = function ojb() {
    return this.b;
};
_.Qb = function qjb() {
    ljb(this);
};
_.b = false;
_.d = 0;
var nJ = jeb(Xqe, 'AbstractHashMap/EntrySetIterator', 303);
Ycb(414, 1, Wqe, ujb);
_.Nb = function vjb(a) {
    Osb(this, a);
};
_.Ob = function wjb() {
    return rjb(this);
};
_.Pb = function xjb() {
    return sjb(this);
};
_.Qb = function yjb() {
    tjb(this);
};
_.b = 0;
_.c = -1;
var qJ = jeb(Xqe, 'AbstractList/IteratorImpl', 414);
Ycb(95, 414, dre, Ajb);
_.Qb = function Gjb() {
    tjb(this);
};
_.Rb = function Bjb(a) {
    zjb(this, a);
};
_.Sb = function Cjb() {
    return this.b > 0;
};
_.Tb = function Djb() {
    return this.b;
};
_.Ub = function Ejb() {
    return rDb(this.b > 0), this.a.Xb(this.c = --this.b);
};
_.Vb = function Fjb() {
    return this.b - 1;
};
_.Wb = function Hjb(a) {
    xDb(this.c != -1);
    this.a.fd(this.c, a);
};
var rJ = jeb(Xqe, 'AbstractList/ListIteratorImpl', 95);
Ycb(256, 55, Fre, Ijb);
_._c = function Jjb(a, b) {
    vDb(a, this.b);
    this.c._c(this.a + a, b);
    ++this.b;
};
_.Xb = function Kjb(a) {
    sDb(a, this.b);
    return this.c.Xb(this.a + a);
};
_.ed = function Ljb(a) {
    var b;
    sDb(a, this.b);
    b = this.c.ed(this.a + a);
    --this.b;
    return b;
};
_.fd = function Mjb(a, b) {
    sDb(a, this.b);
    return this.c.fd(this.a + a, b);
};
_.gc = function Njb() {
    return this.b;
};
_.a = 0;
_.b = 0;
var sJ = jeb(Xqe, 'AbstractList/SubList', 256);
Ycb(257, $qe, _qe, Ojb);
_.$b = function Pjb() {
    this.a.$b();
};
_.Gc = function Qjb(a) {
    return this.a._b(a);
};
_.Jc = function Rjb() {
    var a;
    return a = this.a.vc().Jc(), new Ujb(a);
};
_.Kc = function Sjb(a) {
    if (this.a._b(a)) {
        this.a.Ac(a);
        return true;
    }
    return false;
};
_.gc = function Tjb() {
    return this.a.gc();
};
var vJ = jeb(Xqe, 'AbstractMap/1', 257);
Ycb(526, 1, Wqe, Ujb);
_.Nb = function Vjb(a) {
    Osb(this, a);
};
_.Ob = function Wjb() {
    return this.a.Ob();
};
_.Pb = function Xjb() {
    var a;
    return a = JD(this.a.Pb(), 43), a.jd();
};
_.Qb = function Yjb() {
    this.a.Qb();
};
var uJ = jeb(Xqe, 'AbstractMap/1/1', 526);
Ycb(230, 31, Zqe, Zjb);
_.$b = function $jb() {
    this.a.$b();
};
_.Gc = function _jb(a) {
    return this.a.uc(a);
};
_.Jc = function akb() {
    var a;
    return a = this.a.vc().Jc(), new ckb(a);
};
_.gc = function bkb() {
    return this.a.gc();
};
var xJ = jeb(Xqe, 'AbstractMap/2', 230);
Ycb(300, 1, Wqe, ckb);
_.Nb = function dkb(a) {
    Osb(this, a);
};
_.Ob = function ekb() {
    return this.a.Ob();
};
_.Pb = function fkb() {
    var a;
    return a = JD(this.a.Pb(), 43), a.kd();
};
_.Qb = function gkb() {
    this.a.Qb();
};
var wJ = jeb(Xqe, 'AbstractMap/2/1', 300);
Ycb(478, 1, {
    478: 1,
    43: 1
});
_.Fb = function ikb(a) {
    var b;
    if (!RD(a, 43)) return false;
    b = JD(a, 43);
    return tub(this.d, b.jd()) && tub(this.e, b.kd());
};
_.jd = function jkb() {
    return this.d;
};
_.kd = function kkb() {
    return this.e;
};
_.Hb = function lkb() {
    return uub(this.d) ^ uub(this.e);
};
_.ld = function mkb(a) {
    return hkb(this, a);
};
_.Ib = function nkb() {
    return this.d + '=' + this.e;
};
var yJ = jeb(Xqe, 'AbstractMap/AbstractEntry', 478);
Ycb(388, 478, {
    478: 1,
    388: 1,
    43: 1
}, okb);
var zJ = jeb(Xqe, 'AbstractMap/SimpleEntry', 388);
Ycb(2028, 1, Wse);
_.Fb = function pkb(a) {
    var b;
    if (!RD(a, 43)) return false;
    b = JD(a, 43);
    return tub(this.jd(), b.jd()) && tub(this.kd(), b.kd());
};
_.Hb = function qkb() {
    return uub(this.jd()) ^ uub(this.kd());
};
_.Ib = function rkb() {
    return this.jd() + '=' + this.kd();
};
var AJ = jeb(Xqe, fre, 2028);
Ycb(2036, 2011, are);
_.Vc = function ukb(a) {
    return Vd(this.Ce(a));
};
_.tc = function vkb(a) {
    return skb(this, a);
};
_._b = function wkb(a) {
    return tkb(this, a);
};
_.vc = function xkb() {
    return new Gkb(this);
};
_.Rc = function ykb() {
    return Bkb(this.Ee());
};
_.Wc = function zkb(a) {
    return Vd(this.Fe(a));
};
_.xc = function Akb(a) {
    var b;
    b = a;
    return Wd(this.De(b));
};
_.Yc = function Ckb(a) {
    return Vd(this.Ge(a));
};
_.ec = function Dkb() {
    return new Lkb(this);
};
_.Tc = function Ekb() {
    return Bkb(this.He());
};
_.Zc = function Fkb(a) {
    return Vd(this.Ie(a));
};
var FJ = jeb(Xqe, 'AbstractNavigableMap', 2036);
Ycb(614, $qe, _qe, Gkb);
_.Gc = function Hkb(a) {
    return RD(a, 43) && skb(this.b, JD(a, 43));
};
_.Jc = function Ikb() {
    return this.b.Be();
};
_.Kc = function Jkb(a) {
    var b;
    if (RD(a, 43)) {
        b = JD(a, 43);
        return this.b.Je(b);
    }
    return false;
};
_.gc = function Kkb() {
    return this.b.gc();
};
var CJ = jeb(Xqe, 'AbstractNavigableMap/EntrySet', 614);
Ycb(1110, $qe, cre, Lkb);
_.Lc = function Rkb() {
    return new Ovb(this);
};
_.$b = function Mkb() {
    this.a.$b();
};
_.Gc = function Nkb(a) {
    return tkb(this.a, a);
};
_.Jc = function Okb() {
    var a;
    a = this.a.vc().b.Be();
    return new Skb(a);
};
_.Kc = function Pkb(a) {
    if (tkb(this.a, a)) {
        this.a.Ac(a);
        return true;
    }
    return false;
};
_.gc = function Qkb() {
    return this.a.gc();
};
var EJ = jeb(Xqe, 'AbstractNavigableMap/NavigableKeySet', 1110);
Ycb(1111, 1, Wqe, Skb);
_.Nb = function Tkb(a) {
    Osb(this, a);
};
_.Ob = function Ukb() {
    return rjb(this.a.a);
};
_.Pb = function Vkb() {
    var a;
    a = jyb(this.a);
    return a.jd();
};
_.Qb = function Wkb() {
    kyb(this.a);
};
var DJ = jeb(Xqe, 'AbstractNavigableMap/NavigableKeySet/1', 1111);
Ycb(2049, 31, Zqe);
_.Ec = function Xkb(a) {
    return yDb(_ub(this, a), Xse), true;
};
_.Fc = function Ykb(a) {
    tDb(a);
    lDb(a != this, "Can't add a queue to itself");
    return xe(this, a);
};
_.$b = function Zkb() {
    while(avb(this) != null);
};
var GJ = jeb(Xqe, 'AbstractQueue', 2049);
Ycb(311, 31, {
    4: 1,
    20: 1,
    31: 1,
    16: 1
}, nlb, olb);
_.Ec = function plb(a) {
    return _kb(this, a), true;
};
_.$b = function rlb() {
    alb(this);
};
_.Gc = function slb(a) {
    return blb(new Blb(this), a);
};
_.dc = function tlb() {
    return elb(this);
};
_.Jc = function ulb() {
    return new Blb(this);
};
_.Kc = function vlb(a) {
    return hlb(new Blb(this), a);
};
_.gc = function wlb() {
    return this.c - this.b & this.a.length - 1;
};
_.Lc = function xlb() {
    return new Gvb(this, 272);
};
_.Oc = function ylb(a) {
    var b;
    b = this.c - this.b & this.a.length - 1;
    a.length < b && (a = bDb(new Array(b), a));
    clb(this, a, b);
    a.length > b && VC(a, b, null);
    return a;
};
_.b = 0;
_.c = 0;
var KJ = jeb(Xqe, 'ArrayDeque', 311);
Ycb(445, 1, Wqe, Blb);
_.Nb = function Clb(a) {
    Osb(this, a);
};
_.Ob = function Dlb() {
    return this.a != this.b;
};
_.Pb = function Elb() {
    return zlb(this);
};
_.Qb = function Flb() {
    Alb(this);
};
_.a = 0;
_.b = 0;
_.c = -1;
var JJ = jeb(Xqe, 'ArrayDeque/IteratorImpl', 445);
Ycb(13, 55, Yse, Ulb, Vlb, Wlb);
_._c = function Xlb(a, b) {
    Hlb(this, a, b);
};
_.Ec = function Ylb(a) {
    return Ilb(this, a);
};
_.ad = function Zlb(a, b) {
    return Jlb(this, a, b);
};
_.Fc = function $lb(a) {
    return Klb(this, a);
};
_.$b = function _lb() {
    _Cb(this.c, 0);
};
_.Gc = function amb(a) {
    return Nlb(this, a, 0) != -1;
};
_.Ic = function bmb(a) {
    Llb(this, a);
};
_.Xb = function cmb(a) {
    return Mlb(this, a);
};
_.bd = function dmb(a) {
    return Nlb(this, a, 0);
};
_.dc = function emb() {
    return this.c.length == 0;
};
_.Jc = function fmb() {
    return new rmb(this);
};
_.ed = function gmb(a) {
    return Olb(this, a);
};
_.Kc = function hmb(a) {
    return Plb(this, a);
};
_.ae = function imb(a, b) {
    Qlb(this, a, b);
};
_.fd = function jmb(a, b) {
    return Rlb(this, a, b);
};
_.gc = function kmb() {
    return this.c.length;
};
_.gd = function lmb(a) {
    Slb(this, a);
};
_.Nc = function mmb() {
    return TCb(this.c);
};
_.Oc = function nmb(a) {
    return Tlb(this, a);
};
var MJ = jeb(Xqe, 'ArrayList', 13);
Ycb(7, 1, Wqe, rmb);
_.Nb = function smb(a) {
    Osb(this, a);
};
_.Ob = function tmb() {
    return omb(this);
};
_.Pb = function umb() {
    return pmb(this);
};
_.Qb = function vmb() {
    qmb(this);
};
_.a = 0;
_.b = -1;
var LJ = jeb(Xqe, 'ArrayList/1', 7);
Ycb(2058, $wnd.Function, {}, _mb);
_.Ke = function anb(a, b) {
    return Heb(a, b);
};
Ycb(129, 55, Zse, dnb);
_.Gc = function enb(a) {
    return Ot(this, a) != -1;
};
_.Ic = function fnb(a) {
    var b, c, d, e;
    tDb(a);
    for(c = this.a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        a.Ad(b);
    }
};
_.Xb = function gnb(a) {
    return bnb(this, a);
};
_.fd = function hnb(a, b) {
    var c;
    c = (sDb(a, this.a.length), this.a[a]);
    VC(this.a, a, b);
    return c;
};
_.gc = function inb() {
    return this.a.length;
};
_.gd = function jnb(a) {
    Pmb(this.a, this.a.length, a);
};
_.Nc = function knb() {
    return cnb(this, SC(aJ, Nqe, 1, this.a.length, 5, 1));
};
_.Oc = function lnb(a) {
    return cnb(this, a);
};
var NJ = jeb(Xqe, 'Arrays/ArrayList', 129);
var mnb, nnb, onb;
Ycb(931, 55, Zse, Anb);
_.Gc = function Bnb(a) {
    return false;
};
_.Xb = function Cnb(a) {
    return znb(a);
};
_.Jc = function Dnb() {
    return pnb(), Hnb(), Gnb;
};
_.cd = function Enb() {
    return pnb(), Hnb(), Gnb;
};
_.gc = function Fnb() {
    return 0;
};
var PJ = jeb(Xqe, 'Collections/EmptyList', 931);
Ycb(932, 1, dre, Inb);
_.Nb = function Knb(a) {
    Osb(this, a);
};
_.Rb = function Jnb(a) {
    throw scb(new ahb);
};
_.Ob = function Lnb() {
    return false;
};
_.Sb = function Mnb() {
    return false;
};
_.Pb = function Nnb() {
    throw scb(new qub);
};
_.Tb = function Onb() {
    return 0;
};
_.Ub = function Pnb() {
    throw scb(new qub);
};
_.Vb = function Qnb() {
    return -1;
};
_.Qb = function Rnb() {
    throw scb(new Veb);
};
_.Wb = function Snb(a) {
    throw scb(new Veb);
};
var Gnb;
var OJ = jeb(Xqe, 'Collections/EmptyListIterator', 932);
Ycb(934, 2011, ure, Tnb);
_._b = function Unb(a) {
    return false;
};
_.uc = function Vnb(a) {
    return false;
};
_.vc = function Wnb() {
    return pnb(), onb;
};
_.xc = function Xnb(a) {
    return null;
};
_.ec = function Ynb() {
    return pnb(), onb;
};
_.gc = function Znb() {
    return 0;
};
_.Bc = function $nb() {
    return pnb(), mnb;
};
var QJ = jeb(Xqe, 'Collections/EmptyMap', 934);
Ycb(933, $qe, wre, _nb);
_.Gc = function aob(a) {
    return false;
};
_.Jc = function bob() {
    return pnb(), Hnb(), Gnb;
};
_.gc = function cob() {
    return 0;
};
var RJ = jeb(Xqe, 'Collections/EmptySet', 933);
Ycb(592, 55, {
    3: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1
}, dob);
_.Gc = function eob(a) {
    return tub(this.a, a);
};
_.Xb = function fob(a) {
    sDb(a, 1);
    return this.a;
};
_.gc = function gob() {
    return 1;
};
var SJ = jeb(Xqe, 'Collections/SingletonList', 592);
Ycb(376, 1, qre, oob);
_.Ic = function uob(a) {
    ofb(this, a);
};
_.Lc = function zob() {
    return new Gvb(this, 0);
};
_.Mc = function Aob() {
    return new RBb(null, this.Lc());
};
_.Ec = function pob(a) {
    return hob();
};
_.Fc = function qob(a) {
    return iob();
};
_.$b = function rob() {
    job();
};
_.Gc = function sob(a) {
    return kob(this, a);
};
_.Hc = function tob(a) {
    return lob(this, a);
};
_.dc = function vob() {
    return this.b.dc();
};
_.Jc = function wob() {
    return new Fob(this.b.Jc());
};
_.Kc = function xob(a) {
    return mob();
};
_.gc = function yob() {
    return this.b.gc();
};
_.Nc = function Bob() {
    return this.b.Nc();
};
_.Oc = function Cob(a) {
    return nob(this, a);
};
_.Ib = function Dob() {
    return adb(this.b);
};
var UJ = jeb(Xqe, 'Collections/UnmodifiableCollection', 376);
Ycb(375, 1, Wqe, Fob);
_.Nb = function Gob(a) {
    Osb(this, a);
};
_.Ob = function Hob() {
    return this.b.Ob();
};
_.Pb = function Iob() {
    return this.b.Pb();
};
_.Qb = function Job() {
    Eob();
};
var TJ = jeb(Xqe, 'Collections/UnmodifiableCollectionIterator', 375);
Ycb(525, 376, $se, Kob);
_.Lc = function Xob() {
    return new Gvb(this, 16);
};
_._c = function Lob(a, b) {
    throw scb(new ahb);
};
_.ad = function Mob(a, b) {
    throw scb(new ahb);
};
_.Fb = function Nob(a) {
    return pb(this.a, a);
};
_.Xb = function Oob(a) {
    return this.a.Xb(a);
};
_.Hb = function Pob() {
    return tb(this.a);
};
_.bd = function Qob(a) {
    return this.a.bd(a);
};
_.dc = function Rob() {
    return this.a.dc();
};
_.cd = function Sob() {
    return new Zob(this.a.dd(0));
};
_.dd = function Tob(a) {
    return new Zob(this.a.dd(a));
};
_.ed = function Uob(a) {
    throw scb(new ahb);
};
_.fd = function Vob(a, b) {
    throw scb(new ahb);
};
_.gd = function Wob(a) {
    throw scb(new ahb);
};
_.hd = function Yob(a, b) {
    return new Kob(this.a.hd(a, b));
};
var WJ = jeb(Xqe, 'Collections/UnmodifiableList', 525);
Ycb(689, 375, dre, Zob);
_.Qb = function dpb() {
    Eob();
};
_.Rb = function $ob(a) {
    throw scb(new ahb);
};
_.Sb = function _ob() {
    return this.a.Sb();
};
_.Tb = function apb() {
    return this.a.Tb();
};
_.Ub = function bpb() {
    return this.a.Ub();
};
_.Vb = function cpb() {
    return this.a.Vb();
};
_.Wb = function epb(a) {
    throw scb(new ahb);
};
var VJ = jeb(Xqe, 'Collections/UnmodifiableListIterator', 689);
Ycb(593, 1, Yqe, kpb);
_.wc = function qpb(a) {
    pub(this, a);
};
_.$b = function lpb() {
    throw scb(new ahb);
};
_._b = function mpb(a) {
    return this.c._b(a);
};
_.uc = function npb(a) {
    return fpb(this, a);
};
_.vc = function opb() {
    return gpb(this);
};
_.Fb = function ppb(a) {
    return hpb(this, a);
};
_.xc = function rpb(a) {
    return this.c.xc(a);
};
_.Hb = function spb() {
    return tb(this.c);
};
_.dc = function tpb() {
    return this.c.dc();
};
_.ec = function upb() {
    return ipb(this);
};
_.yc = function vpb(a, b) {
    throw scb(new ahb);
};
_.Ac = function wpb(a) {
    throw scb(new ahb);
};
_.gc = function xpb() {
    return this.c.gc();
};
_.Ib = function ypb() {
    return adb(this.c);
};
_.Bc = function zpb() {
    return jpb(this);
};
var $J = jeb(Xqe, 'Collections/UnmodifiableMap', 593);
Ycb(387, 376, vre, Apb);
_.Lc = function Dpb() {
    return new Gvb(this, 1);
};
_.Fb = function Bpb(a) {
    return pb(this.b, a);
};
_.Hb = function Cpb() {
    return tb(this.b);
};
var aK = jeb(Xqe, 'Collections/UnmodifiableSet', 387);
Ycb(935, 387, vre, Hpb);
_.Gc = function Ipb(a) {
    return Epb(this, a);
};
_.Hc = function Jpb(a) {
    return this.b.Hc(a);
};
_.Jc = function Kpb() {
    var a;
    a = this.b.Jc();
    return new Npb(a);
};
_.Nc = function Lpb() {
    var a;
    a = this.b.Nc();
    Gpb(a, a.length);
    return a;
};
_.Oc = function Mpb(a) {
    return Fpb(this, a);
};
var ZJ = jeb(Xqe, 'Collections/UnmodifiableMap/UnmodifiableEntrySet', 935);
Ycb(936, 1, Wqe, Npb);
_.Nb = function Opb(a) {
    Osb(this, a);
};
_.Pb = function Qpb() {
    return new Spb(JD(this.a.Pb(), 43));
};
_.Ob = function Ppb() {
    return this.a.Ob();
};
_.Qb = function Rpb() {
    throw scb(new ahb);
};
var XJ = jeb(Xqe, 'Collections/UnmodifiableMap/UnmodifiableEntrySet/1', 936);
Ycb(687, 1, Wse, Spb);
_.Fb = function Tpb(a) {
    return this.a.Fb(a);
};
_.jd = function Upb() {
    return this.a.jd();
};
_.kd = function Vpb() {
    return this.a.kd();
};
_.Hb = function Wpb() {
    return this.a.Hb();
};
_.ld = function Xpb(a) {
    throw scb(new ahb);
};
_.Ib = function Ypb() {
    return adb(this.a);
};
var YJ = jeb(Xqe, 'Collections/UnmodifiableMap/UnmodifiableEntrySet/UnmodifiableEntry', 687);
Ycb(594, 525, {
    20: 1,
    16: 1,
    15: 1,
    59: 1
}, Zpb);
var _J = jeb(Xqe, 'Collections/UnmodifiableRandomAccessList', 594);
Ycb(688, 387, xre, $pb);
_.Lc = function bqb() {
    return new Ovb(this);
};
_.Fb = function _pb(a) {
    return pb(this.a, a);
};
_.Hb = function aqb() {
    return tb(this.a);
};
var bK = jeb(Xqe, 'Collections/UnmodifiableSortedSet', 688);
Ycb(837, 1, _se, cqb);
_.Le = function dqb(a, b) {
    var c;
    return c = M9b(JD(a, 11), JD(b, 11)), c != 0 ? c : O9b(JD(a, 11), JD(b, 11));
};
_.Fb = function eqb(a) {
    return this === a;
};
_.Me = function fqb() {
    return new uqb(this);
};
var cK = jeb(Xqe, 'Comparator/lambda$0$Type', 837);
var gqb, hqb, iqb;
Ycb(751, 1, _se, lqb);
_.Le = function mqb(a, b) {
    return kqb(JD(a, 34), JD(b, 34));
};
_.Fb = function nqb(a) {
    return this === a;
};
_.Me = function oqb() {
    return jqb(), iqb;
};
var dK = jeb(Xqe, 'Comparators/NaturalOrderComparator', 751);
Ycb(1186, 1, _se, qqb);
_.Le = function rqb(a, b) {
    return pqb(JD(a, 34), JD(b, 34));
};
_.Fb = function sqb(a) {
    return this === a;
};
_.Me = function tqb() {
    return jqb(), hqb;
};
var eK = jeb(Xqe, 'Comparators/ReverseNaturalOrderComparator', 1186);
Ycb(56, 1, _se, uqb);
_.Fb = function wqb(a) {
    return this === a;
};
_.Le = function vqb(a, b) {
    return this.a.Le(b, a);
};
_.Me = function xqb() {
    return this.a;
};
var fK = jeb(Xqe, 'Comparators/ReversedComparator', 56);
Ycb(175, 63, Nre, yqb);
var gK = jeb(Xqe, 'ConcurrentModificationException', 175);
var zqb, Aqb;
Ycb(1894, 1, ate, Eqb);
_.Ne = function Fqb(a) {
    Cqb(this, a);
};
_.Ib = function Gqb() {
    return 'DoubleSummaryStatistics[count = ' + Qcb(this.a) + ', avg = ' + (Acb(this.a, 0) ? Dqb(this) / Ocb(this.a) : 0) + ', min = ' + this.c + ', max = ' + this.b + ', sum = ' + Dqb(this) + ']';
};
_.a = 0;
_.b = Lse;
_.c = Kse;
_.d = 0;
_.e = 0;
_.f = 0;
var iK = jeb(Xqe, 'DoubleSummaryStatistics', 1894);
Ycb(1814, 63, Nre, Hqb);
var jK = jeb(Xqe, 'EmptyStackException', 1814);
Ycb(447, 2011, Yqe, Oqb);
_.yc = function Uqb(a, b) {
    return Mqb(this, a, b);
};
_.$b = function Pqb() {
    Iqb(this);
};
_._b = function Qqb(a) {
    return Jqb(this, a);
};
_.uc = function Rqb(a) {
    var b, c;
    for(c = new Drb(this.a); c.a < c.c.a.length;){
        b = Crb(c);
        if (tub(a, this.b[b.g])) return true;
    }
    return false;
};
_.vc = function Sqb() {
    return new Yqb(this);
};
_.xc = function Tqb(a) {
    return Kqb(this, a);
};
_.Ac = function Vqb(a) {
    return Nqb(this, a);
};
_.gc = function Wqb() {
    return this.a.c;
};
var nK = jeb(Xqe, 'EnumMap', 447);
Ycb(1281, $qe, _qe, Yqb);
_.$b = function Zqb() {
    Iqb(this.a);
};
_.Gc = function $qb(a) {
    return Xqb(this, a);
};
_.Jc = function _qb() {
    return new crb(this.a);
};
_.Kc = function arb(a) {
    var b;
    if (Xqb(this, a)) {
        b = JD(a, 43).jd();
        Nqb(this.a, b);
        return true;
    }
    return false;
};
_.gc = function brb() {
    return this.a.a.c;
};
var lK = jeb(Xqe, 'EnumMap/EntrySet', 1281);
Ycb(1282, 1, Wqe, crb);
_.Nb = function drb(a) {
    Osb(this, a);
};
_.Pb = function frb() {
    return this.b = Crb(this.a), new hrb(this.c, this.b);
};
_.Ob = function erb() {
    return Brb(this.a);
};
_.Qb = function grb() {
    xDb(!!this.b);
    Nqb(this.c, this.b);
    this.b = null;
};
var kK = jeb(Xqe, 'EnumMap/EntrySetIterator', 1282);
Ycb(1283, 2028, Wse, hrb);
_.jd = function irb() {
    return this.a;
};
_.kd = function jrb() {
    return this.b.b[this.a.g];
};
_.ld = function krb(a) {
    return $Cb(this.b.b, this.a.g, a);
};
var mK = jeb(Xqe, 'EnumMap/MapEntry', 1283);
Ycb(181, $qe, {
    20: 1,
    31: 1,
    16: 1,
    181: 1,
    22: 1
});
var qK = jeb(Xqe, 'EnumSet', 181);
Ycb(161, 181, {
    20: 1,
    31: 1,
    16: 1,
    181: 1,
    161: 1,
    22: 1
}, urb);
_.Ec = function vrb(a) {
    return orb(this, JD(a, 23));
};
_.Gc = function wrb(a) {
    return qrb(this, a);
};
_.Jc = function xrb() {
    return new Drb(this);
};
_.Kc = function yrb(a) {
    return srb(this, a);
};
_.gc = function zrb() {
    return this.c;
};
_.c = 0;
var pK = jeb(Xqe, 'EnumSet/EnumSetImpl', 161);
Ycb(353, 1, Wqe, Drb);
_.Nb = function Erb(a) {
    Osb(this, a);
};
_.Pb = function Grb() {
    return Crb(this);
};
_.Ob = function Frb() {
    return Brb(this);
};
_.Qb = function Hrb() {
    xDb(this.b != -1);
    VC(this.c.b, this.b, null);
    --this.c.c;
    this.b = -1;
};
_.a = -1;
_.b = -1;
var oK = jeb(Xqe, 'EnumSet/EnumSetImpl/IteratorImpl', 353);
Ycb(45, 482, bte, Irb, Jrb, Krb);
_.ze = function Lrb(a, b) {
    return XD(a) === XD(b) || a != null && pb(a, b);
};
_.Ae = function Mrb(a) {
    var b;
    if (a == null) return 0;
    b = tb(a);
    return b | 0;
};
var rK = jeb(Xqe, 'HashMap', 45);
Ycb(50, $qe, cte, Qrb, Rrb, Srb);
_.Ec = function Urb(a) {
    return Nrb(this, a);
};
_.$b = function Vrb() {
    this.a.$b();
};
_.Gc = function Wrb(a) {
    return Orb(this, a);
};
_.dc = function Xrb() {
    return this.a.gc() == 0;
};
_.Jc = function Yrb() {
    return this.a.ec().Jc();
};
_.Kc = function Zrb(a) {
    return Prb(this, a);
};
_.gc = function $rb() {
    return this.a.gc();
};
var sK = jeb(Xqe, 'HashSet', 50);
Ycb(1843, 1, lre, asb);
_.Bd = function bsb(a) {
    _rb(this, a);
};
_.Ib = function csb() {
    return 'IntSummaryStatistics[count = ' + Qcb(this.a) + ', avg = ' + (Acb(this.a, 0) ? Ocb(this.d) / Ocb(this.a) : 0) + ', min = ' + this.c + ', max = ' + this.b + ', sum = ' + Qcb(this.d) + ']';
};
_.a = 0;
_.b = Lre;
_.c = Hqe;
_.d = 0;
var tK = jeb(Xqe, 'IntSummaryStatistics', 1843);
Ycb(1037, 1, pre, isb);
_.Ic = function jsb(a) {
    ofb(this, a);
};
_.Jc = function ksb() {
    return new lsb(this);
};
_.c = 0;
var vK = jeb(Xqe, 'InternalHashCodeMap', 1037);
Ycb(710, 1, Wqe, lsb);
_.Nb = function msb(a) {
    Osb(this, a);
};
_.Pb = function osb() {
    return this.d = this.a[this.c++], this.d;
};
_.Ob = function nsb() {
    var a;
    if (this.c < this.a.length) return true;
    a = this.b.next();
    if (!a.done) {
        this.a = a.value[1];
        this.c = 0;
        return true;
    }
    return false;
};
_.Qb = function psb() {
    hsb(this.e, this.d.jd());
    this.c != 0 && --this.c;
};
_.c = 0;
_.d = null;
var uK = jeb(Xqe, 'InternalHashCodeMap/1', 710);
var ssb;
Ycb(1035, 1, pre, Csb);
_.Ic = function Dsb(a) {
    ofb(this, a);
};
_.Jc = function Esb() {
    return new Fsb(this);
};
_.c = 0;
_.d = 0;
var yK = jeb(Xqe, 'InternalStringMap', 1035);
Ycb(709, 1, Wqe, Fsb);
_.Nb = function Gsb(a) {
    Osb(this, a);
};
_.Pb = function Isb() {
    return this.c = this.a, this.a = this.b.next(), new Ksb(this.d, this.c, this.d.d);
};
_.Ob = function Hsb() {
    return !this.a.done;
};
_.Qb = function Jsb() {
    Bsb(this.d, this.c.value[0]);
};
var wK = jeb(Xqe, 'InternalStringMap/1', 709);
Ycb(1036, 2028, Wse, Ksb);
_.jd = function Lsb() {
    return this.b.value[0];
};
_.kd = function Msb() {
    if (this.a.d != this.c) return zsb(this.a, this.b.value[0]);
    return this.b.value[1];
};
_.ld = function Nsb(a) {
    return Asb(this.a, this.b.value[0], a);
};
_.c = 0;
var xK = jeb(Xqe, 'InternalStringMap/2', 1036);
Ycb(221, 45, bte, Xsb, Ysb);
_.$b = function Zsb() {
    Rsb(this);
};
_._b = function $sb(a) {
    return Ssb(this, a);
};
_.uc = function _sb(a) {
    var b;
    b = this.d.a;
    while(b != this.d){
        if (tub(b.e, a)) return true;
        b = b.a;
    }
    return false;
};
_.vc = function atb() {
    return new ktb(this);
};
_.xc = function btb(a) {
    return Tsb(this, a);
};
_.yc = function ctb(a, b) {
    return Usb(this, a, b);
};
_.Ac = function dtb(a) {
    return Wsb(this, a);
};
_.gc = function etb() {
    return Uib(this.e);
};
_.c = false;
var CK = jeb(Xqe, 'LinkedHashMap', 221);
Ycb(391, 388, {
    478: 1,
    388: 1,
    391: 1,
    43: 1
}, htb, itb);
var zK = jeb(Xqe, 'LinkedHashMap/ChainEntry', 391);
Ycb(699, $qe, _qe, ktb);
_.$b = function ltb() {
    Rsb(this.a);
};
_.Gc = function mtb(a) {
    return jtb(this, a);
};
_.Jc = function ntb() {
    return new rtb(this);
};
_.Kc = function otb(a) {
    var b;
    if (jtb(this, a)) {
        b = JD(a, 43).jd();
        Wsb(this.a, b);
        return true;
    }
    return false;
};
_.gc = function ptb() {
    return Uib(this.a.e);
};
var BK = jeb(Xqe, 'LinkedHashMap/EntrySet', 699);
Ycb(700, 1, Wqe, rtb);
_.Nb = function stb(a) {
    Osb(this, a);
};
_.Pb = function utb() {
    return qtb(this);
};
_.Ob = function ttb() {
    return this.c != this.d.a.d;
};
_.Qb = function vtb() {
    xDb(!!this.a);
    qDb(this.d.a.e.g, this.b);
    gtb(this.a);
    Sib(this.d.a.e, this.a.d);
    this.b = this.d.a.e.g;
    this.a = null;
};
_.b = 0;
var AK = jeb(Xqe, 'LinkedHashMap/EntrySet/EntryIterator', 700);
Ycb(180, 50, cte, wtb, xtb, ytb);
var DK = jeb(Xqe, 'LinkedHashSet', 180);
Ycb(67, 2008, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    67: 1,
    15: 1
}, Mtb, Ntb);
_.Ec = function Otb(a) {
    return Atb(this, a);
};
_.$b = function Ptb() {
    Ltb(this);
};
_.dd = function Qtb(a) {
    return Gtb(this, a);
};
_.gc = function Rtb() {
    return this.b;
};
_.b = 0;
var GK = jeb(Xqe, 'LinkedList', 67);
Ycb(958, 1, dre, Xtb);
_.Nb = function Ztb(a) {
    Osb(this, a);
};
_.Rb = function Ytb(a) {
    Stb(this, a);
};
_.Ob = function $tb() {
    return Ttb(this);
};
_.Sb = function _tb() {
    return this.b.b != this.d.a;
};
_.Pb = function aub() {
    return Utb(this);
};
_.Tb = function bub() {
    return this.a;
};
_.Ub = function cub() {
    return Vtb(this);
};
_.Vb = function dub() {
    return this.a - 1;
};
_.Qb = function eub() {
    Wtb(this);
};
_.Wb = function fub(a) {
    xDb(!!this.c);
    this.c.c = a;
};
_.a = 0;
_.c = null;
var EK = jeb(Xqe, 'LinkedList/ListIteratorImpl', 958);
Ycb(602, 1, {}, gub);
var FK = jeb(Xqe, 'LinkedList/Node', 602);
Ycb(2003, 1, {});
var iub, jub;
var KK = jeb(Xqe, 'Locale', 2003);
Ycb(849, 2003, {}, lub);
_.Ib = function mub() {
    return '';
};
var IK = jeb(Xqe, 'Locale/1', 849);
Ycb(850, 2003, {}, nub);
_.Ib = function oub() {
    return 'unknown';
};
var JK = jeb(Xqe, 'Locale/4', 850);
Ycb(111, 63, {
    3: 1,
    103: 1,
    63: 1,
    80: 1,
    111: 1
}, qub, rub);
var NK = jeb(Xqe, 'NoSuchElementException', 111);
Ycb(461, 1, {
    461: 1
}, Cub);
_.Fb = function Dub(a) {
    var b;
    if (a === this) return true;
    if (!RD(a, 461)) return false;
    b = JD(a, 461);
    return tub(this.a, b.a);
};
_.Hb = function Eub() {
    return uub(this.a);
};
_.Ib = function Fub() {
    return this.a != null ? Qqe + xgb(this.a) + ')' : 'Optional.empty()';
};
var xub;
var QK = jeb(Xqe, 'Optional', 461);
Ycb(403, 1, {
    403: 1
}, Lub, Mub);
_.Fb = function Nub(a) {
    var b;
    if (a === this) return true;
    if (!RD(a, 403)) return false;
    b = JD(a, 403);
    return this.a == b.a && Heb(this.b, b.b) == 0;
};
_.Hb = function Oub() {
    return this.a ? YD(this.b) : 0;
};
_.Ib = function Pub() {
    return this.a ? 'OptionalDouble.of(' + ('' + this.b) + ')' : 'OptionalDouble.empty()';
};
_.a = false;
_.b = 0;
var Gub;
var OK = jeb(Xqe, 'OptionalDouble', 403);
Ycb(508, 1, {
    508: 1
}, Tub, Uub);
_.Fb = function Vub(a) {
    var b;
    if (a === this) return true;
    if (!RD(a, 508)) return false;
    b = JD(a, 508);
    return this.a == b.a && $eb(this.b, b.b) == 0;
};
_.Hb = function Wub() {
    return this.a ? this.b : 0;
};
_.Ib = function Xub() {
    return this.a ? 'OptionalInt.of(' + ('' + this.b) + ')' : 'OptionalInt.empty()';
};
_.a = false;
_.b = 0;
var Qub;
var PK = jeb(Xqe, 'OptionalInt', 508);
Ycb(494, 2049, Zqe, dvb);
_.Fc = function evb(a) {
    return Yub(this, a);
};
_.$b = function fvb() {
    _Cb(this.b.c, 0);
};
_.Gc = function gvb(a) {
    return (a == null ? -1 : Nlb(this.b, a, 0)) != -1;
};
_.Jc = function hvb() {
    return new nvb(this);
};
_.Kc = function ivb(a) {
    return bvb(this, a);
};
_.gc = function jvb() {
    return this.b.c.length;
};
_.Lc = function kvb() {
    return new Gvb(this, 256);
};
_.Nc = function lvb() {
    return TCb(this.b.c);
};
_.Oc = function mvb(a) {
    return Tlb(this.b, a);
};
var SK = jeb(Xqe, 'PriorityQueue', 494);
Ycb(1249, 1, Wqe, nvb);
_.Nb = function ovb(a) {
    Osb(this, a);
};
_.Ob = function pvb() {
    return this.a < this.c.b.c.length;
};
_.Pb = function qvb() {
    rDb(this.a < this.c.b.c.length);
    this.b = this.a++;
    return Mlb(this.c.b, this.b);
};
_.Qb = function rvb() {
    xDb(this.b != -1);
    cvb(this.c, this.a = this.b);
    this.b = -1;
};
_.a = 0;
_.b = -1;
var RK = jeb(Xqe, 'PriorityQueue/1', 1249);
Ycb(233, 1, {
    233: 1
}, Cvb, Dvb);
_.a = 0;
_.b = 0;
var svb, tvb, uvb = 0;
var TK = jeb(Xqe, 'Random', 233);
Ycb(26, 1, jre, Gvb, Hvb, Ivb);
_.yd = function Mvb(a) {
    return (this.a & a) != 0;
};
_.wd = function Jvb() {
    return this.a;
};
_.xd = function Kvb() {
    Evb(this);
    return this.c;
};
_.Nb = function Lvb(a) {
    Evb(this);
    this.d.Nb(a);
};
_.zd = function Nvb(a) {
    return Fvb(this, a);
};
_.a = 0;
_.c = 0;
var hL = jeb(Xqe, 'Spliterators/IteratorSpliterator', 26);
Ycb(479, 26, jre, Ovb);
var VK = jeb(Xqe, 'SortedSet/1', 479);
Ycb(595, 1, ate, Qvb);
_.Ne = function Rvb(a) {
    this.a.Ad(a);
};
var WK = jeb(Xqe, 'Spliterator/OfDouble/0methodref$accept$Type', 595);
Ycb(596, 1, ate, Svb);
_.Ne = function Tvb(a) {
    this.a.Ad(a);
};
var XK = jeb(Xqe, 'Spliterator/OfDouble/1methodref$accept$Type', 596);
Ycb(597, 1, lre, Uvb);
_.Bd = function Vvb(a) {
    this.a.Ad(jfb(a));
};
var YK = jeb(Xqe, 'Spliterator/OfInt/2methodref$accept$Type', 597);
Ycb(598, 1, lre, Wvb);
_.Bd = function Xvb(a) {
    this.a.Ad(jfb(a));
};
var ZK = jeb(Xqe, 'Spliterator/OfInt/3methodref$accept$Type', 598);
Ycb(610, 1, jre);
_.Nb = function bwb(a) {
    Pvb(this, a);
};
_.yd = function cwb(a) {
    return (this.d & a) != 0;
};
_.wd = function _vb() {
    return this.d;
};
_.xd = function awb() {
    return this.e;
};
_.d = 0;
_.e = 0;
var dL = jeb(Xqe, 'Spliterators/BaseSpliterator', 610);
Ycb(719, 610, jre);
_.Oe = function ewb(a) {
    Yvb(this, a);
};
_.Nb = function fwb(a) {
    RD(a, 189) ? Yvb(this, JD(a, 189)) : Yvb(this, new Svb(a));
};
_.zd = function gwb(a) {
    return RD(a, 189) ? this.Pe(JD(a, 189)) : this.Pe(new Qvb(a));
};
var $K = jeb(Xqe, 'Spliterators/AbstractDoubleSpliterator', 719);
Ycb(718, 610, jre);
_.Oe = function iwb(a) {
    Yvb(this, a);
};
_.Nb = function jwb(a) {
    RD(a, 202) ? Yvb(this, JD(a, 202)) : Yvb(this, new Wvb(a));
};
_.zd = function kwb(a) {
    return RD(a, 202) ? this.Pe(JD(a, 202)) : this.Pe(new Uvb(a));
};
var _K = jeb(Xqe, 'Spliterators/AbstractIntSpliterator', 718);
Ycb(484, 610, jre);
var aL = jeb(Xqe, 'Spliterators/AbstractSpliterator', 484);
Ycb(690, 1, jre);
_.Nb = function rwb(a) {
    Pvb(this, a);
};
_.yd = function swb(a) {
    return (this.b & a) != 0;
};
_.wd = function pwb() {
    return this.b;
};
_.xd = function qwb() {
    return this.d - this.c;
};
_.b = 0;
_.c = 0;
_.d = 0;
var cL = jeb(Xqe, 'Spliterators/BaseArraySpliterator', 690);
Ycb(938, 690, jre, uwb);
_.Qe = function vwb(a, b) {
    twb(this, JD(a, 40), b);
};
_.Nb = function wwb(a) {
    mwb(this, a);
};
_.zd = function xwb(a) {
    return nwb(this, a);
};
var bL = jeb(Xqe, 'Spliterators/ArraySpliterator', 938);
Ycb(691, 690, jre, zwb);
_.Qe = function Bwb(a, b) {
    ywb(this, JD(a, 189), b);
};
_.Oe = function Cwb(a) {
    mwb(this, a);
};
_.Nb = function Dwb(a) {
    RD(a, 189) ? mwb(this, JD(a, 189)) : mwb(this, new Svb(a));
};
_.Pe = function Ewb(a) {
    return nwb(this, a);
};
_.zd = function Fwb(a) {
    return RD(a, 189) ? nwb(this, JD(a, 189)) : nwb(this, new Qvb(a));
};
var eL = jeb(Xqe, 'Spliterators/DoubleArraySpliterator', 691);
Ycb(2012, 1, jre);
_.Nb = function Kwb(a) {
    Pvb(this, a);
};
_.yd = function Lwb(a) {
    return (16448 & a) != 0;
};
_.wd = function Iwb() {
    return 16448;
};
_.xd = function Jwb() {
    return 0;
};
var Gwb;
var gL = jeb(Xqe, 'Spliterators/EmptySpliterator', 2012);
Ycb(937, 2012, jre, Owb);
_.Oe = function Pwb(a) {
    Mwb(a);
};
_.Nb = function Qwb(a) {
    RD(a, 202) ? Mwb(JD(a, 202)) : Mwb(new Wvb(a));
};
_.Pe = function Rwb(a) {
    return Nwb(a);
};
_.zd = function Swb(a) {
    return RD(a, 202) ? Nwb(JD(a, 202)) : Nwb(new Uvb(a));
};
var fL = jeb(Xqe, 'Spliterators/EmptySpliterator/OfInt', 937);
Ycb(571, 55, lte, Wwb);
_._c = function Xwb(a, b) {
    _wb(a, this.a.c.length + 1);
    Hlb(this.a, a, b);
};
_.Ec = function Ywb(a) {
    return Ilb(this.a, a);
};
_.ad = function Zwb(a, b) {
    _wb(a, this.a.c.length + 1);
    return Jlb(this.a, a, b);
};
_.Fc = function $wb(a) {
    return Klb(this.a, a);
};
_.$b = function axb() {
    _Cb(this.a.c, 0);
};
_.Gc = function bxb(a) {
    return Nlb(this.a, a, 0) != -1;
};
_.Hc = function cxb(a) {
    return Ae(this.a, a);
};
_.Ic = function dxb(a) {
    Llb(this.a, a);
};
_.Xb = function exb(a) {
    return _wb(a, this.a.c.length), Mlb(this.a, a);
};
_.bd = function fxb(a) {
    return Nlb(this.a, a, 0);
};
_.dc = function gxb() {
    return this.a.c.length == 0;
};
_.Jc = function hxb() {
    return new rmb(this.a);
};
_.ed = function ixb(a) {
    return _wb(a, this.a.c.length), Olb(this.a, a);
};
_.ae = function jxb(a, b) {
    Qlb(this.a, a, b);
};
_.fd = function kxb(a, b) {
    return _wb(a, this.a.c.length), Rlb(this.a, a, b);
};
_.gc = function lxb() {
    return this.a.c.length;
};
_.gd = function mxb(a) {
    Slb(this.a, a);
};
_.hd = function nxb(a, b) {
    return new Ijb(this.a, a, b);
};
_.Nc = function oxb() {
    return TCb(this.a.c);
};
_.Oc = function pxb(a) {
    return Tlb(this.a, a);
};
_.Ib = function qxb() {
    return Ee(this.a);
};
var vL = jeb(Xqe, 'Vector', 571);
Ycb(803, 571, lte, txb);
var iL = jeb(Xqe, 'Stack', 803);
Ycb(212, 1, {
    212: 1
}, xxb);
_.Ib = function yxb() {
    return wxb(this);
};
var jL = jeb(Xqe, 'StringJoiner', 212);
Ycb(538, 2036, {
    3: 1,
    91: 1,
    137: 1,
    134: 1
}, Txb, Uxb);
_.$b = function Vxb() {
    zxb(this);
};
_.Be = function Wxb() {
    return new lyb(this);
};
_.vc = function Xxb() {
    return new ryb(this);
};
_.Ce = function Yxb(a) {
    return Dxb(this, a, true);
};
_.De = function Zxb(a) {
    return Axb(this, a);
};
_.Ee = function $xb() {
    return Bxb(this);
};
_.Fe = function _xb(a) {
    return Exb(this, a, true);
};
_.Ge = function ayb(a) {
    return Dxb(this, a, false);
};
_.He = function byb() {
    return Cxb(this);
};
_.Ie = function cyb(a) {
    return Exb(this, a, false);
};
_.Xc = function dyb(a, b) {
    return Fxb(this, a, b);
};
_.yc = function eyb(a, b) {
    return Kxb(this, a, b);
};
_.Ac = function fyb(a) {
    return Lxb(this, a);
};
_.Je = function gyb(a) {
    return Mxb(this, a);
};
_.gc = function hyb() {
    return this.c;
};
_.$c = function iyb(a, b) {
    return Sxb(this, a, b);
};
_.c = 0;
var tL = jeb(Xqe, 'TreeMap', 538);
Ycb(539, 1, Wqe, lyb, myb);
_.Nb = function nyb(a) {
    Osb(this, a);
};
_.Pb = function pyb() {
    return jyb(this);
};
_.Ob = function oyb() {
    return rjb(this.a);
};
_.Qb = function qyb() {
    kyb(this);
};
var kL = jeb(Xqe, 'TreeMap/EntryIterator', 539);
Ycb(1106, 614, _qe, ryb);
_.$b = function syb() {
    zxb(this.a);
};
var lL = jeb(Xqe, 'TreeMap/EntrySet', 1106);
Ycb(435, 388, {
    478: 1,
    388: 1,
    43: 1,
    435: 1
}, tyb);
_.b = false;
var mL = jeb(Xqe, 'TreeMap/Node', 435);
Ycb(615, 1, {}, uyb);
_.Ib = function vyb() {
    return 'State: mv=' + this.c + ' value=' + this.d + ' done=' + this.a + ' found=' + this.b;
};
_.a = false;
_.b = false;
_.c = false;
var nL = jeb(Xqe, 'TreeMap/State', 615);
Ycb(616, 2036, are, yyb);
_.Be = function zyb() {
    return new myb(this.c, this.f, this.b, this.a, this.e, this.d);
};
_.vc = function Ayb() {
    return new Gkb(this);
};
_.Ce = function Byb(a) {
    return wyb(this, Dxb(this.c, a, true));
};
_.De = function Cyb(a) {
    return wyb(this, Axb(this.c, a));
};
_.Ee = function Dyb() {
    var a;
    return this.f.Re() ? this.a ? a = Dxb(this.c, this.b, true) : a = Dxb(this.c, this.b, false) : a = Bxb(this.c), !!a && xyb(this, a.d) ? a : null;
};
_.Fe = function Eyb(a) {
    return wyb(this, Exb(this.c, a, true));
};
_.Ge = function Fyb(a) {
    return wyb(this, Dxb(this.c, a, false));
};
_.He = function Gyb() {
    var a;
    this.f.Se() ? this.d ? a = Exb(this.c, this.e, true) : a = Exb(this.c, this.e, false) : a = Cxb(this.c);
    return !!a && xyb(this, a.d) ? a : null;
};
_.Ie = function Hyb(a) {
    return wyb(this, Exb(this.c, a, false));
};
_.Xc = function Iyb(a, b) {
    if (this.f.Se() && this.c.a.Le(a, this.e) > 0) throw scb(new Teb(mte + a + ' greater than ' + this.e));
    return this.f.Re() ? Rxb(this.c, this.b, this.a, a, b) : Fxb(this.c, a, b);
};
_.yc = function Jyb(a, b) {
    if (!Hxb(this.c, this.f, a, this.b, this.a, this.e, this.d)) throw scb(new Teb(a + ' outside the range ' + this.b + ' to ' + this.e));
    return Kxb(this.c, a, b);
};
_.Ac = function Kyb(a) {
    var b;
    b = a;
    if (!Hxb(this.c, this.f, b, this.b, this.a, this.e, this.d)) return null;
    return Lxb(this.c, b);
};
_.Je = function Lyb(a) {
    return xyb(this, a.jd()) && Mxb(this.c, a);
};
_.gc = function Myb() {
    var a, b, c;
    this.f.Re() ? this.a ? b = Dxb(this.c, this.b, true) : b = Dxb(this.c, this.b, false) : b = Bxb(this.c);
    if (!(!!b && xyb(this, b.d) ? b : null)) return 0;
    a = 0;
    for(c = new myb(this.c, this.f, this.b, this.a, this.e, this.d); rjb(c.a); c.b = JD(sjb(c.a), 43))++a;
    return a;
};
_.$c = function Nyb(a, b) {
    if (this.f.Re() && this.c.a.Le(a, this.b) < 0) throw scb(new Teb(mte + a + nte + this.b));
    return this.f.Se() ? Rxb(this.c, a, b, this.e, this.d) : Sxb(this.c, a, b);
};
_.a = false;
_.d = false;
var sL = jeb(Xqe, 'TreeMap/SubMap', 616);
Ycb(305, 23, ote, Tyb);
_.Re = function Uyb() {
    return false;
};
_.Se = function Vyb() {
    return false;
};
var Oyb, Pyb, Qyb, Ryb;
var rL = keb(Xqe, 'TreeMap/SubMapType', 305, MI, Xyb, Wyb);
Ycb(1107, 305, ote, Yyb);
_.Se = function Zyb() {
    return true;
};
var oL = keb(Xqe, 'TreeMap/SubMapType/1', 1107, rL, null, null);
Ycb(1108, 305, ote, $yb);
_.Re = function _yb() {
    return true;
};
_.Se = function azb() {
    return true;
};
var pL = keb(Xqe, 'TreeMap/SubMapType/2', 1108, rL, null, null);
Ycb(1109, 305, ote, bzb);
_.Re = function czb() {
    return true;
};
var qL = keb(Xqe, 'TreeMap/SubMapType/3', 1109, rL, null, null);
var dzb;
Ycb(156, $qe, {
    3: 1,
    20: 1,
    31: 1,
    16: 1,
    274: 1,
    22: 1,
    83: 1,
    156: 1
}, lzb, mzb, nzb);
_.Lc = function uzb() {
    return new Ovb(this);
};
_.Ec = function ozb(a) {
    return fzb(this, a);
};
_.$b = function pzb() {
    this.a.$b();
};
_.Gc = function qzb(a) {
    return this.a._b(a);
};
_.Jc = function rzb() {
    return this.a.ec().Jc();
};
_.Kc = function szb(a) {
    return kzb(this, a);
};
_.gc = function tzb() {
    return this.a.gc();
};
var uL = jeb(Xqe, 'TreeSet', 156);
Ycb(1047, 1, {}, xzb);
_.Te = function yzb(a, b) {
    return vzb(this.a, a, b);
};
var wL = jeb(pte, 'BinaryOperator/lambda$0$Type', 1047);
Ycb(1048, 1, {}, zzb);
_.Te = function Azb(a, b) {
    return wzb(this.a, a, b);
};
var xL = jeb(pte, 'BinaryOperator/lambda$1$Type', 1048);
Ycb(930, 1, {}, Bzb);
_.Kb = function Czb(a) {
    return a;
};
var yL = jeb(pte, 'Function/lambda$0$Type', 930);
Ycb(386, 1, Ire, Dzb);
_.Mb = function Ezb(a) {
    return !this.a.Mb(a);
};
var zL = jeb(pte, 'Predicate/lambda$2$Type', 386);
Ycb(563, 1, {
    563: 1
});
var AL = jeb(qte, 'Handler', 563);
Ycb(2053, 1, Jqe);
_.ve = function Hzb() {
    return 'DUMMY';
};
_.Ib = function Izb() {
    return this.ve();
};
var Fzb;
var CL = jeb(qte, 'Level', 2053);
Ycb(1648, 2053, Jqe, Jzb);
_.ve = function Kzb() {
    return 'INFO';
};
var BL = jeb(qte, 'Level/LevelInfo', 1648);
Ycb(1789, 1, {}, Ozb);
var Lzb;
var DL = jeb(qte, 'LogManager', 1789);
Ycb(1842, 1, Jqe, Qzb);
_.b = null;
var EL = jeb(qte, 'LogRecord', 1842);
Ycb(509, 1, {
    509: 1
}, cAb);
_.e = false;
var Rzb = false, Szb = false, Tzb = false, Uzb = false, Vzb = false;
var FL = jeb(qte, 'Logger', 509);
Ycb(814, 563, {
    563: 1
}, fAb);
var GL = jeb(qte, 'SimpleConsoleLogHandler', 814);
Ycb(131, 23, {
    3: 1,
    34: 1,
    23: 1,
    131: 1
}, mAb);
var iAb, jAb, kAb;
var HL = keb(tte, 'Collector/Characteristics', 131, MI, oAb, nAb);
var pAb;
Ycb(741, 1, {}, rAb);
var IL = jeb(tte, 'CollectorImpl', 741);
Ycb(1045, 1, {}, tAb);
_.Te = function uAb(a, b) {
    return vxb(JD(a, 212), JD(b, 212));
};
var JL = jeb(tte, 'Collectors/10methodref$merge$Type', 1045);
Ycb(1046, 1, {}, vAb);
_.Kb = function wAb(a) {
    return wxb(JD(a, 212));
};
var KL = jeb(tte, 'Collectors/11methodref$toString$Type', 1046);
Ycb(163, 1, {}, xAb);
_.Wd = function yAb(a, b) {
    JD(a, 16).Ec(b);
};
var LL = jeb(tte, 'Collectors/20methodref$add$Type', 163);
Ycb(165, 1, {}, zAb);
_.Ve = function AAb() {
    return new Ulb;
};
var ML = jeb(tte, 'Collectors/21methodref$ctor$Type', 165);
Ycb(1044, 1, {}, BAb);
_.Wd = function CAb(a, b) {
    uxb(JD(a, 212), JD(b, 470));
};
var NL = jeb(tte, 'Collectors/9methodref$add$Type', 1044);
Ycb(1043, 1, {}, DAb);
_.Ve = function EAb() {
    return new xxb(this.a, this.b, this.c);
};
var OL = jeb(tte, 'Collectors/lambda$15$Type', 1043);
Ycb(164, 1, {}, FAb);
_.Te = function GAb(a, b) {
    return sAb(JD(a, 16), JD(b, 16));
};
var PL = jeb(tte, 'Collectors/lambda$45$Type', 164);
Ycb(535, 1, {});
_.Ye = function NAb() {
    HAb(this);
};
_.d = false;
var vM = jeb(tte, 'TerminatableStream', 535);
Ycb(806, 535, ute, VAb);
_.Ye = function WAb() {
    HAb(this);
};
var UL = jeb(tte, 'DoubleStreamImpl', 806);
Ycb(1793, 719, jre, ZAb);
_.Pe = function _Ab(a) {
    return YAb(this, JD(a, 189));
};
_.a = null;
var RL = jeb(tte, 'DoubleStreamImpl/2', 1793);
Ycb(1794, 1, ate, aBb);
_.Ne = function bBb(a) {
    $Ab(this.a, a);
};
var QL = jeb(tte, 'DoubleStreamImpl/2/lambda$0$Type', 1794);
Ycb(1791, 1, ate, cBb);
_.Ne = function dBb(a) {
    XAb(this.a, a);
};
var SL = jeb(tte, 'DoubleStreamImpl/lambda$0$Type', 1791);
Ycb(1792, 1, ate, eBb);
_.Ne = function fBb(a) {
    Cqb(this.a, a);
};
var TL = jeb(tte, 'DoubleStreamImpl/lambda$2$Type', 1792);
Ycb(1336, 718, jre, jBb);
_.Pe = function kBb(a) {
    return iBb(this, JD(a, 202));
};
_.a = 0;
_.b = 0;
_.c = 0;
var VL = jeb(tte, 'IntStream/5', 1336);
Ycb(786, 535, ute, nBb);
_.Ye = function oBb() {
    HAb(this);
};
_.Ze = function pBb() {
    return KAb(this), this.a;
};
var YL = jeb(tte, 'IntStreamImpl', 786);
Ycb(787, 535, ute, qBb);
_.Ye = function rBb() {
    HAb(this);
};
_.Ze = function sBb() {
    return KAb(this), Hwb(), Gwb;
};
var WL = jeb(tte, 'IntStreamImpl/Empty', 787);
Ycb(1628, 1, lre, tBb);
_.Bd = function uBb(a) {
    _rb(this.a, a);
};
var XL = jeb(tte, 'IntStreamImpl/lambda$4$Type', 1628);
var sM = leb(tte, 'Stream');
Ycb(28, 535, {
    518: 1,
    672: 1,
    827: 1
}, RBb);
_.Ye = function SBb() {
    HAb(this);
};
var vBb;
var rM = jeb(tte, 'StreamImpl', 28);
Ycb(1067, 484, jre, XBb);
_.zd = function YBb(a) {
    while(VBb(this)){
        if (this.a.zd(a)) return true;
        else {
            HAb(this.b);
            this.b = null;
            this.a = null;
        }
    }
    return false;
};
var $L = jeb(tte, 'StreamImpl/1', 1067);
Ycb(1068, 1, kre, ZBb);
_.Ad = function $Bb(a) {
    WBb(this.a, JD(a, 827));
};
var ZL = jeb(tte, 'StreamImpl/1/lambda$0$Type', 1068);
Ycb(1069, 1, Ire, _Bb);
_.Mb = function aCb(a) {
    return Nrb(this.a, a);
};
var _L = jeb(tte, 'StreamImpl/1methodref$add$Type', 1069);
Ycb(1070, 484, jre, bCb);
_.zd = function cCb(a) {
    var b;
    if (!this.a) {
        b = new Ulb;
        this.b.a.Nb(new dCb(b));
        pnb();
        Slb(b, this.c);
        this.a = new Gvb(b, 16);
    }
    return Fvb(this.a, a);
};
_.a = null;
var bM = jeb(tte, 'StreamImpl/5', 1070);
Ycb(1071, 1, kre, dCb);
_.Ad = function eCb(a) {
    Ilb(this.a, a);
};
var aM = jeb(tte, 'StreamImpl/5/2methodref$add$Type', 1071);
Ycb(720, 484, jre, gCb);
_.zd = function hCb(a) {
    this.b = false;
    while(!this.b && this.c.zd(new iCb(this, a)));
    return this.b;
};
_.b = false;
var dM = jeb(tte, 'StreamImpl/FilterSpliterator', 720);
Ycb(1061, 1, kre, iCb);
_.Ad = function jCb(a) {
    fCb(this.a, this.b, a);
};
var cM = jeb(tte, 'StreamImpl/FilterSpliterator/lambda$0$Type', 1061);
Ycb(1056, 719, jre, mCb);
_.Pe = function nCb(a) {
    return lCb(this, JD(a, 189));
};
var fM = jeb(tte, 'StreamImpl/MapToDoubleSpliterator', 1056);
Ycb(1060, 1, kre, oCb);
_.Ad = function pCb(a) {
    kCb(this.a, this.b, a);
};
var eM = jeb(tte, 'StreamImpl/MapToDoubleSpliterator/lambda$0$Type', 1060);
Ycb(1055, 718, jre, sCb);
_.Pe = function tCb(a) {
    return rCb(this, JD(a, 202));
};
var hM = jeb(tte, 'StreamImpl/MapToIntSpliterator', 1055);
Ycb(1059, 1, kre, uCb);
_.Ad = function vCb(a) {
    qCb(this.a, this.b, a);
};
var gM = jeb(tte, 'StreamImpl/MapToIntSpliterator/lambda$0$Type', 1059);
Ycb(717, 484, jre, yCb);
_.zd = function zCb(a) {
    return xCb(this, a);
};
var jM = jeb(tte, 'StreamImpl/MapToObjSpliterator', 717);
Ycb(1058, 1, kre, ACb);
_.Ad = function BCb(a) {
    wCb(this.a, this.b, a);
};
var iM = jeb(tte, 'StreamImpl/MapToObjSpliterator/lambda$0$Type', 1058);
Ycb(1057, 484, jre, CCb);
_.zd = function DCb(a) {
    while(Acb(this.b, 0)){
        if (!this.a.zd(new ECb)) return false;
        this.b = Mcb(this.b, 1);
    }
    return this.a.zd(a);
};
_.b = 0;
var lM = jeb(tte, 'StreamImpl/SkipSpliterator', 1057);
Ycb(1062, 1, kre, ECb);
_.Ad = function FCb(a) {};
var kM = jeb(tte, 'StreamImpl/SkipSpliterator/lambda$0$Type', 1062);
Ycb(611, 1, kre, HCb);
_.Ad = function ICb(a) {
    GCb(this, a);
};
var mM = jeb(tte, 'StreamImpl/ValueConsumer', 611);
Ycb(1063, 1, kre, JCb);
_.Ad = function KCb(a) {
    wBb();
};
var nM = jeb(tte, 'StreamImpl/lambda$0$Type', 1063);
Ycb(1064, 1, kre, LCb);
_.Ad = function MCb(a) {
    wBb();
};
var oM = jeb(tte, 'StreamImpl/lambda$1$Type', 1064);
Ycb(1065, 1, {}, NCb);
_.Te = function OCb(a, b) {
    return TBb(this.a, a, b);
};
var pM = jeb(tte, 'StreamImpl/lambda$4$Type', 1065);
Ycb(1066, 1, kre, PCb);
_.Ad = function QCb(a) {
    UBb(this.b, this.a, a);
};
var qM = jeb(tte, 'StreamImpl/lambda$5$Type', 1066);
Ycb(1072, 1, kre, RCb);
_.Ad = function SCb(a) {
    OAb(this.a, JD(a, 372));
};
var uM = jeb(tte, 'TerminatableStream/lambda$0$Type', 1072);
Ycb(2088, 1, {});
Ycb(1960, 1, {}, fDb);
var wM = jeb('javaemul.internal', 'ConsoleLogger', 1960);
var hDb = 0;
Ycb(2080, 1, {});
Ycb(1776, 1, kre, EDb);
_.Ad = function FDb(a) {
    JD(a, 318);
};
var xM = jeb(Ate, 'BowyerWatsonTriangulation/lambda$0$Type', 1776);
Ycb(1777, 1, kre, GDb);
_.Ad = function HDb(a) {
    xe(this.a, JD(a, 318).e);
};
var yM = jeb(Ate, 'BowyerWatsonTriangulation/lambda$1$Type', 1777);
Ycb(1778, 1, kre, IDb);
_.Ad = function JDb(a) {
    JD(a, 176);
};
var zM = jeb(Ate, 'BowyerWatsonTriangulation/lambda$2$Type', 1778);
Ycb(1773, 1, Bte, MDb);
_.Le = function NDb(a, b) {
    return LDb(this.a, JD(a, 176), JD(b, 176));
};
_.Fb = function ODb(a) {
    return this === a;
};
_.Me = function PDb() {
    return new uqb(this);
};
var AM = jeb(Ate, 'NaiveMinST/lambda$0$Type', 1773);
Ycb(437, 1, {}, RDb);
var BM = jeb(Ate, 'NodeMicroLayout', 437);
Ycb(176, 1, {
    176: 1
}, SDb);
_.Fb = function TDb(a) {
    var b;
    if (RD(a, 176)) {
        b = JD(a, 176);
        return tub(this.a, b.a) && tub(this.b, b.b) || tub(this.a, b.b) && tub(this.b, b.a);
    } else return false;
};
_.Hb = function UDb() {
    return uub(this.a) + uub(this.b);
};
var CM = jeb(Ate, 'TEdge', 176);
Ycb(318, 1, {
    318: 1
}, WDb);
_.Fb = function XDb(a) {
    var b;
    if (RD(a, 318)) {
        b = JD(a, 318);
        return VDb(this, b.a) && VDb(this, b.b) && VDb(this, b.c);
    } else return false;
};
_.Hb = function YDb() {
    return uub(this.a) + uub(this.b) + uub(this.c);
};
var DM = jeb(Ate, 'TTriangle', 318);
Ycb(224, 1, {
    224: 1
}, ZDb);
var EM = jeb(Ate, 'Tree', 224);
Ycb(1178, 1, {}, _Db);
var GM = jeb(Cte, 'Scanline', 1178);
var FM = leb(Cte, Dte);
Ycb(1704, 1, {}, cEb);
var HM = jeb(Ete, 'CGraph', 1704);
Ycb(317, 1, {
    317: 1
}, eEb);
_.b = 0;
_.c = 0;
_.d = 0;
_.g = 0;
_.i = 0;
_.k = Lse;
var JM = jeb(Ete, 'CGroup', 317);
Ycb(809, 1, {}, iEb);
var IM = jeb(Ete, 'CGroup/CGroupBuilder', 809);
Ycb(60, 1, {
    60: 1
}, jEb);
_.Ib = function kEb() {
    var a;
    if (this.j) return OD(this.j.Kb(this));
    return ceb(LM), LM.o + '@' + (a = jDb(this) >>> 0, a.toString(16));
};
_.f = 0;
_.i = Lse;
var LM = jeb(Ete, 'CNode', 60);
Ycb(808, 1, {}, pEb);
var KM = jeb(Ete, 'CNode/CNodeBuilder', 808);
var uEb;
Ycb(1530, 1, {}, wEb);
_.df = function xEb(a, b) {
    return 0;
};
_.ef = function yEb(a, b) {
    return 0;
};
var MM = jeb(Ete, Gte, 1530);
Ycb(1799, 1, {}, zEb);
_.af = function AEb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    j = Kse;
    for(d = new rmb(a.a.b); d.a < d.c.c.length;){
        b = JD(pmb(d), 60);
        j = $wnd.Math.min(j, b.a.j.d.c + b.b.a);
    }
    n = new Mtb;
    for(g = new rmb(a.a.a); g.a < g.c.c.length;){
        f = JD(pmb(g), 317);
        f.k = j;
        f.g == 0 && Dtb(n, f, n.c.b, n.c);
    }
    while(n.b != 0){
        f = JD(n.b == 0 ? null : (rDb(n.b != 0), Ktb(n, n.a.a)), 317);
        e = f.j.d.c;
        for(m = f.a.a.ec().Jc(); m.Ob();){
            k = JD(m.Pb(), 60);
            p = f.k + k.b.a;
            !KEb(a, f, a.d) || k.d.c < p ? k.i = p : k.i = k.d.c;
        }
        e -= f.j.i;
        f.b += e;
        a.d == (Tgd(), Qgd) || a.d == Ogd ? f.c += e : f.c -= e;
        for(l = f.a.a.ec().Jc(); l.Ob();){
            k = JD(l.Pb(), 60);
            for(i = k.c.Jc(); i.Ob();){
                h = JD(i.Pb(), 60);
                Ugd(a.d) ? o = a.g.df(k, h) : o = a.g.ef(k, h);
                h.a.k = $wnd.Math.max(h.a.k, k.i + k.d.b + o - h.b.a);
                LEb(a, h, a.d) && (h.a.k = $wnd.Math.max(h.a.k, h.d.c - h.b.a));
                --h.a.g;
                h.a.g == 0 && Atb(n, h.a);
            }
        }
    }
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        b.d.c = b.i;
    }
};
var NM = jeb(Ete, 'LongestPathCompaction', 1799);
Ycb(1702, 1, {}, UEb);
_.e = false;
var BEb, CEb, DEb;
var PM = jeb(Ete, Lte, 1702);
Ycb(1703, 1, kre, VEb);
_.Ad = function WEb(a) {
    MEb(this.a, JD(a, 47));
};
var OM = jeb(Ete, Mte, 1703);
Ycb(1800, 1, {}, XEb);
_.bf = function YEb(a) {
    var b, c, d, e, f, g, h;
    for(c = new rmb(a.a.b); c.a < c.c.c.length;){
        b = JD(pmb(c), 60);
        b.c.$b();
    }
    for(e = new rmb(a.a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 60);
        for(g = new rmb(a.a.b); g.a < g.c.c.length;){
            f = JD(pmb(g), 60);
            if (d == f) continue;
            if (!!d.a && d.a == f.a) continue;
            Ugd(a.d) ? h = a.g.ef(d, f) : h = a.g.df(d, f);
            (f.d.c > d.d.c || d.d.c == f.d.c && d.d.b < f.d.b) && rEb(f.d.d + f.d.a + h, d.d.d) && tEb(f.d.d, d.d.d + d.d.a + h) && d.c.Ec(f);
        }
    }
};
var QM = jeb(Ete, 'QuadraticConstraintCalculation', 1800);
Ycb(514, 1, {
    514: 1
}, bFb);
_.a = false;
_.b = false;
_.c = false;
_.d = false;
var RM = jeb(Ete, Nte, 514);
Ycb(797, 1, {}, eFb);
_.bf = function fFb(a) {
    this.c = a;
    dFb(this, new wFb);
};
var XM = jeb(Ete, Ote, 797);
Ycb(1730, 1, {
    678: 1
}, kFb);
_._e = function lFb(a) {
    hFb(this, JD(a, 459));
};
var TM = jeb(Ete, Pte, 1730);
Ycb(1731, 1, Bte, nFb);
_.Le = function oFb(a, b) {
    return mFb(JD(a, 60), JD(b, 60));
};
_.Fb = function pFb(a) {
    return this === a;
};
_.Me = function qFb() {
    return new uqb(this);
};
var SM = jeb(Ete, Qte, 1731);
Ycb(459, 1, {
    459: 1
}, rFb);
_.a = false;
var UM = jeb(Ete, Rte, 459);
Ycb(1732, 1, Bte, sFb);
_.Le = function tFb(a, b) {
    return gFb(JD(a, 459), JD(b, 459));
};
_.Fb = function uFb(a) {
    return this === a;
};
_.Me = function vFb() {
    return new uqb(this);
};
var VM = jeb(Ete, Ste, 1732);
Ycb(1733, 1, Tte, wFb);
_.Lb = function xFb(a) {
    return JD(a, 60), true;
};
_.Fb = function yFb(a) {
    return this === a;
};
_.Mb = function zFb(a) {
    return JD(a, 60), true;
};
var WM = jeb(Ete, 'ScanlineConstraintCalculator/lambda$1$Type', 1733);
Ycb(216, 1, {
    216: 1
}, BFb);
_.Ib = function CFb() {
    return 'NEdge[id=' + this.b + ' w=' + this.g + ' d=' + this.a + ']';
};
_.a = 1;
_.b = 0;
_.c = 0;
_.f = false;
_.g = 0;
var ZM = jeb(Ute, 'NEdge', 216);
Ycb(182, 1, {}, IFb);
var YM = jeb(Ute, 'NEdge/NEdgeBuilder', 182);
Ycb(646, 1, {}, NFb);
var $M = jeb(Ute, 'NGraph', 646);
Ycb(123, 1, {
    123: 1
}, PFb);
_.c = -1;
_.d = 0;
_.e = 0;
_.i = -1;
_.j = false;
var bN = jeb(Ute, 'NNode', 123);
Ycb(788, 1, $se, SFb);
_.Ic = function $Fb(a) {
    ofb(this, a);
};
_.gd = function jGb(a) {
    hub(this, a);
};
_.Lc = function kGb() {
    return new Gvb(this, 16);
};
_.Mc = function lGb() {
    return new RBb(null, new Gvb(this, 16));
};
_._c = function TFb(a, b) {
    ++this.b;
    Hlb(this.a, a, b);
};
_.Ec = function UFb(a) {
    return QFb(this, a);
};
_.ad = function VFb(a, b) {
    ++this.b;
    return Jlb(this.a, a, b);
};
_.Fc = function WFb(a) {
    ++this.b;
    return Klb(this.a, a);
};
_.$b = function XFb() {
    ++this.b;
    _Cb(this.a.c, 0);
};
_.Gc = function YFb(a) {
    return Nlb(this.a, a, 0) != -1;
};
_.Hc = function ZFb(a) {
    return Ae(this.a, a);
};
_.Xb = function _Fb(a) {
    return Mlb(this.a, a);
};
_.bd = function aGb(a) {
    return Nlb(this.a, a, 0);
};
_.dc = function bGb() {
    return this.a.c.length == 0;
};
_.Jc = function cGb() {
    return Jr(new rmb(this.a));
};
_.cd = function dGb() {
    throw scb(new ahb);
};
_.dd = function eGb(a) {
    throw scb(new ahb);
};
_.ed = function fGb(a) {
    ++this.b;
    return Olb(this.a, a);
};
_.Kc = function gGb(a) {
    return RFb(this, a);
};
_.fd = function hGb(a, b) {
    ++this.b;
    return Rlb(this.a, a, b);
};
_.gc = function iGb() {
    return this.a.c.length;
};
_.hd = function mGb(a, b) {
    return new Ijb(this.a, a, b);
};
_.Nc = function nGb() {
    return TCb(this.a.c);
};
_.Oc = function oGb(a) {
    return Tlb(this.a, a);
};
_.b = 0;
var _M = jeb(Ute, 'NNode/ChangeAwareArrayList', 788);
Ycb(271, 1, {}, rGb);
var aN = jeb(Ute, 'NNode/NNodeBuilder', 271);
Ycb(1636, 1, {}, MGb);
_.a = false;
_.f = Hqe;
_.j = 0;
var cN = jeb(Ute, 'NetworkSimplex', 1636);
Ycb(1267, 1, kre, SGb);
_.Ad = function TGb(a) {
    RGb(this.a, JD(a, 680), true, false);
};
var dN = jeb(Wte, 'NodeLabelAndSizeCalculator/lambda$0$Type', 1267);
Ycb(550, 1, {}, $Gb);
_.b = true;
_.c = true;
_.d = true;
_.e = true;
var eN = jeb(Wte, 'NodeMarginCalculator', 550);
Ycb(215, 1, {
    215: 1
});
_.j = false;
_.k = false;
var gN = jeb(Xte, 'Cell', 215);
Ycb(126, 215, {
    126: 1,
    215: 1
}, cHb);
_.ff = function dHb() {
    return bHb(this);
};
_.gf = function eHb() {
    var a;
    a = this.n;
    return this.a.a + a.b + a.c;
};
var fN = jeb(Xte, 'AtomicCell', 126);
Ycb(236, 23, {
    3: 1,
    34: 1,
    23: 1,
    236: 1
}, jHb);
var fHb, gHb, hHb;
var hN = keb(Xte, 'ContainerArea', 236, MI, lHb, kHb);
var mHb;
Ycb(332, 215, Zte);
var iN = jeb(Xte, 'ContainerCell', 332);
Ycb(1478, 332, Zte, HHb);
_.ff = function IHb() {
    var a;
    a = 0;
    this.e ? this.b ? a = this.b.b : !!this.a[1][1] && (a = this.a[1][1].ff()) : a = GHb(this, CHb(this, true));
    return a > 0 ? a + this.n.d + this.n.a : 0;
};
_.gf = function JHb() {
    var a, b, c, d, e;
    e = 0;
    if (this.e) this.b ? e = this.b.a : !!this.a[1][1] && (e = this.a[1][1].gf());
    else if (this.g) e = GHb(this, AHb(this, null, true));
    else for(b = (iHb(), WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ])), c = 0, d = b.length; c < d; ++c){
        a = b[c];
        e = $wnd.Math.max(e, GHb(this, AHb(this, a, true)));
    }
    return e > 0 ? e + this.n.b + this.n.c : 0;
};
_.hf = function KHb() {
    var a, b, c, d, e;
    if (this.g) {
        a = AHb(this, null, false);
        for(c = (iHb(), WC(OC(hN, 1), Ere, 236, 0, [
            fHb,
            gHb,
            hHb
        ])), d = 0, e = c.length; d < e; ++d){
            b = c[d];
            yHb(this, b, a);
        }
    } else for(c = (iHb(), WC(OC(hN, 1), Ere, 236, 0, [
        fHb,
        gHb,
        hHb
    ])), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        a = AHb(this, b, false);
        yHb(this, b, a);
    }
};
_.jf = function LHb() {
    var a, b, c, d;
    b = this.i;
    a = this.n;
    d = CHb(this, false);
    wHb(this, (iHb(), fHb), b.d + a.d, d);
    wHb(this, hHb, b.d + b.a - a.a - d[2], d);
    c = b.a - a.d - a.a;
    if (d[0] > 0) {
        d[0] += this.d;
        c -= d[0];
    }
    if (d[2] > 0) {
        d[2] += this.d;
        c -= d[2];
    }
    this.c.a = $wnd.Math.max(0, c);
    this.c.d = b.d + a.d + (this.c.a - c) / 2;
    d[1] = $wnd.Math.max(d[1], c);
    wHb(this, gHb, b.d + a.d + d[0] - (d[1] - c) / 2, d);
};
_.b = null;
_.d = 0;
_.e = false;
_.f = false;
_.g = false;
var tHb = 0, uHb = 0;
var jN = jeb(Xte, 'GridContainerCell', 1478);
Ycb(457, 23, {
    3: 1,
    34: 1,
    23: 1,
    457: 1
}, QHb);
var MHb, NHb, OHb;
var kN = keb(Xte, 'HorizontalLabelAlignment', 457, MI, SHb, RHb);
var THb;
Ycb(315, 215, {
    215: 1,
    315: 1
}, cIb, dIb, eIb);
_.ff = function fIb() {
    return $Hb(this);
};
_.gf = function gIb() {
    return _Hb(this);
};
_.a = 0;
_.c = false;
var lN = jeb(Xte, 'LabelCell', 315);
Ycb(251, 332, {
    215: 1,
    332: 1,
    251: 1
}, oIb);
_.ff = function pIb() {
    return hIb(this);
};
_.gf = function qIb() {
    return iIb(this);
};
_.hf = function tIb() {
    jIb(this);
};
_.jf = function uIb() {
    kIb(this);
};
_.b = 0;
_.c = 0;
_.d = false;
var qN = jeb(Xte, 'StripContainerCell', 251);
Ycb(1632, 1, Ire, vIb);
_.Mb = function wIb(a) {
    return rIb(JD(a, 215));
};
var mN = jeb(Xte, 'StripContainerCell/lambda$0$Type', 1632);
Ycb(1633, 1, {}, xIb);
_.We = function yIb(a) {
    return JD(a, 215).gf();
};
var nN = jeb(Xte, 'StripContainerCell/lambda$1$Type', 1633);
Ycb(1634, 1, Ire, zIb);
_.Mb = function AIb(a) {
    return sIb(JD(a, 215));
};
var oN = jeb(Xte, 'StripContainerCell/lambda$2$Type', 1634);
Ycb(1635, 1, {}, BIb);
_.We = function CIb(a) {
    return JD(a, 215).ff();
};
var pN = jeb(Xte, 'StripContainerCell/lambda$3$Type', 1635);
Ycb(458, 23, {
    3: 1,
    34: 1,
    23: 1,
    458: 1
}, HIb);
var DIb, EIb, FIb;
var rN = keb(Xte, 'VerticalLabelAlignment', 458, MI, JIb, IIb);
var KIb;
Ycb(780, 1, {}, NIb);
_.c = 0;
_.d = 0;
_.k = 0;
_.s = 0;
_.t = 0;
_.v = false;
_.w = 0;
_.D = false;
_.F = false;
var uN = jeb(due, 'NodeContext', 780);
Ycb(1476, 1, Bte, QIb);
_.Le = function RIb(a, b) {
    return PIb(JD(a, 64), JD(b, 64));
};
_.Fb = function SIb(a) {
    return this === a;
};
_.Me = function TIb() {
    return new uqb(this);
};
var sN = jeb(due, 'NodeContext/0methodref$comparePortSides$Type', 1476);
Ycb(1477, 1, Bte, UIb);
_.Le = function VIb(a, b) {
    return OIb(JD(a, 115), JD(b, 115));
};
_.Fb = function WIb(a) {
    return this === a;
};
_.Me = function XIb() {
    return new uqb(this);
};
var tN = jeb(due, 'NodeContext/1methodref$comparePortContexts$Type', 1477);
Ycb(166, 23, {
    3: 1,
    34: 1,
    23: 1,
    166: 1
}, vJb);
var YIb, ZIb, $Ib, _Ib, aJb, bJb, cJb, dJb, eJb, fJb, gJb, hJb, iJb, jJb, kJb, lJb, mJb, nJb, oJb, pJb, qJb, rJb;
var vN = keb(due, 'NodeLabelLocation', 166, MI, yJb, xJb);
var zJb;
Ycb(115, 1, {
    115: 1
}, CJb);
_.a = false;
var wN = jeb(due, 'PortContext', 115);
Ycb(1481, 1, kre, VJb);
_.Ad = function WJb(a) {
    YHb(JD(a, 315));
};
var xN = jeb(gue, hue, 1481);
Ycb(1482, 1, Ire, XJb);
_.Mb = function YJb(a) {
    return !!JD(a, 115).c;
};
var yN = jeb(gue, iue, 1482);
Ycb(1483, 1, kre, ZJb);
_.Ad = function $Jb(a) {
    YHb(JD(a, 115).c);
};
var zN = jeb(gue, 'LabelPlacer/lambda$2$Type', 1483);
var _Jb;
Ycb(1480, 1, kre, hKb);
_.Ad = function iKb(a) {
    aKb();
    BJb(JD(a, 115));
};
var AN = jeb(gue, 'NodeLabelAndSizeUtilities/lambda$0$Type', 1480);
Ycb(781, 1, kre, oKb);
_.Ad = function pKb(a) {
    mKb(this.b, this.c, this.a, JD(a, 187));
};
_.a = false;
_.c = false;
var BN = jeb(gue, 'NodeLabelCellCreator/lambda$0$Type', 781);
Ycb(1479, 1, kre, vKb);
_.Ad = function wKb(a) {
    uKb(this.a, JD(a, 187));
};
var CN = jeb(gue, 'PortContextCreator/lambda$0$Type', 1479);
var DKb;
Ycb(1848, 1, {}, XKb);
var EN = jeb(kue, 'GreedyRectangleStripOverlapRemover', 1848);
Ycb(1849, 1, Bte, ZKb);
_.Le = function $Kb(a, b) {
    return YKb(JD(a, 225), JD(b, 225));
};
_.Fb = function _Kb(a) {
    return this === a;
};
_.Me = function aLb() {
    return new uqb(this);
};
var DN = jeb(kue, 'GreedyRectangleStripOverlapRemover/0methodref$compareByYCoordinate$Type', 1849);
Ycb(1795, 1, {}, hLb);
_.a = 5;
_.e = 0;
var KN = jeb(kue, 'RectangleStripOverlapRemover', 1795);
Ycb(1796, 1, Bte, lLb);
_.Le = function mLb(a, b) {
    return iLb(JD(a, 225), JD(b, 225));
};
_.Fb = function nLb(a) {
    return this === a;
};
_.Me = function oLb() {
    return new uqb(this);
};
var FN = jeb(kue, 'RectangleStripOverlapRemover/0methodref$compareLeftRectangleBorders$Type', 1796);
Ycb(1798, 1, Bte, pLb);
_.Le = function qLb(a, b) {
    return jLb(JD(a, 225), JD(b, 225));
};
_.Fb = function rLb(a) {
    return this === a;
};
_.Me = function sLb() {
    return new uqb(this);
};
var GN = jeb(kue, 'RectangleStripOverlapRemover/1methodref$compareRightRectangleBorders$Type', 1798);
Ycb(406, 23, {
    3: 1,
    34: 1,
    23: 1,
    406: 1
}, yLb);
var tLb, uLb, vLb, wLb;
var HN = keb(kue, 'RectangleStripOverlapRemover/OverlapRemovalDirection', 406, MI, ALb, zLb);
var BLb;
Ycb(225, 1, {
    225: 1
}, DLb);
var IN = jeb(kue, 'RectangleStripOverlapRemover/RectangleNode', 225);
Ycb(1797, 1, kre, ELb);
_.Ad = function FLb(a) {
    cLb(this.a, JD(a, 225));
};
var JN = jeb(kue, 'RectangleStripOverlapRemover/lambda$1$Type', 1797);
var GLb = false, HLb, ILb;
Ycb(1774, 1, kre, QLb);
_.Ad = function RLb(a) {
    KLb(JD(a, 224));
};
var LN = jeb(mue, 'DepthFirstCompaction/0methodref$compactTree$Type', 1774);
Ycb(804, 1, kre, SLb);
_.Ad = function TLb(a) {
    NLb(this.a, JD(a, 224));
};
var MN = jeb(mue, 'DepthFirstCompaction/lambda$1$Type', 804);
Ycb(1775, 1, kre, ULb);
_.Ad = function VLb(a) {
    OLb(this.a, this.b, this.c, JD(a, 224));
};
var NN = jeb(mue, 'DepthFirstCompaction/lambda$2$Type', 1775);
var WLb, XLb;
Ycb(68, 1, {
    68: 1
}, bMb);
var ON = jeb(mue, 'Node', 68);
Ycb(1174, 1, {}, eMb);
var TN = jeb(mue, 'ScanlineOverlapCheck', 1174);
Ycb(1175, 1, {
    678: 1
}, iMb);
_._e = function jMb(a) {
    gMb(this, JD(a, 439));
};
var QN = jeb(mue, 'ScanlineOverlapCheck/OverlapsScanlineHandler', 1175);
Ycb(1176, 1, Bte, lMb);
_.Le = function mMb(a, b) {
    return kMb(JD(a, 68), JD(b, 68));
};
_.Fb = function nMb(a) {
    return this === a;
};
_.Me = function oMb() {
    return new uqb(this);
};
var PN = jeb(mue, 'ScanlineOverlapCheck/OverlapsScanlineHandler/lambda$0$Type', 1176);
Ycb(439, 1, {
    439: 1
}, pMb);
_.a = false;
var RN = jeb(mue, 'ScanlineOverlapCheck/Timestamp', 439);
Ycb(1177, 1, Bte, qMb);
_.Le = function rMb(a, b) {
    return fMb(JD(a, 439), JD(b, 439));
};
_.Fb = function sMb(a) {
    return this === a;
};
_.Me = function tMb() {
    return new uqb(this);
};
var SN = jeb(mue, 'ScanlineOverlapCheck/lambda$0$Type', 1177);
Ycb(542, 1, {}, uMb);
var UN = jeb('org.eclipse.elk.alg.common.utils', 'SVGImage', 542);
Ycb(743, 1, {}, CMb);
var WN = jeb(pue, que, 743);
Ycb(1159, 1, Bte, EMb);
_.Le = function FMb(a, b) {
    return DMb(JD(a, 234), JD(b, 234));
};
_.Fb = function GMb(a) {
    return this === a;
};
_.Me = function HMb() {
    return new uqb(this);
};
var VN = jeb(pue, rue, 1159);
Ycb(1160, 1, kre, NMb);
_.Ad = function OMb(a) {
    MMb(this.b, this.a, JD(a, 249));
};
var XN = jeb(pue, sue, 1160);
Ycb(222, 1, tue);
var X0 = jeb(uue, 'AbstractLayoutProvider', 222);
Ycb(721, 222, tue, SMb);
_.kf = function TMb(a, b) {
    PMb(this, a, b);
};
var YN = jeb(pue, 'ForceLayoutProvider', 721);
var M4 = leb(vue, wue);
Ycb(148, 1, {
    3: 1,
    102: 1,
    148: 1
}, $Mb);
_.of = function cNb(a, b) {
    return YMb(this, a, b);
};
_.lf = function _Mb() {
    return VMb(this);
};
_.mf = function aNb(a) {
    return WMb(this, a);
};
_.nf = function bNb(a) {
    return XMb(this, a);
};
var O4 = jeb(vue, 'MapPropertyHolder', 148);
Ycb(310, 148, {
    3: 1,
    310: 1,
    102: 1,
    148: 1
});
var cO = jeb(xue, 'FParticle', 310);
Ycb(249, 310, {
    3: 1,
    249: 1,
    310: 1,
    102: 1,
    148: 1
}, eNb);
_.Ib = function fNb() {
    var a;
    if (this.a) {
        a = Nlb(this.a.a, this, 0);
        return a >= 0 ? 'b' + a + '[' + lNb(this.a) + ']' : 'b[' + lNb(this.a) + ']';
    }
    return 'b_' + jDb(this);
};
var ZN = jeb(xue, 'FBendpoint', 249);
Ycb(288, 148, {
    3: 1,
    288: 1,
    102: 1,
    148: 1
}, mNb);
_.Ib = function nNb() {
    return lNb(this);
};
var $N = jeb(xue, 'FEdge', 288);
Ycb(234, 148, {
    3: 1,
    234: 1,
    102: 1,
    148: 1
}, qNb);
var _N = jeb(xue, 'FGraph', 234);
Ycb(442, 310, {
    3: 1,
    442: 1,
    310: 1,
    102: 1,
    148: 1
}, sNb);
_.Ib = function tNb() {
    return this.b == null || this.b.length == 0 ? 'l[' + lNb(this.a) + ']' : 'l_' + this.b;
};
var aO = jeb(xue, 'FLabel', 442);
Ycb(151, 310, {
    3: 1,
    151: 1,
    310: 1,
    102: 1,
    148: 1
}, vNb);
_.Ib = function wNb() {
    return uNb(this);
};
_.a = 0;
var bO = jeb(xue, 'FNode', 151);
Ycb(2046, 1, {});
_.qf = function BNb(a) {
    xNb(this, a);
};
_.rf = function CNb() {
    yNb(this);
};
_.d = 0;
var dO = jeb(zue, 'AbstractForceModel', 2046);
Ycb(626, 2046, {
    626: 1
}, DNb);
_.pf = function FNb(a, b) {
    var c, d, e, f, g;
    ANb(this.f, a, b);
    e = Bdd(odd(b.d), a.d);
    g = $wnd.Math.sqrt(e.a * e.a + e.b * e.b);
    d = $wnd.Math.max(0, g - sdd(a.e) / 2 - sdd(b.e) / 2);
    c = pNb(this.e, a, b);
    c > 0 ? f = -ENb(d, this.c) * c : f = INb(d, this.b) * JD(WMb(a, (IOb(), vOb)), 17).a;
    e.a *= f / g;
    e.b *= f / g;
    return e;
};
_.qf = function GNb(a) {
    xNb(this, a);
    this.a = JD(WMb(a, (IOb(), kOb)), 17).a;
    this.c = Beb(MD(WMb(a, BOb)));
    this.b = Beb(MD(WMb(a, xOb)));
};
_.sf = function HNb(a) {
    return a < this.a;
};
_.a = 0;
_.b = 0;
_.c = 0;
var eO = jeb(zue, 'EadesModel', 626);
Ycb(627, 2046, {
    627: 1
}, JNb);
_.pf = function LNb(a, b) {
    var c, d, e, f, g;
    ANb(this.f, a, b);
    e = Bdd(odd(b.d), a.d);
    g = $wnd.Math.sqrt(e.a * e.a + e.b * e.b);
    d = $wnd.Math.max(0, g - sdd(a.e) / 2 - sdd(b.e) / 2);
    f = PNb(d, this.a) * JD(WMb(a, (IOb(), vOb)), 17).a;
    c = pNb(this.e, a, b);
    c > 0 && (f -= KNb(d, this.a) * c);
    wdd(e, f * this.b / g);
    return e;
};
_.qf = function MNb(a) {
    var b, c, d, e, f, g, h;
    xNb(this, a);
    this.b = Beb(MD(WMb(a, (IOb(), COb))));
    this.c = this.b / JD(WMb(a, kOb), 17).a;
    d = a.e.c.length;
    f = 0;
    e = 0;
    for(h = new rmb(a.e); h.a < h.c.c.length;){
        g = JD(pmb(h), 151);
        f += g.e.a;
        e += g.e.b;
    }
    b = f * e;
    c = Beb(MD(WMb(a, BOb))) * fue;
    this.a = $wnd.Math.sqrt(b / (2 * d)) * c;
};
_.rf = function NNb() {
    yNb(this);
    this.b -= this.c;
};
_.sf = function ONb(a) {
    return this.b > 0;
};
_.a = 0;
_.b = 0;
_.c = 0;
var fO = jeb(zue, 'FruchtermanReingoldModel', 627);
var r1 = leb(Aue, 'ILayoutMetaDataProvider');
Ycb(839, 1, Hue, ZNb);
_.tf = function $Nb(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Bue), ''), 'Force Model'), 'Determines the model for force calculation.'), SNb), (zcd(), tcd)), hO), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Cue), ''), 'Iterations'), 'The number of iterations on the force model.'), jfb(300)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Due), ''), 'Repulsive Power'), 'Determines how many bend points are added to the edge; such bend points are regarded as repelling particles in the force model'), jfb(0)), vcd), UI), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Eue), ''), 'FR Temperature'), 'The temperature is used as a scaling factor for particle displacements.'), Fue), scd), LI), mrb(jcd))));
    Oad(a, Eue, Bue, XNb);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Gue), ''), 'Eades Repulsion'), "Factor for repulsive forces in Eades' model."), 5), scd), LI), mrb(jcd))));
    Oad(a, Gue, Bue, UNb);
    JOb((new KOb, a));
};
var QNb, RNb, SNb, TNb, UNb, VNb, WNb, XNb;
var gO = jeb(Iue, 'ForceMetaDataProvider', 839);
Ycb(421, 23, {
    3: 1,
    34: 1,
    23: 1,
    421: 1
}, cOb);
var _Nb, aOb;
var hO = keb(Iue, 'ForceModelStrategy', 421, MI, eOb, dOb);
var fOb;
Ycb(977, 1, Hue, KOb);
_.tf = function LOb(a) {
    JOb(a);
};
var hOb, iOb, jOb, kOb, lOb, mOb, nOb, oOb, pOb, qOb, rOb, sOb, tOb, uOb, vOb, wOb, xOb, yOb, zOb, AOb, BOb, COb, DOb, EOb, FOb, GOb, HOb;
var jO = jeb(Iue, 'ForceOptions', 977);
Ycb(978, 1, {}, MOb);
_.uf = function NOb() {
    var a;
    return a = new SMb, a;
};
_.vf = function OOb(a) {};
var iO = jeb(Iue, 'ForceOptions/ForceFactory', 978);
var POb, QOb, ROb, SOb;
Ycb(840, 1, Hue, _Ob);
_.tf = function aPb(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, ive), ''), 'Fixed Position'), 'Prevent that the node is moved by the layout algorithm.'), (xdb(), false)), (zcd(), rcd)), GI), mrb((lcd(), icd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, jve), ''), 'Desired Edge Length'), 'Either specified for parent nodes or for individual edges, where the latter takes higher precedence.'), 100), scd), LI), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        gcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, kve), ''), 'Layout Dimension'), 'Dimensions that are permitted to be altered during layout.'), WOb), tcd), pO), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, lve), ''), 'Stress Epsilon'), 'Termination criterion for the iterative process.'), Fue), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, mve), ''), 'Iteration Limit'), "Maximum number of performed iterations. Takes higher precedence than 'epsilon'."), jfb(Hqe)), vcd), UI), mrb(jcd))));
    oPb((new pPb, a));
};
var UOb, VOb, WOb, XOb, YOb, ZOb;
var kO = jeb(Iue, 'StressMetaDataProvider', 840);
Ycb(981, 1, Hue, pPb);
_.tf = function qPb(a) {
    oPb(a);
};
var bPb, cPb, dPb, ePb, fPb, gPb, hPb, iPb, jPb, kPb, lPb, mPb;
var mO = jeb(Iue, 'StressOptions', 981);
Ycb(982, 1, {}, rPb);
_.uf = function sPb() {
    var a;
    return a = new uPb, a;
};
_.vf = function tPb(a) {};
var lO = jeb(Iue, 'StressOptions/StressFactory', 982);
Ycb(1075, 222, tue, uPb);
_.kf = function vPb(a, b) {
    var c, d, e, f, g;
    b.Sg(ove, 1);
    ydb(LD(ksd(a, (nPb(), fPb)))) ? ydb(LD(ksd(a, lPb))) || QDb((c = new RDb((Rod(), new dpd(a))), c)) : PMb(new SMb, a, b.bh(1));
    e = JMb(a);
    d = BMb(this.a, e);
    for(g = d.Jc(); g.Ob();){
        f = JD(g.Pb(), 234);
        if (f.e.c.length <= 1) continue;
        EPb(this.b, f);
        CPb(this.b);
        Llb(f.d, new wPb);
    }
    e = AMb(d);
    IMb(e);
    b.Tg();
};
var oO = jeb(qve, 'StressLayoutProvider', 1075);
Ycb(1076, 1, kre, wPb);
_.Ad = function xPb(a) {
    rNb(JD(a, 442));
};
var nO = jeb(qve, 'StressLayoutProvider/lambda$0$Type', 1076);
Ycb(979, 1, {}, FPb);
_.c = 0;
_.e = 0;
_.g = 0;
var rO = jeb(qve, 'StressMajorization', 979);
Ycb(382, 23, {
    3: 1,
    34: 1,
    23: 1,
    382: 1
}, LPb);
var HPb, IPb, JPb;
var pO = keb(qve, 'StressMajorization/Dimension', 382, MI, NPb, MPb);
var OPb;
Ycb(980, 1, Bte, QPb);
_.Le = function RPb(a, b) {
    return GPb(this.a, JD(a, 151), JD(b, 151));
};
_.Fb = function SPb(a) {
    return this === a;
};
_.Me = function TPb() {
    return new uqb(this);
};
var qO = jeb(qve, 'StressMajorization/lambda$0$Type', 980);
Ycb(1156, 1, {}, _Pb);
var uO = jeb(sve, 'ElkLayered', 1156);
Ycb(1157, 1, kre, cQb);
_.Ad = function dQb(a) {
    aQb(this.a, JD(a, 36));
};
var sO = jeb(sve, 'ElkLayered/lambda$0$Type', 1157);
Ycb(1158, 1, kre, eQb);
_.Ad = function fQb(a) {
    bQb(this.a, JD(a, 36));
};
var tO = jeb(sve, 'ElkLayered/lambda$1$Type', 1158);
Ycb(1241, 1, {}, nQb);
var gQb, hQb, iQb;
var yO = jeb(sve, 'GraphConfigurator', 1241);
Ycb(752, 1, kre, pQb);
_.Ad = function qQb(a) {
    kQb(this.a, JD(a, 9));
};
var vO = jeb(sve, 'GraphConfigurator/lambda$0$Type', 752);
Ycb(753, 1, {}, rQb);
_.Kb = function sQb(a) {
    return jQb(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var wO = jeb(sve, 'GraphConfigurator/lambda$1$Type', 753);
Ycb(754, 1, kre, tQb);
_.Ad = function uQb(a) {
    kQb(this.a, JD(a, 9));
};
var xO = jeb(sve, 'GraphConfigurator/lambda$2$Type', 754);
Ycb(1074, 222, tue, vQb);
_.kf = function wQb(a, b) {
    var c;
    c = o$b(new w$b, a);
    XD(ksd(a, (Bwc(), Iuc))) === XD((eid(), bid)) ? VPb(this.a, c, b) : WPb(this.a, c, b);
    b.Yg() || V$b(new Z$b, c);
};
var zO = jeb(sve, 'LayeredLayoutProvider', 1074);
Ycb(360, 23, {
    3: 1,
    34: 1,
    23: 1,
    360: 1
}, DQb);
var xQb, yQb, zQb, AQb, BQb;
var AO = keb(sve, 'LayeredPhases', 360, MI, FQb, EQb);
var GQb;
Ycb(1659, 1, {}, OQb);
_.i = 0;
var IQb;
var DO = jeb(tve, 'ComponentsToCGraphTransformer', 1659);
var tRb;
Ycb(1660, 1, {}, PQb);
_.wf = function QQb(a, b) {
    return $wnd.Math.min(a.a != null ? Beb(a.a) : a.c.i, b.a != null ? Beb(b.a) : b.c.i);
};
_.xf = function RQb(a, b) {
    return $wnd.Math.min(a.a != null ? Beb(a.a) : a.c.i, b.a != null ? Beb(b.a) : b.c.i);
};
var BO = jeb(tve, 'ComponentsToCGraphTransformer/1', 1660);
Ycb(82, 1, {
    82: 1
});
_.i = 0;
_.k = true;
_.o = Lse;
var JO = jeb(uve, 'CNode', 82);
Ycb(456, 82, {
    456: 1,
    82: 1
}, SQb, TQb);
_.Ib = function UQb() {
    return '';
};
var CO = jeb(tve, 'ComponentsToCGraphTransformer/CRectNode', 456);
Ycb(1629, 1, {}, fRb);
var VQb, WQb;
var GO = jeb(tve, 'OneDimensionalComponentsCompaction', 1629);
Ycb(1630, 1, {}, iRb);
_.Kb = function jRb(a) {
    return gRb(JD(a, 47));
};
_.Fb = function kRb(a) {
    return this === a;
};
var EO = jeb(tve, 'OneDimensionalComponentsCompaction/lambda$0$Type', 1630);
Ycb(1631, 1, {}, lRb);
_.Kb = function mRb(a) {
    return hRb(JD(a, 47));
};
_.Fb = function nRb(a) {
    return this === a;
};
var FO = jeb(tve, 'OneDimensionalComponentsCompaction/lambda$1$Type', 1631);
Ycb(1662, 1, {}, pRb);
var HO = jeb(uve, 'CGraph', 1662);
Ycb(194, 1, {
    194: 1
}, sRb);
_.b = 0;
_.c = 0;
_.e = 0;
_.g = true;
_.i = Lse;
var IO = jeb(uve, 'CGroup', 194);
Ycb(1661, 1, {}, vRb);
_.wf = function wRb(a, b) {
    return $wnd.Math.max(a.a != null ? Beb(a.a) : a.c.i, b.a != null ? Beb(b.a) : b.c.i);
};
_.xf = function xRb(a, b) {
    return $wnd.Math.max(a.a != null ? Beb(a.a) : a.c.i, b.a != null ? Beb(b.a) : b.c.i);
};
var KO = jeb(uve, Gte, 1661);
Ycb(1663, 1, {}, ORb);
_.d = false;
var yRb;
var MO = jeb(uve, Lte, 1663);
Ycb(1664, 1, {}, PRb);
_.Kb = function QRb(a) {
    return zRb(), xdb(), JD(JD(a, 47).a, 82).d.e != 0 ? true : false;
};
_.Fb = function RRb(a) {
    return this === a;
};
var LO = jeb(uve, Mte, 1664);
Ycb(812, 1, {}, URb);
_.a = false;
_.b = false;
_.c = false;
_.d = false;
var NO = jeb(uve, Nte, 812);
Ycb(1844, 1, {}, $Rb);
var SO = jeb(vve, Ote, 1844);
var cP = leb(wve, Dte);
Ycb(1845, 1, {
    374: 1
}, cSb);
_._e = function dSb(a) {
    aSb(this, JD(a, 462));
};
var PO = jeb(vve, Pte, 1845);
Ycb(1846, 1, Bte, fSb);
_.Le = function gSb(a, b) {
    return eSb(JD(a, 82), JD(b, 82));
};
_.Fb = function hSb(a) {
    return this === a;
};
_.Me = function iSb() {
    return new uqb(this);
};
var OO = jeb(vve, Qte, 1846);
Ycb(462, 1, {
    462: 1
}, jSb);
_.a = false;
var QO = jeb(vve, Rte, 462);
Ycb(1847, 1, Bte, kSb);
_.Le = function lSb(a, b) {
    return _Rb(JD(a, 462), JD(b, 462));
};
_.Fb = function mSb(a) {
    return this === a;
};
_.Me = function nSb() {
    return new uqb(this);
};
var RO = jeb(vve, Ste, 1847);
Ycb(143, 1, {
    143: 1
}, oSb, pSb);
_.Fb = function qSb(a) {
    var b;
    if (a == null) return false;
    if (UO != rb(a)) return false;
    b = JD(a, 143);
    return tub(this.c, b.c) && tub(this.d, b.d);
};
_.Hb = function rSb() {
    return Kmb(WC(OC(aJ, 1), Nqe, 1, 5, [
        this.c,
        this.d
    ]));
};
_.Ib = function sSb() {
    return '(' + this.c + Lqe + this.d + (this.a ? 'cx' : '') + this.b + ')';
};
_.a = true;
_.c = 0;
_.d = 0;
var UO = jeb(wve, 'Point', 143);
Ycb(405, 23, {
    3: 1,
    34: 1,
    23: 1,
    405: 1
}, ASb);
var tSb, uSb, vSb, wSb;
var TO = keb(wve, 'Point/Quadrant', 405, MI, ESb, DSb);
var FSb;
Ycb(1650, 1, {}, OSb);
_.b = null;
_.c = null;
_.d = null;
_.e = null;
_.f = null;
var HSb, ISb, JSb, KSb, LSb;
var bP = jeb(wve, 'RectilinearConvexHull', 1650);
Ycb(565, 1, {
    374: 1
}, ZSb);
_._e = function $Sb(a) {
    YSb(this, JD(a, 143));
};
_.b = 0;
var WSb;
var WO = jeb(wve, 'RectilinearConvexHull/MaximalElementsEventHandler', 565);
Ycb(1652, 1, Bte, aTb);
_.Le = function bTb(a, b) {
    return _Sb(MD(a), MD(b));
};
_.Fb = function cTb(a) {
    return this === a;
};
_.Me = function dTb() {
    return new uqb(this);
};
var VO = jeb(wve, 'RectilinearConvexHull/MaximalElementsEventHandler/lambda$0$Type', 1652);
Ycb(1651, 1, {
    374: 1
}, fTb);
_._e = function gTb(a) {
    eTb(this, JD(a, 143));
};
_.a = 0;
_.b = null;
_.c = null;
_.d = null;
_.e = null;
var XO = jeb(wve, 'RectilinearConvexHull/RectangleEventHandler', 1651);
Ycb(1653, 1, Bte, hTb);
_.Le = function iTb(a, b) {
    return QSb(JD(a, 143), JD(b, 143));
};
_.Fb = function jTb(a) {
    return this === a;
};
_.Me = function kTb() {
    return new uqb(this);
};
var YO = jeb(wve, 'RectilinearConvexHull/lambda$0$Type', 1653);
Ycb(1654, 1, Bte, lTb);
_.Le = function mTb(a, b) {
    return RSb(JD(a, 143), JD(b, 143));
};
_.Fb = function nTb(a) {
    return this === a;
};
_.Me = function oTb() {
    return new uqb(this);
};
var ZO = jeb(wve, 'RectilinearConvexHull/lambda$1$Type', 1654);
Ycb(1655, 1, Bte, pTb);
_.Le = function qTb(a, b) {
    return SSb(JD(a, 143), JD(b, 143));
};
_.Fb = function rTb(a) {
    return this === a;
};
_.Me = function sTb() {
    return new uqb(this);
};
var $O = jeb(wve, 'RectilinearConvexHull/lambda$2$Type', 1655);
Ycb(1656, 1, Bte, tTb);
_.Le = function uTb(a, b) {
    return TSb(JD(a, 143), JD(b, 143));
};
_.Fb = function vTb(a) {
    return this === a;
};
_.Me = function wTb() {
    return new uqb(this);
};
var _O = jeb(wve, 'RectilinearConvexHull/lambda$3$Type', 1656);
Ycb(1657, 1, Bte, xTb);
_.Le = function yTb(a, b) {
    return USb(JD(a, 143), JD(b, 143));
};
_.Fb = function zTb(a) {
    return this === a;
};
_.Me = function ATb() {
    return new uqb(this);
};
var aP = jeb(wve, 'RectilinearConvexHull/lambda$4$Type', 1657);
Ycb(1658, 1, {}, CTb);
var dP = jeb(wve, 'Scanline', 1658);
Ycb(2050, 1, {});
var eP = jeb(xve, 'AbstractGraphPlacer', 2050);
Ycb(331, 1, {
    331: 1
}, MTb);
_.Df = function NTb(a) {
    if (this.Ef(a)) {
        Rc(this.b, JD(WMb(a, (Iqc(), Qpc)), 22), a);
        return true;
    } else return false;
};
_.Ef = function OTb(a) {
    var b, c, d, e;
    b = JD(WMb(a, (Iqc(), Qpc)), 22);
    e = JD(Qc(ITb, b), 22);
    for(d = e.Jc(); d.Ob();){
        c = JD(d.Pb(), 22);
        if (!JD(Qc(this.b, c), 15).dc()) return false;
    }
    return true;
};
var ITb;
var hP = jeb(xve, 'ComponentGroup', 331);
Ycb(761, 2050, {}, TTb);
_.Ff = function UTb(a) {
    var b, c;
    for(c = new rmb(this.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 331);
        if (b.Df(a)) return;
    }
    Ilb(this.a, new MTb(a));
};
_.Cf = function VTb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    this.a.c.length = 0;
    b.a.c.length = 0;
    if (a.dc()) {
        b.f.a = 0;
        b.f.b = 0;
        return;
    }
    g = JD(a.Xb(0), 36);
    UMb(b, g);
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 36);
        this.Ff(d);
    }
    o = new Cdd;
    f = Beb(MD(WMb(g, (Bwc(), Vvc))));
    for(j = new rmb(this.a); j.a < j.c.c.length;){
        h = JD(pmb(j), 331);
        k = PTb(h, f);
        HTb(Uc(h.b), o.a, o.b);
        o.a += k.a;
        o.b += k.b;
    }
    b.f.a = o.a - f;
    b.f.b = o.b - f;
    if (ydb(LD(WMb(g, Vtc))) && XD(WMb(g, yuc)) === XD((xhd(), thd))) {
        for(n = a.Jc(); n.Ob();){
            l = JD(n.Pb(), 36);
            GTb(l, l.c.a, l.c.b);
        }
        c = new tUb;
        jUb(c, a, f);
        for(m = a.Jc(); m.Ob();){
            l = JD(m.Pb(), 36);
            mdd(vdd(l.c), c.e);
        }
        mdd(vdd(b.f), c.a);
    }
    for(i = new rmb(this.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 331);
        FTb(b, Uc(h.b));
    }
};
var fP = jeb(xve, 'ComponentGroupGraphPlacer', 761);
Ycb(1265, 761, {}, XTb);
_.Ff = function YTb(a) {
    WTb(this, a);
};
_.Cf = function ZTb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    this.a.c.length = 0;
    b.a.c.length = 0;
    if (a.dc()) {
        b.f.a = 0;
        b.f.b = 0;
        return;
    }
    g = JD(a.Xb(0), 36);
    UMb(b, g);
    for(e = a.Jc(); e.Ob();){
        d = JD(e.Pb(), 36);
        WTb(this, d);
    }
    t = new Cdd;
    s = new Cdd;
    p = new Cdd;
    o = new Cdd;
    f = Beb(MD(WMb(g, (Bwc(), Vvc))));
    for(j = new rmb(this.a); j.a < j.c.c.length;){
        h = JD(pmb(j), 331);
        if (Ugd(JD(WMb(b, (Lgd(), $ed)), 86))) {
            p.a = t.a;
            for(r = new Yv(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                q = JD(Xv(r.b.Pb()), 22);
                if (q.Gc((Rjd(), xjd))) {
                    p.a = s.a;
                    break;
                }
            }
        } else if (Vgd(JD(WMb(b, $ed), 86))) {
            p.b = t.b;
            for(r = new Yv(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                q = JD(Xv(r.b.Pb()), 22);
                if (q.Gc((Rjd(), Qjd))) {
                    p.b = s.b;
                    break;
                }
            }
        }
        k = PTb(JD(h, 561), f);
        HTb(Uc(h.b), p.a, p.b);
        if (Ugd(JD(WMb(b, $ed), 86))) {
            s.a = p.a + k.a;
            o.a = $wnd.Math.max(o.a, s.a);
            for(r = new Yv(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                q = JD(Xv(r.b.Pb()), 22);
                if (q.Gc((Rjd(), Ojd))) {
                    t.a = p.a + k.a;
                    break;
                }
            }
            s.b = p.b + k.b;
            p.b = s.b;
            o.b = $wnd.Math.max(o.b, p.b);
        } else if (Vgd(JD(WMb(b, $ed), 86))) {
            s.b = p.b + k.b;
            o.b = $wnd.Math.max(o.b, s.b);
            for(r = new Yv(Pc(Fc(h.b).a).a.kc()); r.b.Ob();){
                q = JD(Xv(r.b.Pb()), 22);
                if (q.Gc((Rjd(), wjd))) {
                    t.b = p.b + k.b;
                    break;
                }
            }
            s.a = p.a + k.a;
            p.a = s.a;
            o.a = $wnd.Math.max(o.a, p.a);
        }
    }
    b.f.a = o.a - f;
    b.f.b = o.b - f;
    if (ydb(LD(WMb(g, Vtc))) && XD(WMb(g, yuc)) === XD((xhd(), thd))) {
        for(n = a.Jc(); n.Ob();){
            l = JD(n.Pb(), 36);
            GTb(l, l.c.a, l.c.b);
        }
        c = new tUb;
        jUb(c, a, f);
        for(m = a.Jc(); m.Ob();){
            l = JD(m.Pb(), 36);
            mdd(vdd(l.c), c.e);
        }
        mdd(vdd(b.f), c.a);
    }
    for(i = new rmb(this.a); i.a < i.c.c.length;){
        h = JD(pmb(i), 331);
        FTb(b, Uc(h.b));
    }
};
var gP = jeb(xve, 'ComponentGroupModelOrderGraphPlacer', 1265);
Ycb(381, 23, {
    3: 1,
    34: 1,
    23: 1,
    381: 1
}, dUb);
var $Tb, _Tb, aUb, bUb;
var iP = keb(xve, 'ComponentOrderingStrategy', 381, MI, fUb, eUb);
var gUb;
Ycb(643, 1, {}, tUb);
var qP = jeb(xve, 'ComponentsCompactor', 643);
Ycb(1473, 13, Yse, wUb);
_.Ec = function xUb(a) {
    return uUb(this, JD(a, 143));
};
var jP = jeb(xve, 'ComponentsCompactor/Hullpoints', 1473);
Ycb(1470, 1, {
    834: 1
}, zUb);
_.a = false;
var kP = jeb(xve, 'ComponentsCompactor/InternalComponent', 1470);
Ycb(1469, 1, pre, AUb);
_.Ic = function BUb(a) {
    ofb(this, a);
};
_.Jc = function CUb() {
    return new rmb(this.a);
};
var lP = jeb(xve, 'ComponentsCompactor/InternalConnectedComponents', 1469);
Ycb(1472, 1, {
    586: 1
}, DUb);
_.zf = function FUb() {
    return null;
};
_.Af = function GUb() {
    return this.a;
};
_.yf = function EUb() {
    return pUb(this.d);
};
_.Bf = function HUb() {
    return this.b;
};
var mP = jeb(xve, 'ComponentsCompactor/InternalExternalExtension', 1472);
Ycb(1471, 1, {
    586: 1
}, IUb);
_.Af = function LUb() {
    return this.a;
};
_.yf = function JUb() {
    return pUb(this.d);
};
_.zf = function KUb() {
    return this.c;
};
_.Bf = function MUb() {
    return this.b;
};
var nP = jeb(xve, 'ComponentsCompactor/InternalUnionExternalExtension', 1471);
Ycb(1475, 1, {}, NUb);
var oP = jeb(xve, 'ComponentsCompactor/OuterSegments', 1475);
Ycb(1474, 1, {}, OUb);
var pP = jeb(xve, 'ComponentsCompactor/Segments', 1474);
Ycb(1242, 1, {}, SUb);
var sP = jeb(xve, que, 1242);
Ycb(1243, 1, Bte, UUb);
_.Le = function VUb(a, b) {
    return TUb(JD(a, 36), JD(b, 36));
};
_.Fb = function WUb(a) {
    return this === a;
};
_.Me = function XUb() {
    return new uqb(this);
};
var rP = jeb(xve, 'ComponentsProcessor/lambda$0$Type', 1243);
Ycb(561, 331, {
    331: 1,
    561: 1
}, aVb);
_.Df = function bVb(a) {
    return $Ub(this, a);
};
_.Ef = function cVb(a) {
    return _Ub(this, a);
};
var YUb;
var tP = jeb(xve, 'ModelOrderComponentGroup', 561);
Ycb(1263, 2050, {}, dVb);
_.Cf = function eVb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    if (a.gc() == 1) {
        l = JD(a.Xb(0), 36);
        if (l != b) {
            b.a.c.length = 0;
            ETb(b, l, 0, 0);
            UMb(b, l);
            MXb(b.d, l.d);
            b.f.a = l.f.a;
            b.f.b = l.f.b;
        }
        return;
    } else if (a.dc()) {
        b.a.c.length = 0;
        b.f.a = 0;
        b.f.b = 0;
        return;
    }
    this.Hf(a, b);
    e = JD(a.Xb(0), 36);
    b.a.c.length = 0;
    UMb(b, e);
    j = 0;
    m = 0;
    for(g = a.Jc(); g.Ob();){
        f = JD(g.Pb(), 36);
        k = f.f;
        j = $wnd.Math.max(j, k.a);
        m += k.a * k.b;
    }
    j = $wnd.Math.max(j, $wnd.Math.sqrt(m) * Beb(MD(WMb(b, (Bwc(), Ttc)))));
    d = Beb(MD(WMb(b, Vvc)));
    this.Gf(a, b, j, d);
    if (ydb(LD(WMb(e, Vtc)))) {
        c = new tUb;
        jUb(c, a, d);
        for(i = a.Jc(); i.Ob();){
            h = JD(i.Pb(), 36);
            mdd(vdd(h.c), c.e);
        }
        mdd(vdd(b.f), c.a);
    }
    FTb(b, a);
};
_.Gf = function fVb(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    k = 0;
    l = 0;
    h = 0;
    e = d;
    for(g = a.Jc(); g.Ob();){
        f = JD(g.Pb(), 36);
        j = f.f;
        if (k + j.a > c) {
            k = 0;
            l += h + d;
            h = 0;
        }
        i = f.c;
        GTb(f, k + i.a, l + i.b);
        vdd(i);
        e = $wnd.Math.max(e, k + j.a);
        h = $wnd.Math.max(h, j.b);
        k += j.a + d;
    }
    b.f.a = e;
    b.f.b = l + h;
};
_.Hf = function gVb(a, b) {
    var c, d, e, f, g;
    if (XD(WMb(b, (Bwc(), Ytc))) === XD((cUb(), bUb))) {
        for(d = a.Jc(); d.Ob();){
            c = JD(d.Pb(), 36);
            g = 0;
            for(f = new rmb(c.a); f.a < f.c.c.length;){
                e = JD(pmb(f), 9);
                g += JD(WMb(e, Mvc), 17).a;
            }
            c.p = g;
        }
        pnb();
        a.gd(new lVb);
    }
};
var wP = jeb(xve, 'SimpleRowGraphPlacer', 1263);
Ycb(1266, 1263, {}, hVb);
_.Gf = function iVb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    m = 0;
    n = 0;
    h = 0;
    e = d;
    i = null;
    l = 0;
    for(g = a.Jc(); g.Ob();){
        f = JD(g.Pb(), 36);
        k = f.f;
        if (m + k.a > c && !JD(WMb(f, (Iqc(), Qpc)), 22).Gc((Rjd(), xjd)) || !!i && JD(WMb(i, (Iqc(), Qpc)), 22).Gc((Rjd(), wjd)) || JD(WMb(f, (Iqc(), Qpc)), 22).Gc((Rjd(), Qjd))) {
            m = l;
            n += h + d;
            h = 0;
        }
        j = f.c;
        JD(WMb(f, (Iqc(), Qpc)), 22).Gc((Rjd(), xjd)) && (m = e + d);
        GTb(f, m + j.a, n + j.b);
        e = $wnd.Math.max(e, m + k.a);
        JD(WMb(f, Qpc), 22).Gc(Ojd) && (l = $wnd.Math.max(l, m + k.a + d));
        vdd(j);
        h = $wnd.Math.max(h, k.b);
        m += k.a + d;
        i = f;
    }
    b.f.a = e;
    b.f.b = n + h;
};
_.Hf = function jVb(a, b) {};
var uP = jeb(xve, 'ModelOrderRowGraphPlacer', 1266);
Ycb(1264, 1, Bte, lVb);
_.Le = function mVb(a, b) {
    return kVb(JD(a, 36), JD(b, 36));
};
_.Fb = function nVb(a) {
    return this === a;
};
_.Me = function oVb() {
    return new uqb(this);
};
var vP = jeb(xve, 'SimpleRowGraphPlacer/1', 1264);
var pVb;
Ycb(1240, 1, Tte, vVb);
_.Lb = function wVb(a) {
    var b;
    return b = JD(WMb(JD(a, 248).b, (Bwc(), Ruc)), 77), !!b && b.b != 0;
};
_.Fb = function xVb(a) {
    return this === a;
};
_.Mb = function yVb(a) {
    var b;
    return b = JD(WMb(JD(a, 248).b, (Bwc(), Ruc)), 77), !!b && b.b != 0;
};
var xP = jeb(Cve, 'CompoundGraphPostprocessor/1', 1240);
Ycb(1239, 1, Dve, OVb);
_.If = function PVb(a, b) {
    IVb(this, JD(a, 36), b);
};
var zP = jeb(Cve, 'CompoundGraphPreprocessor', 1239);
Ycb(441, 1, {
    441: 1
}, QVb);
_.c = false;
var yP = jeb(Cve, 'CompoundGraphPreprocessor/ExternalPort', 441);
Ycb(248, 1, {
    248: 1
}, TVb);
_.Ib = function UVb() {
    return ls(this.c) + ':' + jWb(this.b);
};
var BP = jeb(Cve, 'CrossHierarchyEdge', 248);
Ycb(759, 1, Bte, WVb);
_.Le = function XVb(a, b) {
    return VVb(this, JD(a, 248), JD(b, 248));
};
_.Fb = function YVb(a) {
    return this === a;
};
_.Me = function $Vb() {
    return new uqb(this);
};
var AP = jeb(Cve, 'CrossHierarchyEdgeComparator', 759);
Ycb(306, 148, {
    3: 1,
    306: 1,
    102: 1,
    148: 1
});
_.p = 0;
var LP = jeb(Eve, 'LGraphElement', 306);
Ycb(18, 306, {
    3: 1,
    18: 1,
    306: 1,
    102: 1,
    148: 1
}, kWb);
_.Ib = function lWb() {
    return jWb(this);
};
var CP = jeb(Eve, 'LEdge', 18);
Ycb(36, 306, {
    3: 1,
    20: 1,
    36: 1,
    306: 1,
    102: 1,
    148: 1
}, nWb);
_.Ic = function oWb(a) {
    ofb(this, a);
};
_.Jc = function pWb() {
    return new rmb(this.b);
};
_.Ib = function qWb() {
    if (this.b.c.length == 0) return 'G-unlayered' + Ee(this.a);
    else if (this.a.c.length == 0) return 'G-layered' + Ee(this.b);
    return 'G[layerless' + Ee(this.a) + ', layers' + Ee(this.b) + ']';
};
var MP = jeb(Eve, 'LGraph', 36);
var rWb;
Ycb(650, 1, {});
_.Jf = function tWb() {
    return this.e.n;
};
_.mf = function uWb(a) {
    return WMb(this.e, a);
};
_.Kf = function vWb() {
    return this.e.o;
};
_.Lf = function wWb() {
    return this.e.p;
};
_.nf = function xWb(a) {
    return XMb(this.e, a);
};
_.Mf = function yWb(a) {
    this.e.n.a = a.a;
    this.e.n.b = a.b;
};
_.Nf = function zWb(a) {
    this.e.o.a = a.a;
    this.e.o.b = a.b;
};
_.Of = function AWb(a) {
    this.e.p = a;
};
var DP = jeb(Eve, 'LGraphAdapters/AbstractLShapeAdapter', 650);
Ycb(460, 1, {
    832: 1
}, BWb);
_.Pf = function CWb() {
    var a, b;
    if (!this.b) {
        this.b = av(this.a.b.c.length);
        for(b = new rmb(this.a.b); b.a < b.c.c.length;){
            a = JD(pmb(b), 72);
            Ilb(this.b, new NWb(a));
        }
    }
    return this.b;
};
_.b = null;
var EP = jeb(Eve, 'LGraphAdapters/LEdgeAdapter', 460);
Ycb(649, 1, {}, DWb);
_.Qf = function EWb() {
    var a, b, c, d, e, f;
    if (!this.b) {
        this.b = new Ulb;
        for(d = new rmb(this.a.b); d.a < d.c.c.length;){
            c = JD(pmb(d), 25);
            for(f = new rmb(c.a); f.a < f.c.c.length;){
                e = JD(pmb(f), 9);
                if (this.c.Mb(e)) {
                    Ilb(this.b, new PWb(this, e, this.e));
                    if (this.d) {
                        if (XMb(e, (Iqc(), Hqc))) for(b = JD(WMb(e, Hqc), 15).Jc(); b.Ob();){
                            a = JD(b.Pb(), 9);
                            Ilb(this.b, new PWb(this, a, false));
                        }
                        if (XMb(e, Fpc)) for(b = JD(WMb(e, Fpc), 15).Jc(); b.Ob();){
                            a = JD(b.Pb(), 9);
                            Ilb(this.b, new PWb(this, a, false));
                        }
                    }
                }
            }
        }
    }
    return this.b;
};
_.Jf = function FWb() {
    throw scb(new bhb(Gve));
};
_.mf = function GWb(a) {
    return WMb(this.a, a);
};
_.Kf = function HWb() {
    return this.a.f;
};
_.Lf = function IWb() {
    return this.a.p;
};
_.nf = function JWb(a) {
    return XMb(this.a, a);
};
_.Mf = function KWb(a) {
    throw scb(new bhb(Gve));
};
_.Nf = function LWb(a) {
    this.a.f.a = a.a;
    this.a.f.b = a.b;
};
_.Of = function MWb(a) {
    this.a.p = a;
};
_.b = null;
_.d = false;
_.e = false;
var FP = jeb(Eve, 'LGraphAdapters/LGraphAdapter', 649);
Ycb(567, 650, {
    187: 1
}, NWb);
var GP = jeb(Eve, 'LGraphAdapters/LLabelAdapter', 567);
Ycb(566, 650, {
    680: 1
}, PWb);
_.Rf = function QWb() {
    return this.b;
};
_.Sf = function RWb() {
    return pnb(), pnb(), mnb;
};
_.Pf = function SWb() {
    var a, b;
    if (!this.a) {
        this.a = av(JD(this.e, 9).b.c.length);
        for(b = new rmb(JD(this.e, 9).b); b.a < b.c.c.length;){
            a = JD(pmb(b), 72);
            Ilb(this.a, new NWb(a));
        }
    }
    return this.a;
};
_.Tf = function TWb() {
    var a;
    a = JD(this.e, 9).d;
    return new _Xb(a.d, a.c, a.a, a.b);
};
_.Uf = function UWb() {
    return pnb(), pnb(), mnb;
};
_.Vf = function VWb() {
    var a, b;
    if (!this.c) {
        this.c = av(JD(this.e, 9).j.c.length);
        for(b = new rmb(JD(this.e, 9).j); b.a < b.c.c.length;){
            a = JD(pmb(b), 11);
            Ilb(this.c, new $Wb(a, this.d));
        }
    }
    return this.c;
};
_.Wf = function WWb() {
    return ydb(LD(WMb(JD(this.e, 9), (Iqc(), Ipc))));
};
_.Xf = function XWb(a) {
    JD(this.e, 9).d.b = a.b;
    JD(this.e, 9).d.d = a.d;
    JD(this.e, 9).d.c = a.c;
    JD(this.e, 9).d.a = a.a;
};
_.Yf = function YWb(a) {
    JD(this.e, 9).f.b = a.b;
    JD(this.e, 9).f.d = a.d;
    JD(this.e, 9).f.c = a.c;
    JD(this.e, 9).f.a = a.a;
};
_.Zf = function ZWb() {
    OWb(this, (sWb(), rWb));
};
_.a = null;
_.b = null;
_.c = null;
_.d = false;
var HP = jeb(Eve, 'LGraphAdapters/LNodeAdapter', 566);
Ycb(1734, 650, {
    831: 1
}, $Wb);
_.Sf = function _Wb() {
    var a, b, c, d, e, f, g, h;
    if (this.d && JD(this.e, 11).i.k == (DYb(), BYb)) return pnb(), pnb(), mnb;
    else if (!this.a) {
        this.a = new Ulb;
        for(c = new rmb(JD(this.e, 11).e); c.a < c.c.c.length;){
            a = JD(pmb(c), 18);
            Ilb(this.a, new BWb(a));
        }
        if (this.d) {
            d = JD(WMb(JD(this.e, 11), (Iqc(), sqc)), 9);
            if (d) for(b = new es(Ir(hYb(d).a.Jc(), new er)); cs(b);){
                a = JD(ds(b), 18);
                Ilb(this.a, new BWb(a));
            }
        }
        if (XMb(JD(this.e, 11).i, (Iqc(), zqc))) {
            g = JD(WMb(JD(this.e, 11).i, zqc), 333);
            h = JD(Tsb(g.e, this.e), 112);
            if (h) for(f = new rmb(h.b); f.a < f.c.c.length;){
                e = JD(pmb(f), 336);
                Ilb(this.a, new BWb(e.a));
            }
        }
    }
    return this.a;
};
_.Pf = function aXb() {
    var a, b;
    if (!this.b) {
        this.b = av(JD(this.e, 11).f.c.length);
        for(b = new rmb(JD(this.e, 11).f); b.a < b.c.c.length;){
            a = JD(pmb(b), 72);
            Ilb(this.b, new NWb(a));
        }
    }
    return this.b;
};
_.Uf = function bXb() {
    var a, b, c, d, e, f, g, h;
    if (this.d && JD(this.e, 11).i.k == (DYb(), BYb)) return pnb(), pnb(), mnb;
    else if (!this.c) {
        this.c = new Ulb;
        for(c = new rmb(JD(this.e, 11).g); c.a < c.c.c.length;){
            a = JD(pmb(c), 18);
            Ilb(this.c, new BWb(a));
        }
        if (this.d) {
            d = JD(WMb(JD(this.e, 11), (Iqc(), sqc)), 9);
            if (d) for(b = new es(Ir(kYb(d).a.Jc(), new er)); cs(b);){
                a = JD(ds(b), 18);
                Ilb(this.c, new BWb(a));
            }
        }
        if (XMb(JD(this.e, 11).i, (Iqc(), zqc))) {
            g = JD(WMb(JD(this.e, 11).i, zqc), 333);
            h = JD(Tsb(g.e, this.e), 112);
            if (h) for(f = new rmb(h.e); f.a < f.c.c.length;){
                e = JD(pmb(f), 336);
                Ilb(this.c, new BWb(e.a));
            }
        }
    }
    return this.c;
};
_.$f = function cXb() {
    return JD(this.e, 11).j;
};
_._f = function dXb() {
    return ydb(LD(WMb(JD(this.e, 11), (Iqc(), Zpc))));
};
_.a = null;
_.b = null;
_.c = null;
_.d = false;
var IP = jeb(Eve, 'LGraphAdapters/LPortAdapter', 1734);
Ycb(1735, 1, Bte, fXb);
_.Le = function gXb(a, b) {
    return eXb(JD(a, 11), JD(b, 11));
};
_.Fb = function hXb(a) {
    return this === a;
};
_.Me = function iXb() {
    return new uqb(this);
};
var JP = jeb(Eve, 'LGraphAdapters/PortComparator', 1735);
Ycb(798, 1, Ire, jXb);
_.Mb = function kXb(a) {
    return JD(a, 9), sWb(), true;
};
var KP = jeb(Eve, 'LGraphAdapters/lambda$0$Type', 798);
Ycb(395, 306, {
    3: 1,
    306: 1,
    395: 1,
    102: 1,
    148: 1
});
var eQ = jeb(Eve, 'LShape', 395);
Ycb(72, 395, {
    3: 1,
    306: 1,
    72: 1,
    395: 1,
    102: 1,
    148: 1
}, HXb, IXb);
_.Ib = function JXb() {
    var a;
    a = GXb(this);
    return a == null ? 'label' : 'l_' + a;
};
var NP = jeb(Eve, 'LLabel', 72);
Ycb(213, 1, {
    3: 1,
    4: 1,
    213: 1,
    411: 1
});
_.Fb = function UXb(a) {
    var b;
    if (RD(a, 213)) {
        b = JD(a, 213);
        return this.d == b.d && this.a == b.a && this.b == b.b && this.c == b.c;
    } else return false;
};
_.Hb = function VXb() {
    var a, b;
    a = Eeb(this.b) << 16;
    a |= Eeb(this.a) & Wre;
    b = Eeb(this.c) << 16;
    b |= Eeb(this.d) & Wre;
    return a ^ b;
};
_.ag = function XXb(b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    g = 0;
    while(g < b.length && WXb((ADb(g, b.length), b.charCodeAt(g)), Lve))++g;
    c = b.length;
    while(c > 0 && WXb((ADb(c - 1, b.length), b.charCodeAt(c - 1)), Mve))--c;
    if (g < c) {
        l = mgb((zDb(g, c, b.length), b.substr(g, c - g)), ',|;');
        try {
            for(i = l, j = 0, k = i.length; j < k; ++j){
                h = i[j];
                f = mgb(h, '=');
                if (f.length != 2) throw scb(new Teb('Expecting a list of key-value pairs.'));
                e = ugb(f[0]);
                m = Edb(ugb(f[1]));
                cgb(e, 'top') ? this.d = m : cgb(e, 'left') ? this.b = m : cgb(e, 'bottom') ? this.a = m : cgb(e, 'right') && (this.c = m);
            }
        } catch (a) {
            a = rcb(a);
            if (RD(a, 130)) {
                d = a;
                throw scb(new Teb(Nve + d));
            } else throw scb(a);
        }
    }
};
_.Ib = function YXb() {
    return '[top=' + this.d + ',left=' + this.b + ',bottom=' + this.a + ',right=' + this.c + ']';
};
_.a = 0;
_.b = 0;
_.c = 0;
_.d = 0;
var c2 = jeb(Ove, 'Spacing', 213);
Ycb(139, 213, Pve, ZXb, $Xb, _Xb, aYb);
var Z1 = jeb(Ove, 'ElkMargin', 139);
Ycb(644, 139, Pve, bYb);
var OP = jeb(Eve, 'LMargin', 644);
Ycb(9, 395, {
    3: 1,
    306: 1,
    9: 1,
    395: 1,
    102: 1,
    148: 1
}, tYb);
_.Ib = function uYb() {
    return sYb(this);
};
_.i = false;
var RP = jeb(Eve, 'LNode', 9);
Ycb(247, 23, {
    3: 1,
    34: 1,
    23: 1,
    247: 1
}, EYb);
var vYb, wYb, xYb, yYb, zYb, AYb, BYb, CYb;
var PP = keb(Eve, 'LNode/NodeType', 247, MI, GYb, FYb);
var HYb;
Ycb(757, 1, Ire, JYb);
_.Mb = function KYb(a) {
    return ydb(LD(WMb(JD(a, 72), (Bwc(), vuc))));
};
var QP = jeb(Eve, 'LNode/lambda$0$Type', 757);
Ycb(107, 213, Qve, LYb, MYb, NYb);
var $1 = jeb(Ove, 'ElkPadding', 107);
Ycb(760, 107, Qve, OYb);
var SP = jeb(Eve, 'LPadding', 760);
Ycb(11, 395, {
    3: 1,
    306: 1,
    11: 1,
    395: 1,
    102: 1,
    148: 1
}, bZb);
_.Ib = function cZb() {
    var a, b, c;
    a = new Ugb;
    Qgb((a.a += 'p_', a), YYb(this));
    !!this.i && Qgb(Pgb((a.a += '[', a), this.i), ']');
    if (this.e.c.length == 1 && this.g.c.length == 0 && JD(Mlb(this.e, 0), 18).c != this) {
        b = JD(Mlb(this.e, 0), 18).c;
        Qgb((a.a += ' << ', a), YYb(b));
        Qgb(Pgb((a.a += '[', a), b.i), ']');
    }
    if (this.e.c.length == 0 && this.g.c.length == 1 && JD(Mlb(this.g, 0), 18).d != this) {
        c = JD(Mlb(this.g, 0), 18).d;
        Qgb((a.a += ' >> ', a), YYb(c));
        Qgb(Pgb((a.a += '[', a), c.i), ']');
    }
    return a.a;
};
_.c = true;
_.d = false;
var PYb, QYb, RYb, SYb, TYb, UYb;
var dQ = jeb(Eve, 'LPort', 11);
Ycb(397, 1, pre, dZb);
_.Ic = function eZb(a) {
    ofb(this, a);
};
_.Jc = function fZb() {
    var a;
    a = new rmb(this.a.e);
    return new gZb(a);
};
var UP = jeb(Eve, 'LPort/1', 397);
Ycb(1262, 1, Wqe, gZb);
_.Nb = function hZb(a) {
    Osb(this, a);
};
_.Pb = function jZb() {
    return JD(pmb(this.a), 18).c;
};
_.Ob = function iZb() {
    return omb(this.a);
};
_.Qb = function kZb() {
    qmb(this.a);
};
var TP = jeb(Eve, 'LPort/1/1', 1262);
Ycb(362, 1, pre, lZb);
_.Ic = function mZb(a) {
    ofb(this, a);
};
_.Jc = function nZb() {
    var a;
    return a = new rmb(this.a.g), new oZb(a);
};
var WP = jeb(Eve, 'LPort/2', 362);
Ycb(758, 1, Wqe, oZb);
_.Nb = function pZb(a) {
    Osb(this, a);
};
_.Pb = function rZb() {
    return JD(pmb(this.a), 18).d;
};
_.Ob = function qZb() {
    return omb(this.a);
};
_.Qb = function sZb() {
    qmb(this.a);
};
var VP = jeb(Eve, 'LPort/2/1', 758);
Ycb(1255, 1, pre, tZb);
_.Ic = function uZb(a) {
    ofb(this, a);
};
_.Jc = function vZb() {
    return new xZb(this);
};
var YP = jeb(Eve, 'LPort/CombineIter', 1255);
Ycb(207, 1, Wqe, xZb);
_.Nb = function yZb(a) {
    Osb(this, a);
};
_.Qb = function BZb() {
    Psb();
};
_.Ob = function zZb() {
    return wZb(this);
};
_.Pb = function AZb() {
    return omb(this.a) ? pmb(this.a) : pmb(this.b);
};
var XP = jeb(Eve, 'LPort/CombineIter/1', 207);
Ycb(1256, 1, Tte, DZb);
_.Lb = function EZb(a) {
    return CZb(a);
};
_.Fb = function FZb(a) {
    return this === a;
};
_.Mb = function GZb(a) {
    return VYb(), JD(a, 11).g.c.length != 0;
};
var ZP = jeb(Eve, 'LPort/lambda$0$Type', 1256);
Ycb(1257, 1, Tte, IZb);
_.Lb = function JZb(a) {
    return HZb(a);
};
_.Fb = function KZb(a) {
    return this === a;
};
_.Mb = function LZb(a) {
    return VYb(), JD(a, 11).e.c.length != 0;
};
var $P = jeb(Eve, 'LPort/lambda$1$Type', 1257);
Ycb(1258, 1, Tte, MZb);
_.Lb = function NZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), xjd);
};
_.Fb = function OZb(a) {
    return this === a;
};
_.Mb = function PZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), xjd);
};
var _P = jeb(Eve, 'LPort/lambda$2$Type', 1258);
Ycb(1259, 1, Tte, QZb);
_.Lb = function RZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), wjd);
};
_.Fb = function SZb(a) {
    return this === a;
};
_.Mb = function TZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), wjd);
};
var aQ = jeb(Eve, 'LPort/lambda$3$Type', 1259);
Ycb(1260, 1, Tte, UZb);
_.Lb = function VZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), Ojd);
};
_.Fb = function WZb(a) {
    return this === a;
};
_.Mb = function XZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), Ojd);
};
var bQ = jeb(Eve, 'LPort/lambda$4$Type', 1260);
Ycb(1261, 1, Tte, YZb);
_.Lb = function ZZb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), Qjd);
};
_.Fb = function $Zb(a) {
    return this === a;
};
_.Mb = function _Zb(a) {
    return VYb(), JD(a, 11).j == (Rjd(), Qjd);
};
var cQ = jeb(Eve, 'LPort/lambda$5$Type', 1261);
Ycb(25, 306, {
    3: 1,
    20: 1,
    306: 1,
    25: 1,
    102: 1,
    148: 1
}, b$b);
_.Ic = function c$b(a) {
    ofb(this, a);
};
_.Jc = function d$b() {
    return new rmb(this.a);
};
_.Ib = function e$b() {
    return 'L_' + Nlb(this.b.b, this, 0) + Ee(this.a);
};
var fQ = jeb(Eve, 'Layer', 25);
Ycb(1271, 1, {}, w$b);
var pQ = jeb(Rve, Sve, 1271);
Ycb(1275, 1, {}, A$b);
_.Kb = function B$b(a) {
    return _Bd(JD(a, 84));
};
var gQ = jeb(Rve, 'ElkGraphImporter/0methodref$connectableShapeToNode$Type', 1275);
Ycb(1278, 1, {}, C$b);
_.Kb = function D$b(a) {
    return _Bd(JD(a, 84));
};
var hQ = jeb(Rve, 'ElkGraphImporter/1methodref$connectableShapeToNode$Type', 1278);
Ycb(1272, 1, kre, E$b);
_.Ad = function F$b(a) {
    k$b(this.a, JD(a, 124));
};
var iQ = jeb(Rve, sue, 1272);
Ycb(1273, 1, kre, G$b);
_.Ad = function H$b(a) {
    k$b(this.a, JD(a, 124));
};
var jQ = jeb(Rve, Tve, 1273);
Ycb(1274, 1, {}, I$b);
_.Kb = function J$b(a) {
    return new RBb(null, new Gvb(Qtd(JD(a, 85)), 16));
};
var kQ = jeb(Rve, Uve, 1274);
Ycb(1276, 1, Ire, K$b);
_.Mb = function L$b(a) {
    return x$b(this.a, JD(a, 27));
};
var lQ = jeb(Rve, Vve, 1276);
Ycb(1277, 1, {}, M$b);
_.Kb = function N$b(a) {
    return new RBb(null, new Gvb(Ptd(JD(a, 85)), 16));
};
var mQ = jeb(Rve, 'ElkGraphImporter/lambda$5$Type', 1277);
Ycb(1279, 1, Ire, O$b);
_.Mb = function P$b(a) {
    return y$b(this.a, JD(a, 27));
};
var nQ = jeb(Rve, 'ElkGraphImporter/lambda$7$Type', 1279);
Ycb(1280, 1, Ire, Q$b);
_.Mb = function R$b(a) {
    return z$b(JD(a, 85));
};
var oQ = jeb(Rve, 'ElkGraphImporter/lambda$8$Type', 1280);
Ycb(1250, 1, {}, Z$b);
var S$b;
var uQ = jeb(Rve, 'ElkGraphLayoutTransferrer', 1250);
Ycb(1251, 1, Ire, a_b);
_.Mb = function b_b(a) {
    return $$b(this.a, JD(a, 18));
};
var qQ = jeb(Rve, 'ElkGraphLayoutTransferrer/lambda$0$Type', 1251);
Ycb(1252, 1, kre, c_b);
_.Ad = function d_b(a) {
    T$b();
    Ilb(this.a, JD(a, 18));
};
var rQ = jeb(Rve, 'ElkGraphLayoutTransferrer/lambda$1$Type', 1252);
Ycb(1253, 1, Ire, e_b);
_.Mb = function f_b(a) {
    return _$b(this.a, JD(a, 18));
};
var sQ = jeb(Rve, 'ElkGraphLayoutTransferrer/lambda$2$Type', 1253);
Ycb(1254, 1, kre, g_b);
_.Ad = function h_b(a) {
    T$b();
    Ilb(this.a, JD(a, 18));
};
var tQ = jeb(Rve, 'ElkGraphLayoutTransferrer/lambda$3$Type', 1254);
Ycb(799, 1, {}, q_b);
var vQ = jeb(Wve, 'BiLinkedHashMultiMap', 799);
Ycb(1490, 1, Dve, t_b);
_.If = function u_b(a, b) {
    r_b(JD(a, 36), b);
};
var yQ = jeb(Wve, 'CommentNodeMarginCalculator', 1490);
Ycb(1491, 1, {}, v_b);
_.Kb = function w_b(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var wQ = jeb(Wve, 'CommentNodeMarginCalculator/lambda$0$Type', 1491);
Ycb(1492, 1, kre, x_b);
_.Ad = function y_b(a) {
    s_b(JD(a, 9));
};
var xQ = jeb(Wve, 'CommentNodeMarginCalculator/lambda$1$Type', 1492);
Ycb(1493, 1, Dve, C_b);
_.If = function D_b(a, b) {
    A_b(JD(a, 36), b);
};
var zQ = jeb(Wve, 'CommentPostprocessor', 1493);
Ycb(1494, 1, Dve, H_b);
_.If = function I_b(a, b) {
    E_b(JD(a, 36), b);
};
var AQ = jeb(Wve, 'CommentPreprocessor', 1494);
Ycb(1495, 1, Dve, K_b);
_.If = function L_b(a, b) {
    J_b(JD(a, 36), b);
};
var BQ = jeb(Wve, 'ConstraintsPostprocessor', 1495);
Ycb(1496, 1, Dve, S_b);
_.If = function T_b(a, b) {
    Q_b(JD(a, 36), b);
};
var CQ = jeb(Wve, 'EdgeAndLayerConstraintEdgeReverser', 1496);
Ycb(1497, 1, Dve, W_b);
_.If = function Y_b(a, b) {
    U_b(JD(a, 36), b);
};
var GQ = jeb(Wve, 'EndLabelPostprocessor', 1497);
Ycb(1498, 1, {}, Z_b);
_.Kb = function $_b(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var DQ = jeb(Wve, 'EndLabelPostprocessor/lambda$0$Type', 1498);
Ycb(1499, 1, Ire, __b);
_.Mb = function a0b(a) {
    return X_b(JD(a, 9));
};
var EQ = jeb(Wve, 'EndLabelPostprocessor/lambda$1$Type', 1499);
Ycb(1500, 1, kre, b0b);
_.Ad = function c0b(a) {
    V_b(JD(a, 9));
};
var FQ = jeb(Wve, 'EndLabelPostprocessor/lambda$2$Type', 1500);
Ycb(1501, 1, Dve, n0b);
_.If = function q0b(a, b) {
    j0b(JD(a, 36), b);
};
var NQ = jeb(Wve, 'EndLabelPreprocessor', 1501);
Ycb(1502, 1, {}, r0b);
_.Kb = function s0b(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var HQ = jeb(Wve, 'EndLabelPreprocessor/lambda$0$Type', 1502);
Ycb(1503, 1, kre, t0b);
_.Ad = function u0b(a) {
    f0b(this.a, this.b, this.c, JD(a, 9));
};
_.a = 0;
_.b = 0;
_.c = false;
var IQ = jeb(Wve, 'EndLabelPreprocessor/lambda$1$Type', 1503);
Ycb(1504, 1, Ire, v0b);
_.Mb = function w0b(a) {
    return XD(WMb(JD(a, 72), (Bwc(), wuc))) === XD((nhd(), mhd));
};
var JQ = jeb(Wve, 'EndLabelPreprocessor/lambda$2$Type', 1504);
Ycb(1505, 1, kre, x0b);
_.Ad = function y0b(a) {
    Atb(this.a, JD(a, 72));
};
var KQ = jeb(Wve, 'EndLabelPreprocessor/lambda$3$Type', 1505);
Ycb(1506, 1, Ire, z0b);
_.Mb = function A0b(a) {
    return XD(WMb(JD(a, 72), (Bwc(), wuc))) === XD((nhd(), lhd));
};
var LQ = jeb(Wve, 'EndLabelPreprocessor/lambda$4$Type', 1506);
Ycb(1507, 1, kre, B0b);
_.Ad = function C0b(a) {
    Atb(this.a, JD(a, 72));
};
var MQ = jeb(Wve, 'EndLabelPreprocessor/lambda$5$Type', 1507);
Ycb(1555, 1, Dve, L0b);
_.If = function M0b(a, b) {
    I0b(JD(a, 36), b);
};
var D0b;
var VQ = jeb(Wve, 'EndLabelSorter', 1555);
Ycb(1556, 1, Bte, O0b);
_.Le = function P0b(a, b) {
    return N0b(JD(a, 452), JD(b, 452));
};
_.Fb = function Q0b(a) {
    return this === a;
};
_.Me = function R0b() {
    return new uqb(this);
};
var OQ = jeb(Wve, 'EndLabelSorter/1', 1556);
Ycb(452, 1, {
    452: 1
}, S0b);
var PQ = jeb(Wve, 'EndLabelSorter/LabelGroup', 452);
Ycb(1557, 1, {}, T0b);
_.Kb = function U0b(a) {
    return E0b(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var QQ = jeb(Wve, 'EndLabelSorter/lambda$0$Type', 1557);
Ycb(1558, 1, Ire, V0b);
_.Mb = function W0b(a) {
    return E0b(), JD(a, 9).k == (DYb(), AYb);
};
var RQ = jeb(Wve, 'EndLabelSorter/lambda$1$Type', 1558);
Ycb(1559, 1, kre, X0b);
_.Ad = function Y0b(a) {
    J0b(JD(a, 9));
};
var SQ = jeb(Wve, 'EndLabelSorter/lambda$2$Type', 1559);
Ycb(1560, 1, Ire, Z0b);
_.Mb = function $0b(a) {
    return E0b(), XD(WMb(JD(a, 72), (Bwc(), wuc))) === XD((nhd(), lhd));
};
var TQ = jeb(Wve, 'EndLabelSorter/lambda$3$Type', 1560);
Ycb(1561, 1, Ire, _0b);
_.Mb = function a1b(a) {
    return E0b(), XD(WMb(JD(a, 72), (Bwc(), wuc))) === XD((nhd(), mhd));
};
var UQ = jeb(Wve, 'EndLabelSorter/lambda$4$Type', 1561);
Ycb(1508, 1, Dve, m1b);
_.If = function n1b(a, b) {
    k1b(this, JD(a, 36));
};
_.b = 0;
_.c = 0;
var aR = jeb(Wve, 'FinalSplineBendpointsCalculator', 1508);
Ycb(1509, 1, {}, o1b);
_.Kb = function p1b(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var WQ = jeb(Wve, 'FinalSplineBendpointsCalculator/lambda$0$Type', 1509);
Ycb(1510, 1, {}, q1b);
_.Kb = function r1b(a) {
    return new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var XQ = jeb(Wve, 'FinalSplineBendpointsCalculator/lambda$1$Type', 1510);
Ycb(1511, 1, Ire, s1b);
_.Mb = function t1b(a) {
    return !eWb(JD(a, 18));
};
var YQ = jeb(Wve, 'FinalSplineBendpointsCalculator/lambda$2$Type', 1511);
Ycb(1512, 1, Ire, u1b);
_.Mb = function v1b(a) {
    return XMb(JD(a, 18), (Iqc(), Dqc));
};
var ZQ = jeb(Wve, 'FinalSplineBendpointsCalculator/lambda$3$Type', 1512);
Ycb(1513, 1, kre, w1b);
_.Ad = function x1b(a) {
    d1b(this.a, JD(a, 132));
};
var $Q = jeb(Wve, 'FinalSplineBendpointsCalculator/lambda$4$Type', 1513);
Ycb(1514, 1, kre, y1b);
_.Ad = function z1b(a) {
    vnb(JD(a, 18).a);
};
var _Q = jeb(Wve, 'FinalSplineBendpointsCalculator/lambda$5$Type', 1514);
Ycb(783, 1, Dve, X1b);
_.If = function Y1b(a, b) {
    O1b(this, JD(a, 36), b);
};
var cR = jeb(Wve, 'GraphTransformer', 783);
Ycb(501, 23, {
    3: 1,
    34: 1,
    23: 1,
    501: 1
}, a2b);
var Z1b, $1b;
var bR = keb(Wve, 'GraphTransformer/Mode', 501, MI, c2b, b2b);
var d2b;
Ycb(1515, 1, Dve, j2b);
_.If = function k2b(a, b) {
    g2b(JD(a, 36), b);
};
var dR = jeb(Wve, 'HierarchicalNodeResizingProcessor', 1515);
Ycb(1516, 1, Dve, r2b);
_.If = function s2b(a, b) {
    n2b(JD(a, 36), b);
};
var fR = jeb(Wve, 'HierarchicalPortConstraintProcessor', 1516);
Ycb(1517, 1, Bte, u2b);
_.Le = function v2b(a, b) {
    return t2b(JD(a, 9), JD(b, 9));
};
_.Fb = function w2b(a) {
    return this === a;
};
_.Me = function x2b() {
    return new uqb(this);
};
var eR = jeb(Wve, 'HierarchicalPortConstraintProcessor/NodeComparator', 1517);
Ycb(1518, 1, Dve, A2b);
_.If = function B2b(a, b) {
    y2b(JD(a, 36), b);
};
var gR = jeb(Wve, 'HierarchicalPortDummySizeProcessor', 1518);
Ycb(1519, 1, Dve, O2b);
_.If = function P2b(a, b) {
    H2b(this, JD(a, 36), b);
};
_.a = 0;
var jR = jeb(Wve, 'HierarchicalPortOrthogonalEdgeRouter', 1519);
Ycb(1520, 1, Bte, R2b);
_.Le = function S2b(a, b) {
    return Q2b(JD(a, 9), JD(b, 9));
};
_.Fb = function T2b(a) {
    return this === a;
};
_.Me = function U2b() {
    return new uqb(this);
};
var hR = jeb(Wve, 'HierarchicalPortOrthogonalEdgeRouter/1', 1520);
Ycb(1521, 1, Bte, W2b);
_.Le = function X2b(a, b) {
    return V2b(JD(a, 9), JD(b, 9));
};
_.Fb = function Y2b(a) {
    return this === a;
};
_.Me = function Z2b() {
    return new uqb(this);
};
var iR = jeb(Wve, 'HierarchicalPortOrthogonalEdgeRouter/2', 1521);
Ycb(1522, 1, Dve, a3b);
_.If = function b3b(a, b) {
    _2b(JD(a, 36), b);
};
var kR = jeb(Wve, 'HierarchicalPortPositionProcessor', 1522);
Ycb(1523, 1, Dve, k3b);
_.If = function l3b(a, b) {
    j3b(this, JD(a, 36));
};
_.a = 0;
_.c = 0;
var c3b, d3b;
var oR = jeb(Wve, 'HighDegreeNodeLayeringProcessor', 1523);
Ycb(562, 1, {
    562: 1
}, m3b);
_.b = -1;
_.d = -1;
var lR = jeb(Wve, 'HighDegreeNodeLayeringProcessor/HighDegreeNodeInformation', 562);
Ycb(1524, 1, {}, n3b);
_.Kb = function o3b(a) {
    return e3b(), hYb(JD(a, 9));
};
_.Fb = function p3b(a) {
    return this === a;
};
var mR = jeb(Wve, 'HighDegreeNodeLayeringProcessor/lambda$0$Type', 1524);
Ycb(1525, 1, {}, q3b);
_.Kb = function r3b(a) {
    return e3b(), kYb(JD(a, 9));
};
_.Fb = function s3b(a) {
    return this === a;
};
var nR = jeb(Wve, 'HighDegreeNodeLayeringProcessor/lambda$1$Type', 1525);
Ycb(1531, 1, Dve, y3b);
_.If = function z3b(a, b) {
    x3b(this, JD(a, 36), b);
};
var tR = jeb(Wve, 'HyperedgeDummyMerger', 1531);
Ycb(784, 1, {}, A3b);
_.a = false;
_.b = false;
_.c = false;
var pR = jeb(Wve, 'HyperedgeDummyMerger/MergeState', 784);
Ycb(1532, 1, {}, B3b);
_.Kb = function C3b(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var qR = jeb(Wve, 'HyperedgeDummyMerger/lambda$0$Type', 1532);
Ycb(1533, 1, {}, D3b);
_.Kb = function E3b(a) {
    return new RBb(null, new Gvb(JD(a, 9).j, 16));
};
var rR = jeb(Wve, 'HyperedgeDummyMerger/lambda$1$Type', 1533);
Ycb(1534, 1, kre, F3b);
_.Ad = function G3b(a) {
    JD(a, 11).p = -1;
};
var sR = jeb(Wve, 'HyperedgeDummyMerger/lambda$2$Type', 1534);
Ycb(1535, 1, Dve, J3b);
_.If = function K3b(a, b) {
    I3b(JD(a, 36), b);
};
var uR = jeb(Wve, 'HypernodesProcessor', 1535);
Ycb(1536, 1, Dve, M3b);
_.If = function N3b(a, b) {
    L3b(JD(a, 36), b);
};
var vR = jeb(Wve, 'InLayerConstraintProcessor', 1536);
Ycb(1537, 1, Dve, P3b);
_.If = function Q3b(a, b) {
    O3b(JD(a, 36), b);
};
var wR = jeb(Wve, 'InnermostNodeMarginCalculator', 1537);
Ycb(1538, 1, Dve, U3b);
_.If = function Z3b(a, b) {
    T3b(this, JD(a, 36));
};
_.a = Lse;
_.b = Lse;
_.c = Kse;
_.d = Kse;
var DR = jeb(Wve, 'InteractiveExternalPortPositioner', 1538);
Ycb(1539, 1, {}, $3b);
_.Kb = function _3b(a) {
    return JD(a, 18).d.i;
};
_.Fb = function a4b(a) {
    return this === a;
};
var xR = jeb(Wve, 'InteractiveExternalPortPositioner/lambda$0$Type', 1539);
Ycb(1540, 1, {}, b4b);
_.Kb = function c4b(a) {
    return V3b(this.a, MD(a));
};
_.Fb = function d4b(a) {
    return this === a;
};
var yR = jeb(Wve, 'InteractiveExternalPortPositioner/lambda$1$Type', 1540);
Ycb(1541, 1, {}, e4b);
_.Kb = function f4b(a) {
    return JD(a, 18).c.i;
};
_.Fb = function g4b(a) {
    return this === a;
};
var zR = jeb(Wve, 'InteractiveExternalPortPositioner/lambda$2$Type', 1541);
Ycb(1542, 1, {}, h4b);
_.Kb = function i4b(a) {
    return W3b(this.a, MD(a));
};
_.Fb = function j4b(a) {
    return this === a;
};
var AR = jeb(Wve, 'InteractiveExternalPortPositioner/lambda$3$Type', 1542);
Ycb(1543, 1, {}, k4b);
_.Kb = function l4b(a) {
    return X3b(this.a, MD(a));
};
_.Fb = function m4b(a) {
    return this === a;
};
var BR = jeb(Wve, 'InteractiveExternalPortPositioner/lambda$4$Type', 1543);
Ycb(1544, 1, {}, n4b);
_.Kb = function o4b(a) {
    return Y3b(this.a, MD(a));
};
_.Fb = function p4b(a) {
    return this === a;
};
var CR = jeb(Wve, 'InteractiveExternalPortPositioner/lambda$5$Type', 1544);
Ycb(79, 23, {
    3: 1,
    34: 1,
    23: 1,
    79: 1,
    196: 1
}, v5b);
_.bg = function w5b() {
    switch(this.g){
        case 15:
            return new rlc;
        case 22:
            return new Nlc;
        case 48:
            return new Wlc;
        case 29:
        case 36:
            return new Y6b;
        case 33:
            return new t_b;
        case 43:
            return new C_b;
        case 1:
            return new H_b;
        case 42:
            return new K_b;
        case 57:
            return new X1b((_1b(), $1b));
        case 0:
            return new X1b((_1b(), Z1b));
        case 2:
            return new S_b;
        case 55:
            return new W_b;
        case 34:
            return new n0b;
        case 52:
            return new m1b;
        case 56:
            return new j2b;
        case 13:
            return new r2b;
        case 39:
            return new A2b;
        case 45:
            return new O2b;
        case 41:
            return new a3b;
        case 9:
            return new k3b;
        case 50:
            return new ldc;
        case 38:
            return new y3b;
        case 44:
            return new J3b;
        case 28:
            return new M3b;
        case 31:
            return new P3b;
        case 3:
            return new U3b;
        case 18:
            return new F5b;
        case 30:
            return new L5b;
        case 5:
            return new Y5b;
        case 51:
            return new f6b;
        case 35:
            return new C6b;
        case 37:
            return new k7b;
        case 53:
            return new L0b;
        case 11:
            return new s7b;
        case 7:
            return new C7b;
        case 40:
            return new Q7b;
        case 46:
            return new T7b;
        case 16:
            return new X7b;
        case 10:
            return new m8b;
        case 49:
            return new O8b;
        case 21:
            return new W8b;
        case 23:
            return new IEc((UEc(), SEc));
        case 8:
            return new d9b;
        case 12:
            return new l9b;
        case 4:
            return new q9b;
        case 19:
            return new L9b;
        case 17:
            return new hac;
        case 54:
            return new kac;
        case 6:
            return new _ac;
        case 25:
            return new oac;
        case 26:
            return new hlc;
        case 47:
            return new Fac;
        case 32:
            return new kbc;
        case 14:
            return new xbc;
        case 27:
            return new Cmc;
        case 20:
            return new Mbc;
        case 24:
            return new IEc((UEc(), TEc));
        default:
            throw scb(new Teb($ve + (this.f != null ? this.f : '' + this.g)));
    }
};
var q4b, r4b, s4b, t4b, u4b, v4b, w4b, x4b, y4b, z4b, A4b, B4b, C4b, D4b, E4b, F4b, G4b, H4b, I4b, J4b, K4b, L4b, M4b, N4b, O4b, P4b, Q4b, R4b, S4b, T4b, U4b, V4b, W4b, X4b, Y4b, Z4b, $4b, _4b, a5b, b5b, c5b, d5b, e5b, f5b, g5b, h5b, i5b, j5b, k5b, l5b, m5b, n5b, o5b, p5b, q5b, r5b, s5b, t5b;
var ER = keb(Wve, _ve, 79, MI, y5b, x5b);
var z5b;
Ycb(1545, 1, Dve, F5b);
_.If = function G5b(a, b) {
    D5b(JD(a, 36), b);
};
var FR = jeb(Wve, 'InvertedPortProcessor', 1545);
Ycb(1546, 1, Dve, L5b);
_.If = function M5b(a, b) {
    K5b(JD(a, 36), b);
};
var JR = jeb(Wve, 'LabelAndNodeSizeProcessor', 1546);
Ycb(1547, 1, Ire, N5b);
_.Mb = function O5b(a) {
    return JD(a, 9).k == (DYb(), AYb);
};
var GR = jeb(Wve, 'LabelAndNodeSizeProcessor/lambda$0$Type', 1547);
Ycb(1548, 1, Ire, P5b);
_.Mb = function Q5b(a) {
    return JD(a, 9).k == (DYb(), wYb);
};
var HR = jeb(Wve, 'LabelAndNodeSizeProcessor/lambda$1$Type', 1548);
Ycb(1549, 1, kre, R5b);
_.Ad = function S5b(a) {
    I5b(this.b, this.a, this.c, JD(a, 9));
};
_.a = false;
_.c = false;
var IR = jeb(Wve, 'LabelAndNodeSizeProcessor/lambda$2$Type', 1549);
Ycb(1550, 1, Dve, Y5b);
_.If = function Z5b(a, b) {
    W5b(JD(a, 36), b);
};
var T5b;
var LR = jeb(Wve, 'LabelDummyInserter', 1550);
Ycb(1551, 1, Tte, $5b);
_.Lb = function _5b(a) {
    return XD(WMb(JD(a, 72), (Bwc(), wuc))) === XD((nhd(), khd));
};
_.Fb = function a6b(a) {
    return this === a;
};
_.Mb = function b6b(a) {
    return XD(WMb(JD(a, 72), (Bwc(), wuc))) === XD((nhd(), khd));
};
var KR = jeb(Wve, 'LabelDummyInserter/1', 1551);
Ycb(1552, 1, Dve, f6b);
_.If = function g6b(a, b) {
    e6b(JD(a, 36), b);
};
var NR = jeb(Wve, 'LabelDummyRemover', 1552);
Ycb(1553, 1, Ire, h6b);
_.Mb = function i6b(a) {
    return ydb(LD(WMb(JD(a, 72), (Bwc(), vuc))));
};
var MR = jeb(Wve, 'LabelDummyRemover/lambda$0$Type', 1553);
Ycb(1317, 1, Dve, C6b);
_.If = function G6b(a, b) {
    y6b(this, JD(a, 36), b);
};
_.a = null;
var j6b;
var UR = jeb(Wve, 'LabelDummySwitcher', 1317);
Ycb(291, 1, {
    291: 1
}, K6b);
_.c = 0;
_.d = null;
_.f = 0;
var OR = jeb(Wve, 'LabelDummySwitcher/LabelDummyInfo', 291);
Ycb(1318, 1, {}, L6b);
_.Kb = function M6b(a) {
    return k6b(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var PR = jeb(Wve, 'LabelDummySwitcher/lambda$0$Type', 1318);
Ycb(1319, 1, Ire, N6b);
_.Mb = function O6b(a) {
    return k6b(), JD(a, 9).k == (DYb(), xYb);
};
var QR = jeb(Wve, 'LabelDummySwitcher/lambda$1$Type', 1319);
Ycb(1320, 1, {}, P6b);
_.Kb = function Q6b(a) {
    return D6b(this.a, JD(a, 9));
};
var RR = jeb(Wve, 'LabelDummySwitcher/lambda$2$Type', 1320);
Ycb(1321, 1, kre, R6b);
_.Ad = function S6b(a) {
    E6b(this.a, JD(a, 291));
};
var SR = jeb(Wve, 'LabelDummySwitcher/lambda$3$Type', 1321);
Ycb(1322, 1, Bte, T6b);
_.Le = function U6b(a, b) {
    return F6b(JD(a, 291), JD(b, 291));
};
_.Fb = function V6b(a) {
    return this === a;
};
_.Me = function W6b() {
    return new uqb(this);
};
var TR = jeb(Wve, 'LabelDummySwitcher/lambda$4$Type', 1322);
Ycb(782, 1, Dve, Y6b);
_.If = function Z6b(a, b) {
    X6b(JD(a, 36), b);
};
var VR = jeb(Wve, 'LabelManagementProcessor', 782);
Ycb(1554, 1, Dve, k7b);
_.If = function l7b(a, b) {
    e7b(JD(a, 36), b);
};
var WR = jeb(Wve, 'LabelSideSelector', 1554);
Ycb(1562, 1, Dve, s7b);
_.If = function t7b(a, b) {
    o7b(JD(a, 36), b);
};
var XR = jeb(Wve, 'LayerConstraintPostprocessor', 1562);
Ycb(1563, 1, Dve, C7b);
_.If = function D7b(a, b) {
    A7b(JD(a, 36), b);
};
var u7b;
var ZR = jeb(Wve, 'LayerConstraintPreprocessor', 1563);
Ycb(364, 23, {
    3: 1,
    34: 1,
    23: 1,
    364: 1
}, K7b);
var E7b, F7b, G7b, H7b;
var YR = keb(Wve, 'LayerConstraintPreprocessor/HiddenNodeConnections', 364, MI, M7b, L7b);
var N7b;
Ycb(1564, 1, Dve, Q7b);
_.If = function R7b(a, b) {
    P7b(JD(a, 36), b);
};
var $R = jeb(Wve, 'LayerSizeAndGraphHeightCalculator', 1564);
Ycb(1565, 1, Dve, T7b);
_.If = function V7b(a, b) {
    S7b(JD(a, 36), b);
};
var _R = jeb(Wve, 'LongEdgeJoiner', 1565);
Ycb(1566, 1, Dve, X7b);
_.If = function Z7b(a, b) {
    W7b(JD(a, 36), b);
};
var aS = jeb(Wve, 'LongEdgeSplitter', 1566);
Ycb(1567, 1, Dve, m8b);
_.If = function p8b(a, b) {
    g8b(this, JD(a, 36), b);
};
_.e = 0;
_.f = 0;
_.j = 0;
_.k = 0;
_.n = 0;
_.o = 0;
var a8b, b8b;
var gS = jeb(Wve, 'NodePromotion', 1567);
Ycb(1568, 1, Bte, r8b);
_.Le = function s8b(a, b) {
    return q8b(JD(a, 9), JD(b, 9));
};
_.Fb = function t8b(a) {
    return this === a;
};
_.Me = function u8b() {
    return new uqb(this);
};
var bS = jeb(Wve, 'NodePromotion/1', 1568);
Ycb(1569, 1, Bte, w8b);
_.Le = function x8b(a, b) {
    return v8b(JD(a, 9), JD(b, 9));
};
_.Fb = function y8b(a) {
    return this === a;
};
_.Me = function z8b() {
    return new uqb(this);
};
var cS = jeb(Wve, 'NodePromotion/2', 1569);
Ycb(1570, 1, {}, A8b);
_.Kb = function B8b(a) {
    return JD(a, 47), c8b(), xdb(), true;
};
_.Fb = function C8b(a) {
    return this === a;
};
var dS = jeb(Wve, 'NodePromotion/lambda$0$Type', 1570);
Ycb(1571, 1, {}, D8b);
_.Kb = function E8b(a) {
    return n8b(this.a, JD(a, 47));
};
_.Fb = function F8b(a) {
    return this === a;
};
_.a = 0;
var eS = jeb(Wve, 'NodePromotion/lambda$1$Type', 1571);
Ycb(1572, 1, {}, G8b);
_.Kb = function H8b(a) {
    return o8b(this.a, JD(a, 47));
};
_.Fb = function I8b(a) {
    return this === a;
};
_.a = 0;
var fS = jeb(Wve, 'NodePromotion/lambda$2$Type', 1572);
Ycb(1573, 1, Dve, O8b);
_.If = function P8b(a, b) {
    J8b(JD(a, 36), b);
};
var hS = jeb(Wve, 'NorthSouthPortPostprocessor', 1573);
Ycb(1574, 1, Dve, W8b);
_.If = function Y8b(a, b) {
    U8b(JD(a, 36), b);
};
var jS = jeb(Wve, 'NorthSouthPortPreprocessor', 1574);
Ycb(1575, 1, Bte, Z8b);
_.Le = function $8b(a, b) {
    return X8b(JD(a, 11), JD(b, 11));
};
_.Fb = function _8b(a) {
    return this === a;
};
_.Me = function a9b() {
    return new uqb(this);
};
var iS = jeb(Wve, 'NorthSouthPortPreprocessor/lambda$0$Type', 1575);
Ycb(1576, 1, Dve, d9b);
_.If = function f9b(a, b) {
    c9b(JD(a, 36), b);
};
var mS = jeb(Wve, 'PartitionMidprocessor', 1576);
Ycb(1577, 1, Ire, g9b);
_.Mb = function h9b(a) {
    return XMb(JD(a, 9), (Bwc(), wvc));
};
var kS = jeb(Wve, 'PartitionMidprocessor/lambda$0$Type', 1577);
Ycb(1578, 1, kre, i9b);
_.Ad = function j9b(a) {
    e9b(this.a, JD(a, 9));
};
var lS = jeb(Wve, 'PartitionMidprocessor/lambda$1$Type', 1578);
Ycb(1579, 1, Dve, l9b);
_.If = function m9b(a, b) {
    k9b(JD(a, 36), b);
};
var nS = jeb(Wve, 'PartitionPostprocessor', 1579);
Ycb(1580, 1, Dve, q9b);
_.If = function r9b(a, b) {
    o9b(JD(a, 36), b);
};
var sS = jeb(Wve, 'PartitionPreprocessor', 1580);
Ycb(1581, 1, Ire, s9b);
_.Mb = function t9b(a) {
    return XMb(JD(a, 9), (Bwc(), wvc));
};
var oS = jeb(Wve, 'PartitionPreprocessor/lambda$0$Type', 1581);
Ycb(1582, 1, {}, u9b);
_.Kb = function v9b(a) {
    return new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var pS = jeb(Wve, 'PartitionPreprocessor/lambda$1$Type', 1582);
Ycb(1583, 1, Ire, w9b);
_.Mb = function x9b(a) {
    return n9b(JD(a, 18));
};
var qS = jeb(Wve, 'PartitionPreprocessor/lambda$2$Type', 1583);
Ycb(1584, 1, kre, y9b);
_.Ad = function z9b(a) {
    p9b(JD(a, 18));
};
var rS = jeb(Wve, 'PartitionPreprocessor/lambda$3$Type', 1584);
Ycb(1585, 1, Dve, L9b);
_.If = function P9b(a, b) {
    I9b(JD(a, 36), b);
};
var A9b, B9b, C9b, D9b, E9b, F9b;
var yS = jeb(Wve, 'PortListSorter', 1585);
Ycb(1586, 1, {}, R9b);
_.Kb = function S9b(a) {
    return G9b(), JD(a, 11).e;
};
var tS = jeb(Wve, 'PortListSorter/lambda$0$Type', 1586);
Ycb(1587, 1, {}, T9b);
_.Kb = function U9b(a) {
    return G9b(), JD(a, 11).g;
};
var uS = jeb(Wve, 'PortListSorter/lambda$1$Type', 1587);
Ycb(1588, 1, Bte, V9b);
_.Le = function W9b(a, b) {
    return M9b(JD(a, 11), JD(b, 11));
};
_.Fb = function X9b(a) {
    return this === a;
};
_.Me = function Y9b() {
    return new uqb(this);
};
var vS = jeb(Wve, 'PortListSorter/lambda$2$Type', 1588);
Ycb(1589, 1, Bte, Z9b);
_.Le = function $9b(a, b) {
    return N9b(JD(a, 11), JD(b, 11));
};
_.Fb = function _9b(a) {
    return this === a;
};
_.Me = function aac() {
    return new uqb(this);
};
var wS = jeb(Wve, 'PortListSorter/lambda$3$Type', 1589);
Ycb(1590, 1, Bte, bac);
_.Le = function cac(a, b) {
    return O9b(JD(a, 11), JD(b, 11));
};
_.Fb = function dac(a) {
    return this === a;
};
_.Me = function eac() {
    return new uqb(this);
};
var xS = jeb(Wve, 'PortListSorter/lambda$4$Type', 1590);
Ycb(1591, 1, Dve, hac);
_.If = function iac(a, b) {
    fac(JD(a, 36), b);
};
var zS = jeb(Wve, 'PortSideProcessor', 1591);
Ycb(1592, 1, Dve, kac);
_.If = function lac(a, b) {
    jac(JD(a, 36), b);
};
var AS = jeb(Wve, 'ReversedEdgeRestorer', 1592);
Ycb(1597, 1, Dve, oac);
_.If = function pac(a, b) {
    mac(this, JD(a, 36), b);
};
var HS = jeb(Wve, 'SelfLoopPortRestorer', 1597);
Ycb(1598, 1, {}, qac);
_.Kb = function rac(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var BS = jeb(Wve, 'SelfLoopPortRestorer/lambda$0$Type', 1598);
Ycb(1599, 1, Ire, sac);
_.Mb = function tac(a) {
    return JD(a, 9).k == (DYb(), AYb);
};
var CS = jeb(Wve, 'SelfLoopPortRestorer/lambda$1$Type', 1599);
Ycb(1600, 1, Ire, uac);
_.Mb = function vac(a) {
    return XMb(JD(a, 9), (Iqc(), zqc));
};
var DS = jeb(Wve, 'SelfLoopPortRestorer/lambda$2$Type', 1600);
Ycb(1601, 1, {}, wac);
_.Kb = function xac(a) {
    return JD(WMb(JD(a, 9), (Iqc(), zqc)), 333);
};
var ES = jeb(Wve, 'SelfLoopPortRestorer/lambda$3$Type', 1601);
Ycb(1602, 1, kre, yac);
_.Ad = function zac(a) {
    nac(this.a, JD(a, 333));
};
var FS = jeb(Wve, 'SelfLoopPortRestorer/lambda$4$Type', 1602);
Ycb(785, 1, kre, Aac);
_.Ad = function Bac(a) {
    ogc(JD(a, 105));
};
var GS = jeb(Wve, 'SelfLoopPortRestorer/lambda$5$Type', 785);
Ycb(1604, 1, Dve, Fac);
_.If = function Hac(a, b) {
    Cac(JD(a, 36), b);
};
var QS = jeb(Wve, 'SelfLoopPostProcessor', 1604);
Ycb(1605, 1, {}, Iac);
_.Kb = function Jac(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var IS = jeb(Wve, 'SelfLoopPostProcessor/lambda$0$Type', 1605);
Ycb(1606, 1, Ire, Kac);
_.Mb = function Lac(a) {
    return JD(a, 9).k == (DYb(), AYb);
};
var JS = jeb(Wve, 'SelfLoopPostProcessor/lambda$1$Type', 1606);
Ycb(1607, 1, Ire, Mac);
_.Mb = function Nac(a) {
    return XMb(JD(a, 9), (Iqc(), zqc));
};
var KS = jeb(Wve, 'SelfLoopPostProcessor/lambda$2$Type', 1607);
Ycb(1608, 1, kre, Oac);
_.Ad = function Pac(a) {
    Dac(JD(a, 9));
};
var LS = jeb(Wve, 'SelfLoopPostProcessor/lambda$3$Type', 1608);
Ycb(1609, 1, {}, Qac);
_.Kb = function Rac(a) {
    return new RBb(null, new Gvb(JD(a, 105).f, 1));
};
var MS = jeb(Wve, 'SelfLoopPostProcessor/lambda$4$Type', 1609);
Ycb(1610, 1, kre, Sac);
_.Ad = function Tac(a) {
    Eac(this.a, JD(a, 336));
};
var NS = jeb(Wve, 'SelfLoopPostProcessor/lambda$5$Type', 1610);
Ycb(1611, 1, Ire, Uac);
_.Mb = function Vac(a) {
    return !!JD(a, 105).i;
};
var OS = jeb(Wve, 'SelfLoopPostProcessor/lambda$6$Type', 1611);
Ycb(1612, 1, kre, Wac);
_.Ad = function Xac(a) {
    Gac(this.a, JD(a, 105));
};
var PS = jeb(Wve, 'SelfLoopPostProcessor/lambda$7$Type', 1612);
Ycb(1593, 1, Dve, _ac);
_.If = function abc(a, b) {
    $ac(JD(a, 36), b);
};
var US = jeb(Wve, 'SelfLoopPreProcessor', 1593);
Ycb(1594, 1, {}, bbc);
_.Kb = function cbc(a) {
    return new RBb(null, new Gvb(JD(a, 105).f, 1));
};
var RS = jeb(Wve, 'SelfLoopPreProcessor/lambda$0$Type', 1594);
Ycb(1595, 1, {}, dbc);
_.Kb = function ebc(a) {
    return JD(a, 336).a;
};
var SS = jeb(Wve, 'SelfLoopPreProcessor/lambda$1$Type', 1595);
Ycb(1596, 1, kre, fbc);
_.Ad = function gbc(a) {
    Zac(JD(a, 18));
};
var TS = jeb(Wve, 'SelfLoopPreProcessor/lambda$2$Type', 1596);
Ycb(1613, 1, Dve, kbc);
_.If = function lbc(a, b) {
    ibc(this, JD(a, 36), b);
};
var $S = jeb(Wve, 'SelfLoopRouter', 1613);
Ycb(1614, 1, {}, mbc);
_.Kb = function nbc(a) {
    return new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var VS = jeb(Wve, 'SelfLoopRouter/lambda$0$Type', 1614);
Ycb(1615, 1, Ire, obc);
_.Mb = function pbc(a) {
    return JD(a, 9).k == (DYb(), AYb);
};
var WS = jeb(Wve, 'SelfLoopRouter/lambda$1$Type', 1615);
Ycb(1616, 1, Ire, qbc);
_.Mb = function rbc(a) {
    return XMb(JD(a, 9), (Iqc(), zqc));
};
var XS = jeb(Wve, 'SelfLoopRouter/lambda$2$Type', 1616);
Ycb(1617, 1, {}, sbc);
_.Kb = function tbc(a) {
    return JD(WMb(JD(a, 9), (Iqc(), zqc)), 333);
};
var YS = jeb(Wve, 'SelfLoopRouter/lambda$3$Type', 1617);
Ycb(1618, 1, kre, ubc);
_.Ad = function vbc(a) {
    hbc(this.a, this.b, JD(a, 333));
};
var ZS = jeb(Wve, 'SelfLoopRouter/lambda$4$Type', 1618);
Ycb(1619, 1, Dve, xbc);
_.If = function Abc(a, b) {
    wbc(JD(a, 36), b);
};
var dT = jeb(Wve, 'SemiInteractiveCrossMinProcessor', 1619);
Ycb(1620, 1, Ire, Bbc);
_.Mb = function Cbc(a) {
    return JD(a, 9).k == (DYb(), AYb);
};
var _S = jeb(Wve, 'SemiInteractiveCrossMinProcessor/lambda$0$Type', 1620);
Ycb(1621, 1, Ire, Dbc);
_.Mb = function Ebc(a) {
    return VMb(JD(a, 9))._b((Bwc(), Lvc));
};
var aT = jeb(Wve, 'SemiInteractiveCrossMinProcessor/lambda$1$Type', 1621);
Ycb(1622, 1, Bte, Fbc);
_.Le = function Gbc(a, b) {
    return ybc(JD(a, 9), JD(b, 9));
};
_.Fb = function Hbc(a) {
    return this === a;
};
_.Me = function Ibc() {
    return new uqb(this);
};
var bT = jeb(Wve, 'SemiInteractiveCrossMinProcessor/lambda$2$Type', 1622);
Ycb(1623, 1, {}, Jbc);
_.Te = function Kbc(a, b) {
    return zbc(JD(a, 9), JD(b, 9));
};
var cT = jeb(Wve, 'SemiInteractiveCrossMinProcessor/lambda$3$Type', 1623);
Ycb(1625, 1, Dve, Mbc);
_.If = function Rbc(a, b) {
    Lbc(JD(a, 36), b);
};
var gT = jeb(Wve, 'SortByInputModelProcessor', 1625);
Ycb(1626, 1, Ire, Sbc);
_.Mb = function Tbc(a) {
    return JD(a, 11).g.c.length != 0;
};
var eT = jeb(Wve, 'SortByInputModelProcessor/lambda$0$Type', 1626);
Ycb(1627, 1, kre, Ubc);
_.Ad = function Vbc(a) {
    Pbc(this.a, JD(a, 11));
};
var fT = jeb(Wve, 'SortByInputModelProcessor/lambda$1$Type', 1627);
Ycb(1705, 797, {}, ccc);
_.bf = function dcc(a) {
    var b, c, d, e;
    this.c = a;
    switch(this.a.g){
        case 2:
            b = new Ulb;
            EBb(BBb(new RBb(null, new Gvb(this.c.a.b, 16)), new edc), new gdc(this, b));
            dFb(this, new mcc);
            Llb(b, new qcc);
            b.c.length = 0;
            EBb(BBb(new RBb(null, new Gvb(this.c.a.b, 16)), new scc), new ucc(b));
            dFb(this, new ycc);
            Llb(b, new Ccc);
            b.c.length = 0;
            c = Kub(SAb(GBb(new RBb(null, new Gvb(this.c.a.b, 16)), new Ecc(this))), new Gcc);
            EBb(new RBb(null, new Gvb(this.c.a.a, 16)), new Kcc(c, b));
            dFb(this, new Occ);
            Llb(b, new Scc);
            b.c.length = 0;
            break;
        case 3:
            d = new Ulb;
            dFb(this, new ecc);
            e = Kub(SAb(GBb(new RBb(null, new Gvb(this.c.a.b, 16)), new icc(this))), new Icc);
            EBb(BBb(new RBb(null, new Gvb(this.c.a.b, 16)), new Ucc), new Wcc(e, d));
            dFb(this, new $cc);
            Llb(d, new cdc);
            d.c.length = 0;
            break;
        default:
            throw scb(new X8c);
    }
};
_.b = 0;
var FT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation', 1705);
Ycb(1706, 1, Tte, ecc);
_.Lb = function fcc(a) {
    return RD(JD(a, 60).g, 152);
};
_.Fb = function gcc(a) {
    return this === a;
};
_.Mb = function hcc(a) {
    return RD(JD(a, 60).g, 152);
};
var hT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$0$Type', 1706);
Ycb(1707, 1, {}, icc);
_.We = function jcc(a) {
    return Ybc(this.a, JD(a, 60));
};
var iT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$1$Type', 1707);
Ycb(1715, 1, Jre, kcc);
_.be = function lcc() {
    Xbc(this.a, this.b, -1);
};
_.b = 0;
var jT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$10$Type', 1715);
Ycb(1717, 1, Tte, mcc);
_.Lb = function ncc(a) {
    return RD(JD(a, 60).g, 152);
};
_.Fb = function occ(a) {
    return this === a;
};
_.Mb = function pcc(a) {
    return RD(JD(a, 60).g, 152);
};
var kT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$11$Type', 1717);
Ycb(1718, 1, kre, qcc);
_.Ad = function rcc(a) {
    JD(a, 372).be();
};
var lT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$12$Type', 1718);
Ycb(1719, 1, Ire, scc);
_.Mb = function tcc(a) {
    return RD(JD(a, 60).g, 9);
};
var mT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$13$Type', 1719);
Ycb(1721, 1, kre, ucc);
_.Ad = function vcc(a) {
    Zbc(this.a, JD(a, 60));
};
var nT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$14$Type', 1721);
Ycb(1720, 1, Jre, wcc);
_.be = function xcc() {
    Xbc(this.b, this.a, -1);
};
_.a = 0;
var oT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$15$Type', 1720);
Ycb(1722, 1, Tte, ycc);
_.Lb = function zcc(a) {
    return RD(JD(a, 60).g, 9);
};
_.Fb = function Acc(a) {
    return this === a;
};
_.Mb = function Bcc(a) {
    return RD(JD(a, 60).g, 9);
};
var pT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$16$Type', 1722);
Ycb(1723, 1, kre, Ccc);
_.Ad = function Dcc(a) {
    JD(a, 372).be();
};
var qT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$17$Type', 1723);
Ycb(1724, 1, {}, Ecc);
_.We = function Fcc(a) {
    return $bc(this.a, JD(a, 60));
};
var rT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$18$Type', 1724);
Ycb(1725, 1, {}, Gcc);
_.Ue = function Hcc() {
    return 0;
};
var sT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$19$Type', 1725);
Ycb(1708, 1, {}, Icc);
_.Ue = function Jcc() {
    return 0;
};
var tT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$2$Type', 1708);
Ycb(1727, 1, kre, Kcc);
_.Ad = function Lcc(a) {
    _bc(this.a, this.b, JD(a, 317));
};
_.a = 0;
var uT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$20$Type', 1727);
Ycb(1726, 1, Jre, Mcc);
_.be = function Ncc() {
    Wbc(this.a, this.b, -1);
};
_.b = 0;
var vT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$21$Type', 1726);
Ycb(1728, 1, Tte, Occ);
_.Lb = function Pcc(a) {
    return JD(a, 60), true;
};
_.Fb = function Qcc(a) {
    return this === a;
};
_.Mb = function Rcc(a) {
    return JD(a, 60), true;
};
var wT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$22$Type', 1728);
Ycb(1729, 1, kre, Scc);
_.Ad = function Tcc(a) {
    JD(a, 372).be();
};
var xT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$23$Type', 1729);
Ycb(1709, 1, Ire, Ucc);
_.Mb = function Vcc(a) {
    return RD(JD(a, 60).g, 9);
};
var yT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$3$Type', 1709);
Ycb(1711, 1, kre, Wcc);
_.Ad = function Xcc(a) {
    acc(this.a, this.b, JD(a, 60));
};
_.a = 0;
var zT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$4$Type', 1711);
Ycb(1710, 1, Jre, Ycc);
_.be = function Zcc() {
    Xbc(this.b, this.a, -1);
};
_.a = 0;
var AT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$5$Type', 1710);
Ycb(1712, 1, Tte, $cc);
_.Lb = function _cc(a) {
    return JD(a, 60), true;
};
_.Fb = function adc(a) {
    return this === a;
};
_.Mb = function bdc(a) {
    return JD(a, 60), true;
};
var BT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$6$Type', 1712);
Ycb(1713, 1, kre, cdc);
_.Ad = function ddc(a) {
    JD(a, 372).be();
};
var CT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$7$Type', 1713);
Ycb(1714, 1, Ire, edc);
_.Mb = function fdc(a) {
    return RD(JD(a, 60).g, 152);
};
var DT = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$8$Type', 1714);
Ycb(1716, 1, kre, gdc);
_.Ad = function hdc(a) {
    bcc(this.a, this.b, JD(a, 60));
};
var ET = jeb(ewe, 'EdgeAwareScanlineConstraintCalculation/lambda$9$Type', 1716);
Ycb(1526, 1, Dve, ldc);
_.If = function qdc(a, b) {
    kdc(this, JD(a, 36), b);
};
var idc;
var JT = jeb(ewe, 'HorizontalGraphCompactor', 1526);
Ycb(1527, 1, {}, rdc);
_.df = function sdc(a, b) {
    var c, d, e;
    if (odc(a, b)) return 0;
    c = mdc(a);
    d = mdc(b);
    if (!!c && c.k == (DYb(), wYb) || !!d && d.k == (DYb(), wYb)) return 0;
    e = JD(WMb(this.a.a, (Iqc(), Aqc)), 313);
    return azc(e, c ? c.k : (DYb(), yYb), d ? d.k : (DYb(), yYb));
};
_.ef = function tdc(a, b) {
    var c, d, e;
    if (odc(a, b)) return 1;
    c = mdc(a);
    d = mdc(b);
    e = JD(WMb(this.a.a, (Iqc(), Aqc)), 313);
    return dzc(e, c ? c.k : (DYb(), yYb), d ? d.k : (DYb(), yYb));
};
var GT = jeb(ewe, 'HorizontalGraphCompactor/1', 1527);
Ycb(1528, 1, {}, udc);
_.cf = function vdc(a, b) {
    return jdc(), a.a.i == 0;
};
var HT = jeb(ewe, 'HorizontalGraphCompactor/lambda$0$Type', 1528);
Ycb(1529, 1, {}, wdc);
_.cf = function xdc(a, b) {
    return pdc(this.a, a, b);
};
var IT = jeb(ewe, 'HorizontalGraphCompactor/lambda$1$Type', 1529);
Ycb(1672, 1, {}, Sdc);
var ydc, zdc;
var lU = jeb(ewe, 'LGraphToCGraphTransformer', 1672);
Ycb(1680, 1, Ire, _dc);
_.Mb = function aec(a) {
    return a != null;
};
var KT = jeb(ewe, 'LGraphToCGraphTransformer/0methodref$nonNull$Type', 1680);
Ycb(1673, 1, {}, bec);
_.Kb = function cec(a) {
    return Adc(), adb(WMb(JD(JD(a, 60).g, 9), (Iqc(), kqc)));
};
var LT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$0$Type', 1673);
Ycb(1674, 1, {}, dec);
_.Kb = function eec(a) {
    return Adc(), jfc(JD(JD(a, 60).g, 152));
};
var MT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$1$Type', 1674);
Ycb(1683, 1, Ire, fec);
_.Mb = function gec(a) {
    return Adc(), RD(JD(a, 60).g, 9);
};
var NT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$10$Type', 1683);
Ycb(1684, 1, kre, hec);
_.Ad = function iec(a) {
    Tdc(JD(a, 60));
};
var OT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$11$Type', 1684);
Ycb(1685, 1, Ire, jec);
_.Mb = function kec(a) {
    return Adc(), RD(JD(a, 60).g, 152);
};
var PT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$12$Type', 1685);
Ycb(1689, 1, kre, lec);
_.Ad = function mec(a) {
    Udc(JD(a, 60));
};
var QT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$13$Type', 1689);
Ycb(1686, 1, kre, nec);
_.Ad = function oec(a) {
    Vdc(this.a, JD(a, 8));
};
_.a = 0;
var RT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$14$Type', 1686);
Ycb(1687, 1, kre, pec);
_.Ad = function qec(a) {
    Wdc(this.a, JD(a, 119));
};
_.a = 0;
var ST = jeb(ewe, 'LGraphToCGraphTransformer/lambda$15$Type', 1687);
Ycb(1688, 1, kre, rec);
_.Ad = function sec(a) {
    Xdc(this.a, JD(a, 8));
};
_.a = 0;
var TT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$16$Type', 1688);
Ycb(1690, 1, {}, tec);
_.Kb = function uec(a) {
    return Adc(), new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var UT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$17$Type', 1690);
Ycb(1691, 1, Ire, vec);
_.Mb = function wec(a) {
    return Adc(), eWb(JD(a, 18));
};
var VT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$18$Type', 1691);
Ycb(1692, 1, kre, xec);
_.Ad = function yec(a) {
    Jdc(this.a, JD(a, 18));
};
var WT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$19$Type', 1692);
Ycb(1676, 1, kre, zec);
_.Ad = function Aec(a) {
    Kdc(this.a, JD(a, 152));
};
var XT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$2$Type', 1676);
Ycb(1693, 1, {}, Bec);
_.Kb = function Cec(a) {
    return Adc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var YT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$20$Type', 1693);
Ycb(1694, 1, {}, Dec);
_.Kb = function Eec(a) {
    return Adc(), new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var ZT = jeb(ewe, 'LGraphToCGraphTransformer/lambda$21$Type', 1694);
Ycb(1695, 1, {}, Fec);
_.Kb = function Gec(a) {
    return Adc(), JD(WMb(JD(a, 18), (Iqc(), Dqc)), 15);
};
var $T = jeb(ewe, 'LGraphToCGraphTransformer/lambda$22$Type', 1695);
Ycb(1696, 1, Ire, Hec);
_.Mb = function Iec(a) {
    return Ydc(JD(a, 15));
};
var _T = jeb(ewe, 'LGraphToCGraphTransformer/lambda$23$Type', 1696);
Ycb(1697, 1, kre, Jec);
_.Ad = function Kec(a) {
    Cdc(this.a, JD(a, 15));
};
var aU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$24$Type', 1697);
Ycb(1698, 1, {}, Lec);
_.Kb = function Mec(a) {
    return Adc(), new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var bU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$25$Type', 1698);
Ycb(1699, 1, Ire, Nec);
_.Mb = function Oec(a) {
    return Adc(), eWb(JD(a, 18));
};
var cU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$26$Type', 1699);
Ycb(1701, 1, kre, Pec);
_.Ad = function Qec(a) {
    Ldc(this.a, JD(a, 18));
};
var dU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$27$Type', 1701);
Ycb(1700, 1, kre, Rec);
_.Ad = function Sec(a) {
    Zdc(this.a, JD(a, 72));
};
_.a = 0;
var eU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$28$Type', 1700);
Ycb(1675, 1, kre, Tec);
_.Ad = function Uec(a) {
    Mdc(this.a, this.b, JD(a, 152));
};
var fU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$3$Type', 1675);
Ycb(1677, 1, {}, Vec);
_.Kb = function Wec(a) {
    return Adc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var gU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$4$Type', 1677);
Ycb(1678, 1, {}, Xec);
_.Kb = function Yec(a) {
    return Adc(), new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var hU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$5$Type', 1678);
Ycb(1679, 1, {}, Zec);
_.Kb = function $ec(a) {
    return Adc(), JD(WMb(JD(a, 18), (Iqc(), Dqc)), 15);
};
var iU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$6$Type', 1679);
Ycb(1681, 1, kre, _ec);
_.Ad = function afc(a) {
    $dc(this.a, JD(a, 15));
};
var jU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$8$Type', 1681);
Ycb(1682, 1, kre, bfc);
_.Ad = function cfc(a) {
    Ndc(this.a, this.b, JD(a, 152));
};
var kU = jeb(ewe, 'LGraphToCGraphTransformer/lambda$9$Type', 1682);
Ycb(1671, 1, {}, gfc);
_.af = function hfc(a) {
    var b, c, d, e, f;
    this.a = a;
    this.d = new NFb;
    this.c = SC(bN, Nqe, 123, this.a.a.a.c.length, 0, 1);
    this.b = 0;
    for(c = new rmb(this.a.a.a); c.a < c.c.c.length;){
        b = JD(pmb(c), 317);
        b.d = this.b;
        f = pGb(qGb(new rGb, b), this.d);
        this.c[this.b] = f;
        ++this.b;
    }
    ffc(this);
    efc(this);
    dfc(this);
    wGb(NGb(this.d), new wld);
    for(e = new rmb(this.a.a.b); e.a < e.c.c.length;){
        d = JD(pmb(e), 60);
        d.d.c = this.c[d.a.d].e + d.b.a;
    }
};
_.b = 0;
var mU = jeb(ewe, 'NetworkSimplexCompaction', 1671);
Ycb(152, 1, {
    34: 1,
    152: 1
}, kfc);
_.Dd = function lfc(a) {
    return ifc(this, JD(a, 152));
};
_.Ib = function mfc() {
    return jfc(this);
};
var nU = jeb(ewe, 'VerticalSegment', 152);
Ycb(820, 1, {}, vfc);
_.c = 0;
_.e = 0;
_.i = 0;
var qU = jeb(fwe, 'BetweenLayerEdgeTwoNodeCrossingsCounter', 820);
Ycb(662, 1, {
    662: 1
}, Cfc);
_.Ib = function Dfc() {
    return 'AdjacencyList [node=' + this.d + ', adjacencies= ' + this.a + ']';
};
_.b = 0;
_.c = 0;
_.f = 0;
var pU = jeb(fwe, 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList', 662);
Ycb(292, 1, {
    34: 1,
    292: 1
}, Gfc);
_.Dd = function Hfc(a) {
    return Efc(this, JD(a, 292));
};
_.Ib = function Ifc() {
    return 'Adjacency [position=' + this.c + ', cardinality=' + this.a + ', currentCardinality=' + this.b + ']';
};
_.a = 0;
_.b = 0;
_.c = 0;
var oU = jeb(fwe, 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList/Adjacency', 292);
Ycb(1972, 1, {}, Lfc);
_.b = 0;
_.e = false;
var rU = jeb(fwe, 'CrossingMatrixFiller', 1972);
var EX = leb(gwe, 'IInitializable');
Ycb(1813, 1, hwe, Rfc);
_.eg = function Ufc(a, b, c, d, e, f) {};
_.gg = function Wfc(a, b, c) {};
_.cg = function Sfc() {
    return this.c != (UEc(), SEc);
};
_.dg = function Tfc() {
    this.e = SC(cE, ise, 30, this.d, 15, 1);
};
_.fg = function Vfc(a, b) {
    b[a][0].c.p = a;
};
_.hg = function Xfc(a, b, c, d) {
    ++this.d;
};
_.ig = function Yfc() {
    return true;
};
_.jg = function Zfc(a, b, c, d) {
    Nfc(this, a, b, c);
    return Mfc(this, b);
};
_.kg = function $fc(a, b) {
    var c;
    c = Ofc(b, a.length);
    Nfc(this, a, c, b);
    return Pfc(this, c);
};
_.d = 0;
var sU = jeb(fwe, 'GreedySwitchHeuristic', 1813);
Ycb(1975, 1, {}, hgc);
_.b = 0;
_.d = 0;
var tU = jeb(fwe, 'NorthSouthEdgeNeighbouringNodeCrossingsCounter', 1975);
Ycb(1962, 1, {}, mgc);
_.a = false;
var uU = jeb(fwe, 'SwitchDecider', 1962);
Ycb(105, 1, {
    105: 1
}, sgc);
_.a = null;
_.c = null;
_.i = null;
var xU = jeb(iwe, 'SelfHyperLoop', 105);
Ycb(1959, 1, {}, ygc);
_.c = 0;
_.e = 0;
var wU = jeb(iwe, 'SelfHyperLoopLabels', 1959);
Ycb(410, 23, {
    3: 1,
    34: 1,
    23: 1,
    410: 1
}, Egc);
var zgc, Agc, Bgc, Cgc;
var vU = keb(iwe, 'SelfHyperLoopLabels/Alignment', 410, MI, Ggc, Fgc);
var Hgc;
Ycb(336, 1, {
    336: 1
}, Jgc);
var yU = jeb(iwe, 'SelfLoopEdge', 336);
Ycb(333, 1, {
    333: 1
}, Ngc);
_.a = false;
var AU = jeb(iwe, 'SelfLoopHolder', 333);
Ycb(1736, 1, Ire, Pgc);
_.Mb = function Qgc(a) {
    return eWb(JD(a, 18));
};
var zU = jeb(iwe, 'SelfLoopHolder/lambda$0$Type', 1736);
Ycb(112, 1, {
    112: 1
}, Sgc);
_.a = false;
_.c = false;
var CU = jeb(iwe, 'SelfLoopPort', 112);
Ycb(1801, 1, Ire, Tgc);
_.Mb = function Ugc(a) {
    return eWb(JD(a, 18));
};
var BU = jeb(iwe, 'SelfLoopPort/lambda$0$Type', 1801);
Ycb(368, 23, {
    3: 1,
    34: 1,
    23: 1,
    368: 1
}, _gc);
var Vgc, Wgc, Xgc, Ygc, Zgc;
var DU = keb(iwe, 'SelfLoopType', 368, MI, chc, bhc);
var dhc;
Ycb(1744, 1, {}, Ahc);
var fhc, ghc, hhc, ihc;
var SU = jeb(jwe, 'PortRestorer', 1744);
Ycb(365, 23, {
    3: 1,
    34: 1,
    23: 1,
    365: 1
}, Jhc);
var Fhc, Ghc, Hhc;
var EU = keb(jwe, 'PortRestorer/PortSideArea', 365, MI, Lhc, Khc);
var Mhc;
Ycb(1745, 1, {}, Ohc);
_.Kb = function Phc(a) {
    return jhc(), JD(a, 15).Mc();
};
var FU = jeb(jwe, 'PortRestorer/lambda$0$Type', 1745);
Ycb(1746, 1, kre, Qhc);
_.Ad = function Rhc(a) {
    jhc();
    JD(a, 112).c = false;
};
var GU = jeb(jwe, 'PortRestorer/lambda$1$Type', 1746);
Ycb(1755, 1, Ire, Shc);
_.Mb = function Thc(a) {
    return jhc(), JD(a, 11).j == (Rjd(), Qjd);
};
var HU = jeb(jwe, 'PortRestorer/lambda$10$Type', 1755);
Ycb(1756, 1, {}, Uhc);
_.Kb = function Vhc(a) {
    return jhc(), JD(a, 112).d;
};
var IU = jeb(jwe, 'PortRestorer/lambda$11$Type', 1756);
Ycb(1757, 1, kre, Whc);
_.Ad = function Xhc(a) {
    Bhc(this.a, JD(a, 11));
};
var JU = jeb(jwe, 'PortRestorer/lambda$12$Type', 1757);
Ycb(1747, 1, kre, Yhc);
_.Ad = function Zhc(a) {
    Chc(this.a, JD(a, 105));
};
var KU = jeb(jwe, 'PortRestorer/lambda$2$Type', 1747);
Ycb(1748, 1, Bte, $hc);
_.Le = function _hc(a, b) {
    return Dhc(JD(a, 112), JD(b, 112));
};
_.Fb = function aic(a) {
    return this === a;
};
_.Me = function bic() {
    return new uqb(this);
};
var LU = jeb(jwe, 'PortRestorer/lambda$3$Type', 1748);
Ycb(1749, 1, Ire, cic);
_.Mb = function dic(a) {
    return jhc(), JD(a, 112).c;
};
var MU = jeb(jwe, 'PortRestorer/lambda$4$Type', 1749);
Ycb(1750, 1, Ire, eic);
_.Mb = function fic(a) {
    return qhc(JD(a, 11));
};
var NU = jeb(jwe, 'PortRestorer/lambda$5$Type', 1750);
Ycb(1751, 1, Ire, gic);
_.Mb = function hic(a) {
    return jhc(), JD(a, 11).j == (Rjd(), xjd);
};
var OU = jeb(jwe, 'PortRestorer/lambda$6$Type', 1751);
Ycb(1752, 1, Ire, iic);
_.Mb = function jic(a) {
    return jhc(), JD(a, 11).j == (Rjd(), wjd);
};
var PU = jeb(jwe, 'PortRestorer/lambda$7$Type', 1752);
Ycb(1753, 1, Ire, kic);
_.Mb = function lic(a) {
    return rhc(JD(a, 11));
};
var QU = jeb(jwe, 'PortRestorer/lambda$8$Type', 1753);
Ycb(1754, 1, Ire, mic);
_.Mb = function nic(a) {
    return jhc(), JD(a, 11).j == (Rjd(), Ojd);
};
var RU = jeb(jwe, 'PortRestorer/lambda$9$Type', 1754);
Ycb(272, 23, {
    3: 1,
    34: 1,
    23: 1,
    272: 1
}, Eic);
var vic, wic, xic, yic, zic, Aic, Bic, Cic;
var TU = keb(jwe, 'PortSideAssigner/Target', 272, MI, Gic, Fic);
var Hic;
Ycb(1737, 1, {}, Jic);
_.Kb = function Kic(a) {
    return BBb(new RBb(null, new Gvb(JD(a, 105).j, 16)), new _ic);
};
var UU = jeb(jwe, 'PortSideAssigner/lambda$1$Type', 1737);
Ycb(1738, 1, {}, Lic);
_.Kb = function Mic(a) {
    return JD(a, 112).d;
};
var VU = jeb(jwe, 'PortSideAssigner/lambda$2$Type', 1738);
Ycb(1739, 1, kre, Nic);
_.Ad = function Oic(a) {
    aZb(JD(a, 11), (Rjd(), xjd));
};
var WU = jeb(jwe, 'PortSideAssigner/lambda$3$Type', 1739);
Ycb(1740, 1, {}, Pic);
_.Kb = function Qic(a) {
    return JD(a, 112).d;
};
var XU = jeb(jwe, 'PortSideAssigner/lambda$4$Type', 1740);
Ycb(1741, 1, kre, Ric);
_.Ad = function Sic(a) {
    sic(this.a, JD(a, 11));
};
var YU = jeb(jwe, 'PortSideAssigner/lambda$5$Type', 1741);
Ycb(1742, 1, Bte, Tic);
_.Le = function Uic(a, b) {
    return tic(JD(a, 105), JD(b, 105));
};
_.Fb = function Vic(a) {
    return this === a;
};
_.Me = function Wic() {
    return new uqb(this);
};
var ZU = jeb(jwe, 'PortSideAssigner/lambda$6$Type', 1742);
Ycb(1743, 1, Bte, Xic);
_.Le = function Yic(a, b) {
    return uic(JD(a, 112), JD(b, 112));
};
_.Fb = function Zic(a) {
    return this === a;
};
_.Me = function $ic() {
    return new uqb(this);
};
var $U = jeb(jwe, 'PortSideAssigner/lambda$7$Type', 1743);
Ycb(800, 1, Ire, _ic);
_.Mb = function ajc(a) {
    return JD(a, 112).c;
};
var _U = jeb(jwe, 'PortSideAssigner/lambda$8$Type', 800);
Ycb(2054, 1, {});
var aV = jeb(kwe, 'AbstractSelfLoopRouter', 2054);
Ycb(1762, 1, Bte, jjc);
_.Le = function kjc(a, b) {
    return hjc(JD(a, 105), JD(b, 105));
};
_.Fb = function ljc(a) {
    return this === a;
};
_.Me = function mjc() {
    return new uqb(this);
};
var bV = jeb(kwe, hue, 1762);
Ycb(1763, 1, Bte, njc);
_.Le = function ojc(a, b) {
    return ijc(JD(a, 105), JD(b, 105));
};
_.Fb = function pjc(a) {
    return this === a;
};
_.Me = function qjc() {
    return new uqb(this);
};
var cV = jeb(kwe, iue, 1763);
Ycb(1802, 2054, {}, Cjc);
_.lg = function Djc(a, b, c) {
    return c;
};
var eV = jeb(kwe, 'OrthogonalSelfLoopRouter', 1802);
Ycb(1804, 1, kre, Ejc);
_.Ad = function Fjc(a) {
    Bjc(this.b, this.a, JD(a, 8));
};
var dV = jeb(kwe, 'OrthogonalSelfLoopRouter/lambda$0$Type', 1804);
Ycb(1803, 1802, {}, Ijc);
_.lg = function Jjc(a, b, c) {
    var d, e;
    d = a.c.d;
    du(c, 0, mdd(odd(d.n), d.a));
    e = a.d.d;
    Atb(c, mdd(odd(e.n), e.a));
    return Gjc(c);
};
var fV = jeb(kwe, 'PolylineSelfLoopRouter', 1803);
Ycb(1758, 1, {}, Xjc);
_.a = null;
var Kjc;
var jV = jeb(kwe, 'RoutingDirector', 1758);
Ycb(1759, 1, Bte, Zjc);
_.Le = function $jc(a, b) {
    return Yjc(JD(a, 112), JD(b, 112));
};
_.Fb = function _jc(a) {
    return this === a;
};
_.Me = function akc() {
    return new uqb(this);
};
var gV = jeb(kwe, 'RoutingDirector/lambda$0$Type', 1759);
Ycb(1760, 1, {}, bkc);
_.Kb = function ckc(a) {
    return Ljc(), JD(a, 105).j;
};
var hV = jeb(kwe, 'RoutingDirector/lambda$1$Type', 1760);
Ycb(1761, 1, kre, dkc);
_.Ad = function ekc(a) {
    Ljc();
    JD(a, 15).gd(Kjc);
};
var iV = jeb(kwe, 'RoutingDirector/lambda$2$Type', 1761);
Ycb(1764, 1, {}, pkc);
var mV = jeb(kwe, 'RoutingSlotAssigner', 1764);
Ycb(1765, 1, Ire, skc);
_.Mb = function tkc(a) {
    return qkc(this.a, JD(a, 105));
};
var kV = jeb(kwe, 'RoutingSlotAssigner/lambda$0$Type', 1765);
Ycb(1766, 1, Bte, ukc);
_.Le = function vkc(a, b) {
    return rkc(this.a, JD(a, 105), JD(b, 105));
};
_.Fb = function wkc(a) {
    return this === a;
};
_.Me = function xkc() {
    return new uqb(this);
};
var lV = jeb(kwe, 'RoutingSlotAssigner/lambda$1$Type', 1766);
Ycb(1805, 1802, {}, zkc);
_.lg = function Akc(a, b, c) {
    var d, e, f, g;
    d = Beb(MD(uXb(a.b.g.b, (Bwc(), Yvc))));
    g = new Tdd(WC(OC(b2, 1), hre, 8, 0, [
        (f = a.c.d, mdd(new Fdd(f.n), f.a))
    ]));
    ykc(a, b, c, g, d);
    Atb(g, (e = a.d.d, mdd(new Fdd(e.n), e.a)));
    return vOc(new zOc(g));
};
var nV = jeb(kwe, 'SplineSelfLoopRouter', 1805);
Ycb(510, 1, Bte, Fkc, Hkc);
_.Le = function Ikc(a, b) {
    return Bkc(this, JD(a, 9), JD(b, 9));
};
_.Fb = function Jkc(a) {
    return this === a;
};
_.Me = function Kkc() {
    return new uqb(this);
};
_.a = false;
var rV = jeb(lwe, 'ModelOrderNodeComparator', 510);
Ycb(1767, 1, Ire, Lkc);
_.Mb = function Mkc(a) {
    return JD(a, 11).e.c.length != 0;
};
var oV = jeb(lwe, 'ModelOrderNodeComparator/lambda$0$Type', 1767);
Ycb(568, 1, Ire, Nkc);
_.Mb = function Okc(a) {
    return JD(a, 11).e.c.length != 0;
};
var pV = jeb(lwe, 'ModelOrderNodeComparator/lambda$1$Type', 568);
Ycb(569, 1, Ire, Pkc);
_.Mb = function Qkc(a) {
    return JD(a, 11).g.c.length != 0;
};
var qV = jeb(lwe, 'ModelOrderNodeComparator/lambda$2$Type', 569);
Ycb(651, 1, Bte, Xkc, Ykc);
_.Le = function Zkc(a, b) {
    return Ukc(this, a, b);
};
_.Fb = function $kc(a) {
    return this === a;
};
_.Me = function _kc() {
    return new uqb(this);
};
_.b = false;
var sV = jeb(lwe, 'ModelOrderPortComparator', 651);
Ycb(1603, 1, Dve, hlc);
_.If = function ilc(a, b) {
    elc(JD(a, 36));
};
var tV = jeb('org.eclipse.elk.alg.layered.intermediate.unzipping', 'AlternatingLayerUnzipper', 1603);
Ycb(795, 1, {}, jlc);
_.mg = function llc(a, b) {
    var c, d, e, f;
    e = klc(b);
    c = new Ulb;
    f = b.f / e;
    for(d = 1; d < e; ++d)Ilb(c, jfb(Pcb(zcb($wnd.Math.round(d * f)))));
    return c;
};
_.ng = function mlc() {
    return false;
};
var uV = jeb(mwe, 'ARDCutIndexHeuristic', 795);
Ycb(1484, 1, Dve, rlc);
_.If = function slc(a, b) {
    qlc(JD(a, 36), b);
};
var xV = jeb(mwe, 'BreakingPointInserter', 1484);
Ycb(314, 1, {
    314: 1
}, tlc);
_.Ib = function wlc() {
    var a;
    a = new Ugb;
    a.a += 'BPInfo[';
    a.a += '\n\tstart=';
    Pgb(a, this.i);
    a.a += '\n\tend=';
    Pgb(a, this.a);
    a.a += '\n\tnodeStartEdge=';
    Pgb(a, this.e);
    a.a += '\n\tstartEndEdge=';
    Pgb(a, this.j);
    a.a += '\n\toriginalEdge=';
    Pgb(a, this.f);
    a.a += '\n\tstartInLayerDummy=';
    Pgb(a, this.k);
    a.a += '\n\tstartInLayerEdge=';
    Pgb(a, this.n);
    a.a += '\n\tendInLayerDummy=';
    Pgb(a, this.b);
    a.a += '\n\tendInLayerEdge=';
    Pgb(a, this.c);
    return a.a;
};
var vV = jeb(mwe, 'BreakingPointInserter/BPInfo', 314);
Ycb(645, 1, {
    645: 1
}, Dlc);
_.a = false;
_.b = 0;
_.c = 0;
var wV = jeb(mwe, 'BreakingPointInserter/Cut', 645);
Ycb(1485, 1, Dve, Nlc);
_.If = function Olc(a, b) {
    Llc(JD(a, 36), b);
};
var AV = jeb(mwe, 'BreakingPointProcessor', 1485);
Ycb(1486, 1, Ire, Plc);
_.Mb = function Qlc(a) {
    return ulc(JD(a, 9));
};
var yV = jeb(mwe, 'BreakingPointProcessor/0methodref$isEnd$Type', 1486);
Ycb(1487, 1, Ire, Rlc);
_.Mb = function Slc(a) {
    return vlc(JD(a, 9));
};
var zV = jeb(mwe, 'BreakingPointProcessor/1methodref$isStart$Type', 1487);
Ycb(1488, 1, Dve, Wlc);
_.If = function Xlc(a, b) {
    Ulc(this, JD(a, 36), b);
};
var CV = jeb(mwe, 'BreakingPointRemover', 1488);
Ycb(1489, 1, kre, Ylc);
_.Ad = function Zlc(a) {
    JD(a, 132).k = true;
};
var BV = jeb(mwe, 'BreakingPointRemover/lambda$0$Type', 1489);
Ycb(791, 1, {}, imc);
_.b = 0;
_.e = 0;
_.f = 0;
_.j = 0;
var IV = jeb(mwe, 'GraphStats', 791);
Ycb(792, 1, {}, kmc);
_.Te = function lmc(a, b) {
    return $wnd.Math.max(Beb(MD(a)), Beb(MD(b)));
};
var DV = jeb(mwe, 'GraphStats/0methodref$max$Type', 792);
Ycb(793, 1, {}, mmc);
_.Te = function nmc(a, b) {
    return $wnd.Math.max(Beb(MD(a)), Beb(MD(b)));
};
var EV = jeb(mwe, 'GraphStats/2methodref$max$Type', 793);
Ycb(1668, 1, {}, omc);
_.Te = function pmc(a, b) {
    return jmc(MD(a), MD(b));
};
var FV = jeb(mwe, 'GraphStats/lambda$1$Type', 1668);
Ycb(1669, 1, {}, qmc);
_.Kb = function rmc(a) {
    return cmc(this.a, JD(a, 25));
};
var GV = jeb(mwe, 'GraphStats/lambda$2$Type', 1669);
Ycb(1670, 1, {}, smc);
_.Kb = function tmc(a) {
    return bmc(this.a, JD(a, 25));
};
var HV = jeb(mwe, 'GraphStats/lambda$6$Type', 1670);
Ycb(794, 1, {}, umc);
_.mg = function vmc(a, b) {
    var c;
    c = JD(WMb(a, (Bwc(), swc)), 15);
    return c ? c : (pnb(), pnb(), mnb);
};
_.ng = function wmc() {
    return false;
};
var JV = jeb(mwe, 'ICutIndexCalculator/ManualCutIndexCalculator', 794);
Ycb(796, 1, {}, xmc);
_.mg = function ymc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    u = (b.n == null && fmc(b), b.n);
    i = (b.d == null && fmc(b), b.d);
    t = SC(aE, Rse, 30, u.length, 15, 1);
    t[0] = u[0];
    r = u[0];
    for(j = 1; j < u.length; j++){
        t[j] = t[j - 1] + u[j];
        r += u[j];
    }
    e = klc(b) - 1;
    g = JD(WMb(a, (Bwc(), twc)), 17).a;
    d = Lse;
    c = new Ulb;
    for(m = $wnd.Math.max(0, e - g); m <= $wnd.Math.min(b.f - 1, e + g); m++){
        p = r / (m + 1);
        q = 0;
        k = 1;
        f = new Ulb;
        s = Lse;
        l = 0;
        h = 0;
        o = i[0];
        if (m == 0) {
            s = r;
            h = (b.g == null && (b.g = amc(b, new mmc)), Beb(b.g));
        } else {
            while(k < b.f){
                if (t[k - 1] - q >= p) {
                    Ilb(f, jfb(k));
                    s = $wnd.Math.max(s, t[k - 1] - l);
                    h += o;
                    q += t[k - 1] - q;
                    l = t[k - 1];
                    o = i[k];
                }
                o = $wnd.Math.max(o, i[k]);
                ++k;
            }
            h += o;
        }
        n = $wnd.Math.min(1 / s, 1 / b.b / h);
        if (n > d) {
            d = n;
            c = f;
        }
    }
    return c;
};
_.ng = function zmc() {
    return false;
};
var KV = jeb(mwe, 'MSDCutIndexHeuristic', 796);
Ycb(1624, 1, Dve, Cmc);
_.If = function Dmc(a, b) {
    Bmc(JD(a, 36), b);
};
var LV = jeb(mwe, 'SingleEdgeGraphWrapper', 1624);
Ycb(231, 23, {
    3: 1,
    34: 1,
    23: 1,
    231: 1
}, Omc);
var Hmc, Imc, Jmc, Kmc, Lmc, Mmc;
var MV = keb(nwe, 'CenterEdgeLabelPlacementStrategy', 231, MI, Qmc, Pmc);
var Rmc;
Ycb(419, 23, {
    3: 1,
    34: 1,
    23: 1,
    419: 1
}, Wmc);
var Tmc, Umc;
var NV = keb(nwe, 'ConstraintCalculationStrategy', 419, MI, Ymc, Xmc);
var Zmc;
Ycb(323, 23, {
    3: 1,
    34: 1,
    23: 1,
    323: 1,
    188: 1,
    196: 1
}, enc);
_.bg = function gnc() {
    return dnc(this);
};
_.og = function fnc() {
    return dnc(this);
};
var _mc, anc, bnc;
var OV = keb(nwe, 'CrossingMinimizationStrategy', 323, MI, inc, hnc);
var jnc;
Ycb(347, 23, {
    3: 1,
    34: 1,
    23: 1,
    347: 1
}, pnc);
var lnc, mnc, nnc;
var PV = keb(nwe, 'CuttingStrategy', 347, MI, rnc, qnc);
var snc;
Ycb(344, 23, {
    3: 1,
    34: 1,
    23: 1,
    344: 1,
    188: 1,
    196: 1
}, Bnc);
_.bg = function Dnc() {
    return Anc(this);
};
_.og = function Cnc() {
    return Anc(this);
};
var unc, vnc, wnc, xnc, ync;
var QV = keb(nwe, 'CycleBreakingStrategy', 344, MI, Fnc, Enc);
var Gnc;
Ycb(416, 23, {
    3: 1,
    34: 1,
    23: 1,
    416: 1
}, Lnc);
var Inc, Jnc;
var RV = keb(nwe, 'DirectionCongruency', 416, MI, Nnc, Mnc);
var Onc;
Ycb(446, 23, {
    3: 1,
    34: 1,
    23: 1,
    446: 1
}, Unc);
var Qnc, Rnc, Snc;
var SV = keb(nwe, 'EdgeConstraint', 446, MI, Wnc, Vnc);
var Xnc;
Ycb(281, 23, {
    3: 1,
    34: 1,
    23: 1,
    281: 1
}, foc);
var Znc, $nc, _nc, aoc, boc, coc;
var TV = keb(nwe, 'EdgeLabelSideSelection', 281, MI, hoc, goc);
var ioc;
Ycb(474, 23, {
    3: 1,
    34: 1,
    23: 1,
    474: 1
}, noc);
var koc, loc;
var UV = keb(nwe, 'EdgeStraighteningStrategy', 474, MI, poc, ooc);
var qoc;
Ycb(279, 23, {
    3: 1,
    34: 1,
    23: 1,
    279: 1
}, zoc);
var soc, toc, uoc, voc, woc, xoc;
var VV = keb(nwe, 'FixedAlignment', 279, MI, Boc, Aoc);
var Coc;
Ycb(280, 23, {
    3: 1,
    34: 1,
    23: 1,
    280: 1
}, Loc);
var Eoc, Foc, Goc, Hoc, Ioc, Joc;
var WV = keb(nwe, 'GraphCompactionStrategy', 280, MI, Noc, Moc);
var Ooc;
Ycb(259, 23, {
    3: 1,
    34: 1,
    23: 1,
    259: 1
}, _oc);
var Qoc, Roc, Soc, Toc, Uoc, Voc, Woc, Xoc, Yoc, Zoc;
var XV = keb(nwe, 'GraphProperties', 259, MI, bpc, apc);
var cpc;
Ycb(298, 23, {
    3: 1,
    34: 1,
    23: 1,
    298: 1
}, ipc);
var epc, fpc, gpc;
var YV = keb(nwe, 'GreedySwitchType', 298, MI, kpc, jpc);
var lpc;
Ycb(312, 23, {
    3: 1,
    34: 1,
    23: 1,
    312: 1
}, rpc);
var npc, opc, ppc;
var ZV = keb(nwe, 'InLayerConstraint', 312, MI, tpc, spc);
var upc;
Ycb(417, 23, {
    3: 1,
    34: 1,
    23: 1,
    417: 1
}, zpc);
var wpc, xpc;
var $V = keb(nwe, 'InteractiveReferencePoint', 417, MI, Bpc, Apc);
var Cpc;
var Epc, Fpc, Gpc, Hpc, Ipc, Jpc, Kpc, Lpc, Mpc, Npc, Opc, Ppc, Qpc, Rpc, Spc, Tpc, Upc, Vpc, Wpc, Xpc, Ypc, Zpc, $pc, _pc, aqc, bqc, cqc, dqc, eqc, fqc, gqc, hqc, iqc, jqc, kqc, lqc, mqc, nqc, oqc, pqc, qqc, rqc, sqc, tqc, uqc, vqc, wqc, xqc, yqc, zqc, Aqc, Bqc, Cqc, Dqc, Eqc, Fqc, Gqc, Hqc;
Ycb(171, 23, {
    3: 1,
    34: 1,
    23: 1,
    171: 1
}, Pqc);
var Jqc, Kqc, Lqc, Mqc, Nqc;
var _V = keb(nwe, 'LayerConstraint', 171, MI, Rqc, Qqc);
var Sqc;
Ycb(420, 23, {
    3: 1,
    34: 1,
    23: 1,
    420: 1
}, Xqc);
var Uqc, Vqc;
var aW = keb(nwe, 'LayerUnzippingStrategy', 420, MI, Zqc, Yqc);
var $qc;
Ycb(838, 1, Hue, Ptc);
_.tf = function Qtc(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, uwe), ''), 'Direction Congruency'), 'Specifies how drawings of the same graph with different layout directions compare to each other: either a natural reading direction is preserved or the drawings are rotated versions of each other.'), Nrc), (zcd(), tcd)), RV), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, vwe), ''), 'Feedback Edges'), 'Whether feedback edges should be highlighted by routing around the nodes.'), (xdb(), false)), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, wwe), ''), 'Interactive Reference Point'), 'Determines which point of a node is considered by interactive layout phases.'), isc), tcd), $V), mrb(jcd))));
    Oad(a, wwe, Ewe, ksc);
    Oad(a, wwe, Owe, jsc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, xwe), ''), 'Merge Edges'), 'Edges that have no ports are merged so they touch the connected nodes at the same points. When this option is disabled, one port is created for each edge directly connected to a node. When it is enabled, all such incoming edges share an input port, and all outgoing edges share an output port.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, ywe), ''), 'Merge Hierarchy-Crossing Edges'), 'If hierarchical layout is active, hierarchy-crossing edges use as few hierarchical ports as possible. They are broken by the algorithm, with hierarchical ports inserted as required. Usually, one such port is created for each edge at each hierarchy crossing point. With this option set to true, we try to create as few hierarchical ports as possible in the process. In particular, all edges that form a hyperedge can share a port.'), true), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(acd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, zwe), ''), 'Allow Non-Flow Ports To Switch Sides'), "Specifies whether non-flow ports may switch sides if their node's port constraints are either FIXED_SIDE or FIXED_ORDER. A non-flow port is a port on a side that is not part of the currently configured layout flow. For instance, given a left-to-right layout direction, north and south ports would be considered non-flow ports. Further note that the underlying criterium whether to switch sides or not solely relies on the minimization of edge crossings. Hence, edge length and other aesthetics criteria are not addressed."), false), rcd), GI), mrb(kcd)), WC(OC(hJ, 1), hre, 2, 6, [
        'org.eclipse.elk.layered.northOrSouthPort'
    ]))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Awe), ''), 'Port Sorting Strategy'), "Only relevant for nodes with FIXED_SIDE port constraints. Determines the way a node's ports are distributed on the sides of a node if their order is not prescribed. The option is set on parent nodes."), atc), tcd), lW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Bwe), ''), 'Thoroughness'), 'How much effort should be spent to produce a nice layout.'), jfb(7)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Cwe), ''), 'Add Unnecessary Bendpoints'), 'Adds bend points even if an edge does not change direction. If true, each long edge dummy will contribute a bend point to its edges and hierarchy-crossing edges will always get a bend point where they cross hierarchy boundaries. By default, bend points are only added where an edge changes direction.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Dwe), ''), 'Generate Position and Layer IDs'), 'If enabled position id and layer id are generated, which are usually only used internally when setting the interactiveLayout option. This option should be specified on the root node.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Ewe), 'cycleBreaking'), 'Cycle Breaking Strategy'), 'Strategy for cycle breaking. Cycle breaking looks for cycles in the graph and determines which edges to reverse to break the cycles. Reversed edges will end up pointing to the opposite direction of regular edges (that is, reversed edges will point left if edges usually point right).'), Lrc), tcd), QV), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Fwe), Txe), 'Node Layering Strategy'), 'Strategy for node layering.'), zsc), tcd), fW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Gwe), Txe), 'Layer Constraint'), 'Determines a constraint on the placement of the node regarding the layering.'), psc), tcd), _V), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Hwe), Txe), 'Layer Choice Constraint'), "Allows to set a constraint regarding the layer placement of a node. Let i be the value of teh constraint. Assumed the drawing has n layers and i < n. If set to i, it expresses that the node should be placed in i-th layer. Should i>=n be true then the node is placed in the last layer of the drawing. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), null), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Iwe), Txe), 'Layer ID'), 'Layer identifier that was calculated by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set.'), jfb(-1)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Jwe), Uxe), 'Upper Bound On Width [MinWidth Layerer]'), "Defines a loose upper bound on the width of the MinWidth layerer. If set to '-1' multiple values are tested and the best result is selected."), jfb(4)), vcd), UI), mrb(jcd))));
    Oad(a, Jwe, Fwe, ssc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Kwe), Uxe), 'Upper Layer Estimation Scaling Factor [MinWidth Layerer]'), "Multiplied with Upper Bound On Width for defining an upper bound on the width of layers which haven't been determined yet, but whose maximum width had been (roughly) estimated by the MinWidth algorithm. Compensates for too high estimations. If set to '-1' multiple values are tested and the best result is selected."), jfb(2)), vcd), UI), mrb(jcd))));
    Oad(a, Kwe, Fwe, usc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Lwe), Vxe), 'Node Promotion Strategy'), 'Reduces number of dummy nodes after layering phase (if possible).'), xsc), tcd), jW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Mwe), Vxe), 'Max Node Promotion Iterations'), 'Limits the number of iterations for node promotion.'), jfb(0)), vcd), UI), mrb(jcd))));
    Oad(a, Mwe, Lwe, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Nwe), 'layering.coffmanGraham'), 'Layer Bound'), 'The maximum number of nodes allowed per layer.'), jfb(Hqe)), vcd), UI), mrb(jcd))));
    Oad(a, Nwe, Fwe, msc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Owe), Wxe), 'Crossing Minimization Strategy'), 'Strategy for crossing minimization.'), Jrc), tcd), OV), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Pwe), Wxe), 'Force Node Model Order'), 'The node order given by the model does not change to produce a better layout. E.g. if node A is before node B in the model this is not changed during crossing minimization. This assumes that the node model order is already respected before crossing minimization. This can be achieved by setting considerModelOrder.strategy to NODES_AND_EDGES.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Qwe), Wxe), 'Hierarchical Sweepiness'), 'How likely it is to use cross-hierarchy (1) vs bottom-up (-1).'), 0.1), scd), LI), mrb(jcd))));
    Oad(a, Qwe, Xxe, Brc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Rwe), Wxe), 'Semi-Interactive Crossing Minimization'), "Preserves the order of nodes within a layer but still minimizes crossings between edges connecting long edge dummies. Derives the desired order from positions specified by the 'org.eclipse.elk.position' layout option. Requires a crossing minimization strategy that is able to process 'in-layer' constraints."), false), rcd), GI), mrb(jcd))));
    Oad(a, Rwe, Owe, Hrc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Swe), Wxe), 'In Layer Predecessor of'), "Allows to set a constraint which specifies of which node the current node is the predecessor. If set to 's' then the node is the predecessor of 's' and is in the same layer"), null), xcd), hJ), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Twe), Wxe), 'In Layer Successor of'), "Allows to set a constraint which specifies of which node the current node is the successor. If set to 's' then the node is the successor of 's' and is in the same layer"), null), xcd), hJ), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Uwe), Wxe), 'Position Choice Constraint'), "Allows to set a constraint regarding the position placement of a node in a layer. Assumed the layer in which the node placed includes n other nodes and i < n. If set to i, it expresses that the node should be placed at the i-th position. Should i>=n be true then the node is placed at the last position in the layer. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), null), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Vwe), Wxe), 'Position ID'), 'Position within a layer that was determined by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set.'), jfb(-1)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Wwe), Yxe), 'Greedy Switch Activation Threshold'), "By default it is decided automatically if the greedy switch is activated or not. The decision is based on whether the size of the input graph (without dummy nodes) is smaller than the value of this option. A '0' enforces the activation."), jfb(40)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Xwe), Yxe), 'Greedy Switch Crossing Minimization'), "Greedy Switch strategy for crossing minimization. The greedy switch heuristic is executed after the regular crossing minimization as a post-processor. Note that if 'hierarchyHandling' is set to 'INCLUDE_CHILDREN', the 'greedySwitchHierarchical.type' option must be used."), yrc), tcd), YV), mrb(jcd))));
    Oad(a, Xwe, Owe, zrc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Ywe), 'crossingMinimization.greedySwitchHierarchical'), 'Greedy Switch Crossing Minimization (hierarchical)'), "Activates the greedy switch heuristic in case hierarchical layout is used. The differences to the non-hierarchical case (see 'greedySwitch.type') are: 1) greedy switch is inactive by default, 3) only the option value set on the node at which hierarchical layout starts is relevant, and 2) if it's activated by the user, it properly addresses hierarchy-crossing edges."), urc), tcd), YV), mrb(jcd))));
    Oad(a, Ywe, Owe, vrc);
    Oad(a, Ywe, Xxe, wrc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Zwe), Zxe), 'Node Placement Strategy'), 'Strategy for node placement.'), $sc), tcd), iW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, $we), Zxe), 'Favor Straight Edges Over Balancing'), "Favor straight edges over a balanced node placement. The default behavior is determined automatically based on the used 'edgeRouting'. For an orthogonal style it is set to true, for all other styles to false."), rcd), GI), mrb(jcd))));
    Oad(a, $we, Zwe, Qsc);
    Oad(a, $we, Zwe, Rsc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, _we), $xe), 'BK Edge Straightening'), "Specifies whether the Brandes Koepf node placer tries to increase the number of straight edges at the expense of diagram size. There is a subtle difference to the 'favorStraightEdges' option, which decides whether a balanced placement of the nodes is desired, or not. In bk terms this means combining the four alignments into a single balanced one, or not. This option on the other hand tries to straighten additional edges during the creation of each of the four alignments."), Ksc), tcd), UV), mrb(jcd))));
    Oad(a, _we, Zwe, Lsc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, axe), $xe), 'BK Fixed Alignment'), 'Tells the BK node placer to use a certain alignment (out of its four) instead of the one producing the smallest height, or the combination of all four.'), Nsc), tcd), VV), mrb(jcd))));
    Oad(a, axe, Zwe, Osc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, bxe), 'nodePlacement.linearSegments'), 'Linear Segments Deflection Dampening'), 'Dampens the movement of nodes to keep the diagram from getting too large.'), 0.3), scd), LI), mrb(jcd))));
    Oad(a, bxe, Zwe, Tsc);
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, cxe), 'nodePlacement.networkSimplex'), 'Node Flexibility'), "Aims at shorter and straighter edges. Two configurations are possible: (a) allow ports to move freely on the side they are assigned to (the order is always defined beforehand), (b) additionally allow to enlarge a node wherever it helps. If this option is not configured for a node, the 'nodeFlexibility.default' value is used, which is specified for the node's parent."), tcd), hW), mrb(icd))));
    Oad(a, cxe, Zwe, Ysc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, dxe), 'nodePlacement.networkSimplex.nodeFlexibility'), 'Node Flexibility Default'), "Default value of the 'nodeFlexibility' option for the children of a hierarchical node."), Wsc), tcd), hW), mrb(jcd))));
    Oad(a, dxe, Zwe, Xsc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, exe), _xe), 'Self-Loop Distribution'), 'Alter the distribution of the loops around the node. It only takes effect for PortConstraints.FREE.'), Vrc), tcd), nW), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, fxe), _xe), 'Self-Loop Ordering'), 'Alter the ordering of the loops they can either be stacked or sequenced. It only takes effect for PortConstraints.FREE.'), Xrc), tcd), oW), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, gxe), 'edgeRouting.splines'), 'Spline Routing Mode'), 'Specifies the way control points are assembled for each individual edge. CONSERVATIVE ensures that edges are properly routed around the nodes but feels rather orthogonal at times. SLOPPY uses fewer control points to obtain curvier edge routes but may result in edges overlapping nodes.'), Zrc), tcd), qW), mrb(jcd))));
    Oad(a, gxe, aye, $rc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, hxe), 'edgeRouting.splines.sloppy'), 'Sloppy Spline Layer Spacing Factor'), 'Spacing factor for routing area between layers when using sloppy spline routing.'), 0.2), scd), LI), mrb(jcd))));
    Oad(a, hxe, aye, asc);
    Oad(a, hxe, gxe, bsc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, ixe), 'edgeRouting.polyline'), 'Sloped Edge Zone Width'), 'Width of the strip to the left and to the right of each layer where the polyline edge router is allowed to refrain from ensuring that edges are routed horizontally. This prevents awkward bend points for nodes that extent almost to the edge of their layer.'), 2), scd), LI), mrb(jcd))));
    Oad(a, ixe, aye, Trc);
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, jxe), bye), 'Spacing Base Value'), "An optional base value for all other layout options of the 'spacing' group. It can be used to conveniently alter the overall 'spaciousness' of the drawing. Whenever an explicit value is set for the other layout options, this base value will have no effect. The base value is not inherited, i.e. it must be set for each hierarchical node."), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, kxe), bye), 'Edge Node Between Layers Spacing'), "The spacing to be preserved between nodes and edges that are routed next to the node's layer. For the spacing between nodes and edges that cross the node's layer 'spacing.edgeNode' is used."), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, lxe), bye), 'Edge Edge Between Layer Spacing'), "Spacing to be preserved between pairs of edges that are routed between the same pair of layers. Note that 'spacing.edgeEdge' is used for the spacing between pairs of edges crossing the same layer."), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, mxe), bye), 'Node Node Between Layers Spacing'), "The spacing to be preserved between any pair of nodes of two adjacent layers. Note that 'spacing.nodeNode' is used for the spacing between nodes within the layer itself."), 20), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, nxe), cye), 'Direction Priority'), 'Defines how important it is to have a certain edge point into the direction of the overall layout. This option is evaluated during the cycle breaking phase.'), jfb(0)), vcd), UI), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, oxe), cye), 'Shortness Priority'), 'Defines how important it is to keep an edge as short as possible. This option is evaluated during the layering phase.'), jfb(0)), vcd), UI), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, pxe), cye), 'Straightness Priority'), 'Defines how important it is to keep an edge straight, i.e. aligned with one of the two axes. This option is evaluated during node placement.'), jfb(0)), vcd), UI), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, qxe), dye), 'Connected Components Compaction'), 'Tries to further compact components (disconnected sub-graphs).'), false), rcd), GI), mrb(jcd))));
    Oad(a, qxe, Que, true);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, rxe), eye), 'Post Compaction Strategy'), fye), frc), tcd), WV), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, sxe), eye), 'Post Compaction Constraint Calculation'), fye), drc), tcd), NV), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, txe), gye), 'High Degree Node Treatment'), 'Makes room around high degree nodes to place leafs and trees.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, uxe), gye), 'High Degree Node Threshold'), 'Whether a node is considered to have a high degree.'), jfb(16)), vcd), UI), mrb(jcd))));
    Oad(a, uxe, txe, true);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, vxe), gye), 'High Degree Node Maximum Tree Height'), 'Maximum height of a subtree connected to a high degree node to be moved to separate layers.'), jfb(5)), vcd), UI), mrb(jcd))));
    Oad(a, vxe, txe, true);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, wxe), hye), 'Graph Wrapping Strategy'), "For certain graphs and certain prescribed drawing areas it may be desirable to split the laid out graph into chunks that are placed side by side. The edges that connect different chunks are 'wrapped' around from the end of one chunk to the start of the other chunk. The points between the chunks are referred to as 'cuts'."), Gtc), tcd), sW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, xxe), hye), 'Additional Wrapped Edges Spacing'), 'To visually separate edges that are wrapped from regularly routed edges an additional spacing value can be specified in form of this layout option. The spacing is added to the regular edgeNode spacing.'), 10), scd), LI), mrb(jcd))));
    Oad(a, xxe, wxe, ltc);
    Oad(a, xxe, wxe, mtc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, yxe), hye), 'Correction Factor for Wrapping'), "At times and for certain types of graphs the executed wrapping may produce results that are consistently biased in the same fashion: either wrapping to often or to rarely. This factor can be used to correct the bias. Internally, it is simply multiplied with the 'aspect ratio' layout option."), 1), scd), LI), mrb(jcd))));
    Oad(a, yxe, wxe, otc);
    Oad(a, yxe, wxe, ptc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, zxe), iye), 'Cutting Strategy'), 'The strategy by which the layer indexes are determined at which the layering crumbles into chunks.'), wtc), tcd), PV), mrb(jcd))));
    Oad(a, zxe, wxe, xtc);
    Oad(a, zxe, wxe, ytc);
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Axe), iye), 'Manually Specified Cuts'), 'Allows the user to specify her own cuts for a certain graph.'), wcd), HK), mrb(jcd))));
    Oad(a, Axe, zxe, rtc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Bxe), 'wrapping.cutting.msd'), 'MSD Freedom'), 'The MSD cutting strategy starts with an initial guess on the number of chunks the graph should be split into. The freedom specifies how much the strategy may deviate from this guess. E.g. if an initial number of 3 is computed, a freedom of 1 allows 2, 3, and 4 cuts.'), ttc), vcd), UI), mrb(jcd))));
    Oad(a, Bxe, zxe, utc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Cxe), jye), 'Validification Strategy'), 'When wrapping graphs, one can specify indices that are not allowed as split points. The validification strategy makes sure every computed split point is allowed.'), Ltc), tcd), rW), mrb(jcd))));
    Oad(a, Cxe, wxe, Mtc);
    Oad(a, Cxe, wxe, Ntc);
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Dxe), jye), 'Valid Indices for Wrapping'), null), wcd), HK), mrb(jcd))));
    Oad(a, Dxe, wxe, Itc);
    Oad(a, Dxe, wxe, Jtc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Exe), kye), 'Improve Cuts'), 'For general graphs it is important that not too many edges wrap backwards. Thus a compromise between evenly-distributed cuts and the total number of cut edges is sought.'), true), rcd), GI), mrb(jcd))));
    Oad(a, Exe, wxe, Ctc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Fxe), kye), 'Distance Penalty When Improving Cuts'), null), 2), scd), LI), mrb(jcd))));
    Oad(a, Fxe, wxe, Atc);
    Oad(a, Fxe, Exe, true);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Gxe), kye), 'Improve Wrapped Edges'), 'The initial wrapping is performed in a very simple way. As a consequence, edges that wrap from one chunk to another may be unnecessarily long. Activating this option tries to shorten such edges.'), true), rcd), GI), mrb(jcd))));
    Oad(a, Gxe, wxe, Etc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Hxe), lye), 'Layer Unzipping Strategy'), "The strategy to use for unzipping a layer into multiple sublayers while maintaining the existing ordering of nodes and edges after crossing minimization. The default value is 'NONE'."), Gsc), tcd), aW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Ixe), lye), 'Unzipping Layer Split'), 'Defines the number of sublayers to split a layer into. The property can be set to the nodes in a layer, which then applies the property for the layer. If multiple nodes set the value to different values, then the lowest value is chosen.'), Bsc), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Jxe), lye), 'Reset Alternation on Long Edges'), 'If set to true, nodes will always be placed in the first sublayer after a long edge when using the ALTERNATING strategy. Otherwise long edge dummies are treated the same as regular nodes. The default value is true. The property can be set to the nodes in a layer, which then applies the property for the layer. If any node sets the value to false, then the value is set to false for the entire layer.'), Dsc), rcd), GI), mrb(icd))));
    Oad(a, Jxe, Hxe, Esc);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Kxe), mye), 'Edge Label Side Selection'), 'Method to decide on edge label sides.'), Rrc), tcd), TV), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Lxe), mye), 'Edge Center Label Placement Strategy'), 'Determines in which layer center labels of long edges should be placed.'), Prc), tcd), MV), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        hcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Mxe), nye), 'Consider Model Order'), 'Preserves the order of nodes and edges in the model file if this does not lead to additional edge crossings. Depending on the strategy this is not always possible since the node and edge order might be conflicting.'), prc), tcd), kW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Nxe), nye), 'Consider Port Order'), 'If disabled the port order of output ports is derived from the edge order and input ports are ordered by their incoming connections. If enabled all ports are ordered by the port model order.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Oxe), nye), 'No Model Order'), 'Set on a node to not set a model order for this node even though it is a real node.'), false), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Pxe), nye), 'Consider Model Order for Components'), 'If set to NONE the usual ordering strategy (by cumulative node priority and size of nodes) is used. INSIDE_PORT_SIDES orders the components with external ports only inside the groups with the same port side. FORCE_MODEL_ORDER enforces the mode order on components. This option might produce bad alignments and sub optimal drawings in terms of used area since the ordering should be respected.'), hrc), tcd), iP), mrb(jcd))));
    Oad(a, Pxe, Que, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Qxe), nye), 'Long Edge Ordering Strategy'), 'Indicates whether long edges are sorted under, over, or equal to nodes that have no connection to a previous layer in a left-to-right or right-to-left layout. Under and over changes to right and left in a vertical layout.'), lrc), tcd), gW), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Rxe), nye), 'Crossing Counter Node Order Influence'), 'Indicates with what percentage (1 for 100%) violations of the node model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal node order. Defaults to no influence (0).'), 0), scd), LI), mrb(jcd))));
    Oad(a, Rxe, Mxe, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Sxe), nye), 'Crossing Counter Port Order Influence'), 'Indicates with what percentage (1 for 100%) violations of the port model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal port order. Defaults to no influence (0).'), 0), scd), LI), mrb(jcd))));
    Oad(a, Sxe, Mxe, null);
    Cwc((new Dwc, a));
};
var arc, brc, crc, drc, erc, frc, grc, hrc, irc, jrc, krc, lrc, mrc, nrc, orc, prc, qrc, rrc, trc, urc, vrc, wrc, xrc, yrc, zrc, Arc, Brc, Crc, Drc, Erc, Frc, Grc, Hrc, Irc, Jrc, Krc, Lrc, Mrc, Nrc, Orc, Prc, Qrc, Rrc, Src, Trc, Urc, Vrc, Wrc, Xrc, Yrc, Zrc, $rc, _rc, asc, bsc, csc, dsc, esc, fsc, gsc, hsc, isc, jsc, ksc, lsc, msc, nsc, osc, psc, qsc, rsc, ssc, tsc, usc, vsc, wsc, xsc, ysc, zsc, Asc, Bsc, Csc, Dsc, Esc, Fsc, Gsc, Hsc, Isc, Jsc, Ksc, Lsc, Msc, Nsc, Osc, Psc, Qsc, Rsc, Ssc, Tsc, Usc, Vsc, Wsc, Xsc, Ysc, Zsc, $sc, _sc, atc, btc, ctc, dtc, etc, ftc, gtc, htc, itc, jtc, ktc, ltc, mtc, ntc, otc, ptc, qtc, rtc, stc, ttc, utc, vtc, wtc, xtc, ytc, ztc, Atc, Btc, Ctc, Dtc, Etc, Ftc, Gtc, Htc, Itc, Jtc, Ktc, Ltc, Mtc, Ntc;
var bW = jeb(nwe, 'LayeredMetaDataProvider', 838);
Ycb(975, 1, Hue, Dwc);
_.tf = function Ewc(a) {
    Cwc(a);
};
var Rtc, Stc, Ttc, Utc, Vtc, Wtc, Xtc, Ytc, Ztc, $tc, _tc, auc, buc, cuc, duc, euc, fuc, guc, huc, iuc, juc, kuc, luc, muc, nuc, ouc, puc, quc, ruc, suc, tuc, uuc, vuc, wuc, xuc, yuc, zuc, Auc, Buc, Cuc, Duc, Euc, Fuc, Guc, Huc, Iuc, Juc, Kuc, Luc, Muc, Nuc, Ouc, Puc, Quc, Ruc, Suc, Tuc, Uuc, Vuc, Wuc, Xuc, Yuc, Zuc, $uc, _uc, avc, bvc, cvc, dvc, evc, fvc, gvc, hvc, ivc, jvc, kvc, lvc, mvc, nvc, ovc, pvc, qvc, rvc, svc, tvc, uvc, vvc, wvc, xvc, yvc, zvc, Avc, Bvc, Cvc, Dvc, Evc, Fvc, Gvc, Hvc, Ivc, Jvc, Kvc, Lvc, Mvc, Nvc, Ovc, Pvc, Qvc, Rvc, Svc, Tvc, Uvc, Vvc, Wvc, Xvc, Yvc, Zvc, $vc, _vc, awc, bwc, cwc, dwc, ewc, fwc, gwc, hwc, iwc, jwc, kwc, lwc, mwc, nwc, owc, pwc, qwc, rwc, swc, twc, uwc, vwc, wwc, xwc, ywc, zwc, Awc;
var dW = jeb(nwe, 'LayeredOptions', 975);
Ycb(976, 1, {}, Fwc);
_.uf = function Gwc() {
    var a;
    return a = new vQb, a;
};
_.vf = function Hwc(a) {};
var cW = jeb(nwe, 'LayeredOptions/LayeredFactory', 976);
Ycb(1330, 1, {});
_.a = 0;
var Iwc;
var V2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder', 1330);
Ycb(772, 1330, {}, Uwc);
var Rwc, Swc;
var eW = jeb(nwe, 'LayeredSpacings/LayeredSpacingsBuilder', 772);
Ycb(265, 23, {
    3: 1,
    34: 1,
    23: 1,
    265: 1,
    188: 1,
    196: 1
}, exc);
_.bg = function gxc() {
    return dxc(this);
};
_.og = function fxc() {
    return dxc(this);
};
var Vwc, Wwc, Xwc, Ywc, Zwc, $wc, _wc, axc, bxc;
var fW = keb(nwe, 'LayeringStrategy', 265, MI, ixc, hxc);
var jxc;
Ycb(349, 23, {
    3: 1,
    34: 1,
    23: 1,
    349: 1
}, qxc);
var lxc, mxc, nxc;
var gW = keb(nwe, 'LongEdgeOrderingStrategy', 349, MI, sxc, rxc);
var txc;
Ycb(203, 23, {
    3: 1,
    34: 1,
    23: 1,
    203: 1
}, Bxc);
var vxc, wxc, xxc, yxc;
var hW = keb(nwe, 'NodeFlexibility', 203, MI, Exc, Dxc);
var Fxc;
Ycb(324, 23, {
    3: 1,
    34: 1,
    23: 1,
    324: 1,
    188: 1,
    196: 1
}, Oxc);
_.bg = function Qxc() {
    return Nxc(this);
};
_.og = function Pxc() {
    return Nxc(this);
};
var Hxc, Ixc, Jxc, Kxc, Lxc;
var iW = keb(nwe, 'NodePlacementStrategy', 324, MI, Sxc, Rxc);
var Txc;
Ycb(242, 23, {
    3: 1,
    34: 1,
    23: 1,
    242: 1
}, eyc);
var Vxc, Wxc, Xxc, Yxc, Zxc, $xc, _xc, ayc, byc, cyc;
var jW = keb(nwe, 'NodePromotionStrategy', 242, MI, gyc, fyc);
var hyc;
Ycb(266, 23, {
    3: 1,
    34: 1,
    23: 1,
    266: 1
}, oyc);
var jyc, kyc, lyc, myc;
var kW = keb(nwe, 'OrderingStrategy', 266, MI, qyc, pyc);
var ryc;
Ycb(418, 23, {
    3: 1,
    34: 1,
    23: 1,
    418: 1
}, wyc);
var tyc, uyc;
var lW = keb(nwe, 'PortSortingStrategy', 418, MI, yyc, xyc);
var zyc;
Ycb(449, 23, {
    3: 1,
    34: 1,
    23: 1,
    449: 1
}, Fyc);
var Byc, Cyc, Dyc;
var mW = keb(nwe, 'PortType', 449, MI, Hyc, Gyc);
var Iyc;
Ycb(379, 23, {
    3: 1,
    34: 1,
    23: 1,
    379: 1
}, Oyc);
var Kyc, Lyc, Myc;
var nW = keb(nwe, 'SelfLoopDistributionStrategy', 379, MI, Qyc, Pyc);
var Ryc;
Ycb(345, 23, {
    3: 1,
    34: 1,
    23: 1,
    345: 1
}, Xyc);
var Tyc, Uyc, Vyc;
var oW = keb(nwe, 'SelfLoopOrderingStrategy', 345, MI, Zyc, Yyc);
var $yc;
Ycb(313, 1, {
    313: 1
}, jzc);
var pW = jeb(nwe, 'Spacings', 313);
Ycb(346, 23, {
    3: 1,
    34: 1,
    23: 1,
    346: 1
}, pzc);
var lzc, mzc, nzc;
var qW = keb(nwe, 'SplineRoutingMode', 346, MI, rzc, qzc);
var szc;
Ycb(348, 23, {
    3: 1,
    34: 1,
    23: 1,
    348: 1
}, yzc);
var uzc, vzc, wzc;
var rW = keb(nwe, 'ValidifyStrategy', 348, MI, Azc, zzc);
var Bzc;
Ycb(380, 23, {
    3: 1,
    34: 1,
    23: 1,
    380: 1
}, Hzc);
var Dzc, Ezc, Fzc;
var sW = keb(nwe, 'WrappingStrategy', 380, MI, Jzc, Izc);
var Kzc;
Ycb(1337, 1, gze, Qzc);
_.pg = function Rzc(a) {
    return JD(a, 36), Mzc;
};
_.If = function Szc(a, b) {
    Pzc(this, JD(a, 36), b);
};
var Mzc;
var tW = jeb(hze, 'DepthFirstCycleBreaker', 1337);
Ycb(773, 1, gze, Xzc);
_.pg = function Zzc(a) {
    return JD(a, 36), Tzc;
};
_.If = function $zc(a, b) {
    Vzc(this, JD(a, 36), b);
};
_.qg = function Yzc(a) {
    return JD(Mlb(a, xvb(this.d, a.c.length)), 9);
};
var Tzc;
var uW = jeb(hze, 'GreedyCycleBreaker', 773);
Ycb(1340, 773, gze, _zc);
_.qg = function aAc(a) {
    var b, c, d, e;
    e = null;
    b = Hqe;
    for(d = new rmb(a); d.a < d.c.c.length;){
        c = JD(pmb(d), 9);
        if (XMb(c, (Iqc(), jqc)) && JD(WMb(c, jqc), 17).a < b) {
            b = JD(WMb(c, jqc), 17).a;
            e = c;
        }
    }
    if (!e) return JD(Mlb(a, xvb(this.d, a.c.length)), 9);
    return e;
};
var vW = jeb(hze, 'GreedyModelOrderCycleBreaker', 1340);
Ycb(1338, 1, gze, fAc);
_.pg = function gAc(a) {
    return JD(a, 36), bAc;
};
_.If = function hAc(a, b) {
    eAc(this, JD(a, 36), b);
};
var bAc;
var wW = jeb(hze, 'InteractiveCycleBreaker', 1338);
Ycb(1339, 1, gze, mAc);
_.pg = function nAc(a) {
    return JD(a, 36), iAc;
};
_.If = function oAc(a, b) {
    lAc(this, JD(a, 36), b);
};
_.a = 0;
_.b = 0;
var iAc;
var xW = jeb(hze, 'ModelOrderCycleBreaker', 1339);
Ycb(1352, 1, gze, sAc);
_.pg = function tAc(a) {
    return JD(a, 36), pAc;
};
_.If = function vAc(a, b) {
    rAc(this, JD(a, 36), b);
};
var pAc;
var zW = jeb(ize, 'BreadthFirstModelOrderLayerer', 1352);
Ycb(1353, 1, Bte, wAc);
_.Le = function xAc(a, b) {
    return uAc(JD(a, 9), JD(b, 9));
};
_.Fb = function yAc(a) {
    return this === a;
};
_.Me = function zAc() {
    return new uqb(this);
};
var yW = jeb(ize, 'BreadthFirstModelOrderLayerer/lambda$0$Type', 1353);
Ycb(1343, 1, gze, JAc);
_.pg = function KAc(a) {
    return JD(a, 36), AAc;
};
_.If = function LAc(a, b) {
    HAc(this, JD(a, 36), b);
};
var AAc;
var CW = jeb(ize, 'CoffmanGrahamLayerer', 1343);
Ycb(1344, 1, Bte, MAc);
_.Le = function NAc(a, b) {
    return DAc(this.a, JD(a, 9), JD(b, 9));
};
_.Fb = function OAc(a) {
    return this === a;
};
_.Me = function PAc() {
    return new uqb(this);
};
var AW = jeb(ize, 'CoffmanGrahamLayerer/0methodref$compareNodesInTopo$Type', 1344);
Ycb(1345, 1, Bte, QAc);
_.Le = function RAc(a, b) {
    return GAc(this.a, JD(a, 9), JD(b, 9));
};
_.Fb = function SAc(a) {
    return this === a;
};
_.Me = function TAc() {
    return new uqb(this);
};
var BW = jeb(ize, 'CoffmanGrahamLayerer/lambda$1$Type', 1345);
Ycb(1354, 1, gze, _Ac);
_.pg = function aBc(a) {
    return JD(a, 36), UAc;
};
_.If = function cBc(a, b) {
    $Ac(this, JD(a, 36), b);
};
_.c = 0;
_.e = 0;
var UAc;
var EW = jeb(ize, 'DepthFirstModelOrderLayerer', 1354);
Ycb(1355, 1, Bte, dBc);
_.Le = function eBc(a, b) {
    return bBc(JD(a, 9), JD(b, 9));
};
_.Fb = function fBc(a) {
    return this === a;
};
_.Me = function gBc() {
    return new uqb(this);
};
var DW = jeb(ize, 'DepthFirstModelOrderLayerer/lambda$0$Type', 1355);
Ycb(1346, 1, gze, jBc);
_.pg = function kBc(a) {
    return JD(a, 36), E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), R4b)), yQb, $4b), zQb, Z4b);
};
_.If = function lBc(a, b) {
    iBc(JD(a, 36), b);
};
var GW = jeb(ize, 'InteractiveLayerer', 1346);
Ycb(560, 1, {
    560: 1
}, mBc);
_.a = 0;
_.c = 0;
var FW = jeb(ize, 'InteractiveLayerer/LayerSpan', 560);
Ycb(1342, 1, gze, sBc);
_.pg = function tBc(a) {
    return JD(a, 36), nBc;
};
_.If = function uBc(a, b) {
    pBc(this, JD(a, 36), b);
};
var nBc;
var HW = jeb(ize, 'LongestPathLayerer', 1342);
Ycb(1351, 1, gze, ABc);
_.pg = function BBc(a) {
    return JD(a, 36), vBc;
};
_.If = function CBc(a, b) {
    xBc(this, JD(a, 36), b);
};
var vBc;
var IW = jeb(ize, 'LongestPathSourceLayerer', 1351);
Ycb(1349, 1, gze, LBc);
_.pg = function MBc(a) {
    return JD(a, 36), E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
};
_.If = function NBc(a, b) {
    JBc(this, JD(a, 36), b);
};
_.a = 0;
_.b = 0;
_.d = 0;
var DBc, EBc;
var KW = jeb(ize, 'MinWidthLayerer', 1349);
Ycb(1350, 1, Bte, PBc);
_.Le = function QBc(a, b) {
    return OBc(this, JD(a, 9), JD(b, 9));
};
_.Fb = function RBc(a) {
    return this === a;
};
_.Me = function SBc() {
    return new uqb(this);
};
var JW = jeb(ize, 'MinWidthLayerer/MinOutgoingEdgesComparator', 1350);
Ycb(1341, 1, gze, $Bc);
_.pg = function _Bc(a) {
    return JD(a, 36), TBc;
};
_.If = function aCc(a, b) {
    ZBc(this, JD(a, 36), b);
};
var TBc;
var LW = jeb(ize, 'NetworkSimplexLayerer', 1341);
Ycb(1347, 1, gze, mCc);
_.pg = function nCc(a) {
    return JD(a, 36), E9c(E9c(E9c(new J9c, (CQb(), xQb), (u5b(), B4b)), yQb, $4b), zQb, Z4b);
};
_.If = function oCc(a, b) {
    jCc(this, JD(a, 36), b);
};
_.d = 0;
_.f = 0;
_.g = 0;
_.i = 0;
_.s = 0;
_.t = 0;
_.u = 0;
var NW = jeb(ize, 'StretchWidthLayerer', 1347);
Ycb(1348, 1, Bte, qCc);
_.Le = function rCc(a, b) {
    return pCc(JD(a, 9), JD(b, 9));
};
_.Fb = function sCc(a) {
    return this === a;
};
_.Me = function tCc() {
    return new uqb(this);
};
var MW = jeb(ize, 'StretchWidthLayerer/1', 1348);
Ycb(402, 1, jze);
_.eg = function ICc(a, b, c, d, e, f) {};
_.sg = function GCc(a, b, c) {
    return zCc(this, a, b, c);
};
_.dg = function HCc() {
    this.g = SC(bE, kze, 30, this.d, 15, 1);
    this.f = SC(bE, kze, 30, this.d, 15, 1);
};
_.fg = function JCc(a, b) {
    this.e[a] = SC(cE, ise, 30, b[a].length, 15, 1);
};
_.gg = function KCc(a, b, c) {
    var d;
    d = c[a][b];
    d.p = b;
    this.e[a][b] = b;
};
_.hg = function LCc(a, b, c, d) {
    JD(Mlb(d[a][b].j, c), 11).p = this.d++;
};
_.b = 0;
_.c = 0;
_.d = 0;
var PW = jeb(lze, 'AbstractBarycenterPortDistributor', 402);
Ycb(1639, 1, Bte, MCc);
_.Le = function NCc(a, b) {
    return CCc(this.a, JD(a, 11), JD(b, 11));
};
_.Fb = function OCc(a) {
    return this === a;
};
_.Me = function PCc() {
    return new uqb(this);
};
var OW = jeb(lze, 'AbstractBarycenterPortDistributor/lambda$0$Type', 1639);
Ycb(811, 1, hwe, XCc);
_.eg = function $Cc(a, b, c, d, e, f) {};
_.gg = function aDc(a, b, c) {};
_.hg = function bDc(a, b, c, d) {};
_.cg = function YCc() {
    return false;
};
_.dg = function ZCc() {
    this.c = this.e.a;
    this.g = this.f.g;
};
_.fg = function _Cc(a, b) {
    b[a][0].c.p = a;
};
_.ig = function cDc() {
    return false;
};
_.tg = function dDc(a, b, c, d) {
    if (c) UCc(this, a);
    else {
        RCc(this, a, d);
        SCc(this, a, b);
    }
    if (a.c.length > 1) {
        ydb(LD(WMb(gYb((sDb(0, a.c.length), JD(a.c[0], 9))), (Bwc(), euc)))) ? zFc(a, this.d, JD(this, 654)) : (pnb(), Slb(a, this.d));
        qDc(this.e, a);
    }
};
_.jg = function eDc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if (b != VCc(c, a.length)) {
        f = a[b - (c ? 1 : -1)];
        vCc(this.f, f, c ? (Eyc(), Cyc) : (Eyc(), Byc));
    }
    e = a[b][0];
    k = !d || e.k == (DYb(), wYb);
    j = _u(a[b]);
    this.tg(j, k, false, c);
    g = 0;
    for(i = new rmb(j); i.a < i.c.c.length;){
        h = JD(pmb(i), 9);
        a[b][g++] = h;
    }
    return false;
};
_.kg = function fDc(a, b) {
    var c, d, e, f, g;
    g = VCc(b, a.length);
    f = _u(a[g]);
    this.tg(f, false, true, b);
    c = 0;
    for(e = new rmb(f); e.a < e.c.c.length;){
        d = JD(pmb(e), 9);
        a[g][c++] = d;
    }
    return false;
};
var SW = jeb(lze, 'BarycenterHeuristic', 811);
Ycb(652, 1, {
    652: 1
}, gDc);
_.Ib = function hDc() {
    return 'BarycenterState [node=' + this.c + ', summedWeight=' + this.d + ', degree=' + this.b + ', barycenter=' + this.a + ', visited=' + this.e + ']';
};
_.b = 0;
_.d = 0;
_.e = false;
var QW = jeb(lze, 'BarycenterHeuristic/BarycenterState', 652);
Ycb(1811, 1, Bte, iDc);
_.Le = function jDc(a, b) {
    return TCc(this.a, JD(a, 9), JD(b, 9));
};
_.Fb = function kDc(a) {
    return this === a;
};
_.Me = function lDc() {
    return new uqb(this);
};
var RW = jeb(lze, 'BarycenterHeuristic/lambda$0$Type', 1811);
Ycb(810, 1, hwe, tDc);
_.dg = function uDc() {};
_.eg = function vDc(a, b, c, d, e, f) {};
_.hg = function yDc(a, b, c, d) {};
_.fg = function wDc(a, b) {
    this.a[a] = SC(QW, {
        3: 1,
        4: 1,
        5: 1,
        2063: 1
    }, 652, b[a].length, 0, 1);
    this.b[a] = SC(TW, {
        3: 1,
        4: 1,
        5: 1,
        2064: 1
    }, 238, b[a].length, 0, 1);
};
_.gg = function xDc(a, b, c) {
    pDc(this, c[a][b], true);
};
_.c = false;
var VW = jeb(lze, 'ForsterConstraintResolver', 810);
Ycb(238, 1, {
    238: 1
}, BDc, CDc);
_.Ib = function DDc() {
    var a, b;
    b = new Ugb;
    b.a += '[';
    for(a = 0; a < this.d.length; a++){
        Qgb(b, sYb(this.d[a]));
        sDc(this.g, this.d[0]).a != null && Qgb(Qgb((b.a += '<', b), Geb(sDc(this.g, this.d[0]).a)), '>');
        a < this.d.length - 1 && (b.a += Lqe, b);
    }
    return (b.a += ']', b).a;
};
_.a = 0;
_.c = 0;
_.f = 0;
var TW = jeb(lze, 'ForsterConstraintResolver/ConstraintGroup', 238);
Ycb(1806, 1, kre, EDc);
_.Ad = function FDc(a) {
    pDc(this.a, JD(a, 9), false);
};
var UW = jeb(lze, 'ForsterConstraintResolver/lambda$0$Type', 1806);
Ycb(217, 1, {
    217: 1,
    229: 1
}, IDc);
_.eg = function KDc(a, b, c, d, e, f) {};
_.fg = function LDc(a, b) {};
_.dg = function JDc() {
    this.r = SC(cE, ise, 30, this.n, 15, 1);
};
_.gg = function MDc(a, b, c) {
    var d, e;
    e = c[a][b];
    d = e.e;
    !!d && Ilb(this.b, d);
};
_.hg = function NDc(a, b, c, d) {
    ++this.n;
};
_.Ib = function ODc() {
    return zmb(this.e, new Qrb);
};
_.g = false;
_.i = false;
_.n = 0;
_.s = false;
var WW = jeb(lze, 'GraphInfoHolder', 217);
Ycb(1851, 1, hwe, SDc);
_.eg = function VDc(a, b, c, d, e, f) {};
_.fg = function WDc(a, b) {};
_.hg = function YDc(a, b, c, d) {};
_.sg = function TDc(a, b, c) {
    c && b > 0 ? (sGc(this.a, a[b - 1], a[b]), undefined) : !c && b < a.length - 1 ? (sGc(this.a, a[b], a[b + 1]), undefined) : uGc(this.a, a[b], c ? (Rjd(), Qjd) : (Rjd(), wjd));
    return PDc(this, a, b, c);
};
_.dg = function UDc() {
    this.d = SC(cE, ise, 30, this.c, 15, 1);
    this.a = new GGc(this.d);
};
_.gg = function XDc(a, b, c) {
    var d;
    d = c[a][b];
    this.c += d.j.c.length;
};
_.c = 0;
var XW = jeb(lze, 'GreedyPortDistributor', 1851);
Ycb(1360, 1, gze, dEc);
_.pg = function eEc(a) {
    return aEc(JD(a, 36));
};
_.If = function fEc(a, b) {
    cEc(JD(a, 36), b);
};
var $Dc;
var ZW = jeb(lze, 'InteractiveCrossingMinimizer', 1360);
Ycb(1361, 1, Bte, hEc);
_.Le = function iEc(a, b) {
    return gEc(this, JD(a, 9), JD(b, 9));
};
_.Fb = function jEc(a) {
    return this === a;
};
_.Me = function kEc() {
    return new uqb(this);
};
var YW = jeb(lze, 'InteractiveCrossingMinimizer/1', 1361);
Ycb(498, 1, {
    498: 1,
    106: 1,
    44: 1
}, IEc);
_.pg = function JEc(a) {
    var b;
    return JD(a, 36), b = K9c(lEc), E9c(b, (CQb(), zQb), (u5b(), j5b)), b;
};
_.If = function KEc(a, b) {
    zEc(this, JD(a, 36), b);
};
_.e = 0;
var lEc;
var dX = jeb(lze, 'LayerSweepCrossingMinimizer', 498);
Ycb(1357, 1, kre, LEc);
_.Ad = function MEc(a) {
    nEc(this.a, JD(a, 217));
};
var $W = jeb(lze, 'LayerSweepCrossingMinimizer/0methodref$compareDifferentRandomizedLayouts$Type', 1357);
Ycb(1358, 1, kre, NEc);
_.Ad = function OEc(a) {
    wEc(this.a, JD(a, 217));
};
var _W = jeb(lze, 'LayerSweepCrossingMinimizer/1methodref$minimizeCrossingsNoCounter$Type', 1358);
Ycb(1359, 1, kre, PEc);
_.Ad = function QEc(a) {
    yEc(this.a, JD(a, 217));
};
var aX = jeb(lze, 'LayerSweepCrossingMinimizer/2methodref$minimizeCrossingsWithCounter$Type', 1359);
Ycb(450, 23, {
    3: 1,
    34: 1,
    23: 1,
    450: 1
}, VEc);
var REc, SEc, TEc;
var bX = keb(lze, 'LayerSweepCrossingMinimizer/CrossMinType', 450, MI, XEc, WEc);
var YEc;
Ycb(1356, 1, Ire, $Ec);
_.Mb = function _Ec(a) {
    return mEc(), JD(a, 25).a.c.length == 0;
};
var cX = jeb(lze, 'LayerSweepCrossingMinimizer/lambda$0$Type', 1356);
Ycb(1808, 1, hwe, cFc);
_.dg = function dFc() {};
_.eg = function eFc(a, b, c, d, e, f) {};
_.hg = function hFc(a, b, c, d) {};
_.fg = function fFc(a, b) {
    b[a][0].c.p = a;
    this.b[a] = SC(eX, {
        3: 1,
        4: 1,
        5: 1,
        1989: 1
    }, 653, b[a].length, 0, 1);
};
_.gg = function gFc(a, b, c) {
    var d;
    d = c[a][b];
    d.p = b;
    VC(this.b[a], b, new iFc);
};
var hX = jeb(lze, 'LayerSweepTypeDecider', 1808);
Ycb(653, 1, {
    653: 1
}, iFc);
_.Ib = function jFc() {
    return 'NodeInfo [connectedEdges=' + this.a + ', hierarchicalInfluence=' + this.b + ', randomInfluence=' + this.c + ']';
};
_.a = 0;
_.b = 0;
_.c = 0;
var eX = jeb(lze, 'LayerSweepTypeDecider/NodeInfo', 653);
Ycb(1809, 1, Tte, kFc);
_.Lb = function lFc(a) {
    return wZb(new xZb(JD(a, 11).b));
};
_.Fb = function mFc(a) {
    return this === a;
};
_.Mb = function nFc(a) {
    return wZb(new xZb(JD(a, 11).b));
};
var fX = jeb(lze, 'LayerSweepTypeDecider/lambda$0$Type', 1809);
Ycb(1810, 1, Tte, oFc);
_.Lb = function pFc(a) {
    return wZb(new xZb(JD(a, 11).b));
};
_.Fb = function qFc(a) {
    return this === a;
};
_.Mb = function rFc(a) {
    return wZb(new xZb(JD(a, 11).b));
};
var gX = jeb(lze, 'LayerSweepTypeDecider/lambda$1$Type', 1810);
Ycb(1852, 402, jze, sFc);
_.rg = function tFc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    j = this.g;
    switch(c.g){
        case 1:
            d = 0;
            e = 0;
            for(i = new rmb(a.j); i.a < i.c.c.length;){
                g = JD(pmb(i), 11);
                if (g.e.c.length != 0) {
                    ++d;
                    g.j == (Rjd(), xjd) && ++e;
                }
            }
            f = b + e;
            l = b + d;
            for(h = mYb(a, (Eyc(), Byc)).Jc(); h.Ob();){
                g = JD(h.Pb(), 11);
                if (g.j == (Rjd(), xjd)) {
                    j[g.p] = f;
                    --f;
                } else {
                    j[g.p] = l;
                    --l;
                }
            }
            return d;
        case 2:
            k = 0;
            for(h = mYb(a, (Eyc(), Cyc)).Jc(); h.Ob();){
                g = JD(h.Pb(), 11);
                ++k;
                j[g.p] = b + k;
            }
            return k;
        default:
            throw scb(new Seb);
    }
};
var iX = jeb(lze, 'LayerTotalPortDistributor', 1852);
Ycb(654, 811, {
    654: 1,
    229: 1
}, yFc);
_.tg = function AFc(a, b, c, d) {
    if (c) UCc(this, a);
    else {
        RCc(this, a, d);
        SCc(this, a, b);
    }
    if (a.c.length > 1) {
        ydb(LD(WMb(gYb((sDb(0, a.c.length), JD(a.c[0], 9))), (Bwc(), euc)))) ? zFc(a, this.d, this) : (pnb(), Slb(a, this.d));
        ydb(LD(WMb(gYb((sDb(0, a.c.length), JD(a.c[0], 9))), euc))) || qDc(this.e, a);
    }
};
var kX = jeb(lze, 'ModelOrderBarycenterHeuristic', 654);
Ycb(1812, 1, Bte, BFc);
_.Le = function CFc(a, b) {
    return wFc(this.a, JD(a, 9), JD(b, 9));
};
_.Fb = function DFc(a) {
    return this === a;
};
_.Me = function EFc() {
    return new uqb(this);
};
var jX = jeb(lze, 'ModelOrderBarycenterHeuristic/lambda$0$Type', 1812);
Ycb(1362, 1, gze, IFc);
_.pg = function JFc(a) {
    var b;
    return JD(a, 36), b = K9c(FFc), E9c(b, (CQb(), zQb), (u5b(), j5b)), b;
};
_.If = function KFc(a, b) {
    HFc((JD(a, 36), b));
};
var FFc;
var lX = jeb(lze, 'NoCrossingMinimizer', 1362);
Ycb(789, 402, jze, LFc);
_.rg = function MFc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    l = this.g;
    switch(c.g){
        case 1:
            e = 0;
            f = 0;
            for(k = new rmb(a.j); k.a < k.c.c.length;){
                i = JD(pmb(k), 11);
                if (i.e.c.length != 0) {
                    ++e;
                    i.j == (Rjd(), xjd) && ++f;
                }
            }
            d = 1 / (e + 1);
            g = b + f * d;
            n = b + 1 - d;
            for(j = mYb(a, (Eyc(), Byc)).Jc(); j.Ob();){
                i = JD(j.Pb(), 11);
                if (i.j == (Rjd(), xjd)) {
                    l[i.p] = g;
                    g -= d;
                } else {
                    l[i.p] = n;
                    n -= d;
                }
            }
            break;
        case 2:
            h = 0;
            for(k = new rmb(a.j); k.a < k.c.c.length;){
                i = JD(pmb(k), 11);
                i.g.c.length == 0 || ++h;
            }
            d = 1 / (h + 1);
            m = b + d;
            for(j = mYb(a, (Eyc(), Cyc)).Jc(); j.Ob();){
                i = JD(j.Pb(), 11);
                l[i.p] = m;
                m += d;
            }
            break;
        default:
            throw scb(new Teb('Port type is undefined'));
    }
    return 1;
};
var mX = jeb(lze, 'NodeRelativePortDistributor', 789);
Ycb(801, 1, {}, QFc, RFc);
var nX = jeb(lze, 'SweepCopy', 801);
Ycb(1807, 1, hwe, UFc);
_.fg = function XFc(a, b) {};
_.dg = function VFc() {
    var a;
    a = SC(cE, ise, 30, this.f, 15, 1);
    this.d = new mHc(a);
    this.a = new GGc(a);
};
_.eg = function WFc(a, b, c, d, e, f) {
    var g;
    g = JD(Mlb(f[a][b].j, c), 11);
    e.c == g && e.c.i.c == e.d.i.c && ++this.e[a];
};
_.gg = function YFc(a, b, c) {
    var d;
    d = c[a][b];
    this.c[a] = this.c[a] | d.k == (DYb(), BYb);
};
_.hg = function ZFc(a, b, c, d) {
    var e;
    e = JD(Mlb(d[a][b].j, c), 11);
    e.p = this.f++;
    e.g.c.length + e.e.c.length > 1 && (e.j == (Rjd(), wjd) ? this.b[a] = true : e.j == Qjd && a > 0 && (this.b[a - 1] = true));
};
_.f = 0;
var oX = jeb(gwe, 'AllCrossingsCounter', 1807);
Ycb(578, 1, {}, cGc);
_.b = 0;
_.d = 0;
var pX = jeb(gwe, 'BinaryIndexedTree', 578);
Ycb(517, 1, {}, GGc);
var eGc, fGc;
var zX = jeb(gwe, 'CrossingsCounter', 517);
Ycb(1896, 1, Bte, KGc);
_.Le = function LGc(a, b) {
    return zGc(this.a, JD(a, 11), JD(b, 11));
};
_.Fb = function MGc(a) {
    return this === a;
};
_.Me = function NGc() {
    return new uqb(this);
};
var qX = jeb(gwe, 'CrossingsCounter/lambda$0$Type', 1896);
Ycb(1897, 1, Bte, OGc);
_.Le = function PGc(a, b) {
    return AGc(this.a, JD(a, 11), JD(b, 11));
};
_.Fb = function QGc(a) {
    return this === a;
};
_.Me = function RGc() {
    return new uqb(this);
};
var rX = jeb(gwe, 'CrossingsCounter/lambda$1$Type', 1897);
Ycb(1898, 1, Bte, SGc);
_.Le = function TGc(a, b) {
    return BGc(this.a, JD(a, 11), JD(b, 11));
};
_.Fb = function UGc(a) {
    return this === a;
};
_.Me = function VGc() {
    return new uqb(this);
};
var sX = jeb(gwe, 'CrossingsCounter/lambda$2$Type', 1898);
Ycb(1899, 1, Bte, WGc);
_.Le = function XGc(a, b) {
    return CGc(this.a, JD(a, 11), JD(b, 11));
};
_.Fb = function YGc(a) {
    return this === a;
};
_.Me = function ZGc() {
    return new uqb(this);
};
var tX = jeb(gwe, 'CrossingsCounter/lambda$3$Type', 1899);
Ycb(hse, 1, kre, $Gc);
_.Ad = function _Gc(a) {
    HGc(this.a, JD(a, 11));
};
var uX = jeb(gwe, 'CrossingsCounter/lambda$4$Type', hse);
Ycb(1901, 1, Ire, aHc);
_.Mb = function bHc(a) {
    return IGc(this.a, JD(a, 11));
};
var vX = jeb(gwe, 'CrossingsCounter/lambda$5$Type', 1901);
Ycb(1902, 1, kre, dHc);
_.Ad = function eHc(a) {
    cHc(this, a);
};
var wX = jeb(gwe, 'CrossingsCounter/lambda$6$Type', 1902);
Ycb(1903, 1, kre, fHc);
_.Ad = function gHc(a) {
    var b;
    gGc();
    $kb(this.b, (b = this.a, JD(a, 11), b));
};
var xX = jeb(gwe, 'CrossingsCounter/lambda$7$Type', 1903);
Ycb(818, 1, Tte, hHc);
_.Lb = function iHc(a) {
    return gGc(), XMb(JD(a, 11), (Iqc(), sqc));
};
_.Fb = function jHc(a) {
    return this === a;
};
_.Mb = function kHc(a) {
    return gGc(), XMb(JD(a, 11), (Iqc(), sqc));
};
var yX = jeb(gwe, 'CrossingsCounter/lambda$8$Type', 818);
Ycb(1895, 1, {}, mHc);
var DX = jeb(gwe, 'HyperedgeCrossingsCounter', 1895);
Ycb(464, 1, {
    34: 1,
    464: 1
}, oHc);
_.Dd = function pHc(a) {
    return nHc(this, JD(a, 464));
};
_.b = 0;
_.c = 0;
_.e = 0;
_.f = 0;
var CX = jeb(gwe, 'HyperedgeCrossingsCounter/Hyperedge', 464);
Ycb(367, 1, {
    34: 1,
    367: 1
}, rHc);
_.Dd = function sHc(a) {
    return qHc(this, JD(a, 367));
};
_.b = 0;
_.c = 0;
var BX = jeb(gwe, 'HyperedgeCrossingsCounter/HyperedgeCorner', 367);
Ycb(516, 23, {
    3: 1,
    34: 1,
    23: 1,
    516: 1
}, wHc);
var tHc, uHc;
var AX = keb(gwe, 'HyperedgeCrossingsCounter/HyperedgeCorner/Type', 516, MI, yHc, xHc);
var zHc;
Ycb(1364, 1, gze, GHc);
_.pg = function HHc(a) {
    return JD(WMb(JD(a, 36), (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) ? CHc : null;
};
_.If = function IHc(a, b) {
    FHc(this, JD(a, 36), b);
};
var CHc;
var FX = jeb(nze, 'InteractiveNodePlacer', 1364);
Ycb(1365, 1, gze, WHc);
_.pg = function XHc(a) {
    return JD(WMb(JD(a, 36), (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) ? JHc : null;
};
_.If = function YHc(a, b) {
    UHc(this, JD(a, 36), b);
};
var JHc, KHc, LHc;
var HX = jeb(nze, 'LinearSegmentsNodePlacer', 1365);
Ycb(261, 1, {
    34: 1,
    261: 1
}, aIc);
_.Dd = function bIc(a) {
    return ZHc(this, JD(a, 261));
};
_.Fb = function cIc(a) {
    var b;
    if (RD(a, 261)) {
        b = JD(a, 261);
        return this.b == b.b;
    }
    return false;
};
_.Hb = function dIc() {
    return this.b;
};
_.Ib = function eIc() {
    return 'ls' + Ee(this.e);
};
_.a = 0;
_.b = 0;
_.c = -1;
_.d = -1;
_.g = 0;
var GX = jeb(nze, 'LinearSegmentsNodePlacer/LinearSegment', 261);
Ycb(1367, 1, gze, BIc);
_.pg = function CIc(a) {
    return JD(WMb(JD(a, 36), (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) ? fIc : null;
};
_.If = function KIc(a, b) {
    xIc(this, JD(a, 36), b);
};
_.b = 0;
_.g = 0;
var fIc;
var rY = jeb(nze, 'NetworkSimplexPlacer', 1367);
Ycb(1386, 1, Bte, LIc);
_.Le = function MIc(a, b) {
    return $eb(JD(a, 17).a, JD(b, 17).a);
};
_.Fb = function NIc(a) {
    return this === a;
};
_.Me = function OIc() {
    return new uqb(this);
};
var IX = jeb(nze, 'NetworkSimplexPlacer/0methodref$compare$Type', 1386);
Ycb(1388, 1, Bte, PIc);
_.Le = function QIc(a, b) {
    return $eb(JD(a, 17).a, JD(b, 17).a);
};
_.Fb = function RIc(a) {
    return this === a;
};
_.Me = function SIc() {
    return new uqb(this);
};
var JX = jeb(nze, 'NetworkSimplexPlacer/1methodref$compare$Type', 1388);
Ycb(639, 1, {
    639: 1
}, TIc);
var KX = jeb(nze, 'NetworkSimplexPlacer/EdgeRep', 639);
Ycb(401, 1, {
    401: 1
}, UIc);
_.b = false;
var LX = jeb(nze, 'NetworkSimplexPlacer/NodeRep', 401);
Ycb(499, 13, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    13: 1,
    16: 1,
    15: 1,
    59: 1,
    499: 1
}, YIc);
var QX = jeb(nze, 'NetworkSimplexPlacer/Path', 499);
Ycb(1368, 1, {}, ZIc);
_.Kb = function $Ic(a) {
    return JD(a, 18).d.i.k;
};
var MX = jeb(nze, 'NetworkSimplexPlacer/Path/lambda$0$Type', 1368);
Ycb(1369, 1, Ire, _Ic);
_.Mb = function aJc(a) {
    return JD(a, 247) == (DYb(), yYb);
};
var NX = jeb(nze, 'NetworkSimplexPlacer/Path/lambda$1$Type', 1369);
Ycb(1370, 1, {}, bJc);
_.Kb = function cJc(a) {
    return JD(a, 18).d.i;
};
var OX = jeb(nze, 'NetworkSimplexPlacer/Path/lambda$2$Type', 1370);
Ycb(1371, 1, Ire, dJc);
_.Mb = function eJc(a) {
    return HJc(Cxc(JD(a, 9)));
};
var PX = jeb(nze, 'NetworkSimplexPlacer/Path/lambda$3$Type', 1371);
Ycb(1372, 1, Ire, fJc);
_.Mb = function gJc(a) {
    return GIc(JD(a, 11));
};
var RX = jeb(nze, 'NetworkSimplexPlacer/lambda$0$Type', 1372);
Ycb(1373, 1, kre, hJc);
_.Ad = function iJc(a) {
    mIc(this.a, this.b, JD(a, 11));
};
var SX = jeb(nze, 'NetworkSimplexPlacer/lambda$1$Type', 1373);
Ycb(1382, 1, kre, jJc);
_.Ad = function kJc(a) {
    nIc(this.a, JD(a, 18));
};
var TX = jeb(nze, 'NetworkSimplexPlacer/lambda$10$Type', 1382);
Ycb(1383, 1, {}, lJc);
_.Kb = function mJc(a) {
    return gIc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var UX = jeb(nze, 'NetworkSimplexPlacer/lambda$11$Type', 1383);
Ycb(1384, 1, kre, nJc);
_.Ad = function oJc(a) {
    oIc(this.a, JD(a, 9));
};
var VX = jeb(nze, 'NetworkSimplexPlacer/lambda$12$Type', 1384);
Ycb(1385, 1, {}, pJc);
_.Kb = function qJc(a) {
    return gIc(), jfb(JD(a, 123).e);
};
var WX = jeb(nze, 'NetworkSimplexPlacer/lambda$13$Type', 1385);
Ycb(1387, 1, {}, rJc);
_.Kb = function sJc(a) {
    return gIc(), jfb(JD(a, 123).e);
};
var XX = jeb(nze, 'NetworkSimplexPlacer/lambda$15$Type', 1387);
Ycb(1389, 1, Ire, tJc);
_.Mb = function uJc(a) {
    return gIc(), JD(a, 401).c.k == (DYb(), AYb);
};
var YX = jeb(nze, 'NetworkSimplexPlacer/lambda$17$Type', 1389);
Ycb(1390, 1, Ire, vJc);
_.Mb = function wJc(a) {
    return gIc(), JD(a, 401).c.j.c.length > 1;
};
var ZX = jeb(nze, 'NetworkSimplexPlacer/lambda$18$Type', 1390);
Ycb(1391, 1, kre, xJc);
_.Ad = function yJc(a) {
    HIc(this.c, this.b, this.d, this.a, JD(a, 401));
};
_.c = 0;
_.d = 0;
var $X = jeb(nze, 'NetworkSimplexPlacer/lambda$19$Type', 1391);
Ycb(1374, 1, {}, zJc);
_.Kb = function AJc(a) {
    return gIc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var _X = jeb(nze, 'NetworkSimplexPlacer/lambda$2$Type', 1374);
Ycb(1392, 1, kre, BJc);
_.Ad = function CJc(a) {
    IIc(this.a, JD(a, 11));
};
_.a = 0;
var aY = jeb(nze, 'NetworkSimplexPlacer/lambda$20$Type', 1392);
Ycb(1393, 1, {}, DJc);
_.Kb = function EJc(a) {
    return gIc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var bY = jeb(nze, 'NetworkSimplexPlacer/lambda$21$Type', 1393);
Ycb(1394, 1, kre, FJc);
_.Ad = function GJc(a) {
    pIc(this.a, JD(a, 9));
};
var cY = jeb(nze, 'NetworkSimplexPlacer/lambda$22$Type', 1394);
Ycb(1395, 1, Ire, IJc);
_.Mb = function JJc(a) {
    return HJc(a);
};
var dY = jeb(nze, 'NetworkSimplexPlacer/lambda$23$Type', 1395);
Ycb(1396, 1, {}, KJc);
_.Kb = function LJc(a) {
    return gIc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var eY = jeb(nze, 'NetworkSimplexPlacer/lambda$24$Type', 1396);
Ycb(1397, 1, Ire, MJc);
_.Mb = function NJc(a) {
    return qIc(this.a, JD(a, 9));
};
var fY = jeb(nze, 'NetworkSimplexPlacer/lambda$25$Type', 1397);
Ycb(1398, 1, kre, OJc);
_.Ad = function PJc(a) {
    rIc(this.a, this.b, JD(a, 9));
};
var gY = jeb(nze, 'NetworkSimplexPlacer/lambda$26$Type', 1398);
Ycb(1399, 1, Ire, QJc);
_.Mb = function RJc(a) {
    return gIc(), !eWb(JD(a, 18));
};
var hY = jeb(nze, 'NetworkSimplexPlacer/lambda$27$Type', 1399);
Ycb(1400, 1, Ire, SJc);
_.Mb = function TJc(a) {
    return gIc(), !eWb(JD(a, 18));
};
var iY = jeb(nze, 'NetworkSimplexPlacer/lambda$28$Type', 1400);
Ycb(1401, 1, {}, UJc);
_.Te = function VJc(a, b) {
    return sIc(this.a, JD(a, 25), JD(b, 25));
};
var jY = jeb(nze, 'NetworkSimplexPlacer/lambda$29$Type', 1401);
Ycb(1375, 1, {}, WJc);
_.Kb = function XJc(a) {
    return gIc(), new RBb(null, new Hvb(new es(Ir(kYb(JD(a, 9)).a.Jc(), new er))));
};
var kY = jeb(nze, 'NetworkSimplexPlacer/lambda$3$Type', 1375);
Ycb(1376, 1, Ire, YJc);
_.Mb = function ZJc(a) {
    return gIc(), FIc(JD(a, 18));
};
var lY = jeb(nze, 'NetworkSimplexPlacer/lambda$4$Type', 1376);
Ycb(1377, 1, kre, $Jc);
_.Ad = function _Jc(a) {
    yIc(this.a, JD(a, 18));
};
var mY = jeb(nze, 'NetworkSimplexPlacer/lambda$5$Type', 1377);
Ycb(1378, 1, {}, aKc);
_.Kb = function bKc(a) {
    return gIc(), new RBb(null, new Gvb(JD(a, 25).a, 16));
};
var nY = jeb(nze, 'NetworkSimplexPlacer/lambda$6$Type', 1378);
Ycb(1379, 1, Ire, cKc);
_.Mb = function dKc(a) {
    return gIc(), JD(a, 9).k == (DYb(), AYb);
};
var oY = jeb(nze, 'NetworkSimplexPlacer/lambda$7$Type', 1379);
Ycb(1380, 1, {}, eKc);
_.Kb = function fKc(a) {
    return gIc(), new RBb(null, new Hvb(new es(Ir(eYb(JD(a, 9)).a.Jc(), new er))));
};
var pY = jeb(nze, 'NetworkSimplexPlacer/lambda$8$Type', 1380);
Ycb(1381, 1, Ire, gKc);
_.Mb = function hKc(a) {
    return gIc(), dWb(JD(a, 18));
};
var qY = jeb(nze, 'NetworkSimplexPlacer/lambda$9$Type', 1381);
Ycb(1363, 1, gze, lKc);
_.pg = function mKc(a) {
    return JD(WMb(JD(a, 36), (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) ? iKc : null;
};
_.If = function nKc(a, b) {
    kKc(JD(a, 36), b);
};
var iKc;
var sY = jeb(nze, 'SimpleNodePlacer', 1363);
Ycb(185, 1, {
    185: 1
}, vKc);
_.Ib = function wKc() {
    var a;
    a = '';
    this.c == (zKc(), yKc) ? a += aue : this.c == xKc && (a += _te);
    this.o == (HKc(), FKc) ? a += lue : this.o == GKc ? a += 'UP' : a += 'BALANCED';
    return a;
};
var vY = jeb(qze, 'BKAlignedLayout', 185);
Ycb(507, 23, {
    3: 1,
    34: 1,
    23: 1,
    507: 1
}, AKc);
var xKc, yKc;
var tY = keb(qze, 'BKAlignedLayout/HDirection', 507, MI, CKc, BKc);
var DKc;
Ycb(506, 23, {
    3: 1,
    34: 1,
    23: 1,
    506: 1
}, IKc);
var FKc, GKc;
var uY = keb(qze, 'BKAlignedLayout/VDirection', 506, MI, KKc, JKc);
var LKc;
Ycb(1640, 1, {}, PKc);
var wY = jeb(qze, 'BKAligner', 1640);
Ycb(1643, 1, {}, UKc);
var zY = jeb(qze, 'BKCompactor', 1643);
Ycb(647, 1, {
    647: 1
}, VKc);
_.a = 0;
var xY = jeb(qze, 'BKCompactor/ClassEdge', 647);
Ycb(453, 1, {
    453: 1
}, XKc);
_.a = null;
_.b = 0;
var yY = jeb(qze, 'BKCompactor/ClassNode', 453);
Ycb(1366, 1, gze, dLc);
_.pg = function hLc(a) {
    return JD(WMb(JD(a, 36), (Iqc(), Wpc)), 22).Gc(($oc(), Toc)) ? YKc : null;
};
_.If = function iLc(a, b) {
    cLc(this, JD(a, 36), b);
};
_.d = false;
var YKc;
var AY = jeb(qze, 'BKNodePlacer', 1366);
Ycb(1641, 1, {}, kLc);
_.d = 0;
var CY = jeb(qze, 'NeighborhoodInformation', 1641);
Ycb(1642, 1, Bte, pLc);
_.Le = function qLc(a, b) {
    return oLc(this, JD(a, 47), JD(b, 47));
};
_.Fb = function rLc(a) {
    return this === a;
};
_.Me = function sLc() {
    return new uqb(this);
};
var BY = jeb(qze, 'NeighborhoodInformation/NeighborComparator', 1642);
Ycb(802, 1, {});
var GY = jeb(qze, 'ThresholdStrategy', 802);
Ycb(1771, 802, {}, xLc);
_.ug = function yLc(a, b, c) {
    return this.a.o == (HKc(), GKc) ? Kse : Lse;
};
_.vg = function zLc() {};
var DY = jeb(qze, 'ThresholdStrategy/NullThresholdStrategy', 1771);
Ycb(570, 1, {
    570: 1
}, ALc);
_.c = false;
_.d = false;
var EY = jeb(qze, 'ThresholdStrategy/Postprocessable', 570);
Ycb(1772, 802, {}, ELc);
_.ug = function FLc(a, b, c) {
    var d, e, f;
    e = b == c;
    d = this.a.a[c.p] == b;
    if (!(e || d)) return a;
    f = a;
    if (this.a.c == (zKc(), yKc)) {
        e && (f = BLc(this, b, true));
        !isNaN(f) && !isFinite(f) && d && (f = BLc(this, c, false));
    } else {
        e && (f = BLc(this, b, true));
        !isNaN(f) && !isFinite(f) && d && (f = BLc(this, c, false));
    }
    return f;
};
_.vg = function GLc() {
    var a, b, c, d, e;
    while(this.d.b != 0){
        e = JD(Htb(this.d), 570);
        d = CLc(this, e);
        if (!d.a) continue;
        a = d.a;
        c = ydb(this.a.f[this.a.g[e.b.p].p]);
        if (!c && !eWb(a) && a.c.i.c == a.d.i.c) continue;
        b = DLc(this, e);
        b || sxb(this.e, e);
    }
    while(this.e.a.c.length != 0)DLc(this, JD(rxb(this.e), 570));
};
var FY = jeb(qze, 'ThresholdStrategy/SimpleThresholdStrategy', 1772);
Ycb(630, 1, {
    630: 1,
    188: 1,
    196: 1
}, KLc);
_.bg = function MLc() {
    return JLc(this);
};
_.og = function LLc() {
    return JLc(this);
};
var HLc;
var HY = jeb(rze, 'EdgeRouterFactory', 630);
Ycb(1424, 1, gze, ZLc);
_.pg = function $Lc(a) {
    return XLc(JD(a, 36));
};
_.If = function _Lc(a, b) {
    YLc(JD(a, 36), b);
};
var OLc, PLc, QLc, RLc, SLc, TLc, ULc, VLc;
var IY = jeb(rze, 'OrthogonalEdgeRouter', 1424);
Ycb(1417, 1, gze, oMc);
_.pg = function pMc(a) {
    return jMc(JD(a, 36));
};
_.If = function qMc(a, b) {
    lMc(this, JD(a, 36), b);
};
var aMc, bMc, cMc, dMc, eMc, fMc;
var KY = jeb(rze, 'PolylineEdgeRouter', 1417);
Ycb(1418, 1, Tte, sMc);
_.Lb = function tMc(a) {
    return rMc(JD(a, 9));
};
_.Fb = function uMc(a) {
    return this === a;
};
_.Mb = function vMc(a) {
    return rMc(JD(a, 9));
};
var JY = jeb(rze, 'PolylineEdgeRouter/1', 1418);
Ycb(1818, 1, Ire, AMc);
_.Mb = function BMc(a) {
    return JD(a, 133).c == (iNc(), gNc);
};
var LY = jeb(sze, 'HyperEdgeCycleDetector/lambda$0$Type', 1818);
Ycb(1819, 1, {}, CMc);
_.Xe = function DMc(a) {
    return JD(a, 133).d;
};
var MY = jeb(sze, 'HyperEdgeCycleDetector/lambda$1$Type', 1819);
Ycb(1820, 1, Ire, EMc);
_.Mb = function FMc(a) {
    return JD(a, 133).c == (iNc(), gNc);
};
var NY = jeb(sze, 'HyperEdgeCycleDetector/lambda$2$Type', 1820);
Ycb(1821, 1, {}, GMc);
_.Xe = function HMc(a) {
    return JD(a, 133).d;
};
var OY = jeb(sze, 'HyperEdgeCycleDetector/lambda$3$Type', 1821);
Ycb(1822, 1, {}, IMc);
_.Xe = function JMc(a) {
    return JD(a, 133).d;
};
var PY = jeb(sze, 'HyperEdgeCycleDetector/lambda$4$Type', 1822);
Ycb(1823, 1, {}, KMc);
_.Xe = function LMc(a) {
    return JD(a, 133).d;
};
var QY = jeb(sze, 'HyperEdgeCycleDetector/lambda$5$Type', 1823);
Ycb(116, 1, {
    34: 1,
    116: 1
}, XMc);
_.Dd = function YMc(a) {
    return NMc(this, JD(a, 116));
};
_.Fb = function ZMc(a) {
    var b;
    if (RD(a, 116)) {
        b = JD(a, 116);
        return this.g == b.g;
    }
    return false;
};
_.Hb = function $Mc() {
    return this.g;
};
_.Ib = function aNc() {
    var a, b, c, d;
    a = new Wgb('{');
    d = new rmb(this.n);
    while(d.a < d.c.c.length){
        c = JD(pmb(d), 11);
        b = fYb(c.i);
        b == null && (b = 'n' + iYb(c.i));
        a.a += '' + b;
        d.a < d.c.c.length && (a.a += ',', a);
    }
    a.a += '}';
    return a.a;
};
_.a = 0;
_.b = 0;
_.c = NaN;
_.d = 0;
_.g = 0;
_.i = 0;
_.o = 0;
_.s = NaN;
var _Y = jeb(sze, 'HyperEdgeSegment', 116);
Ycb(133, 1, {
    133: 1
}, eNc);
_.Ib = function fNc() {
    return this.a + '->' + this.b + ' (' + ks(this.c) + ')';
};
_.d = 0;
var SY = jeb(sze, 'HyperEdgeSegmentDependency', 133);
Ycb(513, 23, {
    3: 1,
    34: 1,
    23: 1,
    513: 1
}, jNc);
var gNc, hNc;
var RY = keb(sze, 'HyperEdgeSegmentDependency/DependencyType', 513, MI, lNc, kNc);
var mNc;
Ycb(1824, 1, {}, ANc);
var $Y = jeb(sze, 'HyperEdgeSegmentSplitter', 1824);
Ycb(1825, 1, {}, DNc);
_.a = 0;
_.b = 0;
var TY = jeb(sze, 'HyperEdgeSegmentSplitter/AreaRating', 1825);
Ycb(335, 1, {
    335: 1
}, ENc);
_.a = 0;
_.b = 0;
_.c = 0;
var UY = jeb(sze, 'HyperEdgeSegmentSplitter/FreeArea', 335);
Ycb(1826, 1, Bte, FNc);
_.Le = function GNc(a, b) {
    return CNc(JD(a, 116), JD(b, 116));
};
_.Fb = function HNc(a) {
    return this === a;
};
_.Me = function INc() {
    return new uqb(this);
};
var VY = jeb(sze, 'HyperEdgeSegmentSplitter/lambda$0$Type', 1826);
Ycb(1827, 1, kre, JNc);
_.Ad = function KNc(a) {
    uNc(this.a, this.d, this.c, this.b, JD(a, 116));
};
_.b = 0;
var WY = jeb(sze, 'HyperEdgeSegmentSplitter/lambda$1$Type', 1827);
Ycb(1828, 1, {}, LNc);
_.Kb = function MNc(a) {
    return new RBb(null, new Gvb(JD(a, 116).e, 16));
};
var XY = jeb(sze, 'HyperEdgeSegmentSplitter/lambda$2$Type', 1828);
Ycb(1829, 1, {}, NNc);
_.Kb = function ONc(a) {
    return new RBb(null, new Gvb(JD(a, 116).j, 16));
};
var YY = jeb(sze, 'HyperEdgeSegmentSplitter/lambda$3$Type', 1829);
Ycb(1830, 1, {}, PNc);
_.We = function QNc(a) {
    return Beb(MD(a));
};
var ZY = jeb(sze, 'HyperEdgeSegmentSplitter/lambda$4$Type', 1830);
Ycb(648, 1, {}, WNc);
_.a = 0;
_.b = 0;
_.c = 0;
var cZ = jeb(sze, 'OrthogonalRoutingGenerator', 648);
Ycb(1644, 1, {}, $Nc);
_.Kb = function _Nc(a) {
    return new RBb(null, new Gvb(JD(a, 116).e, 16));
};
var aZ = jeb(sze, 'OrthogonalRoutingGenerator/lambda$0$Type', 1644);
Ycb(1645, 1, {}, aOc);
_.Kb = function bOc(a) {
    return new RBb(null, new Gvb(JD(a, 116).j, 16));
};
var bZ = jeb(sze, 'OrthogonalRoutingGenerator/lambda$1$Type', 1645);
Ycb(655, 1, {});
var dZ = jeb(tze, 'BaseRoutingDirectionStrategy', 655);
Ycb(1816, 655, {}, fOc);
_.wg = function gOc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (!!a.r && !a.q) return;
    k = b + a.o * c;
    for(j = new rmb(a.n); j.a < j.c.c.length;){
        i = JD(pmb(j), 11);
        l = Kdd(WC(OC(b2, 1), hre, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).a;
        for(h = new rmb(i.g); h.a < h.c.c.length;){
            g = JD(pmb(h), 18);
            if (!eWb(g)) {
                o = g.d;
                p = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    o.i.n,
                    o.n,
                    o.a
                ])).a;
                if ($wnd.Math.abs(l - p) > Fue) {
                    f = k;
                    e = a;
                    d = new Edd(l, f);
                    Atb(g.a, d);
                    cOc(this, g, e, d, false);
                    m = a.r;
                    if (m) {
                        n = Beb(MD(fu(m.e, 0)));
                        d = new Edd(n, f);
                        Atb(g.a, d);
                        cOc(this, g, e, d, false);
                        f = b + m.o * c;
                        e = m;
                        d = new Edd(n, f);
                        Atb(g.a, d);
                        cOc(this, g, e, d, false);
                    }
                    d = new Edd(p, f);
                    Atb(g.a, d);
                    cOc(this, g, e, d, false);
                }
            }
        }
    }
};
_.xg = function hOc(a) {
    return a.i.n.a + a.n.a + a.a.a;
};
_.yg = function iOc() {
    return Rjd(), Ojd;
};
_.zg = function jOc() {
    return Rjd(), xjd;
};
var eZ = jeb(tze, 'NorthToSouthRoutingStrategy', 1816);
Ycb(1817, 655, {}, kOc);
_.wg = function lOc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (!!a.r && !a.q) return;
    k = b - a.o * c;
    for(j = new rmb(a.n); j.a < j.c.c.length;){
        i = JD(pmb(j), 11);
        l = Kdd(WC(OC(b2, 1), hre, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).a;
        for(h = new rmb(i.g); h.a < h.c.c.length;){
            g = JD(pmb(h), 18);
            if (!eWb(g)) {
                o = g.d;
                p = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    o.i.n,
                    o.n,
                    o.a
                ])).a;
                if ($wnd.Math.abs(l - p) > Fue) {
                    f = k;
                    e = a;
                    d = new Edd(l, f);
                    Atb(g.a, d);
                    cOc(this, g, e, d, false);
                    m = a.r;
                    if (m) {
                        n = Beb(MD(fu(m.e, 0)));
                        d = new Edd(n, f);
                        Atb(g.a, d);
                        cOc(this, g, e, d, false);
                        f = b - m.o * c;
                        e = m;
                        d = new Edd(n, f);
                        Atb(g.a, d);
                        cOc(this, g, e, d, false);
                    }
                    d = new Edd(p, f);
                    Atb(g.a, d);
                    cOc(this, g, e, d, false);
                }
            }
        }
    }
};
_.xg = function mOc(a) {
    return a.i.n.a + a.n.a + a.a.a;
};
_.yg = function nOc() {
    return Rjd(), xjd;
};
_.zg = function oOc() {
    return Rjd(), Ojd;
};
var fZ = jeb(tze, 'SouthToNorthRoutingStrategy', 1817);
Ycb(1815, 655, {}, pOc);
_.wg = function qOc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (!!a.r && !a.q) return;
    k = b + a.o * c;
    for(j = new rmb(a.n); j.a < j.c.c.length;){
        i = JD(pmb(j), 11);
        l = Kdd(WC(OC(b2, 1), hre, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).b;
        for(h = new rmb(i.g); h.a < h.c.c.length;){
            g = JD(pmb(h), 18);
            if (!eWb(g)) {
                o = g.d;
                p = Kdd(WC(OC(b2, 1), hre, 8, 0, [
                    o.i.n,
                    o.n,
                    o.a
                ])).b;
                if ($wnd.Math.abs(l - p) > Fue) {
                    f = k;
                    e = a;
                    d = new Edd(f, l);
                    Atb(g.a, d);
                    cOc(this, g, e, d, true);
                    m = a.r;
                    if (m) {
                        n = Beb(MD(fu(m.e, 0)));
                        d = new Edd(f, n);
                        Atb(g.a, d);
                        cOc(this, g, e, d, true);
                        f = b + m.o * c;
                        e = m;
                        d = new Edd(f, n);
                        Atb(g.a, d);
                        cOc(this, g, e, d, true);
                    }
                    d = new Edd(f, p);
                    Atb(g.a, d);
                    cOc(this, g, e, d, true);
                }
            }
        }
    }
};
_.xg = function rOc(a) {
    return a.i.n.b + a.n.b + a.a.b;
};
_.yg = function sOc() {
    return Rjd(), wjd;
};
_.zg = function tOc() {
    return Rjd(), Qjd;
};
var gZ = jeb(tze, 'WestToEastRoutingStrategy', 1815);
Ycb(807, 1, {}, zOc);
_.Ib = function AOc() {
    return Ee(this.a);
};
_.b = 0;
_.c = false;
_.d = false;
_.f = 0;
var iZ = jeb(vze, 'NubSpline', 807);
Ycb(407, 1, {
    407: 1
}, DOc, EOc);
var hZ = jeb(vze, 'NubSpline/PolarCP', 407);
Ycb(1419, 1, gze, YOc);
_.pg = function $Oc(a) {
    return TOc(JD(a, 36));
};
_.If = function _Oc(a, b) {
    XOc(this, JD(a, 36), b);
};
var FOc, GOc, HOc, IOc, JOc;
var pZ = jeb(vze, 'SplineEdgeRouter', 1419);
Ycb(270, 1, {
    270: 1
}, cPc);
_.Ib = function dPc() {
    return this.a + ' ->(' + this.c + ') ' + this.b;
};
_.c = 0;
var jZ = jeb(vze, 'SplineEdgeRouter/Dependency', 270);
Ycb(451, 23, {
    3: 1,
    34: 1,
    23: 1,
    451: 1
}, hPc);
var ePc, fPc;
var kZ = keb(vze, 'SplineEdgeRouter/SideToProcess', 451, MI, jPc, iPc);
var kPc;
Ycb(1420, 1, Ire, mPc);
_.Mb = function nPc(a) {
    return KOc(), !JD(a, 132).o;
};
var lZ = jeb(vze, 'SplineEdgeRouter/lambda$0$Type', 1420);
Ycb(1421, 1, {}, oPc);
_.Xe = function pPc(a) {
    return KOc(), JD(a, 132).v + 1;
};
var mZ = jeb(vze, 'SplineEdgeRouter/lambda$1$Type', 1421);
Ycb(1422, 1, kre, qPc);
_.Ad = function rPc(a) {
    VOc(this.a, this.b, JD(a, 47));
};
var nZ = jeb(vze, 'SplineEdgeRouter/lambda$2$Type', 1422);
Ycb(1423, 1, kre, sPc);
_.Ad = function tPc(a) {
    WOc(this.a, this.b, JD(a, 47));
};
var oZ = jeb(vze, 'SplineEdgeRouter/lambda$3$Type', 1423);
Ycb(132, 1, {
    34: 1,
    132: 1
}, zPc, APc);
_.Dd = function BPc(a) {
    return xPc(this, JD(a, 132));
};
_.b = 0;
_.e = false;
_.f = 0;
_.g = 0;
_.j = false;
_.k = false;
_.n = 0;
_.o = false;
_.p = false;
_.q = false;
_.s = 0;
_.u = 0;
_.v = 0;
_.F = 0;
var rZ = jeb(vze, 'SplineSegment', 132);
Ycb(454, 1, {
    454: 1
}, CPc);
_.a = 0;
_.b = false;
_.c = false;
_.d = false;
_.e = false;
_.f = 0;
var qZ = jeb(vze, 'SplineSegment/EdgeInformation', 454);
Ycb(1162, 1, {}, LPc);
var tZ = jeb(Bze, que, 1162);
Ycb(1163, 1, Bte, NPc);
_.Le = function OPc(a, b) {
    return MPc(JD(a, 120), JD(b, 120));
};
_.Fb = function PPc(a) {
    return this === a;
};
_.Me = function QPc() {
    return new uqb(this);
};
var sZ = jeb(Bze, rue, 1163);
Ycb(1161, 1, {}, WPc);
var uZ = jeb(Bze, 'MrTree', 1161);
Ycb(396, 23, {
    3: 1,
    34: 1,
    23: 1,
    396: 1,
    188: 1,
    196: 1
}, bQc);
_.bg = function dQc() {
    return aQc(this);
};
_.og = function cQc() {
    return aQc(this);
};
var XPc, YPc, ZPc, $Pc;
var vZ = keb(Bze, 'TreeLayoutPhases', 396, MI, fQc, eQc);
var gQc;
Ycb(1077, 222, tue, iQc);
_.kf = function jQc(a, b) {
    var c, d, e, f, g, h, i, j;
    ydb(LD(ksd(a, (kVc(), VUc)))) || QDb((c = new RDb((Rod(), new dpd(a))), c));
    g = b.bh(Cze);
    g.Sg('build tGraph', 1);
    h = (i = new _Qc, UMb(i, a), ZMb(i, (tUc(), kUc), a), j = new Irb, TPc(a, i, j), SPc(a, i, j), i);
    g.Tg();
    g = b.bh(Cze);
    g.Sg('Split graph', 1);
    f = KPc(this.a, h);
    g.Tg();
    for(e = new rmb(f); e.a < e.c.c.length;){
        d = JD(pmb(e), 120);
        UPc(this.b, d, b.bh(0.5999999940395355 / f.c.length));
    }
    g = b.bh(Cze);
    g.Sg('Pack components', 1);
    h = JPc(f);
    g.Tg();
    g = b.bh(Cze);
    g.Sg('Apply layout results', 1);
    RPc(h);
    g.Tg();
};
var wZ = jeb(Bze, 'TreeLayoutProvider', 1077);
Ycb(1840, 1, pre, xQc);
_.Ic = function yQc(a) {
    ofb(this, a);
};
_.Jc = function zQc() {
    return pnb(), Hnb(), Gnb;
};
var xZ = jeb(Bze, 'TreeUtil/1', 1840);
Ycb(1841, 1, pre, AQc);
_.Ic = function BQc(a) {
    ofb(this, a);
};
_.Jc = function CQc() {
    return pnb(), Hnb(), Gnb;
};
var yZ = jeb(Bze, 'TreeUtil/2', 1841);
Ycb(1831, 1, Ire, DQc);
_.Mb = function EQc(a) {
    return ydb(LD(WMb(JD(a, 39), (tUc(), qUc))));
};
var zZ = jeb(Bze, 'TreeUtil/lambda$0$Type', 1831);
Ycb(1837, 1, Ire, FQc);
_.Mb = function GQc(a) {
    return this.a.Gc(JD(a, 39));
};
var AZ = jeb(Bze, 'TreeUtil/lambda$10$Type', 1837);
Ycb(1838, 1, {}, HQc);
_.Kb = function IQc(a) {
    return qQc(this.a, JD(a, 39));
};
var BZ = jeb(Bze, 'TreeUtil/lambda$11$Type', 1838);
Ycb(1839, 1, Ire, JQc);
_.Mb = function KQc(a) {
    return rQc(this.a, this.b, JD(a, 39));
};
var CZ = jeb(Bze, 'TreeUtil/lambda$12$Type', 1839);
Ycb(1832, 1, Ire, LQc);
_.Mb = function MQc(a) {
    return sQc(this.a, JD(a, 65));
};
var DZ = jeb(Bze, 'TreeUtil/lambda$3$Type', 1832);
Ycb(1833, 1, Bte, NQc);
_.Le = function OQc(a, b) {
    return tQc(JD(a, 65), JD(b, 65));
};
_.Fb = function PQc(a) {
    return this === a;
};
_.Me = function QQc() {
    return new uqb(this);
};
var EZ = jeb(Bze, 'TreeUtil/lambda$4$Type', 1833);
Ycb(1834, 1, Ire, RQc);
_.Mb = function SQc(a) {
    return uQc(this.a, JD(a, 65));
};
var FZ = jeb(Bze, 'TreeUtil/lambda$7$Type', 1834);
Ycb(1835, 1, Bte, TQc);
_.Le = function UQc(a, b) {
    return vQc(JD(a, 65), JD(b, 65));
};
_.Fb = function VQc(a) {
    return this === a;
};
_.Me = function WQc() {
    return new uqb(this);
};
var GZ = jeb(Bze, 'TreeUtil/lambda$8$Type', 1835);
Ycb(1836, 1, {}, XQc);
_.Kb = function YQc(a) {
    return JD(a, 65).b;
};
var HZ = jeb(Bze, 'TreeUtil/lambda$9$Type', 1836);
Ycb(492, 148, {
    3: 1,
    492: 1,
    102: 1,
    148: 1
});
_.g = 0;
var JZ = jeb(Eze, 'TGraphElement', 492);
Ycb(65, 492, {
    3: 1,
    65: 1,
    492: 1,
    102: 1,
    148: 1
}, ZQc);
_.Ib = function $Qc() {
    return !!this.b && !!this.c ? dRc(this.b) + '->' + dRc(this.c) : 'e_' + tb(this);
};
var IZ = jeb(Eze, 'TEdge', 65);
Ycb(120, 148, {
    3: 1,
    120: 1,
    102: 1,
    148: 1
}, _Qc);
_.Ib = function aRc() {
    var a, b, c, d, e;
    e = null;
    for(d = Gtb(this.b, 0); d.b != d.d.c;){
        c = JD(Utb(d), 39);
        e += (c.c == null || c.c.length == 0 ? 'n_' + c.g : 'n_' + c.c) + '\n';
    }
    for(b = Gtb(this.a, 0); b.b != b.d.c;){
        a = JD(Utb(b), 65);
        e += (!!a.b && !!a.c ? dRc(a.b) + '->' + dRc(a.c) : 'e_' + tb(a)) + '\n';
    }
    return e;
};
var KZ = jeb(Eze, 'TGraph', 120);
Ycb(628, 492, {
    3: 1,
    492: 1,
    628: 1,
    102: 1,
    148: 1
});
var OZ = jeb(Eze, 'TShape', 628);
Ycb(39, 628, {
    3: 1,
    492: 1,
    39: 1,
    628: 1,
    102: 1,
    148: 1
}, eRc);
_.Ib = function fRc() {
    return dRc(this);
};
var NZ = jeb(Eze, 'TNode', 39);
Ycb(235, 1, pre, gRc);
_.Ic = function hRc(a) {
    ofb(this, a);
};
_.Jc = function iRc() {
    var a;
    return a = Gtb(this.a.d, 0), new jRc(a);
};
var MZ = jeb(Eze, 'TNode/2', 235);
Ycb(329, 1, Wqe, jRc);
_.Nb = function kRc(a) {
    Osb(this, a);
};
_.Pb = function mRc() {
    return JD(Utb(this.a), 65).c;
};
_.Ob = function lRc() {
    return Ttb(this.a);
};
_.Qb = function nRc() {
    Wtb(this.a);
};
var LZ = jeb(Eze, 'TNode/2/1', 329);
Ycb(1869, 1, Dve, tRc);
_.If = function GRc(a, b) {
    rRc(this, JD(a, 120), b);
};
var a$ = jeb(Gze, 'CompactionProcessor', 1869);
Ycb(1870, 1, Bte, HRc);
_.Le = function IRc(a, b) {
    return uRc(this.a, JD(a, 39), JD(b, 39));
};
_.Fb = function JRc(a) {
    return this === a;
};
_.Me = function KRc() {
    return new uqb(this);
};
var PZ = jeb(Gze, 'CompactionProcessor/lambda$0$Type', 1870);
Ycb(1871, 1, Ire, LRc);
_.Mb = function MRc(a) {
    return vRc(this.b, this.a, JD(a, 47));
};
_.a = 0;
_.b = 0;
var QZ = jeb(Gze, 'CompactionProcessor/lambda$1$Type', 1871);
Ycb(1880, 1, Bte, NRc);
_.Le = function ORc(a, b) {
    return wRc(JD(a, 39), JD(b, 39));
};
_.Fb = function PRc(a) {
    return this === a;
};
_.Me = function QRc() {
    return new uqb(this);
};
var RZ = jeb(Gze, 'CompactionProcessor/lambda$10$Type', 1880);
Ycb(1881, 1, Bte, RRc);
_.Le = function SRc(a, b) {
    return xRc(JD(a, 39), JD(b, 39));
};
_.Fb = function TRc(a) {
    return this === a;
};
_.Me = function URc() {
    return new uqb(this);
};
var SZ = jeb(Gze, 'CompactionProcessor/lambda$11$Type', 1881);
Ycb(1882, 1, Bte, VRc);
_.Le = function WRc(a, b) {
    return yRc(JD(a, 39), JD(b, 39));
};
_.Fb = function XRc(a) {
    return this === a;
};
_.Me = function YRc() {
    return new uqb(this);
};
var TZ = jeb(Gze, 'CompactionProcessor/lambda$12$Type', 1882);
Ycb(1872, 1, Ire, ZRc);
_.Mb = function $Rc(a) {
    return zRc(this.a, JD(a, 47));
};
_.a = 0;
var UZ = jeb(Gze, 'CompactionProcessor/lambda$2$Type', 1872);
Ycb(1873, 1, Ire, _Rc);
_.Mb = function aSc(a) {
    return ARc(this.a, JD(a, 47));
};
_.a = 0;
var VZ = jeb(Gze, 'CompactionProcessor/lambda$3$Type', 1873);
Ycb(1874, 1, Ire, bSc);
_.Mb = function cSc(a) {
    return JD(a, 39).c.indexOf(Dze) == -1;
};
var WZ = jeb(Gze, 'CompactionProcessor/lambda$4$Type', 1874);
Ycb(1875, 1, {}, dSc);
_.Kb = function eSc(a) {
    return BRc(this.a, JD(a, 39));
};
_.a = 0;
var XZ = jeb(Gze, 'CompactionProcessor/lambda$5$Type', 1875);
Ycb(1876, 1, {}, fSc);
_.Kb = function gSc(a) {
    return CRc(this.a, JD(a, 39));
};
_.a = 0;
var YZ = jeb(Gze, 'CompactionProcessor/lambda$6$Type', 1876);
Ycb(1877, 1, Bte, hSc);
_.Le = function iSc(a, b) {
    return DRc(this.a, JD(a, 239), JD(b, 239));
};
_.Fb = function jSc(a) {
    return this === a;
};
_.Me = function kSc() {
    return new uqb(this);
};
var ZZ = jeb(Gze, 'CompactionProcessor/lambda$7$Type', 1877);
Ycb(1878, 1, Bte, lSc);
_.Le = function mSc(a, b) {
    return ERc(this.a, JD(a, 39), JD(b, 39));
};
_.Fb = function nSc(a) {
    return this === a;
};
_.Me = function oSc() {
    return new uqb(this);
};
var $Z = jeb(Gze, 'CompactionProcessor/lambda$8$Type', 1878);
Ycb(1879, 1, Bte, pSc);
_.Le = function qSc(a, b) {
    return FRc(JD(a, 39), JD(b, 39));
};
_.Fb = function rSc(a) {
    return this === a;
};
_.Me = function sSc() {
    return new uqb(this);
};
var _Z = jeb(Gze, 'CompactionProcessor/lambda$9$Type', 1879);
Ycb(1867, 1, Dve, uSc);
_.If = function vSc(a, b) {
    tSc(JD(a, 120), b);
};
var b$ = jeb(Gze, 'DirectionProcessor', 1867);
Ycb(1859, 1, Dve, ySc);
_.If = function ASc(a, b) {
    xSc(this, JD(a, 120), b);
};
var c$ = jeb(Gze, 'FanProcessor', 1859);
Ycb(1883, 1, Dve, CSc);
_.If = function FSc(a, b) {
    BSc(JD(a, 120), b);
};
var h$ = jeb(Gze, 'GraphBoundsProcessor', 1883);
Ycb(1884, 1, {}, GSc);
_.We = function HSc(a) {
    return JD(a, 39).e.a;
};
var d$ = jeb(Gze, 'GraphBoundsProcessor/lambda$0$Type', 1884);
Ycb(1885, 1, {}, ISc);
_.We = function JSc(a) {
    return JD(a, 39).e.b;
};
var e$ = jeb(Gze, 'GraphBoundsProcessor/lambda$1$Type', 1885);
Ycb(1886, 1, {}, KSc);
_.We = function LSc(a) {
    return DSc(JD(a, 39));
};
var f$ = jeb(Gze, 'GraphBoundsProcessor/lambda$2$Type', 1886);
Ycb(1887, 1, {}, MSc);
_.We = function NSc(a) {
    return ESc(JD(a, 39));
};
var g$ = jeb(Gze, 'GraphBoundsProcessor/lambda$3$Type', 1887);
Ycb(262, 23, {
    3: 1,
    34: 1,
    23: 1,
    262: 1,
    196: 1
}, $Sc);
_.bg = function _Sc() {
    switch(this.g){
        case 0:
            return new GTc;
        case 1:
            return new ySc;
        case 2:
            return new qTc;
        case 3:
            return new wTc;
        case 4:
            return new jTc;
        case 8:
            return new fTc;
        case 5:
            return new uSc;
        case 6:
            return new DTc;
        case 7:
            return new tRc;
        case 9:
            return new CSc;
        case 10:
            return new JTc;
        default:
            throw scb(new Teb($ve + (this.f != null ? this.f : '' + this.g)));
    }
};
var OSc, PSc, QSc, RSc, SSc, TSc, USc, VSc, WSc, XSc, YSc;
var i$ = keb(Gze, _ve, 262, MI, bTc, aTc);
var cTc;
Ycb(1866, 1, Dve, fTc);
_.If = function gTc(a, b) {
    eTc(JD(a, 120), b);
};
var j$ = jeb(Gze, 'LevelCoordinatesProcessor', 1866);
Ycb(1864, 1, Dve, jTc);
_.If = function kTc(a, b) {
    hTc(this, JD(a, 120), b);
};
_.a = 0;
var l$ = jeb(Gze, 'LevelHeightProcessor', 1864);
Ycb(1865, 1, pre, lTc);
_.Ic = function mTc(a) {
    ofb(this, a);
};
_.Jc = function nTc() {
    return pnb(), Hnb(), Gnb;
};
var k$ = jeb(Gze, 'LevelHeightProcessor/1', 1865);
Ycb(1860, 1, Dve, qTc);
_.If = function rTc(a, b) {
    oTc(this, JD(a, 120), b);
};
var n$ = jeb(Gze, 'LevelProcessor', 1860);
Ycb(1861, 1, Ire, sTc);
_.Mb = function tTc(a) {
    return ydb(LD(WMb(JD(a, 39), (tUc(), qUc))));
};
var m$ = jeb(Gze, 'LevelProcessor/lambda$0$Type', 1861);
Ycb(1862, 1, Dve, wTc);
_.If = function xTc(a, b) {
    uTc(this, JD(a, 120), b);
};
_.a = 0;
var p$ = jeb(Gze, 'NeighborsProcessor', 1862);
Ycb(1863, 1, pre, yTc);
_.Ic = function zTc(a) {
    ofb(this, a);
};
_.Jc = function ATc() {
    return pnb(), Hnb(), Gnb;
};
var o$ = jeb(Gze, 'NeighborsProcessor/1', 1863);
Ycb(1868, 1, Dve, DTc);
_.If = function ETc(a, b) {
    BTc(this, JD(a, 120), b);
};
_.a = 0;
var q$ = jeb(Gze, 'NodePositionProcessor', 1868);
Ycb(1858, 1, Dve, GTc);
_.If = function HTc(a, b) {
    FTc(this, JD(a, 120), b);
};
var r$ = jeb(Gze, 'RootProcessor', 1858);
Ycb(1888, 1, Dve, JTc);
_.If = function KTc(a, b) {
    ITc(JD(a, 120), b);
};
var s$ = jeb(Gze, 'Untreeifyer', 1888);
Ycb(383, 23, {
    3: 1,
    34: 1,
    23: 1,
    383: 1
}, PTc);
var LTc, MTc, NTc;
var t$ = keb(Kze, 'EdgeRoutingMode', 383, MI, RTc, QTc);
var STc;
var UTc, VTc, WTc, XTc, YTc, ZTc, $Tc, _Tc, aUc, bUc, cUc, dUc, eUc, fUc, gUc, hUc, iUc, jUc, kUc, lUc, mUc, nUc, oUc, pUc, qUc, rUc, sUc;
Ycb(841, 1, Hue, FUc);
_.tf = function GUc(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Mze), ''), Tze), 'Turns on Tree compaction which decreases the size of the whole tree by placing nodes of multiple levels in one large level'), (xdb(), false)), (zcd(), rcd)), GI), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Nze), ''), 'Edge End Texture Length'), 'Should be set to the length of the texture at the end of an edge. This value can be used to improve the Edge Routing.'), 7), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Oze), ''), 'Tree Level'), 'The index for the tree level the node is in'), jfb(0)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Pze), ''), Tze), 'When set to a positive number this option will force the algorithm to place the node to the specified position within the trees layer if weighting is set to constraint'), jfb(-1)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Qze), ''), 'Weighting of Nodes'), 'Which weighting to use when computing a node order.'), DUc), tcd), x$), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Rze), ''), 'Edge Routing Mode'), 'Chooses an Edge Routing algorithm.'), xUc), tcd), t$), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Sze), ''), 'Search Order'), 'Which search order to use when computing a spanning tree.'), AUc), tcd), y$), mrb(jcd))));
    lVc((new mVc, a));
};
var uUc, vUc, wUc, xUc, yUc, zUc, AUc, BUc, CUc, DUc;
var u$ = jeb(Kze, 'MrTreeMetaDataProvider', 841);
Ycb(983, 1, Hue, mVc);
_.tf = function nVc(a) {
    lVc(a);
};
var HUc, IUc, JUc, KUc, LUc, MUc, NUc, OUc, PUc, QUc, RUc, SUc, TUc, UUc, VUc, WUc, XUc, YUc, ZUc, $Uc, _Uc, aVc, bVc, cVc, dVc, eVc, fVc, gVc, hVc, iVc, jVc;
var w$ = jeb(Kze, 'MrTreeOptions', 983);
Ycb(984, 1, {}, oVc);
_.uf = function pVc() {
    var a;
    return a = new iQc, a;
};
_.vf = function qVc(a) {};
var v$ = jeb(Kze, 'MrTreeOptions/MrtreeFactory', 984);
Ycb(350, 23, {
    3: 1,
    34: 1,
    23: 1,
    350: 1
}, wVc);
var rVc, sVc, tVc, uVc;
var x$ = keb(Kze, 'OrderWeighting', 350, MI, yVc, xVc);
var zVc;
Ycb(422, 23, {
    3: 1,
    34: 1,
    23: 1,
    422: 1
}, EVc);
var BVc, CVc;
var y$ = keb(Kze, 'TreeifyingOrder', 422, MI, GVc, FVc);
var HVc;
Ycb(1425, 1, gze, QVc);
_.pg = function RVc(a) {
    return JD(a, 120), JVc;
};
_.If = function SVc(a, b) {
    PVc(this, JD(a, 120), b);
};
var JVc;
var z$ = jeb('org.eclipse.elk.alg.mrtree.p1treeify', 'DFSTreeifyer', 1425);
Ycb(1426, 1, gze, YVc);
_.pg = function ZVc(a) {
    return JD(a, 120), TVc;
};
_.If = function bWc(a, b) {
    XVc(this, JD(a, 120), b);
};
var TVc;
var H$ = jeb(Xze, 'NodeOrderer', 1426);
Ycb(1433, 1, {}, dWc);
_.rd = function eWc(a) {
    return cWc(a);
};
var A$ = jeb(Xze, 'NodeOrderer/0methodref$lambda$6$Type', 1433);
Ycb(1427, 1, Ire, fWc);
_.Mb = function gWc(a) {
    return UVc(), ydb(LD(WMb(JD(a, 39), (tUc(), qUc))));
};
var B$ = jeb(Xze, 'NodeOrderer/lambda$0$Type', 1427);
Ycb(1428, 1, Ire, hWc);
_.Mb = function iWc(a) {
    return UVc(), JD(WMb(JD(a, 39), (kVc(), ZUc)), 17).a < 0;
};
var C$ = jeb(Xze, 'NodeOrderer/lambda$1$Type', 1428);
Ycb(1429, 1, Ire, jWc);
_.Mb = function kWc(a) {
    return $Vc(this.a, JD(a, 39));
};
var D$ = jeb(Xze, 'NodeOrderer/lambda$2$Type', 1429);
Ycb(1430, 1, Ire, lWc);
_.Mb = function mWc(a) {
    return _Vc(this.a, JD(a, 39));
};
var E$ = jeb(Xze, 'NodeOrderer/lambda$3$Type', 1430);
Ycb(1431, 1, Bte, nWc);
_.Le = function oWc(a, b) {
    return aWc(JD(a, 39), JD(b, 39));
};
_.Fb = function pWc(a) {
    return this === a;
};
_.Me = function qWc() {
    return new uqb(this);
};
var F$ = jeb(Xze, 'NodeOrderer/lambda$4$Type', 1431);
Ycb(1432, 1, Ire, rWc);
_.Mb = function sWc(a) {
    return UVc(), JD(WMb(JD(a, 39), (tUc(), $Tc)), 17).a != 0;
};
var G$ = jeb(Xze, 'NodeOrderer/lambda$5$Type', 1432);
Ycb(1434, 1, gze, AWc);
_.pg = function BWc(a) {
    return JD(a, 120), tWc;
};
_.If = function CWc(a, b) {
    yWc(this, JD(a, 120), b);
};
_.b = 0;
var tWc;
var I$ = jeb('org.eclipse.elk.alg.mrtree.p3place', 'NodePlacer', 1434);
Ycb(1435, 1, gze, MWc);
_.pg = function NWc(a) {
    return JD(a, 120), DWc;
};
_.If = function _Wc(a, b) {
    LWc(JD(a, 120), b);
};
var DWc;
var c_ = jeb(Yze, 'EdgeRouter', 1435);
Ycb(1437, 1, Bte, aXc);
_.Le = function bXc(a, b) {
    return $eb(JD(a, 17).a, JD(b, 17).a);
};
_.Fb = function cXc(a) {
    return this === a;
};
_.Me = function dXc() {
    return new uqb(this);
};
var J$ = jeb(Yze, 'EdgeRouter/0methodref$compare$Type', 1437);
Ycb(1442, 1, {}, eXc);
_.We = function fXc(a) {
    return Beb(MD(a));
};
var K$ = jeb(Yze, 'EdgeRouter/1methodref$doubleValue$Type', 1442);
Ycb(1444, 1, Bte, gXc);
_.Le = function hXc(a, b) {
    return Heb(Beb(MD(a)), Beb(MD(b)));
};
_.Fb = function iXc(a) {
    return this === a;
};
_.Me = function jXc() {
    return new uqb(this);
};
var L$ = jeb(Yze, 'EdgeRouter/2methodref$compare$Type', 1444);
Ycb(1446, 1, Bte, kXc);
_.Le = function lXc(a, b) {
    return Heb(Beb(MD(a)), Beb(MD(b)));
};
_.Fb = function mXc(a) {
    return this === a;
};
_.Me = function nXc() {
    return new uqb(this);
};
var M$ = jeb(Yze, 'EdgeRouter/3methodref$compare$Type', 1446);
Ycb(1448, 1, {}, oXc);
_.We = function pXc(a) {
    return Beb(MD(a));
};
var N$ = jeb(Yze, 'EdgeRouter/4methodref$doubleValue$Type', 1448);
Ycb(1450, 1, Bte, qXc);
_.Le = function rXc(a, b) {
    return Heb(Beb(MD(a)), Beb(MD(b)));
};
_.Fb = function sXc(a) {
    return this === a;
};
_.Me = function tXc() {
    return new uqb(this);
};
var O$ = jeb(Yze, 'EdgeRouter/5methodref$compare$Type', 1450);
Ycb(1452, 1, Bte, uXc);
_.Le = function vXc(a, b) {
    return Heb(Beb(MD(a)), Beb(MD(b)));
};
_.Fb = function wXc(a) {
    return this === a;
};
_.Me = function xXc() {
    return new uqb(this);
};
var P$ = jeb(Yze, 'EdgeRouter/6methodref$compare$Type', 1452);
Ycb(1436, 1, {}, yXc);
_.Kb = function zXc(a) {
    return EWc(), JD(WMb(JD(a, 39), (kVc(), iVc)), 17);
};
var Q$ = jeb(Yze, 'EdgeRouter/lambda$0$Type', 1436);
Ycb(1447, 1, {}, AXc);
_.Kb = function BXc(a) {
    return OWc(JD(a, 39));
};
var R$ = jeb(Yze, 'EdgeRouter/lambda$11$Type', 1447);
Ycb(1449, 1, {}, CXc);
_.Kb = function DXc(a) {
    return PWc(this.b, this.a, JD(a, 39));
};
_.a = 0;
_.b = 0;
var S$ = jeb(Yze, 'EdgeRouter/lambda$13$Type', 1449);
Ycb(1451, 1, {}, EXc);
_.Kb = function FXc(a) {
    return QWc(this.b, this.a, JD(a, 39));
};
_.a = 0;
_.b = 0;
var T$ = jeb(Yze, 'EdgeRouter/lambda$15$Type', 1451);
Ycb(1453, 1, Bte, GXc);
_.Le = function HXc(a, b) {
    return RWc(JD(a, 65), JD(b, 65));
};
_.Fb = function IXc(a) {
    return this === a;
};
_.Me = function JXc() {
    return new uqb(this);
};
var U$ = jeb(Yze, 'EdgeRouter/lambda$17$Type', 1453);
Ycb(1454, 1, Bte, KXc);
_.Le = function LXc(a, b) {
    return SWc(JD(a, 65), JD(b, 65));
};
_.Fb = function MXc(a) {
    return this === a;
};
_.Me = function NXc() {
    return new uqb(this);
};
var V$ = jeb(Yze, 'EdgeRouter/lambda$18$Type', 1454);
Ycb(1455, 1, Bte, OXc);
_.Le = function PXc(a, b) {
    return TWc(JD(a, 65), JD(b, 65));
};
_.Fb = function QXc(a) {
    return this === a;
};
_.Me = function RXc() {
    return new uqb(this);
};
var W$ = jeb(Yze, 'EdgeRouter/lambda$19$Type', 1455);
Ycb(1438, 1, Ire, SXc);
_.Mb = function TXc(a) {
    return UWc(this.a, JD(a, 39));
};
_.a = 0;
var X$ = jeb(Yze, 'EdgeRouter/lambda$2$Type', 1438);
Ycb(1456, 1, Bte, UXc);
_.Le = function VXc(a, b) {
    return VWc(JD(a, 65), JD(b, 65));
};
_.Fb = function WXc(a) {
    return this === a;
};
_.Me = function XXc() {
    return new uqb(this);
};
var Y$ = jeb(Yze, 'EdgeRouter/lambda$20$Type', 1456);
Ycb(1439, 1, Bte, YXc);
_.Le = function ZXc(a, b) {
    return WWc(JD(a, 39), JD(b, 39));
};
_.Fb = function $Xc(a) {
    return this === a;
};
_.Me = function _Xc() {
    return new uqb(this);
};
var Z$ = jeb(Yze, 'EdgeRouter/lambda$3$Type', 1439);
Ycb(1440, 1, Bte, aYc);
_.Le = function bYc(a, b) {
    return XWc(JD(a, 39), JD(b, 39));
};
_.Fb = function cYc(a) {
    return this === a;
};
_.Me = function dYc() {
    return new uqb(this);
};
var $$ = jeb(Yze, 'EdgeRouter/lambda$4$Type', 1440);
Ycb(1441, 1, {}, eYc);
_.Kb = function fYc(a) {
    return YWc(JD(a, 39));
};
var _$ = jeb(Yze, 'EdgeRouter/lambda$5$Type', 1441);
Ycb(1443, 1, {}, gYc);
_.Kb = function hYc(a) {
    return ZWc(this.b, this.a, JD(a, 39));
};
_.a = 0;
_.b = 0;
var a_ = jeb(Yze, 'EdgeRouter/lambda$7$Type', 1443);
Ycb(1445, 1, {}, iYc);
_.Kb = function jYc(a) {
    return $Wc(this.b, this.a, JD(a, 39));
};
_.a = 0;
_.b = 0;
var b_ = jeb(Yze, 'EdgeRouter/lambda$9$Type', 1445);
Ycb(660, 1, {
    660: 1
}, lYc);
_.e = 0;
_.f = false;
_.g = false;
var f_ = jeb(Yze, 'MultiLevelEdgeNodeNodeGap', 660);
Ycb(1889, 1, Bte, oYc);
_.Le = function pYc(a, b) {
    return mYc(JD(a, 239), JD(b, 239));
};
_.Fb = function qYc(a) {
    return this === a;
};
_.Me = function rYc() {
    return new uqb(this);
};
var d_ = jeb(Yze, 'MultiLevelEdgeNodeNodeGap/lambda$0$Type', 1889);
Ycb(1890, 1, Bte, sYc);
_.Le = function tYc(a, b) {
    return nYc(JD(a, 239), JD(b, 239));
};
_.Fb = function uYc(a) {
    return this === a;
};
_.Me = function vYc() {
    return new uqb(this);
};
var e_ = jeb(Yze, 'MultiLevelEdgeNodeNodeGap/lambda$1$Type', 1890);
var wYc;
Ycb(485, 23, {
    3: 1,
    34: 1,
    23: 1,
    485: 1,
    188: 1,
    196: 1
}, CYc);
_.bg = function EYc() {
    return BYc(this);
};
_.og = function DYc() {
    return BYc(this);
};
var yYc, zYc;
var g_ = keb(Zze, 'RadialLayoutPhases', 485, MI, GYc, FYc);
var HYc;
Ycb(1078, 222, tue, KYc);
_.kf = function LYc(a, b) {
    var c, d, e, f, g, h;
    c = JYc(this, a);
    b.Sg('Radial layout', c.c.length);
    ydb(LD(ksd(a, (b_c(), Q$c)))) || QDb((d = new RDb((Rod(), new dpd(a))), d));
    h = NYc(a);
    msd(a, (xYc(), wYc), h);
    if (!h) throw scb(new Teb('The given graph is not a tree!'));
    e = Beb(MD(ksd(a, V$c)));
    e == 0 && (e = MYc(a));
    msd(a, V$c, e);
    for(g = new rmb(JYc(this, a)); g.a < g.c.c.length;){
        f = JD(pmb(g), 44);
        f.If(a, b.bh(1));
    }
    b.Tg();
};
var h_ = jeb(Zze, 'RadialLayoutProvider', 1078);
Ycb(541, 1, Bte, WYc);
_.Le = function XYc(a, b) {
    return VYc(this.a, this.b, JD(a, 27), JD(b, 27));
};
_.Fb = function YYc(a) {
    return this === a;
};
_.Me = function ZYc() {
    return new uqb(this);
};
_.a = 0;
_.b = 0;
var i_ = jeb(Zze, 'RadialUtil/lambda$0$Type', 541);
Ycb(1334, 1, Dve, _Yc);
_.If = function aZc(a, b) {
    $Yc(JD(a, 27), b);
};
var j_ = jeb(cAe, 'CalculateGraphSize', 1334);
Ycb(1335, 1, Dve, cZc);
_.If = function dZc(a, b) {
    bZc(JD(a, 27));
};
var k_ = jeb(cAe, 'EdgeAngleCalculator', 1335);
Ycb(361, 23, {
    3: 1,
    34: 1,
    23: 1,
    361: 1,
    196: 1
}, kZc);
_.bg = function lZc() {
    switch(this.g){
        case 0:
            return new TZc;
        case 1:
            return new DZc;
        case 2:
            return new XZc;
        case 3:
            return new _Yc;
        case 4:
            return new cZc;
        default:
            throw scb(new Teb($ve + (this.f != null ? this.f : '' + this.g)));
    }
};
var eZc, fZc, gZc, hZc, iZc;
var l_ = keb(cAe, _ve, 361, MI, nZc, mZc);
var oZc;
Ycb(636, 1, {});
_.e = 1;
_.g = 0;
var m_ = jeb(eAe, 'AbstractRadiusExtensionCompaction', 636);
Ycb(1780, 636, {}, AZc);
_.Ag = function BZc(a) {
    var b, c, d, e, f, g, h, i, j;
    this.c = JD(ksd(a, (xYc(), wYc)), 27);
    uZc(this, this.c);
    this.d = x_c(JD(ksd(a, (b_c(), $$c)), 299));
    i = JD(ksd(a, K$c), 17);
    !!i && tZc(this, i.a);
    h = MD(ksd(a, (Lgd(), wgd)));
    vZc(this, (tDb(h), h));
    j = TYc(this.c);
    !!this.d && this.d.Eg(j);
    wZc(this, j);
    g = new dnb(WC(OC(A3, 1), fAe, 27, 0, [
        this.c
    ]));
    for(c = 0; c < 2; c++)for(b = 0; b < j.c.length; b++){
        e = new dnb(WC(OC(A3, 1), fAe, 27, 0, [
            (sDb(b, j.c.length), JD(j.c[b], 27))
        ]));
        f = b < j.c.length - 1 ? (sDb(b + 1, j.c.length), JD(j.c[b + 1], 27)) : (sDb(0, j.c.length), JD(j.c[0], 27));
        d = b == 0 ? JD(Mlb(j, j.c.length - 1), 27) : (sDb(b - 1, j.c.length), JD(j.c[b - 1], 27));
        yZc(this, (sDb(b, j.c.length), JD(j.c[b], 27), g), d, f, e);
    }
};
var n_ = jeb(eAe, 'AnnulusWedgeCompaction', 1780);
Ycb(1332, 1, Dve, DZc);
_.If = function EZc(a, b) {
    CZc(JD(a, 27), b);
};
var o_ = jeb(eAe, 'GeneralCompactor', 1332);
Ycb(1779, 636, {}, IZc);
_.Ag = function JZc(a) {
    var b, c, d, e;
    c = JD(ksd(a, (xYc(), wYc)), 27);
    this.f = c;
    this.b = x_c(JD(ksd(a, (b_c(), $$c)), 299));
    e = JD(ksd(a, K$c), 17);
    !!e && tZc(this, e.a);
    d = MD(ksd(a, (Lgd(), wgd)));
    vZc(this, (tDb(d), d));
    b = TYc(c);
    !!this.b && this.b.Eg(b);
    GZc(this, b);
};
_.a = 0;
var p_ = jeb(eAe, 'RadialCompaction', 1779);
Ycb(1788, 1, {}, LZc);
_.Bg = function MZc(a) {
    var b, c, d, e, f, g;
    this.a = a;
    b = 0;
    g = TYc(a);
    d = 0;
    for(f = new rmb(g); f.a < f.c.c.length;){
        e = JD(pmb(f), 27);
        ++d;
        for(c = d; c < g.c.length; c++)KZc(this, e, (sDb(c, g.c.length), JD(g.c[c], 27))) && (b += 1);
    }
    return b;
};
var q_ = jeb(gAe, 'CrossingMinimizationPosition', 1788);
Ycb(1786, 1, {}, NZc);
_.Bg = function OZc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    d = 0;
    for(c = new es(Ir($Bd(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 85);
        h = _Bd(JD(nDd((!b.c && (b.c = new ree(v3, b, 5, 8)), b.c), 0), 84));
        j = h.i + h.g / 2;
        k = h.j + h.f / 2;
        e = a.i + a.g / 2;
        f = a.j + a.f / 2;
        l = new Cdd;
        l.a = j - e;
        l.b = k - f;
        g = new Edd(l.a, l.b);
        Lcd(g, a.g, a.f);
        l.a -= g.a;
        l.b -= g.b;
        e = j - l.a;
        f = k - l.b;
        i = new Edd(l.a, l.b);
        Lcd(i, h.g, h.f);
        l.a -= i.a;
        l.b -= i.b;
        j = e + l.a;
        k = f + l.b;
        m = j - e;
        n = k - f;
        d += $wnd.Math.sqrt(m * m + n * n);
    }
    return d;
};
var r_ = jeb(gAe, 'EdgeLengthOptimization', 1786);
Ycb(1787, 1, {}, PZc);
_.Bg = function QZc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    d = 0;
    for(c = new es(Ir($Bd(a).a.Jc(), new er)); cs(c);){
        b = JD(ds(c), 85);
        h = _Bd(JD(nDd((!b.c && (b.c = new ree(v3, b, 5, 8)), b.c), 0), 84));
        i = h.i + h.g / 2;
        j = h.j + h.f / 2;
        e = JD(ksd(h, (Lgd(), fgd)), 8);
        f = a.i + e.a + a.g / 2;
        g = a.j + e.b + a.f;
        k = i - f;
        l = j - g;
        d += $wnd.Math.sqrt(k * k + l * l);
    }
    return d;
};
var s_ = jeb(gAe, 'EdgeLengthPositionOptimization', 1787);
Ycb(1331, 636, Dve, TZc);
_.If = function UZc(a, b) {
    SZc(this, JD(a, 27), b);
};
var t_ = jeb('org.eclipse.elk.alg.radial.intermediate.overlaps', 'RadiusExtensionOverlapRemoval', 1331);
Ycb(1333, 1, Dve, XZc);
_.If = function YZc(a, b) {
    WZc(JD(a, 27), b);
};
var u_ = jeb('org.eclipse.elk.alg.radial.intermediate.rotation', 'GeneralRotator', 1333);
Ycb(423, 23, {
    3: 1,
    34: 1,
    23: 1,
    423: 1
}, b$c);
var ZZc, $Zc;
var v_ = keb(iAe, 'AnnulusWedgeCriteria', 423, MI, d$c, c$c);
var e$c;
Ycb(384, 23, {
    3: 1,
    34: 1,
    23: 1,
    384: 1
}, l$c);
var g$c, h$c, i$c;
var w_ = keb(iAe, jAe, 384, MI, n$c, m$c);
var o$c;
Ycb(842, 1, Hue, H$c);
_.tf = function I$c(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, kAe), ''), 'Center On Root'), 'Centers the layout on the root of the tree i.e. so that the central node is also the center node of the final layout. This introduces additional whitespace.'), (xdb(), false)), (zcd(), rcd)), GI), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, lAe), ''), 'Order ID'), 'The id can be used to define an order for nodes of one radius. This can be used to sort them in the layer accordingly.'), jfb(0)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, mAe), ''), 'Radius'), 'The radius option can be used to set the initial radius for the radial layouter.'), 0), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, nAe), ''), 'Rotate'), 'The rotate option determines whether a rotation of the layout should be performed.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, oAe), ''), wAe), 'With the compacter option it can be determined how compaction on the graph is done. It can be chosen between none, the radial compaction or the compaction of wedges separately.'), t$c), tcd), w_), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, pAe), ''), 'Compaction Step Size'), 'Determine the size of steps with which the compaction is done. Step size 1 correlates to a compaction of 1 pixel per Iteration.'), jfb(1)), vcd), UI), mrb(jcd))));
    Oad(a, pAe, oAe, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, qAe), ''), 'Sorter'), 'Sort the nodes per radius according to the sorting algorithm. The strategies are none, by the given order id, or sorting them by polar coordinates.'), D$c), tcd), B_), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, rAe), ''), 'Annulus Wedge Criteria'), 'Determine how the wedge for the node placement is calculated. It can be chosen between wedge determination by the number of leaves or by the maximum sum of diagonals.'), F$c), tcd), v_), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, sAe), ''), 'Translation Optimization'), 'Find the optimal translation of the nodes of the first radii according to this criteria. For example edge crossings can be minimized.'), v$c), tcd), A_), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, tAe), xAe), 'Target Angle'), 'The angle in radians that the layout should be rotated to after layout.'), 0), scd), LI), mrb(jcd))));
    Oad(a, tAe, nAe, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, uAe), xAe), 'Additional Wedge Space'), 'If set to true, modifies the target angle by rotating further such that space is left for an edge to pass in between the nodes. This option should only be used in conjunction with top-down layout.'), false), rcd), GI), mrb(jcd))));
    Oad(a, uAe, nAe, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, vAe), xAe), 'Outgoing Edge Angles'), 'Calculate the required angle of connected nodes to leave space for an incoming edge. This option should only be used in conjunction with top-down layout.'), false), rcd), GI), mrb(jcd))));
    c_c((new d_c, a));
};
var q$c, r$c, s$c, t$c, u$c, v$c, w$c, x$c, y$c, z$c, A$c, B$c, C$c, D$c, E$c, F$c;
var x_ = jeb(iAe, 'RadialMetaDataProvider', 842);
Ycb(985, 1, Hue, d_c);
_.tf = function e_c(a) {
    c_c(a);
};
var J$c, K$c, L$c, M$c, N$c, O$c, P$c, Q$c, R$c, S$c, T$c, U$c, V$c, W$c, X$c, Y$c, Z$c, $$c, _$c, a_c;
var z_ = jeb(iAe, 'RadialOptions', 985);
Ycb(986, 1, {}, f_c);
_.uf = function g_c() {
    var a;
    return a = new KYc, a;
};
_.vf = function h_c(a) {};
var y_ = jeb(iAe, 'RadialOptions/RadialFactory', 986);
Ycb(351, 23, {
    3: 1,
    34: 1,
    23: 1,
    351: 1
}, o_c);
var i_c, j_c, k_c, l_c;
var A_ = keb(iAe, 'RadialTranslationStrategy', 351, MI, q_c, p_c);
var r_c;
Ycb(299, 23, {
    3: 1,
    34: 1,
    23: 1,
    299: 1
}, y_c);
var t_c, u_c, v_c;
var B_ = keb(iAe, 'SortingStrategy', 299, MI, A_c, z_c);
var B_c;
Ycb(1415, 1, gze, G_c);
_.pg = function H_c(a) {
    return JD(a, 27), null;
};
_.If = function I_c(a, b) {
    E_c(this, JD(a, 27), b);
};
_.c = 0;
var C_ = jeb('org.eclipse.elk.alg.radial.p1position', 'EadesRadial', 1415);
Ycb(1784, 1, {}, J_c);
_.Cg = function K_c(a) {
    return RYc(a);
};
var D_ = jeb(zAe, 'AnnulusWedgeByLeafs', 1784);
Ycb(1785, 1, {}, M_c);
_.Cg = function N_c(a) {
    return L_c(this, a);
};
var E_ = jeb(zAe, 'AnnulusWedgeByNodeSpace', 1785);
Ycb(1416, 1, gze, Q_c);
_.pg = function R_c(a) {
    return JD(a, 27), null;
};
_.If = function S_c(a, b) {
    O_c(this, JD(a, 27), b);
};
var F_ = jeb('org.eclipse.elk.alg.radial.p2routing', 'StraightLineEdgeRouter', 1416);
Ycb(805, 1, {}, U_c);
_.Dg = function V_c(a) {};
_.Eg = function X_c(a) {
    T_c(this, a);
};
var H_ = jeb(AAe, 'IDSorter', 805);
Ycb(1783, 1, Bte, Y_c);
_.Le = function Z_c(a, b) {
    return W_c(JD(a, 27), JD(b, 27));
};
_.Fb = function $_c(a) {
    return this === a;
};
_.Me = function __c() {
    return new uqb(this);
};
var G_ = jeb(AAe, 'IDSorter/lambda$0$Type', 1783);
Ycb(1782, 1, {}, c0c);
_.Dg = function d0c(a) {
    a0c(this, a);
};
_.Eg = function e0c(a) {
    var b;
    if (!a.dc()) {
        if (!this.e) {
            b = OYc(JD(a.Xb(0), 27));
            a0c(this, b);
        }
        T_c(this.e, a);
    }
};
var I_ = jeb(AAe, 'PolarCoordinateSorter', 1782);
Ycb(433, 23, {
    3: 1,
    34: 1,
    23: 1,
    433: 1
}, j0c);
var f0c, g0c, h0c;
var J_ = keb(EAe, 'RectPackingLayoutPhases', 433, MI, l0c, k0c);
var m0c;
Ycb(1082, 222, tue, o0c);
_.kf = function q0c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    b.Sg('Rectangle Packing', 1);
    l = JD(ksd(a, (k2c(), a2c)), 107);
    i = ydb(LD(ksd(a, U1c)));
    k = Beb(MD(ksd(a, d2c)));
    C = ydb(LD(ksd(a, e2c)));
    t = (!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a);
    ydb(LD(ksd(a, X1c))) || QDb((e = new RDb((Rod(), new dpd(a))), e));
    B = false;
    if (C && t.i >= 3) {
        v = JD(nDd(t, 0), 27);
        w = JD(nDd(t, 1), 27);
        f = 0;
        while(f + 2 < t.i){
            u = v;
            v = w;
            w = JD(nDd(t, f + 2), 27);
            if (u.f >= v.f + w.f + k || w.f >= u.f + v.f + k) {
                B = true;
                break;
            } else ++f;
        }
    } else B = true;
    if (!B) {
        m = t.i;
        for(h = new CHd(t); h.e != h.i.gc();){
            g = JD(AHd(h), 27);
            msd(g, (Lgd(), ggd), jfb(m));
            --m;
        }
        Mld(a, new wld);
        b.Tg();
        return;
    }
    c = (f9c(this.a), i9c(this.a, (i0c(), f0c), JD(ksd(a, i2c), 188)), i9c(this.a, g0c, JD(ksd(a, _1c), 188)), i9c(this.a, h0c, JD(ksd(a, f2c), 188)), c9c(this.a, (D = new J9c, E9c(D, f0c, (D0c(), B0c)), E9c(D, g0c, A0c), ydb(LD(ksd(a, Y1c))) && E9c(D, f0c, C0c), ydb(LD(ksd(a, P1c))) && E9c(D, f0c, z0c), D)), d9c(this.a, a));
    j = 1 / c.c.length;
    A = 0;
    for(o = new rmb(c); o.a < o.c.c.length;){
        n = JD(pmb(o), 44);
        if (b.Yg()) return;
        n.If(a, b.bh(j));
        ++A;
    }
    q = 0;
    p = 0;
    for(s = new CHd(t); s.e != s.i.gc();){
        r = JD(AHd(s), 27);
        q = $wnd.Math.max(q, r.i + r.g);
        p = $wnd.Math.max(p, r.j + r.f);
    }
    rnd(a, new Edd(Beb(MD(ksd(a, (h1c(), $0c)))), Beb(MD(ksd(a, Z0c)))), new Edd(q, p));
    p0c(t, l);
    i || mnd(a, Beb(MD(ksd(a, $0c))) + (l.b + l.c), Beb(MD(ksd(a, Z0c))) + (l.d + l.a), false, true);
    ydb(LD(ksd(a, X1c))) || QDb((d = new RDb((Rod(), new dpd(a))), d));
    b.Tg();
};
var K_ = jeb(EAe, 'RectPackingLayoutProvider', 1082);
Ycb(1458, 1, Dve, s0c);
_.If = function u0c(a, b) {
    r0c(JD(a, 27), b);
};
var M_ = jeb(FAe, 'InteractiveNodeReorderer', 1458);
Ycb(1459, 1, Bte, v0c);
_.Le = function w0c(a, b) {
    return t0c(JD(a, 27), JD(b, 27));
};
_.Fb = function x0c(a) {
    return this === a;
};
_.Me = function y0c() {
    return new uqb(this);
};
var L_ = jeb(FAe, 'InteractiveNodeReorderer/lambda$0$Type', 1459);
Ycb(398, 23, {
    3: 1,
    34: 1,
    23: 1,
    398: 1,
    196: 1
}, E0c);
_.bg = function F0c() {
    switch(this.g){
        case 0:
            return new W0c;
        case 1:
            return new s0c;
        case 2:
            return new O0c;
        case 3:
            return new L0c;
    }
    return null;
};
var z0c, A0c, B0c, C0c;
var N_ = keb(FAe, _ve, 398, MI, H0c, G0c);
var I0c;
Ycb(1461, 1, Dve, L0c);
_.If = function M0c(a, b) {
    K0c(JD(a, 27), b);
};
var O_ = jeb(FAe, 'MinSizePostProcessor', 1461);
Ycb(1460, 1, Dve, O0c);
_.If = function P0c(a, b) {
    N0c(JD(a, 27), b);
};
var P_ = jeb(FAe, 'MinSizePreProcessor', 1460);
Ycb(1647, 1, Bte, R0c);
_.Le = function S0c(a, b) {
    return Q0c(JD(a, 27), JD(b, 27));
};
_.Fb = function T0c(a) {
    return this === a;
};
_.Me = function U0c() {
    return new uqb(this);
};
var Q_ = jeb(FAe, 'NodeSizeComparator', 1647);
Ycb(1457, 1, Dve, W0c);
_.If = function X0c(a, b) {
    V0c(JD(a, 27));
};
var R_ = jeb(FAe, 'NodeSizeReorderer', 1457);
var Y0c, Z0c, $0c, _0c, a1c, b1c, c1c, d1c, e1c, f1c, g1c;
Ycb(385, 23, {
    3: 1,
    34: 1,
    23: 1,
    385: 1
}, m1c);
var i1c, j1c, k1c;
var S_ = keb(GAe, 'OptimizationGoal', 385, MI, o1c, n1c);
var p1c;
Ycb(844, 1, Hue, J1c);
_.tf = function K1c(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, HAe), ''), 'Try box layout first'), 'Whether one should check whether the regions are stackable to see whether box layout would do the job. For example, nodes with the same height are not stackable inside a row. Therefore, box layout will perform better and faster.'), (xdb(), false)), (zcd(), rcd)), GI), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, IAe), ''), 'Current position of a node in the order of nodes'), 'The rectangles are ordered. Normally according to their definition the the model. This option specifies the current position of a node.'), jfb(-1)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, JAe), ''), 'Desired index of node'), 'The rectangles are ordered. Normally according to their definition the the model. This option allows to specify a desired position that has preference over the original position.'), jfb(-1)), vcd), UI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, KAe), ''), 'In new Row'), 'If set to true this node begins in a new row. Consequently this node cannot be moved in a previous layer during compaction. Width approximation does does not take this into account.'), false), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, LAe), ''), 'Order nodes by height'), 'If set to true the nodes will be sorted by their height before computing the layout. The highest node will be in the first position.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, MAe), UAe), 'Width Approximation Strategy'), 'Strategy for finding an initial width of the drawing.'), G1c), tcd), b0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, NAe), UAe), 'Target Width'), 'Option to place the rectangles in the given target width instead of approximating the width using the desired aspect ratio. The padding is not included in this. Meaning a drawing will have width of targetwidth + horizontal padding.'), -1), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, OAe), UAe), 'Optimization Goal'), 'Optimization goal for approximation of the bounding box given by the first iteration. Determines whether layout is sorted by the maximum scaling, aspect ratio, or area. Depending on the strategy the aspect ratio might be nearly ignored.'), E1c), tcd), S_), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, PAe), UAe), 'Shift Last Placed.'), 'When placing a rectangle behind or below the last placed rectangle in the first iteration, it is sometimes possible to shift the rectangle further to the left or right, resulting in less whitespace. True (default) enables the shift and false disables it. Disabling the shift produces a greater approximated area by the first iteration and a layout, when using ONLY the first iteration (default not the case), where it is sometimes impossible to implement a size transformation of rectangles that will fill the bounding box and eliminate empty spaces.'), true), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, QAe), 'packing'), VAe), 'Strategy for finding an initial placement on nodes.'), y1c), tcd), e0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, RAe), WAe), 'Row Height Reevaluation'), 'During the compaction step the height of a row is normally not changed. If this options is set, the blocks of other rows might be added if they exceed the row height. If this is the case the whole row has to be packed again to be optimal regarding the new row height. This option should, therefore, be used with care since it might be computation heavy.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, SAe), WAe), 'Compaction iterations'), 'Defines the number of compaction iterations. E.g. if set to 2 the width is initially approximated, then the drawing is compacted and based on the resulting drawing the target width is decreased or increased and a second compaction step is executed and the result compared to the first one. The best run is used based on the scale measure.'), jfb(1)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, TAe), 'whiteSpaceElimination'), 'White Space Approximation Strategy'), 'Strategy for expanding nodes such that whitespace in the parent is eliminated.'), B1c), tcd), j0), mrb(jcd))));
    l2c((new m2c, a));
};
var r1c, s1c, t1c, u1c, v1c, w1c, x1c, y1c, z1c, A1c, B1c, C1c, D1c, E1c, F1c, G1c, H1c;
var T_ = jeb(GAe, 'RectPackingMetaDataProvider', 844);
Ycb(991, 1, Hue, m2c);
_.tf = function n2c(a) {
    l2c(a);
};
var L1c, M1c, N1c, O1c, P1c, Q1c, R1c, S1c, T1c, U1c, V1c, W1c, X1c, Y1c, Z1c, $1c, _1c, a2c, b2c, c2c, d2c, e2c, f2c, g2c, h2c, i2c, j2c;
var V_ = jeb(GAe, 'RectPackingOptions', 991);
Ycb(992, 1, {}, o2c);
_.uf = function p2c() {
    var a;
    return a = new o0c, a;
};
_.vf = function q2c(a) {};
var U_ = jeb(GAe, 'RectPackingOptions/RectpackingFactory', 992);
Ycb(1646, 1, {}, v2c);
_.a = 0;
_.c = false;
var W_ = jeb(YAe, 'AreaApproximation', 1646);
var Z_ = leb(YAe, 'BestCandidateFilter');
Ycb(658, 1, {
    520: 1
}, w2c);
_.Fg = function x2c(a, b, c) {
    var d, e, f, g, h, i;
    i = new Ulb;
    f = Kse;
    for(h = new rmb(a); h.a < h.c.c.length;){
        g = JD(pmb(h), 237);
        f = $wnd.Math.min(f, (g.c + (c.b + c.c)) * (g.b + (c.d + c.a)));
    }
    for(e = new rmb(a); e.a < e.c.c.length;){
        d = JD(pmb(e), 237);
        (d.c + (c.b + c.c)) * (d.b + (c.d + c.a)) == f && YCb(i.c, d);
    }
    return i;
};
var X_ = jeb(YAe, 'AreaFilter', 658);
Ycb(659, 1, {
    520: 1
}, y2c);
_.Fg = function z2c(a, b, c) {
    var d, e, f, g, h, i;
    h = new Ulb;
    i = Kse;
    for(g = new rmb(a); g.a < g.c.c.length;){
        f = JD(pmb(g), 237);
        i = $wnd.Math.min(i, $wnd.Math.abs((f.c + (c.b + c.c)) / (f.b + (c.d + c.a)) - b));
    }
    for(e = new rmb(a); e.a < e.c.c.length;){
        d = JD(pmb(e), 237);
        $wnd.Math.abs((d.c + (c.b + c.c)) / (d.b + (c.d + c.a)) - b) == i && YCb(h.c, d);
    }
    return h;
};
var Y_ = jeb(YAe, 'AspectRatioFilter', 659);
Ycb(1408, 1, gze, D2c);
_.pg = function E2c(a) {
    return JD(a, 27), null;
};
_.If = function F2c(a, b) {
    C2c(JD(a, 27), b);
};
var $_ = jeb(YAe, 'GreedyWidthApproximator', 1408);
Ycb(657, 1, {
    520: 1
}, G2c);
_.Fg = function H2c(a, b, c) {
    var d, e, f, g, h, i;
    i = new Ulb;
    f = Lse;
    for(h = new rmb(a); h.a < h.c.c.length;){
        g = JD(pmb(h), 237);
        f = $wnd.Math.max(f, Q4c(g.c + (c.b + c.c), g.b + (c.d + c.a), g.a));
    }
    for(e = new rmb(a); e.a < e.c.c.length;){
        d = JD(pmb(e), 237);
        Q4c(d.c + (c.b + c.c), d.b + (c.d + c.a), d.a) == f && YCb(i.c, d);
    }
    return i;
};
var __ = jeb(YAe, 'ScaleMeasureFilter', 657);
Ycb(1409, 1, gze, J2c);
_.pg = function K2c(a) {
    return JD(a, 27), null;
};
_.If = function L2c(a, b) {
    I2c(JD(a, 27), b);
};
var a0 = jeb(YAe, 'TargetWidthWidthApproximator', 1409);
Ycb(476, 23, {
    3: 1,
    34: 1,
    23: 1,
    476: 1,
    188: 1,
    196: 1
}, Q2c);
_.bg = function S2c() {
    return P2c(this);
};
_.og = function R2c() {
    return P2c(this);
};
var M2c, N2c;
var b0 = keb(YAe, 'WidthApproximationStrategy', 476, MI, U2c, T2c);
var V2c;
Ycb(1410, 1, gze, e3c);
_.pg = function f3c(a) {
    return JD(a, 27), null;
};
_.If = function g3c(a, b) {
    d3c(this, JD(a, 27), b);
};
var c0 = jeb(ZAe, 'Compactor', 1410);
Ycb(1412, 1, gze, k3c);
_.pg = function l3c(a) {
    return JD(a, 27), null;
};
_.If = function m3c(a, b) {
    j3c(JD(a, 27), b);
};
var d0 = jeb(ZAe, 'NoPlacement', 1412);
Ycb(426, 23, {
    3: 1,
    34: 1,
    23: 1,
    426: 1,
    188: 1,
    196: 1
}, s3c);
_.bg = function u3c() {
    return r3c(this);
};
_.og = function t3c() {
    return r3c(this);
};
var n3c, o3c, p3c;
var e0 = keb(ZAe, 'PackingStrategy', 426, MI, w3c, v3c);
var x3c;
Ycb(790, 1, {}, B3c);
_.a = 0;
_.b = 0;
_.c = 0;
_.d = Kse;
_.e = 0;
_.f = Kse;
var f0 = jeb(ZAe, 'RowFillingAndCompaction', 790);
Ycb(1411, 1, gze, D3c);
_.pg = function E3c(a) {
    return JD(a, 27), null;
};
_.If = function F3c(a, b) {
    C3c(JD(a, 27), b);
};
var g0 = jeb(ZAe, 'SimplePlacement', 1411);
Ycb(1413, 1, gze, H3c);
_.pg = function I3c(a) {
    return JD(a, 27), null;
};
_.If = function J3c(a, b) {
    this.Gg(JD(a, 27), b);
};
_.Gg = function K3c(a, b) {
    G3c(a, b);
};
var h0 = jeb(_Ae, 'EqualWhitespaceEliminator', 1413);
Ycb(1414, 1413, gze, M3c);
_.Gg = function N3c(a, b) {
    var c, d, e, f, g;
    b.Sg('To Aspect Ratio Whitesapce Eliminator', 1);
    g = Beb(MD(ksd(a, (h1c(), $0c))));
    f = Beb(MD(ksd(a, Z0c)));
    e = Beb(MD(ksd(a, (k2c(), L1c))));
    c = Beb(MD(ksd(a, Y0c)));
    d = g / f;
    if (d < e) {
        g = f * e;
        msd(a, $0c, g);
    } else {
        c += g / e - f;
        msd(a, Y0c, c);
        msd(a, Z0c, f + c);
    }
    G3c(a, b);
    b.Tg();
};
var i0 = jeb(_Ae, 'ToAspectratioNodeExpander', 1414);
Ycb(427, 23, {
    3: 1,
    34: 1,
    23: 1,
    427: 1,
    188: 1,
    196: 1
}, T3c);
_.bg = function V3c() {
    return S3c(this);
};
_.og = function U3c() {
    return S3c(this);
};
var O3c, P3c, Q3c;
var j0 = keb(_Ae, 'WhiteSpaceEliminationStrategy', 427, MI, X3c, W3c);
var Y3c;
Ycb(172, 1, {
    172: 1
}, j4c);
_.a = 0;
_.c = false;
_.d = 0;
_.e = 0;
_.f = 0;
_.g = 0;
_.i = 0;
_.k = false;
_.o = Kse;
_.p = Kse;
_.r = 0;
_.s = 0;
_.t = 0;
var m0 = jeb(aBe, 'Block', 172);
Ycb(208, 1, {
    208: 1
}, p4c);
_.a = 0;
_.b = 0;
_.d = 0;
_.e = 0;
_.f = 0;
var k0 = jeb(aBe, 'BlockRow', 208);
Ycb(316, 1, {
    316: 1
}, x4c);
_.b = 0;
_.c = 0;
_.d = 0;
_.e = 0;
_.f = 0;
var l0 = jeb(aBe, 'BlockStack', 316);
Ycb(237, 1, {
    237: 1
}, B4c, C4c);
_.a = 0;
_.b = 0;
_.c = 0;
_.d = 0;
_.e = 0;
_.g = 0;
var o0 = jeb(aBe, 'DrawingData', 237);
Ycb(366, 23, {
    3: 1,
    34: 1,
    23: 1,
    366: 1
}, J4c);
var D4c, E4c, F4c, G4c, H4c;
var n0 = keb(aBe, 'DrawingDataDescriptor', 366, MI, L4c, K4c);
var M4c;
Ycb(186, 1, {
    186: 1
}, X4c);
_.b = 0;
_.c = 0;
_.e = 0;
_.f = 0;
var p0 = jeb(aBe, 'RectRow', 186);
Ycb(745, 1, {}, d5c);
_.j = 0;
var v0 = jeb(cBe, Sve, 745);
Ycb(1169, 1, {}, e5c);
_.$e = function f5c(a) {
    return pdd(a.a, a.b);
};
var q0 = jeb(cBe, sue, 1169);
Ycb(1170, 1, {}, g5c);
_.$e = function h5c(a) {
    return $4c(this.a, a);
};
var r0 = jeb(cBe, Tve, 1170);
Ycb(1171, 1, {}, i5c);
_.$e = function j5c(a) {
    return _4c(this.a, a);
};
var s0 = jeb(cBe, Uve, 1171);
Ycb(1172, 1, {}, k5c);
_.$e = function l5c(a) {
    return a5c(this.a, a);
};
var t0 = jeb(cBe, 'ElkGraphImporter/lambda$3$Type', 1172);
Ycb(1173, 1, {}, m5c);
_.$e = function n5c(a) {
    return b5c(this.a, a);
};
var u0 = jeb(cBe, Vve, 1173);
Ycb(1079, 222, tue, o5c);
_.kf = function q5c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    if (lsd(a, (D6c(), C6c))) {
        n = OD(ksd(a, (h7c(), g7c)));
        f = Had(Nad(), n);
        if (f) {
            g = JD(Vnd(f.f), 222);
            g.kf(a, b.bh(1));
        }
    }
    msd(a, x6c, (a6c(), $5c));
    msd(a, y6c, (l6c(), i6c));
    msd(a, z6c, (A7c(), z7c));
    h = JD(ksd(a, (h7c(), c7c)), 17).a;
    b.Sg('Overlap removal', 1);
    ydb(LD(ksd(a, b7c)));
    i = new Qrb;
    j = new s5c(i);
    d = new d5c;
    c = Z4c(d, a);
    k = true;
    e = 0;
    while(e < h && k){
        if (ydb(LD(ksd(a, d7c)))) {
            i.a.$b();
            dMb(new eMb(j), c.i);
            if (i.a.gc() == 0) break;
            c.e = i;
        }
        f9c(this.b);
        i9c(this.b, (w5c(), t5c), (p7c(), o7c));
        i9c(this.b, u5c, c.g);
        i9c(this.b, v5c, (S5c(), R5c));
        this.a = d9c(this.b, c);
        for(m = new rmb(this.a); m.a < m.c.c.length;){
            l = JD(pmb(m), 44);
            l.If(c, b.bh(1));
        }
        c5c(d, c);
        k = ydb(LD(WMb(c, (YLb(), XLb))));
        ++e;
    }
    Y4c(d, c);
    b.Tg();
};
var x0 = jeb(cBe, 'OverlapRemovalLayoutProvider', 1079);
Ycb(1080, 1, {}, s5c);
var w0 = jeb(cBe, 'OverlapRemovalLayoutProvider/lambda$0$Type', 1080);
Ycb(432, 23, {
    3: 1,
    34: 1,
    23: 1,
    432: 1
}, x5c);
var t5c, u5c, v5c;
var y0 = keb(cBe, 'SPOrEPhases', 432, MI, z5c, y5c);
var A5c;
Ycb(1179, 1, {}, D5c);
var A0 = jeb(cBe, 'ShrinkTree', 1179);
Ycb(1081, 222, tue, E5c);
_.kf = function F5c(a, b) {
    var c, d, e, f, g;
    if (lsd(a, (D6c(), C6c))) {
        g = OD(ksd(a, C6c));
        e = Had(Nad(), g);
        if (e) {
            f = JD(Vnd(e.f), 222);
            f.kf(a, b.bh(1));
        }
    }
    d = new d5c;
    c = Z4c(d, a);
    C5c(this.a, c, b.bh(1));
    Y4c(d, c);
};
var z0 = jeb(cBe, 'ShrinkTreeLayoutProvider', 1081);
Ycb(307, 148, {
    3: 1,
    307: 1,
    102: 1,
    148: 1
}, G5c);
_.c = false;
var B0 = jeb('org.eclipse.elk.alg.spore.graph', 'Graph', 307);
Ycb(475, 23, {
    3: 1,
    34: 1,
    23: 1,
    475: 1,
    188: 1,
    196: 1
}, K5c);
_.bg = function M5c() {
    return J5c(this);
};
_.og = function L5c() {
    return J5c(this);
};
var H5c;
var C0 = keb(dBe, jAe, 475, MI, O5c, N5c);
var P5c;
Ycb(543, 23, {
    3: 1,
    34: 1,
    23: 1,
    543: 1,
    188: 1,
    196: 1
}, T5c);
_.bg = function V5c() {
    return new g8c;
};
_.og = function U5c() {
    return new g8c;
};
var R5c;
var D0 = keb(dBe, 'OverlapRemovalStrategy', 543, MI, X5c, W5c);
var Y5c;
Ycb(425, 23, {
    3: 1,
    34: 1,
    23: 1,
    425: 1
}, b6c);
var $5c, _5c;
var E0 = keb(dBe, 'RootSelection', 425, MI, d6c, c6c);
var e6c;
Ycb(325, 23, {
    3: 1,
    34: 1,
    23: 1,
    325: 1
}, m6c);
var g6c, h6c, i6c, j6c, k6c;
var F0 = keb(dBe, 'SpanningTreeCostFunction', 325, MI, o6c, n6c);
var p6c;
Ycb(989, 1, Hue, F6c);
_.tf = function G6c(a) {
    E6c(a);
};
var r6c, s6c, t6c, u6c, v6c, w6c, x6c, y6c, z6c, A6c, B6c, C6c;
var H0 = jeb(dBe, 'SporeCompactionOptions', 989);
Ycb(990, 1, {}, H6c);
_.uf = function I6c() {
    var a;
    return a = new E5c, a;
};
_.vf = function J6c(a) {};
var G0 = jeb(dBe, 'SporeCompactionOptions/SporeCompactionFactory', 990);
Ycb(843, 1, Hue, _6c);
_.tf = function a7c(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, fBe), ''), 'Underlying Layout Algorithm'), 'A layout algorithm that is applied to the graph before it is compacted. If this is null, nothing is applied before compaction.'), (zcd(), xcd)), hJ), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, kBe), 'structure'), 'Structure Extraction Strategy'), 'This option defines what kind of triangulation or other partitioning of the plane is applied to the vertices.'), Y6c), tcd), L0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, gBe), pBe), 'Tree Construction Strategy'), 'Whether a minimum spanning tree or a maximum spanning tree should be constructed.'), W6c), tcd), M0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, hBe), pBe), 'Cost Function for Spanning Tree'), 'The cost function is used in the creation of the spanning tree.'), U6c), tcd), F0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, iBe), pBe), 'Root node for spanning tree construction'), 'The identifier of the node that is preferred as the root of the spanning tree. If this is null, the first node is chosen.'), null), xcd), hJ), mrb(jcd))));
    Oad(a, iBe, jBe, Q6c);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, jBe), pBe), 'Root selection for spanning tree'), 'This sets the method used to select a root node for the construction of a spanning tree'), S6c), tcd), E0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, lBe), dye), VAe), 'This option defines how the compaction is applied.'), L6c), tcd), C0), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, mBe), dye), 'Orthogonal Compaction'), 'Restricts the translation of nodes to orthogonal directions in the compaction phase.'), (xdb(), false)), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, nBe), qBe), 'Upper limit for iterations of overlap removal'), null), jfb(64)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, oBe), qBe), 'Whether to run a supplementary scanline overlap check.'), null), true), rcd), GI), mrb(jcd))));
    i7c((new j7c, a));
    E6c((new F6c, a));
};
var K6c, L6c, M6c, N6c, O6c, P6c, Q6c, R6c, S6c, T6c, U6c, V6c, W6c, X6c, Y6c, Z6c;
var I0 = jeb(dBe, 'SporeMetaDataProvider', 843);
Ycb(987, 1, Hue, j7c);
_.tf = function k7c(a) {
    i7c(a);
};
var b7c, c7c, d7c, e7c, f7c, g7c;
var K0 = jeb(dBe, 'SporeOverlapRemovalOptions', 987);
Ycb(988, 1, {}, l7c);
_.uf = function m7c() {
    var a;
    return a = new o5c, a;
};
_.vf = function n7c(a) {};
var J0 = jeb(dBe, 'SporeOverlapRemovalOptions/SporeOverlapFactory', 988);
Ycb(524, 23, {
    3: 1,
    34: 1,
    23: 1,
    524: 1,
    188: 1,
    196: 1
}, r7c);
_.bg = function t7c() {
    return q7c(this);
};
_.og = function s7c() {
    return q7c(this);
};
var o7c;
var L0 = keb(dBe, 'StructureExtractionStrategy', 524, MI, v7c, u7c);
var w7c;
Ycb(424, 23, {
    3: 1,
    34: 1,
    23: 1,
    424: 1,
    188: 1,
    196: 1
}, C7c);
_.bg = function E7c() {
    return B7c(this);
};
_.og = function D7c() {
    return B7c(this);
};
var y7c, z7c;
var M0 = keb(dBe, 'TreeConstructionStrategy', 424, MI, G7c, F7c);
var H7c;
Ycb(1402, 1, gze, K7c);
_.pg = function L7c(a) {
    return JD(a, 307), new J9c;
};
_.If = function M7c(a, b) {
    J7c(JD(a, 307), b);
};
var O0 = jeb(sBe, 'DelaunayTriangulationPhase', 1402);
Ycb(1403, 1, kre, N7c);
_.Ad = function O7c(a) {
    Ilb(this.a, JD(a, 68).a);
};
var N0 = jeb(sBe, 'DelaunayTriangulationPhase/lambda$0$Type', 1403);
Ycb(774, 1, gze, S7c);
_.pg = function T7c(a) {
    return JD(a, 307), new J9c;
};
_.If = function U7c(a, b) {
    this.Hg(JD(a, 307), b);
};
_.Hg = function V7c(a, b) {
    var c, d, e;
    b.Sg('Minimum spanning tree construction', 1);
    a.d ? d = a.d.a : d = JD(Mlb(a.i, 0), 68).a;
    ydb(LD(WMb(a, (YLb(), WLb)))) ? e = KDb(a.e, d, (c = a.b, c)) : e = KDb(a.e, d, a.b);
    Q7c(this, e, a);
    b.Tg();
};
var S0 = jeb(tBe, 'MinSTPhase', 774);
Ycb(1405, 774, gze, W7c);
_.Hg = function Y7c(a, b) {
    var c, d, e, f;
    b.Sg('Maximum spanning tree construction', 1);
    c = new Z7c(a);
    a.d ? e = a.d.c : e = JD(Mlb(a.i, 0), 68).c;
    ydb(LD(WMb(a, (YLb(), WLb)))) ? f = KDb(a.e, e, (d = c, d)) : f = KDb(a.e, e, c);
    Q7c(this, f, a);
    b.Tg();
};
var Q0 = jeb(tBe, 'MaxSTPhase', 1405);
Ycb(1406, 1, {}, Z7c);
_.$e = function $7c(a) {
    return X7c(this.a, a);
};
var P0 = jeb(tBe, 'MaxSTPhase/lambda$0$Type', 1406);
Ycb(1404, 1, kre, _7c);
_.Ad = function a8c(a) {
    R7c(this.a, JD(a, 68));
};
var R0 = jeb(tBe, 'MinSTPhase/lambda$0$Type', 1404);
Ycb(776, 1, gze, g8c);
_.pg = function h8c(a) {
    return JD(a, 307), new J9c;
};
_.If = function i8c(a, b) {
    f8c(this, JD(a, 307), b);
};
_.a = false;
var U0 = jeb(uBe, 'GrowTreePhase', 776);
Ycb(777, 1, kre, j8c);
_.Ad = function k8c(a) {
    e8c(this.a, this.b, this.c, JD(a, 224));
};
var T0 = jeb(uBe, 'GrowTreePhase/lambda$0$Type', 777);
Ycb(1407, 1, gze, o8c);
_.pg = function p8c(a) {
    return JD(a, 307), new J9c;
};
_.If = function q8c(a, b) {
    n8c(this, JD(a, 307), b);
};
var W0 = jeb(uBe, 'ShrinkTreeCompactionPhase', 1407);
Ycb(775, 1, kre, r8c);
_.Ad = function s8c(a) {
    m8c(this.a, this.b, this.c, JD(a, 224));
};
var V0 = jeb(uBe, 'ShrinkTreeCompactionPhase/lambda$0$Type', 775);
var b3 = leb(cze, 'IGraphElementVisitor');
Ycb(848, 1, {
    521: 1
}, B8c);
_.Ig = function E8c(a) {
    var b;
    b = A8c(this, a);
    UMb(b, JD(Nib(this.b, a), 102));
    y8c(this, a, b);
};
var t8c, u8c, v8c;
var b1 = jeb(uue, 'LayoutConfigurator', 848);
var Y0 = leb(uue, 'LayoutConfigurator/IPropertyHolderOptionFilter');
Ycb(922, 1, {
    1978: 1
}, F8c);
_.Jg = function G8c(a, b) {
    return w8c(), !a.nf(b);
};
var Z0 = jeb(uue, 'LayoutConfigurator/lambda$0$Type', 922);
Ycb(923, 1, {
    1978: 1
}, I8c);
_.Jg = function J8c(a, b) {
    return H8c(a, b);
};
var $0 = jeb(uue, 'LayoutConfigurator/lambda$1$Type', 923);
Ycb(921, 1, {
    824: 1
}, K8c);
_.Kg = function L8c(a, b) {
    return w8c(), !a.nf(b);
};
var _0 = jeb(uue, 'LayoutConfigurator/lambda$2$Type', 921);
Ycb(924, 1, Ire, M8c);
_.Mb = function N8c(a) {
    return D8c(this.a, this.b, JD(a, 1978));
};
var a1 = jeb(uue, 'LayoutConfigurator/lambda$3$Type', 924);
Ycb(846, 1, {}, W8c);
var c1 = jeb(uue, 'RecursiveGraphLayoutEngine', 846);
Ycb(223, 63, Nre, X8c, Y8c);
var d1 = jeb(uue, 'UnsupportedConfigurationException', 223);
Ycb(363, 63, Nre, Z8c);
var e1 = jeb(uue, 'UnsupportedGraphException', 363);
Ycb(744, 1, {});
var F2 = jeb(cze, 'AbstractRandomListAccessor', 744);
Ycb(438, 744, {}, j9c);
_.Lg = function l9c() {
    return null;
};
_.d = true;
_.e = true;
_.f = 0;
var k1 = jeb(xBe, 'AlgorithmAssembler', 438);
Ycb(1164, 1, Ire, m9c);
_.Mb = function n9c(a) {
    return !!JD(a, 106);
};
var f1 = jeb(xBe, 'AlgorithmAssembler/lambda$0$Type', 1164);
Ycb(1165, 1, {}, o9c);
_.Kb = function p9c(a) {
    return k9c(this.a, JD(a, 106));
};
var g1 = jeb(xBe, 'AlgorithmAssembler/lambda$1$Type', 1165);
Ycb(1166, 1, Ire, q9c);
_.Mb = function r9c(a) {
    return !!JD(a, 78);
};
var h1 = jeb(xBe, 'AlgorithmAssembler/lambda$2$Type', 1166);
Ycb(1167, 1, kre, s9c);
_.Ad = function t9c(a) {
    D9c(this.a, JD(a, 78));
};
var i1 = jeb(xBe, 'AlgorithmAssembler/lambda$3$Type', 1167);
Ycb(1168, 1, kre, u9c);
_.Ad = function v9c(a) {
    e9c(this.a, this.b, JD(a, 196));
};
var j1 = jeb(xBe, 'AlgorithmAssembler/lambda$4$Type', 1168);
Ycb(1284, 1, Bte, x9c);
_.Le = function y9c(a, b) {
    return w9c(JD(a, 196), JD(b, 196));
};
_.Fb = function z9c(a) {
    return this === a;
};
_.Me = function A9c() {
    return new uqb(this);
};
var l1 = jeb(xBe, 'EnumBasedFactoryComparator', 1284);
Ycb(78, 744, {
    78: 1
}, J9c);
_.Lg = function L9c() {
    return new Qrb;
};
_.a = 0;
var m1 = jeb(xBe, 'LayoutProcessorConfiguration', 78);
Ycb(Vre, 1, {
    521: 1
}, Q9c);
_.Ig = function U9c(a) {
    pub(N9c, new Z9c(a));
};
var M9c, N9c, O9c;
var q1 = jeb(Aue, 'DeprecatedLayoutOptionReplacer', Vre);
Ycb(1001, 1, kre, V9c);
_.Ad = function W9c(a) {
    R9c(JD(a, 173));
};
var n1 = jeb(Aue, 'DeprecatedLayoutOptionReplacer/lambda$0$Type', 1001);
Ycb(1002, 1, kre, X9c);
_.Ad = function Y9c(a) {
    S9c(JD(a, 173));
};
var o1 = jeb(Aue, 'DeprecatedLayoutOptionReplacer/lambda$1$Type', 1002);
Ycb(1003, 1, {}, Z9c);
_.Wd = function $9c(a, b) {
    T9c(this.a, JD(a, 144), JD(b, 40));
};
var p1 = jeb(Aue, 'DeprecatedLayoutOptionReplacer/lambda$2$Type', 1003);
Ycb(149, 1, {
    685: 1,
    149: 1
}, cad);
_.Fb = function dad(a) {
    return aad(this, a);
};
_.Mg = function ead() {
    return this.b;
};
_.Ng = function fad() {
    return this.c;
};
_.ve = function gad() {
    return this.e;
};
_.Hb = function had() {
    return fgb(this.c);
};
_.Ib = function iad() {
    return 'Layout Algorithm: ' + this.c;
};
var t1 = jeb(Aue, 'LayoutAlgorithmData', 149);
Ycb(285, 1, {}, pad);
var s1 = jeb(Aue, 'LayoutAlgorithmData/Builder', 285);
Ycb(1004, 1, {
    521: 1
}, sad);
_.Ig = function tad(a) {
    RD(a, 206) && !ydb(LD(a.mf((Lgd(), Ifd)))) && qad(JD(a, 27));
};
var u1 = jeb(Aue, 'LayoutAlgorithmResolver', 1004);
Ycb(232, 1, {
    685: 1,
    232: 1
}, uad);
_.Fb = function vad(a) {
    if (RD(a, 232)) return cgb(this.b, JD(a, 232).b);
    return false;
};
_.Mg = function wad() {
    return this.a;
};
_.Ng = function xad() {
    return this.b;
};
_.ve = function yad() {
    return this.d;
};
_.Hb = function zad() {
    return fgb(this.b);
};
_.Ib = function Aad() {
    return 'Layout Type: ' + this.b;
};
var w1 = jeb(Aue, 'LayoutCategoryData', 232);
Ycb(354, 1, {}, Ead);
var v1 = jeb(Aue, 'LayoutCategoryData/Builder', 354);
Ycb(855, 1, {}, Mad);
var Fad;
var T1 = jeb(Aue, 'LayoutMetaDataService', 855);
Ycb(856, 1, {}, Vad);
var y1 = jeb(Aue, 'LayoutMetaDataService/Registry', 856);
Ycb(473, 1, {
    473: 1
}, Wad);
var x1 = jeb(Aue, 'LayoutMetaDataService/Registry/Triple', 473);
Ycb(857, 1, yBe, Xad);
_.Og = function Yad() {
    return new Cdd;
};
var z1 = jeb(Aue, 'LayoutMetaDataService/lambda$0$Type', 857);
Ycb(858, 1, zBe, Zad);
_.Pg = function $ad(a) {
    return odd(JD(a, 8));
};
var A1 = jeb(Aue, 'LayoutMetaDataService/lambda$1$Type', 858);
Ycb(867, 1, yBe, _ad);
_.Og = function abd() {
    return new Ulb;
};
var B1 = jeb(Aue, 'LayoutMetaDataService/lambda$10$Type', 867);
Ycb(868, 1, zBe, bbd);
_.Pg = function cbd(a) {
    return new Wlb(JD(a, 13));
};
var C1 = jeb(Aue, 'LayoutMetaDataService/lambda$11$Type', 868);
Ycb(869, 1, yBe, dbd);
_.Og = function ebd() {
    return new Mtb;
};
var D1 = jeb(Aue, 'LayoutMetaDataService/lambda$12$Type', 869);
Ycb(870, 1, zBe, fbd);
_.Pg = function gbd(a) {
    return cv(JD(a, 67));
};
var E1 = jeb(Aue, 'LayoutMetaDataService/lambda$13$Type', 870);
Ycb(871, 1, yBe, hbd);
_.Og = function ibd() {
    return new Qrb;
};
var F1 = jeb(Aue, 'LayoutMetaDataService/lambda$14$Type', 871);
Ycb(872, 1, zBe, jbd);
_.Pg = function kbd(a) {
    return Qx(JD(a, 50));
};
var G1 = jeb(Aue, 'LayoutMetaDataService/lambda$15$Type', 872);
Ycb(873, 1, yBe, lbd);
_.Og = function mbd() {
    return new wtb;
};
var H1 = jeb(Aue, 'LayoutMetaDataService/lambda$16$Type', 873);
Ycb(874, 1, zBe, nbd);
_.Pg = function obd(a) {
    return Tx(JD(a, 50));
};
var I1 = jeb(Aue, 'LayoutMetaDataService/lambda$17$Type', 874);
Ycb(875, 1, yBe, pbd);
_.Og = function qbd() {
    return new lzb;
};
var J1 = jeb(Aue, 'LayoutMetaDataService/lambda$18$Type', 875);
Ycb(876, 1, zBe, rbd);
_.Pg = function sbd(a) {
    return Ux(JD(a, 156));
};
var K1 = jeb(Aue, 'LayoutMetaDataService/lambda$19$Type', 876);
Ycb(859, 1, yBe, tbd);
_.Og = function ubd() {
    return new Rdd;
};
var L1 = jeb(Aue, 'LayoutMetaDataService/lambda$2$Type', 859);
Ycb(860, 1, zBe, vbd);
_.Pg = function wbd(a) {
    return new Sdd(JD(a, 77));
};
var M1 = jeb(Aue, 'LayoutMetaDataService/lambda$3$Type', 860);
Ycb(861, 1, yBe, xbd);
_.Og = function ybd() {
    return new ZXb;
};
var N1 = jeb(Aue, 'LayoutMetaDataService/lambda$4$Type', 861);
Ycb(862, 1, zBe, zbd);
_.Pg = function Abd(a) {
    return new aYb(JD(a, 139));
};
var O1 = jeb(Aue, 'LayoutMetaDataService/lambda$5$Type', 862);
Ycb(863, 1, yBe, Bbd);
_.Og = function Cbd() {
    return new LYb;
};
var P1 = jeb(Aue, 'LayoutMetaDataService/lambda$6$Type', 863);
Ycb(864, 1, zBe, Dbd);
_.Pg = function Ebd(a) {
    return new NYb(JD(a, 107));
};
var Q1 = jeb(Aue, 'LayoutMetaDataService/lambda$7$Type', 864);
Ycb(865, 1, yBe, Fbd);
_.Og = function Gbd() {
    return new Nnd;
};
var R1 = jeb(Aue, 'LayoutMetaDataService/lambda$8$Type', 865);
Ycb(866, 1, zBe, Hbd);
_.Pg = function Ibd(a) {
    return new Ond(JD(a, 377));
};
var S1 = jeb(Aue, 'LayoutMetaDataService/lambda$9$Type', 866);
var N4 = leb(vue, 'IProperty');
Ycb(21, 1, {
    34: 1,
    685: 1,
    21: 1,
    144: 1
}, Pbd);
_.Dd = function Qbd(a) {
    return Kbd(this, JD(a, 144));
};
_.Fb = function Rbd(a) {
    return RD(a, 21) ? cgb(this.f, JD(a, 21).f) : RD(a, 144) && cgb(this.f, JD(a, 144).Ng());
};
_.Qg = function Sbd() {
    var a;
    if (RD(this.b, 4)) {
        a = cEd(this.b);
        if (a == null) throw scb(new Web(EBe + this.f + "'. " + "Make sure it's type is registered with the " + (ceb(V4), V4.k) + BBe));
        return a;
    } else return this.b;
};
_.Mg = function Tbd() {
    return this.d;
};
_.Ng = function Ubd() {
    return this.f;
};
_.ve = function Vbd() {
    return this.i;
};
_.Hb = function Wbd() {
    return fgb(this.f);
};
_.Ib = function Xbd() {
    return 'Layout Option: ' + this.f;
};
var X1 = jeb(Aue, 'LayoutOptionData', 21);
Ycb(24, 1, {}, fcd);
var U1 = jeb(Aue, 'LayoutOptionData/Builder', 24);
Ycb(170, 23, {
    3: 1,
    34: 1,
    23: 1,
    170: 1
}, mcd);
var gcd, hcd, icd, jcd, kcd;
var V1 = keb(Aue, 'LayoutOptionData/Target', 170, MI, ocd, ncd);
var pcd;
Ycb(282, 23, {
    3: 1,
    34: 1,
    23: 1,
    282: 1
}, Acd);
var rcd, scd, tcd, ucd, vcd, wcd, xcd, ycd;
var W1 = keb(Aue, 'LayoutOptionData/Type', 282, MI, Ccd, Bcd);
var Dcd;
var Fcd;
var Hcd;
Ycb(119, 1, {
    119: 1
}, fdd, gdd, hdd);
_.Fb = function idd(a) {
    var b;
    if (a == null || !RD(a, 119)) return false;
    b = JD(a, 119);
    return tub(this.c, b.c) && tub(this.d, b.d) && tub(this.b, b.b) && tub(this.a, b.a);
};
_.Hb = function jdd() {
    return Kmb(WC(OC(aJ, 1), Nqe, 1, 5, [
        this.c,
        this.d,
        this.b,
        this.a
    ]));
};
_.Ib = function kdd() {
    return 'Rect[x=' + this.c + ',y=' + this.d + ',w=' + this.b + ',h=' + this.a + ']';
};
_.a = 0;
_.b = 0;
_.c = 0;
_.d = 0;
var _1 = jeb(Ove, 'ElkRectangle', 119);
Ycb(8, 1, {
    3: 1,
    4: 1,
    8: 1,
    411: 1
}, Cdd, Ddd, Edd, Fdd);
_.Fb = function Gdd(a) {
    return rdd(this, a);
};
_.Hb = function Hdd() {
    return Eeb(this.a) + gfb(Eeb(this.b));
};
_.ag = function Jdd(b) {
    var c, d, e, f;
    e = 0;
    while(e < b.length && Idd((ADb(e, b.length), b.charCodeAt(e)), Lve))++e;
    c = b.length;
    while(c > 0 && Idd((ADb(c - 1, b.length), b.charCodeAt(c - 1)), Mve))--c;
    if (e >= c) throw scb(new Teb('The given string does not contain any numbers.'));
    f = mgb((zDb(e, c, b.length), b.substr(e, c - e)), ',|;|\r|\n');
    if (f.length != 2) throw scb(new Teb('Exactly two numbers are expected, ' + f.length + ' were found.'));
    try {
        this.a = Edb(ugb(f[0]));
        this.b = Edb(ugb(f[1]));
    } catch (a) {
        a = rcb(a);
        if (RD(a, 130)) {
            d = a;
            throw scb(new Teb(Nve + d));
        } else throw scb(a);
    }
};
_.Ib = function Ldd() {
    return '(' + this.a + ',' + this.b + ')';
};
_.a = 0;
_.b = 0;
var b2 = jeb(Ove, 'KVector', 8);
Ycb(77, 67, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    67: 1,
    15: 1,
    77: 1,
    411: 1
}, Rdd, Sdd, Tdd);
_.Nc = function Wdd() {
    return Qdd(this);
};
_.ag = function Udd(b) {
    var c, d, e, f, g, h;
    e = mgb(b, ',|;|\\(|\\)|\\[|\\]|\\{|\\}| |\t|\n');
    Ltb(this);
    try {
        d = 0;
        g = 0;
        f = 0;
        h = 0;
        while(d < e.length){
            if (e[d] != null && ugb(e[d]).length > 0) {
                g % 2 == 0 ? f = Edb(e[d]) : h = Edb(e[d]);
                g > 0 && g % 2 != 0 && Atb(this, new Edd(f, h));
                ++g;
            }
            ++d;
        }
    } catch (a) {
        a = rcb(a);
        if (RD(a, 130)) {
            c = a;
            throw scb(new Teb('The given string does not match the expected format for vectors.' + c));
        } else throw scb(a);
    }
};
_.Ib = function Xdd() {
    var a, b, c;
    a = new Wgb('(');
    b = Gtb(this, 0);
    while(b.b != b.d.c){
        c = JD(Utb(b), 8);
        Qgb(a, c.a + ',' + c.b);
        b.b != b.d.c && (a.a += '; ', a);
    }
    return (a.a += ')', a).a;
};
var a2 = jeb(Ove, 'KVectorChain', 77);
Ycb(254, 23, {
    3: 1,
    34: 1,
    23: 1,
    254: 1
}, ded);
var Ydd, Zdd, $dd, _dd, aed, bed;
var d2 = keb(GBe, 'Alignment', 254, MI, fed, eed);
var ged;
Ycb(968, 1, Hue, wed);
_.tf = function xed(a) {
    ved(a);
};
var ied, jed, ked, led, med, ned, oed, ped, qed, red, sed, ted;
var f2 = jeb(GBe, 'BoxLayouterOptions', 968);
Ycb(969, 1, {}, yed);
_.uf = function zed() {
    var a;
    return a = new Tld, a;
};
_.vf = function Aed(a) {};
var e2 = jeb(GBe, 'BoxLayouterOptions/BoxFactory', 969);
Ycb(296, 23, {
    3: 1,
    34: 1,
    23: 1,
    296: 1
}, Ied);
var Bed, Ced, Ded, Eed, Fed, Ged;
var g2 = keb(GBe, 'ContentAlignment', 296, MI, Ked, Jed);
var Led;
Ycb(684, 1, Hue, Mgd);
_.tf = function Ngd(a) {
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, LBe), ''), 'Layout Algorithm'), 'Select a specific layout algorithm.'), (zcd(), xcd)), hJ), mrb((lcd(), jcd)))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, MBe), ''), 'Resolved Layout Algorithm'), 'Meta data associated with the selected algorithm.'), wcd), t1), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Eye), ''), 'Alignment'), 'Alignment of the selected node relative to other nodes; the exact meaning depends on the used algorithm.'), Ped), tcd), d2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Oue), ''), 'Aspect Ratio'), 'The desired aspect ratio of the drawing, that is the quotient of width by height.'), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, NBe), ''), 'Bend Points'), "A fixed list of bend points for the edge. This is used by the 'Fixed Layout' algorithm to specify a pre-defined routing for an edge. The vector chain must include the source point, any bend points, and the target point, so it must have at least two points."), wcd), a2), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Qye), ''), 'Content Alignment'), 'Specifies how the content of a node are aligned. Each node can individually control the alignment of its contents. I.e. if a node should be aligned top left in its parent node, the parent node should specify that option.'), Yed), ucd), g2), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Dye), ''), 'Debug Mode'), 'Whether additional debug information shall be generated.'), (xdb(), false)), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Hye), ''), 'Direction'), 'Overall direction of edges: horizontal (right / left) or vertical (down / up).'), _ed), tcd), i2), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, aye), ''), 'Edge Routing'), 'What kind of edge routing style should be applied for the content of a parent node. Algorithms may also set this option to single edges in order to mark them as splines. The bend point list of edges with this option set to SPLINES must be interpreted as control points for a piecewise cubic spline.'), efd), tcd), l2), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, JBe), ''), 'Expand Nodes'), 'If active, nodes are expanded to fill the area of their parent.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Xxe), ''), 'Hierarchy Handling'), "Determines whether separate layout runs are triggered for different compound nodes in a hierarchical graph. Setting a node's hierarchy handling to `INCLUDE_CHILDREN` will lay out that node and all of its descendants in a single layout run, until a descendant is encountered which has its hierarchy handling set to `SEPARATE_CHILDREN`. In general, `SEPARATE_CHILDREN` will ensure that a new layout run is triggered for a node with that setting. Including multiple levels of hierarchy in a single layout run may allow cross-hierarchical edges to be laid out properly. If the root node is set to `INHERIT` (or not set at all), the default behavior is `SEPARATE_CHILDREN`."), jfd), tcd), p2), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        icd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Rue), ''), 'Padding'), "The padding to be left to a parent element's border when placing child elements. This can also serve as an output option of a layout algorithm if node size calculation is setup appropriately."), Lfd), wcd), $1), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        icd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Sue), ''), 'Interactive'), 'Whether the algorithm should be run in interactive mode for the content of a parent node. What this means exactly depends on how the specific algorithm interprets this option. Usually in the interactive mode algorithms try to modify the current layout as little as possible.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, bze), ''), 'interactive Layout'), 'Whether the graph should be changeable interactively and by setting constraints'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Vue), ''), 'Omit Node Micro Layout'), "Node micro layout comprises the computation of node dimensions (if requested), the placement of ports and their labels, and the placement of node labels. The functionality is implemented independent of any specific layout algorithm and shouldn't have any negative impact on the layout algorithm's performance itself. Yet, if any unforeseen behavior occurs, this option allows to deactivate the micro layout."), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Tue), ''), 'Port Constraints'), 'Defines constraints of the position of the ports of a node.'), Zfd), tcd), t2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, $ye), ''), 'Position'), "The position of a node, port, or label. This is used by the 'Fixed Layout' algorithm to specify a pre-defined position."), wcd), b2), nrb(icd, WC(OC(V1, 1), Ere, 170, 0, [
        kcd,
        hcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Lue), ''), 'Priority'), 'Defines the priority of an object; its meaning depends on the specific layout algorithm and the context where it is used.'), vcd), UI), nrb(icd, WC(OC(V1, 1), Ere, 170, 0, [
        gcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Pue), ''), 'Randomization Seed'), 'Seed used for pseudo-random number generators to control the layout algorithm. If the value is 0, the seed shall be determined pseudo-randomly (e.g. from the system time).'), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Que), ''), 'Separate Connected Components'), 'Whether each connected component should be processed separately.'), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Rye), ''), 'Junction Points'), 'This option is not used as option, but as output of the layout algorithms. It is attached to edges and determines the points where junction symbols should be drawn in order to represent hyperedges with orthogonal routing. Whether such points are computed depends on the chosen layout algorithm and edge routing style. The points are put into the vector chain with no specific order.'), ufd), wcd), a2), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Vye), ''), 'Comment Box'), 'Whether the node should be regarded as a comment box instead of a regular node. In that case its placement should be similar to how labels are handled. Any edges incident to a comment box specify to which graph elements the comment is related.'), false), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Wye), ''), 'Hypernode'), 'Whether the node should be handled as a hypernode.'), false), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, OBe), ''), 'Label Manager'), "Label managers can shorten labels upon a layout algorithm's request."), wcd), Y1), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        hcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, PBe), ''), 'Softwrapping Fuzziness'), 'Determines the amount of fuzziness to be used when performing softwrapping on labels. The value expresses the percent of overhang that is permitted for each line. If the next line would take up less space than this threshold, it is appended to the current line instead of being placed in a new line.'), 0), scd), LI), mrb(hcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, _ye), ''), 'Margins'), "Margins define additional space around the actual bounds of a graph element. For instance, ports or labels being placed on the outside of a node's border might introduce such a margin. The margin is used to guarantee non-overlap of other graph elements with those ports or labels."), wfd), wcd), Z1), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Bye), ''), 'No Layout'), "No layout is done for the associated element. This is used to mark parts of a diagram to avoid their inclusion in the layout graph, or to mark parts of the layout graph to prevent layout engines from processing them. If you wish to exclude the contents of a compound node from automatic layout, while the node itself is still considered on its own layer, use the 'Fixed Layout' algorithm for that node."), false), rcd), GI), nrb(icd, WC(OC(V1, 1), Ere, 170, 0, [
        gcd,
        kcd,
        hcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, QBe), ''), 'Scale Factor'), "The scaling factor to be applied to the corresponding node in recursive layout. It causes the corresponding node's size to be adjusted, and its ports and labels to be sized and placed accordingly after the layout of that node has been determined (and before the node itself and its siblings are arranged). The scaling is not reverted afterwards, so the resulting layout graph contains the adjusted size and position data. This option is currently not supported if 'Layout Hierarchy' is set."), 1), scd), LI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, RBe), ''), 'Child Area Width'), 'The width of the area occupied by the laid out children of a node.'), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, SBe), ''), 'Child Area Height'), 'The height of the area occupied by the laid out children of a node.'), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, _ue), ''), vBe), "Turns topdown layout on and off. If this option is enabled, hierarchical layout will be computed first for the root node and then for its children recursively. Layouts are then scaled down to fit the area provided by their parents. Graphs must follow a certain structure for topdown layout to work properly. {@link TopdownNodeTypes.PARALLEL_NODE} nodes must have children of type {@link TopdownNodeTypes.HIERARCHICAL_NODE} and must define {@link topdown.hierarchicalNodeWidth} and {@link topdown.hierarchicalNodeAspectRatio} for their children. Furthermore they need to be laid out using an algorithm that is a {@link TopdownLayoutProvider}. Hierarchical nodes can also be parents of other hierarchical nodes and can optionally use a {@link TopdownSizeApproximator} to dynamically set sizes during topdown layout. In this case {@link topdown.hierarchicalNodeWidth} and {@link topdown.hierarchicalNodeAspectRatio} should be set on the node itself rather than the parent. The values are then used by the size approximator as base values. Hierarchical nodes require the layout option {@link nodeSize.fixedGraphSize} to be true to prevent the algorithm used there from resizing the hierarchical node. This option is not supported if 'Hierarchy Handling' is set to 'INCLUDE_CHILDREN'"), false), rcd), GI), mrb(jcd))));
    Oad(a, _ue, dve, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, TBe), ''), 'Animate'), 'Whether the shift from the old layout to the new computed layout shall be animated.'), true), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, UBe), ''), 'Animation Time Factor'), "Factor for computation of animation time. The higher the value, the longer the animation time. If the value is 0, the resulting time is always equal to the minimum defined by 'Minimal Animation Time'."), jfb(100)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, VBe), ''), 'Layout Ancestors'), 'Whether the hierarchy levels on the path from the selected element to the root of the diagram shall be included in the layout process.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, WBe), ''), 'Maximal Animation Time'), 'The maximal time for animations, in milliseconds.'), jfb(4000)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, XBe), ''), 'Minimal Animation Time'), 'The minimal time for animations, in milliseconds.'), jfb(400)), vcd), UI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, YBe), ''), 'Progress Bar'), 'Whether a progress bar shall be displayed during layout computations.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, ZBe), ''), 'Validate Graph'), 'Whether the graph shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, $Be), ''), 'Validate Options'), 'Whether layout options shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user.'), true), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, _Be), ''), 'Zoom to Fit'), 'Whether the zoom level shall be set to view the whole diagram after layout.'), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, KBe), 'box'), 'Box Layout Mode'), 'Configures the packing mode used by the {@link BoxLayoutProvider}. If SIMPLE is not required (neither priorities are used nor the interactive mode), GROUP_DEC can improve the packing and decrease the area. GROUP_MIXED and GROUP_INC may, in very specific scenarios, work better.'), Ted), tcd), J2), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, aCe), 'json'), 'Shape Coords'), 'For layouts transferred into JSON graphs, specify the coordinate system to be used for nodes, ports, and labels of nodes and ports.'), sfd), tcd), y2), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, bCe), 'json'), 'Edge Coords'), 'For layouts transferred into JSON graphs, specify the coordinate system to be used for edge route points and edge labels.'), qfd), tcd), j2), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, oye), bye), 'Comment Comment Spacing'), 'Spacing to be preserved between a comment box and other comment boxes connected to the same node. The space left between comment boxes of different nodes is controlled by the node-node spacing.'), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, pye), bye), 'Comment Node Spacing'), 'Spacing to be preserved between a node and its connected comment boxes. The space left between a node and the comments of another node is controlled by the node-node spacing.'), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, qye), bye), 'Components Spacing'), "Spacing to be preserved between pairs of connected components. This option is only relevant if 'separateConnectedComponents' is activated."), 20), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, rye), bye), 'Edge Spacing'), 'Spacing to be preserved between any two edges. Note that while this can somewhat easily be satisfied for the segments of orthogonally drawn edges, it is harder for general polylines or splines.'), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Nue), bye), 'Edge Label Spacing'), "The minimal distance to be preserved between a label and the edge it is associated with. Note that the placement of a label is influenced by the 'edgelabels.placement' option."), 2), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, sye), bye), 'Edge Node Spacing'), 'Spacing to be preserved between nodes and edges.'), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, tye), bye), 'Label Spacing'), 'Determines the amount of space to be left between two labels of the same graph element.'), 0), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, wye), bye), 'Label Node Spacing'), "Spacing to be preserved between labels and the border of node they are associated with. Note that the placement of a label is influenced by the 'nodelabels.placement' option."), 5), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, uye), bye), 'Horizontal spacing between Label and Port'), "Horizontal spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, vye), bye), 'Vertical spacing between Label and Port'), "Vertical spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Mue), bye), 'Node Spacing'), 'The minimal distance to be preserved between each two nodes.'), 20), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, xye), bye), 'Node Self Loop Spacing'), 'Spacing to be preserved between a node and its self loops.'), 10), scd), LI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, yye), bye), 'Port Spacing'), 'Spacing between pairs of ports of the same node.'), 10), scd), LI), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        icd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, zye), bye), 'Individual Spacing'), "Allows to specify individual spacing values for graph elements that shall be different from the value specified for the element's parent."), wcd), d3), nrb(icd, WC(OC(V1, 1), Ere, 170, 0, [
        gcd,
        kcd,
        hcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, aze), bye), 'Additional Port Space'), 'Additional space around the sets of ports on each node side. For each side of a node, this option can reserve additional space before and after the ports on each side. For example, a top spacing of 20 makes sure that the first port on the western and eastern side is 20 units away from the northern border.'), zgd), wcd), Z1), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Zye), hCe), 'Layout Partition'), 'Partition to which the node belongs. This requires Layout Partitioning to be active. Nodes with lower partition IDs will appear to the left of nodes with higher partition IDs (assuming a left-to-right layout direction).'), vcd), UI), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        icd
    ])))));
    Oad(a, Zye, Yye, Pfd);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Yye), hCe), 'Layout Partitioning'), 'Whether to activate partitioned layout. This will allow to group nodes through the Layout Partition option. a pair of nodes with different partition indices is then placed such that the node with lower index is placed to the left of the other node (with left-to-right layout direction). Depending on the layout algorithm, this may only be guaranteed to work if all nodes have a layout partition configured, or at least if edges that cross partitions are not part of a partition-crossing cycle.'), Nfd), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Iye), iCe), 'Node Label Padding'), 'Define padding for node labels that are placed inside of a node.'), yfd), wcd), $1), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Zue), iCe), 'Node Label Placement'), "Hints for where node labels are to be placed; if empty, the node label's position is not modified."), Afd), ucd), r2), nrb(icd, WC(OC(V1, 1), Ere, 170, 0, [
        hcd
    ])))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Lye), jCe), 'Port Alignment'), 'Defines the default port distribution for a node. May be overridden for each side individually.'), Rfd), tcd), s2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Mye), jCe), 'Port Alignment (North)'), "Defines how ports on the northern side are placed, overriding the node's general port alignment."), tcd), s2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Nye), jCe), 'Port Alignment (South)'), "Defines how ports on the southern side are placed, overriding the node's general port alignment."), tcd), s2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Oye), jCe), 'Port Alignment (West)'), "Defines how ports on the western side are placed, overriding the node's general port alignment."), tcd), s2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Pye), jCe), 'Port Alignment (East)'), "Defines how ports on the eastern side are placed, overriding the node's general port alignment."), tcd), s2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Yue), kCe), 'Node Size Constraints'), "What should be taken into account when calculating a node's size. Empty size constraints specify that a node's size is already fixed and should not be changed."), Cfd), ucd), z2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Xue), kCe), 'Node Size Options'), 'Options modifying the behavior of the size constraints set on a node. Each member of the set specifies something that should be taken into account when calculating node sizes. The empty set corresponds to no further modifications.'), Hfd), ucd), A2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, pve), kCe), 'Node Size Minimum'), 'The minimal size to which a node can be reduced.'), Ffd), wcd), b2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Wue), kCe), 'Fixed Graph Size'), "By default, the fixed layout provider will enlarge a graph until it is large enough to contain its children. If this option is set, it won't do so."), false), rcd), GI), mrb(jcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Tye), mye), 'Edge Label Placement'), 'Gives a hint on where to put edge labels.'), cfd), tcd), k2), mrb(hcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Uue), mye), 'Inline Edge Labels'), "If true, an edge label is placed directly on its edge. May only apply to center edge labels. This kind of label placement is only advisable if the label's rendering is such that it is not crossed by its edge and thus stays legible."), false), rcd), GI), mrb(hcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, cCe), 'font'), 'Font Name'), 'Font name used for a label.'), xcd), hJ), mrb(hcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, dCe), 'font'), 'Font Size'), 'Font size used for a label.'), vcd), UI), mrb(hcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Xye), lCe), 'Port Anchor Offset'), 'The offset to the port position where connections shall be attached.'), wcd), b2), mrb(kcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Uye), lCe), 'Port Index'), "The index of a port in the fixed order around a node. The order is assumed as clockwise, starting with the leftmost port on the top side. This option must be set if 'Port Constraints' is set to FIXED_ORDER and no specific positions are given for the ports. Additionally, the option 'Port Side' must be defined in this case."), vcd), UI), mrb(kcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Cye), lCe), 'Port Side'), "The side of a node on which a port is situated. This option must be set if 'Port Constraints' is set to FIXED_SIDE or FIXED_ORDER and no specific positions are given for the ports."), egd), tcd), v2), mrb(kcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Zbd(bcd($bd(_bd(new fcd, Aye), lCe), 'Port Border Offset'), "The offset of ports on the node border. With a positive offset the port is moved outside of the node, while with a negative offset the port is moved towards the inside. An offset of 0 means that the port is placed directly on the node border, i.e. if the port side is north, the port's south border touches the nodes's north border; if the port side is east, the port's west border touches the nodes's east border; if the port side is south, the port's north border touches the node's south border; if the port side is west, the port's east border touches the node's west border."), scd), LI), mrb(kcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, $ue), mCe), 'Port Label Placement'), "Decides on a placement method for port labels; if empty, the node label's position is not modified."), bgd), ucd), u2), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Jye), mCe), 'Port Labels Next to Port'), "Use 'portLabels.placement': NEXT_TO_PORT_OF_POSSIBLE."), false), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Kye), mCe), 'Treat Port Labels as Group'), 'If this option is true (default), the labels of a port will be treated as a group when it comes to centering them next to their port. If this option is false, only the first label will be centered next to the port, with the others being placed below. This only applies to labels of eastern and western ports and will have no effect if labels are not placed next to their port.'), true), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, ave), nCe), 'Topdown Scale Factor'), "The scaling factor to be applied to the nodes laid out within the node in recursive topdown layout. The difference to 'Scale Factor' is that the node itself is not scaled. This value has to be set on hierarchical nodes."), 1), scd), LI), mrb(jcd))));
    Oad(a, ave, dve, Igd);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, eCe), nCe), 'Topdown Size Approximator'), 'The size approximator to be used to set sizes of hierarchical nodes during topdown layout. The default value is null, which results in nodes keeping whatever size is defined for them e.g. through parent parallel node or by manually setting the size.'), null), tcd), E2), mrb(icd))));
    Oad(a, eCe, dve, Kgd);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, bve), nCe), 'Topdown Hierarchical Node Width'), 'The fixed size of a hierarchical node when using topdown layout. If this value is set on a parallel node it applies to its children, when set on a hierarchical node it applies to the node itself.'), 150), scd), LI), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        icd
    ])))));
    Oad(a, bve, dve, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, cve), nCe), 'Topdown Hierarchical Node Aspect Ratio'), 'The fixed aspect ratio of a hierarchical node when using topdown layout. Default is 1/sqrt(2). If this value is set on a parallel node it applies to its children, when set on a hierarchical node it applies to the node itself.'), 1.414), scd), LI), nrb(jcd, WC(OC(V1, 1), Ere, 170, 0, [
        icd
    ])))));
    Oad(a, cve, dve, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, dve), nCe), 'Topdown Node Type'), 'The different node types used for topdown layout. If the node type is set to {@link TopdownNodeTypes.PARALLEL_NODE} the algorithm must be set to a {@link TopdownLayoutProvider} such as {@link TopdownPacking}. The {@link nodeSize.fixedGraphSize} option is technically only required for hierarchical nodes.'), null), tcd), B2), mrb(icd))));
    Oad(a, dve, Wue, null);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, fCe), nCe), 'Topdown Scale Cap'), 'Determines the upper limit for the topdown scale factor. The default value is 1.0 which ensures that nested children never end up appearing larger than their parents in terms of unit sizes such as the font size. If the limit is larger, nodes will fully utilize the available space, but it is counteriniuitive for inner nodes to have a larger scale than outer nodes.'), 1), scd), LI), mrb(jcd))));
    Oad(a, fCe, dve, Ggd);
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Fye), oCe), 'Activate Inside Self Loops'), "Whether this node allows to route self loops inside of it instead of around it. If set to true, this will make the node a compound node if it isn't already, and will require the layout algorithm to support compound nodes with hierarchical ports."), false), rcd), GI), mrb(icd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Gye), oCe), 'Inside Self Loop'), 'Whether a self loop should be routed inside a node instead of around that node.'), false), rcd), GI), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, Sye), 'edge'), 'Edge Thickness'), 'The thickness of an edge. This is a hint on the line width used to draw an edge, possibly requiring more space to be reserved for it.'), 1), scd), LI), mrb(gcd))));
    Tad(a, new Pbd(dcd(ccd(ecd(Ybd(Zbd(bcd($bd(_bd(new fcd, gCe), 'edge'), 'Edge Type'), 'The type of an edge. This is usually used for UML class diagrams, where associations must be handled differently from generalizations.'), gfd), tcd), m2), mrb(gcd))));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, Ose), 'Layered'), 'The layer-based method was introduced by Sugiyama, Tagawa and Toda in 1981. It emphasizes the direction of edges by pointing as many edges as possible into the same direction. The nodes are arranged in layers, which are sometimes called "hierarchies", and then reordered such that the number of edge crossings is minimized. Afterwards, concrete coordinates are computed for the nodes and edge bend points.')));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, 'org.eclipse.elk.orthogonal'), 'Orthogonal'), 'Orthogonal methods that follow the "topology-shape-metrics" approach by Batini, Nardelli and Tamassia \'86. The first phase determines the topology of the drawing by applying a planarization technique, which results in a planar representation of the graph. The orthogonal shape is computed in the second phase, which aims at minimizing the number of edge bends, and is called orthogonalization. The third phase leads to concrete coordinates for nodes and edge bend points by applying a compaction method, thus defining the metrics.')));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, Kue), 'Force'), 'Layout algorithms that follow physical analogies by simulating a system of attractive and repulsive forces. The first successful method of this kind was proposed by Eades in 1984.')));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, 'org.eclipse.elk.circle'), 'Circle'), 'Circular layout algorithms emphasize cycles or biconnected components of a graph by arranging them in circles. This is useful if a drawing is desired where such components are clearly grouped, or where cycles are shown as prominent OPTIONS of the graph.')));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, Vze), 'Tree'), 'Specialized layout methods for trees, i.e. acyclic graphs. The regular structure of graphs that have no undirected cycles can be emphasized using an algorithm of this type.')));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, 'org.eclipse.elk.planar'), 'Planar'), 'Algorithms that require a planar or upward planar graph. Most of these algorithms are theoretically interesting, but not practically usable.')));
    Sad(a, new uad(Bad(Dad(Cad(new Ead, yAe), 'Radial'), 'Radial layout algorithms usually position the nodes of the graph on concentric circles.')));
    Xhd((new Yhd, a));
    ved((new wed, a));
    fkd((new gkd, a));
};
var Ned, Oed, Ped, Qed, Red, Sed, Ted, Ued, Ved, Wed, Xed, Yed, Zed, $ed, _ed, afd, bfd, cfd, dfd, efd, ffd, gfd, hfd, ifd, jfd, kfd, lfd, mfd, nfd, ofd, pfd, qfd, rfd, sfd, tfd, ufd, vfd, wfd, xfd, yfd, zfd, Afd, Bfd, Cfd, Dfd, Efd, Ffd, Gfd, Hfd, Ifd, Jfd, Kfd, Lfd, Mfd, Nfd, Ofd, Pfd, Qfd, Rfd, Sfd, Tfd, Ufd, Vfd, Wfd, Xfd, Yfd, Zfd, $fd, _fd, agd, bgd, cgd, dgd, egd, fgd, ggd, hgd, igd, jgd, kgd, lgd, mgd, ngd, ogd, pgd, qgd, rgd, sgd, tgd, ugd, vgd, wgd, xgd, ygd, zgd, Agd, Bgd, Cgd, Dgd, Egd, Fgd, Ggd, Hgd, Igd, Jgd, Kgd;
var h2 = jeb(GBe, 'CoreOptions', 684);
Ycb(86, 23, {
    3: 1,
    34: 1,
    23: 1,
    86: 1
}, Xgd);
var Ogd, Pgd, Qgd, Rgd, Sgd;
var i2 = keb(GBe, 'Direction', 86, MI, Zgd, Ygd);
var $gd;
Ycb(275, 23, {
    3: 1,
    34: 1,
    23: 1,
    275: 1
}, fhd);
var ahd, bhd, chd, dhd;
var j2 = keb(GBe, 'EdgeCoords', 275, MI, hhd, ghd);
var ihd;
Ycb(276, 23, {
    3: 1,
    34: 1,
    23: 1,
    276: 1
}, ohd);
var khd, lhd, mhd;
var k2 = keb(GBe, 'EdgeLabelPlacement', 276, MI, qhd, phd);
var rhd;
Ycb(220, 23, {
    3: 1,
    34: 1,
    23: 1,
    220: 1
}, yhd);
var thd, uhd, vhd, whd;
var l2 = keb(GBe, 'EdgeRouting', 220, MI, Ahd, zhd);
var Bhd;
Ycb(322, 23, {
    3: 1,
    34: 1,
    23: 1,
    322: 1
}, Khd);
var Dhd, Ehd, Fhd, Ghd, Hhd, Ihd;
var m2 = keb(GBe, 'EdgeType', 322, MI, Mhd, Lhd);
var Nhd;
Ycb(966, 1, Hue, Yhd);
_.tf = function Zhd(a) {
    Xhd(a);
};
var Phd, Qhd, Rhd, Shd, Thd, Uhd, Vhd;
var o2 = jeb(GBe, 'FixedLayouterOptions', 966);
Ycb(967, 1, {}, $hd);
_.uf = function _hd() {
    var a;
    return a = new Lnd, a;
};
_.vf = function aid(a) {};
var n2 = jeb(GBe, 'FixedLayouterOptions/FixedFactory', 967);
Ycb(342, 23, {
    3: 1,
    34: 1,
    23: 1,
    342: 1
}, fid);
var bid, cid, did;
var p2 = keb(GBe, 'HierarchyHandling', 342, MI, hid, gid);
var iid;
Ycb(289, 23, {
    3: 1,
    34: 1,
    23: 1,
    289: 1
}, qid);
var kid, lid, mid, nid;
var q2 = keb(GBe, 'LabelSide', 289, MI, sid, rid);
var tid;
Ycb(94, 23, {
    3: 1,
    34: 1,
    23: 1,
    94: 1
}, Fid);
var vid, wid, xid, yid, zid, Aid, Bid, Cid, Did;
var r2 = keb(GBe, 'NodeLabelPlacement', 94, MI, Iid, Hid);
var Jid;
Ycb(255, 23, {
    3: 1,
    34: 1,
    23: 1,
    255: 1
}, Rid);
var Lid, Mid, Nid, Oid, Pid;
var s2 = keb(GBe, 'PortAlignment', 255, MI, Tid, Sid);
var Uid;
Ycb(100, 23, {
    3: 1,
    34: 1,
    23: 1,
    100: 1
}, djd);
var Wid, Xid, Yid, Zid, $id, _id;
var t2 = keb(GBe, 'PortConstraints', 100, MI, fjd, ejd);
var gjd;
Ycb(277, 23, {
    3: 1,
    34: 1,
    23: 1,
    277: 1
}, pjd);
var ijd, jjd, kjd, ljd, mjd, njd;
var u2 = keb(GBe, 'PortLabelPlacement', 277, MI, tjd, sjd);
var ujd;
Ycb(64, 23, {
    3: 1,
    34: 1,
    23: 1,
    64: 1
}, Vjd);
var wjd, xjd, yjd, zjd, Ajd, Bjd, Cjd, Djd, Ejd, Fjd, Gjd, Hjd, Ijd, Jjd, Kjd, Ljd, Mjd, Njd, Ojd, Pjd, Qjd;
var v2 = keb(GBe, 'PortSide', 64, MI, Yjd, Xjd);
var Zjd;
Ycb(970, 1, Hue, gkd);
_.tf = function hkd(a) {
    fkd(a);
};
var _jd, akd, bkd, ckd, dkd;
var x2 = jeb(GBe, 'RandomLayouterOptions', 970);
Ycb(971, 1, {}, ikd);
_.uf = function jkd() {
    var a;
    return a = new Kod, a;
};
_.vf = function kkd(a) {};
var w2 = jeb(GBe, 'RandomLayouterOptions/RandomFactory', 971);
Ycb(297, 23, {
    3: 1,
    34: 1,
    23: 1,
    297: 1
}, pkd);
var lkd, mkd, nkd;
var y2 = keb(GBe, 'ShapeCoords', 297, MI, rkd, qkd);
var skd;
Ycb(378, 23, {
    3: 1,
    34: 1,
    23: 1,
    378: 1
}, zkd);
var ukd, vkd, wkd, xkd;
var z2 = keb(GBe, 'SizeConstraint', 378, MI, Bkd, Akd);
var Ckd;
Ycb(264, 23, {
    3: 1,
    34: 1,
    23: 1,
    264: 1
}, Okd);
var Ekd, Fkd, Gkd, Hkd, Ikd, Jkd, Kkd, Lkd, Mkd;
var A2 = keb(GBe, 'SizeOptions', 264, MI, Qkd, Pkd);
var Rkd;
Ycb(278, 23, {
    3: 1,
    34: 1,
    23: 1,
    278: 1
}, Xkd);
var Tkd, Ukd, Vkd;
var B2 = keb(GBe, 'TopdownNodeTypes', 278, MI, Zkd, Ykd);
var $kd;
Ycb(343, 23, sCe);
var ald, bld;
var E2 = keb(GBe, 'TopdownSizeApproximator', 343, MI, fld, eld);
Ycb(964, 343, sCe, hld);
_.Rg = function ild(a) {
    return gld(a);
};
var C2 = keb(GBe, 'TopdownSizeApproximator/1', 964, E2, null, null);
Ycb(965, 343, sCe, jld);
_.Rg = function kld(b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    c = JD(ksd(b, (Lgd(), igd)), 149);
    A = (Hpd(), o = new cxd, o);
    dsd(A, b);
    B = new Irb;
    for(g = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); g.e != g.i.gc();){
        e = JD(AHd(g), 27);
        t = (n = new cxd, n);
        axd(t, A);
        dsd(t, e);
        D = gld(e);
        dtd(t, $wnd.Math.max(e.g, D.a), $wnd.Math.max(e.f, D.b));
        gsb(B.f, e, t);
    }
    for(f = new CHd((!b.a && (b.a = new X0d(A3, b, 10, 11)), b.a)); f.e != f.i.gc();){
        e = JD(AHd(f), 27);
        for(l = new CHd((!e.e && (e.e = new ree(x3, e, 7, 4)), e.e)); l.e != l.i.gc();){
            k = JD(AHd(l), 85);
            v = JD(Wd(fsb(B.f, e)), 27);
            w = JD(Nib(B, nDd((!k.c && (k.c = new ree(v3, k, 5, 8)), k.c), 0)), 27);
            u = (m = new Vtd, m);
            tCd((!u.b && (u.b = new ree(v3, u, 4, 7)), u.b), v);
            tCd((!u.c && (u.c = new ree(v3, u, 5, 8)), u.c), w);
            Ttd(u, Zwd(v));
            dsd(u, k);
        }
    }
    q = JD(Vnd(c.f), 222);
    try {
        q.kf(A, new hod);
        Wnd(c.f, q);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            p = a;
            throw scb(p);
        } else throw scb(a);
    }
    lsd(A, Ved) || lsd(A, Ued) || Zmd(A);
    j = Beb(MD(ksd(A, Ved)));
    i = Beb(MD(ksd(A, Ued)));
    h = j / i;
    d = Beb(MD(ksd(A, Cgd))) * $wnd.Math.sqrt((!A.a && (A.a = new X0d(A3, A, 10, 11)), A.a).i);
    C = JD(ksd(A, Kfd), 107);
    s = C.b + C.c + 1;
    r = C.d + C.a + 1;
    return new Edd($wnd.Math.max(s, d), $wnd.Math.max(r, d / h));
};
var D2 = keb(GBe, 'TopdownSizeApproximator/2', 965, E2, null, null);
var lld;
Ycb(340, 1, {
    847: 1
}, wld);
_.Sg = function xld(a, b) {
    return nld(this, a, b);
};
_.Tg = function yld() {
    pld(this);
};
_.Ug = function zld() {
    return this.q;
};
_.Vg = function Ald() {
    return !this.f ? null : ynb(this.f);
};
_.Wg = function Bld() {
    return ynb(this.a);
};
_.Xg = function Cld() {
    return this.p;
};
_.Yg = function Dld() {
    return false;
};
_.Zg = function Eld() {
    return this.n;
};
_.$g = function Fld() {
    return this.p != null && !this.b;
};
_._g = function Gld(a) {
    var b;
    if (this.n) {
        b = a;
        Ilb(this.f, b);
    }
};
_.ah = function Hld(a, b) {
    var c, d;
    this.n && !!a && rld(this, (c = new sfe, d = kfe(c, a), rfe(c), d), (bod(), $nd));
};
_.bh = function Ild(a) {
    var b;
    if (this.b) return null;
    else {
        b = old(this, this.g);
        Atb(this.a, b);
        b.i = this;
        this.d = a;
        return b;
    }
};
_.dh = function Jld(a) {
    a > 0 && !this.b && qld(this, a);
};
_.b = false;
_.c = 0;
_.d = -1;
_.e = null;
_.f = null;
_.g = -1;
_.j = false;
_.k = false;
_.n = false;
_.o = 0;
_.q = 0;
_.r = 0;
var G2 = jeb(cze, 'BasicProgressMonitor', 340);
Ycb(701, 222, tue, Tld);
_.kf = function Xld(a, b) {
    Mld(a, b);
};
var N2 = jeb(cze, 'BoxLayoutProvider', 701);
Ycb(960, 1, Bte, Zld);
_.Le = function $ld(a, b) {
    return Yld(this, JD(a, 27), JD(b, 27));
};
_.Fb = function _ld(a) {
    return this === a;
};
_.Me = function amd() {
    return new uqb(this);
};
_.a = false;
var H2 = jeb(cze, 'BoxLayoutProvider/1', 960);
Ycb(162, 1, {
    162: 1
}, hmd, imd);
_.Ib = function jmd() {
    return this.c ? bxd(this.c) : Ee(this.b);
};
var I2 = jeb(cze, 'BoxLayoutProvider/Group', 162);
Ycb(321, 23, {
    3: 1,
    34: 1,
    23: 1,
    321: 1
}, pmd);
var kmd, lmd, mmd, nmd;
var J2 = keb(cze, 'BoxLayoutProvider/PackingMode', 321, MI, rmd, qmd);
var smd;
Ycb(961, 1, Bte, umd);
_.Le = function vmd(a, b) {
    return Uld(JD(a, 162), JD(b, 162));
};
_.Fb = function wmd(a) {
    return this === a;
};
_.Me = function xmd() {
    return new uqb(this);
};
var K2 = jeb(cze, 'BoxLayoutProvider/lambda$0$Type', 961);
Ycb(962, 1, Bte, ymd);
_.Le = function zmd(a, b) {
    return Vld(JD(a, 162), JD(b, 162));
};
_.Fb = function Amd(a) {
    return this === a;
};
_.Me = function Bmd() {
    return new uqb(this);
};
var L2 = jeb(cze, 'BoxLayoutProvider/lambda$1$Type', 962);
Ycb(963, 1, Bte, Cmd);
_.Le = function Dmd(a, b) {
    return Wld(JD(a, 162), JD(b, 162));
};
_.Fb = function Emd(a) {
    return this === a;
};
_.Me = function Fmd() {
    return new uqb(this);
};
var M2 = jeb(cze, 'BoxLayoutProvider/lambda$2$Type', 963);
Ycb(1323, 1, {
    824: 1
}, Gmd);
_.Kg = function Hmd(a, b) {
    return Jwc(), !RD(b, 173) || H8c((w8c(), v8c, JD(a, 173)), b);
};
var O2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$0$Type', 1323);
Ycb(1324, 1, kre, Imd);
_.Ad = function Jmd(a) {
    Mwc(this.a, JD(a, 144));
};
var P2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$1$Type', 1324);
Ycb(1325, 1, kre, Kmd);
_.Ad = function Lmd(a) {
    JD(a, 102);
    Jwc();
};
var Q2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$2$Type', 1325);
Ycb(1329, 1, kre, Mmd);
_.Ad = function Nmd(a) {
    Nwc(this.a, JD(a, 102));
};
var R2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$3$Type', 1329);
Ycb(1327, 1, Ire, Omd);
_.Mb = function Pmd(a) {
    return Owc(this.a, this.b, JD(a, 144));
};
var S2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$4$Type', 1327);
Ycb(1326, 1, Ire, Qmd);
_.Mb = function Rmd(a) {
    return Qwc(this.a, this.b, JD(a, 824));
};
var T2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$5$Type', 1326);
Ycb(1328, 1, kre, Smd);
_.Ad = function Tmd(a) {
    Pwc(this.a, this.b, JD(a, 144));
};
var U2 = jeb(cze, 'ElkSpacings/AbstractSpacingsBuilder/lambda$6$Type', 1328);
Ycb(925, 1, {}, tnd);
_.Kb = function und(a) {
    return snd(a);
};
_.Fb = function vnd(a) {
    return this === a;
};
var W2 = jeb(cze, 'ElkUtil/lambda$0$Type', 925);
Ycb(926, 1, kre, wnd);
_.Ad = function xnd(a) {
    gnd(this.a, this.b, JD(a, 85));
};
_.a = 0;
_.b = 0;
var X2 = jeb(cze, 'ElkUtil/lambda$1$Type', 926);
Ycb(927, 1, kre, ynd);
_.Ad = function znd(a) {
    hnd(this.a, this.b, JD(a, 168));
};
_.a = 0;
_.b = 0;
var Y2 = jeb(cze, 'ElkUtil/lambda$2$Type', 927);
Ycb(928, 1, kre, And);
_.Ad = function Bnd(a) {
    ind(this.a, this.b, JD(a, 153));
};
_.a = 0;
_.b = 0;
var Z2 = jeb(cze, 'ElkUtil/lambda$3$Type', 928);
Ycb(929, 1, kre, Cnd);
_.Ad = function Dnd(a) {
    jnd(this.a, JD(a, 369));
};
var $2 = jeb(cze, 'ElkUtil/lambda$4$Type', 929);
Ycb(326, 1, {
    34: 1,
    326: 1
}, Fnd);
_.Dd = function Gnd(a) {
    return End(this, JD(a, 241));
};
_.Fb = function Hnd(a) {
    var b;
    if (RD(a, 326)) {
        b = JD(a, 326);
        return this.a == b.a;
    }
    return false;
};
_.Hb = function Ind() {
    return YD(this.a);
};
_.Ib = function Jnd() {
    return this.a + ' (exclusive)';
};
_.a = 0;
var _2 = jeb(cze, 'ExclusiveBounds/ExclusiveLowerBound', 326);
Ycb(1083, 222, tue, Lnd);
_.kf = function Mnd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    b.Sg('Fixed Layout', 1);
    f = JD(ksd(a, (Lgd(), dfd)), 220);
    l = 0;
    m = 0;
    for(s = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); s.e != s.i.gc();){
        q = JD(AHd(s), 27);
        B = JD(ksd(q, (Whd(), Vhd)), 8);
        if (B) {
            ftd(q, B.a, B.b);
            if (JD(ksd(q, Qhd), 181).Gc((ykd(), ukd))) {
                n = JD(ksd(q, Shd), 8);
                n.a > 0 && n.b > 0 && mnd(q, n.a, n.b, true, true);
            }
        }
        l = $wnd.Math.max(l, q.i + q.g);
        m = $wnd.Math.max(m, q.j + q.f);
        for(j = new CHd((!q.n && (q.n = new X0d(z3, q, 1, 7)), q.n)); j.e != j.i.gc();){
            h = JD(AHd(j), 153);
            B = JD(ksd(h, Vhd), 8);
            !!B && ftd(h, B.a, B.b);
            l = $wnd.Math.max(l, q.i + h.i + h.g);
            m = $wnd.Math.max(m, q.j + h.j + h.f);
        }
        for(v = new CHd((!q.c && (q.c = new X0d(B3, q, 9, 9)), q.c)); v.e != v.i.gc();){
            u = JD(AHd(v), 124);
            B = JD(ksd(u, Vhd), 8);
            !!B && ftd(u, B.a, B.b);
            w = q.i + u.i;
            A = q.j + u.j;
            l = $wnd.Math.max(l, w + u.g);
            m = $wnd.Math.max(m, A + u.f);
            for(i = new CHd((!u.n && (u.n = new X0d(z3, u, 1, 7)), u.n)); i.e != i.i.gc();){
                h = JD(AHd(i), 153);
                B = JD(ksd(h, Vhd), 8);
                !!B && ftd(h, B.a, B.b);
                l = $wnd.Math.max(l, w + h.i + h.g);
                m = $wnd.Math.max(m, A + h.j + h.f);
            }
        }
        for(e = new es(Ir($Bd(q).a.Jc(), new er)); cs(e);){
            c = JD(ds(e), 85);
            k = Knd(c);
            l = $wnd.Math.max(l, k.a);
            m = $wnd.Math.max(m, k.b);
        }
        for(d = new es(Ir(ZBd(q).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 85);
            if (Zwd(iCd(c)) != a) {
                k = Knd(c);
                l = $wnd.Math.max(l, k.a);
                m = $wnd.Math.max(m, k.b);
            }
        }
    }
    if (f == (xhd(), thd)) for(r = new CHd((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a)); r.e != r.i.gc();){
        q = JD(AHd(r), 27);
        for(d = new es(Ir($Bd(q).a.Jc(), new er)); cs(d);){
            c = JD(ds(d), 85);
            g = bnd(c);
            g.b == 0 ? msd(c, tfd, null) : msd(c, tfd, g);
        }
    }
    if (!ydb(LD(ksd(a, (Whd(), Rhd))))) {
        t = JD(ksd(a, Thd), 107);
        p = l + t.b + t.c;
        o = m + t.d + t.a;
        mnd(a, p, o, true, true);
    }
    b.Tg();
};
var a3 = jeb(cze, 'FixedLayoutProvider', 1083);
Ycb(377, 148, {
    3: 1,
    411: 1,
    377: 1,
    102: 1,
    148: 1
}, Nnd, Ond);
_.ag = function Rnd(b) {
    var c, d, e, f, g, h, i, j, k;
    if (!b) return;
    try {
        j = mgb(b, ';,;');
        for(g = j, h = 0, i = g.length; h < i; ++h){
            f = g[h];
            d = mgb(f, '\\:');
            e = Kad(Nad(), d[0]);
            if (!e) throw scb(new Teb('Invalid option id: ' + d[0]));
            k = Obd(e, d[1]);
            if (k == null) throw scb(new Teb('Invalid option value: ' + d[1]));
            k == null ? (!this.q && (this.q = new Irb), Sib(this.q, e)) : (!this.q && (this.q = new Irb), Qib(this.q, e, k));
        }
    } catch (a) {
        a = rcb(a);
        if (RD(a, 103)) {
            c = a;
            throw scb(new Ueb(c));
        } else throw scb(a);
    }
};
_.Ib = function Snd() {
    var a;
    a = OD(yBb(FBb((!this.q ? (pnb(), pnb(), nnb) : this.q).vc().Mc(), new Tnd), gAb(new DAb, new BAb, new tAb, new vAb, WC(OC(HL, 1), Ere, 131, 0, []))));
    return a;
};
var d3 = jeb(cze, 'IndividualSpacings', 377);
Ycb(959, 1, {}, Tnd);
_.Kb = function Und(a) {
    return Qnd(JD(a, 43));
};
var c3 = jeb(cze, 'IndividualSpacings/lambda$0$Type', 959);
Ycb(702, 1, {}, Xnd);
_.c = 0;
var e3 = jeb(cze, 'InstancePool', 702);
Ycb(1781, 1, {}, Ynd);
var g3 = jeb(cze, 'LoggedGraph', 1781);
Ycb(404, 23, {
    3: 1,
    34: 1,
    23: 1,
    404: 1
}, cod);
var Znd, $nd, _nd, aod;
var f3 = keb(cze, 'LoggedGraph/Type', 404, MI, eod, dod);
var fod;
Ycb(1038, 1, {
    847: 1
}, hod);
_.Sg = function iod(a, b) {
    return false;
};
_.Tg = function jod() {};
_.Ug = function kod() {
    return 0;
};
_.Vg = function lod() {
    return null;
};
_.Wg = function mod() {
    return null;
};
_.Xg = function nod() {
    return null;
};
_.Yg = function ood() {
    return false;
};
_.Zg = function pod() {
    return false;
};
_.$g = function qod() {
    return false;
};
_._g = function rod(a) {};
_.ah = function sod(a, b) {};
_.bh = function tod(a) {
    return this;
};
_.dh = function uod(a) {};
var h3 = jeb(cze, 'NullElkProgressMonitor', 1038);
Ycb(47, 1, {
    20: 1,
    47: 1
}, xod);
_.Ic = function zod(a) {
    ofb(this, a);
};
_.Fb = function yod(a) {
    var b, c, d;
    if (RD(a, 47)) {
        c = JD(a, 47);
        b = this.a == null ? c.a == null : pb(this.a, c.a);
        d = this.b == null ? c.b == null : pb(this.b, c.b);
        return b && d;
    } else return false;
};
_.Hb = function Aod() {
    var a, b, c, d, e, f;
    c = this.a == null ? 0 : tb(this.a);
    a = c & Wre;
    b = c & -65536;
    f = this.b == null ? 0 : tb(this.b);
    d = f & Wre;
    e = f & -65536;
    return a ^ e >> 16 & Wre | b ^ d << 16;
};
_.Jc = function Bod() {
    return new Dod(this);
};
_.Ib = function Cod() {
    return this.a == null && this.b == null ? 'pair(null,null)' : this.a == null ? 'pair(null,' + adb(this.b) + ')' : this.b == null ? 'pair(' + adb(this.a) + ',null)' : 'pair(' + adb(this.a) + ',' + adb(this.b) + ')';
};
var j3 = jeb(cze, 'Pair', 47);
Ycb(972, 1, Wqe, Dod);
_.Nb = function Eod(a) {
    Osb(this, a);
};
_.Ob = function Fod() {
    return !this.c && (!this.b && this.a.a != null || this.a.b != null);
};
_.Pb = function God() {
    if (!this.c && !this.b && this.a.a != null) {
        this.b = true;
        return this.a.a;
    } else if (!this.c && this.a.b != null) {
        this.c = true;
        return this.a.b;
    }
    throw scb(new qub);
};
_.Qb = function Hod() {
    this.c && this.a.b != null ? this.a.b = null : this.b && this.a.a != null && (this.a.a = null);
    throw scb(new Veb);
};
_.b = false;
_.c = false;
var i3 = jeb(cze, 'Pair/1', 972);
Ycb(1073, 222, tue, Kod);
_.kf = function Lod(a, b) {
    var c, d, e, f, g;
    b.Sg('Random Layout', 1);
    if ((!a.a && (a.a = new X0d(A3, a, 10, 11)), a.a).i == 0) {
        b.Tg();
        return;
    }
    f = JD(ksd(a, (ekd(), ckd)), 17);
    !!f && f.a != 0 ? e = new Dvb(f.a) : e = new Cvb;
    c = Deb(MD(ksd(a, _jd)));
    g = Deb(MD(ksd(a, dkd)));
    d = JD(ksd(a, akd), 107);
    Jod(a, e, c, g, d);
    b.Tg();
};
var k3 = jeb(cze, 'RandomLayoutProvider', 1073);
Ycb(239, 1, {
    239: 1
}, Mod);
_.Fb = function Nod(a) {
    return tub(this.a, JD(a, 239).a) && tub(this.b, JD(a, 239).b) && tub(this.c, JD(a, 239).c);
};
_.Hb = function Ood() {
    return Kmb(WC(OC(aJ, 1), Nqe, 1, 5, [
        this.a,
        this.b,
        this.c
    ]));
};
_.Ib = function Pod() {
    return '(' + this.a + Lqe + this.b + Lqe + this.c + ')';
};
var l3 = jeb(cze, 'Triple', 239);
var Qod;
Ycb(547, 1, {});
_.Jf = function Uod() {
    return new Edd(this.f.i, this.f.j);
};
_.mf = function Vod(a) {
    if (IBd(a, (Lgd(), Xfd))) return ksd(this.f, Sod);
    return ksd(this.f, a);
};
_.Kf = function Wod() {
    return new Edd(this.f.g, this.f.f);
};
_.Lf = function Xod() {
    return this.g;
};
_.nf = function Yod(a) {
    return lsd(this.f, a);
};
_.Mf = function Zod(a) {
    htd(this.f, a.a);
    itd(this.f, a.b);
};
_.Nf = function $od(a) {
    gtd(this.f, a.a);
    etd(this.f, a.b);
};
_.Of = function _od(a) {
    this.g = a;
};
_.g = 0;
var Sod;
var m3 = jeb(vCe, 'ElkGraphAdapters/AbstractElkGraphElementAdapter', 547);
Ycb(548, 1, {
    832: 1
}, apd);
_.Pf = function bpd() {
    var a, b;
    if (!this.b) {
        this.b = bv(Osd(this.a).i);
        for(b = new CHd(Osd(this.a)); b.e != b.i.gc();){
            a = JD(AHd(b), 153);
            Ilb(this.b, new fpd(a));
        }
    }
    return this.b;
};
_.b = null;
var n3 = jeb(vCe, 'ElkGraphAdapters/ElkEdgeAdapter', 548);
Ycb(287, 547, {}, dpd);
_.Qf = function epd() {
    return cpd(this);
};
_.a = null;
var o3 = jeb(vCe, 'ElkGraphAdapters/ElkGraphAdapter', 287);
Ycb(625, 547, {
    187: 1
}, fpd);
var p3 = jeb(vCe, 'ElkGraphAdapters/ElkLabelAdapter', 625);
Ycb(624, 547, {
    680: 1
}, jpd);
_.Pf = function mpd() {
    return gpd(this);
};
_.Tf = function npd() {
    var a;
    return a = JD(ksd(this.f, (Lgd(), vfd)), 139), !a && (a = new ZXb), a;
};
_.Vf = function ppd() {
    return hpd(this);
};
_.Xf = function rpd(a) {
    var b;
    b = new aYb(a);
    msd(this.f, (Lgd(), vfd), b);
};
_.Yf = function spd(a) {
    msd(this.f, (Lgd(), Kfd), new NYb(a));
};
_.Rf = function kpd() {
    return this.d;
};
_.Sf = function lpd() {
    var a, b;
    if (!this.a) {
        this.a = new Ulb;
        for(b = new es(Ir(ZBd(JD(this.f, 27)).a.Jc(), new er)); cs(b);){
            a = JD(ds(b), 85);
            Ilb(this.a, new apd(a));
        }
    }
    return this.a;
};
_.Uf = function opd() {
    var a, b;
    if (!this.c) {
        this.c = new Ulb;
        for(b = new es(Ir($Bd(JD(this.f, 27)).a.Jc(), new er)); cs(b);){
            a = JD(ds(b), 85);
            Ilb(this.c, new apd(a));
        }
    }
    return this.c;
};
_.Wf = function qpd() {
    return Xwd(JD(this.f, 27)).i != 0 || ydb(LD(JD(this.f, 27).mf((Lgd(), lfd))));
};
_.Zf = function tpd() {
    ipd(this, (Rod(), Qod));
};
_.a = null;
_.b = null;
_.c = null;
_.d = null;
_.e = null;
var q3 = jeb(vCe, 'ElkGraphAdapters/ElkNodeAdapter', 624);
Ycb(1244, 547, {
    831: 1
}, vpd);
_.Pf = function xpd() {
    return upd(this);
};
_.Sf = function wpd() {
    var a, b;
    if (!this.a) {
        this.a = av(JD(this.f, 124).fh().i);
        for(b = new CHd(JD(this.f, 124).fh()); b.e != b.i.gc();){
            a = JD(AHd(b), 85);
            Ilb(this.a, new apd(a));
        }
    }
    return this.a;
};
_.Uf = function ypd() {
    var a, b;
    if (!this.c) {
        this.c = av(JD(this.f, 124).gh().i);
        for(b = new CHd(JD(this.f, 124).gh()); b.e != b.i.gc();){
            a = JD(AHd(b), 85);
            Ilb(this.c, new apd(a));
        }
    }
    return this.c;
};
_.$f = function zpd() {
    return JD(JD(this.f, 124).mf((Lgd(), dgd)), 64);
};
_._f = function Apd() {
    var a, b, c, d, e, f, g, h;
    d = oxd(JD(this.f, 124));
    for(c = new CHd(JD(this.f, 124).gh()); c.e != c.i.gc();){
        a = JD(AHd(c), 85);
        for(h = new CHd((!a.c && (a.c = new ree(v3, a, 5, 8)), a.c)); h.e != h.i.gc();){
            g = JD(AHd(h), 84);
            if (kCd(_Bd(g), d)) return true;
            else if (_Bd(g) == d && ydb(LD(ksd(a, (Lgd(), mfd))))) return true;
        }
    }
    for(b = new CHd(JD(this.f, 124).fh()); b.e != b.i.gc();){
        a = JD(AHd(b), 85);
        for(f = new CHd((!a.b && (a.b = new ree(v3, a, 4, 7)), a.b)); f.e != f.i.gc();){
            e = JD(AHd(f), 84);
            if (kCd(_Bd(e), d)) return true;
        }
    }
    return false;
};
_.a = null;
_.b = null;
_.c = null;
var r3 = jeb(vCe, 'ElkGraphAdapters/ElkPortAdapter', 1244);
Ycb(1245, 1, Bte, Cpd);
_.Le = function Dpd(a, b) {
    return Bpd(JD(a, 124), JD(b, 124));
};
_.Fb = function Epd(a) {
    return this === a;
};
_.Me = function Fpd() {
    return new uqb(this);
};
var s3 = jeb(vCe, 'ElkGraphAdapters/PortComparator', 1245);
var j6 = leb(wCe, 'EObject');
var t3 = leb(xCe, yCe);
var u3 = leb(xCe, zCe);
var y3 = leb(xCe, ACe);
var C3 = leb(xCe, 'ElkShape');
var v3 = leb(xCe, BCe);
var x3 = leb(xCe, CCe);
var w3 = leb(xCe, DCe);
var h6 = leb(wCe, ECe);
var f6 = leb(wCe, 'EFactory');
var Gpd;
var i6 = leb(wCe, FCe);
var l6 = leb(wCe, 'EPackage');
var Ipd;
var Kpd, Lpd, Mpd, Npd, Opd, Ppd, Qpd, Rpd, Spd, Tpd, Upd;
var z3 = leb(xCe, GCe);
var A3 = leb(xCe, HCe);
var B3 = leb(xCe, ICe);
Ycb(92, 1, JCe);
_.ph = function Xpd() {
    this.qh();
    return null;
};
_.qh = function Ypd() {
    return null;
};
_.rh = function Zpd() {
    return this.qh(), false;
};
_.sh = function $pd() {
    return false;
};
_.th = function _pd(a) {
    Wpd(this, a);
};
var $4 = jeb(KCe, 'BasicNotifierImpl', 92);
Ycb(98, 92, SCe);
_.Uh = function hrd() {
    return qqd(this);
};
_.uh = function Hqd(a, b) {
    return a;
};
_.vh = function Iqd() {
    throw scb(new ahb);
};
_.wh = function Jqd(a) {
    var b;
    return b = s1d(JD(QTd(this.zh(), this.Bh()), 19)), this.Lh().Ph(this, b.n, b.f, a);
};
_.xh = function Kqd(a, b) {
    throw scb(new ahb);
};
_.yh = function Lqd(a, b, c) {
    return bqd(this, a, b, c);
};
_.zh = function Mqd() {
    var a;
    if (this.vh()) {
        a = this.vh().Kk();
        if (a) return a;
    }
    return this.ei();
};
_.Ah = function Nqd() {
    return cqd(this);
};
_.Bh = function Oqd() {
    throw scb(new ahb);
};
_.Ch = function Qqd() {
    var a, b;
    b = this.Wh().Lk();
    !b && this.vh().Qk(b = (g$d(), a = iWd(MTd(this.zh())), a == null ? f$d : new j$d(this, a)));
    return b;
};
_.Dh = function Sqd(a, b) {
    return a;
};
_.Eh = function Tqd(a) {
    var b;
    b = a.mk();
    return !b ? WTd(this.zh(), a) : a.Ij();
};
_.Fh = function Uqd() {
    var a;
    a = this.vh();
    return !a ? null : a.Nk();
};
_.Gh = function Vqd() {
    return !this.vh() ? null : this.vh().Kk();
};
_.Hh = function Wqd(a, b, c) {
    return hqd(this, a, b, c);
};
_.Ih = function Xqd(a) {
    return iqd(this, a);
};
_.Jh = function Yqd(a, b) {
    return jqd(this, a, b);
};
_.Kh = function Zqd() {
    var a;
    a = this.vh();
    return !!a && a.Ok();
};
_.Lh = function $qd() {
    throw scb(new ahb);
};
_.Mh = function _qd() {
    return lqd(this);
};
_.Nh = function ard(a, b, c, d) {
    return mqd(this, a, b, d);
};
_.Oh = function brd(a, b, c) {
    var d;
    return d = JD(QTd(this.zh(), b), 69), d.tk().wk(this, this.di(), b - this.fi(), a, c);
};
_.Ph = function crd(a, b, c, d) {
    return nqd(this, a, b, d);
};
_.Qh = function drd(a, b, c) {
    var d;
    return d = JD(QTd(this.zh(), b), 69), d.tk().xk(this, this.di(), b - this.fi(), a, c);
};
_.Rh = function erd() {
    return !!this.vh() && !!this.vh().Mk();
};
_.Sh = function frd(a) {
    return oqd(this, a);
};
_.Th = function grd(a) {
    return pqd(this, a);
};
_.Vh = function ird(a) {
    return tqd(this, a);
};
_.Wh = function jrd() {
    throw scb(new ahb);
};
_.Xh = function krd() {
    return !this.vh() ? null : this.vh().Mk();
};
_.Yh = function lrd() {
    return lqd(this);
};
_.Zh = function mrd(a, b) {
    Aqd(this, a, b);
};
_.$h = function nrd(a) {
    this.Wh().Pk(a);
};
_._h = function ord(a) {
    this.Wh().Sk(a);
};
_.ai = function prd(a) {
    this.Wh().Rk(a);
};
_.bi = function qrd(a, b) {
    var c, d, e, f;
    f = this.Fh();
    if (!!f && !!a) {
        b = QGd(f.Bl(), this, b);
        f.Fl(this);
    }
    d = this.Lh();
    if (d) {
        if ((Pqd(this, this.Lh(), this.Bh()).Bb & Pse) != 0) {
            e = d.Mh();
            !!e && (!a ? e.El(this) : !f && e.Fl(this));
        } else {
            b = (c = this.Bh(), c >= 0 ? this.wh(b) : this.Lh().Ph(this, -1 - c, null, b));
            b = this.yh(null, -1, b);
        }
    }
    this._h(a);
    return b;
};
_.ci = function rrd(a) {
    var b, c, d, e, f, g, h, i;
    c = this.zh();
    f = WTd(c, a);
    b = this.fi();
    if (f >= b) return JD(a, 69).tk().Ak(this, this.di(), f - b);
    else if (f <= -1) {
        g = Z9d((Gfe(), Efe), c, a);
        if (g) {
            Ife();
            JD(g, 69).uk() || (g = Uae(jae(Efe, g)));
            e = (d = this.Eh(g), JD(d >= 0 ? this.Hh(d, true, true) : uqd(this, g, true), 159));
            i = g.Fk();
            if (i > 1 || i == -1) return JD(JD(e, 218).Pl(a, false), 76);
        } else throw scb(new Teb(LCe + a.ve() + OCe));
    } else if (a.Gk()) return d = this.Eh(a), JD(d >= 0 ? this.Hh(d, false, true) : uqd(this, a, false), 76);
    h = new gPd(this, a);
    return h;
};
_.di = function srd() {
    return Cqd(this);
};
_.ei = function trd() {
    return (GOd(), FOd).S;
};
_.fi = function urd() {
    return VTd(this.ei());
};
_.gi = function vrd(a) {
    Eqd(this, a);
};
_.Ib = function wrd() {
    return Gqd(this);
};
var y6 = jeb(TCe, 'BasicEObjectImpl', 98);
var sOd;
Ycb(117, 98, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1
});
_.hi = function Frd(a) {
    var b;
    b = zrd(this);
    return b[a];
};
_.ii = function Grd(a, b) {
    var c;
    c = zrd(this);
    VC(c, a, b);
};
_.ji = function Hrd(a) {
    var b;
    b = zrd(this);
    VC(b, a, null);
};
_.ph = function Ird() {
    return JD(Crd(this, 4), 128);
};
_.qh = function Jrd() {
    throw scb(new ahb);
};
_.rh = function Krd() {
    return (this.Db & 4) != 0;
};
_.vh = function Lrd() {
    throw scb(new ahb);
};
_.ki = function Mrd(a) {
    Erd(this, 2, a);
};
_.xh = function Nrd(a, b) {
    this.Db = b << 16 | this.Db & 255;
    this.ki(a);
};
_.zh = function Ord() {
    return yrd(this);
};
_.Bh = function Prd() {
    return this.Db >> 16;
};
_.Ch = function Qrd() {
    var a, b;
    return g$d(), b = iWd(MTd((a = JD(Crd(this, 16), 29), !a ? this.ei() : a))), b == null ? f$d : new j$d(this, b);
};
_.sh = function Rrd() {
    return (this.Db & 1) == 0;
};
_.Fh = function Srd() {
    return JD(Crd(this, 128), 1980);
};
_.Gh = function Trd() {
    return JD(Crd(this, 16), 29);
};
_.Kh = function Urd() {
    return (this.Db & 32) != 0;
};
_.Lh = function Vrd() {
    return JD(Crd(this, 2), 52);
};
_.Rh = function Wrd() {
    return (this.Db & 64) != 0;
};
_.Wh = function Xrd() {
    throw scb(new ahb);
};
_.Xh = function Yrd() {
    return JD(Crd(this, 64), 286);
};
_.$h = function Zrd(a) {
    Erd(this, 16, a);
};
_._h = function $rd(a) {
    Erd(this, 128, a);
};
_.ai = function _rd(a) {
    Erd(this, 64, a);
};
_.di = function asd() {
    return Ard(this);
};
_.Db = 0;
var p9 = jeb(TCe, 'MinimalEObjectImpl', 117);
Ycb(118, 117, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.ki = function bsd(a) {
    this.Cb = a;
};
_.Lh = function csd() {
    return this.Cb;
};
var o9 = jeb(TCe, 'MinimalEObjectImpl/Container', 118);
Ycb(2029, 118, {
    109: 1,
    338: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.Hh = function nsd(a, b, c) {
    return esd(this, a, b, c);
};
_.Qh = function osd(a, b, c) {
    return fsd(this, a, b, c);
};
_.Sh = function psd(a) {
    return gsd(this, a);
};
_.Zh = function qsd(a, b) {
    hsd(this, a, b);
};
_.ei = function rsd() {
    return Vpd(), Upd;
};
_.gi = function ssd(a) {
    isd(this, a);
};
_.lf = function tsd() {
    return jsd(this);
};
_.eh = function usd() {
    return !this.o && (this.o = new YQd((Vpd(), Spd), O3, this, 0)), this.o;
};
_.mf = function vsd(a) {
    return ksd(this, a);
};
_.nf = function wsd(a) {
    return lsd(this, a);
};
_.of = function xsd(a, b) {
    return msd(this, a, b);
};
var D3 = jeb(UCe, 'EMapPropertyHolderImpl', 2029);
Ycb(555, 118, {
    109: 1,
    369: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, Bsd);
_.Hh = function Csd(a, b, c) {
    switch(a){
        case 0:
            return this.a;
        case 1:
            return this.b;
    }
    return hqd(this, a, b, c);
};
_.Sh = function Dsd(a) {
    switch(a){
        case 0:
            return this.a != 0;
        case 1:
            return this.b != 0;
    }
    return oqd(this, a);
};
_.Zh = function Esd(a, b) {
    switch(a){
        case 0:
            zsd(this, Beb(MD(b)));
            return;
        case 1:
            Asd(this, Beb(MD(b)));
            return;
    }
    Aqd(this, a, b);
};
_.ei = function Fsd() {
    return Vpd(), Kpd;
};
_.gi = function Gsd(a) {
    switch(a){
        case 0:
            zsd(this, 0);
            return;
        case 1:
            Asd(this, 0);
            return;
    }
    Eqd(this, a);
};
_.Ib = function Hsd() {
    var a;
    if ((this.Db & 64) != 0) return Gqd(this);
    a = new Jgb(Gqd(this));
    a.a += ' (x: ';
    Bgb(a, this.a);
    a.a += ', y: ';
    Bgb(a, this.b);
    a.a += ')';
    return a.a;
};
_.a = 0;
_.b = 0;
var E3 = jeb(UCe, 'ElkBendPointImpl', 555);
Ycb(722, 2029, {
    109: 1,
    338: 1,
    173: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.Hh = function Rsd(a, b, c) {
    return Isd(this, a, b, c);
};
_.Oh = function Ssd(a, b, c) {
    return Jsd(this, a, b, c);
};
_.Qh = function Tsd(a, b, c) {
    return Ksd(this, a, b, c);
};
_.Sh = function Usd(a) {
    return Lsd(this, a);
};
_.Zh = function Vsd(a, b) {
    Msd(this, a, b);
};
_.ei = function Wsd() {
    return Vpd(), Opd;
};
_.gi = function Xsd(a) {
    Nsd(this, a);
};
_.hh = function Ysd() {
    return this.k;
};
_.ih = function Zsd() {
    return Osd(this);
};
_.Ib = function $sd() {
    return Qsd(this);
};
_.k = null;
var I3 = jeb(UCe, 'ElkGraphElementImpl', 722);
Ycb(723, 722, {
    109: 1,
    338: 1,
    173: 1,
    273: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.Hh = function ktd(a, b, c) {
    return _sd(this, a, b, c);
};
_.Sh = function ltd(a) {
    return atd(this, a);
};
_.Zh = function mtd(a, b) {
    btd(this, a, b);
};
_.ei = function ntd() {
    return Vpd(), Tpd;
};
_.gi = function otd(a) {
    ctd(this, a);
};
_.jh = function ptd() {
    return this.f;
};
_.kh = function qtd() {
    return this.g;
};
_.lh = function rtd() {
    return this.i;
};
_.mh = function std() {
    return this.j;
};
_.nh = function ttd(a, b) {
    dtd(this, a, b);
};
_.oh = function utd(a, b) {
    ftd(this, a, b);
};
_.Ib = function vtd() {
    return jtd(this);
};
_.f = 0;
_.g = 0;
_.i = 0;
_.j = 0;
var P3 = jeb(UCe, 'ElkShapeImpl', 723);
Ycb(724, 723, {
    109: 1,
    338: 1,
    84: 1,
    173: 1,
    273: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.Hh = function Dtd(a, b, c) {
    return wtd(this, a, b, c);
};
_.Oh = function Etd(a, b, c) {
    return xtd(this, a, b, c);
};
_.Qh = function Ftd(a, b, c) {
    return ytd(this, a, b, c);
};
_.Sh = function Gtd(a) {
    return ztd(this, a);
};
_.Zh = function Htd(a, b) {
    Atd(this, a, b);
};
_.ei = function Itd() {
    return Vpd(), Lpd;
};
_.gi = function Jtd(a) {
    Btd(this, a);
};
_.fh = function Ktd() {
    return !this.d && (this.d = new ree(x3, this, 8, 5)), this.d;
};
_.gh = function Ltd() {
    return !this.e && (this.e = new ree(x3, this, 7, 4)), this.e;
};
var F3 = jeb(UCe, 'ElkConnectableShapeImpl', 724);
Ycb(268, 722, {
    109: 1,
    338: 1,
    85: 1,
    173: 1,
    268: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, Vtd);
_.wh = function Wtd(a) {
    return Ntd(this, a);
};
_.Hh = function Xtd(a, b, c) {
    switch(a){
        case 3:
            return Otd(this);
        case 4:
            return !this.b && (this.b = new ree(v3, this, 4, 7)), this.b;
        case 5:
            return !this.c && (this.c = new ree(v3, this, 5, 8)), this.c;
        case 6:
            return !this.a && (this.a = new X0d(w3, this, 6, 6)), this.a;
        case 7:
            return xdb(), !this.b && (this.b = new ree(v3, this, 4, 7)), this.b.i <= 1 && (!this.c && (this.c = new ree(v3, this, 5, 8)), this.c.i <= 1) ? false : true;
        case 8:
            return xdb(), Rtd(this) ? true : false;
        case 9:
            return xdb(), Std(this) ? true : false;
        case 10:
            return xdb(), !this.b && (this.b = new ree(v3, this, 4, 7)), this.b.i != 0 && (!this.c && (this.c = new ree(v3, this, 5, 8)), this.c.i != 0) ? true : false;
    }
    return Isd(this, a, b, c);
};
_.Oh = function Ytd(a, b, c) {
    var d;
    switch(b){
        case 3:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? Ntd(this, c) : this.Cb.Ph(this, -1 - d, null, c)));
            return Mtd(this, JD(a, 27), c);
        case 4:
            return !this.b && (this.b = new ree(v3, this, 4, 7)), PGd(this.b, a, c);
        case 5:
            return !this.c && (this.c = new ree(v3, this, 5, 8)), PGd(this.c, a, c);
        case 6:
            return !this.a && (this.a = new X0d(w3, this, 6, 6)), PGd(this.a, a, c);
    }
    return Jsd(this, a, b, c);
};
_.Qh = function Ztd(a, b, c) {
    switch(b){
        case 3:
            return Mtd(this, null, c);
        case 4:
            return !this.b && (this.b = new ree(v3, this, 4, 7)), QGd(this.b, a, c);
        case 5:
            return !this.c && (this.c = new ree(v3, this, 5, 8)), QGd(this.c, a, c);
        case 6:
            return !this.a && (this.a = new X0d(w3, this, 6, 6)), QGd(this.a, a, c);
    }
    return Ksd(this, a, b, c);
};
_.Sh = function $td(a) {
    switch(a){
        case 3:
            return !!Otd(this);
        case 4:
            return !!this.b && this.b.i != 0;
        case 5:
            return !!this.c && this.c.i != 0;
        case 6:
            return !!this.a && this.a.i != 0;
        case 7:
            return !this.b && (this.b = new ree(v3, this, 4, 7)), !(this.b.i <= 1 && (!this.c && (this.c = new ree(v3, this, 5, 8)), this.c.i <= 1));
        case 8:
            return Rtd(this);
        case 9:
            return Std(this);
        case 10:
            return !this.b && (this.b = new ree(v3, this, 4, 7)), this.b.i != 0 && (!this.c && (this.c = new ree(v3, this, 5, 8)), this.c.i != 0);
    }
    return Lsd(this, a);
};
_.Zh = function _td(a, b) {
    switch(a){
        case 3:
            Ttd(this, JD(b, 27));
            return;
        case 4:
            !this.b && (this.b = new ree(v3, this, 4, 7));
            RGd(this.b);
            !this.b && (this.b = new ree(v3, this, 4, 7));
            vCd(this.b, JD(b, 16));
            return;
        case 5:
            !this.c && (this.c = new ree(v3, this, 5, 8));
            RGd(this.c);
            !this.c && (this.c = new ree(v3, this, 5, 8));
            vCd(this.c, JD(b, 16));
            return;
        case 6:
            !this.a && (this.a = new X0d(w3, this, 6, 6));
            RGd(this.a);
            !this.a && (this.a = new X0d(w3, this, 6, 6));
            vCd(this.a, JD(b, 16));
            return;
    }
    Msd(this, a, b);
};
_.ei = function aud() {
    return Vpd(), Mpd;
};
_.gi = function bud(a) {
    switch(a){
        case 3:
            Ttd(this, null);
            return;
        case 4:
            !this.b && (this.b = new ree(v3, this, 4, 7));
            RGd(this.b);
            return;
        case 5:
            !this.c && (this.c = new ree(v3, this, 5, 8));
            RGd(this.c);
            return;
        case 6:
            !this.a && (this.a = new X0d(w3, this, 6, 6));
            RGd(this.a);
            return;
    }
    Nsd(this, a);
};
_.Ib = function cud() {
    return Utd(this);
};
var G3 = jeb(UCe, 'ElkEdgeImpl', 268);
Ycb(440, 2029, {
    109: 1,
    338: 1,
    168: 1,
    440: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, tud);
_.wh = function uud(a) {
    return eud(this, a);
};
_.Hh = function vud(a, b, c) {
    switch(a){
        case 1:
            return this.j;
        case 2:
            return this.k;
        case 3:
            return this.b;
        case 4:
            return this.c;
        case 5:
            return !this.a && (this.a = new qVd(u3, this, 5)), this.a;
        case 6:
            return hud(this);
        case 7:
            if (b) return gud(this);
            return this.i;
        case 8:
            if (b) return fud(this);
            return this.f;
        case 9:
            return !this.g && (this.g = new ree(w3, this, 9, 10)), this.g;
        case 10:
            return !this.e && (this.e = new ree(w3, this, 10, 9)), this.e;
        case 11:
            return this.d;
    }
    return esd(this, a, b, c);
};
_.Oh = function wud(a, b, c) {
    var d, e, f;
    switch(b){
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? eud(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return dud(this, JD(a, 85), c);
        case 9:
            return !this.g && (this.g = new ree(w3, this, 9, 10)), PGd(this.g, a, c);
        case 10:
            return !this.e && (this.e = new ree(w3, this, 10, 9)), PGd(this.e, a, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (Vpd(), Npd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((Vpd(), Npd)), a, c);
};
_.Qh = function xud(a, b, c) {
    switch(b){
        case 5:
            return !this.a && (this.a = new qVd(u3, this, 5)), QGd(this.a, a, c);
        case 6:
            return dud(this, null, c);
        case 9:
            return !this.g && (this.g = new ree(w3, this, 9, 10)), QGd(this.g, a, c);
        case 10:
            return !this.e && (this.e = new ree(w3, this, 10, 9)), QGd(this.e, a, c);
    }
    return fsd(this, a, b, c);
};
_.Sh = function yud(a) {
    switch(a){
        case 1:
            return this.j != 0;
        case 2:
            return this.k != 0;
        case 3:
            return this.b != 0;
        case 4:
            return this.c != 0;
        case 5:
            return !!this.a && this.a.i != 0;
        case 6:
            return !!hud(this);
        case 7:
            return !!this.i;
        case 8:
            return !!this.f;
        case 9:
            return !!this.g && this.g.i != 0;
        case 10:
            return !!this.e && this.e.i != 0;
        case 11:
            return this.d != null;
    }
    return gsd(this, a);
};
_.Zh = function zud(a, b) {
    switch(a){
        case 1:
            qud(this, Beb(MD(b)));
            return;
        case 2:
            rud(this, Beb(MD(b)));
            return;
        case 3:
            jud(this, Beb(MD(b)));
            return;
        case 4:
            kud(this, Beb(MD(b)));
            return;
        case 5:
            !this.a && (this.a = new qVd(u3, this, 5));
            RGd(this.a);
            !this.a && (this.a = new qVd(u3, this, 5));
            vCd(this.a, JD(b, 16));
            return;
        case 6:
            oud(this, JD(b, 85));
            return;
        case 7:
            nud(this, JD(b, 84));
            return;
        case 8:
            mud(this, JD(b, 84));
            return;
        case 9:
            !this.g && (this.g = new ree(w3, this, 9, 10));
            RGd(this.g);
            !this.g && (this.g = new ree(w3, this, 9, 10));
            vCd(this.g, JD(b, 16));
            return;
        case 10:
            !this.e && (this.e = new ree(w3, this, 10, 9));
            RGd(this.e);
            !this.e && (this.e = new ree(w3, this, 10, 9));
            vCd(this.e, JD(b, 16));
            return;
        case 11:
            lud(this, OD(b));
            return;
    }
    hsd(this, a, b);
};
_.ei = function Aud() {
    return Vpd(), Npd;
};
_.gi = function Bud(a) {
    switch(a){
        case 1:
            qud(this, 0);
            return;
        case 2:
            rud(this, 0);
            return;
        case 3:
            jud(this, 0);
            return;
        case 4:
            kud(this, 0);
            return;
        case 5:
            !this.a && (this.a = new qVd(u3, this, 5));
            RGd(this.a);
            return;
        case 6:
            oud(this, null);
            return;
        case 7:
            nud(this, null);
            return;
        case 8:
            mud(this, null);
            return;
        case 9:
            !this.g && (this.g = new ree(w3, this, 9, 10));
            RGd(this.g);
            return;
        case 10:
            !this.e && (this.e = new ree(w3, this, 10, 9));
            RGd(this.e);
            return;
        case 11:
            lud(this, null);
            return;
    }
    isd(this, a);
};
_.Ib = function Cud() {
    return sud(this);
};
_.b = 0;
_.c = 0;
_.d = null;
_.j = 0;
_.k = 0;
var H3 = jeb(UCe, 'ElkEdgeSectionImpl', 440);
Ycb(157, 118, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
});
_.Hh = function Gud(a, b, c) {
    var d;
    if (a == 0) return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
    return dqd(this, a - VTd(this.ei()), QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), a), b, c);
};
_.Oh = function Hud(a, b, c) {
    var d, e;
    if (b == 0) return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), e.tk().wk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Qh = function Iud(a, b, c) {
    var d, e;
    if (b == 0) return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), e.tk().xk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Sh = function Jud(a) {
    var b;
    if (a == 0) return !!this.Ab && this.Ab.i != 0;
    return eqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.Vh = function Kud(a) {
    return Dud(this, a);
};
_.Zh = function Lud(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((c = JD(Crd(this, 16), 29), !c ? this.ei() : c), a), b);
};
_._h = function Mud(a) {
    Erd(this, 128, a);
};
_.ei = function Nud() {
    return cPd(), SOd;
};
_.gi = function Oud(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.li = function Pud() {
    this.Bb |= 1;
};
_.mi = function Qud(a) {
    return Fud(this, a);
};
_.Bb = 0;
var c7 = jeb(TCe, 'EModelElementImpl', 157);
Ycb(704, 157, {
    109: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
}, avd);
_.ni = function bvd(a, b) {
    return Xud(this, a, b);
};
_.oi = function cvd(a) {
    var b, c, d, e, f;
    if (this.a != WSd(a) || (a.Bb & 256) != 0) throw scb(new Teb($Ce + a.zb + XCe));
    for(d = UTd(a); OTd(d.a).i != 0;){
        c = JD(gXd(d, 0, (b = JD(nDd(OTd(d.a), 0), 87), f = b.c, RD(f, 88) ? JD(f, 29) : (cPd(), UOd))), 29);
        if (YSd(c)) {
            e = WSd(c).si().oi(c);
            JD(e, 52).$h(a);
            return e;
        }
        d = UTd(c);
    }
    return (a.D != null ? a.D : a.B) == 'java.util.Map$Entry' ? new eQd(a) : new UPd(a);
};
_.pi = function dvd(a, b) {
    return Yud(this, a, b);
};
_.Hh = function evd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.a;
    }
    return dqd(this, a - VTd((cPd(), POd)), QTd((d = JD(Crd(this, 16), 29), !d ? POd : d), a), b, c);
};
_.Oh = function fvd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 1:
            !!this.a && (c = JD(this.a, 52).Ph(this, 4, l6, c));
            return Vud(this, JD(a, 240), c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), POd) : d), b), 69), e.tk().wk(this, Ard(this), b - VTd((cPd(), POd)), a, c);
};
_.Qh = function gvd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 1:
            return Vud(this, null, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), POd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), POd)), a, c);
};
_.Sh = function hvd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return !!this.a;
    }
    return eqd(this, a - VTd((cPd(), POd)), QTd((b = JD(Crd(this, 16), 29), !b ? POd : b), a));
};
_.Zh = function ivd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            $ud(this, JD(b, 240));
            return;
    }
    fqd(this, a - VTd((cPd(), POd)), QTd((c = JD(Crd(this, 16), 29), !c ? POd : c), a), b);
};
_.ei = function jvd() {
    return cPd(), POd;
};
_.gi = function kvd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            $ud(this, null);
            return;
    }
    gqd(this, a - VTd((cPd(), POd)), QTd((b = JD(Crd(this, 16), 29), !b ? POd : b), a));
};
var Rud, Sud, Tud;
var a7 = jeb(TCe, 'EFactoryImpl', 704);
Ycb(1012, 704, {
    109: 1,
    2059: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
}, mvd);
_.ni = function nvd(a, b) {
    switch(a.ek()){
        case 12:
            return JD(b, 144).Ng();
        case 13:
            return adb(b);
        default:
            throw scb(new Teb(WCe + a.ve() + XCe));
    }
};
_.oi = function ovd(a) {
    var b, c, d, e, f, g, h, i;
    switch(a.G == -1 && (a.G = (b = WSd(a), b ? AUd(b.ri(), a) : -1)), a.G){
        case 4:
            return f = new Lwd, f;
        case 6:
            return g = new cxd, g;
        case 7:
            return h = new rxd, h;
        case 8:
            return d = new Vtd, d;
        case 9:
            return c = new Bsd, c;
        case 10:
            return e = new tud, e;
        case 11:
            return i = new Dxd, i;
        default:
            throw scb(new Teb($Ce + a.zb + XCe));
    }
};
_.pi = function pvd(a, b) {
    switch(a.ek()){
        case 13:
        case 12:
            return null;
        default:
            throw scb(new Teb(WCe + a.ve() + XCe));
    }
};
var J3 = jeb(UCe, 'ElkGraphFactoryImpl', 1012);
Ycb(436, 157, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
});
_.Ch = function tvd() {
    var a, b;
    b = (a = JD(Crd(this, 16), 29), iWd(MTd(!a ? this.ei() : a)));
    return b == null ? (g$d(), g$d(), f$d) : new z$d(this, b);
};
_.Hh = function uvd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.ve();
    }
    return dqd(this, a - VTd(this.ei()), QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), a), b, c);
};
_.Sh = function vvd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
    }
    return eqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.Zh = function wvd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            this.qi(OD(b));
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((c = JD(Crd(this, 16), 29), !c ? this.ei() : c), a), b);
};
_.ei = function xvd() {
    return cPd(), TOd;
};
_.gi = function yvd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            this.qi(null);
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.ve = function zvd() {
    return this.zb;
};
_.qi = function Avd(a) {
    rvd(this, a);
};
_.Ib = function Bvd() {
    return svd(this);
};
_.zb = null;
var g7 = jeb(TCe, 'ENamedElementImpl', 436);
Ycb(184, 436, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    117: 1,
    118: 1,
    675: 1
}, gwd);
_.wh = function iwd(a) {
    return Uvd(this, a);
};
_.Hh = function jwd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.yb;
        case 3:
            return this.xb;
        case 4:
            return this.sb;
        case 5:
            return !this.rb && (this.rb = new c1d(this, a6, this)), this.rb;
        case 6:
            return !this.vb && (this.vb = new _0d(l6, this, 6, 7)), this.vb;
        case 7:
            if (b) return this.Db >> 16 == 7 ? JD(this.Cb, 240) : null;
            return Kvd(this);
    }
    return dqd(this, a - VTd((cPd(), XOd)), QTd((d = JD(Crd(this, 16), 29), !d ? XOd : d), a), b, c);
};
_.Oh = function kwd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 4:
            !!this.sb && (c = JD(this.sb, 52).Ph(this, 1, f6, c));
            return Lvd(this, JD(a, 466), c);
        case 5:
            return !this.rb && (this.rb = new c1d(this, a6, this)), PGd(this.rb, a, c);
        case 6:
            return !this.vb && (this.vb = new _0d(l6, this, 6, 7)), PGd(this.vb, a, c);
        case 7:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? Uvd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 7, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), XOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), XOd)), a, c);
};
_.Qh = function lwd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 4:
            return Lvd(this, null, c);
        case 5:
            return !this.rb && (this.rb = new c1d(this, a6, this)), QGd(this.rb, a, c);
        case 6:
            return !this.vb && (this.vb = new _0d(l6, this, 6, 7)), QGd(this.vb, a, c);
        case 7:
            return bqd(this, null, 7, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), XOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), XOd)), a, c);
};
_.Sh = function mwd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.yb != null;
        case 3:
            return this.xb != null;
        case 4:
            return !!this.sb;
        case 5:
            return !!this.rb && this.rb.i != 0;
        case 6:
            return !!this.vb && this.vb.i != 0;
        case 7:
            return !!Kvd(this);
    }
    return eqd(this, a - VTd((cPd(), XOd)), QTd((b = JD(Crd(this, 16), 29), !b ? XOd : b), a));
};
_.Vh = function nwd(a) {
    var b;
    b = Wvd(this, a);
    return b ? b : Dud(this, a);
};
_.Zh = function owd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            rvd(this, OD(b));
            return;
        case 2:
            fwd(this, OD(b));
            return;
        case 3:
            ewd(this, OD(b));
            return;
        case 4:
            dwd(this, JD(b, 466));
            return;
        case 5:
            !this.rb && (this.rb = new c1d(this, a6, this));
            RGd(this.rb);
            !this.rb && (this.rb = new c1d(this, a6, this));
            vCd(this.rb, JD(b, 16));
            return;
        case 6:
            !this.vb && (this.vb = new _0d(l6, this, 6, 7));
            RGd(this.vb);
            !this.vb && (this.vb = new _0d(l6, this, 6, 7));
            vCd(this.vb, JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), XOd)), QTd((c = JD(Crd(this, 16), 29), !c ? XOd : c), a), b);
};
_.ai = function pwd(a) {
    var b, c;
    if (!!a && !!this.rb) for(c = new CHd(this.rb); c.e != c.i.gc();){
        b = AHd(c);
        RD(b, 357) && (JD(b, 357).w = null);
    }
    Erd(this, 64, a);
};
_.ei = function qwd() {
    return cPd(), XOd;
};
_.gi = function rwd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            rvd(this, null);
            return;
        case 2:
            fwd(this, null);
            return;
        case 3:
            ewd(this, null);
            return;
        case 4:
            dwd(this, null);
            return;
        case 5:
            !this.rb && (this.rb = new c1d(this, a6, this));
            RGd(this.rb);
            return;
        case 6:
            !this.vb && (this.vb = new _0d(l6, this, 6, 7));
            RGd(this.vb);
            return;
    }
    gqd(this, a - VTd((cPd(), XOd)), QTd((b = JD(Crd(this, 16), 29), !b ? XOd : b), a));
};
_.li = function swd() {
    Vvd(this);
};
_.ri = function twd() {
    return !this.rb && (this.rb = new c1d(this, a6, this)), this.rb;
};
_.si = function uwd() {
    return this.sb;
};
_.ti = function vwd() {
    return this.ub;
};
_.ui = function wwd() {
    return this.xb;
};
_.vi = function xwd() {
    return this.yb;
};
_.wi = function ywd(a) {
    this.ub = a;
};
_.Ib = function zwd() {
    var a;
    if ((this.Db & 64) != 0) return svd(this);
    a = new Jgb(svd(this));
    a.a += ' (nsURI: ';
    Egb(a, this.yb);
    a.a += ', nsPrefix: ';
    Egb(a, this.xb);
    a.a += ')';
    return a.a;
};
_.xb = null;
_.yb = null;
var Cvd;
var q7 = jeb(TCe, 'EPackageImpl', 184);
Ycb(552, 184, {
    109: 1,
    2061: 1,
    552: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    117: 1,
    118: 1,
    675: 1
}, Dwd);
_.q = false;
_.r = false;
var Awd = false;
var K3 = jeb(UCe, 'ElkGraphPackageImpl', 552);
Ycb(359, 723, {
    109: 1,
    338: 1,
    173: 1,
    153: 1,
    273: 1,
    359: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, Lwd);
_.wh = function Mwd(a) {
    return Gwd(this, a);
};
_.Hh = function Nwd(a, b, c) {
    switch(a){
        case 7:
            return Hwd(this);
        case 8:
            return this.a;
    }
    return _sd(this, a, b, c);
};
_.Oh = function Owd(a, b, c) {
    var d;
    switch(b){
        case 7:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? Gwd(this, c) : this.Cb.Ph(this, -1 - d, null, c)));
            return Fwd(this, JD(a, 173), c);
    }
    return Jsd(this, a, b, c);
};
_.Qh = function Pwd(a, b, c) {
    if (b == 7) return Fwd(this, null, c);
    return Ksd(this, a, b, c);
};
_.Sh = function Qwd(a) {
    switch(a){
        case 7:
            return !!Hwd(this);
        case 8:
            return !cgb('', this.a);
    }
    return atd(this, a);
};
_.Zh = function Rwd(a, b) {
    switch(a){
        case 7:
            Iwd(this, JD(b, 173));
            return;
        case 8:
            Jwd(this, OD(b));
            return;
    }
    btd(this, a, b);
};
_.ei = function Swd() {
    return Vpd(), Ppd;
};
_.gi = function Twd(a) {
    switch(a){
        case 7:
            Iwd(this, null);
            return;
        case 8:
            Jwd(this, '');
            return;
    }
    ctd(this, a);
};
_.Ib = function Uwd() {
    return Kwd(this);
};
_.a = '';
var L3 = jeb(UCe, 'ElkLabelImpl', 359);
Ycb(206, 724, {
    109: 1,
    338: 1,
    84: 1,
    173: 1,
    27: 1,
    273: 1,
    206: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, cxd);
_.wh = function dxd(a) {
    return Wwd(this, a);
};
_.Hh = function exd(a, b, c) {
    switch(a){
        case 9:
            return !this.c && (this.c = new X0d(B3, this, 9, 9)), this.c;
        case 10:
            return !this.a && (this.a = new X0d(A3, this, 10, 11)), this.a;
        case 11:
            return Zwd(this);
        case 12:
            return !this.b && (this.b = new X0d(x3, this, 12, 3)), this.b;
        case 13:
            return xdb(), !this.a && (this.a = new X0d(A3, this, 10, 11)), this.a.i > 0 ? true : false;
    }
    return wtd(this, a, b, c);
};
_.Oh = function fxd(a, b, c) {
    var d;
    switch(b){
        case 9:
            return !this.c && (this.c = new X0d(B3, this, 9, 9)), PGd(this.c, a, c);
        case 10:
            return !this.a && (this.a = new X0d(A3, this, 10, 11)), PGd(this.a, a, c);
        case 11:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? Wwd(this, c) : this.Cb.Ph(this, -1 - d, null, c)));
            return Vwd(this, JD(a, 27), c);
        case 12:
            return !this.b && (this.b = new X0d(x3, this, 12, 3)), PGd(this.b, a, c);
    }
    return xtd(this, a, b, c);
};
_.Qh = function gxd(a, b, c) {
    switch(b){
        case 9:
            return !this.c && (this.c = new X0d(B3, this, 9, 9)), QGd(this.c, a, c);
        case 10:
            return !this.a && (this.a = new X0d(A3, this, 10, 11)), QGd(this.a, a, c);
        case 11:
            return Vwd(this, null, c);
        case 12:
            return !this.b && (this.b = new X0d(x3, this, 12, 3)), QGd(this.b, a, c);
    }
    return ytd(this, a, b, c);
};
_.Sh = function hxd(a) {
    switch(a){
        case 9:
            return !!this.c && this.c.i != 0;
        case 10:
            return !!this.a && this.a.i != 0;
        case 11:
            return !!Zwd(this);
        case 12:
            return !!this.b && this.b.i != 0;
        case 13:
            return !this.a && (this.a = new X0d(A3, this, 10, 11)), this.a.i > 0;
    }
    return ztd(this, a);
};
_.Zh = function ixd(a, b) {
    switch(a){
        case 9:
            !this.c && (this.c = new X0d(B3, this, 9, 9));
            RGd(this.c);
            !this.c && (this.c = new X0d(B3, this, 9, 9));
            vCd(this.c, JD(b, 16));
            return;
        case 10:
            !this.a && (this.a = new X0d(A3, this, 10, 11));
            RGd(this.a);
            !this.a && (this.a = new X0d(A3, this, 10, 11));
            vCd(this.a, JD(b, 16));
            return;
        case 11:
            axd(this, JD(b, 27));
            return;
        case 12:
            !this.b && (this.b = new X0d(x3, this, 12, 3));
            RGd(this.b);
            !this.b && (this.b = new X0d(x3, this, 12, 3));
            vCd(this.b, JD(b, 16));
            return;
    }
    Atd(this, a, b);
};
_.ei = function jxd() {
    return Vpd(), Qpd;
};
_.gi = function kxd(a) {
    switch(a){
        case 9:
            !this.c && (this.c = new X0d(B3, this, 9, 9));
            RGd(this.c);
            return;
        case 10:
            !this.a && (this.a = new X0d(A3, this, 10, 11));
            RGd(this.a);
            return;
        case 11:
            axd(this, null);
            return;
        case 12:
            !this.b && (this.b = new X0d(x3, this, 12, 3));
            RGd(this.b);
            return;
    }
    Btd(this, a);
};
_.Ib = function lxd() {
    return bxd(this);
};
var M3 = jeb(UCe, 'ElkNodeImpl', 206);
Ycb(193, 724, {
    109: 1,
    338: 1,
    84: 1,
    173: 1,
    124: 1,
    273: 1,
    193: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, rxd);
_.wh = function sxd(a) {
    return nxd(this, a);
};
_.Hh = function txd(a, b, c) {
    if (a == 9) return oxd(this);
    return wtd(this, a, b, c);
};
_.Oh = function uxd(a, b, c) {
    var d;
    switch(b){
        case 9:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? nxd(this, c) : this.Cb.Ph(this, -1 - d, null, c)));
            return mxd(this, JD(a, 27), c);
    }
    return xtd(this, a, b, c);
};
_.Qh = function vxd(a, b, c) {
    if (b == 9) return mxd(this, null, c);
    return ytd(this, a, b, c);
};
_.Sh = function wxd(a) {
    if (a == 9) return !!oxd(this);
    return ztd(this, a);
};
_.Zh = function xxd(a, b) {
    switch(a){
        case 9:
            pxd(this, JD(b, 27));
            return;
    }
    Atd(this, a, b);
};
_.ei = function yxd() {
    return Vpd(), Rpd;
};
_.gi = function zxd(a) {
    switch(a){
        case 9:
            pxd(this, null);
            return;
    }
    Btd(this, a);
};
_.Ib = function Axd() {
    return qxd(this);
};
var N3 = jeb(UCe, 'ElkPortImpl', 193);
var G5 = leb(tDe, 'BasicEMap/Entry');
Ycb(1086, 118, {
    109: 1,
    43: 1,
    93: 1,
    92: 1,
    135: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, Dxd);
_.Fb = function Jxd(a) {
    return this === a;
};
_.jd = function Lxd() {
    return this.b;
};
_.Hb = function Nxd() {
    return jDb(this);
};
_.zi = function Pxd(a) {
    Bxd(this, JD(a, 144));
};
_.Hh = function Exd(a, b, c) {
    switch(a){
        case 0:
            return this.b;
        case 1:
            return this.c;
    }
    return hqd(this, a, b, c);
};
_.Sh = function Fxd(a) {
    switch(a){
        case 0:
            return !!this.b;
        case 1:
            return this.c != null;
    }
    return oqd(this, a);
};
_.Zh = function Gxd(a, b) {
    switch(a){
        case 0:
            Bxd(this, JD(b, 144));
            return;
        case 1:
            Cxd(this, b);
            return;
    }
    Aqd(this, a, b);
};
_.ei = function Hxd() {
    return Vpd(), Spd;
};
_.gi = function Ixd(a) {
    switch(a){
        case 0:
            Bxd(this, null);
            return;
        case 1:
            Cxd(this, null);
            return;
    }
    Eqd(this, a);
};
_.xi = function Kxd() {
    var a;
    if (this.a == -1) {
        a = this.b;
        this.a = !a ? 0 : tb(a);
    }
    return this.a;
};
_.kd = function Mxd() {
    return this.c;
};
_.yi = function Oxd(a) {
    this.a = a;
};
_.ld = function Qxd(a) {
    var b;
    b = this.c;
    Cxd(this, a);
    return b;
};
_.Ib = function Rxd() {
    var a;
    if ((this.Db & 64) != 0) return Gqd(this);
    a = new Ugb;
    Qgb(Qgb(Qgb(a, this.b ? this.b.Ng() : Rqe), Fve), xgb(this.c));
    return a.a;
};
_.a = -1;
_.c = null;
var O3 = jeb(UCe, 'ElkPropertyToValueMapEntryImpl', 1086);
Ycb(973, 1, {}, dyd);
var Q3 = jeb(wDe, 'JsonAdapter', 973);
Ycb(214, 63, Nre, eyd);
var R3 = jeb(wDe, 'JsonImportException', 214);
Ycb(845, 1, {}, Azd);
var G4 = jeb(wDe, 'JsonImporter', 845);
Ycb(879, 1, {}, Bzd);
_.Ai = function Czd(a) {
    zyd(this.a, this.b, JD(a, 138));
};
var S3 = jeb(wDe, 'JsonImporter/lambda$0$Type', 879);
Ycb(880, 1, {}, Dzd);
_.Ai = function Ezd(a) {
    Ayd(this.a, this.b, JD(a, 138));
};
var T3 = jeb(wDe, 'JsonImporter/lambda$1$Type', 880);
Ycb(888, 1, {}, Fzd);
_.Ai = function Gzd(a) {
    Byd(this.a, JD(a, 147));
};
var U3 = jeb(wDe, 'JsonImporter/lambda$10$Type', 888);
Ycb(890, 1, {}, Hzd);
_.Ai = function Izd(a) {
    Cyd(this.a, this.b, JD(a, 138));
};
var V3 = jeb(wDe, 'JsonImporter/lambda$11$Type', 890);
Ycb(891, 1, {}, Jzd);
_.Ai = function Kzd(a) {
    Dyd(this.a, this.b, JD(a, 138));
};
var W3 = jeb(wDe, 'JsonImporter/lambda$12$Type', 891);
Ycb(897, 1, {}, Lzd);
_.Ai = function Mzd(a) {
    Eyd(this.a, this.b, this.c, this.d, JD(a, 138));
};
var X3 = jeb(wDe, 'JsonImporter/lambda$13$Type', 897);
Ycb(896, 1, {}, Nzd);
_.Ai = function Ozd(a) {
    Fyd(this.a, this.b, this.c, this.d, JD(a, 147));
};
var Y3 = jeb(wDe, 'JsonImporter/lambda$14$Type', 896);
Ycb(892, 1, {}, Pzd);
_.Ai = function Qzd(a) {
    Gyd(this.a, this.b, OD(a));
};
var Z3 = jeb(wDe, 'JsonImporter/lambda$15$Type', 892);
Ycb(893, 1, {}, Rzd);
_.Ai = function Szd(a) {
    Hyd(this.a, this.b, OD(a));
};
var $3 = jeb(wDe, 'JsonImporter/lambda$16$Type', 893);
Ycb(894, 1, {}, Tzd);
_.Ai = function Uzd(a) {
    Iyd(this.b, this.a, JD(a, 138));
};
var _3 = jeb(wDe, 'JsonImporter/lambda$17$Type', 894);
Ycb(895, 1, {}, Vzd);
_.Ai = function Wzd(a) {
    Jyd(this.b, this.a, JD(a, 138));
};
var a4 = jeb(wDe, 'JsonImporter/lambda$18$Type', 895);
Ycb(900, 1, {}, Xzd);
_.Ai = function Yzd(a) {
    Kyd(this.a, JD(a, 147));
};
var b4 = jeb(wDe, 'JsonImporter/lambda$19$Type', 900);
Ycb(881, 1, {}, Zzd);
_.Ai = function $zd(a) {
    Lyd(this.a, JD(a, 138));
};
var c4 = jeb(wDe, 'JsonImporter/lambda$2$Type', 881);
Ycb(898, 1, {}, _zd);
_.Ai = function aAd(a) {
    qud(this.a, Beb(MD(a)));
};
var d4 = jeb(wDe, 'JsonImporter/lambda$20$Type', 898);
Ycb(899, 1, {}, bAd);
_.Ai = function cAd(a) {
    rud(this.a, Beb(MD(a)));
};
var e4 = jeb(wDe, 'JsonImporter/lambda$21$Type', 899);
Ycb(903, 1, {}, dAd);
_.Ai = function eAd(a) {
    Myd(this.a, JD(a, 147));
};
var f4 = jeb(wDe, 'JsonImporter/lambda$22$Type', 903);
Ycb(901, 1, {}, fAd);
_.Ai = function gAd(a) {
    jud(this.a, Beb(MD(a)));
};
var g4 = jeb(wDe, 'JsonImporter/lambda$23$Type', 901);
Ycb(902, 1, {}, hAd);
_.Ai = function iAd(a) {
    kud(this.a, Beb(MD(a)));
};
var h4 = jeb(wDe, 'JsonImporter/lambda$24$Type', 902);
Ycb(905, 1, {}, jAd);
_.Ai = function kAd(a) {
    Nyd(this.a, JD(a, 138));
};
var i4 = jeb(wDe, 'JsonImporter/lambda$25$Type', 905);
Ycb(904, 1, {}, lAd);
_.Ai = function mAd(a) {
    Oyd(this.a, JD(a, 147));
};
var j4 = jeb(wDe, 'JsonImporter/lambda$26$Type', 904);
Ycb(906, 1, kre, nAd);
_.Ad = function oAd(a) {
    Pyd(this.b, this.a, OD(a));
};
var k4 = jeb(wDe, 'JsonImporter/lambda$27$Type', 906);
Ycb(907, 1, kre, pAd);
_.Ad = function qAd(a) {
    Qyd(this.b, this.a, OD(a));
};
var l4 = jeb(wDe, 'JsonImporter/lambda$28$Type', 907);
Ycb(908, 1, {}, rAd);
_.Ai = function sAd(a) {
    Ryd(this.a, this.b, JD(a, 138));
};
var m4 = jeb(wDe, 'JsonImporter/lambda$29$Type', 908);
Ycb(884, 1, {}, tAd);
_.Ai = function uAd(a) {
    Syd(this.a, JD(a, 147));
};
var n4 = jeb(wDe, 'JsonImporter/lambda$3$Type', 884);
Ycb(909, 1, {}, vAd);
_.Ai = function wAd(a) {
    Tyd(this.a, this.b, JD(a, 138));
};
var o4 = jeb(wDe, 'JsonImporter/lambda$30$Type', 909);
Ycb(910, 1, {}, xAd);
_.Ai = function yAd(a) {
    Uyd(this.a, MD(a));
};
var p4 = jeb(wDe, 'JsonImporter/lambda$31$Type', 910);
Ycb(911, 1, {}, zAd);
_.Ai = function AAd(a) {
    Vyd(this.a, MD(a));
};
var q4 = jeb(wDe, 'JsonImporter/lambda$32$Type', 911);
Ycb(912, 1, {}, BAd);
_.Ai = function CAd(a) {
    Wyd(this.a, MD(a));
};
var r4 = jeb(wDe, 'JsonImporter/lambda$33$Type', 912);
Ycb(913, 1, {}, DAd);
_.Ai = function EAd(a) {
    Xyd(this.a, MD(a));
};
var s4 = jeb(wDe, 'JsonImporter/lambda$34$Type', 913);
Ycb(914, 1, {}, FAd);
_.Ai = function GAd(a) {
    mzd(this.a, JD(a, 57));
};
var t4 = jeb(wDe, 'JsonImporter/lambda$35$Type', 914);
Ycb(915, 1, {}, HAd);
_.Ai = function IAd(a) {
    nzd(this.a, JD(a, 57));
};
var u4 = jeb(wDe, 'JsonImporter/lambda$36$Type', 915);
Ycb(919, 1, {}, KAd);
var v4 = jeb(wDe, 'JsonImporter/lambda$37$Type', 919);
Ycb(916, 1, kre, LAd);
_.Ad = function MAd(a) {
    Zyd(this.a, this.c, this.b, JD(a, 369));
};
var w4 = jeb(wDe, 'JsonImporter/lambda$38$Type', 916);
Ycb(917, 1, kre, NAd);
_.Ad = function OAd(a) {
    $yd(this.a, this.b, JD(a, 168));
};
var x4 = jeb(wDe, 'JsonImporter/lambda$39$Type', 917);
Ycb(882, 1, {}, PAd);
_.Ai = function QAd(a) {
    qud(this.a, Beb(MD(a)));
};
var y4 = jeb(wDe, 'JsonImporter/lambda$4$Type', 882);
Ycb(918, 1, kre, RAd);
_.Ad = function SAd(a) {
    _yd(this.a, this.b, JD(a, 168));
};
var z4 = jeb(wDe, 'JsonImporter/lambda$40$Type', 918);
Ycb(920, 1, kre, TAd);
_.Ad = function UAd(a) {
    azd(this.a, this.b, this.c, JD(a, 8));
};
var A4 = jeb(wDe, 'JsonImporter/lambda$41$Type', 920);
Ycb(883, 1, {}, VAd);
_.Ai = function WAd(a) {
    rud(this.a, Beb(MD(a)));
};
var B4 = jeb(wDe, 'JsonImporter/lambda$5$Type', 883);
Ycb(887, 1, {}, XAd);
_.Ai = function YAd(a) {
    bzd(this.a, JD(a, 147));
};
var C4 = jeb(wDe, 'JsonImporter/lambda$6$Type', 887);
Ycb(885, 1, {}, ZAd);
_.Ai = function $Ad(a) {
    jud(this.a, Beb(MD(a)));
};
var D4 = jeb(wDe, 'JsonImporter/lambda$7$Type', 885);
Ycb(886, 1, {}, _Ad);
_.Ai = function aBd(a) {
    kud(this.a, Beb(MD(a)));
};
var E4 = jeb(wDe, 'JsonImporter/lambda$8$Type', 886);
Ycb(889, 1, {}, bBd);
_.Ai = function cBd(a) {
    czd(this.a, JD(a, 138));
};
var F4 = jeb(wDe, 'JsonImporter/lambda$9$Type', 889);
Ycb(939, 1, kre, lBd);
_.Ad = function mBd(a) {
    Sxd(this.a, new GC(OD(a)));
};
var H4 = jeb(wDe, 'JsonMetaDataConverter/lambda$0$Type', 939);
Ycb(940, 1, kre, nBd);
_.Ad = function oBd(a) {
    hBd(this.a, JD(a, 243));
};
var I4 = jeb(wDe, 'JsonMetaDataConverter/lambda$1$Type', 940);
Ycb(941, 1, kre, pBd);
_.Ad = function qBd(a) {
    iBd(this.a, JD(a, 149));
};
var J4 = jeb(wDe, 'JsonMetaDataConverter/lambda$2$Type', 941);
Ycb(942, 1, kre, rBd);
_.Ad = function sBd(a) {
    jBd(this.a, JD(a, 170));
};
var K4 = jeb(wDe, 'JsonMetaDataConverter/lambda$3$Type', 942);
Ycb(243, 23, {
    3: 1,
    34: 1,
    23: 1,
    243: 1
}, CBd);
var tBd, uBd, vBd, wBd, xBd, yBd, zBd, ABd;
var L4 = keb(vue, 'GraphFeature', 243, MI, EBd, DBd);
var FBd;
Ycb(12, 1, {
    34: 1,
    144: 1
}, KBd, LBd, MBd, NBd);
_.Dd = function OBd(a) {
    return HBd(this, JD(a, 144));
};
_.Fb = function PBd(a) {
    return IBd(this, a);
};
_.Qg = function QBd() {
    return JBd(this);
};
_.Ng = function RBd() {
    return this.b;
};
_.Hb = function SBd() {
    return fgb(this.b);
};
_.Ib = function TBd() {
    return this.b;
};
var Q4 = jeb(vue, 'Property', 12);
Ycb(656, 1, Bte, VBd);
_.Le = function WBd(a, b) {
    return UBd(this, JD(a, 102), JD(b, 102));
};
_.Fb = function XBd(a) {
    return this === a;
};
_.Me = function YBd() {
    return new uqb(this);
};
var P4 = jeb(vue, 'PropertyHolderComparator', 656);
Ycb(693, 1, Wqe, nCd);
_.Nb = function oCd(a) {
    Osb(this, a);
};
_.Pb = function qCd() {
    return mCd(this);
};
_.Qb = function rCd() {
    Psb();
};
_.Ob = function pCd() {
    return !!this.a;
};
var R4 = jeb(LDe, 'ElkGraphUtil/AncestorIterator', 693);
var Q5 = leb(tDe, 'EList');
Ycb(70, 55, {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1
});
_._c = function GCd(a, b) {
    sCd(this, a, b);
};
_.Ec = function HCd(a) {
    return tCd(this, a);
};
_.ad = function ICd(a, b) {
    return uCd(this, a, b);
};
_.Fc = function JCd(a) {
    return vCd(this, a);
};
_.Fi = function KCd() {
    return new XHd(this);
};
_.Gi = function LCd() {
    return new $Hd(this);
};
_.Hi = function MCd(a) {
    return wCd(this, a);
};
_.Ii = function NCd() {
    return true;
};
_.Ji = function OCd(a, b) {};
_.Ki = function PCd() {};
_.Li = function QCd(a, b) {
    xCd(this, a, b);
};
_.Mi = function RCd(a, b, c) {};
_.Ni = function SCd(a, b) {};
_.Oi = function TCd(a, b, c) {};
_.Fb = function UCd(a) {
    return yCd(this, a);
};
_.Hb = function VCd() {
    return BCd(this);
};
_.Pi = function WCd() {
    return false;
};
_.Jc = function XCd() {
    return new CHd(this);
};
_.cd = function YCd() {
    return new LHd(this);
};
_.dd = function ZCd(a) {
    var b;
    b = this.gc();
    if (a < 0 || a > b) throw scb(new zHd(a, b));
    return new MHd(this, a);
};
_.Ri = function $Cd(a, b) {
    this.Qi(a, this.bd(b));
};
_.Kc = function _Cd(a) {
    return CCd(this, a);
};
_.Ti = function aDd(a, b) {
    return b;
};
_.fd = function bDd(a, b) {
    return DCd(this, a, b);
};
_.Ib = function cDd() {
    return ECd(this);
};
_.Vi = function dDd() {
    return true;
};
_.Wi = function eDd(a, b) {
    return FCd(this, b);
};
var m5 = jeb(tDe, 'AbstractEList', 70);
Ycb(66, 70, QDe, vDd, wDd, xDd);
_.Bi = function yDd(a, b) {
    return fDd(this, a, b);
};
_.Ci = function zDd(a) {
    return gDd(this, a);
};
_.Di = function ADd(a, b) {
    hDd(this, a, b);
};
_.Ei = function BDd(a) {
    iDd(this, a);
};
_.Xi = function CDd(a) {
    return kDd(this, a);
};
_.$b = function DDd() {
    lDd(this);
};
_.Gc = function EDd(a) {
    return mDd(this, a);
};
_.Xb = function FDd(a) {
    return nDd(this, a);
};
_.Yi = function GDd(a) {
    var b, c, d;
    ++this.j;
    c = this.g == null ? 0 : this.g.length;
    if (a > c) {
        d = this.g;
        b = c + (c / 2 | 0) + 4;
        b < a && (b = a);
        this.g = this.Zi(b);
        d != null && $gb(d, 0, this.g, 0, this.i);
    }
};
_.bd = function HDd(a) {
    return oDd(this, a);
};
_.dc = function IDd() {
    return this.i == 0;
};
_.Qi = function JDd(a, b) {
    return pDd(this, a, b);
};
_.Zi = function KDd(a) {
    return SC(aJ, Nqe, 1, a, 5, 1);
};
_.Si = function LDd(a) {
    return this.g[a];
};
_.ed = function MDd(a) {
    return qDd(this, a);
};
_.Ui = function NDd(a, b) {
    return rDd(this, a, b);
};
_.gc = function ODd() {
    return this.i;
};
_.Nc = function PDd() {
    return tDd(this);
};
_.Oc = function QDd(a) {
    return uDd(this, a);
};
_.i = 0;
var v5 = jeb(tDe, 'BasicEList', 66);
var U5 = leb(tDe, 'TreeIterator');
Ycb(692, 66, RDe);
_.Nb = function UDd(a) {
    Osb(this, a);
};
_.Ob = function VDd() {
    return this.g == null && !this.c ? RDd(this) : this.g == null || this.i != 0 && JD(this.g[this.i - 1], 49).Ob();
};
_.Pb = function WDd() {
    return SDd(this);
};
_.Qb = function XDd() {
    if (!this.e) throw scb(new Web('There is no valid object to remove.'));
    this.e.Qb();
};
_.c = false;
var n5 = jeb(tDe, 'AbstractTreeIterator', 692);
Ycb(599, 692, RDe, YDd);
_.$i = function ZDd(a) {
    var b;
    b = JD(a, 57).Ch().Jc();
    RD(b, 284) && JD(b, 284).tl(new $Dd);
    return b;
};
var T4 = jeb(LDe, 'ElkGraphUtil/PropertiesSkippingTreeIterator', 599);
Ycb(943, 1, {}, $Dd);
var S4 = jeb(LDe, 'ElkGraphUtil/PropertiesSkippingTreeIterator/1', 943);
var _Dd, aEd;
var V4 = jeb(LDe, 'ElkReflect', null);
Ycb(877, 1, zBe, gEd);
_.Pg = function hEd(a) {
    return bEd(), prb(JD(a, 181));
};
var U4 = jeb(LDe, 'ElkReflect/lambda$0$Type', 877);
var iEd;
var T5 = leb(tDe, 'ResourceLocator');
Ycb(1040, 1, {});
var K5 = jeb(tDe, 'DelegatingResourceLocator', 1040);
Ycb(1041, 1040, {});
var W4 = jeb('org.eclipse.emf.common', 'EMFPlugin', 1041);
var X4 = leb(EEe, 'Adapter');
var Y4 = leb(EEe, 'Notification');
Ycb(1138, 1, FEe);
_._i = function sEd() {
    return this.d;
};
_.aj = function tEd(a) {};
_.bj = function uEd(a) {
    this.d = a;
};
_.cj = function vEd(a) {
    this.d == a && (this.d = null);
};
_.d = null;
var Z4 = jeb(KCe, 'AdapterImpl', 1138);
Ycb(2039, 70, GEe);
_.Bi = function CEd(a, b) {
    return wEd(this, a, b);
};
_.Ci = function DEd(a) {
    var b, c, d;
    ++this.j;
    if (a.dc()) return false;
    else {
        b = this.Bj();
        for(d = a.Jc(); d.Ob();){
            c = d.Pb();
            this.oj(this.Wi(b, c));
            ++b;
        }
        return true;
    }
};
_.Di = function EEd(a, b) {
    xEd(this, a, b);
};
_.Ei = function FEd(a) {
    yEd(this, a);
};
_.mj = function GEd() {
    return this.pj();
};
_.$b = function HEd() {
    zEd(this, this.Bj(), this.Cj());
};
_.Gc = function IEd(a) {
    return this.rj(a);
};
_.Hc = function JEd(a) {
    return this.sj(a);
};
_.nj = function KEd(a, b) {
    this.yj().Rm();
};
_.oj = function LEd(a) {
    this.yj().Rm();
};
_.pj = function MEd() {
    return this.yj();
};
_.qj = function NEd() {
    this.yj().Rm();
};
_.rj = function OEd(a) {
    return this.yj().Rm();
};
_.sj = function PEd(a) {
    return this.yj().Rm();
};
_.tj = function QEd(a) {
    return this.yj().Rm();
};
_.uj = function REd(a) {
    return this.yj().Rm();
};
_.vj = function SEd() {
    return this.yj().Rm();
};
_.wj = function TEd(a) {
    return this.yj().Rm();
};
_.xj = function UEd() {
    return this.yj().Rm();
};
_.zj = function VEd(a) {
    return this.yj().Rm();
};
_.Aj = function WEd(a, b) {
    return this.yj().Rm();
};
_.Bj = function XEd() {
    return this.yj().Rm();
};
_.Cj = function YEd() {
    return this.yj().Rm();
};
_.Dj = function ZEd(a) {
    return this.yj().Rm();
};
_.Ej = function $Ed() {
    return this.yj().Rm();
};
_.Fb = function _Ed(a) {
    return this.tj(a);
};
_.Xb = function aFd(a) {
    return this.Ti(a, this.uj(a));
};
_.Hb = function bFd() {
    return this.vj();
};
_.bd = function cFd(a) {
    return this.wj(a);
};
_.dc = function dFd() {
    return this.xj();
};
_.Qi = function eFd(a, b) {
    return AEd(this, a, b);
};
_.Si = function fFd(a) {
    return this.uj(a);
};
_.ed = function gFd(a) {
    return BEd(this, a);
};
_.Kc = function hFd(a) {
    var b;
    b = this.bd(a);
    if (b >= 0) {
        this.ed(b);
        return true;
    } else return false;
};
_.Ui = function iFd(a, b) {
    return this.Aj(a, this.Wi(a, b));
};
_.gc = function jFd() {
    return this.Bj();
};
_.Nc = function kFd() {
    return this.Cj();
};
_.Oc = function lFd(a) {
    return this.Dj(a);
};
_.Ib = function mFd() {
    return this.Ej();
};
var J5 = jeb(tDe, 'DelegatingEList', 2039);
Ycb(2040, 2039, GEe);
_.Bi = function uFd(a, b) {
    return nFd(this, a, b);
};
_.Ci = function vFd(a) {
    return this.Bi(this.Bj(), a);
};
_.Di = function wFd(a, b) {
    oFd(this, a, b);
};
_.Ei = function xFd(a) {
    pFd(this, a);
};
_.Ii = function yFd() {
    return !this.Jj();
};
_.$b = function zFd() {
    sFd(this);
};
_.Fj = function AFd(a, b, c, d, e) {
    return new zGd(this, a, b, c, d, e);
};
_.Gj = function BFd(a) {
    Wpd(this.gj(), a);
};
_.Hj = function CFd() {
    return null;
};
_.Ij = function DFd() {
    return -1;
};
_.gj = function EFd() {
    return null;
};
_.Jj = function FFd() {
    return false;
};
_.Kj = function GFd(a, b) {
    return b;
};
_.Lj = function HFd(a, b) {
    return b;
};
_.Mj = function IFd() {
    return false;
};
_.Nj = function JFd() {
    return !this.xj();
};
_.Qi = function KFd(a, b) {
    var c, d;
    if (this.Mj()) {
        d = this.Nj();
        c = AEd(this, a, b);
        this.Gj(this.Fj(7, jfb(b), c, a, d));
        return c;
    } else return AEd(this, a, b);
};
_.ed = function LFd(a) {
    var b, c, d, e;
    if (this.Mj()) {
        c = null;
        d = this.Nj();
        b = this.Fj(4, e = BEd(this, a), null, a, d);
        if (this.Jj() && !!e) {
            c = this.Lj(e, c);
            if (!c) this.Gj(b);
            else {
                c.kj(b);
                c.lj();
            }
        } else if (!c) this.Gj(b);
        else {
            c.kj(b);
            c.lj();
        }
        return e;
    } else {
        e = BEd(this, a);
        if (this.Jj() && !!e) {
            c = this.Lj(e, null);
            !!c && c.lj();
        }
        return e;
    }
};
_.Ui = function MFd(a, b) {
    return tFd(this, a, b);
};
var a5 = jeb(KCe, 'DelegatingNotifyingListImpl', 2040);
Ycb(150, 1, HEe);
_.kj = function mGd(a) {
    return NFd(this, a);
};
_.lj = function nGd() {
    OFd(this);
};
_.dj = function oGd() {
    return this.d;
};
_.Hj = function pGd() {
    return null;
};
_.Oj = function qGd() {
    return null;
};
_.ej = function rGd(a) {
    return -1;
};
_.fj = function sGd() {
    return XFd(this);
};
_.gj = function tGd() {
    return null;
};
_.hj = function uGd() {
    return eGd(this);
};
_.ij = function vGd() {
    return this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o;
};
_.Pj = function wGd() {
    return false;
};
_.jj = function xGd(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    switch(this.d){
        case 1:
        case 2:
            e = a.dj();
            switch(e){
                case 1:
                case 2:
                    f = a.gj();
                    if (XD(f) === XD(this.gj()) && this.ej(null) == a.ej(null)) {
                        this.g = a.fj();
                        a.dj() == 1 && (this.d = 1);
                        return true;
                    }
            }
        case 4:
            e = a.dj();
            switch(e){
                case 4:
                    f = a.gj();
                    if (XD(f) === XD(this.gj()) && this.ej(null) == a.ej(null)) {
                        j = gGd(this);
                        i = this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o;
                        g = a.ij();
                        this.d = 6;
                        l = new wDd(2);
                        if (i <= g) {
                            tCd(l, this.n);
                            tCd(l, a.hj());
                            this.g = WC(OC(cE, 1), ise, 30, 15, [
                                this.o = i,
                                g + 1
                            ]);
                        } else {
                            tCd(l, a.hj());
                            tCd(l, this.n);
                            this.g = WC(OC(cE, 1), ise, 30, 15, [
                                this.o = g,
                                i
                            ]);
                        }
                        this.n = l;
                        j || (this.o = -2 - this.o - 1);
                        return true;
                    }
                    break;
            }
            break;
        case 6:
            e = a.dj();
            switch(e){
                case 4:
                    f = a.gj();
                    if (XD(f) === XD(this.gj()) && this.ej(null) == a.ej(null)) {
                        j = gGd(this);
                        g = a.ij();
                        k = JD(this.g, 54);
                        d = SC(cE, ise, 30, k.length + 1, 15, 1);
                        b = 0;
                        while(b < k.length){
                            h = k[b];
                            if (h <= g) {
                                d[b++] = h;
                                ++g;
                            } else break;
                        }
                        c = JD(this.n, 15);
                        c._c(b, a.hj());
                        d[b] = g;
                        while(++b < d.length)d[b] = k[b - 1];
                        this.g = d;
                        j || (this.o = -2 - d[0]);
                        return true;
                    }
                    break;
            }
            break;
    }
    return false;
};
_.Ib = function yGd() {
    var a, b, c, d;
    d = new Jgb(eeb(this.Om) + '@' + (b = tb(this) >>> 0, b.toString(16)));
    d.a += ' (eventType: ';
    switch(this.d){
        case 1:
            d.a += 'SET';
            break;
        case 2:
            d.a += 'UNSET';
            break;
        case 3:
            d.a += 'ADD';
            break;
        case 5:
            d.a += 'ADD_MANY';
            break;
        case 4:
            d.a += 'REMOVE';
            break;
        case 6:
            d.a += 'REMOVE_MANY';
            break;
        case 7:
            d.a += 'MOVE';
            break;
        case 8:
            d.a += 'REMOVING_ADAPTER';
            break;
        case 9:
            d.a += 'RESOLVE';
            break;
        default:
            Cgb(d, this.d);
            break;
    }
    fGd(this) && (d.a += ', touch: true', d);
    d.a += ', position: ';
    Cgb(d, this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o);
    d.a += ', notifier: ';
    Dgb(d, this.gj());
    d.a += ', feature: ';
    Dgb(d, this.Hj());
    d.a += ', oldValue: ';
    Dgb(d, eGd(this));
    d.a += ', newValue: ';
    if (this.d == 6 && RD(this.g, 54)) {
        c = JD(this.g, 54);
        d.a += '[';
        for(a = 0; a < c.length;){
            d.a += c[a];
            ++a < c.length && (d.a += Lqe, d);
        }
        d.a += ']';
    } else Dgb(d, XFd(this));
    d.a += ', isTouch: ';
    Fgb(d, fGd(this));
    d.a += ', wasSet: ';
    Fgb(d, gGd(this));
    d.a += ')';
    return d.a;
};
_.d = 0;
_.e = 0;
_.f = 0;
_.j = 0;
_.k = 0;
_.o = 0;
_.p = 0;
var c5 = jeb(KCe, 'NotificationImpl', 150);
Ycb(1152, 150, HEe, zGd);
_.Hj = function AGd() {
    return this.a.Hj();
};
_.ej = function BGd(a) {
    return this.a.Ij();
};
_.gj = function CGd() {
    return this.a.gj();
};
var _4 = jeb(KCe, 'DelegatingNotifyingListImpl/1', 1152);
Ycb(250, 66, QDe, EGd, FGd);
_.Ec = function GGd(a) {
    return DGd(this, JD(a, 370));
};
_.kj = function HGd(a) {
    return DGd(this, a);
};
_.lj = function IGd() {
    var a, b, c;
    for(a = 0; a < this.i; ++a){
        b = JD(this.g[a], 370);
        c = b.gj();
        c != null && b.dj() != -1 && JD(c, 93).th(b);
    }
};
_.Zi = function JGd(a) {
    return SC(Y4, Nqe, 370, a, 0, 1);
};
var b5 = jeb(KCe, 'NotificationChainImpl', 250);
Ycb(1464, 92, JCe);
_.qh = function KGd() {
    return this.e;
};
_.sh = function LGd() {
    return (this.f & 1) != 0;
};
_.f = 1;
var d5 = jeb(KCe, 'NotifierImpl', 1464);
Ycb(2037, 66, QDe);
_.Bi = function XGd(a, b) {
    return MGd(this, a, b);
};
_.Ci = function YGd(a) {
    return this.Bi(this.i, a);
};
_.Di = function ZGd(a, b) {
    NGd(this, a, b);
};
_.Ei = function $Gd(a) {
    OGd(this, a);
};
_.Ii = function _Gd() {
    return !this.Jj();
};
_.$b = function aHd() {
    RGd(this);
};
_.Fj = function bHd(a, b, c, d, e) {
    return new sHd(this, a, b, c, d, e);
};
_.Gj = function cHd(a) {
    Wpd(this.gj(), a);
};
_.Hj = function dHd() {
    return null;
};
_.Ij = function eHd() {
    return -1;
};
_.gj = function fHd() {
    return null;
};
_.Jj = function gHd() {
    return false;
};
_.Qj = function hHd() {
    return false;
};
_.Kj = function iHd(a, b) {
    return b;
};
_.Lj = function jHd(a, b) {
    return b;
};
_.Mj = function kHd() {
    return false;
};
_.Nj = function lHd() {
    return this.i != 0;
};
_.Qi = function mHd(a, b) {
    return TGd(this, a, b);
};
_.ed = function nHd(a) {
    return UGd(this, a);
};
_.Ui = function oHd(a, b) {
    return WGd(this, a, b);
};
_.Rj = function pHd(a, b) {
    return b;
};
_.Sj = function qHd(a, b) {
    return b;
};
_.Tj = function rHd(a, b, c) {
    return c;
};
var f5 = jeb(KCe, 'NotifyingListImpl', 2037);
Ycb(1151, 150, HEe, sHd);
_.Hj = function tHd() {
    return this.a.Hj();
};
_.ej = function uHd(a) {
    return this.a.Ij();
};
_.gj = function vHd() {
    return this.a.gj();
};
var e5 = jeb(KCe, 'NotifyingListImpl/1', 1151);
Ycb(944, 66, QDe, wHd);
_.Gc = function xHd(a) {
    if (this.i > 10) {
        if (!this.b || this.c.j != this.a) {
            this.b = new Srb(this);
            this.a = this.j;
        }
        return Orb(this.b, a);
    } else return mDd(this, a);
};
_.Vi = function yHd() {
    return true;
};
_.a = 0;
var g5 = jeb(tDe, 'AbstractEList/1', 944);
Ycb(301, 97, Hse, zHd);
var h5 = jeb(tDe, 'AbstractEList/BasicIndexOutOfBoundsException', 301);
Ycb(42, 1, Wqe, CHd);
_.Nb = function FHd(a) {
    Osb(this, a);
};
_.Uj = function DHd() {
    if (this.i.j != this.f) throw scb(new yqb);
};
_.Vj = function EHd() {
    return AHd(this);
};
_.Ob = function GHd() {
    return this.e != this.i.gc();
};
_.Pb = function HHd() {
    return this.Vj();
};
_.Qb = function IHd() {
    BHd(this);
};
_.e = 0;
_.f = 0;
_.g = -1;
var i5 = jeb(tDe, 'AbstractEList/EIterator', 42);
Ycb(283, 42, dre, LHd, MHd);
_.Qb = function UHd() {
    BHd(this);
};
_.Rb = function NHd(a) {
    JHd(this, a);
};
_.Wj = function OHd() {
    var b;
    try {
        b = this.d.Xb(--this.e);
        this.Uj();
        this.g = this.e;
        return b;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) {
            this.Uj();
            throw scb(new qub);
        } else throw scb(a);
    }
};
_.Xj = function PHd(a) {
    KHd(this, a);
};
_.Sb = function QHd() {
    return this.e != 0;
};
_.Tb = function RHd() {
    return this.e;
};
_.Ub = function SHd() {
    return this.Wj();
};
_.Vb = function THd() {
    return this.e - 1;
};
_.Wb = function VHd(a) {
    this.Xj(a);
};
var j5 = jeb(tDe, 'AbstractEList/EListIterator', 283);
Ycb(352, 42, Wqe, XHd);
_.Vj = function YHd() {
    return WHd(this);
};
_.Qb = function ZHd() {
    throw scb(new ahb);
};
var k5 = jeb(tDe, 'AbstractEList/NonResolvingEIterator', 352);
Ycb(389, 283, dre, $Hd, _Hd);
_.Rb = function aId(a) {
    throw scb(new ahb);
};
_.Vj = function bId() {
    var b;
    try {
        b = this.c.Si(this.e);
        this.Uj();
        this.g = this.e++;
        return b;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) {
            this.Uj();
            throw scb(new qub);
        } else throw scb(a);
    }
};
_.Wj = function cId() {
    var b;
    try {
        b = this.c.Si(--this.e);
        this.Uj();
        this.g = this.e;
        return b;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) {
            this.Uj();
            throw scb(new qub);
        } else throw scb(a);
    }
};
_.Qb = function dId() {
    throw scb(new ahb);
};
_.Wb = function eId(a) {
    throw scb(new ahb);
};
var l5 = jeb(tDe, 'AbstractEList/NonResolvingEListIterator', 389);
Ycb(2026, 70, KEe);
_.Bi = function mId(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    e = b.gc();
    if (e != 0) {
        j = JD(Crd(this.a, 4), 128);
        k = j == null ? 0 : j.length;
        m = k + e;
        d = kId(this, m);
        l = k - a;
        l > 0 && $gb(j, a, d, a + e, l);
        i = b.Jc();
        for(g = 0; g < e; ++g){
            h = i.Pb();
            c = a + g;
            iId(d, c, FCd(this, h));
        }
        W8d(this, d);
        for(f = 0; f < e; ++f){
            h = d[a];
            this.Ji(a, h);
            ++a;
        }
        return true;
    } else {
        ++this.j;
        return false;
    }
};
_.Ci = function nId(a) {
    var b, c, d, e, f, g, h, i, j;
    d = a.gc();
    if (d != 0) {
        i = (c = JD(Crd(this.a, 4), 128), c == null ? 0 : c.length);
        j = i + d;
        b = kId(this, j);
        h = a.Jc();
        for(f = i; f < j; ++f){
            g = h.Pb();
            iId(b, f, FCd(this, g));
        }
        W8d(this, b);
        for(e = i; e < j; ++e){
            g = b[e];
            this.Ji(e, g);
        }
        return true;
    } else {
        ++this.j;
        return false;
    }
};
_.Di = function oId(a, b) {
    var c, d, e, f;
    d = JD(Crd(this.a, 4), 128);
    e = d == null ? 0 : d.length;
    c = kId(this, e + 1);
    f = FCd(this, b);
    a != e && $gb(d, a, c, a + 1, e - a);
    VC(c, a, f);
    W8d(this, c);
    this.Ji(a, b);
};
_.Ei = function pId(a) {
    var b, c, d;
    d = (c = JD(Crd(this.a, 4), 128), c == null ? 0 : c.length);
    b = kId(this, d + 1);
    iId(b, d, FCd(this, a));
    W8d(this, b);
    this.Ji(d, a);
};
_.Fi = function qId() {
    return new RId(this);
};
_.Gi = function rId() {
    return new UId(this);
};
_.Hi = function sId(a) {
    var b, c;
    c = (b = JD(Crd(this.a, 4), 128), b == null ? 0 : b.length);
    if (a < 0 || a > c) throw scb(new zHd(a, c));
    return new VId(this, a);
};
_.$b = function tId() {
    var a, b;
    ++this.j;
    a = JD(Crd(this.a, 4), 128);
    b = a == null ? 0 : a.length;
    W8d(this, null);
    xCd(this, b, a);
};
_.Gc = function uId(a) {
    var b, c, d, e, f;
    b = JD(Crd(this.a, 4), 128);
    if (b != null) {
        if (a != null) for(d = b, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (pb(a, c)) return true;
        }
        else for(d = b, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (XD(c) === XD(a)) return true;
        }
    }
    return false;
};
_.Xb = function vId(a) {
    var b, c;
    b = JD(Crd(this.a, 4), 128);
    c = b == null ? 0 : b.length;
    if (a >= c) throw scb(new zHd(a, c));
    return b[a];
};
_.bd = function wId(a) {
    var b, c, d;
    b = JD(Crd(this.a, 4), 128);
    if (b != null) {
        if (a != null) for(c = 0, d = b.length; c < d; ++c){
            if (pb(a, b[c])) return c;
        }
        else for(c = 0, d = b.length; c < d; ++c){
            if (XD(b[c]) === XD(a)) return c;
        }
    }
    return -1;
};
_.dc = function xId() {
    return JD(Crd(this.a, 4), 128) == null;
};
_.Jc = function yId() {
    return new IId(this);
};
_.cd = function zId() {
    return new MId(this);
};
_.dd = function AId(a) {
    var b, c;
    c = (b = JD(Crd(this.a, 4), 128), b == null ? 0 : b.length);
    if (a < 0 || a > c) throw scb(new zHd(a, c));
    return new NId(this, a);
};
_.Qi = function BId(a, b) {
    var c, d, e;
    c = jId(this);
    e = c == null ? 0 : c.length;
    if (a >= e) throw scb(new mdb(NDe + a + ODe + e));
    if (b >= e) throw scb(new mdb(PDe + b + ODe + e));
    d = c[b];
    if (a != b) {
        a < b ? $gb(c, a, c, a + 1, b - a) : $gb(c, b + 1, c, b, a - b);
        VC(c, a, d);
        W8d(this, c);
    }
    return d;
};
_.Si = function CId(a) {
    return JD(Crd(this.a, 4), 128)[a];
};
_.ed = function DId(a) {
    return lId(this, a);
};
_.Ui = function EId(a, b) {
    var c, d;
    c = jId(this);
    d = c[a];
    iId(c, a, FCd(this, b));
    W8d(this, c);
    return d;
};
_.gc = function FId() {
    var a;
    return a = JD(Crd(this.a, 4), 128), a == null ? 0 : a.length;
};
_.Nc = function GId() {
    var a, b, c;
    a = JD(Crd(this.a, 4), 128);
    c = a == null ? 0 : a.length;
    b = SC(X4, JEe, 412, c, 0, 1);
    c > 0 && $gb(a, 0, b, 0, c);
    return b;
};
_.Oc = function HId(a) {
    var b, c, d;
    b = JD(Crd(this.a, 4), 128);
    d = b == null ? 0 : b.length;
    if (d > 0) {
        if (a.length < d) {
            c = fId(rb(a).c, d);
            a = c;
        }
        $gb(b, 0, a, 0, d);
    }
    a.length > d && VC(a, d, null);
    return a;
};
var gId;
var s5 = jeb(tDe, 'ArrayDelegatingEList', 2026);
Ycb(1026, 42, Wqe, IId);
_.Uj = function JId() {
    if (this.b.j != this.f || XD(JD(Crd(this.b.a, 4), 128)) !== XD(this.a)) throw scb(new yqb);
};
_.Qb = function KId() {
    BHd(this);
    this.a = JD(Crd(this.b.a, 4), 128);
};
var o5 = jeb(tDe, 'ArrayDelegatingEList/EIterator', 1026);
Ycb(706, 283, dre, MId, NId);
_.Uj = function OId() {
    if (this.b.j != this.f || XD(JD(Crd(this.b.a, 4), 128)) !== XD(this.a)) throw scb(new yqb);
};
_.Xj = function PId(a) {
    KHd(this, a);
    this.a = JD(Crd(this.b.a, 4), 128);
};
_.Qb = function QId() {
    BHd(this);
    this.a = JD(Crd(this.b.a, 4), 128);
};
var p5 = jeb(tDe, 'ArrayDelegatingEList/EListIterator', 706);
Ycb(1027, 352, Wqe, RId);
_.Uj = function SId() {
    if (this.b.j != this.f || XD(JD(Crd(this.b.a, 4), 128)) !== XD(this.a)) throw scb(new yqb);
};
var q5 = jeb(tDe, 'ArrayDelegatingEList/NonResolvingEIterator', 1027);
Ycb(707, 389, dre, UId, VId);
_.Uj = function WId() {
    if (this.b.j != this.f || XD(JD(Crd(this.b.a, 4), 128)) !== XD(this.a)) throw scb(new yqb);
};
var r5 = jeb(tDe, 'ArrayDelegatingEList/NonResolvingEListIterator', 707);
Ycb(600, 301, Hse, XId);
var t5 = jeb(tDe, 'BasicEList/BasicIndexOutOfBoundsException', 600);
Ycb(694, 66, QDe, YId);
_._c = function ZId(a, b) {
    throw scb(new ahb);
};
_.Ec = function $Id(a) {
    throw scb(new ahb);
};
_.ad = function _Id(a, b) {
    throw scb(new ahb);
};
_.Fc = function aJd(a) {
    throw scb(new ahb);
};
_.$b = function bJd() {
    throw scb(new ahb);
};
_.Yi = function cJd(a) {
    throw scb(new ahb);
};
_.Jc = function dJd() {
    return this.Fi();
};
_.cd = function eJd() {
    return this.Gi();
};
_.dd = function fJd(a) {
    return this.Hi(a);
};
_.Qi = function gJd(a, b) {
    throw scb(new ahb);
};
_.Ri = function hJd(a, b) {
    throw scb(new ahb);
};
_.ed = function iJd(a) {
    throw scb(new ahb);
};
_.Kc = function jJd(a) {
    throw scb(new ahb);
};
_.fd = function kJd(a, b) {
    throw scb(new ahb);
};
var u5 = jeb(tDe, 'BasicEList/UnmodifiableEList', 694);
Ycb(705, 1, {
    3: 1,
    20: 1,
    16: 1,
    15: 1,
    61: 1,
    581: 1
});
_._c = function LJd(a, b) {
    lJd(this, a, JD(b, 43));
};
_.Ec = function MJd(a) {
    return mJd(this, JD(a, 43));
};
_.Ic = function UJd(a) {
    ofb(this, a);
};
_.Xb = function VJd(a) {
    return JD(nDd(this.c, a), 135);
};
_.Qi = function cKd(a, b) {
    return JD(this.c.Qi(a, b), 43);
};
_.Ri = function dKd(a, b) {
    DJd(this, a, JD(b, 43));
};
_.ed = function gKd(a) {
    return JD(this.c.ed(a), 43);
};
_.fd = function iKd(a, b) {
    return JJd(this, a, JD(b, 43));
};
_.gd = function kKd(a) {
    hub(this, a);
};
_.Lc = function lKd() {
    return new Gvb(this, 16);
};
_.Mc = function mKd() {
    return new RBb(null, new Gvb(this, 16));
};
_.ad = function NJd(a, b) {
    return this.c.ad(a, b);
};
_.Fc = function OJd(a) {
    return this.c.Fc(a);
};
_.$b = function PJd() {
    this.c.$b();
};
_.Gc = function QJd(a) {
    return this.c.Gc(a);
};
_.Hc = function RJd(a) {
    return Ae(this.c, a);
};
_.Yj = function SJd() {
    var a, b, c;
    if (this.d == null) {
        this.d = SC(v5, LEe, 66, 2 * this.f + 1, 0, 1);
        c = this.e;
        this.f = 0;
        for(b = this.c.Jc(); b.e != b.i.gc();){
            a = JD(b.Vj(), 135);
            rJd(this, a);
        }
        this.e = c;
    }
};
_.Fb = function TJd(a) {
    return wJd(this, a);
};
_.Hb = function WJd() {
    return BCd(this.c);
};
_.bd = function XJd(a) {
    return this.c.bd(a);
};
_.Zj = function YJd() {
    this.c = new uKd(this);
};
_.dc = function ZJd() {
    return this.f == 0;
};
_.Jc = function $Jd() {
    return this.c.Jc();
};
_.cd = function _Jd() {
    return this.c.cd();
};
_.dd = function aKd(a) {
    return this.c.dd(a);
};
_.$j = function bKd() {
    return CJd(this);
};
_._j = function eKd(a, b, c) {
    return new uLd(a, b, c);
};
_.ak = function fKd() {
    return new AKd;
};
_.Kc = function hKd(a) {
    return GJd(this, a);
};
_.gc = function jKd() {
    return this.f;
};
_.hd = function nKd(a, b) {
    return new Ijb(this.c, a, b);
};
_.Nc = function oKd() {
    return this.c.Nc();
};
_.Oc = function pKd(a) {
    return this.c.Oc(a);
};
_.Ib = function qKd() {
    return ECd(this.c);
};
_.e = 0;
_.f = 0;
var I5 = jeb(tDe, 'BasicEMap', 705);
Ycb(1021, 66, QDe, uKd);
_.Ji = function vKd(a, b) {
    rKd(this, JD(b, 135));
};
_.Mi = function xKd(a, b, c) {
    var d;
    ++(d = this, JD(b, 135), d).a.e;
};
_.Ni = function yKd(a, b) {
    sKd(this, JD(b, 135));
};
_.Oi = function zKd(a, b, c) {
    tKd(this, JD(b, 135), JD(c, 135));
};
_.Li = function wKd(a, b) {
    qJd(this.a);
};
var w5 = jeb(tDe, 'BasicEMap/1', 1021);
Ycb(1022, 66, QDe, AKd);
_.Zi = function BKd(a) {
    return SC(F5, MEe, 606, a, 0, 1);
};
var x5 = jeb(tDe, 'BasicEMap/2', 1022);
Ycb(1023, $qe, _qe, CKd);
_.$b = function DKd() {
    this.a.c.$b();
};
_.Gc = function EKd(a) {
    return nJd(this.a, a);
};
_.Jc = function FKd() {
    return this.a.f == 0 ? (GLd(), FLd.a) : new _Kd(this.a);
};
_.Kc = function GKd(a) {
    var b;
    b = this.a.f;
    IJd(this.a, a);
    return this.a.f != b;
};
_.gc = function HKd() {
    return this.a.f;
};
var y5 = jeb(tDe, 'BasicEMap/3', 1023);
Ycb(NEe, 31, Zqe, IKd);
_.$b = function JKd() {
    this.a.c.$b();
};
_.Gc = function KKd(a) {
    return oJd(this.a, a);
};
_.Jc = function LKd() {
    return this.a.f == 0 ? (GLd(), FLd.a) : new bLd(this.a);
};
_.gc = function MKd() {
    return this.a.f;
};
var z5 = jeb(tDe, 'BasicEMap/4', NEe);
Ycb(1025, $qe, _qe, OKd);
_.$b = function PKd() {
    this.a.c.$b();
};
_.Gc = function QKd(a) {
    var b, c, d, e, f, g, h, i, j;
    if (this.a.f > 0 && RD(a, 43)) {
        this.a.Yj();
        i = JD(a, 43);
        h = i.jd();
        e = h == null ? 0 : tb(h);
        f = AJd(this.a, e);
        b = this.a.d[f];
        if (b) {
            c = JD(b.g, 371);
            j = b.i;
            for(g = 0; g < j; ++g){
                d = c[g];
                if (d.xi() == e && d.Fb(i)) return true;
            }
        }
    }
    return false;
};
_.Jc = function RKd() {
    return this.a.f == 0 ? (GLd(), FLd.a) : new VKd(this.a);
};
_.Kc = function SKd(a) {
    return NKd(this, a);
};
_.gc = function TKd() {
    return this.a.f;
};
var A5 = jeb(tDe, 'BasicEMap/5', 1025);
Ycb(607, 1, Wqe, VKd);
_.Nb = function WKd(a) {
    Osb(this, a);
};
_.Ob = function XKd() {
    return this.b != -1;
};
_.Pb = function YKd() {
    var a;
    if (this.f.e != this.c) throw scb(new yqb);
    if (this.b == -1) throw scb(new qub);
    this.d = this.a;
    this.e = this.b;
    UKd(this);
    a = JD(this.f.d[this.d].g[this.e], 135);
    return this.bk(a);
};
_.Qb = function ZKd() {
    if (this.f.e != this.c) throw scb(new yqb);
    if (this.e == -1) throw scb(new Veb);
    this.f.c.Kc(nDd(this.f.d[this.d], this.e));
    this.c = this.f.e;
    this.e = -1;
    this.a == this.d && this.b != -1 && --this.b;
};
_.bk = function $Kd(a) {
    return a;
};
_.a = 0;
_.b = -1;
_.c = 0;
_.d = 0;
_.e = 0;
var B5 = jeb(tDe, 'BasicEMap/BasicEMapIterator', 607);
Ycb(1019, 607, Wqe, _Kd);
_.bk = function aLd(a) {
    return a.jd();
};
var C5 = jeb(tDe, 'BasicEMap/BasicEMapKeyIterator', 1019);
Ycb(1020, 607, Wqe, bLd);
_.bk = function cLd(a) {
    return a.kd();
};
var D5 = jeb(tDe, 'BasicEMap/BasicEMapValueIterator', 1020);
Ycb(1018, 1, Yqe, eLd);
_.wc = function kLd(a) {
    pub(this, a);
};
_.$b = function fLd() {
    this.a.c.$b();
};
_._b = function gLd(a) {
    return dLd(this, a);
};
_.uc = function hLd(a) {
    return oJd(this.a, a);
};
_.vc = function iLd() {
    return vJd(this.a);
};
_.Fb = function jLd(a) {
    return wJd(this.a, a);
};
_.xc = function lLd(a) {
    return xJd(this.a, a);
};
_.Hb = function mLd() {
    return BCd(this.a.c);
};
_.dc = function nLd() {
    return this.a.f == 0;
};
_.ec = function oLd() {
    return BJd(this.a);
};
_.yc = function pLd(a, b) {
    return EJd(this.a, a, b);
};
_.Ac = function qLd(a) {
    return IJd(this.a, a);
};
_.gc = function rLd() {
    return this.a.f;
};
_.Ib = function sLd() {
    return ECd(this.a.c);
};
_.Bc = function tLd() {
    return KJd(this.a);
};
var E5 = jeb(tDe, 'BasicEMap/DelegatingMap', 1018);
Ycb(606, 1, {
    43: 1,
    135: 1,
    606: 1
}, uLd);
_.Fb = function vLd(a) {
    var b;
    if (RD(a, 43)) {
        b = JD(a, 43);
        return (this.b != null ? pb(this.b, b.jd()) : XD(this.b) === XD(b.jd())) && (this.c != null ? pb(this.c, b.kd()) : XD(this.c) === XD(b.kd()));
    } else return false;
};
_.xi = function wLd() {
    return this.a;
};
_.jd = function xLd() {
    return this.b;
};
_.kd = function yLd() {
    return this.c;
};
_.Hb = function zLd() {
    return this.a ^ (this.c == null ? 0 : tb(this.c));
};
_.yi = function ALd(a) {
    this.a = a;
};
_.zi = function BLd(a) {
    throw scb(new pz);
};
_.ld = function CLd(a) {
    var b;
    b = this.c;
    this.c = a;
    return b;
};
_.Ib = function DLd() {
    return this.b + '->' + this.c;
};
_.a = 0;
var F5 = jeb(tDe, 'BasicEMap/EntryImpl', 606);
Ycb(531, 1, {}, ELd);
var H5 = jeb(tDe, 'BasicEMap/View', 531);
var FLd;
Ycb(763, 1, {});
_.Fb = function ULd(a) {
    return Nt((pnb(), mnb), a);
};
_.Hb = function VLd() {
    return tnb((pnb(), mnb));
};
_.Ib = function WLd() {
    return Ee((pnb(), mnb));
};
var N5 = jeb(tDe, 'ECollections/BasicEmptyUnmodifiableEList', 763);
Ycb(1287, 1, dre, XLd);
_.Nb = function ZLd(a) {
    Osb(this, a);
};
_.Rb = function YLd(a) {
    throw scb(new ahb);
};
_.Ob = function $Ld() {
    return false;
};
_.Sb = function _Ld() {
    return false;
};
_.Pb = function aMd() {
    throw scb(new qub);
};
_.Tb = function bMd() {
    return 0;
};
_.Ub = function cMd() {
    throw scb(new qub);
};
_.Vb = function dMd() {
    return -1;
};
_.Qb = function eMd() {
    throw scb(new ahb);
};
_.Wb = function fMd(a) {
    throw scb(new ahb);
};
var M5 = jeb(tDe, 'ECollections/BasicEmptyUnmodifiableEList/1', 1287);
Ycb(1285, 763, {
    20: 1,
    16: 1,
    15: 1,
    61: 1
}, gMd);
_._c = function hMd(a, b) {
    JLd();
};
_.Ec = function iMd(a) {
    return KLd();
};
_.ad = function jMd(a, b) {
    return LLd();
};
_.Fc = function kMd(a) {
    return MLd();
};
_.$b = function lMd() {
    NLd();
};
_.Gc = function mMd(a) {
    return false;
};
_.Hc = function nMd(a) {
    return false;
};
_.Ic = function oMd(a) {
    ofb(this, a);
};
_.Xb = function pMd(a) {
    return znb((pnb(), mnb, a)), null;
};
_.bd = function qMd(a) {
    return -1;
};
_.dc = function rMd() {
    return true;
};
_.Jc = function sMd() {
    return this.a;
};
_.cd = function tMd() {
    return this.a;
};
_.dd = function uMd(a) {
    return this.a;
};
_.Qi = function vMd(a, b) {
    return OLd();
};
_.Ri = function wMd(a, b) {
    PLd();
};
_.ed = function xMd(a) {
    return QLd();
};
_.Kc = function yMd(a) {
    return RLd();
};
_.fd = function zMd(a, b) {
    return SLd();
};
_.gc = function AMd() {
    return 0;
};
_.gd = function BMd(a) {
    hub(this, a);
};
_.Lc = function CMd() {
    return new Gvb(this, 16);
};
_.Mc = function DMd() {
    return new RBb(null, new Gvb(this, 16));
};
_.hd = function EMd(a, b) {
    return pnb(), new Ijb(mnb, a, b);
};
_.Nc = function FMd() {
    return Ce((pnb(), mnb));
};
_.Oc = function GMd(a) {
    return pnb(), De(mnb, a);
};
var O5 = jeb(tDe, 'ECollections/EmptyUnmodifiableEList', 1285);
Ycb(1286, 763, {
    20: 1,
    16: 1,
    15: 1,
    61: 1,
    581: 1
}, HMd);
_._c = function IMd(a, b) {
    JLd();
};
_.Ec = function JMd(a) {
    return KLd();
};
_.ad = function KMd(a, b) {
    return LLd();
};
_.Fc = function LMd(a) {
    return MLd();
};
_.$b = function MMd() {
    NLd();
};
_.Gc = function NMd(a) {
    return false;
};
_.Hc = function OMd(a) {
    return false;
};
_.Ic = function PMd(a) {
    ofb(this, a);
};
_.Xb = function QMd(a) {
    return znb((pnb(), mnb, a)), null;
};
_.bd = function RMd(a) {
    return -1;
};
_.dc = function SMd() {
    return true;
};
_.Jc = function TMd() {
    return this.a;
};
_.cd = function UMd() {
    return this.a;
};
_.dd = function VMd(a) {
    return this.a;
};
_.Qi = function XMd(a, b) {
    return OLd();
};
_.Ri = function YMd(a, b) {
    PLd();
};
_.ed = function ZMd(a) {
    return QLd();
};
_.Kc = function $Md(a) {
    return RLd();
};
_.fd = function _Md(a, b) {
    return SLd();
};
_.gc = function aNd() {
    return 0;
};
_.gd = function bNd(a) {
    hub(this, a);
};
_.Lc = function cNd() {
    return new Gvb(this, 16);
};
_.Mc = function dNd() {
    return new RBb(null, new Gvb(this, 16));
};
_.hd = function eNd(a, b) {
    return pnb(), new Ijb(mnb, a, b);
};
_.Nc = function fNd() {
    return Ce((pnb(), mnb));
};
_.Oc = function gNd(a) {
    return pnb(), De(mnb, a);
};
_.$j = function WMd() {
    return pnb(), pnb(), nnb;
};
var P5 = jeb(tDe, 'ECollections/EmptyUnmodifiableEMap', 1286);
var R5 = leb(tDe, 'Enumerator');
var hNd;
Ycb(286, 1, {
    286: 1
}, GNd);
_.Fb = function KNd(a) {
    var b;
    if (this === a) return true;
    if (!RD(a, 286)) return false;
    b = JD(a, 286);
    return this.f == b.f && MNd(this.i, b.i) && LNd(this.a, (this.f & 256) != 0 ? (b.f & 256) != 0 ? b.a : null : (b.f & 256) != 0 ? null : b.a) && LNd(this.d, b.d) && LNd(this.g, b.g) && LNd(this.e, b.e) && DNd(this, b);
};
_.Hb = function PNd() {
    return this.f;
};
_.Ib = function XNd() {
    return ENd(this);
};
_.f = 0;
var lNd = 0, mNd = 0, nNd = 0, oNd = 0, pNd = 0, qNd = 0, rNd = 0, sNd = 0, tNd = 0, uNd, vNd = 0, wNd = 0, xNd = 0, yNd = 0, zNd, ANd;
var W5 = jeb(tDe, 'URI', 286);
Ycb(1085, 45, bte, fOd);
_.yc = function gOd(a, b) {
    return JD(Rib(this, OD(a), JD(b, 286)), 286);
};
var V5 = jeb(tDe, 'URI/URICache', 1085);
Ycb(490, 66, QDe, hOd, iOd);
_.Pi = function jOd() {
    return true;
};
var X5 = jeb(tDe, 'UniqueEList', 490);
Ycb(573, 63, Nre, kOd);
var Y5 = jeb(tDe, 'WrappedException', 573);
var Z5 = leb(wCe, QEe);
var s6 = leb(wCe, REe);
var q6 = leb(wCe, SEe);
var $5 = leb(wCe, TEe);
var a6 = leb(wCe, UEe);
var _5 = leb(wCe, 'EClass');
var c6 = leb(wCe, 'EDataType');
var lOd;
Ycb(1193, 45, bte, oOd);
_.xc = function pOd(a) {
    return VD(a) ? Oib(this, a) : Wd(fsb(this.f, a));
};
var b6 = jeb(wCe, 'EDataType/Internal/ConversionDelegate/Factory/Registry/Impl', 1193);
var e6 = leb(wCe, 'EEnum');
var d6 = leb(wCe, VEe);
var g6 = leb(wCe, WEe);
var k6 = leb(wCe, XEe);
var qOd;
var m6 = leb(wCe, YEe);
var n6 = leb(wCe, ZEe);
Ycb(1017, 1, {}, uOd);
_.Ib = function vOd() {
    return 'NIL';
};
var o6 = jeb(wCe, 'EStructuralFeature/Internal/DynamicValueHolder/1', 1017);
var wOd;
Ycb(1016, 45, bte, zOd);
_.xc = function AOd(a) {
    return VD(a) ? Oib(this, a) : Wd(fsb(this.f, a));
};
var p6 = jeb(wCe, 'EStructuralFeature/Internal/SettingDelegate/Factory/Registry/Impl', 1016);
var r6 = leb(wCe, $Ee);
var t6 = leb(wCe, 'EValidator/PatternMatcher');
var BOd;
var DOd;
var FOd;
var HOd, IOd, JOd, KOd, LOd, MOd, NOd, OOd, POd, QOd, ROd, SOd, TOd, UOd, VOd, WOd, XOd, YOd, ZOd, $Od, _Od, aPd, bPd;
var Bab = leb(_Ee, 'FeatureMap/Entry');
Ycb(530, 1, {
    74: 1
}, dPd);
_.Ik = function ePd() {
    return this.a;
};
_.kd = function fPd() {
    return this.b;
};
var u6 = jeb(TCe, 'BasicEObjectImpl/1', 530);
Ycb(1015, 1, aFe, gPd);
_.Ck = function hPd(a) {
    return jqd(this.a, this.b, a);
};
_.Nj = function iPd() {
    return pqd(this.a, this.b);
};
_.Wb = function jPd(a) {
    Bqd(this.a, this.b, a);
};
_.Dk = function kPd() {
    Fqd(this.a, this.b);
};
var v6 = jeb(TCe, 'BasicEObjectImpl/4', 1015);
Ycb(2027, 1, {
    113: 1
});
_.Jk = function nPd(a) {
    this.e = a == 0 ? lPd : SC(aJ, Nqe, 1, a, 5, 1);
};
_.hi = function oPd(a) {
    return this.e[a];
};
_.ii = function pPd(a, b) {
    this.e[a] = b;
};
_.ji = function qPd(a) {
    this.e[a] = null;
};
_.Kk = function rPd() {
    return this.c;
};
_.Lk = function sPd() {
    throw scb(new ahb);
};
_.Mk = function tPd() {
    throw scb(new ahb);
};
_.Nk = function uPd() {
    return this.d;
};
_.Ok = function vPd() {
    return this.e != null;
};
_.Pk = function wPd(a) {
    this.c = a;
};
_.Qk = function xPd(a) {
    throw scb(new ahb);
};
_.Rk = function yPd(a) {
    throw scb(new ahb);
};
_.Sk = function zPd(a) {
    this.d = a;
};
var lPd;
var w6 = jeb(TCe, 'BasicEObjectImpl/EPropertiesHolderBaseImpl', 2027);
Ycb(192, 2027, {
    113: 1
}, APd);
_.Lk = function BPd() {
    return this.a;
};
_.Mk = function CPd() {
    return this.b;
};
_.Qk = function DPd(a) {
    this.a = a;
};
_.Rk = function EPd(a) {
    this.b = a;
};
var x6 = jeb(TCe, 'BasicEObjectImpl/EPropertiesHolderImpl', 192);
Ycb(500, 98, SCe, FPd);
_.qh = function GPd() {
    return this.f;
};
_.vh = function HPd() {
    return this.k;
};
_.xh = function IPd(a, b) {
    this.g = a;
    this.i = b;
};
_.zh = function JPd() {
    return (this.j & 2) == 0 ? this.ei() : this.Wh().Kk();
};
_.Bh = function KPd() {
    return this.i;
};
_.sh = function LPd() {
    return (this.j & 1) != 0;
};
_.Lh = function MPd() {
    return this.g;
};
_.Rh = function NPd() {
    return (this.j & 4) != 0;
};
_.Wh = function OPd() {
    return !this.k && (this.k = new APd), this.k;
};
_.$h = function PPd(a) {
    this.Wh().Pk(a);
    a ? this.j |= 2 : this.j &= -3;
};
_.ai = function QPd(a) {
    this.Wh().Rk(a);
    a ? this.j |= 4 : this.j &= -5;
};
_.ei = function RPd() {
    return (GOd(), FOd).S;
};
_.i = 0;
_.j = 1;
var i7 = jeb(TCe, 'EObjectImpl', 500);
Ycb(778, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1
}, UPd);
_.hi = function VPd(a) {
    return this.e[a];
};
_.ii = function WPd(a, b) {
    this.e[a] = b;
};
_.ji = function XPd(a) {
    this.e[a] = null;
};
_.zh = function YPd() {
    return this.d;
};
_.Eh = function ZPd(a) {
    return WTd(this.d, a);
};
_.Gh = function $Pd() {
    return this.d;
};
_.Kh = function _Pd() {
    return this.e != null;
};
_.Wh = function aQd() {
    !this.k && (this.k = new oQd);
    return this.k;
};
_.$h = function bQd(a) {
    this.d = a;
};
_.di = function cQd() {
    var a;
    if (this.e == null) {
        a = VTd(this.d);
        this.e = a == 0 ? SPd : SC(aJ, Nqe, 1, a, 5, 1);
    }
    return this;
};
_.fi = function dQd() {
    return 0;
};
var SPd;
var B6 = jeb(TCe, 'DynamicEObjectImpl', 778);
Ycb(1462, 778, {
    109: 1,
    43: 1,
    93: 1,
    92: 1,
    135: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1
}, eQd);
_.Fb = function gQd(a) {
    return this === a;
};
_.Hb = function kQd() {
    return jDb(this);
};
_.$h = function fQd(a) {
    this.d = a;
    this.b = RTd(a, 'key');
    this.c = RTd(a, bDe);
};
_.xi = function hQd() {
    var a;
    if (this.a == -1) {
        a = kqd(this, this.b);
        this.a = a == null ? 0 : tb(a);
    }
    return this.a;
};
_.jd = function iQd() {
    return kqd(this, this.b);
};
_.kd = function jQd() {
    return kqd(this, this.c);
};
_.yi = function lQd(a) {
    this.a = a;
};
_.zi = function mQd(a) {
    Bqd(this, this.b, a);
};
_.ld = function nQd(a) {
    var b;
    b = kqd(this, this.c);
    Bqd(this, this.c, a);
    return b;
};
_.a = 0;
var z6 = jeb(TCe, 'DynamicEObjectImpl/BasicEMapEntry', 1462);
Ycb(1463, 1, {
    113: 1
}, oQd);
_.Jk = function pQd(a) {
    throw scb(new ahb);
};
_.hi = function qQd(a) {
    throw scb(new ahb);
};
_.ii = function rQd(a, b) {
    throw scb(new ahb);
};
_.ji = function sQd(a) {
    throw scb(new ahb);
};
_.Kk = function tQd() {
    throw scb(new ahb);
};
_.Lk = function uQd() {
    return this.a;
};
_.Mk = function vQd() {
    return this.b;
};
_.Nk = function wQd() {
    return this.c;
};
_.Ok = function xQd() {
    throw scb(new ahb);
};
_.Pk = function yQd(a) {
    throw scb(new ahb);
};
_.Qk = function zQd(a) {
    this.a = a;
};
_.Rk = function AQd(a) {
    this.b = a;
};
_.Sk = function BQd(a) {
    this.c = a;
};
var A6 = jeb(TCe, 'DynamicEObjectImpl/DynamicEPropertiesHolderImpl', 1463);
Ycb(503, 157, {
    109: 1,
    93: 1,
    92: 1,
    582: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    503: 1,
    157: 1,
    117: 1,
    118: 1
}, KQd);
_.wh = function LQd(a) {
    return DQd(this, a);
};
_.Hh = function MQd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.d;
        case 2:
            return c ? (!this.b && (this.b = new lRd((cPd(), $Od), u7, this)), this.b) : (!this.b && (this.b = new lRd((cPd(), $Od), u7, this)), CJd(this.b));
        case 3:
            return FQd(this);
        case 4:
            return !this.a && (this.a = new qVd(j6, this, 4)), this.a;
        case 5:
            return !this.c && (this.c = new Ude(j6, this, 5)), this.c;
    }
    return dqd(this, a - VTd((cPd(), HOd)), QTd((d = JD(Crd(this, 16), 29), !d ? HOd : d), a), b, c);
};
_.Oh = function NQd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 3:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? DQd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return CQd(this, JD(a, 154), c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), HOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), HOd)), a, c);
};
_.Qh = function OQd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 2:
            return !this.b && (this.b = new lRd((cPd(), $Od), u7, this)), WQd(this.b, a, c);
        case 3:
            return CQd(this, null, c);
        case 4:
            return !this.a && (this.a = new qVd(j6, this, 4)), QGd(this.a, a, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), HOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), HOd)), a, c);
};
_.Sh = function PQd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.d != null;
        case 2:
            return !!this.b && this.b.f != 0;
        case 3:
            return !!FQd(this);
        case 4:
            return !!this.a && this.a.i != 0;
        case 5:
            return !!this.c && this.c.i != 0;
    }
    return eqd(this, a - VTd((cPd(), HOd)), QTd((b = JD(Crd(this, 16), 29), !b ? HOd : b), a));
};
_.Zh = function QQd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            HQd(this, OD(b));
            return;
        case 2:
            !this.b && (this.b = new lRd((cPd(), $Od), u7, this));
            XQd(this.b, b);
            return;
        case 3:
            GQd(this, JD(b, 154));
            return;
        case 4:
            !this.a && (this.a = new qVd(j6, this, 4));
            RGd(this.a);
            !this.a && (this.a = new qVd(j6, this, 4));
            vCd(this.a, JD(b, 16));
            return;
        case 5:
            !this.c && (this.c = new Ude(j6, this, 5));
            RGd(this.c);
            !this.c && (this.c = new Ude(j6, this, 5));
            vCd(this.c, JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), HOd)), QTd((c = JD(Crd(this, 16), 29), !c ? HOd : c), a), b);
};
_.ei = function RQd() {
    return cPd(), HOd;
};
_.gi = function SQd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            IQd(this, null);
            return;
        case 2:
            !this.b && (this.b = new lRd((cPd(), $Od), u7, this));
            this.b.c.$b();
            return;
        case 3:
            GQd(this, null);
            return;
        case 4:
            !this.a && (this.a = new qVd(j6, this, 4));
            RGd(this.a);
            return;
        case 5:
            !this.c && (this.c = new Ude(j6, this, 5));
            RGd(this.c);
            return;
    }
    gqd(this, a - VTd((cPd(), HOd)), QTd((b = JD(Crd(this, 16), 29), !b ? HOd : b), a));
};
_.Ib = function TQd() {
    return JQd(this);
};
_.d = null;
var D6 = jeb(TCe, 'EAnnotationImpl', 503);
Ycb(140, 705, bFe, YQd);
_.Di = function ZQd(a, b) {
    UQd(this, a, JD(b, 43));
};
_.Tk = function $Qd(a, b) {
    return VQd(this, JD(a, 43), b);
};
_.Xi = function _Qd(a) {
    return JD(JD(this.c, 71).Xi(a), 135);
};
_.Fi = function aRd() {
    return JD(this.c, 71).Fi();
};
_.Gi = function bRd() {
    return JD(this.c, 71).Gi();
};
_.Hi = function cRd(a) {
    return JD(this.c, 71).Hi(a);
};
_.Uk = function dRd(a, b) {
    return WQd(this, a, b);
};
_.Ck = function eRd(a) {
    return JD(this.c, 76).Ck(a);
};
_.Zj = function fRd() {};
_.Nj = function gRd() {
    return JD(this.c, 76).Nj();
};
_._j = function hRd(a, b, c) {
    var d;
    d = JD(WSd(this.b).si().oi(this.b), 135);
    d.yi(a);
    d.zi(b);
    d.ld(c);
    return d;
};
_.ak = function iRd() {
    return new Pee(this);
};
_.Wb = function jRd(a) {
    XQd(this, a);
};
_.Dk = function kRd() {
    JD(this.c, 76).Dk();
};
var vab = jeb(_Ee, 'EcoreEMap', 140);
Ycb(167, 140, bFe, lRd);
_.Yj = function mRd() {
    var a, b, c, d, e, f;
    if (this.d == null) {
        f = SC(v5, LEe, 66, 2 * this.f + 1, 0, 1);
        for(c = this.c.Jc(); c.e != c.i.gc();){
            b = JD(c.Vj(), 135);
            d = b.xi();
            e = (d & Hqe) % f.length;
            a = f[e];
            !a && (a = f[e] = new Pee(this));
            a.Ec(b);
        }
        this.d = f;
    }
};
var C6 = jeb(TCe, 'EAnnotationImpl/1', 167);
Ycb(290, 436, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    290: 1,
    117: 1,
    118: 1
});
_.Hh = function zRd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return jfb(this.s);
        case 5:
            return jfb(this.t);
        case 6:
            return xdb(), this.Gk() ? true : false;
        case 7:
            return xdb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return pRd(this);
            return this.r;
        case 9:
            return this.q;
    }
    return dqd(this, a - VTd(this.ei()), QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), a), b, c);
};
_.Qh = function ARd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 9:
            return oRd(this, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), e.tk().xk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Sh = function BRd(a) {
    var b, c;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return this.Gk();
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && EZd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && EZd(this.q).i == 0);
    }
    return eqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.Zh = function CRd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            this.qi(OD(b));
            return;
        case 2:
            uRd(this, ydb(LD(b)));
            return;
        case 3:
            vRd(this, ydb(LD(b)));
            return;
        case 4:
            tRd(this, JD(b, 17).a);
            return;
        case 5:
            this.Wk(JD(b, 17).a);
            return;
        case 8:
            rRd(this, JD(b, 141));
            return;
        case 9:
            d = qRd(this, JD(b, 87), null);
            !!d && d.lj();
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((c = JD(Crd(this, 16), 29), !c ? this.ei() : c), a), b);
};
_.ei = function DRd() {
    return cPd(), aPd;
};
_.gi = function ERd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            this.qi(null);
            return;
        case 2:
            uRd(this, true);
            return;
        case 3:
            vRd(this, true);
            return;
        case 4:
            tRd(this, 0);
            return;
        case 5:
            this.Wk(1);
            return;
        case 8:
            rRd(this, null);
            return;
        case 9:
            c = qRd(this, null, null);
            !!c && c.lj();
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.li = function FRd() {
    pRd(this);
    this.Bb |= 1;
};
_.Ek = function GRd() {
    return pRd(this);
};
_.Fk = function HRd() {
    return this.t;
};
_.Gk = function IRd() {
    var a;
    return a = this.t, a > 1 || a == -1;
};
_.Pi = function JRd() {
    return (this.Bb & 512) != 0;
};
_.Vk = function KRd(a, b) {
    return sRd(this, a, b);
};
_.Wk = function LRd(a) {
    wRd(this, a);
};
_.Ib = function MRd() {
    return xRd(this);
};
_.s = 0;
_.t = 1;
var s8 = jeb(TCe, 'ETypedElementImpl', 290);
Ycb(448, 290, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    178: 1,
    69: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    448: 1,
    290: 1,
    117: 1,
    118: 1,
    677: 1
});
_.wh = function bSd(a) {
    return NRd(this, a);
};
_.Hh = function cSd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return jfb(this.s);
        case 5:
            return jfb(this.t);
        case 6:
            return xdb(), this.Gk() ? true : false;
        case 7:
            return xdb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return pRd(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return xdb(), (this.Bb & NEe) != 0 ? true : false;
        case 11:
            return xdb(), (this.Bb & wse) != 0 ? true : false;
        case 12:
            return xdb(), (this.Bb & Mse) != 0 ? true : false;
        case 13:
            return this.j;
        case 14:
            return ORd(this);
        case 15:
            return xdb(), (this.Bb & dFe) != 0 ? true : false;
        case 16:
            return xdb(), (this.Bb & ire) != 0 ? true : false;
        case 17:
            return PRd(this);
    }
    return dqd(this, a - VTd(this.ei()), QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), a), b, c);
};
_.Oh = function dSd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 17:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? NRd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 17, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), f.tk().wk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Qh = function eSd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 9:
            return oRd(this, c);
        case 17:
            return bqd(this, null, 17, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), e.tk().xk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Sh = function fSd(a) {
    var b, c;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return this.Gk();
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && EZd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && EZd(this.q).i == 0);
        case 10:
            return (this.Bb & NEe) == 0;
        case 11:
            return (this.Bb & wse) != 0;
        case 12:
            return (this.Bb & Mse) != 0;
        case 13:
            return this.j != null;
        case 14:
            return ORd(this) != null;
        case 15:
            return (this.Bb & dFe) != 0;
        case 16:
            return (this.Bb & ire) != 0;
        case 17:
            return !!PRd(this);
    }
    return eqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.Zh = function gSd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            XRd(this, OD(b));
            return;
        case 2:
            uRd(this, ydb(LD(b)));
            return;
        case 3:
            vRd(this, ydb(LD(b)));
            return;
        case 4:
            tRd(this, JD(b, 17).a);
            return;
        case 5:
            this.Wk(JD(b, 17).a);
            return;
        case 8:
            rRd(this, JD(b, 141));
            return;
        case 9:
            d = qRd(this, JD(b, 87), null);
            !!d && d.lj();
            return;
        case 10:
            SRd(this, ydb(LD(b)));
            return;
        case 11:
            $Rd(this, ydb(LD(b)));
            return;
        case 12:
            YRd(this, ydb(LD(b)));
            return;
        case 13:
            TRd(this, OD(b));
            return;
        case 15:
            ZRd(this, ydb(LD(b)));
            return;
        case 16:
            VRd(this, ydb(LD(b)));
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((c = JD(Crd(this, 16), 29), !c ? this.ei() : c), a), b);
};
_.ei = function hSd() {
    return cPd(), _Od;
};
_.gi = function iSd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 88) && QVd(TTd(JD(this.Cb, 88)), 4);
            rvd(this, null);
            return;
        case 2:
            uRd(this, true);
            return;
        case 3:
            vRd(this, true);
            return;
        case 4:
            tRd(this, 0);
            return;
        case 5:
            this.Wk(1);
            return;
        case 8:
            rRd(this, null);
            return;
        case 9:
            c = qRd(this, null, null);
            !!c && c.lj();
            return;
        case 10:
            SRd(this, true);
            return;
        case 11:
            $Rd(this, false);
            return;
        case 12:
            YRd(this, false);
            return;
        case 13:
            this.i = null;
            URd(this, null);
            return;
        case 15:
            ZRd(this, false);
            return;
        case 16:
            VRd(this, false);
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.li = function jSd() {
    Vae(jae((Gfe(), Efe), this));
    pRd(this);
    this.Bb |= 1;
};
_.mk = function kSd() {
    return this.f;
};
_.fk = function lSd() {
    return ORd(this);
};
_.nk = function mSd() {
    return PRd(this);
};
_.rk = function nSd() {
    return null;
};
_.Xk = function oSd() {
    return this.k;
};
_.Ij = function pSd() {
    return this.n;
};
_.sk = function qSd() {
    return QRd(this);
};
_.tk = function rSd() {
    var a, b, c, d, e, f, g, h, i;
    if (!this.p) {
        c = PRd(this);
        (c.i == null && MTd(c), c.i).length;
        d = this.rk();
        !!d && VTd(PRd(d));
        e = pRd(this);
        g = e.hk();
        a = !g ? null : (g.i & 1) != 0 ? g == pcb ? GI : g == cE ? UI : g == bE ? QI : g == aE ? LI : g == dE ? XI : g == ocb ? cJ : g == $D ? HI : II : g;
        b = ORd(this);
        h = e.fk();
        ffe(this);
        (this.Bb & ire) != 0 && (!!(f = mae((Gfe(), Efe), c)) && f != this || !!(f = Uae(jae(Efe, this)))) ? this.p = new s2d(this, f) : this.Gk() ? this.Zk() ? !d ? (this.Bb & dFe) != 0 ? !a ? this.$k() ? this.p = new D2d(42, this) : this.p = new D2d(0, this) : a == LK ? this.p = new B2d(50, G5, this) : this.$k() ? this.p = new B2d(43, a, this) : this.p = new B2d(1, a, this) : !a ? this.$k() ? this.p = new D2d(44, this) : this.p = new D2d(2, this) : a == LK ? this.p = new B2d(41, G5, this) : this.$k() ? this.p = new B2d(45, a, this) : this.p = new B2d(3, a, this) : (this.Bb & dFe) != 0 ? !a ? this.$k() ? this.p = new E2d(46, this, d) : this.p = new E2d(4, this, d) : this.$k() ? this.p = new C2d(47, a, this, d) : this.p = new C2d(5, a, this, d) : !a ? this.$k() ? this.p = new E2d(48, this, d) : this.p = new E2d(6, this, d) : this.$k() ? this.p = new C2d(49, a, this, d) : this.p = new C2d(7, a, this, d) : RD(e, 155) ? a == Bab ? this.p = new D2d(40, this) : (this.Bb & 512) != 0 ? (this.Bb & dFe) != 0 ? !a ? this.p = new D2d(8, this) : this.p = new B2d(9, a, this) : !a ? this.p = new D2d(10, this) : this.p = new B2d(11, a, this) : (this.Bb & dFe) != 0 ? !a ? this.p = new D2d(12, this) : this.p = new B2d(13, a, this) : !a ? this.p = new D2d(14, this) : this.p = new B2d(15, a, this) : !d ? this.$k() ? (this.Bb & dFe) != 0 ? !a ? this.p = new D2d(16, this) : this.p = new B2d(17, a, this) : !a ? this.p = new D2d(18, this) : this.p = new B2d(19, a, this) : (this.Bb & dFe) != 0 ? !a ? this.p = new D2d(20, this) : this.p = new B2d(21, a, this) : !a ? this.p = new D2d(22, this) : this.p = new B2d(23, a, this) : (i = d.t, i > 1 || i == -1 ? this.$k() ? (this.Bb & dFe) != 0 ? !a ? this.p = new E2d(24, this, d) : this.p = new C2d(25, a, this, d) : !a ? this.p = new E2d(26, this, d) : this.p = new C2d(27, a, this, d) : (this.Bb & dFe) != 0 ? !a ? this.p = new E2d(28, this, d) : this.p = new C2d(29, a, this, d) : !a ? this.p = new E2d(30, this, d) : this.p = new C2d(31, a, this, d) : this.$k() ? (this.Bb & dFe) != 0 ? !a ? this.p = new E2d(32, this, d) : this.p = new C2d(33, a, this, d) : !a ? this.p = new E2d(34, this, d) : this.p = new C2d(35, a, this, d) : (this.Bb & dFe) != 0 ? !a ? this.p = new E2d(36, this, d) : this.p = new C2d(37, a, this, d) : !a ? this.p = new E2d(38, this, d) : this.p = new C2d(39, a, this, d)) : this.Yk() ? this.$k() ? this.p = new d3d(JD(e, 29), this, d) : this.p = new X2d(JD(e, 29), this, d) : RD(e, 155) ? a == Bab ? this.p = new D2d(40, this) : (this.Bb & dFe) != 0 ? !a ? this.p = new c4d(JD(e, 155), b, h, this) : this.p = new e4d(b, h, this, (v3d(), g == cE ? r3d : g == pcb ? m3d : g == dE ? s3d : g == bE ? q3d : g == aE ? p3d : g == ocb ? u3d : g == $D ? n3d : g == _D ? o3d : t3d)) : !a ? this.p = new X3d(JD(e, 155), b, h, this) : this.p = new Z3d(b, h, this, (v3d(), g == cE ? r3d : g == pcb ? m3d : g == dE ? s3d : g == bE ? q3d : g == aE ? p3d : g == ocb ? u3d : g == $D ? n3d : g == _D ? o3d : t3d)) : this.Zk() ? !d ? (this.Bb & dFe) != 0 ? this.$k() ? this.p = new y4d(JD(e, 29), this) : this.p = new w4d(JD(e, 29), this) : this.$k() ? this.p = new u4d(JD(e, 29), this) : this.p = new s4d(JD(e, 29), this) : (this.Bb & dFe) != 0 ? this.$k() ? this.p = new G4d(JD(e, 29), this, d) : this.p = new E4d(JD(e, 29), this, d) : this.$k() ? this.p = new C4d(JD(e, 29), this, d) : this.p = new A4d(JD(e, 29), this, d) : this.$k() ? !d ? (this.Bb & dFe) != 0 ? this.p = new K4d(JD(e, 29), this) : this.p = new I4d(JD(e, 29), this) : (this.Bb & dFe) != 0 ? this.p = new O4d(JD(e, 29), this, d) : this.p = new M4d(JD(e, 29), this, d) : !d ? (this.Bb & dFe) != 0 ? this.p = new Q4d(JD(e, 29), this) : this.p = new g4d(JD(e, 29), this) : (this.Bb & dFe) != 0 ? this.p = new U4d(JD(e, 29), this, d) : this.p = new S4d(JD(e, 29), this, d);
    }
    return this.p;
};
_.ok = function sSd() {
    return (this.Bb & NEe) != 0;
};
_.Yk = function tSd() {
    return false;
};
_.Zk = function uSd() {
    return false;
};
_.pk = function vSd() {
    return (this.Bb & ire) != 0;
};
_.uk = function wSd() {
    return RRd(this);
};
_.$k = function xSd() {
    return false;
};
_.qk = function ySd() {
    return (this.Bb & dFe) != 0;
};
_._k = function zSd(a) {
    this.k = a;
};
_.qi = function ASd(a) {
    XRd(this, a);
};
_.Ib = function BSd() {
    return _Rd(this);
};
_.e = false;
_.n = 0;
var k8 = jeb(TCe, 'EStructuralFeatureImpl', 448);
Ycb(330, 448, {
    109: 1,
    93: 1,
    92: 1,
    35: 1,
    154: 1,
    197: 1,
    57: 1,
    178: 1,
    69: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    330: 1,
    157: 1,
    448: 1,
    290: 1,
    117: 1,
    118: 1,
    677: 1
}, HSd);
_.Hh = function ISd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return jfb(this.s);
        case 5:
            return jfb(this.t);
        case 6:
            return xdb(), ESd(this) ? true : false;
        case 7:
            return xdb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return pRd(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return xdb(), (this.Bb & NEe) != 0 ? true : false;
        case 11:
            return xdb(), (this.Bb & wse) != 0 ? true : false;
        case 12:
            return xdb(), (this.Bb & Mse) != 0 ? true : false;
        case 13:
            return this.j;
        case 14:
            return ORd(this);
        case 15:
            return xdb(), (this.Bb & dFe) != 0 ? true : false;
        case 16:
            return xdb(), (this.Bb & ire) != 0 ? true : false;
        case 17:
            return PRd(this);
        case 18:
            return xdb(), (this.Bb & RCe) != 0 ? true : false;
        case 19:
            if (b) return DSd(this);
            return CSd(this);
    }
    return dqd(this, a - VTd((cPd(), IOd)), QTd((d = JD(Crd(this, 16), 29), !d ? IOd : d), a), b, c);
};
_.Sh = function JSd(a) {
    var b, c;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return ESd(this);
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && EZd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && EZd(this.q).i == 0);
        case 10:
            return (this.Bb & NEe) == 0;
        case 11:
            return (this.Bb & wse) != 0;
        case 12:
            return (this.Bb & Mse) != 0;
        case 13:
            return this.j != null;
        case 14:
            return ORd(this) != null;
        case 15:
            return (this.Bb & dFe) != 0;
        case 16:
            return (this.Bb & ire) != 0;
        case 17:
            return !!PRd(this);
        case 18:
            return (this.Bb & RCe) != 0;
        case 19:
            return !!CSd(this);
    }
    return eqd(this, a - VTd((cPd(), IOd)), QTd((b = JD(Crd(this, 16), 29), !b ? IOd : b), a));
};
_.Zh = function KSd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            XRd(this, OD(b));
            return;
        case 2:
            uRd(this, ydb(LD(b)));
            return;
        case 3:
            vRd(this, ydb(LD(b)));
            return;
        case 4:
            tRd(this, JD(b, 17).a);
            return;
        case 5:
            GSd(this, JD(b, 17).a);
            return;
        case 8:
            rRd(this, JD(b, 141));
            return;
        case 9:
            d = qRd(this, JD(b, 87), null);
            !!d && d.lj();
            return;
        case 10:
            SRd(this, ydb(LD(b)));
            return;
        case 11:
            $Rd(this, ydb(LD(b)));
            return;
        case 12:
            YRd(this, ydb(LD(b)));
            return;
        case 13:
            TRd(this, OD(b));
            return;
        case 15:
            ZRd(this, ydb(LD(b)));
            return;
        case 16:
            VRd(this, ydb(LD(b)));
            return;
        case 18:
            FSd(this, ydb(LD(b)));
            return;
    }
    fqd(this, a - VTd((cPd(), IOd)), QTd((c = JD(Crd(this, 16), 29), !c ? IOd : c), a), b);
};
_.ei = function LSd() {
    return cPd(), IOd;
};
_.gi = function MSd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 88) && QVd(TTd(JD(this.Cb, 88)), 4);
            rvd(this, null);
            return;
        case 2:
            uRd(this, true);
            return;
        case 3:
            vRd(this, true);
            return;
        case 4:
            tRd(this, 0);
            return;
        case 5:
            this.b = 0;
            wRd(this, 1);
            return;
        case 8:
            rRd(this, null);
            return;
        case 9:
            c = qRd(this, null, null);
            !!c && c.lj();
            return;
        case 10:
            SRd(this, true);
            return;
        case 11:
            $Rd(this, false);
            return;
        case 12:
            YRd(this, false);
            return;
        case 13:
            this.i = null;
            URd(this, null);
            return;
        case 15:
            ZRd(this, false);
            return;
        case 16:
            VRd(this, false);
            return;
        case 18:
            FSd(this, false);
            return;
    }
    gqd(this, a - VTd((cPd(), IOd)), QTd((b = JD(Crd(this, 16), 29), !b ? IOd : b), a));
};
_.li = function NSd() {
    DSd(this);
    Vae(jae((Gfe(), Efe), this));
    pRd(this);
    this.Bb |= 1;
};
_.Gk = function OSd() {
    return ESd(this);
};
_.Vk = function PSd(a, b) {
    this.b = 0;
    this.a = null;
    return sRd(this, a, b);
};
_.Wk = function QSd(a) {
    GSd(this, a);
};
_.Ib = function RSd() {
    var a;
    if ((this.Db & 64) != 0) return _Rd(this);
    a = new Jgb(_Rd(this));
    a.a += ' (iD: ';
    Fgb(a, (this.Bb & RCe) != 0);
    a.a += ')';
    return a.a;
};
_.b = 0;
var E6 = jeb(TCe, 'EAttributeImpl', 330);
Ycb(357, 436, {
    109: 1,
    93: 1,
    92: 1,
    141: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    357: 1,
    157: 1,
    117: 1,
    118: 1,
    676: 1
});
_.al = function gTd(a) {
    return a.zh() == this;
};
_.wh = function hTd(a) {
    return VSd(this, a);
};
_.xh = function iTd(a, b) {
    this.w = null;
    this.Db = b << 16 | this.Db & 255;
    this.Cb = a;
};
_.Hh = function jTd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return YSd(this);
        case 4:
            return this.fk();
        case 5:
            return this.F;
        case 6:
            if (b) return WSd(this);
            return SSd(this);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), this.A;
    }
    return dqd(this, a - VTd(this.ei()), QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), a), b, c);
};
_.Oh = function kTd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? VSd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 6, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), f.tk().wk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Qh = function lTd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 6:
            return bqd(this, null, 6, c);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), QGd(this.A, a, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), b), 69), e.tk().xk(this, Ard(this), b - VTd(this.ei()), a, c);
};
_.Sh = function mTd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!YSd(this);
        case 4:
            return this.fk() != null;
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!SSd(this);
        case 7:
            return !!this.A && this.A.i != 0;
    }
    return eqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.Zh = function nTd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            eTd(this, OD(b));
            return;
        case 2:
            bTd(this, OD(b));
            return;
        case 5:
            dTd(this, OD(b));
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            !this.A && (this.A = new Dde(r6, this, 7));
            vCd(this.A, JD(b, 16));
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((c = JD(Crd(this, 16), 29), !c ? this.ei() : c), a), b);
};
_.ei = function oTd() {
    return cPd(), KOd;
};
_.gi = function pTd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 184) && (JD(this.Cb, 184).tb = null);
            rvd(this, null);
            return;
        case 2:
            TSd(this, null);
            USd(this, this.D);
            return;
        case 5:
            dTd(this, null);
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.ek = function qTd() {
    var a;
    return this.G == -1 && (this.G = (a = WSd(this), a ? AUd(a.ri(), this) : -1)), this.G;
};
_.fk = function rTd() {
    return null;
};
_.gk = function sTd() {
    return WSd(this);
};
_.bl = function tTd() {
    return this.v;
};
_.hk = function uTd() {
    return YSd(this);
};
_.ik = function vTd() {
    return this.D != null ? this.D : this.B;
};
_.jk = function wTd() {
    return this.F;
};
_.ck = function xTd(a) {
    return $Sd(this, a);
};
_.cl = function yTd(a) {
    this.v = a;
};
_.dl = function zTd(a) {
    _Sd(this, a);
};
_.el = function ATd(a) {
    this.C = a;
};
_.qi = function BTd(a) {
    eTd(this, a);
};
_.Ib = function CTd() {
    return fTd(this);
};
_.C = null;
_.D = null;
_.G = -1;
var W6 = jeb(TCe, 'EClassifierImpl', 357);
Ycb(88, 357, {
    109: 1,
    93: 1,
    92: 1,
    29: 1,
    141: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    88: 1,
    357: 1,
    157: 1,
    468: 1,
    117: 1,
    118: 1,
    676: 1
}, aUd);
_.al = function bUd(a) {
    return YTd(this, a.zh());
};
_.Hh = function cUd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return YSd(this);
        case 4:
            return null;
        case 5:
            return this.F;
        case 6:
            if (b) return WSd(this);
            return SSd(this);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), this.A;
        case 8:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 9:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 10:
            return UTd(this);
        case 11:
            return !this.q && (this.q = new X0d(k6, this, 11, 10)), this.q;
        case 12:
            return HTd(this);
        case 13:
            return LTd(this);
        case 14:
            return LTd(this), this.r;
        case 15:
            return HTd(this), this.k;
        case 16:
            return ITd(this);
        case 17:
            return KTd(this);
        case 18:
            return MTd(this);
        case 19:
            return NTd(this);
        case 20:
            return HTd(this), this.o;
        case 21:
            return !this.s && (this.s = new X0d(q6, this, 21, 17)), this.s;
        case 22:
            return OTd(this);
        case 23:
            return JTd(this);
    }
    return dqd(this, a - VTd((cPd(), JOd)), QTd((d = JD(Crd(this, 16), 29), !d ? JOd : d), a), b, c);
};
_.Oh = function dUd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? VSd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 6, c);
        case 11:
            return !this.q && (this.q = new X0d(k6, this, 11, 10)), PGd(this.q, a, c);
        case 21:
            return !this.s && (this.s = new X0d(q6, this, 21, 17)), PGd(this.s, a, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), JOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), JOd)), a, c);
};
_.Qh = function eUd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 6:
            return bqd(this, null, 6, c);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), QGd(this.A, a, c);
        case 11:
            return !this.q && (this.q = new X0d(k6, this, 11, 10)), QGd(this.q, a, c);
        case 21:
            return !this.s && (this.s = new X0d(q6, this, 21, 17)), QGd(this.s, a, c);
        case 22:
            return QGd(OTd(this), a, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), JOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), JOd)), a, c);
};
_.Sh = function fUd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!YSd(this);
        case 4:
            return false;
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!SSd(this);
        case 7:
            return !!this.A && this.A.i != 0;
        case 8:
            return (this.Bb & 256) != 0;
        case 9:
            return (this.Bb & 512) != 0;
        case 10:
            return !!this.u && OTd(this.u.a).i != 0 && !(!!this.n && yVd(this.n));
        case 11:
            return !!this.q && this.q.i != 0;
        case 12:
            return HTd(this).i != 0;
        case 13:
            return LTd(this).i != 0;
        case 14:
            return LTd(this), this.r.i != 0;
        case 15:
            return HTd(this), this.k.i != 0;
        case 16:
            return ITd(this).i != 0;
        case 17:
            return KTd(this).i != 0;
        case 18:
            return MTd(this).i != 0;
        case 19:
            return NTd(this).i != 0;
        case 20:
            return HTd(this), !!this.o;
        case 21:
            return !!this.s && this.s.i != 0;
        case 22:
            return !!this.n && yVd(this.n);
        case 23:
            return JTd(this).i != 0;
    }
    return eqd(this, a - VTd((cPd(), JOd)), QTd((b = JD(Crd(this, 16), 29), !b ? JOd : b), a));
};
_.Vh = function gUd(a) {
    var b;
    b = this.i == null || !!this.q && this.q.i != 0 ? null : RTd(this, a);
    return b ? b : Dud(this, a);
};
_.Zh = function hUd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            eTd(this, OD(b));
            return;
        case 2:
            bTd(this, OD(b));
            return;
        case 5:
            dTd(this, OD(b));
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            !this.A && (this.A = new Dde(r6, this, 7));
            vCd(this.A, JD(b, 16));
            return;
        case 8:
            ZTd(this, ydb(LD(b)));
            return;
        case 9:
            $Td(this, ydb(LD(b)));
            return;
        case 10:
            sFd(UTd(this));
            vCd(UTd(this), JD(b, 16));
            return;
        case 11:
            !this.q && (this.q = new X0d(k6, this, 11, 10));
            RGd(this.q);
            !this.q && (this.q = new X0d(k6, this, 11, 10));
            vCd(this.q, JD(b, 16));
            return;
        case 21:
            !this.s && (this.s = new X0d(q6, this, 21, 17));
            RGd(this.s);
            !this.s && (this.s = new X0d(q6, this, 21, 17));
            vCd(this.s, JD(b, 16));
            return;
        case 22:
            RGd(OTd(this));
            vCd(OTd(this), JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), JOd)), QTd((c = JD(Crd(this, 16), 29), !c ? JOd : c), a), b);
};
_.ei = function iUd() {
    return cPd(), JOd;
};
_.gi = function jUd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 184) && (JD(this.Cb, 184).tb = null);
            rvd(this, null);
            return;
        case 2:
            TSd(this, null);
            USd(this, this.D);
            return;
        case 5:
            dTd(this, null);
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            return;
        case 8:
            ZTd(this, false);
            return;
        case 9:
            $Td(this, false);
            return;
        case 10:
            !!this.u && sFd(this.u);
            return;
        case 11:
            !this.q && (this.q = new X0d(k6, this, 11, 10));
            RGd(this.q);
            return;
        case 21:
            !this.s && (this.s = new X0d(q6, this, 21, 17));
            RGd(this.s);
            return;
        case 22:
            !!this.n && RGd(this.n);
            return;
    }
    gqd(this, a - VTd((cPd(), JOd)), QTd((b = JD(Crd(this, 16), 29), !b ? JOd : b), a));
};
_.li = function kUd() {
    var a, b;
    HTd(this);
    LTd(this);
    ITd(this);
    KTd(this);
    MTd(this);
    NTd(this);
    JTd(this);
    lDd(LVd(TTd(this)));
    if (this.s) for(a = 0, b = this.s.i; a < b; ++a)Eud(nDd(this.s, a));
    if (this.q) for(a = 0, b = this.q.i; a < b; ++a)Eud(nDd(this.q, a));
    hae((Gfe(), Efe), this).ve();
    this.Bb |= 1;
};
_.Ib = function lUd() {
    return _Td(this);
};
_.k = null;
_.r = null;
var DTd, ETd, FTd;
var V6 = jeb(TCe, 'EClassImpl', 88);
Ycb(2038, 2037, oFe);
_.Bi = function mUd(a, b) {
    return MGd(this, a, b);
};
_.Ci = function nUd(a) {
    return MGd(this, this.i, a);
};
_.Di = function oUd(a, b) {
    NGd(this, a, b);
};
_.Ei = function pUd(a) {
    OGd(this, a);
};
_.Tk = function qUd(a, b) {
    return PGd(this, a, b);
};
_.Xi = function rUd(a) {
    return kDd(this, a);
};
_.Uk = function vUd(a, b) {
    return QGd(this, a, b);
};
_.Ui = function wUd(a, b) {
    return WGd(this, a, b);
};
_.Fi = function sUd() {
    return new XHd(this);
};
_.Gi = function tUd() {
    return new $Hd(this);
};
_.Hi = function uUd(a) {
    return wCd(this, a);
};
var Mab = jeb(_Ee, 'NotifyingInternalEListImpl', 2038);
Ycb(617, 2038, pFe);
_.Gc = function GUd(a) {
    return xUd(this, a);
};
_.Fj = function HUd(a, b, c, d, e) {
    return yUd(this, a, b, c, d, e);
};
_.Gj = function IUd(a) {
    zUd(this, a);
};
_.Ck = function JUd(a) {
    return this;
};
_.Ik = function KUd() {
    return QTd(this.e.zh(), this.Ij());
};
_.Hj = function LUd() {
    return this.Ik();
};
_.Ij = function MUd() {
    return WTd(this.e.zh(), this.Ik());
};
_.fl = function NUd() {
    return JD(this.Ik().Ek(), 29).hk();
};
_.gl = function OUd() {
    return s1d(JD(this.Ik(), 19)).n;
};
_.gj = function PUd() {
    return this.e;
};
_.hl = function QUd() {
    return true;
};
_.il = function RUd() {
    return false;
};
_.jl = function SUd() {
    return false;
};
_.kl = function TUd() {
    return false;
};
_.bd = function UUd(a) {
    return AUd(this, a);
};
_.Kj = function VUd(a, b) {
    var c;
    return c = JD(a, 52), this.jl() ? this.hl() ? c.Nh(this.e, this.gl(), this.fl(), b) : c.Nh(this.e, WTd(c.zh(), s1d(JD(this.Ik(), 19))), null, b) : c.Nh(this.e, -1 - this.Ij(), null, b);
};
_.Lj = function WUd(a, b) {
    var c;
    return c = JD(a, 52), this.jl() ? this.hl() ? c.Ph(this.e, this.gl(), this.fl(), b) : c.Ph(this.e, WTd(c.zh(), s1d(JD(this.Ik(), 19))), null, b) : c.Ph(this.e, -1 - this.Ij(), null, b);
};
_.Zk = function XUd() {
    return false;
};
_.ll = function YUd() {
    return true;
};
_.ck = function ZUd(a) {
    return jNd(this.d, a);
};
_.Mj = function $Ud() {
    return qqd(this.e);
};
_.Nj = function _Ud() {
    return this.i != 0;
};
_.Zi = function aVd(a) {
    return fId(this.d, a);
};
_.Ti = function bVd(a, b) {
    return this.ll() && this.kl() ? BUd(this, a, JD(b, 57)) : b;
};
_.ml = function cVd(a) {
    return a.Rh() ? zqd(this.e, JD(a, 52)) : a;
};
_.Wb = function dVd(a) {
    CUd(this, a);
};
_.Nc = function eVd() {
    return DUd(this);
};
_.Oc = function fVd(a) {
    var b;
    if (this.kl()) for(b = this.i - 1; b >= 0; --b)nDd(this, b);
    return uDd(this, a);
};
_.Dk = function gVd() {
    RGd(this);
};
_.Wi = function hVd(a, b) {
    return EUd(this, a, b);
};
var qab = jeb(_Ee, 'EcoreEList', 617);
Ycb(489, 617, pFe, iVd);
_.Ii = function jVd() {
    return false;
};
_.Ij = function kVd() {
    return this.c;
};
_.Jj = function lVd() {
    return false;
};
_.ll = function mVd() {
    return true;
};
_.Pi = function nVd() {
    return true;
};
_.Ti = function oVd(a, b) {
    return b;
};
_.Vi = function pVd() {
    return false;
};
_.c = 0;
var aab = jeb(_Ee, 'EObjectEList', 489);
Ycb(81, 489, pFe, qVd);
_.Jj = function rVd() {
    return true;
};
_.jl = function sVd() {
    return false;
};
_.Zk = function tVd() {
    return true;
};
var W9 = jeb(_Ee, 'EObjectContainmentEList', 81);
Ycb(540, 81, pFe, uVd);
_.Ki = function vVd() {
    this.b = true;
};
_.Nj = function wVd() {
    return this.b;
};
_.Dk = function xVd() {
    var a;
    RGd(this);
    if (qqd(this.e)) {
        a = this.b;
        this.b = false;
        Wpd(this.e, new j_d(this.e, 2, this.c, a, false));
    } else this.b = false;
};
_.b = false;
var V9 = jeb(_Ee, 'EObjectContainmentEList/Unsettable', 540);
Ycb(1125, 540, pFe, CVd);
_.Qi = function GVd(a, b) {
    var c, d;
    return c = JD(TGd(this, a, b), 87), qqd(this.e) && zUd(this, new x_d(this.a, 7, (cPd(), LOd), jfb(b), (d = c.c, RD(d, 88) ? JD(d, 29) : UOd), a)), c;
};
_.Rj = function HVd(a, b) {
    return zVd(this, JD(a, 87), b);
};
_.Sj = function IVd(a, b) {
    return AVd(this, JD(a, 87), b);
};
_.Tj = function JVd(a, b, c) {
    return BVd(this, JD(a, 87), JD(b, 87), c);
};
_.Fj = function DVd(a, b, c, d, e) {
    switch(a){
        case 3:
            return yUd(this, a, b, c, d, this.i > 1);
        case 5:
            return yUd(this, a, b, c, d, this.i - JD(c, 15).gc() > 0);
        default:
            return new i_d(this.e, a, this.c, b, c, d, true);
    }
};
_.Qj = function EVd() {
    return true;
};
_.Nj = function FVd() {
    return yVd(this);
};
_.Dk = function KVd() {
    RGd(this);
};
var K6 = jeb(TCe, 'EClassImpl/1', 1125);
Ycb(1139, 1138, FEe);
_.aj = function OVd(a) {
    var b, c, d, e, f, g, h;
    c = a.dj();
    if (c != 8) {
        d = NVd(a);
        if (d == 0) switch(c){
            case 1:
            case 9:
                h = a.hj();
                if (h != null) {
                    b = TTd(JD(h, 468));
                    !b.c && (b.c = new q5d);
                    CCd(b.c, a.gj());
                }
                g = a.fj();
                if (g != null) {
                    e = JD(g, 468);
                    if ((e.Bb & 1) == 0) {
                        b = TTd(e);
                        !b.c && (b.c = new q5d);
                        tCd(b.c, JD(a.gj(), 29));
                    }
                }
                break;
            case 3:
                g = a.fj();
                if (g != null) {
                    e = JD(g, 468);
                    if ((e.Bb & 1) == 0) {
                        b = TTd(e);
                        !b.c && (b.c = new q5d);
                        tCd(b.c, JD(a.gj(), 29));
                    }
                }
                break;
            case 5:
                g = a.fj();
                if (g != null) for(f = JD(g, 16).Jc(); f.Ob();){
                    e = JD(f.Pb(), 468);
                    if ((e.Bb & 1) == 0) {
                        b = TTd(e);
                        !b.c && (b.c = new q5d);
                        tCd(b.c, JD(a.gj(), 29));
                    }
                }
                break;
            case 4:
                h = a.hj();
                if (h != null) {
                    e = JD(h, 468);
                    if ((e.Bb & 1) == 0) {
                        b = TTd(e);
                        !b.c && (b.c = new q5d);
                        CCd(b.c, a.gj());
                    }
                }
                break;
            case 6:
                h = a.hj();
                if (h != null) for(f = JD(h, 16).Jc(); f.Ob();){
                    e = JD(f.Pb(), 468);
                    if ((e.Bb & 1) == 0) {
                        b = TTd(e);
                        !b.c && (b.c = new q5d);
                        CCd(b.c, a.gj());
                    }
                }
                break;
        }
        this.nl(d);
    }
};
_.nl = function PVd(a) {
    MVd(this, a);
};
_.b = 63;
var m8 = jeb(TCe, 'ESuperAdapter', 1139);
Ycb(1140, 1139, FEe, RVd);
_.nl = function SVd(a) {
    QVd(this, a);
};
var F6 = jeb(TCe, 'EClassImpl/10', 1140);
Ycb(1129, 694, pFe);
_.Bi = function TVd(a, b) {
    return fDd(this, a, b);
};
_.Ci = function UVd(a) {
    return gDd(this, a);
};
_.Di = function VVd(a, b) {
    hDd(this, a, b);
};
_.Ei = function WVd(a) {
    iDd(this, a);
};
_.Xi = function YVd(a) {
    return kDd(this, a);
};
_.Ui = function eWd(a, b) {
    return rDd(this, a, b);
};
_.Tk = function XVd(a, b) {
    throw scb(new ahb);
};
_.Fi = function ZVd() {
    return new XHd(this);
};
_.Gi = function $Vd() {
    return new $Hd(this);
};
_.Hi = function _Vd(a) {
    return wCd(this, a);
};
_.Uk = function aWd(a, b) {
    throw scb(new ahb);
};
_.Ck = function bWd(a) {
    return this;
};
_.Nj = function cWd() {
    return this.i != 0;
};
_.Wb = function dWd(a) {
    throw scb(new ahb);
};
_.Dk = function fWd() {
    throw scb(new ahb);
};
var pab = jeb(_Ee, 'EcoreEList/UnmodifiableEList', 1129);
Ycb(328, 1129, pFe, gWd);
_.Vi = function hWd() {
    return false;
};
var oab = jeb(_Ee, 'EcoreEList/UnmodifiableEList/FastCompare', 328);
Ycb(1132, 328, pFe, kWd);
_.bd = function lWd(a) {
    var b, c, d;
    if (RD(a, 178)) {
        b = JD(a, 178);
        c = b.Ij();
        if (c != -1) for(d = this.i; c < d; ++c){
            if (XD(this.g[c]) === XD(a)) return c;
        }
    }
    return -1;
};
var G6 = jeb(TCe, 'EClassImpl/1EAllStructuralFeaturesList', 1132);
Ycb(1126, 490, QDe, pWd);
_.Zi = function qWd(a) {
    return SC(g6, tFe, 87, a, 0, 1);
};
_.Vi = function rWd() {
    return false;
};
var H6 = jeb(TCe, 'EClassImpl/1EGenericSuperTypeEList', 1126);
Ycb(618, 490, QDe, sWd);
_.Zi = function tWd(a) {
    return SC(q6, mFe, 178, a, 0, 1);
};
_.Vi = function uWd() {
    return false;
};
var I6 = jeb(TCe, 'EClassImpl/1EStructuralFeatureUniqueEList', 618);
Ycb(738, 490, QDe, vWd);
_.Zi = function wWd(a) {
    return SC(n6, mFe, 19, a, 0, 1);
};
_.Vi = function xWd() {
    return false;
};
var J6 = jeb(TCe, 'EClassImpl/1ReferenceList', 738);
Ycb(1127, 490, QDe, zWd);
_.Ji = function AWd(a, b) {
    yWd(this, JD(b, 35));
};
_.Zi = function BWd(a) {
    return SC($5, mFe, 35, a, 0, 1);
};
_.Vi = function CWd() {
    return false;
};
var L6 = jeb(TCe, 'EClassImpl/2', 1127);
Ycb(1128, 490, QDe, DWd);
_.Zi = function EWd(a) {
    return SC($5, mFe, 35, a, 0, 1);
};
_.Vi = function FWd() {
    return false;
};
var M6 = jeb(TCe, 'EClassImpl/3', 1128);
Ycb(1130, 328, pFe, IWd);
_.Ec = function JWd(a) {
    return GWd(this, JD(a, 35));
};
_.Ei = function KWd(a) {
    HWd(this, JD(a, 35));
};
var N6 = jeb(TCe, 'EClassImpl/4', 1130);
Ycb(1131, 328, pFe, NWd);
_.Ec = function OWd(a) {
    return LWd(this, JD(a, 19));
};
_.Ei = function PWd(a) {
    MWd(this, JD(a, 19));
};
var O6 = jeb(TCe, 'EClassImpl/5', 1131);
Ycb(1133, 490, QDe, QWd);
_.Zi = function RWd(a) {
    return SC(k6, nFe, 62, a, 0, 1);
};
_.Vi = function SWd() {
    return false;
};
var P6 = jeb(TCe, 'EClassImpl/6', 1133);
Ycb(1134, 490, QDe, TWd);
_.Zi = function UWd(a) {
    return SC(n6, mFe, 19, a, 0, 1);
};
_.Vi = function VWd() {
    return false;
};
var Q6 = jeb(TCe, 'EClassImpl/7', 1134);
Ycb(2041, 2040, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1,
    71: 1
});
_.Bi = function WWd(a, b) {
    return nFd(this, a, b);
};
_.Ci = function XWd(a) {
    return nFd(this, this.Bj(), a);
};
_.Di = function YWd(a, b) {
    oFd(this, a, b);
};
_.Ei = function ZWd(a) {
    pFd(this, a);
};
_.Tk = function $Wd(a, b) {
    return qFd(this, a, b);
};
_.Uk = function eXd(a, b) {
    return rFd(this, a, b);
};
_.Ui = function fXd(a, b) {
    return tFd(this, a, b);
};
_.Xi = function _Wd(a) {
    return this.uj(a);
};
_.Fi = function aXd() {
    return new XHd(this);
};
_.mj = function bXd() {
    return this.pj();
};
_.Gi = function cXd() {
    return new $Hd(this);
};
_.Hi = function dXd(a) {
    return wCd(this, a);
};
var I9 = jeb(_Ee, 'DelegatingNotifyingInternalEListImpl', 2041);
Ycb(739, 2041, uFe);
_.Ii = function kXd() {
    var a;
    a = QTd(yrd(this.b), this.Ij()).Ek();
    return RD(a, 155) && !RD(a, 455) && (a.hk().i & 1) == 0;
};
_.Gc = function lXd(a) {
    var b, c, d, e, f, g, h, i;
    if (this.ll()) {
        i = this.Bj();
        if (i > 4) {
            if (this.ck(a)) {
                if (this.Zk()) {
                    d = JD(a, 52);
                    c = d.Ah();
                    h = c == this.b && (this.jl() ? d.uh(d.Bh(), JD(QTd(yrd(this.b), this.Ij()).Ek(), 29).hk()) == s1d(JD(QTd(yrd(this.b), this.Ij()), 19)).n : -1 - d.Bh() == this.Ij());
                    if (this.kl() && !h && !c && !!d.Fh()) for(e = 0; e < i; ++e){
                        b = hXd(this, this.uj(e));
                        if (XD(b) === XD(a)) return true;
                    }
                    return h;
                } else if (this.jl() && !this.il()) {
                    f = JD(a, 57).Ih(s1d(JD(QTd(yrd(this.b), this.Ij()), 19)));
                    if (XD(f) === XD(this.b)) return true;
                    else if (f == null || !JD(f, 57).Rh()) return false;
                }
            } else return false;
        }
        g = this.rj(a);
        if (this.kl() && !g) for(e = 0; e < i; ++e){
            d = hXd(this, this.uj(e));
            if (XD(d) === XD(a)) return true;
        }
        return g;
    } else return this.rj(a);
};
_.Fj = function mXd(a, b, c, d, e) {
    return new i_d(this.b, a, this.Ij(), b, c, d, e);
};
_.Gj = function nXd(a) {
    Wpd(this.b, a);
};
_.Ck = function oXd(a) {
    return this;
};
_.Hj = function pXd() {
    return QTd(yrd(this.b), this.Ij());
};
_.Ij = function qXd() {
    return WTd(yrd(this.b), QTd(yrd(this.b), this.Ij()));
};
_.gj = function rXd() {
    return this.b;
};
_.hl = function sXd() {
    return !!QTd(yrd(this.b), this.Ij()).Ek().hk();
};
_.Jj = function tXd() {
    var a, b;
    b = QTd(yrd(this.b), this.Ij());
    if (RD(b, 101)) {
        a = JD(b, 19);
        return (a.Bb & RCe) != 0 || !!s1d(JD(b, 19));
    } else return false;
};
_.il = function uXd() {
    var a, b, c, d;
    b = QTd(yrd(this.b), this.Ij());
    if (RD(b, 101)) {
        a = JD(b, 19);
        c = s1d(a);
        return !!c && (d = c.t, d > 1 || d == -1);
    } else return false;
};
_.jl = function vXd() {
    var a, b, c;
    b = QTd(yrd(this.b), this.Ij());
    if (RD(b, 101)) {
        a = JD(b, 19);
        c = s1d(a);
        return !!c;
    } else return false;
};
_.kl = function wXd() {
    var a, b;
    b = QTd(yrd(this.b), this.Ij());
    if (RD(b, 101)) {
        a = JD(b, 19);
        return (a.Bb & Pse) != 0;
    } else return false;
};
_.bd = function xXd(a) {
    var b, c, d, e;
    d = this.wj(a);
    if (d >= 0) return d;
    if (this.ll()) for(c = 0, e = this.Bj(); c < e; ++c){
        b = hXd(this, this.uj(c));
        if (XD(b) === XD(a)) return c;
    }
    return -1;
};
_.Kj = function yXd(a, b) {
    var c;
    return c = JD(a, 52), this.jl() ? this.hl() ? c.Nh(this.b, s1d(JD(QTd(yrd(this.b), this.Ij()), 19)).n, JD(QTd(yrd(this.b), this.Ij()).Ek(), 29).hk(), b) : c.Nh(this.b, WTd(c.zh(), s1d(JD(QTd(yrd(this.b), this.Ij()), 19))), null, b) : c.Nh(this.b, -1 - this.Ij(), null, b);
};
_.Lj = function zXd(a, b) {
    var c;
    return c = JD(a, 52), this.jl() ? this.hl() ? c.Ph(this.b, s1d(JD(QTd(yrd(this.b), this.Ij()), 19)).n, JD(QTd(yrd(this.b), this.Ij()).Ek(), 29).hk(), b) : c.Ph(this.b, WTd(c.zh(), s1d(JD(QTd(yrd(this.b), this.Ij()), 19))), null, b) : c.Ph(this.b, -1 - this.Ij(), null, b);
};
_.Zk = function AXd() {
    var a, b;
    b = QTd(yrd(this.b), this.Ij());
    if (RD(b, 101)) {
        a = JD(b, 19);
        return (a.Bb & RCe) != 0;
    } else return false;
};
_.ll = function BXd() {
    return RD(QTd(yrd(this.b), this.Ij()).Ek(), 88);
};
_.ck = function CXd(a) {
    return QTd(yrd(this.b), this.Ij()).Ek().ck(a);
};
_.Mj = function DXd() {
    return qqd(this.b);
};
_.Nj = function EXd() {
    return !this.xj();
};
_.Pi = function FXd() {
    return QTd(yrd(this.b), this.Ij()).Pi();
};
_.Ti = function GXd(a, b) {
    return gXd(this, a, b);
};
_.Wb = function HXd(a) {
    sFd(this);
    vCd(this, JD(a, 15));
};
_.Nc = function IXd() {
    var a;
    if (this.kl()) for(a = this.Bj() - 1; a >= 0; --a)gXd(this, a, this.uj(a));
    return this.Cj();
};
_.Oc = function JXd(a) {
    var b;
    if (this.kl()) for(b = this.Bj() - 1; b >= 0; --b)gXd(this, b, this.uj(b));
    return this.Dj(a);
};
_.Dk = function KXd() {
    sFd(this);
};
_.Wi = function LXd(a, b) {
    return iXd(this, a, b);
};
var H9 = jeb(_Ee, 'DelegatingEcoreEList', 739);
Ycb(1135, 739, uFe, RXd);
_.nj = function UXd(a, b) {
    MXd(this, a, JD(b, 29));
};
_.oj = function VXd(a) {
    NXd(this, JD(a, 29));
};
_.uj = function _Xd(a) {
    var b, c;
    return b = JD(nDd(OTd(this.a), a), 87), c = b.c, RD(c, 88) ? JD(c, 29) : (cPd(), UOd);
};
_.zj = function eYd(a) {
    var b, c;
    return b = JD(UGd(OTd(this.a), a), 87), c = b.c, RD(c, 88) ? JD(c, 29) : (cPd(), UOd);
};
_.Aj = function fYd(a, b) {
    return PXd(this, a, JD(b, 29));
};
_.Ii = function SXd() {
    return false;
};
_.Fj = function TXd(a, b, c, d, e) {
    return null;
};
_.pj = function WXd() {
    return new xYd(this);
};
_.qj = function XXd() {
    RGd(OTd(this.a));
};
_.rj = function YXd(a) {
    return OXd(this, a);
};
_.sj = function ZXd(a) {
    var b, c;
    for(c = a.Jc(); c.Ob();){
        b = c.Pb();
        if (!OXd(this, b)) return false;
    }
    return true;
};
_.tj = function $Xd(a) {
    var b, c, d;
    if (RD(a, 15)) {
        d = JD(a, 15);
        if (d.gc() == OTd(this.a).i) {
            for(b = d.Jc(), c = new CHd(this); b.Ob();){
                if (XD(b.Pb()) !== XD(AHd(c))) return false;
            }
            return true;
        }
    }
    return false;
};
_.vj = function aYd() {
    var a, b, c, d, e;
    c = 1;
    for(b = new CHd(OTd(this.a)); b.e != b.i.gc();){
        a = JD(AHd(b), 87);
        d = (e = a.c, RD(e, 88) ? JD(e, 29) : (cPd(), UOd));
        c = 31 * c + (!d ? 0 : jDb(d));
    }
    return c;
};
_.wj = function bYd(a) {
    var b, c, d, e;
    d = 0;
    for(c = new CHd(OTd(this.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 87);
        if (XD(a) === XD((e = b.c, RD(e, 88) ? JD(e, 29) : (cPd(), UOd)))) return d;
        ++d;
    }
    return -1;
};
_.xj = function cYd() {
    return OTd(this.a).i == 0;
};
_.yj = function dYd() {
    return null;
};
_.Bj = function gYd() {
    return OTd(this.a).i;
};
_.Cj = function hYd() {
    var a, b, c, d, e, f;
    f = OTd(this.a).i;
    e = SC(aJ, Nqe, 1, f, 5, 1);
    c = 0;
    for(b = new CHd(OTd(this.a)); b.e != b.i.gc();){
        a = JD(AHd(b), 87);
        e[c++] = (d = a.c, RD(d, 88) ? JD(d, 29) : (cPd(), UOd));
    }
    return e;
};
_.Dj = function iYd(a) {
    var b, c, d, e, f, g, h;
    h = OTd(this.a).i;
    if (a.length < h) {
        e = fId(rb(a).c, h);
        a = e;
    }
    a.length > h && VC(a, h, null);
    d = 0;
    for(c = new CHd(OTd(this.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 87);
        f = (g = b.c, RD(g, 88) ? JD(g, 29) : (cPd(), UOd));
        VC(a, d++, f);
    }
    return a;
};
_.Ej = function jYd() {
    var a, b, c, d, e;
    e = new Hgb;
    e.a += '[';
    a = OTd(this.a);
    for(b = 0, d = OTd(this.a).i; b < d;){
        Egb(e, xgb((c = JD(nDd(a, b), 87).c, RD(c, 88) ? JD(c, 29) : (cPd(), UOd))));
        ++b < d && (e.a += Lqe, e);
    }
    e.a += ']';
    return e.a;
};
_.Gj = function kYd(a) {};
_.Ij = function lYd() {
    return 10;
};
_.hl = function mYd() {
    return true;
};
_.Jj = function nYd() {
    return false;
};
_.il = function oYd() {
    return false;
};
_.jl = function pYd() {
    return false;
};
_.kl = function qYd() {
    return true;
};
_.Zk = function rYd() {
    return false;
};
_.ll = function sYd() {
    return true;
};
_.ck = function tYd(a) {
    return RD(a, 88);
};
_.Nj = function uYd() {
    return XTd(this.a);
};
_.Pi = function vYd() {
    return true;
};
_.Vi = function wYd() {
    return true;
};
var S6 = jeb(TCe, 'EClassImpl/8', 1135);
Ycb(1136, 2008, Fre, xYd);
_.dd = function yYd(a) {
    return wCd(this.a, a);
};
_.gc = function zYd() {
    return OTd(this.a.a).i;
};
var R6 = jeb(TCe, 'EClassImpl/8/1', 1136);
Ycb(1137, 490, QDe, AYd);
_.Zi = function BYd(a) {
    return SC(a6, Nqe, 141, a, 0, 1);
};
_.Vi = function CYd() {
    return false;
};
var T6 = jeb(TCe, 'EClassImpl/9', 1137);
Ycb(1124, 50, cte, DYd);
var U6 = jeb(TCe, 'EClassImpl/MyHashSet', 1124);
Ycb(559, 357, {
    109: 1,
    93: 1,
    92: 1,
    141: 1,
    155: 1,
    826: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    357: 1,
    157: 1,
    117: 1,
    118: 1,
    676: 1
}, FYd);
_.Hh = function GYd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return YSd(this);
        case 4:
            return this.fk();
        case 5:
            return this.F;
        case 6:
            if (b) return WSd(this);
            return SSd(this);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), this.A;
        case 8:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
    }
    return dqd(this, a - VTd(this.ei()), QTd((d = JD(Crd(this, 16), 29), !d ? this.ei() : d), a), b, c);
};
_.Sh = function HYd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!YSd(this);
        case 4:
            return this.fk() != null;
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!SSd(this);
        case 7:
            return !!this.A && this.A.i != 0;
        case 8:
            return (this.Bb & 256) == 0;
    }
    return eqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.Zh = function IYd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            eTd(this, OD(b));
            return;
        case 2:
            bTd(this, OD(b));
            return;
        case 5:
            dTd(this, OD(b));
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            !this.A && (this.A = new Dde(r6, this, 7));
            vCd(this.A, JD(b, 16));
            return;
        case 8:
            EYd(this, ydb(LD(b)));
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((c = JD(Crd(this, 16), 29), !c ? this.ei() : c), a), b);
};
_.ei = function JYd() {
    return cPd(), MOd;
};
_.gi = function KYd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 184) && (JD(this.Cb, 184).tb = null);
            rvd(this, null);
            return;
        case 2:
            TSd(this, null);
            USd(this, this.D);
            return;
        case 5:
            dTd(this, null);
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            return;
        case 8:
            EYd(this, true);
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((b = JD(Crd(this, 16), 29), !b ? this.ei() : b), a));
};
_.li = function LYd() {
    hae((Gfe(), Efe), this).ve();
    this.Bb |= 1;
};
_.lk = function MYd() {
    var a, b, c;
    if (!this.c) {
        a = dfe(WSd(this));
        if (!a.dc()) for(c = a.Jc(); c.Ob();){
            b = OD(c.Pb());
            !!Fud(this, b) && cfe(this);
        }
    }
    return this.b;
};
_.fk = function NYd() {
    var b;
    if (!this.e) {
        b = null;
        try {
            b = YSd(this);
        } catch (a) {
            a = rcb(a);
            if (!RD(a, 103)) throw scb(a);
        }
        this.d = null;
        !!b && (b.i & 1) != 0 && (b == pcb ? this.d = (xdb(), vdb) : b == cE ? this.d = jfb(0) : b == bE ? this.d = new Keb(0) : b == aE ? this.d = 0 : b == dE ? this.d = yfb(0) : b == ocb ? this.d = Ufb(0) : b == $D ? this.d = Rdb(0) : this.d = $db(0));
        this.e = true;
    }
    return this.d;
};
_.kk = function OYd() {
    return (this.Bb & 256) != 0;
};
_.ol = function PYd(a) {
    a && (this.D = 'org.eclipse.emf.common.util.AbstractEnumerator');
};
_.dl = function QYd(a) {
    _Sd(this, a);
    this.ol(a);
};
_.el = function RYd(a) {
    this.C = a;
    this.e = false;
};
_.Ib = function SYd() {
    var a;
    if ((this.Db & 64) != 0) return fTd(this);
    a = new Jgb(fTd(this));
    a.a += ' (serializable: ';
    Fgb(a, (this.Bb & 256) != 0);
    a.a += ')';
    return a.a;
};
_.c = false;
_.d = null;
_.e = false;
var X6 = jeb(TCe, 'EDataTypeImpl', 559);
Ycb(455, 559, {
    109: 1,
    93: 1,
    92: 1,
    141: 1,
    155: 1,
    826: 1,
    670: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    357: 1,
    455: 1,
    157: 1,
    117: 1,
    118: 1,
    676: 1
}, VYd);
_.Hh = function WYd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return YSd(this);
        case 4:
            return TYd(this);
        case 5:
            return this.F;
        case 6:
            if (b) return WSd(this);
            return SSd(this);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), this.A;
        case 8:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 9:
            return !this.a && (this.a = new X0d(d6, this, 9, 5)), this.a;
    }
    return dqd(this, a - VTd((cPd(), NOd)), QTd((d = JD(Crd(this, 16), 29), !d ? NOd : d), a), b, c);
};
_.Oh = function XYd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? VSd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 6, c);
        case 9:
            return !this.a && (this.a = new X0d(d6, this, 9, 5)), PGd(this.a, a, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), NOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), NOd)), a, c);
};
_.Qh = function YYd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 6:
            return bqd(this, null, 6, c);
        case 7:
            return !this.A && (this.A = new Dde(r6, this, 7)), QGd(this.A, a, c);
        case 9:
            return !this.a && (this.a = new X0d(d6, this, 9, 5)), QGd(this.a, a, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), NOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), NOd)), a, c);
};
_.Sh = function ZYd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!YSd(this);
        case 4:
            return !!TYd(this);
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!SSd(this);
        case 7:
            return !!this.A && this.A.i != 0;
        case 8:
            return (this.Bb & 256) == 0;
        case 9:
            return !!this.a && this.a.i != 0;
    }
    return eqd(this, a - VTd((cPd(), NOd)), QTd((b = JD(Crd(this, 16), 29), !b ? NOd : b), a));
};
_.Zh = function $Yd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            eTd(this, OD(b));
            return;
        case 2:
            bTd(this, OD(b));
            return;
        case 5:
            dTd(this, OD(b));
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            !this.A && (this.A = new Dde(r6, this, 7));
            vCd(this.A, JD(b, 16));
            return;
        case 8:
            EYd(this, ydb(LD(b)));
            return;
        case 9:
            !this.a && (this.a = new X0d(d6, this, 9, 5));
            RGd(this.a);
            !this.a && (this.a = new X0d(d6, this, 9, 5));
            vCd(this.a, JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), NOd)), QTd((c = JD(Crd(this, 16), 29), !c ? NOd : c), a), b);
};
_.ei = function _Yd() {
    return cPd(), NOd;
};
_.gi = function aZd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 184) && (JD(this.Cb, 184).tb = null);
            rvd(this, null);
            return;
        case 2:
            TSd(this, null);
            USd(this, this.D);
            return;
        case 5:
            dTd(this, null);
            return;
        case 7:
            !this.A && (this.A = new Dde(r6, this, 7));
            RGd(this.A);
            return;
        case 8:
            EYd(this, true);
            return;
        case 9:
            !this.a && (this.a = new X0d(d6, this, 9, 5));
            RGd(this.a);
            return;
    }
    gqd(this, a - VTd((cPd(), NOd)), QTd((b = JD(Crd(this, 16), 29), !b ? NOd : b), a));
};
_.li = function bZd() {
    var a, b;
    if (this.a) for(a = 0, b = this.a.i; a < b; ++a)Eud(nDd(this.a, a));
    hae((Gfe(), Efe), this).ve();
    this.Bb |= 1;
};
_.fk = function cZd() {
    return TYd(this);
};
_.ck = function dZd(a) {
    if (a != null) return true;
    return false;
};
_.ol = function eZd(a) {};
var Y6 = jeb(TCe, 'EEnumImpl', 455);
Ycb(564, 436, {
    109: 1,
    93: 1,
    92: 1,
    1985: 1,
    679: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    564: 1,
    157: 1,
    117: 1,
    118: 1
}, kZd);
_.ve = function tZd() {
    return this.zb;
};
_.wh = function lZd(a) {
    return fZd(this, a);
};
_.Hh = function mZd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return jfb(this.d);
        case 3:
            return this.b ? this.b : this.a;
        case 4:
            return e = this.c, e == null ? this.zb : e;
        case 5:
            return this.Db >> 16 == 5 ? JD(this.Cb, 670) : null;
    }
    return dqd(this, a - VTd((cPd(), OOd)), QTd((d = JD(Crd(this, 16), 29), !d ? OOd : d), a), b, c);
};
_.Oh = function nZd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 5:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? fZd(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 5, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), OOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), OOd)), a, c);
};
_.Qh = function oZd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 5:
            return bqd(this, null, 5, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), OOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), OOd)), a, c);
};
_.Sh = function pZd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.d != 0;
        case 3:
            return !!this.b;
        case 4:
            return this.c != null;
        case 5:
            return !!(this.Db >> 16 == 5 ? JD(this.Cb, 670) : null);
    }
    return eqd(this, a - VTd((cPd(), OOd)), QTd((b = JD(Crd(this, 16), 29), !b ? OOd : b), a));
};
_.Zh = function qZd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            rvd(this, OD(b));
            return;
        case 2:
            jZd(this, JD(b, 17).a);
            return;
        case 3:
            hZd(this, JD(b, 1985));
            return;
        case 4:
            iZd(this, OD(b));
            return;
    }
    fqd(this, a - VTd((cPd(), OOd)), QTd((c = JD(Crd(this, 16), 29), !c ? OOd : c), a), b);
};
_.ei = function rZd() {
    return cPd(), OOd;
};
_.gi = function sZd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            rvd(this, null);
            return;
        case 2:
            jZd(this, 0);
            return;
        case 3:
            hZd(this, null);
            return;
        case 4:
            iZd(this, null);
            return;
    }
    gqd(this, a - VTd((cPd(), OOd)), QTd((b = JD(Crd(this, 16), 29), !b ? OOd : b), a));
};
_.Ib = function uZd() {
    var a;
    return a = this.c, a == null ? this.zb : a;
};
_.b = null;
_.c = null;
_.d = 0;
var Z6 = jeb(TCe, 'EEnumLiteralImpl', 564);
var _6 = leb(TCe, 'EFactoryImpl/InternalEDateTimeFormat');
Ycb(483, 1, {
    2060: 1
}, xZd);
var $6 = jeb(TCe, 'EFactoryImpl/1ClientInternalEDateTimeFormat', 483);
Ycb(246, 118, {
    109: 1,
    93: 1,
    92: 1,
    87: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    246: 1,
    117: 1,
    118: 1
}, NZd);
_.yh = function OZd(a, b, c) {
    var d;
    c = bqd(this, a, b, c);
    if (!!this.e && RD(a, 178)) {
        d = FZd(this, this.e);
        d != this.c && (c = JZd(this, d, c));
    }
    return c;
};
_.Hh = function PZd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return this.f;
        case 1:
            return !this.d && (this.d = new qVd(g6, this, 1)), this.d;
        case 2:
            if (b) return DZd(this);
            return this.c;
        case 3:
            return this.b;
        case 4:
            return this.e;
        case 5:
            if (b) return CZd(this);
            return this.a;
    }
    return dqd(this, a - VTd((cPd(), QOd)), QTd((d = JD(Crd(this, 16), 29), !d ? QOd : d), a), b, c);
};
_.Qh = function QZd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return BZd(this, null, c);
        case 1:
            return !this.d && (this.d = new qVd(g6, this, 1)), QGd(this.d, a, c);
        case 3:
            return zZd(this, null, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), QOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), QOd)), a, c);
};
_.Sh = function RZd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.f;
        case 1:
            return !!this.d && this.d.i != 0;
        case 2:
            return !!this.c;
        case 3:
            return !!this.b;
        case 4:
            return !!this.e;
        case 5:
            return !!this.a;
    }
    return eqd(this, a - VTd((cPd(), QOd)), QTd((b = JD(Crd(this, 16), 29), !b ? QOd : b), a));
};
_.Zh = function SZd(a, b) {
    var c;
    switch(a){
        case 0:
            LZd(this, JD(b, 87));
            return;
        case 1:
            !this.d && (this.d = new qVd(g6, this, 1));
            RGd(this.d);
            !this.d && (this.d = new qVd(g6, this, 1));
            vCd(this.d, JD(b, 16));
            return;
        case 3:
            IZd(this, JD(b, 87));
            return;
        case 4:
            KZd(this, JD(b, 829));
            return;
        case 5:
            GZd(this, JD(b, 141));
            return;
    }
    fqd(this, a - VTd((cPd(), QOd)), QTd((c = JD(Crd(this, 16), 29), !c ? QOd : c), a), b);
};
_.ei = function TZd() {
    return cPd(), QOd;
};
_.gi = function UZd(a) {
    var b;
    switch(a){
        case 0:
            LZd(this, null);
            return;
        case 1:
            !this.d && (this.d = new qVd(g6, this, 1));
            RGd(this.d);
            return;
        case 3:
            IZd(this, null);
            return;
        case 4:
            KZd(this, null);
            return;
        case 5:
            GZd(this, null);
            return;
    }
    gqd(this, a - VTd((cPd(), QOd)), QTd((b = JD(Crd(this, 16), 29), !b ? QOd : b), a));
};
_.Ib = function VZd() {
    var a;
    a = new Wgb(Gqd(this));
    a.a += ' (expression: ';
    MZd(this, a);
    a.a += ')';
    return a.a;
};
var yZd;
var b7 = jeb(TCe, 'EGenericTypeImpl', 246);
Ycb(2013, 2008, vFe);
_.Di = function XZd(a, b) {
    WZd(this, a, b);
};
_.Tk = function YZd(a, b) {
    WZd(this, this.gc(), a);
    return b;
};
_.Xi = function ZZd(a) {
    return fu(this.mj(), a);
};
_.Fi = function $Zd() {
    return this.Gi();
};
_.mj = function _Zd() {
    return new H9d(this);
};
_.Gi = function a$d() {
    return this.Hi(0);
};
_.Hi = function b$d(a) {
    return this.mj().dd(a);
};
_.Uk = function c$d(a, b) {
    ye(this, a, true);
    return b;
};
_.Qi = function d$d(a, b) {
    var c, d;
    d = gu(this, b);
    c = this.dd(a);
    c.Rb(d);
    return d;
};
_.Ri = function e$d(a, b) {
    var c;
    ye(this, b, true);
    c = this.dd(a);
    c.Rb(b);
};
var y9 = jeb(_Ee, 'AbstractSequentialInternalEList', 2013);
Ycb(480, 2013, vFe, j$d);
_.Xi = function k$d(a) {
    return fu(this.mj(), a);
};
_.Fi = function l$d() {
    if (this.b == null) return E$d(), E$d(), D$d;
    return this.pl();
};
_.mj = function m$d() {
    return new pde(this.a, this.b);
};
_.Gi = function n$d() {
    if (this.b == null) return E$d(), E$d(), D$d;
    return this.pl();
};
_.Hi = function o$d(a) {
    var b, c;
    if (this.b == null) {
        if (a < 0 || a > 1) throw scb(new mdb(IEe + a + ', size=0'));
        return E$d(), E$d(), D$d;
    }
    c = this.pl();
    for(b = 0; b < a; ++b)F$d(c);
    return c;
};
_.dc = function p$d() {
    var a, b, c, d, e, f;
    if (this.b != null) for(c = 0; c < this.b.length; ++c){
        a = this.b[c];
        if (!this.sl() || this.a.Th(a)) {
            f = this.a.Jh(a, false);
            Ife();
            if (JD(a, 69).uk()) {
                b = JD(f, 159);
                for(d = 0, e = b.gc(); d < e; ++d){
                    if (h$d(b.Ql(d)) && b.Rl(d) != null) return false;
                }
            } else if (a.Gk()) {
                if (!JD(f, 16).dc()) return false;
            } else if (f != null) return false;
        }
    }
    return true;
};
_.Jc = function q$d() {
    return i$d(this);
};
_.dd = function r$d(a) {
    var b, c;
    if (this.b == null) {
        if (a != 0) throw scb(new mdb(IEe + a + ', size=0'));
        return E$d(), E$d(), D$d;
    }
    c = this.rl() ? this.ql() : this.pl();
    for(b = 0; b < a; ++b)F$d(c);
    return c;
};
_.Qi = function s$d(a, b) {
    throw scb(new ahb);
};
_.Ri = function t$d(a, b) {
    throw scb(new ahb);
};
_.pl = function u$d() {
    return new K$d(this.a, this.b);
};
_.ql = function v$d() {
    return new Y$d(this.a, this.b);
};
_.rl = function w$d() {
    return true;
};
_.gc = function x$d() {
    var a, b, c, d, e, f, g;
    e = 0;
    if (this.b != null) for(c = 0; c < this.b.length; ++c){
        a = this.b[c];
        if (!this.sl() || this.a.Th(a)) {
            g = this.a.Jh(a, false);
            Ife();
            if (JD(a, 69).uk()) {
                b = JD(g, 159);
                for(d = 0, f = b.gc(); d < f; ++d)h$d(b.Ql(d)) && b.Rl(d) != null && ++e;
            } else a.Gk() ? e += JD(g, 16).gc() : g != null && ++e;
        }
    }
    return e;
};
_.sl = function y$d() {
    return true;
};
var f$d;
var O9 = jeb(_Ee, 'EContentsEList', 480);
Ycb(1141, 480, vFe, z$d);
_.pl = function A$d() {
    return new a_d(this.a, this.b);
};
_.ql = function B$d() {
    return new $$d(this.a, this.b);
};
_.sl = function C$d() {
    return false;
};
var f7 = jeb(TCe, 'ENamedElementImpl/1', 1141);
Ycb(284, 1, wFe, K$d);
_.Nb = function N$d(a) {
    Osb(this, a);
};
_.Rb = function L$d(a) {
    throw scb(new ahb);
};
_.tl = function M$d(a) {
    if (this.g != 0 || !!this.e) throw scb(new Web('Iterator already in use or already filtered'));
    this.e = a;
};
_.Ob = function O$d() {
    var a, b, c, d, e, f;
    switch(this.g){
        case 3:
        case 2:
            return true;
        case 1:
            return false;
        case -3:
            !this.p ? ++this.n : this.p.Pb();
        default:
            if (!this.k || (!this.p ? !G$d(this) : !H$d(this, this.p))) {
                while(this.d < this.c.length){
                    b = this.c[this.d++];
                    if ((!this.e || b.mk() != t3 || b.Ij() != 0) && (!this.sl() || this.b.Th(b))) {
                        f = this.b.Jh(b, this.rl());
                        this.f = (Ife(), JD(b, 69).uk());
                        if (this.f || b.Gk()) {
                            if (this.rl()) {
                                d = JD(f, 15);
                                this.k = d;
                            } else {
                                d = JD(f, 71);
                                this.k = this.j = d;
                            }
                            if (RD(this.k, 59)) {
                                this.p = null;
                                this.o = this.k.gc();
                                this.n = 0;
                            } else this.p = !this.j ? this.k.cd() : this.j.Gi();
                            if (!this.p ? G$d(this) : H$d(this, this.p)) {
                                e = !this.p ? !this.j ? this.k.Xb(this.n++) : this.j.Xi(this.n++) : this.p.Pb();
                                if (this.f) {
                                    a = JD(e, 74);
                                    a.Ik();
                                    c = a.kd();
                                    this.i = c;
                                } else {
                                    c = e;
                                    this.i = c;
                                }
                                this.g = 3;
                                return true;
                            }
                        } else if (f != null) {
                            this.k = null;
                            this.p = null;
                            c = f;
                            this.i = c;
                            this.g = 2;
                            return true;
                        }
                    }
                }
                this.k = null;
                this.p = null;
                this.f = false;
                this.g = 1;
                return false;
            } else {
                e = !this.p ? !this.j ? this.k.Xb(this.n++) : this.j.Xi(this.n++) : this.p.Pb();
                if (this.f) {
                    a = JD(e, 74);
                    a.Ik();
                    c = a.kd();
                    this.i = c;
                } else {
                    c = e;
                    this.i = c;
                }
                this.g = 3;
                return true;
            }
    }
};
_.Sb = function P$d() {
    var a, b, c, d, e, f;
    switch(this.g){
        case -3:
        case -2:
            return true;
        case -1:
            return false;
        case 3:
            !this.p ? --this.n : this.p.Ub();
        default:
            if (!this.k || (!this.p ? !I$d(this) : !J$d(this, this.p))) {
                while(this.d > 0){
                    b = this.c[--this.d];
                    if ((!this.e || b.mk() != t3 || b.Ij() != 0) && (!this.sl() || this.b.Th(b))) {
                        f = this.b.Jh(b, this.rl());
                        this.f = (Ife(), JD(b, 69).uk());
                        if (this.f || b.Gk()) {
                            if (this.rl()) {
                                d = JD(f, 15);
                                this.k = d;
                            } else {
                                d = JD(f, 71);
                                this.k = this.j = d;
                            }
                            if (RD(this.k, 59)) {
                                this.o = this.k.gc();
                                this.n = this.o;
                            } else this.p = !this.j ? this.k.dd(this.k.gc()) : this.j.Hi(this.k.gc());
                            if (!this.p ? I$d(this) : J$d(this, this.p)) {
                                e = !this.p ? !this.j ? this.k.Xb(--this.n) : this.j.Xi(--this.n) : this.p.Ub();
                                if (this.f) {
                                    a = JD(e, 74);
                                    a.Ik();
                                    c = a.kd();
                                    this.i = c;
                                } else {
                                    c = e;
                                    this.i = c;
                                }
                                this.g = -3;
                                return true;
                            }
                        } else if (f != null) {
                            this.k = null;
                            this.p = null;
                            c = f;
                            this.i = c;
                            this.g = -2;
                            return true;
                        }
                    }
                }
                this.k = null;
                this.p = null;
                this.g = -1;
                return false;
            } else {
                e = !this.p ? !this.j ? this.k.Xb(--this.n) : this.j.Xi(--this.n) : this.p.Ub();
                if (this.f) {
                    a = JD(e, 74);
                    a.Ik();
                    c = a.kd();
                    this.i = c;
                } else {
                    c = e;
                    this.i = c;
                }
                this.g = -3;
                return true;
            }
    }
};
_.Pb = function Q$d() {
    return F$d(this);
};
_.Tb = function R$d() {
    return this.a;
};
_.Ub = function S$d() {
    var a;
    if (this.g < -1 || this.Sb()) {
        --this.a;
        this.g = 0;
        a = this.i;
        this.Sb();
        return a;
    } else throw scb(new qub);
};
_.Vb = function T$d() {
    return this.a - 1;
};
_.Qb = function U$d() {
    throw scb(new ahb);
};
_.rl = function V$d() {
    return false;
};
_.Wb = function W$d(a) {
    throw scb(new ahb);
};
_.sl = function X$d() {
    return true;
};
_.a = 0;
_.d = 0;
_.f = false;
_.g = 0;
_.n = 0;
_.o = 0;
var D$d;
var M9 = jeb(_Ee, 'EContentsEList/FeatureIteratorImpl', 284);
Ycb(695, 284, wFe, Y$d);
_.rl = function Z$d() {
    return true;
};
var N9 = jeb(_Ee, 'EContentsEList/ResolvingFeatureIteratorImpl', 695);
Ycb(1142, 695, wFe, $$d);
_.sl = function _$d() {
    return false;
};
var d7 = jeb(TCe, 'ENamedElementImpl/1/1', 1142);
Ycb(1143, 284, wFe, a_d);
_.sl = function b_d() {
    return false;
};
var e7 = jeb(TCe, 'ENamedElementImpl/1/2', 1143);
Ycb(38, 150, HEe, e_d, f_d, g_d, h_d, i_d, j_d, k_d, l_d, m_d, n_d, o_d, p_d, q_d, r_d, s_d, t_d, u_d, v_d, w_d, x_d, y_d, z_d, A_d, B_d, C_d);
_.Hj = function D_d() {
    return d_d(this);
};
_.Oj = function E_d() {
    var a;
    a = d_d(this);
    if (a) return a.fk();
    return null;
};
_.ej = function F_d(a) {
    this.b == -1 && !!this.a && (this.b = this.c.Dh(this.a.Ij(), this.a.mk()));
    return this.c.uh(this.b, a);
};
_.gj = function G_d() {
    return this.c;
};
_.Pj = function H_d() {
    var a;
    a = d_d(this);
    if (a) return a.qk();
    return false;
};
_.b = -1;
var h7 = jeb(TCe, 'ENotificationImpl', 38);
Ycb(400, 290, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    62: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    400: 1,
    290: 1,
    117: 1,
    118: 1
}, L_d);
_.wh = function M_d(a) {
    return I_d(this, a);
};
_.Hh = function N_d(a, b, c) {
    var d, e, f;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return jfb(this.s);
        case 5:
            return jfb(this.t);
        case 6:
            return xdb(), f = this.t, f > 1 || f == -1 ? true : false;
        case 7:
            return xdb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return pRd(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return this.Db >> 16 == 10 ? JD(this.Cb, 29) : null;
        case 11:
            return !this.d && (this.d = new Dde(r6, this, 11)), this.d;
        case 12:
            return !this.c && (this.c = new X0d(m6, this, 12, 10)), this.c;
        case 13:
            return !this.a && (this.a = new $_d(this, this)), this.a;
        case 14:
            return J_d(this);
    }
    return dqd(this, a - VTd((cPd(), VOd)), QTd((d = JD(Crd(this, 16), 29), !d ? VOd : d), a), b, c);
};
_.Oh = function O_d(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 10:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? I_d(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 10, c);
        case 12:
            return !this.c && (this.c = new X0d(m6, this, 12, 10)), PGd(this.c, a, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), VOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), VOd)), a, c);
};
_.Qh = function P_d(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 9:
            return oRd(this, c);
        case 10:
            return bqd(this, null, 10, c);
        case 11:
            return !this.d && (this.d = new Dde(r6, this, 11)), QGd(this.d, a, c);
        case 12:
            return !this.c && (this.c = new X0d(m6, this, 12, 10)), QGd(this.c, a, c);
        case 14:
            return QGd(J_d(this), a, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), VOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), VOd)), a, c);
};
_.Sh = function Q_d(a) {
    var b, c, d;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return d = this.t, d > 1 || d == -1;
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && EZd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && EZd(this.q).i == 0);
        case 10:
            return !!(this.Db >> 16 == 10 ? JD(this.Cb, 29) : null);
        case 11:
            return !!this.d && this.d.i != 0;
        case 12:
            return !!this.c && this.c.i != 0;
        case 13:
            return !!this.a && J_d(this.a.a).i != 0 && !(!!this.b && J0d(this.b));
        case 14:
            return !!this.b && J0d(this.b);
    }
    return eqd(this, a - VTd((cPd(), VOd)), QTd((b = JD(Crd(this, 16), 29), !b ? VOd : b), a));
};
_.Zh = function R_d(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            rvd(this, OD(b));
            return;
        case 2:
            uRd(this, ydb(LD(b)));
            return;
        case 3:
            vRd(this, ydb(LD(b)));
            return;
        case 4:
            tRd(this, JD(b, 17).a);
            return;
        case 5:
            wRd(this, JD(b, 17).a);
            return;
        case 8:
            rRd(this, JD(b, 141));
            return;
        case 9:
            d = qRd(this, JD(b, 87), null);
            !!d && d.lj();
            return;
        case 11:
            !this.d && (this.d = new Dde(r6, this, 11));
            RGd(this.d);
            !this.d && (this.d = new Dde(r6, this, 11));
            vCd(this.d, JD(b, 16));
            return;
        case 12:
            !this.c && (this.c = new X0d(m6, this, 12, 10));
            RGd(this.c);
            !this.c && (this.c = new X0d(m6, this, 12, 10));
            vCd(this.c, JD(b, 16));
            return;
        case 13:
            !this.a && (this.a = new $_d(this, this));
            sFd(this.a);
            !this.a && (this.a = new $_d(this, this));
            vCd(this.a, JD(b, 16));
            return;
        case 14:
            RGd(J_d(this));
            vCd(J_d(this), JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), VOd)), QTd((c = JD(Crd(this, 16), 29), !c ? VOd : c), a), b);
};
_.ei = function S_d() {
    return cPd(), VOd;
};
_.gi = function T_d(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            rvd(this, null);
            return;
        case 2:
            uRd(this, true);
            return;
        case 3:
            vRd(this, true);
            return;
        case 4:
            tRd(this, 0);
            return;
        case 5:
            wRd(this, 1);
            return;
        case 8:
            rRd(this, null);
            return;
        case 9:
            c = qRd(this, null, null);
            !!c && c.lj();
            return;
        case 11:
            !this.d && (this.d = new Dde(r6, this, 11));
            RGd(this.d);
            return;
        case 12:
            !this.c && (this.c = new X0d(m6, this, 12, 10));
            RGd(this.c);
            return;
        case 13:
            !!this.a && sFd(this.a);
            return;
        case 14:
            !!this.b && RGd(this.b);
            return;
    }
    gqd(this, a - VTd((cPd(), VOd)), QTd((b = JD(Crd(this, 16), 29), !b ? VOd : b), a));
};
_.li = function U_d() {
    var a, b;
    if (this.c) for(a = 0, b = this.c.i; a < b; ++a)Eud(nDd(this.c, a));
    pRd(this);
    this.Bb |= 1;
};
var m7 = jeb(TCe, 'EOperationImpl', 400);
Ycb(497, 739, uFe, $_d);
_.nj = function b0d(a, b) {
    V_d(this, a, JD(b, 141));
};
_.oj = function c0d(a) {
    W_d(this, JD(a, 141));
};
_.uj = function i0d(a) {
    var b, c;
    return b = JD(nDd(J_d(this.a), a), 87), c = b.c, c ? c : (cPd(), ROd);
};
_.zj = function n0d(a) {
    var b, c;
    return b = JD(UGd(J_d(this.a), a), 87), c = b.c, c ? c : (cPd(), ROd);
};
_.Aj = function o0d(a, b) {
    return Y_d(this, a, JD(b, 141));
};
_.Ii = function __d() {
    return false;
};
_.Fj = function a0d(a, b, c, d, e) {
    return null;
};
_.pj = function d0d() {
    return new G0d(this);
};
_.qj = function e0d() {
    RGd(J_d(this.a));
};
_.rj = function f0d(a) {
    return X_d(this, a);
};
_.sj = function g0d(a) {
    var b, c;
    for(c = a.Jc(); c.Ob();){
        b = c.Pb();
        if (!X_d(this, b)) return false;
    }
    return true;
};
_.tj = function h0d(a) {
    var b, c, d;
    if (RD(a, 15)) {
        d = JD(a, 15);
        if (d.gc() == J_d(this.a).i) {
            for(b = d.Jc(), c = new CHd(this); b.Ob();){
                if (XD(b.Pb()) !== XD(AHd(c))) return false;
            }
            return true;
        }
    }
    return false;
};
_.vj = function j0d() {
    var a, b, c, d, e;
    c = 1;
    for(b = new CHd(J_d(this.a)); b.e != b.i.gc();){
        a = JD(AHd(b), 87);
        d = (e = a.c, e ? e : (cPd(), ROd));
        c = 31 * c + (!d ? 0 : tb(d));
    }
    return c;
};
_.wj = function k0d(a) {
    var b, c, d, e;
    d = 0;
    for(c = new CHd(J_d(this.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 87);
        if (XD(a) === XD((e = b.c, e ? e : (cPd(), ROd)))) return d;
        ++d;
    }
    return -1;
};
_.xj = function l0d() {
    return J_d(this.a).i == 0;
};
_.yj = function m0d() {
    return null;
};
_.Bj = function p0d() {
    return J_d(this.a).i;
};
_.Cj = function q0d() {
    var a, b, c, d, e, f;
    f = J_d(this.a).i;
    e = SC(aJ, Nqe, 1, f, 5, 1);
    c = 0;
    for(b = new CHd(J_d(this.a)); b.e != b.i.gc();){
        a = JD(AHd(b), 87);
        e[c++] = (d = a.c, d ? d : (cPd(), ROd));
    }
    return e;
};
_.Dj = function r0d(a) {
    var b, c, d, e, f, g, h;
    h = J_d(this.a).i;
    if (a.length < h) {
        e = fId(rb(a).c, h);
        a = e;
    }
    a.length > h && VC(a, h, null);
    d = 0;
    for(c = new CHd(J_d(this.a)); c.e != c.i.gc();){
        b = JD(AHd(c), 87);
        f = (g = b.c, g ? g : (cPd(), ROd));
        VC(a, d++, f);
    }
    return a;
};
_.Ej = function s0d() {
    var a, b, c, d, e;
    e = new Hgb;
    e.a += '[';
    a = J_d(this.a);
    for(b = 0, d = J_d(this.a).i; b < d;){
        Egb(e, xgb((c = JD(nDd(a, b), 87).c, c ? c : (cPd(), ROd))));
        ++b < d && (e.a += Lqe, e);
    }
    e.a += ']';
    return e.a;
};
_.Gj = function t0d(a) {};
_.Ij = function u0d() {
    return 13;
};
_.hl = function v0d() {
    return true;
};
_.Jj = function w0d() {
    return false;
};
_.il = function x0d() {
    return false;
};
_.jl = function y0d() {
    return false;
};
_.kl = function z0d() {
    return true;
};
_.Zk = function A0d() {
    return false;
};
_.ll = function B0d() {
    return true;
};
_.ck = function C0d(a) {
    return RD(a, 141);
};
_.Nj = function D0d() {
    return K_d(this.a);
};
_.Pi = function E0d() {
    return true;
};
_.Vi = function F0d() {
    return true;
};
var k7 = jeb(TCe, 'EOperationImpl/1', 497);
Ycb(1315, 2008, Fre, G0d);
_.dd = function H0d(a) {
    return wCd(this.a, a);
};
_.gc = function I0d() {
    return J_d(this.a.a).i;
};
var j7 = jeb(TCe, 'EOperationImpl/1/1', 1315);
Ycb(1316, 540, pFe, N0d);
_.Qi = function R0d(a, b) {
    var c, d;
    return c = JD(TGd(this, a, b), 87), qqd(this.e) && zUd(this, new x_d(this.a, 7, (cPd(), WOd), jfb(b), (d = c.c, d ? d : ROd), a)), c;
};
_.Rj = function S0d(a, b) {
    return K0d(this, JD(a, 87), b);
};
_.Sj = function T0d(a, b) {
    return L0d(this, JD(a, 87), b);
};
_.Tj = function U0d(a, b, c) {
    return M0d(this, JD(a, 87), JD(b, 87), c);
};
_.Fj = function O0d(a, b, c, d, e) {
    switch(a){
        case 3:
            return yUd(this, a, b, c, d, this.i > 1);
        case 5:
            return yUd(this, a, b, c, d, this.i - JD(c, 15).gc() > 0);
        default:
            return new i_d(this.e, a, this.c, b, c, d, true);
    }
};
_.Qj = function P0d() {
    return true;
};
_.Nj = function Q0d() {
    return J0d(this);
};
_.Dk = function V0d() {
    RGd(this);
};
var l7 = jeb(TCe, 'EOperationImpl/2', 1316);
Ycb(491, 1, {
    1983: 1,
    491: 1
}, W0d);
var n7 = jeb(TCe, 'EPackageImpl/1', 491);
Ycb(14, 81, pFe, X0d);
_.fl = function Y0d() {
    return this.d;
};
_.gl = function Z0d() {
    return this.b;
};
_.jl = function $0d() {
    return true;
};
_.b = 0;
var $9 = jeb(_Ee, 'EObjectContainmentWithInverseEList', 14);
Ycb(358, 14, pFe, _0d);
_.kl = function a1d() {
    return true;
};
_.Ti = function b1d(a, b) {
    return BUd(this, a, JD(b, 57));
};
var X9 = jeb(_Ee, 'EObjectContainmentWithInverseEList/Resolving', 358);
Ycb(309, 358, pFe, c1d);
_.Ki = function d1d() {
    this.a.tb = null;
};
var o7 = jeb(TCe, 'EPackageImpl/2', 309);
Ycb(1238, 1, {}, e1d);
var p7 = jeb(TCe, 'EPackageImpl/3', 1238);
Ycb(716, 45, bte, h1d);
_._b = function i1d(a) {
    return VD(a) ? Pib(this, a) : !!fsb(this.f, a);
};
var r7 = jeb(TCe, 'EPackageRegistryImpl', 716);
Ycb(502, 290, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    2062: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    502: 1,
    290: 1,
    117: 1,
    118: 1
}, k1d);
_.wh = function l1d(a) {
    return j1d(this, a);
};
_.Hh = function m1d(a, b, c) {
    var d, e, f;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return jfb(this.s);
        case 5:
            return jfb(this.t);
        case 6:
            return xdb(), f = this.t, f > 1 || f == -1 ? true : false;
        case 7:
            return xdb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return pRd(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return this.Db >> 16 == 10 ? JD(this.Cb, 62) : null;
    }
    return dqd(this, a - VTd((cPd(), YOd)), QTd((d = JD(Crd(this, 16), 29), !d ? YOd : d), a), b, c);
};
_.Oh = function n1d(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), PGd(this.Ab, a, c);
        case 10:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? j1d(this, c) : this.Cb.Ph(this, -1 - e, null, c)));
            return bqd(this, a, 10, c);
    }
    return f = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), YOd) : d), b), 69), f.tk().wk(this, Ard(this), b - VTd((cPd(), YOd)), a, c);
};
_.Qh = function o1d(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 9:
            return oRd(this, c);
        case 10:
            return bqd(this, null, 10, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), YOd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), YOd)), a, c);
};
_.Sh = function p1d(a) {
    var b, c, d;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return d = this.t, d > 1 || d == -1;
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && EZd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && EZd(this.q).i == 0);
        case 10:
            return !!(this.Db >> 16 == 10 ? JD(this.Cb, 62) : null);
    }
    return eqd(this, a - VTd((cPd(), YOd)), QTd((b = JD(Crd(this, 16), 29), !b ? YOd : b), a));
};
_.ei = function q1d() {
    return cPd(), YOd;
};
var s7 = jeb(TCe, 'EParameterImpl', 502);
Ycb(101, 448, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    19: 1,
    178: 1,
    69: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    101: 1,
    448: 1,
    290: 1,
    117: 1,
    118: 1,
    677: 1
}, y1d);
_.Hh = function z1d(a, b, c) {
    var d, e, f, g;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return xdb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return xdb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return jfb(this.s);
        case 5:
            return jfb(this.t);
        case 6:
            return xdb(), g = this.t, g > 1 || g == -1 ? true : false;
        case 7:
            return xdb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return pRd(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return xdb(), (this.Bb & NEe) != 0 ? true : false;
        case 11:
            return xdb(), (this.Bb & wse) != 0 ? true : false;
        case 12:
            return xdb(), (this.Bb & Mse) != 0 ? true : false;
        case 13:
            return this.j;
        case 14:
            return ORd(this);
        case 15:
            return xdb(), (this.Bb & dFe) != 0 ? true : false;
        case 16:
            return xdb(), (this.Bb & ire) != 0 ? true : false;
        case 17:
            return PRd(this);
        case 18:
            return xdb(), (this.Bb & RCe) != 0 ? true : false;
        case 19:
            return xdb(), f = s1d(this), !!f && (f.Bb & RCe) != 0 ? true : false;
        case 20:
            return xdb(), (this.Bb & Pse) != 0 ? true : false;
        case 21:
            if (b) return s1d(this);
            return this.b;
        case 22:
            if (b) return t1d(this);
            return r1d(this);
        case 23:
            return !this.a && (this.a = new Ude($5, this, 23)), this.a;
    }
    return dqd(this, a - VTd((cPd(), ZOd)), QTd((d = JD(Crd(this, 16), 29), !d ? ZOd : d), a), b, c);
};
_.Sh = function A1d(a) {
    var b, c, d, e;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return e = this.t, e > 1 || e == -1;
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && EZd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && EZd(this.q).i == 0);
        case 10:
            return (this.Bb & NEe) == 0;
        case 11:
            return (this.Bb & wse) != 0;
        case 12:
            return (this.Bb & Mse) != 0;
        case 13:
            return this.j != null;
        case 14:
            return ORd(this) != null;
        case 15:
            return (this.Bb & dFe) != 0;
        case 16:
            return (this.Bb & ire) != 0;
        case 17:
            return !!PRd(this);
        case 18:
            return (this.Bb & RCe) != 0;
        case 19:
            return d = s1d(this), !!d && (d.Bb & RCe) != 0;
        case 20:
            return (this.Bb & Pse) == 0;
        case 21:
            return !!this.b;
        case 22:
            return !!r1d(this);
        case 23:
            return !!this.a && this.a.i != 0;
    }
    return eqd(this, a - VTd((cPd(), ZOd)), QTd((b = JD(Crd(this, 16), 29), !b ? ZOd : b), a));
};
_.Zh = function B1d(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            XRd(this, OD(b));
            return;
        case 2:
            uRd(this, ydb(LD(b)));
            return;
        case 3:
            vRd(this, ydb(LD(b)));
            return;
        case 4:
            tRd(this, JD(b, 17).a);
            return;
        case 5:
            wRd(this, JD(b, 17).a);
            return;
        case 8:
            rRd(this, JD(b, 141));
            return;
        case 9:
            d = qRd(this, JD(b, 87), null);
            !!d && d.lj();
            return;
        case 10:
            SRd(this, ydb(LD(b)));
            return;
        case 11:
            $Rd(this, ydb(LD(b)));
            return;
        case 12:
            YRd(this, ydb(LD(b)));
            return;
        case 13:
            TRd(this, OD(b));
            return;
        case 15:
            ZRd(this, ydb(LD(b)));
            return;
        case 16:
            VRd(this, ydb(LD(b)));
            return;
        case 18:
            u1d(this, ydb(LD(b)));
            return;
        case 20:
            x1d(this, ydb(LD(b)));
            return;
        case 21:
            w1d(this, JD(b, 19));
            return;
        case 23:
            !this.a && (this.a = new Ude($5, this, 23));
            RGd(this.a);
            !this.a && (this.a = new Ude($5, this, 23));
            vCd(this.a, JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), ZOd)), QTd((c = JD(Crd(this, 16), 29), !c ? ZOd : c), a), b);
};
_.ei = function C1d() {
    return cPd(), ZOd;
};
_.gi = function D1d(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            RD(this.Cb, 88) && QVd(TTd(JD(this.Cb, 88)), 4);
            rvd(this, null);
            return;
        case 2:
            uRd(this, true);
            return;
        case 3:
            vRd(this, true);
            return;
        case 4:
            tRd(this, 0);
            return;
        case 5:
            wRd(this, 1);
            return;
        case 8:
            rRd(this, null);
            return;
        case 9:
            c = qRd(this, null, null);
            !!c && c.lj();
            return;
        case 10:
            SRd(this, true);
            return;
        case 11:
            $Rd(this, false);
            return;
        case 12:
            YRd(this, false);
            return;
        case 13:
            this.i = null;
            URd(this, null);
            return;
        case 15:
            ZRd(this, false);
            return;
        case 16:
            VRd(this, false);
            return;
        case 18:
            v1d(this, false);
            RD(this.Cb, 88) && QVd(TTd(JD(this.Cb, 88)), 2);
            return;
        case 20:
            x1d(this, true);
            return;
        case 21:
            w1d(this, null);
            return;
        case 23:
            !this.a && (this.a = new Ude($5, this, 23));
            RGd(this.a);
            return;
    }
    gqd(this, a - VTd((cPd(), ZOd)), QTd((b = JD(Crd(this, 16), 29), !b ? ZOd : b), a));
};
_.li = function E1d() {
    t1d(this);
    Vae(jae((Gfe(), Efe), this));
    pRd(this);
    this.Bb |= 1;
};
_.rk = function F1d() {
    return s1d(this);
};
_.Yk = function G1d() {
    var a;
    return a = s1d(this), !!a && (a.Bb & RCe) != 0;
};
_.Zk = function H1d() {
    return (this.Bb & RCe) != 0;
};
_.$k = function I1d() {
    return (this.Bb & Pse) != 0;
};
_.Vk = function J1d(a, b) {
    this.c = null;
    return sRd(this, a, b);
};
_.Ib = function K1d() {
    var a;
    if ((this.Db & 64) != 0) return _Rd(this);
    a = new Jgb(_Rd(this));
    a.a += ' (containment: ';
    Fgb(a, (this.Bb & RCe) != 0);
    a.a += ', resolveProxies: ';
    Fgb(a, (this.Bb & Pse) != 0);
    a.a += ')';
    return a.a;
};
var t7 = jeb(TCe, 'EReferenceImpl', 101);
Ycb(546, 118, {
    109: 1,
    43: 1,
    93: 1,
    92: 1,
    135: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    546: 1,
    117: 1,
    118: 1
}, Q1d);
_.Fb = function W1d(a) {
    return this === a;
};
_.jd = function Y1d() {
    return this.b;
};
_.kd = function Z1d() {
    return this.c;
};
_.Hb = function $1d() {
    return jDb(this);
};
_.zi = function a2d(a) {
    L1d(this, OD(a));
};
_.ld = function b2d(a) {
    return P1d(this, OD(a));
};
_.Hh = function R1d(a, b, c) {
    var d;
    switch(a){
        case 0:
            return this.b;
        case 1:
            return this.c;
    }
    return dqd(this, a - VTd((cPd(), $Od)), QTd((d = JD(Crd(this, 16), 29), !d ? $Od : d), a), b, c);
};
_.Sh = function S1d(a) {
    var b;
    switch(a){
        case 0:
            return this.b != null;
        case 1:
            return this.c != null;
    }
    return eqd(this, a - VTd((cPd(), $Od)), QTd((b = JD(Crd(this, 16), 29), !b ? $Od : b), a));
};
_.Zh = function T1d(a, b) {
    var c;
    switch(a){
        case 0:
            M1d(this, OD(b));
            return;
        case 1:
            O1d(this, OD(b));
            return;
    }
    fqd(this, a - VTd((cPd(), $Od)), QTd((c = JD(Crd(this, 16), 29), !c ? $Od : c), a), b);
};
_.ei = function U1d() {
    return cPd(), $Od;
};
_.gi = function V1d(a) {
    var b;
    switch(a){
        case 0:
            N1d(this, null);
            return;
        case 1:
            O1d(this, null);
            return;
    }
    gqd(this, a - VTd((cPd(), $Od)), QTd((b = JD(Crd(this, 16), 29), !b ? $Od : b), a));
};
_.xi = function X1d() {
    var a;
    if (this.a == -1) {
        a = this.b;
        this.a = a == null ? 0 : fgb(a);
    }
    return this.a;
};
_.yi = function _1d(a) {
    this.a = a;
};
_.Ib = function c2d() {
    var a;
    if ((this.Db & 64) != 0) return Gqd(this);
    a = new Jgb(Gqd(this));
    a.a += ' (key: ';
    Egb(a, this.b);
    a.a += ', value: ';
    Egb(a, this.c);
    a.a += ')';
    return a.a;
};
_.a = -1;
_.b = null;
_.c = null;
var u7 = jeb(TCe, 'EStringToStringMapEntryImpl', 546);
var Aab = leb(_Ee, 'FeatureMap/Entry/Internal');
Ycb(558, 1, xFe);
_.ul = function f2d(a) {
    return this.vl(JD(a, 52));
};
_.vl = function g2d(a) {
    return this.ul(a);
};
_.Fb = function h2d(a) {
    var b, c;
    if (this === a) return true;
    else if (RD(a, 74)) {
        b = JD(a, 74);
        if (b.Ik() == this.c) {
            c = this.kd();
            return c == null ? b.kd() == null : pb(c, b.kd());
        } else return false;
    } else return false;
};
_.Ik = function i2d() {
    return this.c;
};
_.Hb = function j2d() {
    var a;
    a = this.kd();
    return tb(this.c) ^ (a == null ? 0 : tb(a));
};
_.Ib = function k2d() {
    var a, b;
    a = this.c;
    b = WSd(a.nk()).ui();
    a.ve();
    return (b != null && b.length != 0 ? b + ':' + a.ve() : a.ve()) + '=' + this.kd();
};
var v7 = jeb(TCe, 'EStructuralFeatureImpl/BasicFeatureMapEntry', 558);
Ycb(771, 558, xFe, n2d);
_.vl = function o2d(a) {
    return new n2d(this.c, a);
};
_.kd = function p2d() {
    return this.a;
};
_.wl = function q2d(a, b, c) {
    return l2d(this, a, this.a, b, c);
};
_.xl = function r2d(a, b, c) {
    return m2d(this, a, this.a, b, c);
};
var w7 = jeb(TCe, 'EStructuralFeatureImpl/ContainmentUpdatingFeatureMapEntry', 771);
Ycb(1289, 1, {}, s2d);
_.vk = function t2d(a, b, c, d, e) {
    var f;
    f = JD(iqd(a, this.b), 218);
    return f.Vl(this.a).Ck(d);
};
_.wk = function u2d(a, b, c, d, e) {
    var f;
    f = JD(iqd(a, this.b), 218);
    return f.Ml(this.a, d, e);
};
_.xk = function v2d(a, b, c, d, e) {
    var f;
    f = JD(iqd(a, this.b), 218);
    return f.Nl(this.a, d, e);
};
_.yk = function w2d(a, b, c) {
    var d;
    d = JD(iqd(a, this.b), 218);
    return d.Vl(this.a).Nj();
};
_.zk = function x2d(a, b, c, d) {
    var e;
    e = JD(iqd(a, this.b), 218);
    e.Vl(this.a).Wb(d);
};
_.Ak = function y2d(a, b, c) {
    return JD(iqd(a, this.b), 218).Vl(this.a);
};
_.Bk = function z2d(a, b, c) {
    var d;
    d = JD(iqd(a, this.b), 218);
    d.Vl(this.a).Dk();
};
var x7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateFeatureMapDelegator', 1289);
Ycb(89, 1, {}, B2d, C2d, D2d, E2d);
_.vk = function F2d(a, b, c, d, e) {
    var f;
    f = b.hi(c);
    f == null && b.ii(c, f = A2d(this, a));
    if (!e) switch(this.e){
        case 50:
        case 41:
            return JD(f, 581).$j();
        case 40:
            return JD(f, 218).Sl();
    }
    return f;
};
_.wk = function G2d(a, b, c, d, e) {
    var f, g;
    g = b.hi(c);
    g == null && b.ii(c, g = A2d(this, a));
    f = JD(g, 71).Tk(d, e);
    return f;
};
_.xk = function H2d(a, b, c, d, e) {
    var f;
    f = b.hi(c);
    f != null && (e = JD(f, 71).Uk(d, e));
    return e;
};
_.yk = function I2d(a, b, c) {
    var d;
    d = b.hi(c);
    return d != null && JD(d, 76).Nj();
};
_.zk = function J2d(a, b, c, d) {
    var e;
    e = JD(b.hi(c), 76);
    !e && b.ii(c, e = A2d(this, a));
    e.Wb(d);
};
_.Ak = function K2d(a, b, c) {
    var d, e;
    e = b.hi(c);
    e == null && b.ii(c, e = A2d(this, a));
    if (RD(e, 76)) return JD(e, 76);
    else {
        d = JD(b.hi(c), 15);
        return new b5d(d);
    }
};
_.Bk = function L2d(a, b, c) {
    var d;
    d = JD(b.hi(c), 76);
    !d && b.ii(c, d = A2d(this, a));
    d.Dk();
};
_.b = 0;
_.e = 0;
var y7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateMany', 89);
Ycb(496, 1, {});
_.wk = function P2d(a, b, c, d, e) {
    throw scb(new ahb);
};
_.xk = function Q2d(a, b, c, d, e) {
    throw scb(new ahb);
};
_.Ak = function R2d(a, b, c) {
    return new S2d(this, a, b, c);
};
var M2d;
var f8 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingle', 496);
Ycb(1306, 1, aFe, S2d);
_.Ck = function T2d(a) {
    return this.a.vk(this.c, this.d, this.b, a, true);
};
_.Nj = function U2d() {
    return this.a.yk(this.c, this.d, this.b);
};
_.Wb = function V2d(a) {
    this.a.zk(this.c, this.d, this.b, a);
};
_.Dk = function W2d() {
    this.a.Bk(this.c, this.d, this.b);
};
_.b = 0;
var z7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingle/1', 1306);
Ycb(764, 496, {}, X2d);
_.vk = function Y2d(a, b, c, d, e) {
    return Pqd(a, a.Lh(), a.Bh()) == this.b ? this.$k() && d ? cqd(a) : a.Lh() : null;
};
_.wk = function Z2d(a, b, c, d, e) {
    var f, g;
    !!a.Lh() && (e = (f = a.Bh(), f >= 0 ? a.wh(e) : a.Lh().Ph(a, -1 - f, null, e)));
    g = WTd(a.zh(), this.e);
    return a.yh(d, g, e);
};
_.xk = function $2d(a, b, c, d, e) {
    var f;
    f = WTd(a.zh(), this.e);
    return a.yh(null, f, e);
};
_.yk = function _2d(a, b, c) {
    var d;
    d = WTd(a.zh(), this.e);
    return !!a.Lh() && a.Bh() == d;
};
_.zk = function a3d(a, b, c, d) {
    var e, f, g, h, i;
    if (d != null && !$Sd(this.a, d)) throw scb(new zeb(yFe + (RD(d, 57) ? _Td(JD(d, 57).zh()) : feb(rb(d))) + zFe + this.a + "'"));
    e = a.Lh();
    g = WTd(a.zh(), this.e);
    if (XD(d) !== XD(e) || a.Bh() != g && d != null) {
        if (hfe(a, JD(d, 57))) throw scb(new Teb(VCe + a.Ib()));
        i = null;
        !!e && (i = (f = a.Bh(), f >= 0 ? a.wh(i) : a.Lh().Ph(a, -1 - f, null, i)));
        h = JD(d, 52);
        !!h && (i = h.Nh(a, WTd(h.zh(), this.b), null, i));
        i = a.yh(h, g, i);
        !!i && i.lj();
    } else a.rh() && a.sh() && Wpd(a, new g_d(a, 1, g, d, d));
};
_.Bk = function b3d(a, b, c) {
    var d, e, f, g;
    d = a.Lh();
    if (d) {
        g = (e = a.Bh(), e >= 0 ? a.wh(null) : a.Lh().Ph(a, -1 - e, null, null));
        f = WTd(a.zh(), this.e);
        g = a.yh(null, f, g);
        !!g && g.lj();
    } else a.rh() && a.sh() && Wpd(a, new w_d(a, 1, this.e, null, null));
};
_.$k = function c3d() {
    return false;
};
var B7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleContainer', 764);
Ycb(1290, 764, {}, d3d);
_.$k = function e3d() {
    return true;
};
var A7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleContainerResolving', 1290);
Ycb(556, 496, {});
_.vk = function h3d(a, b, c, d, e) {
    var f;
    return f = b.hi(c), f == null ? this.b : XD(f) === XD(M2d) ? null : f;
};
_.yk = function i3d(a, b, c) {
    var d;
    d = b.hi(c);
    return d != null && (XD(d) === XD(M2d) || !pb(d, this.b));
};
_.zk = function j3d(a, b, c, d) {
    var e, f;
    if (a.rh() && a.sh()) {
        e = (f = b.hi(c), f == null ? this.b : XD(f) === XD(M2d) ? null : f);
        if (d == null) {
            if (this.c != null) {
                b.ii(c, null);
                d = this.b;
            } else this.b != null ? b.ii(c, M2d) : b.ii(c, null);
        } else {
            this.yl(d);
            b.ii(c, d);
        }
        Wpd(a, this.d.zl(a, 1, this.e, e, d));
    } else if (d == null) this.c != null ? b.ii(c, null) : this.b != null ? b.ii(c, M2d) : b.ii(c, null);
    else {
        this.yl(d);
        b.ii(c, d);
    }
};
_.Bk = function k3d(a, b, c) {
    var d, e;
    if (a.rh() && a.sh()) {
        d = (e = b.hi(c), e == null ? this.b : XD(e) === XD(M2d) ? null : e);
        b.ji(c);
        Wpd(a, this.d.zl(a, 1, this.e, d, this.b));
    } else b.ji(c);
};
_.yl = function l3d(a) {
    throw scb(new yeb);
};
var Q7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData', 556);
Ycb(AFe, 1, {}, w3d);
_.zl = function x3d(a, b, c, d, e) {
    return new w_d(a, b, c, d, e);
};
_.Al = function y3d(a, b, c, d, e, f) {
    return new y_d(a, b, c, d, e, f);
};
var m3d, n3d, o3d, p3d, q3d, r3d, s3d, t3d, u3d;
var K7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator', AFe);
Ycb(1307, AFe, {}, z3d);
_.zl = function A3d(a, b, c, d, e) {
    return new B_d(a, b, c, ydb(LD(d)), ydb(LD(e)));
};
_.Al = function B3d(a, b, c, d, e, f) {
    return new C_d(a, b, c, ydb(LD(d)), ydb(LD(e)), f);
};
var C7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/1', 1307);
Ycb(1308, AFe, {}, C3d);
_.zl = function D3d(a, b, c, d, e) {
    return new k_d(a, b, c, JD(d, 219).a, JD(e, 219).a);
};
_.Al = function E3d(a, b, c, d, e, f) {
    return new l_d(a, b, c, JD(d, 219).a, JD(e, 219).a, f);
};
var D7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/2', 1308);
Ycb(1309, AFe, {}, F3d);
_.zl = function G3d(a, b, c, d, e) {
    return new m_d(a, b, c, JD(d, 179).a, JD(e, 179).a);
};
_.Al = function H3d(a, b, c, d, e, f) {
    return new n_d(a, b, c, JD(d, 179).a, JD(e, 179).a, f);
};
var E7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/3', 1309);
Ycb(1310, AFe, {}, I3d);
_.zl = function J3d(a, b, c, d, e) {
    return new o_d(a, b, c, Beb(MD(d)), Beb(MD(e)));
};
_.Al = function K3d(a, b, c, d, e, f) {
    return new p_d(a, b, c, Beb(MD(d)), Beb(MD(e)), f);
};
var F7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/4', 1310);
Ycb(1311, AFe, {}, L3d);
_.zl = function M3d(a, b, c, d, e) {
    return new q_d(a, b, c, JD(d, 160).a, JD(e, 160).a);
};
_.Al = function N3d(a, b, c, d, e, f) {
    return new r_d(a, b, c, JD(d, 160).a, JD(e, 160).a, f);
};
var G7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/5', 1311);
Ycb(1312, AFe, {}, O3d);
_.zl = function P3d(a, b, c, d, e) {
    return new s_d(a, b, c, JD(d, 17).a, JD(e, 17).a);
};
_.Al = function Q3d(a, b, c, d, e, f) {
    return new t_d(a, b, c, JD(d, 17).a, JD(e, 17).a, f);
};
var H7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/6', 1312);
Ycb(1313, AFe, {}, R3d);
_.zl = function S3d(a, b, c, d, e) {
    return new u_d(a, b, c, JD(d, 190).a, JD(e, 190).a);
};
_.Al = function T3d(a, b, c, d, e, f) {
    return new v_d(a, b, c, JD(d, 190).a, JD(e, 190).a, f);
};
var I7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/7', 1313);
Ycb(1314, AFe, {}, U3d);
_.zl = function V3d(a, b, c, d, e) {
    return new z_d(a, b, c, JD(d, 191).a, JD(e, 191).a);
};
_.Al = function W3d(a, b, c, d, e, f) {
    return new A_d(a, b, c, JD(d, 191).a, JD(e, 191).a, f);
};
var J7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/8', 1314);
Ycb(1292, 556, {}, X3d);
_.yl = function Y3d(a) {
    if (!this.a.ck(a)) throw scb(new zeb(yFe + rb(a) + zFe + this.a + "'"));
};
var L7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataDynamic', 1292);
Ycb(1293, 556, {}, Z3d);
_.yl = function $3d(a) {};
var M7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataStatic', 1293);
Ycb(765, 556, {});
_.yk = function _3d(a, b, c) {
    var d;
    d = b.hi(c);
    return d != null;
};
_.zk = function a4d(a, b, c, d) {
    var e, f;
    if (a.rh() && a.sh()) {
        e = true;
        f = b.hi(c);
        if (f == null) {
            e = false;
            f = this.b;
        } else XD(f) === XD(M2d) && (f = null);
        if (d == null) {
            if (this.c != null) {
                b.ii(c, null);
                d = this.b;
            } else b.ii(c, M2d);
        } else {
            this.yl(d);
            b.ii(c, d);
        }
        Wpd(a, this.d.Al(a, 1, this.e, f, d, !e));
    } else if (d == null) this.c != null ? b.ii(c, null) : b.ii(c, M2d);
    else {
        this.yl(d);
        b.ii(c, d);
    }
};
_.Bk = function b4d(a, b, c) {
    var d, e;
    if (a.rh() && a.sh()) {
        d = true;
        e = b.hi(c);
        if (e == null) {
            d = false;
            e = this.b;
        } else XD(e) === XD(M2d) && (e = null);
        b.ji(c);
        Wpd(a, this.d.Al(a, 2, this.e, e, this.b, d));
    } else b.ji(c);
};
var P7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettable', 765);
Ycb(1294, 765, {}, c4d);
_.yl = function d4d(a) {
    if (!this.a.ck(a)) throw scb(new zeb(yFe + rb(a) + zFe + this.a + "'"));
};
var N7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableDynamic', 1294);
Ycb(1295, 765, {}, e4d);
_.yl = function f4d(a) {};
var O7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableStatic', 1295);
Ycb(399, 496, {}, g4d);
_.vk = function i4d(a, b, c, d, e) {
    var f, g, h, i, j;
    j = b.hi(c);
    if (this.qk() && XD(j) === XD(M2d)) return null;
    else if (this.$k() && d && j != null) {
        h = JD(j, 52);
        if (h.Rh()) {
            i = zqd(a, h);
            if (h != i) {
                if (!$Sd(this.a, i)) throw scb(new zeb(yFe + rb(i) + zFe + this.a + "'"));
                b.ii(c, j = i);
                if (this.Zk()) {
                    f = JD(i, 52);
                    g = h.Ph(a, !this.b ? -1 - WTd(a.zh(), this.e) : WTd(h.zh(), this.b), null, null);
                    !f.Lh() && (g = f.Nh(a, !this.b ? -1 - WTd(a.zh(), this.e) : WTd(f.zh(), this.b), null, g));
                    !!g && g.lj();
                }
                a.rh() && a.sh() && Wpd(a, new w_d(a, 9, this.e, h, i));
            }
        }
        return j;
    } else return j;
};
_.wk = function j4d(a, b, c, d, e) {
    var f, g;
    g = b.hi(c);
    XD(g) === XD(M2d) && (g = null);
    b.ii(c, d);
    if (this.Jj()) {
        if (XD(g) !== XD(d) && g != null) {
            f = JD(g, 52);
            e = f.Ph(a, WTd(f.zh(), this.b), null, e);
        }
    } else this.Zk() && g != null && (e = JD(g, 52).Ph(a, -1 - WTd(a.zh(), this.e), null, e));
    if (a.rh() && a.sh()) {
        !e && (e = new FGd(4));
        e.kj(new w_d(a, 1, this.e, g, d));
    }
    return e;
};
_.xk = function k4d(a, b, c, d, e) {
    var f;
    f = b.hi(c);
    XD(f) === XD(M2d) && (f = null);
    b.ji(c);
    if (a.rh() && a.sh()) {
        !e && (e = new FGd(4));
        this.qk() ? e.kj(new w_d(a, 2, this.e, f, null)) : e.kj(new w_d(a, 1, this.e, f, null));
    }
    return e;
};
_.yk = function l4d(a, b, c) {
    var d;
    d = b.hi(c);
    return d != null;
};
_.zk = function m4d(a, b, c, d) {
    var e, f, g, h, i;
    if (d != null && !$Sd(this.a, d)) throw scb(new zeb(yFe + (RD(d, 57) ? _Td(JD(d, 57).zh()) : feb(rb(d))) + zFe + this.a + "'"));
    i = b.hi(c);
    h = i != null;
    this.qk() && XD(i) === XD(M2d) && (i = null);
    g = null;
    if (this.Jj()) {
        if (XD(i) !== XD(d)) {
            if (i != null) {
                e = JD(i, 52);
                g = e.Ph(a, WTd(e.zh(), this.b), null, g);
            }
            if (d != null) {
                e = JD(d, 52);
                g = e.Nh(a, WTd(e.zh(), this.b), null, g);
            }
        }
    } else if (this.Zk()) {
        if (XD(i) !== XD(d)) {
            i != null && (g = JD(i, 52).Ph(a, -1 - WTd(a.zh(), this.e), null, g));
            d != null && (g = JD(d, 52).Nh(a, -1 - WTd(a.zh(), this.e), null, g));
        }
    }
    d == null && this.qk() ? b.ii(c, M2d) : b.ii(c, d);
    if (a.rh() && a.sh()) {
        f = new y_d(a, 1, this.e, i, d, this.qk() && !h);
        if (!g) Wpd(a, f);
        else {
            g.kj(f);
            g.lj();
        }
    } else !!g && g.lj();
};
_.Bk = function n4d(a, b, c) {
    var d, e, f, g, h;
    h = b.hi(c);
    g = h != null;
    this.qk() && XD(h) === XD(M2d) && (h = null);
    f = null;
    if (h != null) {
        if (this.Jj()) {
            d = JD(h, 52);
            f = d.Ph(a, WTd(d.zh(), this.b), null, f);
        } else this.Zk() && (f = JD(h, 52).Ph(a, -1 - WTd(a.zh(), this.e), null, f));
    }
    b.ji(c);
    if (a.rh() && a.sh()) {
        e = new y_d(a, this.qk() ? 2 : 1, this.e, h, null, g);
        if (!f) Wpd(a, e);
        else {
            f.kj(e);
            f.lj();
        }
    } else !!f && f.lj();
};
_.Jj = function o4d() {
    return false;
};
_.Zk = function p4d() {
    return false;
};
_.$k = function q4d() {
    return false;
};
_.qk = function r4d() {
    return false;
};
var e8 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObject', 399);
Ycb(557, 399, {}, s4d);
_.Zk = function t4d() {
    return true;
};
var Y7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainment', 557);
Ycb(1298, 557, {}, u4d);
_.$k = function v4d() {
    return true;
};
var R7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentResolving', 1298);
Ycb(767, 557, {}, w4d);
_.qk = function x4d() {
    return true;
};
var T7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettable', 767);
Ycb(1300, 767, {}, y4d);
_.$k = function z4d() {
    return true;
};
var S7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettableResolving', 1300);
Ycb(633, 557, {}, A4d);
_.Jj = function B4d() {
    return true;
};
var X7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverse', 633);
Ycb(1299, 633, {}, C4d);
_.$k = function D4d() {
    return true;
};
var U7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseResolving', 1299);
Ycb(768, 633, {}, E4d);
_.qk = function F4d() {
    return true;
};
var W7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable', 768);
Ycb(1301, 768, {}, G4d);
_.$k = function H4d() {
    return true;
};
var V7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving', 1301);
Ycb(634, 399, {}, I4d);
_.$k = function J4d() {
    return true;
};
var a8 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolving', 634);
Ycb(1302, 634, {}, K4d);
_.qk = function L4d() {
    return true;
};
var Z7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingUnsettable', 1302);
Ycb(769, 634, {}, M4d);
_.Jj = function N4d() {
    return true;
};
var _7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverse', 769);
Ycb(1303, 769, {}, O4d);
_.qk = function P4d() {
    return true;
};
var $7 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable', 1303);
Ycb(1296, 399, {}, Q4d);
_.qk = function R4d() {
    return true;
};
var b8 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectUnsettable', 1296);
Ycb(766, 399, {}, S4d);
_.Jj = function T4d() {
    return true;
};
var d8 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverse', 766);
Ycb(1297, 766, {}, U4d);
_.qk = function V4d() {
    return true;
};
var c8 = jeb(TCe, 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverseUnsettable', 1297);
Ycb(770, 558, xFe, Y4d);
_.vl = function Z4d(a) {
    return new Y4d(this.a, this.c, a);
};
_.kd = function $4d() {
    return this.b;
};
_.wl = function _4d(a, b, c) {
    return W4d(this, a, this.b, c);
};
_.xl = function a5d(a, b, c) {
    return X4d(this, a, this.b, c);
};
var g8 = jeb(TCe, 'EStructuralFeatureImpl/InverseUpdatingFeatureMapEntry', 770);
Ycb(1304, 1, aFe, b5d);
_.Ck = function c5d(a) {
    return this.a;
};
_.Nj = function d5d() {
    return RD(this.a, 96) ? JD(this.a, 96).Nj() : !this.a.dc();
};
_.Wb = function e5d(a) {
    this.a.$b();
    this.a.Fc(JD(a, 15));
};
_.Dk = function f5d() {
    RD(this.a, 96) ? JD(this.a, 96).Dk() : this.a.$b();
};
var h8 = jeb(TCe, 'EStructuralFeatureImpl/SettingMany', 1304);
Ycb(1305, 558, xFe, g5d);
_.ul = function h5d(a) {
    return new l5d((Ihe(), Hhe), this.b.ni(this.a, a));
};
_.kd = function i5d() {
    return null;
};
_.wl = function j5d(a, b, c) {
    return c;
};
_.xl = function k5d(a, b, c) {
    return c;
};
var i8 = jeb(TCe, 'EStructuralFeatureImpl/SimpleContentFeatureMapEntry', 1305);
Ycb(635, 558, xFe, l5d);
_.ul = function m5d(a) {
    return new l5d(this.c, a);
};
_.kd = function n5d() {
    return this.a;
};
_.wl = function o5d(a, b, c) {
    return c;
};
_.xl = function p5d(a, b, c) {
    return c;
};
var j8 = jeb(TCe, 'EStructuralFeatureImpl/SimpleFeatureMapEntry', 635);
Ycb(394, 490, QDe, q5d);
_.Zi = function r5d(a) {
    return SC(_5, Nqe, 29, a, 0, 1);
};
_.Vi = function s5d() {
    return false;
};
var l8 = jeb(TCe, 'ESuperAdapter/1', 394);
Ycb(443, 436, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    829: 1,
    52: 1,
    98: 1,
    157: 1,
    443: 1,
    117: 1,
    118: 1
}, u5d);
_.Hh = function v5d(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return !this.a && (this.a = new D5d(this, g6, this)), this.a;
    }
    return dqd(this, a - VTd((cPd(), bPd)), QTd((d = JD(Crd(this, 16), 29), !d ? bPd : d), a), b, c);
};
_.Qh = function w5d(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3)), QGd(this.Ab, a, c);
        case 2:
            return !this.a && (this.a = new D5d(this, g6, this)), QGd(this.a, a, c);
    }
    return e = JD(QTd((d = JD(Crd(this, 16), 29), !d ? (cPd(), bPd) : d), b), 69), e.tk().xk(this, Ard(this), b - VTd((cPd(), bPd)), a, c);
};
_.Sh = function x5d(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return !!this.a && this.a.i != 0;
    }
    return eqd(this, a - VTd((cPd(), bPd)), QTd((b = JD(Crd(this, 16), 29), !b ? bPd : b), a));
};
_.Zh = function y5d(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            vCd(this.Ab, JD(b, 16));
            return;
        case 1:
            rvd(this, OD(b));
            return;
        case 2:
            !this.a && (this.a = new D5d(this, g6, this));
            RGd(this.a);
            !this.a && (this.a = new D5d(this, g6, this));
            vCd(this.a, JD(b, 16));
            return;
    }
    fqd(this, a - VTd((cPd(), bPd)), QTd((c = JD(Crd(this, 16), 29), !c ? bPd : c), a), b);
};
_.ei = function z5d() {
    return cPd(), bPd;
};
_.gi = function A5d(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new X0d(Z5, this, 0, 3));
            RGd(this.Ab);
            return;
        case 1:
            rvd(this, null);
            return;
        case 2:
            !this.a && (this.a = new D5d(this, g6, this));
            RGd(this.a);
            return;
    }
    gqd(this, a - VTd((cPd(), bPd)), QTd((b = JD(Crd(this, 16), 29), !b ? bPd : b), a));
};
var r8 = jeb(TCe, 'ETypeParameterImpl', 443);
Ycb(444, 81, pFe, D5d);
_.Kj = function E5d(a, b) {
    return B5d(this, JD(a, 87), b);
};
_.Lj = function F5d(a, b) {
    return C5d(this, JD(a, 87), b);
};
var n8 = jeb(TCe, 'ETypeParameterImpl/1', 444);
Ycb(632, 45, bte, G5d);
_.ec = function H5d() {
    return new K5d(this);
};
var q8 = jeb(TCe, 'ETypeParameterImpl/2', 632);
Ycb(553, $qe, _qe, K5d);
_.Ec = function L5d(a) {
    return I5d(this, JD(a, 87));
};
_.Fc = function M5d(a) {
    var b, c, d;
    d = false;
    for(c = a.Jc(); c.Ob();){
        b = JD(c.Pb(), 87);
        Qib(this.a, b, '') == null && (d = true);
    }
    return d;
};
_.$b = function N5d() {
    Tib(this.a);
};
_.Gc = function O5d(a) {
    return Lib(this.a, a);
};
_.Jc = function P5d() {
    var a;
    return a = new mjb(new djb(this.a).a), new S5d(a);
};
_.Kc = function Q5d(a) {
    return J5d(this, a);
};
_.gc = function R5d() {
    return Uib(this.a);
};
var p8 = jeb(TCe, 'ETypeParameterImpl/2/1', 553);
Ycb(554, 1, Wqe, S5d);
_.Nb = function T5d(a) {
    Osb(this, a);
};
_.Pb = function V5d() {
    return JD(kjb(this.a).jd(), 87);
};
_.Ob = function U5d() {
    return this.a.b;
};
_.Qb = function W5d() {
    ljb(this.a);
};
var o8 = jeb(TCe, 'ETypeParameterImpl/2/1/1', 554);
Ycb(1270, 45, bte, X5d);
_._b = function Y5d(a) {
    return VD(a) ? Pib(this, a) : !!fsb(this.f, a);
};
_.xc = function Z5d(a) {
    var b, c;
    b = VD(a) ? Oib(this, a) : Wd(fsb(this.f, a));
    if (RD(b, 830)) {
        c = JD(b, 830);
        b = c.Hk();
        Qib(this, JD(a, 240), b);
        return b;
    } else return b != null ? b : a == null ? (_de(), $de) : null;
};
var t8 = jeb(TCe, 'EValidatorRegistryImpl', 1270);
Ycb(1288, 704, {
    109: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    1986: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
}, f6d);
_.ni = function g6d(a, b) {
    switch(a.ek()){
        case 21:
        case 22:
        case 23:
        case 24:
        case 26:
        case 31:
        case 32:
        case 37:
        case 38:
        case 39:
        case 40:
        case 43:
        case 44:
        case 48:
        case 49:
        case 20:
            return b == null ? null : adb(b);
        case 25:
            return _5d(b);
        case 27:
            return a6d(b);
        case 28:
            return b6d(b);
        case 29:
            return b == null ? null : vZd(Rud[0], JD(b, 205));
        case 41:
            return b == null ? '' : eeb(JD(b, 295));
        case 42:
            return adb(b);
        case 50:
            return OD(b);
        default:
            throw scb(new Teb(WCe + a.ve() + XCe));
    }
};
_.oi = function h6d(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    switch(a.G == -1 && (a.G = (m = WSd(a), m ? AUd(m.ri(), a) : -1)), a.G){
        case 0:
            return c = new HSd, c;
        case 1:
            return b = new KQd, b;
        case 2:
            return d = new aUd, d;
        case 4:
            return e = new FYd, e;
        case 5:
            return f = new VYd, f;
        case 6:
            return g = new kZd, g;
        case 7:
            return h = new avd, h;
        case 10:
            return j = new FPd, j;
        case 11:
            return k = new L_d, k;
        case 12:
            return l = new gwd, l;
        case 13:
            return n = new k1d, n;
        case 14:
            return o = new y1d, o;
        case 17:
            return p = new Q1d, p;
        case 18:
            return i = new NZd, i;
        case 19:
            return q = new u5d, q;
        default:
            throw scb(new Teb($Ce + a.zb + XCe));
    }
};
_.pi = function i6d(a, b) {
    switch(a.ek()){
        case 20:
            return b == null ? null : new shb(b);
        case 21:
            return b == null ? null : new Xhb(b);
        case 23:
        case 22:
            return b == null ? null : $5d(b);
        case 26:
        case 24:
            return b == null ? null : Rdb(Fdb(b, -128, 127) << 24 >> 24);
        case 25:
            return Zud(b);
        case 27:
            return c6d(b);
        case 28:
            return d6d(b);
        case 29:
            return e6d(b);
        case 32:
        case 31:
            return b == null ? null : Edb(b);
        case 38:
        case 37:
            return b == null ? null : new Leb(b);
        case 40:
        case 39:
            return b == null ? null : jfb(Fdb(b, Lre, Hqe));
        case 41:
            return null;
        case 42:
            return b == null ? null : null;
        case 44:
        case 43:
            return b == null ? null : yfb(Gdb(b));
        case 49:
        case 48:
            return b == null ? null : Ufb(Fdb(b, CFe, 32767) << 16 >> 16);
        case 50:
            return b;
        default:
            throw scb(new Teb(WCe + a.ve() + XCe));
    }
};
var u8 = jeb(TCe, 'EcoreFactoryImpl', 1288);
Ycb(545, 184, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    1984: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    545: 1,
    117: 1,
    118: 1,
    675: 1
}, t6d);
_.gb = false;
_.hb = false;
var k6d, l6d = false;
var l9 = jeb(TCe, 'EcorePackageImpl', 545);
Ycb(1194, 1, {
    830: 1
}, x6d);
_.Hk = function y6d() {
    return Afe(), zfe;
};
var F8 = jeb(TCe, 'EcorePackageImpl/1', 1194);
Ycb(1203, 1, PFe, z6d);
_.ck = function A6d(a) {
    return RD(a, 154);
};
_.dk = function B6d(a) {
    return SC(h6, Nqe, 154, a, 0, 1);
};
var v8 = jeb(TCe, 'EcorePackageImpl/10', 1203);
Ycb(1204, 1, PFe, C6d);
_.ck = function D6d(a) {
    return RD(a, 197);
};
_.dk = function E6d(a) {
    return SC(i6, Nqe, 197, a, 0, 1);
};
var w8 = jeb(TCe, 'EcorePackageImpl/11', 1204);
Ycb(1205, 1, PFe, F6d);
_.ck = function G6d(a) {
    return RD(a, 57);
};
_.dk = function H6d(a) {
    return SC(j6, Nqe, 57, a, 0, 1);
};
var x8 = jeb(TCe, 'EcorePackageImpl/12', 1205);
Ycb(1206, 1, PFe, I6d);
_.ck = function J6d(a) {
    return RD(a, 400);
};
_.dk = function K6d(a) {
    return SC(k6, nFe, 62, a, 0, 1);
};
var y8 = jeb(TCe, 'EcorePackageImpl/13', 1206);
Ycb(1207, 1, PFe, L6d);
_.ck = function M6d(a) {
    return RD(a, 240);
};
_.dk = function N6d(a) {
    return SC(l6, Nqe, 240, a, 0, 1);
};
var z8 = jeb(TCe, 'EcorePackageImpl/14', 1207);
Ycb(1208, 1, PFe, O6d);
_.ck = function P6d(a) {
    return RD(a, 502);
};
_.dk = function Q6d(a) {
    return SC(m6, Nqe, 2062, a, 0, 1);
};
var A8 = jeb(TCe, 'EcorePackageImpl/15', 1208);
Ycb(1209, 1, PFe, R6d);
_.ck = function S6d(a) {
    return RD(a, 101);
};
_.dk = function T6d(a) {
    return SC(n6, mFe, 19, a, 0, 1);
};
var B8 = jeb(TCe, 'EcorePackageImpl/16', 1209);
Ycb(1210, 1, PFe, U6d);
_.ck = function V6d(a) {
    return RD(a, 178);
};
_.dk = function W6d(a) {
    return SC(q6, mFe, 178, a, 0, 1);
};
var C8 = jeb(TCe, 'EcorePackageImpl/17', 1210);
Ycb(1211, 1, PFe, X6d);
_.ck = function Y6d(a) {
    return RD(a, 467);
};
_.dk = function Z6d(a) {
    return SC(s6, Nqe, 467, a, 0, 1);
};
var D8 = jeb(TCe, 'EcorePackageImpl/18', 1211);
Ycb(1212, 1, PFe, $6d);
_.ck = function _6d(a) {
    return RD(a, 546);
};
_.dk = function a7d(a) {
    return SC(u7, MEe, 546, a, 0, 1);
};
var E8 = jeb(TCe, 'EcorePackageImpl/19', 1212);
Ycb(1195, 1, PFe, b7d);
_.ck = function c7d(a) {
    return RD(a, 330);
};
_.dk = function d7d(a) {
    return SC($5, mFe, 35, a, 0, 1);
};
var Q8 = jeb(TCe, 'EcorePackageImpl/2', 1195);
Ycb(1213, 1, PFe, e7d);
_.ck = function f7d(a) {
    return RD(a, 246);
};
_.dk = function g7d(a) {
    return SC(g6, tFe, 87, a, 0, 1);
};
var G8 = jeb(TCe, 'EcorePackageImpl/20', 1213);
Ycb(1214, 1, PFe, h7d);
_.ck = function i7d(a) {
    return RD(a, 443);
};
_.dk = function j7d(a) {
    return SC(r6, Nqe, 829, a, 0, 1);
};
var H8 = jeb(TCe, 'EcorePackageImpl/21', 1214);
Ycb(1215, 1, PFe, k7d);
_.ck = function l7d(a) {
    return SD(a);
};
_.dk = function m7d(a) {
    return SC(GI, hre, 471, a, 8, 1);
};
var I8 = jeb(TCe, 'EcorePackageImpl/22', 1215);
Ycb(1216, 1, PFe, n7d);
_.ck = function o7d(a) {
    return RD(a, 195);
};
_.dk = function p7d(a) {
    return SC($D, hre, 195, a, 0, 2);
};
var J8 = jeb(TCe, 'EcorePackageImpl/23', 1216);
Ycb(1217, 1, PFe, q7d);
_.ck = function r7d(a) {
    return RD(a, 219);
};
_.dk = function s7d(a) {
    return SC(HI, hre, 219, a, 0, 1);
};
var K8 = jeb(TCe, 'EcorePackageImpl/24', 1217);
Ycb(1218, 1, PFe, t7d);
_.ck = function u7d(a) {
    return RD(a, 179);
};
_.dk = function v7d(a) {
    return SC(II, hre, 179, a, 0, 1);
};
var L8 = jeb(TCe, 'EcorePackageImpl/25', 1218);
Ycb(1219, 1, PFe, w7d);
_.ck = function x7d(a) {
    return RD(a, 205);
};
_.dk = function y7d(a) {
    return SC(hK, hre, 205, a, 0, 1);
};
var M8 = jeb(TCe, 'EcorePackageImpl/26', 1219);
Ycb(1220, 1, PFe, z7d);
_.ck = function A7d(a) {
    return false;
};
_.dk = function B7d(a) {
    return SC(L5, Nqe, 2159, a, 0, 1);
};
var N8 = jeb(TCe, 'EcorePackageImpl/27', 1220);
Ycb(1221, 1, PFe, C7d);
_.ck = function D7d(a) {
    return TD(a);
};
_.dk = function E7d(a) {
    return SC(LI, hre, 341, a, 7, 1);
};
var O8 = jeb(TCe, 'EcorePackageImpl/28', 1221);
Ycb(1222, 1, PFe, F7d);
_.ck = function G7d(a) {
    return RD(a, 61);
};
_.dk = function H7d(a) {
    return SC(Q5, nue, 61, a, 0, 1);
};
var P8 = jeb(TCe, 'EcorePackageImpl/29', 1222);
Ycb(1196, 1, PFe, I7d);
_.ck = function J7d(a) {
    return RD(a, 503);
};
_.dk = function K7d(a) {
    return SC(Z5, {
        3: 1,
        4: 1,
        5: 1,
        1979: 1
    }, 582, a, 0, 1);
};
var _8 = jeb(TCe, 'EcorePackageImpl/3', 1196);
Ycb(1223, 1, PFe, L7d);
_.ck = function M7d(a) {
    return RD(a, 564);
};
_.dk = function N7d(a) {
    return SC(R5, Nqe, 1985, a, 0, 1);
};
var R8 = jeb(TCe, 'EcorePackageImpl/30', 1223);
Ycb(1224, 1, PFe, O7d);
_.ck = function P7d(a) {
    return RD(a, 159);
};
_.dk = function Q7d(a) {
    return SC(Lab, nue, 159, a, 0, 1);
};
var S8 = jeb(TCe, 'EcorePackageImpl/31', 1224);
Ycb(1225, 1, PFe, R7d);
_.ck = function S7d(a) {
    return RD(a, 74);
};
_.dk = function T7d(a) {
    return SC(Bab, QFe, 74, a, 0, 1);
};
var T8 = jeb(TCe, 'EcorePackageImpl/32', 1225);
Ycb(1226, 1, PFe, U7d);
_.ck = function V7d(a) {
    return RD(a, 160);
};
_.dk = function W7d(a) {
    return SC(QI, hre, 160, a, 0, 1);
};
var U8 = jeb(TCe, 'EcorePackageImpl/33', 1226);
Ycb(1227, 1, PFe, X7d);
_.ck = function Y7d(a) {
    return RD(a, 17);
};
_.dk = function Z7d(a) {
    return SC(UI, hre, 17, a, 0, 1);
};
var V8 = jeb(TCe, 'EcorePackageImpl/34', 1227);
Ycb(1228, 1, PFe, $7d);
_.ck = function _7d(a) {
    return RD(a, 295);
};
_.dk = function a8d(a) {
    return SC(KI, Nqe, 295, a, 0, 1);
};
var W8 = jeb(TCe, 'EcorePackageImpl/35', 1228);
Ycb(1229, 1, PFe, b8d);
_.ck = function c8d(a) {
    return RD(a, 190);
};
_.dk = function d8d(a) {
    return SC(XI, hre, 190, a, 0, 1);
};
var X8 = jeb(TCe, 'EcorePackageImpl/36', 1229);
Ycb(1230, 1, PFe, e8d);
_.ck = function f8d(a) {
    return RD(a, 91);
};
_.dk = function g8d(a) {
    return SC(MK, Nqe, 91, a, 0, 1);
};
var Y8 = jeb(TCe, 'EcorePackageImpl/37', 1230);
Ycb(1231, 1, PFe, h8d);
_.ck = function i8d(a) {
    return RD(a, 583);
};
_.dk = function j8d(a) {
    return SC(s9, Nqe, 583, a, 0, 1);
};
var Z8 = jeb(TCe, 'EcorePackageImpl/38', 1231);
Ycb(1232, 1, PFe, k8d);
_.ck = function l8d(a) {
    return false;
};
_.dk = function m8d(a) {
    return SC(r9, Nqe, 2160, a, 0, 1);
};
var $8 = jeb(TCe, 'EcorePackageImpl/39', 1232);
Ycb(1197, 1, PFe, n8d);
_.ck = function o8d(a) {
    return RD(a, 88);
};
_.dk = function p8d(a) {
    return SC(_5, Nqe, 29, a, 0, 1);
};
var f9 = jeb(TCe, 'EcorePackageImpl/4', 1197);
Ycb(1233, 1, PFe, q8d);
_.ck = function r8d(a) {
    return RD(a, 191);
};
_.dk = function s8d(a) {
    return SC(cJ, hre, 191, a, 0, 1);
};
var a9 = jeb(TCe, 'EcorePackageImpl/40', 1233);
Ycb(1234, 1, PFe, t8d);
_.ck = function u8d(a) {
    return VD(a);
};
_.dk = function v8d(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var b9 = jeb(TCe, 'EcorePackageImpl/41', 1234);
Ycb(1235, 1, PFe, w8d);
_.ck = function x8d(a) {
    return RD(a, 580);
};
_.dk = function y8d(a) {
    return SC(U5, Nqe, 580, a, 0, 1);
};
var c9 = jeb(TCe, 'EcorePackageImpl/42', 1235);
Ycb(1236, 1, PFe, z8d);
_.ck = function A8d(a) {
    return false;
};
_.dk = function B8d(a) {
    return SC(S5, hre, 2161, a, 0, 1);
};
var d9 = jeb(TCe, 'EcorePackageImpl/43', 1236);
Ycb(1237, 1, PFe, C8d);
_.ck = function D8d(a) {
    return RD(a, 43);
};
_.dk = function E8d(a) {
    return SC(LK, tre, 43, a, 0, 1);
};
var e9 = jeb(TCe, 'EcorePackageImpl/44', 1237);
Ycb(1198, 1, PFe, F8d);
_.ck = function G8d(a) {
    return RD(a, 141);
};
_.dk = function H8d(a) {
    return SC(a6, Nqe, 141, a, 0, 1);
};
var g9 = jeb(TCe, 'EcorePackageImpl/5', 1198);
Ycb(1199, 1, PFe, I8d);
_.ck = function J8d(a) {
    return RD(a, 155);
};
_.dk = function K8d(a) {
    return SC(c6, Nqe, 155, a, 0, 1);
};
var h9 = jeb(TCe, 'EcorePackageImpl/6', 1199);
Ycb(1200, 1, PFe, L8d);
_.ck = function M8d(a) {
    return RD(a, 455);
};
_.dk = function N8d(a) {
    return SC(e6, Nqe, 670, a, 0, 1);
};
var i9 = jeb(TCe, 'EcorePackageImpl/7', 1200);
Ycb(1201, 1, PFe, O8d);
_.ck = function P8d(a) {
    return RD(a, 564);
};
_.dk = function Q8d(a) {
    return SC(d6, Nqe, 679, a, 0, 1);
};
var j9 = jeb(TCe, 'EcorePackageImpl/8', 1201);
Ycb(1202, 1, PFe, R8d);
_.ck = function S8d(a) {
    return RD(a, 466);
};
_.dk = function T8d(a) {
    return SC(f6, Nqe, 466, a, 0, 1);
};
var k9 = jeb(TCe, 'EcorePackageImpl/9', 1202);
Ycb(1013, 2026, KEe, X8d);
_.Ji = function Y8d(a, b) {
    U8d(this, JD(b, 412));
};
_.Ni = function Z8d(a, b) {
    V8d(this, a, JD(b, 412));
};
var n9 = jeb(TCe, 'MinimalEObjectImpl/1ArrayDelegatingAdapterList', 1013);
Ycb(1014, 150, HEe, $8d);
_.gj = function _8d() {
    return this.a.a;
};
var m9 = jeb(TCe, 'MinimalEObjectImpl/1ArrayDelegatingAdapterList/1', 1014);
Ycb(1042, 1041, {}, b9d);
var q9 = jeb('org.eclipse.emf.ecore.plugin', 'EcorePlugin', 1042);
var s9 = leb(RFe, 'Resource');
Ycb(779, 1464, SFe);
_.El = function f9d(a) {};
_.Fl = function g9d(a) {};
_.Bl = function h9d() {
    return !this.a && (this.a = new s9d(this)), this.a;
};
_.Cl = function i9d(a) {
    var b, c, d, e, f;
    d = a.length;
    if (d > 0) {
        ADb(0, a.length);
        if (a.charCodeAt(0) == 47) {
            f = new Vlb(4);
            e = 1;
            for(b = 1; b < d; ++b){
                ADb(b, a.length);
                if (a.charCodeAt(b) == 47) {
                    Ilb(f, e == b ? '' : (zDb(e, b, a.length), a.substr(e, b - e)));
                    e = b + 1;
                }
            }
            Ilb(f, (ADb(e, a.length + 1), a.substr(e)));
            return c9d(this, f);
        } else {
            ADb(d - 1, a.length);
            if (a.charCodeAt(d - 1) == 63) {
                c = lgb(a, wgb(63), d - 2);
                c > 0 && (a = (zDb(0, c, a.length), a.substr(0, c)));
            }
        }
    }
    return d9d(this, a);
};
_.Dl = function j9d() {
    return this.c;
};
_.Ib = function k9d() {
    var a;
    return eeb(this.Om) + '@' + (a = tb(this) >>> 0, a.toString(16)) + " uri='" + this.d + "'";
};
_.b = false;
var w9 = jeb(TFe, 'ResourceImpl', 779);
Ycb(1465, 779, SFe, l9d);
var t9 = jeb(TFe, 'BinaryResourceImpl', 1465);
Ycb(1154, 692, RDe);
_.$i = function o9d(a) {
    return RD(a, 57) ? m9d(this, JD(a, 57)) : RD(a, 583) ? new CHd(JD(a, 583).Bl()) : XD(a) === XD(this.f) ? JD(a, 16).Jc() : (GLd(), FLd.a);
};
_.Ob = function p9d() {
    return n9d(this);
};
_.a = false;
var wab = jeb(_Ee, 'EcoreUtil/ContentTreeIterator', 1154);
Ycb(1466, 1154, RDe, q9d);
_.$i = function r9d(a) {
    return XD(a) === XD(this.f) ? JD(a, 15).Jc() : new ufe(JD(a, 57));
};
var u9 = jeb(TFe, 'ResourceImpl/5', 1466);
Ycb(642, 2038, oFe, s9d);
_.Gc = function t9d(a) {
    return this.i <= 4 ? mDd(this, a) : RD(a, 52) && JD(a, 52).Fh() == this.a;
};
_.Ji = function u9d(a, b) {
    a == this.i - 1 && (this.a.b || (this.a.b = true));
};
_.Li = function v9d(a, b) {
    a == 0 ? this.a.b || (this.a.b = true) : xCd(this, a, b);
};
_.Ni = function w9d(a, b) {};
_.Oi = function x9d(a, b, c) {};
_.Ij = function y9d() {
    return 2;
};
_.gj = function z9d() {
    return this.a;
};
_.Jj = function A9d() {
    return true;
};
_.Kj = function B9d(a, b) {
    var c;
    c = JD(a, 52);
    b = c.bi(this.a, b);
    return b;
};
_.Lj = function C9d(a, b) {
    var c;
    c = JD(a, 52);
    return c.bi(null, b);
};
_.Mj = function D9d() {
    return false;
};
_.Pi = function E9d() {
    return true;
};
_.Zi = function F9d(a) {
    return SC(j6, Nqe, 57, a, 0, 1);
};
_.Vi = function G9d() {
    return false;
};
var v9 = jeb(TFe, 'ResourceImpl/ContentsEList', 642);
Ycb(948, 2008, Fre, H9d);
_.dd = function I9d(a) {
    return this.a.Hi(a);
};
_.gc = function J9d() {
    return this.a.gc();
};
var x9 = jeb(_Ee, 'AbstractSequentialInternalEList/1', 948);
var Cfe, Dfe, Efe, Ffe;
Ycb(619, 1, {}, rae);
var K9d, L9d;
var D9 = jeb(_Ee, 'BasicExtendedMetaData', 619);
Ycb(1145, 1, {}, vae);
_.Gl = function wae() {
    return null;
};
_.Hl = function xae() {
    this.a == -2 && tae(this, P9d(this.d, this.b));
    return this.a;
};
_.Il = function yae() {
    return null;
};
_.Jl = function zae() {
    return pnb(), pnb(), mnb;
};
_.ve = function Aae() {
    this.c == gGe && uae(this, U9d(this.d, this.b));
    return this.c;
};
_.Kl = function Bae() {
    return 0;
};
_.a = -2;
_.c = gGe;
var z9 = jeb(_Ee, 'BasicExtendedMetaData/EClassExtendedMetaDataImpl', 1145);
Ycb(1146, 1, {}, Hae);
_.Gl = function Iae() {
    this.a == (M9d(), K9d) && Cae(this, O9d(this.f, this.b));
    return this.a;
};
_.Hl = function Jae() {
    return 0;
};
_.Il = function Kae() {
    this.c == (M9d(), K9d) && Dae(this, S9d(this.f, this.b));
    return this.c;
};
_.Jl = function Lae() {
    !this.d && Eae(this, T9d(this.f, this.b));
    return this.d;
};
_.ve = function Mae() {
    this.e == gGe && Fae(this, U9d(this.f, this.b));
    return this.e;
};
_.Kl = function Nae() {
    this.g == -2 && Gae(this, X9d(this.f, this.b));
    return this.g;
};
_.e = gGe;
_.g = -2;
var A9 = jeb(_Ee, 'BasicExtendedMetaData/EDataTypeExtendedMetaDataImpl', 1146);
Ycb(1144, 1, {}, Rae);
_.b = false;
_.c = false;
var B9 = jeb(_Ee, 'BasicExtendedMetaData/EPackageExtendedMetaDataImpl', 1144);
Ycb(1147, 1, {}, cbe);
_.c = -2;
_.e = gGe;
_.f = gGe;
var C9 = jeb(_Ee, 'BasicExtendedMetaData/EStructuralFeatureExtendedMetaDataImpl', 1147);
Ycb(576, 617, pFe, dbe);
_.Ij = function ebe() {
    return this.c;
};
_.ll = function fbe() {
    return false;
};
_.Ti = function gbe(a, b) {
    return b;
};
_.c = 0;
var Q9 = jeb(_Ee, 'EDataTypeEList', 576);
var Lab = leb(_Ee, 'FeatureMap');
Ycb(75, 576, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    76: 1,
    159: 1,
    218: 1,
    1982: 1,
    71: 1,
    96: 1
}, nce);
_._c = function oce(a, b) {
    hbe(this, a, JD(b, 74));
};
_.Ec = function pce(a) {
    return kbe(this, JD(a, 74));
};
_.Ei = function uce(a) {
    pbe(this, JD(a, 74));
};
_.Kj = function Fce(a, b) {
    return Hbe(this, JD(a, 74), b);
};
_.Lj = function Gce(a, b) {
    return Jbe(this, JD(a, 74), b);
};
_.Qi = function Ice(a, b) {
    return Pbe(this, a, b);
};
_.Ti = function Kce(a, b) {
    return Ube(this, a, JD(b, 74));
};
_.fd = function Mce(a, b) {
    return Xbe(this, a, JD(b, 74));
};
_.Rj = function Qce(a, b) {
    return bce(this, JD(a, 74), b);
};
_.Sj = function Rce(a, b) {
    return dce(this, JD(a, 74), b);
};
_.Tj = function Sce(a, b, c) {
    return ece(this, JD(a, 74), JD(b, 74), c);
};
_.Wi = function Uce(a, b) {
    return mce(this, a, JD(b, 74));
};
_.Ll = function qce(a, b) {
    return jbe(this, a, b);
};
_.ad = function rce(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = new wDd(b.gc());
    for(e = b.Jc(); e.Ob();){
        d = JD(e.Pb(), 74);
        f = d.Ik();
        if (Lfe(this.e, f)) (!f.Pi() || !xbe(this, f, d.kd()) && !mDd(j, d)) && tCd(j, d);
        else {
            k = Kfe(this.e.zh(), f);
            c = JD(this.g, 122);
            g = true;
            for(h = 0; h < this.i; ++h){
                i = c[h];
                if (k.Zl(i.Ik())) {
                    JD(DCd(this, h, d), 74);
                    g = false;
                    break;
                }
            }
            g && tCd(j, d);
        }
    }
    return uCd(this, a, j);
};
_.Fc = function sce(a) {
    var b, c, d, e, f, g, h, i, j;
    i = new wDd(a.gc());
    for(d = a.Jc(); d.Ob();){
        c = JD(d.Pb(), 74);
        e = c.Ik();
        if (Lfe(this.e, e)) (!e.Pi() || !xbe(this, e, c.kd()) && !mDd(i, c)) && tCd(i, c);
        else {
            j = Kfe(this.e.zh(), e);
            b = JD(this.g, 122);
            f = true;
            for(g = 0; g < this.i; ++g){
                h = b[g];
                if (j.Zl(h.Ik())) {
                    JD(DCd(this, g, c), 74);
                    f = false;
                    break;
                }
            }
            f && tCd(i, c);
        }
    }
    return vCd(this, i);
};
_.Ci = function tce(a) {
    this.j = -1;
    return MGd(this, this.i, a);
};
_.Ml = function vce(a, b, c) {
    return qbe(this, a, b, c);
};
_.Uk = function wce(a, b) {
    return ube(this, a, b);
};
_.Nl = function xce(a, b, c) {
    return vbe(this, a, b, c);
};
_.Ol = function yce() {
    return this;
};
_.Pl = function zce(a, b) {
    return Dbe(this, a, b);
};
_.Ql = function Ace(a) {
    return JD(nDd(this, a), 74).Ik();
};
_.Rl = function Bce(a) {
    return JD(nDd(this, a), 74).kd();
};
_.Sl = function Cce() {
    return this.b;
};
_.Jj = function Dce() {
    return true;
};
_.Qj = function Ece() {
    return true;
};
_.Tl = function Hce(a) {
    return !Kbe(this, a);
};
_.Zi = function Jce(a) {
    return SC(Aab, QFe, 339, a, 0, 1);
};
_.ml = function Lce(a) {
    return Vbe(this, a);
};
_.Wb = function Nce(a) {
    Ybe(this, a);
};
_.Ul = function Oce(a, b) {
    $be(this, a, b);
};
_.Vl = function Pce(a) {
    return _be(this, a);
};
_.Wl = function Tce(a) {
    lce(this, a);
};
var G9 = jeb(_Ee, 'BasicFeatureMap', 75);
Ycb(1906, 1, dre);
_.Nb = function $ce(a) {
    Osb(this, a);
};
_.Rb = function Zce(b) {
    if (this.g == -1) throw scb(new Veb);
    Vce(this);
    try {
        ibe(this.e, this.b, this.a, b);
        this.d = this.e.j;
        Yce(this);
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) throw scb(new yqb);
        else throw scb(a);
    }
};
_.Ob = function _ce() {
    return Wce(this);
};
_.Sb = function ade() {
    return Xce(this);
};
_.Pb = function bde() {
    return Yce(this);
};
_.Tb = function cde() {
    return this.a;
};
_.Ub = function dde() {
    var a;
    if (Xce(this)) {
        Vce(this);
        this.g = --this.a;
        if (this.rl()) {
            a = Wbe(this.e, this.b, this.c, this.a, this.j);
            this.j = a;
        }
        this.i = 0;
        return this.j;
    } else throw scb(new qub);
};
_.Vb = function ede() {
    return this.a - 1;
};
_.Qb = function fde() {
    if (this.g == -1) throw scb(new Veb);
    Vce(this);
    try {
        Sbe(this.e, this.b, this.g);
        this.d = this.e.j;
        if (this.g < this.a) {
            --this.a;
            --this.c;
        }
        --this.g;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) throw scb(new yqb);
        else throw scb(a);
    }
};
_.rl = function gde() {
    return false;
};
_.Wb = function hde(b) {
    if (this.g == -1) throw scb(new Veb);
    Vce(this);
    try {
        Zbe(this.e, this.b, this.g, b);
        this.d = this.e.j;
    } catch (a) {
        a = rcb(a);
        if (RD(a, 97)) throw scb(new yqb);
        else throw scb(a);
    }
};
_.a = 0;
_.c = 0;
_.d = 0;
_.f = false;
_.g = 0;
_.i = 0;
var Dab = jeb(_Ee, 'FeatureMapUtil/BasicFeatureEIterator', 1906);
Ycb(409, 1906, dre, ide);
_.Xl = function jde() {
    var a, b, c;
    c = this.e.i;
    a = JD(this.e.g, 122);
    while(this.c < c){
        b = a[this.c];
        if (this.k.Zl(b.Ik())) {
            this.j = this.f ? b : b.kd();
            this.i = 2;
            return true;
        }
        ++this.c;
    }
    this.i = 1;
    this.g = -1;
    return false;
};
_.Yl = function kde() {
    var a, b;
    a = JD(this.e.g, 122);
    while(--this.c >= 0){
        b = a[this.c];
        if (this.k.Zl(b.Ik())) {
            this.j = this.f ? b : b.kd();
            this.i = -2;
            return true;
        }
    }
    this.i = -1;
    this.g = -1;
    return false;
};
var E9 = jeb(_Ee, 'BasicFeatureMap/FeatureEIterator', 409);
Ycb(661, 409, dre, lde);
_.rl = function mde() {
    return true;
};
var F9 = jeb(_Ee, 'BasicFeatureMap/ResolvingFeatureEIterator', 661);
Ycb(946, 480, vFe, nde);
_.mj = function ode() {
    return this;
};
var J9 = jeb(_Ee, 'EContentsEList/1', 946);
Ycb(947, 480, vFe, pde);
_.rl = function qde() {
    return false;
};
var K9 = jeb(_Ee, 'EContentsEList/2', 947);
Ycb(945, 284, wFe, rde);
_.tl = function sde(a) {};
_.Ob = function tde() {
    return false;
};
_.Sb = function ude() {
    return false;
};
var L9 = jeb(_Ee, 'EContentsEList/FeatureIteratorImpl/1', 945);
Ycb(819, 576, pFe, vde);
_.Ki = function wde() {
    this.a = true;
};
_.Nj = function xde() {
    return this.a;
};
_.Dk = function yde() {
    var a;
    RGd(this);
    if (qqd(this.e)) {
        a = this.a;
        this.a = false;
        Wpd(this.e, new j_d(this.e, 2, this.c, a, false));
    } else this.a = false;
};
_.a = false;
var P9 = jeb(_Ee, 'EDataTypeEList/Unsettable', 819);
Ycb(1904, 576, pFe, zde);
_.Pi = function Ade() {
    return true;
};
var S9 = jeb(_Ee, 'EDataTypeUniqueEList', 1904);
Ycb(1905, 819, pFe, Bde);
_.Pi = function Cde() {
    return true;
};
var R9 = jeb(_Ee, 'EDataTypeUniqueEList/Unsettable', 1905);
Ycb(142, 81, pFe, Dde);
_.kl = function Ede() {
    return true;
};
_.Ti = function Fde(a, b) {
    return BUd(this, a, JD(b, 57));
};
var T9 = jeb(_Ee, 'EObjectContainmentEList/Resolving', 142);
Ycb(1148, 540, pFe, Gde);
_.kl = function Hde() {
    return true;
};
_.Ti = function Ide(a, b) {
    return BUd(this, a, JD(b, 57));
};
var U9 = jeb(_Ee, 'EObjectContainmentEList/Unsettable/Resolving', 1148);
Ycb(748, 14, pFe, Jde);
_.Ki = function Kde() {
    this.a = true;
};
_.Nj = function Lde() {
    return this.a;
};
_.Dk = function Mde() {
    var a;
    RGd(this);
    if (qqd(this.e)) {
        a = this.a;
        this.a = false;
        Wpd(this.e, new j_d(this.e, 2, this.c, a, false));
    } else this.a = false;
};
_.a = false;
var Z9 = jeb(_Ee, 'EObjectContainmentWithInverseEList/Unsettable', 748);
Ycb(1182, 748, pFe, Nde);
_.kl = function Ode() {
    return true;
};
_.Ti = function Pde(a, b) {
    return BUd(this, a, JD(b, 57));
};
var Y9 = jeb(_Ee, 'EObjectContainmentWithInverseEList/Unsettable/Resolving', 1182);
Ycb(740, 489, pFe, Qde);
_.Ki = function Rde() {
    this.a = true;
};
_.Nj = function Sde() {
    return this.a;
};
_.Dk = function Tde() {
    var a;
    RGd(this);
    if (qqd(this.e)) {
        a = this.a;
        this.a = false;
        Wpd(this.e, new j_d(this.e, 2, this.c, a, false));
    } else this.a = false;
};
_.a = false;
var _9 = jeb(_Ee, 'EObjectEList/Unsettable', 740);
Ycb(334, 489, pFe, Ude);
_.kl = function Vde() {
    return true;
};
_.Ti = function Wde(a, b) {
    return BUd(this, a, JD(b, 57));
};
var cab = jeb(_Ee, 'EObjectResolvingEList', 334);
Ycb(1790, 740, pFe, Xde);
_.kl = function Yde() {
    return true;
};
_.Ti = function Zde(a, b) {
    return BUd(this, a, JD(b, 57));
};
var bab = jeb(_Ee, 'EObjectResolvingEList/Unsettable', 1790);
Ycb(1467, 1, {}, aee);
var $de;
var dab = jeb(_Ee, 'EObjectValidator', 1467);
Ycb(544, 489, pFe, bee);
_.fl = function cee() {
    return this.d;
};
_.gl = function dee() {
    return this.b;
};
_.Jj = function eee() {
    return true;
};
_.jl = function fee() {
    return true;
};
_.b = 0;
var hab = jeb(_Ee, 'EObjectWithInverseEList', 544);
Ycb(1185, 544, pFe, gee);
_.il = function hee() {
    return true;
};
var eab = jeb(_Ee, 'EObjectWithInverseEList/ManyInverse', 1185);
Ycb(620, 544, pFe, iee);
_.Ki = function jee() {
    this.a = true;
};
_.Nj = function kee() {
    return this.a;
};
_.Dk = function lee() {
    var a;
    RGd(this);
    if (qqd(this.e)) {
        a = this.a;
        this.a = false;
        Wpd(this.e, new j_d(this.e, 2, this.c, a, false));
    } else this.a = false;
};
_.a = false;
var gab = jeb(_Ee, 'EObjectWithInverseEList/Unsettable', 620);
Ycb(1184, 620, pFe, mee);
_.il = function nee() {
    return true;
};
var fab = jeb(_Ee, 'EObjectWithInverseEList/Unsettable/ManyInverse', 1184);
Ycb(749, 544, pFe, oee);
_.kl = function pee() {
    return true;
};
_.Ti = function qee(a, b) {
    return BUd(this, a, JD(b, 57));
};
var lab = jeb(_Ee, 'EObjectWithInverseResolvingEList', 749);
Ycb(33, 749, pFe, ree);
_.il = function see() {
    return true;
};
var iab = jeb(_Ee, 'EObjectWithInverseResolvingEList/ManyInverse', 33);
Ycb(750, 620, pFe, tee);
_.kl = function uee() {
    return true;
};
_.Ti = function vee(a, b) {
    return BUd(this, a, JD(b, 57));
};
var kab = jeb(_Ee, 'EObjectWithInverseResolvingEList/Unsettable', 750);
Ycb(1183, 750, pFe, wee);
_.il = function xee() {
    return true;
};
var jab = jeb(_Ee, 'EObjectWithInverseResolvingEList/Unsettable/ManyInverse', 1183);
Ycb(1149, 617, pFe);
_.Ii = function yee() {
    return (this.b & 1792) == 0;
};
_.Ki = function zee() {
    this.b |= 1;
};
_.hl = function Aee() {
    return (this.b & 4) != 0;
};
_.Jj = function Bee() {
    return (this.b & 40) != 0;
};
_.il = function Cee() {
    return (this.b & 16) != 0;
};
_.jl = function Dee() {
    return (this.b & 8) != 0;
};
_.kl = function Eee() {
    return (this.b & wse) != 0;
};
_.Zk = function Fee() {
    return (this.b & 32) != 0;
};
_.ll = function Gee() {
    return (this.b & NEe) != 0;
};
_.ck = function Hee(a) {
    return !this.d ? this.Ik().Ek().ck(a) : jNd(this.d, a);
};
_.Nj = function Iee() {
    return (this.b & 2) != 0 ? (this.b & 1) != 0 : this.i != 0;
};
_.Pi = function Jee() {
    return (this.b & 128) != 0;
};
_.Dk = function Lee() {
    var a;
    RGd(this);
    if ((this.b & 2) != 0) {
        if (qqd(this.e)) {
            a = (this.b & 1) != 0;
            this.b &= -2;
            zUd(this, new j_d(this.e, 2, WTd(this.e.zh(), this.Ik()), a, false));
        } else this.b &= -2;
    }
};
_.Vi = function Mee() {
    return (this.b & 1536) == 0;
};
_.b = 0;
var nab = jeb(_Ee, 'EcoreEList/Generic', 1149);
Ycb(1150, 1149, pFe, Nee);
_.Ik = function Oee() {
    return this.a;
};
var mab = jeb(_Ee, 'EcoreEList/Dynamic', 1150);
Ycb(747, 66, QDe, Pee);
_.Zi = function Qee(a) {
    return fId(this.a.a, a);
};
var rab = jeb(_Ee, 'EcoreEMap/1', 747);
Ycb(746, 81, pFe, Ree);
_.Ji = function See(a, b) {
    rJd(this.b, JD(b, 135));
};
_.Li = function Tee(a, b) {
    qJd(this.b);
};
_.Mi = function Uee(a, b, c) {
    var d;
    ++(d = this.b, JD(b, 135), d).e;
};
_.Ni = function Vee(a, b) {
    sJd(this.b, JD(b, 135));
};
_.Oi = function Wee(a, b, c) {
    sJd(this.b, JD(c, 135));
    XD(c) === XD(b) && JD(c, 135).yi(zJd(JD(b, 135).jd()));
    rJd(this.b, JD(b, 135));
};
var sab = jeb(_Ee, 'EcoreEMap/DelegateEObjectContainmentEList', 746);
Ycb(1180, 140, bFe, Xee);
var uab = jeb(_Ee, 'EcoreEMap/Unsettable', 1180);
Ycb(1181, 746, pFe, Yee);
_.Ki = function Zee() {
    this.a = true;
};
_.Nj = function $ee() {
    return this.a;
};
_.Dk = function _ee() {
    var a;
    RGd(this);
    if (qqd(this.e)) {
        a = this.a;
        this.a = false;
        Wpd(this.e, new j_d(this.e, 2, this.c, a, false));
    } else this.a = false;
};
_.a = false;
var tab = jeb(_Ee, 'EcoreEMap/Unsettable/UnsettableDelegateEObjectContainmentEList', 1181);
Ycb(1153, 221, bte, sfe);
_.a = false;
_.b = false;
var xab = jeb(_Ee, 'EcoreUtil/Copier', 1153);
Ycb(742, 1, Wqe, ufe);
_.Nb = function vfe(a) {
    Osb(this, a);
};
_.Ob = function wfe() {
    return tfe(this);
};
_.Pb = function xfe() {
    var a;
    tfe(this);
    a = this.b;
    this.b = null;
    return a;
};
_.Qb = function yfe() {
    this.a.Qb();
};
var yab = jeb(_Ee, 'EcoreUtil/ProperContentIterator', 742);
Ycb(1468, 1467, {}, Bfe);
var zfe;
var zab = jeb(_Ee, 'EcoreValidator', 1468);
var Hfe;
var Kab = leb(_Ee, 'FeatureMapUtil/Validator');
Ycb(1248, 1, {
    1987: 1
}, Mfe);
_.Zl = function Nfe(a) {
    return true;
};
var Cab = jeb(_Ee, 'FeatureMapUtil/1', 1248);
Ycb(755, 1, {
    1987: 1
}, Rfe);
_.Zl = function Sfe(a) {
    var b;
    if (this.c == a) return true;
    b = LD(Nib(this.a, a));
    if (b == null) {
        if (Qfe(this, a)) {
            Tfe(this.a, a, (xdb(), wdb));
            return true;
        } else {
            Tfe(this.a, a, (xdb(), vdb));
            return false;
        }
    } else return b == (xdb(), wdb);
};
_.e = false;
var Ofe;
var Fab = jeb(_Ee, 'FeatureMapUtil/BasicValidator', 755);
Ycb(756, 45, bte, Ufe);
var Eab = jeb(_Ee, 'FeatureMapUtil/BasicValidator/Cache', 756);
Ycb(493, 55, {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    61: 1,
    76: 1,
    71: 1,
    96: 1
}, Zfe);
_._c = function $fe(a, b) {
    ibe(this.c, this.b, a, b);
};
_.Ec = function _fe(a) {
    return jbe(this.c, this.b, a);
};
_.ad = function age(a, b) {
    return lbe(this.c, this.b, a, b);
};
_.Fc = function bge(a) {
    return Vfe(this, a);
};
_.Di = function cge(a, b) {
    nbe(this.c, this.b, a, b);
};
_.Tk = function dge(a, b) {
    return qbe(this.c, this.b, a, b);
};
_.Xi = function ege(a) {
    return Cbe(this.c, this.b, a, false);
};
_.Fi = function fge() {
    return rbe(this.c, this.b);
};
_.Gi = function gge() {
    return sbe(this.c, this.b);
};
_.Hi = function hge(a) {
    return tbe(this.c, this.b, a);
};
_.Uk = function ige(a, b) {
    return Wfe(this, a, b);
};
_.$b = function jge() {
    Xfe(this);
};
_.Gc = function kge(a) {
    return xbe(this.c, this.b, a);
};
_.Hc = function lge(a) {
    return zbe(this.c, this.b, a);
};
_.Xb = function mge(a) {
    return Cbe(this.c, this.b, a, true);
};
_.Ck = function nge(a) {
    return this;
};
_.bd = function oge(a) {
    return Ebe(this.c, this.b, a);
};
_.dc = function pge() {
    return Yfe(this);
};
_.Nj = function qge() {
    return !Kbe(this.c, this.b);
};
_.Jc = function rge() {
    return Lbe(this.c, this.b);
};
_.cd = function sge() {
    return Nbe(this.c, this.b);
};
_.dd = function tge(a) {
    return Obe(this.c, this.b, a);
};
_.Qi = function uge(a, b) {
    return Qbe(this.c, this.b, a, b);
};
_.Ri = function vge(a, b) {
    Rbe(this.c, this.b, a, b);
};
_.ed = function wge(a) {
    return Sbe(this.c, this.b, a);
};
_.Kc = function xge(a) {
    return Tbe(this.c, this.b, a);
};
_.fd = function yge(a, b) {
    return Zbe(this.c, this.b, a, b);
};
_.Wb = function zge(a) {
    wbe(this.c, this.b);
    Vfe(this, JD(a, 15));
};
_.gc = function Age() {
    return gce(this.c, this.b);
};
_.Nc = function Bge() {
    return hce(this.c, this.b);
};
_.Oc = function Cge(a) {
    return jce(this.c, this.b, a);
};
_.Ib = function Dge() {
    var a, b;
    b = new Hgb;
    b.a += '[';
    for(a = rbe(this.c, this.b); Wce(a);){
        Egb(b, xgb(Yce(a)));
        Wce(a) && (b.a += Lqe, b);
    }
    b.a += ']';
    return b.a;
};
_.Dk = function Ege() {
    wbe(this.c, this.b);
};
var Gab = jeb(_Ee, 'FeatureMapUtil/FeatureEList', 493);
Ycb(629, 38, HEe, Gge);
_.ej = function Hge(a) {
    return Fge(this, a);
};
_.jj = function Ige(a) {
    var b, c, d, e, f, g, h;
    switch(this.d){
        case 1:
        case 2:
            f = a.gj();
            if (XD(f) === XD(this.c) && Fge(this, null) == a.ej(null)) {
                this.g = a.fj();
                a.dj() == 1 && (this.d = 1);
                return true;
            }
            break;
        case 3:
            e = a.dj();
            switch(e){
                case 3:
                    f = a.gj();
                    if (XD(f) === XD(this.c) && Fge(this, null) == a.ej(null)) {
                        this.d = 5;
                        b = new wDd(2);
                        tCd(b, this.g);
                        tCd(b, a.fj());
                        this.g = b;
                        return true;
                    }
                    break;
            }
            break;
        case 5:
            e = a.dj();
            switch(e){
                case 3:
                    f = a.gj();
                    if (XD(f) === XD(this.c) && Fge(this, null) == a.ej(null)) {
                        c = JD(this.g, 16);
                        c.Ec(a.fj());
                        return true;
                    }
                    break;
            }
            break;
        case 4:
            e = a.dj();
            switch(e){
                case 3:
                    f = a.gj();
                    if (XD(f) === XD(this.c) && Fge(this, null) == a.ej(null)) {
                        this.d = 1;
                        this.g = a.fj();
                        return true;
                    }
                    break;
                case 4:
                    f = a.gj();
                    if (XD(f) === XD(this.c) && Fge(this, null) == a.ej(null)) {
                        this.d = 6;
                        h = new wDd(2);
                        tCd(h, this.n);
                        tCd(h, a.hj());
                        this.n = h;
                        g = WC(OC(cE, 1), ise, 30, 15, [
                            this.o,
                            a.ij()
                        ]);
                        this.g = g;
                        return true;
                    }
                    break;
            }
            break;
        case 6:
            e = a.dj();
            switch(e){
                case 4:
                    f = a.gj();
                    if (XD(f) === XD(this.c) && Fge(this, null) == a.ej(null)) {
                        c = JD(this.n, 16);
                        c.Ec(a.hj());
                        g = JD(this.g, 54);
                        d = SC(cE, ise, 30, g.length + 1, 15, 1);
                        $gb(g, 0, d, 0, g.length);
                        d[g.length] = a.ij();
                        this.g = d;
                        return true;
                    }
                    break;
            }
            break;
    }
    return false;
};
var Hab = jeb(_Ee, 'FeatureMapUtil/FeatureENotificationImpl', 629);
Ycb(549, 493, {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    61: 1,
    76: 1,
    159: 1,
    218: 1,
    1982: 1,
    71: 1,
    96: 1
}, Jge);
_.Ll = function Kge(a, b) {
    return jbe(this.c, a, b);
};
_.Ml = function Lge(a, b, c) {
    return qbe(this.c, a, b, c);
};
_.Nl = function Mge(a, b, c) {
    return vbe(this.c, a, b, c);
};
_.Ol = function Nge() {
    return this;
};
_.Pl = function Oge(a, b) {
    return Dbe(this.c, a, b);
};
_.Ql = function Pge(a) {
    return JD(Cbe(this.c, this.b, a, false), 74).Ik();
};
_.Rl = function Qge(a) {
    return JD(Cbe(this.c, this.b, a, false), 74).kd();
};
_.Sl = function Rge() {
    return this.a;
};
_.Tl = function Sge(a) {
    return !Kbe(this.c, a);
};
_.Ul = function Tge(a, b) {
    $be(this.c, a, b);
};
_.Vl = function Uge(a) {
    return _be(this.c, a);
};
_.Wl = function Vge(a) {
    lce(this.c, a);
};
var Iab = jeb(_Ee, 'FeatureMapUtil/FeatureFeatureMap', 549);
Ycb(1247, 1, aFe, Wge);
_.Ck = function Xge(a) {
    return Cbe(this.b, this.a, -1, a);
};
_.Nj = function Yge() {
    return !Kbe(this.b, this.a);
};
_.Wb = function Zge(a) {
    $be(this.b, this.a, a);
};
_.Dk = function $ge() {
    wbe(this.b, this.a);
};
var Jab = jeb(_Ee, 'FeatureMapUtil/FeatureValue', 1247);
var _ge, ahe, bhe, che, dhe;
var Nab = leb(iGe, 'AnyType');
Ycb(665, 63, Nre, fhe);
var Oab = jeb(iGe, 'InvalidDatatypeValueException', 665);
var Pab = leb(iGe, jGe);
var Qab = leb(iGe, kGe);
var Rab = leb(iGe, lGe);
var ghe;
var ihe;
var khe, lhe, mhe, nhe, ohe, phe, qhe, rhe, she, the, uhe, vhe, whe, xhe, yhe, zhe, Ahe, Bhe, Che, Dhe, Ehe, Fhe, Ghe, Hhe;
Ycb(823, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    836: 1
}, Jhe);
_.Hh = function Khe(a, b, c) {
    switch(a){
        case 0:
            if (c) return !this.c && (this.c = new nce(this, 0)), this.c;
            return !this.c && (this.c = new nce(this, 0)), this.c.b;
        case 1:
            if (c) return !this.c && (this.c = new nce(this, 0)), JD(Mbe(this.c, (Ihe(), lhe)), 159);
            return (!this.c && (this.c = new nce(this, 0)), JD(JD(Mbe(this.c, (Ihe(), lhe)), 159), 218)).Sl();
        case 2:
            if (c) return !this.b && (this.b = new nce(this, 2)), this.b;
            return !this.b && (this.b = new nce(this, 2)), this.b.b;
    }
    return dqd(this, a - VTd(this.ei()), QTd((this.j & 2) == 0 ? this.ei() : (!this.k && (this.k = new APd), this.k).Kk(), a), b, c);
};
_.Qh = function Lhe(a, b, c) {
    var d;
    switch(b){
        case 0:
            return !this.c && (this.c = new nce(this, 0)), ube(this.c, a, c);
        case 1:
            return (!this.c && (this.c = new nce(this, 0)), JD(JD(Mbe(this.c, (Ihe(), lhe)), 159), 71)).Uk(a, c);
        case 2:
            return !this.b && (this.b = new nce(this, 2)), ube(this.b, a, c);
    }
    return d = JD(QTd((this.j & 2) == 0 ? this.ei() : (!this.k && (this.k = new APd), this.k).Kk(), b), 69), d.tk().xk(this, Cqd(this), b - VTd(this.ei()), a, c);
};
_.Sh = function Mhe(a) {
    switch(a){
        case 0:
            return !!this.c && this.c.i != 0;
        case 1:
            return !(!this.c && (this.c = new nce(this, 0)), JD(Mbe(this.c, (Ihe(), lhe)), 159)).dc();
        case 2:
            return !!this.b && this.b.i != 0;
    }
    return eqd(this, a - VTd(this.ei()), QTd((this.j & 2) == 0 ? this.ei() : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Zh = function Nhe(a, b) {
    switch(a){
        case 0:
            !this.c && (this.c = new nce(this, 0));
            Ybe(this.c, b);
            return;
        case 1:
            (!this.c && (this.c = new nce(this, 0)), JD(JD(Mbe(this.c, (Ihe(), lhe)), 159), 218)).Wb(b);
            return;
        case 2:
            !this.b && (this.b = new nce(this, 2));
            Ybe(this.b, b);
            return;
    }
    fqd(this, a - VTd(this.ei()), QTd((this.j & 2) == 0 ? this.ei() : (!this.k && (this.k = new APd), this.k).Kk(), a), b);
};
_.ei = function Ohe() {
    return Ihe(), khe;
};
_.gi = function Phe(a) {
    switch(a){
        case 0:
            !this.c && (this.c = new nce(this, 0));
            RGd(this.c);
            return;
        case 1:
            (!this.c && (this.c = new nce(this, 0)), JD(Mbe(this.c, (Ihe(), lhe)), 159)).$b();
            return;
        case 2:
            !this.b && (this.b = new nce(this, 2));
            RGd(this.b);
            return;
    }
    gqd(this, a - VTd(this.ei()), QTd((this.j & 2) == 0 ? this.ei() : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Ib = function Qhe() {
    var a;
    if ((this.j & 4) != 0) return Gqd(this);
    a = new Jgb(Gqd(this));
    a.a += ' (mixed: ';
    Dgb(a, this.c);
    a.a += ', anyAttribute: ';
    Dgb(a, this.b);
    a.a += ')';
    return a.a;
};
var Sab = jeb(mGe, 'AnyTypeImpl', 823);
Ycb(666, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    2065: 1,
    666: 1
}, The);
_.Hh = function Uhe(a, b, c) {
    switch(a){
        case 0:
            return this.a;
        case 1:
            return this.b;
    }
    return dqd(this, a - VTd((Ihe(), xhe)), QTd((this.j & 2) == 0 ? xhe : (!this.k && (this.k = new APd), this.k).Kk(), a), b, c);
};
_.Sh = function Vhe(a) {
    switch(a){
        case 0:
            return this.a != null;
        case 1:
            return this.b != null;
    }
    return eqd(this, a - VTd((Ihe(), xhe)), QTd((this.j & 2) == 0 ? xhe : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Zh = function Whe(a, b) {
    switch(a){
        case 0:
            Rhe(this, OD(b));
            return;
        case 1:
            She(this, OD(b));
            return;
    }
    fqd(this, a - VTd((Ihe(), xhe)), QTd((this.j & 2) == 0 ? xhe : (!this.k && (this.k = new APd), this.k).Kk(), a), b);
};
_.ei = function Xhe() {
    return Ihe(), xhe;
};
_.gi = function Yhe(a) {
    switch(a){
        case 0:
            this.a = null;
            return;
        case 1:
            this.b = null;
            return;
    }
    gqd(this, a - VTd((Ihe(), xhe)), QTd((this.j & 2) == 0 ? xhe : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Ib = function Zhe() {
    var a;
    if ((this.j & 4) != 0) return Gqd(this);
    a = new Jgb(Gqd(this));
    a.a += ' (data: ';
    Egb(a, this.a);
    a.a += ', target: ';
    Egb(a, this.b);
    a.a += ')';
    return a.a;
};
_.a = null;
_.b = null;
var Tab = jeb(mGe, 'ProcessingInstructionImpl', 666);
Ycb(667, 823, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    836: 1,
    2066: 1,
    667: 1
}, aie);
_.Hh = function bie(a, b, c) {
    switch(a){
        case 0:
            if (c) return !this.c && (this.c = new nce(this, 0)), this.c;
            return !this.c && (this.c = new nce(this, 0)), this.c.b;
        case 1:
            if (c) return !this.c && (this.c = new nce(this, 0)), JD(Mbe(this.c, (Ihe(), lhe)), 159);
            return (!this.c && (this.c = new nce(this, 0)), JD(JD(Mbe(this.c, (Ihe(), lhe)), 159), 218)).Sl();
        case 2:
            if (c) return !this.b && (this.b = new nce(this, 2)), this.b;
            return !this.b && (this.b = new nce(this, 2)), this.b.b;
        case 3:
            return !this.c && (this.c = new nce(this, 0)), OD(Dbe(this.c, (Ihe(), Ahe), true));
        case 4:
            return bfe(this.a, (!this.c && (this.c = new nce(this, 0)), OD(Dbe(this.c, (Ihe(), Ahe), true))));
        case 5:
            return this.a;
    }
    return dqd(this, a - VTd((Ihe(), zhe)), QTd((this.j & 2) == 0 ? zhe : (!this.k && (this.k = new APd), this.k).Kk(), a), b, c);
};
_.Sh = function cie(a) {
    switch(a){
        case 0:
            return !!this.c && this.c.i != 0;
        case 1:
            return !(!this.c && (this.c = new nce(this, 0)), JD(Mbe(this.c, (Ihe(), lhe)), 159)).dc();
        case 2:
            return !!this.b && this.b.i != 0;
        case 3:
            return !this.c && (this.c = new nce(this, 0)), OD(Dbe(this.c, (Ihe(), Ahe), true)) != null;
        case 4:
            return bfe(this.a, (!this.c && (this.c = new nce(this, 0)), OD(Dbe(this.c, (Ihe(), Ahe), true)))) != null;
        case 5:
            return !!this.a;
    }
    return eqd(this, a - VTd((Ihe(), zhe)), QTd((this.j & 2) == 0 ? zhe : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Zh = function die(a, b) {
    switch(a){
        case 0:
            !this.c && (this.c = new nce(this, 0));
            Ybe(this.c, b);
            return;
        case 1:
            (!this.c && (this.c = new nce(this, 0)), JD(JD(Mbe(this.c, (Ihe(), lhe)), 159), 218)).Wb(b);
            return;
        case 2:
            !this.b && (this.b = new nce(this, 2));
            Ybe(this.b, b);
            return;
        case 3:
            _he(this, OD(b));
            return;
        case 4:
            _he(this, afe(this.a, b));
            return;
        case 5:
            $he(this, JD(b, 155));
            return;
    }
    fqd(this, a - VTd((Ihe(), zhe)), QTd((this.j & 2) == 0 ? zhe : (!this.k && (this.k = new APd), this.k).Kk(), a), b);
};
_.ei = function eie() {
    return Ihe(), zhe;
};
_.gi = function fie(a) {
    switch(a){
        case 0:
            !this.c && (this.c = new nce(this, 0));
            RGd(this.c);
            return;
        case 1:
            (!this.c && (this.c = new nce(this, 0)), JD(Mbe(this.c, (Ihe(), lhe)), 159)).$b();
            return;
        case 2:
            !this.b && (this.b = new nce(this, 2));
            RGd(this.b);
            return;
        case 3:
            !this.c && (this.c = new nce(this, 0));
            $be(this.c, (Ihe(), Ahe), null);
            return;
        case 4:
            _he(this, afe(this.a, null));
            return;
        case 5:
            this.a = null;
            return;
    }
    gqd(this, a - VTd((Ihe(), zhe)), QTd((this.j & 2) == 0 ? zhe : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
var Uab = jeb(mGe, 'SimpleAnyTypeImpl', 667);
Ycb(668, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    2067: 1,
    668: 1
}, gie);
_.Hh = function hie(a, b, c) {
    switch(a){
        case 0:
            if (c) return !this.a && (this.a = new nce(this, 0)), this.a;
            return !this.a && (this.a = new nce(this, 0)), this.a.b;
        case 1:
            return c ? (!this.b && (this.b = new YQd((cPd(), $Od), u7, this, 1)), this.b) : (!this.b && (this.b = new YQd((cPd(), $Od), u7, this, 1)), CJd(this.b));
        case 2:
            return c ? (!this.c && (this.c = new YQd((cPd(), $Od), u7, this, 2)), this.c) : (!this.c && (this.c = new YQd((cPd(), $Od), u7, this, 2)), CJd(this.c));
        case 3:
            return !this.a && (this.a = new nce(this, 0)), Mbe(this.a, (Ihe(), Dhe));
        case 4:
            return !this.a && (this.a = new nce(this, 0)), Mbe(this.a, (Ihe(), Ehe));
        case 5:
            return !this.a && (this.a = new nce(this, 0)), Mbe(this.a, (Ihe(), Ghe));
        case 6:
            return !this.a && (this.a = new nce(this, 0)), Mbe(this.a, (Ihe(), Hhe));
    }
    return dqd(this, a - VTd((Ihe(), Che)), QTd((this.j & 2) == 0 ? Che : (!this.k && (this.k = new APd), this.k).Kk(), a), b, c);
};
_.Qh = function iie(a, b, c) {
    var d;
    switch(b){
        case 0:
            return !this.a && (this.a = new nce(this, 0)), ube(this.a, a, c);
        case 1:
            return !this.b && (this.b = new YQd((cPd(), $Od), u7, this, 1)), WQd(this.b, a, c);
        case 2:
            return !this.c && (this.c = new YQd((cPd(), $Od), u7, this, 2)), WQd(this.c, a, c);
        case 5:
            return !this.a && (this.a = new nce(this, 0)), Wfe(Mbe(this.a, (Ihe(), Ghe)), a, c);
    }
    return d = JD(QTd((this.j & 2) == 0 ? (Ihe(), Che) : (!this.k && (this.k = new APd), this.k).Kk(), b), 69), d.tk().xk(this, Cqd(this), b - VTd((Ihe(), Che)), a, c);
};
_.Sh = function jie(a) {
    switch(a){
        case 0:
            return !!this.a && this.a.i != 0;
        case 1:
            return !!this.b && this.b.f != 0;
        case 2:
            return !!this.c && this.c.f != 0;
        case 3:
            return !this.a && (this.a = new nce(this, 0)), !Yfe(Mbe(this.a, (Ihe(), Dhe)));
        case 4:
            return !this.a && (this.a = new nce(this, 0)), !Yfe(Mbe(this.a, (Ihe(), Ehe)));
        case 5:
            return !this.a && (this.a = new nce(this, 0)), !Yfe(Mbe(this.a, (Ihe(), Ghe)));
        case 6:
            return !this.a && (this.a = new nce(this, 0)), !Yfe(Mbe(this.a, (Ihe(), Hhe)));
    }
    return eqd(this, a - VTd((Ihe(), Che)), QTd((this.j & 2) == 0 ? Che : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Zh = function kie(a, b) {
    switch(a){
        case 0:
            !this.a && (this.a = new nce(this, 0));
            Ybe(this.a, b);
            return;
        case 1:
            !this.b && (this.b = new YQd((cPd(), $Od), u7, this, 1));
            XQd(this.b, b);
            return;
        case 2:
            !this.c && (this.c = new YQd((cPd(), $Od), u7, this, 2));
            XQd(this.c, b);
            return;
        case 3:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Dhe)));
            !this.a && (this.a = new nce(this, 0));
            Vfe(Mbe(this.a, Dhe), JD(b, 16));
            return;
        case 4:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Ehe)));
            !this.a && (this.a = new nce(this, 0));
            Vfe(Mbe(this.a, Ehe), JD(b, 16));
            return;
        case 5:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Ghe)));
            !this.a && (this.a = new nce(this, 0));
            Vfe(Mbe(this.a, Ghe), JD(b, 16));
            return;
        case 6:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Hhe)));
            !this.a && (this.a = new nce(this, 0));
            Vfe(Mbe(this.a, Hhe), JD(b, 16));
            return;
    }
    fqd(this, a - VTd((Ihe(), Che)), QTd((this.j & 2) == 0 ? Che : (!this.k && (this.k = new APd), this.k).Kk(), a), b);
};
_.ei = function lie() {
    return Ihe(), Che;
};
_.gi = function mie(a) {
    switch(a){
        case 0:
            !this.a && (this.a = new nce(this, 0));
            RGd(this.a);
            return;
        case 1:
            !this.b && (this.b = new YQd((cPd(), $Od), u7, this, 1));
            this.b.c.$b();
            return;
        case 2:
            !this.c && (this.c = new YQd((cPd(), $Od), u7, this, 2));
            this.c.c.$b();
            return;
        case 3:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Dhe)));
            return;
        case 4:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Ehe)));
            return;
        case 5:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Ghe)));
            return;
        case 6:
            !this.a && (this.a = new nce(this, 0));
            Xfe(Mbe(this.a, (Ihe(), Hhe)));
            return;
    }
    gqd(this, a - VTd((Ihe(), Che)), QTd((this.j & 2) == 0 ? Che : (!this.k && (this.k = new APd), this.k).Kk(), a));
};
_.Ib = function nie() {
    var a;
    if ((this.j & 4) != 0) return Gqd(this);
    a = new Jgb(Gqd(this));
    a.a += ' (mixed: ';
    Dgb(a, this.a);
    a.a += ')';
    return a.a;
};
var Vab = jeb(mGe, 'XMLTypeDocumentRootImpl', 668);
Ycb(1974, 704, {
    109: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1,
    2068: 1
}, Mie);
_.ni = function Nie(a, b) {
    switch(a.ek()){
        case 7:
        case 8:
        case 9:
        case 10:
        case 16:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 32:
        case 33:
        case 34:
        case 36:
        case 37:
        case 44:
        case 45:
        case 50:
        case 51:
        case 53:
        case 55:
        case 56:
        case 57:
        case 58:
        case 60:
        case 61:
        case 4:
            return b == null ? null : adb(b);
        case 19:
        case 28:
        case 29:
        case 35:
        case 38:
        case 39:
        case 41:
        case 46:
        case 52:
        case 54:
        case 5:
            return OD(b);
        case 6:
            return uie(JD(b, 195));
        case 12:
        case 47:
        case 49:
        case 11:
            return Xud(this, a, b);
        case 13:
            return b == null ? null : phb(JD(b, 245));
        case 15:
        case 14:
            return b == null ? null : vie(Beb(MD(b)));
        case 17:
            return wie((Ihe(), b));
        case 18:
            return wie(b);
        case 21:
        case 20:
            return b == null ? null : xie(JD(b, 160).a);
        case 27:
            return yie(JD(b, 195));
        case 30:
            return zie((Ihe(), JD(b, 15)));
        case 31:
            return zie(JD(b, 15));
        case 40:
            return Cie((Ihe(), b));
        case 42:
            return Aie((Ihe(), b));
        case 43:
            return Aie(b);
        case 59:
        case 48:
            return Bie((Ihe(), b));
        default:
            throw scb(new Teb(WCe + a.ve() + XCe));
    }
};
_.oi = function Oie(a) {
    var b, c, d, e, f;
    switch(a.G == -1 && (a.G = (c = WSd(a), c ? AUd(c.ri(), a) : -1)), a.G){
        case 0:
            return b = new Jhe, b;
        case 1:
            return d = new The, d;
        case 2:
            return e = new aie, e;
        case 3:
            return f = new gie, f;
        default:
            throw scb(new Teb($Ce + a.zb + XCe));
    }
};
_.pi = function Pie(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    switch(a.ek()){
        case 5:
        case 52:
        case 4:
            return b;
        case 6:
            return Die(b);
        case 8:
        case 7:
            return b == null ? null : tie(b);
        case 9:
            return b == null ? null : Rdb(Fdb((d = Ipe(b, true), d.length > 0 && (ADb(0, d.length), d.charCodeAt(0) == 43) ? (ADb(1, d.length + 1), d.substr(1)) : d), -128, 127) << 24 >> 24);
        case 10:
            return b == null ? null : Rdb(Fdb((e = Ipe(b, true), e.length > 0 && (ADb(0, e.length), e.charCodeAt(0) == 43) ? (ADb(1, e.length + 1), e.substr(1)) : e), -128, 127) << 24 >> 24);
        case 11:
            return OD(Yud(this, (Ihe(), ohe), b));
        case 12:
            return OD(Yud(this, (Ihe(), phe), b));
        case 13:
            return b == null ? null : new shb(Ipe(b, true));
        case 15:
        case 14:
            return Eie(b);
        case 16:
            return OD(Yud(this, (Ihe(), qhe), b));
        case 17:
            return Fie((Ihe(), b));
        case 18:
            return Fie(b);
        case 28:
        case 29:
        case 35:
        case 38:
        case 39:
        case 41:
        case 54:
        case 19:
            return Ipe(b, true);
        case 21:
        case 20:
            return Gie(b);
        case 22:
            return OD(Yud(this, (Ihe(), rhe), b));
        case 23:
            return OD(Yud(this, (Ihe(), she), b));
        case 24:
            return OD(Yud(this, (Ihe(), the), b));
        case 25:
            return OD(Yud(this, (Ihe(), uhe), b));
        case 26:
            return OD(Yud(this, (Ihe(), vhe), b));
        case 27:
            return Hie(b);
        case 30:
            return Iie((Ihe(), b));
        case 31:
            return Iie(b);
        case 32:
            return b == null ? null : jfb(Fdb((k = Ipe(b, true), k.length > 0 && (ADb(0, k.length), k.charCodeAt(0) == 43) ? (ADb(1, k.length + 1), k.substr(1)) : k), Lre, Hqe));
        case 33:
            return b == null ? null : new Xhb((l = Ipe(b, true), l.length > 0 && (ADb(0, l.length), l.charCodeAt(0) == 43) ? (ADb(1, l.length + 1), l.substr(1)) : l));
        case 34:
            return b == null ? null : jfb(Fdb((m = Ipe(b, true), m.length > 0 && (ADb(0, m.length), m.charCodeAt(0) == 43) ? (ADb(1, m.length + 1), m.substr(1)) : m), Lre, Hqe));
        case 36:
            return b == null ? null : yfb(Gdb((n = Ipe(b, true), n.length > 0 && (ADb(0, n.length), n.charCodeAt(0) == 43) ? (ADb(1, n.length + 1), n.substr(1)) : n)));
        case 37:
            return b == null ? null : yfb(Gdb((o = Ipe(b, true), o.length > 0 && (ADb(0, o.length), o.charCodeAt(0) == 43) ? (ADb(1, o.length + 1), o.substr(1)) : o)));
        case 40:
            return Lie((Ihe(), b));
        case 42:
            return Jie((Ihe(), b));
        case 43:
            return Jie(b);
        case 44:
            return b == null ? null : new Xhb((p = Ipe(b, true), p.length > 0 && (ADb(0, p.length), p.charCodeAt(0) == 43) ? (ADb(1, p.length + 1), p.substr(1)) : p));
        case 45:
            return b == null ? null : new Xhb((q = Ipe(b, true), q.length > 0 && (ADb(0, q.length), q.charCodeAt(0) == 43) ? (ADb(1, q.length + 1), q.substr(1)) : q));
        case 46:
            return Ipe(b, false);
        case 47:
            return OD(Yud(this, (Ihe(), whe), b));
        case 59:
        case 48:
            return Kie((Ihe(), b));
        case 49:
            return OD(Yud(this, (Ihe(), yhe), b));
        case 50:
            return b == null ? null : Ufb(Fdb((r = Ipe(b, true), r.length > 0 && (ADb(0, r.length), r.charCodeAt(0) == 43) ? (ADb(1, r.length + 1), r.substr(1)) : r), CFe, 32767) << 16 >> 16);
        case 51:
            return b == null ? null : Ufb(Fdb((f = Ipe(b, true), f.length > 0 && (ADb(0, f.length), f.charCodeAt(0) == 43) ? (ADb(1, f.length + 1), f.substr(1)) : f), CFe, 32767) << 16 >> 16);
        case 53:
            return OD(Yud(this, (Ihe(), Bhe), b));
        case 55:
            return b == null ? null : Ufb(Fdb((g = Ipe(b, true), g.length > 0 && (ADb(0, g.length), g.charCodeAt(0) == 43) ? (ADb(1, g.length + 1), g.substr(1)) : g), CFe, 32767) << 16 >> 16);
        case 56:
            return b == null ? null : Ufb(Fdb((h = Ipe(b, true), h.length > 0 && (ADb(0, h.length), h.charCodeAt(0) == 43) ? (ADb(1, h.length + 1), h.substr(1)) : h), CFe, 32767) << 16 >> 16);
        case 57:
            return b == null ? null : yfb(Gdb((i = Ipe(b, true), i.length > 0 && (ADb(0, i.length), i.charCodeAt(0) == 43) ? (ADb(1, i.length + 1), i.substr(1)) : i)));
        case 58:
            return b == null ? null : yfb(Gdb((j = Ipe(b, true), j.length > 0 && (ADb(0, j.length), j.charCodeAt(0) == 43) ? (ADb(1, j.length + 1), j.substr(1)) : j)));
        case 60:
            return b == null ? null : jfb(Fdb((c = Ipe(b, true), c.length > 0 && (ADb(0, c.length), c.charCodeAt(0) == 43) ? (ADb(1, c.length + 1), c.substr(1)) : c), Lre, Hqe));
        case 61:
            return b == null ? null : jfb(Fdb(Ipe(b, true), Lre, Hqe));
        default:
            throw scb(new Teb(WCe + a.ve() + XCe));
    }
};
var oie, pie, qie, rie;
var Wab = jeb(mGe, 'XMLTypeFactoryImpl', 1974);
Ycb(577, 184, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    117: 1,
    118: 1,
    675: 1,
    1990: 1,
    577: 1
}, Wie);
_.N = false;
_.O = false;
var Rie = false;
var Vbb = jeb(mGe, 'XMLTypePackageImpl', 577);
Ycb(1907, 1, {
    830: 1
}, Zie);
_.Hk = function $ie() {
    return Mpe(), Lpe;
};
var fbb = jeb(mGe, 'XMLTypePackageImpl/1', 1907);
Ycb(1916, 1, PFe, _ie);
_.ck = function aje(a) {
    return VD(a);
};
_.dk = function bje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Xab = jeb(mGe, 'XMLTypePackageImpl/10', 1916);
Ycb(1917, 1, PFe, cje);
_.ck = function dje(a) {
    return VD(a);
};
_.dk = function eje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Yab = jeb(mGe, 'XMLTypePackageImpl/11', 1917);
Ycb(1918, 1, PFe, fje);
_.ck = function gje(a) {
    return VD(a);
};
_.dk = function hje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Zab = jeb(mGe, 'XMLTypePackageImpl/12', 1918);
Ycb(1919, 1, PFe, ije);
_.ck = function jje(a) {
    return TD(a);
};
_.dk = function kje(a) {
    return SC(LI, hre, 341, a, 7, 1);
};
var $ab = jeb(mGe, 'XMLTypePackageImpl/13', 1919);
Ycb(1920, 1, PFe, lje);
_.ck = function mje(a) {
    return VD(a);
};
_.dk = function nje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var _ab = jeb(mGe, 'XMLTypePackageImpl/14', 1920);
Ycb(1921, 1, PFe, oje);
_.ck = function pje(a) {
    return RD(a, 15);
};
_.dk = function qje(a) {
    return SC(HK, nue, 15, a, 0, 1);
};
var abb = jeb(mGe, 'XMLTypePackageImpl/15', 1921);
Ycb(1922, 1, PFe, rje);
_.ck = function sje(a) {
    return RD(a, 15);
};
_.dk = function tje(a) {
    return SC(HK, nue, 15, a, 0, 1);
};
var bbb = jeb(mGe, 'XMLTypePackageImpl/16', 1922);
Ycb(1923, 1, PFe, uje);
_.ck = function vje(a) {
    return VD(a);
};
_.dk = function wje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var cbb = jeb(mGe, 'XMLTypePackageImpl/17', 1923);
Ycb(1924, 1, PFe, xje);
_.ck = function yje(a) {
    return RD(a, 160);
};
_.dk = function zje(a) {
    return SC(QI, hre, 160, a, 0, 1);
};
var dbb = jeb(mGe, 'XMLTypePackageImpl/18', 1924);
Ycb(1925, 1, PFe, Aje);
_.ck = function Bje(a) {
    return VD(a);
};
_.dk = function Cje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var ebb = jeb(mGe, 'XMLTypePackageImpl/19', 1925);
Ycb(1908, 1, PFe, Dje);
_.ck = function Eje(a) {
    return RD(a, 836);
};
_.dk = function Fje(a) {
    return SC(Nab, Nqe, 836, a, 0, 1);
};
var qbb = jeb(mGe, 'XMLTypePackageImpl/2', 1908);
Ycb(1926, 1, PFe, Gje);
_.ck = function Hje(a) {
    return VD(a);
};
_.dk = function Ije(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var gbb = jeb(mGe, 'XMLTypePackageImpl/20', 1926);
Ycb(1927, 1, PFe, Jje);
_.ck = function Kje(a) {
    return VD(a);
};
_.dk = function Lje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var hbb = jeb(mGe, 'XMLTypePackageImpl/21', 1927);
Ycb(1928, 1, PFe, Mje);
_.ck = function Nje(a) {
    return VD(a);
};
_.dk = function Oje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var ibb = jeb(mGe, 'XMLTypePackageImpl/22', 1928);
Ycb(1929, 1, PFe, Pje);
_.ck = function Qje(a) {
    return VD(a);
};
_.dk = function Rje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var jbb = jeb(mGe, 'XMLTypePackageImpl/23', 1929);
Ycb(1930, 1, PFe, Sje);
_.ck = function Tje(a) {
    return RD(a, 195);
};
_.dk = function Uje(a) {
    return SC($D, hre, 195, a, 0, 2);
};
var kbb = jeb(mGe, 'XMLTypePackageImpl/24', 1930);
Ycb(1931, 1, PFe, Vje);
_.ck = function Wje(a) {
    return VD(a);
};
_.dk = function Xje(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var lbb = jeb(mGe, 'XMLTypePackageImpl/25', 1931);
Ycb(1932, 1, PFe, Yje);
_.ck = function Zje(a) {
    return VD(a);
};
_.dk = function $je(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var mbb = jeb(mGe, 'XMLTypePackageImpl/26', 1932);
Ycb(1933, 1, PFe, _je);
_.ck = function ake(a) {
    return RD(a, 15);
};
_.dk = function bke(a) {
    return SC(HK, nue, 15, a, 0, 1);
};
var nbb = jeb(mGe, 'XMLTypePackageImpl/27', 1933);
Ycb(1934, 1, PFe, cke);
_.ck = function dke(a) {
    return RD(a, 15);
};
_.dk = function eke(a) {
    return SC(HK, nue, 15, a, 0, 1);
};
var obb = jeb(mGe, 'XMLTypePackageImpl/28', 1934);
Ycb(1935, 1, PFe, fke);
_.ck = function gke(a) {
    return VD(a);
};
_.dk = function hke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var pbb = jeb(mGe, 'XMLTypePackageImpl/29', 1935);
Ycb(1909, 1, PFe, ike);
_.ck = function jke(a) {
    return RD(a, 666);
};
_.dk = function kke(a) {
    return SC(Pab, Nqe, 2065, a, 0, 1);
};
var Bbb = jeb(mGe, 'XMLTypePackageImpl/3', 1909);
Ycb(1936, 1, PFe, lke);
_.ck = function mke(a) {
    return RD(a, 17);
};
_.dk = function nke(a) {
    return SC(UI, hre, 17, a, 0, 1);
};
var rbb = jeb(mGe, 'XMLTypePackageImpl/30', 1936);
Ycb(1937, 1, PFe, oke);
_.ck = function pke(a) {
    return VD(a);
};
_.dk = function qke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var sbb = jeb(mGe, 'XMLTypePackageImpl/31', 1937);
Ycb(1938, 1, PFe, rke);
_.ck = function ske(a) {
    return RD(a, 190);
};
_.dk = function tke(a) {
    return SC(XI, hre, 190, a, 0, 1);
};
var tbb = jeb(mGe, 'XMLTypePackageImpl/32', 1938);
Ycb(1939, 1, PFe, uke);
_.ck = function vke(a) {
    return VD(a);
};
_.dk = function wke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var ubb = jeb(mGe, 'XMLTypePackageImpl/33', 1939);
Ycb(1940, 1, PFe, xke);
_.ck = function yke(a) {
    return VD(a);
};
_.dk = function zke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var vbb = jeb(mGe, 'XMLTypePackageImpl/34', 1940);
Ycb(1941, 1, PFe, Ake);
_.ck = function Bke(a) {
    return VD(a);
};
_.dk = function Cke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var wbb = jeb(mGe, 'XMLTypePackageImpl/35', 1941);
Ycb(1942, 1, PFe, Dke);
_.ck = function Eke(a) {
    return VD(a);
};
_.dk = function Fke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var xbb = jeb(mGe, 'XMLTypePackageImpl/36', 1942);
Ycb(1943, 1, PFe, Gke);
_.ck = function Hke(a) {
    return RD(a, 15);
};
_.dk = function Ike(a) {
    return SC(HK, nue, 15, a, 0, 1);
};
var ybb = jeb(mGe, 'XMLTypePackageImpl/37', 1943);
Ycb(1944, 1, PFe, Jke);
_.ck = function Kke(a) {
    return RD(a, 15);
};
_.dk = function Lke(a) {
    return SC(HK, nue, 15, a, 0, 1);
};
var zbb = jeb(mGe, 'XMLTypePackageImpl/38', 1944);
Ycb(1945, 1, PFe, Mke);
_.ck = function Nke(a) {
    return VD(a);
};
_.dk = function Oke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Abb = jeb(mGe, 'XMLTypePackageImpl/39', 1945);
Ycb(1910, 1, PFe, Pke);
_.ck = function Qke(a) {
    return RD(a, 667);
};
_.dk = function Rke(a) {
    return SC(Qab, Nqe, 2066, a, 0, 1);
};
var Mbb = jeb(mGe, 'XMLTypePackageImpl/4', 1910);
Ycb(1946, 1, PFe, Ske);
_.ck = function Tke(a) {
    return VD(a);
};
_.dk = function Uke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Cbb = jeb(mGe, 'XMLTypePackageImpl/40', 1946);
Ycb(1947, 1, PFe, Vke);
_.ck = function Wke(a) {
    return VD(a);
};
_.dk = function Xke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Dbb = jeb(mGe, 'XMLTypePackageImpl/41', 1947);
Ycb(1948, 1, PFe, Yke);
_.ck = function Zke(a) {
    return VD(a);
};
_.dk = function $ke(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Ebb = jeb(mGe, 'XMLTypePackageImpl/42', 1948);
Ycb(1949, 1, PFe, _ke);
_.ck = function ale(a) {
    return VD(a);
};
_.dk = function ble(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Fbb = jeb(mGe, 'XMLTypePackageImpl/43', 1949);
Ycb(1950, 1, PFe, cle);
_.ck = function dle(a) {
    return VD(a);
};
_.dk = function ele(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Gbb = jeb(mGe, 'XMLTypePackageImpl/44', 1950);
Ycb(1951, 1, PFe, fle);
_.ck = function gle(a) {
    return RD(a, 191);
};
_.dk = function hle(a) {
    return SC(cJ, hre, 191, a, 0, 1);
};
var Hbb = jeb(mGe, 'XMLTypePackageImpl/45', 1951);
Ycb(1952, 1, PFe, ile);
_.ck = function jle(a) {
    return VD(a);
};
_.dk = function kle(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Ibb = jeb(mGe, 'XMLTypePackageImpl/46', 1952);
Ycb(1953, 1, PFe, lle);
_.ck = function mle(a) {
    return VD(a);
};
_.dk = function nle(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Jbb = jeb(mGe, 'XMLTypePackageImpl/47', 1953);
Ycb(1954, 1, PFe, ole);
_.ck = function ple(a) {
    return VD(a);
};
_.dk = function qle(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Kbb = jeb(mGe, 'XMLTypePackageImpl/48', 1954);
Ycb(1955, 1, PFe, rle);
_.ck = function sle(a) {
    return RD(a, 191);
};
_.dk = function tle(a) {
    return SC(cJ, hre, 191, a, 0, 1);
};
var Lbb = jeb(mGe, 'XMLTypePackageImpl/49', 1955);
Ycb(1911, 1, PFe, ule);
_.ck = function vle(a) {
    return RD(a, 668);
};
_.dk = function wle(a) {
    return SC(Rab, Nqe, 2067, a, 0, 1);
};
var Qbb = jeb(mGe, 'XMLTypePackageImpl/5', 1911);
Ycb(1956, 1, PFe, xle);
_.ck = function yle(a) {
    return RD(a, 190);
};
_.dk = function zle(a) {
    return SC(XI, hre, 190, a, 0, 1);
};
var Nbb = jeb(mGe, 'XMLTypePackageImpl/50', 1956);
Ycb(1957, 1, PFe, Ale);
_.ck = function Ble(a) {
    return VD(a);
};
_.dk = function Cle(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Obb = jeb(mGe, 'XMLTypePackageImpl/51', 1957);
Ycb(1958, 1, PFe, Dle);
_.ck = function Ele(a) {
    return RD(a, 17);
};
_.dk = function Fle(a) {
    return SC(UI, hre, 17, a, 0, 1);
};
var Pbb = jeb(mGe, 'XMLTypePackageImpl/52', 1958);
Ycb(1912, 1, PFe, Gle);
_.ck = function Hle(a) {
    return VD(a);
};
_.dk = function Ile(a) {
    return SC(hJ, hre, 2, a, 6, 1);
};
var Rbb = jeb(mGe, 'XMLTypePackageImpl/6', 1912);
Ycb(1913, 1, PFe, Jle);
_.ck = function Kle(a) {
    return RD(a, 195);
};
_.dk = function Lle(a) {
    return SC($D, hre, 195, a, 0, 2);
};
var Sbb = jeb(mGe, 'XMLTypePackageImpl/7', 1913);
Ycb(1914, 1, PFe, Mle);
_.ck = function Nle(a) {
    return SD(a);
};
_.dk = function Ole(a) {
    return SC(GI, hre, 471, a, 8, 1);
};
var Tbb = jeb(mGe, 'XMLTypePackageImpl/8', 1914);
Ycb(1915, 1, PFe, Ple);
_.ck = function Qle(a) {
    return RD(a, 219);
};
_.dk = function Rle(a) {
    return SC(HI, hre, 219, a, 0, 1);
};
var Ubb = jeb(mGe, 'XMLTypePackageImpl/9', 1915);
var Sle, Tle;
var Zle, $le;
var cme;
Ycb(53, 63, Nre, eme);
var Wbb = jeb(MGe, 'RegEx/ParseException', 53);
Ycb(815, 1, {}, mme);
_.$l = function nme(a) {
    return a < this.j && _fb(this.i, a) == 63;
};
_._l = function ome() {
    var a, b, c, d, e;
    if (this.c != 10) throw scb(new eme(qEd((a9d(), WDe))));
    a = this.a;
    switch(a){
        case 101:
            a = 27;
            break;
        case 102:
            a = 12;
            break;
        case 110:
            a = 10;
            break;
        case 114:
            a = 13;
            break;
        case 116:
            a = 9;
            break;
        case 120:
            fme(this);
            if (this.c != 0) throw scb(new eme(qEd((a9d(), tEe))));
            if (this.a == 123) {
                e = 0;
                c = 0;
                do {
                    fme(this);
                    if (this.c != 0) throw scb(new eme(qEd((a9d(), tEe))));
                    if ((e = qme(this.a)) < 0) break;
                    if (c > c * 16) throw scb(new eme(qEd((a9d(), uEe))));
                    c = c * 16 + e;
                }while (true);
                if (this.a != 125) throw scb(new eme(qEd((a9d(), vEe))));
                if (c > NGe) throw scb(new eme(qEd((a9d(), wEe))));
                a = c;
            } else {
                e = 0;
                if (this.c != 0 || (e = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
                c = e;
                fme(this);
                if (this.c != 0 || (e = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
                c = c * 16 + e;
                a = c;
            }
            break;
        case 117:
            d = 0;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            a = b;
            break;
        case 118:
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            fme(this);
            if (this.c != 0 || (d = qme(this.a)) < 0) throw scb(new eme(qEd((a9d(), tEe))));
            b = b * 16 + d;
            if (b > NGe) throw scb(new eme(qEd((a9d(), 'parser.descappe.4'))));
            a = b;
            break;
        case 65:
        case 90:
        case 122:
            throw scb(new eme(qEd((a9d(), xEe))));
    }
    return a;
};
_.am = function pme(a) {
    var b, c;
    switch(a){
        case 100:
            c = (this.e & 32) == 32 ? Coe('Nd', true) : (ooe(), Wne);
            break;
        case 68:
            c = (this.e & 32) == 32 ? Coe('Nd', false) : (ooe(), boe);
            break;
        case 119:
            c = (this.e & 32) == 32 ? Coe('IsWord', true) : (ooe(), koe);
            break;
        case 87:
            c = (this.e & 32) == 32 ? Coe('IsWord', false) : (ooe(), doe);
            break;
        case 115:
            c = (this.e & 32) == 32 ? Coe('IsSpace', true) : (ooe(), foe);
            break;
        case 83:
            c = (this.e & 32) == 32 ? Coe('IsSpace', false) : (ooe(), coe);
            break;
        default:
            throw scb(new qz((b = a, OGe + b.toString(16))));
    }
    return c;
};
_.bm = function rme(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    this.b = 1;
    fme(this);
    b = null;
    if (this.c == 0 && this.a == 94) {
        fme(this);
        if (a) k = (ooe(), ooe(), ++noe, new Soe(5));
        else {
            b = (ooe(), ooe(), ++noe, new Soe(4));
            Moe(b, 0, NGe);
            k = (++noe, new Soe(4));
        }
    } else k = (ooe(), ooe(), ++noe, new Soe(4));
    e = true;
    while((m = this.c) != 1){
        if (m == 0 && this.a == 93 && !e) break;
        e = false;
        c = this.a;
        d = false;
        if (m == 10) switch(c){
            case 100:
            case 68:
            case 119:
            case 87:
            case 115:
            case 83:
                Poe(k, this.am(c));
                d = true;
                break;
            case 105:
            case 73:
            case 99:
            case 67:
                c = this.rm(k, c);
                c < 0 && (d = true);
                break;
            case 112:
            case 80:
                l = lme(this, c);
                if (!l) throw scb(new eme(qEd((a9d(), iEe))));
                Poe(k, l);
                d = true;
                break;
            default:
                c = this._l();
        }
        else if (m == 20) {
            g = ggb(this.i, 58, this.d);
            if (g < 0) throw scb(new eme(qEd((a9d(), jEe))));
            h = true;
            if (_fb(this.i, this.d) == 94) {
                ++this.d;
                h = false;
            }
            f = qgb(this.i, this.d, g);
            i = Doe(f, h, (this.e & 512) == 512);
            if (!i) throw scb(new eme(qEd((a9d(), lEe))));
            Poe(k, i);
            d = true;
            if (g + 1 >= this.j || _fb(this.i, g + 1) != 93) throw scb(new eme(qEd((a9d(), jEe))));
            this.d = g + 2;
        }
        fme(this);
        if (!d) {
            if (this.c != 0 || this.a != 45) Moe(k, c, c);
            else {
                fme(this);
                if ((m = this.c) == 1) throw scb(new eme(qEd((a9d(), kEe))));
                if (m == 0 && this.a == 93) {
                    Moe(k, c, c);
                    Moe(k, 45, 45);
                } else {
                    j = this.a;
                    m == 10 && (j = this._l());
                    fme(this);
                    Moe(k, c, j);
                }
            }
        }
        (this.e & NEe) == NEe && this.c == 0 && this.a == 44 && fme(this);
    }
    if (this.c == 1) throw scb(new eme(qEd((a9d(), kEe))));
    if (b) {
        Roe(b, k);
        k = b;
    }
    Qoe(k);
    Noe(k);
    this.b = 0;
    fme(this);
    return k;
};
_.cm = function sme() {
    var a, b, c, d;
    c = this.bm(false);
    while((d = this.c) != 7){
        a = this.a;
        if (d == 0 && (a == 45 || a == 38) || d == 4) {
            fme(this);
            if (this.c != 9) throw scb(new eme(qEd((a9d(), qEe))));
            b = this.bm(false);
            if (d == 4) Poe(c, b);
            else if (a == 45) Roe(c, b);
            else if (a == 38) Ooe(c, b);
            else throw scb(new qz('ASSERT'));
        } else throw scb(new eme(qEd((a9d(), rEe))));
    }
    fme(this);
    return c;
};
_.dm = function tme() {
    var a, b;
    a = this.a - 48;
    b = (ooe(), ooe(), ++noe, new zpe(12, null, a));
    !this.g && (this.g = new Wwb);
    Twb(this.g, new Woe(a));
    fme(this);
    return b;
};
_.em = function ume() {
    fme(this);
    return ooe(), goe;
};
_.fm = function vme() {
    fme(this);
    return ooe(), eoe;
};
_.gm = function wme() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.hm = function xme() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.im = function yme() {
    fme(this);
    return Aoe();
};
_.jm = function zme() {
    fme(this);
    return ooe(), ioe;
};
_.km = function Ame() {
    fme(this);
    return ooe(), loe;
};
_.lm = function Bme() {
    var a;
    if (this.d >= this.j || ((a = _fb(this.i, this.d++)) & 65504) != 64) throw scb(new eme(qEd((a9d(), eEe))));
    fme(this);
    return ooe(), ooe(), ++noe, new ape(0, a - 64);
};
_.mm = function Cme() {
    fme(this);
    return Boe();
};
_.nm = function Dme() {
    fme(this);
    return ooe(), moe;
};
_.om = function Eme() {
    var a;
    a = (ooe(), ooe(), ++noe, new ape(0, 105));
    fme(this);
    return a;
};
_.pm = function Fme() {
    fme(this);
    return ooe(), joe;
};
_.qm = function Gme() {
    fme(this);
    return ooe(), hoe;
};
_.rm = function Hme(a, b) {
    return this._l();
};
_.sm = function Ime() {
    fme(this);
    return ooe(), _ne;
};
_.tm = function Jme() {
    var a, b, c, d, e;
    if (this.d + 1 >= this.j) throw scb(new eme(qEd((a9d(), bEe))));
    d = -1;
    b = null;
    a = _fb(this.i, this.d);
    if (49 <= a && a <= 57) {
        d = a - 48;
        !this.g && (this.g = new Wwb);
        Twb(this.g, new Woe(d));
        ++this.d;
        if (_fb(this.i, this.d) != 41) throw scb(new eme(qEd((a9d(), $De))));
        ++this.d;
    } else {
        a == 63 && --this.d;
        fme(this);
        b = ime(this);
        switch(b.e){
            case 20:
            case 21:
            case 22:
            case 23:
                break;
            case 8:
                if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
                break;
            default:
                throw scb(new eme(qEd((a9d(), cEe))));
        }
    }
    fme(this);
    e = jme(this);
    c = null;
    if (e.e == 2) {
        if (e.Mm() != 2) throw scb(new eme(qEd((a9d(), dEe))));
        c = e.Im(1);
        e = e.Im(0);
    }
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return ooe(), ooe(), ++noe, new npe(d, b, e, c);
};
_.um = function Kme() {
    fme(this);
    return ooe(), aoe;
};
_.vm = function Lme() {
    var a;
    fme(this);
    a = uoe(24, jme(this));
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.wm = function Mme() {
    var a;
    fme(this);
    a = uoe(20, jme(this));
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.xm = function Nme() {
    var a;
    fme(this);
    a = uoe(22, jme(this));
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.ym = function Ome() {
    var a, b, c, d, e;
    a = 0;
    c = 0;
    b = -1;
    while(this.d < this.j){
        b = _fb(this.i, this.d);
        e = Mne(b);
        if (e == 0) break;
        a |= e;
        ++this.d;
    }
    if (this.d >= this.j) throw scb(new eme(qEd((a9d(), _De))));
    if (b == 45) {
        ++this.d;
        while(this.d < this.j){
            b = _fb(this.i, this.d);
            e = Mne(b);
            if (e == 0) break;
            c |= e;
            ++this.d;
        }
        if (this.d >= this.j) throw scb(new eme(qEd((a9d(), _De))));
    }
    if (b == 58) {
        ++this.d;
        fme(this);
        d = voe(jme(this), a, c);
        if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
        fme(this);
    } else if (b == 41) {
        ++this.d;
        fme(this);
        d = voe(jme(this), a, c);
    } else throw scb(new eme(qEd((a9d(), aEe))));
    return d;
};
_.zm = function Pme() {
    var a;
    fme(this);
    a = uoe(21, jme(this));
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.Am = function Qme() {
    var a;
    fme(this);
    a = uoe(23, jme(this));
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.Bm = function Rme() {
    var a, b;
    fme(this);
    a = this.f++;
    b = woe(jme(this), a);
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return b;
};
_.Cm = function Sme() {
    var a;
    fme(this);
    a = woe(jme(this), 0);
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.Dm = function Tme(a) {
    fme(this);
    if (this.c == 5) {
        fme(this);
        return toe(a, (ooe(), ooe(), ++noe, new dpe(9, a)));
    } else return toe(a, (ooe(), ooe(), ++noe, new dpe(3, a)));
};
_.Em = function Ume(a) {
    var b;
    fme(this);
    b = (ooe(), ooe(), ++noe, new Dpe(2));
    if (this.c == 5) {
        fme(this);
        Cpe(b, Zne);
        Cpe(b, a);
    } else {
        Cpe(b, a);
        Cpe(b, Zne);
    }
    return b;
};
_.Fm = function Vme(a) {
    fme(this);
    if (this.c == 5) {
        fme(this);
        return ooe(), ooe(), ++noe, new dpe(9, a);
    } else return ooe(), ooe(), ++noe, new dpe(3, a);
};
_.a = 0;
_.b = 0;
_.c = 0;
_.d = 0;
_.e = 0;
_.f = 1;
_.g = null;
_.j = 0;
var $bb = jeb(MGe, 'RegEx/RegexParser', 815);
Ycb(1893, 815, {}, _me);
_.$l = function ane(a) {
    return false;
};
_._l = function bne() {
    return Yme(this);
};
_.am = function dne(a) {
    return Zme(a);
};
_.bm = function ene(a) {
    return $me(this);
};
_.cm = function fne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.dm = function gne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.em = function hne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.fm = function ine() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.gm = function jne() {
    fme(this);
    return Zme(67);
};
_.hm = function kne() {
    fme(this);
    return Zme(73);
};
_.im = function lne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.jm = function mne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.km = function nne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.lm = function one() {
    fme(this);
    return Zme(99);
};
_.mm = function pne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.nm = function qne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.om = function rne() {
    fme(this);
    return Zme(105);
};
_.pm = function sne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.qm = function tne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.rm = function une(a, b) {
    return Poe(a, Zme(b)), -1;
};
_.sm = function vne() {
    fme(this);
    return ooe(), ooe(), ++noe, new ape(0, 94);
};
_.tm = function wne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.um = function xne() {
    fme(this);
    return ooe(), ooe(), ++noe, new ape(0, 36);
};
_.vm = function yne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.wm = function zne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.xm = function Ane() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.ym = function Bne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.zm = function Cne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.Am = function Dne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.Bm = function Ene() {
    var a;
    fme(this);
    a = woe(jme(this), 0);
    if (this.c != 7) throw scb(new eme(qEd((a9d(), $De))));
    fme(this);
    return a;
};
_.Cm = function Fne() {
    throw scb(new eme(qEd((a9d(), yEe))));
};
_.Dm = function Gne(a) {
    fme(this);
    return toe(a, (ooe(), ooe(), ++noe, new dpe(3, a)));
};
_.Em = function Hne(a) {
    var b;
    fme(this);
    b = (ooe(), ooe(), ++noe, new Dpe(2));
    Cpe(b, a);
    Cpe(b, Zne);
    return b;
};
_.Fm = function Ine(a) {
    fme(this);
    return ooe(), ooe(), ++noe, new dpe(3, a);
};
var Wme = null, Xme = null;
var Xbb = jeb(MGe, 'RegEx/ParserForXMLSchema', 1893);
Ycb(121, 1, $Ge, poe);
_.Gm = function qoe(a) {
    throw scb(new qz('Not supported.'));
};
_.Hm = function yoe() {
    return -1;
};
_.Im = function zoe(a) {
    return null;
};
_.Jm = function Eoe() {
    return null;
};
_.Km = function Hoe(a) {};
_.Lm = function Ioe(a) {};
_.Mm = function Joe() {
    return 0;
};
_.Ib = function Koe() {
    return this.Nm(0);
};
_.Nm = function Loe(a) {
    return this.e == 11 ? '.' : '';
};
_.e = 0;
var Qne, Rne, Sne, Tne, Une, Vne = null, Wne, Xne = null, Yne, Zne, $ne = null, _ne, aoe, boe, coe, doe, eoe, foe, goe, hoe, ioe, joe, koe, loe, moe, noe = 0;
var icb = jeb(MGe, 'RegEx/Token', 121);
Ycb(136, 121, {
    3: 1,
    136: 1,
    121: 1
}, Soe);
_.Nm = function Voe(a) {
    var b, c, d;
    if (this.e == 4) {
        if (this == Yne) c = '.';
        else if (this == Wne) c = '\\d';
        else if (this == koe) c = '\\w';
        else if (this == foe) c = '\\s';
        else {
            d = new Hgb;
            d.a += '[';
            for(b = 0; b < this.b.length; b += 2){
                (a & NEe) != 0 && b > 0 && (d.a += ',', d);
                if (this.b[b] === this.b[b + 1]) Egb(d, Uoe(this.b[b]));
                else {
                    Egb(d, Uoe(this.b[b]));
                    d.a += '-';
                    Egb(d, Uoe(this.b[b + 1]));
                }
            }
            d.a += ']';
            c = d.a;
        }
    } else {
        if (this == boe) c = '\\D';
        else if (this == doe) c = '\\W';
        else if (this == coe) c = '\\S';
        else {
            d = new Hgb;
            d.a += '[^';
            for(b = 0; b < this.b.length; b += 2){
                (a & NEe) != 0 && b > 0 && (d.a += ',', d);
                if (this.b[b] === this.b[b + 1]) Egb(d, Uoe(this.b[b]));
                else {
                    Egb(d, Uoe(this.b[b]));
                    d.a += '-';
                    Egb(d, Uoe(this.b[b + 1]));
                }
            }
            d.a += ']';
            c = d.a;
        }
    }
    return c;
};
_.a = false;
_.c = false;
var Ybb = jeb(MGe, 'RegEx/RangeToken', 136);
Ycb(575, 1, {
    575: 1
}, Woe);
_.a = 0;
var Zbb = jeb(MGe, 'RegEx/RegexParser/ReferencePosition', 575);
Ycb(574, 1, {
    3: 1,
    574: 1
}, Yoe);
_.Fb = function Zoe(a) {
    var b;
    if (a == null) return false;
    if (!RD(a, 574)) return false;
    b = JD(a, 574);
    return cgb(this.b, b.b) && this.a == b.a;
};
_.Hb = function $oe() {
    return fgb(this.b + '/' + Kne(this.a));
};
_.Ib = function _oe() {
    return this.c.Nm(this.a);
};
_.a = 0;
var _bb = jeb(MGe, 'RegEx/RegularExpression', 574);
Ycb(227, 121, $Ge, ape);
_.Hm = function bpe() {
    return this.a;
};
_.Nm = function cpe(a) {
    var b, c, d;
    switch(this.e){
        case 0:
            switch(this.a){
                case 124:
                case 42:
                case 43:
                case 63:
                case 40:
                case 41:
                case 46:
                case 91:
                case 123:
                case 92:
                    d = '\\' + PD(this.a & Wre);
                    break;
                case 12:
                    d = '\\f';
                    break;
                case 10:
                    d = '\\n';
                    break;
                case 13:
                    d = '\\r';
                    break;
                case 9:
                    d = '\\t';
                    break;
                case 27:
                    d = '\\e';
                    break;
                default:
                    if (this.a >= Pse) {
                        c = (b = this.a >>> 0, '0' + b.toString(16));
                        d = '\\v' + qgb(c, c.length - 6, c.length);
                    } else d = '' + PD(this.a & Wre);
            }
            break;
        case 8:
            this == _ne || this == aoe ? d = '' + PD(this.a & Wre) : d = '\\' + PD(this.a & Wre);
            break;
        default:
            d = null;
    }
    return d;
};
_.a = 0;
var acb = jeb(MGe, 'RegEx/Token/CharToken', 227);
Ycb(319, 121, $Ge, dpe);
_.Im = function epe(a) {
    return this.a;
};
_.Km = function fpe(a) {
    this.b = a;
};
_.Lm = function gpe(a) {
    this.c = a;
};
_.Mm = function hpe() {
    return 1;
};
_.Nm = function ipe(a) {
    var b;
    if (this.e == 3) {
        if (this.c < 0 && this.b < 0) b = this.a.Nm(a) + '*';
        else if (this.c == this.b) b = this.a.Nm(a) + '{' + this.c + '}';
        else if (this.c >= 0 && this.b >= 0) b = this.a.Nm(a) + '{' + this.c + ',' + this.b + '}';
        else if (this.c >= 0 && this.b < 0) b = this.a.Nm(a) + '{' + this.c + ',}';
        else throw scb(new qz('Token#toString(): CLOSURE ' + this.c + Lqe + this.b));
    } else {
        if (this.c < 0 && this.b < 0) b = this.a.Nm(a) + '*?';
        else if (this.c == this.b) b = this.a.Nm(a) + '{' + this.c + '}?';
        else if (this.c >= 0 && this.b >= 0) b = this.a.Nm(a) + '{' + this.c + ',' + this.b + '}?';
        else if (this.c >= 0 && this.b < 0) b = this.a.Nm(a) + '{' + this.c + ',}?';
        else throw scb(new qz('Token#toString(): NONGREEDYCLOSURE ' + this.c + Lqe + this.b));
    }
    return b;
};
_.b = 0;
_.c = 0;
var bcb = jeb(MGe, 'RegEx/Token/ClosureToken', 319);
Ycb(816, 121, $Ge, jpe);
_.Im = function kpe(a) {
    return a == 0 ? this.a : this.b;
};
_.Mm = function lpe() {
    return 2;
};
_.Nm = function mpe(a) {
    var b;
    this.b.e == 3 && this.b.Im(0) == this.a ? b = this.a.Nm(a) + '+' : this.b.e == 9 && this.b.Im(0) == this.a ? b = this.a.Nm(a) + '+?' : b = this.a.Nm(a) + ('' + this.b.Nm(a));
    return b;
};
var ccb = jeb(MGe, 'RegEx/Token/ConcatToken', 816);
Ycb(1891, 121, $Ge, npe);
_.Im = function ope(a) {
    if (a == 0) return this.d;
    if (a == 1) return this.b;
    throw scb(new qz('Internal Error: ' + a));
};
_.Mm = function ppe() {
    return !this.b ? 1 : 2;
};
_.Nm = function qpe(a) {
    var b;
    this.c > 0 ? b = '(?(' + this.c + ')' : this.a.e == 8 ? b = '(?(' + this.a + ')' : b = '(?' + this.a;
    !this.b ? b += this.d + ')' : b += this.d + '|' + this.b + ')';
    return b;
};
_.c = 0;
var dcb = jeb(MGe, 'RegEx/Token/ConditionToken', 1891);
Ycb(1892, 121, $Ge, rpe);
_.Im = function spe(a) {
    return this.b;
};
_.Mm = function tpe() {
    return 1;
};
_.Nm = function upe(a) {
    return '(?' + (this.a == 0 ? '' : Kne(this.a)) + (this.c == 0 ? '' : Kne(this.c)) + ':' + this.b.Nm(a) + ')';
};
_.a = 0;
_.c = 0;
var ecb = jeb(MGe, 'RegEx/Token/ModifierToken', 1892);
Ycb(817, 121, $Ge, vpe);
_.Im = function wpe(a) {
    return this.a;
};
_.Mm = function xpe() {
    return 1;
};
_.Nm = function ype(a) {
    var b;
    b = null;
    switch(this.e){
        case 6:
            this.b == 0 ? b = '(?:' + this.a.Nm(a) + ')' : b = '(' + this.a.Nm(a) + ')';
            break;
        case 20:
            b = '(?=' + this.a.Nm(a) + ')';
            break;
        case 21:
            b = '(?!' + this.a.Nm(a) + ')';
            break;
        case 22:
            b = '(?<=' + this.a.Nm(a) + ')';
            break;
        case 23:
            b = '(?<!' + this.a.Nm(a) + ')';
            break;
        case 24:
            b = '(?>' + this.a.Nm(a) + ')';
    }
    return b;
};
_.b = 0;
var fcb = jeb(MGe, 'RegEx/Token/ParenToken', 817);
Ycb(515, 121, {
    3: 1,
    121: 1,
    515: 1
}, zpe);
_.Jm = function Ape() {
    return this.b;
};
_.Nm = function Bpe(a) {
    return this.e == 12 ? '\\' + this.a : One(this.b);
};
_.a = 0;
var gcb = jeb(MGe, 'RegEx/Token/StringToken', 515);
Ycb(463, 121, $Ge, Dpe);
_.Gm = function Epe(a) {
    Cpe(this, a);
};
_.Im = function Fpe(a) {
    return JD(Uwb(this.a, a), 121);
};
_.Mm = function Gpe() {
    return !this.a ? 0 : this.a.a.c.length;
};
_.Nm = function Hpe(a) {
    var b, c, d, e, f;
    if (this.e == 1) {
        if (this.a.a.c.length == 2) {
            b = JD(Uwb(this.a, 0), 121);
            c = JD(Uwb(this.a, 1), 121);
            c.e == 3 && c.Im(0) == b ? e = b.Nm(a) + '+' : c.e == 9 && c.Im(0) == b ? e = b.Nm(a) + '+?' : e = b.Nm(a) + ('' + c.Nm(a));
        } else {
            f = new Hgb;
            for(d = 0; d < this.a.a.c.length; d++)Egb(f, JD(Uwb(this.a, d), 121).Nm(a));
            e = f.a;
        }
        return e;
    }
    if (this.a.a.c.length == 2 && JD(Uwb(this.a, 1), 121).e == 7) e = JD(Uwb(this.a, 0), 121).Nm(a) + '?';
    else if (this.a.a.c.length == 2 && JD(Uwb(this.a, 0), 121).e == 7) e = JD(Uwb(this.a, 1), 121).Nm(a) + '??';
    else {
        f = new Hgb;
        Egb(f, JD(Uwb(this.a, 0), 121).Nm(a));
        for(d = 1; d < this.a.a.c.length; d++){
            f.a += '|';
            Egb(f, JD(Uwb(this.a, d), 121).Nm(a));
        }
        e = f.a;
    }
    return e;
};
var hcb = jeb(MGe, 'RegEx/Token/UnionToken', 463);
Ycb(512, 1, {
    584: 1
}, Jpe);
_.Ib = function Kpe() {
    return this.a.b;
};
var jcb = jeb(_Ge, 'XMLTypeUtil/PatternMatcherImpl', 512);
Ycb(1649, 1467, {}, Npe);
var Lpe;
var kcb = jeb(_Ge, 'XMLTypeValidator', 1649);
Ycb(267, 1, pre, Rpe);
_.Ic = function Spe(a) {
    ofb(this, a);
};
_.Jc = function Tpe() {
    return (this.b - this.a) * this.c < 0 ? Ppe : new lqe(this);
};
_.a = 0;
_.b = 0;
_.c = 0;
var Ppe;
var ncb = jeb(bHe, 'ExclusiveRange', 267);
Ycb(1049, 1, dre, Ype);
_.Rb = function Zpe(a) {
    JD(a, 17);
    Upe();
};
_.Nb = function $pe(a) {
    Osb(this, a);
};
_.Pb = function bqe() {
    return Vpe();
};
_.Ub = function dqe() {
    return Wpe();
};
_.Wb = function gqe(a) {
    JD(a, 17);
    Xpe();
};
_.Ob = function _pe() {
    return false;
};
_.Sb = function aqe() {
    return false;
};
_.Tb = function cqe() {
    return -1;
};
_.Vb = function eqe() {
    return -1;
};
_.Qb = function fqe() {
    throw scb(new bhb(eHe));
};
var lcb = jeb(bHe, 'ExclusiveRange/1', 1049);
Ycb(258, 1, dre, lqe);
_.Rb = function mqe(a) {
    JD(a, 17);
    hqe();
};
_.Nb = function nqe(a) {
    Osb(this, a);
};
_.Pb = function qqe() {
    return iqe(this);
};
_.Ub = function sqe() {
    return jqe(this);
};
_.Wb = function vqe(a) {
    JD(a, 17);
    kqe();
};
_.Ob = function oqe() {
    return this.c.c < 0 ? this.a >= this.c.b : this.a <= this.c.b;
};
_.Sb = function pqe() {
    return this.b > 0;
};
_.Tb = function rqe() {
    return this.b;
};
_.Vb = function tqe() {
    return this.b - 1;
};
_.Qb = function uqe() {
    throw scb(new bhb(eHe));
};
_.a = 0;
_.b = 0;
var mcb = jeb(bHe, 'ExclusiveRange/RangeIterator', 258);
var _D = meb(fFe, 'C');
var cE = meb(iFe, 'I');
var pcb = meb(Dqe, 'Z');
var dE = meb(jFe, 'J');
var $D = meb(eFe, 'B');
var aE = meb(gFe, 'D');
var bE = meb(hFe, 'F');
var ocb = meb(kFe, 'S');
var Y1 = leb('org.eclipse.elk.core.labels', 'ILabelManager');
var L5 = leb(tDe, 'DiagnosticChain');
var r9 = leb(RFe, 'ResourceSet');
var S5 = jeb(tDe, 'InvocationTargetException', null);
var Bqe = (Iz(), Lz);
var gwtOnLoad = gwtOnLoad = Vcb;
Tcb(cdb);
Wcb('permProps', [
    [
        [
            'locale',
            'default'
        ],
        [
            fHe,
            'gecko1_8'
        ]
    ],
    [
        [
            'locale',
            'default'
        ],
        [
            fHe,
            'safari'
        ]
    ]
]);
// --------------    RUN GWT INITIALIZATION CODE    -------------- 
gwtOnLoad(null, 'elk', null);

},{}],"cg1kA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAppSelector", ()=>useAppSelector);
var _reactRedux = require("react-redux");
const useAppSelector = (0, _reactRedux.useSelector);

},{"react-redux":"dwYd3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6MHvA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ELKToPositions", ()=>ELKToPositions);
function ELKToPositions(node) {
    const result = {};
    traverseELKNodes(node, (id, position, size)=>{
        result[id] = {
            x: position.x + size.width / 2,
            y: position.y + size.height / 2
        };
    });
    return result;
}
/**
 * Traverses all nodes, besides the root, and calls the callback with its absolute position, size, and ID.
 */ function traverseELKNodes(rootNode, callback) {
    const toProcess = (rootNode?.children || []).map((n)=>[
            n,
            {
                x: 0,
                y: 0
            }
        ]);
    while(toProcess.length){
        const [node, origin] = toProcess.pop();
        const position = {
            x: node.x + origin.x,
            y: node.y + origin.y
        };
        callback(node.id, position, {
            width: node.width,
            height: node.height
        });
        node.children.forEach((n)=>toProcess.push([
                n,
                position
            ]));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Klpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toELKGraph", ()=>toELKGraph);
// We do our own layouts with ELK instead of using the cytoscape ELK plugin, so we can cache the layouts more easily
// https://github.com/cytoscape/cytoscape.js-elk/blob/master/src/layout.js
const LAYOUT_OPTIONS = {
    algorithm: 'layered',
    'org.eclipse.elk.direction': 'RIGHT',
    // Disabled because ends up with unaligned layers
    // Make layouts more compact
    // 'org.eclipse.elk.layered.compaction.postCompaction.strategy': 'EDGE_LENGTH',
    // Required to layout children
    // https://github.com/kieler/elkjs/issues/44#issuecomment-412283358
    'org.eclipse.elk.hierarchyHandling': 'INCLUDE_CHILDREN',
    // Sometimes seems to improve layouts
    'org.eclipse.elk.layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
    // Disable temporarily, because it sometimes crashes ELK
    // Add partitioning to move signal and bindings to top
    // 'org.eclipse.elk.partitioning.activate': 'true',
    // We are placing the labels directly on the edges
    'org.eclipse.elk.edgeLabels.inline': 'true',
    // Add more spacing overall to make it easier to read
    'org.eclipse.elk.layered.spacing.baseValue': '40'
};
const ROOT_ID = 'ELK:root';
function toELKGraph(graph, visible) {
    // ELK requires that children nodes be nested inside their parents, in the graph JSON.
    // Therefore, we keep track of every node we add, so that when we add a node, to we add it to its parent
    const idToNode = new Map();
    const edges = Object.entries(graph.edges).filter(([id])=>visible?.edges.has(id) ?? true).map(([id, { source, target, size, label }])=>({
            id,
            sources: [
                source
            ],
            targets: [
                target
            ],
            labels: label ? [
                {
                    id: `edge-label:${id}`,
                    text: label,
                    ...size
                }
            ] : []
        }));
    const rootNode = {
        id: ROOT_ID,
        children: [],
        edges: edges,
        layoutOptions: LAYOUT_OPTIONS
    };
    idToNode.set(ROOT_ID, rootNode);
    // Get a node, or create it, so we can add children to nodes we haven't found yet
    const getOrCreateNode = (id)=>{
        if (!idToNode.has(id)) idToNode.set(id, {
            id,
            children: []
        });
        return idToNode.get(id);
    };
    // Iterate through the graph, adding nodes to the graph. If the node has a parent, add it to that parent's children instead of the root
    for (const [id, { parent, size, partition }] of Object.entries(graph.nodes)){
        if (visible && !visible.nodes.has(id)) continue;
        const node = getOrCreateNode(id);
        node.layoutOptions = {
            'org.eclipse.elk.partitioning.partition': partition.toString()
        };
        Object.assign(node, size);
        getOrCreateNode(parent ?? ROOT_ID).children.push(node);
    }
    return rootNode;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l3vNX":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
// --------------    FAKE ELEMENTS GWT ASSUMES EXIST   -------------- 
var $wnd;
if (typeof window !== 'undefined') $wnd = window;
else if (typeof global !== 'undefined') $wnd = global // nodejs
;
else if (typeof self !== 'undefined') $wnd = self // web worker
;
var $moduleName, $moduleBase;
// --------------    WORKAROUND STRICT MODE, SEE #127    -------------- 
var _xblockexpression;
// --------------    GENERATED CODE    -------------- 
var $intern_0 = 2147483647, $intern_1 = {
    3: 1
}, $intern_2 = {
    3: 1,
    4: 1,
    5: 1
}, $intern_3 = {
    204: 1,
    49: 1
}, $intern_4 = {
    204: 1,
    49: 1,
    127: 1
}, $intern_5 = {
    228: 1,
    3: 1
}, $intern_6 = {
    49: 1
}, $intern_7 = {
    91: 1
}, $intern_8 = {
    20: 1,
    31: 1,
    16: 1
}, $intern_9 = 2009, $intern_10 = {
    20: 1,
    31: 1,
    16: 1,
    22: 1
}, $intern_11 = {
    91: 1,
    137: 1,
    134: 1
}, $intern_12 = {
    20: 1,
    31: 1,
    16: 1,
    22: 1,
    83: 1
}, $intern_13 = {
    20: 1,
    31: 1,
    16: 1,
    274: 1,
    22: 1,
    83: 1
}, $intern_14 = {
    49: 1,
    127: 1
}, $intern_15 = {
    355: 1,
    43: 1
}, $intern_16 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1
}, $intern_17 = 16384, $intern_18 = {
    158: 1
}, $intern_19 = {
    40: 1
}, $intern_20 = {
    202: 1
}, $intern_21 = {
    l: 4194303,
    m: 4194303,
    h: 524287
}, $intern_22 = {
    252: 1,
    3: 1,
    34: 1
}, $intern_23 = {
    20: 1
}, $intern_24 = {
    20: 1,
    16: 1
}, $intern_25 = {
    3: 1,
    20: 1,
    31: 1,
    16: 1
}, $intern_26 = {
    308: 1,
    3: 1,
    20: 1,
    31: 1,
    16: 1,
    15: 1,
    59: 1
}, $intern_27 = {
    3: 1,
    4: 1,
    5: 1,
    174: 1
}, $intern_28 = {
    3: 1,
    91: 1
}, $intern_29 = {
    20: 1,
    16: 1,
    22: 1
}, $intern_30 = {
    3: 1,
    20: 1,
    31: 1,
    16: 1,
    22: 1
}, $intern_31 = {
    20: 1,
    16: 1,
    22: 1,
    83: 1
}, $intern_32 = 461845907, $intern_33 = -862048943, $intern_34 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    174: 1
}, $intern_35 = 1073741824, $intern_36 = {
    3: 1,
    6: 1,
    4: 1,
    10: 1,
    5: 1
}, $intern_37 = {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1
}, $intern_38 = {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, $intern_39 = {
    48: 1
}, $intern_40 = {
    372: 1
}, $intern_41 = 1.0E-4, $intern_42 = -2147483648, $intern_43 = {
    3: 1,
    103: 1,
    63: 1,
    80: 1
}, $intern_44 = {
    201: 1,
    3: 1,
    4: 1
}, $intern_45 = 1000, $intern_46 = 65535, $intern_47 = 1900, $intern_48 = {
    54: 1,
    3: 1,
    4: 1
}, $intern_49 = 2048, $intern_50 = {
    3: 1,
    4: 1,
    34: 1,
    205: 1
}, $intern_51 = 4194303, $intern_52 = 1048575, $intern_53 = 524288, $intern_54 = 4194304, $intern_55 = 17592186044416, $intern_56 = 1000000000, $intern_57 = -17592186044416, $intern_58 = {
    3: 1,
    103: 1,
    97: 1,
    63: 1,
    80: 1
}, $intern_59 = {
    3: 1,
    294: 1,
    80: 1
}, $intern_60 = Infinity, $intern_61 = -Infinity, $intern_62 = 4096, $intern_63 = {
    3: 1,
    4: 1,
    579: 1
}, $intern_64 = 65536, $intern_65 = 55296, $intern_66 = {
    108: 1,
    3: 1,
    4: 1
}, $intern_67 = 100000, $intern_68 = 0.3010299956639812, $intern_69 = 4294967295, $intern_70 = {
    43: 1
}, $intern_71 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    13: 1,
    16: 1,
    15: 1,
    59: 1
}, $intern_72 = {
    3: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, $intern_73 = {
    20: 1,
    16: 1,
    15: 1
}, $intern_74 = {
    3: 1,
    51: 1
}, $intern_75 = {
    189: 1
}, $intern_76 = {
    3: 1,
    4: 1,
    91: 1
}, $intern_77 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    16: 1,
    50: 1,
    22: 1
}, $intern_78 = 1.4901161193847656E-8, $intern_79 = 1.1102230246251565E-16, $intern_80 = 15525485, $intern_81 = 5.9604644775390625E-8, $intern_82 = 16777216, $intern_83 = 16777215, $intern_84 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, $intern_85 = {
    3: 1,
    34: 1,
    23: 1,
    305: 1
}, $intern_86 = {
    3: 1,
    4: 1,
    5: 1,
    835: 1
}, $intern_87 = {
    518: 1,
    672: 1
}, $intern_88 = {
    51: 1
}, $intern_89 = {
    177: 1,
    48: 1
}, $intern_90 = {
    183: 1,
    3: 1,
    4: 1
}, $intern_91 = {
    215: 1,
    332: 1
}, $intern_92 = {
    3: 1,
    4: 1,
    5: 1,
    587: 1
}, $intern_93 = 0.01, $intern_94 = {
    3: 1,
    4: 1,
    5: 1,
    198: 1
}, $intern_95 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    99: 1,
    114: 1
}, $intern_96 = {
    222: 1
}, $intern_97 = 0.001, $intern_98 = {
    146: 1
}, $intern_99 = 1.600000023841858, $intern_100 = {
    3: 1,
    6: 1,
    4: 1,
    10: 1,
    5: 1,
    125: 1
}, $intern_101 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    145: 1,
    99: 1,
    114: 1
}, $intern_102 = {
    44: 1
}, $intern_103 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    469: 1,
    145: 1,
    99: 1,
    114: 1
}, $intern_104 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    145: 1,
    199: 1,
    209: 1,
    99: 1,
    114: 1
}, $intern_105 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    145: 1,
    1988: 1,
    209: 1,
    99: 1,
    114: 1
}, $intern_106 = {
    3: 1,
    4: 1,
    139: 1,
    213: 1,
    411: 1
}, $intern_107 = {
    3: 1,
    4: 1,
    107: 1,
    213: 1,
    411: 1
}, $intern_108 = {
    229: 1
}, $intern_109 = {
    3: 1,
    4: 1,
    5: 1,
    585: 1
}, $intern_110 = {
    106: 1,
    44: 1
}, $intern_111 = {
    402: 1,
    229: 1
}, $intern_112 = {
    825: 1,
    3: 1,
    4: 1
}, $intern_113 = 1.7976931348623157E308, $intern_114 = {
    3: 1,
    4: 1,
    5: 1,
    833: 1
}, $intern_115 = 1.0E-5, $intern_116 = 1.0E-6, $intern_117 = 0.09999999999999998, $intern_118 = 1.0E-8, $intern_119 = 4.71238898038469, $intern_120 = 1.5707963267948966, $intern_121 = 3.141592653589793, $intern_122 = 0.10000000149011612, $intern_123 = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, $intern_124 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    519: 1,
    99: 1,
    114: 1
}, $intern_125 = 6.283185307179586, $intern_126 = 4.9E-324, $intern_127 = {
    3: 1,
    4: 1,
    5: 1,
    99: 1
}, $intern_128 = 5.497787143782138, $intern_129 = 3.9269908169872414, $intern_130 = 2.356194490192345, $intern_131 = {
    337: 1
}, $intern_132 = {
    293: 1
}, $intern_133 = 0.05, $intern_134 = 1.2999999523162842, $intern_135 = {
    3: 1,
    34: 1,
    23: 1,
    343: 1
}, $intern_136 = {
    93: 1,
    92: 1
}, $intern_137 = 32768, $intern_138 = {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1
}, $intern_139 = {
    195: 1,
    3: 1,
    4: 1
}, $intern_140 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1
}, $intern_141 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    49: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    580: 1
}, $intern_142 = {
    412: 1,
    671: 1
}, $intern_143 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1
}, $intern_144 = {
    370: 1,
    150: 1
}, $intern_145 = {
    3: 1,
    4: 1,
    5: 1,
    128: 1
}, $intern_146 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    61: 1
}, $intern_147 = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    198: 1
}, $intern_148 = {
    3: 1,
    4: 1,
    5: 1,
    174: 1,
    371: 1
}, $intern_149 = 1024, $intern_150 = {
    76: 1
}, $intern_151 = {
    3: 1,
    20: 1,
    16: 1,
    15: 1,
    61: 1,
    581: 1,
    76: 1,
    71: 1,
    96: 1
}, $intern_152 = 8192, $intern_153 = {
    3: 1,
    4: 1,
    5: 1,
    253: 1
}, $intern_154 = {
    3: 1,
    4: 1,
    5: 1,
    673: 1
}, $intern_155 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    71: 1
}, $intern_156 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    76: 1,
    71: 1,
    96: 1
}, $intern_157 = {
    3: 1,
    4: 1,
    5: 1,
    674: 1
}, $intern_158 = {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1,
    76: 1,
    71: 1,
    96: 1
}, $intern_159 = {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    61: 1,
    71: 1
}, $intern_160 = {
    49: 1,
    127: 1,
    284: 1
}, $intern_161 = {
    74: 1,
    339: 1
}, $intern_162 = 1291, $intern_163 = -32768, $intern_164 = {
    58: 1
}, $intern_165 = {
    3: 1,
    4: 1,
    5: 1,
    122: 1
}, $intern_166 = {
    93: 1,
    92: 1,
    583: 1,
    1980: 1
}, $intern_167 = 1114111, $intern_168 = {
    3: 1,
    121: 1
}, $intern_169 = {
    3: 1,
    4: 1,
    5: 1,
    373: 1
};
var _, prototypesByTypeId_0, initFnList_0, permutationId = -1;
function setGwtProperty(propertyName, propertyValue) {
    typeof window === 'object' && typeof window['$gwt'] === 'object' && (window['$gwt'][propertyName] = propertyValue);
}
function gwtOnLoad_0(errFn, modName, modBase, softPermutationId) {
    ensureModuleInit();
    var initFnList = initFnList_0;
    $moduleName = modName;
    $moduleBase = modBase;
    permutationId = softPermutationId;
    function initializeModules() {
        for(var i = 0; i < initFnList.length; i++)initFnList[i]();
    }
    if (errFn) try {
        $entry(initializeModules)();
    } catch (e) {
        errFn(modName, e);
    }
    else $entry(initializeModules)();
}
function ensureModuleInit() {
    initFnList_0 == null && (initFnList_0 = []);
}
function addInitFunctions() {
    ensureModuleInit();
    var initFnList = initFnList_0;
    for(var i = 0; i < arguments.length; i++)initFnList.push(arguments[i]);
}
function typeMarkerFn() {}
function toString_40(object) {
    var number;
    if (Array.isArray(object) && object.typeMarker === typeMarkerFn) return $getName(getClass__Ljava_lang_Class___devirtual$(object)) + '@' + (number = hashCode__I__devirtual$(object) >>> 0, number.toString(16));
    return object.toString();
}
function portableObjCreate(obj) {
    function F() {}
    F.prototype = obj || {};
    return new F;
}
function makeLambdaFunction(samMethod, ctor, ctorArguments) {
    var lambda = function() {
        return samMethod.apply(lambda, arguments);
    };
    ctor.apply(lambda, ctorArguments);
    return lambda;
}
function emptyMethod() {}
function defineClass(typeId, superTypeIdOrPrototype, castableTypeMap) {
    var prototypesByTypeId = prototypesByTypeId_0, superPrototype;
    var prototype_0 = prototypesByTypeId[typeId];
    var clazz = prototype_0 instanceof Array ? prototype_0[0] : null;
    if (prototype_0 && !clazz) _ = prototype_0;
    else {
        _ = (superPrototype = superTypeIdOrPrototype && superTypeIdOrPrototype.prototype, !superPrototype && (superPrototype = prototypesByTypeId_0[superTypeIdOrPrototype]), portableObjCreate(superPrototype));
        _.castableTypeMap = castableTypeMap;
        !superTypeIdOrPrototype && (_.typeMarker = typeMarkerFn);
        prototypesByTypeId[typeId] = _;
    }
    for(var i = 3; i < arguments.length; ++i)arguments[i].prototype = _;
    clazz && (_.___clazz = clazz);
}
$wnd.goog = $wnd.goog || {};
$wnd.goog.global = $wnd.goog.global || $wnd;
prototypesByTypeId_0 = {};
function $equals(this$static, other) {
    return maskUndefined(this$static) === maskUndefined(other);
}
function Object_0() {}
function equals_Ljava_lang_Object__Z__devirtual$(this$static, other) {
    return instanceOfString(this$static) ? $equals_5(this$static, other) : instanceOfDouble(this$static) ? $equals_4(this$static, other) : instanceOfBoolean(this$static) ? (checkCriticalNotNull(this$static), maskUndefined(this$static) === maskUndefined(other)) : hasJavaObjectVirtualDispatch(this$static) ? this$static.equals_0(other) : isJavaArray(this$static) ? $equals(this$static, other) : $equals_3(this$static, other);
}
function getClass__Ljava_lang_Class___devirtual$(this$static) {
    return instanceOfString(this$static) ? Ljava_lang_String_2_classLit : instanceOfDouble(this$static) ? Ljava_lang_Double_2_classLit : instanceOfBoolean(this$static) ? Ljava_lang_Boolean_2_classLit : hasJavaObjectVirtualDispatch(this$static) ? this$static.___clazz : isJavaArray(this$static) ? this$static.___clazz : this$static.___clazz || Array.isArray(this$static) && getClassLiteralForArray(Lcom_google_gwt_core_client_JavaScriptObject_2_classLit, 1) || Lcom_google_gwt_core_client_JavaScriptObject_2_classLit;
}
function hashCode__I__devirtual$(this$static) {
    return instanceOfString(this$static) ? $hashCode_2(this$static) : instanceOfDouble(this$static) ? $hashCode_1(this$static) : instanceOfBoolean(this$static) ? $hashCode_0(this$static) : hasJavaObjectVirtualDispatch(this$static) ? this$static.hashCode_1() : isJavaArray(this$static) ? getObjectIdentityHashCode(this$static) : $hashCode(this$static);
}
defineClass(1, null, {}, Object_0);
_.equals_0 = function equals(other) {
    return $equals(this, other);
};
_.getClass_0 = function getClass_0() {
    return this.___clazz;
};
_.hashCode_1 = function hashCode_0() {
    return getObjectIdentityHashCode(this);
};
_.toString_0 = function toString_1() {
    var number;
    return $getName(getClass__Ljava_lang_Class___devirtual$(this)) + '@' + (number = hashCode__I__devirtual$(this) >>> 0, number.toString(16));
};
_.equals = function(other) {
    return this.equals_0(other);
};
_.hashCode = function() {
    return this.hashCode_1();
};
_.toString = function() {
    return this.toString_0();
};
function canCast(src_0, dstId) {
    if (instanceOfString(src_0)) return !!stringCastMap[dstId];
    else if (src_0.castableTypeMap) return !!src_0.castableTypeMap[dstId];
    else if (instanceOfDouble(src_0)) return !!doubleCastMap[dstId];
    else if (instanceOfBoolean(src_0)) return !!booleanCastMap[dstId];
    return false;
}
function castTo(src_0, dstId) {
    checkCriticalType(src_0 == null || canCast(src_0, dstId));
    return src_0;
}
function castToArray(src_0) {
    var elementTypeCategory;
    checkCriticalType(src_0 == null || Array.isArray(src_0) && (elementTypeCategory = getElementTypeCategory(src_0), !(elementTypeCategory >= 14 && elementTypeCategory <= 16)));
    return src_0;
}
function castToBoolean(src_0) {
    checkCriticalType(src_0 == null || instanceOfBoolean(src_0));
    return src_0;
}
function castToDouble(src_0) {
    checkCriticalType(src_0 == null || instanceOfDouble(src_0));
    return src_0;
}
function castToJso(src_0) {
    checkCriticalType(src_0 == null || isJsObjectOrFunction(src_0) && !(src_0.typeMarker === typeMarkerFn));
    return src_0;
}
function castToString(src_0) {
    checkCriticalType(src_0 == null || instanceOfString(src_0));
    return src_0;
}
function charToString(x_0) {
    return String.fromCharCode(x_0);
}
function hasJavaObjectVirtualDispatch(src_0) {
    return !Array.isArray(src_0) && src_0.typeMarker === typeMarkerFn;
}
function instanceOf(src_0, dstId) {
    return src_0 != null && canCast(src_0, dstId);
}
function instanceOfBoolean(src_0) {
    return typeof src_0 === 'boolean';
}
function instanceOfDouble(src_0) {
    return typeof src_0 === 'number';
}
function instanceOfJso(src_0) {
    return src_0 != null && isJsObjectOrFunction(src_0) && !(src_0.typeMarker === typeMarkerFn);
}
function instanceOfString(src_0) {
    return typeof src_0 === 'string';
}
function isJsObjectOrFunction(src_0) {
    return typeof src_0 === 'object' || typeof src_0 === 'function';
}
function maskUndefined(src_0) {
    return src_0 == null ? null : src_0;
}
function round_int(x_0) {
    return Math.max(Math.min(x_0, $intern_0), -2147483648) | 0;
}
function throwClassCastExceptionUnlessNull(o) {
    checkCriticalType(o == null);
    return o;
}
var booleanCastMap, doubleCastMap, stringCastMap;
function $ensureNamesAreInitialized(this$static) {
    if (this$static.typeName != null) return;
    initializeNames(this$static);
}
function $getEnumConstants(this$static) {
    return this$static.enumConstantsFunc && this$static.enumConstantsFunc();
}
function $getName(this$static) {
    $ensureNamesAreInitialized(this$static);
    return this$static.typeName;
}
function $toString_5(this$static) {
    return ((this$static.modifiers & 2) != 0 ? 'interface ' : (this$static.modifiers & 1) != 0 ? '' : 'class ') + ($ensureNamesAreInitialized(this$static), this$static.typeName);
}
function Class() {
    ++nextSequentialId;
    this.typeName = null;
    this.simpleName = null;
    this.packageName = null;
    this.compoundName = null;
    this.canonicalName = null;
    this.typeId = null;
    this.arrayLiterals = null;
}
function createClassObject(packageName, compoundClassName) {
    var clazz;
    clazz = new Class;
    clazz.packageName = packageName;
    clazz.compoundName = compoundClassName;
    return clazz;
}
function createForClass(packageName, compoundClassName, typeId) {
    var clazz;
    clazz = createClassObject(packageName, compoundClassName);
    maybeSetClassLiteral(typeId, clazz);
    return clazz;
}
function createForEnum(packageName, compoundClassName, typeId, superclass, enumConstantsFunc, enumValueOfFunc) {
    var clazz;
    clazz = createClassObject(packageName, compoundClassName);
    maybeSetClassLiteral(typeId, clazz);
    clazz.modifiers = enumConstantsFunc ? 8 : 0;
    clazz.enumSuperclass = superclass;
    clazz.enumConstantsFunc = enumConstantsFunc;
    clazz.enumValueOfFunc = enumValueOfFunc;
    return clazz;
}
function createForInterface(packageName, compoundClassName) {
    var clazz;
    clazz = createClassObject(packageName, compoundClassName);
    clazz.modifiers = 2;
    return clazz;
}
function createForPrimitive(className, primitiveTypeId) {
    var clazz;
    clazz = createClassObject('', className);
    clazz.typeId = primitiveTypeId;
    clazz.modifiers = 1;
    return clazz;
}
function getClassLiteralForArray_0(leafClass, dimensions) {
    var arrayLiterals = leafClass.arrayLiterals = leafClass.arrayLiterals || [];
    return arrayLiterals[dimensions] || (arrayLiterals[dimensions] = leafClass.createClassLiteralForArray(dimensions));
}
function getPrototypeForClass(clazz) {
    if (clazz.isPrimitive()) return null;
    var typeId = clazz.typeId;
    return prototypesByTypeId_0[typeId];
}
function initializeNames(clazz) {
    if (clazz.isArray_1()) {
        var componentType = clazz.componentType;
        componentType.isPrimitive() ? clazz.typeName = '[' + componentType.typeId : !componentType.isArray_1() ? clazz.typeName = '[L' + componentType.getName() + ';' : clazz.typeName = '[' + componentType.getName();
        clazz.canonicalName = componentType.getCanonicalName() + '[]';
        clazz.simpleName = componentType.getSimpleName() + '[]';
        return;
    }
    var packageName = clazz.packageName;
    var compoundName = clazz.compoundName;
    compoundName = compoundName.split('/');
    clazz.typeName = join_0('.', [
        packageName,
        join_0('$', compoundName)
    ]);
    clazz.canonicalName = join_0('.', [
        packageName,
        join_0('.', compoundName)
    ]);
    clazz.simpleName = compoundName[compoundName.length - 1];
}
function join_0(separator, strings) {
    var i = 0;
    while(!strings[i] || strings[i] == '')i++;
    var result = strings[i++];
    for(; i < strings.length; i++){
        if (!strings[i] || strings[i] == '') continue;
        result += separator + strings[i];
    }
    return result;
}
function maybeSetClassLiteral(typeId, clazz) {
    var proto;
    if (!typeId) return;
    clazz.typeId = typeId;
    var prototype_0 = getPrototypeForClass(clazz);
    if (!prototype_0) {
        prototypesByTypeId_0[typeId] = [
            clazz
        ];
        return;
    }
    prototype_0.___clazz = clazz;
}
defineClass(295, 1, {
    295: 1,
    2070: 1
}, Class);
_.createClassLiteralForArray = function createClassLiteralForArray(dimensions) {
    var clazz;
    clazz = new Class;
    clazz.modifiers = 4;
    dimensions > 1 ? clazz.componentType = getClassLiteralForArray_0(this, dimensions - 1) : clazz.componentType = this;
    return clazz;
};
_.getCanonicalName = function getCanonicalName() {
    $ensureNamesAreInitialized(this);
    return this.canonicalName;
};
_.getName = function getName() {
    return $getName(this);
};
_.getSimpleName = function getSimpleName() {
    return $ensureNamesAreInitialized(this), this.simpleName;
};
_.isArray_1 = function isArray_1() {
    return (this.modifiers & 4) != 0;
};
_.isPrimitive = function isPrimitive() {
    return (this.modifiers & 1) != 0;
};
_.toString_0 = function toString_44() {
    return $toString_5(this);
};
_.modifiers = 0;
var nextSequentialId = 1;
var Ljava_lang_Object_2_classLit = createForClass('java.lang', 'Object', 1);
var Ljava_lang_Class_2_classLit = createForClass('java.lang', 'Class', 295);
defineClass(2042, 1, $intern_1);
var Lcom_google_common_base_Optional_2_classLit = createForClass('com.google.common.base', 'Optional', 2042);
function $clinit_Absent() {
    $clinit_Absent = emptyMethod;
    INSTANCE = new Absent;
}
function Absent() {}
defineClass(1155, 2042, $intern_1, Absent);
_.equals_0 = function equals_0(object) {
    return object === this;
};
_.hashCode_1 = function hashCode_1() {
    return 2040732332;
};
_.toString_0 = function toString_2() {
    return 'Optional.absent()';
};
_.transform = function transform(function_0) {
    checkNotNull(function_0);
    return $clinit_Absent(), INSTANCE;
};
var INSTANCE;
var Lcom_google_common_base_Absent_2_classLit = createForClass('com.google.common.base', 'Absent', 1155);
function $appendTo(this$static, appendable, parts) {
    checkNotNull(appendable);
    if (parts.hasNext_0()) {
        $append_7(appendable, $toString(parts.next_1()));
        while(parts.hasNext_0()){
            $append_7(appendable, this$static.separator);
            $append_7(appendable, $toString(parts.next_1()));
        }
    }
    return appendable;
}
function $appendTo_0(this$static, builder, parts) {
    var impossible;
    try {
        $appendTo(this$static, builder, parts);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 590)) {
            impossible = $e0;
            throw toJs(new AssertionError_0(impossible));
        } else throw toJs($e0);
    }
    return builder;
}
function $join(this$static, parts) {
    return $appendTo_0(this$static, new StringBuilder, parts).string;
}
function $toString(part) {
    requireNonNull(part);
    return instanceOf(part, 470) ? castTo(part, 470) : toString_40(part);
}
function Joiner() {
    this.separator = castToString(checkNotNull(', '));
}
defineClass(621, 1, {}, Joiner);
var Lcom_google_common_base_Joiner_2_classLit = createForClass('com.google.common.base', 'Joiner', 621);
function equal(a, b) {
    return maskUndefined(a) === maskUndefined(b) || a != null && equals_Ljava_lang_Object__Z__devirtual$(a, b);
}
function badElementIndex(index_0, size_0) {
    if (index_0 < 0) return lenientFormat('%s (%s) must not be negative', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        'index',
        valueOf_3(index_0)
    ]));
    else if (size_0 < 0) throw toJs(new IllegalArgumentException_0('negative size: ' + size_0));
    else return lenientFormat('%s (%s) must be less than size (%s)', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        'index',
        valueOf_3(index_0),
        valueOf_3(size_0)
    ]));
}
function badPositionIndex(index_0, size_0, desc) {
    if (index_0 < 0) return lenientFormat('%s (%s) must not be negative', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        desc,
        valueOf_3(index_0)
    ]));
    else if (size_0 < 0) throw toJs(new IllegalArgumentException_0('negative size: ' + size_0));
    else return lenientFormat('%s (%s) must not be greater than size (%s)', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        desc,
        valueOf_3(index_0),
        valueOf_3(size_0)
    ]));
}
function badPositionIndexes(start_0, end, size_0) {
    if (start_0 < 0 || start_0 > size_0) return badPositionIndex(start_0, size_0, 'start index');
    if (end < 0 || end > size_0) return badPositionIndex(end, size_0, 'end index');
    return lenientFormat('end index (%s) must not be less than start index (%s)', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        valueOf_3(end),
        valueOf_3(start_0)
    ]));
}
function checkArgument(expression) {
    if (!expression) throw toJs(new IllegalArgumentException);
}
function checkArgument_0(expression, errorMessage) {
    if (!expression) throw toJs(new IllegalArgumentException_0(errorMessage));
}
function checkArgument_1(b, p1) {
    if (!b) throw toJs(new IllegalArgumentException_0(lenientFormat('value already present: %s', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        p1
    ]))));
}
function checkArgument_2(b, errorMessageTemplate, p1, p2) {
    if (!b) throw toJs(new IllegalArgumentException_0(lenientFormat(errorMessageTemplate, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        p1,
        p2
    ]))));
}
function checkElementIndex(index_0, size_0) {
    if (index_0 < 0 || index_0 >= size_0) throw toJs(new IndexOutOfBoundsException_0(badElementIndex(index_0, size_0)));
    return index_0;
}
function checkNotNull(reference) {
    if (reference == null) throw toJs(new NullPointerException);
    return reference;
}
function checkNotNull_0(reference, errorMessage) {
    if (reference == null) throw toJs(new NullPointerException_0(errorMessage));
    return reference;
}
function checkPositionIndex(index_0, size_0) {
    if (index_0 < 0 || index_0 > size_0) throw toJs(new IndexOutOfBoundsException_0(badPositionIndex(index_0, size_0, 'index')));
    return index_0;
}
function checkPositionIndexes(start_0, end, size_0) {
    if (start_0 < 0 || end < start_0 || end > size_0) throw toJs(new IndexOutOfBoundsException_0(badPositionIndexes(start_0, end, size_0)));
}
function checkState(expression) {
    if (!expression) throw toJs(new IllegalStateException);
}
function checkState_0(expression) {
    if (!expression) throw toJs(new IllegalStateException_0('no calls to next() since the last call to remove()'));
}
var Lcom_google_common_base_Predicate_2_classLit = createForInterface('com.google.common.base', 'Predicate');
function toStringHelper(components) {
    var builder, first, o, o$iterator;
    builder = $append_5($append_11(new StringBuilder_1('Predicates.'), 'and'), 40);
    first = true;
    for(o$iterator = new AbstractList$IteratorImpl(components); o$iterator.i < o$iterator.this$01_0.size_1();){
        o = (checkCriticalElement(o$iterator.i < o$iterator.this$01_0.size_1()), o$iterator.this$01_0.get_0(o$iterator.last = o$iterator.i++));
        first || (builder.string += ',', builder);
        builder.string += '' + o;
        first = false;
    }
    return (builder.string += ')', builder).string;
}
function $apply(this$static, t) {
    var i;
    for(i = 0; i < this$static.components.array.length; i++){
        if (!castTo($get_12(this$static.components, i), 177).apply_1(t)) return false;
    }
    return true;
}
function Predicates$AndPredicate(components) {
    this.components = components;
}
defineClass(572, 1, {
    177: 1,
    572: 1,
    3: 1,
    48: 1
}, Predicates$AndPredicate);
_.test_0 = function test_0(input_0) {
    return $apply(this, input_0);
};
_.apply_1 = function apply_1(t) {
    return $apply(this, t);
};
_.equals_0 = function equals_1(obj) {
    var that;
    if (instanceOf(obj, 572)) {
        that = castTo(obj, 572);
        return $equals_2(this.components, that.components);
    }
    return false;
};
_.hashCode_1 = function hashCode_2() {
    return hashCode_49(this.components) + 306654252;
};
_.toString_0 = function toString_3() {
    return toStringHelper(this.components);
};
var Lcom_google_common_base_Predicates$AndPredicate_2_classLit = createForClass('com.google.common.base', 'Predicates/AndPredicate', 572);
function Present(reference) {
    this.reference = reference;
}
defineClass(408, 2042, {
    408: 1,
    3: 1
}, Present);
_.equals_0 = function equals_2(object) {
    var other;
    if (instanceOf(object, 408)) {
        other = castTo(object, 408);
        return equals_Ljava_lang_Object__Z__devirtual$(this.reference, other.reference);
    }
    return false;
};
_.hashCode_1 = function hashCode_3() {
    return 1502476572 + hashCode__I__devirtual$(this.reference);
};
_.toString_0 = function toString_4() {
    return 'Optional.of(' + this.reference + ')';
};
_.transform = function transform_0(function_0) {
    return new Present(checkNotNull_0(function_0.apply_0(this.reference), 'the Function passed to Optional.transform() must not return null.'));
};
var Lcom_google_common_base_Present_2_classLit = createForClass('com.google.common.base', 'Present', 408);
function lenientFormat(template, args) {
    var builder, i, i0, placeholderStart, templateStart;
    template = template == null ? 'null' : (checkCriticalNotNull(template), template);
    for(i0 = 0; i0 < args.length; i0++)args[i0] = lenientToString(args[i0]);
    builder = new StringBuilder_0;
    templateStart = 0;
    i = 0;
    while(i < args.length){
        placeholderStart = template.indexOf('%s', templateStart);
        if (placeholderStart == -1) break;
        builder.string += '' + $substring_1(template == null ? 'null' : (checkCriticalNotNull(template), template), templateStart, placeholderStart);
        $append_10(builder, args[i++]);
        templateStart = placeholderStart + 2;
    }
    $append_9(builder, template, templateStart, template.length);
    if (i < args.length) {
        builder.string += ' [';
        $append_10(builder, args[i++]);
        while(i < args.length){
            builder.string += ', ';
            $append_10(builder, args[i++]);
        }
        builder.string += ']';
    }
    return builder.string;
}
function lenientToString(o) {
    var e, number, objectToString;
    if (o == null) return 'null';
    try {
        return toString_40(o);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            e = $e0;
            objectToString = $getName(getClass__Ljava_lang_Class___devirtual$(o)) + '@' + (number = ($clinit_System(), getIdentityHashCode(o)) >>> 0, number.toString(16));
            $log(getLogger(), ($clinit_Level(), 'Exception during lenientFormat for ' + objectToString), e);
            return '<' + objectToString + ' threw ' + $getName(e.___clazz) + '>';
        } else throw toJs($e0);
    }
}
function $forEachRemaining(this$static, consumer) {
    checkCriticalNotNull(consumer);
    while(this$static.hasNext_0())consumer.accept(this$static.next_1());
}
function $remove_21() {
    throw toJs(new UnsupportedOperationException);
}
function $remove() {
    throw toJs(new UnsupportedOperationException);
}
defineClass(204, 1, $intern_3);
_.forEachRemaining = function forEachRemaining(consumer) {
    $forEachRemaining(this, consumer);
};
_.remove = function remove_0() {
    $remove();
};
var Lcom_google_common_collect_UnmodifiableIterator_2_classLit = createForClass('com.google.common.collect', 'UnmodifiableIterator', 204);
defineClass(2022, 204, $intern_4);
_.remove = function remove_1() {
    $remove();
};
_.add_1 = function add_1(e) {
    throw toJs(new UnsupportedOperationException);
};
_.set_1 = function set_1(e) {
    throw toJs(new UnsupportedOperationException);
};
var Lcom_google_common_collect_UnmodifiableListIterator_2_classLit = createForClass('com.google.common.collect', 'UnmodifiableListIterator', 2022);
function AbstractIndexedListIterator(size_0) {
    AbstractIndexedListIterator_0.call(this, size_0, 0);
}
function AbstractIndexedListIterator_0(size_0, position) {
    checkPositionIndex(position, size_0);
    this.size_0 = size_0;
    this.position = position;
}
defineClass(390, 2022, $intern_4);
_.hasNext_0 = function hasNext() {
    return this.position < this.size_0;
};
_.hasPrevious = function hasPrevious() {
    return this.position > 0;
};
_.next_1 = function next_0() {
    if (this.position >= this.size_0) throw toJs(new NoSuchElementException);
    return this.get_0(this.position++);
};
_.nextIndex_0 = function nextIndex_0() {
    return this.position;
};
_.previous_0 = function previous_0() {
    if (this.position <= 0) throw toJs(new NoSuchElementException);
    return this.get_0(--this.position);
};
_.previousIndex = function previousIndex() {
    return this.position - 1;
};
_.position = 0;
_.size_0 = 0;
var Lcom_google_common_collect_AbstractIndexedListIterator_2_classLit = createForClass('com.google.common.collect', 'AbstractIndexedListIterator', 390);
function $hasNext(this$static) {
    checkState(this$static.state != 3);
    switch(this$static.state){
        case 2:
            return false;
        case 0:
            return true;
    }
    return $tryToComputeNext(this$static);
}
function $next(this$static) {
    var result;
    if (!$hasNext(this$static)) throw toJs(new NoSuchElementException);
    this$static.state = 1;
    result = this$static.next_0;
    this$static.next_0 = null;
    return result;
}
function $tryToComputeNext(this$static) {
    this$static.state = 3;
    this$static.next_0 = this$static.computeNext();
    if (this$static.state != 2) {
        this$static.state = 0;
        return true;
    }
    return false;
}
defineClass(697, 204, $intern_3);
_.hasNext_0 = function hasNext_0() {
    return $hasNext(this);
};
_.next_1 = function next_1() {
    return $next(this);
};
_.state = 1;
var Lcom_google_common_collect_AbstractIterator_2_classLit = createForClass('com.google.common.collect', 'AbstractIterator', 697);
function $containsEntry(this$static, key, value_0) {
    var collection;
    collection = castTo(this$static.asMap_0().get_3(key), 16);
    return !!collection && collection.contains(value_0);
}
function $containsValue(this$static, value_0) {
    var collection, collection$iterator;
    for(collection$iterator = this$static.asMap_0().values_0().iterator_0(); collection$iterator.hasNext_0();){
        collection = castTo(collection$iterator.next_1(), 16);
        if (collection.contains(value_0)) return true;
    }
    return false;
}
function $keySet(this$static) {
    var result;
    result = this$static.keySet;
    return !result ? this$static.keySet = this$static.createKeySet() : result;
}
function $keys(this$static) {
    var result;
    result = this$static.keys_0;
    return !result ? this$static.keys_0 = new Multimaps$Keys(this$static) : result;
}
function $remove_0(this$static, key, value_0) {
    var collection;
    collection = castTo(this$static.asMap_0().get_3(key), 16);
    return !!collection && collection.remove_1(value_0);
}
defineClass(2030, 1, {
    228: 1
});
_.asMap_0 = function asMap() {
    var result;
    return result = this.asMap, !result ? this.asMap = this.createAsMap() : result;
};
_.equals_0 = function equals_3(object) {
    return equalsImpl_1(this, object);
};
_.hashCode_1 = function hashCode_4() {
    return hashCode__I__devirtual$(this.asMap_0());
};
_.isEmpty = function isEmpty() {
    return this.size_1() == 0;
};
_.keySet_0 = function keySet_0() {
    return $keySet(this);
};
_.toString_0 = function toString_5() {
    return toString_40(this.asMap_0());
};
var Lcom_google_common_collect_AbstractMultimap_2_classLit = createForClass('com.google.common.collect', 'AbstractMultimap', 2030);
function $clear(this$static) {
    var collection, collection$iterator;
    for(collection$iterator = this$static.map_0.values_0().iterator_0(); collection$iterator.hasNext_0();){
        collection = castTo(collection$iterator.next_1(), 16);
        collection.clear_0();
    }
    this$static.map_0.clear_0();
    this$static.totalSize = 0;
}
function $containsKey(this$static, key) {
    return this$static.map_0.containsKey(key);
}
function $entries(this$static) {
    var result;
    return result = this$static.entries_0, !result ? this$static.entries_0 = new AbstractMultimap$Entries(this$static) : result;
}
function $get(this$static, key) {
    var collection;
    collection = castTo(this$static.map_0.get_3(key), 16);
    !collection && (collection = this$static.createCollection_0(key));
    return this$static.wrapCollection(key, collection);
}
function $put(this$static, key, value_0) {
    var collection;
    collection = castTo(this$static.map_0.get_3(key), 16);
    if (!collection) {
        collection = this$static.createCollection_0(key);
        if (collection.add_2(value_0)) {
            ++this$static.totalSize;
            this$static.map_0.put(key, collection);
            return true;
        } else throw toJs(new AssertionError_0('New Collection violated the Collection spec'));
    } else if (collection.add_2(value_0)) {
        ++this$static.totalSize;
        return true;
    } else return false;
}
function $removeAll(this$static, key) {
    var collection, output;
    collection = castTo(this$static.map_0.remove_0(key), 16);
    if (!collection) return this$static.createUnmodifiableEmptyCollection();
    output = this$static.createCollection();
    output.addAll(collection);
    this$static.totalSize -= collection.size_1();
    collection.clear_0();
    return this$static.unmodifiableCollectionSubclass(output);
}
function $removeValuesForKey(this$static, key) {
    var collection, count;
    collection = castTo(safeRemove_0(this$static.map_0, key), 16);
    if (collection) {
        count = collection.size_1();
        collection.clear_0();
        this$static.totalSize -= count;
    }
}
function $values(this$static) {
    var result;
    return result = this$static.values, !result ? this$static.values = new AbstractMultimap$Values(this$static) : result;
}
function $wrapList(this$static, key, list, ancestor) {
    return instanceOf(list, 59) ? new AbstractMapBasedMultimap$RandomAccessWrappedList(this$static, key, list, ancestor) : new AbstractMapBasedMultimap$WrappedList(this$static, key, list, ancestor);
}
function AbstractMapBasedMultimap(map_0) {
    checkArgument(map_0.isEmpty());
    this.map_0 = map_0;
}
function iteratorOrListIterator(collection) {
    return instanceOf(collection, 15) ? castTo(collection, 15).listIterator_0() : collection.iterator_0();
}
function lambda$1(keyToValueCollectionEntry_0) {
    var key, valueCollection;
    key = keyToValueCollectionEntry_0.getKey();
    valueCollection = castTo(keyToValueCollectionEntry_0.getValue(), 16);
    return map_2(valueCollection.spliterator_0(), new AbstractMapBasedMultimap$lambda$2$Type(key));
}
defineClass(725, 2030, $intern_5);
_.clear_0 = function clear_0() {
    $clear(this);
};
_.containsKey = function containsKey(key) {
    return $containsKey(this, key);
};
_.createAsMap = function createAsMap() {
    return new AbstractMapBasedMultimap$AsMap(this, this.map_0);
};
_.createCollection_0 = function createCollection(key) {
    return this.createCollection();
};
_.createKeySet = function createKeySet() {
    return new AbstractMapBasedMultimap$KeySet(this, this.map_0);
};
_.createUnmodifiableEmptyCollection = function createUnmodifiableEmptyCollection() {
    return this.unmodifiableCollectionSubclass(this.createCollection());
};
_.entryIterator = function entryIterator_0() {
    return new AbstractMapBasedMultimap$2(this);
};
_.entrySpliterator = function entrySpliterator_0() {
    return flatMap(this.map_0.entrySet_0().spliterator_0(), new AbstractMapBasedMultimap$lambda$1$Type, 64, this.totalSize);
};
_.get_1 = function get_0(key) {
    return $get(this, key);
};
_.removeAll = function removeAll(key) {
    return $removeAll(this, key);
};
_.size_1 = function size_1() {
    return this.totalSize;
};
_.unmodifiableCollectionSubclass = function unmodifiableCollectionSubclass(collection) {
    return $clinit_Collections(), new Collections$UnmodifiableCollection(collection);
};
_.valueIterator_0 = function valueIterator() {
    return new AbstractMapBasedMultimap$1(this);
};
_.valueSpliterator = function valueSpliterator() {
    return flatMap(this.map_0.values_0().spliterator_0(), new AbstractMapBasedMultimap$1methodref$spliterator$Type, 64, this.totalSize);
};
_.wrapCollection = function wrapCollection(key, collection) {
    return new AbstractMapBasedMultimap$WrappedCollection(this, key, collection, null);
};
_.totalSize = 0;
var Lcom_google_common_collect_AbstractMapBasedMultimap_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap', 725);
function $asMap(this$static) {
    var result;
    return result = this$static.asMap, !result ? this$static.asMap = new AbstractMapBasedMultimap$AsMap(this$static, this$static.map_0) : result;
}
defineClass(1637, 725, $intern_5);
_.createCollection = function createCollection_0() {
    return new ArrayList_0(this.expectedValuesPerKey);
};
_.createUnmodifiableEmptyCollection = function createUnmodifiableEmptyCollection_0() {
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
};
_.get_1 = function get_1(key) {
    return castTo($get(this, key), 15);
};
_.removeAll = function removeAll_0(key) {
    return castTo($removeAll(this, key), 15);
};
_.asMap_0 = function asMap_0() {
    return $asMap(this);
};
_.equals_0 = function equals_4(object) {
    return equalsImpl_1(this, object);
};
_.get_2 = function get_2(key) {
    return castTo($get(this, key), 15);
};
_.removeAll_0 = function removeAll_1(key) {
    return castTo($removeAll(this, key), 15);
};
_.unmodifiableCollectionSubclass = function unmodifiableCollectionSubclass_0(collection) {
    return unmodifiableList(castTo(collection, 15));
};
_.wrapCollection = function wrapCollection_0(key, collection) {
    return $wrapList(this, key, castTo(collection, 15), null);
};
var Lcom_google_common_collect_AbstractListMultimap_2_classLit = createForClass('com.google.common.collect', 'AbstractListMultimap', 1637);
function AbstractMapBasedMultimap$Itr(this$0) {
    this.this$01 = this$0;
    this.keyIterator = this$0.map_0.entrySet_0().iterator_0();
    this.key = null;
    this.collection = null;
    this.valueIterator = ($clinit_Iterators$EmptyModifiableIterator(), INSTANCE_2);
}
defineClass(731, 1, $intern_6);
_.forEachRemaining = function forEachRemaining_0(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_1() {
    return this.keyIterator.hasNext_0() || this.valueIterator.hasNext_0();
};
_.next_1 = function next_2() {
    var mapEntry;
    if (!this.valueIterator.hasNext_0()) {
        mapEntry = castTo(this.keyIterator.next_1(), 43);
        this.key = mapEntry.getKey();
        this.collection = castTo(mapEntry.getValue(), 16);
        this.valueIterator = this.collection.iterator_0();
    }
    return this.output(this.key, this.valueIterator.next_1());
};
_.remove = function remove_2() {
    this.valueIterator.remove();
    castTo(requireNonNull(this.collection), 16).isEmpty() && this.keyIterator.remove();
    --this.this$01.totalSize;
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$Itr_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/Itr', 731);
function AbstractMapBasedMultimap$1(this$0) {
    AbstractMapBasedMultimap$Itr.call(this, this$0);
}
defineClass(1093, 731, $intern_6, AbstractMapBasedMultimap$1);
_.output = function output_0(key, value_0) {
    return value_0;
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$1_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/1', 1093);
function AbstractMapBasedMultimap$1methodref$spliterator$Type() {}
defineClass(1094, 1, {}, AbstractMapBasedMultimap$1methodref$spliterator$Type);
_.apply_0 = function apply_2(arg0) {
    return castTo(arg0, 16).spliterator_0();
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$1methodref$spliterator$Type_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/1methodref$spliterator$Type', 1094);
function AbstractMapBasedMultimap$2(this$0) {
    AbstractMapBasedMultimap$Itr.call(this, this$0);
}
defineClass(1095, 731, $intern_6, AbstractMapBasedMultimap$2);
_.output = function output_1(key, value_0) {
    return new ImmutableEntry(key, value_0);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$2_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/2', 1095);
function $forEach_2(this$static, consumer) {
    var entry, entry$iterator;
    checkCriticalNotNull(consumer);
    for(entry$iterator = this$static.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        consumer.accept_1(entry.getKey(), entry.getValue());
    }
}
var Ljava_util_Map_2_classLit = createForInterface('java.util', 'Map');
function $containsEntry_0(this$static, entry) {
    var key, ourValue, value_0;
    key = entry.getKey();
    value_0 = entry.getValue();
    ourValue = this$static.get_3(key);
    if (!(maskUndefined(value_0) === maskUndefined(ourValue) || value_0 != null && equals_Ljava_lang_Object__Z__devirtual$(value_0, ourValue))) return false;
    if (ourValue == null && !this$static.containsKey(key)) return false;
    return true;
}
function $implFindEntry(this$static, key, remove) {
    var entry, iter, k;
    for(iter = this$static.entrySet_0().iterator_0(); iter.hasNext_0();){
        entry = castTo(iter.next_1(), 43);
        k = entry.getKey();
        if (maskUndefined(key) === maskUndefined(k) || key != null && equals_Ljava_lang_Object__Z__devirtual$(key, k)) {
            if (remove) {
                entry = new AbstractMap$SimpleEntry(entry.getKey(), entry.getValue());
                iter.remove();
            }
            return entry;
        }
    }
    return null;
}
function $putAll(this$static, map_0) {
    var e, e$iterator;
    checkCriticalNotNull(map_0);
    for(e$iterator = map_0.entrySet_0().iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 43);
        this$static.put(e.getKey(), e.getValue());
    }
}
function $toString_0(this$static) {
    var entry, entry$iterator, joiner;
    joiner = new StringJoiner(', ', '{', '}');
    for(entry$iterator = this$static.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        $add_9(joiner, $toString_1(this$static, entry.getKey()) + '=' + $toString_1(this$static, entry.getValue()));
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function $toString_1(this$static, o) {
    return maskUndefined(o) === maskUndefined(this$static) ? '(this Map)' : o == null ? 'null' : toString_40(o);
}
function getEntryKeyOrNull(entry) {
    return !entry ? null : entry.key;
}
function getEntryValueOrNull(entry) {
    return !entry ? null : entry.getValue();
}
defineClass(2011, 1, $intern_7);
_.forEach = function forEach(consumer) {
    $forEach_2(this, consumer);
};
_.clear_0 = function clear_1() {
    this.entrySet_0().clear_0();
};
_.containsEntry = function containsEntry(entry) {
    return $containsEntry_0(this, entry);
};
_.containsKey = function containsKey_0(key) {
    return !!$implFindEntry(this, key, false);
};
_.containsValue = function containsValue(value_0) {
    var entry, entry$iterator, v;
    for(entry$iterator = this.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        v = entry.getValue();
        if (maskUndefined(value_0) === maskUndefined(v) || value_0 != null && equals_Ljava_lang_Object__Z__devirtual$(value_0, v)) return true;
    }
    return false;
};
_.equals_0 = function equals_5(obj) {
    var entry, entry$iterator, otherMap;
    if (obj === this) return true;
    if (!instanceOf(obj, 91)) return false;
    otherMap = castTo(obj, 91);
    if (this.size_1() != otherMap.size_1()) return false;
    for(entry$iterator = otherMap.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        if (!this.containsEntry(entry)) return false;
    }
    return true;
};
_.get_3 = function get_3(key) {
    return getEntryValueOrNull($implFindEntry(this, key, false));
};
_.hashCode_1 = function hashCode_5() {
    return hashCode_48(this.entrySet_0());
};
_.isEmpty = function isEmpty_0() {
    return this.size_1() == 0;
};
_.keySet_0 = function keySet_1() {
    return new AbstractMap$1(this);
};
_.put = function put(key, value_0) {
    throw toJs(new UnsupportedOperationException_0('Put not supported on this map'));
};
_.putAll = function putAll(map_0) {
    $putAll(this, map_0);
};
_.remove_0 = function remove_3(key) {
    return getEntryValueOrNull($implFindEntry(this, key, true));
};
_.size_1 = function size_2() {
    return this.entrySet_0().size_1();
};
_.toString_0 = function toString_6() {
    return $toString_0(this);
};
_.values_0 = function values_1() {
    return new AbstractMap$2(this);
};
var Ljava_util_AbstractMap_2_classLit = createForClass('java.util', 'AbstractMap', 2011);
function $entrySet(this$static) {
    var result;
    result = this$static.entrySet;
    return !result ? this$static.entrySet = this$static.createEntrySet() : result;
}
defineClass(2031, 2011, $intern_7);
_.createKeySet = function createKeySet_0() {
    return new Maps$KeySet(this);
};
_.entrySet_0 = function entrySet() {
    return $entrySet(this);
};
_.keySet_0 = function keySet_2() {
    var result;
    result = this.keySet;
    return !result ? this.keySet = this.createKeySet() : result;
};
_.values_0 = function values_2() {
    var result;
    result = this.values;
    return !result ? this.values = new Maps$Values(this) : result;
};
var Lcom_google_common_collect_Maps$ViewCachingAbstractMap_2_classLit = createForClass('com.google.common.collect', 'Maps/ViewCachingAbstractMap', 2031);
function $get_0(this$static, key) {
    var collection, k;
    collection = castTo(safeGet(this$static.submap, key), 16);
    if (!collection) return null;
    k = key;
    return this$static.this$01_1.wrapCollection(k, collection);
}
function $remove_1(this$static, key) {
    var collection, output;
    collection = castTo(this$static.submap.remove_0(key), 16);
    if (!collection) return null;
    output = this$static.this$01_1.createCollection();
    output.addAll(collection);
    this$static.this$01_1.totalSize -= collection.size_1();
    collection.clear_0();
    return output;
}
function $wrapEntry(this$static, entry) {
    var key;
    key = entry.getKey();
    return new ImmutableEntry(key, this$static.this$01_1.wrapCollection(key, castTo(entry.getValue(), 16)));
}
function AbstractMapBasedMultimap$AsMap(this$0, submap) {
    this.this$01_1 = this$0;
    this.submap = submap;
}
defineClass(393, 2031, $intern_7, AbstractMapBasedMultimap$AsMap);
_.get_3 = function get_4(key) {
    return $get_0(this, key);
};
_.remove_0 = function remove_4(key) {
    return $remove_1(this, key);
};
_.clear_0 = function clear_2() {
    this.submap == this.this$01_1.map_0 ? this.this$01_1.clear_0() : clear_20(new AbstractMapBasedMultimap$AsMap$AsMapIterator(this));
};
_.containsKey = function containsKey_1(key) {
    return safeContainsKey(this.submap, key);
};
_.createEntrySet_0 = function createEntrySet() {
    return new AbstractMapBasedMultimap$AsMap$AsMapEntries(this);
};
_.createEntrySet = function() {
    return this.createEntrySet_0();
};
_.equals_0 = function equals_6(object) {
    return this === object || equals_Ljava_lang_Object__Z__devirtual$(this.submap, object);
};
_.hashCode_1 = function hashCode_6() {
    return hashCode__I__devirtual$(this.submap);
};
_.keySet_0 = function keySet_3() {
    return this.this$01_1.keySet_0();
};
_.size_1 = function size_3() {
    return this.submap.size_1();
};
_.toString_0 = function toString_7() {
    return toString_40(this.submap);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$AsMap_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/AsMap', 393);
function $forEach_0(this$static, action) {
    var t, t$iterator;
    checkCriticalNotNull(action);
    for(t$iterator = this$static.iterator_0(); t$iterator.hasNext_0();){
        t = t$iterator.next_1();
        action.accept(t);
    }
}
var Ljava_lang_Iterable_2_classLit = createForInterface('java.lang', 'Iterable');
function $addAll(this$static, c) {
    var changed, e, e$iterator;
    checkCriticalNotNull(c);
    changed = false;
    for(e$iterator = c.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        changed = changed | this$static.add_2(e);
    }
    return changed;
}
function $advanceToFind(this$static, o, remove) {
    var e, iter;
    for(iter = this$static.iterator_0(); iter.hasNext_0();){
        e = iter.next_1();
        if (maskUndefined(o) === maskUndefined(e) || o != null && equals_Ljava_lang_Object__Z__devirtual$(o, e)) {
            remove && iter.remove();
            return true;
        }
    }
    return false;
}
function $clear_0(this$static) {
    var iter;
    for(iter = this$static.iterator_0(); iter.hasNext_0();){
        iter.next_1();
        iter.remove();
    }
}
function $containsAll(this$static, c) {
    var e, e$iterator;
    checkCriticalNotNull(c);
    for(e$iterator = c.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        if (!this$static.contains(e)) return false;
    }
    return true;
}
function $removeAll_0(this$static, c) {
    var changed, iter, o;
    checkCriticalNotNull(c);
    changed = false;
    for(iter = new ArrayList$1(this$static); iter.i < iter.this$01.array.length;){
        o = $next_6(iter);
        if (c.contains(o)) {
            $remove_13(iter);
            changed = true;
        }
    }
    return changed;
}
function $toArray(this$static) {
    return this$static.toArray_0(initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, this$static.size_1(), 5, 1));
}
function $toArray_0(this$static, a) {
    var i, it, result, size_0;
    size_0 = this$static.size_1();
    a.length < size_0 && (a = stampJavaTypeInfo_1(new Array(size_0), a));
    result = a;
    it = this$static.iterator_0();
    for(i = 0; i < size_0; ++i)setCheck(result, i, it.next_1());
    a.length > size_0 && setCheck(a, size_0, null);
    return a;
}
function $toString_2(this$static) {
    var e, e$iterator, joiner;
    joiner = new StringJoiner(', ', '[', ']');
    for(e$iterator = this$static.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        $add_9(joiner, maskUndefined(e) === maskUndefined(this$static) ? '(this Collection)' : e == null ? 'null' : toString_40(e));
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
defineClass(31, 1, $intern_8);
_.forEach_0 = function forEach_0(action) {
    $forEach_0(this, action);
};
_.spliterator_0 = function spliterator_0() {
    return new Spliterators$IteratorSpliterator(this, 0);
};
_.stream = function stream_0() {
    return new StreamImpl(null, this.spliterator_0());
};
_.add_2 = function add_2(o) {
    throw toJs(new UnsupportedOperationException_0('Add not supported on this collection'));
};
_.addAll = function addAll(c) {
    return $addAll(this, c);
};
_.clear_0 = function clear_3() {
    $clear_0(this);
};
_.contains = function contains(o) {
    return $advanceToFind(this, o, false);
};
_.containsAll = function containsAll(c) {
    return $containsAll(this, c);
};
_.isEmpty = function isEmpty_1() {
    return this.size_1() == 0;
};
_.remove_1 = function remove_5(o) {
    return $advanceToFind(this, o, true);
};
_.toArray = function toArray() {
    return $toArray(this);
};
_.toArray_0 = function toArray_0(a) {
    return $toArray_0(this, a);
};
_.toString_0 = function toString_8() {
    return $toString_2(this);
};
var Ljava_util_AbstractCollection_2_classLit = createForClass('java.util', 'AbstractCollection', 31);
var Ljava_util_Set_2_classLit = createForInterface('java.util', 'Set');
function $equals_0(this$static, o) {
    var other;
    if (maskUndefined(o) === maskUndefined(this$static)) return true;
    if (!instanceOf(o, 22)) return false;
    other = castTo(o, 22);
    if (other.size_1() != this$static.size_1()) return false;
    return this$static.containsAll(other);
}
function $removeAll_1(this$static, c) {
    var iter, o, o$iterator, size_0;
    checkCriticalNotNull(c);
    size_0 = this$static.map_0.size_1();
    if (size_0 < c.size_1()) for(iter = this$static.map_0.keySet_0().iterator_0(); iter.hasNext_0();){
        o = iter.next_1();
        c.contains(o) && iter.remove();
    }
    else for(o$iterator = c.iterator_0(); o$iterator.hasNext_0();){
        o = o$iterator.next_1();
        this$static.map_0.remove_0(o);
    }
    return size_0 != this$static.map_0.size_1();
}
defineClass($intern_9, 31, $intern_10);
_.spliterator_0 = function spliterator_1() {
    return new Spliterators$IteratorSpliterator(this, 1);
};
_.equals_0 = function equals_7(o) {
    return $equals_0(this, o);
};
_.hashCode_1 = function hashCode_7() {
    return hashCode_48(this);
};
var Ljava_util_AbstractSet_2_classLit = createForClass('java.util', 'AbstractSet', $intern_9);
defineClass(2014, $intern_9, $intern_10);
var Lcom_google_common_collect_Sets$ImprovedAbstractSet_2_classLit = createForClass('com.google.common.collect', 'Sets/ImprovedAbstractSet', 2014);
function $contains(this$static, o) {
    var entry, key, value_0;
    if (instanceOf(o, 43)) {
        entry = castTo(o, 43);
        key = entry.getKey();
        value_0 = safeGet(this$static.map_1(), key);
        return equal(value_0, entry.getValue()) && (value_0 != null || this$static.map_1().containsKey(key));
    }
    return false;
}
defineClass(2015, 2014, $intern_10);
_.clear_0 = function clear_4() {
    this.map_1().clear_0();
};
_.contains = function contains_0(o) {
    return $contains(this, o);
};
_.isEmpty = function isEmpty_2() {
    return this.map_1().isEmpty();
};
_.remove_1 = function remove_6(o) {
    var entry;
    if (this.contains(o) && instanceOf(o, 43)) {
        entry = castTo(o, 43);
        return this.map_1().keySet_0().remove_1(entry.getKey());
    }
    return false;
};
_.size_1 = function size_4() {
    return this.map_1().size_1();
};
var Lcom_google_common_collect_Maps$EntrySet_2_classLit = createForClass('com.google.common.collect', 'Maps/EntrySet', 2015);
function AbstractMapBasedMultimap$AsMap$AsMapEntries(this$1) {
    this.this$11 = this$1;
}
defineClass(1091, 2015, $intern_10, AbstractMapBasedMultimap$AsMap$AsMapEntries);
_.contains = function contains_1(o) {
    return safeContains(this.this$11.submap.entrySet_0(), o);
};
_.iterator_0 = function iterator_0() {
    return new AbstractMapBasedMultimap$AsMap$AsMapIterator(this.this$11);
};
_.map_1 = function map_1() {
    return this.this$11;
};
_.remove_1 = function remove_7(o) {
    var entry;
    if (!safeContains(this.this$11.submap.entrySet_0(), o)) return false;
    entry = castTo(requireNonNull(castTo(o, 43)), 43);
    $removeValuesForKey(this.this$11.this$01_1, entry.getKey());
    return true;
};
_.spliterator_0 = function spliterator_2() {
    return map_2(this.this$11.submap.entrySet_0().spliterator_0(), new AbstractMapBasedMultimap$AsMap$AsMapEntries$0methodref$wrapEntry$Type(this.this$11));
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$AsMap$AsMapEntries_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/AsMap/AsMapEntries', 1091);
function AbstractMapBasedMultimap$AsMap$AsMapEntries$0methodref$wrapEntry$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1092, 1, {}, AbstractMapBasedMultimap$AsMap$AsMapEntries$0methodref$wrapEntry$Type);
_.apply_0 = function apply_3(arg0) {
    return $wrapEntry(this.$$outer_0, castTo(arg0, 43));
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$AsMap$AsMapEntries$0methodref$wrapEntry$Type_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/AsMap/AsMapEntries/0methodref$wrapEntry$Type', 1092);
function AbstractMapBasedMultimap$AsMap$AsMapIterator(this$1) {
    this.this$11 = this$1;
    this.delegateIterator = this.this$11.submap.entrySet_0().iterator_0();
}
defineClass(729, 1, $intern_6, AbstractMapBasedMultimap$AsMap$AsMapIterator);
_.forEachRemaining = function forEachRemaining_1(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_3() {
    var entry;
    return entry = castTo(this.delegateIterator.next_1(), 43), this.collection = castTo(entry.getValue(), 16), $wrapEntry(this.this$11, entry);
};
_.hasNext_0 = function hasNext_2() {
    return this.delegateIterator.hasNext_0();
};
_.remove = function remove_8() {
    checkState_0(!!this.collection);
    this.delegateIterator.remove();
    this.this$11.this$01_1.totalSize -= this.collection.size_1();
    this.collection.clear_0();
    this.collection = null;
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$AsMap$AsMapIterator_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/AsMap/AsMapIterator', 729);
function Maps$KeySet(map_0) {
    this.map_0 = castTo(checkNotNull(map_0), 91);
}
defineClass(527, 2014, $intern_10, Maps$KeySet);
_.clear_0 = function clear_5() {
    this.map_0.clear_0();
};
_.contains = function contains_2(o) {
    return this.map_0.containsKey(o);
};
_.forEach_0 = function forEach_1(action) {
    checkNotNull(action);
    this.map_0.forEach(new Maps$KeySet$lambda$0$Type(action));
};
_.isEmpty = function isEmpty_3() {
    return this.map_0.isEmpty();
};
_.iterator_0 = function iterator_1() {
    return new Maps$1(this.map_0.entrySet_0().iterator_0());
};
_.remove_1 = function remove_9(o) {
    if (this.map_0.containsKey(o)) {
        this.map_0.remove_0(o);
        return true;
    }
    return false;
};
_.size_1 = function size_5() {
    return this.map_0.size_1();
};
var Lcom_google_common_collect_Maps$KeySet_2_classLit = createForClass('com.google.common.collect', 'Maps/KeySet', 527);
function AbstractMapBasedMultimap$KeySet(this$0, subMap) {
    this.this$01 = this$0;
    Maps$KeySet.call(this, subMap);
}
defineClass(327, 527, $intern_10, AbstractMapBasedMultimap$KeySet);
_.clear_0 = function clear_6() {
    var entryIterator;
    clear_20((entryIterator = this.map_0.entrySet_0().iterator_0(), new AbstractMapBasedMultimap$KeySet$1(this, entryIterator)));
};
_.containsAll = function containsAll_0(c) {
    return this.map_0.keySet_0().containsAll(c);
};
_.equals_0 = function equals_8(object) {
    return this === object || equals_Ljava_lang_Object__Z__devirtual$(this.map_0.keySet_0(), object);
};
_.hashCode_1 = function hashCode_8() {
    return hashCode__I__devirtual$(this.map_0.keySet_0());
};
_.iterator_0 = function iterator_2() {
    var entryIterator;
    return entryIterator = this.map_0.entrySet_0().iterator_0(), new AbstractMapBasedMultimap$KeySet$1(this, entryIterator);
};
_.remove_1 = function remove_10(key) {
    var collection, count;
    count = 0;
    collection = castTo(this.map_0.remove_0(key), 16);
    if (collection) {
        count = collection.size_1();
        collection.clear_0();
        this.this$01.totalSize -= count;
    }
    return count > 0;
};
_.spliterator_0 = function spliterator_3() {
    return this.map_0.keySet_0().spliterator_0();
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$KeySet_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/KeySet', 327);
function AbstractMapBasedMultimap$KeySet$1(this$1, val$entryIterator) {
    this.this$11 = this$1;
    this.val$entryIterator2 = val$entryIterator;
}
defineClass(730, 1, $intern_6, AbstractMapBasedMultimap$KeySet$1);
_.forEachRemaining = function forEachRemaining_2(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_3() {
    return this.val$entryIterator2.hasNext_0();
};
_.next_1 = function next_4() {
    this.entry = castTo(this.val$entryIterator2.next_1(), 43);
    return this.entry.getKey();
};
_.remove = function remove_11() {
    var collection;
    checkState_0(!!this.entry);
    collection = castTo(this.entry.getValue(), 16);
    this.val$entryIterator2.remove();
    this.this$11.this$01.totalSize -= collection.size_1();
    collection.clear_0();
    this.entry = null;
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$KeySet$1_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/KeySet/1', 730);
function AbstractMapBasedMultimap$SortedAsMap(this$0, submap) {
    this.this$01_0 = this$0;
    AbstractMapBasedMultimap$AsMap.call(this, this$0, submap);
}
defineClass(487, 393, {
    91: 1,
    134: 1
}, AbstractMapBasedMultimap$SortedAsMap);
_.createKeySet = function createKeySet_1() {
    return this.createKeySet_0();
};
_.keySet_0 = function keySet_4() {
    return this.keySet_1();
};
_.createKeySet_0 = function createKeySet_2() {
    return new AbstractMapBasedMultimap$SortedKeySet(this.this$01_0, this.sortedMap());
};
_.firstKey = function firstKey() {
    return this.sortedMap().firstKey();
};
_.keySet_1 = function keySet_5() {
    var result;
    return result = this.sortedKeySet, !result ? this.sortedKeySet = this.createKeySet_0() : result;
};
_.lastKey = function lastKey() {
    return this.sortedMap().lastKey();
};
_.sortedMap = function sortedMap() {
    return castTo(this.submap, 134);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$SortedAsMap_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/SortedAsMap', 487);
function AbstractMapBasedMultimap$NavigableAsMap(this$0, submap) {
    this.this$01 = this$0;
    AbstractMapBasedMultimap$SortedAsMap.call(this, this$0, submap);
}
defineClass(434, 487, $intern_11, AbstractMapBasedMultimap$NavigableAsMap);
_.createKeySet = function createKeySet_3() {
    return new AbstractMapBasedMultimap$NavigableKeySet(this.this$01, castTo(castTo(this.submap, 134), 137));
};
_.createKeySet_0 = function createKeySet_4() {
    return new AbstractMapBasedMultimap$NavigableKeySet(this.this$01, castTo(castTo(this.submap, 134), 137));
};
_.keySet_0 = function keySet_6() {
    var result;
    return result = this.sortedKeySet, castTo(!result ? this.sortedKeySet = new AbstractMapBasedMultimap$NavigableKeySet(this.this$01, castTo(castTo(this.submap, 134), 137)) : result, 274);
};
_.keySet_1 = function keySet_7() {
    var result;
    return result = this.sortedKeySet, castTo(!result ? this.sortedKeySet = new AbstractMapBasedMultimap$NavigableKeySet(this.this$01, castTo(castTo(this.submap, 134), 137)) : result, 274);
};
_.sortedMap = function sortedMap_0() {
    return castTo(castTo(this.submap, 134), 137);
};
_.ceilingKey = function ceilingKey(key) {
    return castTo(castTo(this.submap, 134), 137).ceilingKey(key);
};
_.floorKey = function floorKey(key) {
    return castTo(castTo(this.submap, 134), 137).floorKey(key);
};
_.headMap = function headMap(toKey, inclusive) {
    return new AbstractMapBasedMultimap$NavigableAsMap(this.this$01, castTo(castTo(this.submap, 134), 137).headMap(toKey, inclusive));
};
_.higherKey = function higherKey(key) {
    return castTo(castTo(this.submap, 134), 137).higherKey(key);
};
_.lowerKey = function lowerKey(key) {
    return castTo(castTo(this.submap, 134), 137).lowerKey(key);
};
_.tailMap = function tailMap(fromKey, inclusive) {
    return new AbstractMapBasedMultimap$NavigableAsMap(this.this$01, castTo(castTo(this.submap, 134), 137).tailMap(fromKey, inclusive));
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$NavigableAsMap_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/NavigableAsMap', 434);
function AbstractMapBasedMultimap$SortedKeySet(this$0, subMap) {
    AbstractMapBasedMultimap$KeySet.call(this, this$0, subMap);
}
defineClass(486, 327, $intern_12, AbstractMapBasedMultimap$SortedKeySet);
_.spliterator_0 = function spliterator_4() {
    return this.map_0.keySet_0().spliterator_0();
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$SortedKeySet_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/SortedKeySet', 486);
function AbstractMapBasedMultimap$NavigableKeySet(this$0, subMap) {
    AbstractMapBasedMultimap$SortedKeySet.call(this, this$0, subMap);
}
defineClass(392, 486, $intern_13, AbstractMapBasedMultimap$NavigableKeySet);
var Lcom_google_common_collect_AbstractMapBasedMultimap$NavigableKeySet_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/NavigableKeySet', 392);
function $addToMap(this$static) {
    this$static.ancestor ? $addToMap(this$static.ancestor) : this$static.this$01_0.map_0.put(this$static.key, this$static.delegate);
}
function $refreshIfEmpty(this$static) {
    var newDelegate;
    if (this$static.ancestor) {
        $refreshIfEmpty(this$static.ancestor);
        if (this$static.ancestor.delegate != this$static.ancestorDelegate) throw toJs(new ConcurrentModificationException);
    } else if (this$static.delegate.isEmpty()) {
        newDelegate = castTo(this$static.this$01_0.map_0.get_3(this$static.key), 16);
        !!newDelegate && (this$static.delegate = newDelegate);
    }
}
function $removeIfEmpty(this$static) {
    this$static.ancestor ? $removeIfEmpty(this$static.ancestor) : this$static.delegate.isEmpty() && this$static.this$01_0.map_0.remove_0(this$static.key);
}
function $size(this$static) {
    $refreshIfEmpty(this$static);
    return this$static.delegate.size_1();
}
function AbstractMapBasedMultimap$WrappedCollection(this$0, key, delegate, ancestor) {
    this.this$01_0 = this$0;
    this.key = key;
    this.delegate = delegate;
    this.ancestor = ancestor;
    this.ancestorDelegate = !ancestor ? null : ancestor.delegate;
}
defineClass(536, 31, $intern_8, AbstractMapBasedMultimap$WrappedCollection);
_.add_2 = function add_3(value_0) {
    var changed, wasEmpty;
    $refreshIfEmpty(this);
    wasEmpty = this.delegate.isEmpty();
    changed = this.delegate.add_2(value_0);
    if (changed) {
        ++this.this$01_0.totalSize;
        wasEmpty && $addToMap(this);
    }
    return changed;
};
_.addAll = function addAll_0(collection) {
    var changed, newSize, oldSize;
    if (collection.isEmpty()) return false;
    oldSize = ($refreshIfEmpty(this), this.delegate.size_1());
    changed = this.delegate.addAll(collection);
    if (changed) {
        newSize = this.delegate.size_1();
        this.this$01_0.totalSize += newSize - oldSize;
        oldSize == 0 && $addToMap(this);
    }
    return changed;
};
_.clear_0 = function clear_7() {
    var oldSize;
    oldSize = ($refreshIfEmpty(this), this.delegate.size_1());
    if (oldSize == 0) return;
    this.delegate.clear_0();
    this.this$01_0.totalSize -= oldSize;
    $removeIfEmpty(this);
};
_.contains = function contains_3(o) {
    $refreshIfEmpty(this);
    return this.delegate.contains(o);
};
_.containsAll = function containsAll_1(c) {
    $refreshIfEmpty(this);
    return this.delegate.containsAll(c);
};
_.equals_0 = function equals_9(object) {
    if (object === this) return true;
    $refreshIfEmpty(this);
    return equals_Ljava_lang_Object__Z__devirtual$(this.delegate, object);
};
_.hashCode_1 = function hashCode_9() {
    $refreshIfEmpty(this);
    return hashCode__I__devirtual$(this.delegate);
};
_.iterator_0 = function iterator_3() {
    $refreshIfEmpty(this);
    return new AbstractMapBasedMultimap$WrappedCollection$WrappedIterator(this);
};
_.remove_1 = function remove_12(o) {
    var changed;
    $refreshIfEmpty(this);
    changed = this.delegate.remove_1(o);
    if (changed) {
        --this.this$01_0.totalSize;
        $removeIfEmpty(this);
    }
    return changed;
};
_.size_1 = function size_6() {
    return $size(this);
};
_.spliterator_0 = function spliterator_5() {
    return $refreshIfEmpty(this), this.delegate.spliterator_0();
};
_.toString_0 = function toString_9() {
    $refreshIfEmpty(this);
    return toString_40(this.delegate);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedCollection_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedCollection', 536);
function $sort_0(this$static, c) {
    var a, i;
    a = this$static.toArray();
    mergeSort(a, 0, a.length, c);
    for(i = 0; i < a.length; i++)this$static.set_2(i, a[i]);
}
var Ljava_util_List_2_classLit = createForInterface('java.util', 'List');
function AbstractMapBasedMultimap$WrappedList(this$0, key, delegate, ancestor) {
    this.this$01 = this$0;
    AbstractMapBasedMultimap$WrappedCollection.call(this, this$0, key, delegate, ancestor);
}
defineClass(727, 536, {
    20: 1,
    31: 1,
    16: 1,
    15: 1
}, AbstractMapBasedMultimap$WrappedList);
_.sort_0 = function sort_0(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_6() {
    return $refreshIfEmpty(this), this.delegate.spliterator_0();
};
_.add_3 = function add_4(index_0, element) {
    var wasEmpty;
    $refreshIfEmpty(this);
    wasEmpty = this.delegate.isEmpty();
    castTo(this.delegate, 15).add_3(index_0, element);
    ++this.this$01.totalSize;
    wasEmpty && $addToMap(this);
};
_.addAll_0 = function addAll_1(index_0, c) {
    var changed, newSize, oldSize;
    if (c.isEmpty()) return false;
    oldSize = ($refreshIfEmpty(this), this.delegate.size_1());
    changed = castTo(this.delegate, 15).addAll_0(index_0, c);
    if (changed) {
        newSize = this.delegate.size_1();
        this.this$01.totalSize += newSize - oldSize;
        oldSize == 0 && $addToMap(this);
    }
    return changed;
};
_.get_0 = function get_5(index_0) {
    $refreshIfEmpty(this);
    return castTo(this.delegate, 15).get_0(index_0);
};
_.indexOf_0 = function indexOf(o) {
    $refreshIfEmpty(this);
    return castTo(this.delegate, 15).indexOf_0(o);
};
_.listIterator_0 = function listIterator() {
    $refreshIfEmpty(this);
    return new AbstractMapBasedMultimap$WrappedList$WrappedListIterator(this);
};
_.listIterator_1 = function listIterator_0(index_0) {
    $refreshIfEmpty(this);
    return new AbstractMapBasedMultimap$WrappedList$WrappedListIterator_0(this, index_0);
};
_.remove_2 = function remove_13(index_0) {
    var value_0;
    $refreshIfEmpty(this);
    value_0 = castTo(this.delegate, 15).remove_2(index_0);
    --this.this$01.totalSize;
    $removeIfEmpty(this);
    return value_0;
};
_.set_2 = function set_2(index_0, element) {
    $refreshIfEmpty(this);
    return castTo(this.delegate, 15).set_2(index_0, element);
};
_.subList = function subList_0(fromIndex, toIndex) {
    $refreshIfEmpty(this);
    return $wrapList(this.this$01, this.key, castTo(this.delegate, 15).subList(fromIndex, toIndex), !this.ancestor ? this : this.ancestor);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedList_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedList', 727);
function AbstractMapBasedMultimap$RandomAccessWrappedList(this$0, key, delegate, ancestor) {
    AbstractMapBasedMultimap$WrappedList.call(this, this$0, key, delegate, ancestor);
}
defineClass(1090, 727, {
    20: 1,
    31: 1,
    16: 1,
    15: 1,
    59: 1
}, AbstractMapBasedMultimap$RandomAccessWrappedList);
var Lcom_google_common_collect_AbstractMapBasedMultimap$RandomAccessWrappedList_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/RandomAccessWrappedList', 1090);
function $$init(this$static) {
    this$static.originalDelegate = this$static.this$11_0.delegate;
}
function $remove_2(this$static) {
    this$static.delegateIterator.remove();
    --this$static.this$11_0.this$01_0.totalSize;
    $removeIfEmpty(this$static.this$11_0);
}
function $validateIterator(this$static) {
    $refreshIfEmpty(this$static.this$11_0);
    if (this$static.this$11_0.delegate != this$static.originalDelegate) throw toJs(new ConcurrentModificationException);
}
function AbstractMapBasedMultimap$WrappedCollection$WrappedIterator(this$1) {
    this.this$11_0 = this$1;
    $$init(this);
    this.delegateIterator = iteratorOrListIterator(this$1.delegate);
}
function AbstractMapBasedMultimap$WrappedCollection$WrappedIterator_0(this$1, delegateIterator) {
    this.this$11_0 = this$1;
    $$init(this);
    this.delegateIterator = delegateIterator;
}
defineClass(613, 1, $intern_6, AbstractMapBasedMultimap$WrappedCollection$WrappedIterator);
_.forEachRemaining = function forEachRemaining_3(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_4() {
    $validateIterator(this);
    return this.delegateIterator.hasNext_0();
};
_.next_1 = function next_5() {
    $validateIterator(this);
    return this.delegateIterator.next_1();
};
_.remove = function remove_14() {
    $remove_2(this);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedCollection$WrappedIterator_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedCollection/WrappedIterator', 613);
function AbstractMapBasedMultimap$WrappedList$WrappedListIterator(this$1) {
    this.this$11 = this$1;
    AbstractMapBasedMultimap$WrappedCollection$WrappedIterator.call(this, this$1);
}
function AbstractMapBasedMultimap$WrappedList$WrappedListIterator_0(this$1, index_0) {
    this.this$11 = this$1;
    AbstractMapBasedMultimap$WrappedCollection$WrappedIterator_0.call(this, this$1, castTo(this$1.delegate, 15).listIterator_1(index_0));
}
defineClass(728, 613, $intern_14, AbstractMapBasedMultimap$WrappedList$WrappedListIterator, AbstractMapBasedMultimap$WrappedList$WrappedListIterator_0);
_.remove = function remove_15() {
    $remove_2(this);
};
_.add_1 = function add_5(value_0) {
    var wasEmpty;
    wasEmpty = $size(this.this$11) == 0;
    ($validateIterator(this), castTo(this.delegateIterator, 127)).add_1(value_0);
    ++this.this$11.this$01.totalSize;
    wasEmpty && $addToMap(this.this$11);
};
_.hasPrevious = function hasPrevious_0() {
    return ($validateIterator(this), castTo(this.delegateIterator, 127)).hasPrevious();
};
_.nextIndex_0 = function nextIndex_1() {
    return ($validateIterator(this), castTo(this.delegateIterator, 127)).nextIndex_0();
};
_.previous_0 = function previous_1() {
    return ($validateIterator(this), castTo(this.delegateIterator, 127)).previous_0();
};
_.previousIndex = function previousIndex_0() {
    return ($validateIterator(this), castTo(this.delegateIterator, 127)).previousIndex();
};
_.set_1 = function set_3(value_0) {
    ($validateIterator(this), castTo(this.delegateIterator, 127)).set_1(value_0);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedList$WrappedListIterator_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedList/WrappedListIterator', 728);
function AbstractMapBasedMultimap$WrappedSortedSet(this$0, key, delegate) {
    AbstractMapBasedMultimap$WrappedCollection.call(this, this$0, key, delegate, null);
}
defineClass(726, 536, $intern_12, AbstractMapBasedMultimap$WrappedSortedSet);
_.spliterator_0 = function spliterator_7() {
    return $refreshIfEmpty(this), this.delegate.spliterator_0();
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedSortedSet_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedSortedSet', 726);
function AbstractMapBasedMultimap$WrappedNavigableSet(this$0, key, delegate) {
    AbstractMapBasedMultimap$WrappedSortedSet.call(this, this$0, key, delegate);
}
defineClass(1089, 726, $intern_13, AbstractMapBasedMultimap$WrappedNavigableSet);
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedNavigableSet_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedNavigableSet', 1089);
function AbstractMapBasedMultimap$WrappedSet(this$0, key, delegate) {
    AbstractMapBasedMultimap$WrappedCollection.call(this, this$0, key, delegate, null);
}
defineClass(1088, 536, $intern_10, AbstractMapBasedMultimap$WrappedSet);
_.spliterator_0 = function spliterator_8() {
    return $refreshIfEmpty(this), this.delegate.spliterator_0();
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$WrappedSet_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/WrappedSet', 1088);
function AbstractMapBasedMultimap$lambda$1$Type() {}
defineClass(1097, 1, {}, AbstractMapBasedMultimap$lambda$1$Type);
_.apply_0 = function apply_4(arg0) {
    return lambda$1(castTo(arg0, 43));
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/lambda$1$Type', 1097);
function AbstractMapBasedMultimap$lambda$2$Type(key_0) {
    this.key_0 = key_0;
}
defineClass(1096, 1, {}, AbstractMapBasedMultimap$lambda$2$Type);
_.apply_0 = function apply_5(arg0) {
    return new ImmutableEntry(this.key_0, arg0);
};
var Lcom_google_common_collect_AbstractMapBasedMultimap$lambda$2$Type_2_classLit = createForClass('com.google.common.collect', 'AbstractMapBasedMultimap/lambda$2$Type', 1096);
var Ljava_util_Map$Entry_2_classLit = createForInterface('java.util', 'Map/Entry');
defineClass(355, 1, $intern_15);
_.equals_0 = function equals_10(object) {
    var that;
    if (instanceOf(object, 43)) {
        that = castTo(object, 43);
        return equal(this.getKey(), that.getKey()) && equal(this.getValue(), that.getValue());
    }
    return false;
};
_.hashCode_1 = function hashCode_10() {
    var k, v;
    k = this.getKey();
    v = this.getValue();
    return (k == null ? 0 : hashCode__I__devirtual$(k)) ^ (v == null ? 0 : hashCode__I__devirtual$(v));
};
_.setValue = function setValue(value_0) {
    throw toJs(new UnsupportedOperationException);
};
_.toString_0 = function toString_10() {
    return this.getKey() + '=' + this.getValue();
};
var Lcom_google_common_collect_AbstractMapEntry_2_classLit = createForClass('com.google.common.collect', 'AbstractMapEntry', 355);
defineClass(2032, 31, $intern_8);
_.clear_0 = function clear_8() {
    this.multimap_0().clear_0();
};
_.contains = function contains_4(o) {
    var entry;
    if (instanceOf(o, 43)) {
        entry = castTo(o, 43);
        return $containsEntry(this.multimap_0(), entry.getKey(), entry.getValue());
    }
    return false;
};
_.remove_1 = function remove_16(o) {
    var entry;
    if (instanceOf(o, 43)) {
        entry = castTo(o, 43);
        return $remove_0(this.multimap_0(), entry.getKey(), entry.getValue());
    }
    return false;
};
_.size_1 = function size_7() {
    return this.multimap_0().totalSize;
};
var Lcom_google_common_collect_Multimaps$Entries_2_classLit = createForClass('com.google.common.collect', 'Multimaps/Entries', 2032);
function AbstractMultimap$Entries(this$0) {
    this.this$01 = this$0;
}
defineClass(732, 2032, $intern_8, AbstractMultimap$Entries);
_.iterator_0 = function iterator_4() {
    return this.this$01.entryIterator();
};
_.multimap_0 = function multimap_0() {
    return this.this$01;
};
_.spliterator_0 = function spliterator_9() {
    return this.this$01.entrySpliterator();
};
var Lcom_google_common_collect_AbstractMultimap$Entries_2_classLit = createForClass('com.google.common.collect', 'AbstractMultimap/Entries', 732);
function AbstractMultimap$EntrySet(this$0) {
    AbstractMultimap$Entries.call(this, this$0);
}
defineClass(733, 732, $intern_10, AbstractMultimap$EntrySet);
_.spliterator_0 = function spliterator_10() {
    return this.this$01.entrySpliterator();
};
_.equals_0 = function equals_11(obj) {
    return equalsImpl_3(this, obj);
};
_.hashCode_1 = function hashCode_11() {
    return hashCodeImpl_0(this);
};
var Lcom_google_common_collect_AbstractMultimap$EntrySet_2_classLit = createForClass('com.google.common.collect', 'AbstractMultimap/EntrySet', 733);
function AbstractMultimap$Values(this$0) {
    this.this$01 = this$0;
}
defineClass(734, 31, $intern_8, AbstractMultimap$Values);
_.clear_0 = function clear_9() {
    this.this$01.clear_0();
};
_.contains = function contains_5(o) {
    return $containsValue(this.this$01, o);
};
_.iterator_0 = function iterator_5() {
    return this.this$01.valueIterator_0();
};
_.size_1 = function size_8() {
    return this.this$01.totalSize;
};
_.spliterator_0 = function spliterator_11() {
    return this.this$01.valueSpliterator();
};
var Lcom_google_common_collect_AbstractMultimap$Values_2_classLit = createForClass('com.google.common.collect', 'AbstractMultimap/Values', 734);
function lambda$0_1(entry_1) {
    entry_1.val$backingEntry2.getKey();
    castTo(entry_1.val$backingEntry2.getValue(), 16).size_1();
    $add();
}
function lambda$1_0(action_0, entry_1) {
    var count, elem, i;
    elem = entry_1.val$backingEntry2.getKey();
    count = castTo(entry_1.val$backingEntry2.getValue(), 16).size_1();
    for(i = 0; i < count; i++)action_0.accept(elem);
}
function $add() {
    throw toJs(new UnsupportedOperationException);
}
function $entrySet_0(this$static) {
    var result;
    result = this$static.entrySet;
    !result && (this$static.entrySet = result = new AbstractMultiset$EntrySet(this$static));
    return result;
}
function $forEachEntry(this$static, action) {
    checkNotNull(action);
    $entrySet_0(this$static).forEach_0(new Multiset$lambda$0$Type);
}
defineClass(2033, 31, {
    828: 1,
    20: 1,
    31: 1,
    16: 1
});
_.forEach_0 = function forEach_2(action) {
    checkNotNull(action);
    $entrySet_0(this).forEach_0(new Multiset$lambda$1$Type(action));
};
_.spliterator_0 = function spliterator_12() {
    var entrySpliterator;
    return entrySpliterator = $entrySet_0(this).spliterator_0(), flatMap(entrySpliterator, new Multisets$lambda$1$Type, 64 | entrySpliterator.characteristics_0() & 1296, this.multimap.totalSize);
};
_.add_2 = function add_6(element) {
    $add();
    return true;
};
_.addAll = function addAll_2(elementsToAdd) {
    return checkNotNull(this), checkNotNull(elementsToAdd), instanceOf(elementsToAdd, 537) ? addAllImpl(castTo(elementsToAdd, 828)) : !elementsToAdd.isEmpty() && addAll_7(this, elementsToAdd.iterator_0());
};
_.contains = function contains_6(element) {
    var values;
    return values = castTo(safeGet($asMap(this.multimap), element), 16), (!values ? 0 : values.size_1()) > 0;
};
_.equals_0 = function equals_12(object) {
    return equalsImpl_2(this, object);
};
_.hashCode_1 = function hashCode_12() {
    return hashCode__I__devirtual$($entrySet_0(this));
};
_.isEmpty = function isEmpty_4() {
    return $entrySet_0(this).isEmpty();
};
_.remove_1 = function remove_17(element) {
    return $remove_5(this, element, 1) > 0;
};
_.toString_0 = function toString_11() {
    return toString_40($entrySet_0(this));
};
var Lcom_google_common_collect_AbstractMultiset_2_classLit = createForClass('com.google.common.collect', 'AbstractMultiset', 2033);
defineClass(2035, 2014, $intern_10);
_.clear_0 = function clear_10() {
    $clear(this.this$01.multimap);
};
_.contains = function contains_7(o) {
    var count, entry;
    if (instanceOf(o, 488)) {
        entry = castTo(o, 413);
        if (castTo(entry.val$backingEntry2.getValue(), 16).size_1() <= 0) return false;
        count = $count(this.this$01, entry.val$backingEntry2.getKey());
        return count == castTo(entry.val$backingEntry2.getValue(), 16).size_1();
    }
    return false;
};
_.remove_1 = function remove_18(object) {
    var element, entry, entryCount, multiset;
    if (instanceOf(object, 488)) {
        entry = castTo(object, 413);
        element = entry.val$backingEntry2.getKey();
        entryCount = castTo(entry.val$backingEntry2.getValue(), 16).size_1();
        if (entryCount != 0) {
            multiset = this.this$01;
            return setCountImpl(multiset, element, entryCount);
        }
    }
    return false;
};
var Lcom_google_common_collect_Multisets$EntrySet_2_classLit = createForClass('com.google.common.collect', 'Multisets/EntrySet', 2035);
function AbstractMultiset$EntrySet(this$0) {
    this.this$01 = this$0;
}
defineClass(1103, 2035, $intern_10, AbstractMultiset$EntrySet);
_.iterator_0 = function iterator_6() {
    return new Multimaps$Keys$1($entrySet($asMap(this.this$01.multimap)).iterator_0());
};
_.size_1 = function size_9() {
    return $asMap(this.this$01.multimap).size_1();
};
var Lcom_google_common_collect_AbstractMultiset$EntrySet_2_classLit = createForClass('com.google.common.collect', 'AbstractMultiset/EntrySet', 1103);
function AbstractSetMultimap(map_0) {
    AbstractMapBasedMultimap.call(this, map_0);
}
defineClass(612, 725, $intern_5);
_.createCollection = function createCollection_1() {
    return this.createCollection_1();
};
_.createUnmodifiableEmptyCollection = function createUnmodifiableEmptyCollection_1() {
    return this.createUnmodifiableEmptyCollection_0();
};
_.get_1 = function get_6(key) {
    return this.get_4(key);
};
_.removeAll = function removeAll_2(key) {
    return this.removeAll_1(key);
};
_.asMap_0 = function asMap_1() {
    var result;
    return result = this.asMap, !result ? this.asMap = this.createAsMap() : result;
};
_.createUnmodifiableEmptyCollection_0 = function createUnmodifiableEmptyCollection_2() {
    return $clinit_Collections(), $clinit_Collections(), EMPTY_SET;
};
_.equals_0 = function equals_13(object) {
    return equalsImpl_1(this, object);
};
_.get_4 = function get_7(key) {
    return castTo($get(this, key), 22);
};
_.removeAll_1 = function removeAll_3(key) {
    return castTo($removeAll(this, key), 22);
};
_.unmodifiableCollectionSubclass = function unmodifiableCollectionSubclass_1(collection) {
    return $clinit_Collections(), new Collections$UnmodifiableSet(castTo(collection, 22));
};
_.wrapCollection = function wrapCollection_1(key, collection) {
    return new AbstractMapBasedMultimap$WrappedSet(this, key, castTo(collection, 22));
};
var Lcom_google_common_collect_AbstractSetMultimap_2_classLit = createForClass('com.google.common.collect', 'AbstractSetMultimap', 612);
function $values_0(this$static) {
    var result;
    return result = this$static.values, !result ? this$static.values = new AbstractMultimap$Values(this$static) : result;
}
defineClass(1665, 612, $intern_5);
_.createCollection = function createCollection_2() {
    return new TreeSet_0(this.valueComparator);
};
_.createCollection_1 = function createCollection_3() {
    return new TreeSet_0(this.valueComparator);
};
_.createUnmodifiableEmptyCollection = function createUnmodifiableEmptyCollection_3() {
    return unmodifiableNavigableSet(new TreeSet_0(this.valueComparator));
};
_.createUnmodifiableEmptyCollection_0 = function createUnmodifiableEmptyCollection_4() {
    return unmodifiableNavigableSet(new TreeSet_0(this.valueComparator));
};
_.get_1 = function get_8(key) {
    return castTo(castTo($get(this, key), 22), 83);
};
_.get_4 = function get_9(key) {
    return castTo(castTo($get(this, key), 22), 83);
};
_.removeAll = function removeAll_4(key) {
    return castTo(castTo($removeAll(this, key), 22), 83);
};
_.removeAll_1 = function removeAll_5(key) {
    return castTo(castTo($removeAll(this, key), 22), 83);
};
_.unmodifiableCollectionSubclass = function unmodifiableCollectionSubclass_2(collection) {
    return instanceOf(collection, 274) ? unmodifiableNavigableSet(castTo(collection, 274)) : ($clinit_Collections(), new Collections$UnmodifiableSortedSet(castTo(collection, 83)));
};
_.asMap_0 = function asMap_2() {
    var result;
    return result = this.asMap, !result ? this.asMap = instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableAsMap(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedAsMap(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$AsMap(this, this.map_0) : result;
};
_.wrapCollection = function wrapCollection_2(key, collection) {
    return instanceOf(collection, 274) ? new AbstractMapBasedMultimap$WrappedNavigableSet(this, key, castTo(collection, 274)) : new AbstractMapBasedMultimap$WrappedSortedSet(this, key, castTo(collection, 83));
};
var Lcom_google_common_collect_AbstractSortedSetMultimap_2_classLit = createForClass('com.google.common.collect', 'AbstractSortedSetMultimap', 1665);
function AbstractSortedKeySortedSetMultimap(map_0) {
    AbstractSetMultimap.call(this, map_0);
}
defineClass(1666, 1665, $intern_5);
_.asMap_0 = function asMap_3() {
    var result;
    return result = this.asMap, castTo(castTo(!result ? this.asMap = instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableAsMap(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedAsMap(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$AsMap(this, this.map_0) : result, 134), 137);
};
_.keySet_0 = function keySet_8() {
    var result;
    return result = this.keySet, castTo(castTo(!result ? this.keySet = instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableKeySet(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedKeySet(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$KeySet(this, this.map_0) : result, 83), 274);
};
_.createKeySet = function createKeySet_5() {
    return instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableKeySet(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedKeySet(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$KeySet(this, this.map_0);
};
var Lcom_google_common_collect_AbstractSortedKeySortedSetMultimap_2_classLit = createForClass('com.google.common.collect', 'AbstractSortedKeySortedSetMultimap', 1666);
defineClass(2055, 1, {
    1992: 1
});
_.equals_0 = function equals_14(obj) {
    return equalsImpl_4(this, obj);
};
_.hashCode_1 = function hashCode_13() {
    var result;
    return hashCode_48((result = this.cellSet, !result ? this.cellSet = new AbstractTable$CellSet(this) : result));
};
_.toString_0 = function toString_12() {
    var map_0;
    return $toString_0((map_0 = this.rowMap, !map_0 ? this.rowMap = new ArrayTable$RowMap(this) : map_0));
};
var Lcom_google_common_collect_AbstractTable_2_classLit = createForClass('com.google.common.collect', 'AbstractTable', 2055);
function AbstractTable$CellSet(this$0) {
    this.this$01 = this$0;
}
defineClass(664, $intern_9, $intern_10, AbstractTable$CellSet);
_.clear_0 = function clear_11() {
    $clear_1();
};
_.contains = function contains_8(o) {
    var cell, row;
    if (instanceOf(o, 465)) {
        cell = castTo(o, 682);
        row = castTo(safeGet($rowMap(this.this$01), $get_2(cell.this$01.rowList, cell.rowIndex)), 91);
        return !!row && safeContains(row.entrySet_0(), new ImmutableEntry($get_2(cell.this$01.columnList, cell.columnIndex), $at(cell.this$01, cell.rowIndex, cell.columnIndex)));
    }
    return false;
};
_.iterator_0 = function iterator_7() {
    return $cellIterator(this.this$01);
};
_.remove_1 = function remove_19(o) {
    var cell, row;
    if (instanceOf(o, 465)) {
        cell = castTo(o, 682);
        row = castTo(safeGet($rowMap(this.this$01), $get_2(cell.this$01.rowList, cell.rowIndex)), 91);
        return !!row && safeRemove(row.entrySet_0(), new ImmutableEntry($get_2(cell.this$01.columnList, cell.columnIndex), $at(cell.this$01, cell.rowIndex, cell.columnIndex)));
    }
    return false;
};
_.size_1 = function size_10() {
    return $size_0(this.this$01);
};
_.spliterator_0 = function spliterator_13() {
    return $cellSpliterator(this.this$01);
};
var Lcom_google_common_collect_AbstractTable$CellSet_2_classLit = createForClass('com.google.common.collect', 'AbstractTable/CellSet', 664);
function AbstractTable$Values(this$0) {
    this.this$01 = this$0;
}
defineClass(1971, 31, $intern_8, AbstractTable$Values);
_.clear_0 = function clear_12() {
    $clear_1();
};
_.contains = function contains_9(o) {
    return $containsValue_0(this.this$01, o);
};
_.iterator_0 = function iterator_8() {
    return $valuesIterator(this.this$01);
};
_.size_1 = function size_11() {
    return $size_0(this.this$01);
};
_.spliterator_0 = function spliterator_14() {
    return $valuesSpliterator(this.this$01);
};
var Lcom_google_common_collect_AbstractTable$Values_2_classLit = createForClass('com.google.common.collect', 'AbstractTable/Values', 1971);
function ArrayListMultimapGwtSerializationDependencies(map_0) {
    AbstractMapBasedMultimap.call(this, map_0);
}
defineClass(1638, 1637, $intern_5);
var Lcom_google_common_collect_ArrayListMultimapGwtSerializationDependencies_2_classLit = createForClass('com.google.common.collect', 'ArrayListMultimapGwtSerializationDependencies', 1638);
function ArrayListMultimap() {
    ArrayListMultimap_0.call(this, 12, 3);
}
function ArrayListMultimap_0(expectedKeys, expectedValuesPerKey) {
    ArrayListMultimapGwtSerializationDependencies.call(this, new HashMap_0(capacity_0(expectedKeys)));
    checkNonnegative(expectedValuesPerKey, 'expectedValuesPerKey');
    this.expectedValuesPerKey = expectedValuesPerKey;
}
defineClass(504, 1638, $intern_5, ArrayListMultimap, ArrayListMultimap_0);
_.createCollection = function createCollection_4() {
    return new ArrayList_0(this.expectedValuesPerKey);
};
_.expectedValuesPerKey = 0;
var Lcom_google_common_collect_ArrayListMultimap_2_classLit = createForClass('com.google.common.collect', 'ArrayListMultimap', 504);
function $at(this$static, rowIndex, columnIndex) {
    checkElementIndex(rowIndex, this$static.rowList.delegateList_0().size_1());
    checkElementIndex(columnIndex, this$static.columnList.delegateList_0().size_1());
    return this$static.array[rowIndex][columnIndex];
}
function $cellIterator(this$static) {
    return new ArrayTable$1(this$static, this$static.rowList.delegateList_0().size_1() * this$static.columnList.delegateList_0().size_1());
}
function $cellSpliterator(this$static) {
    return indexed(this$static.rowList.delegateList_0().size_1() * this$static.columnList.delegateList_0().size_1(), 273, new ArrayTable$1methodref$getCell$Type(this$static));
}
function $clear_1() {
    throw toJs(new UnsupportedOperationException);
}
function $containsValue_0(this$static, value_0) {
    var element, element$array, element$index, element$max, row, row$array, row$index, row$max;
    for(row$array = this$static.array, row$index = 0, row$max = row$array.length; row$index < row$max; ++row$index){
        row = row$array[row$index];
        for(element$array = row, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
            element = element$array[element$index];
            if (maskUndefined(value_0) === maskUndefined(element) || value_0 != null && equals_Ljava_lang_Object__Z__devirtual$(value_0, element)) return true;
        }
    }
    return false;
}
function $eraseAll(this$static) {
    var row, row$array, row$index, row$max;
    for(row$array = this$static.array, row$index = 0, row$max = row$array.length; row$index < row$max; ++row$index){
        row = row$array[row$index];
        fill0_2(row, row.length, null);
    }
}
function $get_1(this$static, rowKey, columnKey) {
    var columnIndex, rowIndex;
    rowIndex = castTo($get_3(this$static.rowKeyToIndex, rowKey), 17);
    columnIndex = castTo($get_3(this$static.columnKeyToIndex, columnKey), 17);
    return !rowIndex || !columnIndex ? null : $at(this$static, rowIndex.value_0, columnIndex.value_0);
}
function $getValue(this$static, index_0) {
    var columnIndex, rowIndex;
    rowIndex = index_0 / this$static.columnList.delegateList_0().size_1() | 0;
    columnIndex = index_0 % this$static.columnList.delegateList_0().size_1();
    return $at(this$static, rowIndex, columnIndex);
}
function $put_0(this$static, rowKey, columnKey, value_0) {
    var columnIndex, rowIndex;
    checkNotNull(rowKey);
    checkNotNull(columnKey);
    rowIndex = castTo($get_3(this$static.rowKeyToIndex, rowKey), 17);
    checkArgument_2(!!rowIndex, 'Row %s not in %s', rowKey, this$static.rowList);
    columnIndex = castTo($get_3(this$static.columnKeyToIndex, columnKey), 17);
    checkArgument_2(!!columnIndex, 'Column %s not in %s', columnKey, this$static.columnList);
    return $set(this$static, rowIndex.value_0, columnIndex.value_0, value_0);
}
function $rowMap(this$static) {
    var map_0;
    map_0 = this$static.rowMap;
    return !map_0 ? this$static.rowMap = new ArrayTable$RowMap(this$static) : map_0;
}
function $set(this$static, rowIndex, columnIndex, value_0) {
    var oldValue;
    checkElementIndex(rowIndex, this$static.rowList.delegateList_0().size_1());
    checkElementIndex(columnIndex, this$static.columnList.delegateList_0().size_1());
    oldValue = this$static.array[rowIndex][columnIndex];
    setCheck(this$static.array[rowIndex], columnIndex, value_0);
    return oldValue;
}
function $size_0(this$static) {
    return this$static.rowList.delegateList_0().size_1() * this$static.columnList.delegateList_0().size_1();
}
function $values_1(this$static) {
    var result;
    return result = this$static.values, !result ? this$static.values = new AbstractTable$Values(this$static) : result;
}
function $valuesIterator(this$static) {
    return new ArrayTable$3(this$static, this$static.rowList.delegateList_0().size_1() * this$static.columnList.delegateList_0().size_1());
}
function $valuesSpliterator(this$static) {
    return indexed(this$static.rowList.delegateList_0().size_1() * this$static.columnList.delegateList_0().size_1(), 16, new ArrayTable$2methodref$getValue$Type(this$static));
}
function ArrayTable(rowKeys, columnKeys) {
    var tmpArray;
    this.rowList = ($clinit_ImmutableList(), checkNotNull(rowKeys), $clinit_ImmutableList(), copyFromCollection(rowKeys));
    this.columnList = (checkNotNull(columnKeys), copyFromCollection(columnKeys));
    checkArgument(this.rowList.delegateList_0().isEmpty() == this.columnList.delegateList_0().isEmpty());
    this.rowKeyToIndex = indexMap(this.rowList);
    this.columnKeyToIndex = indexMap(this.columnList);
    tmpArray = initMultidimensionalArray(Ljava_lang_Object_2_classLit, [
        $intern_16,
        $intern_2
    ], [
        5,
        1
    ], 5, [
        this.rowList.delegateList_0().size_1(),
        this.columnList.delegateList_0().size_1()
    ], 2);
    this.array = tmpArray;
    $eraseAll(this);
}
defineClass(663, 2055, {
    663: 1,
    1992: 1,
    3: 1
}, ArrayTable);
var Lcom_google_common_collect_ArrayTable_2_classLit = createForClass('com.google.common.collect', 'ArrayTable', 663);
function ArrayTable$1(this$0, $anonymous0) {
    this.this$01 = this$0;
    AbstractIndexedListIterator.call(this, $anonymous0);
}
defineClass(1967, 390, $intern_4, ArrayTable$1);
_.get_0 = function get_10(index_0) {
    return new ArrayTable$2(this.this$01, index_0);
};
var Lcom_google_common_collect_ArrayTable$1_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/1', 1967);
function ArrayTable$1methodref$getCell$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1968, 1, {}, ArrayTable$1methodref$getCell$Type);
_.apply_2 = function apply_6(arg0) {
    return new ArrayTable$2(this.$$outer_0, arg0);
};
var Lcom_google_common_collect_ArrayTable$1methodref$getCell$Type_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/1methodref$getCell$Type', 1968);
defineClass(2056, 1, {
    682: 1
});
_.equals_0 = function equals_15(obj) {
    var other;
    if (obj === this) return true;
    if (instanceOf(obj, 465)) {
        other = castTo(obj, 682);
        return equal($get_2(this.this$01.rowList, this.rowIndex), $get_2(other.this$01.rowList, other.rowIndex)) && equal($get_2(this.this$01.columnList, this.columnIndex), $get_2(other.this$01.columnList, other.columnIndex)) && equal($at(this.this$01, this.rowIndex, this.columnIndex), $at(other.this$01, other.rowIndex, other.columnIndex));
    }
    return false;
};
_.hashCode_1 = function hashCode_14() {
    return hashCode_47(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        $get_2(this.this$01.rowList, this.rowIndex),
        $get_2(this.this$01.columnList, this.columnIndex),
        $at(this.this$01, this.rowIndex, this.columnIndex)
    ]));
};
_.toString_0 = function toString_13() {
    return '(' + $get_2(this.this$01.rowList, this.rowIndex) + ',' + $get_2(this.this$01.columnList, this.columnIndex) + ')=' + $at(this.this$01, this.rowIndex, this.columnIndex);
};
var Lcom_google_common_collect_Tables$AbstractCell_2_classLit = createForClass('com.google.common.collect', 'Tables/AbstractCell', 2056);
function ArrayTable$2(this$0, val$index) {
    this.this$01 = this$0;
    this.val$index2 = val$index;
    this.rowIndex = this.val$index2 / this.this$01.columnList.delegateList_0().size_1() | 0;
    this.columnIndex = this.val$index2 % this.this$01.columnList.delegateList_0().size_1();
}
defineClass(465, 2056, {
    465: 1,
    682: 1
}, ArrayTable$2);
_.columnIndex = 0;
_.rowIndex = 0;
_.val$index2 = 0;
var Lcom_google_common_collect_ArrayTable$2_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/2', 465);
function ArrayTable$2methodref$getValue$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1970, 1, {}, ArrayTable$2methodref$getValue$Type);
_.apply_2 = function apply_7(arg0) {
    return $getValue(this.$$outer_0, arg0);
};
var Lcom_google_common_collect_ArrayTable$2methodref$getValue$Type_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/2methodref$getValue$Type', 1970);
function ArrayTable$3(this$0, $anonymous0) {
    this.this$01 = this$0;
    AbstractIndexedListIterator.call(this, $anonymous0);
}
defineClass(1969, 390, $intern_4, ArrayTable$3);
_.get_0 = function get_11(index_0) {
    return $getValue(this.this$01, index_0);
};
var Lcom_google_common_collect_ArrayTable$3_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/3', 1969);
function $forEachEntry_0(this$static, action) {
    this$static.entryIterator().forEachRemaining(action);
}
defineClass(2023, 2011, $intern_7);
_.clear_0 = function clear_13() {
    clear_20(this.entryIterator());
};
_.entrySet_0 = function entrySet_0() {
    return new Maps$IteratorBasedAbstractMap$1(this);
};
_.entrySpliterator = function entrySpliterator_1() {
    return new Spliterators$IteratorSpliterator_1(this.entryIterator(), this.size_1());
};
var Lcom_google_common_collect_Maps$IteratorBasedAbstractMap_2_classLit = createForClass('com.google.common.collect', 'Maps/IteratorBasedAbstractMap', 2023);
function $getEntry(this$static, index_0) {
    checkElementIndex(index_0, this$static.keyIndex.delegate.map_0.size_1());
    return new ArrayTable$ArrayMap$1(this$static, index_0);
}
function $getKey(this$static, index_0) {
    return $keySet_0(this$static.keyIndex).asList_1().get_0(index_0);
}
function ArrayTable$ArrayMap(keyIndex) {
    this.keyIndex = keyIndex;
}
defineClass(821, 2023, $intern_7);
_.clear_0 = function clear_14() {
    throw toJs(new UnsupportedOperationException);
};
_.containsKey = function containsKey_2(key) {
    return $containsKey_0(this.keyIndex, key);
};
_.entryIterator = function entryIterator_1() {
    return new ArrayTable$ArrayMap$2(this, this.keyIndex.delegate.map_0.size_1());
};
_.entrySpliterator = function entrySpliterator_2() {
    return indexed(this.keyIndex.delegate.map_0.size_1(), 16, new ArrayTable$ArrayMap$0methodref$getEntry$Type(this));
};
_.get_3 = function get_12(key) {
    var index_0;
    index_0 = castTo($get_3(this.keyIndex, key), 17);
    return !index_0 ? null : this.getValue_0(index_0.value_0);
};
_.isEmpty = function isEmpty_5() {
    return this.keyIndex.delegate.map_0.isEmpty();
};
_.keySet_0 = function keySet_9() {
    return $keySet_0(this.keyIndex);
};
_.put = function put_0(key, value_0) {
    var index_0;
    index_0 = castTo($get_3(this.keyIndex, key), 17);
    if (!index_0) throw toJs(new IllegalArgumentException_0(this.getKeyRole() + ' ' + key + ' not in ' + $keySet_0(this.keyIndex)));
    return this.setValue_0(index_0.value_0, value_0);
};
_.remove_0 = function remove_20(key) {
    throw toJs(new UnsupportedOperationException);
};
_.size_1 = function size_12() {
    return this.keyIndex.delegate.map_0.size_1();
};
var Lcom_google_common_collect_ArrayTable$ArrayMap_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/ArrayMap', 821);
function ArrayTable$ArrayMap$0methodref$getEntry$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1966, 1, {}, ArrayTable$ArrayMap$0methodref$getEntry$Type);
_.apply_2 = function apply_8(arg0) {
    return $getEntry(this.$$outer_0, arg0);
};
var Lcom_google_common_collect_ArrayTable$ArrayMap$0methodref$getEntry$Type_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/ArrayMap/0methodref$getEntry$Type', 1966);
function ArrayTable$ArrayMap$1(this$1, val$index) {
    this.this$11 = this$1;
    this.val$index2 = val$index;
}
defineClass(1964, 355, $intern_15, ArrayTable$ArrayMap$1);
_.getKey = function getKey() {
    return $getKey(this.this$11, this.val$index2);
};
_.getValue = function getValue() {
    return this.this$11.getValue_0(this.val$index2);
};
_.setValue = function setValue_0(value_0) {
    return this.this$11.setValue_0(this.val$index2, value_0);
};
_.val$index2 = 0;
var Lcom_google_common_collect_ArrayTable$ArrayMap$1_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/ArrayMap/1', 1964);
function ArrayTable$ArrayMap$2(this$1, $anonymous0) {
    this.this$11 = this$1;
    AbstractIndexedListIterator.call(this, $anonymous0);
}
defineClass(1965, 390, $intern_4, ArrayTable$ArrayMap$2);
_.get_0 = function get_13(index_0) {
    return $getEntry(this.this$11, index_0);
};
var Lcom_google_common_collect_ArrayTable$ArrayMap$2_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/ArrayMap/2', 1965);
function ArrayTable$Row(this$0, rowIndex) {
    this.this$01 = this$0;
    ArrayTable$ArrayMap.call(this, this$0.columnKeyToIndex);
    this.rowIndex = rowIndex;
}
defineClass(1963, 821, $intern_7, ArrayTable$Row);
_.getKeyRole = function getKeyRole() {
    return 'Column';
};
_.getValue_0 = function getValue_0(index_0) {
    return $at(this.this$01, this.rowIndex, index_0);
};
_.setValue_0 = function setValue_1(index_0, newValue) {
    return $set(this.this$01, this.rowIndex, index_0, newValue);
};
_.rowIndex = 0;
var Lcom_google_common_collect_ArrayTable$Row_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/Row', 1963);
function $put_1() {
    throw toJs(new UnsupportedOperationException);
}
function $setValue() {
    throw toJs(new UnsupportedOperationException);
}
function ArrayTable$RowMap(this$0) {
    this.this$01 = this$0;
    ArrayTable$ArrayMap.call(this, this$0.rowKeyToIndex);
}
defineClass(822, 821, $intern_7, ArrayTable$RowMap);
_.getValue_0 = function getValue_1(index_0) {
    return new ArrayTable$Row(this.this$01, index_0);
};
_.put = function put_1(key, value_0) {
    return castTo(value_0, 91), $put_1();
};
_.setValue_0 = function setValue_2(index_0, newValue) {
    return castTo(newValue, 91), $setValue();
};
_.getKeyRole = function getKeyRole_0() {
    return 'Row';
};
var Lcom_google_common_collect_ArrayTable$RowMap_2_classLit = createForClass('com.google.common.collect', 'ArrayTable/RowMap', 822);
function checkEntryNotNull(key, value_0) {
    if (key == null) throw toJs(new NullPointerException_0('null key in entry: null=' + value_0));
    else if (value_0 == null) throw toJs(new NullPointerException_0('null value in entry: ' + key + '=null'));
}
function checkNonnegative(value_0, name_0) {
    if (value_0 < 0) throw toJs(new IllegalArgumentException_0(name_0 + ' cannot be negative but was: ' + value_0));
    return value_0;
}
function flatMap(fromSpliterator, function_0, topCharacteristics, topSize) {
    checkArgument_0((topCharacteristics & $intern_17) == 0, 'flatMap does not support SUBSIZED characteristic');
    checkArgument_0((topCharacteristics & 4) == 0, 'flatMap does not support SORTED characteristic');
    checkNotNull(fromSpliterator);
    checkNotNull(function_0);
    return new CollectSpliterators$FlatMapSpliteratorOfObject(fromSpliterator, function_0, topCharacteristics, topSize);
}
function indexed(size_0, extraCharacteristics, function_0) {
    return new CollectSpliterators$1WithCharacteristics(range_0(size_0).spliterator_1(), function_0, extraCharacteristics);
}
function map_2(fromSpliterator, function_0) {
    checkNotNull(fromSpliterator);
    checkNotNull(function_0);
    return new CollectSpliterators$1(fromSpliterator, function_0);
}
function $forEachRemaining_0(this$static, consumer) {
    while(this$static.tryAdvance(consumer));
}
function CollectSpliterators$1(val$fromSpliterator, val$function) {
    this.val$fromSpliterator1 = val$fromSpliterator;
    this.val$function2 = val$function;
}
defineClass(1121, 1, $intern_18, CollectSpliterators$1);
_.hasCharacteristics = function hasCharacteristics(characteristics) {
    return (this.val$fromSpliterator1.characteristics_0() & -262 & characteristics) != 0;
};
_.characteristics_0 = function characteristics_0() {
    return this.val$fromSpliterator1.characteristics_0() & -262;
};
_.estimateSize_0 = function estimateSize() {
    return this.val$fromSpliterator1.estimateSize_0();
};
_.forEachRemaining = function forEachRemaining_4(action) {
    this.val$fromSpliterator1.forEachRemaining(new CollectSpliterators$1$lambda$1$Type(action, this.val$function2));
};
_.tryAdvance = function tryAdvance(action) {
    return this.val$fromSpliterator1.tryAdvance(new CollectSpliterators$1$lambda$0$Type(action, this.val$function2));
};
var Lcom_google_common_collect_CollectSpliterators$1_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/1', 1121);
function CollectSpliterators$1$lambda$0$Type(action_0, function_1) {
    this.action_0 = action_0;
    this.function_1 = function_1;
}
defineClass(1122, 1, $intern_19, CollectSpliterators$1$lambda$0$Type);
_.accept = function accept_0(arg0) {
    this.action_0.accept(this.function_1.apply_0(arg0));
};
var Lcom_google_common_collect_CollectSpliterators$1$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/1/lambda$0$Type', 1122);
function CollectSpliterators$1$lambda$1$Type(action_0, function_1) {
    this.action_0 = action_0;
    this.function_1 = function_1;
}
defineClass(1123, 1, $intern_19, CollectSpliterators$1$lambda$1$Type);
_.accept = function accept_1(arg0) {
    this.action_0.accept(this.function_1.apply_0(arg0));
};
var Lcom_google_common_collect_CollectSpliterators$1$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/1/lambda$1$Type', 1123);
function CollectSpliterators$1WithCharacteristics(delegate, val$function, val$extraCharacteristics) {
    this.val$function2 = val$function;
    this.val$extraCharacteristics3 = val$extraCharacteristics;
    this.delegate = delegate;
}
defineClass(1118, 1, $intern_18, CollectSpliterators$1WithCharacteristics);
_.hasCharacteristics = function hasCharacteristics_0(characteristics) {
    return ((16464 | this.val$extraCharacteristics3) & characteristics) != 0;
};
_.characteristics_0 = function characteristics_1() {
    return 16464 | this.val$extraCharacteristics3;
};
_.estimateSize_0 = function estimateSize_0() {
    return this.delegate.estimateSize_0();
};
_.forEachRemaining = function forEachRemaining_5(action) {
    this.delegate.forEachRemaining_0(new CollectSpliterators$1WithCharacteristics$lambda$1$Type(action, this.val$function2));
};
_.tryAdvance = function tryAdvance_0(action) {
    return this.delegate.tryAdvance_0(new CollectSpliterators$1WithCharacteristics$lambda$0$Type(action, this.val$function2));
};
_.val$extraCharacteristics3 = 0;
var Lcom_google_common_collect_CollectSpliterators$1WithCharacteristics_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/1WithCharacteristics', 1118);
function CollectSpliterators$1WithCharacteristics$lambda$0$Type(action_0, function_1) {
    this.action_0 = action_0;
    this.function_1 = function_1;
}
defineClass(1119, 1, $intern_20, CollectSpliterators$1WithCharacteristics$lambda$0$Type);
_.accept_0 = function accept_2(arg0) {
    this.action_0.accept(this.function_1.apply_2(arg0));
};
var Lcom_google_common_collect_CollectSpliterators$1WithCharacteristics$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/1WithCharacteristics/lambda$0$Type', 1119);
function CollectSpliterators$1WithCharacteristics$lambda$1$Type(action_0, function_1) {
    this.action_0 = action_0;
    this.function_1 = function_1;
}
defineClass(1120, 1, $intern_20, CollectSpliterators$1WithCharacteristics$lambda$1$Type);
_.accept_0 = function accept_3(arg0) {
    this.action_0.accept(this.function_1.apply_2(arg0));
};
var Lcom_google_common_collect_CollectSpliterators$1WithCharacteristics$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/1WithCharacteristics/lambda$1$Type', 1120);
function $lambda$0(this$static, fromElement_0) {
    return this$static.prefix = castTo(this$static.function_0.apply_0(fromElement_0), 158);
}
function $lambda$1(this$static, action_1, fromElement_1) {
    var elements;
    elements = castTo(this$static.function_0.apply_0(fromElement_1), 158);
    !!elements && elements.forEachRemaining(action_1);
}
defineClass(1114, 1, $intern_18);
_.hasCharacteristics = function hasCharacteristics_1(characteristics) {
    return (this.characteristics & characteristics) != 0;
};
_.characteristics_0 = function characteristics_2() {
    return this.characteristics;
};
_.estimateSize_0 = function estimateSize_1() {
    !!this.prefix && (this.estimatedSize = max_1(this.estimatedSize, this.prefix.estimateSize_0()));
    return max_1(this.estimatedSize, 0);
};
_.forEachRemaining = function forEachRemaining_6(action) {
    if (this.prefix) {
        this.prefix.forEachRemaining(action);
        this.prefix = null;
    }
    this.from.forEachRemaining(new CollectSpliterators$FlatMapSpliterator$lambda$1$Type(this, action));
    this.estimatedSize = 0;
};
_.tryAdvance = function tryAdvance_1(action) {
    while(true){
        if (!!this.prefix && this.prefix.tryAdvance(action)) {
            neq(this.estimatedSize, $intern_21) && (this.estimatedSize = sub_2(this.estimatedSize, 1));
            return true;
        } else this.prefix = null;
        if (!this.from.tryAdvance(new CollectSpliterators$FlatMapSpliterator$lambda$0$Type(this))) return false;
    }
};
_.characteristics = 0;
_.estimatedSize = 0;
var Lcom_google_common_collect_CollectSpliterators$FlatMapSpliterator_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/FlatMapSpliterator', 1114);
function CollectSpliterators$FlatMapSpliterator$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1116, 1, $intern_19, CollectSpliterators$FlatMapSpliterator$lambda$0$Type);
_.accept = function accept_4(arg0) {
    $lambda$0(this.$$outer_0, arg0);
};
var Lcom_google_common_collect_CollectSpliterators$FlatMapSpliterator$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/FlatMapSpliterator/lambda$0$Type', 1116);
function CollectSpliterators$FlatMapSpliterator$lambda$1$Type($$outer_0, action_1) {
    this.$$outer_0 = $$outer_0;
    this.action_1 = action_1;
}
defineClass(1117, 1, $intern_19, CollectSpliterators$FlatMapSpliterator$lambda$1$Type);
_.accept = function accept_5(arg0) {
    $lambda$1(this.$$outer_0, this.action_1, arg0);
};
var Lcom_google_common_collect_CollectSpliterators$FlatMapSpliterator$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/FlatMapSpliterator/lambda$1$Type', 1117);
function CollectSpliterators$FlatMapSpliteratorOfObject(from, function_0, characteristics, estimatedSize) {
    this.prefix = null;
    this.from = from;
    this.function_0 = function_0;
    this.characteristics = characteristics;
    this.estimatedSize = estimatedSize;
}
defineClass(1115, 1114, $intern_18, CollectSpliterators$FlatMapSpliteratorOfObject);
var Lcom_google_common_collect_CollectSpliterators$FlatMapSpliteratorOfObject_2_classLit = createForClass('com.google.common.collect', 'CollectSpliterators/FlatMapSpliteratorOfObject', 1115);
function safeContains(collection, object) {
    checkNotNull(collection);
    try {
        return collection.contains(object);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 211) || instanceOf($e0, 169)) return false;
        else throw toJs($e0);
    }
}
function safeRemove(collection, object) {
    checkNotNull(collection);
    try {
        return collection.remove_1(object);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 211) || instanceOf($e0, 169)) return false;
        else throw toJs($e0);
    }
}
function $equals_1(this$static, obj) {
    var compareResult, that;
    if (instanceOf(obj, 252)) {
        that = castTo(obj, 252);
        try {
            compareResult = this$static.compareTo(that);
            return compareResult == 0;
        } catch ($e0) {
            $e0 = toJava($e0);
            if (instanceOf($e0, 211)) return false;
            else throw toJs($e0);
        }
    }
    return false;
}
function Cut(endpoint) {
    this.endpoint = endpoint;
}
defineClass(252, 1, $intern_22);
_.compareTo_0 = function compareTo_0(that) {
    return this.compareTo(castTo(that, 252));
};
_.compareTo = function compareTo(that) {
    var result;
    if (that == ($clinit_Cut$BelowAll(), INSTANCE_1)) return 1;
    if (that == ($clinit_Cut$AboveAll(), INSTANCE_0)) return -1;
    result = ($clinit_Range(), compareTo_Ljava_lang_Object__I__devirtual$(this.endpoint, that.endpoint));
    if (result != 0) return result;
    return instanceOf(this, 511) == instanceOf(that, 511) ? 0 : instanceOf(this, 511) ? 1 : -1;
};
_.endpoint_0 = function endpoint_0() {
    return this.endpoint;
};
_.equals_0 = function equals_16(obj) {
    return $equals_1(this, obj);
};
var Lcom_google_common_collect_Cut_2_classLit = createForClass('com.google.common.collect', 'Cut', 252);
function $clinit_Cut$AboveAll() {
    $clinit_Cut$AboveAll = emptyMethod;
    INSTANCE_0 = new Cut$AboveAll;
}
function Cut$AboveAll() {
    Cut.call(this, '');
}
defineClass(1769, 252, $intern_22, Cut$AboveAll);
_.compareTo = function compareTo_1(o) {
    return o == this ? 0 : 1;
};
_.describeAsLowerBound = function describeAsLowerBound(sb) {
    throw toJs(new AssertionError);
};
_.describeAsUpperBound = function describeAsUpperBound(sb) {
    sb.string += '+\u221E)';
};
_.endpoint_0 = function endpoint_1() {
    throw toJs(new IllegalStateException_0('range unbounded on this side'));
};
_.hashCode_1 = function hashCode_15() {
    return $clinit_System(), getIdentityHashCode(this);
};
_.isLessThan = function isLessThan(value_0) {
    return false;
};
_.toString_0 = function toString_14() {
    return '+\u221E';
};
var INSTANCE_0;
var Lcom_google_common_collect_Cut$AboveAll_2_classLit = createForClass('com.google.common.collect', 'Cut/AboveAll', 1769);
function Cut$AboveValue(endpoint) {
    Cut.call(this, castTo(checkNotNull(endpoint), 34));
}
defineClass(511, 252, {
    252: 1,
    511: 1,
    3: 1,
    34: 1
}, Cut$AboveValue);
_.describeAsLowerBound = function describeAsLowerBound_0(sb) {
    $append_10((sb.string += '(', sb), this.endpoint);
};
_.describeAsUpperBound = function describeAsUpperBound_0(sb) {
    $append_5($append_10(sb, this.endpoint), 93);
};
_.hashCode_1 = function hashCode_16() {
    return ~hashCode__I__devirtual$(this.endpoint);
};
_.isLessThan = function isLessThan_0(value_0) {
    return $clinit_Range(), compareTo_Ljava_lang_Object__I__devirtual$(this.endpoint, value_0) < 0;
};
_.toString_0 = function toString_15() {
    return '/' + this.endpoint + '\\';
};
var Lcom_google_common_collect_Cut$AboveValue_2_classLit = createForClass('com.google.common.collect', 'Cut/AboveValue', 511);
function $clinit_Cut$BelowAll() {
    $clinit_Cut$BelowAll = emptyMethod;
    INSTANCE_1 = new Cut$BelowAll;
}
function Cut$BelowAll() {
    Cut.call(this, '');
}
defineClass(1768, 252, $intern_22, Cut$BelowAll);
_.compareTo = function compareTo_2(o) {
    return o == this ? 0 : -1;
};
_.describeAsLowerBound = function describeAsLowerBound_1(sb) {
    sb.string += '(-\u221E';
};
_.describeAsUpperBound = function describeAsUpperBound_1(sb) {
    throw toJs(new AssertionError);
};
_.endpoint_0 = function endpoint_2() {
    throw toJs(new IllegalStateException_0('range unbounded on this side'));
};
_.hashCode_1 = function hashCode_17() {
    return $clinit_System(), getIdentityHashCode(this);
};
_.isLessThan = function isLessThan_1(value_0) {
    return true;
};
_.toString_0 = function toString_16() {
    return '-\u221E';
};
var INSTANCE_1;
var Lcom_google_common_collect_Cut$BelowAll_2_classLit = createForClass('com.google.common.collect', 'Cut/BelowAll', 1768);
function Cut$BelowValue(endpoint) {
    Cut.call(this, castTo(checkNotNull(endpoint), 34));
}
defineClass(1770, 252, $intern_22, Cut$BelowValue);
_.describeAsLowerBound = function describeAsLowerBound_2(sb) {
    $append_10((sb.string += '[', sb), this.endpoint);
};
_.describeAsUpperBound = function describeAsUpperBound_2(sb) {
    $append_5($append_10(sb, this.endpoint), 41);
};
_.hashCode_1 = function hashCode_18() {
    return hashCode__I__devirtual$(this.endpoint);
};
_.isLessThan = function isLessThan_2(value_0) {
    return $clinit_Range(), compareTo_Ljava_lang_Object__I__devirtual$(this.endpoint, value_0) <= 0;
};
_.toString_0 = function toString_17() {
    return '\\' + this.endpoint + '/';
};
var Lcom_google_common_collect_Cut$BelowValue_2_classLit = createForClass('com.google.common.collect', 'Cut/BelowValue', 1770);
function FluentIterable() {
    $clinit_Absent();
}
function concatNoDefensiveCopy(inputs) {
    var input_0, input$array, input$index, input$max;
    for(input$array = inputs, input$index = 0, input$max = input$array.length; input$index < input$max; ++input$index){
        input_0 = input$array[input$index];
        checkNotNull(input_0);
    }
    return new FluentIterable$3(inputs);
}
defineClass(532, 1, $intern_23);
_.forEach_0 = function forEach_3(action) {
    $forEach_0(this, action);
};
_.toString_0 = function toString_18() {
    return toString_25(castTo(checkNotNull_0(this, 'use Optional.orNull() instead of Optional.or(null)'), 20).iterator_0());
};
var Lcom_google_common_collect_FluentIterable_2_classLit = createForClass('com.google.common.collect', 'FluentIterable', 532);
function FluentIterable$2(val$inputs) {
    this.val$inputs1 = val$inputs;
    FluentIterable.call(this);
}
defineClass(430, 532, $intern_23, FluentIterable$2);
_.iterator_0 = function iterator_9() {
    return new Iterators$ConcatenatedIterator(transform_2(this.val$inputs1.iterator_0(), new Iterables$10));
};
var Lcom_google_common_collect_FluentIterable$2_2_classLit = createForClass('com.google.common.collect', 'FluentIterable/2', 430);
function $iterator(this$static) {
    return new Iterators$ConcatenatedIterator(new FluentIterable$3$1(this$static.val$inputs1.length, this$static.val$inputs1));
}
function FluentIterable$3(val$inputs) {
    this.val$inputs1 = val$inputs;
    FluentIterable.call(this);
}
defineClass(1034, 532, $intern_23, FluentIterable$3);
_.iterator_0 = function iterator_10() {
    return $iterator(this);
};
var Lcom_google_common_collect_FluentIterable$3_2_classLit = createForClass('com.google.common.collect', 'FluentIterable/3', 1034);
function FluentIterable$3$1($anonymous0, val$inputs) {
    this.val$inputs3 = val$inputs;
    AbstractIndexedListIterator.call(this, $anonymous0);
}
defineClass(708, 390, $intern_4, FluentIterable$3$1);
_.get_0 = function get_14(i) {
    return this.val$inputs3[i].iterator_0();
};
var Lcom_google_common_collect_FluentIterable$3$1_2_classLit = createForClass('com.google.common.collect', 'FluentIterable/3/1', 708);
defineClass(2016, 1, {});
_.toString_0 = function toString_19() {
    return toString_40(this.delegate_0().coll);
};
var Lcom_google_common_collect_ForwardingObject_2_classLit = createForClass('com.google.common.collect', 'ForwardingObject', 2016);
defineClass(2017, 2016, $intern_24);
_.delegate_0 = function delegate_0() {
    return this.delegate_1();
};
_.forEach_0 = function forEach_4(action) {
    $forEach_0(this, action);
};
_.spliterator_0 = function spliterator_15() {
    return new Spliterators$IteratorSpliterator(this, 0);
};
_.stream = function stream_1() {
    return new StreamImpl(null, this.spliterator_0());
};
_.add_2 = function add_7(element) {
    return this.delegate_1(), $add_4();
};
_.addAll = function addAll_3(collection) {
    return this.delegate_1(), $addAll_3();
};
_.clear_0 = function clear_15() {
    this.delegate_1(), $clear_5();
};
_.contains = function contains_10(object) {
    return this.delegate_1().contains(object);
};
_.containsAll = function containsAll_2(collection) {
    return this.delegate_1().containsAll(collection);
};
_.isEmpty = function isEmpty_6() {
    return this.delegate_1().coll.isEmpty();
};
_.iterator_0 = function iterator_11() {
    return this.delegate_1().iterator_0();
};
_.remove_1 = function remove_21(object) {
    return this.delegate_1(), $remove_14();
};
_.size_1 = function size_13() {
    return this.delegate_1().coll.size_1();
};
_.toArray = function toArray_1() {
    return this.delegate_1().toArray();
};
_.toArray_0 = function toArray_2(array) {
    return this.delegate_1().toArray_0(array);
};
var Lcom_google_common_collect_ForwardingCollection_2_classLit = createForClass('com.google.common.collect', 'ForwardingCollection', 2017);
function $clinit_ImmutableCollection() {
    $clinit_ImmutableCollection = emptyMethod;
    new ForwardingImmutableCollection(($clinit_Collections(), $clinit_Collections(), EMPTY_LIST));
}
defineClass(2024, 31, $intern_25);
_.iterator_0 = function iterator_12() {
    return this.iterator_1();
};
_.add_2 = function add_8(e) {
    throw toJs(new UnsupportedOperationException);
};
_.addAll = function addAll_4(newElements) {
    throw toJs(new UnsupportedOperationException);
};
_.asList_1 = function asList() {
    var list;
    list = this.asList_0;
    return !list ? this.asList_0 = this.createAsList() : list;
};
_.clear_0 = function clear_16() {
    throw toJs(new UnsupportedOperationException);
};
_.contains = function contains_11(object) {
    return object != null && $advanceToFind(this, object, false);
};
_.createAsList = function createAsList() {
    switch(this.size_1()){
        case 0:
            return $clinit_ImmutableList(), $clinit_ImmutableList(), EMPTY;
        case 1:
            return $clinit_ImmutableList(), new SingletonImmutableList(checkNotNull(this.iterator_1().next_1()));
        default:
            return new RegularImmutableAsList_0(this, this.toArray());
    }
};
_.remove_1 = function remove_22(object) {
    throw toJs(new UnsupportedOperationException);
};
var Lcom_google_common_collect_ImmutableCollection_2_classLit = createForClass('com.google.common.collect', 'ImmutableCollection', 2024);
function ForwardingImmutableCollection(delegate) {
    $clinit_ImmutableCollection();
    this.delegate = delegate;
}
defineClass(711, 2024, $intern_25, ForwardingImmutableCollection);
_.iterator_0 = function iterator_14() {
    return unmodifiableIterator(this.delegate.iterator_0());
};
_.contains = function contains_12(object) {
    return object != null && this.delegate.contains(object);
};
_.containsAll = function containsAll_3(targets) {
    return this.delegate.containsAll(targets);
};
_.isEmpty = function isEmpty_7() {
    return this.delegate.isEmpty();
};
_.iterator_1 = function iterator_13() {
    return unmodifiableIterator(this.delegate.iterator_0());
};
_.size_1 = function size_14() {
    return this.delegate.size_1();
};
_.toArray = function toArray_3() {
    return this.delegate.toArray();
};
_.toArray_0 = function toArray_4(other) {
    return this.delegate.toArray_0(other);
};
_.toString_0 = function toString_20() {
    return toString_40(this.delegate);
};
var Lcom_google_common_collect_ForwardingImmutableCollection_2_classLit = createForClass('com.google.common.collect', 'ForwardingImmutableCollection', 711);
function $clinit_ImmutableList() {
    $clinit_ImmutableList = emptyMethod;
    $clinit_ImmutableCollection();
    EMPTY = new RegularImmutableList(($clinit_Collections(), $clinit_Collections(), EMPTY_LIST));
}
function $listIterator(this$static, index_0) {
    return new ImmutableList$1(this$static, this$static.size_1(), index_0);
}
function $reverse(this$static) {
    var list;
    list = (checkNotNull(this$static), this$static ? new ArrayList_1(this$static) : newArrayList_0(this$static.iterator_0()));
    reverse_2(list);
    return unsafeDelegateList(list);
}
function copyFromCollection(collection) {
    $clinit_ImmutableList();
    var elements;
    elements = collection.toArray();
    switch(elements.length){
        case 0:
            return EMPTY;
        case 1:
            return new SingletonImmutableList(checkNotNull(elements[0]));
        default:
            return new RegularImmutableList(nullCheckedList(elements));
    }
}
function nullCheckedList(array) {
    var castedArray, i, len;
    for(i = 0, len = array.length; i < len; i++){
        if (array[i] == null) throw toJs(new NullPointerException_0('at index ' + i));
    }
    castedArray = array;
    return new Arrays$ArrayList(castedArray);
}
function unsafeDelegateList(list) {
    var castedList;
    switch(list.size_1()){
        case 0:
            return EMPTY;
        case 1:
            return new SingletonImmutableList(checkNotNull(list.get_0(0)));
        default:
            castedList = list;
            return new RegularImmutableList(castedList);
    }
}
defineClass(308, 2024, $intern_26);
_.iterator_0 = function iterator_16() {
    return this.iterator_1();
};
_.listIterator_0 = function listIterator_1() {
    return this.listIterator_2(0);
};
_.listIterator_1 = function listIterator_3(index_0) {
    return this.listIterator_2(index_0);
};
_.sort_0 = function sort_1(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_16() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.subList = function subList_2(fromIndex, toIndex) {
    return this.subList_0(fromIndex, toIndex);
};
_.add_3 = function add_9(index_0, element) {
    throw toJs(new UnsupportedOperationException);
};
_.addAll_0 = function addAll_5(index_0, newElements) {
    throw toJs(new UnsupportedOperationException);
};
_.asList_1 = function asList_0() {
    return this;
};
_.equals_0 = function equals_17(obj) {
    return equalsImpl(this, obj);
};
_.hashCode_1 = function hashCode_19() {
    return hashCodeImpl(this);
};
_.indexOf_0 = function indexOf_0(object) {
    return object == null ? -1 : indexOfRandomAccess(this, object);
};
_.iterator_1 = function iterator_15() {
    return this.listIterator_2(0);
};
_.listIterator_2 = function listIterator_2(index_0) {
    return $listIterator(this, index_0);
};
_.remove_2 = function remove_23(index_0) {
    throw toJs(new UnsupportedOperationException);
};
_.set_2 = function set_4(index_0, element) {
    throw toJs(new UnsupportedOperationException);
};
_.subList_0 = function subList_1(fromIndex, toIndex) {
    var wrapper;
    return unsafeDelegateList((wrapper = new Lists$1(this), new AbstractList$SubList(wrapper, fromIndex, toIndex)));
};
var EMPTY;
var Lcom_google_common_collect_ImmutableList_2_classLit = createForClass('com.google.common.collect', 'ImmutableList', 308);
function $get_2(this$static, index_0) {
    return this$static.delegateList_0().get_0(index_0);
}
defineClass(2051, 308, $intern_26);
_.iterator_0 = function iterator_18() {
    return unmodifiableIterator(this.delegateList_0().iterator_0());
};
_.subList = function subList_4(fromIndex, toIndex) {
    return unsafeDelegateList(this.delegateList_0().subList(fromIndex, toIndex));
};
_.contains = function contains_13(object) {
    return object != null && this.delegateList_0().contains(object);
};
_.containsAll = function containsAll_4(targets) {
    return this.delegateList_0().containsAll(targets);
};
_.equals_0 = function equals_18(obj) {
    return equals_Ljava_lang_Object__Z__devirtual$(this.delegateList_0(), obj);
};
_.get_0 = function get_15(index_0) {
    return $get_2(this, index_0);
};
_.hashCode_1 = function hashCode_20() {
    return hashCode__I__devirtual$(this.delegateList_0());
};
_.indexOf_0 = function indexOf_1(object) {
    return this.delegateList_0().indexOf_0(object);
};
_.isEmpty = function isEmpty_8() {
    return this.delegateList_0().isEmpty();
};
_.iterator_1 = function iterator_17() {
    return unmodifiableIterator(this.delegateList_0().iterator_0());
};
_.size_1 = function size_15() {
    return this.delegateList_0().size_1();
};
_.subList_0 = function subList_3(fromIndex, toIndex) {
    return unsafeDelegateList(this.delegateList_0().subList(fromIndex, toIndex));
};
_.toArray = function toArray_5() {
    return this.delegateList_0().toArray_0(initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, this.delegateList_0().size_1(), 5, 1));
};
_.toArray_0 = function toArray_6(other) {
    return this.delegateList_0().toArray_0(other);
};
_.toString_0 = function toString_21() {
    return toString_40(this.delegateList_0());
};
var Lcom_google_common_collect_ForwardingImmutableList_2_classLit = createForClass('com.google.common.collect', 'ForwardingImmutableList', 2051);
function $clinit_ImmutableMap() {
    $clinit_ImmutableMap = emptyMethod;
    EMPTY_0 = new RegularImmutableMap_0(stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Map$Entry_2_classLit, 1), $intern_27, 43, 0, []));
}
function $entrySet_1(this$static) {
    if (this$static.cachedEntrySet) return this$static.cachedEntrySet;
    return this$static.cachedEntrySet = this$static.createEntrySet_1();
}
function $keySet_0(this$static) {
    if (this$static.cachedKeySet) return this$static.cachedKeySet;
    return this$static.cachedKeySet = this$static.createKeySet_1();
}
function $put_2() {
    throw toJs(new UnsupportedOperationException);
}
function fromEntryList(entries) {
    $clinit_ImmutableMap();
    var entry, entryArray, size_0;
    size_0 = entries.array.length;
    switch(size_0){
        case 0:
            return EMPTY_0;
        case 1:
            entry = castTo(getOnlyElement(new ArrayList$1(entries)), 43);
            return of(entry.getKey(), entry.getValue());
        default:
            entryArray = castTo($toArray_1(entries, initUnidimensionalArray(Ljava_util_Map$Entry_2_classLit, $intern_27, 43, entries.array.length, 0, 1)), 174);
            return new RegularImmutableMap(entryArray);
    }
}
function of(k1, v1) {
    return $clinit_ImmutableMap(), checkEntryNotNull(k1, v1), new SingletonImmutableBiMap(k1, v1);
}
function of_0(k1, v1, k2, v2) {
    $clinit_ImmutableMap();
    return new RegularImmutableMap_0(stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Map$Entry_2_classLit, 1), $intern_27, 43, 0, [
        (checkEntryNotNull(k1, v1), new ImmutableEntry(k1, v1)),
        (checkEntryNotNull(k2, v2), new ImmutableEntry(k2, v2))
    ]));
}
defineClass(712, 1, $intern_28);
_.entrySet_0 = function entrySet_1() {
    return $entrySet_1(this);
};
_.forEach = function forEach_5(consumer) {
    $forEach_2(this, consumer);
};
_.keySet_0 = function keySet_10() {
    return $keySet_0(this);
};
_.values_0 = function values_4() {
    return this.values_2();
};
_.clear_0 = function clear_17() {
    throw toJs(new UnsupportedOperationException);
};
_.containsKey = function containsKey_3(key) {
    return this.get_3(key) != null;
};
_.containsValue = function containsValue_0(value_0) {
    return this.values_2().contains(value_0);
};
_.createKeySet_1 = function createKeySet_6() {
    return new ImmutableMapKeySet(this);
};
_.createValues = function createValues() {
    return new ImmutableMapValues(this);
};
_.equals_0 = function equals_19(object) {
    return equalsImpl_0(this, object);
};
_.hashCode_1 = function hashCode_21() {
    return $entrySet_1(this).hashCode_1();
};
_.isEmpty = function isEmpty_9() {
    return this.size_1() == 0;
};
_.put = function put_2(k, v) {
    return $put_2();
};
_.remove_0 = function remove_24(o) {
    throw toJs(new UnsupportedOperationException);
};
_.toString_0 = function toString_22() {
    return toStringImpl(this);
};
_.values_2 = function values_3() {
    if (this.cachedValues) return this.cachedValues;
    return this.cachedValues = this.createValues();
};
_.cachedEntrySet = null;
_.cachedKeySet = null;
_.cachedValues = null;
var EMPTY_0;
var Lcom_google_common_collect_ImmutableMap_2_classLit = createForClass('com.google.common.collect', 'ImmutableMap', 712);
function $containsKey_0(this$static, key) {
    return safeContainsKey(this$static.delegate, key);
}
function $get_3(this$static, key) {
    return key == null ? null : safeGet(this$static.delegate, key);
}
function ForwardingImmutableMap(entries) {
    var delegate, entry, entry$array, entry$index, entry$max, key, previous;
    delegate = new LinkedHashMap;
    for(entry$array = entries, entry$index = 0, entry$max = entry$array.length; entry$index < entry$max; ++entry$index){
        entry = entry$array[entry$index];
        key = checkNotNull(entry.getKey());
        previous = $put_11(delegate, key, checkNotNull(entry.getValue()));
        if (previous != null) throw toJs(new IllegalArgumentException_0('duplicate key: ' + key));
    }
    this.delegate = ($clinit_Collections(), new Collections$UnmodifiableMap(delegate));
}
defineClass(713, 712, $intern_28);
_.containsKey = function containsKey_4(key) {
    return $containsKey_0(this, key);
};
_.containsValue = function containsValue_1(value_0) {
    return $containsValue_3(this.delegate, value_0);
};
_.createEntrySet_1 = function createEntrySet_0() {
    return unsafeDelegate(new ForwardingImmutableMap$1(this));
};
_.createKeySet_1 = function createKeySet_7() {
    return unsafeDelegate($keySet_1(this.delegate));
};
_.createValues = function createValues_0() {
    return $clinit_ImmutableCollection(), new ForwardingImmutableCollection($values_2(this.delegate));
};
_.equals_0 = function equals_20(object) {
    return $equals_7(this.delegate, object);
};
_.get_3 = function get_16(key) {
    return $get_3(this, key);
};
_.hashCode_1 = function hashCode_22() {
    return hashCode__I__devirtual$(this.delegate.map_0);
};
_.isEmpty = function isEmpty_10() {
    return this.delegate.map_0.isEmpty();
};
_.size_1 = function size_16() {
    return this.delegate.map_0.size_1();
};
_.toString_0 = function toString_23() {
    return toString_40(this.delegate.map_0);
};
var Lcom_google_common_collect_ForwardingImmutableMap_2_classLit = createForClass('com.google.common.collect', 'ForwardingImmutableMap', 713);
defineClass(2018, 2017, $intern_29);
_.delegate_0 = function delegate_1() {
    return this.delegate_2();
};
_.delegate_1 = function delegate_2() {
    return this.delegate_2();
};
_.spliterator_0 = function spliterator_17() {
    return new Spliterators$IteratorSpliterator(this, 1);
};
_.equals_0 = function equals_21(object) {
    return object === this || this.delegate_2().equals_0(object);
};
_.hashCode_1 = function hashCode_23() {
    return this.delegate_2().hashCode_1();
};
var Lcom_google_common_collect_ForwardingSet_2_classLit = createForClass('com.google.common.collect', 'ForwardingSet', 2018);
function ForwardingImmutableMap$1(this$0) {
    this.this$01 = this$0;
}
defineClass(1050, 2018, $intern_29, ForwardingImmutableMap$1);
_.delegate_0 = function delegate_3() {
    return $entrySet_2(this.this$01.delegate);
};
_.delegate_1 = function delegate_4() {
    return $entrySet_2(this.this$01.delegate);
};
_.contains = function contains_14(object) {
    if (instanceOf(object, 43) && castTo(object, 43).getKey() == null) return false;
    try {
        return $contains_3($entrySet_2(this.this$01.delegate), object);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 211)) return false;
        else throw toJs($e0);
    }
};
_.delegate_2 = function delegate_5() {
    return $entrySet_2(this.this$01.delegate);
};
_.toArray_0 = function toArray_7(array) {
    var result;
    result = $toArray_4($entrySet_2(this.this$01.delegate), array);
    $entrySet_2(this.this$01.delegate).coll.size_1() < result.length && setCheck(result, $entrySet_2(this.this$01.delegate).coll.size_1(), null);
    return result;
};
var Lcom_google_common_collect_ForwardingImmutableMap$1_2_classLit = createForClass('com.google.common.collect', 'ForwardingImmutableMap/1', 1050);
function unsafeDelegate(delegate) {
    $clinit_ImmutableCollection();
    switch(delegate.size_1()){
        case 0:
            return $clinit_RegularImmutableSet(), EMPTY_2;
        case 1:
            return new SingletonImmutableSet(delegate.iterator_0().next_1());
        default:
            return new RegularImmutableSet(delegate);
    }
}
defineClass(2025, 2024, $intern_30);
_.iterator_0 = function iterator_19() {
    return this.iterator_1();
};
_.spliterator_0 = function spliterator_18() {
    return new Spliterators$IteratorSpliterator(this, 1);
};
_.equals_0 = function equals_22(obj) {
    return equalsImpl_3(this, obj);
};
_.hashCode_1 = function hashCode_24() {
    return hashCodeImpl_0(this);
};
var Lcom_google_common_collect_ImmutableSet_2_classLit = createForClass('com.google.common.collect', 'ImmutableSet', 2025);
function ForwardingImmutableSet(delegate) {
    $clinit_ImmutableCollection();
    this.delegate = ($clinit_Collections(), new Collections$UnmodifiableSet(delegate));
}
defineClass(703, 2025, $intern_30);
_.iterator_0 = function iterator_21() {
    return unmodifiableIterator(new Collections$UnmodifiableCollectionIterator(this.delegate.coll.iterator_0()));
};
_.contains = function contains_15(object) {
    return object != null && $contains_2(this.delegate, object);
};
_.containsAll = function containsAll_5(targets) {
    return $containsAll_0(this.delegate, targets);
};
_.hashCode_1 = function hashCode_25() {
    return hashCode__I__devirtual$(this.delegate.coll);
};
_.isEmpty = function isEmpty_11() {
    return this.delegate.coll.isEmpty();
};
_.iterator_1 = function iterator_20() {
    return unmodifiableIterator(new Collections$UnmodifiableCollectionIterator(this.delegate.coll.iterator_0()));
};
_.size_1 = function size_17() {
    return this.delegate.coll.size_1();
};
_.toArray = function toArray_8() {
    return this.delegate.coll.toArray();
};
_.toArray_0 = function toArray_9(other) {
    return $toArray_3(this.delegate, other);
};
_.toString_0 = function toString_24() {
    return toString_40(this.delegate.coll);
};
var Lcom_google_common_collect_ForwardingImmutableSet_2_classLit = createForClass('com.google.common.collect', 'ForwardingImmutableSet', 703);
defineClass(2019, 2018, $intern_31);
_.delegate_0 = function delegate_6() {
    return this.unmodifiableDelegate;
};
_.delegate_1 = function delegate_7() {
    return this.unmodifiableDelegate;
};
_.delegate_2 = function delegate_8() {
    return this.unmodifiableDelegate;
};
_.spliterator_0 = function spliterator_19() {
    return new SortedSet$1(this);
};
var Lcom_google_common_collect_ForwardingSortedSet_2_classLit = createForClass('com.google.common.collect', 'ForwardingSortedSet', 2019);
function $clear_2(this$static) {
    this$static.size_0 = 0;
    fill_1(this$static.hashTableKToV, null);
    fill_1(this$static.hashTableVToK, null);
    this$static.firstInKeyInsertionOrder = null;
    this$static.lastInKeyInsertionOrder = null;
    ++this$static.modCount;
}
function $containsValue_1(this$static, value_0) {
    return !!$seekByValue(this$static, value_0, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15))));
}
function $delete(this$static, entry) {
    var bucketEntry, bucketEntry0, keyBucket, prevBucketEntry, valueBucket;
    keyBucket = entry.keyHash & this$static.mask;
    prevBucketEntry = null;
    for(bucketEntry0 = this$static.hashTableKToV[keyBucket];; bucketEntry0 = bucketEntry0.nextInKToVBucket){
        if (bucketEntry0 == entry) {
            !prevBucketEntry ? this$static.hashTableKToV[keyBucket] = entry.nextInKToVBucket : prevBucketEntry.nextInKToVBucket = entry.nextInKToVBucket;
            break;
        }
        prevBucketEntry = bucketEntry0;
    }
    valueBucket = entry.valueHash & this$static.mask;
    prevBucketEntry = null;
    for(bucketEntry = this$static.hashTableVToK[valueBucket];; bucketEntry = bucketEntry.nextInVToKBucket){
        if (bucketEntry == entry) {
            !prevBucketEntry ? this$static.hashTableVToK[valueBucket] = entry.nextInVToKBucket : prevBucketEntry.nextInVToKBucket = entry.nextInVToKBucket;
            break;
        }
        prevBucketEntry = bucketEntry;
    }
    !entry.prevInKeyInsertionOrder ? this$static.firstInKeyInsertionOrder = entry.nextInKeyInsertionOrder : entry.prevInKeyInsertionOrder.nextInKeyInsertionOrder = entry.nextInKeyInsertionOrder;
    !entry.nextInKeyInsertionOrder ? this$static.lastInKeyInsertionOrder = entry.prevInKeyInsertionOrder : entry.nextInKeyInsertionOrder.prevInKeyInsertionOrder = entry.prevInKeyInsertionOrder;
    --this$static.size_0;
    ++this$static.modCount;
}
function $forEach(this$static, action) {
    var entry;
    checkNotNull(action);
    for(entry = this$static.firstInKeyInsertionOrder; entry; entry = entry.nextInKeyInsertionOrder)action.accept_1(entry.key, entry.value_0);
}
function $get_4(this$static, key) {
    return valueOrNull($seekByKey(this$static, key, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(key == null ? 0 : hashCode__I__devirtual$(key), $intern_33)), 15)))));
}
function $insert(this$static, entry, oldEntryForKey) {
    var keyBucket, valueBucket;
    keyBucket = entry.keyHash & this$static.mask;
    entry.nextInKToVBucket = this$static.hashTableKToV[keyBucket];
    this$static.hashTableKToV[keyBucket] = entry;
    valueBucket = entry.valueHash & this$static.mask;
    entry.nextInVToKBucket = this$static.hashTableVToK[valueBucket];
    this$static.hashTableVToK[valueBucket] = entry;
    if (!oldEntryForKey) {
        entry.prevInKeyInsertionOrder = this$static.lastInKeyInsertionOrder;
        entry.nextInKeyInsertionOrder = null;
        !this$static.lastInKeyInsertionOrder ? this$static.firstInKeyInsertionOrder = entry : this$static.lastInKeyInsertionOrder.nextInKeyInsertionOrder = entry;
        this$static.lastInKeyInsertionOrder = entry;
    } else {
        entry.prevInKeyInsertionOrder = oldEntryForKey.prevInKeyInsertionOrder;
        !entry.prevInKeyInsertionOrder ? this$static.firstInKeyInsertionOrder = entry : entry.prevInKeyInsertionOrder.nextInKeyInsertionOrder = entry;
        entry.nextInKeyInsertionOrder = oldEntryForKey.nextInKeyInsertionOrder;
        !entry.nextInKeyInsertionOrder ? this$static.lastInKeyInsertionOrder = entry : entry.nextInKeyInsertionOrder.prevInKeyInsertionOrder = entry;
    }
    ++this$static.size_0;
    ++this$static.modCount;
}
function $inverse(this$static) {
    var result;
    result = this$static.inverse;
    return !result ? this$static.inverse = new HashBiMap$Inverse(this$static) : result;
}
function $put_3(this$static, key, value_0) {
    var keyHash, newEntry, oldEntryForKey, oldEntryForValue, valueHash;
    keyHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(key == null ? 0 : hashCode__I__devirtual$(key), $intern_33)), 15)));
    valueHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15)));
    oldEntryForKey = $seekByKey(this$static, key, keyHash);
    if (!!oldEntryForKey && valueHash == oldEntryForKey.valueHash && equal(value_0, oldEntryForKey.value_0)) return value_0;
    oldEntryForValue = $seekByValue(this$static, value_0, valueHash);
    if (oldEntryForValue) throw toJs(new IllegalArgumentException_0('value already present: ' + value_0));
    newEntry = new HashBiMap$BiEntry(key, keyHash, value_0, valueHash);
    if (oldEntryForKey) {
        $delete(this$static, oldEntryForKey);
        $insert(this$static, newEntry, oldEntryForKey);
        oldEntryForKey.prevInKeyInsertionOrder = null;
        oldEntryForKey.nextInKeyInsertionOrder = null;
        return oldEntryForKey.value_0;
    } else {
        $insert(this$static, newEntry, null);
        $rehashIfNecessary(this$static);
        return null;
    }
}
function $putInverse(this$static, value_0, key, force) {
    var keyHash, newEntry, oldEntryForKey, oldEntryForValue, valueHash;
    valueHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15)));
    keyHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(key == null ? 0 : hashCode__I__devirtual$(key), $intern_33)), 15)));
    oldEntryForValue = $seekByValue(this$static, value_0, valueHash);
    oldEntryForKey = $seekByKey(this$static, key, keyHash);
    if (!!oldEntryForValue && keyHash == oldEntryForValue.keyHash && equal(key, oldEntryForValue.key)) return key;
    else if (!!oldEntryForKey && !force) throw toJs(new IllegalArgumentException_0('key already present: ' + key));
    !!oldEntryForValue && $delete(this$static, oldEntryForValue);
    !!oldEntryForKey && $delete(this$static, oldEntryForKey);
    newEntry = new HashBiMap$BiEntry(key, keyHash, value_0, valueHash);
    $insert(this$static, newEntry, oldEntryForKey);
    if (oldEntryForKey) {
        oldEntryForKey.prevInKeyInsertionOrder = null;
        oldEntryForKey.nextInKeyInsertionOrder = null;
    }
    if (oldEntryForValue) {
        oldEntryForValue.prevInKeyInsertionOrder = null;
        oldEntryForValue.nextInKeyInsertionOrder = null;
    }
    $rehashIfNecessary(this$static);
    return !oldEntryForValue ? null : oldEntryForValue.key;
}
function $rehashIfNecessary(this$static) {
    var entry, newTableSize, oldKToV;
    oldKToV = this$static.hashTableKToV;
    if (needsResizing(this$static.size_0, oldKToV.length)) {
        newTableSize = oldKToV.length * 2;
        this$static.hashTableKToV = initUnidimensionalArray(Lcom_google_common_collect_HashBiMap$BiEntry_2_classLit, $intern_34, 304, newTableSize, 0, 1);
        this$static.hashTableVToK = initUnidimensionalArray(Lcom_google_common_collect_HashBiMap$BiEntry_2_classLit, $intern_34, 304, newTableSize, 0, 1);
        this$static.mask = newTableSize - 1;
        this$static.size_0 = 0;
        for(entry = this$static.firstInKeyInsertionOrder; entry; entry = entry.nextInKeyInsertionOrder)$insert(this$static, entry, entry);
        ++this$static.modCount;
    }
}
function $seekByKey(this$static, key, keyHash) {
    var entry;
    for(entry = this$static.hashTableKToV[keyHash & this$static.mask]; entry; entry = entry.nextInKToVBucket){
        if (keyHash == entry.keyHash && equal(key, entry.key)) return entry;
    }
    return null;
}
function $seekByValue(this$static, value_0, valueHash) {
    var entry;
    for(entry = this$static.hashTableVToK[valueHash & this$static.mask]; entry; entry = entry.nextInVToKBucket){
        if (valueHash == entry.valueHash && equal(value_0, entry.value_0)) return entry;
    }
    return null;
}
function HashBiMap() {
    var tableSize;
    checkNonnegative(16, 'expectedSize');
    tableSize = closedTableSize(16);
    this.hashTableKToV = initUnidimensionalArray(Lcom_google_common_collect_HashBiMap$BiEntry_2_classLit, $intern_34, 304, tableSize, 0, 1);
    this.hashTableVToK = initUnidimensionalArray(Lcom_google_common_collect_HashBiMap$BiEntry_2_classLit, $intern_34, 304, tableSize, 0, 1);
    this.firstInKeyInsertionOrder = null;
    this.lastInKeyInsertionOrder = null;
    this.size_0 = 0;
    this.mask = tableSize - 1;
    this.modCount = 0;
}
defineClass(528, 2023, $intern_28, HashBiMap);
_.putAll = function putAll_0(map_0) {
    $putAll(this, map_0);
};
_.values_0 = function values_5() {
    var result;
    return result = this.inverse, new HashBiMap$Inverse$InverseKeySet(!result ? this.inverse = new HashBiMap$Inverse(this) : result);
};
_.clear_0 = function clear_18() {
    $clear_2(this);
};
_.containsKey = function containsKey_5(key) {
    return !!$seekByKey(this, key, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(key == null ? 0 : hashCode__I__devirtual$(key), $intern_33)), 15))));
};
_.containsValue = function containsValue_2(value_0) {
    return $containsValue_1(this, value_0);
};
_.entryIterator = function entryIterator_2() {
    return new HashBiMap$1(this, this);
};
_.forEach = function forEach_6(action) {
    $forEach(this, action);
};
_.get_3 = function get_17(key) {
    return $get_4(this, key);
};
_.keySet_0 = function keySet_11() {
    return new HashBiMap$KeySet(this);
};
_.put = function put_3(key, value_0) {
    return $put_3(this, key, value_0);
};
_.remove_0 = function remove_25(key) {
    var entry;
    entry = $seekByKey(this, key, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(key == null ? 0 : hashCode__I__devirtual$(key), $intern_33)), 15))));
    if (!entry) return null;
    else {
        $delete(this, entry);
        entry.prevInKeyInsertionOrder = null;
        entry.nextInKeyInsertionOrder = null;
        return entry.value_0;
    }
};
_.size_1 = function size_18() {
    return this.size_0;
};
_.values_1 = function values_6() {
    var result;
    return result = this.inverse, new HashBiMap$Inverse$InverseKeySet(!result ? this.inverse = new HashBiMap$Inverse(this) : result);
};
_.mask = 0;
_.modCount = 0;
_.size_0 = 0;
var Lcom_google_common_collect_HashBiMap_2_classLit = createForClass('com.google.common.collect', 'HashBiMap', 528);
function $hasNext_0(this$static) {
    if (this$static.this$01.modCount != this$static.expectedModCount) throw toJs(new ConcurrentModificationException);
    return !!this$static.next_0 && this$static.remaining > 0;
}
function HashBiMap$Itr(this$0) {
    this.this$01 = this$0;
    this.next_0 = this.this$01.firstInKeyInsertionOrder;
    this.expectedModCount = this.this$01.modCount;
    this.remaining = this.this$01.size_0;
}
defineClass(529, 1, $intern_6);
_.forEachRemaining = function forEachRemaining_7(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_5() {
    return $hasNext_0(this);
};
_.next_1 = function next_6() {
    var entry;
    if (!$hasNext_0(this)) throw toJs(new NoSuchElementException);
    entry = castTo(requireNonNull(this.next_0), 304);
    this.next_0 = entry.nextInKeyInsertionOrder;
    this.toRemove = entry;
    --this.remaining;
    return this.output_0(entry);
};
_.remove = function remove_26() {
    if (this.this$01.modCount != this.expectedModCount) throw toJs(new ConcurrentModificationException);
    if (!this.toRemove) throw toJs(new IllegalStateException_0('no calls to next() since the last call to remove()'));
    $delete(this.this$01, this.toRemove);
    this.expectedModCount = this.this$01.modCount;
    this.toRemove = null;
};
_.expectedModCount = 0;
_.remaining = 0;
_.toRemove = null;
var Lcom_google_common_collect_HashBiMap$Itr_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Itr', 529);
function HashBiMap$1(this$0, this$0_1) {
    this.this$02 = this$0_1;
    HashBiMap$Itr.call(this, this$0);
}
defineClass(998, 529, $intern_6, HashBiMap$1);
_.output_0 = function output_2(entry) {
    return new HashBiMap$1$MapEntry(this, entry);
};
var Lcom_google_common_collect_HashBiMap$1_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/1', 998);
function HashBiMap$1$MapEntry(this$1, entry) {
    this.this$11 = this$1;
    this.delegate = entry;
}
defineClass(999, 355, $intern_15, HashBiMap$1$MapEntry);
_.getKey = function getKey_0() {
    return this.delegate.key;
};
_.getValue = function getValue_2() {
    return this.delegate.value_0;
};
_.setValue = function setValue_3(value_0) {
    var newEntry, oldValue, valueHash;
    oldValue = this.delegate.value_0;
    valueHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15)));
    if (valueHash == this.delegate.valueHash && (maskUndefined(value_0) === maskUndefined(oldValue) || value_0 != null && equals_Ljava_lang_Object__Z__devirtual$(value_0, oldValue))) return value_0;
    checkArgument_1(!$seekByValue(this.this$11.this$02, value_0, valueHash), value_0);
    $delete(this.this$11.this$02, this.delegate);
    newEntry = new HashBiMap$BiEntry(this.delegate.key, this.delegate.keyHash, value_0, valueHash);
    $insert(this.this$11.this$02, newEntry, this.delegate);
    this.delegate.prevInKeyInsertionOrder = null;
    this.delegate.nextInKeyInsertionOrder = null;
    this.this$11.expectedModCount = this.this$11.this$02.modCount;
    this.this$11.toRemove == this.delegate && (this.this$11.toRemove = newEntry);
    this.delegate = newEntry;
    return oldValue;
};
var Lcom_google_common_collect_HashBiMap$1$MapEntry_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/1/MapEntry', 999);
function ImmutableEntry(key, value_0) {
    this.key = key;
    this.value_0 = value_0;
}
defineClass(244, 355, {
    355: 1,
    244: 1,
    3: 1,
    43: 1
}, ImmutableEntry);
_.getKey = function getKey_1() {
    return this.key;
};
_.getValue = function getValue_3() {
    return this.value_0;
};
_.setValue = function setValue_4(value_0) {
    throw toJs(new UnsupportedOperationException);
};
var Lcom_google_common_collect_ImmutableEntry_2_classLit = createForClass('com.google.common.collect', 'ImmutableEntry', 244);
function HashBiMap$BiEntry(key, keyHash, value_0, valueHash) {
    ImmutableEntry.call(this, key, value_0);
    this.keyHash = keyHash;
    this.valueHash = valueHash;
}
defineClass(304, 244, {
    355: 1,
    304: 1,
    244: 1,
    3: 1,
    43: 1
}, HashBiMap$BiEntry);
_.keyHash = 0;
_.valueHash = 0;
var Lcom_google_common_collect_HashBiMap$BiEntry_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/BiEntry', 304);
function $get_5(this$static, value_0) {
    return keyOrNull($seekByValue(this$static.this$01, value_0, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15)))));
}
function HashBiMap$Inverse(this$0) {
    this.this$01 = this$0;
}
function lambda$0(action_0, k_1, v_2) {
    action_0.accept_1(v_2, k_1);
}
defineClass(604, 2023, $intern_28, HashBiMap$Inverse);
_.putAll = function putAll_1(map_0) {
    $putAll(this, map_0);
};
_.values_0 = function values_7() {
    return new HashBiMap$KeySet(this.this$01);
};
_.clear_0 = function clear_19() {
    $clear_2(this.this$01);
};
_.containsKey = function containsKey_6(value_0) {
    return $containsValue_1(this.this$01, value_0);
};
_.entryIterator = function entryIterator_3() {
    return new HashBiMap$Inverse$1(this, this.this$01);
};
_.forEach = function forEach_7(action) {
    checkNotNull(action);
    $forEach(this.this$01, new HashBiMap$Inverse$lambda$0$Type(action));
};
_.get_3 = function get_18(value_0) {
    return $get_5(this, value_0);
};
_.keySet_0 = function keySet_12() {
    return new HashBiMap$Inverse$InverseKeySet(this);
};
_.put = function put_4(value_0, key) {
    return $putInverse(this.this$01, value_0, key, false);
};
_.remove_0 = function remove_27(value_0) {
    var entry;
    entry = $seekByValue(this.this$01, value_0, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15))));
    if (!entry) return null;
    else {
        $delete(this.this$01, entry);
        entry.prevInKeyInsertionOrder = null;
        entry.nextInKeyInsertionOrder = null;
        return entry.key;
    }
};
_.size_1 = function size_19() {
    return this.this$01.size_0;
};
_.values_1 = function values_8() {
    return new HashBiMap$KeySet(this.this$01);
};
var Lcom_google_common_collect_HashBiMap$Inverse_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Inverse', 604);
function HashBiMap$Inverse$1(this$1, this$0) {
    this.this$11 = this$1;
    HashBiMap$Itr.call(this, this$0);
}
defineClass(995, 529, $intern_6, HashBiMap$Inverse$1);
_.output_0 = function output_3(entry) {
    return new HashBiMap$Inverse$1$InverseEntry(this, entry);
};
var Lcom_google_common_collect_HashBiMap$Inverse$1_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Inverse/1', 995);
function HashBiMap$Inverse$1$InverseEntry(this$2, entry) {
    this.this$21 = this$2;
    this.delegate = entry;
}
defineClass(996, 355, $intern_15, HashBiMap$Inverse$1$InverseEntry);
_.getKey = function getKey_2() {
    return this.delegate.value_0;
};
_.getValue = function getValue_4() {
    return this.delegate.key;
};
_.setValue = function setValue_5(key) {
    var keyHash, newEntry, oldKey;
    oldKey = this.delegate.key;
    keyHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(key == null ? 0 : hashCode__I__devirtual$(key), $intern_33)), 15)));
    if (keyHash == this.delegate.keyHash && (maskUndefined(key) === maskUndefined(oldKey) || key != null && equals_Ljava_lang_Object__Z__devirtual$(key, oldKey))) return key;
    checkArgument_1(!$seekByKey(this.this$21.this$11.this$01, key, keyHash), key);
    $delete(this.this$21.this$11.this$01, this.delegate);
    newEntry = new HashBiMap$BiEntry(key, keyHash, this.delegate.value_0, this.delegate.valueHash);
    this.delegate = newEntry;
    $insert(this.this$21.this$11.this$01, newEntry, null);
    this.this$21.expectedModCount = this.this$21.this$11.this$01.modCount;
    return oldKey;
};
var Lcom_google_common_collect_HashBiMap$Inverse$1$InverseEntry_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Inverse/1/InverseEntry', 996);
function HashBiMap$Inverse$InverseKeySet(this$1) {
    this.this$11 = this$1;
    Maps$KeySet.call(this, this$1);
}
defineClass(605, 527, $intern_10, HashBiMap$Inverse$InverseKeySet);
_.iterator_0 = function iterator_22() {
    return new HashBiMap$Inverse$InverseKeySet$1(this.this$11.this$01);
};
_.remove_1 = function remove_28(o) {
    var entry;
    entry = $seekByValue(this.this$11.this$01, o, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(o == null ? 0 : hashCode__I__devirtual$(o), $intern_33)), 15))));
    if (!entry) return false;
    else {
        $delete(this.this$11.this$01, entry);
        return true;
    }
};
var Lcom_google_common_collect_HashBiMap$Inverse$InverseKeySet_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Inverse/InverseKeySet', 605);
function HashBiMap$Inverse$InverseKeySet$1(this$0) {
    HashBiMap$Itr.call(this, this$0);
}
defineClass(994, 529, $intern_6, HashBiMap$Inverse$InverseKeySet$1);
_.output_0 = function output_4(entry) {
    return entry.value_0;
};
var Lcom_google_common_collect_HashBiMap$Inverse$InverseKeySet$1_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Inverse/InverseKeySet/1', 994);
function HashBiMap$Inverse$lambda$0$Type(action_0) {
    this.action_0 = action_0;
}
defineClass(997, 1, {}, HashBiMap$Inverse$lambda$0$Type);
_.accept_1 = function accept_6(arg0, arg1) {
    lambda$0(this.action_0, arg0, arg1);
};
var Lcom_google_common_collect_HashBiMap$Inverse$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/Inverse/lambda$0$Type', 997);
function HashBiMap$KeySet(this$0) {
    this.this$01 = this$0;
    Maps$KeySet.call(this, this$0);
}
defineClass(603, 527, $intern_10, HashBiMap$KeySet);
_.iterator_0 = function iterator_23() {
    return new HashBiMap$KeySet$1(this.this$01);
};
_.remove_1 = function remove_29(o) {
    var entry;
    entry = $seekByKey(this.this$01, o, toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(o == null ? 0 : hashCode__I__devirtual$(o), $intern_33)), 15))));
    if (!entry) return false;
    else {
        $delete(this.this$01, entry);
        entry.prevInKeyInsertionOrder = null;
        entry.nextInKeyInsertionOrder = null;
        return true;
    }
};
var Lcom_google_common_collect_HashBiMap$KeySet_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/KeySet', 603);
function HashBiMap$KeySet$1(this$0) {
    HashBiMap$Itr.call(this, this$0);
}
defineClass(993, 529, $intern_6, HashBiMap$KeySet$1);
_.output_0 = function output_5(entry) {
    return entry.key;
};
var Lcom_google_common_collect_HashBiMap$KeySet$1_2_classLit = createForClass('com.google.common.collect', 'HashBiMap/KeySet/1', 993);
function HashMultimapGwtSerializationDependencies(map_0) {
    AbstractSetMultimap.call(this, map_0);
}
defineClass(1087, 612, $intern_5);
var Lcom_google_common_collect_HashMultimapGwtSerializationDependencies_2_classLit = createForClass('com.google.common.collect', 'HashMultimapGwtSerializationDependencies', 1087);
function HashMultimap() {
    HashMultimapGwtSerializationDependencies.call(this, new HashMap_0(capacity_0(12)));
    checkArgument(true);
    this.expectedValuesPerKey = 2;
}
defineClass(269, 1087, $intern_5, HashMultimap);
_.createCollection = function createCollection_5() {
    return new HashSet_0(capacity_0(this.expectedValuesPerKey));
};
_.createCollection_1 = function createCollection_6() {
    return new HashSet_0(capacity_0(this.expectedValuesPerKey));
};
_.expectedValuesPerKey = 2;
var Lcom_google_common_collect_HashMultimap_2_classLit = createForClass('com.google.common.collect', 'HashMultimap', 269);
function closedTableSize(expectedEntries) {
    var tableSize;
    expectedEntries = $wnd.Math.max(expectedEntries, 2);
    tableSize = highestOneBit(expectedEntries);
    if (expectedEntries > tableSize) {
        tableSize <<= 1;
        return tableSize > 0 ? tableSize : $intern_35;
    }
    return tableSize;
}
function needsResizing(size_0, tableSize) {
    return size_0 > tableSize && tableSize < $intern_35;
}
defineClass(2043, 308, $intern_26);
_.contains = function contains_16(target) {
    return this.delegateCollection().contains(target);
};
_.isEmpty = function isEmpty_12() {
    return this.delegateCollection().isEmpty();
};
_.size_1 = function size_20() {
    return this.delegateCollection().size_1();
};
var Lcom_google_common_collect_ImmutableAsList_2_classLit = createForClass('com.google.common.collect', 'ImmutableAsList', 2043);
function ImmutableBiMap(delegate) {
    this.delegate = ($clinit_Collections(), new Collections$UnmodifiableMap(delegate));
}
defineClass(1976, 713, $intern_28);
_.values_2 = function values_9() {
    return $clinit_ImmutableCollection(), new SingletonImmutableSet(this.singleValue);
};
_.values_0 = function values_10() {
    return $clinit_ImmutableCollection(), new SingletonImmutableSet(this.singleValue);
};
_.values_1 = function values_11() {
    return $clinit_ImmutableCollection(), new SingletonImmutableSet(this.singleValue);
};
var Lcom_google_common_collect_ImmutableBiMap_2_classLit = createForClass('com.google.common.collect', 'ImmutableBiMap', 1976);
defineClass(2021, 1, {});
var Lcom_google_common_collect_ImmutableCollection$Builder_2_classLit = createForClass('com.google.common.collect', 'ImmutableCollection/Builder', 2021);
function ImmutableEnumSet(delegate) {
    ForwardingImmutableSet.call(this, delegate);
}
function asImmutable(delegate) {
    $clinit_ImmutableCollection();
    switch(delegate.size_0){
        case 0:
            return $clinit_RegularImmutableSet(), EMPTY_2;
        case 1:
            return new SingletonImmutableSet(getOnlyElement(new EnumSet$EnumSetImpl$IteratorImpl(delegate)));
        default:
            return new ImmutableEnumSet(delegate);
    }
}
defineClass(1010, 703, $intern_30, ImmutableEnumSet);
var Lcom_google_common_collect_ImmutableEnumSet_2_classLit = createForClass('com.google.common.collect', 'ImmutableEnumSet', 1010);
function ImmutableList$1(this$0, $anonymous0, $anonymous1) {
    this.this$01 = this$0;
    AbstractIndexedListIterator_0.call(this, $anonymous0, $anonymous1);
}
defineClass(957, 390, $intern_4, ImmutableList$1);
_.get_0 = function get_19(index_0) {
    return this.this$01.get_0(index_0);
};
var Lcom_google_common_collect_ImmutableList$1_2_classLit = createForClass('com.google.common.collect', 'ImmutableList/1', 957);
function ImmutableList$Builder(capacity) {
    this.contents = (checkNonnegative(capacity, 'initialArraySize'), new ArrayList_0(capacity));
}
defineClass(956, 2021, {}, ImmutableList$Builder);
var Lcom_google_common_collect_ImmutableList$Builder_2_classLit = createForClass('com.google.common.collect', 'ImmutableList/Builder', 956);
function ImmutableMap$1(val$entryIterator) {
    this.val$entryIterator2 = val$entryIterator;
}
defineClass(608, 204, $intern_3, ImmutableMap$1);
_.hasNext_0 = function hasNext_6() {
    return this.val$entryIterator2.hasNext_0();
};
_.next_1 = function next_7() {
    return castTo(this.val$entryIterator2.next_1(), 43).getKey();
};
var Lcom_google_common_collect_ImmutableMap$1_2_classLit = createForClass('com.google.common.collect', 'ImmutableMap/1', 608);
function ImmutableMap$2methodref$getKey$Type() {}
defineClass(1029, 1, {}, ImmutableMap$2methodref$getKey$Type);
_.apply_0 = function apply_9(arg0) {
    return castTo(arg0, 43).getKey();
};
var Lcom_google_common_collect_ImmutableMap$2methodref$getKey$Type_2_classLit = createForClass('com.google.common.collect', 'ImmutableMap/2methodref$getKey$Type', 1029);
function $put_4(this$static, key, value_0) {
    $add_3(this$static.entries_0, ($clinit_ImmutableMap(), checkEntryNotNull(key, value_0), new ImmutableEntry(key, value_0)));
    return this$static;
}
function ImmutableMap$Builder(initCapacity) {
    this.entries_0 = (checkNonnegative(initCapacity, 'initialArraySize'), new ArrayList_0(initCapacity));
}
defineClass(1028, 1, {}, ImmutableMap$Builder);
var Lcom_google_common_collect_ImmutableMap$Builder_2_classLit = createForClass('com.google.common.collect', 'ImmutableMap/Builder', 1028);
defineClass(2044, 2025, $intern_30);
_.asList_1 = function asList_1() {
    var result;
    return result = this.asList, !result ? this.asList = new IndexedImmutableSet$1(this) : result;
};
_.createAsList = function createAsList_0() {
    return new RegularImmutableAsList_0(this, $toArray_0(this, initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, this.size_1(), 5, 1)));
};
var Lcom_google_common_collect_ImmutableSet$CachingAsList_2_classLit = createForClass('com.google.common.collect', 'ImmutableSet/CachingAsList', 2044);
defineClass(2045, 2044, $intern_30);
_.iterator_0 = function iterator_25() {
    var entryIterator;
    return entryIterator = $entrySet_1(this.map_0).iterator_1(), new ImmutableMap$1(entryIterator);
};
_.createAsList = function createAsList_1() {
    return new IndexedImmutableSet$1(this);
};
_.forEach_0 = function forEach_8(consumer) {
    var i, n;
    checkNotNull(consumer);
    n = this.size_1();
    for(i = 0; i < n; i++)consumer.accept(castTo($entrySet_1(this.map_0).asList_1().get_0(i), 43).getKey());
};
_.iterator_1 = function iterator_24() {
    var result;
    return result = this.asList, $listIterator(!result ? this.asList = new IndexedImmutableSet$1(this) : result, 0);
};
_.spliterator_0 = function spliterator_20() {
    return indexed(this.size_1(), 1296, new IndexedImmutableSet$0methodref$get$Type(this));
};
var Lcom_google_common_collect_IndexedImmutableSet_2_classLit = createForClass('com.google.common.collect', 'IndexedImmutableSet', 2045);
function $get_6(this$static, index_0) {
    return castTo($entrySet_1(this$static.map_0).asList_1().get_0(index_0), 43).getKey();
}
function ImmutableMapKeySet(map_0) {
    $clinit_ImmutableCollection();
    this.map_0 = map_0;
}
defineClass(1190, 2045, $intern_30, ImmutableMapKeySet);
_.iterator_0 = function iterator_27() {
    var entryIterator;
    return entryIterator = $entrySet_1(this.map_0).iterator_1(), new ImmutableMap$1(entryIterator);
};
_.contains = function contains_17(object) {
    return this.map_0.containsKey(object);
};
_.forEach_0 = function forEach_9(action) {
    checkNotNull(action);
    $forEach_2(this.map_0, new ImmutableMapKeySet$lambda$0$Type(action));
};
_.iterator_1 = function iterator_26() {
    var entryIterator;
    return entryIterator = $entrySet_1(this.map_0).iterator_1(), new ImmutableMap$1(entryIterator);
};
_.size_1 = function size_21() {
    return this.map_0.size_1();
};
_.spliterator_0 = function spliterator_21() {
    return map_2($entrySet_1(this.map_0).spliterator_0(), new ImmutableMap$2methodref$getKey$Type);
};
var Lcom_google_common_collect_ImmutableMapKeySet_2_classLit = createForClass('com.google.common.collect', 'ImmutableMapKeySet', 1190);
function ImmutableMapKeySet$lambda$0$Type(action_0) {
    this.action_0 = action_0;
}
defineClass(1191, 1, {}, ImmutableMapKeySet$lambda$0$Type);
_.accept_1 = function accept_7(arg0, arg1) {
    $clinit_ImmutableCollection();
    this.action_0.accept(arg0);
};
var Lcom_google_common_collect_ImmutableMapKeySet$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'ImmutableMapKeySet/lambda$0$Type', 1191);
function ImmutableMapValues(map_0) {
    $clinit_ImmutableCollection();
    this.map_0 = map_0;
}
defineClass(1187, 2024, $intern_25, ImmutableMapValues);
_.iterator_0 = function iterator_29() {
    return new ImmutableMapValues$1(this);
};
_.asList_1 = function asList_2() {
    var entryList;
    entryList = $entrySet_1(this.map_0).asList_1();
    return new ImmutableMapValues$2(this, entryList);
};
_.contains = function contains_18(object) {
    return object != null && contains_19(new ImmutableMapValues$1(this), object);
};
_.iterator_1 = function iterator_28() {
    return new ImmutableMapValues$1(this);
};
_.size_1 = function size_22() {
    return this.map_0.size_1();
};
_.spliterator_0 = function spliterator_22() {
    return map_2($entrySet_1(this.map_0).spliterator_0(), new ImmutableMapValues$0methodref$getValue$Type);
};
var Lcom_google_common_collect_ImmutableMapValues_2_classLit = createForClass('com.google.common.collect', 'ImmutableMapValues', 1187);
function ImmutableMapValues$0methodref$getValue$Type() {}
defineClass(1188, 1, {}, ImmutableMapValues$0methodref$getValue$Type);
_.apply_0 = function apply_10(arg0) {
    return castTo(arg0, 43).getValue();
};
var Lcom_google_common_collect_ImmutableMapValues$0methodref$getValue$Type_2_classLit = createForClass('com.google.common.collect', 'ImmutableMapValues/0methodref$getValue$Type', 1188);
function ImmutableMapValues$1(this$0) {
    this.this$01 = this$0;
    this.entryItr = $entrySet_1(this.this$01.map_0).iterator_1();
}
defineClass(622, 204, $intern_3, ImmutableMapValues$1);
_.hasNext_0 = function hasNext_7() {
    return this.entryItr.hasNext_0();
};
_.next_1 = function next_8() {
    return castTo(this.entryItr.next_1(), 43).getValue();
};
var Lcom_google_common_collect_ImmutableMapValues$1_2_classLit = createForClass('com.google.common.collect', 'ImmutableMapValues/1', 622);
function ImmutableMapValues$2(this$0, val$entryList) {
    $clinit_ImmutableList();
    this.this$01 = this$0;
    this.val$entryList2 = val$entryList;
}
defineClass(1189, 2043, $intern_26, ImmutableMapValues$2);
_.delegateCollection = function delegateCollection() {
    return this.this$01;
};
_.get_0 = function get_20(index_0) {
    return castTo(this.val$entryList2.get_0(index_0), 43).getValue();
};
var Lcom_google_common_collect_ImmutableMapValues$2_2_classLit = createForClass('com.google.common.collect', 'ImmutableMapValues/2', 1189);
function IndexedImmutableSet$0methodref$get$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1192, 1, {}, IndexedImmutableSet$0methodref$get$Type);
_.apply_2 = function apply_11(arg0) {
    return $get_6(this.$$outer_0, arg0);
};
var Lcom_google_common_collect_IndexedImmutableSet$0methodref$get$Type_2_classLit = createForClass('com.google.common.collect', 'IndexedImmutableSet/0methodref$get$Type', 1192);
function IndexedImmutableSet$1(this$0) {
    $clinit_ImmutableList();
    this.this$01 = this$0;
}
defineClass(623, 2043, $intern_26, IndexedImmutableSet$1);
_.delegateCollection = function delegateCollection_0() {
    return this.this$01;
};
_.get_0 = function get_21(index_0) {
    return $get_6(this.this$01, index_0);
};
_.size_1 = function size_23() {
    return this.this$01.map_0.size_1();
};
var Lcom_google_common_collect_IndexedImmutableSet$1_2_classLit = createForClass('com.google.common.collect', 'IndexedImmutableSet/1', 623);
function addAll_6(addTo, elementsToAdd) {
    var c;
    if (instanceOf(elementsToAdd, 16)) {
        c = castTo(elementsToAdd, 16);
        return addTo.addAll(c);
    }
    return addAll_7(addTo, castTo(checkNotNull(elementsToAdd), 20).iterator_0());
}
function all_0(iterable, predicate) {
    return all_1(iterable.iterator_0(), predicate);
}
function any_0(iterable, predicate) {
    return indexOf_2(iterable.iterator_0(), predicate) != -1;
}
function concat_0(inputs) {
    return checkNotNull(inputs), new FluentIterable$2(inputs);
}
function filter_0(unfiltered, retainIfTrue) {
    checkNotNull(unfiltered);
    checkNotNull(retainIfTrue);
    return new Iterables$4(unfiltered, retainIfTrue);
}
function get_22(iterable) {
    checkNotNull(iterable);
    return get_23(new Iterators$ConcatenatedIterator(transform_2(iterable.val$inputs1.iterator_0(), new Iterables$10)));
}
function getLast(iterable) {
    var list;
    if (iterable) {
        list = iterable;
        if (list.isEmpty()) throw toJs(new NoSuchElementException);
        return list.get_0(list.size_1() - 1);
    }
    return getLast_0(iterable.iterator_0());
}
function isEmpty_13(iterable) {
    if (instanceOf(iterable, 16)) return castTo(iterable, 16).isEmpty();
    return !iterable.iterator_0().hasNext_0();
}
function transform_1(fromIterable, function_0) {
    checkNotNull(fromIterable);
    checkNotNull(function_0);
    return new Iterables$5(fromIterable, function_0);
}
function Iterables$10() {}
defineClass(41, 1, {}, Iterables$10);
_.apply_0 = function apply_12(iterable) {
    return castTo(iterable, 20).iterator_0();
};
_.equals_0 = function equals_23(other) {
    return this === other;
};
var Lcom_google_common_collect_Iterables$10_2_classLit = createForClass('com.google.common.collect', 'Iterables/10', 41);
function $iterator_0(this$static) {
    return filter_1(this$static.val$unfiltered1.iterator_0(), this$static.val$retainIfTrue2);
}
function Iterables$4(val$unfiltered, val$retainIfTrue) {
    this.val$unfiltered1 = val$unfiltered;
    this.val$retainIfTrue2 = val$retainIfTrue;
    FluentIterable.call(this);
}
function lambda$0_0(retainIfTrue_0, action_1, a_2) {
    retainIfTrue_0.test_0(a_2) && action_1.accept(a_2);
}
defineClass(1030, 532, $intern_23, Iterables$4);
_.forEach_0 = function forEach_10(action) {
    checkNotNull(action);
    this.val$unfiltered1.forEach_0(new Iterables$4$lambda$0$Type(this.val$retainIfTrue2, action));
};
_.iterator_0 = function iterator_30() {
    return $iterator_0(this);
};
var Lcom_google_common_collect_Iterables$4_2_classLit = createForClass('com.google.common.collect', 'Iterables/4', 1030);
function Iterables$4$lambda$0$Type(retainIfTrue_0, action_1) {
    this.retainIfTrue_0 = retainIfTrue_0;
    this.action_1 = action_1;
}
defineClass(1031, 1, $intern_19, Iterables$4$lambda$0$Type);
_.accept = function accept_8(arg0) {
    lambda$0_0(this.retainIfTrue_0, this.action_1, arg0);
};
var Lcom_google_common_collect_Iterables$4$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'Iterables/4/lambda$0$Type', 1031);
function Iterables$5(val$fromIterable, val$function) {
    this.val$fromIterable1 = val$fromIterable;
    this.val$function2 = val$function;
    FluentIterable.call(this);
}
defineClass(1032, 532, $intern_23, Iterables$5);
_.forEach_0 = function forEach_11(action) {
    checkNotNull(action);
    $forEach_0(this.val$fromIterable1, new Iterables$5$lambda$0$Type(action, this.val$function2));
};
_.iterator_0 = function iterator_31() {
    return transform_2(new AbstractEList$EIterator(this.val$fromIterable1), this.val$function2);
};
var Lcom_google_common_collect_Iterables$5_2_classLit = createForClass('com.google.common.collect', 'Iterables/5', 1032);
function Iterables$5$lambda$0$Type(action_0, function_1) {
    this.action_0 = action_0;
    this.function_1 = function_1;
}
defineClass(1033, 1, $intern_19, Iterables$5$lambda$0$Type);
_.accept = function accept_9(arg0) {
    this.action_0.accept($apply_18(arg0));
};
var Lcom_google_common_collect_Iterables$5$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'Iterables/5/lambda$0$Type', 1033);
function addAll_7(addTo, iterator) {
    var wasModified;
    checkNotNull(addTo);
    checkNotNull(iterator);
    wasModified = false;
    while(iterator.hasNext_0())wasModified = wasModified | addTo.add_2(iterator.next_1());
    return wasModified;
}
function advance(iterator) {
    var i;
    checkNotNull(iterator);
    checkArgument_0(true, 'numberToAdvance must be nonnegative');
    for(i = 0; i < 0 && $hasNext_1(iterator); i++)$next_0(iterator);
    return i;
}
function all_1(iterator, predicate) {
    var element;
    checkNotNull(predicate);
    while(iterator.hasNext_0()){
        element = iterator.next_1();
        if (!$apply_8(castTo(element, 9))) return false;
    }
    return true;
}
function clear_20(iterator) {
    checkNotNull(iterator);
    while(iterator.hasNext_0()){
        iterator.next_1();
        iterator.remove();
    }
}
function contains_19(iterator, element) {
    if (element == null) while(iterator.entryItr.hasNext_0()){
        if (castTo(iterator.entryItr.next_1(), 43).getValue() == null) return true;
    }
    else while(iterator.entryItr.hasNext_0()){
        if (equals_Ljava_lang_Object__Z__devirtual$(element, castTo(iterator.entryItr.next_1(), 43).getValue())) return true;
    }
    return false;
}
function elementsEqual(iterator1, iterator2) {
    var o1, o2;
    while(iterator1.hasNext_0()){
        if (!iterator2.hasNext_0()) return false;
        o1 = iterator1.next_1();
        o2 = iterator2.next_1();
        if (!(maskUndefined(o1) === maskUndefined(o2) || o1 != null && equals_Ljava_lang_Object__Z__devirtual$(o1, o2))) return false;
    }
    return !iterator2.hasNext_0();
}
function filter_1(unfiltered, retainIfTrue) {
    checkNotNull(unfiltered);
    checkNotNull(retainIfTrue);
    return new Iterators$5(unfiltered, retainIfTrue);
}
function get_23(iterator) {
    var skipped;
    skipped = advance(iterator);
    if (!$hasNext_1(iterator)) throw toJs(new IndexOutOfBoundsException_0('position (0) must be less than the number of elements that remained (' + skipped + ')'));
    return $next_0(iterator);
}
function getLast_0(iterator) {
    var current;
    while(true){
        current = iterator.next_1();
        if (!iterator.hasNext_0()) return current;
    }
}
function getLast_1(iterator) {
    return $hasNext_5(iterator.val$edgesIter2) ? getLast_0(iterator) : null;
}
function getNext(iterator) {
    return iterator.hasNext_0() ? iterator.next_1() : null;
}
function getOnlyElement(iterator) {
    var first, i, sb;
    first = iterator.next_1();
    if (!iterator.hasNext_0()) return first;
    sb = $append_10($append_11(new StringBuilder, 'expected one element but was: <'), first);
    for(i = 0; i < 4 && iterator.hasNext_0(); i++)$append_10((sb.string += ', ', sb), iterator.next_1());
    iterator.hasNext_0() && (sb.string += ', ...', sb);
    sb.string += '>';
    throw toJs(new IllegalArgumentException_0(sb.string));
}
function indexOf_2(iterator, predicate) {
    var current, i;
    checkNotNull_0(predicate, 'predicate');
    for(i = 0; iterator.hasNext_0(); i++){
        current = iterator.next_1();
        if (predicate.apply_1(current)) return i;
    }
    return -1;
}
function size_24(iterator) {
    var count;
    count = 0;
    while(iterator.hasNext_0()){
        iterator.next_1();
        count = add_20(count, 1);
    }
    return saturatedCast(count);
}
function toString_25(iterator) {
    var first, sb;
    sb = $append_5(new StringBuilder, 91);
    first = true;
    while(iterator.hasNext_0()){
        first || (sb.string += ', ', sb);
        first = false;
        $append_10(sb, iterator.next_1());
    }
    return (sb.string += ']', sb).string;
}
function transform_2(fromIterator, function_0) {
    checkNotNull(function_0);
    return new Iterators$6(fromIterator, function_0);
}
function unmodifiableIterator(iterator) {
    var result;
    checkNotNull(iterator);
    if (instanceOf(iterator, 204)) {
        result = castTo(iterator, 204);
        return result;
    }
    return new Iterators$1(iterator);
}
function Iterators$1(val$iterator) {
    this.val$iterator1 = val$iterator;
}
defineClass(1052, 204, $intern_3, Iterators$1);
_.hasNext_0 = function hasNext_8() {
    return this.val$iterator1.hasNext_0();
};
_.next_1 = function next_9() {
    return this.val$iterator1.next_1();
};
var Lcom_google_common_collect_Iterators$1_2_classLit = createForClass('com.google.common.collect', 'Iterators/1', 1052);
function Iterators$5(val$unfiltered, val$retainIfTrue) {
    this.val$unfiltered1 = val$unfiltered;
    this.val$retainIfTrue2 = val$retainIfTrue;
}
defineClass(1053, 697, $intern_3, Iterators$5);
_.computeNext = function computeNext() {
    var element;
    while(this.val$unfiltered1.hasNext_0()){
        element = this.val$unfiltered1.next_1();
        if (this.val$retainIfTrue2.apply_1(element)) return element;
    }
    return this.state = 2, null;
};
var Lcom_google_common_collect_Iterators$5_2_classLit = createForClass('com.google.common.collect', 'Iterators/5', 1053);
function TransformedIterator(backingIterator) {
    this.backingIterator = castTo(checkNotNull(backingIterator), 49);
}
defineClass(481, 1, $intern_6);
_.forEachRemaining = function forEachRemaining_8(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_9() {
    return this.backingIterator.hasNext_0();
};
_.next_1 = function next_10() {
    return this.transform_0(this.backingIterator.next_1());
};
_.remove = function remove_30() {
    this.backingIterator.remove();
};
var Lcom_google_common_collect_TransformedIterator_2_classLit = createForClass('com.google.common.collect', 'TransformedIterator', 481);
function Iterators$6($anonymous0, val$function) {
    this.val$function2 = val$function;
    TransformedIterator.call(this, $anonymous0);
}
defineClass(1054, 481, $intern_6, Iterators$6);
_.transform_0 = function transform_3(from) {
    return this.val$function2.apply_0(from);
};
var Lcom_google_common_collect_Iterators$6_2_classLit = createForClass('com.google.common.collect', 'Iterators/6', 1054);
function Iterators$9(val$value) {
    this.val$value1 = val$value;
}
defineClass(715, 204, $intern_3, Iterators$9);
_.hasNext_0 = function hasNext_10() {
    return !this.done_0;
};
_.next_1 = function next_11() {
    if (this.done_0) throw toJs(new NoSuchElementException);
    this.done_0 = true;
    return this.val$value1;
};
_.done_0 = false;
var Lcom_google_common_collect_Iterators$9_2_classLit = createForClass('com.google.common.collect', 'Iterators/9', 715);
function $clinit_Iterators$ArrayItr() {
    $clinit_Iterators$ArrayItr = emptyMethod;
    EMPTY_1 = new Iterators$ArrayItr(initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1));
}
function Iterators$ArrayItr(array) {
    AbstractIndexedListIterator_0.call(this, 0, 0);
    this.array = array;
    this.offset = 0;
}
defineClass(1051, 390, $intern_4, Iterators$ArrayItr);
_.get_0 = function get_24(index_0) {
    return this.array[this.offset + index_0];
};
_.offset = 0;
var EMPTY_1;
var Lcom_google_common_collect_Iterators$ArrayItr_2_classLit = createForClass('com.google.common.collect', 'Iterators/ArrayItr', 1051);
function $getTopMetaIterator(this$static) {
    while(!this$static.topMetaIterator || !this$static.topMetaIterator.hasNext_0()){
        if (!!this$static.metaIterators && !$isEmpty(this$static.metaIterators)) this$static.topMetaIterator = castTo($removeFirst(this$static.metaIterators), 49);
        else return null;
    }
    return this$static.topMetaIterator;
}
function $hasNext_1(this$static) {
    var topConcat;
    while(!castTo(checkNotNull(this$static.iterator), 49).hasNext_0()){
        this$static.topMetaIterator = $getTopMetaIterator(this$static);
        if (!this$static.topMetaIterator) return false;
        this$static.iterator = castTo(this$static.topMetaIterator.next_1(), 49);
        if (instanceOf(this$static.iterator, 37)) {
            topConcat = castTo(this$static.iterator, 37);
            this$static.iterator = topConcat.iterator;
            !this$static.metaIterators && (this$static.metaIterators = new ArrayDeque);
            $addFirst(this$static.metaIterators, this$static.topMetaIterator);
            if (topConcat.metaIterators) while(!$isEmpty(topConcat.metaIterators))$addFirst(this$static.metaIterators, castTo($removeLast(topConcat.metaIterators), 49));
            this$static.topMetaIterator = topConcat.topMetaIterator;
        }
    }
    return true;
}
function $next_0(this$static) {
    if ($hasNext_1(this$static)) {
        this$static.toRemove = this$static.iterator;
        return this$static.iterator.next_1();
    } else throw toJs(new NoSuchElementException);
}
function Iterators$ConcatenatedIterator(metaIterator) {
    this.iterator = ($clinit_Iterators$ArrayItr(), EMPTY_1);
    this.topMetaIterator = castTo(checkNotNull(metaIterator), 49);
}
defineClass(37, 1, {
    37: 1,
    49: 1
}, Iterators$ConcatenatedIterator);
_.forEachRemaining = function forEachRemaining_9(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_11() {
    return $hasNext_1(this);
};
_.next_1 = function next_12() {
    return $next_0(this);
};
_.remove = function remove_31() {
    if (!this.toRemove) throw toJs(new IllegalStateException_0('no calls to next() since the last call to remove()'));
    this.toRemove.remove();
    this.toRemove = null;
};
var Lcom_google_common_collect_Iterators$ConcatenatedIterator_2_classLit = createForClass('com.google.common.collect', 'Iterators/ConcatenatedIterator', 37);
function $compareTo(this$static, other) {
    return this$static.ordinal - other.ordinal;
}
function $name(this$static) {
    return this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal;
}
function $toString_3(this$static) {
    return this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal;
}
function Enum(name_0, ordinal) {
    this.name_0 = name_0;
    this.ordinal = ordinal;
}
function createValueOfMap(enumConstants) {
    var result, value_0, value$array, value$index, value$max;
    result = {};
    for(value$array = enumConstants, value$index = 0, value$max = value$array.length; value$index < value$max; ++value$index){
        value_0 = value$array[value$index];
        result[':' + (value_0.name_0 != null ? value_0.name_0 : '' + value_0.ordinal)] = value_0;
    }
    return result;
}
function valueOf(map_0, name_0) {
    var result;
    checkCriticalNotNull(name_0);
    result = map_0[':' + name_0];
    checkCriticalArgument_0(!!result, 'Enum constant undefined: ' + name_0);
    return result;
}
function valueOf_0(enumType, name_0) {
    var enumValueOfFunc;
    enumValueOfFunc = (checkCriticalNotNull(enumType), enumType).enumValueOfFunc;
    checkCriticalArgument(!!enumValueOfFunc);
    checkCriticalNotNull(name_0);
    return enumValueOfFunc(name_0);
}
defineClass(23, 1, {
    3: 1,
    34: 1,
    23: 1
});
_.compareTo_0 = function compareTo_3(other) {
    return $compareTo(this, castTo(other, 23));
};
_.equals_0 = function equals_24(other) {
    return this === other;
};
_.hashCode_1 = function hashCode_26() {
    return getObjectIdentityHashCode(this);
};
_.toString_0 = function toString_26() {
    return $toString_3(this);
};
_.ordinal = 0;
var Ljava_lang_Enum_2_classLit = createForClass('java.lang', 'Enum', 23);
function $clinit_Iterators$EmptyModifiableIterator() {
    $clinit_Iterators$EmptyModifiableIterator = emptyMethod;
    INSTANCE_2 = new Iterators$EmptyModifiableIterator;
}
function Iterators$EmptyModifiableIterator() {
    Enum.call(this, 'INSTANCE', 0);
}
function valueOf_1(name_0) {
    $clinit_Iterators$EmptyModifiableIterator();
    return valueOf(($clinit_Iterators$EmptyModifiableIterator$Map(), $MAP), name_0);
}
function values_12() {
    $clinit_Iterators$EmptyModifiableIterator();
    return stampJavaTypeInfo(getClassLiteralForArray(Lcom_google_common_collect_Iterators$EmptyModifiableIterator_2_classLit, 1), $intern_36, 534, 0, [
        INSTANCE_2
    ]);
}
defineClass(534, 23, {
    534: 1,
    3: 1,
    34: 1,
    23: 1,
    49: 1
}, Iterators$EmptyModifiableIterator);
_.forEachRemaining = function forEachRemaining_10(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_12() {
    return false;
};
_.next_1 = function next_13() {
    throw toJs(new NoSuchElementException);
};
_.remove = function remove_32() {
    checkState_0(false);
};
var INSTANCE_2;
var Lcom_google_common_collect_Iterators$EmptyModifiableIterator_2_classLit = createForEnum('com.google.common.collect', 'Iterators/EmptyModifiableIterator', 534, Ljava_lang_Enum_2_classLit, values_12, valueOf_1);
function $clinit_Iterators$EmptyModifiableIterator$Map() {
    $clinit_Iterators$EmptyModifiableIterator$Map = emptyMethod;
    $MAP = createValueOfMap(($clinit_Iterators$EmptyModifiableIterator(), stampJavaTypeInfo(getClassLiteralForArray(Lcom_google_common_collect_Iterators$EmptyModifiableIterator_2_classLit, 1), $intern_36, 534, 0, [
        INSTANCE_2
    ])));
}
var $MAP;
function LinkedHashMultimapGwtSerializationDependencies(map_0) {
    AbstractSetMultimap.call(this, map_0);
}
defineClass(1853, 612, $intern_5);
var Lcom_google_common_collect_LinkedHashMultimapGwtSerializationDependencies_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimapGwtSerializationDependencies', 1853);
function LinkedHashMultimap() {
    LinkedHashMultimapGwtSerializationDependencies.call(this, new LinkedHashMap_0(capacity_0(16)));
    checkNonnegative(2, 'expectedValuesPerKey');
    this.valueSetCapacity = 2;
    this.multimapHeaderEntry = new LinkedHashMultimap$ValueEntry(null, null, 0, null);
    succeedsInMultimap(this.multimapHeaderEntry, this.multimapHeaderEntry);
}
function succeedsInMultimap(pred, succ) {
    pred.successorInMultimap = succ;
    succ.predecessorInMultimap = pred;
}
function succeedsInValueSet(pred, succ) {
    pred.setSuccessorInValueSet(succ);
    succ.setPredecessorInValueSet(pred);
}
defineClass(1854, 1853, $intern_5, LinkedHashMultimap);
_.createCollection = function createCollection_7() {
    return new LinkedHashSet_0(capacity_0(this.valueSetCapacity));
};
_.clear_0 = function clear_21() {
    $clear(this);
    succeedsInMultimap(this.multimapHeaderEntry, this.multimapHeaderEntry);
};
_.createCollection_1 = function createCollection_8() {
    return new LinkedHashSet_0(capacity_0(this.valueSetCapacity));
};
_.createCollection_0 = function createCollection_9(key) {
    return new LinkedHashMultimap$ValueSet(this, key, this.valueSetCapacity);
};
_.entryIterator = function entryIterator_4() {
    return new LinkedHashMultimap$1(this);
};
_.entrySpliterator = function entrySpliterator_3() {
    var result;
    return new Spliterators$IteratorSpliterator((result = this.entries_0, castTo(!result ? this.entries_0 = new AbstractMultimap$EntrySet(this) : result, 22)), 17);
};
_.keySet_0 = function keySet_13() {
    var result;
    return result = this.keySet, !result ? this.keySet = new AbstractMapBasedMultimap$KeySet(this, this.map_0) : result;
};
_.valueIterator_0 = function valueIterator_0() {
    return new Maps$2(new LinkedHashMultimap$1(this));
};
_.valueSpliterator = function valueSpliterator_0() {
    var result;
    return map_2(new Spliterators$IteratorSpliterator((result = this.entries_0, castTo(!result ? this.entries_0 = new AbstractMultimap$EntrySet(this) : result, 22)), 17), new LinkedHashMultimap$0methodref$getValue$Type);
};
_.valueSetCapacity = 2;
var Lcom_google_common_collect_LinkedHashMultimap_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimap', 1854);
function LinkedHashMultimap$0methodref$getValue$Type() {}
defineClass(1857, 1, {}, LinkedHashMultimap$0methodref$getValue$Type);
_.apply_0 = function apply_13(arg0) {
    return castTo(arg0, 43).getValue();
};
var Lcom_google_common_collect_LinkedHashMultimap$0methodref$getValue$Type_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimap/0methodref$getValue$Type', 1857);
function $next_1(this$static) {
    var result;
    if (this$static.nextEntry == this$static.this$01.multimapHeaderEntry) throw toJs(new NoSuchElementException);
    result = this$static.nextEntry;
    this$static.toRemove = result;
    this$static.nextEntry = castTo(requireNonNull(this$static.nextEntry.successorInMultimap), 226);
    return result;
}
function LinkedHashMultimap$1(this$0) {
    this.this$01 = this$0;
    this.nextEntry = castTo(requireNonNull(this.this$01.multimapHeaderEntry.successorInMultimap), 226);
}
defineClass(813, 1, $intern_6, LinkedHashMultimap$1);
_.forEachRemaining = function forEachRemaining_11(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_14() {
    return $next_1(this);
};
_.hasNext_0 = function hasNext_13() {
    return this.nextEntry != this.this$01.multimapHeaderEntry;
};
_.remove = function remove_33() {
    checkState_0(!!this.toRemove);
    $remove_0(this.this$01, this.toRemove.key, this.toRemove.value_0);
    this.toRemove = null;
};
var Lcom_google_common_collect_LinkedHashMultimap$1_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimap/1', 813);
function LinkedHashMultimap$ValueEntry(key, value_0, smearedValueHash, nextInValueBucket) {
    ImmutableEntry.call(this, key, value_0);
    this.smearedValueHash = smearedValueHash;
    this.nextInValueBucket = nextInValueBucket;
}
defineClass(226, 244, {
    355: 1,
    244: 1,
    226: 1,
    588: 1,
    3: 1,
    43: 1
}, LinkedHashMultimap$ValueEntry);
_.getSuccessorInValueSet = function getSuccessorInValueSet() {
    return castTo(requireNonNull(this.successorInValueSet), 588);
};
_.setPredecessorInValueSet = function setPredecessorInValueSet(entry) {
    this.predecessorInValueSet = entry;
};
_.setSuccessorInValueSet = function setSuccessorInValueSet(entry) {
    this.successorInValueSet = entry;
};
_.smearedValueHash = 0;
var Lcom_google_common_collect_LinkedHashMultimap$ValueEntry_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimap/ValueEntry', 226);
function $rehashIfNecessary_0(this$static) {
    var bucket, entry, hashTable, mask, valueEntry;
    if (needsResizing(this$static.size_0, this$static.hashTable.length)) {
        hashTable = initUnidimensionalArray(Lcom_google_common_collect_LinkedHashMultimap$ValueEntry_2_classLit, $intern_34, 226, this$static.hashTable.length * 2, 0, 1);
        this$static.hashTable = hashTable;
        mask = hashTable.length - 1;
        for(entry = this$static.firstEntry; entry != this$static; entry = entry.getSuccessorInValueSet()){
            valueEntry = castTo(entry, 226);
            bucket = valueEntry.smearedValueHash & mask;
            valueEntry.nextInValueBucket = hashTable[bucket];
            hashTable[bucket] = valueEntry;
        }
    }
}
function $remove_3(this$static, o) {
    var bucket, entry, prev, smearedHash;
    smearedHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(o == null ? 0 : hashCode__I__devirtual$(o), $intern_33)), 15)));
    bucket = smearedHash & this$static.hashTable.length - 1;
    prev = null;
    for(entry = this$static.hashTable[bucket]; entry; prev = entry, entry = entry.nextInValueBucket)if (entry.smearedValueHash == smearedHash && equal(entry.value_0, o)) {
        !prev ? this$static.hashTable[bucket] = entry.nextInValueBucket : prev.nextInValueBucket = entry.nextInValueBucket;
        succeedsInValueSet(castTo(requireNonNull(entry.predecessorInValueSet), 588), castTo(requireNonNull(entry.successorInValueSet), 588));
        succeedsInMultimap(castTo(requireNonNull(entry.predecessorInMultimap), 226), castTo(requireNonNull(entry.successorInMultimap), 226));
        --this$static.size_0;
        ++this$static.modCount;
        return true;
    }
    return false;
}
function LinkedHashMultimap$ValueSet(this$0, key, expectedValues) {
    var hashTable, tableSize;
    this.this$01 = this$0;
    this.key = key;
    this.firstEntry = this;
    this.lastEntry = this;
    tableSize = closedTableSize(expectedValues);
    hashTable = initUnidimensionalArray(Lcom_google_common_collect_LinkedHashMultimap$ValueEntry_2_classLit, $intern_34, 226, tableSize, 0, 1);
    this.hashTable = hashTable;
}
defineClass(1855, 2014, {
    588: 1,
    20: 1,
    31: 1,
    16: 1,
    22: 1
}, LinkedHashMultimap$ValueSet);
_.add_2 = function add_10(value_0) {
    var bucket, entry, newEntry, rowHead, smearedHash;
    smearedHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(value_0 == null ? 0 : hashCode__I__devirtual$(value_0), $intern_33)), 15)));
    bucket = smearedHash & this.hashTable.length - 1;
    rowHead = this.hashTable[bucket];
    for(entry = rowHead; entry; entry = entry.nextInValueBucket){
        if (entry.smearedValueHash == smearedHash && equal(entry.value_0, value_0)) return false;
    }
    newEntry = new LinkedHashMultimap$ValueEntry(this.key, value_0, smearedHash, rowHead);
    succeedsInValueSet(this.lastEntry, newEntry);
    newEntry.successorInValueSet = this;
    this.lastEntry = newEntry;
    succeedsInMultimap(castTo(requireNonNull(this.this$01.multimapHeaderEntry.predecessorInMultimap), 226), newEntry);
    succeedsInMultimap(newEntry, this.this$01.multimapHeaderEntry);
    this.hashTable[bucket] = newEntry;
    ++this.size_0;
    ++this.modCount;
    $rehashIfNecessary_0(this);
    return true;
};
_.clear_0 = function clear_22() {
    var entry, valueEntry;
    fill_1(this.hashTable, null);
    this.size_0 = 0;
    for(entry = this.firstEntry; entry != this; entry = entry.getSuccessorInValueSet()){
        valueEntry = castTo(entry, 226);
        succeedsInMultimap(castTo(requireNonNull(valueEntry.predecessorInMultimap), 226), castTo(requireNonNull(valueEntry.successorInMultimap), 226));
    }
    this.firstEntry = this;
    this.lastEntry = this;
    ++this.modCount;
};
_.contains = function contains_20(o) {
    var entry, smearedHash;
    smearedHash = toInt_0(mul_0($intern_32, rotateLeft(toInt_0(mul_0(o == null ? 0 : hashCode__I__devirtual$(o), $intern_33)), 15)));
    for(entry = this.hashTable[smearedHash & this.hashTable.length - 1]; entry; entry = entry.nextInValueBucket){
        if (entry.smearedValueHash == smearedHash && equal(entry.value_0, o)) return true;
    }
    return false;
};
_.forEach_0 = function forEach_12(action) {
    var entry;
    checkNotNull(action);
    for(entry = this.firstEntry; entry != this; entry = entry.getSuccessorInValueSet())action.accept(castTo(entry, 226).value_0);
};
_.getSuccessorInValueSet = function getSuccessorInValueSet_0() {
    return this.firstEntry;
};
_.iterator_0 = function iterator_32() {
    return new LinkedHashMultimap$ValueSet$1(this);
};
_.remove_1 = function remove_34(o) {
    return $remove_3(this, o);
};
_.setPredecessorInValueSet = function setPredecessorInValueSet_0(entry) {
    this.lastEntry = entry;
};
_.setSuccessorInValueSet = function setSuccessorInValueSet_0(entry) {
    this.firstEntry = entry;
};
_.size_1 = function size_25() {
    return this.size_0;
};
_.modCount = 0;
_.size_0 = 0;
var Lcom_google_common_collect_LinkedHashMultimap$ValueSet_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimap/ValueSet', 1855);
function $checkForComodification(this$static) {
    if (this$static.this$11.modCount != this$static.expectedModCount) throw toJs(new ConcurrentModificationException);
}
function LinkedHashMultimap$ValueSet$1(this$1) {
    this.this$11 = this$1;
    this.nextEntry = this.this$11.firstEntry;
    this.expectedModCount = this.this$11.modCount;
}
defineClass(1856, 1, $intern_6, LinkedHashMultimap$ValueSet$1);
_.forEachRemaining = function forEachRemaining_12(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_14() {
    return $checkForComodification(this), this.nextEntry != this.this$11;
};
_.next_1 = function next_15() {
    var entry, result;
    $checkForComodification(this);
    if (this.nextEntry == this.this$11) throw toJs(new NoSuchElementException);
    entry = castTo(this.nextEntry, 226);
    result = entry.value_0;
    this.toRemove = entry;
    this.nextEntry = castTo(requireNonNull(entry.successorInValueSet), 588);
    return result;
};
_.remove = function remove_35() {
    $checkForComodification(this);
    checkState_0(!!this.toRemove);
    $remove_3(this.this$11, this.toRemove.value_0);
    this.expectedModCount = this.this$11.modCount;
    this.toRemove = null;
};
_.expectedModCount = 0;
var Lcom_google_common_collect_LinkedHashMultimap$ValueSet$1_2_classLit = createForClass('com.google.common.collect', 'LinkedHashMultimap/ValueSet/1', 1856);
function $addNode(this$static, key, value_0, nextSibling) {
    var keyList, keyTail, node;
    node = new LinkedListMultimap$Node(key, value_0);
    if (!this$static.head) {
        this$static.head = this$static.tail = node;
        $put_6(this$static.keyToKeyList, key, new LinkedListMultimap$KeyList(node));
        ++this$static.modCount;
    } else if (!nextSibling) {
        castTo(requireNonNull(this$static.tail), 495).next_0 = node;
        node.previous = this$static.tail;
        this$static.tail = node;
        keyList = castTo($get_10(this$static.keyToKeyList, key), 260);
        if (!keyList) {
            $put_6(this$static.keyToKeyList, key, keyList = new LinkedListMultimap$KeyList(node));
            ++this$static.modCount;
        } else {
            ++keyList.count;
            keyTail = keyList.tail;
            keyTail.nextSibling = node;
            node.previousSibling = keyTail;
            keyList.tail = node;
        }
    } else {
        keyList = castTo(requireNonNull(castTo($get_10(this$static.keyToKeyList, key), 260)), 260);
        ++keyList.count;
        node.previous = nextSibling.previous;
        node.previousSibling = nextSibling.previousSibling;
        node.next_0 = nextSibling;
        node.nextSibling = nextSibling;
        !nextSibling.previousSibling ? keyList.head = node : nextSibling.previousSibling.nextSibling = node;
        !nextSibling.previous ? this$static.head = node : nextSibling.previous.next_0 = node;
        nextSibling.previous = node;
        nextSibling.previousSibling = node;
    }
    ++this$static.size_0;
    return node;
}
function $clear_3(this$static) {
    this$static.head = null;
    this$static.tail = null;
    $reset(this$static.keyToKeyList);
    this$static.size_0 = 0;
    ++this$static.modCount;
}
function $containsKey_1(this$static, key) {
    return $containsKey_3(this$static.keyToKeyList, key);
}
function $removeAll_2(this$static, key) {
    var castKey, oldValues;
    castKey = key;
    oldValues = unmodifiableList(newArrayList_0(new LinkedListMultimap$ValueForKeyIterator(this$static, castKey)));
    clear_20(new LinkedListMultimap$ValueForKeyIterator(this$static, castKey));
    return oldValues;
}
function $removeNode(this$static, node) {
    var keyList;
    node.previous ? node.previous.next_0 = node.next_0 : this$static.head = node.next_0;
    node.next_0 ? node.next_0.previous = node.previous : this$static.tail = node.previous;
    if (!node.previousSibling && !node.nextSibling) {
        keyList = castTo(requireNonNull(castTo($remove_6(this$static.keyToKeyList, node.key), 260)), 260);
        keyList.count = 0;
        ++this$static.modCount;
    } else {
        keyList = castTo(requireNonNull(castTo($get_10(this$static.keyToKeyList, node.key), 260)), 260);
        --keyList.count;
        !node.previousSibling ? keyList.head = castTo(requireNonNull(node.nextSibling), 495) : node.previousSibling.nextSibling = node.nextSibling;
        !node.nextSibling ? keyList.tail = castTo(requireNonNull(node.previousSibling), 495) : node.nextSibling.previousSibling = node.previousSibling;
    }
    --this$static.size_0;
}
function LinkedListMultimap() {
    this.keyToKeyList = new HashMap_0(capacity_0(12));
}
defineClass(762, 2030, $intern_5, LinkedListMultimap);
_.asMap_0 = function asMap_4() {
    var result;
    return result = this.asMap, !result ? this.asMap = new Multimaps$AsMap(this) : result;
};
_.equals_0 = function equals_25(object) {
    return equalsImpl_1(this, object);
};
_.get_1 = function get_25(key) {
    return new LinkedListMultimap$1(this, key);
};
_.removeAll = function removeAll_6(key) {
    return $removeAll_2(this, key);
};
_.clear_0 = function clear_23() {
    $clear_3(this);
};
_.containsKey = function containsKey_7(key) {
    return $containsKey_1(this, key);
};
_.createAsMap = function createAsMap_0() {
    return new Multimaps$AsMap(this);
};
_.createKeySet = function createKeySet_8() {
    return new LinkedListMultimap$1KeySetImpl(this);
};
_.get_2 = function get_26(key) {
    return new LinkedListMultimap$1(this, key);
};
_.isEmpty = function isEmpty_14() {
    return !this.head;
};
_.removeAll_0 = function removeAll_7(key) {
    return $removeAll_2(this, key);
};
_.size_1 = function size_26() {
    return this.size_0;
};
_.modCount = 0;
_.size_0 = 0;
var Lcom_google_common_collect_LinkedListMultimap_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap', 762);
function $equals_2(this$static, o) {
    var elem, elem$iterator, elemOther, iterOther, other;
    if (maskUndefined(o) === maskUndefined(this$static)) return true;
    if (!instanceOf(o, 15)) return false;
    other = castTo(o, 15);
    if (this$static.size_1() != other.size_1()) return false;
    iterOther = other.iterator_0();
    for(elem$iterator = this$static.iterator_0(); elem$iterator.hasNext_0();){
        elem = elem$iterator.next_1();
        elemOther = iterOther.next_1();
        if (!(maskUndefined(elem) === maskUndefined(elemOther) || elem != null && equals_Ljava_lang_Object__Z__devirtual$(elem, elemOther))) return false;
    }
    return true;
}
function $indexOf(this$static, toFind) {
    var i, n;
    for(i = 0, n = this$static.size_1(); i < n; ++i){
        if (equals_57(toFind, this$static.get_0(i))) return i;
    }
    return -1;
}
defineClass(55, 31, $intern_37);
_.sort_0 = function sort_2(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_23() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.add_3 = function add_11(index_0, element) {
    throw toJs(new UnsupportedOperationException_0('Add not supported on this list'));
};
_.add_2 = function add_12(obj) {
    this.add_3(this.size_1(), obj);
    return true;
};
_.addAll_0 = function addAll_8(index_0, c) {
    var changed, e, e$iterator;
    checkCriticalNotNull(c);
    changed = false;
    for(e$iterator = c.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        this.add_3(index_0++, e);
        changed = true;
    }
    return changed;
};
_.clear_0 = function clear_24() {
    this.removeRange(0, this.size_1());
};
_.equals_0 = function equals_26(o) {
    return $equals_2(this, o);
};
_.hashCode_1 = function hashCode_27() {
    return hashCode_49(this);
};
_.indexOf_0 = function indexOf_3(toFind) {
    return $indexOf(this, toFind);
};
_.iterator_0 = function iterator_33() {
    return new AbstractList$IteratorImpl(this);
};
_.listIterator_0 = function listIterator_4() {
    return this.listIterator_1(0);
};
_.listIterator_1 = function listIterator_5(from) {
    return new AbstractList$ListIteratorImpl(this, from);
};
_.remove_2 = function remove_36(index_0) {
    throw toJs(new UnsupportedOperationException_0('Remove not supported on this list'));
};
_.removeRange = function removeRange(fromIndex, endIndex) {
    var i, iter;
    iter = this.listIterator_1(fromIndex);
    for(i = fromIndex; i < endIndex; ++i){
        iter.next_1();
        iter.remove();
    }
};
_.set_2 = function set_5(index_0, o) {
    throw toJs(new UnsupportedOperationException_0('Set not supported on this list'));
};
_.subList = function subList_5(fromIndex, toIndex) {
    return new AbstractList$SubList(this, fromIndex, toIndex);
};
_.modCount = 0;
var Ljava_util_AbstractList_2_classLit = createForClass('java.util', 'AbstractList', 55);
function $add_0(this$static, index_0, element) {
    var iter;
    iter = this$static.listIterator_1(index_0);
    iter.add_1(element);
}
function $addAll_0(this$static, index_0, c) {
    var e, e$iterator, iter, modified;
    checkCriticalNotNull(c);
    modified = false;
    iter = this$static.listIterator_1(index_0);
    for(e$iterator = c.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        iter.add_1(e);
        modified = true;
    }
    return modified;
}
function $get_7(this$static, index_0) {
    var iter;
    iter = this$static.listIterator_1(index_0);
    try {
        return iter.next_1();
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 111)) throw toJs(new IndexOutOfBoundsException_0("Can't get element " + index_0));
        else throw toJs($e0);
    }
}
function $remove_4(this$static, index_0) {
    var iter, old;
    iter = this$static.listIterator_1(index_0);
    try {
        old = iter.next_1();
        iter.remove();
        return old;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 111)) throw toJs(new IndexOutOfBoundsException_0("Can't remove element " + index_0));
        else throw toJs($e0);
    }
}
defineClass(2008, 55, $intern_37);
_.add_3 = function add_13(index_0, element) {
    $add_0(this, index_0, element);
};
_.addAll_0 = function addAll_9(index_0, c) {
    return $addAll_0(this, index_0, c);
};
_.get_0 = function get_27(index_0) {
    return $get_7(this, index_0);
};
_.iterator_0 = function iterator_34() {
    return this.listIterator_1(0);
};
_.remove_2 = function remove_37(index_0) {
    return $remove_4(this, index_0);
};
_.set_2 = function set_6(index_0, element) {
    var iter, old;
    iter = this.listIterator_1(index_0);
    try {
        old = iter.next_1();
        iter.set_1(element);
        return old;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 111)) throw toJs(new IndexOutOfBoundsException_0("Can't set element " + index_0));
        else throw toJs($e0);
    }
};
var Ljava_util_AbstractSequentialList_2_classLit = createForClass('java.util', 'AbstractSequentialList', 2008);
function $listIterator_0(this$static, index_0) {
    return new LinkedListMultimap$ValueForKeyIterator_0(this$static.this$01, this$static.val$key2, index_0);
}
function LinkedListMultimap$1(this$0, val$key) {
    this.this$01 = this$0;
    this.val$key2 = val$key;
}
defineClass(631, 2008, $intern_37, LinkedListMultimap$1);
_.listIterator_1 = function listIterator_6(index_0) {
    return $listIterator_0(this, index_0);
};
_.size_1 = function size_27() {
    var keyList;
    keyList = castTo($get_10(this.this$01.keyToKeyList, this.val$key2), 260);
    return !keyList ? 0 : keyList.count;
};
var Lcom_google_common_collect_LinkedListMultimap$1_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap/1', 631);
function LinkedListMultimap$1KeySetImpl(this$0) {
    this.this$01 = this$0;
}
defineClass(1269, 2014, $intern_10, LinkedListMultimap$1KeySetImpl);
_.contains = function contains_21(key) {
    return $containsKey_1(this.this$01, key);
};
_.iterator_0 = function iterator_35() {
    return new LinkedListMultimap$DistinctKeyIterator(this.this$01);
};
_.remove_1 = function remove_38(o) {
    return !$removeAll_2(this.this$01, o).list.isEmpty();
};
_.size_1 = function size_28() {
    return $size_2(this.this$01.keyToKeyList);
};
var Lcom_google_common_collect_LinkedListMultimap$1KeySetImpl_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap/1KeySetImpl', 1269);
function $checkForConcurrentModification(this$static) {
    if (this$static.this$01.modCount != this$static.expectedModCount) throw toJs(new ConcurrentModificationException);
}
function LinkedListMultimap$DistinctKeyIterator(this$0) {
    this.this$01 = this$0;
    this.seenKeys = new HashSet_0(capacity_0($keySet(this.this$01).size_1()));
    this.next_0 = this.this$01.head;
    this.expectedModCount = this.this$01.modCount;
}
defineClass(1268, 1, $intern_6, LinkedListMultimap$DistinctKeyIterator);
_.forEachRemaining = function forEachRemaining_13(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_15() {
    $checkForConcurrentModification(this);
    return !!this.next_0;
};
_.next_1 = function next_16() {
    $checkForConcurrentModification(this);
    if (!this.next_0) throw toJs(new NoSuchElementException);
    this.current = this.next_0;
    $add_6(this.seenKeys, this.current.key);
    do this.next_0 = this.next_0.next_0;
    while (!!this.next_0 && !$add_6(this.seenKeys, this.next_0.key));
    return this.current.key;
};
_.remove = function remove_39() {
    $checkForConcurrentModification(this);
    checkState_0(!!this.current);
    clear_20(new LinkedListMultimap$ValueForKeyIterator(this.this$01, this.current.key));
    this.current = null;
    this.expectedModCount = this.this$01.modCount;
};
_.expectedModCount = 0;
var Lcom_google_common_collect_LinkedListMultimap$DistinctKeyIterator_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap/DistinctKeyIterator', 1268);
function LinkedListMultimap$KeyList(firstNode) {
    this.head = firstNode;
    this.tail = firstNode;
    firstNode.previousSibling = null;
    firstNode.nextSibling = null;
    this.count = 1;
}
defineClass(260, 1, {
    260: 1
}, LinkedListMultimap$KeyList);
_.count = 0;
var Lcom_google_common_collect_LinkedListMultimap$KeyList_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap/KeyList', 260);
function LinkedListMultimap$Node(key, value_0) {
    this.key = key;
    this.value_0 = value_0;
}
defineClass(495, 355, {
    355: 1,
    495: 1,
    43: 1
}, LinkedListMultimap$Node);
_.getKey = function getKey_3() {
    return this.key;
};
_.getValue = function getValue_5() {
    return this.value_0;
};
_.setValue = function setValue_6(newValue) {
    var result;
    result = this.value_0;
    this.value_0 = newValue;
    return result;
};
var Lcom_google_common_collect_LinkedListMultimap$Node_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap/Node', 495);
function $next_2(this$static) {
    if (!this$static.next_0) throw toJs(new NoSuchElementException);
    this$static.previous = this$static.current = this$static.next_0;
    this$static.next_0 = this$static.next_0.nextSibling;
    ++this$static.nextIndex;
    return this$static.current.value_0;
}
function $previous(this$static) {
    if (!this$static.previous) throw toJs(new NoSuchElementException);
    this$static.next_0 = this$static.current = this$static.previous;
    this$static.previous = this$static.previous.previousSibling;
    --this$static.nextIndex;
    return this$static.current.value_0;
}
function LinkedListMultimap$ValueForKeyIterator(this$0, key) {
    var keyList;
    this.this$01 = this$0;
    this.key = key;
    keyList = castTo($get_10(this$0.keyToKeyList, key), 260);
    this.next_0 = !keyList ? null : keyList.head;
}
function LinkedListMultimap$ValueForKeyIterator_0(this$0, key, index_0) {
    var keyList, size_0;
    this.this$01 = this$0;
    keyList = castTo($get_10(this$0.keyToKeyList, key), 260);
    size_0 = !keyList ? 0 : keyList.count;
    checkPositionIndex(index_0, size_0);
    if (index_0 >= (size_0 / 2 | 0)) {
        this.previous = !keyList ? null : keyList.tail;
        this.nextIndex = size_0;
        while(index_0++ < size_0)$previous(this);
    } else {
        this.next_0 = !keyList ? null : keyList.head;
        while(index_0-- > 0)$next_2(this);
    }
    this.key = key;
    this.current = null;
}
defineClass(551, 1, $intern_14, LinkedListMultimap$ValueForKeyIterator, LinkedListMultimap$ValueForKeyIterator_0);
_.forEachRemaining = function forEachRemaining_14(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_14(value_0) {
    this.previous = $addNode(this.this$01, this.key, value_0, this.next_0);
    ++this.nextIndex;
    this.current = null;
};
_.hasNext_0 = function hasNext_16() {
    return !!this.next_0;
};
_.hasPrevious = function hasPrevious_1() {
    return !!this.previous;
};
_.next_1 = function next_17() {
    return $next_2(this);
};
_.nextIndex_0 = function nextIndex_2() {
    return this.nextIndex;
};
_.previous_0 = function previous_2() {
    return $previous(this);
};
_.previousIndex = function previousIndex_1() {
    return this.nextIndex - 1;
};
_.remove = function remove_40() {
    checkState_0(!!this.current);
    if (this.current != this.next_0) {
        this.previous = this.current.previousSibling;
        --this.nextIndex;
    } else this.next_0 = this.current.nextSibling;
    $removeNode(this.this$01, this.current);
    this.current = null;
};
_.set_1 = function set_7(value_0) {
    checkState(!!this.current);
    this.current.value_0 = value_0;
};
_.nextIndex = 0;
var Lcom_google_common_collect_LinkedListMultimap$ValueForKeyIterator_2_classLit = createForClass('com.google.common.collect', 'LinkedListMultimap/ValueForKeyIterator', 551);
function computeArrayListCapacity(arraySize) {
    checkNonnegative(arraySize, 'arraySize');
    return saturatedCast(add_20(add_20(5, arraySize), arraySize / 10 | 0));
}
function equalsImpl(thisList, other) {
    var i, otherList, size_0;
    if (maskUndefined(other) === maskUndefined(checkNotNull(thisList))) return true;
    if (!instanceOf(other, 15)) return false;
    otherList = castTo(other, 15);
    size_0 = thisList.size_1();
    if (size_0 != otherList.size_1()) return false;
    if (instanceOf(otherList, 59)) {
        for(i = 0; i < size_0; i++){
            if (!equal(thisList.get_0(i), otherList.get_0(i))) return false;
        }
        return true;
    } else return elementsEqual(thisList.iterator_0(), otherList.iterator_0());
}
function hashCodeImpl(list) {
    var hashCode, o, o$iterator;
    hashCode = 1;
    for(o$iterator = list.iterator_0(); o$iterator.hasNext_0();){
        o = o$iterator.next_1();
        hashCode = 31 * hashCode + (o == null ? 0 : hashCode__I__devirtual$(o));
        hashCode = ~~hashCode;
    }
    return hashCode;
}
function indexOfRandomAccess(list, element) {
    var i, size_0;
    size_0 = list.size_1();
    if (element == null) for(i = 0; i < size_0; i++){
        if (list.get_0(i) == null) return i;
    }
    else for(i = 0; i < size_0; i++){
        if (equals_Ljava_lang_Object__Z__devirtual$(element, list.get_0(i))) return i;
    }
    return -1;
}
function newArrayList(elements) {
    checkNotNull(elements);
    return instanceOf(elements, 16) ? new ArrayList_1(castTo(elements, 16)) : newArrayList_0(elements.iterator_0());
}
function newArrayList_0(elements) {
    var list;
    list = new ArrayList;
    addAll_7(list, elements);
    return list;
}
function newArrayList_1(elements) {
    var capacity, list;
    checkNotNull(elements);
    capacity = computeArrayListCapacity(elements.length);
    list = new ArrayList_0(capacity);
    addAll_15(list, elements);
    return list;
}
function newArrayListWithCapacity(initialArraySize) {
    checkNonnegative(initialArraySize, 'initialArraySize');
    return new ArrayList_0(initialArraySize);
}
function newArrayListWithExpectedSize(estimatedSize) {
    return new ArrayList_0((checkNonnegative(estimatedSize, 'arraySize'), saturatedCast(add_20(add_20(5, estimatedSize), estimatedSize / 10 | 0))));
}
function newLinkedList(elements) {
    var list;
    list = new LinkedList;
    addAll_6(list, elements);
    return list;
}
function reverse_0(list) {
    var result, reversed;
    if (instanceOf(list, 308)) {
        reversed = $reverse(castTo(list, 308));
        result = reversed;
        return result;
    } else return instanceOf(list, 429) ? castTo(list, 429).forwardList : instanceOf(list, 59) ? new Lists$RandomAccessReverseList(list) : new Lists$ReverseList(list);
}
defineClass(1006, 55, $intern_37);
_.add_3 = function add_15(index_0, element) {
    this.backingList.add_3(index_0, element);
};
_.addAll_0 = function addAll_10(index_0, c) {
    return this.backingList.addAll_0(index_0, c);
};
_.contains = function contains_22(o) {
    return this.backingList.contains(o);
};
_.get_0 = function get_28(index_0) {
    return this.backingList.get_0(index_0);
};
_.remove_2 = function remove_41(index_0) {
    return this.backingList.remove_2(index_0);
};
_.set_2 = function set_8(index_0, element) {
    return this.backingList.set_2(index_0, element);
};
_.size_1 = function size_29() {
    return this.backingList.size_1();
};
var Lcom_google_common_collect_Lists$AbstractListWrapper_2_classLit = createForClass('com.google.common.collect', 'Lists/AbstractListWrapper', 1006);
defineClass(1007, 1006, $intern_38);
var Lcom_google_common_collect_Lists$RandomAccessListWrapper_2_classLit = createForClass('com.google.common.collect', 'Lists/RandomAccessListWrapper', 1007);
function Lists$1($anonymous0) {
    this.backingList = castTo(checkNotNull($anonymous0), 15);
}
defineClass(1009, 1007, $intern_38, Lists$1);
_.listIterator_1 = function listIterator_7(index_0) {
    return this.backingList.listIterator_1(index_0);
};
var Lcom_google_common_collect_Lists$1_2_classLit = createForClass('com.google.common.collect', 'Lists/1', 1009);
function $listIterator_1(this$static, index_0) {
    var forwardIterator, start_0;
    start_0 = $reversePosition(this$static, index_0);
    forwardIterator = this$static.forwardList.listIterator_1(start_0);
    return new Lists$ReverseList$1(this$static, forwardIterator);
}
function $reverseIndex(this$static, index_0) {
    var size_0;
    size_0 = this$static.forwardList.size_1();
    checkElementIndex(index_0, size_0);
    return size_0 - 1 - index_0;
}
function $reversePosition(this$static, index_0) {
    var size_0;
    size_0 = this$static.forwardList.size_1();
    checkPositionIndex(index_0, size_0);
    return size_0 - index_0;
}
function Lists$ReverseList(forwardList) {
    this.forwardList = castTo(checkNotNull(forwardList), 15);
}
defineClass(429, 55, {
    429: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1
}, Lists$ReverseList);
_.add_3 = function add_16(index_0, element) {
    this.forwardList.add_3($reversePosition(this, index_0), element);
};
_.clear_0 = function clear_25() {
    this.forwardList.clear_0();
};
_.get_0 = function get_29(index_0) {
    return this.forwardList.get_0($reverseIndex(this, index_0));
};
_.iterator_0 = function iterator_36() {
    return $listIterator_1(this, 0);
};
_.listIterator_1 = function listIterator_8(index_0) {
    return $listIterator_1(this, index_0);
};
_.remove_2 = function remove_42(index_0) {
    return this.forwardList.remove_2($reverseIndex(this, index_0));
};
_.removeRange = function removeRange_0(fromIndex, toIndex) {
    (checkPositionIndexes(fromIndex, toIndex, this.forwardList.size_1()), reverse_0(this.forwardList.subList($reversePosition(this, toIndex), $reversePosition(this, fromIndex)))).clear_0();
};
_.set_2 = function set_9(index_0, element) {
    return this.forwardList.set_2($reverseIndex(this, index_0), element);
};
_.size_1 = function size_30() {
    return this.forwardList.size_1();
};
_.subList = function subList_6(fromIndex, toIndex) {
    return checkPositionIndexes(fromIndex, toIndex, this.forwardList.size_1()), reverse_0(this.forwardList.subList($reversePosition(this, toIndex), $reversePosition(this, fromIndex)));
};
var Lcom_google_common_collect_Lists$ReverseList_2_classLit = createForClass('com.google.common.collect', 'Lists/ReverseList', 429);
function Lists$RandomAccessReverseList(forwardList) {
    Lists$ReverseList.call(this, forwardList);
}
defineClass(1005, 429, {
    429: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1
}, Lists$RandomAccessReverseList);
var Lcom_google_common_collect_Lists$RandomAccessReverseList_2_classLit = createForClass('com.google.common.collect', 'Lists/RandomAccessReverseList', 1005);
function Lists$ReverseList$1(this$1, val$forwardIterator) {
    this.this$11 = this$1;
    this.val$forwardIterator2 = val$forwardIterator;
}
defineClass(1008, 1, $intern_14, Lists$ReverseList$1);
_.forEachRemaining = function forEachRemaining_15(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_17(e) {
    this.val$forwardIterator2.add_1(e);
    this.val$forwardIterator2.previous_0();
    this.canRemoveOrSet = false;
};
_.hasNext_0 = function hasNext_17() {
    return this.val$forwardIterator2.hasPrevious();
};
_.hasPrevious = function hasPrevious_2() {
    return this.val$forwardIterator2.hasNext_0();
};
_.next_1 = function next_18() {
    if (!this.val$forwardIterator2.hasPrevious()) throw toJs(new NoSuchElementException);
    this.canRemoveOrSet = true;
    return this.val$forwardIterator2.previous_0();
};
_.nextIndex_0 = function nextIndex_3() {
    return $reversePosition(this.this$11, this.val$forwardIterator2.nextIndex_0());
};
_.previous_0 = function previous_3() {
    if (!this.val$forwardIterator2.hasNext_0()) throw toJs(new NoSuchElementException);
    this.canRemoveOrSet = true;
    return this.val$forwardIterator2.next_1();
};
_.previousIndex = function previousIndex_2() {
    return $reversePosition(this.this$11, this.val$forwardIterator2.nextIndex_0()) - 1;
};
_.remove = function remove_43() {
    checkState_0(this.canRemoveOrSet);
    this.val$forwardIterator2.remove();
    this.canRemoveOrSet = false;
};
_.set_1 = function set_10(e) {
    checkState(this.canRemoveOrSet);
    this.val$forwardIterator2.set_1(e);
};
_.canRemoveOrSet = false;
var Lcom_google_common_collect_Lists$ReverseList$1_2_classLit = createForClass('com.google.common.collect', 'Lists/ReverseList/1', 1008);
function asMapEntryIterator(set_0, function_0) {
    return new Maps$3(set_0.iterator_0(), function_0);
}
function capacity_0(expectedSize) {
    if (expectedSize < 3) {
        checkNonnegative(expectedSize, 'expectedSize');
        return expectedSize + 1;
    }
    if (expectedSize < $intern_35) return round_int(expectedSize / 0.75 + 1);
    return $intern_0;
}
function equalsImpl_0(map_0, object) {
    var o;
    if (map_0 === object) return true;
    else if (instanceOf(object, 91)) {
        o = castTo(object, 91);
        return equalsImpl_3($entrySet_1(map_0), o.entrySet_0());
    }
    return false;
}
function indexMap(list) {
    var builder, e, e$iterator, i;
    builder = new ImmutableMap$Builder(list.delegateList_0().size_1());
    i = 0;
    for(e$iterator = unmodifiableIterator(list.delegateList_0().iterator_0()); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        $put_4(builder, e, valueOf_3(i++));
    }
    return fromEntryList(builder.entries_0);
}
function keyOrNull(entry) {
    return !entry ? null : entry.key;
}
function safeContainsKey(map_0, key) {
    checkNotNull(map_0);
    try {
        return map_0.containsKey(key);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 211) || instanceOf($e0, 169)) return false;
        else throw toJs($e0);
    }
}
function safeGet(map_0, key) {
    checkNotNull(map_0);
    try {
        return map_0.get_3(key);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 211) || instanceOf($e0, 169)) return null;
        else throw toJs($e0);
    }
}
function safeRemove_0(map_0, key) {
    checkNotNull(map_0);
    try {
        return map_0.remove_0(key);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 211) || instanceOf($e0, 169)) return null;
        else throw toJs($e0);
    }
}
function toStringImpl(map_0) {
    var entry, entry$iterator, first, sb;
    sb = $append_5((checkNonnegative(map_0.size_1(), 'size'), new StringBuilder_0), 123);
    first = true;
    for(entry$iterator = $entrySet_1(map_0).iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        first || (sb.string += ', ', sb);
        first = false;
        $append_10($append_5($append_10(sb, entry.getKey()), 61), entry.getValue());
    }
    return (sb.string += '}', sb).string;
}
function valueOrNull(entry) {
    return !entry ? null : entry.value_0;
}
function $transform(entry) {
    return castTo(entry, 43).getKey();
}
function Maps$1($anonymous0) {
    TransformedIterator.call(this, $anonymous0);
}
defineClass(428, 481, $intern_6, Maps$1);
_.transform_0 = function transform_4(entry) {
    return $transform(entry);
};
var Lcom_google_common_collect_Maps$1_2_classLit = createForClass('com.google.common.collect', 'Maps/1', 428);
function Maps$2($anonymous0) {
    TransformedIterator.call(this, $anonymous0);
}
defineClass(696, 481, $intern_6, Maps$2);
_.transform_0 = function transform_5(entry) {
    return castTo(entry, 43).getValue();
};
var Lcom_google_common_collect_Maps$2_2_classLit = createForClass('com.google.common.collect', 'Maps/2', 696);
function Maps$3($anonymous0, val$function) {
    this.val$function2 = val$function;
    TransformedIterator.call(this, $anonymous0);
}
defineClass(953, 481, $intern_6, Maps$3);
_.transform_0 = function transform_6(key) {
    return new ImmutableEntry(key, $apply_0(this.val$function2, key));
};
var Lcom_google_common_collect_Maps$3_2_classLit = createForClass('com.google.common.collect', 'Maps/3', 953);
function Maps$IteratorBasedAbstractMap$1(this$1) {
    this.this$11 = this$1;
}
defineClass(950, 2015, $intern_10, Maps$IteratorBasedAbstractMap$1);
_.forEach_0 = function forEach_13(action) {
    $forEachEntry_0(this.this$11, action);
};
_.iterator_0 = function iterator_37() {
    return this.this$11.entryIterator();
};
_.map_1 = function map_3() {
    return this.this$11;
};
_.spliterator_0 = function spliterator_24() {
    return this.this$11.entrySpliterator();
};
var Lcom_google_common_collect_Maps$IteratorBasedAbstractMap$1_2_classLit = createForClass('com.google.common.collect', 'Maps/IteratorBasedAbstractMap/1', 950);
function Maps$KeySet$lambda$0$Type(action_0) {
    this.action_0 = action_0;
}
defineClass(951, 1, {}, Maps$KeySet$lambda$0$Type);
_.accept_1 = function accept_10(arg0, arg1) {
    this.action_0.accept(arg0);
};
var Lcom_google_common_collect_Maps$KeySet$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'Maps/KeySet/lambda$0$Type', 951);
function Maps$Values(map_0) {
    this.map_0 = castTo(checkNotNull(map_0), 91);
}
defineClass(949, 31, $intern_8, Maps$Values);
_.clear_0 = function clear_26() {
    this.map_0.clear_0();
};
_.contains = function contains_23(o) {
    return this.map_0.containsValue(o);
};
_.forEach_0 = function forEach_14(action) {
    checkNotNull(action);
    this.map_0.forEach(new Maps$Values$lambda$0$Type(action));
};
_.isEmpty = function isEmpty_15() {
    return this.map_0.isEmpty();
};
_.iterator_0 = function iterator_38() {
    return new Maps$2(this.map_0.entrySet_0().iterator_0());
};
_.remove_1 = function remove_44(o) {
    var entry, entry$iterator;
    try {
        return $advanceToFind(this, o, true);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 46)) {
            for(entry$iterator = this.map_0.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
                entry = castTo(entry$iterator.next_1(), 43);
                if (equal(o, entry.getValue())) {
                    this.map_0.remove_0(entry.getKey());
                    return true;
                }
            }
            return false;
        } else throw toJs($e0);
    }
};
_.size_1 = function size_31() {
    return this.map_0.size_1();
};
var Lcom_google_common_collect_Maps$Values_2_classLit = createForClass('com.google.common.collect', 'Maps/Values', 949);
function Maps$Values$lambda$0$Type(action_0) {
    this.action_0 = action_0;
}
defineClass(952, 1, {}, Maps$Values$lambda$0$Type);
_.accept_1 = function accept_11(arg0, arg1) {
    this.action_0.accept(arg1);
};
var Lcom_google_common_collect_Maps$Values$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'Maps/Values/lambda$0$Type', 952);
function equalsImpl_1(multimap, object) {
    var that;
    if (object === multimap) return true;
    if (instanceOf(object, 228)) {
        that = castTo(object, 228);
        return equals_Ljava_lang_Object__Z__devirtual$(multimap.asMap_0(), that.asMap_0());
    }
    return false;
}
function $removeValuesForKey_0(this$static, key) {
    this$static.multimap.keySet_0().remove_1(key);
}
function Multimaps$AsMap(multimap) {
    this.multimap = castTo(checkNotNull(multimap), 228);
}
defineClass(735, 2031, $intern_7, Multimaps$AsMap);
_.get_3 = function get_30(key) {
    return this.multimap.containsKey(key) ? this.multimap.get_1(key) : null;
};
_.remove_0 = function remove_45(key) {
    return this.multimap.containsKey(key) ? this.multimap.removeAll(key) : null;
};
_.clear_0 = function clear_27() {
    this.multimap.clear_0();
};
_.containsKey = function containsKey_8(key) {
    return this.multimap.containsKey(key);
};
_.createEntrySet_0 = function createEntrySet_1() {
    return new Multimaps$AsMap$EntrySet(this);
};
_.createEntrySet = function() {
    return this.createEntrySet_0();
};
_.isEmpty = function isEmpty_16() {
    return this.multimap.isEmpty();
};
_.keySet_0 = function keySet_14() {
    return this.multimap.keySet_0();
};
_.size_1 = function size_32() {
    return this.multimap.keySet_0().size_1();
};
var Lcom_google_common_collect_Multimaps$AsMap_2_classLit = createForClass('com.google.common.collect', 'Multimaps/AsMap', 735);
function Multimaps$AsMap$EntrySet(this$1) {
    this.this$11 = this$1;
}
defineClass(1098, 2015, $intern_10, Multimaps$AsMap$EntrySet);
_.iterator_0 = function iterator_39() {
    return asMapEntryIterator(this.this$11.multimap.keySet_0(), new Multimaps$AsMap$EntrySet$1(this));
};
_.map_1 = function map_4() {
    return this.this$11;
};
_.remove_1 = function remove_46(o) {
    var entry;
    if (!$contains(this, o)) return false;
    entry = castTo(requireNonNull(castTo(o, 43)), 43);
    $removeValuesForKey_0(this.this$11, entry.getKey());
    return true;
};
var Lcom_google_common_collect_Multimaps$AsMap$EntrySet_2_classLit = createForClass('com.google.common.collect', 'Multimaps/AsMap/EntrySet', 1098);
function $apply_0(this$static, key) {
    return this$static.this$21.this$11.multimap.get_1(key);
}
function Multimaps$AsMap$EntrySet$1(this$2) {
    this.this$21 = this$2;
}
defineClass(1102, 1, {}, Multimaps$AsMap$EntrySet$1);
_.apply_0 = function apply_14(key) {
    return $apply_0(this, key);
};
_.equals_0 = function equals_27(other) {
    return this === other;
};
var Lcom_google_common_collect_Multimaps$AsMap$EntrySet$1_2_classLit = createForClass('com.google.common.collect', 'Multimaps/AsMap/EntrySet/1', 1102);
function $count(this$static, element) {
    var values;
    values = castTo(safeGet($asMap(this$static.multimap), element), 16);
    return !values ? 0 : values.size_1();
}
function $remove_5(this$static, element, occurrences) {
    var i, iterator, oldCount, values, values0;
    checkNonnegative(occurrences, 'occurrences');
    if (occurrences == 0) return values0 = castTo(safeGet($asMap(this$static.multimap), element), 16), !values0 ? 0 : values0.size_1();
    values = castTo(safeGet($asMap(this$static.multimap), element), 16);
    if (!values) return 0;
    oldCount = values.size_1();
    if (occurrences >= oldCount) values.clear_0();
    else {
        iterator = values.iterator_0();
        for(i = 0; i < occurrences; i++){
            iterator.next_1();
            iterator.remove();
        }
    }
    return oldCount;
}
function Multimaps$Keys(multimap) {
    this.multimap = multimap;
}
defineClass(537, 2033, {
    537: 1,
    828: 1,
    20: 1,
    31: 1,
    16: 1
}, Multimaps$Keys);
_.clear_0 = function clear_28() {
    $clear(this.multimap);
};
_.contains = function contains_24(element) {
    return $containsKey(this.multimap, element);
};
_.forEach_0 = function forEach_15(consumer) {
    checkNotNull(consumer);
    $forEach_0($entries(this.multimap), new Multimaps$Keys$lambda$1$Type(consumer));
};
_.iterator_0 = function iterator_40() {
    return new Maps$1($entries(this.multimap).this$01.entryIterator());
};
_.size_1 = function size_33() {
    return this.multimap.totalSize;
};
_.spliterator_0 = function spliterator_25() {
    return map_2($entries(this.multimap).spliterator_0(), new Multimaps$Keys$0methodref$getKey$Type);
};
var Lcom_google_common_collect_Multimaps$Keys_2_classLit = createForClass('com.google.common.collect', 'Multimaps/Keys', 537);
function Multimaps$Keys$0methodref$getKey$Type() {}
defineClass(1100, 1, {}, Multimaps$Keys$0methodref$getKey$Type);
_.apply_0 = function apply_15(arg0) {
    return castTo(arg0, 43).getKey();
};
var Lcom_google_common_collect_Multimaps$Keys$0methodref$getKey$Type_2_classLit = createForClass('com.google.common.collect', 'Multimaps/Keys/0methodref$getKey$Type', 1100);
function Multimaps$Keys$1($anonymous0) {
    TransformedIterator.call(this, $anonymous0);
}
defineClass(1099, 481, $intern_6, Multimaps$Keys$1);
_.transform_0 = function transform_7(backingEntry) {
    return new Multimaps$Keys$1$1(castTo(backingEntry, 43));
};
var Lcom_google_common_collect_Multimaps$Keys$1_2_classLit = createForClass('com.google.common.collect', 'Multimaps/Keys/1', 1099);
defineClass(2034, 1, {
    413: 1
});
_.equals_0 = function equals_28(object) {
    var that;
    if (instanceOf(object, 488)) {
        that = castTo(object, 413);
        return castTo(this.val$backingEntry2.getValue(), 16).size_1() == castTo(that.val$backingEntry2.getValue(), 16).size_1() && equal(this.val$backingEntry2.getKey(), that.val$backingEntry2.getKey());
    }
    return false;
};
_.hashCode_1 = function hashCode_28() {
    var e;
    e = this.val$backingEntry2.getKey();
    return (e == null ? 0 : hashCode__I__devirtual$(e)) ^ castTo(this.val$backingEntry2.getValue(), 16).size_1();
};
_.toString_0 = function toString_27() {
    var n, text_0;
    text_0 = valueOf_6(this.val$backingEntry2.getKey());
    n = castTo(this.val$backingEntry2.getValue(), 16).size_1();
    return n == 1 ? text_0 : text_0 + ' x ' + n;
};
var Lcom_google_common_collect_Multisets$AbstractEntry_2_classLit = createForClass('com.google.common.collect', 'Multisets/AbstractEntry', 2034);
function Multimaps$Keys$1$1(val$backingEntry) {
    this.val$backingEntry2 = val$backingEntry;
}
defineClass(488, 2034, {
    488: 1,
    413: 1
}, Multimaps$Keys$1$1);
var Lcom_google_common_collect_Multimaps$Keys$1$1_2_classLit = createForClass('com.google.common.collect', 'Multimaps/Keys/1/1', 488);
function Multimaps$Keys$lambda$1$Type(consumer_0) {
    this.consumer_0 = consumer_0;
}
defineClass(1101, 1, $intern_19, Multimaps$Keys$lambda$1$Type);
_.accept = function accept_12(arg0) {
    this.consumer_0.accept(castTo(arg0, 43).getKey());
};
var Lcom_google_common_collect_Multimaps$Keys$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'Multimaps/Keys/lambda$1$Type', 1101);
function Multiset$lambda$0$Type() {}
defineClass(1104, 1, $intern_19, Multiset$lambda$0$Type);
_.accept = function accept_13(arg0) {
    lambda$0_1(castTo(arg0, 413));
};
var Lcom_google_common_collect_Multiset$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'Multiset/lambda$0$Type', 1104);
function Multiset$lambda$1$Type(action_0) {
    this.action_0 = action_0;
}
defineClass(736, 1, $intern_19, Multiset$lambda$1$Type);
_.accept = function accept_14(arg0) {
    lambda$1_0(this.action_0, castTo(arg0, 413));
};
var Lcom_google_common_collect_Multiset$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'Multiset/lambda$1$Type', 736);
function addAllImpl(elements) {
    if ($entrySet_0(elements).isEmpty()) return false;
    $forEachEntry(elements, new Multisets$0methodref$add$Type);
    return true;
}
function equalsImpl_2(multiset, object) {
    var entry, entry$iterator, that;
    if (object === multiset) return true;
    if (instanceOf(object, 537)) {
        that = castTo(object, 828);
        if (multiset.multimap.totalSize != that.multimap.totalSize || $entrySet_0(multiset).size_1() != $entrySet_0(that).size_1()) return false;
        for(entry$iterator = $entrySet_0(that).iterator_0(); entry$iterator.hasNext_0();){
            entry = castTo(entry$iterator.next_1(), 413);
            if ($count(multiset, entry.val$backingEntry2.getKey()) != castTo(entry.val$backingEntry2.getValue(), 16).size_1()) return false;
        }
        return true;
    }
    return false;
}
function lambda$1_1(entry_0) {
    return new Spliterators$IteratorSpliterator(nCopies(castTo(entry_0.val$backingEntry2.getValue(), 16).size_1(), entry_0.val$backingEntry2.getKey()), 16);
}
function setCountImpl(self_0, element, oldCount) {
    var values, oldCount_0, values_0, delta;
    checkNonnegative(oldCount, 'oldCount');
    checkNonnegative(0, 'newCount');
    values = castTo(safeGet($asMap(self_0.multimap), element), 16);
    if ((!values ? 0 : values.size_1()) == oldCount) {
        checkNonnegative(0, 'count');
        oldCount_0 = (values_0 = castTo(safeGet($asMap(self_0.multimap), element), 16), !values_0 ? 0 : values_0.size_1());
        delta = -oldCount_0;
        delta > 0 ? $add() : delta < 0 && $remove_5(self_0, element, -delta);
        return true;
    } else return false;
}
function Multisets$0methodref$add$Type() {}
defineClass(1105, 1, {}, Multisets$0methodref$add$Type);
var Lcom_google_common_collect_Multisets$0methodref$add$Type_2_classLit = createForClass('com.google.common.collect', 'Multisets/0methodref$add$Type', 1105);
function Multisets$lambda$1$Type() {}
defineClass(737, 1, {}, Multisets$lambda$1$Type);
_.apply_0 = function apply_16(arg0) {
    return lambda$1_1(castTo(arg0, 413));
};
var Lcom_google_common_collect_Multisets$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'Multisets/lambda$1$Type', 737);
defineClass(2052, 1, $intern_1);
var Lcom_google_common_collect_RangeGwtSerializationDependencies_2_classLit = createForClass('com.google.common.collect', 'RangeGwtSerializationDependencies', 2052);
function $clinit_Range() {
    $clinit_Range = emptyMethod;
    new Range_0(($clinit_Cut$BelowAll(), INSTANCE_1), ($clinit_Cut$AboveAll(), INSTANCE_0));
}
function $apply_1(this$static, input_0) {
    return checkNotNull(input_0), this$static.lowerBound.isLessThan(input_0) && !this$static.upperBound.isLessThan(input_0);
}
function Range_0(lowerBound, upperBound) {
    this.lowerBound = castTo(checkNotNull(lowerBound), 252);
    this.upperBound = castTo(checkNotNull(upperBound), 252);
    if (lowerBound.compareTo(upperBound) > 0 || lowerBound == ($clinit_Cut$AboveAll(), INSTANCE_0) || upperBound == ($clinit_Cut$BelowAll(), INSTANCE_1)) throw toJs(new IllegalArgumentException_0('Invalid range: ' + toString_29(lowerBound, upperBound)));
}
function closed_0(lower, upper) {
    $clinit_Range();
    return new Range_0(new Cut$BelowValue(lower), new Cut$AboveValue(upper));
}
function toString_29(lowerBound, upperBound) {
    var sb;
    sb = new StringBuilder_0;
    lowerBound.describeAsLowerBound(sb);
    sb.string += '..';
    upperBound.describeAsUpperBound(sb);
    return sb.string;
}
defineClass(505, 2052, {
    177: 1,
    505: 1,
    3: 1,
    48: 1
}, Range_0);
_.apply_1 = function apply_17(input_0) {
    return $apply_1(this, castTo(input_0, 34));
};
_.test_0 = function test_1(input_0) {
    return $apply_1(this, castTo(input_0, 34));
};
_.equals_0 = function equals_29(object) {
    var other;
    if (instanceOf(object, 505)) {
        other = castTo(object, 505);
        return $equals_1(this.lowerBound, other.lowerBound) && $equals_1(this.upperBound, other.upperBound);
    }
    return false;
};
_.hashCode_1 = function hashCode_29() {
    return this.lowerBound.hashCode_1() * 31 + this.upperBound.hashCode_1();
};
_.toString_0 = function toString_28() {
    return toString_29(this.lowerBound, this.upperBound);
};
var Lcom_google_common_collect_Range_2_classLit = createForClass('com.google.common.collect', 'Range', 505);
function RegularImmutableAsList(delegate, delegateList) {
    this.delegate = delegate;
    this.delegateList = delegateList;
}
function RegularImmutableAsList_0(delegate, array) {
    $clinit_ImmutableList();
    RegularImmutableAsList.call(this, delegate, unsafeDelegateList(new Arrays$ArrayList(array)));
}
defineClass(637, 2043, $intern_26, RegularImmutableAsList_0);
_.listIterator_1 = function listIterator_10(index_0) {
    return $listIterator(this.delegateList, index_0);
};
_.delegateCollection = function delegateCollection_1() {
    return this.delegate;
};
_.get_0 = function get_31(index_0) {
    return $get_2(this.delegateList, index_0);
};
_.listIterator_2 = function listIterator_9(index_0) {
    return $listIterator(this.delegateList, index_0);
};
var Lcom_google_common_collect_RegularImmutableAsList_2_classLit = createForClass('com.google.common.collect', 'RegularImmutableAsList', 637);
function RegularImmutableList(delegate) {
    this.delegate = ($clinit_Collections(), instanceOf(delegate, 59) ? new Collections$UnmodifiableRandomAccessList(delegate) : new Collections$UnmodifiableList(delegate));
}
defineClass(640, 2051, $intern_26, RegularImmutableList);
_.delegateList_0 = function delegateList_0() {
    return this.delegate;
};
var Lcom_google_common_collect_RegularImmutableList_2_classLit = createForClass('com.google.common.collect', 'RegularImmutableList', 640);
function RegularImmutableMap(entries) {
    ForwardingImmutableMap.call(this, entries);
}
function RegularImmutableMap_0(entries) {
    RegularImmutableMap.call(this, entries);
}
defineClass(533, 713, $intern_28, RegularImmutableMap, RegularImmutableMap_0);
var Lcom_google_common_collect_RegularImmutableMap_2_classLit = createForClass('com.google.common.collect', 'RegularImmutableMap', 533);
function $clinit_RegularImmutableSet() {
    $clinit_RegularImmutableSet = emptyMethod;
    $clinit_ImmutableCollection();
    EMPTY_2 = new RegularImmutableSet(($clinit_Collections(), $clinit_Collections(), EMPTY_SET));
}
function RegularImmutableSet(delegate) {
    $clinit_RegularImmutableSet();
    ForwardingImmutableSet.call(this, delegate);
}
defineClass(714, 703, $intern_30, RegularImmutableSet);
var EMPTY_2;
var Lcom_google_common_collect_RegularImmutableSet_2_classLit = createForClass('com.google.common.collect', 'RegularImmutableSet', 714);
function equalsImpl_3(s, object) {
    var o;
    if (maskUndefined(s) === maskUndefined(object)) return true;
    if (instanceOf(object, 22)) {
        o = castTo(object, 22);
        try {
            return s.size_1() == o.size_1() && s.containsAll(o);
        } catch ($e0) {
            $e0 = toJava($e0);
            if (instanceOf($e0, 169) || instanceOf($e0, 211)) return false;
            else throw toJs($e0);
        }
    }
    return false;
}
function hashCodeImpl_0(s) {
    var hashCode, o, o$iterator;
    hashCode = 0;
    for(o$iterator = s.iterator_0(); o$iterator.hasNext_0();){
        o = o$iterator.next_1();
        hashCode += o != null ? hashCode__I__devirtual$(o) : 0;
        hashCode = ~~hashCode;
    }
    return hashCode;
}
function intersection_0(set1, set2) {
    checkNotNull_0(set1, 'set1');
    checkNotNull_0(set2, 'set2');
    return new Sets$2(set1, set2);
}
function newHashSet(elements) {
    return instanceOf(elements, 16) ? new HashSet_1(castTo(elements, 16)) : newHashSet_0(elements.iterator_0());
}
function newHashSet_0(elements) {
    var set_0;
    set_0 = new HashSet;
    addAll_7(set_0, elements);
    return set_0;
}
function newHashSet_1(elements) {
    var set_0;
    set_0 = new HashSet_0(capacity_0(elements.length));
    addAll_15(set_0, elements);
    return set_0;
}
function newLinkedHashSet(elements) {
    var set_0;
    if (elements) return new LinkedHashSet_1(elements);
    set_0 = new LinkedHashSet;
    addAll_6(set_0, elements);
    return set_0;
}
function newTreeSet(elements) {
    var set_0;
    set_0 = new TreeSet;
    addAll_6(set_0, elements);
    return set_0;
}
function unmodifiableNavigableSet(set_0) {
    if (instanceOf(set_0, 601)) return set_0;
    return new Sets$UnmodifiableNavigableSet(set_0);
}
defineClass(2020, $intern_9, $intern_10);
_.iterator_0 = function iterator_41() {
    return new Sets$2$1(this.val$set11, this.val$set22);
};
_.add_2 = function add_18(e) {
    throw toJs(new UnsupportedOperationException);
};
_.addAll = function addAll_11(newElements) {
    throw toJs(new UnsupportedOperationException);
};
_.clear_0 = function clear_29() {
    throw toJs(new UnsupportedOperationException);
};
_.remove_1 = function remove_47(object) {
    throw toJs(new UnsupportedOperationException);
};
var Lcom_google_common_collect_Sets$SetView_2_classLit = createForClass('com.google.common.collect', 'Sets/SetView', 2020);
function $size_1(this$static) {
    var e, e$iterator, size_0;
    size_0 = 0;
    for(e$iterator = new EnumSet$EnumSetImpl$IteratorImpl(this$static.val$set11); e$iterator.i < e$iterator.this$11.all.length;){
        e = $next_7(e$iterator);
        this$static.val$set22.contains(e) && ++size_0;
    }
    return size_0;
}
function Sets$2(val$set1, val$set2) {
    this.val$set11 = val$set1;
    this.val$set22 = val$set2;
}
defineClass(954, 2020, $intern_10, Sets$2);
_.iterator_0 = function iterator_42() {
    return new Sets$2$1(this.val$set11, this.val$set22);
};
_.contains = function contains_25(object) {
    return $contains_5(this.val$set11, object) && this.val$set22.contains(object);
};
_.containsAll = function containsAll_6(collection) {
    return $containsAll(this.val$set11, collection) && this.val$set22.containsAll(collection);
};
_.isEmpty = function isEmpty_17() {
    return disjoint(this.val$set22, this.val$set11);
};
_.size_1 = function size_34() {
    return $size_1(this);
};
_.stream = function stream_2() {
    return $filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.val$set11, 1)), new Sets$2$0methodref$contains$Type(this.val$set22));
};
var Lcom_google_common_collect_Sets$2_2_classLit = createForClass('com.google.common.collect', 'Sets/2', 954);
function Sets$2$0methodref$contains$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(955, 1, $intern_39, Sets$2$0methodref$contains$Type);
_.test_0 = function test_2(arg0) {
    return this.$$outer_0.contains(arg0);
};
var Lcom_google_common_collect_Sets$2$0methodref$contains$Type_2_classLit = createForClass('com.google.common.collect', 'Sets/2/0methodref$contains$Type', 955);
function Sets$2$1(val$set1, val$set2) {
    this.val$set12 = val$set1;
    this.val$set23 = val$set2;
    this.itr = new EnumSet$EnumSetImpl$IteratorImpl(this.val$set12);
}
defineClass(698, 697, $intern_3, Sets$2$1);
_.computeNext = function computeNext_0() {
    var e;
    while($hasNext_4(this.itr)){
        e = $next_7(this.itr);
        if (this.val$set23.contains(e)) return e;
    }
    return this.state = 2, null;
};
var Lcom_google_common_collect_Sets$2$1_2_classLit = createForClass('com.google.common.collect', 'Sets/2/1', 698);
function Sets$UnmodifiableNavigableSet(delegate) {
    this.delegate = castTo(checkNotNull(delegate), 274);
    this.unmodifiableDelegate = ($clinit_Collections(), new Collections$UnmodifiableSortedSet(delegate));
}
defineClass(601, 2019, {
    601: 1,
    3: 1,
    20: 1,
    16: 1,
    274: 1,
    22: 1,
    83: 1
}, Sets$UnmodifiableNavigableSet);
_.delegate_0 = function delegate_9() {
    return this.unmodifiableDelegate;
};
_.delegate_1 = function delegate_10() {
    return this.unmodifiableDelegate;
};
_.delegate_2 = function delegate_11() {
    return this.unmodifiableDelegate;
};
_.forEach_0 = function forEach_16(action) {
    this.delegate.forEach_0(action);
};
_.stream = function stream_3() {
    return this.delegate.stream();
};
var Lcom_google_common_collect_Sets$UnmodifiableNavigableSet_2_classLit = createForClass('com.google.common.collect', 'Sets/UnmodifiableNavigableSet', 601);
function SingletonImmutableBiMap(key, value_0) {
    ImmutableBiMap.call(this, singletonMap(checkNotNull(key), checkNotNull(value_0)));
    this.singleValue = value_0;
}
defineClass(1977, 1976, $intern_28, SingletonImmutableBiMap);
_.values_2 = function values_13() {
    return $clinit_ImmutableCollection(), new SingletonImmutableSet(this.singleValue);
};
_.values_0 = function values_14() {
    return $clinit_ImmutableCollection(), new SingletonImmutableSet(this.singleValue);
};
_.values_1 = function values_15() {
    return $clinit_ImmutableCollection(), new SingletonImmutableSet(this.singleValue);
};
var Lcom_google_common_collect_SingletonImmutableBiMap_2_classLit = createForClass('com.google.common.collect', 'SingletonImmutableBiMap', 1977);
function SingletonImmutableList(element) {
    $clinit_ImmutableList();
    this.delegate = ($clinit_Collections(), new Collections$SingletonList(checkNotNull(element)));
}
defineClass(641, 2051, $intern_26, SingletonImmutableList);
_.delegateList_0 = function delegateList_1() {
    return this.delegate;
};
var Lcom_google_common_collect_SingletonImmutableList_2_classLit = createForClass('com.google.common.collect', 'SingletonImmutableList', 641);
function SingletonImmutableSet(element) {
    $clinit_ImmutableCollection();
    this.element = checkNotNull(element);
}
defineClass(356, 2025, $intern_30, SingletonImmutableSet);
_.iterator_0 = function iterator_44() {
    return new Iterators$9(this.element);
};
_.contains = function contains_26(object) {
    return equals_Ljava_lang_Object__Z__devirtual$(this.element, object);
};
_.iterator_1 = function iterator_43() {
    return new Iterators$9(this.element);
};
_.size_1 = function size_35() {
    return 1;
};
var Lcom_google_common_collect_SingletonImmutableSet_2_classLit = createForClass('com.google.common.collect', 'SingletonImmutableSet', 356);
function closeAll(toClose) {
    var stream, stream$array, stream$index, stream$max;
    for(stream$array = toClose, stream$index = 0, stream$max = stream$array.length; stream$index < stream$max; ++stream$index){
        stream = stream$array[stream$index];
        $close(stream);
    }
}
function concat_1(streams) {
    var characteristics, estimatedSize, isParallel, splitr, splitrsBuilder, stream, stream$array, stream$index, stream$max;
    isParallel = false;
    characteristics = 336;
    estimatedSize = 0;
    splitrsBuilder = new ImmutableList$Builder(streams.length);
    for(stream$array = streams, stream$index = 0, stream$max = stream$array.length; stream$index < stream$max; ++stream$index){
        stream = stream$array[stream$index];
        isParallel = isParallel | ($throwIfTerminated(stream), false);
        splitr = ($terminate(stream), stream.spliterator);
        $add_3(splitrsBuilder.contents, checkNotNull(splitr));
        characteristics &= splitr.characteristics_0();
        estimatedSize = saturatedAdd(estimatedSize, splitr.estimateSize_0());
    }
    return castTo(castTo($onClose(new StreamImpl(null, flatMap(new Spliterators$IteratorSpliterator(($clinit_ImmutableList(), copyFromCollection(splitrsBuilder.contents)), 16), new Streams$lambda$0$Type, characteristics, estimatedSize)), new Streams$lambda$1$Type(streams)), 672), 827);
}
function Streams$lambda$0$Type() {}
defineClass(1112, 1, {}, Streams$lambda$0$Type);
_.apply_0 = function apply_18(arg0) {
    return castTo(arg0, 158);
};
var Lcom_google_common_collect_Streams$lambda$0$Type_2_classLit = createForClass('com.google.common.collect', 'Streams/lambda$0$Type', 1112);
function Streams$lambda$1$Type(streams_0) {
    this.streams_0 = streams_0;
}
defineClass(1113, 1, $intern_40, Streams$lambda$1$Type);
_.run = function run_0() {
    closeAll(this.streams_0);
};
var Lcom_google_common_collect_Streams$lambda$1$Type_2_classLit = createForClass('com.google.common.collect', 'Streams/lambda$1$Type', 1113);
function equalsImpl_4(table, obj) {
    var result, result0, that;
    if (obj === table) return true;
    else if (instanceOf(obj, 663)) {
        that = castTo(obj, 1992);
        return $equals_0((result0 = table.cellSet, !result0 ? table.cellSet = new AbstractTable$CellSet(table) : result0), (result = that.cellSet, !result ? that.cellSet = new AbstractTable$CellSet(that) : result));
    } else return false;
}
function TreeMultimap(keyComparator, valueComparator) {
    AbstractSortedKeySortedSetMultimap.call(this, new TreeMap_0(keyComparator));
    this.keyComparator = keyComparator;
    this.valueComparator = valueComparator;
}
function create(keyComparator, valueComparator) {
    return new TreeMultimap(castTo(checkNotNull(keyComparator), 51), castTo(checkNotNull(valueComparator), 51));
}
defineClass(1667, 1666, $intern_5, TreeMultimap);
_.asMap_0 = function asMap_5() {
    var result;
    return result = this.asMap, castTo(castTo(!result ? this.asMap = instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableAsMap(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedAsMap(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$AsMap(this, this.map_0) : result, 134), 137);
};
_.createCollection = function createCollection_10() {
    return new TreeSet_0(this.valueComparator);
};
_.createCollection_1 = function createCollection_11() {
    return new TreeSet_0(this.valueComparator);
};
_.keySet_0 = function keySet_15() {
    var result;
    return result = this.keySet, castTo(castTo(!result ? this.keySet = instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableKeySet(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedKeySet(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$KeySet(this, this.map_0) : result, 83), 274);
};
_.createAsMap = function createAsMap_1() {
    return instanceOf(this.map_0, 137) ? new AbstractMapBasedMultimap$NavigableAsMap(this, castTo(this.map_0, 137)) : instanceOf(this.map_0, 134) ? new AbstractMapBasedMultimap$SortedAsMap(this, castTo(this.map_0, 134)) : new AbstractMapBasedMultimap$AsMap(this, this.map_0);
};
_.createCollection_0 = function createCollection_12(key) {
    key == null && this.keyComparator.compare_1(key, key);
    return new TreeSet_0(this.valueComparator);
};
var Lcom_google_common_collect_TreeMultimap_2_classLit = createForClass('com.google.common.collect', 'TreeMultimap', 1667);
function $clinit_DoubleMath() {
    $clinit_DoubleMath = emptyMethod;
    $wnd.Math.log(2);
}
function fuzzyCompare(a, b) {
    $clinit_DoubleMath();
    return checkNonNegative($intern_41), $wnd.Math.abs(a - b) <= $intern_41 || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : compare_0(isNaN(a), isNaN(b));
}
function fuzzyEquals(a, b) {
    $clinit_DoubleMath();
    checkNonNegative($intern_41);
    return $wnd.Math.abs(a - b) <= $intern_41 || a == b || isNaN(a) && isNaN(b);
}
function saturatedAdd(a, b) {
    var naiveSum;
    naiveSum = add_20(a, b);
    if (lt(xor_0(a, b), 0) | gte_0(xor_0(a, naiveSum), 0)) return naiveSum;
    return add_20($intern_21, xor_0(shru_0(naiveSum, 63), 1));
}
function checkNonNegative(x_0) {
    if (!(x_0 >= 0)) throw toJs(new IllegalArgumentException_0('tolerance (' + x_0 + ') must be >= 0'));
    return x_0;
}
function compare_0(a, b) {
    return a == b ? 0 : a ? 1 : -1;
}
function saturatedCast(value_0) {
    if (compare_2(value_0, $intern_0) > 0) return $intern_0;
    if (compare_2(value_0, $intern_42) < 0) return $intern_42;
    return toInt_0(value_0);
}
function $$init_0(this$static) {
    this$static.stackTrace = initUnidimensionalArray(Ljava_lang_StackTraceElement_2_classLit, $intern_16, 320, 0, 0, 1);
}
function $addSuppressed(this$static, exception) {
    checkCriticalNotNull_0(exception, 'Cannot suppress a null exception.');
    checkCriticalArgument_0(exception != this$static, 'Exception can not suppress itself.');
    if (this$static.disableSuppression) return;
    this$static.suppressedExceptions == null ? this$static.suppressedExceptions = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Throwable_2_classLit, 1), $intern_16, 80, 0, [
        exception
    ]) : this$static.suppressedExceptions[this$static.suppressedExceptions.length] = exception;
}
function $fillInStackTrace(this$static) {
    if (this$static.writableStackTrace) {
        this$static.backingJsObject !== '__noinit__' && this$static.initializeBackingError();
        this$static.stackTrace = null;
    }
    return this$static;
}
function $linkBack(this$static, error) {
    if (error instanceof Object) try {
        error.__java$exception = this$static;
        if (navigator.userAgent.toLowerCase().indexOf('msie') != -1 && $doc.documentMode < 9) return;
        var throwable = this$static;
        Object.defineProperties(error, {
            cause: {
                get: function() {
                    var cause = throwable.getCause();
                    return cause && cause.getBackingJsObject();
                }
            },
            suppressed: {
                get: function() {
                    return throwable.getBackingSuppressed();
                }
            }
        });
    } catch (ignored) {}
}
function $printStackTraceImpl(this$static, out, ident) {
    var t, t$array, t$index, t$max, theCause;
    String.fromCharCode(10);
    $printStackTraceItems(this$static);
    for(t$array = (this$static.suppressedExceptions == null && (this$static.suppressedExceptions = initUnidimensionalArray(Ljava_lang_Throwable_2_classLit, $intern_16, 80, 0, 0, 1)), this$static.suppressedExceptions), t$index = 0, t$max = t$array.length; t$index < t$max; ++t$index){
        t = t$array[t$index];
        $printStackTraceImpl(t, out, '\t' + ident);
    }
    theCause = this$static.cause_0;
    !!theCause && $printStackTraceImpl(theCause, out, ident);
}
function $printStackTraceItems(this$static) {
    var element$array, element$index, element$max, stackTrace;
    for(element$array = (this$static.stackTrace == null && (this$static.stackTrace = ($clinit_StackTraceCreator(), stackTrace = collector_1.getStackTrace(this$static), dropInternalFrames(stackTrace))), this$static.stackTrace), element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index)String.fromCharCode(10);
}
function $setBackingJsObject(this$static, backingJsObject) {
    this$static.backingJsObject = backingJsObject;
    $linkBack(this$static, backingJsObject);
}
function $toString_4(this$static, message) {
    var className;
    className = $getName(this$static.___clazz);
    return message == null ? className : className + ': ' + message;
}
function Throwable() {
    $$init_0(this);
    $fillInStackTrace(this);
    this.initializeBackingError();
}
function Throwable_0(message) {
    $$init_0(this);
    this.detailMessage = message;
    $fillInStackTrace(this);
    this.initializeBackingError();
}
function Throwable_1(message, cause) {
    $$init_0(this);
    this.cause_0 = cause;
    this.detailMessage = message;
    $fillInStackTrace(this);
    this.initializeBackingError();
}
function fixIE(e) {
    if (!('stack' in e)) try {
        throw e;
    } catch (ignored) {}
    return e;
}
defineClass(80, 1, {
    3: 1,
    80: 1
});
_.createError = function createError(msg) {
    return new Error(msg);
};
_.getBackingJsObject = function getBackingJsObject() {
    return this.backingJsObject;
};
_.getBackingSuppressed = function getBackingSuppressed() {
    var i, result, suppressed;
    suppressed = (this.suppressedExceptions == null && (this.suppressedExceptions = initUnidimensionalArray(Ljava_lang_Throwable_2_classLit, $intern_16, 80, 0, 0, 1)), this.suppressedExceptions);
    result = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, suppressed.length, 5, 1);
    for(i = 0; i < suppressed.length; i++)result[i] = suppressed[i].backingJsObject;
    return result;
};
_.getCause = function getCause() {
    return this.cause_0;
};
_.getMessage = function getMessage() {
    return this.detailMessage;
};
_.initializeBackingError = function initializeBackingError() {
    $setBackingJsObject(this, fixIE(this.createError($toString_4(this, this.detailMessage))));
    captureStackTrace(this);
};
_.toString_0 = function toString_30() {
    return $toString_4(this, this.getMessage());
};
_.backingJsObject = '__noinit__';
_.disableSuppression = false;
_.writableStackTrace = true;
var Ljava_lang_Throwable_2_classLit = createForClass('java.lang', 'Throwable', 80);
defineClass(103, 80, {
    3: 1,
    103: 1,
    80: 1
});
var Ljava_lang_Exception_2_classLit = createForClass('java.lang', 'Exception', 103);
function RuntimeException() {
    Throwable.call(this);
}
function RuntimeException_0(message) {
    Throwable_0.call(this, message);
}
defineClass(63, 103, $intern_43, RuntimeException, RuntimeException_0);
var Ljava_lang_RuntimeException_2_classLit = createForClass('java.lang', 'RuntimeException', 63);
defineClass(591, 63, $intern_43);
var Ljava_lang_JsException_2_classLit = createForClass('java.lang', 'JsException', 591);
defineClass(851, 591, $intern_43);
var Lcom_google_gwt_core_client_impl_JavaScriptExceptionBase_2_classLit = createForClass('com.google.gwt.core.client.impl', 'JavaScriptExceptionBase', 851);
function $clinit_JavaScriptException() {
    $clinit_JavaScriptException = emptyMethod;
    NOT_SET = new Object_0;
}
function $ensureInit(this$static) {
    var exception;
    if (this$static.message_0 == null) {
        exception = maskUndefined(this$static.e) === maskUndefined(NOT_SET) ? null : this$static.e;
        this$static.name_0 = exception == null ? 'null' : instanceOfJso(exception) ? getExceptionName0(castToJso(exception)) : instanceOfString(exception) ? 'String' : $getName(getClass__Ljava_lang_Class___devirtual$(exception));
        this$static.description = this$static.description + ': ' + (instanceOfJso(exception) ? getExceptionDescription0(castToJso(exception)) : exception + '');
        this$static.message_0 = '(' + this$static.name_0 + ') ' + this$static.description;
    }
}
function JavaScriptException(e) {
    $clinit_JavaScriptException();
    $$init_0(this);
    $fillInStackTrace(this);
    this.backingJsObject = e;
    $linkBack(this, e);
    this.detailMessage = e == null ? 'null' : toString_40(e);
    this.description = '';
    this.e = e;
    this.description = '';
}
function getExceptionDescription0(e) {
    return e == null ? null : e.message;
}
function getExceptionName0(e) {
    return e == null ? null : e.name;
}
defineClass(472, 851, {
    472: 1,
    3: 1,
    103: 1,
    63: 1,
    80: 1
}, JavaScriptException);
_.getMessage = function getMessage_0() {
    $ensureInit(this);
    return this.message_0;
};
_.getThrown = function getThrown() {
    return maskUndefined(this.e) === maskUndefined(NOT_SET) ? null : this.e;
};
var NOT_SET;
var Lcom_google_gwt_core_client_JavaScriptException_2_classLit = createForClass('com.google.gwt.core.client', 'JavaScriptException', 472);
function $equals_3(this$static, other) {
    return !!this$static && !!this$static.equals ? this$static.equals(other) : maskUndefined(this$static) === maskUndefined(other);
}
function $hashCode(this$static) {
    return !!this$static && !!this$static.hashCode ? this$static.hashCode() : getObjectIdentityHashCode(this$static);
}
var Lcom_google_gwt_core_client_JavaScriptObject_2_classLit = createForClass('com.google.gwt.core.client', 'JavaScriptObject$', 0);
function escapeChar(c, escapeTable) {
    var lookedUp = escapeTable_0[c.charCodeAt(0)];
    return lookedUp == null ? c : lookedUp;
}
function escapeValue(toEscape) {
    var escapeTable = (!escapeTable_0 && (escapeTable_0 = initEscapeTable()), escapeTable_0);
    var s = toEscape.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g, function(x_0) {
        return escapeChar(x_0, escapeTable);
    });
    return '"' + s + '"';
}
function initEscapeTable() {
    var out = [
        '\\u0000',
        '\\u0001',
        '\\u0002',
        '\\u0003',
        '\\u0004',
        '\\u0005',
        '\\u0006',
        '\\u0007',
        '\\b',
        '\\t',
        '\\n',
        '\\u000B',
        '\\f',
        '\\r',
        '\\u000E',
        '\\u000F',
        '\\u0010',
        '\\u0011',
        '\\u0012',
        '\\u0013',
        '\\u0014',
        '\\u0015',
        '\\u0016',
        '\\u0017',
        '\\u0018',
        '\\u0019',
        '\\u001A',
        '\\u001B',
        '\\u001C',
        '\\u001D',
        '\\u001E',
        '\\u001F'
    ];
    out[34] = '\\"';
    out[92] = '\\\\';
    out[173] = '\\u00ad';
    out[1536] = '\\u0600';
    out[1537] = '\\u0601';
    out[1538] = '\\u0602';
    out[1539] = '\\u0603';
    out[1757] = '\\u06dd';
    out[1807] = '\\u070f';
    out[6068] = '\\u17b4';
    out[6069] = '\\u17b5';
    out[8203] = '\\u200b';
    out[8204] = '\\u200c';
    out[8205] = '\\u200d';
    out[8206] = '\\u200e';
    out[8207] = '\\u200f';
    out[8232] = '\\u2028';
    out[8233] = '\\u2029';
    out[8234] = '\\u202a';
    out[8235] = '\\u202b';
    out[8236] = '\\u202c';
    out[8237] = '\\u202d';
    out[8238] = '\\u202e';
    out[8288] = '\\u2060';
    out[8289] = '\\u2061';
    out[8290] = '\\u2062';
    out[8291] = '\\u2063';
    out[8292] = '\\u2064';
    out[8298] = '\\u206a';
    out[8299] = '\\u206b';
    out[8300] = '\\u206c';
    out[8301] = '\\u206d';
    out[8302] = '\\u206e';
    out[8303] = '\\u206f';
    out[65279] = '\\ufeff';
    out[65529] = '\\ufff9';
    out[65530] = '\\ufffa';
    out[65531] = '\\ufffb';
    return out;
}
var escapeTable_0;
defineClass(1993, 1, {});
var Lcom_google_gwt_core_client_Scheduler_2_classLit = createForClass('com.google.gwt.core.client', 'Scheduler', 1993);
function $clinit_Impl() {
    $clinit_Impl = emptyMethod;
    $clinit_StackTraceCreator(), collector_1;
}
function apply_19(jsFunction, thisObj, args) {
    var __0;
    return jsFunction.apply(thisObj, args);
}
function enter_0() {
    var now_0;
    if (entryDepth != 0) {
        now_0 = Date.now();
        if (now_0 - watchdogEntryDepthLastScheduled > 2000) {
            watchdogEntryDepthLastScheduled = now_0;
            watchdogEntryDepthTimerId = $wnd.setTimeout(watchdogEntryDepthRun, 10);
        }
    }
    if (entryDepth++ == 0) {
        $flushEntryCommands(($clinit_SchedulerImpl(), INSTANCE_3));
        return true;
    }
    return false;
}
function entry_2(jsFunction) {
    $clinit_Impl();
    return function() {
        var __0;
        return entry0_0(jsFunction, this, arguments);
    };
}
function entry0_0(jsFunction, thisObj, args) {
    var initialEntry;
    initialEntry = enter_0();
    try {
        return apply_19(jsFunction, thisObj, args);
    } finally{
        exit(initialEntry);
    }
}
function exit(initialEntry) {
    initialEntry && $flushFinallyCommands(($clinit_SchedulerImpl(), INSTANCE_3));
    --entryDepth;
    if (initialEntry) {
        if (watchdogEntryDepthTimerId != -1) {
            watchdogEntryDepthCancel(watchdogEntryDepthTimerId);
            watchdogEntryDepthTimerId = -1;
        }
    }
}
function reportToBrowser(e) {
    $clinit_Impl();
    $wnd.setTimeout(function() {
        throw e;
    }, 0);
}
function watchdogEntryDepthCancel(timerId) {
    $wnd.clearTimeout(timerId);
}
function watchdogEntryDepthRun() {
    entryDepth != 0 && (entryDepth = 0);
    watchdogEntryDepthTimerId = -1;
}
var entryDepth = 0, watchdogEntryDepthLastScheduled = 0, watchdogEntryDepthTimerId = -1;
function $clinit_SchedulerImpl() {
    $clinit_SchedulerImpl = emptyMethod;
    INSTANCE_3 = new SchedulerImpl;
}
function $flushEntryCommands(this$static) {
    var oldQueue, rescheduled;
    if (this$static.entryCommands) {
        rescheduled = null;
        do {
            oldQueue = this$static.entryCommands;
            this$static.entryCommands = null;
            rescheduled = runScheduledTasks(oldQueue, rescheduled);
        }while (this$static.entryCommands);
        this$static.entryCommands = rescheduled;
    }
}
function $flushFinallyCommands(this$static) {
    var oldQueue, rescheduled;
    if (this$static.finallyCommands) {
        rescheduled = null;
        do {
            oldQueue = this$static.finallyCommands;
            this$static.finallyCommands = null;
            rescheduled = runScheduledTasks(oldQueue, rescheduled);
        }while (this$static.finallyCommands);
        this$static.finallyCommands = rescheduled;
    }
}
function SchedulerImpl() {}
function push_0(queue, task) {
    !queue && (queue = []);
    queue[queue.length] = task;
    return queue;
}
function runScheduledTasks(tasks, rescheduled) {
    var e, i, j, t;
    for(i = 0, j = tasks.length; i < j; i++){
        t = tasks[i];
        try {
            t[1] ? t[0].$_nullMethod() && (rescheduled = push_0(rescheduled, t)) : t[0].$_nullMethod();
        } catch ($e0) {
            $e0 = toJava($e0);
            if (instanceOf($e0, 80)) {
                e = $e0;
                $clinit_Impl();
                reportToBrowser(instanceOf(e, 472) ? castTo(e, 472).getThrown() : e);
            } else throw toJs($e0);
        }
    }
    return rescheduled;
}
defineClass(878, 1993, {}, SchedulerImpl);
var INSTANCE_3;
var Lcom_google_gwt_core_client_impl_SchedulerImpl_2_classLit = createForClass('com.google.gwt.core.client.impl', 'SchedulerImpl', 878);
function $clinit_StackTraceCreator() {
    $clinit_StackTraceCreator = emptyMethod;
    var c, enforceLegacy;
    enforceLegacy = !supportsErrorStack();
    c = new StackTraceCreator$CollectorModernNoSourceMap;
    collector_1 = enforceLegacy ? new StackTraceCreator$CollectorLegacy : c;
}
function captureStackTrace(error) {
    $clinit_StackTraceCreator();
    collector_1.collect(error);
}
function dropInternalFrames(stackTrace) {
    var dropFrameUntilFnName, dropFrameUntilFnName2, i, numberOfFramesToSearch;
    dropFrameUntilFnName = 'captureStackTrace';
    dropFrameUntilFnName2 = 'initializeBackingError';
    numberOfFramesToSearch = $wnd.Math.min(stackTrace.length, 5);
    for(i = numberOfFramesToSearch - 1; i >= 0; i--)if ($equals_5(stackTrace[i].methodName, dropFrameUntilFnName) || $equals_5(stackTrace[i].methodName, dropFrameUntilFnName2)) {
        stackTrace.length >= i + 1 && stackTrace.splice(0, i + 1);
        break;
    }
    return stackTrace;
}
function extractFunctionName(fnName) {
    var fnRE = /function(?:\s+([\w$]+))?\s*\(/;
    var match_0 = fnRE.exec(fnName);
    return match_0 && match_0[1] || 'anonymous';
}
function parseInt_0(number) {
    $clinit_StackTraceCreator();
    return parseInt(number) || -1;
}
function split_1(t) {
    $clinit_StackTraceCreator();
    var e = t.backingJsObject;
    if (e && e.stack) {
        var stack_0 = e.stack;
        var toString_0 = e + '\n';
        stack_0.substring(0, toString_0.length) == toString_0 && (stack_0 = stack_0.substring(toString_0.length));
        return stack_0.split('\n');
    }
    return [];
}
function supportsErrorStack() {
    if (Error.stackTraceLimit > 0) {
        $wnd.Error.stackTraceLimit = Error.stackTraceLimit = 64;
        return true;
    }
    return 'stack' in new Error;
}
var collector_1;
defineClass(2004, 1, {});
var Lcom_google_gwt_core_client_impl_StackTraceCreator$Collector_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/Collector', 2004);
function StackTraceCreator$CollectorLegacy() {}
defineClass(852, 2004, {}, StackTraceCreator$CollectorLegacy);
_.collect = function collect(error) {
    var seen = {}, name_1;
    var fnStack = [];
    error['fnStack'] = fnStack;
    var callee = arguments.callee.caller;
    while(callee){
        var name_0 = ($clinit_StackTraceCreator(), callee.name || (callee.name = extractFunctionName(callee.toString())));
        fnStack.push(name_0);
        var keyName = ':' + name_0;
        var withThisName = seen[keyName];
        if (withThisName) {
            var i, j;
            for(i = 0, j = withThisName.length; i < j; i++){
                if (withThisName[i] === callee) return;
            }
        }
        (withThisName || (seen[keyName] = [])).push(callee);
        callee = callee.caller;
    }
};
_.getStackTrace = function getStackTrace(t) {
    var i, length_0, stack_0, stackTrace;
    stack_0 = ($clinit_StackTraceCreator(), t && t['fnStack'] ? t['fnStack'] : []);
    length_0 = stack_0.length;
    stackTrace = initUnidimensionalArray(Ljava_lang_StackTraceElement_2_classLit, $intern_16, 320, length_0, 0, 1);
    for(i = 0; i < length_0; i++)stackTrace[i] = new StackTraceElement(stack_0[i], null, -1);
    return stackTrace;
};
var Lcom_google_gwt_core_client_impl_StackTraceCreator$CollectorLegacy_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/CollectorLegacy', 852);
function $parse(this$static, stString) {
    var closeParen, col, endFileUrlIndex, fileName, index_0, lastColonIndex, line, location_0, toReturn;
    location_0 = '';
    if (stString.length == 0) return this$static.createSte('Unknown', 'anonymous', -1, -1);
    toReturn = $trim(stString);
    $equals_5(toReturn.substr(0, 3), 'at ') && (toReturn = (checkCriticalStringElementIndex(3, toReturn.length + 1), toReturn.substr(3)));
    toReturn = toReturn.replace(/\[.*?\]/g, '');
    index_0 = toReturn.indexOf('(');
    if (index_0 == -1) {
        index_0 = toReturn.indexOf('@');
        if (index_0 == -1) {
            location_0 = toReturn;
            toReturn = '';
        } else {
            location_0 = $trim((checkCriticalStringElementIndex(index_0 + 1, toReturn.length + 1), toReturn.substr(index_0 + 1)));
            toReturn = $trim((checkCriticalStringBounds(0, index_0, toReturn.length), toReturn.substr(0, index_0)));
        }
    } else {
        closeParen = toReturn.indexOf(')', index_0);
        location_0 = (checkCriticalStringBounds(index_0 + 1, closeParen, toReturn.length), toReturn.substr(index_0 + 1, closeParen - (index_0 + 1)));
        toReturn = $trim((checkCriticalStringBounds(0, index_0, toReturn.length), toReturn.substr(0, index_0)));
    }
    index_0 = $indexOf_1(toReturn, fromCodePoint(46));
    index_0 != -1 && (toReturn = (checkCriticalStringElementIndex(index_0 + 1, toReturn.length + 1), toReturn.substr(index_0 + 1)));
    (toReturn.length == 0 || $equals_5(toReturn, 'Anonymous function')) && (toReturn = 'anonymous');
    lastColonIndex = $lastIndexOf(location_0, fromCodePoint(58));
    endFileUrlIndex = $lastIndexOf_0(location_0, fromCodePoint(58), lastColonIndex - 1);
    line = -1;
    col = -1;
    fileName = 'Unknown';
    if (lastColonIndex != -1 && endFileUrlIndex != -1) {
        fileName = (checkCriticalStringBounds(0, endFileUrlIndex, location_0.length), location_0.substr(0, endFileUrlIndex));
        line = parseInt_0((checkCriticalStringBounds(endFileUrlIndex + 1, lastColonIndex, location_0.length), location_0.substr(endFileUrlIndex + 1, lastColonIndex - (endFileUrlIndex + 1))));
        col = parseInt_0((checkCriticalStringElementIndex(lastColonIndex + 1, location_0.length + 1), location_0.substr(lastColonIndex + 1)));
    }
    return this$static.createSte(fileName, toReturn, line, col);
}
defineClass(2005, 2004, {});
_.collect = function collect_0(error) {};
_.createSte = function createSte(fileName, method, line, col) {
    return new StackTraceElement(method, fileName + '@' + col, line < 0 ? -1 : line);
};
_.getStackTrace = function getStackTrace_0(t) {
    var addIndex, i, length_0, stack_0, stackTrace, ste;
    stack_0 = split_1(t);
    stackTrace = initUnidimensionalArray(Ljava_lang_StackTraceElement_2_classLit, $intern_16, 320, 0, 0, 1);
    addIndex = 0;
    length_0 = stack_0.length;
    if (length_0 == 0) return stackTrace;
    ste = $parse(this, stack_0[0]);
    $equals_5(ste.methodName, 'anonymous') || (stackTrace[addIndex++] = ste);
    for(i = 1; i < length_0; i++)stackTrace[addIndex++] = $parse(this, stack_0[i]);
    return stackTrace;
};
var Lcom_google_gwt_core_client_impl_StackTraceCreator$CollectorModern_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/CollectorModern', 2005);
function StackTraceCreator$CollectorModernNoSourceMap() {}
defineClass(853, 2005, {}, StackTraceCreator$CollectorModernNoSourceMap);
_.createSte = function createSte_0(fileName, method, line, col) {
    return new StackTraceElement(method, fileName, -1);
};
var Lcom_google_gwt_core_client_impl_StackTraceCreator$CollectorModernNoSourceMap_2_classLit = createForClass('com.google.gwt.core.client.impl', 'StackTraceCreator/CollectorModernNoSourceMap', 853);
function $clinit_DateTimeFormat() {
    $clinit_DateTimeFormat = emptyMethod;
    new HashMap;
}
function $addPart(this$static, buf, count) {
    var oldLength;
    if (buf.string.length > 0) {
        $add_3(this$static.patternParts, new DateTimeFormat$PatternPart(buf.string, count));
        oldLength = buf.string.length;
        0 < oldLength ? buf.string = $substring_1(buf.string, 0, 0) : 0 > oldLength && (buf.string += valueOf_7(initUnidimensionalArray(C_classLit, $intern_44, 30, -oldLength, 15, 1)));
    }
}
function $format(this$static, date, timeZone) {
    var ch_0, diff, i, j, keepDate, keepTime, n, toAppendTo, trailQuote;
    !timeZone && (timeZone = createTimeZone(date.jsdate.getTimezoneOffset()));
    diff = (date.jsdate.getTimezoneOffset() - timeZone.standardOffset) * 60000;
    keepDate = new Date_2(add_20(fromDouble_0(date.jsdate.getTime()), diff));
    keepTime = keepDate;
    if (keepDate.jsdate.getTimezoneOffset() != date.jsdate.getTimezoneOffset()) {
        diff > 0 ? diff -= 86400000 : diff += 86400000;
        keepTime = new Date_2(add_20(fromDouble_0(date.jsdate.getTime()), diff));
    }
    toAppendTo = new StringBuilder_0;
    n = this$static.pattern.length;
    for(i = 0; i < n;){
        ch_0 = $charAt(this$static.pattern, i);
        if (ch_0 >= 97 && ch_0 <= 122 || ch_0 >= 65 && ch_0 <= 90) {
            for(j = i + 1; j < n && $charAt(this$static.pattern, j) == ch_0; ++j);
            $subFormat(toAppendTo, ch_0, j - i, keepDate, keepTime, timeZone);
            i = j;
        } else if (ch_0 == 39) {
            ++i;
            if (i < n && $charAt(this$static.pattern, i) == 39) {
                toAppendTo.string += "'";
                ++i;
                continue;
            }
            trailQuote = false;
            while(!trailQuote){
                j = i;
                while(j < n && $charAt(this$static.pattern, j) != 39)++j;
                if (j >= n) throw toJs(new IllegalArgumentException_0("Missing trailing '"));
                j + 1 < n && $charAt(this$static.pattern, j + 1) == 39 ? ++j : trailQuote = true;
                $append_11(toAppendTo, $substring_1(this$static.pattern, i, j));
                i = j + 1;
            }
        } else {
            toAppendTo.string += String.fromCharCode(ch_0);
            ++i;
        }
    }
    return toAppendTo.string;
}
function $formatFractionalSeconds(buf, count, date) {
    var time, value_0;
    time = fromDouble_0(date.jsdate.getTime());
    if (compare_2(time, 0) < 0) {
        value_0 = $intern_45 - toInt_0(mod(neg_0(time), $intern_45));
        value_0 == $intern_45 && (value_0 = 0);
    } else value_0 = toInt_0(mod(time, $intern_45));
    if (count == 1) {
        value_0 = $wnd.Math.min((value_0 + 50) / 100 | 0, 9);
        $append_5(buf, 48 + value_0 & $intern_46);
    } else if (count == 2) {
        value_0 = $wnd.Math.min((value_0 + 5) / 10 | 0, 99);
        $zeroPaddingNumber(buf, value_0, 2);
    } else {
        $zeroPaddingNumber(buf, value_0, 3);
        count > 3 && $zeroPaddingNumber(buf, 0, count - 3);
    }
}
function $formatMonth(buf, count, date) {
    var value_0;
    value_0 = date.jsdate.getMonth();
    switch(count){
        case 5:
            $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'J',
                'F',
                'M',
                'A',
                'M',
                'J',
                'J',
                'A',
                'S',
                'O',
                'N',
                'D'
            ])[value_0]);
            break;
        case 4:
            $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ])[value_0]);
            break;
        case 3:
            $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ])[value_0]);
            break;
        default:
            $zeroPaddingNumber(buf, value_0 + 1, count);
    }
}
function $formatYear(buf, count, date) {
    var value_0;
    value_0 = date.jsdate.getFullYear() - $intern_47 + $intern_47;
    value_0 < 0 && (value_0 = -value_0);
    switch(count){
        case 1:
            buf.string += value_0;
            break;
        case 2:
            $zeroPaddingNumber(buf, value_0 % 100, 2);
            break;
        default:
            $zeroPaddingNumber(buf, value_0, count);
    }
}
function $getNextCharCountInPattern(pattern, start_0) {
    var ch_0, next;
    ch_0 = (checkCriticalStringElementIndex(start_0, pattern.length), pattern.charCodeAt(start_0));
    next = start_0 + 1;
    while(next < pattern.length && (checkCriticalStringElementIndex(next, pattern.length), pattern.charCodeAt(next) == ch_0))++next;
    return next - start_0;
}
function $identifyAbutStart(this$static) {
    var abut, i, len;
    abut = false;
    len = this$static.patternParts.array.length;
    for(i = 0; i < len; i++){
        if ($isNumeric(castTo($get_11(this$static.patternParts, i), 431))) {
            if (!abut && i + 1 < len && $isNumeric(castTo($get_11(this$static.patternParts, i + 1), 431))) {
                abut = true;
                castTo($get_11(this$static.patternParts, i), 431).abutStart = true;
            }
        } else abut = false;
    }
}
function $isNumeric(part) {
    var i;
    if (part.count <= 0) return false;
    i = $indexOf_1('MLydhHmsSDkK', fromCodePoint($charAt(part.text_0, 0)));
    return i > 1 || i >= 0 && part.count < 3;
}
function $matchString(text_0, start_0, data_0, pos) {
    var bestMatch, bestMatchLength, count, i, length_0, textInLowerCase;
    count = data_0.length;
    bestMatchLength = 0;
    bestMatch = -1;
    textInLowerCase = $toLowerCase((checkCriticalStringElementIndex(start_0, text_0.length + 1), text_0.substr(start_0)), ($clinit_Locale(), ROOT));
    for(i = 0; i < count; ++i){
        length_0 = data_0[i].length;
        if (length_0 > bestMatchLength && $startsWith(textInLowerCase, $toLowerCase(data_0[i], ROOT))) {
            bestMatch = i;
            bestMatchLength = length_0;
        }
    }
    bestMatch >= 0 && (pos[0] = start_0 + bestMatchLength);
    return bestMatch;
}
function $parse_0(this$static, text_0, date) {
    var abutPass, abutPat, abutStart, cal, count, i, parsePos, part, s;
    cal = new DateRecord;
    parsePos = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        0
    ]);
    abutPat = -1;
    abutStart = 0;
    abutPass = 0;
    for(i = 0; i < this$static.patternParts.array.length; ++i){
        part = castTo($get_11(this$static.patternParts, i), 431);
        if (part.count > 0) {
            if (abutPat < 0 && part.abutStart) {
                abutPat = i;
                abutStart = parsePos[0];
                abutPass = 0;
            }
            if (abutPat >= 0) {
                count = part.count;
                if (i == abutPat) {
                    count -= abutPass++;
                    if (count == 0) return 0;
                }
                if (!$subParse(text_0, parsePos, part, count, cal)) {
                    i = abutPat - 1;
                    parsePos[0] = abutStart;
                    continue;
                }
            } else {
                abutPat = -1;
                if (!$subParse(text_0, parsePos, part, 0, cal)) return 0;
            }
        } else {
            abutPat = -1;
            if ($charAt(part.text_0, 0) == 32) {
                s = parsePos[0];
                $skipSpace(text_0, parsePos);
                if (parsePos[0] > s) continue;
            } else if ($startsWith_0(text_0, part.text_0, parsePos[0])) {
                parsePos[0] += part.text_0.length;
                continue;
            }
            return 0;
        }
    }
    if (!$calcDate(cal, date)) return 0;
    return parsePos[0];
}
function $parse_1(this$static, text_0) {
    var charsConsumed, curDate, date;
    curDate = new Date_0;
    date = new Date_1(curDate.jsdate.getFullYear() - $intern_47, curDate.jsdate.getMonth(), curDate.jsdate.getDate());
    charsConsumed = $parse_0(this$static, text_0, date);
    if (charsConsumed == 0 || charsConsumed < text_0.length) throw toJs(new IllegalArgumentException_0(text_0));
    return date;
}
function $parseInt(text_0, pos) {
    var ch_0, ind, ret;
    ret = 0;
    ind = pos[0];
    if (ind >= text_0.length) return -1;
    ch_0 = (checkCriticalStringElementIndex(ind, text_0.length), text_0.charCodeAt(ind));
    while(ch_0 >= 48 && ch_0 <= 57){
        ret = ret * 10 + (ch_0 - 48);
        ++ind;
        if (ind >= text_0.length) break;
        ch_0 = (checkCriticalStringElementIndex(ind, text_0.length), text_0.charCodeAt(ind));
    }
    ind > pos[0] ? pos[0] = ind : ret = -1;
    return ret;
}
function $parsePattern(this$static, pattern) {
    var buf, ch_0, count, i, inQuote;
    buf = new StringBuilder_0;
    inQuote = false;
    for(i = 0; i < pattern.length; i++){
        ch_0 = (checkCriticalStringElementIndex(i, pattern.length), pattern.charCodeAt(i));
        if (ch_0 == 32) {
            $addPart(this$static, buf, 0);
            buf.string += ' ';
            $addPart(this$static, buf, 0);
            while(i + 1 < pattern.length && (checkCriticalStringElementIndex(i + 1, pattern.length), pattern.charCodeAt(i + 1) == 32))++i;
            continue;
        }
        if (inQuote) {
            if (ch_0 == 39) {
                if (i + 1 < pattern.length && (checkCriticalStringElementIndex(i + 1, pattern.length), pattern.charCodeAt(i + 1) == 39)) {
                    buf.string += String.fromCharCode(ch_0);
                    ++i;
                } else inQuote = false;
            } else buf.string += String.fromCharCode(ch_0);
            continue;
        }
        if ($indexOf_1('GyMLdkHmsSEcDahKzZv', fromCodePoint(ch_0)) > 0) {
            $addPart(this$static, buf, 0);
            buf.string += String.fromCharCode(ch_0);
            count = $getNextCharCountInPattern(pattern, i);
            $addPart(this$static, buf, count);
            i += count - 1;
            continue;
        }
        if (ch_0 == 39) {
            if (i + 1 < pattern.length && (checkCriticalStringElementIndex(i + 1, pattern.length), pattern.charCodeAt(i + 1) == 39)) {
                buf.string += "'";
                ++i;
            } else inQuote = true;
        } else buf.string += String.fromCharCode(ch_0);
    }
    $addPart(this$static, buf, 0);
    $identifyAbutStart(this$static);
}
function $parseTimeZoneOffset(text_0, pos, cal) {
    var offset, sign, st, value_0;
    if (pos[0] >= text_0.length) {
        cal.tzOffset = 0;
        return true;
    }
    switch($charAt(text_0, pos[0])){
        case 43:
            sign = 1;
            break;
        case 45:
            sign = -1;
            break;
        default:
            cal.tzOffset = 0;
            return true;
    }
    ++pos[0];
    st = pos[0];
    value_0 = $parseInt(text_0, pos);
    if (value_0 == 0 && pos[0] == st) return false;
    if (pos[0] < text_0.length && $charAt(text_0, pos[0]) == 58) {
        offset = value_0 * 60;
        ++pos[0];
        st = pos[0];
        value_0 = $parseInt(text_0, pos);
        if (value_0 == 0 && pos[0] == st) return false;
        offset += value_0;
    } else {
        offset = value_0;
        offset < 24 && pos[0] - st <= 2 ? offset *= 60 : offset = offset % 100 + (offset / 100 | 0) * 60;
    }
    offset *= sign;
    cal.tzOffset = -offset;
    return true;
}
function $skipSpace(text_0, pos) {
    while(pos[0] < text_0.length && $indexOf_1(' \t\r\n', fromCodePoint($charAt(text_0, pos[0]))) >= 0)++pos[0];
}
function $subFormat(buf, ch_0, count, adjustedDate, adjustedTime, timezone) {
    var value_0, value0, value1, value10, value2, value3, value4, value5, value6, value7, value8, value9;
    switch(ch_0){
        case 71:
            value0 = adjustedDate.jsdate.getFullYear() - $intern_47 >= -1900 ? 1 : 0;
            count >= 4 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Before Christ',
                'Anno Domini'
            ])[value0]) : $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'BC',
                'AD'
            ])[value0]);
            break;
        case 121:
            $formatYear(buf, count, adjustedDate);
            break;
        case 77:
            $formatMonth(buf, count, adjustedDate);
            break;
        case 107:
            value1 = adjustedTime.jsdate.getHours();
            value1 == 0 ? $zeroPaddingNumber(buf, 24, count) : $zeroPaddingNumber(buf, value1, count);
            break;
        case 83:
            $formatFractionalSeconds(buf, count, adjustedTime);
            break;
        case 69:
            value2 = adjustedDate.jsdate.getDay();
            count == 5 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'S',
                'M',
                'T',
                'W',
                'T',
                'F',
                'S'
            ])[value2]) : count == 4 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ])[value2]) : $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ])[value2]);
            break;
        case 97:
            adjustedTime.jsdate.getHours() >= 12 && adjustedTime.jsdate.getHours() < 24 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'AM',
                'PM'
            ])[1]) : $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'AM',
                'PM'
            ])[0]);
            break;
        case 104:
            value3 = adjustedTime.jsdate.getHours() % 12;
            value3 == 0 ? $zeroPaddingNumber(buf, 12, count) : $zeroPaddingNumber(buf, value3, count);
            break;
        case 75:
            value4 = adjustedTime.jsdate.getHours() % 12;
            $zeroPaddingNumber(buf, value4, count);
            break;
        case 72:
            value5 = adjustedTime.jsdate.getHours();
            $zeroPaddingNumber(buf, value5, count);
            break;
        case 99:
            value6 = adjustedDate.jsdate.getDay();
            count == 5 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'S',
                'M',
                'T',
                'W',
                'T',
                'F',
                'S'
            ])[value6]) : count == 4 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ])[value6]) : count == 3 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ])[value6]) : $zeroPaddingNumber(buf, value6, 1);
            break;
        case 76:
            value7 = adjustedDate.jsdate.getMonth();
            count == 5 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'J',
                'F',
                'M',
                'A',
                'M',
                'J',
                'J',
                'A',
                'S',
                'O',
                'N',
                'D'
            ])[value7]) : count == 4 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ])[value7]) : count == 3 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ])[value7]) : $zeroPaddingNumber(buf, value7 + 1, count);
            break;
        case 81:
            value8 = adjustedDate.jsdate.getMonth() / 3 | 0;
            count < 4 ? $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Q1',
                'Q2',
                'Q3',
                'Q4'
            ])[value8]) : $append_11(buf, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                '1st quarter',
                '2nd quarter',
                '3rd quarter',
                '4th quarter'
            ])[value8]);
            break;
        case 100:
            value9 = adjustedDate.jsdate.getDate();
            $zeroPaddingNumber(buf, value9, count);
            break;
        case 109:
            value10 = adjustedTime.jsdate.getMinutes();
            $zeroPaddingNumber(buf, value10, count);
            break;
        case 115:
            value_0 = adjustedTime.jsdate.getSeconds();
            $zeroPaddingNumber(buf, value_0, count);
            break;
        case 122:
            count < 4 ? $append_11(buf, timezone.tzNames[0]) : $append_11(buf, timezone.tzNames[1]);
            break;
        case 118:
            $append_11(buf, timezone.timezoneID);
            break;
        case 90:
            count < 3 ? $append_11(buf, $getRFCTimeZoneString(timezone)) : count == 3 ? $append_11(buf, $getISOTimeZoneString(timezone)) : $append_11(buf, composeGMTString(timezone.standardOffset));
            break;
        default:
            return false;
    }
    return true;
}
function $subParse(text_0, pos, part, digitCount, cal) {
    var ch_0, start_0, value_0;
    $skipSpace(text_0, pos);
    start_0 = pos[0];
    ch_0 = $charAt(part.text_0, 0);
    value_0 = -1;
    if ($isNumeric(part)) {
        if (digitCount > 0) {
            if (start_0 + digitCount > text_0.length) return false;
            value_0 = $parseInt((checkCriticalStringBounds(0, start_0 + digitCount, text_0.length), text_0.substr(0, start_0 + digitCount)), pos);
        } else value_0 = $parseInt(text_0, pos);
    }
    switch(ch_0){
        case 71:
            value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'Before Christ',
                'Anno Domini'
            ]), pos);
            cal.era = value_0;
            return true;
        case 77:
            return $subParseMonth(text_0, pos, cal, value_0, start_0);
        case 76:
            return $subParseStandaloneMonth(text_0, pos, cal, value_0, start_0);
        case 69:
            return $subParseDayOfWeek(text_0, pos, start_0, cal);
        case 99:
            return $subParseStandaloneDay(text_0, pos, start_0, cal);
        case 97:
            value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
                'AM',
                'PM'
            ]), pos);
            cal.ampm = value_0;
            return true;
        case 121:
            return $subParseYear(text_0, pos, start_0, value_0, part, cal);
        case 100:
            if (value_0 <= 0) return false;
            cal.dayOfMonth = value_0;
            return true;
        case 83:
            if (value_0 < 0) return false;
            return $subParseFractionalSeconds(value_0, start_0, pos[0], cal);
        case 104:
            value_0 == 12 && (value_0 = 0);
        case 75:
        case 72:
            if (value_0 < 0) return false;
            cal.hours = value_0;
            cal.midnightIs24 = false;
            return true;
        case 107:
            if (value_0 < 0) return false;
            cal.hours = value_0;
            cal.midnightIs24 = true;
            return true;
        case 109:
            if (value_0 < 0) return false;
            cal.minutes = value_0;
            return true;
        case 115:
            if (value_0 < 0) return false;
            cal.seconds = value_0;
            return true;
        case 90:
            if (start_0 < text_0.length && (checkCriticalStringElementIndex(start_0, text_0.length), text_0.charCodeAt(start_0) == 90)) {
                ++pos[0];
                cal.tzOffset = 0;
                return true;
            }
        case 122:
        case 118:
            return $subParseTimeZoneInGMT(text_0, start_0, pos, cal);
        default:
            return false;
    }
}
function $subParseDayOfWeek(text_0, pos, start_0, cal) {
    var value_0;
    value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]), pos);
    value_0 < 0 && (value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]), pos));
    if (value_0 < 0) return false;
    cal.dayOfWeek = value_0;
    return true;
}
function $subParseFractionalSeconds(value_0, start_0, end, cal) {
    var a, i;
    i = end - start_0;
    if (i < 3) while(i < 3){
        value_0 *= 10;
        ++i;
    }
    else {
        a = 1;
        while(i > 3){
            a *= 10;
            --i;
        }
        value_0 = (value_0 + (a >> 1)) / a | 0;
    }
    cal.milliseconds = value_0;
    return true;
}
function $subParseMonth(text_0, pos, cal, value_0, start_0) {
    if (value_0 < 0) {
        value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]), pos);
        value_0 < 0 && (value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ]), pos));
        if (value_0 < 0) return false;
        cal.month = value_0;
        return true;
    } else if (value_0 > 0) {
        cal.month = value_0 - 1;
        return true;
    }
    return false;
}
function $subParseStandaloneDay(text_0, pos, start_0, cal) {
    var value_0;
    value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]), pos);
    value_0 < 0 && (value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]), pos));
    if (value_0 < 0) return false;
    cal.dayOfWeek = value_0;
    return true;
}
function $subParseStandaloneMonth(text_0, pos, cal, value_0, start_0) {
    if (value_0 < 0) {
        value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]), pos);
        value_0 < 0 && (value_0 = $matchString(text_0, start_0, stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ]), pos));
        if (value_0 < 0) return false;
        cal.month = value_0;
        return true;
    } else if (value_0 > 0) {
        cal.month = value_0 - 1;
        return true;
    }
    return false;
}
function $subParseTimeZoneInGMT(text_0, start_0, pos, cal) {
    if (start_0 >= 0 && $equals_5(text_0.substr(start_0, 3), 'GMT')) {
        pos[0] = start_0 + 3;
        return $parseTimeZoneOffset(text_0, pos, cal);
    }
    if (start_0 >= 0 && $equals_5(text_0.substr(start_0, 3), 'UTC')) {
        pos[0] = start_0 + 3;
        return $parseTimeZoneOffset(text_0, pos, cal);
    }
    return $parseTimeZoneOffset(text_0, pos, cal);
}
function $subParseYear(text_0, pos, start_0, value_0, part, cal) {
    var ambiguousTwoDigitYear, ch_0, date, defaultCenturyStartYear;
    ch_0 = 32;
    if (value_0 < 0) {
        if (pos[0] >= text_0.length) return false;
        ch_0 = $charAt(text_0, pos[0]);
        if (ch_0 != 43 && ch_0 != 45) return false;
        ++pos[0];
        value_0 = $parseInt(text_0, pos);
        if (value_0 < 0) return false;
        ch_0 == 45 && (value_0 = -value_0);
    }
    if (ch_0 == 32 && pos[0] - start_0 == 2 && part.count == 2) {
        date = new Date_0;
        defaultCenturyStartYear = date.jsdate.getFullYear() - $intern_47 + $intern_47 - 80;
        ambiguousTwoDigitYear = defaultCenturyStartYear % 100;
        cal.ambiguousYear = value_0 == ambiguousTwoDigitYear;
        value_0 += (defaultCenturyStartYear / 100 | 0) * 100 + (value_0 < ambiguousTwoDigitYear ? 100 : 0);
    }
    cal.year = value_0;
    return true;
}
function $zeroPaddingNumber(buf, value_0, minWidth) {
    var b, i;
    b = 10;
    for(i = 0; i < minWidth - 1; i++){
        value_0 < b && (buf.string += '0', buf);
        b *= 10;
    }
    buf.string += value_0;
}
defineClass(1039, 1, {});
var Lcom_google_gwt_i18n_shared_DateTimeFormat_2_classLit = createForClass('com.google.gwt.i18n.shared', 'DateTimeFormat', 1039);
function $clinit_DateTimeFormat_0() {
    $clinit_DateTimeFormat_0 = emptyMethod;
    $clinit_DateTimeFormat();
    cache = new HashMap;
}
function DateTimeFormat(pattern) {
    $clinit_DateTimeFormat();
    this.patternParts = new ArrayList;
    this.pattern = pattern;
    $parsePattern(this, pattern);
}
function getFormat(pattern, dtfi) {
    $clinit_DateTimeFormat_0();
    var defaultDtfi, dtf;
    defaultDtfi = $getDateTimeFormatInfo(($clinit_LocaleInfo(), $clinit_LocaleInfo(), instance_0));
    dtf = null;
    dtfi == defaultDtfi && (dtf = castTo($getStringValue(cache, pattern), 609));
    if (!dtf) {
        dtf = new DateTimeFormat(pattern);
        dtfi == defaultDtfi && $putStringValue(cache, pattern, dtf);
    }
    return dtf;
}
defineClass(609, 1039, {
    609: 1
}, DateTimeFormat);
var cache;
var Lcom_google_gwt_i18n_client_DateTimeFormat_2_classLit = createForClass('com.google.gwt.i18n.client', 'DateTimeFormat', 609);
defineClass(2047, 1, {});
var Lcom_google_gwt_i18n_shared_DefaultDateTimeFormatInfo_2_classLit = createForClass('com.google.gwt.i18n.shared', 'DefaultDateTimeFormatInfo', 2047);
defineClass($intern_49, 2047, {});
var Lcom_google_gwt_i18n_client_DefaultDateTimeFormatInfo_2_classLit = createForClass('com.google.gwt.i18n.client', 'DefaultDateTimeFormatInfo', $intern_49);
function $clinit_LocaleInfo() {
    $clinit_LocaleInfo = emptyMethod;
    instance_0 = new LocaleInfo;
}
function $getDateTimeFormatInfo(this$static) {
    !this$static.dateTimeFormatInfo && (this$static.dateTimeFormatInfo = new DateTimeFormatInfoImpl);
    return this$static.dateTimeFormatInfo;
}
function LocaleInfo() {}
defineClass(1084, 1, {}, LocaleInfo);
var instance_0;
var Lcom_google_gwt_i18n_client_LocaleInfo_2_classLit = createForClass('com.google.gwt.i18n.client', 'LocaleInfo', 1084);
function $getISOTimeZoneString(this$static) {
    var data_0, offset;
    offset = -this$static.standardOffset;
    data_0 = stampJavaTypeInfo(getClassLiteralForArray(C_classLit, 1), $intern_44, 30, 15, [
        43,
        48,
        48,
        58,
        48,
        48
    ]);
    if (offset < 0) {
        data_0[0] = 45;
        offset = -offset;
    }
    data_0[1] = data_0[1] + ((offset / 60 | 0) / 10 | 0) & $intern_46;
    data_0[2] = data_0[2] + (offset / 60 | 0) % 10 & $intern_46;
    data_0[4] = data_0[4] + (offset % 60 / 10 | 0) & $intern_46;
    data_0[5] = data_0[5] + offset % 10 & $intern_46;
    return valueOf_8(data_0, 0, data_0.length);
}
function $getRFCTimeZoneString(this$static) {
    var data_0, offset;
    offset = -this$static.standardOffset;
    data_0 = stampJavaTypeInfo(getClassLiteralForArray(C_classLit, 1), $intern_44, 30, 15, [
        43,
        48,
        48,
        48,
        48
    ]);
    if (offset < 0) {
        data_0[0] = 45;
        offset = -offset;
    }
    data_0[1] = data_0[1] + ((offset / 60 | 0) / 10 | 0) & $intern_46;
    data_0[2] = data_0[2] + (offset / 60 | 0) % 10 & $intern_46;
    data_0[3] = data_0[3] + (offset % 60 / 10 | 0) & $intern_46;
    data_0[4] = data_0[4] + offset % 10 & $intern_46;
    return valueOf_8(data_0, 0, data_0.length);
}
function TimeZone() {}
function composeGMTString(offset) {
    var data_0;
    data_0 = stampJavaTypeInfo(getClassLiteralForArray(C_classLit, 1), $intern_44, 30, 15, [
        71,
        77,
        84,
        45,
        48,
        48,
        58,
        48,
        48
    ]);
    if (offset <= 0) {
        data_0[3] = 43;
        offset = -offset;
    }
    data_0[4] = data_0[4] + ((offset / 60 | 0) / 10 | 0) & $intern_46;
    data_0[5] = data_0[5] + (offset / 60 | 0) % 10 & $intern_46;
    data_0[7] = data_0[7] + (offset % 60 / 10 | 0) & $intern_46;
    data_0[8] = data_0[8] + offset % 10 & $intern_46;
    return valueOf_8(data_0, 0, data_0.length);
}
function composePOSIXTimeZoneID(offset) {
    var str;
    if (offset == 0) return 'Etc/GMT';
    if (offset < 0) {
        offset = -offset;
        str = 'Etc/GMT-';
    } else str = 'Etc/GMT+';
    return str + offsetDisplay(offset);
}
function composeUTCString(offset) {
    var str;
    if (offset == 0) return 'UTC';
    if (offset < 0) {
        offset = -offset;
        str = 'UTC+';
    } else str = 'UTC-';
    return str + offsetDisplay(offset);
}
function createTimeZone(timeZoneOffsetInMinutes) {
    var tz;
    tz = new TimeZone;
    tz.standardOffset = timeZoneOffsetInMinutes;
    tz.timezoneID = composePOSIXTimeZoneID(timeZoneOffsetInMinutes);
    tz.tzNames = initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 2, 6, 1);
    tz.tzNames[0] = composeUTCString(timeZoneOffsetInMinutes);
    tz.tzNames[1] = composeUTCString(timeZoneOffsetInMinutes);
    return tz;
}
function offsetDisplay(offset) {
    var hour, mins;
    hour = offset / 60 | 0;
    mins = offset % 60;
    if (mins == 0) return '' + hour;
    return '' + hour + ':' + ('' + mins);
}
defineClass(1973, 1, {}, TimeZone);
_.standardOffset = 0;
var Lcom_google_gwt_i18n_client_TimeZone_2_classLit = createForClass('com.google.gwt.i18n.client', 'TimeZone', 1973);
function DateTimeFormatInfoImpl() {}
defineClass(1246, $intern_49, {}, DateTimeFormatInfoImpl);
var Lcom_google_gwt_i18n_client_impl_cldr_DateTimeFormatInfoImpl_2_classLit = createForClass('com.google.gwt.i18n.client.impl.cldr', 'DateTimeFormatInfoImpl', 1246);
function DateTimeFormat$PatternPart(txt, cnt) {
    this.text_0 = txt;
    this.count = cnt;
    this.abutStart = false;
}
defineClass(431, 1, {
    431: 1
}, DateTimeFormat$PatternPart);
_.abutStart = false;
_.count = 0;
var Lcom_google_gwt_i18n_shared_DateTimeFormat$PatternPart_2_classLit = createForClass('com.google.gwt.i18n.shared', 'DateTimeFormat/PatternPart', 431);
function $compareTo_0(this$static, other) {
    return compare_6(fromDouble_0(this$static.jsdate.getTime()), fromDouble_0(other.jsdate.getTime()));
}
function $fixDaylightSavings(this$static, requestedHours) {
    var badHours, copy, day, newTime, originalTimeInMillis, timeDiff, timeDiffHours, timeDiffMinutes;
    requestedHours %= 24;
    if (this$static.jsdate.getHours() != requestedHours) {
        copy = new $wnd.Date(this$static.jsdate.getTime());
        copy.setDate(copy.getDate() + 1);
        timeDiff = this$static.jsdate.getTimezoneOffset() - copy.getTimezoneOffset();
        if (timeDiff > 0) {
            timeDiffHours = timeDiff / 60 | 0;
            timeDiffMinutes = timeDiff % 60;
            day = this$static.jsdate.getDate();
            badHours = this$static.jsdate.getHours();
            badHours + timeDiffHours >= 24 && ++day;
            newTime = new $wnd.Date(this$static.jsdate.getFullYear(), this$static.jsdate.getMonth(), day, requestedHours + timeDiffHours, this$static.jsdate.getMinutes() + timeDiffMinutes, this$static.jsdate.getSeconds(), this$static.jsdate.getMilliseconds());
            this$static.jsdate.setTime(newTime.getTime());
        }
    }
    originalTimeInMillis = this$static.jsdate.getTime();
    this$static.jsdate.setTime(originalTimeInMillis + 3600000);
    this$static.jsdate.getHours() != requestedHours && this$static.jsdate.setTime(originalTimeInMillis);
}
function $setDate(this$static, date) {
    var hours;
    hours = this$static.jsdate.getHours();
    this$static.jsdate.setDate(date);
    $fixDaylightSavings(this$static, hours);
}
function $setHours(this$static, hours) {
    this$static.jsdate.setHours(hours);
    $fixDaylightSavings(this$static, hours);
}
function $setMinutes(this$static, minutes) {
    var hours;
    hours = this$static.jsdate.getHours() + (minutes / 60 | 0);
    this$static.jsdate.setMinutes(minutes);
    $fixDaylightSavings(this$static, hours);
}
function $setMonth(this$static, month) {
    var hours;
    hours = this$static.jsdate.getHours();
    this$static.jsdate.setMonth(month);
    $fixDaylightSavings(this$static, hours);
}
function $setSeconds(this$static, seconds) {
    var hours;
    hours = this$static.jsdate.getHours() + (seconds / 3600 | 0);
    this$static.jsdate.setSeconds(seconds);
    $fixDaylightSavings(this$static, hours);
}
function $setTime(this$static, time) {
    this$static.jsdate.setTime(toDouble_0(time));
}
function $setYear(this$static, year) {
    var hours;
    hours = this$static.jsdate.getHours();
    this$static.jsdate.setFullYear(year + $intern_47);
    $fixDaylightSavings(this$static, hours);
}
function Date_0() {
    this.jsdate = new $wnd.Date;
}
function Date_1(year, month, date) {
    this.jsdate = new $wnd.Date;
    this.jsdate.setFullYear(year + $intern_47, month, date);
    this.jsdate.setHours(0, 0, 0, 0);
    $fixDaylightSavings(this, 0);
}
function Date_2(date) {
    this.jsdate = new $wnd.Date(toDouble_0(date));
}
function padTwo(number) {
    return number < 10 ? '0' + number : '' + number;
}
defineClass(205, 1, $intern_50, Date_0, Date_1, Date_2);
_.compareTo_0 = function compareTo_4(other) {
    return $compareTo_0(this, castTo(other, 205));
};
_.equals_0 = function equals_30(obj) {
    return instanceOf(obj, 205) && eq(fromDouble_0(this.jsdate.getTime()), fromDouble_0(castTo(obj, 205).jsdate.getTime()));
};
_.hashCode_1 = function hashCode_30() {
    var time;
    time = fromDouble_0(this.jsdate.getTime());
    return toInt_0(xor_0(time, shru_0(time, 32)));
};
_.toString_0 = function toString_31() {
    var hourOffset, minuteOffset, offset;
    offset = -this.jsdate.getTimezoneOffset();
    hourOffset = (offset >= 0 ? '+' : '') + (offset / 60 | 0);
    minuteOffset = padTwo($wnd.Math.abs(offset) % 60);
    return ($clinit_Date$StringData(), DAYS)[this.jsdate.getDay()] + ' ' + MONTHS[this.jsdate.getMonth()] + ' ' + padTwo(this.jsdate.getDate()) + ' ' + padTwo(this.jsdate.getHours()) + ':' + padTwo(this.jsdate.getMinutes()) + ':' + padTwo(this.jsdate.getSeconds()) + ' GMT' + hourOffset + minuteOffset + ' ' + this.jsdate.getFullYear();
};
var Ljava_util_Date_2_classLit = createForClass('java.util', 'Date', 205);
function $calcDate(this$static, date) {
    var adjustment, daysInCurrentMonth, defaultCenturyStart, offset, orgDayOfMonth, orgMonth, tmp;
    this$static.era == 0 && this$static.year > 0 && (this$static.year = -(this$static.year - 1));
    this$static.year > $intern_42 && $setYear(date, this$static.year - $intern_47);
    orgDayOfMonth = date.jsdate.getDate();
    $setDate(date, 1);
    this$static.month >= 0 && $setMonth(date, this$static.month);
    if (this$static.dayOfMonth >= 0) $setDate(date, this$static.dayOfMonth);
    else if (this$static.month >= 0) {
        tmp = new Date_1(date.jsdate.getFullYear() - $intern_47, date.jsdate.getMonth(), 35);
        daysInCurrentMonth = 35 - tmp.jsdate.getDate();
        $setDate(date, $wnd.Math.min(daysInCurrentMonth, orgDayOfMonth));
    } else $setDate(date, orgDayOfMonth);
    this$static.hours < 0 && (this$static.hours = date.jsdate.getHours());
    this$static.ampm > 0 && this$static.hours < 12 && (this$static.hours += 12);
    $setHours(date, this$static.hours == 24 && this$static.midnightIs24 ? 0 : this$static.hours);
    this$static.minutes >= 0 && $setMinutes(date, this$static.minutes);
    this$static.seconds >= 0 && $setSeconds(date, this$static.seconds);
    this$static.milliseconds >= 0 && $setTime(date, add_20(mul_0(div(fromDouble_0(date.jsdate.getTime()), $intern_45), $intern_45), this$static.milliseconds));
    if (this$static.ambiguousYear) {
        defaultCenturyStart = new Date_0;
        $setYear(defaultCenturyStart, defaultCenturyStart.jsdate.getFullYear() - $intern_47 - 80);
        lt(fromDouble_0(date.jsdate.getTime()), fromDouble_0(defaultCenturyStart.jsdate.getTime())) && $setYear(date, defaultCenturyStart.jsdate.getFullYear() - $intern_47 + 100);
    }
    if (this$static.dayOfWeek >= 0) {
        if (this$static.dayOfMonth == -1) {
            adjustment = (7 + this$static.dayOfWeek - date.jsdate.getDay()) % 7;
            adjustment > 3 && (adjustment -= 7);
            orgMonth = date.jsdate.getMonth();
            $setDate(date, date.jsdate.getDate() + adjustment);
            date.jsdate.getMonth() != orgMonth && $setDate(date, date.jsdate.getDate() + (adjustment > 0 ? -7 : 7));
        } else {
            if (date.jsdate.getDay() != this$static.dayOfWeek) return false;
        }
    }
    if (this$static.tzOffset > $intern_42) {
        offset = date.jsdate.getTimezoneOffset();
        $setTime(date, add_20(fromDouble_0(date.jsdate.getTime()), (this$static.tzOffset - offset) * 60 * $intern_45));
    }
    return true;
}
function DateRecord() {
    Date_0.call(this);
    this.era = -1;
    this.ambiguousYear = false;
    this.year = $intern_42;
    this.month = -1;
    this.dayOfMonth = -1;
    this.ampm = -1;
    this.midnightIs24 = false;
    this.hours = -1;
    this.minutes = -1;
    this.seconds = -1;
    this.milliseconds = -1;
    this.dayOfWeek = -1;
    this.tzOffset = $intern_42;
}
defineClass(1961, 205, $intern_50, DateRecord);
_.ambiguousYear = false;
_.ampm = 0;
_.dayOfMonth = 0;
_.dayOfWeek = 0;
_.era = 0;
_.hours = 0;
_.midnightIs24 = false;
_.milliseconds = 0;
_.minutes = 0;
_.month = 0;
_.seconds = 0;
_.tzOffset = 0;
_.year = 0;
var Lcom_google_gwt_i18n_shared_impl_DateRecord_2_classLit = createForClass('com.google.gwt.i18n.shared.impl', 'DateRecord', 1961);
defineClass(2010, 1, {});
_.isArray_0 = function isArray() {
    return null;
};
_.isBoolean = function isBoolean() {
    return null;
};
_.isNumber = function isNumber() {
    return null;
};
_.isObject = function isObject() {
    return null;
};
_.isString = function isString() {
    return null;
};
var Lcom_google_gwt_json_client_JSONValue_2_classLit = createForClass('com.google.gwt.json.client', 'JSONValue', 2010);
function $get_8(this$static, index_0) {
    var v = this$static.jsArray[index_0];
    var func = ($clinit_JSONParser(), typeMap)[typeof v];
    return func ? func(v) : throwUnknownTypeException(typeof v);
}
function $set_0(this$static, index_0, value_0) {
    var previous;
    previous = $get_8(this$static, index_0);
    $set0(this$static, index_0, value_0);
    return previous;
}
function $set0(this$static, index_0, value_0) {
    if (value_0) {
        var func = value_0.getUnwrapper();
        value_0 = func(value_0);
    } else value_0 = undefined;
    this$static.jsArray[index_0] = value_0;
}
function JSONArray() {
    this.jsArray = [];
}
function JSONArray_0(arr) {
    this.jsArray = arr;
}
function unwrap(value_0) {
    return value_0.jsArray;
}
defineClass(138, 2010, {
    138: 1
}, JSONArray, JSONArray_0);
_.equals_0 = function equals_31(other) {
    if (!instanceOf(other, 138)) return false;
    return $equals_3(this.jsArray, castTo(other, 138).jsArray);
};
_.getUnwrapper = function getUnwrapper() {
    return unwrap;
};
_.hashCode_1 = function hashCode_31() {
    return $hashCode(this.jsArray);
};
_.isArray_0 = function isArray_0() {
    return this;
};
_.toString_0 = function toString_32() {
    var c, i, sb;
    sb = new StringBuilder_1('[');
    for(i = 0, c = this.jsArray.length; i < c; i++){
        i > 0 && (sb.string += ',', sb);
        $append_10(sb, $get_8(this, i));
    }
    sb.string += ']';
    return sb.string;
};
var Lcom_google_gwt_json_client_JSONArray_2_classLit = createForClass('com.google.gwt.json.client', 'JSONArray', 138);
function $clinit_JSONBoolean() {
    $clinit_JSONBoolean = emptyMethod;
    FALSE = new JSONBoolean(false);
    TRUE = new JSONBoolean(true);
}
function JSONBoolean(value_0) {
    this.value_0 = value_0;
}
function unwrap_0(value_0) {
    return value_0.value_0;
}
defineClass(477, 2010, {
    477: 1
}, JSONBoolean);
_.getUnwrapper = function getUnwrapper_0() {
    return unwrap_0;
};
_.isBoolean = function isBoolean_0() {
    return this;
};
_.toString_0 = function toString_33() {
    return $clinit_Boolean(), '' + this.value_0;
};
_.value_0 = false;
var FALSE, TRUE;
var Lcom_google_gwt_json_client_JSONBoolean_2_classLit = createForClass('com.google.gwt.json.client', 'JSONBoolean', 477);
function JSONException(message) {
    RuntimeException_0.call(this, message);
}
defineClass(974, 63, $intern_43, JSONException);
var Lcom_google_gwt_json_client_JSONException_2_classLit = createForClass('com.google.gwt.json.client', 'JSONException', 974);
function $clinit_JSONNull() {
    $clinit_JSONNull = emptyMethod;
    instance_1 = new JSONNull;
}
function JSONNull() {}
function unwrap_1() {
    return null;
}
defineClass(1011, 2010, {}, JSONNull);
_.getUnwrapper = function getUnwrapper_1() {
    return unwrap_1;
};
_.toString_0 = function toString_34() {
    return 'null';
};
var instance_1;
var Lcom_google_gwt_json_client_JSONNull_2_classLit = createForClass('com.google.gwt.json.client', 'JSONNull', 1011);
function JSONNumber(value_0) {
    this.value_0 = value_0;
}
function unwrap_2(value_0) {
    return value_0.value_0;
}
defineClass(263, 2010, {
    263: 1
}, JSONNumber);
_.equals_0 = function equals_32(other) {
    if (!instanceOf(other, 263)) return false;
    return this.value_0 == castTo(other, 263).value_0;
};
_.getUnwrapper = function getUnwrapper_2() {
    return unwrap_2;
};
_.hashCode_1 = function hashCode_32() {
    return $hashCode_1(this.value_0);
};
_.isNumber = function isNumber_0() {
    return this;
};
_.toString_0 = function toString_35() {
    return this.value_0 + '';
};
_.value_0 = 0;
var Lcom_google_gwt_json_client_JSONNumber_2_classLit = createForClass('com.google.gwt.json.client', 'JSONNumber', 263);
function $computeKeys0(this$static, result) {
    var jsObject = this$static.jsObject;
    var i = 0;
    for(var key in jsObject)jsObject.hasOwnProperty(key) && (result[i++] = key);
    return result;
}
function $containsKey_2(this$static, key) {
    return key in this$static.jsObject;
}
function $get_9(this$static, key) {
    if (key == null) throw toJs(new NullPointerException);
    return $get0(this$static, key);
}
function $get0(this$static, key) {
    var jsObject = this$static.jsObject;
    var v;
    key = String(key);
    jsObject.hasOwnProperty(key) && (v = jsObject[key]);
    var func = ($clinit_JSONParser(), typeMap)[typeof v];
    var ret = func ? func(v) : throwUnknownTypeException(typeof v);
    return ret;
}
function $put_5(this$static, key, jsonValue) {
    var previous;
    if (key == null) throw toJs(new NullPointerException);
    previous = $get_9(this$static, key);
    $put0(this$static, key, jsonValue);
    return previous;
}
function $put0(this$static, key, value_0) {
    if (value_0) {
        var func = value_0.getUnwrapper();
        this$static.jsObject[key] = func(value_0);
    } else delete this$static.jsObject[key];
}
function JSONObject() {
    JSONObject_0.call(this, {});
}
function JSONObject_0(jsValue) {
    this.jsObject = jsValue;
}
function unwrap_3(value_0) {
    return value_0.jsObject;
}
defineClass(147, 2010, {
    147: 1
}, JSONObject, JSONObject_0);
_.equals_0 = function equals_33(other) {
    if (!instanceOf(other, 147)) return false;
    return $equals_3(this.jsObject, castTo(other, 147).jsObject);
};
_.getUnwrapper = function getUnwrapper_3() {
    return unwrap_3;
};
_.hashCode_1 = function hashCode_33() {
    return $hashCode(this.jsObject);
};
_.isObject = function isObject_0() {
    return this;
};
_.toString_0 = function toString_36() {
    var first, key, key$array, key$index, key$max, keys_0, sb;
    sb = new StringBuilder_1('{');
    first = true;
    keys_0 = $computeKeys0(this, initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 0, 6, 1));
    for(key$array = keys_0, key$index = 0, key$max = key$array.length; key$index < key$max; ++key$index){
        key = key$array[key$index];
        first ? first = false : (sb.string += ', ', sb);
        $append_11(sb, escapeValue(key));
        sb.string += ':';
        $append_10(sb, $get_9(this, key));
    }
    sb.string += '}';
    return sb.string;
};
var Lcom_google_gwt_json_client_JSONObject_2_classLit = createForClass('com.google.gwt.json.client', 'JSONObject', 147);
function JSONObject$1(this$0, val$keys) {
    this.this$01 = this$0;
    this.val$keys2 = val$keys;
}
defineClass(589, $intern_9, $intern_10, JSONObject$1);
_.contains = function contains_27(o) {
    return instanceOfString(o) && $containsKey_2(this.this$01, castToString(o));
};
_.iterator_0 = function iterator_45() {
    return new AbstractList$IteratorImpl(new Arrays$ArrayList(this.val$keys2));
};
_.size_1 = function size_36() {
    return this.val$keys2.length;
};
var Lcom_google_gwt_json_client_JSONObject$1_2_classLit = createForClass('com.google.gwt.json.client', 'JSONObject/1', 589);
function $clinit_JSONParser() {
    $clinit_JSONParser = emptyMethod;
    typeMap = {
        'boolean': createBoolean,
        'number': createNumber,
        'string': createString,
        'object': createObject,
        'function': createObject,
        'undefined': createUndefined
    };
}
function createBoolean(v) {
    return $clinit_JSONBoolean(), v ? TRUE : FALSE;
}
function createNumber(v) {
    return new JSONNumber(v);
}
function createObject(o) {
    if (!o) return $clinit_JSONNull(), instance_1;
    var v = o.valueOf ? o.valueOf() : o;
    if (v !== o) {
        var func = typeMap[typeof v];
        return func ? func(v) : throwUnknownTypeException(typeof v);
    } else if (o instanceof Array || o instanceof $wnd.Array) return new JSONArray_0(o);
    else return new JSONObject_0(o);
}
function createString(v) {
    return new JSONString(v);
}
function createUndefined() {
    return null;
}
function throwUnknownTypeException(typeString) {
    $clinit_JSONParser();
    throw toJs(new JSONException("Unexpected typeof result '" + typeString + "'; please report this bug to the GWT team"));
}
var typeMap;
function JSONString(value_0) {
    if (value_0 == null) throw toJs(new NullPointerException);
    this.value_0 = value_0;
}
function unwrap_4(value_0) {
    return value_0.value_0;
}
defineClass(210, 2010, {
    210: 1
}, JSONString);
_.equals_0 = function equals_34(other) {
    if (!instanceOf(other, 210)) return false;
    return $equals_5(this.value_0, castTo(other, 210).value_0);
};
_.getUnwrapper = function getUnwrapper_4() {
    return unwrap_4;
};
_.hashCode_1 = function hashCode_34() {
    return $hashCode_2(this.value_0);
};
_.isString = function isString_0() {
    return this;
};
_.toString_0 = function toString_37() {
    return escapeValue(this.value_0);
};
var Lcom_google_gwt_json_client_JSONString_2_classLit = createForClass('com.google.gwt.json.client', 'JSONString', 210);
function canSet(array, value_0) {
    var elementTypeCategory;
    switch(getElementTypeCategory(array)){
        case 6:
            return instanceOfString(value_0);
        case 7:
            return instanceOfDouble(value_0);
        case 8:
            return instanceOfBoolean(value_0);
        case 3:
            return Array.isArray(value_0) && (elementTypeCategory = getElementTypeCategory(value_0), !(elementTypeCategory >= 14 && elementTypeCategory <= 16));
        case 11:
            return value_0 != null && typeof value_0 === 'function';
        case 12:
            return value_0 != null && (typeof value_0 === 'object' || typeof value_0 == 'function');
        case 0:
            return canCast(value_0, array.__elementTypeId$);
        case 2:
            return isJsObjectOrFunction(value_0) && !(value_0.typeMarker === typeMarkerFn);
        case 1:
            return isJsObjectOrFunction(value_0) && !(value_0.typeMarker === typeMarkerFn) || canCast(value_0, array.__elementTypeId$);
        default:
            return true;
    }
}
function getClassLiteralForArray(clazz, dimensions) {
    return getClassLiteralForArray_0(clazz, dimensions);
}
function getElementTypeCategory(array) {
    return array.__elementTypeCategory$ == null ? 10 : array.__elementTypeCategory$;
}
function initMultidimensionalArray(leafClassLiteral, castableTypeMapExprs, elementTypeIds, leafElementTypeCategory, dimExprs, count) {
    return initMultidimensionalArray_0(leafClassLiteral, castableTypeMapExprs, elementTypeIds, leafElementTypeCategory, dimExprs, 0, count);
}
function initMultidimensionalArray_0(leafClassLiteral, castableTypeMapExprs, elementTypeIds, leafElementTypeCategory, dimExprs, index_0, count) {
    var elementTypeCategory, i, isLastDimension, length_0, result;
    length_0 = dimExprs[index_0];
    isLastDimension = index_0 == count - 1;
    elementTypeCategory = isLastDimension ? leafElementTypeCategory : 0;
    result = initializeArrayElementsWithDefaults(elementTypeCategory, length_0);
    leafElementTypeCategory != 10 && stampJavaTypeInfo(getClassLiteralForArray(leafClassLiteral, count - index_0), castableTypeMapExprs[index_0], elementTypeIds[index_0], elementTypeCategory, result);
    if (!isLastDimension) {
        ++index_0;
        for(i = 0; i < length_0; ++i)result[i] = initMultidimensionalArray_0(leafClassLiteral, castableTypeMapExprs, elementTypeIds, leafElementTypeCategory, dimExprs, index_0, count);
    }
    return result;
}
function initUnidimensionalArray(leafClassLiteral, castableTypeMap, elementTypeId, length_0, elementTypeCategory, dimensions) {
    var result;
    result = initializeArrayElementsWithDefaults(elementTypeCategory, length_0);
    elementTypeCategory != 10 && stampJavaTypeInfo(getClassLiteralForArray(leafClassLiteral, dimensions), castableTypeMap, elementTypeId, elementTypeCategory, result);
    return result;
}
function initializeArrayElementsWithDefaults(elementTypeCategory, length_0) {
    var array = new Array(length_0);
    var initValue;
    switch(elementTypeCategory){
        case 14:
        case 15:
            initValue = 0;
            break;
        case 16:
            initValue = false;
            break;
        default:
            return array;
    }
    for(var i = 0; i < length_0; ++i)array[i] = initValue;
    return array;
}
function isJavaArray(src_0) {
    return Array.isArray(src_0) && src_0.typeMarker === typeMarkerFn;
}
function setCheck(array, index_0, value_0) {
    checkCriticalArrayType(value_0 == null || canSet(array, value_0));
    return array[index_0] = value_0;
}
function stampJavaTypeInfo(arrayClass, castableTypeMap, elementTypeId, elementTypeCategory, array) {
    array.___clazz = arrayClass;
    array.castableTypeMap = castableTypeMap;
    array.typeMarker = typeMarkerFn;
    array.__elementTypeId$ = elementTypeId;
    array.__elementTypeCategory$ = elementTypeCategory;
    return array;
}
function stampJavaTypeInfo_0(array, referenceType) {
    getElementTypeCategory(referenceType) != 10 && stampJavaTypeInfo(getClass__Ljava_lang_Class___devirtual$(referenceType), referenceType.castableTypeMap, referenceType.__elementTypeId$, getElementTypeCategory(referenceType), array);
    return array;
}
function create_0(value_0) {
    var a0, a1, a2;
    a0 = value_0 & $intern_51;
    a1 = value_0 >> 22 & $intern_51;
    a2 = value_0 < 0 ? $intern_52 : 0;
    return create0(a0, a1, a2);
}
function create_1(a) {
    return create0(a.l, a.m, a.h);
}
function create0(l, m, h) {
    return {
        l: l,
        m: m,
        h: h
    };
}
function divMod(a, b, computeRemainder) {
    var aIsCopy, aIsMinValue, aIsNegative, bpower, c, negative;
    if (b.l == 0 && b.m == 0 && b.h == 0) throw toJs(new ArithmeticException('divide by zero'));
    if (a.l == 0 && a.m == 0 && a.h == 0) {
        computeRemainder && (remainder = create0(0, 0, 0));
        return create0(0, 0, 0);
    }
    if (b.h == $intern_53 && b.m == 0 && b.l == 0) return divModByMinValue(a, computeRemainder);
    negative = false;
    if (b.h >> 19 != 0) {
        b = neg(b);
        negative = !negative;
    }
    bpower = powerOfTwo(b);
    aIsNegative = false;
    aIsMinValue = false;
    aIsCopy = false;
    if (a.h == $intern_53 && a.m == 0 && a.l == 0) {
        aIsMinValue = true;
        aIsNegative = true;
        if (bpower == -1) {
            a = create_1(($clinit_BigLongLib$Const(), MAX_VALUE));
            aIsCopy = true;
            negative = !negative;
        } else {
            c = shr(a, bpower);
            negative && negate(c);
            computeRemainder && (remainder = create0(0, 0, 0));
            return c;
        }
    } else if (a.h >> 19 != 0) {
        aIsNegative = true;
        a = neg(a);
        aIsCopy = true;
        negative = !negative;
    }
    if (bpower != -1) return divModByShift(a, bpower, negative, aIsNegative, computeRemainder);
    if (compare_1(a, b) < 0) {
        computeRemainder && (aIsNegative ? remainder = neg(a) : remainder = create0(a.l, a.m, a.h));
        return create0(0, 0, 0);
    }
    return divModHelper(aIsCopy ? a : create0(a.l, a.m, a.h), b, negative, aIsNegative, aIsMinValue, computeRemainder);
}
function divModByMinValue(a, computeRemainder) {
    if (a.h == $intern_53 && a.m == 0 && a.l == 0) {
        computeRemainder && (remainder = create0(0, 0, 0));
        return create_1(($clinit_BigLongLib$Const(), ONE));
    }
    computeRemainder && (remainder = create0(a.l, a.m, a.h));
    return create0(0, 0, 0);
}
function divModByShift(a, bpower, negative, aIsNegative, computeRemainder) {
    var c;
    c = shr(a, bpower);
    negative && negate(c);
    if (computeRemainder) {
        a = maskRight(a, bpower);
        aIsNegative ? remainder = neg(a) : remainder = create0(a.l, a.m, a.h);
    }
    return c;
}
function divModHelper(a, b, negative, aIsNegative, aIsMinValue, computeRemainder) {
    var bshift, gte, quotient, shift_0, a1, a2, a0;
    shift_0 = numberOfLeadingZeros(b) - numberOfLeadingZeros(a);
    bshift = shl(b, shift_0);
    quotient = create0(0, 0, 0);
    while(shift_0 >= 0){
        gte = trialSubtract(a, bshift);
        if (gte) {
            shift_0 < 22 ? (quotient.l |= 1 << shift_0, undefined) : shift_0 < 44 ? (quotient.m |= 1 << shift_0 - 22, undefined) : (quotient.h |= 1 << shift_0 - 44, undefined);
            if (a.l == 0 && a.m == 0 && a.h == 0) break;
        }
        a1 = bshift.m;
        a2 = bshift.h;
        a0 = bshift.l;
        bshift.h = a2 >>> 1;
        bshift.m = a1 >>> 1 | (a2 & 1) << 21;
        bshift.l = a0 >>> 1 | (a1 & 1) << 21;
        --shift_0;
    }
    negative && negate(quotient);
    if (computeRemainder) {
        if (aIsNegative) {
            remainder = neg(a);
            aIsMinValue && (remainder = sub_1(remainder, ($clinit_BigLongLib$Const(), ONE)));
        } else remainder = create0(a.l, a.m, a.h);
    }
    return quotient;
}
function maskRight(a, bits) {
    var b0, b1, b2;
    if (bits <= 22) {
        b0 = a.l & (1 << bits) - 1;
        b1 = b2 = 0;
    } else if (bits <= 44) {
        b0 = a.l;
        b1 = a.m & (1 << bits - 22) - 1;
        b2 = 0;
    } else {
        b0 = a.l;
        b1 = a.m;
        b2 = a.h & (1 << bits - 44) - 1;
    }
    return create0(b0, b1, b2);
}
function negate(a) {
    var neg0, neg1, neg2;
    neg0 = ~a.l + 1 & $intern_51;
    neg1 = ~a.m + (neg0 == 0 ? 1 : 0) & $intern_51;
    neg2 = ~a.h + (neg0 == 0 && neg1 == 0 ? 1 : 0) & $intern_52;
    a.l = neg0;
    a.m = neg1;
    a.h = neg2;
}
function numberOfLeadingZeros(a) {
    var b1, b2;
    b2 = numberOfLeadingZeros_0(a.h);
    if (b2 == 32) {
        b1 = numberOfLeadingZeros_0(a.m);
        return b1 == 32 ? numberOfLeadingZeros_0(a.l) + 32 : b1 + 20 - 10;
    } else return b2 - 12;
}
function powerOfTwo(a) {
    var h, l, m;
    l = a.l;
    if ((l & l - 1) != 0) return -1;
    m = a.m;
    if ((m & m - 1) != 0) return -1;
    h = a.h;
    if ((h & h - 1) != 0) return -1;
    if (h == 0 && m == 0 && l == 0) return -1;
    if (h == 0 && m == 0 && l != 0) return numberOfTrailingZeros(l);
    if (h == 0 && m != 0 && l == 0) return numberOfTrailingZeros(m) + 22;
    if (h != 0 && m == 0 && l == 0) return numberOfTrailingZeros(h) + 44;
    return -1;
}
function toDoubleHelper(a) {
    return a.l + a.m * $intern_54 + a.h * $intern_55;
}
function trialSubtract(a, b) {
    var sum0, sum1, sum2;
    sum2 = a.h - b.h;
    if (sum2 < 0) return false;
    sum0 = a.l - b.l;
    sum1 = a.m - b.m + (sum0 >> 22);
    sum2 += sum1 >> 22;
    if (sum2 < 0) return false;
    a.l = sum0 & $intern_51;
    a.m = sum1 & $intern_51;
    a.h = sum2 & $intern_52;
    return true;
}
var remainder;
function add_19(a, b) {
    var sum0, sum1, sum2;
    sum0 = a.l + b.l;
    sum1 = a.m + b.m + (sum0 >> 22);
    sum2 = a.h + b.h + (sum1 >> 22);
    return create0(sum0 & $intern_51, sum1 & $intern_51, sum2 & $intern_52);
}
function and(a, b) {
    return create0(a.l & b.l, a.m & b.m, a.h & b.h);
}
function compare_1(a, b) {
    var a0, a1, a2, b0, b1, b2, signA, signB;
    signA = a.h >> 19;
    signB = b.h >> 19;
    if (signA != signB) return signB - signA;
    a2 = a.h;
    b2 = b.h;
    if (a2 != b2) return a2 - b2;
    a1 = a.m;
    b1 = b.m;
    if (a1 != b1) return a1 - b1;
    a0 = a.l;
    b0 = b.l;
    return a0 - b0;
}
function fromDouble(value_0) {
    var a0, a1, a2, negative, result;
    if (isNaN(value_0)) return $clinit_BigLongLib$Const(), ZERO;
    if (value_0 < -9223372036854776000) return $clinit_BigLongLib$Const(), MIN_VALUE;
    if (value_0 >= 9223372036854775807) return $clinit_BigLongLib$Const(), MAX_VALUE;
    negative = false;
    if (value_0 < 0) {
        negative = true;
        value_0 = -value_0;
    }
    a2 = 0;
    if (value_0 >= $intern_55) {
        a2 = round_int(value_0 / $intern_55);
        value_0 -= a2 * $intern_55;
    }
    a1 = 0;
    if (value_0 >= $intern_54) {
        a1 = round_int(value_0 / $intern_54);
        value_0 -= a1 * $intern_54;
    }
    a0 = round_int(value_0);
    result = create0(a0, a1, a2);
    negative && negate(result);
    return result;
}
function mul(a, b) {
    var a0, a1, a2, a3, a4, b0, b1, b2, b3, b4, c0, c00, c01, c1, c10, c11, c12, c13, c2, c22, c23, c24, p0, p1, p2, p3, p4;
    a0 = a.l & 8191;
    a1 = a.l >> 13 | (a.m & 15) << 9;
    a2 = a.m >> 4 & 8191;
    a3 = a.m >> 17 | (a.h & 255) << 5;
    a4 = (a.h & 1048320) >> 8;
    b0 = b.l & 8191;
    b1 = b.l >> 13 | (b.m & 15) << 9;
    b2 = b.m >> 4 & 8191;
    b3 = b.m >> 17 | (b.h & 255) << 5;
    b4 = (b.h & 1048320) >> 8;
    p0 = a0 * b0;
    p1 = a1 * b0;
    p2 = a2 * b0;
    p3 = a3 * b0;
    p4 = a4 * b0;
    if (b1 != 0) {
        p1 += a0 * b1;
        p2 += a1 * b1;
        p3 += a2 * b1;
        p4 += a3 * b1;
    }
    if (b2 != 0) {
        p2 += a0 * b2;
        p3 += a1 * b2;
        p4 += a2 * b2;
    }
    if (b3 != 0) {
        p3 += a0 * b3;
        p4 += a1 * b3;
    }
    b4 != 0 && (p4 += a0 * b4);
    c00 = p0 & $intern_51;
    c01 = (p1 & 511) << 13;
    c0 = c00 + c01;
    c10 = p0 >> 22;
    c11 = p1 >> 9;
    c12 = (p2 & 262143) << 4;
    c13 = (p3 & 31) << 17;
    c1 = c10 + c11 + c12 + c13;
    c22 = p2 >> 18;
    c23 = p3 >> 5;
    c24 = (p4 & 4095) << 8;
    c2 = c22 + c23 + c24;
    c1 += c0 >> 22;
    c0 &= $intern_51;
    c2 += c1 >> 22;
    c1 &= $intern_51;
    c2 &= $intern_52;
    return create0(c0, c1, c2);
}
function neg(a) {
    var neg0, neg1, neg2;
    neg0 = ~a.l + 1 & $intern_51;
    neg1 = ~a.m + (neg0 == 0 ? 1 : 0) & $intern_51;
    neg2 = ~a.h + (neg0 == 0 && neg1 == 0 ? 1 : 0) & $intern_52;
    return create0(neg0, neg1, neg2);
}
function not(a) {
    return create0(~a.l & $intern_51, ~a.m & $intern_51, ~a.h & $intern_52);
}
function or(a, b) {
    return create0(a.l | b.l, a.m | b.m, a.h | b.h);
}
function shl(a, n) {
    var res0, res1, res2;
    n &= 63;
    if (n < 22) {
        res0 = a.l << n;
        res1 = a.m << n | a.l >> 22 - n;
        res2 = a.h << n | a.m >> 22 - n;
    } else if (n < 44) {
        res0 = 0;
        res1 = a.l << n - 22;
        res2 = a.m << n - 22 | a.l >> 44 - n;
    } else {
        res0 = 0;
        res1 = 0;
        res2 = a.l << n - 44;
    }
    return create0(res0 & $intern_51, res1 & $intern_51, res2 & $intern_52);
}
function shr(a, n) {
    var a2, negative, res0, res1, res2;
    n &= 63;
    a2 = a.h;
    negative = (a2 & $intern_53) != 0;
    negative && (a2 |= -1048576);
    if (n < 22) {
        res2 = a2 >> n;
        res1 = a.m >> n | a2 << 22 - n;
        res0 = a.l >> n | a.m << 22 - n;
    } else if (n < 44) {
        res2 = negative ? $intern_52 : 0;
        res1 = a2 >> n - 22;
        res0 = a.m >> n - 22 | a2 << 44 - n;
    } else {
        res2 = negative ? $intern_52 : 0;
        res1 = negative ? $intern_51 : 0;
        res0 = a2 >> n - 44;
    }
    return create0(res0 & $intern_51, res1 & $intern_51, res2 & $intern_52);
}
function shru(a, n) {
    var a2, res0, res1, res2;
    n &= 63;
    a2 = a.h & $intern_52;
    if (n < 22) {
        res2 = a2 >>> n;
        res1 = a.m >> n | a2 << 22 - n;
        res0 = a.l >> n | a.m << 22 - n;
    } else if (n < 44) {
        res2 = 0;
        res1 = a2 >>> n - 22;
        res0 = a.m >> n - 22 | a.h << 44 - n;
    } else {
        res2 = 0;
        res1 = 0;
        res0 = a2 >>> n - 44;
    }
    return create0(res0 & $intern_51, res1 & $intern_51, res2 & $intern_52);
}
function sub_1(a, b) {
    var sum0, sum1, sum2;
    sum0 = a.l - b.l;
    sum1 = a.m - b.m + (sum0 >> 22);
    sum2 = a.h - b.h + (sum1 >> 22);
    return create0(sum0 & $intern_51, sum1 & $intern_51, sum2 & $intern_52);
}
function toDouble(a) {
    if (compare_1(a, ($clinit_BigLongLib$Const(), ZERO)) < 0) return -toDoubleHelper(neg(a));
    return a.l + a.m * $intern_54 + a.h * $intern_55;
}
function toInt(a) {
    return a.l | a.m << 22;
}
function toString_38(a) {
    var digits, rem, res, tenPowerLong, zeroesNeeded;
    if (a.l == 0 && a.m == 0 && a.h == 0) return '0';
    if (a.h == $intern_53 && a.m == 0 && a.l == 0) return '-9223372036854775808';
    if (a.h >> 19 != 0) return '-' + toString_38(neg(a));
    rem = a;
    res = '';
    while(!(rem.l == 0 && rem.m == 0 && rem.h == 0)){
        tenPowerLong = create_0($intern_56);
        rem = divMod(rem, tenPowerLong, true);
        digits = '' + toInt(remainder);
        if (!(rem.l == 0 && rem.m == 0 && rem.h == 0)) {
            zeroesNeeded = 9 - digits.length;
            for(; zeroesNeeded > 0; zeroesNeeded--)digits = '0' + digits;
        }
        res = digits + res;
    }
    return res;
}
function xor(a, b) {
    return create0(a.l ^ b.l, a.m ^ b.m, a.h ^ b.h);
}
function $clinit_BigLongLib$Const() {
    $clinit_BigLongLib$Const = emptyMethod;
    MAX_VALUE = create0($intern_51, $intern_51, 524287);
    MIN_VALUE = create0(0, 0, $intern_53);
    ONE = create_0(1);
    create_0(2);
    ZERO = create_0(0);
}
var MAX_VALUE, MIN_VALUE, ONE, ZERO;
function toJava(e) {
    var javaException;
    if (instanceOf(e, 80)) return e;
    javaException = e && e.__java$exception;
    if (!javaException) {
        javaException = new JavaScriptException(e);
        captureStackTrace(javaException);
    }
    return javaException;
}
function toJs(t) {
    return t.backingJsObject;
}
function add_20(a, b) {
    var result;
    if (isSmallLong0(a) && isSmallLong0(b)) {
        result = a + b;
        if ($intern_57 < result && result < $intern_55) return result;
    }
    return createLongEmul(add_19(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b));
}
function and_0(a, b) {
    return createLongEmul(and(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b));
}
function compare_2(a, b) {
    var result;
    if (isSmallLong0(a) && isSmallLong0(b)) {
        result = a - b;
        if (!isNaN(result)) return result;
    }
    return compare_1(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b);
}
function createLongEmul(big_0) {
    var a2;
    a2 = big_0.h;
    if (a2 == 0) return big_0.l + big_0.m * $intern_54;
    if (a2 == $intern_52) return big_0.l + big_0.m * $intern_54 - $intern_55;
    return big_0;
}
function div(a, b) {
    var result;
    if (isSmallLong0(a) && isSmallLong0(b)) {
        result = a / b;
        if ($intern_57 < result && result < $intern_55) return result < 0 ? $wnd.Math.ceil(result) : $wnd.Math.floor(result);
    }
    return createLongEmul(divMod(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b, false));
}
function eq(a, b) {
    return compare_2(a, b) == 0;
}
function fromDouble_0(value_0) {
    if ($intern_57 < value_0 && value_0 < $intern_55) return value_0 < 0 ? $wnd.Math.ceil(value_0) : $wnd.Math.floor(value_0);
    return createLongEmul(fromDouble(value_0));
}
function gt(a, b) {
    return compare_2(a, b) > 0;
}
function gte_0(a, b) {
    return compare_2(a, b) >= 0;
}
function isSmallLong0(value_0) {
    return typeof value_0 === 'number';
}
function lt(a, b) {
    return compare_2(a, b) < 0;
}
function mod(a, b) {
    var result;
    if (isSmallLong0(a) && isSmallLong0(b)) {
        result = a % b;
        if ($intern_57 < result && result < $intern_55) return result;
    }
    return createLongEmul((divMod(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b, true), remainder));
}
function mul_0(a, b) {
    var result;
    if (isSmallLong0(a) && isSmallLong0(b)) {
        result = a * b;
        if ($intern_57 < result && result < $intern_55) return result;
    }
    return createLongEmul(mul(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b));
}
function neg_0(a) {
    var result;
    if (isSmallLong0(a)) {
        result = 0 - a;
        if (!isNaN(result)) return result;
    }
    return createLongEmul(neg(a));
}
function neq(a, b) {
    return compare_2(a, b) != 0;
}
function or_0(a, b) {
    return createLongEmul(or(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b));
}
function shl_0(a, n) {
    return createLongEmul(shl(isSmallLong0(a) ? toBigLong(a) : a, n));
}
function shr_0(a, n) {
    return createLongEmul(shr(isSmallLong0(a) ? toBigLong(a) : a, n));
}
function shru_0(a, n) {
    return createLongEmul(shru(isSmallLong0(a) ? toBigLong(a) : a, n));
}
function sub_2(a, b) {
    var result;
    if (isSmallLong0(a) && isSmallLong0(b)) {
        result = a - b;
        if ($intern_57 < result && result < $intern_55) return result;
    }
    return createLongEmul(sub_1(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b));
}
function toBigLong(longValue) {
    var a0, a1, a3, value_0;
    value_0 = longValue;
    a3 = 0;
    if (value_0 < 0) {
        value_0 += $intern_55;
        a3 = $intern_52;
    }
    a1 = round_int(value_0 / $intern_54);
    a0 = round_int(value_0 - a1 * $intern_54);
    return create0(a0, a1, a3);
}
function toDouble_0(a) {
    var d;
    if (isSmallLong0(a)) {
        d = a;
        return d == -0 ? 0 : d;
    }
    return toDouble(a);
}
function toInt_0(a) {
    if (isSmallLong0(a)) return a | 0;
    return toInt(a);
}
function toString_39(a) {
    if (isSmallLong0(a)) return '' + a;
    return toString_38(a);
}
function xor_0(a, b) {
    return createLongEmul(xor(isSmallLong0(a) ? toBigLong(a) : a, isSmallLong0(b) ? toBigLong(b) : b));
}
function init() {
    $clinit_ElkJs();
    exportLayout();
}
function $split(this$static, input_0) {
    return input_0.split(this$static);
}
defineClass(2006, 1, {
    518: 1
});
var Ljava_io_OutputStream_2_classLit = createForClass('java.io', 'OutputStream', 2006);
defineClass(2007, 2006, {
    518: 1
});
var Ljava_io_FilterOutputStream_2_classLit = createForClass('java.io', 'FilterOutputStream', 2007);
function $println(x_0) {
    !x_0 || $toString_4(x_0, x_0.getMessage());
    String.fromCharCode(10);
}
function PrintStream() {}
defineClass(854, 2007, {
    518: 1
}, PrintStream);
var Ljava_io_PrintStream_2_classLit = createForClass('java.io', 'PrintStream', 854);
function $replace0(this$static, start_0, end, toInsert) {
    var length_0;
    length_0 = this$static.string.length;
    end > length_0 ? end = length_0 : checkCriticalStringElementIndex(start_0, end + 1);
    this$static.string = $substring_1(this$static.string, 0, start_0) + ('' + toInsert) + $substring_0(this$static.string, end);
}
function $substring(this$static, end) {
    return $substring_1(this$static.string, 0, end);
}
function AbstractStringBuilder(string) {
    this.string = string;
}
defineClass(415, 1, {
    470: 1
});
_.toString_0 = function toString_41() {
    return this.string;
};
var Ljava_lang_AbstractStringBuilder_2_classLit = createForClass('java.lang', 'AbstractStringBuilder', 415);
function ArithmeticException(explanation) {
    RuntimeException_0.call(this, explanation);
}
defineClass(523, 63, $intern_43, ArithmeticException);
var Ljava_lang_ArithmeticException_2_classLit = createForClass('java.lang', 'ArithmeticException', 523);
function IndexOutOfBoundsException() {
    RuntimeException.call(this);
}
function IndexOutOfBoundsException_0(message) {
    RuntimeException_0.call(this, message);
}
defineClass(97, 63, $intern_58, IndexOutOfBoundsException, IndexOutOfBoundsException_0);
var Ljava_lang_IndexOutOfBoundsException_2_classLit = createForClass('java.lang', 'IndexOutOfBoundsException', 97);
function ArrayIndexOutOfBoundsException() {
    IndexOutOfBoundsException.call(this);
}
function ArrayIndexOutOfBoundsException_0(msg) {
    IndexOutOfBoundsException_0.call(this, msg);
}
defineClass(638, 97, $intern_58, ArrayIndexOutOfBoundsException, ArrayIndexOutOfBoundsException_0);
var Ljava_lang_ArrayIndexOutOfBoundsException_2_classLit = createForClass('java.lang', 'ArrayIndexOutOfBoundsException', 638);
function ArrayStoreException() {
    RuntimeException.call(this);
}
function ArrayStoreException_0(message) {
    RuntimeException_0.call(this, message);
}
defineClass(522, 63, $intern_43, ArrayStoreException, ArrayStoreException_0);
var Ljava_lang_ArrayStoreException_2_classLit = createForClass('java.lang', 'ArrayStoreException', 522);
function Error_0(message) {
    Throwable_0.call(this, message);
}
function Error_1(message, cause) {
    Throwable_1.call(this, message, cause);
}
defineClass(294, 80, $intern_59, Error_0);
var Ljava_lang_Error_2_classLit = createForClass('java.lang', 'Error', 294);
function AssertionError() {
    Throwable.call(this);
}
function AssertionError_0(message) {
    Error_1.call(this, message == null ? 'null' : toString_40(message), instanceOf(message, 80) ? castTo(message, 80) : null);
}
defineClass(200, 294, $intern_59, AssertionError, AssertionError_0);
var Ljava_lang_AssertionError_2_classLit = createForClass('java.lang', 'AssertionError', 200);
function $clinit_Boolean() {
    $clinit_Boolean = emptyMethod;
    FALSE_0 = false;
    TRUE_0 = true;
}
function $booleanValue(this$static) {
    return checkCriticalNotNull(this$static), this$static;
}
function $compareTo_1(this$static, b) {
    return compare_3((checkCriticalNotNull(this$static), this$static), (checkCriticalNotNull(b), b));
}
function $hashCode_0(this$static) {
    return (checkCriticalNotNull(this$static), this$static) ? 1231 : 1237;
}
function compare_3(x_0, y_0) {
    $clinit_Boolean();
    return x_0 == y_0 ? 0 : x_0 ? 1 : -1;
}
function compareTo_Ljava_lang_Object__I__devirtual$(this$static, other) {
    $clinit_Boolean();
    return instanceOfString(this$static) ? $compareTo_9(this$static, castToString(other)) : instanceOfDouble(this$static) ? $compareTo_4(this$static, castToDouble(other)) : instanceOfBoolean(this$static) ? $compareTo_1(this$static, castToBoolean(other)) : this$static.compareTo_0(other);
}
booleanCastMap = {
    3: 1,
    471: 1,
    34: 1
};
var FALSE_0, TRUE_0;
var Ljava_lang_Boolean_2_classLit = createForClass('java.lang', 'Boolean', 471);
function __parseAndValidateDouble(s) {
    floatRegex == null && (floatRegex = new RegExp('^\\s*[+-]?(NaN|Infinity|((\\d+\\.?\\d*)|(\\.\\d+))([eE][+-]?\\d+)?[dDfF]?)\\s*$'));
    if (!floatRegex.test(s)) throw toJs(new NumberFormatException('For input string: "' + s + '"'));
    return parseFloat(s);
}
function __parseAndValidateInt(s, lowerBound, upperBound) {
    var i, isTooLow, length_0, startIndex, toReturn;
    if (s == null) throw toJs(new NumberFormatException('null'));
    length_0 = s.length;
    startIndex = length_0 > 0 && (checkCriticalStringElementIndex(0, s.length), s.charCodeAt(0) == 45 || (checkCriticalStringElementIndex(0, s.length), s.charCodeAt(0) == 43)) ? 1 : 0;
    for(i = startIndex; i < length_0; i++){
        if (digit_0((checkCriticalStringElementIndex(i, s.length), s.charCodeAt(i))) == -1) throw toJs(new NumberFormatException('For input string: "' + s + '"'));
    }
    toReturn = parseInt(s, 10);
    isTooLow = toReturn < lowerBound;
    if (isNaN(toReturn)) throw toJs(new NumberFormatException('For input string: "' + s + '"'));
    else if (isTooLow || toReturn > upperBound) throw toJs(new NumberFormatException('For input string: "' + s + '"'));
    return toReturn;
}
function __parseAndValidateLong(s) {
    var c, firstTime, head, i, length_0, maxDigits, minValue, negative, orig, radixPower, toReturn;
    if (s == null) throw toJs(new NumberFormatException('null'));
    orig = s;
    length_0 = s.length;
    negative = false;
    if (length_0 > 0) {
        c = (checkCriticalStringElementIndex(0, s.length), s.charCodeAt(0));
        if (c == 45 || c == 43) {
            s = (checkCriticalStringElementIndex(1, s.length + 1), s.substr(1));
            --length_0;
            negative = c == 45;
        }
    }
    if (length_0 == 0) throw toJs(new NumberFormatException('For input string: "' + orig + '"'));
    while(s.length > 0 && (checkCriticalStringElementIndex(0, s.length), s.charCodeAt(0) == 48)){
        s = (checkCriticalStringElementIndex(1, s.length + 1), s.substr(1));
        --length_0;
    }
    if (length_0 > ($clinit_Number$__ParseLong(), maxLengthForRadix)[10]) throw toJs(new NumberFormatException('For input string: "' + orig + '"'));
    for(i = 0; i < length_0; i++){
        if (digit_0((checkCriticalStringElementIndex(i, s.length), s.charCodeAt(i))) == -1) throw toJs(new NumberFormatException('For input string: "' + orig + '"'));
    }
    toReturn = 0;
    maxDigits = maxDigitsForRadix[10];
    radixPower = maxDigitsRadixPower[10];
    minValue = neg_0(maxValueForRadix[10]);
    firstTime = true;
    head = length_0 % maxDigits;
    if (head > 0) {
        toReturn = -parseInt((checkCriticalStringBounds(0, head, s.length), s.substr(0, head)), 10);
        s = (checkCriticalStringElementIndex(head, s.length + 1), s.substr(head));
        length_0 -= head;
        firstTime = false;
    }
    while(length_0 >= maxDigits){
        head = parseInt((checkCriticalStringBounds(0, maxDigits, s.length), s.substr(0, maxDigits)), 10);
        s = (checkCriticalStringElementIndex(maxDigits, s.length + 1), s.substr(maxDigits));
        length_0 -= maxDigits;
        if (firstTime) firstTime = false;
        else {
            if (compare_2(toReturn, minValue) < 0) throw toJs(new NumberFormatException('For input string: "' + orig + '"'));
            toReturn = mul_0(toReturn, radixPower);
        }
        toReturn = sub_2(toReturn, head);
    }
    if (compare_2(toReturn, 0) > 0) throw toJs(new NumberFormatException('For input string: "' + orig + '"'));
    if (!negative) {
        toReturn = neg_0(toReturn);
        if (compare_2(toReturn, 0) < 0) throw toJs(new NumberFormatException('For input string: "' + orig + '"'));
    }
    return toReturn;
}
function doubleValue__D__devirtual$(this$static) {
    return instanceOfDouble(this$static) ? (checkCriticalNotNull(this$static), this$static) : this$static.doubleValue();
}
defineClass(241, 1, {
    3: 1,
    241: 1
});
var floatRegex;
var Ljava_lang_Number_2_classLit = createForClass('java.lang', 'Number', 241);
function $compareTo_2(this$static, b) {
    return this$static.value_0 - b.value_0;
}
function Byte(value_0) {
    this.value_0 = value_0;
}
defineClass(219, 241, {
    3: 1,
    219: 1,
    34: 1,
    241: 1
}, Byte);
_.compareTo_0 = function compareTo_5(b) {
    return $compareTo_2(this, castTo(b, 219));
};
_.doubleValue = function doubleValue_0() {
    return this.value_0;
};
_.equals_0 = function equals_35(o) {
    return instanceOf(o, 219) && castTo(o, 219).value_0 == this.value_0;
};
_.hashCode_1 = function hashCode_35() {
    return this.value_0;
};
_.toString_0 = function toString_42() {
    return '' + this.value_0;
};
_.value_0 = 0;
var Ljava_lang_Byte_2_classLit = createForClass('java.lang', 'Byte', 219);
function $clinit_Byte$BoxedValues() {
    $clinit_Byte$BoxedValues = emptyMethod;
    boxedValues = initUnidimensionalArray(Ljava_lang_Byte_2_classLit, $intern_16, 219, 256, 0, 1);
}
function get_32(b) {
    $clinit_Byte$BoxedValues();
    var rebase, result;
    rebase = b + 128;
    result = boxedValues[rebase];
    !result && (result = boxedValues[rebase] = new Byte(b));
    return result;
}
var boxedValues;
function $compareTo_3(this$static, c) {
    return this$static.value_0 - c.value_0;
}
function Character(value_0) {
    this.value_0 = value_0;
}
function digit_0(c) {
    if (c >= 48 && c < 48 + $wnd.Math.min(10, 10)) return c - 48;
    if (c >= 97 && c < 97) return c - 97 + 10;
    if (c >= 65 && c < 65) return c - 65 + 10;
    return -1;
}
function valueOf_2(c) {
    var result;
    if (c < 128) return $clinit_Character$BoxedValues(), result = boxedValues_0[c], !result && (result = boxedValues_0[c] = new Character(c)), result;
    return new Character(c);
}
defineClass(179, 1, {
    3: 1,
    179: 1,
    34: 1
}, Character);
_.compareTo_0 = function compareTo_6(c) {
    return $compareTo_3(this, castTo(c, 179));
};
_.equals_0 = function equals_36(o) {
    return instanceOf(o, 179) && castTo(o, 179).value_0 == this.value_0;
};
_.hashCode_1 = function hashCode_36() {
    return this.value_0;
};
_.toString_0 = function toString_43() {
    return String.fromCharCode(this.value_0);
};
_.value_0 = 0;
var digitRegex;
var Ljava_lang_Character_2_classLit = createForClass('java.lang', 'Character', 179);
function $clinit_Character$BoxedValues() {
    $clinit_Character$BoxedValues = emptyMethod;
    boxedValues_0 = initUnidimensionalArray(Ljava_lang_Character_2_classLit, $intern_16, 179, 128, 0, 1);
}
var boxedValues_0;
function ClassCastException() {
    RuntimeException.call(this);
}
function ClassCastException_0(message) {
    RuntimeException_0.call(this, message);
}
defineClass(211, 63, {
    3: 1,
    211: 1,
    103: 1,
    63: 1,
    80: 1
}, ClassCastException, ClassCastException_0);
var Ljava_lang_ClassCastException_2_classLit = createForClass('java.lang', 'ClassCastException', 211);
function $compareTo_4(this$static, b) {
    return compare_4((checkCriticalNotNull(this$static), this$static), (checkCriticalNotNull(b), b));
}
function $doubleValue(this$static) {
    return checkCriticalNotNull(this$static), this$static;
}
function $equals_4(this$static, o) {
    return checkCriticalNotNull(this$static), maskUndefined(this$static) === maskUndefined(o);
}
function $floatValue(this$static) {
    return checkCriticalNotNull(this$static), this$static;
}
function $hashCode_1(this$static) {
    return round_int((checkCriticalNotNull(this$static), this$static));
}
function $intValue(this$static) {
    return round_int((checkCriticalNotNull(this$static), this$static));
}
function $toString_6(this$static) {
    return '' + (checkCriticalNotNull(this$static), this$static);
}
function compare_4(x_0, y_0) {
    if (x_0 < y_0) return -1;
    if (x_0 > y_0) return 1;
    if (x_0 == y_0) return x_0 == 0 ? compare_4(1 / x_0, 1 / y_0) : 0;
    return isNaN(x_0) ? isNaN(y_0) ? 0 : 1 : -1;
}
function isInfinite(x_0) {
    return !isNaN(x_0) && !isFinite(x_0);
}
doubleCastMap = {
    3: 1,
    34: 1,
    341: 1,
    241: 1
};
var Ljava_lang_Double_2_classLit = createForClass('java.lang', 'Double', 341);
function $compareTo_5(this$static, b) {
    return compare_4(this$static.value_0, b.value_0);
}
function Float(value_0) {
    this.value_0 = value_0;
}
function Float_0(s) {
    this.value_0 = parseFloat_0(s);
}
function parseFloat_0(s) {
    var doubleValue;
    doubleValue = __parseAndValidateDouble(s);
    if (doubleValue > 3.4028234663852886E38) return $intern_60;
    else if (doubleValue < -340282346638528860000000000000000000000) return $intern_61;
    return doubleValue;
}
defineClass(160, 241, {
    3: 1,
    34: 1,
    160: 1,
    241: 1
}, Float, Float_0);
_.compareTo_0 = function compareTo_7(b) {
    return $compareTo_5(this, castTo(b, 160));
};
_.doubleValue = function doubleValue_1() {
    return this.value_0;
};
_.equals_0 = function equals_37(o) {
    return instanceOf(o, 160) && $equals_4(this.value_0, castTo(o, 160).value_0);
};
_.hashCode_1 = function hashCode_37() {
    return round_int(this.value_0);
};
_.toString_0 = function toString_45() {
    return '' + this.value_0;
};
_.value_0 = 0;
var Ljava_lang_Float_2_classLit = createForClass('java.lang', 'Float', 160);
function IllegalArgumentException() {
    RuntimeException.call(this);
}
function IllegalArgumentException_0(message) {
    RuntimeException_0.call(this, message);
}
function IllegalArgumentException_1(cause) {
    Throwable_1.call(this, 'The given string does not match the expected format for individual spacings.', cause);
}
defineClass(32, 63, {
    3: 1,
    103: 1,
    32: 1,
    63: 1,
    80: 1
}, IllegalArgumentException, IllegalArgumentException_0, IllegalArgumentException_1);
var Ljava_lang_IllegalArgumentException_2_classLit = createForClass('java.lang', 'IllegalArgumentException', 32);
function IllegalStateException() {
    RuntimeException.call(this);
}
function IllegalStateException_0(s) {
    RuntimeException_0.call(this, s);
}
defineClass(73, 63, $intern_43, IllegalStateException, IllegalStateException_0);
var Ljava_lang_IllegalStateException_2_classLit = createForClass('java.lang', 'IllegalStateException', 73);
function $compareTo_6(this$static, b) {
    return compare_5(this$static.value_0, b.value_0);
}
function Integer(value_0) {
    this.value_0 = value_0;
}
function bitCount(x_0) {
    x_0 -= x_0 >> 1 & 1431655765;
    x_0 = (x_0 >> 2 & 858993459) + (x_0 & 858993459);
    x_0 = (x_0 >> 4) + x_0 & 252645135;
    x_0 += x_0 >> 8;
    x_0 += x_0 >> 16;
    return x_0 & 63;
}
function compare_5(x_0, y_0) {
    return x_0 < y_0 ? -1 : x_0 > y_0 ? 1 : 0;
}
function highestOneBit(i) {
    var rtn;
    if (i < 0) return $intern_42;
    else if (i == 0) return 0;
    else {
        for(rtn = $intern_35; (rtn & i) == 0; rtn >>= 1);
        return rtn;
    }
}
function numberOfLeadingZeros_0(i) {
    var m, n, y_0;
    if (i < 0) return 0;
    else if (i == 0) return 32;
    else {
        y_0 = -(i >> 16);
        m = y_0 >> 16 & 16;
        n = 16 - m;
        i = i >> m;
        y_0 = i - 256;
        m = y_0 >> 16 & 8;
        n += m;
        i <<= m;
        y_0 = i - $intern_62;
        m = y_0 >> 16 & 4;
        n += m;
        i <<= m;
        y_0 = i - $intern_17;
        m = y_0 >> 16 & 2;
        n += m;
        i <<= m;
        y_0 = i >> 14;
        m = y_0 & ~(y_0 >> 1);
        return n + 2 - m;
    }
}
function numberOfTrailingZeros(i) {
    var r, rtn;
    if (i == 0) return 32;
    else {
        rtn = 0;
        for(r = 1; (r & i) == 0; r <<= 1)++rtn;
        return rtn;
    }
}
function reverse_1(i) {
    var nibbles;
    nibbles = ($clinit_Integer$ReverseNibbles(), reverseNibbles);
    return nibbles[i >>> 28] | nibbles[i >> 24 & 15] << 4 | nibbles[i >> 20 & 15] << 8 | nibbles[i >> 16 & 15] << 12 | nibbles[i >> 12 & 15] << 16 | nibbles[i >> 8 & 15] << 20 | nibbles[i >> 4 & 15] << 24 | nibbles[i & 15] << 28;
}
function rotateLeft(i, distance) {
    while(distance-- > 0)i = i << 1 | (i < 0 ? 1 : 0);
    return i;
}
function valueOf_3(i) {
    var rebase, result;
    if (i > -129 && i < 128) return $clinit_Integer$BoxedValues(), rebase = i + 128, result = boxedValues_1[rebase], !result && (result = boxedValues_1[rebase] = new Integer(i)), result;
    return new Integer(i);
}
defineClass(17, 241, {
    3: 1,
    34: 1,
    17: 1,
    241: 1
}, Integer);
_.compareTo_0 = function compareTo_8(b) {
    return $compareTo_6(this, castTo(b, 17));
};
_.doubleValue = function doubleValue_2() {
    return this.value_0;
};
_.equals_0 = function equals_38(o) {
    return instanceOf(o, 17) && castTo(o, 17).value_0 == this.value_0;
};
_.hashCode_1 = function hashCode_38() {
    return this.value_0;
};
_.toString_0 = function toString_46() {
    return '' + this.value_0;
};
_.value_0 = 0;
var Ljava_lang_Integer_2_classLit = createForClass('java.lang', 'Integer', 17);
function $clinit_Integer$BoxedValues() {
    $clinit_Integer$BoxedValues = emptyMethod;
    boxedValues_1 = initUnidimensionalArray(Ljava_lang_Integer_2_classLit, $intern_16, 17, 256, 0, 1);
}
var boxedValues_1;
function $clinit_Integer$ReverseNibbles() {
    $clinit_Integer$ReverseNibbles = emptyMethod;
    reverseNibbles = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        0,
        8,
        4,
        12,
        2,
        10,
        6,
        14,
        1,
        9,
        5,
        13,
        3,
        11,
        7,
        15
    ]);
}
var reverseNibbles;
function $compareTo_7(this$static, b) {
    return compare_6(this$static.value_0, b.value_0);
}
function Long(value_0) {
    this.value_0 = value_0;
}
function compare_6(x_0, y_0) {
    return compare_2(x_0, y_0) < 0 ? -1 : compare_2(x_0, y_0) > 0 ? 1 : 0;
}
function hashCode_40(l) {
    return toInt_0(shru_0(l, 32)) ^ toInt_0(l);
}
function valueOf_4(l) {
    var rebase, result;
    if (compare_2(l, -129) > 0 && compare_2(l, 128) < 0) return $clinit_Long$BoxedValues(), rebase = toInt_0(l) + 128, result = boxedValues_2[rebase], !result && (result = boxedValues_2[rebase] = new Long(l)), result;
    return new Long(l);
}
defineClass(190, 241, {
    3: 1,
    34: 1,
    190: 1,
    241: 1
}, Long);
_.compareTo_0 = function compareTo_9(b) {
    return $compareTo_7(this, castTo(b, 190));
};
_.doubleValue = function doubleValue_3() {
    return toDouble_0(this.value_0);
};
_.equals_0 = function equals_39(o) {
    return instanceOf(o, 190) && eq(castTo(o, 190).value_0, this.value_0);
};
_.hashCode_1 = function hashCode_39() {
    return hashCode_40(this.value_0);
};
_.toString_0 = function toString_47() {
    return '' + toString_39(this.value_0);
};
_.value_0 = 0;
var Ljava_lang_Long_2_classLit = createForClass('java.lang', 'Long', 190);
function $clinit_Long$BoxedValues() {
    $clinit_Long$BoxedValues = emptyMethod;
    boxedValues_2 = initUnidimensionalArray(Ljava_lang_Long_2_classLit, $intern_16, 190, 256, 0, 1);
}
var boxedValues_2;
function max_1(x_0, y_0) {
    return compare_2(x_0, y_0) > 0 ? x_0 : y_0;
}
function signum(d) {
    return d == 0 || isNaN(d) ? d : d < 0 ? -1 : 1;
}
defineClass(2086, 1, {});
function NegativeArraySizeException(message) {
    RuntimeException_0.call(this, message);
}
defineClass(1850, 63, $intern_43, NegativeArraySizeException);
var Ljava_lang_NegativeArraySizeException_2_classLit = createForClass('java.lang', 'NegativeArraySizeException', 1850);
function NullPointerException() {
    RuntimeException.call(this);
}
function NullPointerException_0(message) {
    RuntimeException_0.call(this, message);
}
defineClass(169, 591, {
    3: 1,
    103: 1,
    169: 1,
    63: 1,
    80: 1
}, NullPointerException, NullPointerException_0);
_.createError = function createError_0(msg) {
    return new TypeError(msg);
};
var Ljava_lang_NullPointerException_2_classLit = createForClass('java.lang', 'NullPointerException', 169);
function $clinit_Number$__ParseLong() {
    $clinit_Number$__ParseLong = emptyMethod;
    var i;
    maxDigitsForRadix = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        -1,
        -1,
        30,
        19,
        15,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5
    ]);
    maxDigitsRadixPower = initUnidimensionalArray(I_classLit, $intern_48, 30, 37, 15, 1);
    maxLengthForRadix = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        -1,
        -1,
        63,
        40,
        32,
        28,
        25,
        23,
        21,
        20,
        19,
        19,
        18,
        18,
        17,
        17,
        16,
        16,
        16,
        15,
        15,
        15,
        15,
        14,
        14,
        14,
        14,
        14,
        14,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13
    ]);
    maxValueForRadix = initUnidimensionalArray(J_classLit, $intern_63, 30, 37, 14, 1);
    for(i = 2; i <= 36; i++){
        maxDigitsRadixPower[i] = round_int($wnd.Math.pow(i, maxDigitsForRadix[i]));
        maxValueForRadix[i] = div($intern_21, maxDigitsRadixPower[i]);
    }
}
var maxDigitsForRadix, maxDigitsRadixPower, maxLengthForRadix, maxValueForRadix;
function NumberFormatException(message) {
    IllegalArgumentException_0.call(this, message);
}
defineClass(130, 32, {
    3: 1,
    103: 1,
    32: 1,
    130: 1,
    63: 1,
    80: 1
}, NumberFormatException);
var Ljava_lang_NumberFormatException_2_classLit = createForClass('java.lang', 'NumberFormatException', 130);
function $compareTo_8(this$static, b) {
    return this$static.value_0 - b.value_0;
}
function Short(value_0) {
    this.value_0 = value_0;
}
function valueOf_5(s) {
    var rebase, result;
    if (s > -129 && s < 128) return $clinit_Short$BoxedValues(), rebase = s + 128, result = boxedValues_3[rebase], !result && (result = boxedValues_3[rebase] = new Short(s)), result;
    return new Short(s);
}
defineClass(191, 241, {
    3: 1,
    34: 1,
    241: 1,
    191: 1
}, Short);
_.compareTo_0 = function compareTo_10(b) {
    return $compareTo_8(this, castTo(b, 191));
};
_.doubleValue = function doubleValue_4() {
    return this.value_0;
};
_.equals_0 = function equals_40(o) {
    return instanceOf(o, 191) && castTo(o, 191).value_0 == this.value_0;
};
_.hashCode_1 = function hashCode_41() {
    return this.value_0;
};
_.toString_0 = function toString_48() {
    return '' + this.value_0;
};
_.value_0 = 0;
var Ljava_lang_Short_2_classLit = createForClass('java.lang', 'Short', 191);
function $clinit_Short$BoxedValues() {
    $clinit_Short$BoxedValues = emptyMethod;
    boxedValues_3 = initUnidimensionalArray(Ljava_lang_Short_2_classLit, $intern_16, 191, 256, 0, 1);
}
var boxedValues_3;
function StackTraceElement(methodName, fileName, lineNumber) {
    this.className = 'Unknown';
    this.methodName = methodName;
    this.fileName = fileName;
    this.lineNumber = lineNumber;
}
defineClass(320, 1, {
    3: 1,
    320: 1
}, StackTraceElement);
_.equals_0 = function equals_41(other) {
    var st;
    if (instanceOf(other, 320)) {
        st = castTo(other, 320);
        return this.lineNumber == st.lineNumber && this.methodName == st.methodName && this.className == st.className && this.fileName == st.fileName;
    }
    return false;
};
_.hashCode_1 = function hashCode_42() {
    return hashCode_47(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        valueOf_3(this.lineNumber),
        this.className,
        this.methodName,
        this.fileName
    ]));
};
_.toString_0 = function toString_49() {
    return this.className + '.' + this.methodName + '(' + (this.fileName != null ? this.fileName : 'Unknown Source') + (this.lineNumber >= 0 ? ':' + this.lineNumber : '') + ')';
};
_.lineNumber = 0;
var Ljava_lang_StackTraceElement_2_classLit = createForClass('java.lang', 'StackTraceElement', 320);
function $charAt(this$static, index_0) {
    checkCriticalStringElementIndex(index_0, this$static.length);
    return this$static.charCodeAt(index_0);
}
function $compareTo_9(this$static, other) {
    var a, b;
    a = (checkCriticalNotNull(this$static), this$static);
    b = (checkCriticalNotNull(other), other);
    return a == b ? 0 : a < b ? -1 : 1;
}
function $endsWith(suffix) {
    var suffixlength;
    suffixlength = suffix.length;
    return $equals_5('org.eclipse.elk.layered'.substr(23 - suffixlength, suffixlength), suffix);
}
function $equals_5(this$static, other) {
    return checkCriticalNotNull(this$static), maskUndefined(this$static) === maskUndefined(other);
}
function $equalsIgnoreCase(this$static, other) {
    checkCriticalNotNull(this$static);
    if (other == null) return false;
    if ($equals_5(this$static, other)) return true;
    return this$static.length == other.length && $equals_5(this$static.toLowerCase(), other.toLowerCase());
}
function $getChars0(this$static, srcBegin, srcEnd, dst, dstBegin) {
    while(srcBegin < srcEnd)dst[dstBegin++] = $charAt(this$static, srcBegin++);
}
function $hashCode_2(this$static) {
    var h, i;
    h = 0;
    for(i = 0; i < this$static.length; i++)h = (h << 5) - h + (checkCriticalStringElementIndex(i, this$static.length), this$static.charCodeAt(i)) | 0;
    return h;
}
function $indexOf_0(this$static, codePoint, startIndex) {
    return $indexOf_2(this$static, fromCodePoint(codePoint), startIndex);
}
function $indexOf_1(this$static, str) {
    return this$static.indexOf(str);
}
function $indexOf_2(this$static, str, startIndex) {
    return this$static.indexOf(str, startIndex);
}
function $intern(this$static) {
    return checkCriticalNotNull(this$static), this$static;
}
function $lastIndexOf(this$static, str) {
    return this$static.lastIndexOf(str);
}
function $lastIndexOf_0(this$static, str, start_0) {
    return this$static.lastIndexOf(str, start_0);
}
function $split_0(this$static, regex) {
    var compiled, count, lastNonEmpty, lastTrail, matchIndex, matchObj, out, trail;
    compiled = new RegExp(regex, 'g');
    out = initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 0, 6, 1);
    count = 0;
    trail = this$static;
    lastTrail = null;
    while(true){
        matchObj = compiled.exec(trail);
        if (matchObj == null || trail == '') {
            out[count] = trail;
            break;
        } else {
            matchIndex = matchObj.index;
            out[count] = (checkCriticalStringBounds(0, matchIndex, trail.length), trail.substr(0, matchIndex));
            trail = $substring_1(trail, matchIndex + matchObj[0].length, trail.length);
            compiled.lastIndex = 0;
            if (lastTrail == trail) {
                out[count] = (checkCriticalStringBounds(0, 1, trail.length), trail.substr(0, 1));
                trail = (checkCriticalStringElementIndex(1, trail.length + 1), trail.substr(1));
            }
            lastTrail = trail;
            ++count;
        }
    }
    if (this$static.length > 0) {
        lastNonEmpty = out.length;
        while(lastNonEmpty > 0 && out[lastNonEmpty - 1] == '')--lastNonEmpty;
        lastNonEmpty < out.length && (out.length = lastNonEmpty);
    }
    return out;
}
function $startsWith(this$static, prefix) {
    return $equals_5(this$static.substr(0, prefix.length), prefix);
}
function $startsWith_0(this$static, prefix, toffset) {
    return toffset >= 0 && $equals_5(this$static.substr(toffset, prefix.length), prefix);
}
function $substring_0(this$static, beginIndex) {
    checkCriticalStringElementIndex(beginIndex, this$static.length + 1);
    return this$static.substr(beginIndex);
}
function $substring_1(this$static, beginIndex, endIndex) {
    checkCriticalStringBounds(beginIndex, endIndex, this$static.length);
    return this$static.substr(beginIndex, endIndex - beginIndex);
}
function $toCharArray(this$static) {
    var charArr, n;
    n = this$static.length;
    charArr = initUnidimensionalArray(C_classLit, $intern_44, 30, n, 15, 1);
    $getChars0(this$static, 0, n, charArr, 0);
    return charArr;
}
function $toLowerCase(this$static, locale) {
    return locale == ($clinit_Locale(), $clinit_Locale(), defaultLocale) ? this$static.toLocaleLowerCase() : this$static.toLowerCase();
}
function $toString_7(this$static) {
    return checkCriticalNotNull(this$static), this$static;
}
function $trim(this$static) {
    var end, length_0, start_0;
    length_0 = this$static.length;
    start_0 = 0;
    while(start_0 < length_0 && (checkCriticalStringElementIndex(start_0, this$static.length), this$static.charCodeAt(start_0) <= 32))++start_0;
    end = length_0;
    while(end > start_0 && (checkCriticalStringElementIndex(end - 1, this$static.length), this$static.charCodeAt(end - 1) <= 32))--end;
    return start_0 > 0 || end < length_0 ? (checkCriticalStringBounds(start_0, end, this$static.length), this$static.substr(start_0, end - start_0)) : this$static;
}
function fromCharCode(array) {
    return String.fromCharCode.apply(null, array);
}
function fromCodePoint(codePoint) {
    var hiSurrogate, loSurrogate;
    if (codePoint >= $intern_64) {
        hiSurrogate = $intern_65 + (codePoint - $intern_64 >> 10 & 1023) & $intern_46;
        loSurrogate = 56320 + (codePoint - $intern_64 & 1023) & $intern_46;
        return String.fromCharCode(hiSurrogate) + ('' + String.fromCharCode(loSurrogate));
    } else return String.fromCharCode(codePoint & $intern_46);
}
function valueOf_6(x_0) {
    return x_0 == null ? 'null' : toString_40(x_0);
}
function valueOf_7(x_0) {
    return valueOf_8(x_0, 0, x_0.length);
}
function valueOf_8(x_0, offset, count) {
    var batchEnd, batchStart, end, s;
    end = offset + count;
    checkCriticalStringBounds(offset, end, x_0.length);
    s = '';
    for(batchStart = offset; batchStart < end;){
        batchEnd = $wnd.Math.min(batchStart + 10000, end);
        s += fromCharCode(x_0.slice(batchStart, batchEnd));
        batchStart = batchEnd;
    }
    return s;
}
stringCastMap = {
    3: 1,
    470: 1,
    34: 1,
    2: 1
};
var Ljava_lang_String_2_classLit = createForClass('java.lang', 'String', 2);
function $append(this$static, x_0) {
    this$static.string += String.fromCharCode(x_0);
    return this$static;
}
function $append_0(this$static, x_0) {
    this$static.string += x_0;
    return this$static;
}
function $append_1(this$static, x_0) {
    this$static.string += x_0;
    return this$static;
}
function $append_2(this$static, x_0) {
    this$static.string += '' + x_0;
    return this$static;
}
function $append_3(this$static, x_0) {
    this$static.string += '' + x_0;
    return this$static;
}
function $append_4(this$static, x_0) {
    this$static.string += x_0;
    return this$static;
}
function $deleteCharAt(this$static, start_0) {
    $replace0(this$static, start_0, start_0 + 1, '');
    return this$static;
}
function StringBuffer() {
    AbstractStringBuilder.call(this, '');
}
function StringBuffer_0() {
    AbstractStringBuilder.call(this, '');
}
function StringBuffer_1(s) {
    AbstractStringBuilder.call(this, (checkCriticalNotNull(s), s));
}
defineClass(110, 415, {
    470: 1
}, StringBuffer, StringBuffer_0, StringBuffer_1);
var Ljava_lang_StringBuffer_2_classLit = createForClass('java.lang', 'StringBuffer', 110);
function $append_5(this$static, x_0) {
    this$static.string += String.fromCharCode(x_0);
    return this$static;
}
function $append_6(this$static, x_0) {
    this$static.string += x_0;
    return this$static;
}
function $append_7(this$static, x_0) {
    return this$static.string += '' + x_0, this$static;
}
function $append_8(this$static, x_0) {
    this$static.string += '' + x_0;
    return this$static;
}
function $append_9(this$static, x_0, start_0, end) {
    this$static.string += '' + $substring_1(x_0 == null ? 'null' : toString_40(x_0), start_0, end);
    return this$static;
}
function $append_10(this$static, x_0) {
    this$static.string += '' + x_0;
    return this$static;
}
function $append_11(this$static, x_0) {
    this$static.string += '' + x_0;
    return this$static;
}
function $append_12(this$static, x_0) {
    this$static.string += valueOf_8(x_0, 0, x_0.length);
    return this$static;
}
function $append_13(this$static, x_0, len) {
    this$static.string += valueOf_8(x_0, 0, len);
    return this$static;
}
function $insert_0(this$static, index_0, x_0) {
    $replace0(this$static, index_0, index_0, x_0);
    return this$static;
}
function StringBuilder() {
    AbstractStringBuilder.call(this, '');
}
function StringBuilder_0() {
    AbstractStringBuilder.call(this, '');
}
function StringBuilder_1(s) {
    AbstractStringBuilder.call(this, (checkCriticalNotNull(s), s));
}
defineClass(104, 415, {
    470: 1
}, StringBuilder, StringBuilder_0, StringBuilder_1);
var Ljava_lang_StringBuilder_2_classLit = createForClass('java.lang', 'StringBuilder', 104);
function StringIndexOutOfBoundsException(message) {
    IndexOutOfBoundsException_0.call(this, message);
}
defineClass(686, 97, $intern_58, StringIndexOutOfBoundsException);
var Ljava_lang_StringIndexOutOfBoundsException_2_classLit = createForClass('java.lang', 'StringIndexOutOfBoundsException', 686);
function $clinit_System() {
    $clinit_System = emptyMethod;
    err_0 = new PrintStream;
}
function arraycopy(src_0, srcOfs, dest, destOfs, len) {
    $clinit_System();
    var destArray, destComp, destEnd, destType, srcArray, srcComp, srcType;
    checkCriticalNotNull_0(src_0, 'src');
    checkCriticalNotNull_0(dest, 'dest');
    srcType = getClass__Ljava_lang_Class___devirtual$(src_0);
    destType = getClass__Ljava_lang_Class___devirtual$(dest);
    checkCriticalArrayType_0((srcType.modifiers & 4) != 0, 'srcType is not an array');
    checkCriticalArrayType_0((destType.modifiers & 4) != 0, 'destType is not an array');
    srcComp = srcType.componentType;
    destComp = destType.componentType;
    checkCriticalArrayType_0((srcComp.modifiers & 1) != 0 ? srcComp == destComp : (destComp.modifiers & 1) == 0, "Array types don't match");
    checkArrayCopyIndicies(src_0, srcOfs, dest, destOfs, len);
    if ((srcComp.modifiers & 1) == 0 && srcType != destType) {
        srcArray = castToArray(src_0);
        destArray = castToArray(dest);
        if (maskUndefined(src_0) === maskUndefined(dest) && srcOfs < destOfs) {
            srcOfs += len;
            for(destEnd = destOfs + len; destEnd-- > destOfs;)setCheck(destArray, destEnd, srcArray[--srcOfs]);
        } else for(destEnd = destOfs + len; destOfs < destEnd;)setCheck(destArray, destOfs++, srcArray[srcOfs++]);
    } else copy_0(src_0, srcOfs, dest, destOfs, len, true);
}
function checkArrayCopyIndicies(src_0, srcOfs, dest, destOfs, len) {
    var destlen, srclen;
    srclen = src_0.length;
    destlen = dest.length;
    if (srcOfs < 0 || destOfs < 0 || len < 0 || srcOfs + len > srclen || destOfs + len > destlen) throw toJs(new IndexOutOfBoundsException);
}
defineClass(2091, 1, {});
var err_0;
function UnsupportedOperationException() {
    RuntimeException.call(this);
}
function UnsupportedOperationException_0(message) {
    RuntimeException_0.call(this, message);
}
defineClass(46, 63, {
    3: 1,
    103: 1,
    63: 1,
    80: 1,
    46: 1
}, UnsupportedOperationException, UnsupportedOperationException_0);
var Ljava_lang_UnsupportedOperationException_2_classLit = createForClass('java.lang', 'UnsupportedOperationException', 46);
function $clinit_BigDecimal() {
    $clinit_BigDecimal = emptyMethod;
    var i, j, j0;
    new BigDecimal(1, 0);
    new BigDecimal(10, 0);
    new BigDecimal(0, 0);
    BI_SCALED_BY_ZERO = initUnidimensionalArray(Ljava_math_BigDecimal_2_classLit, $intern_16, 245, 11, 0, 1);
    CH_ZEROS = initUnidimensionalArray(C_classLit, $intern_44, 30, 100, 15, 1);
    DOUBLE_FIVE_POW = stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        1,
        5,
        25,
        125,
        625,
        3125,
        15625,
        78125,
        390625,
        1953125,
        9765625,
        48828125,
        244140625,
        1220703125,
        6103515625,
        30517578125,
        152587890625,
        762939453125,
        3814697265625,
        19073486328125,
        95367431640625,
        476837158203125,
        2384185791015625
    ]);
    DOUBLE_FIVE_POW_BIT_LENGTH = initUnidimensionalArray(I_classLit, $intern_48, 30, DOUBLE_FIVE_POW.length, 15, 1);
    DOUBLE_TEN_POW = stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        1,
        10,
        100,
        $intern_45,
        10000,
        $intern_67,
        1000000,
        10000000,
        100000000,
        $intern_56,
        10000000000,
        100000000000,
        1000000000000,
        10000000000000,
        100000000000000,
        1000000000000000,
        10000000000000000
    ]);
    DOUBLE_TEN_POW_BIT_LENGTH = initUnidimensionalArray(I_classLit, $intern_48, 30, DOUBLE_TEN_POW.length, 15, 1);
    ZERO_SCALED_BY = initUnidimensionalArray(Ljava_math_BigDecimal_2_classLit, $intern_16, 245, 11, 0, 1);
    i = 0;
    for(; i < ZERO_SCALED_BY.length; i++){
        BI_SCALED_BY_ZERO[i] = new BigDecimal(i, 0);
        ZERO_SCALED_BY[i] = new BigDecimal(0, i);
        CH_ZEROS[i] = 48;
    }
    for(; i < CH_ZEROS.length; i++)CH_ZEROS[i] = 48;
    for(j0 = 0; j0 < DOUBLE_FIVE_POW_BIT_LENGTH.length; j0++)DOUBLE_FIVE_POW_BIT_LENGTH[j0] = bitLength(DOUBLE_FIVE_POW[j0]);
    for(j = 0; j < DOUBLE_TEN_POW_BIT_LENGTH.length; j++)DOUBLE_TEN_POW_BIT_LENGTH[j] = bitLength(DOUBLE_TEN_POW[j]);
    $clinit_Multiplication();
}
function $compareTo_10(this$static, val) {
    var diffPrecision, diffScale, thisSign, thisUnscaled, valUnscaled, valueSign;
    thisSign = $signum(this$static);
    valueSign = $signum(val);
    if (thisSign == valueSign) {
        if (this$static.scale == val.scale && this$static.bitLength < 54 && val.bitLength < 54) return this$static.smallValue < val.smallValue ? -1 : this$static.smallValue > val.smallValue ? 1 : 0;
        diffScale = this$static.scale - val.scale;
        diffPrecision = (this$static.precision > 0 ? this$static.precision : $wnd.Math.floor((this$static.bitLength - 1) * $intern_68) + 1) - (val.precision > 0 ? val.precision : $wnd.Math.floor((val.bitLength - 1) * $intern_68) + 1);
        if (diffPrecision > diffScale + 1) return thisSign;
        else if (diffPrecision < diffScale - 1) return -thisSign;
        else {
            thisUnscaled = (!this$static.intVal && (this$static.intVal = valueOf_9(fromDouble_0(this$static.smallValue))), this$static.intVal);
            valUnscaled = (!val.intVal && (val.intVal = valueOf_9(fromDouble_0(val.smallValue))), val.intVal);
            diffScale < 0 ? thisUnscaled = $multiply(thisUnscaled, powerOf10(-diffScale)) : diffScale > 0 && (valUnscaled = $multiply(valUnscaled, powerOf10(diffScale)));
            return $compareTo_11(thisUnscaled, valUnscaled);
        }
    } else return thisSign < valueSign ? -1 : 1;
}
function $initFrom(this$static, val) {
    var begin, ch_0, i, last, offset, scaleString, unscaled, unscaledBuffer;
    begin = 0;
    offset = 0;
    last = val.length;
    scaleString = null;
    unscaledBuffer = new StringBuilder_0;
    if (offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 43)) {
        ++offset;
        ++begin;
        if (offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 43 || (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 45))) throw toJs(new NumberFormatException('For input string: "' + val + '"'));
    }
    while(offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) != 46) && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) != 101) && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) != 69))++offset;
    unscaledBuffer.string += '' + $substring_1(val == null ? 'null' : (checkCriticalNotNull(val), val), begin, offset);
    if (offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 46)) {
        ++offset;
        begin = offset;
        while(offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) != 101) && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) != 69))++offset;
        this$static.scale = offset - begin;
        unscaledBuffer.string += '' + $substring_1(val == null ? 'null' : (checkCriticalNotNull(val), val), begin, offset);
    } else this$static.scale = 0;
    if (offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 101 || (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 69))) {
        ++offset;
        begin = offset;
        if (offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) == 43)) {
            ++offset;
            offset < last && (checkCriticalStringElementIndex(offset, val.length), val.charCodeAt(offset) != 45) && ++begin;
        }
        scaleString = (checkCriticalStringBounds(begin, last, val.length), val.substr(begin, last - begin));
        this$static.scale = this$static.scale - __parseAndValidateInt(scaleString, $intern_42, $intern_0);
        if (this$static.scale != round_int(this$static.scale)) throw toJs(new NumberFormatException('Scale out of range.'));
    }
    unscaled = unscaledBuffer.string;
    if (unscaled.length < 16) {
        this$static.smallValue = (unscaledRegex == null && (unscaledRegex = new RegExp('^[+-]?\\d*$', 'i')), unscaledRegex.test(unscaled) ? parseInt(unscaled, 10) : NaN);
        if (isNaN(this$static.smallValue)) throw toJs(new NumberFormatException('For input string: "' + val + '"'));
        this$static.bitLength = bitLength(this$static.smallValue);
    } else $setUnscaledValue(this$static, new BigInteger_3(unscaled));
    this$static.precision = unscaledBuffer.string.length;
    for(i = 0; i < unscaledBuffer.string.length; ++i){
        ch_0 = $charAt(unscaledBuffer.string, i);
        if (ch_0 != 45 && ch_0 != 48) break;
        --this$static.precision;
    }
    this$static.precision == 0 && (this$static.precision = 1);
}
function $setUnscaledValue(this$static, unscaledValue) {
    var value_0;
    this$static.intVal = unscaledValue;
    this$static.bitLength = bitLength_1(unscaledValue);
    this$static.bitLength < 54 && (this$static.smallValue = (value_0 = unscaledValue.numberLength > 1 ? fromBits_0(unscaledValue.digits[0], unscaledValue.digits[1]) : fromBits_0(unscaledValue.digits[0], 0), toDouble_0(unscaledValue.sign > 0 ? value_0 : neg_0(value_0))));
}
function $signum(this$static) {
    if (this$static.bitLength < 54) return this$static.smallValue < 0 ? -1 : this$static.smallValue > 0 ? 1 : 0;
    return (!this$static.intVal && (this$static.intVal = valueOf_9(fromDouble_0(this$static.smallValue))), this$static.intVal).sign;
}
function $toPlainString(this$static) {
    var begin, delta, intStr, result;
    intStr = toDecimalScaledString_0((!this$static.intVal && (this$static.intVal = valueOf_9(fromDouble_0(this$static.smallValue))), this$static.intVal), 0);
    if (this$static.scale == 0 || this$static.bitLength == 0 && this$static.smallValue != -1 && this$static.scale < 0) return intStr;
    begin = $signum(this$static) < 0 ? 1 : 0;
    delta = this$static.scale;
    result = (intStr.length, $wnd.Math.abs(round_int(this$static.scale)), new StringBuilder_0);
    begin == 1 && (result.string += '-', result);
    if (this$static.scale > 0) {
        delta -= intStr.length - begin;
        if (delta >= 0) {
            result.string += '0.';
            for(; delta > CH_ZEROS.length; delta -= CH_ZEROS.length)$append_12(result, CH_ZEROS);
            $append_13(result, CH_ZEROS, round_int(delta));
            $append_11(result, (checkCriticalStringElementIndex(begin, intStr.length + 1), intStr.substr(begin)));
        } else {
            delta = begin - delta;
            $append_11(result, $substring_1(intStr, begin, round_int(delta)));
            result.string += '.';
            $append_11(result, $substring_0(intStr, round_int(delta)));
        }
    } else {
        $append_11(result, (checkCriticalStringElementIndex(begin, intStr.length + 1), intStr.substr(begin)));
        for(; delta < -CH_ZEROS.length; delta += CH_ZEROS.length)$append_12(result, CH_ZEROS);
        $append_13(result, CH_ZEROS, round_int(-delta));
    }
    return result.string;
}
function $toString_8(this$static) {
    var begin, end, exponent, intString, result;
    if (this$static.toStringImage != null) return this$static.toStringImage;
    if (this$static.bitLength < 32) {
        this$static.toStringImage = toDecimalScaledString(fromDouble_0(this$static.smallValue), round_int(this$static.scale));
        return this$static.toStringImage;
    }
    intString = toDecimalScaledString_0((!this$static.intVal && (this$static.intVal = valueOf_9(fromDouble_0(this$static.smallValue))), this$static.intVal), 0);
    if (this$static.scale == 0) return intString;
    begin = (!this$static.intVal && (this$static.intVal = valueOf_9(fromDouble_0(this$static.smallValue))), this$static.intVal).sign < 0 ? 2 : 1;
    end = intString.length;
    exponent = -this$static.scale + end - begin;
    result = new StringBuilder;
    result.string += '' + intString;
    if (this$static.scale > 0 && exponent >= -6) {
        if (exponent >= 0) $insert_0(result, end - round_int(this$static.scale), String.fromCharCode(46));
        else {
            $replace0(result, begin - 1, begin - 1, '0.');
            $insert_0(result, begin + 1, valueOf_8(CH_ZEROS, 0, -round_int(exponent) - 1));
        }
    } else {
        if (end - begin >= 1) {
            $insert_0(result, begin, String.fromCharCode(46));
            ++end;
        }
        $insert_0(result, end, String.fromCharCode(69));
        exponent > 0 && $insert_0(result, ++end, String.fromCharCode(43));
        $insert_0(result, ++end, '' + toString_39(fromDouble_0(exponent)));
    }
    this$static.toStringImage = result.string;
    return this$static.toStringImage;
}
function BigDecimal(smallValue, scale) {
    this.scale = scale;
    this.bitLength = bitLength_0(smallValue);
    this.bitLength < 54 ? this.smallValue = toDouble_0(smallValue) : this.intVal = ($clinit_BigInteger(), compare_2(smallValue, 0) >= 0 ? fromBits(smallValue) : $negate(fromBits(neg_0(smallValue))));
}
function BigDecimal_0(val) {
    $clinit_BigDecimal();
    $initFrom(this, val);
}
function bitLength(value_0) {
    var negative, result;
    if (value_0 > -140737488355328 && value_0 < 140737488355328) {
        if (value_0 == 0) return 0;
        negative = value_0 < 0;
        negative && (value_0 = -value_0);
        result = round_int($wnd.Math.floor($wnd.Math.log(value_0) / 0.6931471805599453));
        (!negative || value_0 != $wnd.Math.pow(2, result)) && ++result;
        return result;
    }
    return bitLength_0(fromDouble_0(value_0));
}
function bitLength_0(value_0) {
    var high;
    compare_2(value_0, 0) < 0 && (value_0 = createLongEmul(not(isSmallLong0(value_0) ? toBigLong(value_0) : value_0)));
    return high = toInt_0(shru_0(value_0, 32)), 64 - (high != 0 ? numberOfLeadingZeros_0(high) : numberOfLeadingZeros_0(toInt_0(value_0)) + 32);
}
defineClass(245, 241, {
    3: 1,
    34: 1,
    241: 1,
    245: 1
}, BigDecimal, BigDecimal_0);
_.compareTo_0 = function compareTo_11(val) {
    return $compareTo_10(this, castTo(val, 245));
};
_.doubleValue = function doubleValue_5() {
    return __parseAndValidateDouble($toString_8(this));
};
_.equals_0 = function equals_42(x_0) {
    var x1;
    if (this === x_0) return true;
    if (instanceOf(x_0, 245)) {
        x1 = castTo(x_0, 245);
        return this.scale == x1.scale && $compareTo_10(this, x1) == 0;
    }
    return false;
};
_.hashCode_1 = function hashCode_43() {
    var longValue;
    if (this.hashCode_0 != 0) return this.hashCode_0;
    if (this.bitLength < 54) {
        longValue = fromDouble_0(this.smallValue);
        this.hashCode_0 = toInt_0(and_0(longValue, -1));
        this.hashCode_0 = 33 * this.hashCode_0 + toInt_0(and_0(shr_0(longValue, 32), -1));
        this.hashCode_0 = 17 * this.hashCode_0 + round_int(this.scale);
        return this.hashCode_0;
    }
    this.hashCode_0 = 17 * $hashCode_3(this.intVal) + round_int(this.scale);
    return this.hashCode_0;
};
_.toString_0 = function toString_50() {
    return $toString_8(this);
};
_.bitLength = 0;
_.hashCode_0 = 0;
_.precision = 0;
_.scale = 0;
_.smallValue = 0;
var BI_SCALED_BY_ZERO, CH_ZEROS, DOUBLE_FIVE_POW, DOUBLE_FIVE_POW_BIT_LENGTH, DOUBLE_TEN_POW, DOUBLE_TEN_POW_BIT_LENGTH, ZERO_SCALED_BY, unscaledRegex;
var Ljava_math_BigDecimal_2_classLit = createForClass('java.math', 'BigDecimal', 245);
function $clinit_BigInteger() {
    $clinit_BigInteger = emptyMethod;
    var i;
    ONE_0 = new BigInteger(1, 1);
    TEN = new BigInteger(1, 10);
    ZERO_0 = new BigInteger(0, 0);
    MINUS_ONE = new BigInteger(-1, 1);
    SMALL_VALUES = stampJavaTypeInfo(getClassLiteralForArray(Ljava_math_BigInteger_2_classLit, 1), $intern_16, 90, 0, [
        ZERO_0,
        ONE_0,
        new BigInteger(1, 2),
        new BigInteger(1, 3),
        new BigInteger(1, 4),
        new BigInteger(1, 5),
        new BigInteger(1, 6),
        new BigInteger(1, 7),
        new BigInteger(1, 8),
        new BigInteger(1, 9),
        TEN
    ]);
    TWO_POWS = initUnidimensionalArray(Ljava_math_BigInteger_2_classLit, $intern_16, 90, 32, 0, 1);
    for(i = 0; i < TWO_POWS.length; i++)TWO_POWS[i] = gte_0(shl_0(1, i), 0) ? fromBits(shl_0(1, i)) : $negate(fromBits(neg_0(shl_0(1, i))));
}
function $compareTo_11(this$static, val) {
    if (this$static.sign > val.sign) return 1;
    if (this$static.sign < val.sign) return -1;
    if (this$static.numberLength > val.numberLength) return this$static.sign;
    if (this$static.numberLength < val.numberLength) return -val.sign;
    return this$static.sign * compareArrays(this$static.digits, val.digits, this$static.numberLength);
}
function $cutOffLeadingZeroes(this$static) {
    while(this$static.numberLength > 0 && this$static.digits[--this$static.numberLength] == 0);
    this$static.digits[this$static.numberLength++] == 0 && (this$static.sign = 0);
}
function $equals_6(this$static, x_0) {
    var x1;
    if (maskUndefined(this$static) === maskUndefined(x_0)) return true;
    if (instanceOf(x_0, 90)) {
        x1 = castTo(x_0, 90);
        return this$static.sign == x1.sign && this$static.numberLength == x1.numberLength && $equalsArrays(this$static, x1.digits);
    }
    return false;
}
function $equalsArrays(this$static, b) {
    var i;
    for(i = this$static.numberLength - 1; i >= 0 && this$static.digits[i] === b[i]; i--);
    return i < 0;
}
function $getFirstNonzeroDigit(this$static) {
    var i;
    if (this$static.firstNonzeroDigit == -2) {
        if (this$static.sign == 0) i = -1;
        else {
            for(i = 0; this$static.digits[i] == 0; i++);
        }
        this$static.firstNonzeroDigit = i;
    }
    return this$static.firstNonzeroDigit;
}
function $hashCode_3(this$static) {
    var i;
    if (this$static.hashCode_0 != 0) return this$static.hashCode_0;
    for(i = 0; i < this$static.digits.length; i++)this$static.hashCode_0 = this$static.hashCode_0 * 33 + (this$static.digits[i] & -1);
    this$static.hashCode_0 = this$static.hashCode_0 * this$static.sign;
    return this$static.hashCode_0;
}
function $multiply(this$static, val) {
    if (val.sign == 0 || this$static.sign == 0) return ZERO_0;
    return $clinit_Multiplication(), karatsuba(this$static, val);
}
function $negate(this$static) {
    return this$static.sign == 0 ? this$static : new BigInteger_1(-this$static.sign, this$static.numberLength, this$static.digits);
}
function $pow(this$static, exp_0) {
    var x_0;
    if (exp_0 < 0) throw toJs(new ArithmeticException('Negative exponent'));
    if (exp_0 == 0) return ONE_0;
    else if (exp_0 == 1 || $equals_6(this$static, ONE_0) || $equals_6(this$static, ZERO_0)) return this$static;
    if (!$testBit(this$static, 0)) {
        x_0 = 1;
        while(!$testBit(this$static, x_0))++x_0;
        return $multiply(getPowerOfTwo(x_0 * exp_0), $pow($shiftRight(this$static, x_0), exp_0));
    }
    return pow_0(this$static, exp_0);
}
function $shiftLeft(this$static, n) {
    if (n == 0 || this$static.sign == 0) return this$static;
    return n > 0 ? shiftLeft(this$static, n) : shiftRight(this$static, -n);
}
function $shiftRight(this$static, n) {
    if (n == 0 || this$static.sign == 0) return this$static;
    return n > 0 ? shiftRight(this$static, n) : shiftLeft(this$static, -n);
}
function $testBit(this$static, n) {
    var digit, firstNonZeroDigit, intCount;
    if (n == 0) return (this$static.digits[0] & 1) != 0;
    if (n < 0) throw toJs(new ArithmeticException('Negative bit address'));
    intCount = n >> 5;
    if (intCount >= this$static.numberLength) return this$static.sign < 0;
    digit = this$static.digits[intCount];
    n = 1 << (n & 31);
    if (this$static.sign < 0) {
        firstNonZeroDigit = $getFirstNonzeroDigit(this$static);
        if (intCount < firstNonZeroDigit) return false;
        else firstNonZeroDigit == intCount ? digit = -digit : digit = ~digit;
    }
    return (digit & n) != 0;
}
function BigInteger(sign, bits) {
    $clinit_BigInteger();
    BigInteger_1.call(this, sign, 1, stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        bits
    ]));
}
function BigInteger_0(lowBits, highBits) {
    BigInteger_1.call(this, 1, 2, stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        lowBits,
        highBits
    ]));
}
function BigInteger_1(sign, numberLength, digits) {
    $clinit_BigInteger();
    this.sign = sign;
    this.numberLength = numberLength;
    this.digits = digits;
}
function BigInteger_2(digits) {
    $clinit_BigInteger();
    if (digits.length == 0) {
        this.sign = 0;
        this.numberLength = 1;
        this.digits = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
            0
        ]);
    } else {
        this.sign = 1;
        this.numberLength = digits.length;
        this.digits = digits;
        $cutOffLeadingZeroes(this);
    }
}
function BigInteger_3(val) {
    $clinit_BigInteger();
    BigInteger_4.call(this, val);
}
function BigInteger_4(val) {
    checkCriticalNotNull(val);
    if (val.length == 0) throw toJs(new NumberFormatException('Zero length BigInteger'));
    setFromString(this, val);
}
function fromBits(bits) {
    $clinit_BigInteger();
    var highBits, lowBits;
    lowBits = toInt_0(bits);
    highBits = toInt_0(shru_0(bits, 32));
    if (highBits != 0) return new BigInteger_0(lowBits, highBits);
    if (lowBits > 10 || lowBits < 0) return new BigInteger(1, lowBits);
    return SMALL_VALUES[lowBits];
}
function getPowerOfTwo(exp_0) {
    var bitN, intCount, resDigits;
    if (exp_0 < TWO_POWS.length) return TWO_POWS[exp_0];
    intCount = exp_0 >> 5;
    bitN = exp_0 & 31;
    resDigits = initUnidimensionalArray(I_classLit, $intern_48, 30, intCount + 1, 15, 1);
    resDigits[intCount] = 1 << bitN;
    return new BigInteger_1(1, intCount + 1, resDigits);
}
function setFromString(bi, val) {
    var bigRadix, bigRadixDigit, bigRadixDigitsLength, charsPerInt, digitIndex, digits, endChar, newDigit, numberLength, sign, startChar, stringLength, substrEnd, substrStart, topChars;
    stringLength = val.length;
    endChar = stringLength;
    checkCriticalStringElementIndex(0, val.length);
    if (val.charCodeAt(0) == 45) {
        sign = -1;
        startChar = 1;
        --stringLength;
    } else {
        sign = 1;
        startChar = 0;
    }
    charsPerInt = ($clinit_Conversion(), digitFitInInt)[10];
    bigRadixDigitsLength = stringLength / charsPerInt | 0;
    topChars = stringLength % charsPerInt;
    topChars != 0 && ++bigRadixDigitsLength;
    digits = initUnidimensionalArray(I_classLit, $intern_48, 30, bigRadixDigitsLength, 15, 1);
    bigRadix = bigRadices[8];
    digitIndex = 0;
    substrEnd = startChar + (topChars == 0 ? charsPerInt : topChars);
    for(substrStart = startChar; substrStart < endChar; substrStart = substrEnd, substrEnd = substrStart + charsPerInt){
        bigRadixDigit = __parseAndValidateInt((checkCriticalStringBounds(substrStart, substrEnd, val.length), val.substr(substrStart, substrEnd - substrStart)), $intern_42, $intern_0);
        newDigit = ($clinit_Multiplication(), multiplyByInt(digits, digits, digitIndex, bigRadix));
        newDigit += inplaceAdd(digits, digitIndex, bigRadixDigit);
        digits[digitIndex++] = newDigit;
    }
    numberLength = digitIndex;
    bi.sign = sign;
    bi.numberLength = numberLength;
    bi.digits = digits;
    $cutOffLeadingZeroes(bi);
}
function valueOf_9(val) {
    $clinit_BigInteger();
    return compare_2(val, 0) >= 0 ? fromBits(val) : $negate(fromBits(neg_0(val)));
}
defineClass(90, 241, {
    3: 1,
    34: 1,
    241: 1,
    90: 1
}, BigInteger, BigInteger_0, BigInteger_1, BigInteger_2, BigInteger_3);
_.compareTo_0 = function compareTo_12(val) {
    return $compareTo_11(this, castTo(val, 90));
};
_.doubleValue = function doubleValue_6() {
    return __parseAndValidateDouble(toDecimalScaledString_0(this, 0));
};
_.equals_0 = function equals_43(x_0) {
    return $equals_6(this, x_0);
};
_.hashCode_1 = function hashCode_44() {
    return $hashCode_3(this);
};
_.toString_0 = function toString_51() {
    return toDecimalScaledString_0(this, 0);
};
_.firstNonzeroDigit = -2;
_.hashCode_0 = 0;
_.numberLength = 0;
_.sign = 0;
var MINUS_ONE, ONE_0, SMALL_VALUES, TEN, TWO_POWS, ZERO_0;
var Ljava_math_BigInteger_2_classLit = createForClass('java.math', 'BigInteger', 90);
function bitLength_1(val) {
    var bLength, highDigit, i;
    if (val.sign == 0) return 0;
    bLength = val.numberLength << 5;
    highDigit = val.digits[val.numberLength - 1];
    if (val.sign < 0) {
        i = $getFirstNonzeroDigit(val);
        if (i == val.numberLength - 1) {
            --highDigit;
            highDigit = highDigit | 0;
        }
    }
    bLength -= numberOfLeadingZeros_0(highDigit);
    return bLength;
}
function shiftLeft(source, count) {
    var intCount, resDigits, resLength, result;
    intCount = count >> 5;
    count &= 31;
    resLength = source.numberLength + intCount + (count == 0 ? 0 : 1);
    resDigits = initUnidimensionalArray(I_classLit, $intern_48, 30, resLength, 15, 1);
    shiftLeft_0(resDigits, source.digits, intCount, count);
    result = new BigInteger_1(source.sign, resLength, resDigits);
    $cutOffLeadingZeroes(result);
    return result;
}
function shiftLeft_0(result, source, intCount, count) {
    var i, i0, rightShiftCount;
    if (count == 0) arraycopy(source, 0, result, intCount, result.length - intCount);
    else {
        rightShiftCount = 32 - count;
        result[result.length - 1] = 0;
        for(i0 = result.length - 1; i0 > intCount; i0--){
            result[i0] |= source[i0 - intCount - 1] >>> rightShiftCount;
            result[i0 - 1] = source[i0 - intCount - 1] << count;
        }
    }
    for(i = 0; i < intCount; i++)result[i] = 0;
}
function shiftLeftOneBit(result, source, srcLen) {
    var carry, i, val;
    carry = 0;
    for(i = 0; i < srcLen; i++){
        val = source[i];
        result[i] = val << 1 | carry;
        carry = val >>> 31;
    }
    carry != 0 && (result[srcLen] = carry);
}
function shiftRight(source, count) {
    var i, intCount, resDigits, resLength, result;
    intCount = count >> 5;
    count &= 31;
    if (intCount >= source.numberLength) return source.sign < 0 ? ($clinit_BigInteger(), MINUS_ONE) : ($clinit_BigInteger(), ZERO_0);
    resLength = source.numberLength - intCount;
    resDigits = initUnidimensionalArray(I_classLit, $intern_48, 30, resLength + 1, 15, 1);
    shiftRight_0(resDigits, resLength, source.digits, intCount, count);
    if (source.sign < 0) {
        for(i = 0; i < intCount && source.digits[i] == 0; i++);
        if (i < intCount || count > 0 && source.digits[i] << 32 - count != 0) {
            for(i = 0; i < resLength && resDigits[i] == -1; i++)resDigits[i] = 0;
            i == resLength && ++resLength;
            ++resDigits[i];
        }
    }
    result = new BigInteger_1(source.sign, resLength, resDigits);
    $cutOffLeadingZeroes(result);
    return result;
}
function shiftRight_0(result, resultLen, source, intCount, count) {
    var allZero, i, leftShiftCount;
    allZero = true;
    for(i = 0; i < intCount; i++)allZero = allZero & source[i] == 0;
    if (count == 0) {
        arraycopy(source, intCount, result, 0, resultLen);
        i = resultLen;
    } else {
        leftShiftCount = 32 - count;
        allZero = allZero & source[i] << leftShiftCount == 0;
        for(i = 0; i < resultLen - 1; i++)result[i] = source[i + intCount] >>> count | source[i + intCount + 1] << leftShiftCount;
        result[i] = source[i + intCount] >>> count;
        ++i;
    }
    return allZero;
}
function $clinit_Conversion() {
    $clinit_Conversion = emptyMethod;
    bigRadices = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        $intern_42,
        1162261467,
        $intern_35,
        1220703125,
        362797056,
        1977326743,
        $intern_35,
        387420489,
        $intern_56,
        214358881,
        429981696,
        815730721,
        1475789056,
        170859375,
        268435456,
        410338673,
        612220032,
        893871739,
        1280000000,
        1801088541,
        113379904,
        148035889,
        191102976,
        244140625,
        308915776,
        387420489,
        481890304,
        594823321,
        729000000,
        887503681,
        $intern_35,
        1291467969,
        1544804416,
        1838265625,
        60466176
    ]);
    digitFitInInt = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        -1,
        -1,
        31,
        19,
        15,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5
    ]);
}
function divideLongByBillion(a) {
    var aPos, quot, rem;
    if (compare_2(a, 0) >= 0) {
        quot = div(a, $intern_56);
        rem = mod(a, $intern_56);
    } else {
        aPos = shru_0(a, 1);
        quot = div(aPos, 500000000);
        rem = mod(aPos, 500000000);
        rem = add_20(shl_0(rem, 1), and_0(a, 1));
    }
    return or_0(shl_0(rem, 32), and_0(quot, $intern_69));
}
function toDecimalScaledString(value_0, scale) {
    $clinit_Conversion();
    var currentChar, endPoint, exponent, insertPoint, j, j0, negNumber, prev, resLengthInChars, result, result1, result10, startPoint, v;
    negNumber = compare_2(value_0, 0) < 0;
    negNumber && (value_0 = neg_0(value_0));
    if (compare_2(value_0, 0) == 0) switch(scale){
        case 0:
            return '0';
        case 1:
            return '0.0';
        case 2:
            return '0.00';
        case 3:
            return '0.000';
        case 4:
            return '0.0000';
        case 5:
            return '0.00000';
        case 6:
            return '0.000000';
        default:
            result10 = new StringBuilder;
            scale < 0 ? (result10.string += '0E+', result10) : (result10.string += '0E', result10);
            result10.string += scale == $intern_42 ? '2147483648' : '' + -scale;
            return result10.string;
    }
    resLengthInChars = 18;
    result = initUnidimensionalArray(C_classLit, $intern_44, 30, resLengthInChars + 1, 15, 1);
    currentChar = resLengthInChars;
    v = value_0;
    do {
        prev = v;
        v = div(v, 10);
        result[--currentChar] = toInt_0(add_20(48, sub_2(prev, mul_0(v, 10)))) & $intern_46;
    }while (compare_2(v, 0) != 0);
    exponent = sub_2(sub_2(sub_2(resLengthInChars, currentChar), scale), 1);
    if (scale == 0) {
        negNumber && (result[--currentChar] = 45);
        return valueOf_8(result, currentChar, resLengthInChars - currentChar);
    }
    if (scale > 0 && compare_2(exponent, -6) >= 0) {
        if (compare_2(exponent, 0) >= 0) {
            insertPoint = currentChar + toInt_0(exponent);
            for(j0 = resLengthInChars - 1; j0 >= insertPoint; j0--)result[j0 + 1] = result[j0];
            result[++insertPoint] = 46;
            negNumber && (result[--currentChar] = 45);
            return valueOf_8(result, currentChar, resLengthInChars - currentChar + 1);
        }
        for(j = 2; lt(j, add_20(neg_0(exponent), 1)); j++)result[--currentChar] = 48;
        result[--currentChar] = 46;
        result[--currentChar] = 48;
        negNumber && (result[--currentChar] = 45);
        return valueOf_8(result, currentChar, resLengthInChars - currentChar);
    }
    startPoint = currentChar + 1;
    endPoint = resLengthInChars;
    result1 = new StringBuilder_0;
    negNumber && (result1.string += '-', result1);
    if (endPoint - startPoint >= 1) {
        $append_5(result1, result[currentChar]);
        result1.string += '.';
        result1.string += valueOf_8(result, currentChar + 1, resLengthInChars - currentChar - 1);
    } else result1.string += valueOf_8(result, currentChar, resLengthInChars - currentChar);
    result1.string += 'E';
    compare_2(exponent, 0) > 0 && (result1.string += '+', result1);
    result1.string += '' + toString_39(exponent);
    return result1.string;
}
function toDecimalScaledString_0(val, scale) {
    $clinit_Conversion();
    var currentChar, delta, digits, endPoint, exponent, highDigit, i, i1, insertPoint, j, j0, negNumber, numberLength, prev, previous, res, resDigit, resLengthInChars, result, result1, result10, result11, sign, startPoint, temp, temp1, tempLen, v;
    sign = val.sign;
    numberLength = val.numberLength;
    digits = val.digits;
    if (sign == 0) switch(scale){
        case 0:
            return '0';
        case 1:
            return '0.0';
        case 2:
            return '0.00';
        case 3:
            return '0.000';
        case 4:
            return '0.0000';
        case 5:
            return '0.00000';
        case 6:
            return '0.000000';
        default:
            result10 = new StringBuilder;
            scale < 0 ? (result10.string += '0E+', result10) : (result10.string += '0E', result10);
            result10.string += -scale;
            return result10.string;
    }
    resLengthInChars = numberLength * 10 + 1 + 7;
    result = initUnidimensionalArray(C_classLit, $intern_44, 30, resLengthInChars + 1, 15, 1);
    currentChar = resLengthInChars;
    if (numberLength == 1) {
        highDigit = digits[0];
        if (highDigit < 0) {
            v = and_0(highDigit, $intern_69);
            do {
                prev = v;
                v = div(v, 10);
                result[--currentChar] = 48 + toInt_0(sub_2(prev, mul_0(v, 10))) & $intern_46;
            }while (compare_2(v, 0) != 0);
        } else {
            v = highDigit;
            do {
                prev = v;
                v = v / 10 | 0;
                result[--currentChar] = 48 + (prev - v * 10) & $intern_46;
            }while (v != 0);
        }
    } else {
        temp = initUnidimensionalArray(I_classLit, $intern_48, 30, numberLength, 15, 1);
        tempLen = numberLength;
        arraycopy(digits, 0, temp, 0, tempLen);
        BIG_LOOP: while(true){
            result11 = 0;
            for(i1 = tempLen - 1; i1 >= 0; i1--){
                temp1 = add_20(shl_0(result11, 32), and_0(temp[i1], $intern_69));
                res = divideLongByBillion(temp1);
                temp[i1] = toInt_0(res);
                result11 = toInt_0(shr_0(res, 32));
            }
            resDigit = toInt_0(result11);
            previous = currentChar;
            do result[--currentChar] = 48 + resDigit % 10 & $intern_46;
            while ((resDigit = resDigit / 10 | 0) != 0 && currentChar != 0);
            delta = 9 - previous + currentChar;
            for(i = 0; i < delta && currentChar > 0; i++)result[--currentChar] = 48;
            j = tempLen - 1;
            for(; temp[j] == 0; j--){
                if (j == 0) break BIG_LOOP;
            }
            tempLen = j + 1;
        }
        while(result[currentChar] == 48)++currentChar;
    }
    negNumber = sign < 0;
    exponent = resLengthInChars - currentChar - scale - 1;
    if (scale == 0) {
        negNumber && (result[--currentChar] = 45);
        return valueOf_8(result, currentChar, resLengthInChars - currentChar);
    }
    if (scale > 0 && exponent >= -6) {
        if (exponent >= 0) {
            insertPoint = currentChar + exponent;
            for(j0 = resLengthInChars - 1; j0 >= insertPoint; j0--)result[j0 + 1] = result[j0];
            result[++insertPoint] = 46;
            negNumber && (result[--currentChar] = 45);
            return valueOf_8(result, currentChar, resLengthInChars - currentChar + 1);
        }
        for(j = 2; j < -exponent + 1; j++)result[--currentChar] = 48;
        result[--currentChar] = 46;
        result[--currentChar] = 48;
        negNumber && (result[--currentChar] = 45);
        return valueOf_8(result, currentChar, resLengthInChars - currentChar);
    }
    startPoint = currentChar + 1;
    endPoint = resLengthInChars;
    result1 = new StringBuilder_0;
    negNumber && (result1.string += '-', result1);
    if (endPoint - startPoint >= 1) {
        $append_5(result1, result[currentChar]);
        result1.string += '.';
        result1.string += valueOf_8(result, currentChar + 1, resLengthInChars - currentChar - 1);
    } else result1.string += valueOf_8(result, currentChar, resLengthInChars - currentChar);
    result1.string += 'E';
    exponent > 0 && (result1.string += '+', result1);
    result1.string += '' + exponent;
    return result1.string;
}
var bigRadices, digitFitInInt;
function add_21(op1, op2) {
    var a, b, cmp, op1Len, op1Sign, op2Len, op2Sign, res, res0, resDigits, resSign, valueHi, valueLo;
    op1Sign = op1.sign;
    op2Sign = op2.sign;
    if (op1Sign == 0) return op2;
    if (op2Sign == 0) return op1;
    op1Len = op1.numberLength;
    op2Len = op2.numberLength;
    if (op1Len + op2Len == 2) {
        a = and_0(op1.digits[0], $intern_69);
        b = and_0(op2.digits[0], $intern_69);
        if (op1Sign == op2Sign) {
            res0 = add_20(a, b);
            valueLo = toInt_0(res0);
            valueHi = toInt_0(shru_0(res0, 32));
            return valueHi == 0 ? new BigInteger(op1Sign, valueLo) : new BigInteger_1(op1Sign, 2, stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
                valueLo,
                valueHi
            ]));
        }
        return $clinit_BigInteger(), gte_0(op1Sign < 0 ? sub_2(b, a) : sub_2(a, b), 0) ? fromBits(op1Sign < 0 ? sub_2(b, a) : sub_2(a, b)) : $negate(fromBits(neg_0(op1Sign < 0 ? sub_2(b, a) : sub_2(a, b))));
    } else if (op1Sign == op2Sign) {
        resSign = op1Sign;
        resDigits = op1Len >= op2Len ? add_22(op1.digits, op1Len, op2.digits, op2Len) : add_22(op2.digits, op2Len, op1.digits, op1Len);
    } else {
        cmp = op1Len != op2Len ? op1Len > op2Len ? 1 : -1 : compareArrays(op1.digits, op2.digits, op1Len);
        if (cmp == 0) return $clinit_BigInteger(), ZERO_0;
        if (cmp == 1) {
            resSign = op1Sign;
            resDigits = subtract_0(op1.digits, op1Len, op2.digits, op2Len);
        } else {
            resSign = op2Sign;
            resDigits = subtract_0(op2.digits, op2Len, op1.digits, op1Len);
        }
    }
    res = new BigInteger_1(resSign, resDigits.length, resDigits);
    $cutOffLeadingZeroes(res);
    return res;
}
function add_22(a, aSize, b, bSize) {
    var res;
    res = initUnidimensionalArray(I_classLit, $intern_48, 30, aSize + 1, 15, 1);
    add_23(res, a, aSize, b, bSize);
    return res;
}
function add_23(res, a, aSize, b, bSize) {
    var carry, i;
    carry = add_20(and_0(a[0], $intern_69), and_0(b[0], $intern_69));
    res[0] = toInt_0(carry);
    carry = shr_0(carry, 32);
    if (aSize >= bSize) {
        for(i = 1; i < bSize; i++){
            carry = add_20(carry, add_20(and_0(a[i], $intern_69), and_0(b[i], $intern_69)));
            res[i] = toInt_0(carry);
            carry = shr_0(carry, 32);
        }
        for(; i < aSize; i++){
            carry = add_20(carry, and_0(a[i], $intern_69));
            res[i] = toInt_0(carry);
            carry = shr_0(carry, 32);
        }
    } else {
        for(i = 1; i < aSize; i++){
            carry = add_20(carry, add_20(and_0(a[i], $intern_69), and_0(b[i], $intern_69)));
            res[i] = toInt_0(carry);
            carry = shr_0(carry, 32);
        }
        for(; i < bSize; i++){
            carry = add_20(carry, and_0(b[i], $intern_69));
            res[i] = toInt_0(carry);
            carry = shr_0(carry, 32);
        }
    }
    compare_2(carry, 0) != 0 && (res[i] = toInt_0(carry));
}
function compareArrays(a, b, size_0) {
    var i;
    for(i = size_0 - 1; i >= 0 && a[i] === b[i]; i--);
    return i < 0 ? 0 : lt(and_0(a[i], $intern_69), and_0(b[i], $intern_69)) ? -1 : 1;
}
function inplaceAdd(a, aSize, addend) {
    var carry, i;
    carry = and_0(addend, $intern_69);
    for(i = 0; compare_2(carry, 0) != 0 && i < aSize; i++){
        carry = add_20(carry, and_0(a[i], $intern_69));
        a[i] = toInt_0(carry);
        carry = shr_0(carry, 32);
    }
    return toInt_0(carry);
}
function subtract(op1, op2) {
    var a, b, cmp, op1Len, op1Sign, op2Len, op2Sign, res, resDigits, resSign;
    op1Sign = op1.sign;
    op2Sign = op2.sign;
    if (op2Sign == 0) return op1;
    if (op1Sign == 0) return op2.sign == 0 ? op2 : new BigInteger_1(-op2.sign, op2.numberLength, op2.digits);
    op1Len = op1.numberLength;
    op2Len = op2.numberLength;
    if (op1Len + op2Len == 2) {
        a = and_0(op1.digits[0], $intern_69);
        b = and_0(op2.digits[0], $intern_69);
        op1Sign < 0 && (a = neg_0(a));
        op2Sign < 0 && (b = neg_0(b));
        return $clinit_BigInteger(), gte_0(sub_2(a, b), 0) ? fromBits(sub_2(a, b)) : $negate(fromBits(neg_0(sub_2(a, b))));
    }
    cmp = op1Len != op2Len ? op1Len > op2Len ? 1 : -1 : compareArrays(op1.digits, op2.digits, op1Len);
    if (cmp == -1) {
        resSign = -op2Sign;
        resDigits = op1Sign == op2Sign ? subtract_0(op2.digits, op2Len, op1.digits, op1Len) : add_22(op2.digits, op2Len, op1.digits, op1Len);
    } else {
        resSign = op1Sign;
        if (op1Sign == op2Sign) {
            if (cmp == 0) return $clinit_BigInteger(), ZERO_0;
            resDigits = subtract_0(op1.digits, op1Len, op2.digits, op2Len);
        } else resDigits = add_22(op1.digits, op1Len, op2.digits, op2Len);
    }
    res = new BigInteger_1(resSign, resDigits.length, resDigits);
    $cutOffLeadingZeroes(res);
    return res;
}
function subtract_0(a, aSize, b, bSize) {
    var res;
    res = initUnidimensionalArray(I_classLit, $intern_48, 30, aSize, 15, 1);
    subtract_1(res, a, aSize, b, bSize);
    return res;
}
function subtract_1(res, a, aSize, b, bSize) {
    var borrow, i;
    borrow = 0;
    for(i = 0; i < bSize; i++){
        borrow = add_20(borrow, sub_2(and_0(a[i], $intern_69), and_0(b[i], $intern_69)));
        res[i] = toInt_0(borrow);
        borrow = shr_0(borrow, 32);
    }
    for(; i < aSize; i++){
        borrow = add_20(borrow, and_0(a[i], $intern_69));
        res[i] = toInt_0(borrow);
        borrow = shr_0(borrow, 32);
    }
}
function $clinit_Multiplication() {
    $clinit_Multiplication = emptyMethod;
    var fivePow, i;
    bigFivePows = initUnidimensionalArray(Ljava_math_BigInteger_2_classLit, $intern_16, 90, 32, 0, 1);
    bigTenPows = initUnidimensionalArray(Ljava_math_BigInteger_2_classLit, $intern_16, 90, 32, 0, 1);
    fivePow = 1;
    for(i = 0; i <= 18; i++){
        bigFivePows[i] = ($clinit_BigInteger(), compare_2(fivePow, 0) >= 0 ? fromBits(fivePow) : $negate(fromBits(neg_0(fivePow))));
        bigTenPows[i] = gte_0(shl_0(fivePow, i), 0) ? fromBits(shl_0(fivePow, i)) : $negate(fromBits(neg_0(shl_0(fivePow, i))));
        fivePow = mul_0(fivePow, 5);
    }
    for(; i < bigTenPows.length; i++){
        bigFivePows[i] = $multiply(bigFivePows[i - 1], bigFivePows[1]);
        bigTenPows[i] = $multiply(bigTenPows[i - 1], ($clinit_BigInteger(), TEN));
    }
}
function karatsuba(op1, op2) {
    $clinit_Multiplication();
    var lower, lowerOp1, lowerOp2, middle, ndiv2, temp, upper, upperOp1, upperOp2;
    if (op2.numberLength > op1.numberLength) {
        temp = op1;
        op1 = op2;
        op2 = temp;
    }
    if (op2.numberLength < 63) return multiplyPAP(op1, op2);
    ndiv2 = (op1.numberLength & -2) << 4;
    upperOp1 = $shiftRight(op1, ndiv2);
    upperOp2 = $shiftRight(op2, ndiv2);
    lowerOp1 = subtract(op1, $shiftLeft(upperOp1, ndiv2));
    lowerOp2 = subtract(op2, $shiftLeft(upperOp2, ndiv2));
    upper = karatsuba(upperOp1, upperOp2);
    lower = karatsuba(lowerOp1, lowerOp2);
    middle = karatsuba(subtract(upperOp1, lowerOp1), subtract(lowerOp2, upperOp2));
    middle = add_21(add_21(middle, upper), lower);
    middle = $shiftLeft(middle, ndiv2);
    upper = $shiftLeft(upper, ndiv2 << 1);
    return add_21(add_21(upper, middle), lower);
}
function multArraysPAP(aDigits, aLen, bDigits, bLen, resDigits) {
    if (aLen == 0 || bLen == 0) return;
    aLen == 1 ? resDigits[bLen] = multiplyByInt(resDigits, bDigits, bLen, aDigits[0]) : bLen == 1 ? resDigits[aLen] = multiplyByInt(resDigits, aDigits, aLen, bDigits[0]) : multPAP(aDigits, bDigits, resDigits, aLen, bLen);
}
function multPAP(a, b, t, aLen, bLen) {
    var aI, carry, i, j;
    if (maskUndefined(a) === maskUndefined(b) && aLen == bLen) {
        square(a, aLen, t);
        return;
    }
    for(i = 0; i < aLen; i++){
        carry = 0;
        aI = a[i];
        for(j = 0; j < bLen; j++){
            carry = add_20(add_20(mul_0(and_0(aI, $intern_69), and_0(b[j], $intern_69)), and_0(t[i + j], $intern_69)), and_0(toInt_0(carry), $intern_69));
            t[i + j] = toInt_0(carry);
            carry = shru_0(carry, 32);
        }
        t[i + bLen] = toInt_0(carry);
    }
}
function multiplyByInt(res, a, aSize, factor) {
    $clinit_Multiplication();
    var carry, i;
    carry = 0;
    for(i = 0; i < aSize; i++){
        carry = add_20(mul_0(and_0(a[i], $intern_69), and_0(factor, $intern_69)), and_0(toInt_0(carry), $intern_69));
        res[i] = toInt_0(carry);
        carry = shru_0(carry, 32);
    }
    return toInt_0(carry);
}
function multiplyPAP(a, b) {
    var aDigits, aLen, bDigits, bLen, resDigits, resLength, resSign, result, val, valueHi, valueLo;
    aLen = a.numberLength;
    bLen = b.numberLength;
    resLength = aLen + bLen;
    resSign = a.sign != b.sign ? -1 : 1;
    if (resLength == 2) {
        val = mul_0(and_0(a.digits[0], $intern_69), and_0(b.digits[0], $intern_69));
        valueLo = toInt_0(val);
        valueHi = toInt_0(shru_0(val, 32));
        return valueHi == 0 ? new BigInteger(resSign, valueLo) : new BigInteger_1(resSign, 2, stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
            valueLo,
            valueHi
        ]));
    }
    aDigits = a.digits;
    bDigits = b.digits;
    resDigits = initUnidimensionalArray(I_classLit, $intern_48, 30, resLength, 15, 1);
    multArraysPAP(aDigits, aLen, bDigits, bLen, resDigits);
    result = new BigInteger_1(resSign, resLength, resDigits);
    $cutOffLeadingZeroes(result);
    return result;
}
function pow_0(base, exponent) {
    $clinit_Multiplication();
    var acc, res;
    res = ($clinit_BigInteger(), ONE_0);
    acc = base;
    for(; exponent > 1; exponent >>= 1){
        (exponent & 1) != 0 && (res = $multiply(res, acc));
        acc.numberLength == 1 ? acc = $multiply(acc, acc) : acc = new BigInteger_2(square(acc.digits, acc.numberLength, initUnidimensionalArray(I_classLit, $intern_48, 30, acc.numberLength << 1, 15, 1)));
    }
    res = $multiply(res, acc);
    return res;
}
function powerOf10(exp_0) {
    $clinit_Multiplication();
    var intExp, longExp, powerOfFive, res;
    intExp = round_int(exp_0);
    if (exp_0 < bigTenPows.length) return bigTenPows[intExp];
    else if (exp_0 <= 50) return $pow(($clinit_BigInteger(), TEN), intExp);
    else if (exp_0 <= $intern_45) return $shiftLeft($pow(bigFivePows[1], intExp), intExp);
    if (exp_0 > 1000000) throw toJs(new ArithmeticException('power of ten too big'));
    if (exp_0 <= $intern_0) return $shiftLeft($pow(bigFivePows[1], intExp), intExp);
    powerOfFive = $pow(bigFivePows[1], $intern_0);
    res = powerOfFive;
    longExp = fromDouble_0(exp_0 - $intern_0);
    intExp = round_int(exp_0 % $intern_0);
    while(compare_2(longExp, $intern_0) > 0){
        res = $multiply(res, powerOfFive);
        longExp = sub_2(longExp, $intern_0);
    }
    res = $multiply(res, $pow(bigFivePows[1], intExp));
    res = $shiftLeft(res, $intern_0);
    longExp = fromDouble_0(exp_0 - $intern_0);
    while(compare_2(longExp, $intern_0) > 0){
        res = $shiftLeft(res, $intern_0);
        longExp = sub_2(longExp, $intern_0);
    }
    res = $shiftLeft(res, intExp);
    return res;
}
function square(a, aLen, res) {
    var carry, i, i0, index_0, j;
    for(i0 = 0; i0 < aLen; i0++){
        carry = 0;
        for(j = i0 + 1; j < aLen; j++){
            carry = add_20(add_20(mul_0(and_0(a[i0], $intern_69), and_0(a[j], $intern_69)), and_0(res[i0 + j], $intern_69)), and_0(toInt_0(carry), $intern_69));
            res[i0 + j] = toInt_0(carry);
            carry = shru_0(carry, 32);
        }
        res[i0 + aLen] = toInt_0(carry);
    }
    shiftLeftOneBit(res, res, aLen << 1);
    carry = 0;
    for(i = 0, index_0 = 0; i < aLen; ++i, index_0++){
        carry = add_20(add_20(mul_0(and_0(a[i], $intern_69), and_0(a[i], $intern_69)), and_0(res[index_0], $intern_69)), and_0(toInt_0(carry), $intern_69));
        res[index_0] = toInt_0(carry);
        carry = shru_0(carry, 32);
        ++index_0;
        carry = add_20(carry, and_0(res[index_0], $intern_69));
        res[index_0] = toInt_0(carry);
        carry = shru_0(carry, 32);
    }
    return res;
}
var bigFivePows, bigTenPows;
function $containsKey_3(this$static, key) {
    return instanceOfString(key) ? $hasStringValue(this$static, key) : !!$getEntry_0(this$static.hashCodeMap, key);
}
function $containsValue_2(this$static, value_0, entries) {
    var entry, entry$iterator;
    for(entry$iterator = entries.iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        if (this$static.equals_1(value_0, entry.getValue())) return true;
    }
    return false;
}
function $get_10(this$static, key) {
    return instanceOfString(key) ? $getStringValue(this$static, key) : getEntryValueOrNull($getEntry_0(this$static.hashCodeMap, key));
}
function $getStringValue(this$static, key) {
    return key == null ? getEntryValueOrNull($getEntry_0(this$static.hashCodeMap, null)) : $get_15(this$static.stringMap, key);
}
function $hasStringValue(this$static, key) {
    return key == null ? !!$getEntry_0(this$static.hashCodeMap, null) : $contains_7(this$static.stringMap, key);
}
function $put_6(this$static, key, value_0) {
    return instanceOfString(key) ? $putStringValue(this$static, key, value_0) : $put_9(this$static.hashCodeMap, key, value_0);
}
function $putStringValue(this$static, key, value_0) {
    return key == null ? $put_9(this$static.hashCodeMap, null, value_0) : $put_10(this$static.stringMap, key, value_0);
}
function $remove_6(this$static, key) {
    return instanceOfString(key) ? key == null ? $remove_19(this$static.hashCodeMap, null) : $remove_20(this$static.stringMap, key) : $remove_19(this$static.hashCodeMap, key);
}
function $reset(this$static) {
    this$static.hashCodeMap = new InternalHashCodeMap(this$static);
    this$static.stringMap = new InternalStringMap(this$static);
    ++this$static.modCount;
}
function $size_2(this$static) {
    return this$static.hashCodeMap.size_0 + this$static.stringMap.size_0;
}
function AbstractHashMap(ignored, alsoIgnored) {
    checkCriticalArgument_0(ignored >= 0, 'Negative initial capacity');
    checkCriticalArgument_0(alsoIgnored >= 0, 'Non-positive load factor');
    $reset(this);
}
defineClass(482, 2011, $intern_7);
_.clear_0 = function clear_30() {
    $reset(this);
};
_.containsKey = function containsKey_9(key) {
    return $containsKey_3(this, key);
};
_.containsValue = function containsValue_3(value_0) {
    return $containsValue_2(this, value_0, this.stringMap) || $containsValue_2(this, value_0, this.hashCodeMap);
};
_.entrySet_0 = function entrySet_2() {
    return new AbstractHashMap$EntrySet(this);
};
_.get_3 = function get_33(key) {
    return $get_10(this, key);
};
_.put = function put_5(key, value_0) {
    return $put_6(this, key, value_0);
};
_.remove_0 = function remove_48(key) {
    return $remove_6(this, key);
};
_.size_1 = function size_37() {
    return $size_2(this);
};
_.modCount = 0;
var Ljava_util_AbstractHashMap_2_classLit = createForClass('java.util', 'AbstractHashMap', 482);
function $contains_0(this$static, o) {
    if (instanceOf(o, 43)) return $containsEntry_0(this$static.this$01, castTo(o, 43));
    return false;
}
function AbstractHashMap$EntrySet(this$0) {
    this.this$01 = this$0;
}
defineClass(302, $intern_9, $intern_10, AbstractHashMap$EntrySet);
_.clear_0 = function clear_31() {
    this.this$01.clear_0();
};
_.contains = function contains_28(o) {
    return $contains_0(this, o);
};
_.iterator_0 = function iterator_46() {
    return new AbstractHashMap$EntrySetIterator(this.this$01);
};
_.remove_1 = function remove_49(entry) {
    var key;
    if ($contains_0(this, entry)) {
        key = castTo(entry, 43).getKey();
        this.this$01.remove_0(key);
        return true;
    }
    return false;
};
_.size_1 = function size_38() {
    return this.this$01.size_1();
};
var Ljava_util_AbstractHashMap$EntrySet_2_classLit = createForClass('java.util', 'AbstractHashMap/EntrySet', 302);
function $computeHasNext(this$static) {
    if (this$static.current.hasNext_0()) return true;
    if (this$static.current != this$static.stringMapEntries) return false;
    this$static.current = new InternalHashCodeMap$1(this$static.this$01.hashCodeMap);
    return this$static.current.hasNext_0();
}
function $next_3(this$static) {
    var rv;
    checkCriticalConcurrentModification(this$static.this$01.modCount, this$static.lastModCount);
    checkCriticalElement(this$static.hasNext);
    this$static.last = this$static.current;
    rv = castTo(this$static.current.next_1(), 43);
    this$static.hasNext = $computeHasNext(this$static);
    return rv;
}
function $remove_7(this$static) {
    checkCriticalState(!!this$static.last);
    checkCriticalConcurrentModification(this$static.this$01.modCount, this$static.lastModCount);
    this$static.last.remove();
    this$static.last = null;
    this$static.hasNext = $computeHasNext(this$static);
    this$static.lastModCount = this$static.this$01.modCount;
}
function AbstractHashMap$EntrySetIterator(this$0) {
    this.this$01 = this$0;
    this.stringMapEntries = new InternalStringMap$1(this.this$01.stringMap);
    this.current = this.stringMapEntries;
    this.hasNext = $computeHasNext(this);
    this.lastModCount = this.this$01.modCount;
}
defineClass(303, 1, $intern_6, AbstractHashMap$EntrySetIterator);
_.forEachRemaining = function forEachRemaining_16(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_19() {
    return $next_3(this);
};
_.hasNext_0 = function hasNext_18() {
    return this.hasNext;
};
_.remove = function remove_50() {
    $remove_7(this);
};
_.hasNext = false;
_.lastModCount = 0;
var Ljava_util_AbstractHashMap$EntrySetIterator_2_classLit = createForClass('java.util', 'AbstractHashMap/EntrySetIterator', 303);
function $hasNext_2(this$static) {
    return this$static.i < this$static.this$01_0.size_1();
}
function $next_4(this$static) {
    checkCriticalElement(this$static.i < this$static.this$01_0.size_1());
    return this$static.this$01_0.get_0(this$static.last = this$static.i++);
}
function $remove_8(this$static) {
    checkCriticalState(this$static.last != -1);
    this$static.this$01_0.remove_2(this$static.last);
    this$static.i = this$static.last;
    this$static.last = -1;
}
function AbstractList$IteratorImpl(this$0) {
    this.this$01_0 = this$0;
}
defineClass(414, 1, $intern_6, AbstractList$IteratorImpl);
_.forEachRemaining = function forEachRemaining_17(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_19() {
    return $hasNext_2(this);
};
_.next_1 = function next_20() {
    return $next_4(this);
};
_.remove = function remove_51() {
    $remove_8(this);
};
_.i = 0;
_.last = -1;
var Ljava_util_AbstractList$IteratorImpl_2_classLit = createForClass('java.util', 'AbstractList/IteratorImpl', 414);
function $add_1(this$static, o) {
    this$static.this$01.add_3(this$static.i, o);
    ++this$static.i;
    this$static.last = -1;
}
function AbstractList$ListIteratorImpl(this$0, start_0) {
    this.this$01 = this$0;
    AbstractList$IteratorImpl.call(this, this$0);
    checkCriticalPositionIndex(start_0, this$0.size_1());
    this.i = start_0;
}
defineClass(95, 414, $intern_14, AbstractList$ListIteratorImpl);
_.remove = function remove_52() {
    $remove_8(this);
};
_.add_1 = function add_24(o) {
    $add_1(this, o);
};
_.hasPrevious = function hasPrevious_3() {
    return this.i > 0;
};
_.nextIndex_0 = function nextIndex_4() {
    return this.i;
};
_.previous_0 = function previous_4() {
    return checkCriticalElement(this.i > 0), this.this$01.get_0(this.last = --this.i);
};
_.previousIndex = function previousIndex_3() {
    return this.i - 1;
};
_.set_1 = function set_11(o) {
    checkCriticalState(this.last != -1);
    this.this$01.set_2(this.last, o);
};
var Ljava_util_AbstractList$ListIteratorImpl_2_classLit = createForClass('java.util', 'AbstractList/ListIteratorImpl', 95);
function AbstractList$SubList(wrapped, fromIndex, toIndex) {
    checkCriticalPositionIndexes(fromIndex, toIndex, wrapped.size_1());
    this.wrapped = wrapped;
    this.fromIndex = fromIndex;
    this.size_0 = toIndex - fromIndex;
}
defineClass(256, 55, $intern_37, AbstractList$SubList);
_.add_3 = function add_25(index_0, element) {
    checkCriticalPositionIndex(index_0, this.size_0);
    this.wrapped.add_3(this.fromIndex + index_0, element);
    ++this.size_0;
};
_.get_0 = function get_34(index_0) {
    checkCriticalElementIndex(index_0, this.size_0);
    return this.wrapped.get_0(this.fromIndex + index_0);
};
_.remove_2 = function remove_53(index_0) {
    var result;
    checkCriticalElementIndex(index_0, this.size_0);
    result = this.wrapped.remove_2(this.fromIndex + index_0);
    --this.size_0;
    return result;
};
_.set_2 = function set_12(index_0, element) {
    checkCriticalElementIndex(index_0, this.size_0);
    return this.wrapped.set_2(this.fromIndex + index_0, element);
};
_.size_1 = function size_39() {
    return this.size_0;
};
_.fromIndex = 0;
_.size_0 = 0;
var Ljava_util_AbstractList$SubList_2_classLit = createForClass('java.util', 'AbstractList/SubList', 256);
function AbstractMap$1(this$0) {
    this.this$01 = this$0;
}
defineClass(257, $intern_9, $intern_10, AbstractMap$1);
_.clear_0 = function clear_32() {
    this.this$01.clear_0();
};
_.contains = function contains_29(key) {
    return this.this$01.containsKey(key);
};
_.iterator_0 = function iterator_47() {
    var outerIter;
    return outerIter = this.this$01.entrySet_0().iterator_0(), new AbstractMap$1$1(outerIter);
};
_.remove_1 = function remove_54(key) {
    if (this.this$01.containsKey(key)) {
        this.this$01.remove_0(key);
        return true;
    }
    return false;
};
_.size_1 = function size_40() {
    return this.this$01.size_1();
};
var Ljava_util_AbstractMap$1_2_classLit = createForClass('java.util', 'AbstractMap/1', 257);
function AbstractMap$1$1(val$outerIter) {
    this.val$outerIter2 = val$outerIter;
}
defineClass(526, 1, $intern_6, AbstractMap$1$1);
_.forEachRemaining = function forEachRemaining_18(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_20() {
    return this.val$outerIter2.hasNext_0();
};
_.next_1 = function next_21() {
    var entry;
    return entry = castTo(this.val$outerIter2.next_1(), 43), entry.getKey();
};
_.remove = function remove_55() {
    this.val$outerIter2.remove();
};
var Ljava_util_AbstractMap$1$1_2_classLit = createForClass('java.util', 'AbstractMap/1/1', 526);
function AbstractMap$2(this$0) {
    this.this$01 = this$0;
}
defineClass(230, 31, $intern_8, AbstractMap$2);
_.clear_0 = function clear_33() {
    this.this$01.clear_0();
};
_.contains = function contains_30(value_0) {
    return this.this$01.containsValue(value_0);
};
_.iterator_0 = function iterator_48() {
    var outerIter;
    return outerIter = this.this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter);
};
_.size_1 = function size_41() {
    return this.this$01.size_1();
};
var Ljava_util_AbstractMap$2_2_classLit = createForClass('java.util', 'AbstractMap/2', 230);
function AbstractMap$2$1(val$outerIter) {
    this.val$outerIter2 = val$outerIter;
}
defineClass(300, 1, $intern_6, AbstractMap$2$1);
_.forEachRemaining = function forEachRemaining_19(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_21() {
    return this.val$outerIter2.hasNext_0();
};
_.next_1 = function next_22() {
    var entry;
    return entry = castTo(this.val$outerIter2.next_1(), 43), entry.getValue();
};
_.remove = function remove_56() {
    this.val$outerIter2.remove();
};
var Ljava_util_AbstractMap$2$1_2_classLit = createForClass('java.util', 'AbstractMap/2/1', 300);
function $setValue_0(this$static, value_0) {
    var oldValue;
    oldValue = this$static.value_0;
    this$static.value_0 = value_0;
    return oldValue;
}
defineClass(478, 1, {
    478: 1,
    43: 1
});
_.equals_0 = function equals_44(other) {
    var entry;
    if (!instanceOf(other, 43)) return false;
    entry = castTo(other, 43);
    return equals_57(this.key, entry.getKey()) && equals_57(this.value_0, entry.getValue());
};
_.getKey = function getKey_4() {
    return this.key;
};
_.getValue = function getValue_6() {
    return this.value_0;
};
_.hashCode_1 = function hashCode_45() {
    return hashCode_55(this.key) ^ hashCode_55(this.value_0);
};
_.setValue = function setValue_7(value_0) {
    return $setValue_0(this, value_0);
};
_.toString_0 = function toString_52() {
    return this.key + '=' + this.value_0;
};
var Ljava_util_AbstractMap$AbstractEntry_2_classLit = createForClass('java.util', 'AbstractMap/AbstractEntry', 478);
function AbstractMap$SimpleEntry(key, value_0) {
    this.key = key;
    this.value_0 = value_0;
}
defineClass(388, 478, {
    478: 1,
    388: 1,
    43: 1
}, AbstractMap$SimpleEntry);
var Ljava_util_AbstractMap$SimpleEntry_2_classLit = createForClass('java.util', 'AbstractMap/SimpleEntry', 388);
defineClass(2028, 1, $intern_70);
_.equals_0 = function equals_45(other) {
    var entry;
    if (!instanceOf(other, 43)) return false;
    entry = castTo(other, 43);
    return equals_57(this.getKey(), entry.getKey()) && equals_57(this.getValue(), entry.getValue());
};
_.hashCode_1 = function hashCode_46() {
    return hashCode_55(this.getKey()) ^ hashCode_55(this.getValue());
};
_.toString_0 = function toString_53() {
    return this.getKey() + '=' + this.getValue();
};
var Ljava_util_AbstractMapEntry_2_classLit = createForClass('java.util', 'AbstractMapEntry', 2028);
function $containsEntry_1(this$static, entry) {
    var key, lookupEntry;
    key = entry.getKey();
    lookupEntry = this$static.getEntry(key);
    return !!lookupEntry && equals_57(lookupEntry.value_0, entry.getValue());
}
function $containsKey_4(this$static, k) {
    var key;
    key = k;
    return !!this$static.getEntry(key);
}
function getKeyOrNSE(entry) {
    if (!entry) throw toJs(new NoSuchElementException);
    return entry.key;
}
defineClass(2036, 2011, $intern_11);
_.ceilingKey = function ceilingKey_0(key) {
    return getEntryKeyOrNull(this.getCeilingEntry(key));
};
_.containsEntry = function containsEntry_0(entry) {
    return $containsEntry_1(this, entry);
};
_.containsKey = function containsKey_10(k) {
    return $containsKey_4(this, k);
};
_.entrySet_0 = function entrySet_3() {
    return new AbstractNavigableMap$EntrySet(this);
};
_.firstKey = function firstKey_0() {
    return getKeyOrNSE(this.getFirstEntry());
};
_.floorKey = function floorKey_0(key) {
    return getEntryKeyOrNull(this.getFloorEntry(key));
};
_.get_3 = function get_35(k) {
    var key;
    key = k;
    return getEntryValueOrNull(this.getEntry(key));
};
_.higherKey = function higherKey_0(key) {
    return getEntryKeyOrNull(this.getHigherEntry(key));
};
_.keySet_0 = function keySet_16() {
    return new AbstractNavigableMap$NavigableKeySet(this);
};
_.lastKey = function lastKey_0() {
    return getKeyOrNSE(this.getLastEntry());
};
_.lowerKey = function lowerKey_0(key) {
    return getEntryKeyOrNull(this.getLowerEntry(key));
};
var Ljava_util_AbstractNavigableMap_2_classLit = createForClass('java.util', 'AbstractNavigableMap', 2036);
function AbstractNavigableMap$EntrySet(this$0) {
    this.this$01_0 = this$0;
}
defineClass(614, $intern_9, $intern_10, AbstractNavigableMap$EntrySet);
_.contains = function contains_31(o) {
    return instanceOf(o, 43) && $containsEntry_1(this.this$01_0, castTo(o, 43));
};
_.iterator_0 = function iterator_49() {
    return this.this$01_0.entryIterator_0();
};
_.remove_1 = function remove_57(o) {
    var entry;
    if (instanceOf(o, 43)) {
        entry = castTo(o, 43);
        return this.this$01_0.removeEntry(entry);
    }
    return false;
};
_.size_1 = function size_42() {
    return this.this$01_0.size_1();
};
var Ljava_util_AbstractNavigableMap$EntrySet_2_classLit = createForClass('java.util', 'AbstractNavigableMap/EntrySet', 614);
function AbstractNavigableMap$NavigableKeySet(map_0) {
    this.map_0 = map_0;
}
defineClass(1110, $intern_9, $intern_13, AbstractNavigableMap$NavigableKeySet);
_.spliterator_0 = function spliterator_26() {
    return new SortedSet$1(this);
};
_.clear_0 = function clear_34() {
    this.map_0.clear_0();
};
_.contains = function contains_32(o) {
    return $containsKey_4(this.map_0, o);
};
_.iterator_0 = function iterator_50() {
    var entryIterator;
    entryIterator = this.map_0.entrySet_0().this$01_0.entryIterator_0();
    return new AbstractNavigableMap$NavigableKeySet$1(entryIterator);
};
_.remove_1 = function remove_58(o) {
    if ($containsKey_4(this.map_0, o)) {
        this.map_0.remove_0(o);
        return true;
    }
    return false;
};
_.size_1 = function size_43() {
    return this.map_0.size_1();
};
var Ljava_util_AbstractNavigableMap$NavigableKeySet_2_classLit = createForClass('java.util', 'AbstractNavigableMap/NavigableKeySet', 1110);
function AbstractNavigableMap$NavigableKeySet$1(val$entryIterator) {
    this.val$entryIterator2 = val$entryIterator;
}
defineClass(1111, 1, $intern_6, AbstractNavigableMap$NavigableKeySet$1);
_.forEachRemaining = function forEachRemaining_20(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_22() {
    return $hasNext_2(this.val$entryIterator2.iter);
};
_.next_1 = function next_23() {
    var entry;
    entry = $next_10(this.val$entryIterator2);
    return entry.getKey();
};
_.remove = function remove_59() {
    $remove_27(this.val$entryIterator2);
};
var Ljava_util_AbstractNavigableMap$NavigableKeySet$1_2_classLit = createForClass('java.util', 'AbstractNavigableMap/NavigableKeySet/1', 1111);
defineClass(2049, 31, $intern_8);
_.add_2 = function add_26(o) {
    return checkCriticalState_0($offer(this, o), 'Unable to add element to queue'), true;
};
_.addAll = function addAll_12(c) {
    checkCriticalNotNull(c);
    checkCriticalArgument_0(c != this, "Can't add a queue to itself");
    return $addAll(this, c);
};
_.clear_0 = function clear_35() {
    while($poll_0(this) != null);
};
var Ljava_util_AbstractQueue_2_classLit = createForClass('java.util', 'AbstractQueue', 2049);
function $addFirst(this$static, e) {
    checkCriticalNotNull(e);
    this$static.head = this$static.head - 1 & this$static.array.length - 1;
    setCheck(this$static.array, this$static.head, e);
    $ensureCapacity(this$static);
}
function $addLast(this$static, e) {
    checkCriticalNotNull(e);
    setCheck(this$static.array, this$static.tail, e);
    this$static.tail = this$static.tail + 1 & this$static.array.length - 1;
    $ensureCapacity(this$static);
}
function $clear_4(this$static) {
    if (this$static.head == this$static.tail) return;
    this$static.array = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 8, 5, 1);
    this$static.head = 0;
    this$static.tail = 0;
}
function $contains_1(it, o) {
    if (o == null) return false;
    while(it.currentIndex != it.fence){
        if (equals_Ljava_lang_Object__Z__devirtual$(o, $next_5(it))) return true;
    }
    return false;
}
function $copyElements(this$static, dest, count) {
    var dstIdx, i, mask;
    mask = this$static.array.length - 1;
    for(i = this$static.head, dstIdx = 0; dstIdx < count; i = i + 1 & mask, ++dstIdx)setCheck(dest, dstIdx, this$static.array[i]);
}
function $ensureCapacity(this$static) {
    var newArray, newLength, numElements;
    if (this$static.head != this$static.tail) return;
    numElements = this$static.array.length;
    newLength = highestOneBit($wnd.Math.max(8, numElements)) << 1;
    if (this$static.head != 0) {
        newArray = createFrom(this$static.array, newLength);
        $copyElements(this$static, newArray, numElements);
        this$static.array = newArray;
        this$static.head = 0;
    } else setLength(this$static.array, newLength);
    this$static.tail = numElements;
}
function $isEmpty(this$static) {
    return this$static.head == this$static.tail;
}
function $pollFirst(this$static) {
    var e;
    e = this$static.array[this$static.head];
    if (e == null) return null;
    setCheck(this$static.array, this$static.head, null);
    this$static.head = this$static.head + 1 & this$static.array.length - 1;
    return e;
}
function $pollLast(this$static) {
    var e;
    e = this$static.array[this$static.tail - 1 & this$static.array.length - 1];
    if (e == null) return null;
    this$static.tail = this$static.tail - 1 & this$static.array.length - 1;
    setCheck(this$static.array, this$static.tail, null);
    return e;
}
function $remove_9(it, o) {
    if ($contains_1(it, o)) {
        $remove_10(it);
        return true;
    }
    return false;
}
function $removeAtIndex(this$static, i) {
    var headDistance, mask, size_0, tailDistance;
    mask = this$static.array.length - 1;
    headDistance = i - this$static.head & mask;
    tailDistance = this$static.tail - i & mask;
    size_0 = this$static.tail - this$static.head & mask;
    checkConcurrentModification(headDistance < size_0);
    if (headDistance >= tailDistance) {
        $shiftLeftAtIndex(this$static, i);
        return -1;
    } else {
        $shiftRightAtIndex(this$static, i);
        return 1;
    }
}
function $removeFirst(this$static) {
    var e;
    e = $pollFirst(this$static);
    checkCriticalElement(e != null);
    return e;
}
function $removeLast(this$static) {
    var e;
    e = $pollLast(this$static);
    checkCriticalElement(e != null);
    return e;
}
function $shiftLeftAtIndex(this$static, i) {
    var mask, nextOffset;
    mask = this$static.array.length - 1;
    this$static.tail = this$static.tail - 1 & mask;
    while(i != this$static.tail){
        nextOffset = i + 1 & mask;
        setCheck(this$static.array, i, this$static.array[nextOffset]);
        i = nextOffset;
    }
    setCheck(this$static.array, this$static.tail, null);
}
function $shiftRightAtIndex(this$static, i) {
    var mask, prevOffset;
    mask = this$static.array.length - 1;
    while(i != this$static.head){
        prevOffset = i - 1 & mask;
        setCheck(this$static.array, i, this$static.array[prevOffset]);
        i = prevOffset;
    }
    setCheck(this$static.array, this$static.head, null);
    this$static.head = this$static.head + 1 & mask;
}
function ArrayDeque() {
    this.array = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 8, 5, 1);
}
function ArrayDeque_0(numElements) {
    this.array = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, highestOneBit($wnd.Math.max(8, numElements)) << 1, 5, 1);
}
function checkConcurrentModification(expression) {
    if (!expression) throw toJs(new ConcurrentModificationException);
}
defineClass(311, 31, {
    4: 1,
    20: 1,
    31: 1,
    16: 1
}, ArrayDeque, ArrayDeque_0);
_.add_2 = function add_27(e) {
    return $addLast(this, e), true;
};
_.clear_0 = function clear_36() {
    $clear_4(this);
};
_.contains = function contains_33(o) {
    return $contains_1(new ArrayDeque$IteratorImpl(this), o);
};
_.isEmpty = function isEmpty_18() {
    return $isEmpty(this);
};
_.iterator_0 = function iterator_51() {
    return new ArrayDeque$IteratorImpl(this);
};
_.remove_1 = function remove_60(o) {
    return $remove_9(new ArrayDeque$IteratorImpl(this), o);
};
_.size_1 = function size_44() {
    return this.tail - this.head & this.array.length - 1;
};
_.spliterator_0 = function spliterator_27() {
    return new Spliterators$IteratorSpliterator(this, 272);
};
_.toArray_0 = function toArray_10(out) {
    var size_0;
    size_0 = this.tail - this.head & this.array.length - 1;
    out.length < size_0 && (out = stampJavaTypeInfo_1(new Array(size_0), out));
    $copyElements(this, out, size_0);
    out.length > size_0 && setCheck(out, size_0, null);
    return out;
};
_.head = 0;
_.tail = 0;
var Ljava_util_ArrayDeque_2_classLit = createForClass('java.util', 'ArrayDeque', 311);
function $next_5(this$static) {
    var e;
    checkCriticalElement(this$static.currentIndex != this$static.fence);
    e = this$static.this$01.array[this$static.currentIndex];
    checkConcurrentModification(this$static.fence == this$static.this$01.tail && e != null);
    this$static.lastIndex = this$static.currentIndex;
    this$static.currentIndex = this$static.currentIndex + 1 & this$static.this$01.array.length - 1;
    return e;
}
function $remove_10(this$static) {
    checkCriticalState(this$static.lastIndex >= 0);
    if ($removeAtIndex(this$static.this$01, this$static.lastIndex) < 0) {
        this$static.currentIndex = this$static.currentIndex - 1 & this$static.this$01.array.length - 1;
        this$static.fence = this$static.this$01.tail;
    }
    this$static.lastIndex = -1;
}
function ArrayDeque$IteratorImpl(this$0) {
    this.this$01 = this$0;
    this.currentIndex = this.this$01.head;
    this.fence = this.this$01.tail;
}
defineClass(445, 1, $intern_6, ArrayDeque$IteratorImpl);
_.forEachRemaining = function forEachRemaining_21(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_23() {
    return this.currentIndex != this.fence;
};
_.next_1 = function next_24() {
    return $next_5(this);
};
_.remove = function remove_61() {
    $remove_10(this);
};
_.currentIndex = 0;
_.fence = 0;
_.lastIndex = -1;
var Ljava_util_ArrayDeque$IteratorImpl_2_classLit = createForClass('java.util', 'ArrayDeque/IteratorImpl', 445);
function $$init_1(this$static) {
    this$static.array = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1);
}
function $add_2(this$static, index_0, o) {
    checkCriticalPositionIndex(index_0, this$static.array.length);
    insertTo(this$static.array, index_0, o);
}
function $add_3(this$static, o) {
    push_1(this$static.array, o);
    return true;
}
function $addAll_1(this$static, index_0, c) {
    var cArray, len;
    checkCriticalPositionIndex(index_0, this$static.array.length);
    cArray = c.toArray();
    len = cArray.length;
    if (len == 0) return false;
    insertTo_0(this$static.array, index_0, cArray);
    return true;
}
function $addAll_2(this$static, c) {
    var cArray, len;
    cArray = c.toArray();
    len = cArray.length;
    if (len == 0) return false;
    insertTo_0(this$static.array, this$static.array.length, cArray);
    return true;
}
function $forEach_1(this$static, consumer) {
    var e, e$array, e$index, e$max;
    checkCriticalNotNull(consumer);
    for(e$array = this$static.array, e$index = 0, e$max = e$array.length; e$index < e$max; ++e$index){
        e = e$array[e$index];
        consumer.accept(e);
    }
}
function $get_11(this$static, index_0) {
    checkCriticalElementIndex(index_0, this$static.array.length);
    return this$static.array[index_0];
}
function $indexOf_3(this$static, o, index_0) {
    for(; index_0 < this$static.array.length; ++index_0){
        if (equals_57(o, this$static.array[index_0])) return index_0;
    }
    return -1;
}
function $remove_11(this$static, index_0) {
    var previous;
    previous = (checkCriticalElementIndex(index_0, this$static.array.length), this$static.array[index_0]);
    removeFrom(this$static.array, index_0, 1);
    return previous;
}
function $remove_12(this$static, o) {
    var i;
    i = $indexOf_3(this$static, o, 0);
    if (i == -1) return false;
    $remove_11(this$static, i);
    return true;
}
function $removeRange(this$static, fromIndex, endIndex) {
    var count;
    checkCriticalPositionIndexes(fromIndex, endIndex, this$static.array.length);
    count = endIndex - fromIndex;
    removeFrom(this$static.array, fromIndex, count);
}
function $set_1(this$static, index_0, o) {
    var previous;
    previous = (checkCriticalElementIndex(index_0, this$static.array.length), this$static.array[index_0]);
    this$static.array[index_0] = o;
    return previous;
}
function $sort(this$static, c) {
    sort_4(this$static.array, this$static.array.length, c);
}
function $toArray_1(this$static, out) {
    var i, size_0;
    size_0 = this$static.array.length;
    out.length < size_0 && (out = stampJavaTypeInfo_1(new Array(size_0), out));
    for(i = 0; i < size_0; ++i)setCheck(out, i, this$static.array[i]);
    out.length > size_0 && setCheck(out, size_0, null);
    return out;
}
function ArrayList() {
    $$init_1(this);
}
function ArrayList_0(initialCapacity) {
    $$init_1(this);
    checkCriticalArgument_0(initialCapacity >= 0, 'Initial capacity must not be negative');
}
function ArrayList_1(c) {
    $$init_1(this);
    insertTo_0(this.array, 0, c.toArray());
}
defineClass(13, 55, $intern_71, ArrayList, ArrayList_0, ArrayList_1);
_.add_3 = function add_28(index_0, o) {
    $add_2(this, index_0, o);
};
_.add_2 = function add_29(o) {
    return $add_3(this, o);
};
_.addAll_0 = function addAll_13(index_0, c) {
    return $addAll_1(this, index_0, c);
};
_.addAll = function addAll_14(c) {
    return $addAll_2(this, c);
};
_.clear_0 = function clear_37() {
    setLength(this.array, 0);
};
_.contains = function contains_34(o) {
    return $indexOf_3(this, o, 0) != -1;
};
_.forEach_0 = function forEach_17(consumer) {
    $forEach_1(this, consumer);
};
_.get_0 = function get_36(index_0) {
    return $get_11(this, index_0);
};
_.indexOf_0 = function indexOf_4(o) {
    return $indexOf_3(this, o, 0);
};
_.isEmpty = function isEmpty_19() {
    return this.array.length == 0;
};
_.iterator_0 = function iterator_52() {
    return new ArrayList$1(this);
};
_.remove_2 = function remove_62(index_0) {
    return $remove_11(this, index_0);
};
_.remove_1 = function remove_63(o) {
    return $remove_12(this, o);
};
_.removeRange = function removeRange_1(fromIndex, endIndex) {
    $removeRange(this, fromIndex, endIndex);
};
_.set_2 = function set_13(index_0, o) {
    return $set_1(this, index_0, o);
};
_.size_1 = function size_45() {
    return this.array.length;
};
_.sort_0 = function sort_3(c) {
    $sort(this, c);
};
_.toArray = function toArray_11() {
    return clone_0(this.array);
};
_.toArray_0 = function toArray_12(out) {
    return $toArray_1(this, out);
};
var Ljava_util_ArrayList_2_classLit = createForClass('java.util', 'ArrayList', 13);
function $hasNext_3(this$static) {
    return this$static.i < this$static.this$01.array.length;
}
function $next_6(this$static) {
    checkCriticalElement(this$static.i < this$static.this$01.array.length);
    this$static.last = this$static.i++;
    return this$static.this$01.array[this$static.last];
}
function $remove_13(this$static) {
    checkCriticalState(this$static.last != -1);
    $remove_11(this$static.this$01, this$static.i = this$static.last);
    this$static.last = -1;
}
function ArrayList$1(this$0) {
    this.this$01 = this$0;
}
defineClass(7, 1, $intern_6, ArrayList$1);
_.forEachRemaining = function forEachRemaining_22(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_24() {
    return $hasNext_3(this);
};
_.next_1 = function next_25() {
    return $next_6(this);
};
_.remove = function remove_64() {
    $remove_13(this);
};
_.i = 0;
_.last = -1;
var Ljava_util_ArrayList$1_2_classLit = createForClass('java.util', 'ArrayList/1', 7);
function copyOf(original, newLength) {
    checkCriticalArraySize(newLength);
    return copyPrimitiveArray(original, initUnidimensionalArray(I_classLit, $intern_48, 30, newLength, 15, 1), newLength);
}
function copyOf_0(original, newLength) {
    var result;
    checkCriticalArraySize(newLength);
    return result = original.slice(0, newLength), result.length = newLength, stampJavaTypeInfo_0(result, original);
}
function copyPrimitiveArray(original, copy, to) {
    var copyLen, len;
    len = original.length;
    copyLen = $wnd.Math.min(to, len);
    copy_0(original, 0, copy, 0, copyLen, true);
    return copy;
}
function deepToString(a, arraysIveSeen) {
    var joiner, obj, obj$array, obj$index, obj$max, objArray, old, tempSet, elementTypeCategory;
    if (a == null) return 'null';
    old = arraysIveSeen.map_0.put(a, arraysIveSeen);
    if (old != null) return '[...]';
    joiner = new StringJoiner(', ', '[', ']');
    for(obj$array = a, obj$index = 0, obj$max = obj$array.length; obj$index < obj$max; ++obj$index){
        obj = obj$array[obj$index];
        if (obj != null && (getClass__Ljava_lang_Class___devirtual$(obj).modifiers & 4) != 0) {
            if (Array.isArray(obj) && (elementTypeCategory = getElementTypeCategory(obj), !(elementTypeCategory >= 14 && elementTypeCategory <= 16))) {
                if (arraysIveSeen.map_0.containsKey(obj)) {
                    !joiner.builder ? joiner.builder = new StringBuilder_1(joiner.prefix) : $append_11(joiner.builder, joiner.delimiter);
                    $append_8(joiner.builder, '[...]');
                } else {
                    objArray = castToArray(obj);
                    tempSet = new HashSet_1(arraysIveSeen);
                    $add_9(joiner, deepToString(objArray, tempSet));
                }
            } else instanceOf(obj, 183) ? $add_9(joiner, toString_61(castTo(obj, 183))) : instanceOf(obj, 195) ? $add_9(joiner, toString_54(castTo(obj, 195))) : instanceOf(obj, 201) ? $add_9(joiner, toString_55(castTo(obj, 201))) : instanceOf(obj, 2057) ? $add_9(joiner, toString_60(castTo(obj, 2057))) : instanceOf(obj, 54) ? $add_9(joiner, toString_58(castTo(obj, 54))) : instanceOf(obj, 579) ? $add_9(joiner, toString_59(castTo(obj, 579))) : instanceOf(obj, 825) ? $add_9(joiner, toString_57(castTo(obj, 825))) : instanceOf(obj, 108) && $add_9(joiner, toString_56(castTo(obj, 108)));
        } else $add_9(joiner, obj == null ? 'null' : toString_40(obj));
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function equals_46(array1, array2) {
    var i, val1, val2;
    if (maskUndefined(array1) === maskUndefined(array2)) return true;
    if (array1 == null || array2 == null) return false;
    if (array1.length != array2.length) return false;
    for(i = 0; i < array1.length; ++i){
        val1 = array1[i];
        val2 = array2[i];
        if (!(maskUndefined(val1) === maskUndefined(val2) || val1 != null && equals_Ljava_lang_Object__Z__devirtual$(val1, val2))) return false;
    }
    return true;
}
function fill(a, fromIndex, toIndex, val) {
    checkCriticalArrayBounds_0(fromIndex, toIndex, a.length);
    fill0(a, fromIndex, toIndex, val);
}
function fill_0(a, val) {
    fill0_0(a, a.length, val);
}
function fill_1(a, val) {
    fill0_2(a, a.length, val);
}
function fill_2(a) {
    fill0_3(a, a.length);
}
function fill0(a, fromIndex, toIndex, val) {
    var i;
    for(i = fromIndex; i < toIndex; ++i)a[i] = val;
}
function fill0_0(a, toIndex, val) {
    var i;
    for(i = 0; i < toIndex; ++i)a[i] = val;
}
function fill0_1(a, toIndex) {
    var i;
    for(i = 0; i < toIndex; ++i)a[i] = -1;
}
function fill0_2(a, toIndex, val) {
    var i;
    for(i = 0; i < toIndex; ++i)setCheck(a, i, val);
}
function fill0_3(a, toIndex) {
    var i;
    for(i = 0; i < toIndex; ++i)a[i] = false;
}
function hashCode_47(a) {
    var e, e$array, e$index, e$max, hashCode;
    hashCode = 1;
    for(e$array = a, e$index = 0, e$max = e$array.length; e$index < e$max; ++e$index){
        e = e$array[e$index];
        hashCode = 31 * hashCode + (e != null ? hashCode__I__devirtual$(e) : 0);
        hashCode = hashCode | 0;
    }
    return hashCode;
}
function insertionSort(array, low, high, comp) {
    var i, j, t;
    for(i = low + 1; i < high; ++i)for(j = i; j > low && comp.compare_1(array[j - 1], array[j]) > 0; --j){
        t = array[j];
        setCheck(array, j, array[j - 1]);
        setCheck(array, j - 1, t);
    }
}
function merge(src_0, srcLow, srcMid, srcHigh, dest, destLow, destHigh, comp) {
    var topIdx;
    topIdx = srcMid;
    while(destLow < destHigh)topIdx >= srcHigh || srcLow < srcMid && comp.compare_1(src_0[srcLow], src_0[topIdx]) <= 0 ? setCheck(dest, destLow++, src_0[srcLow++]) : setCheck(dest, destLow++, src_0[topIdx++]);
}
function mergeSort(x_0, fromIndex, toIndex, comp) {
    var temp;
    comp = ($clinit_Comparators(), !comp ? INTERNAL_NATURAL_ORDER : comp);
    temp = x_0.slice(fromIndex, toIndex);
    mergeSort_0(temp, x_0, fromIndex, toIndex, -fromIndex, comp);
}
function mergeSort_0(temp, array, low, high, ofs, comp) {
    var length_0, tempHigh, tempLow, tempMid;
    length_0 = high - low;
    if (length_0 < 7) {
        insertionSort(array, low, high, comp);
        return;
    }
    tempLow = low + ofs;
    tempHigh = high + ofs;
    tempMid = tempLow + (tempHigh - tempLow >> 1);
    mergeSort_0(array, temp, tempLow, tempMid, -ofs, comp);
    mergeSort_0(array, temp, tempMid, tempHigh, -ofs, comp);
    if (comp.compare_1(temp[tempMid - 1], temp[tempMid]) <= 0) {
        while(low < high)setCheck(array, low++, temp[tempLow++]);
        return;
    }
    merge(temp, tempLow, tempMid, tempHigh, array, low, high, comp);
}
function sort_4(x_0, toIndex, c) {
    checkCriticalArrayBounds_0(0, toIndex, x_0.length);
    mergeSort(x_0, 0, toIndex, c);
}
function sort_5(x_0, c) {
    mergeSort(x_0, 0, x_0.length, c);
}
function spliterator_28(array, endExclusive) {
    return checkCriticalArrayBounds(endExclusive, array.length), new Spliterators$ArraySpliterator(array, endExclusive);
}
function stream_4(array) {
    return new StreamImpl(null, spliterator_28(array, array.length));
}
function toString_54(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        $add_9(joiner, '' + element);
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_55(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        $add_9(joiner, String.fromCharCode(element));
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_56(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        !joiner.builder ? joiner.builder = new StringBuilder_1(joiner.prefix) : $append_11(joiner.builder, joiner.delimiter);
        $append_8(joiner.builder, '' + element);
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_57(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        !joiner.builder ? joiner.builder = new StringBuilder_1(joiner.prefix) : $append_11(joiner.builder, joiner.delimiter);
        $append_8(joiner.builder, '' + element);
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_58(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        !joiner.builder ? joiner.builder = new StringBuilder_1(joiner.prefix) : $append_11(joiner.builder, joiner.delimiter);
        $append_8(joiner.builder, '' + element);
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_59(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        !joiner.builder ? joiner.builder = new StringBuilder_1(joiner.prefix) : $append_11(joiner.builder, joiner.delimiter);
        $append_8(joiner.builder, '' + toString_39(element));
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_60(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        $add_9(joiner, '' + element);
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function toString_61(a) {
    var element, element$array, element$index, element$max, joiner;
    if (a == null) return 'null';
    joiner = new StringJoiner(', ', '[', ']');
    for(element$array = a, element$index = 0, element$max = element$array.length; element$index < element$max; ++element$index){
        element = element$array[element$index];
        !joiner.builder ? joiner.builder = new StringBuilder_1(joiner.prefix) : $append_11(joiner.builder, joiner.delimiter);
        $append_8(joiner.builder, '' + element);
    }
    return !joiner.builder ? joiner.emptyValue : joiner.suffix.length == 0 ? joiner.builder.string : joiner.builder.string + ('' + joiner.suffix);
}
function Arrays$0methodref$compare$Type() {}
defineClass(2058, $wnd.Function, {}, Arrays$0methodref$compare$Type);
_.compare_0 = function compare_7(d1, d2) {
    return compare_4(d1, d2);
};
function $get_12(this$static, index_0) {
    checkCriticalElementIndex(index_0, this$static.array.length);
    return this$static.array[index_0];
}
function $toArray_2(this$static, out) {
    var i, size_0;
    size_0 = this$static.array.length;
    out.length < size_0 && (out = stampJavaTypeInfo_1(new Array(size_0), out));
    for(i = 0; i < size_0; ++i)setCheck(out, i, this$static.array[i]);
    out.length > size_0 && setCheck(out, size_0, null);
    return out;
}
function Arrays$ArrayList(array) {
    checkCriticalNotNull(array);
    this.array = array;
}
defineClass(129, 55, $intern_72, Arrays$ArrayList);
_.contains = function contains_35(o) {
    return $indexOf(this, o) != -1;
};
_.forEach_0 = function forEach_18(consumer) {
    var e, e$array, e$index, e$max;
    checkCriticalNotNull(consumer);
    for(e$array = this.array, e$index = 0, e$max = e$array.length; e$index < e$max; ++e$index){
        e = e$array[e$index];
        consumer.accept(e);
    }
};
_.get_0 = function get_37(index_0) {
    return $get_12(this, index_0);
};
_.set_2 = function set_14(index_0, value_0) {
    var was;
    was = (checkCriticalElementIndex(index_0, this.array.length), this.array[index_0]);
    setCheck(this.array, index_0, value_0);
    return was;
};
_.size_1 = function size_46() {
    return this.array.length;
};
_.sort_0 = function sort_6(c) {
    sort_4(this.array, this.array.length, c);
};
_.toArray = function toArray_13() {
    return $toArray_2(this, initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, this.array.length, 5, 1));
};
_.toArray_0 = function toArray_14(out) {
    return $toArray_2(this, out);
};
var Ljava_util_Arrays$ArrayList_2_classLit = createForClass('java.util', 'Arrays/ArrayList', 129);
function $clinit_Collections() {
    $clinit_Collections = emptyMethod;
    EMPTY_LIST = new Collections$EmptyList;
    EMPTY_MAP = new Collections$EmptyMap;
    EMPTY_SET = new Collections$EmptySet;
}
function addAll_15(c, a) {
    $clinit_Collections();
    var e, e$array, e$index, e$max, result;
    result = false;
    for(e$array = a, e$index = 0, e$max = e$array.length; e$index < e$max; ++e$index){
        e = e$array[e$index];
        result = result | c.add_2(e);
    }
    return result;
}
function disjoint(c1, c2) {
    $clinit_Collections();
    var iterating, o, o$iterator, testing;
    iterating = c1;
    testing = c2;
    if (instanceOf(c1, 22) && !instanceOf(c2, 22)) {
        iterating = c2;
        testing = c1;
    }
    for(o$iterator = iterating.iterator_0(); o$iterator.hasNext_0();){
        o = o$iterator.next_1();
        if (testing.contains(o)) return false;
    }
    return true;
}
function hashCode_48(collection) {
    $clinit_Collections();
    var e, e$iterator, hashCode;
    hashCode = 0;
    for(e$iterator = collection.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        hashCode = hashCode + (e != null ? hashCode__I__devirtual$(e) : 0);
        hashCode = hashCode | 0;
    }
    return hashCode;
}
function hashCode_49(list) {
    $clinit_Collections();
    var e, e$iterator, hashCode;
    hashCode = 1;
    for(e$iterator = list.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        hashCode = 31 * hashCode + (e != null ? hashCode__I__devirtual$(e) : 0);
        hashCode = hashCode | 0;
    }
    return hashCode;
}
function nCopies(n, o) {
    $clinit_Collections();
    var i, list;
    list = new ArrayList;
    for(i = 0; i < n; ++i)push_1(list.array, o);
    return new Collections$UnmodifiableRandomAccessList(list);
}
function reverse_2(l) {
    var t;
    $clinit_Collections();
    var head, headElem, iBack, iFront, tail, tailElem;
    if (instanceOf(l, 59)) for(iFront = 0, iBack = l.size_1() - 1; iFront < iBack; ++iFront, --iBack){
        t = l.get_0(iFront);
        l.set_2(iFront, l.get_0(iBack));
        l.set_2(iBack, t);
    }
    else {
        head = l.listIterator_0();
        tail = l.listIterator_1(l.size_1());
        while(head.nextIndex_0() < tail.previousIndex()){
            headElem = head.next_1();
            tailElem = tail.previous_0();
            head.set_1(tailElem);
            tail.set_1(headElem);
        }
    }
}
function reverseOrder_0(cmp) {
    $clinit_Collections();
    return !cmp ? ($clinit_Comparators(), $clinit_Comparators(), REVERSE_NATURAL_ORDER) : cmp.reversed();
}
function singletonMap(key, value_0) {
    $clinit_Collections();
    var map_0;
    map_0 = new HashMap_0(1);
    instanceOfString(key) ? $putStringValue(map_0, key, value_0) : $put_9(map_0.hashCodeMap, key, value_0);
    return new Collections$UnmodifiableMap(map_0);
}
function unmodifiableList(list) {
    $clinit_Collections();
    return instanceOf(list, 59) ? new Collections$UnmodifiableRandomAccessList(list) : new Collections$UnmodifiableList(list);
}
var EMPTY_LIST, EMPTY_MAP, EMPTY_SET;
function $get_13(location_0) {
    checkCriticalElementIndex(location_0, 0);
    return null;
}
function Collections$EmptyList() {}
defineClass(931, 55, $intern_72, Collections$EmptyList);
_.contains = function contains_36(object) {
    return false;
};
_.get_0 = function get_38(location_0) {
    return $get_13(location_0);
};
_.iterator_0 = function iterator_53() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
_.listIterator_0 = function listIterator_11() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
_.size_1 = function size_47() {
    return 0;
};
var Ljava_util_Collections$EmptyList_2_classLit = createForClass('java.util', 'Collections/EmptyList', 931);
function $clinit_Collections$EmptyListIterator() {
    $clinit_Collections$EmptyListIterator = emptyMethod;
    INSTANCE_4 = new Collections$EmptyListIterator;
}
function Collections$EmptyListIterator() {}
defineClass(932, 1, $intern_14, Collections$EmptyListIterator);
_.forEachRemaining = function forEachRemaining_23(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_30(o) {
    throw toJs(new UnsupportedOperationException);
};
_.hasNext_0 = function hasNext_25() {
    return false;
};
_.hasPrevious = function hasPrevious_4() {
    return false;
};
_.next_1 = function next_26() {
    throw toJs(new NoSuchElementException);
};
_.nextIndex_0 = function nextIndex_5() {
    return 0;
};
_.previous_0 = function previous_5() {
    throw toJs(new NoSuchElementException);
};
_.previousIndex = function previousIndex_4() {
    return -1;
};
_.remove = function remove_65() {
    throw toJs(new IllegalStateException);
};
_.set_1 = function set_15(o) {
    throw toJs(new IllegalStateException);
};
var INSTANCE_4;
var Ljava_util_Collections$EmptyListIterator_2_classLit = createForClass('java.util', 'Collections/EmptyListIterator', 932);
function Collections$EmptyMap() {}
defineClass(934, 2011, $intern_28, Collections$EmptyMap);
_.containsKey = function containsKey_11(key) {
    return false;
};
_.containsValue = function containsValue_4(value_0) {
    return false;
};
_.entrySet_0 = function entrySet_4() {
    return $clinit_Collections(), EMPTY_SET;
};
_.get_3 = function get_39(key) {
    return null;
};
_.keySet_0 = function keySet_17() {
    return $clinit_Collections(), EMPTY_SET;
};
_.size_1 = function size_48() {
    return 0;
};
_.values_0 = function values_16() {
    return $clinit_Collections(), EMPTY_LIST;
};
var Ljava_util_Collections$EmptyMap_2_classLit = createForClass('java.util', 'Collections/EmptyMap', 934);
function Collections$EmptySet() {}
defineClass(933, $intern_9, $intern_30, Collections$EmptySet);
_.contains = function contains_37(object) {
    return false;
};
_.iterator_0 = function iterator_54() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
_.size_1 = function size_49() {
    return 0;
};
var Ljava_util_Collections$EmptySet_2_classLit = createForClass('java.util', 'Collections/EmptySet', 933);
function Collections$SingletonList(element) {
    this.element = element;
}
defineClass(592, 55, {
    3: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1
}, Collections$SingletonList);
_.contains = function contains_38(item_0) {
    return equals_57(this.element, item_0);
};
_.get_0 = function get_40(index_0) {
    checkCriticalElementIndex(index_0, 1);
    return this.element;
};
_.size_1 = function size_50() {
    return 1;
};
var Ljava_util_Collections$SingletonList_2_classLit = createForClass('java.util', 'Collections/SingletonList', 592);
function $add_4() {
    throw toJs(new UnsupportedOperationException);
}
function $addAll_3() {
    throw toJs(new UnsupportedOperationException);
}
function $clear_5() {
    throw toJs(new UnsupportedOperationException);
}
function $contains_2(this$static, o) {
    return this$static.coll.contains(o);
}
function $containsAll_0(this$static, c) {
    return this$static.coll.containsAll(c);
}
function $remove_14() {
    throw toJs(new UnsupportedOperationException);
}
function $toArray_3(this$static, a) {
    return this$static.coll.toArray_0(a);
}
function Collections$UnmodifiableCollection(coll) {
    this.coll = coll;
}
defineClass(376, 1, $intern_24, Collections$UnmodifiableCollection);
_.forEach_0 = function forEach_19(action) {
    $forEach_0(this, action);
};
_.spliterator_0 = function spliterator_29() {
    return new Spliterators$IteratorSpliterator(this, 0);
};
_.stream = function stream_5() {
    return new StreamImpl(null, this.spliterator_0());
};
_.add_2 = function add_31(o) {
    return $add_4();
};
_.addAll = function addAll_16(c) {
    return $addAll_3();
};
_.clear_0 = function clear_38() {
    $clear_5();
};
_.contains = function contains_39(o) {
    return $contains_2(this, o);
};
_.containsAll = function containsAll_7(c) {
    return $containsAll_0(this, c);
};
_.isEmpty = function isEmpty_20() {
    return this.coll.isEmpty();
};
_.iterator_0 = function iterator_55() {
    return new Collections$UnmodifiableCollectionIterator(this.coll.iterator_0());
};
_.remove_1 = function remove_66(o) {
    return $remove_14();
};
_.size_1 = function size_51() {
    return this.coll.size_1();
};
_.toArray = function toArray_15() {
    return this.coll.toArray();
};
_.toArray_0 = function toArray_16(a) {
    return $toArray_3(this, a);
};
_.toString_0 = function toString_62() {
    return toString_40(this.coll);
};
var Ljava_util_Collections$UnmodifiableCollection_2_classLit = createForClass('java.util', 'Collections/UnmodifiableCollection', 376);
function $remove_15() {
    throw toJs(new UnsupportedOperationException);
}
function Collections$UnmodifiableCollectionIterator(it) {
    this.it = it;
}
defineClass(375, 1, $intern_6, Collections$UnmodifiableCollectionIterator);
_.forEachRemaining = function forEachRemaining_24(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_26() {
    return this.it.hasNext_0();
};
_.next_1 = function next_27() {
    return this.it.next_1();
};
_.remove = function remove_67() {
    $remove_15();
};
var Ljava_util_Collections$UnmodifiableCollectionIterator_2_classLit = createForClass('java.util', 'Collections/UnmodifiableCollectionIterator', 375);
function Collections$UnmodifiableList(list) {
    Collections$UnmodifiableCollection.call(this, list);
    this.list = list;
}
defineClass(525, 376, $intern_73, Collections$UnmodifiableList);
_.spliterator_0 = function spliterator_30() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.add_3 = function add_32(index_0, element) {
    throw toJs(new UnsupportedOperationException);
};
_.addAll_0 = function addAll_17(index_0, c) {
    throw toJs(new UnsupportedOperationException);
};
_.equals_0 = function equals_47(o) {
    return equals_Ljava_lang_Object__Z__devirtual$(this.list, o);
};
_.get_0 = function get_41(index_0) {
    return this.list.get_0(index_0);
};
_.hashCode_1 = function hashCode_50() {
    return hashCode__I__devirtual$(this.list);
};
_.indexOf_0 = function indexOf_5(o) {
    return this.list.indexOf_0(o);
};
_.isEmpty = function isEmpty_21() {
    return this.list.isEmpty();
};
_.listIterator_0 = function listIterator_12() {
    return new Collections$UnmodifiableListIterator(this.list.listIterator_1(0));
};
_.listIterator_1 = function listIterator_13(from) {
    return new Collections$UnmodifiableListIterator(this.list.listIterator_1(from));
};
_.remove_2 = function remove_68(index_0) {
    throw toJs(new UnsupportedOperationException);
};
_.set_2 = function set_16(index_0, element) {
    throw toJs(new UnsupportedOperationException);
};
_.sort_0 = function sort_7(c) {
    throw toJs(new UnsupportedOperationException);
};
_.subList = function subList_7(fromIndex, toIndex) {
    return new Collections$UnmodifiableList(this.list.subList(fromIndex, toIndex));
};
var Ljava_util_Collections$UnmodifiableList_2_classLit = createForClass('java.util', 'Collections/UnmodifiableList', 525);
function Collections$UnmodifiableListIterator(lit) {
    Collections$UnmodifiableCollectionIterator.call(this, lit);
    this.lit = lit;
}
defineClass(689, 375, $intern_14, Collections$UnmodifiableListIterator);
_.remove = function remove_69() {
    $remove_15();
};
_.add_1 = function add_33(o) {
    throw toJs(new UnsupportedOperationException);
};
_.hasPrevious = function hasPrevious_5() {
    return this.lit.hasPrevious();
};
_.nextIndex_0 = function nextIndex_6() {
    return this.lit.nextIndex_0();
};
_.previous_0 = function previous_6() {
    return this.lit.previous_0();
};
_.previousIndex = function previousIndex_5() {
    return this.lit.previousIndex();
};
_.set_1 = function set_17(o) {
    throw toJs(new UnsupportedOperationException);
};
var Ljava_util_Collections$UnmodifiableListIterator_2_classLit = createForClass('java.util', 'Collections/UnmodifiableListIterator', 689);
function $containsValue_3(this$static, val) {
    return this$static.map_0.containsValue(val);
}
function $entrySet_2(this$static) {
    !this$static.entrySet && (this$static.entrySet = new Collections$UnmodifiableMap$UnmodifiableEntrySet(this$static.map_0.entrySet_0()));
    return this$static.entrySet;
}
function $equals_7(this$static, o) {
    return equals_Ljava_lang_Object__Z__devirtual$(this$static.map_0, o);
}
function $keySet_1(this$static) {
    !this$static.keySet && (this$static.keySet = new Collections$UnmodifiableSet(this$static.map_0.keySet_0()));
    return this$static.keySet;
}
function $values_2(this$static) {
    !this$static.values && (this$static.values = new Collections$UnmodifiableCollection(this$static.map_0.values_0()));
    return this$static.values;
}
function Collections$UnmodifiableMap(map_0) {
    this.map_0 = map_0;
}
defineClass(593, 1, $intern_7, Collections$UnmodifiableMap);
_.forEach = function forEach_20(consumer) {
    $forEach_2(this, consumer);
};
_.clear_0 = function clear_39() {
    throw toJs(new UnsupportedOperationException);
};
_.containsKey = function containsKey_12(key) {
    return this.map_0.containsKey(key);
};
_.containsValue = function containsValue_5(val) {
    return $containsValue_3(this, val);
};
_.entrySet_0 = function entrySet_5() {
    return $entrySet_2(this);
};
_.equals_0 = function equals_48(o) {
    return $equals_7(this, o);
};
_.get_3 = function get_42(key) {
    return this.map_0.get_3(key);
};
_.hashCode_1 = function hashCode_51() {
    return hashCode__I__devirtual$(this.map_0);
};
_.isEmpty = function isEmpty_22() {
    return this.map_0.isEmpty();
};
_.keySet_0 = function keySet_18() {
    return $keySet_1(this);
};
_.put = function put_6(key, value_0) {
    throw toJs(new UnsupportedOperationException);
};
_.remove_0 = function remove_70(key) {
    throw toJs(new UnsupportedOperationException);
};
_.size_1 = function size_52() {
    return this.map_0.size_1();
};
_.toString_0 = function toString_63() {
    return toString_40(this.map_0);
};
_.values_0 = function values_17() {
    return $values_2(this);
};
var Ljava_util_Collections$UnmodifiableMap_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap', 593);
function Collections$UnmodifiableSet(set_0) {
    Collections$UnmodifiableCollection.call(this, set_0);
}
defineClass(387, 376, $intern_29, Collections$UnmodifiableSet);
_.spliterator_0 = function spliterator_31() {
    return new Spliterators$IteratorSpliterator(this, 1);
};
_.equals_0 = function equals_49(o) {
    return equals_Ljava_lang_Object__Z__devirtual$(this.coll, o);
};
_.hashCode_1 = function hashCode_52() {
    return hashCode__I__devirtual$(this.coll);
};
var Ljava_util_Collections$UnmodifiableSet_2_classLit = createForClass('java.util', 'Collections/UnmodifiableSet', 387);
function $contains_3(this$static, o) {
    return this$static.coll.contains(o);
}
function $toArray_4(this$static, a) {
    var result;
    result = this$static.coll.toArray_0(a);
    $wrap(result, this$static.coll.size_1());
    return result;
}
function $wrap(array, size_0) {
    var i;
    for(i = 0; i < size_0; ++i)setCheck(array, i, new Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry(castTo(array[i], 43)));
}
function Collections$UnmodifiableMap$UnmodifiableEntrySet(s) {
    Collections$UnmodifiableSet.call(this, s);
}
defineClass(935, 387, $intern_29, Collections$UnmodifiableMap$UnmodifiableEntrySet);
_.contains = function contains_40(o) {
    return $contains_3(this, o);
};
_.containsAll = function containsAll_8(o) {
    return this.coll.containsAll(o);
};
_.iterator_0 = function iterator_56() {
    var it;
    it = this.coll.iterator_0();
    return new Collections$UnmodifiableMap$UnmodifiableEntrySet$1(it);
};
_.toArray = function toArray_17() {
    var array;
    array = this.coll.toArray();
    $wrap(array, array.length);
    return array;
};
_.toArray_0 = function toArray_18(a) {
    return $toArray_4(this, a);
};
var Ljava_util_Collections$UnmodifiableMap$UnmodifiableEntrySet_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap/UnmodifiableEntrySet', 935);
function Collections$UnmodifiableMap$UnmodifiableEntrySet$1(val$it) {
    this.val$it2 = val$it;
}
defineClass(936, 1, $intern_6, Collections$UnmodifiableMap$UnmodifiableEntrySet$1);
_.forEachRemaining = function forEachRemaining_25(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_28() {
    return new Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry(castTo(this.val$it2.next_1(), 43));
};
_.hasNext_0 = function hasNext_27() {
    return this.val$it2.hasNext_0();
};
_.remove = function remove_71() {
    throw toJs(new UnsupportedOperationException);
};
var Ljava_util_Collections$UnmodifiableMap$UnmodifiableEntrySet$1_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap/UnmodifiableEntrySet/1', 936);
function Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry(entry) {
    this.entry = entry;
}
defineClass(687, 1, $intern_70, Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry);
_.equals_0 = function equals_50(o) {
    return this.entry.equals_0(o);
};
_.getKey = function getKey_5() {
    return this.entry.getKey();
};
_.getValue = function getValue_7() {
    return this.entry.getValue();
};
_.hashCode_1 = function hashCode_53() {
    return this.entry.hashCode_1();
};
_.setValue = function setValue_8(value_0) {
    throw toJs(new UnsupportedOperationException);
};
_.toString_0 = function toString_64() {
    return toString_40(this.entry);
};
var Ljava_util_Collections$UnmodifiableMap$UnmodifiableEntrySet$UnmodifiableEntry_2_classLit = createForClass('java.util', 'Collections/UnmodifiableMap/UnmodifiableEntrySet/UnmodifiableEntry', 687);
function Collections$UnmodifiableRandomAccessList(list) {
    Collections$UnmodifiableList.call(this, list);
}
defineClass(594, 525, {
    20: 1,
    16: 1,
    15: 1,
    59: 1
}, Collections$UnmodifiableRandomAccessList);
var Ljava_util_Collections$UnmodifiableRandomAccessList_2_classLit = createForClass('java.util', 'Collections/UnmodifiableRandomAccessList', 594);
function Collections$UnmodifiableSortedSet(sortedSet) {
    Collections$UnmodifiableSet.call(this, sortedSet);
    this.sortedSet = sortedSet;
}
defineClass(688, 387, $intern_31, Collections$UnmodifiableSortedSet);
_.spliterator_0 = function spliterator_32() {
    return new SortedSet$1(this);
};
_.equals_0 = function equals_51(o) {
    return equals_Ljava_lang_Object__Z__devirtual$(this.sortedSet, o);
};
_.hashCode_1 = function hashCode_54() {
    return hashCode__I__devirtual$(this.sortedSet);
};
var Ljava_util_Collections$UnmodifiableSortedSet_2_classLit = createForClass('java.util', 'Collections/UnmodifiableSortedSet', 688);
function Comparator$lambda$0$Type() {}
defineClass(837, 1, $intern_74, Comparator$lambda$0$Type);
_.compare_1 = function compare_8(a, b) {
    var c;
    return c = lambda$2_5(castTo(a, 11), castTo(b, 11)), c != 0 ? c : lambda$4_4(castTo(a, 11), castTo(b, 11));
};
_.equals_0 = function equals_52(other) {
    return this === other;
};
_.reversed = function reversed_0() {
    return new Comparators$ReversedComparator(this);
};
var Ljava_util_Comparator$lambda$0$Type_2_classLit = createForClass('java.util', 'Comparator/lambda$0$Type', 837);
function $clinit_Comparators() {
    $clinit_Comparators = emptyMethod;
    INTERNAL_NATURAL_ORDER = new Comparators$NaturalOrderComparator;
    NATURAL_ORDER = new Comparators$NaturalOrderComparator;
    REVERSE_NATURAL_ORDER = new Comparators$ReverseNaturalOrderComparator;
}
var INTERNAL_NATURAL_ORDER, NATURAL_ORDER, REVERSE_NATURAL_ORDER;
function $compare(a, b) {
    return checkCriticalNotNull(a), compareTo_Ljava_lang_Object__I__devirtual$(a, (checkCriticalNotNull(b), b));
}
function Comparators$NaturalOrderComparator() {}
defineClass(751, 1, $intern_74, Comparators$NaturalOrderComparator);
_.compare_1 = function compare_9(a, b) {
    return $compare(castTo(a, 34), castTo(b, 34));
};
_.equals_0 = function equals_53(other) {
    return this === other;
};
_.reversed = function reversed_1() {
    return $clinit_Comparators(), REVERSE_NATURAL_ORDER;
};
var Ljava_util_Comparators$NaturalOrderComparator_2_classLit = createForClass('java.util', 'Comparators/NaturalOrderComparator', 751);
function $compare_0(a, b) {
    return checkCriticalNotNull(b), compareTo_Ljava_lang_Object__I__devirtual$(b, (checkCriticalNotNull(a), a));
}
function Comparators$ReverseNaturalOrderComparator() {}
defineClass(1186, 1, $intern_74, Comparators$ReverseNaturalOrderComparator);
_.compare_1 = function compare_10(a, b) {
    return $compare_0(castTo(a, 34), castTo(b, 34));
};
_.equals_0 = function equals_54(other) {
    return this === other;
};
_.reversed = function reversed_2() {
    return $clinit_Comparators(), NATURAL_ORDER;
};
var Ljava_util_Comparators$ReverseNaturalOrderComparator_2_classLit = createForClass('java.util', 'Comparators/ReverseNaturalOrderComparator', 1186);
function Comparators$ReversedComparator(comparator) {
    this.comparator = comparator;
}
defineClass(56, 1, $intern_74, Comparators$ReversedComparator);
_.equals_0 = function equals_55(other) {
    return this === other;
};
_.compare_1 = function compare_11(a, b) {
    return this.comparator.compare_1(b, a);
};
_.reversed = function reversed_3() {
    return this.comparator;
};
var Ljava_util_Comparators$ReversedComparator_2_classLit = createForClass('java.util', 'Comparators/ReversedComparator', 56);
function ConcurrentModificationException() {
    RuntimeException.call(this);
}
defineClass(175, 63, $intern_43, ConcurrentModificationException);
var Ljava_util_ConcurrentModificationException_2_classLit = createForClass('java.util', 'ConcurrentModificationException', 175);
function $clinit_Date$StringData() {
    $clinit_Date$StringData = emptyMethod;
    DAYS = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ]);
    MONTHS = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ]);
}
var DAYS, MONTHS;
function $accept(this$static, value_0) {
    var compensatedValue, newSum;
    this$static.count = add_20(this$static.count, 1);
    this$static.min_0 = $wnd.Math.min(this$static.min_0, value_0);
    this$static.max_0 = $wnd.Math.max(this$static.max_0, value_0);
    this$static.naiveSum += value_0;
    compensatedValue = value_0 - this$static.sumError;
    newSum = this$static.sum + compensatedValue;
    this$static.sumError = newSum - this$static.sum - compensatedValue;
    this$static.sum = newSum;
}
function $getSum(this$static) {
    var compensatedSum;
    compensatedSum = this$static.sum + this$static.sumError;
    if (isNaN(compensatedSum) && isInfinite(this$static.naiveSum)) return this$static.naiveSum;
    return compensatedSum;
}
function DoubleSummaryStatistics() {}
defineClass(1894, 1, $intern_75, DoubleSummaryStatistics);
_.accept_2 = function accept_15(value_0) {
    $accept(this, value_0);
};
_.toString_0 = function toString_65() {
    return 'DoubleSummaryStatistics[count = ' + toString_39(this.count) + ', avg = ' + (gt(this.count, 0) ? $getSum(this) / toDouble_0(this.count) : 0) + ', min = ' + this.min_0 + ', max = ' + this.max_0 + ', sum = ' + $getSum(this) + ']';
};
_.count = 0;
_.max_0 = $intern_61;
_.min_0 = $intern_60;
_.naiveSum = 0;
_.sum = 0;
_.sumError = 0;
var Ljava_util_DoubleSummaryStatistics_2_classLit = createForClass('java.util', 'DoubleSummaryStatistics', 1894);
function EmptyStackException() {
    RuntimeException.call(this);
}
defineClass(1814, 63, $intern_43, EmptyStackException);
var Ljava_util_EmptyStackException_2_classLit = createForClass('java.util', 'EmptyStackException', 1814);
function $clear_6(this$static) {
    $clear_0(this$static.keySet);
    this$static.values = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, this$static.values.length, 5, 1);
}
function $containsKey_5(this$static, key) {
    return $contains_5(this$static.keySet, key);
}
function $get_14(this$static, k) {
    return $contains_5(this$static.keySet, k) ? this$static.values[castTo(k, 23).ordinal] : null;
}
function $put_7(this$static, key, value_0) {
    $add_5(this$static.keySet, key);
    return setAt(this$static.values, key.ordinal, value_0);
}
function $put_8(this$static, key, value_0) {
    return $put_7(this$static, castTo(key, 23), value_0);
}
function $remove_16(this$static, key) {
    return $remove_17(this$static.keySet, key) ? setAt(this$static.values, castTo(key, 23).ordinal, null) : null;
}
function EnumMap(type_0) {
    var all;
    this.keySet = (all = castTo(type_0.enumConstantsFunc && type_0.enumConstantsFunc(), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    this.values = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, this.keySet.all.length, 5, 1);
}
defineClass(447, 2011, $intern_7, EnumMap);
_.put = function put_7(key, value_0) {
    return $put_8(this, key, value_0);
};
_.clear_0 = function clear_40() {
    $clear_6(this);
};
_.containsKey = function containsKey_13(key) {
    return $containsKey_5(this, key);
};
_.containsValue = function containsValue_6(value_0) {
    var key, key$iterator;
    for(key$iterator = new EnumSet$EnumSetImpl$IteratorImpl(this.keySet); key$iterator.i < key$iterator.this$11.all.length;){
        key = $next_7(key$iterator);
        if (equals_57(value_0, this.values[key.ordinal])) return true;
    }
    return false;
};
_.entrySet_0 = function entrySet_6() {
    return new EnumMap$EntrySet(this);
};
_.get_3 = function get_43(k) {
    return $get_14(this, k);
};
_.remove_0 = function remove_72(key) {
    return $remove_16(this, key);
};
_.size_1 = function size_53() {
    return this.keySet.size_0;
};
var Ljava_util_EnumMap_2_classLit = createForClass('java.util', 'EnumMap', 447);
function $contains_4(this$static, o) {
    if (instanceOf(o, 43)) return $containsEntry_0(this$static.this$01, castTo(o, 43));
    return false;
}
function EnumMap$EntrySet(this$0) {
    this.this$01 = this$0;
}
defineClass(1281, $intern_9, $intern_10, EnumMap$EntrySet);
_.clear_0 = function clear_41() {
    $clear_6(this.this$01);
};
_.contains = function contains_41(o) {
    return $contains_4(this, o);
};
_.iterator_0 = function iterator_57() {
    return new EnumMap$EntrySetIterator(this.this$01);
};
_.remove_1 = function remove_73(entry) {
    var key;
    if ($contains_4(this, entry)) {
        key = castTo(entry, 43).getKey();
        $remove_16(this.this$01, key);
        return true;
    }
    return false;
};
_.size_1 = function size_54() {
    return this.this$01.keySet.size_0;
};
var Ljava_util_EnumMap$EntrySet_2_classLit = createForClass('java.util', 'EnumMap/EntrySet', 1281);
function EnumMap$EntrySetIterator(this$0) {
    this.this$01 = this$0;
    this.it = new EnumSet$EnumSetImpl$IteratorImpl(this.this$01.keySet);
}
defineClass(1282, 1, $intern_6, EnumMap$EntrySetIterator);
_.forEachRemaining = function forEachRemaining_26(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_29() {
    return this.key = $next_7(this.it), new EnumMap$MapEntry(this.this$01, this.key);
};
_.hasNext_0 = function hasNext_28() {
    return $hasNext_4(this.it);
};
_.remove = function remove_74() {
    checkCriticalState(!!this.key);
    $remove_16(this.this$01, this.key);
    this.key = null;
};
var Ljava_util_EnumMap$EntrySetIterator_2_classLit = createForClass('java.util', 'EnumMap/EntrySetIterator', 1282);
function EnumMap$MapEntry(this$0, key) {
    this.this$01 = this$0;
    this.key = key;
}
defineClass(1283, 2028, $intern_70, EnumMap$MapEntry);
_.getKey = function getKey_6() {
    return this.key;
};
_.getValue = function getValue_8() {
    return this.this$01.values[this.key.ordinal];
};
_.setValue = function setValue_9(value_0) {
    return setAt(this.this$01.values, this.key.ordinal, value_0);
};
var Ljava_util_EnumMap$MapEntry_2_classLit = createForClass('java.util', 'EnumMap/MapEntry', 1283);
function allOf(elementType) {
    var all, result, set_0;
    all = castTo(elementType.enumConstantsFunc && elementType.enumConstantsFunc(), 10);
    set_0 = (result = all.slice(), castTo(stampJavaTypeInfo_0(result, all), 10));
    return new EnumSet$EnumSetImpl(all, set_0, all.length);
}
function of_1(first) {
    var all, set_0, clazz, superclass;
    set_0 = (all = castTo($getEnumConstants((clazz = first.___clazz, superclass = clazz.enumSuperclass, superclass == Ljava_lang_Enum_2_classLit ? clazz : superclass)), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    $add_5(set_0, first);
    return set_0;
}
function of_2(first, rest) {
    var set_0;
    set_0 = of_1(first);
    addAll_15(set_0, rest);
    return set_0;
}
defineClass(181, $intern_9, {
    20: 1,
    31: 1,
    16: 1,
    181: 1,
    22: 1
});
var Ljava_util_EnumSet_2_classLit = createForClass('java.util', 'EnumSet', 181);
function $add_5(this$static, e) {
    var ordinal;
    checkCriticalNotNull(e);
    ordinal = e.ordinal;
    if (!this$static.set_0[ordinal]) {
        setCheck(this$static.set_0, ordinal, e);
        ++this$static.size_0;
        return true;
    }
    return false;
}
function $clone(this$static) {
    var clonedSet;
    clonedSet = castTo(clone_0(this$static.set_0), 10);
    return new EnumSet$EnumSetImpl(this$static.all, clonedSet, this$static.size_0);
}
function $contains_5(this$static, o) {
    return instanceOf(o, 23) && $containsEnum(this$static, castTo(o, 23));
}
function $containsEnum(this$static, e) {
    return !!e && this$static.set_0[e.ordinal] == e;
}
function $remove_17(this$static, o) {
    return instanceOf(o, 23) && $removeEnum(this$static, castTo(o, 23));
}
function $removeEnum(this$static, e) {
    if (!!e && this$static.set_0[e.ordinal] == e) {
        setCheck(this$static.set_0, e.ordinal, null);
        --this$static.size_0;
        return true;
    }
    return false;
}
function EnumSet$EnumSetImpl(all, set_0, size_0) {
    this.all = all;
    this.set_0 = set_0;
    this.size_0 = size_0;
}
defineClass(161, 181, {
    20: 1,
    31: 1,
    16: 1,
    181: 1,
    161: 1,
    22: 1
}, EnumSet$EnumSetImpl);
_.add_2 = function add_34(e) {
    return $add_5(this, castTo(e, 23));
};
_.contains = function contains_42(o) {
    return $contains_5(this, o);
};
_.iterator_0 = function iterator_58() {
    return new EnumSet$EnumSetImpl$IteratorImpl(this);
};
_.remove_1 = function remove_75(o) {
    return $remove_17(this, o);
};
_.size_1 = function size_55() {
    return this.size_0;
};
_.size_0 = 0;
var Ljava_util_EnumSet$EnumSetImpl_2_classLit = createForClass('java.util', 'EnumSet/EnumSetImpl', 161);
function $findNext(this$static) {
    var c;
    ++this$static.i;
    for(c = this$static.this$11.all.length; this$static.i < c; ++this$static.i){
        if (this$static.this$11.set_0[this$static.i]) return;
    }
}
function $hasNext_4(this$static) {
    return this$static.i < this$static.this$11.all.length;
}
function $next_7(this$static) {
    checkCriticalElement(this$static.i < this$static.this$11.all.length);
    this$static.last = this$static.i;
    $findNext(this$static);
    return this$static.this$11.set_0[this$static.last];
}
function EnumSet$EnumSetImpl$IteratorImpl(this$1) {
    this.this$11 = this$1;
    $findNext(this);
}
defineClass(353, 1, $intern_6, EnumSet$EnumSetImpl$IteratorImpl);
_.forEachRemaining = function forEachRemaining_27(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_30() {
    return $next_7(this);
};
_.hasNext_0 = function hasNext_29() {
    return $hasNext_4(this);
};
_.remove = function remove_76() {
    checkCriticalState(this.last != -1);
    setCheck(this.this$11.set_0, this.last, null);
    --this.this$11.size_0;
    this.last = -1;
};
_.i = -1;
_.last = -1;
var Ljava_util_EnumSet$EnumSetImpl$IteratorImpl_2_classLit = createForClass('java.util', 'EnumSet/EnumSetImpl/IteratorImpl', 353);
function HashMap() {
    $reset(this);
}
function HashMap_0(ignored) {
    AbstractHashMap.call(this, ignored, 0);
}
function HashMap_1(toBeCopied) {
    $reset(this);
    $putAll(this, toBeCopied);
}
defineClass(45, 482, $intern_76, HashMap, HashMap_0, HashMap_1);
_.equals_1 = function equals_56(value1, value2) {
    return maskUndefined(value1) === maskUndefined(value2) || value1 != null && equals_Ljava_lang_Object__Z__devirtual$(value1, value2);
};
_.getHashCode = function getHashCode(key) {
    var hashCode;
    if (key == null) return 0;
    hashCode = hashCode__I__devirtual$(key);
    return hashCode | 0;
};
var Ljava_util_HashMap_2_classLit = createForClass('java.util', 'HashMap', 45);
function $add_6(this$static, o) {
    var old;
    old = this$static.map_0.put(o, this$static);
    return old == null;
}
function $contains_6(this$static, o) {
    return this$static.map_0.containsKey(o);
}
function $remove_18(this$static, o) {
    return this$static.map_0.remove_0(o) != null;
}
function HashSet() {
    this.map_0 = new HashMap;
}
function HashSet_0(initialCapacity) {
    this.map_0 = new HashMap_0(initialCapacity);
}
function HashSet_1(c) {
    this.map_0 = new HashMap_0(c.size_1());
    $addAll(this, c);
}
function HashSet_2(map_0) {
    this.map_0 = map_0;
}
defineClass(50, $intern_9, $intern_77, HashSet, HashSet_0, HashSet_1);
_.add_2 = function add_35(o) {
    return $add_6(this, o);
};
_.clear_0 = function clear_42() {
    this.map_0.clear_0();
};
_.contains = function contains_43(o) {
    return $contains_6(this, o);
};
_.isEmpty = function isEmpty_23() {
    return this.map_0.size_1() == 0;
};
_.iterator_0 = function iterator_59() {
    return this.map_0.keySet_0().iterator_0();
};
_.remove_1 = function remove_77(o) {
    return $remove_18(this, o);
};
_.size_1 = function size_56() {
    return this.map_0.size_1();
};
var Ljava_util_HashSet_2_classLit = createForClass('java.util', 'HashSet', 50);
function $accept_0(this$static, value_0) {
    this$static.count = add_20(this$static.count, 1);
    this$static.min_0 = $wnd.Math.min(this$static.min_0, value_0);
    this$static.max_0 = $wnd.Math.max(this$static.max_0, value_0);
    this$static.sum = add_20(this$static.sum, value_0);
}
function IntSummaryStatistics() {}
defineClass(1843, 1, $intern_20, IntSummaryStatistics);
_.accept_0 = function accept_16(value_0) {
    $accept_0(this, value_0);
};
_.toString_0 = function toString_66() {
    return 'IntSummaryStatistics[count = ' + toString_39(this.count) + ', avg = ' + (gt(this.count, 0) ? toDouble_0(this.sum) / toDouble_0(this.count) : 0) + ', min = ' + this.min_0 + ', max = ' + this.max_0 + ', sum = ' + toString_39(this.sum) + ']';
};
_.count = 0;
_.max_0 = $intern_42;
_.min_0 = $intern_0;
_.sum = 0;
var Ljava_util_IntSummaryStatistics_2_classLit = createForClass('java.util', 'IntSummaryStatistics', 1843);
function $findEntryInChain(this$static, key, chain) {
    var entry, entry$array, entry$index, entry$max;
    for(entry$array = chain, entry$index = 0, entry$max = entry$array.length; entry$index < entry$max; ++entry$index){
        entry = entry$array[entry$index];
        if (this$static.host.equals_1(key, entry.getKey())) return entry;
    }
    return null;
}
function $getChainOrEmpty(this$static, hashCode) {
    var chain;
    chain = this$static.backingMap.get(hashCode);
    return chain == null ? initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1) : chain;
}
function $getEntry_0(this$static, key) {
    return $findEntryInChain(this$static, key, $getChainOrEmpty(this$static, this$static.host.getHashCode(key)));
}
function $put_9(this$static, key, value_0) {
    var chain, chain0, entry, hashCode;
    hashCode = this$static.host.getHashCode(key);
    chain0 = (chain = this$static.backingMap.get(hashCode), chain == null ? initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1) : chain);
    if (chain0.length == 0) this$static.backingMap.set(hashCode, chain0);
    else {
        entry = $findEntryInChain(this$static, key, chain0);
        if (entry) return entry.setValue(value_0);
    }
    setCheck(chain0, chain0.length, new AbstractMap$SimpleEntry(key, value_0));
    ++this$static.size_0;
    ++this$static.host.modCount;
    return null;
}
function $remove_19(this$static, key) {
    var chain, chain0, entry, hashCode, i;
    hashCode = this$static.host.getHashCode(key);
    chain0 = (chain = this$static.backingMap.get(hashCode), chain == null ? initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1) : chain);
    for(i = 0; i < chain0.length; i++){
        entry = chain0[i];
        if (this$static.host.equals_1(key, entry.getKey())) {
            if (chain0.length == 1) {
                chain0.length = 0;
                $delete_0(this$static.backingMap, hashCode);
            } else chain0.splice(i, 1);
            --this$static.size_0;
            ++this$static.host.modCount;
            return entry.getValue();
        }
    }
    return null;
}
function InternalHashCodeMap(host) {
    this.backingMap = newJsMap();
    this.host = host;
}
defineClass(1037, 1, $intern_23, InternalHashCodeMap);
_.forEach_0 = function forEach_21(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_60() {
    return new InternalHashCodeMap$1(this);
};
_.size_0 = 0;
var Ljava_util_InternalHashCodeMap_2_classLit = createForClass('java.util', 'InternalHashCodeMap', 1037);
function InternalHashCodeMap$1(this$0) {
    this.this$01 = this$0;
    this.chains = this.this$01.backingMap.entries();
    this.chain = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1);
}
defineClass(710, 1, $intern_6, InternalHashCodeMap$1);
_.forEachRemaining = function forEachRemaining_28(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_31() {
    return this.lastEntry = this.chain[this.itemIndex++], this.lastEntry;
};
_.hasNext_0 = function hasNext_30() {
    var current;
    if (this.itemIndex < this.chain.length) return true;
    current = this.chains.next();
    if (!current.done) {
        this.chain = current.value[1];
        this.itemIndex = 0;
        return true;
    }
    return false;
};
_.remove = function remove_78() {
    $remove_19(this.this$01, this.lastEntry.getKey());
    this.itemIndex != 0 && --this.itemIndex;
};
_.itemIndex = 0;
_.lastEntry = null;
var Ljava_util_InternalHashCodeMap$1_2_classLit = createForClass('java.util', 'InternalHashCodeMap/1', 710);
function $delete_0(this$static, key) {
    var fn;
    fn = this$static['delete'];
    fn.call(this$static, key);
}
function $delete_1(this$static, key) {
    var fn;
    fn = this$static['delete'];
    fn.call(this$static, key);
}
function $clinit_InternalJsMapFactory() {
    $clinit_InternalJsMapFactory = emptyMethod;
    jsMapCtor = getJsMapConstructor();
}
function canHandleObjectCreateAndProto() {
    if (!Object.create || !Object.getOwnPropertyNames) return false;
    var protoField = '__proto__';
    var map_0 = Object.create(null);
    if (map_0[protoField] !== undefined) return false;
    var keys_0 = Object.getOwnPropertyNames(map_0);
    if (keys_0.length != 0) return false;
    map_0[protoField] = 42;
    if (map_0[protoField] !== 42) return false;
    if (Object.getOwnPropertyNames(map_0).length == 0) return false;
    return true;
}
function getJsMapConstructor() {
    function isCorrectIterationProtocol() {
        try {
            return (new Map).entries().next().done;
        } catch (e) {
            return false;
        }
    }
    if (typeof Map === 'function' && Map.prototype.entries && isCorrectIterationProtocol()) return Map;
    else return getJsMapPolyFill();
}
function getJsMapPolyFill() {
    function Stringmap() {
        this.obj = this.createObject();
    }
    Stringmap.prototype.createObject = function(key) {
        return Object.create(null);
    };
    Stringmap.prototype.get = function(key) {
        return this.obj[key];
    };
    Stringmap.prototype.set = function(key, value_0) {
        this.obj[key] = value_0;
    };
    Stringmap.prototype['delete'] = function(key) {
        delete this.obj[key];
    };
    Stringmap.prototype.keys = function() {
        return Object.getOwnPropertyNames(this.obj);
    };
    Stringmap.prototype.entries = function() {
        var keys_0 = this.keys();
        var map_0 = this;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= keys_0.length) return {
                    done: true
                };
                var key = keys_0[nextIndex++];
                return {
                    value: [
                        key,
                        map_0.get(key)
                    ],
                    done: false
                };
            }
        };
    };
    if (!canHandleObjectCreateAndProto()) {
        Stringmap.prototype.createObject = function() {
            return {};
        };
        Stringmap.prototype.get = function(key) {
            return this.obj[':' + key];
        };
        Stringmap.prototype.set = function(key, value_0) {
            this.obj[':' + key] = value_0;
        };
        Stringmap.prototype['delete'] = function(key) {
            delete this.obj[':' + key];
        };
        Stringmap.prototype.keys = function() {
            var result = [];
            for(var key in this.obj)key.charCodeAt(0) == 58 && result.push(key.substring(1));
            return result;
        };
    }
    return Stringmap;
}
function newJsMap() {
    $clinit_InternalJsMapFactory();
    return new jsMapCtor;
}
var jsMapCtor;
function $contains_7(this$static, key) {
    return !(this$static.backingMap.get(key) === undefined);
}
function $get_15(this$static, key) {
    return this$static.backingMap.get(key);
}
function $put_10(this$static, key, value_0) {
    var oldValue;
    oldValue = this$static.backingMap.get(key);
    this$static.backingMap.set(key, value_0 === undefined ? null : value_0);
    if (oldValue === undefined) {
        ++this$static.size_0;
        ++this$static.host.modCount;
    } else ++this$static.valueMod;
    return oldValue;
}
function $remove_20(this$static, key) {
    var value_0;
    value_0 = this$static.backingMap.get(key);
    if (value_0 === undefined) ++this$static.valueMod;
    else {
        $delete_1(this$static.backingMap, key);
        --this$static.size_0;
        ++this$static.host.modCount;
    }
    return value_0;
}
function InternalStringMap(host) {
    this.backingMap = newJsMap();
    this.host = host;
}
defineClass(1035, 1, $intern_23, InternalStringMap);
_.forEach_0 = function forEach_22(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_61() {
    return new InternalStringMap$1(this);
};
_.size_0 = 0;
_.valueMod = 0;
var Ljava_util_InternalStringMap_2_classLit = createForClass('java.util', 'InternalStringMap', 1035);
function InternalStringMap$1(this$0) {
    this.this$01 = this$0;
    this.entries_0 = this.this$01.backingMap.entries();
    this.current = this.entries_0.next();
}
defineClass(709, 1, $intern_6, InternalStringMap$1);
_.forEachRemaining = function forEachRemaining_29(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_32() {
    return this.last = this.current, this.current = this.entries_0.next(), new InternalStringMap$2(this.this$01, this.last, this.this$01.valueMod);
};
_.hasNext_0 = function hasNext_31() {
    return !this.current.done;
};
_.remove = function remove_79() {
    $remove_20(this.this$01, this.last.value[0]);
};
var Ljava_util_InternalStringMap$1_2_classLit = createForClass('java.util', 'InternalStringMap/1', 709);
function InternalStringMap$2(this$0, val$entry, val$lastValueMod) {
    this.this$01 = this$0;
    this.val$entry2 = val$entry;
    this.val$lastValueMod3 = val$lastValueMod;
}
defineClass(1036, 2028, $intern_70, InternalStringMap$2);
_.getKey = function getKey_7() {
    return this.val$entry2.value[0];
};
_.getValue = function getValue_9() {
    if (this.this$01.valueMod != this.val$lastValueMod3) return $get_15(this.this$01, this.val$entry2.value[0]);
    return this.val$entry2.value[1];
};
_.setValue = function setValue_10(object) {
    return $put_10(this.this$01, this.val$entry2.value[0], object);
};
_.val$lastValueMod3 = 0;
var Ljava_util_InternalStringMap$2_2_classLit = createForClass('java.util', 'InternalStringMap/2', 1036);
function $$init_2(this$static) {
    this$static.head = new LinkedHashMap$ChainEntry(this$static);
    this$static.map_0 = new HashMap;
}
function $clear_7(this$static) {
    $reset(this$static.map_0);
    this$static.head.prev = this$static.head;
    this$static.head.next_0 = this$static.head;
}
function $containsKey_6(this$static, key) {
    return $containsKey_3(this$static.map_0, key);
}
function $get_16(this$static, key) {
    var entry;
    entry = castTo($get_10(this$static.map_0, key), 391);
    if (entry) {
        $recordAccess(this$static, entry);
        return entry.value_0;
    }
    return null;
}
function $put_11(this$static, key, value_0) {
    var newEntry, old, oldValue;
    old = castTo($get_10(this$static.map_0, key), 391);
    if (!old) {
        newEntry = new LinkedHashMap$ChainEntry_0(this$static, key, value_0);
        $put_6(this$static.map_0, key, newEntry);
        $addToEnd(newEntry);
        return null;
    } else {
        oldValue = $setValue_0(old, value_0);
        $recordAccess(this$static, old);
        return oldValue;
    }
}
function $recordAccess(this$static, entry) {
    if (this$static.accessOrder) {
        $remove_23(entry);
        $addToEnd(entry);
    }
}
function $remove_22(this$static, key) {
    var entry;
    entry = castTo($remove_6(this$static.map_0, key), 391);
    if (entry) {
        $remove_23(entry);
        return entry.value_0;
    }
    return null;
}
function LinkedHashMap() {
    HashMap.call(this);
    $$init_2(this);
    this.head.prev = this.head;
    this.head.next_0 = this.head;
}
function LinkedHashMap_0(ignored) {
    AbstractHashMap.call(this, ignored, 0);
    $$init_2(this);
    this.head.prev = this.head;
    this.head.next_0 = this.head;
}
defineClass(221, 45, $intern_76, LinkedHashMap, LinkedHashMap_0);
_.clear_0 = function clear_43() {
    $clear_7(this);
};
_.containsKey = function containsKey_14(key) {
    return $containsKey_6(this, key);
};
_.containsValue = function containsValue_7(value_0) {
    var node;
    node = this.head.next_0;
    while(node != this.head){
        if (equals_57(node.value_0, value_0)) return true;
        node = node.next_0;
    }
    return false;
};
_.entrySet_0 = function entrySet_7() {
    return new LinkedHashMap$EntrySet(this);
};
_.get_3 = function get_44(key) {
    return $get_16(this, key);
};
_.put = function put_8(key, value_0) {
    return $put_11(this, key, value_0);
};
_.remove_0 = function remove_80(key) {
    return $remove_22(this, key);
};
_.size_1 = function size_57() {
    return $size_2(this.map_0);
};
_.accessOrder = false;
var Ljava_util_LinkedHashMap_2_classLit = createForClass('java.util', 'LinkedHashMap', 221);
function $addToEnd(this$static) {
    var tail;
    tail = this$static.this$01.head.prev;
    this$static.prev = tail;
    this$static.next_0 = this$static.this$01.head;
    tail.next_0 = this$static.this$01.head.prev = this$static;
}
function $remove_23(this$static) {
    this$static.next_0.prev = this$static.prev;
    this$static.prev.next_0 = this$static.next_0;
    this$static.next_0 = this$static.prev = null;
}
function LinkedHashMap$ChainEntry(this$0) {
    LinkedHashMap$ChainEntry_0.call(this, this$0, null, null);
}
function LinkedHashMap$ChainEntry_0(this$0, key, value_0) {
    this.this$01 = this$0;
    AbstractMap$SimpleEntry.call(this, key, value_0);
}
defineClass(391, 388, {
    478: 1,
    388: 1,
    391: 1,
    43: 1
}, LinkedHashMap$ChainEntry, LinkedHashMap$ChainEntry_0);
var Ljava_util_LinkedHashMap$ChainEntry_2_classLit = createForClass('java.util', 'LinkedHashMap/ChainEntry', 391);
function $contains_8(this$static, o) {
    if (instanceOf(o, 43)) return $containsEntry_0(this$static.this$01, castTo(o, 43));
    return false;
}
function LinkedHashMap$EntrySet(this$0) {
    this.this$01 = this$0;
}
defineClass(699, $intern_9, $intern_10, LinkedHashMap$EntrySet);
_.clear_0 = function clear_44() {
    $clear_7(this.this$01);
};
_.contains = function contains_44(o) {
    return $contains_8(this, o);
};
_.iterator_0 = function iterator_62() {
    return new LinkedHashMap$EntrySet$EntryIterator(this);
};
_.remove_1 = function remove_81(entry) {
    var key;
    if ($contains_8(this, entry)) {
        key = castTo(entry, 43).getKey();
        $remove_22(this.this$01, key);
        return true;
    }
    return false;
};
_.size_1 = function size_58() {
    return $size_2(this.this$01.map_0);
};
var Ljava_util_LinkedHashMap$EntrySet_2_classLit = createForClass('java.util', 'LinkedHashMap/EntrySet', 699);
function $next_8(this$static) {
    checkCriticalConcurrentModification(this$static.this$11.this$01.map_0.modCount, this$static.lastModCount);
    checkCriticalElement(this$static.next_0 != this$static.this$11.this$01.head);
    this$static.last = this$static.next_0;
    this$static.next_0 = this$static.next_0.next_0;
    return this$static.last;
}
function LinkedHashMap$EntrySet$EntryIterator(this$1) {
    this.this$11 = this$1;
    this.next_0 = this$1.this$01.head.next_0;
    this.lastModCount = this$1.this$01.map_0.modCount;
}
defineClass(700, 1, $intern_6, LinkedHashMap$EntrySet$EntryIterator);
_.forEachRemaining = function forEachRemaining_30(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_33() {
    return $next_8(this);
};
_.hasNext_0 = function hasNext_32() {
    return this.next_0 != this.this$11.this$01.head;
};
_.remove = function remove_82() {
    checkCriticalState(!!this.last);
    checkCriticalConcurrentModification(this.this$11.this$01.map_0.modCount, this.lastModCount);
    $remove_23(this.last);
    $remove_6(this.this$11.this$01.map_0, this.last.key);
    this.lastModCount = this.this$11.this$01.map_0.modCount;
    this.last = null;
};
_.lastModCount = 0;
var Ljava_util_LinkedHashMap$EntrySet$EntryIterator_2_classLit = createForClass('java.util', 'LinkedHashMap/EntrySet/EntryIterator', 700);
function LinkedHashSet() {
    HashSet_2.call(this, new LinkedHashMap);
}
function LinkedHashSet_0(ignored) {
    HashSet_2.call(this, new LinkedHashMap_0(ignored));
}
function LinkedHashSet_1(c) {
    HashSet_2.call(this, new LinkedHashMap);
    $addAll(this, c);
}
defineClass(180, 50, $intern_77, LinkedHashSet, LinkedHashSet_0, LinkedHashSet_1);
var Ljava_util_LinkedHashSet_2_classLit = createForClass('java.util', 'LinkedHashSet', 180);
function $$init_3(this$static) {
    this$static.header = new LinkedList$Node;
    this$static.tail = new LinkedList$Node;
}
function $add_7(this$static, o) {
    $addNode_0(this$static, o, this$static.tail.prev, this$static.tail);
    return true;
}
function $addFirst_0(this$static, o) {
    $addNode_0(this$static, o, this$static.header, this$static.header.next_0);
}
function $addLast_0(this$static, o) {
    $addNode_0(this$static, o, this$static.tail.prev, this$static.tail);
}
function $addNode_0(this$static, o, prev, next) {
    var node;
    node = new LinkedList$Node;
    node.value_0 = o;
    node.prev = prev;
    node.next_0 = next;
    next.prev = prev.next_0 = node;
    ++this$static.size_0;
}
function $getFirst(this$static) {
    checkCriticalElement(this$static.size_0 != 0);
    return this$static.header.next_0.value_0;
}
function $getLast(this$static) {
    checkCriticalElement(this$static.size_0 != 0);
    return this$static.tail.prev.value_0;
}
function $listIterator_2(this$static, index_0) {
    var i, node;
    checkCriticalPositionIndex(index_0, this$static.size_0);
    if (index_0 >= this$static.size_0 >> 1) {
        node = this$static.tail;
        for(i = this$static.size_0; i > index_0; --i)node = node.prev;
    } else {
        node = this$static.header.next_0;
        for(i = 0; i < index_0; ++i)node = node.next_0;
    }
    return new LinkedList$ListIteratorImpl(this$static, index_0, node);
}
function $poll(this$static) {
    return this$static.size_0 == 0 ? null : (checkCriticalElement(this$static.size_0 != 0), $removeNode_0(this$static, this$static.header.next_0));
}
function $removeFirst_0(this$static) {
    checkCriticalElement(this$static.size_0 != 0);
    return $removeNode_0(this$static, this$static.header.next_0);
}
function $removeLast_0(this$static) {
    checkCriticalElement(this$static.size_0 != 0);
    return $removeNode_0(this$static, this$static.tail.prev);
}
function $removeNode_0(this$static, node) {
    var oldValue;
    oldValue = node.value_0;
    node.next_0.prev = node.prev;
    node.prev.next_0 = node.next_0;
    node.next_0 = node.prev = null;
    node.value_0 = null;
    --this$static.size_0;
    return oldValue;
}
function $reset_0(this$static) {
    this$static.header.next_0 = this$static.tail;
    this$static.tail.prev = this$static.header;
    this$static.header.prev = this$static.tail.next_0 = null;
    this$static.size_0 = 0;
}
function LinkedList() {
    $$init_3(this);
    $reset_0(this);
}
function LinkedList_0(c) {
    $$init_3(this);
    $reset_0(this);
    $addAll(this, c);
}
defineClass(67, 2008, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    67: 1,
    15: 1
}, LinkedList, LinkedList_0);
_.add_2 = function add_36(o) {
    return $add_7(this, o);
};
_.clear_0 = function clear_45() {
    $reset_0(this);
};
_.listIterator_1 = function listIterator_14(index_0) {
    return $listIterator_2(this, index_0);
};
_.size_1 = function size_59() {
    return this.size_0;
};
_.size_0 = 0;
var Ljava_util_LinkedList_2_classLit = createForClass('java.util', 'LinkedList', 67);
function $add_8(this$static, o) {
    $addNode_0(this$static.this$01, o, this$static.currentNode.prev, this$static.currentNode);
    ++this$static.currentIndex;
    this$static.lastNode = null;
}
function $hasNext_5(this$static) {
    return this$static.currentNode != this$static.this$01.tail;
}
function $next_9(this$static) {
    checkCriticalElement(this$static.currentNode != this$static.this$01.tail);
    this$static.lastNode = this$static.currentNode;
    this$static.currentNode = this$static.currentNode.next_0;
    ++this$static.currentIndex;
    return this$static.lastNode.value_0;
}
function $previous_0(this$static) {
    checkCriticalElement(this$static.currentNode.prev != this$static.this$01.header);
    this$static.lastNode = this$static.currentNode = this$static.currentNode.prev;
    --this$static.currentIndex;
    return this$static.lastNode.value_0;
}
function $remove_24(this$static) {
    var nextNode;
    checkCriticalState(!!this$static.lastNode);
    nextNode = this$static.lastNode.next_0;
    $removeNode_0(this$static.this$01, this$static.lastNode);
    this$static.currentNode == this$static.lastNode ? this$static.currentNode = nextNode : --this$static.currentIndex;
    this$static.lastNode = null;
}
function LinkedList$ListIteratorImpl(this$0, index_0, startNode) {
    this.this$01 = this$0;
    this.currentNode = startNode;
    this.currentIndex = index_0;
}
defineClass(958, 1, $intern_14, LinkedList$ListIteratorImpl);
_.forEachRemaining = function forEachRemaining_31(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_37(o) {
    $add_8(this, o);
};
_.hasNext_0 = function hasNext_33() {
    return $hasNext_5(this);
};
_.hasPrevious = function hasPrevious_6() {
    return this.currentNode.prev != this.this$01.header;
};
_.next_1 = function next_34() {
    return $next_9(this);
};
_.nextIndex_0 = function nextIndex_7() {
    return this.currentIndex;
};
_.previous_0 = function previous_7() {
    return $previous_0(this);
};
_.previousIndex = function previousIndex_6() {
    return this.currentIndex - 1;
};
_.remove = function remove_83() {
    $remove_24(this);
};
_.set_1 = function set_18(o) {
    checkCriticalState(!!this.lastNode);
    this.lastNode.value_0 = o;
};
_.currentIndex = 0;
_.lastNode = null;
var Ljava_util_LinkedList$ListIteratorImpl_2_classLit = createForClass('java.util', 'LinkedList/ListIteratorImpl', 958);
function LinkedList$Node() {}
defineClass(602, 1, {}, LinkedList$Node);
var Ljava_util_LinkedList$Node_2_classLit = createForClass('java.util', 'LinkedList/Node', 602);
function $clinit_Locale() {
    $clinit_Locale = emptyMethod;
    ROOT = new Locale$1;
    defaultLocale = new Locale$4;
}
defineClass(2003, 1, {});
var ROOT, defaultLocale;
var Ljava_util_Locale_2_classLit = createForClass('java.util', 'Locale', 2003);
function Locale$1() {}
defineClass(849, 2003, {}, Locale$1);
_.toString_0 = function toString_67() {
    return '';
};
var Ljava_util_Locale$1_2_classLit = createForClass('java.util', 'Locale/1', 849);
function Locale$4() {}
defineClass(850, 2003, {}, Locale$4);
_.toString_0 = function toString_68() {
    return 'unknown';
};
var Ljava_util_Locale$4_2_classLit = createForClass('java.util', 'Locale/4', 850);
function NoSuchElementException() {
    RuntimeException.call(this);
}
function NoSuchElementException_0() {
    RuntimeException_0.call(this, 'There is no more element.');
}
defineClass(111, 63, {
    3: 1,
    103: 1,
    63: 1,
    80: 1,
    111: 1
}, NoSuchElementException, NoSuchElementException_0);
var Ljava_util_NoSuchElementException_2_classLit = createForClass('java.util', 'NoSuchElementException', 111);
function equals_57(a, b) {
    return maskUndefined(a) === maskUndefined(b) || a != null && equals_Ljava_lang_Object__Z__devirtual$(a, b);
}
function hashCode_55(o) {
    return o != null ? hashCode__I__devirtual$(o) : 0;
}
function requireNonNull(obj) {
    if (obj == null) throw toJs(new NullPointerException);
    return obj;
}
function requireNonNull_0(obj, message) {
    if (obj == null) throw toJs(new NullPointerException_0(message));
    return obj;
}
function $clinit_Optional() {
    $clinit_Optional = emptyMethod;
    EMPTY_3 = new Optional(null);
}
function $get_17(this$static) {
    checkCriticalElement(this$static.ref != null);
    return this$static.ref;
}
function $ifPresent(this$static, consumer) {
    this$static.ref != null && $accept_2(consumer, this$static.ref);
}
function $orElse(this$static) {
    return this$static.ref != null ? this$static.ref : null;
}
function Optional(ref) {
    $clinit_Optional();
    this.ref = ref;
}
defineClass(461, 1, {
    461: 1
}, Optional);
_.equals_0 = function equals_58(obj) {
    var other;
    if (obj === this) return true;
    if (!instanceOf(obj, 461)) return false;
    other = castTo(obj, 461);
    return equals_57(this.ref, other.ref);
};
_.hashCode_1 = function hashCode_56() {
    return hashCode_55(this.ref);
};
_.toString_0 = function toString_69() {
    return this.ref != null ? 'Optional.of(' + valueOf_6(this.ref) + ')' : 'Optional.empty()';
};
var EMPTY_3;
var Ljava_util_Optional_2_classLit = createForClass('java.util', 'Optional', 461);
function $clinit_OptionalDouble() {
    $clinit_OptionalDouble = emptyMethod;
    EMPTY_4 = new OptionalDouble;
}
function $getAsDouble(this$static) {
    checkCriticalElement(this$static.present);
    return this$static.ref;
}
function $orElse_0(this$static) {
    return this$static.present ? this$static.ref : 0;
}
function $orElseGet(this$static, other) {
    return this$static.present ? this$static.ref : other.getAsDouble();
}
function OptionalDouble() {
    this.ref = 0;
    this.present = false;
}
function OptionalDouble_0(value_0) {
    $clinit_OptionalDouble();
    this.ref = value_0;
    this.present = true;
}
defineClass(403, 1, {
    403: 1
}, OptionalDouble, OptionalDouble_0);
_.equals_0 = function equals_59(obj) {
    var other;
    if (obj === this) return true;
    if (!instanceOf(obj, 403)) return false;
    other = castTo(obj, 403);
    return this.present == other.present && compare_4(this.ref, other.ref) == 0;
};
_.hashCode_1 = function hashCode_57() {
    return this.present ? round_int(this.ref) : 0;
};
_.toString_0 = function toString_70() {
    return this.present ? 'OptionalDouble.of(' + ('' + this.ref) + ')' : 'OptionalDouble.empty()';
};
_.present = false;
_.ref = 0;
var EMPTY_4;
var Ljava_util_OptionalDouble_2_classLit = createForClass('java.util', 'OptionalDouble', 403);
function $clinit_OptionalInt() {
    $clinit_OptionalInt = emptyMethod;
    EMPTY_5 = new OptionalInt;
}
function $orElse_1(this$static) {
    return this$static.present ? this$static.ref : 0;
}
function OptionalInt() {
    this.ref = 0;
    this.present = false;
}
function OptionalInt_0(value_0) {
    $clinit_OptionalInt();
    this.ref = value_0;
    this.present = true;
}
defineClass(508, 1, {
    508: 1
}, OptionalInt, OptionalInt_0);
_.equals_0 = function equals_60(obj) {
    var other;
    if (obj === this) return true;
    if (!instanceOf(obj, 508)) return false;
    other = castTo(obj, 508);
    return this.present == other.present && compare_5(this.ref, other.ref) == 0;
};
_.hashCode_1 = function hashCode_58() {
    return this.present ? this.ref : 0;
};
_.toString_0 = function toString_71() {
    return this.present ? 'OptionalInt.of(' + ('' + this.ref) + ')' : 'OptionalInt.empty()';
};
_.present = false;
_.ref = 0;
var EMPTY_5;
var Ljava_util_OptionalInt_2_classLit = createForClass('java.util', 'OptionalInt', 508);
function $addAll_4(this$static, c) {
    var e, e$iterator, oldSize;
    checkCriticalNotNull(c);
    checkCriticalArgument(c != this$static);
    oldSize = this$static.heap.array.length;
    for(e$iterator = c.iterator_0(); e$iterator.hasNext_0();){
        e = e$iterator.next_1();
        $add_3(this$static.heap, checkCriticalNotNull(e));
    }
    if (oldSize != this$static.heap.array.length) {
        $makeHeap(this$static, 0);
        return true;
    }
    return false;
}
function $makeHeap(this$static, node) {
    var rightChild;
    if (node * 2 + 1 >= this$static.heap.array.length) return;
    $makeHeap(this$static, 2 * node + 1);
    rightChild = 2 * node + 2;
    rightChild < this$static.heap.array.length && $makeHeap(this$static, rightChild);
    $mergeHeaps(this$static, node);
}
function $mergeHeaps(this$static, node) {
    var heapSize, smallestChild, value_0, leftChild, rightChild, smallestChild_0;
    heapSize = this$static.heap.array.length;
    value_0 = $get_11(this$static.heap, node);
    while(node * 2 + 1 < heapSize){
        smallestChild = (leftChild = 2 * node + 1, rightChild = leftChild + 1, smallestChild_0 = leftChild, rightChild < heapSize && this$static.cmp.compare_1($get_11(this$static.heap, rightChild), $get_11(this$static.heap, leftChild)) < 0 && (smallestChild_0 = rightChild), smallestChild_0);
        if (this$static.cmp.compare_1(value_0, $get_11(this$static.heap, smallestChild)) < 0) break;
        $set_1(this$static.heap, node, $get_11(this$static.heap, smallestChild));
        node = smallestChild;
    }
    $set_1(this$static.heap, node, value_0);
}
function $offer(this$static, e) {
    var childNode, node;
    checkCriticalNotNull(e);
    node = this$static.heap.array.length;
    $add_3(this$static.heap, e);
    while(node > 0){
        childNode = node;
        node = (node - 1) / 2 | 0;
        if (this$static.cmp.compare_1($get_11(this$static.heap, node), e) <= 0) {
            $set_1(this$static.heap, childNode, e);
            return true;
        }
        $set_1(this$static.heap, childNode, $get_11(this$static.heap, node));
    }
    $set_1(this$static.heap, node, e);
    return true;
}
function $poll_0(this$static) {
    var value_0;
    value_0 = this$static.heap.array.length == 0 ? null : $get_11(this$static.heap, 0);
    value_0 != null && $removeAtIndex_0(this$static, 0);
    return value_0;
}
function $remove_25(this$static, o) {
    var index_0;
    index_0 = o == null ? -1 : $indexOf_3(this$static.heap, o, 0);
    if (index_0 < 0) return false;
    $removeAtIndex_0(this$static, index_0);
    return true;
}
function $removeAtIndex_0(this$static, index_0) {
    var lastValue;
    lastValue = $remove_11(this$static.heap, this$static.heap.array.length - 1);
    if (index_0 < this$static.heap.array.length) {
        $set_1(this$static.heap, index_0, lastValue);
        $mergeHeaps(this$static, index_0);
    }
}
function PriorityQueue(comparator) {
    this.heap = new ArrayList_0(11);
    this.cmp = ($clinit_Comparators(), comparator);
}
defineClass(494, 2049, $intern_8, PriorityQueue);
_.addAll = function addAll_18(c) {
    return $addAll_4(this, c);
};
_.clear_0 = function clear_46() {
    setLength(this.heap.array, 0);
};
_.contains = function contains_45(o) {
    return (o == null ? -1 : $indexOf_3(this.heap, o, 0)) != -1;
};
_.iterator_0 = function iterator_63() {
    return new PriorityQueue$1(this);
};
_.remove_1 = function remove_84(o) {
    return $remove_25(this, o);
};
_.size_1 = function size_60() {
    return this.heap.array.length;
};
_.spliterator_0 = function spliterator_33() {
    return new Spliterators$IteratorSpliterator(this, 256);
};
_.toArray = function toArray_19() {
    return clone_0(this.heap.array);
};
_.toArray_0 = function toArray_20(a) {
    return $toArray_1(this.heap, a);
};
var Ljava_util_PriorityQueue_2_classLit = createForClass('java.util', 'PriorityQueue', 494);
function PriorityQueue$1(this$0) {
    this.this$01 = this$0;
}
defineClass(1249, 1, $intern_6, PriorityQueue$1);
_.forEachRemaining = function forEachRemaining_32(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_34() {
    return this.i < this.this$01.heap.array.length;
};
_.next_1 = function next_35() {
    checkCriticalElement(this.i < this.this$01.heap.array.length);
    this.last = this.i++;
    return $get_11(this.this$01.heap, this.last);
};
_.remove = function remove_85() {
    checkCriticalState(this.last != -1);
    $removeAtIndex_0(this.this$01, this.i = this.last);
    this.last = -1;
};
_.i = 0;
_.last = -1;
var Ljava_util_PriorityQueue$1_2_classLit = createForClass('java.util', 'PriorityQueue/1', 1249);
function $clinit_Random() {
    $clinit_Random = emptyMethod;
    var i, i0, twoToTheXMinus24Tmp, twoToTheXMinus48Tmp;
    twoToTheXMinus24 = initUnidimensionalArray(D_classLit, $intern_66, 30, 25, 15, 1);
    twoToTheXMinus48 = initUnidimensionalArray(D_classLit, $intern_66, 30, 33, 15, 1);
    twoToTheXMinus48Tmp = 1.52587890625E-5;
    for(i0 = 32; i0 >= 0; i0--){
        twoToTheXMinus48[i0] = twoToTheXMinus48Tmp;
        twoToTheXMinus48Tmp *= 0.5;
    }
    twoToTheXMinus24Tmp = 1;
    for(i = 24; i >= 0; i--){
        twoToTheXMinus24[i] = twoToTheXMinus24Tmp;
        twoToTheXMinus24Tmp *= 0.5;
    }
}
function $nextDouble(this$static) {
    return $nextInternal(this$static, 26) * $intern_78 + $nextInternal(this$static, 27) * $intern_79;
}
function $nextInt(this$static, n) {
    var bits, val;
    checkCriticalArgument(n > 0);
    if ((n & -n) == n) return round_int(n * $nextInternal(this$static, 31) * 4.6566128730773926E-10);
    do {
        bits = $nextInternal(this$static, 31);
        val = bits % n;
    }while (bits - val + (n - 1) < 0);
    return round_int(val);
}
function $nextInternal(this$static, bits) {
    var carry, dval, h, hi, l, lo;
    hi = this$static.seedhi * $intern_80 + this$static.seedlo * 1502;
    lo = this$static.seedlo * $intern_80 + 11;
    carry = $wnd.Math.floor(lo * $intern_81);
    hi += carry;
    lo -= carry * $intern_82;
    hi %= $intern_82;
    this$static.seedhi = hi;
    this$static.seedlo = lo;
    if (bits <= 24) return $wnd.Math.floor(this$static.seedhi * twoToTheXMinus24[bits]);
    else {
        h = this$static.seedhi * (1 << bits - 24);
        l = $wnd.Math.floor(this$static.seedlo * twoToTheXMinus48[bits]);
        dval = h + l;
        dval >= 2147483648 && (dval -= 4294967296);
        return dval;
    }
}
function $nextLong(this$static) {
    return add_20(shl_0(fromDouble_0($nextInternal(this$static, 32)), 32), fromDouble_0($nextInternal(this$static, 32)));
}
function $setSeed(this$static, seedhi, seedlo) {
    this$static.seedhi = seedhi ^ 1502;
    this$static.seedlo = seedlo ^ $intern_80;
}
function $setSeed_0(this$static, seed) {
    $setSeed(this$static, toInt_0(and_0(shr_0(seed, 24), $intern_83)), toInt_0(and_0(seed, $intern_83)));
}
function Random() {
    $clinit_Random();
    var hi, lo, seed;
    seed = uniqueSeed++ + Date.now();
    hi = round_int($wnd.Math.floor(seed * $intern_81)) & $intern_83;
    lo = round_int(seed - hi * $intern_82);
    this.seedhi = hi ^ 1502;
    this.seedlo = lo ^ $intern_80;
}
function Random_0(seed) {
    $clinit_Random();
    $setSeed(this, toInt_0(and_0(shr_0(seed, 24), $intern_83)), toInt_0(and_0(seed, $intern_83)));
}
defineClass(233, 1, {
    233: 1
}, Random, Random_0);
_.seedhi = 0;
_.seedlo = 0;
var twoToTheXMinus24, twoToTheXMinus48, uniqueSeed = 0;
var Ljava_util_Random_2_classLit = createForClass('java.util', 'Random', 233);
function $initIterator(this$static) {
    if (!this$static.it) {
        this$static.it = this$static.collection.iterator_0();
        this$static.estimateSize = this$static.collection.size_1();
    }
}
function $tryAdvance(this$static, consumer) {
    checkCriticalNotNull(consumer);
    $initIterator(this$static);
    if (this$static.it.hasNext_0()) {
        consumer.accept(this$static.it.next_1());
        return true;
    }
    return false;
}
function Spliterators$IteratorSpliterator(collection, characteristics) {
    this.collection = (checkCriticalNotNull(collection), collection);
    this.characteristics = (characteristics & $intern_62) == 0 ? characteristics | 64 | $intern_17 : characteristics;
}
function Spliterators$IteratorSpliterator_0(it) {
    this.it = (checkCriticalNotNull(it), it);
    this.characteristics = 0;
    this.estimateSize = $intern_21;
}
function Spliterators$IteratorSpliterator_1(it, size_0) {
    this.it = (checkCriticalNotNull(it), it);
    this.characteristics = 16449;
    this.estimateSize = size_0;
}
defineClass(26, 1, $intern_18, Spliterators$IteratorSpliterator, Spliterators$IteratorSpliterator_0, Spliterators$IteratorSpliterator_1);
_.hasCharacteristics = function hasCharacteristics_2(characteristics) {
    return (this.characteristics & characteristics) != 0;
};
_.characteristics_0 = function characteristics_3() {
    return this.characteristics;
};
_.estimateSize_0 = function estimateSize_2() {
    $initIterator(this);
    return this.estimateSize;
};
_.forEachRemaining = function forEachRemaining_33(consumer) {
    $initIterator(this);
    this.it.forEachRemaining(consumer);
};
_.tryAdvance = function tryAdvance_2(consumer) {
    return $tryAdvance(this, consumer);
};
_.characteristics = 0;
_.estimateSize = 0;
var Ljava_util_Spliterators$IteratorSpliterator_2_classLit = createForClass('java.util', 'Spliterators/IteratorSpliterator', 26);
function SortedSet$1($anonymous0) {
    Spliterators$IteratorSpliterator.call(this, $anonymous0, 21);
}
defineClass(479, 26, $intern_18, SortedSet$1);
var Ljava_util_SortedSet$1_2_classLit = createForClass('java.util', 'SortedSet/1', 479);
function $forEachRemaining_1(this$static, consumer) {
    while(this$static.tryAdvance_0(consumer));
}
function Spliterator$OfDouble$0methodref$accept$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(595, 1, $intern_75, Spliterator$OfDouble$0methodref$accept$Type);
_.accept_2 = function accept_17(arg0) {
    this.$$outer_0.accept(arg0);
};
var Ljava_util_Spliterator$OfDouble$0methodref$accept$Type_2_classLit = createForClass('java.util', 'Spliterator/OfDouble/0methodref$accept$Type', 595);
function Spliterator$OfDouble$1methodref$accept$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(596, 1, $intern_75, Spliterator$OfDouble$1methodref$accept$Type);
_.accept_2 = function accept_18(arg0) {
    this.$$outer_0.accept(arg0);
};
var Ljava_util_Spliterator$OfDouble$1methodref$accept$Type_2_classLit = createForClass('java.util', 'Spliterator/OfDouble/1methodref$accept$Type', 596);
function Spliterator$OfInt$2methodref$accept$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(597, 1, $intern_20, Spliterator$OfInt$2methodref$accept$Type);
_.accept_0 = function accept_19(arg0) {
    this.$$outer_0.accept(valueOf_3(arg0));
};
var Ljava_util_Spliterator$OfInt$2methodref$accept$Type_2_classLit = createForClass('java.util', 'Spliterator/OfInt/2methodref$accept$Type', 597);
function Spliterator$OfInt$3methodref$accept$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(598, 1, $intern_20, Spliterator$OfInt$3methodref$accept$Type);
_.accept_0 = function accept_20(arg0) {
    this.$$outer_0.accept(valueOf_3(arg0));
};
var Ljava_util_Spliterator$OfInt$3methodref$accept$Type_2_classLit = createForClass('java.util', 'Spliterator/OfInt/3methodref$accept$Type', 598);
function checkCriticalArrayBounds(end, length_0) {
    if (0 > end || end > length_0) throw toJs(new ArrayIndexOutOfBoundsException_0('fromIndex: 0, toIndex: ' + end + ', length: ' + length_0));
}
function Spliterators$BaseSpliterator(size_0, characteristics) {
    this.sizeEstimate = size_0;
    this.characteristics = (characteristics & 64) != 0 ? characteristics | $intern_17 : characteristics;
}
defineClass(610, 1, $intern_18);
_.forEachRemaining = function forEachRemaining_34(consumer) {
    $forEachRemaining_0(this, consumer);
};
_.hasCharacteristics = function hasCharacteristics_3(characteristics) {
    return (this.characteristics & characteristics) != 0;
};
_.characteristics_0 = function characteristics_4() {
    return this.characteristics;
};
_.estimateSize_0 = function estimateSize_3() {
    return this.sizeEstimate;
};
_.characteristics = 0;
_.sizeEstimate = 0;
var Ljava_util_Spliterators$BaseSpliterator_2_classLit = createForClass('java.util', 'Spliterators/BaseSpliterator', 610);
function Spliterators$AbstractDoubleSpliterator(size_0, characteristics) {
    Spliterators$BaseSpliterator.call(this, size_0, characteristics);
}
defineClass(719, 610, $intern_18);
_.forEachRemaining_0 = function forEachRemaining_35(consumer) {
    $forEachRemaining_1(this, consumer);
};
_.forEachRemaining = function forEachRemaining_36(consumer) {
    instanceOf(consumer, 189) ? $forEachRemaining_1(this, castTo(consumer, 189)) : $forEachRemaining_1(this, new Spliterator$OfDouble$1methodref$accept$Type(consumer));
};
_.tryAdvance = function tryAdvance_3(consumer) {
    return instanceOf(consumer, 189) ? this.tryAdvance_0(castTo(consumer, 189)) : this.tryAdvance_0(new Spliterator$OfDouble$0methodref$accept$Type(consumer));
};
var Ljava_util_Spliterators$AbstractDoubleSpliterator_2_classLit = createForClass('java.util', 'Spliterators/AbstractDoubleSpliterator', 719);
function Spliterators$AbstractIntSpliterator(size_0, characteristics) {
    Spliterators$BaseSpliterator.call(this, size_0, characteristics);
}
defineClass(718, 610, $intern_18);
_.forEachRemaining_0 = function forEachRemaining_37(consumer) {
    $forEachRemaining_1(this, consumer);
};
_.forEachRemaining = function forEachRemaining_38(consumer) {
    instanceOf(consumer, 202) ? $forEachRemaining_1(this, castTo(consumer, 202)) : $forEachRemaining_1(this, new Spliterator$OfInt$3methodref$accept$Type(consumer));
};
_.tryAdvance = function tryAdvance_4(consumer) {
    return instanceOf(consumer, 202) ? this.tryAdvance_0(castTo(consumer, 202)) : this.tryAdvance_0(new Spliterator$OfInt$2methodref$accept$Type(consumer));
};
var Ljava_util_Spliterators$AbstractIntSpliterator_2_classLit = createForClass('java.util', 'Spliterators/AbstractIntSpliterator', 718);
function Spliterators$AbstractSpliterator(size_0, characteristics) {
    Spliterators$BaseSpliterator.call(this, size_0, characteristics);
}
defineClass(484, 610, $intern_18);
var Ljava_util_Spliterators$AbstractSpliterator_2_classLit = createForClass('java.util', 'Spliterators/AbstractSpliterator', 484);
function $forEachRemaining_2(this$static, consumer) {
    checkCriticalNotNull(consumer);
    while(this$static.index_0 < this$static.limit)this$static.consume(consumer, this$static.index_0++);
}
function $tryAdvance_0(this$static, consumer) {
    checkCriticalNotNull(consumer);
    if (this$static.index_0 < this$static.limit) {
        this$static.consume(consumer, this$static.index_0++);
        return true;
    }
    return false;
}
function Spliterators$BaseArraySpliterator(limit, characteristics) {
    this.index_0 = 0;
    this.limit = limit;
    this.characteristics = characteristics | 64 | $intern_17;
}
defineClass(690, 1, $intern_18);
_.forEachRemaining = function forEachRemaining_39(consumer) {
    $forEachRemaining_0(this, consumer);
};
_.hasCharacteristics = function hasCharacteristics_4(characteristics) {
    return (this.characteristics & characteristics) != 0;
};
_.characteristics_0 = function characteristics_5() {
    return this.characteristics;
};
_.estimateSize_0 = function estimateSize_4() {
    return this.limit - this.index_0;
};
_.characteristics = 0;
_.index_0 = 0;
_.limit = 0;
var Ljava_util_Spliterators$BaseArraySpliterator_2_classLit = createForClass('java.util', 'Spliterators/BaseArraySpliterator', 690);
function $consume(this$static, consumer, index_0) {
    consumer.accept(this$static.array[index_0]);
}
function Spliterators$ArraySpliterator(array, limit) {
    Spliterators$BaseArraySpliterator.call(this, limit, 1040);
    this.array = array;
}
defineClass(938, 690, $intern_18, Spliterators$ArraySpliterator);
_.consume = function consume(consumer, index_0) {
    $consume(this, castTo(consumer, 40), index_0);
};
_.forEachRemaining = function forEachRemaining_40(consumer) {
    $forEachRemaining_2(this, consumer);
};
_.tryAdvance = function tryAdvance_5(consumer) {
    return $tryAdvance_0(this, consumer);
};
var Ljava_util_Spliterators$ArraySpliterator_2_classLit = createForClass('java.util', 'Spliterators/ArraySpliterator', 938);
function $consume_0(this$static, consumer, index_0) {
    consumer.accept_2(this$static.array[index_0]);
}
function Spliterators$DoubleArraySpliterator(array, characteristics) {
    Spliterators$DoubleArraySpliterator_0.call(this, array, array.length, characteristics);
}
function Spliterators$DoubleArraySpliterator_0(array, limit, characteristics) {
    Spliterators$BaseArraySpliterator.call(this, limit, characteristics);
    this.array = array;
}
defineClass(691, 690, $intern_18, Spliterators$DoubleArraySpliterator);
_.consume = function consume_0(consumer, index_0) {
    $consume_0(this, castTo(consumer, 189), index_0);
};
_.forEachRemaining_0 = function forEachRemaining_41(consumer) {
    $forEachRemaining_2(this, consumer);
};
_.forEachRemaining = function forEachRemaining_42(consumer) {
    instanceOf(consumer, 189) ? $forEachRemaining_2(this, castTo(consumer, 189)) : $forEachRemaining_2(this, new Spliterator$OfDouble$1methodref$accept$Type(consumer));
};
_.tryAdvance_0 = function tryAdvance_6(consumer) {
    return $tryAdvance_0(this, consumer);
};
_.tryAdvance = function tryAdvance_7(consumer) {
    return instanceOf(consumer, 189) ? $tryAdvance_0(this, castTo(consumer, 189)) : $tryAdvance_0(this, new Spliterator$OfDouble$0methodref$accept$Type(consumer));
};
var Ljava_util_Spliterators$DoubleArraySpliterator_2_classLit = createForClass('java.util', 'Spliterators/DoubleArraySpliterator', 691);
function $clinit_Spliterators$EmptySpliterator() {
    $clinit_Spliterators$EmptySpliterator = emptyMethod;
    $clinit_Spliterators$EmptySpliterator();
    OF_INT = new Spliterators$EmptySpliterator$OfInt;
}
defineClass(2012, 1, $intern_18);
_.forEachRemaining = function forEachRemaining_43(consumer) {
    $forEachRemaining_0(this, consumer);
};
_.hasCharacteristics = function hasCharacteristics_5(characteristics) {
    return (16448 & characteristics) != 0;
};
_.characteristics_0 = function characteristics_6() {
    return 16448;
};
_.estimateSize_0 = function estimateSize_5() {
    return 0;
};
var OF_INT;
var Ljava_util_Spliterators$EmptySpliterator_2_classLit = createForClass('java.util', 'Spliterators/EmptySpliterator', 2012);
function $forEachRemaining_3(consumer) {
    checkCriticalNotNull(consumer);
}
function $tryAdvance_1(consumer) {
    return checkCriticalNotNull(consumer), false;
}
function Spliterators$EmptySpliterator$OfInt() {}
defineClass(937, 2012, $intern_18, Spliterators$EmptySpliterator$OfInt);
_.forEachRemaining_0 = function forEachRemaining_44(consumer) {
    $forEachRemaining_3(consumer);
};
_.forEachRemaining = function forEachRemaining_45(consumer) {
    instanceOf(consumer, 202) ? $forEachRemaining_3(castTo(consumer, 202)) : $forEachRemaining_3(new Spliterator$OfInt$3methodref$accept$Type(consumer));
};
_.tryAdvance_0 = function tryAdvance_8(consumer) {
    return $tryAdvance_1(consumer);
};
_.tryAdvance = function tryAdvance_9(consumer) {
    return instanceOf(consumer, 202) ? $tryAdvance_1(castTo(consumer, 202)) : $tryAdvance_1(new Spliterator$OfInt$2methodref$accept$Type(consumer));
};
var Ljava_util_Spliterators$EmptySpliterator$OfInt_2_classLit = createForClass('java.util', 'Spliterators/EmptySpliterator/OfInt', 937);
function $addElement(this$static, o) {
    $add_3(this$static.arrayList, o);
}
function $elementAt(this$static, index_0) {
    return checkArrayElementIndex(index_0, this$static.arrayList.array.length), $get_11(this$static.arrayList, index_0);
}
function $setElementAt(this$static, o, index_0) {
    checkArrayElementIndex(index_0, this$static.arrayList.array.length);
    $set_1(this$static.arrayList, index_0, o);
}
function Vector() {
    this.arrayList = new ArrayList;
}
function checkArrayElementIndex(index_0, size_0) {
    if (index_0 < 0 || index_0 >= size_0) throw toJs(new ArrayIndexOutOfBoundsException);
}
defineClass(571, 55, $intern_84, Vector);
_.add_3 = function add_38(index_0, o) {
    checkArrayElementIndex(index_0, this.arrayList.array.length + 1);
    $add_2(this.arrayList, index_0, o);
};
_.add_2 = function add_39(o) {
    return $add_3(this.arrayList, o);
};
_.addAll_0 = function addAll_19(index_0, c) {
    checkArrayElementIndex(index_0, this.arrayList.array.length + 1);
    return $addAll_1(this.arrayList, index_0, c);
};
_.addAll = function addAll_20(c) {
    return $addAll_2(this.arrayList, c);
};
_.clear_0 = function clear_47() {
    setLength(this.arrayList.array, 0);
};
_.contains = function contains_46(elem) {
    return $indexOf_3(this.arrayList, elem, 0) != -1;
};
_.containsAll = function containsAll_9(c) {
    return $containsAll(this.arrayList, c);
};
_.forEach_0 = function forEach_23(consumer) {
    $forEach_1(this.arrayList, consumer);
};
_.get_0 = function get_45(index_0) {
    return checkArrayElementIndex(index_0, this.arrayList.array.length), $get_11(this.arrayList, index_0);
};
_.indexOf_0 = function indexOf_6(elem) {
    return $indexOf_3(this.arrayList, elem, 0);
};
_.isEmpty = function isEmpty_24() {
    return this.arrayList.array.length == 0;
};
_.iterator_0 = function iterator_64() {
    return new ArrayList$1(this.arrayList);
};
_.remove_2 = function remove_86(index_0) {
    return checkArrayElementIndex(index_0, this.arrayList.array.length), $remove_11(this.arrayList, index_0);
};
_.removeRange = function removeRange_2(fromIndex, endIndex) {
    $removeRange(this.arrayList, fromIndex, endIndex);
};
_.set_2 = function set_19(index_0, elem) {
    return checkArrayElementIndex(index_0, this.arrayList.array.length), $set_1(this.arrayList, index_0, elem);
};
_.size_1 = function size_61() {
    return this.arrayList.array.length;
};
_.sort_0 = function sort_8(c) {
    $sort(this.arrayList, c);
};
_.subList = function subList_8(fromIndex, toIndex) {
    return new AbstractList$SubList(this.arrayList, fromIndex, toIndex);
};
_.toArray = function toArray_21() {
    return clone_0(this.arrayList.array);
};
_.toArray_0 = function toArray_22(a) {
    return $toArray_1(this.arrayList, a);
};
_.toString_0 = function toString_72() {
    return $toString_2(this.arrayList);
};
var Ljava_util_Vector_2_classLit = createForClass('java.util', 'Vector', 571);
function $pop(this$static) {
    var sz;
    sz = this$static.arrayList.array.length;
    if (sz > 0) return checkArrayElementIndex(sz - 1, this$static.arrayList.array.length), $remove_11(this$static.arrayList, sz - 1);
    else throw toJs(new EmptyStackException);
}
function $push(this$static, o) {
    $add_3(this$static.arrayList, o);
    return o;
}
function Stack() {
    Vector.call(this);
}
defineClass(803, 571, $intern_84, Stack);
var Ljava_util_Stack_2_classLit = createForClass('java.util', 'Stack', 803);
function $add_9(this$static, newElement) {
    !this$static.builder ? this$static.builder = new StringBuilder_1(this$static.prefix) : $append_11(this$static.builder, this$static.delimiter);
    $append_8(this$static.builder, newElement);
    return this$static;
}
function $merge(this$static, other) {
    var otherLength;
    if (other.builder) {
        otherLength = other.builder.string.length;
        !this$static.builder ? this$static.builder = new StringBuilder_1(this$static.prefix) : $append_11(this$static.builder, this$static.delimiter);
        $append_9(this$static.builder, other.builder, other.prefix.length, otherLength);
    }
    return this$static;
}
function $toString_9(this$static) {
    return !this$static.builder ? this$static.emptyValue : this$static.suffix.length == 0 ? this$static.builder.string : this$static.builder.string + ('' + this$static.suffix);
}
function StringJoiner(delimiter, prefix, suffix) {
    this.delimiter = (checkCriticalNotNull(delimiter), delimiter);
    this.prefix = (checkCriticalNotNull(prefix), prefix);
    this.suffix = (checkCriticalNotNull(suffix), suffix);
    this.emptyValue = this.prefix + ('' + this.suffix);
}
defineClass(212, 1, {
    212: 1
}, StringJoiner);
_.toString_0 = function toString_73() {
    return $toString_9(this);
};
var Ljava_util_StringJoiner_2_classLit = createForClass('java.util', 'StringJoiner', 212);
function $clear_8(this$static) {
    this$static.root = null;
    this$static.size_0 = 0;
}
function $getEntry_1(this$static, key) {
    var c, childNum, tree;
    tree = this$static.root;
    while(tree){
        c = this$static.cmp.compare_1(key, tree.key);
        if (c == 0) return tree;
        childNum = c < 0 ? 0 : 1;
        tree = tree.child[childNum];
    }
    return null;
}
function $getFirstEntry(this$static) {
    var nextNode, node;
    if (!this$static.root) return null;
    node = this$static.root;
    while(nextNode = node.child[0])node = nextNode;
    return node;
}
function $getLastEntry(this$static) {
    var nextNode, node;
    if (!this$static.root) return null;
    node = this$static.root;
    while(nextNode = node.child[1])node = nextNode;
    return node;
}
function $getNodeAfter(this$static, key, inclusive) {
    var c, foundNode, node;
    foundNode = null;
    node = this$static.root;
    while(node){
        c = this$static.cmp.compare_1(key, node.key);
        if (inclusive && c == 0) return node;
        if (c >= 0) node = node.child[1];
        else {
            foundNode = node;
            node = node.child[0];
        }
    }
    return foundNode;
}
function $getNodeBefore(this$static, key, inclusive) {
    var c, foundNode, node;
    foundNode = null;
    node = this$static.root;
    while(node){
        c = this$static.cmp.compare_1(key, node.key);
        if (inclusive && c == 0) return node;
        if (c <= 0) node = node.child[0];
        else {
            foundNode = node;
            node = node.child[1];
        }
    }
    return foundNode;
}
function $headMap(this$static, toKey, inclusive) {
    return new TreeMap$SubMap(this$static, ($clinit_TreeMap$SubMapType(), Head), null, false, toKey, inclusive);
}
function $inOrderAdd(this$static, list, type_0, current, fromKey, fromInclusive, toKey, toInclusive) {
    var leftNode, rightNode;
    if (!current) return;
    leftNode = current.child[0];
    !!leftNode && $inOrderAdd(this$static, list, type_0, leftNode, fromKey, fromInclusive, toKey, toInclusive);
    $inRange(this$static, type_0, current.key, fromKey, fromInclusive, toKey, toInclusive) && list.add_2(current);
    rightNode = current.child[1];
    !!rightNode && $inOrderAdd(this$static, list, type_0, rightNode, fromKey, fromInclusive, toKey, toInclusive);
}
function $inRange(this$static, type_0, key, fromKey, fromInclusive, toKey, toInclusive) {
    var compare, compare0;
    if (type_0.fromKeyValid() && (compare0 = this$static.cmp.compare_1(key, fromKey), compare0 < 0 || !fromInclusive && compare0 == 0)) return false;
    if (type_0.toKeyValid() && (compare = this$static.cmp.compare_1(key, toKey), compare > 0 || !toInclusive && compare == 0)) return false;
    return true;
}
function $insert_1(this$static, tree, newNode, state) {
    var c, childNum;
    if (!tree) return newNode;
    else {
        c = this$static.cmp.compare_1(newNode.key, tree.key);
        if (c == 0) {
            state.value_0 = $setValue_0(tree, newNode.value_0);
            state.found = true;
            return tree;
        }
        childNum = c < 0 ? 0 : 1;
        tree.child[childNum] = $insert_1(this$static, tree.child[childNum], newNode, state);
        if ($isRed(tree.child[childNum])) {
            if ($isRed(tree.child[1 - childNum])) {
                tree.isRed = true;
                tree.child[0].isRed = false;
                tree.child[1].isRed = false;
            } else $isRed(tree.child[childNum].child[childNum]) ? tree = $rotateSingle(tree, 1 - childNum) : $isRed(tree.child[childNum].child[1 - childNum]) && (tree = $rotateDouble(tree, 1 - childNum));
        }
    }
    return tree;
}
function $isRed(node) {
    return !!node && node.isRed;
}
function $put_12(this$static, key, value_0) {
    var node, state;
    node = new TreeMap$Node(key, value_0);
    state = new TreeMap$State;
    this$static.root = $insert_1(this$static, this$static.root, node, state);
    state.found || ++this$static.size_0;
    this$static.root.isRed = false;
    return state.value_0;
}
function $remove_26(this$static, k) {
    var key, state;
    key = k;
    state = new TreeMap$State;
    $removeWithState(this$static, key, state);
    return state.value_0;
}
function $removeEntry(this$static, entry) {
    var state;
    state = new TreeMap$State;
    state.matchValue = true;
    state.value_0 = entry.getValue();
    return $removeWithState(this$static, entry.getKey(), state);
}
function $removeWithState(this$static, key, state) {
    var c, dir_0, dir2, found, grandparent, head, last, newNode, node, parent_0, sibling;
    if (!this$static.root) return false;
    found = null;
    parent_0 = null;
    head = new TreeMap$Node(null, null);
    dir_0 = 1;
    head.child[1] = this$static.root;
    node = head;
    while(node.child[dir_0]){
        last = dir_0;
        grandparent = parent_0;
        parent_0 = node;
        node = node.child[dir_0];
        c = this$static.cmp.compare_1(key, node.key);
        dir_0 = c < 0 ? 0 : 1;
        c == 0 && (!state.matchValue || equals_57(node.value_0, state.value_0)) && (found = node);
        if (!(!!node && node.isRed) && !$isRed(node.child[dir_0])) {
            if ($isRed(node.child[1 - dir_0])) parent_0 = parent_0.child[last] = $rotateSingle(node, dir_0);
            else if (!$isRed(node.child[1 - dir_0])) {
                sibling = parent_0.child[1 - last];
                if (sibling) {
                    if (!$isRed(sibling.child[1 - last]) && !$isRed(sibling.child[last])) {
                        parent_0.isRed = false;
                        sibling.isRed = true;
                        node.isRed = true;
                    } else {
                        dir2 = grandparent.child[1] == parent_0 ? 1 : 0;
                        $isRed(sibling.child[last]) ? grandparent.child[dir2] = $rotateDouble(parent_0, last) : $isRed(sibling.child[1 - last]) && (grandparent.child[dir2] = $rotateSingle(parent_0, last));
                        node.isRed = grandparent.child[dir2].isRed = true;
                        grandparent.child[dir2].child[0].isRed = false;
                        grandparent.child[dir2].child[1].isRed = false;
                    }
                }
            }
        }
    }
    if (found) {
        state.found = true;
        state.value_0 = found.value_0;
        if (node != found) {
            newNode = new TreeMap$Node(node.key, node.value_0);
            $replaceNode(this$static, head, found, newNode);
            parent_0 == found && (parent_0 = newNode);
        }
        parent_0.child[parent_0.child[1] == node ? 1 : 0] = node.child[!node.child[0] ? 1 : 0];
        --this$static.size_0;
    }
    this$static.root = head.child[1];
    !!this$static.root && (this$static.root.isRed = false);
    return state.found;
}
function $replaceNode(this$static, head, node, newNode) {
    var direction, parent_0;
    parent_0 = head;
    direction = parent_0.key == null || this$static.cmp.compare_1(node.key, parent_0.key) > 0 ? 1 : 0;
    while(parent_0.child[direction] != node){
        parent_0 = parent_0.child[direction];
        direction = this$static.cmp.compare_1(node.key, parent_0.key) > 0 ? 1 : 0;
    }
    parent_0.child[direction] = newNode;
    newNode.isRed = node.isRed;
    newNode.child[0] = node.child[0];
    newNode.child[1] = node.child[1];
    node.child[0] = null;
    node.child[1] = null;
}
function $rotateDouble(tree, rotateDirection) {
    var otherChildDir;
    otherChildDir = 1 - rotateDirection;
    tree.child[otherChildDir] = $rotateSingle(tree.child[otherChildDir], otherChildDir);
    return $rotateSingle(tree, rotateDirection);
}
function $rotateSingle(tree, rotateDirection) {
    var otherChildDir, save;
    otherChildDir = 1 - rotateDirection;
    save = tree.child[otherChildDir];
    tree.child[otherChildDir] = save.child[rotateDirection];
    save.child[rotateDirection] = tree;
    tree.isRed = true;
    save.isRed = false;
    return save;
}
function $subMap(this$static, fromKey, fromInclusive, toKey, toInclusive) {
    return new TreeMap$SubMap(this$static, ($clinit_TreeMap$SubMapType(), Range_1), fromKey, fromInclusive, toKey, toInclusive);
}
function $tailMap(this$static, fromKey, inclusive) {
    return new TreeMap$SubMap(this$static, ($clinit_TreeMap$SubMapType(), Tail), fromKey, inclusive, null, false);
}
function TreeMap() {
    TreeMap_0.call(this, null);
}
function TreeMap_0(c) {
    this.root = null;
    this.cmp = ($clinit_Comparators(), !c ? INTERNAL_NATURAL_ORDER : c);
}
defineClass(538, 2036, {
    3: 1,
    91: 1,
    137: 1,
    134: 1
}, TreeMap, TreeMap_0);
_.clear_0 = function clear_48() {
    $clear_8(this);
};
_.entryIterator_0 = function entryIterator_5() {
    return new TreeMap$EntryIterator(this);
};
_.entrySet_0 = function entrySet_8() {
    return new TreeMap$EntrySet(this);
};
_.getCeilingEntry = function getCeilingEntry(key) {
    return $getNodeAfter(this, key, true);
};
_.getEntry = function getEntry(key) {
    return $getEntry_1(this, key);
};
_.getFirstEntry = function getFirstEntry() {
    return $getFirstEntry(this);
};
_.getFloorEntry = function getFloorEntry(key) {
    return $getNodeBefore(this, key, true);
};
_.getHigherEntry = function getHigherEntry(key) {
    return $getNodeAfter(this, key, false);
};
_.getLastEntry = function getLastEntry() {
    return $getLastEntry(this);
};
_.getLowerEntry = function getLowerEntry(key) {
    return $getNodeBefore(this, key, false);
};
_.headMap = function headMap_0(toKey, inclusive) {
    return $headMap(this, toKey, inclusive);
};
_.put = function put_9(key, value_0) {
    return $put_12(this, key, value_0);
};
_.remove_0 = function remove_87(k) {
    return $remove_26(this, k);
};
_.removeEntry = function removeEntry(entry) {
    return $removeEntry(this, entry);
};
_.size_1 = function size_62() {
    return this.size_0;
};
_.tailMap = function tailMap_0(fromKey, inclusive) {
    return $tailMap(this, fromKey, inclusive);
};
_.size_0 = 0;
var Ljava_util_TreeMap_2_classLit = createForClass('java.util', 'TreeMap', 538);
function $next_10(this$static) {
    return this$static.last = castTo($next_4(this$static.iter), 43);
}
function $remove_27(this$static) {
    $remove_8(this$static.iter);
    $removeEntry(this$static.this$01, this$static.last);
    this$static.last = null;
}
function TreeMap$EntryIterator(this$0) {
    TreeMap$EntryIterator_0.call(this, this$0, ($clinit_TreeMap$SubMapType(), All), null, false, null, false);
}
function TreeMap$EntryIterator_0(this$0, type_0, fromKey, fromInclusive, toKey, toInclusive) {
    var list;
    this.this$01 = this$0;
    list = new ArrayList;
    $inOrderAdd(this$0, list, type_0, this$0.root, fromKey, fromInclusive, toKey, toInclusive);
    this.iter = new AbstractList$ListIteratorImpl(list, 0);
}
defineClass(539, 1, $intern_6, TreeMap$EntryIterator, TreeMap$EntryIterator_0);
_.forEachRemaining = function forEachRemaining_46(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_36() {
    return $next_10(this);
};
_.hasNext_0 = function hasNext_35() {
    return $hasNext_2(this.iter);
};
_.remove = function remove_88() {
    $remove_27(this);
};
var Ljava_util_TreeMap$EntryIterator_2_classLit = createForClass('java.util', 'TreeMap/EntryIterator', 539);
function TreeMap$EntrySet(this$0) {
    this.this$01 = this$0;
    AbstractNavigableMap$EntrySet.call(this, this$0);
}
defineClass(1106, 614, $intern_10, TreeMap$EntrySet);
_.clear_0 = function clear_49() {
    $clear_8(this.this$01);
};
var Ljava_util_TreeMap$EntrySet_2_classLit = createForClass('java.util', 'TreeMap/EntrySet', 1106);
function TreeMap$Node(key, value_0) {
    AbstractMap$SimpleEntry.call(this, key, value_0);
    this.child = initUnidimensionalArray(Ljava_util_TreeMap$Node_2_classLit, $intern_27, 435, 2, 0, 1);
    this.isRed = true;
}
defineClass(435, 388, {
    478: 1,
    388: 1,
    43: 1,
    435: 1
}, TreeMap$Node);
_.isRed = false;
var Ljava_util_TreeMap$Node_2_classLit = createForClass('java.util', 'TreeMap/Node', 435);
function TreeMap$State() {}
defineClass(615, 1, {}, TreeMap$State);
_.toString_0 = function toString_74() {
    return 'State: mv=' + this.matchValue + ' value=' + this.value_0 + ' done=' + this.done_0 + ' found=' + this.found;
};
_.done_0 = false;
_.found = false;
_.matchValue = false;
var Ljava_util_TreeMap$State_2_classLit = createForClass('java.util', 'TreeMap/State', 615);
function $guardInRange(this$static, entry) {
    return !!entry && $inRange_0(this$static, entry.key) ? entry : null;
}
function $inRange_0(this$static, key) {
    return $inRange(this$static.this$01, this$static.type_0, key, this$static.fromKey, this$static.fromInclusive, this$static.toKey, this$static.toInclusive);
}
function TreeMap$SubMap(this$0, type_0, fromKey, fromInclusive, toKey, toInclusive) {
    this.this$01 = this$0;
    switch(type_0.ordinal){
        case 2:
            if (this$0.cmp.compare_1(toKey, fromKey) < 0) throw toJs(new IllegalArgumentException_0('subMap: ' + toKey + ' less than ' + fromKey));
            break;
        case 1:
            this$0.cmp.compare_1(toKey, toKey);
            break;
        case 3:
            this$0.cmp.compare_1(fromKey, fromKey);
    }
    this.type_0 = type_0;
    this.fromKey = fromKey;
    this.fromInclusive = fromInclusive;
    this.toKey = toKey;
    this.toInclusive = toInclusive;
}
defineClass(616, 2036, $intern_11, TreeMap$SubMap);
_.entryIterator_0 = function entryIterator_6() {
    return new TreeMap$EntryIterator_0(this.this$01, this.type_0, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive);
};
_.entrySet_0 = function entrySet_9() {
    return new AbstractNavigableMap$EntrySet(this);
};
_.getCeilingEntry = function getCeilingEntry_0(key) {
    return $guardInRange(this, $getNodeAfter(this.this$01, key, true));
};
_.getEntry = function getEntry_0(key) {
    return $guardInRange(this, $getEntry_1(this.this$01, key));
};
_.getFirstEntry = function getFirstEntry_0() {
    var entry;
    return this.type_0.fromKeyValid() ? this.fromInclusive ? entry = $getNodeAfter(this.this$01, this.fromKey, true) : entry = $getNodeAfter(this.this$01, this.fromKey, false) : entry = $getFirstEntry(this.this$01), !!entry && $inRange_0(this, entry.key) ? entry : null;
};
_.getFloorEntry = function getFloorEntry_0(key) {
    return $guardInRange(this, $getNodeBefore(this.this$01, key, true));
};
_.getHigherEntry = function getHigherEntry_0(key) {
    return $guardInRange(this, $getNodeAfter(this.this$01, key, false));
};
_.getLastEntry = function getLastEntry_0() {
    var entry;
    this.type_0.toKeyValid() ? this.toInclusive ? entry = $getNodeBefore(this.this$01, this.toKey, true) : entry = $getNodeBefore(this.this$01, this.toKey, false) : entry = $getLastEntry(this.this$01);
    return !!entry && $inRange_0(this, entry.key) ? entry : null;
};
_.getLowerEntry = function getLowerEntry_0(key) {
    return $guardInRange(this, $getNodeBefore(this.this$01, key, false));
};
_.headMap = function headMap_1(toKey, toInclusive) {
    if (this.type_0.toKeyValid() && this.this$01.cmp.compare_1(toKey, this.toKey) > 0) throw toJs(new IllegalArgumentException_0('subMap: ' + toKey + ' greater than ' + this.toKey));
    return this.type_0.fromKeyValid() ? $subMap(this.this$01, this.fromKey, this.fromInclusive, toKey, toInclusive) : $headMap(this.this$01, toKey, toInclusive);
};
_.put = function put_10(key, value_0) {
    if (!$inRange(this.this$01, this.type_0, key, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive)) throw toJs(new IllegalArgumentException_0(key + ' outside the range ' + this.fromKey + ' to ' + this.toKey));
    return $put_12(this.this$01, key, value_0);
};
_.remove_0 = function remove_89(k) {
    var key;
    key = k;
    if (!$inRange(this.this$01, this.type_0, key, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive)) return null;
    return $remove_26(this.this$01, key);
};
_.removeEntry = function removeEntry_0(entry) {
    return $inRange_0(this, entry.getKey()) && $removeEntry(this.this$01, entry);
};
_.size_1 = function size_63() {
    var count, entry, it;
    this.type_0.fromKeyValid() ? this.fromInclusive ? entry = $getNodeAfter(this.this$01, this.fromKey, true) : entry = $getNodeAfter(this.this$01, this.fromKey, false) : entry = $getFirstEntry(this.this$01);
    if (!(!!entry && $inRange_0(this, entry.key) ? entry : null)) return 0;
    count = 0;
    for(it = new TreeMap$EntryIterator_0(this.this$01, this.type_0, this.fromKey, this.fromInclusive, this.toKey, this.toInclusive); $hasNext_2(it.iter); it.last = castTo($next_4(it.iter), 43))++count;
    return count;
};
_.tailMap = function tailMap_1(fromKey, fromInclusive) {
    if (this.type_0.fromKeyValid() && this.this$01.cmp.compare_1(fromKey, this.fromKey) < 0) throw toJs(new IllegalArgumentException_0('subMap: ' + fromKey + ' less than ' + this.fromKey));
    return this.type_0.toKeyValid() ? $subMap(this.this$01, fromKey, fromInclusive, this.toKey, this.toInclusive) : $tailMap(this.this$01, fromKey, fromInclusive);
};
_.fromInclusive = false;
_.toInclusive = false;
var Ljava_util_TreeMap$SubMap_2_classLit = createForClass('java.util', 'TreeMap/SubMap', 616);
function $clinit_TreeMap$SubMapType() {
    $clinit_TreeMap$SubMapType = emptyMethod;
    All = new TreeMap$SubMapType('All', 0);
    Head = new TreeMap$SubMapType$1;
    Range_1 = new TreeMap$SubMapType$2;
    Tail = new TreeMap$SubMapType$3;
}
function TreeMap$SubMapType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_10(name_0) {
    $clinit_TreeMap$SubMapType();
    return valueOf(($clinit_TreeMap$SubMapType$Map(), $MAP_0), name_0);
}
function values_18() {
    $clinit_TreeMap$SubMapType();
    return stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_TreeMap$SubMapType_2_classLit, 1), $intern_36, 305, 0, [
        All,
        Head,
        Range_1,
        Tail
    ]);
}
defineClass(305, 23, $intern_85, TreeMap$SubMapType);
_.fromKeyValid = function fromKeyValid() {
    return false;
};
_.toKeyValid = function toKeyValid() {
    return false;
};
var All, Head, Range_1, Tail;
var Ljava_util_TreeMap$SubMapType_2_classLit = createForEnum('java.util', 'TreeMap/SubMapType', 305, Ljava_lang_Enum_2_classLit, values_18, valueOf_10);
function TreeMap$SubMapType$1() {
    TreeMap$SubMapType.call(this, 'Head', 1);
}
defineClass(1107, 305, $intern_85, TreeMap$SubMapType$1);
_.toKeyValid = function toKeyValid_0() {
    return true;
};
var Ljava_util_TreeMap$SubMapType$1_2_classLit = createForEnum('java.util', 'TreeMap/SubMapType/1', 1107, Ljava_util_TreeMap$SubMapType_2_classLit, null, null);
function TreeMap$SubMapType$2() {
    TreeMap$SubMapType.call(this, 'Range', 2);
}
defineClass(1108, 305, $intern_85, TreeMap$SubMapType$2);
_.fromKeyValid = function fromKeyValid_0() {
    return true;
};
_.toKeyValid = function toKeyValid_1() {
    return true;
};
var Ljava_util_TreeMap$SubMapType$2_2_classLit = createForEnum('java.util', 'TreeMap/SubMapType/2', 1108, Ljava_util_TreeMap$SubMapType_2_classLit, null, null);
function TreeMap$SubMapType$3() {
    TreeMap$SubMapType.call(this, 'Tail', 3);
}
defineClass(1109, 305, $intern_85, TreeMap$SubMapType$3);
_.fromKeyValid = function fromKeyValid_1() {
    return true;
};
var Ljava_util_TreeMap$SubMapType$3_2_classLit = createForEnum('java.util', 'TreeMap/SubMapType/3', 1109, Ljava_util_TreeMap$SubMapType_2_classLit, null, null);
function $clinit_TreeMap$SubMapType$Map() {
    $clinit_TreeMap$SubMapType$Map = emptyMethod;
    $MAP_0 = createValueOfMap(($clinit_TreeMap$SubMapType(), stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_TreeMap$SubMapType_2_classLit, 1), $intern_36, 305, 0, [
        All,
        Head,
        Range_1,
        Tail
    ])));
}
var $MAP_0;
function $add_10(this$static, o) {
    return this$static.map_0.put(o, ($clinit_Boolean(), FALSE_0)) == null;
}
function $ceiling(this$static, e) {
    return this$static.map_0.ceilingKey(e);
}
function $floor(this$static, e) {
    return this$static.map_0.floorKey(e);
}
function $higher(this$static, e) {
    return this$static.map_0.higherKey(e);
}
function $lower(this$static, e) {
    return this$static.map_0.lowerKey(e);
}
function $remove_28(this$static, o) {
    return this$static.map_0.remove_0(o) != null;
}
function TreeSet() {
    this.map_0 = new TreeMap;
}
function TreeSet_0(c) {
    this.map_0 = new TreeMap_0(c);
}
function TreeSet_1(map_0) {
    this.map_0 = map_0;
}
defineClass(156, $intern_9, {
    3: 1,
    20: 1,
    31: 1,
    16: 1,
    274: 1,
    22: 1,
    83: 1,
    156: 1
}, TreeSet, TreeSet_0, TreeSet_1);
_.spliterator_0 = function spliterator_34() {
    return new SortedSet$1(this);
};
_.add_2 = function add_40(o) {
    return $add_10(this, o);
};
_.clear_0 = function clear_50() {
    this.map_0.clear_0();
};
_.contains = function contains_47(o) {
    return this.map_0.containsKey(o);
};
_.iterator_0 = function iterator_65() {
    return this.map_0.keySet_0().iterator_0();
};
_.remove_1 = function remove_90(o) {
    return $remove_28(this, o);
};
_.size_1 = function size_64() {
    return this.map_0.size_1();
};
var Ljava_util_TreeSet_2_classLit = createForClass('java.util', 'TreeSet', 156);
function lambda$0_2(comparator_0, t_1, u_2) {
    return comparator_0.compare_1(t_1, u_2) <= 0 ? u_2 : t_1;
}
function lambda$1_2(comparator_0, t_1, u_2) {
    return comparator_0.compare_1(t_1, u_2) <= 0 ? t_1 : u_2;
}
function BinaryOperator$lambda$0$Type(comparator_0) {
    this.comparator_0 = comparator_0;
}
defineClass(1047, 1, {}, BinaryOperator$lambda$0$Type);
_.apply_3 = function apply_20(arg0, arg1) {
    return lambda$0_2(this.comparator_0, arg0, arg1);
};
var Ljava_util_function_BinaryOperator$lambda$0$Type_2_classLit = createForClass('java.util.function', 'BinaryOperator/lambda$0$Type', 1047);
function BinaryOperator$lambda$1$Type(comparator_0) {
    this.comparator_0 = comparator_0;
}
defineClass(1048, 1, {}, BinaryOperator$lambda$1$Type);
_.apply_3 = function apply_21(arg0, arg1) {
    return lambda$1_2(this.comparator_0, arg0, arg1);
};
var Ljava_util_function_BinaryOperator$lambda$1$Type_2_classLit = createForClass('java.util.function', 'BinaryOperator/lambda$1$Type', 1048);
function Function$lambda$0$Type() {}
defineClass(930, 1, {}, Function$lambda$0$Type);
_.apply_0 = function apply_22(t) {
    return t;
};
var Ljava_util_function_Function$lambda$0$Type_2_classLit = createForClass('java.util.function', 'Function/lambda$0$Type', 930);
function Predicate$lambda$2$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(386, 1, $intern_39, Predicate$lambda$2$Type);
_.test_0 = function test_3(t) {
    return !this.$$outer_0.test_0(t);
};
var Ljava_util_function_Predicate$lambda$2$Type_2_classLit = createForClass('java.util.function', 'Predicate/lambda$2$Type', 386);
defineClass(563, 1, {
    563: 1
});
var Ljava_util_logging_Handler_2_classLit = createForClass('java.util.logging', 'Handler', 563);
function $clinit_Level() {
    $clinit_Level = emptyMethod;
    INFO = new Level$LevelInfo;
}
defineClass(2053, 1, $intern_1);
_.getName = function getName_0() {
    return 'DUMMY';
};
_.toString_0 = function toString_75() {
    return this.getName();
};
var INFO;
var Ljava_util_logging_Level_2_classLit = createForClass('java.util.logging', 'Level', 2053);
function Level$LevelInfo() {}
defineClass(1648, 2053, $intern_1, Level$LevelInfo);
_.getName = function getName_1() {
    return 'INFO';
};
var Ljava_util_logging_Level$LevelInfo_2_classLit = createForClass('java.util.logging', 'Level/LevelInfo', 1648);
function $addLoggerImpl(this$static, logger) {
    (($clinit_Logger(), LOGGING_OFF) ? null : logger.name_0).length == 0 && $addHandler(logger, new SimpleConsoleLogHandler);
    $putStringValue(this$static.loggerMap, LOGGING_OFF ? null : logger.name_0, logger);
}
function $ensureLogger(this$static, name_0) {
    var logger, newLogger, name_1, parentName;
    logger = castTo($getStringValue(this$static.loggerMap, name_0), 509);
    if (!logger) {
        newLogger = new Logger(name_0);
        name_1 = ($clinit_Logger(), LOGGING_OFF) ? null : newLogger.name_0;
        parentName = $substring_1(name_1, 0, $wnd.Math.max(0, $lastIndexOf(name_1, fromCodePoint(46))));
        $setParent(newLogger, $ensureLogger(this$static, parentName));
        (LOGGING_OFF ? null : newLogger.name_0).length == 0 && $addHandler(newLogger, new SimpleConsoleLogHandler);
        $putStringValue(this$static.loggerMap, LOGGING_OFF ? null : newLogger.name_0, newLogger);
        return newLogger;
    }
    return logger;
}
function LogManager() {
    this.loggerMap = new HashMap;
}
function getLogManager() {
    var rootLogger;
    if (!singleton) {
        singleton = new LogManager;
        rootLogger = new Logger('');
        $setLevel(rootLogger, ($clinit_Level(), INFO));
        $addLoggerImpl(singleton, rootLogger);
    }
    return singleton;
}
defineClass(1789, 1, {}, LogManager);
var singleton;
var Ljava_util_logging_LogManager_2_classLit = createForClass('java.util.logging', 'LogManager', 1789);
function LogRecord(msg) {
    this.msg = msg;
    $clinit_System();
    fromDouble_0(Date.now());
}
defineClass(1842, 1, $intern_1, LogRecord);
_.thrown = null;
var Ljava_util_logging_LogRecord_2_classLit = createForClass('java.util.logging', 'LogRecord', 1842);
function $clinit_Logger() {
    $clinit_Logger = emptyMethod;
    LOGGING_OFF = true;
    ALL_ENABLED = false;
    INFO_ENABLED = false;
    WARNING_ENABLED = false;
    SEVERE_ENABLED = false;
}
function $actuallyLog(this$static, record) {
    var handler$array, handler$array0, handler$index, handler$index0, handler$max, handler$max0, logger;
    for(handler$array0 = $getHandlers(this$static), handler$index0 = 0, handler$max0 = handler$array0.length; handler$index0 < handler$max0; ++handler$index0)$publish(record);
    logger = !LOGGING_OFF && this$static.useParentHandlers ? LOGGING_OFF ? null : this$static.parent_0 : null;
    while(logger){
        for(handler$array = $getHandlers(logger), handler$index = 0, handler$max = handler$array.length; handler$index < handler$max; ++handler$index)$publish(record);
        logger = !LOGGING_OFF && logger.useParentHandlers ? LOGGING_OFF ? null : logger.parent_0 : null;
    }
}
function $addHandler(this$static, handler) {
    if (LOGGING_OFF) return;
    $add_3(this$static.handlers, handler);
}
function $getEffectiveLevel(this$static) {
    var effectiveLevel, logger;
    if (this$static.level) return this$static.level;
    logger = LOGGING_OFF ? null : this$static.parent_0;
    while(logger){
        effectiveLevel = LOGGING_OFF ? null : logger.level;
        if (effectiveLevel) return effectiveLevel;
        logger = LOGGING_OFF ? null : logger.parent_0;
    }
    return $clinit_Level(), INFO;
}
function $getHandlers(this$static) {
    if (LOGGING_OFF) return initUnidimensionalArray(Ljava_util_logging_Handler_2_classLit, $intern_86, 563, 0, 0, 1);
    return castTo($toArray_1(this$static.handlers, initUnidimensionalArray(Ljava_util_logging_Handler_2_classLit, $intern_86, 563, this$static.handlers.array.length, 0, 1)), 835);
}
function $log(this$static, msg, thrown) {
    var record;
    (ALL_ENABLED ? ($getEffectiveLevel(this$static), true) : INFO_ENABLED ? ($clinit_Level(), true) : WARNING_ENABLED ? ($clinit_Level(), true) : SEVERE_ENABLED && ($clinit_Level(), false)) && (record = new LogRecord(msg), record.thrown = thrown, $actuallyLog(this$static, record), undefined);
}
function $setLevel(this$static, newLevel) {
    if (LOGGING_OFF) return;
    this$static.level = newLevel;
}
function $setParent(this$static, newParent) {
    if (LOGGING_OFF) return;
    !!newParent && (this$static.parent_0 = newParent);
}
function Logger(name_0) {
    $clinit_Logger();
    if (LOGGING_OFF) return;
    this.name_0 = name_0;
    this.useParentHandlers = true;
    this.handlers = new ArrayList;
}
function getLogger() {
    $clinit_Logger();
    if (LOGGING_OFF) return new Logger(null);
    return $ensureLogger(getLogManager(), 'com.google.common.base.Strings');
}
defineClass(509, 1, {
    509: 1
}, Logger);
_.useParentHandlers = false;
var ALL_ENABLED = false, INFO_ENABLED = false, LOGGING_OFF = false, SEVERE_ENABLED = false, WARNING_ENABLED = false;
var Ljava_util_logging_Logger_2_classLit = createForClass('java.util.logging', 'Logger', 509);
function $publish(record) {
    var console_0, level, val;
    console_0 = $equals_5(typeof console, 'undefined') ? null : new ConsoleLogger;
    if (!console_0) return;
    $clinit_Level();
    level = (val = 900, val >= $intern_45 ? 'error' : val >= 900 ? 'warn' : val >= 800 ? 'info' : 'log');
    $log_0(level, record.msg);
    !!record.thrown && $log_1(console_0, level, record.thrown, 'Exception: ', true);
}
function SimpleConsoleLogHandler() {}
defineClass(814, 563, {
    563: 1
}, SimpleConsoleLogHandler);
var Ljava_util_logging_SimpleConsoleLogHandler_2_classLit = createForClass('java.util.logging', 'SimpleConsoleLogHandler', 814);
function of_3(supplier, accumulator, combiner, finisher, characteristics) {
    checkCriticalNotNull(supplier);
    checkCriticalNotNull(accumulator);
    checkCriticalNotNull(combiner);
    checkCriticalNotNull(finisher);
    checkCriticalNotNull(characteristics);
    return new CollectorImpl(supplier, accumulator, finisher);
}
function of_4(supplier, accumulator, combiner, characteristics) {
    checkCriticalNotNull(supplier);
    checkCriticalNotNull(accumulator);
    checkCriticalNotNull(combiner);
    checkCriticalNotNull(characteristics);
    return new CollectorImpl(supplier, accumulator, new Function$lambda$0$Type);
}
function $clinit_Collector$Characteristics() {
    $clinit_Collector$Characteristics = emptyMethod;
    CONCURRENT = new Collector$Characteristics('CONCURRENT', 0);
    IDENTITY_FINISH = new Collector$Characteristics('IDENTITY_FINISH', 1);
    UNORDERED = new Collector$Characteristics('UNORDERED', 2);
}
function Collector$Characteristics(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_11(name_0) {
    $clinit_Collector$Characteristics();
    return valueOf(($clinit_Collector$Characteristics$Map(), $MAP_1), name_0);
}
function values_19() {
    $clinit_Collector$Characteristics();
    return stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        CONCURRENT,
        IDENTITY_FINISH,
        UNORDERED
    ]);
}
defineClass(131, 23, {
    3: 1,
    34: 1,
    23: 1,
    131: 1
}, Collector$Characteristics);
var CONCURRENT, IDENTITY_FINISH, UNORDERED;
var Ljava_util_stream_Collector$Characteristics_2_classLit = createForEnum('java.util.stream', 'Collector/Characteristics', 131, Ljava_lang_Enum_2_classLit, values_19, valueOf_11);
function $clinit_Collector$Characteristics$Map() {
    $clinit_Collector$Characteristics$Map = emptyMethod;
    $MAP_1 = createValueOfMap(($clinit_Collector$Characteristics(), stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        CONCURRENT,
        IDENTITY_FINISH,
        UNORDERED
    ])));
}
var $MAP_1;
function CollectorImpl(supplier, accumulator, finisher) {
    this.supplier = supplier;
    this.accumulator = accumulator;
    $clinit_Collections();
    this.finisher = finisher;
}
defineClass(741, 1, {}, CollectorImpl);
var Ljava_util_stream_CollectorImpl_2_classLit = createForClass('java.util.stream', 'CollectorImpl', 741);
function lambda$45(c1_0, c2_1) {
    return c1_0.addAll(c2_1), c1_0;
}
function Collectors$10methodref$merge$Type() {}
defineClass(1045, 1, {}, Collectors$10methodref$merge$Type);
_.apply_3 = function apply_23(arg0, arg1) {
    return $merge(castTo(arg0, 212), castTo(arg1, 212));
};
var Ljava_util_stream_Collectors$10methodref$merge$Type_2_classLit = createForClass('java.util.stream', 'Collectors/10methodref$merge$Type', 1045);
function Collectors$11methodref$toString$Type() {}
defineClass(1046, 1, {}, Collectors$11methodref$toString$Type);
_.apply_0 = function apply_24(arg0) {
    return $toString_9(castTo(arg0, 212));
};
var Ljava_util_stream_Collectors$11methodref$toString$Type_2_classLit = createForClass('java.util.stream', 'Collectors/11methodref$toString$Type', 1046);
function Collectors$20methodref$add$Type() {}
defineClass(163, 1, {}, Collectors$20methodref$add$Type);
_.accept_1 = function accept_21(arg0, arg1) {
    castTo(arg0, 16).add_2(arg1);
};
var Ljava_util_stream_Collectors$20methodref$add$Type_2_classLit = createForClass('java.util.stream', 'Collectors/20methodref$add$Type', 163);
function Collectors$21methodref$ctor$Type() {}
defineClass(165, 1, {}, Collectors$21methodref$ctor$Type);
_.get_5 = function get_46() {
    return new ArrayList;
};
var Ljava_util_stream_Collectors$21methodref$ctor$Type_2_classLit = createForClass('java.util.stream', 'Collectors/21methodref$ctor$Type', 165);
function Collectors$9methodref$add$Type() {}
defineClass(1044, 1, {}, Collectors$9methodref$add$Type);
_.accept_1 = function accept_22(arg0, arg1) {
    $add_9(castTo(arg0, 212), castTo(arg1, 470));
};
var Ljava_util_stream_Collectors$9methodref$add$Type_2_classLit = createForClass('java.util.stream', 'Collectors/9methodref$add$Type', 1044);
function Collectors$lambda$15$Type() {
    this.delimiter_0 = ';,;';
    this.prefix_1 = '';
    this.suffix_2 = '';
}
defineClass(1043, 1, {}, Collectors$lambda$15$Type);
_.get_5 = function get_47() {
    return new StringJoiner(this.delimiter_0, this.prefix_1, this.suffix_2);
};
var Ljava_util_stream_Collectors$lambda$15$Type_2_classLit = createForClass('java.util.stream', 'Collectors/lambda$15$Type', 1043);
function Collectors$lambda$45$Type() {}
defineClass(164, 1, {}, Collectors$lambda$45$Type);
_.apply_3 = function apply_25(arg0, arg1) {
    return lambda$45(castTo(arg0, 16), castTo(arg1, 16));
};
var Ljava_util_stream_Collectors$lambda$45$Type_2_classLit = createForClass('java.util.stream', 'Collectors/lambda$45$Type', 164);
function $close(this$static) {
    if (!this$static.root) {
        this$static.terminated = true;
        $runClosers(this$static);
    } else this$static.root.close_0();
}
function $onClose(this$static, closeHandler) {
    !this$static.root ? $add_3(this$static.onClose, closeHandler) : $onClose(this$static.root, closeHandler);
    return this$static;
}
function $runClosers(this$static) {
    var e, i, size_0, suppressed, throwables;
    throwables = new ArrayList;
    $forEach_1(this$static.onClose, new TerminatableStream$lambda$0$Type(throwables));
    this$static.onClose.array.length = 0;
    if (throwables.array.length != 0) {
        e = (checkCriticalElementIndex(0, throwables.array.length), castTo(throwables.array[0], 80));
        for(i = 1, size_0 = throwables.array.length; i < size_0; ++i){
            suppressed = (checkCriticalElementIndex(i, throwables.array.length), castTo(throwables.array[i], 80));
            suppressed != e && $addSuppressed(e, suppressed);
        }
        if (instanceOf(e, 63)) throw toJs(castTo(e, 63));
        if (instanceOf(e, 294)) throw toJs(castTo(e, 294));
    }
}
function $terminate(this$static) {
    if (!this$static.root) {
        $throwIfTerminated(this$static);
        this$static.terminated = true;
    } else $terminate(this$static.root);
}
function $throwIfTerminated(this$static) {
    if (this$static.root) $throwIfTerminated(this$static.root);
    else if (this$static.terminated) throw toJs(new IllegalStateException_0("Stream already terminated, can't be modified or used"));
}
function TerminatableStream(previous) {
    if (!previous) {
        this.root = null;
        this.onClose = new ArrayList;
    } else {
        this.root = previous;
        this.onClose = null;
    }
}
function lambda$0_3(throwables_0, runnable_1) {
    var e;
    try {
        runnable_1.run();
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 80)) {
            e = $e0;
            push_1(throwables_0.array, e);
        } else throw toJs($e0);
    }
}
defineClass(535, 1, {});
_.close_0 = function close_0() {
    $close(this);
};
_.terminated = false;
var Ljava_util_stream_TerminatableStream_2_classLit = createForClass('java.util.stream', 'TerminatableStream', 535);
function $average(this$static) {
    var stats;
    stats = $collect(this$static);
    if (eq(stats.count, 0)) return $clinit_OptionalDouble(), $clinit_OptionalDouble(), EMPTY_4;
    return $clinit_OptionalDouble(), new OptionalDouble_0(gt(stats.count, 0) ? $getSum(stats) / toDouble_0(stats.count) : 0);
}
function $collect(this$static) {
    var acc;
    $terminate(this$static);
    acc = new DoubleSummaryStatistics;
    $forEachRemaining_1(this$static.spliterator, new DoubleStreamImpl$lambda$2$Type(acc));
    return acc;
}
function $max(this$static) {
    var stats;
    stats = $collect(this$static);
    if (eq(stats.count, 0)) return $clinit_OptionalDouble(), $clinit_OptionalDouble(), EMPTY_4;
    return $clinit_OptionalDouble(), new OptionalDouble_0(stats.max_0);
}
function $min(this$static) {
    var stats;
    stats = $collect(this$static);
    if (eq(stats.count, 0)) return $clinit_OptionalDouble(), $clinit_OptionalDouble(), EMPTY_4;
    return $clinit_OptionalDouble(), new OptionalDouble_0(stats.min_0);
}
function $sorted(this$static) {
    var sortingSpliterator;
    $throwIfTerminated(this$static);
    sortingSpliterator = new DoubleStreamImpl$2(this$static, this$static.spliterator.sizeEstimate, this$static.spliterator.characteristics | 4);
    return new DoubleStreamImpl(this$static, sortingSpliterator);
}
function $toArray_5(this$static) {
    var entries;
    $terminate(this$static);
    entries = initUnidimensionalArray(D_classLit, $intern_66, 30, 0, 15, 1);
    $forEachRemaining_1(this$static.spliterator, new DoubleStreamImpl$lambda$0$Type(entries));
    return entries;
}
function DoubleStreamImpl(previous, spliterator) {
    TerminatableStream.call(this, previous);
    this.spliterator = spliterator;
}
function lambda$0_4(entries_0, value_1) {
    return entries_0[entries_0.length] = value_1;
}
defineClass(806, 535, $intern_87, DoubleStreamImpl);
_.close_0 = function close_1() {
    $close(this);
};
var Ljava_util_stream_DoubleStreamImpl_2_classLit = createForClass('java.util.stream', 'DoubleStreamImpl', 806);
function $tryAdvance_2(this$static, action) {
    var list;
    if (!this$static.ordered) {
        list = initUnidimensionalArray(D_classLit, $intern_66, 30, 0, 15, 1);
        $forEachRemaining_1(this$static.this$01.spliterator, new DoubleStreamImpl$2$lambda$0$Type(list));
        sort_9(list, makeLambdaFunction(Arrays$0methodref$compare$Type.prototype.compare_0, Arrays$0methodref$compare$Type, []));
        this$static.ordered = new Spliterators$DoubleArraySpliterator(list, this$static.characteristics);
    }
    return $tryAdvance_0(this$static.ordered, action);
}
function DoubleStreamImpl$2(this$0, $anonymous0, $anonymous1) {
    this.this$01 = this$0;
    Spliterators$AbstractDoubleSpliterator.call(this, $anonymous0, $anonymous1);
}
function lambda$0_5(list_0, item_1) {
    return list_0[list_0.length] = item_1;
}
defineClass(1793, 719, $intern_18, DoubleStreamImpl$2);
_.tryAdvance_0 = function tryAdvance_10(action) {
    return $tryAdvance_2(this, castTo(action, 189));
};
_.ordered = null;
var Ljava_util_stream_DoubleStreamImpl$2_2_classLit = createForClass('java.util.stream', 'DoubleStreamImpl/2', 1793);
function DoubleStreamImpl$2$lambda$0$Type(list_0) {
    this.list_0 = list_0;
}
defineClass(1794, 1, $intern_75, DoubleStreamImpl$2$lambda$0$Type);
_.accept_2 = function accept_23(arg0) {
    lambda$0_5(this.list_0, arg0);
};
var Ljava_util_stream_DoubleStreamImpl$2$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'DoubleStreamImpl/2/lambda$0$Type', 1794);
function DoubleStreamImpl$lambda$0$Type(entries_0) {
    this.entries_0 = entries_0;
}
defineClass(1791, 1, $intern_75, DoubleStreamImpl$lambda$0$Type);
_.accept_2 = function accept_24(arg0) {
    lambda$0_4(this.entries_0, arg0);
};
var Ljava_util_stream_DoubleStreamImpl$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'DoubleStreamImpl/lambda$0$Type', 1791);
function DoubleStreamImpl$lambda$2$Type(acc_1) {
    this.acc_1 = acc_1;
}
defineClass(1792, 1, $intern_75, DoubleStreamImpl$lambda$2$Type);
_.accept_2 = function accept_25(arg0) {
    $accept(this.acc_1, arg0);
};
var Ljava_util_stream_DoubleStreamImpl$lambda$2$Type_2_classLit = createForClass('java.util.stream', 'DoubleStreamImpl/lambda$2$Type', 1792);
function range_0(endExclusive) {
    if (0 >= endExclusive) return new IntStreamImpl$Empty;
    return rangeClosed(endExclusive - 1);
}
function rangeClosed(endInclusive) {
    var count, spliterator;
    if (0 > endInclusive) return new IntStreamImpl$Empty;
    count = endInclusive + 1;
    spliterator = new IntStream$5(count, endInclusive);
    return new IntStreamImpl(null, spliterator);
}
function $tryAdvance_3(this$static, action) {
    if (this$static.next_0 <= this$static.val$endInclusive5) {
        action.accept_0(this$static.next_0++);
        return true;
    }
    return false;
}
function IntStream$5($anonymous0, val$endInclusive) {
    this.val$startInclusive4 = 0;
    this.val$endInclusive5 = val$endInclusive;
    Spliterators$AbstractIntSpliterator.call(this, $anonymous0, 17493);
    this.next_0 = this.val$startInclusive4;
}
defineClass(1336, 718, $intern_18, IntStream$5);
_.tryAdvance_0 = function tryAdvance_11(action) {
    return $tryAdvance_3(this, castTo(action, 202));
};
_.next_0 = 0;
_.val$endInclusive5 = 0;
_.val$startInclusive4 = 0;
var Ljava_util_stream_IntStream$5_2_classLit = createForClass('java.util.stream', 'IntStream/5', 1336);
function $collect_0(this$static) {
    var acc;
    $terminate(this$static);
    acc = new IntSummaryStatistics;
    $forEachRemaining_1(this$static.spliterator, new IntStreamImpl$lambda$4$Type(acc));
    return acc;
}
function $max_0(this$static) {
    var stats;
    stats = $collect_0(this$static);
    if (eq(stats.count, 0)) return $clinit_OptionalInt(), $clinit_OptionalInt(), EMPTY_5;
    return $clinit_OptionalInt(), new OptionalInt_0(stats.max_0);
}
function IntStreamImpl(previous, spliterator) {
    TerminatableStream.call(this, previous);
    this.spliterator = spliterator;
}
defineClass(786, 535, $intern_87, IntStreamImpl);
_.close_0 = function close_2() {
    $close(this);
};
_.spliterator_1 = function spliterator_35() {
    return $terminate(this), this.spliterator;
};
var Ljava_util_stream_IntStreamImpl_2_classLit = createForClass('java.util.stream', 'IntStreamImpl', 786);
function IntStreamImpl$Empty() {
    TerminatableStream.call(this, null);
}
defineClass(787, 535, $intern_87, IntStreamImpl$Empty);
_.close_0 = function close_3() {
    $close(this);
};
_.spliterator_1 = function spliterator_36() {
    return $terminate(this), $clinit_Spliterators$EmptySpliterator(), OF_INT;
};
var Ljava_util_stream_IntStreamImpl$Empty_2_classLit = createForClass('java.util.stream', 'IntStreamImpl/Empty', 787);
function IntStreamImpl$lambda$4$Type(acc_1) {
    this.acc_1 = acc_1;
}
defineClass(1628, 1, $intern_20, IntStreamImpl$lambda$4$Type);
_.accept_0 = function accept_26(arg0) {
    $accept_0(this.acc_1, arg0);
};
var Ljava_util_stream_IntStreamImpl$lambda$4$Type_2_classLit = createForClass('java.util.stream', 'IntStreamImpl/lambda$4$Type', 1628);
var Ljava_util_stream_Stream_2_classLit = createForInterface('java.util.stream', 'Stream');
function $clinit_StreamImpl() {
    $clinit_StreamImpl = emptyMethod;
    NULL_CONSUMER = new StreamImpl$lambda$0$Type;
}
function $anyMatch(this$static, predicate) {
    return ($throwIfTerminated(this$static), $spliterator(new StreamImpl(this$static, new StreamImpl$FilterSpliterator(predicate, this$static.spliterator)))).tryAdvance(NULL_CONSUMER);
}
function $collect_1(this$static, collector) {
    var lastArg;
    return collector.finisher.apply_0($reduce(this$static, collector.supplier.get_5(), (lastArg = new StreamImpl$lambda$4$Type(collector), lastArg)));
}
function $count_0(this$static) {
    var count;
    $terminate(this$static);
    count = 0;
    while(this$static.spliterator.tryAdvance(new StreamImpl$lambda$1$Type))count = add_20(count, 1);
    return count;
}
function $distinct(this$static) {
    var seen;
    $throwIfTerminated(this$static);
    seen = new HashSet;
    return $filter(this$static, new StreamImpl$1methodref$add$Type(seen));
}
function $filter(this$static, predicate) {
    $throwIfTerminated(this$static);
    return new StreamImpl(this$static, new StreamImpl$FilterSpliterator(predicate, this$static.spliterator));
}
function $findFirst(this$static) {
    var holder;
    $terminate(this$static);
    holder = new StreamImpl$ValueConsumer;
    if (this$static.spliterator.tryAdvance(holder)) return $clinit_Optional(), new Optional(checkCriticalNotNull(holder.value_0));
    return $clinit_Optional(), $clinit_Optional(), EMPTY_3;
}
function $flatMap(this$static, mapper) {
    var flatMapSpliterator, spliteratorOfStreams;
    $throwIfTerminated(this$static);
    spliteratorOfStreams = new StreamImpl$MapToObjSpliterator(mapper, this$static.spliterator);
    flatMapSpliterator = new StreamImpl$1(spliteratorOfStreams);
    return new StreamImpl(this$static, flatMapSpliterator);
}
function $forEach_3(this$static, action) {
    $terminate(this$static);
    this$static.spliterator.forEachRemaining(action);
}
function $map(this$static, mapper) {
    $throwIfTerminated(this$static);
    return new StreamImpl(this$static, new StreamImpl$MapToObjSpliterator(mapper, this$static.spliterator));
}
function $mapToDouble(this$static, mapper) {
    $throwIfTerminated(this$static);
    return new DoubleStreamImpl(this$static, new StreamImpl$MapToDoubleSpliterator(mapper, this$static.spliterator));
}
function $mapToInt(this$static, mapper) {
    $throwIfTerminated(this$static);
    return new IntStreamImpl(this$static, new StreamImpl$MapToIntSpliterator(mapper, this$static.spliterator));
}
function $max_1(this$static, comparator) {
    return $reduce_0(this$static, (checkCriticalNotNull(comparator), new BinaryOperator$lambda$0$Type(comparator)));
}
function $min_0(this$static, comparator) {
    return $reduce_0(this$static, (checkCriticalNotNull(comparator), new BinaryOperator$lambda$1$Type(comparator)));
}
function $reduce(this$static, identity, accumulator) {
    var consumer;
    $terminate(this$static);
    consumer = new StreamImpl$ValueConsumer;
    consumer.value_0 = identity;
    this$static.spliterator.forEachRemaining(new StreamImpl$lambda$5$Type(consumer, accumulator));
    return consumer.value_0;
}
function $reduce_0(this$static, accumulator) {
    var consumer;
    consumer = new StreamImpl$ValueConsumer;
    if (!this$static.spliterator.tryAdvance(consumer)) {
        $terminate(this$static);
        return $clinit_Optional(), $clinit_Optional(), EMPTY_3;
    }
    return $clinit_Optional(), new Optional(checkCriticalNotNull($reduce(this$static, consumer.value_0, accumulator)));
}
function $skip(this$static) {
    $throwIfTerminated(this$static);
    checkCriticalState_0(true, 'n may not be negative');
    return new StreamImpl(this$static, new StreamImpl$SkipSpliterator(this$static.spliterator));
}
function $sorted_0(this$static) {
    var c;
    $throwIfTerminated(this$static);
    c = ($clinit_Comparators(), $clinit_Comparators(), NATURAL_ORDER);
    return $sorted_1(this$static, c);
}
function $sorted_1(this$static, comparator) {
    var sortedSpliterator;
    $throwIfTerminated(this$static);
    sortedSpliterator = new StreamImpl$5(this$static, this$static.spliterator.estimateSize_0(), this$static.spliterator.characteristics_0() | 4, comparator);
    return new StreamImpl(this$static, sortedSpliterator);
}
function $spliterator(this$static) {
    $terminate(this$static);
    return this$static.spliterator;
}
function $toArray_6(this$static, generator) {
    var collected;
    collected = castTo($collect_1(this$static, of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    return collected.toArray_0($apply_10(collected.size_1()));
}
function StreamImpl(prev, spliterator) {
    $clinit_StreamImpl();
    TerminatableStream.call(this, prev);
    this.spliterator = spliterator;
}
function lambda$4(collector_0, a_1, t_2) {
    $clinit_StreamImpl();
    collector_0.accumulator.accept_1(a_1, t_2);
    return a_1;
}
function lambda$5(consumer_0, accumulator_1, item_2) {
    $clinit_StreamImpl();
    $accept_1(consumer_0, accumulator_1.apply_3(consumer_0.value_0, item_2));
}
defineClass(28, 535, {
    518: 1,
    672: 1,
    827: 1
}, StreamImpl);
_.close_0 = function close_4() {
    $close(this);
};
var NULL_CONSUMER;
var Ljava_util_stream_StreamImpl_2_classLit = createForClass('java.util.stream', 'StreamImpl', 28);
function $advanceToNextSpliterator(this$static) {
    while(!this$static.next_0){
        if (!$tryAdvance_6(this$static.val$spliteratorOfStreams5, new StreamImpl$1$lambda$0$Type(this$static))) return false;
    }
    return true;
}
function $lambda$0_0(this$static, n_0) {
    if (n_0) {
        this$static.nextStream = n_0;
        this$static.next_0 = ($terminate(n_0), n_0.spliterator);
    }
}
function StreamImpl$1(val$spliteratorOfStreams) {
    this.val$spliteratorOfStreams5 = val$spliteratorOfStreams;
    Spliterators$AbstractSpliterator.call(this, $intern_21, 0);
}
defineClass(1067, 484, $intern_18, StreamImpl$1);
_.tryAdvance = function tryAdvance_12(action) {
    while($advanceToNextSpliterator(this)){
        if (this.next_0.tryAdvance(action)) return true;
        else {
            $close(this.nextStream);
            this.nextStream = null;
            this.next_0 = null;
        }
    }
    return false;
};
var Ljava_util_stream_StreamImpl$1_2_classLit = createForClass('java.util.stream', 'StreamImpl/1', 1067);
function StreamImpl$1$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1068, 1, $intern_19, StreamImpl$1$lambda$0$Type);
_.accept = function accept_27(arg0) {
    $lambda$0_0(this.$$outer_0, castTo(arg0, 827));
};
var Ljava_util_stream_StreamImpl$1$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/1/lambda$0$Type', 1068);
function StreamImpl$1methodref$add$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1069, 1, $intern_39, StreamImpl$1methodref$add$Type);
_.test_0 = function test_4(arg0) {
    return $add_6(this.$$outer_0, arg0);
};
var Ljava_util_stream_StreamImpl$1methodref$add$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/1methodref$add$Type', 1069);
function StreamImpl$5(this$0, $anonymous0, $anonymous1, val$comparator) {
    this.this$01 = this$0;
    this.val$comparator5 = val$comparator;
    Spliterators$AbstractSpliterator.call(this, $anonymous0, $anonymous1);
}
defineClass(1070, 484, $intern_18, StreamImpl$5);
_.tryAdvance = function tryAdvance_13(action) {
    var list;
    if (!this.ordered) {
        list = new ArrayList;
        this.this$01.spliterator.forEachRemaining(new StreamImpl$5$2methodref$add$Type(list));
        $clinit_Collections();
        $sort(list, this.val$comparator5);
        this.ordered = new Spliterators$IteratorSpliterator(list, 16);
    }
    return $tryAdvance(this.ordered, action);
};
_.ordered = null;
var Ljava_util_stream_StreamImpl$5_2_classLit = createForClass('java.util.stream', 'StreamImpl/5', 1070);
function StreamImpl$5$2methodref$add$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1071, 1, $intern_19, StreamImpl$5$2methodref$add$Type);
_.accept = function accept_28(arg0) {
    $add_3(this.$$outer_0, arg0);
};
var Ljava_util_stream_StreamImpl$5$2methodref$add$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/5/2methodref$add$Type', 1071);
function $lambda$0_1(this$static, action_1, item_1) {
    if (this$static.filter.test_0(item_1)) {
        this$static.found = true;
        action_1.accept(item_1);
    }
}
function StreamImpl$FilterSpliterator(filter, original) {
    Spliterators$AbstractSpliterator.call(this, original.estimateSize_0(), original.characteristics_0() & -16449);
    checkCriticalNotNull(filter);
    this.filter = filter;
    this.original = original;
}
defineClass(720, 484, $intern_18, StreamImpl$FilterSpliterator);
_.tryAdvance = function tryAdvance_14(action) {
    this.found = false;
    while(!this.found && this.original.tryAdvance(new StreamImpl$FilterSpliterator$lambda$0$Type(this, action)));
    return this.found;
};
_.found = false;
var Ljava_util_stream_StreamImpl$FilterSpliterator_2_classLit = createForClass('java.util.stream', 'StreamImpl/FilterSpliterator', 720);
function StreamImpl$FilterSpliterator$lambda$0$Type($$outer_0, action_1) {
    this.$$outer_0 = $$outer_0;
    this.action_1 = action_1;
}
defineClass(1061, 1, $intern_19, StreamImpl$FilterSpliterator$lambda$0$Type);
_.accept = function accept_29(arg0) {
    $lambda$0_1(this.$$outer_0, this.action_1, arg0);
};
var Ljava_util_stream_StreamImpl$FilterSpliterator$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/FilterSpliterator/lambda$0$Type', 1061);
function $lambda$0_2(this$static, action_1, u_1) {
    action_1.accept_2(this$static.map_0.applyAsDouble(u_1));
}
function $tryAdvance_4(this$static, action) {
    return this$static.original.tryAdvance(new StreamImpl$MapToDoubleSpliterator$lambda$0$Type(this$static, action));
}
function StreamImpl$MapToDoubleSpliterator(map_0, original) {
    Spliterators$AbstractDoubleSpliterator.call(this, original.estimateSize_0(), original.characteristics_0() & -6);
    checkCriticalNotNull(map_0);
    this.map_0 = map_0;
    this.original = original;
}
defineClass(1056, 719, $intern_18, StreamImpl$MapToDoubleSpliterator);
_.tryAdvance_0 = function tryAdvance_15(action) {
    return $tryAdvance_4(this, castTo(action, 189));
};
var Ljava_util_stream_StreamImpl$MapToDoubleSpliterator_2_classLit = createForClass('java.util.stream', 'StreamImpl/MapToDoubleSpliterator', 1056);
function StreamImpl$MapToDoubleSpliterator$lambda$0$Type($$outer_0, action_1) {
    this.$$outer_0 = $$outer_0;
    this.action_1 = action_1;
}
defineClass(1060, 1, $intern_19, StreamImpl$MapToDoubleSpliterator$lambda$0$Type);
_.accept = function accept_30(arg0) {
    $lambda$0_2(this.$$outer_0, this.action_1, arg0);
};
var Ljava_util_stream_StreamImpl$MapToDoubleSpliterator$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/MapToDoubleSpliterator/lambda$0$Type', 1060);
function $lambda$0_3(this$static, action_1, u_1) {
    action_1.accept_0(this$static.map_0.applyAsInt(u_1));
}
function $tryAdvance_5(this$static, action) {
    return this$static.original.tryAdvance(new StreamImpl$MapToIntSpliterator$lambda$0$Type(this$static, action));
}
function StreamImpl$MapToIntSpliterator(map_0, original) {
    Spliterators$AbstractIntSpliterator.call(this, original.estimateSize_0(), original.characteristics_0() & -6);
    checkCriticalNotNull(map_0);
    this.map_0 = map_0;
    this.original = original;
}
defineClass(1055, 718, $intern_18, StreamImpl$MapToIntSpliterator);
_.tryAdvance_0 = function tryAdvance_16(action) {
    return $tryAdvance_5(this, castTo(action, 202));
};
var Ljava_util_stream_StreamImpl$MapToIntSpliterator_2_classLit = createForClass('java.util.stream', 'StreamImpl/MapToIntSpliterator', 1055);
function StreamImpl$MapToIntSpliterator$lambda$0$Type($$outer_0, action_1) {
    this.$$outer_0 = $$outer_0;
    this.action_1 = action_1;
}
defineClass(1059, 1, $intern_19, StreamImpl$MapToIntSpliterator$lambda$0$Type);
_.accept = function accept_31(arg0) {
    $lambda$0_3(this.$$outer_0, this.action_1, arg0);
};
var Ljava_util_stream_StreamImpl$MapToIntSpliterator$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/MapToIntSpliterator/lambda$0$Type', 1059);
function $lambda$0_4(this$static, action_1, u_1) {
    action_1.accept(this$static.map_0.apply_0(u_1));
}
function $tryAdvance_6(this$static, action) {
    return this$static.original.tryAdvance(new StreamImpl$MapToObjSpliterator$lambda$0$Type(this$static, action));
}
function StreamImpl$MapToObjSpliterator(map_0, original) {
    Spliterators$AbstractSpliterator.call(this, original.estimateSize_0(), original.characteristics_0() & -6);
    checkCriticalNotNull(map_0);
    this.map_0 = map_0;
    this.original = original;
}
defineClass(717, 484, $intern_18, StreamImpl$MapToObjSpliterator);
_.tryAdvance = function tryAdvance_17(action) {
    return $tryAdvance_6(this, action);
};
var Ljava_util_stream_StreamImpl$MapToObjSpliterator_2_classLit = createForClass('java.util.stream', 'StreamImpl/MapToObjSpliterator', 717);
function StreamImpl$MapToObjSpliterator$lambda$0$Type($$outer_0, action_1) {
    this.$$outer_0 = $$outer_0;
    this.action_1 = action_1;
}
defineClass(1058, 1, $intern_19, StreamImpl$MapToObjSpliterator$lambda$0$Type);
_.accept = function accept_32(arg0) {
    $lambda$0_4(this.$$outer_0, this.action_1, arg0);
};
var Ljava_util_stream_StreamImpl$MapToObjSpliterator$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/MapToObjSpliterator/lambda$0$Type', 1058);
function StreamImpl$SkipSpliterator(original) {
    Spliterators$AbstractSpliterator.call(this, original.hasCharacteristics(64) ? max_1(0, sub_2(original.estimateSize_0(), 1)) : $intern_21, original.characteristics_0());
    this.skip = 1;
    this.original = original;
}
defineClass(1057, 484, $intern_18, StreamImpl$SkipSpliterator);
_.tryAdvance = function tryAdvance_18(action) {
    while(gt(this.skip, 0)){
        if (!this.original.tryAdvance(new StreamImpl$SkipSpliterator$lambda$0$Type)) return false;
        this.skip = sub_2(this.skip, 1);
    }
    return this.original.tryAdvance(action);
};
_.skip = 0;
var Ljava_util_stream_StreamImpl$SkipSpliterator_2_classLit = createForClass('java.util.stream', 'StreamImpl/SkipSpliterator', 1057);
function StreamImpl$SkipSpliterator$lambda$0$Type() {}
defineClass(1062, 1, $intern_19, StreamImpl$SkipSpliterator$lambda$0$Type);
_.accept = function accept_33(arg0) {};
var Ljava_util_stream_StreamImpl$SkipSpliterator$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/SkipSpliterator/lambda$0$Type', 1062);
function $accept_1(this$static, value_0) {
    this$static.value_0 = value_0;
}
function StreamImpl$ValueConsumer() {}
defineClass(611, 1, $intern_19, StreamImpl$ValueConsumer);
_.accept = function accept_34(value_0) {
    $accept_1(this, value_0);
};
var Ljava_util_stream_StreamImpl$ValueConsumer_2_classLit = createForClass('java.util.stream', 'StreamImpl/ValueConsumer', 611);
function StreamImpl$lambda$0$Type() {}
defineClass(1063, 1, $intern_19, StreamImpl$lambda$0$Type);
_.accept = function accept_35(arg0) {
    $clinit_StreamImpl();
};
var Ljava_util_stream_StreamImpl$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/lambda$0$Type', 1063);
function StreamImpl$lambda$1$Type() {}
defineClass(1064, 1, $intern_19, StreamImpl$lambda$1$Type);
_.accept = function accept_36(arg0) {
    $clinit_StreamImpl();
};
var Ljava_util_stream_StreamImpl$lambda$1$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/lambda$1$Type', 1064);
function StreamImpl$lambda$4$Type(collector_0) {
    this.collector_0 = collector_0;
}
defineClass(1065, 1, {}, StreamImpl$lambda$4$Type);
_.apply_3 = function apply_26(arg0, arg1) {
    return lambda$4(this.collector_0, arg0, arg1);
};
var Ljava_util_stream_StreamImpl$lambda$4$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/lambda$4$Type', 1065);
function StreamImpl$lambda$5$Type(consumer_0, accumulator_1) {
    this.consumer_0 = consumer_0;
    this.accumulator_1 = accumulator_1;
}
defineClass(1066, 1, $intern_19, StreamImpl$lambda$5$Type);
_.accept = function accept_37(arg0) {
    lambda$5(this.consumer_0, this.accumulator_1, arg0);
};
var Ljava_util_stream_StreamImpl$lambda$5$Type_2_classLit = createForClass('java.util.stream', 'StreamImpl/lambda$5$Type', 1066);
function TerminatableStream$lambda$0$Type(throwables_0) {
    this.throwables_0 = throwables_0;
}
defineClass(1072, 1, $intern_19, TerminatableStream$lambda$0$Type);
_.accept = function accept_38(arg0) {
    lambda$0_3(this.throwables_0, castTo(arg0, 372));
};
var Ljava_util_stream_TerminatableStream$lambda$0$Type_2_classLit = createForClass('java.util.stream', 'TerminatableStream/lambda$0$Type', 1072);
function clone_0(array) {
    var result;
    result = array.slice();
    return stampJavaTypeInfo_0(result, array);
}
function copy_0(src_0, srcOfs, dest, destOfs, len, overwrite) {
    var batchEnd, batchStart, destArray, end, spliceArgs;
    if (len == 0) return;
    if (maskUndefined(src_0) === maskUndefined(dest)) {
        src_0 = src_0.slice(srcOfs, srcOfs + len);
        srcOfs = 0;
    }
    destArray = dest;
    for(batchStart = srcOfs, end = srcOfs + len; batchStart < end;){
        batchEnd = $wnd.Math.min(batchStart + 10000, end);
        len = batchEnd - batchStart;
        spliceArgs = src_0.slice(batchStart, batchEnd);
        spliceArgs.splice(0, 0, destOfs, overwrite ? len : 0);
        Array.prototype.splice.apply(destArray, spliceArgs);
        batchStart = batchEnd;
        destOfs += len;
    }
}
function createFrom(array, length_0) {
    return stampJavaTypeInfo_1(new Array(length_0), array);
}
function insertTo(array, index_0, value_0) {
    array.splice(index_0, 0, value_0);
}
function insertTo_0(array, index_0, values) {
    copy_0(values, 0, array, index_0, values.length, false);
}
function push_1(array, o) {
    array.push(o);
}
function removeFrom(array, index_0, deleteCount) {
    array.splice(index_0, deleteCount);
}
function setAt(array, index_0, value_0) {
    var originalValue;
    originalValue = array[index_0];
    array[index_0] = value_0;
    return originalValue;
}
function setLength(array, length_0) {
    array.length = length_0;
}
function sort_9(array, fn) {
    array.sort(fn);
}
defineClass(2088, 1, {});
function stampJavaTypeInfo_1(array, referenceType) {
    return stampJavaTypeInfo_0(array, referenceType);
}
function $groupStart(msg, expanded) {
    (!expanded && console.groupCollapsed != null ? console.groupCollapsed : console.group != null ? console.group : console.log).call(console, msg);
}
function $log_0(level, message) {
    var logFn;
    logFn = console[level];
    logFn.call(console, message);
}
function $log_1(this$static, level, t, label_0, expanded) {
    var cause, suppressed, suppressed$array, suppressed$index, suppressed$max;
    $groupStart(label_0 + $toString_4(t, t.getMessage()), expanded);
    $log_0(level, getBackingErrorStack(t));
    cause = t.cause_0;
    !!cause && $log_1(this$static, level, cause, 'Caused by: ', false);
    for(suppressed$array = (t.suppressedExceptions == null && (t.suppressedExceptions = initUnidimensionalArray(Ljava_lang_Throwable_2_classLit, $intern_16, 80, 0, 0, 1)), t.suppressedExceptions), suppressed$index = 0, suppressed$max = suppressed$array.length; suppressed$index < suppressed$max; ++suppressed$index){
        suppressed = suppressed$array[suppressed$index];
        $log_1(this$static, level, suppressed, 'Suppressed: ', false);
    }
    console.groupEnd != null && console.groupEnd.call(console);
}
function ConsoleLogger() {}
function getBackingErrorStack(t) {
    var backingError = t.backingJsObject;
    function stringify(fnStack) {
        if (!fnStack || fnStack.length == 0) return '';
        return '\t' + fnStack.join('\n\t');
    }
    return backingError && (backingError.stack || stringify(t['fnStack']));
}
defineClass(1960, 1, {}, ConsoleLogger);
var Ljavaemul_internal_ConsoleLogger_2_classLit = createForClass('javaemul.internal', 'ConsoleLogger', 1960);
function getIdentityHashCode(o) {
    switch(typeof o){
        case 'string':
            return $hashCode_2(o);
        case 'number':
            return $hashCode_1(o);
        case 'boolean':
            return $hashCode_0(o);
        default:
            return o == null ? 0 : getObjectIdentityHashCode(o);
    }
}
function getObjectIdentityHashCode(o) {
    return o.$H || (o.$H = ++nextHash);
}
var nextHash = 0;
function checkCriticalArgument(expression) {
    if (!expression) throw toJs(new IllegalArgumentException);
}
function checkCriticalArgument_0(expression, errorMessage) {
    if (!expression) throw toJs(new IllegalArgumentException_0(errorMessage));
}
function checkCriticalArrayBounds_0(start_0, end, length_0) {
    if (start_0 > end) throw toJs(new IllegalArgumentException_0('fromIndex: ' + start_0 + ' > toIndex: ' + end));
    if (start_0 < 0 || end > length_0) throw toJs(new ArrayIndexOutOfBoundsException_0('fromIndex: ' + start_0 + ', toIndex: ' + end + ', length: ' + length_0));
}
function checkCriticalArraySize(size_0) {
    if (size_0 < 0) throw toJs(new NegativeArraySizeException('Negative array size: ' + size_0));
}
function checkCriticalArrayType(expression) {
    if (!expression) throw toJs(new ArrayStoreException);
}
function checkCriticalArrayType_0(expression, errorMessage) {
    if (!expression) throw toJs(new ArrayStoreException_0(errorMessage));
}
function checkCriticalConcurrentModification(currentModCount, recordedModCount) {
    if (currentModCount != recordedModCount) throw toJs(new ConcurrentModificationException);
}
function checkCriticalElement(expression) {
    if (!expression) throw toJs(new NoSuchElementException);
}
function checkCriticalElementIndex(index_0, size_0) {
    if (index_0 < 0 || index_0 >= size_0) throw toJs(new IndexOutOfBoundsException_0('Index: ' + index_0 + ', Size: ' + size_0));
}
function checkCriticalNotNull(reference) {
    if (reference == null) throw toJs(new NullPointerException);
    return reference;
}
function checkCriticalNotNull_0(reference, errorMessage) {
    if (reference == null) throw toJs(new NullPointerException_0(errorMessage));
}
function checkCriticalPositionIndex(index_0, size_0) {
    if (index_0 < 0 || index_0 > size_0) throw toJs(new IndexOutOfBoundsException_0('Index: ' + index_0 + ', Size: ' + size_0));
}
function checkCriticalPositionIndexes(start_0, end, size_0) {
    if (start_0 < 0 || end > size_0) throw toJs(new IndexOutOfBoundsException_0('fromIndex: ' + start_0 + ', toIndex: ' + end + ', size: ' + size_0));
    if (start_0 > end) throw toJs(new IllegalArgumentException_0('fromIndex: ' + start_0 + ' > toIndex: ' + end));
}
function checkCriticalState(expression) {
    if (!expression) throw toJs(new IllegalStateException);
}
function checkCriticalState_0(expression, errorMessage) {
    if (!expression) throw toJs(new IllegalStateException_0(errorMessage));
}
function checkCriticalStringBounds(start_0, end, length_0) {
    if (start_0 < 0 || end > length_0 || end < start_0) throw toJs(new StringIndexOutOfBoundsException('fromIndex: ' + start_0 + ', toIndex: ' + end + ', length: ' + length_0));
}
function checkCriticalStringElementIndex(index_0, size_0) {
    if (index_0 < 0 || index_0 >= size_0) throw toJs(new StringIndexOutOfBoundsException('Index: ' + index_0 + ', Size: ' + size_0));
}
function checkCriticalType(expression) {
    if (!expression) throw toJs(new ClassCastException_0(null));
}
defineClass(2080, 1, {});
function fromBits_0(lowBits, highBits) {
    var highBitsLong, lowBitsLong;
    lowBitsLong = and_0(lowBits, $intern_69);
    highBitsLong = shl_0(highBits, 32);
    return or_0(highBitsLong, lowBitsLong);
}
function triangulate(vertices) {
    var bottomright, boundary, c, i, invalidTriangles, onBoundary, other, other$iterator, sa, sb, sc, size_0, superTriangle, tEdge, tEdge$iterator, tEdge$iterator0, tEdges, topleft, triangle, triangle$iterator, triangle$iterator0, triangulation, v, v$iterator, vertex, vertex$iterator;
    topleft = new KVector_1($intern_60, $intern_60);
    bottomright = new KVector_1($intern_61, $intern_61);
    for(v$iterator = new ArrayList$1(vertices); v$iterator.i < v$iterator.this$01.array.length;){
        v = castTo($next_6(v$iterator), 8);
        topleft.x_0 = $wnd.Math.min(topleft.x_0, v.x_0);
        topleft.y_0 = $wnd.Math.min(topleft.y_0, v.y_0);
        bottomright.x_0 = $wnd.Math.max(bottomright.x_0, v.x_0);
        bottomright.y_0 = $wnd.Math.max(bottomright.y_0, v.y_0);
    }
    size_0 = new KVector_1(bottomright.x_0 - topleft.x_0, bottomright.y_0 - topleft.y_0);
    sa = new KVector_1(topleft.x_0 - 50, topleft.y_0 - size_0.x_0 - 50);
    sb = new KVector_1(topleft.x_0 - 50, bottomright.y_0 + size_0.x_0 + 50);
    sc = new KVector_1(bottomright.x_0 + size_0.y_0 / 2 + 50, topleft.y_0 + size_0.y_0 / 2);
    superTriangle = new TTriangle(sa, sb, sc);
    triangulation = new HashSet;
    invalidTriangles = new ArrayList;
    boundary = new ArrayList;
    triangulation.map_0.put(superTriangle, triangulation);
    for(vertex$iterator = new ArrayList$1(vertices); vertex$iterator.i < vertex$iterator.this$01.array.length;){
        vertex = castTo($next_6(vertex$iterator), 8);
        invalidTriangles.array.length = 0;
        for(triangle$iterator0 = triangulation.map_0.keySet_0().iterator_0(); triangle$iterator0.hasNext_0();){
            triangle = castTo(triangle$iterator0.next_1(), 318);
            c = triangle.circumcenter;
            $distance_0(c, triangle.a);
            fuzzyCompare($distance_0(triangle.circumcenter, vertex), $distance_0(triangle.circumcenter, triangle.a)) < 0 && push_1(invalidTriangles.array, triangle);
        }
        boundary.array.length = 0;
        for(triangle$iterator = new ArrayList$1(invalidTriangles); triangle$iterator.i < triangle$iterator.this$01.array.length;){
            triangle = castTo($next_6(triangle$iterator), 318);
            for(tEdge$iterator0 = new ArrayList$1(triangle.tEdges); tEdge$iterator0.i < tEdge$iterator0.this$01.array.length;){
                tEdge = castTo($next_6(tEdge$iterator0), 176);
                onBoundary = true;
                for(other$iterator = new ArrayList$1(invalidTriangles); other$iterator.i < other$iterator.this$01.array.length;){
                    other = castTo($next_6(other$iterator), 318);
                    other != triangle && (equals_57(tEdge, $get_11(other.tEdges, 0)) || equals_57(tEdge, $get_11(other.tEdges, 1)) || equals_57(tEdge, $get_11(other.tEdges, 2))) && (onBoundary = false);
                }
                onBoundary && push_1(boundary.array, tEdge);
            }
        }
        $removeAll_1(triangulation, invalidTriangles);
        $forEach_0(triangulation, new BowyerWatsonTriangulation$lambda$0$Type);
        for(tEdge$iterator = new ArrayList$1(boundary); tEdge$iterator.i < tEdge$iterator.this$01.array.length;){
            tEdge = castTo($next_6(tEdge$iterator), 176);
            $add_6(triangulation, new TTriangle(vertex, tEdge.u, tEdge.v));
        }
    }
    tEdges = new HashSet;
    $forEach_0(triangulation, new BowyerWatsonTriangulation$lambda$1$Type(tEdges));
    i = tEdges.map_0.keySet_0().iterator_0();
    while(i.hasNext_0()){
        tEdge = castTo(i.next_1(), 176);
        ($contains_9(superTriangle, tEdge.u) || $contains_9(superTriangle, tEdge.v)) && i.remove();
    }
    $forEach_0(tEdges, new BowyerWatsonTriangulation$lambda$2$Type);
    return tEdges;
}
function BowyerWatsonTriangulation$lambda$0$Type() {}
defineClass(1776, 1, $intern_19, BowyerWatsonTriangulation$lambda$0$Type);
_.accept = function accept_39(arg0) {
    castTo(arg0, 318);
};
var Lorg_eclipse_elk_alg_common_BowyerWatsonTriangulation$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common', 'BowyerWatsonTriangulation/lambda$0$Type', 1776);
function BowyerWatsonTriangulation$lambda$1$Type(tEdges_0) {
    this.tEdges_0 = tEdges_0;
}
defineClass(1777, 1, $intern_19, BowyerWatsonTriangulation$lambda$1$Type);
_.accept = function accept_40(arg0) {
    $addAll(this.tEdges_0, castTo(arg0, 318).tEdges);
};
var Lorg_eclipse_elk_alg_common_BowyerWatsonTriangulation$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.common', 'BowyerWatsonTriangulation/lambda$1$Type', 1777);
function BowyerWatsonTriangulation$lambda$2$Type() {}
defineClass(1778, 1, $intern_19, BowyerWatsonTriangulation$lambda$2$Type);
_.accept = function accept_41(arg0) {
    castTo(arg0, 176);
};
var Lorg_eclipse_elk_alg_common_BowyerWatsonTriangulation$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.common', 'BowyerWatsonTriangulation/lambda$2$Type', 1778);
function createSpanningTree(tEdges, root, costFunction) {
    var edge, edge$iterator, edge$iterator0, edgeList, edges, minST, nextEdge, nextNode, nodeInTree, subTree, treeNodes, weight;
    weight = new HashMap;
    for(edge$iterator0 = tEdges.map_0.keySet_0().iterator_0(); edge$iterator0.hasNext_0();){
        edge = castTo(edge$iterator0.next_1(), 176);
        $put_6(weight, edge, costFunction.cost(edge));
    }
    edgeList = (checkNotNull(tEdges), tEdges ? new ArrayList_1(tEdges) : newArrayList_0(tEdges.map_0.keySet_0().iterator_0()));
    $sort(edgeList, new NaiveMinST$lambda$0$Type(weight));
    edges = newLinkedHashSet(edgeList);
    minST = new Tree(root);
    treeNodes = new HashMap;
    $put_9(treeNodes.hashCodeMap, root, minST);
    while(edges.map_0.size_1() != 0){
        nextEdge = null;
        nextNode = null;
        nodeInTree = null;
        for(edge$iterator = edges.map_0.keySet_0().iterator_0(); edge$iterator.hasNext_0();){
            edge = castTo(edge$iterator.next_1(), 176);
            if ($doubleValue(castToDouble(getEntryValueOrNull($getEntry_0(weight.hashCodeMap, edge)))) <= $intern_60) {
                if ($containsKey_3(treeNodes, edge.u) && !$containsKey_3(treeNodes, edge.v)) {
                    nextNode = edge.v;
                    nodeInTree = edge.u;
                    nextEdge = edge;
                    break;
                }
                if ($containsKey_3(treeNodes, edge.v)) {
                    if (!$containsKey_3(treeNodes, edge.u)) {
                        nextNode = edge.u;
                        nodeInTree = edge.v;
                        nextEdge = edge;
                        break;
                    }
                }
            }
        }
        if (!nextEdge) break;
        subTree = new Tree(nextNode);
        $add_3(castTo(getEntryValueOrNull($getEntry_0(treeNodes.hashCodeMap, nodeInTree)), 224).children, subTree);
        $put_9(treeNodes.hashCodeMap, nextNode, subTree);
        edges.map_0.remove_0(nextEdge);
    }
    return minST;
}
function lambda$0_6(weight_0, e1_1, e2_2) {
    return $compareTo_4(castToDouble(getEntryValueOrNull($getEntry_0(weight_0.hashCodeMap, e1_1))), castToDouble(getEntryValueOrNull($getEntry_0(weight_0.hashCodeMap, e2_2))));
}
function NaiveMinST$lambda$0$Type(weight_0) {
    this.weight_0 = weight_0;
}
defineClass(1773, 1, $intern_88, NaiveMinST$lambda$0$Type);
_.compare_1 = function compare_12(arg0, arg1) {
    return lambda$0_6(this.weight_0, castTo(arg0, 176), castTo(arg1, 176));
};
_.equals_0 = function equals_61(other) {
    return this === other;
};
_.reversed = function reversed_4() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_NaiveMinST$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common', 'NaiveMinST/lambda$0$Type', 1773);
function $execute(this$static) {
    var calcu;
    sortPortLists(this$static.adapter);
    calculateLabelAndNodeSizes(this$static.adapter);
    calcu = new NodeMarginCalculator(this$static.adapter);
    $process(calcu);
}
function NodeMicroLayout(adapter) {
    this.adapter = adapter;
}
defineClass(437, 1, {}, NodeMicroLayout);
var Lorg_eclipse_elk_alg_common_NodeMicroLayout_2_classLit = createForClass('org.eclipse.elk.alg.common', 'NodeMicroLayout', 437);
function TEdge(u, v) {
    this.u = u;
    this.v = v;
}
defineClass(176, 1, {
    176: 1
}, TEdge);
_.equals_0 = function equals_62(obj) {
    var other;
    if (instanceOf(obj, 176)) {
        other = castTo(obj, 176);
        return equals_57(this.u, other.u) && equals_57(this.v, other.v) || equals_57(this.u, other.v) && equals_57(this.v, other.u);
    } else return false;
};
_.hashCode_1 = function hashCode_59() {
    return hashCode_55(this.u) + hashCode_55(this.v);
};
var Lorg_eclipse_elk_alg_common_TEdge_2_classLit = createForClass('org.eclipse.elk.alg.common', 'TEdge', 176);
function $contains_9(this$static, vertex) {
    return equals_57(vertex, $get_11(this$static.vertices, 0)) || equals_57(vertex, $get_11(this$static.vertices, 1)) || equals_57(vertex, $get_11(this$static.vertices, 2));
}
function TTriangle(a, b, c) {
    var ab, ac, bc, e, f, g, px, py;
    this.a = a;
    this.b = b;
    this.c = c;
    this.tEdges = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_TEdge_2_classLit, 1), $intern_2, 176, 0, [
        new TEdge(a, b),
        new TEdge(b, c),
        new TEdge(c, a)
    ]));
    this.vertices = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        a,
        b,
        c
    ]));
    this.circumcenter = (ab = $sub_0($clone_1(this.b), this.a), ac = $sub_0($clone_1(this.c), this.a), bc = $sub_0($clone_1(this.c), this.b), e = ab.x_0 * (this.a.x_0 + this.b.x_0) + ab.y_0 * (this.a.y_0 + this.b.y_0), f = ac.x_0 * (this.a.x_0 + this.c.x_0) + ac.y_0 * (this.a.y_0 + this.c.y_0), g = 2 * (ab.x_0 * bc.y_0 - ab.y_0 * bc.x_0), px = (ac.y_0 * e - ab.y_0 * f) / g, py = (ab.x_0 * f - ac.x_0 * e) / g, new KVector_1(px, py));
}
defineClass(318, 1, {
    318: 1
}, TTriangle);
_.equals_0 = function equals_63(obj) {
    var other;
    if (instanceOf(obj, 318)) {
        other = castTo(obj, 318);
        return $contains_9(this, other.a) && $contains_9(this, other.b) && $contains_9(this, other.c);
    } else return false;
};
_.hashCode_1 = function hashCode_60() {
    return hashCode_55(this.a) + hashCode_55(this.b) + hashCode_55(this.c);
};
var Lorg_eclipse_elk_alg_common_TTriangle_2_classLit = createForClass('org.eclipse.elk.alg.common', 'TTriangle', 318);
function Tree(n) {
    this.node = n;
    this.children = new ArrayList;
}
defineClass(224, 1, {
    224: 1
}, Tree);
var Lorg_eclipse_elk_alg_common_Tree_2_classLit = createForClass('org.eclipse.elk.alg.common', 'Tree', 224);
function $go(this$static) {
    var h, h$iterator, p, p$iterator;
    $clinit_Collections();
    $sort(this$static.points, this$static.comparator);
    for(p$iterator = new ArrayList$1(this$static.points); p$iterator.i < p$iterator.this$01.array.length;){
        p = $next_6(p$iterator);
        for(h$iterator = new ArrayList$1(this$static.eventHandlers); h$iterator.i < h$iterator.this$01.array.length;){
            h = castTo($next_6(h$iterator), 678);
            h.handle(p);
        }
    }
}
function Scanline(points, comparator, eventHandlers) {
    this.comparator = comparator;
    this.points = points;
    this.eventHandlers = (checkNotNull(eventHandlers), new ArrayList_1(eventHandlers));
}
function execute(points, comparator, eventHandlers) {
    var copy;
    copy = (checkNotNull(points), new ArrayList_1(points));
    $go(new Scanline(copy, comparator, eventHandlers));
}
defineClass(1178, 1, {}, Scanline);
var Lorg_eclipse_elk_alg_common_compaction_Scanline_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction', 'Scanline', 1178);
var Lorg_eclipse_elk_alg_common_compaction_Scanline$EventHandler_2_classLit = createForInterface('org.eclipse.elk.alg.common.compaction', 'Scanline/EventHandler');
function $supports(this$static, direction) {
    return $containsEnum(this$static.supportedDirections, direction);
}
function CGraph(supportedDirections) {
    this.cNodes = new ArrayList;
    this.cGroups = new ArrayList;
    this.predefinedHorizontalConstraints = new ArrayList;
    this.predefinedVerticalConstraints = new ArrayList;
    this.supportedDirections = supportedDirections;
}
defineClass(1704, 1, {}, CGraph);
var Lorg_eclipse_elk_alg_common_compaction_oned_CGraph_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'CGraph', 1704);
function $addCNode(this$static, cNode) {
    if (cNode.cGroup) throw toJs(new RuntimeException_0('CNode belongs to another CGroup.'));
    $add_6(this$static.cNodes, cNode);
    cNode.cGroup = this$static;
    !this$static.reference && (this$static.reference = cNode);
}
function CGroup() {
    this.cNodes = new LinkedHashSet;
    this.incomingConstraints = new HashSet;
    this.outDegree = 0;
    this.outDegreeReal = 0;
}
defineClass(317, 1, {
    317: 1
}, CGroup);
_.delta = 0;
_.deltaNormalized = 0;
_.id_0 = 0;
_.outDegree = 0;
_.outDegreeReal = 0;
_.startPos = $intern_61;
var Lorg_eclipse_elk_alg_common_compaction_oned_CGroup_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'CGroup', 317);
function $create(this$static, graph) {
    $add_3(graph.cGroups, this$static.group_0);
    return this$static.group_0;
}
function $master(this$static, master) {
    this$static.group_0.master = master;
    return this$static;
}
function $nodes(this$static, nodes) {
    var n, n$array, n$index, n$max;
    for(n$array = nodes, n$index = 0, n$max = n$array.length; n$index < n$max; ++n$index){
        n = n$array[n$index];
        $addCNode(this$static.group_0, n);
    }
    return this$static;
}
function CGroup$CGroupBuilder() {
    this.group_0 = new CGroup;
}
defineClass(809, 1, {}, CGroup$CGroupBuilder);
var Lorg_eclipse_elk_alg_common_compaction_oned_CGroup$CGroupBuilder_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'CGroup/CGroupBuilder', 809);
function CNode() {
    this.cGroupOffset = new KVector;
    this.constraints = new ArrayList;
}
defineClass(60, 1, {
    60: 1
}, CNode);
_.toString_0 = function toString_76() {
    var number;
    if (this.toStringDelegate) return castToString(this.toStringDelegate.apply_0(this));
    return $ensureNamesAreInitialized(Lorg_eclipse_elk_alg_common_compaction_oned_CNode_2_classLit), Lorg_eclipse_elk_alg_common_compaction_oned_CNode_2_classLit.typeName + '@' + (number = getObjectIdentityHashCode(this) >>> 0, number.toString(16));
};
_.id_0 = 0;
_.startPos = $intern_61;
var Lorg_eclipse_elk_alg_common_compaction_oned_CNode_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'CNode', 60);
function $create_0(this$static, graph) {
    $add_3(graph.cNodes, this$static.node);
    return this$static.node;
}
function $hitbox(this$static, hitbox) {
    this$static.node.hitbox = hitbox;
    return this$static;
}
function $origin(this$static, origin_0) {
    this$static.node.origin_0 = origin_0;
    return this$static;
}
function $toStringDelegate(this$static, delegate) {
    this$static.node.toStringDelegate = delegate;
    return this$static;
}
function CNode$CNodeBuilder() {
    this.node = new CNode;
}
defineClass(808, 1, {}, CNode$CNodeBuilder);
var Lorg_eclipse_elk_alg_common_compaction_oned_CNode$CNodeBuilder_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'CNode/CNodeBuilder', 808);
function eq_0(d1, d2) {
    return $clinit_DoubleMath(), checkNonNegative($intern_41), $wnd.Math.abs(d1 - d2) <= $intern_41 || d1 == d2 || isNaN(d1) && isNaN(d2);
}
function gt_0(d1, d2) {
    return $clinit_DoubleMath(), $clinit_DoubleMath(), checkNonNegative($intern_41), ($wnd.Math.abs(d1 - d2) <= $intern_41 || d1 == d2 || isNaN(d1) && isNaN(d2) ? 0 : d1 < d2 ? -1 : d1 > d2 ? 1 : compare_0(isNaN(d1), isNaN(d2))) > 0;
}
function le(d1, d2) {
    return $clinit_DoubleMath(), $clinit_DoubleMath(), checkNonNegative($intern_41), ($wnd.Math.abs(d1 - d2) <= $intern_41 || d1 == d2 || isNaN(d1) && isNaN(d2) ? 0 : d1 < d2 ? -1 : d1 > d2 ? 1 : compare_0(isNaN(d1), isNaN(d2))) <= 0;
}
function lt_0(d1, d2) {
    return $clinit_DoubleMath(), $clinit_DoubleMath(), checkNonNegative($intern_41), ($wnd.Math.abs(d1 - d2) <= $intern_41 || d1 == d2 || isNaN(d1) && isNaN(d2) ? 0 : d1 < d2 ? -1 : d1 > d2 ? 1 : compare_0(isNaN(d1), isNaN(d2))) < 0;
}
function $clinit_ISpacingsHandler() {
    $clinit_ISpacingsHandler = emptyMethod;
    DEFAULT_SPACING_HANDLER = new ISpacingsHandler$1;
}
var DEFAULT_SPACING_HANDLER;
function ISpacingsHandler$1() {}
defineClass(1530, 1, {}, ISpacingsHandler$1);
_.getHorizontalSpacing = function getHorizontalSpacing(cNode1, cNode2) {
    return 0;
};
_.getVerticalSpacing = function getVerticalSpacing(cNode1, cNode2) {
    return 0;
};
var Lorg_eclipse_elk_alg_common_compaction_oned_ISpacingsHandler$1_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ISpacingsHandler/1', 1530);
function LongestPathCompaction() {}
defineClass(1799, 1, {}, LongestPathCompaction);
_.compact = function compact(compactor) {
    var cNode, cNode$iterator, cNode$iterator0, diff, group, group$iterator, incNode, incNode$iterator, minStartPos, node, node$iterator, node$iterator0, sinks, spacing, suggestedX;
    minStartPos = $intern_60;
    for(cNode$iterator0 = new ArrayList$1(compactor.cGraph.cNodes); cNode$iterator0.i < cNode$iterator0.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator0), 60);
        minStartPos = $wnd.Math.min(minStartPos, cNode.cGroup.reference.hitbox.x_0 + cNode.cGroupOffset.x_0);
    }
    sinks = new LinkedList;
    for(group$iterator = new ArrayList$1(compactor.cGraph.cGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 317);
        group.startPos = minStartPos;
        group.outDegree == 0 && $addNode_0(sinks, group, sinks.tail.prev, sinks.tail);
    }
    while(sinks.size_0 != 0){
        group = castTo(sinks.size_0 == 0 ? null : (checkCriticalElement(sinks.size_0 != 0), $removeNode_0(sinks, sinks.header.next_0)), 317);
        diff = group.reference.hitbox.x_0;
        for(node$iterator0 = group.cNodes.map_0.keySet_0().iterator_0(); node$iterator0.hasNext_0();){
            node = castTo(node$iterator0.next_1(), 60);
            suggestedX = group.startPos + node.cGroupOffset.x_0;
            !$isLocked(compactor, group, compactor.direction) || node.hitbox.x_0 < suggestedX ? node.startPos = suggestedX : node.startPos = node.hitbox.x_0;
        }
        diff -= group.reference.startPos;
        group.delta += diff;
        compactor.direction == ($clinit_Direction(), RIGHT_6) || compactor.direction == DOWN_1 ? group.deltaNormalized += diff : group.deltaNormalized -= diff;
        for(node$iterator = group.cNodes.map_0.keySet_0().iterator_0(); node$iterator.hasNext_0();){
            node = castTo(node$iterator.next_1(), 60);
            for(incNode$iterator = node.constraints.iterator_0(); incNode$iterator.hasNext_0();){
                incNode = castTo(incNode$iterator.next_1(), 60);
                $isHorizontal(compactor.direction) ? spacing = compactor.spacingsHandler.getHorizontalSpacing(node, incNode) : spacing = compactor.spacingsHandler.getVerticalSpacing(node, incNode);
                incNode.cGroup.startPos = $wnd.Math.max(incNode.cGroup.startPos, node.startPos + node.hitbox.width_0 + spacing - incNode.cGroupOffset.x_0);
                $isLocked_0(compactor, incNode, compactor.direction) && (incNode.cGroup.startPos = $wnd.Math.max(incNode.cGroup.startPos, incNode.hitbox.x_0 - incNode.cGroupOffset.x_0));
                --incNode.cGroup.outDegree;
                incNode.cGroup.outDegree == 0 && $add_7(sinks, incNode.cGroup);
            }
        }
    }
    for(cNode$iterator = new ArrayList$1(compactor.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        cNode.hitbox.x_0 = cNode.startPos;
    }
};
var Lorg_eclipse_elk_alg_common_compaction_oned_LongestPathCompaction_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'LongestPathCompaction', 1799);
function $clinit_OneDimensionalCompactor() {
    $clinit_OneDimensionalCompactor = emptyMethod;
    LONGEST_PATH_COMPACTION = new LongestPathCompaction;
    SCANLINE_CONSTRAINTS = new ScanlineConstraintCalculator;
    QUADRATIC_CONSTRAINTS = new QuadraticConstraintCalculation;
}
function $calculateConstraints(this$static) {
    var cNode, cNode$iterator, cstrs;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        cNode.constraints.clear_0();
    }
    $isHorizontal(this$static.direction) ? cstrs = this$static.cGraph.predefinedHorizontalConstraints : cstrs = this$static.cGraph.predefinedVerticalConstraints;
    $forEach_1(cstrs, new OneDimensionalCompactor$lambda$0$Type(this$static));
    this$static.constraintAlgorithm.calculateConstraints(this$static);
    $calculateConstraintsForCGroups(this$static);
}
function $calculateConstraintsForCGroups(this$static) {
    var cNode, cNode$iterator, group, group$iterator, group$iterator0, inc, inc$iterator;
    for(group$iterator0 = new ArrayList$1(this$static.cGraph.cGroups); group$iterator0.i < group$iterator0.this$01.array.length;){
        group = castTo($next_6(group$iterator0), 317);
        group.outDegree = 0;
        group.outDegreeReal = 0;
        group.incomingConstraints.map_0.clear_0();
    }
    for(group$iterator = new ArrayList$1(this$static.cGraph.cGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 317);
        for(cNode$iterator = group.cNodes.map_0.keySet_0().iterator_0(); cNode$iterator.hasNext_0();){
            cNode = castTo(cNode$iterator.next_1(), 60);
            for(inc$iterator = cNode.constraints.iterator_0(); inc$iterator.hasNext_0();){
                inc = castTo(inc$iterator.next_1(), 60);
                if (inc.cGroup != group) {
                    $add_6(group.incomingConstraints, inc);
                    ++inc.cGroup.outDegree;
                    ++inc.cGroup.outDegreeReal;
                }
            }
        }
    }
}
function $calculateGroupOffsets(this$static) {
    var group, group$iterator, n, n$iterator, n$iterator0;
    for(group$iterator = new ArrayList$1(this$static.cGraph.cGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 317);
        group.reference = null;
        for(n$iterator0 = group.cNodes.map_0.keySet_0().iterator_0(); n$iterator0.hasNext_0();){
            n = castTo(n$iterator0.next_1(), 60);
            $reset_5(n.cGroupOffset);
            (!group.reference || n.hitbox.x_0 < group.reference.hitbox.x_0) && (group.reference = n);
        }
        for(n$iterator = group.cNodes.map_0.keySet_0().iterator_0(); n$iterator.hasNext_0();){
            n = castTo(n$iterator.next_1(), 60);
            n.cGroupOffset.x_0 = n.hitbox.x_0 - group.reference.hitbox.x_0;
            n.cGroupOffset.y_0 = n.hitbox.y_0 - group.reference.hitbox.y_0;
        }
    }
    return this$static;
}
function $changeDirection(this$static, dir_0) {
    var oldDirection;
    if (this$static.finished) throw toJs(new IllegalStateException_0(($ensureNamesAreInitialized(Lorg_eclipse_elk_alg_common_compaction_oned_OneDimensionalCompactor_2_classLit), 'The ' + Lorg_eclipse_elk_alg_common_compaction_oned_OneDimensionalCompactor_2_classLit.simpleName + ' instance has been finished already.')));
    if (!$supports(this$static.cGraph, dir_0)) throw toJs(new RuntimeException_0('The direction ' + dir_0 + ' is not supported by the CGraph instance.'));
    if (dir_0 == this$static.direction) return this$static;
    oldDirection = this$static.direction;
    this$static.direction = dir_0;
    switch(oldDirection.ordinal){
        case 0:
            switch(dir_0.ordinal){
                case 2:
                    $calculateConstraints(this$static);
                    break;
                case 1:
                    $mirrorHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 4:
                    $transposeHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 3:
                    $transposeHitboxes(this$static);
                    $mirrorHitboxes(this$static);
                    $calculateConstraints(this$static);
            }
            break;
        case 2:
            switch(dir_0.ordinal){
                case 1:
                    $mirrorHitboxes(this$static);
                    $reverseConstraints(this$static);
                    break;
                case 4:
                    $transposeHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 3:
                    $transposeHitboxes(this$static);
                    $mirrorHitboxes(this$static);
                    $calculateConstraints(this$static);
            }
            break;
        case 1:
            switch(dir_0.ordinal){
                case 2:
                    $mirrorHitboxes(this$static);
                    $reverseConstraints(this$static);
                    break;
                case 4:
                    $mirrorHitboxes(this$static);
                    $transposeHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 3:
                    $mirrorHitboxes(this$static);
                    $transposeHitboxes(this$static);
                    $mirrorHitboxes(this$static);
                    $calculateConstraints(this$static);
            }
            break;
        case 4:
            switch(dir_0.ordinal){
                case 2:
                    $transposeHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 1:
                    $transposeHitboxes(this$static);
                    $mirrorHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 3:
                    $mirrorHitboxes(this$static);
                    $reverseConstraints(this$static);
            }
            break;
        case 3:
            switch(dir_0.ordinal){
                case 2:
                    $mirrorHitboxes(this$static);
                    $transposeHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 1:
                    $mirrorHitboxes(this$static);
                    $transposeHitboxes(this$static);
                    $mirrorHitboxes(this$static);
                    $calculateConstraints(this$static);
                    break;
                case 4:
                    $mirrorHitboxes(this$static);
                    $reverseConstraints(this$static);
            }
    }
    return this$static;
}
function $compact(this$static) {
    var g, g$iterator, n, n$iterator;
    if (this$static.finished) throw toJs(new IllegalStateException_0(($ensureNamesAreInitialized(Lorg_eclipse_elk_alg_common_compaction_oned_OneDimensionalCompactor_2_classLit), 'The ' + Lorg_eclipse_elk_alg_common_compaction_oned_OneDimensionalCompactor_2_classLit.simpleName + ' instance has been finished already.')));
    this$static.direction == ($clinit_Direction(), UNDEFINED_2) && $changeDirection(this$static, LEFT_6);
    for(g$iterator = new ArrayList$1(this$static.cGraph.cGroups); g$iterator.i < g$iterator.this$01.array.length;){
        g = castTo($next_6(g$iterator), 317);
        g.outDegree = g.outDegreeReal;
    }
    for(n$iterator = new ArrayList$1(this$static.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 60);
        n.startPos = $intern_61;
    }
    this$static.compactionAlgorithm.compact(this$static);
    return this$static;
}
function $isLocked(this$static, group, dir_0) {
    var n, n$iterator;
    for(n$iterator = group.cNodes.map_0.keySet_0().iterator_0(); n$iterator.hasNext_0();){
        n = castTo(n$iterator.next_1(), 60);
        if ($isLocked_0(this$static, n, dir_0)) return true;
    }
    return false;
}
function $isLocked_0(this$static, node, dir_0) {
    if (this$static.lockFun) return this$static.lockFun.isLocked(node, dir_0);
    return false;
}
function $lambda$0_5(this$static, p_0) {
    this$static.direction == ($clinit_Direction(), LEFT_6) || this$static.direction == UP_1 ? castTo(p_0.first, 60).constraints.add_2(castTo(p_0.second, 60)) : castTo(p_0.second, 60).constraints.add_2(castTo(p_0.first, 60));
}
function $mirrorHitboxes(this$static) {
    var cNode, cNode$iterator;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        cNode.hitbox.x_0 = -cNode.hitbox.x_0 - cNode.hitbox.width_0;
    }
    $calculateGroupOffsets(this$static);
}
function $reverseConstraints(this$static) {
    var cNode, cNode$iterator, cNode$iterator0, cNode$iterator1, inc, inc$iterator, incMap;
    incMap = new HashMap;
    for(cNode$iterator0 = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator0.i < cNode$iterator0.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator0), 60);
        $put_6(incMap, cNode, new ArrayList);
    }
    for(cNode$iterator1 = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator1.i < cNode$iterator1.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator1), 60);
        cNode.startPos = $intern_61;
        for(inc$iterator = cNode.constraints.iterator_0(); inc$iterator.hasNext_0();){
            inc = castTo(inc$iterator.next_1(), 60);
            castTo(getEntryValueOrNull($getEntry_0(incMap.hashCodeMap, inc)), 15).add_2(cNode);
        }
    }
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        cNode.constraints.clear_0();
        cNode.constraints = castTo(getEntryValueOrNull($getEntry_0(incMap.hashCodeMap, cNode)), 15);
    }
    $calculateConstraintsForCGroups(this$static);
}
function $setCompactionAlgorithm(this$static, compactor) {
    this$static.compactionAlgorithm = compactor;
    return this$static;
}
function $setConstraintAlgorithm(this$static, theConstraintAlgorithm) {
    this$static.constraintAlgorithm = theConstraintAlgorithm;
    return this$static;
}
function $setLockFunction(this$static, fun) {
    this$static.lockFun = fun;
    return this$static;
}
function $setSpacingsHandler(this$static, handler) {
    this$static.spacingsHandler = handler;
    return this$static;
}
function $transposeHitboxes(this$static) {
    var cNode, cNode$iterator, tmp;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        tmp = cNode.hitbox.x_0;
        cNode.hitbox.x_0 = cNode.hitbox.y_0;
        cNode.hitbox.y_0 = tmp;
        tmp = cNode.hitbox.width_0;
        cNode.hitbox.width_0 = cNode.hitbox.height;
        cNode.hitbox.height = tmp;
        tmp = cNode.cGroupOffset.x_0;
        cNode.cGroupOffset.x_0 = cNode.cGroupOffset.y_0;
        cNode.cGroupOffset.y_0 = tmp;
    }
    $calculateGroupOffsets(this$static);
}
function OneDimensionalCompactor(cGraph) {
    $clinit_OneDimensionalCompactor();
    var n, n$iterator;
    this.compactionAlgorithm = LONGEST_PATH_COMPACTION;
    this.constraintAlgorithm = SCANLINE_CONSTRAINTS;
    this.spacingsHandler = ($clinit_ISpacingsHandler(), DEFAULT_SPACING_HANDLER);
    this.direction = ($clinit_Direction(), UNDEFINED_2);
    this.cGraph = cGraph;
    $calculateGroupOffsets(this);
    for(n$iterator = new ArrayList$1(cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 60);
        !n.cGroup && $create($nodes(new CGroup$CGroupBuilder, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_compaction_oned_CNode_2_classLit, 1), $intern_2, 60, 0, [
            n
        ])), cGraph);
        n.hitboxPreCompaction = new ElkRectangle_1(n.hitbox);
    }
}
defineClass(1702, 1, {}, OneDimensionalCompactor);
_.finished = false;
var LONGEST_PATH_COMPACTION, QUADRATIC_CONSTRAINTS, SCANLINE_CONSTRAINTS;
var Lorg_eclipse_elk_alg_common_compaction_oned_OneDimensionalCompactor_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'OneDimensionalCompactor', 1702);
function OneDimensionalCompactor$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1703, 1, $intern_19, OneDimensionalCompactor$lambda$0$Type);
_.accept = function accept_42(arg0) {
    $lambda$0_5(this.$$outer_0, castTo(arg0, 47));
};
var Lorg_eclipse_elk_alg_common_compaction_oned_OneDimensionalCompactor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'OneDimensionalCompactor/lambda$0$Type', 1703);
function QuadraticConstraintCalculation() {}
defineClass(1800, 1, {}, QuadraticConstraintCalculation);
_.calculateConstraints = function calculateConstraints(compactor) {
    var cNode, cNode$iterator, cNode1, cNode1$iterator, cNode2, cNode2$iterator, spacing;
    for(cNode$iterator = new ArrayList$1(compactor.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        cNode.constraints.clear_0();
    }
    for(cNode1$iterator = new ArrayList$1(compactor.cGraph.cNodes); cNode1$iterator.i < cNode1$iterator.this$01.array.length;){
        cNode1 = castTo($next_6(cNode1$iterator), 60);
        for(cNode2$iterator = new ArrayList$1(compactor.cGraph.cNodes); cNode2$iterator.i < cNode2$iterator.this$01.array.length;){
            cNode2 = castTo($next_6(cNode2$iterator), 60);
            if (cNode1 == cNode2) continue;
            if (!!cNode1.cGroup && cNode1.cGroup == cNode2.cGroup) continue;
            $isHorizontal(compactor.direction) ? spacing = compactor.spacingsHandler.getVerticalSpacing(cNode1, cNode2) : spacing = compactor.spacingsHandler.getHorizontalSpacing(cNode1, cNode2);
            (cNode2.hitbox.x_0 > cNode1.hitbox.x_0 || cNode1.hitbox.x_0 == cNode2.hitbox.x_0 && cNode1.hitbox.width_0 < cNode2.hitbox.width_0) && gt_0(cNode2.hitbox.y_0 + cNode2.hitbox.height + spacing, cNode1.hitbox.y_0) && lt_0(cNode2.hitbox.y_0, cNode1.hitbox.y_0 + cNode1.hitbox.height + spacing) && cNode1.constraints.add_2(cNode2);
        }
    }
};
var Lorg_eclipse_elk_alg_common_compaction_oned_QuadraticConstraintCalculation_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'QuadraticConstraintCalculation', 1800);
function $applyOr(this$static, other) {
    this$static.left = this$static.left | other.left;
    this$static.right = this$static.right | other.right;
    this$static.up = this$static.up | other.up;
    this$static.down = this$static.down | other.down;
}
function $get_18(this$static, direction) {
    switch(direction.ordinal){
        case 2:
            return this$static.left;
        case 1:
            return this$static.right;
        case 4:
            return this$static.up;
        case 3:
            return this$static.down;
        default:
            return false;
    }
}
function $set_2(this$static, value_0, direction) {
    switch(direction.ordinal){
        case 2:
            this$static.left = value_0;
            break;
        case 1:
            this$static.right = value_0;
            break;
        case 4:
            this$static.up = value_0;
            break;
        case 3:
            this$static.down = value_0;
    }
}
function $set_3(this$static) {
    this$static.left = false;
    this$static.right = false;
    this$static.up = false;
    this$static.down = false;
}
function Quadruplet() {
    $set_3(this);
}
defineClass(514, 1, {
    514: 1
}, Quadruplet);
_.down = false;
_.left = false;
_.right = false;
_.up = false;
var Lorg_eclipse_elk_alg_common_compaction_oned_Quadruplet_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'Quadruplet', 514);
function $overlap(n1, n2) {
    if (!n1 || !n2 || n1 == n2) return false;
    return le(n1.hitbox.x_0, n2.hitbox.x_0 + n2.hitbox.width_0) && le(n2.hitbox.x_0, n1.hitbox.x_0 + n1.hitbox.width_0);
}
function $sweep(this$static, filterFun) {
    var n, n$iterator, points;
    points = new ArrayList;
    for(n$iterator = new ArrayList$1(this$static.compactor.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 60);
        if (filterFun.apply_1(n)) {
            $add_3(points, new ScanlineConstraintCalculator$Timestamp(n, true));
            $add_3(points, new ScanlineConstraintCalculator$Timestamp(n, false));
        }
    }
    $reset_1(this$static.constraintsScanlineHandler);
    execute(points, this$static.constraintsScanlineComparator, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_compaction_Scanline$EventHandler_2_classLit, 1), $intern_2, 678, 0, [
        this$static.constraintsScanlineHandler
    ])));
}
function ScanlineConstraintCalculator() {
    this.constraintsScanlineComparator = new ScanlineConstraintCalculator$lambda$0$Type;
    this.constraintsScanlineHandler = new ScanlineConstraintCalculator$ConstraintsScanlineHandler(this);
}
function lambda$0_7(p1_0, p2_1) {
    var cmp, y1, y2;
    y1 = p1_0.node.hitbox.y_0;
    p1_0.low || (y1 += p1_0.node.hitbox.height);
    y2 = p2_1.node.hitbox.y_0;
    p2_1.low || (y2 += p2_1.node.hitbox.height);
    cmp = compare_4(y1, y2);
    if (cmp == 0) {
        if (!p1_0.low && p2_1.low) return -1;
        else if (!p2_1.low && p1_0.low) return 1;
    }
    return cmp;
}
defineClass(797, 1, {}, ScanlineConstraintCalculator);
_.calculateConstraints = function calculateConstraints_0(theCompactor) {
    this.compactor = theCompactor;
    $sweep(this, new ScanlineConstraintCalculator$lambda$1$Type);
};
var Lorg_eclipse_elk_alg_common_compaction_oned_ScanlineConstraintCalculator_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ScanlineConstraintCalculator', 797);
function $handle(this$static, p) {
    var left, right;
    p.low ? $insert_2(this$static, p) : (left = castTo($lower(this$static.intervals, p.node), 60), !!left && left == this$static.cand[p.node.id_0] && !!left.cGroup && left.cGroup != p.node.cGroup && left.constraints.add_2(p.node), right = castTo($higher(this$static.intervals, p.node), 60), !!right && this$static.cand[right.id_0] == p.node && !!right.cGroup && right.cGroup != p.node.cGroup && p.node.constraints.add_2(right), $remove_28(this$static.intervals, p.node), undefined);
}
function $insert_2(this$static, p) {
    var right, success;
    success = $add_10(this$static.intervals, p.node);
    if (!success) throw toJs(new IllegalStateException_0('Invalid hitboxes for scanline constraint calculation.'));
    ($overlap(p.node, castTo($floor(this$static.intervals, p.node), 60)) || $overlap(p.node, castTo($ceiling(this$static.intervals, p.node), 60))) && ($clinit_System(), String.fromCharCode(10));
    this$static.cand[p.node.id_0] = castTo($lower(this$static.intervals, p.node), 60);
    right = castTo($higher(this$static.intervals, p.node), 60);
    !!right && (this$static.cand[right.id_0] = p.node);
}
function $reset_1(this$static) {
    var index_0, n, n$iterator;
    this$static.intervals.map_0.clear_0();
    this$static.cand = initUnidimensionalArray(Lorg_eclipse_elk_alg_common_compaction_oned_CNode_2_classLit, $intern_2, 60, this$static.this$01.compactor.cGraph.cNodes.array.length, 0, 1);
    index_0 = 0;
    for(n$iterator = new ArrayList$1(this$static.this$01.compactor.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 60);
        n.id_0 = index_0++;
    }
}
function ScanlineConstraintCalculator$ConstraintsScanlineHandler(this$0) {
    this.this$01 = this$0;
    this.intervals = new TreeSet_0(castTo(checkNotNull(new ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type), 51));
}
function lambda$0_8(c1_0, c2_1) {
    return compare_4(c1_0.hitbox.x_0 + c1_0.hitbox.width_0 / 2, c2_1.hitbox.x_0 + c2_1.hitbox.width_0 / 2);
}
defineClass(1730, 1, {
    678: 1
}, ScanlineConstraintCalculator$ConstraintsScanlineHandler);
_.handle = function handle(p) {
    $handle(this, castTo(p, 459));
};
var Lorg_eclipse_elk_alg_common_compaction_oned_ScanlineConstraintCalculator$ConstraintsScanlineHandler_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ScanlineConstraintCalculator/ConstraintsScanlineHandler', 1730);
function ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type() {}
defineClass(1731, 1, $intern_88, ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type);
_.compare_1 = function compare_13(arg0, arg1) {
    return lambda$0_8(castTo(arg0, 60), castTo(arg1, 60));
};
_.equals_0 = function equals_64(other) {
    return this === other;
};
_.reversed = function reversed_5() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_compaction_oned_ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ScanlineConstraintCalculator/ConstraintsScanlineHandler/lambda$0$Type', 1731);
function ScanlineConstraintCalculator$Timestamp(node, low) {
    this.node = node;
    this.low = low;
}
defineClass(459, 1, {
    459: 1
}, ScanlineConstraintCalculator$Timestamp);
_.low = false;
var Lorg_eclipse_elk_alg_common_compaction_oned_ScanlineConstraintCalculator$Timestamp_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ScanlineConstraintCalculator/Timestamp', 459);
function ScanlineConstraintCalculator$lambda$0$Type() {}
defineClass(1732, 1, $intern_88, ScanlineConstraintCalculator$lambda$0$Type);
_.compare_1 = function compare_14(arg0, arg1) {
    return lambda$0_7(castTo(arg0, 459), castTo(arg1, 459));
};
_.equals_0 = function equals_65(other) {
    return this === other;
};
_.reversed = function reversed_6() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_compaction_oned_ScanlineConstraintCalculator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ScanlineConstraintCalculator/lambda$0$Type', 1732);
function ScanlineConstraintCalculator$lambda$1$Type() {}
defineClass(1733, 1, $intern_89, ScanlineConstraintCalculator$lambda$1$Type);
_.apply_1 = function apply_27(arg0) {
    return castTo(arg0, 60), true;
};
_.equals_0 = function equals_66(other) {
    return this === other;
};
_.test_0 = function test_5(input_0) {
    return castTo(input_0, 60), true;
};
var Lorg_eclipse_elk_alg_common_compaction_oned_ScanlineConstraintCalculator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.compaction.oned', 'ScanlineConstraintCalculator/lambda$1$Type', 1733);
function $getOther(this$static, some_0) {
    if (some_0 == this$static.source) return this$static.target;
    else if (some_0 == this$static.target) return this$static.source;
    else throw toJs(new IllegalArgumentException_0('Node ' + some_0 + ' not part of edge ' + this$static));
}
function NEdge() {}
defineClass(216, 1, {
    216: 1
}, NEdge);
_.toString_0 = function toString_77() {
    return 'NEdge[id=' + this.id_0 + ' w=' + this.weight + ' d=' + this.delta + ']';
};
_.delta = 1;
_.id_0 = 0;
_.internalId = 0;
_.treeEdge = false;
_.weight = 0;
var Lorg_eclipse_elk_alg_common_networksimplex_NEdge_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NEdge', 216);
function $create_1(this$static) {
    if (!this$static.edge.source || !this$static.edge.target) throw toJs(new IllegalStateException_0(($ensureNamesAreInitialized(Lorg_eclipse_elk_alg_common_networksimplex_NEdge_2_classLit), Lorg_eclipse_elk_alg_common_networksimplex_NEdge_2_classLit.simpleName + ' must have a source and target ' + ($ensureNamesAreInitialized(Lorg_eclipse_elk_alg_common_networksimplex_NNode_2_classLit), Lorg_eclipse_elk_alg_common_networksimplex_NNode_2_classLit.simpleName) + ' specified.')));
    if (this$static.edge.source == this$static.edge.target) throw toJs(new IllegalStateException_0('Network simplex does not support self-loops: ' + this$static.edge + ' ' + this$static.edge.source + ' ' + this$static.edge.target));
    $add_11(this$static.edge.source.outgoingEdges, this$static.edge);
    $add_11(this$static.edge.target.incomingEdges, this$static.edge);
    return this$static.edge;
}
function $delta(this$static, delta) {
    this$static.edge.delta = delta;
    return this$static;
}
function $source(this$static, source) {
    this$static.edge.source = source;
    return this$static;
}
function $target(this$static, target) {
    this$static.edge.target = target;
    return this$static;
}
function $weight(this$static, weight) {
    this$static.edge.weight = weight;
    return this$static;
}
function NEdge$NEdgeBuilder() {
    this.edge = new NEdge;
}
defineClass(182, 1, {}, NEdge$NEdgeBuilder);
var Lorg_eclipse_elk_alg_common_networksimplex_NEdge$NEdgeBuilder_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NEdge/NEdgeBuilder', 182);
function $createArtificialRootAndConnect(this$static, nodesToConnect) {
    var root, src_0, src$iterator;
    root = $create_2(new NNode$NNodeBuilder, this$static);
    for(src$iterator = new ArrayList$1(nodesToConnect); src$iterator.i < src$iterator.this$01.array.length;){
        src_0 = castTo($next_6(src$iterator), 123);
        $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 0), 0), root), src_0));
    }
    return root;
}
function $dfs(this$static, node, mark) {
    var edge, edge$iterator, other;
    if (mark[node.internalId]) return;
    mark[node.internalId] = true;
    for(edge$iterator = new ArrayList$1($getConnectedEdges(node)); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        other = $getOther(edge, node);
        $dfs(this$static, other, mark);
    }
}
function $findConCompRepresentatives(this$static) {
    var ccRep, mark, node, node$iterator;
    ccRep = new ArrayList;
    mark = initUnidimensionalArray(Z_classLit, $intern_90, 30, this$static.nodes.array.length, 16, 1);
    fill0_3(mark, mark.length);
    for(node$iterator = new ArrayList$1(this$static.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        if (!mark[node.internalId]) {
            push_1(ccRep.array, node);
            $dfs(this$static, node, mark);
        }
    }
    return ccRep;
}
function $makeConnected(this$static) {
    var ccRep, id_0, n, n$iterator, root;
    id_0 = 0;
    for(n$iterator = new ArrayList$1(this$static.nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 123);
        n.internalId = id_0++;
    }
    ccRep = $findConCompRepresentatives(this$static);
    root = null;
    ccRep.array.length > 1 && (root = $createArtificialRootAndConnect(this$static, ccRep));
    return root;
}
function NGraph() {
    this.nodes = new ArrayList;
}
defineClass(646, 1, {}, NGraph);
var Lorg_eclipse_elk_alg_common_networksimplex_NGraph_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NGraph', 646);
function $getConnectedEdges(this$static) {
    if (this$static.incomingEdgesModCnt != this$static.incomingEdges.modCount || this$static.outgoingEdgesModCnt != this$static.outgoingEdges.modCount) {
        setLength(this$static.allEdges.array, 0);
        $addAll_2(this$static.allEdges, this$static.incomingEdges);
        $addAll_2(this$static.allEdges, this$static.outgoingEdges);
        this$static.incomingEdgesModCnt = this$static.incomingEdges.modCount;
        this$static.outgoingEdgesModCnt = this$static.outgoingEdges.modCount;
    }
    return this$static.allEdges;
}
function NNode() {
    this.outgoingEdges = new NNode$ChangeAwareArrayList;
    this.incomingEdges = new NNode$ChangeAwareArrayList;
    this.allEdges = new ArrayList;
    this.unknownCutvalues = new ArrayList;
}
defineClass(123, 1, {
    123: 1
}, NNode);
_.incomingEdgesModCnt = -1;
_.internalId = 0;
_.layer = 0;
_.outgoingEdgesModCnt = -1;
_.treeNode = false;
var Lorg_eclipse_elk_alg_common_networksimplex_NNode_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NNode', 123);
function $add_11(this$static, e) {
    ++this$static.modCount;
    return $add_3(this$static.list, e);
}
function $remove_29(this$static, o) {
    ++this$static.modCount;
    return $remove_12(this$static.list, o);
}
function NNode$ChangeAwareArrayList() {
    this.list = new ArrayList;
}
defineClass(788, 1, $intern_73, NNode$ChangeAwareArrayList);
_.forEach_0 = function forEach_24(action) {
    $forEach_0(this, action);
};
_.sort_0 = function sort_10(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_37() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.stream = function stream_6() {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(this, 16));
};
_.add_3 = function add_41(index_0, element) {
    ++this.modCount;
    $add_2(this.list, index_0, element);
};
_.add_2 = function add_42(e) {
    return $add_11(this, e);
};
_.addAll_0 = function addAll_21(index_0, c) {
    ++this.modCount;
    return $addAll_1(this.list, index_0, c);
};
_.addAll = function addAll_22(c) {
    ++this.modCount;
    return $addAll_2(this.list, c);
};
_.clear_0 = function clear_51() {
    ++this.modCount;
    setLength(this.list.array, 0);
};
_.contains = function contains_48(o) {
    return $indexOf_3(this.list, o, 0) != -1;
};
_.containsAll = function containsAll_10(c) {
    return $containsAll(this.list, c);
};
_.get_0 = function get_48(index_0) {
    return $get_11(this.list, index_0);
};
_.indexOf_0 = function indexOf_7(o) {
    return $indexOf_3(this.list, o, 0);
};
_.isEmpty = function isEmpty_25() {
    return this.list.array.length == 0;
};
_.iterator_0 = function iterator_66() {
    return unmodifiableIterator(new ArrayList$1(this.list));
};
_.listIterator_0 = function listIterator_15() {
    throw toJs(new UnsupportedOperationException);
};
_.listIterator_1 = function listIterator_16(index_0) {
    throw toJs(new UnsupportedOperationException);
};
_.remove_2 = function remove_91(index_0) {
    ++this.modCount;
    return $remove_11(this.list, index_0);
};
_.remove_1 = function remove_92(o) {
    return $remove_29(this, o);
};
_.set_2 = function set_20(index_0, element) {
    ++this.modCount;
    return $set_1(this.list, index_0, element);
};
_.size_1 = function size_65() {
    return this.list.array.length;
};
_.subList = function subList_9(fromIndex, toIndex) {
    return new AbstractList$SubList(this.list, fromIndex, toIndex);
};
_.toArray = function toArray_23() {
    return clone_0(this.list.array);
};
_.toArray_0 = function toArray_24(a) {
    return $toArray_1(this.list, a);
};
_.modCount = 0;
var Lorg_eclipse_elk_alg_common_networksimplex_NNode$ChangeAwareArrayList_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NNode/ChangeAwareArrayList', 788);
function $create_2(this$static, graph) {
    $add_3(graph.nodes, this$static.node);
    return this$static.node;
}
function $origin_0(this$static, origin_0) {
    this$static.node.origin_0 = origin_0;
    return this$static;
}
function NNode$NNodeBuilder() {
    this.node = new NNode;
}
defineClass(271, 1, {}, NNode$NNodeBuilder);
var Lorg_eclipse_elk_alg_common_networksimplex_NNode$NNodeBuilder_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NNode/NNodeBuilder', 271);
function $balance(this$static, filling) {
    var i, newLayer, node, node$iterator, range;
    range = null;
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        if (node.incomingEdges.list.array.length == node.outgoingEdges.list.array.length) {
            newLayer = node.layer;
            range = $minimalSpan(node);
            for(i = node.layer - castTo(range.first, 17).value_0 + 1; i < node.layer + castTo(range.second, 17).value_0; i++)filling[i] < filling[newLayer] && (newLayer = i);
            if (filling[newLayer] < filling[node.layer]) {
                --filling[node.layer];
                ++filling[newLayer];
                node.layer = newLayer;
            }
        }
    }
}
function $cutvalues(this$static) {
    var edge, edge$iterator, leafs, node, node$iterator, node$iterator0, source, target, toDetermine, treeEdgeCount;
    leafs = new ArrayList;
    for(node$iterator0 = new ArrayList$1(this$static.graph_0.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 123);
        treeEdgeCount = 0;
        node.unknownCutvalues.array.length = 0;
        for(edge$iterator = new ArrayList$1($getConnectedEdges(node)); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 216);
            if (edge.treeEdge) {
                $add_3(node.unknownCutvalues, edge);
                ++treeEdgeCount;
            }
        }
        treeEdgeCount == 1 && push_1(leafs.array, node);
    }
    for(node$iterator = new ArrayList$1(leafs); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        while(node.unknownCutvalues.array.length == 1){
            toDetermine = castTo($next_6(new ArrayList$1(node.unknownCutvalues)), 216);
            this$static.cutvalue[toDetermine.internalId] = toDetermine.weight;
            source = toDetermine.source;
            target = toDetermine.target;
            for(edge$iterator = new ArrayList$1($getConnectedEdges(node)); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 216);
                equals_Ljava_lang_Object__Z__devirtual$(edge, toDetermine) || (edge.treeEdge ? source == edge.source || target == edge.target ? this$static.cutvalue[toDetermine.internalId] -= this$static.cutvalue[edge.internalId] - edge.weight : this$static.cutvalue[toDetermine.internalId] += this$static.cutvalue[edge.internalId] - edge.weight : node == source ? edge.source == node ? this$static.cutvalue[toDetermine.internalId] += edge.weight : this$static.cutvalue[toDetermine.internalId] -= edge.weight : edge.source == node ? this$static.cutvalue[toDetermine.internalId] -= edge.weight : this$static.cutvalue[toDetermine.internalId] += edge.weight);
            }
            $remove_12(source.unknownCutvalues, toDetermine);
            $remove_12(target.unknownCutvalues, toDetermine);
            source == node ? node = toDetermine.target : node = toDetermine.source;
        }
    }
}
function $enterEdge(this$static, leave) {
    var edge, edge$iterator, repSlack, replace, slack, source, target;
    if (!leave.treeEdge) throw toJs(new IllegalArgumentException_0('The input edge is not a tree edge.'));
    replace = null;
    repSlack = $intern_0;
    for(edge$iterator = new ArrayList$1(this$static.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        source = edge.source;
        target = edge.target;
        if ($isInHead(this$static, source, leave) && !$isInHead(this$static, target, leave)) {
            slack = target.layer - source.layer - edge.delta;
            if (slack < repSlack) {
                repSlack = slack;
                replace = edge;
            }
        }
    }
    return replace;
}
function $exchange(this$static, leave, enter) {
    var delta, node, node$iterator;
    if (!leave.treeEdge) throw toJs(new IllegalArgumentException_0('Given leave edge is no tree edge.'));
    if (enter.treeEdge) throw toJs(new IllegalArgumentException_0('Given enter edge is a tree edge already.'));
    leave.treeEdge = false;
    $remove_18(this$static.treeEdges, leave);
    enter.treeEdge = true;
    $add_6(this$static.treeEdges, enter);
    delta = enter.target.layer - enter.source.layer - enter.delta;
    $isInHead(this$static, enter.target, leave) || (delta = -delta);
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        $isInHead(this$static, node, leave) || (node.layer += delta);
    }
    this$static.postOrder = 1;
    fill_2(this$static.edgeVisited);
    $postorderTraversal(this$static, castTo($next_6(new ArrayList$1(this$static.graph_0.nodes)), 123));
    $cutvalues(this$static);
}
function $execute_0(this$static, monitor) {
    var e, iter, node, node$iterator, removeSubtrees;
    monitor.begin('Network simplex', 1);
    if (this$static.graph_0.nodes.array.length < 1) {
        monitor.done_1();
        return;
    }
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        node.layer = 0;
    }
    removeSubtrees = this$static.graph_0.nodes.array.length >= 40;
    removeSubtrees && $removeSubtrees(this$static);
    $initialize(this$static);
    $feasibleTree(this$static);
    e = $leaveEdge(this$static);
    iter = 0;
    while(!!e && iter < this$static.iterationLimit){
        $exchange(this$static, e, $enterEdge(this$static, e));
        e = $leaveEdge(this$static);
        ++iter;
    }
    removeSubtrees && $reattachSubtrees(this$static);
    this$static.balance ? $balance(this$static, $normalize(this$static)) : $normalize(this$static);
    this$static.cutvalue = null;
    this$static.edges = null;
    this$static.treeEdges = null;
    this$static.edgeVisited = null;
    this$static.lowestPoID = null;
    this$static.poID = null;
    this$static.sources = null;
    this$static.subtreeNodesStack = null;
    monitor.done_1();
}
function $feasibleTree(this$static) {
    var e, node, node$iterator, slack;
    $layeringTopologicalNumbering(this$static, this$static.sources);
    if (this$static.edges.array.length > 0) {
        fill_2(this$static.edgeVisited);
        while($tightTreeDFS(this$static, castTo($next_6(new ArrayList$1(this$static.graph_0.nodes)), 123)) < this$static.graph_0.nodes.array.length){
            e = $minimalSlack(this$static);
            slack = e.target.layer - e.source.layer - e.delta;
            e.target.treeNode && (slack = -slack);
            for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
                node = castTo($next_6(node$iterator), 123);
                node.treeNode && (node.layer += slack);
            }
            fill_2(this$static.edgeVisited);
        }
        fill_2(this$static.edgeVisited);
        $postorderTraversal(this$static, castTo($next_6(new ArrayList$1(this$static.graph_0.nodes)), 123));
        $cutvalues(this$static);
    }
}
function $initialize(this$static) {
    var counter, edge, edge$iterator, index_0, n, n$iterator, node, node$iterator, numEdges, numNodes, theEdges;
    numNodes = this$static.graph_0.nodes.array.length;
    for(n$iterator = new ArrayList$1(this$static.graph_0.nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 123);
        n.treeNode = false;
    }
    this$static.poID = initUnidimensionalArray(I_classLit, $intern_48, 30, numNodes, 15, 1);
    this$static.lowestPoID = initUnidimensionalArray(I_classLit, $intern_48, 30, numNodes, 15, 1);
    this$static.sources = new ArrayList;
    index_0 = 0;
    theEdges = new ArrayList;
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        node.internalId = index_0++;
        node.incomingEdges.list.array.length == 0 && $add_3(this$static.sources, node);
        $addAll_2(theEdges, node.outgoingEdges);
    }
    counter = 0;
    for(edge$iterator = new ArrayList$1(theEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        edge.internalId = counter++;
        edge.treeEdge = false;
    }
    numEdges = theEdges.array.length;
    if (this$static.cutvalue == null || this$static.cutvalue.length < numEdges) {
        this$static.cutvalue = initUnidimensionalArray(D_classLit, $intern_66, 30, numEdges, 15, 1);
        this$static.edgeVisited = initUnidimensionalArray(Z_classLit, $intern_90, 30, numEdges, 16, 1);
    } else fill_2(this$static.edgeVisited);
    this$static.edges = theEdges;
    this$static.treeEdges = new LinkedHashSet_0(capacity_0(this$static.edges.array.length));
    this$static.postOrder = 1;
}
function $isInHead(this$static, node, edge) {
    var source, target;
    source = edge.source;
    target = edge.target;
    if (this$static.lowestPoID[source.internalId] <= this$static.poID[node.internalId] && this$static.poID[node.internalId] <= this$static.poID[source.internalId] && this$static.lowestPoID[target.internalId] <= this$static.poID[node.internalId] && this$static.poID[node.internalId] <= this$static.poID[target.internalId]) {
        if (this$static.poID[source.internalId] < this$static.poID[target.internalId]) return false;
        return true;
    }
    if (this$static.poID[source.internalId] < this$static.poID[target.internalId]) return true;
    return false;
}
function $layeringTopologicalNumbering(this$static, initialRootNodes) {
    var edge, edge$iterator, incident, node, node$iterator, roots, target;
    incident = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.graph_0.nodes.array.length, 15, 1);
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        incident[node.internalId] += node.incomingEdges.list.array.length;
    }
    roots = newLinkedList(initialRootNodes);
    while(roots.size_0 != 0){
        node = castTo(roots.size_0 == 0 ? null : (checkCriticalElement(roots.size_0 != 0), $removeNode_0(roots, roots.header.next_0)), 123);
        for(edge$iterator = unmodifiableIterator(new ArrayList$1(node.outgoingEdges.list)); edge$iterator.hasNext_0();){
            edge = castTo(edge$iterator.next_1(), 216);
            target = edge.target;
            target.layer = $wnd.Math.max(target.layer, node.layer + edge.delta);
            --incident[target.internalId];
            incident[target.internalId] == 0 && $addNode_0(roots, target, roots.tail.prev, roots.tail);
        }
    }
}
function $leaveEdge(this$static) {
    var edge, edge$iterator;
    for(edge$iterator = this$static.treeEdges.map_0.keySet_0().iterator_0(); edge$iterator.hasNext_0();){
        edge = castTo(edge$iterator.next_1(), 216);
        if (edge.treeEdge && this$static.cutvalue[edge.internalId] < -0.0000000001) return edge;
    }
    return null;
}
function $minimalSlack(this$static) {
    var curSlack, edge, edge$iterator, minSlack, minSlackEdge;
    minSlack = $intern_0;
    minSlackEdge = null;
    for(edge$iterator = new ArrayList$1(this$static.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        if (edge.source.treeNode ^ edge.target.treeNode) {
            curSlack = edge.target.layer - edge.source.layer - edge.delta;
            if (curSlack < minSlack) {
                minSlack = curSlack;
                minSlackEdge = edge;
            }
        }
    }
    return minSlackEdge;
}
function $minimalSpan(node) {
    var currentSpan, edge, edge$iterator, minSpanIn, minSpanOut;
    minSpanOut = $intern_0;
    minSpanIn = $intern_0;
    for(edge$iterator = new ArrayList$1($getConnectedEdges(node)); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        currentSpan = edge.target.layer - edge.source.layer;
        edge.target == node && currentSpan < minSpanIn ? minSpanIn = currentSpan : currentSpan < minSpanOut && (minSpanOut = currentSpan);
    }
    minSpanIn == $intern_0 && (minSpanIn = -1);
    minSpanOut == $intern_0 && (minSpanOut = -1);
    return new Pair(valueOf_3(minSpanIn), valueOf_3(minSpanOut));
}
function $normalize(this$static) {
    var filling, highest, layerID, lowest, node, node$iterator, node$iterator0, nodeCntInLayer, nodeCntInLayer$array, nodeCntInLayer$index, nodeCntInLayer$max;
    highest = $intern_42;
    lowest = $intern_0;
    for(node$iterator0 = new ArrayList$1(this$static.graph_0.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 123);
        lowest = $wnd.Math.min(lowest, node.layer);
        highest = $wnd.Math.max(highest, node.layer);
    }
    filling = initUnidimensionalArray(I_classLit, $intern_48, 30, highest - lowest + 1, 15, 1);
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        node.layer -= lowest;
        ++filling[node.layer];
    }
    layerID = 0;
    if (this$static.previousLayeringNodeCounts != null) for(nodeCntInLayer$array = this$static.previousLayeringNodeCounts, nodeCntInLayer$index = 0, nodeCntInLayer$max = nodeCntInLayer$array.length; nodeCntInLayer$index < nodeCntInLayer$max; ++nodeCntInLayer$index){
        nodeCntInLayer = nodeCntInLayer$array[nodeCntInLayer$index];
        filling[layerID++] += nodeCntInLayer;
        if (filling.length == layerID) break;
    }
    return filling;
}
function $postorderTraversal(this$static, node) {
    var edge, edge$iterator, lowest;
    lowest = $intern_0;
    for(edge$iterator = new ArrayList$1($getConnectedEdges(node)); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        if (edge.treeEdge && !this$static.edgeVisited[edge.internalId]) {
            this$static.edgeVisited[edge.internalId] = true;
            lowest = $wnd.Math.min(lowest, $postorderTraversal(this$static, $getOther(edge, node)));
        }
    }
    this$static.poID[node.internalId] = this$static.postOrder;
    this$static.lowestPoID[node.internalId] = $wnd.Math.min(lowest, this$static.postOrder++);
    return this$static.lowestPoID[node.internalId];
}
function $reattachSubtrees(this$static) {
    var edge, leafy, node, placed;
    while(!$isEmpty(this$static.subtreeNodesStack)){
        leafy = castTo($removeFirst(this$static.subtreeNodesStack), 47);
        node = castTo(leafy.first, 123);
        edge = castTo(leafy.second, 216);
        placed = $getOther(edge, node);
        if (edge.target == node) {
            $add_11(placed.outgoingEdges, edge);
            node.layer = placed.layer + edge.delta;
        } else {
            $add_11(placed.incomingEdges, edge);
            node.layer = placed.layer - edge.delta;
        }
        $add_3(this$static.graph_0.nodes, node);
    }
}
function $removeSubtrees(this$static) {
    var edge, isOutEdge, leafs, leafy, node, node$iterator, other;
    this$static.subtreeNodesStack = new ArrayDeque;
    leafs = new LinkedList;
    for(node$iterator = new ArrayList$1(this$static.graph_0.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 123);
        $getConnectedEdges(node).array.length == 1 && $addNode_0(leafs, node, leafs.tail.prev, leafs.tail);
    }
    while(leafs.size_0 != 0){
        node = castTo(leafs.size_0 == 0 ? null : (checkCriticalElement(leafs.size_0 != 0), $removeNode_0(leafs, leafs.header.next_0)), 123);
        if ($getConnectedEdges(node).array.length == 0) continue;
        edge = castTo($get_11($getConnectedEdges(node), 0), 216);
        isOutEdge = node.outgoingEdges.list.array.length > 0;
        other = $getOther(edge, node);
        isOutEdge ? $remove_29(other.incomingEdges, edge) : $remove_29(other.outgoingEdges, edge);
        $getConnectedEdges(other).array.length == 1 && $addNode_0(leafs, other, leafs.tail.prev, leafs.tail);
        leafy = new Pair(node, edge);
        $addFirst(this$static.subtreeNodesStack, leafy);
        $remove_12(this$static.graph_0.nodes, node);
    }
}
function $tightTreeDFS(this$static, node) {
    var edge, edge$iterator, nodeCount, opposite;
    nodeCount = 1;
    node.treeNode = true;
    opposite = null;
    for(edge$iterator = new ArrayList$1($getConnectedEdges(node)); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 216);
        if (!this$static.edgeVisited[edge.internalId]) {
            this$static.edgeVisited[edge.internalId] = true;
            opposite = $getOther(edge, node);
            if (edge.treeEdge) nodeCount += $tightTreeDFS(this$static, opposite);
            else if (!opposite.treeNode && edge.delta == edge.target.layer - edge.source.layer) {
                edge.treeEdge = true;
                $add_6(this$static.treeEdges, edge);
                nodeCount += $tightTreeDFS(this$static, opposite);
            }
        }
    }
    return nodeCount;
}
function $withBalancing(this$static, doBalance) {
    this$static.balance = doBalance;
    return this$static;
}
function $withIterationLimit(this$static, limit) {
    this$static.iterationLimit = limit;
    return this$static;
}
function $withPreviousLayering(this$static, considerPreviousLayering) {
    this$static.previousLayeringNodeCounts = considerPreviousLayering;
    return this$static;
}
function NetworkSimplex() {}
function forGraph(graph) {
    var ns;
    ns = new NetworkSimplex;
    ns.graph_0 = graph;
    return ns;
}
defineClass(1636, 1, {}, NetworkSimplex);
_.balance = false;
_.iterationLimit = $intern_0;
_.postOrder = 0;
var Lorg_eclipse_elk_alg_common_networksimplex_NetworkSimplex_2_classLit = createForClass('org.eclipse.elk.alg.common.networksimplex', 'NetworkSimplex', 1636);
function calculateLabelAndNodeSizes(adapter) {
    $forEach_1(adapter.getNodes(), new NodeLabelAndSizeCalculator$lambda$0$Type(adapter));
}
function sortPortLists(adapter) {
    var node, node$iterator;
    for(node$iterator = new ArrayList$1($getNodes(adapter)); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 680);
        node.sortPortList();
    }
}
function computeInsideNodeLabelPadding(node, layoutDirection) {
    var col, col$array, col$array0, col$index, col$index0, col$max, col$max0, labelCell, labelCellContainer, nodeContext, padding, row, row$array, row$array0, row$index, row$index0, row$max, row$max0;
    nodeContext = new NodeContext(node);
    createNodeLabelCells(nodeContext, !(layoutDirection == ($clinit_Direction(), UP_1) || layoutDirection == DOWN_1));
    labelCellContainer = nodeContext.insideNodeLabelContainer;
    padding = new ElkPadding;
    for(col$array0 = ($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ])), col$index0 = 0, col$max0 = col$array0.length; col$index0 < col$max0; ++col$index0){
        col = col$array0[col$index0];
        labelCell = $getCell(labelCellContainer, BEGIN, col);
        !!labelCell && (padding.top_0 = $wnd.Math.max(padding.top_0, labelCell.getMinimumHeight()));
    }
    for(col$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ]), col$index = 0, col$max = col$array.length; col$index < col$max; ++col$index){
        col = col$array[col$index];
        labelCell = $getCell(labelCellContainer, END, col);
        !!labelCell && (padding.bottom = $wnd.Math.max(padding.bottom, labelCell.getMinimumHeight()));
    }
    for(row$array0 = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ]), row$index0 = 0, row$max0 = row$array0.length; row$index0 < row$max0; ++row$index0){
        row = row$array0[row$index0];
        labelCell = $getCell(labelCellContainer, row, BEGIN);
        !!labelCell && (padding.left = $wnd.Math.max(padding.left, labelCell.getMinimumWidth()));
    }
    for(row$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ]), row$index = 0, row$max = row$array.length; row$index < row$max; ++row$index){
        row = row$array[row$index];
        labelCell = $getCell(labelCellContainer, row, END);
        !!labelCell && (padding.right = $wnd.Math.max(padding.right, labelCell.getMinimumWidth()));
    }
    if (padding.top_0 > 0) {
        padding.top_0 += labelCellContainer.padding.top_0;
        padding.top_0 += labelCellContainer.gap;
    }
    if (padding.bottom > 0) {
        padding.bottom += labelCellContainer.padding.bottom;
        padding.bottom += labelCellContainer.gap;
    }
    if (padding.left > 0) {
        padding.left += labelCellContainer.padding.left;
        padding.left += labelCellContainer.gap;
    }
    if (padding.right > 0) {
        padding.right += labelCellContainer.padding.right;
        padding.right += labelCellContainer.gap;
    }
    return padding;
}
function process(graph, node, applyStuff, ignoreInsidePortLabels) {
    var horizontalLayoutMode, layoutDirection, minSize, nodeContext, outerNodeLabelsOverhang;
    nodeContext = new NodeContext(node);
    createPortContexts(nodeContext, ignoreInsidePortLabels);
    horizontalLayoutMode = true;
    if (!!graph && graph.hasProperty(($clinit_CoreOptions(), DIRECTION_1))) {
        layoutDirection = castTo(graph.getProperty(($clinit_CoreOptions(), DIRECTION_1)), 86);
        horizontalLayoutMode = layoutDirection == ($clinit_Direction(), UNDEFINED_2) || layoutDirection == LEFT_6 || layoutDirection == RIGHT_6;
    }
    createNodeLabelCellContainers(nodeContext, false);
    $forEach_1(nodeContext.node.getLabels(), new NodeLabelCellCreator$lambda$0$Type(nodeContext, false, horizontalLayoutMode));
    createInsidePortLabelCell(nodeContext, nodeContext.nodeContainer, ($clinit_ContainerArea(), BEGIN), ($clinit_PortSide(), NORTH_1));
    createInsidePortLabelCell(nodeContext, nodeContext.nodeContainer, END, SOUTH_0);
    createInsidePortLabelCell(nodeContext, nodeContext.nodeContainerMiddleRow, BEGIN, WEST_0);
    createInsidePortLabelCell(nodeContext, nodeContext.nodeContainerMiddleRow, END, EAST_0);
    setupNorthOrSouthPortLabelCell(nodeContext, NORTH_1);
    setupNorthOrSouthPortLabelCell(nodeContext, SOUTH_0);
    setupEastOrWestPortLabelCell(nodeContext, EAST_0);
    setupEastOrWestPortLabelCell(nodeContext, WEST_0);
    $clinit_NodeLabelAndSizeUtilities();
    minSize = nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), MINIMUM_SIZE)) && nodeContext.sizeOptions.contains(($clinit_SizeOptions(), MINIMUM_SIZE_ACCOUNTS_FOR_PADDING)) ? getMinimumNodeOrClientAreaSize(nodeContext) : null;
    !!minSize && $setCenterCellMinimumSize(nodeContext.insideNodeLabelContainer, minSize);
    setupNodePaddingForPortsWithOffset(nodeContext);
    calculateHorizontalPortPlacementSize(nodeContext);
    calculateVerticalPortPlacementSize(nodeContext);
    configureCellSystemSizeContributions(nodeContext);
    setNodeWidth(nodeContext);
    placeHorizontalPorts(nodeContext);
    placePortLabels(nodeContext, NORTH_1);
    placePortLabels(nodeContext, SOUTH_0);
    updateVerticalInsidePortLabelCellPadding(nodeContext);
    setNodeHeight(nodeContext);
    if (!applyStuff) return nodeContext.nodeSize;
    offsetSouthernPortsByNodeSize(nodeContext);
    placeVerticalPorts(nodeContext);
    placePortLabels(nodeContext, EAST_0);
    placePortLabels(nodeContext, WEST_0);
    outerNodeLabelsOverhang = nodeContext.sizeOptions.contains(($clinit_SizeOptions(), OUTSIDE_NODE_LABELS_OVERHANG));
    placeHorizontalOuterNodeLabelContainer(nodeContext, outerNodeLabelsOverhang, NORTH_1);
    placeHorizontalOuterNodeLabelContainer(nodeContext, outerNodeLabelsOverhang, SOUTH_0);
    placeVerticalOuterNodeLabelContainer(nodeContext, outerNodeLabelsOverhang, EAST_0);
    placeVerticalOuterNodeLabelContainer(nodeContext, outerNodeLabelsOverhang, WEST_0);
    $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(new AbstractMap$2(nodeContext.nodeLabelCells), 0)), new LabelPlacer$lambda$0$Type);
    $forEach_3($filter(new StreamImpl(null, $values_0(nodeContext.portContexts).this$01.valueSpliterator()), new LabelPlacer$lambda$1$Type), new LabelPlacer$lambda$2$Type);
    setNodePadding(nodeContext);
    nodeContext.node.setSize(nodeContext.nodeSize);
    $forEach_3(new StreamImpl(null, $values_0(nodeContext.portContexts).this$01.valueSpliterator()), new NodeLabelAndSizeUtilities$lambda$0$Type);
    return nodeContext.nodeSize;
}
function NodeLabelAndSizeCalculator$lambda$0$Type(graph_0) {
    this.graph_0 = graph_0;
}
defineClass(1267, 1, $intern_19, NodeLabelAndSizeCalculator$lambda$0$Type);
_.accept = function accept_43(arg0) {
    process(this.graph_0, castTo(arg0, 680), true, false);
};
var Lorg_eclipse_elk_alg_common_nodespacing_NodeLabelAndSizeCalculator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing', 'NodeLabelAndSizeCalculator/lambda$0$Type', 1267);
function $computeLabelBox(labelBox, label_0, incomingEdge, node, port, portLabelSpace, labelSpacing) {
    labelBox.x_0 = node.getPosition().x_0;
    labelBox.y_0 = node.getPosition().y_0;
    if (port) {
        labelBox.x_0 += port.getPosition().x_0;
        labelBox.y_0 += port.getPosition().y_0;
    }
    labelBox.width_0 = label_0.getSize().x_0;
    labelBox.height = label_0.getSize().y_0;
    if (!port) incomingEdge ? labelBox.x_0 -= labelSpacing + label_0.getSize().x_0 : labelBox.x_0 += node.getSize().x_0 + labelSpacing;
    else switch(port.getSide().ordinal){
        case 0:
        case 2:
            labelBox.x_0 += port.getSize().x_0 + labelSpacing + portLabelSpace.x_0 + labelSpacing;
            break;
        case 4:
            labelBox.x_0 -= labelSpacing + portLabelSpace.x_0 + labelSpacing + label_0.getSize().x_0;
            break;
        case 1:
            labelBox.x_0 += port.getSize().x_0 + labelSpacing;
            labelBox.y_0 -= labelSpacing + portLabelSpace.y_0 + labelSpacing + label_0.getSize().y_0;
            break;
        case 3:
            labelBox.x_0 += port.getSize().x_0 + labelSpacing;
            labelBox.y_0 += port.getSize().y_0 + labelSpacing + portLabelSpace.y_0 + labelSpacing;
    }
}
function $excludeEdgeHeadTailLabels(this$static) {
    this$static.includeEdgeHeadTailLabels = false;
    return this$static;
}
function $process(this$static) {
    var node, node$iterator, spacing;
    spacing = $doubleValue(castToDouble(this$static.adapter.getProperty(($clinit_CoreOptions(), SPACING_LABEL_NODE_0))));
    for(node$iterator = new ArrayList$1(this$static.adapter.getNodes()); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 680);
        $processNode_0(this$static, node, spacing);
    }
}
function $processEdgeHeadTailLabels(boundingBox, outgoingEdges, incomingEdges, node, port, portLabelSpace, labelSpacing) {
    var edge, edge$iterator, edge$iterator0, label_0, label$iterator, labelBox;
    labelBox = new ElkRectangle;
    for(edge$iterator0 = outgoingEdges.iterator_0(); edge$iterator0.hasNext_0();){
        edge = castTo(edge$iterator0.next_1(), 832);
        for(label$iterator = new ArrayList$1(edge.getLabels()); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 187);
            if (maskUndefined(label_0.getProperty(($clinit_CoreOptions(), EDGE_LABELS_PLACEMENT_0))) === maskUndefined(($clinit_EdgeLabelPlacement(), TAIL))) {
                $computeLabelBox(labelBox, label_0, false, node, port, portLabelSpace, labelSpacing);
                $union(boundingBox, labelBox);
            }
        }
    }
    for(edge$iterator = incomingEdges.iterator_0(); edge$iterator.hasNext_0();){
        edge = castTo(edge$iterator.next_1(), 832);
        for(label$iterator = new ArrayList$1(edge.getLabels()); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 187);
            if (maskUndefined(label_0.getProperty(($clinit_CoreOptions(), EDGE_LABELS_PLACEMENT_0))) === maskUndefined(($clinit_EdgeLabelPlacement(), HEAD))) {
                $computeLabelBox(labelBox, label_0, true, node, port, portLabelSpace, labelSpacing);
                $union(boundingBox, labelBox);
            }
        }
    }
}
function $processNode(this$static, node) {
    var spacing;
    spacing = $doubleValue(castToDouble(this$static.adapter.getProperty(($clinit_CoreOptions(), SPACING_LABEL_NODE_0))));
    $processNode_0(this$static, node, spacing);
}
function $processNode_0(this$static, node, labelSpacing) {
    var boundingBox, elementBox, label_0, label$iterator, margin, port, port$iterator, portX, portY, requiredPortLabelSpace;
    boundingBox = new ElkRectangle_0(node.getPosition().x_0, node.getPosition().y_0, node.getSize().x_0, node.getSize().y_0);
    elementBox = new ElkRectangle;
    if (this$static.includeLabels) for(label$iterator = new ArrayList$1(node.getLabels()); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 187);
        elementBox.x_0 = label_0.getPosition().x_0 + node.getPosition().x_0;
        elementBox.y_0 = label_0.getPosition().y_0 + node.getPosition().y_0;
        elementBox.width_0 = label_0.getSize().x_0;
        elementBox.height = label_0.getSize().y_0;
        $union(boundingBox, elementBox);
    }
    for(port$iterator = new ArrayList$1(node.getPorts()); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 831);
        portX = port.getPosition().x_0 + node.getPosition().x_0;
        portY = port.getPosition().y_0 + node.getPosition().y_0;
        if (this$static.includePorts) {
            elementBox.x_0 = portX;
            elementBox.y_0 = portY;
            elementBox.width_0 = port.getSize().x_0;
            elementBox.height = port.getSize().y_0;
            $union(boundingBox, elementBox);
        }
        if (this$static.includePortLabels) for(label$iterator = new ArrayList$1(port.getLabels()); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 187);
            elementBox.x_0 = label_0.getPosition().x_0 + portX;
            elementBox.y_0 = label_0.getPosition().y_0 + portY;
            elementBox.width_0 = label_0.getSize().x_0;
            elementBox.height = label_0.getSize().y_0;
            $union(boundingBox, elementBox);
        }
        if (this$static.includeEdgeHeadTailLabels) {
            requiredPortLabelSpace = new KVector_1(-labelSpacing, -labelSpacing);
            if (castTo(node.getProperty(($clinit_CoreOptions(), PORT_LABELS_PLACEMENT_5)), 181).contains(($clinit_PortLabelPlacement(), OUTSIDE_0))) for(label$iterator = new ArrayList$1(port.getLabels()); label$iterator.i < label$iterator.this$01.array.length;){
                label_0 = castTo($next_6(label$iterator), 187);
                requiredPortLabelSpace.x_0 += label_0.getSize().x_0 + labelSpacing;
                requiredPortLabelSpace.y_0 += label_0.getSize().y_0 + labelSpacing;
            }
            requiredPortLabelSpace.x_0 = $wnd.Math.max(requiredPortLabelSpace.x_0, 0);
            requiredPortLabelSpace.y_0 = $wnd.Math.max(requiredPortLabelSpace.y_0, 0);
            $processEdgeHeadTailLabels(boundingBox, port.getOutgoingEdges(), port.getIncomingEdges(), node, port, requiredPortLabelSpace, labelSpacing);
        }
    }
    this$static.includeEdgeHeadTailLabels && $processEdgeHeadTailLabels(boundingBox, node.getOutgoingEdges(), node.getIncomingEdges(), node, null, null, labelSpacing);
    margin = new ElkMargin_2(node.getMargin());
    margin.top_0 = $wnd.Math.max(0, node.getPosition().y_0 - boundingBox.y_0);
    margin.bottom = $wnd.Math.max(0, boundingBox.y_0 + boundingBox.height - (node.getPosition().y_0 + node.getSize().y_0));
    margin.left = $wnd.Math.max(0, node.getPosition().x_0 - boundingBox.x_0);
    margin.right = $wnd.Math.max(0, boundingBox.x_0 + boundingBox.width_0 - (node.getPosition().x_0 + node.getSize().x_0));
    node.setMargin(margin);
}
function NodeMarginCalculator(adapter) {
    this.adapter = adapter;
}
defineClass(550, 1, {}, NodeMarginCalculator);
_.includeEdgeHeadTailLabels = true;
_.includeLabels = true;
_.includePortLabels = true;
_.includePorts = true;
var Lorg_eclipse_elk_alg_common_nodespacing_NodeMarginCalculator_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing', 'NodeMarginCalculator', 550);
function $setContributesToMinimumHeight(this$static, contributesToMinimumHeight) {
    this$static.contributesToMinimumHeight = contributesToMinimumHeight;
}
function Cell() {
    this.padding = new ElkPadding;
    this.cellRectangle = new ElkRectangle;
}
defineClass(215, 1, {
    215: 1
});
_.contributesToMinimumHeight = false;
_.contributesToMinimumWidth = false;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_Cell_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'Cell', 215);
function $getMinimumHeight(this$static) {
    var padding;
    padding = this$static.padding;
    return this$static.minimumContentAreaSize.y_0 + padding.top_0 + padding.bottom;
}
function AtomicCell() {
    Cell.call(this);
    this.minimumContentAreaSize = new KVector;
}
defineClass(126, 215, {
    126: 1,
    215: 1
}, AtomicCell);
_.getMinimumHeight = function getMinimumHeight() {
    return $getMinimumHeight(this);
};
_.getMinimumWidth = function getMinimumWidth() {
    var padding;
    padding = this.padding;
    return this.minimumContentAreaSize.x_0 + padding.left + padding.right;
};
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_AtomicCell_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'AtomicCell', 126);
function $clinit_ContainerArea() {
    $clinit_ContainerArea = emptyMethod;
    BEGIN = new ContainerArea('BEGIN', 0);
    CENTER = new ContainerArea('CENTER', 1);
    END = new ContainerArea('END', 2);
}
function ContainerArea(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_12(name_0) {
    $clinit_ContainerArea();
    return valueOf(($clinit_ContainerArea$Map(), $MAP_2), name_0);
}
function values_20() {
    $clinit_ContainerArea();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ]);
}
defineClass(236, 23, {
    3: 1,
    34: 1,
    23: 1,
    236: 1
}, ContainerArea);
var BEGIN, CENTER, END;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit = createForEnum('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'ContainerArea', 236, Ljava_lang_Enum_2_classLit, values_20, valueOf_12);
function $clinit_ContainerArea$Map() {
    $clinit_ContainerArea$Map = emptyMethod;
    $MAP_2 = createValueOfMap(($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ])));
}
var $MAP_2;
function $applyHorizontalLayout(cell, x_0, width_0) {
    var cellRect;
    if (cell) {
        cellRect = cell.cellRectangle;
        cellRect.x_0 = x_0;
        cellRect.width_0 = width_0;
    }
}
function $applyVerticalLayout(cell, y_0, height) {
    var cellRect;
    if (cell) {
        cellRect = cell.cellRectangle;
        cellRect.y_0 = y_0;
        cellRect.height = height;
    }
}
function ContainerCell() {
    Cell.call(this);
}
function minHeightOfCell(cell, respectContributionFlag) {
    if (!cell) return 0;
    if (respectContributionFlag && !cell.contributesToMinimumHeight) return 0;
    if (instanceOf(cell, 126)) {
        if (castTo(cell, 126).minimumContentAreaSize.y_0 == 0) return 0;
    }
    return cell.getMinimumHeight();
}
function minWidthOfCell(cell, respectContributionFlag) {
    if (!cell) return 0;
    if (respectContributionFlag && !cell.contributesToMinimumWidth) return 0;
    if (instanceOf(cell, 126)) {
        if (castTo(cell, 126).minimumContentAreaSize.x_0 == 0) return 0;
    }
    return cell.getMinimumWidth();
}
defineClass(332, 215, $intern_91);
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerCell_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'ContainerCell', 332);
function $clinit_GridContainerCell() {
    $clinit_GridContainerCell = emptyMethod;
    ROWS = ($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ])).length;
    COLUMNS = ROWS;
}
function $applyHeightToRow(this$static, row, y_0, rowHeights) {
    var column;
    for(column = 0; column < COLUMNS; column++)$applyVerticalLayout(this$static.cells_0[row.ordinal][column], y_0, rowHeights[row.ordinal]);
}
function $applyWidthToColumn(this$static, column, x_0, colWidths) {
    var row;
    for(row = 0; row < ROWS; row++)$applyHorizontalLayout(this$static.cells_0[row][column.ordinal], x_0, colWidths[column.ordinal]);
}
function $applyWidthsToRow(this$static, row, colWidths) {
    var cellPadding, cellRectangle, centerWidth, freeContentAreaWidth;
    cellRectangle = this$static.cellRectangle;
    cellPadding = this$static.padding;
    $applyWidthToColumn(this$static, ($clinit_ContainerArea(), BEGIN), cellRectangle.x_0 + cellPadding.left, colWidths);
    $applyWidthToColumn(this$static, END, cellRectangle.x_0 + cellRectangle.width_0 - cellPadding.right - colWidths[2], colWidths);
    freeContentAreaWidth = cellRectangle.width_0 - cellPadding.left - cellPadding.right;
    if (colWidths[0] > 0) {
        colWidths[0] += this$static.gap;
        freeContentAreaWidth -= colWidths[0];
    }
    if (colWidths[2] > 0) {
        colWidths[2] += this$static.gap;
        freeContentAreaWidth -= colWidths[2];
    }
    centerWidth = $wnd.Math.max(0, freeContentAreaWidth);
    colWidths[1] = $wnd.Math.max(colWidths[1], freeContentAreaWidth);
    $applyWidthToColumn(this$static, CENTER, cellRectangle.x_0 + cellPadding.left + colWidths[0] - (colWidths[1] - freeContentAreaWidth) / 2, colWidths);
    if (row == CENTER) {
        this$static.centerCellRect.width_0 = centerWidth;
        this$static.centerCellRect.x_0 = cellRectangle.x_0 + cellPadding.left + (centerWidth - freeContentAreaWidth) / 2;
    }
}
function $getCell(this$static, row, col) {
    return this$static.cells_0[row.ordinal][col.ordinal];
}
function $minColumnWidths(this$static, row, respectContributionFlag) {
    var colWidths;
    colWidths = stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        $minWidthOfColumn(this$static, ($clinit_ContainerArea(), BEGIN), row, respectContributionFlag),
        $minWidthOfColumn(this$static, CENTER, row, respectContributionFlag),
        $minWidthOfColumn(this$static, END, row, respectContributionFlag)
    ]);
    if (this$static.symmetrical) {
        colWidths[0] = $wnd.Math.max(colWidths[0], colWidths[2]);
        colWidths[2] = colWidths[0];
    }
    return colWidths;
}
function $minHeightOfRow(this$static, row, respectContributionFlag) {
    var column, maxMinHeight;
    maxMinHeight = 0;
    for(column = 0; column < COLUMNS; column++)maxMinHeight = $wnd.Math.max(maxMinHeight, minHeightOfCell(this$static.cells_0[row.ordinal][column], respectContributionFlag));
    row == ($clinit_ContainerArea(), CENTER) && !!this$static.centerCellMinimumSize && (maxMinHeight = $wnd.Math.max(maxMinHeight, this$static.centerCellMinimumSize.y_0));
    return maxMinHeight;
}
function $minRowHeights(this$static, respectContributionFlag) {
    var rowHeights;
    rowHeights = stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        $minHeightOfRow(this$static, ($clinit_ContainerArea(), BEGIN), respectContributionFlag),
        $minHeightOfRow(this$static, CENTER, respectContributionFlag),
        $minHeightOfRow(this$static, END, respectContributionFlag)
    ]);
    if (this$static.symmetrical) {
        rowHeights[0] = $wnd.Math.max(rowHeights[0], rowHeights[2]);
        rowHeights[2] = rowHeights[0];
    }
    return rowHeights;
}
function $minWidthOfColumn(this$static, column, row, respectContributionFlag) {
    var maxMinWidth, rowIndex;
    maxMinWidth = 0;
    if (!row) for(rowIndex = 0; rowIndex < ROWS; rowIndex++)maxMinWidth = $wnd.Math.max(maxMinWidth, minWidthOfCell(this$static.cells_0[rowIndex][column.ordinal], respectContributionFlag));
    else maxMinWidth = minWidthOfCell(this$static.cells_0[row.ordinal][column.ordinal], respectContributionFlag);
    column == ($clinit_ContainerArea(), CENTER) && !!this$static.centerCellMinimumSize && (maxMinWidth = $wnd.Math.max(maxMinWidth, this$static.centerCellMinimumSize.x_0));
    return maxMinWidth;
}
function $setCell(this$static, row, col, cell) {
    setCheck(this$static.cells_0[row.ordinal], col.ordinal, cell);
}
function $setCenterCellMinimumSize(this$static, minimumSize) {
    this$static.centerCellMinimumSize = new KVector_2(minimumSize);
}
function $sumWithGaps(this$static, values) {
    var activeComponents, sum, val, val$array, val$index, val$max;
    sum = 0;
    activeComponents = 0;
    for(val$array = values, val$index = 0, val$max = val$array.length; val$index < val$max; ++val$index){
        val = val$array[val$index];
        if (val > 0) {
            sum += val;
            ++activeComponents;
        }
    }
    activeComponents > 1 && (sum += this$static.gap * (activeComponents - 1));
    return sum;
}
function GridContainerCell(tabular, symmetrical, gap) {
    $clinit_GridContainerCell();
    ContainerCell.call(this);
    this.cells_0 = initMultidimensionalArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_Cell_2_classLit, [
        $intern_16,
        $intern_92
    ], [
        587,
        215
    ], 0, [
        ROWS,
        COLUMNS
    ], 2);
    this.centerCellRect = new ElkRectangle;
    this.tabular = tabular;
    this.symmetrical = symmetrical;
    this.gap = gap;
}
defineClass(1478, 332, $intern_91, GridContainerCell);
_.getMinimumHeight = function getMinimumHeight_0() {
    var height;
    height = 0;
    this.onlyCenterCellContributesToMinimumSize ? this.centerCellMinimumSize ? height = this.centerCellMinimumSize.y_0 : !!this.cells_0[1][1] && (height = this.cells_0[1][1].getMinimumHeight()) : height = $sumWithGaps(this, $minRowHeights(this, true));
    return height > 0 ? height + this.padding.top_0 + this.padding.bottom : 0;
};
_.getMinimumWidth = function getMinimumWidth_0() {
    var area, area$array, area$index, area$max, width_0;
    width_0 = 0;
    if (this.onlyCenterCellContributesToMinimumSize) this.centerCellMinimumSize ? width_0 = this.centerCellMinimumSize.x_0 : !!this.cells_0[1][1] && (width_0 = this.cells_0[1][1].getMinimumWidth());
    else if (this.tabular) width_0 = $sumWithGaps(this, $minColumnWidths(this, null, true));
    else for(area$array = ($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ])), area$index = 0, area$max = area$array.length; area$index < area$max; ++area$index){
        area = area$array[area$index];
        width_0 = $wnd.Math.max(width_0, $sumWithGaps(this, $minColumnWidths(this, area, true)));
    }
    return width_0 > 0 ? width_0 + this.padding.left + this.padding.right : 0;
};
_.layoutChildrenHorizontally = function layoutChildrenHorizontally() {
    var colWidths, row, row$array, row$index, row$max;
    if (this.tabular) {
        colWidths = $minColumnWidths(this, null, false);
        for(row$array = ($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
            BEGIN,
            CENTER,
            END
        ])), row$index = 0, row$max = row$array.length; row$index < row$max; ++row$index){
            row = row$array[row$index];
            $applyWidthsToRow(this, row, colWidths);
        }
    } else for(row$array = ($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ])), row$index = 0, row$max = row$array.length; row$index < row$max; ++row$index){
        row = row$array[row$index];
        colWidths = $minColumnWidths(this, row, false);
        $applyWidthsToRow(this, row, colWidths);
    }
};
_.layoutChildrenVertically = function layoutChildrenVertically() {
    var cellPadding, cellRectangle, freeContentAreaHeight, rowHeights;
    cellRectangle = this.cellRectangle;
    cellPadding = this.padding;
    rowHeights = $minRowHeights(this, false);
    $applyHeightToRow(this, ($clinit_ContainerArea(), BEGIN), cellRectangle.y_0 + cellPadding.top_0, rowHeights);
    $applyHeightToRow(this, END, cellRectangle.y_0 + cellRectangle.height - cellPadding.bottom - rowHeights[2], rowHeights);
    freeContentAreaHeight = cellRectangle.height - cellPadding.top_0 - cellPadding.bottom;
    if (rowHeights[0] > 0) {
        rowHeights[0] += this.gap;
        freeContentAreaHeight -= rowHeights[0];
    }
    if (rowHeights[2] > 0) {
        rowHeights[2] += this.gap;
        freeContentAreaHeight -= rowHeights[2];
    }
    this.centerCellRect.height = $wnd.Math.max(0, freeContentAreaHeight);
    this.centerCellRect.y_0 = cellRectangle.y_0 + cellPadding.top_0 + (this.centerCellRect.height - freeContentAreaHeight) / 2;
    rowHeights[1] = $wnd.Math.max(rowHeights[1], freeContentAreaHeight);
    $applyHeightToRow(this, CENTER, cellRectangle.y_0 + cellPadding.top_0 + rowHeights[0] - (rowHeights[1] - freeContentAreaHeight) / 2, rowHeights);
};
_.centerCellMinimumSize = null;
_.gap = 0;
_.onlyCenterCellContributesToMinimumSize = false;
_.symmetrical = false;
_.tabular = false;
var COLUMNS = 0, ROWS = 0;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_GridContainerCell_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'GridContainerCell', 1478);
function $clinit_HorizontalLabelAlignment() {
    $clinit_HorizontalLabelAlignment = emptyMethod;
    LEFT = new HorizontalLabelAlignment('LEFT', 0);
    CENTER_0 = new HorizontalLabelAlignment('CENTER', 1);
    RIGHT = new HorizontalLabelAlignment('RIGHT', 2);
}
function HorizontalLabelAlignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_13(name_0) {
    $clinit_HorizontalLabelAlignment();
    return valueOf(($clinit_HorizontalLabelAlignment$Map(), $MAP_3), name_0);
}
function values_21() {
    $clinit_HorizontalLabelAlignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_HorizontalLabelAlignment_2_classLit, 1), $intern_36, 457, 0, [
        LEFT,
        CENTER_0,
        RIGHT
    ]);
}
defineClass(457, 23, {
    3: 1,
    34: 1,
    23: 1,
    457: 1
}, HorizontalLabelAlignment);
var CENTER_0, LEFT, RIGHT;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_HorizontalLabelAlignment_2_classLit = createForEnum('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'HorizontalLabelAlignment', 457, Ljava_lang_Enum_2_classLit, values_21, valueOf_13);
function $clinit_HorizontalLabelAlignment$Map() {
    $clinit_HorizontalLabelAlignment$Map = emptyMethod;
    $MAP_3 = createValueOfMap(($clinit_HorizontalLabelAlignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_HorizontalLabelAlignment_2_classLit, 1), $intern_36, 457, 0, [
        LEFT,
        CENTER_0,
        RIGHT
    ])));
}
var $MAP_3;
function $$init_4(this$static) {
    this$static.horizontalAlignment = ($clinit_HorizontalLabelAlignment(), CENTER_0);
    this$static.verticalAlignment = ($clinit_VerticalLabelAlignment(), CENTER_1);
    this$static.labels = (checkNonnegative(2, 'initialArraySize'), new ArrayList_0(2));
    this$static.minimumContentAreaSize = new KVector;
}
function $addLabel(this$static, label_0) {
    var labelSize;
    $add_3(this$static.labels, label_0);
    labelSize = label_0.getSize();
    if (this$static.horizontalLayoutMode) {
        this$static.minimumContentAreaSize.x_0 = $wnd.Math.max(this$static.minimumContentAreaSize.x_0, labelSize.x_0);
        this$static.minimumContentAreaSize.y_0 += labelSize.y_0;
        this$static.labels.array.length > 1 && (this$static.minimumContentAreaSize.y_0 += this$static.gap);
    } else {
        this$static.minimumContentAreaSize.x_0 += labelSize.x_0;
        this$static.minimumContentAreaSize.y_0 = $wnd.Math.max(this$static.minimumContentAreaSize.y_0, labelSize.y_0);
        this$static.labels.array.length > 1 && (this$static.minimumContentAreaSize.x_0 += this$static.gap);
    }
}
function $applyHorizontalModeLabelLayout(this$static) {
    var cellPadding, cellRect, label_0, label$iterator, labelPos, labelSize, yPos;
    cellRect = this$static.cellRectangle;
    cellPadding = this$static.padding;
    yPos = cellRect.y_0;
    this$static.verticalAlignment == ($clinit_VerticalLabelAlignment(), CENTER_1) ? yPos += (cellRect.height - this$static.minimumContentAreaSize.y_0) / 2 : this$static.verticalAlignment == BOTTOM && (yPos += cellRect.height - this$static.minimumContentAreaSize.y_0);
    for(label$iterator = new ArrayList$1(this$static.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 187);
        labelSize = label_0.getSize();
        labelPos = new KVector;
        labelPos.y_0 = yPos;
        yPos += labelSize.y_0 + this$static.gap;
        switch(this$static.horizontalAlignment.ordinal){
            case 0:
                labelPos.x_0 = cellRect.x_0 + cellPadding.left;
                break;
            case 1:
                labelPos.x_0 = cellRect.x_0 + cellPadding.left + (cellRect.width_0 - labelSize.x_0) / 2;
                break;
            case 2:
                labelPos.x_0 = cellRect.x_0 + cellRect.width_0 - cellPadding.right - labelSize.x_0;
        }
        label_0.setPosition(labelPos);
    }
}
function $applyLabelLayout(this$static) {
    this$static.horizontalLayoutMode ? $applyHorizontalModeLabelLayout(this$static) : $applyVerticalModeLabelLayout(this$static);
}
function $applyVerticalModeLabelLayout(this$static) {
    var cellPadding, cellRect, label_0, label$iterator, labelPos, labelSize, xPos;
    cellRect = this$static.cellRectangle;
    cellPadding = this$static.padding;
    xPos = cellRect.x_0;
    this$static.horizontalAlignment == ($clinit_HorizontalLabelAlignment(), CENTER_0) ? xPos += (cellRect.width_0 - this$static.minimumContentAreaSize.x_0) / 2 : this$static.horizontalAlignment == RIGHT && (xPos += cellRect.width_0 - this$static.minimumContentAreaSize.x_0);
    for(label$iterator = new ArrayList$1(this$static.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 187);
        labelSize = label_0.getSize();
        labelPos = new KVector;
        labelPos.x_0 = xPos;
        xPos += labelSize.x_0 + this$static.gap;
        switch(this$static.verticalAlignment.ordinal){
            case 0:
                labelPos.y_0 = cellRect.y_0 + cellPadding.top_0;
                break;
            case 1:
                labelPos.y_0 = cellRect.y_0 + cellPadding.top_0 + (cellRect.height - labelSize.y_0) / 2;
                break;
            case 2:
                labelPos.y_0 = cellRect.y_0 + cellRect.height - cellPadding.bottom - labelSize.y_0;
        }
        label_0.setPosition(labelPos);
    }
}
function $getMinimumHeight_0(this$static) {
    var padding;
    padding = this$static.padding;
    return this$static.minimumContentAreaSize.y_0 + padding.top_0 + padding.bottom;
}
function $getMinimumWidth(this$static) {
    var padding;
    padding = this$static.padding;
    return this$static.minimumContentAreaSize.x_0 + padding.left + padding.right;
}
function $setHorizontalAlignment(this$static, newHorizontalAlignment) {
    requireNonNull_0(newHorizontalAlignment, 'Horizontal alignment cannot be null');
    this$static.horizontalAlignment = newHorizontalAlignment;
    return this$static;
}
function $setVerticalAlignment(this$static, newVerticalAlignment) {
    requireNonNull_0(newVerticalAlignment, 'Vertical alignment cannot be null');
    this$static.verticalAlignment = newVerticalAlignment;
    return this$static;
}
function LabelCell(gap) {
    Cell.call(this);
    $$init_4(this);
    this.gap = gap;
    this.horizontalLayoutMode = true;
}
function LabelCell_0(gap, nodeLabelLocation, horizontalLayoutMode) {
    Cell.call(this);
    $$init_4(this);
    this.gap = gap;
    this.horizontalLayoutMode = horizontalLayoutMode;
    this.horizontalAlignment = nodeLabelLocation.horizontalAlignment;
    this.verticalAlignment = nodeLabelLocation.verticalAlignment;
}
function LabelCell_1(gap, horizontalLayoutMode) {
    Cell.call(this);
    $$init_4(this);
    this.gap = gap;
    this.horizontalLayoutMode = horizontalLayoutMode;
}
defineClass(315, 215, {
    215: 1,
    315: 1
}, LabelCell, LabelCell_0, LabelCell_1);
_.getMinimumHeight = function getMinimumHeight_1() {
    return $getMinimumHeight_0(this);
};
_.getMinimumWidth = function getMinimumWidth_1() {
    return $getMinimumWidth(this);
};
_.gap = 0;
_.horizontalLayoutMode = false;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_LabelCell_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'LabelCell', 315);
function $getMinimumHeight_1(this$static) {
    var activeCells, cellHeight, cellHeight$array, cellHeight$index, cellHeight$max, cellHeights, height;
    height = 0;
    if (this$static.containerMode == 0) {
        cellHeights = $minCellHeights(this$static, true);
        activeCells = 0;
        for(cellHeight$array = cellHeights, cellHeight$index = 0, cellHeight$max = cellHeight$array.length; cellHeight$index < cellHeight$max; ++cellHeight$index){
            cellHeight = cellHeight$array[cellHeight$index];
            if (cellHeight > 0) {
                height += cellHeight;
                ++activeCells;
            }
        }
        activeCells > 1 && (height += this$static.gap * (activeCells - 1));
    } else height = $orElse_0($max($mapToDouble($filter(stream_4(this$static.cells_0), new StripContainerCell$lambda$2$Type), new StripContainerCell$lambda$3$Type)));
    return height > 0 ? height + this$static.padding.top_0 + this$static.padding.bottom : 0;
}
function $getMinimumWidth_0(this$static) {
    var activeCells, cellWidth, cellWidth$array, cellWidth$index, cellWidth$max, cellWidths, width_0;
    width_0 = 0;
    if (this$static.containerMode == 0) width_0 = $orElse_0($max($mapToDouble($filter(stream_4(this$static.cells_0), new StripContainerCell$lambda$0$Type), new StripContainerCell$lambda$1$Type)));
    else {
        cellWidths = $minCellWidths(this$static, true);
        activeCells = 0;
        for(cellWidth$array = cellWidths, cellWidth$index = 0, cellWidth$max = cellWidth$array.length; cellWidth$index < cellWidth$max; ++cellWidth$index){
            cellWidth = cellWidth$array[cellWidth$index];
            if (cellWidth > 0) {
                width_0 += cellWidth;
                ++activeCells;
            }
        }
        activeCells > 1 && (width_0 += this$static.gap * (activeCells - 1));
    }
    return width_0 > 0 ? width_0 + this$static.padding.left + this$static.padding.right : 0;
}
function $layoutChildrenHorizontally(this$static) {
    var cellPadding, cellRectangle, cellWidths, childCell, childCell$array, childCell$array0, childCell$index, childCell$index0, childCell$max, childCell$max0, freeContentAreaWidth, width_0, xPos;
    cellRectangle = this$static.cellRectangle;
    cellPadding = this$static.padding;
    if (this$static.containerMode == 0) {
        xPos = cellRectangle.x_0 + cellPadding.left;
        width_0 = cellRectangle.width_0 - cellPadding.left - cellPadding.right;
        for(childCell$array0 = this$static.cells_0, childCell$index0 = 0, childCell$max0 = childCell$array0.length; childCell$index0 < childCell$max0; ++childCell$index0){
            childCell = childCell$array0[childCell$index0];
            $applyHorizontalLayout(childCell, xPos, width_0);
        }
    } else {
        cellWidths = $minCellWidths(this$static, false);
        $applyHorizontalLayout(this$static.cells_0[0], cellRectangle.x_0 + cellPadding.left, cellWidths[0]);
        $applyHorizontalLayout(this$static.cells_0[2], cellRectangle.x_0 + cellRectangle.width_0 - cellPadding.right - cellWidths[2], cellWidths[2]);
        freeContentAreaWidth = cellRectangle.width_0 - cellPadding.left - cellPadding.right;
        if (cellWidths[0] > 0) {
            freeContentAreaWidth -= cellWidths[0] + this$static.gap;
            cellWidths[0] += this$static.gap;
        }
        cellWidths[2] > 0 && (freeContentAreaWidth -= cellWidths[2] + this$static.gap);
        cellWidths[1] = $wnd.Math.max(cellWidths[1], freeContentAreaWidth);
        $applyHorizontalLayout(this$static.cells_0[1], cellRectangle.x_0 + cellPadding.left + cellWidths[0] - (cellWidths[1] - freeContentAreaWidth) / 2, cellWidths[1]);
    }
    for(childCell$array = this$static.cells_0, childCell$index = 0, childCell$max = childCell$array.length; childCell$index < childCell$max; ++childCell$index){
        childCell = childCell$array[childCell$index];
        instanceOf(childCell, 332) && castTo(childCell, 332).layoutChildrenHorizontally();
    }
}
function $layoutChildrenVertically(this$static) {
    var cellHeights, cellPadding, cellRectangle, childCell, childCell$array, childCell$array0, childCell$index, childCell$index0, childCell$max, childCell$max0, contentAreaFreeHeight, contentAreaHeight, height, yPos;
    cellRectangle = this$static.cellRectangle;
    cellPadding = this$static.padding;
    if (this$static.containerMode == 0) {
        cellHeights = $minCellHeights(this$static, false);
        $applyVerticalLayout(this$static.cells_0[0], cellRectangle.y_0 + cellPadding.top_0, cellHeights[0]);
        $applyVerticalLayout(this$static.cells_0[2], cellRectangle.y_0 + cellRectangle.height - cellPadding.bottom - cellHeights[2], cellHeights[2]);
        contentAreaHeight = cellRectangle.height - cellPadding.top_0 - cellPadding.bottom;
        contentAreaFreeHeight = contentAreaHeight;
        if (cellHeights[0] > 0) {
            cellHeights[0] += this$static.gap;
            contentAreaFreeHeight -= cellHeights[0];
        }
        cellHeights[2] > 0 && (contentAreaFreeHeight -= cellHeights[2] + this$static.gap);
        cellHeights[1] = $wnd.Math.max(cellHeights[1], contentAreaFreeHeight);
        $applyVerticalLayout(this$static.cells_0[1], cellRectangle.y_0 + cellPadding.top_0 + cellHeights[0] - (cellHeights[1] - contentAreaFreeHeight) / 2, cellHeights[1]);
    } else {
        yPos = cellRectangle.y_0 + cellPadding.top_0;
        height = cellRectangle.height - cellPadding.top_0 - cellPadding.bottom;
        for(childCell$array0 = this$static.cells_0, childCell$index0 = 0, childCell$max0 = childCell$array0.length; childCell$index0 < childCell$max0; ++childCell$index0){
            childCell = childCell$array0[childCell$index0];
            $applyVerticalLayout(childCell, yPos, height);
        }
    }
    for(childCell$array = this$static.cells_0, childCell$index = 0, childCell$max = childCell$array.length; childCell$index < childCell$max; ++childCell$index){
        childCell = childCell$array[childCell$index];
        instanceOf(childCell, 332) && castTo(childCell, 332).layoutChildrenVertically();
    }
}
function $minCellHeights(this$static, respectContributionFlag) {
    var cellHeights;
    cellHeights = stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        minHeightOfCell(this$static.cells_0[0], respectContributionFlag),
        minHeightOfCell(this$static.cells_0[1], respectContributionFlag),
        minHeightOfCell(this$static.cells_0[2], respectContributionFlag)
    ]);
    if (this$static.symmetrical) {
        cellHeights[0] = $wnd.Math.max(cellHeights[0], cellHeights[2]);
        cellHeights[2] = cellHeights[0];
    }
    return cellHeights;
}
function $minCellWidths(this$static, respectContributionFlag) {
    var cellWidths;
    cellWidths = stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        minWidthOfCell(this$static.cells_0[0], respectContributionFlag),
        minWidthOfCell(this$static.cells_0[1], respectContributionFlag),
        minWidthOfCell(this$static.cells_0[2], respectContributionFlag)
    ]);
    if (this$static.symmetrical) {
        cellWidths[0] = $wnd.Math.max(cellWidths[0], cellWidths[2]);
        cellWidths[2] = cellWidths[0];
    }
    return cellWidths;
}
function $setCell_0(this$static, area, cell) {
    this$static.cells_0[area.ordinal] = cell;
}
function StripContainerCell(mode, symmetrical, gap) {
    ContainerCell.call(this);
    this.cells_0 = initUnidimensionalArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_Cell_2_classLit, $intern_92, 215, ($clinit_ContainerArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_ContainerArea_2_classLit, 1), $intern_36, 236, 0, [
        BEGIN,
        CENTER,
        END
    ])).length, 0, 1);
    this.containerMode = mode;
    this.symmetrical = symmetrical;
    this.gap = gap;
}
function lambda$0_9(cell_0) {
    return !!cell_0 && cell_0.contributesToMinimumWidth;
}
function lambda$2(cell_0) {
    return !!cell_0 && cell_0.contributesToMinimumHeight;
}
defineClass(251, 332, {
    215: 1,
    332: 1,
    251: 1
}, StripContainerCell);
_.getMinimumHeight = function getMinimumHeight_2() {
    return $getMinimumHeight_1(this);
};
_.getMinimumWidth = function getMinimumWidth_2() {
    return $getMinimumWidth_0(this);
};
_.layoutChildrenHorizontally = function layoutChildrenHorizontally_0() {
    $layoutChildrenHorizontally(this);
};
_.layoutChildrenVertically = function layoutChildrenVertically_0() {
    $layoutChildrenVertically(this);
};
_.containerMode = 0;
_.gap = 0;
_.symmetrical = false;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_StripContainerCell_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'StripContainerCell', 251);
function StripContainerCell$lambda$0$Type() {}
defineClass(1632, 1, $intern_39, StripContainerCell$lambda$0$Type);
_.test_0 = function test_6(arg0) {
    return lambda$0_9(castTo(arg0, 215));
};
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_StripContainerCell$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'StripContainerCell/lambda$0$Type', 1632);
function StripContainerCell$lambda$1$Type() {}
defineClass(1633, 1, {}, StripContainerCell$lambda$1$Type);
_.applyAsDouble = function applyAsDouble(arg0) {
    return castTo(arg0, 215).getMinimumWidth();
};
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_StripContainerCell$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'StripContainerCell/lambda$1$Type', 1633);
function StripContainerCell$lambda$2$Type() {}
defineClass(1634, 1, $intern_39, StripContainerCell$lambda$2$Type);
_.test_0 = function test_7(arg0) {
    return lambda$2(castTo(arg0, 215));
};
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_StripContainerCell$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'StripContainerCell/lambda$2$Type', 1634);
function StripContainerCell$lambda$3$Type() {}
defineClass(1635, 1, {}, StripContainerCell$lambda$3$Type);
_.applyAsDouble = function applyAsDouble_0(arg0) {
    return castTo(arg0, 215).getMinimumHeight();
};
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_StripContainerCell$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'StripContainerCell/lambda$3$Type', 1635);
function $clinit_VerticalLabelAlignment() {
    $clinit_VerticalLabelAlignment = emptyMethod;
    TOP = new VerticalLabelAlignment('TOP', 0);
    CENTER_1 = new VerticalLabelAlignment('CENTER', 1);
    BOTTOM = new VerticalLabelAlignment('BOTTOM', 2);
}
function VerticalLabelAlignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_14(name_0) {
    $clinit_VerticalLabelAlignment();
    return valueOf(($clinit_VerticalLabelAlignment$Map(), $MAP_4), name_0);
}
function values_22() {
    $clinit_VerticalLabelAlignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_VerticalLabelAlignment_2_classLit, 1), $intern_36, 458, 0, [
        TOP,
        CENTER_1,
        BOTTOM
    ]);
}
defineClass(458, 23, {
    3: 1,
    34: 1,
    23: 1,
    458: 1
}, VerticalLabelAlignment);
var BOTTOM, CENTER_1, TOP;
var Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_VerticalLabelAlignment_2_classLit = createForEnum('org.eclipse.elk.alg.common.nodespacing.cellsystem', 'VerticalLabelAlignment', 458, Ljava_lang_Enum_2_classLit, values_22, valueOf_14);
function $clinit_VerticalLabelAlignment$Map() {
    $clinit_VerticalLabelAlignment$Map = emptyMethod;
    $MAP_4 = createValueOfMap(($clinit_VerticalLabelAlignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_VerticalLabelAlignment_2_classLit, 1), $intern_36, 458, 0, [
        TOP,
        CENTER_1,
        BOTTOM
    ])));
}
var $MAP_4;
function $getPortAlignment(this$static, portSide) {
    var alignment;
    alignment = null;
    switch(portSide.ordinal){
        case 1:
            this$static.node.hasProperty(($clinit_CoreOptions(), PORT_ALIGNMENT_NORTH_0)) && (alignment = castTo(this$static.node.getProperty(PORT_ALIGNMENT_NORTH_0), 255));
            break;
        case 3:
            this$static.node.hasProperty(($clinit_CoreOptions(), PORT_ALIGNMENT_SOUTH_0)) && (alignment = castTo(this$static.node.getProperty(PORT_ALIGNMENT_SOUTH_0), 255));
            break;
        case 2:
            this$static.node.hasProperty(($clinit_CoreOptions(), PORT_ALIGNMENT_EAST_0)) && (alignment = castTo(this$static.node.getProperty(PORT_ALIGNMENT_EAST_0), 255));
            break;
        case 4:
            this$static.node.hasProperty(($clinit_CoreOptions(), PORT_ALIGNMENT_WEST_0)) && (alignment = castTo(this$static.node.getProperty(PORT_ALIGNMENT_WEST_0), 255));
    }
    !alignment && (alignment = castTo(this$static.node.getProperty(($clinit_CoreOptions(), PORT_ALIGNMENT_DEFAULT)), 255));
    return alignment;
}
function NodeContext(node) {
    var symmetry;
    this.portContexts = create(new NodeContext$0methodref$comparePortSides$Type, new NodeContext$1methodref$comparePortContexts$Type);
    this.insidePortLabelCells = new EnumMap(castTo(checkNotNull(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 295));
    this.outsideNodeLabelContainers = new EnumMap(castTo(checkNotNull(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 295));
    this.nodeLabelCells = new EnumMap(castTo(checkNotNull(Lorg_eclipse_elk_alg_common_nodespacing_internal_NodeLabelLocation_2_classLit), 295));
    this.node = node;
    this.nodeSize = new KVector_2(node.getSize());
    this.topdownLayout = $booleanValue(castToBoolean(node.getProperty(($clinit_CoreOptions(), TOPDOWN_LAYOUT_2))));
    this.treatAsCompoundNode = node.isCompoundNode() || $booleanValue(castToBoolean(node.getProperty(INSIDE_SELF_LOOPS_ACTIVATE_0)));
    this.sizeConstraints = castTo(node.getProperty(NODE_SIZE_CONSTRAINTS_6), 22);
    this.sizeOptions = castTo(node.getProperty(NODE_SIZE_OPTIONS_6), 22);
    this.portConstraints = castTo(node.getProperty(PORT_CONSTRAINTS_1), 100);
    this.portLabelsPlacement = castTo(node.getProperty(PORT_LABELS_PLACEMENT_5), 22);
    if (!isValid_1(this.portLabelsPlacement)) throw toJs(new UnsupportedConfigurationException_0('Invalid port label placement: ' + this.portLabelsPlacement));
    this.portLabelsTreatAsGroup = $booleanValue(castToBoolean(node.getProperty(PORT_LABELS_TREAT_AS_GROUP_0)));
    this.nodeLabelPlacement = castTo(node.getProperty(NODE_LABELS_PLACEMENT_5), 22);
    if (!isValid_0(this.nodeLabelPlacement)) throw toJs(new UnsupportedConfigurationException_0('Invalid node label placement: ' + this.nodeLabelPlacement));
    this.nodeLabelsPadding = castTo(getIndividualOrInherited_0(node, NODE_LABELS_PADDING_0), 107);
    this.nodeLabelSpacing = $doubleValue(castToDouble(getIndividualOrInherited_0(node, SPACING_LABEL_NODE_0)));
    this.labelLabelSpacing = $doubleValue(castToDouble(getIndividualOrInherited_0(node, SPACING_LABEL_LABEL_0)));
    this.portPortSpacing = $doubleValue(castToDouble(getIndividualOrInherited_0(node, SPACING_PORT_PORT_0)));
    this.portLabelSpacingHorizontal = $doubleValue(castToDouble(getIndividualOrInherited_0(node, SPACING_LABEL_PORT_HORIZONTAL_0)));
    this.portLabelSpacingVertical = $doubleValue(castToDouble(getIndividualOrInherited_0(node, SPACING_LABEL_PORT_VERTICAL_0)));
    this.surroundingPortMargins = castTo(getIndividualOrInherited_0(node, SPACING_PORTS_SURROUNDING_0), 139);
    this.labelCellSpacing = 2 * this.labelLabelSpacing;
    symmetry = !this.sizeOptions.contains(($clinit_SizeOptions(), ASYMMETRICAL));
    this.nodeContainer = new StripContainerCell(0, symmetry, 0);
    this.nodeContainerMiddleRow = new StripContainerCell(1, symmetry, 0);
    $setCell_0(this.nodeContainer, ($clinit_ContainerArea(), CENTER), this.nodeContainerMiddleRow);
}
function comparePortContexts(portContext1, portContext2) {
    var portSideComparison;
    portSideComparison = comparePortSides(portContext1.port.getSide(), portContext2.port.getSide());
    if (portSideComparison != 0) return portSideComparison;
    switch(portContext1.port.getSide().ordinal){
        case 1:
        case 2:
            return compare_5(portContext1.port.getVolatileId(), portContext2.port.getVolatileId());
        case 3:
        case 4:
            return compare_5(portContext2.port.getVolatileId(), portContext1.port.getVolatileId());
    }
    return 0;
}
function comparePortSides(portSide1, portSide2) {
    return compare_5(portSide1.ordinal, portSide2.ordinal);
}
defineClass(780, 1, {}, NodeContext);
_.labelCellSpacing = 0;
_.labelLabelSpacing = 0;
_.nodeLabelSpacing = 0;
_.portLabelSpacingHorizontal = 0;
_.portLabelSpacingVertical = 0;
_.portLabelsTreatAsGroup = false;
_.portPortSpacing = 0;
_.topdownLayout = false;
_.treatAsCompoundNode = false;
var Lorg_eclipse_elk_alg_common_nodespacing_internal_NodeContext_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal', 'NodeContext', 780);
function NodeContext$0methodref$comparePortSides$Type() {}
defineClass(1476, 1, $intern_88, NodeContext$0methodref$comparePortSides$Type);
_.compare_1 = function compare_15(arg0, arg1) {
    return comparePortSides(castTo(arg0, 64), castTo(arg1, 64));
};
_.equals_0 = function equals_67(other) {
    return this === other;
};
_.reversed = function reversed_7() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_NodeContext$0methodref$comparePortSides$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal', 'NodeContext/0methodref$comparePortSides$Type', 1476);
function NodeContext$1methodref$comparePortContexts$Type() {}
defineClass(1477, 1, $intern_88, NodeContext$1methodref$comparePortContexts$Type);
_.compare_1 = function compare_16(arg0, arg1) {
    return comparePortContexts(castTo(arg0, 115), castTo(arg1, 115));
};
_.equals_0 = function equals_68(other) {
    return this === other;
};
_.reversed = function reversed_8() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_NodeContext$1methodref$comparePortContexts$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal', 'NodeContext/1methodref$comparePortContexts$Type', 1477);
function $clinit_NodeLabelLocation() {
    $clinit_NodeLabelLocation = emptyMethod;
    OUT_T_L = new NodeLabelLocation('OUT_T_L', 0, ($clinit_HorizontalLabelAlignment(), LEFT), ($clinit_VerticalLabelAlignment(), BOTTOM), ($clinit_ContainerArea(), BEGIN), BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(($clinit_NodeLabelPlacement(), OUTSIDE), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_LEFT_0
        ]))
    ]));
    OUT_T_C = new NodeLabelLocation('OUT_T_C', 1, CENTER_0, BOTTOM, BEGIN, CENTER, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_CENTER_0
        ])),
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    OUT_T_R = new NodeLabelLocation('OUT_T_R', 2, RIGHT, BOTTOM, BEGIN, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_RIGHT_0
        ]))
    ]));
    OUT_B_L = new NodeLabelLocation('OUT_B_L', 3, LEFT, TOP, END, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_LEFT_0
        ]))
    ]));
    OUT_B_C = new NodeLabelLocation('OUT_B_C', 4, CENTER_0, TOP, END, CENTER, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_CENTER_0
        ])),
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    OUT_B_R = new NodeLabelLocation('OUT_B_R', 5, RIGHT, TOP, END, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_RIGHT_0
        ]))
    ]));
    OUT_L_T = new NodeLabelLocation('OUT_L_T', 6, RIGHT, TOP, BEGIN, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_LEFT_0,
            V_TOP_0,
            H_PRIORITY
        ]))
    ]));
    OUT_L_C = new NodeLabelLocation('OUT_L_C', 7, RIGHT, CENTER_1, CENTER, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_LEFT_0,
            V_CENTER_0
        ])),
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_LEFT_0,
            V_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    OUT_L_B = new NodeLabelLocation('OUT_L_B', 8, RIGHT, BOTTOM, END, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_LEFT_0,
            V_BOTTOM_0,
            H_PRIORITY
        ]))
    ]));
    OUT_R_T = new NodeLabelLocation('OUT_R_T', 9, LEFT, TOP, BEGIN, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_RIGHT_0,
            V_TOP_0,
            H_PRIORITY
        ]))
    ]));
    OUT_R_C = new NodeLabelLocation('OUT_R_C', 10, LEFT, CENTER_1, CENTER, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_RIGHT_0,
            V_CENTER_0
        ])),
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_RIGHT_0,
            V_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    OUT_R_B = new NodeLabelLocation('OUT_R_B', 11, LEFT, BOTTOM, END, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(OUTSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            H_RIGHT_0,
            V_BOTTOM_0,
            H_PRIORITY
        ]))
    ]));
    IN_T_L = new NodeLabelLocation('IN_T_L', 12, LEFT, TOP, BEGIN, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_LEFT_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_LEFT_0,
            H_PRIORITY
        ]))
    ]));
    IN_T_C = new NodeLabelLocation('IN_T_C', 13, CENTER_0, TOP, BEGIN, CENTER, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_CENTER_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    IN_T_R = new NodeLabelLocation('IN_T_R', 14, RIGHT, TOP, BEGIN, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_RIGHT_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_TOP_0,
            H_RIGHT_0,
            H_PRIORITY
        ]))
    ]));
    IN_C_L = new NodeLabelLocation('IN_C_L', 15, LEFT, CENTER_1, CENTER, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_CENTER_0,
            H_LEFT_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_CENTER_0,
            H_LEFT_0,
            H_PRIORITY
        ]))
    ]));
    IN_C_C = new NodeLabelLocation('IN_C_C', 16, CENTER_0, CENTER_1, CENTER, CENTER, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_CENTER_0,
            H_CENTER_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_CENTER_0,
            H_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    IN_C_R = new NodeLabelLocation('IN_C_R', 17, RIGHT, CENTER_1, CENTER, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_CENTER_0,
            H_RIGHT_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_CENTER_0,
            H_RIGHT_0,
            H_PRIORITY
        ]))
    ]));
    IN_B_L = new NodeLabelLocation('IN_B_L', 18, LEFT, BOTTOM, END, BEGIN, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_LEFT_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_LEFT_0,
            H_PRIORITY
        ]))
    ]));
    IN_B_C = new NodeLabelLocation('IN_B_C', 19, CENTER_0, BOTTOM, END, CENTER, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_CENTER_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_CENTER_0,
            H_PRIORITY
        ]))
    ]));
    IN_B_R = new NodeLabelLocation('IN_B_R', 20, RIGHT, BOTTOM, END, END, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, [
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_RIGHT_0
        ])),
        of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
            V_BOTTOM_0,
            H_RIGHT_0,
            H_PRIORITY
        ]))
    ]));
    UNDEFINED = new NodeLabelLocation('UNDEFINED', 21, null, null, null, null, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_Set_2_classLit, 1), $intern_2, 22, 0, []));
}
function $getOutsideSide(this$static) {
    switch(this$static.ordinal){
        case 0:
        case 1:
        case 2:
            return $clinit_PortSide(), NORTH_1;
        case 3:
        case 4:
        case 5:
            return $clinit_PortSide(), SOUTH_0;
        case 6:
        case 7:
        case 8:
            return $clinit_PortSide(), WEST_0;
        case 9:
        case 10:
        case 11:
            return $clinit_PortSide(), EAST_0;
        default:
            return $clinit_PortSide(), UNDEFINED_5;
    }
}
function $isInsideLocation(this$static) {
    switch(this$static.ordinal){
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
            return true;
        default:
            return false;
    }
}
function NodeLabelLocation(enum$name, enum$ordinal, horizontalAlignment, verticalAlignment, row, column, assignedPlacements) {
    Enum.call(this, enum$name, enum$ordinal);
    this.horizontalAlignment = horizontalAlignment;
    this.verticalAlignment = verticalAlignment;
    this.containerRow = row;
    this.containerColumn = column;
    this.assignedPlacements = newArrayList_1(assignedPlacements);
}
function fromNodeLabelPlacement(labelPlacement) {
    $clinit_NodeLabelLocation();
    var location_0, location$array, location$index, location$max;
    for(location$array = values_23(), location$index = 0, location$max = location$array.length; location$index < location$max; ++location$index){
        location_0 = location$array[location$index];
        if ($indexOf_3(location_0.assignedPlacements, labelPlacement, 0) != -1) return location_0;
    }
    return UNDEFINED;
}
function valueOf_15(name_0) {
    $clinit_NodeLabelLocation();
    return valueOf(($clinit_NodeLabelLocation$Map(), $MAP_5), name_0);
}
function values_23() {
    $clinit_NodeLabelLocation();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_nodespacing_internal_NodeLabelLocation_2_classLit, 1), $intern_36, 166, 0, [
        OUT_T_L,
        OUT_T_C,
        OUT_T_R,
        OUT_B_L,
        OUT_B_C,
        OUT_B_R,
        OUT_L_T,
        OUT_L_C,
        OUT_L_B,
        OUT_R_T,
        OUT_R_C,
        OUT_R_B,
        IN_T_L,
        IN_T_C,
        IN_T_R,
        IN_C_L,
        IN_C_C,
        IN_C_R,
        IN_B_L,
        IN_B_C,
        IN_B_R,
        UNDEFINED
    ]);
}
defineClass(166, 23, {
    3: 1,
    34: 1,
    23: 1,
    166: 1
}, NodeLabelLocation);
var IN_B_C, IN_B_L, IN_B_R, IN_C_C, IN_C_L, IN_C_R, IN_T_C, IN_T_L, IN_T_R, OUT_B_C, OUT_B_L, OUT_B_R, OUT_L_B, OUT_L_C, OUT_L_T, OUT_R_B, OUT_R_C, OUT_R_T, OUT_T_C, OUT_T_L, OUT_T_R, UNDEFINED;
var Lorg_eclipse_elk_alg_common_nodespacing_internal_NodeLabelLocation_2_classLit = createForEnum('org.eclipse.elk.alg.common.nodespacing.internal', 'NodeLabelLocation', 166, Ljava_lang_Enum_2_classLit, values_23, valueOf_15);
function $clinit_NodeLabelLocation$Map() {
    $clinit_NodeLabelLocation$Map = emptyMethod;
    $MAP_5 = createValueOfMap(values_23());
}
var $MAP_5;
function $applyPortPosition(this$static) {
    this$static.port.setPosition(this$static.portPosition);
}
function PortContext(parentNodeContext, port) {
    var portLabelsNextToPort;
    this.portMargin = new ElkMargin;
    this.port = port;
    this.portPosition = new KVector_2(port.getPosition());
    portLabelsNextToPort = parentNodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), NEXT_TO_PORT_IF_POSSIBLE_0));
    parentNodeContext.portLabelsPlacement.contains(INSIDE_0) ? parentNodeContext.treatAsCompoundNode ? this.labelsNextToPort = portLabelsNextToPort && !port.hasCompoundConnections() : this.labelsNextToPort = true : parentNodeContext.portLabelsPlacement.contains(OUTSIDE_0) ? portLabelsNextToPort ? this.labelsNextToPort = !(port.getIncomingEdges().iterator_0().hasNext_0() || port.getOutgoingEdges().iterator_0().hasNext_0()) : this.labelsNextToPort = false : this.labelsNextToPort = false;
}
defineClass(115, 1, {
    115: 1
}, PortContext);
_.labelsNextToPort = false;
var Lorg_eclipse_elk_alg_common_nodespacing_internal_PortContext_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal', 'PortContext', 115);
function configureCellSystemSizeContributions(nodeContext) {
    var freePortPlacement, labelCell, location_0, location$array, location$index, location$max, overhang;
    if (nodeContext.sizeConstraints.isEmpty()) return;
    if (nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), PORTS_0))) {
        castTo($get_14(nodeContext.insidePortLabelCells, ($clinit_PortSide(), NORTH_1)), 126).contributesToMinimumWidth = true;
        castTo($get_14(nodeContext.insidePortLabelCells, SOUTH_0), 126).contributesToMinimumWidth = true;
        freePortPlacement = nodeContext.portConstraints != ($clinit_PortConstraints(), FIXED_RATIO) && nodeContext.portConstraints != FIXED_POS;
        $setContributesToMinimumHeight(castTo($get_14(nodeContext.insidePortLabelCells, EAST_0), 126), freePortPlacement);
        $setContributesToMinimumHeight(castTo($get_14(nodeContext.insidePortLabelCells, WEST_0), 126), freePortPlacement);
        $setContributesToMinimumHeight(nodeContext.nodeContainerMiddleRow, freePortPlacement);
        if (nodeContext.sizeConstraints.contains(PORT_LABELS)) {
            castTo($get_14(nodeContext.insidePortLabelCells, NORTH_1), 126).contributesToMinimumHeight = true;
            castTo($get_14(nodeContext.insidePortLabelCells, SOUTH_0), 126).contributesToMinimumHeight = true;
            castTo($get_14(nodeContext.insidePortLabelCells, EAST_0), 126).contributesToMinimumWidth = true;
            castTo($get_14(nodeContext.insidePortLabelCells, WEST_0), 126).contributesToMinimumWidth = true;
            nodeContext.nodeContainerMiddleRow.contributesToMinimumWidth = true;
        }
    }
    if (nodeContext.sizeConstraints.contains(NODE_LABELS)) {
        nodeContext.insideNodeLabelContainer.contributesToMinimumHeight = true;
        nodeContext.insideNodeLabelContainer.contributesToMinimumWidth = true;
        nodeContext.nodeContainerMiddleRow.contributesToMinimumHeight = true;
        nodeContext.nodeContainerMiddleRow.contributesToMinimumWidth = true;
        overhang = nodeContext.sizeOptions.contains(($clinit_SizeOptions(), OUTSIDE_NODE_LABELS_OVERHANG));
        for(location$array = values_23(), location$index = 0, location$max = location$array.length; location$index < location$max; ++location$index){
            location_0 = location$array[location$index];
            labelCell = castTo($get_14(nodeContext.nodeLabelCells, location_0), 315);
            if (labelCell) {
                if ($isInsideLocation(location_0)) {
                    labelCell.contributesToMinimumHeight = true;
                    labelCell.contributesToMinimumWidth = true;
                } else {
                    labelCell.contributesToMinimumHeight = !overhang;
                    labelCell.contributesToMinimumWidth = !overhang;
                }
            }
        }
    }
    if (nodeContext.sizeConstraints.contains(MINIMUM_SIZE) && nodeContext.sizeOptions.contains(($clinit_SizeOptions(), MINIMUM_SIZE_ACCOUNTS_FOR_PADDING))) {
        nodeContext.nodeContainerMiddleRow.contributesToMinimumHeight = true;
        nodeContext.nodeContainerMiddleRow.contributesToMinimumHeight = true;
        if (!nodeContext.insideNodeLabelContainer.contributesToMinimumHeight) {
            nodeContext.insideNodeLabelContainer.contributesToMinimumHeight = true;
            nodeContext.insideNodeLabelContainer.contributesToMinimumWidth = true;
            nodeContext.insideNodeLabelContainer.onlyCenterCellContributesToMinimumSize = true;
        }
    }
}
function updateVerticalInsidePortLabelCellPadding(nodeContext) {
    var bottomBorderOffset, bottomPadding, eastCell, topBorderOffset, topPadding, westCell;
    if (nodeContext.portConstraints == ($clinit_PortConstraints(), FIXED_RATIO) || nodeContext.portConstraints == FIXED_POS) return;
    topBorderOffset = nodeContext.nodeContainer.padding.top_0 + $getMinimumHeight(castTo($get_14(nodeContext.insidePortLabelCells, ($clinit_PortSide(), NORTH_1)), 126)) + nodeContext.labelCellSpacing;
    bottomBorderOffset = nodeContext.nodeContainer.padding.bottom + $getMinimumHeight(castTo($get_14(nodeContext.insidePortLabelCells, SOUTH_0), 126)) + nodeContext.labelCellSpacing;
    eastCell = castTo($get_14(nodeContext.insidePortLabelCells, EAST_0), 126);
    westCell = castTo($get_14(nodeContext.insidePortLabelCells, WEST_0), 126);
    topPadding = $wnd.Math.max(0, eastCell.padding.top_0 - topBorderOffset);
    topPadding = $wnd.Math.max(topPadding, westCell.padding.top_0 - topBorderOffset);
    bottomPadding = $wnd.Math.max(0, eastCell.padding.bottom - bottomBorderOffset);
    bottomPadding = $wnd.Math.max(bottomPadding, westCell.padding.bottom - bottomBorderOffset);
    eastCell.padding.top_0 = topPadding;
    westCell.padding.top_0 = topPadding;
    eastCell.padding.bottom = bottomPadding;
    westCell.padding.bottom = bottomPadding;
}
function calculateHorizontalNodeSizeRequiredByFixedPosPorts(nodeContext, portSide) {
    var cell, portContext, portContext$iterator, rightmostPortBorder;
    rightmostPortBorder = 0;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        rightmostPortBorder = $wnd.Math.max(rightmostPortBorder, portContext.portPosition.x_0 + portContext.port.getSize().x_0);
    }
    cell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    cell.padding.left = 0;
    cell.minimumContentAreaSize.x_0 = rightmostPortBorder;
}
function calculateHorizontalNodeSizeRequiredByFixedRatioPorts(nodeContext, portSide) {
    var cell, currentPortContext, currentPortRatio, currentPortWidth, minWidth, portContextIterator, portContexts, portLabelsInside, previousPortContext, previousPortRatio, previousPortWidth, requiredSpace;
    cell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    if (portContexts.isEmpty()) {
        cell.padding.left = 0;
        cell.padding.right = 0;
        return;
    }
    portLabelsInside = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0));
    minWidth = 0;
    portContextIterator = portContexts.iterator_0();
    previousPortContext = null;
    previousPortRatio = 0;
    previousPortWidth = 0;
    while(portContextIterator.hasNext_0()){
        currentPortContext = castTo(portContextIterator.next_1(), 115);
        currentPortRatio = $doubleValue(castToDouble(currentPortContext.port.getProperty(($clinit_PortPlacementCalculator(), PORT_RATIO_OR_POSITION))));
        currentPortWidth = currentPortContext.port.getSize().x_0;
        nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), PORT_LABELS)) && setupPortMargins(nodeContext, portSide);
        if (!previousPortContext) !!nodeContext.surroundingPortMargins && nodeContext.surroundingPortMargins.left > 0 && (minWidth = $wnd.Math.max(minWidth, minSizeRequiredToRespectSpacing(nodeContext.surroundingPortMargins.left + currentPortContext.portMargin.left, currentPortRatio)));
        else {
            requiredSpace = previousPortWidth + previousPortContext.portMargin.right + nodeContext.portPortSpacing + currentPortContext.portMargin.left;
            minWidth = $wnd.Math.max(minWidth, ($clinit_DoubleMath(), checkNonNegative($intern_93), $wnd.Math.abs(previousPortRatio - currentPortRatio) <= $intern_93 || previousPortRatio == currentPortRatio || isNaN(previousPortRatio) && isNaN(currentPortRatio) ? 0 : requiredSpace / (currentPortRatio - previousPortRatio)));
        }
        previousPortContext = currentPortContext;
        previousPortRatio = currentPortRatio;
        previousPortWidth = currentPortWidth;
    }
    if (!!nodeContext.surroundingPortMargins && nodeContext.surroundingPortMargins.right > 0) {
        requiredSpace = previousPortWidth + nodeContext.surroundingPortMargins.right;
        portLabelsInside && (requiredSpace += previousPortContext.portMargin.right);
        minWidth = $wnd.Math.max(minWidth, ($clinit_DoubleMath(), checkNonNegative($intern_93), $wnd.Math.abs(previousPortRatio - 1) <= $intern_93 || previousPortRatio == 1 || isNaN(previousPortRatio) && isNaN(1) ? 0 : requiredSpace / (1 - previousPortRatio)));
    }
    cell.padding.left = 0;
    cell.minimumContentAreaSize.x_0 = minWidth;
}
function calculateHorizontalNodeSizeRequiredByFreePorts(nodeContext, portSide) {
    var cell, width_0;
    cell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    if (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).isEmpty()) {
        cell.padding.left = 0;
        cell.padding.right = 0;
        return;
    }
    cell.padding.left = nodeContext.surroundingPortMargins.left;
    cell.padding.right = nodeContext.surroundingPortMargins.right;
    nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), PORT_LABELS)) && setupPortMargins(nodeContext, portSide);
    width_0 = portWidthPlusPortPortSpacing(nodeContext, portSide);
    $getPortAlignment(nodeContext, portSide) == ($clinit_PortAlignment(), DISTRIBUTED) && (width_0 += 2 * nodeContext.portPortSpacing);
    cell.minimumContentAreaSize.x_0 = width_0;
}
function calculateHorizontalPortPlacementSize(nodeContext) {
    switch(nodeContext.portConstraints.ordinal){
        case 5:
            calculateHorizontalNodeSizeRequiredByFixedPosPorts(nodeContext, ($clinit_PortSide(), NORTH_1));
            calculateHorizontalNodeSizeRequiredByFixedPosPorts(nodeContext, SOUTH_0);
            break;
        case 4:
            calculateHorizontalNodeSizeRequiredByFixedRatioPorts(nodeContext, ($clinit_PortSide(), NORTH_1));
            calculateHorizontalNodeSizeRequiredByFixedRatioPorts(nodeContext, SOUTH_0);
            break;
        default:
            calculateHorizontalNodeSizeRequiredByFreePorts(nodeContext, ($clinit_PortSide(), NORTH_1));
            calculateHorizontalNodeSizeRequiredByFreePorts(nodeContext, SOUTH_0);
    }
}
function computeHorizontalPortMargins(nodeContext, portSide) {
    var labelWidth, labelsBounds, overhang, portContext, portContext$iterator, portWidth;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        labelWidth = portContext.portLabelCell ? $getMinimumWidth(portContext.portLabelCell) : 0;
        if (labelWidth > 0) {
            if (portContext.labelsNextToPort) {
                portWidth = portContext.port.getSize().x_0;
                if (labelWidth > portWidth) {
                    overhang = (labelWidth - portWidth) / 2;
                    portContext.portMargin.left = overhang;
                    portContext.portMargin.right = overhang;
                }
            } else portContext.portMargin.right = nodeContext.portLabelSpacingHorizontal + labelWidth;
        } else if (isFixed(nodeContext.portLabelsPlacement)) {
            labelsBounds = getLabelsBounds(portContext.port);
            labelsBounds.x_0 < 0 && (portContext.portMargin.left = -labelsBounds.x_0);
            labelsBounds.x_0 + labelsBounds.width_0 > portContext.port.getSize().x_0 && (portContext.portMargin.right = labelsBounds.x_0 + labelsBounds.width_0 - portContext.port.getSize().x_0);
        }
    }
}
function minSizeRequiredToRespectSpacing(spacing, secondRatio) {
    return $clinit_DoubleMath(), checkNonNegative($intern_93), $wnd.Math.abs(0 - secondRatio) <= $intern_93 || 0 == secondRatio || isNaN(0) && isNaN(secondRatio) ? 0 : spacing / secondRatio;
}
function portWidthPlusPortPortSpacing(nodeContext, portSide) {
    var portContext, portContextIterator, result;
    result = 0;
    portContextIterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0();
    while(portContextIterator.hasNext_0()){
        portContext = castTo(portContextIterator.next_1(), 115);
        result += portContext.portMargin.left + portContext.port.getSize().x_0 + portContext.portMargin.right;
        portContextIterator.hasNext_0() && (result += nodeContext.portPortSpacing);
    }
    return result;
}
function setupPortMargins(nodeContext, portSide) {
    var alwaysSameSide, alwaysSameSideAbove, leftmostPortContext, portContextIterator, portContexts, portLabelsOutside, rightmostPortContext, spaceEfficient, spaceEfficientPortLabels, uniformPortSpacing;
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    portLabelsOutside = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), OUTSIDE_0));
    alwaysSameSide = nodeContext.portLabelsPlacement.contains(ALWAYS_SAME_SIDE);
    alwaysSameSideAbove = nodeContext.portLabelsPlacement.contains(ALWAYS_OTHER_SAME_SIDE);
    spaceEfficient = nodeContext.portLabelsPlacement.contains(SPACE_EFFICIENT_0);
    uniformPortSpacing = nodeContext.sizeOptions.contains(($clinit_SizeOptions(), UNIFORM_PORT_SPACING));
    spaceEfficientPortLabels = !alwaysSameSide && !alwaysSameSideAbove && (spaceEfficient || portContexts.size_1() == 2);
    computeHorizontalPortMargins(nodeContext, portSide);
    leftmostPortContext = null;
    rightmostPortContext = null;
    if (portLabelsOutside) {
        portContextIterator = portContexts.iterator_0();
        leftmostPortContext = castTo(portContextIterator.next_1(), 115);
        rightmostPortContext = leftmostPortContext;
        while(portContextIterator.hasNext_0())rightmostPortContext = castTo(portContextIterator.next_1(), 115);
        leftmostPortContext.portMargin.left = 0;
        rightmostPortContext.portMargin.right = 0;
        spaceEfficientPortLabels && !leftmostPortContext.labelsNextToPort && (leftmostPortContext.portMargin.right = 0);
    }
    if (uniformPortSpacing) {
        unifyPortMargins(portContexts);
        if (portLabelsOutside) {
            leftmostPortContext.portMargin.left = 0;
            rightmostPortContext.portMargin.right = 0;
        }
    }
}
function unifyPortMargins(portContexts) {
    var maxLeft, maxRight, portContext, portContext$iterator, portContext$iterator0;
    maxLeft = 0;
    maxRight = 0;
    for(portContext$iterator0 = portContexts.iterator_0(); portContext$iterator0.hasNext_0();){
        portContext = castTo(portContext$iterator0.next_1(), 115);
        maxLeft = $wnd.Math.max(maxLeft, portContext.portMargin.left);
        maxRight = $wnd.Math.max(maxRight, portContext.portMargin.right);
    }
    for(portContext$iterator = portContexts.iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portMargin.left = maxLeft;
        portContext.portMargin.right = maxRight;
    }
}
function calculateWidthDueToLabels(nodeContext, portSide) {
    var minCellSize, portContext, portContext$iterator, theAppropriateCell;
    theAppropriateCell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    minCellSize = theAppropriateCell.minimumContentAreaSize;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        !!portContext.portLabelCell && (minCellSize.x_0 = $wnd.Math.max(minCellSize.x_0, $getMinimumWidth(portContext.portLabelCell)));
    }
    if (minCellSize.x_0 > 0) switch(portSide.ordinal){
        case 2:
            theAppropriateCell.padding.right = nodeContext.portLabelSpacingHorizontal;
            break;
        case 4:
            theAppropriateCell.padding.left = nodeContext.portLabelSpacingHorizontal;
    }
}
function createInsidePortLabelCell(nodeContext, container, containerArea, portSide) {
    var portLabelCell;
    portLabelCell = new AtomicCell;
    container.cells_0[containerArea.ordinal] = portLabelCell;
    $put_7(nodeContext.insidePortLabelCells, portSide, portLabelCell);
}
function setupEastOrWestPortLabelCell(nodeContext, portSide) {
    nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0)) && calculateWidthDueToLabels(nodeContext, portSide);
    setupTopAndBottomPadding(nodeContext, portSide);
}
function setupNorthOrSouthPortLabelCell(nodeContext, portSide) {
    var padding;
    padding = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126).padding;
    switch(portSide.ordinal){
        case 1:
            nodeContext.portLabelSpacingVertical >= 0 && (padding.top_0 = nodeContext.portLabelSpacingVertical);
            break;
        case 3:
            nodeContext.portLabelSpacingVertical >= 0 && (padding.bottom = nodeContext.portLabelSpacingVertical);
    }
    if (nodeContext.surroundingPortMargins) {
        padding.left = nodeContext.surroundingPortMargins.left;
        padding.right = nodeContext.surroundingPortMargins.right;
    }
}
function setupTopAndBottomPadding(nodeContext, portSide) {
    var padding;
    if (nodeContext.surroundingPortMargins) {
        padding = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126).padding;
        padding.top_0 = nodeContext.surroundingPortMargins.top_0;
        padding.bottom = nodeContext.surroundingPortMargins.bottom;
    }
}
function placeHorizontalOuterNodeLabelContainer(nodeContext, outerNodeLabelsOverhang, portSide) {
    var nodeLabelContainer, nodeLabelContainerRect, nodeSize;
    nodeSize = nodeContext.nodeSize;
    nodeLabelContainer = castTo($get_14(nodeContext.outsideNodeLabelContainers, portSide), 251);
    nodeLabelContainerRect = nodeLabelContainer.cellRectangle;
    nodeLabelContainerRect.width_0 = $getMinimumWidth_0(nodeLabelContainer);
    nodeLabelContainerRect.height = $getMinimumHeight_1(nodeLabelContainer);
    nodeLabelContainerRect.width_0 = $wnd.Math.max(nodeLabelContainerRect.width_0, nodeSize.x_0);
    nodeLabelContainerRect.width_0 > nodeSize.x_0 && !outerNodeLabelsOverhang && (nodeLabelContainerRect.width_0 = nodeSize.x_0);
    nodeLabelContainerRect.x_0 = -(nodeLabelContainerRect.width_0 - nodeSize.x_0) / 2;
    switch(portSide.ordinal){
        case 1:
            nodeLabelContainerRect.y_0 = -nodeLabelContainerRect.height;
            break;
        case 3:
            nodeLabelContainerRect.y_0 = nodeSize.y_0;
    }
    $layoutChildrenHorizontally(nodeLabelContainer);
    $layoutChildrenVertically(nodeLabelContainer);
}
function placeVerticalOuterNodeLabelContainer(nodeContext, outerNodeLabelsOverhang, portSide) {
    var nodeLabelContainer, nodeLabelContainerRect, nodeSize;
    nodeSize = nodeContext.nodeSize;
    nodeLabelContainer = castTo($get_14(nodeContext.outsideNodeLabelContainers, portSide), 251);
    nodeLabelContainerRect = nodeLabelContainer.cellRectangle;
    nodeLabelContainerRect.width_0 = $getMinimumWidth_0(nodeLabelContainer);
    nodeLabelContainerRect.height = $getMinimumHeight_1(nodeLabelContainer);
    nodeLabelContainerRect.height = $wnd.Math.max(nodeLabelContainerRect.height, nodeSize.y_0);
    nodeLabelContainerRect.height > nodeSize.y_0 && !outerNodeLabelsOverhang && (nodeLabelContainerRect.height = nodeSize.y_0);
    nodeLabelContainerRect.y_0 = -(nodeLabelContainerRect.height - nodeSize.y_0) / 2;
    switch(portSide.ordinal){
        case 4:
            nodeLabelContainerRect.x_0 = -nodeLabelContainerRect.width_0;
            break;
        case 2:
            nodeLabelContainerRect.x_0 = nodeSize.x_0;
    }
    $layoutChildrenHorizontally(nodeLabelContainer);
    $layoutChildrenVertically(nodeLabelContainer);
}
function LabelPlacer$lambda$0$Type() {}
defineClass(1481, 1, $intern_19, LabelPlacer$lambda$0$Type);
_.accept = function accept_44(arg0) {
    $applyLabelLayout(castTo(arg0, 315));
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_algorithm_LabelPlacer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal.algorithm', 'LabelPlacer/lambda$0$Type', 1481);
function LabelPlacer$lambda$1$Type() {}
defineClass(1482, 1, $intern_39, LabelPlacer$lambda$1$Type);
_.test_0 = function test_8(arg0) {
    return !!castTo(arg0, 115).portLabelCell;
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_algorithm_LabelPlacer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal.algorithm', 'LabelPlacer/lambda$1$Type', 1482);
function LabelPlacer$lambda$2$Type() {}
defineClass(1483, 1, $intern_19, LabelPlacer$lambda$2$Type);
_.accept = function accept_45(arg0) {
    $applyLabelLayout(castTo(arg0, 115).portLabelCell);
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_algorithm_LabelPlacer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal.algorithm', 'LabelPlacer/lambda$2$Type', 1483);
function $clinit_NodeLabelAndSizeUtilities() {
    $clinit_NodeLabelAndSizeUtilities = emptyMethod;
    EFFECTIVELY_FIXED_SIZE_CONSTRAINTS = of_1(($clinit_SizeConstraint(), PORT_LABELS));
}
function getMinimumNodeOrClientAreaSize(nodeContext) {
    $clinit_NodeLabelAndSizeUtilities();
    var minSize;
    minSize = new KVector_2(castTo(nodeContext.node.getProperty(($clinit_CoreOptions(), NODE_SIZE_MINIMUM_5)), 8));
    if (nodeContext.sizeOptions.contains(($clinit_SizeOptions(), DEFAULT_MINIMUM_SIZE))) {
        minSize.x_0 <= 0 && (minSize.x_0 = 20);
        minSize.y_0 <= 0 && (minSize.y_0 = 20);
    }
    return minSize;
}
function getMinimumNodeSize(nodeContext) {
    $clinit_NodeLabelAndSizeUtilities();
    if (nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), MINIMUM_SIZE))) {
        if (!nodeContext.sizeOptions.contains(($clinit_SizeOptions(), MINIMUM_SIZE_ACCOUNTS_FOR_PADDING))) return getMinimumNodeOrClientAreaSize(nodeContext);
    }
    return null;
}
function isFirstOutsidePortLabelPlacedDifferently(nodeContext, portSide) {
    $clinit_NodeLabelAndSizeUtilities();
    var alwaysSameSide, firstPort, portContexts, spaceEfficient;
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    if (portContexts.size_1() >= 2) {
        firstPort = castTo(portContexts.iterator_0().next_1(), 115);
        alwaysSameSide = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), ALWAYS_SAME_SIDE));
        spaceEfficient = nodeContext.portLabelsPlacement.contains(SPACE_EFFICIENT_0);
        return !firstPort.labelsNextToPort && !alwaysSameSide && (portContexts.size_1() == 2 || spaceEfficient);
    } else return false;
}
function offsetSouthernPortsByNodeSize(nodeContext) {
    $clinit_NodeLabelAndSizeUtilities();
    var nodeHeight, portContext, portContext$iterator, portPosition;
    nodeHeight = nodeContext.nodeSize.y_0;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, ($clinit_PortSide(), SOUTH_0)), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portPosition = portContext.portPosition;
        portPosition.y_0 += nodeHeight;
    }
}
function setNodePadding(nodeContext) {
    $clinit_NodeLabelAndSizeUtilities();
    var clientArea, nodePadding, nodeRect;
    if (!nodeContext.sizeOptions.contains(($clinit_SizeOptions(), COMPUTE_PADDING))) return;
    nodeRect = nodeContext.nodeContainer.cellRectangle;
    clientArea = new ElkRectangle_1(nodeContext.insideNodeLabelContainer.centerCellRect);
    nodePadding = new ElkPadding;
    nodePadding.left = clientArea.x_0 - nodeRect.x_0;
    nodePadding.top_0 = clientArea.y_0 - nodeRect.y_0;
    nodePadding.right = nodeRect.x_0 + nodeRect.width_0 - (clientArea.x_0 + clientArea.width_0);
    nodePadding.bottom = nodeRect.y_0 + nodeRect.height - (clientArea.y_0 + clientArea.height);
    nodeContext.node.setPadding(nodePadding);
}
function setupNodePaddingForPortsWithOffset(nodeContext) {
    $clinit_NodeLabelAndSizeUtilities();
    var insidePart, insidePartIsBigger, nodeCellPadding, portBorderOffset, portContext, portContext$iterator, symmetry;
    nodeCellPadding = nodeContext.nodeContainer.padding;
    for(portContext$iterator = $values_0(nodeContext.portContexts).this$01.valueIterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portBorderOffset = 0;
        if (portContext.port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0))) {
            portBorderOffset = $doubleValue(castToDouble(portContext.port.getProperty(PORT_BORDER_OFFSET_0)));
            if (portBorderOffset < 0) switch(portContext.port.getSide().ordinal){
                case 1:
                    nodeCellPadding.top_0 = $wnd.Math.max(nodeCellPadding.top_0, -portBorderOffset);
                    break;
                case 3:
                    nodeCellPadding.bottom = $wnd.Math.max(nodeCellPadding.bottom, -portBorderOffset);
                    break;
                case 2:
                    nodeCellPadding.right = $wnd.Math.max(nodeCellPadding.right, -portBorderOffset);
                    break;
                case 4:
                    nodeCellPadding.left = $wnd.Math.max(nodeCellPadding.left, -portBorderOffset);
            }
        }
        if (isFixed(nodeContext.portLabelsPlacement)) {
            insidePart = computeInsidePart_0(portContext.port, portBorderOffset);
            symmetry = !castTo(nodeContext.node.getProperty(NODE_SIZE_OPTIONS_6), 181).contains(($clinit_SizeOptions(), ASYMMETRICAL));
            insidePartIsBigger = false;
            switch(portContext.port.getSide().ordinal){
                case 1:
                    insidePartIsBigger = insidePart > nodeCellPadding.top_0;
                    nodeCellPadding.top_0 = $wnd.Math.max(nodeCellPadding.top_0, insidePart);
                    if (symmetry && insidePartIsBigger) {
                        nodeCellPadding.top_0 = $wnd.Math.max(nodeCellPadding.top_0, nodeCellPadding.bottom);
                        nodeCellPadding.bottom = nodeCellPadding.top_0 + portBorderOffset;
                    }
                    break;
                case 3:
                    insidePartIsBigger = insidePart > nodeCellPadding.bottom;
                    nodeCellPadding.bottom = $wnd.Math.max(nodeCellPadding.bottom, insidePart);
                    if (symmetry && insidePartIsBigger) {
                        nodeCellPadding.bottom = $wnd.Math.max(nodeCellPadding.bottom, nodeCellPadding.top_0);
                        nodeCellPadding.top_0 = nodeCellPadding.bottom + portBorderOffset;
                    }
                    break;
                case 2:
                    insidePartIsBigger = insidePart > nodeCellPadding.right;
                    nodeCellPadding.right = $wnd.Math.max(nodeCellPadding.right, insidePart);
                    if (symmetry && insidePartIsBigger) {
                        nodeCellPadding.right = $wnd.Math.max(nodeCellPadding.left, nodeCellPadding.right);
                        nodeCellPadding.left = nodeCellPadding.right + portBorderOffset;
                    }
                    break;
                case 4:
                    insidePartIsBigger = insidePart > nodeCellPadding.left;
                    nodeCellPadding.left = $wnd.Math.max(nodeCellPadding.left, insidePart);
                    if (symmetry && insidePartIsBigger) {
                        nodeCellPadding.left = $wnd.Math.max(nodeCellPadding.left, nodeCellPadding.right);
                        nodeCellPadding.right = nodeCellPadding.left + portBorderOffset;
                    }
            }
        }
    }
}
var EFFECTIVELY_FIXED_SIZE_CONSTRAINTS;
function NodeLabelAndSizeUtilities$lambda$0$Type() {}
defineClass(1480, 1, $intern_19, NodeLabelAndSizeUtilities$lambda$0$Type);
_.accept = function accept_46(arg0) {
    $clinit_NodeLabelAndSizeUtilities();
    $applyPortPosition(castTo(arg0, 115));
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_algorithm_NodeLabelAndSizeUtilities$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal.algorithm', 'NodeLabelAndSizeUtilities/lambda$0$Type', 1480);
function createNodeLabelCellContainers(nodeContext, onlyInside) {
    var eastContainer, northContainer, southContainer, symmetry, tabularNodeLabels, westContainer;
    symmetry = !nodeContext.sizeOptions.contains(($clinit_SizeOptions(), ASYMMETRICAL));
    tabularNodeLabels = nodeContext.sizeOptions.contains(FORCE_TABULAR_NODE_LABELS);
    nodeContext.insideNodeLabelContainer = new GridContainerCell(tabularNodeLabels, symmetry, nodeContext.labelCellSpacing);
    !!nodeContext.nodeLabelsPadding && $copy(nodeContext.insideNodeLabelContainer.padding, nodeContext.nodeLabelsPadding);
    $setCell_0(nodeContext.nodeContainerMiddleRow, ($clinit_ContainerArea(), CENTER), nodeContext.insideNodeLabelContainer);
    if (!onlyInside) {
        northContainer = new StripContainerCell(1, symmetry, nodeContext.labelCellSpacing);
        northContainer.padding.bottom = nodeContext.nodeLabelSpacing;
        $put_7(nodeContext.outsideNodeLabelContainers, ($clinit_PortSide(), NORTH_1), northContainer);
        southContainer = new StripContainerCell(1, symmetry, nodeContext.labelCellSpacing);
        southContainer.padding.top_0 = nodeContext.nodeLabelSpacing;
        $put_7(nodeContext.outsideNodeLabelContainers, SOUTH_0, southContainer);
        westContainer = new StripContainerCell(0, symmetry, nodeContext.labelCellSpacing);
        westContainer.padding.right = nodeContext.nodeLabelSpacing;
        $put_7(nodeContext.outsideNodeLabelContainers, WEST_0, westContainer);
        eastContainer = new StripContainerCell(0, symmetry, nodeContext.labelCellSpacing);
        eastContainer.padding.left = nodeContext.nodeLabelSpacing;
        $put_7(nodeContext.outsideNodeLabelContainers, EAST_0, eastContainer);
    }
}
function createNodeLabelCells(nodeContext, horizontalLayoutMode) {
    createNodeLabelCellContainers(nodeContext, true);
    $forEach_1(nodeContext.node.getLabels(), new NodeLabelCellCreator$lambda$0$Type(nodeContext, true, horizontalLayoutMode));
}
function handleNodeLabel(nodeContext, label_0, onlyInside, horizontalLayoutMode) {
    var labelLocation, labelPlacement;
    labelPlacement = label_0.hasProperty(($clinit_CoreOptions(), NODE_LABELS_PLACEMENT_5)) ? castTo(label_0.getProperty(NODE_LABELS_PLACEMENT_5), 22) : nodeContext.nodeLabelPlacement;
    labelLocation = fromNodeLabelPlacement(labelPlacement);
    if (labelLocation == ($clinit_NodeLabelLocation(), UNDEFINED)) return;
    if (onlyInside && !$isInsideLocation(labelLocation)) return;
    $addLabel(retrieveNodeLabelCell(nodeContext, labelLocation, horizontalLayoutMode), label_0);
}
function lambda$0_10(nodeContext_0, onlyInside_1, horizontalLayoutMode_2, label_3) {
    handleNodeLabel(nodeContext_0, label_3, onlyInside_1, horizontalLayoutMode_2);
}
function retrieveNodeLabelCell(nodeContext, nodeLabelLocation, horizontalLayoutMode) {
    var containerCell, nodeLabelCell, outsideSide;
    nodeLabelCell = castTo($get_14(nodeContext.nodeLabelCells, nodeLabelLocation), 315);
    if (!nodeLabelCell) {
        nodeLabelCell = new LabelCell_0(nodeContext.labelLabelSpacing, nodeLabelLocation, horizontalLayoutMode);
        $put_7(nodeContext.nodeLabelCells, nodeLabelLocation, nodeLabelCell);
        if ($isInsideLocation(nodeLabelLocation)) $setCell(nodeContext.insideNodeLabelContainer, nodeLabelLocation.containerRow, nodeLabelLocation.containerColumn, nodeLabelCell);
        else {
            outsideSide = $getOutsideSide(nodeLabelLocation);
            containerCell = castTo($get_14(nodeContext.outsideNodeLabelContainers, outsideSide), 251);
            switch(outsideSide.ordinal){
                case 1:
                case 3:
                    nodeLabelCell.contributesToMinimumHeight = true;
                    $setCell_0(containerCell, nodeLabelLocation.containerColumn, nodeLabelCell);
                    break;
                case 4:
                case 2:
                    nodeLabelCell.contributesToMinimumWidth = true;
                    $setCell_0(containerCell, nodeLabelLocation.containerRow, nodeLabelCell);
            }
        }
    }
    return nodeLabelCell;
}
function NodeLabelCellCreator$lambda$0$Type(nodeContext_0, onlyInside_1, horizontalLayoutMode_2) {
    this.nodeContext_0 = nodeContext_0;
    this.onlyInside_1 = onlyInside_1;
    this.horizontalLayoutMode_2 = horizontalLayoutMode_2;
}
defineClass(781, 1, $intern_19, NodeLabelCellCreator$lambda$0$Type);
_.accept = function accept_47(arg0) {
    lambda$0_10(this.nodeContext_0, this.onlyInside_1, this.horizontalLayoutMode_2, castTo(arg0, 187));
};
_.horizontalLayoutMode_2 = false;
_.onlyInside_1 = false;
var Lorg_eclipse_elk_alg_common_nodespacing_internal_algorithm_NodeLabelCellCreator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal.algorithm', 'NodeLabelCellCreator/lambda$0$Type', 781);
function setNodeHeight(nodeContext) {
    var height, minNodeSize, nodeCellRectangle, nodeSize;
    nodeSize = nodeContext.nodeSize;
    $clinit_NodeLabelAndSizeUtilities();
    if (nodeContext.sizeConstraints.isEmpty() || equals_Ljava_lang_Object__Z__devirtual$(nodeContext.sizeConstraints, EFFECTIVELY_FIXED_SIZE_CONSTRAINTS)) height = nodeSize.y_0;
    else {
        nodeContext.topdownLayout ? height = $wnd.Math.max(nodeSize.y_0, $getMinimumHeight_1(nodeContext.nodeContainer)) : height = $getMinimumHeight_1(nodeContext.nodeContainer);
        if (nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), NODE_LABELS)) && !nodeContext.sizeOptions.contains(($clinit_SizeOptions(), OUTSIDE_NODE_LABELS_OVERHANG))) {
            height = $wnd.Math.max(height, $getMinimumHeight_1(castTo($get_14(nodeContext.outsideNodeLabelContainers, ($clinit_PortSide(), EAST_0)), 251)));
            height = $wnd.Math.max(height, $getMinimumHeight_1(castTo($get_14(nodeContext.outsideNodeLabelContainers, WEST_0), 251)));
        }
        minNodeSize = getMinimumNodeSize(nodeContext);
        !!minNodeSize && (height = $wnd.Math.max(height, minNodeSize.y_0));
        if (nodeContext.sizeConstraints.contains(PORTS_0)) {
            if (nodeContext.portConstraints == ($clinit_PortConstraints(), FIXED_RATIO) || nodeContext.portConstraints == FIXED_POS) {
                height = $wnd.Math.max(height, $getMinimumHeight(castTo($get_14(nodeContext.insidePortLabelCells, ($clinit_PortSide(), EAST_0)), 126)));
                height = $wnd.Math.max(height, $getMinimumHeight(castTo($get_14(nodeContext.insidePortLabelCells, WEST_0), 126)));
            }
        }
    }
    $booleanValue(castToBoolean(nodeContext.node.getGraph().getProperty(($clinit_CoreOptions(), NODE_SIZE_FIXED_GRAPH_SIZE_3)))) ? nodeSize.y_0 = $wnd.Math.max(nodeSize.y_0, height) : nodeSize.y_0 = height;
    nodeCellRectangle = nodeContext.nodeContainer.cellRectangle;
    nodeCellRectangle.y_0 = 0;
    nodeCellRectangle.height = height;
    $layoutChildrenVertically(nodeContext.nodeContainer);
}
function setNodeWidth(nodeContext) {
    var minNodeSize, nodeCellRectangle, nodeSize, width_0;
    nodeSize = nodeContext.nodeSize;
    $clinit_NodeLabelAndSizeUtilities();
    if (nodeContext.sizeConstraints.isEmpty() || equals_Ljava_lang_Object__Z__devirtual$(nodeContext.sizeConstraints, EFFECTIVELY_FIXED_SIZE_CONSTRAINTS)) width_0 = nodeSize.x_0;
    else {
        nodeContext.topdownLayout ? width_0 = $wnd.Math.max(nodeSize.x_0, $getMinimumWidth_0(nodeContext.nodeContainer)) : width_0 = $getMinimumWidth_0(nodeContext.nodeContainer);
        if (nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), NODE_LABELS)) && !nodeContext.sizeOptions.contains(($clinit_SizeOptions(), OUTSIDE_NODE_LABELS_OVERHANG))) {
            width_0 = $wnd.Math.max(width_0, $getMinimumWidth_0(castTo($get_14(nodeContext.outsideNodeLabelContainers, ($clinit_PortSide(), NORTH_1)), 251)));
            width_0 = $wnd.Math.max(width_0, $getMinimumWidth_0(castTo($get_14(nodeContext.outsideNodeLabelContainers, SOUTH_0), 251)));
        }
        minNodeSize = getMinimumNodeSize(nodeContext);
        !!minNodeSize && (width_0 = $wnd.Math.max(width_0, minNodeSize.x_0));
    }
    $booleanValue(castToBoolean(nodeContext.node.getGraph().getProperty(($clinit_CoreOptions(), NODE_SIZE_FIXED_GRAPH_SIZE_3)))) ? nodeSize.x_0 = $wnd.Math.max(nodeSize.x_0, width_0) : nodeSize.x_0 = width_0;
    nodeCellRectangle = nodeContext.nodeContainer.cellRectangle;
    nodeCellRectangle.x_0 = 0;
    nodeCellRectangle.width_0 = width_0;
    $layoutChildrenHorizontally(nodeContext.nodeContainer);
}
function createPortContext(nodeContext, port, imPortLabels) {
    var portContext;
    portContext = new PortContext(nodeContext, port);
    $put(nodeContext.portContexts, port.getSide(), portContext);
    if (imPortLabels && !isFixed(nodeContext.portLabelsPlacement)) {
        portContext.portLabelCell = new LabelCell(nodeContext.labelLabelSpacing);
        $forEach_1(port.getLabels(), new PortContextCreator$lambda$0$Type(portContext));
    }
}
function createPortContexts(nodeContext, ignoreInsidePortLabels) {
    var imPortLabels, port, port$iterator, volatileId;
    imPortLabels = !ignoreInsidePortLabels || !nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0));
    volatileId = 0;
    for(port$iterator = new ArrayList$1(nodeContext.node.getPorts()); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 831);
        if (port.getSide() == ($clinit_PortSide(), UNDEFINED_5)) throw toJs(new IllegalArgumentException_0('Label and node size calculator can only be used with ports that have port sides assigned.'));
        port.setVolatileId(volatileId++);
        createPortContext(nodeContext, port, imPortLabels);
    }
}
function lambda$0_11(portContext_0, label_1) {
    $addLabel(portContext_0.portLabelCell, label_1);
}
function PortContextCreator$lambda$0$Type(portContext_0) {
    this.portContext_0 = portContext_0;
}
defineClass(1479, 1, $intern_19, PortContextCreator$lambda$0$Type);
_.accept = function accept_48(arg0) {
    lambda$0_11(this.portContext_0, castTo(arg0, 187));
};
var Lorg_eclipse_elk_alg_common_nodespacing_internal_algorithm_PortContextCreator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.nodespacing.internal.algorithm', 'PortContextCreator/lambda$0$Type', 1479);
function constrainedInsidePortLabelPlacement(nodeContext, portSide) {
    var insidePortLabelContainer, labelContainerRect, leftBorder, overlapRemovalDirection, overlapRemover, padding, padding0, portContext, portContext$iterator, portContext$iterator0, portContexts, portLabelCell, portLabelCellRect, portPosition, portSize, rightBorder, startCoordinate, stripHeight, verticalLabelAlignment, actualMinX, actualMaxX;
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    if (portSide == ($clinit_PortSide(), EAST_0) || portSide == WEST_0) {
        simpleInsidePortLabelPlacement(nodeContext, portSide);
        return;
    }
    overlapRemovalDirection = portSide == NORTH_1 ? ($clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), DOWN) : ($clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), UP);
    verticalLabelAlignment = portSide == NORTH_1 ? ($clinit_VerticalLabelAlignment(), TOP) : ($clinit_VerticalLabelAlignment(), BOTTOM);
    insidePortLabelContainer = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    labelContainerRect = insidePortLabelContainer.cellRectangle;
    leftBorder = labelContainerRect.x_0 + maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        insidePortLabelContainer.padding.left,
        nodeContext.surroundingPortMargins.left,
        nodeContext.nodeLabelSpacing
    ]));
    rightBorder = labelContainerRect.x_0 + labelContainerRect.width_0 - maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        insidePortLabelContainer.padding.right,
        nodeContext.surroundingPortMargins.right,
        nodeContext.nodeLabelSpacing
    ]));
    overlapRemover = $withGap(createForDirection(overlapRemovalDirection), nodeContext.portLabelSpacingVertical);
    startCoordinate = portSide == NORTH_1 ? $intern_61 : $intern_60;
    for(portContext$iterator0 = portContexts.iterator_0(); portContext$iterator0.hasNext_0();){
        portContext = castTo(portContext$iterator0.next_1(), 115);
        if (!portContext.portLabelCell || portContext.portLabelCell.labels.array.length <= 0) continue;
        portSize = portContext.port.getSize();
        portPosition = portContext.portPosition;
        portLabelCell = portContext.portLabelCell;
        portLabelCellRect = portLabelCell.cellRectangle;
        portLabelCellRect.width_0 = (padding0 = portLabelCell.padding, portLabelCell.minimumContentAreaSize.x_0 + padding0.left + padding0.right);
        portLabelCellRect.height = (padding = portLabelCell.padding, portLabelCell.minimumContentAreaSize.y_0 + padding.top_0 + padding.bottom);
        requireNonNull_0(verticalLabelAlignment, 'Vertical alignment cannot be null');
        portLabelCell.verticalAlignment = verticalLabelAlignment;
        $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
        portLabelCellRect.x_0 = portPosition.x_0 - (portLabelCellRect.width_0 - portSize.x_0) / 2;
        actualMinX = $wnd.Math.min(leftBorder, portPosition.x_0);
        actualMaxX = $wnd.Math.max(rightBorder, portPosition.x_0 + portSize.x_0);
        portLabelCellRect.x_0 < actualMinX ? portLabelCellRect.x_0 = actualMinX : portLabelCellRect.x_0 + portLabelCellRect.width_0 > actualMaxX && (portLabelCellRect.x_0 = actualMaxX - portLabelCellRect.width_0);
        $add_3(overlapRemover.rectangleNodes, new RectangleStripOverlapRemover$RectangleNode(portLabelCellRect, $importRectangle(overlapRemover, portLabelCellRect)));
        startCoordinate = portSide == NORTH_1 ? $wnd.Math.max(startCoordinate, portPosition.y_0 + portContext.port.getSize().y_0) : $wnd.Math.min(startCoordinate, portPosition.y_0);
    }
    startCoordinate += portSide == NORTH_1 ? nodeContext.portLabelSpacingVertical : -nodeContext.portLabelSpacingVertical;
    stripHeight = $removeOverlaps_0((overlapRemover.startCoordinate = startCoordinate, overlapRemover));
    stripHeight > 0 && (castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126).minimumContentAreaSize.y_0 = stripHeight);
    for(portContext$iterator = portContexts.iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        if (!portContext.portLabelCell || portContext.portLabelCell.labels.array.length <= 0) continue;
        portLabelCellRect = portContext.portLabelCell.cellRectangle;
        portLabelCellRect.x_0 -= portContext.portPosition.x_0;
        portLabelCellRect.y_0 -= portContext.portPosition.y_0;
    }
}
function constrainedOutsidePortLabelPlacement(nodeContext, portSide) {
    var overlapRemovalDirection, overlapRemover, padding, padding0, padding1, portContext, portContext$iterator, portContext$iterator0, portContexts, portLabelCell, portLabelCellRect, portPosition, portSize, portWithSpecialNeeds, startCoordinate, verticalLabelAlignment;
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    if (portContexts.size_1() <= 2 || portSide == ($clinit_PortSide(), EAST_0) || portSide == ($clinit_PortSide(), WEST_0)) {
        simpleOutsidePortLabelPlacement(nodeContext, portSide);
        return;
    }
    portWithSpecialNeeds = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), SPACE_EFFICIENT_0));
    overlapRemovalDirection = portSide == ($clinit_PortSide(), NORTH_1) ? ($clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), UP) : ($clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), DOWN);
    verticalLabelAlignment = portSide == NORTH_1 ? ($clinit_VerticalLabelAlignment(), BOTTOM) : ($clinit_VerticalLabelAlignment(), TOP);
    overlapRemover = $withGap(createForDirection(overlapRemovalDirection), nodeContext.portLabelSpacingHorizontal);
    startCoordinate = portSide == NORTH_1 ? $intern_60 : $intern_61;
    for(portContext$iterator0 = portContexts.iterator_0(); portContext$iterator0.hasNext_0();){
        portContext = castTo(portContext$iterator0.next_1(), 115);
        if (!portContext.portLabelCell || portContext.portLabelCell.labels.array.length <= 0) continue;
        portSize = portContext.port.getSize();
        portPosition = portContext.portPosition;
        portLabelCell = portContext.portLabelCell;
        portLabelCellRect = portLabelCell.cellRectangle;
        portLabelCellRect.width_0 = (padding0 = portLabelCell.padding, portLabelCell.minimumContentAreaSize.x_0 + padding0.left + padding0.right);
        portLabelCellRect.height = (padding1 = portLabelCell.padding, portLabelCell.minimumContentAreaSize.y_0 + padding1.top_0 + padding1.bottom);
        if (portWithSpecialNeeds) {
            portLabelCellRect.x_0 = portPosition.x_0 - (padding = portLabelCell.padding, portLabelCell.minimumContentAreaSize.x_0 + padding.left + padding.right) - nodeContext.portLabelSpacingHorizontal;
            portWithSpecialNeeds = false;
        } else portLabelCellRect.x_0 = portPosition.x_0 + portSize.x_0 + nodeContext.portLabelSpacingHorizontal;
        requireNonNull_0(verticalLabelAlignment, 'Vertical alignment cannot be null');
        portLabelCell.verticalAlignment = verticalLabelAlignment;
        $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
        $add_3(overlapRemover.rectangleNodes, new RectangleStripOverlapRemover$RectangleNode(portLabelCellRect, $importRectangle(overlapRemover, portLabelCellRect)));
        startCoordinate = portSide == NORTH_1 ? $wnd.Math.min(startCoordinate, portPosition.y_0) : $wnd.Math.max(startCoordinate, portPosition.y_0 + portContext.port.getSize().y_0);
    }
    startCoordinate += portSide == NORTH_1 ? -nodeContext.portLabelSpacingVertical : nodeContext.portLabelSpacingVertical;
    $removeOverlaps_0((overlapRemover.startCoordinate = startCoordinate, overlapRemover));
    for(portContext$iterator = portContexts.iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        if (!portContext.portLabelCell || portContext.portLabelCell.labels.array.length <= 0) continue;
        portLabelCellRect = portContext.portLabelCell.cellRectangle;
        portLabelCellRect.x_0 -= portContext.portPosition.x_0;
        portLabelCellRect.y_0 -= portContext.portPosition.y_0;
    }
}
function placePortLabels(nodeContext, portSide) {
    var constrainedPlacement;
    constrainedPlacement = !nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), PORT_LABELS)) || nodeContext.portConstraints == ($clinit_PortConstraints(), FIXED_POS);
    nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0)) ? constrainedPlacement ? constrainedInsidePortLabelPlacement(nodeContext, portSide) : simpleInsidePortLabelPlacement(nodeContext, portSide) : nodeContext.portLabelsPlacement.contains(OUTSIDE_0) && (constrainedPlacement ? constrainedOutsidePortLabelPlacement(nodeContext, portSide) : simpleOutsidePortLabelPlacement(nodeContext, portSide));
}
function portLabelBorderOffsetForPortSide(nodeContext, portSide) {
    switch(portSide.ordinal){
        case 1:
            return nodeContext.nodeContainer.padding.top_0 + nodeContext.portLabelSpacingVertical;
        case 3:
            return nodeContext.nodeContainer.padding.bottom + nodeContext.portLabelSpacingVertical;
        case 2:
            return nodeContext.nodeContainer.padding.right + nodeContext.portLabelSpacingHorizontal;
        case 4:
            return nodeContext.nodeContainer.padding.left + nodeContext.portLabelSpacingHorizontal;
        default:
            return 0;
    }
}
function simpleInsidePortLabelPlacement(nodeContext, portSide) {
    var insideNorthOrSouthPortLabelAreaHeight, labelBorderOffset, labelHeight, padding, padding0, portBorderOffset, portContext, portContext$iterator, portLabelCell, portLabelCellRect, portLabelSpacingHorizontal, portLabelSpacingVertical, portSize;
    insideNorthOrSouthPortLabelAreaHeight = 0;
    labelBorderOffset = portLabelBorderOffsetForPortSide(nodeContext, portSide);
    portLabelSpacingHorizontal = nodeContext.portLabelSpacingHorizontal;
    portLabelSpacingVertical = nodeContext.portLabelSpacingVertical;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        if (!portContext.portLabelCell || portContext.portLabelCell.labels.array.length <= 0) continue;
        portSize = portContext.port.getSize();
        portBorderOffset = portContext.port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? $doubleValue(castToDouble(portContext.port.getProperty(PORT_BORDER_OFFSET_0))) : 0;
        portLabelCell = portContext.portLabelCell;
        portLabelCellRect = portLabelCell.cellRectangle;
        portLabelCellRect.width_0 = (padding0 = portLabelCell.padding, portLabelCell.minimumContentAreaSize.x_0 + padding0.left + padding0.right);
        portLabelCellRect.height = (padding = portLabelCell.padding, portLabelCell.minimumContentAreaSize.y_0 + padding.top_0 + padding.bottom);
        switch(portSide.ordinal){
            case 1:
                portLabelCellRect.x_0 = portContext.labelsNextToPort ? (portSize.x_0 - portLabelCellRect.width_0) / 2 : portSize.x_0 + portLabelSpacingHorizontal;
                portLabelCellRect.y_0 = portSize.y_0 + portBorderOffset + labelBorderOffset;
                $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), CENTER_0));
                $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), TOP));
                break;
            case 3:
                portLabelCellRect.x_0 = portContext.labelsNextToPort ? (portSize.x_0 - portLabelCellRect.width_0) / 2 : portSize.x_0 + portLabelSpacingHorizontal;
                portLabelCellRect.y_0 = -portBorderOffset - labelBorderOffset - portLabelCellRect.height;
                $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), CENTER_0));
                $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
                break;
            case 2:
                portLabelCellRect.x_0 = -portBorderOffset - labelBorderOffset - portLabelCellRect.width_0;
                if (portContext.labelsNextToPort) {
                    labelHeight = nodeContext.portLabelsTreatAsGroup ? portLabelCellRect.height : castTo($get_11(portLabelCell.labels, 0), 187).getSize().y_0;
                    portLabelCellRect.y_0 = (portSize.y_0 - labelHeight) / 2;
                } else portLabelCellRect.y_0 = portSize.y_0 + portLabelSpacingVertical;
                $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
                $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), CENTER_1));
                break;
            case 4:
                portLabelCellRect.x_0 = portSize.x_0 + portBorderOffset + labelBorderOffset;
                if (portContext.labelsNextToPort) {
                    labelHeight = nodeContext.portLabelsTreatAsGroup ? portLabelCellRect.height : castTo($get_11(portLabelCell.labels, 0), 187).getSize().y_0;
                    portLabelCellRect.y_0 = (portSize.y_0 - labelHeight) / 2;
                } else portLabelCellRect.y_0 = portSize.y_0 + portLabelSpacingVertical;
                $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
                $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), CENTER_1));
        }
        (portSide == ($clinit_PortSide(), NORTH_1) || portSide == SOUTH_0) && (insideNorthOrSouthPortLabelAreaHeight = $wnd.Math.max(insideNorthOrSouthPortLabelAreaHeight, portLabelCellRect.height));
    }
    insideNorthOrSouthPortLabelAreaHeight > 0 && (castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126).minimumContentAreaSize.y_0 = insideNorthOrSouthPortLabelAreaHeight);
}
function simpleOutsidePortLabelPlacement(nodeContext, portSide) {
    var alwaysAbove, labelHeight, padding, padding0, placeFirstPortDifferently, portContext, portContext$iterator, portContexts, portLabelCell, portLabelCellRect, portSize;
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    placeFirstPortDifferently = isFirstOutsidePortLabelPlacedDifferently(nodeContext, portSide);
    alwaysAbove = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), ALWAYS_OTHER_SAME_SIDE));
    for(portContext$iterator = portContexts.iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        if (!portContext.portLabelCell || portContext.portLabelCell.labels.array.length <= 0) continue;
        portSize = portContext.port.getSize();
        portLabelCell = portContext.portLabelCell;
        portLabelCellRect = portLabelCell.cellRectangle;
        portLabelCellRect.width_0 = (padding0 = portLabelCell.padding, portLabelCell.minimumContentAreaSize.x_0 + padding0.left + padding0.right);
        portLabelCellRect.height = (padding = portLabelCell.padding, portLabelCell.minimumContentAreaSize.y_0 + padding.top_0 + padding.bottom);
        switch(portSide.ordinal){
            case 1:
                if (portContext.labelsNextToPort) {
                    portLabelCellRect.x_0 = (portSize.x_0 - portLabelCellRect.width_0) / 2;
                    $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), CENTER_0));
                } else if (placeFirstPortDifferently || alwaysAbove) {
                    portLabelCellRect.x_0 = -portLabelCellRect.width_0 - nodeContext.portLabelSpacingHorizontal;
                    $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
                } else {
                    portLabelCellRect.x_0 = portSize.x_0 + nodeContext.portLabelSpacingHorizontal;
                    $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
                }
                portLabelCellRect.y_0 = -portLabelCellRect.height - nodeContext.portLabelSpacingVertical;
                $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
                break;
            case 3:
                if (portContext.labelsNextToPort) {
                    portLabelCellRect.x_0 = (portSize.x_0 - portLabelCellRect.width_0) / 2;
                    $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), CENTER_0));
                } else if (placeFirstPortDifferently || alwaysAbove) {
                    portLabelCellRect.x_0 = -portLabelCellRect.width_0 - nodeContext.portLabelSpacingHorizontal;
                    $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
                } else {
                    portLabelCellRect.x_0 = portSize.x_0 + nodeContext.portLabelSpacingHorizontal;
                    $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
                }
                portLabelCellRect.y_0 = portSize.y_0 + nodeContext.portLabelSpacingVertical;
                $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), TOP));
                break;
            case 2:
                if (portContext.labelsNextToPort) {
                    labelHeight = nodeContext.portLabelsTreatAsGroup ? portLabelCellRect.height : castTo($get_11(portLabelCell.labels, 0), 187).getSize().y_0;
                    portLabelCellRect.y_0 = (portSize.y_0 - labelHeight) / 2;
                    $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), CENTER_1));
                } else if (placeFirstPortDifferently || alwaysAbove) {
                    portLabelCellRect.y_0 = -portLabelCellRect.height - nodeContext.portLabelSpacingVertical;
                    $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
                } else {
                    portLabelCellRect.y_0 = portSize.y_0 + nodeContext.portLabelSpacingVertical;
                    $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), TOP));
                }
                portLabelCellRect.x_0 = portSize.x_0 + nodeContext.portLabelSpacingHorizontal;
                $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
                break;
            case 4:
                if (portContext.labelsNextToPort) {
                    labelHeight = nodeContext.portLabelsTreatAsGroup ? portLabelCellRect.height : castTo($get_11(portLabelCell.labels, 0), 187).getSize().y_0;
                    portLabelCellRect.y_0 = (portSize.y_0 - labelHeight) / 2;
                    $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), CENTER_1));
                } else if (placeFirstPortDifferently || alwaysAbove) {
                    portLabelCellRect.y_0 = -portLabelCellRect.height - nodeContext.portLabelSpacingVertical;
                    $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
                } else {
                    portLabelCellRect.y_0 = portSize.y_0 + nodeContext.portLabelSpacingVertical;
                    $setVerticalAlignment(portLabelCell, ($clinit_VerticalLabelAlignment(), TOP));
                }
                portLabelCellRect.x_0 = -portLabelCellRect.width_0 - nodeContext.portLabelSpacingHorizontal;
                $setHorizontalAlignment(portLabelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
        }
        placeFirstPortDifferently = false;
    }
}
function $clinit_PortPlacementCalculator() {
    $clinit_PortPlacementCalculator = emptyMethod;
    PORT_RATIO_OR_POSITION = new Property_0('portRatioOrPosition', 0);
}
function calculateVerticalPortXCoordinate(portContext, nodeWidth) {
    var port;
    port = portContext.port;
    return port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? port.getSide() == ($clinit_PortSide(), WEST_0) ? -port.getSize().x_0 - $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : nodeWidth + $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : port.getSide() == ($clinit_PortSide(), WEST_0) ? -port.getSize().x_0 : nodeWidth;
}
function placeHorizontalFixedPosPorts(nodeContext, portSide) {
    var port, portContext, portContext$iterator;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portPosition.y_0 = (port = portContext.port, port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? port.getSide() == ($clinit_PortSide(), NORTH_1) ? -port.getSize().y_0 - $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : port.getSide() == ($clinit_PortSide(), NORTH_1) ? -port.getSize().y_0 : 0);
    }
}
function placeHorizontalFixedRatioPorts(nodeContext, portSide) {
    var nodeWidth, port, portContext, portContext$iterator;
    nodeWidth = nodeContext.nodeSize.x_0;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portPosition.x_0 = nodeWidth * $doubleValue(castToDouble(portContext.port.getProperty(PORT_RATIO_OR_POSITION)));
        portContext.portPosition.y_0 = (port = portContext.port, port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? port.getSide() == ($clinit_PortSide(), NORTH_1) ? -port.getSize().y_0 - $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : port.getSide() == ($clinit_PortSide(), NORTH_1) ? -port.getSize().y_0 : 0);
    }
}
function placeHorizontalFreePorts(nodeContext, portSide) {
    var additionalSpaceBetweenPorts, availableSpace, calculatedPortPlacementWidth, currentXPos, insidePortLabelCell, insidePortLabelCellPadding, insidePortLabelCellRectangle, port, portAlignment, portContext, portContext$iterator, spaceBetweenPorts;
    if (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).isEmpty()) return;
    insidePortLabelCell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    insidePortLabelCellRectangle = insidePortLabelCell.cellRectangle;
    insidePortLabelCellPadding = insidePortLabelCell.padding;
    portAlignment = $getPortAlignment(nodeContext, portSide);
    availableSpace = insidePortLabelCellRectangle.width_0 - insidePortLabelCellPadding.left - insidePortLabelCellPadding.right;
    calculatedPortPlacementWidth = insidePortLabelCell.minimumContentAreaSize.x_0;
    currentXPos = insidePortLabelCellRectangle.x_0 + insidePortLabelCellPadding.left;
    spaceBetweenPorts = nodeContext.portPortSpacing;
    if ((portAlignment == ($clinit_PortAlignment(), DISTRIBUTED) || portAlignment == JUSTIFIED) && castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() == 1) {
        calculatedPortPlacementWidth = portAlignment == DISTRIBUTED ? calculatedPortPlacementWidth - 2 * nodeContext.portPortSpacing : calculatedPortPlacementWidth;
        portAlignment = CENTER_6;
    }
    if (availableSpace < calculatedPortPlacementWidth && !nodeContext.sizeOptions.contains(($clinit_SizeOptions(), PORTS_OVERHANG))) {
        if (portAlignment == DISTRIBUTED) {
            spaceBetweenPorts += (availableSpace - calculatedPortPlacementWidth) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() + 1);
            currentXPos += spaceBetweenPorts;
        } else spaceBetweenPorts += (availableSpace - calculatedPortPlacementWidth) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() - 1);
    } else {
        if (availableSpace < calculatedPortPlacementWidth) {
            calculatedPortPlacementWidth = portAlignment == DISTRIBUTED ? calculatedPortPlacementWidth - 2 * nodeContext.portPortSpacing : calculatedPortPlacementWidth;
            portAlignment = CENTER_6;
        }
        switch(portAlignment.ordinal){
            case 3:
                currentXPos += (availableSpace - calculatedPortPlacementWidth) / 2;
                break;
            case 4:
                currentXPos += availableSpace - calculatedPortPlacementWidth;
                break;
            case 0:
                additionalSpaceBetweenPorts = (availableSpace - calculatedPortPlacementWidth) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() + 1);
                spaceBetweenPorts += $wnd.Math.max(0, additionalSpaceBetweenPorts);
                currentXPos += spaceBetweenPorts;
                break;
            case 1:
                additionalSpaceBetweenPorts = (availableSpace - calculatedPortPlacementWidth) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() - 1);
                spaceBetweenPorts += $wnd.Math.max(0, additionalSpaceBetweenPorts);
        }
    }
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portPosition.x_0 = currentXPos + portContext.portMargin.left;
        portContext.portPosition.y_0 = (port = portContext.port, port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? port.getSide() == ($clinit_PortSide(), NORTH_1) ? -port.getSize().y_0 - $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : port.getSide() == ($clinit_PortSide(), NORTH_1) ? -port.getSize().y_0 : 0);
        currentXPos += portContext.portMargin.left + portContext.port.getSize().x_0 + portContext.portMargin.right + spaceBetweenPorts;
    }
}
function placeHorizontalPorts(nodeContext) {
    $clinit_PortPlacementCalculator();
    switch(nodeContext.portConstraints.ordinal){
        case 5:
            placeHorizontalFixedPosPorts(nodeContext, ($clinit_PortSide(), NORTH_1));
            placeHorizontalFixedPosPorts(nodeContext, SOUTH_0);
            break;
        case 4:
            placeHorizontalFixedRatioPorts(nodeContext, ($clinit_PortSide(), NORTH_1));
            placeHorizontalFixedRatioPorts(nodeContext, SOUTH_0);
            break;
        default:
            placeHorizontalFreePorts(nodeContext, ($clinit_PortSide(), NORTH_1));
            placeHorizontalFreePorts(nodeContext, SOUTH_0);
    }
}
function placeVerticalFixedPosPorts(nodeContext, portSide) {
    var nodeWidth, port, portContext, portContext$iterator;
    nodeWidth = nodeContext.nodeSize.x_0;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portPosition.x_0 = (port = portContext.port, port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? port.getSide() == ($clinit_PortSide(), WEST_0) ? -port.getSize().x_0 - $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : nodeWidth + $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : port.getSide() == ($clinit_PortSide(), WEST_0) ? -port.getSize().x_0 : nodeWidth);
    }
}
function placeVerticalFixedRatioPorts(nodeContext, portSide) {
    var nodeSize, portContext, portContext$iterator;
    nodeSize = nodeContext.nodeSize;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portPosition.x_0 = calculateVerticalPortXCoordinate(portContext, nodeSize.x_0);
        portContext.portPosition.y_0 = nodeSize.y_0 * $doubleValue(castToDouble(portContext.port.getProperty(PORT_RATIO_OR_POSITION)));
    }
}
function placeVerticalFreePorts(nodeContext, portSide) {
    var additionalSpaceBetweenPorts, availableSpace, calculatedPortPlacementHeight, currentYPos, insidePortLabelCell, insidePortLabelCellPadding, insidePortLabelCellRectangle, nodeWidth, port, portAlignment, portContext, portContext$iterator, spaceBetweenPorts;
    if (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).isEmpty()) return;
    insidePortLabelCell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    insidePortLabelCellRectangle = insidePortLabelCell.cellRectangle;
    insidePortLabelCellPadding = insidePortLabelCell.padding;
    portAlignment = $getPortAlignment(nodeContext, portSide);
    availableSpace = insidePortLabelCellRectangle.height - insidePortLabelCellPadding.top_0 - insidePortLabelCellPadding.bottom;
    calculatedPortPlacementHeight = insidePortLabelCell.minimumContentAreaSize.y_0;
    currentYPos = insidePortLabelCellRectangle.y_0 + insidePortLabelCellPadding.top_0;
    spaceBetweenPorts = nodeContext.portPortSpacing;
    nodeWidth = nodeContext.nodeSize.x_0;
    if ((portAlignment == ($clinit_PortAlignment(), DISTRIBUTED) || portAlignment == JUSTIFIED) && castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() == 1) {
        calculatedPortPlacementHeight = portAlignment == DISTRIBUTED ? calculatedPortPlacementHeight - 2 * nodeContext.portPortSpacing : calculatedPortPlacementHeight;
        portAlignment = CENTER_6;
    }
    if (availableSpace < calculatedPortPlacementHeight && !nodeContext.sizeOptions.contains(($clinit_SizeOptions(), PORTS_OVERHANG))) {
        if (portAlignment == DISTRIBUTED) {
            spaceBetweenPorts += (availableSpace - calculatedPortPlacementHeight) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() + 1);
            currentYPos += spaceBetweenPorts;
        } else spaceBetweenPorts += (availableSpace - calculatedPortPlacementHeight) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() - 1);
    } else {
        if (availableSpace < calculatedPortPlacementHeight) {
            calculatedPortPlacementHeight = portAlignment == DISTRIBUTED ? calculatedPortPlacementHeight - 2 * nodeContext.portPortSpacing : calculatedPortPlacementHeight;
            portAlignment = CENTER_6;
        }
        switch(portAlignment.ordinal){
            case 3:
                currentYPos += (availableSpace - calculatedPortPlacementHeight) / 2;
                break;
            case 4:
                currentYPos += availableSpace - calculatedPortPlacementHeight;
                break;
            case 0:
                additionalSpaceBetweenPorts = (availableSpace - calculatedPortPlacementHeight) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() + 1);
                spaceBetweenPorts += $wnd.Math.max(0, additionalSpaceBetweenPorts);
                currentYPos += spaceBetweenPorts;
                break;
            case 1:
                additionalSpaceBetweenPorts = (availableSpace - calculatedPortPlacementHeight) / (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).size_1() - 1);
                spaceBetweenPorts += $wnd.Math.max(0, additionalSpaceBetweenPorts);
        }
    }
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portPosition.x_0 = (port = portContext.port, port.hasProperty(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0)) ? port.getSide() == ($clinit_PortSide(), WEST_0) ? -port.getSize().x_0 - $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : nodeWidth + $doubleValue(castToDouble(port.getProperty(PORT_BORDER_OFFSET_0))) : port.getSide() == ($clinit_PortSide(), WEST_0) ? -port.getSize().x_0 : nodeWidth);
        portContext.portPosition.y_0 = currentYPos + portContext.portMargin.top_0;
        currentYPos += portContext.portMargin.top_0 + portContext.port.getSize().y_0 + portContext.portMargin.bottom + spaceBetweenPorts;
    }
}
function placeVerticalPorts(nodeContext) {
    $clinit_PortPlacementCalculator();
    switch(nodeContext.portConstraints.ordinal){
        case 5:
            placeVerticalFixedPosPorts(nodeContext, ($clinit_PortSide(), EAST_0));
            placeVerticalFixedPosPorts(nodeContext, WEST_0);
            break;
        case 4:
            placeVerticalFixedRatioPorts(nodeContext, ($clinit_PortSide(), EAST_0));
            placeVerticalFixedRatioPorts(nodeContext, WEST_0);
            break;
        default:
            placeVerticalFreePorts(nodeContext, ($clinit_PortSide(), EAST_0));
            placeVerticalFreePorts(nodeContext, WEST_0);
    }
}
var PORT_RATIO_OR_POSITION;
function calculateVerticalNodeSizeRequiredByFixedPosPorts(nodeContext, portSide) {
    var bottommostPortBorder, cell, portContext, portContext$iterator;
    bottommostPortBorder = 0;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        bottommostPortBorder = $wnd.Math.max(bottommostPortBorder, portContext.portPosition.y_0 + portContext.port.getSize().y_0);
    }
    cell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    cell.padding.top_0 = 0;
    cell.minimumContentAreaSize.y_0 = bottommostPortBorder;
}
function calculateVerticalNodeSizeRequiredByFixedRatioPorts(nodeContext, portSide) {
    var cell, currentPortContext, currentPortHeight, currentPortRatio, minHeight, portContextIterator, portContexts, portLabelsInside, previousPortContext, previousPortHeight, previousPortRatio, requiredSpace;
    cell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    if (portContexts.isEmpty()) {
        cell.padding.top_0 = 0;
        cell.padding.bottom = 0;
        return;
    }
    portLabelsInside = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0));
    minHeight = 0;
    nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), PORT_LABELS)) && setupPortMargins_0(nodeContext, portSide);
    portContextIterator = portContexts.iterator_0();
    previousPortContext = null;
    previousPortRatio = 0;
    previousPortHeight = 0;
    while(portContextIterator.hasNext_0()){
        currentPortContext = castTo(portContextIterator.next_1(), 115);
        currentPortRatio = $doubleValue(castToDouble(currentPortContext.port.getProperty(($clinit_PortPlacementCalculator(), PORT_RATIO_OR_POSITION))));
        currentPortHeight = currentPortContext.port.getSize().y_0;
        if (!previousPortContext) !!nodeContext.surroundingPortMargins && nodeContext.surroundingPortMargins.top_0 > 0 && (minHeight = $wnd.Math.max(minHeight, minSizeRequiredToRespectSpacing(nodeContext.surroundingPortMargins.top_0 + currentPortContext.portMargin.top_0, currentPortRatio)));
        else {
            requiredSpace = previousPortHeight + previousPortContext.portMargin.bottom + nodeContext.portPortSpacing + currentPortContext.portMargin.top_0;
            minHeight = $wnd.Math.max(minHeight, ($clinit_DoubleMath(), checkNonNegative($intern_93), $wnd.Math.abs(previousPortRatio - currentPortRatio) <= $intern_93 || previousPortRatio == currentPortRatio || isNaN(previousPortRatio) && isNaN(currentPortRatio) ? 0 : requiredSpace / (currentPortRatio - previousPortRatio)));
        }
        previousPortContext = currentPortContext;
        previousPortRatio = currentPortRatio;
        previousPortHeight = currentPortHeight;
    }
    if (!!nodeContext.surroundingPortMargins && nodeContext.surroundingPortMargins.bottom > 0) {
        requiredSpace = previousPortHeight + nodeContext.surroundingPortMargins.bottom;
        portLabelsInside && (requiredSpace += previousPortContext.portMargin.bottom);
        minHeight = $wnd.Math.max(minHeight, ($clinit_DoubleMath(), checkNonNegative($intern_93), $wnd.Math.abs(previousPortRatio - 1) <= $intern_93 || previousPortRatio == 1 || isNaN(previousPortRatio) && isNaN(1) ? 0 : requiredSpace / (1 - previousPortRatio)));
    }
    cell.padding.top_0 = 0;
    cell.minimumContentAreaSize.y_0 = minHeight;
}
function calculateVerticalNodeSizeRequiredByFreePorts(nodeContext, portSide) {
    var cell, height;
    cell = castTo($get_14(nodeContext.insidePortLabelCells, portSide), 126);
    if (castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).isEmpty()) {
        cell.padding.top_0 = 0;
        cell.padding.bottom = 0;
        return;
    }
    cell.padding.top_0 = nodeContext.surroundingPortMargins.top_0;
    cell.padding.bottom = nodeContext.surroundingPortMargins.bottom;
    nodeContext.sizeConstraints.contains(($clinit_SizeConstraint(), PORT_LABELS)) && setupPortMargins_0(nodeContext, portSide);
    height = portHeightPlusPortPortSpacing(nodeContext, portSide);
    $getPortAlignment(nodeContext, portSide) == ($clinit_PortAlignment(), DISTRIBUTED) && (height += 2 * nodeContext.portPortSpacing);
    cell.minimumContentAreaSize.y_0 = height;
}
function calculateVerticalPortPlacementSize(nodeContext) {
    switch(nodeContext.portConstraints.ordinal){
        case 5:
            calculateVerticalNodeSizeRequiredByFixedPosPorts(nodeContext, ($clinit_PortSide(), EAST_0));
            calculateVerticalNodeSizeRequiredByFixedPosPorts(nodeContext, WEST_0);
            break;
        case 4:
            calculateVerticalNodeSizeRequiredByFixedRatioPorts(nodeContext, ($clinit_PortSide(), EAST_0));
            calculateVerticalNodeSizeRequiredByFixedRatioPorts(nodeContext, WEST_0);
            break;
        default:
            calculateVerticalNodeSizeRequiredByFreePorts(nodeContext, ($clinit_PortSide(), EAST_0));
            calculateVerticalNodeSizeRequiredByFreePorts(nodeContext, WEST_0);
    }
}
function computeVerticalPortMargins(nodeContext, portSide) {
    var firstLabelHeight, firstLabelOverhang, labelHeight, labelsBounds, overhang, portContext, portContext$iterator, portHeight;
    for(portContext$iterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        labelHeight = portContext.portLabelCell ? $getMinimumHeight_0(portContext.portLabelCell) : 0;
        if (labelHeight > 0) {
            if (portContext.labelsNextToPort) {
                portHeight = portContext.port.getSize().y_0;
                if (labelHeight > portHeight) {
                    if (nodeContext.portLabelsTreatAsGroup || portContext.portLabelCell.labels.array.length == 1) {
                        overhang = (labelHeight - portHeight) / 2;
                        portContext.portMargin.top_0 = overhang;
                        portContext.portMargin.bottom = overhang;
                    } else {
                        firstLabelHeight = castTo($get_11(portContext.portLabelCell.labels, 0), 187).getSize().y_0;
                        firstLabelOverhang = (firstLabelHeight - portHeight) / 2;
                        portContext.portMargin.top_0 = $wnd.Math.max(0, firstLabelOverhang);
                        portContext.portMargin.bottom = labelHeight - firstLabelOverhang - portHeight;
                    }
                }
            } else portContext.portMargin.bottom = nodeContext.portLabelSpacingVertical + labelHeight;
        } else if (isFixed(nodeContext.portLabelsPlacement)) {
            labelsBounds = getLabelsBounds(portContext.port);
            labelsBounds.y_0 < 0 && (portContext.portMargin.top_0 = -labelsBounds.y_0);
            labelsBounds.y_0 + labelsBounds.height > portContext.port.getSize().y_0 && (portContext.portMargin.bottom = labelsBounds.y_0 + labelsBounds.height - portContext.port.getSize().y_0);
        }
    }
}
function portHeightPlusPortPortSpacing(nodeContext, portSide) {
    var portContext, portContextIterator, result;
    result = 0;
    portContextIterator = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83).iterator_0();
    while(portContextIterator.hasNext_0()){
        portContext = castTo(portContextIterator.next_1(), 115);
        result += portContext.portMargin.top_0 + portContext.port.getSize().y_0 + portContext.portMargin.bottom;
        portContextIterator.hasNext_0() && (result += nodeContext.portPortSpacing);
    }
    return result;
}
function setupPortMargins_0(nodeContext, portSide) {
    var alwaysSameSide, alwaysSameSideAbove, bottommostPortContext, portContextIterator, portContexts, portLabelsOutside, spaceEfficient, spaceEfficientPortLabels, topmostPortContext, uniformPortSpacing;
    portContexts = castTo(castTo($get(nodeContext.portContexts, portSide), 22), 83);
    portLabelsOutside = nodeContext.portLabelsPlacement.contains(($clinit_PortLabelPlacement(), OUTSIDE_0));
    alwaysSameSide = nodeContext.portLabelsPlacement.contains(ALWAYS_SAME_SIDE);
    alwaysSameSideAbove = nodeContext.portLabelsPlacement.contains(ALWAYS_OTHER_SAME_SIDE);
    spaceEfficient = nodeContext.portLabelsPlacement.contains(SPACE_EFFICIENT_0);
    uniformPortSpacing = nodeContext.sizeOptions.contains(($clinit_SizeOptions(), UNIFORM_PORT_SPACING));
    spaceEfficientPortLabels = !alwaysSameSide && !alwaysSameSideAbove && (spaceEfficient || portContexts.size_1() == 2);
    computeVerticalPortMargins(nodeContext, portSide);
    topmostPortContext = null;
    bottommostPortContext = null;
    if (portLabelsOutside) {
        portContextIterator = portContexts.iterator_0();
        topmostPortContext = castTo(portContextIterator.next_1(), 115);
        bottommostPortContext = topmostPortContext;
        while(portContextIterator.hasNext_0())bottommostPortContext = castTo(portContextIterator.next_1(), 115);
        topmostPortContext.portMargin.top_0 = 0;
        bottommostPortContext.portMargin.bottom = 0;
        spaceEfficientPortLabels && !topmostPortContext.labelsNextToPort && (topmostPortContext.portMargin.bottom = 0);
    }
    if (uniformPortSpacing) {
        unifyPortMargins_0(portContexts);
        if (portLabelsOutside) {
            topmostPortContext.portMargin.top_0 = 0;
            bottommostPortContext.portMargin.bottom = 0;
        }
    }
}
function unifyPortMargins_0(portContexts) {
    var maxBottom, maxTop, portContext, portContext$iterator, portContext$iterator0;
    maxTop = 0;
    maxBottom = 0;
    for(portContext$iterator0 = portContexts.iterator_0(); portContext$iterator0.hasNext_0();){
        portContext = castTo(portContext$iterator0.next_1(), 115);
        maxTop = $wnd.Math.max(maxTop, portContext.portMargin.top_0);
        maxBottom = $wnd.Math.max(maxBottom, portContext.portMargin.bottom);
    }
    for(portContext$iterator = portContexts.iterator_0(); portContext$iterator.hasNext_0();){
        portContext = castTo(portContext$iterator.next_1(), 115);
        portContext.portMargin.top_0 = maxTop;
        portContext.portMargin.bottom = maxBottom;
    }
}
function $removeOverlaps(overlapRemover) {
    var alreadyPlacedNodes, currNode, currNode$iterator, currRect, overlapNode, overlapNode$iterator, overlapRect, stripSize, verticalGap, yPos;
    verticalGap = overlapRemover.gapVertical;
    alreadyPlacedNodes = new HashSet;
    stripSize = 0;
    for(currNode$iterator = new ArrayList$1(overlapRemover.rectangleNodes); currNode$iterator.i < currNode$iterator.this$01.array.length;){
        currNode = castTo($next_6(currNode$iterator), 225);
        yPos = 0;
        $sort_0(currNode.overlappingNodes, new GreedyRectangleStripOverlapRemover$0methodref$compareByYCoordinate$Type);
        for(overlapNode$iterator = $listIterator_2(currNode.overlappingNodes, 0); overlapNode$iterator.currentNode != overlapNode$iterator.this$01.tail;){
            overlapNode = castTo($next_9(overlapNode$iterator), 225);
            if (alreadyPlacedNodes.map_0.containsKey(overlapNode)) {
                currRect = currNode.rectangle;
                overlapRect = overlapNode.rectangle;
                yPos < overlapRect.y_0 + overlapRect.height + verticalGap && yPos + currRect.height + verticalGap > overlapRect.y_0 && (yPos = overlapRect.y_0 + overlapRect.height + verticalGap);
            }
        }
        currNode.rectangle.y_0 = yPos;
        alreadyPlacedNodes.map_0.put(currNode, alreadyPlacedNodes);
        stripSize = $wnd.Math.max(stripSize, currNode.rectangle.y_0 + currNode.rectangle.height);
    }
    return stripSize;
}
function GreedyRectangleStripOverlapRemover() {}
function compareByYCoordinate(node1, node2) {
    return compare_4(node1.rectangle.y_0, node2.rectangle.y_0);
}
defineClass(1848, 1, {}, GreedyRectangleStripOverlapRemover);
var Lorg_eclipse_elk_alg_common_overlaps_GreedyRectangleStripOverlapRemover_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'GreedyRectangleStripOverlapRemover', 1848);
function GreedyRectangleStripOverlapRemover$0methodref$compareByYCoordinate$Type() {}
defineClass(1849, 1, $intern_88, GreedyRectangleStripOverlapRemover$0methodref$compareByYCoordinate$Type);
_.compare_1 = function compare_17(arg0, arg1) {
    return compareByYCoordinate(castTo(arg0, 225), castTo(arg1, 225));
};
_.equals_0 = function equals_69(other) {
    return this === other;
};
_.reversed = function reversed_9() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_overlaps_GreedyRectangleStripOverlapRemover$0methodref$compareByYCoordinate$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'GreedyRectangleStripOverlapRemover/0methodref$compareByYCoordinate$Type', 1849);
function $computeOverlaps(this$static) {
    var currNode, currNode$iterator, intersectingNode, intersectingNode$iterator, intersectingNodes, intersectingRectangle, scanlinePos;
    intersectingNodes = new TreeSet_0(castTo(checkNotNull(new RectangleStripOverlapRemover$1methodref$compareRightRectangleBorders$Type), 51));
    scanlinePos = $intern_61;
    for(currNode$iterator = new ArrayList$1(this$static.rectangleNodes); currNode$iterator.i < currNode$iterator.this$01.array.length;){
        currNode = castTo($next_6(currNode$iterator), 225);
        scanlinePos = currNode.rectangle.x_0;
        while(intersectingNodes.map_0.size_1() != 0){
            intersectingRectangle = castTo(intersectingNodes.map_0.firstKey(), 225);
            if (intersectingRectangle.rectangle.x_0 + intersectingRectangle.rectangle.width_0 < scanlinePos) intersectingNodes.map_0.remove_0(intersectingRectangle);
            else break;
        }
        for(intersectingNode$iterator = intersectingNodes.map_0.keySet_0().iterator_0(); intersectingNode$iterator.hasNext_0();){
            intersectingNode = castTo(intersectingNode$iterator.next_1(), 225);
            $add_7(intersectingNode.overlappingNodes, currNode);
            $add_7(currNode.overlappingNodes, intersectingNode);
        }
        intersectingNodes.map_0.put(currNode, ($clinit_Boolean(), FALSE_0));
    }
}
function $exportRectangle(this$static, rectangleNode) {
    var originalRectangle, rectangle;
    rectangle = rectangleNode.rectangle;
    originalRectangle = rectangleNode.originalRectangle;
    switch(this$static.overlapRemovalDirection.ordinal){
        case 0:
            originalRectangle.y_0 = this$static.startCoordinate - rectangle.height - rectangle.y_0;
            break;
        case 1:
            originalRectangle.y_0 += this$static.startCoordinate;
            break;
        case 2:
            originalRectangle.x_0 = this$static.startCoordinate - rectangle.height - rectangle.y_0;
            break;
        case 3:
            originalRectangle.x_0 = this$static.startCoordinate + rectangle.y_0;
    }
}
function $importRectangle(this$static, rectangle) {
    switch(this$static.overlapRemovalDirection.ordinal){
        case 0:
        case 1:
            return rectangle;
        case 2:
        case 3:
            return new ElkRectangle_0(rectangle.y_0, 0, rectangle.height, rectangle.width_0);
        default:
            return null;
    }
}
function $removeOverlaps_0(this$static) {
    var stripSize;
    !this$static.overlapRemovalStrategy && (this$static.overlapRemovalStrategy = new GreedyRectangleStripOverlapRemover);
    $sort(this$static.rectangleNodes, new RectangleStripOverlapRemover$0methodref$compareLeftRectangleBorders$Type);
    $computeOverlaps(this$static);
    stripSize = $removeOverlaps(this$static);
    $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.rectangleNodes, 16)), new RectangleStripOverlapRemover$lambda$1$Type(this$static));
    return stripSize;
}
function $withGap(this$static, theVerticalGap) {
    this$static.gapVertical = theVerticalGap;
    return this$static;
}
function $withStartCoordinate(this$static, coordinate) {
    this$static.startCoordinate = coordinate;
    return this$static;
}
function RectangleStripOverlapRemover() {
    this.rectangleNodes = new ArrayList;
}
function compareLeftRectangleBorders(rn1, rn2) {
    return compare_4(rn1.rectangle.x_0, rn2.rectangle.x_0);
}
function compareRightRectangleBorders(rn1, rn2) {
    return compare_4(rn1.rectangle.x_0 + rn1.rectangle.width_0, rn2.rectangle.x_0 + rn2.rectangle.width_0);
}
function createForDirection(direction) {
    var remover;
    remover = new RectangleStripOverlapRemover;
    remover.overlapRemovalDirection = direction;
    return remover;
}
defineClass(1795, 1, {}, RectangleStripOverlapRemover);
_.gapVertical = 5;
_.startCoordinate = 0;
var Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'RectangleStripOverlapRemover', 1795);
function RectangleStripOverlapRemover$0methodref$compareLeftRectangleBorders$Type() {}
defineClass(1796, 1, $intern_88, RectangleStripOverlapRemover$0methodref$compareLeftRectangleBorders$Type);
_.compare_1 = function compare_18(arg0, arg1) {
    return compareLeftRectangleBorders(castTo(arg0, 225), castTo(arg1, 225));
};
_.equals_0 = function equals_70(other) {
    return this === other;
};
_.reversed = function reversed_10() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$0methodref$compareLeftRectangleBorders$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'RectangleStripOverlapRemover/0methodref$compareLeftRectangleBorders$Type', 1796);
function RectangleStripOverlapRemover$1methodref$compareRightRectangleBorders$Type() {}
defineClass(1798, 1, $intern_88, RectangleStripOverlapRemover$1methodref$compareRightRectangleBorders$Type);
_.compare_1 = function compare_19(arg0, arg1) {
    return compareRightRectangleBorders(castTo(arg0, 225), castTo(arg1, 225));
};
_.equals_0 = function equals_71(other) {
    return this === other;
};
_.reversed = function reversed_11() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$1methodref$compareRightRectangleBorders$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'RectangleStripOverlapRemover/1methodref$compareRightRectangleBorders$Type', 1798);
function $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection() {
    $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection = emptyMethod;
    UP = new RectangleStripOverlapRemover$OverlapRemovalDirection('UP', 0);
    DOWN = new RectangleStripOverlapRemover$OverlapRemovalDirection('DOWN', 1);
    LEFT_0 = new RectangleStripOverlapRemover$OverlapRemovalDirection('LEFT', 2);
    RIGHT_0 = new RectangleStripOverlapRemover$OverlapRemovalDirection('RIGHT', 3);
}
function RectangleStripOverlapRemover$OverlapRemovalDirection(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_16(name_0) {
    $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection();
    return valueOf(($clinit_RectangleStripOverlapRemover$OverlapRemovalDirection$Map(), $MAP_6), name_0);
}
function values_24() {
    $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$OverlapRemovalDirection_2_classLit, 1), $intern_36, 406, 0, [
        UP,
        DOWN,
        LEFT_0,
        RIGHT_0
    ]);
}
defineClass(406, 23, {
    3: 1,
    34: 1,
    23: 1,
    406: 1
}, RectangleStripOverlapRemover$OverlapRemovalDirection);
var DOWN, LEFT_0, RIGHT_0, UP;
var Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$OverlapRemovalDirection_2_classLit = createForEnum('org.eclipse.elk.alg.common.overlaps', 'RectangleStripOverlapRemover/OverlapRemovalDirection', 406, Ljava_lang_Enum_2_classLit, values_24, valueOf_16);
function $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection$Map() {
    $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection$Map = emptyMethod;
    $MAP_6 = createValueOfMap(($clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$OverlapRemovalDirection_2_classLit, 1), $intern_36, 406, 0, [
        UP,
        DOWN,
        LEFT_0,
        RIGHT_0
    ])));
}
var $MAP_6;
function RectangleStripOverlapRemover$RectangleNode(originalRectangle, rectangle) {
    this.overlappingNodes = new LinkedList;
    this.originalRectangle = originalRectangle;
    this.rectangle = rectangle;
}
defineClass(225, 1, {
    225: 1
}, RectangleStripOverlapRemover$RectangleNode);
var Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$RectangleNode_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'RectangleStripOverlapRemover/RectangleNode', 225);
function RectangleStripOverlapRemover$lambda$1$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1797, 1, $intern_19, RectangleStripOverlapRemover$lambda$1$Type);
_.accept = function accept_49(arg0) {
    $exportRectangle(this.$$outer_0, castTo(arg0, 225));
};
var Lorg_eclipse_elk_alg_common_overlaps_RectangleStripOverlapRemover$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.overlaps', 'RectangleStripOverlapRemover/lambda$1$Type', 1797);
function compact_0(tree, orthogonal) {
    svg_0 = new SVGImage;
    orthogonalCompaction = orthogonal;
    root_0 = tree;
    castTo(root_0.node, 68);
    drawTree(root_0, svg_0, null);
    compactTree(root_0);
}
function compactTree(tree) {
    var child, child$iterator, compactionVector, minUnderlap, rc, rt;
    $forEach_1(tree.children, new DepthFirstCompaction$0methodref$compactTree$Type);
    for(child$iterator = new ArrayList$1(tree.children); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 224);
        compactionVector = $sub_0($clone_1(castTo(tree.node, 68).vertex), castTo(child.node, 68).vertex);
        if (orthogonalCompaction) {
            rt = castTo(tree.node, 68).rect;
            rc = castTo(child.node, 68).rect;
            if ($wnd.Math.abs(compactionVector.x_0) >= $wnd.Math.abs(compactionVector.y_0)) {
                compactionVector.y_0 = 0;
                rc.y_0 + rc.height > rt.y_0 && rc.y_0 < rt.y_0 + rt.height && $scaleToLength(compactionVector, $wnd.Math.max(rt.x_0 - (rc.x_0 + rc.width_0), rc.x_0 - (rt.x_0 + rt.width_0)));
            } else {
                compactionVector.x_0 = 0;
                rc.x_0 + rc.width_0 > rt.x_0 && rc.x_0 < rt.x_0 + rt.width_0 && $scaleToLength(compactionVector, $wnd.Math.max(rt.y_0 - (rc.y_0 + rc.height), rc.y_0 - (rt.y_0 + rt.height)));
            }
        } else $scaleToLength(compactionVector, $underlap(castTo(tree.node, 68), castTo(child.node, 68)));
        minUnderlap = $wnd.Math.sqrt(compactionVector.x_0 * compactionVector.x_0 + compactionVector.y_0 * compactionVector.y_0);
        minUnderlap = getMinUnderlap(root_0, child, minUnderlap, compactionVector);
        $scaleToLength(compactionVector, minUnderlap);
        $translate(castTo(child.node, 68), compactionVector);
        $forEach_1(child.children, new DepthFirstCompaction$lambda$1$Type(compactionVector));
        castTo(root_0.node, 68);
        drawTree(root_0, svg_0, child);
    }
}
function drawTree(t, svgImage, mark) {
    castTo(t.node, 68);
    castTo(t.node, 68);
    castTo(t.node, 68);
    $forEach_1(t.children, new DepthFirstCompaction$lambda$2$Type(mark, svgImage, t));
}
function getMinUnderlap(tree, child, currentMinUnderlap, compactionVector) {
    var c, c$iterator, minUnderlap;
    minUnderlap = $wnd.Math.min(currentMinUnderlap, minUnderlapWithSubtree(castTo(tree.node, 68), child, currentMinUnderlap, compactionVector));
    for(c$iterator = new ArrayList$1(tree.children); c$iterator.i < c$iterator.this$01.array.length;){
        c = castTo($next_6(c$iterator), 224);
        c != child && (minUnderlap = $wnd.Math.min(minUnderlap, getMinUnderlap(c, child, minUnderlap, compactionVector)));
    }
    return minUnderlap;
}
function lambda$1_3(compactionVector_0, c_1) {
    $translate(castTo(c_1.node, 68), compactionVector_0);
    $forEach_1(c_1.children, new DepthFirstCompaction$lambda$1$Type(compactionVector_0));
}
function lambda$2_0(mark_0, svgImage_1, t_2, c_3) {
    c_3 == mark_0 ? (castTo(t_2.node, 68), castTo(t_2.node, 68), castTo(c_3.node, 68), castTo(c_3.node, 68).vertex.y_0) : (castTo(t_2.node, 68), castTo(t_2.node, 68), castTo(c_3.node, 68), castTo(c_3.node, 68).vertex.y_0);
    drawTree(c_3, svgImage_1, mark_0);
}
function minUnderlapWithSubtree(r, tree, currentMinUnderlap, compactionVector) {
    var c, child, child$iterator, minUnderlap;
    minUnderlap = currentMinUnderlap;
    for(child$iterator = new ArrayList$1(tree.children); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 224);
        c = castTo(child.node, 68);
        if (fuzzyCompare(r.rect.x_0, c.rect.x_0 + c.rect.width_0) <= 0 && fuzzyCompare(c.rect.x_0, r.rect.x_0 + r.rect.width_0) <= 0 && fuzzyCompare(r.rect.y_0, c.rect.y_0 + c.rect.height) <= 0 && fuzzyCompare(c.rect.y_0, r.rect.y_0 + r.rect.height) <= 0) {
            if (fuzzyCompare(c.rect.x_0, r.rect.x_0 + r.rect.width_0) == 0 && compactionVector.x_0 < 0 || fuzzyCompare(c.rect.x_0 + c.rect.width_0, r.rect.x_0) == 0 && compactionVector.x_0 > 0 || fuzzyCompare(c.rect.y_0, r.rect.y_0 + r.rect.height) == 0 && compactionVector.y_0 < 0 || fuzzyCompare(c.rect.y_0 + c.rect.height, r.rect.y_0) == 0 && compactionVector.y_0 > 0) {
                minUnderlap = 0;
                break;
            }
        } else minUnderlap = $wnd.Math.min(minUnderlap, $distance(r, c, compactionVector));
        minUnderlap = $wnd.Math.min(minUnderlap, minUnderlapWithSubtree(r, child, minUnderlap, compactionVector));
    }
    return minUnderlap;
}
var orthogonalCompaction = false, root_0, svg_0;
function DepthFirstCompaction$0methodref$compactTree$Type() {}
defineClass(1774, 1, $intern_19, DepthFirstCompaction$0methodref$compactTree$Type);
_.accept = function accept_50(arg0) {
    compactTree(castTo(arg0, 224));
};
var Lorg_eclipse_elk_alg_common_spore_DepthFirstCompaction$0methodref$compactTree$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'DepthFirstCompaction/0methodref$compactTree$Type', 1774);
function DepthFirstCompaction$lambda$1$Type(compactionVector_0) {
    this.compactionVector_0 = compactionVector_0;
}
defineClass(804, 1, $intern_19, DepthFirstCompaction$lambda$1$Type);
_.accept = function accept_51(arg0) {
    lambda$1_3(this.compactionVector_0, castTo(arg0, 224));
};
var Lorg_eclipse_elk_alg_common_spore_DepthFirstCompaction$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'DepthFirstCompaction/lambda$1$Type', 804);
function DepthFirstCompaction$lambda$2$Type(mark_0, svgImage_1, t_2) {
    this.mark_0 = mark_0;
    this.svgImage_1 = svgImage_1;
    this.t_2 = t_2;
}
defineClass(1775, 1, $intern_19, DepthFirstCompaction$lambda$2$Type);
_.accept = function accept_52(arg0) {
    lambda$2_0(this.mark_0, this.svgImage_1, this.t_2, castTo(arg0, 224));
};
var Lorg_eclipse_elk_alg_common_spore_DepthFirstCompaction$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'DepthFirstCompaction/lambda$2$Type', 1775);
function $clinit_InternalProperties() {
    $clinit_InternalProperties = emptyMethod;
    DEBUG_SVG = new Property_0('debugSVG', ($clinit_Boolean(), false));
    OVERLAPS_EXISTED = new Property_0('overlapsExisted', true);
}
var DEBUG_SVG, OVERLAPS_EXISTED;
function $distance(this$static, other, v) {
    var distance, e1, e1$iterator, e2, e2$iterator, result;
    result = $intern_60;
    for(e1$iterator = new ArrayList$1(getRectEdges(this$static.rect)); e1$iterator.i < e1$iterator.this$01.array.length;){
        e1 = castTo($next_6(e1$iterator), 176);
        for(e2$iterator = new ArrayList$1(getRectEdges(other.rect)); e2$iterator.i < e2$iterator.this$01.array.length;){
            e2 = castTo($next_6(e2$iterator), 176);
            distance = distance_0(e1.u, e1.v, e2.u, e2.v, v);
            result = $wnd.Math.min(result, distance);
        }
    }
    return result;
}
function $setCenterPosition(this$static, p) {
    $translate(this$static, $sub_0(new KVector_1(p.x_0, p.y_0), this$static.vertex));
}
function $translate(this$static, v) {
    $add_19(this$static.vertex, v);
    this$static.rect.x_0 += v.x_0;
    this$static.rect.y_0 += v.y_0;
}
function $underlap(this$static, other) {
    var hScale, horizontalCenterDistance, horizontalUnderlap, scale, vScale, verticalCenterDistance, verticalUnderlap;
    horizontalCenterDistance = $wnd.Math.abs($getCenter(this$static.rect).x_0 - $getCenter(other.rect).x_0);
    verticalCenterDistance = $wnd.Math.abs($getCenter(this$static.rect).y_0 - $getCenter(other.rect).y_0);
    horizontalUnderlap = 0;
    verticalUnderlap = 0;
    hScale = 1;
    vScale = 1;
    if (horizontalCenterDistance > this$static.rect.width_0 / 2 + other.rect.width_0 / 2) {
        horizontalUnderlap = $wnd.Math.min($wnd.Math.abs(this$static.rect.x_0 - (other.rect.x_0 + other.rect.width_0)), $wnd.Math.abs(this$static.rect.x_0 + this$static.rect.width_0 - other.rect.x_0));
        hScale = 1 - horizontalUnderlap / horizontalCenterDistance;
    }
    if (verticalCenterDistance > this$static.rect.height / 2 + other.rect.height / 2) {
        verticalUnderlap = $wnd.Math.min($wnd.Math.abs(this$static.rect.y_0 - (other.rect.y_0 + other.rect.height)), $wnd.Math.abs(this$static.rect.y_0 + this$static.rect.height - other.rect.y_0));
        vScale = 1 - verticalUnderlap / verticalCenterDistance;
    }
    scale = $wnd.Math.min(hScale, vScale);
    return (1 - scale) * $wnd.Math.sqrt(horizontalCenterDistance * horizontalCenterDistance + verticalCenterDistance * verticalCenterDistance);
}
function Node_0(v, r) {
    this.originalVertex = v;
    this.vertex = $clone_1(this.originalVertex);
    this.rect = new ElkRectangle_1(r);
}
defineClass(68, 1, {
    68: 1
}, Node_0);
var Lorg_eclipse_elk_alg_common_spore_Node_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'Node', 68);
function $overlap_0(n1, n2) {
    if (!n1 || !n2 || n1 == n2) return false;
    return fuzzyCompare(n1.rect.x_0, n2.rect.x_0 + n2.rect.width_0) < 0 && fuzzyCompare(n2.rect.x_0, n1.rect.x_0 + n1.rect.width_0) < 0;
}
function $sweep_0(this$static, nodes) {
    var n, n$iterator, overlapsScanlineHandler, points;
    points = new ArrayList;
    for(n$iterator = new ArrayList$1(nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 68);
        $add_3(points, new ScanlineOverlapCheck$Timestamp(n, true));
        $add_3(points, new ScanlineOverlapCheck$Timestamp(n, false));
    }
    overlapsScanlineHandler = new ScanlineOverlapCheck$OverlapsScanlineHandler(this$static);
    overlapsScanlineHandler.intervalsSortLeft.map_0.clear_0();
    execute(points, this$static.overlapsScanlineComparator, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_compaction_Scanline$EventHandler_2_classLit, 1), $intern_2, 678, 0, [
        overlapsScanlineHandler
    ])));
}
function ScanlineOverlapCheck(oh) {
    this.overlapsScanlineComparator = new ScanlineOverlapCheck$lambda$0$Type;
    this.overlapHandler = oh;
}
function lambda$0_12(p1_0, p2_1) {
    var cmp, y1, y2;
    y1 = p1_0.node.rect.y_0;
    p1_0.low || (y1 += p1_0.node.rect.height);
    y2 = p2_1.node.rect.y_0;
    p2_1.low || (y2 += p2_1.node.rect.height);
    cmp = compare_4(y1, y2);
    if (cmp == 0) {
        if (!p1_0.low && p2_1.low) return -1;
        else if (!p2_1.low && p1_0.low) return 1;
    }
    return cmp;
}
defineClass(1174, 1, {}, ScanlineOverlapCheck);
var Lorg_eclipse_elk_alg_common_spore_ScanlineOverlapCheck_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'ScanlineOverlapCheck', 1174);
function $handle_0(this$static, p) {
    p.low ? $insert_3(this$static, p) : $remove_28(this$static.intervalsSortLeft, p.node);
}
function $insert_3(this$static, p) {
    var other, other$iterator, overlapsFound, success;
    success = $add_10(this$static.intervalsSortLeft, p.node);
    if (!success) throw toJs(new IllegalStateException_0('Invalid hitboxes for scanline overlap calculation.'));
    overlapsFound = false;
    for(other$iterator = this$static.intervalsSortLeft.map_0.keySet_0().iterator_0(); other$iterator.hasNext_0();){
        other = castTo(other$iterator.next_1(), 68);
        if ($overlap_0(p.node, other)) {
            $handle_4(this$static.this$01.overlapHandler, p.node, other);
            overlapsFound = true;
        } else {
            if (overlapsFound) break;
        }
    }
}
function ScanlineOverlapCheck$OverlapsScanlineHandler(this$0) {
    this.this$01 = this$0;
    this.intervalsSortLeft = new TreeSet_0(castTo(checkNotNull(new ScanlineOverlapCheck$OverlapsScanlineHandler$lambda$0$Type), 51));
}
function lambda$0_13(n1_0, n2_1) {
    var cmp;
    cmp = compare_4(n1_0.rect.x_0, n2_1.rect.x_0);
    if (cmp != 0) return cmp;
    cmp = compare_4(n1_0.originalVertex.x_0, n2_1.originalVertex.x_0);
    if (cmp != 0) return cmp;
    return compare_4(n1_0.originalVertex.y_0, n2_1.originalVertex.y_0);
}
defineClass(1175, 1, {
    678: 1
}, ScanlineOverlapCheck$OverlapsScanlineHandler);
_.handle = function handle_0(p) {
    $handle_0(this, castTo(p, 439));
};
var Lorg_eclipse_elk_alg_common_spore_ScanlineOverlapCheck$OverlapsScanlineHandler_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'ScanlineOverlapCheck/OverlapsScanlineHandler', 1175);
function ScanlineOverlapCheck$OverlapsScanlineHandler$lambda$0$Type() {}
defineClass(1176, 1, $intern_88, ScanlineOverlapCheck$OverlapsScanlineHandler$lambda$0$Type);
_.compare_1 = function compare_20(arg0, arg1) {
    return lambda$0_13(castTo(arg0, 68), castTo(arg1, 68));
};
_.equals_0 = function equals_72(other) {
    return this === other;
};
_.reversed = function reversed_12() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_spore_ScanlineOverlapCheck$OverlapsScanlineHandler$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'ScanlineOverlapCheck/OverlapsScanlineHandler/lambda$0$Type', 1176);
function ScanlineOverlapCheck$Timestamp(node, low) {
    this.node = node;
    this.low = low;
}
defineClass(439, 1, {
    439: 1
}, ScanlineOverlapCheck$Timestamp);
_.low = false;
var Lorg_eclipse_elk_alg_common_spore_ScanlineOverlapCheck$Timestamp_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'ScanlineOverlapCheck/Timestamp', 439);
function ScanlineOverlapCheck$lambda$0$Type() {}
defineClass(1177, 1, $intern_88, ScanlineOverlapCheck$lambda$0$Type);
_.compare_1 = function compare_21(arg0, arg1) {
    return lambda$0_12(castTo(arg0, 439), castTo(arg1, 439));
};
_.equals_0 = function equals_73(other) {
    return this === other;
};
_.reversed = function reversed_13() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_common_spore_ScanlineOverlapCheck$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.common.spore', 'ScanlineOverlapCheck/lambda$0$Type', 1177);
function SVGImage() {}
defineClass(542, 1, {}, SVGImage);
var Lorg_eclipse_elk_alg_common_utils_SVGImage_2_classLit = createForClass('org.eclipse.elk.alg.common.utils', 'SVGImage', 542);
function getRectEdges(r) {
    var rectEdegs;
    rectEdegs = new ArrayList;
    $add_3(rectEdegs, new TEdge(new KVector_1(r.x_0, r.y_0), new KVector_1(r.x_0 + r.width_0, r.y_0)));
    $add_3(rectEdegs, new TEdge(new KVector_1(r.x_0, r.y_0), new KVector_1(r.x_0, r.y_0 + r.height)));
    $add_3(rectEdegs, new TEdge(new KVector_1(r.x_0 + r.width_0, r.y_0 + r.height), new KVector_1(r.x_0 + r.width_0, r.y_0)));
    $add_3(rectEdegs, new TEdge(new KVector_1(r.x_0 + r.width_0, r.y_0 + r.height), new KVector_1(r.x_0, r.y_0 + r.height)));
    return rectEdegs;
}
function overlap_0(r1, r2) {
    var horizontalCenterDistance, horizontalOverlap, verticalCenterDistance, verticalOverlap;
    horizontalOverlap = $wnd.Math.min($wnd.Math.abs(r1.x_0 - (r2.x_0 + r2.width_0)), $wnd.Math.abs(r1.x_0 + r1.width_0 - r2.x_0));
    verticalOverlap = $wnd.Math.min($wnd.Math.abs(r1.y_0 - (r2.y_0 + r2.height)), $wnd.Math.abs(r1.y_0 + r1.height - r2.y_0));
    horizontalCenterDistance = $wnd.Math.abs(r1.x_0 + r1.width_0 / 2 - (r2.x_0 + r2.width_0 / 2));
    if (horizontalCenterDistance > r1.width_0 / 2 + r2.width_0 / 2) return 1;
    verticalCenterDistance = $wnd.Math.abs(r1.y_0 + r1.height / 2 - (r2.y_0 + r2.height / 2));
    if (verticalCenterDistance > r1.height / 2 + r2.height / 2) return 1;
    if (horizontalCenterDistance == 0 && verticalCenterDistance == 0) return 0;
    if (horizontalCenterDistance == 0) return verticalOverlap / verticalCenterDistance + 1;
    if (verticalCenterDistance == 0) return horizontalOverlap / horizontalCenterDistance + 1;
    return $wnd.Math.min(horizontalOverlap / horizontalCenterDistance, verticalOverlap / verticalCenterDistance) + 1;
}
function $buildIncidenceLists(graph) {
    var edge, edge$iterator, incidence, n, node, node$iterator;
    n = graph.nodes.array.length;
    incidence = initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, n, 0, 1);
    for(node$iterator = new ArrayList$1(graph.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 151);
        incidence[node.id_0] = new LinkedList;
    }
    for(edge$iterator = new ArrayList$1(graph.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 288);
        incidence[edge.source.id_0].add_2(edge);
        incidence[edge.target.id_0].add_2(edge);
    }
    return incidence;
}
function $dfs_0(this$static, node, last, graph, visited, incidence) {
    var component, edge, edge$iterator;
    if (!visited[node.id_0]) {
        visited[node.id_0] = true;
        component = graph;
        !component && (component = new FGraph);
        $add_3(component.nodes, node);
        for(edge$iterator = incidence[node.id_0].iterator_0(); edge$iterator.hasNext_0();){
            edge = castTo(edge$iterator.next_1(), 288);
            if (edge.target == last || edge.source == last) continue;
            edge.source != node && $dfs_0(this$static, edge.source, node, component, visited, incidence);
            edge.target != node && $dfs_0(this$static, edge.target, node, component, visited, incidence);
            $add_3(component.edges, edge);
            $addAll_2(component.labels, edge.labels);
        }
        return component;
    }
    return null;
}
function $moveGraph(destGraph, sourceGraph, offsetx, offsety) {
    var bendpoint, bendpoint$iterator, edge, edge$iterator, graphOffset, label_0, label$iterator, node, node$iterator;
    graphOffset = new KVector_1(offsetx, offsety);
    $sub_0(graphOffset, castTo($getProperty(sourceGraph, ($clinit_InternalProperties_0(), BB_UPLEFT)), 8));
    for(node$iterator = new ArrayList$1(sourceGraph.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 151);
        $add_19(node.position, graphOffset);
        $add_3(destGraph.nodes, node);
    }
    for(edge$iterator = new ArrayList$1(sourceGraph.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 288);
        for(bendpoint$iterator = new ArrayList$1(edge.bendpoints); bendpoint$iterator.i < bendpoint$iterator.this$01.array.length;){
            bendpoint = castTo($next_6(bendpoint$iterator), 249);
            $add_19(bendpoint.position, graphOffset);
        }
        $add_3(destGraph.edges, edge);
    }
    for(label$iterator = new ArrayList$1(sourceGraph.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 442);
        $add_19(label_0.position, graphOffset);
        $add_3(destGraph.labels, label_0);
    }
}
function $recombine(components) {
    var broadestRow, graph, graph$iterator, graph$iterator0, graph$iterator1, highestBox, maxRowWidth, maxx, maxy, minx, miny, node, node$iterator, priority, result, size_0, spacing, totalArea, xpos, ypos;
    if (components.size_1() == 1) return castTo(components.get_0(0), 234);
    else if (components.size_1() <= 0) return new FGraph;
    for(graph$iterator0 = components.iterator_0(); graph$iterator0.hasNext_0();){
        graph = castTo(graph$iterator0.next_1(), 234);
        priority = 0;
        minx = $intern_0;
        miny = $intern_0;
        maxx = $intern_42;
        maxy = $intern_42;
        for(node$iterator = new ArrayList$1(graph.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 151);
            priority += castTo($getProperty(node, ($clinit_ForceOptions(), PRIORITY)), 17).value_0;
            minx = $wnd.Math.min(minx, node.position.x_0 - node.size_0.x_0 / 2);
            miny = $wnd.Math.min(miny, node.position.y_0 - node.size_0.y_0 / 2);
            maxx = $wnd.Math.max(maxx, node.position.x_0 + node.size_0.x_0 / 2);
            maxy = $wnd.Math.max(maxy, node.position.y_0 + node.size_0.y_0 / 2);
        }
        $setProperty_0(graph, ($clinit_ForceOptions(), PRIORITY), valueOf_3(priority));
        $setProperty_0(graph, ($clinit_InternalProperties_0(), BB_UPLEFT), new KVector_1(minx, miny));
        $setProperty_0(graph, BB_LOWRIGHT, new KVector_1(maxx, maxy));
    }
    $clinit_Collections();
    components.sort_0(new ComponentsProcessor$1);
    result = new FGraph;
    $copyProperties(result, castTo(components.get_0(0), 102));
    maxRowWidth = 0;
    totalArea = 0;
    for(graph$iterator1 = components.iterator_0(); graph$iterator1.hasNext_0();){
        graph = castTo(graph$iterator1.next_1(), 234);
        size_0 = $sub_0($clone_1(castTo($getProperty(graph, ($clinit_InternalProperties_0(), BB_LOWRIGHT)), 8)), castTo($getProperty(graph, BB_UPLEFT), 8));
        maxRowWidth = $wnd.Math.max(maxRowWidth, size_0.x_0);
        totalArea += size_0.x_0 * size_0.y_0;
    }
    maxRowWidth = $wnd.Math.max(maxRowWidth, $wnd.Math.sqrt(totalArea) * $doubleValue(castToDouble($getProperty(result, ($clinit_ForceOptions(), ASPECT_RATIO)))));
    spacing = $doubleValue(castToDouble($getProperty(result, SPACING_NODE_NODE)));
    xpos = 0;
    ypos = 0;
    highestBox = 0;
    broadestRow = spacing;
    for(graph$iterator = components.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 234);
        size_0 = $sub_0($clone_1(castTo($getProperty(graph, ($clinit_InternalProperties_0(), BB_LOWRIGHT)), 8)), castTo($getProperty(graph, BB_UPLEFT), 8));
        if (xpos + size_0.x_0 > maxRowWidth) {
            xpos = 0;
            ypos += highestBox + spacing;
            highestBox = 0;
        }
        $moveGraph(result, graph, xpos, ypos);
        broadestRow = $wnd.Math.max(broadestRow, xpos + size_0.x_0);
        highestBox = $wnd.Math.max(highestBox, size_0.y_0);
        xpos += size_0.x_0 + spacing;
    }
    return result;
}
function $split_1(this$static, graph) {
    var comp, comp$iterator, components, id_0, incidence, node, node$iterator, node$iterator0, separate, visited;
    separate = castToBoolean($getProperty(graph, ($clinit_ForceOptions(), SEPARATE_CONNECTED_COMPONENTS)));
    if (separate == null || (checkCriticalNotNull(separate), separate)) {
        visited = initUnidimensionalArray(Z_classLit, $intern_90, 30, graph.nodes.array.length, 16, 1);
        incidence = $buildIncidenceLists(graph);
        components = new LinkedList;
        for(node$iterator0 = new ArrayList$1(graph.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 151);
            comp = $dfs_0(this$static, node, null, null, visited, incidence);
            if (comp) {
                $copyProperties(comp, graph);
                $addNode_0(components, comp, components.tail.prev, components.tail);
            }
        }
        if (components.size_0 > 1) for(comp$iterator = $listIterator_2(components, 0); comp$iterator.currentNode != comp$iterator.this$01.tail;){
            comp = castTo($next_9(comp$iterator), 234);
            id_0 = 0;
            for(node$iterator = new ArrayList$1(comp.nodes); node$iterator.i < node$iterator.this$01.array.length;){
                node = castTo($next_6(node$iterator), 151);
                node.id_0 = id_0++;
            }
        }
        return components;
    }
    return newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_force_graph_FGraph_2_classLit, 1), $intern_95, 234, 0, [
        graph
    ]));
}
function ComponentsProcessor() {}
defineClass(743, 1, {}, ComponentsProcessor);
var Lorg_eclipse_elk_alg_force_ComponentsProcessor_2_classLit = createForClass('org.eclipse.elk.alg.force', 'ComponentsProcessor', 743);
function $compare_1(graph1, graph2) {
    var prio, size1, size2;
    prio = castTo($getProperty(graph2, ($clinit_ForceOptions(), PRIORITY)), 17).value_0 - castTo($getProperty(graph1, PRIORITY), 17).value_0;
    if (prio == 0) {
        size1 = $sub_0($clone_1(castTo($getProperty(graph1, ($clinit_InternalProperties_0(), BB_LOWRIGHT)), 8)), castTo($getProperty(graph1, BB_UPLEFT), 8));
        size2 = $sub_0($clone_1(castTo($getProperty(graph2, BB_LOWRIGHT), 8)), castTo($getProperty(graph2, BB_UPLEFT), 8));
        return compare_4(size1.x_0 * size1.y_0, size2.x_0 * size2.y_0);
    }
    return prio;
}
function ComponentsProcessor$1() {}
defineClass(1159, 1, $intern_88, ComponentsProcessor$1);
_.compare_1 = function compare_22(graph1, graph2) {
    return $compare_1(castTo(graph1, 234), castTo(graph2, 234));
};
_.equals_0 = function equals_74(other) {
    return this === other;
};
_.reversed = function reversed_14() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_force_ComponentsProcessor$1_2_classLit = createForClass('org.eclipse.elk.alg.force', 'ComponentsProcessor/1', 1159);
function $applyLayout(fgraph) {
    var bendpoint, bendpoint$iterator, endLocation, fedge, fedge$iterator, flabel, flabel$iterator, fnode, fnode$iterator, height, kedge, kedgeSection, kgraph, klabel, knode, labelPos, maxXPos, maxYPos, minXPos, minYPos, node, node$iterator, nodePos, object, offset, padding, pos, size_0, startLocation, width_0;
    kgraph = castTo($getProperty(fgraph, ($clinit_InternalProperties_0(), ORIGIN)), 27);
    minXPos = $intern_0;
    minYPos = $intern_0;
    maxXPos = $intern_42;
    maxYPos = $intern_42;
    for(node$iterator = new ArrayList$1(fgraph.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 151);
        pos = node.position;
        size_0 = node.size_0;
        minXPos = $wnd.Math.min(minXPos, pos.x_0 - size_0.x_0 / 2);
        minYPos = $wnd.Math.min(minYPos, pos.y_0 - size_0.y_0 / 2);
        maxXPos = $wnd.Math.max(maxXPos, pos.x_0 + size_0.x_0 / 2);
        maxYPos = $wnd.Math.max(maxYPos, pos.y_0 + size_0.y_0 / 2);
    }
    for(bendpoint$iterator = new ArrayList$1(fgraph.bendPoints); bendpoint$iterator.i < bendpoint$iterator.this$01.array.length;){
        bendpoint = castTo($next_6(bendpoint$iterator), 249);
        pos = bendpoint.position;
        size_0 = bendpoint.size_0;
        minXPos = $wnd.Math.min(minXPos, pos.x_0 - size_0.x_0 / 2);
        minYPos = $wnd.Math.min(minYPos, pos.y_0 - size_0.y_0 / 2);
        maxXPos = $wnd.Math.max(maxXPos, pos.x_0 + size_0.x_0 / 2);
        maxYPos = $wnd.Math.max(maxYPos, pos.y_0 + size_0.y_0 / 2);
    }
    padding = castTo($getProperty_0(kgraph, ($clinit_ForceOptions(), PADDING)), 107);
    offset = new KVector_1(padding.left - minXPos, padding.top_0 - minYPos);
    for(fnode$iterator = new ArrayList$1(fgraph.nodes); fnode$iterator.i < fnode$iterator.this$01.array.length;){
        fnode = castTo($next_6(fnode$iterator), 151);
        object = $getProperty(fnode, ORIGIN);
        if (instanceOf(object, 206)) {
            knode = castTo(object, 27);
            nodePos = $add_19(new KVector_2(fnode.position), offset);
            $setLocation_1(knode, nodePos.x_0 - knode.width_0 / 2, nodePos.y_0 - knode.height / 2);
        }
    }
    for(fedge$iterator = new ArrayList$1(fgraph.edges); fedge$iterator.i < fedge$iterator.this$01.array.length;){
        fedge = castTo($next_6(fedge$iterator), 288);
        kedge = castTo($getProperty(fedge, ORIGIN), 85);
        kedgeSection = firstEdgeSection(kedge);
        startLocation = new KVector_2($getSourcePoint(fedge));
        $add_19(startLocation, offset);
        $setStartLocation(kedgeSection, startLocation.x_0, startLocation.y_0);
        $forEach_1(fedge.bendpoints, new ElkGraphImporter$lambda$0$Type(offset, kedgeSection));
        endLocation = new KVector_2($getTargetPoint(fedge));
        $add_19(endLocation, offset);
        $setEndLocation(kedgeSection, endLocation.x_0, endLocation.y_0);
    }
    for(flabel$iterator = new ArrayList$1(fgraph.labels); flabel$iterator.i < flabel$iterator.this$01.array.length;){
        flabel = castTo($next_6(flabel$iterator), 442);
        klabel = castTo($getProperty(flabel, ORIGIN), 153);
        labelPos = $add_19(new KVector_2(flabel.position), offset);
        $setLocation_1(klabel, labelPos.x_0, labelPos.y_0);
    }
    width_0 = maxXPos - minXPos + (padding.left + padding.right);
    height = maxYPos - minYPos + (padding.top_0 + padding.bottom);
    $booleanValue(castToBoolean($getProperty_0(kgraph, ($clinit_CoreOptions(), NODE_SIZE_FIXED_GRAPH_SIZE_3)))) || resizeNode_1(kgraph, width_0, height, false, true);
    $setProperty_1(kgraph, CHILD_AREA_WIDTH, width_0 - (padding.left + padding.right));
    $setProperty_1(kgraph, CHILD_AREA_HEIGHT, height - (padding.top_0 + padding.bottom));
}
function $importGraph(kgraph) {
    var elemMap, fgraph;
    fgraph = new FGraph;
    $copyProperties(fgraph, kgraph);
    $setProperty_0(fgraph, ($clinit_InternalProperties_0(), ORIGIN), kgraph);
    elemMap = new HashMap;
    $transformNodes(kgraph, fgraph, elemMap);
    $transformEdges(kgraph, fgraph, elemMap);
    return fgraph;
}
function $transformEdges(parentNode, fgraph, elemMap) {
    var kedge, kedge$iterator, klabel, klabel$iterator, knode, knode$iterator, newEdge, newLabel;
    for(knode$iterator = new AbstractEList$EIterator((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children)); knode$iterator.cursor != knode$iterator.this$01_2.size_1();){
        knode = castTo($doNext(knode$iterator), 27);
        for(kedge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(knode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(kedge$iterator);){
            kedge = castTo($next_0(kedge$iterator), 85);
            !kedge.sources && (kedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, kedge, 4, 7));
            if (!(kedge.sources.size_0 <= 1 && (!kedge.targets && (kedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, kedge, 5, 8)), kedge.targets.size_0 <= 1))) throw toJs(new UnsupportedGraphException('Graph must not contain hyperedges.'));
            if (!$isHierarchical(kedge) && knode != connectableShapeToNode(castTo($get_20((!kedge.targets && (kedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, kedge, 5, 8)), kedge.targets), 0), 84))) {
                newEdge = new FEdge;
                $copyProperties(newEdge, kedge);
                $setProperty_0(newEdge, ($clinit_InternalProperties_0(), ORIGIN), kedge);
                $setSource(newEdge, castTo(getEntryValueOrNull($getEntry_0(elemMap.hashCodeMap, knode)), 151));
                $setTarget(newEdge, castTo($get_10(elemMap, connectableShapeToNode(castTo($get_20((!kedge.targets && (kedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, kedge, 5, 8)), kedge.targets), 0), 84))), 151));
                $add_3(fgraph.edges, newEdge);
                for(klabel$iterator = new AbstractEList$EIterator((!kedge.labels && (kedge.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, kedge, 1, 7)), kedge.labels)); klabel$iterator.cursor != klabel$iterator.this$01_2.size_1();){
                    klabel = castTo($doNext(klabel$iterator), 153);
                    newLabel = new FLabel(newEdge, klabel.text_0);
                    $copyProperties(newLabel, klabel);
                    $setProperty_0(newLabel, ORIGIN, klabel);
                    newLabel.size_0.x_0 = $wnd.Math.max(klabel.width_0, 1);
                    newLabel.size_0.y_0 = $wnd.Math.max(klabel.height, 1);
                    $refreshPosition(newLabel);
                    $add_3(fgraph.labels, newLabel);
                }
            }
        }
    }
}
function $transformNodes(parentNode, fgraph, elemMap) {
    var index_0, knode, knode$iterator, label_0, newNode, portConstraints;
    index_0 = 0;
    for(knode$iterator = new AbstractEList$EIterator((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children)); knode$iterator.cursor != knode$iterator.this$01_2.size_1();){
        knode = castTo($doNext(knode$iterator), 27);
        label_0 = '';
        (!knode.labels && (knode.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, knode, 1, 7)), knode.labels).size_0 == 0 || (label_0 = castTo($get_20((!knode.labels && (knode.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, knode, 1, 7)), knode.labels), 0), 153).text_0);
        newNode = new FNode(label_0);
        $copyProperties(newNode, knode);
        $setProperty_0(newNode, ($clinit_InternalProperties_0(), ORIGIN), knode);
        newNode.id_0 = index_0++;
        newNode.position.x_0 = knode.x_0 + knode.width_0 / 2;
        newNode.position.y_0 = knode.y_0 + knode.height / 2;
        newNode.size_0.x_0 = $wnd.Math.max(knode.width_0, 1);
        newNode.size_0.y_0 = $wnd.Math.max(knode.height, 1);
        $add_3(fgraph.nodes, newNode);
        $put_9(elemMap.hashCodeMap, knode, newNode);
        portConstraints = castTo($getProperty_0(knode, ($clinit_ForceOptions(), PORT_CONSTRAINTS)), 100);
        portConstraints == ($clinit_PortConstraints(), UNDEFINED_4) && (portConstraints = FREE);
    }
}
function lambda$0_14(offset_0, kedgeSection_1, bp_2) {
    var position;
    position = new KVector_2(bp_2.position);
    $add_19(position, offset_0);
    createBendPoint(kedgeSection_1, position.x_0, position.y_0);
}
function ElkGraphImporter$lambda$0$Type(offset_0, kedgeSection_1) {
    this.offset_0 = offset_0;
    this.kedgeSection_1 = kedgeSection_1;
}
defineClass(1160, 1, $intern_19, ElkGraphImporter$lambda$0$Type);
_.accept = function accept_53(arg0) {
    lambda$0_14(this.offset_0, this.kedgeSection_1, castTo(arg0, 249));
};
var Lorg_eclipse_elk_alg_force_ElkGraphImporter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.force', 'ElkGraphImporter/lambda$0$Type', 1160);
defineClass(222, 1, $intern_96);
var Lorg_eclipse_elk_core_AbstractLayoutProvider_2_classLit = createForClass('org.eclipse.elk.core', 'AbstractLayoutProvider', 222);
function $layout(this$static, elkGraph, progressMonitor) {
    var builder, comp, comp$iterator, components, fgraph;
    progressMonitor.begin('ELK Force', 1);
    $booleanValue(castToBoolean($getProperty_0(elkGraph, ($clinit_ForceOptions(), OMIT_NODE_MICRO_LAYOUT)))) || $execute((builder = new NodeMicroLayout(($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(elkGraph))), builder));
    fgraph = $importGraph(elkGraph);
    $setOptions(fgraph);
    $updateModel(this$static, castTo($getProperty(fgraph, MODEL_0), 421));
    components = $split_1(this$static.componentsProcessor, fgraph);
    for(comp$iterator = components.iterator_0(); comp$iterator.hasNext_0();){
        comp = castTo(comp$iterator.next_1(), 234);
        $layout_0(this$static.forceModel, comp, progressMonitor.subTask(1 / components.size_1()));
    }
    fgraph = $recombine(components);
    $applyLayout(fgraph);
    progressMonitor.done_1();
}
function $setOptions(fgraph) {
    var randomSeed, val;
    randomSeed = castTo($getProperty(fgraph, ($clinit_ForceOptions(), RANDOM_SEED)), 17);
    if (randomSeed) {
        val = randomSeed.value_0;
        val == 0 ? $setProperty_0(fgraph, ($clinit_InternalProperties_0(), RANDOM), new Random) : $setProperty_0(fgraph, ($clinit_InternalProperties_0(), RANDOM), new Random_0(val));
    } else $setProperty_0(fgraph, ($clinit_InternalProperties_0(), RANDOM), new Random_0(1));
}
function $updateModel(this$static, strategy) {
    switch(strategy.ordinal){
        case 0:
            instanceOf(this$static.forceModel, 626) || (this$static.forceModel = new EadesModel);
            break;
        case 1:
            instanceOf(this$static.forceModel, 627) || (this$static.forceModel = new FruchtermanReingoldModel);
    }
}
function ForceLayoutProvider() {
    this.componentsProcessor = new ComponentsProcessor;
}
defineClass(721, 222, $intern_96, ForceLayoutProvider);
_.layout = function layout(elkGraph, progressMonitor) {
    $layout(this, elkGraph, progressMonitor);
};
var Lorg_eclipse_elk_alg_force_ForceLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.force', 'ForceLayoutProvider', 721);
var Lorg_eclipse_elk_graph_properties_IPropertyHolder_2_classLit = createForInterface('org.eclipse.elk.graph.properties', 'IPropertyHolder');
function $copyProperties(this$static, other) {
    var otherMap;
    if (!other) return this$static;
    otherMap = other.getAllProperties();
    otherMap.isEmpty() || (!this$static.propertyMap ? this$static.propertyMap = new HashMap_1(otherMap) : $putAll(this$static.propertyMap, otherMap));
    return this$static;
}
function $getAllProperties(this$static) {
    return !this$static.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : this$static.propertyMap;
}
function $getProperty(this$static, property) {
    var defaultValue, value_0;
    value_0 = (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $get_10(this$static.propertyMap, property));
    if (value_0 != null) return value_0;
    defaultValue = property.getDefault();
    instanceOf(defaultValue, 4) && (defaultValue == null ? (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $remove_6(this$static.propertyMap, property)) : (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $put_6(this$static.propertyMap, property, defaultValue)), this$static);
    return defaultValue;
}
function $hasProperty(this$static, property) {
    return !!this$static.propertyMap && $containsKey_3(this$static.propertyMap, property);
}
function $setProperty(this$static, property, value_0) {
    return value_0 == null ? (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $remove_6(this$static.propertyMap, property)) : (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $put_6(this$static.propertyMap, property, value_0)), this$static;
}
function $setProperty_0(this$static, property, value_0) {
    value_0 == null ? (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $remove_6(this$static.propertyMap, property)) : (!this$static.propertyMap && (this$static.propertyMap = new HashMap), $put_6(this$static.propertyMap, property, value_0));
    return this$static;
}
function MapPropertyHolder() {}
defineClass(148, 1, {
    3: 1,
    102: 1,
    148: 1
}, MapPropertyHolder);
_.setProperty = function setProperty(property, value_0) {
    return $setProperty(this, property, value_0);
};
_.getAllProperties = function getAllProperties() {
    return $getAllProperties(this);
};
_.getProperty = function getProperty(property) {
    return $getProperty(this, property);
};
_.hasProperty = function hasProperty(property) {
    return $hasProperty(this, property);
};
var Lorg_eclipse_elk_graph_properties_MapPropertyHolder_2_classLit = createForClass('org.eclipse.elk.graph.properties', 'MapPropertyHolder', 148);
function FParticle() {
    this.displacement = new KVector;
    this.position = new KVector;
    this.size_0 = new KVector;
}
defineClass(310, 148, {
    3: 1,
    310: 1,
    102: 1,
    148: 1
});
var Lorg_eclipse_elk_alg_force_graph_FParticle_2_classLit = createForClass('org.eclipse.elk.alg.force.graph', 'FParticle', 310);
function FBendpoint(edge) {
    FParticle.call(this);
    this.edge = edge;
    $add_3(edge.bendpoints, this);
}
defineClass(249, 310, {
    3: 1,
    249: 1,
    310: 1,
    102: 1,
    148: 1
}, FBendpoint);
_.toString_0 = function toString_78() {
    var index_0;
    if (this.edge) {
        index_0 = $indexOf_3(this.edge.bendpoints, this, 0);
        return index_0 >= 0 ? 'b' + index_0 + '[' + $toString_10(this.edge) + ']' : 'b[' + $toString_10(this.edge) + ']';
    }
    return 'b_' + getObjectIdentityHashCode(this);
};
var Lorg_eclipse_elk_alg_force_graph_FBendpoint_2_classLit = createForClass('org.eclipse.elk.alg.force.graph', 'FBendpoint', 249);
function $distributeBendpoints(this$static) {
    var bendPoint, bendPoint$iterator, count, incr, pos, sourcePos, targetPos;
    count = this$static.bendpoints.array.length;
    if (count > 0) {
        sourcePos = this$static.source.position;
        targetPos = this$static.target.position;
        incr = $scale($sub_0(new KVector_1(targetPos.x_0, targetPos.y_0), sourcePos), 1 / (count + 1));
        pos = new KVector_1(sourcePos.x_0, sourcePos.y_0);
        for(bendPoint$iterator = new ArrayList$1(this$static.bendpoints); bendPoint$iterator.i < bendPoint$iterator.this$01.array.length;){
            bendPoint = castTo($next_6(bendPoint$iterator), 249);
            bendPoint.position.x_0 = pos.x_0 + incr.x_0;
            bendPoint.position.y_0 = pos.y_0 + incr.y_0;
            pos.x_0 += incr.x_0;
            pos.y_0 += incr.y_0;
        }
    }
}
function $getSourcePoint(this$static) {
    var v;
    v = $sub_0($clone_1(this$static.target.position), this$static.source.position);
    clipVector(v, this$static.source.size_0.x_0, this$static.source.size_0.y_0);
    return $add_19(v, this$static.source.position);
}
function $getTargetPoint(this$static) {
    var v;
    v = $sub_0($clone_1(this$static.source.position), this$static.target.position);
    clipVector(v, this$static.target.size_0.x_0, this$static.target.size_0.y_0);
    return $add_19(v, this$static.target.position);
}
function $setSource(this$static, theSource) {
    this$static.source = theSource;
}
function $setTarget(this$static, theTarget) {
    this$static.target = theTarget;
}
function $toString_10(this$static) {
    return !!this$static.source && !!this$static.target ? $toString_11(this$static.source) + '->' + $toString_11(this$static.target) : 'e_' + getObjectIdentityHashCode(this$static);
}
function FEdge() {
    this.bendpoints = new ArrayList;
    this.labels = new ArrayList;
}
defineClass(288, 148, {
    3: 1,
    288: 1,
    102: 1,
    148: 1
}, FEdge);
_.toString_0 = function toString_79() {
    return $toString_10(this);
};
var Lorg_eclipse_elk_alg_force_graph_FEdge_2_classLit = createForClass('org.eclipse.elk.alg.force.graph', 'FEdge', 288);
function $calcAdjacency(this$static) {
    var edge, edge$iterator, n;
    n = this$static.nodes.array.length;
    this$static.adjacency = initMultidimensionalArray(I_classLit, [
        $intern_16,
        $intern_48
    ], [
        54,
        30
    ], 15, [
        n,
        n
    ], 2);
    for(edge$iterator = new ArrayList$1(this$static.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 288);
        this$static.adjacency[edge.source.id_0][edge.target.id_0] += castTo($getProperty(edge, ($clinit_ForceOptions(), PRIORITY)), 17).value_0;
    }
}
function $getConnection(this$static, particle1, particle2) {
    var bpoint1, bpoint2, node1, node2;
    if (instanceOf(particle1, 151) && instanceOf(particle2, 151)) {
        node1 = castTo(particle1, 151);
        node2 = castTo(particle2, 151);
        return this$static.adjacency[node1.id_0][node2.id_0] + this$static.adjacency[node2.id_0][node1.id_0];
    } else if (instanceOf(particle1, 249) && instanceOf(particle2, 249)) {
        bpoint1 = castTo(particle1, 249);
        bpoint2 = castTo(particle2, 249);
        if (bpoint1.edge == bpoint2.edge) return castTo($getProperty(bpoint2.edge, ($clinit_ForceOptions(), PRIORITY)), 17).value_0;
    }
    return 0;
}
function FGraph() {
    this.nodes = new ArrayList;
    this.edges = new ArrayList;
    this.labels = new ArrayList;
    this.bendPoints = new ArrayList;
}
defineClass(234, 148, {
    3: 1,
    234: 1,
    102: 1,
    148: 1
}, FGraph);
var Lorg_eclipse_elk_alg_force_graph_FGraph_2_classLit = createForClass('org.eclipse.elk.alg.force.graph', 'FGraph', 234);
function $refreshPosition(this$static) {
    var newLabelPosition, placeInline, pos, spacing, src_0, srcToTgt, tgt, toLabelCenter;
    placeInline = $booleanValue(castToBoolean($getProperty(this$static, ($clinit_ForceOptions(), EDGE_LABELS_INLINE))));
    src_0 = this$static.edge.source.position;
    tgt = this$static.edge.target.position;
    if (placeInline) {
        srcToTgt = $scale($sub_0(new KVector_1(tgt.x_0, tgt.y_0), src_0), 0.5);
        toLabelCenter = $scale($clone_1(this$static.size_0), 0.5);
        newLabelPosition = $sub_0($add_19(new KVector_1(src_0.x_0, src_0.y_0), srcToTgt), toLabelCenter);
        $set_7(this$static.position, newLabelPosition);
    } else {
        spacing = $doubleValue(castToDouble($getProperty(this$static.edge, SPACING_EDGE_LABEL)));
        pos = this$static.position;
        if (src_0.x_0 >= tgt.x_0) {
            if (src_0.y_0 >= tgt.y_0) {
                pos.x_0 = tgt.x_0 + (src_0.x_0 - tgt.x_0) / 2 + spacing;
                pos.y_0 = tgt.y_0 + (src_0.y_0 - tgt.y_0) / 2 - spacing - this$static.size_0.y_0;
            } else {
                pos.x_0 = tgt.x_0 + (src_0.x_0 - tgt.x_0) / 2 + spacing;
                pos.y_0 = src_0.y_0 + (tgt.y_0 - src_0.y_0) / 2 + spacing;
            }
        } else if (src_0.y_0 >= tgt.y_0) {
            pos.x_0 = src_0.x_0 + (tgt.x_0 - src_0.x_0) / 2 + spacing;
            pos.y_0 = tgt.y_0 + (src_0.y_0 - tgt.y_0) / 2 + spacing;
        } else {
            pos.x_0 = src_0.x_0 + (tgt.x_0 - src_0.x_0) / 2 + spacing;
            pos.y_0 = src_0.y_0 + (tgt.y_0 - src_0.y_0) / 2 - spacing - this$static.size_0.y_0;
        }
    }
}
function FLabel(fedge, text_0) {
    FParticle.call(this);
    this.edge = fedge;
    this.text_0 = text_0;
    $add_3(this.edge.labels, this);
}
defineClass(442, 310, {
    3: 1,
    442: 1,
    310: 1,
    102: 1,
    148: 1
}, FLabel);
_.toString_0 = function toString_80() {
    return this.text_0 == null || this.text_0.length == 0 ? 'l[' + $toString_10(this.edge) + ']' : 'l_' + this.text_0;
};
var Lorg_eclipse_elk_alg_force_graph_FLabel_2_classLit = createForClass('org.eclipse.elk.alg.force.graph', 'FLabel', 442);
function $toString_11(this$static) {
    return this$static.label_0 == null || this$static.label_0.length == 0 ? 'n_' + this$static.id_0 : 'n_' + this$static.label_0;
}
function FNode(label_0) {
    FParticle.call(this);
    this.label_0 = label_0;
}
defineClass(151, 310, {
    3: 1,
    151: 1,
    310: 1,
    102: 1,
    148: 1
}, FNode);
_.toString_0 = function toString_81() {
    return $toString_11(this);
};
_.id_0 = 0;
var Lorg_eclipse_elk_alg_force_graph_FNode_2_classLit = createForClass('org.eclipse.elk.alg.force.graph', 'FNode', 151);
function $initialize_0(this$static, fgraph) {
    var bends, count, edge, edge$iterator, i, node, node$iterator, pos, posScale;
    this$static.graph_0 = fgraph;
    this$static.random_0 = castTo($getProperty(fgraph, ($clinit_InternalProperties_0(), RANDOM)), 233);
    $calcAdjacency(fgraph);
    this$static.dispBound = $wnd.Math.max(fgraph.nodes.array.length * 16 + fgraph.edges.array.length, 256);
    if (!$booleanValue(castToBoolean($getProperty(fgraph, ($clinit_ForceOptions(), INTERACTIVE))))) {
        posScale = this$static.graph_0.nodes.array.length;
        for(node$iterator = new ArrayList$1(fgraph.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 151);
            pos = node.position;
            pos.x_0 = $nextDouble(this$static.random_0) * posScale;
            pos.y_0 = $nextDouble(this$static.random_0) * posScale;
        }
    }
    bends = fgraph.bendPoints;
    for(edge$iterator = new ArrayList$1(fgraph.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 288);
        count = castTo($getProperty(edge, REPULSIVE_POWER_0), 17).value_0;
        if (count > 0) {
            for(i = 0; i < count; i++)$add_3(bends, new FBendpoint(edge));
            $distributeBendpoints(edge);
        }
    }
}
function $iterationDone(this$static) {
    var edge, edge$iterator, label_0, label$iterator;
    for(edge$iterator = new ArrayList$1(this$static.graph_0.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 288);
        for(label$iterator = new ArrayList$1(edge.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 442);
            $refreshPosition(label_0);
        }
        $distributeBendpoints(edge);
    }
}
function $layout_0(this$static, fgraph, monitor) {
    var d, displacement, iterations, u, u$iterator, v, v$iterator, v$iterator0;
    monitor.begin('Component Layout', 1);
    this$static.initialize(fgraph);
    iterations = 0;
    while(this$static.moreIterations(iterations) && !monitor.isCanceled()){
        this$static.iterationDone();
        for(v$iterator0 = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
            fgraph.nodes,
            fgraph.labels,
            fgraph.bendPoints
        ]))); $hasNext_1(v$iterator0);){
            v = castTo($next_0(v$iterator0), 310);
            for(u$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                fgraph.nodes,
                fgraph.labels,
                fgraph.bendPoints
            ]))); $hasNext_1(u$iterator);){
                u = castTo($next_0(u$iterator), 310);
                if (u != v) {
                    displacement = this$static.calcDisplacement(u, v);
                    !!displacement && $add_19(v.displacement, displacement);
                }
            }
        }
        for(v$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
            fgraph.nodes,
            fgraph.labels,
            fgraph.bendPoints
        ]))); $hasNext_1(v$iterator);){
            v = castTo($next_0(v$iterator), 310);
            d = v.displacement;
            $bound(d, -this$static.dispBound, -this$static.dispBound, this$static.dispBound, this$static.dispBound);
            $add_19(v.position, d);
            d.x_0 = 0;
            d.y_0 = 0;
        }
        ++iterations;
    }
    monitor.done_1();
}
function avoidSamePosition(random, u, v) {
    var length_0, orthogonaluV, orthogonalvV, pu, pv, triedForBendPoints, uE, uVector, vE, vVector;
    pu = u.position;
    pv = v.position;
    while(pu.x_0 - pv.x_0 == 0 && pu.y_0 - pv.y_0 == 0){
        triedForBendPoints = false;
        if (instanceOf(u, 249) && instanceOf(v, 249) && !triedForBendPoints) {
            uE = castTo(u, 249).edge;
            uVector = $sub_0(new KVector_2($getTargetPoint(uE)), $getSourcePoint(uE));
            length_0 = 2;
            orthogonaluV = new KVector_1(uVector.x_0 / $wnd.Math.sqrt(uVector.x_0 * uVector.x_0 + uVector.y_0 * uVector.y_0) * length_0, -uVector.y_0 / $wnd.Math.sqrt(uVector.x_0 * uVector.x_0 + uVector.y_0 * uVector.y_0) * length_0);
            $add_19(pu, orthogonaluV);
            vE = castTo(v, 249).edge;
            vVector = $sub_0(new KVector_2($getTargetPoint(vE)), $getSourcePoint(vE));
            length_0 = uVector == vVector ? -2 : 2;
            orthogonalvV = new KVector_1(vVector.x_0 / $wnd.Math.sqrt(vVector.x_0 * vVector.x_0 + vVector.y_0 * vVector.y_0) * length_0, -(vVector.y_0 / $wnd.Math.sqrt(vVector.x_0 * vVector.x_0 + vVector.y_0 * vVector.y_0)) * length_0);
            $add_19(pu, orthogonalvV);
            triedForBendPoints = true;
        } else {
            pu.x_0 += $nextInternal(random, 26) * $intern_78 + $nextInternal(random, 27) * $intern_79 - 0.5;
            pu.y_0 += $nextInternal(random, 26) * $intern_78 + $nextInternal(random, 27) * $intern_79 - 0.5;
            pv.x_0 += $nextInternal(random, 26) * $intern_78 + $nextInternal(random, 27) * $intern_79 - 0.5;
            pv.y_0 += $nextInternal(random, 26) * $intern_78 + $nextInternal(random, 27) * $intern_79 - 0.5;
        }
    }
}
defineClass(2046, 1, {});
_.initialize = function initialize(fgraph) {
    $initialize_0(this, fgraph);
};
_.iterationDone = function iterationDone() {
    $iterationDone(this);
};
_.dispBound = 0;
var Lorg_eclipse_elk_alg_force_model_AbstractForceModel_2_classLit = createForClass('org.eclipse.elk.alg.force.model', 'AbstractForceModel', 2046);
function EadesModel() {
    this.maxIterations = castTo($getDefault(($clinit_ForceOptions(), ITERATIONS_0)), 17).value_0;
    this.springLength = $doubleValue(castToDouble($getDefault(SPACING_NODE_NODE)));
    this.repulsionFactor = $doubleValue(castToDouble($getDefault(REPULSION_0)));
}
function attractive(d, s) {
    return d > 0 ? $wnd.Math.log(d / s) : -100;
}
function repulsive(d, r) {
    return d > 0 ? r / (d * d) : r * 100;
}
defineClass(626, 2046, {
    626: 1
}, EadesModel);
_.calcDisplacement = function calcDisplacement(forcer, forcee) {
    var connection, d, displacement, force, length_0;
    avoidSamePosition(this.random_0, forcer, forcee);
    displacement = $sub_0($clone_1(forcee.position), forcer.position);
    length_0 = $wnd.Math.sqrt(displacement.x_0 * displacement.x_0 + displacement.y_0 * displacement.y_0);
    d = $wnd.Math.max(0, length_0 - $length(forcer.size_0) / 2 - $length(forcee.size_0) / 2);
    connection = $getConnection(this.graph_0, forcer, forcee);
    connection > 0 ? force = -attractive(d, this.springLength) * connection : force = repulsive(d, this.repulsionFactor) * castTo($getProperty(forcer, ($clinit_ForceOptions(), PRIORITY)), 17).value_0;
    displacement.x_0 *= force / length_0;
    displacement.y_0 *= force / length_0;
    return displacement;
};
_.initialize = function initialize_0(graph) {
    $initialize_0(this, graph);
    this.maxIterations = castTo($getProperty(graph, ($clinit_ForceOptions(), ITERATIONS_0)), 17).value_0;
    this.springLength = $doubleValue(castToDouble($getProperty(graph, SPACING_NODE_NODE)));
    this.repulsionFactor = $doubleValue(castToDouble($getProperty(graph, REPULSION_0)));
};
_.moreIterations = function moreIterations(count) {
    return count < this.maxIterations;
};
_.maxIterations = 0;
_.repulsionFactor = 0;
_.springLength = 0;
var Lorg_eclipse_elk_alg_force_model_EadesModel_2_classLit = createForClass('org.eclipse.elk.alg.force.model', 'EadesModel', 626);
function FruchtermanReingoldModel() {
    this.temperature = $doubleValue(castToDouble($getDefault(($clinit_ForceOptions(), TEMPERATURE_0))));
}
function attractive_0(d, k) {
    return d * d / k;
}
function repulsive_0(d, k) {
    return d > 0 ? k * k / d : k * k * 100;
}
defineClass(627, 2046, {
    627: 1
}, FruchtermanReingoldModel);
_.calcDisplacement = function calcDisplacement_0(forcer, forcee) {
    var connection, d, displacement, force, length_0;
    avoidSamePosition(this.random_0, forcer, forcee);
    displacement = $sub_0($clone_1(forcee.position), forcer.position);
    length_0 = $wnd.Math.sqrt(displacement.x_0 * displacement.x_0 + displacement.y_0 * displacement.y_0);
    d = $wnd.Math.max(0, length_0 - $length(forcer.size_0) / 2 - $length(forcee.size_0) / 2);
    force = repulsive_0(d, this.k) * castTo($getProperty(forcer, ($clinit_ForceOptions(), PRIORITY)), 17).value_0;
    connection = $getConnection(this.graph_0, forcer, forcee);
    connection > 0 && (force -= attractive_0(d, this.k) * connection);
    $scale(displacement, force * this.temperature / length_0);
    return displacement;
};
_.initialize = function initialize_1(graph) {
    var area, c, n, totalHeight, totalWidth, v, v$iterator;
    $initialize_0(this, graph);
    this.temperature = $doubleValue(castToDouble($getProperty(graph, ($clinit_ForceOptions(), TEMPERATURE_0))));
    this.threshold = this.temperature / castTo($getProperty(graph, ITERATIONS_0), 17).value_0;
    n = graph.nodes.array.length;
    totalWidth = 0;
    totalHeight = 0;
    for(v$iterator = new ArrayList$1(graph.nodes); v$iterator.i < v$iterator.this$01.array.length;){
        v = castTo($next_6(v$iterator), 151);
        totalWidth += v.size_0.x_0;
        totalHeight += v.size_0.y_0;
    }
    area = totalWidth * totalHeight;
    c = $doubleValue(castToDouble($getProperty(graph, SPACING_NODE_NODE))) * $intern_93;
    this.k = $wnd.Math.sqrt(area / (2 * n)) * c;
};
_.iterationDone = function iterationDone_0() {
    $iterationDone(this);
    this.temperature -= this.threshold;
};
_.moreIterations = function moreIterations_0(count) {
    return this.temperature > 0;
};
_.k = 0;
_.temperature = 0;
_.threshold = 0;
var Lorg_eclipse_elk_alg_force_model_FruchtermanReingoldModel_2_classLit = createForClass('org.eclipse.elk.alg.force.model', 'FruchtermanReingoldModel', 627);
var Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit = createForInterface('org.eclipse.elk.core.data', 'ILayoutMetaDataProvider');
function $clinit_ForceMetaDataProvider() {
    $clinit_ForceMetaDataProvider = emptyMethod;
    MODEL_DEFAULT = ($clinit_ForceModelStrategy(), FRUCHTERMAN_REINGOLD);
    MODEL = new Property_1('org.eclipse.elk.force.model', MODEL_DEFAULT);
    valueOf_3(1);
    ITERATIONS = new Property_1('org.eclipse.elk.force.iterations', valueOf_3(300));
    valueOf_3(0);
    REPULSIVE_POWER = new Property_1('org.eclipse.elk.force.repulsivePower', valueOf_3(0));
    new ExclusiveBounds$ExclusiveLowerBound;
    TEMPERATURE = new Property_1('org.eclipse.elk.force.temperature', $intern_97);
    new ExclusiveBounds$ExclusiveLowerBound;
    REPULSION = new Property_1('org.eclipse.elk.force.repulsion', 5);
    TEMPERATURE_DEP_MODEL_0 = FRUCHTERMAN_REINGOLD;
    REPULSION_DEP_MODEL_0 = EADES;
}
function ForceMetaDataProvider() {
    $clinit_ForceMetaDataProvider();
}
defineClass(839, 1, $intern_98, ForceMetaDataProvider);
_.apply_4 = function apply_28(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.force.model'), ''), 'Force Model'), 'Determines the model for force calculation.'), MODEL_DEFAULT), ($clinit_LayoutOptionData$Type(), ENUM)), Lorg_eclipse_elk_alg_force_options_ForceModelStrategy_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.force.iterations'), ''), 'Iterations'), 'The number of iterations on the force model.'), valueOf_3(300)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.force.repulsivePower'), ''), 'Repulsive Power'), 'Determines how many bend points are added to the edge; such bend points are regarded as repelling particles in the force model'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.force.temperature'), ''), 'FR Temperature'), 'The temperature is used as a scaling factor for particle displacements.'), $intern_97), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.force.temperature', 'org.eclipse.elk.force.model', TEMPERATURE_DEP_MODEL_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.force.repulsion'), ''), 'Eades Repulsion'), "Factor for repulsive forces in Eades' model."), 5), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.force.repulsion', 'org.eclipse.elk.force.model', REPULSION_DEP_MODEL_0);
    $apply_2((new ForceOptions, registry));
};
var ITERATIONS, MODEL, MODEL_DEFAULT, REPULSION, REPULSION_DEP_MODEL_0, REPULSIVE_POWER, TEMPERATURE, TEMPERATURE_DEP_MODEL_0;
var Lorg_eclipse_elk_alg_force_options_ForceMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.force.options', 'ForceMetaDataProvider', 839);
function $clinit_ForceModelStrategy() {
    $clinit_ForceModelStrategy = emptyMethod;
    EADES = new ForceModelStrategy('EADES', 0);
    FRUCHTERMAN_REINGOLD = new ForceModelStrategy('FRUCHTERMAN_REINGOLD', 1);
}
function ForceModelStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_17(name_0) {
    $clinit_ForceModelStrategy();
    return valueOf(($clinit_ForceModelStrategy$Map(), $MAP_7), name_0);
}
function values_25() {
    $clinit_ForceModelStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_force_options_ForceModelStrategy_2_classLit, 1), $intern_36, 421, 0, [
        EADES,
        FRUCHTERMAN_REINGOLD
    ]);
}
defineClass(421, 23, {
    3: 1,
    34: 1,
    23: 1,
    421: 1
}, ForceModelStrategy);
var EADES, FRUCHTERMAN_REINGOLD;
var Lorg_eclipse_elk_alg_force_options_ForceModelStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.force.options', 'ForceModelStrategy', 421, Ljava_lang_Enum_2_classLit, values_25, valueOf_17);
function $clinit_ForceModelStrategy$Map() {
    $clinit_ForceModelStrategy$Map = emptyMethod;
    $MAP_7 = createValueOfMap(($clinit_ForceModelStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_force_options_ForceModelStrategy_2_classLit, 1), $intern_36, 421, 0, [
        EADES,
        FRUCHTERMAN_REINGOLD
    ])));
}
var $MAP_7;
function $clinit_ForceOptions() {
    $clinit_ForceOptions = emptyMethod;
    PRIORITY = new Property_2(($clinit_CoreOptions(), PRIORITY_3), valueOf_3(1));
    SPACING_NODE_NODE = new Property_2(SPACING_NODE_NODE_6, 80);
    SPACING_EDGE_LABEL = new Property_2(SPACING_EDGE_LABEL_1, 5);
    ASPECT_RATIO = new Property_2(ASPECT_RATIO_4, $intern_99);
    RANDOM_SEED = new Property_2(RANDOM_SEED_1, valueOf_3(1));
    SEPARATE_CONNECTED_COMPONENTS = new Property_2(SEPARATE_CONNECTED_COMPONENTS_2, ($clinit_Boolean(), true));
    PADDING_DEFAULT = new ElkPadding_0(50);
    PADDING = new Property_2(PADDING_5, PADDING_DEFAULT);
    INTERACTIVE = INTERACTIVE_8;
    PORT_CONSTRAINTS = PORT_CONSTRAINTS_1;
    EDGE_LABELS_INLINE = new Property_2(EDGE_LABELS_INLINE_1, false);
    OMIT_NODE_MICRO_LAYOUT = OMIT_NODE_MICRO_LAYOUT_4;
    NODE_SIZE_FIXED_GRAPH_SIZE = NODE_SIZE_FIXED_GRAPH_SIZE_3;
    NODE_SIZE_OPTIONS = NODE_SIZE_OPTIONS_6;
    NODE_SIZE_CONSTRAINTS = NODE_SIZE_CONSTRAINTS_6;
    NODE_LABELS_PLACEMENT = NODE_LABELS_PLACEMENT_5;
    PORT_LABELS_PLACEMENT = PORT_LABELS_PLACEMENT_5;
    MODEL_0 = ($clinit_ForceMetaDataProvider(), MODEL);
    TEMPERATURE_0 = TEMPERATURE;
    ITERATIONS_0 = ITERATIONS;
    REPULSION_0 = REPULSION;
    REPULSIVE_POWER_0 = REPULSIVE_POWER;
    TOPDOWN_LAYOUT = TOPDOWN_LAYOUT_2;
    TOPDOWN_SCALE_FACTOR = TOPDOWN_SCALE_FACTOR_2;
    TOPDOWN_HIERARCHICAL_NODE_WIDTH = TOPDOWN_HIERARCHICAL_NODE_WIDTH_2;
    TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO = TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2;
    TOPDOWN_NODE_TYPE_DEFAULT = ($clinit_TopdownNodeTypes(), HIERARCHICAL_NODE);
    new Property_2(TOPDOWN_NODE_TYPE, TOPDOWN_NODE_TYPE_DEFAULT);
}
function $apply_2(registry) {
    $register(registry, new LayoutAlgorithmData($supportedFeatures($category($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.force'), 'ELK Force'), 'Force-based algorithm provided by the Eclipse Layout Kernel. Implements methods that follow physical analogies by simulating forces that move the nodes into a balanced distribution. Currently the original Eades model and the Fruchterman - Reingold model are supported.'), new ForceOptions$ForceFactory), 'org.eclipse.elk.force'), of_2(($clinit_GraphFeature(), MULTI_EDGES), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_properties_GraphFeature_2_classLit, 1), $intern_36, 243, 0, [
        EDGE_LABELS
    ])))));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.priority', valueOf_3(1));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.spacing.nodeNode', 80);
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.spacing.edgeLabel', 5);
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.aspectRatio', $intern_99);
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.randomSeed', valueOf_3(1));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.separateConnectedComponents', ($clinit_Boolean(), true));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.padding', PADDING_DEFAULT);
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.interactive', $getDefault(INTERACTIVE));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.portConstraints', $getDefault(PORT_CONSTRAINTS));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.edgeLabels.inline', false);
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.omitNodeMicroLayout', $getDefault(OMIT_NODE_MICRO_LAYOUT));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.nodeSize.fixedGraphSize', $getDefault(NODE_SIZE_FIXED_GRAPH_SIZE));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.nodeLabels.placement', $getDefault(NODE_LABELS_PLACEMENT));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.portLabels.placement', $getDefault(PORT_LABELS_PLACEMENT));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.force.model', $getDefault(MODEL_0));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.force.temperature', $getDefault(TEMPERATURE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.force.iterations', $getDefault(ITERATIONS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.force.repulsion', $getDefault(REPULSION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.force.repulsivePower', $getDefault(REPULSIVE_POWER_0));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.topdownLayout', $getDefault(TOPDOWN_LAYOUT));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.topdown.scaleFactor', $getDefault(TOPDOWN_SCALE_FACTOR));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.topdown.hierarchicalNodeWidth', $getDefault(TOPDOWN_HIERARCHICAL_NODE_WIDTH));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', $getDefault(TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO));
    $addOptionSupport(registry, 'org.eclipse.elk.force', 'org.eclipse.elk.topdown.nodeType', TOPDOWN_NODE_TYPE_DEFAULT);
}
function ForceOptions() {
    $clinit_ForceOptions();
}
defineClass(977, 1, $intern_98, ForceOptions);
_.apply_4 = function apply_29(registry) {
    $apply_2(registry);
};
var ASPECT_RATIO, EDGE_LABELS_INLINE, INTERACTIVE, ITERATIONS_0, MODEL_0, NODE_LABELS_PLACEMENT, NODE_SIZE_CONSTRAINTS, NODE_SIZE_FIXED_GRAPH_SIZE, NODE_SIZE_OPTIONS, OMIT_NODE_MICRO_LAYOUT, PADDING, PADDING_DEFAULT, PORT_CONSTRAINTS, PORT_LABELS_PLACEMENT, PRIORITY, RANDOM_SEED, REPULSION_0, REPULSIVE_POWER_0, SEPARATE_CONNECTED_COMPONENTS, SPACING_EDGE_LABEL, SPACING_NODE_NODE, TEMPERATURE_0, TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO, TOPDOWN_HIERARCHICAL_NODE_WIDTH, TOPDOWN_LAYOUT, TOPDOWN_NODE_TYPE_DEFAULT, TOPDOWN_SCALE_FACTOR;
var Lorg_eclipse_elk_alg_force_options_ForceOptions_2_classLit = createForClass('org.eclipse.elk.alg.force.options', 'ForceOptions', 977);
function ForceOptions$ForceFactory() {}
defineClass(978, 1, {}, ForceOptions$ForceFactory);
_.create_0 = function create_2() {
    var provider;
    return provider = new ForceLayoutProvider, provider;
};
_.destroy = function destroy(obj) {};
var Lorg_eclipse_elk_alg_force_options_ForceOptions$ForceFactory_2_classLit = createForClass('org.eclipse.elk.alg.force.options', 'ForceOptions/ForceFactory', 978);
function $clinit_InternalProperties_0() {
    $clinit_InternalProperties_0 = emptyMethod;
    ORIGIN = new Property('origin');
    RANDOM = new Property('random');
    BB_UPLEFT = new Property('boundingBox.upLeft');
    BB_LOWRIGHT = new Property('boundingBox.lowRight');
}
var BB_LOWRIGHT, BB_UPLEFT, ORIGIN, RANDOM;
function $clinit_StressMetaDataProvider() {
    $clinit_StressMetaDataProvider = emptyMethod;
    FIXED = new Property_1('org.eclipse.elk.stress.fixed', ($clinit_Boolean(), false));
    DESIRED_EDGE_LENGTH = new Property_1('org.eclipse.elk.stress.desiredEdgeLength', 100);
    DIMENSION_DEFAULT = ($clinit_StressMajorization$Dimension(), XY);
    DIMENSION = new Property_1('org.eclipse.elk.stress.dimension', DIMENSION_DEFAULT);
    EPSILON = new Property_1('org.eclipse.elk.stress.epsilon', $intern_97);
    ITERATION_LIMIT = new Property_1('org.eclipse.elk.stress.iterationLimit', valueOf_3($intern_0));
}
function StressMetaDataProvider() {
    $clinit_StressMetaDataProvider();
}
defineClass(840, 1, $intern_98, StressMetaDataProvider);
_.apply_4 = function apply_30(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.stress.fixed'), ''), 'Fixed Position'), 'Prevent that the node is moved by the layout algorithm.'), ($clinit_Boolean(), false)), ($clinit_LayoutOptionData$Type(), BOOLEAN)), Ljava_lang_Boolean_2_classLit), of_1(($clinit_LayoutOptionData$Target(), NODES)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.stress.desiredEdgeLength'), ''), 'Desired Edge Length'), 'Either specified for parent nodes or for individual edges, where the latter takes higher precedence.'), 100), DOUBLE), Ljava_lang_Double_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        EDGES
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.stress.dimension'), ''), 'Layout Dimension'), 'Dimensions that are permitted to be altered during layout.'), DIMENSION_DEFAULT), ENUM), Lorg_eclipse_elk_alg_force_stress_StressMajorization$Dimension_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.stress.epsilon'), ''), 'Stress Epsilon'), 'Termination criterion for the iterative process.'), $intern_97), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.stress.iterationLimit'), ''), 'Iteration Limit'), "Maximum number of performed iterations. Takes higher precedence than 'epsilon'."), valueOf_3($intern_0)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $apply_3((new StressOptions, registry));
};
var DESIRED_EDGE_LENGTH, DIMENSION, DIMENSION_DEFAULT, EPSILON, FIXED, ITERATION_LIMIT;
var Lorg_eclipse_elk_alg_force_options_StressMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.force.options', 'StressMetaDataProvider', 840);
function $clinit_StressOptions() {
    $clinit_StressOptions = emptyMethod;
    INTERACTIVE_0 = ($clinit_CoreOptions(), INTERACTIVE_8);
    new Property_2(EDGE_LABELS_INLINE_1, ($clinit_Boolean(), true));
    NODE_SIZE_CONSTRAINTS_0 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_MINIMUM = NODE_SIZE_MINIMUM_5;
    NODE_SIZE_OPTIONS_0 = NODE_SIZE_OPTIONS_6;
    NODE_LABELS_PLACEMENT_0 = NODE_LABELS_PLACEMENT_5;
    OMIT_NODE_MICRO_LAYOUT_0 = OMIT_NODE_MICRO_LAYOUT_4;
    PORT_LABELS_PLACEMENT_0 = PORT_LABELS_PLACEMENT_5;
    FIXED_0 = ($clinit_StressMetaDataProvider(), FIXED);
    DIMENSION_0 = DIMENSION;
    EPSILON_0 = EPSILON;
    ITERATION_LIMIT_0 = ITERATION_LIMIT;
    DESIRED_EDGE_LENGTH_0 = DESIRED_EDGE_LENGTH;
}
function $apply_3(registry) {
    $register(registry, new LayoutAlgorithmData($category($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.stress'), 'ELK Stress'), "Minimizes the stress within a layout using stress majorization. Stress exists if the euclidean distance between a pair of nodes doesn't match their graph theoretic distance, that is, the shortest path between the two nodes. The method allows to specify individual edge lengths."), new StressOptions$StressFactory), 'org.eclipse.elk.force')));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.interactive', $getDefault(INTERACTIVE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.edgeLabels.inline', ($clinit_Boolean(), true));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.nodeLabels.placement', $getDefault(NODE_LABELS_PLACEMENT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.omitNodeMicroLayout', $getDefault(OMIT_NODE_MICRO_LAYOUT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.portLabels.placement', $getDefault(PORT_LABELS_PLACEMENT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.stress.fixed', $getDefault(FIXED_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.stress.dimension', $getDefault(DIMENSION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.stress.epsilon', $getDefault(EPSILON_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.stress.iterationLimit', $getDefault(ITERATION_LIMIT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.stress', 'org.eclipse.elk.stress.desiredEdgeLength', $getDefault(DESIRED_EDGE_LENGTH_0));
}
function StressOptions() {
    $clinit_StressOptions();
}
defineClass(981, 1, $intern_98, StressOptions);
_.apply_4 = function apply_31(registry) {
    $apply_3(registry);
};
var DESIRED_EDGE_LENGTH_0, DIMENSION_0, EPSILON_0, FIXED_0, INTERACTIVE_0, ITERATION_LIMIT_0, NODE_LABELS_PLACEMENT_0, NODE_SIZE_CONSTRAINTS_0, NODE_SIZE_MINIMUM, NODE_SIZE_OPTIONS_0, OMIT_NODE_MICRO_LAYOUT_0, PORT_LABELS_PLACEMENT_0;
var Lorg_eclipse_elk_alg_force_options_StressOptions_2_classLit = createForClass('org.eclipse.elk.alg.force.options', 'StressOptions', 981);
function StressOptions$StressFactory() {}
defineClass(982, 1, {}, StressOptions$StressFactory);
_.create_0 = function create_3() {
    var provider;
    return provider = new StressLayoutProvider, provider;
};
_.destroy = function destroy_0(obj) {};
var Lorg_eclipse_elk_alg_force_options_StressOptions$StressFactory_2_classLit = createForClass('org.eclipse.elk.alg.force.options', 'StressOptions/StressFactory', 982);
function StressLayoutProvider() {
    this.componentsProcessor = new ComponentsProcessor;
    this.stressMajorization = new StressMajorization;
}
defineClass(1075, 222, $intern_96, StressLayoutProvider);
_.layout = function layout_0(layoutGraph, progressMonitor) {
    var builder, components, fgraph, subGraph, subGraph$iterator;
    progressMonitor.begin('ELK Stress', 1);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, ($clinit_StressOptions(), INTERACTIVE_0)))) ? $booleanValue(castToBoolean($getProperty_0(layoutGraph, OMIT_NODE_MICRO_LAYOUT_0))) || $execute((builder = new NodeMicroLayout(($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(layoutGraph))), builder)) : $layout(new ForceLayoutProvider, layoutGraph, progressMonitor.subTask(1));
    fgraph = $importGraph(layoutGraph);
    components = $split_1(this.componentsProcessor, fgraph);
    for(subGraph$iterator = components.iterator_0(); subGraph$iterator.hasNext_0();){
        subGraph = castTo(subGraph$iterator.next_1(), 234);
        if (subGraph.nodes.array.length <= 1) continue;
        $initialize_1(this.stressMajorization, subGraph);
        $execute_1(this.stressMajorization);
        $forEach_1(subGraph.labels, new StressLayoutProvider$lambda$0$Type);
    }
    fgraph = $recombine(components);
    $applyLayout(fgraph);
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_force_stress_StressLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.force.stress', 'StressLayoutProvider', 1075);
function StressLayoutProvider$lambda$0$Type() {}
defineClass(1076, 1, $intern_19, StressLayoutProvider$lambda$0$Type);
_.accept = function accept_54(arg0) {
    $refreshPosition(castTo(arg0, 442));
};
var Lorg_eclipse_elk_alg_force_stress_StressLayoutProvider$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.force.stress', 'StressLayoutProvider/lambda$0$Type', 1076);
function $computeNewPosition(this$static, u) {
    var eucDist, v, v$iterator, weightSum, wij, xDisp, yDisp;
    weightSum = 0;
    xDisp = 0;
    yDisp = 0;
    for(v$iterator = new ArrayList$1(this$static.graph_0.nodes); v$iterator.i < v$iterator.this$01.array.length;){
        v = castTo($next_6(v$iterator), 151);
        if (u == v) continue;
        wij = this$static.w[u.id_0][v.id_0];
        weightSum += wij;
        eucDist = $distance_0(u.position, v.position);
        eucDist > 0 && this$static.dim != ($clinit_StressMajorization$Dimension(), Y) && (xDisp += wij * (v.position.x_0 + this$static.apsp[u.id_0][v.id_0] * (u.position.x_0 - v.position.x_0) / eucDist));
        eucDist > 0 && this$static.dim != ($clinit_StressMajorization$Dimension(), X) && (yDisp += wij * (v.position.y_0 + this$static.apsp[u.id_0][v.id_0] * (u.position.y_0 - v.position.y_0) / eucDist));
    }
    switch(this$static.dim.ordinal){
        case 1:
            return new KVector_1(xDisp / weightSum, u.position.y_0);
        case 2:
            return new KVector_1(u.position.x_0, yDisp / weightSum);
        default:
            return new KVector_1(xDisp / weightSum, yDisp / weightSum);
    }
}
function $computeStress(this$static) {
    var eucDisplacement, eucDist, i, j, nodes, stress, u, v;
    stress = 0;
    nodes = this$static.graph_0.nodes;
    for(i = 0; i < nodes.array.length; ++i){
        u = (checkCriticalElementIndex(i, nodes.array.length), castTo(nodes.array[i], 151));
        for(j = i + 1; j < nodes.array.length; ++j){
            v = (checkCriticalElementIndex(j, nodes.array.length), castTo(nodes.array[j], 151));
            eucDist = $distance_0(u.position, v.position);
            eucDisplacement = eucDist - this$static.apsp[u.id_0][v.id_0];
            stress += this$static.w[u.id_0][v.id_0] * eucDisplacement * eucDisplacement;
        }
    }
    return stress;
}
function $dijkstra(this$static, source, dist) {
    var d, e, e$iterator, el, mark, n, n$iterator, nodes, u, v;
    nodes = new PriorityQueue(new StressMajorization$lambda$0$Type(dist));
    mark = initUnidimensionalArray(Z_classLit, $intern_90, 30, this$static.graph_0.nodes.array.length, 16, 1);
    fill0_3(mark, mark.length);
    dist[source.id_0] = 0;
    for(n$iterator = new ArrayList$1(this$static.graph_0.nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 151);
        n.id_0 != source.id_0 && (dist[n.id_0] = $intern_0);
        checkCriticalState_0($offer(nodes, n), 'Unable to add element to queue');
    }
    while(nodes.heap.array.length != 0){
        u = castTo($poll_0(nodes), 151);
        mark[u.id_0] = true;
        for(e$iterator = $listIterator_0(new LinkedListMultimap$1(this$static.connectedEdges, u), 0); e$iterator.next_0;){
            e = castTo($next_2(e$iterator), 288);
            v = $getOther_0(e, u);
            if (mark[v.id_0]) continue;
            $hasProperty(e, ($clinit_StressOptions(), DESIRED_EDGE_LENGTH_0)) ? el = $doubleValue(castToDouble($getProperty(e, DESIRED_EDGE_LENGTH_0))) : el = this$static.desiredEdgeLength;
            d = dist[u.id_0] + el;
            if (d < dist[v.id_0]) {
                dist[v.id_0] = d;
                $remove_25(nodes, v);
                checkCriticalState_0($offer(nodes, v), 'Unable to add element to queue');
            }
        }
    }
}
function $done(this$static, count, prevStress, curStress) {
    return prevStress == 0 || (prevStress - curStress) / prevStress < this$static.epsilon || count >= this$static.iterationLimit;
}
function $execute_1(this$static) {
    var count, curStress, newPos, prevStress, u, u$iterator;
    if (this$static.graph_0.nodes.array.length <= 1) return;
    count = 0;
    prevStress = $computeStress(this$static);
    curStress = $intern_60;
    do {
        count > 0 && (prevStress = curStress);
        for(u$iterator = new ArrayList$1(this$static.graph_0.nodes); u$iterator.i < u$iterator.this$01.array.length;){
            u = castTo($next_6(u$iterator), 151);
            if ($booleanValue(castToBoolean($getProperty(u, ($clinit_StressOptions(), FIXED_0))))) continue;
            newPos = $computeNewPosition(this$static, u);
            $add_19($reset_5(u.position), newPos);
        }
        curStress = $computeStress(this$static);
    }while (!$done(this$static, count++, prevStress, curStress));
}
function $getOther_0(edge, one) {
    if (edge.source == one) return edge.target;
    else if (edge.target == one) return edge.source;
    else throw toJs(new IllegalArgumentException_0("Node 'one' must be either source or target of edge 'edge'."));
}
function $initialize_1(this$static, fgraph) {
    var dij, edge, edge$iterator, i, j, n, source, source$iterator, wij;
    if (fgraph.nodes.array.length <= 1) return;
    this$static.graph_0 = fgraph;
    this$static.dim = castTo($getProperty(this$static.graph_0, ($clinit_StressOptions(), DIMENSION_0)), 382);
    this$static.iterationLimit = castTo($getProperty(this$static.graph_0, ITERATION_LIMIT_0), 17).value_0;
    this$static.epsilon = $doubleValue(castToDouble($getProperty(this$static.graph_0, EPSILON_0)));
    this$static.desiredEdgeLength = $doubleValue(castToDouble($getProperty(this$static.graph_0, DESIRED_EDGE_LENGTH_0)));
    $clear_3(this$static.connectedEdges);
    for(edge$iterator = new ArrayList$1(this$static.graph_0.edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 288);
        $addNode(this$static.connectedEdges, edge.source, edge, null);
        $addNode(this$static.connectedEdges, edge.target, edge, null);
    }
    n = this$static.graph_0.nodes.array.length;
    this$static.apsp = initMultidimensionalArray(D_classLit, [
        $intern_16,
        $intern_66
    ], [
        108,
        30
    ], 15, [
        n,
        n
    ], 2);
    for(source$iterator = new ArrayList$1(this$static.graph_0.nodes); source$iterator.i < source$iterator.this$01.array.length;){
        source = castTo($next_6(source$iterator), 151);
        $dijkstra(this$static, source, this$static.apsp[source.id_0]);
    }
    this$static.w = initMultidimensionalArray(D_classLit, [
        $intern_16,
        $intern_66
    ], [
        108,
        30
    ], 15, [
        n,
        n
    ], 2);
    for(i = 0; i < n; ++i)for(j = 0; j < n; ++j){
        dij = this$static.apsp[i][j];
        wij = 1 / (dij * dij);
        this$static.w[i][j] = wij;
    }
}
function StressMajorization() {
    this.connectedEdges = new LinkedListMultimap;
}
function lambda$0_15(dist_0, n1_1, n2_2) {
    return compare_4(dist_0[n1_1.id_0], dist_0[n2_2.id_0]);
}
defineClass(979, 1, {}, StressMajorization);
_.desiredEdgeLength = 0;
_.epsilon = 0;
_.iterationLimit = 0;
var Lorg_eclipse_elk_alg_force_stress_StressMajorization_2_classLit = createForClass('org.eclipse.elk.alg.force.stress', 'StressMajorization', 979);
function $clinit_StressMajorization$Dimension() {
    $clinit_StressMajorization$Dimension = emptyMethod;
    XY = new StressMajorization$Dimension('XY', 0);
    X = new StressMajorization$Dimension('X', 1);
    Y = new StressMajorization$Dimension('Y', 2);
}
function StressMajorization$Dimension(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_18(name_0) {
    $clinit_StressMajorization$Dimension();
    return valueOf(($clinit_StressMajorization$Dimension$Map(), $MAP_8), name_0);
}
function values_26() {
    $clinit_StressMajorization$Dimension();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_force_stress_StressMajorization$Dimension_2_classLit, 1), $intern_36, 382, 0, [
        XY,
        X,
        Y
    ]);
}
defineClass(382, 23, {
    3: 1,
    34: 1,
    23: 1,
    382: 1
}, StressMajorization$Dimension);
var X, XY, Y;
var Lorg_eclipse_elk_alg_force_stress_StressMajorization$Dimension_2_classLit = createForEnum('org.eclipse.elk.alg.force.stress', 'StressMajorization/Dimension', 382, Ljava_lang_Enum_2_classLit, values_26, valueOf_18);
function $clinit_StressMajorization$Dimension$Map() {
    $clinit_StressMajorization$Dimension$Map = emptyMethod;
    $MAP_8 = createValueOfMap(($clinit_StressMajorization$Dimension(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_force_stress_StressMajorization$Dimension_2_classLit, 1), $intern_36, 382, 0, [
        XY,
        X,
        Y
    ])));
}
var $MAP_8;
function StressMajorization$lambda$0$Type(dist_0) {
    this.dist_0 = dist_0;
}
defineClass(980, 1, $intern_88, StressMajorization$lambda$0$Type);
_.compare_1 = function compare_23(arg0, arg1) {
    return lambda$0_15(this.dist_0, castTo(arg0, 151), castTo(arg1, 151));
};
_.equals_0 = function equals_75(other) {
    return this === other;
};
_.reversed = function reversed_15() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_force_stress_StressMajorization$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.force.stress', 'StressMajorization/lambda$0$Type', 980);
function $collectAllGraphsBottomUp(root) {
    var collectedGraphs, continueSearchingTheseGraphs, nestedGraph, nextGraph, node, node$iterator;
    collectedGraphs = new ArrayDeque;
    continueSearchingTheseGraphs = new ArrayDeque;
    $addFirst(collectedGraphs, root);
    $addFirst(continueSearchingTheseGraphs, root);
    while(continueSearchingTheseGraphs.head != continueSearchingTheseGraphs.tail){
        nextGraph = castTo($removeFirst(continueSearchingTheseGraphs), 36);
        for(node$iterator = new ArrayList$1(nextGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (node.nestedGraph) {
                nestedGraph = node.nestedGraph;
                $addFirst(collectedGraphs, nestedGraph);
                $addFirst(continueSearchingTheseGraphs, nestedGraph);
            }
        }
    }
    return collectedGraphs;
}
function $doCompoundLayout(this$static, lgraph, monitor) {
    var theMonitor;
    theMonitor = monitor;
    !theMonitor && (theMonitor = $withMaxHierarchyLevels(new BasicProgressMonitor, 0));
    theMonitor.begin('Layered layout', 2);
    $process_1(this$static.compoundGraphPreprocessor, lgraph, theMonitor.subTask(1));
    $hierarchicalLayout(this$static, lgraph, theMonitor.subTask(1));
    $process_0(lgraph, theMonitor.subTask(1));
    theMonitor.done_1();
}
function $doLayout(this$static, lgraph, monitor) {
    var comp, comp$iterator, compWork, components, theMonitor;
    theMonitor = monitor;
    !theMonitor && (theMonitor = $withMaxHierarchyLevels(new BasicProgressMonitor, 0));
    theMonitor.begin('Layered layout', 1);
    $prepareGraphForLayout(this$static.graphConfigurator, lgraph);
    components = $split_2(this$static.componentsProcessor, lgraph);
    if (components.size_1() == 1) $layout_1(castTo(components.get_0(0), 36), theMonitor);
    else {
        compWork = 1 / components.size_1();
        for(comp$iterator = components.iterator_0(); comp$iterator.hasNext_0();){
            comp = castTo(comp$iterator.next_1(), 36);
            if (monitor.isCanceled()) return;
            $layout_1(comp, theMonitor.subTask(compWork));
        }
    }
    $combine(this$static.componentsProcessor, components, lgraph);
    $resizeGraph(lgraph);
    theMonitor.done_1();
}
function $hierarchicalLayout(this$static, lgraph, monitor) {
    var algorithm, g, g$iterator, graph, graphAndAlgorithm, graphAndAlgorithm$iterator, graphs, graphsAndAlgorithms, processor, processors, rootProcessors, slotIndex, work, parentCms, rootType;
    graphs = $collectAllGraphsBottomUp(lgraph);
    parentCms = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_STRATEGY_0)), 323);
    $forEach_0(graphs, new ElkLayered$lambda$0$Type(parentCms));
    rootType = castTo($getProperty(lgraph, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0), 298);
    $forEach_0(graphs, new ElkLayered$lambda$1$Type(rootType));
    work = 0;
    graphsAndAlgorithms = new ArrayList;
    for(g$iterator = new ArrayDeque$IteratorImpl(graphs); g$iterator.currentIndex != g$iterator.fence;){
        g = castTo($next_5(g$iterator), 36);
        $prepareGraphForLayout(this$static.graphConfigurator, g);
        processors = castTo($getProperty(g, ($clinit_InternalProperties_1(), PROCESSORS)), 15);
        work += processors.size_1();
        algorithm = processors.iterator_0();
        $add_3(graphsAndAlgorithms, new Pair(g, algorithm));
    }
    monitor.begin('Recursive hierarchical layout', work);
    slotIndex = 0;
    rootProcessors = castTo(castTo($get_11(graphsAndAlgorithms, graphsAndAlgorithms.array.length - 1), 47).second, 49);
    while(rootProcessors.hasNext_0())for(graphAndAlgorithm$iterator = new ArrayList$1(graphsAndAlgorithms); graphAndAlgorithm$iterator.i < graphAndAlgorithm$iterator.this$01.array.length;){
        graphAndAlgorithm = castTo($next_6(graphAndAlgorithm$iterator), 47);
        processors = castTo(graphAndAlgorithm.second, 49);
        graph = castTo(graphAndAlgorithm.first, 36);
        while(processors.hasNext_0()){
            processor = castTo(processors.next_1(), 44);
            if (instanceOf(processor, 498)) {
                if (!graph.parentNode) {
                    processor.process(graph, monitor.subTask(1));
                    ++slotIndex;
                    break;
                } else break;
            } else {
                processor.process(graph, monitor.subTask(1));
                ++slotIndex;
            }
        }
    }
    monitor.done_1();
}
function $layout_1(lgraph, monitor) {
    var algorithm, gwtDoesntSupportPrintf, layer, layer$iterator, monitorProgress, monitorWasAlreadyRunning, node, node$iterator, processor, processor$iterator, processor$iterator0, slot, slotIndex;
    monitorWasAlreadyRunning = monitor.isRunning();
    monitorWasAlreadyRunning || monitor.begin('Component Layout', 1);
    algorithm = castTo($getProperty(lgraph, ($clinit_InternalProperties_1(), PROCESSORS)), 15);
    monitorProgress = 1 / algorithm.size_1();
    if (monitor.isLoggingEnabled()) {
        monitor.log_0('ELK Layered uses the following ' + algorithm.size_1() + ' modules:');
        slot = 0;
        for(processor$iterator0 = algorithm.iterator_0(); processor$iterator0.hasNext_0();){
            processor = castTo(processor$iterator0.next_1(), 44);
            gwtDoesntSupportPrintf = (slot < 10 ? '0' : '') + slot++;
            monitor.log_0('   Slot ' + gwtDoesntSupportPrintf + ': ' + $getName(getClass__Ljava_lang_Class___devirtual$(processor)));
        }
    }
    slotIndex = 0;
    for(processor$iterator = algorithm.iterator_0(); processor$iterator.hasNext_0();){
        processor = castTo(processor$iterator.next_1(), 44);
        if (monitor.isCanceled()) return;
        processor.process(lgraph, monitor.subTask(monitorProgress));
        ++slotIndex;
    }
    for(layer$iterator = new ArrayList$1(lgraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        $addAll_2(lgraph.layerlessNodes, layer.nodes);
        layer.nodes.array.length = 0;
    }
    for(node$iterator = new ArrayList$1(lgraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $setLayer_0(node, null);
    }
    lgraph.layers.array.length = 0;
    monitorWasAlreadyRunning || monitor.done_1();
}
function $resizeGraph(lgraph) {
    var adjustedSize, calculatedSize, minSize, sizeConstraint, sizeOptions;
    sizeConstraint = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1)), 22);
    sizeOptions = castTo($getProperty(lgraph, NODE_SIZE_OPTIONS_1), 22);
    calculatedSize = new KVector_1(lgraph.size_0.x_0 + lgraph.padding.left + lgraph.padding.right, lgraph.size_0.y_0 + lgraph.padding.top_0 + lgraph.padding.bottom);
    adjustedSize = new KVector_2(calculatedSize);
    if (sizeConstraint.contains(($clinit_SizeConstraint(), MINIMUM_SIZE))) {
        minSize = castTo($getProperty(lgraph, NODE_SIZE_MINIMUM_0), 8);
        if (sizeOptions.contains(($clinit_SizeOptions(), DEFAULT_MINIMUM_SIZE))) {
            minSize.x_0 <= 0 && (minSize.x_0 = 20);
            minSize.y_0 <= 0 && (minSize.y_0 = 20);
        }
        adjustedSize.x_0 = $wnd.Math.max(calculatedSize.x_0, minSize.x_0);
        adjustedSize.y_0 = $wnd.Math.max(calculatedSize.y_0, minSize.y_0);
    }
    $booleanValue(castToBoolean($getProperty(lgraph, NODE_SIZE_FIXED_GRAPH_SIZE_0))) || $resizeGraphNoReallyIMeanIt(lgraph, calculatedSize, adjustedSize);
}
function $resizeGraphNoReallyIMeanIt(lgraph, oldSize, newSize) {
    var contentAlignment, extPortSide, lPadding, node, node$iterator;
    contentAlignment = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), CONTENT_ALIGNMENT)), 22);
    newSize.x_0 > oldSize.x_0 && (contentAlignment.contains(($clinit_ContentAlignment(), H_CENTER)) ? lgraph.offset.x_0 += (newSize.x_0 - oldSize.x_0) / 2 : contentAlignment.contains(H_RIGHT) && (lgraph.offset.x_0 += newSize.x_0 - oldSize.x_0));
    newSize.y_0 > oldSize.y_0 && (contentAlignment.contains(($clinit_ContentAlignment(), V_CENTER)) ? lgraph.offset.y_0 += (newSize.y_0 - oldSize.y_0) / 2 : contentAlignment.contains(V_BOTTOM) && (lgraph.offset.y_0 += newSize.y_0 - oldSize.y_0));
    if (castTo($getProperty(lgraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) && (newSize.x_0 > oldSize.x_0 || newSize.y_0 > oldSize.y_0)) for(node$iterator = new ArrayList$1(lgraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
            extPortSide = castTo($getProperty(node, EXT_PORT_SIDE), 64);
            extPortSide == ($clinit_PortSide(), EAST_0) ? node.pos.x_0 += newSize.x_0 - oldSize.x_0 : extPortSide == SOUTH_0 && (node.pos.y_0 += newSize.y_0 - oldSize.y_0);
        }
    }
    lPadding = lgraph.padding;
    lgraph.size_0.x_0 = newSize.x_0 - lPadding.left - lPadding.right;
    lgraph.size_0.y_0 = newSize.y_0 - lPadding.top_0 - lPadding.bottom;
}
function ElkLayered() {
    this.graphConfigurator = new GraphConfigurator;
    this.componentsProcessor = new ComponentsProcessor_0;
    this.compoundGraphPreprocessor = new CompoundGraphPreprocessor;
    $clinit_CompoundGraphPostprocessor();
}
function lambda$0_16(parentCms_0, child_1) {
    var childCms;
    childCms = castTo($getProperty(child_1, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_STRATEGY_0)), 323);
    if (childCms != parentCms_0) throw toJs(new UnsupportedGraphException('The hierarchy aware processor ' + childCms + ' in child node ' + child_1 + ' is only allowed if the root node specifies the same hierarchical processor.'));
}
function lambda$1_4(rootType_0, g_1) {
    return $setProperty_0(g_1, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0), rootType_0);
}
defineClass(1156, 1, {}, ElkLayered);
var Lorg_eclipse_elk_alg_layered_ElkLayered_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'ElkLayered', 1156);
function ElkLayered$lambda$0$Type(parentCms_0) {
    this.parentCms_0 = parentCms_0;
}
defineClass(1157, 1, $intern_19, ElkLayered$lambda$0$Type);
_.accept = function accept_55(arg0) {
    lambda$0_16(this.parentCms_0, castTo(arg0, 36));
};
var Lorg_eclipse_elk_alg_layered_ElkLayered$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'ElkLayered/lambda$0$Type', 1157);
function ElkLayered$lambda$1$Type(rootType_0) {
    this.rootType_0 = rootType_0;
}
defineClass(1158, 1, $intern_19, ElkLayered$lambda$1$Type);
_.accept = function accept_56(arg0) {
    lambda$1_4(this.rootType_0, castTo(arg0, 36));
};
var Lorg_eclipse_elk_alg_layered_ElkLayered$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'ElkLayered/lambda$1$Type', 1158);
function $clinit_GraphConfigurator() {
    $clinit_GraphConfigurator = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION = $addAfter($addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P4_NODE_PLACEMENT), ($clinit_IntermediateProcessorStrategy(), INNERMOST_NODE_MARGIN_CALCULATOR)), P4_NODE_PLACEMENT, LABEL_AND_NODE_SIZE_PROCESSOR), P5_EDGE_ROUTING, LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR), P5_EDGE_ROUTING, END_LABEL_SORTER);
    LABEL_MANAGEMENT_ADDITIONS = $addBefore($addBefore(new LayoutProcessorConfiguration, P4_NODE_PLACEMENT, CENTER_LABEL_MANAGEMENT_PROCESSOR), P4_NODE_PLACEMENT, END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR);
    HIERARCHICAL_ADDITIONS = $addAfter(new LayoutProcessorConfiguration, P5_EDGE_ROUTING, HIERARCHICAL_NODE_RESIZER);
}
function $copyPortConstraints(this$static, node) {
    var nestedGraph, originalPortconstraints;
    originalPortconstraints = castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    $setProperty_0(node, ($clinit_InternalProperties_1(), ORIGINAL_PORT_CONSTRAINTS), originalPortconstraints);
    nestedGraph = node.nestedGraph;
    !!nestedGraph && ($forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(nestedGraph.layerlessNodes, 16)), new GraphConfigurator$lambda$0$Type(this$static)), $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(nestedGraph.layers, 16)), new GraphConfigurator$lambda$1$Type), new GraphConfigurator$lambda$2$Type(this$static)));
}
function $getPhaseIndependentLayoutProcessorConfiguration(lgraph) {
    var configuration, graphProperties, greedySwitchType, hierarchyHandling, internalGreedyType;
    graphProperties = castTo($getProperty(lgraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
    configuration = createFrom_0(BASELINE_PROCESSING_CONFIGURATION);
    hierarchyHandling = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), HIERARCHY_HANDLING)), 342);
    hierarchyHandling == ($clinit_HierarchyHandling(), INCLUDE_CHILDREN) && $addAll_6(configuration, HIERARCHICAL_ADDITIONS);
    $booleanValue(castToBoolean($getProperty(lgraph, FEEDBACK_EDGES_0))) ? $addBefore(configuration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), PORT_SIDE_PROCESSOR)) : $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), PORT_SIDE_PROCESSOR));
    $getProperty(lgraph, ($clinit_LabelManagementOptions(), LABEL_MANAGER)) != null && $addAll_6(configuration, LABEL_MANAGEMENT_ADDITIONS);
    ($booleanValue(castToBoolean($getProperty(lgraph, INTERACTIVE_LAYOUT))) || $booleanValue(castToBoolean($getProperty(lgraph, GENERATE_POSITION_AND_LAYER_IDS_0)))) && $addAfter(configuration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), CONSTRAINTS_POSTPROCESSOR));
    switch(castTo($getProperty(lgraph, DIRECTION), 86).ordinal){
        case 2:
        case 3:
        case 4:
            $addAfter($addBefore(configuration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), DIRECTION_PREPROCESSOR)), P5_EDGE_ROUTING, DIRECTION_POSTPROCESSOR);
    }
    graphProperties.contains(($clinit_GraphProperties(), COMMENTS)) && $addAfter($addBefore($addBefore(configuration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), COMMENT_PREPROCESSOR)), P4_NODE_PLACEMENT, COMMENT_NODE_MARGIN_CALCULATOR), P5_EDGE_ROUTING, COMMENT_POSTPROCESSOR);
    maskUndefined($getProperty(lgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) !== maskUndefined(($clinit_NodePromotionStrategy(), NONE_10)) && $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), NODE_PROMOTION));
    if (graphProperties.contains(PARTITIONS)) {
        $addBefore(configuration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), PARTITION_PREPROCESSOR));
        $addBefore(configuration, P2_LAYERING, PARTITION_MIDPROCESSOR);
        $addBefore(configuration, P3_NODE_ORDERING, PARTITION_POSTPROCESSOR);
    }
    maskUndefined($getProperty(lgraph, COMPACTION_POST_COMPACTION_STRATEGY_0)) !== maskUndefined(($clinit_GraphCompactionStrategy(), NONE_5)) && maskUndefined($getProperty(lgraph, EDGE_ROUTING)) !== maskUndefined(($clinit_EdgeRouting(), POLYLINE)) && $addAfter(configuration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), HORIZONTAL_COMPACTOR));
    $booleanValue(castToBoolean($getProperty(lgraph, HIGH_DEGREE_NODES_TREATMENT_0))) && $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), HIGH_DEGREE_NODE_LAYER_PROCESSOR));
    $booleanValue(castToBoolean($getProperty(lgraph, CROSSING_MINIMIZATION_SEMI_INTERACTIVE_0))) && $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), SEMI_INTERACTIVE_CROSSMIN_PROCESSOR));
    if (activateGreedySwitchFor(lgraph)) {
        maskUndefined($getProperty(lgraph, HIERARCHY_HANDLING)) === maskUndefined(INCLUDE_CHILDREN) ? greedySwitchType = castTo($getProperty(lgraph, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0), 298) : greedySwitchType = castTo($getProperty(lgraph, CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_0), 298);
        internalGreedyType = greedySwitchType == ($clinit_GreedySwitchType(), ONE_SIDED) ? ($clinit_IntermediateProcessorStrategy(), ONE_SIDED_GREEDY_SWITCH) : ($clinit_IntermediateProcessorStrategy(), TWO_SIDED_GREEDY_SWITCH);
        $addBefore(configuration, ($clinit_LayeredPhases(), P4_NODE_PLACEMENT), internalGreedyType);
    }
    castTo($getProperty(lgraph, LAYER_UNZIPPING_STRATEGY_0), 420).ordinal == 1 && $addBefore(configuration, ($clinit_LayeredPhases(), P4_NODE_PLACEMENT), ($clinit_IntermediateProcessorStrategy(), ALTERNATING_LAYER_UNZIPPER));
    switch(castTo($getProperty(lgraph, WRAPPING_STRATEGY_0), 380).ordinal){
        case 1:
            $addBefore(configuration, ($clinit_LayeredPhases(), P4_NODE_PLACEMENT), ($clinit_IntermediateProcessorStrategy(), SINGLE_EDGE_GRAPH_WRAPPER));
            break;
        case 2:
            $addAfter($addBefore($addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), BREAKING_POINT_INSERTER)), P4_NODE_PLACEMENT, BREAKING_POINT_PROCESSOR), P5_EDGE_ROUTING, BREAKING_POINT_REMOVER);
    }
    maskUndefined($getProperty(lgraph, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) && $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), SORT_BY_INPUT_ORDER_OF_MODEL));
    return configuration;
}
function $prepareGraphForLayout(this$static, lgraph) {
    var edgeSpacing, direction, randomSeed, favorStraightness, spacings;
    edgeSpacing = $doubleValue(castToDouble($getProperty(lgraph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE))));
    edgeSpacing < 2 && $setProperty_0(lgraph, SPACING_EDGE_EDGE, 2);
    direction = castTo($getProperty(lgraph, DIRECTION), 86);
    direction == ($clinit_Direction(), UNDEFINED_2) && $setProperty_0(lgraph, DIRECTION, getDirection_1(lgraph));
    randomSeed = castTo($getProperty(lgraph, RANDOM_SEED_0), 17);
    randomSeed.value_0 == 0 ? $setProperty_0(lgraph, ($clinit_InternalProperties_1(), RANDOM_0), new Random) : $setProperty_0(lgraph, ($clinit_InternalProperties_1(), RANDOM_0), new Random_0(randomSeed.value_0));
    favorStraightness = castToBoolean($getProperty(lgraph, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0));
    favorStraightness == null && $setProperty_0(lgraph, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0, ($clinit_Boolean(), maskUndefined($getProperty(lgraph, EDGE_ROUTING)) === maskUndefined(($clinit_EdgeRouting(), ORTHOGONAL)) ? true : false));
    $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(lgraph.layerlessNodes, 16)), new GraphConfigurator$lambda$0$Type(this$static));
    $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(lgraph.layers, 16)), new GraphConfigurator$lambda$1$Type), new GraphConfigurator$lambda$2$Type(this$static));
    spacings = new Spacings(lgraph);
    $setProperty_0(lgraph, ($clinit_InternalProperties_1(), SPACINGS), spacings);
    $reset_4(this$static.algorithmAssembler);
    $setPhase(this$static.algorithmAssembler, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), castTo($getProperty(lgraph, CYCLE_BREAKING_STRATEGY_0), 188));
    $setPhase(this$static.algorithmAssembler, P2_LAYERING, castTo($getProperty(lgraph, LAYERING_STRATEGY_0), 188));
    $setPhase(this$static.algorithmAssembler, P3_NODE_ORDERING, castTo($getProperty(lgraph, CROSSING_MINIMIZATION_STRATEGY_0), 188));
    $setPhase(this$static.algorithmAssembler, P4_NODE_PLACEMENT, castTo($getProperty(lgraph, NODE_PLACEMENT_STRATEGY_0), 188));
    $setPhase(this$static.algorithmAssembler, P5_EDGE_ROUTING, factoryFor(castTo($getProperty(lgraph, EDGE_ROUTING), 220)));
    $addProcessorConfiguration(this$static.algorithmAssembler, $getPhaseIndependentLayoutProcessorConfiguration(lgraph));
    $setProperty_0(lgraph, PROCESSORS, $build_0(this$static.algorithmAssembler, lgraph));
}
function GraphConfigurator() {
    $clinit_GraphConfigurator();
    this.algorithmAssembler = new AlgorithmAssembler(Lorg_eclipse_elk_alg_layered_LayeredPhases_2_classLit);
}
function activateGreedySwitchFor(lgraph) {
    var activationThreshold, graphSize, greedySwitchType, interactiveCrossMin;
    if (maskUndefined($getProperty(lgraph, ($clinit_LayeredOptions(), HIERARCHY_HANDLING))) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN))) return !lgraph.parentNode && maskUndefined($getProperty(lgraph, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0)) !== maskUndefined(($clinit_GreedySwitchType(), OFF));
    greedySwitchType = castTo($getProperty(lgraph, CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_0), 298);
    interactiveCrossMin = $booleanValue(castToBoolean($getProperty(lgraph, CROSSING_MINIMIZATION_SEMI_INTERACTIVE_0))) || maskUndefined($getProperty(lgraph, CROSSING_MINIMIZATION_STRATEGY_0)) === maskUndefined(($clinit_CrossingMinimizationStrategy(), INTERACTIVE_1));
    activationThreshold = castTo($getProperty(lgraph, CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD_0), 17).value_0;
    graphSize = lgraph.layerlessNodes.array.length;
    return !interactiveCrossMin && greedySwitchType != ($clinit_GreedySwitchType(), OFF) && (activationThreshold == 0 || activationThreshold > graphSize);
}
defineClass(1241, 1, {}, GraphConfigurator);
var BASELINE_PROCESSING_CONFIGURATION, HIERARCHICAL_ADDITIONS, LABEL_MANAGEMENT_ADDITIONS;
var Lorg_eclipse_elk_alg_layered_GraphConfigurator_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'GraphConfigurator', 1241);
function GraphConfigurator$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(752, 1, $intern_19, GraphConfigurator$lambda$0$Type);
_.accept = function accept_57(arg0) {
    $copyPortConstraints(this.$$outer_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_GraphConfigurator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'GraphConfigurator/lambda$0$Type', 752);
function GraphConfigurator$lambda$1$Type() {}
defineClass(753, 1, {}, GraphConfigurator$lambda$1$Type);
_.apply_0 = function apply_32(arg0) {
    return $clinit_GraphConfigurator(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_GraphConfigurator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'GraphConfigurator/lambda$1$Type', 753);
function GraphConfigurator$lambda$2$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(754, 1, $intern_19, GraphConfigurator$lambda$2$Type);
_.accept = function accept_58(arg0) {
    $copyPortConstraints(this.$$outer_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_GraphConfigurator$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'GraphConfigurator/lambda$2$Type', 754);
function LayeredLayoutProvider() {
    this.elkLayered = new ElkLayered;
}
defineClass(1074, 222, $intern_96, LayeredLayoutProvider);
_.layout = function layout_1(elkgraph, progressMonitor) {
    var layeredGraph;
    layeredGraph = $importGraph_0(new ElkGraphImporter, elkgraph);
    maskUndefined($getProperty_0(elkgraph, ($clinit_LayeredOptions(), HIERARCHY_HANDLING))) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN)) ? $doCompoundLayout(this.elkLayered, layeredGraph, progressMonitor) : $doLayout(this.elkLayered, layeredGraph, progressMonitor);
    progressMonitor.isCanceled() || $applyLayout_1(new ElkGraphLayoutTransferrer, layeredGraph);
};
var Lorg_eclipse_elk_alg_layered_LayeredLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.layered', 'LayeredLayoutProvider', 1074);
function $clinit_LayeredPhases() {
    $clinit_LayeredPhases = emptyMethod;
    P1_CYCLE_BREAKING = new LayeredPhases('P1_CYCLE_BREAKING', 0);
    P2_LAYERING = new LayeredPhases('P2_LAYERING', 1);
    P3_NODE_ORDERING = new LayeredPhases('P3_NODE_ORDERING', 2);
    P4_NODE_PLACEMENT = new LayeredPhases('P4_NODE_PLACEMENT', 3);
    P5_EDGE_ROUTING = new LayeredPhases('P5_EDGE_ROUTING', 4);
}
function LayeredPhases(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_19(name_0) {
    $clinit_LayeredPhases();
    return valueOf(($clinit_LayeredPhases$Map(), $MAP_9), name_0);
}
function values_27() {
    $clinit_LayeredPhases();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_LayeredPhases_2_classLit, 1), $intern_36, 360, 0, [
        P1_CYCLE_BREAKING,
        P2_LAYERING,
        P3_NODE_ORDERING,
        P4_NODE_PLACEMENT,
        P5_EDGE_ROUTING
    ]);
}
defineClass(360, 23, {
    3: 1,
    34: 1,
    23: 1,
    360: 1
}, LayeredPhases);
var P1_CYCLE_BREAKING, P2_LAYERING, P3_NODE_ORDERING, P4_NODE_PLACEMENT, P5_EDGE_ROUTING;
var Lorg_eclipse_elk_alg_layered_LayeredPhases_2_classLit = createForEnum('org.eclipse.elk.alg.layered', 'LayeredPhases', 360, Ljava_lang_Enum_2_classLit, values_27, valueOf_19);
function $clinit_LayeredPhases$Map() {
    $clinit_LayeredPhases$Map = emptyMethod;
    $MAP_9 = createValueOfMap(($clinit_LayeredPhases(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_LayeredPhases_2_classLit, 1), $intern_36, 360, 0, [
        P1_CYCLE_BREAKING,
        P2_LAYERING,
        P3_NODE_ORDERING,
        P4_NODE_PLACEMENT,
        P5_EDGE_ROUTING
    ])));
}
var $MAP_9;
function $clinit_ComponentsToCGraphTransformer() {
    $clinit_ComponentsToCGraphTransformer = emptyMethod;
    SPACING_HANDLER = new ComponentsToCGraphTransformer$1;
}
function $applyLayout_0(this$static) {
    var bottomRight, cNode, cNode$iterator, n, n$iterator, placeholder, placeholder$iterator, topLeft;
    for(n$iterator = new ArrayList$1(this$static.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        n.rect.x_0 = n.hitbox.x_0;
        n.rect.y_0 = n.hitbox.y_0;
    }
    topLeft = new KVector_1($intern_60, $intern_60);
    bottomRight = new KVector_1($intern_61, $intern_61);
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        topLeft.x_0 = $wnd.Math.min(topLeft.x_0, cNode.hitbox.x_0);
        topLeft.y_0 = $wnd.Math.min(topLeft.y_0, cNode.hitbox.y_0);
        bottomRight.x_0 = $wnd.Math.max(bottomRight.x_0, cNode.hitbox.x_0 + cNode.hitbox.width_0);
        bottomRight.y_0 = $wnd.Math.max(bottomRight.y_0, cNode.hitbox.y_0 + cNode.hitbox.height);
    }
    for(placeholder$iterator = $values(this$static.externalPlaceholder).this$01.valueIterator_0(); placeholder$iterator.hasNext_0();){
        placeholder = castTo(placeholder$iterator.next_1(), 47);
        cNode = castTo(placeholder.second, 82);
        topLeft.x_0 = $wnd.Math.min(topLeft.x_0, cNode.hitbox.x_0);
        topLeft.y_0 = $wnd.Math.min(topLeft.y_0, cNode.hitbox.y_0);
        bottomRight.x_0 = $wnd.Math.max(bottomRight.x_0, cNode.hitbox.x_0 + cNode.hitbox.width_0);
        bottomRight.y_0 = $wnd.Math.max(bottomRight.y_0, cNode.hitbox.y_0 + cNode.hitbox.height);
    }
    this$static.globalOffset = $negate_0(new KVector_1(topLeft.x_0, topLeft.y_0));
    this$static.graphSize = $sub_0(new KVector_1(bottomRight.x_0, bottomRight.y_0), topLeft);
    this$static.cGraph.cGroups.array.length = 0;
    this$static.cGraph.cNodes.array.length = 0;
}
function $getOffset(this$static, c) {
    var cOffset;
    cOffset = $sub_0($clone_1(castTo($get_10(this$static.oldPosition, c), 8)), $getPosition(castTo($get_10(this$static.offsets, c), 456).rect));
    return cOffset;
}
function $setLock(cNode, portSides) {
    portSides.isEmpty() && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, ($clinit_PortSide(), SIDES_NORTH)) && $set_4(cNode.lock, true, true, true, false);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_EAST) && $set_4(cNode.lock, false, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_SOUTH) && $set_4(cNode.lock, true, true, false, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_WEST) && $set_4(cNode.lock, true, false, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_EAST) && $set_4(cNode.lock, false, true, true, false);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_EAST_SOUTH) && $set_4(cNode.lock, false, true, false, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_SOUTH_WEST) && $set_4(cNode.lock, true, false, false, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_WEST) && $set_4(cNode.lock, true, false, true, false);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_SOUTH) && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_EAST_WEST) && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_SOUTH) && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_EAST_SOUTH_WEST) && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_SOUTH_WEST) && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_EAST_WEST) && $set_4(cNode.lock, true, true, true, true);
    equals_Ljava_lang_Object__Z__devirtual$(portSides, SIDES_NORTH_EAST_SOUTH_WEST) && $set_4(cNode.lock, true, true, true, true);
}
function $transform_0(this$static, ccs) {
    var comp, comp$iterator, dummyGroup, ee, ee$iterator, group, rect, rect$iterator, rectNode, rectPlaceholder;
    this$static.cGraph = new CGraph_0(allOf(Lorg_eclipse_elk_core_options_Direction_2_classLit));
    for(comp$iterator = new ArrayList$1(ccs.components); comp$iterator.i < comp$iterator.this$01.array.length;){
        comp = castTo($next_6(comp$iterator), 834);
        group = new CGroup_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_oned_CNode_2_classLit, 1), $intern_2, 82, 0, []));
        $add_3(this$static.cGraph.cGroups, group);
        for(rect$iterator = new ArrayList$1(comp.rectilinearConvexHull); rect$iterator.i < rect$iterator.this$01.array.length;){
            rect = castTo($next_6(rect$iterator), 119);
            rectNode = new ComponentsToCGraphTransformer$CRectNode(this$static, rect);
            $setLock(rectNode, castTo($getProperty(comp.graph_0, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22));
            if (!$containsKey_3(this$static.oldPosition, comp)) {
                $put_6(this$static.oldPosition, comp, new KVector_1(rect.x_0, rect.y_0));
                $put_6(this$static.offsets, comp, rectNode);
            }
            $add_3(this$static.cGraph.cNodes, rectNode);
            $addCNode_0(group, rectNode);
        }
        for(ee$iterator = new ArrayList$1(comp.externalExtensions); ee$iterator.i < ee$iterator.this$01.array.length;){
            ee = castTo($next_6(ee$iterator), 586);
            rectNode = new ComponentsToCGraphTransformer$CRectNode(this$static, ee.getRepresentor());
            $put_6(this$static.externalExtensions, ee, new Pair(group, rectNode));
            $setLock(rectNode, castTo($getProperty(comp.graph_0, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22));
            if (ee.getPlaceholder()) {
                rectPlaceholder = new ComponentsToCGraphTransformer$CRectNode_0(this$static, ee.getPlaceholder(), 1);
                $setLock(rectPlaceholder, castTo($getProperty(comp.graph_0, EXT_PORT_CONNECTIONS), 22));
                dummyGroup = new CGroup_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_oned_CNode_2_classLit, 1), $intern_2, 82, 0, []));
                $addCNode_0(dummyGroup, rectPlaceholder);
                $put(this$static.externalPlaceholder, ee.getDirection(), new Pair(group, rectPlaceholder));
            }
        }
    }
    return this$static.cGraph;
}
function ComponentsToCGraphTransformer(spacing) {
    $clinit_ComponentsToCGraphTransformer();
    this.oldPosition = new HashMap;
    this.offsets = new HashMap;
    this.externalExtensions = new HashMap;
    this.externalPlaceholder = new HashMultimap;
    this.spacing = spacing;
}
defineClass(1659, 1, {}, ComponentsToCGraphTransformer);
_.spacing = 0;
var SPACING_HANDLER;
var Lorg_eclipse_elk_alg_layered_compaction_components_ComponentsToCGraphTransformer_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.components', 'ComponentsToCGraphTransformer', 1659);
function $clinit_ISpacingsHandler_0() {
    $clinit_ISpacingsHandler_0 = emptyMethod;
    DEFAULT_SPACING_HANDLER_0 = new ISpacingsHandler$1_0;
}
var DEFAULT_SPACING_HANDLER_0;
function ComponentsToCGraphTransformer$1() {}
defineClass(1660, 1, {}, ComponentsToCGraphTransformer$1);
_.getHorizontalSpacing_0 = function getHorizontalSpacing_0(cNode1, cNode2) {
    return $wnd.Math.min(cNode1.individualSpacing != null ? $doubleValue(cNode1.individualSpacing) : cNode1.this$01.spacing, cNode2.individualSpacing != null ? $doubleValue(cNode2.individualSpacing) : cNode2.this$01.spacing);
};
_.getVerticalSpacing_0 = function getVerticalSpacing_0(cNode1, cNode2) {
    return $wnd.Math.min(cNode1.individualSpacing != null ? $doubleValue(cNode1.individualSpacing) : cNode1.this$01.spacing, cNode2.individualSpacing != null ? $doubleValue(cNode2.individualSpacing) : cNode2.this$01.spacing);
};
var Lorg_eclipse_elk_alg_layered_compaction_components_ComponentsToCGraphTransformer$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.components', 'ComponentsToCGraphTransformer/1', 1660);
defineClass(82, 1, {
    82: 1
});
_.id_0 = 0;
_.reposition = true;
_.startPos = $intern_61;
var Lorg_eclipse_elk_alg_layered_compaction_oned_CNode_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'CNode', 82);
function ComponentsToCGraphTransformer$CRectNode(this$0, rect) {
    ComponentsToCGraphTransformer$CRectNode_0.call(this, this$0, rect, null);
}
function ComponentsToCGraphTransformer$CRectNode_0(this$0, rect, spacing) {
    this.this$01 = this$0;
    this.constraints = new ArrayList;
    this.cGroupOffset = new KVector;
    this.lock = new Quadruplet_0;
    this.spacingIgnore = new Quadruplet_0;
    this.rect = rect;
    this.hitbox = new ElkRectangle_0(rect.x_0, rect.y_0, rect.width_0, rect.height);
    this.individualSpacing = spacing;
}
defineClass(456, 82, {
    456: 1,
    82: 1
}, ComponentsToCGraphTransformer$CRectNode, ComponentsToCGraphTransformer$CRectNode_0);
_.toString_0 = function toString_82() {
    return '';
};
var Lorg_eclipse_elk_alg_layered_compaction_components_ComponentsToCGraphTransformer$CRectNode_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.components', 'ComponentsToCGraphTransformer/CRectNode', 456);
function $clinit_OneDimensionalComponentsCompaction() {
    $clinit_OneDimensionalComponentsCompaction = emptyMethod;
    LEFT_RIGHT = newHashSet_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Direction_2_classLit, 1), $intern_36, 86, 0, [
        ($clinit_Direction(), LEFT_6),
        RIGHT_6
    ]));
    UP_DOWN = newHashSet_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Direction_2_classLit, 1), $intern_36, 86, 0, [
        UP_1,
        DOWN_1
    ]));
}
function $addExternalEdgeRepresentations(this$static, ees) {
    var p, p$iterator;
    for(p$iterator = new ArrayList$1(ees); p$iterator.i < p$iterator.this$01.array.length;){
        p = castTo($next_6(p$iterator), 47);
        $add_3(this$static.compactionGraph.cNodes, castTo(p.second, 82));
        $addCNode_0(castTo(p.first, 194), castTo(p.second, 82));
    }
}
function $addPlaceholders(this$static, dir_0) {
    var d, d$iterator, dirs, pair, pair$iterator;
    dirs = dir_0 == 1 ? UP_DOWN : LEFT_RIGHT;
    for(d$iterator = dirs.map_0.keySet_0().iterator_0(); d$iterator.hasNext_0();){
        d = castTo(d$iterator.next_1(), 86);
        for(pair$iterator = castTo($get(this$static.transformer.externalPlaceholder, d), 22).iterator_0(); pair$iterator.hasNext_0();){
            pair = castTo(pair$iterator.next_1(), 47);
            $add_3(this$static.compactionGraph.cNodes, castTo(pair.second, 82));
            $add_3(this$static.compactionGraph.cGroups, castTo(pair.second, 82).cGroup);
        }
    }
}
function $compact_0(this$static) {
    var delta, direction, g, g$iterator, g$iterator0, g$iterator1, g$iterator2;
    delta = 0;
    for(g$iterator0 = new ArrayList$1(this$static.compactionGraph.cGroups); g$iterator0.i < g$iterator0.this$01.array.length;){
        g = castTo($next_6(g$iterator0), 194);
        g.delta = 0;
        g.deltaNormalized = 0;
    }
    $addPlaceholders(this$static, 0);
    $addExternalEdgeRepresentations(this$static, this$static.verticalExternalExtensions);
    $calculateGroupOffsets_0(this$static.compactor);
    $forceConstraintsRecalculation(this$static.compactor);
    direction = ($clinit_Direction(), LEFT_6);
    $compact_2($applyLockingStrategy($changeDirection_0($compact_2($applyLockingStrategy($changeDirection_0($compact_2($changeDirection_0(this$static.compactor, direction)), $opposite(direction)))), direction)));
    $changeDirection_0(this$static.compactor, LEFT_6);
    $removeExternalEdgeRepresentations(this$static, this$static.verticalExternalExtensions);
    $removePlaceholders(this$static, 0);
    $updateExternalExtensionDimensions(this$static, 0);
    $updatePlaceholders(this$static, 1);
    $addPlaceholders(this$static, 1);
    $addExternalEdgeRepresentations(this$static, this$static.horizontalExternalExtensions);
    $calculateGroupOffsets_0(this$static.compactor);
    for(g$iterator1 = new ArrayList$1(this$static.compactionGraph.cGroups); g$iterator1.i < g$iterator1.this$01.array.length;){
        g = castTo($next_6(g$iterator1), 194);
        delta += $wnd.Math.abs(g.deltaNormalized);
    }
    for(g$iterator2 = new ArrayList$1(this$static.compactionGraph.cGroups); g$iterator2.i < g$iterator2.this$01.array.length;){
        g = castTo($next_6(g$iterator2), 194);
        g.delta = 0;
        g.deltaNormalized = 0;
    }
    direction = UP_1;
    $compact_2($applyLockingStrategy($changeDirection_0($compact_2($applyLockingStrategy($changeDirection_0($compact_2($forceConstraintsRecalculation($changeDirection_0(this$static.compactor, direction))), $opposite(direction)))), direction)));
    $changeDirection_0(this$static.compactor, LEFT_6);
    $removeExternalEdgeRepresentations(this$static, this$static.horizontalExternalExtensions);
    $removePlaceholders(this$static, 1);
    $updateExternalExtensionDimensions(this$static, 1);
    $updatePlaceholders(this$static, 0);
    $forceConstraintsRecalculation(this$static.compactor);
    for(g$iterator = new ArrayList$1(this$static.compactionGraph.cGroups); g$iterator.i < g$iterator.this$01.array.length;){
        g = castTo($next_6(g$iterator), 194);
        delta += $wnd.Math.abs(g.deltaNormalized);
    }
    return delta;
}
function $compact_1(this$static) {
    var allNodes, cNode, cNode$iterator, delta, entry, entry$iterator, run;
    allNodes = new ArrayList;
    this$static.verticalExternalExtensions = new ArrayList;
    this$static.horizontalExternalExtensions = new ArrayList;
    for(entry$iterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(this$static.transformer.externalExtensions).this$01); entry$iterator.hasNext;){
        entry = $next_3(entry$iterator);
        $add_3(allNodes, castTo(castTo(entry.getValue(), 47).second, 82));
        $isHorizontal(castTo(entry.getKey(), 586).getDirection()) ? $add_3(this$static.horizontalExternalExtensions, castTo(entry.getValue(), 47)) : $add_3(this$static.verticalExternalExtensions, castTo(entry.getValue(), 47));
    }
    $addExternalEdgeRepresentations(this$static, this$static.horizontalExternalExtensions);
    $addExternalEdgeRepresentations(this$static, this$static.verticalExternalExtensions);
    this$static.compactor = new OneDimensionalCompactor_0(this$static.compactionGraph);
    $setSpacingsHandler_0(this$static.compactor, ($clinit_ComponentsToCGraphTransformer(), SPACING_HANDLER));
    $removeExternalEdgeRepresentations(this$static, this$static.horizontalExternalExtensions);
    $removeExternalEdgeRepresentations(this$static, this$static.verticalExternalExtensions);
    $addAll_2(allNodes, this$static.compactor.cGraph.cNodes);
    this$static.topLeft = new KVector_1($intern_60, $intern_60);
    this$static.bottomRight = new KVector_1($intern_61, $intern_61);
    for(cNode$iterator = new ArrayList$1(allNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        this$static.topLeft.x_0 = $wnd.Math.min(this$static.topLeft.x_0, cNode.hitbox.x_0);
        this$static.topLeft.y_0 = $wnd.Math.min(this$static.topLeft.y_0, cNode.hitbox.y_0);
        this$static.bottomRight.x_0 = $wnd.Math.max(this$static.bottomRight.x_0, cNode.hitbox.x_0 + cNode.hitbox.width_0);
        this$static.bottomRight.y_0 = $wnd.Math.max(this$static.bottomRight.y_0, cNode.hitbox.y_0 + cNode.hitbox.height);
    }
    $setLockingStrategy(this$static.compactor, new OneDimensionalComponentsCompaction$lambda$0$Type);
    run = 0;
    do {
        delta = $compact_0(this$static);
        ++run;
    }while ((run < 2 || delta > $intern_41) && run < 10);
    $setLockingStrategy(this$static.compactor, new OneDimensionalComponentsCompaction$lambda$1$Type);
    $compact_0(this$static);
    $finish(this$static.compactor);
    $applyLayout_0(this$static.transformer);
}
function $getOffset_0(this$static, c) {
    var individual;
    individual = $getOffset(this$static.transformer, c);
    return $add_19($negate_0(individual), this$static.transformer.globalOffset);
}
function $removeExternalEdgeRepresentations(this$static, ees) {
    var p, p$iterator;
    for(p$iterator = new ArrayList$1(ees); p$iterator.i < p$iterator.this$01.array.length;){
        p = castTo($next_6(p$iterator), 47);
        $remove_12(this$static.compactionGraph.cNodes, p.second);
        $removeCNode(castTo(p.first, 194), castTo(p.second, 82));
    }
}
function $removePlaceholders(this$static, dir_0) {
    var d, d$iterator, dirs, pair, pair$iterator;
    dirs = dir_0 == 1 ? UP_DOWN : LEFT_RIGHT;
    for(d$iterator = dirs.map_0.keySet_0().iterator_0(); d$iterator.hasNext_0();){
        d = castTo(d$iterator.next_1(), 86);
        for(pair$iterator = castTo($get(this$static.transformer.externalPlaceholder, d), 22).iterator_0(); pair$iterator.hasNext_0();){
            pair = castTo(pair$iterator.next_1(), 47);
            $remove_12(this$static.compactionGraph.cNodes, pair.second);
            $remove_12(this$static.compactionGraph.cGroups, castTo(pair.second, 82).cGroup);
        }
    }
}
function $updateExternalExtensionDimensions(this$static, dir_0) {
    var adelta, cNode, ee, entry, entry$iterator, group;
    for(entry$iterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(this$static.transformer.externalExtensions).this$01); entry$iterator.hasNext;){
        entry = $next_3(entry$iterator);
        ee = castTo(entry.getKey(), 586);
        if (dir_0 == 1) {
            if (ee.getDirection() != ($clinit_Direction(), UP_1) && ee.getDirection() != DOWN_1) continue;
        } else {
            if (ee.getDirection() != ($clinit_Direction(), LEFT_6) && ee.getDirection() != RIGHT_6) continue;
        }
        cNode = castTo(castTo(entry.getValue(), 47).second, 82);
        group = castTo(castTo(entry.getValue(), 47).first, 194);
        adelta = group.deltaNormalized;
        switch(ee.getDirection().ordinal){
            case 2:
                cNode.hitbox.x_0 = this$static.topLeft.x_0;
                cNode.hitbox.width_0 = $wnd.Math.max(1, cNode.hitbox.width_0 + adelta);
                break;
            case 1:
                cNode.hitbox.x_0 = cNode.hitbox.x_0 + adelta;
                cNode.hitbox.width_0 = $wnd.Math.max(1, cNode.hitbox.width_0 - adelta);
                break;
            case 4:
                cNode.hitbox.y_0 = this$static.topLeft.y_0;
                cNode.hitbox.height = $wnd.Math.max(1, cNode.hitbox.height + adelta);
                break;
            case 3:
                cNode.hitbox.y_0 = cNode.hitbox.y_0 + adelta;
                cNode.hitbox.height = $wnd.Math.max(1, cNode.hitbox.height - adelta);
        }
    }
}
function $updatePlaceholders(this$static, dir_0) {
    var adelta, cNode, d, d$iterator, dirs, pair, pair$iterator, parentComponentGroup;
    dirs = dir_0 == 1 ? UP_DOWN : LEFT_RIGHT;
    for(d$iterator = dirs.map_0.keySet_0().iterator_0(); d$iterator.hasNext_0();){
        d = castTo(d$iterator.next_1(), 86);
        for(pair$iterator = castTo($get(this$static.transformer.externalPlaceholder, d), 22).iterator_0(); pair$iterator.hasNext_0();){
            pair = castTo(pair$iterator.next_1(), 47);
            cNode = castTo(pair.second, 82);
            parentComponentGroup = castTo(pair.first, 194);
            adelta = parentComponentGroup.deltaNormalized;
            switch(d.ordinal){
                case 2:
                case 1:
                    cNode.hitbox.y_0 += adelta;
                    break;
                case 4:
                case 3:
                    cNode.hitbox.x_0 += adelta;
            }
        }
    }
}
function OneDimensionalComponentsCompaction() {}
function lambda$0_17(pair_0) {
    $clinit_OneDimensionalComponentsCompaction();
    return $clinit_Boolean(), castTo(pair_0.first, 82).cGroup.outDegree != 0 ? true : false;
}
function lambda$1_5(pair_0) {
    $clinit_OneDimensionalComponentsCompaction();
    return $clinit_Boolean(), $get_19(castTo(pair_0.first, 82).lock, castTo(pair_0.second, 86)) || castTo(pair_0.first, 82).cGroup.outDegree != 0 && $get_19(castTo(pair_0.first, 82).lock, castTo(pair_0.second, 86)) ? true : false;
}
defineClass(1629, 1, {}, OneDimensionalComponentsCompaction);
var LEFT_RIGHT, UP_DOWN;
var Lorg_eclipse_elk_alg_layered_compaction_components_OneDimensionalComponentsCompaction_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.components', 'OneDimensionalComponentsCompaction', 1629);
function OneDimensionalComponentsCompaction$lambda$0$Type() {}
defineClass(1630, 1, {}, OneDimensionalComponentsCompaction$lambda$0$Type);
_.apply_0 = function apply_33(arg0) {
    return lambda$0_17(castTo(arg0, 47));
};
_.equals_0 = function equals_76(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_compaction_components_OneDimensionalComponentsCompaction$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.components', 'OneDimensionalComponentsCompaction/lambda$0$Type', 1630);
function OneDimensionalComponentsCompaction$lambda$1$Type() {}
defineClass(1631, 1, {}, OneDimensionalComponentsCompaction$lambda$1$Type);
_.apply_0 = function apply_34(arg0) {
    return lambda$1_5(castTo(arg0, 47));
};
_.equals_0 = function equals_77(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_compaction_components_OneDimensionalComponentsCompaction$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.components', 'OneDimensionalComponentsCompaction/lambda$1$Type', 1631);
function $supports_0(this$static, direction) {
    return $containsEnum(this$static.supportedDirections, direction);
}
function CGraph_0(supportedDirections) {
    this.cNodes = new ArrayList;
    this.cGroups = new ArrayList;
    this.supportedDirections = supportedDirections;
}
defineClass(1662, 1, {}, CGraph_0);
var Lorg_eclipse_elk_alg_layered_compaction_oned_CGraph_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'CGraph', 1662);
function $addCNode_0(this$static, cNode) {
    $add_6(this$static.cNodes, cNode);
    if (cNode.cGroup) throw toJs(new RuntimeException_0('CNode belongs to another CGroup.'));
    cNode.cGroup = this$static;
}
function $removeCNode(this$static, cNode) {
    var removed;
    removed = $remove_18(this$static.cNodes, cNode);
    removed && (cNode.cGroup = null);
    return removed;
}
function CGroup_0(inputCNodes) {
    var cNode, cNode$array, cNode$index, cNode$max;
    this.cNodes = new LinkedHashSet;
    this.incomingConstraints = new HashSet;
    this.outDegree = 0;
    for(cNode$array = inputCNodes, cNode$index = 0, cNode$max = cNode$array.length; cNode$index < cNode$max; ++cNode$index){
        cNode = cNode$array[cNode$index];
        !this.reference && (this.reference = cNode);
        $addCNode_0(this, cNode);
    }
}
defineClass(194, 1, {
    194: 1
}, CGroup_0);
_.delta = 0;
_.deltaNormalized = 0;
_.outDegree = 0;
_.reposition = true;
_.startPos = $intern_61;
var Lorg_eclipse_elk_alg_layered_compaction_oned_CGroup_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'CGroup', 194);
function ISpacingsHandler$1_0() {}
defineClass(1661, 1, {}, ISpacingsHandler$1_0);
_.getHorizontalSpacing_0 = function getHorizontalSpacing_1(cNode1, cNode2) {
    return $wnd.Math.max(cNode1.individualSpacing != null ? $doubleValue(cNode1.individualSpacing) : cNode1.this$01.spacing, cNode2.individualSpacing != null ? $doubleValue(cNode2.individualSpacing) : cNode2.this$01.spacing);
};
_.getVerticalSpacing_0 = function getVerticalSpacing_1(cNode1, cNode2) {
    return $wnd.Math.max(cNode1.individualSpacing != null ? $doubleValue(cNode1.individualSpacing) : cNode1.this$01.spacing, cNode2.individualSpacing != null ? $doubleValue(cNode2.individualSpacing) : cNode2.this$01.spacing);
};
var Lorg_eclipse_elk_alg_layered_compaction_oned_ISpacingsHandler$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'ISpacingsHandler/1', 1661);
function $clinit_OneDimensionalCompactor_0() {
    $clinit_OneDimensionalCompactor_0 = emptyMethod;
    SCANLINE_CONSTRAINTS_0 = new ScanlineConstraintCalculator_0;
}
function $applyLockingStrategy(this$static) {
    $applyLockingStrategy_0(this$static, this$static.direction);
    return this$static;
}
function $applyLockingStrategy_0(this$static, dir_0) {
    var cGroup, cGroup$iterator, cNode, cNode$iterator;
    for(cGroup$iterator = new ArrayList$1(this$static.cGraph.cGroups); cGroup$iterator.i < cGroup$iterator.this$01.array.length;){
        cGroup = castTo($next_6(cGroup$iterator), 194);
        cGroup.reposition = true;
    }
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        cNode.reposition = $booleanValue(castToBoolean(this$static.lockingStrategy.apply_0(new Pair(cNode, dir_0))));
        cNode.cGroup.reposition = cNode.cGroup.reposition & $booleanValue(castToBoolean(this$static.lockingStrategy.apply_0(new Pair(cNode, dir_0))));
    }
    return this$static;
}
function $calculateConstraints_0(this$static) {
    var cNode, cNode$iterator;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        cNode.constraints.clear_0();
    }
    $calculateConstraints_1(this$static.constraintAlgorithm, this$static);
    $calculateConstraintsForCGroups_0(this$static);
}
function $calculateConstraintsForCGroups_0(this$static) {
    var cNode, cNode$iterator, group, group$iterator, group$iterator0, inc, inc$iterator;
    for(group$iterator0 = new ArrayList$1(this$static.cGraph.cGroups); group$iterator0.i < group$iterator0.this$01.array.length;){
        group = castTo($next_6(group$iterator0), 194);
        group.outDegree = 0;
        group.incomingConstraints.map_0.clear_0();
    }
    for(group$iterator = new ArrayList$1(this$static.cGraph.cGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 194);
        for(cNode$iterator = group.cNodes.map_0.keySet_0().iterator_0(); cNode$iterator.hasNext_0();){
            cNode = castTo(cNode$iterator.next_1(), 82);
            for(inc$iterator = cNode.constraints.iterator_0(); inc$iterator.hasNext_0();){
                inc = castTo(inc$iterator.next_1(), 82);
                if (inc.cGroup != group) {
                    $add_6(group.incomingConstraints, inc);
                    ++inc.cGroup.outDegree;
                }
            }
        }
    }
}
function $calculateGroupOffsets_0(this$static) {
    var group, group$iterator, n, n$iterator, n$iterator0;
    for(group$iterator = new ArrayList$1(this$static.cGraph.cGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 194);
        group.reference = null;
        for(n$iterator0 = group.cNodes.map_0.keySet_0().iterator_0(); n$iterator0.hasNext_0();){
            n = castTo(n$iterator0.next_1(), 82);
            $reset_5(n.cGroupOffset);
            (!group.reference || n.hitbox.x_0 < group.reference.hitbox.x_0) && (group.reference = n);
        }
        for(n$iterator = group.cNodes.map_0.keySet_0().iterator_0(); n$iterator.hasNext_0();){
            n = castTo(n$iterator.next_1(), 82);
            n.cGroupOffset.x_0 = n.hitbox.x_0 - group.reference.hitbox.x_0;
            n.cGroupOffset.y_0 = n.hitbox.y_0 - group.reference.hitbox.y_0;
        }
    }
    return this$static;
}
function $changeDirection_0(this$static, dir_0) {
    var oldDirection;
    if (this$static.finished) throw toJs(new IllegalStateException_0(($ensureNamesAreInitialized(Lorg_eclipse_elk_alg_layered_compaction_oned_OneDimensionalCompactor_2_classLit), 'The ' + Lorg_eclipse_elk_alg_layered_compaction_oned_OneDimensionalCompactor_2_classLit.simpleName + ' instance has been finished already.')));
    if (!$supports_0(this$static.cGraph, dir_0)) throw toJs(new RuntimeException_0('The direction ' + dir_0 + ' is not supported by the CGraph instance.'));
    if (dir_0 == this$static.direction) return this$static;
    oldDirection = this$static.direction;
    this$static.direction = dir_0;
    switch(oldDirection.ordinal){
        case 0:
            switch(dir_0.ordinal){
                case 2:
                    $calculateConstraints_0(this$static);
                    break;
                case 1:
                    $mirrorHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 4:
                    $transposeHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 3:
                    $transposeHitboxes_0(this$static);
                    $mirrorHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
            }
            break;
        case 2:
            switch(dir_0.ordinal){
                case 1:
                    $mirrorHitboxes_0(this$static);
                    $reverseConstraints_0(this$static);
                    break;
                case 4:
                    $transposeHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 3:
                    $transposeHitboxes_0(this$static);
                    $mirrorHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
            }
            break;
        case 1:
            switch(dir_0.ordinal){
                case 2:
                    $mirrorHitboxes_0(this$static);
                    $reverseConstraints_0(this$static);
                    break;
                case 4:
                    $mirrorHitboxes_0(this$static);
                    $transposeHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 3:
                    $mirrorHitboxes_0(this$static);
                    $transposeHitboxes_0(this$static);
                    $mirrorHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
            }
            break;
        case 4:
            switch(dir_0.ordinal){
                case 2:
                    $transposeHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 1:
                    $transposeHitboxes_0(this$static);
                    $mirrorHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 3:
                    $mirrorHitboxes_0(this$static);
                    $reverseConstraints_0(this$static);
            }
            break;
        case 3:
            switch(dir_0.ordinal){
                case 2:
                    $mirrorHitboxes_0(this$static);
                    $transposeHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 1:
                    $mirrorHitboxes_0(this$static);
                    $transposeHitboxes_0(this$static);
                    $mirrorHitboxes_0(this$static);
                    $calculateConstraints_0(this$static);
                    break;
                case 4:
                    $mirrorHitboxes_0(this$static);
                    $reverseConstraints_0(this$static);
            }
    }
    return this$static;
}
function $compact_2(this$static) {
    var g, g$iterator, incN, incN$iterator, n, n$iterator, node, node$iterator;
    if (this$static.finished) throw toJs(new IllegalStateException_0(($ensureNamesAreInitialized(Lorg_eclipse_elk_alg_layered_compaction_oned_OneDimensionalCompactor_2_classLit), 'The ' + Lorg_eclipse_elk_alg_layered_compaction_oned_OneDimensionalCompactor_2_classLit.simpleName + ' instance has been finished already.')));
    this$static.direction == ($clinit_Direction(), UNDEFINED_2) && $changeDirection_0(this$static, LEFT_6);
    for(g$iterator = new ArrayList$1(this$static.cGraph.cGroups); g$iterator.i < g$iterator.this$01.array.length;){
        g = castTo($next_6(g$iterator), 194);
        g.outDegree = 0;
    }
    for(n$iterator = new ArrayList$1(this$static.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        n.startPos = $intern_61;
        for(incN$iterator = n.constraints.iterator_0(); incN$iterator.hasNext_0();){
            incN = castTo(incN$iterator.next_1(), 82);
            ++incN.cGroup.outDegree;
        }
    }
    $compact_3(this$static);
    for(node$iterator = new ArrayList$1(this$static.cGraph.cNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 82);
        node.reposition = true;
    }
    return this$static;
}
function $finish(this$static) {
    $changeDirection_0(this$static, ($clinit_Direction(), LEFT_6));
    this$static.finished = true;
    return this$static;
}
function $forceConstraintsRecalculation(this$static) {
    $calculateConstraints_0(this$static);
    return this$static;
}
function $mirrorHitboxes_0(this$static) {
    var cNode, cNode$iterator;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        cNode.hitbox.x_0 = -cNode.hitbox.x_0 - cNode.hitbox.width_0;
    }
    $calculateGroupOffsets_0(this$static);
}
function $reverseConstraints_0(this$static) {
    var cNode, cNode$iterator, cNode$iterator0, cNode$iterator1, inc, inc$iterator, incMap;
    incMap = new HashMap;
    for(cNode$iterator0 = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator0.i < cNode$iterator0.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator0), 82);
        $put_6(incMap, cNode, new ArrayList);
    }
    for(cNode$iterator1 = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator1.i < cNode$iterator1.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator1), 82);
        cNode.startPos = $intern_61;
        for(inc$iterator = cNode.constraints.iterator_0(); inc$iterator.hasNext_0();){
            inc = castTo(inc$iterator.next_1(), 82);
            castTo(getEntryValueOrNull($getEntry_0(incMap.hashCodeMap, inc)), 15).add_2(cNode);
        }
    }
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        cNode.constraints.clear_0();
        cNode.constraints = castTo(getEntryValueOrNull($getEntry_0(incMap.hashCodeMap, cNode)), 15);
    }
    $calculateConstraintsForCGroups_0(this$static);
}
function $setLockingStrategy(this$static, strategy) {
    this$static.lockingStrategy = strategy;
    return this$static;
}
function $setSpacingsHandler_0(this$static, handler) {
    this$static.spacingsHandler = handler;
    return this$static;
}
function $transposeHitboxes_0(this$static) {
    var cNode, cNode$iterator, tmp;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        tmp = cNode.hitbox.x_0;
        cNode.hitbox.x_0 = cNode.hitbox.y_0;
        cNode.hitbox.y_0 = tmp;
        tmp = cNode.hitbox.width_0;
        cNode.hitbox.width_0 = cNode.hitbox.height;
        cNode.hitbox.height = tmp;
        tmp = cNode.cGroupOffset.x_0;
        cNode.cGroupOffset.x_0 = cNode.cGroupOffset.y_0;
        cNode.cGroupOffset.y_0 = tmp;
    }
    $calculateGroupOffsets_0(this$static);
}
function OneDimensionalCompactor_0(cGraph) {
    $clinit_OneDimensionalCompactor_0();
    var group, n, n$iterator;
    this.constraintAlgorithm = SCANLINE_CONSTRAINTS_0;
    this.direction = ($clinit_Direction(), UNDEFINED_2);
    this.spacingsHandler = ($clinit_ISpacingsHandler_0(), DEFAULT_SPACING_HANDLER_0);
    this.cGraph = cGraph;
    $setLockingStrategy(this, new OneDimensionalCompactor$lambda$0$Type_0);
    $calculateGroupOffsets_0(this);
    for(n$iterator = new ArrayList$1(cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        if (!n.cGroup) {
            group = new CGroup_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_oned_CNode_2_classLit, 1), $intern_2, 82, 0, [
                n
            ]));
            $add_3(cGraph.cGroups, group);
        }
    }
}
defineClass(1663, 1, {}, OneDimensionalCompactor_0);
_.finished = false;
var SCANLINE_CONSTRAINTS_0;
var Lorg_eclipse_elk_alg_layered_compaction_oned_OneDimensionalCompactor_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'OneDimensionalCompactor', 1663);
function OneDimensionalCompactor$lambda$0$Type_0() {}
defineClass(1664, 1, {}, OneDimensionalCompactor$lambda$0$Type_0);
_.apply_0 = function apply_35(arg0) {
    return $clinit_OneDimensionalCompactor_0(), $clinit_Boolean(), castTo(castTo(arg0, 47).first, 82).cGroup.outDegree != 0 ? true : false;
};
_.equals_0 = function equals_78(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_compaction_oned_OneDimensionalCompactor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'OneDimensionalCompactor/lambda$0$Type', 1664);
function $get_19(this$static, direction) {
    switch(direction.ordinal){
        case 2:
            return this$static.left;
        case 1:
            return this$static.right;
        case 4:
            return this$static.up;
        case 3:
            return this$static.down;
        default:
            return false;
    }
}
function $set_4(this$static, l, r, u, d) {
    this$static.left = l;
    this$static.right = r;
    this$static.up = u;
    this$static.down = d;
}
function Quadruplet_0() {
    $set_4(this, false, false, false, false);
}
defineClass(812, 1, {}, Quadruplet_0);
_.down = false;
_.left = false;
_.right = false;
_.up = false;
var Lorg_eclipse_elk_alg_layered_compaction_oned_Quadruplet_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned', 'Quadruplet', 812);
function $compact_3(compactor) {
    var cNode, cNode$iterator, cNode$iterator0, diff, group, group$iterator, incNode, incNode$iterator, minStartPos, node, node$iterator, node$iterator0, sinks, spacing, suggestedX;
    minStartPos = $intern_60;
    for(cNode$iterator0 = new ArrayList$1(compactor.cGraph.cNodes); cNode$iterator0.i < cNode$iterator0.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator0), 82);
        minStartPos = $wnd.Math.min(minStartPos, cNode.cGroup.reference.hitbox.x_0 + cNode.cGroupOffset.x_0);
    }
    sinks = new LinkedList;
    for(group$iterator = new ArrayList$1(compactor.cGraph.cGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 194);
        group.startPos = minStartPos;
        group.outDegree == 0 && $addNode_0(sinks, group, sinks.tail.prev, sinks.tail);
    }
    while(sinks.size_0 != 0){
        group = castTo(sinks.size_0 == 0 ? null : (checkCriticalElement(sinks.size_0 != 0), $removeNode_0(sinks, sinks.header.next_0)), 194);
        diff = group.reference.hitbox.x_0;
        for(node$iterator0 = group.cNodes.map_0.keySet_0().iterator_0(); node$iterator0.hasNext_0();){
            node = castTo(node$iterator0.next_1(), 82);
            suggestedX = group.startPos + node.cGroupOffset.x_0;
            node.cGroup.reposition || node.hitbox.x_0 < suggestedX ? node.startPos = suggestedX : node.startPos = node.hitbox.x_0;
        }
        diff -= group.reference.startPos;
        group.delta += diff;
        compactor.direction == ($clinit_Direction(), RIGHT_6) || compactor.direction == DOWN_1 ? group.deltaNormalized += diff : group.deltaNormalized -= diff;
        for(node$iterator = group.cNodes.map_0.keySet_0().iterator_0(); node$iterator.hasNext_0();){
            node = castTo(node$iterator.next_1(), 82);
            for(incNode$iterator = node.constraints.iterator_0(); incNode$iterator.hasNext_0();){
                incNode = castTo(incNode$iterator.next_1(), 82);
                $isHorizontal(compactor.direction) ? spacing = compactor.spacingsHandler.getHorizontalSpacing_0(node, incNode) : spacing = compactor.spacingsHandler.getVerticalSpacing_0(node, incNode);
                incNode.cGroup.startPos = $wnd.Math.max(incNode.cGroup.startPos, node.startPos + node.hitbox.width_0 + spacing - incNode.cGroupOffset.x_0);
                incNode.reposition || (incNode.cGroup.startPos = $wnd.Math.max(incNode.cGroup.startPos, incNode.hitbox.x_0 - incNode.cGroupOffset.x_0));
                --incNode.cGroup.outDegree;
                incNode.cGroup.outDegree == 0 && $add_7(sinks, incNode.cGroup);
            }
        }
    }
    for(cNode$iterator = new ArrayList$1(compactor.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 82);
        cNode.hitbox.x_0 = cNode.startPos;
    }
}
function $blowUpHitboxes(this$static) {
    var n, n$iterator, spacing;
    for(n$iterator = new ArrayList$1(this$static.compactor.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        spacing = (checkCriticalNotNull(0), 0);
        if (spacing > 0) {
            !($isHorizontal(this$static.compactor.direction) && n.spacingIgnore.up) && !($isVertical(this$static.compactor.direction) && n.spacingIgnore.left) && (n.hitbox.y_0 -= $wnd.Math.max(0, spacing / 2 - 0.5));
            !($isHorizontal(this$static.compactor.direction) && n.spacingIgnore.down) && !($isVertical(this$static.compactor.direction) && n.spacingIgnore.right) && (n.hitbox.height += $wnd.Math.max(0, spacing - 1));
        }
    }
}
function $calculateConstraints_1(this$static, theCompactor) {
    this$static.compactor = theCompactor;
    $sweep_1(this$static);
}
function $normalizeHitboxes(this$static) {
    var n, n$iterator, spacing;
    for(n$iterator = new ArrayList$1(this$static.compactor.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        spacing = (checkCriticalNotNull(0), 0);
        if (spacing > 0) {
            !($isHorizontal(this$static.compactor.direction) && n.spacingIgnore.up) && !($isVertical(this$static.compactor.direction) && n.spacingIgnore.left) && (n.hitbox.y_0 += $wnd.Math.max(0, spacing / 2 - 0.5));
            !($isHorizontal(this$static.compactor.direction) && n.spacingIgnore.down) && !($isVertical(this$static.compactor.direction) && n.spacingIgnore.right) && (n.hitbox.height -= spacing - 1);
        }
    }
}
function $sweep_1(this$static) {
    var n, n$iterator, points;
    $blowUpHitboxes(this$static);
    points = new ArrayList;
    for(n$iterator = new ArrayList$1(this$static.compactor.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        $add_3(points, new ScanlineConstraintCalculator$Timestamp_0(n, true));
        $add_3(points, new ScanlineConstraintCalculator$Timestamp_0(n, false));
    }
    $reset_2(this$static.constraintsScanlineHandler);
    execute_0(points, this$static.constraintsScanlineComparator, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit, 1), $intern_2, 374, 0, [
        this$static.constraintsScanlineHandler
    ])));
    $normalizeHitboxes(this$static);
}
function ScanlineConstraintCalculator_0() {
    this.constraintsScanlineComparator = new ScanlineConstraintCalculator$lambda$0$Type_0;
    this.constraintsScanlineHandler = new ScanlineConstraintCalculator$ConstraintsScanlineHandler_0(this);
}
function lambda$0_18(p1_0, p2_1) {
    var cmp, y1, y2;
    y1 = p1_0.node.hitbox.y_0;
    p1_0.low || (y1 += p1_0.node.hitbox.height);
    y2 = p2_1.node.hitbox.y_0;
    p2_1.low || (y2 += p2_1.node.hitbox.height);
    cmp = compare_4(y1, y2);
    if (cmp == 0) {
        if (!p1_0.low && p2_1.low) return -1;
        else if (!p2_1.low && p1_0.low) return 1;
    }
    return cmp;
}
defineClass(1844, 1, {}, ScanlineConstraintCalculator_0);
var Lorg_eclipse_elk_alg_layered_compaction_oned_algs_ScanlineConstraintCalculator_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned.algs', 'ScanlineConstraintCalculator', 1844);
var Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit = createForInterface('org.eclipse.elk.alg.layered.compaction.recthull', 'Scanline/EventHandler');
function $handle_1(this$static, p) {
    var right, left, right_0;
    p.low ? ($add_10(this$static.intervals, p.node), this$static.cand[p.node.id_0] = castTo($lower(this$static.intervals, p.node), 82), right = castTo($higher(this$static.intervals, p.node), 82), !!right && (this$static.cand[right.id_0] = p.node), undefined) : (left = castTo($lower(this$static.intervals, p.node), 82), !!left && left == this$static.cand[p.node.id_0] && !!left.cGroup && left.cGroup != p.node.cGroup && left.constraints.add_2(p.node), right_0 = castTo($higher(this$static.intervals, p.node), 82), !!right_0 && this$static.cand[right_0.id_0] == p.node && !!right_0.cGroup && right_0.cGroup != p.node.cGroup && p.node.constraints.add_2(right_0), $remove_28(this$static.intervals, p.node), undefined);
}
function $reset_2(this$static) {
    var index_0, n, n$iterator;
    this$static.intervals.map_0.clear_0();
    this$static.cand = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_compaction_oned_CNode_2_classLit, $intern_2, 82, this$static.this$01.compactor.cGraph.cNodes.array.length, 0, 1);
    index_0 = 0;
    for(n$iterator = new ArrayList$1(this$static.this$01.compactor.cGraph.cNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 82);
        n.id_0 = index_0++;
    }
}
function ScanlineConstraintCalculator$ConstraintsScanlineHandler_0(this$0) {
    this.this$01 = this$0;
    this.intervals = new TreeSet_0(castTo(checkNotNull(new ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type_0), 51));
}
function lambda$0_19(c1_0, c2_1) {
    return compare_4(c1_0.hitbox.x_0 + c1_0.hitbox.width_0 / 2, c2_1.hitbox.x_0 + c2_1.hitbox.width_0 / 2);
}
defineClass(1845, 1, {
    374: 1
}, ScanlineConstraintCalculator$ConstraintsScanlineHandler_0);
_.handle = function handle_1(p) {
    $handle_1(this, castTo(p, 462));
};
var Lorg_eclipse_elk_alg_layered_compaction_oned_algs_ScanlineConstraintCalculator$ConstraintsScanlineHandler_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned.algs', 'ScanlineConstraintCalculator/ConstraintsScanlineHandler', 1845);
function ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type_0() {}
defineClass(1846, 1, $intern_88, ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type_0);
_.compare_1 = function compare_24(arg0, arg1) {
    return lambda$0_19(castTo(arg0, 82), castTo(arg1, 82));
};
_.equals_0 = function equals_79(other) {
    return this === other;
};
_.reversed = function reversed_16() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_oned_algs_ScanlineConstraintCalculator$ConstraintsScanlineHandler$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned.algs', 'ScanlineConstraintCalculator/ConstraintsScanlineHandler/lambda$0$Type', 1846);
function ScanlineConstraintCalculator$Timestamp_0(node, low) {
    this.node = node;
    this.low = low;
}
defineClass(462, 1, {
    462: 1
}, ScanlineConstraintCalculator$Timestamp_0);
_.low = false;
var Lorg_eclipse_elk_alg_layered_compaction_oned_algs_ScanlineConstraintCalculator$Timestamp_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned.algs', 'ScanlineConstraintCalculator/Timestamp', 462);
function ScanlineConstraintCalculator$lambda$0$Type_0() {}
defineClass(1847, 1, $intern_88, ScanlineConstraintCalculator$lambda$0$Type_0);
_.compare_1 = function compare_25(arg0, arg1) {
    return lambda$0_18(castTo(arg0, 462), castTo(arg1, 462));
};
_.equals_0 = function equals_80(other) {
    return this === other;
};
_.reversed = function reversed_17() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_oned_algs_ScanlineConstraintCalculator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.oned.algs', 'ScanlineConstraintCalculator/lambda$0$Type', 1847);
function Point(x_0, y_0) {
    this.x_0 = x_0;
    this.y_0 = y_0;
}
function Point_0(x_0, y_0, quadrant) {
    Point.call(this, x_0, y_0);
    this.quadrant = quadrant;
}
defineClass(143, 1, {
    143: 1
}, Point, Point_0);
_.equals_0 = function equals_81(obj) {
    var p2;
    if (obj == null) return false;
    if (Lorg_eclipse_elk_alg_layered_compaction_recthull_Point_2_classLit != getClass__Ljava_lang_Class___devirtual$(obj)) return false;
    p2 = castTo(obj, 143);
    return equals_57(this.x_0, p2.x_0) && equals_57(this.y_0, p2.y_0);
};
_.hashCode_1 = function hashCode_61() {
    return hashCode_47(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        this.x_0,
        this.y_0
    ]));
};
_.toString_0 = function toString_83() {
    return '(' + this.x_0 + ', ' + this.y_0 + (this.convex ? 'cx' : '') + this.quadrant + ')';
};
_.convex = true;
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_alg_layered_compaction_recthull_Point_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'Point', 143);
function $clinit_Point$Quadrant() {
    $clinit_Point$Quadrant = emptyMethod;
    Q1 = new Point$Quadrant('Q1', 0);
    Q4 = new Point$Quadrant('Q4', 1);
    Q2 = new Point$Quadrant('Q2', 2);
    Q3 = new Point$Quadrant('Q3', 3);
}
function $isLeft(this$static) {
    return this$static == Q1 || this$static == Q4;
}
function $isUpper(this$static) {
    return this$static == Q1 || this$static == Q2;
}
function Point$Quadrant(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function isBothLeftOrBothRight(q1, q2) {
    $clinit_Point$Quadrant();
    return q1 == Q1 && q2 == Q4 || q1 == Q4 && q2 == Q1 || q1 == Q3 && q2 == Q2 || q1 == Q2 && q2 == Q3;
}
function isOneLeftOneRight(q1, q2) {
    $clinit_Point$Quadrant();
    return q1 == Q1 && q2 == Q2 || q1 == Q1 && q2 == Q3 || q1 == Q4 && q2 == Q3 || q1 == Q4 && q2 == Q2;
}
function valueOf_20(name_0) {
    $clinit_Point$Quadrant();
    return valueOf(($clinit_Point$Quadrant$Map(), $MAP_10), name_0);
}
function values_28() {
    $clinit_Point$Quadrant();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Point$Quadrant_2_classLit, 1), $intern_36, 405, 0, [
        Q1,
        Q4,
        Q2,
        Q3
    ]);
}
defineClass(405, 23, {
    3: 1,
    34: 1,
    23: 1,
    405: 1
}, Point$Quadrant);
var Q1, Q2, Q3, Q4;
var Lorg_eclipse_elk_alg_layered_compaction_recthull_Point$Quadrant_2_classLit = createForEnum('org.eclipse.elk.alg.layered.compaction.recthull', 'Point/Quadrant', 405, Ljava_lang_Enum_2_classLit, values_28, valueOf_20);
function $clinit_Point$Quadrant$Map() {
    $clinit_Point$Quadrant$Map = emptyMethod;
    $MAP_10 = createValueOfMap(($clinit_Point$Quadrant(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Point$Quadrant_2_classLit, 1), $intern_36, 405, 0, [
        Q1,
        Q4,
        Q2,
        Q3
    ])));
}
var $MAP_10;
function $clinit_RectilinearConvexHull() {
    $clinit_RectilinearConvexHull = emptyMethod;
    RIGHT_HIGH_FIRST = new RectilinearConvexHull$lambda$0$Type;
    RIGHT_LOW_FIRST = new RectilinearConvexHull$lambda$1$Type;
    LEFT_HIGH_FIRST = new RectilinearConvexHull$lambda$2$Type;
    LEFT_LOW_FIRST = new RectilinearConvexHull$lambda$3$Type;
    RIGHT_SPECIAL_ORDER = new RectilinearConvexHull$lambda$4$Type;
}
function $splitIntoRectangles(this$static) {
    var handler;
    handler = new RectilinearConvexHull$RectangleEventHandler(this$static);
    execute_0(this$static.hull, RIGHT_SPECIAL_ORDER, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit, 1), $intern_2, 374, 0, [
        handler
    ])));
    !!handler.queued && $add_3(handler.rects, handler.queued);
    return handler.rects;
}
function RectilinearConvexHull() {
    this.hull = new ArrayList;
}
function addConcaveCorners(pts, q) {
    var last, next, p, pIt;
    pIt = new AbstractList$ListIteratorImpl(pts, 0);
    last = (checkCriticalElement(pIt.i < pIt.this$01_0.size_1()), castTo(pIt.this$01_0.get_0(pIt.last = pIt.i++), 143));
    while(pIt.i < pIt.this$01_0.size_1()){
        next = (checkCriticalElement(pIt.i < pIt.this$01_0.size_1()), castTo(pIt.this$01_0.get_0(pIt.last = pIt.i++), 143));
        p = new Point_0(next.x_0, last.y_0, q);
        checkCriticalElement(pIt.i > 0);
        pIt.this$01.get_0(pIt.last = --pIt.i);
        $add_1(pIt, p);
        checkCriticalElement(pIt.i < pIt.this$01_0.size_1());
        pIt.this$01_0.get_0(pIt.last = pIt.i++);
        p.convex = false;
        last = next;
    }
}
function lambda$0_20(p1_0, p2_1) {
    $clinit_RectilinearConvexHull();
    return p1_0.x_0 == p2_1.x_0 ? compare_4(p2_1.y_0, p1_0.y_0) : compare_4(p1_0.x_0, p2_1.x_0);
}
function lambda$1_6(p1_0, p2_1) {
    $clinit_RectilinearConvexHull();
    return p1_0.x_0 == p2_1.x_0 ? compare_4(p1_0.y_0, p2_1.y_0) : compare_4(p1_0.x_0, p2_1.x_0);
}
function lambda$2_1(p1_0, p2_1) {
    $clinit_RectilinearConvexHull();
    return p1_0.x_0 == p2_1.x_0 ? compare_4(p2_1.y_0, p1_0.y_0) : compare_4(p2_1.x_0, p1_0.x_0);
}
function lambda$3(p1_0, p2_1) {
    $clinit_RectilinearConvexHull();
    return p1_0.x_0 == p2_1.x_0 ? compare_4(p1_0.y_0, p2_1.y_0) : compare_4(p2_1.x_0, p1_0.x_0);
}
function lambda$4_0(p1_0, p2_1) {
    $clinit_RectilinearConvexHull();
    var val;
    if (p1_0.x_0 == p2_1.x_0) {
        if (p1_0.quadrant == p2_1.quadrant || isBothLeftOrBothRight(p1_0.quadrant, p2_1.quadrant)) {
            val = $isLeft(p1_0.quadrant) ? 1 : -1;
            if (p1_0.convex && !p2_1.convex) return val;
            else if (!p1_0.convex && p2_1.convex) return -val;
        }
        return compare_5(p1_0.quadrant.ordinal, p2_1.quadrant.ordinal);
    } else return compare_4(p1_0.x_0, p2_1.x_0);
}
function of_5(points) {
    $clinit_RectilinearConvexHull();
    var p, p$iterator, q1, q2, q3, q4, rch;
    rch = new RectilinearConvexHull;
    for(p$iterator = new ArrayList$1(points); p$iterator.i < p$iterator.this$01.array.length;){
        p = castTo($next_6(p$iterator), 143);
        (!rch.xMax1 || p.x_0 >= rch.xMax1.x_0) && (rch.xMax1 = p);
        if (!rch.xMin1 || p.x_0 <= rch.xMin1.x_0) {
            rch.xMin2 = rch.xMin1;
            rch.xMin1 = p;
        }
        (!rch.yMax1 || p.y_0 >= rch.yMax1.y_0) && (rch.yMax1 = p);
        (!rch.yMin1 || p.y_0 <= rch.yMin1.y_0) && (rch.yMin1 = p);
    }
    q1 = new RectilinearConvexHull$MaximalElementsEventHandler(($clinit_Point$Quadrant(), Q1));
    execute_0(points, RIGHT_LOW_FIRST, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit, 1), $intern_2, 374, 0, [
        q1
    ])));
    q4 = new RectilinearConvexHull$MaximalElementsEventHandler(Q4);
    execute_0(points, RIGHT_HIGH_FIRST, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit, 1), $intern_2, 374, 0, [
        q4
    ])));
    q2 = new RectilinearConvexHull$MaximalElementsEventHandler(Q2);
    execute_0(points, LEFT_LOW_FIRST, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit, 1), $intern_2, 374, 0, [
        q2
    ])));
    q3 = new RectilinearConvexHull$MaximalElementsEventHandler(Q3);
    execute_0(points, LEFT_HIGH_FIRST, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline$EventHandler_2_classLit, 1), $intern_2, 374, 0, [
        q3
    ])));
    addConcaveCorners(q1.points, Q1);
    addConcaveCorners(q2.points, Q2);
    addConcaveCorners(q3.points, Q3);
    addConcaveCorners(q4.points, Q4);
    rch.hull.array.length = 0;
    $addAll_2(rch.hull, q1.points);
    $addAll_2(rch.hull, reverse_0(q2.points));
    $addAll_2(rch.hull, q3.points);
    $addAll_2(rch.hull, reverse_0(q4.points));
    return rch;
}
defineClass(1650, 1, {}, RectilinearConvexHull);
_.xMax1 = null;
_.xMin1 = null;
_.xMin2 = null;
_.yMax1 = null;
_.yMin1 = null;
var LEFT_HIGH_FIRST, LEFT_LOW_FIRST, RIGHT_HIGH_FIRST, RIGHT_LOW_FIRST, RIGHT_SPECIAL_ORDER;
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull', 1650);
function $clinit_RectilinearConvexHull$MaximalElementsEventHandler() {
    $clinit_RectilinearConvexHull$MaximalElementsEventHandler = emptyMethod;
    DBL_CMP = new RectilinearConvexHull$MaximalElementsEventHandler$lambda$0$Type;
}
function $handle_2(this$static, p) {
    if (this$static.compare.compare_1(p.y_0, this$static.maximalY) > 0) {
        $add_3(this$static.points, new Point_0(p.x_0, p.y_0, this$static.quadrant));
        this$static.maximalY = p.y_0;
    }
}
function RectilinearConvexHull$MaximalElementsEventHandler(quadrant) {
    $clinit_RectilinearConvexHull$MaximalElementsEventHandler();
    this.points = new ArrayList;
    this.quadrant = quadrant;
    switch(quadrant.ordinal){
        case 0:
        case 2:
            this.compare = reverseOrder_0(DBL_CMP);
            this.maximalY = $intern_60;
            break;
        case 3:
        case 1:
            this.compare = DBL_CMP;
            this.maximalY = $intern_61;
    }
}
function lambda$0_21(d1_0, d2_1) {
    $clinit_RectilinearConvexHull$MaximalElementsEventHandler();
    return compare_4((checkCriticalNotNull(d1_0), d1_0), (checkCriticalNotNull(d2_1), d2_1));
}
defineClass(565, 1, {
    374: 1
}, RectilinearConvexHull$MaximalElementsEventHandler);
_.handle = function handle_2(p) {
    $handle_2(this, castTo(p, 143));
};
_.maximalY = 0;
var DBL_CMP;
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$MaximalElementsEventHandler_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/MaximalElementsEventHandler', 565);
function RectilinearConvexHull$MaximalElementsEventHandler$lambda$0$Type() {}
defineClass(1652, 1, $intern_88, RectilinearConvexHull$MaximalElementsEventHandler$lambda$0$Type);
_.compare_1 = function compare_26(arg0, arg1) {
    return lambda$0_21(castToDouble(arg0), castToDouble(arg1));
};
_.equals_0 = function equals_82(other) {
    return this === other;
};
_.reversed = function reversed_18() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$MaximalElementsEventHandler$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/MaximalElementsEventHandler/lambda$0$Type', 1652);
function $handle_3(this$static, p) {
    var r;
    if (!!this$static.queued && (p.x_0 != this$static.queuedPnt.x_0 || isOneLeftOneRight(this$static.queuedPnt.quadrant, p.quadrant))) {
        $add_3(this$static.rects, this$static.queued);
        this$static.lastX = this$static.queued.x_0 + this$static.queued.width_0;
        this$static.queued = null;
        this$static.queuedPnt = null;
    }
    $isUpper(p.quadrant) ? this$static.minY = p : this$static.maxY = p;
    if (p.quadrant == ($clinit_Point$Quadrant(), Q1) && !p.convex || p.quadrant == Q2 && p.convex || p.quadrant == Q3 && p.convex || p.quadrant == Q4 && !p.convex) {
        if (!!this$static.minY && !!this$static.maxY) {
            r = new ElkRectangle_0(this$static.lastX, this$static.minY.y_0, p.x_0 - this$static.lastX, this$static.maxY.y_0 - this$static.minY.y_0);
            this$static.queued = r;
            this$static.queuedPnt = p;
        }
    }
}
function RectilinearConvexHull$RectangleEventHandler(this$0) {
    this.this$01 = this$0;
    this.rects = new ArrayList;
    this.lastX = $wnd.Math.min(this.this$01.xMin1.x_0, this.this$01.xMin2.x_0);
}
defineClass(1651, 1, {
    374: 1
}, RectilinearConvexHull$RectangleEventHandler);
_.handle = function handle_3(p) {
    $handle_3(this, castTo(p, 143));
};
_.lastX = 0;
_.maxY = null;
_.minY = null;
_.queued = null;
_.queuedPnt = null;
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$RectangleEventHandler_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/RectangleEventHandler', 1651);
function RectilinearConvexHull$lambda$0$Type() {}
defineClass(1653, 1, $intern_88, RectilinearConvexHull$lambda$0$Type);
_.compare_1 = function compare_27(arg0, arg1) {
    return lambda$0_20(castTo(arg0, 143), castTo(arg1, 143));
};
_.equals_0 = function equals_83(other) {
    return this === other;
};
_.reversed = function reversed_19() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/lambda$0$Type', 1653);
function RectilinearConvexHull$lambda$1$Type() {}
defineClass(1654, 1, $intern_88, RectilinearConvexHull$lambda$1$Type);
_.compare_1 = function compare_28(arg0, arg1) {
    return lambda$1_6(castTo(arg0, 143), castTo(arg1, 143));
};
_.equals_0 = function equals_84(other) {
    return this === other;
};
_.reversed = function reversed_20() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/lambda$1$Type', 1654);
function RectilinearConvexHull$lambda$2$Type() {}
defineClass(1655, 1, $intern_88, RectilinearConvexHull$lambda$2$Type);
_.compare_1 = function compare_29(arg0, arg1) {
    return lambda$2_1(castTo(arg0, 143), castTo(arg1, 143));
};
_.equals_0 = function equals_85(other) {
    return this === other;
};
_.reversed = function reversed_21() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/lambda$2$Type', 1655);
function RectilinearConvexHull$lambda$3$Type() {}
defineClass(1656, 1, $intern_88, RectilinearConvexHull$lambda$3$Type);
_.compare_1 = function compare_30(arg0, arg1) {
    return lambda$3(castTo(arg0, 143), castTo(arg1, 143));
};
_.equals_0 = function equals_86(other) {
    return this === other;
};
_.reversed = function reversed_22() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/lambda$3$Type', 1656);
function RectilinearConvexHull$lambda$4$Type() {}
defineClass(1657, 1, $intern_88, RectilinearConvexHull$lambda$4$Type);
_.compare_1 = function compare_31(arg0, arg1) {
    return lambda$4_0(castTo(arg0, 143), castTo(arg1, 143));
};
_.equals_0 = function equals_87(other) {
    return this === other;
};
_.reversed = function reversed_23() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compaction_recthull_RectilinearConvexHull$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'RectilinearConvexHull/lambda$4$Type', 1657);
function $go_0(this$static) {
    var h, h$iterator, p, p$iterator;
    $clinit_Collections();
    $sort(this$static.points, this$static.comparator);
    for(p$iterator = new ArrayList$1(this$static.points); p$iterator.i < p$iterator.this$01.array.length;){
        p = $next_6(p$iterator);
        for(h$iterator = new ArrayList$1(this$static.eventHandlers); h$iterator.i < h$iterator.this$01.array.length;){
            h = castTo($next_6(h$iterator), 374);
            h.handle(p);
        }
    }
}
function Scanline_0(points, comparator, eventHandlers) {
    this.comparator = comparator;
    this.points = points;
    this.eventHandlers = (checkNotNull(eventHandlers), new ArrayList_1(eventHandlers));
}
function execute_0(points, comparator, eventHandlers) {
    var copy;
    copy = (checkNotNull(points), new ArrayList_1(points));
    $go_0(new Scanline_0(copy, comparator, eventHandlers));
}
defineClass(1658, 1, {}, Scanline_0);
var Lorg_eclipse_elk_alg_layered_compaction_recthull_Scanline_2_classLit = createForClass('org.eclipse.elk.alg.layered.compaction.recthull', 'Scanline', 1658);
function $moveGraph_0(destGraph, sourceGraph, offsetx, offsety) {
    var edge, edge$iterator, graphOffset, junctionPoints, label_0, label$iterator, node, node$iterator, port, port$iterator;
    graphOffset = $add_18(sourceGraph.offset, offsetx, offsety);
    for(node$iterator = new ArrayList$1(sourceGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $add_19(node.pos, graphOffset);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                $offset_2(edge.bendPoints, graphOffset);
                junctionPoints = castTo($getProperty(edge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
                !!junctionPoints && $offset_2(junctionPoints, graphOffset);
                for(label$iterator = new ArrayList$1(edge.labels); label$iterator.i < label$iterator.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator), 72);
                    $add_19(label_0.pos, graphOffset);
                }
            }
        }
        $add_3(destGraph.layerlessNodes, node);
        node.graph_0 = destGraph;
    }
}
function $moveGraphs(destGraph, sourceGraphs) {
    var sourceGraph, sourceGraph$iterator;
    for(sourceGraph$iterator = sourceGraphs.iterator_0(); sourceGraph$iterator.hasNext_0();){
        sourceGraph = castTo(sourceGraph$iterator.next_1(), 36);
        $moveGraph_0(destGraph, sourceGraph, 0, 0);
    }
}
function $offsetGraph(graph, offsetx, offsety) {
    var edge, edge$iterator, graphOffset, junctionPoints, label_0, label$iterator, node, node$iterator, port, port$iterator;
    graphOffset = new KVector_1(offsetx, offsety);
    for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $add_19(node.pos, graphOffset);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                $offset_2(edge.bendPoints, graphOffset);
                junctionPoints = castTo($getProperty(edge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
                !!junctionPoints && $offset_2(junctionPoints, graphOffset);
                for(label$iterator = new ArrayList$1(edge.labels); label$iterator.i < label$iterator.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator), 72);
                    $add_19(label_0.pos, graphOffset);
                }
            }
        }
    }
}
function $offsetGraphs(graphs, offsetx, offsety) {
    var graph, graph$iterator;
    for(graph$iterator = graphs.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 36);
        $offsetGraph(graph, offsetx, offsety);
    }
}
defineClass(2050, 1, {});
var Lorg_eclipse_elk_alg_layered_components_AbstractGraphPlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'AbstractGraphPlacer', 2050);
function $clinit_ComponentGroup() {
    $clinit_ComponentGroup = emptyMethod;
    CONSTRAINTS = new HashMultimap;
    $put(CONSTRAINTS, ($clinit_PortSide(), SIDES_NONE), SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_SOUTH, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_SOUTH, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_WEST, SIDES_NORTH_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_WEST, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_EAST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_SOUTH_WEST, SIDES_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_SOUTH_WEST, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_SOUTH_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH, SIDES_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_EAST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_NORTH_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_EAST_SOUTH_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_NORTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_EAST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_NORTH_EAST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NONE);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_EAST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH_EAST_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_EAST_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH_SOUTH_WEST);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH_EAST_SOUTH);
    $put(CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
}
function $$init_5(this$static) {
    this$static.components = new ArrayListMultimap;
}
function $getComponents(this$static, connections) {
    return castTo($get(this$static.components, connections), 15);
}
function ComponentGroup(component) {
    $clinit_ComponentGroup();
    $$init_5(this);
    this.add_4(component);
}
defineClass(331, 1, {
    331: 1
}, ComponentGroup);
_.add_4 = function add_43(component) {
    if (this.canAdd(component)) {
        $put(this.components, castTo($getProperty(component, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22), component);
        return true;
    } else return false;
};
_.canAdd = function canAdd(component) {
    var candidateSides, constraint, constraint$iterator, constraints;
    candidateSides = castTo($getProperty(component, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22);
    constraints = castTo($get(CONSTRAINTS, candidateSides), 22);
    for(constraint$iterator = constraints.iterator_0(); constraint$iterator.hasNext_0();){
        constraint = castTo(constraint$iterator.next_1(), 22);
        if (!castTo($get(this.components, constraint), 15).isEmpty()) return false;
    }
    return true;
};
var CONSTRAINTS;
var Lorg_eclipse_elk_alg_layered_components_ComponentGroup_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentGroup', 331);
function $placeComponents(group, spacing) {
    var colLeftWidth, colMidWidth, colNsWidth, colRightWidth, componentSize, rowBottomHeight, rowMidHeight, rowTopHeight, rowWeHeight, sizeC, sizeE, sizeENS, sizeN, sizeNE, sizeNESW, sizeNS, sizeNW, sizeNWE, sizeS, sizeSE, sizeSW, sizeSWE, sizeW, sizeWE, sizeWNS;
    sizeC = $placeComponentsInRows($getComponents(group, ($clinit_PortSide(), SIDES_NONE)), spacing);
    sizeN = $placeComponentsHorizontally($getComponents(group, SIDES_NORTH), spacing);
    sizeS = $placeComponentsHorizontally($getComponents(group, SIDES_SOUTH), spacing);
    sizeW = $placeComponentsVertically($getComponents(group, SIDES_WEST), spacing);
    sizeE = $placeComponentsVertically($getComponents(group, SIDES_EAST), spacing);
    sizeNW = $placeComponentsHorizontally($getComponents(group, SIDES_NORTH_WEST), spacing);
    sizeNE = $placeComponentsHorizontally($getComponents(group, SIDES_NORTH_EAST), spacing);
    sizeSW = $placeComponentsHorizontally($getComponents(group, SIDES_SOUTH_WEST), spacing);
    sizeSE = $placeComponentsHorizontally($getComponents(group, SIDES_EAST_SOUTH), spacing);
    sizeWE = $placeComponentsVertically($getComponents(group, SIDES_EAST_WEST), spacing);
    sizeNS = $placeComponentsHorizontally($getComponents(group, SIDES_NORTH_SOUTH), spacing);
    sizeNWE = $placeComponentsHorizontally($getComponents(group, SIDES_NORTH_EAST_WEST), spacing);
    sizeSWE = $placeComponentsHorizontally($getComponents(group, SIDES_EAST_SOUTH_WEST), spacing);
    sizeWNS = $placeComponentsVertically($getComponents(group, SIDES_NORTH_SOUTH_WEST), spacing);
    sizeENS = $placeComponentsVertically($getComponents(group, SIDES_NORTH_EAST_SOUTH), spacing);
    sizeNESW = $placeComponentsHorizontally($getComponents(group, SIDES_NORTH_EAST_SOUTH_WEST), spacing);
    colLeftWidth = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        sizeNW.x_0,
        sizeW.x_0,
        sizeSW.x_0,
        sizeWNS.x_0
    ]));
    colMidWidth = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        sizeN.x_0,
        sizeC.x_0,
        sizeS.x_0,
        sizeNESW.x_0
    ]));
    colNsWidth = sizeNS.x_0;
    colRightWidth = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        sizeNE.x_0,
        sizeE.x_0,
        sizeSE.x_0,
        sizeENS.x_0
    ]));
    rowTopHeight = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        sizeNW.y_0,
        sizeN.y_0,
        sizeNE.y_0,
        sizeNWE.y_0
    ]));
    rowMidHeight = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        sizeW.y_0,
        sizeC.y_0,
        sizeE.y_0,
        sizeNESW.y_0
    ]));
    rowWeHeight = sizeWE.y_0;
    rowBottomHeight = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        sizeSW.y_0,
        sizeS.y_0,
        sizeSE.y_0,
        sizeSWE.y_0
    ]));
    $offsetGraphs($getComponents(group, SIDES_NONE), colLeftWidth + colNsWidth, rowTopHeight + rowWeHeight);
    $offsetGraphs($getComponents(group, SIDES_NORTH_EAST_SOUTH_WEST), colLeftWidth + colNsWidth, rowTopHeight + rowWeHeight);
    $offsetGraphs($getComponents(group, SIDES_NORTH), colLeftWidth + colNsWidth, 0);
    $offsetGraphs($getComponents(group, SIDES_SOUTH), colLeftWidth + colNsWidth, rowTopHeight + rowWeHeight + rowMidHeight);
    $offsetGraphs($getComponents(group, SIDES_WEST), 0, rowTopHeight + rowWeHeight);
    $offsetGraphs($getComponents(group, SIDES_EAST), colLeftWidth + colNsWidth + colMidWidth, rowTopHeight + rowWeHeight);
    $offsetGraphs($getComponents(group, SIDES_NORTH_EAST), colLeftWidth + colNsWidth + colMidWidth, 0);
    $offsetGraphs($getComponents(group, SIDES_SOUTH_WEST), 0, rowTopHeight + rowWeHeight + rowMidHeight);
    $offsetGraphs($getComponents(group, SIDES_EAST_SOUTH), colLeftWidth + colNsWidth + colMidWidth, rowTopHeight + rowWeHeight + rowMidHeight);
    $offsetGraphs($getComponents(group, SIDES_EAST_WEST), 0, rowTopHeight);
    $offsetGraphs($getComponents(group, SIDES_NORTH_SOUTH), colLeftWidth, 0);
    $offsetGraphs($getComponents(group, SIDES_EAST_SOUTH_WEST), 0, rowTopHeight + rowWeHeight + rowMidHeight);
    $offsetGraphs($getComponents(group, SIDES_NORTH_EAST_SOUTH), colLeftWidth + colNsWidth + colMidWidth, 0);
    componentSize = new KVector;
    componentSize.x_0 = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        colLeftWidth + colMidWidth + colNsWidth + colRightWidth,
        sizeWE.x_0,
        sizeNWE.x_0,
        sizeSWE.x_0
    ]));
    componentSize.y_0 = maxd(stampJavaTypeInfo(getClassLiteralForArray(D_classLit, 1), $intern_66, 30, 15, [
        rowTopHeight + rowMidHeight + rowWeHeight + rowBottomHeight,
        sizeNS.y_0,
        sizeWNS.y_0,
        sizeENS.y_0
    ]));
    return componentSize;
}
function $placeComponentsHorizontally(components, spacing) {
    var component, component$iterator, size_0;
    size_0 = new KVector;
    for(component$iterator = components.iterator_0(); component$iterator.hasNext_0();){
        component = castTo(component$iterator.next_1(), 36);
        $offsetGraph(component, size_0.x_0, 0);
        size_0.x_0 += component.size_0.x_0 + spacing;
        size_0.y_0 = $wnd.Math.max(size_0.y_0, component.size_0.y_0);
    }
    size_0.y_0 > 0 && (size_0.y_0 += spacing);
    return size_0;
}
function $placeComponentsInRows(components, spacing) {
    var broadestRow, component, component$iterator, componentSize, graph, graph$iterator, highestBox, maxRowWidth, size_0, totalArea, xpos, ypos;
    if (components.isEmpty()) return new KVector;
    maxRowWidth = 0;
    totalArea = 0;
    for(component$iterator = components.iterator_0(); component$iterator.hasNext_0();){
        component = castTo(component$iterator.next_1(), 36);
        componentSize = component.size_0;
        maxRowWidth = $wnd.Math.max(maxRowWidth, componentSize.x_0);
        totalArea += componentSize.x_0 * componentSize.y_0;
    }
    maxRowWidth = $wnd.Math.max(maxRowWidth, $wnd.Math.sqrt(totalArea) * $doubleValue(castToDouble($getProperty(castTo(components.iterator_0().next_1(), 36), ($clinit_LayeredOptions(), ASPECT_RATIO_0)))));
    xpos = 0;
    ypos = 0;
    highestBox = 0;
    broadestRow = spacing;
    for(graph$iterator = components.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 36);
        size_0 = graph.size_0;
        if (xpos + size_0.x_0 > maxRowWidth) {
            xpos = 0;
            ypos += highestBox + spacing;
            highestBox = 0;
        }
        $offsetGraph(graph, xpos, ypos);
        broadestRow = $wnd.Math.max(broadestRow, xpos + size_0.x_0);
        highestBox = $wnd.Math.max(highestBox, size_0.y_0);
        xpos += size_0.x_0 + spacing;
    }
    return new KVector_1(broadestRow + spacing, ypos + highestBox + spacing);
}
function $placeComponentsVertically(components, spacing) {
    var component, component$iterator, size_0;
    size_0 = new KVector;
    for(component$iterator = components.iterator_0(); component$iterator.hasNext_0();){
        component = castTo(component$iterator.next_1(), 36);
        $offsetGraph(component, 0, size_0.y_0);
        size_0.y_0 += component.size_0.y_0 + spacing;
        size_0.x_0 = $wnd.Math.max(size_0.x_0, component.size_0.x_0);
    }
    size_0.x_0 > 0 && (size_0.x_0 += spacing);
    return size_0;
}
function ComponentGroupGraphPlacer() {
    this.componentGroups = new ArrayList;
}
defineClass(761, 2050, {}, ComponentGroupGraphPlacer);
_.addComponent = function addComponent(component) {
    var group, group$iterator;
    for(group$iterator = new ArrayList$1(this.componentGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 331);
        if (group.add_4(component)) return;
    }
    $add_3(this.componentGroups, new ComponentGroup(component));
};
_.combine = function combine(components, target) {
    var compactor, component, component$iterator, componentSpacing, firstComponent, group, group$iterator, group$iterator0, groupSize, h, h$iterator, h$iterator0, offset;
    this.componentGroups.array.length = 0;
    target.layerlessNodes.array.length = 0;
    if (components.isEmpty()) {
        target.size_0.x_0 = 0;
        target.size_0.y_0 = 0;
        return;
    }
    firstComponent = castTo(components.get_0(0), 36);
    $copyProperties(target, firstComponent);
    for(component$iterator = components.iterator_0(); component$iterator.hasNext_0();){
        component = castTo(component$iterator.next_1(), 36);
        this.addComponent(component);
    }
    offset = new KVector;
    componentSpacing = $doubleValue(castToDouble($getProperty(firstComponent, ($clinit_LayeredOptions(), SPACING_COMPONENT_COMPONENT))));
    for(group$iterator0 = new ArrayList$1(this.componentGroups); group$iterator0.i < group$iterator0.this$01.array.length;){
        group = castTo($next_6(group$iterator0), 331);
        groupSize = $placeComponents(group, componentSpacing);
        $offsetGraphs($values(group.components), offset.x_0, offset.y_0);
        offset.x_0 += groupSize.x_0;
        offset.y_0 += groupSize.y_0;
    }
    target.size_0.x_0 = offset.x_0 - componentSpacing;
    target.size_0.y_0 = offset.y_0 - componentSpacing;
    if ($booleanValue(castToBoolean($getProperty(firstComponent, COMPACTION_CONNECTED_COMPONENTS_0))) && maskUndefined($getProperty(firstComponent, EDGE_ROUTING)) === maskUndefined(($clinit_EdgeRouting(), ORTHOGONAL))) {
        for(h$iterator0 = components.iterator_0(); h$iterator0.hasNext_0();){
            h = castTo(h$iterator0.next_1(), 36);
            $offsetGraph(h, h.offset.x_0, h.offset.y_0);
        }
        compactor = new ComponentsCompactor;
        $compact_4(compactor, components, componentSpacing);
        for(h$iterator = components.iterator_0(); h$iterator.hasNext_0();){
            h = castTo(h$iterator.next_1(), 36);
            $add_19($reset_5(h.offset), compactor.yetAnotherOffset);
        }
        $add_19($reset_5(target.size_0), compactor.compactedGraphSize);
    }
    for(group$iterator = new ArrayList$1(this.componentGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 331);
        $moveGraphs(target, $values(group.components));
    }
};
var Lorg_eclipse_elk_alg_layered_components_ComponentGroupGraphPlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentGroupGraphPlacer', 761);
function $addComponent(this$static, component) {
    var group;
    if (this$static.componentGroups.array.length > 0) {
        group = castTo($get_11(this$static.componentGroups, this$static.componentGroups.array.length - 1), 561);
        if ($add_14(group, component)) return;
    }
    $add_3(this$static.componentGroups, new ModelOrderComponentGroup(component));
}
function ComponentGroupModelOrderGraphPlacer() {
    ComponentGroupGraphPlacer.call(this);
}
defineClass(1265, 761, {}, ComponentGroupModelOrderGraphPlacer);
_.addComponent = function addComponent_0(component) {
    $addComponent(this, component);
};
_.combine = function combine_0(components, target) {
    var compactor, component, component$iterator, componentSpacing, firstComponent, group, group$iterator, group$iterator0, groupSize, h, h$iterator, h$iterator0, maxSize, offset, side, side$iterator, spaceBlockedByComponents, spaceBlockedBySouthEdges;
    this.componentGroups.array.length = 0;
    target.layerlessNodes.array.length = 0;
    if (components.isEmpty()) {
        target.size_0.x_0 = 0;
        target.size_0.y_0 = 0;
        return;
    }
    firstComponent = castTo(components.get_0(0), 36);
    $copyProperties(target, firstComponent);
    for(component$iterator = components.iterator_0(); component$iterator.hasNext_0();){
        component = castTo(component$iterator.next_1(), 36);
        $addComponent(this, component);
    }
    spaceBlockedBySouthEdges = new KVector;
    spaceBlockedByComponents = new KVector;
    offset = new KVector;
    maxSize = new KVector;
    componentSpacing = $doubleValue(castToDouble($getProperty(firstComponent, ($clinit_LayeredOptions(), SPACING_COMPONENT_COMPONENT))));
    for(group$iterator0 = new ArrayList$1(this.componentGroups); group$iterator0.i < group$iterator0.this$01.array.length;){
        group = castTo($next_6(group$iterator0), 331);
        if ($isHorizontal(castTo($getProperty(target, ($clinit_CoreOptions(), DIRECTION_1)), 86))) {
            offset.x_0 = spaceBlockedBySouthEdges.x_0;
            for(side$iterator = new Maps$1($entries($keys(group.components).multimap).this$01.entryIterator()); side$iterator.backingIterator.hasNext_0();){
                side = castTo($transform(side$iterator.backingIterator.next_1()), 22);
                if (side.contains(($clinit_PortSide(), NORTH_1))) {
                    offset.x_0 = spaceBlockedByComponents.x_0;
                    break;
                }
            }
        } else if ($isVertical(castTo($getProperty(target, DIRECTION_1), 86))) {
            offset.y_0 = spaceBlockedBySouthEdges.y_0;
            for(side$iterator = new Maps$1($entries($keys(group.components).multimap).this$01.entryIterator()); side$iterator.backingIterator.hasNext_0();){
                side = castTo($transform(side$iterator.backingIterator.next_1()), 22);
                if (side.contains(($clinit_PortSide(), WEST_0))) {
                    offset.y_0 = spaceBlockedByComponents.y_0;
                    break;
                }
            }
        }
        groupSize = $placeComponents(castTo(group, 561), componentSpacing);
        $offsetGraphs($values(group.components), offset.x_0, offset.y_0);
        if ($isHorizontal(castTo($getProperty(target, DIRECTION_1), 86))) {
            spaceBlockedByComponents.x_0 = offset.x_0 + groupSize.x_0;
            maxSize.x_0 = $wnd.Math.max(maxSize.x_0, spaceBlockedByComponents.x_0);
            for(side$iterator = new Maps$1($entries($keys(group.components).multimap).this$01.entryIterator()); side$iterator.backingIterator.hasNext_0();){
                side = castTo($transform(side$iterator.backingIterator.next_1()), 22);
                if (side.contains(($clinit_PortSide(), SOUTH_0))) {
                    spaceBlockedBySouthEdges.x_0 = offset.x_0 + groupSize.x_0;
                    break;
                }
            }
            spaceBlockedByComponents.y_0 = offset.y_0 + groupSize.y_0;
            offset.y_0 = spaceBlockedByComponents.y_0;
            maxSize.y_0 = $wnd.Math.max(maxSize.y_0, offset.y_0);
        } else if ($isVertical(castTo($getProperty(target, DIRECTION_1), 86))) {
            spaceBlockedByComponents.y_0 = offset.y_0 + groupSize.y_0;
            maxSize.y_0 = $wnd.Math.max(maxSize.y_0, spaceBlockedByComponents.y_0);
            for(side$iterator = new Maps$1($entries($keys(group.components).multimap).this$01.entryIterator()); side$iterator.backingIterator.hasNext_0();){
                side = castTo($transform(side$iterator.backingIterator.next_1()), 22);
                if (side.contains(($clinit_PortSide(), EAST_0))) {
                    spaceBlockedBySouthEdges.y_0 = offset.y_0 + groupSize.y_0;
                    break;
                }
            }
            spaceBlockedByComponents.x_0 = offset.x_0 + groupSize.x_0;
            offset.x_0 = spaceBlockedByComponents.x_0;
            maxSize.x_0 = $wnd.Math.max(maxSize.x_0, offset.x_0);
        }
    }
    target.size_0.x_0 = maxSize.x_0 - componentSpacing;
    target.size_0.y_0 = maxSize.y_0 - componentSpacing;
    if ($booleanValue(castToBoolean($getProperty(firstComponent, COMPACTION_CONNECTED_COMPONENTS_0))) && maskUndefined($getProperty(firstComponent, EDGE_ROUTING)) === maskUndefined(($clinit_EdgeRouting(), ORTHOGONAL))) {
        for(h$iterator0 = components.iterator_0(); h$iterator0.hasNext_0();){
            h = castTo(h$iterator0.next_1(), 36);
            $offsetGraph(h, h.offset.x_0, h.offset.y_0);
        }
        compactor = new ComponentsCompactor;
        $compact_4(compactor, components, componentSpacing);
        for(h$iterator = components.iterator_0(); h$iterator.hasNext_0();){
            h = castTo(h$iterator.next_1(), 36);
            $add_19($reset_5(h.offset), compactor.yetAnotherOffset);
        }
        $add_19($reset_5(target.size_0), compactor.compactedGraphSize);
    }
    for(group$iterator = new ArrayList$1(this.componentGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 331);
        $moveGraphs(target, $values(group.components));
    }
};
var Lorg_eclipse_elk_alg_layered_components_ComponentGroupModelOrderGraphPlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentGroupModelOrderGraphPlacer', 1265);
function $clinit_ComponentOrderingStrategy() {
    $clinit_ComponentOrderingStrategy = emptyMethod;
    NONE = new ComponentOrderingStrategy('NONE', 0);
    INSIDE_PORT_SIDE_GROUPS = new ComponentOrderingStrategy('INSIDE_PORT_SIDE_GROUPS', 1);
    GROUP_MODEL_ORDER = new ComponentOrderingStrategy('GROUP_MODEL_ORDER', 2);
    MODEL_ORDER = new ComponentOrderingStrategy('MODEL_ORDER', 3);
}
function ComponentOrderingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_21(name_0) {
    $clinit_ComponentOrderingStrategy();
    return valueOf(($clinit_ComponentOrderingStrategy$Map(), $MAP_11), name_0);
}
function values_29() {
    $clinit_ComponentOrderingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_components_ComponentOrderingStrategy_2_classLit, 1), $intern_36, 381, 0, [
        NONE,
        INSIDE_PORT_SIDE_GROUPS,
        GROUP_MODEL_ORDER,
        MODEL_ORDER
    ]);
}
defineClass(381, 23, {
    3: 1,
    34: 1,
    23: 1,
    381: 1
}, ComponentOrderingStrategy);
var GROUP_MODEL_ORDER, INSIDE_PORT_SIDE_GROUPS, MODEL_ORDER, NONE;
var Lorg_eclipse_elk_alg_layered_components_ComponentOrderingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.components', 'ComponentOrderingStrategy', 381, Ljava_lang_Enum_2_classLit, values_29, valueOf_21);
function $clinit_ComponentOrderingStrategy$Map() {
    $clinit_ComponentOrderingStrategy$Map = emptyMethod;
    $MAP_11 = createValueOfMap(($clinit_ComponentOrderingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_components_ComponentOrderingStrategy_2_classLit, 1), $intern_36, 381, 0, [
        NONE,
        INSIDE_PORT_SIDE_GROUPS,
        GROUP_MODEL_ORDER,
        MODEL_ORDER
    ])));
}
var $MAP_11;
function $addLGraphElementBounds(pts, element, offset) {
    var margins;
    margins = null;
    !!element && (margins = element.margin);
    $add_12(pts, new Point(element.pos.x_0 - margins.left + offset.x_0, element.pos.y_0 - margins.top_0 + offset.y_0));
    $add_12(pts, new Point(element.pos.x_0 - margins.left + offset.x_0, element.pos.y_0 + element.size_0.y_0 + margins.bottom + offset.y_0));
    $add_12(pts, new Point(element.pos.x_0 + element.size_0.x_0 + margins.right + offset.x_0, element.pos.y_0 - margins.top_0 + offset.y_0));
    $add_12(pts, new Point(element.pos.x_0 + element.size_0.x_0 + margins.right + offset.x_0, element.pos.y_0 + element.size_0.y_0 + margins.bottom + offset.y_0));
}
function $compact_4(this$static, graphs, spacing) {
    var c, cc, cc$iterator, cc$iterator0, ccs, e, e$iterator, graph, graph$iterator, graph$iterator0, last, lastArg, n, n$iterator, newPos, node, node$iterator, offset, v, v$iterator, vc, compaction;
    this$static.graphTopLeft = new KVector_1($intern_60, $intern_60);
    this$static.graphBottomRight = new KVector_1($intern_61, $intern_61);
    for(graph$iterator0 = graphs.iterator_0(); graph$iterator0.hasNext_0();){
        graph = castTo(graph$iterator0.next_1(), 36);
        for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            this$static.graphTopLeft.x_0 = $wnd.Math.min(this$static.graphTopLeft.x_0, node.pos.x_0 - node.margin.left);
            this$static.graphTopLeft.y_0 = $wnd.Math.min(this$static.graphTopLeft.y_0, node.pos.y_0 - node.margin.top_0);
            this$static.graphBottomRight.x_0 = $wnd.Math.max(this$static.graphBottomRight.x_0, node.pos.x_0 + node.size_0.x_0 + node.margin.right);
            this$static.graphBottomRight.y_0 = $wnd.Math.max(this$static.graphBottomRight.y_0, node.pos.y_0 + node.size_0.y_0 + node.margin.bottom);
        }
    }
    ccs = new ComponentsCompactor$InternalConnectedComponents;
    for(graph$iterator = graphs.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 36);
        c = $transformLGraph(this$static, graph);
        $add_3(ccs.components, c);
        c.containsRegularNodes = c.containsRegularNodes | !castTo($getProperty(c.graph_0, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22).isEmpty();
    }
    this$static.compactor = ($clinit_OneDimensionalComponentsCompaction(), compaction = new OneDimensionalComponentsCompaction, compaction.transformer = new ComponentsToCGraphTransformer(spacing), compaction.compactionGraph = $transform_0(compaction.transformer, ccs), compaction);
    $compact_1((lastArg = this$static.compactor, new BasicProgressMonitor, lastArg));
    this$static.yetAnotherOffset = new KVector;
    this$static.compactedGraphSize = this$static.compactor.transformer.graphSize;
    for(cc$iterator0 = new ArrayList$1(ccs.components); cc$iterator0.i < cc$iterator0.this$01.array.length;){
        cc = castTo($next_6(cc$iterator0), 834);
        offset = $getOffset_0(this$static.compactor, cc);
        offsetGraph(cc.graph_0, offset.x_0, offset.y_0);
        for(n$iterator = new ArrayList$1(cc.graph_0.layerlessNodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            if (n.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
                newPos = $getExternalPortPosition(this$static, n.pos, castTo($getProperty(n, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64));
                $add_19($reset_5(n.pos), newPos);
            }
        }
    }
    for(cc$iterator = new ArrayList$1(ccs.components); cc$iterator.i < cc$iterator.this$01.array.length;){
        cc = castTo($next_6(cc$iterator), 834);
        for(e$iterator = new ArrayList$1($getExternalEdges(cc)); e$iterator.i < e$iterator.this$01.array.length;){
            e = castTo($next_6(e$iterator), 18);
            vc = new KVectorChain_0(e.bendPoints);
            $add_0(vc, 0, $getAbsoluteAnchor(e.source));
            $add_7(vc, $getAbsoluteAnchor(e.target));
            last = null;
            for(v$iterator = $listIterator_2(vc, 0); v$iterator.currentNode != v$iterator.this$01.tail;){
                v = castTo($next_9(v$iterator), 8);
                if (!last) {
                    last = v;
                    continue;
                }
                if (fuzzyEquals(last.x_0, v.x_0)) {
                    this$static.yetAnotherOffset.x_0 = $wnd.Math.min(this$static.yetAnotherOffset.x_0, last.x_0);
                    this$static.compactedGraphSize.x_0 = $wnd.Math.max(this$static.compactedGraphSize.x_0, last.x_0);
                } else if (fuzzyEquals(last.y_0, v.y_0)) {
                    this$static.yetAnotherOffset.y_0 = $wnd.Math.min(this$static.yetAnotherOffset.y_0, last.y_0);
                    this$static.compactedGraphSize.y_0 = $wnd.Math.max(this$static.compactedGraphSize.y_0, last.y_0);
                }
                last = v;
            }
        }
    }
    $negate_0(this$static.yetAnotherOffset);
    $add_19(this$static.compactedGraphSize, this$static.yetAnotherOffset);
}
function $componentHullPoints(graph) {
    var absolute, bp, bp$iterator, edge, edge$iterator, n, n$iterator, pts;
    pts = new ComponentsCompactor$Hullpoints;
    for(n$iterator = new ArrayList$1(graph.layerlessNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 9);
        if (n.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
        $addLGraphElementBounds(pts, n, new KVector);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            if (edge.source.owner.type_0 == EXTERNAL_PORT || edge.target.owner.type_0 == EXTERNAL_PORT) continue;
            for(bp$iterator = $listIterator_2(edge.bendPoints, 0); bp$iterator.currentNode != bp$iterator.this$01.tail;){
                bp = castTo($next_9(bp$iterator), 8);
                absolute = bp;
                $add_12(pts, new Point(absolute.x_0, absolute.y_0));
            }
        }
    }
    return pts;
}
function $createDummyNode(graph) {
    var dummy, dummyEdge, dummyPort, extPortDummy, extPortDummyPort;
    extPortDummy = castTo($get_11(graph.layerlessNodes, 0), 9);
    dummy = new LNode(graph);
    $add_3(graph.layerlessNodes, dummy);
    dummy.size_0.x_0 = $wnd.Math.max(1, extPortDummy.size_0.x_0);
    dummy.size_0.y_0 = $wnd.Math.max(1, extPortDummy.size_0.y_0);
    dummy.pos.x_0 = extPortDummy.pos.x_0;
    dummy.pos.y_0 = extPortDummy.pos.y_0;
    switch(castTo($getProperty(extPortDummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64).ordinal){
        case 4:
            dummy.pos.x_0 += 2;
            break;
        case 1:
            dummy.pos.y_0 += 2;
            break;
        case 2:
            dummy.pos.x_0 -= 2;
            break;
        case 3:
            dummy.pos.y_0 -= 2;
    }
    dummyPort = new LPort;
    $setNode(dummyPort, dummy);
    dummyEdge = new LEdge;
    extPortDummyPort = castTo($get_11(extPortDummy.ports, 0), 11);
    $setSource_0(dummyEdge, extPortDummyPort);
    $setTarget_0(dummyEdge, dummyPort);
    $add_19($reset_5(dummyPort.pos), extPortDummyPort.pos);
    $add_19($reset_5(dummyPort.anchor), extPortDummyPort.anchor);
    return dummy;
}
function $edgeToSegments(this$static, edge, externalExtension) {
    var externalPort, externalPortSide, i, outerSegmentIsFirst, p1, p2, points, segment, segments;
    externalPort = externalExtension.externalPort;
    externalPortSide = externalExtension.externalPortSide;
    p1 = $getAbsoluteAnchor(edge.source);
    p2 = $getAbsoluteAnchor(edge.target);
    if (externalPort == edge.source) {
        p1 = $getExternalPortPosition(this$static, p1, externalPortSide);
        p2 = $getPortPositionOnMargin(edge.target);
    } else {
        p1 = $getPortPositionOnMargin(edge.source);
        p2 = $getExternalPortPosition(this$static, p2, externalPortSide);
    }
    points = new KVectorChain_0(edge.bendPoints);
    $addNode_0(points, p1, points.header, points.header.next_0);
    $addNode_0(points, p2, points.tail.prev, points.tail);
    outerSegmentIsFirst = edge.source == externalPort;
    segments = new ComponentsCompactor$Segments;
    for(i = 0; i < points.size_0 - 1; ++i){
        segment = new Pair(castTo($get_7(points, i), 8), castTo($get_7(points, i + 1), 8));
        outerSegmentIsFirst && i == 0 || !outerSegmentIsFirst && i == points.size_0 - 2 ? segments.outerSegment = segment : $add_3(segments.innerSegments, segment);
    }
    return segments;
}
function $getExternalPortPosition(this$static, pos, ps) {
    switch(ps.ordinal){
        case 1:
            return new KVector_1(pos.x_0, $wnd.Math.min(this$static.graphTopLeft.y_0, pos.y_0));
        case 2:
            return new KVector_1($wnd.Math.max(this$static.graphBottomRight.x_0, pos.x_0), pos.y_0);
        case 3:
            return new KVector_1(pos.x_0, $wnd.Math.max(this$static.graphBottomRight.y_0, pos.y_0));
        case 4:
            return new KVector_1($wnd.Math.min(pos.x_0, this$static.graphTopLeft.x_0), pos.y_0);
    }
    return new KVector_1(pos.x_0, pos.y_0);
}
function $getPortPositionOnMargin(port) {
    var margins, pos;
    pos = $clone_1(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        port.owner.pos,
        port.pos,
        port.anchor
    ])));
    margins = port.owner.margin;
    switch(port.side.ordinal){
        case 1:
            pos.y_0 -= margins.top_0;
            break;
        case 2:
            pos.x_0 += margins.right;
            break;
        case 3:
            pos.y_0 += margins.bottom;
            break;
        case 4:
            pos.x_0 -= margins.left;
    }
    return pos;
}
function $portSideToDirection(side) {
    switch(side.ordinal){
        case 1:
            return $clinit_Direction(), UP_1;
        case 4:
            return $clinit_Direction(), LEFT_6;
        case 2:
            return $clinit_Direction(), RIGHT_6;
        case 3:
            return $clinit_Direction(), DOWN_1;
    }
    return $clinit_Direction(), UNDEFINED_2;
}
function $segmentToRectangle(p1, p2, extent) {
    return new ElkRectangle_0($wnd.Math.min(p1.x_0, p2.x_0) - extent / 2, $wnd.Math.min(p1.y_0, p2.y_0) - extent / 2, $wnd.Math.abs(p1.x_0 - p2.x_0) + extent, $wnd.Math.abs(p1.y_0 - p2.y_0) + extent);
}
function $transformLEdge(this$static, externalEdge, hullPoints, outerSegments) {
    var extent, externalExtension, margins, outerSegmentRect, rect, segment, segment$iterator, segments, side, thickness;
    externalExtension = new ComponentsCompactor$InternalExternalExtension(externalEdge);
    segments = $edgeToSegments(this$static, externalEdge, externalExtension);
    thickness = $wnd.Math.max($doubleValue(castToDouble($getProperty(externalEdge, ($clinit_LayeredOptions(), EDGE_THICKNESS)))), 1);
    for(segment$iterator = new ArrayList$1(segments.innerSegments); segment$iterator.i < segment$iterator.this$01.array.length;){
        segment = castTo($next_6(segment$iterator), 47);
        rect = $segmentToRectangle(castTo(segment.first, 8), castTo(segment.second, 8), thickness);
        returnVal = true;
        returnVal = returnVal & $add_13(hullPoints, new KVector_1(rect.x_0, rect.y_0));
        returnVal = returnVal & $add_13(hullPoints, $add_18(new KVector_1(rect.x_0, rect.y_0), rect.width_0, 0));
        returnVal = returnVal & $add_13(hullPoints, $add_18(new KVector_1(rect.x_0, rect.y_0), 0, rect.height));
        returnVal, $add_13(hullPoints, $add_18(new KVector_1(rect.x_0, rect.y_0), rect.width_0, rect.height));
    }
    side = externalExtension.externalPortSide;
    outerSegmentRect = $segmentToRectangle(castTo(segments.outerSegment.first, 8), castTo(segments.outerSegment.second, 8), thickness);
    if (side == ($clinit_PortSide(), WEST_0) || side == EAST_0) {
        outerSegments.min_0[side.ordinal] = $wnd.Math.min(outerSegments.min_0[side.ordinal], outerSegmentRect.y_0);
        outerSegments.max_0[side.ordinal] = $wnd.Math.max(outerSegments.max_0[side.ordinal], outerSegmentRect.y_0 + outerSegmentRect.height);
    } else {
        outerSegments.min_0[side.ordinal] = $wnd.Math.min(outerSegments.min_0[side.ordinal], outerSegmentRect.x_0);
        outerSegments.max_0[side.ordinal] = $wnd.Math.max(outerSegments.max_0[side.ordinal], outerSegmentRect.x_0 + outerSegmentRect.width_0);
    }
    extent = $intern_61;
    margins = externalExtension.externalPort.owner.margin;
    switch(side.ordinal){
        case 4:
            extent = margins.right;
            break;
        case 2:
            extent = margins.left;
            break;
        case 1:
            extent = margins.bottom;
            break;
        case 3:
            extent = margins.top_0;
    }
    outerSegments.extent[side.ordinal] = $wnd.Math.max(outerSegments.extent[side.ordinal], extent);
    return externalExtension;
}
function $transformLGraph(this$static, graph) {
    var component, edge, edge$iterator, extension, extensions, extent, externalExtensions, hullPoints, iee, iuee, max_0, min_0, node, node$iterator, outerSegments, placeholder, ps, ps$iterator;
    component = new ComponentsCompactor$InternalComponent(graph);
    component.containsRegularNodes || $createDummyNode(graph);
    hullPoints = $componentHullPoints(graph);
    externalExtensions = new HashMultimap;
    outerSegments = new ComponentsCompactor$OuterSegments;
    for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            if (edge.source.owner.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) || edge.target.owner.type_0 == EXTERNAL_PORT) {
                iee = $transformLEdge(this$static, edge, hullPoints, outerSegments);
                $put(externalExtensions, $portSideToDirection(iee.externalPortSide), iee.edge);
            }
        }
    }
    extensions = new ArrayList;
    for(ps$iterator = castTo($getProperty(component.graph_0, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22).iterator_0(); ps$iterator.hasNext_0();){
        ps = castTo(ps$iterator.next_1(), 64);
        min_0 = outerSegments.min_0[ps.ordinal];
        max_0 = outerSegments.max_0[ps.ordinal];
        extent = outerSegments.extent[ps.ordinal];
        extension = null;
        placeholder = null;
        switch(ps.ordinal){
            case 4:
                extension = new ElkRectangle_0(this$static.graphTopLeft.x_0, min_0, hullPoints.topLeft.x_0 - this$static.graphTopLeft.x_0, max_0 - min_0);
                placeholder = new ElkRectangle_0(this$static.graphTopLeft.x_0, min_0, extent, max_0 - min_0);
                $add_13(hullPoints, new KVector_1(extension.x_0 + extension.width_0, extension.y_0));
                $add_13(hullPoints, new KVector_1(extension.x_0 + extension.width_0, extension.y_0 + extension.height));
                break;
            case 2:
                extension = new ElkRectangle_0(hullPoints.bottomRight.x_0, min_0, this$static.graphBottomRight.x_0 - hullPoints.bottomRight.x_0, max_0 - min_0);
                placeholder = new ElkRectangle_0(this$static.graphBottomRight.x_0 - extent, min_0, extent, max_0 - min_0);
                $add_13(hullPoints, new KVector_1(extension.x_0, extension.y_0));
                $add_13(hullPoints, new KVector_1(extension.x_0, extension.y_0 + extension.height));
                break;
            case 1:
                extension = new ElkRectangle_0(min_0, this$static.graphTopLeft.y_0, max_0 - min_0, hullPoints.topLeft.y_0 - this$static.graphTopLeft.y_0);
                placeholder = new ElkRectangle_0(min_0, this$static.graphTopLeft.y_0, max_0 - min_0, extent);
                $add_13(hullPoints, new KVector_1(extension.x_0, extension.y_0 + extension.height));
                $add_13(hullPoints, new KVector_1(extension.x_0 + extension.width_0, extension.y_0 + extension.height));
                break;
            case 3:
                extension = new ElkRectangle_0(min_0, hullPoints.bottomRight.y_0, max_0 - min_0, this$static.graphBottomRight.y_0 - hullPoints.bottomRight.y_0);
                placeholder = new ElkRectangle_0(min_0, this$static.graphBottomRight.y_0 - extent, max_0 - min_0, extent);
                $add_13(hullPoints, new KVector_1(extension.x_0, extension.y_0));
                $add_13(hullPoints, new KVector_1(extension.x_0 + extension.width_0, extension.y_0));
        }
        if (extension) {
            iuee = new ComponentsCompactor$InternalUnionExternalExtension;
            iuee.side = ps;
            iuee.extension = extension;
            iuee.placeholder = placeholder;
            iuee.edges = newHashSet(castTo($get(externalExtensions, $portSideToDirection(ps)), 22));
            push_1(extensions.array, iuee);
        }
    }
    $addAll_2(component.externalExtensions, extensions);
    component.rectilinearConvexHull = $splitIntoRectangles(of_5(hullPoints));
    return component;
}
function ComponentsCompactor() {}
defineClass(643, 1, {}, ComponentsCompactor);
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor', 643);
function $add_12(this$static, e) {
    this$static.topLeft.x_0 = $wnd.Math.min(this$static.topLeft.x_0, e.x_0);
    this$static.topLeft.y_0 = $wnd.Math.min(this$static.topLeft.y_0, e.y_0);
    this$static.bottomRight.x_0 = $wnd.Math.max(this$static.bottomRight.x_0, e.x_0);
    this$static.bottomRight.y_0 = $wnd.Math.max(this$static.bottomRight.y_0, e.y_0);
    return push_1(this$static.array, e), true;
}
function $add_13(this$static, e) {
    return $add_12(this$static, new Point(e.x_0, e.y_0));
}
function ComponentsCompactor$Hullpoints() {
    $$init_1(this);
    this.topLeft = new KVector_1($intern_60, $intern_60);
    this.bottomRight = new KVector_1($intern_61, $intern_61);
}
defineClass(1473, 13, $intern_71, ComponentsCompactor$Hullpoints);
_.add_2 = function add_44(e) {
    return $add_12(this, castTo(e, 143));
};
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$Hullpoints_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/Hullpoints', 1473);
function $getExternalEdges(this$static) {
    var edges, ee, ee$iterator;
    edges = new ArrayList;
    for(ee$iterator = new ArrayList$1(this$static.externalExtensions); ee$iterator.i < ee$iterator.this$01.array.length;){
        ee = castTo($next_6(ee$iterator), 586);
        $addAll_2(edges, castTo(ee.getRepresentative(), 16));
    }
    return edges;
}
function ComponentsCompactor$InternalComponent(graph) {
    var n, n$iterator;
    this.externalExtensions = new ArrayList;
    this.graph_0 = graph;
    this.containsRegularNodes = false;
    for(n$iterator = new ArrayList$1(graph.layerlessNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 9);
        this.containsRegularNodes = this.containsRegularNodes | n.type_0 == ($clinit_LNode$NodeType(), NORMAL);
    }
}
defineClass(1470, 1, {
    834: 1
}, ComponentsCompactor$InternalComponent);
_.containsRegularNodes = false;
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$InternalComponent_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/InternalComponent', 1470);
function ComponentsCompactor$InternalConnectedComponents() {
    this.components = new ArrayList;
}
defineClass(1469, 1, $intern_23, ComponentsCompactor$InternalConnectedComponents);
_.forEach_0 = function forEach_25(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_67() {
    return new ArrayList$1(this.components);
};
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$InternalConnectedComponents_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/InternalConnectedComponents', 1469);
function ComponentsCompactor$InternalExternalExtension(edge) {
    this.edge = edge;
    if (edge.source.owner.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
        this.externalPort = edge.source;
        this.externalPortSide = castTo($getProperty(edge.source.owner, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
    } else if (edge.target.owner.type_0 == EXTERNAL_PORT) {
        this.externalPort = edge.target;
        this.externalPortSide = castTo($getProperty(edge.target.owner, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
    } else throw toJs(new IllegalArgumentException_0('Edge ' + edge + ' is not an external edge.'));
}
defineClass(1472, 1, {
    586: 1
}, ComponentsCompactor$InternalExternalExtension);
_.getPlaceholder = function getPlaceholder() {
    return null;
};
_.getRepresentative = function getRepresentative() {
    return this.edge;
};
_.getDirection = function getDirection() {
    return $portSideToDirection(this.externalPortSide);
};
_.getRepresentor = function getRepresentor() {
    return this.externalExtension;
};
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$InternalExternalExtension_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/InternalExternalExtension', 1472);
function ComponentsCompactor$InternalUnionExternalExtension() {
    this.edges = new HashSet;
}
defineClass(1471, 1, {
    586: 1
}, ComponentsCompactor$InternalUnionExternalExtension);
_.getRepresentative = function getRepresentative_0() {
    return this.edges;
};
_.getDirection = function getDirection_0() {
    return $portSideToDirection(this.side);
};
_.getPlaceholder = function getPlaceholder_0() {
    return this.placeholder;
};
_.getRepresentor = function getRepresentor_0() {
    return this.extension;
};
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$InternalUnionExternalExtension_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/InternalUnionExternalExtension', 1471);
function ComponentsCompactor$OuterSegments() {
    this.min_0 = initUnidimensionalArray(D_classLit, $intern_66, 30, ($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])).length, 15, 1);
    this.max_0 = initUnidimensionalArray(D_classLit, $intern_66, 30, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ]).length, 15, 1);
    this.extent = initUnidimensionalArray(D_classLit, $intern_66, 30, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ]).length, 15, 1);
    fill_0(this.min_0, $intern_60);
    fill_0(this.max_0, $intern_61);
    fill_0(this.extent, $intern_61);
}
defineClass(1475, 1, {}, ComponentsCompactor$OuterSegments);
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$OuterSegments_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/OuterSegments', 1475);
function ComponentsCompactor$Segments() {
    this.innerSegments = new ArrayList;
}
defineClass(1474, 1, {}, ComponentsCompactor$Segments);
var Lorg_eclipse_elk_alg_layered_components_ComponentsCompactor$Segments_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsCompactor/Segments', 1474);
function $combine(this$static, components, target) {
    this$static.graphPlacer.combine(components, target);
}
function $dfs_1(this$static, node, data_0) {
    var all, component, extPortSides, mutableData, port1, port1$iterator, port2, port2$iterator;
    if (node.id_0 == 0) {
        node.id_0 = 1;
        mutableData = data_0;
        if (!mutableData) {
            component = new ArrayList;
            extPortSides = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
            mutableData = new Pair(component, extPortSides);
        }
        castTo(mutableData.first, 15).add_2(node);
        node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) && castTo(mutableData.second, 22).add_2(castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64));
        for(port1$iterator = new ArrayList$1(node.ports); port1$iterator.i < port1$iterator.this$01.array.length;){
            port1 = castTo($next_6(port1$iterator), 11);
            for(port2$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                new LPort$1(port1),
                new LPort$2(port1)
            ]))); $hasNext_1(port2$iterator);){
                port2 = castTo($next_0(port2$iterator), 11);
                $dfs_1(this$static, port2.owner, mutableData);
            }
        }
        return mutableData;
    }
    return null;
}
function $split_2(this$static, graph) {
    var compatiblePortConstraints, componentData, extPortConstraints, extPorts, n, n$iterator, newGraph, node, node$iterator, node$iterator0, result, separate, separateProperty;
    this$static.graphPlacer = this$static.simpleRowGraphPlacer;
    separateProperty = castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), SEPARATE_CONNECTED_COMPONENTS_0)));
    separate = separateProperty == null || (checkCriticalNotNull(separateProperty), separateProperty);
    extPorts = castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS));
    extPortConstraints = castTo($getProperty(graph, PORT_CONSTRAINTS_0), 100);
    compatiblePortConstraints = !(extPortConstraints == ($clinit_PortConstraints(), FIXED_ORDER) || extPortConstraints == FIXED_RATIO || extPortConstraints == FIXED_POS);
    if (separate && (compatiblePortConstraints || !extPorts)) {
        for(node$iterator0 = new ArrayList$1(graph.layerlessNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            node.id_0 = 0;
        }
        result = new ArrayList;
        for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            componentData = $dfs_1(this$static, node, null);
            if (componentData) {
                newGraph = new LGraph;
                $copyProperties(newGraph, graph);
                $setProperty_0(newGraph, EXT_PORT_CONNECTIONS, castTo(componentData.second, 22));
                $copy(newGraph.padding, graph.padding);
                $setProperty_0(newGraph, NODE_SIZE_MINIMUM_0, null);
                for(n$iterator = castTo(componentData.first, 15).iterator_0(); n$iterator.hasNext_0();){
                    n = castTo(n$iterator.next_1(), 9);
                    $add_3(newGraph.layerlessNodes, n);
                    n.graph_0 = newGraph;
                }
                result.add_2(newGraph);
            }
        }
        extPorts && (maskUndefined($getProperty(graph, CONSIDER_MODEL_ORDER_COMPONENTS_0)) === maskUndefined(($clinit_ComponentOrderingStrategy(), GROUP_MODEL_ORDER)) ? this$static.graphPlacer = this$static.componentGroupModelOrderGraphPlacer : maskUndefined($getProperty(graph, CONSIDER_MODEL_ORDER_COMPONENTS_0)) === maskUndefined(MODEL_ORDER) ? this$static.graphPlacer = this$static.modelOrderRowGraphPlacer : this$static.graphPlacer = this$static.componentGroupGraphPlacer);
    } else result = new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LGraph_2_classLit, 1), $intern_101, 36, 0, [
        graph
    ]));
    maskUndefined($getProperty(graph, CONSIDER_MODEL_ORDER_COMPONENTS_0)) !== maskUndefined(($clinit_ComponentOrderingStrategy(), NONE)) && ($clinit_Collections(), result.sort_0(new ComponentsProcessor$lambda$0$Type));
    return result;
}
function ComponentsProcessor_0() {
    this.componentGroupGraphPlacer = new ComponentGroupGraphPlacer;
    this.componentGroupModelOrderGraphPlacer = new ComponentGroupModelOrderGraphPlacer;
    this.modelOrderRowGraphPlacer = new ModelOrderRowGraphPlacer;
    this.simpleRowGraphPlacer = new SimpleRowGraphPlacer;
}
function lambda$0_22(g1_0, g2_1) {
    var g1Order, g2Order;
    g1Order = getMinimalModelOrder(g1_0);
    g2Order = getMinimalModelOrder(g2_1);
    return g1Order < g2Order ? -1 : g1Order > g2Order ? 1 : 0;
}
defineClass(1242, 1, {}, ComponentsProcessor_0);
var Lorg_eclipse_elk_alg_layered_components_ComponentsProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsProcessor', 1242);
function ComponentsProcessor$lambda$0$Type() {}
defineClass(1243, 1, $intern_88, ComponentsProcessor$lambda$0$Type);
_.compare_1 = function compare_32(arg0, arg1) {
    return lambda$0_22(castTo(arg0, 36), castTo(arg1, 36));
};
_.equals_0 = function equals_88(other) {
    return this === other;
};
_.reversed = function reversed_24() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_components_ComponentsProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ComponentsProcessor/lambda$0$Type', 1243);
function $clinit_ModelOrderComponentGroup() {
    $clinit_ModelOrderComponentGroup = emptyMethod;
    $clinit_ComponentGroup();
    MODEL_ORDER_CONSTRAINTS = new HashMultimap;
    $put(MODEL_ORDER_CONSTRAINTS, ($clinit_PortSide(), SIDES_NORTH), SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NONE, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NONE, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_SOUTH_WEST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_NORTH_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_NORTH_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_NORTH_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NONE, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_SOUTH, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_SOUTH_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NONE, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_SOUTH, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_SOUTH_WEST, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH_WEST, SIDES_EAST_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NONE, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST_WEST, SIDES_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_NORTH_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST, SIDES_NORTH_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_SOUTH, SIDES_NORTH_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NONE, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_SOUTH, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_WEST, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH_EAST_SOUTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_WEST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_EAST, SIDES_NORTH_EAST_SOUTH_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_WEST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_EAST_WEST, SIDES_EAST);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_NONE);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_NORTH);
    $put(MODEL_ORDER_CONSTRAINTS, SIDES_NORTH_SOUTH, SIDES_SOUTH);
}
function $add_14(this$static, component) {
    if ($canAdd(this$static, component)) {
        $put(this$static.components, castTo($getProperty(component, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22), component);
        $add_7(this$static.componentOrder, component);
        return true;
    } else return false;
}
function $canAdd(this$static, component) {
    var candidateSides, constraint, constraint$iterator, constraint$iterator0, constraints, modelOrderConstraints;
    candidateSides = castTo($getProperty(component, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22);
    constraints = castTo($get(($clinit_ComponentGroup(), CONSTRAINTS), candidateSides), 22);
    modelOrderConstraints = castTo($get(MODEL_ORDER_CONSTRAINTS, candidateSides), 22);
    for(constraint$iterator0 = constraints.iterator_0(); constraint$iterator0.hasNext_0();){
        constraint = castTo(constraint$iterator0.next_1(), 22);
        if (!castTo($get(this$static.components, constraint), 15).isEmpty()) return false;
    }
    for(constraint$iterator = modelOrderConstraints.iterator_0(); constraint$iterator.hasNext_0();){
        constraint = castTo(constraint$iterator.next_1(), 22);
        if (!castTo($get(this$static.components, constraint), 15).isEmpty()) return false;
    }
    return true;
}
function ModelOrderComponentGroup(component) {
    $clinit_ModelOrderComponentGroup();
    $$init_5(this);
    this.componentOrder = new LinkedList;
    $add_14(this, component);
    $add_7(this.componentOrder, component);
}
defineClass(561, 331, {
    331: 1,
    561: 1
}, ModelOrderComponentGroup);
_.add_4 = function add_45(component) {
    return $add_14(this, component);
};
_.canAdd = function canAdd_0(component) {
    return $canAdd(this, component);
};
var MODEL_ORDER_CONSTRAINTS;
var Lorg_eclipse_elk_alg_layered_components_ModelOrderComponentGroup_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ModelOrderComponentGroup', 561);
function SimpleRowGraphPlacer() {}
defineClass(1263, 2050, {}, SimpleRowGraphPlacer);
_.combine = function combine_1(components, target) {
    var compactor, componentSpacing, firstComponent, graph, graph$iterator, h, h$iterator, maxRowWidth, size_0, source, totalArea;
    if (components.size_1() == 1) {
        source = castTo(components.get_0(0), 36);
        if (source != target) {
            target.layerlessNodes.array.length = 0;
            $moveGraph_0(target, source, 0, 0);
            $copyProperties(target, source);
            $copy(target.padding, source.padding);
            target.size_0.x_0 = source.size_0.x_0;
            target.size_0.y_0 = source.size_0.y_0;
        }
        return;
    } else if (components.isEmpty()) {
        target.layerlessNodes.array.length = 0;
        target.size_0.x_0 = 0;
        target.size_0.y_0 = 0;
        return;
    }
    this.sortComponents(components, target);
    firstComponent = castTo(components.get_0(0), 36);
    target.layerlessNodes.array.length = 0;
    $copyProperties(target, firstComponent);
    maxRowWidth = 0;
    totalArea = 0;
    for(graph$iterator = components.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 36);
        size_0 = graph.size_0;
        maxRowWidth = $wnd.Math.max(maxRowWidth, size_0.x_0);
        totalArea += size_0.x_0 * size_0.y_0;
    }
    maxRowWidth = $wnd.Math.max(maxRowWidth, $wnd.Math.sqrt(totalArea) * $doubleValue(castToDouble($getProperty(target, ($clinit_LayeredOptions(), ASPECT_RATIO_0)))));
    componentSpacing = $doubleValue(castToDouble($getProperty(target, SPACING_COMPONENT_COMPONENT)));
    this.placeComponents(components, target, maxRowWidth, componentSpacing);
    if ($booleanValue(castToBoolean($getProperty(firstComponent, COMPACTION_CONNECTED_COMPONENTS_0)))) {
        compactor = new ComponentsCompactor;
        $compact_4(compactor, components, componentSpacing);
        for(h$iterator = components.iterator_0(); h$iterator.hasNext_0();){
            h = castTo(h$iterator.next_1(), 36);
            $add_19($reset_5(h.offset), compactor.yetAnotherOffset);
        }
        $add_19($reset_5(target.size_0), compactor.compactedGraphSize);
    }
    $moveGraphs(target, components);
};
_.placeComponents = function placeComponents(components, target, maxRowWidth, componentSpacing) {
    var broadestRow, graph, graph$iterator, highestBox, offset, size_0, xpos, ypos;
    xpos = 0;
    ypos = 0;
    highestBox = 0;
    broadestRow = componentSpacing;
    for(graph$iterator = components.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 36);
        size_0 = graph.size_0;
        if (xpos + size_0.x_0 > maxRowWidth) {
            xpos = 0;
            ypos += highestBox + componentSpacing;
            highestBox = 0;
        }
        offset = graph.offset;
        $offsetGraph(graph, xpos + offset.x_0, ypos + offset.y_0);
        $reset_5(offset);
        broadestRow = $wnd.Math.max(broadestRow, xpos + size_0.x_0);
        highestBox = $wnd.Math.max(highestBox, size_0.y_0);
        xpos += size_0.x_0 + componentSpacing;
    }
    target.size_0.x_0 = broadestRow;
    target.size_0.y_0 = ypos + highestBox;
};
_.sortComponents = function sortComponents(components, target) {
    var graph, graph$iterator, node, node$iterator, priority;
    if (maskUndefined($getProperty(target, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_COMPONENTS_0))) === maskUndefined(($clinit_ComponentOrderingStrategy(), NONE))) {
        for(graph$iterator = components.iterator_0(); graph$iterator.hasNext_0();){
            graph = castTo(graph$iterator.next_1(), 36);
            priority = 0;
            for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
                node = castTo($next_6(node$iterator), 9);
                priority += castTo($getProperty(node, PRIORITY_0), 17).value_0;
            }
            graph.id_0 = priority;
        }
        $clinit_Collections();
        components.sort_0(new SimpleRowGraphPlacer$1);
    }
};
var Lorg_eclipse_elk_alg_layered_components_SimpleRowGraphPlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'SimpleRowGraphPlacer', 1263);
function ModelOrderRowGraphPlacer() {}
defineClass(1266, 1263, {}, ModelOrderRowGraphPlacer);
_.placeComponents = function placeComponents_0(components, target, maxRowWidth, componentSpacing) {
    var broadestRow, graph, graph$iterator, highestBox, lastComponent, offset, size_0, startXOfRow, xpos, ypos;
    xpos = 0;
    ypos = 0;
    highestBox = 0;
    broadestRow = componentSpacing;
    lastComponent = null;
    startXOfRow = 0;
    for(graph$iterator = components.iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 36);
        size_0 = graph.size_0;
        if (xpos + size_0.x_0 > maxRowWidth && !castTo($getProperty(graph, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22).contains(($clinit_PortSide(), NORTH_1)) || !!lastComponent && castTo($getProperty(lastComponent, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22).contains(($clinit_PortSide(), EAST_0)) || castTo($getProperty(graph, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22).contains(($clinit_PortSide(), WEST_0))) {
            xpos = startXOfRow;
            ypos += highestBox + componentSpacing;
            highestBox = 0;
        }
        offset = graph.offset;
        castTo($getProperty(graph, ($clinit_InternalProperties_1(), EXT_PORT_CONNECTIONS)), 22).contains(($clinit_PortSide(), NORTH_1)) && (xpos = broadestRow + componentSpacing);
        $offsetGraph(graph, xpos + offset.x_0, ypos + offset.y_0);
        broadestRow = $wnd.Math.max(broadestRow, xpos + size_0.x_0);
        castTo($getProperty(graph, EXT_PORT_CONNECTIONS), 22).contains(SOUTH_0) && (startXOfRow = $wnd.Math.max(startXOfRow, xpos + size_0.x_0 + componentSpacing));
        $reset_5(offset);
        highestBox = $wnd.Math.max(highestBox, size_0.y_0);
        xpos += size_0.x_0 + componentSpacing;
        lastComponent = graph;
    }
    target.size_0.x_0 = broadestRow;
    target.size_0.y_0 = ypos + highestBox;
};
_.sortComponents = function sortComponents_0(components, target) {};
var Lorg_eclipse_elk_alg_layered_components_ModelOrderRowGraphPlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'ModelOrderRowGraphPlacer', 1266);
function $compare_2(graph1, graph2) {
    var prio, size1, size2;
    prio = graph2.id_0 - graph1.id_0;
    if (prio == 0) {
        size1 = graph1.size_0.x_0 * graph1.size_0.y_0;
        size2 = graph2.size_0.x_0 * graph2.size_0.y_0;
        return compare_4(size1, size2);
    }
    return prio;
}
function SimpleRowGraphPlacer$1() {}
defineClass(1264, 1, $intern_88, SimpleRowGraphPlacer$1);
_.compare_1 = function compare_33(graph1, graph2) {
    return $compare_2(castTo(graph1, 36), castTo(graph2, 36));
};
_.equals_0 = function equals_89(other) {
    return this === other;
};
_.reversed = function reversed_25() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_components_SimpleRowGraphPlacer$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.components', 'SimpleRowGraphPlacer/1', 1264);
function $clinit_CompoundGraphPostprocessor() {
    $clinit_CompoundGraphPostprocessor = emptyMethod;
    HAS_JUNCTION_POINTS_PREDICATE = new CompoundGraphPostprocessor$1;
}
function $process_0(graph, monitor) {
    var addUnnecessaryBendpoints, bendPoints, chEdge, chEdge$iterator, crossHierarchyEdges, crossHierarchyMap, dummyEdge, dummyEdge$iterator, dummyEdges, junctionPoints, lastPoint, ledge, nextPoint, offset, origEdge, origEdge$iterator, referenceGraph, referenceNode, sourcePoint, sourcePort, targetPoint, targetPort, xDiffEnough, yDiffEnough;
    monitor.begin('Compound graph postprocessor', 1);
    addUnnecessaryBendpoints = $booleanValue(castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), UNNECESSARY_BENDPOINTS_0))));
    crossHierarchyMap = castTo($getProperty(graph, ($clinit_InternalProperties_1(), CROSS_HIERARCHY_MAP)), 228);
    dummyEdges = new HashSet;
    for(origEdge$iterator = crossHierarchyMap.keySet_0().iterator_0(); origEdge$iterator.hasNext_0();){
        origEdge = castTo(origEdge$iterator.next_1(), 18);
        crossHierarchyEdges = new ArrayList_1(crossHierarchyMap.get_1(origEdge));
        $clinit_Collections();
        $sort(crossHierarchyEdges, new CrossHierarchyEdgeComparator(graph));
        sourcePort = $getActualSource((checkCriticalElementIndex(0, crossHierarchyEdges.array.length), castTo(crossHierarchyEdges.array[0], 248)));
        targetPort = $getActualTarget(castTo($get_11(crossHierarchyEdges, crossHierarchyEdges.array.length - 1), 248));
        referenceNode = sourcePort.owner;
        isDescendant(targetPort.owner, referenceNode) ? referenceGraph = referenceNode.nestedGraph : referenceGraph = $getGraph(referenceNode);
        junctionPoints = clearJunctionPoints(origEdge, crossHierarchyEdges);
        $reset_0(origEdge.bendPoints);
        lastPoint = null;
        for(chEdge$iterator = new ArrayList$1(crossHierarchyEdges); chEdge$iterator.i < chEdge$iterator.this$01.array.length;){
            chEdge = castTo($next_6(chEdge$iterator), 248);
            offset = new KVector;
            changeCoordSystem(offset, chEdge.graph_0, referenceGraph);
            ledge = chEdge.newEdge;
            bendPoints = new KVectorChain;
            $addAllAsCopies(bendPoints, 0, ledge.bendPoints);
            $offset_2(bendPoints, offset);
            sourcePoint = new KVector_2($getAbsoluteAnchor(ledge.source));
            targetPoint = new KVector_2($getAbsoluteAnchor(ledge.target));
            $add_19(sourcePoint, offset);
            $add_19(targetPoint, offset);
            if (lastPoint) {
                bendPoints.size_0 == 0 ? nextPoint = targetPoint : nextPoint = (checkCriticalElement(bendPoints.size_0 != 0), castTo(bendPoints.header.next_0.value_0, 8));
                xDiffEnough = $wnd.Math.abs(lastPoint.x_0 - nextPoint.x_0) > $intern_97;
                yDiffEnough = $wnd.Math.abs(lastPoint.y_0 - nextPoint.y_0) > $intern_97;
                (!addUnnecessaryBendpoints && xDiffEnough && yDiffEnough || addUnnecessaryBendpoints && (xDiffEnough || yDiffEnough)) && $add_7(origEdge.bendPoints, sourcePoint);
            }
            $addAll(origEdge.bendPoints, bendPoints);
            bendPoints.size_0 == 0 ? lastPoint = sourcePoint : lastPoint = (checkCriticalElement(bendPoints.size_0 != 0), castTo(bendPoints.tail.prev.value_0, 8));
            copyJunctionPoints(ledge, junctionPoints, offset);
            if ($getActualTarget(chEdge) == targetPort) {
                if ($getGraph(targetPort.owner) != chEdge.graph_0) {
                    offset = new KVector;
                    changeCoordSystem(offset, $getGraph(targetPort.owner), referenceGraph);
                }
                $setProperty_0(origEdge, TARGET_OFFSET, offset);
            }
            copyLabelsBack(ledge, origEdge, referenceGraph);
            dummyEdges.map_0.put(ledge, dummyEdges);
        }
        $setSource_0(origEdge, sourcePort);
        $setTarget_0(origEdge, targetPort);
    }
    for(dummyEdge$iterator = dummyEdges.map_0.keySet_0().iterator_0(); dummyEdge$iterator.hasNext_0();){
        dummyEdge = castTo(dummyEdge$iterator.next_1(), 18);
        $setSource_0(dummyEdge, null);
        $setTarget_0(dummyEdge, null);
    }
    monitor.done_1();
}
function clearJunctionPoints(origEdge, crossHierarchyEdges) {
    var junctionPoints;
    junctionPoints = castTo($getProperty(origEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
    if (any_0(crossHierarchyEdges, HAS_JUNCTION_POINTS_PREDICATE)) {
        if (!junctionPoints) {
            junctionPoints = new KVectorChain;
            $setProperty_0(origEdge, JUNCTION_POINTS, junctionPoints);
        } else $reset_0(junctionPoints);
    } else !!junctionPoints && $setProperty_0(origEdge, JUNCTION_POINTS, null);
    return junctionPoints;
}
function copyJunctionPoints(source, target, offset) {
    var jpCopies, ledgeJPs;
    ledgeJPs = castTo($getProperty(source, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
    if (ledgeJPs) {
        jpCopies = new KVectorChain;
        $addAllAsCopies(jpCopies, 0, ledgeJPs);
        $offset_2(jpCopies, offset);
        $addAll(target, jpCopies);
    }
}
function copyLabelsBack(hierarchySegment, origEdge, referenceGraph) {
    var currLabel, labelIterator;
    labelIterator = new AbstractList$ListIteratorImpl(hierarchySegment.labels, 0);
    while(labelIterator.i < labelIterator.this$01_0.size_1()){
        currLabel = (checkCriticalElement(labelIterator.i < labelIterator.this$01_0.size_1()), castTo(labelIterator.this$01_0.get_0(labelIterator.last = labelIterator.i++), 72));
        if (maskUndefined($getProperty(currLabel, ($clinit_InternalProperties_1(), ORIGINAL_LABEL_EDGE))) !== maskUndefined(origEdge)) continue;
        changeCoordSystem(currLabel.pos, $getGraph(hierarchySegment.source.owner), referenceGraph);
        $remove_8(labelIterator);
        $add_3(origEdge.labels, currLabel);
    }
}
var HAS_JUNCTION_POINTS_PREDICATE;
function CompoundGraphPostprocessor$1() {}
defineClass(1240, 1, $intern_89, CompoundGraphPostprocessor$1);
_.apply_1 = function apply_36(chEdge) {
    var jps;
    return jps = castTo($getProperty(castTo(chEdge, 248).newEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77), !!jps && jps.size_0 != 0;
};
_.equals_0 = function equals_90(other) {
    return this === other;
};
_.test_0 = function test_9(input_0) {
    var jps;
    return jps = castTo($getProperty(castTo(input_0, 248).newEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77), !!jps && jps.size_0 != 0;
};
var Lorg_eclipse_elk_alg_layered_compound_CompoundGraphPostprocessor$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.compound', 'CompoundGraphPostprocessor/1', 1240);
function $calculateNetFlow(port) {
    var incomingEdge, incomingEdge$iterator, inputPortVote, insideSelfLoopsEnabled, isInsideSelfLoop, isSelfLoop, node, outgoingEdge, outgoingEdge$iterator, outputPortVote, sourceNode, targetNode;
    node = port.owner;
    insideSelfLoopsEnabled = $booleanValue(castToBoolean($getProperty(node, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE))));
    outputPortVote = 0;
    inputPortVote = 0;
    for(outgoingEdge$iterator = new ArrayList$1(port.outgoingEdges); outgoingEdge$iterator.i < outgoingEdge$iterator.this$01.array.length;){
        outgoingEdge = castTo($next_6(outgoingEdge$iterator), 18);
        isSelfLoop = $isSelfLoop(outgoingEdge);
        isInsideSelfLoop = isSelfLoop && insideSelfLoopsEnabled && $booleanValue(castToBoolean($getProperty(outgoingEdge, INSIDE_SELF_LOOPS_YO)));
        targetNode = outgoingEdge.target.owner;
        isSelfLoop && isInsideSelfLoop ? ++inputPortVote : isSelfLoop && !isInsideSelfLoop ? ++outputPortVote : $getGraph(targetNode).parentNode == node ? ++inputPortVote : ++outputPortVote;
    }
    for(incomingEdge$iterator = new ArrayList$1(port.incomingEdges); incomingEdge$iterator.i < incomingEdge$iterator.this$01.array.length;){
        incomingEdge = castTo($next_6(incomingEdge$iterator), 18);
        isSelfLoop = $isSelfLoop(incomingEdge);
        isInsideSelfLoop = isSelfLoop && insideSelfLoopsEnabled && $booleanValue(castToBoolean($getProperty(incomingEdge, INSIDE_SELF_LOOPS_YO)));
        sourceNode = incomingEdge.source.owner;
        isSelfLoop && isInsideSelfLoop ? ++outputPortVote : isSelfLoop && !isInsideSelfLoop ? ++inputPortVote : $getGraph(sourceNode).parentNode == node ? ++outputPortVote : ++inputPortVote;
    }
    return outputPortVote - inputPortVote;
}
function $connectChild(this$static, graph, externalPort, origEdge, sourcePort, targetPort) {
    var dummyEdge;
    dummyEdge = $createDummyEdge(origEdge);
    $setSource_0(dummyEdge, sourcePort);
    $setTarget_0(dummyEdge, targetPort);
    $put(this$static.crossHierarchyMap, origEdge, new CrossHierarchyEdge(dummyEdge, graph, externalPort.type_0));
}
function $connectSiblings(this$static, graph, externalOutputPort, containedExternalPorts, origEdge) {
    var dummyEdge, externalPort2, externalPort2$iterator, targetExternalPort;
    targetExternalPort = null;
    for(externalPort2$iterator = new ArrayList$1(containedExternalPorts); externalPort2$iterator.i < externalPort2$iterator.this$01.array.length;){
        externalPort2 = castTo($next_6(externalPort2$iterator), 441);
        if (externalPort2 != externalOutputPort && $indexOf_3(externalPort2.origEdges, origEdge, 0) != -1) {
            targetExternalPort = externalPort2;
            break;
        }
    }
    dummyEdge = $createDummyEdge(origEdge);
    $setSource_0(dummyEdge, externalOutputPort.dummyPort);
    $setTarget_0(dummyEdge, targetExternalPort.dummyPort);
    $put(this$static.crossHierarchyMap, origEdge, new CrossHierarchyEdge(dummyEdge, graph, externalOutputPort.type_0));
}
function $createDummyEdge(origEdge) {
    var dummyEdge;
    dummyEdge = new LEdge;
    $copyProperties(dummyEdge, origEdge);
    $setProperty_0(dummyEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS), null);
    return dummyEdge;
}
function $createExternalPortDummy(this$static, graph, parentNode, portType, portSide, edge) {
    var dummyNode, dummyPort, layoutDirection, outsidePort, propertyHolder, offset;
    dummyNode = null;
    outsidePort = portType == ($clinit_PortType(), INPUT) ? edge.source : edge.target;
    layoutDirection = getDirection_1(graph);
    if (outsidePort.owner == parentNode) {
        dummyNode = castTo($get_10(this$static.dummyNodeMap, outsidePort), 9);
        if (!dummyNode) {
            dummyNode = createExternalPortDummy(outsidePort, castTo($getProperty(parentNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100), portSide, $calculateNetFlow(outsidePort), null, outsidePort.pos, outsidePort.size_0, layoutDirection, graph);
            $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), outsidePort);
            $put_6(this$static.dummyNodeMap, outsidePort, dummyNode);
        }
    } else {
        dummyNode = createExternalPortDummy((propertyHolder = new MapPropertyHolder, offset = $doubleValue(castToDouble($getProperty(graph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE)))) / 2, $setProperty(propertyHolder, PORT_BORDER_OFFSET, offset), propertyHolder), castTo($getProperty(parentNode, PORT_CONSTRAINTS_0), 100), portSide, portType == INPUT ? -1 : 1, null, new KVector, new KVector_1(0, 0), layoutDirection, graph);
        dummyPort = $createPortForDummy(dummyNode, parentNode, portType);
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), dummyPort);
        $put_6(this$static.dummyNodeMap, dummyPort, dummyNode);
    }
    castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).add_2(($clinit_GraphProperties(), EXTERNAL_PORTS));
    $isSideFixed(castTo($getProperty(graph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100)) ? $setProperty_0(graph, PORT_CONSTRAINTS_0, ($clinit_PortConstraints(), FIXED_SIDE)) : $setProperty_0(graph, PORT_CONSTRAINTS_0, ($clinit_PortConstraints(), FREE));
    return dummyNode;
}
function $createPortForDummy(dummyNode, parentNode, type_0) {
    var graph, layoutDirection, port;
    graph = $getGraph(parentNode);
    layoutDirection = getDirection_1(graph);
    port = new LPort;
    $setNode(port, parentNode);
    switch(type_0.ordinal){
        case 1:
            $setSide(port, $opposed(fromDirection(layoutDirection)));
            break;
        case 2:
            $setSide(port, fromDirection(layoutDirection));
    }
    $setProperty_0(port, ($clinit_LayeredOptions(), PORT_BORDER_OFFSET), castToDouble($getProperty(dummyNode, PORT_BORDER_OFFSET)));
    return port;
}
function $getShallowestEdgeSegment(edgeSegments) {
    var crossHierarchyEdge, crossHierarchyEdge$iterator, index_0, result;
    result = -1;
    index_0 = 0;
    for(crossHierarchyEdge$iterator = new ArrayList$1(edgeSegments); crossHierarchyEdge$iterator.i < crossHierarchyEdge$iterator.this$01.array.length;){
        crossHierarchyEdge = castTo($next_6(crossHierarchyEdge$iterator), 248);
        if (crossHierarchyEdge.type_0 == ($clinit_PortType(), INPUT)) {
            result = index_0 == 0 ? 0 : index_0 - 1;
            break;
        } else index_0 == edgeSegments.array.length - 1 && (result = index_0);
        index_0 += 1;
    }
    return result;
}
function $introduceHierarchicalEdgeSegment(this$static, graph, parentNode, origEdge, oppositePort, portType, defaultExternalPort) {
    var dummyEdge, dummyNode, externalPort, externalPortSide, mergeExternalPorts, parentEndPort, thickness;
    mergeExternalPorts = $booleanValue(castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), MERGE_HIERARCHY_EDGES_0))));
    parentEndPort = null;
    portType == ($clinit_PortType(), INPUT) && origEdge.source.owner == parentNode ? parentEndPort = origEdge.source : portType == OUTPUT && origEdge.target.owner == parentNode && (parentEndPort = origEdge.target);
    externalPort = defaultExternalPort;
    if (!externalPort || !mergeExternalPorts || !!parentEndPort) {
        externalPortSide = ($clinit_PortSide(), UNDEFINED_5);
        parentEndPort ? externalPortSide = parentEndPort.side : $isSideFixed(castTo($getProperty(parentNode, PORT_CONSTRAINTS_0), 100)) && (externalPortSide = portType == INPUT ? WEST_0 : EAST_0);
        dummyNode = $createExternalPortDummy(this$static, graph, parentNode, portType, externalPortSide, origEdge);
        dummyEdge = $createDummyEdge(($getGraph(parentNode), origEdge));
        if (portType == INPUT) {
            $setSource_0(dummyEdge, castTo($get_11(dummyNode.ports, 0), 11));
            $setTarget_0(dummyEdge, oppositePort);
        } else {
            $setSource_0(dummyEdge, oppositePort);
            $setTarget_0(dummyEdge, castTo($get_11(dummyNode.ports, 0), 11));
        }
        externalPort = new CompoundGraphPreprocessor$ExternalPort(origEdge, dummyEdge, dummyNode, castTo($getProperty(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0)), 11), portType, !parentEndPort);
    } else {
        $add_3(externalPort.origEdges, origEdge);
        thickness = $wnd.Math.max($doubleValue(castToDouble($getProperty(externalPort.newEdge, EDGE_THICKNESS))), $doubleValue(castToDouble($getProperty(origEdge, EDGE_THICKNESS))));
        $setProperty_0(externalPort.newEdge, EDGE_THICKNESS, thickness);
    }
    $put(this$static.crossHierarchyMap, origEdge, new CrossHierarchyEdge(externalPort.newEdge, graph, portType));
    return externalPort;
}
function $moveLabelsAndRemoveOriginalEdges(this$static, graph) {
    var currLabel, edgeSegments, labelIterator, origEdge, origEdge$iterator, targetDummyEdgeIndex, targetSegment;
    for(origEdge$iterator = $keySet(this$static.crossHierarchyMap).iterator_0(); origEdge$iterator.hasNext_0();){
        origEdge = castTo(origEdge$iterator.next_1(), 18);
        if (origEdge.labels.array.length > 0) {
            edgeSegments = new ArrayList_1(castTo($get(this$static.crossHierarchyMap, origEdge), 22));
            $clinit_Collections();
            $sort(edgeSegments, new CrossHierarchyEdgeComparator(graph));
            labelIterator = new AbstractList$ListIteratorImpl(origEdge.labels, 0);
            while(labelIterator.i < labelIterator.this$01_0.size_1()){
                currLabel = (checkCriticalElement(labelIterator.i < labelIterator.this$01_0.size_1()), castTo(labelIterator.this$01_0.get_0(labelIterator.last = labelIterator.i++), 72));
                targetDummyEdgeIndex = -1;
                switch(castTo($getProperty(currLabel, ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT)), 276).ordinal){
                    case 1:
                        targetDummyEdgeIndex = edgeSegments.array.length - 1;
                        break;
                    case 0:
                        targetDummyEdgeIndex = $getShallowestEdgeSegment(edgeSegments);
                        break;
                    case 2:
                        targetDummyEdgeIndex = 0;
                }
                if (targetDummyEdgeIndex != -1) {
                    targetSegment = (checkCriticalElementIndex(targetDummyEdgeIndex, edgeSegments.array.length), castTo(edgeSegments.array[targetDummyEdgeIndex], 248));
                    $add_3(targetSegment.newEdge.labels, currLabel);
                    castTo($getProperty($getGraph(targetSegment.newEdge.source.owner), ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).add_2(($clinit_GraphProperties(), END_LABELS));
                    castTo($getProperty($getGraph(targetSegment.newEdge.source.owner), GRAPH_PROPERTIES), 22).add_2(CENTER_LABELS);
                    $remove_8(labelIterator);
                    $setProperty_0(currLabel, ORIGINAL_LABEL_EDGE, origEdge);
                }
            }
        }
        $setSource_0(origEdge, null);
        $setTarget_0(origEdge, null);
    }
}
function $process_1(this$static, graph, monitor) {
    monitor.begin('Compound graph preprocessor', 1);
    this$static.crossHierarchyMap = new HashMultimap;
    $transformHierarchyEdges(this$static, graph, null);
    $moveLabelsAndRemoveOriginalEdges(this$static, graph);
    $setSidesOfPortsToSidesOfDummyNodes(this$static);
    $setProperty_0(graph, ($clinit_InternalProperties_1(), CROSS_HIERARCHY_MAP), this$static.crossHierarchyMap);
    this$static.crossHierarchyMap = null;
    $reset(this$static.dummyNodeMap);
    monitor.done_1();
}
function $processInnerHierarchicalEdgeSegments(this$static, graph, parentNode, containedExternalPorts, exportedExternalPorts) {
    var createdExternalPorts, currentExternalPort, externalPort, externalPort$iterator, externalPort$iterator0, inEdge, inEdge$iterator, newExternalPort, outEdge, outEdge$iterator, sourceNode, targetNode;
    createdExternalPorts = new ArrayList;
    for(externalPort$iterator0 = new ArrayList$1(containedExternalPorts); externalPort$iterator0.i < externalPort$iterator0.this$01.array.length;){
        externalPort = castTo($next_6(externalPort$iterator0), 441);
        currentExternalPort = null;
        if (externalPort.type_0 == ($clinit_PortType(), OUTPUT)) for(outEdge$iterator = new ArrayList$1(externalPort.origEdges); outEdge$iterator.i < outEdge$iterator.this$01.array.length;){
            outEdge = castTo($next_6(outEdge$iterator), 18);
            targetNode = outEdge.target.owner;
            if ($getGraph(targetNode) == graph) $connectChild(this$static, graph, externalPort, outEdge, externalPort.dummyPort, outEdge.target);
            else if (!parentNode || isDescendant(targetNode, parentNode)) $connectSiblings(this$static, graph, externalPort, containedExternalPorts, outEdge);
            else {
                newExternalPort = $introduceHierarchicalEdgeSegment(this$static, graph, parentNode, outEdge, externalPort.dummyPort, OUTPUT, currentExternalPort);
                newExternalPort != currentExternalPort && push_1(createdExternalPorts.array, newExternalPort);
                newExternalPort.exported && (currentExternalPort = newExternalPort);
            }
        }
        else for(inEdge$iterator = new ArrayList$1(externalPort.origEdges); inEdge$iterator.i < inEdge$iterator.this$01.array.length;){
            inEdge = castTo($next_6(inEdge$iterator), 18);
            sourceNode = inEdge.source.owner;
            if ($getGraph(sourceNode) == graph) $connectChild(this$static, graph, externalPort, inEdge, inEdge.source, externalPort.dummyPort);
            else if (!parentNode || isDescendant(sourceNode, parentNode)) continue;
            else {
                newExternalPort = $introduceHierarchicalEdgeSegment(this$static, graph, parentNode, inEdge, externalPort.dummyPort, INPUT, currentExternalPort);
                newExternalPort != currentExternalPort && push_1(createdExternalPorts.array, newExternalPort);
                newExternalPort.exported && (currentExternalPort = newExternalPort);
            }
        }
    }
    for(externalPort$iterator = new ArrayList$1(createdExternalPorts); externalPort$iterator.i < externalPort$iterator.this$01.array.length;){
        externalPort = castTo($next_6(externalPort$iterator), 441);
        $indexOf_3(graph.layerlessNodes, externalPort.dummyNode, 0) != -1 || $add_3(graph.layerlessNodes, externalPort.dummyNode);
        externalPort.exported && push_1(exportedExternalPorts.array, externalPort);
    }
}
function $processInsideSelfLoops(this$static, nestedGraph, node) {
    var dummyEdge, isInsideSelfLoop, isSelfLoop, lport, lport$iterator, outEdge, outEdge$array, outEdge$index, outEdge$max, outEdges, sourceExtPortDummy, sourcePort, targetExtPortDummy, targetPort;
    if (!$booleanValue(castToBoolean($getProperty(node, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE))))) return;
    for(lport$iterator = new ArrayList$1(node.ports); lport$iterator.i < lport$iterator.this$01.array.length;){
        lport = castTo($next_6(lport$iterator), 11);
        outEdges = toEdgeArray(lport.outgoingEdges);
        for(outEdge$array = outEdges, outEdge$index = 0, outEdge$max = outEdge$array.length; outEdge$index < outEdge$max; ++outEdge$index){
            outEdge = outEdge$array[outEdge$index];
            isSelfLoop = outEdge.target.owner == node;
            isInsideSelfLoop = isSelfLoop && $booleanValue(castToBoolean($getProperty(outEdge, INSIDE_SELF_LOOPS_YO)));
            if (isInsideSelfLoop) {
                sourcePort = outEdge.source;
                sourceExtPortDummy = castTo($get_10(this$static.dummyNodeMap, sourcePort), 9);
                if (!sourceExtPortDummy) {
                    sourceExtPortDummy = createExternalPortDummy(sourcePort, ($clinit_PortConstraints(), FREE), sourcePort.side, -1, null, null, sourcePort.size_0, castTo($getProperty(nestedGraph, DIRECTION), 86), nestedGraph);
                    $setProperty_0(sourceExtPortDummy, ($clinit_InternalProperties_1(), ORIGIN_0), sourcePort);
                    $put_6(this$static.dummyNodeMap, sourcePort, sourceExtPortDummy);
                    $add_3(nestedGraph.layerlessNodes, sourceExtPortDummy);
                }
                targetPort = outEdge.target;
                targetExtPortDummy = castTo($get_10(this$static.dummyNodeMap, targetPort), 9);
                if (!targetExtPortDummy) {
                    targetExtPortDummy = createExternalPortDummy(targetPort, ($clinit_PortConstraints(), FREE), targetPort.side, 1, null, null, targetPort.size_0, castTo($getProperty(nestedGraph, DIRECTION), 86), nestedGraph);
                    $setProperty_0(targetExtPortDummy, ($clinit_InternalProperties_1(), ORIGIN_0), targetPort);
                    $put_6(this$static.dummyNodeMap, targetPort, targetExtPortDummy);
                    $add_3(nestedGraph.layerlessNodes, targetExtPortDummy);
                }
                dummyEdge = $createDummyEdge(outEdge);
                $setSource_0(dummyEdge, castTo($get_11(sourceExtPortDummy.ports, 0), 11));
                $setTarget_0(dummyEdge, castTo($get_11(targetExtPortDummy.ports, 0), 11));
                $put(this$static.crossHierarchyMap, outEdge, new CrossHierarchyEdge(dummyEdge, nestedGraph, ($clinit_PortType(), OUTPUT)));
                castTo($getProperty(nestedGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).add_2(($clinit_GraphProperties(), EXTERNAL_PORTS));
            }
        }
    }
}
function $processOuterHierarchicalEdgeSegments(this$static, graph, parentNode, exportedExternalPorts) {
    var childNode, childNode$iterator, childPort, childPort$iterator, createdExternalPorts, currentExternalInputPort, currentExternalOutputPort, externalPort, externalPort$iterator, inEdge, inEdge$array, inEdge$index, inEdge$max, newExternalPort, outEdge, outEdge$array, outEdge$index, outEdge$max;
    createdExternalPorts = new ArrayList;
    for(childNode$iterator = new ArrayList$1(graph.layerlessNodes); childNode$iterator.i < childNode$iterator.this$01.array.length;){
        childNode = castTo($next_6(childNode$iterator), 9);
        for(childPort$iterator = new ArrayList$1(childNode.ports); childPort$iterator.i < childPort$iterator.this$01.array.length;){
            childPort = castTo($next_6(childPort$iterator), 11);
            currentExternalOutputPort = null;
            for(outEdge$array = toEdgeArray(childPort.outgoingEdges), outEdge$index = 0, outEdge$max = outEdge$array.length; outEdge$index < outEdge$max; ++outEdge$index){
                outEdge = outEdge$array[outEdge$index];
                if (!isDescendant(outEdge.target.owner, parentNode)) {
                    newExternalPort = $introduceHierarchicalEdgeSegment(this$static, graph, parentNode, outEdge, outEdge.source, ($clinit_PortType(), OUTPUT), currentExternalOutputPort);
                    newExternalPort != currentExternalOutputPort && push_1(createdExternalPorts.array, newExternalPort);
                    newExternalPort.exported && (currentExternalOutputPort = newExternalPort);
                }
            }
            currentExternalInputPort = null;
            for(inEdge$array = toEdgeArray(childPort.incomingEdges), inEdge$index = 0, inEdge$max = inEdge$array.length; inEdge$index < inEdge$max; ++inEdge$index){
                inEdge = inEdge$array[inEdge$index];
                if (!isDescendant(inEdge.source.owner, parentNode)) {
                    newExternalPort = $introduceHierarchicalEdgeSegment(this$static, graph, parentNode, inEdge, inEdge.target, ($clinit_PortType(), INPUT), currentExternalInputPort);
                    newExternalPort != currentExternalInputPort && push_1(createdExternalPorts.array, newExternalPort);
                    newExternalPort.exported && (currentExternalInputPort = newExternalPort);
                }
            }
        }
    }
    for(externalPort$iterator = new ArrayList$1(createdExternalPorts); externalPort$iterator.i < externalPort$iterator.this$01.array.length;){
        externalPort = castTo($next_6(externalPort$iterator), 441);
        $indexOf_3(graph.layerlessNodes, externalPort.dummyNode, 0) != -1 || $add_3(graph.layerlessNodes, externalPort.dummyNode);
        externalPort.exported && push_1(exportedExternalPorts.array, externalPort);
    }
}
function $setSidesOfPortsToSidesOfDummyNodes(this$static) {
    var dummyNode, e, e$iterator, externalPort;
    for(e$iterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(this$static.dummyNodeMap).this$01); e$iterator.hasNext;){
        e = $next_3(e$iterator);
        externalPort = castTo(e.getKey(), 11);
        dummyNode = castTo(e.getValue(), 9);
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), externalPort);
        $setProperty_0(externalPort, PORT_DUMMY, dummyNode);
        $setProperty_0(externalPort, INSIDE_CONNECTIONS, ($clinit_Boolean(), true));
        $setSide(externalPort, castTo($getProperty(dummyNode, EXT_PORT_SIDE), 64));
        $getProperty(dummyNode, EXT_PORT_SIDE);
        $setProperty_0(externalPort.owner, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_SIDE));
        castTo($getProperty($getGraph(externalPort.owner), GRAPH_PROPERTIES), 22).add_2(($clinit_GraphProperties(), NON_FREE_PORTS));
    }
}
function $transformHierarchyEdges(this$static, graph, parentNode) {
    var childPorts, containedExternalPorts, dummyNode, dummyNodePort, dummyPortLabel, exportedExternalPorts, extPortLabel, extPortLabel$iterator, insidePart, insidePortLabels, nestedGraph, node, node$iterator, port, port$iterator, portConstraints, side;
    containedExternalPorts = new ArrayList;
    for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        nestedGraph = node.nestedGraph;
        if (nestedGraph) {
            childPorts = $transformHierarchyEdges(this$static, nestedGraph, node);
            $addAll_2(containedExternalPorts, childPorts);
            $processInsideSelfLoops(this$static, nestedGraph, node);
            if (castTo($getProperty(nestedGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS))) {
                portConstraints = castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
                insidePortLabels = castTo($getProperty(node, PORT_LABELS_PLACEMENT_1), 181).contains(($clinit_PortLabelPlacement(), INSIDE_0));
                for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                    port = castTo($next_6(port$iterator), 11);
                    dummyNode = castTo($get_10(this$static.dummyNodeMap, port), 9);
                    if (!dummyNode) {
                        dummyNode = createExternalPortDummy(port, portConstraints, port.side, -(port.incomingEdges.array.length - port.outgoingEdges.array.length), null, new KVector, port.size_0, castTo($getProperty(nestedGraph, DIRECTION), 86), nestedGraph);
                        $setProperty_0(dummyNode, ORIGIN_0, port);
                        $put_6(this$static.dummyNodeMap, port, dummyNode);
                        $add_3(nestedGraph.layerlessNodes, dummyNode);
                    }
                    dummyNodePort = castTo($get_11(dummyNode.ports, 0), 11);
                    for(extPortLabel$iterator = new ArrayList$1(port.labels); extPortLabel$iterator.i < extPortLabel$iterator.this$01.array.length;){
                        extPortLabel = castTo($next_6(extPortLabel$iterator), 72);
                        dummyPortLabel = new LLabel;
                        dummyPortLabel.size_0.x_0 = extPortLabel.size_0.x_0;
                        dummyPortLabel.size_0.y_0 = extPortLabel.size_0.y_0;
                        $add_3(dummyNodePort.labels, dummyPortLabel);
                        if (!insidePortLabels) {
                            side = port.side;
                            insidePart = 0;
                            isFixed(castTo($getProperty(node, PORT_LABELS_PLACEMENT_1), 22)) && (insidePart = computeInsidePart(extPortLabel.pos, extPortLabel.size_0, port.size_0, 0, side));
                            portConstraints == ($clinit_PortConstraints(), FREE) || ($clinit_PortSide(), SIDES_EAST_WEST).contains(side) ? dummyPortLabel.size_0.x_0 = insidePart : dummyPortLabel.size_0.y_0 = insidePart;
                        }
                    }
                }
            }
        }
    }
    exportedExternalPorts = new ArrayList;
    $processInnerHierarchicalEdgeSegments(this$static, graph, parentNode, containedExternalPorts, exportedExternalPorts);
    !!parentNode && $processOuterHierarchicalEdgeSegments(this$static, graph, parentNode, exportedExternalPorts);
    return exportedExternalPorts;
}
function CompoundGraphPreprocessor() {
    this.dummyNodeMap = new HashMap;
}
defineClass(1239, 1, $intern_102, CompoundGraphPreprocessor);
_.process = function process_0(graph, monitor) {
    $process_1(this, castTo(graph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_compound_CompoundGraphPreprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.compound', 'CompoundGraphPreprocessor', 1239);
function CompoundGraphPreprocessor$ExternalPort(origEdge, newEdge, dummyNode, dummyPort, portType, exported) {
    this.origEdges = new ArrayList;
    this.type_0 = ($clinit_PortType(), UNDEFINED_0);
    $add_3(this.origEdges, origEdge);
    this.newEdge = newEdge;
    this.dummyNode = dummyNode;
    this.dummyPort = dummyPort;
    this.type_0 = portType;
    this.exported = exported;
}
defineClass(441, 1, {
    441: 1
}, CompoundGraphPreprocessor$ExternalPort);
_.exported = false;
var Lorg_eclipse_elk_alg_layered_compound_CompoundGraphPreprocessor$ExternalPort_2_classLit = createForClass('org.eclipse.elk.alg.layered.compound', 'CompoundGraphPreprocessor/ExternalPort', 441);
function $getActualSource(this$static) {
    if (this$static.newEdge.source.owner.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) return castTo($getProperty(this$static.newEdge.source.owner, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    return this$static.newEdge.source;
}
function $getActualTarget(this$static) {
    if (this$static.newEdge.target.owner.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) return castTo($getProperty(this$static.newEdge.target.owner, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    return this$static.newEdge.target;
}
function CrossHierarchyEdge(newEdge, graph, type_0) {
    this.newEdge = newEdge;
    this.graph_0 = graph;
    this.type_0 = type_0;
}
defineClass(248, 1, {
    248: 1
}, CrossHierarchyEdge);
_.toString_0 = function toString_84() {
    return $toString_3(this.type_0) + ':' + $toString_12(this.newEdge);
};
var Lorg_eclipse_elk_alg_layered_compound_CrossHierarchyEdge_2_classLit = createForClass('org.eclipse.elk.alg.layered.compound', 'CrossHierarchyEdge', 248);
function $compare_3(this$static, edge1, edge2) {
    var level1, level2;
    if (edge1.type_0 == ($clinit_PortType(), OUTPUT) && edge2.type_0 == INPUT) return -1;
    else if (edge1.type_0 == INPUT && edge2.type_0 == OUTPUT) return 1;
    level1 = hierarchyLevel(edge1.graph_0, this$static.graph_0);
    level2 = hierarchyLevel(edge2.graph_0, this$static.graph_0);
    return edge1.type_0 == OUTPUT ? level2 - level1 : level1 - level2;
}
function CrossHierarchyEdgeComparator(graph) {
    this.graph_0 = graph;
}
function hierarchyLevel(nestedGraph, topLevelGraph) {
    var currentGraph, currentNode, level;
    currentGraph = nestedGraph;
    level = 0;
    do {
        if (currentGraph == topLevelGraph) return level;
        currentNode = currentGraph.parentNode;
        if (!currentNode) throw toJs(new IllegalArgumentException);
        currentGraph = $getGraph(currentNode);
        ++level;
    }while (true);
}
defineClass(759, 1, $intern_88, CrossHierarchyEdgeComparator);
_.compare_1 = function compare_34(edge1, edge2) {
    return $compare_3(this, castTo(edge1, 248), castTo(edge2, 248));
};
_.equals_0 = function equals_91(other) {
    return this === other;
};
_.reversed = function reversed_26() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_compound_CrossHierarchyEdgeComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.compound', 'CrossHierarchyEdgeComparator', 759);
function $getDesignation(this$static) {
    var identifier;
    identifier = getOriginIdentifier(this$static);
    if (identifier) return identifier;
    return null;
}
defineClass(306, 148, {
    3: 1,
    306: 1,
    102: 1,
    148: 1
});
_.id_0 = 0;
var Lorg_eclipse_elk_alg_layered_graph_LGraphElement_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphElement', 306);
function $getDesignation_0(this$static) {
    if (this$static.labels.array.length != 0 && !!castTo($get_11(this$static.labels, 0), 72).text_0) return castTo($get_11(this$static.labels, 0), 72).text_0;
    return $getDesignation(this$static);
}
function $getOther_1(this$static, node) {
    if (node == this$static.source.owner) return this$static.target.owner;
    else if (node == this$static.target.owner) return this$static.source.owner;
    else throw toJs(new IllegalArgumentException_0("'node' must either be the source node or target node of the edge."));
}
function $getOther_2(this$static, port) {
    if (port == this$static.source) return this$static.target;
    else if (port == this$static.target) return this$static.source;
    else throw toJs(new IllegalArgumentException_0("'port' must be either the source port or target port of the edge."));
}
function $isInLayerEdge(this$static) {
    return !$isSelfLoop(this$static) && this$static.source.owner.layer == this$static.target.owner.layer;
}
function $isSelfLoop(this$static) {
    if (!this$static.source || !this$static.target) return false;
    return !!this$static.source.owner && this$static.source.owner == this$static.target.owner;
}
function $reverse_0(this$static, adaptPorts) {
    var label_0, label$iterator, labelPlacement, oldSource, oldTarget, reversed;
    oldSource = this$static.source;
    oldTarget = this$static.target;
    $setSource_0(this$static, null);
    $setTarget_0(this$static, null);
    adaptPorts && $booleanValue(castToBoolean($getProperty(oldTarget, ($clinit_InternalProperties_1(), INPUT_COLLECT)))) ? $setSource_0(this$static, provideCollectorPort(oldTarget.owner, ($clinit_PortType(), OUTPUT), ($clinit_PortSide(), EAST_0))) : $setSource_0(this$static, oldTarget);
    adaptPorts && $booleanValue(castToBoolean($getProperty(oldSource, ($clinit_InternalProperties_1(), OUTPUT_COLLECT)))) ? $setTarget_0(this$static, provideCollectorPort(oldSource.owner, ($clinit_PortType(), INPUT), ($clinit_PortSide(), WEST_0))) : $setTarget_0(this$static, oldSource);
    for(label$iterator = new ArrayList$1(this$static.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 72);
        labelPlacement = castTo($getProperty(label_0, ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT)), 276);
        labelPlacement == ($clinit_EdgeLabelPlacement(), TAIL) ? $setProperty_0(label_0, EDGE_LABELS_PLACEMENT, HEAD) : labelPlacement == HEAD && $setProperty_0(label_0, EDGE_LABELS_PLACEMENT, TAIL);
    }
    reversed = $booleanValue(castToBoolean($getProperty(this$static, ($clinit_InternalProperties_1(), REVERSED))));
    $setProperty_0(this$static, REVERSED, ($clinit_Boolean(), reversed ? false : true));
    this$static.bendPoints = reverse_3(this$static.bendPoints);
}
function $setSource_0(this$static, source) {
    !!this$static.source && $remove_12(this$static.source.outgoingEdges, this$static);
    this$static.source = source;
    !!this$static.source && $add_3(this$static.source.outgoingEdges, this$static);
}
function $setTarget_0(this$static, target) {
    !!this$static.target && $remove_12(this$static.target.incomingEdges, this$static);
    this$static.target = target;
    !!this$static.target && $add_3(this$static.target.incomingEdges, this$static);
}
function $setTargetAndInsertAtIndex(this$static, targetPort, index_0) {
    !!this$static.target && $remove_12(this$static.target.incomingEdges, this$static);
    this$static.target = targetPort;
    !!this$static.target && $add_2(this$static.target.incomingEdges, index_0, this$static);
}
function $toString_12(this$static) {
    var designation, result;
    result = new StringBuilder;
    result.string += 'e_';
    designation = $getDesignation_0(this$static);
    designation != null && (result.string += '' + designation, result);
    if (!!this$static.source && !!this$static.target) {
        $append_11((result.string += ' ', result), $getDesignation_3(this$static.source));
        $append_11($append_10((result.string += '[', result), this$static.source.owner), ']');
        $append_11((result.string += ' -> ', result), $getDesignation_3(this$static.target));
        $append_11($append_10((result.string += '[', result), this$static.target.owner), ']');
    }
    return result.string;
}
function LEdge() {
    this.bendPoints = new KVectorChain;
    this.labels = (checkNonnegative(3, 'initialArraySize'), new ArrayList_0(3));
}
defineClass(18, 306, {
    3: 1,
    18: 1,
    306: 1,
    102: 1,
    148: 1
}, LEdge);
_.toString_0 = function toString_85() {
    return $toString_12(this);
};
var Lorg_eclipse_elk_alg_layered_graph_LEdge_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LEdge', 18);
function $toNodeArray(this$static) {
    var layer, layerIndex, layerIter, lgraphArray;
    lgraphArray = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_16, 199, this$static.layers.array.length, 0, 2);
    layerIter = new AbstractList$ListIteratorImpl(this$static.layers, 0);
    while(layerIter.i < layerIter.this$01_0.size_1()){
        layer = (checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25));
        layerIndex = layerIter.i - 1;
        lgraphArray[layerIndex] = toNodeArray(layer.nodes);
    }
    return lgraphArray;
}
function LGraph() {
    this.size_0 = new KVector;
    this.padding = new LPadding;
    this.offset = new KVector;
    this.layerlessNodes = new ArrayList;
    this.layers = new ArrayList;
}
defineClass(36, 306, {
    3: 1,
    20: 1,
    36: 1,
    306: 1,
    102: 1,
    148: 1
}, LGraph);
_.forEach_0 = function forEach_26(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_68() {
    return new ArrayList$1(this.layers);
};
_.toString_0 = function toString_86() {
    if (this.layers.array.length == 0) return 'G-unlayered' + $toString_2(this.layerlessNodes);
    else if (this.layerlessNodes.array.length == 0) return 'G-layered' + $toString_2(this.layers);
    return 'G[layerless' + $toString_2(this.layerlessNodes) + ', layers' + $toString_2(this.layers) + ']';
};
var Lorg_eclipse_elk_alg_layered_graph_LGraph_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraph', 36);
function $clinit_LGraphAdapters() {
    $clinit_LGraphAdapters = emptyMethod;
    DEFAULT_PORTLIST_SORTER = new LGraphAdapters$PortComparator;
}
var DEFAULT_PORTLIST_SORTER;
defineClass(650, 1, {});
_.getPosition = function getPosition() {
    return this.element.pos;
};
_.getProperty = function getProperty_0(prop) {
    return $getProperty(this.element, prop);
};
_.getSize = function getSize() {
    return this.element.size_0;
};
_.getVolatileId = function getVolatileId() {
    return this.element.id_0;
};
_.hasProperty = function hasProperty_0(prop) {
    return $hasProperty(this.element, prop);
};
_.setPosition = function setPosition(pos) {
    this.element.pos.x_0 = pos.x_0;
    this.element.pos.y_0 = pos.y_0;
};
_.setSize = function setSize(size_0) {
    this.element.size_0.x_0 = size_0.x_0;
    this.element.size_0.y_0 = size_0.y_0;
};
_.setVolatileId = function setVolatileId(volatileId) {
    this.element.id_0 = volatileId;
};
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$AbstractLShapeAdapter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/AbstractLShapeAdapter', 650);
function LGraphAdapters$LEdgeAdapter(edge) {
    this.element = edge;
}
defineClass(460, 1, {
    832: 1
}, LGraphAdapters$LEdgeAdapter);
_.getLabels = function getLabels() {
    var l, l$iterator;
    if (!this.labelAdapters) {
        this.labelAdapters = newArrayListWithCapacity(this.element.labels.array.length);
        for(l$iterator = new ArrayList$1(this.element.labels); l$iterator.i < l$iterator.this$01.array.length;){
            l = castTo($next_6(l$iterator), 72);
            $add_3(this.labelAdapters, new LGraphAdapters$LLabelAdapter(l));
        }
    }
    return this.labelAdapters;
};
_.labelAdapters = null;
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$LEdgeAdapter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/LEdgeAdapter', 460);
function LGraphAdapters$LGraphAdapter(element, transparentNorthSouthEdges, transparentCommentNodes, nodeFilter) {
    this.element = element;
    this.transparentNorthSouthEdges = transparentNorthSouthEdges;
    this.transparentCommentNodes = transparentCommentNodes;
    this.nodeFilter = nodeFilter;
}
defineClass(649, 1, {}, LGraphAdapters$LGraphAdapter);
_.getNodes = function getNodes() {
    var comment, comment$iterator, l, l$iterator, n, n$iterator;
    if (!this.nodeAdapters) {
        this.nodeAdapters = new ArrayList;
        for(l$iterator = new ArrayList$1(this.element.layers); l$iterator.i < l$iterator.this$01.array.length;){
            l = castTo($next_6(l$iterator), 25);
            for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
                n = castTo($next_6(n$iterator), 9);
                if (this.nodeFilter.test_0(n)) {
                    $add_3(this.nodeAdapters, new LGraphAdapters$LNodeAdapter(this, n, this.transparentNorthSouthEdges));
                    if (this.transparentCommentNodes) {
                        if ($hasProperty(n, ($clinit_InternalProperties_1(), TOP_COMMENTS))) for(comment$iterator = castTo($getProperty(n, TOP_COMMENTS), 15).iterator_0(); comment$iterator.hasNext_0();){
                            comment = castTo(comment$iterator.next_1(), 9);
                            $add_3(this.nodeAdapters, new LGraphAdapters$LNodeAdapter(this, comment, false));
                        }
                        if ($hasProperty(n, BOTTOM_COMMENTS)) for(comment$iterator = castTo($getProperty(n, BOTTOM_COMMENTS), 15).iterator_0(); comment$iterator.hasNext_0();){
                            comment = castTo(comment$iterator.next_1(), 9);
                            $add_3(this.nodeAdapters, new LGraphAdapters$LNodeAdapter(this, comment, false));
                        }
                    }
                }
            }
        }
    }
    return this.nodeAdapters;
};
_.getPosition = function getPosition_0() {
    throw toJs(new UnsupportedOperationException_0('Not supported by LGraph'));
};
_.getProperty = function getProperty_1(prop) {
    return $getProperty(this.element, prop);
};
_.getSize = function getSize_0() {
    return this.element.size_0;
};
_.getVolatileId = function getVolatileId_0() {
    return this.element.id_0;
};
_.hasProperty = function hasProperty_1(prop) {
    return $hasProperty(this.element, prop);
};
_.setPosition = function setPosition_0(pos) {
    throw toJs(new UnsupportedOperationException_0('Not supported by LGraph'));
};
_.setSize = function setSize_0(size_0) {
    this.element.size_0.x_0 = size_0.x_0;
    this.element.size_0.y_0 = size_0.y_0;
};
_.setVolatileId = function setVolatileId_0(volatileId) {
    this.element.id_0 = volatileId;
};
_.nodeAdapters = null;
_.transparentCommentNodes = false;
_.transparentNorthSouthEdges = false;
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$LGraphAdapter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/LGraphAdapter', 649);
function LGraphAdapters$LLabelAdapter(element) {
    this.element = element;
}
defineClass(567, 650, {
    187: 1
}, LGraphAdapters$LLabelAdapter);
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$LLabelAdapter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/LLabelAdapter', 567);
function $sortPortList(this$static, comparator) {
    $isOrderFixed(castTo($getProperty(castTo(this$static.element, 9), ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100)) && ($clinit_Collections(), $sort(castTo(this$static.element, 9).ports, comparator));
}
function LGraphAdapters$LNodeAdapter(parent_0, element, transparentNorthSouthEdges) {
    this.element = element;
    this.parentGraphAdapter = parent_0;
    this.transparentNorthSouthEdges = transparentNorthSouthEdges;
}
defineClass(566, 650, {
    680: 1
}, LGraphAdapters$LNodeAdapter);
_.getGraph = function getGraph() {
    return this.parentGraphAdapter;
};
_.getIncomingEdges = function getIncomingEdges() {
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
};
_.getLabels = function getLabels_0() {
    var l, l$iterator;
    if (!this.labelAdapters) {
        this.labelAdapters = newArrayListWithCapacity(castTo(this.element, 9).labels.array.length);
        for(l$iterator = new ArrayList$1(castTo(this.element, 9).labels); l$iterator.i < l$iterator.this$01.array.length;){
            l = castTo($next_6(l$iterator), 72);
            $add_3(this.labelAdapters, new LGraphAdapters$LLabelAdapter(l));
        }
    }
    return this.labelAdapters;
};
_.getMargin = function getMargin() {
    var lmargins;
    lmargins = castTo(this.element, 9).margin;
    return new ElkMargin_1(lmargins.top_0, lmargins.right, lmargins.bottom, lmargins.left);
};
_.getOutgoingEdges = function getOutgoingEdges() {
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
};
_.getPorts = function getPorts() {
    var p, p$iterator;
    if (!this.portAdapters) {
        this.portAdapters = newArrayListWithCapacity(castTo(this.element, 9).ports.array.length);
        for(p$iterator = new ArrayList$1(castTo(this.element, 9).ports); p$iterator.i < p$iterator.this$01.array.length;){
            p = castTo($next_6(p$iterator), 11);
            $add_3(this.portAdapters, new LGraphAdapters$LPortAdapter(p, this.transparentNorthSouthEdges));
        }
    }
    return this.portAdapters;
};
_.isCompoundNode = function isCompoundNode() {
    return $booleanValue(castToBoolean($getProperty(castTo(this.element, 9), ($clinit_InternalProperties_1(), COMPOUND_NODE))));
};
_.setMargin = function setMargin(margin) {
    castTo(this.element, 9).margin.left = margin.left;
    castTo(this.element, 9).margin.top_0 = margin.top_0;
    castTo(this.element, 9).margin.right = margin.right;
    castTo(this.element, 9).margin.bottom = margin.bottom;
};
_.setPadding = function setPadding(padding) {
    castTo(this.element, 9).padding.left = padding.left;
    castTo(this.element, 9).padding.top_0 = padding.top_0;
    castTo(this.element, 9).padding.right = padding.right;
    castTo(this.element, 9).padding.bottom = padding.bottom;
};
_.sortPortList = function sortPortList() {
    $sortPortList(this, ($clinit_LGraphAdapters(), DEFAULT_PORTLIST_SORTER));
};
_.labelAdapters = null;
_.parentGraphAdapter = null;
_.portAdapters = null;
_.transparentNorthSouthEdges = false;
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$LNodeAdapter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/LNodeAdapter', 566);
function LGraphAdapters$LPortAdapter(element, transparentNorthSouthEdges) {
    this.element = element;
    this.transparentNorthSouthEdges = transparentNorthSouthEdges;
}
defineClass(1734, 650, {
    831: 1
}, LGraphAdapters$LPortAdapter);
_.getIncomingEdges = function getIncomingEdges_0() {
    var e, e$iterator, e$iterator0, portDummy, sle, sle$iterator, slh, slp;
    if (this.transparentNorthSouthEdges && castTo(this.element, 11).owner.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT)) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    else if (!this.incomingEdgeAdapters) {
        this.incomingEdgeAdapters = new ArrayList;
        for(e$iterator0 = new ArrayList$1(castTo(this.element, 11).incomingEdges); e$iterator0.i < e$iterator0.this$01.array.length;){
            e = castTo($next_6(e$iterator0), 18);
            $add_3(this.incomingEdgeAdapters, new LGraphAdapters$LEdgeAdapter(e));
        }
        if (this.transparentNorthSouthEdges) {
            portDummy = castTo($getProperty(castTo(this.element, 11), ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
            if (portDummy) for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(portDummy).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
                e = castTo($next_0(e$iterator), 18);
                $add_3(this.incomingEdgeAdapters, new LGraphAdapters$LEdgeAdapter(e));
            }
        }
        if ($hasProperty(castTo(this.element, 11).owner, ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER))) {
            slh = castTo($getProperty(castTo(this.element, 11).owner, SELF_LOOP_HOLDER), 333);
            slp = castTo($get_16(slh.slPorts, this.element), 112);
            if (slp) for(sle$iterator = new ArrayList$1(slp.incomingSLEdges); sle$iterator.i < sle$iterator.this$01.array.length;){
                sle = castTo($next_6(sle$iterator), 336);
                $add_3(this.incomingEdgeAdapters, new LGraphAdapters$LEdgeAdapter(sle.lEdge));
            }
        }
    }
    return this.incomingEdgeAdapters;
};
_.getLabels = function getLabels_1() {
    var l, l$iterator;
    if (!this.labelAdapters) {
        this.labelAdapters = newArrayListWithCapacity(castTo(this.element, 11).labels.array.length);
        for(l$iterator = new ArrayList$1(castTo(this.element, 11).labels); l$iterator.i < l$iterator.this$01.array.length;){
            l = castTo($next_6(l$iterator), 72);
            $add_3(this.labelAdapters, new LGraphAdapters$LLabelAdapter(l));
        }
    }
    return this.labelAdapters;
};
_.getOutgoingEdges = function getOutgoingEdges_0() {
    var e, e$iterator, e$iterator0, portDummy, sle, sle$iterator, slh, slp;
    if (this.transparentNorthSouthEdges && castTo(this.element, 11).owner.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT)) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    else if (!this.outgoingEdgeAdapters) {
        this.outgoingEdgeAdapters = new ArrayList;
        for(e$iterator0 = new ArrayList$1(castTo(this.element, 11).outgoingEdges); e$iterator0.i < e$iterator0.this$01.array.length;){
            e = castTo($next_6(e$iterator0), 18);
            $add_3(this.outgoingEdgeAdapters, new LGraphAdapters$LEdgeAdapter(e));
        }
        if (this.transparentNorthSouthEdges) {
            portDummy = castTo($getProperty(castTo(this.element, 11), ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
            if (portDummy) for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(portDummy).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
                e = castTo($next_0(e$iterator), 18);
                $add_3(this.outgoingEdgeAdapters, new LGraphAdapters$LEdgeAdapter(e));
            }
        }
        if ($hasProperty(castTo(this.element, 11).owner, ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER))) {
            slh = castTo($getProperty(castTo(this.element, 11).owner, SELF_LOOP_HOLDER), 333);
            slp = castTo($get_16(slh.slPorts, this.element), 112);
            if (slp) for(sle$iterator = new ArrayList$1(slp.outgoingSLEdges); sle$iterator.i < sle$iterator.this$01.array.length;){
                sle = castTo($next_6(sle$iterator), 336);
                $add_3(this.outgoingEdgeAdapters, new LGraphAdapters$LEdgeAdapter(sle.lEdge));
            }
        }
    }
    return this.outgoingEdgeAdapters;
};
_.getSide = function getSide() {
    return castTo(this.element, 11).side;
};
_.hasCompoundConnections = function hasCompoundConnections() {
    return $booleanValue(castToBoolean($getProperty(castTo(this.element, 11), ($clinit_InternalProperties_1(), INSIDE_CONNECTIONS))));
};
_.incomingEdgeAdapters = null;
_.labelAdapters = null;
_.outgoingEdgeAdapters = null;
_.transparentNorthSouthEdges = false;
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$LPortAdapter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/LPortAdapter', 1734);
function $compare_4(port1, port2) {
    var index1, index2, indexDifference, ordinalDifference;
    ordinalDifference = port1.side.ordinal - port2.side.ordinal;
    if (ordinalDifference != 0) return ordinalDifference;
    index1 = castTo($getProperty(port1, ($clinit_LayeredOptions(), PORT_INDEX)), 17);
    index2 = castTo($getProperty(port2, PORT_INDEX), 17);
    if (!!index1 && !!index2) {
        indexDifference = index1.value_0 - index2.value_0;
        if (indexDifference != 0) return indexDifference;
    }
    switch(port1.side.ordinal){
        case 1:
            return compare_4(port1.pos.x_0, port2.pos.x_0);
        case 2:
            return compare_4(port1.pos.y_0, port2.pos.y_0);
        case 3:
            return compare_4(port2.pos.x_0, port1.pos.x_0);
        case 4:
            return compare_4(port2.pos.y_0, port1.pos.y_0);
        default:
            throw toJs(new IllegalStateException_0('Port side is undefined'));
    }
}
function LGraphAdapters$PortComparator() {}
defineClass(1735, 1, $intern_88, LGraphAdapters$PortComparator);
_.compare_1 = function compare_35(port1, port2) {
    return $compare_4(castTo(port1, 11), castTo(port2, 11));
};
_.equals_0 = function equals_92(other) {
    return this === other;
};
_.reversed = function reversed_27() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$PortComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/PortComparator', 1735);
function LGraphAdapters$lambda$0$Type() {}
defineClass(798, 1, $intern_39, LGraphAdapters$lambda$0$Type);
_.test_0 = function test_10(arg0) {
    return castTo(arg0, 9), $clinit_LGraphAdapters(), true;
};
var Lorg_eclipse_elk_alg_layered_graph_LGraphAdapters$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LGraphAdapters/lambda$0$Type', 798);
function calcPortOffset(port, side) {
    var node;
    node = port.owner;
    switch(side.ordinal){
        case 1:
            return -(port.pos.y_0 + port.size_0.y_0);
        case 2:
            return port.pos.x_0 - node.size_0.x_0;
        case 3:
            return port.pos.y_0 - node.size_0.y_0;
        case 4:
            return -(port.pos.x_0 + port.size_0.x_0);
    }
    return 0;
}
function calcPortSide(port, direction) {
    var height, heightPercent, node, nodeHeight, nodeWidth, width_0, widthPercent, xpos, ypos;
    node = port.owner;
    nodeWidth = node.size_0.x_0;
    nodeHeight = node.size_0.y_0;
    if (nodeWidth <= 0 && nodeHeight <= 0) return $clinit_PortSide(), UNDEFINED_5;
    xpos = port.pos.x_0;
    ypos = port.pos.y_0;
    width_0 = port.size_0.x_0;
    height = port.size_0.y_0;
    switch(direction.ordinal){
        case 2:
        case 1:
            if (xpos < 0) return $clinit_PortSide(), WEST_0;
            else if (xpos + width_0 > nodeWidth) return $clinit_PortSide(), EAST_0;
            break;
        case 4:
        case 3:
            if (ypos < 0) return $clinit_PortSide(), NORTH_1;
            else if (ypos + height > nodeHeight) return $clinit_PortSide(), SOUTH_0;
    }
    widthPercent = (xpos + width_0 / 2) / nodeWidth;
    heightPercent = (ypos + height / 2) / nodeHeight;
    return widthPercent + heightPercent <= 1 && widthPercent - heightPercent <= 0 ? ($clinit_PortSide(), WEST_0) : widthPercent + heightPercent >= 1 && widthPercent - heightPercent >= 0 ? ($clinit_PortSide(), EAST_0) : heightPercent < 0.5 ? ($clinit_PortSide(), NORTH_1) : ($clinit_PortSide(), SOUTH_0);
}
function centerPoint(point, boundary, side) {
    switch(side.ordinal){
        case 1:
            point.x_0 = boundary.x_0 / 2;
            point.y_0 = 0;
            break;
        case 2:
            point.x_0 = boundary.x_0;
            point.y_0 = boundary.y_0 / 2;
            break;
        case 3:
            point.x_0 = boundary.x_0 / 2;
            point.y_0 = boundary.y_0;
            break;
        case 4:
            point.x_0 = 0;
            point.y_0 = boundary.y_0 / 2;
    }
}
function changeCoordSystem(point, oldGraph, newGraph) {
    var graph, node, padding;
    if (oldGraph == newGraph) return;
    graph = oldGraph;
    do {
        $add_19(point, graph.offset);
        node = graph.parentNode;
        if (node) {
            padding = graph.padding;
            $add_18(point, padding.left, padding.top_0);
            $add_19(point, node.pos);
            graph = $getGraph(node);
        }
    }while (node);
    graph = newGraph;
    do {
        $sub_0(point, graph.offset);
        node = graph.parentNode;
        if (node) {
            padding = graph.padding;
            $sub(point, padding.left, padding.top_0);
            $sub_0(point, node.pos);
            graph = $getGraph(node);
        }
    }while (node);
}
function createExternalPortDummy(propertyHolder, portConstraints, portSide, netFlow, portNodeSize, portPosition, portSize, layoutDirection, layeredGraph) {
    var anchor, dummy, dummyPort, explicitAnchor, finalExternalPortSide, informationAboutIt, portBorderOffset;
    finalExternalPortSide = portSide;
    dummy = new LNode(layeredGraph);
    $setType(dummy, ($clinit_LNode$NodeType(), EXTERNAL_PORT));
    $setProperty_0(dummy, ($clinit_InternalProperties_1(), EXT_PORT_SIZE), portSize);
    $setProperty_0(dummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    portBorderOffset = $doubleValue(castToDouble(propertyHolder.getProperty(PORT_BORDER_OFFSET)));
    $setProperty_0(dummy, PORT_BORDER_OFFSET, portBorderOffset);
    dummyPort = new LPort;
    $setNode(dummyPort, dummy);
    if (!(portConstraints != FREE && portConstraints != UNDEFINED_4)) {
        netFlow >= 0 ? finalExternalPortSide = fromDirection(layoutDirection) : finalExternalPortSide = $opposed(fromDirection(layoutDirection));
        propertyHolder.setProperty(PORT_SIDE, finalExternalPortSide);
    }
    anchor = new KVector;
    explicitAnchor = false;
    if (propertyHolder.hasProperty(PORT_ANCHOR)) {
        $set_7(anchor, castTo(propertyHolder.getProperty(PORT_ANCHOR), 8));
        explicitAnchor = true;
    } else $set_6(anchor, portSize.x_0 / 2, portSize.y_0 / 2);
    switch(finalExternalPortSide.ordinal){
        case 4:
            $setProperty_0(dummy, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), FIRST_SEPARATE_0));
            $setProperty_0(dummy, EDGE_CONSTRAINT, ($clinit_EdgeConstraint(), OUTGOING_ONLY));
            dummy.size_0.y_0 = portSize.y_0;
            portBorderOffset < 0 && (dummy.size_0.x_0 = -portBorderOffset);
            $setSide(dummyPort, ($clinit_PortSide(), EAST_0));
            explicitAnchor || (anchor.x_0 = portSize.x_0);
            anchor.x_0 -= portSize.x_0;
            break;
        case 2:
            $setProperty_0(dummy, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), LAST_SEPARATE_0));
            $setProperty_0(dummy, EDGE_CONSTRAINT, ($clinit_EdgeConstraint(), INCOMING_ONLY));
            dummy.size_0.y_0 = portSize.y_0;
            portBorderOffset < 0 && (dummy.size_0.x_0 = -portBorderOffset);
            $setSide(dummyPort, ($clinit_PortSide(), WEST_0));
            explicitAnchor || (anchor.x_0 = 0);
            break;
        case 1:
            $setProperty_0(dummy, IN_LAYER_CONSTRAINT, ($clinit_InLayerConstraint(), TOP_1));
            dummy.size_0.x_0 = portSize.x_0;
            portBorderOffset < 0 && (dummy.size_0.y_0 = -portBorderOffset);
            $setSide(dummyPort, ($clinit_PortSide(), SOUTH_0));
            explicitAnchor || (anchor.y_0 = portSize.y_0);
            anchor.y_0 -= portSize.y_0;
            break;
        case 3:
            $setProperty_0(dummy, IN_LAYER_CONSTRAINT, ($clinit_InLayerConstraint(), BOTTOM_0));
            dummy.size_0.x_0 = portSize.x_0;
            portBorderOffset < 0 && (dummy.size_0.y_0 = -portBorderOffset);
            $setSide(dummyPort, ($clinit_PortSide(), NORTH_1));
            explicitAnchor || (anchor.y_0 = 0);
    }
    $set_7(dummyPort.pos, anchor);
    $setProperty_0(dummy, PORT_ANCHOR, anchor);
    if (portConstraints == FIXED_ORDER || portConstraints == FIXED_RATIO || portConstraints == FIXED_POS) {
        informationAboutIt = 0;
        if (portConstraints == FIXED_ORDER && propertyHolder.hasProperty(PORT_INDEX)) switch(finalExternalPortSide.ordinal){
            case 1:
            case 2:
                informationAboutIt = castTo(propertyHolder.getProperty(PORT_INDEX), 17).value_0;
                break;
            case 3:
            case 4:
                informationAboutIt = -castTo(propertyHolder.getProperty(PORT_INDEX), 17).value_0;
        }
        else switch(finalExternalPortSide.ordinal){
            case 4:
            case 2:
                informationAboutIt = portPosition.y_0;
                portConstraints == FIXED_RATIO && (informationAboutIt /= portNodeSize.y_0);
                break;
            case 1:
            case 3:
                informationAboutIt = portPosition.x_0;
                portConstraints == FIXED_RATIO && (informationAboutIt /= portNodeSize.x_0);
        }
        $setProperty_0(dummy, PORT_RATIO_OR_POSITION_0, informationAboutIt);
    }
    $setProperty_0(dummy, EXT_PORT_SIDE, finalExternalPortSide);
    return dummy;
}
function createPort(node, endPoint, type_0, layeredGraph) {
    var defaultSide, direction, graphProperties, mergePorts, port, portSide, pos;
    direction = getDirection_1(layeredGraph);
    mergePorts = $booleanValue(castToBoolean($getProperty(layeredGraph, ($clinit_LayeredOptions(), MERGE_EDGES_0))));
    if ((mergePorts || $booleanValue(castToBoolean($getProperty(node, HYPERNODE)))) && !$isSideFixed(castTo($getProperty(node, PORT_CONSTRAINTS_0), 100))) {
        defaultSide = fromDirection(direction);
        port = provideCollectorPort(node, type_0, type_0 == ($clinit_PortType(), OUTPUT) ? defaultSide : $opposed(defaultSide));
    } else {
        port = new LPort;
        $setNode(port, node);
        if (endPoint) {
            pos = port.pos;
            pos.x_0 = endPoint.x_0 - node.pos.x_0;
            pos.y_0 = endPoint.y_0 - node.pos.y_0;
            $bound(pos, 0, 0, node.size_0.x_0, node.size_0.y_0);
            $setSide(port, calcPortSide(port, direction));
        } else {
            defaultSide = fromDirection(direction);
            $setSide(port, type_0 == ($clinit_PortType(), OUTPUT) ? defaultSide : $opposed(defaultSide));
        }
        graphProperties = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
        portSide = port.side;
        switch(direction.ordinal){
            case 2:
            case 1:
                (portSide == ($clinit_PortSide(), NORTH_1) || portSide == SOUTH_0) && graphProperties.add_2(($clinit_GraphProperties(), NORTH_SOUTH_PORTS));
                break;
            case 4:
            case 3:
                (portSide == ($clinit_PortSide(), EAST_0) || portSide == WEST_0) && graphProperties.add_2(($clinit_GraphProperties(), NORTH_SOUTH_PORTS));
        }
    }
    return port;
}
function findMaxNonDummyNodeWidth(layer) {
    var maxWidth, node, node$iterator, width_0;
    if ($isVertical(castTo($getProperty(layer.owner, ($clinit_LayeredOptions(), DIRECTION)), 86))) return 0;
    maxWidth = 0;
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 == ($clinit_LNode$NodeType(), NORMAL)) {
            width_0 = node.size_0.x_0;
            maxWidth = $wnd.Math.max(maxWidth, width_0);
        }
    }
    return maxWidth;
}
function getDirection_1(graph) {
    var aspectRatio, direction;
    direction = castTo($getProperty(graph, ($clinit_LayeredOptions(), DIRECTION)), 86);
    if (direction == ($clinit_Direction(), UNDEFINED_2)) {
        aspectRatio = $doubleValue(castToDouble($getProperty(graph, ASPECT_RATIO_0)));
        return aspectRatio >= 1 ? RIGHT_6 : DOWN_1;
    }
    return direction;
}
function getExternalPortPosition(graph, portDummy, portWidth, portHeight) {
    var graphOffset, graphSize, padding, portOffset, portPosition;
    portPosition = new KVector_2(portDummy.pos);
    portPosition.x_0 += portDummy.size_0.x_0 / 2;
    portPosition.y_0 += portDummy.size_0.y_0 / 2;
    portOffset = $doubleValue(castToDouble($getProperty(portDummy, ($clinit_LayeredOptions(), PORT_BORDER_OFFSET))));
    graphSize = graph.size_0;
    padding = graph.padding;
    graphOffset = graph.offset;
    switch(castTo($getProperty(portDummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64).ordinal){
        case 1:
            portPosition.x_0 += padding.left + graphOffset.x_0 - portWidth / 2;
            portPosition.y_0 = -portHeight - portOffset;
            portDummy.pos.y_0 = -(padding.top_0 + portOffset + graphOffset.y_0);
            break;
        case 2:
            portPosition.x_0 = graphSize.x_0 + padding.left + padding.right + portOffset;
            portPosition.y_0 += padding.top_0 + graphOffset.y_0 - portHeight / 2;
            portDummy.pos.x_0 = graphSize.x_0 + padding.right + portOffset - graphOffset.x_0;
            break;
        case 3:
            portPosition.x_0 += padding.left + graphOffset.x_0 - portWidth / 2;
            portPosition.y_0 = graphSize.y_0 + padding.top_0 + padding.bottom + portOffset;
            portDummy.pos.y_0 = graphSize.y_0 + padding.bottom + portOffset - graphOffset.y_0;
            break;
        case 4:
            portPosition.x_0 = -portWidth - portOffset;
            portPosition.y_0 += padding.top_0 + graphOffset.y_0 - portHeight / 2;
            portDummy.pos.x_0 = -(padding.left + portOffset + graphOffset.x_0);
    }
    return portPosition;
}
function getIndividualOrInherited(node, property) {
    var individualSpacings, result;
    result = null;
    if ($hasProperty(node, ($clinit_CoreOptions(), SPACING_INDIVIDUAL_0))) {
        individualSpacings = castTo($getProperty(node, SPACING_INDIVIDUAL_0), 102);
        individualSpacings.hasProperty(property) && (result = individualSpacings.getProperty(property));
    }
    result == null && !!$getGraph(node) && (result = $getProperty($getGraph(node), property));
    return result;
}
function getMinimalModelOrder(graph) {
    var node, node$iterator, order;
    order = $intern_0;
    for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $hasProperty(node, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && (order = $wnd.Math.min(order, castTo($getProperty(node, MODEL_ORDER_1), 17).value_0));
    }
    return order;
}
function initializePort(port, portConstraints, direction, anchorPos) {
    var nodeHeight, nodeWidth, portAnchor, portSide, portSize, ratio;
    portSide = port.side;
    if (portSide == ($clinit_PortSide(), UNDEFINED_5) && portConstraints != ($clinit_PortConstraints(), FREE) && portConstraints != ($clinit_PortConstraints(), UNDEFINED_4)) {
        portSide = calcPortSide(port, direction);
        $setSide(port, portSide);
        !(!port.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : port.propertyMap).containsKey(($clinit_LayeredOptions(), PORT_BORDER_OFFSET)) && portSide != UNDEFINED_5 && (port.pos.x_0 != 0 || port.pos.y_0 != 0) && $setProperty_0(port, PORT_BORDER_OFFSET, calcPortOffset(port, portSide));
    }
    if (portConstraints == ($clinit_PortConstraints(), FIXED_RATIO)) {
        ratio = 0;
        switch(portSide.ordinal){
            case 1:
            case 3:
                nodeWidth = port.owner.size_0.x_0;
                nodeWidth > 0 && (ratio = port.pos.x_0 / nodeWidth);
                break;
            case 2:
            case 4:
                nodeHeight = port.owner.size_0.y_0;
                nodeHeight > 0 && (ratio = port.pos.y_0 / nodeHeight);
        }
        $setProperty_0(port, ($clinit_InternalProperties_1(), PORT_RATIO_OR_POSITION_0), ratio);
    }
    portSize = port.size_0;
    portAnchor = port.anchor;
    if (anchorPos) {
        portAnchor.x_0 = anchorPos.x_0;
        portAnchor.y_0 = anchorPos.y_0;
        port.explicitlySuppliedPortAnchor = true;
    } else if (portConstraints != FREE && portConstraints != UNDEFINED_4 && portSide != UNDEFINED_5) switch(portSide.ordinal){
        case 1:
            portAnchor.x_0 = portSize.x_0 / 2;
            break;
        case 2:
            portAnchor.x_0 = portSize.x_0;
            portAnchor.y_0 = portSize.y_0 / 2;
            break;
        case 3:
            portAnchor.x_0 = portSize.x_0 / 2;
            portAnchor.y_0 = portSize.y_0;
            break;
        case 4:
            portAnchor.y_0 = portSize.y_0 / 2;
    }
    else {
        portAnchor.x_0 = portSize.x_0 / 2;
        portAnchor.y_0 = portSize.y_0 / 2;
    }
}
function isDescendant(child, parent_0) {
    var current, next;
    current = child;
    next = $getGraph(current).parentNode;
    while(next){
        current = next;
        if (current == parent_0) return true;
        next = $getGraph(current).parentNode;
    }
    return false;
}
function offsetGraph(graph, offsetx, offsety) {
    var edge, edge$iterator, graphOffset, junctionPoints, label_0, label$iterator, node, node$iterator, port, port$iterator;
    graphOffset = new KVector_1(offsetx, offsety);
    for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $add_19(node.pos, graphOffset);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                $offset_2(edge.bendPoints, graphOffset);
                junctionPoints = castTo($getProperty(edge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
                !!junctionPoints && $offset_2(junctionPoints, graphOffset);
                for(label$iterator = new ArrayList$1(edge.labels); label$iterator.i < label$iterator.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator), 72);
                    $add_19(label_0.pos, graphOffset);
                }
            }
        }
    }
}
function placeNodesHorizontally(layer, xoffset) {
    var alignment, inports, leftMargin, maxLeftMargin, maxRightMargin, node, node$iterator, node$iterator0, nodeSize, outports, port, port$iterator, ratio, rightMargin, size_0, xpos;
    maxLeftMargin = 0;
    maxRightMargin = 0;
    for(node$iterator0 = new ArrayList$1(layer.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        maxLeftMargin = $wnd.Math.max(maxLeftMargin, node.margin.left);
        maxRightMargin = $wnd.Math.max(maxRightMargin, node.margin.right);
    }
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        alignment = castTo($getProperty(node, ($clinit_LayeredOptions(), ALIGNMENT)), 254);
        switch(alignment.ordinal){
            case 1:
                ratio = 0;
                break;
            case 2:
                ratio = 1;
                break;
            case 5:
                ratio = 0.5;
                break;
            default:
                inports = 0;
                outports = 0;
                for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                    port = castTo($next_6(port$iterator), 11);
                    port.incomingEdges.array.length == 0 || ++inports;
                    port.outgoingEdges.array.length == 0 || ++outports;
                }
                inports + outports == 0 ? ratio = 0.5 : ratio = outports / (inports + outports);
        }
        size_0 = layer.size_0;
        nodeSize = node.size_0.x_0;
        xpos = (size_0.x_0 - nodeSize) * ratio;
        ratio > 0.5 ? xpos -= maxRightMargin * 2 * (ratio - 0.5) : ratio < 0.5 && (xpos += maxLeftMargin * 2 * (0.5 - ratio));
        leftMargin = node.margin.left;
        xpos < leftMargin && (xpos = leftMargin);
        rightMargin = node.margin.right;
        xpos > size_0.x_0 - rightMargin - nodeSize && (xpos = size_0.x_0 - rightMargin - nodeSize);
        node.pos.x_0 = xoffset + xpos;
    }
}
function provideCollectorPort(node, type_0, side) {
    var inport, inport$iterator, outport, outport$iterator, port;
    port = null;
    switch(type_0.ordinal){
        case 1:
            for(inport$iterator = new ArrayList$1(node.ports); inport$iterator.i < inport$iterator.this$01.array.length;){
                inport = castTo($next_6(inport$iterator), 11);
                if ($booleanValue(castToBoolean($getProperty(inport, ($clinit_InternalProperties_1(), INPUT_COLLECT))))) return inport;
            }
            port = new LPort;
            $setProperty_0(port, ($clinit_InternalProperties_1(), INPUT_COLLECT), ($clinit_Boolean(), true));
            break;
        case 2:
            for(outport$iterator = new ArrayList$1(node.ports); outport$iterator.i < outport$iterator.this$01.array.length;){
                outport = castTo($next_6(outport$iterator), 11);
                if ($booleanValue(castToBoolean($getProperty(outport, ($clinit_InternalProperties_1(), OUTPUT_COLLECT))))) return outport;
            }
            port = new LPort;
            $setProperty_0(port, ($clinit_InternalProperties_1(), OUTPUT_COLLECT), ($clinit_Boolean(), true));
    }
    if (port) {
        $setNode(port, node);
        $setSide(port, side);
        centerPoint(port.pos, node.size_0, side);
    }
    return port;
}
function resizeNode(node, newSize, movePorts) {
    var all, fixedPorts, heightDiff, heightPercent, heightRatio, label_0, label$iterator, midx, midy, oldSize, port, port$iterator, widthDiff, widthPercent, widthRatio;
    oldSize = new KVector_2(node.size_0);
    widthRatio = newSize.x_0 / oldSize.x_0;
    heightRatio = newSize.y_0 / oldSize.y_0;
    widthDiff = newSize.x_0 - oldSize.x_0;
    heightDiff = newSize.y_0 - oldSize.y_0;
    if (movePorts) {
        fixedPorts = maskUndefined($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0))) === maskUndefined(($clinit_PortConstraints(), FIXED_POS));
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            switch(port.side.ordinal){
                case 1:
                    fixedPorts || (port.pos.x_0 *= widthRatio);
                    break;
                case 2:
                    port.pos.x_0 += widthDiff;
                    fixedPorts || (port.pos.y_0 *= heightRatio);
                    break;
                case 3:
                    fixedPorts || (port.pos.x_0 *= widthRatio);
                    port.pos.y_0 += heightDiff;
                    break;
                case 4:
                    fixedPorts || (port.pos.y_0 *= heightRatio);
            }
        }
    }
    for(label$iterator = new ArrayList$1(node.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 72);
        midx = label_0.pos.x_0 + label_0.size_0.x_0 / 2;
        midy = label_0.pos.y_0 + label_0.size_0.y_0 / 2;
        widthPercent = midx / oldSize.x_0;
        heightPercent = midy / oldSize.y_0;
        if (widthPercent + heightPercent >= 1) {
            if (widthPercent - heightPercent > 0 && midy >= 0) {
                label_0.pos.x_0 += widthDiff;
                label_0.pos.y_0 += heightDiff * heightPercent;
            } else if (widthPercent - heightPercent < 0 && midx >= 0) {
                label_0.pos.x_0 += widthDiff * widthPercent;
                label_0.pos.y_0 += heightDiff;
            }
        }
    }
    node.size_0.x_0 = newSize.x_0;
    node.size_0.y_0 = newSize.y_0;
    $setProperty_0(node, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1), ($clinit_SizeConstraint(), all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)));
}
function toEdgeArray(edges) {
    return castTo($toArray_1(edges, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LEdge_2_classLit, $intern_103, 18, edges.array.length, 0, 1)), 469);
}
function toNodeArray(nodes) {
    return castTo($toArray_1(nodes, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, nodes.array.length, 0, 1)), 199);
}
function toPortArray(ports) {
    return castTo($toArray_1(ports, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LPort_2_classLit, $intern_105, 11, ports.array.length, 0, 1)), 1988);
}
function LShape() {
    this.pos = new KVector;
    this.size_0 = new KVector;
}
defineClass(395, 306, {
    3: 1,
    306: 1,
    395: 1,
    102: 1,
    148: 1
});
var Lorg_eclipse_elk_alg_layered_graph_LShape_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LShape', 395);
function $getDesignation_1(this$static) {
    if (this$static.text_0) return this$static.text_0;
    return $getDesignation(this$static);
}
function LLabel() {
    LLabel_0.call(this, '');
}
function LLabel_0(thetext) {
    LShape.call(this);
    this.text_0 = thetext;
}
defineClass(72, 395, {
    3: 1,
    306: 1,
    72: 1,
    395: 1,
    102: 1,
    148: 1
}, LLabel, LLabel_0);
_.toString_0 = function toString_87() {
    var designation;
    designation = $getDesignation_1(this);
    return designation == null ? 'label' : 'l_' + designation;
};
var Lorg_eclipse_elk_alg_layered_graph_LLabel_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LLabel', 72);
function $$init_6(this$static) {}
function $add_15(this$static, other) {
    this$static.left += other.left;
    this$static.right += other.right;
    this$static.top_0 += other.top_0;
    this$static.bottom += other.bottom;
    return this$static;
}
function $copy(this$static, other) {
    this$static.left = other.left;
    this$static.right = other.right;
    this$static.top_0 = other.top_0;
    this$static.bottom = other.bottom;
    return this$static;
}
function $set_5(this$static, newTop, newRight, newBottom, newLeft) {
    this$static.top_0 = newTop;
    this$static.right = newRight;
    this$static.bottom = newBottom;
    this$static.left = newLeft;
}
function $setBottom(this$static, bottom) {
    this$static.bottom = bottom;
}
function $setLeft(this$static, left) {
    this$static.left = left;
}
function $setRight(this$static, right) {
    this$static.right = right;
}
function $setTop(this$static, top_0) {
    this$static.top_0 = top_0;
}
function Spacing() {
    $$init_6(this);
}
function Spacing_0(top_0, right, bottom, left) {
    $$init_6(this);
    $set_5(this, top_0, right, bottom, left);
}
function isdelim(c, delims) {
    var i;
    for(i = 0; i < delims.length; i++){
        if (c == (checkCriticalStringElementIndex(i, delims.length), delims.charCodeAt(i))) return true;
    }
    return false;
}
defineClass(213, 1, {
    3: 1,
    4: 1,
    213: 1,
    411: 1
});
_.equals_0 = function equals_93(obj) {
    var other;
    if (instanceOf(obj, 213)) {
        other = castTo(obj, 213);
        return this.top_0 == other.top_0 && this.bottom == other.bottom && this.left == other.left && this.right == other.right;
    } else return false;
};
_.hashCode_1 = function hashCode_62() {
    var code1, code2;
    code1 = $hashCode_1(this.left) << 16;
    code1 |= $hashCode_1(this.bottom) & $intern_46;
    code2 = $hashCode_1(this.right) << 16;
    code2 |= $hashCode_1(this.top_0) & $intern_46;
    return code1 ^ code2;
};
_.parse_0 = function parse_0(string) {
    var end, exception, key, keyandvalue, start_0, token, token$array, token$index, token$max, tokens, value_0;
    start_0 = 0;
    while(start_0 < string.length && isdelim((checkCriticalStringElementIndex(start_0, string.length), string.charCodeAt(start_0)), '([{"\' \t\r\n'))++start_0;
    end = string.length;
    while(end > 0 && isdelim((checkCriticalStringElementIndex(end - 1, string.length), string.charCodeAt(end - 1)), ')]}"\' \t\r\n'))--end;
    if (start_0 < end) {
        tokens = $split_0((checkCriticalStringBounds(start_0, end, string.length), string.substr(start_0, end - start_0)), ',|;');
        try {
            for(token$array = tokens, token$index = 0, token$max = token$array.length; token$index < token$max; ++token$index){
                token = token$array[token$index];
                keyandvalue = $split_0(token, '=');
                if (keyandvalue.length != 2) throw toJs(new IllegalArgumentException_0('Expecting a list of key-value pairs.'));
                key = $trim(keyandvalue[0]);
                value_0 = __parseAndValidateDouble($trim(keyandvalue[1]));
                $equals_5(key, 'top') ? this.top_0 = value_0 : $equals_5(key, 'left') ? this.left = value_0 : $equals_5(key, 'bottom') ? this.bottom = value_0 : $equals_5(key, 'right') && (this.right = value_0);
            }
        } catch ($e0) {
            $e0 = toJava($e0);
            if (instanceOf($e0, 130)) {
                exception = $e0;
                throw toJs(new IllegalArgumentException_0('The given string contains parts that cannot be parsed as numbers.' + exception));
            } else throw toJs($e0);
        }
    }
};
_.toString_0 = function toString_88() {
    return '[top=' + this.top_0 + ',left=' + this.left + ',bottom=' + this.bottom + ',right=' + this.right + ']';
};
_.bottom = 0;
_.left = 0;
_.right = 0;
_.top_0 = 0;
var Lorg_eclipse_elk_core_math_Spacing_2_classLit = createForClass('org.eclipse.elk.core.math', 'Spacing', 213);
function ElkMargin() {
    Spacing.call(this);
}
function ElkMargin_0() {
    Spacing_0.call(this, 0, 0, 0, 0);
}
function ElkMargin_1(top_0, right, bottom, left) {
    Spacing_0.call(this, top_0, right, bottom, left);
}
function ElkMargin_2(other) {
    Spacing_0.call(this, other.top_0, other.right, other.bottom, other.left);
}
defineClass(139, 213, $intern_106, ElkMargin, ElkMargin_0, ElkMargin_1, ElkMargin_2);
var Lorg_eclipse_elk_core_math_ElkMargin_2_classLit = createForClass('org.eclipse.elk.core.math', 'ElkMargin', 139);
function LMargin() {
    ElkMargin.call(this);
}
defineClass(644, 139, $intern_106, LMargin);
var Lorg_eclipse_elk_alg_layered_graph_LMargin_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LMargin', 644);
function $borderToContentAreaCoordinates(this$static, horizontal, vertical) {
    var graphPadding, offset, pos, thegraph;
    thegraph = $getGraph(this$static);
    graphPadding = thegraph.padding;
    offset = thegraph.offset;
    pos = this$static.pos;
    horizontal && (pos.x_0 = pos.x_0 - graphPadding.left - offset.x_0);
    vertical && (pos.y_0 = pos.y_0 - graphPadding.top_0 - offset.y_0);
}
function $findPortIndices(this$static) {
    var currentIndex, currentSide, firstIndexForCurrentSide, port;
    this$static.portSideIndices = new EnumMap(castTo(checkNotNull(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 295));
    firstIndexForCurrentSide = 0;
    currentSide = ($clinit_PortSide(), NORTH_1);
    currentIndex = 0;
    for(; currentIndex < this$static.ports.array.length; currentIndex++){
        port = castTo($get_11(this$static.ports, currentIndex), 11);
        if (port.side != currentSide) {
            firstIndexForCurrentSide != currentIndex && $put_7(this$static.portSideIndices, currentSide, new Pair(valueOf_3(firstIndexForCurrentSide), valueOf_3(currentIndex)));
            currentSide = port.side;
            firstIndexForCurrentSide = currentIndex;
        }
    }
    $put_7(this$static.portSideIndices, currentSide, new Pair(valueOf_3(firstIndexForCurrentSide), valueOf_3(currentIndex)));
}
function $getConnectedEdges_0(this$static) {
    var iterables, port, port$iterator;
    iterables = new ArrayList;
    for(port$iterator = new ArrayList$1(this$static.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $add_3(iterables, port.connectedEdges);
    }
    return checkNotNull(iterables), new FluentIterable$2(iterables);
}
function $getDesignation_2(this$static) {
    var id_0;
    if (this$static.labels.array.length != 0 && !!castTo($get_11(this$static.labels, 0), 72).text_0) return castTo($get_11(this$static.labels, 0), 72).text_0;
    id_0 = $getDesignation(this$static);
    if (id_0 != null) return id_0;
    return '' + (!this$static.layer ? -1 : $indexOf_3(this$static.layer.nodes, this$static, 0));
}
function $getGraph(this$static) {
    if (!this$static.graph_0 && !!this$static.layer) return this$static.layer.owner;
    return this$static.graph_0;
}
function $getIncomingEdges(this$static) {
    var iterables, port, port$iterator;
    iterables = new ArrayList;
    for(port$iterator = new ArrayList$1(this$static.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $add_3(iterables, port.incomingEdges);
    }
    return checkNotNull(iterables), new FluentIterable$2(iterables);
}
function $getIndex(this$static) {
    return !this$static.layer ? -1 : $indexOf_3(this$static.layer.nodes, this$static, 0);
}
function $getInteractiveReferencePoint(this$static) {
    var nodePos, nodeSize;
    switch(castTo($getProperty($getGraph(this$static), ($clinit_LayeredOptions(), INTERACTIVE_REFERENCE_POINT_0)), 417).ordinal){
        case 0:
            nodePos = this$static.pos;
            nodeSize = this$static.size_0;
            return new KVector_1(nodePos.x_0 + nodeSize.x_0 / 2, nodePos.y_0 + nodeSize.y_0 / 2);
        case 1:
            return new KVector_2(this$static.pos);
        default:
            return null;
    }
}
function $getOutgoingEdges(this$static) {
    var iterables, port, port$iterator;
    iterables = new ArrayList;
    for(port$iterator = new ArrayList$1(this$static.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $add_3(iterables, port.outgoingEdges);
    }
    return checkNotNull(iterables), new FluentIterable$2(iterables);
}
function $getPortSideView(this$static, side) {
    var indices;
    this$static.portSidesCached || $findPortIndices(this$static);
    indices = castTo($get_14(this$static.portSideIndices, side), 47);
    return !indices ? ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST) : new AbstractList$SubList(this$static.ports, castTo(indices.first, 17).value_0, castTo(indices.second, 17).value_0);
}
function $getPorts(this$static, portType) {
    switch(portType.ordinal){
        case 1:
            return filter_0(this$static.ports, ($clinit_LPort(), INPUT_PREDICATE));
        case 2:
            return filter_0(this$static.ports, ($clinit_LPort(), OUTPUT_PREDICATE));
        default:
            return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    }
}
function $getPorts_0(this$static, portType, side) {
    var sidePredicate, typePredicate;
    typePredicate = null;
    switch(portType.ordinal){
        case 1:
            typePredicate = ($clinit_LPort(), INPUT_PREDICATE);
            break;
        case 2:
            typePredicate = ($clinit_LPort(), OUTPUT_PREDICATE);
    }
    sidePredicate = null;
    switch(side.ordinal){
        case 1:
            sidePredicate = ($clinit_LPort(), NORTH_PREDICATE);
            break;
        case 2:
            sidePredicate = ($clinit_LPort(), EAST_PREDICATE);
            break;
        case 3:
            sidePredicate = ($clinit_LPort(), SOUTH_PREDICATE);
            break;
        case 4:
            sidePredicate = ($clinit_LPort(), WEST_PREDICATE);
    }
    return !!typePredicate && !!sidePredicate ? filter_0(this$static.ports, new Predicates$AndPredicate(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lcom_google_common_base_Predicate_2_classLit, 1), $intern_2, 177, 0, [
        castTo(checkNotNull(typePredicate), 177),
        castTo(checkNotNull(sidePredicate), 177)
    ])))) : ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST);
}
function $getPorts_1(this$static, side) {
    switch(side.ordinal){
        case 1:
            return filter_0(this$static.ports, ($clinit_LPort(), NORTH_PREDICATE));
        case 2:
            return filter_0(this$static.ports, ($clinit_LPort(), EAST_PREDICATE));
        case 3:
            return filter_0(this$static.ports, ($clinit_LPort(), SOUTH_PREDICATE));
        case 4:
            return filter_0(this$static.ports, ($clinit_LPort(), WEST_PREDICATE));
        default:
            return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    }
}
function $setLayer(this$static, index_0, newlayer) {
    if (!!newlayer && (index_0 < 0 || index_0 > newlayer.nodes.array.length)) throw toJs(new IllegalArgumentException_0('index must be >= 0 and <= layer node count'));
    !!this$static.layer && $remove_12(this$static.layer.nodes, this$static);
    this$static.layer = newlayer;
    !!newlayer && $add_2(newlayer.nodes, index_0, this$static);
}
function $setLayer_0(this$static, thelayer) {
    !!this$static.layer && $remove_12(this$static.layer.nodes, this$static);
    this$static.layer = thelayer;
    !!this$static.layer && $add_3(this$static.layer.nodes, this$static);
}
function $setType(this$static, type_0) {
    this$static.type_0 = type_0;
}
function $toString_13(this$static) {
    var result;
    result = new StringBuilder;
    result.string += 'n';
    this$static.type_0 != ($clinit_LNode$NodeType(), NORMAL) && $append_11($append_11((result.string += '(', result), $toString_3(this$static.type_0).toLowerCase()), ')');
    $append_11((result.string += '_', result), $getDesignation_2(this$static));
    return result.string;
}
function LNode(graph) {
    LShape.call(this);
    this.type_0 = ($clinit_LNode$NodeType(), NORMAL);
    this.ports = (checkNonnegative(6, 'initialArraySize'), new ArrayList_0(6));
    this.labels = (checkNonnegative(2, 'initialArraySize'), new ArrayList_0(2));
    this.margin = new LMargin;
    this.padding = new LPadding;
    this.graph_0 = graph;
}
defineClass(9, 395, {
    3: 1,
    306: 1,
    9: 1,
    395: 1,
    102: 1,
    148: 1
}, LNode);
_.toString_0 = function toString_89() {
    return $toString_13(this);
};
_.portSidesCached = false;
var Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LNode', 9);
function $clinit_LNode$NodeType() {
    $clinit_LNode$NodeType = emptyMethod;
    NORMAL = new LNode$NodeType('NORMAL', 0);
    LONG_EDGE = new LNode$NodeType('LONG_EDGE', 1);
    EXTERNAL_PORT = new LNode$NodeType('EXTERNAL_PORT', 2);
    NORTH_SOUTH_PORT = new LNode$NodeType('NORTH_SOUTH_PORT', 3);
    LABEL = new LNode$NodeType('LABEL', 4);
    BREAKING_POINT = new LNode$NodeType('BREAKING_POINT', 5);
    PLACEHOLDER = new LNode$NodeType('PLACEHOLDER', 6);
    NONSHIFTING_PLACEHOLDER = new LNode$NodeType('NONSHIFTING_PLACEHOLDER', 7);
}
function LNode$NodeType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_22(name_0) {
    $clinit_LNode$NodeType();
    return valueOf(($clinit_LNode$NodeType$Map(), $MAP_12), name_0);
}
function values_30() {
    $clinit_LNode$NodeType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LNode$NodeType_2_classLit, 1), $intern_36, 247, 0, [
        NORMAL,
        LONG_EDGE,
        EXTERNAL_PORT,
        NORTH_SOUTH_PORT,
        LABEL,
        BREAKING_POINT,
        PLACEHOLDER,
        NONSHIFTING_PLACEHOLDER
    ]);
}
defineClass(247, 23, {
    3: 1,
    34: 1,
    23: 1,
    247: 1
}, LNode$NodeType);
var BREAKING_POINT, EXTERNAL_PORT, LABEL, LONG_EDGE, NONSHIFTING_PLACEHOLDER, NORMAL, NORTH_SOUTH_PORT, PLACEHOLDER;
var Lorg_eclipse_elk_alg_layered_graph_LNode$NodeType_2_classLit = createForEnum('org.eclipse.elk.alg.layered.graph', 'LNode/NodeType', 247, Ljava_lang_Enum_2_classLit, values_30, valueOf_22);
function $clinit_LNode$NodeType$Map() {
    $clinit_LNode$NodeType$Map = emptyMethod;
    $MAP_12 = createValueOfMap(($clinit_LNode$NodeType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LNode$NodeType_2_classLit, 1), $intern_36, 247, 0, [
        NORMAL,
        LONG_EDGE,
        EXTERNAL_PORT,
        NORTH_SOUTH_PORT,
        LABEL,
        BREAKING_POINT,
        PLACEHOLDER,
        NONSHIFTING_PLACEHOLDER
    ])));
}
var $MAP_12;
function LNode$lambda$0$Type() {}
defineClass(757, 1, $intern_39, LNode$lambda$0$Type);
_.test_0 = function test_11(arg0) {
    return $booleanValue(castToBoolean($getProperty(castTo(arg0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_INLINE_0))));
};
var Lorg_eclipse_elk_alg_layered_graph_LNode$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LNode/lambda$0$Type', 757);
function ElkPadding() {
    Spacing.call(this);
}
function ElkPadding_0(any) {
    Spacing_0.call(this, any, any, any, any);
}
function ElkPadding_1(other) {
    Spacing_0.call(this, other.top_0, other.right, other.bottom, other.left);
}
defineClass(107, 213, $intern_107, ElkPadding, ElkPadding_0, ElkPadding_1);
var Lorg_eclipse_elk_core_math_ElkPadding_2_classLit = createForClass('org.eclipse.elk.core.math', 'ElkPadding', 107);
function LPadding() {
    ElkPadding.call(this);
}
defineClass(760, 107, $intern_107, LPadding);
var Lorg_eclipse_elk_alg_layered_graph_LPadding_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPadding', 760);
function $clinit_LPort() {
    $clinit_LPort = emptyMethod;
    OUTPUT_PREDICATE = new LPort$lambda$0$Type;
    INPUT_PREDICATE = new LPort$lambda$1$Type;
    NORTH_PREDICATE = new LPort$lambda$2$Type;
    EAST_PREDICATE = new LPort$lambda$3$Type;
    SOUTH_PREDICATE = new LPort$lambda$4$Type;
    WEST_PREDICATE = new LPort$lambda$5$Type;
}
function $getAbsoluteAnchor(this$static) {
    return sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        this$static.owner.pos,
        this$static.pos,
        this$static.anchor
    ]));
}
function $getDegree(this$static) {
    return this$static.incomingEdges.array.length + this$static.outgoingEdges.array.length;
}
function $getDesignation_3(this$static) {
    var id_0;
    if (this$static.labels.array.length != 0 && !!castTo($get_11(this$static.labels, 0), 72).text_0) return castTo($get_11(this$static.labels, 0), 72).text_0;
    id_0 = $getDesignation(this$static);
    if (id_0 != null) return id_0;
    return '' + (!this$static.owner ? -1 : $indexOf_3(this$static.owner.ports, this$static, 0));
}
function $getNetFlow(this$static) {
    return this$static.incomingEdges.array.length - this$static.outgoingEdges.array.length;
}
function $setConnectedToExternalNodes(this$static, conn) {
    this$static.connectedToExternalNodes = conn;
}
function $setNode(this$static, node) {
    !!this$static.owner && $remove_12(this$static.owner.ports, this$static);
    this$static.owner = node;
    !!this$static.owner && $add_3(this$static.owner.ports, this$static);
}
function $setSide(this$static, theside) {
    if (!theside) throw toJs(new NullPointerException);
    this$static.side = theside;
    if (!this$static.explicitlySuppliedPortAnchor) switch(this$static.side.ordinal){
        case 1:
            this$static.anchor.x_0 = this$static.size_0.x_0 / 2;
            this$static.anchor.y_0 = 0;
            break;
        case 2:
            this$static.anchor.x_0 = this$static.size_0.x_0;
            this$static.anchor.y_0 = this$static.size_0.y_0 / 2;
            break;
        case 3:
            this$static.anchor.x_0 = this$static.size_0.x_0 / 2;
            this$static.anchor.y_0 = this$static.size_0.y_0;
            break;
        case 4:
            this$static.anchor.x_0 = 0;
            this$static.anchor.y_0 = this$static.size_0.y_0 / 2;
    }
}
function LPort() {
    $clinit_LPort();
    LShape.call(this);
    this.side = ($clinit_PortSide(), UNDEFINED_5);
    this.anchor = new KVector;
    new LMargin;
    this.labels = (checkNonnegative(2, 'initialArraySize'), new ArrayList_0(2));
    this.incomingEdges = (checkNonnegative(4, 'initialArraySize'), new ArrayList_0(4));
    this.outgoingEdges = (checkNonnegative(4, 'initialArraySize'), new ArrayList_0(4));
    this.connectedEdges = new LPort$CombineIter(this.incomingEdges, this.outgoingEdges);
}
defineClass(11, 395, {
    3: 1,
    306: 1,
    11: 1,
    395: 1,
    102: 1,
    148: 1
}, LPort);
_.toString_0 = function toString_90() {
    var result, source, target;
    result = new StringBuilder;
    $append_11((result.string += 'p_', result), $getDesignation_3(this));
    !!this.owner && $append_11($append_10((result.string += '[', result), this.owner), ']');
    if (this.incomingEdges.array.length == 1 && this.outgoingEdges.array.length == 0 && castTo($get_11(this.incomingEdges, 0), 18).source != this) {
        source = castTo($get_11(this.incomingEdges, 0), 18).source;
        $append_11((result.string += ' << ', result), $getDesignation_3(source));
        $append_11($append_10((result.string += '[', result), source.owner), ']');
    }
    if (this.incomingEdges.array.length == 0 && this.outgoingEdges.array.length == 1 && castTo($get_11(this.outgoingEdges, 0), 18).target != this) {
        target = castTo($get_11(this.outgoingEdges, 0), 18).target;
        $append_11((result.string += ' >> ', result), $getDesignation_3(target));
        $append_11($append_10((result.string += '[', result), target.owner), ']');
    }
    return result.string;
};
_.connectedToExternalNodes = true;
_.explicitlySuppliedPortAnchor = false;
var EAST_PREDICATE, INPUT_PREDICATE, NORTH_PREDICATE, OUTPUT_PREDICATE, SOUTH_PREDICATE, WEST_PREDICATE;
var Lorg_eclipse_elk_alg_layered_graph_LPort_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort', 11);
function LPort$1(this$0) {
    this.this$01 = this$0;
}
defineClass(397, 1, $intern_23, LPort$1);
_.forEach_0 = function forEach_27(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_69() {
    var edgesIter;
    edgesIter = new ArrayList$1(this.this$01.incomingEdges);
    return new LPort$1$1(edgesIter);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/1', 397);
function LPort$1$1(val$edgesIter) {
    this.val$edgesIter2 = val$edgesIter;
}
defineClass(1262, 1, $intern_6, LPort$1$1);
_.forEachRemaining = function forEachRemaining_47(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_37() {
    return castTo($next_6(this.val$edgesIter2), 18).source;
};
_.hasNext_0 = function hasNext_36() {
    return $hasNext_3(this.val$edgesIter2);
};
_.remove = function remove_93() {
    $remove_13(this.val$edgesIter2);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$1$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/1/1', 1262);
function LPort$2(this$0) {
    this.this$01 = this$0;
}
defineClass(362, 1, $intern_23, LPort$2);
_.forEach_0 = function forEach_28(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_70() {
    var edgesIter;
    return edgesIter = new ArrayList$1(this.this$01.outgoingEdges), new LPort$2$1(edgesIter);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$2_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/2', 362);
function LPort$2$1(val$edgesIter) {
    this.val$edgesIter2 = val$edgesIter;
}
defineClass(758, 1, $intern_6, LPort$2$1);
_.forEachRemaining = function forEachRemaining_48(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_38() {
    return castTo($next_6(this.val$edgesIter2), 18).target;
};
_.hasNext_0 = function hasNext_37() {
    return $hasNext_3(this.val$edgesIter2);
};
_.remove = function remove_94() {
    $remove_13(this.val$edgesIter2);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$2$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/2/1', 758);
function LPort$CombineIter(firstIterable, secondIterable) {
    this.firstIterable = firstIterable;
    this.secondIterable = secondIterable;
}
defineClass(1255, 1, $intern_23, LPort$CombineIter);
_.forEach_0 = function forEach_29(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_71() {
    return new LPort$CombineIter$1(this);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$CombineIter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/CombineIter', 1255);
function $hasNext_6(this$static) {
    return $hasNext_3(this$static.firstIterator) || $hasNext_3(this$static.secondIterator);
}
function LPort$CombineIter$1(this$1) {
    this.this$11 = this$1;
    this.firstIterator = new ArrayList$1(this.this$11.firstIterable);
    this.secondIterator = new ArrayList$1(this.this$11.secondIterable);
}
defineClass(207, 1, $intern_6, LPort$CombineIter$1);
_.forEachRemaining = function forEachRemaining_49(consumer) {
    $forEachRemaining(this, consumer);
};
_.remove = function remove_95() {
    $remove_21();
};
_.hasNext_0 = function hasNext_38() {
    return $hasNext_6(this);
};
_.next_1 = function next_39() {
    return $hasNext_3(this.firstIterator) ? $next_6(this.firstIterator) : $next_6(this.secondIterator);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$CombineIter$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/CombineIter/1', 207);
function $apply_4(arg0) {
    return $clinit_LPort(), castTo(arg0, 11).outgoingEdges.array.length != 0;
}
function LPort$lambda$0$Type() {}
defineClass(1256, 1, $intern_89, LPort$lambda$0$Type);
_.apply_1 = function apply_37(arg0) {
    return $apply_4(arg0);
};
_.equals_0 = function equals_94(other) {
    return this === other;
};
_.test_0 = function test_12(input_0) {
    return $clinit_LPort(), castTo(input_0, 11).outgoingEdges.array.length != 0;
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/lambda$0$Type', 1256);
function $apply_5(arg0) {
    return $clinit_LPort(), castTo(arg0, 11).incomingEdges.array.length != 0;
}
function LPort$lambda$1$Type() {}
defineClass(1257, 1, $intern_89, LPort$lambda$1$Type);
_.apply_1 = function apply_38(arg0) {
    return $apply_5(arg0);
};
_.equals_0 = function equals_95(other) {
    return this === other;
};
_.test_0 = function test_13(input_0) {
    return $clinit_LPort(), castTo(input_0, 11).incomingEdges.array.length != 0;
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/lambda$1$Type', 1257);
function LPort$lambda$2$Type() {}
defineClass(1258, 1, $intern_89, LPort$lambda$2$Type);
_.apply_1 = function apply_39(arg0) {
    return $clinit_LPort(), castTo(arg0, 11).side == ($clinit_PortSide(), NORTH_1);
};
_.equals_0 = function equals_96(other) {
    return this === other;
};
_.test_0 = function test_14(input_0) {
    return $clinit_LPort(), castTo(input_0, 11).side == ($clinit_PortSide(), NORTH_1);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/lambda$2$Type', 1258);
function LPort$lambda$3$Type() {}
defineClass(1259, 1, $intern_89, LPort$lambda$3$Type);
_.apply_1 = function apply_40(arg0) {
    return $clinit_LPort(), castTo(arg0, 11).side == ($clinit_PortSide(), EAST_0);
};
_.equals_0 = function equals_97(other) {
    return this === other;
};
_.test_0 = function test_15(input_0) {
    return $clinit_LPort(), castTo(input_0, 11).side == ($clinit_PortSide(), EAST_0);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/lambda$3$Type', 1259);
function LPort$lambda$4$Type() {}
defineClass(1260, 1, $intern_89, LPort$lambda$4$Type);
_.apply_1 = function apply_41(arg0) {
    return $clinit_LPort(), castTo(arg0, 11).side == ($clinit_PortSide(), SOUTH_0);
};
_.equals_0 = function equals_98(other) {
    return this === other;
};
_.test_0 = function test_16(input_0) {
    return $clinit_LPort(), castTo(input_0, 11).side == ($clinit_PortSide(), SOUTH_0);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/lambda$4$Type', 1260);
function LPort$lambda$5$Type() {}
defineClass(1261, 1, $intern_89, LPort$lambda$5$Type);
_.apply_1 = function apply_42(arg0) {
    return $clinit_LPort(), castTo(arg0, 11).side == ($clinit_PortSide(), WEST_0);
};
_.equals_0 = function equals_99(other) {
    return this === other;
};
_.test_0 = function test_17(input_0) {
    return $clinit_LPort(), castTo(input_0, 11).side == ($clinit_PortSide(), WEST_0);
};
var Lorg_eclipse_elk_alg_layered_graph_LPort$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'LPort/lambda$5$Type', 1261);
function $getIndex_0(this$static) {
    return $indexOf_3(this$static.owner.layers, this$static, 0);
}
function Layer(graph) {
    this.size_0 = new KVector;
    this.nodes = new ArrayList;
    this.owner = graph;
}
defineClass(25, 306, {
    3: 1,
    20: 1,
    306: 1,
    25: 1,
    102: 1,
    148: 1
}, Layer);
_.forEach_0 = function forEach_30(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_72() {
    return new ArrayList$1(this.nodes);
};
_.toString_0 = function toString_91() {
    return 'L_' + $indexOf_3(this.owner.layers, this, 0) + $toString_2(this.nodes);
};
var Lorg_eclipse_elk_alg_layered_graph_Layer_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph', 'Layer', 25);
function $calculateMinimumGraphSize(elkgraph, lgraph) {
    var configuredMinSize, graphAdapter, minSize, nodeAdapter, sizeConstraints;
    if (!$getParent_2(elkgraph)) return;
    sizeConstraints = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1)), 181);
    maskUndefined($getProperty_0(elkgraph, PORT_CONSTRAINTS_0)) === maskUndefined(($clinit_PortConstraints(), UNDEFINED_4)) && $setProperty_1(elkgraph, PORT_CONSTRAINTS_0, FREE);
    graphAdapter = ($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter($getParent_2(elkgraph)));
    nodeAdapter = new ElkGraphAdapters$ElkNodeAdapter(!$getParent_2(elkgraph) ? null : new ElkGraphAdapters$ElkGraphAdapter($getParent_2(elkgraph)), elkgraph);
    minSize = process(graphAdapter, nodeAdapter, false, true);
    $add_5(sizeConstraints, ($clinit_SizeConstraint(), MINIMUM_SIZE));
    configuredMinSize = castTo($getProperty(lgraph, NODE_SIZE_MINIMUM_0), 8);
    configuredMinSize.x_0 = $wnd.Math.max(minSize.x_0, configuredMinSize.x_0);
    configuredMinSize.y_0 = $wnd.Math.max(minSize.y_0, configuredMinSize.y_0);
}
function $calculateNetFlow_0(elkport) {
    var elkgraph, incomingEdge, incomingEdge$iterator, inputPortVote, insideSelfLoopsEnabled, isInsideSelfLoop, isSelfLoop, outgoingEdge, outgoingEdge$iterator, outputPortVote, sourceNode, targetNode;
    elkgraph = $getParent_3(elkport);
    insideSelfLoopsEnabled = $booleanValue(castToBoolean($getProperty_0(elkgraph, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE))));
    outputPortVote = 0;
    inputPortVote = 0;
    for(outgoingEdge$iterator = new AbstractEList$EIterator((!elkport.outgoingEdges && (elkport.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 7, 4)), elkport.outgoingEdges)); outgoingEdge$iterator.cursor != outgoingEdge$iterator.this$01_2.size_1();){
        outgoingEdge = castTo($doNext(outgoingEdge$iterator), 85);
        isSelfLoop = $isSelfloop(outgoingEdge);
        isInsideSelfLoop = isSelfLoop && insideSelfLoopsEnabled && $booleanValue(castToBoolean($getProperty_0(outgoingEdge, INSIDE_SELF_LOOPS_YO)));
        targetNode = connectableShapeToNode(castTo($get_20((!outgoingEdge.targets && (outgoingEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, outgoingEdge, 5, 8)), outgoingEdge.targets), 0), 84));
        isSelfLoop && isInsideSelfLoop ? ++inputPortVote : isSelfLoop && !isInsideSelfLoop ? ++outputPortVote : $getParent_2(targetNode) == elkgraph || targetNode == elkgraph ? ++inputPortVote : ++outputPortVote;
    }
    for(incomingEdge$iterator = new AbstractEList$EIterator((!elkport.incomingEdges && (elkport.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 8, 5)), elkport.incomingEdges)); incomingEdge$iterator.cursor != incomingEdge$iterator.this$01_2.size_1();){
        incomingEdge = castTo($doNext(incomingEdge$iterator), 85);
        isSelfLoop = $isSelfloop(incomingEdge);
        isInsideSelfLoop = isSelfLoop && insideSelfLoopsEnabled && $booleanValue(castToBoolean($getProperty_0(incomingEdge, INSIDE_SELF_LOOPS_YO)));
        sourceNode = connectableShapeToNode(castTo($get_20((!incomingEdge.sources && (incomingEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, incomingEdge, 4, 7)), incomingEdge.sources), 0), 84));
        isSelfLoop && isInsideSelfLoop ? ++outputPortVote : isSelfLoop && !isInsideSelfLoop ? ++inputPortVote : $getParent_2(sourceNode) == elkgraph || sourceNode == elkgraph ? ++outputPortVote : ++inputPortVote;
    }
    return outputPortVote - inputPortVote;
}
function $checkEdgeValidity(edge) {
    if ((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources).size_0 == 0) throw toJs(new UnsupportedGraphException('Edges must have a source.'));
    else if ((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets).size_0 == 0) throw toJs(new UnsupportedGraphException('Edges must have a target.'));
    else {
        !edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7));
        if (!(edge.sources.size_0 <= 1 && (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets.size_0 <= 1))) throw toJs(new UnsupportedGraphException('Hyperedges are not supported.'));
    }
}
function $checkExternalPorts(elkgraph, graphProperties) {
    var connectsToChild, elkedge, elkedge$iterator, elkport, enableSelfLoops, externalPortEdges, hasExternalPorts, hasHyperedges, isInsideSelfLoop, portIterator, portLabelPlacement;
    enableSelfLoops = $booleanValue(castToBoolean($getProperty_0(elkgraph, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE))));
    portLabelPlacement = castTo($getProperty_0(elkgraph, PORT_LABELS_PLACEMENT_1), 22);
    hasExternalPorts = false;
    hasHyperedges = false;
    portIterator = new AbstractEList$EIterator((!elkgraph.ports && (elkgraph.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, elkgraph, 9, 9)), elkgraph.ports));
    while(portIterator.cursor != portIterator.this$01_2.size_1() && (!hasExternalPorts || !hasHyperedges)){
        elkport = castTo($doNext(portIterator), 124);
        externalPortEdges = 0;
        for(elkedge$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
            (!elkport.incomingEdges && (elkport.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 8, 5)), elkport.incomingEdges),
            (!elkport.outgoingEdges && (elkport.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 7, 4)), elkport.outgoingEdges)
        ]))); $hasNext_1(elkedge$iterator);){
            elkedge = castTo($next_0(elkedge$iterator), 85);
            isInsideSelfLoop = enableSelfLoops && $isSelfloop(elkedge) && $booleanValue(castToBoolean($getProperty_0(elkedge, INSIDE_SELF_LOOPS_YO)));
            connectsToChild = $contains_11((!elkedge.sources && (elkedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 4, 7)), elkedge.sources), elkport) ? elkgraph == $getParent_2(connectableShapeToNode(castTo($get_20((!elkedge.targets && (elkedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 5, 8)), elkedge.targets), 0), 84))) : elkgraph == $getParent_2(connectableShapeToNode(castTo($get_20((!elkedge.sources && (elkedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 4, 7)), elkedge.sources), 0), 84)));
            if (isInsideSelfLoop || connectsToChild) {
                ++externalPortEdges;
                if (externalPortEdges > 1) break;
            }
        }
        externalPortEdges > 0 ? hasExternalPorts = true : portLabelPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0)) && (!elkport.labels && (elkport.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elkport, 1, 7)), elkport.labels).size_0 > 0 && (hasExternalPorts = true);
        externalPortEdges > 1 && (hasHyperedges = true);
    }
    hasExternalPorts && graphProperties.add_2(($clinit_GraphProperties(), EXTERNAL_PORTS));
    hasHyperedges && graphProperties.add_2(($clinit_GraphProperties(), HYPEREDGES));
}
function $createLGraph(elkgraph) {
    var all, lPadding, lgraph, nodeLabelpadding, nodePadding, root;
    lgraph = new LGraph;
    $copyProperties(lgraph, elkgraph);
    maskUndefined($getProperty(lgraph, ($clinit_LayeredOptions(), DIRECTION))) === maskUndefined(($clinit_Direction(), UNDEFINED_2)) && $setProperty_0(lgraph, DIRECTION, getDirection_1(lgraph));
    if ($getProperty(lgraph, ($clinit_LabelManagementOptions(), LABEL_MANAGER)) == null) {
        root = castTo(getRootContainer(elkgraph), 173);
        $setProperty_0(lgraph, LABEL_MANAGER, throwClassCastExceptionUnlessNull(root.getProperty(LABEL_MANAGER)));
    }
    $setProperty_0(lgraph, ($clinit_InternalProperties_1(), ORIGIN_0), elkgraph);
    $setProperty_0(lgraph, GRAPH_PROPERTIES, (all = castTo($getEnumConstants(Lorg_eclipse_elk_alg_layered_options_GraphProperties_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)));
    nodeLabelpadding = computeInsideNodeLabelPadding((!$getParent_2(elkgraph) || ($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter($getParent_2(elkgraph))), $clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkNodeAdapter(!$getParent_2(elkgraph) ? null : new ElkGraphAdapters$ElkGraphAdapter($getParent_2(elkgraph)), elkgraph)), RIGHT_6);
    nodePadding = castTo($getProperty(lgraph, PADDING_0), 107);
    lPadding = lgraph.padding;
    $add_15(lPadding, nodePadding);
    $add_15(lPadding, nodeLabelpadding);
    return lgraph;
}
function $ensureDefinedPortSide(lgraph, elkport) {
    var layoutDirection, netFlow, portConstraints, portSide;
    layoutDirection = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), DIRECTION)), 86);
    portSide = castTo($getProperty_0(elkport, PORT_SIDE), 64);
    portConstraints = castTo($getProperty(lgraph, PORT_CONSTRAINTS_0), 100);
    if (portConstraints != ($clinit_PortConstraints(), FREE) && portConstraints != UNDEFINED_4) {
        if (portSide == ($clinit_PortSide(), UNDEFINED_5)) {
            portSide = calcPortSide_0(elkport, layoutDirection);
            portSide == UNDEFINED_5 && (portSide = fromDirection(layoutDirection));
        }
    } else {
        netFlow = $calculateNetFlow_0(elkport);
        netFlow > 0 ? portSide = fromDirection(layoutDirection) : portSide = $opposed(fromDirection(layoutDirection));
    }
    $setProperty_1(elkport, PORT_SIDE, portSide);
}
function $findCoordinateSystemOrigin(this$static, elkedge, topLevelElkGraph, topLevelLGraph) {
    var lgraph, lnode, origin_0, source, target;
    source = connectableShapeToNode(castTo($get_20((!elkedge.sources && (elkedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 4, 7)), elkedge.sources), 0), 84));
    target = connectableShapeToNode(castTo($get_20((!elkedge.targets && (elkedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 5, 8)), elkedge.targets), 0), 84));
    if ($getParent_2(source) == $getParent_2(target)) return null;
    if (isDescendant_0(target, source)) return null;
    origin_0 = $getContainingNode(elkedge);
    if (origin_0 == topLevelElkGraph) return topLevelLGraph;
    else {
        lnode = castTo($get_10(this$static.nodeAndPortMap, origin_0), 9);
        if (lnode) {
            lgraph = lnode.nestedGraph;
            if (lgraph) return lgraph;
        }
    }
    return null;
}
function $hasInsideSelfLoops(elknode) {
    var edge, edge$iterator;
    if ($booleanValue(castToBoolean($getProperty_0(elknode, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE))))) for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(elknode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 85);
        if ($isSelfloop(edge)) {
            if ($booleanValue(castToBoolean($getProperty_0(edge, INSIDE_SELF_LOOPS_YO)))) return true;
        }
    }
    return false;
}
function $importFlatGraph(this$static, elkgraph0, lgraph) {
    var child, child$iterator, connectsSiblings, connectsToGraph, elkedge, elkedge$iterator, elkedge$iterator0, elkgraph, enableInsideSelfLoops, index_0, isInsideSelfLoop, isToBeLaidOut, source, target;
    index_0 = 0;
    for(child$iterator = new AbstractEList$EIterator((!elkgraph0.children && (elkgraph0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, elkgraph0, 10, 11)), elkgraph0.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
        child = castTo($doNext(child$iterator), 27);
        if (!$booleanValue(castToBoolean($getProperty_0(child, ($clinit_LayeredOptions(), NO_LAYOUT))))) {
            elkgraph = $getParent_2(child);
            if ((maskUndefined($getProperty_0(elkgraph, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) || maskUndefined($getProperty_0(elkgraph, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), MODEL_ORDER_0)) || maskUndefined($getProperty_0(elkgraph, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), GREEDY_MODEL_ORDER)) || $booleanValue(castToBoolean($getProperty_0(elkgraph, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))) || maskUndefined($getProperty_0(elkgraph, CONSIDER_MODEL_ORDER_COMPONENTS_0)) !== maskUndefined(($clinit_ComponentOrderingStrategy(), NONE)) || maskUndefined($getProperty_0(elkgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT)) || maskUndefined($getProperty_0(elkgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_RIGHT_TO_LEFT)) || maskUndefined($getProperty_0(elkgraph, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), BF_MODEL_ORDER)) || maskUndefined($getProperty_0(elkgraph, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), DF_MODEL_ORDER))) && !$booleanValue(castToBoolean($getProperty_0(child, CONSIDER_MODEL_ORDER_NO_MODEL_ORDER_0)))) {
                $setProperty_1(child, ($clinit_InternalProperties_1(), MODEL_ORDER_1), valueOf_3(index_0));
                ++index_0;
            }
            $transformNode(this$static, child, lgraph);
        }
    }
    index_0 = 0;
    for(elkedge$iterator0 = new AbstractEList$EIterator((!elkgraph0.containedEdges && (elkgraph0.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkgraph0, 12, 3)), elkgraph0.containedEdges)); elkedge$iterator0.cursor != elkedge$iterator0.this$01_2.size_1();){
        elkedge = castTo($doNext(elkedge$iterator0), 85);
        if (maskUndefined($getProperty_0(elkgraph0, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_STRATEGY_0))) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) || maskUndefined($getProperty_0(elkgraph0, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), MODEL_ORDER_0)) || maskUndefined($getProperty_0(elkgraph0, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), GREEDY_MODEL_ORDER)) || $booleanValue(castToBoolean($getProperty_0(elkgraph0, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))) || maskUndefined($getProperty_0(elkgraph0, CONSIDER_MODEL_ORDER_COMPONENTS_0)) !== maskUndefined(($clinit_ComponentOrderingStrategy(), NONE)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_RIGHT_TO_LEFT)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), BF_MODEL_ORDER)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), DF_MODEL_ORDER))) {
            $setProperty_1(elkedge, ($clinit_InternalProperties_1(), MODEL_ORDER_1), valueOf_3(index_0));
            ++index_0;
        }
        source = getSourceNode(elkedge);
        target = getTargetNode_0(elkedge);
        enableInsideSelfLoops = $booleanValue(castToBoolean($getProperty_0(source, INSIDE_SELF_LOOPS_ACTIVATE)));
        isToBeLaidOut = !$booleanValue(castToBoolean($getProperty_0(elkedge, NO_LAYOUT)));
        isInsideSelfLoop = enableInsideSelfLoops && $isSelfloop(elkedge) && $booleanValue(castToBoolean($getProperty_0(elkedge, INSIDE_SELF_LOOPS_YO)));
        connectsSiblings = $getParent_2(source) == elkgraph0 && $getParent_2(source) == $getParent_2(target);
        connectsToGraph = ($getParent_2(source) == elkgraph0 && target == elkgraph0) ^ ($getParent_2(target) == elkgraph0 && source == elkgraph0);
        isToBeLaidOut && !isInsideSelfLoop && (connectsToGraph || connectsSiblings) && $transformEdge(this$static, elkedge, elkgraph0, lgraph);
    }
    if ($getParent_2(elkgraph0)) for(elkedge$iterator = new AbstractEList$EIterator($getContainedEdges($getParent_2(elkgraph0))); elkedge$iterator.cursor != elkedge$iterator.this$01_2.size_1();){
        elkedge = castTo($doNext(elkedge$iterator), 85);
        source = getSourceNode(elkedge);
        if (source == elkgraph0 && $isSelfloop(elkedge)) {
            isInsideSelfLoop = $booleanValue(castToBoolean($getProperty_0(source, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE)))) && $booleanValue(castToBoolean($getProperty_0(elkedge, INSIDE_SELF_LOOPS_YO)));
            isInsideSelfLoop && $transformEdge(this$static, elkedge, elkgraph0, lgraph);
        }
    }
}
function $importGraph_0(this$static, elkgraph) {
    var elkport, elkport$iterator, graphProperties, topLevelGraph;
    topLevelGraph = $createLGraph(elkgraph);
    !elkgraph.ports && (elkgraph.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, elkgraph, 9, 9));
    $forEach_3(new StreamImpl(null, (!elkgraph.ports && (elkgraph.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, elkgraph, 9, 9)), new Spliterators$IteratorSpliterator(elkgraph.ports, 16))), new ElkGraphImporter$lambda$0$Type_0(topLevelGraph));
    graphProperties = castTo($getProperty(topLevelGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
    $checkExternalPorts(elkgraph, graphProperties);
    if (graphProperties.contains(($clinit_GraphProperties(), EXTERNAL_PORTS))) for(elkport$iterator = new AbstractEList$EIterator((!elkgraph.ports && (elkgraph.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, elkgraph, 9, 9)), elkgraph.ports)); elkport$iterator.cursor != elkport$iterator.this$01_2.size_1();){
        elkport = castTo($doNext(elkport$iterator), 124);
        $transformExternalPort(this$static, elkgraph, topLevelGraph, elkport);
    }
    castTo($getProperty_0(elkgraph, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1)), 181).size_1() != 0 && $calculateMinimumGraphSize(elkgraph, topLevelGraph);
    $booleanValue(castToBoolean($getProperty(topLevelGraph, PARTITIONING_ACTIVATE))) && graphProperties.add_2(PARTITIONS);
    $hasProperty(topLevelGraph, SPACING_BASE_VALUE_0) && $apply_7(new LayeredSpacings$LayeredSpacingsBuilder($doubleValue(castToDouble($getProperty(topLevelGraph, SPACING_BASE_VALUE_0)))), topLevelGraph);
    maskUndefined($getProperty_0(elkgraph, HIERARCHY_HANDLING)) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN)) ? $importHierarchicalGraph(this$static, elkgraph, topLevelGraph) : $importFlatGraph(this$static, elkgraph, topLevelGraph);
    return topLevelGraph;
}
function $importHierarchicalGraph(this$static, elkgraph0, lgraph) {
    var elkChildGraphNode, elkChildGraphNode$iterator, elkGraphNode, elkGraphQueue, elkedge, elkedge$iterator, elkgraph, elknode, finalNestedGraph, hasChildren, hasHierarchyHandlingEnabled, hasInsideSelfLoops, index_0, isInsideSelfLoop, isNodeToBeLaidOut, ledge, lnode, nestedGraph, parentElkGraph, parentGraphDirection, parentLGraph, parentLNode, partOfSameLayoutRun, sourceNode, targetNode, usesElkLayered;
    elkGraphQueue = new LinkedList;
    parentGraphDirection = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), DIRECTION)), 86);
    index_0 = 0;
    $addAll(elkGraphQueue, (!elkgraph0.children && (elkgraph0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, elkgraph0, 10, 11)), elkgraph0.children));
    while(elkGraphQueue.size_0 != 0){
        elknode = castTo(elkGraphQueue.size_0 == 0 ? null : (checkCriticalElement(elkGraphQueue.size_0 != 0), $removeNode_0(elkGraphQueue, elkGraphQueue.header.next_0)), 27);
        elkgraph = $getParent_2(elknode);
        (maskUndefined($getProperty_0(elkgraph, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) || maskUndefined($getProperty_0(elkgraph, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), MODEL_ORDER_0)) || maskUndefined($getProperty_0(elkgraph, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), GREEDY_MODEL_ORDER)) || $booleanValue(castToBoolean($getProperty_0(elkgraph, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))) || maskUndefined($getProperty_0(elkgraph, CONSIDER_MODEL_ORDER_COMPONENTS_0)) !== maskUndefined(($clinit_ComponentOrderingStrategy(), NONE)) || maskUndefined($getProperty_0(elkgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT)) || maskUndefined($getProperty_0(elkgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_RIGHT_TO_LEFT)) || maskUndefined($getProperty_0(elkgraph, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), BF_MODEL_ORDER)) || maskUndefined($getProperty_0(elkgraph, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), DF_MODEL_ORDER))) && !$booleanValue(castToBoolean($getProperty_0(elknode, CONSIDER_MODEL_ORDER_NO_MODEL_ORDER_0))) && $setProperty_1(elknode, ($clinit_InternalProperties_1(), MODEL_ORDER_1), valueOf_3(index_0++));
        isNodeToBeLaidOut = !$booleanValue(castToBoolean($getProperty_0(elknode, NO_LAYOUT)));
        if (isNodeToBeLaidOut) {
            hasChildren = (!elknode.children && (elknode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, elknode, 10, 11)), elknode.children).size_0 != 0;
            hasInsideSelfLoops = $hasInsideSelfLoops(elknode);
            hasHierarchyHandlingEnabled = maskUndefined($getProperty_0(elknode, HIERARCHY_HANDLING)) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN));
            usesElkLayered = !$hasProperty_0(elknode, ($clinit_CoreOptions(), ALGORITHM)) || $endsWith(castToString($getProperty_0(elknode, ALGORITHM)));
            nestedGraph = null;
            if (usesElkLayered && hasHierarchyHandlingEnabled && (hasChildren || hasInsideSelfLoops)) {
                nestedGraph = $createLGraph(elknode);
                $setProperty_0(nestedGraph, DIRECTION, parentGraphDirection);
                $hasProperty(nestedGraph, SPACING_BASE_VALUE_0) && $apply_7(new LayeredSpacings$LayeredSpacingsBuilder($doubleValue(castToDouble($getProperty(nestedGraph, SPACING_BASE_VALUE_0)))), nestedGraph);
                if (castTo($getProperty_0(elknode, NODE_SIZE_CONSTRAINTS_1), 181).size_1() != 0) {
                    finalNestedGraph = nestedGraph;
                    $forEach_3(new StreamImpl(null, (!elknode.ports && (elknode.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, elknode, 9, 9)), new Spliterators$IteratorSpliterator(elknode.ports, 16))), new ElkGraphImporter$lambda$1$Type(finalNestedGraph));
                    $calculateMinimumGraphSize(elknode, nestedGraph);
                }
            }
            parentLGraph = lgraph;
            parentLNode = castTo($get_10(this$static.nodeAndPortMap, $getParent_2(elknode)), 9);
            !!parentLNode && (parentLGraph = parentLNode.nestedGraph);
            lnode = $transformNode(this$static, elknode, parentLGraph);
            if (nestedGraph) {
                lnode.nestedGraph = nestedGraph;
                nestedGraph.parentNode = lnode;
                $addAll(elkGraphQueue, (!elknode.children && (elknode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, elknode, 10, 11)), elknode.children));
            }
        }
    }
    index_0 = 0;
    $addNode_0(elkGraphQueue, elkgraph0, elkGraphQueue.tail.prev, elkGraphQueue.tail);
    while(elkGraphQueue.size_0 != 0){
        elkGraphNode = castTo(elkGraphQueue.size_0 == 0 ? null : (checkCriticalElement(elkGraphQueue.size_0 != 0), $removeNode_0(elkGraphQueue, elkGraphQueue.header.next_0)), 27);
        for(elkedge$iterator = new AbstractEList$EIterator((!elkGraphNode.containedEdges && (elkGraphNode.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkGraphNode, 12, 3)), elkGraphNode.containedEdges)); elkedge$iterator.cursor != elkedge$iterator.this$01_2.size_1();){
            elkedge = castTo($doNext(elkedge$iterator), 85);
            $checkEdgeValidity(elkedge);
            (maskUndefined($getProperty_0(elkgraph0, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) || maskUndefined($getProperty_0(elkgraph0, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), MODEL_ORDER_0)) || maskUndefined($getProperty_0(elkgraph0, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), GREEDY_MODEL_ORDER)) || $booleanValue(castToBoolean($getProperty_0(elkgraph0, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))) || maskUndefined($getProperty_0(elkgraph0, CONSIDER_MODEL_ORDER_COMPONENTS_0)) !== maskUndefined(($clinit_ComponentOrderingStrategy(), NONE)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_RIGHT_TO_LEFT)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), BF_MODEL_ORDER)) || maskUndefined($getProperty_0(elkgraph0, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), DF_MODEL_ORDER))) && $setProperty_1(elkedge, ($clinit_InternalProperties_1(), MODEL_ORDER_1), valueOf_3(index_0++));
            sourceNode = connectableShapeToNode(castTo($get_20((!elkedge.sources && (elkedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 4, 7)), elkedge.sources), 0), 84));
            targetNode = connectableShapeToNode(castTo($get_20((!elkedge.targets && (elkedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 5, 8)), elkedge.targets), 0), 84));
            if ($booleanValue(castToBoolean($getProperty_0(elkedge, NO_LAYOUT))) || $booleanValue(castToBoolean($getProperty_0(sourceNode, NO_LAYOUT))) || $booleanValue(castToBoolean($getProperty_0(targetNode, NO_LAYOUT)))) continue;
            isInsideSelfLoop = $isSelfloop(elkedge) && $booleanValue(castToBoolean($getProperty_0(sourceNode, INSIDE_SELF_LOOPS_ACTIVATE))) && $booleanValue(castToBoolean($getProperty_0(elkedge, INSIDE_SELF_LOOPS_YO)));
            parentElkGraph = elkGraphNode;
            isInsideSelfLoop || isDescendant_0(targetNode, sourceNode) ? parentElkGraph = sourceNode : isDescendant_0(sourceNode, targetNode) && (parentElkGraph = targetNode);
            parentLGraph = lgraph;
            parentLNode = castTo($get_10(this$static.nodeAndPortMap, parentElkGraph), 9);
            !!parentLNode && (parentLGraph = parentLNode.nestedGraph);
            ledge = $transformEdge(this$static, elkedge, parentElkGraph, parentLGraph);
            $setProperty_0(ledge, ($clinit_InternalProperties_1(), COORDINATE_SYSTEM_ORIGIN), $findCoordinateSystemOrigin(this$static, elkedge, elkgraph0, lgraph));
        }
        hasHierarchyHandlingEnabled = maskUndefined($getProperty_0(elkGraphNode, HIERARCHY_HANDLING)) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN));
        if (hasHierarchyHandlingEnabled) for(elkChildGraphNode$iterator = new AbstractEList$EIterator((!elkGraphNode.children && (elkGraphNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, elkGraphNode, 10, 11)), elkGraphNode.children)); elkChildGraphNode$iterator.cursor != elkChildGraphNode$iterator.this$01_2.size_1();){
            elkChildGraphNode = castTo($doNext(elkChildGraphNode$iterator), 27);
            usesElkLayered = !$hasProperty_0(elkChildGraphNode, ($clinit_CoreOptions(), ALGORITHM)) || $endsWith(castToString($getProperty_0(elkChildGraphNode, ALGORITHM)));
            partOfSameLayoutRun = maskUndefined($getProperty_0(elkChildGraphNode, HIERARCHY_HANDLING)) === maskUndefined(INCLUDE_CHILDREN);
            usesElkLayered && partOfSameLayoutRun && $addNode_0(elkGraphQueue, elkChildGraphNode, elkGraphQueue.tail.prev, elkGraphQueue.tail);
        }
    }
}
function $isConnectedToExternalNodes(elkport) {
    var inEdge, inEdge$iterator, outEdge, outEdge$iterator, parent_0, sourceNode, targetNode;
    parent_0 = $getParent_3(elkport);
    for(outEdge$iterator = new AbstractEList$EIterator((!elkport.outgoingEdges && (elkport.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 7, 4)), elkport.outgoingEdges)); outEdge$iterator.cursor != outEdge$iterator.this$01_2.size_1();){
        outEdge = castTo($doNext(outEdge$iterator), 85);
        targetNode = connectableShapeToNode(castTo($get_20((!outEdge.targets && (outEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, outEdge, 5, 8)), outEdge.targets), 0), 84));
        if (!isDescendant_0(targetNode, parent_0)) return true;
    }
    for(inEdge$iterator = new AbstractEList$EIterator((!elkport.incomingEdges && (elkport.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 8, 5)), elkport.incomingEdges)); inEdge$iterator.cursor != inEdge$iterator.this$01_2.size_1();){
        inEdge = castTo($doNext(inEdge$iterator), 85);
        sourceNode = connectableShapeToNode(castTo($get_20((!inEdge.sources && (inEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, inEdge, 4, 7)), inEdge.sources), 0), 84));
        if (!isDescendant_0(sourceNode, parent_0)) return true;
    }
    return false;
}
function $transformEdge(this$static, elkedge, elkparent, lgraph) {
    var bendPointsRequired, crossMinStrat, edgeSection, elkSourceNode, elkSourceShape, elkTargetNode, elkTargetShape, elklabel, elklabel$iterator, graphProperties, importedBendpoints, ledge, llabel, nodePlaceStrat, originalBendpoints, point, point$iterator, portType, sourceElem, sourceLNode, sourceLPort, sourcePoint, targetElem, targetLNode, targetLPort, targetPoint;
    $checkEdgeValidity(elkedge);
    elkSourceShape = castTo($get_20((!elkedge.sources && (elkedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 4, 7)), elkedge.sources), 0), 84);
    elkTargetShape = castTo($get_20((!elkedge.targets && (elkedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 5, 8)), elkedge.targets), 0), 84);
    elkSourceNode = connectableShapeToNode(elkSourceShape);
    elkTargetNode = connectableShapeToNode(elkTargetShape);
    edgeSection = (!elkedge.sections && (elkedge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, elkedge, 6, 6)), elkedge.sections).size_0 == 0 ? null : castTo($get_20((!elkedge.sections && (elkedge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, elkedge, 6, 6)), elkedge.sections), 0), 168);
    sourceLNode = castTo($get_10(this$static.nodeAndPortMap, elkSourceNode), 9);
    targetLNode = castTo($get_10(this$static.nodeAndPortMap, elkTargetNode), 9);
    sourceLPort = null;
    targetLPort = null;
    if (instanceOf(elkSourceShape, 193)) {
        sourceElem = castTo($get_10(this$static.nodeAndPortMap, elkSourceShape), 306);
        if (instanceOf(sourceElem, 11)) sourceLPort = castTo(sourceElem, 11);
        else if (instanceOf(sourceElem, 9)) {
            sourceLNode = castTo(sourceElem, 9);
            sourceLPort = castTo($get_11(sourceLNode.ports, 0), 11);
        }
    }
    if (instanceOf(elkTargetShape, 193)) {
        targetElem = castTo($get_10(this$static.nodeAndPortMap, elkTargetShape), 306);
        if (instanceOf(targetElem, 11)) targetLPort = castTo(targetElem, 11);
        else if (instanceOf(targetElem, 9)) {
            targetLNode = castTo(targetElem, 9);
            targetLPort = castTo($get_11(targetLNode.ports, 0), 11);
        }
    }
    if (!sourceLNode || !targetLNode) throw toJs(new UnsupportedGraphException('The source or the target of edge ' + elkedge + ' could not be found. ' + 'This usually happens when an edge connects a node laid out by ELK Layered to a node in ' + 'another level of hierarchy laid out by either another instance of ELK Layered or another ' + 'layout algorithm alltogether. The former can be solved by setting the hierarchyHandling ' + 'option to INCLUDE_CHILDREN.'));
    ledge = new LEdge;
    $copyProperties(ledge, elkedge);
    $setProperty_0(ledge, ($clinit_InternalProperties_1(), ORIGIN_0), elkedge);
    $setProperty_0(ledge, ($clinit_LayeredOptions(), JUNCTION_POINTS), null);
    graphProperties = castTo($getProperty(lgraph, GRAPH_PROPERTIES), 22);
    sourceLNode == targetLNode && graphProperties.add_2(($clinit_GraphProperties(), SELF_LOOPS));
    if (!sourceLPort) {
        portType = ($clinit_PortType(), OUTPUT);
        sourcePoint = null;
        if (!!edgeSection && $isSideFixed(castTo($getProperty(sourceLNode, PORT_CONSTRAINTS_0), 100))) {
            sourcePoint = new KVector_1(edgeSection.startX, edgeSection.startY);
            toAbsolute(sourcePoint, $getContainingNode(elkedge));
            toRelative(sourcePoint, elkparent);
            if (isDescendant_0(elkTargetNode, elkSourceNode)) {
                portType = INPUT;
                $add_19(sourcePoint, sourceLNode.pos);
            }
        }
        sourceLPort = createPort(sourceLNode, sourcePoint, portType, lgraph);
    }
    if (!targetLPort) {
        portType = ($clinit_PortType(), INPUT);
        targetPoint = null;
        if (!!edgeSection && $isSideFixed(castTo($getProperty(targetLNode, PORT_CONSTRAINTS_0), 100))) {
            targetPoint = new KVector_1(edgeSection.endX, edgeSection.endY);
            toAbsolute(targetPoint, $getContainingNode(elkedge));
            toRelative(targetPoint, elkparent);
        }
        targetLPort = createPort(targetLNode, targetPoint, portType, $getGraph(targetLNode));
    }
    $setSource_0(ledge, sourceLPort);
    $setTarget_0(ledge, targetLPort);
    (sourceLPort.incomingEdges.array.length > 1 || sourceLPort.outgoingEdges.array.length > 1 || targetLPort.incomingEdges.array.length > 1 || targetLPort.outgoingEdges.array.length > 1) && graphProperties.add_2(($clinit_GraphProperties(), HYPEREDGES));
    for(elklabel$iterator = new AbstractEList$EIterator((!elkedge.labels && (elkedge.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elkedge, 1, 7)), elkedge.labels)); elklabel$iterator.cursor != elklabel$iterator.this$01_2.size_1();){
        elklabel = castTo($doNext(elklabel$iterator), 153);
        if (!$booleanValue(castToBoolean($getProperty_0(elklabel, NO_LAYOUT))) && !!elklabel.text_0) {
            llabel = $transformLabel(elklabel);
            $add_3(ledge.labels, llabel);
            switch(castTo($getProperty(llabel, EDGE_LABELS_PLACEMENT), 276).ordinal){
                case 1:
                case 2:
                    graphProperties.add_2(($clinit_GraphProperties(), END_LABELS));
                    break;
                case 0:
                    graphProperties.add_2(($clinit_GraphProperties(), CENTER_LABELS));
                    $setProperty_0(llabel, EDGE_LABELS_PLACEMENT, ($clinit_EdgeLabelPlacement(), CENTER_5));
            }
        }
    }
    crossMinStrat = castTo($getProperty(lgraph, CROSSING_MINIMIZATION_STRATEGY_0), 323);
    nodePlaceStrat = castTo($getProperty(lgraph, NODE_PLACEMENT_STRATEGY_0), 324);
    bendPointsRequired = crossMinStrat == ($clinit_CrossingMinimizationStrategy(), INTERACTIVE_1) || nodePlaceStrat == ($clinit_NodePlacementStrategy(), INTERACTIVE_4);
    if (!!edgeSection && (!edgeSection.bendPoints && (edgeSection.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, edgeSection, 5)), edgeSection.bendPoints).size_0 != 0 && bendPointsRequired) {
        originalBendpoints = createVectorChain(edgeSection);
        importedBendpoints = new KVectorChain;
        for(point$iterator = $listIterator_2(originalBendpoints, 0); point$iterator.currentNode != point$iterator.this$01.tail;){
            point = castTo($next_9(point$iterator), 8);
            $add_7(importedBendpoints, new KVector_2(point));
        }
        $setProperty_0(ledge, ORIGINAL_BENDPOINTS, importedBendpoints);
    }
    return ledge;
}
function $transformExternalPort(this$static, elkgraph, lgraph, elkport) {
    var dummy, dummyPort, elklabel, elklabel$iterator, elkportPosition, graphSize, insidePart, insidePortLabels, llabel, netFlow, portConstraints, portOffset, portSide;
    elkportPosition = new KVector_1(elkport.x_0 + elkport.width_0 / 2, elkport.y_0 + elkport.height / 2);
    netFlow = $calculateNetFlow_0(elkport);
    portConstraints = castTo($getProperty_0(elkgraph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    portSide = castTo($getProperty_0(elkport, PORT_SIDE), 64);
    if (!$containsKey_8($getAllProperties_0(elkport), PORT_BORDER_OFFSET)) {
        elkport.x_0 == 0 && elkport.y_0 == 0 ? portOffset = 0 : portOffset = calcPortOffset_0(elkport, portSide);
        $setProperty_1(elkport, PORT_BORDER_OFFSET, portOffset);
    }
    graphSize = new KVector_1(elkgraph.width_0, elkgraph.height);
    dummy = createExternalPortDummy(elkport, portConstraints, portSide, netFlow, graphSize, elkportPosition, new KVector_1(elkport.width_0, elkport.height), castTo($getProperty(lgraph, DIRECTION), 86), lgraph);
    $setProperty_0(dummy, ($clinit_InternalProperties_1(), ORIGIN_0), elkport);
    dummyPort = castTo($get_11(dummy.ports, 0), 11);
    $setConnectedToExternalNodes(dummyPort, $isConnectedToExternalNodes(elkport));
    $setProperty_0(dummy, PORT_LABELS_PLACEMENT_1, ($clinit_PortLabelPlacement(), of_1(OUTSIDE_0)));
    insidePortLabels = castTo($getProperty_0(elkgraph, PORT_LABELS_PLACEMENT_1), 181).contains(INSIDE_0);
    for(elklabel$iterator = new AbstractEList$EIterator((!elkport.labels && (elkport.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elkport, 1, 7)), elkport.labels)); elklabel$iterator.cursor != elklabel$iterator.this$01_2.size_1();){
        elklabel = castTo($doNext(elklabel$iterator), 153);
        if (!$booleanValue(castToBoolean($getProperty_0(elklabel, NO_LAYOUT))) && !!elklabel.text_0) {
            llabel = $transformLabel(elklabel);
            $add_3(dummyPort.labels, llabel);
            if (!insidePortLabels) {
                insidePart = 0;
                isFixed(castTo($getProperty_0(elkgraph, PORT_LABELS_PLACEMENT_1), 22)) && (insidePart = computeInsidePart(new KVector_1(elklabel.x_0, elklabel.y_0), new KVector_1(elklabel.width_0, elklabel.height), new KVector_1(elkport.width_0, elkport.height), 0, portSide));
                switch(portSide.ordinal){
                    case 2:
                    case 4:
                        llabel.size_0.x_0 = insidePart;
                        break;
                    case 1:
                    case 3:
                        llabel.size_0.y_0 = insidePart;
                }
            }
        }
    }
    $setProperty_0(dummy, SPACING_LABEL_PORT_HORIZONTAL, castToDouble($getProperty_0($getParent_2(elkgraph), SPACING_LABEL_PORT_HORIZONTAL)));
    $setProperty_0(dummy, SPACING_LABEL_PORT_VERTICAL, castToDouble($getProperty_0($getParent_2(elkgraph), SPACING_LABEL_PORT_VERTICAL)));
    $setProperty_0(dummy, SPACING_LABEL_LABEL, castToDouble($getProperty_0($getParent_2(elkgraph), SPACING_LABEL_LABEL)));
    $add_3(lgraph.layerlessNodes, dummy);
    $put_6(this$static.nodeAndPortMap, elkport, dummy);
}
function $transformLabel(elklabel) {
    var newLabel;
    newLabel = new LLabel_0(elklabel.text_0);
    $copyProperties(newLabel, elklabel);
    $setProperty_0(newLabel, ($clinit_InternalProperties_1(), ORIGIN_0), elklabel);
    newLabel.size_0.x_0 = elklabel.width_0;
    newLabel.size_0.y_0 = elklabel.height;
    newLabel.pos.x_0 = elklabel.x_0;
    newLabel.pos.y_0 = elklabel.y_0;
    return newLabel;
}
function $transformNode(this$static, elknode, lgraph) {
    var direction, elkgraph, elklabel, elklabel$iterator, elkport, elkport$iterator, graphProperties, lnode, portConstraints, portModelOrder;
    lnode = new LNode(lgraph);
    $copyProperties(lnode, elknode);
    $setProperty_0(lnode, ($clinit_InternalProperties_1(), ORIGIN_0), elknode);
    lnode.size_0.x_0 = elknode.width_0;
    lnode.size_0.y_0 = elknode.height;
    lnode.pos.x_0 = elknode.x_0;
    lnode.pos.y_0 = elknode.y_0;
    $add_3(lgraph.layerlessNodes, lnode);
    $put_6(this$static.nodeAndPortMap, elknode, lnode);
    ((!elknode.children && (elknode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, elknode, 10, 11)), elknode.children).size_0 != 0 || $booleanValue(castToBoolean($getProperty_0(elknode, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_ACTIVATE))))) && $setProperty_0(lnode, COMPOUND_NODE, ($clinit_Boolean(), true));
    graphProperties = castTo($getProperty(lgraph, GRAPH_PROPERTIES), 22);
    portConstraints = castTo($getProperty(lnode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    portConstraints == ($clinit_PortConstraints(), UNDEFINED_4) ? $setProperty_0(lnode, PORT_CONSTRAINTS_0, FREE) : portConstraints != FREE && graphProperties.add_2(($clinit_GraphProperties(), NON_FREE_PORTS));
    portModelOrder = 0;
    direction = castTo($getProperty(lgraph, DIRECTION), 86);
    for(elkport$iterator = new AbstractEList$EIterator((!elknode.ports && (elknode.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, elknode, 9, 9)), elknode.ports)); elkport$iterator.cursor != elkport$iterator.this$01_2.size_1();){
        elkport = castTo($doNext(elkport$iterator), 124);
        elkgraph = $getParent_2(elknode);
        (maskUndefined($getProperty_0(elkgraph, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) || maskUndefined($getProperty_0(elkgraph, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), MODEL_ORDER_0)) || maskUndefined($getProperty_0(elkgraph, CYCLE_BREAKING_STRATEGY_0)) === maskUndefined(($clinit_CycleBreakingStrategy(), GREEDY_MODEL_ORDER)) || $booleanValue(castToBoolean($getProperty_0(elkgraph, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))) || maskUndefined($getProperty_0(elkgraph, CONSIDER_MODEL_ORDER_COMPONENTS_0)) !== maskUndefined(($clinit_ComponentOrderingStrategy(), NONE)) || maskUndefined($getProperty_0(elkgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT)) || maskUndefined($getProperty_0(elkgraph, LAYERING_NODE_PROMOTION_STRATEGY_0)) === maskUndefined(($clinit_NodePromotionStrategy(), MODEL_ORDER_RIGHT_TO_LEFT)) || maskUndefined($getProperty_0(elkgraph, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), BF_MODEL_ORDER)) || maskUndefined($getProperty_0(elkgraph, LAYERING_STRATEGY_0)) === maskUndefined(($clinit_LayeringStrategy(), DF_MODEL_ORDER))) && !$booleanValue(castToBoolean($getProperty_0(elknode, CONSIDER_MODEL_ORDER_NO_MODEL_ORDER_0))) && $setProperty_1(elkport, MODEL_ORDER_1, valueOf_3(portModelOrder++));
        $booleanValue(castToBoolean($getProperty_0(elkport, NO_LAYOUT))) || $transformPort(this$static, elkport, lnode, graphProperties, direction, portConstraints);
    }
    for(elklabel$iterator = new AbstractEList$EIterator((!elknode.labels && (elknode.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elknode, 1, 7)), elknode.labels)); elklabel$iterator.cursor != elklabel$iterator.this$01_2.size_1();){
        elklabel = castTo($doNext(elklabel$iterator), 153);
        !$booleanValue(castToBoolean($getProperty_0(elklabel, NO_LAYOUT))) && !!elklabel.text_0 && $add_3(lnode.labels, $transformLabel(elklabel));
    }
    $booleanValue(castToBoolean($getProperty(lnode, COMMENT_BOX))) && graphProperties.add_2(($clinit_GraphProperties(), COMMENTS));
    if ($booleanValue(castToBoolean($getProperty(lnode, HYPERNODE)))) {
        graphProperties.add_2(($clinit_GraphProperties(), HYPERNODES));
        graphProperties.add_2(HYPEREDGES);
        $setProperty_0(lnode, PORT_CONSTRAINTS_0, FREE);
    }
    return lnode;
}
function $transformPort(this$static, elkport, parentLNode, graphProperties, layoutDirection, portConstraints) {
    var connectionsToDescendants, elklabel, elklabel$iterator, lport, portPos, portSize;
    lport = new LPort;
    $copyProperties(lport, elkport);
    $setSide(lport, castTo($getProperty_0(elkport, ($clinit_LayeredOptions(), PORT_SIDE)), 64));
    $setProperty_0(lport, ($clinit_InternalProperties_1(), ORIGIN_0), elkport);
    $setNode(lport, parentLNode);
    portSize = lport.size_0;
    portSize.x_0 = elkport.width_0;
    portSize.y_0 = elkport.height;
    portPos = lport.pos;
    portPos.x_0 = elkport.x_0;
    portPos.y_0 = elkport.y_0;
    $put_6(this$static.nodeAndPortMap, elkport, lport);
    connectionsToDescendants = $anyMatch($map($flatMap(new StreamImpl(null, (!elkport.outgoingEdges && (elkport.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 7, 4)), new Spliterators$IteratorSpliterator(elkport.outgoingEdges, 16))), new ElkGraphImporter$lambda$2$Type), new ElkGraphImporter$0methodref$connectableShapeToNode$Type), new ElkGraphImporter$lambda$4$Type(elkport));
    connectionsToDescendants || (connectionsToDescendants = $anyMatch($map($flatMap(new StreamImpl(null, (!elkport.incomingEdges && (elkport.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 8, 5)), new Spliterators$IteratorSpliterator(elkport.incomingEdges, 16))), new ElkGraphImporter$lambda$5$Type), new ElkGraphImporter$1methodref$connectableShapeToNode$Type), new ElkGraphImporter$lambda$7$Type(elkport)));
    connectionsToDescendants || (connectionsToDescendants = $anyMatch(new StreamImpl(null, (!elkport.outgoingEdges && (elkport.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, elkport, 7, 4)), new Spliterators$IteratorSpliterator(elkport.outgoingEdges, 16))), new ElkGraphImporter$lambda$8$Type));
    $setProperty_0(lport, INSIDE_CONNECTIONS, ($clinit_Boolean(), connectionsToDescendants ? true : false));
    initializePort(lport, portConstraints, layoutDirection, castTo($getProperty_0(elkport, PORT_ANCHOR), 8));
    for(elklabel$iterator = new AbstractEList$EIterator((!elkport.labels && (elkport.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elkport, 1, 7)), elkport.labels)); elklabel$iterator.cursor != elklabel$iterator.this$01_2.size_1();){
        elklabel = castTo($doNext(elklabel$iterator), 153);
        !$booleanValue(castToBoolean($getProperty_0(elklabel, NO_LAYOUT))) && !!elklabel.text_0 && $add_3(lport.labels, $transformLabel(elklabel));
    }
    switch(layoutDirection.ordinal){
        case 2:
        case 1:
            (lport.side == ($clinit_PortSide(), NORTH_1) || lport.side == SOUTH_0) && graphProperties.add_2(($clinit_GraphProperties(), NORTH_SOUTH_PORTS));
            break;
        case 4:
        case 3:
            (lport.side == ($clinit_PortSide(), EAST_0) || lport.side == WEST_0) && graphProperties.add_2(($clinit_GraphProperties(), NORTH_SOUTH_PORTS));
    }
    return lport;
}
function ElkGraphImporter() {
    this.nodeAndPortMap = new HashMap;
}
function lambda$4_1(elkport_0, targetNode_1) {
    return isDescendant_0(targetNode_1, $getParent_3(elkport_0));
}
function lambda$7(elkport_0, sourceNode_1) {
    return isDescendant_0(sourceNode_1, $getParent_3(elkport_0));
}
function lambda$8(edge_0) {
    return $isSelfloop(edge_0) && $booleanValue(castToBoolean($getProperty_0(edge_0, ($clinit_LayeredOptions(), INSIDE_SELF_LOOPS_YO))));
}
defineClass(1271, 1, {}, ElkGraphImporter);
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter', 1271);
function ElkGraphImporter$0methodref$connectableShapeToNode$Type() {}
defineClass(1275, 1, {}, ElkGraphImporter$0methodref$connectableShapeToNode$Type);
_.apply_0 = function apply_43(arg0) {
    return connectableShapeToNode(castTo(arg0, 84));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$0methodref$connectableShapeToNode$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/0methodref$connectableShapeToNode$Type', 1275);
function ElkGraphImporter$1methodref$connectableShapeToNode$Type() {}
defineClass(1278, 1, {}, ElkGraphImporter$1methodref$connectableShapeToNode$Type);
_.apply_0 = function apply_44(arg0) {
    return connectableShapeToNode(castTo(arg0, 84));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$1methodref$connectableShapeToNode$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/1methodref$connectableShapeToNode$Type', 1278);
function ElkGraphImporter$lambda$0$Type_0(topLevelGraph_1) {
    this.topLevelGraph_1 = topLevelGraph_1;
}
defineClass(1272, 1, $intern_19, ElkGraphImporter$lambda$0$Type_0);
_.accept = function accept_59(arg0) {
    $ensureDefinedPortSide(this.topLevelGraph_1, castTo(arg0, 124));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$0$Type', 1272);
function ElkGraphImporter$lambda$1$Type(finalNestedGraph_1) {
    this.finalNestedGraph_1 = finalNestedGraph_1;
}
defineClass(1273, 1, $intern_19, ElkGraphImporter$lambda$1$Type);
_.accept = function accept_60(arg0) {
    $ensureDefinedPortSide(this.finalNestedGraph_1, castTo(arg0, 124));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$1$Type', 1273);
function ElkGraphImporter$lambda$2$Type() {}
defineClass(1274, 1, {}, ElkGraphImporter$lambda$2$Type);
_.apply_0 = function apply_45(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator($getTargets(castTo(arg0, 85)), 16));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$2$Type', 1274);
function ElkGraphImporter$lambda$4$Type(elkport_0) {
    this.elkport_0 = elkport_0;
}
defineClass(1276, 1, $intern_39, ElkGraphImporter$lambda$4$Type);
_.test_0 = function test_18(arg0) {
    return lambda$4_1(this.elkport_0, castTo(arg0, 27));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$4$Type', 1276);
function ElkGraphImporter$lambda$5$Type() {}
defineClass(1277, 1, {}, ElkGraphImporter$lambda$5$Type);
_.apply_0 = function apply_46(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator($getSources(castTo(arg0, 85)), 16));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$5$Type', 1277);
function ElkGraphImporter$lambda$7$Type(elkport_0) {
    this.elkport_0 = elkport_0;
}
defineClass(1279, 1, $intern_39, ElkGraphImporter$lambda$7$Type);
_.test_0 = function test_19(arg0) {
    return lambda$7(this.elkport_0, castTo(arg0, 27));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$7$Type', 1279);
function ElkGraphImporter$lambda$8$Type() {}
defineClass(1280, 1, $intern_39, ElkGraphImporter$lambda$8$Type);
_.test_0 = function test_20(arg0) {
    return lambda$8(castTo(arg0, 85));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphImporter$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphImporter/lambda$8$Type', 1280);
function $clinit_ElkGraphLayoutTransferrer() {
    $clinit_ElkGraphLayoutTransferrer = emptyMethod;
    ZERO_OFFSET = new KVector;
}
function $applyEdgeLayout(ledge, routing, offset) {
    var bendPoints, edgeOffset, elkedge, elkedgeSection, elklabel, junctionPoints, llabel, llabel$iterator, sourcePoint, sourcePort, targetPoint;
    elkedge = castTo($getProperty(ledge, ($clinit_InternalProperties_1(), ORIGIN_0)), 85);
    if (!elkedge) return;
    bendPoints = ledge.bendPoints;
    edgeOffset = new KVector_2(offset);
    $add_19(edgeOffset, $calculateHierarchicalOffset(ledge));
    if (isDescendant(ledge.target.owner, ledge.source.owner)) {
        sourcePort = ledge.source;
        sourcePoint = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            sourcePort.pos,
            sourcePort.anchor
        ]));
        $sub_0(sourcePoint, offset);
    } else sourcePoint = $getAbsoluteAnchor(ledge.source);
    $addNode_0(bendPoints, sourcePoint, bendPoints.header, bendPoints.header.next_0);
    targetPoint = $getAbsoluteAnchor(ledge.target);
    $getProperty(ledge, TARGET_OFFSET) != null && $add_19(targetPoint, castTo($getProperty(ledge, TARGET_OFFSET), 8));
    $addNode_0(bendPoints, targetPoint, bendPoints.tail.prev, bendPoints.tail);
    $offset_2(bendPoints, edgeOffset);
    elkedgeSection = firstEdgeSection(elkedge);
    $setIncomingShape(elkedgeSection, castTo($get_20((!elkedge.sources && (elkedge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 4, 7)), elkedge.sources), 0), 84));
    $setOutgoingShape(elkedgeSection, castTo($get_20((!elkedge.targets && (elkedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 5, 8)), elkedge.targets), 0), 84));
    applyVectorChain(bendPoints, elkedgeSection);
    for(llabel$iterator = new ArrayList$1(ledge.labels); llabel$iterator.i < llabel$iterator.this$01.array.length;){
        llabel = castTo($next_6(llabel$iterator), 72);
        elklabel = castTo($getProperty(llabel, ORIGIN_0), 153);
        $setWidth_0(elklabel, llabel.size_0.x_0);
        $setHeight_0(elklabel, llabel.size_0.y_0);
        $setLocation_1(elklabel, llabel.pos.x_0 + edgeOffset.x_0, llabel.pos.y_0 + edgeOffset.y_0);
        $setProperty_1(elklabel, ($clinit_LabelDummySwitcher(), INCLUDE_LABEL), castToBoolean($getProperty(llabel, INCLUDE_LABEL)));
    }
    junctionPoints = castTo($getProperty(ledge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
    if (junctionPoints) {
        $offset_2(junctionPoints, edgeOffset);
        $setProperty_1(elkedge, JUNCTION_POINTS, junctionPoints);
    } else $setProperty_1(elkedge, JUNCTION_POINTS, null);
    routing == ($clinit_EdgeRouting(), SPLINES) ? $setProperty_1(elkedge, EDGE_ROUTING, SPLINES) : $setProperty_1(elkedge, EDGE_ROUTING, null);
}
function $applyLayout_1(this$static, lgraph) {
    var edgeList, elkport, graphOrigin, lPadding, ledge, ledge$iterator, lnode, lnode$iterator, lnode$iterator0, nestedGraph, offset, padding, parentElkNode, parentLNode, port, port$iterator, portPosition, routing, sizeOptions;
    graphOrigin = $getProperty(lgraph, ($clinit_InternalProperties_1(), ORIGIN_0));
    if (!instanceOf(graphOrigin, 206)) return;
    parentElkNode = castTo(graphOrigin, 27);
    parentLNode = lgraph.parentNode;
    offset = new KVector_2(lgraph.offset);
    lPadding = lgraph.padding;
    offset.x_0 += lPadding.left;
    offset.y_0 += lPadding.top_0;
    sizeOptions = castTo($getProperty_0(parentElkNode, ($clinit_LayeredOptions(), NODE_SIZE_OPTIONS_1)), 181);
    if ($containsEnum(sizeOptions, ($clinit_SizeOptions(), COMPUTE_PADDING))) {
        padding = castTo($getProperty_0(parentElkNode, PADDING_0), 107);
        $setBottom(padding, lPadding.bottom);
        $setTop(padding, lPadding.top_0);
        $setLeft(padding, lPadding.left);
        $setRight(padding, lPadding.right);
    }
    edgeList = new ArrayList;
    for(lnode$iterator0 = new ArrayList$1(lgraph.layerlessNodes); lnode$iterator0.i < lnode$iterator0.this$01.array.length;){
        lnode = castTo($next_6(lnode$iterator0), 9);
        if (instanceOf($getProperty(lnode, ORIGIN_0), 206)) $applyNodeLayout(lnode, offset);
        else if (instanceOf($getProperty(lnode, ORIGIN_0), 193) && !parentLNode) {
            elkport = castTo($getProperty(lnode, ORIGIN_0), 124);
            portPosition = getExternalPortPosition(lgraph, lnode, elkport.width_0, elkport.height);
            $setLocation_1(elkport, portPosition.x_0, portPosition.y_0);
        }
        for(port$iterator = new ArrayList$1(lnode.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(port.outgoingEdges, 16)), new ElkGraphLayoutTransferrer$lambda$0$Type(lnode)), new ElkGraphLayoutTransferrer$lambda$1$Type(edgeList));
        }
    }
    if (parentLNode) for(port$iterator = new ArrayList$1(parentLNode.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(port.outgoingEdges, 16)), new ElkGraphLayoutTransferrer$lambda$2$Type(parentLNode)), new ElkGraphLayoutTransferrer$lambda$3$Type(edgeList));
    }
    routing = castTo($getProperty_0(parentElkNode, EDGE_ROUTING), 220);
    for(ledge$iterator = new ArrayList$1(edgeList); ledge$iterator.i < ledge$iterator.this$01.array.length;){
        ledge = castTo($next_6(ledge$iterator), 18);
        $applyEdgeLayout(ledge, routing, offset);
    }
    $applyParentNodeLayout(lgraph);
    for(lnode$iterator = new ArrayList$1(lgraph.layerlessNodes); lnode$iterator.i < lnode$iterator.this$01.array.length;){
        lnode = castTo($next_6(lnode$iterator), 9);
        nestedGraph = lnode.nestedGraph;
        !!nestedGraph && $applyLayout_1(this$static, nestedGraph);
    }
}
function $applyNodeLayout(lnode, offset) {
    var elklabel, elknode, elkport, layerID, llabel, llabel$iterator, llabel$iterator0, lport, lport$iterator, lport$iterator0, nf, nodeHasLabelPlacement, nodeID, origin_0;
    elknode = castTo($getProperty(lnode, ($clinit_InternalProperties_1(), ORIGIN_0)), 27);
    nodeID = castTo($getProperty(lnode, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_POSITION_ID_0)), 17).value_0;
    layerID = castTo($getProperty(lnode, LAYERING_LAYER_ID_0), 17).value_0;
    $setProperty_1(elknode, CROSSING_MINIMIZATION_POSITION_ID_0, valueOf_3(nodeID));
    $setProperty_1(elknode, LAYERING_LAYER_ID_0, valueOf_3(layerID));
    $setX_1(elknode, lnode.pos.x_0 + offset.x_0);
    $setY_2(elknode, lnode.pos.y_0 + offset.y_0);
    if (castTo($getProperty_0(elknode, NODE_SIZE_CONSTRAINTS_1), 181).size_1() != 0 || !!lnode.nestedGraph || maskUndefined($getProperty($getGraph(lnode), NODE_PLACEMENT_STRATEGY_0)) === maskUndefined(($clinit_NodePlacementStrategy(), NETWORK_SIMPLEX_0)) && $isFlexibleSizeWhereSpacePermits(($clinit_NodeFlexibility(), (!lnode.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : lnode.propertyMap).containsKey(NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0) ? nf = castTo($getProperty(lnode, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0), 203) : nf = castTo($getProperty($getGraph(lnode), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0), 203), nf))) {
        $setWidth_0(elknode, lnode.size_0.x_0);
        $setHeight_0(elknode, lnode.size_0.y_0);
    }
    for(lport$iterator0 = new ArrayList$1(lnode.ports); lport$iterator0.i < lport$iterator0.this$01.array.length;){
        lport = castTo($next_6(lport$iterator0), 11);
        origin_0 = $getProperty(lport, ORIGIN_0);
        if (instanceOf(origin_0, 193)) {
            elkport = castTo(origin_0, 124);
            $setLocation_1(elkport, lport.pos.x_0, lport.pos.y_0);
            $setProperty_1(elkport, PORT_SIDE, lport.side);
        }
    }
    nodeHasLabelPlacement = castTo($getProperty(lnode, NODE_LABELS_PLACEMENT_1), 181).size_1() != 0;
    for(llabel$iterator0 = new ArrayList$1(lnode.labels); llabel$iterator0.i < llabel$iterator0.this$01.array.length;){
        llabel = castTo($next_6(llabel$iterator0), 72);
        if (nodeHasLabelPlacement || castTo($getProperty(llabel, NODE_LABELS_PLACEMENT_1), 181).size_1() != 0) {
            elklabel = castTo($getProperty(llabel, ORIGIN_0), 153);
            $setDimensions(elklabel, llabel.size_0.x_0, llabel.size_0.y_0);
            $setLocation_1(elklabel, llabel.pos.x_0, llabel.pos.y_0);
        }
    }
    if (!isFixed(castTo($getProperty(lnode, PORT_LABELS_PLACEMENT_1), 22))) for(lport$iterator = new ArrayList$1(lnode.ports); lport$iterator.i < lport$iterator.this$01.array.length;){
        lport = castTo($next_6(lport$iterator), 11);
        for(llabel$iterator = new ArrayList$1(lport.labels); llabel$iterator.i < llabel$iterator.this$01.array.length;){
            llabel = castTo($next_6(llabel$iterator), 72);
            elklabel = castTo($getProperty(llabel, ORIGIN_0), 153);
            $setWidth_0(elklabel, llabel.size_0.x_0);
            $setHeight_0(elklabel, llabel.size_0.y_0);
            $setLocation_1(elklabel, llabel.pos.x_0, llabel.pos.y_0);
        }
    }
}
function $applyParentNodeLayout(lgraph) {
    var actualGraphSize, all, elknode, graphProps, sizeConstraintsIncludedPortLabels;
    elknode = castTo($getProperty(lgraph, ($clinit_InternalProperties_1(), ORIGIN_0)), 27);
    sizeConstraintsIncludedPortLabels = castTo($getProperty_0(elknode, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1)), 181).contains(($clinit_SizeConstraint(), PORT_LABELS));
    if (!lgraph.parentNode) {
        graphProps = castTo($getProperty(lgraph, GRAPH_PROPERTIES), 22);
        actualGraphSize = new KVector_1(lgraph.size_0.x_0 + lgraph.padding.left + lgraph.padding.right, lgraph.size_0.y_0 + lgraph.padding.top_0 + lgraph.padding.bottom);
        if (graphProps.contains(($clinit_GraphProperties(), EXTERNAL_PORTS))) {
            $setProperty_1(elknode, PORT_CONSTRAINTS_0, ($clinit_PortConstraints(), FIXED_POS));
            resizeNode_1(elknode, actualGraphSize.x_0, actualGraphSize.y_0, false, true);
        } else $booleanValue(castToBoolean($getProperty_0(elknode, NODE_SIZE_FIXED_GRAPH_SIZE_0))) || resizeNode_1(elknode, actualGraphSize.x_0, actualGraphSize.y_0, true, true);
    }
    sizeConstraintsIncludedPortLabels ? $setProperty_1(elknode, NODE_SIZE_CONSTRAINTS_1, of_1(PORT_LABELS)) : $setProperty_1(elknode, NODE_SIZE_CONSTRAINTS_1, (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)));
}
function $calculateHierarchicalOffset(ledge) {
    var currentGraph, representingNode, result, targetCoordinateSystem;
    targetCoordinateSystem = castTo($getProperty(ledge, ($clinit_InternalProperties_1(), COORDINATE_SYSTEM_ORIGIN)), 36);
    if (targetCoordinateSystem) {
        result = new KVector;
        currentGraph = $getGraph(ledge.source.owner);
        while(currentGraph != targetCoordinateSystem){
            representingNode = currentGraph.parentNode;
            currentGraph = $getGraph(representingNode);
            $add_18($add_19($add_19(result, representingNode.pos), currentGraph.offset), currentGraph.padding.left, currentGraph.padding.top_0);
        }
        return result;
    }
    return ZERO_OFFSET;
}
function ElkGraphLayoutTransferrer() {
    $clinit_ElkGraphLayoutTransferrer();
}
function lambda$0_23(lnode_0, edge_1) {
    $clinit_ElkGraphLayoutTransferrer();
    return !isDescendant(edge_1.target.owner, lnode_0);
}
function lambda$2_2(parentLNode_0, edge_1) {
    $clinit_ElkGraphLayoutTransferrer();
    return isDescendant(edge_1.target.owner, parentLNode_0);
}
defineClass(1250, 1, {}, ElkGraphLayoutTransferrer);
var ZERO_OFFSET;
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphLayoutTransferrer_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphLayoutTransferrer', 1250);
function ElkGraphLayoutTransferrer$lambda$0$Type(lnode_0) {
    this.lnode_0 = lnode_0;
}
defineClass(1251, 1, $intern_39, ElkGraphLayoutTransferrer$lambda$0$Type);
_.test_0 = function test_21(arg0) {
    return lambda$0_23(this.lnode_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphLayoutTransferrer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphLayoutTransferrer/lambda$0$Type', 1251);
function ElkGraphLayoutTransferrer$lambda$1$Type(edgeList_0) {
    this.edgeList_0 = edgeList_0;
}
defineClass(1252, 1, $intern_19, ElkGraphLayoutTransferrer$lambda$1$Type);
_.accept = function accept_61(arg0) {
    $clinit_ElkGraphLayoutTransferrer();
    $add_3(this.edgeList_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphLayoutTransferrer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphLayoutTransferrer/lambda$1$Type', 1252);
function ElkGraphLayoutTransferrer$lambda$2$Type(parentLNode_0) {
    this.parentLNode_0 = parentLNode_0;
}
defineClass(1253, 1, $intern_39, ElkGraphLayoutTransferrer$lambda$2$Type);
_.test_0 = function test_22(arg0) {
    return lambda$2_2(this.parentLNode_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphLayoutTransferrer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphLayoutTransferrer/lambda$2$Type', 1253);
function ElkGraphLayoutTransferrer$lambda$3$Type(edgeList_0) {
    this.edgeList_0 = edgeList_0;
}
defineClass(1254, 1, $intern_19, ElkGraphLayoutTransferrer$lambda$3$Type);
_.accept = function accept_62(arg0) {
    $clinit_ElkGraphLayoutTransferrer();
    $add_3(this.edgeList_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_graph_transform_ElkGraphLayoutTransferrer$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.graph.transform', 'ElkGraphLayoutTransferrer/lambda$3$Type', 1254);
function getIdentifier(element) {
    var container, id_0, parentId;
    id_0 = element.getIdentifier();
    if (id_0) {
        container = element.eContainer_0();
        if (instanceOf(container, 173)) {
            parentId = getIdentifier(castTo(container, 173));
            if (parentId != null) return parentId + '.' + id_0;
        }
        return id_0;
    }
    return null;
}
function getOriginIdentifier(element) {
    var origin_0;
    origin_0 = $getProperty(element, ($clinit_InternalProperties_1(), ORIGIN_0));
    if (instanceOf(origin_0, 173)) return getIdentifier(castTo(origin_0, 173));
    return null;
}
function $getKey_0(this$static, value_0) {
    return castTo($get_16(this$static.hashMapValuesToKey, value_0), 34);
}
function $getValues(this$static, key) {
    var toReturn;
    toReturn = castTo($get_16(this$static.multiMapKeyToValues, key), 67);
    !toReturn && (toReturn = new LinkedList);
    return toReturn;
}
function $isMaximalKey(this$static, key) {
    var entry, otherKey, otherKey$iterator, outerIter;
    for(otherKey$iterator = (outerIter = new AbstractMap$1(this$static.multiMapKeyToValues).this$01.entrySet_0().iterator_0(), new AbstractMap$1$1(outerIter)); otherKey$iterator.val$outerIter2.hasNext_0();){
        otherKey = (entry = castTo(otherKey$iterator.val$outerIter2.next_1(), 43), castTo(entry.getKey(), 34));
        if ($compareTo_6(key, castTo(otherKey, 17)) < 0) return false;
    }
    return true;
}
function $isMinimalKey(this$static, key) {
    var entry, otherKey, otherKey$iterator, outerIter;
    for(otherKey$iterator = (outerIter = new AbstractMap$1(this$static.multiMapKeyToValues).this$01.entrySet_0().iterator_0(), new AbstractMap$1$1(outerIter)); otherKey$iterator.val$outerIter2.hasNext_0();){
        otherKey = (entry = castTo(otherKey$iterator.val$outerIter2.next_1(), 43), castTo(entry.getKey(), 34));
        if ($compareTo_6(key, castTo(otherKey, 17)) > 0) return false;
    }
    return true;
}
function $put_13(this$static, key, value_0) {
    var oldKey, values, values0;
    oldKey = castTo($get_16(this$static.hashMapValuesToKey, value_0), 34);
    if (oldKey != null) {
        values0 = castTo($get_16(this$static.multiMapKeyToValues, oldKey), 67);
        $advanceToFind(values0, value_0, true);
    }
    values = castTo($get_16(this$static.multiMapKeyToValues, key), 67);
    if (!values) {
        values = new LinkedList;
        $put_11(this$static.multiMapKeyToValues, key, values);
    }
    $addNode_0(values, value_0, values.tail.prev, values.tail);
    $put_11(this$static.hashMapValuesToKey, value_0, key);
}
function $putAll_0(this$static, key, values) {
    var value_0, value$iterator;
    for(value$iterator = new ArrayList$1(values); value$iterator.i < value$iterator.this$01.array.length;){
        value_0 = $next_6(value$iterator);
        $put_13(this$static, key, value_0);
    }
}
function BiLinkedHashMultiMap() {
    this.multiMapKeyToValues = new LinkedHashMap;
    this.hashMapValuesToKey = new LinkedHashMap;
}
defineClass(799, 1, {}, BiLinkedHashMultiMap);
var Lorg_eclipse_elk_alg_layered_intermediate_BiLinkedHashMultiMap_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'BiLinkedHashMultiMap', 799);
function $process_2(layeredGraph, monitor) {
    monitor.begin('Node margin calculation', 1);
    $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(layeredGraph.layers, 16)), new CommentNodeMarginCalculator$lambda$0$Type), new CommentNodeMarginCalculator$lambda$1$Type);
    monitor.done_1();
}
function $processComments(node) {
    var bottomBoxes, bottomWidth, commentBox, commentBox$iterator, commentCommentSpacing, commentNodeSpacing, margin, maxCommentWidth, maxHeight, protrusion, topBoxes, topWidth;
    margin = node.margin;
    topBoxes = castTo($getProperty(node, ($clinit_InternalProperties_1(), TOP_COMMENTS)), 15);
    bottomBoxes = castTo($getProperty(node, BOTTOM_COMMENTS), 15);
    if (!topBoxes && !bottomBoxes) return;
    commentCommentSpacing = $doubleValue(castToDouble(getIndividualOrDefault(node, ($clinit_LayeredOptions(), SPACING_COMMENT_COMMENT))));
    commentNodeSpacing = $doubleValue(castToDouble(getIndividualOrDefault(node, SPACING_COMMENT_NODE)));
    topWidth = 0;
    if (topBoxes) {
        maxHeight = 0;
        for(commentBox$iterator = topBoxes.iterator_0(); commentBox$iterator.hasNext_0();){
            commentBox = castTo(commentBox$iterator.next_1(), 9);
            maxHeight = $wnd.Math.max(maxHeight, commentBox.size_0.y_0);
            topWidth += commentBox.size_0.x_0;
        }
        topWidth += commentCommentSpacing * (topBoxes.size_1() - 1);
        margin.top_0 += maxHeight + commentNodeSpacing;
    }
    bottomWidth = 0;
    if (bottomBoxes) {
        maxHeight = 0;
        for(commentBox$iterator = bottomBoxes.iterator_0(); commentBox$iterator.hasNext_0();){
            commentBox = castTo(commentBox$iterator.next_1(), 9);
            maxHeight = $wnd.Math.max(maxHeight, commentBox.size_0.y_0);
            bottomWidth += commentBox.size_0.x_0;
        }
        bottomWidth += commentCommentSpacing * (bottomBoxes.size_1() - 1);
        margin.bottom += maxHeight + commentNodeSpacing;
    }
    maxCommentWidth = $wnd.Math.max(topWidth, bottomWidth);
    if (maxCommentWidth > node.size_0.x_0) {
        protrusion = (maxCommentWidth - node.size_0.x_0) / 2;
        margin.left = $wnd.Math.max(margin.left, protrusion);
        margin.right = $wnd.Math.max(margin.right, protrusion);
    }
}
function CommentNodeMarginCalculator() {}
defineClass(1490, 1, $intern_102, CommentNodeMarginCalculator);
_.process = function process_1(layeredGraph, monitor) {
    $process_2(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_CommentNodeMarginCalculator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'CommentNodeMarginCalculator', 1490);
function CommentNodeMarginCalculator$lambda$0$Type() {}
defineClass(1491, 1, {}, CommentNodeMarginCalculator$lambda$0$Type);
_.apply_0 = function apply_47(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_CommentNodeMarginCalculator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'CommentNodeMarginCalculator/lambda$0$Type', 1491);
function CommentNodeMarginCalculator$lambda$1$Type() {}
defineClass(1492, 1, $intern_19, CommentNodeMarginCalculator$lambda$1$Type);
_.accept = function accept_63(arg0) {
    $processComments(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_CommentNodeMarginCalculator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'CommentNodeMarginCalculator/lambda$1$Type', 1492);
function $getBoxPort(commentBox) {
    var edge, edge$iterator, edge$iterator0, nodePort, port, port$iterator;
    nodePort = castTo($getProperty(commentBox, ($clinit_InternalProperties_1(), COMMENT_CONN_PORT)), 11);
    for(port$iterator = new ArrayList$1(commentBox.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        for(edge$iterator0 = new ArrayList$1(port.outgoingEdges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
            edge = castTo($next_6(edge$iterator0), 18);
            $setTarget_0(edge, nodePort);
            return port;
        }
        for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            $setSource_0(edge, nodePort);
            return port;
        }
    }
    return null;
}
function $process_3(layeredGraph, monitor) {
    var bottomBoxes, boxes, layer, layer$iterator, node, node$iterator, topBoxes;
    monitor.begin('Comment post-processing', 1);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        boxes = new ArrayList;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            topBoxes = castTo($getProperty(node, ($clinit_InternalProperties_1(), TOP_COMMENTS)), 15);
            bottomBoxes = castTo($getProperty(node, BOTTOM_COMMENTS), 15);
            if (!!topBoxes || !!bottomBoxes) {
                $process_4(node, topBoxes, bottomBoxes);
                !!topBoxes && $addAll_2(boxes, topBoxes);
                !!bottomBoxes && $addAll_2(boxes, bottomBoxes);
            }
        }
        $addAll_2(layer.nodes, boxes);
    }
    monitor.done_1();
}
function $process_4(node, topBoxes, bottomBoxes) {
    var anchorInc, anchorX, baseLine, box, box$iterator, box$iterator0, boxPort, boxesWidth, commentCommentSpacing, margin, maxHeight, nodePort, nodePos, nodeSize, x_0;
    nodePos = node.pos;
    nodeSize = node.size_0;
    margin = node.margin;
    commentCommentSpacing = $doubleValue(castToDouble(getIndividualOrDefault(node, ($clinit_LayeredOptions(), SPACING_COMMENT_COMMENT))));
    if (topBoxes) {
        boxesWidth = commentCommentSpacing * (topBoxes.size_1() - 1);
        maxHeight = 0;
        for(box$iterator0 = topBoxes.iterator_0(); box$iterator0.hasNext_0();){
            box = castTo(box$iterator0.next_1(), 9);
            boxesWidth += box.size_0.x_0;
            maxHeight = $wnd.Math.max(maxHeight, box.size_0.y_0);
        }
        x_0 = nodePos.x_0 - (boxesWidth - nodeSize.x_0) / 2;
        baseLine = nodePos.y_0 - margin.top_0 + maxHeight;
        anchorInc = nodeSize.x_0 / (topBoxes.size_1() + 1);
        anchorX = anchorInc;
        for(box$iterator = topBoxes.iterator_0(); box$iterator.hasNext_0();){
            box = castTo(box$iterator.next_1(), 9);
            box.pos.x_0 = x_0;
            box.pos.y_0 = baseLine - box.size_0.y_0;
            x_0 += box.size_0.x_0 + commentCommentSpacing;
            boxPort = $getBoxPort(box);
            boxPort.pos.x_0 = box.size_0.x_0 / 2 - boxPort.anchor.x_0;
            boxPort.pos.y_0 = box.size_0.y_0;
            nodePort = castTo($getProperty(box, ($clinit_InternalProperties_1(), COMMENT_CONN_PORT)), 11);
            if (nodePort.incomingEdges.array.length + nodePort.outgoingEdges.array.length == 1) {
                nodePort.pos.x_0 = anchorX - nodePort.anchor.x_0;
                nodePort.pos.y_0 = 0;
                $setNode(nodePort, node);
            }
            anchorX += anchorInc;
        }
    }
    if (bottomBoxes) {
        boxesWidth = commentCommentSpacing * (bottomBoxes.size_1() - 1);
        maxHeight = 0;
        for(box$iterator0 = bottomBoxes.iterator_0(); box$iterator0.hasNext_0();){
            box = castTo(box$iterator0.next_1(), 9);
            boxesWidth += box.size_0.x_0;
            maxHeight = $wnd.Math.max(maxHeight, box.size_0.y_0);
        }
        x_0 = nodePos.x_0 - (boxesWidth - nodeSize.x_0) / 2;
        baseLine = nodePos.y_0 + nodeSize.y_0 + margin.bottom - maxHeight;
        anchorInc = nodeSize.x_0 / (bottomBoxes.size_1() + 1);
        anchorX = anchorInc;
        for(box$iterator = bottomBoxes.iterator_0(); box$iterator.hasNext_0();){
            box = castTo(box$iterator.next_1(), 9);
            box.pos.x_0 = x_0;
            box.pos.y_0 = baseLine;
            x_0 += box.size_0.x_0 + commentCommentSpacing;
            boxPort = $getBoxPort(box);
            boxPort.pos.x_0 = box.size_0.x_0 / 2 - boxPort.anchor.x_0;
            boxPort.pos.y_0 = 0;
            nodePort = castTo($getProperty(box, ($clinit_InternalProperties_1(), COMMENT_CONN_PORT)), 11);
            if (nodePort.incomingEdges.array.length + nodePort.outgoingEdges.array.length == 1) {
                nodePort.pos.x_0 = anchorX - nodePort.anchor.x_0;
                nodePort.pos.y_0 = nodeSize.y_0;
                $setNode(nodePort, node);
            }
            anchorX += anchorInc;
        }
    }
}
function CommentPostprocessor() {}
defineClass(1493, 1, $intern_102, CommentPostprocessor);
_.process = function process_2(layeredGraph, monitor) {
    $process_3(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_CommentPostprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'CommentPostprocessor', 1493);
function $process_5(layeredGraph, monitor) {
    var commentBoxCount, edge, edgeCount, inedge, inedge$iterator, node, nodeIter, oppositePort, outedge, outedge$iterator, port, port$iterator, port$iterator0, re, re$iterator, revEdges;
    monitor.begin('Comment pre-processing', 1);
    commentBoxCount = 0;
    nodeIter = new ArrayList$1(layeredGraph.layerlessNodes);
    while(nodeIter.i < nodeIter.this$01.array.length){
        node = castTo($next_6(nodeIter), 9);
        if ($booleanValue(castToBoolean($getProperty(node, ($clinit_LayeredOptions(), COMMENT_BOX))))) {
            ++commentBoxCount;
            edgeCount = 0;
            edge = null;
            oppositePort = null;
            for(port$iterator0 = new ArrayList$1(node.ports); port$iterator0.i < port$iterator0.this$01.array.length;){
                port = castTo($next_6(port$iterator0), 11);
                edgeCount += port.incomingEdges.array.length + port.outgoingEdges.array.length;
                if (port.incomingEdges.array.length == 1) {
                    edge = castTo($get_11(port.incomingEdges, 0), 18);
                    oppositePort = edge.source;
                }
                if (port.outgoingEdges.array.length == 1) {
                    edge = castTo($get_11(port.outgoingEdges, 0), 18);
                    oppositePort = edge.target;
                }
            }
            if (edgeCount == 1 && oppositePort.incomingEdges.array.length + oppositePort.outgoingEdges.array.length == 1 && !$booleanValue(castToBoolean($getProperty(oppositePort.owner, COMMENT_BOX)))) {
                $processBox(node, edge, oppositePort, oppositePort.owner);
                $remove_13(nodeIter);
            } else {
                revEdges = new ArrayList;
                for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                    port = castTo($next_6(port$iterator), 11);
                    for(outedge$iterator = new ArrayList$1(port.outgoingEdges); outedge$iterator.i < outedge$iterator.this$01.array.length;){
                        outedge = castTo($next_6(outedge$iterator), 18);
                        outedge.target.outgoingEdges.array.length == 0 || push_1(revEdges.array, outedge);
                    }
                    for(inedge$iterator = new ArrayList$1(port.incomingEdges); inedge$iterator.i < inedge$iterator.this$01.array.length;){
                        inedge = castTo($next_6(inedge$iterator), 18);
                        inedge.source.incomingEdges.array.length == 0 || push_1(revEdges.array, inedge);
                    }
                }
                for(re$iterator = new ArrayList$1(revEdges); re$iterator.i < re$iterator.this$01.array.length;){
                    re = castTo($next_6(re$iterator), 18);
                    $reverse_0(re, true);
                }
            }
        }
    }
    monitor.isLoggingEnabled() && monitor.log_0('Found ' + commentBoxCount + ' comment boxes');
    monitor.done_1();
}
function $processBox(box, edge, oppositePort, realNode) {
    var bottomBoxes, boxList, hasNorth, hasSouth, label_0, label$iterator, labelPos, onlyBottom, onlyTop, port1, port1$iterator, port2, port2$iterator, topBoxes, topFirst;
    onlyTop = false;
    onlyBottom = false;
    if ($isSideFixed(castTo($getProperty(realNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100))) {
        hasNorth = false;
        hasSouth = false;
        portLoop: for(port1$iterator = new ArrayList$1(realNode.ports); port1$iterator.i < port1$iterator.this$01.array.length;){
            port1 = castTo($next_6(port1$iterator), 11);
            for(port2$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                new LPort$1(port1),
                new LPort$2(port1)
            ]))); $hasNext_1(port2$iterator);){
                port2 = castTo($next_0(port2$iterator), 11);
                if (!$booleanValue(castToBoolean($getProperty(port2.owner, COMMENT_BOX)))) {
                    if (port1.side == ($clinit_PortSide(), NORTH_1)) {
                        hasNorth = true;
                        break portLoop;
                    }
                    if (port1.side == SOUTH_0) {
                        hasSouth = true;
                        break portLoop;
                    }
                }
            }
        }
        onlyTop = hasSouth && !hasNorth;
        onlyBottom = hasNorth && !hasSouth;
    }
    if (!onlyTop && !onlyBottom && realNode.labels.array.length != 0) {
        labelPos = 0;
        for(label$iterator = new ArrayList$1(realNode.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            labelPos += label_0.pos.y_0 + label_0.size_0.y_0 / 2;
        }
        labelPos /= realNode.labels.array.length;
        topFirst = labelPos >= realNode.size_0.y_0 / 2;
    } else topFirst = !onlyBottom;
    if (topFirst) {
        topBoxes = castTo($getProperty(realNode, ($clinit_InternalProperties_1(), TOP_COMMENTS)), 15);
        if (!topBoxes) {
            boxList = new ArrayList;
            $setProperty_0(realNode, TOP_COMMENTS, boxList);
        } else if (onlyTop) boxList = topBoxes;
        else {
            bottomBoxes = castTo($getProperty(realNode, BOTTOM_COMMENTS), 15);
            if (!bottomBoxes) {
                boxList = new ArrayList;
                $setProperty_0(realNode, BOTTOM_COMMENTS, boxList);
            } else topBoxes.size_1() <= bottomBoxes.size_1() ? boxList = topBoxes : boxList = bottomBoxes;
        }
    } else {
        bottomBoxes = castTo($getProperty(realNode, ($clinit_InternalProperties_1(), BOTTOM_COMMENTS)), 15);
        if (!bottomBoxes) {
            boxList = new ArrayList;
            $setProperty_0(realNode, BOTTOM_COMMENTS, boxList);
        } else if (onlyBottom) boxList = bottomBoxes;
        else {
            topBoxes = castTo($getProperty(realNode, TOP_COMMENTS), 15);
            if (!topBoxes) {
                boxList = new ArrayList;
                $setProperty_0(realNode, TOP_COMMENTS, boxList);
            } else bottomBoxes.size_1() <= topBoxes.size_1() ? boxList = bottomBoxes : boxList = topBoxes;
        }
    }
    boxList.add_2(box);
    $setProperty_0(box, ($clinit_InternalProperties_1(), COMMENT_CONN_PORT), oppositePort);
    if (edge.target == oppositePort) {
        $setTarget_0(edge, null);
        oppositePort.incomingEdges.array.length + oppositePort.outgoingEdges.array.length == 0 && $setNode(oppositePort, null);
        $removeHierarchicalPortDummyNode(oppositePort);
    } else {
        $setSource_0(edge, null);
        oppositePort.incomingEdges.array.length + oppositePort.outgoingEdges.array.length == 0 && $setNode(oppositePort, null);
    }
    $reset_0(edge.bendPoints);
}
function $removeHierarchicalPortDummyNode(oppositePort) {
    var dummy, layer;
    dummy = castTo($getProperty(oppositePort, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
    if (dummy) {
        layer = dummy.layer;
        $remove_12(layer.nodes, dummy);
        layer.nodes.array.length == 0 && $remove_12($getGraph(dummy).layers, layer);
    }
}
function CommentPreprocessor() {}
defineClass(1494, 1, $intern_102, CommentPreprocessor);
_.process = function process_3(layeredGraph, monitor) {
    $process_5(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_CommentPreprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'CommentPreprocessor', 1494);
function $process_6(graph, progressMonitor) {
    var currentNode, currentNode$iterator, layer, layer$iterator, layerIndex, nodeLayer, posIndex;
    progressMonitor.begin('Constraints Postprocessor', 1);
    layerIndex = 0;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        posIndex = 0;
        nodeLayer = false;
        for(currentNode$iterator = new ArrayList$1(layer.nodes); currentNode$iterator.i < currentNode$iterator.this$01.array.length;){
            currentNode = castTo($next_6(currentNode$iterator), 9);
            if (currentNode.type_0 == ($clinit_LNode$NodeType(), NORMAL)) {
                nodeLayer = true;
                $setProperty_0(currentNode, ($clinit_LayeredOptions(), LAYERING_LAYER_ID_0), valueOf_3(layerIndex));
                $setProperty_0(currentNode, CROSSING_MINIMIZATION_POSITION_ID_0, valueOf_3(posIndex));
                ++posIndex;
            }
        }
        nodeLayer && ++layerIndex;
    }
    progressMonitor.done_1();
}
function ConstraintsPostprocessor() {}
defineClass(1495, 1, $intern_102, ConstraintsPostprocessor);
_.process = function process_4(graph, progressMonitor) {
    $process_6(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_ConstraintsPostprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'ConstraintsPostprocessor', 1495);
function $canReverseIncomingEdge(targetNodeLayerConstraint, edge) {
    var sourceLayerConstraint, sourceNode;
    if ($booleanValue(castToBoolean($getProperty(edge, ($clinit_InternalProperties_1(), REVERSED))))) return false;
    sourceNode = edge.source.owner;
    if (targetNodeLayerConstraint == ($clinit_LayerConstraint(), FIRST)) {
        if (sourceNode.type_0 == ($clinit_LNode$NodeType(), LABEL)) return false;
    }
    sourceLayerConstraint = castTo($getProperty(sourceNode, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
    if (sourceLayerConstraint == FIRST_SEPARATE_0) return false;
    return true;
}
function $canReverseOutgoingEdge(sourceNodeLayerConstraint, edge) {
    var targetLayerConstraint, targetNode;
    if ($booleanValue(castToBoolean($getProperty(edge, ($clinit_InternalProperties_1(), REVERSED))))) return false;
    targetNode = edge.target.owner;
    if (sourceNodeLayerConstraint == ($clinit_LayerConstraint(), LAST)) {
        if (targetNode.type_0 == ($clinit_LNode$NodeType(), LABEL)) return false;
    }
    targetLayerConstraint = castTo($getProperty(targetNode, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
    if (targetLayerConstraint == LAST_SEPARATE_0) return false;
    return true;
}
function $handleInnerNodes(remainingNodes) {
    var allPortsReversed, e, e$iterator, e$iterator0, edgeConstraint, layerConstraint, lc, node, node$iterator, port, port$iterator;
    for(node$iterator = new ArrayList$1(remainingNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        layerConstraint = castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
        edgeConstraint = null;
        switch(layerConstraint.ordinal){
            case 1:
            case 2:
                edgeConstraint = ($clinit_EdgeConstraint(), OUTGOING_ONLY);
                break;
            case 3:
            case 4:
                edgeConstraint = ($clinit_EdgeConstraint(), INCOMING_ONLY);
        }
        if (edgeConstraint) {
            $setProperty_0(node, ($clinit_InternalProperties_1(), EDGE_CONSTRAINT), ($clinit_EdgeConstraint(), OUTGOING_ONLY));
            edgeConstraint == INCOMING_ONLY ? $reverseEdges(node, layerConstraint, ($clinit_PortType(), INPUT)) : edgeConstraint == OUTGOING_ONLY && $reverseEdges(node, layerConstraint, ($clinit_PortType(), OUTPUT));
        } else if ($isSideFixed(castTo($getProperty(node, PORT_CONSTRAINTS_0), 100)) && node.ports.array.length != 0) {
            allPortsReversed = true;
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                if (!(port.side == ($clinit_PortSide(), EAST_0) && port.incomingEdges.array.length - port.outgoingEdges.array.length > 0 || port.side == WEST_0 && port.incomingEdges.array.length - port.outgoingEdges.array.length < 0)) {
                    allPortsReversed = false;
                    break;
                }
                for(e$iterator0 = new ArrayList$1(port.outgoingEdges); e$iterator0.i < e$iterator0.this$01.array.length;){
                    e = castTo($next_6(e$iterator0), 18);
                    lc = castTo($getProperty(e.target.owner, LAYERING_LAYER_CONSTRAINT_0), 171);
                    if (lc == ($clinit_LayerConstraint(), LAST) || lc == LAST_SEPARATE_0) {
                        allPortsReversed = false;
                        break;
                    }
                }
                for(e$iterator = new ArrayList$1(port.incomingEdges); e$iterator.i < e$iterator.this$01.array.length;){
                    e = castTo($next_6(e$iterator), 18);
                    lc = castTo($getProperty(e.source.owner, LAYERING_LAYER_CONSTRAINT_0), 171);
                    if (lc == ($clinit_LayerConstraint(), FIRST) || lc == FIRST_SEPARATE_0) {
                        allPortsReversed = false;
                        break;
                    }
                }
            }
            allPortsReversed && $reverseEdges(node, layerConstraint, ($clinit_PortType(), UNDEFINED_0));
        }
    }
}
function $handleOuterNodes(layeredGraph) {
    var edgeConstraint, layerConstraint, node, node$iterator, remainingNodes;
    remainingNodes = new ArrayList_0(layeredGraph.layerlessNodes.array.length);
    for(node$iterator = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        layerConstraint = castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
        edgeConstraint = null;
        switch(layerConstraint.ordinal){
            case 1:
            case 2:
                edgeConstraint = ($clinit_EdgeConstraint(), OUTGOING_ONLY);
                break;
            case 3:
            case 4:
                edgeConstraint = ($clinit_EdgeConstraint(), INCOMING_ONLY);
        }
        if (edgeConstraint) {
            $setProperty_0(node, ($clinit_InternalProperties_1(), EDGE_CONSTRAINT), ($clinit_EdgeConstraint(), OUTGOING_ONLY));
            edgeConstraint == INCOMING_ONLY ? $reverseEdges(node, layerConstraint, ($clinit_PortType(), INPUT)) : edgeConstraint == OUTGOING_ONLY && $reverseEdges(node, layerConstraint, ($clinit_PortType(), OUTPUT));
        } else push_1(remainingNodes.array, node);
    }
    return remainingNodes;
}
function $process_7(layeredGraph, monitor) {
    var remainingNodes;
    monitor.begin('Edge and layer constraint edge reversal', 1);
    remainingNodes = $handleOuterNodes(layeredGraph);
    $handleInnerNodes(remainingNodes);
    monitor.done_1();
}
function $reverseEdges(node, nodeLayerConstraint, targetPortType) {
    var edge, edge$array, edge$index, edge$max, incoming, outgoing, port, port$array, port$index, port$max;
    for(port$array = toPortArray(node.ports), port$index = 0, port$max = port$array.length; port$index < port$max; ++port$index){
        port = port$array[port$index];
        if (targetPortType == ($clinit_PortType(), INPUT) || targetPortType == UNDEFINED_0) {
            outgoing = toEdgeArray(port.outgoingEdges);
            for(edge$array = outgoing, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                edge = edge$array[edge$index];
                $canReverseOutgoingEdge(nodeLayerConstraint, edge) && $reverse_0(edge, true);
            }
        }
        if (targetPortType == OUTPUT || targetPortType == UNDEFINED_0) {
            incoming = toEdgeArray(port.incomingEdges);
            for(edge$array = incoming, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                edge = edge$array[edge$index];
                $canReverseIncomingEdge(nodeLayerConstraint, edge) && $reverse_0(edge, true);
            }
        }
    }
}
function EdgeAndLayerConstraintEdgeReverser() {}
defineClass(1496, 1, $intern_102, EdgeAndLayerConstraintEdgeReverser);
_.process = function process_5(layeredGraph, monitor) {
    $process_7(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_EdgeAndLayerConstraintEdgeReverser_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EdgeAndLayerConstraintEdgeReverser', 1496);
function $process_8(layeredGraph, monitor) {
    monitor.begin('End label post-processing', 1);
    $forEach_3($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(layeredGraph.layers, 16)), new EndLabelPostprocessor$lambda$0$Type), new EndLabelPostprocessor$lambda$1$Type), new EndLabelPostprocessor$lambda$2$Type);
    monitor.done_1();
}
function $processNode_1(node) {
    var endLabelCells, labelCell, labelCell$iterator, labelCellRect, nodePos;
    endLabelCells = castTo($getProperty(node, ($clinit_InternalProperties_1(), END_LABELS_0)), 91);
    nodePos = node.pos;
    for(labelCell$iterator = endLabelCells.values_0().iterator_0(); labelCell$iterator.hasNext_0();){
        labelCell = castTo(labelCell$iterator.next_1(), 315);
        labelCellRect = labelCell.cellRectangle;
        labelCellRect.x_0 += nodePos.x_0;
        labelCellRect.y_0 += nodePos.y_0;
        labelCell.horizontalLayoutMode ? $applyHorizontalModeLabelLayout(labelCell) : $applyVerticalModeLabelLayout(labelCell);
    }
    $setProperty_0(node, END_LABELS_0, null);
}
function EndLabelPostprocessor() {}
function lambda$1_7(node_0) {
    return (node_0.type_0 == ($clinit_LNode$NodeType(), NORMAL) || node_0.type_0 == EXTERNAL_PORT) && $hasProperty(node_0, ($clinit_InternalProperties_1(), END_LABELS_0));
}
defineClass(1497, 1, $intern_102, EndLabelPostprocessor);
_.process = function process_6(layeredGraph, monitor) {
    $process_8(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPostprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPostprocessor', 1497);
function EndLabelPostprocessor$lambda$0$Type() {}
defineClass(1498, 1, {}, EndLabelPostprocessor$lambda$0$Type);
_.apply_0 = function apply_48(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPostprocessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPostprocessor/lambda$0$Type', 1498);
function EndLabelPostprocessor$lambda$1$Type() {}
defineClass(1499, 1, $intern_39, EndLabelPostprocessor$lambda$1$Type);
_.test_0 = function test_23(arg0) {
    return lambda$1_7(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPostprocessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPostprocessor/lambda$1$Type', 1499);
function EndLabelPostprocessor$lambda$2$Type() {}
defineClass(1500, 1, $intern_19, EndLabelPostprocessor$lambda$2$Type);
_.accept = function accept_64(arg0) {
    $processNode_1(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPostprocessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPostprocessor/lambda$2$Type', 1500);
function $calculateOverlapStartCoordinate(node, portSide, edgeLabelSpacing) {
    var nodeMargin, nodeSize;
    nodeSize = node.size_0;
    nodeMargin = node.margin;
    switch(portSide.ordinal){
        case 1:
            return -nodeMargin.top_0 - edgeLabelSpacing;
        case 3:
            return nodeSize.y_0 + nodeMargin.bottom + edgeLabelSpacing;
        case 2:
            return nodeSize.x_0 + nodeMargin.right + edgeLabelSpacing;
        case 4:
            return -nodeMargin.left - edgeLabelSpacing;
        default:
            return 0;
    }
}
function $createConfiguredLabelCell(labels, labelLabelSpacing, verticalLayout) {
    var label_0, label$iterator, labelCell, labelCellRect, padding, padding0;
    if (!labels || labels.array.length == 0) return null;
    labelCell = new LabelCell_1(labelLabelSpacing, !verticalLayout);
    for(label$iterator = new ArrayList$1(labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 72);
        $addLabel(labelCell, ($clinit_LGraphAdapters(), new LGraphAdapters$LLabelAdapter(label_0)));
    }
    labelCellRect = labelCell.cellRectangle;
    labelCellRect.height = (padding0 = labelCell.padding, labelCell.minimumContentAreaSize.y_0 + padding0.top_0 + padding0.bottom);
    labelCellRect.width_0 = (padding = labelCell.padding, labelCell.minimumContentAreaSize.x_0 + padding.left + padding.right);
    return labelCell;
}
function $lambda$1_0(edgeLabelSpacing_1, labelLabelSpacing_3, verticalLayout_5, node_3) {
    $processNode_2(node_3, edgeLabelSpacing_1, labelLabelSpacing_3, verticalLayout_5);
}
function $placeLabels(node, portLabelCells, labelLabelSpacing, edgeLabelSpacing, verticalLayout) {
    var all, port, port$iterator, portSidesWithLabels;
    portSidesWithLabels = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        if (portLabelCells[port.id_0]) {
            $placeLabels_0(port, portLabelCells[port.id_0], edgeLabelSpacing);
            $add_5(portSidesWithLabels, port.side);
        }
    }
    if (verticalLayout) {
        $removeLabelOverlaps(node, portLabelCells, ($clinit_PortSide(), EAST_0), 2 * labelLabelSpacing, edgeLabelSpacing);
        $removeLabelOverlaps(node, portLabelCells, WEST_0, 2 * labelLabelSpacing, edgeLabelSpacing);
    } else {
        $removeLabelOverlaps(node, portLabelCells, ($clinit_PortSide(), NORTH_1), 2 * labelLabelSpacing, edgeLabelSpacing);
        $removeLabelOverlaps(node, portLabelCells, SOUTH_0, 2 * labelLabelSpacing, edgeLabelSpacing);
    }
}
function $placeLabels_0(port, labelCell, edgeLabelSpacing) {
    var labelCellRect, nodeMargin, nodeSize, portAnchor, portPos;
    labelCellRect = labelCell.cellRectangle;
    nodeSize = port.owner.size_0;
    nodeMargin = port.owner.margin;
    portPos = port.pos;
    portAnchor = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        portPos,
        port.anchor
    ]));
    switch(port.side.ordinal){
        case 1:
            $setVerticalAlignment(labelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
            labelCellRect.y_0 = -nodeMargin.top_0 - edgeLabelSpacing - labelCellRect.height;
            if (castTo(castTo($get_11(labelCell.labels, 0), 187).getProperty(($clinit_InternalProperties_1(), LABEL_SIDE)), 289) == ($clinit_LabelSide(), ABOVE)) {
                $setHorizontalAlignment(labelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
                labelCellRect.x_0 = portAnchor.x_0 - $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) - edgeLabelSpacing - labelCellRect.width_0;
            } else {
                $setHorizontalAlignment(labelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
                labelCellRect.x_0 = portAnchor.x_0 + $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) + edgeLabelSpacing;
            }
            break;
        case 2:
            $setHorizontalAlignment(labelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
            labelCellRect.x_0 = nodeSize.x_0 + nodeMargin.right + edgeLabelSpacing;
            if (castTo(castTo($get_11(labelCell.labels, 0), 187).getProperty(($clinit_InternalProperties_1(), LABEL_SIDE)), 289) == ($clinit_LabelSide(), ABOVE)) {
                $setVerticalAlignment(labelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
                labelCellRect.y_0 = portAnchor.y_0 - $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) - edgeLabelSpacing - labelCellRect.height;
            } else {
                $setVerticalAlignment(labelCell, ($clinit_VerticalLabelAlignment(), TOP));
                labelCellRect.y_0 = portAnchor.y_0 + $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) + edgeLabelSpacing;
            }
            break;
        case 3:
            $setVerticalAlignment(labelCell, ($clinit_VerticalLabelAlignment(), TOP));
            labelCellRect.y_0 = nodeSize.y_0 + nodeMargin.bottom + edgeLabelSpacing;
            if (castTo(castTo($get_11(labelCell.labels, 0), 187).getProperty(($clinit_InternalProperties_1(), LABEL_SIDE)), 289) == ($clinit_LabelSide(), ABOVE)) {
                $setHorizontalAlignment(labelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
                labelCellRect.x_0 = portAnchor.x_0 - $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) - edgeLabelSpacing - labelCellRect.width_0;
            } else {
                $setHorizontalAlignment(labelCell, ($clinit_HorizontalLabelAlignment(), LEFT));
                labelCellRect.x_0 = portAnchor.x_0 + $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) + edgeLabelSpacing;
            }
            break;
        case 4:
            $setHorizontalAlignment(labelCell, ($clinit_HorizontalLabelAlignment(), RIGHT));
            labelCellRect.x_0 = -nodeMargin.left - edgeLabelSpacing - labelCellRect.width_0;
            if (castTo(castTo($get_11(labelCell.labels, 0), 187).getProperty(($clinit_InternalProperties_1(), LABEL_SIDE)), 289) == ($clinit_LabelSide(), ABOVE)) {
                $setVerticalAlignment(labelCell, ($clinit_VerticalLabelAlignment(), BOTTOM));
                labelCellRect.y_0 = portAnchor.y_0 - $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) - edgeLabelSpacing - labelCellRect.height;
            } else {
                $setVerticalAlignment(labelCell, ($clinit_VerticalLabelAlignment(), TOP));
                labelCellRect.y_0 = portAnchor.y_0 + $doubleValue(castToDouble($getProperty(port, MAX_EDGE_THICKNESS))) + edgeLabelSpacing;
            }
    }
}
function $portSideToOverlapRemovalDirection(portSide) {
    switch(portSide.ordinal){
        case 1:
            return $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), UP;
        case 3:
            return $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), DOWN;
        case 2:
            return $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), RIGHT_0;
        case 4:
            return $clinit_RectangleStripOverlapRemover$OverlapRemovalDirection(), LEFT_0;
        default:
            return null;
    }
}
function $process_9(layeredGraph, monitor) {
    var edgeLabelSpacing, labelLabelSpacing, verticalLayout;
    monitor.begin('End label pre-processing', 1);
    edgeLabelSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_LABEL_0))));
    labelLabelSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_LABEL_LABEL)));
    verticalLayout = $isVertical(castTo($getProperty(layeredGraph, DIRECTION), 86));
    $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(layeredGraph.layers, 16)), new EndLabelPreprocessor$lambda$0$Type), new EndLabelPreprocessor$lambda$1$Type(edgeLabelSpacing, labelLabelSpacing, verticalLayout));
    monitor.done_1();
}
function $processNode_2(node, edgeLabelSpacing, labelLabelSpacing, verticalLayout) {
    var index_0, port, portCount, portIndex, portLabelCells, portToLabelCellMap;
    portCount = node.ports.array.length;
    portLabelCells = initUnidimensionalArray(Lorg_eclipse_elk_alg_common_nodespacing_cellsystem_LabelCell_2_classLit, $intern_92, 315, portCount, 0, 1);
    for(portIndex = 0; portIndex < portCount; portIndex++){
        port = castTo($get_11(node.ports, portIndex), 11);
        port.id_0 = portIndex;
        portLabelCells[portIndex] = $createConfiguredLabelCell(gatherLabels(port), labelLabelSpacing, verticalLayout);
    }
    $placeLabels(node, portLabelCells, labelLabelSpacing, edgeLabelSpacing, verticalLayout);
    portToLabelCellMap = new HashMap;
    for(index_0 = 0; index_0 < portLabelCells.length; index_0++)!!portLabelCells[index_0] && $put_6(portToLabelCellMap, castTo($get_11(node.ports, index_0), 11), portLabelCells[index_0]);
    if (portToLabelCellMap.hashCodeMap.size_0 + portToLabelCellMap.stringMap.size_0 != 0) {
        $setProperty_0(node, ($clinit_InternalProperties_1(), END_LABELS_0), portToLabelCellMap);
        $updateNodeMargins(node, portLabelCells);
    }
}
function $removeLabelOverlaps(node, portLabelCells, portSide, labelLabelSpacing, edgeLabelSpacing) {
    var labelCellRect, overlapRemover, port, port$iterator;
    overlapRemover = $withStartCoordinate($withGap(createForDirection($portSideToOverlapRemovalDirection(portSide)), labelLabelSpacing), $calculateOverlapStartCoordinate(node, portSide, edgeLabelSpacing));
    for(port$iterator = $getPorts_1(node, portSide).iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        if (portLabelCells[port.id_0]) {
            labelCellRect = portLabelCells[port.id_0].cellRectangle;
            $add_3(overlapRemover.rectangleNodes, new RectangleStripOverlapRemover$RectangleNode(labelCellRect, $importRectangle(overlapRemover, labelCellRect)));
        }
    }
    $removeOverlaps_0(overlapRemover);
}
function $updateNodeMargins(node, labelCells) {
    var labelCell, labelCell$array, labelCell$index, labelCell$max, nodeMargin, nodeMarginRectangle, nodeSize;
    nodeMargin = node.margin;
    nodeSize = node.size_0;
    nodeMarginRectangle = new ElkRectangle_0(-nodeMargin.left, -nodeMargin.top_0, nodeMargin.left + nodeSize.x_0 + nodeMargin.right, nodeMargin.top_0 + nodeSize.y_0 + nodeMargin.bottom);
    for(labelCell$array = labelCells, labelCell$index = 0, labelCell$max = labelCell$array.length; labelCell$index < labelCell$max; ++labelCell$index){
        labelCell = labelCell$array[labelCell$index];
        !!labelCell && $union(nodeMarginRectangle, labelCell.cellRectangle);
    }
    nodeMargin.left = -nodeMarginRectangle.x_0;
    nodeMargin.top_0 = -nodeMarginRectangle.y_0;
    nodeMargin.right = nodeMarginRectangle.width_0 - nodeMargin.left - nodeSize.x_0;
    nodeMargin.bottom = nodeMarginRectangle.height - nodeMargin.top_0 - nodeSize.y_0;
}
function EndLabelPreprocessor() {}
function gatherLabels(port) {
    var dummyNode, dummyPort, dummyPort$iterator, labels, maxEdgeThickness;
    labels = new ArrayList;
    maxEdgeThickness = gatherLabels_0(port, labels);
    dummyNode = castTo($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
    if (dummyNode) for(dummyPort$iterator = new ArrayList$1(dummyNode.ports); dummyPort$iterator.i < dummyPort$iterator.this$01.array.length;){
        dummyPort = castTo($next_6(dummyPort$iterator), 11);
        maskUndefined($getProperty(dummyPort, ORIGIN_0)) === maskUndefined(port) && (maxEdgeThickness = $wnd.Math.max(maxEdgeThickness, gatherLabels_0(dummyPort, labels)));
    }
    labels.array.length == 0 || $setProperty_0(port, MAX_EDGE_THICKNESS, maxEdgeThickness);
    return maxEdgeThickness != -1 ? labels : null;
}
function gatherLabels_0(port, targetList) {
    var incidentEdge, incidentEdge$iterator, label_0, label$iterator, labels, maxEdgeThickness;
    maxEdgeThickness = -1;
    labels = new LinkedList;
    for(incidentEdge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(incidentEdge$iterator.firstIterator) || $hasNext_3(incidentEdge$iterator.secondIterator);){
        incidentEdge = castTo($hasNext_3(incidentEdge$iterator.firstIterator) ? $next_6(incidentEdge$iterator.firstIterator) : $next_6(incidentEdge$iterator.secondIterator), 18);
        maxEdgeThickness = $wnd.Math.max(maxEdgeThickness, $doubleValue(castToDouble($getProperty(incidentEdge, ($clinit_LayeredOptions(), EDGE_THICKNESS)))));
        incidentEdge.source == port ? $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(incidentEdge.labels, 16)), new EndLabelPreprocessor$lambda$2$Type), new EndLabelPreprocessor$lambda$3$Type(labels)) : $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(incidentEdge.labels, 16)), new EndLabelPreprocessor$lambda$4$Type), new EndLabelPreprocessor$lambda$5$Type(labels));
        for(label$iterator = $listIterator_2(labels, 0); label$iterator.currentNode != label$iterator.this$01.tail;){
            label_0 = castTo($next_9(label$iterator), 72);
            $hasProperty(label_0, ($clinit_InternalProperties_1(), END_LABEL_EDGE)) || $setProperty_0(label_0, END_LABEL_EDGE, incidentEdge);
        }
        $addAll_2(targetList, labels);
        $reset_0(labels);
    }
    return maxEdgeThickness;
}
defineClass(1501, 1, $intern_102, EndLabelPreprocessor);
_.process = function process_7(layeredGraph, monitor) {
    $process_9(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor', 1501);
function EndLabelPreprocessor$lambda$0$Type() {}
defineClass(1502, 1, {}, EndLabelPreprocessor$lambda$0$Type);
_.apply_0 = function apply_49(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor/lambda$0$Type', 1502);
function EndLabelPreprocessor$lambda$1$Type(edgeLabelSpacing_1, labelLabelSpacing_3, verticalLayout_5) {
    this.edgeLabelSpacing_1 = edgeLabelSpacing_1;
    this.labelLabelSpacing_3 = labelLabelSpacing_3;
    this.verticalLayout_5 = verticalLayout_5;
}
defineClass(1503, 1, $intern_19, EndLabelPreprocessor$lambda$1$Type);
_.accept = function accept_65(arg0) {
    $lambda$1_0(this.edgeLabelSpacing_1, this.labelLabelSpacing_3, this.verticalLayout_5, castTo(arg0, 9));
};
_.edgeLabelSpacing_1 = 0;
_.labelLabelSpacing_3 = 0;
_.verticalLayout_5 = false;
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor/lambda$1$Type', 1503);
function EndLabelPreprocessor$lambda$2$Type() {}
defineClass(1504, 1, $intern_39, EndLabelPreprocessor$lambda$2$Type);
_.test_0 = function test_24(arg0) {
    return maskUndefined($getProperty(castTo(arg0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT))) === maskUndefined(($clinit_EdgeLabelPlacement(), TAIL));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor/lambda$2$Type', 1504);
function EndLabelPreprocessor$lambda$3$Type(labels_0) {
    this.labels_0 = labels_0;
}
defineClass(1505, 1, $intern_19, EndLabelPreprocessor$lambda$3$Type);
_.accept = function accept_66(arg0) {
    $add_7(this.labels_0, castTo(arg0, 72));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor/lambda$3$Type', 1505);
function EndLabelPreprocessor$lambda$4$Type() {}
defineClass(1506, 1, $intern_39, EndLabelPreprocessor$lambda$4$Type);
_.test_0 = function test_25(arg0) {
    return maskUndefined($getProperty(castTo(arg0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT))) === maskUndefined(($clinit_EdgeLabelPlacement(), HEAD));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor/lambda$4$Type', 1506);
function EndLabelPreprocessor$lambda$5$Type(labels_0) {
    this.labels_0 = labels_0;
}
defineClass(1507, 1, $intern_19, EndLabelPreprocessor$lambda$5$Type);
_.accept = function accept_67(arg0) {
    $add_7(this.labels_0, castTo(arg0, 72));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelPreprocessor$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelPreprocessor/lambda$5$Type', 1507);
function $clinit_EndLabelSorter() {
    $clinit_EndLabelSorter = emptyMethod;
    LABEL_GROUP_COMPARATOR = new EndLabelSorter$1;
}
function $createLabelGroups(portLabelCell) {
    var edge, edgeToGroupMap, label_0, label$iterator;
    edgeToGroupMap = new HashMap;
    for(label$iterator = new ArrayList$1(portLabelCell.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 187);
        edge = castTo(label_0.getProperty(($clinit_InternalProperties_1(), END_LABEL_EDGE)), 18);
        !!$getEntry_0(edgeToGroupMap.hashCodeMap, edge) || $put_6(edgeToGroupMap, edge, new EndLabelSorter$LabelGroup(edge));
        $add_3(castTo(getEntryValueOrNull($getEntry_0(edgeToGroupMap.hashCodeMap, edge)), 452).labels, label_0);
    }
    return new ArrayList_1(new AbstractMap$2(edgeToGroupMap));
}
function $initialize_2(lGraph) {
    var layer, layer$iterator, nextElementID, node, node$iterator, port, port$iterator;
    nextElementID = 0;
    for(layer$iterator = new ArrayList$1(lGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.id_0 = nextElementID++;
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                port.id_0 = nextElementID++;
            }
        }
    }
}
function $needsSorting(port) {
    var edgesWithEndLabels, headLabels, inEdge, inEdge$iterator, outEdge, outEdge$iterator, tailLabels;
    edgesWithEndLabels = 0;
    for(inEdge$iterator = new ArrayList$1(port.incomingEdges); inEdge$iterator.i < inEdge$iterator.this$01.array.length;){
        inEdge = castTo($next_6(inEdge$iterator), 18);
        headLabels = $anyMatch(new StreamImpl(null, new Spliterators$IteratorSpliterator(inEdge.labels, 16)), new EndLabelSorter$lambda$3$Type);
        headLabels && ++edgesWithEndLabels;
    }
    for(outEdge$iterator = new ArrayList$1(port.outgoingEdges); outEdge$iterator.i < outEdge$iterator.this$01.array.length;){
        outEdge = castTo($next_6(outEdge$iterator), 18);
        tailLabels = $anyMatch(new StreamImpl(null, new Spliterators$IteratorSpliterator(outEdge.labels, 16)), new EndLabelSorter$lambda$4$Type);
        tailLabels && ++edgesWithEndLabels;
    }
    return edgesWithEndLabels >= 2;
}
function $process_10(layeredGraph, monitor) {
    monitor.begin('Sort end labels', 1);
    $forEach_3($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(layeredGraph.layers, 16)), new EndLabelSorter$lambda$0$Type), new EndLabelSorter$lambda$1$Type), new EndLabelSorter$lambda$2$Type);
    monitor.done_1();
}
function $processNode_3(node) {
    var initializeMethodCalled, labelCellMap, port, port$iterator;
    initializeMethodCalled = false;
    if ($hasProperty(node, ($clinit_InternalProperties_1(), END_LABELS_0))) {
        labelCellMap = castTo($getProperty(node, END_LABELS_0), 91);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            if ($needsSorting(port)) {
                if (!initializeMethodCalled) {
                    $initialize_2($getGraph(node));
                    initializeMethodCalled = true;
                }
                $sort_1(castTo(labelCellMap.get_3(port), 315));
            }
        }
    }
}
function $sort_1(portLabelCell) {
    var group, group$iterator, labelGroups, portLabelCellLabels;
    labelGroups = $createLabelGroups(portLabelCell);
    $sort(labelGroups, LABEL_GROUP_COMPARATOR);
    portLabelCellLabels = portLabelCell.labels;
    portLabelCellLabels.array.length = 0;
    for(group$iterator = new ArrayList$1(labelGroups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 452);
        $addAll_2(portLabelCellLabels, group.labels);
    }
}
function EndLabelSorter() {
    $clinit_EndLabelSorter();
}
defineClass(1555, 1, $intern_102, EndLabelSorter);
_.process = function process_8(layeredGraph, monitor) {
    $process_10(castTo(layeredGraph, 36), monitor);
};
var LABEL_GROUP_COMPARATOR;
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter', 1555);
function $compare_5(group1, group2) {
    var sourcePortDiff, targetNodeDiff;
    sourcePortDiff = compare_5(group1.edge.source.id_0, group2.edge.source.id_0);
    if (sourcePortDiff != 0) return sourcePortDiff;
    targetNodeDiff = compare_5(group1.edge.target.owner.id_0, group2.edge.target.owner.id_0);
    if (targetNodeDiff != 0) return targetNodeDiff;
    return compare_5(group2.edge.target.id_0, group1.edge.target.id_0);
}
function EndLabelSorter$1() {}
defineClass(1556, 1, $intern_88, EndLabelSorter$1);
_.compare_1 = function compare_36(group1, group2) {
    return $compare_5(castTo(group1, 452), castTo(group2, 452));
};
_.equals_0 = function equals_100(other) {
    return this === other;
};
_.reversed = function reversed_28() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/1', 1556);
function EndLabelSorter$LabelGroup(edge) {
    this.labels = new ArrayList;
    $addAll_2(this.labels, this.labels);
    this.edge = edge;
}
defineClass(452, 1, {
    452: 1
}, EndLabelSorter$LabelGroup);
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$LabelGroup_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/LabelGroup', 452);
function EndLabelSorter$lambda$0$Type() {}
defineClass(1557, 1, {}, EndLabelSorter$lambda$0$Type);
_.apply_0 = function apply_50(arg0) {
    return $clinit_EndLabelSorter(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/lambda$0$Type', 1557);
function EndLabelSorter$lambda$1$Type() {}
defineClass(1558, 1, $intern_39, EndLabelSorter$lambda$1$Type);
_.test_0 = function test_26(arg0) {
    return $clinit_EndLabelSorter(), castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/lambda$1$Type', 1558);
function EndLabelSorter$lambda$2$Type() {}
defineClass(1559, 1, $intern_19, EndLabelSorter$lambda$2$Type);
_.accept = function accept_68(arg0) {
    $processNode_3(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/lambda$2$Type', 1559);
function EndLabelSorter$lambda$3$Type() {}
defineClass(1560, 1, $intern_39, EndLabelSorter$lambda$3$Type);
_.test_0 = function test_27(arg0) {
    return $clinit_EndLabelSorter(), maskUndefined($getProperty(castTo(arg0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT))) === maskUndefined(($clinit_EdgeLabelPlacement(), HEAD));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/lambda$3$Type', 1560);
function EndLabelSorter$lambda$4$Type() {}
defineClass(1561, 1, $intern_39, EndLabelSorter$lambda$4$Type);
_.test_0 = function test_28(arg0) {
    return $clinit_EndLabelSorter(), maskUndefined($getProperty(castTo(arg0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT))) === maskUndefined(($clinit_EdgeLabelPlacement(), TAIL));
};
var Lorg_eclipse_elk_alg_layered_intermediate_EndLabelSorter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'EndLabelSorter/lambda$4$Type', 1561);
function $absMin(d1, d2) {
    return $wnd.Math.abs(d1) < $wnd.Math.abs(d2) ? d1 : d2;
}
function $calculateBezierBendPoints(this$static, edgeChain, survivingEdge) {
    var addMidPoint, allCP, currentBendPoints, currentEdge, edge, edgeIterator, halfway, lastCP, northSouthCP, nt, nubSpline, sourcePort, targetPort, y_0, first, second, v, v2, straightenBeginning, iter, last, secondLast, straightenEnding;
    if (edgeChain.isEmpty()) return;
    allCP = new KVectorChain;
    edge = survivingEdge ? survivingEdge : castTo(edgeChain.get_0(0), 18);
    sourcePort = edge.source;
    $clinit_SplineEdgeRouter();
    nt = sourcePort.owner.type_0;
    if (!(nt == ($clinit_LNode$NodeType(), NORMAL) || nt == NORTH_SOUTH_PORT || nt == EXTERNAL_PORT || nt == BREAKING_POINT)) throw toJs(new IllegalArgumentException_0('The target node of the edge must be a normal node or a northSouthPort.'));
    $addLast_0(allCP, sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        sourcePort.owner.pos,
        sourcePort.pos,
        sourcePort.anchor
    ])));
    if (($clinit_PortSide(), SIDES_NORTH_SOUTH).contains(sourcePort.side)) {
        y_0 = $doubleValue(castToDouble($getProperty(sourcePort, ($clinit_InternalProperties_1(), SPLINE_NS_PORT_Y_COORD))));
        northSouthCP = new KVector_1(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            sourcePort.owner.pos,
            sourcePort.pos,
            sourcePort.anchor
        ])).x_0, y_0);
        $addNode_0(allCP, northSouthCP, allCP.tail.prev, allCP.tail);
    }
    lastCP = null;
    addMidPoint = false;
    edgeIterator = edgeChain.iterator_0();
    while(edgeIterator.hasNext_0()){
        currentEdge = castTo(edgeIterator.next_1(), 18);
        currentBendPoints = currentEdge.bendPoints;
        if (currentBendPoints.size_0 != 0) {
            if (addMidPoint) {
                halfway = $scale($add_19(lastCP, (checkCriticalElement(currentBendPoints.size_0 != 0), castTo(currentBendPoints.header.next_0.value_0, 8))), 0.5);
                $addNode_0(allCP, halfway, allCP.tail.prev, allCP.tail);
                addMidPoint = false;
            } else addMidPoint = true;
            lastCP = $clone_1((checkCriticalElement(currentBendPoints.size_0 != 0), castTo(currentBendPoints.tail.prev.value_0, 8)));
            $addAll(allCP, currentBendPoints);
            $reset_0(currentBendPoints);
        }
    }
    targetPort = edge.target;
    if (SIDES_NORTH_SOUTH.contains(targetPort.side)) {
        y_0 = $doubleValue(castToDouble($getProperty(targetPort, ($clinit_InternalProperties_1(), SPLINE_NS_PORT_Y_COORD))));
        northSouthCP = new KVector_1(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            targetPort.owner.pos,
            targetPort.pos,
            targetPort.anchor
        ])).x_0, y_0);
        $addNode_0(allCP, northSouthCP, allCP.tail.prev, allCP.tail);
    }
    $addLast_0(allCP, sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        targetPort.owner.pos,
        targetPort.pos,
        targetPort.anchor
    ])));
    this$static.splineRoutingMode == ($clinit_SplineRoutingMode(), CONSERVATIVE) && (first = (checkCriticalElement(allCP.size_0 != 0), castTo(allCP.header.next_0.value_0, 8)), second = castTo($get_7(allCP, 1), 8), v = new KVector_0(portSideToDirection(sourcePort.side)), v.x_0 *= 5, v.y_0 *= 5, v2 = $sub_0(new KVector_1(second.x_0, second.y_0), first), straightenBeginning = new KVector_1($absMin(v.x_0, v2.x_0), $absMin(v.y_0, v2.y_0)), $add_19(straightenBeginning, first), iter = $listIterator_2(allCP, 1), $add_8(iter, straightenBeginning), last = (checkCriticalElement(allCP.size_0 != 0), castTo(allCP.tail.prev.value_0, 8)), secondLast = castTo($get_7(allCP, allCP.size_0 - 2), 8), v = new KVector_0(portSideToDirection(targetPort.side)), v.x_0 *= 5, v.y_0 *= 5, v2 = $sub_0(new KVector_1(secondLast.x_0, secondLast.y_0), last), straightenEnding = new KVector_1($absMin(v.x_0, v2.x_0), $absMin(v.y_0, v2.y_0)), $add_19(straightenEnding, last), $add_0(allCP, allCP.size_0 - 1, straightenEnding), undefined);
    nubSpline = new NubSpline(allCP);
    $addAll(edge.bendPoints, $getBezierCP(nubSpline));
}
function $calculateControlPoints(this$static, segment) {
    var edge, edge$iterator, ei, sloppy, xStartPos, xEndPos, halfway;
    if (segment.handled) return;
    segment.handled = true;
    for(edge$iterator = segment.edges.map_0.keySet_0().iterator_0(); edge$iterator.hasNext_0();){
        edge = castTo(edge$iterator.next_1(), 18);
        if (segment.isStraight && segment.edges.map_0.size_1() <= 1) {
            xStartPos = segment.boundingBox.x_0;
            xEndPos = segment.boundingBox.x_0 + segment.boundingBox.width_0;
            halfway = new KVector_1(xStartPos + (xEndPos - xStartPos) / 2, segment.centerControlPointY);
            $add_7(castTo(segment.edges.map_0.keySet_0().iterator_0().next_1(), 18).bendPoints, halfway);
            continue;
        }
        ei = castTo($get_10(segment.edgeInformation, edge), 454);
        if (ei.invertedLeft || ei.invertedRight) {
            $calculateControlPointsInvertedEdge(this$static, edge, segment);
            continue;
        }
        sloppy = this$static.splineRoutingMode == ($clinit_SplineRoutingMode(), SLOPPY) && (ei.normalSourceNode || ei.normalTargetNode) && $segmentAllowsSloppyRouting(this$static, segment) && segment.edges.map_0.size_1() <= 1;
        sloppy ? $calculateControlPointsSloppy(edge, segment) : $calculateControlPointsConservative(this$static, edge, segment);
    }
    segment.inverseOrder && $forEach_0(segment.edges, new FinalSplineBendpointsCalculator$lambda$5$Type);
}
function $calculateControlPointsConservative(this$static, edge, containingSegment) {
    var center, centerXPos, ei, endXPos, isHyperedge, sourceStraightCP, sourceVerticalCP, startXPos, targetStraightCP, targetVerticalCP, ySourceAnchor, yTargetAnchor;
    startXPos = containingSegment.boundingBox.x_0;
    endXPos = containingSegment.boundingBox.x_0 + containingSegment.boundingBox.width_0;
    ei = castTo($get_10(containingSegment.edgeInformation, edge), 454);
    ySourceAnchor = ei.startY;
    yTargetAnchor = ei.endY;
    sourceStraightCP = new KVector_1(startXPos, ySourceAnchor);
    targetStraightCP = new KVector_1(endXPos, yTargetAnchor);
    centerXPos = startXPos;
    containingSegment.isWestOfInitialLayer || (centerXPos += this$static.edgeNodeSpacing);
    centerXPos += containingSegment.xDelta + containingSegment.rank * this$static.edgeEdgeSpacing;
    sourceVerticalCP = new KVector_1(centerXPos, ySourceAnchor);
    targetVerticalCP = new KVector_1(centerXPos, yTargetAnchor);
    $addAll_7(edge.bendPoints, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        sourceStraightCP,
        sourceVerticalCP
    ]));
    isHyperedge = containingSegment.edges.map_0.size_1() > 1;
    if (isHyperedge) {
        center = new KVector_1(centerXPos, containingSegment.centerControlPointY);
        $add_7(edge.bendPoints, center);
    }
    $addAll_7(edge.bendPoints, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        targetVerticalCP,
        targetStraightCP
    ]));
}
function $calculateControlPointsInvertedEdge(this$static, edge, containingSegment) {
    var center, centerXPos, ei, endXPos, isHyperedge, sourceStraightCP, sourceVerticalCP, startXPos, targetStraightCP, targetVerticalCP, ySourceAnchor, yTargetAnchor;
    startXPos = containingSegment.boundingBox.x_0;
    endXPos = containingSegment.boundingBox.x_0 + containingSegment.boundingBox.width_0;
    ei = castTo($get_10(containingSegment.edgeInformation, edge), 454);
    ySourceAnchor = ei.startY;
    yTargetAnchor = ei.endY;
    ei.invertedLeft ? sourceStraightCP = new KVector_1(endXPos, ySourceAnchor) : sourceStraightCP = new KVector_1(startXPos, ySourceAnchor);
    ei.invertedRight ? targetStraightCP = new KVector_1(startXPos, yTargetAnchor) : targetStraightCP = new KVector_1(endXPos, yTargetAnchor);
    centerXPos = startXPos;
    containingSegment.isWestOfInitialLayer || (centerXPos += this$static.edgeNodeSpacing);
    centerXPos += containingSegment.xDelta + containingSegment.rank * this$static.edgeEdgeSpacing;
    sourceVerticalCP = new KVector_1(centerXPos, ySourceAnchor);
    targetVerticalCP = new KVector_1(centerXPos, yTargetAnchor);
    $addAll_7(edge.bendPoints, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        sourceStraightCP,
        sourceVerticalCP
    ]));
    isHyperedge = containingSegment.edges.map_0.size_1() > 1;
    if (isHyperedge) {
        center = new KVector_1(centerXPos, containingSegment.centerControlPointY);
        $add_7(edge.bendPoints, center);
    }
    $addAll_7(edge.bendPoints, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        targetVerticalCP,
        targetStraightCP
    ]));
}
function $calculateControlPointsSloppy(edge, containingSegment) {
    var approx, box, centerXPos, centerYPos, edgePointsDownwards, ei, endXPos, needToCheckSrc, needToCheckTgt, neighbor, neighborIndex, shortCutSource, shortCutTarget, sourceStraightCP, sourceVerticalCP, src_0, startXPos, targetStraightCP, targetVerticalCP, tgt, v1, v2, v3, ySourceAnchor, yTargetAnchor;
    ei = castTo($get_10(containingSegment.edgeInformation, edge), 454);
    startXPos = containingSegment.boundingBox.x_0;
    endXPos = containingSegment.boundingBox.x_0 + containingSegment.boundingBox.width_0;
    ySourceAnchor = ei.startY;
    yTargetAnchor = ei.endY;
    edgePointsDownwards = ySourceAnchor < yTargetAnchor;
    sourceStraightCP = new KVector_1(startXPos, ySourceAnchor);
    targetStraightCP = new KVector_1(endXPos, yTargetAnchor);
    centerXPos = (startXPos + endXPos) / 2;
    sourceVerticalCP = new KVector_1(centerXPos, ySourceAnchor);
    targetVerticalCP = new KVector_1(centerXPos, yTargetAnchor);
    centerYPos = $computeSloppyCenterY(edge, ySourceAnchor, yTargetAnchor);
    v1 = $getAbsoluteAnchor(containingSegment.sourcePort);
    v2 = new KVector_1(centerXPos, centerYPos);
    v3 = $getAbsoluteAnchor(containingSegment.targetPort);
    approx = approximateBezierSegment(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        v1,
        v2,
        v3
    ]));
    shortCutSource = false;
    src_0 = containingSegment.sourcePort.owner;
    if (!!src_0 && !!src_0.layer && ei.normalSourceNode) {
        needToCheckSrc = edgePointsDownwards && src_0.id_0 < src_0.layer.nodes.array.length - 1 || !edgePointsDownwards && src_0.id_0 > 0;
        if (needToCheckSrc) {
            if (needToCheckSrc) {
                neighborIndex = src_0.id_0;
                edgePointsDownwards ? ++neighborIndex : --neighborIndex;
                neighbor = castTo($get_11(src_0.layer.nodes, neighborIndex), 9);
                box = $nodeToBoundingBox(neighbor);
                shortCutSource = !(intersects_0(box, v1, approx[0]) || contains_50(box, v1, approx[0]));
            }
        } else shortCutSource = true;
    }
    shortCutTarget = false;
    tgt = containingSegment.targetPort.owner;
    if (!!tgt && !!tgt.layer && ei.normalTargetNode) {
        needToCheckTgt = edgePointsDownwards && tgt.id_0 > 0 || !edgePointsDownwards && tgt.id_0 < tgt.layer.nodes.array.length - 1;
        if (needToCheckTgt) {
            neighborIndex = tgt.id_0;
            edgePointsDownwards ? --neighborIndex : ++neighborIndex;
            neighbor = castTo($get_11(tgt.layer.nodes, neighborIndex), 9);
            box = $nodeToBoundingBox(neighbor);
            shortCutTarget = !(intersects_0(box, approx[0], v3) || contains_50(box, approx[0], v3));
        } else shortCutTarget = true;
    }
    shortCutSource && shortCutTarget && $add_7(edge.bendPoints, v2);
    shortCutSource || $addAll_7(edge.bendPoints, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        sourceStraightCP,
        sourceVerticalCP
    ]));
    shortCutTarget || $addAll_7(edge.bendPoints, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        targetVerticalCP,
        targetStraightCP
    ]));
}
function $computeSloppyCenterY(edge, ySourceAnchor, yTargetAnchor) {
    var centerYPos, degreeDiff, indegree, outdegree, port, port$iterator;
    indegree = 0;
    outdegree = 0;
    if (edge.source) for(port$iterator = new ArrayList$1(edge.target.owner.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        indegree += port.incomingEdges.array.length;
    }
    else indegree = 1;
    if (edge.target) for(port$iterator = new ArrayList$1(edge.source.owner.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        outdegree += port.outgoingEdges.array.length;
    }
    else outdegree = 1;
    degreeDiff = round_int(signum(outdegree - indegree));
    centerYPos = (yTargetAnchor + ySourceAnchor) / 2 + (yTargetAnchor - ySourceAnchor) * (0.4 * degreeDiff);
    return centerYPos;
}
function $indexNodesPerLayer(graph) {
    var index_0, l, l$iterator, n, n$iterator;
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        index_0 = 0;
        for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            n.id_0 = index_0++;
        }
    }
}
function $nodeToBoundingBox(node) {
    var m, pos, size_0;
    pos = node.pos;
    size_0 = node.size_0;
    m = node.margin;
    return new ElkRectangle_0(pos.x_0 - m.left, pos.y_0 - m.top_0, size_0.x_0 + (m.left + m.right), size_0.y_0 + (m.top_0 + m.bottom));
}
function $process_11(this$static, graph) {
    var e, e$iterator, e$iterator0, edgeChain, spline, startEdges, survivingEdge;
    this$static.edgeEdgeSpacing = $doubleValue(castToDouble($getProperty(graph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE_BETWEEN_LAYERS_0))));
    this$static.edgeNodeSpacing = $doubleValue(castToDouble($getProperty(graph, SPACING_EDGE_NODE_BETWEEN_LAYERS_0)));
    this$static.splineRoutingMode = castTo($getProperty(graph, EDGE_ROUTING_SPLINES_MODE_0), 346);
    this$static.compactionStrategy = castTo($getProperty(graph, COMPACTION_POST_COMPACTION_STRATEGY_0), 280);
    $indexNodesPerLayer(graph);
    startEdges = castTo($collect_1($filter($filter($flatMap($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(graph.layers, 16)), new FinalSplineBendpointsCalculator$lambda$0$Type), new FinalSplineBendpointsCalculator$lambda$1$Type), new FinalSplineBendpointsCalculator$lambda$2$Type), new FinalSplineBendpointsCalculator$lambda$3$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    for(e$iterator0 = startEdges.iterator_0(); e$iterator0.hasNext_0();){
        e = castTo(e$iterator0.next_1(), 18);
        spline = castTo($getProperty(e, ($clinit_InternalProperties_1(), SPLINE_ROUTE_START)), 15);
        spline.forEach_0(new FinalSplineBendpointsCalculator$lambda$4$Type(this$static));
        $setProperty_0(e, SPLINE_ROUTE_START, null);
    }
    for(e$iterator = startEdges.iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 18);
        survivingEdge = castTo($getProperty(e, ($clinit_InternalProperties_1(), SPLINE_SURVIVING_EDGE)), 18);
        edgeChain = castTo($getProperty(e, SPLINE_EDGE_CHAIN), 15);
        $calculateBezierBendPoints(this$static, edgeChain, survivingEdge);
        $setProperty_0(e, SPLINE_EDGE_CHAIN, null);
    }
}
function $segmentAllowsSloppyRouting(this$static, segment) {
    var endXPos, n, nodeSegmentDistance, startXPos, t;
    if (this$static.compactionStrategy == ($clinit_GraphCompactionStrategy(), NONE_5)) return true;
    startXPos = segment.boundingBox.x_0;
    endXPos = segment.boundingBox.x_0 + segment.boundingBox.width_0;
    if (segment.initialSegment) {
        n = segment.sourceNode;
        t = n.layer.size_0.x_0 - n.size_0.x_0 / 2;
        nodeSegmentDistance = startXPos - (n.pos.x_0 + n.size_0.x_0);
        if (nodeSegmentDistance > t) return false;
    }
    if (segment.lastSegment) {
        n = segment.targetNode;
        t = n.layer.size_0.x_0 - n.size_0.x_0 / 2;
        nodeSegmentDistance = n.pos.x_0 - endXPos;
        if (nodeSegmentDistance > t) return false;
    }
    return true;
}
function FinalSplineBendpointsCalculator() {}
defineClass(1508, 1, $intern_102, FinalSplineBendpointsCalculator);
_.process = function process_9(graph, progressMonitor) {
    $process_11(this, castTo(graph, 36));
};
_.edgeEdgeSpacing = 0;
_.edgeNodeSpacing = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator', 1508);
function FinalSplineBendpointsCalculator$lambda$0$Type() {}
defineClass(1509, 1, {}, FinalSplineBendpointsCalculator$lambda$0$Type);
_.apply_0 = function apply_51(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator/lambda$0$Type', 1509);
function FinalSplineBendpointsCalculator$lambda$1$Type() {}
defineClass(1510, 1, {}, FinalSplineBendpointsCalculator$lambda$1$Type);
_.apply_0 = function apply_52(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator/lambda$1$Type', 1510);
function FinalSplineBendpointsCalculator$lambda$2$Type() {}
defineClass(1511, 1, $intern_39, FinalSplineBendpointsCalculator$lambda$2$Type);
_.test_0 = function test_29(arg0) {
    return !$isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator/lambda$2$Type', 1511);
function FinalSplineBendpointsCalculator$lambda$3$Type() {}
defineClass(1512, 1, $intern_39, FinalSplineBendpointsCalculator$lambda$3$Type);
_.test_0 = function test_30(arg0) {
    return $hasProperty(castTo(arg0, 18), ($clinit_InternalProperties_1(), SPLINE_ROUTE_START));
};
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator/lambda$3$Type', 1512);
function FinalSplineBendpointsCalculator$lambda$4$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1513, 1, $intern_19, FinalSplineBendpointsCalculator$lambda$4$Type);
_.accept = function accept_69(arg0) {
    $calculateControlPoints(this.$$outer_0, castTo(arg0, 132));
};
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator/lambda$4$Type', 1513);
function FinalSplineBendpointsCalculator$lambda$5$Type() {}
defineClass(1514, 1, $intern_19, FinalSplineBendpointsCalculator$lambda$5$Type);
_.accept = function accept_70(arg0) {
    reverse_2(castTo(arg0, 18).bendPoints);
};
var Lorg_eclipse_elk_alg_layered_intermediate_FinalSplineBendpointsCalculator$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'FinalSplineBendpointsCalculator/lambda$5$Type', 1514);
function $getMirroredPortSideX(side) {
    switch(side.ordinal){
        case 2:
            return $clinit_PortSide(), WEST_0;
        case 4:
            return $clinit_PortSide(), EAST_0;
        default:
            return side;
    }
}
function $getMirroredPortSideY(side) {
    switch(side.ordinal){
        case 1:
            return $clinit_PortSide(), SOUTH_0;
        case 3:
            return $clinit_PortSide(), NORTH_1;
        default:
            return side;
    }
}
function $mirrorAllX(layeredGraph, nodes) {
    $mirrorX(nodes, layeredGraph);
    $mirrorX_1(layeredGraph.padding);
    $mirrorX_1(castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), NODE_LABELS_PADDING)), 213));
}
function $mirrorAllY(layeredGraph, nodes) {
    $mirrorY(nodes, layeredGraph);
    $mirrorY_1(layeredGraph.padding);
    $mirrorY_1(castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), NODE_LABELS_PADDING)), 213));
}
function $mirrorInLayerConstraintY(node) {
    switch(castTo($getProperty(node, ($clinit_InternalProperties_1(), IN_LAYER_CONSTRAINT)), 312).ordinal){
        case 1:
            $setProperty_0(node, IN_LAYER_CONSTRAINT, ($clinit_InLayerConstraint(), BOTTOM_0));
            break;
        case 2:
            $setProperty_0(node, IN_LAYER_CONSTRAINT, ($clinit_InLayerConstraint(), TOP_1));
    }
}
function $mirrorLayerConstraintX(node) {
    switch(castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171).ordinal){
        case 1:
            $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), LAST));
            break;
        case 2:
            $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), LAST_SEPARATE_0));
            break;
        case 3:
            $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), FIRST));
            break;
        case 4:
            $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), FIRST_SEPARATE_0));
    }
}
function $mirrorNodeLabelPlacementX(shape_0) {
    var oldPlacement;
    if (!$hasProperty(shape_0, ($clinit_LayeredOptions(), NODE_LABELS_PLACEMENT_1))) return;
    oldPlacement = castTo($getProperty(shape_0, NODE_LABELS_PLACEMENT_1), 22);
    if (oldPlacement.contains(($clinit_NodeLabelPlacement(), H_LEFT_0))) {
        oldPlacement.remove_1(H_LEFT_0);
        oldPlacement.add_2(H_RIGHT_0);
    } else if (oldPlacement.contains(H_RIGHT_0)) {
        oldPlacement.remove_1(H_RIGHT_0);
        oldPlacement.add_2(H_LEFT_0);
    }
}
function $mirrorNodeLabelPlacementY(shape_0) {
    var oldPlacement;
    if (!$hasProperty(shape_0, ($clinit_LayeredOptions(), NODE_LABELS_PLACEMENT_1))) return;
    oldPlacement = castTo($getProperty(shape_0, NODE_LABELS_PLACEMENT_1), 22);
    if (oldPlacement.contains(($clinit_NodeLabelPlacement(), V_TOP_0))) {
        oldPlacement.remove_1(V_TOP_0);
        oldPlacement.add_2(V_BOTTOM_0);
    } else if (oldPlacement.contains(V_BOTTOM_0)) {
        oldPlacement.remove_1(V_BOTTOM_0);
        oldPlacement.add_2(V_TOP_0);
    }
}
function $mirrorX(nodes, graph) {
    var bendPoint, bendPoint$iterator, edge, edge$iterator, index_0, jp, jp$iterator, junctionPoints, label_0, label$iterator, label$iterator0, label$iterator1, node, node$iterator, node$iterator0, nodeSize, offset, port, port$iterator;
    offset = 0;
    if (graph.size_0.x_0 == 0) for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        offset = $wnd.Math.max(offset, node.pos.x_0 + node.size_0.x_0 + node.margin.right);
    }
    else offset = graph.size_0.x_0 - graph.offset.x_0;
    offset -= graph.offset.x_0;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $mirrorX_0(node.pos, offset - node.size_0.x_0);
        $mirrorX_1(node.padding);
        $mirrorNodeLabelPlacementX(node);
        (!node.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : node.propertyMap).containsKey(($clinit_LayeredOptions(), POSITION)) && $mirrorX_0(castTo($getProperty(node, POSITION), 8), offset - node.size_0.x_0);
        switch(castTo($getProperty(node, ALIGNMENT), 254).ordinal){
            case 1:
                $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), RIGHT_5));
                break;
            case 2:
                $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), LEFT_5));
        }
        nodeSize = node.size_0;
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            $mirrorX_0(port.pos, nodeSize.x_0 - port.size_0.x_0);
            $mirrorX_0(port.anchor, port.size_0.x_0);
            $setSide(port, $getMirroredPortSideX(port.side));
            index_0 = castTo($getProperty(port, PORT_INDEX), 17);
            !!index_0 && $setProperty_0(port, PORT_INDEX, valueOf_3(-index_0.value_0));
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                for(bendPoint$iterator = $listIterator_2(edge.bendPoints, 0); bendPoint$iterator.currentNode != bendPoint$iterator.this$01.tail;){
                    bendPoint = castTo($next_9(bendPoint$iterator), 8);
                    bendPoint.x_0 = offset - bendPoint.x_0;
                }
                junctionPoints = castTo($getProperty(edge, JUNCTION_POINTS), 77);
                if (junctionPoints) for(jp$iterator = $listIterator_2(junctionPoints, 0); jp$iterator.currentNode != jp$iterator.this$01.tail;){
                    jp = castTo($next_9(jp$iterator), 8);
                    jp.x_0 = offset - jp.x_0;
                }
                for(label$iterator0 = new ArrayList$1(edge.labels); label$iterator0.i < label$iterator0.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator0), 72);
                    $mirrorX_0(label_0.pos, offset - label_0.size_0.x_0);
                }
            }
            for(label$iterator1 = new ArrayList$1(port.labels); label$iterator1.i < label$iterator1.this$01.array.length;){
                label_0 = castTo($next_6(label$iterator1), 72);
                $mirrorX_0(label_0.pos, port.size_0.x_0 - label_0.size_0.x_0);
            }
        }
        if (node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
            $setProperty_0(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE), $getMirroredPortSideX(castTo($getProperty(node, EXT_PORT_SIDE), 64)));
            $mirrorLayerConstraintX(node);
        }
        for(label$iterator = new ArrayList$1(node.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            $mirrorNodeLabelPlacementX(label_0);
            $mirrorX_0(label_0.pos, nodeSize.x_0 - label_0.size_0.x_0);
        }
    }
}
function $mirrorX_0(v, offset) {
    v.x_0 = offset - v.x_0;
}
function $mirrorX_1(spacing) {
    var oldLeft, oldRight;
    oldLeft = spacing.left;
    oldRight = spacing.right;
    spacing.left = oldRight;
    spacing.right = oldLeft;
}
function $mirrorY(nodes, graph) {
    var bendPoint, bendPoint$iterator, edge, edge$iterator, index_0, jp, jp$iterator, junctionPoints, label_0, label$iterator, label$iterator0, label$iterator1, node, node$iterator, node$iterator0, nodeSize, offset, port, port$iterator;
    offset = 0;
    if (graph.size_0.y_0 == 0) for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        offset = $wnd.Math.max(offset, node.pos.y_0 + node.size_0.y_0 + node.margin.bottom);
    }
    else offset = graph.size_0.y_0 - graph.offset.y_0;
    offset -= graph.offset.y_0;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $mirrorY_0(node.pos, offset - node.size_0.y_0);
        $mirrorY_1(node.padding);
        $mirrorNodeLabelPlacementY(node);
        (!node.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : node.propertyMap).containsKey(($clinit_LayeredOptions(), POSITION)) && $mirrorY_0(castTo($getProperty(node, POSITION), 8), offset - node.size_0.y_0);
        switch(castTo($getProperty(node, ALIGNMENT), 254).ordinal){
            case 3:
                $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), BOTTOM_1));
                break;
            case 4:
                $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), TOP_2));
        }
        nodeSize = node.size_0;
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            $mirrorY_0(port.pos, nodeSize.y_0 - port.size_0.y_0);
            $mirrorY_0(port.anchor, port.size_0.y_0);
            $setSide(port, $getMirroredPortSideY(port.side));
            index_0 = castTo($getProperty(port, PORT_INDEX), 17);
            !!index_0 && $setProperty_0(port, PORT_INDEX, valueOf_3(-index_0.value_0));
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                for(bendPoint$iterator = $listIterator_2(edge.bendPoints, 0); bendPoint$iterator.currentNode != bendPoint$iterator.this$01.tail;){
                    bendPoint = castTo($next_9(bendPoint$iterator), 8);
                    bendPoint.y_0 = offset - bendPoint.y_0;
                }
                junctionPoints = castTo($getProperty(edge, JUNCTION_POINTS), 77);
                if (junctionPoints) for(jp$iterator = $listIterator_2(junctionPoints, 0); jp$iterator.currentNode != jp$iterator.this$01.tail;){
                    jp = castTo($next_9(jp$iterator), 8);
                    jp.y_0 = offset - jp.y_0;
                }
                for(label$iterator0 = new ArrayList$1(edge.labels); label$iterator0.i < label$iterator0.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator0), 72);
                    $mirrorY_0(label_0.pos, offset - label_0.size_0.y_0);
                }
            }
            for(label$iterator1 = new ArrayList$1(port.labels); label$iterator1.i < label$iterator1.this$01.array.length;){
                label_0 = castTo($next_6(label$iterator1), 72);
                $mirrorY_0(label_0.pos, port.size_0.y_0 - label_0.size_0.y_0);
            }
        }
        if (node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
            $setProperty_0(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE), $getMirroredPortSideY(castTo($getProperty(node, EXT_PORT_SIDE), 64)));
            $mirrorInLayerConstraintY(node);
        }
        for(label$iterator = new ArrayList$1(node.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            $mirrorNodeLabelPlacementY(label_0);
            $mirrorY_0(label_0.pos, nodeSize.y_0 - label_0.size_0.y_0);
        }
    }
}
function $mirrorY_0(v, offset) {
    v.y_0 = offset - v.y_0;
}
function $mirrorY_1(spacing) {
    var oldBottom, oldTop;
    oldTop = spacing.top_0;
    oldBottom = spacing.bottom;
    spacing.top_0 = oldBottom;
    spacing.bottom = oldTop;
}
function $process_12(this$static, layeredGraph, monitor) {
    var congruency, layer, layer$iterator, nodes;
    monitor.begin('Graph transformation (' + this$static.mode + ')', 1);
    nodes = newArrayList(layeredGraph.layerlessNodes);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        $addAll_2(nodes, layer.nodes);
    }
    congruency = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), DIRECTION_CONGRUENCY_0)), 416);
    if (congruency == ($clinit_DirectionCongruency(), READING_DIRECTION)) switch(castTo($getProperty(layeredGraph, DIRECTION), 86).ordinal){
        case 2:
            $mirrorAllX(layeredGraph, nodes);
            break;
        case 3:
            $transposeAll(layeredGraph, nodes);
            break;
        case 4:
            if (this$static.mode == ($clinit_GraphTransformer$Mode(), TO_INTERNAL_LTR)) {
                $transposeAll(layeredGraph, nodes);
                $mirrorAllY(layeredGraph, nodes);
            } else {
                $mirrorAllY(layeredGraph, nodes);
                $transposeAll(layeredGraph, nodes);
            }
    }
    else if (this$static.mode == ($clinit_GraphTransformer$Mode(), TO_INTERNAL_LTR)) switch(castTo($getProperty(layeredGraph, DIRECTION), 86).ordinal){
        case 2:
            $mirrorAllX(layeredGraph, nodes);
            $mirrorAllY(layeredGraph, nodes);
            break;
        case 3:
            $transposeAll(layeredGraph, nodes);
            $mirrorAllX(layeredGraph, nodes);
            break;
        case 4:
            $mirrorAllX(layeredGraph, nodes);
            $transposeAll(layeredGraph, nodes);
    }
    else switch(castTo($getProperty(layeredGraph, DIRECTION), 86).ordinal){
        case 2:
            $mirrorAllX(layeredGraph, nodes);
            $mirrorAllY(layeredGraph, nodes);
            break;
        case 3:
            $mirrorAllX(layeredGraph, nodes);
            $transposeAll(layeredGraph, nodes);
            break;
        case 4:
            $transposeAll(layeredGraph, nodes);
            $mirrorAllX(layeredGraph, nodes);
    }
    monitor.done_1();
}
function $transpose(nodes) {
    var bendPoint, bendPoint$iterator, edge, edge$iterator, index_0, jp, jp$iterator, junctionPoints, label_0, label$iterator, label$iterator0, label$iterator1, node, node$iterator, port, port$iterator;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $transpose_0(node.pos);
        $transpose_0(node.size_0);
        $transpose_1(node.padding);
        $transposeNodeLabelPlacement(node);
        $transposeProperties(node);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            $transpose_0(port.pos);
            $transpose_0(port.anchor);
            $transpose_0(port.size_0);
            $setSide(port, $transposePortSide(port.side));
            index_0 = castTo($getProperty(port, ($clinit_LayeredOptions(), PORT_INDEX)), 17);
            !!index_0 && $setProperty_0(port, PORT_INDEX, valueOf_3(-index_0.value_0));
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                for(bendPoint$iterator = $listIterator_2(edge.bendPoints, 0); bendPoint$iterator.currentNode != bendPoint$iterator.this$01.tail;){
                    bendPoint = castTo($next_9(bendPoint$iterator), 8);
                    $transpose_0(bendPoint);
                }
                junctionPoints = castTo($getProperty(edge, JUNCTION_POINTS), 77);
                if (junctionPoints) for(jp$iterator = $listIterator_2(junctionPoints, 0); jp$iterator.currentNode != jp$iterator.this$01.tail;){
                    jp = castTo($next_9(jp$iterator), 8);
                    $transpose_0(jp);
                }
                for(label$iterator0 = new ArrayList$1(edge.labels); label$iterator0.i < label$iterator0.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator0), 72);
                    $transpose_0(label_0.pos);
                    $transpose_0(label_0.size_0);
                }
            }
            for(label$iterator1 = new ArrayList$1(port.labels); label$iterator1.i < label$iterator1.this$01.array.length;){
                label_0 = castTo($next_6(label$iterator1), 72);
                $transpose_0(label_0.pos);
                $transpose_0(label_0.size_0);
            }
        }
        if (node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
            $setProperty_0(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE), $transposePortSide(castTo($getProperty(node, EXT_PORT_SIDE), 64)));
            $transposeLayerConstraint(node);
        }
        for(label$iterator = new ArrayList$1(node.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            $transposeNodeLabelPlacement(label_0);
            $transpose_0(label_0.size_0);
            $transpose_0(label_0.pos);
        }
    }
}
function $transpose_0(v) {
    var temp;
    temp = v.x_0;
    v.x_0 = v.y_0;
    v.y_0 = temp;
}
function $transpose_1(spacing) {
    var oldBottom, oldLeft, oldRight, oldTop;
    oldTop = spacing.top_0;
    oldBottom = spacing.bottom;
    oldLeft = spacing.left;
    oldRight = spacing.right;
    spacing.top_0 = oldLeft;
    spacing.bottom = oldRight;
    spacing.left = oldTop;
    spacing.right = oldBottom;
}
function $transposeAll(layeredGraph, nodes) {
    var oldSide;
    $transpose(nodes);
    oldSide = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), EDGE_LABELS_SIDE_SELECTION_0)), 281);
    !!oldSide && $setProperty_0(layeredGraph, EDGE_LABELS_SIDE_SELECTION_0, $transpose_2(oldSide));
    $transpose_0(layeredGraph.offset);
    $transpose_0(layeredGraph.size_0);
    $transpose_1(layeredGraph.padding);
    $transpose_1(castTo($getProperty(layeredGraph, NODE_LABELS_PADDING), 213));
}
function $transposeLayerConstraint(node) {
    var inLayerConstraint, layerConstraint;
    layerConstraint = castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
    inLayerConstraint = castTo($getProperty(node, ($clinit_InternalProperties_1(), IN_LAYER_CONSTRAINT)), 312);
    if (layerConstraint == ($clinit_LayerConstraint(), FIRST_SEPARATE_0)) {
        $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, NONE_7);
        $setProperty_0(node, IN_LAYER_CONSTRAINT, ($clinit_InLayerConstraint(), TOP_1));
    } else if (layerConstraint == LAST_SEPARATE_0) {
        $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, NONE_7);
        $setProperty_0(node, IN_LAYER_CONSTRAINT, ($clinit_InLayerConstraint(), BOTTOM_0));
    } else if (inLayerConstraint == ($clinit_InLayerConstraint(), TOP_1)) {
        $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, FIRST_SEPARATE_0);
        $setProperty_0(node, IN_LAYER_CONSTRAINT, NONE_6);
    } else if (inLayerConstraint == BOTTOM_0) {
        $setProperty_0(node, LAYERING_LAYER_CONSTRAINT_0, LAST_SEPARATE_0);
        $setProperty_0(node, IN_LAYER_CONSTRAINT, NONE_6);
    }
}
function $transposeNodeLabelPlacement(shape_0) {
    var all, newPlacement, oldPlacement;
    if (!$hasProperty(shape_0, ($clinit_LayeredOptions(), NODE_LABELS_PLACEMENT_1))) return;
    oldPlacement = castTo($getProperty(shape_0, NODE_LABELS_PLACEMENT_1), 22);
    if (oldPlacement.isEmpty()) return;
    newPlacement = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    oldPlacement.contains(($clinit_NodeLabelPlacement(), INSIDE)) ? $add_5(newPlacement, INSIDE) : $add_5(newPlacement, OUTSIDE);
    oldPlacement.contains(H_PRIORITY) || $add_5(newPlacement, H_PRIORITY);
    oldPlacement.contains(H_LEFT_0) ? $add_5(newPlacement, V_TOP_0) : oldPlacement.contains(H_CENTER_0) ? $add_5(newPlacement, V_CENTER_0) : oldPlacement.contains(H_RIGHT_0) && $add_5(newPlacement, V_BOTTOM_0);
    oldPlacement.contains(V_TOP_0) ? $add_5(newPlacement, H_LEFT_0) : oldPlacement.contains(V_CENTER_0) ? $add_5(newPlacement, H_CENTER_0) : oldPlacement.contains(V_BOTTOM_0) && $add_5(newPlacement, H_RIGHT_0);
    $setProperty_0(shape_0, NODE_LABELS_PLACEMENT_1, newPlacement);
}
function $transposePortSide(side) {
    switch(side.ordinal){
        case 1:
            return $clinit_PortSide(), WEST_0;
        case 4:
            return $clinit_PortSide(), NORTH_1;
        case 3:
            return $clinit_PortSide(), EAST_0;
        case 2:
            return $clinit_PortSide(), SOUTH_0;
        default:
            return $clinit_PortSide(), UNDEFINED_5;
    }
}
function $transposeProperties(node) {
    var minSize, pos, tmp;
    minSize = castTo($getProperty(node, ($clinit_LayeredOptions(), NODE_SIZE_MINIMUM_0)), 8);
    $setProperty_0(node, NODE_SIZE_MINIMUM_0, new KVector_1(minSize.y_0, minSize.x_0));
    switch(castTo($getProperty(node, ALIGNMENT), 254).ordinal){
        case 1:
            $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), TOP_2));
            break;
        case 2:
            $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), BOTTOM_1));
            break;
        case 3:
            $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), LEFT_5));
            break;
        case 4:
            $setProperty_0(node, ALIGNMENT, ($clinit_Alignment(), RIGHT_5));
    }
    if ((!node.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : node.propertyMap).containsKey(POSITION)) {
        pos = castTo($getProperty(node, POSITION), 8);
        tmp = pos.x_0;
        pos.x_0 = pos.y_0;
        pos.y_0 = tmp;
    }
}
function GraphTransformer(themode) {
    this.mode = themode;
}
defineClass(783, 1, $intern_102, GraphTransformer);
_.process = function process_10(layeredGraph, monitor) {
    $process_12(this, castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_GraphTransformer_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'GraphTransformer', 783);
function $clinit_GraphTransformer$Mode() {
    $clinit_GraphTransformer$Mode = emptyMethod;
    TO_INTERNAL_LTR = new GraphTransformer$Mode('TO_INTERNAL_LTR', 0);
    TO_INPUT_DIRECTION = new GraphTransformer$Mode('TO_INPUT_DIRECTION', 1);
}
function GraphTransformer$Mode(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_23(name_0) {
    $clinit_GraphTransformer$Mode();
    return valueOf(($clinit_GraphTransformer$Mode$Map(), $MAP_13), name_0);
}
function values_31() {
    $clinit_GraphTransformer$Mode();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_GraphTransformer$Mode_2_classLit, 1), $intern_36, 501, 0, [
        TO_INTERNAL_LTR,
        TO_INPUT_DIRECTION
    ]);
}
defineClass(501, 23, {
    3: 1,
    34: 1,
    23: 1,
    501: 1
}, GraphTransformer$Mode);
var TO_INPUT_DIRECTION, TO_INTERNAL_LTR;
var Lorg_eclipse_elk_alg_layered_intermediate_GraphTransformer$Mode_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate', 'GraphTransformer/Mode', 501, Ljava_lang_Enum_2_classLit, values_31, valueOf_23);
function $clinit_GraphTransformer$Mode$Map() {
    $clinit_GraphTransformer$Mode$Map = emptyMethod;
    $MAP_13 = createValueOfMap(($clinit_GraphTransformer$Mode(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_GraphTransformer$Mode_2_classLit, 1), $intern_36, 501, 0, [
        TO_INTERNAL_LTR,
        TO_INPUT_DIRECTION
    ])));
}
var $MAP_13;
function $graphLayoutToNode(node, lgraph) {
    var actualGraphSize, childNode, childNode$iterator, origin_0, port, portPosition;
    for(childNode$iterator = new ArrayList$1(lgraph.layerlessNodes); childNode$iterator.i < childNode$iterator.this$01.array.length;){
        childNode = castTo($next_6(childNode$iterator), 9);
        origin_0 = $getProperty(childNode, ($clinit_InternalProperties_1(), ORIGIN_0));
        if (instanceOf(origin_0, 11)) {
            port = castTo(origin_0, 11);
            portPosition = getExternalPortPosition(lgraph, childNode, port.size_0.x_0, port.size_0.y_0);
            port.pos.x_0 = portPosition.x_0;
            port.pos.y_0 = portPosition.y_0;
            $setSide(port, castTo($getProperty(childNode, EXT_PORT_SIDE), 64));
        }
    }
    actualGraphSize = new KVector_1(lgraph.size_0.x_0 + lgraph.padding.left + lgraph.padding.right, lgraph.size_0.y_0 + lgraph.padding.top_0 + lgraph.padding.bottom);
    if (castTo($getProperty(lgraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS))) {
        $setProperty_0(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
        castTo($getProperty($getGraph(node), GRAPH_PROPERTIES), 22).add_2(NON_FREE_PORTS);
        resizeNode(node, actualGraphSize, false);
    } else resizeNode(node, actualGraphSize, true);
}
function $process_13(graph, progressMonitor) {
    var layer, layer$iterator, node, node$iterator;
    progressMonitor.begin('Resize child graph to fit parent.', 1);
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        $addAll_2(graph.layerlessNodes, layer.nodes);
        layer.nodes.array.length = 0;
    }
    for(node$iterator = new ArrayList$1(graph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $setLayer_0(node, null);
    }
    graph.layers.array.length = 0;
    $resizeGraph_0(graph);
    !!graph.parentNode && $graphLayoutToNode(graph.parentNode, graph);
    progressMonitor.done_1();
}
function $resizeGraph_0(lgraph) {
    var adjustedSize, calculatedSize, minSize, sizeConstraint, sizeOptions;
    sizeConstraint = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1)), 22);
    sizeOptions = castTo($getProperty(lgraph, NODE_SIZE_OPTIONS_1), 22);
    calculatedSize = new KVector_1(lgraph.size_0.x_0 + lgraph.padding.left + lgraph.padding.right, lgraph.size_0.y_0 + lgraph.padding.top_0 + lgraph.padding.bottom);
    adjustedSize = new KVector_2(calculatedSize);
    if (sizeConstraint.contains(($clinit_SizeConstraint(), MINIMUM_SIZE))) {
        minSize = castTo($getProperty(lgraph, NODE_SIZE_MINIMUM_0), 8);
        if (sizeOptions.contains(($clinit_SizeOptions(), DEFAULT_MINIMUM_SIZE))) {
            minSize.x_0 <= 0 && (minSize.x_0 = 20);
            minSize.y_0 <= 0 && (minSize.y_0 = 20);
        }
        adjustedSize.x_0 = $wnd.Math.max(calculatedSize.x_0, minSize.x_0);
        adjustedSize.y_0 = $wnd.Math.max(calculatedSize.y_0, minSize.y_0);
    }
    $resizeGraphNoReallyIMeanIt_0(lgraph, calculatedSize, adjustedSize);
}
function $resizeGraphNoReallyIMeanIt_0(lgraph, oldSize, newSize) {
    var contentAlignment, extPortSide, node, node$iterator, padding;
    contentAlignment = castTo($getProperty(lgraph, ($clinit_LayeredOptions(), CONTENT_ALIGNMENT)), 22);
    newSize.x_0 > oldSize.x_0 && (contentAlignment.contains(($clinit_ContentAlignment(), H_CENTER)) ? lgraph.offset.x_0 += (newSize.x_0 - oldSize.x_0) / 2 : contentAlignment.contains(H_RIGHT) && (lgraph.offset.x_0 += newSize.x_0 - oldSize.x_0));
    newSize.y_0 > oldSize.y_0 && (contentAlignment.contains(($clinit_ContentAlignment(), V_CENTER)) ? lgraph.offset.y_0 += (newSize.y_0 - oldSize.y_0) / 2 : contentAlignment.contains(V_BOTTOM) && (lgraph.offset.y_0 += newSize.y_0 - oldSize.y_0));
    if (castTo($getProperty(lgraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) && (newSize.x_0 > oldSize.x_0 || newSize.y_0 > oldSize.y_0)) for(node$iterator = new ArrayList$1(lgraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
            extPortSide = castTo($getProperty(node, EXT_PORT_SIDE), 64);
            extPortSide == ($clinit_PortSide(), EAST_0) ? node.pos.x_0 += newSize.x_0 - oldSize.x_0 : extPortSide == SOUTH_0 && (node.pos.y_0 += newSize.y_0 - oldSize.y_0);
        }
    }
    padding = lgraph.padding;
    lgraph.size_0.x_0 = newSize.x_0 - padding.left - padding.right;
    lgraph.size_0.y_0 = newSize.y_0 - padding.top_0 - padding.bottom;
}
function HierarchicalNodeResizingProcessor() {}
defineClass(1515, 1, $intern_102, HierarchicalNodeResizingProcessor);
_.process = function process_11(graph, progressMonitor) {
    $process_13(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalNodeResizingProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalNodeResizingProcessor', 1515);
function $createDummy(layeredGraph, originalDummy) {
    var inputPort, newDummy, outputPort;
    newDummy = new LNode(layeredGraph);
    $copyProperties(newDummy, originalDummy);
    $setProperty_0(newDummy, ($clinit_InternalProperties_1(), EXT_PORT_REPLACED_DUMMY), originalDummy);
    $setProperty_0(newDummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    $setProperty_0(newDummy, ALIGNMENT, ($clinit_Alignment(), CENTER_4));
    $setType(newDummy, ($clinit_LNode$NodeType(), EXTERNAL_PORT));
    inputPort = new LPort;
    $setNode(inputPort, newDummy);
    $setSide(inputPort, ($clinit_PortSide(), WEST_0));
    outputPort = new LPort;
    $setNode(outputPort, newDummy);
    $setSide(outputPort, EAST_0);
    return newDummy;
}
function $isNorthernOrSouthernDummy(node) {
    var nodeType, portSide;
    nodeType = node.type_0;
    if (nodeType == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
        portSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        return portSide == ($clinit_PortSide(), NORTH_1) || portSide == SOUTH_0;
    }
    return false;
}
function $process_14(layeredGraph, monitor) {
    monitor.begin('Hierarchical port constraint processing', 1);
    $processEasternAndWesternPortDummies(layeredGraph);
    $processNorthernAndSouthernPortDummies(layeredGraph);
    monitor.done_1();
}
function $processEasternAndWesternPortDummies(layeredGraph) {
    var layers;
    if (!$isOrderFixed(castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100))) return;
    layers = layeredGraph.layers;
    $processEasternAndWesternPortDummies_0((checkCriticalElementIndex(0, layers.array.length), castTo(layers.array[0], 25)));
    $processEasternAndWesternPortDummies_0(castTo($get_11(layers, layers.array.length - 1), 25));
}
function $processEasternAndWesternPortDummies_0(layer) {
    var externalPortSide, lastHierarchicalDummy, node, node$array, node$index, node$max, nodes;
    nodes = toNodeArray(layer.nodes);
    sort_5(nodes, new HierarchicalPortConstraintProcessor$NodeComparator);
    lastHierarchicalDummy = null;
    for(node$array = nodes, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) break;
        externalPortSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        if (externalPortSide != ($clinit_PortSide(), WEST_0) && externalPortSide != EAST_0) continue;
        !!lastHierarchicalDummy && castTo($getProperty(lastHierarchicalDummy, IN_LAYER_SUCCESSOR_CONSTRAINTS), 15).add_2(node);
        lastHierarchicalDummy = node;
    }
}
function $processNorthernAndSouthernPortDummies(layeredGraph) {
    var currLayerIdx, currentLayer, currentNode, currentNode$iterator, dummy, dummy$iterator, edge, edge$iterator, edge$iterator0, extPortToDummyNodeMap, i, layer, layerCount, layers, newDummyNodes, nextExtPortToDummyNodesMap, nextLayerDummy, nextNewDummyNodes, nodeList, originalDummy, originalDummy$iterator, originalExternalPortDummies, portConstraints, prevExtPortToDummyNodesMap, prevLayerDummy, prevNewDummyNodes, sourceNode, targetNode;
    portConstraints = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    if (!(portConstraints != ($clinit_PortConstraints(), FREE) && portConstraints != UNDEFINED_4)) return;
    layers = layeredGraph.layers;
    layerCount = layers.array.length;
    extPortToDummyNodeMap = new ArrayList_0((checkNonnegative(layerCount + 2, 'arraySize'), saturatedCast(add_20(add_20(5, layerCount + 2), (layerCount + 2) / 10 | 0))));
    newDummyNodes = new ArrayList_0((checkNonnegative(layerCount + 2, 'arraySize'), saturatedCast(add_20(add_20(5, layerCount + 2), (layerCount + 2) / 10 | 0))));
    $add_3(extPortToDummyNodeMap, new HashMap);
    $add_3(extPortToDummyNodeMap, new HashMap);
    $add_3(newDummyNodes, new ArrayList);
    $add_3(newDummyNodes, new ArrayList);
    originalExternalPortDummies = new ArrayList;
    for(currLayerIdx = 0; currLayerIdx < layerCount; currLayerIdx++){
        currentLayer = (checkCriticalElementIndex(currLayerIdx, layers.array.length), castTo(layers.array[currLayerIdx], 25));
        prevExtPortToDummyNodesMap = (checkCriticalElementIndex(currLayerIdx, extPortToDummyNodeMap.array.length), castTo(extPortToDummyNodeMap.array[currLayerIdx], 91));
        nextExtPortToDummyNodesMap = new HashMap;
        push_1(extPortToDummyNodeMap.array, nextExtPortToDummyNodesMap);
        prevNewDummyNodes = (checkCriticalElementIndex(currLayerIdx, newDummyNodes.array.length), castTo(newDummyNodes.array[currLayerIdx], 15));
        nextNewDummyNodes = new ArrayList;
        push_1(newDummyNodes.array, nextNewDummyNodes);
        for(currentNode$iterator = new ArrayList$1(currentLayer.nodes); currentNode$iterator.i < currentNode$iterator.this$01.array.length;){
            currentNode = castTo($next_6(currentNode$iterator), 9);
            if ($isNorthernOrSouthernDummy(currentNode)) {
                push_1(originalExternalPortDummies.array, currentNode);
                continue;
            }
            for(edge$iterator0 = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(currentNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator0);){
                edge = castTo($next_0(edge$iterator0), 18);
                sourceNode = edge.source.owner;
                if (!$isNorthernOrSouthernDummy(sourceNode)) continue;
                prevLayerDummy = castTo(prevExtPortToDummyNodesMap.get_3($getProperty(sourceNode, ($clinit_InternalProperties_1(), ORIGIN_0))), 9);
                if (!prevLayerDummy) {
                    prevLayerDummy = $createDummy(layeredGraph, sourceNode);
                    prevExtPortToDummyNodesMap.put($getProperty(sourceNode, ORIGIN_0), prevLayerDummy);
                    prevNewDummyNodes.add_2(prevLayerDummy);
                }
                $setSource_0(edge, castTo($get_11(prevLayerDummy.ports, 1), 11));
            }
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(currentNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                targetNode = edge.target.owner;
                if (!$isNorthernOrSouthernDummy(targetNode)) continue;
                nextLayerDummy = castTo($get_10(nextExtPortToDummyNodesMap, $getProperty(targetNode, ($clinit_InternalProperties_1(), ORIGIN_0))), 9);
                if (!nextLayerDummy) {
                    nextLayerDummy = $createDummy(layeredGraph, targetNode);
                    $put_6(nextExtPortToDummyNodesMap, $getProperty(targetNode, ORIGIN_0), nextLayerDummy);
                    push_1(nextNewDummyNodes.array, nextLayerDummy);
                }
                $setTarget_0(edge, castTo($get_11(nextLayerDummy.ports, 0), 11));
            }
        }
    }
    for(i = 0; i < newDummyNodes.array.length; i++){
        nodeList = (checkCriticalElementIndex(i, newDummyNodes.array.length), castTo(newDummyNodes.array[i], 15));
        if (nodeList.isEmpty()) continue;
        layer = null;
        if (i == 0) {
            layer = new Layer(layeredGraph);
            checkCriticalPositionIndex(0, layers.array.length);
            insertTo(layers.array, 0, layer);
        } else if (i == extPortToDummyNodeMap.array.length - 1) {
            layer = new Layer(layeredGraph);
            push_1(layers.array, layer);
        } else layer = (checkCriticalElementIndex(i - 1, layers.array.length), castTo(layers.array[i - 1], 25));
        for(dummy$iterator = nodeList.iterator_0(); dummy$iterator.hasNext_0();){
            dummy = castTo(dummy$iterator.next_1(), 9);
            $setLayer_0(dummy, layer);
        }
    }
    for(originalDummy$iterator = new ArrayList$1(originalExternalPortDummies); originalDummy$iterator.i < originalDummy$iterator.this$01.array.length;){
        originalDummy = castTo($next_6(originalDummy$iterator), 9);
        $setLayer_0(originalDummy, null);
    }
    $setProperty_0(layeredGraph, ($clinit_InternalProperties_1(), EXT_PORT_REPLACED_DUMMIES), originalExternalPortDummies);
}
function HierarchicalPortConstraintProcessor() {}
defineClass(1516, 1, $intern_102, HierarchicalPortConstraintProcessor);
_.process = function process_12(layeredGraph, monitor) {
    $process_14(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortConstraintProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortConstraintProcessor', 1516);
function $compare_6(node1, node2) {
    var nodePos1, nodePos2, nodeType1, nodeType2;
    nodeType1 = node1.type_0;
    nodePos1 = $doubleValue(castToDouble($getProperty(node1, ($clinit_InternalProperties_1(), PORT_RATIO_OR_POSITION_0))));
    nodeType2 = node2.type_0;
    nodePos2 = $doubleValue(castToDouble($getProperty(node2, PORT_RATIO_OR_POSITION_0)));
    return nodeType2 != ($clinit_LNode$NodeType(), EXTERNAL_PORT) ? -1 : nodeType1 != EXTERNAL_PORT ? 1 : nodePos1 == nodePos2 ? 0 : nodePos1 < nodePos2 ? -1 : 1;
}
function HierarchicalPortConstraintProcessor$NodeComparator() {}
defineClass(1517, 1, $intern_88, HierarchicalPortConstraintProcessor$NodeComparator);
_.compare_1 = function compare_37(node1, node2) {
    return $compare_6(castTo(node1, 9), castTo(node2, 9));
};
_.equals_0 = function equals_101(other) {
    return this === other;
};
_.reversed = function reversed_29() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortConstraintProcessor$NodeComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortConstraintProcessor/NodeComparator', 1517);
function $process_15(layeredGraph, monitor) {
    var delta, edgeSpacing, layer, layer$iterator, node, node$iterator, northernDummies, side, southernDummies;
    monitor.begin('Hierarchical port dummy size processing', 1);
    northernDummies = new ArrayList;
    southernDummies = new ArrayList;
    edgeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE_BETWEEN_LAYERS_0))));
    delta = edgeSpacing * 2;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        northernDummies.array.length = 0;
        southernDummies.array.length = 0;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) {
                side = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
                side == ($clinit_PortSide(), NORTH_1) ? push_1(northernDummies.array, node) : side == SOUTH_0 && push_1(southernDummies.array, node);
            }
        }
        $setWidths(northernDummies, true, delta);
        $setWidths(southernDummies, false, delta);
    }
    monitor.done_1();
}
function $setWidths(nodes, topDown, delta) {
    var currentWidth, node, node$iterator, port, port$iterator, step;
    currentWidth = 0;
    step = delta;
    if (!topDown) {
        currentWidth = delta * (nodes.array.length - 1);
        step *= -1;
    }
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $setProperty_0(node, ($clinit_LayeredOptions(), ALIGNMENT), ($clinit_Alignment(), CENTER_4));
        node.size_0.x_0 = currentWidth;
        for(port$iterator = $getPorts_1(node, ($clinit_PortSide(), EAST_0)).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            port.pos.x_0 = currentWidth;
        }
        currentWidth += step;
    }
}
function HierarchicalPortDummySizeProcessor() {}
defineClass(1518, 1, $intern_102, HierarchicalPortDummySizeProcessor);
_.process = function process_13(layeredGraph, monitor) {
    $process_15(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortDummySizeProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortDummySizeProcessor', 1518);
function $assignAscendingCoordinates(dummies, graph) {
    var currentMargin, currentPosition, currentSize, delta, graphSize, index_0, nextValidCoordinate, spacing;
    spacing = $doubleValue(castToDouble($getProperty(graph, ($clinit_LayeredOptions(), SPACING_PORT_PORT))));
    nextValidCoordinate = dummies[0].pos.x_0 + dummies[0].size_0.x_0 + dummies[0].margin.right + spacing;
    for(index_0 = 1; index_0 < dummies.length; index_0++){
        currentPosition = dummies[index_0].pos;
        currentSize = dummies[index_0].size_0;
        currentMargin = dummies[index_0].margin;
        delta = currentPosition.x_0 - currentMargin.left - nextValidCoordinate;
        delta < 0 && (currentPosition.x_0 -= delta);
        graphSize = graph.size_0;
        graphSize.x_0 = $wnd.Math.max(graphSize.x_0, currentPosition.x_0 + currentSize.x_0);
        nextValidCoordinate = currentPosition.x_0 + currentSize.x_0 + currentMargin.right + spacing;
    }
}
function $calculateNorthSouthDummyPositions(dummy) {
    var anchor, connectedPort, connectedPort$iterator, dummyInPort, offset, posSum;
    dummyInPort = castTo($get_11(dummy.ports, 0), 11);
    if (dummyInPort.incomingEdges.array.length + dummyInPort.outgoingEdges.array.length == 0) dummy.pos.x_0 = 0;
    else {
        posSum = 0;
        for(connectedPort$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
            new LPort$1(dummyInPort),
            new LPort$2(dummyInPort)
        ]))); $hasNext_1(connectedPort$iterator);){
            connectedPort = castTo($next_0(connectedPort$iterator), 11);
            posSum += connectedPort.owner.pos.x_0 + connectedPort.pos.x_0 + connectedPort.anchor.x_0;
        }
        anchor = castTo($getProperty(dummy, ($clinit_LayeredOptions(), PORT_ANCHOR)), 8);
        offset = !anchor ? 0 : anchor.x_0;
        dummy.pos.x_0 = posSum / (dummyInPort.incomingEdges.array.length + dummyInPort.outgoingEdges.array.length) - offset;
    }
}
function $correctSlantedEdgeSegments(layer) {
    var bendPoints, edge, edge$iterator, extPortSide, firstBendPoint, lastBendPoint, node, node$iterator, sourcePort, targetPort;
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
        extPortSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        if (extPortSide == ($clinit_PortSide(), EAST_0) || extPortSide == WEST_0) for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            bendPoints = edge.bendPoints;
            if (bendPoints.size_0 == 0) continue;
            sourcePort = edge.source;
            if (sourcePort.owner == node) {
                firstBendPoint = (checkCriticalElement(bendPoints.size_0 != 0), castTo(bendPoints.header.next_0.value_0, 8));
                firstBendPoint.y_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    sourcePort.owner.pos,
                    sourcePort.pos,
                    sourcePort.anchor
                ])).y_0;
            }
            targetPort = edge.target;
            if (targetPort.owner == node) {
                lastBendPoint = (checkCriticalElement(bendPoints.size_0 != 0), castTo(bendPoints.tail.prev.value_0, 8));
                lastBendPoint.y_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    targetPort.owner.pos,
                    targetPort.pos,
                    targetPort.anchor
                ])).y_0;
            }
        }
    }
}
function $ensureUniquePositions(dummies, graph) {
    var dummyArray;
    if (dummies.array.length == 0) return;
    dummyArray = castTo($toArray_1(dummies, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, dummies.array.length, 0, 1)), 199);
    sort_5(dummyArray, new HierarchicalPortOrthogonalEdgeRouter$1);
    $assignAscendingCoordinates(dummyArray, graph);
}
function $fixCoordinates(layer, constraints, graph) {
    var extPortSide, extPortSize, graphActualSize, newActualGraphHeight, node, node$iterator, node$iterator0, nodePosition, offset, padding, ratio, requiredActualGraphHeight;
    padding = graph.padding;
    offset = graph.offset;
    graphActualSize = new KVector_1(graph.size_0.x_0 + graph.padding.left + graph.padding.right, graph.size_0.y_0 + graph.padding.top_0 + graph.padding.bottom);
    newActualGraphHeight = graphActualSize.y_0;
    for(node$iterator0 = new ArrayList$1(layer.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
        extPortSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        extPortSize = castTo($getProperty(node, EXT_PORT_SIZE), 8);
        nodePosition = node.pos;
        switch(extPortSide.ordinal){
            case 2:
                nodePosition.x_0 = graph.size_0.x_0 + padding.right - offset.x_0;
                break;
            case 4:
                nodePosition.x_0 = -offset.x_0 - padding.left;
        }
        requiredActualGraphHeight = 0;
        switch(extPortSide.ordinal){
            case 2:
            case 4:
                if (constraints == ($clinit_PortConstraints(), FIXED_RATIO)) {
                    ratio = $doubleValue(castToDouble($getProperty(node, PORT_RATIO_OR_POSITION_0)));
                    nodePosition.y_0 = graphActualSize.y_0 * ratio - castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_ANCHOR)), 8).y_0;
                    requiredActualGraphHeight = nodePosition.y_0 + extPortSize.y_0;
                    $borderToContentAreaCoordinates(node, false, true);
                } else if (constraints == FIXED_POS) {
                    nodePosition.y_0 = $doubleValue(castToDouble($getProperty(node, PORT_RATIO_OR_POSITION_0))) - castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_ANCHOR)), 8).y_0;
                    requiredActualGraphHeight = nodePosition.y_0 + extPortSize.y_0;
                    $borderToContentAreaCoordinates(node, false, true);
                }
        }
        newActualGraphHeight = $wnd.Math.max(newActualGraphHeight, requiredActualGraphHeight);
    }
    graph.size_0.y_0 += newActualGraphHeight - graphActualSize.y_0;
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
        extPortSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        nodePosition = node.pos;
        switch(extPortSide.ordinal){
            case 1:
                nodePosition.y_0 = -offset.y_0 - padding.top_0;
                break;
            case 3:
                nodePosition.y_0 = graph.size_0.y_0 + padding.bottom - offset.y_0;
        }
    }
}
function $process_16(this$static, layeredGraph, monitor) {
    var northSouthDummies, constraints, layers, layers_0;
    monitor.begin('Orthogonally routing hierarchical port edges', 1);
    this$static.northernExtPortEdgeRoutingHeight = 0;
    northSouthDummies = $restoreNorthSouthDummies(layeredGraph);
    $setNorthSouthDummyCoordinates(layeredGraph, northSouthDummies);
    $routeEdges(this$static, layeredGraph, northSouthDummies);
    $removeTemporaryNorthSouthDummies(layeredGraph);
    constraints = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    layers = layeredGraph.layers;
    $fixCoordinates((checkCriticalElementIndex(0, layers.array.length), castTo(layers.array[0], 25)), constraints, layeredGraph);
    $fixCoordinates(castTo($get_11(layers, layers.array.length - 1), 25), constraints, layeredGraph);
    layers_0 = layeredGraph.layers;
    $correctSlantedEdgeSegments((checkCriticalElementIndex(0, layers_0.array.length), castTo(layers_0.array[0], 25)));
    $correctSlantedEdgeSegments(castTo($get_11(layers_0, layers_0.array.length - 1), 25));
    monitor.done_1();
}
function $removeTemporaryNorthSouthDummies(layeredGraph) {
    var edge, edge$array, edge$array0, edge$index, edge$index0, edge$max, edge$max0, edges, firstBendPoint, incomingEdgeBendPoints, iter, lastBendPoint, layer, layer$iterator, node, node$iterator, node$iterator0, nodeInPort, nodeOriginPort, nodeOutPort, nodeToOriginEdge, nodesToRemove, outgoingEdgeBendPoints, port, port$iterator, replacedDummy, replacedDummyPort;
    nodesToRemove = new ArrayList;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator0 = new ArrayList$1(layer.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
            if (!$hasProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_REPLACED_DUMMY))) continue;
            nodeInPort = null;
            nodeOutPort = null;
            nodeOriginPort = null;
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                switch(port.side.ordinal){
                    case 4:
                        nodeInPort = port;
                        break;
                    case 2:
                        nodeOutPort = port;
                        break;
                    default:
                        nodeOriginPort = port;
                }
            }
            nodeToOriginEdge = castTo($get_11(nodeOriginPort.outgoingEdges, 0), 18);
            incomingEdgeBendPoints = new KVectorChain_0(nodeToOriginEdge.bendPoints);
            firstBendPoint = new KVector_2(nodeOriginPort.pos);
            $add_19(firstBendPoint, node.pos);
            iter = $listIterator_2(incomingEdgeBendPoints, 0);
            $add_8(iter, firstBendPoint);
            outgoingEdgeBendPoints = reverse_3(nodeToOriginEdge.bendPoints);
            lastBendPoint = new KVector_2(nodeOriginPort.pos);
            $add_19(lastBendPoint, node.pos);
            $addNode_0(outgoingEdgeBendPoints, lastBendPoint, outgoingEdgeBendPoints.tail.prev, outgoingEdgeBendPoints.tail);
            replacedDummy = castTo($getProperty(node, EXT_PORT_REPLACED_DUMMY), 9);
            replacedDummyPort = castTo($get_11(replacedDummy.ports, 0), 11);
            edges = castTo($toArray_1(nodeInPort.incomingEdges, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LEdge_2_classLit, $intern_103, 18, 0, 0, 1)), 469);
            for(edge$array0 = edges, edge$index0 = 0, edge$max0 = edge$array0.length; edge$index0 < edge$max0; ++edge$index0){
                edge = edge$array0[edge$index0];
                $setTarget_0(edge, replacedDummyPort);
                $addAllAsCopies(edge.bendPoints, edge.bendPoints.size_0, incomingEdgeBendPoints);
            }
            edges = toEdgeArray(nodeOutPort.outgoingEdges);
            for(edge$array = edges, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                edge = edge$array[edge$index];
                $setSource_0(edge, replacedDummyPort);
                $addAllAsCopies(edge.bendPoints, 0, outgoingEdgeBendPoints);
            }
            $setSource_0(nodeToOriginEdge, null);
            $setTarget_0(nodeToOriginEdge, null);
            push_1(nodesToRemove.array, node);
        }
    }
    for(node$iterator = new ArrayList$1(nodesToRemove); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $setLayer_0(node, null);
    }
}
function $restoreDummy(dummy, graph) {
    var currentY, dummyPort, label_0, label$iterator, labelLabelSpacing, portLabelPlacement, portLabelSpacingHorizontal, portLabelSpacingVertical, portSide, xCenterRelativeToPort;
    portSide = castTo($getProperty(dummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
    dummyPort = castTo($get_11(dummy.ports, 0), 11);
    portSide == ($clinit_PortSide(), NORTH_1) ? $setSide(dummyPort, SOUTH_0) : portSide == SOUTH_0 && $setSide(dummyPort, NORTH_1);
    if (castTo($getProperty(graph, ($clinit_LayeredOptions(), NODE_SIZE_CONSTRAINTS_1)), 181).contains(($clinit_SizeConstraint(), PORT_LABELS))) {
        portLabelSpacingHorizontal = $doubleValue(castToDouble($getProperty(dummy, SPACING_LABEL_PORT_HORIZONTAL)));
        portLabelSpacingVertical = $doubleValue(castToDouble($getProperty(dummy, SPACING_LABEL_PORT_VERTICAL)));
        labelLabelSpacing = $doubleValue(castToDouble($getProperty(dummy, SPACING_LABEL_LABEL)));
        portLabelPlacement = castTo($getProperty(graph, PORT_LABELS_PLACEMENT_1), 22);
        if (portLabelPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0))) {
            currentY = portLabelSpacingVertical;
            xCenterRelativeToPort = dummy.size_0.x_0 / 2 - dummyPort.pos.x_0;
            for(label$iterator = new ArrayList$1(dummyPort.labels); label$iterator.i < label$iterator.this$01.array.length;){
                label_0 = castTo($next_6(label$iterator), 72);
                label_0.pos.y_0 = currentY;
                label_0.pos.x_0 = xCenterRelativeToPort - label_0.size_0.x_0 / 2;
                currentY += label_0.size_0.y_0 + labelLabelSpacing;
            }
        } else if (portLabelPlacement.contains(OUTSIDE_0)) for(label$iterator = new ArrayList$1(dummyPort.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            label_0.pos.x_0 = portLabelSpacingHorizontal + dummy.size_0.x_0 - dummyPort.pos.x_0;
        }
        $processNode(new NodeMarginCalculator(($clinit_LGraphAdapters(), new LGraphAdapters$LGraphAdapter(graph, false, false, new LGraphAdapters$lambda$0$Type))), new LGraphAdapters$LNodeAdapter(null, dummy, false));
    }
}
function $restoreNorthSouthDummies(layeredGraph) {
    var dummy, dummy$iterator, dummy$iterator0, layer, layer$iterator, node, node$iterator, replacedDummy, restoredDummies, outPort, extPortSide, inPort, edge;
    restoredDummies = new ArrayList;
    if (!$hasProperty(layeredGraph, ($clinit_InternalProperties_1(), EXT_PORT_REPLACED_DUMMIES))) return restoredDummies;
    for(dummy$iterator0 = castTo($getProperty(layeredGraph, EXT_PORT_REPLACED_DUMMIES), 15).iterator_0(); dummy$iterator0.hasNext_0();){
        dummy = castTo(dummy$iterator0.next_1(), 9);
        $restoreDummy(dummy, layeredGraph);
        push_1(restoredDummies.array, dummy);
    }
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
            replacedDummy = castTo($getProperty(node, EXT_PORT_REPLACED_DUMMY), 9);
            !!replacedDummy && (outPort = new LPort, $setNode(outPort, node), extPortSide = castTo($getProperty(node, EXT_PORT_SIDE), 64), $setSide(outPort, extPortSide), inPort = castTo($get_11(replacedDummy.ports, 0), 11), edge = new LEdge, $setSource_0(edge, outPort), $setTarget_0(edge, inPort), undefined);
        }
    }
    for(dummy$iterator = new ArrayList$1(restoredDummies); dummy$iterator.i < dummy$iterator.this$01.array.length;){
        dummy = castTo($next_6(dummy$iterator), 9);
        $setLayer_0(dummy, castTo($get_11(layeredGraph.layers, layeredGraph.layers.array.length - 1), 25));
    }
    return restoredDummies;
}
function $restoreProperOrder(dummies, graph) {
    var dummyArray;
    if (dummies.array.length == 0) return;
    dummyArray = castTo($toArray_1(dummies, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, dummies.array.length, 0, 1)), 199);
    sort_5(dummyArray, new HierarchicalPortOrthogonalEdgeRouter$2);
    $assignAscendingCoordinates(dummyArray, graph);
}
function $routeEdges(this$static, layeredGraph, northSouthDummies) {
    var edge, edge$iterator, edgeSpacing, hierarchicalPortDummy, hierarchicalPortDummy$iterator, nodeSpacing, northernSourceLayer, northernTargetLayer, portSide, routingGenerator, slots, southernSourceLayer, southernTargetLayer;
    northernSourceLayer = new LinkedHashSet;
    northernTargetLayer = new LinkedHashSet;
    southernSourceLayer = new LinkedHashSet;
    southernTargetLayer = new LinkedHashSet;
    nodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0))));
    edgeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_EDGE)));
    for(hierarchicalPortDummy$iterator = new ArrayList$1(northSouthDummies); hierarchicalPortDummy$iterator.i < hierarchicalPortDummy$iterator.this$01.array.length;){
        hierarchicalPortDummy = castTo($next_6(hierarchicalPortDummy$iterator), 9);
        portSide = castTo($getProperty(hierarchicalPortDummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        if (portSide == ($clinit_PortSide(), NORTH_1)) {
            northernTargetLayer.map_0.put(hierarchicalPortDummy, northernTargetLayer);
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(hierarchicalPortDummy).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                $add_6(northernSourceLayer, edge.source.owner);
            }
        } else if (portSide == SOUTH_0) {
            southernTargetLayer.map_0.put(hierarchicalPortDummy, southernTargetLayer);
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(hierarchicalPortDummy).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                $add_6(southernSourceLayer, edge.source.owner);
            }
        }
    }
    if (northernSourceLayer.map_0.size_1() != 0) {
        routingGenerator = new OrthogonalRoutingGenerator(2, edgeSpacing);
        slots = $routeEdges_0(routingGenerator, layeredGraph, northernSourceLayer, northernTargetLayer, -nodeSpacing - layeredGraph.offset.y_0);
        if (slots > 0) {
            this$static.northernExtPortEdgeRoutingHeight = nodeSpacing + (slots - 1) * edgeSpacing;
            layeredGraph.offset.y_0 += this$static.northernExtPortEdgeRoutingHeight;
            layeredGraph.size_0.y_0 += this$static.northernExtPortEdgeRoutingHeight;
        }
    }
    if (southernSourceLayer.map_0.size_1() != 0) {
        routingGenerator = new OrthogonalRoutingGenerator(1, edgeSpacing);
        slots = $routeEdges_0(routingGenerator, layeredGraph, southernSourceLayer, southernTargetLayer, layeredGraph.size_0.y_0 + nodeSpacing - layeredGraph.offset.y_0);
        slots > 0 && (layeredGraph.size_0.y_0 += nodeSpacing + (slots - 1) * edgeSpacing);
    }
}
function $setNorthSouthDummyCoordinates(layeredGraph, northSouthDummies) {
    var constraints, dummy, dummy$iterator, graphPadding, graphSize, graphWidth, northY, northernDummies, southY, southernDummies, anchor, offset, anchor_0, offset_0;
    constraints = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    graphSize = layeredGraph.size_0;
    graphPadding = layeredGraph.padding;
    graphWidth = graphSize.x_0 + graphPadding.left + graphPadding.right;
    northY = 0 - graphPadding.top_0 - layeredGraph.offset.y_0;
    southY = graphSize.y_0 + graphPadding.top_0 + graphPadding.bottom - layeredGraph.offset.y_0;
    northernDummies = new ArrayList;
    southernDummies = new ArrayList;
    for(dummy$iterator = new ArrayList$1(northSouthDummies); dummy$iterator.i < dummy$iterator.this$01.array.length;){
        dummy = castTo($next_6(dummy$iterator), 9);
        switch(constraints.ordinal){
            case 1:
            case 2:
            case 3:
                $calculateNorthSouthDummyPositions(dummy);
                break;
            case 4:
                anchor = castTo($getProperty(dummy, PORT_ANCHOR), 8);
                offset = !anchor ? 0 : anchor.x_0;
                dummy.pos.x_0 = graphWidth * $doubleValue(castToDouble($getProperty(dummy, ($clinit_InternalProperties_1(), PORT_RATIO_OR_POSITION_0)))) - offset;
                $borderToContentAreaCoordinates(dummy, true, false);
                break;
            case 5:
                anchor_0 = castTo($getProperty(dummy, PORT_ANCHOR), 8);
                offset_0 = !anchor_0 ? 0 : anchor_0.x_0;
                dummy.pos.x_0 = $doubleValue(castToDouble($getProperty(dummy, ($clinit_InternalProperties_1(), PORT_RATIO_OR_POSITION_0)))) - offset_0;
                $borderToContentAreaCoordinates(dummy, true, false);
                graphSize.x_0 = $wnd.Math.max(graphSize.x_0, dummy.pos.x_0 + dummy.size_0.x_0 / 2);
        }
        switch(castTo($getProperty(dummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64).ordinal){
            case 1:
                dummy.pos.y_0 = northY;
                push_1(northernDummies.array, dummy);
                break;
            case 3:
                dummy.pos.y_0 = southY;
                push_1(southernDummies.array, dummy);
        }
    }
    switch(constraints.ordinal){
        case 1:
        case 2:
            $ensureUniquePositions(northernDummies, layeredGraph);
            $ensureUniquePositions(southernDummies, layeredGraph);
            break;
        case 3:
            $restoreProperOrder(northernDummies, layeredGraph);
            $restoreProperOrder(southernDummies, layeredGraph);
    }
}
function HierarchicalPortOrthogonalEdgeRouter() {}
defineClass(1519, 1, $intern_102, HierarchicalPortOrthogonalEdgeRouter);
_.process = function process_14(layeredGraph, monitor) {
    $process_16(this, castTo(layeredGraph, 36), monitor);
};
_.northernExtPortEdgeRoutingHeight = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortOrthogonalEdgeRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortOrthogonalEdgeRouter', 1519);
function $compare_7(a, b) {
    return compare_4(a.pos.x_0, b.pos.x_0);
}
function HierarchicalPortOrthogonalEdgeRouter$1() {}
defineClass(1520, 1, $intern_88, HierarchicalPortOrthogonalEdgeRouter$1);
_.compare_1 = function compare_38(a, b) {
    return $compare_7(castTo(a, 9), castTo(b, 9));
};
_.equals_0 = function equals_102(other) {
    return this === other;
};
_.reversed = function reversed_30() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortOrthogonalEdgeRouter$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortOrthogonalEdgeRouter/1', 1520);
function $compare_8(a, b) {
    return compare_4($doubleValue(castToDouble($getProperty(a, ($clinit_InternalProperties_1(), PORT_RATIO_OR_POSITION_0)))), $doubleValue(castToDouble($getProperty(b, PORT_RATIO_OR_POSITION_0))));
}
function HierarchicalPortOrthogonalEdgeRouter$2() {}
defineClass(1521, 1, $intern_88, HierarchicalPortOrthogonalEdgeRouter$2);
_.compare_1 = function compare_39(a, b) {
    return $compare_8(castTo(a, 9), castTo(b, 9));
};
_.equals_0 = function equals_103(other) {
    return this === other;
};
_.reversed = function reversed_31() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortOrthogonalEdgeRouter$2_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortOrthogonalEdgeRouter/2', 1521);
function $fixCoordinates_0(layer, layeredGraph) {
    var extPortSide, finalYCoordinate, graphHeight, node, node$iterator, portConstraints;
    portConstraints = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    if (!(portConstraints == ($clinit_PortConstraints(), FIXED_RATIO) || portConstraints == FIXED_POS)) return;
    graphHeight = new KVector_1(layeredGraph.size_0.x_0 + layeredGraph.padding.left + layeredGraph.padding.right, layeredGraph.size_0.y_0 + layeredGraph.padding.top_0 + layeredGraph.padding.bottom).y_0;
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) continue;
        extPortSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
        if (extPortSide != ($clinit_PortSide(), EAST_0) && extPortSide != WEST_0) continue;
        finalYCoordinate = $doubleValue(castToDouble($getProperty(node, PORT_RATIO_OR_POSITION_0)));
        portConstraints == FIXED_RATIO && (finalYCoordinate *= graphHeight);
        node.pos.y_0 = finalYCoordinate - castTo($getProperty(node, PORT_ANCHOR), 8).y_0;
        $borderToContentAreaCoordinates(node, false, true);
    }
}
function $process_17(layeredGraph, monitor) {
    var layers;
    monitor.begin('Hierarchical port position processing', 1);
    layers = layeredGraph.layers;
    layers.array.length > 0 && $fixCoordinates_0((checkCriticalElementIndex(0, layers.array.length), castTo(layers.array[0], 25)), layeredGraph);
    layers.array.length > 1 && $fixCoordinates_0(castTo($get_11(layers, layers.array.length - 1), 25), layeredGraph);
    monitor.done_1();
}
function HierarchicalPortPositionProcessor() {}
defineClass(1522, 1, $intern_102, HierarchicalPortPositionProcessor);
_.process = function process_15(layeredGraph, monitor) {
    $process_17(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HierarchicalPortPositionProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HierarchicalPortPositionProcessor', 1522);
function $clinit_HighDegreeNodeLayeringProcessor() {
    $clinit_HighDegreeNodeLayeringProcessor = emptyMethod;
    INCOMING_EDGES = new HighDegreeNodeLayeringProcessor$lambda$0$Type;
    OUTGOING_EDGES = new HighDegreeNodeLayeringProcessor$lambda$1$Type;
}
function $calculateInformation(this$static, hdn) {
    var hdni, incEdge, incEdge$iterator, outEdge, outEdge$iterator, src_0, tgt, treeHeight;
    hdni = new HighDegreeNodeLayeringProcessor$HighDegreeNodeInformation;
    for(incEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(hdn).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(incEdge$iterator);){
        incEdge = castTo($next_0(incEdge$iterator), 18);
        if ($isSelfLoop(incEdge)) continue;
        src_0 = incEdge.source.owner;
        if ($hasSingleConnection(src_0, OUTGOING_EDGES)) {
            treeHeight = $isTreeRoot(this$static, src_0, OUTGOING_EDGES, INCOMING_EDGES);
            if (treeHeight == -1) continue;
            hdni.incTreesMaxHeight = $wnd.Math.max(hdni.incTreesMaxHeight, treeHeight);
            !hdni.incTreeRoots && (hdni.incTreeRoots = new ArrayList);
            $add_3(hdni.incTreeRoots, src_0);
        }
    }
    for(outEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(hdn).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outEdge$iterator);){
        outEdge = castTo($next_0(outEdge$iterator), 18);
        if ($isSelfLoop(outEdge)) continue;
        tgt = outEdge.target.owner;
        if ($hasSingleConnection(tgt, INCOMING_EDGES)) {
            treeHeight = $isTreeRoot(this$static, tgt, INCOMING_EDGES, OUTGOING_EDGES);
            if (treeHeight == -1) continue;
            hdni.outTreesMaxHeight = $wnd.Math.max(hdni.outTreesMaxHeight, treeHeight);
            !hdni.outTreeRoots && (hdni.outTreeRoots = new ArrayList);
            $add_3(hdni.outTreeRoots, tgt);
        }
    }
    return hdni;
}
function $hasSingleConnection(node, edgeSelector) {
    var connection, e, e$iterator;
    connection = null;
    for(e$iterator = castTo(edgeSelector.apply_0(node), 20).iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 18);
        if (!connection) connection = e.source.owner == node ? e.target.owner : e.source.owner;
        else {
            if ((e.source.owner == node ? e.target.owner : e.source.owner) != connection) return false;
        }
    }
    return true;
}
function $isTreeRoot(this$static, root, ancestorEdges, descendantEdges) {
    var currentHeight, e, e$iterator, height, other;
    if (size_24(($clinit_HighDegreeNodeLayeringProcessor(), new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(root).val$inputs1.iterator_0(), new Iterables$10)))) >= this$static.degreeThreshold) return -1;
    if (!$hasSingleConnection(root, ancestorEdges)) return -1;
    if (isEmpty_13(castTo(descendantEdges.apply_0(root), 20))) return 1;
    currentHeight = 0;
    for(e$iterator = castTo(descendantEdges.apply_0(root), 20).iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 18);
        other = e.source.owner == root ? e.target.owner : e.source.owner;
        height = $isTreeRoot(this$static, other, ancestorEdges, descendantEdges);
        if (height == -1) return -1;
        currentHeight = $wnd.Math.max(currentHeight, height);
        if (currentHeight > this$static.treeHeightThreshold - 1) return -1;
    }
    return currentHeight + 1;
}
function $moveTree(this$static, root, edgesFun, layers) {
    var e, e$iterator, other, subList;
    $setLayer_0(root, castTo(layers.get_0(0), 25));
    subList = layers.subList(1, layers.size_1());
    for(e$iterator = castTo(edgesFun.apply_0(root), 20).iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 18);
        other = e.source.owner == root ? e.target.owner : e.source.owner;
        $moveTree(this$static, other, edgesFun, subList);
    }
}
function $process_18(this$static, graph) {
    var afterLayers, hdni, highDegreeNode, highDegreeNode$iterator, highDegreeNode$iterator0, highDegreeNodes, i, i0, incMax, incRoot, incRoot$iterator, incRoots, l, lay, layerIt, layerIt2, n, n$iterator, outMax, outRoot, outRoot$iterator, outRoots, preLayers, l_0, l_1;
    this$static.layeredGraph = graph;
    this$static.degreeThreshold = castTo($getProperty(graph, ($clinit_LayeredOptions(), HIGH_DEGREE_NODES_THRESHOLD_0)), 17).value_0;
    this$static.treeHeightThreshold = castTo($getProperty(graph, HIGH_DEGREE_NODES_TREE_HEIGHT_0), 17).value_0;
    this$static.treeHeightThreshold == 0 && (this$static.treeHeightThreshold = $intern_0);
    layerIt = new AbstractList$ListIteratorImpl(graph.layers, 0);
    while(layerIt.i < layerIt.this$01_0.size_1()){
        lay = (checkCriticalElement(layerIt.i < layerIt.this$01_0.size_1()), castTo(layerIt.this$01_0.get_0(layerIt.last = layerIt.i++), 25));
        highDegreeNodes = new ArrayList;
        incMax = -1;
        outMax = -1;
        for(n$iterator = new ArrayList$1(lay.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            if (size_24(($clinit_HighDegreeNodeLayeringProcessor(), new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(n).val$inputs1.iterator_0(), new Iterables$10)))) >= this$static.degreeThreshold) {
                hdni = $calculateInformation(this$static, n);
                incMax = $wnd.Math.max(incMax, hdni.incTreesMaxHeight);
                outMax = $wnd.Math.max(outMax, hdni.outTreesMaxHeight);
                $add_3(highDegreeNodes, new Pair(n, hdni));
            }
        }
        preLayers = new ArrayList;
        for(i0 = 0; i0 < incMax; ++i0)$add_2(preLayers, 0, (checkCriticalElement(layerIt.i > 0), layerIt.this$01.get_0(layerIt.last = --layerIt.i), l_0 = new Layer(this$static.layeredGraph), $add_1(layerIt, l_0), checkCriticalElement(layerIt.i < layerIt.this$01_0.size_1()), layerIt.this$01_0.get_0(layerIt.last = layerIt.i++), l_0));
        for(highDegreeNode$iterator0 = new ArrayList$1(highDegreeNodes); highDegreeNode$iterator0.i < highDegreeNode$iterator0.this$01.array.length;){
            highDegreeNode = castTo($next_6(highDegreeNode$iterator0), 47);
            incRoots = castTo(highDegreeNode.second, 562).incTreeRoots;
            if (!incRoots) continue;
            for(incRoot$iterator = new ArrayList$1(incRoots); incRoot$iterator.i < incRoot$iterator.this$01.array.length;){
                incRoot = castTo($next_6(incRoot$iterator), 9);
                $moveTree(this$static, incRoot, INCOMING_EDGES, preLayers);
            }
        }
        afterLayers = new ArrayList;
        for(i = 0; i < outMax; ++i)$add_3(afterLayers, (l_1 = new Layer(this$static.layeredGraph), $add_1(layerIt, l_1), l_1));
        for(highDegreeNode$iterator = new ArrayList$1(highDegreeNodes); highDegreeNode$iterator.i < highDegreeNode$iterator.this$01.array.length;){
            highDegreeNode = castTo($next_6(highDegreeNode$iterator), 47);
            outRoots = castTo(highDegreeNode.second, 562).outTreeRoots;
            if (!outRoots) continue;
            for(outRoot$iterator = new ArrayList$1(outRoots); outRoot$iterator.i < outRoot$iterator.this$01.array.length;){
                outRoot = castTo($next_6(outRoot$iterator), 9);
                $moveTree(this$static, outRoot, OUTGOING_EDGES, afterLayers);
            }
        }
    }
    layerIt2 = new AbstractList$ListIteratorImpl(graph.layers, 0);
    while(layerIt2.i < layerIt2.this$01_0.size_1()){
        l = (checkCriticalElement(layerIt2.i < layerIt2.this$01_0.size_1()), castTo(layerIt2.this$01_0.get_0(layerIt2.last = layerIt2.i++), 25));
        l.nodes.array.length == 0 && $remove_8(layerIt2);
    }
}
function HighDegreeNodeLayeringProcessor() {
    $clinit_HighDegreeNodeLayeringProcessor();
}
defineClass(1523, 1, $intern_102, HighDegreeNodeLayeringProcessor);
_.process = function process_16(graph, progressMonitor) {
    $process_18(this, castTo(graph, 36));
};
_.degreeThreshold = 0;
_.treeHeightThreshold = 0;
var INCOMING_EDGES, OUTGOING_EDGES;
var Lorg_eclipse_elk_alg_layered_intermediate_HighDegreeNodeLayeringProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HighDegreeNodeLayeringProcessor', 1523);
function HighDegreeNodeLayeringProcessor$HighDegreeNodeInformation() {}
defineClass(562, 1, {
    562: 1
}, HighDegreeNodeLayeringProcessor$HighDegreeNodeInformation);
_.incTreesMaxHeight = -1;
_.outTreesMaxHeight = -1;
var Lorg_eclipse_elk_alg_layered_intermediate_HighDegreeNodeLayeringProcessor$HighDegreeNodeInformation_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HighDegreeNodeLayeringProcessor/HighDegreeNodeInformation', 562);
function HighDegreeNodeLayeringProcessor$lambda$0$Type() {}
defineClass(1524, 1, {}, HighDegreeNodeLayeringProcessor$lambda$0$Type);
_.apply_0 = function apply_53(arg0) {
    return $clinit_HighDegreeNodeLayeringProcessor(), $getIncomingEdges(castTo(arg0, 9));
};
_.equals_0 = function equals_104(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_HighDegreeNodeLayeringProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HighDegreeNodeLayeringProcessor/lambda$0$Type', 1524);
function HighDegreeNodeLayeringProcessor$lambda$1$Type() {}
defineClass(1525, 1, {}, HighDegreeNodeLayeringProcessor$lambda$1$Type);
_.apply_0 = function apply_54(arg0) {
    return $clinit_HighDegreeNodeLayeringProcessor(), $getOutgoingEdges(castTo(arg0, 9));
};
_.equals_0 = function equals_105(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_HighDegreeNodeLayeringProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HighDegreeNodeLayeringProcessor/lambda$1$Type', 1525);
function $checkMergeAllowed(currNode, lastNode) {
    var currHasLabelDummies, currNodeSource, currNodeTarget, eligibleForSourceMerging, eligibleForTargetMerging, lastHasLabelDummies, lastNodeSource, lastNodeTarget, sameSource, sameTarget;
    currHasLabelDummies = $booleanValue(castToBoolean($getProperty(currNode, ($clinit_InternalProperties_1(), LONG_EDGE_HAS_LABEL_DUMMIES))));
    lastHasLabelDummies = $booleanValue(castToBoolean($getProperty(lastNode, LONG_EDGE_HAS_LABEL_DUMMIES)));
    currNodeSource = castTo($getProperty(currNode, LONG_EDGE_SOURCE), 11);
    lastNodeSource = castTo($getProperty(lastNode, LONG_EDGE_SOURCE), 11);
    currNodeTarget = castTo($getProperty(currNode, LONG_EDGE_TARGET), 11);
    lastNodeTarget = castTo($getProperty(lastNode, LONG_EDGE_TARGET), 11);
    sameSource = !!currNodeSource && currNodeSource == lastNodeSource;
    sameTarget = !!currNodeTarget && currNodeTarget == lastNodeTarget;
    if (!currHasLabelDummies && !lastHasLabelDummies) return new HyperedgeDummyMerger$MergeState(castTo($next_6(new ArrayList$1(currNode.ports)), 11).id_0 == castTo($next_6(new ArrayList$1(lastNode.ports)), 11).id_0, sameSource, sameTarget);
    eligibleForSourceMerging = (!$booleanValue(castToBoolean($getProperty(currNode, LONG_EDGE_HAS_LABEL_DUMMIES))) || $booleanValue(castToBoolean($getProperty(currNode, LONG_EDGE_BEFORE_LABEL_DUMMY)))) && (!$booleanValue(castToBoolean($getProperty(lastNode, LONG_EDGE_HAS_LABEL_DUMMIES))) || $booleanValue(castToBoolean($getProperty(lastNode, LONG_EDGE_BEFORE_LABEL_DUMMY))));
    eligibleForTargetMerging = (!$booleanValue(castToBoolean($getProperty(currNode, LONG_EDGE_HAS_LABEL_DUMMIES))) || !$booleanValue(castToBoolean($getProperty(currNode, LONG_EDGE_BEFORE_LABEL_DUMMY)))) && (!$booleanValue(castToBoolean($getProperty(lastNode, LONG_EDGE_HAS_LABEL_DUMMIES))) || !$booleanValue(castToBoolean($getProperty(lastNode, LONG_EDGE_BEFORE_LABEL_DUMMY))));
    return new HyperedgeDummyMerger$MergeState(sameSource && eligibleForSourceMerging || sameTarget && eligibleForTargetMerging, sameSource, sameTarget);
}
function $dfs_2(this$static, p, index_0) {
    var p2, p2$iterator, p2$iterator0;
    p.id_0 = index_0;
    for(p2$iterator0 = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        new LPort$1(p),
        new LPort$2(p)
    ]))); $hasNext_1(p2$iterator0);){
        p2 = castTo($next_0(p2$iterator0), 11);
        p2.id_0 == -1 && $dfs_2(this$static, p2, index_0);
    }
    if (p.owner.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) for(p2$iterator = new ArrayList$1(p.owner.ports); p2$iterator.i < p2$iterator.this$01.array.length;){
        p2 = castTo($next_6(p2$iterator), 11);
        p2 != p && p2.id_0 == -1 && $dfs_2(this$static, p2, index_0);
    }
}
function $identifyHyperedges(this$static, lGraph) {
    var index_0, p, p$iterator, ports;
    ports = castTo($collect_1($flatMap($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(lGraph.layers, 16)), new HyperedgeDummyMerger$lambda$0$Type), new HyperedgeDummyMerger$lambda$1$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    ports.forEach_0(new HyperedgeDummyMerger$lambda$2$Type);
    index_0 = 0;
    for(p$iterator = ports.iterator_0(); p$iterator.hasNext_0();){
        p = castTo(p$iterator.next_1(), 11);
        p.id_0 == -1 && $dfs_2(this$static, p, index_0++);
    }
}
function $mergeNodes(mergeSource, mergeTarget, keepSourcePort, keepTargetPort) {
    var mergeTargetInputPort, mergeTargetOutputPort, port, port$iterator;
    mergeTargetInputPort = castTo($getPorts_1(mergeTarget, ($clinit_PortSide(), WEST_0)).iterator_0().next_1(), 11);
    mergeTargetOutputPort = castTo($getPorts_1(mergeTarget, EAST_0).iterator_0().next_1(), 11);
    for(port$iterator = new ArrayList$1(mergeSource.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        while(port.incomingEdges.array.length != 0)$setTarget_0(castTo($get_11(port.incomingEdges, 0), 18), mergeTargetInputPort);
        while(port.outgoingEdges.array.length != 0)$setSource_0(castTo($get_11(port.outgoingEdges, 0), 18), mergeTargetOutputPort);
    }
    keepSourcePort || $setProperty_0(mergeTarget, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), null);
    keepTargetPort || $setProperty_0(mergeTarget, ($clinit_InternalProperties_1(), LONG_EDGE_TARGET), null);
}
function $process_19(this$static, layeredGraph, monitor) {
    var currNode, currNodeType, lastNode, lastNodeType, layer, layerIter, nodeIndex, nodes, state;
    monitor.begin('Hyperedge merging', 1);
    $identifyHyperedges(this$static, layeredGraph);
    layerIter = new AbstractList$ListIteratorImpl(layeredGraph.layers, 0);
    while(layerIter.i < layerIter.this$01_0.size_1()){
        layer = (checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25));
        nodes = layer.nodes;
        if (nodes.array.length == 0) continue;
        currNode = null;
        currNodeType = null;
        lastNode = null;
        lastNodeType = null;
        for(nodeIndex = 0; nodeIndex < nodes.array.length; nodeIndex++){
            currNode = (checkCriticalElementIndex(nodeIndex, nodes.array.length), castTo(nodes.array[nodeIndex], 9));
            currNodeType = currNode.type_0;
            if (currNodeType == ($clinit_LNode$NodeType(), LONG_EDGE) && lastNodeType == LONG_EDGE) {
                state = $checkMergeAllowed(currNode, lastNode);
                if (state.allowMerge) {
                    $mergeNodes(currNode, lastNode, state.sameSource, state.sameTarget);
                    checkCriticalElementIndex(nodeIndex, nodes.array.length);
                    removeFrom(nodes.array, nodeIndex, 1);
                    --nodeIndex;
                    currNode = lastNode;
                    currNodeType = lastNodeType;
                }
            }
            lastNode = currNode;
            lastNodeType = currNodeType;
        }
    }
    monitor.done_1();
}
function HyperedgeDummyMerger() {}
defineClass(1531, 1, $intern_102, HyperedgeDummyMerger);
_.process = function process_17(layeredGraph, monitor) {
    $process_19(this, castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HyperedgeDummyMerger_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HyperedgeDummyMerger', 1531);
function HyperedgeDummyMerger$MergeState(allowMerge, sameSource, sameTarget) {
    this.allowMerge = allowMerge;
    this.sameSource = sameSource;
    this.sameTarget = sameTarget;
}
defineClass(784, 1, {}, HyperedgeDummyMerger$MergeState);
_.allowMerge = false;
_.sameSource = false;
_.sameTarget = false;
var Lorg_eclipse_elk_alg_layered_intermediate_HyperedgeDummyMerger$MergeState_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HyperedgeDummyMerger/MergeState', 784);
function HyperedgeDummyMerger$lambda$0$Type() {}
defineClass(1532, 1, {}, HyperedgeDummyMerger$lambda$0$Type);
_.apply_0 = function apply_55(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_HyperedgeDummyMerger$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HyperedgeDummyMerger/lambda$0$Type', 1532);
function HyperedgeDummyMerger$lambda$1$Type() {}
defineClass(1533, 1, {}, HyperedgeDummyMerger$lambda$1$Type);
_.apply_0 = function apply_56(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 9).ports, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_HyperedgeDummyMerger$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HyperedgeDummyMerger/lambda$1$Type', 1533);
function HyperedgeDummyMerger$lambda$2$Type() {}
defineClass(1534, 1, $intern_19, HyperedgeDummyMerger$lambda$2$Type);
_.accept = function accept_71(arg0) {
    castTo(arg0, 11).id_0 = -1;
};
var Lorg_eclipse_elk_alg_layered_intermediate_HyperedgeDummyMerger$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HyperedgeDummyMerger/lambda$2$Type', 1534);
function $moveHypernode(layeredGraph, hypernode, right) {
    var bendEdges, bendx, diffx, diffy, edge, edge$iterator, first, firstPoint, junctionPoints, lastPoint, northPort, port, port$iterator, second, southPort;
    bendEdges = new ArrayList;
    bendx = $intern_0;
    diffx = $intern_0;
    diffy = $intern_0;
    if (right) {
        bendx = layeredGraph.size_0.x_0;
        for(port$iterator = new ArrayList$1(hypernode.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if (edge.bendPoints.size_0 != 0) {
                    firstPoint = castTo($getFirst(edge.bendPoints), 8);
                    if (firstPoint.x_0 < bendx) {
                        diffx = bendx - firstPoint.x_0;
                        diffy = $intern_0;
                        bendEdges.array.length = 0;
                        bendx = firstPoint.x_0;
                    }
                    if (firstPoint.x_0 <= bendx) {
                        push_1(bendEdges.array, edge);
                        edge.bendPoints.size_0 > 1 && (diffy = $wnd.Math.min(diffy, $wnd.Math.abs(castTo($get_7(edge.bendPoints, 1), 8).y_0 - firstPoint.y_0)));
                    }
                }
            }
        }
    } else for(port$iterator = new ArrayList$1(hypernode.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            if (edge.bendPoints.size_0 != 0) {
                lastPoint = castTo($getLast(edge.bendPoints), 8);
                if (lastPoint.x_0 > bendx) {
                    diffx = lastPoint.x_0 - bendx;
                    diffy = $intern_0;
                    bendEdges.array.length = 0;
                    bendx = lastPoint.x_0;
                }
                if (lastPoint.x_0 >= bendx) {
                    push_1(bendEdges.array, edge);
                    edge.bendPoints.size_0 > 1 && (diffy = $wnd.Math.min(diffy, $wnd.Math.abs(castTo($get_7(edge.bendPoints, edge.bendPoints.size_0 - 2), 8).y_0 - lastPoint.y_0)));
                }
            }
        }
    }
    if (bendEdges.array.length != 0 && diffx > hypernode.size_0.x_0 / 2 && diffy > hypernode.size_0.y_0 / 2) {
        northPort = new LPort;
        $setNode(northPort, hypernode);
        $setSide(northPort, ($clinit_PortSide(), NORTH_1));
        northPort.pos.x_0 = hypernode.size_0.x_0 / 2;
        southPort = new LPort;
        $setNode(southPort, hypernode);
        $setSide(southPort, SOUTH_0);
        southPort.pos.x_0 = hypernode.size_0.x_0 / 2;
        southPort.pos.y_0 = hypernode.size_0.y_0;
        for(edge$iterator = new ArrayList$1(bendEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            if (right) {
                first = castTo($removeFirst_0(edge.bendPoints), 8);
                second = edge.bendPoints.size_0 == 0 ? $getAbsoluteAnchor(edge.target) : castTo($getFirst(edge.bendPoints), 8);
                second.y_0 >= first.y_0 ? $setSource_0(edge, southPort) : $setSource_0(edge, northPort);
            } else {
                first = castTo($removeLast_0(edge.bendPoints), 8);
                second = edge.bendPoints.size_0 == 0 ? $getAbsoluteAnchor(edge.source) : castTo($getLast(edge.bendPoints), 8);
                second.y_0 >= first.y_0 ? $setTarget_0(edge, southPort) : $setTarget_0(edge, northPort);
            }
            junctionPoints = castTo($getProperty(edge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
            !!junctionPoints && $advanceToFind(junctionPoints, first, true);
        }
        hypernode.pos.x_0 = bendx - hypernode.size_0.x_0 / 2;
    }
}
function $process_20(layeredGraph, monitor) {
    var bottomEdges, layer, layer$iterator, leftEdges, node, node$iterator, port, port$iterator, rightEdges, topEdges;
    monitor.begin('Hypernodes processing', 1);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if ($booleanValue(castToBoolean($getProperty(node, ($clinit_LayeredOptions(), HYPERNODE)))) && node.ports.array.length <= 2) {
                topEdges = 0;
                rightEdges = 0;
                bottomEdges = 0;
                leftEdges = 0;
                for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                    port = castTo($next_6(port$iterator), 11);
                    switch(port.side.ordinal){
                        case 1:
                            ++topEdges;
                            break;
                        case 2:
                            ++rightEdges;
                            break;
                        case 3:
                            ++bottomEdges;
                            break;
                        case 4:
                            ++leftEdges;
                    }
                }
                topEdges == 0 && bottomEdges == 0 && $moveHypernode(layeredGraph, node, leftEdges <= rightEdges);
            }
        }
    }
    monitor.done_1();
}
function HypernodesProcessor() {}
defineClass(1535, 1, $intern_102, HypernodesProcessor);
_.process = function process_18(layeredGraph, monitor) {
    $process_20(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_HypernodesProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'HypernodesProcessor', 1535);
function $process_21(layeredGraph, monitor) {
    var bottomConstrainedNodes, constraint, i, layer, layer$iterator, node, node$iterator, nodes, topInsertionIndex;
    monitor.begin('Layer constraint edge reversal', 1);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        topInsertionIndex = -1;
        bottomConstrainedNodes = new ArrayList;
        nodes = toNodeArray(layer.nodes);
        for(i = 0; i < nodes.length; i++){
            constraint = castTo($getProperty(nodes[i], ($clinit_InternalProperties_1(), IN_LAYER_CONSTRAINT)), 312);
            if (topInsertionIndex == -1) constraint != ($clinit_InLayerConstraint(), TOP_1) && (topInsertionIndex = i);
            else if (constraint == ($clinit_InLayerConstraint(), TOP_1)) {
                $setLayer_0(nodes[i], null);
                $setLayer(nodes[i], topInsertionIndex++, layer);
            }
            constraint == ($clinit_InLayerConstraint(), BOTTOM_0) && push_1(bottomConstrainedNodes.array, nodes[i]);
        }
        for(node$iterator = new ArrayList$1(bottomConstrainedNodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            $setLayer_0(node, null);
            $setLayer_0(node, layer);
        }
    }
    monitor.done_1();
}
function InLayerConstraintProcessor() {}
defineClass(1536, 1, $intern_102, InLayerConstraintProcessor);
_.process = function process_19(layeredGraph, monitor) {
    $process_21(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_InLayerConstraintProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InLayerConstraintProcessor', 1536);
function $process_22(layeredGraph, monitor) {
    monitor.begin('Node margin calculation', 1);
    $process($excludeEdgeHeadTailLabels(new NodeMarginCalculator(($clinit_LGraphAdapters(), new LGraphAdapters$LGraphAdapter(layeredGraph, false, false, new LGraphAdapters$lambda$0$Type)))));
    monitor.done_1();
}
function InnermostNodeMarginCalculator() {}
defineClass(1537, 1, $intern_102, InnermostNodeMarginCalculator);
_.process = function process_20(layeredGraph, monitor) {
    $process_22(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_InnermostNodeMarginCalculator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InnermostNodeMarginCalculator', 1537);
function $findNorthSouthPortXCoordinate(dummy) {
    var e, e$iterator, margins, max_0, min_0, n, port;
    port = castTo($get_11(dummy.ports, 0), 11);
    if (port.outgoingEdges.array.length != 0 && port.incomingEdges.array.length != 0) throw toJs(new IllegalStateException_0('Interactive layout does not support NORTH/SOUTH ports with incoming _and_ outgoing edges.'));
    if (port.outgoingEdges.array.length != 0) {
        min_0 = $intern_60;
        for(e$iterator = new ArrayList$1(port.outgoingEdges); e$iterator.i < e$iterator.this$01.array.length;){
            e = castTo($next_6(e$iterator), 18);
            n = e.target.owner;
            margins = castTo($getProperty(n, ($clinit_LayeredOptions(), MARGINS)), 139);
            min_0 = $wnd.Math.min(min_0, n.pos.x_0 - margins.left);
        }
        return new Present(checkNotNull(min_0));
    }
    if (port.incomingEdges.array.length != 0) {
        max_0 = $intern_61;
        for(e$iterator = new ArrayList$1(port.incomingEdges); e$iterator.i < e$iterator.this$01.array.length;){
            e = castTo($next_6(e$iterator), 18);
            n = e.source.owner;
            margins = castTo($getProperty(n, ($clinit_LayeredOptions(), MARGINS)), 139);
            max_0 = $wnd.Math.max(max_0, n.pos.x_0 + n.size_0.x_0 + margins.right);
        }
        return new Present(checkNotNull(max_0));
    }
    return $clinit_Absent(), $clinit_Absent(), INSTANCE;
}
function $findYCoordinate(dummy, funGetOtherNode) {
    var e, e$iterator, other;
    for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(dummy).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        other = castTo(funGetOtherNode.apply_0(e), 9);
        return new Present(checkNotNull(other.pos.y_0 + other.size_0.y_0 / 2));
    }
    return $clinit_Absent(), $clinit_Absent(), INSTANCE;
}
function $process_23(this$static, layeredGraph) {
    var ilc, lc, margins, node, node$iterator, node$iterator0;
    if (!castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS))) return;
    for(node$iterator0 = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        if (node.type_0 == ($clinit_LNode$NodeType(), NORMAL)) {
            margins = castTo($getProperty(node, ($clinit_LayeredOptions(), MARGINS)), 139);
            this$static.minX = $wnd.Math.min(this$static.minX, node.pos.x_0 - margins.left);
            this$static.maxX = $wnd.Math.max(this$static.maxX, node.pos.x_0 + node.size_0.x_0 + margins.right);
            this$static.minY = $wnd.Math.min(this$static.minY, node.pos.y_0 - margins.top_0);
            this$static.maxY = $wnd.Math.max(this$static.maxY, node.pos.y_0 + node.size_0.y_0 + margins.bottom);
        }
    }
    for(node$iterator = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), NORMAL)) switch(node.type_0.ordinal){
            case 2:
                lc = castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
                if (lc == ($clinit_LayerConstraint(), FIRST_SEPARATE_0)) {
                    node.pos.x_0 = this$static.minX - 10;
                    $findYCoordinate(node, new InteractiveExternalPortPositioner$lambda$0$Type).transform(new InteractiveExternalPortPositioner$lambda$1$Type(node));
                    break;
                }
                if (lc == LAST_SEPARATE_0) {
                    node.pos.x_0 = this$static.maxX + 10;
                    $findYCoordinate(node, new InteractiveExternalPortPositioner$lambda$2$Type).transform(new InteractiveExternalPortPositioner$lambda$3$Type(node));
                    break;
                }
                ilc = castTo($getProperty(node, IN_LAYER_CONSTRAINT), 312);
                if (ilc == ($clinit_InLayerConstraint(), TOP_1)) {
                    $findNorthSouthPortXCoordinate(node).transform(new InteractiveExternalPortPositioner$lambda$4$Type(node));
                    node.pos.y_0 = this$static.minY - 10;
                    break;
                }
                if (ilc == BOTTOM_0) {
                    $findNorthSouthPortXCoordinate(node).transform(new InteractiveExternalPortPositioner$lambda$5$Type(node));
                    node.pos.y_0 = this$static.maxY + 10;
                    break;
                }
                break;
            default:
                throw toJs(new IllegalArgumentException_0('The node type ' + node.type_0 + ' is not supported by the ' + Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner_2_classLit));
        }
    }
}
function InteractiveExternalPortPositioner() {}
function lambda$1_8(node_0, d_1) {
    return node_0.pos.y_0 = (checkCriticalNotNull(d_1), d_1);
}
function lambda$3_0(node_0, d_1) {
    return node_0.pos.y_0 = (checkCriticalNotNull(d_1), d_1);
}
function lambda$4_2(node_0, x_1) {
    return node_0.pos.x_0 = (checkCriticalNotNull(x_1), x_1) + 10;
}
function lambda$5_0(node_0, x_1) {
    return node_0.pos.x_0 = (checkCriticalNotNull(x_1), x_1) + 10;
}
defineClass(1538, 1, $intern_102, InteractiveExternalPortPositioner);
_.process = function process_21(layeredGraph, progressMonitor) {
    $process_23(this, castTo(layeredGraph, 36));
};
_.maxX = $intern_61;
_.maxY = $intern_61;
_.minX = $intern_60;
_.minY = $intern_60;
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner', 1538);
function InteractiveExternalPortPositioner$lambda$0$Type() {}
defineClass(1539, 1, {}, InteractiveExternalPortPositioner$lambda$0$Type);
_.apply_0 = function apply_57(arg0) {
    return castTo(arg0, 18).target.owner;
};
_.equals_0 = function equals_106(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner/lambda$0$Type', 1539);
function InteractiveExternalPortPositioner$lambda$1$Type(node_0) {
    this.node_0 = node_0;
}
defineClass(1540, 1, {}, InteractiveExternalPortPositioner$lambda$1$Type);
_.apply_0 = function apply_58(arg0) {
    return lambda$1_8(this.node_0, castToDouble(arg0));
};
_.equals_0 = function equals_107(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner/lambda$1$Type', 1540);
function InteractiveExternalPortPositioner$lambda$2$Type() {}
defineClass(1541, 1, {}, InteractiveExternalPortPositioner$lambda$2$Type);
_.apply_0 = function apply_59(arg0) {
    return castTo(arg0, 18).source.owner;
};
_.equals_0 = function equals_108(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner/lambda$2$Type', 1541);
function InteractiveExternalPortPositioner$lambda$3$Type(node_0) {
    this.node_0 = node_0;
}
defineClass(1542, 1, {}, InteractiveExternalPortPositioner$lambda$3$Type);
_.apply_0 = function apply_60(arg0) {
    return lambda$3_0(this.node_0, castToDouble(arg0));
};
_.equals_0 = function equals_109(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner/lambda$3$Type', 1542);
function InteractiveExternalPortPositioner$lambda$4$Type(node_0) {
    this.node_0 = node_0;
}
defineClass(1543, 1, {}, InteractiveExternalPortPositioner$lambda$4$Type);
_.apply_0 = function apply_61(arg0) {
    return lambda$4_2(this.node_0, castToDouble(arg0));
};
_.equals_0 = function equals_110(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner/lambda$4$Type', 1543);
function InteractiveExternalPortPositioner$lambda$5$Type(node_0) {
    this.node_0 = node_0;
}
defineClass(1544, 1, {}, InteractiveExternalPortPositioner$lambda$5$Type);
_.apply_0 = function apply_62(arg0) {
    return lambda$5_0(this.node_0, castToDouble(arg0));
};
_.equals_0 = function equals_111(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_InteractiveExternalPortPositioner$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InteractiveExternalPortPositioner/lambda$5$Type', 1544);
function $clinit_IntermediateProcessorStrategy() {
    $clinit_IntermediateProcessorStrategy = emptyMethod;
    DIRECTION_PREPROCESSOR = new IntermediateProcessorStrategy('DIRECTION_PREPROCESSOR', 0);
    COMMENT_PREPROCESSOR = new IntermediateProcessorStrategy('COMMENT_PREPROCESSOR', 1);
    EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER = new IntermediateProcessorStrategy('EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER', 2);
    INTERACTIVE_EXTERNAL_PORT_POSITIONER = new IntermediateProcessorStrategy('INTERACTIVE_EXTERNAL_PORT_POSITIONER', 3);
    PARTITION_PREPROCESSOR = new IntermediateProcessorStrategy('PARTITION_PREPROCESSOR', 4);
    LABEL_DUMMY_INSERTER = new IntermediateProcessorStrategy('LABEL_DUMMY_INSERTER', 5);
    SELF_LOOP_PREPROCESSOR = new IntermediateProcessorStrategy('SELF_LOOP_PREPROCESSOR', 6);
    LAYER_CONSTRAINT_PREPROCESSOR = new IntermediateProcessorStrategy('LAYER_CONSTRAINT_PREPROCESSOR', 7);
    PARTITION_MIDPROCESSOR = new IntermediateProcessorStrategy('PARTITION_MIDPROCESSOR', 8);
    HIGH_DEGREE_NODE_LAYER_PROCESSOR = new IntermediateProcessorStrategy('HIGH_DEGREE_NODE_LAYER_PROCESSOR', 9);
    NODE_PROMOTION = new IntermediateProcessorStrategy('NODE_PROMOTION', 10);
    LAYER_CONSTRAINT_POSTPROCESSOR = new IntermediateProcessorStrategy('LAYER_CONSTRAINT_POSTPROCESSOR', 11);
    PARTITION_POSTPROCESSOR = new IntermediateProcessorStrategy('PARTITION_POSTPROCESSOR', 12);
    HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR = new IntermediateProcessorStrategy('HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR', 13);
    SEMI_INTERACTIVE_CROSSMIN_PROCESSOR = new IntermediateProcessorStrategy('SEMI_INTERACTIVE_CROSSMIN_PROCESSOR', 14);
    BREAKING_POINT_INSERTER = new IntermediateProcessorStrategy('BREAKING_POINT_INSERTER', 15);
    LONG_EDGE_SPLITTER = new IntermediateProcessorStrategy('LONG_EDGE_SPLITTER', 16);
    PORT_SIDE_PROCESSOR = new IntermediateProcessorStrategy('PORT_SIDE_PROCESSOR', 17);
    INVERTED_PORT_PROCESSOR = new IntermediateProcessorStrategy('INVERTED_PORT_PROCESSOR', 18);
    PORT_LIST_SORTER = new IntermediateProcessorStrategy('PORT_LIST_SORTER', 19);
    SORT_BY_INPUT_ORDER_OF_MODEL = new IntermediateProcessorStrategy('SORT_BY_INPUT_ORDER_OF_MODEL', 20);
    NORTH_SOUTH_PORT_PREPROCESSOR = new IntermediateProcessorStrategy('NORTH_SOUTH_PORT_PREPROCESSOR', 21);
    BREAKING_POINT_PROCESSOR = new IntermediateProcessorStrategy('BREAKING_POINT_PROCESSOR', 22);
    ONE_SIDED_GREEDY_SWITCH = new IntermediateProcessorStrategy('ONE_SIDED_GREEDY_SWITCH', 23);
    TWO_SIDED_GREEDY_SWITCH = new IntermediateProcessorStrategy('TWO_SIDED_GREEDY_SWITCH', 24);
    SELF_LOOP_PORT_RESTORER = new IntermediateProcessorStrategy('SELF_LOOP_PORT_RESTORER', 25);
    ALTERNATING_LAYER_UNZIPPER = new IntermediateProcessorStrategy('ALTERNATING_LAYER_UNZIPPER', 26);
    SINGLE_EDGE_GRAPH_WRAPPER = new IntermediateProcessorStrategy('SINGLE_EDGE_GRAPH_WRAPPER', 27);
    IN_LAYER_CONSTRAINT_PROCESSOR = new IntermediateProcessorStrategy('IN_LAYER_CONSTRAINT_PROCESSOR', 28);
    END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR = new IntermediateProcessorStrategy('END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR', 29);
    LABEL_AND_NODE_SIZE_PROCESSOR = new IntermediateProcessorStrategy('LABEL_AND_NODE_SIZE_PROCESSOR', 30);
    INNERMOST_NODE_MARGIN_CALCULATOR = new IntermediateProcessorStrategy('INNERMOST_NODE_MARGIN_CALCULATOR', 31);
    SELF_LOOP_ROUTER = new IntermediateProcessorStrategy('SELF_LOOP_ROUTER', 32);
    COMMENT_NODE_MARGIN_CALCULATOR = new IntermediateProcessorStrategy('COMMENT_NODE_MARGIN_CALCULATOR', 33);
    END_LABEL_PREPROCESSOR = new IntermediateProcessorStrategy('END_LABEL_PREPROCESSOR', 34);
    LABEL_DUMMY_SWITCHER = new IntermediateProcessorStrategy('LABEL_DUMMY_SWITCHER', 35);
    CENTER_LABEL_MANAGEMENT_PROCESSOR = new IntermediateProcessorStrategy('CENTER_LABEL_MANAGEMENT_PROCESSOR', 36);
    LABEL_SIDE_SELECTOR = new IntermediateProcessorStrategy('LABEL_SIDE_SELECTOR', 37);
    HYPEREDGE_DUMMY_MERGER = new IntermediateProcessorStrategy('HYPEREDGE_DUMMY_MERGER', 38);
    HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR = new IntermediateProcessorStrategy('HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR', 39);
    LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR = new IntermediateProcessorStrategy('LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR', 40);
    HIERARCHICAL_PORT_POSITION_PROCESSOR = new IntermediateProcessorStrategy('HIERARCHICAL_PORT_POSITION_PROCESSOR', 41);
    CONSTRAINTS_POSTPROCESSOR = new IntermediateProcessorStrategy('CONSTRAINTS_POSTPROCESSOR', 42);
    COMMENT_POSTPROCESSOR = new IntermediateProcessorStrategy('COMMENT_POSTPROCESSOR', 43);
    HYPERNODE_PROCESSOR = new IntermediateProcessorStrategy('HYPERNODE_PROCESSOR', 44);
    HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER = new IntermediateProcessorStrategy('HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER', 45);
    LONG_EDGE_JOINER = new IntermediateProcessorStrategy('LONG_EDGE_JOINER', 46);
    SELF_LOOP_POSTPROCESSOR = new IntermediateProcessorStrategy('SELF_LOOP_POSTPROCESSOR', 47);
    BREAKING_POINT_REMOVER = new IntermediateProcessorStrategy('BREAKING_POINT_REMOVER', 48);
    NORTH_SOUTH_PORT_POSTPROCESSOR = new IntermediateProcessorStrategy('NORTH_SOUTH_PORT_POSTPROCESSOR', 49);
    HORIZONTAL_COMPACTOR = new IntermediateProcessorStrategy('HORIZONTAL_COMPACTOR', 50);
    LABEL_DUMMY_REMOVER = new IntermediateProcessorStrategy('LABEL_DUMMY_REMOVER', 51);
    FINAL_SPLINE_BENDPOINTS_CALCULATOR = new IntermediateProcessorStrategy('FINAL_SPLINE_BENDPOINTS_CALCULATOR', 52);
    END_LABEL_SORTER = new IntermediateProcessorStrategy('END_LABEL_SORTER', 53);
    REVERSED_EDGE_RESTORER = new IntermediateProcessorStrategy('REVERSED_EDGE_RESTORER', 54);
    END_LABEL_POSTPROCESSOR = new IntermediateProcessorStrategy('END_LABEL_POSTPROCESSOR', 55);
    HIERARCHICAL_NODE_RESIZER = new IntermediateProcessorStrategy('HIERARCHICAL_NODE_RESIZER', 56);
    DIRECTION_POSTPROCESSOR = new IntermediateProcessorStrategy('DIRECTION_POSTPROCESSOR', 57);
}
function IntermediateProcessorStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_24(name_0) {
    $clinit_IntermediateProcessorStrategy();
    return valueOf(($clinit_IntermediateProcessorStrategy$Map(), $MAP_14), name_0);
}
function values_32() {
    $clinit_IntermediateProcessorStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_IntermediateProcessorStrategy_2_classLit, 1), $intern_36, 79, 0, [
        DIRECTION_PREPROCESSOR,
        COMMENT_PREPROCESSOR,
        EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER,
        INTERACTIVE_EXTERNAL_PORT_POSITIONER,
        PARTITION_PREPROCESSOR,
        LABEL_DUMMY_INSERTER,
        SELF_LOOP_PREPROCESSOR,
        LAYER_CONSTRAINT_PREPROCESSOR,
        PARTITION_MIDPROCESSOR,
        HIGH_DEGREE_NODE_LAYER_PROCESSOR,
        NODE_PROMOTION,
        LAYER_CONSTRAINT_POSTPROCESSOR,
        PARTITION_POSTPROCESSOR,
        HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR,
        SEMI_INTERACTIVE_CROSSMIN_PROCESSOR,
        BREAKING_POINT_INSERTER,
        LONG_EDGE_SPLITTER,
        PORT_SIDE_PROCESSOR,
        INVERTED_PORT_PROCESSOR,
        PORT_LIST_SORTER,
        SORT_BY_INPUT_ORDER_OF_MODEL,
        NORTH_SOUTH_PORT_PREPROCESSOR,
        BREAKING_POINT_PROCESSOR,
        ONE_SIDED_GREEDY_SWITCH,
        TWO_SIDED_GREEDY_SWITCH,
        SELF_LOOP_PORT_RESTORER,
        ALTERNATING_LAYER_UNZIPPER,
        SINGLE_EDGE_GRAPH_WRAPPER,
        IN_LAYER_CONSTRAINT_PROCESSOR,
        END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR,
        LABEL_AND_NODE_SIZE_PROCESSOR,
        INNERMOST_NODE_MARGIN_CALCULATOR,
        SELF_LOOP_ROUTER,
        COMMENT_NODE_MARGIN_CALCULATOR,
        END_LABEL_PREPROCESSOR,
        LABEL_DUMMY_SWITCHER,
        CENTER_LABEL_MANAGEMENT_PROCESSOR,
        LABEL_SIDE_SELECTOR,
        HYPEREDGE_DUMMY_MERGER,
        HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR,
        LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR,
        HIERARCHICAL_PORT_POSITION_PROCESSOR,
        CONSTRAINTS_POSTPROCESSOR,
        COMMENT_POSTPROCESSOR,
        HYPERNODE_PROCESSOR,
        HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER,
        LONG_EDGE_JOINER,
        SELF_LOOP_POSTPROCESSOR,
        BREAKING_POINT_REMOVER,
        NORTH_SOUTH_PORT_POSTPROCESSOR,
        HORIZONTAL_COMPACTOR,
        LABEL_DUMMY_REMOVER,
        FINAL_SPLINE_BENDPOINTS_CALCULATOR,
        END_LABEL_SORTER,
        REVERSED_EDGE_RESTORER,
        END_LABEL_POSTPROCESSOR,
        HIERARCHICAL_NODE_RESIZER,
        DIRECTION_POSTPROCESSOR
    ]);
}
defineClass(79, 23, {
    3: 1,
    34: 1,
    23: 1,
    79: 1,
    196: 1
}, IntermediateProcessorStrategy);
_.create_1 = function create_4() {
    switch(this.ordinal){
        case 15:
            return new BreakingPointInserter;
        case 22:
            return new BreakingPointProcessor;
        case 48:
            return new BreakingPointRemover;
        case 29:
        case 36:
            return new LabelManagementProcessor;
        case 33:
            return new CommentNodeMarginCalculator;
        case 43:
            return new CommentPostprocessor;
        case 1:
            return new CommentPreprocessor;
        case 42:
            return new ConstraintsPostprocessor;
        case 57:
            return new GraphTransformer(($clinit_GraphTransformer$Mode(), TO_INTERNAL_LTR));
        case 0:
            return new GraphTransformer(($clinit_GraphTransformer$Mode(), TO_INPUT_DIRECTION));
        case 2:
            return new EdgeAndLayerConstraintEdgeReverser;
        case 55:
            return new EndLabelPostprocessor;
        case 34:
            return new EndLabelPreprocessor;
        case 52:
            return new FinalSplineBendpointsCalculator;
        case 56:
            return new HierarchicalNodeResizingProcessor;
        case 13:
            return new HierarchicalPortConstraintProcessor;
        case 39:
            return new HierarchicalPortDummySizeProcessor;
        case 45:
            return new HierarchicalPortOrthogonalEdgeRouter;
        case 41:
            return new HierarchicalPortPositionProcessor;
        case 9:
            return new HighDegreeNodeLayeringProcessor;
        case 50:
            return new HorizontalGraphCompactor;
        case 38:
            return new HyperedgeDummyMerger;
        case 44:
            return new HypernodesProcessor;
        case 28:
            return new InLayerConstraintProcessor;
        case 31:
            return new InnermostNodeMarginCalculator;
        case 3:
            return new InteractiveExternalPortPositioner;
        case 18:
            return new InvertedPortProcessor;
        case 30:
            return new LabelAndNodeSizeProcessor;
        case 5:
            return new LabelDummyInserter;
        case 51:
            return new LabelDummyRemover;
        case 35:
            return new LabelDummySwitcher;
        case 37:
            return new LabelSideSelector;
        case 53:
            return new EndLabelSorter;
        case 11:
            return new LayerConstraintPostprocessor;
        case 7:
            return new LayerConstraintPreprocessor;
        case 40:
            return new LayerSizeAndGraphHeightCalculator;
        case 46:
            return new LongEdgeJoiner;
        case 16:
            return new LongEdgeSplitter;
        case 10:
            return new NodePromotion;
        case 49:
            return new NorthSouthPortPostprocessor;
        case 21:
            return new NorthSouthPortPreprocessor;
        case 23:
            return new LayerSweepCrossingMinimizer(($clinit_LayerSweepCrossingMinimizer$CrossMinType(), ONE_SIDED_GREEDY_SWITCH_0));
        case 8:
            return new PartitionMidprocessor;
        case 12:
            return new PartitionPostprocessor;
        case 4:
            return new PartitionPreprocessor;
        case 19:
            return new PortListSorter;
        case 17:
            return new PortSideProcessor;
        case 54:
            return new ReversedEdgeRestorer;
        case 6:
            return new SelfLoopPreProcessor;
        case 25:
            return new SelfLoopPortRestorer;
        case 26:
            return new AlternatingLayerUnzipper;
        case 47:
            return new SelfLoopPostProcessor;
        case 32:
            return new SelfLoopRouter;
        case 14:
            return new SemiInteractiveCrossMinProcessor;
        case 27:
            return new SingleEdgeGraphWrapper;
        case 20:
            return new SortByInputModelProcessor;
        case 24:
            return new LayerSweepCrossingMinimizer(($clinit_LayerSweepCrossingMinimizer$CrossMinType(), TWO_SIDED_GREEDY_SWITCH_0));
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout processor ' + (this.name_0 != null ? this.name_0 : '' + this.ordinal)));
    }
};
var ALTERNATING_LAYER_UNZIPPER, BREAKING_POINT_INSERTER, BREAKING_POINT_PROCESSOR, BREAKING_POINT_REMOVER, CENTER_LABEL_MANAGEMENT_PROCESSOR, COMMENT_NODE_MARGIN_CALCULATOR, COMMENT_POSTPROCESSOR, COMMENT_PREPROCESSOR, CONSTRAINTS_POSTPROCESSOR, DIRECTION_POSTPROCESSOR, DIRECTION_PREPROCESSOR, EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER, END_LABEL_POSTPROCESSOR, END_LABEL_PREPROCESSOR, END_LABEL_SORTER, END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR, FINAL_SPLINE_BENDPOINTS_CALCULATOR, HIERARCHICAL_NODE_RESIZER, HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR, HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR, HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER, HIERARCHICAL_PORT_POSITION_PROCESSOR, HIGH_DEGREE_NODE_LAYER_PROCESSOR, HORIZONTAL_COMPACTOR, HYPEREDGE_DUMMY_MERGER, HYPERNODE_PROCESSOR, INNERMOST_NODE_MARGIN_CALCULATOR, INTERACTIVE_EXTERNAL_PORT_POSITIONER, INVERTED_PORT_PROCESSOR, IN_LAYER_CONSTRAINT_PROCESSOR, LABEL_AND_NODE_SIZE_PROCESSOR, LABEL_DUMMY_INSERTER, LABEL_DUMMY_REMOVER, LABEL_DUMMY_SWITCHER, LABEL_SIDE_SELECTOR, LAYER_CONSTRAINT_POSTPROCESSOR, LAYER_CONSTRAINT_PREPROCESSOR, LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR, LONG_EDGE_JOINER, LONG_EDGE_SPLITTER, NODE_PROMOTION, NORTH_SOUTH_PORT_POSTPROCESSOR, NORTH_SOUTH_PORT_PREPROCESSOR, ONE_SIDED_GREEDY_SWITCH, PARTITION_MIDPROCESSOR, PARTITION_POSTPROCESSOR, PARTITION_PREPROCESSOR, PORT_LIST_SORTER, PORT_SIDE_PROCESSOR, REVERSED_EDGE_RESTORER, SELF_LOOP_PORT_RESTORER, SELF_LOOP_POSTPROCESSOR, SELF_LOOP_PREPROCESSOR, SELF_LOOP_ROUTER, SEMI_INTERACTIVE_CROSSMIN_PROCESSOR, SINGLE_EDGE_GRAPH_WRAPPER, SORT_BY_INPUT_ORDER_OF_MODEL, TWO_SIDED_GREEDY_SWITCH;
var Lorg_eclipse_elk_alg_layered_intermediate_IntermediateProcessorStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate', 'IntermediateProcessorStrategy', 79, Ljava_lang_Enum_2_classLit, values_32, valueOf_24);
function $clinit_IntermediateProcessorStrategy$Map() {
    $clinit_IntermediateProcessorStrategy$Map = emptyMethod;
    $MAP_14 = createValueOfMap(values_32());
}
var $MAP_14;
function $createEastPortSideDummies(layeredGraph, eastwardPort, edge, layerNodeList) {
    var dummy, dummyEdge, dummyInput, dummyOutput, label_0, labelIterator, labelPlacement;
    if (edge.source.owner == eastwardPort.owner) return;
    dummy = new LNode(layeredGraph);
    $setType(dummy, ($clinit_LNode$NodeType(), LONG_EDGE));
    $setProperty_0(dummy, ($clinit_InternalProperties_1(), ORIGIN_0), edge);
    $setProperty_0(dummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    push_1(layerNodeList.array, dummy);
    dummyInput = new LPort;
    $setNode(dummyInput, dummy);
    $setSide(dummyInput, ($clinit_PortSide(), WEST_0));
    dummyOutput = new LPort;
    $setNode(dummyOutput, dummy);
    $setSide(dummyOutput, EAST_0);
    $setTarget_0(edge, dummyInput);
    dummyEdge = new LEdge;
    $copyProperties(dummyEdge, edge);
    $setProperty_0(dummyEdge, JUNCTION_POINTS, null);
    $setSource_0(dummyEdge, dummyOutput);
    $setTarget_0(dummyEdge, eastwardPort);
    $setLongEdgeSourceAndTarget(dummy, dummyInput, dummyOutput);
    labelIterator = new AbstractList$ListIteratorImpl(edge.labels, 0);
    while(labelIterator.i < labelIterator.this$01_0.size_1()){
        label_0 = (checkCriticalElement(labelIterator.i < labelIterator.this$01_0.size_1()), castTo(labelIterator.this$01_0.get_0(labelIterator.last = labelIterator.i++), 72));
        labelPlacement = castTo($getProperty(label_0, EDGE_LABELS_PLACEMENT), 276);
        if (labelPlacement == ($clinit_EdgeLabelPlacement(), HEAD)) {
            $hasProperty(label_0, END_LABEL_EDGE) || $setProperty_0(label_0, END_LABEL_EDGE, edge);
            $remove_8(labelIterator);
            $add_3(dummyEdge.labels, label_0);
        }
    }
}
function $createWestPortSideDummies(layeredGraph, westwardPort, edge, layerNodeList) {
    var dummy, dummyEdge, dummyInput, dummyOutput, label_0, labelIterator, originalTarget;
    if (edge.target.owner == westwardPort.owner) return;
    dummy = new LNode(layeredGraph);
    $setType(dummy, ($clinit_LNode$NodeType(), LONG_EDGE));
    $setProperty_0(dummy, ($clinit_InternalProperties_1(), ORIGIN_0), edge);
    $setProperty_0(dummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    push_1(layerNodeList.array, dummy);
    dummyInput = new LPort;
    $setNode(dummyInput, dummy);
    $setSide(dummyInput, ($clinit_PortSide(), WEST_0));
    dummyOutput = new LPort;
    $setNode(dummyOutput, dummy);
    $setSide(dummyOutput, EAST_0);
    originalTarget = edge.target;
    $setTarget_0(edge, dummyInput);
    dummyEdge = new LEdge;
    $copyProperties(dummyEdge, edge);
    $setProperty_0(dummyEdge, JUNCTION_POINTS, null);
    $setSource_0(dummyEdge, dummyOutput);
    $setTarget_0(dummyEdge, originalTarget);
    labelIterator = new AbstractList$ListIteratorImpl(edge.labels, 0);
    while(labelIterator.i < labelIterator.this$01_0.size_1()){
        label_0 = (checkCriticalElement(labelIterator.i < labelIterator.this$01_0.size_1()), castTo(labelIterator.this$01_0.get_0(labelIterator.last = labelIterator.i++), 72));
        if (maskUndefined($getProperty(label_0, EDGE_LABELS_PLACEMENT)) === maskUndefined(($clinit_EdgeLabelPlacement(), HEAD))) {
            $setProperty_0(label_0, END_LABEL_EDGE, edge);
            $remove_8(labelIterator);
            $add_3(dummyEdge.labels, label_0);
        }
    }
    $setLongEdgeSourceAndTarget(dummy, dummyInput, dummyOutput);
}
function $process_24(layeredGraph, monitor) {
    var currentLayer, edge, edge$array, edge$index, edge$max, edgeArray, edges, layerIterator, layers, node, node$iterator, node$iterator0, node$iterator1, port, port$iterator, port$iterator0, previousLayer, unassignedNodes;
    monitor.begin('Inverted port preprocessing', 1);
    layers = layeredGraph.layers;
    layerIterator = new AbstractList$ListIteratorImpl(layers, 0);
    currentLayer = null;
    unassignedNodes = new ArrayList;
    while(layerIterator.i < layerIterator.this$01_0.size_1()){
        previousLayer = currentLayer;
        currentLayer = (checkCriticalElement(layerIterator.i < layerIterator.this$01_0.size_1()), castTo(layerIterator.this$01_0.get_0(layerIterator.last = layerIterator.i++), 25));
        for(node$iterator0 = new ArrayList$1(unassignedNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            $setLayer_0(node, previousLayer);
        }
        unassignedNodes.array.length = 0;
        for(node$iterator1 = new ArrayList$1(currentLayer.nodes); node$iterator1.i < node$iterator1.this$01.array.length;){
            node = castTo($next_6(node$iterator1), 9);
            if (node.type_0 != ($clinit_LNode$NodeType(), NORMAL)) continue;
            if (!$isSideFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100))) continue;
            for(port$iterator0 = $getPorts_0(node, ($clinit_PortType(), INPUT), ($clinit_PortSide(), EAST_0)).iterator_0(); port$iterator0.hasNext_0();){
                port = castTo(port$iterator0.next_1(), 11);
                edges = port.incomingEdges;
                edgeArray = castTo($toArray_1(edges, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LEdge_2_classLit, $intern_103, 18, edges.array.length, 0, 1)), 469);
                for(edge$array = edgeArray, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                    edge = edge$array[edge$index];
                    $createEastPortSideDummies(layeredGraph, port, edge, unassignedNodes);
                }
            }
            for(port$iterator = $getPorts_0(node, OUTPUT, WEST_0).iterator_0(); port$iterator.hasNext_0();){
                port = castTo(port$iterator.next_1(), 11);
                edges = port.outgoingEdges;
                edgeArray = castTo($toArray_1(edges, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LEdge_2_classLit, $intern_103, 18, edges.array.length, 0, 1)), 469);
                for(edge$array = edgeArray, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                    edge = edge$array[edge$index];
                    $createWestPortSideDummies(layeredGraph, port, edge, unassignedNodes);
                }
            }
        }
    }
    for(node$iterator = new ArrayList$1(unassignedNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $setLayer_0(node, currentLayer);
    }
    monitor.done_1();
}
function $setLongEdgeSourceAndTarget(longEdgeDummy, dummyInputPort, dummyOutputPort) {
    var sourceNode, sourceNodeType, sourcePort, targetNode, targetNodeType, targetPort;
    sourcePort = castTo($get_11(dummyInputPort.incomingEdges, 0), 18).source;
    sourceNode = sourcePort.owner;
    sourceNodeType = sourceNode.type_0;
    targetPort = castTo($get_11(dummyOutputPort.outgoingEdges, 0), 18).target;
    targetNode = targetPort.owner;
    targetNodeType = targetNode.type_0;
    sourceNodeType == ($clinit_LNode$NodeType(), LONG_EDGE) ? $setProperty_0(longEdgeDummy, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), castTo($getProperty(sourceNode, LONG_EDGE_SOURCE), 11)) : $setProperty_0(longEdgeDummy, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), sourcePort);
    targetNodeType == LONG_EDGE ? $setProperty_0(longEdgeDummy, ($clinit_InternalProperties_1(), LONG_EDGE_TARGET), castTo($getProperty(targetNode, LONG_EDGE_TARGET), 11)) : $setProperty_0(longEdgeDummy, ($clinit_InternalProperties_1(), LONG_EDGE_TARGET), targetPort);
}
function InvertedPortProcessor() {}
defineClass(1545, 1, $intern_102, InvertedPortProcessor);
_.process = function process_22(layeredGraph, monitor) {
    $process_24(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_InvertedPortProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'InvertedPortProcessor', 1545);
function $computePortLabelBox(dummyPort, labelLabelSpacing) {
    var label_0, label$iterator, labelSize, result;
    if (dummyPort.labels.array.length == 0) return null;
    else {
        result = new ElkRectangle;
        for(label$iterator = new ArrayList$1(dummyPort.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            labelSize = label_0.size_0;
            result.width_0 = $wnd.Math.max(result.width_0, labelSize.x_0);
            result.height += labelSize.y_0;
        }
        result.height += (dummyPort.labels.array.length - 1) * labelLabelSpacing;
        return result;
    }
}
function $lambda$2(portLabelPlacement_1, placeNextToPort_2, treatAsGroup_3, dummy_3) {
    $placeExternalPortDummyLabels(dummy_3, portLabelPlacement_1, placeNextToPort_2, treatAsGroup_3);
}
function $placeExternalPortDummyLabels(dummy, graphPortLabelPlacement, placeNextToPortIfPossible, treatAsGroup) {
    var currentY, dummyPort, dummyPortPos, dummySize, label_0, label$iterator, labelHeight, labelLabelSpacing, labelPortSpacingHorizontal, labelPortSpacingVertical, labelPos, portLabelBox;
    labelPortSpacingHorizontal = $doubleValue(castToDouble($getProperty(dummy, ($clinit_LayeredOptions(), SPACING_LABEL_PORT_HORIZONTAL))));
    labelPortSpacingVertical = $doubleValue(castToDouble($getProperty(dummy, SPACING_LABEL_PORT_VERTICAL)));
    labelLabelSpacing = $doubleValue(castToDouble($getProperty(dummy, SPACING_LABEL_LABEL)));
    dummySize = dummy.size_0;
    dummyPort = castTo($get_11(dummy.ports, 0), 11);
    dummyPortPos = dummyPort.pos;
    portLabelBox = $computePortLabelBox(dummyPort, labelLabelSpacing);
    if (!portLabelBox) return;
    if (graphPortLabelPlacement.contains(($clinit_PortLabelPlacement(), INSIDE_0))) switch(castTo($getProperty(dummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64).ordinal){
        case 1:
            portLabelBox.x_0 = (dummySize.x_0 - portLabelBox.width_0) / 2 - dummyPortPos.x_0;
            portLabelBox.y_0 = labelPortSpacingVertical;
            break;
        case 3:
            portLabelBox.x_0 = (dummySize.x_0 - portLabelBox.width_0) / 2 - dummyPortPos.x_0;
            portLabelBox.y_0 = -labelPortSpacingVertical - portLabelBox.height;
            break;
        case 2:
            if (placeNextToPortIfPossible && dummyPort.incomingEdges.array.length == 0 && dummyPort.outgoingEdges.array.length == 0) {
                labelHeight = treatAsGroup ? portLabelBox.height : castTo($get_11(dummyPort.labels, 0), 72).size_0.y_0;
                portLabelBox.y_0 = (dummySize.y_0 - labelHeight) / 2 - dummyPortPos.y_0;
            } else portLabelBox.y_0 = dummySize.y_0 + labelPortSpacingVertical - dummyPortPos.y_0;
            portLabelBox.x_0 = -labelPortSpacingHorizontal - portLabelBox.width_0;
            break;
        case 4:
            if (placeNextToPortIfPossible && dummyPort.incomingEdges.array.length == 0 && dummyPort.outgoingEdges.array.length == 0) {
                labelHeight = treatAsGroup ? portLabelBox.height : castTo($get_11(dummyPort.labels, 0), 72).size_0.y_0;
                portLabelBox.y_0 = (dummySize.y_0 - labelHeight) / 2 - dummyPortPos.y_0;
            } else portLabelBox.y_0 = dummySize.y_0 + labelPortSpacingVertical - dummyPortPos.y_0;
            portLabelBox.x_0 = labelPortSpacingHorizontal;
    }
    else if (graphPortLabelPlacement.contains(OUTSIDE_0)) switch(castTo($getProperty(dummy, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64).ordinal){
        case 1:
        case 3:
            portLabelBox.x_0 = dummyPortPos.x_0 + labelPortSpacingHorizontal;
            break;
        case 2:
        case 4:
            if (placeNextToPortIfPossible && !dummyPort.connectedToExternalNodes) {
                labelHeight = treatAsGroup ? portLabelBox.height : castTo($get_11(dummyPort.labels, 0), 72).size_0.y_0;
                portLabelBox.y_0 = (dummySize.y_0 - labelHeight) / 2 - dummyPortPos.y_0;
            } else portLabelBox.y_0 = dummyPortPos.y_0 + labelPortSpacingVertical;
    }
    currentY = portLabelBox.y_0;
    for(label$iterator = new ArrayList$1(dummyPort.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 72);
        labelPos = label_0.pos;
        labelPos.x_0 = portLabelBox.x_0;
        labelPos.y_0 = currentY;
        currentY += label_0.size_0.y_0 + labelLabelSpacing;
    }
}
function $process_25(layeredGraph, monitor) {
    var layer, layer$iterator, placeNextToPort, portLabelPlacement, treatAsGroup;
    monitor.begin('Node and Port Label Placement and Node Sizing', 1);
    calculateLabelAndNodeSizes(($clinit_LGraphAdapters(), new LGraphAdapters$LGraphAdapter(layeredGraph, true, true, new LabelAndNodeSizeProcessor$lambda$0$Type)));
    if (castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS))) {
        portLabelPlacement = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_LABELS_PLACEMENT_1)), 22);
        placeNextToPort = portLabelPlacement.contains(($clinit_PortLabelPlacement(), NEXT_TO_PORT_IF_POSSIBLE_0));
        treatAsGroup = $booleanValue(castToBoolean($getProperty(layeredGraph, PORT_LABELS_TREAT_AS_GROUP)));
        for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
            layer = castTo($next_6(layer$iterator), 25);
            $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(layer.nodes, 16)), new LabelAndNodeSizeProcessor$lambda$1$Type), new LabelAndNodeSizeProcessor$lambda$2$Type(portLabelPlacement, placeNextToPort, treatAsGroup));
        }
    }
    monitor.done_1();
}
function LabelAndNodeSizeProcessor() {}
defineClass(1546, 1, $intern_102, LabelAndNodeSizeProcessor);
_.process = function process_23(layeredGraph, monitor) {
    $process_25(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelAndNodeSizeProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelAndNodeSizeProcessor', 1546);
function LabelAndNodeSizeProcessor$lambda$0$Type() {}
defineClass(1547, 1, $intern_39, LabelAndNodeSizeProcessor$lambda$0$Type);
_.test_0 = function test_31(arg0) {
    return castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelAndNodeSizeProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelAndNodeSizeProcessor/lambda$0$Type', 1547);
function LabelAndNodeSizeProcessor$lambda$1$Type() {}
defineClass(1548, 1, $intern_39, LabelAndNodeSizeProcessor$lambda$1$Type);
_.test_0 = function test_32(arg0) {
    return castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelAndNodeSizeProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelAndNodeSizeProcessor/lambda$1$Type', 1548);
function LabelAndNodeSizeProcessor$lambda$2$Type(portLabelPlacement_1, placeNextToPort_2, treatAsGroup_3) {
    this.portLabelPlacement_1 = portLabelPlacement_1;
    this.placeNextToPort_2 = placeNextToPort_2;
    this.treatAsGroup_3 = treatAsGroup_3;
}
defineClass(1549, 1, $intern_19, LabelAndNodeSizeProcessor$lambda$2$Type);
_.accept = function accept_72(arg0) {
    $lambda$2(this.portLabelPlacement_1, this.placeNextToPort_2, this.treatAsGroup_3, castTo(arg0, 9));
};
_.placeNextToPort_2 = false;
_.treatAsGroup_3 = false;
var Lorg_eclipse_elk_alg_layered_intermediate_LabelAndNodeSizeProcessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelAndNodeSizeProcessor/lambda$2$Type', 1549);
function $clinit_LabelDummyInserter() {
    $clinit_LabelDummyInserter = emptyMethod;
    CENTER_LABEL = new LabelDummyInserter$1;
}
function $createLabelDummy(layeredGraph, edge, thickness, representedLabels) {
    var dummyNode, dummyPort, dummyPort$iterator, portPos;
    dummyNode = new LNode(layeredGraph);
    $setType(dummyNode, ($clinit_LNode$NodeType(), LABEL));
    $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), edge);
    $setProperty_0(dummyNode, REPRESENTED_LABELS, representedLabels);
    $setProperty_0(dummyNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    $setProperty_0(dummyNode, LONG_EDGE_SOURCE, edge.source);
    $setProperty_0(dummyNode, LONG_EDGE_TARGET, edge.target);
    splitEdge(edge, dummyNode);
    portPos = $wnd.Math.floor(thickness / 2);
    for(dummyPort$iterator = new ArrayList$1(dummyNode.ports); dummyPort$iterator.i < dummyPort$iterator.this$01.array.length;){
        dummyPort = castTo($next_6(dummyPort$iterator), 11);
        dummyPort.pos.y_0 = portPos;
    }
    return dummyNode;
}
function $process_26(layeredGraph, monitor) {
    var dummyNode, dummySize, edge, edge$iterator, edgeLabelSpacing, iterator, label_0, labelLabelSpacing, layoutDirection, newDummyNodes, node, node$iterator, representedLabels, thickness;
    monitor.begin('Label dummy insertions', 1);
    newDummyNodes = new ArrayList;
    edgeLabelSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_LABEL_0))));
    labelLabelSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_LABEL_LABEL)));
    layoutDirection = castTo($getProperty(layeredGraph, DIRECTION), 86);
    for(node$iterator = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            if (edge.source.owner != edge.target.owner && any_0(edge.labels, CENTER_LABEL)) {
                thickness = $retrieveThickness(edge);
                representedLabels = newArrayListWithCapacity(edge.labels.array.length);
                dummyNode = $createLabelDummy(layeredGraph, edge, thickness, representedLabels);
                push_1(newDummyNodes.array, dummyNode);
                dummySize = dummyNode.size_0;
                iterator = new AbstractList$ListIteratorImpl(edge.labels, 0);
                while(iterator.i < iterator.this$01_0.size_1()){
                    label_0 = (checkCriticalElement(iterator.i < iterator.this$01_0.size_1()), castTo(iterator.this$01_0.get_0(iterator.last = iterator.i++), 72));
                    if (maskUndefined($getProperty(label_0, EDGE_LABELS_PLACEMENT)) === maskUndefined(($clinit_EdgeLabelPlacement(), CENTER_5))) {
                        if (layoutDirection == ($clinit_Direction(), UP_1) || layoutDirection == DOWN_1) {
                            dummySize.x_0 += label_0.size_0.x_0 + labelLabelSpacing;
                            dummySize.y_0 = $wnd.Math.max(dummySize.y_0, label_0.size_0.y_0);
                        } else {
                            dummySize.x_0 = $wnd.Math.max(dummySize.x_0, label_0.size_0.x_0);
                            dummySize.y_0 += label_0.size_0.y_0 + labelLabelSpacing;
                        }
                        push_1(representedLabels.array, label_0);
                        $remove_8(iterator);
                    }
                }
                if (layoutDirection == ($clinit_Direction(), UP_1) || layoutDirection == DOWN_1) {
                    dummySize.x_0 -= labelLabelSpacing;
                    dummySize.y_0 += edgeLabelSpacing + thickness;
                } else dummySize.y_0 += edgeLabelSpacing - labelLabelSpacing + thickness;
            }
        }
    }
    $addAll_2(layeredGraph.layerlessNodes, newDummyNodes);
    monitor.done_1();
}
function $retrieveThickness(edge) {
    var thickness;
    thickness = $doubleValue(castToDouble($getProperty(edge, ($clinit_LayeredOptions(), EDGE_THICKNESS))));
    if (thickness < 0) {
        thickness = 0;
        $setProperty_0(edge, EDGE_THICKNESS, thickness);
    }
    return thickness;
}
function LabelDummyInserter() {
    $clinit_LabelDummyInserter();
}
defineClass(1550, 1, $intern_102, LabelDummyInserter);
_.process = function process_24(layeredGraph, monitor) {
    $process_26(castTo(layeredGraph, 36), monitor);
};
var CENTER_LABEL;
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummyInserter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummyInserter', 1550);
function LabelDummyInserter$1() {}
defineClass(1551, 1, $intern_89, LabelDummyInserter$1);
_.apply_1 = function apply_63(label_0) {
    return maskUndefined($getProperty(castTo(label_0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT))) === maskUndefined(($clinit_EdgeLabelPlacement(), CENTER_5));
};
_.equals_0 = function equals_112(other) {
    return this === other;
};
_.test_0 = function test_33(input_0) {
    return maskUndefined($getProperty(castTo(input_0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT))) === maskUndefined(($clinit_EdgeLabelPlacement(), CENTER_5));
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummyInserter$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummyInserter/1', 1551);
function $placeLabelsForHorizontalLayout(labels, labelPos, labelSpacing, labelSpace) {
    var label_0, label$iterator;
    for(label$iterator = labels.iterator_0(); label$iterator.hasNext_0();){
        label_0 = castTo(label$iterator.next_1(), 72);
        label_0.pos.x_0 = labelPos.x_0 + (labelSpace.x_0 - label_0.size_0.x_0) / 2;
        label_0.pos.y_0 = labelPos.y_0;
        labelPos.y_0 += label_0.size_0.y_0 + labelSpacing;
    }
}
function $placeLabelsForVerticalLayout(labels, labelPos, labelSpacing, labelSpace, leftAligned, layoutDirection) {
    var effectiveLabels, inline, label_0, label$iterator;
    inline = !$spliterator($filter(labels.stream(), new Predicate$lambda$2$Type(new LabelDummyRemover$lambda$0$Type))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER));
    effectiveLabels = labels;
    layoutDirection == ($clinit_Direction(), UP_1) && (effectiveLabels = reverse_0(effectiveLabels));
    for(label$iterator = effectiveLabels.iterator_0(); label$iterator.hasNext_0();){
        label_0 = castTo(label$iterator.next_1(), 72);
        label_0.pos.x_0 = labelPos.x_0;
        inline ? label_0.pos.y_0 = labelPos.y_0 + (labelSpace.y_0 - label_0.size_0.y_0) / 2 : leftAligned ? label_0.pos.y_0 = labelPos.y_0 : label_0.pos.y_0 = labelPos.y_0 + labelSpace.y_0 - label_0.size_0.y_0;
        labelPos.x_0 += label_0.size_0.x_0 + labelSpacing;
    }
}
function $process_27(layeredGraph, monitor) {
    var currLabelPos, edgeLabelSpacing, labelLabelSpacing, labelSpace, labelsBelowEdge, layer, layer$iterator, layoutDirection, node, nodeIterator, originEdge, representedLabels, thickness;
    monitor.begin('Label dummy removal', 1);
    edgeLabelSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_LABEL_0))));
    labelLabelSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_LABEL_LABEL)));
    layoutDirection = castTo($getProperty(layeredGraph, DIRECTION), 86);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodeIterator = new AbstractList$ListIteratorImpl(layer.nodes, 0);
        while(nodeIterator.i < nodeIterator.this$01_0.size_1()){
            node = (checkCriticalElement(nodeIterator.i < nodeIterator.this$01_0.size_1()), castTo(nodeIterator.this$01_0.get_0(nodeIterator.last = nodeIterator.i++), 9));
            if (node.type_0 == ($clinit_LNode$NodeType(), LABEL)) {
                originEdge = castTo($getProperty(node, ($clinit_InternalProperties_1(), ORIGIN_0)), 18);
                thickness = $doubleValue(castToDouble($getProperty(originEdge, EDGE_THICKNESS)));
                labelsBelowEdge = maskUndefined($getProperty(node, LABEL_SIDE)) === maskUndefined(($clinit_LabelSide(), BELOW));
                currLabelPos = new KVector_2(node.pos);
                labelsBelowEdge && (currLabelPos.y_0 += thickness + edgeLabelSpacing);
                labelSpace = new KVector_1(node.size_0.x_0, node.size_0.y_0 + (node.type_0 == LABEL && !$spliterator($filter(castTo($getProperty(node, REPRESENTED_LABELS), 15).stream(), new Predicate$lambda$2$Type(new LNode$lambda$0$Type))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER)) ? 0 : -thickness - edgeLabelSpacing));
                representedLabels = castTo($getProperty(node, REPRESENTED_LABELS), 15);
                layoutDirection == ($clinit_Direction(), UP_1) || layoutDirection == DOWN_1 ? $placeLabelsForVerticalLayout(representedLabels, currLabelPos, labelLabelSpacing, labelSpace, labelsBelowEdge, layoutDirection) : $placeLabelsForHorizontalLayout(representedLabels, currLabelPos, labelLabelSpacing, labelSpace);
                $addAll_2(originEdge.labels, representedLabels);
                joinAt(node, maskUndefined($getProperty(layeredGraph, EDGE_ROUTING)) === maskUndefined(($clinit_EdgeRouting(), POLYLINE)));
                $remove_8(nodeIterator);
            }
        }
    }
    monitor.done_1();
}
function LabelDummyRemover() {}
defineClass(1552, 1, $intern_102, LabelDummyRemover);
_.process = function process_25(layeredGraph, monitor) {
    $process_27(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummyRemover_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummyRemover', 1552);
function LabelDummyRemover$lambda$0$Type() {}
defineClass(1553, 1, $intern_39, LabelDummyRemover$lambda$0$Type);
_.test_0 = function test_34(arg0) {
    return $booleanValue(castToBoolean($getProperty(castTo(arg0, 72), ($clinit_LayeredOptions(), EDGE_LABELS_INLINE_0))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummyRemover$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummyRemover/lambda$0$Type', 1553);
function $clinit_LabelDummySwitcher() {
    $clinit_LabelDummySwitcher = emptyMethod;
    INCLUDE_LABEL = new Property_0('edgelabelcenterednessanalysis.includelabel', ($clinit_Boolean(), FALSE_0));
}
function $assignIdsToLayers(layeredGraph) {
    var layer, layer$iterator, layerIndex;
    layerIndex = 0;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layer.id_0 = layerIndex;
        ++layerIndex;
    }
}
function $assignLayer(this$static, labelDummyInfo, targetLayerIndex) {
    var label_0, label$iterator, newLayerId;
    targetLayerIndex != labelDummyInfo.leftmostLayerId + labelDummyInfo.leftLongEdgeDummies.size_1() && $swapNodes(labelDummyInfo.labelDummy, $ithDummyNode(labelDummyInfo, targetLayerIndex - labelDummyInfo.leftmostLayerId));
    newLayerId = labelDummyInfo.labelDummy.layer.id_0;
    this$static.layerWidths[newLayerId] = $wnd.Math.max(this$static.layerWidths[newLayerId], labelDummyInfo.labelDummy.size_0.x_0);
    for(label$iterator = castTo($getProperty(labelDummyInfo.labelDummy, ($clinit_InternalProperties_1(), REPRESENTED_LABELS)), 15).iterator_0(); label$iterator.hasNext_0();){
        label_0 = castTo(label$iterator.next_1(), 72);
        $setProperty_0(label_0, INCLUDE_LABEL, ($clinit_Boolean(), true));
    }
}
function $assignToWiderLayer(this$static, labelDummyInfo) {
    var dummyWidth, layer, layer$iterator, validLayers;
    dummyWidth = labelDummyInfo.labelDummy.size_0.x_0;
    validLayers = new AbstractList$SubList($getGraph(labelDummyInfo.labelDummy).layers, labelDummyInfo.leftmostLayerId, labelDummyInfo.rightmostLayerId + 1);
    for(layer$iterator = new AbstractList$IteratorImpl(validLayers); layer$iterator.i < layer$iterator.this$01_0.size_1();){
        layer = (checkCriticalElement(layer$iterator.i < layer$iterator.this$01_0.size_1()), castTo(layer$iterator.this$01_0.get_0(layer$iterator.last = layer$iterator.i++), 25));
        if (layer.size_0.x_0 >= dummyWidth) {
            $assignLayer(this$static, labelDummyInfo, layer.id_0);
            return true;
        }
    }
    return false;
}
function $calculateLayerWidths(this$static, layeredGraph) {
    var layer, layer$iterator;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        this$static.layerWidths[layer.id_0] = findMaxNonDummyNodeWidth(layer);
    }
}
function $computeLayerWidthSums(this$static, labelDummyInfo) {
    var currentIndex, currentWidthSum, edgeNodeSpacing, layerWidthSums, leftDummy, leftDummy$iterator, lgraph, minSpaceBetweenLayers, nodeNodeSpacing, rightDummy, rightDummy$iterator;
    lgraph = $getGraph(labelDummyInfo.labelDummy);
    edgeNodeSpacing = $doubleValue(castToDouble($getProperty(lgraph, ($clinit_LayeredOptions(), SPACING_EDGE_NODE_BETWEEN_LAYERS_0)))) * 2;
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty(lgraph, SPACING_NODE_NODE_BETWEEN_LAYERS_0)));
    minSpaceBetweenLayers = $wnd.Math.max(edgeNodeSpacing, nodeNodeSpacing);
    layerWidthSums = initUnidimensionalArray(D_classLit, $intern_66, 30, labelDummyInfo.rightmostLayerId - labelDummyInfo.leftmostLayerId + 1, 15, 1);
    currentWidthSum = -minSpaceBetweenLayers;
    currentIndex = 0;
    for(leftDummy$iterator = labelDummyInfo.leftLongEdgeDummies.iterator_0(); leftDummy$iterator.hasNext_0();){
        leftDummy = castTo(leftDummy$iterator.next_1(), 9);
        currentWidthSum += this$static.layerWidths[leftDummy.layer.id_0] + minSpaceBetweenLayers;
        layerWidthSums[currentIndex++] = currentWidthSum;
    }
    currentWidthSum += this$static.layerWidths[labelDummyInfo.labelDummy.layer.id_0] + minSpaceBetweenLayers;
    layerWidthSums[currentIndex++] = currentWidthSum;
    for(rightDummy$iterator = new ArrayList$1(labelDummyInfo.rightLongEdgeDummies); rightDummy$iterator.i < rightDummy$iterator.this$01.array.length;){
        rightDummy = castTo($next_6(rightDummy$iterator), 9);
        currentWidthSum += this$static.layerWidths[rightDummy.layer.id_0] + minSpaceBetweenLayers;
        layerWidthSums[currentIndex++] = currentWidthSum;
    }
    return layerWidthSums;
}
function $computeSpaceEfficientAssignment(this$static, labelDummyInfos) {
    var labelCount, labelIndex, nonTrivialLabels;
    nonTrivialLabels = $performTrivialAssignments(this$static, labelDummyInfos);
    if (nonTrivialLabels.array.length == 0) return;
    $sort(nonTrivialLabels, new LabelDummySwitcher$lambda$4$Type);
    labelCount = nonTrivialLabels.array.length;
    for(labelIndex = 0; labelIndex < labelCount; labelIndex++)$assignLayer(this$static, (checkCriticalElementIndex(labelIndex, nonTrivialLabels.array.length), castTo(nonTrivialLabels.array[labelIndex], 291)), $findPotentiallyWidestLayer(this$static, nonTrivialLabels, labelIndex));
}
function $doUpdateLongEdgeLabelDummyInfo(labelDummy) {
    var longEdgeDummy;
    longEdgeDummy = ($clinit_LabelDummySwitcher(), castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(labelDummy).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner);
    while(longEdgeDummy.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)){
        $setProperty_0(longEdgeDummy, ($clinit_InternalProperties_1(), LONG_EDGE_BEFORE_LABEL_DUMMY), ($clinit_Boolean(), true));
        longEdgeDummy = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(longEdgeDummy).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner;
    }
}
function $findCenterLayerTargetId(this$static, labelDummyInfo) {
    var i, layerWidthSums, threshold;
    layerWidthSums = $computeLayerWidthSums(this$static, labelDummyInfo);
    threshold = layerWidthSums[layerWidthSums.length - 1] / 2;
    for(i = 0; i < layerWidthSums.length; i++){
        if (layerWidthSums[i] >= threshold) return labelDummyInfo.leftmostLayerId + i;
    }
    return labelDummyInfo.leftmostLayerId + labelDummyInfo.leftLongEdgeDummies.size_1();
}
function $findPotentiallyWidestLayer(this$static, labelDummyInfos, labelIndex) {
    var currLabelInfo, label_0, labelCount, labelDummyInfo, labelDummyWidth, largestUnassignedLabel, layer, potentialWidth, widestLayerIndex, widestLayerWidth;
    labelCount = labelDummyInfos.array.length;
    labelDummyInfo = (checkCriticalElementIndex(labelIndex, labelDummyInfos.array.length), castTo(labelDummyInfos.array[labelIndex], 291));
    labelDummyWidth = labelDummyInfo.labelDummy.size_0.x_0;
    widestLayerIndex = labelDummyInfo.leftmostLayerId;
    widestLayerWidth = 0;
    for(layer = labelDummyInfo.leftmostLayerId; layer <= labelDummyInfo.rightmostLayerId; layer++){
        if (labelDummyWidth <= this$static.layerWidths[layer]) return layer;
        potentialWidth = this$static.layerWidths[layer];
        largestUnassignedLabel = null;
        for(label_0 = labelIndex + 1; label_0 < labelCount; label_0++){
            currLabelInfo = (checkCriticalElementIndex(label_0, labelDummyInfos.array.length), castTo(labelDummyInfos.array[label_0], 291));
            currLabelInfo.leftmostLayerId <= layer && currLabelInfo.rightmostLayerId >= layer && (largestUnassignedLabel = currLabelInfo);
        }
        !!largestUnassignedLabel && (potentialWidth = $wnd.Math.max(potentialWidth, largestUnassignedLabel.labelDummy.size_0.x_0));
        if (potentialWidth > widestLayerWidth) {
            widestLayerIndex = layer;
            widestLayerWidth = potentialWidth;
        }
    }
    return widestLayerIndex;
}
function $findWidestLayerTargetId(this$static, labelDummyInfo) {
    var index_0, widestLayerIndex;
    widestLayerIndex = labelDummyInfo.leftmostLayerId;
    for(index_0 = widestLayerIndex + 1; index_0 <= labelDummyInfo.rightmostLayerId; index_0++)this$static.layerWidths[index_0] > this$static.layerWidths[widestLayerIndex] && (widestLayerIndex = index_0);
    return widestLayerIndex;
}
function $gatherLabelDummyInfos(layeredGraph, defaultPlacementStrategy) {
    var infos, strategy, strategy$array, strategy$index, strategy$max;
    infos = new EnumMap(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit);
    for(strategy$array = ($clinit_CenterEdgeLabelPlacementStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit, 1), $intern_36, 231, 0, [
        MEDIAN_LAYER,
        TAIL_LAYER,
        HEAD_LAYER,
        SPACE_EFFICIENT_LAYER,
        WIDEST_LAYER,
        CENTER_LAYER
    ])), strategy$index = 0, strategy$max = strategy$array.length; strategy$index < strategy$max; ++strategy$index){
        strategy = strategy$array[strategy$index];
        $put_8(infos, strategy, new ArrayList);
    }
    $forEach_3($map($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(layeredGraph.layers, 16)), new LabelDummySwitcher$lambda$0$Type), new LabelDummySwitcher$lambda$1$Type), new LabelDummySwitcher$lambda$2$Type(defaultPlacementStrategy)), new LabelDummySwitcher$lambda$3$Type(infos));
    return infos;
}
function $isPartOfReversedEdge(labelDummyInfo) {
    var incoming, outgoing;
    incoming = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(labelDummyInfo.labelDummy).val$inputs1.iterator_0(), new Iterables$10))), 18);
    outgoing = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(labelDummyInfo.labelDummy).val$inputs1.iterator_0(), new Iterables$10))), 18);
    return $booleanValue(castToBoolean($getProperty(incoming, ($clinit_InternalProperties_1(), REVERSED)))) || $booleanValue(castToBoolean($getProperty(outgoing, REVERSED)));
}
function $performTrivialAssignments(this$static, labelDummyInfos) {
    var labelDummyInfo, labelDummyInfo$iterator, remainingLabels;
    remainingLabels = new ArrayList_0(labelDummyInfos.size_1());
    for(labelDummyInfo$iterator = labelDummyInfos.iterator_0(); labelDummyInfo$iterator.hasNext_0();){
        labelDummyInfo = castTo(labelDummyInfo$iterator.next_1(), 291);
        labelDummyInfo.leftmostLayerId == labelDummyInfo.rightmostLayerId ? $assignLayer(this$static, labelDummyInfo, labelDummyInfo.leftmostLayerId) : $assignToWiderLayer(this$static, labelDummyInfo) || push_1(remainingLabels.array, labelDummyInfo);
    }
    return remainingLabels;
}
function $process_28(this$static, layeredGraph, monitor) {
    var defaultPlacementStrategy, labelDummyInfos, strategy, strategy$array, strategy$array0, strategy$array1, strategy$index, strategy$index0, strategy$index1, strategy$max, strategy$max0, strategy$max1;
    monitor.begin('Label dummy switching', 1);
    defaultPlacementStrategy = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_0)), 231);
    $assignIdsToLayers(layeredGraph);
    labelDummyInfos = $gatherLabelDummyInfos(layeredGraph, defaultPlacementStrategy);
    this$static.layerWidths = initUnidimensionalArray(D_classLit, $intern_66, 30, layeredGraph.layers.array.length, 15, 1);
    for(strategy$array0 = ($clinit_CenterEdgeLabelPlacementStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit, 1), $intern_36, 231, 0, [
        MEDIAN_LAYER,
        TAIL_LAYER,
        HEAD_LAYER,
        SPACE_EFFICIENT_LAYER,
        WIDEST_LAYER,
        CENTER_LAYER
    ])), strategy$index0 = 0, strategy$max0 = strategy$array0.length; strategy$index0 < strategy$max0; ++strategy$index0){
        strategy = strategy$array0[strategy$index0];
        if ((strategy == WIDEST_LAYER || strategy == CENTER_LAYER || strategy == SPACE_EFFICIENT_LAYER) && !castTo($containsEnum(labelDummyInfos.keySet, strategy) ? labelDummyInfos.values[strategy.ordinal] : null, 15).isEmpty()) {
            $calculateLayerWidths(this$static, layeredGraph);
            break;
        }
    }
    for(strategy$array1 = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit, 1), $intern_36, 231, 0, [
        MEDIAN_LAYER,
        TAIL_LAYER,
        HEAD_LAYER,
        SPACE_EFFICIENT_LAYER,
        WIDEST_LAYER,
        CENTER_LAYER
    ]), strategy$index1 = 0, strategy$max1 = strategy$array1.length; strategy$index1 < strategy$max1; ++strategy$index1){
        strategy = strategy$array1[strategy$index1];
        strategy == WIDEST_LAYER || strategy == CENTER_LAYER || strategy == SPACE_EFFICIENT_LAYER || $processStrategy(this$static, castTo($containsEnum(labelDummyInfos.keySet, strategy) ? labelDummyInfos.values[strategy.ordinal] : null, 15));
    }
    for(strategy$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit, 1), $intern_36, 231, 0, [
        MEDIAN_LAYER,
        TAIL_LAYER,
        HEAD_LAYER,
        SPACE_EFFICIENT_LAYER,
        WIDEST_LAYER,
        CENTER_LAYER
    ]), strategy$index = 0, strategy$max = strategy$array.length; strategy$index < strategy$max; ++strategy$index){
        strategy = strategy$array[strategy$index];
        (strategy == WIDEST_LAYER || strategy == CENTER_LAYER || strategy == SPACE_EFFICIENT_LAYER) && $processStrategy(this$static, castTo($containsEnum(labelDummyInfos.keySet, strategy) ? labelDummyInfos.values[strategy.ordinal] : null, 15));
    }
    this$static.layerWidths = null;
    monitor.done_1();
}
function $processStrategy(this$static, labelDummyInfos) {
    var labelDummyInfo, labelDummyInfo$iterator, reversed, reversed0, layers, lowerMedian;
    if (labelDummyInfos.isEmpty()) return;
    if (castTo(labelDummyInfos.get_0(0), 291).placementStrategy == ($clinit_CenterEdgeLabelPlacementStrategy(), SPACE_EFFICIENT_LAYER)) $computeSpaceEfficientAssignment(this$static, labelDummyInfos);
    else for(labelDummyInfo$iterator = labelDummyInfos.iterator_0(); labelDummyInfo$iterator.hasNext_0();){
        labelDummyInfo = castTo(labelDummyInfo$iterator.next_1(), 291);
        switch(labelDummyInfo.placementStrategy.ordinal){
            case 5:
                $assignLayer(this$static, labelDummyInfo, $findCenterLayerTargetId(this$static, labelDummyInfo));
                break;
            case 0:
                $assignLayer(this$static, labelDummyInfo, (layers = labelDummyInfo.rightmostLayerId - labelDummyInfo.leftmostLayerId + 1, lowerMedian = (layers - 1) / 2 | 0, labelDummyInfo.leftmostLayerId + lowerMedian));
                break;
            case 4:
                $assignLayer(this$static, labelDummyInfo, $findWidestLayerTargetId(this$static, labelDummyInfo));
                break;
            case 2:
                $setEndLayerNodeAlignment(labelDummyInfo);
                $assignLayer(this$static, labelDummyInfo, (reversed0 = $isPartOfReversedEdge(labelDummyInfo), reversed0 ? labelDummyInfo.leftmostLayerId : labelDummyInfo.rightmostLayerId));
                break;
            case 1:
                $setEndLayerNodeAlignment(labelDummyInfo);
                $assignLayer(this$static, labelDummyInfo, (reversed = $isPartOfReversedEdge(labelDummyInfo), reversed ? labelDummyInfo.rightmostLayerId : labelDummyInfo.leftmostLayerId));
        }
        $doUpdateLongEdgeLabelDummyInfo(labelDummyInfo.labelDummy);
    }
}
function $setEndLayerNodeAlignment(labelDummyInfo) {
    var isHeadLabel, isPartOfReversedEdge;
    isHeadLabel = labelDummyInfo.placementStrategy == ($clinit_CenterEdgeLabelPlacementStrategy(), HEAD_LAYER);
    isPartOfReversedEdge = $isPartOfReversedEdge(labelDummyInfo);
    isHeadLabel && !isPartOfReversedEdge || !isHeadLabel && isPartOfReversedEdge ? $setProperty_0(labelDummyInfo.labelDummy, ($clinit_LayeredOptions(), ALIGNMENT), ($clinit_Alignment(), RIGHT_5)) : $setProperty_0(labelDummyInfo.labelDummy, ($clinit_LayeredOptions(), ALIGNMENT), ($clinit_Alignment(), LEFT_5));
}
function $swapNodes(labelDummy, longEdgeDummy) {
    var dummy1LayerPosition, dummy2LayerPosition, edge, edge$array, edge$array0, edge$array1, edge$array2, edge$index, edge$index0, edge$index1, edge$index2, edge$max, edge$max0, edge$max1, edge$max2, incomingEdges1, incomingEdges2, inputPort1, inputPort2, layer1, layer2, outgoingEdges1, outgoingEdges2, outputPort1, outputPort2;
    layer1 = labelDummy.layer;
    layer2 = longEdgeDummy.layer;
    dummy1LayerPosition = $indexOf_3(layer1.nodes, labelDummy, 0);
    dummy2LayerPosition = $indexOf_3(layer2.nodes, longEdgeDummy, 0);
    inputPort1 = castTo($getPorts(labelDummy, ($clinit_PortType(), INPUT)).iterator_0().next_1(), 11);
    outputPort1 = castTo($getPorts(labelDummy, OUTPUT).iterator_0().next_1(), 11);
    inputPort2 = castTo($getPorts(longEdgeDummy, INPUT).iterator_0().next_1(), 11);
    outputPort2 = castTo($getPorts(longEdgeDummy, OUTPUT).iterator_0().next_1(), 11);
    incomingEdges1 = toEdgeArray(inputPort1.incomingEdges);
    outgoingEdges1 = toEdgeArray(outputPort1.outgoingEdges);
    incomingEdges2 = toEdgeArray(inputPort2.incomingEdges);
    outgoingEdges2 = toEdgeArray(outputPort2.outgoingEdges);
    $setLayer(labelDummy, dummy2LayerPosition, layer2);
    for(edge$array0 = incomingEdges2, edge$index0 = 0, edge$max0 = edge$array0.length; edge$index0 < edge$max0; ++edge$index0){
        edge = edge$array0[edge$index0];
        $setTarget_0(edge, inputPort1);
    }
    for(edge$array1 = outgoingEdges2, edge$index1 = 0, edge$max1 = edge$array1.length; edge$index1 < edge$max1; ++edge$index1){
        edge = edge$array1[edge$index1];
        $setSource_0(edge, outputPort1);
    }
    $setLayer(longEdgeDummy, dummy1LayerPosition, layer1);
    for(edge$array2 = incomingEdges1, edge$index2 = 0, edge$max2 = edge$array2.length; edge$index2 < edge$max2; ++edge$index2){
        edge = edge$array2[edge$index2];
        $setTarget_0(edge, inputPort2);
    }
    for(edge$array = outgoingEdges1, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
        edge = edge$array[edge$index];
        $setSource_0(edge, outputPort2);
    }
}
function LabelDummySwitcher() {
    $clinit_LabelDummySwitcher();
}
function lambda$2_3(defaultPlacementStrategy_0, labelDummy_1) {
    $clinit_LabelDummySwitcher();
    return new LabelDummySwitcher$LabelDummyInfo(labelDummy_1, defaultPlacementStrategy_0);
}
function lambda$3_1(infos_0, dummyInfo_1) {
    $clinit_LabelDummySwitcher();
    return castTo($get_14(infos_0, dummyInfo_1.placementStrategy), 15).add_2(dummyInfo_1);
}
function lambda$4_3(info1_0, info2_1) {
    $clinit_LabelDummySwitcher();
    return compare_4(info2_1.labelDummy.size_0.x_0, info1_0.labelDummy.size_0.x_0);
}
defineClass(1317, 1, $intern_102, LabelDummySwitcher);
_.process = function process_26(layeredGraph, monitor) {
    $process_28(this, castTo(layeredGraph, 36), monitor);
};
_.layerWidths = null;
var INCLUDE_LABEL;
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher', 1317);
function $gatherLeftLongEdgeDummies(this$static) {
    var source;
    source = this$static.labelDummy;
    do {
        source = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(source).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner;
        source.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) && this$static.leftLongEdgeDummies.add_2(source);
    }while (source.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE));
    this$static.leftLongEdgeDummies = reverse_0(this$static.leftLongEdgeDummies);
}
function $gatherRightLongEdgeDummies(this$static) {
    var target;
    target = this$static.labelDummy;
    do {
        target = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(target).val$inputs1.iterator_0(), new Iterables$10))), 18).target.owner;
        target.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) && $add_3(this$static.rightLongEdgeDummies, target);
    }while (target.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE));
}
function $ithDummyNode(this$static, i) {
    return i < this$static.leftLongEdgeDummies.size_1() ? castTo(this$static.leftLongEdgeDummies.get_0(i), 9) : i == this$static.leftLongEdgeDummies.size_1() ? this$static.labelDummy : castTo($get_11(this$static.rightLongEdgeDummies, i - this$static.leftLongEdgeDummies.size_1() - 1), 9);
}
function LabelDummySwitcher$LabelDummyInfo(labelDummy, defaultPlacementStrategy) {
    var label_0, label$iterator;
    this.leftLongEdgeDummies = new ArrayList;
    this.rightLongEdgeDummies = new ArrayList;
    this.labelDummy = labelDummy;
    this.placementStrategy = defaultPlacementStrategy;
    $gatherLeftLongEdgeDummies(this);
    $gatherRightLongEdgeDummies(this);
    this.leftLongEdgeDummies.isEmpty() ? this.leftmostLayerId = labelDummy.layer.id_0 : this.leftmostLayerId = castTo(this.leftLongEdgeDummies.get_0(0), 9).layer.id_0;
    this.rightLongEdgeDummies.array.length == 0 ? this.rightmostLayerId = labelDummy.layer.id_0 : this.rightmostLayerId = castTo($get_11(this.rightLongEdgeDummies, this.rightLongEdgeDummies.array.length - 1), 9).layer.id_0;
    for(label$iterator = castTo($getProperty(labelDummy, ($clinit_InternalProperties_1(), REPRESENTED_LABELS)), 15).iterator_0(); label$iterator.hasNext_0();){
        label_0 = castTo(label$iterator.next_1(), 72);
        if ($hasProperty(label_0, ($clinit_LayeredOptions(), EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_0))) {
            this.placementStrategy = castTo($getProperty(label_0, EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_0), 231);
            break;
        }
    }
}
defineClass(291, 1, {
    291: 1
}, LabelDummySwitcher$LabelDummyInfo);
_.leftmostLayerId = 0;
_.placementStrategy = null;
_.rightmostLayerId = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher$LabelDummyInfo_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher/LabelDummyInfo', 291);
function LabelDummySwitcher$lambda$0$Type() {}
defineClass(1318, 1, {}, LabelDummySwitcher$lambda$0$Type);
_.apply_0 = function apply_64(arg0) {
    return $clinit_LabelDummySwitcher(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher/lambda$0$Type', 1318);
function LabelDummySwitcher$lambda$1$Type() {}
defineClass(1319, 1, $intern_39, LabelDummySwitcher$lambda$1$Type);
_.test_0 = function test_35(arg0) {
    return $clinit_LabelDummySwitcher(), castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), LABEL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher/lambda$1$Type', 1319);
function LabelDummySwitcher$lambda$2$Type(defaultPlacementStrategy_0) {
    this.defaultPlacementStrategy_0 = defaultPlacementStrategy_0;
}
defineClass(1320, 1, {}, LabelDummySwitcher$lambda$2$Type);
_.apply_0 = function apply_65(arg0) {
    return lambda$2_3(this.defaultPlacementStrategy_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher/lambda$2$Type', 1320);
function LabelDummySwitcher$lambda$3$Type(infos_0) {
    this.infos_0 = infos_0;
}
defineClass(1321, 1, $intern_19, LabelDummySwitcher$lambda$3$Type);
_.accept = function accept_73(arg0) {
    lambda$3_1(this.infos_0, castTo(arg0, 291));
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher/lambda$3$Type', 1321);
function LabelDummySwitcher$lambda$4$Type() {}
defineClass(1322, 1, $intern_88, LabelDummySwitcher$lambda$4$Type);
_.compare_1 = function compare_40(arg0, arg1) {
    return lambda$4_3(castTo(arg0, 291), castTo(arg1, 291));
};
_.equals_0 = function equals_113(other) {
    return this === other;
};
_.reversed = function reversed_32() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelDummySwitcher$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelDummySwitcher/lambda$4$Type', 1322);
function $process_29(layeredGraph, monitor) {
    monitor.begin('Label management', 1);
    throwClassCastExceptionUnlessNull($getProperty(layeredGraph, ($clinit_LabelManagementOptions(), LABEL_MANAGER)));
    monitor.done_1();
}
function LabelManagementProcessor() {}
defineClass(782, 1, $intern_102, LabelManagementProcessor);
_.process = function process_27(layeredGraph, monitor) {
    $process_29(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelManagementProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelManagementProcessor', 782);
function $applyForDummyNodeRunWithSimpleLoops(dummyNodes, defaultSide) {
    var currLongEdgeSource, currLongEdgeTarget, currentDummy, currentDummy$iterator, endPort, endPort0, labelDummyRun, prevLongEdgeSource, prevLongEdgeTarget;
    labelDummyRun = newArrayListWithCapacity(dummyNodes.tail - dummyNodes.head & dummyNodes.array.length - 1);
    prevLongEdgeSource = null;
    prevLongEdgeTarget = null;
    for(currentDummy$iterator = new ArrayDeque$IteratorImpl(dummyNodes); currentDummy$iterator.currentIndex != currentDummy$iterator.fence;){
        currentDummy = castTo($next_5(currentDummy$iterator), 9);
        currLongEdgeSource = (endPort0 = castTo($getProperty(currentDummy, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE)), 11), !endPort0 ? null : endPort0.owner);
        currLongEdgeTarget = (endPort = castTo($getProperty(currentDummy, LONG_EDGE_TARGET), 11), !endPort ? null : endPort.owner);
        if (prevLongEdgeSource != currLongEdgeSource || prevLongEdgeTarget != currLongEdgeTarget) {
            $applyLabelSidesToLabelDummyRun(labelDummyRun, defaultSide);
            prevLongEdgeSource = currLongEdgeSource;
            prevLongEdgeTarget = currLongEdgeTarget;
        }
        push_1(labelDummyRun.array, currentDummy);
    }
    $applyLabelSidesToLabelDummyRun(labelDummyRun, defaultSide);
}
function $applyLabelSide(labels, side) {
    var label_0, label$iterator;
    for(label$iterator = labels.iterator_0(); label$iterator.hasNext_0();){
        label_0 = castTo(label$iterator.next_1(), 72);
        $setProperty_0(label_0, ($clinit_InternalProperties_1(), LABEL_SIDE), side);
    }
}
function $applyLabelSide_0(edge, side) {
    var label_0, label$iterator;
    for(label$iterator = new ArrayList$1(edge.labels); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 72);
        $setProperty_0(label_0, ($clinit_InternalProperties_1(), LABEL_SIDE), side);
    }
}
function $applyLabelSide_1(labelDummy, side) {
    var effectiveSide, originEdge, port, port$iterator, portPos, thickness;
    if (labelDummy.type_0 == ($clinit_LNode$NodeType(), LABEL)) {
        effectiveSide = labelDummy.type_0 == LABEL && !$spliterator($filter(castTo($getProperty(labelDummy, ($clinit_InternalProperties_1(), REPRESENTED_LABELS)), 15).stream(), new Predicate$lambda$2$Type(new LNode$lambda$0$Type))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER)) ? ($clinit_LabelSide(), INLINE) : side;
        $setProperty_0(labelDummy, ($clinit_InternalProperties_1(), LABEL_SIDE), effectiveSide);
        if (effectiveSide != ($clinit_LabelSide(), BELOW)) {
            originEdge = castTo($getProperty(labelDummy, ORIGIN_0), 18);
            thickness = $doubleValue(castToDouble($getProperty(originEdge, ($clinit_LayeredOptions(), EDGE_THICKNESS))));
            portPos = 0;
            if (effectiveSide == ABOVE) portPos = labelDummy.size_0.y_0 - $wnd.Math.ceil(thickness / 2);
            else if (effectiveSide == INLINE) {
                portPos = $wnd.Math.ceil(labelDummy.size_0.y_0 - $doubleValue(castToDouble($getProperty($getGraph(labelDummy), SPACING_EDGE_LABEL_0))) - thickness) / 2;
                labelDummy.size_0.y_0 -= $doubleValue(castToDouble($getProperty($getGraph(labelDummy), SPACING_EDGE_LABEL_0)));
                labelDummy.size_0.y_0 -= thickness;
            }
            for(port$iterator = new ArrayList$1(labelDummy.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                port.pos.y_0 = portPos;
            }
        }
    }
}
function $applyLabelSidesToLabelDummyRun(labelDummyRun, defaultSide) {
    var dummyNode, dummyNode$iterator;
    if (labelDummyRun.array.length != 0) {
        if (labelDummyRun.array.length == 2) {
            $applyLabelSide_1((checkCriticalElementIndex(0, labelDummyRun.array.length), castTo(labelDummyRun.array[0], 9)), ($clinit_LabelSide(), ABOVE));
            $applyLabelSide_1((checkCriticalElementIndex(1, labelDummyRun.array.length), castTo(labelDummyRun.array[1], 9)), BELOW);
        } else for(dummyNode$iterator = new ArrayList$1(labelDummyRun); dummyNode$iterator.i < dummyNode$iterator.this$01.array.length;){
            dummyNode = castTo($next_6(dummyNode$iterator), 9);
            $applyLabelSide_1(dummyNode, defaultSide);
        }
        labelDummyRun.array.length = 0;
    }
}
function $basedOnDirection(graph, sideForRightwardEdges) {
    var edge, edge$iterator, layer, layer$iterator, node, node$iterator, side, incoming, outgoing;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (node.type_0 == ($clinit_LNode$NodeType(), LABEL)) {
                side = (incoming = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10))), 18), outgoing = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10))), 18), !$booleanValue(castToBoolean($getProperty(incoming, ($clinit_InternalProperties_1(), REVERSED)))) || !$booleanValue(castToBoolean($getProperty(outgoing, REVERSED)))) ? sideForRightwardEdges : $opposite_0(sideForRightwardEdges);
                $applyLabelSide_1(node, side);
            }
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                side = $booleanValue(castToBoolean($getProperty(edge, ($clinit_InternalProperties_1(), REVERSED)))) ? $opposite_0(sideForRightwardEdges) : sideForRightwardEdges;
                $applyLabelSide_0(edge, side);
            }
        }
    }
}
function $process_30(layeredGraph, monitor) {
    var mode;
    mode = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), EDGE_LABELS_SIDE_SELECTION_0)), 281);
    monitor.begin('Label side selection (' + mode + ')', 1);
    switch(mode.ordinal){
        case 0:
            $sameSide(layeredGraph, ($clinit_LabelSide(), ABOVE));
            break;
        case 1:
            $sameSide(layeredGraph, ($clinit_LabelSide(), BELOW));
            break;
        case 2:
            $basedOnDirection(layeredGraph, ($clinit_LabelSide(), ABOVE));
            break;
        case 3:
            $basedOnDirection(layeredGraph, ($clinit_LabelSide(), BELOW));
            break;
        case 4:
            $smart(layeredGraph, ($clinit_LabelSide(), ABOVE));
            break;
        case 5:
            $smart(layeredGraph, ($clinit_LabelSide(), BELOW));
    }
    monitor.done_1();
}
function $sameSide(graph, labelSide) {
    var edge, edge$iterator, layer, layer$iterator, node, node$iterator;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.type_0 == ($clinit_LNode$NodeType(), LABEL) && $applyLabelSide_1(node, labelSide);
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                $applyLabelSide_0(edge, labelSide);
            }
        }
    }
}
function $smart(graph, defaultSide) {
    var dummyNodeQueue, labelDummiesInQueue, layer, layer$iterator, node, node$iterator, topGroup;
    dummyNodeQueue = new ArrayDeque;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        topGroup = true;
        labelDummiesInQueue = 0;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            switch(node.type_0.ordinal){
                case 4:
                    ++labelDummiesInQueue;
                case 1:
                    $addLast(dummyNodeQueue, node);
                    break;
                case 0:
                    $smartForRegularNode(node, defaultSide);
                default:
                    dummyNodeQueue.head == dummyNodeQueue.tail || $smartForConsecutiveDummyNodeRun(dummyNodeQueue, labelDummiesInQueue, topGroup, false, defaultSide);
                    topGroup = false;
                    labelDummiesInQueue = 0;
            }
        }
        dummyNodeQueue.head == dummyNodeQueue.tail || $smartForConsecutiveDummyNodeRun(dummyNodeQueue, labelDummiesInQueue, topGroup, true, defaultSide);
    }
}
function $smartForConsecutiveDummyNodeRun(dummyNodes, labelDummyCount, topGroup, bottomGroup, defaultSide) {
    if (topGroup && (!bottomGroup || (dummyNodes.tail - dummyNodes.head & dummyNodes.array.length - 1) > 1) && labelDummyCount == 1 && castTo(dummyNodes.array[dummyNodes.head], 9).type_0 == ($clinit_LNode$NodeType(), LABEL)) $applyLabelSide_1(castTo(dummyNodes.array[dummyNodes.head], 9), ($clinit_LabelSide(), ABOVE));
    else if (bottomGroup && (!topGroup || (dummyNodes.tail - dummyNodes.head & dummyNodes.array.length - 1) > 1) && labelDummyCount == 1 && castTo(dummyNodes.array[dummyNodes.tail - 1 & dummyNodes.array.length - 1], 9).type_0 == ($clinit_LNode$NodeType(), LABEL)) $applyLabelSide_1(castTo(dummyNodes.array[dummyNodes.tail - 1 & dummyNodes.array.length - 1], 9), ($clinit_LabelSide(), BELOW));
    else if ((dummyNodes.tail - dummyNodes.head & dummyNodes.array.length - 1) == 2) {
        $applyLabelSide_1(castTo($pollFirst(dummyNodes), 9), ($clinit_LabelSide(), ABOVE));
        $applyLabelSide_1(castTo($pollFirst(dummyNodes), 9), BELOW);
    } else $applyForDummyNodeRunWithSimpleLoops(dummyNodes, defaultSide);
    $clear_4(dummyNodes);
}
function $smartForRegularNode(node, defaultSide) {
    var currentPortSide, endLabelQueue, port, port$iterator, portEndLabels;
    endLabelQueue = new ArrayDeque_0(node.ports.array.length);
    currentPortSide = null;
    for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        if (port.side != currentPortSide) {
            endLabelQueue.head == endLabelQueue.tail || $smartForRegularNodePortEndLabels(endLabelQueue, currentPortSide, defaultSide);
            $clear_4(endLabelQueue);
            currentPortSide = port.side;
        }
        portEndLabels = gatherLabels(port);
        !!portEndLabels && $addLast(endLabelQueue, portEndLabels);
    }
    endLabelQueue.head == endLabelQueue.tail || $smartForRegularNodePortEndLabels(endLabelQueue, currentPortSide, defaultSide);
}
function $smartForRegularNodePortEndLabels(endLabelQueue, portSide, defaultSide) {
    var labelList, labelList$iterator;
    if ((endLabelQueue.tail - endLabelQueue.head & endLabelQueue.array.length - 1) == 2) {
        if (portSide == ($clinit_PortSide(), NORTH_1) || portSide == EAST_0) {
            $applyLabelSide(castTo($pollFirst(endLabelQueue), 15), ($clinit_LabelSide(), ABOVE));
            $applyLabelSide(castTo($pollFirst(endLabelQueue), 15), BELOW);
        } else {
            $applyLabelSide(castTo($pollFirst(endLabelQueue), 15), ($clinit_LabelSide(), BELOW));
            $applyLabelSide(castTo($pollFirst(endLabelQueue), 15), ABOVE);
        }
    } else for(labelList$iterator = new ArrayDeque$IteratorImpl(endLabelQueue); labelList$iterator.currentIndex != labelList$iterator.fence;){
        labelList = castTo($next_5(labelList$iterator), 15);
        $applyLabelSide(labelList, defaultSide);
    }
}
function LabelSideSelector() {}
defineClass(1554, 1, $intern_102, LabelSideSelector);
_.process = function process_28(layeredGraph, monitor) {
    $process_30(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LabelSideSelector_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LabelSideSelector', 1554);
function $moveFirstAndLastNodes(layeredGraph, firstLayer, lastLayer, firstLabelLayer, lastLabelLayer) {
    var layer, layer$iterator, layerIter, node, node$array, node$index, node$max, nodes;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodes = toNodeArray(layer.nodes);
        for(node$array = nodes, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            switch(castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171).ordinal){
                case 1:
                    $throwUpUnlessNoIncomingEdges(node);
                    $setLayer_0(node, firstLayer);
                    $moveLabelsToLabelLayer(node, true, firstLabelLayer);
                    break;
                case 3:
                    $throwUpUnlessNoOutgoingEdges(node);
                    $setLayer_0(node, lastLayer);
                    $moveLabelsToLabelLayer(node, false, lastLabelLayer);
            }
        }
    }
    layerIter = new AbstractList$ListIteratorImpl(layeredGraph.layers, 0);
    while(layerIter.i < layerIter.this$01_0.size_1())(checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25)).nodes.array.length == 0 && $remove_8(layerIter);
}
function $moveLabelsToLabelLayer(node, incoming, labelLayer) {
    var edge, edge$iterator, possibleLableDummy;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2((incoming ? $getIncomingEdges(node) : $getOutgoingEdges(node)).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        possibleLableDummy = incoming ? edge.source.owner : edge.target.owner;
        possibleLableDummy.type_0 == ($clinit_LNode$NodeType(), LABEL) && $setLayer_0(possibleLableDummy, labelLayer);
    }
}
function $process_31(layeredGraph, monitor) {
    var firstLabelLayer, firstLayer, firstSeparateLayer, lastLabelLayer, lastLayer, lastSeparateLayer, layers;
    monitor.begin('Layer constraint postprocessing', 1);
    layers = layeredGraph.layers;
    if (layers.array.length != 0) {
        firstLayer = (checkCriticalElementIndex(0, layers.array.length), castTo(layers.array[0], 25));
        lastLayer = castTo($get_11(layers, layers.array.length - 1), 25);
        firstLabelLayer = new Layer(layeredGraph);
        lastLabelLayer = new Layer(layeredGraph);
        $moveFirstAndLastNodes(layeredGraph, firstLayer, lastLayer, firstLabelLayer, lastLabelLayer);
        firstLabelLayer.nodes.array.length == 0 || (checkCriticalPositionIndex(0, layers.array.length), insertTo(layers.array, 0, firstLabelLayer));
        lastLabelLayer.nodes.array.length == 0 || push_1(layers.array, lastLabelLayer);
    }
    if ($hasProperty(layeredGraph, ($clinit_InternalProperties_1(), HIDDEN_NODES))) {
        firstSeparateLayer = new Layer(layeredGraph);
        lastSeparateLayer = new Layer(layeredGraph);
        $restoreHiddenNodes(layeredGraph, firstSeparateLayer, lastSeparateLayer);
        firstSeparateLayer.nodes.array.length == 0 || (checkCriticalPositionIndex(0, layers.array.length), insertTo(layers.array, 0, firstSeparateLayer));
        lastSeparateLayer.nodes.array.length == 0 || push_1(layers.array, lastSeparateLayer);
    }
    monitor.done_1();
}
function $restoreHiddenNodes(layeredGraph, firstSeparateLayer, lastSeparateLayer) {
    var hiddenEdge, hiddenEdge$iterator, hiddenNode, hiddenNode$iterator, isOutgoing, originalOppositePort;
    for(hiddenNode$iterator = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), HIDDEN_NODES)), 15).iterator_0(); hiddenNode$iterator.hasNext_0();){
        hiddenNode = castTo(hiddenNode$iterator.next_1(), 9);
        switch(castTo($getProperty(hiddenNode, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171).ordinal){
            case 2:
                $setLayer_0(hiddenNode, firstSeparateLayer);
                break;
            case 4:
                $setLayer_0(hiddenNode, lastSeparateLayer);
        }
        for(hiddenEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(hiddenNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(hiddenEdge$iterator);){
            hiddenEdge = castTo($next_0(hiddenEdge$iterator), 18);
            if (!!hiddenEdge.source && !!hiddenEdge.target) continue;
            isOutgoing = !hiddenEdge.target;
            originalOppositePort = castTo($getProperty(hiddenEdge, ORIGINAL_OPPOSITE_PORT), 11);
            isOutgoing ? $setTarget_0(hiddenEdge, originalOppositePort) : $setSource_0(hiddenEdge, originalOppositePort);
        }
    }
}
function $throwUpUnlessNoIncomingEdges(node) {
    var incoming, incoming$iterator;
    for(incoming$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(incoming$iterator);){
        incoming = castTo($next_0(incoming$iterator), 18);
        if (incoming.source.owner.type_0 != ($clinit_LNode$NodeType(), LABEL)) throw toJs(new UnsupportedConfigurationException_0("Node '" + $getDesignation_2(node) + "' has its layer constraint set to FIRST, but has at least one incoming edge that " + ' does not come from a FIRST_SEPARATE node. That must not happen.'));
    }
}
function $throwUpUnlessNoOutgoingEdges(node) {
    var outgoing, outgoing$iterator;
    for(outgoing$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outgoing$iterator);){
        outgoing = castTo($next_0(outgoing$iterator), 18);
        if (outgoing.target.owner.type_0 != ($clinit_LNode$NodeType(), LABEL)) throw toJs(new UnsupportedConfigurationException_0("Node '" + $getDesignation_2(node) + "' has its layer constraint set to LAST, but has at least one outgoing edge that " + ' does not go to a LAST_SEPARATE node. That must not happen.'));
    }
}
function LayerConstraintPostprocessor() {}
defineClass(1562, 1, $intern_102, LayerConstraintPostprocessor);
_.process = function process_29(layeredGraph, monitor) {
    $process_31(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LayerConstraintPostprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LayerConstraintPostprocessor', 1562);
function $clinit_LayerConstraintPreprocessor() {
    $clinit_LayerConstraintPreprocessor = emptyMethod;
    HIDDEN_NODE_CONNECTIONS = new Property_0('separateLayerConnections', ($clinit_LayerConstraintPreprocessor$HiddenNodeConnections(), NONE_0));
}
function $ensureNoInacceptableEdges(lNode) {
    var inEdge, inEdge$iterator, layerConstraint, outEdge, outEdge$iterator;
    layerConstraint = castTo($getProperty(lNode, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171);
    if (layerConstraint == ($clinit_LayerConstraint(), FIRST_SEPARATE_0)) for(inEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(inEdge$iterator);){
        inEdge = castTo($next_0(inEdge$iterator), 18);
        if (!$isAcceptableIncidentEdge(inEdge)) throw toJs(new UnsupportedConfigurationException_0("Node '" + $getDesignation_2(lNode) + "' has its layer constraint set to FIRST_SEPARATE, but has at least one incoming edge. " + 'FIRST_SEPARATE nodes must not have incoming edges.'));
    }
    else if (layerConstraint == LAST_SEPARATE_0) for(outEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outEdge$iterator);){
        outEdge = castTo($next_0(outEdge$iterator), 18);
        if (!$isAcceptableIncidentEdge(outEdge)) throw toJs(new UnsupportedConfigurationException_0("Node '" + $getDesignation_2(lNode) + "' has its layer constraint set to LAST_SEPARATE, but has at least one outgoing edge. " + 'LAST_SEPARATE nodes must not have outgoing edges.'));
    }
}
function $hide(lNode) {
    var lEdge, lEdge$iterator, isOutgoing, oppositePort;
    $ensureNoInacceptableEdges(lNode);
    for(lEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(lEdge$iterator);){
        lEdge = castTo($next_0(lEdge$iterator), 18);
        isOutgoing = lEdge.source.owner == lNode;
        oppositePort = isOutgoing ? lEdge.target : lEdge.source;
        isOutgoing ? $setTarget_0(lEdge, null) : $setSource_0(lEdge, null);
        $setProperty_0(lEdge, ($clinit_InternalProperties_1(), ORIGINAL_OPPOSITE_PORT), oppositePort);
        $updateOppositeNodeLayerConstraints(lNode, oppositePort.owner);
    }
}
function $isAcceptableIncidentEdge(edge) {
    var sourceNode, targetNode;
    sourceNode = edge.source.owner;
    targetNode = edge.target.owner;
    return sourceNode.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) && targetNode.type_0 == EXTERNAL_PORT;
}
function $isRelevantNode(lNode) {
    switch(castTo($getProperty(lNode, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171).ordinal){
        case 2:
        case 4:
            return true;
        default:
            return false;
    }
}
function $process_32(layeredGraph, monitor) {
    var hiddenNodes, lNode, nodeIterator;
    monitor.begin('Layer constraint preprocessing', 1);
    hiddenNodes = new ArrayList;
    nodeIterator = new AbstractList$ListIteratorImpl(layeredGraph.layerlessNodes, 0);
    while(nodeIterator.i < nodeIterator.this$01_0.size_1()){
        lNode = (checkCriticalElement(nodeIterator.i < nodeIterator.this$01_0.size_1()), castTo(nodeIterator.this$01_0.get_0(nodeIterator.last = nodeIterator.i++), 9));
        if ($isRelevantNode(lNode)) {
            $hide(lNode);
            push_1(hiddenNodes.array, lNode);
            $remove_8(nodeIterator);
        }
    }
    hiddenNodes.array.length == 0 || $setProperty_0(layeredGraph, ($clinit_InternalProperties_1(), HIDDEN_NODES), hiddenNodes);
    monitor.done_1();
}
function $updateOppositeNodeLayerConstraints(hiddenNode, oppositeNode) {
    var connections;
    if ($hasProperty(oppositeNode, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0))) return;
    connections = $combine_0(castTo($getProperty(oppositeNode, HIDDEN_NODE_CONNECTIONS), 364), castTo($getProperty(hiddenNode, LAYERING_LAYER_CONSTRAINT_0), 171));
    $setProperty_0(oppositeNode, HIDDEN_NODE_CONNECTIONS, connections);
    if ($hasNext_1(new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(oppositeNode).val$inputs1.iterator_0(), new Iterables$10)))) return;
    switch(connections.ordinal){
        case 1:
            $setProperty_0(oppositeNode, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), FIRST));
            break;
        case 2:
            $setProperty_0(oppositeNode, LAYERING_LAYER_CONSTRAINT_0, ($clinit_LayerConstraint(), LAST));
    }
}
function LayerConstraintPreprocessor() {
    $clinit_LayerConstraintPreprocessor();
}
defineClass(1563, 1, $intern_102, LayerConstraintPreprocessor);
_.process = function process_30(layeredGraph, monitor) {
    $process_32(castTo(layeredGraph, 36), monitor);
};
var HIDDEN_NODE_CONNECTIONS;
var Lorg_eclipse_elk_alg_layered_intermediate_LayerConstraintPreprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LayerConstraintPreprocessor', 1563);
function $clinit_LayerConstraintPreprocessor$HiddenNodeConnections() {
    $clinit_LayerConstraintPreprocessor$HiddenNodeConnections = emptyMethod;
    NONE_0 = new LayerConstraintPreprocessor$HiddenNodeConnections('NONE', 0);
    FIRST_SEPARATE = new LayerConstraintPreprocessor$HiddenNodeConnections('FIRST_SEPARATE', 1);
    LAST_SEPARATE = new LayerConstraintPreprocessor$HiddenNodeConnections('LAST_SEPARATE', 2);
    BOTH = new LayerConstraintPreprocessor$HiddenNodeConnections('BOTH', 3);
}
function $combine_0(this$static, layerConstraint) {
    switch(this$static.ordinal){
        case 0:
            return layerConstraint == ($clinit_LayerConstraint(), FIRST_SEPARATE_0) ? FIRST_SEPARATE : LAST_SEPARATE;
        case 1:
            return layerConstraint == ($clinit_LayerConstraint(), FIRST_SEPARATE_0) ? FIRST_SEPARATE : BOTH;
        case 2:
            return layerConstraint == ($clinit_LayerConstraint(), FIRST_SEPARATE_0) ? BOTH : LAST_SEPARATE;
        default:
            return BOTH;
    }
}
function LayerConstraintPreprocessor$HiddenNodeConnections(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_25(name_0) {
    $clinit_LayerConstraintPreprocessor$HiddenNodeConnections();
    return valueOf(($clinit_LayerConstraintPreprocessor$HiddenNodeConnections$Map(), $MAP_15), name_0);
}
function values_33() {
    $clinit_LayerConstraintPreprocessor$HiddenNodeConnections();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_LayerConstraintPreprocessor$HiddenNodeConnections_2_classLit, 1), $intern_36, 364, 0, [
        NONE_0,
        FIRST_SEPARATE,
        LAST_SEPARATE,
        BOTH
    ]);
}
defineClass(364, 23, {
    3: 1,
    34: 1,
    23: 1,
    364: 1
}, LayerConstraintPreprocessor$HiddenNodeConnections);
var BOTH, FIRST_SEPARATE, LAST_SEPARATE, NONE_0;
var Lorg_eclipse_elk_alg_layered_intermediate_LayerConstraintPreprocessor$HiddenNodeConnections_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate', 'LayerConstraintPreprocessor/HiddenNodeConnections', 364, Ljava_lang_Enum_2_classLit, values_33, valueOf_25);
function $clinit_LayerConstraintPreprocessor$HiddenNodeConnections$Map() {
    $clinit_LayerConstraintPreprocessor$HiddenNodeConnections$Map = emptyMethod;
    $MAP_15 = createValueOfMap(($clinit_LayerConstraintPreprocessor$HiddenNodeConnections(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_LayerConstraintPreprocessor$HiddenNodeConnections_2_classLit, 1), $intern_36, 364, 0, [
        NONE_0,
        FIRST_SEPARATE,
        LAST_SEPARATE,
        BOTH
    ])));
}
var $MAP_15;
function $process_33(layeredGraph, monitor) {
    var bottom, firstNode, foundNodes, lastNode, layer, layer$iterator, layerSize, maxY, minY, node, node$iterator, nodeMargin, nodeSize, top_0;
    monitor.begin('Layer size calculation', 1);
    minY = $intern_60;
    maxY = $intern_61;
    foundNodes = false;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layerSize = layer.size_0;
        layerSize.x_0 = 0;
        layerSize.y_0 = 0;
        if (layer.nodes.array.length == 0) continue;
        foundNodes = true;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            nodeSize = node.size_0;
            nodeMargin = node.margin;
            layerSize.x_0 = $wnd.Math.max(layerSize.x_0, nodeSize.x_0 + nodeMargin.left + nodeMargin.right);
        }
        firstNode = castTo($get_11(layer.nodes, 0), 9);
        top_0 = firstNode.pos.y_0 - firstNode.margin.top_0;
        firstNode.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) && (top_0 -= castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_PORTS_SURROUNDING)), 139).top_0);
        lastNode = castTo($get_11(layer.nodes, layer.nodes.array.length - 1), 9);
        bottom = lastNode.pos.y_0 + lastNode.size_0.y_0 + lastNode.margin.bottom;
        lastNode.type_0 == EXTERNAL_PORT && (bottom += castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_PORTS_SURROUNDING)), 139).bottom);
        layerSize.y_0 = bottom - top_0;
        minY = $wnd.Math.min(minY, top_0);
        maxY = $wnd.Math.max(maxY, bottom);
    }
    if (!foundNodes) {
        minY = 0;
        maxY = 0;
    }
    layeredGraph.size_0.y_0 = maxY - minY;
    layeredGraph.offset.y_0 -= minY;
    monitor.done_1();
}
function LayerSizeAndGraphHeightCalculator() {}
defineClass(1564, 1, $intern_102, LayerSizeAndGraphHeightCalculator);
_.process = function process_31(layeredGraph, monitor) {
    $process_33(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LayerSizeAndGraphHeightCalculator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LayerSizeAndGraphHeightCalculator', 1564);
function $process_34(layeredGraph, monitor) {
    var addUnnecessaryBendpoints, layer, layer$iterator, node, nodeIterator;
    monitor.begin('Edge joining', 1);
    addUnnecessaryBendpoints = $booleanValue(castToBoolean($getProperty(layeredGraph, ($clinit_LayeredOptions(), UNNECESSARY_BENDPOINTS_0))));
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodeIterator = new AbstractList$ListIteratorImpl(layer.nodes, 0);
        while(nodeIterator.i < nodeIterator.this$01_0.size_1()){
            node = (checkCriticalElement(nodeIterator.i < nodeIterator.this$01_0.size_1()), castTo(nodeIterator.this$01_0.get_0(nodeIterator.last = nodeIterator.i++), 9));
            if (node.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) {
                joinAt(node, addUnnecessaryBendpoints);
                $remove_8(nodeIterator);
            }
        }
    }
    monitor.done_1();
}
function LongEdgeJoiner() {}
function joinAt(longEdgeDummy, addUnnecessaryBendpoints) {
    var bendPoint, bendPoint$iterator, droppedEdge, droppedEdgeListIndex, droppedJunctionsPoints, edgeCount, inputPortEdges, jp, jp$iterator, label_0, label$iterator, outputPortEdges, survivingBendPoints, survivingEdge, survivingJunctionPoints, survivingLabels, targetIncomingEdges, unnecessaryBendpoint;
    inputPortEdges = castTo($getPorts_1(longEdgeDummy, ($clinit_PortSide(), WEST_0)).iterator_0().next_1(), 11).incomingEdges;
    outputPortEdges = castTo($getPorts_1(longEdgeDummy, EAST_0).iterator_0().next_1(), 11).outgoingEdges;
    edgeCount = inputPortEdges.array.length;
    unnecessaryBendpoint = $getAbsoluteAnchor(castTo($get_11(longEdgeDummy.ports, 0), 11));
    while(edgeCount-- > 0){
        survivingEdge = (checkCriticalElementIndex(0, inputPortEdges.array.length), castTo(inputPortEdges.array[0], 18));
        droppedEdge = (checkCriticalElementIndex(0, outputPortEdges.array.length), castTo(outputPortEdges.array[0], 18));
        targetIncomingEdges = droppedEdge.target.incomingEdges;
        droppedEdgeListIndex = $indexOf_3(targetIncomingEdges, droppedEdge, 0);
        $setTargetAndInsertAtIndex(survivingEdge, droppedEdge.target, droppedEdgeListIndex);
        $setSource_0(droppedEdge, null);
        $setTarget_0(droppedEdge, null);
        survivingBendPoints = survivingEdge.bendPoints;
        addUnnecessaryBendpoints && $add_7(survivingBendPoints, new KVector_2(unnecessaryBendpoint));
        for(bendPoint$iterator = $listIterator_2(droppedEdge.bendPoints, 0); bendPoint$iterator.currentNode != bendPoint$iterator.this$01.tail;){
            bendPoint = castTo($next_9(bendPoint$iterator), 8);
            $add_7(survivingBendPoints, new KVector_2(bendPoint));
        }
        survivingLabels = survivingEdge.labels;
        for(label$iterator = new ArrayList$1(droppedEdge.labels); label$iterator.i < label$iterator.this$01.array.length;){
            label_0 = castTo($next_6(label$iterator), 72);
            push_1(survivingLabels.array, label_0);
        }
        survivingJunctionPoints = castTo($getProperty(survivingEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
        droppedJunctionsPoints = castTo($getProperty(droppedEdge, JUNCTION_POINTS), 77);
        if (droppedJunctionsPoints) {
            if (!survivingJunctionPoints) {
                survivingJunctionPoints = new KVectorChain;
                $setProperty_0(survivingEdge, JUNCTION_POINTS, survivingJunctionPoints);
            }
            for(jp$iterator = $listIterator_2(droppedJunctionsPoints, 0); jp$iterator.currentNode != jp$iterator.this$01.tail;){
                jp = castTo($next_9(jp$iterator), 8);
                $add_7(survivingJunctionPoints, new KVector_2(jp));
            }
        }
    }
}
defineClass(1565, 1, $intern_102, LongEdgeJoiner);
_.process = function process_32(layeredGraph, monitor) {
    $process_34(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LongEdgeJoiner_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LongEdgeJoiner', 1565);
function $process_35(layeredGraph, monitor) {
    var edge, edge$iterator, layer, layerIter, nextLayer, node, node$iterator, port, port$iterator, targetLayer, targetPort, dummyNode;
    monitor.begin('Edge splitting', 1);
    if (layeredGraph.layers.array.length <= 2) {
        monitor.done_1();
        return;
    }
    layerIter = new AbstractList$ListIteratorImpl(layeredGraph.layers, 0);
    nextLayer = (checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25));
    while(layerIter.i < layerIter.this$01_0.size_1()){
        layer = nextLayer;
        nextLayer = (checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25));
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                    edge = castTo($next_6(edge$iterator), 18);
                    targetPort = edge.target;
                    targetLayer = targetPort.owner.layer;
                    targetLayer != layer && targetLayer != nextLayer && splitEdge(edge, (dummyNode = new LNode(layeredGraph), $setType(dummyNode, ($clinit_LNode$NodeType(), LONG_EDGE)), $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), edge), $setProperty_0(dummyNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS)), $setLayer_0(dummyNode, nextLayer), dummyNode));
                }
            }
        }
    }
    monitor.done_1();
}
function LongEdgeSplitter() {}
function moveHeadLabels(oldEdge, newEdge) {
    var label_0, labelIterator, labelPlacement;
    labelIterator = new AbstractList$ListIteratorImpl(oldEdge.labels, 0);
    while(labelIterator.i < labelIterator.this$01_0.size_1()){
        label_0 = (checkCriticalElement(labelIterator.i < labelIterator.this$01_0.size_1()), castTo(labelIterator.this$01_0.get_0(labelIterator.last = labelIterator.i++), 72));
        labelPlacement = castTo($getProperty(label_0, ($clinit_LayeredOptions(), EDGE_LABELS_PLACEMENT)), 276);
        if (labelPlacement == ($clinit_EdgeLabelPlacement(), HEAD)) {
            $remove_8(labelIterator);
            $add_3(newEdge.labels, label_0);
            $hasProperty(label_0, ($clinit_InternalProperties_1(), END_LABEL_EDGE)) || $setProperty_0(label_0, END_LABEL_EDGE, oldEdge);
        }
    }
}
function setDummyNodeProperties(dummyNode, inEdge, outEdge) {
    var inEdgeSourceNode, outEdgeTargetNode;
    inEdgeSourceNode = inEdge.source.owner;
    outEdgeTargetNode = outEdge.target.owner;
    if (inEdgeSourceNode.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) {
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), castTo($getProperty(inEdgeSourceNode, LONG_EDGE_SOURCE), 11));
        $setProperty_0(dummyNode, LONG_EDGE_TARGET, castTo($getProperty(inEdgeSourceNode, LONG_EDGE_TARGET), 11));
        $setProperty_0(dummyNode, LONG_EDGE_HAS_LABEL_DUMMIES, castToBoolean($getProperty(inEdgeSourceNode, LONG_EDGE_HAS_LABEL_DUMMIES)));
    } else if (inEdgeSourceNode.type_0 == LABEL) {
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), castTo($getProperty(inEdgeSourceNode, LONG_EDGE_SOURCE), 11));
        $setProperty_0(dummyNode, LONG_EDGE_TARGET, castTo($getProperty(inEdgeSourceNode, LONG_EDGE_TARGET), 11));
        $setProperty_0(dummyNode, LONG_EDGE_HAS_LABEL_DUMMIES, ($clinit_Boolean(), true));
    } else if (outEdgeTargetNode.type_0 == LABEL) {
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), castTo($getProperty(outEdgeTargetNode, LONG_EDGE_SOURCE), 11));
        $setProperty_0(dummyNode, LONG_EDGE_TARGET, castTo($getProperty(outEdgeTargetNode, LONG_EDGE_TARGET), 11));
        $setProperty_0(dummyNode, LONG_EDGE_HAS_LABEL_DUMMIES, ($clinit_Boolean(), true));
    } else {
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), inEdge.source);
        $setProperty_0(dummyNode, LONG_EDGE_TARGET, outEdge.target);
    }
}
function splitEdge(edge, dummyNode) {
    var dummyEdge, dummyInput, dummyOutput, oldEdgeTarget, portPos, thickness;
    oldEdgeTarget = edge.target;
    thickness = $doubleValue(castToDouble($getProperty(edge, ($clinit_LayeredOptions(), EDGE_THICKNESS))));
    if (thickness < 0) {
        thickness = 0;
        $setProperty_0(edge, EDGE_THICKNESS, thickness);
    }
    dummyNode.size_0.y_0 = thickness;
    portPos = $wnd.Math.floor(thickness / 2);
    dummyInput = new LPort;
    $setSide(dummyInput, ($clinit_PortSide(), WEST_0));
    $setNode(dummyInput, dummyNode);
    dummyInput.pos.y_0 = portPos;
    dummyOutput = new LPort;
    $setSide(dummyOutput, EAST_0);
    $setNode(dummyOutput, dummyNode);
    dummyOutput.pos.y_0 = portPos;
    $setTarget_0(edge, dummyInput);
    dummyEdge = new LEdge;
    $copyProperties(dummyEdge, edge);
    $setProperty_0(dummyEdge, JUNCTION_POINTS, null);
    $setSource_0(dummyEdge, dummyOutput);
    $setTarget_0(dummyEdge, oldEdgeTarget);
    setDummyNodeProperties(dummyNode, edge, dummyEdge);
    moveHeadLabels(edge, dummyEdge);
    return dummyEdge;
}
defineClass(1566, 1, $intern_102, LongEdgeSplitter);
_.process = function process_33(layeredGraph, monitor) {
    $process_35(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_LongEdgeSplitter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'LongEdgeSplitter', 1566);
function $clinit_NodePromotion() {
    $clinit_NodePromotion = emptyMethod;
    MODEL_ORDER_NODE_COMPARATOR_DESC = new NodePromotion$1;
    MODEL_ORDER_NODE_COMPARATOR_ASC = new NodePromotion$2;
}
function $modelOrderNodePromotion(this$static, leftToRight) {
    var connectedNode, containsLabels, currentLayer, currentLayerId, modelOrderAllowsPromotion, nextLayer, nextLayerId, nextLayerNode, nextLayerNode$iterator, node, nodeConnectedToNextLayer, nodeIndex, nodeToPromote, nodesToPromote, otherNode, otherNodeIndex, promoteThroughDummyLayer, shallBePromoted, somethingChanged;
    somethingChanged = false;
    do {
        somethingChanged = false;
        for(currentLayerId = leftToRight ? new AbstractMap$1(this$static.biLayerMap.multiMapKeyToValues).this$01.size_1() - 2 : 1; leftToRight ? currentLayerId >= 0 : currentLayerId < new AbstractMap$1(this$static.biLayerMap.multiMapKeyToValues).this$01.size_1(); currentLayerId += leftToRight ? -1 : 1){
            currentLayer = $getValues(this$static.biLayerMap, valueOf_3(currentLayerId));
            for(nodeIndex = 0; nodeIndex < currentLayer.size_0; nodeIndex++){
                node = castTo($get_7(currentLayer, nodeIndex), 9);
                if (!$hasProperty(node, ($clinit_InternalProperties_1(), MODEL_ORDER_1))) continue;
                if ($isMaximalKey(this$static.biLayerMap, valueOf_3(currentLayerId)) && this$static.promotionStrategy == ($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT) || $isMinimalKey(this$static.biLayerMap, valueOf_3(currentLayerId)) && this$static.promotionStrategy == ($clinit_NodePromotionStrategy(), MODEL_ORDER_RIGHT_TO_LEFT)) continue;
                shallBePromoted = true;
                for(otherNodeIndex = 0; otherNodeIndex < currentLayer.size_0; otherNodeIndex++){
                    otherNode = castTo($get_7(currentLayer, otherNodeIndex), 9);
                    $hasProperty(otherNode, MODEL_ORDER_1) && (leftToRight && castTo($getProperty(node, MODEL_ORDER_1), 17).value_0 < castTo($getProperty(otherNode, MODEL_ORDER_1), 17).value_0 || !leftToRight && castTo($getProperty(node, MODEL_ORDER_1), 17).value_0 > castTo($getProperty(otherNode, MODEL_ORDER_1), 17).value_0) && (shallBePromoted = false);
                }
                if (!shallBePromoted) continue;
                nextLayerId = leftToRight ? currentLayerId + 1 : currentLayerId - 1;
                nextLayer = $getValues(this$static.biLayerMap, valueOf_3(nextLayerId));
                modelOrderAllowsPromotion = false;
                promoteThroughDummyLayer = true;
                containsLabels = false;
                for(nextLayerNode$iterator = $listIterator_2(nextLayer, 0); nextLayerNode$iterator.currentNode != nextLayerNode$iterator.this$01.tail;){
                    nextLayerNode = castTo($next_9(nextLayerNode$iterator), 9);
                    if ($hasProperty(nextLayerNode, MODEL_ORDER_1)) {
                        if (nextLayerNode.id_0 != node.id_0) {
                            modelOrderAllowsPromotion = modelOrderAllowsPromotion | (leftToRight ? castTo($getProperty(nextLayerNode, MODEL_ORDER_1), 17).value_0 < castTo($getProperty(node, MODEL_ORDER_1), 17).value_0 : castTo($getProperty(nextLayerNode, MODEL_ORDER_1), 17).value_0 > castTo($getProperty(node, MODEL_ORDER_1), 17).value_0);
                            promoteThroughDummyLayer = false;
                        }
                    } else if (!modelOrderAllowsPromotion && promoteThroughDummyLayer) {
                        if (nextLayerNode.type_0 == ($clinit_LNode$NodeType(), LABEL)) {
                            containsLabels = true;
                            leftToRight ? nodeConnectedToNextLayer = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(nextLayerNode).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner : nodeConnectedToNextLayer = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(nextLayerNode).val$inputs1.iterator_0(), new Iterables$10))), 18).target.owner;
                            if (nodeConnectedToNextLayer == node) {
                                leftToRight ? connectedNode = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(nextLayerNode).val$inputs1.iterator_0(), new Iterables$10))), 18).target.owner : connectedNode = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(nextLayerNode).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner;
                                (leftToRight ? castTo($getKey_0(this$static.biLayerMap, connectedNode), 17).value_0 - castTo($getKey_0(this$static.biLayerMap, nodeConnectedToNextLayer), 17).value_0 : castTo($getKey_0(this$static.biLayerMap, nodeConnectedToNextLayer), 17).value_0 - castTo($getKey_0(this$static.biLayerMap, connectedNode), 17).value_0) <= 2 && (promoteThroughDummyLayer = false);
                            }
                        }
                    }
                }
                if (containsLabels && promoteThroughDummyLayer) {
                    leftToRight ? connectedNode = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10))), 18).target.owner : connectedNode = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner;
                    (leftToRight ? castTo($getKey_0(this$static.biLayerMap, connectedNode), 17).value_0 - castTo($getKey_0(this$static.biLayerMap, node), 17).value_0 : castTo($getKey_0(this$static.biLayerMap, node), 17).value_0 - castTo($getKey_0(this$static.biLayerMap, connectedNode), 17).value_0) <= 2 && connectedNode.type_0 == ($clinit_LNode$NodeType(), NORMAL) && (promoteThroughDummyLayer = false);
                }
                if (modelOrderAllowsPromotion || promoteThroughDummyLayer) {
                    nodesToPromote = $promoteNodeByModelOrder(this$static, node, leftToRight);
                    while(nodesToPromote.map_0.size_1() != 0){
                        nodeToPromote = castTo(nodesToPromote.map_0.keySet_0().iterator_0().next_1(), 9);
                        nodesToPromote.map_0.remove_0(nodeToPromote);
                        $addAll(nodesToPromote, $promoteNodeByModelOrder(this$static, nodeToPromote, leftToRight));
                    }
                    --nodeIndex;
                    somethingChanged = true;
                }
            }
        }
    }while (somethingChanged);
}
function $precalculateAndSetInformation(this$static) {
    var dummyBaggage, inDegree, incoming, layer, layer$iterator, layer$iterator0, layerID, layerSize, layerSizePixel, node, node$iterator, nodeID, nodesNdummies, outDegree, outcoming;
    this$static.nodeSizeAffix = $doubleValue(castToDouble($getProperty(this$static.masterGraph, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0))));
    this$static.dummySize = $doubleValue(castToDouble($getProperty(this$static.masterGraph, SPACING_EDGE_NODE_BETWEEN_LAYERS_0)));
    this$static.maxHeight = this$static.masterGraph.layers.array.length;
    layerID = this$static.maxHeight - 1;
    nodeID = 0;
    this$static.maxWidth = 0;
    this$static.maxWidthPixel = 0;
    this$static.currentWidth = newArrayList_1(initUnidimensionalArray(Ljava_lang_Integer_2_classLit, $intern_16, 17, this$static.maxHeight, 0, 1));
    this$static.currentWidthPixel = newArrayList_1(initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, this$static.maxHeight, 7, 1));
    for(layer$iterator0 = new ArrayList$1(this$static.masterGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        layer.id_0 = layerID;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.id_0 = nodeID;
            ++nodeID;
        }
        --layerID;
    }
    this$static.layers = initUnidimensionalArray(I_classLit, $intern_48, 30, nodeID, 15, 1);
    this$static.degreeDiff = initMultidimensionalArray(I_classLit, [
        $intern_16,
        $intern_48
    ], [
        54,
        30
    ], 15, [
        nodeID,
        3
    ], 2);
    this$static.nodes = new ArrayList;
    this$static.nodesWithIncomingEdges = new ArrayList;
    dummyBaggage = 0;
    this$static.dummyNodeCount = 0;
    for(layer$iterator = new ArrayList$1(this$static.masterGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layerID = layer.id_0;
        incoming = 0;
        outcoming = 0;
        layerSize = layer.nodes.array.length;
        layerSizePixel = 0;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            nodeID = node.id_0;
            this$static.layers[nodeID] = node.layer.id_0;
            layerSizePixel += node.size_0.y_0 + this$static.nodeSizeAffix;
            inDegree = size_24(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
            outDegree = size_24(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
            this$static.degreeDiff[nodeID][0] = outDegree - inDegree;
            this$static.degreeDiff[nodeID][1] = inDegree;
            this$static.degreeDiff[nodeID][2] = outDegree;
            incoming += inDegree;
            outcoming += outDegree;
            inDegree > 0 && $add_3(this$static.nodesWithIncomingEdges, node);
            $add_3(this$static.nodes, node);
        }
        dummyBaggage -= incoming;
        nodesNdummies = layerSize + dummyBaggage;
        layerSizePixel += dummyBaggage * this$static.dummySize;
        $set_1(this$static.currentWidth, layerID, valueOf_3(nodesNdummies));
        $set_1(this$static.currentWidthPixel, layerID, layerSizePixel);
        this$static.maxWidth = $wnd.Math.max(this$static.maxWidth, nodesNdummies);
        this$static.maxWidthPixel = $wnd.Math.max(this$static.maxWidthPixel, layerSizePixel);
        this$static.dummyNodeCount += dummyBaggage;
        dummyBaggage += outcoming;
    }
}
function $precalculateAndSetInformationModelOrder(this$static) {
    var layer, layer$iterator, layer$iterator0, layerId, leftToRight, modelOrderComparator, node, node$iterator, nodeId;
    this$static.biLayerMap = new BiLinkedHashMultiMap;
    nodeId = 0;
    layerId = 0;
    for(layer$iterator0 = new ArrayList$1(this$static.masterGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        layer.id_0 = layerId;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.id_0 = nodeId;
            ++nodeId;
        }
        ++layerId;
    }
    leftToRight = this$static.promotionStrategy == ($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT);
    modelOrderComparator = leftToRight ? MODEL_ORDER_NODE_COMPARATOR_DESC : MODEL_ORDER_NODE_COMPARATOR_ASC;
    for(layer$iterator = new ArrayList$1(this$static.masterGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        $sort(layer.nodes, modelOrderComparator);
        $putAll_0(this$static.biLayerMap, valueOf_3(layer.id_0), layer.nodes);
    }
}
function $process_36(this$static, layeredGraph, progressMonitor) {
    var donna, donna$iterator, funFunction, martha, martha$iterator, newMaxWidth, newMaxWidthPixel, promoteUntil, promoteUntilD, promoteUntilN;
    progressMonitor.begin('Node promotion heuristic', 1);
    this$static.masterGraph = layeredGraph;
    this$static.promotionStrategy = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), LAYERING_NODE_PROMOTION_STRATEGY_0)), 242);
    this$static.promotionStrategy != ($clinit_NodePromotionStrategy(), MODEL_ORDER_LEFT_TO_RIGHT) && this$static.promotionStrategy != MODEL_ORDER_RIGHT_TO_LEFT ? $precalculateAndSetInformation(this$static) : $precalculateAndSetInformationModelOrder(this$static);
    promoteUntil = castTo($getProperty(this$static.masterGraph, LAYERING_NODE_PROMOTION_MAX_ITERATIONS_0), 17).value_0;
    funFunction = new NodePromotion$lambda$0$Type;
    switch(this$static.promotionStrategy.ordinal){
        case 2:
        case 1:
            $promotionMagic(this$static, funFunction);
            break;
        case 3:
            this$static.promotionStrategy = NO_BOUNDARY;
            $promotionMagic(this$static, funFunction);
            newMaxWidth = 0;
            for(martha$iterator = new ArrayList$1(this$static.currentWidth); martha$iterator.i < martha$iterator.this$01.array.length;){
                martha = castTo($next_6(martha$iterator), 17);
                newMaxWidth = $wnd.Math.max(newMaxWidth, martha.value_0);
            }
            if (newMaxWidth > this$static.maxWidth) {
                this$static.promotionStrategy = NIKOLOV;
                $promotionMagic(this$static, funFunction);
            }
            break;
        case 4:
            this$static.promotionStrategy = NO_BOUNDARY;
            $promotionMagic(this$static, funFunction);
            newMaxWidthPixel = 0;
            for(donna$iterator = new ArrayList$1(this$static.currentWidthPixel); donna$iterator.i < donna$iterator.this$01.array.length;){
                donna = castToDouble($next_6(donna$iterator));
                newMaxWidthPixel = $wnd.Math.max(newMaxWidthPixel, (checkCriticalNotNull(donna), donna));
            }
            if (newMaxWidthPixel > this$static.maxWidthPixel) {
                this$static.promotionStrategy = NIKOLOV_PIXEL;
                $promotionMagic(this$static, funFunction);
            }
            break;
        case 6:
            promoteUntilN = round_int($wnd.Math.ceil(this$static.layers.length * promoteUntil / 100));
            $promotionMagic(this$static, new NodePromotion$lambda$1$Type(promoteUntilN));
            break;
        case 5:
            promoteUntilD = round_int($wnd.Math.ceil(this$static.dummyNodeCount * promoteUntil / 100));
            $promotionMagic(this$static, new NodePromotion$lambda$2$Type(promoteUntilD));
            break;
        case 8:
            $modelOrderNodePromotion(this$static, true);
            break;
        case 9:
            $modelOrderNodePromotion(this$static, false);
            break;
        default:
            $promotionMagic(this$static, funFunction);
    }
    this$static.promotionStrategy != MODEL_ORDER_LEFT_TO_RIGHT && this$static.promotionStrategy != MODEL_ORDER_RIGHT_TO_LEFT ? $setNewLayering(this$static, layeredGraph) : $setNewLayeringModelOrder(this$static, layeredGraph);
    progressMonitor.done_1();
}
function $promoteNode(this$static, node) {
    var dummiesBuilt, dummiesReduced, dummydiff, edge, edge$iterator, masterNode, maxWidthNotExceeded, nodeLayerPos, nodeSize, promotion;
    maxWidthNotExceeded = true;
    dummydiff = 0;
    nodeLayerPos = this$static.layers[node.id_0];
    nodeSize = node.size_0.y_0 + this$static.nodeSizeAffix;
    dummiesBuilt = this$static.degreeDiff[node.id_0][2];
    $set_1(this$static.currentWidth, nodeLayerPos, valueOf_3(castTo($get_11(this$static.currentWidth, nodeLayerPos), 17).value_0 - 1 + dummiesBuilt));
    $set_1(this$static.currentWidthPixel, nodeLayerPos, $doubleValue(castToDouble($get_11(this$static.currentWidthPixel, nodeLayerPos))) - nodeSize + dummiesBuilt * this$static.dummySize);
    ++nodeLayerPos;
    if (nodeLayerPos >= this$static.maxHeight) {
        ++this$static.maxHeight;
        $add_3(this$static.currentWidth, valueOf_3(1));
        $add_3(this$static.currentWidthPixel, nodeSize);
    } else {
        dummiesReduced = this$static.degreeDiff[node.id_0][1];
        $set_1(this$static.currentWidth, nodeLayerPos, valueOf_3(castTo($get_11(this$static.currentWidth, nodeLayerPos), 17).value_0 + 1 - dummiesReduced));
        $set_1(this$static.currentWidthPixel, nodeLayerPos, $doubleValue(castToDouble($get_11(this$static.currentWidthPixel, nodeLayerPos))) + nodeSize - dummiesReduced * this$static.dummySize);
    }
    (this$static.promotionStrategy == ($clinit_NodePromotionStrategy(), NIKOLOV) && (castTo($get_11(this$static.currentWidth, nodeLayerPos), 17).value_0 > this$static.maxWidth || castTo($get_11(this$static.currentWidth, nodeLayerPos - 1), 17).value_0 > this$static.maxWidth) || this$static.promotionStrategy == NIKOLOV_PIXEL && ($doubleValue(castToDouble($get_11(this$static.currentWidthPixel, nodeLayerPos))) > this$static.maxWidthPixel || $doubleValue(castToDouble($get_11(this$static.currentWidthPixel, nodeLayerPos - 1))) > this$static.maxWidthPixel)) && (maxWidthNotExceeded = false);
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        masterNode = edge.source.owner;
        if (this$static.layers[masterNode.id_0] == nodeLayerPos) {
            promotion = $promoteNode(this$static, masterNode);
            dummydiff = dummydiff + castTo(promotion.first, 17).value_0;
            maxWidthNotExceeded = maxWidthNotExceeded && $booleanValue(castToBoolean(promotion.second));
        }
    }
    this$static.layers[node.id_0] = nodeLayerPos;
    dummydiff = dummydiff + this$static.degreeDiff[node.id_0][0];
    return new Pair(valueOf_3(dummydiff), ($clinit_Boolean(), maxWidthNotExceeded ? true : false));
}
function $promoteNodeByModelOrder(this$static, node, leftToRight) {
    var edge, edge$iterator, nextNode, nodesToPromote, old, oldLayerId;
    oldLayerId = castTo($getKey_0(this$static.biLayerMap, node), 17).value_0;
    leftToRight ? $put_13(this$static.biLayerMap, valueOf_3(oldLayerId + 1), node) : $put_13(this$static.biLayerMap, valueOf_3(oldLayerId - 1), node);
    nodesToPromote = new LinkedHashSet;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2((leftToRight ? $getOutgoingEdges(node) : $getIncomingEdges(node)).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        leftToRight ? nextNode = edge.target.owner : nextNode = edge.source.owner;
        maskUndefined($getKey_0(this$static.biLayerMap, nextNode)) === maskUndefined($getKey_0(this$static.biLayerMap, node)) && (old = nodesToPromote.map_0.put(nextNode, nodesToPromote), old);
    }
    return nodesToPromote;
}
function $promotionMagic(this$static, funky) {
    var apply_0, currentWidthBackup, currentWidthPixelBackup, dummyBackup, heightBackup, iterationCounter, layeringBackup, node, node$iterator, promotionFlag, promotionPair, promotions, reducedDummies;
    iterationCounter = 0;
    reducedDummies = 0;
    layeringBackup = copyOf(this$static.layers, this$static.layers.length);
    dummyBackup = this$static.dummyNodeCount;
    heightBackup = this$static.maxHeight;
    currentWidthBackup = this$static.currentWidth;
    currentWidthPixelBackup = this$static.currentWidthPixel;
    do {
        promotions = 0;
        for(node$iterator = new ArrayList$1(this$static.nodesWithIncomingEdges); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            promotionPair = $promoteNode(this$static, node);
            apply_0 = true;
            (this$static.promotionStrategy == ($clinit_NodePromotionStrategy(), NIKOLOV) || this$static.promotionStrategy == NIKOLOV_PIXEL) && (apply_0 = $booleanValue(castToBoolean(promotionPair.second)));
            if (castTo(promotionPair.first, 17).value_0 < 0 && apply_0) {
                ++promotions;
                layeringBackup = copyOf(this$static.layers, this$static.layers.length);
                this$static.dummyNodeCount = this$static.dummyNodeCount + castTo(promotionPair.first, 17).value_0;
                reducedDummies += dummyBackup - this$static.dummyNodeCount;
                dummyBackup = this$static.dummyNodeCount + castTo(promotionPair.first, 17).value_0;
                heightBackup = this$static.maxHeight;
                currentWidthBackup = newArrayList(this$static.currentWidth);
                currentWidthPixelBackup = newArrayList(this$static.currentWidthPixel);
            } else {
                this$static.layers = copyOf(layeringBackup, layeringBackup.length);
                this$static.dummyNodeCount = dummyBackup;
                this$static.currentWidth = (checkNotNull(currentWidthBackup), currentWidthBackup ? new ArrayList_1(currentWidthBackup) : newArrayList_0(new ArrayList$1(currentWidthBackup)));
                this$static.currentWidthPixel = (checkNotNull(currentWidthPixelBackup), currentWidthPixelBackup ? new ArrayList_1(currentWidthPixelBackup) : newArrayList_0(new ArrayList$1(currentWidthPixelBackup)));
                this$static.maxHeight = heightBackup;
            }
        }
        ++iterationCounter;
        promotionFlag = promotions != 0 && $booleanValue(castToBoolean(funky.apply_0(new Pair(valueOf_3(reducedDummies), valueOf_3(iterationCounter)))));
    }while (promotionFlag);
}
function $setNewLayering(this$static, layeredGraph) {
    var i, laLaLayer, layList, layerIt, node, node$iterator, possiblyEvilLayer;
    layList = new ArrayList;
    for(i = 0; i <= this$static.maxHeight; i++){
        laLaLayer = new Layer(layeredGraph);
        laLaLayer.id_0 = this$static.maxHeight - i;
        push_1(layList.array, laLaLayer);
    }
    for(node$iterator = new ArrayList$1(this$static.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $setLayer_0(node, castTo($get_11(layList, this$static.maxHeight - this$static.layers[node.id_0]), 25));
    }
    layerIt = new ArrayList$1(layList);
    while(layerIt.i < layerIt.this$01.array.length){
        possiblyEvilLayer = castTo($next_6(layerIt), 25);
        possiblyEvilLayer.nodes.array.length == 0 && $remove_13(layerIt);
    }
    layeredGraph.layers.array.length = 0;
    $addAll_2(layeredGraph.layers, layList);
}
function $setNewLayeringModelOrder(this$static, layeredGraph) {
    var keySet, layerIndex, layerIndex$iterator, layerList, layerNodes, newLayer, node, node$iterator;
    layerList = new ArrayList;
    layeredGraph.layers.array.length = 0;
    keySet = castTo($collect_1($sorted_0(new StreamImpl(null, new Spliterators$IteratorSpliterator(new AbstractMap$1(this$static.biLayerMap.multiMapKeyToValues), 1))), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    for(layerIndex$iterator = keySet.iterator_0(); layerIndex$iterator.hasNext_0();){
        layerIndex = castTo(layerIndex$iterator.next_1(), 17);
        layerNodes = $getValues(this$static.biLayerMap, layerIndex);
        if (layerNodes.size_0 != 0) {
            newLayer = new Layer(layeredGraph);
            push_1(layerList.array, newLayer);
            newLayer.id_0 = layerIndex.value_0;
            for(node$iterator = $listIterator_2(layerNodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
                node = castTo($next_9(node$iterator), 9);
                $setLayer_0(node, newLayer);
            }
        }
    }
    $addAll_2(layeredGraph.layers, layerList);
}
function NodePromotion() {
    $clinit_NodePromotion();
    this.biLayerMap = new BiLinkedHashMultiMap;
}
function lambda$1_9(promoteUntilN_0, pair_1) {
    $clinit_NodePromotion();
    return $clinit_Boolean(), castTo(pair_1.second, 17).value_0 < promoteUntilN_0 ? true : false;
}
function lambda$2_4(promoteUntilD_0, pair_1) {
    $clinit_NodePromotion();
    return $clinit_Boolean(), castTo(pair_1.first, 17).value_0 < promoteUntilD_0 ? true : false;
}
defineClass(1567, 1, $intern_102, NodePromotion);
_.process = function process_34(layeredGraph, progressMonitor) {
    $process_36(this, castTo(layeredGraph, 36), progressMonitor);
};
_.dummyNodeCount = 0;
_.dummySize = 0;
_.maxHeight = 0;
_.maxWidth = 0;
_.maxWidthPixel = 0;
_.nodeSizeAffix = 0;
var MODEL_ORDER_NODE_COMPARATOR_ASC, MODEL_ORDER_NODE_COMPARATOR_DESC;
var Lorg_eclipse_elk_alg_layered_intermediate_NodePromotion_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NodePromotion', 1567);
function $compare_9(o1, o2) {
    if ($hasProperty(o1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(o2, MODEL_ORDER_1)) return castTo($getProperty(o2, MODEL_ORDER_1), 17).value_0 - castTo($getProperty(o1, MODEL_ORDER_1), 17).value_0;
    return 0;
}
function NodePromotion$1() {}
defineClass(1568, 1, $intern_88, NodePromotion$1);
_.compare_1 = function compare_41(o1, o2) {
    return $compare_9(castTo(o1, 9), castTo(o2, 9));
};
_.equals_0 = function equals_114(other) {
    return this === other;
};
_.reversed = function reversed_33() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_NodePromotion$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NodePromotion/1', 1568);
function $compare_10(o1, o2) {
    if ($hasProperty(o1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(o2, MODEL_ORDER_1)) return castTo($getProperty(o1, MODEL_ORDER_1), 17).value_0 - castTo($getProperty(o2, MODEL_ORDER_1), 17).value_0;
    return 0;
}
function NodePromotion$2() {}
defineClass(1569, 1, $intern_88, NodePromotion$2);
_.compare_1 = function compare_42(o1, o2) {
    return $compare_10(castTo(o1, 9), castTo(o2, 9));
};
_.equals_0 = function equals_115(other) {
    return this === other;
};
_.reversed = function reversed_34() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_NodePromotion$2_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NodePromotion/2', 1569);
function NodePromotion$lambda$0$Type() {}
defineClass(1570, 1, {}, NodePromotion$lambda$0$Type);
_.apply_0 = function apply_66(arg0) {
    return castTo(arg0, 47), $clinit_NodePromotion(), $clinit_Boolean(), true;
};
_.equals_0 = function equals_116(other) {
    return this === other;
};
var Lorg_eclipse_elk_alg_layered_intermediate_NodePromotion$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NodePromotion/lambda$0$Type', 1570);
function NodePromotion$lambda$1$Type(promoteUntilN_0) {
    this.promoteUntilN_0 = promoteUntilN_0;
}
defineClass(1571, 1, {}, NodePromotion$lambda$1$Type);
_.apply_0 = function apply_67(arg0) {
    return lambda$1_9(this.promoteUntilN_0, castTo(arg0, 47));
};
_.equals_0 = function equals_117(other) {
    return this === other;
};
_.promoteUntilN_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_NodePromotion$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NodePromotion/lambda$1$Type', 1571);
function NodePromotion$lambda$2$Type(promoteUntilD_0) {
    this.promoteUntilD_0 = promoteUntilD_0;
}
defineClass(1572, 1, {}, NodePromotion$lambda$2$Type);
_.apply_0 = function apply_68(arg0) {
    return lambda$2_4(this.promoteUntilD_0, castTo(arg0, 47));
};
_.equals_0 = function equals_118(other) {
    return this === other;
};
_.promoteUntilD_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_NodePromotion$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NodePromotion/lambda$2$Type', 1572);
function $process_37(layeredGraph, monitor) {
    var currentPort, layer, layer$iterator, node, node$array, node$index, node$max, nodeArray, port, port$iterator, portIterator, previousPort, routing, sameOriginPort, selfLoop, inputPort, outputPort, originInputPort, originOutputPort, bendPoint;
    monitor.begin('Odd port side processing', 1);
    routing = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), EDGE_ROUTING)), 220);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodeArray = toNodeArray(layer.nodes);
        for(node$array = nodeArray, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            if (node.type_0 != ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT)) continue;
            if (routing == ($clinit_EdgeRouting(), SPLINES)) for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                port.incomingEdges.array.length == 0 || $processSplineInputPort(port);
                port.outgoingEdges.array.length == 0 || $processSplineOutputPort(port);
            }
            else if (instanceOf($getProperty(node, ($clinit_InternalProperties_1(), ORIGIN_0)), 18)) {
                selfLoop = castTo($getProperty(node, ORIGIN_0), 18);
                inputPort = castTo($getPorts_1(node, ($clinit_PortSide(), WEST_0)).iterator_0().next_1(), 11);
                outputPort = castTo($getPorts_1(node, EAST_0).iterator_0().next_1(), 11);
                originInputPort = castTo($getProperty(inputPort, ORIGIN_0), 11);
                originOutputPort = castTo($getProperty(outputPort, ORIGIN_0), 11);
                $setSource_0(selfLoop, originOutputPort);
                $setTarget_0(selfLoop, originInputPort);
                bendPoint = new KVector_2(outputPort.owner.pos);
                bendPoint.x_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    originOutputPort.owner.pos,
                    originOutputPort.pos,
                    originOutputPort.anchor
                ])).x_0;
                $add_7(selfLoop.bendPoints, bendPoint);
                bendPoint = new KVector_2(inputPort.owner.pos);
                bendPoint.x_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    originInputPort.owner.pos,
                    originInputPort.pos,
                    originInputPort.anchor
                ])).x_0;
                $add_7(selfLoop.bendPoints, bendPoint);
            } else {
                if (node.ports.array.length >= 2) {
                    sameOriginPort = true;
                    portIterator = new ArrayList$1(node.ports);
                    currentPort = castTo($next_6(portIterator), 11);
                    previousPort = null;
                    while(portIterator.i < portIterator.this$01.array.length){
                        previousPort = currentPort;
                        currentPort = castTo($next_6(portIterator), 11);
                        if (!equals_Ljava_lang_Object__Z__devirtual$($getProperty(previousPort, ORIGIN_0), $getProperty(currentPort, ORIGIN_0))) {
                            sameOriginPort = false;
                            break;
                        }
                    }
                } else sameOriginPort = false;
                for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                    port = castTo($next_6(port$iterator), 11);
                    port.incomingEdges.array.length == 0 || $processInputPort(port, sameOriginPort);
                    port.outgoingEdges.array.length == 0 || $processOutputPort(port, sameOriginPort);
                }
            }
            $setLayer_0(node, null);
        }
    }
    monitor.done_1();
}
function $processInputPort(inputPort, addJunctionPoints) {
    var edgeArray, inEdge, inEdge$array, inEdge$index, inEdge$max, junctionPoints, originPort, x_0, y_0;
    originPort = castTo($getProperty(inputPort, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    x_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        originPort.owner.pos,
        originPort.pos,
        originPort.anchor
    ])).x_0;
    y_0 = inputPort.owner.pos.y_0;
    edgeArray = toEdgeArray(inputPort.incomingEdges);
    for(inEdge$array = edgeArray, inEdge$index = 0, inEdge$max = inEdge$array.length; inEdge$index < inEdge$max; ++inEdge$index){
        inEdge = inEdge$array[inEdge$index];
        $setTarget_0(inEdge, originPort);
        $addLast_0(inEdge.bendPoints, new KVector_1(x_0, y_0));
        if (addJunctionPoints) {
            junctionPoints = castTo($getProperty(inEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
            if (!junctionPoints) {
                junctionPoints = new KVectorChain;
                $setProperty_0(inEdge, JUNCTION_POINTS, junctionPoints);
            }
            $add_7(junctionPoints, new KVector_1(x_0, y_0));
        }
    }
}
function $processOutputPort(outputPort, addJunctionPoints) {
    var edgeArray, junctionPoints, originPort, outEdge, outEdge$array, outEdge$index, outEdge$max, x_0, y_0;
    originPort = castTo($getProperty(outputPort, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    x_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        originPort.owner.pos,
        originPort.pos,
        originPort.anchor
    ])).x_0;
    y_0 = outputPort.owner.pos.y_0;
    edgeArray = toEdgeArray(outputPort.outgoingEdges);
    for(outEdge$array = edgeArray, outEdge$index = 0, outEdge$max = outEdge$array.length; outEdge$index < outEdge$max; ++outEdge$index){
        outEdge = outEdge$array[outEdge$index];
        $setSource_0(outEdge, originPort);
        $addFirst_0(outEdge.bendPoints, new KVector_1(x_0, y_0));
        if (addJunctionPoints) {
            junctionPoints = castTo($getProperty(outEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
            if (!junctionPoints) {
                junctionPoints = new KVectorChain;
                $setProperty_0(outEdge, JUNCTION_POINTS, junctionPoints);
            }
            $add_7(junctionPoints, new KVector_1(x_0, y_0));
        }
    }
}
function $processSplineInputPort(inputPort) {
    var edgeArray, inEdge, inEdge$array, inEdge$index, inEdge$max, originPort;
    originPort = castTo($getProperty(inputPort, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    $setProperty_0(originPort, SPLINE_NS_PORT_Y_COORD, inputPort.owner.pos.y_0);
    edgeArray = toEdgeArray(inputPort.incomingEdges);
    for(inEdge$array = edgeArray, inEdge$index = 0, inEdge$max = inEdge$array.length; inEdge$index < inEdge$max; ++inEdge$index){
        inEdge = inEdge$array[inEdge$index];
        $setTarget_0(inEdge, originPort);
    }
}
function $processSplineOutputPort(outputPort) {
    var edgeArray, originPort, outEdge, outEdge$array, outEdge$index, outEdge$max;
    originPort = castTo($getProperty(outputPort, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    $setProperty_0(originPort, SPLINE_NS_PORT_Y_COORD, outputPort.owner.pos.y_0);
    edgeArray = toEdgeArray(outputPort.outgoingEdges);
    for(outEdge$array = edgeArray, outEdge$index = 0, outEdge$max = outEdge$array.length; outEdge$index < outEdge$max; ++outEdge$index){
        outEdge = outEdge$array[outEdge$index];
        $setSource_0(outEdge, originPort);
    }
}
function NorthSouthPortPostprocessor() {}
defineClass(1573, 1, $intern_102, NorthSouthPortPostprocessor);
_.process = function process_35(layeredGraph, monitor) {
    $process_37(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_NorthSouthPortPostprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NorthSouthPortPostprocessor', 1573);
function $createDummyNode_0(layeredGraph, inPort, outPort, dummyNodes) {
    var crossingHint, dummy, dummyInputPort, dummyOutputPort, edge, edge$array, edge$index, edge$max, edgeArray;
    dummy = new LNode(layeredGraph);
    $setType(dummy, ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT));
    $setProperty_0(dummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    crossingHint = 0;
    if (inPort) {
        dummyInputPort = new LPort;
        $setProperty_0(dummyInputPort, ($clinit_InternalProperties_1(), ORIGIN_0), inPort);
        $setProperty_0(dummy, ORIGIN_0, inPort.owner);
        $setSide(dummyInputPort, ($clinit_PortSide(), WEST_0));
        $setNode(dummyInputPort, dummy);
        edgeArray = toEdgeArray(inPort.incomingEdges);
        for(edge$array = edgeArray, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
            edge = edge$array[edge$index];
            $setTarget_0(edge, dummyInputPort);
        }
        $setProperty_0(inPort, PORT_DUMMY, dummy);
        ++crossingHint;
    }
    if (outPort) {
        dummyOutputPort = new LPort;
        $setProperty_0(dummy, ($clinit_InternalProperties_1(), ORIGIN_0), outPort.owner);
        $setProperty_0(dummyOutputPort, ORIGIN_0, outPort);
        $setSide(dummyOutputPort, ($clinit_PortSide(), EAST_0));
        $setNode(dummyOutputPort, dummy);
        edgeArray = toEdgeArray(outPort.outgoingEdges);
        for(edge$array = edgeArray, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
            edge = edge$array[edge$index];
            $setSource_0(edge, dummyOutputPort);
        }
        $setProperty_0(outPort, PORT_DUMMY, dummy);
        ++crossingHint;
    }
    $setProperty_0(dummy, ($clinit_InternalProperties_1(), CROSSING_HINT), valueOf_3(crossingHint));
    push_1(dummyNodes.array, dummy);
    return dummy;
}
function $createDummyNodes(layeredGraph, ports, dummyNodes, opposingSideDummyNodes, barycenterAssociates) {
    var edge, edge$iterator, edge$iterator0, edge$iterator1, in_0, inOutPort, inOutPort$iterator, inOutPorts, inPort, inPort$iterator, inPorts, northSouthSelfLoopEdges, out, outPort, outPort$iterator, outPorts, port, port$iterator, port$iterator0, sameSideSelfLoopEdges, dummy, dummyInputPort, dummyOutputPort;
    inPorts = new ArrayList_0(ports.size_0);
    outPorts = new ArrayList_0(ports.size_0);
    inOutPorts = new ArrayList_0(ports.size_0);
    sameSideSelfLoopEdges = new ArrayList_0(ports.size_0);
    northSouthSelfLoopEdges = new ArrayList_0(ports.size_0);
    for(port$iterator0 = $listIterator_2(ports, 0); port$iterator0.currentNode != port$iterator0.this$01.tail;){
        port = castTo($next_9(port$iterator0), 11);
        for(edge$iterator0 = new ArrayList$1(port.outgoingEdges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
            edge = castTo($next_6(edge$iterator0), 18);
            if (edge.source.owner == edge.target.owner) {
                if (port.side == edge.target.side) {
                    push_1(sameSideSelfLoopEdges.array, edge);
                    continue;
                } else if (port.side == ($clinit_PortSide(), NORTH_1) && edge.target.side == SOUTH_0) {
                    push_1(northSouthSelfLoopEdges.array, edge);
                    continue;
                }
            }
        }
    }
    for(edge$iterator1 = new ArrayList$1(northSouthSelfLoopEdges); edge$iterator1.i < edge$iterator1.this$01.array.length;){
        edge = castTo($next_6(edge$iterator1), 18);
        $createNorthSouthSelfLoopDummyNodes(layeredGraph, edge, dummyNodes, opposingSideDummyNodes, ($clinit_PortSide(), EAST_0));
    }
    for(edge$iterator = new ArrayList$1(sameSideSelfLoopEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 18);
        dummy = new LNode(layeredGraph);
        $setType(dummy, ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT));
        $setProperty_0(dummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
        $setProperty_0(dummy, ($clinit_InternalProperties_1(), ORIGIN_0), edge);
        dummyInputPort = new LPort;
        $setProperty_0(dummyInputPort, ORIGIN_0, edge.target);
        $setSide(dummyInputPort, ($clinit_PortSide(), WEST_0));
        $setNode(dummyInputPort, dummy);
        dummyOutputPort = new LPort;
        $setProperty_0(dummyOutputPort, ORIGIN_0, edge.source);
        $setSide(dummyOutputPort, EAST_0);
        $setNode(dummyOutputPort, dummy);
        $setProperty_0(edge.source, PORT_DUMMY, dummy);
        $setProperty_0(edge.target, PORT_DUMMY, dummy);
        $setSource_0(edge, null);
        $setTarget_0(edge, null);
        push_1(dummyNodes.array, dummy);
        $setProperty_0(dummy, CROSSING_HINT, valueOf_3(2));
    }
    for(port$iterator = $listIterator_2(ports, 0); port$iterator.currentNode != port$iterator.this$01.tail;){
        port = castTo($next_9(port$iterator), 11);
        in_0 = port.incomingEdges.array.length > 0;
        out = port.outgoingEdges.array.length > 0;
        in_0 && out ? push_1(inOutPorts.array, port) : in_0 ? push_1(inPorts.array, port) : out && push_1(outPorts.array, port);
    }
    for(inPort$iterator = new ArrayList$1(inPorts); inPort$iterator.i < inPort$iterator.this$01.array.length;){
        inPort = castTo($next_6(inPort$iterator), 11);
        $add_3(barycenterAssociates, $createDummyNode_0(layeredGraph, inPort, null, dummyNodes));
    }
    for(outPort$iterator = new ArrayList$1(outPorts); outPort$iterator.i < outPort$iterator.this$01.array.length;){
        outPort = castTo($next_6(outPort$iterator), 11);
        $add_3(barycenterAssociates, $createDummyNode_0(layeredGraph, null, outPort, dummyNodes));
    }
    for(inOutPort$iterator = new ArrayList$1(inOutPorts); inOutPort$iterator.i < inOutPort$iterator.this$01.array.length;){
        inOutPort = castTo($next_6(inOutPort$iterator), 11);
        $add_3(barycenterAssociates, $createDummyNode_0(layeredGraph, inOutPort, inOutPort, dummyNodes));
    }
}
function $createNorthSouthSelfLoopDummyNodes(layeredGraph, selfLoop, northDummyNodes, southDummyNodes, portSide) {
    var northDummy, northDummyOutputPort, southDummy, southDummyInputPort;
    northDummy = new LNode(layeredGraph);
    $setType(northDummy, ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT));
    $setProperty_0(northDummy, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    $setProperty_0(northDummy, ($clinit_InternalProperties_1(), ORIGIN_0), selfLoop.source.owner);
    northDummyOutputPort = new LPort;
    $setProperty_0(northDummyOutputPort, ORIGIN_0, selfLoop.source);
    $setSide(northDummyOutputPort, portSide);
    $setNode(northDummyOutputPort, northDummy);
    $setProperty_0(selfLoop.source, PORT_DUMMY, northDummy);
    southDummy = new LNode(layeredGraph);
    $setType(southDummy, NORTH_SOUTH_PORT);
    $setProperty_0(southDummy, PORT_CONSTRAINTS_0, FIXED_POS);
    $setProperty_0(southDummy, ORIGIN_0, selfLoop.target.owner);
    southDummyInputPort = new LPort;
    $setProperty_0(southDummyInputPort, ORIGIN_0, selfLoop.target);
    $setSide(southDummyInputPort, portSide);
    $setNode(southDummyInputPort, southDummy);
    $setProperty_0(selfLoop.target, PORT_DUMMY, southDummy);
    $setSource_0(selfLoop, northDummyOutputPort);
    $setTarget_0(selfLoop, southDummyInputPort);
    checkCriticalPositionIndex(0, northDummyNodes.array.length);
    insertTo(northDummyNodes.array, 0, northDummy);
    push_1(southDummyNodes.array, southDummy);
    $setProperty_0(northDummy, CROSSING_HINT, valueOf_3(1));
    $setProperty_0(southDummy, CROSSING_HINT, valueOf_3(1));
}
function $modelOrderNorthSouthInputReversing(portList) {
    var incoming, outgoing, port, port$iterator;
    incoming = new LinkedList;
    outgoing = new LinkedList;
    for(port$iterator = $listIterator_2(portList, 0); port$iterator.currentNode != port$iterator.this$01.tail;){
        port = castTo($next_9(port$iterator), 11);
        port.incomingEdges.array.length == 0 ? $addNode_0(outgoing, port, outgoing.tail.prev, outgoing.tail) : $addNode_0(incoming, port, incoming.tail.prev, incoming.tail);
    }
    reverse_0(incoming).addAll(outgoing);
    return incoming;
}
function $process_38(layeredGraph, monitor) {
    var barycenterAssociates, dummy, dummy$iterator, dummy$iterator0, dummyPort, insertPoint, layer, layer$iterator, node, node$array, node$index, node$max, nodeArray, northDummyNodes, originPort, pointer, port, port$iterator, portList, predecessor, southDummyNodes, successor;
    monitor.begin('Odd port side processing', 1);
    northDummyNodes = new ArrayList;
    southDummyNodes = new ArrayList;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        pointer = -1;
        nodeArray = toNodeArray(layer.nodes);
        for(node$array = nodeArray, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            ++pointer;
            if (!(node.type_0 == ($clinit_LNode$NodeType(), NORMAL) && $isSideFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100)))) continue;
            !$isOrderFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100)) && maskUndefined($getProperty($getGraph(node), CONSIDER_MODEL_ORDER_STRATEGY_0)) === maskUndefined(($clinit_OrderingStrategy(), NONE_11)) && $sortPortList_0(node);
            $setProperty_0(node, ($clinit_InternalProperties_1(), IN_LAYER_LAYOUT_UNIT), node);
            northDummyNodes.array.length = 0;
            southDummyNodes.array.length = 0;
            barycenterAssociates = new ArrayList;
            portList = new LinkedList;
            addAll_6(portList, $getPorts_1(node, ($clinit_PortSide(), NORTH_1)));
            maskUndefined($getProperty($getGraph(node), CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) && (portList = $modelOrderNorthSouthInputReversing(portList));
            $createDummyNodes(layeredGraph, portList, northDummyNodes, southDummyNodes, barycenterAssociates);
            insertPoint = pointer;
            successor = node;
            for(dummy$iterator0 = new ArrayList$1(northDummyNodes); dummy$iterator0.i < dummy$iterator0.this$01.array.length;){
                dummy = castTo($next_6(dummy$iterator0), 9);
                $setLayer(dummy, insertPoint, layer);
                ++pointer;
                $setProperty_0(dummy, IN_LAYER_LAYOUT_UNIT, node);
                dummyPort = castTo($get_11(dummy.ports, 0), 11);
                originPort = castTo($getProperty(dummyPort, ORIGIN_0), 11);
                $booleanValue(castToBoolean($getProperty(originPort, ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES_0))) || castTo($getProperty(dummy, IN_LAYER_SUCCESSOR_CONSTRAINTS), 15).add_2(successor);
            }
            $reset_0(portList);
            for(port$iterator = $getPorts_1(node, SOUTH_0).iterator_0(); port$iterator.hasNext_0();){
                port = castTo(port$iterator.next_1(), 11);
                $addNode_0(portList, port, portList.header, portList.header.next_0);
            }
            maskUndefined($getProperty($getGraph(node), CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(NONE_11) && (portList = $modelOrderNorthSouthInputReversing(portList));
            $createDummyNodes(layeredGraph, portList, southDummyNodes, null, barycenterAssociates);
            predecessor = node;
            for(dummy$iterator = new ArrayList$1(southDummyNodes); dummy$iterator.i < dummy$iterator.this$01.array.length;){
                dummy = castTo($next_6(dummy$iterator), 9);
                $setLayer(dummy, ++pointer, layer);
                $setProperty_0(dummy, IN_LAYER_LAYOUT_UNIT, node);
                dummyPort = castTo($get_11(dummy.ports, 0), 11);
                originPort = castTo($getProperty(dummyPort, ORIGIN_0), 11);
                $booleanValue(castToBoolean($getProperty(originPort, ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES_0))) || castTo($getProperty(predecessor, IN_LAYER_SUCCESSOR_CONSTRAINTS), 15).add_2(dummy);
            }
            barycenterAssociates.array.length == 0 || $setProperty_0(node, BARYCENTER_ASSOCIATES, barycenterAssociates);
        }
    }
    monitor.done_1();
}
function $sortPortList_0(node) {
    var inOutPorts, inPorts, incoming, outPorts, outgoing, port, port$iterator, ports;
    ports = node.ports.array.length;
    inPorts = 0;
    inOutPorts = ports;
    outPorts = 2 * ports;
    for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        switch(port.side.ordinal){
            case 2:
            case 4:
                port.id_0 = -1;
                break;
            case 1:
            case 3:
                incoming = port.incomingEdges.array.length;
                outgoing = port.outgoingEdges.array.length;
                incoming > 0 && outgoing > 0 ? port.id_0 = inOutPorts++ : incoming > 0 ? port.id_0 = inPorts++ : outgoing > 0 ? port.id_0 = outPorts++ : port.id_0 = inPorts++;
        }
    }
    $clinit_Collections();
    $sort(node.ports, new NorthSouthPortPreprocessor$lambda$0$Type);
}
function NorthSouthPortPreprocessor() {}
function lambda$0_24(port1_0, port2_1) {
    var side1, side2;
    side1 = port1_0.side;
    side2 = port2_1.side;
    return side1 != side2 ? side1.ordinal - side2.ordinal : port1_0.id_0 == port2_1.id_0 ? 0 : side1 == ($clinit_PortSide(), NORTH_1) ? port1_0.id_0 - port2_1.id_0 : port2_1.id_0 - port1_0.id_0;
}
defineClass(1574, 1, $intern_102, NorthSouthPortPreprocessor);
_.process = function process_36(layeredGraph, monitor) {
    $process_38(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_NorthSouthPortPreprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NorthSouthPortPreprocessor', 1574);
function NorthSouthPortPreprocessor$lambda$0$Type() {}
defineClass(1575, 1, $intern_88, NorthSouthPortPreprocessor$lambda$0$Type);
_.compare_1 = function compare_43(arg0, arg1) {
    return lambda$0_24(castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_119(other) {
    return this === other;
};
_.reversed = function reversed_35() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_NorthSouthPortPreprocessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'NorthSouthPortPreprocessor/lambda$0$Type', 1575);
function $connectNodes(firstPartition, secondPartition) {
    var edge, node, node$iterator, otherNode, otherNode$iterator, sourcePort, targetPort;
    for(node$iterator = firstPartition.iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 9);
        sourcePort = new LPort;
        $setNode(sourcePort, node);
        $setSide(sourcePort, ($clinit_PortSide(), EAST_0));
        $setProperty_0(sourcePort, ($clinit_InternalProperties_1(), PARTITION_DUMMY), ($clinit_Boolean(), true));
        for(otherNode$iterator = secondPartition.iterator_0(); otherNode$iterator.hasNext_0();){
            otherNode = castTo(otherNode$iterator.next_1(), 9);
            targetPort = new LPort;
            $setNode(targetPort, otherNode);
            $setSide(targetPort, WEST_0);
            $setProperty_0(targetPort, PARTITION_DUMMY, true);
            edge = new LEdge;
            $setProperty_0(edge, PARTITION_DUMMY, true);
            $setSource_0(edge, sourcePort);
            $setTarget_0(edge, targetPort);
        }
    }
}
function $process_39(lGraph, monitor) {
    var firstId, idIterator, partitionToNodesMap, result, secondId, sortedPartitionIDs;
    monitor.begin('Partition midprocessing', 1);
    partitionToNodesMap = new HashMultimap;
    $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(lGraph.layerlessNodes, 16)), new PartitionMidprocessor$lambda$0$Type), new PartitionMidprocessor$lambda$1$Type(partitionToNodesMap));
    if (partitionToNodesMap.totalSize == 0) return;
    sortedPartitionIDs = castTo($collect_1($sorted_0((result = partitionToNodesMap.keySet, new StreamImpl(null, (!result ? partitionToNodesMap.keySet = new AbstractMapBasedMultimap$KeySet(partitionToNodesMap, partitionToNodesMap.map_0) : result).spliterator_0()))), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    idIterator = sortedPartitionIDs.iterator_0();
    firstId = castTo(idIterator.next_1(), 17);
    while(idIterator.hasNext_0()){
        secondId = castTo(idIterator.next_1(), 17);
        $connectNodes(castTo($get(partitionToNodesMap, firstId), 22), castTo($get(partitionToNodesMap, secondId), 22));
        firstId = secondId;
    }
    monitor.done_1();
}
function PartitionMidprocessor() {}
function lambda$1_10(partitionToNodesMap_0, node_1) {
    return $put(partitionToNodesMap_0, castTo($getProperty(node_1, ($clinit_LayeredOptions(), PARTITIONING_PARTITION)), 17), node_1);
}
defineClass(1576, 1, $intern_102, PartitionMidprocessor);
_.process = function process_37(lGraph, monitor) {
    $process_39(castTo(lGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionMidprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionMidprocessor', 1576);
function PartitionMidprocessor$lambda$0$Type() {}
defineClass(1577, 1, $intern_39, PartitionMidprocessor$lambda$0$Type);
_.test_0 = function test_36(arg0) {
    return $hasProperty(castTo(arg0, 9), ($clinit_LayeredOptions(), PARTITIONING_PARTITION));
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionMidprocessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionMidprocessor/lambda$0$Type', 1577);
function PartitionMidprocessor$lambda$1$Type(partitionToNodesMap_0) {
    this.partitionToNodesMap_0 = partitionToNodesMap_0;
}
defineClass(1578, 1, $intern_19, PartitionMidprocessor$lambda$1$Type);
_.accept = function accept_74(arg0) {
    lambda$1_10(this.partitionToNodesMap_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionMidprocessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionMidprocessor/lambda$1$Type', 1578);
function $process_40(lGraph, monitor) {
    var layer, layer$iterator, node, node$iterator, port, ports;
    monitor.begin('Partition postprocessing', 1);
    for(layer$iterator = new ArrayList$1(lGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            ports = new ArrayList$1(node.ports);
            while(ports.i < ports.this$01.array.length){
                port = castTo($next_6(ports), 11);
                $booleanValue(castToBoolean($getProperty(port, ($clinit_InternalProperties_1(), PARTITION_DUMMY)))) && $remove_13(ports);
            }
        }
    }
    monitor.done_1();
}
function PartitionPostprocessor() {}
defineClass(1579, 1, $intern_102, PartitionPostprocessor);
_.process = function process_38(lGraph, monitor) {
    $process_40(castTo(lGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionPostprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionPostprocessor', 1579);
function $mustBeReversed(lEdge) {
    var sourcePartition, targetPartition;
    if ($hasProperty(lEdge.target.owner, ($clinit_LayeredOptions(), PARTITIONING_PARTITION))) {
        sourcePartition = castTo($getProperty(lEdge.source.owner, PARTITIONING_PARTITION), 17);
        targetPartition = castTo($getProperty(lEdge.target.owner, PARTITIONING_PARTITION), 17);
        return compare_5(sourcePartition.value_0, targetPartition.value_0) > 0;
    } else return false;
}
function $process_41(lGraph, monitor) {
    var edgesToBeReversed;
    monitor.begin('Partition preprocessing', 1);
    edgesToBeReversed = castTo($collect_1($filter($flatMap($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(lGraph.layerlessNodes, 16)), new PartitionPreprocessor$lambda$0$Type), new PartitionPreprocessor$lambda$1$Type), new PartitionPreprocessor$lambda$2$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    $forEach_3(edgesToBeReversed.stream(), new PartitionPreprocessor$lambda$3$Type);
    monitor.done_1();
}
function $reverse_1(lEdge) {
    var priority;
    $reverse_0(lEdge, true);
    priority = $intern_45;
    $hasProperty(lEdge, ($clinit_LayeredOptions(), PRIORITY_DIRECTION_0)) && (priority += castTo($getProperty(lEdge, PRIORITY_DIRECTION_0), 17).value_0);
    $setProperty_0(lEdge, PRIORITY_DIRECTION_0, valueOf_3(priority));
}
function PartitionPreprocessor() {}
defineClass(1580, 1, $intern_102, PartitionPreprocessor);
_.process = function process_39(lGraph, monitor) {
    $process_41(castTo(lGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionPreprocessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionPreprocessor', 1580);
function PartitionPreprocessor$lambda$0$Type() {}
defineClass(1581, 1, $intern_39, PartitionPreprocessor$lambda$0$Type);
_.test_0 = function test_37(arg0) {
    return $hasProperty(castTo(arg0, 9), ($clinit_LayeredOptions(), PARTITIONING_PARTITION));
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionPreprocessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionPreprocessor/lambda$0$Type', 1581);
function PartitionPreprocessor$lambda$1$Type() {}
defineClass(1582, 1, {}, PartitionPreprocessor$lambda$1$Type);
_.apply_0 = function apply_69(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionPreprocessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionPreprocessor/lambda$1$Type', 1582);
function PartitionPreprocessor$lambda$2$Type() {}
defineClass(1583, 1, $intern_39, PartitionPreprocessor$lambda$2$Type);
_.test_0 = function test_38(arg0) {
    return $mustBeReversed(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionPreprocessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionPreprocessor/lambda$2$Type', 1583);
function PartitionPreprocessor$lambda$3$Type() {}
defineClass(1584, 1, $intern_19, PartitionPreprocessor$lambda$3$Type);
_.accept = function accept_75(arg0) {
    $reverse_1(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_PartitionPreprocessor$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PartitionPreprocessor/lambda$3$Type', 1584);
function $clinit_PortListSorter() {
    $clinit_PortListSorter = emptyMethod;
    IN_EDGES = new PortListSorter$lambda$0$Type;
    OUT_EDGES = new PortListSorter$lambda$1$Type;
    CMP_PORT_SIDE = new PortListSorter$lambda$2$Type;
    CMP_PORT_DEGREE_EAST_WEST = new PortListSorter$lambda$3$Type;
    CMP_FIXED_ORDER_AND_FIXED_POS = new PortListSorter$lambda$4$Type;
    CMP_COMBINED = (checkCriticalNotNull(CMP_FIXED_ORDER_AND_FIXED_POS), new Comparator$lambda$0$Type);
}
function $findPortSideRange(ports, side) {
    var currentSide, hb, highIdx, lb, lowIdx;
    if (ports.array.length == 0) return new Pair(valueOf_3(0), valueOf_3(0));
    currentSide = (checkCriticalElementIndex(0, ports.array.length), castTo(ports.array[0], 11)).side;
    lowIdx = 0;
    lb = side.ordinal;
    hb = side.ordinal + 1;
    while(lowIdx < ports.array.length - 1 && currentSide.ordinal < lb){
        ++lowIdx;
        currentSide = (checkCriticalElementIndex(lowIdx, ports.array.length), castTo(ports.array[lowIdx], 11)).side;
    }
    highIdx = lowIdx;
    while(highIdx < ports.array.length - 1 && currentSide.ordinal < hb){
        ++highIdx;
        currentSide = (checkCriticalElementIndex(lowIdx, ports.array.length), castTo(ports.array[lowIdx], 11)).side;
    }
    return new Pair(valueOf_3(lowIdx), valueOf_3(highIdx));
}
function $process_42(layeredGraph, monitor) {
    var layer, layer$iterator, node, node$iterator, portConstraints, ports, pss;
    monitor.begin('Port order processing', 1);
    pss = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), PORT_SORTING_STRATEGY_0)), 418);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            portConstraints = castTo($getProperty(node, PORT_CONSTRAINTS_0), 100);
            ports = node.ports;
            if (portConstraints == ($clinit_PortConstraints(), FIXED_ORDER) || portConstraints == FIXED_RATIO || portConstraints == FIXED_POS) {
                $clinit_Collections();
                $sort(ports, CMP_COMBINED);
            } else if (portConstraints != FREE && portConstraints != UNDEFINED_4) {
                $clinit_Collections();
                $sort(ports, CMP_PORT_SIDE);
                $reverseWestAndSouthSide(ports);
                pss == ($clinit_PortSortingStrategy(), PORT_DEGREE) && $sort(ports, CMP_PORT_DEGREE_EAST_WEST);
            }
            node.portSidesCached = true;
            $findPortIndices(node);
        }
    }
    monitor.done_1();
}
function $reverse_2(ports, lowIdx, highIdx) {
    var i, n, tmp;
    if (highIdx <= lowIdx + 2) return;
    n = (highIdx - lowIdx) / 2 | 0;
    for(i = 0; i < n; ++i){
        tmp = (checkCriticalElementIndex(lowIdx + i, ports.array.length), castTo(ports.array[lowIdx + i], 11));
        $set_1(ports, lowIdx + i, (checkCriticalElementIndex(highIdx - i - 1, ports.array.length), castTo(ports.array[highIdx - i - 1], 11)));
        checkCriticalElementIndex(highIdx - i - 1, ports.array.length);
        ports.array[highIdx - i - 1] = tmp;
    }
}
function $reverseWestAndSouthSide(ports) {
    var southIndices, westIndices;
    if (ports.array.length <= 1) return;
    southIndices = $findPortSideRange(ports, ($clinit_PortSide(), SOUTH_0));
    $reverse_2(ports, castTo(southIndices.first, 17).value_0, castTo(southIndices.second, 17).value_0);
    westIndices = $findPortSideRange(ports, WEST_0);
    $reverse_2(ports, castTo(westIndices.first, 17).value_0, castTo(westIndices.second, 17).value_0);
}
function PortListSorter() {
    $clinit_PortListSorter();
}
function lambda$2_5(p1_0, p2_1) {
    $clinit_PortListSorter();
    var ordinalDifference;
    ordinalDifference = p1_0.side.ordinal - p2_1.side.ordinal;
    if (ordinalDifference != 0) return ordinalDifference;
    return 0;
}
function lambda$3_2(p1_0, p2_1) {
    $clinit_PortListSorter();
    var ordinalDifference;
    ordinalDifference = p1_0.side.ordinal - p2_1.side.ordinal;
    if (ordinalDifference != 0) return 0;
    switch(p1_0.side.ordinal){
        case 2:
            return realDegree_0(p2_1, OUT_EDGES) - realDegree_0(p1_0, OUT_EDGES);
        case 4:
            return realDegree_0(p1_0, IN_EDGES) - realDegree_0(p2_1, IN_EDGES);
    }
    return 0;
}
function lambda$4_4(p1_0, p2_1) {
    $clinit_PortListSorter();
    var index1, index2, indexDifference, ordinalDifference, portConstraints;
    portConstraints = castTo($getProperty(p1_0.owner, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    ordinalDifference = p1_0.side.ordinal - p2_1.side.ordinal;
    if (ordinalDifference != 0 || !(portConstraints == ($clinit_PortConstraints(), FIXED_ORDER) || portConstraints == FIXED_RATIO || portConstraints == FIXED_POS)) return 0;
    if (portConstraints == ($clinit_PortConstraints(), FIXED_ORDER)) {
        index1 = castTo($getProperty(p1_0, PORT_INDEX), 17);
        index2 = castTo($getProperty(p2_1, PORT_INDEX), 17);
        if (!!index1 && !!index2) {
            indexDifference = index1.value_0 - index2.value_0;
            if (indexDifference != 0) return indexDifference;
        }
    }
    switch(p1_0.side.ordinal){
        case 1:
            return compare_4(p1_0.pos.x_0, p2_1.pos.x_0);
        case 2:
            return compare_4(p1_0.pos.y_0, p2_1.pos.y_0);
        case 3:
            return compare_4(p2_1.pos.x_0, p1_0.pos.x_0);
        case 4:
            return compare_4(p2_1.pos.y_0, p1_0.pos.y_0);
        default:
            throw toJs(new IllegalStateException_0('Port side is undefined'));
    }
}
function realDegree_0(p, edgesFun) {
    var e, e$iterator, realDegree;
    realDegree = 0;
    for(e$iterator = castTo(edgesFun.apply_0(p), 20).iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 18);
        $booleanValue(castToBoolean($getProperty(e, ($clinit_InternalProperties_1(), REVERSED)))) || ++realDegree;
    }
    return realDegree;
}
defineClass(1585, 1, $intern_102, PortListSorter);
_.process = function process_40(layeredGraph, monitor) {
    $process_42(castTo(layeredGraph, 36), monitor);
};
var CMP_COMBINED, CMP_FIXED_ORDER_AND_FIXED_POS, CMP_PORT_DEGREE_EAST_WEST, CMP_PORT_SIDE, IN_EDGES, OUT_EDGES;
var Lorg_eclipse_elk_alg_layered_intermediate_PortListSorter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortListSorter', 1585);
function PortListSorter$lambda$0$Type() {}
defineClass(1586, 1, {}, PortListSorter$lambda$0$Type);
_.apply_0 = function apply_70(arg0) {
    return $clinit_PortListSorter(), castTo(arg0, 11).incomingEdges;
};
var Lorg_eclipse_elk_alg_layered_intermediate_PortListSorter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortListSorter/lambda$0$Type', 1586);
function PortListSorter$lambda$1$Type() {}
defineClass(1587, 1, {}, PortListSorter$lambda$1$Type);
_.apply_0 = function apply_71(arg0) {
    return $clinit_PortListSorter(), castTo(arg0, 11).outgoingEdges;
};
var Lorg_eclipse_elk_alg_layered_intermediate_PortListSorter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortListSorter/lambda$1$Type', 1587);
function PortListSorter$lambda$2$Type() {}
defineClass(1588, 1, $intern_88, PortListSorter$lambda$2$Type);
_.compare_1 = function compare_44(arg0, arg1) {
    return lambda$2_5(castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_120(other) {
    return this === other;
};
_.reversed = function reversed_36() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PortListSorter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortListSorter/lambda$2$Type', 1588);
function PortListSorter$lambda$3$Type() {}
defineClass(1589, 1, $intern_88, PortListSorter$lambda$3$Type);
_.compare_1 = function compare_45(arg0, arg1) {
    return lambda$3_2(castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_121(other) {
    return this === other;
};
_.reversed = function reversed_37() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PortListSorter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortListSorter/lambda$3$Type', 1589);
function PortListSorter$lambda$4$Type() {}
defineClass(1590, 1, $intern_88, PortListSorter$lambda$4$Type);
_.compare_1 = function compare_46(arg0, arg1) {
    return lambda$4_4(castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_122(other) {
    return this === other;
};
_.reversed = function reversed_38() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PortListSorter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortListSorter/lambda$4$Type', 1590);
function $process_43(layeredGraph, monitor) {
    var layer, layer$iterator, node, node$iterator, node$iterator0;
    monitor.begin('Port side processing', 1);
    for(node$iterator0 = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        $process_44(node);
    }
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            $process_44(node);
        }
    }
    monitor.done_1();
}
function $process_44(node) {
    var port, port$iterator, portDummy;
    if ($isSideFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100))) for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        port.side == ($clinit_PortSide(), UNDEFINED_5) && (portDummy = castTo($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9), portDummy ? $setSide(port, castTo($getProperty(portDummy, EXT_PORT_SIDE), 64)) : port.incomingEdges.array.length - port.outgoingEdges.array.length < 0 ? $setSide(port, EAST_0) : $setSide(port, WEST_0));
    }
    else {
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            portDummy = castTo($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
            portDummy ? $setSide(port, castTo($getProperty(portDummy, EXT_PORT_SIDE), 64)) : port.incomingEdges.array.length - port.outgoingEdges.array.length < 0 ? $setSide(port, ($clinit_PortSide(), EAST_0)) : $setSide(port, ($clinit_PortSide(), WEST_0));
        }
        $setProperty_0(node, PORT_CONSTRAINTS_0, ($clinit_PortConstraints(), FIXED_SIDE));
    }
}
function PortSideProcessor() {}
defineClass(1591, 1, $intern_102, PortSideProcessor);
_.process = function process_41(layeredGraph, monitor) {
    $process_43(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_PortSideProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'PortSideProcessor', 1591);
function $process_45(layeredGraph, monitor) {
    var edge, edge$array, edge$index, edge$max, edgeArray, layer, layer$iterator, node, node$iterator, port, port$iterator;
    monitor.begin('Restoring reversed edges', 1);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                edgeArray = toEdgeArray(port.outgoingEdges);
                for(edge$array = edgeArray, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                    edge = edge$array[edge$index];
                    $booleanValue(castToBoolean($getProperty(edge, ($clinit_InternalProperties_1(), REVERSED)))) && $reverse_0(edge, false);
                }
            }
        }
    }
    monitor.done_1();
}
function ReversedEdgeRestorer() {}
defineClass(1592, 1, $intern_102, ReversedEdgeRestorer);
_.process = function process_42(layeredGraph, monitor) {
    $process_45(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_ReversedEdgeRestorer_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'ReversedEdgeRestorer', 1592);
function $process_46(this$static, graph, progressMonitor) {
    progressMonitor.begin('Self-Loop ordering', 1);
    $forEach_3($map($filter($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(graph.layers, 16)), new SelfLoopPortRestorer$lambda$0$Type), new SelfLoopPortRestorer$lambda$1$Type), new SelfLoopPortRestorer$lambda$2$Type), new SelfLoopPortRestorer$lambda$3$Type), new SelfLoopPortRestorer$lambda$4$Type(this$static));
    progressMonitor.done_1();
}
function $processNode_4(this$static, slHolder) {
    if (slHolder.arePortsHidden) switch(castTo($getProperty(slHolder.lNode, ($clinit_InternalProperties_1(), ORIGINAL_PORT_CONSTRAINTS)), 100).ordinal){
        case 0:
        case 1:
            $assignPortSides(slHolder);
        case 2:
            $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new SelfLoopPortRestorer$lambda$5$Type);
            $restorePorts_0(this$static.portRestorer, slHolder);
    }
    else $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new SelfLoopPortRestorer$lambda$5$Type);
}
function SelfLoopPortRestorer() {
    this.portRestorer = new PortRestorer;
}
defineClass(1597, 1, $intern_102, SelfLoopPortRestorer);
_.process = function process_43(graph, progressMonitor) {
    $process_46(this, castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer', 1597);
function SelfLoopPortRestorer$lambda$0$Type() {}
defineClass(1598, 1, {}, SelfLoopPortRestorer$lambda$0$Type);
_.apply_0 = function apply_72(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer/lambda$0$Type', 1598);
function SelfLoopPortRestorer$lambda$1$Type() {}
defineClass(1599, 1, $intern_39, SelfLoopPortRestorer$lambda$1$Type);
_.test_0 = function test_39(arg0) {
    return castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer/lambda$1$Type', 1599);
function SelfLoopPortRestorer$lambda$2$Type() {}
defineClass(1600, 1, $intern_39, SelfLoopPortRestorer$lambda$2$Type);
_.test_0 = function test_40(arg0) {
    return $hasProperty(castTo(arg0, 9), ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer/lambda$2$Type', 1600);
function SelfLoopPortRestorer$lambda$3$Type() {}
defineClass(1601, 1, {}, SelfLoopPortRestorer$lambda$3$Type);
_.apply_0 = function apply_73(arg0) {
    return castTo($getProperty(castTo(arg0, 9), ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER)), 333);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer/lambda$3$Type', 1601);
function SelfLoopPortRestorer$lambda$4$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1602, 1, $intern_19, SelfLoopPortRestorer$lambda$4$Type);
_.accept = function accept_76(arg0) {
    $processNode_4(this.$$outer_0, castTo(arg0, 333));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer/lambda$4$Type', 1602);
function SelfLoopPortRestorer$lambda$5$Type() {}
defineClass(785, 1, $intern_19, SelfLoopPortRestorer$lambda$5$Type);
_.accept = function accept_77(arg0) {
    $computePortsPerSide(castTo(arg0, 105));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPortRestorer$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPortRestorer/lambda$5$Type', 785);
function $process_47(graph, progressMonitor) {
    progressMonitor.begin('Self-Loop post-processing', 1);
    $forEach_3($filter($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(graph.layers, 16)), new SelfLoopPostProcessor$lambda$0$Type), new SelfLoopPostProcessor$lambda$1$Type), new SelfLoopPostProcessor$lambda$2$Type), new SelfLoopPostProcessor$lambda$3$Type);
    progressMonitor.done_1();
}
function $processNode_5(lNode) {
    var slHolder;
    slHolder = castTo($getProperty(lNode, ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER)), 333);
    $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new SelfLoopPostProcessor$lambda$4$Type), new SelfLoopPostProcessor$lambda$5$Type(lNode));
    $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new SelfLoopPostProcessor$lambda$6$Type), new SelfLoopPostProcessor$lambda$7$Type(lNode));
}
function $restoreEdge(lNode, slEdge) {
    var lEdge;
    lEdge = slEdge.lEdge;
    $setSource_0(lEdge, slEdge.slSource.lPort);
    $setTarget_0(lEdge, slEdge.slTarget.lPort);
    $offset_2(lEdge.bendPoints, lNode.pos);
}
function SelfLoopPostProcessor() {}
function lambda$7_0(lNode_0, slLoop_1) {
    $applyPlacement(slLoop_1.slLabels, lNode_0.pos);
}
defineClass(1604, 1, $intern_102, SelfLoopPostProcessor);
_.process = function process_44(graph, progressMonitor) {
    $process_47(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor', 1604);
function SelfLoopPostProcessor$lambda$0$Type() {}
defineClass(1605, 1, {}, SelfLoopPostProcessor$lambda$0$Type);
_.apply_0 = function apply_74(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$0$Type', 1605);
function SelfLoopPostProcessor$lambda$1$Type() {}
defineClass(1606, 1, $intern_39, SelfLoopPostProcessor$lambda$1$Type);
_.test_0 = function test_41(arg0) {
    return castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$1$Type', 1606);
function SelfLoopPostProcessor$lambda$2$Type() {}
defineClass(1607, 1, $intern_39, SelfLoopPostProcessor$lambda$2$Type);
_.test_0 = function test_42(arg0) {
    return $hasProperty(castTo(arg0, 9), ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$2$Type', 1607);
function SelfLoopPostProcessor$lambda$3$Type() {}
defineClass(1608, 1, $intern_19, SelfLoopPostProcessor$lambda$3$Type);
_.accept = function accept_78(arg0) {
    $processNode_5(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$3$Type', 1608);
function SelfLoopPostProcessor$lambda$4$Type() {}
defineClass(1609, 1, {}, SelfLoopPostProcessor$lambda$4$Type);
_.apply_0 = function apply_75(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 105).slEdges, 1));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$4$Type', 1609);
function SelfLoopPostProcessor$lambda$5$Type(lNode_1) {
    this.lNode_1 = lNode_1;
}
defineClass(1610, 1, $intern_19, SelfLoopPostProcessor$lambda$5$Type);
_.accept = function accept_79(arg0) {
    $restoreEdge(this.lNode_1, castTo(arg0, 336));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$5$Type', 1610);
function SelfLoopPostProcessor$lambda$6$Type() {}
defineClass(1611, 1, $intern_39, SelfLoopPostProcessor$lambda$6$Type);
_.test_0 = function test_43(arg0) {
    return !!castTo(arg0, 105).slLabels;
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$6$Type', 1611);
function SelfLoopPostProcessor$lambda$7$Type(lNode_0) {
    this.lNode_0 = lNode_0;
}
defineClass(1612, 1, $intern_19, SelfLoopPostProcessor$lambda$7$Type);
_.accept = function accept_80(arg0) {
    lambda$7_0(this.lNode_0, castTo(arg0, 105));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPostProcessor$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPostProcessor/lambda$7$Type', 1612);
function $hidePorts(slHolder) {
    var entry, hierarchyMode, lNode, lPort, nestedGraph, orderFixed, outerIter, slPort, slPort$iterator;
    lNode = slHolder.lNode;
    nestedGraph = lNode.nestedGraph;
    orderFixed = $isOrderFixed(castTo($getProperty(lNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100));
    hierarchyMode = !!nestedGraph && castTo($getProperty(nestedGraph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS));
    if (orderFixed || hierarchyMode) return;
    for(slPort$iterator = (outerIter = new AbstractMap$2(slHolder.slPorts).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter)); slPort$iterator.val$outerIter2.hasNext_0();){
        slPort = (entry = castTo(slPort$iterator.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 112));
        if (slPort.hadOnlySelfLoops) {
            lPort = slPort.lPort;
            $setNode(lPort, null);
            slPort.isHidden = true;
            slHolder.arePortsHidden = true;
        }
    }
}
function $lambda$2_0(lEdge_0) {
    $setSource_0(lEdge_0, null);
    $setTarget_0(lEdge_0, null);
}
function $process_48(graph, progressMonitor) {
    var lnode, lnode$iterator, slHolder, holder;
    progressMonitor.begin('Self-Loop pre-processing', 1);
    for(lnode$iterator = new ArrayList$1(graph.layerlessNodes); lnode$iterator.i < lnode$iterator.this$01.array.length;){
        lnode = castTo($next_6(lnode$iterator), 9);
        if (needsSelfLoopProcessing(lnode)) {
            slHolder = (holder = new SelfLoopHolder(lnode), $setProperty_0(lnode, ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER), holder), $initialize_3(holder), holder);
            $forEach_3($map($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new SelfLoopPreProcessor$lambda$0$Type), new SelfLoopPreProcessor$lambda$1$Type), new SelfLoopPreProcessor$lambda$2$Type);
            $hidePorts(slHolder);
        }
    }
    progressMonitor.done_1();
}
function SelfLoopPreProcessor() {}
defineClass(1593, 1, $intern_102, SelfLoopPreProcessor);
_.process = function process_45(graph, progressMonitor) {
    $process_48(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPreProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPreProcessor', 1593);
function SelfLoopPreProcessor$lambda$0$Type() {}
defineClass(1594, 1, {}, SelfLoopPreProcessor$lambda$0$Type);
_.apply_0 = function apply_76(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 105).slEdges, 1));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPreProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPreProcessor/lambda$0$Type', 1594);
function SelfLoopPreProcessor$lambda$1$Type() {}
defineClass(1595, 1, {}, SelfLoopPreProcessor$lambda$1$Type);
_.apply_0 = function apply_77(arg0) {
    return castTo(arg0, 336).lEdge;
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPreProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPreProcessor/lambda$1$Type', 1595);
function SelfLoopPreProcessor$lambda$2$Type() {}
defineClass(1596, 1, $intern_19, SelfLoopPreProcessor$lambda$2$Type);
_.accept = function accept_81(arg0) {
    $lambda$2_0(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopPreProcessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopPreProcessor/lambda$2$Type', 1596);
function $lambda$4(this$static, router_2, slHolder_3) {
    $determineLoopRoutes(this$static.routingDirector, slHolder_3);
    $placeLabels_1(slHolder_3);
    $assignRoutingSlots(this$static.routingSlotAssigner, slHolder_3);
    $routeSelfLoops(router_2, slHolder_3);
}
function $process_49(this$static, graph, progressMonitor) {
    var router;
    progressMonitor.begin('Self-Loop routing', 1);
    router = $routerForGraph(graph);
    throwClassCastExceptionUnlessNull($getProperty(graph, ($clinit_LabelManagementOptions(), LABEL_MANAGER)));
    $forEach_3($map($filter($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(graph.layers, 16)), new SelfLoopRouter$lambda$0$Type), new SelfLoopRouter$lambda$1$Type), new SelfLoopRouter$lambda$2$Type), new SelfLoopRouter$lambda$3$Type), new SelfLoopRouter$lambda$4$Type(this$static, router));
    progressMonitor.done_1();
}
function $routerForGraph(graph) {
    switch(castTo($getProperty(graph, ($clinit_LayeredOptions(), EDGE_ROUTING)), 220).ordinal){
        case 1:
            return new PolylineSelfLoopRouter;
        case 3:
            return new SplineSelfLoopRouter;
        default:
            return new OrthogonalSelfLoopRouter;
    }
}
function SelfLoopRouter() {
    this.routingDirector = new RoutingDirector;
    this.routingSlotAssigner = new RoutingSlotAssigner;
}
defineClass(1613, 1, $intern_102, SelfLoopRouter);
_.process = function process_46(graph, progressMonitor) {
    $process_49(this, castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopRouter', 1613);
function SelfLoopRouter$lambda$0$Type() {}
defineClass(1614, 1, {}, SelfLoopRouter$lambda$0$Type);
_.apply_0 = function apply_78(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopRouter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopRouter/lambda$0$Type', 1614);
function SelfLoopRouter$lambda$1$Type() {}
defineClass(1615, 1, $intern_39, SelfLoopRouter$lambda$1$Type);
_.test_0 = function test_44(arg0) {
    return castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopRouter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopRouter/lambda$1$Type', 1615);
function SelfLoopRouter$lambda$2$Type() {}
defineClass(1616, 1, $intern_39, SelfLoopRouter$lambda$2$Type);
_.test_0 = function test_45(arg0) {
    return $hasProperty(castTo(arg0, 9), ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopRouter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopRouter/lambda$2$Type', 1616);
function SelfLoopRouter$lambda$3$Type() {}
defineClass(1617, 1, {}, SelfLoopRouter$lambda$3$Type);
_.apply_0 = function apply_79(arg0) {
    return castTo($getProperty(castTo(arg0, 9), ($clinit_InternalProperties_1(), SELF_LOOP_HOLDER)), 333);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopRouter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopRouter/lambda$3$Type', 1617);
function SelfLoopRouter$lambda$4$Type($$outer_0, router_2) {
    this.$$outer_0 = $$outer_0;
    this.router_2 = router_2;
}
defineClass(1618, 1, $intern_19, SelfLoopRouter$lambda$4$Type);
_.accept = function accept_82(arg0) {
    $lambda$4(this.$$outer_0, this.router_2, castTo(arg0, 333));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SelfLoopRouter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SelfLoopRouter/lambda$4$Type', 1618);
function $process_50(layeredGraph, progressMonitor) {
    var addedConstraints, l, l$iterator, reduced;
    progressMonitor.begin('Semi-Interactive Crossing Minimization Processor', 1);
    addedConstraints = false;
    for(l$iterator = new ArrayList$1(layeredGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        reduced = $reduce_0($sorted_1($filter($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(l.nodes, 16)), new SemiInteractiveCrossMinProcessor$lambda$0$Type), new SemiInteractiveCrossMinProcessor$lambda$1$Type), new SemiInteractiveCrossMinProcessor$lambda$2$Type), new SemiInteractiveCrossMinProcessor$lambda$3$Type);
        addedConstraints = addedConstraints | reduced.ref != null;
    }
    addedConstraints && $setProperty_0(layeredGraph, ($clinit_InternalProperties_1(), IN_LAYER_SUCCESSOR_CONSTRAINTS_BETWEEN_NON_DUMMIES), ($clinit_Boolean(), true));
    progressMonitor.done_1();
}
function SemiInteractiveCrossMinProcessor() {}
function lambda$2_6(n1_0, n2_1) {
    var origPos1, origPos2;
    origPos1 = castTo($getProperty(n1_0, ($clinit_LayeredOptions(), POSITION)), 8);
    origPos2 = castTo($getProperty(n2_1, POSITION), 8);
    return compare_4(origPos1.y_0, origPos2.y_0);
}
function lambda$3_3(prev_0, cur_1) {
    castTo($getProperty(prev_0, ($clinit_InternalProperties_1(), IN_LAYER_SUCCESSOR_CONSTRAINTS)), 15).add_2(cur_1);
    return cur_1;
}
defineClass(1619, 1, $intern_102, SemiInteractiveCrossMinProcessor);
_.process = function process_47(layeredGraph, progressMonitor) {
    $process_50(castTo(layeredGraph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SemiInteractiveCrossMinProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SemiInteractiveCrossMinProcessor', 1619);
function SemiInteractiveCrossMinProcessor$lambda$0$Type() {}
defineClass(1620, 1, $intern_39, SemiInteractiveCrossMinProcessor$lambda$0$Type);
_.test_0 = function test_46(arg0) {
    return castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SemiInteractiveCrossMinProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SemiInteractiveCrossMinProcessor/lambda$0$Type', 1620);
function SemiInteractiveCrossMinProcessor$lambda$1$Type() {}
defineClass(1621, 1, $intern_39, SemiInteractiveCrossMinProcessor$lambda$1$Type);
_.test_0 = function test_47(arg0) {
    return $getAllProperties(castTo(arg0, 9)).containsKey(($clinit_LayeredOptions(), POSITION));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SemiInteractiveCrossMinProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SemiInteractiveCrossMinProcessor/lambda$1$Type', 1621);
function SemiInteractiveCrossMinProcessor$lambda$2$Type() {}
defineClass(1622, 1, $intern_88, SemiInteractiveCrossMinProcessor$lambda$2$Type);
_.compare_1 = function compare_47(arg0, arg1) {
    return lambda$2_6(castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_123(other) {
    return this === other;
};
_.reversed = function reversed_39() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SemiInteractiveCrossMinProcessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SemiInteractiveCrossMinProcessor/lambda$2$Type', 1622);
function SemiInteractiveCrossMinProcessor$lambda$3$Type() {}
defineClass(1623, 1, {}, SemiInteractiveCrossMinProcessor$lambda$3$Type);
_.apply_3 = function apply_80(arg0, arg1) {
    return lambda$3_3(castTo(arg0, 9), castTo(arg1, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SemiInteractiveCrossMinProcessor$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SemiInteractiveCrossMinProcessor/lambda$3$Type', 1623);
function $process_51(graph, progressMonitor) {
    var comparator, layer, layer$iterator, layerIndex, node, node$iterator, previousLayer, previousLayerIndex;
    progressMonitor.begin('Sort By Input Model ' + $getProperty(graph, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_STRATEGY_0)), 1);
    layerIndex = 0;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layer.id_0 = layerIndex;
        previousLayerIndex = layerIndex == 0 ? 0 : layerIndex - 1;
        previousLayer = castTo($get_11(graph.layers, previousLayerIndex), 25);
        comparator = new ModelOrderNodeComparator(previousLayer, castTo($getProperty(graph, CONSIDER_MODEL_ORDER_STRATEGY_0), 266), castTo($getProperty(graph, CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_0), 349), true);
        insertionSort_0(layer.nodes, comparator);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (maskUndefined($getProperty(node, PORT_CONSTRAINTS_0)) !== maskUndefined(($clinit_PortConstraints(), FIXED_ORDER)) && maskUndefined($getProperty(node, PORT_CONSTRAINTS_0)) !== maskUndefined(FIXED_POS)) {
                $clinit_Collections();
                $sort(node.ports, new ModelOrderPortComparator(previousLayer, castTo($getProperty(graph, CONSIDER_MODEL_ORDER_STRATEGY_0), 266), longEdgeTargetNodePreprocessing(node), $booleanValue(castToBoolean($getProperty(graph, CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER_0)))));
                progressMonitor.log_0('Node ' + node + ' ports: ' + node.ports);
            }
        }
        comparator = new ModelOrderNodeComparator(previousLayer, castTo($getProperty(graph, CONSIDER_MODEL_ORDER_STRATEGY_0), 266), castTo($getProperty(graph, CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_0), 349), false);
        insertionSort_0(layer.nodes, comparator);
        progressMonitor.log_0('Layer ' + layerIndex + ': ' + layer);
        ++layerIndex;
    }
    progressMonitor.done_1();
}
function SortByInputModelProcessor() {}
function getTargetNode(port) {
    var edge, node;
    node = null;
    edge = castTo($get_11(port.outgoingEdges, 0), 18);
    do {
        node = edge.target.owner;
        if ($hasProperty(node, ($clinit_InternalProperties_1(), LONG_EDGE_TARGET))) return castTo($getProperty(node, LONG_EDGE_TARGET), 11).owner;
        if (node.type_0 != ($clinit_LNode$NodeType(), NORMAL) && $hasNext_1(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)))) edge = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10))), 18);
        else if (node.type_0 != NORMAL) return null;
    }while (!!node && node.type_0 != ($clinit_LNode$NodeType(), NORMAL));
    return node;
}
function insertionSort_0(layer, comparator) {
    var i, j, temp;
    for(i = 1; i < layer.array.length; i++){
        temp = (checkCriticalElementIndex(i, layer.array.length), castTo(layer.array[i], 9));
        j = i;
        while(j > 0 && $compare_11(comparator, (checkCriticalElementIndex(j - 1, layer.array.length), castTo(layer.array[j - 1], 9)), temp) > 0){
            $set_1(layer, j, (checkCriticalElementIndex(j - 1, layer.array.length), castTo(layer.array[j - 1], 9)));
            --j;
        }
        checkCriticalElementIndex(j, layer.array.length);
        layer.array[j] = temp;
    }
    comparator.biggerThan = new HashMap;
    comparator.smallerThan = new HashMap;
}
function lambda$1_11(targetNodeModelOrder_0, p_1) {
    var edge, previousOrder, targetNode;
    targetNode = getTargetNode(p_1);
    $setProperty_0(p_1, ($clinit_InternalProperties_1(), LONG_EDGE_TARGET_NODE), targetNode);
    if (targetNode) {
        previousOrder = $intern_0;
        !!$getEntry_0(targetNodeModelOrder_0.hashCodeMap, targetNode) && (previousOrder = castTo(getEntryValueOrNull($getEntry_0(targetNodeModelOrder_0.hashCodeMap, targetNode)), 17).value_0);
        edge = castTo($get_11(p_1.outgoingEdges, 0), 18);
        $booleanValue(castToBoolean($getProperty(edge, REVERSED))) || $put_6(targetNodeModelOrder_0, targetNode, valueOf_3($wnd.Math.min(castTo($getProperty(edge, MODEL_ORDER_1), 17).value_0, previousOrder)));
    }
}
function longEdgeTargetNodePreprocessing(node) {
    var targetNodeModelOrder;
    targetNodeModelOrder = new HashMap;
    if ($hasProperty(node, ($clinit_InternalProperties_1(), TARGET_NODE_MODEL_ORDER))) return castTo($getProperty(node, TARGET_NODE_MODEL_ORDER), 91);
    $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(node.ports, 16)), new SortByInputModelProcessor$lambda$0$Type), new SortByInputModelProcessor$lambda$1$Type(targetNodeModelOrder));
    $setProperty_0(node, TARGET_NODE_MODEL_ORDER, targetNodeModelOrder);
    return targetNodeModelOrder;
}
defineClass(1625, 1, $intern_102, SortByInputModelProcessor);
_.process = function process_48(graph, progressMonitor) {
    $process_51(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_SortByInputModelProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SortByInputModelProcessor', 1625);
function SortByInputModelProcessor$lambda$0$Type() {}
defineClass(1626, 1, $intern_39, SortByInputModelProcessor$lambda$0$Type);
_.test_0 = function test_48(arg0) {
    return castTo(arg0, 11).outgoingEdges.array.length != 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_SortByInputModelProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SortByInputModelProcessor/lambda$0$Type', 1626);
function SortByInputModelProcessor$lambda$1$Type(targetNodeModelOrder_0) {
    this.targetNodeModelOrder_0 = targetNodeModelOrder_0;
}
defineClass(1627, 1, $intern_19, SortByInputModelProcessor$lambda$1$Type);
_.accept = function accept_83(arg0) {
    lambda$1_11(this.targetNodeModelOrder_0, castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_intermediate_SortByInputModelProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate', 'SortByInputModelProcessor/lambda$1$Type', 1627);
function $alterGroupedHitboxOrthogonal(g, spacing, fac) {
    var delta, master, n, n$iterator, vs;
    master = g.master;
    !master && (master = castTo(g.cNodes.map_0.keySet_0().iterator_0().next_1(), 60));
    $alterHitbox(master, spacing, fac);
    if (g.cNodes.map_0.size_1() == 1) return;
    delta = spacing * fac;
    for(n$iterator = g.cNodes.map_0.keySet_0().iterator_0(); n$iterator.hasNext_0();){
        n = castTo(n$iterator.next_1(), 60);
        if (n != master) {
            vs = getVerticalSegmentOrNull(n);
            if (vs.ignoreSpacing.up) {
                n.hitbox.y_0 += delta + $intern_93;
                n.hitbox.height -= delta + $intern_93;
            } else vs.ignoreSpacing.down && (n.hitbox.height -= delta + $intern_93);
        }
    }
}
function $alterHitbox(n, spacing, fac) {
    var delta, vs;
    delta = spacing * fac;
    if (instanceOf(n.origin_0, 152)) {
        vs = getVerticalSegmentOrNull(n);
        if (vs.ignoreSpacing.up) vs.ignoreSpacing.down || (n.hitbox.height += delta + $intern_93);
        else {
            n.hitbox.y_0 -= delta + $intern_93;
            n.hitbox.height += delta + $intern_93;
        }
    } else if (instanceOf(n.origin_0, 9)) {
        n.hitbox.y_0 -= delta;
        n.hitbox.height += 2 * delta;
    }
}
function $lambda$1_1(this$static, n_0) {
    var lNode, spacing, vs;
    if (instanceOf(n_0.origin_0, 9) && castTo(n_0.origin_0, 9).type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) return $intern_60;
    vs = getVerticalSegmentOrNull(n_0);
    if (vs) return $wnd.Math.max(0, this$static.verticalEdgeEdgeSpacing / 2 - 0.5);
    lNode = getLNodeOrNull(n_0);
    if (lNode) {
        spacing = $doubleValue(castToDouble(getIndividualOrDefault(lNode, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0))));
        return $wnd.Math.max(0, spacing / 2 - 0.5);
    }
    return $intern_60;
}
function $lambda$14(schedule_1, n_1) {
    var finalSpacing, lNode, spacing;
    lNode = getLNodeOrNull(n_1);
    spacing = $doubleValue(castToDouble(getIndividualOrDefault(lNode, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE))));
    finalSpacing = $wnd.Math.max(0, spacing / 2 - 0.5);
    $alterHitbox(n_1, finalSpacing, 1);
    $add_3(schedule_1, new EdgeAwareScanlineConstraintCalculation$lambda$15$Type(n_1, finalSpacing));
}
function $lambda$18(this$static, n_0) {
    var lNode, spacing, vs;
    if (instanceOf(n_0.origin_0, 9) && castTo(n_0.origin_0, 9).type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) return $intern_60;
    vs = getVerticalSegmentOrNull(n_0);
    if (vs) return $wnd.Math.max(0, this$static.verticalEdgeEdgeSpacing / 2 - 0.5);
    lNode = getLNodeOrNull(n_0);
    if (lNode) {
        spacing = $doubleValue(castToDouble(getIndividualOrDefault(lNode, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0))));
        return $wnd.Math.max(0, spacing / 2 - 0.5);
    }
    return $intern_60;
}
function $lambda$20(minSpacing_1, schedule_3, g_2) {
    $alterGroupedHitboxOrthogonal(g_2, minSpacing_1, 1);
    $add_3(schedule_3, new EdgeAwareScanlineConstraintCalculation$lambda$21$Type(g_2, minSpacing_1));
}
function $lambda$4_0(minSpacing_1, schedule_3, n_2) {
    $alterHitbox(n_2, minSpacing_1, 1);
    $add_3(schedule_3, new EdgeAwareScanlineConstraintCalculation$lambda$5$Type(n_2, minSpacing_1));
}
function $lambda$9(this$static, schedule_1, n_1) {
    var spacing;
    spacing = $wnd.Math.max(0, this$static.verticalEdgeEdgeSpacing / 2 - 0.5);
    $alterHitbox(n_1, spacing, 1);
    $add_3(schedule_1, new EdgeAwareScanlineConstraintCalculation$lambda$10$Type(n_1, spacing));
}
function EdgeAwareScanlineConstraintCalculation(graph) {
    ScanlineConstraintCalculator.call(this);
    this.verticalEdgeEdgeSpacing = $doubleValue(castToDouble($getProperty(graph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE))));
    this.edgeRouting = castTo($getProperty(graph, EDGE_ROUTING), 220);
}
defineClass(1705, 797, {}, EdgeAwareScanlineConstraintCalculation);
_.calculateConstraints = function calculateConstraints_1(theCompactor) {
    var schedule, minSpacing, schedule_0, minSpacing_0;
    this.compactor = theCompactor;
    switch(this.edgeRouting.ordinal){
        case 2:
            schedule = new ArrayList;
            $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.compactor.cGraph.cNodes, 16)), new EdgeAwareScanlineConstraintCalculation$lambda$8$Type), new EdgeAwareScanlineConstraintCalculation$lambda$9$Type(this, schedule));
            $sweep(this, new EdgeAwareScanlineConstraintCalculation$lambda$11$Type);
            $forEach_1(schedule, new EdgeAwareScanlineConstraintCalculation$lambda$12$Type);
            schedule.array.length = 0;
            $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.compactor.cGraph.cNodes, 16)), new EdgeAwareScanlineConstraintCalculation$lambda$13$Type), new EdgeAwareScanlineConstraintCalculation$lambda$14$Type(schedule));
            $sweep(this, new EdgeAwareScanlineConstraintCalculation$lambda$16$Type);
            $forEach_1(schedule, new EdgeAwareScanlineConstraintCalculation$lambda$17$Type);
            schedule.array.length = 0;
            minSpacing = $orElseGet($min($mapToDouble(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.compactor.cGraph.cNodes, 16)), new EdgeAwareScanlineConstraintCalculation$lambda$18$Type(this))), new EdgeAwareScanlineConstraintCalculation$lambda$19$Type);
            $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.compactor.cGraph.cGroups, 16)), new EdgeAwareScanlineConstraintCalculation$lambda$20$Type(minSpacing, schedule));
            $sweep(this, new EdgeAwareScanlineConstraintCalculation$lambda$22$Type);
            $forEach_1(schedule, new EdgeAwareScanlineConstraintCalculation$lambda$23$Type);
            schedule.array.length = 0;
            break;
        case 3:
            schedule_0 = new ArrayList;
            $sweep(this, new EdgeAwareScanlineConstraintCalculation$lambda$0$Type);
            minSpacing_0 = $orElseGet($min($mapToDouble(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.compactor.cGraph.cNodes, 16)), new EdgeAwareScanlineConstraintCalculation$lambda$1$Type(this))), new EdgeAwareScanlineConstraintCalculation$lambda$2$Type);
            $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this.compactor.cGraph.cNodes, 16)), new EdgeAwareScanlineConstraintCalculation$lambda$3$Type), new EdgeAwareScanlineConstraintCalculation$lambda$4$Type(minSpacing_0, schedule_0));
            $sweep(this, new EdgeAwareScanlineConstraintCalculation$lambda$6$Type);
            $forEach_1(schedule_0, new EdgeAwareScanlineConstraintCalculation$lambda$7$Type);
            schedule_0.array.length = 0;
            break;
        default:
            throw toJs(new UnsupportedConfigurationException);
    }
};
_.verticalEdgeEdgeSpacing = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation', 1705);
function EdgeAwareScanlineConstraintCalculation$lambda$0$Type() {}
defineClass(1706, 1, $intern_89, EdgeAwareScanlineConstraintCalculation$lambda$0$Type);
_.apply_1 = function apply_81(arg0) {
    return instanceOf(castTo(arg0, 60).origin_0, 152);
};
_.equals_0 = function equals_124(other) {
    return this === other;
};
_.test_0 = function test_49(input_0) {
    return instanceOf(castTo(input_0, 60).origin_0, 152);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$0$Type', 1706);
function EdgeAwareScanlineConstraintCalculation$lambda$1$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1707, 1, {}, EdgeAwareScanlineConstraintCalculation$lambda$1$Type);
_.applyAsDouble = function applyAsDouble_1(arg0) {
    return $lambda$1_1(this.$$outer_0, castTo(arg0, 60));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$1$Type', 1707);
function EdgeAwareScanlineConstraintCalculation$lambda$10$Type(n_1, spacing_2) {
    this.n_1 = n_1;
    this.spacing_2 = spacing_2;
}
defineClass(1715, 1, $intern_40, EdgeAwareScanlineConstraintCalculation$lambda$10$Type);
_.run = function run_1() {
    $alterHitbox(this.n_1, this.spacing_2, -1);
};
_.spacing_2 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$10$Type', 1715);
function EdgeAwareScanlineConstraintCalculation$lambda$11$Type() {}
defineClass(1717, 1, $intern_89, EdgeAwareScanlineConstraintCalculation$lambda$11$Type);
_.apply_1 = function apply_82(arg0) {
    return instanceOf(castTo(arg0, 60).origin_0, 152);
};
_.equals_0 = function equals_125(other) {
    return this === other;
};
_.test_0 = function test_50(input_0) {
    return instanceOf(castTo(input_0, 60).origin_0, 152);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$11$Type', 1717);
function EdgeAwareScanlineConstraintCalculation$lambda$12$Type() {}
defineClass(1718, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$12$Type);
_.accept = function accept_84(arg0) {
    castTo(arg0, 372).run();
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$12$Type', 1718);
function EdgeAwareScanlineConstraintCalculation$lambda$13$Type() {}
defineClass(1719, 1, $intern_39, EdgeAwareScanlineConstraintCalculation$lambda$13$Type);
_.test_0 = function test_51(arg0) {
    return instanceOf(castTo(arg0, 60).origin_0, 9);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$13$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$13$Type', 1719);
function EdgeAwareScanlineConstraintCalculation$lambda$14$Type(schedule_1) {
    this.schedule_1 = schedule_1;
}
defineClass(1721, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$14$Type);
_.accept = function accept_85(arg0) {
    $lambda$14(this.schedule_1, castTo(arg0, 60));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$14$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$14$Type', 1721);
function EdgeAwareScanlineConstraintCalculation$lambda$15$Type(n_1, finalSpacing_2) {
    this.n_1 = n_1;
    this.finalSpacing_2 = finalSpacing_2;
}
defineClass(1720, 1, $intern_40, EdgeAwareScanlineConstraintCalculation$lambda$15$Type);
_.run = function run_2() {
    $alterHitbox(this.n_1, this.finalSpacing_2, -1);
};
_.finalSpacing_2 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$15$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$15$Type', 1720);
function EdgeAwareScanlineConstraintCalculation$lambda$16$Type() {}
defineClass(1722, 1, $intern_89, EdgeAwareScanlineConstraintCalculation$lambda$16$Type);
_.apply_1 = function apply_83(arg0) {
    return instanceOf(castTo(arg0, 60).origin_0, 9);
};
_.equals_0 = function equals_126(other) {
    return this === other;
};
_.test_0 = function test_52(input_0) {
    return instanceOf(castTo(input_0, 60).origin_0, 9);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$16$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$16$Type', 1722);
function EdgeAwareScanlineConstraintCalculation$lambda$17$Type() {}
defineClass(1723, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$17$Type);
_.accept = function accept_86(arg0) {
    castTo(arg0, 372).run();
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$17$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$17$Type', 1723);
function EdgeAwareScanlineConstraintCalculation$lambda$18$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1724, 1, {}, EdgeAwareScanlineConstraintCalculation$lambda$18$Type);
_.applyAsDouble = function applyAsDouble_2(arg0) {
    return $lambda$18(this.$$outer_0, castTo(arg0, 60));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$18$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$18$Type', 1724);
function EdgeAwareScanlineConstraintCalculation$lambda$19$Type() {}
defineClass(1725, 1, {}, EdgeAwareScanlineConstraintCalculation$lambda$19$Type);
_.getAsDouble = function getAsDouble() {
    return 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$19$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$19$Type', 1725);
function EdgeAwareScanlineConstraintCalculation$lambda$2$Type() {}
defineClass(1708, 1, {}, EdgeAwareScanlineConstraintCalculation$lambda$2$Type);
_.getAsDouble = function getAsDouble_0() {
    return 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$2$Type', 1708);
function EdgeAwareScanlineConstraintCalculation$lambda$20$Type(minSpacing_1, schedule_3) {
    this.minSpacing_1 = minSpacing_1;
    this.schedule_3 = schedule_3;
}
defineClass(1727, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$20$Type);
_.accept = function accept_87(arg0) {
    $lambda$20(this.minSpacing_1, this.schedule_3, castTo(arg0, 317));
};
_.minSpacing_1 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$20$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$20$Type', 1727);
function EdgeAwareScanlineConstraintCalculation$lambda$21$Type(g_1, minSpacing_2) {
    this.g_1 = g_1;
    this.minSpacing_2 = minSpacing_2;
}
defineClass(1726, 1, $intern_40, EdgeAwareScanlineConstraintCalculation$lambda$21$Type);
_.run = function run_3() {
    $alterGroupedHitboxOrthogonal(this.g_1, this.minSpacing_2, -1);
};
_.minSpacing_2 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$21$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$21$Type', 1726);
function EdgeAwareScanlineConstraintCalculation$lambda$22$Type() {}
defineClass(1728, 1, $intern_89, EdgeAwareScanlineConstraintCalculation$lambda$22$Type);
_.apply_1 = function apply_84(arg0) {
    return castTo(arg0, 60), true;
};
_.equals_0 = function equals_127(other) {
    return this === other;
};
_.test_0 = function test_53(input_0) {
    return castTo(input_0, 60), true;
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$22$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$22$Type', 1728);
function EdgeAwareScanlineConstraintCalculation$lambda$23$Type() {}
defineClass(1729, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$23$Type);
_.accept = function accept_88(arg0) {
    castTo(arg0, 372).run();
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$23$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$23$Type', 1729);
function EdgeAwareScanlineConstraintCalculation$lambda$3$Type() {}
defineClass(1709, 1, $intern_39, EdgeAwareScanlineConstraintCalculation$lambda$3$Type);
_.test_0 = function test_54(arg0) {
    return instanceOf(castTo(arg0, 60).origin_0, 9);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$3$Type', 1709);
function EdgeAwareScanlineConstraintCalculation$lambda$4$Type(minSpacing_1, schedule_3) {
    this.minSpacing_1 = minSpacing_1;
    this.schedule_3 = schedule_3;
}
defineClass(1711, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$4$Type);
_.accept = function accept_89(arg0) {
    $lambda$4_0(this.minSpacing_1, this.schedule_3, castTo(arg0, 60));
};
_.minSpacing_1 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$4$Type', 1711);
function EdgeAwareScanlineConstraintCalculation$lambda$5$Type(n_1, minSpacing_2) {
    this.n_1 = n_1;
    this.minSpacing_2 = minSpacing_2;
}
defineClass(1710, 1, $intern_40, EdgeAwareScanlineConstraintCalculation$lambda$5$Type);
_.run = function run_4() {
    $alterHitbox(this.n_1, this.minSpacing_2, -1);
};
_.minSpacing_2 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$5$Type', 1710);
function EdgeAwareScanlineConstraintCalculation$lambda$6$Type() {}
defineClass(1712, 1, $intern_89, EdgeAwareScanlineConstraintCalculation$lambda$6$Type);
_.apply_1 = function apply_85(arg0) {
    return castTo(arg0, 60), true;
};
_.equals_0 = function equals_128(other) {
    return this === other;
};
_.test_0 = function test_55(input_0) {
    return castTo(input_0, 60), true;
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$6$Type', 1712);
function EdgeAwareScanlineConstraintCalculation$lambda$7$Type() {}
defineClass(1713, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$7$Type);
_.accept = function accept_90(arg0) {
    castTo(arg0, 372).run();
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$7$Type', 1713);
function EdgeAwareScanlineConstraintCalculation$lambda$8$Type() {}
defineClass(1714, 1, $intern_39, EdgeAwareScanlineConstraintCalculation$lambda$8$Type);
_.test_0 = function test_56(arg0) {
    return instanceOf(castTo(arg0, 60).origin_0, 152);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$8$Type', 1714);
function EdgeAwareScanlineConstraintCalculation$lambda$9$Type($$outer_0, schedule_1) {
    this.$$outer_0 = $$outer_0;
    this.schedule_1 = schedule_1;
}
defineClass(1716, 1, $intern_19, EdgeAwareScanlineConstraintCalculation$lambda$9$Type);
_.accept = function accept_91(arg0) {
    $lambda$9(this.$$outer_0, this.schedule_1, castTo(arg0, 60));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_EdgeAwareScanlineConstraintCalculation$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'EdgeAwareScanlineConstraintCalculation/lambda$9$Type', 1716);
function $clinit_HorizontalGraphCompactor() {
    $clinit_HorizontalGraphCompactor = emptyMethod;
    NETWORK_SIMPLEX_COMPACTION = new NetworkSimplexCompaction;
}
function $process_52(this$static, layeredGraph, progressMonitor) {
    var odc, strategy, transformer;
    strategy = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), COMPACTION_POST_COMPACTION_STRATEGY_0)), 280);
    if (strategy == ($clinit_GraphCompactionStrategy(), NONE_5)) return;
    progressMonitor.begin('Horizontal Compaction', 1);
    this$static.lGraph = layeredGraph;
    transformer = new LGraphToCGraphTransformer;
    odc = new OneDimensionalCompactor((transformer.layeredGraph = layeredGraph, transformer.edgeRouting = castTo($getProperty(transformer.layeredGraph, EDGE_ROUTING), 220), $init(transformer), $transformNodes_0(transformer), $transformEdges_0(transformer), transformer.cGraph));
    $setSpacingsHandler(odc, this$static.specialSpacingsHandler);
    switch(castTo($getProperty(layeredGraph, COMPACTION_POST_COMPACTION_CONSTRAINTS_0), 419).ordinal){
        case 1:
            $setConstraintAlgorithm(odc, new EdgeAwareScanlineConstraintCalculation(this$static.lGraph));
            break;
        default:
            $setConstraintAlgorithm(odc, ($clinit_OneDimensionalCompactor(), QUADRATIC_CONSTRAINTS));
    }
    switch(strategy.ordinal){
        case 1:
            $compact(odc);
            break;
        case 2:
            $compact($changeDirection(odc, ($clinit_Direction(), RIGHT_6)));
            break;
        case 3:
            $compact($setLockFunction($changeDirection($compact(odc), ($clinit_Direction(), RIGHT_6)), new HorizontalGraphCompactor$lambda$0$Type));
            break;
        case 4:
            $compact($setLockFunction($changeDirection($compact(odc), ($clinit_Direction(), RIGHT_6)), new HorizontalGraphCompactor$lambda$1$Type(transformer)));
            break;
        case 5:
            $compact($setCompactionAlgorithm(odc, NETWORK_SIMPLEX_COMPACTION));
    }
    $changeDirection(odc, ($clinit_Direction(), LEFT_6));
    odc.finished = true;
    $applyLayout_2(transformer);
    progressMonitor.done_1();
}
function HorizontalGraphCompactor() {
    $clinit_HorizontalGraphCompactor();
    this.specialSpacingsHandler = new HorizontalGraphCompactor$1(this);
}
function getLNodeOrNull(cNode) {
    $clinit_HorizontalGraphCompactor();
    if (instanceOf(cNode.origin_0, 9)) return castTo(cNode.origin_0, 9);
    return null;
}
function getVerticalSegmentOrNull(cNode) {
    $clinit_HorizontalGraphCompactor();
    if (instanceOf(cNode.origin_0, 152)) return castTo(cNode.origin_0, 152);
    return null;
}
function isVerticalSegmentsOfSameEdge(cNode1, cNode2) {
    $clinit_HorizontalGraphCompactor();
    var v1, v2;
    v1 = getVerticalSegmentOrNull(cNode1);
    v2 = getVerticalSegmentOrNull(cNode2);
    return !!v1 && !!v2 && !disjoint(v1.representedLEdges, v2.representedLEdges);
}
function lambda$1_12(transformer_0, node_1, dir_2) {
    $clinit_HorizontalGraphCompactor();
    return $get_18(castTo($get_10(transformer_0.lockMap, node_1), 514), dir_2);
}
defineClass(1526, 1, $intern_102, HorizontalGraphCompactor);
_.process = function process_49(layeredGraph, progressMonitor) {
    $process_52(this, castTo(layeredGraph, 36), progressMonitor);
};
var NETWORK_SIMPLEX_COMPACTION;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_HorizontalGraphCompactor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'HorizontalGraphCompactor', 1526);
function HorizontalGraphCompactor$1(this$0) {
    this.this$01 = this$0;
}
defineClass(1527, 1, {}, HorizontalGraphCompactor$1);
_.getHorizontalSpacing = function getHorizontalSpacing_2(cNode1, cNode2) {
    var node1, node2, spacings;
    if (isVerticalSegmentsOfSameEdge(cNode1, cNode2)) return 0;
    node1 = getLNodeOrNull(cNode1);
    node2 = getLNodeOrNull(cNode2);
    if (!!node1 && node1.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) || !!node2 && node2.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) return 0;
    spacings = castTo($getProperty(this.this$01.lGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    return $getHorizontalSpacing(spacings, node1 ? node1.type_0 : ($clinit_LNode$NodeType(), LONG_EDGE), node2 ? node2.type_0 : ($clinit_LNode$NodeType(), LONG_EDGE));
};
_.getVerticalSpacing = function getVerticalSpacing_2(cNode1, cNode2) {
    var node1, node2, spacings;
    if (isVerticalSegmentsOfSameEdge(cNode1, cNode2)) return 1;
    node1 = getLNodeOrNull(cNode1);
    node2 = getLNodeOrNull(cNode2);
    spacings = castTo($getProperty(this.this$01.lGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    return $getVerticalSpacing(spacings, node1 ? node1.type_0 : ($clinit_LNode$NodeType(), LONG_EDGE), node2 ? node2.type_0 : ($clinit_LNode$NodeType(), LONG_EDGE));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_HorizontalGraphCompactor$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'HorizontalGraphCompactor/1', 1527);
function HorizontalGraphCompactor$lambda$0$Type() {}
defineClass(1528, 1, {}, HorizontalGraphCompactor$lambda$0$Type);
_.isLocked = function isLocked(arg0, arg1) {
    return $clinit_HorizontalGraphCompactor(), arg0.cGroup.outDegreeReal == 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_HorizontalGraphCompactor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'HorizontalGraphCompactor/lambda$0$Type', 1528);
function HorizontalGraphCompactor$lambda$1$Type(transformer_0) {
    this.transformer_0 = transformer_0;
}
defineClass(1529, 1, {}, HorizontalGraphCompactor$lambda$1$Type);
_.isLocked = function isLocked_0(arg0, arg1) {
    return lambda$1_12(this.transformer_0, arg0, arg1);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_HorizontalGraphCompactor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'HorizontalGraphCompactor/lambda$1$Type', 1529);
function $clinit_LGraphToCGraphTransformer() {
    $clinit_LGraphToCGraphTransformer = emptyMethod;
    NODE_TO_STRING_DELEGATE = new LGraphToCGraphTransformer$lambda$0$Type;
    VS_TO_STRING_DELEGATE = new LGraphToCGraphTransformer$lambda$1$Type;
}
function $adjustControlPointBetweenSegments(this$static, left, right, leftIdx, rightIdx, spline) {
    var adjust, chunk, chunks, endX, idx1, idx2, k, n, newPos, startX, strip, width_0;
    idx1 = leftIdx;
    if (left.initialSegment && left.isStraight) {
        n = castTo($get_10(this$static.nodesMap, left.sourceNode), 60);
        startX = n.hitbox.x_0 + n.hitbox.width_0;
        --idx1;
    } else startX = left.boundingBox.x_0 + left.boundingBox.width_0;
    idx2 = rightIdx;
    if (right.lastSegment && right.isStraight) {
        n = castTo($get_10(this$static.nodesMap, right.targetNode), 60);
        endX = n.hitbox.x_0;
        ++idx2;
    } else endX = right.boundingBox.x_0;
    strip = endX - startX;
    chunks = $wnd.Math.max(2, idx2 - idx1);
    chunk = strip / chunks;
    newPos = startX + chunk;
    for(k = idx1; k < idx2; ++k){
        adjust = castTo(spline.get_0(k), 132);
        width_0 = adjust.boundingBox.width_0;
        adjust.boundingBox.x_0 = newPos - width_0 / 2;
        newPos += chunk;
    }
}
function $adjustSplineControlPoints(this$static, spline) {
    var i, j, lastSeg, needle, nextSeg;
    if (spline.isEmpty()) return;
    lastSeg = castTo(spline.get_0(0), 132);
    if (spline.size_1() == 1) {
        $adjustControlPointBetweenSegments(this$static, lastSeg, lastSeg, 1, 0, spline);
        return;
    }
    i = 1;
    while(i < spline.size_1())if (lastSeg.initialSegment || !lastSeg.isStraight) {
        needle = $firstNonStraightSegment(spline, i);
        if (needle) {
            j = castTo(needle.first, 17).value_0;
            nextSeg = castTo(needle.second, 132);
            $adjustControlPointBetweenSegments(this$static, lastSeg, nextSeg, i, j, spline);
            i = j + 1;
            lastSeg = nextSeg;
        }
    }
}
function $applyCommentPositions(this$static) {
    var comment, e, e$iterator, offset, other;
    for(e$iterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(this$static.commentOffsets).this$01); e$iterator.hasNext;){
        e = $next_3(e$iterator);
        comment = castTo(e.getKey(), 9);
        other = castTo(castTo(e.getValue(), 47).first, 9);
        offset = castTo(castTo(e.getValue(), 47).second, 8);
        $add_19($reset_5(comment.pos), $add_19($clone_1(other.pos), offset));
    }
}
function $applyExternalPortPositions(this$static, topLeft, bottomRight) {
    var cNode, cNode$iterator, lNode;
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        lNode = getLNodeOrNull(cNode);
        if (lNode) {
            if (lNode.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT)) switch(castTo($getProperty(lNode, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64).ordinal){
                case 4:
                    lNode.pos.x_0 = topLeft.x_0;
                    break;
                case 2:
                    lNode.pos.x_0 = bottomRight.x_0 - (lNode.size_0.x_0 + lNode.margin.right);
                    break;
                case 1:
                    lNode.pos.y_0 = topLeft.y_0;
                    break;
                case 3:
                    lNode.pos.y_0 = bottomRight.y_0 - (lNode.size_0.y_0 + lNode.margin.bottom);
            }
        }
    }
}
function $applyLayout_2(this$static) {
    var bottomRight, cNode, cNode$iterator, topLeft;
    $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.cGraph.cNodes, 16)), new LGraphToCGraphTransformer$lambda$10$Type), new LGraphToCGraphTransformer$lambda$11$Type);
    $applyCommentPositions(this$static);
    $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.cGraph.cNodes, 16)), new LGraphToCGraphTransformer$lambda$12$Type), new LGraphToCGraphTransformer$lambda$13$Type);
    if (this$static.edgeRouting == ($clinit_EdgeRouting(), SPLINES)) {
        $forEach_3($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(new AbstractMap$1(this$static.nodesMap), 1)), new LGraphToCGraphTransformer$lambda$17$Type), new LGraphToCGraphTransformer$lambda$18$Type), new LGraphToCGraphTransformer$lambda$19$Type(this$static));
        $forEach_3($filter($map($flatMap($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.layeredGraph.layers, 16)), new LGraphToCGraphTransformer$lambda$20$Type), new LGraphToCGraphTransformer$lambda$21$Type), new LGraphToCGraphTransformer$lambda$22$Type), new LGraphToCGraphTransformer$lambda$23$Type), new LGraphToCGraphTransformer$lambda$24$Type(this$static));
    }
    $forEach_3($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(new AbstractMap$1(this$static.nodesMap), 1)), new LGraphToCGraphTransformer$lambda$25$Type), new LGraphToCGraphTransformer$lambda$26$Type), new LGraphToCGraphTransformer$lambda$27$Type(this$static));
    topLeft = new KVector_1($intern_60, $intern_60);
    bottomRight = new KVector_1($intern_61, $intern_61);
    for(cNode$iterator = new ArrayList$1(this$static.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        topLeft.x_0 = $wnd.Math.min(topLeft.x_0, cNode.hitbox.x_0);
        topLeft.y_0 = $wnd.Math.min(topLeft.y_0, cNode.hitbox.y_0);
        bottomRight.x_0 = $wnd.Math.max(bottomRight.x_0, cNode.hitbox.x_0 + cNode.hitbox.width_0);
        bottomRight.y_0 = $wnd.Math.max(bottomRight.y_0, cNode.hitbox.y_0 + cNode.hitbox.height);
    }
    $add_19($reset_5(this$static.layeredGraph.offset), $negate_0(new KVector_1(topLeft.x_0, topLeft.y_0)));
    $add_19($reset_5(this$static.layeredGraph.size_0), $sub_0(new KVector_1(bottomRight.x_0, bottomRight.y_0), topLeft));
    $applyExternalPortPositions(this$static, topLeft, bottomRight);
    $reset(this$static.nodesMap);
    $reset(this$static.commentOffsets);
    $reset(this$static.verticalSegmentsMap);
    $reset(this$static.lockMap);
    this$static.cGraph.cGroups.array.length = 0;
    this$static.cGraph.cNodes.array.length = 0;
    this$static.cGraph = null;
    this$static.layeredGraph = null;
}
function $collectVerticalSegmentsOrthogonal(this$static) {
    var bend1, bend2, bends, cNode, cTargetNode, edge, edge$iterator, edge$iterator0, first, lastSegment, layer, layer$iterator, node, node$iterator, verticalSegments, vs;
    verticalSegments = new ArrayList;
    for(layer$iterator = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            cNode = castTo($get_10(this$static.nodesMap, node), 60);
            for(edge$iterator0 = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator0);){
                edge = castTo($next_0(edge$iterator0), 18);
                bends = $listIterator_2(edge.bendPoints, 0);
                first = true;
                lastSegment = null;
                if (bends.currentNode != bends.this$01.tail) {
                    bend1 = castTo($next_9(bends), 8);
                    bend2 = null;
                    if (edge.source.side == ($clinit_PortSide(), NORTH_1)) {
                        vs = new VerticalSegment(bend1, new KVector_1(bend1.x_0, cNode.hitbox.y_0), cNode, edge);
                        vs.ignoreSpacing.down = true;
                        vs.aPort = edge.source;
                        push_1(verticalSegments.array, vs);
                    }
                    if (edge.source.side == SOUTH_0) {
                        vs = new VerticalSegment(bend1, new KVector_1(bend1.x_0, cNode.hitbox.y_0 + cNode.hitbox.height), cNode, edge);
                        vs.ignoreSpacing.up = true;
                        vs.aPort = edge.source;
                        push_1(verticalSegments.array, vs);
                    }
                    while(bends.currentNode != bends.this$01.tail){
                        bend2 = castTo($next_9(bends), 8);
                        if (!eq_0(bend1.y_0, bend2.y_0)) {
                            lastSegment = new VerticalSegment(bend1, bend2, null, edge);
                            push_1(verticalSegments.array, lastSegment);
                            if (first) {
                                first = false;
                                if (bend2.y_0 < cNode.hitbox.y_0) lastSegment.ignoreSpacing.down = true;
                                else if (bend2.y_0 > cNode.hitbox.y_0 + cNode.hitbox.height) lastSegment.ignoreSpacing.up = true;
                                else {
                                    lastSegment.ignoreSpacing.up = true;
                                    lastSegment.ignoreSpacing.down = true;
                                }
                            }
                        }
                        bends.currentNode != bends.this$01.tail && (bend1 = bend2);
                    }
                    if (lastSegment) {
                        cTargetNode = castTo($get_10(this$static.nodesMap, edge.target.owner), 60);
                        if (bend1.y_0 < cTargetNode.hitbox.y_0) lastSegment.ignoreSpacing.down = true;
                        else if (bend1.y_0 > cTargetNode.hitbox.y_0 + cTargetNode.hitbox.height) lastSegment.ignoreSpacing.up = true;
                        else {
                            lastSegment.ignoreSpacing.up = true;
                            lastSegment.ignoreSpacing.down = true;
                        }
                    }
                }
            }
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                if (edge.bendPoints.size_0 != 0) {
                    bend1 = castTo($getLast(edge.bendPoints), 8);
                    if (edge.target.side == ($clinit_PortSide(), NORTH_1)) {
                        vs = new VerticalSegment(bend1, new KVector_1(bend1.x_0, cNode.hitbox.y_0), cNode, edge);
                        vs.ignoreSpacing.down = true;
                        vs.aPort = edge.target;
                        push_1(verticalSegments.array, vs);
                    }
                    if (edge.target.side == SOUTH_0) {
                        vs = new VerticalSegment(bend1, new KVector_1(bend1.x_0, cNode.hitbox.y_0 + cNode.hitbox.height), cNode, edge);
                        vs.ignoreSpacing.up = true;
                        vs.aPort = edge.target;
                        push_1(verticalSegments.array, vs);
                    }
                }
            }
        }
    }
    return verticalSegments;
}
function $firstNonStraightSegment(spline, index_0) {
    var i, seg;
    if (index_0 < 0 || index_0 >= spline.size_1()) return null;
    for(i = index_0; i < spline.size_1(); ++i){
        seg = castTo(spline.get_0(i), 132);
        if (i == spline.size_1() - 1 || !seg.isStraight) return new Pair(valueOf_3(i), seg);
    }
    return null;
}
function $init(this$static) {
    var hasEdges, index_0, l, l$iterator, n, n$iterator, supportedDirections;
    hasEdges = false;
    index_0 = 0;
    for(l$iterator = new ArrayList$1(this$static.layeredGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        l.id_0 = index_0++;
        for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            !hasEdges && !isEmpty_13($getConnectedEdges_0(n)) && (hasEdges = true);
        }
    }
    supportedDirections = of_2(($clinit_Direction(), UNDEFINED_2), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Direction_2_classLit, 1), $intern_36, 86, 0, [
        LEFT_6,
        RIGHT_6
    ]));
    if (!hasEdges) {
        $add_5(supportedDirections, UP_1);
        $add_5(supportedDirections, DOWN_1);
    }
    this$static.cGraph = new CGraph(supportedDirections);
    $reset(this$static.nodesMap);
    $reset(this$static.commentOffsets);
    $reset(this$static.lockMap);
    $reset(this$static.verticalSegmentsMap);
}
function $lambda$19(this$static, sl_0) {
    var cNode, deltaX, lNode;
    lNode = sl_0.source.owner;
    cNode = castTo($get_10(this$static.nodesMap, lNode), 60);
    deltaX = cNode.hitbox.x_0 - cNode.hitboxPreCompaction.x_0;
    $offset_1(sl_0.bendPoints, deltaX, 0);
}
function $lambda$2_1(this$static, vs_0) {
    var vsNode;
    vsNode = castTo($get_10(this$static.verticalSegmentsMap, vs_0), 60);
    $forEach_1(vs_0.constraints, new LGraphToCGraphTransformer$lambda$3$Type(this$static, vsNode));
}
function $lambda$27(this$static, sl_0) {
    var cNode, deltaX, lNode;
    lNode = sl_0.source.owner;
    cNode = castTo($get_10(this$static.nodesMap, lNode), 60);
    deltaX = cNode.hitbox.x_0 - cNode.hitboxPreCompaction.x_0;
    $forEach_1(sl_0.labels, new LGraphToCGraphTransformer$lambda$28$Type(deltaX));
}
function $lambda$3(this$static, vsNode_1, other_1) {
    var otherNode;
    otherNode = castTo($get_10(this$static.verticalSegmentsMap, other_1), 60);
    $add_3(this$static.cGraph.predefinedHorizontalConstraints, new Pair(vsNode_1, otherNode));
}
function $lambda$9_0(this$static, cNode_1, other_1) {
    return $put_6(this$static.verticalSegmentsMap, other_1, cNode_1);
}
function $mergeVerticalSegments(this$static, verticalSegments) {
    var next, survivor, vsIt, newX, newY, maxX, newW, maxY, newH;
    if (verticalSegments.array.length == 0) return;
    $clinit_Collections();
    sort_4(verticalSegments.array, verticalSegments.array.length, null);
    vsIt = new ArrayList$1(verticalSegments);
    survivor = castTo($next_6(vsIt), 152);
    while(vsIt.i < vsIt.this$01.array.length){
        next = castTo($next_6(vsIt), 152);
        if (eq_0(survivor.hitbox.x_0, next.hitbox.x_0) && !(lt_0($getBottomLeft(survivor.hitbox).y_0, next.hitbox.y_0) || lt_0($getBottomLeft(next.hitbox).y_0, survivor.hitbox.y_0))) survivor = ($addAll_2(survivor.representedLEdges, next.representedLEdges), $addAll_2(survivor.affectedBends, next.affectedBends), $addAll_2(survivor.affectedBoundingBoxes, next.affectedBoundingBoxes), $addAll(survivor.junctionPoints, next.junctionPoints), $addAll_2(survivor.constraints, next.constraints), $addAll_2(survivor.potentialGroupParents, next.potentialGroupParents), newX = $wnd.Math.min(survivor.hitbox.x_0, next.hitbox.x_0), newY = $wnd.Math.min(survivor.hitbox.y_0, next.hitbox.y_0), maxX = $wnd.Math.max(survivor.hitbox.x_0 + survivor.hitbox.width_0, next.hitbox.x_0 + next.hitbox.width_0), newW = maxX - newX, maxY = $wnd.Math.max(survivor.hitbox.y_0 + survivor.hitbox.height, next.hitbox.y_0 + next.hitbox.height), newH = maxY - newY, $setRect(survivor.hitbox, newX, newY, newW, newH), $applyOr(survivor.ignoreSpacing, next.ignoreSpacing), !survivor.aPort && (survivor.aPort = next.aPort), $addAll_2(survivor.joined, next.joined), $add_3(survivor.joined, next), survivor);
        else {
            $verticalSegmentToCNode(this$static, survivor);
            survivor = next;
        }
    }
    $verticalSegmentToCNode(this$static, survivor);
}
function $transformEdges_0(this$static) {
    var style, verticalSegments, verticalSegments_0;
    style = castTo($getProperty(this$static.layeredGraph, ($clinit_LayeredOptions(), EDGE_ROUTING)), 220);
    switch(style.ordinal){
        case 2:
            verticalSegments = $collectVerticalSegmentsOrthogonal(this$static);
            break;
        case 3:
            verticalSegments = (verticalSegments_0 = new ArrayList, $forEach_3($filter($map($flatMap($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.layeredGraph.layers, 16)), new LGraphToCGraphTransformer$lambda$4$Type), new LGraphToCGraphTransformer$lambda$5$Type), new LGraphToCGraphTransformer$lambda$6$Type), new LGraphToCGraphTransformer$0methodref$nonNull$Type), new LGraphToCGraphTransformer$lambda$8$Type(verticalSegments_0)), verticalSegments_0);
            break;
        default:
            throw toJs(new IllegalStateException_0('Compaction not supported for ' + style + ' edges.'));
    }
    $mergeVerticalSegments(this$static, verticalSegments);
    $forEach_0(new AbstractMap$1(this$static.verticalSegmentsMap), new LGraphToCGraphTransformer$lambda$2$Type(this$static));
}
function $transformNodes_0(this$static) {
    var cNode, difference, e, hitbox, layer, layer$iterator, node, node$iterator, nodeLock, other, p;
    for(layer$iterator = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if ($booleanValue(castToBoolean($getProperty(node, ($clinit_LayeredOptions(), COMMENT_BOX))))) {
                if (!isEmpty_13($getConnectedEdges_0(node))) {
                    e = castTo(get_22($getConnectedEdges_0(node)), 18);
                    other = e.source.owner;
                    other == node && (other = e.target.owner);
                    p = new Pair(other, $sub_0($clone_1(node.pos), other.pos));
                    $put_6(this$static.commentOffsets, node, p);
                    continue;
                }
            }
            hitbox = new ElkRectangle_0(node.pos.x_0 - node.margin.left, node.pos.y_0 - node.margin.top_0, node.size_0.x_0 + node.margin.left + node.margin.right, node.size_0.y_0 + node.margin.top_0 + node.margin.bottom);
            cNode = $create_0($toStringDelegate($hitbox($origin(new CNode$CNodeBuilder, node), hitbox), NODE_TO_STRING_DELEGATE), this$static.cGraph);
            $create($master($nodes(new CGroup$CGroupBuilder, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_common_compaction_oned_CNode_2_classLit, 1), $intern_2, 60, 0, [
                cNode
            ])), cNode), this$static.cGraph);
            nodeLock = new Quadruplet;
            $put_6(this$static.lockMap, cNode, nodeLock);
            difference = size_24(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10))) - size_24(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
            difference < 0 ? $set_2(nodeLock, true, ($clinit_Direction(), LEFT_6)) : difference > 0 && $set_2(nodeLock, true, ($clinit_Direction(), RIGHT_6));
            node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) && $set_3(nodeLock);
            $put_6(this$static.nodesMap, node, cNode);
        }
    }
}
function $verticalSegmentToCNode(this$static, verticalSegment) {
    var cNode, difference, e, e$iterator, inc, out, vsLock;
    cNode = $create_0($toStringDelegate($hitbox($origin(new CNode$CNodeBuilder, verticalSegment), new ElkRectangle_1(verticalSegment.hitbox)), VS_TO_STRING_DELEGATE), this$static.cGraph);
    verticalSegment.potentialGroupParents.array.length == 0 || $addCNode(castTo($get_11(verticalSegment.potentialGroupParents, 0), 60).cGroup, cNode);
    vsLock = new Quadruplet;
    $put_6(this$static.lockMap, cNode, vsLock);
    inc = new HashSet;
    out = new HashSet;
    for(e$iterator = new ArrayList$1(verticalSegment.representedLEdges); e$iterator.i < e$iterator.this$01.array.length;){
        e = castTo($next_6(e$iterator), 18);
        $add_6(inc, e.source);
        $add_6(out, e.target);
    }
    difference = inc.map_0.size_1() - out.map_0.size_1();
    if (difference < 0) {
        $set_2(vsLock, true, ($clinit_Direction(), LEFT_6));
        $set_2(vsLock, false, RIGHT_6);
    } else if (difference > 0) {
        $set_2(vsLock, false, ($clinit_Direction(), LEFT_6));
        $set_2(vsLock, true, RIGHT_6);
    }
    $forEach_1(verticalSegment.joined, new LGraphToCGraphTransformer$lambda$9$Type(this$static, cNode));
    $put_6(this$static.verticalSegmentsMap, verticalSegment, cNode);
}
function LGraphToCGraphTransformer() {
    $clinit_LGraphToCGraphTransformer();
    this.commentOffsets = new HashMap;
    this.nodesMap = new HashMap;
    this.verticalSegmentsMap = new HashMap;
    this.lockMap = new HashMap;
}
function lambda$11(cNode_0) {
    $clinit_LGraphToCGraphTransformer();
    var lNode;
    lNode = castTo(cNode_0.origin_0, 9);
    lNode.pos.x_0 = cNode_0.hitbox.x_0 + lNode.margin.left;
}
function lambda$13(cNode_0) {
    $clinit_LGraphToCGraphTransformer();
    var deltaX, vs;
    deltaX = cNode_0.hitbox.x_0 - cNode_0.hitboxPreCompaction.x_0;
    vs = castTo(cNode_0.origin_0, 152);
    $forEach_1(vs.affectedBends, new LGraphToCGraphTransformer$lambda$14$Type(deltaX));
    $forEach_1(vs.affectedBoundingBoxes, new LGraphToCGraphTransformer$lambda$15$Type(deltaX));
    $forEach_0(vs.junctionPoints, new LGraphToCGraphTransformer$lambda$16$Type(deltaX));
}
function lambda$14(deltaX_0, b_1) {
    $clinit_LGraphToCGraphTransformer();
    return b_1.x_0 += deltaX_0;
}
function lambda$15(deltaX_0, bb_1) {
    $clinit_LGraphToCGraphTransformer();
    return bb_1.x_0 += deltaX_0;
}
function lambda$16(deltaX_0, jp_1) {
    $clinit_LGraphToCGraphTransformer();
    return jp_1.x_0 += deltaX_0;
}
function lambda$23(chain_0) {
    $clinit_LGraphToCGraphTransformer();
    return !!chain_0 && !chain_0.isEmpty();
}
function lambda$28(deltaX_0, l_1) {
    $clinit_LGraphToCGraphTransformer();
    l_1.pos.x_0 += deltaX_0;
}
function lambda$8_0(verticalSegments_0, spline_1) {
    $clinit_LGraphToCGraphTransformer();
    var lastVs, leftTop, rightBottom, s, s$iterator, vs;
    lastVs = null;
    for(s$iterator = spline_1.iterator_0(); s$iterator.hasNext_0();){
        s = castTo(s$iterator.next_1(), 132);
        if (s.isStraight) continue;
        leftTop = $getTopLeft(s.boundingBox);
        rightBottom = $getBottomRight(s.boundingBox);
        vs = new VerticalSegment(leftTop, rightBottom, null, castTo(s.edges.map_0.keySet_0().iterator_0().next_1(), 18));
        $add_3(vs.affectedBoundingBoxes, s.boundingBox);
        push_1(verticalSegments_0.array, vs);
        !!lastVs && $add_3(lastVs.constraints, vs);
        lastVs = vs;
    }
}
defineClass(1672, 1, {}, LGraphToCGraphTransformer);
var NODE_TO_STRING_DELEGATE, VS_TO_STRING_DELEGATE;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer', 1672);
function LGraphToCGraphTransformer$0methodref$nonNull$Type() {}
defineClass(1680, 1, $intern_39, LGraphToCGraphTransformer$0methodref$nonNull$Type);
_.test_0 = function test_57(arg0) {
    return arg0 != null;
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$0methodref$nonNull$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/0methodref$nonNull$Type', 1680);
function LGraphToCGraphTransformer$lambda$0$Type() {}
defineClass(1673, 1, {}, LGraphToCGraphTransformer$lambda$0$Type);
_.apply_0 = function apply_86(arg0) {
    return $clinit_LGraphToCGraphTransformer(), toString_40($getProperty(castTo(castTo(arg0, 60).origin_0, 9), ($clinit_InternalProperties_1(), ORIGIN_0)));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$0$Type', 1673);
function LGraphToCGraphTransformer$lambda$1$Type() {}
defineClass(1674, 1, {}, LGraphToCGraphTransformer$lambda$1$Type);
_.apply_0 = function apply_87(arg0) {
    return $clinit_LGraphToCGraphTransformer(), $toString_14(castTo(castTo(arg0, 60).origin_0, 152));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$1$Type', 1674);
function LGraphToCGraphTransformer$lambda$10$Type() {}
defineClass(1683, 1, $intern_39, LGraphToCGraphTransformer$lambda$10$Type);
_.test_0 = function test_58(arg0) {
    return $clinit_LGraphToCGraphTransformer(), instanceOf(castTo(arg0, 60).origin_0, 9);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$10$Type', 1683);
function LGraphToCGraphTransformer$lambda$11$Type() {}
defineClass(1684, 1, $intern_19, LGraphToCGraphTransformer$lambda$11$Type);
_.accept = function accept_92(arg0) {
    lambda$11(castTo(arg0, 60));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$11$Type', 1684);
function LGraphToCGraphTransformer$lambda$12$Type() {}
defineClass(1685, 1, $intern_39, LGraphToCGraphTransformer$lambda$12$Type);
_.test_0 = function test_59(arg0) {
    return $clinit_LGraphToCGraphTransformer(), instanceOf(castTo(arg0, 60).origin_0, 152);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$12$Type', 1685);
function LGraphToCGraphTransformer$lambda$13$Type() {}
defineClass(1689, 1, $intern_19, LGraphToCGraphTransformer$lambda$13$Type);
_.accept = function accept_93(arg0) {
    lambda$13(castTo(arg0, 60));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$13$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$13$Type', 1689);
function LGraphToCGraphTransformer$lambda$14$Type(deltaX_0) {
    this.deltaX_0 = deltaX_0;
}
defineClass(1686, 1, $intern_19, LGraphToCGraphTransformer$lambda$14$Type);
_.accept = function accept_94(arg0) {
    lambda$14(this.deltaX_0, castTo(arg0, 8));
};
_.deltaX_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$14$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$14$Type', 1686);
function LGraphToCGraphTransformer$lambda$15$Type(deltaX_0) {
    this.deltaX_0 = deltaX_0;
}
defineClass(1687, 1, $intern_19, LGraphToCGraphTransformer$lambda$15$Type);
_.accept = function accept_95(arg0) {
    lambda$15(this.deltaX_0, castTo(arg0, 119));
};
_.deltaX_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$15$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$15$Type', 1687);
function LGraphToCGraphTransformer$lambda$16$Type(deltaX_0) {
    this.deltaX_0 = deltaX_0;
}
defineClass(1688, 1, $intern_19, LGraphToCGraphTransformer$lambda$16$Type);
_.accept = function accept_96(arg0) {
    lambda$16(this.deltaX_0, castTo(arg0, 8));
};
_.deltaX_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$16$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$16$Type', 1688);
function LGraphToCGraphTransformer$lambda$17$Type() {}
defineClass(1690, 1, {}, LGraphToCGraphTransformer$lambda$17$Type);
_.apply_0 = function apply_88(arg0) {
    return $clinit_LGraphToCGraphTransformer(), new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$17$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$17$Type', 1690);
function LGraphToCGraphTransformer$lambda$18$Type() {}
defineClass(1691, 1, $intern_39, LGraphToCGraphTransformer$lambda$18$Type);
_.test_0 = function test_60(arg0) {
    return $clinit_LGraphToCGraphTransformer(), $isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$18$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$18$Type', 1691);
function LGraphToCGraphTransformer$lambda$19$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1692, 1, $intern_19, LGraphToCGraphTransformer$lambda$19$Type);
_.accept = function accept_97(arg0) {
    $lambda$19(this.$$outer_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$19$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$19$Type', 1692);
function LGraphToCGraphTransformer$lambda$2$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1676, 1, $intern_19, LGraphToCGraphTransformer$lambda$2$Type);
_.accept = function accept_98(arg0) {
    $lambda$2_1(this.$$outer_0, castTo(arg0, 152));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$2$Type', 1676);
function LGraphToCGraphTransformer$lambda$20$Type() {}
defineClass(1693, 1, {}, LGraphToCGraphTransformer$lambda$20$Type);
_.apply_0 = function apply_89(arg0) {
    return $clinit_LGraphToCGraphTransformer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$20$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$20$Type', 1693);
function LGraphToCGraphTransformer$lambda$21$Type() {}
defineClass(1694, 1, {}, LGraphToCGraphTransformer$lambda$21$Type);
_.apply_0 = function apply_90(arg0) {
    return $clinit_LGraphToCGraphTransformer(), new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$21$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$21$Type', 1694);
function LGraphToCGraphTransformer$lambda$22$Type() {}
defineClass(1695, 1, {}, LGraphToCGraphTransformer$lambda$22$Type);
_.apply_0 = function apply_91(arg0) {
    return $clinit_LGraphToCGraphTransformer(), castTo($getProperty(castTo(arg0, 18), ($clinit_InternalProperties_1(), SPLINE_ROUTE_START)), 15);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$22$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$22$Type', 1695);
function LGraphToCGraphTransformer$lambda$23$Type() {}
defineClass(1696, 1, $intern_39, LGraphToCGraphTransformer$lambda$23$Type);
_.test_0 = function test_61(arg0) {
    return lambda$23(castTo(arg0, 15));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$23$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$23$Type', 1696);
function LGraphToCGraphTransformer$lambda$24$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1697, 1, $intern_19, LGraphToCGraphTransformer$lambda$24$Type);
_.accept = function accept_99(arg0) {
    $adjustSplineControlPoints(this.$$outer_0, castTo(arg0, 15));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$24$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$24$Type', 1697);
function LGraphToCGraphTransformer$lambda$25$Type() {}
defineClass(1698, 1, {}, LGraphToCGraphTransformer$lambda$25$Type);
_.apply_0 = function apply_92(arg0) {
    return $clinit_LGraphToCGraphTransformer(), new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$25$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$25$Type', 1698);
function LGraphToCGraphTransformer$lambda$26$Type() {}
defineClass(1699, 1, $intern_39, LGraphToCGraphTransformer$lambda$26$Type);
_.test_0 = function test_62(arg0) {
    return $clinit_LGraphToCGraphTransformer(), $isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$26$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$26$Type', 1699);
function LGraphToCGraphTransformer$lambda$27$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1701, 1, $intern_19, LGraphToCGraphTransformer$lambda$27$Type);
_.accept = function accept_100(arg0) {
    $lambda$27(this.$$outer_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$27$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$27$Type', 1701);
function LGraphToCGraphTransformer$lambda$28$Type(deltaX_0) {
    this.deltaX_0 = deltaX_0;
}
defineClass(1700, 1, $intern_19, LGraphToCGraphTransformer$lambda$28$Type);
_.accept = function accept_101(arg0) {
    lambda$28(this.deltaX_0, castTo(arg0, 72));
};
_.deltaX_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$28$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$28$Type', 1700);
function LGraphToCGraphTransformer$lambda$3$Type($$outer_0, vsNode_1) {
    this.$$outer_0 = $$outer_0;
    this.vsNode_1 = vsNode_1;
}
defineClass(1675, 1, $intern_19, LGraphToCGraphTransformer$lambda$3$Type);
_.accept = function accept_102(arg0) {
    $lambda$3(this.$$outer_0, this.vsNode_1, castTo(arg0, 152));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$3$Type', 1675);
function LGraphToCGraphTransformer$lambda$4$Type() {}
defineClass(1677, 1, {}, LGraphToCGraphTransformer$lambda$4$Type);
_.apply_0 = function apply_93(arg0) {
    return $clinit_LGraphToCGraphTransformer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$4$Type', 1677);
function LGraphToCGraphTransformer$lambda$5$Type() {}
defineClass(1678, 1, {}, LGraphToCGraphTransformer$lambda$5$Type);
_.apply_0 = function apply_94(arg0) {
    return $clinit_LGraphToCGraphTransformer(), new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$5$Type', 1678);
function LGraphToCGraphTransformer$lambda$6$Type() {}
defineClass(1679, 1, {}, LGraphToCGraphTransformer$lambda$6$Type);
_.apply_0 = function apply_95(arg0) {
    return $clinit_LGraphToCGraphTransformer(), castTo($getProperty(castTo(arg0, 18), ($clinit_InternalProperties_1(), SPLINE_ROUTE_START)), 15);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$6$Type', 1679);
function LGraphToCGraphTransformer$lambda$8$Type(verticalSegments_0) {
    this.verticalSegments_0 = verticalSegments_0;
}
defineClass(1681, 1, $intern_19, LGraphToCGraphTransformer$lambda$8$Type);
_.accept = function accept_103(arg0) {
    lambda$8_0(this.verticalSegments_0, castTo(arg0, 15));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$8$Type', 1681);
function LGraphToCGraphTransformer$lambda$9$Type($$outer_0, cNode_1) {
    this.$$outer_0 = $$outer_0;
    this.cNode_1 = cNode_1;
}
defineClass(1682, 1, $intern_19, LGraphToCGraphTransformer$lambda$9$Type);
_.accept = function accept_104(arg0) {
    $lambda$9_0(this.$$outer_0, this.cNode_1, castTo(arg0, 152));
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_LGraphToCGraphTransformer$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'LGraphToCGraphTransformer/lambda$9$Type', 1682);
function $addArtificialSourceNode(this$static) {
    var dummySource, lastArg, n, n$iterator, sources, src_0, src$iterator;
    sources = new LinkedList;
    for(n$iterator = new ArrayList$1(this$static.networkSimplexGraph.nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 123);
        n.incomingEdges.list.array.length == 0 && $addNode_0(sources, n, sources.tail.prev, sources.tail);
    }
    if (sources.size_0 > 1) {
        dummySource = $create_2((lastArg = new NNode$NNodeBuilder, ++this$static.index_0, lastArg), this$static.networkSimplexGraph);
        for(src$iterator = $listIterator_2(sources, 0); src$iterator.currentNode != src$iterator.this$01.tail;){
            src_0 = castTo($next_9(src$iterator), 123);
            $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 1), 0), dummySource), src_0));
        }
    }
}
function $addEdgeConstraints(this$static) {
    var cNode, cNode$iterator, cNode$iterator0, e, e$iterator, lEdge, lEdge$iterator, lEdgeMap, lNode, lNodeMap, n, n$iterator, src_0, srcPort, target, tgt, tgtPort, vs;
    lNodeMap = new HashMap;
    lEdgeMap = new HashMultimap;
    for(cNode$iterator0 = new ArrayList$1(this$static.compactor.cGraph.cNodes); cNode$iterator0.i < cNode$iterator0.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator0), 60);
        lNode = getLNodeOrNull(cNode);
        if (lNode) $put_9(lNodeMap.hashCodeMap, lNode, cNode);
        else {
            vs = getVerticalSegmentOrNull(cNode);
            if (vs) for(e$iterator = new ArrayList$1(vs.representedLEdges); e$iterator.i < e$iterator.this$01.array.length;){
                e = castTo($next_6(e$iterator), 18);
                $put(lEdgeMap, e, cNode);
            }
        }
    }
    for(cNode$iterator = new ArrayList$1(this$static.compactor.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        lNode = getLNodeOrNull(cNode);
        if (lNode) for(lEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(lEdge$iterator);){
            lEdge = castTo($next_0(lEdge$iterator), 18);
            if ($isSelfLoop(lEdge)) continue;
            srcPort = lEdge.source;
            tgtPort = lEdge.target;
            if (($clinit_PortSide(), SIDES_NORTH_SOUTH).contains(lEdge.source.side) && SIDES_NORTH_SOUTH.contains(lEdge.target.side)) continue;
            target = castTo($get_10(lNodeMap, lEdge.target.owner), 60);
            $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 0), 100), this$static.nNodes[cNode.cGroup.id_0]), this$static.nNodes[target.cGroup.id_0]));
            if (srcPort.side == WEST_0 && $apply_4(($clinit_LPort(), OUTPUT_PREDICATE, srcPort))) for(n$iterator = castTo($get(lEdgeMap, lEdge), 22).iterator_0(); n$iterator.hasNext_0();){
                n = castTo(n$iterator.next_1(), 60);
                if (n.hitbox.x_0 < cNode.hitbox.x_0) {
                    src_0 = this$static.nNodes[n.cGroup.id_0];
                    tgt = this$static.nNodes[cNode.cGroup.id_0];
                    if (src_0 == tgt) continue;
                    $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 1), 100), src_0), tgt));
                }
            }
            if (tgtPort.side == EAST_0 && $apply_5(($clinit_LPort(), INPUT_PREDICATE, tgtPort))) for(n$iterator = castTo($get(lEdgeMap, lEdge), 22).iterator_0(); n$iterator.hasNext_0();){
                n = castTo(n$iterator.next_1(), 60);
                if (n.hitbox.x_0 > cNode.hitbox.x_0) {
                    src_0 = this$static.nNodes[cNode.cGroup.id_0];
                    tgt = this$static.nNodes[n.cGroup.id_0];
                    if (src_0 == tgt) continue;
                    $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 1), 100), src_0), tgt));
                }
            }
        }
    }
}
function $addSeparationConstraints(this$static) {
    var adjust, alterOffset, cNode, cNode$iterator, delta, helper, incNode, incNode$iterator, offsetDelta, port, spacing, weight;
    for(cNode$iterator = new ArrayList$1(this$static.compactor.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        for(incNode$iterator = cNode.constraints.iterator_0(); incNode$iterator.hasNext_0();){
            incNode = castTo(incNode$iterator.next_1(), 60);
            if (cNode.cGroup == incNode.cGroup) continue;
            $isHorizontal(this$static.compactor.direction) ? spacing = this$static.compactor.spacingsHandler.getHorizontalSpacing(cNode, incNode) : spacing = this$static.compactor.spacingsHandler.getVerticalSpacing(cNode, incNode);
            delta = cNode.cGroupOffset.x_0 + cNode.hitbox.width_0 + spacing - incNode.cGroupOffset.x_0;
            delta = $wnd.Math.ceil(delta);
            delta = $wnd.Math.max(0, delta);
            if (isVerticalSegmentsOfSameEdge(cNode, incNode)) {
                helper = $create_2(new NNode$NNodeBuilder, this$static.networkSimplexGraph);
                offsetDelta = round_int($wnd.Math.ceil(incNode.cGroupOffset.x_0 - cNode.cGroupOffset.x_0));
                adjust = offsetDelta - (incNode.cGroupOffset.x_0 - cNode.cGroupOffset.x_0);
                port = getVerticalSegmentOrNull(cNode).aPort;
                alterOffset = cNode;
                if (!port) {
                    port = getVerticalSegmentOrNull(incNode).aPort;
                    adjust = -adjust;
                    alterOffset = incNode;
                }
                if (port) {
                    alterOffset.cGroupOffset.x_0 -= adjust;
                    port.pos.x_0 -= adjust;
                }
                $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, $wnd.Math.max(0, offsetDelta)), 1), helper), this$static.nNodes[cNode.cGroup.id_0]));
                $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, $wnd.Math.max(0, -offsetDelta)), 1), helper), this$static.nNodes[incNode.cGroup.id_0]));
            } else {
                weight = 1;
                (instanceOf(cNode.origin_0, 152) && instanceOf(incNode.origin_0, 9) || instanceOf(incNode.origin_0, 152) && instanceOf(cNode.origin_0, 9)) && (weight = 2);
                $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, round_int(delta)), weight), this$static.nNodes[cNode.cGroup.id_0]), this$static.nNodes[incNode.cGroup.id_0]));
            }
        }
    }
}
function NetworkSimplexCompaction() {}
defineClass(1671, 1, {}, NetworkSimplexCompaction);
_.compact = function compact_1(theCompactor) {
    var cGroup, cGroup$iterator, cNode, cNode$iterator, nNode;
    this.compactor = theCompactor;
    this.networkSimplexGraph = new NGraph;
    this.nNodes = initUnidimensionalArray(Lorg_eclipse_elk_alg_common_networksimplex_NNode_2_classLit, $intern_2, 123, this.compactor.cGraph.cGroups.array.length, 0, 1);
    this.index_0 = 0;
    for(cGroup$iterator = new ArrayList$1(this.compactor.cGraph.cGroups); cGroup$iterator.i < cGroup$iterator.this$01.array.length;){
        cGroup = castTo($next_6(cGroup$iterator), 317);
        cGroup.id_0 = this.index_0;
        nNode = $create_2($origin_0(new NNode$NNodeBuilder, cGroup), this.networkSimplexGraph);
        this.nNodes[this.index_0] = nNode;
        ++this.index_0;
    }
    $addSeparationConstraints(this);
    $addEdgeConstraints(this);
    $addArtificialSourceNode(this);
    $execute_0(forGraph(this.networkSimplexGraph), new BasicProgressMonitor);
    for(cNode$iterator = new ArrayList$1(this.compactor.cGraph.cNodes); cNode$iterator.i < cNode$iterator.this$01.array.length;){
        cNode = castTo($next_6(cNode$iterator), 60);
        cNode.hitbox.x_0 = this.nNodes[cNode.cGroup.id_0].layer + cNode.cGroupOffset.x_0;
    }
};
_.index_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_NetworkSimplexCompaction_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'NetworkSimplexCompaction', 1671);
function $compareTo_12(this$static, o) {
    var d;
    d = fuzzyCompare(this$static.hitbox.x_0, o.hitbox.x_0);
    if (d == 0) return compare_4(this$static.hitbox.y_0, o.hitbox.y_0);
    return d;
}
function $toString_14(this$static) {
    var sb;
    sb = new StringBuilder;
    sb.string += 'VerticalSegment ';
    $append_10(sb, this$static.hitbox);
    sb.string += ' ';
    $append_11(sb, $join(new Joiner, new ArrayList$1(this$static.representedLEdges)));
    return sb.string;
}
function VerticalSegment(bend1, bend2, cNode, lEdge) {
    var inJPs, jp, jp$iterator;
    this.potentialGroupParents = new ArrayList;
    this.representedLEdges = new ArrayList;
    this.affectedBends = new ArrayList;
    this.affectedBoundingBoxes = new ArrayList;
    this.hitbox = new ElkRectangle;
    this.junctionPoints = new KVectorChain;
    this.ignoreSpacing = new Quadruplet;
    this.constraints = new ArrayList;
    this.joined = new ArrayList;
    $add_3(this.affectedBends, bend1);
    $add_3(this.affectedBends, bend2);
    this.hitbox.x_0 = $wnd.Math.min(bend1.x_0, bend2.x_0);
    this.hitbox.y_0 = $wnd.Math.min(bend1.y_0, bend2.y_0);
    this.hitbox.width_0 = $wnd.Math.abs(bend1.x_0 - bend2.x_0);
    this.hitbox.height = $wnd.Math.abs(bend1.y_0 - bend2.y_0);
    inJPs = castTo($getProperty(lEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
    if (inJPs) for(jp$iterator = $listIterator_2(inJPs, 0); jp$iterator.currentNode != jp$iterator.this$01.tail;){
        jp = castTo($next_9(jp$iterator), 8);
        eq_0(jp.x_0, bend1.x_0) && $add_7(this.junctionPoints, jp);
    }
    !!cNode && $add_3(this.potentialGroupParents, cNode);
    $add_3(this.representedLEdges, lEdge);
}
defineClass(152, 1, {
    34: 1,
    152: 1
}, VerticalSegment);
_.compareTo_0 = function compareTo_13(o) {
    return $compareTo_12(this, castTo(o, 152));
};
_.toString_0 = function toString_92() {
    return $toString_14(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_compaction_VerticalSegment_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.compaction', 'VerticalSegment', 152);
function $addEasternCrossings(this$static, upperNode, lowerNode) {
    this$static.upperAdjacencies = $getAdjacencyFor(this$static, upperNode, ($clinit_PortSide(), EAST_0), this$static.easternAdjacencies);
    this$static.lowerAdjacencies = $getAdjacencyFor(this$static, lowerNode, EAST_0, this$static.easternAdjacencies);
    if (this$static.upperAdjacencies.currentSize == 0 || this$static.lowerAdjacencies.currentSize == 0) return;
    $countCrossingsByMergingAdjacencyLists(this$static);
}
function $addWesternCrossings(this$static, upperNode, lowerNode) {
    this$static.upperAdjacencies = $getAdjacencyFor(this$static, upperNode, ($clinit_PortSide(), WEST_0), this$static.westernAdjacencies);
    this$static.lowerAdjacencies = $getAdjacencyFor(this$static, lowerNode, WEST_0, this$static.westernAdjacencies);
    if (this$static.upperAdjacencies.currentSize == 0 || this$static.lowerAdjacencies.currentSize == 0) return;
    $countCrossingsByMergingAdjacencyLists(this$static);
}
function $countBothSideCrossings(this$static, upperNode, lowerNode) {
    this$static.upperLowerCrossings = 0;
    this$static.lowerUpperCrossings = 0;
    if (upperNode == lowerNode) return;
    $addWesternCrossings(this$static, upperNode, lowerNode);
    $addEasternCrossings(this$static, upperNode, lowerNode);
}
function $countCrossingsByMergingAdjacencyLists(this$static) {
    while(this$static.upperAdjacencies.currentSize != 0 && this$static.lowerAdjacencies.currentSize != 0){
        if ($currentAdjacency(this$static.upperAdjacencies).position > $currentAdjacency(this$static.lowerAdjacencies).position) {
            this$static.upperLowerCrossings += this$static.upperAdjacencies.currentSize;
            $removeFirst_1(this$static.lowerAdjacencies);
        } else if ($currentAdjacency(this$static.lowerAdjacencies).position > $currentAdjacency(this$static.upperAdjacencies).position) {
            this$static.lowerUpperCrossings += this$static.lowerAdjacencies.currentSize;
            $removeFirst_1(this$static.upperAdjacencies);
        } else {
            this$static.upperLowerCrossings += $countAdjacenciesBelowNodeOfFirstPort(this$static.upperAdjacencies);
            this$static.lowerUpperCrossings += $countAdjacenciesBelowNodeOfFirstPort(this$static.lowerAdjacencies);
            $removeFirst_1(this$static.upperAdjacencies);
            $removeFirst_1(this$static.lowerAdjacencies);
        }
    }
}
function $countEasternEdgeCrossings(this$static, upperNode, lowerNode) {
    this$static.upperLowerCrossings = 0;
    this$static.lowerUpperCrossings = 0;
    if (upperNode == lowerNode) return;
    $addEasternCrossings(this$static, upperNode, lowerNode);
}
function $countWesternEdgeCrossings(this$static, upperNode, lowerNode) {
    this$static.upperLowerCrossings = 0;
    this$static.lowerUpperCrossings = 0;
    if (upperNode == lowerNode) return;
    $addWesternCrossings(this$static, upperNode, lowerNode);
}
function $getAdjacencyFor(this$static, node, side, adjacencies) {
    var aL, n, n$array, n$index, n$max;
    if (adjacencies.hashCodeMap.size_0 + adjacencies.stringMap.size_0 == 0) for(n$array = this$static.currentNodeOrder[this$static.freeLayerIndex], n$index = 0, n$max = n$array.length; n$index < n$max; ++n$index){
        n = n$array[n$index];
        $put_6(adjacencies, n, new BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList(this$static, n, side));
    }
    aL = castTo(getEntryValueOrNull($getEntry_0(adjacencies.hashCodeMap, node)), 662);
    aL.currentIndex = 0;
    aL.currentSize = aL.size_0;
    aL.currentSize == 0 || $reset_3(castTo($get_11(aL.adjacencyList, aL.currentIndex), 292));
    return aL;
}
function $setPortPositionsForLayer(this$static, layerIndex, portSide) {
    var node, node$array, node$index, node$max, port, port$iterator, portId, ports;
    portId = 0;
    for(node$array = this$static.currentNodeOrder[layerIndex], node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        ports = inNorthSouthEastWestOrder(node, portSide);
        for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            $put_6(this$static.portPositions, port, valueOf_3(portId++));
        }
    }
}
function BetweenLayerEdgeTwoNodeCrossingsCounter(currentNodeOrder, freeLayerIndex) {
    this.portPositions = new HashMap;
    this.easternAdjacencies = new HashMap;
    this.westernAdjacencies = new HashMap;
    this.currentNodeOrder = currentNodeOrder;
    this.freeLayerIndex = freeLayerIndex;
    this.freeLayerIndex > 0 && $setPortPositionsForLayer(this, this.freeLayerIndex - 1, ($clinit_PortSide(), EAST_0));
    this.freeLayerIndex < this.currentNodeOrder.length - 1 && $setPortPositionsForLayer(this, this.freeLayerIndex + 1, ($clinit_PortSide(), WEST_0));
}
defineClass(820, 1, {}, BetweenLayerEdgeTwoNodeCrossingsCounter);
_.freeLayerIndex = 0;
_.lowerUpperCrossings = 0;
_.upperLowerCrossings = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_BetweenLayerEdgeTwoNodeCrossingsCounter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'BetweenLayerEdgeTwoNodeCrossingsCounter', 820);
function $addAdjacencyOf(this$static, edge) {
    var adjacentPort, adjacentPortPosition, lastIndex;
    adjacentPort = $adjacentPortOf(edge, this$static.side);
    adjacentPortPosition = castTo($get_10(this$static.this$01.portPositions, adjacentPort), 17).value_0;
    lastIndex = this$static.adjacencyList.array.length - 1;
    if (this$static.adjacencyList.array.length != 0 && castTo($get_11(this$static.adjacencyList, lastIndex), 292).position == adjacentPortPosition) {
        ++castTo($get_11(this$static.adjacencyList, lastIndex), 292).cardinality;
        ++castTo($get_11(this$static.adjacencyList, lastIndex), 292).currentCardinality;
    } else $add_3(this$static.adjacencyList, new BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList$Adjacency(adjacentPortPosition));
}
function $adjacentPortOf(e, s) {
    return s == ($clinit_PortSide(), WEST_0) ? e.source : e.target;
}
function $countAdjacenciesBelowNodeOfFirstPort(this$static) {
    return this$static.currentSize - castTo($get_11(this$static.adjacencyList, this$static.currentIndex), 292).currentCardinality;
}
function $currentAdjacency(this$static) {
    return castTo($get_11(this$static.adjacencyList, this$static.currentIndex), 292);
}
function $iterateTroughEdgesCollectingAdjacencies(this$static) {
    var edge, edge$iterator, edges, port, port$iterator, ports;
    ports = inNorthSouthEastWestOrder(this$static.node, this$static.side);
    for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        edges = this$static.side == ($clinit_PortSide(), WEST_0) ? port.incomingEdges : port.outgoingEdges;
        for(edge$iterator = new ArrayList$1(edges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            if (!$isSelfLoop(edge) && edge.source.owner.layer != edge.target.owner.layer) {
                $addAdjacencyOf(this$static, edge);
                ++this$static.size_0;
                ++this$static.currentSize;
            }
        }
    }
}
function $removeFirst_1(this$static) {
    var currentEntry;
    if (this$static.currentSize == 0) return;
    currentEntry = castTo($get_11(this$static.adjacencyList, this$static.currentIndex), 292);
    currentEntry.currentCardinality == 1 ? (++this$static.currentIndex, this$static.currentIndex < this$static.adjacencyList.array.length && $reset_3(castTo($get_11(this$static.adjacencyList, this$static.currentIndex), 292))) : --currentEntry.currentCardinality;
    --this$static.currentSize;
}
function BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList(this$0, node, side) {
    this.this$01 = this$0;
    this.node = node;
    this.side = side;
    this.adjacencyList = new ArrayList;
    $iterateTroughEdgesCollectingAdjacencies(this);
    $clinit_Collections();
    $sort(this.adjacencyList, null);
}
defineClass(662, 1, {
    662: 1
}, BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList);
_.toString_0 = function toString_93() {
    return 'AdjacencyList [node=' + this.node + ', adjacencies= ' + this.adjacencyList + ']';
};
_.currentIndex = 0;
_.currentSize = 0;
_.size_0 = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList', 662);
function $compareTo_13(this$static, o) {
    return this$static.position < o.position ? -1 : this$static.position == o.position ? 0 : 1;
}
function $reset_3(this$static) {
    this$static.currentCardinality = this$static.cardinality;
}
function BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList$Adjacency(adjacentPortPosition) {
    this.position = adjacentPortPosition;
    this.cardinality = 1;
    this.currentCardinality = 1;
}
defineClass(292, 1, {
    34: 1,
    292: 1
}, BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList$Adjacency);
_.compareTo_0 = function compareTo_14(o) {
    return $compareTo_13(this, castTo(o, 292));
};
_.toString_0 = function toString_94() {
    return 'Adjacency [position=' + this.position + ', cardinality=' + this.cardinality + ', currentCardinality=' + this.currentCardinality + ']';
};
_.cardinality = 0;
_.currentCardinality = 0;
_.position = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_BetweenLayerEdgeTwoNodeCrossingsCounter$AdjacencyList$Adjacency_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList/Adjacency', 292);
function $fillCrossingMatrix(this$static, upperNode, lowerNode) {
    if (this$static.oneSided) switch(this$static.direction){
        case 1:
            $countEasternEdgeCrossings(this$static.inBetweenLayerCrossingCounter, upperNode, lowerNode);
            break;
        case 0:
            $countWesternEdgeCrossings(this$static.inBetweenLayerCrossingCounter, upperNode, lowerNode);
    }
    else $countBothSideCrossings(this$static.inBetweenLayerCrossingCounter, upperNode, lowerNode);
    this$static.crossingMatrix[upperNode.id_0][lowerNode.id_0] = this$static.inBetweenLayerCrossingCounter.upperLowerCrossings;
    this$static.crossingMatrix[lowerNode.id_0][upperNode.id_0] = this$static.inBetweenLayerCrossingCounter.lowerUpperCrossings;
}
function $getCrossingMatrixEntry(this$static, upperNode, lowerNode) {
    if (!this$static.isCrossingMatrixFilled[upperNode.id_0][lowerNode.id_0]) {
        $fillCrossingMatrix(this$static, upperNode, lowerNode);
        this$static.isCrossingMatrixFilled[upperNode.id_0][lowerNode.id_0] = true;
        this$static.isCrossingMatrixFilled[lowerNode.id_0][upperNode.id_0] = true;
    }
    return this$static.crossingMatrix[upperNode.id_0][lowerNode.id_0];
}
function CrossingMatrixFiller(greedySwitchType, graph, freeLayerIndex, direction) {
    var freeLayer;
    this.direction = direction;
    this.oneSided = greedySwitchType == ($clinit_LayerSweepCrossingMinimizer$CrossMinType(), ONE_SIDED_GREEDY_SWITCH_0);
    freeLayer = graph[freeLayerIndex];
    this.isCrossingMatrixFilled = initMultidimensionalArray(Z_classLit, [
        $intern_16,
        $intern_90
    ], [
        183,
        30
    ], 16, [
        freeLayer.length,
        freeLayer.length
    ], 2);
    this.crossingMatrix = initMultidimensionalArray(I_classLit, [
        $intern_16,
        $intern_48
    ], [
        54,
        30
    ], 15, [
        freeLayer.length,
        freeLayer.length
    ], 2);
    this.inBetweenLayerCrossingCounter = new BetweenLayerEdgeTwoNodeCrossingsCounter(graph, freeLayerIndex);
}
defineClass(1972, 1, {}, CrossingMatrixFiller);
_.direction = 0;
_.oneSided = false;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_CrossingMatrixFiller_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'CrossingMatrixFiller', 1972);
function init_0(initializables, order) {
    var e, edge, edge$iterator, i, i$iterator, i$iterator0, i$iterator1, i$iterator2, i$iterator3, l, n, p, port, ports;
    for(l = 0; l < order.length; l++){
        for(i$iterator0 = initializables.iterator_0(); i$iterator0.hasNext_0();){
            i = castTo(i$iterator0.next_1(), 229);
            i.initAtLayerLevel(l, order);
        }
        for(n = 0; n < order[l].length; n++){
            for(i$iterator1 = initializables.iterator_0(); i$iterator1.hasNext_0();){
                i = castTo(i$iterator1.next_1(), 229);
                i.initAtNodeLevel(l, n, order);
            }
            ports = order[l][n].ports;
            for(p = 0; p < ports.array.length; p++){
                for(i$iterator2 = initializables.iterator_0(); i$iterator2.hasNext_0();){
                    i = castTo(i$iterator2.next_1(), 229);
                    i.initAtPortLevel(l, n, p, order);
                }
                port = (checkCriticalElementIndex(p, ports.array.length), castTo(ports.array[p], 11));
                e = 0;
                for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
                    edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
                    for(i$iterator3 = initializables.iterator_0(); i$iterator3.hasNext_0();){
                        i = castTo(i$iterator3.next_1(), 229);
                        i.initAtEdgeLevel(l, n, p, e++, edge, order);
                    }
                }
            }
        }
    }
    for(i$iterator = initializables.iterator_0(); i$iterator.hasNext_0();){
        i = castTo(i$iterator.next_1(), 229);
        i.initAfterTraversal();
    }
}
var Lorg_eclipse_elk_alg_layered_p3order_counting_IInitializable_2_classLit = createForInterface('org.eclipse.elk.alg.layered.p3order.counting', 'IInitializable');
function $continueSwitchingUntilNoImprovementInLayer(this$static, freeLayerIndex) {
    var continueSwitching, improved;
    improved = false;
    do {
        continueSwitching = $sweepDownwardInLayer(this$static, freeLayerIndex);
        improved = improved | continueSwitching;
    }while (continueSwitching);
    return improved;
}
function $setUp(this$static, order, freeLayerIndex, forwardSweep) {
    var crossingMatrixFiller, side;
    this$static.currentNodeOrder = order;
    side = forwardSweep ? 0 : 1;
    this$static.switchDecider = (crossingMatrixFiller = new CrossingMatrixFiller(this$static.greedySwitchType, this$static.currentNodeOrder, freeLayerIndex, side), new SwitchDecider(freeLayerIndex, this$static.currentNodeOrder, crossingMatrixFiller, this$static.portPositions, this$static.graphData, this$static.greedySwitchType == ($clinit_LayerSweepCrossingMinimizer$CrossMinType(), ONE_SIDED_GREEDY_SWITCH_0)));
}
function $startIndex(isForwardSweep, length_0) {
    return isForwardSweep ? 0 : length_0 - 1;
}
function $sweepDownwardInLayer(this$static, layerIndex) {
    var continueSwitching, lengthOfFreeLayer, lowerNodeIndex, upperNodeIndex;
    continueSwitching = false;
    lengthOfFreeLayer = this$static.currentNodeOrder[layerIndex].length;
    for(upperNodeIndex = 0; upperNodeIndex < lengthOfFreeLayer - 1; upperNodeIndex++){
        lowerNodeIndex = upperNodeIndex + 1;
        continueSwitching = continueSwitching | $switchIfImproves(this$static, layerIndex, upperNodeIndex, lowerNodeIndex);
    }
    return continueSwitching;
}
function $switchIfImproves(this$static, layerIndex, upperNodeIndex, lowerNodeIndex) {
    var continueSwitching, layer, temp;
    continueSwitching = false;
    if ($doesSwitchReduceCrossings(this$static.switchDecider, upperNodeIndex, lowerNodeIndex)) {
        $notifyOfSwitch(this$static.switchDecider, this$static.currentNodeOrder[layerIndex][upperNodeIndex], this$static.currentNodeOrder[layerIndex][lowerNodeIndex]);
        layer = this$static.currentNodeOrder[layerIndex];
        temp = layer[lowerNodeIndex];
        layer[lowerNodeIndex] = layer[upperNodeIndex];
        layer[upperNodeIndex] = temp;
        continueSwitching = true;
    }
    return continueSwitching;
}
function GreedySwitchHeuristic(greedyType, graphData) {
    this.graphData = graphData;
    this.greedySwitchType = greedyType;
}
defineClass(1813, 1, $intern_108, GreedySwitchHeuristic);
_.initAtEdgeLevel = function initAtEdgeLevel(l, n, p, e, edge, nodeOrder) {};
_.initAtNodeLevel = function initAtNodeLevel(l, n, nodeOrder) {};
_.alwaysImproves = function alwaysImproves() {
    return this.greedySwitchType != ($clinit_LayerSweepCrossingMinimizer$CrossMinType(), ONE_SIDED_GREEDY_SWITCH_0);
};
_.initAfterTraversal = function initAfterTraversal() {
    this.portPositions = initUnidimensionalArray(I_classLit, $intern_48, 30, this.nPorts, 15, 1);
};
_.initAtLayerLevel = function initAtLayerLevel(l, nodeOrder) {
    nodeOrder[l][0].layer.id_0 = l;
};
_.initAtPortLevel = function initAtPortLevel(l, n, p, nodeOrder) {
    ++this.nPorts;
};
_.isDeterministic = function isDeterministic() {
    return true;
};
_.minimizeCrossings = function minimizeCrossings(order, freeLayerIndex, forwardSweep, isFirstSweep) {
    $setUp(this, order, freeLayerIndex, forwardSweep);
    return $continueSwitchingUntilNoImprovementInLayer(this, freeLayerIndex);
};
_.setFirstLayerOrder = function setFirstLayerOrder(currentOrder, isForwardSweep) {
    var startIndex;
    startIndex = $startIndex(isForwardSweep, currentOrder.length);
    $setUp(this, currentOrder, startIndex, isForwardSweep);
    return $sweepDownwardInLayer(this, startIndex);
};
_.nPorts = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_GreedySwitchHeuristic_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'GreedySwitchHeuristic', 1813);
function $countCrossings(this$static, upperNode, lowerNode) {
    this$static.upperLowerCrossings = 0;
    this$static.lowerUpperCrossings = 0;
    upperNode.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT) && lowerNode.type_0 == NORTH_SOUTH_PORT && castTo($getProperty(upperNode, ($clinit_InternalProperties_1(), ORIGIN_0)), 9) == castTo($getProperty(lowerNode, ORIGIN_0), 9) && ($originPortOf(upperNode).side == ($clinit_PortSide(), NORTH_1) ? $countCrossingsOfTwoNorthSouthDummies(this$static, upperNode, lowerNode) : $countCrossingsOfTwoNorthSouthDummies(this$static, lowerNode, upperNode));
    upperNode.type_0 == NORTH_SOUTH_PORT && lowerNode.type_0 == LONG_EDGE ? $originPortOf(upperNode).side == ($clinit_PortSide(), NORTH_1) ? this$static.upperLowerCrossings = 1 : this$static.lowerUpperCrossings = 1 : lowerNode.type_0 == NORTH_SOUTH_PORT && upperNode.type_0 == LONG_EDGE && ($originPortOf(lowerNode).side == ($clinit_PortSide(), NORTH_1) ? this$static.lowerUpperCrossings = 1 : this$static.upperLowerCrossings = 1);
    $processIfNormalNodeWithNSPortsAndLongEdgeDummy(this$static, upperNode, lowerNode);
}
function $countCrossingsOfTwoNorthSouthDummies(this$static, furtherFromNormalNode, closerToNormalNode) {
    var closerEastPorts, closerWestPorts, furtherEastPorts, furtherWestPorts;
    if ($originPortPositionOf(this$static, furtherFromNormalNode) > $originPortPositionOf(this$static, closerToNormalNode)) {
        closerEastPorts = $getPortSideView(closerToNormalNode, ($clinit_PortSide(), EAST_0));
        this$static.upperLowerCrossings = closerEastPorts.isEmpty() ? 0 : $getDegree(castTo(closerEastPorts.get_0(0), 11));
        furtherWestPorts = $getPortSideView(furtherFromNormalNode, WEST_0);
        this$static.lowerUpperCrossings = furtherWestPorts.isEmpty() ? 0 : $getDegree(castTo(furtherWestPorts.get_0(0), 11));
    } else {
        closerWestPorts = $getPortSideView(closerToNormalNode, ($clinit_PortSide(), WEST_0));
        this$static.upperLowerCrossings = closerWestPorts.isEmpty() ? 0 : $getDegree(castTo(closerWestPorts.get_0(0), 11));
        furtherEastPorts = $getPortSideView(furtherFromNormalNode, EAST_0);
        this$static.lowerUpperCrossings = furtherEastPorts.isEmpty() ? 0 : $getDegree(castTo(furtherEastPorts.get_0(0), 11));
    }
}
function $initializePortPositions(this$static) {
    var node, node$array, node$index, node$max;
    for(node$array = this$static.layer, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        $setPortIdsOn(this$static, node, ($clinit_PortSide(), SOUTH_0));
        $setPortIdsOn(this$static, node, NORTH_1);
    }
}
function $numberOfNorthSouthEdges(node, side) {
    var numberOfEdges, port, port$iterator;
    numberOfEdges = 0;
    for(port$iterator = $getPortSideView(node, side).iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        numberOfEdges += $getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)) != null ? 1 : 0;
    }
    return numberOfEdges;
}
function $originPortOf(node) {
    var origin_0, port;
    port = castTo($get_11(node.ports, 0), 11);
    origin_0 = castTo($getProperty(port, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
    return origin_0;
}
function $originPortPositionOf(this$static, node) {
    var origin_0, port;
    origin_0 = $originPortOf(node);
    port = origin_0;
    return castTo($get_10(this$static.portPositions, port), 17).value_0;
}
function $processIfNormalNodeWithNSPortsAndLongEdgeDummy(this$static, upperNode, lowerNode) {
    if (upperNode.type_0 == ($clinit_LNode$NodeType(), NORMAL) && lowerNode.type_0 == LONG_EDGE) {
        this$static.upperLowerCrossings = $numberOfNorthSouthEdges(upperNode, ($clinit_PortSide(), SOUTH_0));
        this$static.lowerUpperCrossings = $numberOfNorthSouthEdges(upperNode, NORTH_1);
    }
    if (lowerNode.type_0 == NORMAL && upperNode.type_0 == LONG_EDGE) {
        this$static.upperLowerCrossings = $numberOfNorthSouthEdges(lowerNode, ($clinit_PortSide(), NORTH_1));
        this$static.lowerUpperCrossings = $numberOfNorthSouthEdges(lowerNode, SOUTH_0);
    }
}
function $setPortIdsOn(this$static, node, side) {
    var port, port$iterator, portId, ports;
    ports = inNorthSouthEastWestOrder(node, side);
    portId = 0;
    for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        $put_6(this$static.portPositions, port, valueOf_3(portId++));
    }
}
function NorthSouthEdgeNeighbouringNodeCrossingsCounter(nodes) {
    this.layer = nodes;
    this.portPositions = new HashMap;
    $initializePortPositions(this);
}
defineClass(1975, 1, {}, NorthSouthEdgeNeighbouringNodeCrossingsCounter);
_.lowerUpperCrossings = 0;
_.upperLowerCrossings = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_NorthSouthEdgeNeighbouringNodeCrossingsCounter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'NorthSouthEdgeNeighbouringNodeCrossingsCounter', 1975);
function $doesSwitchReduceCrossings(this$static, upperNodeIndex, lowerNodeIndex) {
    var crossingNumbers, leftInlayer, lowerNode, lowerPort, lowerUpperCrossings, rightInlayer, upperLowerCrossings, upperNode, upperPort, upperNode_0, lowerNode_0, constraints, neitherNodeIsLongEdgeDummy, upperLayoutUnit, lowerLayoutUnit, areInDifferentLayoutUnits, nodesHaveLayoutUnits, upperNodeHasNorthernEdges, lowerNodeHasSouthernEdges, hasLayoutUnitConstraint;
    if (upperNode_0 = this$static.freeLayer[upperNodeIndex], lowerNode_0 = this$static.freeLayer[lowerNodeIndex], (constraints = castTo($getProperty(upperNode_0, ($clinit_InternalProperties_1(), IN_LAYER_SUCCESSOR_CONSTRAINTS)), 15), !!constraints && constraints.size_1() != 0 && constraints.contains(lowerNode_0)) || (neitherNodeIsLongEdgeDummy = upperNode_0.type_0 != ($clinit_LNode$NodeType(), LONG_EDGE) && lowerNode_0.type_0 != LONG_EDGE, upperLayoutUnit = castTo($getProperty(upperNode_0, IN_LAYER_LAYOUT_UNIT), 9), lowerLayoutUnit = castTo($getProperty(lowerNode_0, IN_LAYER_LAYOUT_UNIT), 9), areInDifferentLayoutUnits = upperLayoutUnit != lowerLayoutUnit, nodesHaveLayoutUnits = !!upperLayoutUnit && upperLayoutUnit != upperNode_0 || !!lowerLayoutUnit && lowerLayoutUnit != lowerNode_0, upperNodeHasNorthernEdges = $hasEdgesOnSide(upperNode_0, ($clinit_PortSide(), NORTH_1)), lowerNodeHasSouthernEdges = $hasEdgesOnSide(lowerNode_0, SOUTH_0), nodesHaveLayoutUnits = nodesHaveLayoutUnits | ($hasEdgesOnSide(upperNode_0, SOUTH_0) || $hasEdgesOnSide(lowerNode_0, NORTH_1)), hasLayoutUnitConstraint = nodesHaveLayoutUnits && areInDifferentLayoutUnits || upperNodeHasNorthernEdges || lowerNodeHasSouthernEdges, neitherNodeIsLongEdgeDummy && hasLayoutUnitConstraint) || upperNode_0.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT) && lowerNode_0.type_0 == NORMAL || lowerNode_0.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT) && upperNode_0.type_0 == NORMAL) return false;
    upperNode = this$static.freeLayer[upperNodeIndex];
    lowerNode = this$static.freeLayer[lowerNodeIndex];
    leftInlayer = $countInLayerCrossingsBetweenNodesInBothOrders(this$static.leftInLayerCounter, upperNode, lowerNode, ($clinit_PortSide(), WEST_0));
    rightInlayer = $countInLayerCrossingsBetweenNodesInBothOrders(this$static.rightInLayerCounter, upperNode, lowerNode, EAST_0);
    $countCrossings(this$static.northSouthCounter, upperNode, lowerNode);
    upperLowerCrossings = $getCrossingMatrixEntry(this$static.crossingMatrixFiller, upperNode, lowerNode) + castTo(leftInlayer.first, 17).value_0 + castTo(rightInlayer.first, 17).value_0 + this$static.northSouthCounter.upperLowerCrossings;
    lowerUpperCrossings = $getCrossingMatrixEntry(this$static.crossingMatrixFiller, lowerNode, upperNode) + castTo(leftInlayer.second, 17).value_0 + castTo(rightInlayer.second, 17).value_0 + this$static.northSouthCounter.lowerUpperCrossings;
    if (this$static.countCrossingsCausedByPortSwitch) {
        upperPort = castTo($getProperty(upperNode, ORIGIN_0), 11);
        lowerPort = castTo($getProperty(lowerNode, ORIGIN_0), 11);
        crossingNumbers = $countCrossingsBetweenPortsInBothOrders(this$static.parentCrossCounter, upperPort, lowerPort);
        upperLowerCrossings += castTo(crossingNumbers.first, 17).value_0;
        lowerUpperCrossings += castTo(crossingNumbers.second, 17).value_0;
    }
    return upperLowerCrossings > lowerUpperCrossings;
}
function $hasEdgesOnSide(node, side) {
    var port, port$iterator, ports;
    ports = $getPortSideView(node, side);
    for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        if ($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)) != null || $hasNext_6(new LPort$CombineIter$1(port.connectedEdges))) return true;
    }
    return false;
}
function $initParentCrossingsCounters(this$static, freeLayerIndex, length_0) {
    var leftLayer, middleLayer, parentGraphData, parentNodeLayerPos, parentNodeOrder, portPos, rightLayer, rightMostLayer;
    parentGraphData = this$static.graphData.parentGraphData;
    parentNodeOrder = parentGraphData.currentNodeOrder;
    portPos = parentGraphData.portPositions;
    this$static.parentCrossCounter = new CrossingsCounter(portPos);
    parentNodeLayerPos = this$static.graphData.parent_0.layer.id_0;
    leftLayer = parentNodeLayerPos > 0 ? parentNodeOrder[parentNodeLayerPos - 1] : initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, 0, 0, 1);
    middleLayer = parentNodeOrder[parentNodeLayerPos];
    rightLayer = parentNodeLayerPos < parentNodeOrder.length - 1 ? parentNodeOrder[parentNodeLayerPos + 1] : initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, 0, 0, 1);
    rightMostLayer = freeLayerIndex == length_0 - 1;
    rightMostLayer ? $initForCountingBetween(this$static.parentCrossCounter, middleLayer, rightLayer) : $initForCountingBetween(this$static.parentCrossCounter, leftLayer, middleLayer);
}
function $notifyOfSwitch(this$static, upperNode, lowerNode) {
    var lowerPort, upperPort;
    $switchNodes(this$static.leftInLayerCounter, upperNode, lowerNode, ($clinit_PortSide(), WEST_0));
    $switchNodes(this$static.rightInLayerCounter, upperNode, lowerNode, EAST_0);
    if (this$static.countCrossingsCausedByPortSwitch) {
        upperPort = castTo($getProperty(upperNode, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
        lowerPort = castTo($getProperty(lowerNode, ORIGIN_0), 11);
        $switchPorts(this$static.parentCrossCounter, upperPort, lowerPort);
    }
}
function SwitchDecider(freeLayerIndex, graph, crossingMatrixFiller, portPositions, graphData, oneSided) {
    this.crossingMatrixFiller = crossingMatrixFiller;
    this.graphData = graphData;
    if (freeLayerIndex >= graph.length) throw toJs(new IndexOutOfBoundsException_0('Greedy SwitchDecider: Free layer not in graph.'));
    this.freeLayer = graph[freeLayerIndex];
    this.leftInLayerCounter = new CrossingsCounter(portPositions);
    $initPortPositionsForInLayerCrossings(this.leftInLayerCounter, this.freeLayer, ($clinit_PortSide(), WEST_0));
    this.rightInLayerCounter = new CrossingsCounter(portPositions);
    $initPortPositionsForInLayerCrossings(this.rightInLayerCounter, this.freeLayer, EAST_0);
    this.northSouthCounter = new NorthSouthEdgeNeighbouringNodeCrossingsCounter(this.freeLayer);
    this.countCrossingsCausedByPortSwitch = !oneSided && graphData.hasParent && !graphData.useBottomUp && this.freeLayer[0].type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT);
    this.countCrossingsCausedByPortSwitch && $initParentCrossingsCounters(this, freeLayerIndex, graph.length);
}
defineClass(1962, 1, {}, SwitchDecider);
_.countCrossingsCausedByPortSwitch = false;
var Lorg_eclipse_elk_alg_layered_intermediate_greedyswitch_SwitchDecider_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.greedyswitch', 'SwitchDecider', 1962);
function $addSelfLoopEdge(this$static, slEdge) {
    var lLabels, slSource, slTarget;
    if ($add_6(this$static.slEdges, slEdge)) {
        slEdge.slHyperLoop = this$static;
        slSource = slEdge.slSource;
        $indexOf_3(this$static.slPorts, slSource, 0) != -1 || $add_3(this$static.slPorts, slSource);
        slTarget = slEdge.slTarget;
        $indexOf_3(this$static.slPorts, slTarget, 0) != -1 || $add_3(this$static.slPorts, slTarget);
        lLabels = slEdge.lEdge.labels;
        if (lLabels.array.length != 0) {
            !this$static.slLabels && (this$static.slLabels = new SelfHyperLoopLabels(this$static));
            $addLLabels(this$static.slLabels, lLabels);
        }
    }
}
function $computePortsPerSide(this$static) {
    var portSide, slPort, slPort$iterator;
    this$static.slPortsBySide = new ArrayListMultimap_0(($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])).length, this$static.slPorts.array.length);
    for(slPort$iterator = new ArrayList$1(this$static.slPorts); slPort$iterator.i < slPort$iterator.this$01.array.length;){
        slPort = castTo($next_6(slPort$iterator), 112);
        portSide = slPort.lPort.side;
        $put(this$static.slPortsBySide, portSide, slPort);
    }
    this$static.selfLoopType = fromPortSides($keySet(this$static.slPortsBySide));
}
function $setLeftmostPort(this$static, leftmostPort) {
    this$static.leftmostPort = leftmostPort;
}
function $setRightmostPort(this$static, rightmostPort) {
    this$static.rightmostPort = rightmostPort;
}
function $setRoutingSlot(this$static, portSide, slot) {
    var slotCount;
    this$static.routingSlot[portSide.ordinal] = slot;
    slotCount = this$static.slHolder.routingSlotCount;
    slotCount[portSide.ordinal] = $wnd.Math.max(slotCount[portSide.ordinal], slot + 1);
}
function SelfHyperLoop(slHolder) {
    var all;
    this.slPorts = new ArrayList;
    this.slEdges = new HashSet;
    this.occupiedPortSides = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    this.routingSlot = initUnidimensionalArray(I_classLit, $intern_48, 30, ($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])).length, 15, 1);
    this.slHolder = slHolder;
}
defineClass(105, 1, {
    105: 1
}, SelfHyperLoop);
_.leftmostPort = null;
_.rightmostPort = null;
_.slLabels = null;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfHyperLoop_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfHyperLoop', 105);
function $addLLabels(this$static, newLLabels) {
    var newLLabel, newLLabel$iterator;
    for(newLLabel$iterator = new ArrayList$1(newLLabels); newLLabel$iterator.i < newLLabel$iterator.this$01.array.length;){
        newLLabel = castTo($next_6(newLLabel$iterator), 72);
        $add_3(this$static.lLabels, newLLabel);
        $updateSize(this$static, newLLabel);
    }
}
function $applyPlacement(this$static, offset) {
    $isHorizontal(this$static.layoutDirection) ? $applyPlacementForHorizontalLayout(this$static, offset) : $applyPlacementVerticalForVerticalLayout(this$static, offset);
}
function $applyPlacementForHorizontalLayout(this$static, offset) {
    var lLabel, lLabel$iterator, labelPos, x_0, y_0;
    x_0 = this$static.position.x_0;
    y_0 = this$static.position.y_0;
    for(lLabel$iterator = new ArrayList$1(this$static.lLabels); lLabel$iterator.i < lLabel$iterator.this$01.array.length;){
        lLabel = castTo($next_6(lLabel$iterator), 72);
        labelPos = lLabel.pos;
        this$static.alignment == ($clinit_SelfHyperLoopLabels$Alignment(), LEFT_1) || this$static.side == ($clinit_PortSide(), EAST_0) ? labelPos.x_0 = x_0 : this$static.alignment == RIGHT_1 || this$static.side == ($clinit_PortSide(), WEST_0) ? labelPos.x_0 = x_0 + this$static.size_0.x_0 - lLabel.size_0.x_0 : labelPos.x_0 = x_0 + (this$static.size_0.x_0 - lLabel.size_0.x_0) / 2;
        labelPos.y_0 = y_0;
        $add_19(labelPos, offset);
        y_0 += lLabel.size_0.y_0 + this$static.labelLabelSpacing;
    }
}
function $applyPlacementVerticalForVerticalLayout(this$static, offset) {
    var lLabel, lLabel$iterator, labelPos, x_0, y_0;
    x_0 = this$static.position.x_0;
    y_0 = this$static.position.y_0;
    for(lLabel$iterator = new ArrayList$1(this$static.lLabels); lLabel$iterator.i < lLabel$iterator.this$01.array.length;){
        lLabel = castTo($next_6(lLabel$iterator), 72);
        labelPos = lLabel.pos;
        labelPos.x_0 = x_0;
        this$static.side == ($clinit_PortSide(), NORTH_1) ? labelPos.y_0 = y_0 + this$static.size_0.y_0 - lLabel.size_0.y_0 : labelPos.y_0 = y_0;
        $add_19(labelPos, offset);
        x_0 += lLabel.size_0.x_0 + this$static.labelLabelSpacing;
    }
}
function $updateSize(this$static, newLLabel) {
    var newLLabelSize;
    newLLabelSize = newLLabel.size_0;
    if ($isHorizontal(this$static.layoutDirection)) {
        this$static.size_0.x_0 = $wnd.Math.max(this$static.size_0.x_0, newLLabelSize.x_0);
        this$static.size_0.y_0 += newLLabelSize.y_0;
        this$static.lLabels.array.length > 1 && (this$static.size_0.y_0 += this$static.labelLabelSpacing);
    } else {
        this$static.size_0.x_0 += newLLabelSize.x_0;
        this$static.size_0.y_0 = $wnd.Math.max(this$static.size_0.y_0, newLLabelSize.y_0);
        this$static.lLabels.array.length > 1 && (this$static.size_0.x_0 += this$static.labelLabelSpacing);
    }
}
function SelfHyperLoopLabels(slLoop) {
    var lNode;
    this.lLabels = new ArrayList;
    this.size_0 = new KVector;
    this.position = new KVector;
    lNode = slLoop.slHolder.lNode;
    this.layoutDirection = castTo($getProperty($getGraph(lNode), ($clinit_LayeredOptions(), DIRECTION)), 86);
    this.labelLabelSpacing = $doubleValue(castToDouble(getIndividualOrInherited(lNode, SPACING_LABEL_LABEL)));
}
defineClass(1959, 1, {}, SelfHyperLoopLabels);
_.id_0 = 0;
_.labelLabelSpacing = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfHyperLoopLabels_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfHyperLoopLabels', 1959);
function $clinit_SelfHyperLoopLabels$Alignment() {
    $clinit_SelfHyperLoopLabels$Alignment = emptyMethod;
    CENTER_2 = new SelfHyperLoopLabels$Alignment('CENTER', 0);
    LEFT_1 = new SelfHyperLoopLabels$Alignment('LEFT', 1);
    RIGHT_1 = new SelfHyperLoopLabels$Alignment('RIGHT', 2);
    TOP_0 = new SelfHyperLoopLabels$Alignment('TOP', 3);
}
function SelfHyperLoopLabels$Alignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_26(name_0) {
    $clinit_SelfHyperLoopLabels$Alignment();
    return valueOf(($clinit_SelfHyperLoopLabels$Alignment$Map(), $MAP_16), name_0);
}
function values_34() {
    $clinit_SelfHyperLoopLabels$Alignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfHyperLoopLabels$Alignment_2_classLit, 1), $intern_36, 410, 0, [
        CENTER_2,
        LEFT_1,
        RIGHT_1,
        TOP_0
    ]);
}
defineClass(410, 23, {
    3: 1,
    34: 1,
    23: 1,
    410: 1
}, SelfHyperLoopLabels$Alignment);
var CENTER_2, LEFT_1, RIGHT_1, TOP_0;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfHyperLoopLabels$Alignment_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfHyperLoopLabels/Alignment', 410, Ljava_lang_Enum_2_classLit, values_34, valueOf_26);
function $clinit_SelfHyperLoopLabels$Alignment$Map() {
    $clinit_SelfHyperLoopLabels$Alignment$Map = emptyMethod;
    $MAP_16 = createValueOfMap(($clinit_SelfHyperLoopLabels$Alignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfHyperLoopLabels$Alignment_2_classLit, 1), $intern_36, 410, 0, [
        CENTER_2,
        LEFT_1,
        RIGHT_1,
        TOP_0
    ])));
}
var $MAP_16;
function SelfLoopEdge(lEdge, slSource, slTarget) {
    this.lEdge = lEdge;
    this.slSource = slSource;
    this.slTarget = slTarget;
    $add_3(slSource.outgoingSLEdges, this);
    $add_3(slTarget.incomingSLEdges, this);
}
defineClass(336, 1, {
    336: 1
}, SelfLoopEdge);
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopEdge_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfLoopEdge', 336);
function $initialize_3(this$static) {
    var entry, lEdge, lEdge$iterator, outerIter, outerIter0, slEdges, slPort, slPort$iterator, slPort$iterator0;
    slEdges = new ArrayList;
    for(lEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(this$static.lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(lEdge$iterator);){
        lEdge = castTo($next_0(lEdge$iterator), 18);
        $isSelfLoop(lEdge) && $add_3(slEdges, new SelfLoopEdge(lEdge, $selfLoopPortFor(this$static, lEdge.source), $selfLoopPortFor(this$static, lEdge.target)));
    }
    for(slPort$iterator0 = (outerIter0 = new AbstractMap$2(this$static.slPorts).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter0)); slPort$iterator0.val$outerIter2.hasNext_0();){
        slPort = (entry = castTo(slPort$iterator0.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 112));
        slPort.lPort.id_0 = 0;
    }
    for(slPort$iterator = (outerIter = new AbstractMap$2(this$static.slPorts).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter)); slPort$iterator.val$outerIter2.hasNext_0();){
        slPort = (entry = castTo(slPort$iterator.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 112));
        slPort.lPort.id_0 == 0 && $add_3(this$static.slHyperLoops, $initializeHyperLoop(this$static, slPort));
    }
}
function $initializeHyperLoop(this$static, slPort) {
    var bfsQueue, currentSLPort, slEdge, slEdge$iterator, slEdge$iterator0, slLoop, slSourcePort, slTargetPort;
    slLoop = new SelfHyperLoop(this$static);
    bfsQueue = new LinkedList;
    $addNode_0(bfsQueue, slPort, bfsQueue.tail.prev, bfsQueue.tail);
    while(bfsQueue.size_0 != 0){
        currentSLPort = castTo(bfsQueue.size_0 == 0 ? null : (checkCriticalElement(bfsQueue.size_0 != 0), $removeNode_0(bfsQueue, bfsQueue.header.next_0)), 112);
        currentSLPort.lPort.id_0 = 1;
        for(slEdge$iterator0 = new ArrayList$1(currentSLPort.outgoingSLEdges); slEdge$iterator0.i < slEdge$iterator0.this$01.array.length;){
            slEdge = castTo($next_6(slEdge$iterator0), 336);
            $addSelfLoopEdge(slLoop, slEdge);
            slTargetPort = slEdge.slTarget;
            slTargetPort.lPort.id_0 == 0 && $addNode_0(bfsQueue, slTargetPort, bfsQueue.tail.prev, bfsQueue.tail);
        }
        for(slEdge$iterator = new ArrayList$1(currentSLPort.incomingSLEdges); slEdge$iterator.i < slEdge$iterator.this$01.array.length;){
            slEdge = castTo($next_6(slEdge$iterator), 336);
            $addSelfLoopEdge(slLoop, slEdge);
            slSourcePort = slEdge.slSource;
            slSourcePort.lPort.id_0 == 0 && $addNode_0(bfsQueue, slSourcePort, bfsQueue.tail.prev, bfsQueue.tail);
        }
    }
    return slLoop;
}
function $selfLoopPortFor(this$static, lport) {
    $containsKey_6(this$static.slPorts, lport) || $put_11(this$static.slPorts, lport, new SelfLoopPort(lport));
    return castTo($get_16(this$static.slPorts, lport), 112);
}
function SelfLoopHolder(node) {
    this.slHyperLoops = new ArrayList;
    this.slPorts = new LinkedHashMap;
    this.routingSlotCount = initUnidimensionalArray(I_classLit, $intern_48, 30, ($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])).length, 15, 1);
    this.lNode = node;
}
function needsSelfLoopProcessing(lNode) {
    if (lNode.type_0 != ($clinit_LNode$NodeType(), NORMAL)) return false;
    return $anyMatch(new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(lNode).val$inputs1.iterator_0(), new Iterables$10)))), new SelfLoopHolder$lambda$0$Type);
}
defineClass(333, 1, {
    333: 1
}, SelfLoopHolder);
_.arePortsHidden = false;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopHolder_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfLoopHolder', 333);
function SelfLoopHolder$lambda$0$Type() {}
defineClass(1736, 1, $intern_39, SelfLoopHolder$lambda$0$Type);
_.test_0 = function test_63(arg0) {
    return $isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopHolder$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfLoopHolder/lambda$0$Type', 1736);
function $getSLNetFlow(this$static) {
    return this$static.incomingSLEdges.array.length - this$static.outgoingSLEdges.array.length;
}
function SelfLoopPort(lPort) {
    this.incomingSLEdges = new ArrayList;
    this.outgoingSLEdges = new ArrayList;
    this.lPort = lPort;
    this.hadOnlySelfLoops = !$spliterator($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new LPort$CombineIter$1(lPort.connectedEdges))), new Predicate$lambda$2$Type(new SelfLoopPort$lambda$0$Type))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER));
}
defineClass(112, 1, {
    112: 1
}, SelfLoopPort);
_.hadOnlySelfLoops = false;
_.isHidden = false;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopPort_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfLoopPort', 112);
function SelfLoopPort$lambda$0$Type() {}
defineClass(1801, 1, $intern_39, SelfLoopPort$lambda$0$Type);
_.test_0 = function test_64(arg0) {
    return $isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopPort$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfLoopPort/lambda$0$Type', 1801);
function $clinit_SelfLoopType() {
    $clinit_SelfLoopType = emptyMethod;
    ONE_SIDE = new SelfLoopType('ONE_SIDE', 0);
    TWO_SIDES_CORNER = new SelfLoopType('TWO_SIDES_CORNER', 1);
    TWO_SIDES_OPPOSING = new SelfLoopType('TWO_SIDES_OPPOSING', 2);
    THREE_SIDES = new SelfLoopType('THREE_SIDES', 3);
    FOUR_SIDES = new SelfLoopType('FOUR_SIDES', 4);
}
function SelfLoopType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function fromPortSides(portSides) {
    $clinit_SelfLoopType();
    var eastWest, northSouth;
    if (portSides.contains(($clinit_PortSide(), UNDEFINED_5))) throw toJs(new IllegalArgumentException_0('Port sides must not contain UNDEFINED'));
    switch(portSides.size_1()){
        case 1:
            return ONE_SIDE;
        case 2:
            eastWest = portSides.contains(EAST_0) && portSides.contains(WEST_0);
            northSouth = portSides.contains(NORTH_1) && portSides.contains(SOUTH_0);
            return eastWest || northSouth ? TWO_SIDES_OPPOSING : TWO_SIDES_CORNER;
        case 3:
            return THREE_SIDES;
        case 4:
            return FOUR_SIDES;
        default:
            return null;
    }
}
function valueOf_27(name_0) {
    $clinit_SelfLoopType();
    return valueOf(($clinit_SelfLoopType$Map(), $MAP_17), name_0);
}
function values_35() {
    $clinit_SelfLoopType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopType_2_classLit, 1), $intern_36, 368, 0, [
        ONE_SIDE,
        TWO_SIDES_CORNER,
        TWO_SIDES_OPPOSING,
        THREE_SIDES,
        FOUR_SIDES
    ]);
}
defineClass(368, 23, {
    3: 1,
    34: 1,
    23: 1,
    368: 1
}, SelfLoopType);
var FOUR_SIDES, ONE_SIDE, THREE_SIDES, TWO_SIDES_CORNER, TWO_SIDES_OPPOSING;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopType_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate.loops', 'SelfLoopType', 368, Ljava_lang_Enum_2_classLit, values_35, valueOf_27);
function $clinit_SelfLoopType$Map() {
    $clinit_SelfLoopType$Map = emptyMethod;
    $MAP_17 = createValueOfMap(($clinit_SelfLoopType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_SelfLoopType_2_classLit, 1), $intern_36, 368, 0, [
        ONE_SIDE,
        TWO_SIDES_CORNER,
        TWO_SIDES_OPPOSING,
        THREE_SIDES,
        FOUR_SIDES
    ])));
}
var $MAP_17;
function $clinit_PortRestorer() {
    $clinit_PortRestorer = emptyMethod;
    NES = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        ($clinit_PortSide(), NORTH_1),
        EAST_0,
        SOUTH_0
    ]);
    ESW = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        EAST_0,
        SOUTH_0,
        WEST_0
    ]);
    SWN = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        SOUTH_0,
        WEST_0,
        NORTH_1
    ]);
    WNE = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        WEST_0,
        NORTH_1,
        EAST_0
    ]);
}
function $addAll_5(slPorts, lNode) {
    $forEach_3($map(slPorts.stream(), new PortRestorer$lambda$11$Type), new PortRestorer$lambda$12$Type(lNode));
}
function $addAllThat(lPorts, fromIndex, condition, target) {
    var i, lPort;
    for(i = fromIndex; i < lPorts.array.length; i++){
        lPort = (checkCriticalElementIndex(i, lPorts.array.length), castTo(lPorts.array[i], 11));
        if (condition.test_0(lPort)) push_1(target.array, lPort);
        else return i;
    }
    return lPorts.array.length;
}
function $addToTargetArea(this$static, slPorts, portSide, area, addMode) {
    var hiddenPorts, targetArea;
    hiddenPorts = castTo($collect_1($filter(slPorts.stream(), new PortRestorer$lambda$4$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    reverse_2(hiddenPorts);
    targetArea = castTo($get_1(this$static.targetAreas, portSide, area), 15);
    addMode == 0 ? targetArea.addAll_0(0, hiddenPorts) : targetArea.addAll(hiddenPorts);
}
function $addToTargetArea_0(this$static, slLoop, portSide, area, addMode) {
    $addToTargetArea(this$static, castTo($get(slLoop.slPortsBySide, portSide), 15), portSide, area, addMode);
}
function $computePortListSplitIndex(sortedPorts) {
    var nonNegativeNetFlowIndex, positiveNetFlowIndex;
    positiveNetFlowIndex = 0;
    for(; positiveNetFlowIndex < sortedPorts.array.length; positiveNetFlowIndex++){
        if ($getSLNetFlow((checkCriticalElementIndex(positiveNetFlowIndex, sortedPorts.array.length), castTo(sortedPorts.array[positiveNetFlowIndex], 112))) > 0) break;
    }
    if (positiveNetFlowIndex > 0 && positiveNetFlowIndex < sortedPorts.array.length - 1) return positiveNetFlowIndex;
    nonNegativeNetFlowIndex = 0;
    for(; nonNegativeNetFlowIndex < sortedPorts.array.length; nonNegativeNetFlowIndex++){
        if ($getSLNetFlow((checkCriticalElementIndex(nonNegativeNetFlowIndex, sortedPorts.array.length), castTo(sortedPorts.array[nonNegativeNetFlowIndex], 112))) > 0) break;
    }
    if (nonNegativeNetFlowIndex > 0 && positiveNetFlowIndex < sortedPorts.array.length - 1) return nonNegativeNetFlowIndex;
    return sortedPorts.array.length / 2 | 0;
}
function $initTargetAreas(this$static) {
    var area, area$array, area$index, area$max, side, side$array, side$index, side$max;
    this$static.targetAreas = new ArrayTable(new Arrays$ArrayList(($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ]))), new Arrays$ArrayList(($clinit_PortRestorer$PortSideArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$PortSideArea_2_classLit, 1), $intern_36, 365, 0, [
        START,
        MIDDLE,
        END_0
    ]))));
    for(side$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ]), side$index = 0, side$max = side$array.length; side$index < side$max; ++side$index){
        side = side$array[side$index];
        for(area$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$PortSideArea_2_classLit, 1), $intern_36, 365, 0, [
            START,
            MIDDLE,
            END_0
        ]), area$index = 0, area$max = area$array.length; area$index < area$max; ++area$index){
            area = area$array[area$index];
            $put_0(this$static.targetAreas, side, area, new ArrayList);
        }
    }
}
function $lambda$5(lPort_0) {
    var connections, eastConnections, westConnections;
    return lPort_0.side == ($clinit_PortSide(), NORTH_1) && (connections = $northSouthPortConnectionSides(lPort_0), eastConnections = $containsEnum(connections, EAST_0), westConnections = $containsEnum(connections, WEST_0), westConnections || westConnections && eastConnections);
}
function $lambda$8(lPort_0) {
    var connections;
    return lPort_0.side == ($clinit_PortSide(), SOUTH_0) && (connections = $northSouthPortConnectionSides(lPort_0), $containsEnum(connections, EAST_0));
}
function $northSouthPortConnectionSides(lPort) {
    var all, connectionSides, dummyLPort, dummyLPort$iterator, portDummy;
    connectionSides = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    portDummy = castTo($getProperty(lPort, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
    if (portDummy) for(dummyLPort$iterator = new ArrayList$1(portDummy.ports); dummyLPort$iterator.i < dummyLPort$iterator.this$01.array.length;){
        dummyLPort = castTo($next_6(dummyLPort$iterator), 11);
        maskUndefined($getProperty(dummyLPort, ORIGIN_0)) === maskUndefined(lPort) && $hasNext_6(new LPort$CombineIter$1(dummyLPort.connectedEdges)) && $add_5(connectionSides, dummyLPort.side);
    }
    return connectionSides;
}
function $processFourSideLoops(this$static) {
    var side, side$iterator, slLoop, slLoop$iterator;
    for(slLoop$iterator = castTo($get(this$static.slLoopsByType, ($clinit_SelfLoopType(), FOUR_SIDES)), 15).iterator_0(); slLoop$iterator.hasNext_0();){
        slLoop = castTo(slLoop$iterator.next_1(), 105);
        for(side$iterator = $keySet(slLoop.slPortsBySide).iterator_0(); side$iterator.hasNext_0();){
            side = castTo(side$iterator.next_1(), 64);
            $addToTargetArea_0(this$static, slLoop, side, ($clinit_PortRestorer$PortSideArea(), MIDDLE), 1);
        }
    }
}
function $processOneSideLoops(this$static, ordering) {
    var side, slLoop, slLoop$iterator, sortedPorts, splitIndex;
    ordering == ($clinit_SelfLoopOrderingStrategy(), REVERSE_STACKED) && reverse_2(castTo($get(this$static.slLoopsByType, ($clinit_SelfLoopType(), ONE_SIDE)), 15));
    for(slLoop$iterator = castTo($get(this$static.slLoopsByType, ($clinit_SelfLoopType(), ONE_SIDE)), 15).iterator_0(); slLoop$iterator.hasNext_0();){
        slLoop = castTo(slLoop$iterator.next_1(), 105);
        side = castTo($get_11(slLoop.slPorts, 0), 112).lPort.side;
        sortedPorts = new ArrayList_1(slLoop.slPorts);
        $sort(sortedPorts, new PortRestorer$lambda$3$Type);
        switch(ordering.ordinal){
            case 2:
                $addToTargetArea(this$static, sortedPorts, side, ($clinit_PortRestorer$PortSideArea(), MIDDLE), 1);
                break;
            case 1:
            case 0:
                splitIndex = $computePortListSplitIndex(sortedPorts);
                $addToTargetArea(this$static, new AbstractList$SubList(sortedPorts, 0, splitIndex), side, ($clinit_PortRestorer$PortSideArea(), MIDDLE), 0);
                $addToTargetArea(this$static, new AbstractList$SubList(sortedPorts, splitIndex, sortedPorts.array.length), side, MIDDLE, 1);
        }
    }
}
function $processThreeSideLoops(this$static) {
    var portSides, sides, slLoop, slLoop$iterator;
    for(slLoop$iterator = castTo($get(this$static.slLoopsByType, ($clinit_SelfLoopType(), THREE_SIDES)), 15).iterator_0(); slLoop$iterator.hasNext_0();){
        slLoop = castTo(slLoop$iterator.next_1(), 105);
        sides = (portSides = $keySet(slLoop.slPortsBySide), portSides.contains(($clinit_PortSide(), NORTH_1)) ? portSides.contains(EAST_0) ? portSides.contains(SOUTH_0) ? portSides.contains(WEST_0) ? null : NES : WNE : SWN : ESW);
        $addToTargetArea_0(this$static, slLoop, sides[0], ($clinit_PortRestorer$PortSideArea(), END_0), 0);
        $addToTargetArea_0(this$static, slLoop, sides[1], MIDDLE, 1);
        $addToTargetArea_0(this$static, slLoop, sides[2], START, 1);
    }
}
function $processTwoSideCornerLoops(this$static) {
    var sides, slLoop, slLoop$iterator;
    for(slLoop$iterator = castTo($get(this$static.slLoopsByType, ($clinit_SelfLoopType(), TWO_SIDES_CORNER)), 15).iterator_0(); slLoop$iterator.hasNext_0();){
        slLoop = castTo(slLoop$iterator.next_1(), 105);
        sides = sortedTwoSideLoopPortSides(slLoop);
        $addToTargetArea_0(this$static, slLoop, sides[0], ($clinit_PortRestorer$PortSideArea(), END_0), 0);
        $addToTargetArea_0(this$static, slLoop, sides[1], START, 1);
    }
}
function $processTwoSideOpposingLoops(this$static) {
    var sides, slLoop, slLoop$iterator;
    for(slLoop$iterator = castTo($get(this$static.slLoopsByType, ($clinit_SelfLoopType(), TWO_SIDES_OPPOSING)), 15).iterator_0(); slLoop$iterator.hasNext_0();){
        slLoop = castTo(slLoop$iterator.next_1(), 105);
        sides = sortedTwoSideLoopPortSides(slLoop);
        $addToTargetArea_0(this$static, slLoop, sides[0], ($clinit_PortRestorer$PortSideArea(), END_0), 0);
        $addToTargetArea_0(this$static, slLoop, sides[1], START, 1);
    }
}
function $restorePorts(this$static, slHolder) {
    var lNode, newPortList, nextOldPortIndex, oldPortList;
    lNode = slHolder.lNode;
    oldPortList = new ArrayList_1(lNode.ports);
    nextOldPortIndex = 0;
    newPortList = lNode.ports;
    newPortList.array.length = 0;
    $addAll_5(castTo($get_1(this$static.targetAreas, ($clinit_PortSide(), NORTH_1), ($clinit_PortRestorer$PortSideArea(), START)), 15), lNode);
    nextOldPortIndex = $addAllThat(oldPortList, nextOldPortIndex, new PortRestorer$lambda$5$Type, newPortList);
    $addAll_5(castTo($get_1(this$static.targetAreas, NORTH_1, MIDDLE), 15), lNode);
    nextOldPortIndex = $addAllThat(oldPortList, nextOldPortIndex, new PortRestorer$lambda$6$Type, newPortList);
    $addAll_5(castTo($get_1(this$static.targetAreas, NORTH_1, END_0), 15), lNode);
    $addAll_5(castTo($get_1(this$static.targetAreas, EAST_0, START), 15), lNode);
    $addAll_5(castTo($get_1(this$static.targetAreas, EAST_0, MIDDLE), 15), lNode);
    nextOldPortIndex = $addAllThat(oldPortList, nextOldPortIndex, new PortRestorer$lambda$7$Type, newPortList);
    $addAll_5(castTo($get_1(this$static.targetAreas, EAST_0, END_0), 15), lNode);
    $addAll_5(castTo($get_1(this$static.targetAreas, SOUTH_0, START), 15), lNode);
    nextOldPortIndex = $addAllThat(oldPortList, nextOldPortIndex, new PortRestorer$lambda$8$Type, newPortList);
    $addAll_5(castTo($get_1(this$static.targetAreas, SOUTH_0, MIDDLE), 15), lNode);
    nextOldPortIndex = $addAllThat(oldPortList, nextOldPortIndex, new PortRestorer$lambda$9$Type, newPortList);
    $addAll_5(castTo($get_1(this$static.targetAreas, SOUTH_0, END_0), 15), lNode);
    $addAll_5(castTo($get_1(this$static.targetAreas, WEST_0, START), 15), lNode);
    nextOldPortIndex = $addAllThat(oldPortList, nextOldPortIndex, new PortRestorer$lambda$10$Type, newPortList);
    $addAll_5(castTo($get_1(this$static.targetAreas, WEST_0, MIDDLE), 15), lNode);
    $addAll_5(castTo($get_1(this$static.targetAreas, WEST_0, END_0), 15), lNode);
}
function $restorePorts_0(this$static, slHolder) {
    var loops;
    $initTargetAreas(this$static);
    this$static.slLoopsByType = (loops = new ArrayListMultimap, $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new PortRestorer$lambda$2$Type(loops)), loops);
    $processOneSideLoops(this$static, castTo($getProperty(slHolder.lNode, ($clinit_LayeredOptions(), EDGE_ROUTING_SELF_LOOP_ORDERING_0)), 345));
    $processTwoSideCornerLoops(this$static);
    $processThreeSideLoops(this$static);
    $processFourSideLoops(this$static);
    $processTwoSideOpposingLoops(this$static);
    $restorePorts(this$static, slHolder);
    $forEach_3($flatMap(new StreamImpl(null, $valuesSpliterator($values_1(this$static.targetAreas).this$01)), new PortRestorer$lambda$0$Type), new PortRestorer$lambda$1$Type);
    slHolder.arePortsHidden = false;
    this$static.slLoopsByType = null;
}
function PortRestorer() {
    $clinit_PortRestorer();
}
function lambda$12(lNode_0, lPort_1) {
    $clinit_PortRestorer();
    $setNode(lPort_1, lNode_0);
}
function lambda$2_7(loops_0, slLoop_1) {
    $clinit_PortRestorer();
    return $put(loops_0, slLoop_1.selfLoopType, slLoop_1);
}
function lambda$3_4(slPort1_0, slPort2_1) {
    $clinit_PortRestorer();
    return compare_5(slPort1_0.incomingSLEdges.array.length - slPort1_0.outgoingSLEdges.array.length, slPort2_1.incomingSLEdges.array.length - slPort2_1.outgoingSLEdges.array.length);
}
function sortedTwoSideLoopPortSides(slLoop) {
    $clinit_PortRestorer();
    var sides;
    sides = castTo($toArray_0($keySet(slLoop.slPortsBySide), initUnidimensionalArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, $intern_100, 64, 2, 0, 1)), 125);
    mergeSort(sides, 0, sides.length, null);
    if (sides[0] == ($clinit_PortSide(), NORTH_1) && sides[1] == WEST_0) {
        setCheck(sides, 0, WEST_0);
        setCheck(sides, 1, NORTH_1);
    }
    return sides;
}
defineClass(1744, 1, {}, PortRestorer);
var ESW, NES, SWN, WNE;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer', 1744);
function $clinit_PortRestorer$PortSideArea() {
    $clinit_PortRestorer$PortSideArea = emptyMethod;
    START = new PortRestorer$PortSideArea('START', 0);
    MIDDLE = new PortRestorer$PortSideArea('MIDDLE', 1);
    END_0 = new PortRestorer$PortSideArea('END', 2);
}
function PortRestorer$PortSideArea(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_28(name_0) {
    $clinit_PortRestorer$PortSideArea();
    return valueOf(($clinit_PortRestorer$PortSideArea$Map(), $MAP_18), name_0);
}
function values_36() {
    $clinit_PortRestorer$PortSideArea();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$PortSideArea_2_classLit, 1), $intern_36, 365, 0, [
        START,
        MIDDLE,
        END_0
    ]);
}
defineClass(365, 23, {
    3: 1,
    34: 1,
    23: 1,
    365: 1
}, PortRestorer$PortSideArea);
var END_0, MIDDLE, START;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$PortSideArea_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/PortSideArea', 365, Ljava_lang_Enum_2_classLit, values_36, valueOf_28);
function $clinit_PortRestorer$PortSideArea$Map() {
    $clinit_PortRestorer$PortSideArea$Map = emptyMethod;
    $MAP_18 = createValueOfMap(($clinit_PortRestorer$PortSideArea(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$PortSideArea_2_classLit, 1), $intern_36, 365, 0, [
        START,
        MIDDLE,
        END_0
    ])));
}
var $MAP_18;
function PortRestorer$lambda$0$Type() {}
defineClass(1745, 1, {}, PortRestorer$lambda$0$Type);
_.apply_0 = function apply_96(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 15).stream();
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$0$Type', 1745);
function PortRestorer$lambda$1$Type() {}
defineClass(1746, 1, $intern_19, PortRestorer$lambda$1$Type);
_.accept = function accept_105(arg0) {
    $clinit_PortRestorer();
    castTo(arg0, 112).isHidden = false;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$1$Type', 1746);
function PortRestorer$lambda$10$Type() {}
defineClass(1755, 1, $intern_39, PortRestorer$lambda$10$Type);
_.test_0 = function test_65(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 11).side == ($clinit_PortSide(), WEST_0);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$10$Type', 1755);
function PortRestorer$lambda$11$Type() {}
defineClass(1756, 1, {}, PortRestorer$lambda$11$Type);
_.apply_0 = function apply_97(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 112).lPort;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$11$Type', 1756);
function PortRestorer$lambda$12$Type(lNode_0) {
    this.lNode_0 = lNode_0;
}
defineClass(1757, 1, $intern_19, PortRestorer$lambda$12$Type);
_.accept = function accept_106(arg0) {
    lambda$12(this.lNode_0, castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$12$Type', 1757);
function PortRestorer$lambda$2$Type(loops_0) {
    this.loops_0 = loops_0;
}
defineClass(1747, 1, $intern_19, PortRestorer$lambda$2$Type);
_.accept = function accept_107(arg0) {
    lambda$2_7(this.loops_0, castTo(arg0, 105));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$2$Type', 1747);
function PortRestorer$lambda$3$Type() {}
defineClass(1748, 1, $intern_88, PortRestorer$lambda$3$Type);
_.compare_1 = function compare_48(arg0, arg1) {
    return lambda$3_4(castTo(arg0, 112), castTo(arg1, 112));
};
_.equals_0 = function equals_129(other) {
    return this === other;
};
_.reversed = function reversed_40() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$3$Type', 1748);
function PortRestorer$lambda$4$Type() {}
defineClass(1749, 1, $intern_39, PortRestorer$lambda$4$Type);
_.test_0 = function test_66(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 112).isHidden;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$4$Type', 1749);
function PortRestorer$lambda$5$Type() {}
defineClass(1750, 1, $intern_39, PortRestorer$lambda$5$Type);
_.test_0 = function test_67(arg0) {
    return $lambda$5(castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$5$Type', 1750);
function PortRestorer$lambda$6$Type() {}
defineClass(1751, 1, $intern_39, PortRestorer$lambda$6$Type);
_.test_0 = function test_68(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 11).side == ($clinit_PortSide(), NORTH_1);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$6$Type', 1751);
function PortRestorer$lambda$7$Type() {}
defineClass(1752, 1, $intern_39, PortRestorer$lambda$7$Type);
_.test_0 = function test_69(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 11).side == ($clinit_PortSide(), EAST_0);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$7$Type', 1752);
function PortRestorer$lambda$8$Type() {}
defineClass(1753, 1, $intern_39, PortRestorer$lambda$8$Type);
_.test_0 = function test_70(arg0) {
    return $lambda$8(castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$8$Type', 1753);
function PortRestorer$lambda$9$Type() {}
defineClass(1754, 1, $intern_39, PortRestorer$lambda$9$Type);
_.test_0 = function test_71(arg0) {
    return $clinit_PortRestorer(), castTo(arg0, 11).side == ($clinit_PortSide(), SOUTH_0);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortRestorer$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortRestorer/lambda$9$Type', 1754);
function $assignPortSides(slHolder) {
    switch(castTo($getProperty(slHolder.lNode, ($clinit_LayeredOptions(), EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_0)), 379).ordinal){
        case 1:
            $forEach_3($map($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new PortSideAssigner$lambda$1$Type), new PortSideAssigner$lambda$2$Type), new PortSideAssigner$lambda$3$Type);
            break;
        case 2:
            $assignToNorthOrSouthSide(slHolder);
            break;
        case 0:
            $assignToAllSides(slHolder);
    }
}
function $assignToAllSides(slHolder) {
    var assignmentTargets, currLoop, currTarget, slLoop, slLoop$iterator, slSortedLoops;
    slSortedLoops = new ArrayList_1(slHolder.slHyperLoops);
    $sort(slSortedLoops, new PortSideAssigner$lambda$6$Type);
    assignmentTargets = ($clinit_PortSideAssigner$Target(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$Target_2_classLit, 1), $intern_36, 272, 0, [
        NORTH,
        SOUTH,
        EAST,
        WEST,
        NORTH_WEST_CORNER,
        NORTH_EAST_CORNER,
        SOUTH_WEST_CORNER,
        SOUTH_EAST_CORNER
    ]));
    currLoop = 0;
    for(slLoop$iterator = new ArrayList$1(slSortedLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        currTarget = assignmentTargets[currLoop % assignmentTargets.length];
        $assignToTarget(slLoop, currTarget);
        ++currLoop;
    }
}
function $assignToNorthOrSouthSide(slHolder) {
    var finalNewPortSide, newPortSide, northPorts, slHiddenPorts, slLoop, slLoop$iterator, southPorts;
    northPorts = 0;
    southPorts = 0;
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        slHiddenPorts = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(slLoop.slPorts, 16)), new PortSideAssigner$lambda$8$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
            ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
        ]))), 15);
        newPortSide = null;
        if (northPorts <= southPorts) {
            newPortSide = ($clinit_PortSide(), NORTH_1);
            northPorts += slHiddenPorts.size_1();
        } else if (southPorts < northPorts) {
            newPortSide = ($clinit_PortSide(), SOUTH_0);
            southPorts += slHiddenPorts.size_1();
        }
        finalNewPortSide = newPortSide;
        $forEach_3($map(slHiddenPorts.stream(), new PortSideAssigner$lambda$4$Type), new PortSideAssigner$lambda$5$Type(finalNewPortSide));
    }
}
function $assignToTarget(slLoop, target) {
    var i, i0, secondHalfStartIndex, slPort, slPorts;
    slPorts = slLoop.slPorts;
    target.firstSide != target.secondSide && $sort(slPorts, new PortSideAssigner$lambda$7$Type);
    secondHalfStartIndex = slPorts.array.length / 2 | 0;
    for(i0 = 0; i0 < secondHalfStartIndex; i0++){
        slPort = (checkCriticalElementIndex(i0, slPorts.array.length), castTo(slPorts.array[i0], 112));
        slPort.isHidden && $setSide(slPort.lPort, target.firstSide);
    }
    for(i = secondHalfStartIndex; i < slPorts.array.length; i++){
        slPort = (checkCriticalElementIndex(i, slPorts.array.length), castTo(slPorts.array[i], 112));
        slPort.isHidden && $setSide(slPort.lPort, target.secondSide);
    }
}
function lambda$5_1(finalNewPortSide_0, lPort_1) {
    $setSide(lPort_1, finalNewPortSide_0);
}
function lambda$6(slLoop1_0, slLoop2_1) {
    return compare_5(slLoop2_1.slPorts.array.length, slLoop1_0.slPorts.array.length);
}
function lambda$7_1(slPort1_0, slPort2_1) {
    return compare_5($getNetFlow(slPort1_0.lPort), $getNetFlow(slPort2_1.lPort));
}
function $clinit_PortSideAssigner$Target() {
    $clinit_PortSideAssigner$Target = emptyMethod;
    NORTH = new PortSideAssigner$Target('NORTH', 0, ($clinit_PortSide(), NORTH_1), NORTH_1);
    SOUTH = new PortSideAssigner$Target('SOUTH', 1, SOUTH_0, SOUTH_0);
    EAST = new PortSideAssigner$Target('EAST', 2, EAST_0, EAST_0);
    WEST = new PortSideAssigner$Target('WEST', 3, WEST_0, WEST_0);
    NORTH_WEST_CORNER = new PortSideAssigner$Target('NORTH_WEST_CORNER', 4, WEST_0, NORTH_1);
    NORTH_EAST_CORNER = new PortSideAssigner$Target('NORTH_EAST_CORNER', 5, NORTH_1, EAST_0);
    SOUTH_WEST_CORNER = new PortSideAssigner$Target('SOUTH_WEST_CORNER', 6, SOUTH_0, WEST_0);
    SOUTH_EAST_CORNER = new PortSideAssigner$Target('SOUTH_EAST_CORNER', 7, EAST_0, SOUTH_0);
}
function PortSideAssigner$Target(enum$name, enum$ordinal, firstSide, secondSide) {
    Enum.call(this, enum$name, enum$ordinal);
    this.firstSide = firstSide;
    this.secondSide = secondSide;
}
function valueOf_29(name_0) {
    $clinit_PortSideAssigner$Target();
    return valueOf(($clinit_PortSideAssigner$Target$Map(), $MAP_19), name_0);
}
function values_37() {
    $clinit_PortSideAssigner$Target();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$Target_2_classLit, 1), $intern_36, 272, 0, [
        NORTH,
        SOUTH,
        EAST,
        WEST,
        NORTH_WEST_CORNER,
        NORTH_EAST_CORNER,
        SOUTH_WEST_CORNER,
        SOUTH_EAST_CORNER
    ]);
}
defineClass(272, 23, {
    3: 1,
    34: 1,
    23: 1,
    272: 1
}, PortSideAssigner$Target);
var EAST, NORTH, NORTH_EAST_CORNER, NORTH_WEST_CORNER, SOUTH, SOUTH_EAST_CORNER, SOUTH_WEST_CORNER, WEST;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$Target_2_classLit = createForEnum('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/Target', 272, Ljava_lang_Enum_2_classLit, values_37, valueOf_29);
function $clinit_PortSideAssigner$Target$Map() {
    $clinit_PortSideAssigner$Target$Map = emptyMethod;
    $MAP_19 = createValueOfMap(($clinit_PortSideAssigner$Target(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$Target_2_classLit, 1), $intern_36, 272, 0, [
        NORTH,
        SOUTH,
        EAST,
        WEST,
        NORTH_WEST_CORNER,
        NORTH_EAST_CORNER,
        SOUTH_WEST_CORNER,
        SOUTH_EAST_CORNER
    ])));
}
var $MAP_19;
function PortSideAssigner$lambda$1$Type() {}
defineClass(1737, 1, {}, PortSideAssigner$lambda$1$Type);
_.apply_0 = function apply_98(arg0) {
    return $filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 105).slPorts, 16)), new PortSideAssigner$lambda$8$Type);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$1$Type', 1737);
function PortSideAssigner$lambda$2$Type() {}
defineClass(1738, 1, {}, PortSideAssigner$lambda$2$Type);
_.apply_0 = function apply_99(arg0) {
    return castTo(arg0, 112).lPort;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$2$Type', 1738);
function PortSideAssigner$lambda$3$Type() {}
defineClass(1739, 1, $intern_19, PortSideAssigner$lambda$3$Type);
_.accept = function accept_108(arg0) {
    $setSide(castTo(arg0, 11), ($clinit_PortSide(), NORTH_1));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$3$Type', 1739);
function PortSideAssigner$lambda$4$Type() {}
defineClass(1740, 1, {}, PortSideAssigner$lambda$4$Type);
_.apply_0 = function apply_100(arg0) {
    return castTo(arg0, 112).lPort;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$4$Type', 1740);
function PortSideAssigner$lambda$5$Type(finalNewPortSide_0) {
    this.finalNewPortSide_0 = finalNewPortSide_0;
}
defineClass(1741, 1, $intern_19, PortSideAssigner$lambda$5$Type);
_.accept = function accept_109(arg0) {
    lambda$5_1(this.finalNewPortSide_0, castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$5$Type', 1741);
function PortSideAssigner$lambda$6$Type() {}
defineClass(1742, 1, $intern_88, PortSideAssigner$lambda$6$Type);
_.compare_1 = function compare_49(arg0, arg1) {
    return lambda$6(castTo(arg0, 105), castTo(arg1, 105));
};
_.equals_0 = function equals_130(other) {
    return this === other;
};
_.reversed = function reversed_41() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$6$Type', 1742);
function PortSideAssigner$lambda$7$Type() {}
defineClass(1743, 1, $intern_88, PortSideAssigner$lambda$7$Type);
_.compare_1 = function compare_50(arg0, arg1) {
    return lambda$7_1(castTo(arg0, 112), castTo(arg1, 112));
};
_.equals_0 = function equals_131(other) {
    return this === other;
};
_.reversed = function reversed_42() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$7$Type', 1743);
function PortSideAssigner$lambda$8$Type() {}
defineClass(800, 1, $intern_39, PortSideAssigner$lambda$8$Type);
_.test_0 = function test_72(arg0) {
    return castTo(arg0, 112).isHidden;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_ordering_PortSideAssigner$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.ordering', 'PortSideAssigner/lambda$8$Type', 800);
defineClass(2054, 1, {});
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_AbstractSelfLoopRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'AbstractSelfLoopRouter', 2054);
function $assignOneSidedSequencedSideAndAlignment(slLoops, portSide) {
    var id_0, lPort, lPort$iterator, leftLoopAlignmentReference, leftSlLoop, leftSlLoopIdx, rightLoopAlignmentReference, rightSlLoop, rightSlLoopIdx;
    id_0 = 0;
    for(lPort$iterator = new ArrayList$1((checkCriticalElementIndex(0, slLoops.array.length), castTo(slLoops.array[0], 105)).slHolder.lNode.ports); lPort$iterator.i < lPort$iterator.this$01.array.length;){
        lPort = castTo($next_6(lPort$iterator), 11);
        lPort.id_0 = id_0++;
    }
    portSide == ($clinit_PortSide(), NORTH_1) ? $sort(slLoops, new LabelPlacer$lambda$0$Type_0) : $sort(slLoops, new LabelPlacer$lambda$1$Type_0);
    leftSlLoopIdx = 0;
    rightSlLoopIdx = slLoops.array.length - 1;
    while(leftSlLoopIdx < rightSlLoopIdx){
        leftSlLoop = (checkCriticalElementIndex(leftSlLoopIdx, slLoops.array.length), castTo(slLoops.array[leftSlLoopIdx], 105));
        rightSlLoop = (checkCriticalElementIndex(rightSlLoopIdx, slLoops.array.length), castTo(slLoops.array[rightSlLoopIdx], 105));
        leftLoopAlignmentReference = portSide == NORTH_1 ? leftSlLoop.rightmostPort : leftSlLoop.leftmostPort;
        rightLoopAlignmentReference = portSide == NORTH_1 ? rightSlLoop.leftmostPort : rightSlLoop.rightmostPort;
        $assignSideAndAlignment(leftSlLoop, portSide, ($clinit_SelfHyperLoopLabels$Alignment(), RIGHT_1), leftLoopAlignmentReference);
        $assignSideAndAlignment(rightSlLoop, portSide, LEFT_1, rightLoopAlignmentReference);
        ++leftSlLoopIdx;
        --rightSlLoopIdx;
    }
    leftSlLoopIdx == rightSlLoopIdx && $assignSideAndAlignment((checkCriticalElementIndex(leftSlLoopIdx, slLoops.array.length), castTo(slLoops.array[leftSlLoopIdx], 105)), portSide, ($clinit_SelfHyperLoopLabels$Alignment(), CENTER_2), null);
}
function $assignOneSidedSimpleSideAndAlignment(slLoop, loopSide) {
    var topmostPort;
    switch(loopSide.ordinal){
        case 2:
        case 4:
            topmostPort = slLoop.leftmostPort;
            slLoop.rightmostPort.lPort.pos.y_0 < topmostPort.lPort.pos.y_0 && (topmostPort = slLoop.rightmostPort);
            $assignSideAndAlignment(slLoop, loopSide, ($clinit_SelfHyperLoopLabels$Alignment(), TOP_0), topmostPort);
            break;
        case 1:
        case 3:
            $assignSideAndAlignment(slLoop, loopSide, ($clinit_SelfHyperLoopLabels$Alignment(), CENTER_2), null);
    }
}
function $assignSideAndAlignment(slLoop, side, alignment, alignmentReference) {
    var slLabels;
    slLabels = slLoop.slLabels;
    slLabels.side = side;
    slLabels.alignment = alignment;
    slLabels.alignmentReferenceSLPort = alignmentReference;
}
function $assignSideAndAlignment_0(slHolder) {
    var loopSide, northernOneSidedSLLoops, occupiedSides, orderingStrategy, slLabels, slLoop, slLoop$iterator, southernOneSidedSLLoops, leftmostPortSide, rightmostPortSide, leftmostPortSide_0, rightmostPortSide_0;
    northernOneSidedSLLoops = null;
    southernOneSidedSLLoops = null;
    orderingStrategy = castTo($getProperty(slHolder.lNode, ($clinit_LayeredOptions(), EDGE_ROUTING_SELF_LOOP_ORDERING_0)), 345);
    if (orderingStrategy == ($clinit_SelfLoopOrderingStrategy(), SEQUENCED)) {
        northernOneSidedSLLoops = new ArrayList;
        southernOneSidedSLLoops = new ArrayList;
    }
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        slLabels = slLoop.slLabels;
        if (!slLabels) continue;
        switch(slLoop.selfLoopType.ordinal){
            case 0:
                loopSide = castTo($next_7(new EnumSet$EnumSetImpl$IteratorImpl(slLoop.occupiedPortSides)), 64);
                orderingStrategy == SEQUENCED && loopSide == ($clinit_PortSide(), NORTH_1) ? push_1(northernOneSidedSLLoops.array, slLoop) : orderingStrategy == SEQUENCED && loopSide == ($clinit_PortSide(), SOUTH_0) ? push_1(southernOneSidedSLLoops.array, slLoop) : $assignOneSidedSimpleSideAndAlignment(slLoop, loopSide);
                break;
            case 1:
                leftmostPortSide = slLoop.leftmostPort.lPort.side;
                rightmostPortSide = slLoop.rightmostPort.lPort.side;
                leftmostPortSide == ($clinit_PortSide(), NORTH_1) ? $assignSideAndAlignment(slLoop, NORTH_1, ($clinit_SelfHyperLoopLabels$Alignment(), LEFT_1), slLoop.leftmostPort) : rightmostPortSide == NORTH_1 ? $assignSideAndAlignment(slLoop, NORTH_1, ($clinit_SelfHyperLoopLabels$Alignment(), RIGHT_1), slLoop.rightmostPort) : leftmostPortSide == SOUTH_0 ? $assignSideAndAlignment(slLoop, SOUTH_0, ($clinit_SelfHyperLoopLabels$Alignment(), RIGHT_1), slLoop.leftmostPort) : rightmostPortSide == SOUTH_0 && $assignSideAndAlignment(slLoop, SOUTH_0, ($clinit_SelfHyperLoopLabels$Alignment(), LEFT_1), slLoop.rightmostPort);
                break;
            case 2:
            case 3:
                occupiedSides = slLoop.occupiedPortSides;
                $containsEnum(occupiedSides, ($clinit_PortSide(), NORTH_1)) ? $containsEnum(occupiedSides, SOUTH_0) ? $containsEnum(occupiedSides, WEST_0) ? $containsEnum(occupiedSides, EAST_0) || $assignSideAndAlignment(slLoop, NORTH_1, ($clinit_SelfHyperLoopLabels$Alignment(), RIGHT_1), slLoop.rightmostPort) : $assignSideAndAlignment(slLoop, NORTH_1, ($clinit_SelfHyperLoopLabels$Alignment(), LEFT_1), slLoop.leftmostPort) : $assignSideAndAlignment(slLoop, NORTH_1, ($clinit_SelfHyperLoopLabels$Alignment(), CENTER_2), null) : $assignSideAndAlignment(slLoop, SOUTH_0, ($clinit_SelfHyperLoopLabels$Alignment(), CENTER_2), null);
                break;
            case 4:
                leftmostPortSide_0 = slLoop.leftmostPort.lPort.side;
                rightmostPortSide_0 = slLoop.leftmostPort.lPort.side;
                leftmostPortSide_0 == ($clinit_PortSide(), NORTH_1) || rightmostPortSide_0 == NORTH_1 ? $assignSideAndAlignment(slLoop, SOUTH_0, ($clinit_SelfHyperLoopLabels$Alignment(), CENTER_2), null) : $assignSideAndAlignment(slLoop, NORTH_1, ($clinit_SelfHyperLoopLabels$Alignment(), CENTER_2), null);
        }
    }
    if (northernOneSidedSLLoops) {
        northernOneSidedSLLoops.array.length == 0 || $assignOneSidedSequencedSideAndAlignment(northernOneSidedSLLoops, ($clinit_PortSide(), NORTH_1));
        southernOneSidedSLLoops.array.length == 0 || $assignOneSidedSequencedSideAndAlignment(southernOneSidedSLLoops, ($clinit_PortSide(), SOUTH_0));
    }
}
function $computeCoordinates(slLoop) {
    var alignRef, pos, size_0, slLabels;
    slLabels = slLoop.slLabels;
    alignRef = slLabels.alignmentReferenceSLPort;
    size_0 = slLabels.size_0;
    pos = slLabels.position;
    switch(slLabels.alignment.ordinal){
        case 0:
            pos.x_0 = (slLoop.slHolder.lNode.size_0.x_0 - size_0.x_0) / 2;
            break;
        case 1:
            pos.x_0 = alignRef.lPort.pos.x_0 + alignRef.lPort.anchor.x_0;
            break;
        case 2:
            pos.x_0 = alignRef.lPort.pos.x_0 + alignRef.lPort.anchor.x_0 - size_0.x_0;
            break;
        case 3:
            pos.y_0 = alignRef.lPort.pos.y_0 + alignRef.lPort.anchor.y_0;
    }
}
function $placeLabels_1(slHolder) {
    var slLoop, slLoop$iterator;
    $assignSideAndAlignment_0(slHolder);
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        !!slLoop.slLabels && $computeCoordinates(slLoop);
    }
}
function lambda$0_25(slLoop1_0, slLoop2_1) {
    return compare_5(slLoop1_0.leftmostPort.lPort.id_0, slLoop2_1.leftmostPort.lPort.id_0);
}
function lambda$1_13(slLoop1_0, slLoop2_1) {
    return compare_5(slLoop2_1.leftmostPort.lPort.id_0, slLoop1_0.leftmostPort.lPort.id_0);
}
function LabelPlacer$lambda$0$Type_0() {}
defineClass(1762, 1, $intern_88, LabelPlacer$lambda$0$Type_0);
_.compare_1 = function compare_51(arg0, arg1) {
    return lambda$0_25(castTo(arg0, 105), castTo(arg1, 105));
};
_.equals_0 = function equals_132(other) {
    return this === other;
};
_.reversed = function reversed_43() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_LabelPlacer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'LabelPlacer/lambda$0$Type', 1762);
function LabelPlacer$lambda$1$Type_0() {}
defineClass(1763, 1, $intern_88, LabelPlacer$lambda$1$Type_0);
_.compare_1 = function compare_52(arg0, arg1) {
    return lambda$1_13(castTo(arg0, 105), castTo(arg1, 105));
};
_.equals_0 = function equals_133(other) {
    return this === other;
};
_.reversed = function reversed_44() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_LabelPlacer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'LabelPlacer/lambda$1$Type', 1763);
function $addCornerBendPoints(slEdge, routingDirection, routingSlotPositions, bendPoints) {
    var currPortSide, currPortSideComponent, lSourcePort, lTargetPort, nextPortSide, nextPortSideComponent, slLoop;
    lSourcePort = slEdge.slSource.lPort;
    lTargetPort = slEdge.slTarget.lPort;
    if (lSourcePort.side == lTargetPort.side) return;
    slLoop = slEdge.slHyperLoop;
    currPortSide = lSourcePort.side;
    nextPortSide = null;
    while(currPortSide != lTargetPort.side){
        nextPortSide = routingDirection == 0 ? $right(currPortSide) : $left(currPortSide);
        currPortSideComponent = $getBaseVector(currPortSide, slLoop.routingSlot[currPortSide.ordinal], routingSlotPositions);
        nextPortSideComponent = $getBaseVector(nextPortSide, slLoop.routingSlot[nextPortSide.ordinal], routingSlotPositions);
        $add_7(bendPoints, $add_19(currPortSideComponent, nextPortSideComponent));
        currPortSide = nextPortSide;
    }
}
function $addOuterBendPoint(slEdge, slPort, routingSlotPositions, bendPoints) {
    var anchor, lPort, portSide, result, slLoop;
    slLoop = slEdge.slHyperLoop;
    lPort = slPort.lPort;
    portSide = lPort.side;
    result = $getBaseVector(portSide, slLoop.routingSlot[portSide.ordinal], routingSlotPositions);
    anchor = $add_19($clone_1(lPort.pos), lPort.anchor);
    switch(lPort.side.ordinal){
        case 1:
        case 3:
            result.x_0 += anchor.x_0;
            break;
        case 2:
        case 4:
            result.y_0 += anchor.y_0;
    }
    $addNode_0(bendPoints, result, bendPoints.tail.prev, bendPoints.tail);
}
function $computeBaselinePosition(slHolder, portSide, nodeSelfLoopDistance) {
    var lMargins, lNode;
    lNode = slHolder.lNode;
    lMargins = lNode.margin;
    switch(portSide.ordinal){
        case 1:
            return -lMargins.top_0 - nodeSelfLoopDistance;
        case 2:
            return lNode.size_0.x_0 + lMargins.right + nodeSelfLoopDistance;
        case 3:
            return lNode.size_0.y_0 + lMargins.bottom + nodeSelfLoopDistance;
        case 4:
            return -lMargins.left - nodeSelfLoopDistance;
        default:
            return -1;
    }
}
function $computeEdgeRoutingDirection(slEdge) {
    var slLoop, sourceLPort, sourcePortSide, targetLPort, targetPortSide;
    sourceLPort = slEdge.slSource.lPort;
    sourcePortSide = sourceLPort.side;
    targetLPort = slEdge.slTarget.lPort;
    targetPortSide = targetLPort.side;
    if (sourcePortSide == targetPortSide) return sourceLPort.id_0 < targetLPort.id_0 ? 0 : 1;
    else if ($right(sourcePortSide) == targetPortSide) return 0;
    else if ($left(sourcePortSide) == targetPortSide) return 1;
    else {
        slLoop = slEdge.slHyperLoop;
        return $containsEnum(slLoop.occupiedPortSides, $right(sourcePortSide)) ? 0 : 1;
    }
}
function $computePositions(positions, slHolder, portSide, edgeEdgeDistance, edgeLabelDistance, nodeSelfLoopDistance) {
    var currPos, factor, largestLabelSize, sidePositions, slot;
    currPos = $computeBaselinePosition(slHolder, portSide, nodeSelfLoopDistance);
    factor = portSide == ($clinit_PortSide(), NORTH_1) || portSide == WEST_0 ? -1 : 1;
    sidePositions = positions[portSide.ordinal];
    for(slot = 0; slot < sidePositions.length; slot++){
        largestLabelSize = sidePositions[slot];
        largestLabelSize > 0 && (largestLabelSize += edgeLabelDistance);
        sidePositions[slot] = currPos;
        currPos += factor * (largestLabelSize + edgeEdgeDistance);
    }
}
function $computeRoutingSlotPositions(slHolder, edgeEdgeDistance, edgeLabelDistance, nodeSLDistance) {
    var portSide, portSide$array, portSide$index, portSide$max, positions;
    positions = initUnidimensionalArray(D_classLit, $intern_16, 108, ($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])).length, 0, 2);
    for(portSide$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ]), portSide$index = 0, portSide$max = portSide$array.length; portSide$index < portSide$max; ++portSide$index){
        portSide = portSide$array[portSide$index];
        positions[portSide.ordinal] = initUnidimensionalArray(D_classLit, $intern_66, 30, slHolder.routingSlotCount[portSide.ordinal], 15, 1);
    }
    $initializeWithMaxLabelHeight(positions, slHolder, NORTH_1);
    $initializeWithMaxLabelHeight(positions, slHolder, SOUTH_0);
    $computePositions(positions, slHolder, NORTH_1, edgeEdgeDistance, edgeLabelDistance, nodeSLDistance);
    $computePositions(positions, slHolder, EAST_0, edgeEdgeDistance, edgeLabelDistance, nodeSLDistance);
    $computePositions(positions, slHolder, SOUTH_0, edgeEdgeDistance, edgeLabelDistance, nodeSLDistance);
    $computePositions(positions, slHolder, WEST_0, edgeEdgeDistance, edgeLabelDistance, nodeSLDistance);
    return positions;
}
function $getBaseVector(portSide, routingSlot, routingSlotPositions) {
    var position;
    position = routingSlotPositions[portSide.ordinal][routingSlot];
    switch(portSide.ordinal){
        case 1:
        case 3:
            return new KVector_1(0, position);
        case 2:
        case 4:
            return new KVector_1(position, 0);
        default:
            return null;
    }
}
function $initializeWithMaxLabelHeight(positions, slHolder, portSide) {
    var routingSlot, sidePositions, slLabels, slLoop, slLoop$iterator;
    sidePositions = positions[portSide.ordinal];
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        slLabels = slLoop.slLabels;
        if (!!slLabels && slLabels.side == portSide) {
            routingSlot = slLoop.routingSlot[portSide.ordinal];
            sidePositions[routingSlot] = $wnd.Math.max(sidePositions[routingSlot], slLabels.size_0.y_0);
        }
    }
}
function $placeLabels_2(slLoop, slLabels, routingSlotPositions, edgeLabelDistance) {
    var labelPosition, labelSide;
    labelSide = slLabels.side;
    labelPosition = routingSlotPositions[labelSide.ordinal][slLoop.routingSlot[labelSide.ordinal]];
    switch(labelSide.ordinal){
        case 1:
            labelPosition -= edgeLabelDistance + slLabels.size_0.y_0;
            slLabels.position.y_0 = labelPosition;
            break;
        case 3:
            labelPosition += edgeLabelDistance;
            slLabels.position.y_0 = labelPosition;
            break;
        case 4:
            labelPosition -= edgeLabelDistance + slLabels.size_0.x_0;
            slLabels.position.x_0 = labelPosition;
            break;
        case 2:
            labelPosition += edgeLabelDistance;
            slLabels.position.x_0 = labelPosition;
    }
}
function $routeSelfLoops(this$static, slHolder) {
    var bendPoints, edgeEdgeDistance, edgeLabelDistance, lEdge, lNode, newNodeMargins, nodeMargins, nodeSLDistance, nodeSize, routingDirection, routingSlotPositions, slEdge, slEdge$iterator, slLabels, slLoop, slLoop$iterator, bendPoints_0, pos;
    lNode = slHolder.lNode;
    nodeSize = lNode.size_0;
    nodeMargins = lNode.margin;
    edgeEdgeDistance = $doubleValue(castToDouble(getIndividualOrInherited(lNode, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE))));
    edgeLabelDistance = $doubleValue(castToDouble(getIndividualOrInherited(lNode, SPACING_EDGE_LABEL_0)));
    nodeSLDistance = $doubleValue(castToDouble(getIndividualOrInherited(lNode, SPACING_NODE_SELF_LOOP)));
    newNodeMargins = new LMargin;
    $set_5(newNodeMargins, nodeMargins.top_0, nodeMargins.right, nodeMargins.bottom, nodeMargins.left);
    routingSlotPositions = $computeRoutingSlotPositions(slHolder, edgeEdgeDistance, edgeLabelDistance, nodeSLDistance);
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        for(slEdge$iterator = slLoop.slEdges.map_0.keySet_0().iterator_0(); slEdge$iterator.hasNext_0();){
            slEdge = castTo(slEdge$iterator.next_1(), 336);
            lEdge = slEdge.lEdge;
            routingDirection = $computeEdgeRoutingDirection(slEdge);
            bendPoints = (bendPoints_0 = new KVectorChain, $addOuterBendPoint(slEdge, slEdge.slSource, routingSlotPositions, bendPoints_0), $addCornerBendPoints(slEdge, routingDirection, routingSlotPositions, bendPoints_0), $addOuterBendPoint(slEdge, slEdge.slTarget, routingSlotPositions, bendPoints_0), bendPoints_0);
            bendPoints = this$static.modifyBendPoints(slEdge, routingDirection, bendPoints);
            $reset_0(lEdge.bendPoints);
            $addAll(lEdge.bendPoints, bendPoints);
            $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(bendPoints, 16)), new OrthogonalSelfLoopRouter$lambda$0$Type(nodeSize, newNodeMargins));
        }
        slLabels = slLoop.slLabels;
        if (slLabels) {
            $placeLabels_2(slLoop, slLabels, routingSlotPositions, edgeLabelDistance);
            pos = new KVector_2(slLabels.position);
            $updateNewNodeMargins(nodeSize, newNodeMargins, pos);
            $add_19(pos, slLabels.size_0);
            $updateNewNodeMargins(nodeSize, newNodeMargins, pos);
        }
    }
    $set_5(nodeMargins, newNodeMargins.top_0, newNodeMargins.right, newNodeMargins.bottom, newNodeMargins.left);
}
function $updateNewNodeMargins(nodeSize, newNodeMargins, bendPoint) {
    newNodeMargins.left = $wnd.Math.max(newNodeMargins.left, -bendPoint.x_0);
    newNodeMargins.right = $wnd.Math.max(newNodeMargins.right, bendPoint.x_0 - nodeSize.x_0);
    newNodeMargins.top_0 = $wnd.Math.max(newNodeMargins.top_0, -bendPoint.y_0);
    newNodeMargins.bottom = $wnd.Math.max(newNodeMargins.bottom, bendPoint.y_0 - nodeSize.y_0);
}
function OrthogonalSelfLoopRouter() {}
defineClass(1802, 2054, {}, OrthogonalSelfLoopRouter);
_.modifyBendPoints = function modifyBendPoints(slEdge, routingDirection, bendPoints) {
    return bendPoints;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_OrthogonalSelfLoopRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'OrthogonalSelfLoopRouter', 1802);
function OrthogonalSelfLoopRouter$lambda$0$Type(nodeSize_1, newNodeMargins_2) {
    this.nodeSize_1 = nodeSize_1;
    this.newNodeMargins_2 = newNodeMargins_2;
}
defineClass(1804, 1, $intern_19, OrthogonalSelfLoopRouter$lambda$0$Type);
_.accept = function accept_110(arg0) {
    $updateNewNodeMargins(this.nodeSize_1, this.newNodeMargins_2, castTo(arg0, 8));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_OrthogonalSelfLoopRouter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'OrthogonalSelfLoopRouter/lambda$0$Type', 1804);
function $cutCorners(bendPoints) {
    var bpIterator, corner, effectiveDistance, next, offset1, offset2, previous, result;
    result = new KVectorChain;
    bpIterator = $listIterator_2(bendPoints, 0);
    previous = null;
    corner = castTo($next_9(bpIterator), 8);
    next = castTo($next_9(bpIterator), 8);
    while(bpIterator.currentNode != bpIterator.this$01.tail){
        previous = corner;
        corner = next;
        next = castTo($next_9(bpIterator), 8);
        offset1 = $nearZeroToZero($sub_0(new KVector_1(previous.x_0, previous.y_0), corner));
        offset2 = $nearZeroToZero($sub_0(new KVector_1(next.x_0, next.y_0), corner));
        effectiveDistance = 10;
        effectiveDistance = $wnd.Math.min(effectiveDistance, $wnd.Math.abs(offset1.x_0 + offset1.y_0) / 2);
        effectiveDistance = $wnd.Math.min(effectiveDistance, $wnd.Math.abs(offset2.x_0 + offset2.y_0) / 2);
        offset1.x_0 = signum(offset1.x_0) * effectiveDistance;
        offset1.y_0 = signum(offset1.y_0) * effectiveDistance;
        offset2.x_0 = signum(offset2.x_0) * effectiveDistance;
        offset2.y_0 = signum(offset2.y_0) * effectiveDistance;
        $add_7(result, $add_19(offset1, corner));
        $add_7(result, $add_19(offset2, corner));
    }
    return result;
}
function $nearZeroToZero(vector) {
    vector.x_0 >= -0.01 && vector.x_0 <= $intern_93 && (vector.x_0 = 0);
    vector.y_0 >= -0.01 && vector.y_0 <= $intern_93 && (vector.y_0 = 0);
    return vector;
}
function PolylineSelfLoopRouter() {}
defineClass(1803, 1802, {}, PolylineSelfLoopRouter);
_.modifyBendPoints = function modifyBendPoints_0(slEdge, routingDirection, bendPoints) {
    var lSourcePort, lTargetPort;
    lSourcePort = slEdge.slSource.lPort;
    $add_0(bendPoints, 0, $add_19($clone_1(lSourcePort.pos), lSourcePort.anchor));
    lTargetPort = slEdge.slTarget.lPort;
    $add_7(bendPoints, $add_19($clone_1(lTargetPort.pos), lTargetPort.anchor));
    return $cutCorners(bendPoints);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_PolylineSelfLoopRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'PolylineSelfLoopRouter', 1803);
function $clinit_RoutingDirector() {
    $clinit_RoutingDirector = emptyMethod;
    COMPARE_BY_ID = new RoutingDirector$lambda$0$Type;
}
function $assignPortIds(lPorts) {
    var i;
    for(i = 0; i < lPorts.array.length; i++)(checkCriticalElementIndex(i, lPorts.array.length), castTo(lPorts.array[i], 11)).id_0 = i;
}
function $computeEdgePenalty(this$static, slHolder, leftmostPort, rightmostPort) {
    var leftOfRightmostPortId, leftmostPortId, portCount, rightmostPortId;
    this$static.portPenalties == null && $computePenalties(this$static, slHolder);
    portCount = slHolder.lNode.ports.array.length;
    leftmostPortId = leftmostPort.lPort.id_0;
    rightmostPortId = rightmostPort.lPort.id_0;
    leftOfRightmostPortId = rightmostPortId - 1;
    leftOfRightmostPortId < 0 && (leftOfRightmostPortId = portCount - 1);
    return leftmostPortId <= leftOfRightmostPortId ? this$static.portPenalties[leftOfRightmostPortId] - this$static.portPenalties[leftmostPortId] : this$static.portPenalties[portCount - 1] - this$static.portPenalties[leftmostPortId] + this$static.portPenalties[leftOfRightmostPortId];
}
function $computeMissingPortSide(slLoop) {
    var side, side$array, side$index, side$max, sides;
    sides = $keySet(slLoop.slPortsBySide);
    for(side$array = ($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])), side$index = 0, side$max = side$array.length; side$index < side$max; ++side$index){
        side = side$array[side$index];
        if (side != UNDEFINED_5 && !sides.contains(side)) return side;
    }
    return null;
}
function $computeOccupiedPortSides(slLoop) {
    var currPortSide, targetSide;
    currPortSide = slLoop.leftmostPort.lPort.side;
    targetSide = slLoop.rightmostPort.lPort.side;
    while(currPortSide != targetSide){
        $add_5(slLoop.occupiedPortSides, currPortSide);
        currPortSide = $right(currPortSide);
    }
    $add_5(slLoop.occupiedPortSides, currPortSide);
}
function $computePenalties(this$static, slHolder) {
    var currPort, i, penaltySum, ports;
    ports = slHolder.lNode.ports;
    this$static.portPenalties = initUnidimensionalArray(I_classLit, $intern_48, 30, ports.array.length, 15, 1);
    penaltySum = 0;
    for(i = 0; i < ports.array.length; i++){
        currPort = (checkCriticalElementIndex(i, ports.array.length), castTo(ports.array[i], 11));
        currPort.incomingEdges.array.length == 0 && currPort.outgoingEdges.array.length == 0 ? penaltySum += 1 : penaltySum += 3;
        this$static.portPenalties[i] = penaltySum;
    }
}
function $determineFourSideLoopRoutes(this$static, slLoop) {
    var currLeftPort, currPenalty, currRightPort, rightPortIndex, slHolder, sortedSLPorts, worstLeftPort, worstPenalty, worstRightPort;
    sortedSLPorts = slLoop.slPorts;
    slHolder = slLoop.slHolder;
    worstLeftPort = castTo($get_11(sortedSLPorts, sortedSLPorts.array.length - 1), 112);
    worstRightPort = (checkCriticalElementIndex(0, sortedSLPorts.array.length), castTo(sortedSLPorts.array[0], 112));
    worstPenalty = $computeEdgePenalty(this$static, slHolder, worstLeftPort, worstRightPort);
    for(rightPortIndex = 1; rightPortIndex < sortedSLPorts.array.length; rightPortIndex++){
        currLeftPort = (checkCriticalElementIndex(rightPortIndex - 1, sortedSLPorts.array.length), castTo(sortedSLPorts.array[rightPortIndex - 1], 112));
        currRightPort = (checkCriticalElementIndex(rightPortIndex, sortedSLPorts.array.length), castTo(sortedSLPorts.array[rightPortIndex], 112));
        currPenalty = $computeEdgePenalty(this$static, slHolder, currLeftPort, currRightPort);
        if (currPenalty > worstPenalty) {
            worstLeftPort = currLeftPort;
            worstRightPort = currRightPort;
            worstPenalty = currPenalty;
        }
    }
    slLoop.leftmostPort = worstRightPort;
    slLoop.rightmostPort = worstLeftPort;
}
function $determineLoopRoutes(this$static, slHolder) {
    var side, sides, slLoop, slLoop$iterator;
    $assignPortIds(slHolder.lNode.ports);
    $forEach_3($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new RoutingDirector$lambda$1$Type), new RoutingDirector$lambda$2$Type);
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        switch(slLoop.selfLoopType.ordinal){
            case 0:
                side = castTo($get_11(slLoop.slPorts, 0), 112).lPort.side;
                $setLeftmostPort(slLoop, castTo($get_17($min_0(castTo($get(slLoop.slPortsBySide, side), 15).stream(), COMPARE_BY_ID)), 112));
                $setRightmostPort(slLoop, castTo($get_17($max_1(castTo($get(slLoop.slPortsBySide, side), 15).stream(), COMPARE_BY_ID)), 112));
                break;
            case 1:
                sides = sortedTwoSideLoopPortSides(slLoop);
                $setLeftmostPort(slLoop, castTo($get_17($min_0(castTo($get(slLoop.slPortsBySide, sides[0]), 15).stream(), COMPARE_BY_ID)), 112));
                $setRightmostPort(slLoop, castTo($get_17($max_1(castTo($get(slLoop.slPortsBySide, sides[1]), 15).stream(), COMPARE_BY_ID)), 112));
                break;
            case 2:
                $determineTwoSideOpposingLoopRoutes(this$static, slLoop);
                break;
            case 3:
                $determineThreeSideLoopRoutes(slLoop);
                break;
            case 4:
                $determineFourSideLoopRoutes(this$static, slLoop);
        }
        $computeOccupiedPortSides(slLoop);
    }
    this$static.portPenalties = null;
}
function $determineThreeSideLoopRoutes(slLoop) {
    var leftmostSide, rightmostSide;
    leftmostSide = null;
    rightmostSide = null;
    switch($computeMissingPortSide(slLoop).ordinal){
        case 1:
            leftmostSide = ($clinit_PortSide(), EAST_0);
            rightmostSide = WEST_0;
            break;
        case 2:
            leftmostSide = ($clinit_PortSide(), SOUTH_0);
            rightmostSide = NORTH_1;
            break;
        case 3:
            leftmostSide = ($clinit_PortSide(), WEST_0);
            rightmostSide = EAST_0;
            break;
        case 4:
            leftmostSide = ($clinit_PortSide(), NORTH_1);
            rightmostSide = SOUTH_0;
    }
    $setLeftmostPort(slLoop, castTo($get_17($min_0(castTo($get(slLoop.slPortsBySide, leftmostSide), 15).stream(), COMPARE_BY_ID)), 112));
    $setRightmostPort(slLoop, castTo($get_17($max_1(castTo($get(slLoop.slPortsBySide, rightmostSide), 15).stream(), COMPARE_BY_ID)), 112));
}
function $determineTwoSideOpposingLoopRoutes(this$static, slLoop) {
    var option1LeftmostPort, option1Penalty, option1RightmostPort, option2LeftmostPort, option2Penalty, option2RightmostPort, sides, slHolder;
    sides = castTo($toArray_0($keySet(slLoop.slPortsBySide), initUnidimensionalArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, $intern_100, 64, 2, 0, 1)), 125);
    slHolder = slLoop.slHolder;
    option1LeftmostPort = $lowestPortOnSide(slLoop, sides[0]);
    option1RightmostPort = $highestPortOnSide(slLoop, sides[1]);
    option1Penalty = $computeEdgePenalty(this$static, slHolder, option1LeftmostPort, option1RightmostPort);
    option2LeftmostPort = $lowestPortOnSide(slLoop, sides[1]);
    option2RightmostPort = $highestPortOnSide(slLoop, sides[0]);
    option2Penalty = $computeEdgePenalty(this$static, slHolder, option2LeftmostPort, option2RightmostPort);
    if (option1Penalty <= option2Penalty) {
        slLoop.leftmostPort = option1LeftmostPort;
        slLoop.rightmostPort = option1RightmostPort;
    } else {
        slLoop.leftmostPort = option2LeftmostPort;
        slLoop.rightmostPort = option2RightmostPort;
    }
}
function $highestPortOnSide(slLoop, side) {
    return castTo($get_17($max_1(castTo($get(slLoop.slPortsBySide, side), 15).stream(), COMPARE_BY_ID)), 112);
}
function $lowestPortOnSide(slLoop, side) {
    return castTo($get_17($min_0(castTo($get(slLoop.slPortsBySide, side), 15).stream(), COMPARE_BY_ID)), 112);
}
function RoutingDirector() {
    $clinit_RoutingDirector();
}
function lambda$0_26(slPort1_0, slPort2_1) {
    $clinit_RoutingDirector();
    return compare_5(slPort1_0.lPort.id_0, slPort2_1.lPort.id_0);
}
defineClass(1758, 1, {}, RoutingDirector);
_.portPenalties = null;
var COMPARE_BY_ID;
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingDirector_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingDirector', 1758);
function RoutingDirector$lambda$0$Type() {}
defineClass(1759, 1, $intern_88, RoutingDirector$lambda$0$Type);
_.compare_1 = function compare_53(arg0, arg1) {
    return lambda$0_26(castTo(arg0, 112), castTo(arg1, 112));
};
_.equals_0 = function equals_134(other) {
    return this === other;
};
_.reversed = function reversed_45() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingDirector$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingDirector/lambda$0$Type', 1759);
function RoutingDirector$lambda$1$Type() {}
defineClass(1760, 1, {}, RoutingDirector$lambda$1$Type);
_.apply_0 = function apply_101(arg0) {
    return $clinit_RoutingDirector(), castTo(arg0, 105).slPorts;
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingDirector$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingDirector/lambda$1$Type', 1760);
function RoutingDirector$lambda$2$Type() {}
defineClass(1761, 1, $intern_19, RoutingDirector$lambda$2$Type);
_.accept = function accept_111(arg0) {
    $clinit_RoutingDirector();
    castTo(arg0, 15).sort_0(COMPARE_BY_ID);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingDirector$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingDirector/lambda$2$Type', 1761);
function $assignRawRoutingSlotsToLoops(this$static, slHolder) {
    var portSide, portSide$iterator, slLoop, slLoop$iterator, slot;
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        slot = castTo($get_10(this$static.slLoopToSegmentMap, slLoop), 116).routingSlot;
        for(portSide$iterator = new EnumSet$EnumSetImpl$IteratorImpl(slLoop.occupiedPortSides); portSide$iterator.i < portSide$iterator.this$11.all.length;){
            portSide = castTo($next_7(portSide$iterator), 64);
            $setRoutingSlot(slLoop, portSide, slot);
        }
    }
}
function $assignRawRoutingSlotsToSegments(this$static) {
    var inDependency, inDependency$iterator, nextRoutingSlot, segment, segment$iterator, sinks, sourceSegment;
    sinks = new LinkedList;
    for(segment$iterator = new ArrayList$1(this$static.hyperEdgeSegments); segment$iterator.i < segment$iterator.this$01.array.length;){
        segment = castTo($next_6(segment$iterator), 116);
        $setInWeight(segment, segment.incomingSegmentDependencies.array.length);
        $setOutWeight(segment, segment.outgoingSegmentDependencies.array.length);
        if (segment.outDepWeight == 0) {
            segment.routingSlot = 0;
            $addNode_0(sinks, segment, sinks.tail.prev, sinks.tail);
        }
    }
    while(sinks.size_0 != 0){
        segment = castTo(sinks.size_0 == 0 ? null : (checkCriticalElement(sinks.size_0 != 0), $removeNode_0(sinks, sinks.header.next_0)), 116);
        nextRoutingSlot = segment.routingSlot + 1;
        for(inDependency$iterator = new ArrayList$1(segment.incomingSegmentDependencies); inDependency$iterator.i < inDependency$iterator.this$01.array.length;){
            inDependency = castTo($next_6(inDependency$iterator), 133);
            sourceSegment = inDependency.source;
            $setRoutingSlot_0(sourceSegment, $wnd.Math.max(sourceSegment.routingSlot, nextRoutingSlot));
            $setOutWeight(sourceSegment, sourceSegment.outDepWeight - 1);
            sourceSegment.outDepWeight == 0 && $addNode_0(sinks, sourceSegment, sinks.tail.prev, sinks.tail);
        }
    }
}
function $assignRoutingSlots(this$static, slHolder) {
    var labelCrossingMatrix, nextFreeRoutingSlotAtPort;
    labelCrossingMatrix = $computeLabelCrossingMatrix(slHolder);
    $createCrossingGraph(this$static, slHolder, labelCrossingMatrix);
    breakNonCriticalCycles(this$static.hyperEdgeSegments, castTo($getProperty($getGraph(slHolder.lNode), ($clinit_InternalProperties_1(), RANDOM_0)), 233));
    $assignRawRoutingSlotsToSegments(this$static);
    $assignRawRoutingSlotsToLoops(this$static, slHolder);
    nextFreeRoutingSlotAtPort = initUnidimensionalArray(I_classLit, $intern_48, 30, slHolder.lNode.ports.array.length, 15, 1);
    $shiftTowardsNodeOnSide(this$static, slHolder, ($clinit_PortSide(), NORTH_1), nextFreeRoutingSlotAtPort, labelCrossingMatrix);
    $shiftTowardsNodeOnSide(this$static, slHolder, EAST_0, nextFreeRoutingSlotAtPort, labelCrossingMatrix);
    $shiftTowardsNodeOnSide(this$static, slHolder, SOUTH_0, nextFreeRoutingSlotAtPort, labelCrossingMatrix);
    $shiftTowardsNodeOnSide(this$static, slHolder, WEST_0, nextFreeRoutingSlotAtPort, labelCrossingMatrix);
    this$static.hyperEdgeSegments = null;
    this$static.slLoopToSegmentMap = null;
    this$static.slLoopActivityOverPorts = null;
}
function $computeLabelCrossingMatrix(slHolder) {
    var crossingMatrix, labelID, overlap, sl1Idx, sl2Idx, slLoop, slLoop$iterator, slLoop1, slLoop2, slLoops;
    labelID = 0;
    for(slLoop$iterator = new ArrayList$1(slHolder.slHyperLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        !!slLoop.slLabels && (slLoop.slLabels.id_0 = labelID++);
    }
    crossingMatrix = initMultidimensionalArray(Z_classLit, [
        $intern_16,
        $intern_90
    ], [
        183,
        30
    ], 16, [
        labelID,
        labelID
    ], 2);
    slLoops = slHolder.slHyperLoops;
    for(sl1Idx = 0; sl1Idx < slLoops.array.length; sl1Idx++){
        slLoop1 = (checkCriticalElementIndex(sl1Idx, slLoops.array.length), castTo(slLoops.array[sl1Idx], 105));
        if (slLoop1.slLabels) for(sl2Idx = sl1Idx + 1; sl2Idx < slLoops.array.length; sl2Idx++){
            slLoop2 = (checkCriticalElementIndex(sl2Idx, slLoops.array.length), castTo(slLoops.array[sl2Idx], 105));
            if (slLoop2.slLabels) {
                overlap = $labelsOverlap(slLoop1, slLoop2);
                crossingMatrix[slLoop1.slLabels.id_0][slLoop2.slLabels.id_0] = overlap;
                crossingMatrix[slLoop2.slLabels.id_0][slLoop1.slLabels.id_0] = overlap;
            }
        }
    }
    return crossingMatrix;
}
function $computeLoopActivity(this$static, slHolder) {
    var lPortIdx, lPortTargetIdx, lPorts, loopActivity, slLoop, slLoop$iterator, slLoops;
    slLoops = slHolder.slHyperLoops;
    lPorts = slHolder.lNode.ports;
    for(slLoop$iterator = new ArrayList$1(slLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        loopActivity = initUnidimensionalArray(Z_classLit, $intern_90, 30, lPorts.array.length, 16, 1);
        $put_6(this$static.slLoopActivityOverPorts, slLoop, loopActivity);
        lPortIdx = slLoop.leftmostPort.lPort.id_0 - 1;
        lPortTargetIdx = slLoop.rightmostPort.lPort.id_0;
        while(lPortIdx != lPortTargetIdx){
            lPortIdx = (lPortIdx + 1) % lPorts.array.length;
            loopActivity[lPortIdx] = true;
        }
    }
}
function $countCrossings_0(this$static, slUpperLoop, slLowerLoop) {
    var crossings, lowerLoopActivity, slPort, slPort$iterator;
    lowerLoopActivity = castTo($get_10(this$static.slLoopActivityOverPorts, slLowerLoop), 183);
    crossings = 0;
    for(slPort$iterator = new ArrayList$1(slUpperLoop.slPorts); slPort$iterator.i < slPort$iterator.this$01.array.length;){
        slPort = castTo($next_6(slPort$iterator), 112);
        lowerLoopActivity[slPort.lPort.id_0] && ++crossings;
    }
    return crossings;
}
function $createCrossingGraph(this$static, slHolder, labelCrossingMatrix) {
    var firstIdx, secondIdx, segment, slLoop, slLoop$iterator, slLoop1, slLoops;
    slLoops = slHolder.slHyperLoops;
    this$static.hyperEdgeSegments = new ArrayList_0(slLoops.array.length);
    this$static.slLoopToSegmentMap = new HashMap;
    for(slLoop$iterator = new ArrayList$1(slLoops); slLoop$iterator.i < slLoop$iterator.this$01.array.length;){
        slLoop = castTo($next_6(slLoop$iterator), 105);
        segment = new HyperEdgeSegment(null);
        $add_3(this$static.hyperEdgeSegments, segment);
        $put_6(this$static.slLoopToSegmentMap, slLoop, segment);
    }
    this$static.slLoopActivityOverPorts = new HashMap;
    $computeLoopActivity(this$static, slHolder);
    for(firstIdx = 0; firstIdx < slLoops.array.length - 1; firstIdx++){
        slLoop1 = castTo($get_11(slHolder.slHyperLoops, firstIdx), 105);
        for(secondIdx = firstIdx + 1; secondIdx < slLoops.array.length; secondIdx++)$createDependencies(this$static, slLoop1, castTo($get_11(slHolder.slHyperLoops, secondIdx), 105), labelCrossingMatrix);
    }
}
function $createDependencies(this$static, slLoop1, slLoop2, labelCrossingMatrix) {
    var firstAboveSecondCrossings, secondAboveFirstCrossings, segment1, segment2;
    firstAboveSecondCrossings = $countCrossings_0(this$static, slLoop1, slLoop2);
    secondAboveFirstCrossings = $countCrossings_0(this$static, slLoop2, slLoop1);
    segment1 = castTo($get_10(this$static.slLoopToSegmentMap, slLoop1), 116);
    segment2 = castTo($get_10(this$static.slLoopToSegmentMap, slLoop2), 116);
    if (firstAboveSecondCrossings < secondAboveFirstCrossings) new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), REGULAR), segment1, segment2, secondAboveFirstCrossings - firstAboveSecondCrossings);
    else if (secondAboveFirstCrossings < firstAboveSecondCrossings) new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), REGULAR), segment2, segment1, firstAboveSecondCrossings - secondAboveFirstCrossings);
    else if (firstAboveSecondCrossings != 0 || !(!slLoop1.slLabels || !slLoop2.slLabels) && labelCrossingMatrix[slLoop1.slLabels.id_0][slLoop2.slLabels.id_0]) {
        new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), REGULAR), segment1, segment2, 0);
        new HyperEdgeSegmentDependency(REGULAR, segment2, segment1, 0);
    }
}
function $labelsOverlap(slLoop1, slLoop2) {
    var end1, end2, slLabels1, slLabels2, start1, start2;
    slLabels1 = slLoop1.slLabels;
    slLabels2 = slLoop2.slLabels;
    if (!slLabels1 || !slLabels2) return false;
    if (slLabels1.side != slLabels2.side || slLabels1.side == ($clinit_PortSide(), EAST_0) || slLabels1.side == ($clinit_PortSide(), WEST_0)) return false;
    start1 = slLabels1.position.x_0;
    end1 = start1 + slLabels1.size_0.x_0;
    start2 = slLabels2.position.x_0;
    end2 = start2 + slLabels2.size_0.x_0;
    return start1 <= end2 && end1 >= start2;
}
function $shiftTowardsNodeOnSide(this$static, slHolder, side, nextFreeRoutingSlotAtPort, labelCrossingMatrix) {
    var activeAtPort, i, lPort, lPort$iterator, lowestAvailableSlot, maxLPortIndex, minLPortIndex, otherLabelIdx, ourLabelIdx, portIndex, portIndex0, slLoop, slLoop$iterator, slLoops, slotAssignedToLabel, slotsWithLabelConflicts;
    slLoops = castTo($collect_1($sorted_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(slHolder.slHyperLoops, 16)), new RoutingSlotAssigner$lambda$0$Type(side)), new RoutingSlotAssigner$lambda$1$Type(side)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    minLPortIndex = $intern_0;
    maxLPortIndex = $intern_42;
    for(lPort$iterator = new ArrayList$1(slHolder.lNode.ports); lPort$iterator.i < lPort$iterator.this$01.array.length;){
        lPort = castTo($next_6(lPort$iterator), 11);
        if (lPort.side == side) {
            minLPortIndex = $wnd.Math.min(minLPortIndex, lPort.id_0);
            maxLPortIndex = $wnd.Math.max(maxLPortIndex, lPort.id_0);
        }
    }
    if (minLPortIndex == $intern_0) for(i = 0; i < slLoops.size_1(); i++)$setRoutingSlot(castTo(slLoops.get_0(i), 105), side, i);
    else {
        slotAssignedToLabel = initUnidimensionalArray(I_classLit, $intern_48, 30, labelCrossingMatrix.length, 15, 1);
        fill0_1(slotAssignedToLabel, slotAssignedToLabel.length);
        for(slLoop$iterator = slLoops.iterator_0(); slLoop$iterator.hasNext_0();){
            slLoop = castTo(slLoop$iterator.next_1(), 105);
            activeAtPort = castTo($get_10(this$static.slLoopActivityOverPorts, slLoop), 183);
            lowestAvailableSlot = 0;
            for(portIndex0 = minLPortIndex; portIndex0 <= maxLPortIndex; portIndex0++)activeAtPort[portIndex0] && (lowestAvailableSlot = $wnd.Math.max(lowestAvailableSlot, nextFreeRoutingSlotAtPort[portIndex0]));
            if (slLoop.slLabels) {
                ourLabelIdx = slLoop.slLabels.id_0;
                slotsWithLabelConflicts = new HashSet;
                for(otherLabelIdx = 0; otherLabelIdx < labelCrossingMatrix.length; otherLabelIdx++)labelCrossingMatrix[ourLabelIdx][otherLabelIdx] && $add_6(slotsWithLabelConflicts, valueOf_3(slotAssignedToLabel[otherLabelIdx]));
                while($contains_6(slotsWithLabelConflicts, valueOf_3(lowestAvailableSlot)))++lowestAvailableSlot;
            }
            $setRoutingSlot(slLoop, side, lowestAvailableSlot);
            for(portIndex = minLPortIndex; portIndex <= maxLPortIndex; portIndex++)activeAtPort[portIndex] && (nextFreeRoutingSlotAtPort[portIndex] = lowestAvailableSlot + 1);
            !!slLoop.slLabels && (slotAssignedToLabel[slLoop.slLabels.id_0] = lowestAvailableSlot);
        }
    }
}
function RoutingSlotAssigner() {}
function lambda$0_27(side_0, slLoop_1) {
    return $containsEnum(slLoop_1.occupiedPortSides, side_0);
}
function lambda$1_14(side_0, sl1_1, sl2_2) {
    return compare_5(sl1_1.routingSlot[side_0.ordinal], sl2_2.routingSlot[side_0.ordinal]);
}
defineClass(1764, 1, {}, RoutingSlotAssigner);
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingSlotAssigner_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingSlotAssigner', 1764);
function RoutingSlotAssigner$lambda$0$Type(side_0) {
    this.side_0 = side_0;
}
defineClass(1765, 1, $intern_39, RoutingSlotAssigner$lambda$0$Type);
_.test_0 = function test_73(arg0) {
    return lambda$0_27(this.side_0, castTo(arg0, 105));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingSlotAssigner$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingSlotAssigner/lambda$0$Type', 1765);
function RoutingSlotAssigner$lambda$1$Type(side_0) {
    this.side_0 = side_0;
}
defineClass(1766, 1, $intern_88, RoutingSlotAssigner$lambda$1$Type);
_.compare_1 = function compare_54(arg0, arg1) {
    return lambda$1_14(this.side_0, castTo(arg0, 105), castTo(arg1, 105));
};
_.equals_0 = function equals_135(other) {
    return this === other;
};
_.reversed = function reversed_46() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_RoutingSlotAssigner$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'RoutingSlotAssigner/lambda$1$Type', 1766);
function $addSplineControlPoints(slEdge, routingDirection, orthoBendPoints, newBendPoints, edgeLabelDistance) {
    var currPortSide, firstBP, midBP, offset, secondBP, secondBPIndex;
    currPortSide = slEdge.slSource.lPort.side;
    firstBP = castTo($get_7(orthoBendPoints, 0), 8);
    for(secondBPIndex = 1; secondBPIndex < orthoBendPoints.size_0; secondBPIndex++){
        secondBP = castTo($get_7(orthoBendPoints, secondBPIndex), 8);
        $addNode_0(newBendPoints, firstBP, newBendPoints.tail.prev, newBendPoints.tail);
        midBP = $scale($add_19(new KVector_2(firstBP), secondBP), 0.5);
        offset = $scale(new KVector_0(portSideToDirection(currPortSide)), edgeLabelDistance);
        $add_19(midBP, offset);
        $addNode_0(newBendPoints, midBP, newBendPoints.tail.prev, newBendPoints.tail);
        firstBP = secondBP;
        currPortSide = routingDirection == 0 ? $right(currPortSide) : $left(currPortSide);
    }
    $add_7(newBendPoints, (checkCriticalElement(orthoBendPoints.size_0 != 0), castTo(orthoBendPoints.tail.prev.value_0, 8)));
}
function SplineSelfLoopRouter() {}
defineClass(1805, 1802, {}, SplineSelfLoopRouter);
_.modifyBendPoints = function modifyBendPoints_1(slEdge, routingDirection, bendPoints) {
    var edgeLabelDistance, lPort, lPort0, splineBendPoints;
    edgeLabelDistance = $doubleValue(castToDouble(getIndividualOrInherited(slEdge.slHyperLoop.slHolder.lNode, ($clinit_LayeredOptions(), SPACING_EDGE_LABEL_0))));
    splineBendPoints = new KVectorChain_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        (lPort0 = slEdge.slSource.lPort, $add_19(new KVector_2(lPort0.pos), lPort0.anchor))
    ]));
    $addSplineControlPoints(slEdge, routingDirection, bendPoints, splineBendPoints, edgeLabelDistance);
    $add_7(splineBendPoints, (lPort = slEdge.slTarget.lPort, $add_19(new KVector_2(lPort.pos), lPort.anchor)));
    return $getBezierCP(new NubSpline(splineBendPoints));
};
var Lorg_eclipse_elk_alg_layered_intermediate_loops_routing_SplineSelfLoopRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.loops.routing', 'SplineSelfLoopRouter', 1805);
function $compare_11(this$static, n1, n2) {
    var comparedWithLongEdgeFeedback, n1EdgeOrder, n1ModelOrder, n2EdgeOrder, n2ModelOrder, p, p$iterator, p$iterator0, p1Node, p1SourcePort, p2Node, p2SourcePort, port, port$iterator, previousNode, previousNode$array, previousNode$index, previousNode$max;
    if ($containsKey_3(this$static.biggerThan, n1)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, n1), 50), n2)) return 1;
    } else $put_6(this$static.biggerThan, n1, new HashSet);
    if ($containsKey_3(this$static.biggerThan, n2)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, n2), 50), n1)) return -1;
    } else $put_6(this$static.biggerThan, n2, new HashSet);
    if ($containsKey_3(this$static.smallerThan, n1)) {
        if ($contains_6(castTo($get_10(this$static.smallerThan, n1), 50), n2)) return -1;
    } else $put_6(this$static.smallerThan, n1, new HashSet);
    if ($containsKey_3(this$static.smallerThan, n2)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, n2), 50), n1)) return 1;
    } else $put_6(this$static.smallerThan, n2, new HashSet);
    if (this$static.orderingStrategy == ($clinit_OrderingStrategy(), PREFER_EDGES) || !$hasProperty(n1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) || !$hasProperty(n2, ($clinit_InternalProperties_1(), MODEL_ORDER_1))) {
        p1SourcePort = null;
        for(p$iterator0 = new ArrayList$1(n1.ports); p$iterator0.i < p$iterator0.this$01.array.length;){
            p = castTo($next_6(p$iterator0), 11);
            p.incomingEdges.array.length == 0 || castTo($get_11(p.incomingEdges, 0), 18).source.owner.layer.id_0 == n1.layer.id_0 - 1 && (p1SourcePort = castTo($get_11(p.incomingEdges, 0), 18).source);
        }
        p2SourcePort = null;
        for(p$iterator = new ArrayList$1(n2.ports); p$iterator.i < p$iterator.this$01.array.length;){
            p = castTo($next_6(p$iterator), 11);
            p.incomingEdges.array.length == 0 || castTo($get_11(p.incomingEdges, 0), 18).source.owner.layer.id_0 == n2.layer.id_0 - 1 && (p2SourcePort = castTo($get_11(p.incomingEdges, 0), 18).source);
        }
        if (!!p1SourcePort && !!p2SourcePort) {
            p1Node = p1SourcePort.owner;
            p2Node = p2SourcePort.owner;
            if (!!p1Node && p1Node == p2Node) {
                for(port$iterator = new ArrayList$1(p1Node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                    port = castTo($next_6(port$iterator), 11);
                    if (port == p1SourcePort) {
                        $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                        return -1;
                    } else if (port == p2SourcePort) {
                        $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                        return 1;
                    }
                }
                n1EdgeOrder = $getModelOrderFromConnectedEdges(this$static, n1);
                n2EdgeOrder = $getModelOrderFromConnectedEdges(this$static, n2);
                if (n1EdgeOrder > n2EdgeOrder) {
                    $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                    return 1;
                } else {
                    $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                    return -1;
                }
            }
            for(previousNode$array = this$static.previousLayer, previousNode$index = 0, previousNode$max = previousNode$array.length; previousNode$index < previousNode$max; ++previousNode$index){
                previousNode = previousNode$array[previousNode$index];
                if (previousNode == p1Node) {
                    $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                    return -1;
                } else if (previousNode == p2Node) {
                    $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                    return 1;
                }
            }
        }
        if (!!p1SourcePort && !p2SourcePort || !p1SourcePort && !!p2SourcePort) {
            comparedWithLongEdgeFeedback = $handleHelperDummyNodes(this$static, n1, n2);
            if (comparedWithLongEdgeFeedback != 0) {
                comparedWithLongEdgeFeedback > 0 ? $updateBiggerAndSmallerAssociations(this$static, n1, n2) : $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                return comparedWithLongEdgeFeedback;
            }
            if (!$hasProperty(n1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) || !$hasProperty(n2, MODEL_ORDER_1)) {
                n1ModelOrder = $getModelOrderFromConnectedEdges(this$static, n1);
                n2ModelOrder = $getModelOrderFromConnectedEdges(this$static, n2);
                if (n1ModelOrder > n2ModelOrder) {
                    $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                    return 1;
                } else {
                    $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                    return -1;
                }
            }
        }
        if (!p1SourcePort && !p2SourcePort) {
            comparedWithLongEdgeFeedback = $handleHelperDummyNodes(this$static, n1, n2);
            if (comparedWithLongEdgeFeedback != 0) {
                comparedWithLongEdgeFeedback > 0 ? $updateBiggerAndSmallerAssociations(this$static, n1, n2) : $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                return comparedWithLongEdgeFeedback;
            }
        }
    }
    if ($hasProperty(n1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(n2, MODEL_ORDER_1)) {
        n1ModelOrder = castTo($getProperty(n1, MODEL_ORDER_1), 17).value_0;
        n2ModelOrder = castTo($getProperty(n2, MODEL_ORDER_1), 17).value_0;
        if (n1ModelOrder > n2ModelOrder) {
            $updateBiggerAndSmallerAssociations(this$static, n1, n2);
            return 1;
        } else {
            $updateBiggerAndSmallerAssociations(this$static, n2, n1);
            return -1;
        }
    } else {
        $updateBiggerAndSmallerAssociations(this$static, n2, n1);
        return -1;
    }
}
function $getModelOrderFromConnectedEdges(this$static, n) {
    var edge, sourcePort;
    sourcePort = castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n.ports, 16)), new ModelOrderNodeComparator$lambda$0$Type))), 11);
    if (sourcePort) {
        edge = castTo($get_11(sourcePort.incomingEdges, 0), 18);
        if (edge) return castTo($getProperty(edge, ($clinit_InternalProperties_1(), MODEL_ORDER_1)), 17).value_0;
    }
    return $returnValue(this$static.longEdgeNodeOrder);
}
function $handleHelperDummyNodes(this$static, n1, n2) {
    var dummyLayerId, dummyNodeSourceNode, dummyNodeSourcePort, dummyNodeTargetNode, dummyNodeTargetPort, n1LayerId, n1ReferenceNode, n1SourceFeedbackNode, n1TargetFeedbackNode, n1dummyNodeSourcePort, n1dummyNodeTargetPort, n1dummySourceNode, n1dummyTargetNode, n2LayerId, n2ReferenceNode, n2SourceFeedbackNode, n2TargetFeedbackNode, n2dummyNodeSourcePort, n2dummyNodeTargetPort, n2dummySourceNode, n2dummyTargetNode, port, port$iterator, returnValue_0;
    if (n1.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) && n2.type_0 == NORMAL) {
        dummyNodeSourcePort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n1.ports, 16)), new ModelOrderNodeComparator$lambda$1$Type))), 11).incomingEdges, 0), 18).source;
        dummyNodeSourceNode = dummyNodeSourcePort.owner;
        dummyNodeTargetPort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n1.ports, 16)), new ModelOrderNodeComparator$lambda$2$Type))), 11).outgoingEdges, 0), 18).target;
        dummyNodeTargetNode = dummyNodeTargetPort.owner;
        dummyLayerId = n1.layer.id_0;
        if (dummyNodeSourceNode.layer.id_0 != dummyLayerId && dummyNodeTargetNode.layer.id_0 != dummyLayerId) return 0;
        if (dummyNodeSourceNode == n2) {
            $updateBiggerAndSmallerAssociations(this$static, n1, n2);
            return 1;
        } else {
            if (dummyNodeTargetNode == n2) {
                $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                return 1;
            }
            return $compare_11(this$static, dummyNodeSourceNode, n2);
        }
    } else if (n1.type_0 == NORMAL && n2.type_0 == LONG_EDGE) {
        dummyNodeSourcePort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n2.ports, 16)), new ModelOrderNodeComparator$lambda$1$Type))), 11).incomingEdges, 0), 18).source;
        dummyNodeSourceNode = dummyNodeSourcePort.owner;
        dummyNodeTargetPort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n2.ports, 16)), new ModelOrderNodeComparator$lambda$2$Type))), 11).outgoingEdges, 0), 18).target;
        dummyNodeTargetNode = dummyNodeTargetPort.owner;
        dummyLayerId = n1.layer.id_0;
        if (dummyNodeSourceNode.layer.id_0 != dummyLayerId && dummyNodeTargetNode.layer.id_0 != dummyLayerId) return 0;
        if (dummyNodeSourceNode == n1) {
            $updateBiggerAndSmallerAssociations(this$static, n2, n1);
            return -1;
        } else {
            if (dummyNodeTargetNode == n1) {
                $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                return -1;
            }
            return $compare_11(this$static, n1, dummyNodeSourceNode);
        }
    } else if (n1.type_0 == LONG_EDGE && n2.type_0 == LONG_EDGE) {
        n1dummyNodeSourcePort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n1.ports, 16)), new ModelOrderNodeComparator$lambda$1$Type))), 11).incomingEdges, 0), 18).source;
        n1dummyNodeTargetPort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n1.ports, 16)), new ModelOrderNodeComparator$lambda$2$Type))), 11).outgoingEdges, 0), 18).target;
        n1dummySourceNode = n1dummyNodeSourcePort.owner;
        n1dummyTargetNode = n1dummyNodeTargetPort.owner;
        n1LayerId = n1.layer.id_0;
        n1SourceFeedbackNode = false;
        n1TargetFeedbackNode = false;
        n2dummyNodeSourcePort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n2.ports, 16)), new ModelOrderNodeComparator$lambda$1$Type))), 11).incomingEdges, 0), 18).source;
        n2dummyNodeTargetPort = castTo($get_11(castTo($orElse($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(n2.ports, 16)), new ModelOrderNodeComparator$lambda$2$Type))), 11).outgoingEdges, 0), 18).target;
        n2dummySourceNode = n2dummyNodeSourcePort.owner;
        n2dummyTargetNode = n2dummyNodeTargetPort.owner;
        n2LayerId = n2.layer.id_0;
        n2SourceFeedbackNode = false;
        n2TargetFeedbackNode = false;
        n1ReferenceNode = n1;
        n2ReferenceNode = n2;
        if (n1dummySourceNode.layer.id_0 == n1LayerId) {
            n1SourceFeedbackNode = true;
            n1ReferenceNode = n1dummySourceNode;
        } else if (n1dummyTargetNode.layer.id_0 == n1LayerId) {
            n1TargetFeedbackNode = true;
            n1ReferenceNode = n1dummyTargetNode;
        }
        if (n2dummySourceNode.layer.id_0 == n2LayerId) {
            n2SourceFeedbackNode = true;
            n2ReferenceNode = n2dummySourceNode;
        } else if (n2dummyTargetNode.layer.id_0 == n2LayerId) {
            n2TargetFeedbackNode = true;
            n2ReferenceNode = n2dummyTargetNode;
        }
        if (n1ReferenceNode == n2ReferenceNode) {
            if (this$static.beforePorts) {
                if (n1SourceFeedbackNode && n2SourceFeedbackNode) {
                    returnValue_0 = $compare_13(new ModelOrderPortComparator_0(this$static.previousLayer, this$static.orderingStrategy, null, n2TargetFeedbackNode), n1dummyNodeSourcePort, n2dummyNodeSourcePort);
                    if (returnValue_0 > 0) {
                        $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                        return 1;
                    } else {
                        $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                        return -1;
                    }
                } else if (n1SourceFeedbackNode && n2TargetFeedbackNode) {
                    $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                    return 1;
                } else if (n1TargetFeedbackNode && n2SourceFeedbackNode) {
                    $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                    return -1;
                } else if (n1TargetFeedbackNode && n2TargetFeedbackNode) return 0;
            } else for(port$iterator = new ArrayList$1(n1ReferenceNode.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                if (n1dummyNodeSourcePort == port) {
                    $updateBiggerAndSmallerAssociations(this$static, n2, n1);
                    return -1;
                } else if (n2dummyNodeSourcePort == port) {
                    $updateBiggerAndSmallerAssociations(this$static, n1, n2);
                    return 1;
                }
            }
        }
        return $compare_11(this$static, n1ReferenceNode, n2ReferenceNode);
    } else return 0;
}
function $updateBiggerAndSmallerAssociations(this$static, bigger, smaller) {
    var biggerNodeBiggerThan, biggerNodeSmallerThan, smallerNodeBiggerThan, smallerNodeSmallerThan, veryBig, veryBig$iterator, verySmall, verySmall$iterator;
    biggerNodeBiggerThan = castTo($get_10(this$static.biggerThan, bigger), 50);
    smallerNodeBiggerThan = castTo($get_10(this$static.biggerThan, smaller), 50);
    biggerNodeSmallerThan = castTo($get_10(this$static.smallerThan, bigger), 50);
    smallerNodeSmallerThan = castTo($get_10(this$static.smallerThan, smaller), 50);
    biggerNodeBiggerThan.map_0.put(smaller, biggerNodeBiggerThan);
    smallerNodeSmallerThan.map_0.put(bigger, smallerNodeSmallerThan);
    for(verySmall$iterator = smallerNodeBiggerThan.map_0.keySet_0().iterator_0(); verySmall$iterator.hasNext_0();){
        verySmall = castTo(verySmall$iterator.next_1(), 9);
        biggerNodeBiggerThan.map_0.put(verySmall, biggerNodeBiggerThan);
        $add_6(castTo($get_10(this$static.smallerThan, verySmall), 50), bigger);
        $addAll(castTo($get_10(this$static.smallerThan, verySmall), 50), biggerNodeSmallerThan);
    }
    for(veryBig$iterator = biggerNodeSmallerThan.map_0.keySet_0().iterator_0(); veryBig$iterator.hasNext_0();){
        veryBig = castTo(veryBig$iterator.next_1(), 9);
        smallerNodeSmallerThan.map_0.put(veryBig, smallerNodeSmallerThan);
        $add_6(castTo($get_10(this$static.biggerThan, veryBig), 50), smaller);
        $addAll(castTo($get_10(this$static.biggerThan, veryBig), 50), smallerNodeBiggerThan);
    }
}
function ModelOrderNodeComparator(thePreviousLayer, orderingStrategy, longEdgeOrderingStrategy, beforePorts) {
    ModelOrderNodeComparator_0.call(this, orderingStrategy, longEdgeOrderingStrategy, beforePorts);
    this.previousLayer = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, thePreviousLayer.nodes.array.length, 0, 1);
    $toArray_1(thePreviousLayer.nodes, this.previousLayer);
}
function ModelOrderNodeComparator_0(orderingStrategy, longEdgeOrderingStrategy, beforePorts) {
    this.biggerThan = new HashMap;
    this.smallerThan = new HashMap;
    this.longEdgeNodeOrder = ($clinit_LongEdgeOrderingStrategy(), EQUAL);
    this.orderingStrategy = orderingStrategy;
    this.longEdgeNodeOrder = longEdgeOrderingStrategy;
    this.beforePorts = beforePorts;
}
function ModelOrderNodeComparator_1(previousLayer, orderingStrategy, longEdgeOrderingStrategy) {
    ModelOrderNodeComparator_0.call(this, orderingStrategy, longEdgeOrderingStrategy, false);
    this.previousLayer = previousLayer;
}
defineClass(510, 1, $intern_88, ModelOrderNodeComparator, ModelOrderNodeComparator_1);
_.compare_1 = function compare_55(n1, n2) {
    return $compare_11(this, castTo(n1, 9), castTo(n2, 9));
};
_.equals_0 = function equals_136(other) {
    return this === other;
};
_.reversed = function reversed_47() {
    return new Comparators$ReversedComparator(this);
};
_.beforePorts = false;
var Lorg_eclipse_elk_alg_layered_intermediate_preserveorder_ModelOrderNodeComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.preserveorder', 'ModelOrderNodeComparator', 510);
function ModelOrderNodeComparator$lambda$0$Type() {}
defineClass(1767, 1, $intern_39, ModelOrderNodeComparator$lambda$0$Type);
_.test_0 = function test_74(arg0) {
    return castTo(arg0, 11).incomingEdges.array.length != 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_preserveorder_ModelOrderNodeComparator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.preserveorder', 'ModelOrderNodeComparator/lambda$0$Type', 1767);
function ModelOrderNodeComparator$lambda$1$Type() {}
defineClass(568, 1, $intern_39, ModelOrderNodeComparator$lambda$1$Type);
_.test_0 = function test_75(arg0) {
    return castTo(arg0, 11).incomingEdges.array.length != 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_preserveorder_ModelOrderNodeComparator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.preserveorder', 'ModelOrderNodeComparator/lambda$1$Type', 568);
function ModelOrderNodeComparator$lambda$2$Type() {}
defineClass(569, 1, $intern_39, ModelOrderNodeComparator$lambda$2$Type);
_.test_0 = function test_76(arg0) {
    return castTo(arg0, 11).outgoingEdges.array.length != 0;
};
var Lorg_eclipse_elk_alg_layered_intermediate_preserveorder_ModelOrderNodeComparator$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.preserveorder', 'ModelOrderNodeComparator/lambda$2$Type', 569);
function $$init_7(this$static) {
    this$static.biggerThan = new HashMap;
    this$static.smallerThan = new HashMap;
}
function $checkPortModelOrder(p1, p2) {
    if ($hasProperty(p1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(p2, MODEL_ORDER_1)) return compare_5(castTo($getProperty(p1, MODEL_ORDER_1), 17).value_0, castTo($getProperty(p2, MODEL_ORDER_1), 17).value_0);
    return 0;
}
function $checkReferenceLayer(layer, p1Node, p2Node) {
    var node, node$iterator;
    for(node$iterator = layer.iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 9);
        if (node == p1Node) return -1;
        else if (node == p2Node) return 1;
    }
    return 0;
}
function $compare_12(this$static, originalP1, originalP2) {
    return $compare_13(this$static, castTo(originalP1, 11), castTo(originalP2, 11));
}
function $compare_13(this$static, originalP1, originalP2) {
    var inPreviousLayer, inPreviousLayer0, p1, p1MO, p1Node, p1Order, p1SourcePort, p1TargetNode, p2, p2MO, p2Node, p2Order, p2SourcePort, p2TargetNode, port, port$iterator, previousLayer, result, reverseOrder;
    p1 = originalP1;
    p2 = originalP2;
    if ($containsKey_3(this$static.biggerThan, p1)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, p1), 50), p2)) return 1;
    } else $put_6(this$static.biggerThan, p1, new HashSet);
    if ($containsKey_3(this$static.biggerThan, p2)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, p2), 50), p1)) return -1;
    } else $put_6(this$static.biggerThan, p2, new HashSet);
    if ($containsKey_3(this$static.smallerThan, p1)) {
        if ($contains_6(castTo($get_10(this$static.smallerThan, p1), 50), p2)) return -1;
    } else $put_6(this$static.smallerThan, p1, new HashSet);
    if ($containsKey_3(this$static.smallerThan, p2)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, p2), 50), p1)) return 1;
    } else $put_6(this$static.smallerThan, p2, new HashSet);
    if (p1.side != p2.side) {
        result = $compare_14(p1.side, p2.side);
        result > 0 ? $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, 1) : $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, 1);
        return result;
    }
    reverseOrder = 1;
    if (p1.incomingEdges.array.length != 0 && p2.incomingEdges.array.length != 0) {
        (p1.side == ($clinit_PortSide(), WEST_0) && p2.side == WEST_0 || p1.side == NORTH_1 && p2.side == NORTH_1 || p1.side == SOUTH_0 && p2.side == SOUTH_0) && (reverseOrder = -reverseOrder);
        p1SourcePort = castTo($get_11(p1.incomingEdges, 0), 18).source;
        p2SourcePort = castTo($get_11(p2.incomingEdges, 0), 18).source;
        p1Node = p1SourcePort.owner;
        p2Node = p2SourcePort.owner;
        if (p1Node == p2Node) for(port$iterator = new ArrayList$1(p1Node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            if (p1SourcePort == port) {
                $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                return -reverseOrder;
            } else if (p2SourcePort == port) {
                $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                return reverseOrder;
            }
        }
        if (p1SourcePort.owner.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) && p2SourcePort.owner.type_0 == LONG_EDGE && p1Node.layer.id_0 == p2Node.layer.id_0 && p1Node.layer.id_0 == p1.owner.layer.id_0) {
            previousLayer = p1Node.layer;
            inPreviousLayer0 = $checkReferenceLayer(previousLayer, p1Node, p2Node);
            if (inPreviousLayer0 != 0) {
                p1.side == EAST_0 && p2.side == EAST_0 && (reverseOrder = -reverseOrder);
                if (inPreviousLayer0 > 0) {
                    $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                    return reverseOrder;
                } else {
                    $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                    return -reverseOrder;
                }
            }
        }
        inPreviousLayer = $checkReferenceLayer(castTo($collect_1(stream_4(this$static.previousLayer), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
            ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
        ]))), 20), p1Node, p2Node);
        if (inPreviousLayer != 0) {
            if (inPreviousLayer > 0) {
                $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                return reverseOrder;
            } else {
                $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                return -reverseOrder;
            }
        }
        if (this$static.portModelOrder) {
            result = $checkPortModelOrder(p1, p2);
            if (result != 0) {
                if (result > 0) {
                    $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                    return reverseOrder;
                } else {
                    $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                    return -reverseOrder;
                }
            }
        }
    }
    if (p1.outgoingEdges.array.length != 0 && p2.outgoingEdges.array.length != 0) {
        (p1.side == ($clinit_PortSide(), WEST_0) && p2.side == WEST_0 || p1.side == SOUTH_0 && p2.side == SOUTH_0) && (reverseOrder = -reverseOrder);
        p1TargetNode = castTo($getProperty(p1, ($clinit_InternalProperties_1(), LONG_EDGE_TARGET_NODE)), 9);
        p2TargetNode = castTo($getProperty(p2, LONG_EDGE_TARGET_NODE), 9);
        if (this$static.strategy == ($clinit_OrderingStrategy(), PREFER_NODES) && !!p1TargetNode && !!p2TargetNode && $hasProperty(p1TargetNode, MODEL_ORDER_1) && $hasProperty(p2TargetNode, MODEL_ORDER_1)) {
            p1MO = castTo($getProperty(p1TargetNode, MODEL_ORDER_1), 17).value_0;
            p2MO = castTo($getProperty(p2TargetNode, MODEL_ORDER_1), 17).value_0;
            if (p1MO > p2MO) {
                $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                return reverseOrder;
            } else {
                $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                return -reverseOrder;
            }
        }
        if (this$static.portModelOrder) {
            result = $checkPortModelOrder(p1, p2);
            if (result != 0) {
                if (result > 0) {
                    $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                    return reverseOrder;
                } else {
                    $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                    return -reverseOrder;
                }
            }
        }
        p1Order = 0;
        p2Order = 0;
        $hasProperty(castTo($get_11(p1.outgoingEdges, 0), 18), MODEL_ORDER_1) && (p1Order = castTo($getProperty(castTo($get_11(p1.outgoingEdges, 0), 18), MODEL_ORDER_1), 17).value_0);
        $hasProperty(castTo($get_11(p2.outgoingEdges, 0), 18), MODEL_ORDER_1) && (p2Order = castTo($getProperty(castTo($get_11(p2.outgoingEdges, 0), 18), MODEL_ORDER_1), 17).value_0);
        if (!!p1TargetNode && p1TargetNode == p2TargetNode) {
            if (p1Order > p2Order) {
                $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
                return reverseOrder;
            } else {
                $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
                return -reverseOrder;
            }
        }
        if (this$static.targetNodeModelOrder) {
            this$static.targetNodeModelOrder.containsKey(p1TargetNode) && (p1Order = castTo(this$static.targetNodeModelOrder.get_3(p1TargetNode), 17).value_0);
            this$static.targetNodeModelOrder.containsKey(p2TargetNode) && (p2Order = castTo(this$static.targetNodeModelOrder.get_3(p2TargetNode), 17).value_0);
        }
        if (p1Order > p2Order) {
            $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
            return reverseOrder;
        } else {
            $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
            return -reverseOrder;
        }
    }
    if (p1.incomingEdges.array.length != 0 && p2.outgoingEdges.array.length != 0) {
        $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
        return 1;
    } else if (p1.outgoingEdges.array.length != 0 && p2.incomingEdges.array.length != 0) {
        $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
        return -1;
    } else if ($hasProperty(p1, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(p2, MODEL_ORDER_1)) {
        p1MO = castTo($getProperty(p1, MODEL_ORDER_1), 17).value_0;
        p2MO = castTo($getProperty(p2, MODEL_ORDER_1), 17).value_0;
        (p1.side == ($clinit_PortSide(), WEST_0) && p2.side == WEST_0 || p1.side == SOUTH_0 && p2.side == SOUTH_0) && (reverseOrder = -reverseOrder);
        if (p1MO > p2MO) {
            $updateBiggerAndSmallerAssociations_0(this$static, p1, p2, reverseOrder);
            return reverseOrder;
        } else {
            $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
            return -reverseOrder;
        }
    } else {
        $updateBiggerAndSmallerAssociations_0(this$static, p2, p1, reverseOrder);
        return -reverseOrder;
    }
}
function $updateBiggerAndSmallerAssociations_0(this$static, biggerOri, smallerOri, reverseOrder) {
    var bigger, biggerPortBiggerThan, biggerPortSmallerThan, smaller, smallerPortBiggerThan, smallerPortSmallerThan, veryBig, veryBig$iterator, verySmall, verySmall$iterator;
    bigger = biggerOri;
    smaller = smallerOri;
    if (reverseOrder < 0) {
        bigger = smallerOri;
        smaller = biggerOri;
    }
    biggerPortBiggerThan = castTo($get_10(this$static.biggerThan, bigger), 50);
    smallerPortBiggerThan = castTo($get_10(this$static.biggerThan, smaller), 50);
    biggerPortSmallerThan = castTo($get_10(this$static.smallerThan, bigger), 50);
    smallerPortSmallerThan = castTo($get_10(this$static.smallerThan, smaller), 50);
    biggerPortBiggerThan.map_0.put(smaller, biggerPortBiggerThan);
    smallerPortSmallerThan.map_0.put(bigger, smallerPortSmallerThan);
    for(verySmall$iterator = smallerPortBiggerThan.map_0.keySet_0().iterator_0(); verySmall$iterator.hasNext_0();){
        verySmall = castTo(verySmall$iterator.next_1(), 11);
        biggerPortBiggerThan.map_0.put(verySmall, biggerPortBiggerThan);
        $add_6(castTo($get_10(this$static.smallerThan, verySmall), 50), bigger);
        $addAll(castTo($get_10(this$static.smallerThan, verySmall), 50), biggerPortSmallerThan);
    }
    for(veryBig$iterator = biggerPortSmallerThan.map_0.keySet_0().iterator_0(); veryBig$iterator.hasNext_0();){
        veryBig = castTo(veryBig$iterator.next_1(), 11);
        smallerPortSmallerThan.map_0.put(veryBig, smallerPortSmallerThan);
        $add_6(castTo($get_10(this$static.biggerThan, veryBig), 50), smaller);
        $addAll(castTo($get_10(this$static.biggerThan, veryBig), 50), smallerPortBiggerThan);
    }
}
function ModelOrderPortComparator(previousLayer, strategy, targetNodeModelOrder, portModelOrder) {
    $$init_7(this);
    this.previousLayer = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, previousLayer.nodes.array.length, 0, 1);
    this.strategy = strategy;
    $toArray_1(previousLayer.nodes, this.previousLayer);
    this.targetNodeModelOrder = targetNodeModelOrder;
    this.portModelOrder = portModelOrder;
}
function ModelOrderPortComparator_0(previousLayer, strategy, targetNodeModelOrder, portModelOrder) {
    $$init_7(this);
    this.previousLayer = previousLayer;
    this.strategy = strategy;
    this.targetNodeModelOrder = targetNodeModelOrder;
    this.portModelOrder = portModelOrder;
}
defineClass(651, 1, $intern_88, ModelOrderPortComparator, ModelOrderPortComparator_0);
_.compare_1 = function compare_56(originalP1, originalP2) {
    return $compare_12(this, originalP1, originalP2);
};
_.equals_0 = function equals_137(other) {
    return this === other;
};
_.reversed = function reversed_48() {
    return new Comparators$ReversedComparator(this);
};
_.portModelOrder = false;
var Lorg_eclipse_elk_alg_layered_intermediate_preserveorder_ModelOrderPortComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.preserveorder', 'ModelOrderPortComparator', 651);
function $compare_14(ps1, ps2) {
    return compare_5(ps1.ordinal, ps2.ordinal);
}
function $createDummyNode_1(graph, nextEdgeToSplit) {
    var dummyNode;
    dummyNode = new LNode(graph);
    $setType(dummyNode, ($clinit_LNode$NodeType(), LONG_EDGE));
    $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), nextEdgeToSplit);
    $setProperty_0(dummyNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_POS));
    return dummyNode;
}
function $getLayerSplitProperty(layer) {
    var i, layerSplit, nodeValue, propertyUnset;
    layerSplit = $intern_0;
    propertyUnset = true;
    for(i = 0; i < layer.nodes.array.length; i++)if ($hasProperty(castTo($get_11(layer.nodes, i), 9), ($clinit_LayeredOptions(), LAYER_UNZIPPING_LAYER_SPLIT_0))) {
        propertyUnset = false;
        nodeValue = castTo($getProperty(castTo($get_11(layer.nodes, i), 9), LAYER_UNZIPPING_LAYER_SPLIT_0), 17).value_0;
        layerSplit = layerSplit < nodeValue ? layerSplit : nodeValue;
    }
    propertyUnset && (layerSplit = castTo($getDefault(($clinit_LayeredOptions(), LAYER_UNZIPPING_LAYER_SPLIT_0)), 17).value_0);
    return layerSplit;
}
function $getResetOnLongEdgesProperty(layer) {
    var i;
    for(i = 0; i < layer.nodes.array.length; i++)if ($hasProperty(castTo($get_11(layer.nodes, i), 9), ($clinit_LayeredOptions(), LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0))) {
        if (!$booleanValue(castToBoolean($getProperty(castTo($get_11(layer.nodes, i), 9), LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0)))) return false;
    }
    return true;
}
function $process_53(graph) {
    var N, i, insertionLayerOffset, j, j0, layer, layer$iterator, newLayer, newLayer$iterator, newLayers, node, nodeIndex, nodeIterator, nodesInLayer, resetOnLongEdges, subLayers, targetLayer;
    $processLayerSplitProperty(graph);
    insertionLayerOffset = 1;
    newLayers = new ArrayList;
    for(i = 0; i < graph.layers.array.length; i++){
        N = $getLayerSplitProperty(castTo($get_11(graph.layers, i), 25));
        resetOnLongEdges = $getResetOnLongEdgesProperty(castTo($get_11(graph.layers, i), 25));
        if (castTo($get_11(graph.layers, i), 25).nodes.array.length > N) {
            subLayers = new ArrayList;
            $add_3(subLayers, castTo($get_11(graph.layers, i), 25));
            for(j0 = 0; j0 < N - 1; j0++){
                newLayer = new Layer(graph);
                $add_3(newLayers, new Pair(newLayer, valueOf_3(i + j0 + insertionLayerOffset)));
                push_1(subLayers.array, newLayer);
            }
            insertionLayerOffset += N - 1;
            nodesInLayer = (checkCriticalElementIndex(0, subLayers.array.length), castTo(subLayers.array[0], 25)).nodes.array.length;
            for(j = 0, nodeIndex = 0, targetLayer = 0; j < nodesInLayer; ++j, ++nodeIndex, targetLayer++){
                node = castTo($get_11((checkCriticalElementIndex(0, subLayers.array.length), castTo(subLayers.array[0], 25)).nodes, nodeIndex), 9);
                if (node.type_0 != ($clinit_LNode$NodeType(), NONSHIFTING_PLACEHOLDER)) nodeIndex += $shiftNode(graph, subLayers, targetLayer % N, nodeIndex);
                else {
                    j -= 1;
                    targetLayer -= 1;
                }
                resetOnLongEdges && node.type_0 == LONG_EDGE && (targetLayer = -1);
            }
        }
    }
    for(newLayer$iterator = new ArrayList$1(newLayers); newLayer$iterator.i < newLayer$iterator.this$01.array.length;){
        newLayer = castTo($next_6(newLayer$iterator), 47);
        $add_2(graph.layers, castTo(newLayer.second, 17).value_0, castTo(newLayer.first, 25));
    }
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodeIterator = new AbstractList$ListIteratorImpl(layer.nodes, 0);
        while(nodeIterator.i < nodeIterator.this$01_0.size_1()){
            node = (checkCriticalElement(nodeIterator.i < nodeIterator.this$01_0.size_1()), castTo(nodeIterator.this$01_0.get_0(nodeIterator.last = nodeIterator.i++), 9));
            (node.type_0 == ($clinit_LNode$NodeType(), PLACEHOLDER) || node.type_0 == NONSHIFTING_PLACEHOLDER) && $remove_8(nodeIterator);
        }
    }
}
function $processLayerSplitProperty(graph) {
    var layer, layer$iterator, node, node$iterator, setLayerSplit, setResetOnLongEdges;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        setLayerSplit = false;
        setResetOnLongEdges = false;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (!setLayerSplit && $hasProperty(node, ($clinit_LayeredOptions(), LAYER_UNZIPPING_LAYER_SPLIT_0))) {
                $setProperty_0(layer, ($clinit_LayeredOptions(), LAYER_UNZIPPING_LAYER_SPLIT_0), castTo($getProperty(node, LAYER_UNZIPPING_LAYER_SPLIT_0), 17));
                setLayerSplit = true;
            }
            if (!setResetOnLongEdges && $hasProperty(node, ($clinit_LayeredOptions(), LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0))) {
                $setProperty_0(layer, ($clinit_LayeredOptions(), LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0), castToBoolean($getProperty(node, LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0)));
                setResetOnLongEdges = true;
            }
            if (setLayerSplit && setResetOnLongEdges) return;
        }
    }
}
function $shiftNode(graph, subLayers, targetLayer, nodeIndex) {
    var dummyNode, edgeCount, extraEdge, incomingEdge, incomingEdge$iterator, layerIndex, layerIndex0, nextEdgeToSplit, noIncomingEdges, node, outgoingEdge, outgoingEdge$iterator, placeholder, reversedIncomingEdges;
    node = castTo($get_11((checkCriticalElementIndex(0, subLayers.array.length), castTo(subLayers.array[0], 25)).nodes, nodeIndex), 9);
    targetLayer > 0 && $setLayer_0(node, (checkCriticalElementIndex(targetLayer, subLayers.array.length), castTo(subLayers.array[targetLayer], 25)));
    edgeCount = 0;
    noIncomingEdges = true;
    reversedIncomingEdges = reverse_0(newArrayList($getIncomingEdges(node)));
    for(incomingEdge$iterator = reversedIncomingEdges.iterator_0(); incomingEdge$iterator.hasNext_0();){
        incomingEdge = castTo(incomingEdge$iterator.next_1(), 18);
        noIncomingEdges = false;
        nextEdgeToSplit = incomingEdge;
        for(layerIndex = 0; layerIndex < targetLayer; layerIndex++){
            dummyNode = $createDummyNode_1(graph, nextEdgeToSplit);
            nodeIndex + edgeCount > (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25)).nodes.array.length ? $setLayer_0(dummyNode, (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25))) : $setLayer(dummyNode, nodeIndex + edgeCount, (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25)));
            nextEdgeToSplit = splitEdge(nextEdgeToSplit, dummyNode);
        }
        targetLayer > 0 && (edgeCount += 1);
    }
    if (noIncomingEdges) {
        for(layerIndex = 0; layerIndex < targetLayer; layerIndex++){
            dummyNode = new LNode(graph);
            $setType(dummyNode, ($clinit_LNode$NodeType(), PLACEHOLDER));
            nodeIndex + edgeCount > (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25)).nodes.array.length ? $setLayer_0(dummyNode, (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25))) : $setLayer(dummyNode, nodeIndex + edgeCount, (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25)));
        }
        targetLayer > 0 && (edgeCount += 1);
    }
    extraEdge = false;
    for(outgoingEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outgoingEdge$iterator);){
        outgoingEdge = castTo($next_0(outgoingEdge$iterator), 18);
        nextEdgeToSplit = outgoingEdge;
        for(layerIndex0 = targetLayer + 1; layerIndex0 < subLayers.array.length; layerIndex0++){
            dummyNode = $createDummyNode_1(graph, nextEdgeToSplit);
            $setLayer_0(dummyNode, (checkCriticalElementIndex(layerIndex0, subLayers.array.length), castTo(subLayers.array[layerIndex0], 25)));
            nextEdgeToSplit = splitEdge(nextEdgeToSplit, dummyNode);
        }
        for(layerIndex = 0; layerIndex <= targetLayer; layerIndex++)if (extraEdge) {
            placeholder = new LNode(graph);
            $setType(placeholder, ($clinit_LNode$NodeType(), NONSHIFTING_PLACEHOLDER));
            nodeIndex + 1 > (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25)).nodes.array.length ? $setLayer_0(placeholder, (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25))) : $setLayer(placeholder, nodeIndex + 1, (checkCriticalElementIndex(layerIndex, subLayers.array.length), castTo(subLayers.array[layerIndex], 25)));
        }
        extraEdge && (edgeCount += 1);
        extraEdge = true;
    }
    return edgeCount > 0 ? edgeCount - 1 : 0;
}
function AlternatingLayerUnzipper() {}
defineClass(1603, 1, $intern_102, AlternatingLayerUnzipper);
_.process = function process_50(graph, progressMonitor) {
    $process_53(castTo(graph, 36));
};
var Lorg_eclipse_elk_alg_layered_intermediate_unzipping_AlternatingLayerUnzipper_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.unzipping', 'AlternatingLayerUnzipper', 1603);
function ARDCutIndexHeuristic() {}
function getChunkCount(gs) {
    var rows_0, rowsd;
    rowsd = $wnd.Math.sqrt((gs.sumWidth == null && (gs.sumWidth = $determineWidth(gs, new GraphStats$lambda$1$Type)), $doubleValue(gs.sumWidth) / (gs.dar * (gs.maxHeight == null && (gs.maxHeight = $determineHeight(gs, new GraphStats$2methodref$max$Type)), $doubleValue(gs.maxHeight)))));
    rows_0 = toInt_0(fromDouble_0($wnd.Math.round(rowsd)));
    rows_0 = $wnd.Math.min(rows_0, gs.longestPath);
    return rows_0;
}
defineClass(795, 1, {}, ARDCutIndexHeuristic);
_.getCutIndexes = function getCutIndexes(graph, gs) {
    var cuts, idx, rows_0, step;
    rows_0 = getChunkCount(gs);
    cuts = new ArrayList;
    step = gs.longestPath / rows_0;
    for(idx = 1; idx < rows_0; ++idx)$add_3(cuts, valueOf_3(toInt_0(fromDouble_0($wnd.Math.round(idx * step)))));
    return cuts;
};
_.guaranteeValid = function guaranteeValid() {
    return false;
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_ARDCutIndexHeuristic_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'ARDCutIndexHeuristic', 795);
function $applyCuts(graph, cuts) {
    var alreadySplit, bpEndMarker, bpLayer1, bpLayer2, bpStartMarker, bpi, bpiPrev, cut, cutIt, e, e$iterator, e$iterator0, idx, inPortBp1, inPortBp2, layer, layerIt, n, n$iterator, noSplitEdges, nodeStartEdge, openEdges, originalEdge, originalEdge$iterator, outPortBp1, outPortBp2, prevNode, startEndEdge;
    layerIt = new AbstractList$ListIteratorImpl(graph.layers, 0);
    cutIt = cuts.iterator_0();
    idx = 0;
    cut = castTo(cutIt.next_1(), 17).value_0;
    noSplitEdges = 0;
    alreadySplit = new HashSet;
    openEdges = new LinkedHashSet;
    while(layerIt.i < layerIt.this$01_0.size_1()){
        layer = (checkCriticalElement(layerIt.i < layerIt.this$01_0.size_1()), castTo(layerIt.this$01_0.get_0(layerIt.last = layerIt.i++), 25));
        for(n$iterator = new ArrayList$1(layer.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            for(e$iterator0 = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator0);){
                e = castTo($next_0(e$iterator0), 18);
                openEdges.map_0.put(e, openEdges);
            }
            for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
                e = castTo($next_0(e$iterator), 18);
                openEdges.map_0.remove_0(e);
            }
        }
        if (idx + 1 == cut) {
            bpLayer1 = new Layer(graph);
            $add_1(layerIt, bpLayer1);
            bpLayer2 = new Layer(graph);
            $add_1(layerIt, bpLayer2);
            for(originalEdge$iterator = openEdges.map_0.keySet_0().iterator_0(); originalEdge$iterator.hasNext_0();){
                originalEdge = castTo(originalEdge$iterator.next_1(), 18);
                if (!alreadySplit.map_0.containsKey(originalEdge)) {
                    ++noSplitEdges;
                    alreadySplit.map_0.put(originalEdge, alreadySplit);
                }
                bpStartMarker = new LNode(graph);
                $setProperty_0(bpStartMarker, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_SIDE));
                $setLayer_0(bpStartMarker, bpLayer1);
                $setType(bpStartMarker, ($clinit_LNode$NodeType(), BREAKING_POINT));
                inPortBp1 = new LPort;
                $setNode(inPortBp1, bpStartMarker);
                $setSide(inPortBp1, ($clinit_PortSide(), WEST_0));
                outPortBp1 = new LPort;
                $setNode(outPortBp1, bpStartMarker);
                $setSide(outPortBp1, EAST_0);
                bpEndMarker = new LNode(graph);
                $setProperty_0(bpEndMarker, PORT_CONSTRAINTS_0, FIXED_SIDE);
                $setLayer_0(bpEndMarker, bpLayer2);
                $setType(bpEndMarker, BREAKING_POINT);
                inPortBp2 = new LPort;
                $setNode(inPortBp2, bpEndMarker);
                $setSide(inPortBp2, WEST_0);
                outPortBp2 = new LPort;
                $setNode(outPortBp2, bpEndMarker);
                $setSide(outPortBp2, EAST_0);
                nodeStartEdge = new LEdge;
                $setSource_0(nodeStartEdge, originalEdge.source);
                $setTarget_0(nodeStartEdge, inPortBp1);
                $setProperty_0(nodeStartEdge, ($clinit_InternalProperties_1(), MODEL_ORDER_1), castTo($getProperty(originalEdge, MODEL_ORDER_1), 17));
                startEndEdge = new LEdge;
                $setSource_0(startEndEdge, outPortBp1);
                $setTarget_0(startEndEdge, inPortBp2);
                $setProperty_0(startEndEdge, MODEL_ORDER_1, castTo($getProperty(originalEdge, MODEL_ORDER_1), 17));
                $setSource_0(originalEdge, outPortBp2);
                bpi = new BreakingPointInserter$BPInfo(bpStartMarker, bpEndMarker, nodeStartEdge, startEndEdge, originalEdge);
                $setProperty_0(bpStartMarker, BREAKING_POINT_INFO, bpi);
                $setProperty_0(bpEndMarker, BREAKING_POINT_INFO, bpi);
                prevNode = nodeStartEdge.source.owner;
                if (prevNode.type_0 == BREAKING_POINT) {
                    bpiPrev = castTo($getProperty(prevNode, BREAKING_POINT_INFO), 314);
                    bpiPrev.next_0 = bpi;
                    bpi.prev = bpiPrev;
                }
            }
            if (cutIt.hasNext_0()) cut = castTo(cutIt.next_1(), 17).value_0;
            else break;
        }
        ++idx;
    }
    return valueOf_3(noSplitEdges);
}
function $computeEdgeSpans(graph) {
    var e, e$iterator, i, l, l$iterator, n, n$iterator, n$iterator0, open_0, spans;
    spans = initUnidimensionalArray(I_classLit, $intern_48, 30, graph.layers.array.length + 1, 15, 1);
    open_0 = new HashSet;
    i = 0;
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        spans[i++] = open_0.map_0.size_1();
        for(n$iterator0 = new ArrayList$1(l.nodes); n$iterator0.i < n$iterator0.this$01.array.length;){
            n = castTo($next_6(n$iterator0), 9);
            for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
                e = castTo($next_0(e$iterator), 18);
                open_0.map_0.put(e, open_0);
            }
        }
        for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
                e = castTo($next_0(e$iterator), 18);
                open_0.map_0.remove_0(e);
            }
        }
    }
    return spans;
}
function $improveCuts(graph, cuts) {
    var bestCut, bestScore, ccuts, cut, cutIdx, cutIdx$iterator, dist, hit, i, idx, improvedCuts, lCut, lDist, lastCut, rCut, rDist, score, spans, distancePenalty;
    improvedCuts = new ArrayList;
    ccuts = new ArrayList;
    lastCut = null;
    for(cutIdx$iterator = cuts.iterator_0(); cutIdx$iterator.hasNext_0();){
        cutIdx = castTo(cutIdx$iterator.next_1(), 17);
        cut = new BreakingPointInserter$Cut(cutIdx.value_0);
        push_1(ccuts.array, cut);
        if (lastCut) {
            cut.prev = lastCut;
            lastCut.suc = cut;
        }
        lastCut = cut;
    }
    spans = $computeEdgeSpans(graph);
    for(i = 0; i < ccuts.array.length; ++i){
        lCut = null;
        rCut = $selfOrNext((checkCriticalElementIndex(0, ccuts.array.length), castTo(ccuts.array[0], 645)));
        bestCut = null;
        bestScore = $intern_60;
        for(idx = 1; idx < graph.layers.array.length; ++idx){
            rDist = rCut ? $wnd.Math.abs(rCut.index_0 - idx) : $wnd.Math.abs(idx - lCut.index_0) + 1;
            lDist = lCut ? $wnd.Math.abs(idx - lCut.index_0) : rDist + 1;
            if (lDist < rDist) {
                hit = lCut;
                dist = lDist;
            } else {
                hit = rCut;
                dist = rDist;
            }
            score = (distancePenalty = $doubleValue(castToDouble($getProperty(graph, ($clinit_LayeredOptions(), WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_0)))), spans[idx] + $wnd.Math.pow(dist, distancePenalty));
            if (score < bestScore) {
                bestScore = score;
                bestCut = hit;
                bestCut.newIndex = idx;
            }
            if (!!rCut && idx == rCut.index_0) {
                lCut = rCut;
                rCut = $next_11(rCut);
            }
        }
        if (bestCut) {
            $add_3(improvedCuts, valueOf_3(bestCut.newIndex));
            bestCut.assigned = true;
            $offset(bestCut);
        }
    }
    $clinit_Collections();
    sort_4(improvedCuts.array, improvedCuts.array.length, null);
    return improvedCuts;
}
function $process_54(graph, progressMonitor) {
    var cuts, gs, icic;
    progressMonitor.begin('Breaking Point Insertion', 1);
    gs = new GraphStats(graph);
    switch(castTo($getProperty(graph, ($clinit_LayeredOptions(), WRAPPING_CUTTING_STRATEGY_0)), 347).ordinal){
        case 2:
            icic = new ICutIndexCalculator$ManualCutIndexCalculator;
            break;
        case 0:
            icic = new ARDCutIndexHeuristic;
            break;
        default:
            icic = new MSDCutIndexHeuristic;
    }
    cuts = icic.getCutIndexes(graph, gs);
    $booleanValue(castToBoolean($getProperty(graph, WRAPPING_MULTI_EDGE_IMPROVE_CUTS_0))) && (cuts = $improveCuts(graph, cuts));
    if (!icic.guaranteeValid() && $hasProperty(graph, WRAPPING_VALIDIFY_STRATEGY_0)) switch(castTo($getProperty(graph, WRAPPING_VALIDIFY_STRATEGY_0), 348).ordinal){
        case 2:
            cuts = validifyIndexesLookingBack_0(gs, cuts);
            break;
        case 1:
            cuts = validifyIndexesGreedily(gs, cuts);
    }
    if (cuts.isEmpty()) {
        progressMonitor.done_1();
        return;
    }
    $applyCuts(graph, cuts);
    progressMonitor.done_1();
}
function BreakingPointInserter() {}
defineClass(1484, 1, $intern_102, BreakingPointInserter);
_.process = function process_51(graph, progressMonitor) {
    $process_54(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointInserter_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointInserter', 1484);
function BreakingPointInserter$BPInfo(startDummy, endDummy, nodeStartEdge, startEndEdge, originalEdge) {
    this.start_0 = startDummy;
    this.end = endDummy;
    this.nodeStartEdge = nodeStartEdge;
    this.startEndEdge = startEndEdge;
    this.originalEdge = originalEdge;
}
function isEnd(n) {
    var bpi;
    bpi = castTo($getProperty(n, ($clinit_InternalProperties_1(), BREAKING_POINT_INFO)), 314);
    if (bpi) return bpi.end == n;
    return false;
}
function isStart(n) {
    var bpi;
    bpi = castTo($getProperty(n, ($clinit_InternalProperties_1(), BREAKING_POINT_INFO)), 314);
    if (bpi) return bpi.start_0 == n;
    return false;
}
defineClass(314, 1, {
    314: 1
}, BreakingPointInserter$BPInfo);
_.toString_0 = function toString_95() {
    var sb;
    sb = new StringBuilder;
    sb.string += 'BPInfo[';
    sb.string += '\n\tstart=';
    $append_10(sb, this.start_0);
    sb.string += '\n\tend=';
    $append_10(sb, this.end);
    sb.string += '\n\tnodeStartEdge=';
    $append_10(sb, this.nodeStartEdge);
    sb.string += '\n\tstartEndEdge=';
    $append_10(sb, this.startEndEdge);
    sb.string += '\n\toriginalEdge=';
    $append_10(sb, this.originalEdge);
    sb.string += '\n\tstartInLayerDummy=';
    $append_10(sb, this.startInLayerDummy);
    sb.string += '\n\tstartInLayerEdge=';
    $append_10(sb, this.startInLayerEdge);
    sb.string += '\n\tendInLayerDummy=';
    $append_10(sb, this.endInLayerDummy);
    sb.string += '\n\tendInLayerEdge=';
    $append_10(sb, this.endInLayerEdge);
    return sb.string;
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointInserter$BPInfo_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointInserter/BPInfo', 314);
function $next_11(this$static) {
    if (this$static.suc) return $selfOrNext(this$static.suc);
    return null;
}
function $offset(this$static) {
    var offset;
    if (!this$static.assigned) throw toJs(new IllegalStateException_0('Cannot offset an unassigned cut.'));
    offset = this$static.newIndex - this$static.index_0;
    this$static.index_0 += offset;
    $offsetPrev(this$static, offset);
    $offsetSuc(this$static, offset);
}
function $offset_0(this$static, offset) {
    this$static.index_0 += offset;
}
function $offsetPrev(this$static, offset) {
    if (!!this$static.prev && !this$static.prev.assigned) {
        $offset_0(this$static.prev, offset);
        $offsetPrev(this$static.prev, offset);
    }
}
function $offsetSuc(this$static, offset) {
    if (!!this$static.suc && !this$static.suc.assigned) {
        $offset_0(this$static.suc, offset);
        $offsetSuc(this$static.suc, offset);
    }
}
function $selfOrNext(this$static) {
    if (this$static.assigned) {
        if (this$static.suc) return $selfOrNext(this$static.suc);
    } else return this$static;
    return null;
}
function BreakingPointInserter$Cut(index_0) {
    this.index_0 = index_0;
}
defineClass(645, 1, {
    645: 1
}, BreakingPointInserter$Cut);
_.assigned = false;
_.index_0 = 0;
_.newIndex = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointInserter$Cut_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointInserter/Cut', 645);
function $dropDummies(bpNode, inLayerDummy, forwards, force) {
    var didsome, newLayer, nextOne, nextTwo, predOne, predTwo;
    predOne = $nextLongEdgeDummy(bpNode, forwards);
    predTwo = $nextLongEdgeDummy(inLayerDummy, forwards);
    didsome = false;
    while(!!predOne && !!predTwo){
        if (force || $isAdjacentOrSeparatedByBreakingpoints(predOne, predTwo, forwards)) {
            nextOne = $nextLongEdgeDummy(predOne, forwards);
            nextTwo = $nextLongEdgeDummy(predTwo, forwards);
            $updateIndexesAfter(inLayerDummy);
            $updateIndexesAfter(bpNode);
            newLayer = predOne.layer;
            joinAt(predOne, false);
            joinAt(predTwo, false);
            if (forwards) {
                $setLayer(inLayerDummy, predTwo.id_0, newLayer);
                inLayerDummy.id_0 = predTwo.id_0;
                $setLayer(bpNode, predOne.id_0 + 1, newLayer);
                bpNode.id_0 = predOne.id_0;
            } else {
                $setLayer(bpNode, predOne.id_0, newLayer);
                bpNode.id_0 = predOne.id_0;
                $setLayer(inLayerDummy, predTwo.id_0 + 1, newLayer);
                inLayerDummy.id_0 = predTwo.id_0;
            }
            $setLayer_0(predOne, null);
            $setLayer_0(predTwo, null);
            predOne = nextOne;
            predTwo = nextTwo;
            didsome = true;
        } else break;
    }
    return didsome;
}
function $improveMultiCutIndexEdges(graph) {
    var current, info, l, l$iterator, n, n$iterator, newInfo, next;
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        for(n$iterator = new ArrayList$1(newArrayList(l.nodes)); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            if (isStart(n)) {
                info = castTo($getProperty(n, ($clinit_InternalProperties_1(), BREAKING_POINT_INFO)), 314);
                if (!info.prev && !!info.next_0) {
                    current = info;
                    next = info.next_0;
                    while(next){
                        $dropDummies(next.start_0, next.startInLayerDummy, false, true);
                        $updateIndexesAfter(current.end);
                        $updateIndexesAfter(next.start_0);
                        $updateIndexesAfter(next.startInLayerDummy);
                        $updateIndexesAfter(next.endInLayerDummy);
                        $setTarget_0(next.endInLayerEdge, current.endInLayerEdge.target);
                        $setTarget_0(current.endInLayerEdge, null);
                        $setLayer_0(current.end, null);
                        $setLayer_0(next.start_0, null);
                        $setLayer_0(next.startInLayerDummy, null);
                        $setLayer_0(next.endInLayerDummy, null);
                        newInfo = new BreakingPointInserter$BPInfo(current.start_0, next.end, current.nodeStartEdge, next.startEndEdge, next.originalEdge);
                        newInfo.startInLayerDummy = current.startInLayerDummy;
                        newInfo.startInLayerEdge = current.startInLayerEdge;
                        newInfo.endInLayerDummy = current.endInLayerDummy;
                        newInfo.endInLayerEdge = next.endInLayerEdge;
                        newInfo.prev = current.prev;
                        newInfo.next_0 = next.next_0;
                        $setProperty_0(current.start_0, BREAKING_POINT_INFO, newInfo);
                        $setProperty_0(next.end, BREAKING_POINT_INFO, newInfo);
                        next = next.next_0;
                        current = newInfo;
                    }
                }
            }
        }
    }
}
function $improveUnneccesarilyLongEdges(graph, forwards) {
    var bpInfo, bpNode, check, didsome, dummy, layer, layer$iterator, layers, n, n$iterator, nodes;
    check = forwards ? new BreakingPointProcessor$0methodref$isEnd$Type : new BreakingPointProcessor$1methodref$isStart$Type;
    didsome = false;
    do {
        didsome = false;
        layers = forwards ? reverse_0(graph.layers) : graph.layers;
        for(layer$iterator = layers.iterator_0(); layer$iterator.hasNext_0();){
            layer = castTo(layer$iterator.next_1(), 25);
            nodes = newArrayList(layer.nodes);
            forwards || reverse_0(nodes);
            for(n$iterator = new ArrayList$1(nodes); n$iterator.i < n$iterator.this$01.array.length;){
                n = castTo($next_6(n$iterator), 9);
                if (check.test_0(n)) {
                    bpNode = n;
                    bpInfo = castTo($getProperty(n, ($clinit_InternalProperties_1(), BREAKING_POINT_INFO)), 314);
                    dummy = forwards ? bpInfo.endInLayerDummy : bpInfo.startInLayerDummy;
                    didsome = $dropDummies(bpNode, dummy, forwards, false);
                }
            }
        }
    }while (didsome);
}
function $isAdjacentOrSeparatedByBreakingpoints(dummy1, dummy2, forwards) {
    var end, i, layer, node, start_0;
    layer = dummy1.layer;
    start_0 = forwards ? dummy2 : dummy1;
    end = forwards ? dummy1 : dummy2;
    for(i = start_0.id_0 + 1; i < end.id_0; ++i){
        node = castTo($get_11(layer.nodes, i), 9);
        if (!(node.type_0 == ($clinit_LNode$NodeType(), BREAKING_POINT) || $isInLayerDummy(node))) return false;
    }
    return true;
}
function $isInLayerDummy(node) {
    var e, e$iterator;
    if (node.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        if (!$isSelfLoop(e) && node.layer == $getOther_1(e, node).layer) return true;
    }
    return false;
}
function $nextLongEdgeDummy(start_0, forwards) {
    var e, e$iterator, edges, other;
    edges = forwards ? $getOutgoingEdges(start_0) : $getIncomingEdges(start_0);
    for(e$iterator = new Iterators$ConcatenatedIterator(transform_2(edges.val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        other = $getOther_1(e, start_0);
        if (other.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) && other.layer != start_0.layer) return other;
    }
    return null;
}
function $performWrapping(graph) {
    var aNode, bpi, dummyEdges, e, e$iterator, idx, it, l, layer, layerIt, layers, n, n$iterator, n$iterator0, newLayer, nodesToMove, offset, reverse, startInLayerEdge;
    layers = graph.layers;
    layerIt = new AbstractList$ListIteratorImpl(layers, 0);
    $add_1(layerIt, new Layer(graph));
    reverse = false;
    idx = 1;
    while(layerIt.i < layerIt.this$01_0.size_1()){
        layer = (checkCriticalElement(layerIt.i < layerIt.this$01_0.size_1()), castTo(layerIt.this$01_0.get_0(layerIt.last = layerIt.i++), 25));
        newLayer = (checkCriticalElementIndex(idx, layers.array.length), castTo(layers.array[idx], 25));
        nodesToMove = newArrayList(layer.nodes);
        offset = nodesToMove.array.length;
        for(n$iterator0 = new ArrayList$1(nodesToMove); n$iterator0.i < n$iterator0.this$01.array.length;){
            n = castTo($next_6(n$iterator0), 9);
            $setLayer_0(n, newLayer);
        }
        if (reverse) {
            for(n$iterator = reverse_0(nodesToMove).iterator_0(); n$iterator.hasNext_0();){
                n = castTo(n$iterator.next_1(), 9);
                for(e$iterator = new ArrayList$1(newArrayList($getIncomingEdges(n))); e$iterator.i < e$iterator.this$01.array.length;){
                    e = castTo($next_6(e$iterator), 18);
                    $reverse_0(e, true);
                    $setProperty_0(graph, ($clinit_InternalProperties_1(), CYCLIC), ($clinit_Boolean(), true));
                    dummyEdges = insertDummies(graph, e, offset);
                    bpi = castTo($getProperty(n, BREAKING_POINT_INFO), 314);
                    startInLayerEdge = castTo($get_11(dummyEdges, dummyEdges.array.length - 1), 18);
                    bpi.startInLayerDummy = startInLayerEdge.source.owner;
                    bpi.startInLayerEdge = startInLayerEdge;
                    bpi.endInLayerDummy = e.target.owner;
                    bpi.endInLayerEdge = e;
                }
            }
            reverse = false;
        } else if (nodesToMove.array.length != 0) {
            aNode = (checkCriticalElementIndex(0, nodesToMove.array.length), castTo(nodesToMove.array[0], 9));
            if (aNode.type_0 == ($clinit_LNode$NodeType(), BREAKING_POINT)) {
                reverse = true;
                idx = -1;
            }
        }
        ++idx;
    }
    it = new AbstractList$ListIteratorImpl(graph.layers, 0);
    while(it.i < it.this$01_0.size_1()){
        l = (checkCriticalElement(it.i < it.this$01_0.size_1()), castTo(it.this$01_0.get_0(it.last = it.i++), 25));
        l.nodes.array.length == 0 && $remove_8(it);
    }
}
function $process_55(graph, progressMonitor) {
    var index_0, l, l$iterator, n, n$iterator;
    progressMonitor.begin('Breaking Point Processor', 1);
    $performWrapping(graph);
    if ($booleanValue(castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_0))))) {
        for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
            l = castTo($next_6(l$iterator), 25);
            index_0 = 0;
            for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
                n = castTo($next_6(n$iterator), 9);
                n.id_0 = index_0++;
            }
        }
        $improveMultiCutIndexEdges(graph);
        $improveUnneccesarilyLongEdges(graph, true);
        $improveUnneccesarilyLongEdges(graph, false);
    }
    progressMonitor.done_1();
}
function $updateIndexesAfter(node) {
    var i;
    for(i = node.id_0 + 1; i < node.layer.nodes.array.length; ++i)--castTo($get_11(node.layer.nodes, i), 9).id_0;
}
function BreakingPointProcessor() {}
defineClass(1485, 1, $intern_102, BreakingPointProcessor);
_.process = function process_52(graph, progressMonitor) {
    $process_55(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointProcessor_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointProcessor', 1485);
function BreakingPointProcessor$0methodref$isEnd$Type() {}
defineClass(1486, 1, $intern_39, BreakingPointProcessor$0methodref$isEnd$Type);
_.test_0 = function test_77(arg0) {
    return isEnd(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointProcessor$0methodref$isEnd$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointProcessor/0methodref$isEnd$Type', 1486);
function BreakingPointProcessor$1methodref$isStart$Type() {}
defineClass(1487, 1, $intern_39, BreakingPointProcessor$1methodref$isStart$Type);
_.test_0 = function test_78(arg0) {
    return isStart(castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointProcessor$1methodref$isStart$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointProcessor/1methodref$isStart$Type', 1487);
function $addNullSafe(container, toAdd) {
    if (!toAdd) return false;
    return $addAll(container, toAdd);
}
function $process_56(this$static, graph, progressMonitor) {
    var bpi, l, l$iterator, node, node$iterator;
    progressMonitor.begin('Breaking Point Removing', 1);
    this$static.edgeRouting = castTo($getProperty(graph, ($clinit_LayeredOptions(), EDGE_ROUTING)), 220);
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        for(node$iterator = new ArrayList$1(newArrayList(l.nodes)); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (isEnd(node)) {
                bpi = castTo($getProperty(node, ($clinit_InternalProperties_1(), BREAKING_POINT_INFO)), 314);
                !bpi.next_0 && $remove_30(this$static, bpi);
            }
        }
    }
    progressMonitor.done_1();
}
function $remove_30(this$static, bpi) {
    var e1, e2, e3, joinedEdges, joinedSegments, junctionPointsOne, junctionPointsThree, junctionPointsTwo, newBends, newJunctionPoints, s1, s2, s3;
    newBends = new KVectorChain;
    switch(this$static.edgeRouting.ordinal){
        case 3:
            s1 = castTo($getProperty(bpi.nodeStartEdge, ($clinit_InternalProperties_1(), SPLINE_ROUTE_START)), 15);
            s2 = castTo($getProperty(bpi.startEndEdge, SPLINE_ROUTE_START), 15);
            s3 = castTo($getProperty(bpi.originalEdge, SPLINE_ROUTE_START), 15);
            e1 = castTo($getProperty(bpi.nodeStartEdge, SPLINE_EDGE_CHAIN), 15);
            e2 = castTo($getProperty(bpi.startEndEdge, SPLINE_EDGE_CHAIN), 15);
            e3 = castTo($getProperty(bpi.originalEdge, SPLINE_EDGE_CHAIN), 15);
            joinedSegments = new ArrayList;
            $addAll_2(joinedSegments, s1);
            s2.forEach_0(new BreakingPointRemover$lambda$0$Type);
            $addAll_2(joinedSegments, reverse_0(s2));
            $addAll_2(joinedSegments, s3);
            joinedEdges = new ArrayList;
            $addAll_2(joinedEdges, e1);
            $addAll_2(joinedEdges, reverse_0(e2));
            $addAll_2(joinedEdges, e3);
            $setProperty_0(bpi.originalEdge, SPLINE_ROUTE_START, joinedSegments);
            $setProperty_0(bpi.originalEdge, SPLINE_EDGE_CHAIN, joinedEdges);
            $setProperty_0(bpi.originalEdge, SPLINE_SURVIVING_EDGE, bpi.originalEdge);
            $setProperty_0(bpi.nodeStartEdge, SPLINE_ROUTE_START, null);
            $setProperty_0(bpi.nodeStartEdge, SPLINE_EDGE_CHAIN, null);
            $setProperty_0(bpi.startEndEdge, SPLINE_ROUTE_START, null);
            $setProperty_0(bpi.startEndEdge, SPLINE_EDGE_CHAIN, null);
            break;
        case 1:
            $addAll(newBends, bpi.nodeStartEdge.bendPoints);
            $add_7(newBends, bpi.start_0.pos);
            $addAll(newBends, reverse_0(bpi.startEndEdge.bendPoints));
            $add_7(newBends, bpi.end.pos);
            $addAll(newBends, bpi.originalEdge.bendPoints);
            break;
        default:
            $addAll(newBends, bpi.nodeStartEdge.bendPoints);
            $addAll(newBends, reverse_0(bpi.startEndEdge.bendPoints));
            $addAll(newBends, bpi.originalEdge.bendPoints);
    }
    $reset_0(bpi.originalEdge.bendPoints);
    $addAll(bpi.originalEdge.bendPoints, newBends);
    $setSource_0(bpi.originalEdge, bpi.nodeStartEdge.source);
    junctionPointsOne = castTo($getProperty(bpi.nodeStartEdge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
    junctionPointsTwo = castTo($getProperty(bpi.startEndEdge, JUNCTION_POINTS), 77);
    junctionPointsThree = castTo($getProperty(bpi.originalEdge, JUNCTION_POINTS), 77);
    if (!!junctionPointsOne || !!junctionPointsTwo || !!junctionPointsThree) {
        newJunctionPoints = new KVectorChain;
        $addNullSafe(newJunctionPoints, junctionPointsThree);
        $addNullSafe(newJunctionPoints, junctionPointsTwo);
        $addNullSafe(newJunctionPoints, junctionPointsOne);
        $setProperty_0(bpi.originalEdge, JUNCTION_POINTS, newJunctionPoints);
    }
    $setSource_0(bpi.startEndEdge, null);
    $setTarget_0(bpi.startEndEdge, null);
    $setSource_0(bpi.nodeStartEdge, null);
    $setTarget_0(bpi.nodeStartEdge, null);
    $setLayer_0(bpi.end, null);
    $setLayer_0(bpi.start_0, null);
    !!bpi.prev && $remove_30(this$static, bpi.prev);
}
function BreakingPointRemover() {}
defineClass(1488, 1, $intern_102, BreakingPointRemover);
_.process = function process_53(graph, progressMonitor) {
    $process_56(this, castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointRemover_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointRemover', 1488);
function BreakingPointRemover$lambda$0$Type() {}
defineClass(1489, 1, $intern_19, BreakingPointRemover$lambda$0$Type);
_.accept = function accept_112(arg0) {
    castTo(arg0, 132).inverseOrder = true;
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_BreakingPointRemover$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'BreakingPointRemover/lambda$0$Type', 1489);
function insertDummies(layeredGraph, originalEdge, offsetFirstInLayerDummy) {
    var additionalSpacing, createdEdges, dummyEdge, dummyInput, dummyNode, dummyOutput, edge, edgeNodeSpacing, i, is, nextLayer, portPos, src_0, srcIndex, targetPort, tgt, tgtIndex, thickness;
    edgeNodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_NODE))));
    additionalSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, WRAPPING_ADDITIONAL_EDGE_SPACING_0)));
    is = new IndividualSpacings;
    $setProperty_0(is, SPACING_EDGE_NODE, edgeNodeSpacing + additionalSpacing);
    edge = originalEdge;
    targetPort = edge.target;
    src_0 = edge.source.owner;
    tgt = edge.target.owner;
    srcIndex = $getIndex_0(src_0.layer);
    tgtIndex = $getIndex_0(tgt.layer);
    createdEdges = new ArrayList;
    for(i = srcIndex; i <= tgtIndex; i++){
        dummyNode = new LNode(layeredGraph);
        $setType(dummyNode, ($clinit_LNode$NodeType(), LONG_EDGE));
        $setProperty_0(dummyNode, ($clinit_InternalProperties_1(), ORIGIN_0), edge);
        $setProperty_0(dummyNode, PORT_CONSTRAINTS_0, ($clinit_PortConstraints(), FIXED_POS));
        $setProperty_0(dummyNode, SPACING_INDIVIDUAL, is);
        nextLayer = castTo($get_11(layeredGraph.layers, i), 25);
        i == srcIndex ? $setLayer(dummyNode, nextLayer.nodes.array.length - offsetFirstInLayerDummy, nextLayer) : $setLayer_0(dummyNode, nextLayer);
        thickness = $doubleValue(castToDouble($getProperty(edge, EDGE_THICKNESS)));
        if (thickness < 0) {
            thickness = 0;
            $setProperty_0(edge, EDGE_THICKNESS, thickness);
        }
        dummyNode.size_0.y_0 = thickness;
        portPos = $wnd.Math.floor(thickness / 2);
        dummyInput = new LPort;
        $setSide(dummyInput, ($clinit_PortSide(), WEST_0));
        $setNode(dummyInput, dummyNode);
        dummyInput.pos.y_0 = portPos;
        dummyOutput = new LPort;
        $setSide(dummyOutput, EAST_0);
        $setNode(dummyOutput, dummyNode);
        dummyOutput.pos.y_0 = portPos;
        $setTarget_0(edge, dummyInput);
        dummyEdge = new LEdge;
        $copyProperties(dummyEdge, edge);
        $setProperty_0(dummyEdge, JUNCTION_POINTS, null);
        $setSource_0(dummyEdge, dummyOutput);
        $setTarget_0(dummyEdge, targetPort);
        setDummyProperties(dummyNode, edge, dummyEdge);
        push_1(createdEdges.array, dummyEdge);
        edge = dummyEdge;
    }
    return createdEdges;
}
function setDummyProperties(dummy, inEdge, outEdge) {
    var inEdgeSourceNode;
    inEdgeSourceNode = inEdge.source.owner;
    if (inEdgeSourceNode.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) {
        $setProperty_0(dummy, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), castTo($getProperty(inEdgeSourceNode, LONG_EDGE_SOURCE), 11));
        $setProperty_0(dummy, LONG_EDGE_TARGET, castTo($getProperty(inEdgeSourceNode, LONG_EDGE_TARGET), 11));
    } else {
        $setProperty_0(dummy, ($clinit_InternalProperties_1(), LONG_EDGE_SOURCE), inEdge.source);
        $setProperty_0(dummy, LONG_EDGE_TARGET, outEdge.target);
    }
}
function $determineHeight(this$static, fun) {
    return $doubleValue(castToDouble($get_17($reduce_0($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.graph_0.layers, 16)), new GraphStats$lambda$6$Type(this$static)), fun))));
}
function $determineLayerHeight(this$static, layer) {
    var inc, inc$iterator, lH, n, n$iterator, origin_0, src_0;
    lH = 0;
    for(n$iterator = new ArrayList$1(layer.nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 9);
        lH += n.size_0.y_0 + n.margin.bottom + n.margin.top_0 + this$static.inLayerSpacing;
        for(inc$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(inc$iterator);){
            inc = castTo($next_0(inc$iterator), 18);
            if (inc.source.owner.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT)) {
                src_0 = inc.source.owner;
                origin_0 = castTo($getProperty(src_0, ($clinit_InternalProperties_1(), ORIGIN_0)), 9);
                lH += origin_0.size_0.y_0 + origin_0.margin.bottom + origin_0.margin.top_0;
            }
        }
    }
    return lH;
}
function $determineLayerWidth(this$static, l) {
    var maxW, n, n$iterator, nW;
    maxW = 0;
    for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 9);
        nW = n.size_0.x_0 + n.margin.right + n.margin.left + this$static.spacing;
        maxW = $wnd.Math.max(maxW, nW);
    }
    return maxW;
}
function $determineWidth(this$static, fun) {
    return $doubleValue(castToDouble($get_17($reduce_0($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.graph_0.layers, 16)), new GraphStats$lambda$2$Type(this$static)), fun))));
}
function $initCutAllowed(this$static) {
    var f, f$iterator, forbidden, i, layer, layerIt;
    if (this$static.cutsAllowed != null) return;
    this$static.cutsAllowed = initUnidimensionalArray(Z_classLit, $intern_90, 30, this$static.graph_0.layers.array.length, 16, 1);
    this$static.cutsAllowed[0] = false;
    if ($hasProperty(this$static.graph_0, ($clinit_LayeredOptions(), WRAPPING_VALIDIFY_FORBIDDEN_INDICES_0))) {
        forbidden = castTo($getProperty(this$static.graph_0, WRAPPING_VALIDIFY_FORBIDDEN_INDICES_0), 15);
        for(f$iterator = forbidden.iterator_0(); f$iterator.hasNext_0();){
            f = castTo(f$iterator.next_1(), 17).value_0;
            f > 0 && f < this$static.cutsAllowed.length && (this$static.cutsAllowed[f] = false);
        }
    } else {
        layerIt = new ArrayList$1(this$static.graph_0.layers);
        layerIt.i < layerIt.this$01.array.length && $next_6(layerIt);
        i = 1;
        while(layerIt.i < layerIt.this$01.array.length){
            layer = castTo($next_6(layerIt), 25);
            this$static.cutsAllowed[i++] = $isCutAllowed_0(layer);
        }
    }
}
function $initWidthsAndHeights(this$static) {
    var i, l, n;
    n = this$static.longestPath;
    this$static.widths = initUnidimensionalArray(D_classLit, $intern_66, 30, n, 15, 1);
    this$static.heights = initUnidimensionalArray(D_classLit, $intern_66, 30, n, 15, 1);
    for(i = 0; i < n; i++){
        l = castTo($get_11(this$static.graph_0.layers, i), 25);
        this$static.widths[i] = $determineLayerWidth(this$static, l);
        this$static.heights[i] = $determineLayerHeight(this$static, l);
    }
}
function $isCutAllowed(this$static, layerIndex) {
    this$static.cutsAllowed == null && $initCutAllowed(this$static);
    return this$static.cutsAllowed[layerIndex];
}
function $isCutAllowed_0(layer) {
    var cutAllowed, e, e$iterator, n1, n2, src_0, tgt, tgt$iterator;
    cutAllowed = true;
    n1 = null;
    n2 = null;
    check: for(tgt$iterator = new ArrayList$1(layer.nodes); tgt$iterator.i < tgt$iterator.this$01.array.length;){
        tgt = castTo($next_6(tgt$iterator), 9);
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(tgt).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 18);
            if (!!n1 && n1 != tgt) {
                cutAllowed = false;
                break check;
            }
            n1 = tgt;
            src_0 = e.source.owner;
            if (!!n2 && n2 != src_0) {
                cutAllowed = false;
                break check;
            }
            n2 = src_0;
        }
    }
    return cutAllowed;
}
function GraphStats(graph) {
    var aspectRatio, correction, dir_0;
    this.graph_0 = graph;
    dir_0 = castTo($getProperty(graph, ($clinit_LayeredOptions(), DIRECTION)), 86);
    aspectRatio = $doubleValue(castToDouble($getProperty(graph, ASPECT_RATIO_0)));
    correction = $doubleValue(castToDouble($getProperty(graph, WRAPPING_CORRECTION_FACTOR_0)));
    dir_0 == ($clinit_Direction(), LEFT_6) || dir_0 == RIGHT_6 || dir_0 == UNDEFINED_2 ? this.dar = aspectRatio * correction : this.dar = 1 / (aspectRatio * correction);
    this.spacing = $doubleValue(castToDouble($getProperty(graph, SPACING_NODE_NODE_BETWEEN_LAYERS_0)));
    this.inLayerSpacing = $doubleValue(castToDouble($getProperty(graph, SPACING_NODE_NODE_0)));
    this.longestPath = graph.layers.array.length;
}
function lambda$1_15(a_0, b_1) {
    return (checkCriticalNotNull(a_0), a_0) + (checkCriticalNotNull(b_1), b_1);
}
defineClass(791, 1, {}, GraphStats);
_.dar = 0;
_.inLayerSpacing = 0;
_.longestPath = 0;
_.spacing = 0;
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_GraphStats_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'GraphStats', 791);
function GraphStats$0methodref$max$Type() {}
defineClass(792, 1, {}, GraphStats$0methodref$max$Type);
_.apply_3 = function apply_102(arg0, arg1) {
    return $wnd.Math.max($doubleValue(castToDouble(arg0)), $doubleValue(castToDouble(arg1)));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_GraphStats$0methodref$max$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'GraphStats/0methodref$max$Type', 792);
function GraphStats$2methodref$max$Type() {}
defineClass(793, 1, {}, GraphStats$2methodref$max$Type);
_.apply_3 = function apply_103(arg0, arg1) {
    return $wnd.Math.max($doubleValue(castToDouble(arg0)), $doubleValue(castToDouble(arg1)));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_GraphStats$2methodref$max$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'GraphStats/2methodref$max$Type', 793);
function GraphStats$lambda$1$Type() {}
defineClass(1668, 1, {}, GraphStats$lambda$1$Type);
_.apply_3 = function apply_104(arg0, arg1) {
    return lambda$1_15(castToDouble(arg0), castToDouble(arg1));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_GraphStats$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'GraphStats/lambda$1$Type', 1668);
function GraphStats$lambda$2$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1669, 1, {}, GraphStats$lambda$2$Type);
_.apply_0 = function apply_105(arg0) {
    return $determineLayerWidth(this.$$outer_0, castTo(arg0, 25));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_GraphStats$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'GraphStats/lambda$2$Type', 1669);
function GraphStats$lambda$6$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1670, 1, {}, GraphStats$lambda$6$Type);
_.apply_0 = function apply_106(arg0) {
    return $determineLayerHeight(this.$$outer_0, castTo(arg0, 25));
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_GraphStats$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'GraphStats/lambda$6$Type', 1670);
function ICutIndexCalculator$ManualCutIndexCalculator() {}
defineClass(794, 1, {}, ICutIndexCalculator$ManualCutIndexCalculator);
_.getCutIndexes = function getCutIndexes_0(graph, gs) {
    var cuts;
    cuts = castTo($getProperty(graph, ($clinit_LayeredOptions(), WRAPPING_CUTTING_CUTS_0)), 15);
    return cuts ? cuts : ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST);
};
_.guaranteeValid = function guaranteeValid_0() {
    return false;
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_ICutIndexCalculator$ManualCutIndexCalculator_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'ICutIndexCalculator/ManualCutIndexCalculator', 794);
function MSDCutIndexHeuristic() {}
defineClass(796, 1, {}, MSDCutIndexHeuristic);
_.getCutIndexes = function getCutIndexes_1(graph, gs) {
    var bestCuts, bestMaxScale, cutCnt, cuts, freedom, height, heights, i, index_0, lastCutWidth, m, maxScale, rowHeightMax, rowSum, sumSoFar, total, width_0, widthAtIndex, widths;
    widths = (gs.widths == null && $initWidthsAndHeights(gs), gs.widths);
    heights = (gs.heights == null && $initWidthsAndHeights(gs), gs.heights);
    widthAtIndex = initUnidimensionalArray(D_classLit, $intern_66, 30, widths.length, 15, 1);
    widthAtIndex[0] = widths[0];
    total = widths[0];
    for(i = 1; i < widths.length; i++){
        widthAtIndex[i] = widthAtIndex[i - 1] + widths[i];
        total += widths[i];
    }
    cutCnt = getChunkCount(gs) - 1;
    freedom = castTo($getProperty(graph, ($clinit_LayeredOptions(), WRAPPING_CUTTING_MSD_FREEDOM_0)), 17).value_0;
    bestMaxScale = $intern_61;
    bestCuts = new ArrayList;
    for(m = $wnd.Math.max(0, cutCnt - freedom); m <= $wnd.Math.min(gs.longestPath - 1, cutCnt + freedom); m++){
        rowSum = total / (m + 1);
        sumSoFar = 0;
        index_0 = 1;
        cuts = new ArrayList;
        width_0 = $intern_61;
        lastCutWidth = 0;
        height = 0;
        rowHeightMax = heights[0];
        if (m == 0) {
            width_0 = total;
            height = (gs.maxHeight == null && (gs.maxHeight = $determineHeight(gs, new GraphStats$2methodref$max$Type)), $doubleValue(gs.maxHeight));
        } else {
            while(index_0 < gs.longestPath){
                if (widthAtIndex[index_0 - 1] - sumSoFar >= rowSum) {
                    $add_3(cuts, valueOf_3(index_0));
                    width_0 = $wnd.Math.max(width_0, widthAtIndex[index_0 - 1] - lastCutWidth);
                    height += rowHeightMax;
                    sumSoFar += widthAtIndex[index_0 - 1] - sumSoFar;
                    lastCutWidth = widthAtIndex[index_0 - 1];
                    rowHeightMax = heights[index_0];
                }
                rowHeightMax = $wnd.Math.max(rowHeightMax, heights[index_0]);
                ++index_0;
            }
            height += rowHeightMax;
        }
        maxScale = $wnd.Math.min(1 / width_0, 1 / gs.dar / height);
        if (maxScale > bestMaxScale) {
            bestMaxScale = maxScale;
            bestCuts = cuts;
        }
    }
    return bestCuts;
};
_.guaranteeValid = function guaranteeValid_1() {
    return false;
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_MSDCutIndexHeuristic_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'MSDCutIndexHeuristic', 796);
function $performCuts(graph, gs, cuts) {
    var cutIt, e, e$iterator, incEdges, index_0, it, l, n, n$iterator, newIndex, newLayer, nextCut, nodesToMove, oldLayer;
    if (cuts.isEmpty()) return;
    index_0 = 0;
    newIndex = 0;
    cutIt = cuts.iterator_0();
    nextCut = castTo(cutIt.next_1(), 17).value_0;
    while(index_0 < gs.longestPath){
        if (index_0 == nextCut) {
            newIndex = 0;
            cutIt.hasNext_0() ? nextCut = castTo(cutIt.next_1(), 17).value_0 : nextCut = gs.longestPath + 1;
        }
        if (index_0 != newIndex) {
            oldLayer = castTo($get_11(graph.layers, index_0), 25);
            newLayer = castTo($get_11(graph.layers, newIndex), 25);
            nodesToMove = newArrayList(oldLayer.nodes);
            for(n$iterator = new ArrayList$1(nodesToMove); n$iterator.i < n$iterator.this$01.array.length;){
                n = castTo($next_6(n$iterator), 9);
                $setLayer(n, newLayer.nodes.array.length, newLayer);
                if (newIndex == 0) {
                    incEdges = newArrayList($getIncomingEdges(n));
                    for(e$iterator = new ArrayList$1(incEdges); e$iterator.i < e$iterator.this$01.array.length;){
                        e = castTo($next_6(e$iterator), 18);
                        $reverse_0(e, true);
                        $setProperty_0(graph, ($clinit_InternalProperties_1(), CYCLIC), ($clinit_Boolean(), true));
                        insertDummies(graph, e, 1);
                    }
                }
            }
        }
        ++newIndex;
        ++index_0;
    }
    it = new AbstractList$ListIteratorImpl(graph.layers, 0);
    while(it.i < it.this$01_0.size_1()){
        l = (checkCriticalElement(it.i < it.this$01_0.size_1()), castTo(it.this$01_0.get_0(it.last = it.i++), 25));
        l.nodes.array.length == 0 && $remove_8(it);
    }
}
function $process_57(graph, progressMonitor) {
    var currentAR, cuts, gs, icic, sumWidth;
    progressMonitor.begin('Path-Like Graph Wrapping', 1);
    if (graph.layers.array.length == 0) {
        progressMonitor.done_1();
        return;
    }
    gs = new GraphStats(graph);
    sumWidth = (gs.maxWidth == null && (gs.maxWidth = $determineWidth(gs, new GraphStats$0methodref$max$Type)), $doubleValue(gs.maxWidth) * gs.longestPath);
    currentAR = sumWidth / (gs.maxWidth == null && (gs.maxWidth = $determineWidth(gs, new GraphStats$0methodref$max$Type)), $doubleValue(gs.maxWidth));
    if (gs.dar > currentAR) {
        progressMonitor.done_1();
        return;
    }
    switch(castTo($getProperty(graph, ($clinit_LayeredOptions(), WRAPPING_CUTTING_STRATEGY_0)), 347).ordinal){
        case 2:
            icic = new ICutIndexCalculator$ManualCutIndexCalculator;
            break;
        case 0:
            icic = new ARDCutIndexHeuristic;
            break;
        default:
            icic = new MSDCutIndexHeuristic;
    }
    cuts = icic.getCutIndexes(graph, gs);
    if (!icic.guaranteeValid()) switch(castTo($getProperty(graph, WRAPPING_VALIDIFY_STRATEGY_0), 348).ordinal){
        case 2:
            cuts = validifyIndexesLookingBack_0(gs, cuts);
            break;
        case 1:
            cuts = validifyIndexesGreedily(gs, cuts);
    }
    $performCuts(graph, gs, cuts);
    progressMonitor.done_1();
}
function SingleEdgeGraphWrapper() {}
function validifyIndexesGreedily(gs, cuts) {
    var cut, cutIt, offset, validCuts;
    validCuts = new ArrayList;
    offset = 0;
    cutIt = cuts.iterator_0();
    while(cutIt.hasNext_0()){
        cut = valueOf_3(castTo(cutIt.next_1(), 17).value_0 + offset);
        while(cut.value_0 < gs.longestPath && !$isCutAllowed(gs, cut.value_0)){
            cut = valueOf_3(cut.value_0 + 1);
            ++offset;
        }
        if (cut.value_0 >= gs.longestPath) break;
        push_1(validCuts.array, cut);
    }
    return validCuts;
}
function validifyIndexesLookingBack(desiredCuts, validCuts) {
    var cIdx, current, distHigher, distLower, finalCuts, iIdx, offset, select;
    finalCuts = new ArrayList;
    iIdx = 0;
    cIdx = 0;
    offset = 0;
    while(iIdx < validCuts.array.length - 1 && cIdx < desiredCuts.size_1()){
        current = castTo(desiredCuts.get_0(cIdx), 17).value_0 + offset;
        while((checkCriticalElementIndex(iIdx + 1, validCuts.array.length), castTo(validCuts.array[iIdx + 1], 17)).value_0 < current)++iIdx;
        select = 0;
        distLower = current - (checkCriticalElementIndex(iIdx, validCuts.array.length), castTo(validCuts.array[iIdx], 17)).value_0;
        distHigher = (checkCriticalElementIndex(iIdx + 1, validCuts.array.length), castTo(validCuts.array[iIdx + 1], 17)).value_0 - current;
        distLower > distHigher && ++select;
        $add_3(finalCuts, (checkCriticalElementIndex(iIdx + select, validCuts.array.length), castTo(validCuts.array[iIdx + select], 17)));
        offset += (checkCriticalElementIndex(iIdx + select, validCuts.array.length), castTo(validCuts.array[iIdx + select], 17)).value_0 - current;
        ++cIdx;
        while(cIdx < desiredCuts.size_1() && castTo(desiredCuts.get_0(cIdx), 17).value_0 + offset <= (checkCriticalElementIndex(iIdx + select, validCuts.array.length), castTo(validCuts.array[iIdx + select], 17)).value_0)++cIdx;
        iIdx += 1 + select;
    }
    return finalCuts;
}
function validifyIndexesLookingBack_0(gs, desiredCuts) {
    var i, validCuts;
    if (desiredCuts.isEmpty()) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    validCuts = new ArrayList;
    $add_3(validCuts, valueOf_3($intern_42));
    for(i = 1; i < gs.longestPath; ++i){
        gs.cutsAllowed == null && $initCutAllowed(gs);
        gs.cutsAllowed[i] && $add_3(validCuts, valueOf_3(i));
    }
    if (validCuts.array.length == 1) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    $add_3(validCuts, valueOf_3($intern_0));
    return validifyIndexesLookingBack(desiredCuts, validCuts);
}
defineClass(1624, 1, $intern_102, SingleEdgeGraphWrapper);
_.process = function process_54(graph, progressMonitor) {
    $process_57(castTo(graph, 36), progressMonitor);
};
var Lorg_eclipse_elk_alg_layered_intermediate_wrapping_SingleEdgeGraphWrapper_2_classLit = createForClass('org.eclipse.elk.alg.layered.intermediate.wrapping', 'SingleEdgeGraphWrapper', 1624);
function $clinit_CenterEdgeLabelPlacementStrategy() {
    $clinit_CenterEdgeLabelPlacementStrategy = emptyMethod;
    MEDIAN_LAYER = new CenterEdgeLabelPlacementStrategy('MEDIAN_LAYER', 0);
    TAIL_LAYER = new CenterEdgeLabelPlacementStrategy('TAIL_LAYER', 1);
    HEAD_LAYER = new CenterEdgeLabelPlacementStrategy('HEAD_LAYER', 2);
    SPACE_EFFICIENT_LAYER = new CenterEdgeLabelPlacementStrategy('SPACE_EFFICIENT_LAYER', 3);
    WIDEST_LAYER = new CenterEdgeLabelPlacementStrategy('WIDEST_LAYER', 4);
    CENTER_LAYER = new CenterEdgeLabelPlacementStrategy('CENTER_LAYER', 5);
}
function CenterEdgeLabelPlacementStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_30(name_0) {
    $clinit_CenterEdgeLabelPlacementStrategy();
    return valueOf(($clinit_CenterEdgeLabelPlacementStrategy$Map(), $MAP_20), name_0);
}
function values_38() {
    $clinit_CenterEdgeLabelPlacementStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit, 1), $intern_36, 231, 0, [
        MEDIAN_LAYER,
        TAIL_LAYER,
        HEAD_LAYER,
        SPACE_EFFICIENT_LAYER,
        WIDEST_LAYER,
        CENTER_LAYER
    ]);
}
defineClass(231, 23, {
    3: 1,
    34: 1,
    23: 1,
    231: 1
}, CenterEdgeLabelPlacementStrategy);
var CENTER_LAYER, HEAD_LAYER, MEDIAN_LAYER, SPACE_EFFICIENT_LAYER, TAIL_LAYER, WIDEST_LAYER;
var Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'CenterEdgeLabelPlacementStrategy', 231, Ljava_lang_Enum_2_classLit, values_38, valueOf_30);
function $clinit_CenterEdgeLabelPlacementStrategy$Map() {
    $clinit_CenterEdgeLabelPlacementStrategy$Map = emptyMethod;
    $MAP_20 = createValueOfMap(($clinit_CenterEdgeLabelPlacementStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit, 1), $intern_36, 231, 0, [
        MEDIAN_LAYER,
        TAIL_LAYER,
        HEAD_LAYER,
        SPACE_EFFICIENT_LAYER,
        WIDEST_LAYER,
        CENTER_LAYER
    ])));
}
var $MAP_20;
function $clinit_ConstraintCalculationStrategy() {
    $clinit_ConstraintCalculationStrategy = emptyMethod;
    QUADRATIC = new ConstraintCalculationStrategy('QUADRATIC', 0);
    SCANLINE = new ConstraintCalculationStrategy('SCANLINE', 1);
}
function ConstraintCalculationStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_31(name_0) {
    $clinit_ConstraintCalculationStrategy();
    return valueOf(($clinit_ConstraintCalculationStrategy$Map(), $MAP_21), name_0);
}
function values_39() {
    $clinit_ConstraintCalculationStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_ConstraintCalculationStrategy_2_classLit, 1), $intern_36, 419, 0, [
        QUADRATIC,
        SCANLINE
    ]);
}
defineClass(419, 23, {
    3: 1,
    34: 1,
    23: 1,
    419: 1
}, ConstraintCalculationStrategy);
var QUADRATIC, SCANLINE;
var Lorg_eclipse_elk_alg_layered_options_ConstraintCalculationStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'ConstraintCalculationStrategy', 419, Ljava_lang_Enum_2_classLit, values_39, valueOf_31);
function $clinit_ConstraintCalculationStrategy$Map() {
    $clinit_ConstraintCalculationStrategy$Map = emptyMethod;
    $MAP_21 = createValueOfMap(($clinit_ConstraintCalculationStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_ConstraintCalculationStrategy_2_classLit, 1), $intern_36, 419, 0, [
        QUADRATIC,
        SCANLINE
    ])));
}
var $MAP_21;
function $clinit_CrossingMinimizationStrategy() {
    $clinit_CrossingMinimizationStrategy = emptyMethod;
    LAYER_SWEEP = new CrossingMinimizationStrategy('LAYER_SWEEP', 0);
    INTERACTIVE_1 = new CrossingMinimizationStrategy('INTERACTIVE', 1);
    NONE_1 = new CrossingMinimizationStrategy('NONE', 2);
}
function $create_3(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new LayerSweepCrossingMinimizer(($clinit_LayerSweepCrossingMinimizer$CrossMinType(), BARYCENTER));
        case 1:
            return new InteractiveCrossingMinimizer;
        case 2:
            return new NoCrossingMinimizer;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the crossing minimizer ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function CrossingMinimizationStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_32(name_0) {
    $clinit_CrossingMinimizationStrategy();
    return valueOf(($clinit_CrossingMinimizationStrategy$Map(), $MAP_22), name_0);
}
function values_40() {
    $clinit_CrossingMinimizationStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CrossingMinimizationStrategy_2_classLit, 1), $intern_36, 323, 0, [
        LAYER_SWEEP,
        INTERACTIVE_1,
        NONE_1
    ]);
}
defineClass(323, 23, {
    3: 1,
    34: 1,
    23: 1,
    323: 1,
    188: 1,
    196: 1
}, CrossingMinimizationStrategy);
_.create_1 = function create_6() {
    return $create_3(this);
};
_.create_2 = function create_5() {
    return $create_3(this);
};
var INTERACTIVE_1, LAYER_SWEEP, NONE_1;
var Lorg_eclipse_elk_alg_layered_options_CrossingMinimizationStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'CrossingMinimizationStrategy', 323, Ljava_lang_Enum_2_classLit, values_40, valueOf_32);
function $clinit_CrossingMinimizationStrategy$Map() {
    $clinit_CrossingMinimizationStrategy$Map = emptyMethod;
    $MAP_22 = createValueOfMap(($clinit_CrossingMinimizationStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CrossingMinimizationStrategy_2_classLit, 1), $intern_36, 323, 0, [
        LAYER_SWEEP,
        INTERACTIVE_1,
        NONE_1
    ])));
}
var $MAP_22;
function $clinit_CuttingStrategy() {
    $clinit_CuttingStrategy = emptyMethod;
    ARD = new CuttingStrategy('ARD', 0);
    MSD = new CuttingStrategy('MSD', 1);
    MANUAL = new CuttingStrategy('MANUAL', 2);
}
function CuttingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_33(name_0) {
    $clinit_CuttingStrategy();
    return valueOf(($clinit_CuttingStrategy$Map(), $MAP_23), name_0);
}
function values_41() {
    $clinit_CuttingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CuttingStrategy_2_classLit, 1), $intern_36, 347, 0, [
        ARD,
        MSD,
        MANUAL
    ]);
}
defineClass(347, 23, {
    3: 1,
    34: 1,
    23: 1,
    347: 1
}, CuttingStrategy);
var ARD, MANUAL, MSD;
var Lorg_eclipse_elk_alg_layered_options_CuttingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'CuttingStrategy', 347, Ljava_lang_Enum_2_classLit, values_41, valueOf_33);
function $clinit_CuttingStrategy$Map() {
    $clinit_CuttingStrategy$Map = emptyMethod;
    $MAP_23 = createValueOfMap(($clinit_CuttingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CuttingStrategy_2_classLit, 1), $intern_36, 347, 0, [
        ARD,
        MSD,
        MANUAL
    ])));
}
var $MAP_23;
function $clinit_CycleBreakingStrategy() {
    $clinit_CycleBreakingStrategy = emptyMethod;
    GREEDY = new CycleBreakingStrategy('GREEDY', 0);
    DEPTH_FIRST = new CycleBreakingStrategy('DEPTH_FIRST', 1);
    INTERACTIVE_2 = new CycleBreakingStrategy('INTERACTIVE', 2);
    MODEL_ORDER_0 = new CycleBreakingStrategy('MODEL_ORDER', 3);
    GREEDY_MODEL_ORDER = new CycleBreakingStrategy('GREEDY_MODEL_ORDER', 4);
}
function $create_4(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new GreedyCycleBreaker;
        case 1:
            return new DepthFirstCycleBreaker;
        case 2:
            return new InteractiveCycleBreaker;
        case 3:
            return new ModelOrderCycleBreaker;
        case 4:
            return new GreedyModelOrderCycleBreaker;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the cycle breaker ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function CycleBreakingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_34(name_0) {
    $clinit_CycleBreakingStrategy();
    return valueOf(($clinit_CycleBreakingStrategy$Map(), $MAP_24), name_0);
}
function values_42() {
    $clinit_CycleBreakingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CycleBreakingStrategy_2_classLit, 1), $intern_36, 344, 0, [
        GREEDY,
        DEPTH_FIRST,
        INTERACTIVE_2,
        MODEL_ORDER_0,
        GREEDY_MODEL_ORDER
    ]);
}
defineClass(344, 23, {
    3: 1,
    34: 1,
    23: 1,
    344: 1,
    188: 1,
    196: 1
}, CycleBreakingStrategy);
_.create_1 = function create_8() {
    return $create_4(this);
};
_.create_2 = function create_7() {
    return $create_4(this);
};
var DEPTH_FIRST, GREEDY, GREEDY_MODEL_ORDER, INTERACTIVE_2, MODEL_ORDER_0;
var Lorg_eclipse_elk_alg_layered_options_CycleBreakingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'CycleBreakingStrategy', 344, Ljava_lang_Enum_2_classLit, values_42, valueOf_34);
function $clinit_CycleBreakingStrategy$Map() {
    $clinit_CycleBreakingStrategy$Map = emptyMethod;
    $MAP_24 = createValueOfMap(($clinit_CycleBreakingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_CycleBreakingStrategy_2_classLit, 1), $intern_36, 344, 0, [
        GREEDY,
        DEPTH_FIRST,
        INTERACTIVE_2,
        MODEL_ORDER_0,
        GREEDY_MODEL_ORDER
    ])));
}
var $MAP_24;
function $clinit_DirectionCongruency() {
    $clinit_DirectionCongruency = emptyMethod;
    READING_DIRECTION = new DirectionCongruency('READING_DIRECTION', 0);
    ROTATION = new DirectionCongruency('ROTATION', 1);
}
function DirectionCongruency(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_35(name_0) {
    $clinit_DirectionCongruency();
    return valueOf(($clinit_DirectionCongruency$Map(), $MAP_25), name_0);
}
function values_43() {
    $clinit_DirectionCongruency();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_DirectionCongruency_2_classLit, 1), $intern_36, 416, 0, [
        READING_DIRECTION,
        ROTATION
    ]);
}
defineClass(416, 23, {
    3: 1,
    34: 1,
    23: 1,
    416: 1
}, DirectionCongruency);
var READING_DIRECTION, ROTATION;
var Lorg_eclipse_elk_alg_layered_options_DirectionCongruency_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'DirectionCongruency', 416, Ljava_lang_Enum_2_classLit, values_43, valueOf_35);
function $clinit_DirectionCongruency$Map() {
    $clinit_DirectionCongruency$Map = emptyMethod;
    $MAP_25 = createValueOfMap(($clinit_DirectionCongruency(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_DirectionCongruency_2_classLit, 1), $intern_36, 416, 0, [
        READING_DIRECTION,
        ROTATION
    ])));
}
var $MAP_25;
function $clinit_EdgeConstraint() {
    $clinit_EdgeConstraint = emptyMethod;
    NONE_2 = new EdgeConstraint('NONE', 0);
    INCOMING_ONLY = new EdgeConstraint('INCOMING_ONLY', 1);
    OUTGOING_ONLY = new EdgeConstraint('OUTGOING_ONLY', 2);
}
function EdgeConstraint(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_36(name_0) {
    $clinit_EdgeConstraint();
    return valueOf(($clinit_EdgeConstraint$Map(), $MAP_26), name_0);
}
function values_44() {
    $clinit_EdgeConstraint();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_EdgeConstraint_2_classLit, 1), $intern_36, 446, 0, [
        NONE_2,
        INCOMING_ONLY,
        OUTGOING_ONLY
    ]);
}
defineClass(446, 23, {
    3: 1,
    34: 1,
    23: 1,
    446: 1
}, EdgeConstraint);
var INCOMING_ONLY, NONE_2, OUTGOING_ONLY;
var Lorg_eclipse_elk_alg_layered_options_EdgeConstraint_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'EdgeConstraint', 446, Ljava_lang_Enum_2_classLit, values_44, valueOf_36);
function $clinit_EdgeConstraint$Map() {
    $clinit_EdgeConstraint$Map = emptyMethod;
    $MAP_26 = createValueOfMap(($clinit_EdgeConstraint(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_EdgeConstraint_2_classLit, 1), $intern_36, 446, 0, [
        NONE_2,
        INCOMING_ONLY,
        OUTGOING_ONLY
    ])));
}
var $MAP_26;
function $clinit_EdgeLabelSideSelection() {
    $clinit_EdgeLabelSideSelection = emptyMethod;
    ALWAYS_UP = new EdgeLabelSideSelection('ALWAYS_UP', 0);
    ALWAYS_DOWN = new EdgeLabelSideSelection('ALWAYS_DOWN', 1);
    DIRECTION_UP = new EdgeLabelSideSelection('DIRECTION_UP', 2);
    DIRECTION_DOWN = new EdgeLabelSideSelection('DIRECTION_DOWN', 3);
    SMART_UP = new EdgeLabelSideSelection('SMART_UP', 4);
    SMART_DOWN = new EdgeLabelSideSelection('SMART_DOWN', 5);
}
function $transpose_2(this$static) {
    switch(this$static.ordinal){
        case 0:
            return ALWAYS_DOWN;
        case 1:
            return ALWAYS_UP;
        case 2:
            return DIRECTION_DOWN;
        case 3:
            return DIRECTION_UP;
        case 4:
            return SMART_DOWN;
        case 5:
            return SMART_UP;
        default:
            return null;
    }
}
function EdgeLabelSideSelection(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_37(name_0) {
    $clinit_EdgeLabelSideSelection();
    return valueOf(($clinit_EdgeLabelSideSelection$Map(), $MAP_27), name_0);
}
function values_45() {
    $clinit_EdgeLabelSideSelection();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_EdgeLabelSideSelection_2_classLit, 1), $intern_36, 281, 0, [
        ALWAYS_UP,
        ALWAYS_DOWN,
        DIRECTION_UP,
        DIRECTION_DOWN,
        SMART_UP,
        SMART_DOWN
    ]);
}
defineClass(281, 23, {
    3: 1,
    34: 1,
    23: 1,
    281: 1
}, EdgeLabelSideSelection);
var ALWAYS_DOWN, ALWAYS_UP, DIRECTION_DOWN, DIRECTION_UP, SMART_DOWN, SMART_UP;
var Lorg_eclipse_elk_alg_layered_options_EdgeLabelSideSelection_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'EdgeLabelSideSelection', 281, Ljava_lang_Enum_2_classLit, values_45, valueOf_37);
function $clinit_EdgeLabelSideSelection$Map() {
    $clinit_EdgeLabelSideSelection$Map = emptyMethod;
    $MAP_27 = createValueOfMap(($clinit_EdgeLabelSideSelection(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_EdgeLabelSideSelection_2_classLit, 1), $intern_36, 281, 0, [
        ALWAYS_UP,
        ALWAYS_DOWN,
        DIRECTION_UP,
        DIRECTION_DOWN,
        SMART_UP,
        SMART_DOWN
    ])));
}
var $MAP_27;
function $clinit_EdgeStraighteningStrategy() {
    $clinit_EdgeStraighteningStrategy = emptyMethod;
    NONE_3 = new EdgeStraighteningStrategy('NONE', 0);
    IMPROVE_STRAIGHTNESS = new EdgeStraighteningStrategy('IMPROVE_STRAIGHTNESS', 1);
}
function EdgeStraighteningStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_38(name_0) {
    $clinit_EdgeStraighteningStrategy();
    return valueOf(($clinit_EdgeStraighteningStrategy$Map(), $MAP_28), name_0);
}
function values_46() {
    $clinit_EdgeStraighteningStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_EdgeStraighteningStrategy_2_classLit, 1), $intern_36, 474, 0, [
        NONE_3,
        IMPROVE_STRAIGHTNESS
    ]);
}
defineClass(474, 23, {
    3: 1,
    34: 1,
    23: 1,
    474: 1
}, EdgeStraighteningStrategy);
var IMPROVE_STRAIGHTNESS, NONE_3;
var Lorg_eclipse_elk_alg_layered_options_EdgeStraighteningStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'EdgeStraighteningStrategy', 474, Ljava_lang_Enum_2_classLit, values_46, valueOf_38);
function $clinit_EdgeStraighteningStrategy$Map() {
    $clinit_EdgeStraighteningStrategy$Map = emptyMethod;
    $MAP_28 = createValueOfMap(($clinit_EdgeStraighteningStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_EdgeStraighteningStrategy_2_classLit, 1), $intern_36, 474, 0, [
        NONE_3,
        IMPROVE_STRAIGHTNESS
    ])));
}
var $MAP_28;
function $clinit_FixedAlignment() {
    $clinit_FixedAlignment = emptyMethod;
    NONE_4 = new FixedAlignment('NONE', 0);
    LEFTUP = new FixedAlignment('LEFTUP', 1);
    RIGHTUP = new FixedAlignment('RIGHTUP', 2);
    LEFTDOWN = new FixedAlignment('LEFTDOWN', 3);
    RIGHTDOWN = new FixedAlignment('RIGHTDOWN', 4);
    BALANCED = new FixedAlignment('BALANCED', 5);
}
function FixedAlignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_39(name_0) {
    $clinit_FixedAlignment();
    return valueOf(($clinit_FixedAlignment$Map(), $MAP_29), name_0);
}
function values_47() {
    $clinit_FixedAlignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_FixedAlignment_2_classLit, 1), $intern_36, 279, 0, [
        NONE_4,
        LEFTUP,
        RIGHTUP,
        LEFTDOWN,
        RIGHTDOWN,
        BALANCED
    ]);
}
defineClass(279, 23, {
    3: 1,
    34: 1,
    23: 1,
    279: 1
}, FixedAlignment);
var BALANCED, LEFTDOWN, LEFTUP, NONE_4, RIGHTDOWN, RIGHTUP;
var Lorg_eclipse_elk_alg_layered_options_FixedAlignment_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'FixedAlignment', 279, Ljava_lang_Enum_2_classLit, values_47, valueOf_39);
function $clinit_FixedAlignment$Map() {
    $clinit_FixedAlignment$Map = emptyMethod;
    $MAP_29 = createValueOfMap(($clinit_FixedAlignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_FixedAlignment_2_classLit, 1), $intern_36, 279, 0, [
        NONE_4,
        LEFTUP,
        RIGHTUP,
        LEFTDOWN,
        RIGHTDOWN,
        BALANCED
    ])));
}
var $MAP_29;
function $clinit_GraphCompactionStrategy() {
    $clinit_GraphCompactionStrategy = emptyMethod;
    NONE_5 = new GraphCompactionStrategy('NONE', 0);
    LEFT_2 = new GraphCompactionStrategy('LEFT', 1);
    RIGHT_2 = new GraphCompactionStrategy('RIGHT', 2);
    LEFT_RIGHT_CONSTRAINT_LOCKING = new GraphCompactionStrategy('LEFT_RIGHT_CONSTRAINT_LOCKING', 3);
    LEFT_RIGHT_CONNECTION_LOCKING = new GraphCompactionStrategy('LEFT_RIGHT_CONNECTION_LOCKING', 4);
    EDGE_LENGTH = new GraphCompactionStrategy('EDGE_LENGTH', 5);
}
function GraphCompactionStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_40(name_0) {
    $clinit_GraphCompactionStrategy();
    return valueOf(($clinit_GraphCompactionStrategy$Map(), $MAP_30), name_0);
}
function values_48() {
    $clinit_GraphCompactionStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_GraphCompactionStrategy_2_classLit, 1), $intern_36, 280, 0, [
        NONE_5,
        LEFT_2,
        RIGHT_2,
        LEFT_RIGHT_CONSTRAINT_LOCKING,
        LEFT_RIGHT_CONNECTION_LOCKING,
        EDGE_LENGTH
    ]);
}
defineClass(280, 23, {
    3: 1,
    34: 1,
    23: 1,
    280: 1
}, GraphCompactionStrategy);
var EDGE_LENGTH, LEFT_2, LEFT_RIGHT_CONNECTION_LOCKING, LEFT_RIGHT_CONSTRAINT_LOCKING, NONE_5, RIGHT_2;
var Lorg_eclipse_elk_alg_layered_options_GraphCompactionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'GraphCompactionStrategy', 280, Ljava_lang_Enum_2_classLit, values_48, valueOf_40);
function $clinit_GraphCompactionStrategy$Map() {
    $clinit_GraphCompactionStrategy$Map = emptyMethod;
    $MAP_30 = createValueOfMap(($clinit_GraphCompactionStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_GraphCompactionStrategy_2_classLit, 1), $intern_36, 280, 0, [
        NONE_5,
        LEFT_2,
        RIGHT_2,
        LEFT_RIGHT_CONSTRAINT_LOCKING,
        LEFT_RIGHT_CONNECTION_LOCKING,
        EDGE_LENGTH
    ])));
}
var $MAP_30;
function $clinit_GraphProperties() {
    $clinit_GraphProperties = emptyMethod;
    COMMENTS = new GraphProperties('COMMENTS', 0);
    EXTERNAL_PORTS = new GraphProperties('EXTERNAL_PORTS', 1);
    HYPEREDGES = new GraphProperties('HYPEREDGES', 2);
    HYPERNODES = new GraphProperties('HYPERNODES', 3);
    NON_FREE_PORTS = new GraphProperties('NON_FREE_PORTS', 4);
    NORTH_SOUTH_PORTS = new GraphProperties('NORTH_SOUTH_PORTS', 5);
    SELF_LOOPS = new GraphProperties('SELF_LOOPS', 6);
    CENTER_LABELS = new GraphProperties('CENTER_LABELS', 7);
    END_LABELS = new GraphProperties('END_LABELS', 8);
    PARTITIONS = new GraphProperties('PARTITIONS', 9);
}
function GraphProperties(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_41(name_0) {
    $clinit_GraphProperties();
    return valueOf(($clinit_GraphProperties$Map(), $MAP_31), name_0);
}
function values_49() {
    $clinit_GraphProperties();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_GraphProperties_2_classLit, 1), $intern_36, 259, 0, [
        COMMENTS,
        EXTERNAL_PORTS,
        HYPEREDGES,
        HYPERNODES,
        NON_FREE_PORTS,
        NORTH_SOUTH_PORTS,
        SELF_LOOPS,
        CENTER_LABELS,
        END_LABELS,
        PARTITIONS
    ]);
}
defineClass(259, 23, {
    3: 1,
    34: 1,
    23: 1,
    259: 1
}, GraphProperties);
var CENTER_LABELS, COMMENTS, END_LABELS, EXTERNAL_PORTS, HYPEREDGES, HYPERNODES, NON_FREE_PORTS, NORTH_SOUTH_PORTS, PARTITIONS, SELF_LOOPS;
var Lorg_eclipse_elk_alg_layered_options_GraphProperties_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'GraphProperties', 259, Ljava_lang_Enum_2_classLit, values_49, valueOf_41);
function $clinit_GraphProperties$Map() {
    $clinit_GraphProperties$Map = emptyMethod;
    $MAP_31 = createValueOfMap(($clinit_GraphProperties(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_GraphProperties_2_classLit, 1), $intern_36, 259, 0, [
        COMMENTS,
        EXTERNAL_PORTS,
        HYPEREDGES,
        HYPERNODES,
        NON_FREE_PORTS,
        NORTH_SOUTH_PORTS,
        SELF_LOOPS,
        CENTER_LABELS,
        END_LABELS,
        PARTITIONS
    ])));
}
var $MAP_31;
function $clinit_GreedySwitchType() {
    $clinit_GreedySwitchType = emptyMethod;
    ONE_SIDED = new GreedySwitchType('ONE_SIDED', 0);
    TWO_SIDED = new GreedySwitchType('TWO_SIDED', 1);
    OFF = new GreedySwitchType('OFF', 2);
}
function GreedySwitchType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_42(name_0) {
    $clinit_GreedySwitchType();
    return valueOf(($clinit_GreedySwitchType$Map(), $MAP_32), name_0);
}
function values_50() {
    $clinit_GreedySwitchType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_GreedySwitchType_2_classLit, 1), $intern_36, 298, 0, [
        ONE_SIDED,
        TWO_SIDED,
        OFF
    ]);
}
defineClass(298, 23, {
    3: 1,
    34: 1,
    23: 1,
    298: 1
}, GreedySwitchType);
var OFF, ONE_SIDED, TWO_SIDED;
var Lorg_eclipse_elk_alg_layered_options_GreedySwitchType_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'GreedySwitchType', 298, Ljava_lang_Enum_2_classLit, values_50, valueOf_42);
function $clinit_GreedySwitchType$Map() {
    $clinit_GreedySwitchType$Map = emptyMethod;
    $MAP_32 = createValueOfMap(($clinit_GreedySwitchType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_GreedySwitchType_2_classLit, 1), $intern_36, 298, 0, [
        ONE_SIDED,
        TWO_SIDED,
        OFF
    ])));
}
var $MAP_32;
function $clinit_InLayerConstraint() {
    $clinit_InLayerConstraint = emptyMethod;
    NONE_6 = new InLayerConstraint('NONE', 0);
    TOP_1 = new InLayerConstraint('TOP', 1);
    BOTTOM_0 = new InLayerConstraint('BOTTOM', 2);
}
function InLayerConstraint(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_43(name_0) {
    $clinit_InLayerConstraint();
    return valueOf(($clinit_InLayerConstraint$Map(), $MAP_33), name_0);
}
function values_51() {
    $clinit_InLayerConstraint();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_InLayerConstraint_2_classLit, 1), $intern_36, 312, 0, [
        NONE_6,
        TOP_1,
        BOTTOM_0
    ]);
}
defineClass(312, 23, {
    3: 1,
    34: 1,
    23: 1,
    312: 1
}, InLayerConstraint);
var BOTTOM_0, NONE_6, TOP_1;
var Lorg_eclipse_elk_alg_layered_options_InLayerConstraint_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'InLayerConstraint', 312, Ljava_lang_Enum_2_classLit, values_51, valueOf_43);
function $clinit_InLayerConstraint$Map() {
    $clinit_InLayerConstraint$Map = emptyMethod;
    $MAP_33 = createValueOfMap(($clinit_InLayerConstraint(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_InLayerConstraint_2_classLit, 1), $intern_36, 312, 0, [
        NONE_6,
        TOP_1,
        BOTTOM_0
    ])));
}
var $MAP_33;
function $clinit_InteractiveReferencePoint() {
    $clinit_InteractiveReferencePoint = emptyMethod;
    CENTER_3 = new InteractiveReferencePoint('CENTER', 0);
    TOP_LEFT = new InteractiveReferencePoint('TOP_LEFT', 1);
}
function InteractiveReferencePoint(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_44(name_0) {
    $clinit_InteractiveReferencePoint();
    return valueOf(($clinit_InteractiveReferencePoint$Map(), $MAP_34), name_0);
}
function values_52() {
    $clinit_InteractiveReferencePoint();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_InteractiveReferencePoint_2_classLit, 1), $intern_36, 417, 0, [
        CENTER_3,
        TOP_LEFT
    ]);
}
defineClass(417, 23, {
    3: 1,
    34: 1,
    23: 1,
    417: 1
}, InteractiveReferencePoint);
var CENTER_3, TOP_LEFT;
var Lorg_eclipse_elk_alg_layered_options_InteractiveReferencePoint_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'InteractiveReferencePoint', 417, Ljava_lang_Enum_2_classLit, values_52, valueOf_44);
function $clinit_InteractiveReferencePoint$Map() {
    $clinit_InteractiveReferencePoint$Map = emptyMethod;
    $MAP_34 = createValueOfMap(($clinit_InteractiveReferencePoint(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_InteractiveReferencePoint_2_classLit, 1), $intern_36, 417, 0, [
        CENTER_3,
        TOP_LEFT
    ])));
}
var $MAP_34;
function $clinit_InternalProperties_1() {
    $clinit_InternalProperties_1 = emptyMethod;
    var all, all0;
    ORIGIN_0 = new Property('origin');
    COORDINATE_SYSTEM_ORIGIN = new Property('coordinateOrigin');
    PROCESSORS = new Property('processors');
    COMPOUND_NODE = new Property_0('compoundNode', ($clinit_Boolean(), false));
    INSIDE_CONNECTIONS = new Property_0('insideConnections', false);
    ORIGINAL_BENDPOINTS = new Property('originalBendpoints');
    ORIGINAL_DUMMY_NODE_POSITION = new Property('originalDummyNodePosition');
    ORIGINAL_LABEL_EDGE = new Property('originalLabelEdge');
    REPRESENTED_LABELS = new Property('representedLabels');
    END_LABELS_0 = new Property('endLabels');
    END_LABEL_EDGE = new Property('endLabel.origin');
    LABEL_SIDE = new Property_0('labelSide', ($clinit_LabelSide(), UNKNOWN));
    MAX_EDGE_THICKNESS = new Property_0('maxEdgeThickness', 0);
    REVERSED = new Property_0('reversed', false);
    RANDOM_0 = new Property('random');
    LONG_EDGE_SOURCE = new Property_0('longEdgeSource', null);
    LONG_EDGE_TARGET = new Property_0('longEdgeTarget', null);
    LONG_EDGE_HAS_LABEL_DUMMIES = new Property_0('longEdgeHasLabelDummies', false);
    LONG_EDGE_BEFORE_LABEL_DUMMY = new Property_0('longEdgeBeforeLabelDummy', false);
    EDGE_CONSTRAINT = new Property_0('edgeConstraint', ($clinit_EdgeConstraint(), NONE_2));
    IN_LAYER_LAYOUT_UNIT = new Property('inLayerLayoutUnit');
    IN_LAYER_CONSTRAINT = new Property_0('inLayerConstraint', ($clinit_InLayerConstraint(), NONE_6));
    IN_LAYER_SUCCESSOR_CONSTRAINTS = new Property_0('inLayerSuccessorConstraint', new ArrayList);
    IN_LAYER_SUCCESSOR_CONSTRAINTS_BETWEEN_NON_DUMMIES = new Property_0('inLayerSuccessorConstraintBetweenNonDummies', false);
    PORT_DUMMY = new Property('portDummy');
    CROSSING_HINT = new Property_0('crossingHint', valueOf_3(0));
    GRAPH_PROPERTIES = new Property_0('graphProperties', (all0 = castTo($getEnumConstants(Lorg_eclipse_elk_alg_layered_options_GraphProperties_2_classLit), 10), new EnumSet$EnumSetImpl(all0, castTo(createFrom(all0, all0.length), 10), 0)));
    EXT_PORT_SIDE = new Property_0('externalPortSide', ($clinit_PortSide(), UNDEFINED_5));
    EXT_PORT_SIZE = new Property_0('externalPortSize', new KVector);
    EXT_PORT_REPLACED_DUMMIES = new Property('externalPortReplacedDummies');
    EXT_PORT_REPLACED_DUMMY = new Property('externalPortReplacedDummy');
    EXT_PORT_CONNECTIONS = new Property_0('externalPortConnections', (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)));
    PORT_RATIO_OR_POSITION_0 = new Property_0('portRatioOrPosition', 0);
    BARYCENTER_ASSOCIATES = new Property('barycenterAssociates');
    TOP_COMMENTS = new Property('TopSideComments');
    BOTTOM_COMMENTS = new Property('BottomSideComments');
    COMMENT_CONN_PORT = new Property('CommentConnectionPort');
    INPUT_COLLECT = new Property_0('inputCollect', false);
    OUTPUT_COLLECT = new Property_0('outputCollect', false);
    CYCLIC = new Property_0('cyclic', false);
    CROSS_HIERARCHY_MAP = new Property('crossHierarchyMap');
    TARGET_OFFSET = new Property('targetOffset');
    new Property_0('splineLabelSize', new KVector);
    SPACINGS = new Property('spacings');
    PARTITION_DUMMY = new Property_0('partitionConstraint', false);
    BREAKING_POINT_INFO = new Property('breakingPoint.info');
    SPLINE_SURVIVING_EDGE = new Property('splines.survivingEdge');
    SPLINE_ROUTE_START = new Property('splines.route.start');
    SPLINE_EDGE_CHAIN = new Property('splines.edgeChain');
    ORIGINAL_PORT_CONSTRAINTS = new Property('originalPortConstraints');
    SELF_LOOP_HOLDER = new Property('selfLoopHolder');
    SPLINE_NS_PORT_Y_COORD = new Property('splines.nsPortY');
    MODEL_ORDER_1 = new Property('modelOrder');
    LONG_EDGE_TARGET_NODE = new Property('longEdgeTargetNode');
    FIRST_TRY_WITH_INITIAL_ORDER = new Property_0('firstTryWithInitialOrder', false);
    SECOND_TRY_WITH_INITIAL_ORDER = new Property_0('firstTryWithInitialOrder', false);
    HIDDEN_NODES = new Property('layerConstraints.hiddenNodes');
    ORIGINAL_OPPOSITE_PORT = new Property('layerConstraints.opposidePort');
    TARGET_NODE_MODEL_ORDER = new Property('targetNode.modelOrder');
}
var BARYCENTER_ASSOCIATES, BOTTOM_COMMENTS, BREAKING_POINT_INFO, COMMENT_CONN_PORT, COMPOUND_NODE, COORDINATE_SYSTEM_ORIGIN, CROSSING_HINT, CROSS_HIERARCHY_MAP, CYCLIC, EDGE_CONSTRAINT, END_LABELS_0, END_LABEL_EDGE, EXT_PORT_CONNECTIONS, EXT_PORT_REPLACED_DUMMIES, EXT_PORT_REPLACED_DUMMY, EXT_PORT_SIDE, EXT_PORT_SIZE, FIRST_TRY_WITH_INITIAL_ORDER, GRAPH_PROPERTIES, HIDDEN_NODES, INPUT_COLLECT, INSIDE_CONNECTIONS, IN_LAYER_CONSTRAINT, IN_LAYER_LAYOUT_UNIT, IN_LAYER_SUCCESSOR_CONSTRAINTS, IN_LAYER_SUCCESSOR_CONSTRAINTS_BETWEEN_NON_DUMMIES, LABEL_SIDE, LONG_EDGE_BEFORE_LABEL_DUMMY, LONG_EDGE_HAS_LABEL_DUMMIES, LONG_EDGE_SOURCE, LONG_EDGE_TARGET, LONG_EDGE_TARGET_NODE, MAX_EDGE_THICKNESS, MODEL_ORDER_1, ORIGIN_0, ORIGINAL_BENDPOINTS, ORIGINAL_DUMMY_NODE_POSITION, ORIGINAL_LABEL_EDGE, ORIGINAL_OPPOSITE_PORT, ORIGINAL_PORT_CONSTRAINTS, OUTPUT_COLLECT, PARTITION_DUMMY, PORT_DUMMY, PORT_RATIO_OR_POSITION_0, PROCESSORS, RANDOM_0, REPRESENTED_LABELS, REVERSED, SECOND_TRY_WITH_INITIAL_ORDER, SELF_LOOP_HOLDER, SPACINGS, SPLINE_EDGE_CHAIN, SPLINE_NS_PORT_Y_COORD, SPLINE_ROUTE_START, SPLINE_SURVIVING_EDGE, TARGET_NODE_MODEL_ORDER, TARGET_OFFSET, TOP_COMMENTS;
function $clinit_LayerConstraint() {
    $clinit_LayerConstraint = emptyMethod;
    NONE_7 = new LayerConstraint('NONE', 0);
    FIRST = new LayerConstraint('FIRST', 1);
    FIRST_SEPARATE_0 = new LayerConstraint('FIRST_SEPARATE', 2);
    LAST = new LayerConstraint('LAST', 3);
    LAST_SEPARATE_0 = new LayerConstraint('LAST_SEPARATE', 4);
}
function LayerConstraint(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_45(name_0) {
    $clinit_LayerConstraint();
    return valueOf(($clinit_LayerConstraint$Map(), $MAP_35), name_0);
}
function values_53() {
    $clinit_LayerConstraint();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LayerConstraint_2_classLit, 1), $intern_36, 171, 0, [
        NONE_7,
        FIRST,
        FIRST_SEPARATE_0,
        LAST,
        LAST_SEPARATE_0
    ]);
}
defineClass(171, 23, {
    3: 1,
    34: 1,
    23: 1,
    171: 1
}, LayerConstraint);
var FIRST, FIRST_SEPARATE_0, LAST, LAST_SEPARATE_0, NONE_7;
var Lorg_eclipse_elk_alg_layered_options_LayerConstraint_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'LayerConstraint', 171, Ljava_lang_Enum_2_classLit, values_53, valueOf_45);
function $clinit_LayerConstraint$Map() {
    $clinit_LayerConstraint$Map = emptyMethod;
    $MAP_35 = createValueOfMap(($clinit_LayerConstraint(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LayerConstraint_2_classLit, 1), $intern_36, 171, 0, [
        NONE_7,
        FIRST,
        FIRST_SEPARATE_0,
        LAST,
        LAST_SEPARATE_0
    ])));
}
var $MAP_35;
function $clinit_LayerUnzippingStrategy() {
    $clinit_LayerUnzippingStrategy = emptyMethod;
    NONE_8 = new LayerUnzippingStrategy('NONE', 0);
    ALTERNATING = new LayerUnzippingStrategy('ALTERNATING', 1);
}
function LayerUnzippingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_46(name_0) {
    $clinit_LayerUnzippingStrategy();
    return valueOf(($clinit_LayerUnzippingStrategy$Map(), $MAP_36), name_0);
}
function values_54() {
    $clinit_LayerUnzippingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LayerUnzippingStrategy_2_classLit, 1), $intern_36, 420, 0, [
        NONE_8,
        ALTERNATING
    ]);
}
defineClass(420, 23, {
    3: 1,
    34: 1,
    23: 1,
    420: 1
}, LayerUnzippingStrategy);
var ALTERNATING, NONE_8;
var Lorg_eclipse_elk_alg_layered_options_LayerUnzippingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'LayerUnzippingStrategy', 420, Ljava_lang_Enum_2_classLit, values_54, valueOf_46);
function $clinit_LayerUnzippingStrategy$Map() {
    $clinit_LayerUnzippingStrategy$Map = emptyMethod;
    $MAP_36 = createValueOfMap(($clinit_LayerUnzippingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LayerUnzippingStrategy_2_classLit, 1), $intern_36, 420, 0, [
        NONE_8,
        ALTERNATING
    ])));
}
var $MAP_36;
function $clinit_LayeredMetaDataProvider() {
    $clinit_LayeredMetaDataProvider = emptyMethod;
    DIRECTION_CONGRUENCY_DEFAULT = ($clinit_DirectionCongruency(), READING_DIRECTION);
    DIRECTION_CONGRUENCY = new Property_1('org.eclipse.elk.layered.directionCongruency', DIRECTION_CONGRUENCY_DEFAULT);
    FEEDBACK_EDGES = new Property_1('org.eclipse.elk.layered.feedbackEdges', ($clinit_Boolean(), false));
    INTERACTIVE_REFERENCE_POINT_DEFAULT = ($clinit_InteractiveReferencePoint(), CENTER_3);
    INTERACTIVE_REFERENCE_POINT = new Property_1('org.eclipse.elk.layered.interactiveReferencePoint', INTERACTIVE_REFERENCE_POINT_DEFAULT);
    MERGE_EDGES = new Property_1('org.eclipse.elk.layered.mergeEdges', false);
    MERGE_HIERARCHY_EDGES = new Property_1('org.eclipse.elk.layered.mergeHierarchyEdges', true);
    ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES = new Property_1('org.eclipse.elk.layered.allowNonFlowPortsToSwitchSides', false);
    PORT_SORTING_STRATEGY_DEFAULT = ($clinit_PortSortingStrategy(), INPUT_ORDER);
    PORT_SORTING_STRATEGY = new Property_1('org.eclipse.elk.layered.portSortingStrategy', PORT_SORTING_STRATEGY_DEFAULT);
    valueOf_3(1);
    THOROUGHNESS = new Property_1('org.eclipse.elk.layered.thoroughness', valueOf_3(7));
    UNNECESSARY_BENDPOINTS = new Property_1('org.eclipse.elk.layered.unnecessaryBendpoints', false);
    GENERATE_POSITION_AND_LAYER_IDS = new Property_1('org.eclipse.elk.layered.generatePositionAndLayerIds', false);
    CYCLE_BREAKING_STRATEGY_DEFAULT = ($clinit_CycleBreakingStrategy(), GREEDY);
    CYCLE_BREAKING_STRATEGY = new Property_1('org.eclipse.elk.layered.cycleBreaking.strategy', CYCLE_BREAKING_STRATEGY_DEFAULT);
    LAYERING_STRATEGY_DEFAULT = ($clinit_LayeringStrategy(), NETWORK_SIMPLEX);
    LAYERING_STRATEGY = new Property_1('org.eclipse.elk.layered.layering.strategy', LAYERING_STRATEGY_DEFAULT);
    LAYERING_LAYER_CONSTRAINT_DEFAULT = ($clinit_LayerConstraint(), NONE_7);
    LAYERING_LAYER_CONSTRAINT = new Property_1('org.eclipse.elk.layered.layering.layerConstraint', LAYERING_LAYER_CONSTRAINT_DEFAULT);
    valueOf_3(-1);
    LAYERING_LAYER_CHOICE_CONSTRAINT = new Property_1('org.eclipse.elk.layered.layering.layerChoiceConstraint', null);
    valueOf_3(-1);
    LAYERING_LAYER_ID = new Property_1('org.eclipse.elk.layered.layering.layerId', valueOf_3(-1));
    valueOf_3(-1);
    LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH = new Property_1('org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth', valueOf_3(4));
    valueOf_3(-1);
    LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR = new Property_1('org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor', valueOf_3(2));
    LAYERING_NODE_PROMOTION_STRATEGY_DEFAULT = ($clinit_NodePromotionStrategy(), NONE_10);
    LAYERING_NODE_PROMOTION_STRATEGY = new Property_1('org.eclipse.elk.layered.layering.nodePromotion.strategy', LAYERING_NODE_PROMOTION_STRATEGY_DEFAULT);
    valueOf_3(0);
    LAYERING_NODE_PROMOTION_MAX_ITERATIONS = new Property_1('org.eclipse.elk.layered.layering.nodePromotion.maxIterations', valueOf_3(0));
    LAYERING_COFFMAN_GRAHAM_LAYER_BOUND = new Property_1('org.eclipse.elk.layered.layering.coffmanGraham.layerBound', valueOf_3($intern_0));
    CROSSING_MINIMIZATION_STRATEGY_DEFAULT = ($clinit_CrossingMinimizationStrategy(), LAYER_SWEEP);
    CROSSING_MINIMIZATION_STRATEGY = new Property_1('org.eclipse.elk.layered.crossingMinimization.strategy', CROSSING_MINIMIZATION_STRATEGY_DEFAULT);
    CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER = new Property_1('org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder', false);
    CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS = new Property_1('org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness', 0.1);
    CROSSING_MINIMIZATION_SEMI_INTERACTIVE = new Property_1('org.eclipse.elk.layered.crossingMinimization.semiInteractive', false);
    CROSSING_MINIMIZATION_IN_LAYER_PRED_OF = new Property_1('org.eclipse.elk.layered.crossingMinimization.inLayerPredOf', null);
    CROSSING_MINIMIZATION_IN_LAYER_SUCC_OF = new Property_1('org.eclipse.elk.layered.crossingMinimization.inLayerSuccOf', null);
    valueOf_3(-1);
    CROSSING_MINIMIZATION_POSITION_CHOICE_CONSTRAINT = new Property_1('org.eclipse.elk.layered.crossingMinimization.positionChoiceConstraint', null);
    valueOf_3(-1);
    CROSSING_MINIMIZATION_POSITION_ID = new Property_1('org.eclipse.elk.layered.crossingMinimization.positionId', valueOf_3(-1));
    valueOf_3(0);
    CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD = new Property_1('org.eclipse.elk.layered.crossingMinimization.greedySwitch.activationThreshold', valueOf_3(40));
    CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEFAULT = ($clinit_GreedySwitchType(), TWO_SIDED);
    CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE = new Property_1('org.eclipse.elk.layered.crossingMinimization.greedySwitch.type', CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEFAULT);
    CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEFAULT = OFF;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE = new Property_1('org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type', CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEFAULT);
    NODE_PLACEMENT_STRATEGY_DEFAULT = ($clinit_NodePlacementStrategy(), BRANDES_KOEPF);
    NODE_PLACEMENT_STRATEGY = new Property_1('org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_STRATEGY_DEFAULT);
    NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES = new Property('org.eclipse.elk.layered.nodePlacement.favorStraightEdges');
    NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEFAULT = ($clinit_EdgeStraighteningStrategy(), IMPROVE_STRAIGHTNESS);
    NODE_PLACEMENT_BK_EDGE_STRAIGHTENING = new Property_1('org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening', NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEFAULT);
    NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEFAULT = ($clinit_FixedAlignment(), NONE_4);
    NODE_PLACEMENT_BK_FIXED_ALIGNMENT = new Property_1('org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment', NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEFAULT);
    new ExclusiveBounds$ExclusiveLowerBound;
    NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING = new Property_1('org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening', 0.3);
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY = new Property('org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility');
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEFAULT = ($clinit_NodeFlexibility(), NONE_9);
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT = new Property_1('org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default', NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEFAULT);
    EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_DEFAULT = ($clinit_SelfLoopDistributionStrategy(), NORTH_0);
    EDGE_ROUTING_SELF_LOOP_DISTRIBUTION = new Property_1('org.eclipse.elk.layered.edgeRouting.selfLoopDistribution', EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_DEFAULT);
    EDGE_ROUTING_SELF_LOOP_ORDERING_DEFAULT = ($clinit_SelfLoopOrderingStrategy(), STACKED);
    EDGE_ROUTING_SELF_LOOP_ORDERING = new Property_1('org.eclipse.elk.layered.edgeRouting.selfLoopOrdering', EDGE_ROUTING_SELF_LOOP_ORDERING_DEFAULT);
    EDGE_ROUTING_SPLINES_MODE_DEFAULT = ($clinit_SplineRoutingMode(), SLOPPY);
    EDGE_ROUTING_SPLINES_MODE = new Property_1('org.eclipse.elk.layered.edgeRouting.splines.mode', EDGE_ROUTING_SPLINES_MODE_DEFAULT);
    EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR = new Property_1('org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor', 0.2);
    EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH = new Property_1('org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth', 2);
    SPACING_BASE_VALUE = new Property_1('org.eclipse.elk.layered.spacing.baseValue', null);
    SPACING_EDGE_NODE_BETWEEN_LAYERS = new Property_1('org.eclipse.elk.layered.spacing.edgeNodeBetweenLayers', 10);
    SPACING_EDGE_EDGE_BETWEEN_LAYERS = new Property_1('org.eclipse.elk.layered.spacing.edgeEdgeBetweenLayers', 10);
    SPACING_NODE_NODE_BETWEEN_LAYERS = new Property_1('org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers', 20);
    valueOf_3(0);
    PRIORITY_DIRECTION = new Property_1('org.eclipse.elk.layered.priority.direction', valueOf_3(0));
    valueOf_3(0);
    PRIORITY_SHORTNESS = new Property_1('org.eclipse.elk.layered.priority.shortness', valueOf_3(0));
    valueOf_3(0);
    PRIORITY_STRAIGHTNESS = new Property_1('org.eclipse.elk.layered.priority.straightness', valueOf_3(0));
    COMPACTION_CONNECTED_COMPONENTS = new Property_1('org.eclipse.elk.layered.compaction.connectedComponents', false);
    COMPACTION_POST_COMPACTION_STRATEGY_DEFAULT = ($clinit_GraphCompactionStrategy(), NONE_5);
    COMPACTION_POST_COMPACTION_STRATEGY = new Property_1('org.eclipse.elk.layered.compaction.postCompaction.strategy', COMPACTION_POST_COMPACTION_STRATEGY_DEFAULT);
    COMPACTION_POST_COMPACTION_CONSTRAINTS_DEFAULT = ($clinit_ConstraintCalculationStrategy(), SCANLINE);
    COMPACTION_POST_COMPACTION_CONSTRAINTS = new Property_1('org.eclipse.elk.layered.compaction.postCompaction.constraints', COMPACTION_POST_COMPACTION_CONSTRAINTS_DEFAULT);
    HIGH_DEGREE_NODES_TREATMENT = new Property_1('org.eclipse.elk.layered.highDegreeNodes.treatment', false);
    valueOf_3(0);
    HIGH_DEGREE_NODES_THRESHOLD = new Property_1('org.eclipse.elk.layered.highDegreeNodes.threshold', valueOf_3(16));
    valueOf_3(0);
    HIGH_DEGREE_NODES_TREE_HEIGHT = new Property_1('org.eclipse.elk.layered.highDegreeNodes.treeHeight', valueOf_3(5));
    WRAPPING_STRATEGY_DEFAULT = ($clinit_WrappingStrategy(), OFF_0);
    WRAPPING_STRATEGY = new Property_1('org.eclipse.elk.layered.wrapping.strategy', WRAPPING_STRATEGY_DEFAULT);
    WRAPPING_ADDITIONAL_EDGE_SPACING = new Property_1('org.eclipse.elk.layered.wrapping.additionalEdgeSpacing', 10);
    WRAPPING_CORRECTION_FACTOR = new Property_1('org.eclipse.elk.layered.wrapping.correctionFactor', 1);
    WRAPPING_CUTTING_STRATEGY_DEFAULT = ($clinit_CuttingStrategy(), MSD);
    WRAPPING_CUTTING_STRATEGY = new Property_1('org.eclipse.elk.layered.wrapping.cutting.strategy', WRAPPING_CUTTING_STRATEGY_DEFAULT);
    WRAPPING_CUTTING_CUTS = new Property('org.eclipse.elk.layered.wrapping.cutting.cuts');
    WRAPPING_CUTTING_MSD_FREEDOM_DEFAULT = valueOf_3(1);
    valueOf_3(0);
    WRAPPING_CUTTING_MSD_FREEDOM = new Property_1('org.eclipse.elk.layered.wrapping.cutting.msd.freedom', WRAPPING_CUTTING_MSD_FREEDOM_DEFAULT);
    WRAPPING_VALIDIFY_STRATEGY_DEFAULT = ($clinit_ValidifyStrategy(), GREEDY_0);
    WRAPPING_VALIDIFY_STRATEGY = new Property_1('org.eclipse.elk.layered.wrapping.validify.strategy', WRAPPING_VALIDIFY_STRATEGY_DEFAULT);
    WRAPPING_VALIDIFY_FORBIDDEN_INDICES = new Property('org.eclipse.elk.layered.wrapping.validify.forbiddenIndices');
    WRAPPING_MULTI_EDGE_IMPROVE_CUTS = new Property_1('org.eclipse.elk.layered.wrapping.multiEdge.improveCuts', true);
    WRAPPING_MULTI_EDGE_DISTANCE_PENALTY = new Property_1('org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty', 2);
    WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES = new Property_1('org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges', true);
    LAYER_UNZIPPING_STRATEGY_DEFAULT = ($clinit_LayerUnzippingStrategy(), NONE_8);
    LAYER_UNZIPPING_STRATEGY = new Property_1('org.eclipse.elk.layered.layerUnzipping.strategy', LAYER_UNZIPPING_STRATEGY_DEFAULT);
    LAYER_UNZIPPING_LAYER_SPLIT_DEFAULT = valueOf_3(2);
    valueOf_3(1);
    LAYER_UNZIPPING_LAYER_SPLIT = new Property_1('org.eclipse.elk.layered.layerUnzipping.layerSplit', LAYER_UNZIPPING_LAYER_SPLIT_DEFAULT);
    LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEFAULT = true;
    LAYER_UNZIPPING_RESET_ON_LONG_EDGES = new Property_1('org.eclipse.elk.layered.layerUnzipping.resetOnLongEdges', LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEFAULT);
    EDGE_LABELS_SIDE_SELECTION_DEFAULT = ($clinit_EdgeLabelSideSelection(), SMART_DOWN);
    EDGE_LABELS_SIDE_SELECTION = new Property_1('org.eclipse.elk.layered.edgeLabels.sideSelection', EDGE_LABELS_SIDE_SELECTION_DEFAULT);
    EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_DEFAULT = ($clinit_CenterEdgeLabelPlacementStrategy(), MEDIAN_LAYER);
    EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY = new Property_1('org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy', EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_DEFAULT);
    CONSIDER_MODEL_ORDER_STRATEGY_DEFAULT = ($clinit_OrderingStrategy(), NONE_11);
    CONSIDER_MODEL_ORDER_STRATEGY = new Property_1('org.eclipse.elk.layered.considerModelOrder.strategy', CONSIDER_MODEL_ORDER_STRATEGY_DEFAULT);
    CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER = new Property_1('org.eclipse.elk.layered.considerModelOrder.portModelOrder', false);
    CONSIDER_MODEL_ORDER_NO_MODEL_ORDER = new Property_1('org.eclipse.elk.layered.considerModelOrder.noModelOrder', false);
    CONSIDER_MODEL_ORDER_COMPONENTS_DEFAULT = ($clinit_ComponentOrderingStrategy(), NONE);
    CONSIDER_MODEL_ORDER_COMPONENTS = new Property_1('org.eclipse.elk.layered.considerModelOrder.components', CONSIDER_MODEL_ORDER_COMPONENTS_DEFAULT);
    CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_DEFAULT = ($clinit_LongEdgeOrderingStrategy(), DUMMY_NODE_OVER);
    CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY = new Property_1('org.eclipse.elk.layered.considerModelOrder.longEdgeStrategy', CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_DEFAULT);
    CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE = new Property_1('org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence', 0);
    CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE = new Property_1('org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence', 0);
    INTERACTIVE_REFERENCE_POINT_DEP_CYCLE_BREAKING_STRATEGY_0 = INTERACTIVE_2;
    INTERACTIVE_REFERENCE_POINT_DEP_CROSSING_MINIMIZATION_STRATEGY_1 = INTERACTIVE_1;
    LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_DEP_LAYERING_STRATEGY_0 = MIN_WIDTH;
    LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_DEP_LAYERING_STRATEGY_0 = MIN_WIDTH;
    LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_DEP_LAYERING_STRATEGY_0 = COFFMAN_GRAHAM;
    CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_DEP_HIERARCHY_HANDLING_0 = ($clinit_HierarchyHandling(), INCLUDE_CHILDREN);
    CROSSING_MINIMIZATION_SEMI_INTERACTIVE_DEP_CROSSING_MINIMIZATION_STRATEGY_0 = LAYER_SWEEP;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEP_CROSSING_MINIMIZATION_STRATEGY_0 = LAYER_SWEEP;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEP_CROSSING_MINIMIZATION_STRATEGY_0 = LAYER_SWEEP;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEP_HIERARCHY_HANDLING_1 = INCLUDE_CHILDREN;
    NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_DEP_NODE_PLACEMENT_STRATEGY_0 = NETWORK_SIMPLEX_0;
    NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_DEP_NODE_PLACEMENT_STRATEGY_1 = BRANDES_KOEPF;
    NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEP_NODE_PLACEMENT_STRATEGY_0 = BRANDES_KOEPF;
    NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEP_NODE_PLACEMENT_STRATEGY_0 = BRANDES_KOEPF;
    NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_DEP_NODE_PLACEMENT_STRATEGY_0 = LINEAR_SEGMENTS;
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEP_NODE_PLACEMENT_STRATEGY_0 = NETWORK_SIMPLEX_0;
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEP_NODE_PLACEMENT_STRATEGY_0 = NETWORK_SIMPLEX_0;
    EDGE_ROUTING_SPLINES_MODE_DEP_EDGE_ROUTING_0 = ($clinit_EdgeRouting(), SPLINES);
    EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_DEP_EDGE_ROUTING_0 = SPLINES;
    EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_DEP_EDGE_ROUTING_SPLINES_MODE_1 = SLOPPY;
    EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_DEP_EDGE_ROUTING_0 = POLYLINE;
    WRAPPING_ADDITIONAL_EDGE_SPACING_DEP_WRAPPING_STRATEGY_0 = SINGLE_EDGE;
    WRAPPING_ADDITIONAL_EDGE_SPACING_DEP_WRAPPING_STRATEGY_1 = MULTI_EDGE;
    WRAPPING_CORRECTION_FACTOR_DEP_WRAPPING_STRATEGY_0 = SINGLE_EDGE;
    WRAPPING_CORRECTION_FACTOR_DEP_WRAPPING_STRATEGY_1 = MULTI_EDGE;
    WRAPPING_CUTTING_STRATEGY_DEP_WRAPPING_STRATEGY_0 = SINGLE_EDGE;
    WRAPPING_CUTTING_STRATEGY_DEP_WRAPPING_STRATEGY_1 = MULTI_EDGE;
    WRAPPING_CUTTING_CUTS_DEP_WRAPPING_CUTTING_STRATEGY_0 = MANUAL;
    WRAPPING_CUTTING_MSD_FREEDOM_DEP_WRAPPING_CUTTING_STRATEGY_0 = MSD;
    WRAPPING_VALIDIFY_STRATEGY_DEP_WRAPPING_STRATEGY_0 = SINGLE_EDGE;
    WRAPPING_VALIDIFY_STRATEGY_DEP_WRAPPING_STRATEGY_1 = MULTI_EDGE;
    WRAPPING_VALIDIFY_FORBIDDEN_INDICES_DEP_WRAPPING_STRATEGY_0 = SINGLE_EDGE;
    WRAPPING_VALIDIFY_FORBIDDEN_INDICES_DEP_WRAPPING_STRATEGY_1 = MULTI_EDGE;
    WRAPPING_MULTI_EDGE_IMPROVE_CUTS_DEP_WRAPPING_STRATEGY_0 = MULTI_EDGE;
    WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_DEP_WRAPPING_STRATEGY_0 = MULTI_EDGE;
    WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_DEP_WRAPPING_STRATEGY_0 = MULTI_EDGE;
    LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEP_LAYER_UNZIPPING_STRATEGY_0 = ALTERNATING;
}
function LayeredMetaDataProvider() {
    $clinit_LayeredMetaDataProvider();
}
defineClass(838, 1, $intern_98, LayeredMetaDataProvider);
_.apply_4 = function apply_107(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.directionCongruency'), ''), 'Direction Congruency'), 'Specifies how drawings of the same graph with different layout directions compare to each other: either a natural reading direction is preserved or the drawings are rotated versions of each other.'), DIRECTION_CONGRUENCY_DEFAULT), ($clinit_LayoutOptionData$Type(), ENUM)), Lorg_eclipse_elk_alg_layered_options_DirectionCongruency_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.feedbackEdges'), ''), 'Feedback Edges'), 'Whether feedback edges should be highlighted by routing around the nodes.'), ($clinit_Boolean(), false)), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.interactiveReferencePoint'), ''), 'Interactive Reference Point'), 'Determines which point of a node is considered by interactive layout phases.'), INTERACTIVE_REFERENCE_POINT_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_InteractiveReferencePoint_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.interactiveReferencePoint', 'org.eclipse.elk.layered.cycleBreaking.strategy', INTERACTIVE_REFERENCE_POINT_DEP_CYCLE_BREAKING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.interactiveReferencePoint', 'org.eclipse.elk.layered.crossingMinimization.strategy', INTERACTIVE_REFERENCE_POINT_DEP_CROSSING_MINIMIZATION_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.mergeEdges'), ''), 'Merge Edges'), 'Edges that have no ports are merged so they touch the connected nodes at the same points. When this option is disabled, one port is created for each edge directly connected to a node. When it is enabled, all such incoming edges share an input port, and all outgoing edges share an output port.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.mergeHierarchyEdges'), ''), 'Merge Hierarchy-Crossing Edges'), 'If hierarchical layout is active, hierarchy-crossing edges use as few hierarchical ports as possible. They are broken by the algorithm, with hierarchical ports inserted as required. Usually, one such port is created for each edge at each hierarchy crossing point. With this option set to true, we try to create as few hierarchical ports as possible in the process. In particular, all edges that form a hyperedge can share a port.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($legacyIds($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.allowNonFlowPortsToSwitchSides'), ''), 'Allow Non-Flow Ports To Switch Sides'), "Specifies whether non-flow ports may switch sides if their node's port constraints are either FIXED_SIDE or FIXED_ORDER. A non-flow port is a port on a side that is not part of the currently configured layout flow. For instance, given a left-to-right layout direction, north and south ports would be considered non-flow ports. Further note that the underlying criterium whether to switch sides or not solely relies on the minimization of edge crossings. Hence, edge length and other aesthetics criteria are not addressed."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PORTS)), stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'org.eclipse.elk.layered.northOrSouthPort'
    ]))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.portSortingStrategy'), ''), 'Port Sorting Strategy'), "Only relevant for nodes with FIXED_SIDE port constraints. Determines the way a node's ports are distributed on the sides of a node if their order is not prescribed. The option is set on parent nodes."), PORT_SORTING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_PortSortingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.thoroughness'), ''), 'Thoroughness'), 'How much effort should be spent to produce a nice layout.'), valueOf_3(7)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.unnecessaryBendpoints'), ''), 'Add Unnecessary Bendpoints'), 'Adds bend points even if an edge does not change direction. If true, each long edge dummy will contribute a bend point to its edges and hierarchy-crossing edges will always get a bend point where they cross hierarchy boundaries. By default, bend points are only added where an edge changes direction.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.generatePositionAndLayerIds'), ''), 'Generate Position and Layer IDs'), 'If enabled position id and layer id are generated, which are usually only used internally when setting the interactiveLayout option. This option should be specified on the root node.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.cycleBreaking.strategy'), 'cycleBreaking'), 'Cycle Breaking Strategy'), 'Strategy for cycle breaking. Cycle breaking looks for cycles in the graph and determines which edges to reverse to break the cycles. Reversed edges will end up pointing to the opposite direction of regular edges (that is, reversed edges will point left if edges usually point right).'), CYCLE_BREAKING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_CycleBreakingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.strategy'), 'layering'), 'Node Layering Strategy'), 'Strategy for node layering.'), LAYERING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_LayeringStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.layerConstraint'), 'layering'), 'Layer Constraint'), 'Determines a constraint on the placement of the node regarding the layering.'), LAYERING_LAYER_CONSTRAINT_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_LayerConstraint_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.layerChoiceConstraint'), 'layering'), 'Layer Choice Constraint'), "Allows to set a constraint regarding the layer placement of a node. Let i be the value of teh constraint. Assumed the drawing has n layers and i < n. If set to i, it expresses that the node should be placed in i-th layer. Should i>=n be true then the node is placed in the last layer of the drawing. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), null), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.layerId'), 'layering'), 'Layer ID'), 'Layer identifier that was calculated by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set.'), valueOf_3(-1)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth'), 'layering.minWidth'), 'Upper Bound On Width [MinWidth Layerer]'), "Defines a loose upper bound on the width of the MinWidth layerer. If set to '-1' multiple values are tested and the best result is selected."), valueOf_3(4)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth', 'org.eclipse.elk.layered.layering.strategy', LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_DEP_LAYERING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor'), 'layering.minWidth'), 'Upper Layer Estimation Scaling Factor [MinWidth Layerer]'), "Multiplied with Upper Bound On Width for defining an upper bound on the width of layers which haven't been determined yet, but whose maximum width had been (roughly) estimated by the MinWidth algorithm. Compensates for too high estimations. If set to '-1' multiple values are tested and the best result is selected."), valueOf_3(2)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor', 'org.eclipse.elk.layered.layering.strategy', LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_DEP_LAYERING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.nodePromotion.strategy'), 'layering.nodePromotion'), 'Node Promotion Strategy'), 'Reduces number of dummy nodes after layering phase (if possible).'), LAYERING_NODE_PROMOTION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_NodePromotionStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.nodePromotion.maxIterations'), 'layering.nodePromotion'), 'Max Node Promotion Iterations'), 'Limits the number of iterations for node promotion.'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.layering.nodePromotion.maxIterations', 'org.eclipse.elk.layered.layering.nodePromotion.strategy', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layering.coffmanGraham.layerBound'), 'layering.coffmanGraham'), 'Layer Bound'), 'The maximum number of nodes allowed per layer.'), valueOf_3($intern_0)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.layering.coffmanGraham.layerBound', 'org.eclipse.elk.layered.layering.strategy', LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_DEP_LAYERING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.strategy'), 'crossingMinimization'), 'Crossing Minimization Strategy'), 'Strategy for crossing minimization.'), CROSSING_MINIMIZATION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_CrossingMinimizationStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder'), 'crossingMinimization'), 'Force Node Model Order'), 'The node order given by the model does not change to produce a better layout. E.g. if node A is before node B in the model this is not changed during crossing minimization. This assumes that the node model order is already respected before crossing minimization. This can be achieved by setting considerModelOrder.strategy to NODES_AND_EDGES.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness'), 'crossingMinimization'), 'Hierarchical Sweepiness'), 'How likely it is to use cross-hierarchy (1) vs bottom-up (-1).'), 0.1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness', 'org.eclipse.elk.hierarchyHandling', CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_DEP_HIERARCHY_HANDLING_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.semiInteractive'), 'crossingMinimization'), 'Semi-Interactive Crossing Minimization'), "Preserves the order of nodes within a layer but still minimizes crossings between edges connecting long edge dummies. Derives the desired order from positions specified by the 'org.eclipse.elk.position' layout option. Requires a crossing minimization strategy that is able to process 'in-layer' constraints."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.crossingMinimization.semiInteractive', 'org.eclipse.elk.layered.crossingMinimization.strategy', CROSSING_MINIMIZATION_SEMI_INTERACTIVE_DEP_CROSSING_MINIMIZATION_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.inLayerPredOf'), 'crossingMinimization'), 'In Layer Predecessor of'), "Allows to set a constraint which specifies of which node the current node is the predecessor. If set to 's' then the node is the predecessor of 's' and is in the same layer"), null), STRING), Ljava_lang_String_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.inLayerSuccOf'), 'crossingMinimization'), 'In Layer Successor of'), "Allows to set a constraint which specifies of which node the current node is the successor. If set to 's' then the node is the successor of 's' and is in the same layer"), null), STRING), Ljava_lang_String_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.positionChoiceConstraint'), 'crossingMinimization'), 'Position Choice Constraint'), "Allows to set a constraint regarding the position placement of a node in a layer. Assumed the layer in which the node placed includes n other nodes and i < n. If set to i, it expresses that the node should be placed at the i-th position. Should i>=n be true then the node is placed at the last position in the layer. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), null), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.positionId'), 'crossingMinimization'), 'Position ID'), 'Position within a layer that was determined by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set.'), valueOf_3(-1)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.activationThreshold'), 'crossingMinimization.greedySwitch'), 'Greedy Switch Activation Threshold'), "By default it is decided automatically if the greedy switch is activated or not. The decision is based on whether the size of the input graph (without dummy nodes) is smaller than the value of this option. A '0' enforces the activation."), valueOf_3(40)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.type'), 'crossingMinimization.greedySwitch'), 'Greedy Switch Crossing Minimization'), "Greedy Switch strategy for crossing minimization. The greedy switch heuristic is executed after the regular crossing minimization as a post-processor. Note that if 'hierarchyHandling' is set to 'INCLUDE_CHILDREN', the 'greedySwitchHierarchical.type' option must be used."), CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_GreedySwitchType_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.type', 'org.eclipse.elk.layered.crossingMinimization.strategy', CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEP_CROSSING_MINIMIZATION_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type'), 'crossingMinimization.greedySwitchHierarchical'), 'Greedy Switch Crossing Minimization (hierarchical)'), "Activates the greedy switch heuristic in case hierarchical layout is used. The differences to the non-hierarchical case (see 'greedySwitch.type') are: 1) greedy switch is inactive by default, 3) only the option value set on the node at which hierarchical layout starts is relevant, and 2) if it's activated by the user, it properly addresses hierarchy-crossing edges."), CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_GreedySwitchType_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type', 'org.eclipse.elk.layered.crossingMinimization.strategy', CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEP_CROSSING_MINIMIZATION_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type', 'org.eclipse.elk.hierarchyHandling', CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEP_HIERARCHY_HANDLING_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.strategy'), 'nodePlacement'), 'Node Placement Strategy'), 'Strategy for node placement.'), NODE_PLACEMENT_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_NodePlacementStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.favorStraightEdges'), 'nodePlacement'), 'Favor Straight Edges Over Balancing'), "Favor straight edges over a balanced node placement. The default behavior is determined automatically based on the used 'edgeRouting'. For an orthogonal style it is set to true, for all other styles to false."), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.favorStraightEdges', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_DEP_NODE_PLACEMENT_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.favorStraightEdges', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_DEP_NODE_PLACEMENT_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening'), 'nodePlacement.bk'), 'BK Edge Straightening'), "Specifies whether the Brandes Koepf node placer tries to increase the number of straight edges at the expense of diagram size. There is a subtle difference to the 'favorStraightEdges' option, which decides whether a balanced placement of the nodes is desired, or not. In bk terms this means combining the four alignments into a single balanced one, or not. This option on the other hand tries to straighten additional edges during the creation of each of the four alignments."), NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_EdgeStraighteningStrategy_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEP_NODE_PLACEMENT_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment'), 'nodePlacement.bk'), 'BK Fixed Alignment'), 'Tells the BK node placer to use a certain alignment (out of its four) instead of the one producing the smallest height, or the combination of all four.'), NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_FixedAlignment_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEP_NODE_PLACEMENT_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening'), 'nodePlacement.linearSegments'), 'Linear Segments Deflection Dampening'), 'Dampens the movement of nodes to keep the diagram from getting too large.'), 0.3), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_DEP_NODE_PLACEMENT_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility'), 'nodePlacement.networkSimplex'), 'Node Flexibility'), "Aims at shorter and straighter edges. Two configurations are possible: (a) allow ports to move freely on the side they are assigned to (the order is always defined beforehand), (b) additionally allow to enlarge a node wherever it helps. If this option is not configured for a node, the 'nodeFlexibility.default' value is used, which is specified for the node's parent."), ENUM), Lorg_eclipse_elk_alg_layered_options_NodeFlexibility_2_classLit), of_1(NODES))));
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEP_NODE_PLACEMENT_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default'), 'nodePlacement.networkSimplex.nodeFlexibility'), 'Node Flexibility Default'), "Default value of the 'nodeFlexibility' option for the children of a hierarchical node."), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_NodeFlexibility_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default', 'org.eclipse.elk.layered.nodePlacement.strategy', NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEP_NODE_PLACEMENT_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeRouting.selfLoopDistribution'), 'edgeRouting'), 'Self-Loop Distribution'), 'Alter the distribution of the loops around the node. It only takes effect for PortConstraints.FREE.'), EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_SelfLoopDistributionStrategy_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeRouting.selfLoopOrdering'), 'edgeRouting'), 'Self-Loop Ordering'), 'Alter the ordering of the loops they can either be stacked or sequenced. It only takes effect for PortConstraints.FREE.'), EDGE_ROUTING_SELF_LOOP_ORDERING_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_SelfLoopOrderingStrategy_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeRouting.splines.mode'), 'edgeRouting.splines'), 'Spline Routing Mode'), 'Specifies the way control points are assembled for each individual edge. CONSERVATIVE ensures that edges are properly routed around the nodes but feels rather orthogonal at times. SLOPPY uses fewer control points to obtain curvier edge routes but may result in edges overlapping nodes.'), EDGE_ROUTING_SPLINES_MODE_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_SplineRoutingMode_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.edgeRouting.splines.mode', 'org.eclipse.elk.edgeRouting', EDGE_ROUTING_SPLINES_MODE_DEP_EDGE_ROUTING_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor'), 'edgeRouting.splines.sloppy'), 'Sloppy Spline Layer Spacing Factor'), 'Spacing factor for routing area between layers when using sloppy spline routing.'), 0.2), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor', 'org.eclipse.elk.edgeRouting', EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_DEP_EDGE_ROUTING_0);
    $addDependency(registry, 'org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor', 'org.eclipse.elk.layered.edgeRouting.splines.mode', EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_DEP_EDGE_ROUTING_SPLINES_MODE_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth'), 'edgeRouting.polyline'), 'Sloped Edge Zone Width'), 'Width of the strip to the left and to the right of each layer where the polyline edge router is allowed to refrain from ensuring that edges are routed horizontally. This prevents awkward bend points for nodes that extent almost to the edge of their layer.'), 2), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth', 'org.eclipse.elk.edgeRouting', EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_DEP_EDGE_ROUTING_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.spacing.baseValue'), 'spacing'), 'Spacing Base Value'), "An optional base value for all other layout options of the 'spacing' group. It can be used to conveniently alter the overall 'spaciousness' of the drawing. Whenever an explicit value is set for the other layout options, this base value will have no effect. The base value is not inherited, i.e. it must be set for each hierarchical node."), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.spacing.edgeNodeBetweenLayers'), 'spacing'), 'Edge Node Between Layers Spacing'), "The spacing to be preserved between nodes and edges that are routed next to the node's layer. For the spacing between nodes and edges that cross the node's layer 'spacing.edgeNode' is used."), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.spacing.edgeEdgeBetweenLayers'), 'spacing'), 'Edge Edge Between Layer Spacing'), "Spacing to be preserved between pairs of edges that are routed between the same pair of layers. Note that 'spacing.edgeEdge' is used for the spacing between pairs of edges crossing the same layer."), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers'), 'spacing'), 'Node Node Between Layers Spacing'), "The spacing to be preserved between any pair of nodes of two adjacent layers. Note that 'spacing.nodeNode' is used for the spacing between nodes within the layer itself."), 20), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.priority.direction'), 'priority'), 'Direction Priority'), 'Defines how important it is to have a certain edge point into the direction of the overall layout. This option is evaluated during the cycle breaking phase.'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.priority.shortness'), 'priority'), 'Shortness Priority'), 'Defines how important it is to keep an edge as short as possible. This option is evaluated during the layering phase.'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.priority.straightness'), 'priority'), 'Straightness Priority'), 'Defines how important it is to keep an edge straight, i.e. aligned with one of the two axes. This option is evaluated during node placement.'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.compaction.connectedComponents'), 'compaction'), 'Connected Components Compaction'), 'Tries to further compact components (disconnected sub-graphs).'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.compaction.connectedComponents', 'org.eclipse.elk.separateConnectedComponents', true);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.compaction.postCompaction.strategy'), 'compaction.postCompaction'), 'Post Compaction Strategy'), 'Specifies whether and how post-process compaction is applied.'), COMPACTION_POST_COMPACTION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_GraphCompactionStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.compaction.postCompaction.constraints'), 'compaction.postCompaction'), 'Post Compaction Constraint Calculation'), 'Specifies whether and how post-process compaction is applied.'), COMPACTION_POST_COMPACTION_CONSTRAINTS_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_ConstraintCalculationStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.highDegreeNodes.treatment'), 'highDegreeNodes'), 'High Degree Node Treatment'), 'Makes room around high degree nodes to place leafs and trees.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.highDegreeNodes.threshold'), 'highDegreeNodes'), 'High Degree Node Threshold'), 'Whether a node is considered to have a high degree.'), valueOf_3(16)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.highDegreeNodes.threshold', 'org.eclipse.elk.layered.highDegreeNodes.treatment', true);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.highDegreeNodes.treeHeight'), 'highDegreeNodes'), 'High Degree Node Maximum Tree Height'), 'Maximum height of a subtree connected to a high degree node to be moved to separate layers.'), valueOf_3(5)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.highDegreeNodes.treeHeight', 'org.eclipse.elk.layered.highDegreeNodes.treatment', true);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.strategy'), 'wrapping'), 'Graph Wrapping Strategy'), "For certain graphs and certain prescribed drawing areas it may be desirable to split the laid out graph into chunks that are placed side by side. The edges that connect different chunks are 'wrapped' around from the end of one chunk to the start of the other chunk. The points between the chunks are referred to as 'cuts'."), WRAPPING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_WrappingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.additionalEdgeSpacing'), 'wrapping'), 'Additional Wrapped Edges Spacing'), 'To visually separate edges that are wrapped from regularly routed edges an additional spacing value can be specified in form of this layout option. The spacing is added to the regular edgeNode spacing.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.additionalEdgeSpacing', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_ADDITIONAL_EDGE_SPACING_DEP_WRAPPING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.additionalEdgeSpacing', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_ADDITIONAL_EDGE_SPACING_DEP_WRAPPING_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.correctionFactor'), 'wrapping'), 'Correction Factor for Wrapping'), "At times and for certain types of graphs the executed wrapping may produce results that are consistently biased in the same fashion: either wrapping to often or to rarely. This factor can be used to correct the bias. Internally, it is simply multiplied with the 'aspect ratio' layout option."), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.correctionFactor', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_CORRECTION_FACTOR_DEP_WRAPPING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.correctionFactor', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_CORRECTION_FACTOR_DEP_WRAPPING_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.cutting.strategy'), 'wrapping.cutting'), 'Cutting Strategy'), 'The strategy by which the layer indexes are determined at which the layering crumbles into chunks.'), WRAPPING_CUTTING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_CuttingStrategy_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.cutting.strategy', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_CUTTING_STRATEGY_DEP_WRAPPING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.cutting.strategy', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_CUTTING_STRATEGY_DEP_WRAPPING_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.cutting.cuts'), 'wrapping.cutting'), 'Manually Specified Cuts'), 'Allows the user to specify her own cuts for a certain graph.'), OBJECT), Ljava_util_List_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.cutting.cuts', 'org.eclipse.elk.layered.wrapping.cutting.strategy', WRAPPING_CUTTING_CUTS_DEP_WRAPPING_CUTTING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.cutting.msd.freedom'), 'wrapping.cutting.msd'), 'MSD Freedom'), 'The MSD cutting strategy starts with an initial guess on the number of chunks the graph should be split into. The freedom specifies how much the strategy may deviate from this guess. E.g. if an initial number of 3 is computed, a freedom of 1 allows 2, 3, and 4 cuts.'), WRAPPING_CUTTING_MSD_FREEDOM_DEFAULT), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.cutting.msd.freedom', 'org.eclipse.elk.layered.wrapping.cutting.strategy', WRAPPING_CUTTING_MSD_FREEDOM_DEP_WRAPPING_CUTTING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.validify.strategy'), 'wrapping.validify'), 'Validification Strategy'), 'When wrapping graphs, one can specify indices that are not allowed as split points. The validification strategy makes sure every computed split point is allowed.'), WRAPPING_VALIDIFY_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_ValidifyStrategy_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.validify.strategy', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_VALIDIFY_STRATEGY_DEP_WRAPPING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.validify.strategy', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_VALIDIFY_STRATEGY_DEP_WRAPPING_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.validify.forbiddenIndices'), 'wrapping.validify'), 'Valid Indices for Wrapping'), null), OBJECT), Ljava_util_List_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.validify.forbiddenIndices', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_VALIDIFY_FORBIDDEN_INDICES_DEP_WRAPPING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.validify.forbiddenIndices', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_VALIDIFY_FORBIDDEN_INDICES_DEP_WRAPPING_STRATEGY_1);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.multiEdge.improveCuts'), 'wrapping.multiEdge'), 'Improve Cuts'), 'For general graphs it is important that not too many edges wrap backwards. Thus a compromise between evenly-distributed cuts and the total number of cut edges is sought.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.multiEdge.improveCuts', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_MULTI_EDGE_IMPROVE_CUTS_DEP_WRAPPING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty'), 'wrapping.multiEdge'), 'Distance Penalty When Improving Cuts'), null), 2), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_DEP_WRAPPING_STRATEGY_0);
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty', 'org.eclipse.elk.layered.wrapping.multiEdge.improveCuts', true);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges'), 'wrapping.multiEdge'), 'Improve Wrapped Edges'), 'The initial wrapping is performed in a very simple way. As a consequence, edges that wrap from one chunk to another may be unnecessarily long. Activating this option tries to shorten such edges.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges', 'org.eclipse.elk.layered.wrapping.strategy', WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_DEP_WRAPPING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layerUnzipping.strategy'), 'layerUnzipping'), 'Layer Unzipping Strategy'), "The strategy to use for unzipping a layer into multiple sublayers while maintaining the existing ordering of nodes and edges after crossing minimization. The default value is 'NONE'."), LAYER_UNZIPPING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_LayerUnzippingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layerUnzipping.layerSplit'), 'layerUnzipping'), 'Unzipping Layer Split'), 'Defines the number of sublayers to split a layer into. The property can be set to the nodes in a layer, which then applies the property for the layer. If multiple nodes set the value to different values, then the lowest value is chosen.'), LAYER_UNZIPPING_LAYER_SPLIT_DEFAULT), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.layerUnzipping.resetOnLongEdges'), 'layerUnzipping'), 'Reset Alternation on Long Edges'), 'If set to true, nodes will always be placed in the first sublayer after a long edge when using the ALTERNATING strategy. Otherwise long edge dummies are treated the same as regular nodes. The default value is true. The property can be set to the nodes in a layer, which then applies the property for the layer. If any node sets the value to false, then the value is set to false for the entire layer.'), LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEFAULT), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $addDependency(registry, 'org.eclipse.elk.layered.layerUnzipping.resetOnLongEdges', 'org.eclipse.elk.layered.layerUnzipping.strategy', LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEP_LAYER_UNZIPPING_STRATEGY_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeLabels.sideSelection'), 'edgeLabels'), 'Edge Label Side Selection'), 'Method to decide on edge label sides.'), EDGE_LABELS_SIDE_SELECTION_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_EdgeLabelSideSelection_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy'), 'edgeLabels'), 'Edge Center Label Placement Strategy'), 'Determines in which layer center labels of long edges should be placed.'), EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_CenterEdgeLabelPlacementStrategy_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        LABELS
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.strategy'), 'considerModelOrder'), 'Consider Model Order'), 'Preserves the order of nodes and edges in the model file if this does not lead to additional edge crossings. Depending on the strategy this is not always possible since the node and edge order might be conflicting.'), CONSIDER_MODEL_ORDER_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_OrderingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.portModelOrder'), 'considerModelOrder'), 'Consider Port Order'), 'If disabled the port order of output ports is derived from the edge order and input ports are ordered by their incoming connections. If enabled all ports are ordered by the port model order.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.noModelOrder'), 'considerModelOrder'), 'No Model Order'), 'Set on a node to not set a model order for this node even though it is a real node.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.components'), 'considerModelOrder'), 'Consider Model Order for Components'), 'If set to NONE the usual ordering strategy (by cumulative node priority and size of nodes) is used. INSIDE_PORT_SIDES orders the components with external ports only inside the groups with the same port side. FORCE_MODEL_ORDER enforces the mode order on components. This option might produce bad alignments and sub optimal drawings in terms of used area since the ordering should be respected.'), CONSIDER_MODEL_ORDER_COMPONENTS_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_components_ComponentOrderingStrategy_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.considerModelOrder.components', 'org.eclipse.elk.separateConnectedComponents', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.longEdgeStrategy'), 'considerModelOrder'), 'Long Edge Ordering Strategy'), 'Indicates whether long edges are sorted under, over, or equal to nodes that have no connection to a previous layer in a left-to-right or right-to-left layout. Under and over changes to right and left in a vertical layout.'), CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_layered_options_LongEdgeOrderingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence'), 'considerModelOrder'), 'Crossing Counter Node Order Influence'), 'Indicates with what percentage (1 for 100%) violations of the node model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal node order. Defaults to no influence (0).'), 0), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence', 'org.eclipse.elk.layered.considerModelOrder.strategy', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence'), 'considerModelOrder'), 'Crossing Counter Port Order Influence'), 'Indicates with what percentage (1 for 100%) violations of the port model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal port order. Defaults to no influence (0).'), 0), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence', 'org.eclipse.elk.layered.considerModelOrder.strategy', null);
    $apply_6((new LayeredOptions, registry));
};
var ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES, COMPACTION_CONNECTED_COMPONENTS, COMPACTION_POST_COMPACTION_CONSTRAINTS, COMPACTION_POST_COMPACTION_CONSTRAINTS_DEFAULT, COMPACTION_POST_COMPACTION_STRATEGY, COMPACTION_POST_COMPACTION_STRATEGY_DEFAULT, CONSIDER_MODEL_ORDER_COMPONENTS, CONSIDER_MODEL_ORDER_COMPONENTS_DEFAULT, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE, CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY, CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_DEFAULT, CONSIDER_MODEL_ORDER_NO_MODEL_ORDER, CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER, CONSIDER_MODEL_ORDER_STRATEGY, CONSIDER_MODEL_ORDER_STRATEGY_DEFAULT, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER, CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEFAULT, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEP_CROSSING_MINIMIZATION_STRATEGY_0, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_DEP_HIERARCHY_HANDLING_1, CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE, CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEFAULT, CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_DEP_CROSSING_MINIMIZATION_STRATEGY_0, CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS, CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_DEP_HIERARCHY_HANDLING_0, CROSSING_MINIMIZATION_IN_LAYER_PRED_OF, CROSSING_MINIMIZATION_IN_LAYER_SUCC_OF, CROSSING_MINIMIZATION_POSITION_CHOICE_CONSTRAINT, CROSSING_MINIMIZATION_POSITION_ID, CROSSING_MINIMIZATION_SEMI_INTERACTIVE, CROSSING_MINIMIZATION_SEMI_INTERACTIVE_DEP_CROSSING_MINIMIZATION_STRATEGY_0, CROSSING_MINIMIZATION_STRATEGY, CROSSING_MINIMIZATION_STRATEGY_DEFAULT, CYCLE_BREAKING_STRATEGY, CYCLE_BREAKING_STRATEGY_DEFAULT, DIRECTION_CONGRUENCY, DIRECTION_CONGRUENCY_DEFAULT, EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY, EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_DEFAULT, EDGE_LABELS_SIDE_SELECTION, EDGE_LABELS_SIDE_SELECTION_DEFAULT, EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH, EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_DEP_EDGE_ROUTING_0, EDGE_ROUTING_SELF_LOOP_DISTRIBUTION, EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_DEFAULT, EDGE_ROUTING_SELF_LOOP_ORDERING, EDGE_ROUTING_SELF_LOOP_ORDERING_DEFAULT, EDGE_ROUTING_SPLINES_MODE, EDGE_ROUTING_SPLINES_MODE_DEFAULT, EDGE_ROUTING_SPLINES_MODE_DEP_EDGE_ROUTING_0, EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR, EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_DEP_EDGE_ROUTING_0, EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_DEP_EDGE_ROUTING_SPLINES_MODE_1, FEEDBACK_EDGES, GENERATE_POSITION_AND_LAYER_IDS, HIGH_DEGREE_NODES_THRESHOLD, HIGH_DEGREE_NODES_TREATMENT, HIGH_DEGREE_NODES_TREE_HEIGHT, INTERACTIVE_REFERENCE_POINT, INTERACTIVE_REFERENCE_POINT_DEFAULT, INTERACTIVE_REFERENCE_POINT_DEP_CROSSING_MINIMIZATION_STRATEGY_1, INTERACTIVE_REFERENCE_POINT_DEP_CYCLE_BREAKING_STRATEGY_0, LAYERING_COFFMAN_GRAHAM_LAYER_BOUND, LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_DEP_LAYERING_STRATEGY_0, LAYERING_LAYER_CHOICE_CONSTRAINT, LAYERING_LAYER_CONSTRAINT, LAYERING_LAYER_CONSTRAINT_DEFAULT, LAYERING_LAYER_ID, LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH, LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_DEP_LAYERING_STRATEGY_0, LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR, LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_DEP_LAYERING_STRATEGY_0, LAYERING_NODE_PROMOTION_MAX_ITERATIONS, LAYERING_NODE_PROMOTION_STRATEGY, LAYERING_NODE_PROMOTION_STRATEGY_DEFAULT, LAYERING_STRATEGY, LAYERING_STRATEGY_DEFAULT, LAYER_UNZIPPING_LAYER_SPLIT, LAYER_UNZIPPING_LAYER_SPLIT_DEFAULT, LAYER_UNZIPPING_RESET_ON_LONG_EDGES, LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEFAULT, LAYER_UNZIPPING_RESET_ON_LONG_EDGES_DEP_LAYER_UNZIPPING_STRATEGY_0, LAYER_UNZIPPING_STRATEGY, LAYER_UNZIPPING_STRATEGY_DEFAULT, MERGE_EDGES, MERGE_HIERARCHY_EDGES, NODE_PLACEMENT_BK_EDGE_STRAIGHTENING, NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEFAULT, NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_DEP_NODE_PLACEMENT_STRATEGY_0, NODE_PLACEMENT_BK_FIXED_ALIGNMENT, NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEFAULT, NODE_PLACEMENT_BK_FIXED_ALIGNMENT_DEP_NODE_PLACEMENT_STRATEGY_0, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_DEP_NODE_PLACEMENT_STRATEGY_0, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_DEP_NODE_PLACEMENT_STRATEGY_1, NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING, NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_DEP_NODE_PLACEMENT_STRATEGY_0, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEFAULT, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_DEP_NODE_PLACEMENT_STRATEGY_0, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEP_NODE_PLACEMENT_STRATEGY_0, NODE_PLACEMENT_STRATEGY, NODE_PLACEMENT_STRATEGY_DEFAULT, PORT_SORTING_STRATEGY, PORT_SORTING_STRATEGY_DEFAULT, PRIORITY_DIRECTION, PRIORITY_SHORTNESS, PRIORITY_STRAIGHTNESS, SPACING_BASE_VALUE, SPACING_EDGE_EDGE_BETWEEN_LAYERS, SPACING_EDGE_NODE_BETWEEN_LAYERS, SPACING_NODE_NODE_BETWEEN_LAYERS, THOROUGHNESS, UNNECESSARY_BENDPOINTS, WRAPPING_ADDITIONAL_EDGE_SPACING, WRAPPING_ADDITIONAL_EDGE_SPACING_DEP_WRAPPING_STRATEGY_0, WRAPPING_ADDITIONAL_EDGE_SPACING_DEP_WRAPPING_STRATEGY_1, WRAPPING_CORRECTION_FACTOR, WRAPPING_CORRECTION_FACTOR_DEP_WRAPPING_STRATEGY_0, WRAPPING_CORRECTION_FACTOR_DEP_WRAPPING_STRATEGY_1, WRAPPING_CUTTING_CUTS, WRAPPING_CUTTING_CUTS_DEP_WRAPPING_CUTTING_STRATEGY_0, WRAPPING_CUTTING_MSD_FREEDOM, WRAPPING_CUTTING_MSD_FREEDOM_DEFAULT, WRAPPING_CUTTING_MSD_FREEDOM_DEP_WRAPPING_CUTTING_STRATEGY_0, WRAPPING_CUTTING_STRATEGY, WRAPPING_CUTTING_STRATEGY_DEFAULT, WRAPPING_CUTTING_STRATEGY_DEP_WRAPPING_STRATEGY_0, WRAPPING_CUTTING_STRATEGY_DEP_WRAPPING_STRATEGY_1, WRAPPING_MULTI_EDGE_DISTANCE_PENALTY, WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_DEP_WRAPPING_STRATEGY_0, WRAPPING_MULTI_EDGE_IMPROVE_CUTS, WRAPPING_MULTI_EDGE_IMPROVE_CUTS_DEP_WRAPPING_STRATEGY_0, WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES, WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_DEP_WRAPPING_STRATEGY_0, WRAPPING_STRATEGY, WRAPPING_STRATEGY_DEFAULT, WRAPPING_VALIDIFY_FORBIDDEN_INDICES, WRAPPING_VALIDIFY_FORBIDDEN_INDICES_DEP_WRAPPING_STRATEGY_0, WRAPPING_VALIDIFY_FORBIDDEN_INDICES_DEP_WRAPPING_STRATEGY_1, WRAPPING_VALIDIFY_STRATEGY, WRAPPING_VALIDIFY_STRATEGY_DEFAULT, WRAPPING_VALIDIFY_STRATEGY_DEP_WRAPPING_STRATEGY_0, WRAPPING_VALIDIFY_STRATEGY_DEP_WRAPPING_STRATEGY_1;
var Lorg_eclipse_elk_alg_layered_options_LayeredMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.layered.options', 'LayeredMetaDataProvider', 838);
function $clinit_LayeredOptions() {
    $clinit_LayeredOptions = emptyMethod;
    SPACING_COMMENT_COMMENT = ($clinit_CoreOptions(), SPACING_COMMENT_COMMENT_0);
    SPACING_COMMENT_NODE = SPACING_COMMENT_NODE_0;
    SPACING_COMPONENT_COMPONENT = SPACING_COMPONENT_COMPONENT_0;
    SPACING_EDGE_EDGE = SPACING_EDGE_EDGE_0;
    SPACING_EDGE_LABEL_0 = SPACING_EDGE_LABEL_1;
    SPACING_EDGE_NODE = SPACING_EDGE_NODE_1;
    SPACING_LABEL_LABEL = SPACING_LABEL_LABEL_0;
    SPACING_LABEL_PORT_HORIZONTAL = SPACING_LABEL_PORT_HORIZONTAL_0;
    SPACING_LABEL_PORT_VERTICAL = SPACING_LABEL_PORT_VERTICAL_0;
    SPACING_LABEL_NODE = SPACING_LABEL_NODE_0;
    SPACING_NODE_NODE_0 = SPACING_NODE_NODE_6;
    SPACING_NODE_SELF_LOOP = SPACING_NODE_SELF_LOOP_0;
    SPACING_PORT_PORT = SPACING_PORT_PORT_0;
    SPACING_INDIVIDUAL = SPACING_INDIVIDUAL_0;
    SPACING_BASE_VALUE_0 = ($clinit_LayeredMetaDataProvider(), SPACING_BASE_VALUE);
    SPACING_EDGE_EDGE_BETWEEN_LAYERS_0 = SPACING_EDGE_EDGE_BETWEEN_LAYERS;
    SPACING_EDGE_NODE_BETWEEN_LAYERS_0 = SPACING_EDGE_NODE_BETWEEN_LAYERS;
    SPACING_NODE_NODE_BETWEEN_LAYERS_0 = SPACING_NODE_NODE_BETWEEN_LAYERS;
    PRIORITY_0 = new Property_2(PRIORITY_3, valueOf_3(0));
    PRIORITY_DIRECTION_0 = PRIORITY_DIRECTION;
    PRIORITY_SHORTNESS_0 = PRIORITY_SHORTNESS;
    PRIORITY_STRAIGHTNESS_0 = PRIORITY_STRAIGHTNESS;
    WRAPPING_STRATEGY_0 = WRAPPING_STRATEGY;
    WRAPPING_ADDITIONAL_EDGE_SPACING_0 = WRAPPING_ADDITIONAL_EDGE_SPACING;
    WRAPPING_CORRECTION_FACTOR_0 = WRAPPING_CORRECTION_FACTOR;
    WRAPPING_CUTTING_STRATEGY_0 = WRAPPING_CUTTING_STRATEGY;
    WRAPPING_CUTTING_CUTS_0 = WRAPPING_CUTTING_CUTS;
    WRAPPING_CUTTING_MSD_FREEDOM_0 = WRAPPING_CUTTING_MSD_FREEDOM;
    WRAPPING_VALIDIFY_STRATEGY_0 = WRAPPING_VALIDIFY_STRATEGY;
    WRAPPING_VALIDIFY_FORBIDDEN_INDICES_0 = WRAPPING_VALIDIFY_FORBIDDEN_INDICES;
    WRAPPING_MULTI_EDGE_IMPROVE_CUTS_0 = WRAPPING_MULTI_EDGE_IMPROVE_CUTS;
    WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_0 = WRAPPING_MULTI_EDGE_DISTANCE_PENALTY;
    WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_0 = WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES;
    LAYER_UNZIPPING_STRATEGY_0 = LAYER_UNZIPPING_STRATEGY;
    LAYER_UNZIPPING_LAYER_SPLIT_0 = LAYER_UNZIPPING_LAYER_SPLIT;
    LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0 = LAYER_UNZIPPING_RESET_ON_LONG_EDGES;
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0 = NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY;
    NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0 = NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT;
    EDGE_ROUTING_SPLINES_MODE_0 = EDGE_ROUTING_SPLINES_MODE;
    EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_0 = EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR;
    TOPDOWN_LAYOUT_0 = TOPDOWN_LAYOUT_2;
    TOPDOWN_SCALE_FACTOR_0 = TOPDOWN_SCALE_FACTOR_2;
    TOPDOWN_HIERARCHICAL_NODE_WIDTH_0 = TOPDOWN_HIERARCHICAL_NODE_WIDTH_2;
    TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_0 = TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2;
    TOPDOWN_NODE_TYPE_DEFAULT_0 = ($clinit_TopdownNodeTypes(), HIERARCHICAL_NODE);
    new Property_2(TOPDOWN_NODE_TYPE, TOPDOWN_NODE_TYPE_DEFAULT_0);
    PADDING_DEFAULT_0 = new ElkPadding_0(12);
    PADDING_0 = new Property_2(PADDING_5, PADDING_DEFAULT_0);
    EDGE_ROUTING_DEFAULT = ($clinit_EdgeRouting(), ORTHOGONAL);
    EDGE_ROUTING = new Property_2(EDGE_ROUTING_0, EDGE_ROUTING_DEFAULT);
    PORT_BORDER_OFFSET = new Property_2(PORT_BORDER_OFFSET_0, 0);
    RANDOM_SEED_0 = new Property_2(RANDOM_SEED_1, valueOf_3(1));
    ASPECT_RATIO_0 = new Property_2(ASPECT_RATIO_4, $intern_99);
    NO_LAYOUT = NO_LAYOUT_0;
    PORT_CONSTRAINTS_0 = PORT_CONSTRAINTS_1;
    PORT_SIDE = PORT_SIDE_0;
    DEBUG_MODE = DEBUG_MODE_3;
    ALIGNMENT = ALIGNMENT_0;
    HIERARCHY_HANDLING = HIERARCHY_HANDLING_0;
    SEPARATE_CONNECTED_COMPONENTS_0 = new Property_2(SEPARATE_CONNECTED_COMPONENTS_2, ($clinit_Boolean(), true));
    INSIDE_SELF_LOOPS_ACTIVATE = INSIDE_SELF_LOOPS_ACTIVATE_0;
    INSIDE_SELF_LOOPS_YO = INSIDE_SELF_LOOPS_YO_0;
    NODE_SIZE_CONSTRAINTS_1 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_OPTIONS_1 = NODE_SIZE_OPTIONS_6;
    NODE_SIZE_FIXED_GRAPH_SIZE_0 = NODE_SIZE_FIXED_GRAPH_SIZE_3;
    DIRECTION_DEFAULT = ($clinit_Direction(), UNDEFINED_2);
    DIRECTION = new Property_2(DIRECTION_1, DIRECTION_DEFAULT);
    NODE_LABELS_PLACEMENT_1 = NODE_LABELS_PLACEMENT_5;
    NODE_LABELS_PADDING = NODE_LABELS_PADDING_0;
    PORT_LABELS_PLACEMENT_1 = PORT_LABELS_PLACEMENT_5;
    PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE = PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE_0;
    PORT_LABELS_TREAT_AS_GROUP = PORT_LABELS_TREAT_AS_GROUP_0;
    PORT_ALIGNMENT_DEFAULT_DEFAULT = ($clinit_PortAlignment(), JUSTIFIED);
    new Property_2(PORT_ALIGNMENT_DEFAULT, PORT_ALIGNMENT_DEFAULT_DEFAULT);
    PORT_ALIGNMENT_NORTH = PORT_ALIGNMENT_NORTH_0;
    PORT_ALIGNMENT_SOUTH = PORT_ALIGNMENT_SOUTH_0;
    PORT_ALIGNMENT_WEST = PORT_ALIGNMENT_WEST_0;
    PORT_ALIGNMENT_EAST = PORT_ALIGNMENT_EAST_0;
    UNNECESSARY_BENDPOINTS_0 = UNNECESSARY_BENDPOINTS;
    LAYERING_STRATEGY_0 = LAYERING_STRATEGY;
    LAYERING_NODE_PROMOTION_STRATEGY_0 = LAYERING_NODE_PROMOTION_STRATEGY;
    THOROUGHNESS_0 = THOROUGHNESS;
    LAYERING_LAYER_CONSTRAINT_0 = LAYERING_LAYER_CONSTRAINT;
    CYCLE_BREAKING_STRATEGY_0 = CYCLE_BREAKING_STRATEGY;
    CROSSING_MINIMIZATION_STRATEGY_0 = CROSSING_MINIMIZATION_STRATEGY;
    CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0 = CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD_0 = CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_0 = CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE;
    CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0 = CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE;
    CROSSING_MINIMIZATION_SEMI_INTERACTIVE_0 = CROSSING_MINIMIZATION_SEMI_INTERACTIVE;
    MERGE_EDGES_0 = MERGE_EDGES;
    MERGE_HIERARCHY_EDGES_0 = MERGE_HIERARCHY_EDGES;
    INTERACTIVE_REFERENCE_POINT_0 = INTERACTIVE_REFERENCE_POINT;
    NODE_PLACEMENT_STRATEGY_0 = NODE_PLACEMENT_STRATEGY;
    NODE_PLACEMENT_BK_FIXED_ALIGNMENT_0 = NODE_PLACEMENT_BK_FIXED_ALIGNMENT;
    FEEDBACK_EDGES_0 = FEEDBACK_EDGES;
    NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_0 = NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING;
    EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_0 = EDGE_ROUTING_SELF_LOOP_DISTRIBUTION;
    EDGE_ROUTING_SELF_LOOP_ORDERING_0 = EDGE_ROUTING_SELF_LOOP_ORDERING;
    CONTENT_ALIGNMENT = CONTENT_ALIGNMENT_2;
    NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_0 = NODE_PLACEMENT_BK_EDGE_STRAIGHTENING;
    COMPACTION_POST_COMPACTION_STRATEGY_0 = COMPACTION_POST_COMPACTION_STRATEGY;
    COMPACTION_POST_COMPACTION_CONSTRAINTS_0 = COMPACTION_POST_COMPACTION_CONSTRAINTS;
    COMPACTION_CONNECTED_COMPONENTS_0 = COMPACTION_CONNECTED_COMPONENTS;
    HIGH_DEGREE_NODES_TREATMENT_0 = HIGH_DEGREE_NODES_TREATMENT;
    HIGH_DEGREE_NODES_THRESHOLD_0 = HIGH_DEGREE_NODES_THRESHOLD;
    HIGH_DEGREE_NODES_TREE_HEIGHT_0 = HIGH_DEGREE_NODES_TREE_HEIGHT;
    NODE_SIZE_MINIMUM_0 = NODE_SIZE_MINIMUM_5;
    JUNCTION_POINTS = JUNCTION_POINTS_0;
    EDGE_THICKNESS = EDGE_THICKNESS_0;
    EDGE_LABELS_PLACEMENT = EDGE_LABELS_PLACEMENT_0;
    EDGE_LABELS_INLINE_0 = EDGE_LABELS_INLINE_1;
    CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_0 = CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS;
    PORT_INDEX = PORT_INDEX_0;
    COMMENT_BOX = COMMENT_BOX_0;
    HYPERNODE = HYPERNODE_0;
    PORT_ANCHOR = PORT_ANCHOR_0;
    PARTITIONING_ACTIVATE = PARTITIONING_ACTIVATE_0;
    PARTITIONING_PARTITION = PARTITIONING_PARTITION_0;
    LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_0 = LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH;
    LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_0 = LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR;
    POSITION = POSITION_2;
    ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES_0 = ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES;
    LAYERING_NODE_PROMOTION_MAX_ITERATIONS_0 = LAYERING_NODE_PROMOTION_MAX_ITERATIONS;
    EDGE_LABELS_SIDE_SELECTION_0 = EDGE_LABELS_SIDE_SELECTION;
    EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_0 = EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY;
    MARGINS = MARGINS_0;
    LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_0 = LAYERING_COFFMAN_GRAHAM_LAYER_BOUND;
    NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0 = NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES;
    SPACING_PORTS_SURROUNDING = SPACING_PORTS_SURROUNDING_0;
    DIRECTION_CONGRUENCY_0 = DIRECTION_CONGRUENCY;
    PORT_SORTING_STRATEGY_0 = PORT_SORTING_STRATEGY;
    EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_0 = EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH;
    CROSSING_MINIMIZATION_IN_LAYER_PRED_OF_0 = CROSSING_MINIMIZATION_IN_LAYER_PRED_OF;
    CROSSING_MINIMIZATION_IN_LAYER_SUCC_OF_0 = CROSSING_MINIMIZATION_IN_LAYER_SUCC_OF;
    LAYERING_LAYER_CHOICE_CONSTRAINT_0 = LAYERING_LAYER_CHOICE_CONSTRAINT;
    CROSSING_MINIMIZATION_POSITION_CHOICE_CONSTRAINT_0 = CROSSING_MINIMIZATION_POSITION_CHOICE_CONSTRAINT;
    INTERACTIVE_LAYOUT = INTERACTIVE_LAYOUT_2;
    LAYERING_LAYER_ID_0 = LAYERING_LAYER_ID;
    CROSSING_MINIMIZATION_POSITION_ID_0 = CROSSING_MINIMIZATION_POSITION_ID;
    CONSIDER_MODEL_ORDER_STRATEGY_0 = CONSIDER_MODEL_ORDER_STRATEGY;
    CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_0 = CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY;
    CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE_0 = CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE;
    CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE_0 = CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE;
    CONSIDER_MODEL_ORDER_NO_MODEL_ORDER_0 = CONSIDER_MODEL_ORDER_NO_MODEL_ORDER;
    CONSIDER_MODEL_ORDER_COMPONENTS_0 = CONSIDER_MODEL_ORDER_COMPONENTS;
    CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER_0 = CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER;
    GENERATE_POSITION_AND_LAYER_IDS_0 = GENERATE_POSITION_AND_LAYER_IDS;
}
function $apply_6(registry) {
    $register(registry, new LayoutAlgorithmData($supportedFeatures($category($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.layered'), 'ELK Layered'), 'Layer-based algorithm provided by the Eclipse Layout Kernel. Arranges as many edges as possible into one direction by placing nodes into subsequent layers. This implementation supports different routing styles (straight, orthogonal, splines); if orthogonal routing is selected, arbitrary port constraints are respected, thus enabling the layout of block diagrams such as actor-oriented models or circuit schematics. Furthermore, full layout of compound graphs with cross-hierarchy edges is supported when the respective option is activated on the top level.'), new LayeredOptions$LayeredFactory), 'org.eclipse.elk.layered'), of_2(($clinit_GraphFeature(), SELF_LOOPS_0), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_properties_GraphFeature_2_classLit, 1), $intern_36, 243, 0, [
        INSIDE_SELF_LOOPS,
        MULTI_EDGES,
        EDGE_LABELS,
        PORTS_1,
        COMPOUND,
        CLUSTERS
    ])))));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.commentComment', $getDefault(SPACING_COMMENT_COMMENT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.commentNode', $getDefault(SPACING_COMMENT_NODE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.componentComponent', $getDefault(SPACING_COMPONENT_COMPONENT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.edgeEdge', $getDefault(SPACING_EDGE_EDGE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.edgeLabel', $getDefault(SPACING_EDGE_LABEL_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.edgeNode', $getDefault(SPACING_EDGE_NODE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.labelLabel', $getDefault(SPACING_LABEL_LABEL));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.labelPortHorizontal', $getDefault(SPACING_LABEL_PORT_HORIZONTAL));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.labelPortVertical', $getDefault(SPACING_LABEL_PORT_VERTICAL));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.labelNode', $getDefault(SPACING_LABEL_NODE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.nodeNode', $getDefault(SPACING_NODE_NODE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.nodeSelfLoop', $getDefault(SPACING_NODE_SELF_LOOP));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.portPort', $getDefault(SPACING_PORT_PORT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.individual', $getDefault(SPACING_INDIVIDUAL));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.spacing.baseValue', $getDefault(SPACING_BASE_VALUE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.spacing.edgeEdgeBetweenLayers', $getDefault(SPACING_EDGE_EDGE_BETWEEN_LAYERS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.spacing.edgeNodeBetweenLayers', $getDefault(SPACING_EDGE_NODE_BETWEEN_LAYERS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers', $getDefault(SPACING_NODE_NODE_BETWEEN_LAYERS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.priority', valueOf_3(0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.priority.direction', $getDefault(PRIORITY_DIRECTION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.priority.shortness', $getDefault(PRIORITY_SHORTNESS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.priority.straightness', $getDefault(PRIORITY_STRAIGHTNESS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.strategy', $getDefault(WRAPPING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.additionalEdgeSpacing', $getDefault(WRAPPING_ADDITIONAL_EDGE_SPACING_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.correctionFactor', $getDefault(WRAPPING_CORRECTION_FACTOR_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.cutting.strategy', $getDefault(WRAPPING_CUTTING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.cutting.cuts', $getDefault(WRAPPING_CUTTING_CUTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.cutting.msd.freedom', $getDefault(WRAPPING_CUTTING_MSD_FREEDOM_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.validify.strategy', $getDefault(WRAPPING_VALIDIFY_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.validify.forbiddenIndices', $getDefault(WRAPPING_VALIDIFY_FORBIDDEN_INDICES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.multiEdge.improveCuts', $getDefault(WRAPPING_MULTI_EDGE_IMPROVE_CUTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty', $getDefault(WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges', $getDefault(WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layerUnzipping.strategy', $getDefault(LAYER_UNZIPPING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layerUnzipping.layerSplit', $getDefault(LAYER_UNZIPPING_LAYER_SPLIT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layerUnzipping.resetOnLongEdges', $getDefault(LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility', $getDefault(NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default', $getDefault(NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeRouting.splines.mode', $getDefault(EDGE_ROUTING_SPLINES_MODE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor', $getDefault(EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.topdownLayout', $getDefault(TOPDOWN_LAYOUT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.topdown.scaleFactor', $getDefault(TOPDOWN_SCALE_FACTOR_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.topdown.hierarchicalNodeWidth', $getDefault(TOPDOWN_HIERARCHICAL_NODE_WIDTH_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', $getDefault(TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.topdown.nodeType', TOPDOWN_NODE_TYPE_DEFAULT_0);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.padding', PADDING_DEFAULT_0);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.edgeRouting', EDGE_ROUTING_DEFAULT);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.port.borderOffset', 0);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.randomSeed', valueOf_3(1));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.aspectRatio', $intern_99);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.noLayout', $getDefault(NO_LAYOUT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portConstraints', $getDefault(PORT_CONSTRAINTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.port.side', $getDefault(PORT_SIDE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.debugMode', $getDefault(DEBUG_MODE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.alignment', $getDefault(ALIGNMENT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.hierarchyHandling', $getDefault(HIERARCHY_HANDLING));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.separateConnectedComponents', ($clinit_Boolean(), true));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.insideSelfLoops.activate', $getDefault(INSIDE_SELF_LOOPS_ACTIVATE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.insideSelfLoops.yo', $getDefault(INSIDE_SELF_LOOPS_YO));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_1));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS_1));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.nodeSize.fixedGraphSize', $getDefault(NODE_SIZE_FIXED_GRAPH_SIZE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.direction', DIRECTION_DEFAULT);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.nodeLabels.placement', $getDefault(NODE_LABELS_PLACEMENT_1));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.nodeLabels.padding', $getDefault(NODE_LABELS_PADDING));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portLabels.placement', $getDefault(PORT_LABELS_PLACEMENT_1));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portLabels.nextToPortIfPossible', $getDefault(PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portLabels.treatAsGroup', $getDefault(PORT_LABELS_TREAT_AS_GROUP));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portAlignment.default', PORT_ALIGNMENT_DEFAULT_DEFAULT);
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portAlignment.north', $getDefault(PORT_ALIGNMENT_NORTH));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portAlignment.south', $getDefault(PORT_ALIGNMENT_SOUTH));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portAlignment.west', $getDefault(PORT_ALIGNMENT_WEST));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.portAlignment.east', $getDefault(PORT_ALIGNMENT_EAST));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.unnecessaryBendpoints', $getDefault(UNNECESSARY_BENDPOINTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.strategy', $getDefault(LAYERING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.nodePromotion.strategy', $getDefault(LAYERING_NODE_PROMOTION_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.thoroughness', $getDefault(THOROUGHNESS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.layerConstraint', $getDefault(LAYERING_LAYER_CONSTRAINT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.cycleBreaking.strategy', $getDefault(CYCLE_BREAKING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.strategy', $getDefault(CROSSING_MINIMIZATION_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder', $getDefault(CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.activationThreshold', $getDefault(CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.greedySwitch.type', $getDefault(CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type', $getDefault(CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.semiInteractive', $getDefault(CROSSING_MINIMIZATION_SEMI_INTERACTIVE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.mergeEdges', $getDefault(MERGE_EDGES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.mergeHierarchyEdges', $getDefault(MERGE_HIERARCHY_EDGES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.interactiveReferencePoint', $getDefault(INTERACTIVE_REFERENCE_POINT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.strategy', $getDefault(NODE_PLACEMENT_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment', $getDefault(NODE_PLACEMENT_BK_FIXED_ALIGNMENT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.feedbackEdges', $getDefault(FEEDBACK_EDGES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening', $getDefault(NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeRouting.selfLoopDistribution', $getDefault(EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeRouting.selfLoopOrdering', $getDefault(EDGE_ROUTING_SELF_LOOP_ORDERING_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.contentAlignment', $getDefault(CONTENT_ALIGNMENT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening', $getDefault(NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.compaction.postCompaction.strategy', $getDefault(COMPACTION_POST_COMPACTION_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.compaction.postCompaction.constraints', $getDefault(COMPACTION_POST_COMPACTION_CONSTRAINTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.compaction.connectedComponents', $getDefault(COMPACTION_CONNECTED_COMPONENTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.highDegreeNodes.treatment', $getDefault(HIGH_DEGREE_NODES_TREATMENT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.highDegreeNodes.threshold', $getDefault(HIGH_DEGREE_NODES_THRESHOLD_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.highDegreeNodes.treeHeight', $getDefault(HIGH_DEGREE_NODES_TREE_HEIGHT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.junctionPoints', $getDefault(JUNCTION_POINTS));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.edge.thickness', $getDefault(EDGE_THICKNESS));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.edgeLabels.placement', $getDefault(EDGE_LABELS_PLACEMENT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.edgeLabels.inline', $getDefault(EDGE_LABELS_INLINE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness', $getDefault(CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.port.index', $getDefault(PORT_INDEX));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.commentBox', $getDefault(COMMENT_BOX));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.hypernode', $getDefault(HYPERNODE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.port.anchor', $getDefault(PORT_ANCHOR));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.partitioning.activate', $getDefault(PARTITIONING_ACTIVATE));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.partitioning.partition', $getDefault(PARTITIONING_PARTITION));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth', $getDefault(LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor', $getDefault(LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.position', $getDefault(POSITION));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.allowNonFlowPortsToSwitchSides', $getDefault(ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.nodePromotion.maxIterations', $getDefault(LAYERING_NODE_PROMOTION_MAX_ITERATIONS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeLabels.sideSelection', $getDefault(EDGE_LABELS_SIDE_SELECTION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy', $getDefault(EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.margins', $getDefault(MARGINS));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.coffmanGraham.layerBound', $getDefault(LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.nodePlacement.favorStraightEdges', $getDefault(NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.spacing.portsSurrounding', $getDefault(SPACING_PORTS_SURROUNDING));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.directionCongruency', $getDefault(DIRECTION_CONGRUENCY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.portSortingStrategy', $getDefault(PORT_SORTING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth', $getDefault(EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.inLayerPredOf', $getDefault(CROSSING_MINIMIZATION_IN_LAYER_PRED_OF_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.inLayerSuccOf', $getDefault(CROSSING_MINIMIZATION_IN_LAYER_SUCC_OF_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.layerChoiceConstraint', $getDefault(LAYERING_LAYER_CHOICE_CONSTRAINT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.positionChoiceConstraint', $getDefault(CROSSING_MINIMIZATION_POSITION_CHOICE_CONSTRAINT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.interactiveLayout', $getDefault(INTERACTIVE_LAYOUT));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.layering.layerId', $getDefault(LAYERING_LAYER_ID_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.crossingMinimization.positionId', $getDefault(CROSSING_MINIMIZATION_POSITION_ID_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.strategy', $getDefault(CONSIDER_MODEL_ORDER_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.longEdgeStrategy', $getDefault(CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence', $getDefault(CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence', $getDefault(CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.noModelOrder', $getDefault(CONSIDER_MODEL_ORDER_NO_MODEL_ORDER_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.components', $getDefault(CONSIDER_MODEL_ORDER_COMPONENTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.considerModelOrder.portModelOrder', $getDefault(CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER_0));
    $addOptionSupport(registry, 'org.eclipse.elk.layered', 'org.eclipse.elk.layered.generatePositionAndLayerIds', $getDefault(GENERATE_POSITION_AND_LAYER_IDS_0));
}
function LayeredOptions() {
    $clinit_LayeredOptions();
}
defineClass(975, 1, $intern_98, LayeredOptions);
_.apply_4 = function apply_108(registry) {
    $apply_6(registry);
};
var ALIGNMENT, ALLOW_NON_FLOW_PORTS_TO_SWITCH_SIDES_0, ASPECT_RATIO_0, COMMENT_BOX, COMPACTION_CONNECTED_COMPONENTS_0, COMPACTION_POST_COMPACTION_CONSTRAINTS_0, COMPACTION_POST_COMPACTION_STRATEGY_0, CONSIDER_MODEL_ORDER_COMPONENTS_0, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE_0, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE_0, CONSIDER_MODEL_ORDER_LONG_EDGE_STRATEGY_0, CONSIDER_MODEL_ORDER_NO_MODEL_ORDER_0, CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER_0, CONSIDER_MODEL_ORDER_STRATEGY_0, CONTENT_ALIGNMENT, CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0, CROSSING_MINIMIZATION_GREEDY_SWITCH_ACTIVATION_THRESHOLD_0, CROSSING_MINIMIZATION_GREEDY_SWITCH_HIERARCHICAL_TYPE_0, CROSSING_MINIMIZATION_GREEDY_SWITCH_TYPE_0, CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_0, CROSSING_MINIMIZATION_IN_LAYER_PRED_OF_0, CROSSING_MINIMIZATION_IN_LAYER_SUCC_OF_0, CROSSING_MINIMIZATION_POSITION_CHOICE_CONSTRAINT_0, CROSSING_MINIMIZATION_POSITION_ID_0, CROSSING_MINIMIZATION_SEMI_INTERACTIVE_0, CROSSING_MINIMIZATION_STRATEGY_0, CYCLE_BREAKING_STRATEGY_0, DEBUG_MODE, DIRECTION, DIRECTION_CONGRUENCY_0, DIRECTION_DEFAULT, EDGE_LABELS_CENTER_LABEL_PLACEMENT_STRATEGY_0, EDGE_LABELS_INLINE_0, EDGE_LABELS_PLACEMENT, EDGE_LABELS_SIDE_SELECTION_0, EDGE_ROUTING, EDGE_ROUTING_DEFAULT, EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_0, EDGE_ROUTING_SELF_LOOP_DISTRIBUTION_0, EDGE_ROUTING_SELF_LOOP_ORDERING_0, EDGE_ROUTING_SPLINES_MODE_0, EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_0, EDGE_THICKNESS, FEEDBACK_EDGES_0, GENERATE_POSITION_AND_LAYER_IDS_0, HIERARCHY_HANDLING, HIGH_DEGREE_NODES_THRESHOLD_0, HIGH_DEGREE_NODES_TREATMENT_0, HIGH_DEGREE_NODES_TREE_HEIGHT_0, HYPERNODE, INSIDE_SELF_LOOPS_ACTIVATE, INSIDE_SELF_LOOPS_YO, INTERACTIVE_LAYOUT, INTERACTIVE_REFERENCE_POINT_0, JUNCTION_POINTS, LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_0, LAYERING_LAYER_CHOICE_CONSTRAINT_0, LAYERING_LAYER_CONSTRAINT_0, LAYERING_LAYER_ID_0, LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_0, LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_0, LAYERING_NODE_PROMOTION_MAX_ITERATIONS_0, LAYERING_NODE_PROMOTION_STRATEGY_0, LAYERING_STRATEGY_0, LAYER_UNZIPPING_LAYER_SPLIT_0, LAYER_UNZIPPING_RESET_ON_LONG_EDGES_0, LAYER_UNZIPPING_STRATEGY_0, MARGINS, MERGE_EDGES_0, MERGE_HIERARCHY_EDGES_0, NODE_LABELS_PADDING, NODE_LABELS_PLACEMENT_1, NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_0, NODE_PLACEMENT_BK_FIXED_ALIGNMENT_0, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0, NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_0, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0, NODE_PLACEMENT_STRATEGY_0, NODE_SIZE_CONSTRAINTS_1, NODE_SIZE_FIXED_GRAPH_SIZE_0, NODE_SIZE_MINIMUM_0, NODE_SIZE_OPTIONS_1, NO_LAYOUT, PADDING_0, PADDING_DEFAULT_0, PARTITIONING_ACTIVATE, PARTITIONING_PARTITION, PORT_ALIGNMENT_DEFAULT_DEFAULT, PORT_ALIGNMENT_EAST, PORT_ALIGNMENT_NORTH, PORT_ALIGNMENT_SOUTH, PORT_ALIGNMENT_WEST, PORT_ANCHOR, PORT_BORDER_OFFSET, PORT_CONSTRAINTS_0, PORT_INDEX, PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE, PORT_LABELS_PLACEMENT_1, PORT_LABELS_TREAT_AS_GROUP, PORT_SIDE, PORT_SORTING_STRATEGY_0, POSITION, PRIORITY_0, PRIORITY_DIRECTION_0, PRIORITY_SHORTNESS_0, PRIORITY_STRAIGHTNESS_0, RANDOM_SEED_0, SEPARATE_CONNECTED_COMPONENTS_0, SPACING_BASE_VALUE_0, SPACING_COMMENT_COMMENT, SPACING_COMMENT_NODE, SPACING_COMPONENT_COMPONENT, SPACING_EDGE_EDGE, SPACING_EDGE_EDGE_BETWEEN_LAYERS_0, SPACING_EDGE_LABEL_0, SPACING_EDGE_NODE, SPACING_EDGE_NODE_BETWEEN_LAYERS_0, SPACING_INDIVIDUAL, SPACING_LABEL_LABEL, SPACING_LABEL_NODE, SPACING_LABEL_PORT_HORIZONTAL, SPACING_LABEL_PORT_VERTICAL, SPACING_NODE_NODE_0, SPACING_NODE_NODE_BETWEEN_LAYERS_0, SPACING_NODE_SELF_LOOP, SPACING_PORTS_SURROUNDING, SPACING_PORT_PORT, THOROUGHNESS_0, TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_0, TOPDOWN_HIERARCHICAL_NODE_WIDTH_0, TOPDOWN_LAYOUT_0, TOPDOWN_NODE_TYPE_DEFAULT_0, TOPDOWN_SCALE_FACTOR_0, UNNECESSARY_BENDPOINTS_0, WRAPPING_ADDITIONAL_EDGE_SPACING_0, WRAPPING_CORRECTION_FACTOR_0, WRAPPING_CUTTING_CUTS_0, WRAPPING_CUTTING_MSD_FREEDOM_0, WRAPPING_CUTTING_STRATEGY_0, WRAPPING_MULTI_EDGE_DISTANCE_PENALTY_0, WRAPPING_MULTI_EDGE_IMPROVE_CUTS_0, WRAPPING_MULTI_EDGE_IMPROVE_WRAPPED_EDGES_0, WRAPPING_STRATEGY_0, WRAPPING_VALIDIFY_FORBIDDEN_INDICES_0, WRAPPING_VALIDIFY_STRATEGY_0;
var Lorg_eclipse_elk_alg_layered_options_LayeredOptions_2_classLit = createForClass('org.eclipse.elk.alg.layered.options', 'LayeredOptions', 975);
function LayeredOptions$LayeredFactory() {}
defineClass(976, 1, {}, LayeredOptions$LayeredFactory);
_.create_0 = function create_9() {
    var provider;
    return provider = new LayeredLayoutProvider, provider;
};
_.destroy = function destroy_1(obj) {};
var Lorg_eclipse_elk_alg_layered_options_LayeredOptions$LayeredFactory_2_classLit = createForClass('org.eclipse.elk.alg.layered.options', 'LayeredOptions/LayeredFactory', 976);
function $clinit_ElkSpacings$AbstractSpacingsBuilder() {
    $clinit_ElkSpacings$AbstractSpacingsBuilder = emptyMethod;
    ELK_OPTION_TARGET_FILTER = new ElkSpacings$AbstractSpacingsBuilder$lambda$0$Type;
}
function $apply_7(this$static, holder) {
    $build(this$static).accept(holder);
}
function $build(this$static) {
    $add_3(this$static.filters, ($clinit_LayoutConfigurator(), NO_OVERWRITE_HOLDER));
    if (fuzzyEquals(this$static.baseSpacing, $doubleValue(castToDouble($getDefault(($clinit_LayeredSpacings$LayeredSpacingsBuilder(), BASE_SPACING_OPTION)))))) return new ElkSpacings$AbstractSpacingsBuilder$lambda$2$Type;
    return new ElkSpacings$AbstractSpacingsBuilder$lambda$3$Type(this$static);
}
function $lambda$1_2(this$static, option_0) {
    var factor;
    factor = $getDefault(($clinit_LayeredSpacings$LayeredSpacingsBuilder(), BASE_SPACING_OPTION)) != null && option_0.getDefault() != null ? $doubleValue(castToDouble(option_0.getDefault())) / $doubleValue(castToDouble($getDefault(BASE_SPACING_OPTION))) : 1;
    $put_6(this$static.factorMap, option_0, factor);
}
function $lambda$3_0(this$static, element_0) {
    $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(new AbstractMap$1(this$static.factorMap), 1)), new ElkSpacings$AbstractSpacingsBuilder$lambda$4$Type(this$static, element_0)), new ElkSpacings$AbstractSpacingsBuilder$lambda$6$Type(this$static, element_0));
}
function $lambda$4_1(this$static, element_1, p_1) {
    return !$spliterator($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.filters, 16)), new Predicate$lambda$2$Type(new ElkSpacings$AbstractSpacingsBuilder$lambda$5$Type(element_1, p_1)))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER));
}
function $lambda$6(this$static, element_1, p_1) {
    element_1.setProperty(p_1, $doubleValue(castToDouble($get_10(this$static.factorMap, p_1))) * this$static.baseSpacing);
}
function lambda$5_2(element_0, p_1, filter_2) {
    $clinit_ElkSpacings$AbstractSpacingsBuilder();
    return filter_2.accept_4(element_0, p_1);
}
defineClass(1330, 1, {});
_.baseSpacing = 0;
var ELK_OPTION_TARGET_FILTER;
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder', 1330);
function $clinit_LayeredSpacings$LayeredSpacingsBuilder() {
    $clinit_LayeredSpacings$LayeredSpacingsBuilder = emptyMethod;
    $clinit_ElkSpacings$AbstractSpacingsBuilder();
    BASE_SPACING_OPTION = ($clinit_LayeredOptions(), SPACING_NODE_NODE_0);
    DEPENDENT_SPACING_OPTIONS = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_properties_IProperty_2_classLit, 1), $intern_109, 144, 0, [
        SPACING_COMPONENT_COMPONENT,
        SPACING_EDGE_EDGE,
        SPACING_EDGE_LABEL_0,
        SPACING_EDGE_NODE,
        SPACING_LABEL_LABEL,
        SPACING_LABEL_NODE,
        SPACING_LABEL_PORT_HORIZONTAL,
        SPACING_LABEL_PORT_VERTICAL,
        SPACING_NODE_SELF_LOOP,
        SPACING_PORT_PORT,
        SPACING_EDGE_EDGE_BETWEEN_LAYERS_0,
        SPACING_EDGE_NODE_BETWEEN_LAYERS_0,
        SPACING_NODE_NODE_BETWEEN_LAYERS_0
    ]));
}
function LayeredSpacings$LayeredSpacingsBuilder(d) {
    $clinit_LayeredSpacings$LayeredSpacingsBuilder();
    this.filters = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_LayoutConfigurator$IPropertyHolderOptionFilter_2_classLit, 1), $intern_2, 824, 0, [
        ELK_OPTION_TARGET_FILTER
    ]));
    this.factorMap = new HashMap;
    this.baseSpacing = d;
    $put_6(this.factorMap, BASE_SPACING_OPTION, 1);
    $forEach_1(DEPENDENT_SPACING_OPTIONS, new ElkSpacings$AbstractSpacingsBuilder$lambda$1$Type(this));
}
defineClass(772, 1330, {}, LayeredSpacings$LayeredSpacingsBuilder);
var BASE_SPACING_OPTION, DEPENDENT_SPACING_OPTIONS;
var Lorg_eclipse_elk_alg_layered_options_LayeredSpacings$LayeredSpacingsBuilder_2_classLit = createForClass('org.eclipse.elk.alg.layered.options', 'LayeredSpacings/LayeredSpacingsBuilder', 772);
function $clinit_LayeringStrategy() {
    $clinit_LayeringStrategy = emptyMethod;
    NETWORK_SIMPLEX = new LayeringStrategy('NETWORK_SIMPLEX', 0);
    LONGEST_PATH = new LayeringStrategy('LONGEST_PATH', 1);
    LONGEST_PATH_SOURCE = new LayeringStrategy('LONGEST_PATH_SOURCE', 2);
    COFFMAN_GRAHAM = new LayeringStrategy('COFFMAN_GRAHAM', 3);
    INTERACTIVE_3 = new LayeringStrategy('INTERACTIVE', 4);
    STRETCH_WIDTH = new LayeringStrategy('STRETCH_WIDTH', 5);
    MIN_WIDTH = new LayeringStrategy('MIN_WIDTH', 6);
    BF_MODEL_ORDER = new LayeringStrategy('BF_MODEL_ORDER', 7);
    DF_MODEL_ORDER = new LayeringStrategy('DF_MODEL_ORDER', 8);
}
function $create_5(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new NetworkSimplexLayerer;
        case 1:
            return new LongestPathLayerer;
        case 3:
            return new CoffmanGrahamLayerer;
        case 4:
            return new InteractiveLayerer;
        case 5:
            return new StretchWidthLayerer;
        case 6:
            return new MinWidthLayerer;
        case 2:
            return new LongestPathSourceLayerer;
        case 7:
            return new BreadthFirstModelOrderLayerer;
        case 8:
            return new DepthFirstModelOrderLayerer;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layerer ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function LayeringStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_47(name_0) {
    $clinit_LayeringStrategy();
    return valueOf(($clinit_LayeringStrategy$Map(), $MAP_37), name_0);
}
function values_55() {
    $clinit_LayeringStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LayeringStrategy_2_classLit, 1), $intern_36, 265, 0, [
        NETWORK_SIMPLEX,
        LONGEST_PATH,
        LONGEST_PATH_SOURCE,
        COFFMAN_GRAHAM,
        INTERACTIVE_3,
        STRETCH_WIDTH,
        MIN_WIDTH,
        BF_MODEL_ORDER,
        DF_MODEL_ORDER
    ]);
}
defineClass(265, 23, {
    3: 1,
    34: 1,
    23: 1,
    265: 1,
    188: 1,
    196: 1
}, LayeringStrategy);
_.create_1 = function create_11() {
    return $create_5(this);
};
_.create_2 = function create_10() {
    return $create_5(this);
};
var BF_MODEL_ORDER, COFFMAN_GRAHAM, DF_MODEL_ORDER, INTERACTIVE_3, LONGEST_PATH, LONGEST_PATH_SOURCE, MIN_WIDTH, NETWORK_SIMPLEX, STRETCH_WIDTH;
var Lorg_eclipse_elk_alg_layered_options_LayeringStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'LayeringStrategy', 265, Ljava_lang_Enum_2_classLit, values_55, valueOf_47);
function $clinit_LayeringStrategy$Map() {
    $clinit_LayeringStrategy$Map = emptyMethod;
    $MAP_37 = createValueOfMap(($clinit_LayeringStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LayeringStrategy_2_classLit, 1), $intern_36, 265, 0, [
        NETWORK_SIMPLEX,
        LONGEST_PATH,
        LONGEST_PATH_SOURCE,
        COFFMAN_GRAHAM,
        INTERACTIVE_3,
        STRETCH_WIDTH,
        MIN_WIDTH,
        BF_MODEL_ORDER,
        DF_MODEL_ORDER
    ])));
}
var $MAP_37;
function $clinit_LongEdgeOrderingStrategy() {
    $clinit_LongEdgeOrderingStrategy = emptyMethod;
    DUMMY_NODE_OVER = new LongEdgeOrderingStrategy('DUMMY_NODE_OVER', 0);
    DUMMY_NODE_UNDER = new LongEdgeOrderingStrategy('DUMMY_NODE_UNDER', 1);
    EQUAL = new LongEdgeOrderingStrategy('EQUAL', 2);
}
function $returnValue(this$static) {
    switch(this$static.ordinal){
        case 0:
            return $intern_0;
        case 1:
            return $intern_42;
        default:
            return 0;
    }
}
function LongEdgeOrderingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_48(name_0) {
    $clinit_LongEdgeOrderingStrategy();
    return valueOf(($clinit_LongEdgeOrderingStrategy$Map(), $MAP_38), name_0);
}
function values_56() {
    $clinit_LongEdgeOrderingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LongEdgeOrderingStrategy_2_classLit, 1), $intern_36, 349, 0, [
        DUMMY_NODE_OVER,
        DUMMY_NODE_UNDER,
        EQUAL
    ]);
}
defineClass(349, 23, {
    3: 1,
    34: 1,
    23: 1,
    349: 1
}, LongEdgeOrderingStrategy);
var DUMMY_NODE_OVER, DUMMY_NODE_UNDER, EQUAL;
var Lorg_eclipse_elk_alg_layered_options_LongEdgeOrderingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'LongEdgeOrderingStrategy', 349, Ljava_lang_Enum_2_classLit, values_56, valueOf_48);
function $clinit_LongEdgeOrderingStrategy$Map() {
    $clinit_LongEdgeOrderingStrategy$Map = emptyMethod;
    $MAP_38 = createValueOfMap(($clinit_LongEdgeOrderingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_LongEdgeOrderingStrategy_2_classLit, 1), $intern_36, 349, 0, [
        DUMMY_NODE_OVER,
        DUMMY_NODE_UNDER,
        EQUAL
    ])));
}
var $MAP_38;
function $clinit_NodeFlexibility() {
    $clinit_NodeFlexibility = emptyMethod;
    NONE_9 = new NodeFlexibility('NONE', 0);
    PORT_POSITION = new NodeFlexibility('PORT_POSITION', 1);
    NODE_SIZE_WHERE_SPACE_PERMITS = new NodeFlexibility('NODE_SIZE_WHERE_SPACE_PERMITS', 2);
    NODE_SIZE = new NodeFlexibility('NODE_SIZE', 3);
}
function $isFlexibleSizeWhereSpacePermits(this$static) {
    return this$static == NODE_SIZE_WHERE_SPACE_PERMITS || this$static == NODE_SIZE;
}
function NodeFlexibility(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function getNodeFlexibility(lNode) {
    $clinit_NodeFlexibility();
    var nf;
    (!lNode.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : lNode.propertyMap).containsKey(($clinit_LayeredOptions(), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0)) ? nf = castTo($getProperty(lNode, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0), 203) : nf = castTo($getProperty($getGraph(lNode), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0), 203);
    return nf;
}
function valueOf_49(name_0) {
    $clinit_NodeFlexibility();
    return valueOf(($clinit_NodeFlexibility$Map(), $MAP_39), name_0);
}
function values_57() {
    $clinit_NodeFlexibility();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_NodeFlexibility_2_classLit, 1), $intern_36, 203, 0, [
        NONE_9,
        PORT_POSITION,
        NODE_SIZE_WHERE_SPACE_PERMITS,
        NODE_SIZE
    ]);
}
defineClass(203, 23, {
    3: 1,
    34: 1,
    23: 1,
    203: 1
}, NodeFlexibility);
var NODE_SIZE, NODE_SIZE_WHERE_SPACE_PERMITS, NONE_9, PORT_POSITION;
var Lorg_eclipse_elk_alg_layered_options_NodeFlexibility_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'NodeFlexibility', 203, Ljava_lang_Enum_2_classLit, values_57, valueOf_49);
function $clinit_NodeFlexibility$Map() {
    $clinit_NodeFlexibility$Map = emptyMethod;
    $MAP_39 = createValueOfMap(($clinit_NodeFlexibility(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_NodeFlexibility_2_classLit, 1), $intern_36, 203, 0, [
        NONE_9,
        PORT_POSITION,
        NODE_SIZE_WHERE_SPACE_PERMITS,
        NODE_SIZE
    ])));
}
var $MAP_39;
function $clinit_NodePlacementStrategy() {
    $clinit_NodePlacementStrategy = emptyMethod;
    SIMPLE = new NodePlacementStrategy('SIMPLE', 0);
    INTERACTIVE_4 = new NodePlacementStrategy('INTERACTIVE', 1);
    LINEAR_SEGMENTS = new NodePlacementStrategy('LINEAR_SEGMENTS', 2);
    BRANDES_KOEPF = new NodePlacementStrategy('BRANDES_KOEPF', 3);
    NETWORK_SIMPLEX_0 = new NodePlacementStrategy('NETWORK_SIMPLEX', 4);
}
function $create_6(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new SimpleNodePlacer;
        case 1:
            return new InteractiveNodePlacer;
        case 2:
            return new LinearSegmentsNodePlacer;
        case 3:
            return new BKNodePlacer;
        case 4:
            return new NetworkSimplexPlacer;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the node placer ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function NodePlacementStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_50(name_0) {
    $clinit_NodePlacementStrategy();
    return valueOf(($clinit_NodePlacementStrategy$Map(), $MAP_40), name_0);
}
function values_58() {
    $clinit_NodePlacementStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_NodePlacementStrategy_2_classLit, 1), $intern_36, 324, 0, [
        SIMPLE,
        INTERACTIVE_4,
        LINEAR_SEGMENTS,
        BRANDES_KOEPF,
        NETWORK_SIMPLEX_0
    ]);
}
defineClass(324, 23, {
    3: 1,
    34: 1,
    23: 1,
    324: 1,
    188: 1,
    196: 1
}, NodePlacementStrategy);
_.create_1 = function create_13() {
    return $create_6(this);
};
_.create_2 = function create_12() {
    return $create_6(this);
};
var BRANDES_KOEPF, INTERACTIVE_4, LINEAR_SEGMENTS, NETWORK_SIMPLEX_0, SIMPLE;
var Lorg_eclipse_elk_alg_layered_options_NodePlacementStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'NodePlacementStrategy', 324, Ljava_lang_Enum_2_classLit, values_58, valueOf_50);
function $clinit_NodePlacementStrategy$Map() {
    $clinit_NodePlacementStrategy$Map = emptyMethod;
    $MAP_40 = createValueOfMap(($clinit_NodePlacementStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_NodePlacementStrategy_2_classLit, 1), $intern_36, 324, 0, [
        SIMPLE,
        INTERACTIVE_4,
        LINEAR_SEGMENTS,
        BRANDES_KOEPF,
        NETWORK_SIMPLEX_0
    ])));
}
var $MAP_40;
function $clinit_NodePromotionStrategy() {
    $clinit_NodePromotionStrategy = emptyMethod;
    NONE_10 = new NodePromotionStrategy('NONE', 0);
    NIKOLOV = new NodePromotionStrategy('NIKOLOV', 1);
    NIKOLOV_PIXEL = new NodePromotionStrategy('NIKOLOV_PIXEL', 2);
    NIKOLOV_IMPROVED = new NodePromotionStrategy('NIKOLOV_IMPROVED', 3);
    NIKOLOV_IMPROVED_PIXEL = new NodePromotionStrategy('NIKOLOV_IMPROVED_PIXEL', 4);
    DUMMYNODE_PERCENTAGE = new NodePromotionStrategy('DUMMYNODE_PERCENTAGE', 5);
    NODECOUNT_PERCENTAGE = new NodePromotionStrategy('NODECOUNT_PERCENTAGE', 6);
    NO_BOUNDARY = new NodePromotionStrategy('NO_BOUNDARY', 7);
    MODEL_ORDER_LEFT_TO_RIGHT = new NodePromotionStrategy('MODEL_ORDER_LEFT_TO_RIGHT', 8);
    MODEL_ORDER_RIGHT_TO_LEFT = new NodePromotionStrategy('MODEL_ORDER_RIGHT_TO_LEFT', 9);
}
function NodePromotionStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_51(name_0) {
    $clinit_NodePromotionStrategy();
    return valueOf(($clinit_NodePromotionStrategy$Map(), $MAP_41), name_0);
}
function values_59() {
    $clinit_NodePromotionStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_NodePromotionStrategy_2_classLit, 1), $intern_36, 242, 0, [
        NONE_10,
        NIKOLOV,
        NIKOLOV_PIXEL,
        NIKOLOV_IMPROVED,
        NIKOLOV_IMPROVED_PIXEL,
        DUMMYNODE_PERCENTAGE,
        NODECOUNT_PERCENTAGE,
        NO_BOUNDARY,
        MODEL_ORDER_LEFT_TO_RIGHT,
        MODEL_ORDER_RIGHT_TO_LEFT
    ]);
}
defineClass(242, 23, {
    3: 1,
    34: 1,
    23: 1,
    242: 1
}, NodePromotionStrategy);
var DUMMYNODE_PERCENTAGE, MODEL_ORDER_LEFT_TO_RIGHT, MODEL_ORDER_RIGHT_TO_LEFT, NIKOLOV, NIKOLOV_IMPROVED, NIKOLOV_IMPROVED_PIXEL, NIKOLOV_PIXEL, NODECOUNT_PERCENTAGE, NONE_10, NO_BOUNDARY;
var Lorg_eclipse_elk_alg_layered_options_NodePromotionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'NodePromotionStrategy', 242, Ljava_lang_Enum_2_classLit, values_59, valueOf_51);
function $clinit_NodePromotionStrategy$Map() {
    $clinit_NodePromotionStrategy$Map = emptyMethod;
    $MAP_41 = createValueOfMap(($clinit_NodePromotionStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_NodePromotionStrategy_2_classLit, 1), $intern_36, 242, 0, [
        NONE_10,
        NIKOLOV,
        NIKOLOV_PIXEL,
        NIKOLOV_IMPROVED,
        NIKOLOV_IMPROVED_PIXEL,
        DUMMYNODE_PERCENTAGE,
        NODECOUNT_PERCENTAGE,
        NO_BOUNDARY,
        MODEL_ORDER_LEFT_TO_RIGHT,
        MODEL_ORDER_RIGHT_TO_LEFT
    ])));
}
var $MAP_41;
function $clinit_OrderingStrategy() {
    $clinit_OrderingStrategy = emptyMethod;
    NONE_11 = new OrderingStrategy('NONE', 0);
    NODES_AND_EDGES = new OrderingStrategy('NODES_AND_EDGES', 1);
    PREFER_EDGES = new OrderingStrategy('PREFER_EDGES', 2);
    PREFER_NODES = new OrderingStrategy('PREFER_NODES', 3);
}
function OrderingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_52(name_0) {
    $clinit_OrderingStrategy();
    return valueOf(($clinit_OrderingStrategy$Map(), $MAP_42), name_0);
}
function values_60() {
    $clinit_OrderingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_OrderingStrategy_2_classLit, 1), $intern_36, 266, 0, [
        NONE_11,
        NODES_AND_EDGES,
        PREFER_EDGES,
        PREFER_NODES
    ]);
}
defineClass(266, 23, {
    3: 1,
    34: 1,
    23: 1,
    266: 1
}, OrderingStrategy);
var NODES_AND_EDGES, NONE_11, PREFER_EDGES, PREFER_NODES;
var Lorg_eclipse_elk_alg_layered_options_OrderingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'OrderingStrategy', 266, Ljava_lang_Enum_2_classLit, values_60, valueOf_52);
function $clinit_OrderingStrategy$Map() {
    $clinit_OrderingStrategy$Map = emptyMethod;
    $MAP_42 = createValueOfMap(($clinit_OrderingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_OrderingStrategy_2_classLit, 1), $intern_36, 266, 0, [
        NONE_11,
        NODES_AND_EDGES,
        PREFER_EDGES,
        PREFER_NODES
    ])));
}
var $MAP_42;
function $clinit_PortSortingStrategy() {
    $clinit_PortSortingStrategy = emptyMethod;
    INPUT_ORDER = new PortSortingStrategy('INPUT_ORDER', 0);
    PORT_DEGREE = new PortSortingStrategy('PORT_DEGREE', 1);
}
function PortSortingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_53(name_0) {
    $clinit_PortSortingStrategy();
    return valueOf(($clinit_PortSortingStrategy$Map(), $MAP_43), name_0);
}
function values_61() {
    $clinit_PortSortingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_PortSortingStrategy_2_classLit, 1), $intern_36, 418, 0, [
        INPUT_ORDER,
        PORT_DEGREE
    ]);
}
defineClass(418, 23, {
    3: 1,
    34: 1,
    23: 1,
    418: 1
}, PortSortingStrategy);
var INPUT_ORDER, PORT_DEGREE;
var Lorg_eclipse_elk_alg_layered_options_PortSortingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'PortSortingStrategy', 418, Ljava_lang_Enum_2_classLit, values_61, valueOf_53);
function $clinit_PortSortingStrategy$Map() {
    $clinit_PortSortingStrategy$Map = emptyMethod;
    $MAP_43 = createValueOfMap(($clinit_PortSortingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_PortSortingStrategy_2_classLit, 1), $intern_36, 418, 0, [
        INPUT_ORDER,
        PORT_DEGREE
    ])));
}
var $MAP_43;
function $clinit_PortType() {
    $clinit_PortType = emptyMethod;
    UNDEFINED_0 = new PortType('UNDEFINED', 0);
    INPUT = new PortType('INPUT', 1);
    OUTPUT = new PortType('OUTPUT', 2);
}
function PortType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_54(name_0) {
    $clinit_PortType();
    return valueOf(($clinit_PortType$Map(), $MAP_44), name_0);
}
function values_62() {
    $clinit_PortType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_PortType_2_classLit, 1), $intern_36, 449, 0, [
        UNDEFINED_0,
        INPUT,
        OUTPUT
    ]);
}
defineClass(449, 23, {
    3: 1,
    34: 1,
    23: 1,
    449: 1
}, PortType);
var INPUT, OUTPUT, UNDEFINED_0;
var Lorg_eclipse_elk_alg_layered_options_PortType_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'PortType', 449, Ljava_lang_Enum_2_classLit, values_62, valueOf_54);
function $clinit_PortType$Map() {
    $clinit_PortType$Map = emptyMethod;
    $MAP_44 = createValueOfMap(($clinit_PortType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_PortType_2_classLit, 1), $intern_36, 449, 0, [
        UNDEFINED_0,
        INPUT,
        OUTPUT
    ])));
}
var $MAP_44;
function $clinit_SelfLoopDistributionStrategy() {
    $clinit_SelfLoopDistributionStrategy = emptyMethod;
    EQUALLY = new SelfLoopDistributionStrategy('EQUALLY', 0);
    NORTH_0 = new SelfLoopDistributionStrategy('NORTH', 1);
    NORTH_SOUTH = new SelfLoopDistributionStrategy('NORTH_SOUTH', 2);
}
function SelfLoopDistributionStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_55(name_0) {
    $clinit_SelfLoopDistributionStrategy();
    return valueOf(($clinit_SelfLoopDistributionStrategy$Map(), $MAP_45), name_0);
}
function values_63() {
    $clinit_SelfLoopDistributionStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_SelfLoopDistributionStrategy_2_classLit, 1), $intern_36, 379, 0, [
        EQUALLY,
        NORTH_0,
        NORTH_SOUTH
    ]);
}
defineClass(379, 23, {
    3: 1,
    34: 1,
    23: 1,
    379: 1
}, SelfLoopDistributionStrategy);
var EQUALLY, NORTH_0, NORTH_SOUTH;
var Lorg_eclipse_elk_alg_layered_options_SelfLoopDistributionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'SelfLoopDistributionStrategy', 379, Ljava_lang_Enum_2_classLit, values_63, valueOf_55);
function $clinit_SelfLoopDistributionStrategy$Map() {
    $clinit_SelfLoopDistributionStrategy$Map = emptyMethod;
    $MAP_45 = createValueOfMap(($clinit_SelfLoopDistributionStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_SelfLoopDistributionStrategy_2_classLit, 1), $intern_36, 379, 0, [
        EQUALLY,
        NORTH_0,
        NORTH_SOUTH
    ])));
}
var $MAP_45;
function $clinit_SelfLoopOrderingStrategy() {
    $clinit_SelfLoopOrderingStrategy = emptyMethod;
    STACKED = new SelfLoopOrderingStrategy('STACKED', 0);
    REVERSE_STACKED = new SelfLoopOrderingStrategy('REVERSE_STACKED', 1);
    SEQUENCED = new SelfLoopOrderingStrategy('SEQUENCED', 2);
}
function SelfLoopOrderingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_56(name_0) {
    $clinit_SelfLoopOrderingStrategy();
    return valueOf(($clinit_SelfLoopOrderingStrategy$Map(), $MAP_46), name_0);
}
function values_64() {
    $clinit_SelfLoopOrderingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_SelfLoopOrderingStrategy_2_classLit, 1), $intern_36, 345, 0, [
        STACKED,
        REVERSE_STACKED,
        SEQUENCED
    ]);
}
defineClass(345, 23, {
    3: 1,
    34: 1,
    23: 1,
    345: 1
}, SelfLoopOrderingStrategy);
var REVERSE_STACKED, SEQUENCED, STACKED;
var Lorg_eclipse_elk_alg_layered_options_SelfLoopOrderingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'SelfLoopOrderingStrategy', 345, Ljava_lang_Enum_2_classLit, values_64, valueOf_56);
function $clinit_SelfLoopOrderingStrategy$Map() {
    $clinit_SelfLoopOrderingStrategy$Map = emptyMethod;
    $MAP_46 = createValueOfMap(($clinit_SelfLoopOrderingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_SelfLoopOrderingStrategy_2_classLit, 1), $intern_36, 345, 0, [
        STACKED,
        REVERSE_STACKED,
        SEQUENCED
    ])));
}
var $MAP_46;
function $getHorizontalSpacing(this$static, nt1, nt2) {
    return $getLocalSpacing(this$static, nt1, nt2, this$static.nodeTypeSpacingOptionsHorizontal);
}
function $getLocalSpacing(this$static, nt1, nt2, nodeTypeSpacingMapping) {
    var layoutOption;
    layoutOption = nodeTypeSpacingMapping[nt1.ordinal][nt2.ordinal];
    return $doubleValue(castToDouble($getProperty(this$static.graph_0, layoutOption)));
}
function $getLocalSpacing_0(n1, n2, nodeTypeSpacingMapping) {
    var layoutOption, s1, s2, t1, t2;
    t1 = n1.type_0;
    t2 = n2.type_0;
    layoutOption = nodeTypeSpacingMapping[t1.ordinal][t2.ordinal];
    s1 = castToDouble(getIndividualOrDefault(n1, layoutOption));
    s2 = castToDouble(getIndividualOrDefault(n2, layoutOption));
    return $wnd.Math.max((checkCriticalNotNull(s1), s1), (checkCriticalNotNull(s2), s2));
}
function $getVerticalSpacing(this$static, nt1, nt2) {
    return $getLocalSpacing(this$static, nt1, nt2, this$static.nodeTypeSpacingOptionsVertical);
}
function $getVerticalSpacing_0(this$static, n1, n2) {
    return $getLocalSpacing_0(n1, n2, this$static.nodeTypeSpacingOptionsVertical);
}
function $nodeTypeSpacing(this$static, n1, n2, spacing) {
    setCheck(this$static.nodeTypeSpacingOptionsVertical[n1.ordinal], n2.ordinal, spacing);
    setCheck(this$static.nodeTypeSpacingOptionsVertical[n2.ordinal], n1.ordinal, spacing);
}
function $nodeTypeSpacing_0(this$static, n1, n2, spacingVert, spacingHorz) {
    setCheck(this$static.nodeTypeSpacingOptionsVertical[n1.ordinal], n2.ordinal, spacingVert);
    setCheck(this$static.nodeTypeSpacingOptionsVertical[n2.ordinal], n1.ordinal, spacingVert);
    setCheck(this$static.nodeTypeSpacingOptionsHorizontal[n1.ordinal], n2.ordinal, spacingHorz);
    setCheck(this$static.nodeTypeSpacingOptionsHorizontal[n2.ordinal], n1.ordinal, spacingHorz);
}
function $nodeTypeSpacing_1(this$static, nt, spacing) {
    setCheck(this$static.nodeTypeSpacingOptionsVertical[nt.ordinal], nt.ordinal, spacing);
}
function $nodeTypeSpacing_2(this$static, nt, spacingVert, spacingHorz) {
    setCheck(this$static.nodeTypeSpacingOptionsVertical[nt.ordinal], nt.ordinal, spacingVert);
    setCheck(this$static.nodeTypeSpacingOptionsHorizontal[nt.ordinal], nt.ordinal, spacingHorz);
}
function Spacings(graph) {
    var n;
    this.graph_0 = graph;
    n = ($clinit_LNode$NodeType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LNode$NodeType_2_classLit, 1), $intern_36, 247, 0, [
        NORMAL,
        LONG_EDGE,
        EXTERNAL_PORT,
        NORTH_SOUTH_PORT,
        LABEL,
        BREAKING_POINT,
        PLACEHOLDER,
        NONSHIFTING_PLACEHOLDER
    ])).length;
    this.nodeTypeSpacingOptionsHorizontal = initMultidimensionalArray(Lorg_eclipse_elk_graph_properties_IProperty_2_classLit, [
        $intern_16,
        $intern_109
    ], [
        585,
        144
    ], 0, [
        n,
        n
    ], 2);
    this.nodeTypeSpacingOptionsVertical = initMultidimensionalArray(Lorg_eclipse_elk_graph_properties_IProperty_2_classLit, [
        $intern_16,
        $intern_109
    ], [
        585,
        144
    ], 0, [
        n,
        n
    ], 2);
    $nodeTypeSpacing_2(this, NORMAL, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0), SPACING_NODE_NODE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing_0(this, NORMAL, LONG_EDGE, SPACING_EDGE_NODE, SPACING_EDGE_NODE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing(this, NORMAL, NORTH_SOUTH_PORT, SPACING_EDGE_NODE);
    $nodeTypeSpacing(this, NORMAL, EXTERNAL_PORT, SPACING_EDGE_NODE);
    $nodeTypeSpacing_0(this, NORMAL, LABEL, SPACING_NODE_NODE_0, SPACING_NODE_NODE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing_2(this, LONG_EDGE, SPACING_EDGE_EDGE, SPACING_EDGE_EDGE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing(this, LONG_EDGE, NORTH_SOUTH_PORT, SPACING_EDGE_EDGE);
    $nodeTypeSpacing(this, LONG_EDGE, EXTERNAL_PORT, SPACING_EDGE_EDGE);
    $nodeTypeSpacing_0(this, LONG_EDGE, LABEL, SPACING_EDGE_NODE, SPACING_EDGE_NODE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing_1(this, NORTH_SOUTH_PORT, SPACING_EDGE_EDGE);
    $nodeTypeSpacing(this, NORTH_SOUTH_PORT, EXTERNAL_PORT, SPACING_EDGE_EDGE);
    $nodeTypeSpacing(this, NORTH_SOUTH_PORT, LABEL, SPACING_LABEL_NODE);
    $nodeTypeSpacing_1(this, EXTERNAL_PORT, SPACING_PORT_PORT);
    $nodeTypeSpacing_0(this, EXTERNAL_PORT, LABEL, SPACING_LABEL_PORT_VERTICAL, SPACING_LABEL_PORT_HORIZONTAL);
    $nodeTypeSpacing_2(this, LABEL, SPACING_EDGE_EDGE, SPACING_EDGE_EDGE);
    $nodeTypeSpacing_2(this, BREAKING_POINT, SPACING_EDGE_EDGE, SPACING_EDGE_EDGE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing_0(this, BREAKING_POINT, NORMAL, SPACING_EDGE_NODE, SPACING_EDGE_NODE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing_0(this, BREAKING_POINT, LABEL, SPACING_EDGE_NODE, SPACING_EDGE_NODE_BETWEEN_LAYERS_0);
    $nodeTypeSpacing_0(this, BREAKING_POINT, LONG_EDGE, SPACING_EDGE_NODE, SPACING_EDGE_NODE_BETWEEN_LAYERS_0);
}
function getIndividualOrDefault(node, property) {
    var individualSpacings, result;
    result = null;
    if ($hasProperty(node, ($clinit_LayeredOptions(), SPACING_INDIVIDUAL))) {
        individualSpacings = castTo($getProperty(node, SPACING_INDIVIDUAL), 102);
        individualSpacings.hasProperty(property) && (result = individualSpacings.getProperty(property));
    }
    result == null && (result = $getProperty($getGraph(node), property));
    return result;
}
defineClass(313, 1, {
    313: 1
}, Spacings);
var Lorg_eclipse_elk_alg_layered_options_Spacings_2_classLit = createForClass('org.eclipse.elk.alg.layered.options', 'Spacings', 313);
function $clinit_SplineRoutingMode() {
    $clinit_SplineRoutingMode = emptyMethod;
    CONSERVATIVE = new SplineRoutingMode('CONSERVATIVE', 0);
    CONSERVATIVE_SOFT = new SplineRoutingMode('CONSERVATIVE_SOFT', 1);
    SLOPPY = new SplineRoutingMode('SLOPPY', 2);
}
function SplineRoutingMode(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_57(name_0) {
    $clinit_SplineRoutingMode();
    return valueOf(($clinit_SplineRoutingMode$Map(), $MAP_47), name_0);
}
function values_65() {
    $clinit_SplineRoutingMode();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_SplineRoutingMode_2_classLit, 1), $intern_36, 346, 0, [
        CONSERVATIVE,
        CONSERVATIVE_SOFT,
        SLOPPY
    ]);
}
defineClass(346, 23, {
    3: 1,
    34: 1,
    23: 1,
    346: 1
}, SplineRoutingMode);
var CONSERVATIVE, CONSERVATIVE_SOFT, SLOPPY;
var Lorg_eclipse_elk_alg_layered_options_SplineRoutingMode_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'SplineRoutingMode', 346, Ljava_lang_Enum_2_classLit, values_65, valueOf_57);
function $clinit_SplineRoutingMode$Map() {
    $clinit_SplineRoutingMode$Map = emptyMethod;
    $MAP_47 = createValueOfMap(($clinit_SplineRoutingMode(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_SplineRoutingMode_2_classLit, 1), $intern_36, 346, 0, [
        CONSERVATIVE,
        CONSERVATIVE_SOFT,
        SLOPPY
    ])));
}
var $MAP_47;
function $clinit_ValidifyStrategy() {
    $clinit_ValidifyStrategy = emptyMethod;
    NO = new ValidifyStrategy('NO', 0);
    GREEDY_0 = new ValidifyStrategy('GREEDY', 1);
    LOOK_BACK = new ValidifyStrategy('LOOK_BACK', 2);
}
function ValidifyStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_58(name_0) {
    $clinit_ValidifyStrategy();
    return valueOf(($clinit_ValidifyStrategy$Map(), $MAP_48), name_0);
}
function values_66() {
    $clinit_ValidifyStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_ValidifyStrategy_2_classLit, 1), $intern_36, 348, 0, [
        NO,
        GREEDY_0,
        LOOK_BACK
    ]);
}
defineClass(348, 23, {
    3: 1,
    34: 1,
    23: 1,
    348: 1
}, ValidifyStrategy);
var GREEDY_0, LOOK_BACK, NO;
var Lorg_eclipse_elk_alg_layered_options_ValidifyStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'ValidifyStrategy', 348, Ljava_lang_Enum_2_classLit, values_66, valueOf_58);
function $clinit_ValidifyStrategy$Map() {
    $clinit_ValidifyStrategy$Map = emptyMethod;
    $MAP_48 = createValueOfMap(($clinit_ValidifyStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_ValidifyStrategy_2_classLit, 1), $intern_36, 348, 0, [
        NO,
        GREEDY_0,
        LOOK_BACK
    ])));
}
var $MAP_48;
function $clinit_WrappingStrategy() {
    $clinit_WrappingStrategy = emptyMethod;
    OFF_0 = new WrappingStrategy('OFF', 0);
    SINGLE_EDGE = new WrappingStrategy('SINGLE_EDGE', 1);
    MULTI_EDGE = new WrappingStrategy('MULTI_EDGE', 2);
}
function WrappingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_59(name_0) {
    $clinit_WrappingStrategy();
    return valueOf(($clinit_WrappingStrategy$Map(), $MAP_49), name_0);
}
function values_67() {
    $clinit_WrappingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_WrappingStrategy_2_classLit, 1), $intern_36, 380, 0, [
        OFF_0,
        SINGLE_EDGE,
        MULTI_EDGE
    ]);
}
defineClass(380, 23, {
    3: 1,
    34: 1,
    23: 1,
    380: 1
}, WrappingStrategy);
var MULTI_EDGE, OFF_0, SINGLE_EDGE;
var Lorg_eclipse_elk_alg_layered_options_WrappingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.layered.options', 'WrappingStrategy', 380, Ljava_lang_Enum_2_classLit, values_67, valueOf_59);
function $clinit_WrappingStrategy$Map() {
    $clinit_WrappingStrategy$Map = emptyMethod;
    $MAP_49 = createValueOfMap(($clinit_WrappingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_options_WrappingStrategy_2_classLit, 1), $intern_36, 380, 0, [
        OFF_0,
        SINGLE_EDGE,
        MULTI_EDGE
    ])));
}
var $MAP_49;
function $clinit_DepthFirstCycleBreaker() {
    $clinit_DepthFirstCycleBreaker = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION = $addAfter(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), REVERSED_EDGE_RESTORER));
}
function $dfs_3(this$static, n) {
    var out, out$iterator, target;
    if (this$static.visited[n.id_0]) return;
    this$static.visited[n.id_0] = true;
    this$static.active[n.id_0] = true;
    for(out$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(out$iterator);){
        out = castTo($next_0(out$iterator), 18);
        if ($isSelfLoop(out)) continue;
        target = out.target.owner;
        this$static.active[target.id_0] ? $add_3(this$static.edgesToBeReversed, out) : $dfs_3(this$static, target);
    }
    this$static.active[n.id_0] = false;
}
function $process_58(this$static, graph, monitor) {
    var edge, edge$iterator, i, index_0, n, node, node$iterator, nodeCount, nodes, source, source$iterator;
    monitor.begin('Depth-first cycle removal', 1);
    nodes = graph.layerlessNodes;
    nodeCount = nodes.array.length;
    this$static.sources = new ArrayList;
    this$static.visited = initUnidimensionalArray(Z_classLit, $intern_90, 30, nodeCount, 16, 1);
    this$static.active = initUnidimensionalArray(Z_classLit, $intern_90, 30, nodeCount, 16, 1);
    this$static.edgesToBeReversed = new ArrayList;
    index_0 = 0;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        node.id_0 = index_0;
        isEmpty_13($getIncomingEdges(node)) && $add_3(this$static.sources, node);
        ++index_0;
    }
    for(source$iterator = new ArrayList$1(this$static.sources); source$iterator.i < source$iterator.this$01.array.length;){
        source = castTo($next_6(source$iterator), 9);
        $dfs_3(this$static, source);
    }
    for(i = 0; i < nodeCount; i++)if (!this$static.visited[i]) {
        n = (checkCriticalElementIndex(i, nodes.array.length), castTo(nodes.array[i], 9));
        $dfs_3(this$static, n);
    }
    for(edge$iterator = new ArrayList$1(this$static.edgesToBeReversed); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 18);
        $reverse_0(edge, true);
        $setProperty_0(graph, ($clinit_InternalProperties_1(), CYCLIC), ($clinit_Boolean(), true));
    }
    this$static.sources = null;
    this$static.visited = null;
    this$static.active = null;
    this$static.edgesToBeReversed = null;
    monitor.done_1();
}
function DepthFirstCycleBreaker() {
    $clinit_DepthFirstCycleBreaker();
}
defineClass(1337, 1, $intern_110, DepthFirstCycleBreaker);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration(graph) {
    return castTo(graph, 36), INTERMEDIATE_PROCESSING_CONFIGURATION;
};
_.process = function process_55(graph, monitor) {
    $process_58(this, castTo(graph, 36), monitor);
};
var INTERMEDIATE_PROCESSING_CONFIGURATION;
var Lorg_eclipse_elk_alg_layered_p1cycles_DepthFirstCycleBreaker_2_classLit = createForClass('org.eclipse.elk.alg.layered.p1cycles', 'DepthFirstCycleBreaker', 1337);
function $clinit_GreedyCycleBreaker() {
    $clinit_GreedyCycleBreaker = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION_0 = $addAfter(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), REVERSED_EDGE_RESTORER));
}
function $process_59(this$static, layeredGraph, monitor) {
    var edge, edge$array, edge$index, edge$iterator, edge$iterator0, edge$max, index_0, maxNode, maxNodes, maxOutflow, nextLeft, nextRight, node, node$iterator, node$iterator0, node$iterator1, nodes, outflow, outgoingEdges, port, port$array, port$index, port$iterator, port$max, ports, priority, shiftBase, sink, source, targetIx, unprocessedNodeCount;
    monitor.begin('Greedy cycle removal', 1);
    nodes = layeredGraph.layerlessNodes;
    unprocessedNodeCount = nodes.array.length;
    this$static.indeg = initUnidimensionalArray(I_classLit, $intern_48, 30, unprocessedNodeCount, 15, 1);
    this$static.outdeg = initUnidimensionalArray(I_classLit, $intern_48, 30, unprocessedNodeCount, 15, 1);
    this$static.mark = initUnidimensionalArray(I_classLit, $intern_48, 30, unprocessedNodeCount, 15, 1);
    index_0 = 0;
    for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        node.id_0 = index_0;
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator0 = new ArrayList$1(port.incomingEdges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
                edge = castTo($next_6(edge$iterator0), 18);
                if (edge.source.owner == node) continue;
                priority = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_DIRECTION_0)), 17).value_0;
                this$static.indeg[index_0] += priority > 0 ? priority + 1 : 1;
            }
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if (edge.target.owner == node) continue;
                priority = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_DIRECTION_0)), 17).value_0;
                this$static.outdeg[index_0] += priority > 0 ? priority + 1 : 1;
            }
        }
        this$static.outdeg[index_0] == 0 ? $add_7(this$static.sinks, node) : this$static.indeg[index_0] == 0 && $add_7(this$static.sources, node);
        ++index_0;
    }
    nextRight = -1;
    nextLeft = 1;
    maxNodes = new ArrayList;
    this$static.random_0 = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), RANDOM_0)), 233);
    while(unprocessedNodeCount > 0){
        while(this$static.sinks.size_0 != 0){
            sink = castTo($removeFirst_0(this$static.sinks), 9);
            this$static.mark[sink.id_0] = nextRight--;
            $updateNeighbors(this$static, sink);
            --unprocessedNodeCount;
        }
        while(this$static.sources.size_0 != 0){
            source = castTo($removeFirst_0(this$static.sources), 9);
            this$static.mark[source.id_0] = nextLeft++;
            $updateNeighbors(this$static, source);
            --unprocessedNodeCount;
        }
        if (unprocessedNodeCount > 0) {
            maxOutflow = $intern_42;
            for(node$iterator1 = new ArrayList$1(nodes); node$iterator1.i < node$iterator1.this$01.array.length;){
                node = castTo($next_6(node$iterator1), 9);
                if (this$static.mark[node.id_0] == 0) {
                    outflow = this$static.outdeg[node.id_0] - this$static.indeg[node.id_0];
                    if (outflow >= maxOutflow) {
                        if (outflow > maxOutflow) {
                            maxNodes.array.length = 0;
                            maxOutflow = outflow;
                        }
                        push_1(maxNodes.array, node);
                    }
                }
            }
            maxNode = this$static.chooseNodeWithMaxOutflow(maxNodes);
            this$static.mark[maxNode.id_0] = nextLeft++;
            $updateNeighbors(this$static, maxNode);
            --unprocessedNodeCount;
        }
    }
    shiftBase = nodes.array.length + 1;
    for(index_0 = 0; index_0 < nodes.array.length; index_0++)this$static.mark[index_0] < 0 && (this$static.mark[index_0] += shiftBase);
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        ports = toPortArray(node.ports);
        for(port$array = ports, port$index = 0, port$max = port$array.length; port$index < port$max; ++port$index){
            port = port$array[port$index];
            outgoingEdges = toEdgeArray(port.outgoingEdges);
            for(edge$array = outgoingEdges, edge$index = 0, edge$max = edge$array.length; edge$index < edge$max; ++edge$index){
                edge = edge$array[edge$index];
                targetIx = edge.target.owner.id_0;
                if (this$static.mark[node.id_0] > this$static.mark[targetIx]) {
                    $reverse_0(edge, true);
                    $setProperty_0(layeredGraph, CYCLIC, ($clinit_Boolean(), true));
                }
            }
        }
    }
    this$static.indeg = null;
    this$static.outdeg = null;
    this$static.mark = null;
    $reset_0(this$static.sources);
    $reset_0(this$static.sinks);
    monitor.done_1();
}
function $updateNeighbors(this$static, node) {
    var connectedPort, edge, edge$iterator, endpoint, index_0, port, port$iterator, priority;
    for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
            edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
            connectedPort = edge.source == port ? edge.target : edge.source;
            endpoint = connectedPort.owner;
            if (node == endpoint) continue;
            priority = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_DIRECTION_0)), 17).value_0;
            priority < 0 && (priority = 0);
            index_0 = endpoint.id_0;
            if (this$static.mark[index_0] == 0) {
                if (edge.target == connectedPort) {
                    this$static.indeg[index_0] -= priority + 1;
                    this$static.indeg[index_0] <= 0 && this$static.outdeg[index_0] > 0 && $add_7(this$static.sources, endpoint);
                } else {
                    this$static.outdeg[index_0] -= priority + 1;
                    this$static.outdeg[index_0] <= 0 && this$static.indeg[index_0] > 0 && $add_7(this$static.sinks, endpoint);
                }
            }
        }
    }
}
function GreedyCycleBreaker() {
    $clinit_GreedyCycleBreaker();
    this.sources = new LinkedList;
    this.sinks = new LinkedList;
}
defineClass(773, 1, $intern_110, GreedyCycleBreaker);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_0(graph) {
    return castTo(graph, 36), INTERMEDIATE_PROCESSING_CONFIGURATION_0;
};
_.process = function process_56(layeredGraph, monitor) {
    $process_59(this, castTo(layeredGraph, 36), monitor);
};
_.chooseNodeWithMaxOutflow = function chooseNodeWithMaxOutflow(nodes) {
    return castTo($get_11(nodes, $nextInt(this.random_0, nodes.array.length)), 9);
};
var INTERMEDIATE_PROCESSING_CONFIGURATION_0;
var Lorg_eclipse_elk_alg_layered_p1cycles_GreedyCycleBreaker_2_classLit = createForClass('org.eclipse.elk.alg.layered.p1cycles', 'GreedyCycleBreaker', 773);
function GreedyModelOrderCycleBreaker() {
    $clinit_GreedyCycleBreaker();
    GreedyCycleBreaker.call(this);
}
defineClass(1340, 773, $intern_110, GreedyModelOrderCycleBreaker);
_.chooseNodeWithMaxOutflow = function chooseNodeWithMaxOutflow_0(nodes) {
    var minimumModelOrder, node, node$iterator, returnNode;
    returnNode = null;
    minimumModelOrder = $intern_0;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if ($hasProperty(node, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && castTo($getProperty(node, MODEL_ORDER_1), 17).value_0 < minimumModelOrder) {
            minimumModelOrder = castTo($getProperty(node, MODEL_ORDER_1), 17).value_0;
            returnNode = node;
        }
    }
    if (!returnNode) return castTo($get_11(nodes, $nextInt(this.random_0, nodes.array.length)), 9);
    return returnNode;
};
var Lorg_eclipse_elk_alg_layered_p1cycles_GreedyModelOrderCycleBreaker_2_classLit = createForClass('org.eclipse.elk.alg.layered.p1cycles', 'GreedyModelOrderCycleBreaker', 1340);
function $clinit_InteractiveCycleBreaker() {
    $clinit_InteractiveCycleBreaker = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION_1 = $addAfter($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), INTERACTIVE_EXTERNAL_PORT_POSITIONER)), P5_EDGE_ROUTING, REVERSED_EDGE_RESTORER);
}
function $findCycles(this$static, node1, revEdges) {
    var edge, edge$iterator, node2, port, port$iterator;
    node1.id_0 = -1;
    for(port$iterator = $getPorts(node1, ($clinit_PortType(), OUTPUT)).iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            node2 = edge.target.owner;
            node1 != node2 && (node2.id_0 < 0 ? revEdges.add_2(edge) : node2.id_0 > 0 && $findCycles(this$static, node2, revEdges));
        }
    }
    node1.id_0 = 0;
}
function $process_60(this$static, layeredGraph, monitor) {
    var edge, edge$iterator, edge$iterator0, edge$iterator1, node, node$iterator, port, port$iterator, revEdges, source, source$iterator, sourcex, target, targetx;
    monitor.begin('Interactive cycle breaking', 1);
    revEdges = new ArrayList;
    for(source$iterator = new ArrayList$1(layeredGraph.layerlessNodes); source$iterator.i < source$iterator.this$01.array.length;){
        source = castTo($next_6(source$iterator), 9);
        source.id_0 = 1;
        sourcex = $getInteractiveReferencePoint(source).x_0;
        for(port$iterator = $getPorts(source, ($clinit_PortType(), OUTPUT)).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            for(edge$iterator0 = new ArrayList$1(port.outgoingEdges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
                edge = castTo($next_6(edge$iterator0), 18);
                target = edge.target.owner;
                if (target != source) {
                    targetx = $getInteractiveReferencePoint(target).x_0;
                    targetx < sourcex && push_1(revEdges.array, edge);
                }
            }
        }
    }
    for(edge$iterator1 = new ArrayList$1(revEdges); edge$iterator1.i < edge$iterator1.this$01.array.length;){
        edge = castTo($next_6(edge$iterator1), 18);
        $reverse_0(edge, true);
    }
    revEdges.array.length = 0;
    for(node$iterator = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        node.id_0 > 0 && $findCycles(this$static, node, revEdges);
    }
    for(edge$iterator = new ArrayList$1(revEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 18);
        $reverse_0(edge, true);
    }
    revEdges.array.length = 0;
    monitor.done_1();
}
function InteractiveCycleBreaker() {
    $clinit_InteractiveCycleBreaker();
}
defineClass(1338, 1, $intern_110, InteractiveCycleBreaker);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_1(graph) {
    return castTo(graph, 36), INTERMEDIATE_PROCESSING_CONFIGURATION_1;
};
_.process = function process_57(layeredGraph, monitor) {
    $process_60(this, castTo(layeredGraph, 36), monitor);
};
var INTERMEDIATE_PROCESSING_CONFIGURATION_1;
var Lorg_eclipse_elk_alg_layered_p1cycles_InteractiveCycleBreaker_2_classLit = createForClass('org.eclipse.elk.alg.layered.p1cycles', 'InteractiveCycleBreaker', 1338);
function $clinit_ModelOrderCycleBreaker() {
    $clinit_ModelOrderCycleBreaker = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION_2 = $addAfter(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), REVERSED_EDGE_RESTORER));
}
function $computeConstraintModelOrder(this$static, node, offset) {
    var modelOrder;
    modelOrder = 0;
    switch(castTo($getProperty(node, ($clinit_LayeredOptions(), LAYERING_LAYER_CONSTRAINT_0)), 171).ordinal){
        case 2:
            modelOrder = 2 * -offset + this$static.firstSeparateModelOrder;
            ++this$static.firstSeparateModelOrder;
            break;
        case 1:
            modelOrder = -offset;
            break;
        case 3:
            modelOrder = offset;
            break;
        case 4:
            modelOrder = 2 * offset + this$static.lastSeparateModelOrder;
            ++this$static.lastSeparateModelOrder;
    }
    $hasProperty(node, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && (modelOrder += castTo($getProperty(node, MODEL_ORDER_1), 17).value_0);
    return modelOrder;
}
function $process_61(this$static, layeredGraph, monitor) {
    var edge, edge$iterator, edge$iterator0, modelOrderSource, modelOrderTarget, node, node$iterator, offset, port, port$iterator, revEdges, source, source$iterator, target;
    monitor.begin('Model order cycle breaking', 1);
    this$static.firstSeparateModelOrder = 0;
    this$static.lastSeparateModelOrder = 0;
    revEdges = new ArrayList;
    offset = layeredGraph.layerlessNodes.array.length;
    for(node$iterator = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $hasProperty(node, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && (offset = $wnd.Math.max(offset, castTo($getProperty(node, MODEL_ORDER_1), 17).value_0 + 1));
    }
    for(source$iterator = new ArrayList$1(layeredGraph.layerlessNodes); source$iterator.i < source$iterator.this$01.array.length;){
        source = castTo($next_6(source$iterator), 9);
        modelOrderSource = $computeConstraintModelOrder(this$static, source, offset);
        for(port$iterator = $getPorts(source, ($clinit_PortType(), OUTPUT)).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            for(edge$iterator0 = new ArrayList$1(port.outgoingEdges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
                edge = castTo($next_6(edge$iterator0), 18);
                target = edge.target.owner;
                modelOrderTarget = $computeConstraintModelOrder(this$static, target, offset);
                modelOrderTarget < modelOrderSource && push_1(revEdges.array, edge);
            }
        }
    }
    for(edge$iterator = new ArrayList$1(revEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 18);
        $reverse_0(edge, true);
        $setProperty_0(layeredGraph, ($clinit_InternalProperties_1(), CYCLIC), ($clinit_Boolean(), true));
    }
    revEdges.array.length = 0;
    monitor.done_1();
}
function ModelOrderCycleBreaker() {
    $clinit_ModelOrderCycleBreaker();
}
defineClass(1339, 1, $intern_110, ModelOrderCycleBreaker);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_2(graph) {
    return castTo(graph, 36), INTERMEDIATE_PROCESSING_CONFIGURATION_2;
};
_.process = function process_58(layeredGraph, monitor) {
    $process_61(this, castTo(layeredGraph, 36), monitor);
};
_.firstSeparateModelOrder = 0;
_.lastSeparateModelOrder = 0;
var INTERMEDIATE_PROCESSING_CONFIGURATION_2;
var Lorg_eclipse_elk_alg_layered_p1cycles_ModelOrderCycleBreaker_2_classLit = createForClass('org.eclipse.elk.alg.layered.p1cycles', 'ModelOrderCycleBreaker', 1339);
function $clinit_BreadthFirstModelOrderLayerer() {
    $clinit_BreadthFirstModelOrderLayerer = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION_0 = $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
}
function $process_62(this$static, thelayeredGraph, monitor) {
    var currentDummyLayer, currentLayer, edge, edge$iterator, edge$iterator0, firstNode, layer, layer$iterator, layer$iterator0, layerId, node, node$iterator, node$iterator0, realNodes, toDelete;
    monitor.begin('Breadth first model order layering', 1);
    this$static.layeredGraph = thelayeredGraph;
    realNodes = new ArrayList;
    for(node$iterator0 = new ArrayList$1(this$static.layeredGraph.layerlessNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        node.type_0 == ($clinit_LNode$NodeType(), NORMAL) && push_1(realNodes.array, node);
    }
    $clinit_Collections();
    $sort(realNodes, new BreadthFirstModelOrderLayerer$lambda$0$Type);
    firstNode = true;
    currentLayer = new Layer(this$static.layeredGraph);
    currentDummyLayer = null;
    $add_3(this$static.layeredGraph.layers, currentLayer);
    for(node$iterator = new ArrayList$1(realNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (firstNode) {
            $setLayer_0(node, currentLayer);
            firstNode = false;
        } else {
            for(edge$iterator0 = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator0);){
                edge = castTo($next_0(edge$iterator0), 18);
                if (edge.source.owner.type_0 == ($clinit_LNode$NodeType(), NORMAL) && edge.source.owner.layer == currentLayer || edge.source.owner.type_0 == LABEL && castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(edge.source.owner).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner.layer == currentLayer) {
                    currentDummyLayer = new Layer(this$static.layeredGraph);
                    $add_3(this$static.layeredGraph.layers, currentDummyLayer);
                    currentLayer = new Layer(this$static.layeredGraph);
                    $add_3(this$static.layeredGraph.layers, currentLayer);
                }
            }
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                edge.source.owner.type_0 == ($clinit_LNode$NodeType(), LABEL) && !edge.source.owner.layer && $setLayer_0(edge.source.owner, currentDummyLayer);
            }
            $setLayer_0(node, currentLayer);
        }
    }
    this$static.layeredGraph.layerlessNodes.array.length = 0;
    toDelete = new ArrayList;
    for(layer$iterator0 = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        layer.nodes.array.length == 0 && push_1(toDelete.array, layer);
    }
    $removeAll_0(this$static.layeredGraph.layers, toDelete);
    layerId = 0;
    for(layer$iterator = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layer.id_0 = layerId;
        ++layerId;
    }
    monitor.done_1();
}
function BreadthFirstModelOrderLayerer() {
    $clinit_BreadthFirstModelOrderLayerer();
}
function lambda$0_28(n1_0, n2_1) {
    $clinit_BreadthFirstModelOrderLayerer();
    if ($hasProperty(n1_0, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(n2_1, MODEL_ORDER_1)) return compare_5(castTo($getProperty(n1_0, MODEL_ORDER_1), 17).value_0, castTo($getProperty(n2_1, MODEL_ORDER_1), 17).value_0);
    throw toJs(new UnsupportedGraphException('The BF model order layer assigner requires all real nodes to have a model order.'));
}
defineClass(1352, 1, $intern_110, BreadthFirstModelOrderLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_3(graph) {
    return castTo(graph, 36), BASELINE_PROCESSING_CONFIGURATION_0;
};
_.process = function process_59(thelayeredGraph, monitor) {
    $process_62(this, castTo(thelayeredGraph, 36), monitor);
};
var BASELINE_PROCESSING_CONFIGURATION_0;
var Lorg_eclipse_elk_alg_layered_p2layers_BreadthFirstModelOrderLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'BreadthFirstModelOrderLayerer', 1352);
function BreadthFirstModelOrderLayerer$lambda$0$Type() {}
defineClass(1353, 1, $intern_88, BreadthFirstModelOrderLayerer$lambda$0$Type);
_.compare_1 = function compare_57(arg0, arg1) {
    return lambda$0_28(castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_138(other) {
    return this === other;
};
_.reversed = function reversed_49() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p2layers_BreadthFirstModelOrderLayerer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'BreadthFirstModelOrderLayerer/lambda$0$Type', 1353);
function $clinit_CoffmanGrahamLayerer() {
    $clinit_CoffmanGrahamLayerer = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION_1 = $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
}
function $canAdd_0(n, l) {
    var e, e$iterator, v;
    for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        v = e.target.owner;
        if (v.layer == l) return false;
    }
    return true;
}
function $compareNodesInTopo(this$static, u, v) {
    var inListU, inLsitV, itU, itV, iu, iv;
    inListU = castTo($get(this$static.inTopo, u), 15);
    inLsitV = castTo($get(this$static.inTopo, v), 15);
    itU = inListU.listIterator_1(inListU.size_1());
    itV = inLsitV.listIterator_1(inLsitV.size_1());
    while(itU.hasPrevious() && itV.hasPrevious()){
        iu = castTo(itU.previous_0(), 17);
        iv = castTo(itV.previous_0(), 17);
        if (iu != iv) return compare_5(iu.value_0, iv.value_0);
    }
    return !itU.hasNext_0() && !itV.hasNext_0() ? 0 : itU.hasNext_0() ? 1 : -1;
}
function $createLayer(graph, layers) {
    var aLayer;
    aLayer = new Layer(graph);
    push_1(layers.array, aLayer);
    return aLayer;
}
function $dfs_4(this$static, start_0, v) {
    var out, out$iterator, transitive, transitive$iterator, w;
    if (this$static.nodeMark[v.id_0]) return;
    for(out$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(v).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(out$iterator);){
        out = castTo($next_0(out$iterator), 18);
        w = out.target.owner;
        for(transitive$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(w).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(transitive$iterator);){
            transitive = castTo($next_0(transitive$iterator), 18);
            transitive.source.owner == start_0 && (this$static.edgeMark[transitive.id_0] = true);
        }
        $dfs_4(this$static, start_0, w);
    }
    this$static.nodeMark[v.id_0] = true;
}
function $lambda$1_3(this$static, n1_0, n2_1) {
    return -compare_5(this$static.topoOrd[n1_0.id_0], this$static.topoOrd[n2_1.id_0]);
}
function $process_63(this$static, layeredGraph, progressMonitor) {
    var currentLayer, e, e$iterator, edgeIndex, i, index_0, j, layers, n, n$iterator, sinks, sources, src_0, tgt, u, v, v$iterator, v$iterator0, w;
    progressMonitor.begin('Coffman-Graham Layering', 1);
    if (layeredGraph.layerlessNodes.array.length == 0) {
        progressMonitor.done_1();
        return;
    }
    w = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), LAYERING_COFFMAN_GRAHAM_LAYER_BOUND_0)), 17).value_0;
    index_0 = 0;
    edgeIndex = 0;
    for(n$iterator = new ArrayList$1(layeredGraph.layerlessNodes); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 9);
        n.id_0 = index_0++;
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 18);
            e.id_0 = edgeIndex++;
        }
    }
    this$static.nodeMark = initUnidimensionalArray(Z_classLit, $intern_90, 30, index_0, 16, 1);
    this$static.edgeMark = initUnidimensionalArray(Z_classLit, $intern_90, 30, edgeIndex, 16, 1);
    this$static.inDeg = initUnidimensionalArray(I_classLit, $intern_48, 30, index_0, 15, 1);
    this$static.outDeg = initUnidimensionalArray(I_classLit, $intern_48, 30, index_0, 15, 1);
    this$static.topoOrd = initUnidimensionalArray(I_classLit, $intern_48, 30, index_0, 15, 1);
    $clear(this$static.inTopo);
    $transitiveReduction(this$static, layeredGraph);
    sources = new PriorityQueue(new CoffmanGrahamLayerer$0methodref$compareNodesInTopo$Type(this$static));
    for(v$iterator0 = new ArrayList$1(layeredGraph.layerlessNodes); v$iterator0.i < v$iterator0.this$01.array.length;){
        v = castTo($next_6(v$iterator0), 9);
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(v).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 18);
            this$static.edgeMark[e.id_0] || ++this$static.inDeg[v.id_0];
        }
        this$static.inDeg[v.id_0] == 0 && checkCriticalState_0($offer(sources, v), 'Unable to add element to queue');
    }
    i = 0;
    while(sources.heap.array.length != 0){
        v = castTo($poll_0(sources), 9);
        this$static.topoOrd[v.id_0] = i++;
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(v).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 18);
            if (this$static.edgeMark[e.id_0]) continue;
            tgt = e.target.owner;
            --this$static.inDeg[tgt.id_0];
            $put(this$static.inTopo, tgt, valueOf_3(this$static.topoOrd[v.id_0]));
            this$static.inDeg[tgt.id_0] == 0 && checkCriticalState_0($offer(sources, tgt), 'Unable to add element to queue');
        }
    }
    sinks = new PriorityQueue(new CoffmanGrahamLayerer$lambda$1$Type(this$static));
    for(v$iterator = new ArrayList$1(layeredGraph.layerlessNodes); v$iterator.i < v$iterator.this$01.array.length;){
        v = castTo($next_6(v$iterator), 9);
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(v).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 18);
            this$static.edgeMark[e.id_0] || ++this$static.outDeg[v.id_0];
        }
        this$static.outDeg[v.id_0] == 0 && checkCriticalState_0($offer(sinks, v), 'Unable to add element to queue');
    }
    layers = new ArrayList;
    currentLayer = $createLayer(layeredGraph, layers);
    while(sinks.heap.array.length != 0){
        u = castTo($poll_0(sinks), 9);
        (currentLayer.nodes.array.length >= w || !$canAdd_0(u, currentLayer)) && (currentLayer = $createLayer(layeredGraph, layers));
        $setLayer_0(u, currentLayer);
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(u).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 18);
            if (this$static.edgeMark[e.id_0]) continue;
            src_0 = e.source.owner;
            --this$static.outDeg[src_0.id_0];
            this$static.outDeg[src_0.id_0] == 0 && checkCriticalState_0($offer(sinks, src_0), 'Unable to add element to queue');
        }
    }
    for(j = layers.array.length - 1; j >= 0; --j)$add_3(layeredGraph.layers, (checkCriticalElementIndex(j, layers.array.length), castTo(layers.array[j], 25)));
    layeredGraph.layerlessNodes.array.length = 0;
    progressMonitor.done_1();
}
function $transitiveReduction(this$static, graph) {
    var out, out$iterator, start_0, start$iterator;
    for(start$iterator = new ArrayList$1(graph.layerlessNodes); start$iterator.i < start$iterator.this$01.array.length;){
        start_0 = castTo($next_6(start$iterator), 9);
        fill_2(this$static.nodeMark);
        for(out$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(start_0).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(out$iterator);){
            out = castTo($next_0(out$iterator), 18);
            $dfs_4(this$static, start_0, out.target.owner);
        }
    }
}
function CoffmanGrahamLayerer() {
    $clinit_CoffmanGrahamLayerer();
    this.inTopo = new ArrayListMultimap;
}
defineClass(1343, 1, $intern_110, CoffmanGrahamLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_4(graph) {
    return castTo(graph, 36), BASELINE_PROCESSING_CONFIGURATION_1;
};
_.process = function process_60(layeredGraph, progressMonitor) {
    $process_63(this, castTo(layeredGraph, 36), progressMonitor);
};
var BASELINE_PROCESSING_CONFIGURATION_1;
var Lorg_eclipse_elk_alg_layered_p2layers_CoffmanGrahamLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'CoffmanGrahamLayerer', 1343);
function CoffmanGrahamLayerer$0methodref$compareNodesInTopo$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1344, 1, $intern_88, CoffmanGrahamLayerer$0methodref$compareNodesInTopo$Type);
_.compare_1 = function compare_58(arg0, arg1) {
    return $compareNodesInTopo(this.$$outer_0, castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_139(other) {
    return this === other;
};
_.reversed = function reversed_50() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p2layers_CoffmanGrahamLayerer$0methodref$compareNodesInTopo$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'CoffmanGrahamLayerer/0methodref$compareNodesInTopo$Type', 1344);
function CoffmanGrahamLayerer$lambda$1$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1345, 1, $intern_88, CoffmanGrahamLayerer$lambda$1$Type);
_.compare_1 = function compare_59(arg0, arg1) {
    return $lambda$1_3(this.$$outer_0, castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_140(other) {
    return this === other;
};
_.reversed = function reversed_51() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p2layers_CoffmanGrahamLayerer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'CoffmanGrahamLayerer/lambda$1$Type', 1345);
function $clinit_DepthFirstModelOrderLayerer() {
    $clinit_DepthFirstModelOrderLayerer = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION_2 = $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
}
function $addNodeToLayer(this$static, layerId, node) {
    var edge, edge$iterator;
    if (layerId < this$static.layeredGraph.layers.array.length) {
        this$static.currentLayer = castTo($get_11(this$static.layeredGraph.layers, layerId), 25);
        this$static.currentDummyLayer = castTo($get_11(this$static.layeredGraph.layers, layerId - 1), 25);
        this$static.currentLayerId = layerId;
    } else {
        this$static.currentDummyLayer = new Layer(this$static.layeredGraph);
        this$static.currentDummyLayer.id_0 = layerId - 1;
        $add_3(this$static.layeredGraph.layers, this$static.currentDummyLayer);
        this$static.currentLayer = new Layer(this$static.layeredGraph);
        this$static.currentLayer.id_0 = layerId;
        $add_3(this$static.layeredGraph.layers, this$static.currentLayer);
        this$static.currentLayerId = layerId;
    }
    $setLayer_0(node, this$static.currentLayer);
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        !edge.source.owner.layer && edge.source.owner.type_0 == ($clinit_LNode$NodeType(), LABEL) && $setLayer_0(edge.source.owner, this$static.currentDummyLayer);
    }
}
function $getMaxConnectedLayer(layerId, node) {
    var edge, edge$iterator, maxLayer;
    maxLayer = layerId;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        !!edge.source.owner.layer && (maxLayer = $wnd.Math.max(maxLayer, edge.source.owner.layer.id_0));
    }
    return maxLayer;
}
function $isConnectedToCurrentLayer(this$static, node) {
    var connectedLayerViaDummy, connectedViaLabelDummy, directlyConnected, edge, edge$iterator;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        if (this$static.nodesToPlace.size_0 == 0) {
            directlyConnected = edge.source.owner.type_0 == ($clinit_LNode$NodeType(), NORMAL) && !!edge.source.owner.layer && edge.source.owner.layer.id_0 == this$static.currentLayerId;
            if ($hasNext_1(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(edge.source.owner).val$inputs1.iterator_0(), new Iterables$10)))) {
                connectedLayerViaDummy = castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(edge.source.owner).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner.layer;
                connectedViaLabelDummy = edge.source.owner.type_0 == LABEL && !!connectedLayerViaDummy && connectedLayerViaDummy.id_0 == this$static.currentLayerId;
            } else connectedViaLabelDummy = false;
        } else {
            directlyConnected = edge.source.owner.type_0 == ($clinit_LNode$NodeType(), NORMAL) && edge.source.owner.id_0 == this$static.currentLayerId;
            connectedViaLabelDummy = edge.source.owner.type_0 == LABEL && castTo($next_0(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(edge.source.owner).val$inputs1.iterator_0(), new Iterables$10))), 18).source.owner.id_0 == this$static.currentLayerId;
        }
        if (directlyConnected || connectedViaLabelDummy) return true;
    }
    return false;
}
function $placeNodesToPlace(this$static) {
    var dummyLayer, newLayer, nodeToPlace, nodeToPlace$iterator;
    this$static.maxToPlace = 0;
    for(nodeToPlace$iterator = $listIterator_2(this$static.nodesToPlace, 0); nodeToPlace$iterator.currentNode != nodeToPlace$iterator.this$01.tail;){
        nodeToPlace = castTo($next_9(nodeToPlace$iterator), 9);
        if (nodeToPlace.id_0 >= this$static.layeredGraph.layers.array.length) {
            dummyLayer = new Layer(this$static.layeredGraph);
            dummyLayer.id_0 = nodeToPlace.id_0 - 1;
            $add_3(this$static.layeredGraph.layers, dummyLayer);
            newLayer = new Layer(this$static.layeredGraph);
            newLayer.id_0 = nodeToPlace.id_0;
            $add_3(this$static.layeredGraph.layers, newLayer);
        }
        $setLayer_0(nodeToPlace, castTo($get_11(this$static.layeredGraph.layers, nodeToPlace.id_0), 25));
    }
}
function $process_64(this$static, thelayeredGraph, monitor) {
    var desiredLayer, edge, edge$iterator, firstNode, layer, layer$iterator, layer$iterator0, layerDiff, layerId, maxLayer, node, node$iterator, node$iterator0, realNodes, toDelete, toPlace, toPlace$iterator;
    monitor.begin('Depth first model order layering', 1);
    this$static.layeredGraph = thelayeredGraph;
    realNodes = new ArrayList;
    for(node$iterator0 = new ArrayList$1(this$static.layeredGraph.layerlessNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        node.type_0 == ($clinit_LNode$NodeType(), NORMAL) && push_1(realNodes.array, node);
    }
    $clinit_Collections();
    $sort(realNodes, new DepthFirstModelOrderLayerer$lambda$0$Type);
    firstNode = true;
    this$static.currentLayer = new Layer(this$static.layeredGraph);
    this$static.currentDummyLayer = null;
    $add_3(this$static.layeredGraph.layers, this$static.currentLayer);
    this$static.currentLayer.id_0 = 0;
    this$static.currentLayerId = 0;
    this$static.nodesToPlace = new LinkedList;
    for(node$iterator = new ArrayList$1(realNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (firstNode) {
            $setLayer_0(node, this$static.currentLayer);
            firstNode = false;
        } else if ($isConnectedToCurrentLayer(this$static, node)) {
            maxLayer = this$static.currentLayerId;
            maxLayer = $getMaxConnectedLayer(maxLayer, node);
            desiredLayer = maxLayer + 2;
            layerDiff = maxLayer - this$static.currentLayerId;
            if (this$static.nodesToPlace.size_0 == 0) $addNodeToLayer(this$static, desiredLayer, node);
            else if (layerDiff > 0) {
                for(toPlace$iterator = $listIterator_2(this$static.nodesToPlace, 0); toPlace$iterator.currentNode != toPlace$iterator.this$01.tail;){
                    toPlace = castTo($next_9(toPlace$iterator), 9);
                    toPlace.id_0 += maxLayer - this$static.maxToPlace;
                }
                $placeNodesToPlace(this$static);
                $reset_0(this$static.nodesToPlace);
                $addNodeToLayer(this$static, desiredLayer, node);
            } else {
                $add_7(this$static.nodesToPlace, node);
                node.id_0 = desiredLayer;
                this$static.maxToPlace = $wnd.Math.max(this$static.maxToPlace, desiredLayer);
                for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                    edge = castTo($next_0(edge$iterator), 18);
                    if (!edge.source.owner.layer && edge.source.owner.type_0 == ($clinit_LNode$NodeType(), LABEL)) {
                        $add_7(this$static.nodesToPlace, edge.source.owner);
                        edge.source.owner.id_0 = desiredLayer - 1;
                    }
                }
                this$static.currentLayerId = desiredLayer;
            }
        } else {
            $placeNodesToPlace(this$static);
            $reset_0(this$static.nodesToPlace);
            desiredLayer = 0;
            if ($hasNext_1(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)))) {
                maxLayer = 0;
                maxLayer = $getMaxConnectedLayer(maxLayer, node);
                desiredLayer = maxLayer + 2;
                $addNodeToLayer(this$static, desiredLayer, node);
            } else {
                $add_7(this$static.nodesToPlace, node);
                node.id_0 = 0;
                this$static.maxToPlace = $wnd.Math.max(this$static.maxToPlace, 0);
                this$static.currentLayer = castTo($get_11(this$static.layeredGraph.layers, 0), 25);
                this$static.currentLayerId = 0;
            }
        }
    }
    this$static.nodesToPlace.size_0 == 0 || $placeNodesToPlace(this$static);
    this$static.layeredGraph.layerlessNodes.array.length = 0;
    toDelete = new ArrayList;
    for(layer$iterator0 = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        layer.nodes.array.length == 0 && push_1(toDelete.array, layer);
    }
    $removeAll_0(this$static.layeredGraph.layers, toDelete);
    layerId = 0;
    for(layer$iterator = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layer.id_0 = layerId;
        ++layerId;
    }
    monitor.done_1();
}
function DepthFirstModelOrderLayerer() {
    $clinit_DepthFirstModelOrderLayerer();
}
function lambda$0_29(n1_0, n2_1) {
    $clinit_DepthFirstModelOrderLayerer();
    if ($hasProperty(n1_0, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(n2_1, MODEL_ORDER_1)) return compare_5(castTo($getProperty(n1_0, MODEL_ORDER_1), 17).value_0, castTo($getProperty(n2_1, MODEL_ORDER_1), 17).value_0);
    throw toJs(new UnsupportedGraphException('The DF model order layer assigner requires all real nodes to have a model order.'));
}
defineClass(1354, 1, $intern_110, DepthFirstModelOrderLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_5(graph) {
    return castTo(graph, 36), BASELINE_PROCESSING_CONFIGURATION_2;
};
_.process = function process_61(thelayeredGraph, monitor) {
    $process_64(this, castTo(thelayeredGraph, 36), monitor);
};
_.currentLayerId = 0;
_.maxToPlace = 0;
var BASELINE_PROCESSING_CONFIGURATION_2;
var Lorg_eclipse_elk_alg_layered_p2layers_DepthFirstModelOrderLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'DepthFirstModelOrderLayerer', 1354);
function DepthFirstModelOrderLayerer$lambda$0$Type() {}
defineClass(1355, 1, $intern_88, DepthFirstModelOrderLayerer$lambda$0$Type);
_.compare_1 = function compare_60(arg0, arg1) {
    return lambda$0_29(castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_141(other) {
    return this === other;
};
_.reversed = function reversed_52() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p2layers_DepthFirstModelOrderLayerer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'DepthFirstModelOrderLayerer/lambda$0$Type', 1355);
function $checkNode(node1, graph) {
    var edge, edge$iterator, layer1, layer2, newIndex, newLayer, node2, port, port$iterator, shiftNodes;
    node1.id_0 = 1;
    layer1 = node1.layer;
    shiftNodes = new LinkedHashSet;
    for(port$iterator = $getPorts(node1, ($clinit_PortType(), OUTPUT)).iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            node2 = edge.target.owner;
            if (node1 != node2) {
                layer2 = node2.layer;
                if (layer2.id_0 <= layer1.id_0) {
                    newIndex = layer1.id_0 + 1;
                    if (newIndex == graph.layers.array.length) {
                        newLayer = new Layer(graph);
                        newLayer.id_0 = newIndex;
                        $add_3(graph.layers, newLayer);
                        $setLayer_0(node2, newLayer);
                    } else {
                        newLayer = castTo($get_11(graph.layers, newIndex), 25);
                        $setLayer_0(node2, newLayer);
                    }
                    shiftNodes.map_0.put(node2, shiftNodes);
                }
            }
        }
    }
    return shiftNodes;
}
function $process_65(layeredGraph, monitor) {
    var currentSpans, foundSpan, layer, layerIterator, layers, maxx, minx, nextIndex, node, node$iterator, node$iterator0, node$iterator1, nodeToCheck, shiftedNodes, span_0, span$iterator, spanIter;
    monitor.begin('Interactive node layering', 1);
    currentSpans = new ArrayList;
    for(node$iterator0 = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        minx = node.pos.x_0;
        maxx = minx + node.size_0.x_0;
        maxx = $wnd.Math.max(minx + 1, maxx);
        spanIter = new AbstractList$ListIteratorImpl(currentSpans, 0);
        foundSpan = null;
        while(spanIter.i < spanIter.this$01_0.size_1()){
            span_0 = (checkCriticalElement(spanIter.i < spanIter.this$01_0.size_1()), castTo(spanIter.this$01_0.get_0(spanIter.last = spanIter.i++), 560));
            if (span_0.start_0 >= maxx) {
                checkCriticalElement(spanIter.i > 0);
                spanIter.this$01.get_0(spanIter.last = --spanIter.i);
                break;
            } else if (span_0.end > minx) {
                if (!foundSpan) {
                    $add_3(span_0.nodes, node);
                    span_0.start_0 = $wnd.Math.min(span_0.start_0, minx);
                    span_0.end = $wnd.Math.max(span_0.end, maxx);
                    foundSpan = span_0;
                } else {
                    $addAll_2(foundSpan.nodes, span_0.nodes);
                    foundSpan.end = $wnd.Math.max(foundSpan.end, span_0.end);
                    $remove_8(spanIter);
                }
            }
        }
        if (!foundSpan) {
            foundSpan = new InteractiveLayerer$LayerSpan;
            foundSpan.start_0 = minx;
            foundSpan.end = maxx;
            $add_1(spanIter, foundSpan);
            $add_3(foundSpan.nodes, node);
        }
    }
    layers = layeredGraph.layers;
    nextIndex = 0;
    for(span$iterator = new ArrayList$1(currentSpans); span$iterator.i < span$iterator.this$01.array.length;){
        span_0 = castTo($next_6(span$iterator), 560);
        layer = new Layer(layeredGraph);
        layer.id_0 = nextIndex++;
        push_1(layers.array, layer);
        for(node$iterator1 = new ArrayList$1(span_0.nodes); node$iterator1.i < node$iterator1.this$01.array.length;){
            node = castTo($next_6(node$iterator1), 9);
            $setLayer_0(node, layer);
            node.id_0 = 0;
        }
    }
    for(node$iterator = new ArrayList$1(layeredGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.id_0 == 0) {
            shiftedNodes = $checkNode(node, layeredGraph);
            while(shiftedNodes.map_0.size_1() != 0){
                nodeToCheck = castTo(shiftedNodes.map_0.keySet_0().iterator_0().next_1(), 9);
                shiftedNodes.map_0.remove_0(nodeToCheck);
                $addAll(shiftedNodes, $checkNode(nodeToCheck, layeredGraph));
            }
        }
    }
    layerIterator = new AbstractList$ListIteratorImpl(layers, 0);
    while(layerIterator.i < layerIterator.this$01_0.size_1())(checkCriticalElement(layerIterator.i < layerIterator.this$01_0.size_1()), castTo(layerIterator.this$01_0.get_0(layerIterator.last = layerIterator.i++), 25)).nodes.array.length == 0 && $remove_8(layerIterator);
    layeredGraph.layerlessNodes.array.length = 0;
    monitor.done_1();
}
function InteractiveLayerer() {}
defineClass(1346, 1, $intern_110, InteractiveLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_6(graph) {
    return castTo(graph, 36), $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), INTERACTIVE_EXTERNAL_PORT_POSITIONER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
};
_.process = function process_62(layeredGraph, monitor) {
    $process_65(castTo(layeredGraph, 36), monitor);
};
var Lorg_eclipse_elk_alg_layered_p2layers_InteractiveLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'InteractiveLayerer', 1346);
function InteractiveLayerer$LayerSpan() {
    this.nodes = new ArrayList;
}
defineClass(560, 1, {
    560: 1
}, InteractiveLayerer$LayerSpan);
_.end = 0;
_.start_0 = 0;
var Lorg_eclipse_elk_alg_layered_p2layers_InteractiveLayerer$LayerSpan_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'InteractiveLayerer/LayerSpan', 560);
function $clinit_LongestPathLayerer() {
    $clinit_LongestPathLayerer = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION_3 = $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
}
function $process_66(this$static, thelayeredGraph, monitor) {
    var index_0, node, node$iterator, node$iterator0, nodes;
    monitor.begin('Longest path layering', 1);
    this$static.layeredGraph = thelayeredGraph;
    nodes = this$static.layeredGraph.layerlessNodes;
    this$static.nodeHeights = initUnidimensionalArray(I_classLit, $intern_48, 30, nodes.array.length, 15, 1);
    index_0 = 0;
    for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        node.id_0 = index_0;
        this$static.nodeHeights[index_0] = -1;
        ++index_0;
    }
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $visit(this$static, node);
    }
    nodes.array.length = 0;
    this$static.layeredGraph = null;
    this$static.nodeHeights = null;
    monitor.done_1();
}
function $putNode(this$static, node, height) {
    var i, layers;
    layers = this$static.layeredGraph.layers;
    for(i = layers.array.length; i < height; i++)$add_2(layers, 0, new Layer(this$static.layeredGraph));
    $setLayer_0(node, castTo($get_11(layers, layers.array.length - height), 25));
    this$static.nodeHeights[node.id_0] = height;
}
function $visit(this$static, node) {
    var edge, edge$iterator, height, maxHeight, port, port$iterator, targetHeight, targetNode;
    height = this$static.nodeHeights[node.id_0];
    if (height >= 0) return height;
    else {
        maxHeight = 1;
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                targetNode = edge.target.owner;
                if (node != targetNode) {
                    targetHeight = $visit(this$static, targetNode);
                    maxHeight = $wnd.Math.max(maxHeight, targetHeight + 1);
                }
            }
        }
        $putNode(this$static, node, maxHeight);
        return maxHeight;
    }
}
function LongestPathLayerer() {
    $clinit_LongestPathLayerer();
}
defineClass(1342, 1, $intern_110, LongestPathLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_7(graph) {
    return castTo(graph, 36), BASELINE_PROCESSING_CONFIGURATION_3;
};
_.process = function process_63(thelayeredGraph, monitor) {
    $process_66(this, castTo(thelayeredGraph, 36), monitor);
};
var BASELINE_PROCESSING_CONFIGURATION_3;
var Lorg_eclipse_elk_alg_layered_p2layers_LongestPathLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'LongestPathLayerer', 1342);
function $clinit_LongestPathSourceLayerer() {
    $clinit_LongestPathSourceLayerer = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION_4 = $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
}
function $process_67(this$static, thelayeredGraph, monitor) {
    var index_0, node, node$iterator, node$iterator0, nodes;
    monitor.begin('Longest path to source layering', 1);
    this$static.layeredGraph = thelayeredGraph;
    nodes = this$static.layeredGraph.layerlessNodes;
    this$static.nodeHeights = initUnidimensionalArray(I_classLit, $intern_48, 30, nodes.array.length, 15, 1);
    index_0 = 0;
    for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        node.id_0 = index_0;
        this$static.nodeHeights[index_0] = -1;
        ++index_0;
    }
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $visit_0(this$static, node);
    }
    nodes.array.length = 0;
    this$static.layeredGraph = null;
    this$static.nodeHeights = null;
    monitor.done_1();
}
function $putNode_0(this$static, node, height) {
    var i, layers;
    layers = this$static.layeredGraph.layers;
    for(i = layers.array.length; i < height; i++)$add_2(layers, layers.array.length, new Layer(this$static.layeredGraph));
    $setLayer_0(node, (checkCriticalElementIndex(height - 1, layers.array.length), castTo(layers.array[height - 1], 25)));
    this$static.nodeHeights[node.id_0] = height;
}
function $visit_0(this$static, node) {
    var edge, edge$iterator, height, maxHeight, port, port$iterator, sourceHeight, sourceNode;
    height = this$static.nodeHeights[node.id_0];
    if (height >= 0) return height;
    else {
        maxHeight = 1;
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                sourceNode = edge.source.owner;
                if (node != sourceNode) {
                    sourceHeight = $visit_0(this$static, sourceNode);
                    maxHeight = $wnd.Math.max(maxHeight, sourceHeight + 1);
                }
            }
        }
        $putNode_0(this$static, node, maxHeight);
        return maxHeight;
    }
}
function LongestPathSourceLayerer() {
    $clinit_LongestPathSourceLayerer();
}
defineClass(1351, 1, $intern_110, LongestPathSourceLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_8(graph) {
    return castTo(graph, 36), BASELINE_PROCESSING_CONFIGURATION_4;
};
_.process = function process_64(thelayeredGraph, monitor) {
    $process_67(this, castTo(thelayeredGraph, 36), monitor);
};
var BASELINE_PROCESSING_CONFIGURATION_4;
var Lorg_eclipse_elk_alg_layered_p2layers_LongestPathSourceLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'LongestPathSourceLayerer', 1351);
function $clinit_MinWidthLayerer() {
    $clinit_MinWidthLayerer = emptyMethod;
    UPPERBOUND_ON_WIDTH_RANGE = closed_0(valueOf_3(1), valueOf_3(4));
    COMPENSATOR_RANGE = closed_0(valueOf_3(1), valueOf_3(2));
}
function $computeMinWidthLayering(this$static, upperBoundOnWidth, compensator, nodes, nodeSuccessors) {
    var alreadyPlacedInCurrentLayer, alreadyPlacedInOtherLayers, currentLayer, currentNode, currentSpanningEdges, goingOutFromThisLayer, inDeg, layers, maxWidth, outDeg, realWidth, ubwConsiderSize, unplacedNodes, widthCurrent, widthUp;
    layers = new ArrayList;
    unplacedNodes = newLinkedHashSet(nodes);
    ubwConsiderSize = upperBoundOnWidth * this$static.avgSize;
    inDeg = 0;
    outDeg = 0;
    alreadyPlacedInCurrentLayer = new HashSet;
    alreadyPlacedInOtherLayers = new HashSet;
    currentLayer = new ArrayList;
    widthCurrent = 0;
    widthUp = 0;
    maxWidth = 0;
    realWidth = 0;
    currentSpanningEdges = 0;
    goingOutFromThisLayer = 0;
    while(unplacedNodes.map_0.size_1() != 0){
        currentNode = $selectNode(unplacedNodes, nodeSuccessors, alreadyPlacedInOtherLayers);
        if (currentNode) {
            unplacedNodes.map_0.remove_0(currentNode);
            push_1(currentLayer.array, currentNode);
            alreadyPlacedInCurrentLayer.map_0.put(currentNode, alreadyPlacedInCurrentLayer);
            outDeg = this$static.outDegree[currentNode.id_0];
            widthCurrent += this$static.normSize[currentNode.id_0] - outDeg * this$static.dummySize;
            inDeg = this$static.inDegree[currentNode.id_0];
            widthUp += inDeg * this$static.dummySize;
            goingOutFromThisLayer += outDeg * this$static.dummySize;
            realWidth += this$static.normSize[currentNode.id_0];
        }
        if (!currentNode || unplacedNodes.map_0.size_1() == 0 || widthCurrent >= ubwConsiderSize && this$static.normSize[currentNode.id_0] > outDeg * this$static.dummySize || widthUp >= compensator * ubwConsiderSize) {
            push_1(layers.array, currentLayer);
            currentLayer = new ArrayList;
            $addAll(alreadyPlacedInOtherLayers, alreadyPlacedInCurrentLayer);
            alreadyPlacedInCurrentLayer.map_0.clear_0();
            currentSpanningEdges -= goingOutFromThisLayer;
            maxWidth = $wnd.Math.max(maxWidth, currentSpanningEdges * this$static.dummySize + realWidth);
            currentSpanningEdges += widthUp;
            widthCurrent = widthUp;
            widthUp = 0;
            goingOutFromThisLayer = 0;
            realWidth = 0;
        }
    }
    return new Pair(maxWidth, layers);
}
function $countEdgesExceptSelfLoops(edges) {
    var edge, edge$iterator, i;
    i = 0;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(edges.val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        edge.source.owner == edge.target.owner || ++i;
    }
    return i;
}
function $precalcSuccessors(nodes) {
    var edge, edge$iterator, node, node$iterator, outEdges, outNodes, successors;
    successors = newArrayListWithCapacity(nodes.array.length);
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        outNodes = new HashSet;
        outEdges = $getOutgoingEdges(node);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(outEdges.val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            edge.source.owner == edge.target.owner || $add_6(outNodes, edge.target.owner);
        }
        push_1(successors.array, outNodes);
    }
    return successors;
}
function $process_68(this$static, layeredGraph, progressMonitor) {
    var c, cEnd, cStart, candidateLayering, compensator, currentLayer, i, layerList, layerList$iterator, layering, layers, minNumOfLayers, minWidth, newNumOfLayers, newWidth, node, node$iterator, node$iterator0, node$iterator1, nodeSuccessors, notInserted, numOfNodes, result, size_0, ubw, ubwEnd, ubwStart, upperBoundOnWidth;
    progressMonitor.begin('MinWidth layering', 1);
    layers = layeredGraph.layers;
    notInserted = layeredGraph.layerlessNodes;
    upperBoundOnWidth = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), LAYERING_MIN_WIDTH_UPPER_BOUND_ON_WIDTH_0)), 17).value_0;
    compensator = castTo($getProperty(layeredGraph, LAYERING_MIN_WIDTH_UPPER_LAYER_ESTIMATION_SCALING_FACTOR_0), 17).value_0;
    this$static.dummySize = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_EDGE)));
    this$static.minimumNodeSize = $intern_60;
    for(node$iterator0 = new ArrayList$1(notInserted); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), NORMAL)) continue;
        size_0 = node.size_0.y_0;
        this$static.minimumNodeSize = $wnd.Math.min(this$static.minimumNodeSize, size_0);
    }
    this$static.minimumNodeSize = $wnd.Math.max(1, this$static.minimumNodeSize);
    numOfNodes = notInserted.array.length;
    this$static.inDegree = initUnidimensionalArray(I_classLit, $intern_48, 30, numOfNodes, 15, 1);
    this$static.outDegree = initUnidimensionalArray(I_classLit, $intern_48, 30, numOfNodes, 15, 1);
    this$static.normSize = initUnidimensionalArray(D_classLit, $intern_66, 30, numOfNodes, 15, 1);
    i = 0;
    this$static.avgSize = 0;
    for(node$iterator1 = new ArrayList$1(notInserted); node$iterator1.i < node$iterator1.this$01.array.length;){
        node = castTo($next_6(node$iterator1), 9);
        node.id_0 = i++;
        this$static.inDegree[node.id_0] = $countEdgesExceptSelfLoops($getIncomingEdges(node));
        this$static.outDegree[node.id_0] = $countEdgesExceptSelfLoops($getOutgoingEdges(node));
        this$static.normSize[node.id_0] = node.size_0.y_0 / this$static.minimumNodeSize;
        this$static.avgSize += this$static.normSize[node.id_0];
    }
    this$static.dummySize /= this$static.minimumNodeSize;
    this$static.avgSize /= numOfNodes;
    nodeSuccessors = $precalcSuccessors(notInserted);
    $sort(notInserted, reverseOrder_0(new MinWidthLayerer$MinOutgoingEdgesComparator(this$static)));
    minWidth = $intern_60;
    minNumOfLayers = $intern_0;
    candidateLayering = null;
    ubwStart = upperBoundOnWidth;
    ubwEnd = upperBoundOnWidth;
    cStart = compensator;
    cEnd = compensator;
    if (upperBoundOnWidth < 0) {
        ubwStart = castTo(UPPERBOUND_ON_WIDTH_RANGE.lowerBound.endpoint_0(), 17).value_0;
        ubwEnd = castTo(UPPERBOUND_ON_WIDTH_RANGE.upperBound.endpoint_0(), 17).value_0;
    }
    if (compensator < 0) {
        cStart = castTo(COMPENSATOR_RANGE.lowerBound.endpoint_0(), 17).value_0;
        cEnd = castTo(COMPENSATOR_RANGE.upperBound.endpoint_0(), 17).value_0;
    }
    for(ubw = ubwStart; ubw <= ubwEnd; ubw++)for(c = cStart; c <= cEnd; c++){
        result = $computeMinWidthLayering(this$static, ubw, c, notInserted, nodeSuccessors);
        newWidth = $doubleValue(castToDouble(result.first));
        layering = castTo(result.second, 15);
        newNumOfLayers = layering.size_1();
        if (newWidth < minWidth || newWidth == minWidth && newNumOfLayers < minNumOfLayers) {
            minWidth = newWidth;
            minNumOfLayers = newNumOfLayers;
            candidateLayering = layering;
        }
    }
    for(layerList$iterator = candidateLayering.iterator_0(); layerList$iterator.hasNext_0();){
        layerList = castTo(layerList$iterator.next_1(), 15);
        currentLayer = new Layer(layeredGraph);
        for(node$iterator = layerList.iterator_0(); node$iterator.hasNext_0();){
            node = castTo(node$iterator.next_1(), 9);
            $setLayer_0(node, currentLayer);
        }
        push_1(layers.array, currentLayer);
    }
    reverse_2(layers);
    notInserted.array.length = 0;
    progressMonitor.done_1();
}
function $selectNode(nodes, successors, targets) {
    var node, node$iterator;
    for(node$iterator = nodes.map_0.keySet_0().iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 9);
        if ($containsAll(targets, castTo($get_11(successors, node.id_0), 16))) return node;
    }
    return null;
}
function MinWidthLayerer() {
    $clinit_MinWidthLayerer();
}
defineClass(1349, 1, $intern_110, MinWidthLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_9(graph) {
    return castTo(graph, 36), $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
};
_.process = function process_65(layeredGraph, progressMonitor) {
    $process_68(this, castTo(layeredGraph, 36), progressMonitor);
};
_.avgSize = 0;
_.dummySize = 0;
_.minimumNodeSize = 0;
var COMPENSATOR_RANGE, UPPERBOUND_ON_WIDTH_RANGE;
var Lorg_eclipse_elk_alg_layered_p2layers_MinWidthLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'MinWidthLayerer', 1349);
function $compare_15(this$static, o1, o2) {
    var outs1, outs2;
    outs1 = this$static.this$01.outDegree[o1.id_0];
    outs2 = this$static.this$01.outDegree[o2.id_0];
    if (outs1 < outs2) return -1;
    if (outs1 == outs2) return 0;
    return 1;
}
function MinWidthLayerer$MinOutgoingEdgesComparator(this$0) {
    this.this$01 = this$0;
}
defineClass(1350, 1, $intern_88, MinWidthLayerer$MinOutgoingEdgesComparator);
_.compare_1 = function compare_61(o1, o2) {
    return $compare_15(this, castTo(o1, 9), castTo(o2, 9));
};
_.equals_0 = function equals_142(other) {
    return this === other;
};
_.reversed = function reversed_53() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p2layers_MinWidthLayerer$MinOutgoingEdgesComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'MinWidthLayerer/MinOutgoingEdgesComparator', 1350);
function $clinit_NetworkSimplexLayerer() {
    $clinit_NetworkSimplexLayerer = emptyMethod;
    BASELINE_PROCESSING_CONFIGURATION_5 = $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
}
function $connectedComponents(this$static, theNodes) {
    var components, counter, node, node$iterator, node$iterator0;
    this$static.nodeVisited == null || this$static.nodeVisited.length < theNodes.array.length ? this$static.nodeVisited = initUnidimensionalArray(Z_classLit, $intern_90, 30, theNodes.array.length, 16, 1) : fill_2(this$static.nodeVisited);
    this$static.componentNodes = new ArrayList;
    counter = 0;
    for(node$iterator0 = new ArrayList$1(theNodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        node.id_0 = counter++;
    }
    components = new LinkedList;
    for(node$iterator = new ArrayList$1(theNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (!this$static.nodeVisited[node.id_0]) {
            $connectedComponentsDFS(this$static, node);
            components.size_0 == 0 || (checkCriticalElement(components.size_0 != 0), castTo(components.header.next_0.value_0, 15)).size_1() < this$static.componentNodes.array.length ? $addFirst_0(components, this$static.componentNodes) : $addLast_0(components, this$static.componentNodes);
            this$static.componentNodes = new ArrayList;
        }
    }
    return components;
}
function $connectedComponentsDFS(this$static, node) {
    var edge, edge$iterator, opposite, port, port$iterator;
    this$static.nodeVisited[node.id_0] = true;
    $add_3(this$static.componentNodes, node);
    for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
            edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
            opposite = $getOpposite(port, edge).owner;
            this$static.nodeVisited[opposite.id_0] || $connectedComponentsDFS(this$static, opposite);
        }
    }
}
function $getOpposite(port, edge) {
    if (edge.source == port) return edge.target;
    else if (edge.target == port) return edge.source;
    throw toJs(new IllegalArgumentException_0('Input edge is not connected to the input port.'));
}
function $initialize_4(theNodes) {
    var graph, lEdge, lEdge$iterator, lNode, lNode$iterator, lNode$iterator0, nNode, nodeMap;
    nodeMap = new HashMap;
    graph = new NGraph;
    for(lNode$iterator0 = theNodes.iterator_0(); lNode$iterator0.hasNext_0();){
        lNode = castTo(lNode$iterator0.next_1(), 9);
        nNode = $create_2($origin_0(new NNode$NNodeBuilder, lNode), graph);
        $put_9(nodeMap.hashCodeMap, lNode, nNode);
    }
    for(lNode$iterator = theNodes.iterator_0(); lNode$iterator.hasNext_0();){
        lNode = castTo(lNode$iterator.next_1(), 9);
        for(lEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(lEdge$iterator);){
            lEdge = castTo($next_0(lEdge$iterator), 18);
            if ($isSelfLoop(lEdge)) continue;
            $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, $wnd.Math.max(1, castTo($getProperty(lEdge, ($clinit_LayeredOptions(), PRIORITY_SHORTNESS_0)), 17).value_0)), 1), castTo($get_10(nodeMap, lEdge.source.owner), 123)), castTo($get_10(nodeMap, lEdge.target.owner), 123)));
        }
    }
    return graph;
}
function $process_69(this$static, theLayeredGraph, monitor) {
    var connComp, connComp$iterator, connectedComponents, graph, iterLimit, l, l$iterator, lNode, layerIdx, layers, nNode, nNode$iterator, previousLayeringNodeCounts, theNodes, thoroughness;
    monitor.begin('Network simplex layering', 1);
    this$static.layeredGraph = theLayeredGraph;
    thoroughness = castTo($getProperty(theLayeredGraph, ($clinit_LayeredOptions(), THOROUGHNESS_0)), 17).value_0 * 4;
    theNodes = this$static.layeredGraph.layerlessNodes;
    if (theNodes.array.length < 1) {
        monitor.done_1();
        return;
    }
    connectedComponents = $connectedComponents(this$static, theNodes);
    previousLayeringNodeCounts = null;
    for(connComp$iterator = $listIterator_2(connectedComponents, 0); connComp$iterator.currentNode != connComp$iterator.this$01.tail;){
        connComp = castTo($next_9(connComp$iterator), 15);
        iterLimit = thoroughness * round_int($wnd.Math.sqrt(connComp.size_1()));
        graph = $initialize_4(connComp);
        $execute_0($withBalancing($withPreviousLayering($withIterationLimit(forGraph(graph), iterLimit), previousLayeringNodeCounts), true), monitor.subTask(1));
        layers = this$static.layeredGraph.layers;
        for(nNode$iterator = new ArrayList$1(graph.nodes); nNode$iterator.i < nNode$iterator.this$01.array.length;){
            nNode = castTo($next_6(nNode$iterator), 123);
            while(layers.array.length <= nNode.layer)$add_2(layers, layers.array.length, new Layer(this$static.layeredGraph));
            lNode = castTo(nNode.origin_0, 9);
            $setLayer_0(lNode, castTo($get_11(layers, nNode.layer), 25));
        }
        if (connectedComponents.size_0 > 1) {
            previousLayeringNodeCounts = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.layeredGraph.layers.array.length, 15, 1);
            layerIdx = 0;
            for(l$iterator = new ArrayList$1(this$static.layeredGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
                l = castTo($next_6(l$iterator), 25);
                previousLayeringNodeCounts[layerIdx++] = l.nodes.array.length;
            }
        }
    }
    theNodes.array.length = 0;
    this$static.componentNodes = null;
    this$static.layeredGraph = null;
    this$static.nodeVisited = null;
    monitor.done_1();
}
function NetworkSimplexLayerer() {
    $clinit_NetworkSimplexLayerer();
}
defineClass(1341, 1, $intern_110, NetworkSimplexLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_10(graph) {
    return castTo(graph, 36), BASELINE_PROCESSING_CONFIGURATION_5;
};
_.process = function process_66(theLayeredGraph, monitor) {
    $process_69(this, castTo(theLayeredGraph, 36), monitor);
};
var BASELINE_PROCESSING_CONFIGURATION_5;
var Lorg_eclipse_elk_alg_layered_p2layers_NetworkSimplexLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'NetworkSimplexLayerer', 1341);
function $computeDegrees(this$static) {
    var node, node$iterator;
    this$static.inDegree = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.sortedLayerlessNodes.array.length, 15, 1);
    this$static.outDegree = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.sortedLayerlessNodes.array.length, 15, 1);
    for(node$iterator = new ArrayList$1(this$static.sortedLayerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        this$static.inDegree[node.id_0] = size_24(new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
        this$static.outDegree[node.id_0] = size_24(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
    }
}
function $computeNormalizedSize(this$static) {
    var node, node$iterator;
    this$static.normSize = initUnidimensionalArray(D_classLit, $intern_66, 30, this$static.sortedLayerlessNodes.array.length, 15, 1);
    for(node$iterator = new ArrayList$1(this$static.sortedLayerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        this$static.normSize[node.id_0] = node.size_0.y_0 / this$static.minimumNodeSize;
    }
}
function $computeSortedNodes(this$static) {
    var node, node$iterator, unsortedNodes;
    unsortedNodes = this$static.currentGraph.layerlessNodes;
    this$static.sortedLayerlessNodes = (checkNotNull(unsortedNodes), new ArrayList_1(unsortedNodes));
    for(node$iterator = new ArrayList$1(unsortedNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        node.id_0 = $getRank(node).value_0;
    }
    $clinit_Collections();
    $sort(this$static.sortedLayerlessNodes, new StretchWidthLayerer$1);
}
function $computeSuccessors(this$static) {
    var currSucc, edge, edge$iterator, i, node, node$iterator;
    i = 0;
    this$static.successors = new ArrayList;
    currSucc = new HashSet;
    for(node$iterator = new ArrayList$1(this$static.sortedLayerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        node.id_0 = i;
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            $add_6(currSucc, edge.target.owner);
        }
        currSucc.map_0.remove_0(node);
        $add_3(this$static.successors, new HashSet_1(currSucc));
        currSucc.map_0.clear_0();
        ++i;
    }
}
function $conditionGoUp(this$static) {
    var a, b;
    a = this$static.widthCurrent - this$static.outDegree[this$static.selectedNode.id_0] * this$static.dummySize + this$static.normSize[this$static.selectedNode.id_0] > this$static.maxWidth;
    b = this$static.widthUp + this$static.inDegree[this$static.selectedNode.id_0] * this$static.dummySize > this$static.maxWidth * this$static.upperLayerInfluence * this$static.dummySize;
    return a || b;
}
function $getAverageOutDegree(this$static) {
    var allOut, node, node$iterator;
    allOut = 0;
    for(node$iterator = new ArrayList$1(this$static.currentGraph.layerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        allOut += size_24(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
    }
    return allOut / this$static.currentGraph.layerlessNodes.array.length;
}
function $getRank(node) {
    var max_0, pre, preEdge, preEdge$iterator, temp;
    max_0 = size_24(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
    for(preEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(preEdge$iterator);){
        preEdge = castTo($next_0(preEdge$iterator), 18);
        pre = preEdge.source.owner;
        temp = size_24(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(pre).val$inputs1.iterator_0(), new Iterables$10)));
        max_0 = $wnd.Math.max(max_0, temp);
    }
    return valueOf_3(max_0);
}
function $minMaxNodeSize(this$static) {
    var node, node$iterator, size_0;
    for(node$iterator = new ArrayList$1(this$static.sortedLayerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (node.type_0 != ($clinit_LNode$NodeType(), NORMAL)) continue;
        size_0 = node.size_0.y_0;
        this$static.minimumNodeSize = $wnd.Math.min(this$static.minimumNodeSize, size_0);
        this$static.maximumNodeSize = $wnd.Math.max(this$static.maximumNodeSize, size_0);
    }
}
function $process_70(this$static, layeredGraph, progressMonitor) {
    var currentLayer;
    progressMonitor.begin('StretchWidth layering', 1);
    if (layeredGraph.layerlessNodes.array.length == 0) {
        progressMonitor.done_1();
        return;
    }
    this$static.currentGraph = layeredGraph;
    this$static.widthCurrent = 0;
    this$static.widthUp = 0;
    this$static.minimumNodeSize = $intern_60;
    this$static.maximumNodeSize = $intern_61;
    this$static.dummySize = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE))));
    $computeSortedNodes(this$static);
    $computeSuccessors(this$static);
    $computeDegrees(this$static);
    $minMaxNodeSize(this$static);
    $computeNormalizedSize(this$static);
    this$static.minimumNodeSize = $wnd.Math.max(1, this$static.minimumNodeSize);
    this$static.maximumNodeSize = $wnd.Math.max(1, this$static.maximumNodeSize);
    this$static.dummySize = this$static.dummySize / this$static.minimumNodeSize;
    this$static.maxWidth = this$static.maximumNodeSize / this$static.minimumNodeSize;
    this$static.upperLayerInfluence = $getAverageOutDegree(this$static);
    currentLayer = new Layer(this$static.currentGraph);
    $add_3(this$static.currentGraph.layers, currentLayer);
    this$static.tempLayerlessNodes = newArrayList(this$static.sortedLayerlessNodes);
    this$static.remainingOutGoing = copyOf(this$static.outDegree, this$static.outDegree.length);
    while(this$static.tempLayerlessNodes.array.length != 0){
        this$static.selectedNode = $selectNode_0(this$static);
        if (!this$static.selectedNode || $conditionGoUp(this$static) && this$static.alreadyPlacedNodes.map_0.size_1() != 0) {
            $updateOutGoing(this$static, currentLayer);
            currentLayer = new Layer(this$static.currentGraph);
            $add_3(this$static.currentGraph.layers, currentLayer);
            $addAll(this$static.alreadyPlacedInOtherLayers, this$static.alreadyPlacedNodes);
            this$static.alreadyPlacedNodes.map_0.clear_0();
            this$static.widthCurrent = this$static.widthUp;
            this$static.widthUp = 0;
        } else if ($conditionGoUp(this$static)) {
            this$static.currentGraph.layers.array.length = 0;
            currentLayer = new Layer(this$static.currentGraph);
            $add_3(this$static.currentGraph.layers, currentLayer);
            this$static.widthCurrent = 0;
            this$static.widthUp = 0;
            this$static.alreadyPlacedNodes.map_0.clear_0();
            this$static.alreadyPlacedInOtherLayers.map_0.clear_0();
            ++this$static.maxWidth;
            this$static.tempLayerlessNodes = newArrayList(this$static.sortedLayerlessNodes);
            this$static.remainingOutGoing = copyOf(this$static.outDegree, this$static.outDegree.length);
        } else {
            $setLayer_0(this$static.selectedNode, currentLayer);
            $remove_12(this$static.tempLayerlessNodes, this$static.selectedNode);
            $add_6(this$static.alreadyPlacedNodes, this$static.selectedNode);
            this$static.widthCurrent = this$static.widthCurrent - this$static.outDegree[this$static.selectedNode.id_0] * this$static.dummySize + this$static.normSize[this$static.selectedNode.id_0];
            this$static.widthUp += this$static.inDegree[this$static.selectedNode.id_0] * this$static.dummySize;
        }
    }
    layeredGraph.layerlessNodes.array.length = 0;
    reverse_2(layeredGraph.layers);
    progressMonitor.done_1();
}
function $selectNode_0(this$static) {
    var node, node$iterator;
    for(node$iterator = new ArrayList$1(this$static.tempLayerlessNodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        if (this$static.remainingOutGoing[node.id_0] <= 0) return node;
    }
    return null;
}
function $updateOutGoing(this$static, currentLayer) {
    var edge, edge$iterator, node, node$iterator, pos;
    for(node$iterator = new ArrayList$1(currentLayer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 18);
            pos = edge.source.owner.id_0;
            this$static.remainingOutGoing[pos] = this$static.remainingOutGoing[pos] - 1;
        }
    }
}
function StretchWidthLayerer() {
    this.alreadyPlacedNodes = new HashSet;
    this.alreadyPlacedInOtherLayers = new HashSet;
}
defineClass(1347, 1, $intern_110, StretchWidthLayerer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_11(graph) {
    return castTo(graph, 36), $addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P1_CYCLE_BREAKING), ($clinit_IntermediateProcessorStrategy(), EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER)), P2_LAYERING, LAYER_CONSTRAINT_PREPROCESSOR), P3_NODE_ORDERING, LAYER_CONSTRAINT_POSTPROCESSOR);
};
_.process = function process_67(layeredGraph, progressMonitor) {
    $process_70(this, castTo(layeredGraph, 36), progressMonitor);
};
_.dummySize = 0;
_.maxWidth = 0;
_.maximumNodeSize = 0;
_.minimumNodeSize = 0;
_.upperLayerInfluence = 0;
_.widthCurrent = 0;
_.widthUp = 0;
var Lorg_eclipse_elk_alg_layered_p2layers_StretchWidthLayerer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'StretchWidthLayerer', 1347);
function $compare_16(o1, o2) {
    if (o1.id_0 < o2.id_0) return 1;
    else if (o1.id_0 > o2.id_0) return -1;
    return 0;
}
function StretchWidthLayerer$1() {}
defineClass(1348, 1, $intern_88, StretchWidthLayerer$1);
_.compare_1 = function compare_62(o1, o2) {
    return $compare_16(castTo(o1, 9), castTo(o2, 9));
};
_.equals_0 = function equals_143(other) {
    return this === other;
};
_.reversed = function reversed_54() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p2layers_StretchWidthLayerer$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.p2layers', 'StretchWidthLayerer/1', 1348);
function create_14(cmt, r, currentOrder) {
    return cmt == ($clinit_LayerSweepCrossingMinimizer$CrossMinType(), TWO_SIDED_GREEDY_SWITCH_0) ? new GreedyPortDistributor : $nextInternal(r, 1) != 0 ? new NodeRelativePortDistributor(currentOrder.length) : new LayerTotalPortDistributor(currentOrder.length);
}
function $calculateInLayerPortsBarycenterValues(this$static, node) {
    var barycenter, connectedPort, connectedPort$iterator, inLayerConnections, inLayerPort, inLayerPort$iterator, layerSize, nodeIndexInLayer, portSide, sum;
    nodeIndexInLayer = this$static.nodePositions[node.layer.id_0][node.id_0] + 1;
    layerSize = node.layer.nodes.array.length + 1;
    for(inLayerPort$iterator = new ArrayList$1(this$static.inLayerPorts); inLayerPort$iterator.i < inLayerPort$iterator.this$01.array.length;){
        inLayerPort = castTo($next_6(inLayerPort$iterator), 11);
        sum = 0;
        inLayerConnections = 0;
        for(connectedPort$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
            new LPort$1(inLayerPort),
            new LPort$2(inLayerPort)
        ]))); $hasNext_1(connectedPort$iterator);){
            connectedPort = castTo($next_0(connectedPort$iterator), 11);
            if (connectedPort.owner.layer == node.layer) {
                sum += $positionOf(this$static, connectedPort.owner) + 1;
                ++inLayerConnections;
            }
        }
        barycenter = sum / inLayerConnections;
        portSide = inLayerPort.side;
        portSide == ($clinit_PortSide(), EAST_0) ? barycenter < nodeIndexInLayer ? this$static.portBarycenter[inLayerPort.id_0] = this$static.minBarycenter - barycenter : this$static.portBarycenter[inLayerPort.id_0] = this$static.maxBarycenter + (layerSize - barycenter) : portSide == WEST_0 && (barycenter < nodeIndexInLayer ? this$static.portBarycenter[inLayerPort.id_0] = this$static.maxBarycenter + barycenter : this$static.portBarycenter[inLayerPort.id_0] = this$static.minBarycenter - (layerSize - barycenter));
    }
}
function $calculatePortRanks(this$static, layer, portType) {
    var consumedRank, nodeIx;
    consumedRank = 0;
    for(nodeIx = 0; nodeIx < layer.length; nodeIx++)consumedRank += this$static.calculatePortRanks(layer[nodeIx], consumedRank, portType);
}
function $dealWithNorthSouthPorts(this$static, absurdlyLargeFloat, port, portDummy) {
    var input_0, output, portDummyPort, portDummyPort$iterator, sum;
    input_0 = false;
    output = false;
    for(portDummyPort$iterator = new ArrayList$1(portDummy.ports); portDummyPort$iterator.i < portDummyPort$iterator.this$01.array.length;){
        portDummyPort = castTo($next_6(portDummyPort$iterator), 11);
        maskUndefined($getProperty(portDummyPort, ($clinit_InternalProperties_1(), ORIGIN_0))) === maskUndefined(port) && (portDummyPort.outgoingEdges.array.length == 0 ? portDummyPort.incomingEdges.array.length == 0 || (input_0 = true) : output = true);
    }
    sum = 0;
    input_0 && input_0 ^ output ? sum = port.side == ($clinit_PortSide(), NORTH_1) ? -this$static.nodePositions[portDummy.layer.id_0][portDummy.id_0] : absurdlyLargeFloat - this$static.nodePositions[portDummy.layer.id_0][portDummy.id_0] : output && input_0 ^ output ? sum = this$static.nodePositions[portDummy.layer.id_0][portDummy.id_0] + 1 : input_0 && output && (sum = port.side == ($clinit_PortSide(), NORTH_1) ? 0 : absurdlyLargeFloat / 2);
    return sum;
}
function $distributePorts(this$static, node, ports) {
    this$static.inLayerPorts.array.length = 0;
    $iteratePortsAndCollectInLayerPorts(this$static, node, ports);
    this$static.inLayerPorts.array.length == 0 || $calculateInLayerPortsBarycenterValues(this$static, node);
}
function $distributePorts_0(this$static, node, side) {
    if (!$isOrderFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100))) {
        $distributePorts(this$static, node, $getPorts_1(node, side));
        $distributePorts(this$static, node, $getPorts_1(node, ($clinit_PortSide(), SOUTH_0)));
        $distributePorts(this$static, node, $getPorts_1(node, NORTH_1));
        $clinit_Collections();
        $sort(node.ports, new AbstractBarycenterPortDistributor$lambda$0$Type(this$static));
    }
}
function $distributePortsWhileSweeping(this$static, nodeOrder, currentIndex, isForwardSweep) {
    var fixedLayer, freeLayer, node, node$array, node$array0, node$index, node$index0, node$max, node$max0, side;
    $updateNodePositions(this$static, nodeOrder, currentIndex);
    freeLayer = nodeOrder[currentIndex];
    side = isForwardSweep ? ($clinit_PortSide(), WEST_0) : ($clinit_PortSide(), EAST_0);
    if ($isNotFirstLayer(nodeOrder.length, currentIndex, isForwardSweep)) {
        fixedLayer = nodeOrder[isForwardSweep ? currentIndex - 1 : currentIndex + 1];
        $calculatePortRanks(this$static, fixedLayer, isForwardSweep ? ($clinit_PortType(), OUTPUT) : ($clinit_PortType(), INPUT));
        for(node$array0 = freeLayer, node$index0 = 0, node$max0 = node$array0.length; node$index0 < node$max0; ++node$index0){
            node = node$array0[node$index0];
            $distributePorts_0(this$static, node, side);
        }
        $calculatePortRanks(this$static, freeLayer, isForwardSweep ? ($clinit_PortType(), INPUT) : ($clinit_PortType(), OUTPUT));
        for(node$array = fixedLayer, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            !!node.nestedGraph || $distributePorts_0(this$static, node, $opposed(side));
        }
    } else for(node$array = freeLayer, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        $distributePorts_0(this$static, node, side);
    }
    return false;
}
function $isNotFirstLayer(length_0, currentIndex, isForwardSweep) {
    return isForwardSweep ? currentIndex != 0 : currentIndex != length_0 - 1;
}
function $iteratePortsAndCollectInLayerPorts(this$static, node, ports) {
    var absurdlyLargeFloat, connectedPort, incomingEdge, incomingEdge$iterator, northSouthPort, outgoingEdge, outgoingEdge$iterator, port, port$iterator, portDummy, sum;
    this$static.minBarycenter = 0;
    this$static.maxBarycenter = 0;
    absurdlyLargeFloat = 2 * node.layer.nodes.array.length + 1;
    PortIteration: for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        northSouthPort = port.side == ($clinit_PortSide(), NORTH_1) || port.side == SOUTH_0;
        sum = 0;
        if (northSouthPort) {
            portDummy = castTo($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
            if (!portDummy) continue;
            sum += $dealWithNorthSouthPorts(this$static, absurdlyLargeFloat, port, portDummy);
        } else {
            for(outgoingEdge$iterator = new ArrayList$1(port.outgoingEdges); outgoingEdge$iterator.i < outgoingEdge$iterator.this$01.array.length;){
                outgoingEdge = castTo($next_6(outgoingEdge$iterator), 18);
                connectedPort = outgoingEdge.target;
                if (connectedPort.owner.layer == node.layer) {
                    $add_3(this$static.inLayerPorts, port);
                    continue PortIteration;
                } else sum += this$static.portRanks[connectedPort.id_0];
            }
            for(incomingEdge$iterator = new ArrayList$1(port.incomingEdges); incomingEdge$iterator.i < incomingEdge$iterator.this$01.array.length;){
                incomingEdge = castTo($next_6(incomingEdge$iterator), 18);
                connectedPort = incomingEdge.source;
                if (connectedPort.owner.layer == node.layer) {
                    $add_3(this$static.inLayerPorts, port);
                    continue PortIteration;
                } else sum -= this$static.portRanks[connectedPort.id_0];
            }
        }
        if (port.incomingEdges.array.length + port.outgoingEdges.array.length > 0) {
            this$static.portBarycenter[port.id_0] = sum / (port.incomingEdges.array.length + port.outgoingEdges.array.length);
            this$static.minBarycenter = $wnd.Math.min(this$static.minBarycenter, this$static.portBarycenter[port.id_0]);
            this$static.maxBarycenter = $wnd.Math.max(this$static.maxBarycenter, this$static.portBarycenter[port.id_0]);
        } else northSouthPort && (this$static.portBarycenter[port.id_0] = sum);
    }
}
function $lambda$0_6(this$static, port1_0, port2_1) {
    var port1Bary, port2Bary, side1, side2;
    side1 = port1_0.side;
    side2 = port2_1.side;
    if (side1 != side2) return side1.ordinal - side2.ordinal;
    else {
        port1Bary = this$static.portBarycenter[port1_0.id_0];
        port2Bary = this$static.portBarycenter[port2_1.id_0];
        return port1Bary == 0 && port2Bary == 0 ? 0 : port1Bary == 0 ? -1 : port2Bary == 0 ? 1 : compare_4(port1Bary, port2Bary);
    }
}
function $positionOf(this$static, node) {
    return this$static.nodePositions[node.layer.id_0][node.id_0];
}
function $updateNodePositions(this$static, nodeOrder, currentIndex) {
    var i, layer, node;
    layer = nodeOrder[currentIndex];
    for(i = 0; i < layer.length; i++){
        node = layer[i];
        this$static.nodePositions[node.layer.id_0][node.id_0] = i;
    }
}
function AbstractBarycenterPortDistributor(numLayers) {
    this.inLayerPorts = new ArrayList;
    this.nodePositions = initUnidimensionalArray(I_classLit, $intern_16, 54, numLayers, 0, 2);
}
defineClass(402, 1, $intern_111);
_.initAtEdgeLevel = function initAtEdgeLevel_0(l, n, p, e, edge, nodeOrder) {};
_.distributePortsWhileSweeping = function distributePortsWhileSweeping(nodeOrder, currentIndex, isForwardSweep) {
    return $distributePortsWhileSweeping(this, nodeOrder, currentIndex, isForwardSweep);
};
_.initAfterTraversal = function initAfterTraversal_0() {
    this.portRanks = initUnidimensionalArray(F_classLit, $intern_112, 30, this.nPorts, 15, 1);
    this.portBarycenter = initUnidimensionalArray(F_classLit, $intern_112, 30, this.nPorts, 15, 1);
};
_.initAtLayerLevel = function initAtLayerLevel_0(l, nodeOrder) {
    this.nodePositions[l] = initUnidimensionalArray(I_classLit, $intern_48, 30, nodeOrder[l].length, 15, 1);
};
_.initAtNodeLevel = function initAtNodeLevel_0(l, n, nodeOrder) {
    var node;
    node = nodeOrder[l][n];
    node.id_0 = n;
    this.nodePositions[l][n] = n;
};
_.initAtPortLevel = function initAtPortLevel_0(l, n, p, nodeOrder) {
    castTo($get_11(nodeOrder[l][n].ports, p), 11).id_0 = this.nPorts++;
};
_.maxBarycenter = 0;
_.minBarycenter = 0;
_.nPorts = 0;
var Lorg_eclipse_elk_alg_layered_p3order_AbstractBarycenterPortDistributor_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'AbstractBarycenterPortDistributor', 402);
function AbstractBarycenterPortDistributor$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1639, 1, $intern_88, AbstractBarycenterPortDistributor$lambda$0$Type);
_.compare_1 = function compare_63(arg0, arg1) {
    return $lambda$0_6(this.$$outer_0, castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_144(other) {
    return this === other;
};
_.reversed = function reversed_55() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_AbstractBarycenterPortDistributor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'AbstractBarycenterPortDistributor/lambda$0$Type', 1639);
function $calculateBarycenter(this$static, node, forward_0) {
    var associate, associate$iterator, barycenterAssociates, fixedNode, fixedPort, fixedPort$iterator, freePort, freePort$iterator, portIterable;
    if (this$static.barycenterState[node.layer.id_0][node.id_0].visited) return;
    else this$static.barycenterState[node.layer.id_0][node.id_0].visited = true;
    this$static.barycenterState[node.layer.id_0][node.id_0].degree = 0;
    this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight = 0;
    this$static.barycenterState[node.layer.id_0][node.id_0].barycenter = null;
    for(freePort$iterator = new ArrayList$1(node.ports); freePort$iterator.i < freePort$iterator.this$01.array.length;){
        freePort = castTo($next_6(freePort$iterator), 11);
        portIterable = forward_0 ? new LPort$1(freePort) : new LPort$2(freePort);
        for(fixedPort$iterator = portIterable.iterator_0(); fixedPort$iterator.hasNext_0();){
            fixedPort = castTo(fixedPort$iterator.next_1(), 11);
            fixedNode = fixedPort.owner;
            if (fixedNode.layer == node.layer) {
                if (fixedNode != node) {
                    $calculateBarycenter(this$static, fixedNode, forward_0);
                    this$static.barycenterState[node.layer.id_0][node.id_0].degree += this$static.barycenterState[fixedNode.layer.id_0][fixedNode.id_0].degree;
                    this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight += this$static.barycenterState[fixedNode.layer.id_0][fixedNode.id_0].summedWeight;
                }
            } else {
                this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight += this$static.portRanks[fixedPort.id_0];
                ++this$static.barycenterState[node.layer.id_0][node.id_0].degree;
            }
        }
    }
    barycenterAssociates = castTo($getProperty(node, ($clinit_InternalProperties_1(), BARYCENTER_ASSOCIATES)), 15);
    if (barycenterAssociates) for(associate$iterator = barycenterAssociates.iterator_0(); associate$iterator.hasNext_0();){
        associate = castTo(associate$iterator.next_1(), 9);
        if (node.layer == associate.layer) {
            $calculateBarycenter(this$static, associate, forward_0);
            this$static.barycenterState[node.layer.id_0][node.id_0].degree += this$static.barycenterState[associate.layer.id_0][associate.id_0].degree;
            this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight += this$static.barycenterState[associate.layer.id_0][associate.id_0].summedWeight;
        }
    }
    if (this$static.barycenterState[node.layer.id_0][node.id_0].degree > 0) {
        this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight += $nextInternal(this$static.random_0, 24) * $intern_81 * 0.07000000029802322 - 0.03500000014901161;
        this$static.barycenterState[node.layer.id_0][node.id_0].barycenter = this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight / this$static.barycenterState[node.layer.id_0][node.id_0].degree;
    }
}
function $calculateBarycenters(this$static, nodes, forward_0) {
    var node, node$iterator, node$iterator0;
    for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        this$static.barycenterState[node.layer.id_0][node.id_0].visited = false;
    }
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $calculateBarycenter(this$static, node, forward_0);
    }
}
function $fillInUnknownBarycenters(this$static, nodes, preOrdered) {
    var lastValue, maxBary, nextNodeIterator, nextValue, node, node$iterator, node$iterator0, nodesIterator, value_0, x_0;
    if (preOrdered) {
        lastValue = -1;
        nodesIterator = new AbstractList$ListIteratorImpl(nodes, 0);
        while(nodesIterator.i < nodesIterator.this$01_0.size_1()){
            node = (checkCriticalElement(nodesIterator.i < nodesIterator.this$01_0.size_1()), castTo(nodesIterator.this$01_0.get_0(nodesIterator.last = nodesIterator.i++), 9));
            value_0 = this$static.barycenterState[node.layer.id_0][node.id_0].barycenter;
            if (value_0 == null) {
                nextValue = lastValue + 1;
                nextNodeIterator = new AbstractList$ListIteratorImpl(nodes, nodesIterator.i);
                while(nextNodeIterator.i < nextNodeIterator.this$01_0.size_1()){
                    x_0 = $stateOf(this$static, (checkCriticalElement(nextNodeIterator.i < nextNodeIterator.this$01_0.size_1()), castTo(nextNodeIterator.this$01_0.get_0(nextNodeIterator.last = nextNodeIterator.i++), 9))).barycenter;
                    if (x_0 != null) {
                        nextValue = (checkCriticalNotNull(x_0), x_0);
                        break;
                    }
                }
                value_0 = (lastValue + nextValue) / 2;
                this$static.barycenterState[node.layer.id_0][node.id_0].barycenter = value_0;
                this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight = (checkCriticalNotNull(value_0), value_0);
                this$static.barycenterState[node.layer.id_0][node.id_0].degree = 1;
            }
            lastValue = (checkCriticalNotNull(value_0), value_0);
        }
    } else {
        maxBary = 0;
        for(node$iterator0 = new ArrayList$1(nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            this$static.barycenterState[node.layer.id_0][node.id_0].barycenter != null && (maxBary = $wnd.Math.max(maxBary, $doubleValue(this$static.barycenterState[node.layer.id_0][node.id_0].barycenter)));
        }
        maxBary += 2;
        for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (this$static.barycenterState[node.layer.id_0][node.id_0].barycenter == null) {
                value_0 = $nextInternal(this$static.random_0, 24) * $intern_81 * maxBary - 1;
                this$static.barycenterState[node.layer.id_0][node.id_0].barycenter = value_0;
                this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight = value_0;
                this$static.barycenterState[node.layer.id_0][node.id_0].degree = 1;
            }
        }
    }
}
function $lambda$0_7(this$static, n1_0, n2_1) {
    var s1, s2;
    s1 = this$static.barycenterState[n1_0.layer.id_0][n1_0.id_0];
    s2 = this$static.barycenterState[n2_1.layer.id_0][n2_1.id_0];
    if (s1.barycenter != null && s2.barycenter != null) return $compareTo_4(s1.barycenter, s2.barycenter);
    else if (s1.barycenter != null) return -1;
    else if (s2.barycenter != null) return 1;
    return 0;
}
function $randomizeBarycenters(this$static, nodes) {
    var node, node$iterator;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        this$static.barycenterState[node.layer.id_0][node.id_0].barycenter = $nextDouble(this$static.random_0);
        this$static.barycenterState[node.layer.id_0][node.id_0].summedWeight = $doubleValue(this$static.barycenterState[node.layer.id_0][node.id_0].barycenter);
        this$static.barycenterState[node.layer.id_0][node.id_0].degree = 1;
    }
}
function $startIndex_0(dir_0, length_0) {
    return dir_0 ? 0 : $wnd.Math.max(0, length_0 - 1);
}
function $stateOf(this$static, node) {
    return this$static.barycenterState[node.layer.id_0][node.id_0];
}
function BarycenterHeuristic(constraintResolver, random, portDistributor) {
    this.barycenterStateComparator = new BarycenterHeuristic$lambda$0$Type(this);
    this.constraintResolver = constraintResolver;
    this.random_0 = random;
    this.portDistributor = portDistributor;
}
defineClass(811, 1, $intern_108, BarycenterHeuristic);
_.initAtEdgeLevel = function initAtEdgeLevel_1(l, n, p, e, edge, nodeOrder) {};
_.initAtNodeLevel = function initAtNodeLevel_1(l, n, nodeOrder) {};
_.initAtPortLevel = function initAtPortLevel_1(l, n, p, nodeOrder) {};
_.alwaysImproves = function alwaysImproves_0() {
    return false;
};
_.initAfterTraversal = function initAfterTraversal_1() {
    this.barycenterState = this.constraintResolver.barycenterStates;
    this.portRanks = this.portDistributor.portRanks;
};
_.initAtLayerLevel = function initAtLayerLevel_1(l, nodeOrder) {
    nodeOrder[l][0].layer.id_0 = l;
};
_.isDeterministic = function isDeterministic_0() {
    return false;
};
_.minimizeCrossings_0 = function minimizeCrossings_0(layer, preOrdered, randomize, forward_0) {
    if (randomize) $randomizeBarycenters(this, layer);
    else {
        $calculateBarycenters(this, layer, forward_0);
        $fillInUnknownBarycenters(this, layer, preOrdered);
    }
    if (layer.array.length > 1) {
        $booleanValue(castToBoolean($getProperty($getGraph((checkCriticalElementIndex(0, layer.array.length), castTo(layer.array[0], 9))), ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0)))) ? insertionSort_1(layer, this.barycenterStateComparator, castTo(this, 654)) : ($clinit_Collections(), $sort(layer, this.barycenterStateComparator));
        $processConstraints(this.constraintResolver, layer);
    }
};
_.minimizeCrossings = function minimizeCrossings_1(order, freeLayerIndex, forwardSweep, isFirstSweep) {
    var firstNodeInLayer, fixedLayer, index_0, nodeGroup, nodeGroup$iterator, nodes, preOrdered;
    if (freeLayerIndex != $startIndex_0(forwardSweep, order.length)) {
        fixedLayer = order[freeLayerIndex - (forwardSweep ? 1 : -1)];
        $calculatePortRanks(this.portDistributor, fixedLayer, forwardSweep ? ($clinit_PortType(), OUTPUT) : ($clinit_PortType(), INPUT));
    }
    firstNodeInLayer = order[freeLayerIndex][0];
    preOrdered = !isFirstSweep || firstNodeInLayer.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT);
    nodes = newArrayList_1(order[freeLayerIndex]);
    this.minimizeCrossings_0(nodes, preOrdered, false, forwardSweep);
    index_0 = 0;
    for(nodeGroup$iterator = new ArrayList$1(nodes); nodeGroup$iterator.i < nodeGroup$iterator.this$01.array.length;){
        nodeGroup = castTo($next_6(nodeGroup$iterator), 9);
        order[freeLayerIndex][index_0++] = nodeGroup;
    }
    return false;
};
_.setFirstLayerOrder = function setFirstLayerOrder_0(order, isForwardSweep) {
    var index_0, nodeGroup, nodeGroup$iterator, nodes, startIndex;
    startIndex = $startIndex_0(isForwardSweep, order.length);
    nodes = newArrayList_1(order[startIndex]);
    this.minimizeCrossings_0(nodes, false, true, isForwardSweep);
    index_0 = 0;
    for(nodeGroup$iterator = new ArrayList$1(nodes); nodeGroup$iterator.i < nodeGroup$iterator.this$01.array.length;){
        nodeGroup = castTo($next_6(nodeGroup$iterator), 9);
        order[startIndex][index_0++] = nodeGroup;
    }
    return false;
};
var Lorg_eclipse_elk_alg_layered_p3order_BarycenterHeuristic_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'BarycenterHeuristic', 811);
function BarycenterHeuristic$BarycenterState(node) {
    this.node = node;
}
defineClass(652, 1, {
    652: 1
}, BarycenterHeuristic$BarycenterState);
_.toString_0 = function toString_96() {
    return 'BarycenterState [node=' + this.node + ', summedWeight=' + this.summedWeight + ', degree=' + this.degree + ', barycenter=' + this.barycenter + ', visited=' + this.visited + ']';
};
_.degree = 0;
_.summedWeight = 0;
_.visited = false;
var Lorg_eclipse_elk_alg_layered_p3order_BarycenterHeuristic$BarycenterState_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'BarycenterHeuristic/BarycenterState', 652);
function BarycenterHeuristic$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1811, 1, $intern_88, BarycenterHeuristic$lambda$0$Type);
_.compare_1 = function compare_64(arg0, arg1) {
    return $lambda$0_7(this.$$outer_0, castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_145(other) {
    return this === other;
};
_.reversed = function reversed_56() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_BarycenterHeuristic$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'BarycenterHeuristic/lambda$0$Type', 1811);
function $buildConstraintsGraph(this$static, groups, onlyBetweenNormalNodes) {
    var currentUnitNode, currentUnitNode$iterator, group, group$iterator, group$iterator0, lastNonDummyNode, lastUnitNode, lastUnitNode$iterator, node, successor, successor$iterator;
    for(group$iterator0 = new ArrayList$1(groups); group$iterator0.i < group$iterator0.this$01.array.length;){
        group = castTo($next_6(group$iterator0), 238);
        group.outgoingConstraints = null;
        group.incomingConstraintsCount = 0;
    }
    lastNonDummyNode = null;
    for(group$iterator = new ArrayList$1(groups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 238);
        node = group.nodes[0];
        if (onlyBetweenNormalNodes && node.type_0 != ($clinit_LNode$NodeType(), NORMAL)) continue;
        for(successor$iterator = castTo($getProperty(node, ($clinit_InternalProperties_1(), IN_LAYER_SUCCESSOR_CONSTRAINTS)), 15).iterator_0(); successor$iterator.hasNext_0();){
            successor = castTo(successor$iterator.next_1(), 9);
            if (!onlyBetweenNormalNodes || successor.type_0 == ($clinit_LNode$NodeType(), NORMAL)) {
                (!group.outgoingConstraints && (group.outgoingConstraints = new ArrayList), group.outgoingConstraints).add_2(this$static.constraintGroups[successor.layer.id_0][successor.id_0]);
                ++this$static.constraintGroups[successor.layer.id_0][successor.id_0].incomingConstraintsCount;
            }
        }
        if (!onlyBetweenNormalNodes && node.type_0 == ($clinit_LNode$NodeType(), NORMAL)) {
            if (lastNonDummyNode) for(lastUnitNode$iterator = castTo($get(this$static.layoutUnits, lastNonDummyNode), 22).iterator_0(); lastUnitNode$iterator.hasNext_0();){
                lastUnitNode = castTo(lastUnitNode$iterator.next_1(), 9);
                for(currentUnitNode$iterator = castTo($get(this$static.layoutUnits, node), 22).iterator_0(); currentUnitNode$iterator.hasNext_0();){
                    currentUnitNode = castTo(currentUnitNode$iterator.next_1(), 9);
                    $getOutgoingConstraints(this$static.constraintGroups[lastUnitNode.layer.id_0][lastUnitNode.id_0]).add_2(this$static.constraintGroups[currentUnitNode.layer.id_0][currentUnitNode.id_0]);
                    ++this$static.constraintGroups[currentUnitNode.layer.id_0][currentUnitNode.id_0].incomingConstraintsCount;
                }
            }
            lastNonDummyNode = node;
        }
    }
}
function $findViolatedConstraint(groups) {
    var activeGroups, group, group$iterator, predecessor, predecessor$iterator, successor, successor$iterator, successorIncomingList;
    activeGroups = null;
    for(group$iterator = new ArrayList$1(groups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 238);
        $doubleValue($stateOf_0(group.this$01, group.nodes[0]).barycenter);
        group.incomingConstraints = null;
        if (!!group.outgoingConstraints && group.outgoingConstraints.size_1() > 0 && group.incomingConstraintsCount == 0) {
            !activeGroups && (activeGroups = new ArrayList);
            push_1(activeGroups.array, group);
        }
    }
    if (activeGroups) while(activeGroups.array.length != 0){
        group = castTo($remove_11(activeGroups, 0), 238);
        if (!!group.incomingConstraints && group.incomingConstraints.array.length > 0) for(predecessor$iterator = (!group.incomingConstraints && (group.incomingConstraints = new ArrayList), new ArrayList$1(group.incomingConstraints)); predecessor$iterator.i < predecessor$iterator.this$01.array.length;){
            predecessor = castTo($next_6(predecessor$iterator), 238);
            if ($floatValue($stateOf_0(predecessor.this$01, predecessor.nodes[0]).barycenter) == $floatValue($stateOf_0(group.this$01, group.nodes[0]).barycenter)) {
                if ($indexOf_3(groups, predecessor, 0) > $indexOf_3(groups, group, 0)) return new Pair(predecessor, group);
            } else if ($doubleValue($stateOf_0(predecessor.this$01, predecessor.nodes[0]).barycenter) > $doubleValue($stateOf_0(group.this$01, group.nodes[0]).barycenter)) return new Pair(predecessor, group);
        }
        for(successor$iterator = (!group.outgoingConstraints && (group.outgoingConstraints = new ArrayList), group.outgoingConstraints).iterator_0(); successor$iterator.hasNext_0();){
            successor = castTo(successor$iterator.next_1(), 238);
            successorIncomingList = (!successor.incomingConstraints && (successor.incomingConstraints = new ArrayList), successor.incomingConstraints);
            checkCriticalPositionIndex(0, successorIncomingList.array.length);
            insertTo(successorIncomingList.array, 0, group);
            successor.incomingConstraintsCount == successorIncomingList.array.length && push_1(activeGroups.array, successor);
        }
    }
    return null;
}
function $handleViolatedConstraint(this$static, firstNodeGroup, secondNodeGroup, nodeGroups) {
    var alreadyInserted, firstNodeGroupConstraint, newNodeGroup, nodeGroup, nodeGroupIterator, secondNodeGroupConstraint;
    newNodeGroup = new ForsterConstraintResolver$ConstraintGroup_0(this$static, firstNodeGroup, secondNodeGroup);
    nodeGroupIterator = new AbstractList$ListIteratorImpl(nodeGroups, 0);
    alreadyInserted = false;
    while(nodeGroupIterator.i < nodeGroupIterator.this$01_0.size_1()){
        nodeGroup = (checkCriticalElement(nodeGroupIterator.i < nodeGroupIterator.this$01_0.size_1()), castTo(nodeGroupIterator.this$01_0.get_0(nodeGroupIterator.last = nodeGroupIterator.i++), 238));
        if (nodeGroup == firstNodeGroup || nodeGroup == secondNodeGroup) $remove_8(nodeGroupIterator);
        else if (!alreadyInserted && $doubleValue($stateOf_0(nodeGroup.this$01, nodeGroup.nodes[0]).barycenter) > $doubleValue($stateOf_0(newNodeGroup.this$01, newNodeGroup.nodes[0]).barycenter)) {
            checkCriticalElement(nodeGroupIterator.i > 0);
            nodeGroupIterator.this$01.get_0(nodeGroupIterator.last = --nodeGroupIterator.i);
            $add_1(nodeGroupIterator, newNodeGroup);
            alreadyInserted = true;
        } else if (!!nodeGroup.outgoingConstraints && nodeGroup.outgoingConstraints.size_1() > 0) {
            firstNodeGroupConstraint = (!nodeGroup.outgoingConstraints && (nodeGroup.outgoingConstraints = new ArrayList), nodeGroup.outgoingConstraints).remove_1(firstNodeGroup);
            secondNodeGroupConstraint = (!nodeGroup.outgoingConstraints && (nodeGroup.outgoingConstraints = new ArrayList), nodeGroup.outgoingConstraints).remove_1(secondNodeGroup);
            if (firstNodeGroupConstraint || secondNodeGroupConstraint) {
                (!nodeGroup.outgoingConstraints && (nodeGroup.outgoingConstraints = new ArrayList), nodeGroup.outgoingConstraints).add_2(newNodeGroup);
                ++newNodeGroup.incomingConstraintsCount;
            }
        }
    }
    alreadyInserted || push_1(nodeGroups.array, newNodeGroup);
}
function $initAtNodeLevel(this$static, node, fullInit) {
    var layerIndex, layoutUnit, nodeIndex;
    layerIndex = node.layer.id_0;
    nodeIndex = node.id_0;
    this$static.constraintGroups[layerIndex][nodeIndex] = new ForsterConstraintResolver$ConstraintGroup(this$static, node);
    if (fullInit) {
        this$static.barycenterStates[layerIndex][nodeIndex] = new BarycenterHeuristic$BarycenterState(node);
        layoutUnit = castTo($getProperty(node, ($clinit_InternalProperties_1(), IN_LAYER_LAYOUT_UNIT)), 9);
        !!layoutUnit && $put(this$static.layoutUnits, layoutUnit, node);
    }
}
function $processConstraints(this$static, nodes) {
    if (this$static.constraintsBetweenNonDummies) {
        $processConstraints_0(this$static, nodes, true);
        $forEach_3(new StreamImpl(null, new Spliterators$IteratorSpliterator(nodes, 16)), new ForsterConstraintResolver$lambda$0$Type(this$static));
    }
    $processConstraints_0(this$static, nodes, false);
}
function $processConstraints_0(this$static, nodes, onlyBetweenNormalNodes) {
    var group, group$iterator, groups, node, node$array, node$index, node$iterator, node$max, violatedConstraint;
    groups = new ArrayList_0(nodes.array.length);
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        $add_3(groups, this$static.constraintGroups[node.layer.id_0][node.id_0]);
    }
    $buildConstraintsGraph(this$static, groups, onlyBetweenNormalNodes);
    violatedConstraint = null;
    while(violatedConstraint = $findViolatedConstraint(groups))$handleViolatedConstraint(this$static, castTo(violatedConstraint.first, 238), castTo(violatedConstraint.second, 238), groups);
    nodes.array.length = 0;
    for(group$iterator = new ArrayList$1(groups); group$iterator.i < group$iterator.this$01.array.length;){
        group = castTo($next_6(group$iterator), 238);
        for(node$array = group.nodes, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            push_1(nodes.array, node);
            this$static.barycenterStates[node.layer.id_0][node.id_0].barycenter = $stateOf_0(group.this$01, group.nodes[0]).barycenter;
        }
    }
}
function $stateOf_0(this$static, node) {
    return this$static.barycenterStates[node.layer.id_0][node.id_0];
}
function ForsterConstraintResolver(currentNodeOrder) {
    currentNodeOrder.length > 0 && currentNodeOrder[0].length > 0 && (this.constraintsBetweenNonDummies = $booleanValue(castToBoolean($getProperty($getGraph(currentNodeOrder[0][0]), ($clinit_InternalProperties_1(), IN_LAYER_SUCCESSOR_CONSTRAINTS_BETWEEN_NON_DUMMIES)))));
    this.barycenterStates = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_BarycenterHeuristic$BarycenterState_2_classLit, $intern_16, 2063, currentNodeOrder.length, 0, 2);
    this.constraintGroups = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_ForsterConstraintResolver$ConstraintGroup_2_classLit, $intern_16, 2064, currentNodeOrder.length, 0, 2);
    this.layoutUnits = new LinkedHashMultimap;
}
defineClass(810, 1, $intern_108, ForsterConstraintResolver);
_.initAfterTraversal = function initAfterTraversal_2() {};
_.initAtEdgeLevel = function initAtEdgeLevel_2(l, n, p, e, edge, nodeOrder) {};
_.initAtPortLevel = function initAtPortLevel_2(l, n, p, nodeOrder) {};
_.initAtLayerLevel = function initAtLayerLevel_2(l, nodeOrder) {
    this.barycenterStates[l] = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_BarycenterHeuristic$BarycenterState_2_classLit, {
        3: 1,
        4: 1,
        5: 1,
        2063: 1
    }, 652, nodeOrder[l].length, 0, 1);
    this.constraintGroups[l] = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_ForsterConstraintResolver$ConstraintGroup_2_classLit, {
        3: 1,
        4: 1,
        5: 1,
        2064: 1
    }, 238, nodeOrder[l].length, 0, 1);
};
_.initAtNodeLevel = function initAtNodeLevel_2(l, n, nodeOrder) {
    $initAtNodeLevel(this, nodeOrder[l][n], true);
};
_.constraintsBetweenNonDummies = false;
var Lorg_eclipse_elk_alg_layered_p3order_ForsterConstraintResolver_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'ForsterConstraintResolver', 810);
function $getOutgoingConstraints(this$static) {
    !this$static.outgoingConstraints && (this$static.outgoingConstraints = new ArrayList);
    return this$static.outgoingConstraints;
}
function $setBarycenter(this$static, barycenter) {
    var node, node$array, node$index, node$max;
    for(node$array = this$static.nodes, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        $stateOf_0(this$static.this$01, node).barycenter = barycenter;
    }
}
function ForsterConstraintResolver$ConstraintGroup(this$0, node) {
    this.this$01 = this$0;
    this.nodes = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, 1), $intern_104, 9, 0, [
        node
    ]);
}
function ForsterConstraintResolver$ConstraintGroup_0(this$0, nodeGroup1, nodeGroup2) {
    var candidate, candidate$iterator, i, i0, length1, length2;
    this.this$01 = this$0;
    length1 = nodeGroup1.nodes.length;
    length2 = nodeGroup2.nodes.length;
    this.nodes = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, length1 + length2, 0, 1);
    for(i0 = 0; i0 < length1; i0++)this.nodes[i0] = nodeGroup1.nodes[i0];
    for(i = 0; i < length2; i++)this.nodes[length1 + i] = nodeGroup2.nodes[i];
    if (nodeGroup1.outgoingConstraints) {
        this.outgoingConstraints = newLinkedList(nodeGroup1.outgoingConstraints);
        this.outgoingConstraints.remove_1(nodeGroup2);
        if (nodeGroup2.outgoingConstraints) for(candidate$iterator = nodeGroup2.outgoingConstraints.iterator_0(); candidate$iterator.hasNext_0();){
            candidate = castTo(candidate$iterator.next_1(), 238);
            if (candidate == nodeGroup1) continue;
            else this.outgoingConstraints.contains(candidate) ? --candidate.incomingConstraintsCount : this.outgoingConstraints.add_2(candidate);
        }
    } else if (nodeGroup2.outgoingConstraints) {
        this.outgoingConstraints = newLinkedList(nodeGroup2.outgoingConstraints);
        this.outgoingConstraints.remove_1(nodeGroup1);
    }
    this.summedWeight = nodeGroup1.summedWeight + nodeGroup2.summedWeight;
    this.degree = nodeGroup1.degree + nodeGroup2.degree;
    this.degree > 0 ? $setBarycenter(this, this.summedWeight / this.degree) : $stateOf_0(nodeGroup1.this$01, nodeGroup1.nodes[0]).barycenter != null && $stateOf_0(nodeGroup2.this$01, nodeGroup2.nodes[0]).barycenter != null ? $setBarycenter(this, ($doubleValue($stateOf_0(nodeGroup1.this$01, nodeGroup1.nodes[0]).barycenter) + $doubleValue($stateOf_0(nodeGroup2.this$01, nodeGroup2.nodes[0]).barycenter)) / 2) : $stateOf_0(nodeGroup1.this$01, nodeGroup1.nodes[0]).barycenter != null ? $setBarycenter(this, $stateOf_0(nodeGroup1.this$01, nodeGroup1.nodes[0]).barycenter) : $stateOf_0(nodeGroup2.this$01, nodeGroup2.nodes[0]).barycenter != null && $setBarycenter(this, $stateOf_0(nodeGroup2.this$01, nodeGroup2.nodes[0]).barycenter);
}
defineClass(238, 1, {
    238: 1
}, ForsterConstraintResolver$ConstraintGroup, ForsterConstraintResolver$ConstraintGroup_0);
_.toString_0 = function toString_97() {
    var i, sb;
    sb = new StringBuilder;
    sb.string += '[';
    for(i = 0; i < this.nodes.length; i++){
        $append_11(sb, $toString_13(this.nodes[i]));
        $stateOf_0(this.this$01, this.nodes[0]).barycenter != null && $append_11($append_11((sb.string += '<', sb), $toString_6($stateOf_0(this.this$01, this.nodes[0]).barycenter)), '>');
        i < this.nodes.length - 1 && (sb.string += ', ', sb);
    }
    return (sb.string += ']', sb).string;
};
_.degree = 0;
_.incomingConstraintsCount = 0;
_.summedWeight = 0;
var Lorg_eclipse_elk_alg_layered_p3order_ForsterConstraintResolver$ConstraintGroup_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'ForsterConstraintResolver/ConstraintGroup', 238);
function ForsterConstraintResolver$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1806, 1, $intern_19, ForsterConstraintResolver$lambda$0$Type);
_.accept = function accept_113(arg0) {
    $initAtNodeLevel(this.$$outer_0, castTo(arg0, 9), false);
};
var Lorg_eclipse_elk_alg_layered_p3order_ForsterConstraintResolver$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'ForsterConstraintResolver/lambda$0$Type', 1806);
function $setBestNodeNPortOrder(this$static, bestNodeNPortOrder) {
    this$static.bestNodeAndPortOrder = bestNodeNPortOrder;
}
function $setCurrentlyBestNodeAndPortOrder(this$static, currentlyBestNodeAndPortOrder) {
    this$static.currentlyBestNodeAndPortOrder = currentlyBestNodeAndPortOrder;
}
function GraphInfoHolder(graph, crossMinType, graphs) {
    var constraintResolver, graphProperties, initializables, random;
    this.lGraph = graph;
    this.currentNodeOrder = $toNodeArray(graph);
    this.parent_0 = this.lGraph.parentNode;
    this.hasParent = !!this.parent_0;
    this.parentGraphData = this.hasParent ? castTo($get_11(graphs, $getGraph(this.parent_0).id_0), 217) : null;
    graphProperties = castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
    this.hasExternalPorts = graphProperties.contains(($clinit_GraphProperties(), EXTERNAL_PORTS));
    this.childGraphs = new ArrayList;
    this.crossingsCounter = new AllCrossingsCounter(this.currentNodeOrder);
    random = castTo($getProperty(this.lGraph, RANDOM_0), 233);
    this.portDistributor = create_14(crossMinType, random, this.currentNodeOrder);
    this.layerSweepTypeDecider = new LayerSweepTypeDecider(this);
    initializables = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p3order_counting_IInitializable_2_classLit, 1), $intern_2, 229, 0, [
        this,
        this.crossingsCounter,
        this.layerSweepTypeDecider,
        this.portDistributor
    ]));
    if (crossMinType == ($clinit_LayerSweepCrossingMinimizer$CrossMinType(), BARYCENTER) && !$booleanValue(castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))))) {
        constraintResolver = new ForsterConstraintResolver(this.currentNodeOrder);
        push_1(initializables.array, constraintResolver);
        this.crossMinimizer = new BarycenterHeuristic(constraintResolver, random, castTo(this.portDistributor, 402));
    } else if (crossMinType == BARYCENTER && $booleanValue(castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))))) {
        constraintResolver = new ForsterConstraintResolver(this.currentNodeOrder);
        push_1(initializables.array, constraintResolver);
        this.crossMinimizer = new ModelOrderBarycenterHeuristic(constraintResolver, random, castTo(this.portDistributor, 402));
    } else this.crossMinimizer = new GreedySwitchHeuristic(crossMinType, this);
    $add_3(initializables, this.crossMinimizer);
    init_0(initializables, this.currentNodeOrder);
    this.useBottomUp = $useBottomUp(this.layerSweepTypeDecider);
}
defineClass(217, 1, {
    217: 1,
    229: 1
}, GraphInfoHolder);
_.initAtEdgeLevel = function initAtEdgeLevel_3(l, n, p, e, edge, nodeOrder) {};
_.initAtLayerLevel = function initAtLayerLevel_3(l, nodeOrder) {};
_.initAfterTraversal = function initAfterTraversal_3() {
    this.portPositions = initUnidimensionalArray(I_classLit, $intern_48, 30, this.nPorts, 15, 1);
};
_.initAtNodeLevel = function initAtNodeLevel_3(l, n, nodeOrder) {
    var nestedGraph, node;
    node = nodeOrder[l][n];
    nestedGraph = node.nestedGraph;
    !!nestedGraph && $add_3(this.childGraphs, nestedGraph);
};
_.initAtPortLevel = function initAtPortLevel_3(l, n, p, nodeOrder) {
    ++this.nPorts;
};
_.toString_0 = function toString_98() {
    return deepToString(this.currentNodeOrder, new HashSet);
};
_.hasExternalPorts = false;
_.hasParent = false;
_.nPorts = 0;
_.useBottomUp = false;
var Lorg_eclipse_elk_alg_layered_p3order_GraphInfoHolder_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'GraphInfoHolder', 217);
function $distributePortsInLayer(this$static, nodeOrder, currentIndex, isForwardSweep) {
    var improved, innerGraph, nestedGraph, node, node$array, node$index, node$max, side, useHierarchicalCrossCounter;
    side = isForwardSweep ? ($clinit_PortSide(), WEST_0) : ($clinit_PortSide(), EAST_0);
    improved = false;
    for(node$array = nodeOrder[currentIndex], node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        if ($isOrderFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100))) continue;
        nestedGraph = node.nestedGraph;
        useHierarchicalCrossCounter = !$getPortSideView(node, side).isEmpty() && !!nestedGraph;
        if (useHierarchicalCrossCounter) {
            innerGraph = $toNodeArray(nestedGraph);
            this$static.hierarchicalCrossingsCounter = new BetweenLayerEdgeTwoNodeCrossingsCounter(innerGraph, isForwardSweep ? 0 : innerGraph.length - 1);
        }
        improved = improved | $distributePortsOnNode(this$static, node, side, useHierarchicalCrossCounter);
    }
    return improved;
}
function $distributePortsOnNode(this$static, node, side, useHierarchicalCrosscounter) {
    var continueSwitching, i, improved, lowerPort, ports, upperPort, lower;
    ports = $getPortSideView(node, side);
    (side == ($clinit_PortSide(), SOUTH_0) || side == WEST_0) && (ports = reverse_0(ports));
    improved = false;
    do {
        continueSwitching = false;
        for(i = 0; i < ports.size_1() - 1; i++){
            upperPort = castTo(ports.get_0(i), 11);
            lowerPort = castTo(ports.get_0(i + 1), 11);
            if ($switchingDecreasesCrossings(this$static, upperPort, lowerPort, useHierarchicalCrosscounter)) {
                improved = true;
                $switchPorts(this$static.crossingsCounter, castTo(ports.get_0(i), 11), castTo(ports.get_0(i + 1), 11));
                lower = castTo(ports.get_0(i + 1), 11);
                ports.set_2(i + 1, castTo(ports.get_0(i), 11));
                ports.set_2(i, lower);
                continueSwitching = true;
            }
        }
    }while (continueSwitching);
    return improved;
}
function $switchingDecreasesCrossings(this$static, upperPort, lowerPort, useHierarchicalCrosscounter) {
    var lowerNode, lowerUpperCrossings, originalNSwitchedCrossings, upperLowerCrossings, upperNode;
    originalNSwitchedCrossings = $countCrossingsBetweenPortsInBothOrders(this$static.crossingsCounter, upperPort, lowerPort);
    upperLowerCrossings = castTo(originalNSwitchedCrossings.first, 17).value_0;
    lowerUpperCrossings = castTo(originalNSwitchedCrossings.second, 17).value_0;
    if (useHierarchicalCrosscounter) {
        upperNode = castTo($getProperty(upperPort, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
        lowerNode = castTo($getProperty(lowerPort, PORT_DUMMY), 9);
        if (!!upperNode && !!lowerNode) {
            $countBothSideCrossings(this$static.hierarchicalCrossingsCounter, upperNode, lowerNode);
            upperLowerCrossings += this$static.hierarchicalCrossingsCounter.upperLowerCrossings;
            lowerUpperCrossings += this$static.hierarchicalCrossingsCounter.lowerUpperCrossings;
        }
    }
    return upperLowerCrossings > lowerUpperCrossings;
}
function GreedyPortDistributor() {}
defineClass(1851, 1, $intern_108, GreedyPortDistributor);
_.initAtEdgeLevel = function initAtEdgeLevel_4(l, n, p, e, edge, nodeOrder) {};
_.initAtLayerLevel = function initAtLayerLevel_4(l, nodeOrder) {};
_.initAtPortLevel = function initAtPortLevel_4(l, n, p, nodeOrder) {};
_.distributePortsWhileSweeping = function distributePortsWhileSweeping_0(nodeOrder, currentIndex, isForwardSweep) {
    isForwardSweep && currentIndex > 0 ? ($initForCountingBetween(this.crossingsCounter, nodeOrder[currentIndex - 1], nodeOrder[currentIndex]), undefined) : !isForwardSweep && currentIndex < nodeOrder.length - 1 ? ($initForCountingBetween(this.crossingsCounter, nodeOrder[currentIndex], nodeOrder[currentIndex + 1]), undefined) : $initPortPositionsForInLayerCrossings(this.crossingsCounter, nodeOrder[currentIndex], isForwardSweep ? ($clinit_PortSide(), WEST_0) : ($clinit_PortSide(), EAST_0));
    return $distributePortsInLayer(this, nodeOrder, currentIndex, isForwardSweep);
};
_.initAfterTraversal = function initAfterTraversal_4() {
    this.portPos = initUnidimensionalArray(I_classLit, $intern_48, 30, this.nPorts, 15, 1);
    this.crossingsCounter = new CrossingsCounter(this.portPos);
};
_.initAtNodeLevel = function initAtNodeLevel_4(l, n, nodeOrder) {
    var node;
    node = nodeOrder[l][n];
    this.nPorts += node.ports.array.length;
};
_.nPorts = 0;
var Lorg_eclipse_elk_alg_layered_p3order_GreedyPortDistributor_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'GreedyPortDistributor', 1851);
function $clinit_InteractiveCrossingMinimizer() {
    $clinit_InteractiveCrossingMinimizer = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION_3 = $addAfter($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), LONG_EDGE_SPLITTER)), P4_NODE_PLACEMENT, IN_LAYER_CONSTRAINT_PROCESSOR), P5_EDGE_ROUTING, LONG_EDGE_JOINER);
}
function $getLayoutProcessorConfiguration(graph) {
    var configuration;
    configuration = createFrom_0(INTERMEDIATE_PROCESSING_CONFIGURATION_3);
    castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), NON_FREE_PORTS)) && $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), PORT_LIST_SORTER));
    return configuration;
}
function $getPos(node, horizPos) {
    var bendpoints, edge, originNode, originPort, point1, point2, pointIter, source, sourcePoint, target, targetPoint;
    switch(node.type_0.ordinal){
        case 1:
            edge = castTo($getProperty(node, ($clinit_InternalProperties_1(), ORIGIN_0)), 18);
            bendpoints = castTo($getProperty(edge, ORIGINAL_BENDPOINTS), 77);
            !bendpoints ? bendpoints = new KVectorChain : $booleanValue(castToBoolean($getProperty(edge, REVERSED))) && (bendpoints = reverse_3(bendpoints));
            source = castTo($getProperty(node, LONG_EDGE_SOURCE), 11);
            if (source) {
                sourcePoint = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    source.owner.pos,
                    source.pos,
                    source.anchor
                ]));
                if (horizPos <= sourcePoint.x_0) return sourcePoint.y_0;
                $addNode_0(bendpoints, sourcePoint, bendpoints.header, bendpoints.header.next_0);
            }
            target = castTo($getProperty(node, LONG_EDGE_TARGET), 11);
            if (target) {
                targetPoint = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    target.owner.pos,
                    target.pos,
                    target.anchor
                ]));
                if (targetPoint.x_0 <= horizPos) return targetPoint.y_0;
                $addNode_0(bendpoints, targetPoint, bendpoints.tail.prev, bendpoints.tail);
            }
            if (bendpoints.size_0 >= 2) {
                pointIter = $listIterator_2(bendpoints, 0);
                point1 = castTo($next_9(pointIter), 8);
                point2 = castTo($next_9(pointIter), 8);
                while(point2.x_0 < horizPos && pointIter.currentNode != pointIter.this$01.tail){
                    point1 = point2;
                    point2 = castTo($next_9(pointIter), 8);
                }
                return point1.y_0 + (horizPos - point1.x_0) / (point2.x_0 - point1.x_0) * (point2.y_0 - point1.y_0);
            }
            break;
        case 3:
            originPort = castTo($getProperty(castTo($get_11(node.ports, 0), 11), ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
            originNode = originPort.owner;
            switch(originPort.side.ordinal){
                case 1:
                    return originNode.pos.y_0;
                case 3:
                    return originNode.pos.y_0 + originNode.size_0.y_0;
            }
    }
    return $getInteractiveReferencePoint(node).y_0;
}
function $process_71(layeredGraph, monitor) {
    var horizPos, layer, layer$iterator, layer$iterator0, layerIndex, nextIndex, node, node$iterator, node$iterator0, nodeCount, nodeOrder, port, port$iterator, portCount, portDistributor, pos;
    monitor.begin('Interactive crossing minimization', 1);
    layerIndex = 0;
    for(layer$iterator0 = new ArrayList$1(layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        layer.id_0 = layerIndex++;
    }
    nodeOrder = $toNodeArray(layeredGraph);
    portDistributor = new NodeRelativePortDistributor(nodeOrder.length);
    init_0(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p3order_counting_IInitializable_2_classLit, 1), $intern_2, 229, 0, [
        portDistributor
    ])), nodeOrder);
    portCount = 0;
    layerIndex = 0;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        horizPos = 0;
        nodeCount = 0;
        for(node$iterator0 = new ArrayList$1(layer.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            if (node.pos.x_0 > 0) {
                horizPos += node.pos.x_0 + node.size_0.x_0 / 2;
                ++nodeCount;
            }
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                port.id_0 = portCount++;
            }
        }
        nodeCount > 0 && (horizPos /= nodeCount);
        pos = initUnidimensionalArray(D_classLit, $intern_66, 30, layer.nodes.array.length, 15, 1);
        nextIndex = 0;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.id_0 = nextIndex++;
            pos[node.id_0] = $getPos(node, horizPos);
            node.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) && $setProperty_0(node, ($clinit_InternalProperties_1(), ORIGINAL_DUMMY_NODE_POSITION), pos[node.id_0]);
        }
        $clinit_Collections();
        $sort(layer.nodes, new InteractiveCrossingMinimizer$1(pos));
        $distributePortsWhileSweeping(portDistributor, nodeOrder, layerIndex, true);
        ++layerIndex;
    }
    monitor.done_1();
}
function InteractiveCrossingMinimizer() {
    $clinit_InteractiveCrossingMinimizer();
}
defineClass(1360, 1, $intern_110, InteractiveCrossingMinimizer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_12(graph) {
    return $getLayoutProcessorConfiguration(castTo(graph, 36));
};
_.process = function process_68(layeredGraph, monitor) {
    $process_71(castTo(layeredGraph, 36), monitor);
};
var INTERMEDIATE_PROCESSING_CONFIGURATION_3;
var Lorg_eclipse_elk_alg_layered_p3order_InteractiveCrossingMinimizer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'InteractiveCrossingMinimizer', 1360);
function $compare_17(this$static, node1, node2) {
    var compare, node1Successors, node2Successors;
    compare = compare_4(this$static.val$pos2[node1.id_0], this$static.val$pos2[node2.id_0]);
    if (compare == 0) {
        node1Successors = castTo($getProperty(node1, ($clinit_InternalProperties_1(), IN_LAYER_SUCCESSOR_CONSTRAINTS)), 15);
        node2Successors = castTo($getProperty(node2, IN_LAYER_SUCCESSOR_CONSTRAINTS), 15);
        if (node1Successors.contains(node2)) return -1;
        else if (node2Successors.contains(node1)) return 1;
    }
    return compare;
}
function InteractiveCrossingMinimizer$1(val$pos) {
    this.val$pos2 = val$pos;
}
defineClass(1361, 1, $intern_88, InteractiveCrossingMinimizer$1);
_.compare_1 = function compare_65(node1, node2) {
    return $compare_17(this, castTo(node1, 9), castTo(node2, 9));
};
_.equals_0 = function equals_146(other) {
    return this === other;
};
_.reversed = function reversed_57() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_InteractiveCrossingMinimizer$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'InteractiveCrossingMinimizer/1', 1361);
function $clinit_LayerSweepCrossingMinimizer() {
    $clinit_LayerSweepCrossingMinimizer = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION_4 = $add_17($after($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), LONG_EDGE_SPLITTER)), P4_NODE_PLACEMENT, IN_LAYER_CONSTRAINT_PROCESSOR), P5_EDGE_ROUTING), LONG_EDGE_JOINER);
}
function $compareDifferentRandomizedLayouts(this$static, gData) {
    var bestCrossings, crossings, i, thouroughness;
    $setSeed_0(this$static.random_0, this$static.randomSeed);
    this$static.graphsWhoseNodeOrderChanged.map_0.clear_0();
    if ($doubleValue(castToDouble($getProperty(gData.lGraph, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE_0)))) != 0 || $doubleValue(castToDouble($getProperty(gData.lGraph, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE_0))) != 0) {
        bestCrossings = $intern_113;
        maskUndefined($getProperty(gData.lGraph, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) && $setProperty_0(gData.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER), ($clinit_Boolean(), true));
        thouroughness = castTo($getProperty(gData.lGraph, THOROUGHNESS_0), 17).value_0;
        for(i = 0; i < thouroughness; i++){
            crossings = $minimizeCrossingsNodePortOrderWithCounter(this$static, gData);
            if (crossings < bestCrossings) {
                bestCrossings = crossings;
                $saveAllNodeOrdersOfChangedGraphs(this$static);
                if (bestCrossings == 0) break;
            }
        }
    } else {
        bestCrossings = $intern_0;
        maskUndefined($getProperty(gData.lGraph, CONSIDER_MODEL_ORDER_STRATEGY_0)) !== maskUndefined(($clinit_OrderingStrategy(), NONE_11)) && $setProperty_0(gData.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER), ($clinit_Boolean(), true));
        thouroughness = castTo($getProperty(gData.lGraph, THOROUGHNESS_0), 17).value_0;
        for(i = 0; i < thouroughness; i++){
            crossings = $minimizeCrossingsWithCounter(this$static, gData);
            if (crossings < bestCrossings) {
                bestCrossings = crossings;
                $saveAllNodeOrdersOfChangedGraphs(this$static);
                if (bestCrossings == 0) break;
            }
        }
    }
}
function $countCurrentNumberOfCrossings(this$static, currentGraph) {
    var child, childLGraph, childLGraph$iterator, countCrossingsIn, gD, totalCrossings;
    totalCrossings = 0;
    countCrossingsIn = new ArrayDeque;
    $addFirst(countCrossingsIn, currentGraph);
    while(countCrossingsIn.head != countCrossingsIn.tail){
        gD = castTo($removeFirst(countCrossingsIn), 217);
        totalCrossings += $countAllCrossings(gD.crossingsCounter, gD.currentNodeOrder);
        for(childLGraph$iterator = new ArrayList$1(gD.childGraphs); childLGraph$iterator.i < childLGraph$iterator.this$01.array.length;){
            childLGraph = castTo($next_6(childLGraph$iterator), 36);
            child = castTo($get_11(this$static.graphInfoHolders, childLGraph.id_0), 217);
            child.useBottomUp || (totalCrossings += $countCurrentNumberOfCrossings(this$static, child));
        }
    }
    return totalCrossings;
}
function $countCurrentNumberOfCrossingsNodePortOrder(this$static, currentGraph) {
    var child, childLGraph, childLGraph$iterator, countCrossingsIn, crossingCounterNodeInfluence, crossingCounterPortInfluence, gD, modelOrderInfluence, modelOrderStrategy, totalCrossings;
    totalCrossings = 0;
    countCrossingsIn = new ArrayDeque;
    $addFirst(countCrossingsIn, currentGraph);
    while(countCrossingsIn.head != countCrossingsIn.tail){
        gD = castTo($removeFirst(countCrossingsIn), 217);
        modelOrderInfluence = 0;
        modelOrderStrategy = castTo($getProperty(currentGraph.lGraph, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_STRATEGY_0)), 266);
        crossingCounterNodeInfluence = $doubleValue(castToDouble($getProperty(currentGraph.lGraph, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_NODE_INFLUENCE_0)));
        crossingCounterPortInfluence = $doubleValue(castToDouble($getProperty(currentGraph.lGraph, CONSIDER_MODEL_ORDER_CROSSING_COUNTER_PORT_INFLUENCE_0)));
        if (modelOrderStrategy != ($clinit_OrderingStrategy(), NONE_11)) {
            modelOrderInfluence += crossingCounterNodeInfluence * $countModelOrderNodeChanges(gD.currentNodeOrder, modelOrderStrategy);
            modelOrderInfluence += crossingCounterPortInfluence * $countModelOrderPortChanges(gD.currentNodeOrder);
        }
        totalCrossings += $countAllCrossings(gD.crossingsCounter, gD.currentNodeOrder) + modelOrderInfluence;
        for(childLGraph$iterator = new ArrayList$1(gD.childGraphs); childLGraph$iterator.i < childLGraph$iterator.this$01.array.length;){
            childLGraph = castTo($next_6(childLGraph$iterator), 36);
            child = castTo($get_11(this$static.graphInfoHolders, childLGraph.id_0), 217);
            child.useBottomUp || (totalCrossings += $countCurrentNumberOfCrossings(this$static, child));
        }
    }
    return totalCrossings;
}
function $countModelOrderNodeChanges(layers, strategy) {
    var comp, i, j, layer, layer$array, layer$index, layer$max, previousLayer, wrongModelOrder;
    previousLayer = -1;
    wrongModelOrder = 0;
    for(layer$array = layers, layer$index = 0, layer$max = layer$array.length; layer$index < layer$max; ++layer$index){
        layer = layer$array[layer$index];
        comp = new ModelOrderNodeComparator_1(previousLayer == -1 ? layers[0] : layers[previousLayer], strategy, ($clinit_LongEdgeOrderingStrategy(), EQUAL));
        for(i = 0; i < layer.length; i++)for(j = i + 1; j < layer.length; j++)$hasProperty(layer[i], ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(layer[j], MODEL_ORDER_1) && $compare_11(comp, layer[i], layer[j]) > 0 && ++wrongModelOrder;
        ++previousLayer;
    }
    return wrongModelOrder;
}
function $countModelOrderPortChanges(layers) {
    var comp, i, j, lNode, lNode$array, lNode$index, lNode$max, layer, layer$array, layer$index, layer$max, previousLayer, wrongModelOrder;
    previousLayer = -1;
    wrongModelOrder = 0;
    for(layer$array = layers, layer$index = 0, layer$max = layer$array.length; layer$index < layer$max; ++layer$index){
        layer = layer$array[layer$index];
        for(lNode$array = layer, lNode$index = 0, lNode$max = lNode$array.length; lNode$index < lNode$max; ++lNode$index){
            lNode = lNode$array[lNode$index];
            comp = new ModelOrderPortComparator_0(previousLayer == -1 ? layers[0] : layers[previousLayer], castTo($getProperty($getGraph(lNode), ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_STRATEGY_0)), 266), longEdgeTargetNodePreprocessing(lNode), $booleanValue(castToBoolean($getProperty($getGraph(lNode), CONSIDER_MODEL_ORDER_PORT_MODEL_ORDER_0))));
            for(i = 0; i < lNode.ports.array.length; i++)for(j = i + 1; j < lNode.ports.array.length; j++)$compare_12(comp, castTo($get_11(lNode.ports, i), 11), castTo($get_11(lNode.ports, j), 11)) > 0 && ++wrongModelOrder;
        }
        ++previousLayer;
    }
    return wrongModelOrder;
}
function $endIndex(isForwardSweep, length_0) {
    return isForwardSweep ? length_0 - 1 : 0;
}
function $firstIndex(isForwardSweep, length_0) {
    return isForwardSweep ? 0 : length_0 - 1;
}
function $initialize_5(this$static, rootGraph) {
    var gData, graph, graphs, graphsToSweepOn, i, iter;
    this$static.graphInfoHolders = new ArrayList;
    this$static.random_0 = castTo($getProperty(rootGraph, ($clinit_InternalProperties_1(), RANDOM_0)), 233);
    this$static.randomSeed = $nextLong(this$static.random_0);
    graphsToSweepOn = new LinkedList;
    graphs = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LGraph_2_classLit, 1), $intern_101, 36, 0, [
        rootGraph
    ]));
    i = 0;
    while(i < graphs.array.length){
        graph = (checkCriticalElementIndex(i, graphs.array.length), castTo(graphs.array[i], 36));
        graph.id_0 = i++;
        gData = new GraphInfoHolder(graph, this$static.crossMinType, this$static.graphInfoHolders);
        $addAll_2(graphs, gData.childGraphs);
        $add_3(this$static.graphInfoHolders, gData);
        gData.useBottomUp && (iter = $listIterator_2(graphsToSweepOn, 0), $add_8(iter, gData));
    }
    this$static.graphsWhoseNodeOrderChanged = new HashSet;
    return graphsToSweepOn;
}
function $minimizeCrossings(graphsToSweepOn, minimizingMethod) {
    var gData, gData$iterator;
    for(gData$iterator = $listIterator_2(graphsToSweepOn, 0); gData$iterator.currentNode != gData$iterator.this$01.tail;){
        gData = castTo($next_9(gData$iterator), 217);
        if (gData.currentNodeOrder.length > 0) {
            minimizingMethod.accept(gData);
            gData.hasParent && $setPortOrderOnParentGraph(gData);
        }
    }
}
function $minimizeCrossingsNoCounter(this$static, gData) {
    var improved, isForwardSweep;
    isForwardSweep = $nextInternal(this$static.random_0, 1) != 0;
    improved = true;
    while(improved){
        improved = false;
        improved = gData.crossMinimizer.setFirstLayerOrder(gData.currentNodeOrder, isForwardSweep);
        improved = improved | $sweepReducingCrossings(this$static, gData, isForwardSweep, false);
        isForwardSweep = !isForwardSweep;
    }
    $setCurrentlyBestNodeOrders(this$static);
}
function $minimizeCrossingsNodePortOrderWithCounter(this$static, gData) {
    var crossingsInGraph, initialCrossings, isForwardSweep, oldNumberOfCrossings;
    isForwardSweep = $nextInternal(this$static.random_0, 1) != 0;
    initialCrossings = $countCurrentNumberOfCrossingsNodePortOrder(this$static, gData);
    if (initialCrossings == 0 && $booleanValue(castToBoolean($getProperty(gData.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER))))) return 0;
    !$booleanValue(castToBoolean($getProperty(gData.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER)))) && !$booleanValue(castToBoolean($getProperty(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER))) || maskUndefined($getProperty(gData.lGraph, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_STRATEGY_0))) === maskUndefined(($clinit_OrderingStrategy(), NONE_11)) ? gData.crossMinimizer.setFirstLayerOrder(gData.currentNodeOrder, isForwardSweep) : isForwardSweep = $booleanValue(castToBoolean($getProperty(gData.lGraph, FIRST_TRY_WITH_INITIAL_ORDER)));
    $sweepReducingCrossings(this$static, gData, isForwardSweep, true);
    $booleanValue(castToBoolean($getProperty(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER))) && $setProperty_0(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER, ($clinit_Boolean(), false));
    if ($booleanValue(castToBoolean($getProperty(gData.lGraph, FIRST_TRY_WITH_INITIAL_ORDER)))) {
        $setProperty_0(gData.lGraph, FIRST_TRY_WITH_INITIAL_ORDER, ($clinit_Boolean(), false));
        $setProperty_0(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER, true);
    }
    crossingsInGraph = $countCurrentNumberOfCrossingsNodePortOrder(this$static, gData);
    do {
        $setCurrentlyBestNodeOrders(this$static);
        if (crossingsInGraph == 0) return 0;
        isForwardSweep = !isForwardSweep;
        oldNumberOfCrossings = crossingsInGraph;
        $sweepReducingCrossings(this$static, gData, isForwardSweep, false);
        crossingsInGraph = $countCurrentNumberOfCrossingsNodePortOrder(this$static, gData);
    }while (oldNumberOfCrossings > crossingsInGraph);
    return oldNumberOfCrossings;
}
function $minimizeCrossingsWithCounter(this$static, gData) {
    var crossingsInGraph, initialCrossings, isForwardSweep, oldNumberOfCrossings;
    isForwardSweep = $nextInternal(this$static.random_0, 1) != 0;
    initialCrossings = $countCurrentNumberOfCrossings(this$static, gData);
    if (initialCrossings == 0 && $booleanValue(castToBoolean($getProperty(gData.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER))))) return 0;
    !$booleanValue(castToBoolean($getProperty(gData.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER)))) && !$booleanValue(castToBoolean($getProperty(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER))) || maskUndefined($getProperty(gData.lGraph, ($clinit_LayeredOptions(), CONSIDER_MODEL_ORDER_STRATEGY_0))) === maskUndefined(($clinit_OrderingStrategy(), NONE_11)) ? gData.crossMinimizer.setFirstLayerOrder(gData.currentNodeOrder, isForwardSweep) : isForwardSweep = $booleanValue(castToBoolean($getProperty(gData.lGraph, FIRST_TRY_WITH_INITIAL_ORDER)));
    $sweepReducingCrossings(this$static, gData, isForwardSweep, true);
    $booleanValue(castToBoolean($getProperty(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER))) && $setProperty_0(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER, ($clinit_Boolean(), false));
    if ($booleanValue(castToBoolean($getProperty(gData.lGraph, FIRST_TRY_WITH_INITIAL_ORDER)))) {
        $setProperty_0(gData.lGraph, FIRST_TRY_WITH_INITIAL_ORDER, ($clinit_Boolean(), false));
        $setProperty_0(gData.lGraph, SECOND_TRY_WITH_INITIAL_ORDER, true);
    }
    crossingsInGraph = $countCurrentNumberOfCrossings(this$static, gData);
    do {
        $setCurrentlyBestNodeOrders(this$static);
        if (crossingsInGraph == 0) return 0;
        isForwardSweep = !isForwardSweep;
        oldNumberOfCrossings = crossingsInGraph;
        $sweepReducingCrossings(this$static, gData, isForwardSweep, false);
        crossingsInGraph = $countCurrentNumberOfCrossings(this$static, gData);
    }while (oldNumberOfCrossings > crossingsInGraph);
    return oldNumberOfCrossings;
}
function $process_72(this$static, layeredGraph, progressMonitor) {
    var emptyGraph, graphsToSweepOn, hierarchicalLayout, minimizingMethod, parent_0, singleNode;
    progressMonitor.begin('Minimize Crossings ' + this$static.crossMinType, 1);
    emptyGraph = layeredGraph.layers.array.length == 0 || !$spliterator($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(layeredGraph.layers, 16)), new Predicate$lambda$2$Type(new LayerSweepCrossingMinimizer$lambda$0$Type))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER));
    singleNode = layeredGraph.layers.array.length == 1 && castTo($get_11(layeredGraph.layers, 0), 25).nodes.array.length == 1;
    hierarchicalLayout = maskUndefined($getProperty(layeredGraph, ($clinit_LayeredOptions(), HIERARCHY_HANDLING))) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN));
    if (emptyGraph || singleNode && !hierarchicalLayout) {
        progressMonitor.done_1();
        return;
    }
    graphsToSweepOn = $initialize_5(this$static, layeredGraph);
    minimizingMethod = (parent_0 = castTo($get_7(graphsToSweepOn, 0), 217), parent_0.crossMinimizer.isDeterministic() ? parent_0.crossMinimizer.alwaysImproves() ? new LayerSweepCrossingMinimizer$1methodref$minimizeCrossingsNoCounter$Type(this$static) : new LayerSweepCrossingMinimizer$2methodref$minimizeCrossingsWithCounter$Type(this$static) : new LayerSweepCrossingMinimizer$0methodref$compareDifferentRandomizedLayouts$Type(this$static));
    $minimizeCrossings(graphsToSweepOn, minimizingMethod);
    $transferNodeAndPortOrdersToGraph(this$static);
    progressMonitor.done_1();
}
function $saveAllNodeOrdersOfChangedGraphs(this$static) {
    var graph, graph$iterator;
    for(graph$iterator = this$static.graphsWhoseNodeOrderChanged.map_0.keySet_0().iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 217);
        $setBestNodeNPortOrder(graph, new SweepCopy(graph.currentlyBestNodeAndPortOrder));
    }
}
function $setCurrentlyBestNodeOrders(this$static) {
    var graph, graph$iterator;
    for(graph$iterator = this$static.graphsWhoseNodeOrderChanged.map_0.keySet_0().iterator_0(); graph$iterator.hasNext_0();){
        graph = castTo(graph$iterator.next_1(), 217);
        $setCurrentlyBestNodeAndPortOrder(graph, new SweepCopy_0(graph.currentNodeOrder));
    }
}
function $setPortOrderOnParentGraph(gData) {
    var bestSweep;
    if (gData.hasExternalPorts) {
        bestSweep = gData.crossMinimizer.isDeterministic() ? gData.currentlyBestNodeAndPortOrder : gData.bestNodeAndPortOrder;
        $sortPortsByDummyPositionsInLastLayer(bestSweep.nodeOrder, gData.parent_0, true);
        $sortPortsByDummyPositionsInLastLayer(bestSweep.nodeOrder, gData.parent_0, false);
        $setProperty_0(gData.parent_0, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0), ($clinit_PortConstraints(), FIXED_ORDER));
    }
}
function $sortPortDummiesByPortPositions(parentNode, layerCloseToNodeEdge, side) {
    var i, port, port$iterator, ports, sortedDummies;
    ports = inNorthSouthEastWestOrder(parentNode, side);
    sortedDummies = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, layerCloseToNodeEdge.length, 0, 1);
    i = 0;
    for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        $booleanValue(castToBoolean($getProperty(port, ($clinit_InternalProperties_1(), INSIDE_CONNECTIONS)))) && (sortedDummies[i++] = castTo($getProperty(port, PORT_DUMMY), 9));
    }
    if (i < layerCloseToNodeEdge.length) throw toJs(new IllegalStateException_0('Expected ' + layerCloseToNodeEdge.length + ' hierarchical ports, but found only ' + i + '.'));
    return sortedDummies;
}
function $sortPortsByDummyPositionsInLastLayer(nodeOrder, parent_0, onRightMostLayer) {
    var endIndex, i, j, lastLayer, port, ports;
    endIndex = $endIndex(onRightMostLayer, nodeOrder.length);
    lastLayer = nodeOrder[endIndex];
    j = $firstIndex(onRightMostLayer, lastLayer.length);
    if (lastLayer[j].type_0 != ($clinit_LNode$NodeType(), EXTERNAL_PORT)) return;
    ports = parent_0.ports;
    for(i = 0; i < ports.array.length; i++){
        port = (checkCriticalElementIndex(i, ports.array.length), castTo(ports.array[i], 11));
        if ((onRightMostLayer ? port.side == ($clinit_PortSide(), EAST_0) : port.side == ($clinit_PortSide(), WEST_0)) && $booleanValue(castToBoolean($getProperty(port, ($clinit_InternalProperties_1(), INSIDE_CONNECTIONS))))) {
            $set_1(ports, i, castTo($getProperty(lastLayer[j], ($clinit_InternalProperties_1(), ORIGIN_0)), 11));
            j += onRightMostLayer ? 1 : -1;
        }
    }
}
function $sweepInHierarchicalNodes(this$static, layer, isForwardSweep, isFirstSweep) {
    var improved, node, node$array, node$index, node$max, nestedLGraph, nestedGraph, nestedGraphNodeOrder, startIndex, firstNode, improved_0;
    improved = false;
    for(node$array = layer, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        $booleanValue(($clinit_Boolean(), node.nestedGraph ? true : false)) && !castTo($get_11(this$static.graphInfoHolders, node.nestedGraph.id_0), 217).useBottomUp && (improved = improved | (nestedLGraph = node.nestedGraph, nestedGraph = castTo($get_11(this$static.graphInfoHolders, nestedLGraph.id_0), 217), nestedGraphNodeOrder = nestedGraph.currentNodeOrder, startIndex = $firstIndex(isForwardSweep, nestedGraphNodeOrder.length), firstNode = nestedGraphNodeOrder[startIndex][0], firstNode.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) ? nestedGraphNodeOrder[startIndex] = $sortPortDummiesByPortPositions(node, nestedGraphNodeOrder[startIndex], isForwardSweep ? ($clinit_PortSide(), WEST_0) : ($clinit_PortSide(), EAST_0)) : nestedGraph.crossMinimizer.setFirstLayerOrder(nestedGraphNodeOrder, isForwardSweep), improved_0 = $sweepReducingCrossings(this$static, nestedGraph, isForwardSweep, isFirstSweep), $sortPortsByDummyPositionsInLastLayer(nestedGraph.currentNodeOrder, nestedGraph.parent_0, isForwardSweep), improved_0));
    }
    return improved;
}
function $sweepReducingCrossings(this$static, graph, forward_0, firstSweep) {
    var firstLayer, i, improved, length_0, nodes;
    nodes = graph.currentNodeOrder;
    length_0 = nodes.length;
    improved = graph.portDistributor.distributePortsWhileSweeping(nodes, forward_0 ? 0 : length_0 - 1, forward_0);
    firstLayer = nodes[forward_0 ? 0 : length_0 - 1];
    improved = improved | $sweepInHierarchicalNodes(this$static, firstLayer, forward_0, firstSweep);
    for(i = forward_0 ? 1 : length_0 - 2; forward_0 ? i < length_0 : i >= 0; i += forward_0 ? 1 : -1){
        improved = improved | graph.crossMinimizer.minimizeCrossings(nodes, i, forward_0, firstSweep && !$booleanValue(castToBoolean($getProperty(graph.lGraph, ($clinit_InternalProperties_1(), FIRST_TRY_WITH_INITIAL_ORDER)))) && !$booleanValue(castToBoolean($getProperty(graph.lGraph, ($clinit_InternalProperties_1(), SECOND_TRY_WITH_INITIAL_ORDER)))));
        improved = improved | graph.portDistributor.distributePortsWhileSweeping(nodes, i, forward_0);
        improved = improved | $sweepInHierarchicalNodes(this$static, nodes[i], forward_0, firstSweep);
    }
    $add_6(this$static.graphsWhoseNodeOrderChanged, graph);
    return improved;
}
function $transferNodeAndPortOrdersToGraph(this$static) {
    var bestSweep, gD, gD$iterator;
    for(gD$iterator = new ArrayList$1(this$static.graphInfoHolders); gD$iterator.i < gD$iterator.this$01.array.length;){
        gD = castTo($next_6(gD$iterator), 217);
        bestSweep = gD.crossMinimizer.isDeterministic() ? gD.currentlyBestNodeAndPortOrder : gD.bestNodeAndPortOrder;
        !!bestSweep && $transferNodeAndPortOrdersToGraph_0(bestSweep, gD.lGraph);
    }
}
function LayerSweepCrossingMinimizer(cT) {
    $clinit_LayerSweepCrossingMinimizer();
    this.crossMinType = cT;
}
defineClass(498, 1, {
    498: 1,
    106: 1,
    44: 1
}, LayerSweepCrossingMinimizer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_13(graph) {
    var configuration;
    return castTo(graph, 36), configuration = createFrom_0(INTERMEDIATE_PROCESSING_CONFIGURATION_4), $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), PORT_LIST_SORTER)), configuration;
};
_.process = function process_69(layeredGraph, progressMonitor) {
    $process_72(this, castTo(layeredGraph, 36), progressMonitor);
};
_.randomSeed = 0;
var INTERMEDIATE_PROCESSING_CONFIGURATION_4;
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepCrossingMinimizer', 498);
function LayerSweepCrossingMinimizer$0methodref$compareDifferentRandomizedLayouts$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1357, 1, $intern_19, LayerSweepCrossingMinimizer$0methodref$compareDifferentRandomizedLayouts$Type);
_.accept = function accept_114(arg0) {
    $compareDifferentRandomizedLayouts(this.$$outer_0, castTo(arg0, 217));
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$0methodref$compareDifferentRandomizedLayouts$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepCrossingMinimizer/0methodref$compareDifferentRandomizedLayouts$Type', 1357);
function LayerSweepCrossingMinimizer$1methodref$minimizeCrossingsNoCounter$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1358, 1, $intern_19, LayerSweepCrossingMinimizer$1methodref$minimizeCrossingsNoCounter$Type);
_.accept = function accept_115(arg0) {
    $minimizeCrossingsNoCounter(this.$$outer_0, castTo(arg0, 217));
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$1methodref$minimizeCrossingsNoCounter$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepCrossingMinimizer/1methodref$minimizeCrossingsNoCounter$Type', 1358);
function LayerSweepCrossingMinimizer$2methodref$minimizeCrossingsWithCounter$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1359, 1, $intern_19, LayerSweepCrossingMinimizer$2methodref$minimizeCrossingsWithCounter$Type);
_.accept = function accept_116(arg0) {
    $minimizeCrossingsWithCounter(this.$$outer_0, castTo(arg0, 217));
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$2methodref$minimizeCrossingsWithCounter$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepCrossingMinimizer/2methodref$minimizeCrossingsWithCounter$Type', 1359);
function $clinit_LayerSweepCrossingMinimizer$CrossMinType() {
    $clinit_LayerSweepCrossingMinimizer$CrossMinType = emptyMethod;
    BARYCENTER = new LayerSweepCrossingMinimizer$CrossMinType('BARYCENTER', 0);
    ONE_SIDED_GREEDY_SWITCH_0 = new LayerSweepCrossingMinimizer$CrossMinType('ONE_SIDED_GREEDY_SWITCH', 1);
    TWO_SIDED_GREEDY_SWITCH_0 = new LayerSweepCrossingMinimizer$CrossMinType('TWO_SIDED_GREEDY_SWITCH', 2);
}
function LayerSweepCrossingMinimizer$CrossMinType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_60(name_0) {
    $clinit_LayerSweepCrossingMinimizer$CrossMinType();
    return valueOf(($clinit_LayerSweepCrossingMinimizer$CrossMinType$Map(), $MAP_50), name_0);
}
function values_68() {
    $clinit_LayerSweepCrossingMinimizer$CrossMinType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$CrossMinType_2_classLit, 1), $intern_36, 450, 0, [
        BARYCENTER,
        ONE_SIDED_GREEDY_SWITCH_0,
        TWO_SIDED_GREEDY_SWITCH_0
    ]);
}
defineClass(450, 23, {
    3: 1,
    34: 1,
    23: 1,
    450: 1
}, LayerSweepCrossingMinimizer$CrossMinType);
var BARYCENTER, ONE_SIDED_GREEDY_SWITCH_0, TWO_SIDED_GREEDY_SWITCH_0;
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$CrossMinType_2_classLit = createForEnum('org.eclipse.elk.alg.layered.p3order', 'LayerSweepCrossingMinimizer/CrossMinType', 450, Ljava_lang_Enum_2_classLit, values_68, valueOf_60);
function $clinit_LayerSweepCrossingMinimizer$CrossMinType$Map() {
    $clinit_LayerSweepCrossingMinimizer$CrossMinType$Map = emptyMethod;
    $MAP_50 = createValueOfMap(($clinit_LayerSweepCrossingMinimizer$CrossMinType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$CrossMinType_2_classLit, 1), $intern_36, 450, 0, [
        BARYCENTER,
        ONE_SIDED_GREEDY_SWITCH_0,
        TWO_SIDED_GREEDY_SWITCH_0
    ])));
}
var $MAP_50;
function LayerSweepCrossingMinimizer$lambda$0$Type() {}
defineClass(1356, 1, $intern_39, LayerSweepCrossingMinimizer$lambda$0$Type);
_.test_0 = function test_79(arg0) {
    return $clinit_LayerSweepCrossingMinimizer(), castTo(arg0, 25).nodes.array.length == 0;
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepCrossingMinimizer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepCrossingMinimizer/lambda$0$Type', 1356);
function $transferInfoTo(this$static, currentNode, target) {
    var targetNodeInfo;
    targetNodeInfo = this$static.nodeInfo[target.layer.id_0][target.id_0];
    targetNodeInfo.hierarchicalInfluence += currentNode.hierarchicalInfluence;
    targetNodeInfo.randomInfluence += currentNode.randomInfluence;
    targetNodeInfo.connectedEdges += currentNode.connectedEdges;
    ++targetNodeInfo.connectedEdges;
}
function $useBottomUp(this$static) {
    var allPaths, boundary, currentNode, eastPorts, edge, edge$iterator, layer, layer$array, layer$index, layer$max, node, node$array, node$index, node$iterator, node$max, normalized, northSouthPorts, nsDummy, nsPortDummies, pathsToHierarchical, pathsToRandom, port, port$iterator, target, westPorts;
    boundary = $doubleValue(castToDouble($getProperty(this$static.graphData.lGraph, ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_HIERARCHICAL_SWEEPINESS_0))));
    if (boundary < -1 || !this$static.graphData.hasParent || $isOrderFixed(castTo($getProperty(this$static.graphData.parent_0, PORT_CONSTRAINTS_0), 100)) || $getPortSideView(this$static.graphData.parent_0, ($clinit_PortSide(), EAST_0)).size_1() < 2 && $getPortSideView(this$static.graphData.parent_0, WEST_0).size_1() < 2) return true;
    if (this$static.graphData.crossMinimizer.isDeterministic()) return false;
    pathsToRandom = 0;
    pathsToHierarchical = 0;
    nsPortDummies = new ArrayList;
    for(layer$array = this$static.graphData.currentNodeOrder, layer$index = 0, layer$max = layer$array.length; layer$index < layer$max; ++layer$index){
        layer = layer$array[layer$index];
        for(node$array = layer, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            if (node.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT)) {
                push_1(nsPortDummies.array, node);
                continue;
            }
            currentNode = this$static.nodeInfo[node.layer.id_0][node.id_0];
            if (node.type_0 == EXTERNAL_PORT) {
                currentNode.hierarchicalInfluence = 1;
                castTo($getProperty(node, ($clinit_InternalProperties_1(), ORIGIN_0)), 11).side == ($clinit_PortSide(), EAST_0) && (pathsToHierarchical += currentNode.connectedEdges);
            } else {
                westPorts = $getPortSideView(node, ($clinit_PortSide(), WEST_0));
                westPorts.isEmpty() || !any_0(westPorts, new LayerSweepTypeDecider$lambda$1$Type) ? currentNode.randomInfluence = 1 : (eastPorts = $getPortSideView(node, EAST_0), (eastPorts.isEmpty() || !any_0(eastPorts, new LayerSweepTypeDecider$lambda$0$Type)) && (pathsToRandom += currentNode.connectedEdges));
            }
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                pathsToRandom += currentNode.randomInfluence;
                pathsToHierarchical += currentNode.hierarchicalInfluence;
                target = edge.target.owner;
                $transferInfoTo(this$static, currentNode, target);
            }
            northSouthPorts = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                $getPortSideView(node, ($clinit_PortSide(), NORTH_1)),
                $getPortSideView(node, SOUTH_0)
            ]));
            for(port$iterator = new Iterators$ConcatenatedIterator(new FluentIterable$3$1(northSouthPorts.val$inputs1.length, northSouthPorts.val$inputs1)); $hasNext_1(port$iterator);){
                port = castTo($next_0(port$iterator), 11);
                nsDummy = castTo($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
                if (nsDummy) {
                    pathsToRandom += currentNode.randomInfluence;
                    pathsToHierarchical += currentNode.hierarchicalInfluence;
                    $transferInfoTo(this$static, currentNode, nsDummy);
                }
            }
        }
        for(node$iterator = new ArrayList$1(nsPortDummies); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            currentNode = this$static.nodeInfo[node.layer.id_0][node.id_0];
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                pathsToRandom += currentNode.randomInfluence;
                pathsToHierarchical += currentNode.hierarchicalInfluence;
                target = edge.target.owner;
                $transferInfoTo(this$static, currentNode, target);
            }
        }
        nsPortDummies.array.length = 0;
    }
    allPaths = pathsToRandom + pathsToHierarchical;
    normalized = allPaths == 0 ? $intern_60 : (pathsToRandom - pathsToHierarchical) / allPaths;
    return normalized >= boundary;
}
function LayerSweepTypeDecider(graphData) {
    this.graphData = graphData;
    this.nodeInfo = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_LayerSweepTypeDecider$NodeInfo_2_classLit, $intern_16, 1989, graphData.currentNodeOrder.length, 0, 2);
}
defineClass(1808, 1, $intern_108, LayerSweepTypeDecider);
_.initAfterTraversal = function initAfterTraversal_5() {};
_.initAtEdgeLevel = function initAtEdgeLevel_5(l, n, p, e, edge, nodeOrder) {};
_.initAtPortLevel = function initAtPortLevel_5(l, n, p, nodeOrder) {};
_.initAtLayerLevel = function initAtLayerLevel_5(l, nodeOrder) {
    nodeOrder[l][0].layer.id_0 = l;
    this.nodeInfo[l] = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_LayerSweepTypeDecider$NodeInfo_2_classLit, {
        3: 1,
        4: 1,
        5: 1,
        1989: 1
    }, 653, nodeOrder[l].length, 0, 1);
};
_.initAtNodeLevel = function initAtNodeLevel_5(l, n, nodeOrder) {
    var node;
    node = nodeOrder[l][n];
    node.id_0 = n;
    setCheck(this.nodeInfo[l], n, new LayerSweepTypeDecider$NodeInfo);
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepTypeDecider_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepTypeDecider', 1808);
function LayerSweepTypeDecider$NodeInfo() {}
defineClass(653, 1, {
    653: 1
}, LayerSweepTypeDecider$NodeInfo);
_.toString_0 = function toString_99() {
    return 'NodeInfo [connectedEdges=' + this.connectedEdges + ', hierarchicalInfluence=' + this.hierarchicalInfluence + ', randomInfluence=' + this.randomInfluence + ']';
};
_.connectedEdges = 0;
_.hierarchicalInfluence = 0;
_.randomInfluence = 0;
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepTypeDecider$NodeInfo_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepTypeDecider/NodeInfo', 653);
function LayerSweepTypeDecider$lambda$0$Type() {}
defineClass(1809, 1, $intern_89, LayerSweepTypeDecider$lambda$0$Type);
_.apply_1 = function apply_109(arg0) {
    return $hasNext_6(new LPort$CombineIter$1(castTo(arg0, 11).connectedEdges));
};
_.equals_0 = function equals_147(other) {
    return this === other;
};
_.test_0 = function test_80(input_0) {
    return $hasNext_6(new LPort$CombineIter$1(castTo(input_0, 11).connectedEdges));
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepTypeDecider$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepTypeDecider/lambda$0$Type', 1809);
function LayerSweepTypeDecider$lambda$1$Type() {}
defineClass(1810, 1, $intern_89, LayerSweepTypeDecider$lambda$1$Type);
_.apply_1 = function apply_110(arg0) {
    return $hasNext_6(new LPort$CombineIter$1(castTo(arg0, 11).connectedEdges));
};
_.equals_0 = function equals_148(other) {
    return this === other;
};
_.test_0 = function test_81(input_0) {
    return $hasNext_6(new LPort$CombineIter$1(castTo(input_0, 11).connectedEdges));
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerSweepTypeDecider$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerSweepTypeDecider/lambda$1$Type', 1810);
function LayerTotalPortDistributor(numLayers) {
    AbstractBarycenterPortDistributor.call(this, numLayers);
}
defineClass(1852, 402, $intern_111, LayerTotalPortDistributor);
_.calculatePortRanks = function calculatePortRanks(node, rankSum, type_0) {
    var inputCount, northInputCount, northPos, port, port$iterator, port$iterator0, portRanks, pos, restPos;
    portRanks = this.portRanks;
    switch(type_0.ordinal){
        case 1:
            inputCount = 0;
            northInputCount = 0;
            for(port$iterator0 = new ArrayList$1(node.ports); port$iterator0.i < port$iterator0.this$01.array.length;){
                port = castTo($next_6(port$iterator0), 11);
                if (port.incomingEdges.array.length != 0) {
                    ++inputCount;
                    port.side == ($clinit_PortSide(), NORTH_1) && ++northInputCount;
                }
            }
            northPos = rankSum + northInputCount;
            restPos = rankSum + inputCount;
            for(port$iterator = $getPorts(node, ($clinit_PortType(), INPUT)).iterator_0(); port$iterator.hasNext_0();){
                port = castTo(port$iterator.next_1(), 11);
                if (port.side == ($clinit_PortSide(), NORTH_1)) {
                    portRanks[port.id_0] = northPos;
                    --northPos;
                } else {
                    portRanks[port.id_0] = restPos;
                    --restPos;
                }
            }
            return inputCount;
        case 2:
            pos = 0;
            for(port$iterator = $getPorts(node, ($clinit_PortType(), OUTPUT)).iterator_0(); port$iterator.hasNext_0();){
                port = castTo(port$iterator.next_1(), 11);
                ++pos;
                portRanks[port.id_0] = rankSum + pos;
            }
            return pos;
        default:
            throw toJs(new IllegalArgumentException);
    }
};
var Lorg_eclipse_elk_alg_layered_p3order_LayerTotalPortDistributor_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'LayerTotalPortDistributor', 1852);
function $compareBasedOnBarycenter(this$static, n1, n2) {
    var s1, s2, value_0;
    s1 = this$static.barycenterState[n1.layer.id_0][n1.id_0];
    s2 = this$static.barycenterState[n2.layer.id_0][n2.id_0];
    if (s1.barycenter != null && s2.barycenter != null) {
        value_0 = $compareTo_4(s1.barycenter, s2.barycenter);
        value_0 < 0 ? $updateBiggerAndSmallerAssociations_1(this$static, n1, n2) : value_0 > 0 && $updateBiggerAndSmallerAssociations_1(this$static, n2, n1);
        return value_0;
    } else if (s1.barycenter != null) {
        $updateBiggerAndSmallerAssociations_1(this$static, n1, n2);
        return -1;
    } else if (s2.barycenter != null) {
        $updateBiggerAndSmallerAssociations_1(this$static, n2, n1);
        return 1;
    }
    return 0;
}
function $compareBasedOnTansitiveDependencies(this$static, n1, n2) {
    if ($containsKey_3(this$static.biggerThan, n1)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, n1), 50), n2)) return 1;
    } else $put_6(this$static.biggerThan, n1, new HashSet);
    if ($containsKey_3(this$static.biggerThan, n2)) {
        if ($contains_6(castTo($get_10(this$static.biggerThan, n2), 50), n1)) return -1;
    } else $put_6(this$static.biggerThan, n2, new HashSet);
    if ($containsKey_3(this$static.smallerThan, n1)) {
        if ($contains_6(castTo($get_10(this$static.smallerThan, n1), 50), n2)) return -1;
    } else $put_6(this$static.smallerThan, n1, new HashSet);
    if ($containsKey_3(this$static.smallerThan, n2)) {
        if ($contains_6(castTo($get_10(this$static.smallerThan, n2), 50), n1)) return 1;
    } else $put_6(this$static.smallerThan, n2, new HashSet);
    return 0;
}
function $lambda$0_8(this$static, n1_0, n2_1) {
    var transitiveComparison, value_0;
    transitiveComparison = $compareBasedOnTansitiveDependencies(this$static, n1_0, n2_1);
    if (transitiveComparison != 0) return transitiveComparison;
    if ($hasProperty(n1_0, ($clinit_InternalProperties_1(), MODEL_ORDER_1)) && $hasProperty(n2_1, MODEL_ORDER_1)) {
        value_0 = compare_5(castTo($getProperty(n1_0, MODEL_ORDER_1), 17).value_0, castTo($getProperty(n2_1, MODEL_ORDER_1), 17).value_0);
        value_0 < 0 ? $updateBiggerAndSmallerAssociations_1(this$static, n1_0, n2_1) : value_0 > 0 && $updateBiggerAndSmallerAssociations_1(this$static, n2_1, n1_0);
        return value_0;
    }
    return $compareBasedOnBarycenter(this$static, n1_0, n2_1);
}
function $updateBiggerAndSmallerAssociations_1(this$static, bigger, smaller) {
    var biggerNodeBiggerThan, biggerNodeSmallerThan, smallerNodeBiggerThan, smallerNodeSmallerThan, veryBig, veryBig$iterator, verySmall, verySmall$iterator;
    biggerNodeBiggerThan = castTo($get_10(this$static.biggerThan, bigger), 50);
    smallerNodeBiggerThan = castTo($get_10(this$static.biggerThan, smaller), 50);
    biggerNodeSmallerThan = castTo($get_10(this$static.smallerThan, bigger), 50);
    smallerNodeSmallerThan = castTo($get_10(this$static.smallerThan, smaller), 50);
    biggerNodeBiggerThan.map_0.put(smaller, biggerNodeBiggerThan);
    smallerNodeSmallerThan.map_0.put(bigger, smallerNodeSmallerThan);
    for(verySmall$iterator = smallerNodeBiggerThan.map_0.keySet_0().iterator_0(); verySmall$iterator.hasNext_0();){
        verySmall = castTo(verySmall$iterator.next_1(), 9);
        biggerNodeBiggerThan.map_0.put(verySmall, biggerNodeBiggerThan);
        $add_6(castTo($get_10(this$static.smallerThan, verySmall), 50), bigger);
        $addAll(castTo($get_10(this$static.smallerThan, verySmall), 50), biggerNodeSmallerThan);
    }
    for(veryBig$iterator = biggerNodeSmallerThan.map_0.keySet_0().iterator_0(); veryBig$iterator.hasNext_0();){
        veryBig = castTo(veryBig$iterator.next_1(), 9);
        smallerNodeSmallerThan.map_0.put(veryBig, smallerNodeSmallerThan);
        $add_6(castTo($get_10(this$static.biggerThan, veryBig), 50), smaller);
        $addAll(castTo($get_10(this$static.biggerThan, veryBig), 50), smallerNodeBiggerThan);
    }
}
function ModelOrderBarycenterHeuristic(constraintResolver, random, portDistributor) {
    BarycenterHeuristic.call(this, constraintResolver, random, portDistributor);
    this.biggerThan = new HashMap;
    this.smallerThan = new HashMap;
    this.barycenterStateComparator = new ModelOrderBarycenterHeuristic$lambda$0$Type(this);
}
function insertionSort_1(layer, comparator, barycenterHeuristic) {
    var i, j, temp;
    for(i = 1; i < layer.array.length; i++){
        temp = (checkCriticalElementIndex(i, layer.array.length), castTo(layer.array[i], 9));
        j = i;
        while(j > 0 && comparator.compare_1((checkCriticalElementIndex(j - 1, layer.array.length), castTo(layer.array[j - 1], 9)), temp) > 0){
            $set_1(layer, j, (checkCriticalElementIndex(j - 1, layer.array.length), castTo(layer.array[j - 1], 9)));
            --j;
        }
        checkCriticalElementIndex(j, layer.array.length);
        layer.array[j] = temp;
    }
    barycenterHeuristic.biggerThan = new HashMap;
    barycenterHeuristic.smallerThan = new HashMap;
}
defineClass(654, 811, {
    654: 1,
    229: 1
}, ModelOrderBarycenterHeuristic);
_.minimizeCrossings_0 = function minimizeCrossings_2(layer, preOrdered, randomize, forward_0) {
    if (randomize) $randomizeBarycenters(this, layer);
    else {
        $calculateBarycenters(this, layer, forward_0);
        $fillInUnknownBarycenters(this, layer, preOrdered);
    }
    if (layer.array.length > 1) {
        $booleanValue(castToBoolean($getProperty($getGraph((checkCriticalElementIndex(0, layer.array.length), castTo(layer.array[0], 9))), ($clinit_LayeredOptions(), CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0)))) ? insertionSort_1(layer, this.barycenterStateComparator, this) : ($clinit_Collections(), $sort(layer, this.barycenterStateComparator));
        $booleanValue(castToBoolean($getProperty($getGraph((checkCriticalElementIndex(0, layer.array.length), castTo(layer.array[0], 9))), CROSSING_MINIMIZATION_FORCE_NODE_MODEL_ORDER_0))) || $processConstraints(this.constraintResolver, layer);
    }
};
var Lorg_eclipse_elk_alg_layered_p3order_ModelOrderBarycenterHeuristic_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'ModelOrderBarycenterHeuristic', 654);
function ModelOrderBarycenterHeuristic$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1812, 1, $intern_88, ModelOrderBarycenterHeuristic$lambda$0$Type);
_.compare_1 = function compare_66(arg0, arg1) {
    return $lambda$0_8(this.$$outer_0, castTo(arg0, 9), castTo(arg1, 9));
};
_.equals_0 = function equals_149(other) {
    return this === other;
};
_.reversed = function reversed_58() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_ModelOrderBarycenterHeuristic$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'ModelOrderBarycenterHeuristic/lambda$0$Type', 1812);
function $clinit_NoCrossingMinimizer() {
    $clinit_NoCrossingMinimizer = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIGURATION_5 = $add_17($after($addBefore($addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), LONG_EDGE_SPLITTER)), P4_NODE_PLACEMENT, IN_LAYER_CONSTRAINT_PROCESSOR), P5_EDGE_ROUTING), LONG_EDGE_JOINER);
}
function $process_73(progressMonitor) {
    progressMonitor.begin('No crossing minimization', 1);
    progressMonitor.done_1();
}
function NoCrossingMinimizer() {
    $clinit_NoCrossingMinimizer();
}
defineClass(1362, 1, $intern_110, NoCrossingMinimizer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_14(graph) {
    var configuration;
    return castTo(graph, 36), configuration = createFrom_0(INTERMEDIATE_PROCESSING_CONFIGURATION_5), $addBefore(configuration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), PORT_LIST_SORTER)), configuration;
};
_.process = function process_70(graph, progressMonitor) {
    $process_73((castTo(graph, 36), progressMonitor));
};
var INTERMEDIATE_PROCESSING_CONFIGURATION_5;
var Lorg_eclipse_elk_alg_layered_p3order_NoCrossingMinimizer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'NoCrossingMinimizer', 1362);
function NodeRelativePortDistributor(numLayers) {
    AbstractBarycenterPortDistributor.call(this, numLayers);
}
defineClass(789, 402, $intern_111, NodeRelativePortDistributor);
_.calculatePortRanks = function calculatePortRanks_0(node, rankSum, type_0) {
    var incr, inputCount, northInputCount, northPos, outputCount, port, port$iterator, port$iterator0, portRanks, pos, restPos;
    portRanks = this.portRanks;
    switch(type_0.ordinal){
        case 1:
            inputCount = 0;
            northInputCount = 0;
            for(port$iterator0 = new ArrayList$1(node.ports); port$iterator0.i < port$iterator0.this$01.array.length;){
                port = castTo($next_6(port$iterator0), 11);
                if (port.incomingEdges.array.length != 0) {
                    ++inputCount;
                    port.side == ($clinit_PortSide(), NORTH_1) && ++northInputCount;
                }
            }
            incr = 1 / (inputCount + 1);
            northPos = rankSum + northInputCount * incr;
            restPos = rankSum + 1 - incr;
            for(port$iterator = $getPorts(node, ($clinit_PortType(), INPUT)).iterator_0(); port$iterator.hasNext_0();){
                port = castTo(port$iterator.next_1(), 11);
                if (port.side == ($clinit_PortSide(), NORTH_1)) {
                    portRanks[port.id_0] = northPos;
                    northPos -= incr;
                } else {
                    portRanks[port.id_0] = restPos;
                    restPos -= incr;
                }
            }
            break;
        case 2:
            outputCount = 0;
            for(port$iterator0 = new ArrayList$1(node.ports); port$iterator0.i < port$iterator0.this$01.array.length;){
                port = castTo($next_6(port$iterator0), 11);
                port.outgoingEdges.array.length == 0 || ++outputCount;
            }
            incr = 1 / (outputCount + 1);
            pos = rankSum + incr;
            for(port$iterator = $getPorts(node, ($clinit_PortType(), OUTPUT)).iterator_0(); port$iterator.hasNext_0();){
                port = castTo(port$iterator.next_1(), 11);
                portRanks[port.id_0] = pos;
                pos += incr;
            }
            break;
        default:
            throw toJs(new IllegalArgumentException_0('Port type is undefined'));
    }
    return 1;
};
var Lorg_eclipse_elk_alg_layered_p3order_NodeRelativePortDistributor_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'NodeRelativePortDistributor', 789);
function $assertCorrectPortSides(dummy) {
    var anchorY, dummyPort, dummyPorts, origin_0, port, port$iterator, portHeight;
    origin_0 = castTo($getProperty(dummy, ($clinit_InternalProperties_1(), IN_LAYER_LAYOUT_UNIT)), 9);
    dummyPorts = dummy.ports;
    dummyPort = (checkCriticalElementIndex(0, dummyPorts.array.length), castTo(dummyPorts.array[0], 11));
    for(port$iterator = new ArrayList$1(origin_0.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        if (maskUndefined(port) === maskUndefined($getProperty(dummyPort, ORIGIN_0))) {
            if (port.side == ($clinit_PortSide(), NORTH_1) && dummy.id_0 > origin_0.id_0) {
                $setSide(port, SOUTH_0);
                if (port.explicitlySuppliedPortAnchor) {
                    portHeight = port.size_0.y_0;
                    anchorY = port.anchor.y_0;
                    port.anchor.y_0 = portHeight - anchorY;
                }
            } else if (port.side == SOUTH_0 && origin_0.id_0 > dummy.id_0) {
                $setSide(port, NORTH_1);
                if (port.explicitlySuppliedPortAnchor) {
                    portHeight = port.size_0.y_0;
                    anchorY = port.anchor.y_0;
                    port.anchor.y_0 = -(portHeight - anchorY);
                }
            }
            break;
        }
    }
    return origin_0;
}
function $deepCopy(currentlyBestNodeOrder) {
    var i, result;
    if (currentlyBestNodeOrder == null) return null;
    result = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_16, 199, currentlyBestNodeOrder.length, 0, 2);
    for(i = 0; i < result.length; i++)result[i] = castTo(copyOf_0(currentlyBestNodeOrder[i], currentlyBestNodeOrder[i].length), 199);
    return result;
}
function $transferNodeAndPortOrdersToGraph_0(this$static, lGraph) {
    var dummy, dummy$iterator, i, j, layers, node, node$iterator, nodes, northSouthPortDummies, origin_0, updatePortOrder;
    northSouthPortDummies = new ArrayList;
    updatePortOrder = new HashSet;
    layers = lGraph.layers;
    for(i = 0; i < layers.array.length; i++){
        nodes = (checkCriticalElementIndex(i, layers.array.length), castTo(layers.array[i], 25)).nodes;
        northSouthPortDummies.array.length = 0;
        for(j = 0; j < nodes.array.length; j++){
            node = this$static.nodeOrder[i][j];
            node.id_0 = j;
            node.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT) && push_1(northSouthPortDummies.array, node);
            $set_1(castTo($get_11(lGraph.layers, i), 25).nodes, j, node);
            node.ports.array.length = 0;
            $addAll_2(node.ports, castTo(castTo($get_11(this$static.portOrders, i), 15).get_0(j), 16));
            $isOrderFixed(castTo($getProperty(node, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100)) || $setProperty_0(node, PORT_CONSTRAINTS_0, ($clinit_PortConstraints(), FIXED_ORDER));
        }
        for(dummy$iterator = new ArrayList$1(northSouthPortDummies); dummy$iterator.i < dummy$iterator.this$01.array.length;){
            dummy = castTo($next_6(dummy$iterator), 9);
            origin_0 = $assertCorrectPortSides(dummy);
            updatePortOrder.map_0.put(origin_0, updatePortOrder);
            updatePortOrder.map_0.put(dummy, updatePortOrder);
        }
    }
    for(node$iterator = updatePortOrder.map_0.keySet_0().iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 9);
        $clinit_Collections();
        $sort(node.ports, ($clinit_PortListSorter(), CMP_COMBINED));
        node.portSidesCached = true;
        $findPortIndices(node);
    }
}
function SweepCopy(sc) {
    this.nodeOrder = $deepCopy(sc.nodeOrder);
    this.portOrders = new ArrayList_1(sc.portOrders);
}
function SweepCopy_0(nodeOrderIn) {
    var lNodes, lNodes$array, lNodes$index, lNodes$max, layer, node, node$array, node$index, node$max;
    this.nodeOrder = $deepCopy(nodeOrderIn);
    this.portOrders = new ArrayList;
    for(lNodes$array = nodeOrderIn, lNodes$index = 0, lNodes$max = lNodes$array.length; lNodes$index < lNodes$max; ++lNodes$index){
        lNodes = lNodes$array[lNodes$index];
        layer = new ArrayList;
        $add_3(this.portOrders, layer);
        for(node$array = lNodes, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
            node = node$array[node$index];
            $add_3(layer, new ArrayList_1(node.ports));
        }
    }
}
defineClass(801, 1, {}, SweepCopy, SweepCopy_0);
var Lorg_eclipse_elk_alg_layered_p3order_SweepCopy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order', 'SweepCopy', 801);
function $countAllCrossings(this$static, currentOrder) {
    var crossings, layerIndex;
    if (currentOrder.length == 0) return 0;
    crossings = $countInLayerCrossingsOnSide(this$static.crossingCounter, currentOrder[0], ($clinit_PortSide(), WEST_0));
    crossings += $countInLayerCrossingsOnSide(this$static.crossingCounter, currentOrder[currentOrder.length - 1], EAST_0);
    for(layerIndex = 0; layerIndex < currentOrder.length; layerIndex++)crossings += $countCrossingsAt(this$static, layerIndex, currentOrder);
    return crossings;
}
function $countCrossingsAt(this$static, layerIndex, currentOrder) {
    var leftLayer, rightLayer, totalCrossings;
    totalCrossings = 0;
    leftLayer = currentOrder[layerIndex];
    if (layerIndex < currentOrder.length - 1) {
        rightLayer = currentOrder[layerIndex + 1];
        if (this$static.hasHyperEdgesEastOfIndex[layerIndex]) {
            totalCrossings = $countCrossings_1(this$static.hyperedgeCrossingsCounter, leftLayer, rightLayer);
            totalCrossings += $countInLayerCrossingsOnSide(this$static.crossingCounter, leftLayer, ($clinit_PortSide(), EAST_0));
            totalCrossings += $countInLayerCrossingsOnSide(this$static.crossingCounter, rightLayer, WEST_0);
        } else totalCrossings = $countCrossingsBetweenLayers(this$static.crossingCounter, leftLayer, rightLayer);
    }
    this$static.hasNorthSouthPorts[layerIndex] && (totalCrossings += $countNorthSouthPortCrossingsInLayer(this$static.crossingCounter, leftLayer));
    return totalCrossings;
}
function AllCrossingsCounter(graph) {
    this.inLayerEdgeCounts = initUnidimensionalArray(I_classLit, $intern_48, 30, graph.length, 15, 1);
    this.hasNorthSouthPorts = initUnidimensionalArray(Z_classLit, $intern_90, 30, graph.length, 16, 1);
    this.hasHyperEdgesEastOfIndex = initUnidimensionalArray(Z_classLit, $intern_90, 30, graph.length, 16, 1);
    this.nPorts = 0;
}
defineClass(1807, 1, $intern_108, AllCrossingsCounter);
_.initAtLayerLevel = function initAtLayerLevel_6(l, nodeOrder) {};
_.initAfterTraversal = function initAfterTraversal_6() {
    var portPos;
    portPos = initUnidimensionalArray(I_classLit, $intern_48, 30, this.nPorts, 15, 1);
    this.hyperedgeCrossingsCounter = new HyperedgeCrossingsCounter(portPos);
    this.crossingCounter = new CrossingsCounter(portPos);
};
_.initAtEdgeLevel = function initAtEdgeLevel_6(l, n, p, e, edge, nodeOrder) {
    var port;
    port = castTo($get_11(nodeOrder[l][n].ports, p), 11);
    edge.source == port && edge.source.owner.layer == edge.target.owner.layer && ++this.inLayerEdgeCounts[l];
};
_.initAtNodeLevel = function initAtNodeLevel_6(l, n, nodeOrder) {
    var node;
    node = nodeOrder[l][n];
    this.hasNorthSouthPorts[l] = this.hasNorthSouthPorts[l] | node.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT);
};
_.initAtPortLevel = function initAtPortLevel_6(l, n, p, nodeOrder) {
    var port;
    port = castTo($get_11(nodeOrder[l][n].ports, p), 11);
    port.id_0 = this.nPorts++;
    port.outgoingEdges.array.length + port.incomingEdges.array.length > 1 && (port.side == ($clinit_PortSide(), EAST_0) ? this.hasHyperEdgesEastOfIndex[l] = true : port.side == WEST_0 && l > 0 && (this.hasHyperEdgesEastOfIndex[l - 1] = true));
};
_.nPorts = 0;
var Lorg_eclipse_elk_alg_layered_p3order_counting_AllCrossingsCounter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'AllCrossingsCounter', 1807);
function $add_16(this$static, index_0) {
    var i;
    ++this$static.size_0;
    ++this$static.numsPerIndex[index_0];
    i = index_0 + 1;
    while(i < this$static.binarySums.length){
        ++this$static.binarySums[i];
        i += i & -i;
    }
}
function $clear_9(this$static) {
    this$static.binarySums = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.maxNum + 1, 15, 1);
    this$static.numsPerIndex = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.maxNum, 15, 1);
    this$static.size_0 = 0;
}
function $rank(this$static, index_0) {
    var i, sum;
    i = index_0;
    sum = 0;
    while(i > 0){
        sum += this$static.binarySums[i];
        i -= i & -i;
    }
    return sum;
}
function $removeAll_3(this$static, index_0) {
    var i, numEntries;
    numEntries = this$static.numsPerIndex[index_0];
    if (numEntries == 0) return;
    this$static.numsPerIndex[index_0] = 0;
    this$static.size_0 -= numEntries;
    i = index_0 + 1;
    while(i < this$static.binarySums.length){
        this$static.binarySums[i] -= numEntries;
        i += i & -i;
    }
}
function BinaryIndexedTree(maxNum) {
    this.maxNum = maxNum;
    this.binarySums = initUnidimensionalArray(I_classLit, $intern_48, 30, maxNum + 1, 15, 1);
    this.numsPerIndex = initUnidimensionalArray(I_classLit, $intern_48, 30, maxNum, 15, 1);
    this.size_0 = 0;
}
defineClass(578, 1, {}, BinaryIndexedTree);
_.maxNum = 0;
_.size_0 = 0;
var Lorg_eclipse_elk_alg_layered_p3order_counting_BinaryIndexedTree_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'BinaryIndexedTree', 578);
function inNorthSouthEastWestOrder(node, side) {
    switch(side.ordinal){
        case 2:
        case 1:
            return $getPortSideView(node, side);
        case 3:
        case 4:
            return reverse_0($getPortSideView(node, side));
    }
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function $clinit_CrossingsCounter() {
    $clinit_CrossingsCounter = emptyMethod;
    INDEXING_SIDE = ($clinit_PortSide(), WEST_0);
    STACK_SIDE = EAST_0;
}
function $connectedInLayerPortsSortedByPosition(this$static, upperNode, lowerNode, side) {
    var edge, edge$iterator, node, node$array, node$index, node$max, port, port$iterator, ports;
    ports = new TreeSet_0(new CrossingsCounter$lambda$2$Type(this$static));
    for(node$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, 1), $intern_104, 9, 0, [
        upperNode,
        lowerNode
    ]), node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        for(port$iterator = inNorthSouthEastWestOrder(node, side).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
                edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
                if (!$isSelfLoop(edge)) {
                    ports.map_0.put(port, ($clinit_Boolean(), FALSE_0));
                    $isInLayer(edge) && $add_10(ports, port == edge.source ? edge.target : edge.source);
                }
            }
        }
    }
    return checkNotNull(ports), new ArrayList_1(ports);
}
function $connectedPortsSortedByPosition(this$static, upperPort, lowerPort) {
    var edge, edge$iterator, port, port$array, port$index, port$max, ports;
    ports = new TreeSet_0(new CrossingsCounter$lambda$3$Type(this$static));
    for(port$array = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_graph_LPort_2_classLit, 1), $intern_105, 11, 0, [
        upperPort,
        lowerPort
    ]), port$index = 0, port$max = port$array.length; port$index < port$max; ++port$index){
        port = port$array[port$index];
        ports.map_0.put(port, ($clinit_Boolean(), FALSE_0));
        for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
            edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
            edge.source == edge.target || $add_10(ports, port == edge.source ? edge.target : edge.source);
        }
    }
    return checkNotNull(ports), new ArrayList_1(ports);
}
function $countCrossingsBetweenLayers(this$static, leftLayerNodes, rightLayerNodes) {
    var ports;
    ports = $initPortPositionsCounterClockwise(this$static, leftLayerNodes, rightLayerNodes);
    this$static.indexTree = new BinaryIndexedTree(ports.array.length);
    return $countCrossingsOnPorts(this$static, ports);
}
function $countCrossingsBetweenPortsInBothOrders(this$static, upperPort, lowerPort) {
    var lowerUpperCrossings, ports, upperLowerCrossings;
    ports = $connectedPortsSortedByPosition(this$static, upperPort, lowerPort);
    upperLowerCrossings = $countCrossingsOnPorts(this$static, ports);
    $clear_9(this$static.indexTree);
    $switchPorts(this$static, upperPort, lowerPort);
    $clinit_Collections();
    $sort(ports, new CrossingsCounter$lambda$0$Type(this$static));
    lowerUpperCrossings = $countCrossingsOnPorts(this$static, ports);
    $clear_9(this$static.indexTree);
    $switchPorts(this$static, lowerPort, upperPort);
    return new Pair(valueOf_3(upperLowerCrossings), valueOf_3(lowerUpperCrossings));
}
function $countCrossingsOnPorts(this$static, ports) {
    var crossings, edge, edge$iterator, endPosition, port, port$iterator;
    crossings = 0;
    for(port$iterator = new ArrayList$1(ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $removeAll_3(this$static.indexTree, this$static.portPositions[port.id_0]);
        for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
            edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
            endPosition = $positionOf_0(this$static, port == edge.source ? edge.target : edge.source);
            if (endPosition > this$static.portPositions[port.id_0]) {
                crossings += $rank(this$static.indexTree, endPosition);
                $addFirst(this$static.ends, valueOf_3(endPosition));
            }
        }
        while(!$isEmpty(this$static.ends))$add_16(this$static.indexTree, castTo($removeFirst(this$static.ends), 17).value_0);
    }
    return crossings;
}
function $countInLayerCrossingsBetweenNodesInBothOrders(this$static, upperNode, lowerNode, side) {
    var lowerUpperCrossings, ports, upperLowerCrossings;
    ports = $connectedInLayerPortsSortedByPosition(this$static, upperNode, lowerNode, side);
    upperLowerCrossings = $countInLayerCrossingsOnPorts(this$static, ports);
    $switchNodes(this$static, upperNode, lowerNode, side);
    $clear_9(this$static.indexTree);
    $clinit_Collections();
    $sort(ports, new CrossingsCounter$lambda$1$Type(this$static));
    lowerUpperCrossings = $countInLayerCrossingsOnPorts(this$static, ports);
    $switchNodes(this$static, lowerNode, upperNode, side);
    $clear_9(this$static.indexTree);
    return new Pair(valueOf_3(upperLowerCrossings), valueOf_3(lowerUpperCrossings));
}
function $countInLayerCrossingsOnPorts(this$static, ports) {
    var crossings, edge, edge$iterator, endPosition, numBetweenLayerEdges, port, port$iterator;
    crossings = 0;
    for(port$iterator = new ArrayList$1(ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $removeAll_3(this$static.indexTree, this$static.portPositions[port.id_0]);
        numBetweenLayerEdges = 0;
        for(edge$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
            edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
            if ($isInLayer(edge)) {
                endPosition = $positionOf_0(this$static, port == edge.source ? edge.target : edge.source);
                if (endPosition > this$static.portPositions[port.id_0]) {
                    crossings += $rank(this$static.indexTree, endPosition);
                    $addFirst(this$static.ends, valueOf_3(endPosition));
                }
            } else ++numBetweenLayerEdges;
        }
        crossings += this$static.indexTree.size_0 * numBetweenLayerEdges;
        while(!$isEmpty(this$static.ends))$add_16(this$static.indexTree, castTo($removeFirst(this$static.ends), 17).value_0);
    }
    return crossings;
}
function $countInLayerCrossingsOnSide(this$static, nodes, side) {
    var ports;
    ports = $initPortPositionsForInLayerCrossings(this$static, nodes, side);
    return $countInLayerCrossingsOnPorts(this$static, ports);
}
function $countNorthSouthCrossingsOnPorts(this$static, ports) {
    var crossings, dummy, dummyPort, endPosition, port, port$iterator, targetAndDegree, targetAndDegree$iterator, targetsAndDegrees;
    crossings = 0;
    targetsAndDegrees = new ArrayList;
    for(port$iterator = new ArrayList$1(ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        $removeAll_3(this$static.indexTree, this$static.portPositions[port.id_0]);
        targetsAndDegrees.array.length = 0;
        switch(port.owner.type_0.ordinal){
            case 0:
                dummy = castTo($getProperty(port, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
                $forEach_1(dummy.ports, new CrossingsCounter$lambda$4$Type(targetsAndDegrees));
                break;
            case 1:
                $ifPresent($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(port.owner.ports, 16)), new CrossingsCounter$lambda$5$Type(port))), new CrossingsCounter$lambda$6$Type(targetsAndDegrees));
                break;
            case 3:
                dummyPort = castTo($getProperty(port, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
                $add_3(targetsAndDegrees, new Pair(dummyPort, valueOf_3(port.incomingEdges.array.length + port.outgoingEdges.array.length)));
        }
        for(targetAndDegree$iterator = new ArrayList$1(targetsAndDegrees); targetAndDegree$iterator.i < targetAndDegree$iterator.this$01.array.length;){
            targetAndDegree = castTo($next_6(targetAndDegree$iterator), 47);
            endPosition = $positionOf_0(this$static, castTo(targetAndDegree.first, 11));
            if (endPosition > this$static.portPositions[port.id_0]) {
                crossings += $rank(this$static.indexTree, endPosition) * castTo(targetAndDegree.second, 17).value_0;
                $addFirst(this$static.ends, valueOf_3(endPosition));
            }
        }
        while(!$isEmpty(this$static.ends))$add_16(this$static.indexTree, castTo($removeFirst(this$static.ends), 17).value_0);
    }
    return crossings;
}
function $countNorthSouthPortCrossingsInLayer(this$static, layer) {
    var ports;
    ports = $initPositionsForNorthSouthCounting(this$static, layer);
    this$static.indexTree = new BinaryIndexedTree(ports.array.length);
    return $countNorthSouthCrossingsOnPorts(this$static, ports);
}
function $emptyStack(this$static, stack_0, ports, side, startIndex) {
    var dummy, index_0, p;
    index_0 = startIndex;
    while(stack_0.head != stack_0.tail){
        dummy = castTo($removeFirst(stack_0), 9);
        p = castTo($getPortSideView(dummy, side).get_0(0), 11);
        this$static.portPositions[p.id_0] = index_0++;
        push_1(ports.array, p);
    }
    return index_0;
}
function $initForCountingBetween(this$static, leftLayerNodes, rightLayerNodes) {
    var ports;
    ports = $initPortPositionsCounterClockwise(this$static, leftLayerNodes, rightLayerNodes);
    this$static.indexTree = new BinaryIndexedTree(ports.array.length);
}
function $initPortPositionsCounterClockwise(this$static, leftLayerNodes, rightLayerNodes) {
    var ports;
    ports = new ArrayList;
    $initPositions(this$static, leftLayerNodes, ports, ($clinit_PortSide(), EAST_0), true, false);
    $initPositions(this$static, rightLayerNodes, ports, WEST_0, false, false);
    return ports;
}
function $initPortPositionsForInLayerCrossings(this$static, nodes, side) {
    var ports;
    ports = new ArrayList;
    $initPositions(this$static, nodes, ports, side, true, true);
    this$static.indexTree = new BinaryIndexedTree(ports.array.length);
    return ports;
}
function $initPositions(this$static, nodes, ports, side, topDown, getCardinalities) {
    var i, node, nodePorts, numPorts, port, port$iterator;
    numPorts = ports.array.length;
    getCardinalities && (this$static.nodeCardinalities = initUnidimensionalArray(I_classLit, $intern_48, 30, nodes.length, 15, 1));
    for(i = topDown ? 0 : nodes.length - 1; topDown ? i < nodes.length : i >= 0; i += topDown ? 1 : -1){
        node = nodes[i];
        nodePorts = side == ($clinit_PortSide(), EAST_0) ? topDown ? $getPortSideView(node, side) : reverse_0($getPortSideView(node, side)) : topDown ? reverse_0($getPortSideView(node, side)) : $getPortSideView(node, side);
        getCardinalities && (this$static.nodeCardinalities[node.id_0] = nodePorts.size_1());
        for(port$iterator = nodePorts.iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            this$static.portPositions[port.id_0] = numPorts++;
        }
        $addAll_2(ports, nodePorts);
    }
}
function $initPositionsForNorthSouthCounting(this$static, nodes) {
    var current, i, index_0, lastLayoutUnit, p, p$iterator, p$iterator0, p$iterator1, ports, stack_0;
    ports = new ArrayList;
    stack_0 = new ArrayDeque;
    lastLayoutUnit = null;
    index_0 = 0;
    for(i = 0; i < nodes.length; ++i){
        current = nodes[i];
        $isLayoutUnitChanged(lastLayoutUnit, current) && (index_0 = $emptyStack(this$static, stack_0, ports, STACK_SIDE, index_0));
        $hasProperty(current, ($clinit_InternalProperties_1(), IN_LAYER_LAYOUT_UNIT)) && (lastLayoutUnit = castTo($getProperty(current, IN_LAYER_LAYOUT_UNIT), 9));
        switch(current.type_0.ordinal){
            case 0:
                for(p$iterator0 = $iterator_0(filter_0($getPortSideView(current, ($clinit_PortSide(), NORTH_1)), new CrossingsCounter$lambda$8$Type)); $hasNext(p$iterator0);){
                    p = castTo($next(p$iterator0), 11);
                    this$static.portPositions[p.id_0] = index_0++;
                    push_1(ports.array, p);
                }
                index_0 = $emptyStack(this$static, stack_0, ports, STACK_SIDE, index_0);
                for(p$iterator1 = $iterator_0(filter_0($getPortSideView(current, SOUTH_0), new CrossingsCounter$lambda$8$Type)); $hasNext(p$iterator1);){
                    p = castTo($next(p$iterator1), 11);
                    this$static.portPositions[p.id_0] = index_0++;
                    push_1(ports.array, p);
                }
                break;
            case 3:
                if (!$getPortSideView(current, INDEXING_SIDE).isEmpty()) {
                    p = castTo($getPortSideView(current, INDEXING_SIDE).get_0(0), 11);
                    this$static.portPositions[p.id_0] = index_0++;
                    push_1(ports.array, p);
                }
                $getPortSideView(current, STACK_SIDE).isEmpty() || $addFirst(stack_0, current);
                break;
            case 1:
                for(p$iterator = $getPortSideView(current, ($clinit_PortSide(), WEST_0)).iterator_0(); p$iterator.hasNext_0();){
                    p = castTo(p$iterator.next_1(), 11);
                    this$static.portPositions[p.id_0] = index_0++;
                    push_1(ports.array, p);
                }
                $getPortSideView(current, EAST_0).forEach_0(new CrossingsCounter$lambda$7$Type(stack_0, current));
        }
    }
    $emptyStack(this$static, stack_0, ports, STACK_SIDE, index_0);
    return ports;
}
function $isInLayer(edge) {
    var sourceLayer, targetLayer;
    sourceLayer = edge.source.owner.layer;
    targetLayer = edge.target.owner.layer;
    return sourceLayer == targetLayer;
}
function $isLayoutUnitChanged(lastUnit, node) {
    var unit;
    if (!lastUnit || lastUnit == node || !$hasProperty(node, ($clinit_InternalProperties_1(), IN_LAYER_LAYOUT_UNIT))) return false;
    unit = castTo($getProperty(node, ($clinit_InternalProperties_1(), IN_LAYER_LAYOUT_UNIT)), 9);
    return unit != lastUnit;
}
function $lambda$0_9(this$static, a_0, b_1) {
    return compare_5(this$static.portPositions[a_0.id_0], this$static.portPositions[b_1.id_0]);
}
function $lambda$1_4(this$static, a_0, b_1) {
    return compare_5(this$static.portPositions[a_0.id_0], this$static.portPositions[b_1.id_0]);
}
function $lambda$2_2(this$static, a_0, b_1) {
    return compare_5(this$static.portPositions[a_0.id_0], this$static.portPositions[b_1.id_0]);
}
function $lambda$3_1(this$static, a_0, b_1) {
    return compare_5(this$static.portPositions[a_0.id_0], this$static.portPositions[b_1.id_0]);
}
function $positionOf_0(this$static, port) {
    return this$static.portPositions[port.id_0];
}
function $switchNodes(this$static, wasUpperNode, wasLowerNode, side) {
    var port, port$iterator, port$iterator0, ports;
    ports = inNorthSouthEastWestOrder(wasUpperNode, side);
    for(port$iterator0 = ports.iterator_0(); port$iterator0.hasNext_0();){
        port = castTo(port$iterator0.next_1(), 11);
        this$static.portPositions[port.id_0] = this$static.portPositions[port.id_0] + this$static.nodeCardinalities[wasLowerNode.id_0];
    }
    ports = inNorthSouthEastWestOrder(wasLowerNode, side);
    for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        this$static.portPositions[port.id_0] = this$static.portPositions[port.id_0] - this$static.nodeCardinalities[wasUpperNode.id_0];
    }
}
function $switchPorts(this$static, topPort, bottomPort) {
    var topPortPos;
    topPortPos = this$static.portPositions[topPort.id_0];
    this$static.portPositions[topPort.id_0] = this$static.portPositions[bottomPort.id_0];
    this$static.portPositions[bottomPort.id_0] = topPortPos;
}
function CrossingsCounter(portPositions) {
    $clinit_CrossingsCounter();
    this.portPositions = portPositions;
    this.ends = new ArrayDeque;
}
function lambda$4_5(targetsAndDegrees_0, p_1) {
    $clinit_CrossingsCounter();
    return $add_3(targetsAndDegrees_0, new Pair(p_1, valueOf_3(p_1.incomingEdges.array.length + p_1.outgoingEdges.array.length)));
}
function lambda$5_3(port_0, p_1) {
    $clinit_CrossingsCounter();
    return p_1 != port_0;
}
function lambda$6_0(targetsAndDegrees_0, p_1) {
    $clinit_CrossingsCounter();
    return $add_3(targetsAndDegrees_0, new Pair(p_1, valueOf_3(p_1.incomingEdges.array.length + p_1.outgoingEdges.array.length)));
}
defineClass(517, 1, {}, CrossingsCounter);
var INDEXING_SIDE, STACK_SIDE;
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter', 517);
function CrossingsCounter$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1896, 1, $intern_88, CrossingsCounter$lambda$0$Type);
_.compare_1 = function compare_67(arg0, arg1) {
    return $lambda$0_9(this.$$outer_0, castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_150(other) {
    return this === other;
};
_.reversed = function reversed_59() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$0$Type', 1896);
function CrossingsCounter$lambda$1$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1897, 1, $intern_88, CrossingsCounter$lambda$1$Type);
_.compare_1 = function compare_68(arg0, arg1) {
    return $lambda$1_4(this.$$outer_0, castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_151(other) {
    return this === other;
};
_.reversed = function reversed_60() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$1$Type', 1897);
function CrossingsCounter$lambda$2$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1898, 1, $intern_88, CrossingsCounter$lambda$2$Type);
_.compare_1 = function compare_69(arg0, arg1) {
    return $lambda$2_2(this.$$outer_0, castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_152(other) {
    return this === other;
};
_.reversed = function reversed_61() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$2$Type', 1898);
function CrossingsCounter$lambda$3$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1899, 1, $intern_88, CrossingsCounter$lambda$3$Type);
_.compare_1 = function compare_70(arg0, arg1) {
    return $lambda$3_1(this.$$outer_0, castTo(arg0, 11), castTo(arg1, 11));
};
_.equals_0 = function equals_153(other) {
    return this === other;
};
_.reversed = function reversed_62() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$3$Type', 1899);
function CrossingsCounter$lambda$4$Type(targetsAndDegrees_0) {
    this.targetsAndDegrees_0 = targetsAndDegrees_0;
}
defineClass($intern_47, 1, $intern_19, CrossingsCounter$lambda$4$Type);
_.accept = function accept_117(arg0) {
    lambda$4_5(this.targetsAndDegrees_0, castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$4$Type', $intern_47);
function CrossingsCounter$lambda$5$Type(port_0) {
    this.port_0 = port_0;
}
defineClass(1901, 1, $intern_39, CrossingsCounter$lambda$5$Type);
_.test_0 = function test_82(arg0) {
    return lambda$5_3(this.port_0, castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$5$Type', 1901);
function $accept_2(this$static, arg0) {
    lambda$6_0(this$static.targetsAndDegrees_0, castTo(arg0, 11));
}
function CrossingsCounter$lambda$6$Type(targetsAndDegrees_0) {
    this.targetsAndDegrees_0 = targetsAndDegrees_0;
}
defineClass(1902, 1, $intern_19, CrossingsCounter$lambda$6$Type);
_.accept = function accept_118(arg0) {
    $accept_2(this, arg0);
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$6$Type', 1902);
function CrossingsCounter$lambda$7$Type(stack_0, current_1) {
    this.stack_0 = stack_0;
    this.current_1 = current_1;
}
defineClass(1903, 1, $intern_19, CrossingsCounter$lambda$7$Type);
_.accept = function accept_119(arg0) {
    var lastArg;
    $clinit_CrossingsCounter();
    $addFirst(this.stack_0, (lastArg = this.current_1, castTo(arg0, 11), lastArg));
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$7$Type', 1903);
function CrossingsCounter$lambda$8$Type() {}
defineClass(818, 1, $intern_89, CrossingsCounter$lambda$8$Type);
_.apply_1 = function apply_111(arg0) {
    return $clinit_CrossingsCounter(), $hasProperty(castTo(arg0, 11), ($clinit_InternalProperties_1(), PORT_DUMMY));
};
_.equals_0 = function equals_154(other) {
    return this === other;
};
_.test_0 = function test_83(input_0) {
    return $clinit_CrossingsCounter(), $hasProperty(castTo(input_0, 11), ($clinit_InternalProperties_1(), PORT_DUMMY));
};
var Lorg_eclipse_elk_alg_layered_p3order_counting_CrossingsCounter$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'CrossingsCounter/lambda$8$Type', 818);
function $countCrossings_1(this$static, leftLayer, rightLayer) {
    var compressDeltas, crossings, delta, edge, edge$iterator, firstIndex, he, he$array, he$index, he$max, hyperedge, hyperedgeSet, hyperedges, i, i0, i1, i2, i3, i4, i5, index_0, k, leftCorners, leftLayerRef, node, node$array, node$array0, node$array1, node$index, node$index0, node$index1, node$max, node$max0, node$max1, northInputPorts, openHyperedges, otherInputPorts, p, p$iterator, port, port$iterator, port2HyperedgeMap, portEdges, portIter, pos, q, rightCorners, rightLayerRef, sourceCount, sourceHE, sourcePort, sourcePort$iterator, southSequence, targetCount, targetHE, targetPort, tree, treeSize;
    sourceCount = 0;
    for(node$array0 = leftLayer, node$index0 = 0, node$max0 = node$array0.length; node$index0 < node$max0; ++node$index0){
        node = node$array0[node$index0];
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            portEdges = 0;
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                node.layer != edge.target.owner.layer && ++portEdges;
            }
            portEdges > 0 && (this$static.portPos[port.id_0] = sourceCount++);
        }
    }
    targetCount = 0;
    for(node$array1 = rightLayer, node$index1 = 0, node$max1 = node$array1.length; node$index1 < node$max1; ++node$index1){
        node = node$array1[node$index1];
        northInputPorts = 0;
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            if (port.side == ($clinit_PortSide(), NORTH_1)) for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if (node.layer != edge.source.owner.layer) {
                    ++northInputPorts;
                    break;
                }
            }
            else break;
        }
        otherInputPorts = 0;
        portIter = new AbstractList$ListIteratorImpl(node.ports, node.ports.array.length);
        while(portIter.i > 0){
            port = (checkCriticalElement(portIter.i > 0), castTo(portIter.this$01.get_0(portIter.last = --portIter.i), 11));
            portEdges = 0;
            for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                node.layer != edge.source.owner.layer && ++portEdges;
            }
            if (portEdges > 0) {
                if (port.side == ($clinit_PortSide(), NORTH_1)) {
                    this$static.portPos[port.id_0] = targetCount;
                    ++targetCount;
                } else {
                    this$static.portPos[port.id_0] = targetCount + northInputPorts + otherInputPorts;
                    ++otherInputPorts;
                }
            }
        }
        targetCount += otherInputPorts;
    }
    port2HyperedgeMap = new HashMap;
    hyperedgeSet = new LinkedHashSet;
    for(node$array = leftLayer, node$index = 0, node$max = node$array.length; node$index < node$max; ++node$index){
        node = node$array[node$index];
        for(sourcePort$iterator = new ArrayList$1(node.ports); sourcePort$iterator.i < sourcePort$iterator.this$01.array.length;){
            sourcePort = castTo($next_6(sourcePort$iterator), 11);
            for(edge$iterator = new ArrayList$1(sourcePort.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                targetPort = edge.target;
                if (node.layer != targetPort.owner.layer) {
                    sourceHE = castTo(getEntryValueOrNull($getEntry_0(port2HyperedgeMap.hashCodeMap, sourcePort)), 464);
                    targetHE = castTo(getEntryValueOrNull($getEntry_0(port2HyperedgeMap.hashCodeMap, targetPort)), 464);
                    if (!sourceHE && !targetHE) {
                        hyperedge = new HyperedgeCrossingsCounter$Hyperedge;
                        hyperedgeSet.map_0.put(hyperedge, hyperedgeSet);
                        $add_3(hyperedge.edges, edge);
                        $add_3(hyperedge.ports, sourcePort);
                        $put_9(port2HyperedgeMap.hashCodeMap, sourcePort, hyperedge);
                        $add_3(hyperedge.ports, targetPort);
                        $put_9(port2HyperedgeMap.hashCodeMap, targetPort, hyperedge);
                    } else if (!sourceHE) {
                        $add_3(targetHE.edges, edge);
                        $add_3(targetHE.ports, sourcePort);
                        $put_9(port2HyperedgeMap.hashCodeMap, sourcePort, targetHE);
                    } else if (!targetHE) {
                        $add_3(sourceHE.edges, edge);
                        $add_3(sourceHE.ports, targetPort);
                        $put_9(port2HyperedgeMap.hashCodeMap, targetPort, sourceHE);
                    } else if (sourceHE == targetHE) $add_3(sourceHE.edges, edge);
                    else {
                        $add_3(sourceHE.edges, edge);
                        for(p$iterator = new ArrayList$1(targetHE.ports); p$iterator.i < p$iterator.this$01.array.length;){
                            p = castTo($next_6(p$iterator), 11);
                            $put_9(port2HyperedgeMap.hashCodeMap, p, sourceHE);
                        }
                        $addAll_2(sourceHE.edges, targetHE.edges);
                        $addAll_2(sourceHE.ports, targetHE.ports);
                        hyperedgeSet.map_0.remove_0(targetHE);
                    }
                }
            }
        }
    }
    hyperedges = castTo($toArray_0(hyperedgeSet, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$Hyperedge_2_classLit, {
        3: 1,
        4: 1,
        5: 1,
        1991: 1
    }, 464, hyperedgeSet.map_0.size_1(), 0, 1)), 1991);
    leftLayerRef = leftLayer[0].layer;
    rightLayerRef = rightLayer[0].layer;
    for(he$array = hyperedges, he$index = 0, he$max = he$array.length; he$index < he$max; ++he$index){
        he = he$array[he$index];
        he.upperLeft = sourceCount;
        he.upperRight = targetCount;
        for(port$iterator = new ArrayList$1(he.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            pos = this$static.portPos[port.id_0];
            if (port.owner.layer == leftLayerRef) {
                pos < he.upperLeft && (he.upperLeft = pos);
                pos > he.lowerLeft && (he.lowerLeft = pos);
            } else if (port.owner.layer == rightLayerRef) {
                pos < he.upperRight && (he.upperRight = pos);
                pos > he.lowerRight && (he.lowerRight = pos);
            }
        }
    }
    mergeSort(hyperedges, 0, hyperedges.length, null);
    southSequence = initUnidimensionalArray(I_classLit, $intern_48, 30, hyperedges.length, 15, 1);
    compressDeltas = initUnidimensionalArray(I_classLit, $intern_48, 30, targetCount + 1, 15, 1);
    for(i0 = 0; i0 < hyperedges.length; i0++){
        southSequence[i0] = hyperedges[i0].upperRight;
        compressDeltas[southSequence[i0]] = 1;
    }
    delta = 0;
    for(i1 = 0; i1 < compressDeltas.length; i1++)compressDeltas[i1] == 1 ? compressDeltas[i1] = delta : --delta;
    q = 0;
    for(i2 = 0; i2 < southSequence.length; i2++){
        southSequence[i2] += compressDeltas[southSequence[i2]];
        q = $wnd.Math.max(q, southSequence[i2] + 1);
    }
    firstIndex = 1;
    while(firstIndex < q)firstIndex *= 2;
    treeSize = 2 * firstIndex - 1;
    firstIndex -= 1;
    tree = initUnidimensionalArray(I_classLit, $intern_48, 30, treeSize, 15, 1);
    crossings = 0;
    for(k = 0; k < southSequence.length; k++){
        index_0 = southSequence[k] + firstIndex;
        ++tree[index_0];
        while(index_0 > 0){
            index_0 % 2 > 0 && (crossings += tree[index_0 + 1]);
            index_0 = (index_0 - 1) / 2 | 0;
            ++tree[index_0];
        }
    }
    leftCorners = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$HyperedgeCorner_2_classLit, $intern_2, 367, hyperedges.length * 2, 0, 1);
    for(i3 = 0; i3 < hyperedges.length; i3++){
        leftCorners[2 * i3] = new HyperedgeCrossingsCounter$HyperedgeCorner(hyperedges[i3], hyperedges[i3].upperLeft, hyperedges[i3].lowerLeft, ($clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type(), UPPER));
        leftCorners[2 * i3 + 1] = new HyperedgeCrossingsCounter$HyperedgeCorner(hyperedges[i3], hyperedges[i3].lowerLeft, hyperedges[i3].upperLeft, LOWER);
    }
    mergeSort(leftCorners, 0, leftCorners.length, null);
    openHyperedges = 0;
    for(i4 = 0; i4 < leftCorners.length; i4++)switch(leftCorners[i4].type_0.ordinal){
        case 0:
            ++openHyperedges;
            break;
        case 1:
            --openHyperedges;
            crossings += openHyperedges;
    }
    rightCorners = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$HyperedgeCorner_2_classLit, $intern_2, 367, hyperedges.length * 2, 0, 1);
    for(i5 = 0; i5 < hyperedges.length; i5++){
        rightCorners[2 * i5] = new HyperedgeCrossingsCounter$HyperedgeCorner(hyperedges[i5], hyperedges[i5].upperRight, hyperedges[i5].lowerRight, ($clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type(), UPPER));
        rightCorners[2 * i5 + 1] = new HyperedgeCrossingsCounter$HyperedgeCorner(hyperedges[i5], hyperedges[i5].lowerRight, hyperedges[i5].upperRight, LOWER);
    }
    mergeSort(rightCorners, 0, rightCorners.length, null);
    openHyperedges = 0;
    for(i = 0; i < rightCorners.length; i++)switch(rightCorners[i].type_0.ordinal){
        case 0:
            ++openHyperedges;
            break;
        case 1:
            --openHyperedges;
            crossings += openHyperedges;
    }
    return crossings;
}
function HyperedgeCrossingsCounter(portPos) {
    this.portPos = portPos;
}
defineClass(1895, 1, {}, HyperedgeCrossingsCounter);
var Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'HyperedgeCrossingsCounter', 1895);
function $compareTo_14(this$static, other) {
    if (this$static.upperLeft < other.upperLeft) return -1;
    else if (this$static.upperLeft > other.upperLeft) return 1;
    else if (this$static.upperRight < other.upperRight) return -1;
    else if (this$static.upperRight > other.upperRight) return 1;
    return hashCode__I__devirtual$(this$static) - hashCode__I__devirtual$(other);
}
function HyperedgeCrossingsCounter$Hyperedge() {
    this.edges = new ArrayList;
    this.ports = new ArrayList;
}
defineClass(464, 1, {
    34: 1,
    464: 1
}, HyperedgeCrossingsCounter$Hyperedge);
_.compareTo_0 = function compareTo_15(other) {
    return $compareTo_14(this, castTo(other, 464));
};
_.lowerLeft = 0;
_.lowerRight = 0;
_.upperLeft = 0;
_.upperRight = 0;
var Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$Hyperedge_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'HyperedgeCrossingsCounter/Hyperedge', 464);
function $compareTo_15(this$static, other) {
    if (this$static.position < other.position) return -1;
    else if (this$static.position > other.position) return 1;
    else if (this$static.oppositePosition < other.oppositePosition) return -1;
    else if (this$static.oppositePosition > other.oppositePosition) return 1;
    else if (this$static.hyperedge != other.hyperedge) return hashCode__I__devirtual$(this$static.hyperedge) - hashCode__I__devirtual$(other.hyperedge);
    else if (this$static.type_0 == ($clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type(), UPPER) && other.type_0 == LOWER) return -1;
    else if (this$static.type_0 == LOWER && other.type_0 == UPPER) return 1;
    return 0;
}
function HyperedgeCrossingsCounter$HyperedgeCorner(hyperedge, position, oppositePosition, type_0) {
    this.hyperedge = hyperedge;
    this.position = position;
    this.oppositePosition = oppositePosition;
    this.type_0 = type_0;
}
defineClass(367, 1, {
    34: 1,
    367: 1
}, HyperedgeCrossingsCounter$HyperedgeCorner);
_.compareTo_0 = function compareTo_16(other) {
    return $compareTo_15(this, castTo(other, 367));
};
_.oppositePosition = 0;
_.position = 0;
var Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$HyperedgeCorner_2_classLit = createForClass('org.eclipse.elk.alg.layered.p3order.counting', 'HyperedgeCrossingsCounter/HyperedgeCorner', 367);
function $clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type() {
    $clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type = emptyMethod;
    UPPER = new HyperedgeCrossingsCounter$HyperedgeCorner$Type('UPPER', 0);
    LOWER = new HyperedgeCrossingsCounter$HyperedgeCorner$Type('LOWER', 1);
}
function HyperedgeCrossingsCounter$HyperedgeCorner$Type(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_61(name_0) {
    $clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type();
    return valueOf(($clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type$Map(), $MAP_51), name_0);
}
function values_69() {
    $clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$HyperedgeCorner$Type_2_classLit, 1), $intern_36, 516, 0, [
        UPPER,
        LOWER
    ]);
}
defineClass(516, 23, {
    3: 1,
    34: 1,
    23: 1,
    516: 1
}, HyperedgeCrossingsCounter$HyperedgeCorner$Type);
var LOWER, UPPER;
var Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$HyperedgeCorner$Type_2_classLit = createForEnum('org.eclipse.elk.alg.layered.p3order.counting', 'HyperedgeCrossingsCounter/HyperedgeCorner/Type', 516, Ljava_lang_Enum_2_classLit, values_69, valueOf_61);
function $clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type$Map() {
    $clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type$Map = emptyMethod;
    $MAP_51 = createValueOfMap(($clinit_HyperedgeCrossingsCounter$HyperedgeCorner$Type(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p3order_counting_HyperedgeCrossingsCounter$HyperedgeCorner$Type_2_classLit, 1), $intern_36, 516, 0, [
        UPPER,
        LOWER
    ])));
}
var $MAP_51;
function $clinit_InteractiveNodePlacer() {
    $clinit_InteractiveNodePlacer = emptyMethod;
    HIERARCHY_PROCESSING_ADDITIONS = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), HIERARCHICAL_PORT_POSITION_PROCESSOR));
}
function $placeNodes(this$static, layer) {
    var minValidY, node, node$iterator, nodeType, originalYCoordinate, prevNodeType, spacing;
    minValidY = $intern_61;
    prevNodeType = ($clinit_LNode$NodeType(), NORMAL);
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        nodeType = node.type_0;
        if (nodeType != NORMAL) {
            originalYCoordinate = castToDouble($getProperty(node, ($clinit_InternalProperties_1(), ORIGINAL_DUMMY_NODE_POSITION)));
            if (originalYCoordinate == null) {
                minValidY = $wnd.Math.max(minValidY, 0);
                node.pos.y_0 = minValidY + $getVerticalSpacing(this$static.spacings, nodeType, prevNodeType);
            } else node.pos.y_0 = (checkCriticalNotNull(originalYCoordinate), originalYCoordinate);
        }
        spacing = $getVerticalSpacing(this$static.spacings, nodeType, prevNodeType);
        node.pos.y_0 < minValidY + spacing + node.margin.top_0 && (node.pos.y_0 = minValidY + spacing + node.margin.top_0);
        minValidY = node.pos.y_0 + node.size_0.y_0 + node.margin.bottom;
        prevNodeType = nodeType;
    }
}
function $process_74(this$static, layeredGraph, monitor) {
    var layer, layer$iterator;
    monitor.begin('Interactive node placement', 1);
    this$static.spacings = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        $placeNodes(this$static, layer);
    }
    monitor.done_1();
}
function InteractiveNodePlacer() {
    $clinit_InteractiveNodePlacer();
}
defineClass(1364, 1, $intern_110, InteractiveNodePlacer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_15(graph) {
    return castTo($getProperty(castTo(graph, 36), ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) ? HIERARCHY_PROCESSING_ADDITIONS : null;
};
_.process = function process_71(layeredGraph, monitor) {
    $process_74(this, castTo(layeredGraph, 36), monitor);
};
var HIERARCHY_PROCESSING_ADDITIONS;
var Lorg_eclipse_elk_alg_layered_p4nodes_InteractiveNodePlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'InteractiveNodePlacer', 1364);
function $clinit_LinearSegmentsNodePlacer() {
    $clinit_LinearSegmentsNodePlacer = emptyMethod;
    HIERARCHY_PROCESSING_ADDITIONS_0 = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), HIERARCHICAL_PORT_POSITION_PROCESSOR));
    INPUT_PRIO = new Property_0('linearSegments.inputPrio', valueOf_3(0));
    OUTPUT_PRIO = new Property_0('linearSegments.outputPrio', valueOf_3(0));
}
function $balancePlacement(this$static, layeredGraph) {
    var deflection, deflectionDampening, finalIters, incoming, lastTotalDeflection, merged, mode, node, node$iterator, outgoing, pendulumIters, ready, segment, segment$array, segment$array0, segment$index, segment$index0, segment$max, segment$max0, thoroughness, threshold, totalDeflection;
    deflectionDampening = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), NODE_PLACEMENT_LINEAR_SEGMENTS_DEFLECTION_DAMPENING_0))));
    thoroughness = castTo($getProperty(layeredGraph, THOROUGHNESS_0), 17).value_0;
    pendulumIters = 4;
    finalIters = 3;
    threshold = 20 / thoroughness;
    ready = false;
    mode = 0;
    lastTotalDeflection = $intern_0;
    do {
        incoming = mode != 1;
        outgoing = mode != 0;
        totalDeflection = 0;
        for(segment$array0 = this$static.linearSegments, segment$index0 = 0, segment$max0 = segment$array0.length; segment$index0 < segment$max0; ++segment$index0){
            segment = segment$array0[segment$index0];
            segment.refSegment = null;
            $calcDeflection(this$static, segment, incoming, outgoing, deflectionDampening);
            totalDeflection += $wnd.Math.abs(segment.deflection);
        }
        do merged = $mergeRegions(this$static, layeredGraph);
        while (merged);
        for(segment$array = this$static.linearSegments, segment$index = 0, segment$max = segment$array.length; segment$index < segment$max; ++segment$index){
            segment = segment$array[segment$index];
            deflection = $region(segment).deflection;
            if (deflection != 0) for(node$iterator = new ArrayList$1(segment.nodes); node$iterator.i < node$iterator.this$01.array.length;){
                node = castTo($next_6(node$iterator), 9);
                node.pos.y_0 += deflection;
            }
        }
        if (mode == 0 || mode == 1) {
            --pendulumIters;
            if (pendulumIters <= 0 && (totalDeflection < lastTotalDeflection || -pendulumIters > thoroughness)) {
                mode = 2;
                lastTotalDeflection = $intern_0;
            } else if (mode == 0) {
                mode = 1;
                lastTotalDeflection = totalDeflection;
            } else {
                mode = 0;
                lastTotalDeflection = totalDeflection;
            }
        } else {
            ready = totalDeflection >= lastTotalDeflection || lastTotalDeflection - totalDeflection < threshold;
            lastTotalDeflection = totalDeflection;
            ready && --finalIters;
        }
    }while (!(ready && finalIters <= 0));
}
function $calcDeflection(this$static, segment, incoming, outgoing, deflectionDampening) {
    var edge, edge$iterator, edgeWeightSum, inputPrio, minPrio, node, node$iterator, nodeDeflection, nodeWeightSum, otherNode, otherPort, otherPrio, outputPrio, port, port$iterator, portpos, prio, segmentDeflection;
    segmentDeflection = 0;
    nodeWeightSum = 0;
    for(node$iterator = new ArrayList$1(segment.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        nodeDeflection = 0;
        edgeWeightSum = 0;
        inputPrio = incoming ? castTo($getProperty(node, INPUT_PRIO), 17).value_0 : $intern_42;
        outputPrio = outgoing ? castTo($getProperty(node, OUTPUT_PRIO), 17).value_0 : $intern_42;
        minPrio = $wnd.Math.max(inputPrio, outputPrio);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            portpos = node.pos.y_0 + port.pos.y_0 + port.anchor.y_0;
            if (outgoing) for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                otherPort = edge.target;
                otherNode = otherPort.owner;
                if (segment != this$static.linearSegments[otherNode.id_0]) {
                    otherPrio = $wnd.Math.max(castTo($getProperty(otherNode, INPUT_PRIO), 17).value_0, castTo($getProperty(otherNode, OUTPUT_PRIO), 17).value_0);
                    prio = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0;
                    if (prio >= minPrio && prio >= otherPrio) {
                        nodeDeflection += otherNode.pos.y_0 + otherPort.pos.y_0 + otherPort.anchor.y_0 - portpos;
                        ++edgeWeightSum;
                    }
                }
            }
            if (incoming) for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                otherPort = edge.source;
                otherNode = otherPort.owner;
                if (segment != this$static.linearSegments[otherNode.id_0]) {
                    otherPrio = $wnd.Math.max(castTo($getProperty(otherNode, INPUT_PRIO), 17).value_0, castTo($getProperty(otherNode, OUTPUT_PRIO), 17).value_0);
                    prio = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0;
                    if (prio >= minPrio && prio >= otherPrio) {
                        nodeDeflection += otherNode.pos.y_0 + otherPort.pos.y_0 + otherPort.anchor.y_0 - portpos;
                        ++edgeWeightSum;
                    }
                }
            }
        }
        if (edgeWeightSum > 0) {
            segmentDeflection += nodeDeflection / edgeWeightSum;
            ++nodeWeightSum;
        }
    }
    if (nodeWeightSum > 0) {
        segment.deflection = deflectionDampening * segmentDeflection / nodeWeightSum;
        segment.weight = nodeWeightSum;
    } else {
        segment.deflection = 0;
        segment.weight = 0;
    }
}
function $createDependencyGraphEdges(layeredGraph, segmentList, outgoingList, incomingCountList) {
    var currentNode, currentSegment, cycleNode, cycleNodesIter, cycleSegment, indexInLayer, layer, layer$iterator, layerIndex, nextLinearSegmentID, nextNode, nextSegment, nodeIter, nodes, previousNode;
    nextLinearSegmentID = segmentList.array.length;
    layerIndex = 0;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodes = layer.nodes;
        if (nodes.array.length == 0) continue;
        nodeIter = new ArrayList$1(nodes);
        indexInLayer = 0;
        previousNode = null;
        currentNode = castTo($next_6(nodeIter), 9);
        currentSegment = null;
        while(currentNode){
            currentSegment = castTo($get_11(segmentList, currentNode.id_0), 261);
            if (currentSegment.indexInLastLayer >= 0) {
                cycleSegment = null;
                cycleNodesIter = new AbstractList$ListIteratorImpl(layer.nodes, indexInLayer + 1);
                while(cycleNodesIter.i < cycleNodesIter.this$01_0.size_1()){
                    cycleNode = (checkCriticalElement(cycleNodesIter.i < cycleNodesIter.this$01_0.size_1()), castTo(cycleNodesIter.this$01_0.get_0(cycleNodesIter.last = cycleNodesIter.i++), 9));
                    cycleSegment = castTo($get_11(segmentList, cycleNode.id_0), 261);
                    if (cycleSegment.lastLayer == currentSegment.lastLayer && cycleSegment.indexInLastLayer < currentSegment.indexInLastLayer) break;
                    else cycleSegment = null;
                }
                if (cycleSegment) {
                    if (previousNode) {
                        $set_1(incomingCountList, currentNode.id_0, valueOf_3(castTo($get_11(incomingCountList, currentNode.id_0), 17).value_0 - 1));
                        castTo($get_11(outgoingList, previousNode.id_0), 15).remove_1(currentSegment);
                    }
                    currentSegment = $split_3(currentSegment, currentNode, nextLinearSegmentID++);
                    push_1(segmentList.array, currentSegment);
                    $add_3(outgoingList, new ArrayList);
                    if (previousNode) {
                        castTo($get_11(outgoingList, previousNode.id_0), 15).add_2(currentSegment);
                        $add_3(incomingCountList, valueOf_3(1));
                    } else $add_3(incomingCountList, valueOf_3(0));
                }
            }
            nextNode = null;
            if (nodeIter.i < nodeIter.this$01.array.length) {
                nextNode = castTo($next_6(nodeIter), 9);
                nextSegment = castTo($get_11(segmentList, nextNode.id_0), 261);
                castTo($get_11(outgoingList, currentNode.id_0), 15).add_2(nextSegment);
                $set_1(incomingCountList, nextNode.id_0, valueOf_3(castTo($get_11(incomingCountList, nextNode.id_0), 17).value_0 + 1));
            }
            currentSegment.lastLayer = layerIndex;
            currentSegment.indexInLastLayer = indexInLayer++;
            previousNode = currentNode;
            currentNode = nextNode;
        }
        ++layerIndex;
    }
}
function $createUnbalancedPlacement(this$static, layeredGraph) {
    var layer, layerIndex, node, node$iterator, node$iterator0, nodeCount, recentNode, recentNodeType, segment, segment$array, segment$index, segment$max, spacing, uppermostPlace;
    nodeCount = initUnidimensionalArray(I_classLit, $intern_48, 30, layeredGraph.layers.array.length, 15, 1);
    recentNodeType = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode$NodeType_2_classLit, $intern_36, 247, layeredGraph.layers.array.length, 0, 1);
    recentNode = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, layeredGraph.layers.array.length, 0, 1);
    for(segment$array = this$static.linearSegments, segment$index = 0, segment$max = segment$array.length; segment$index < segment$max; ++segment$index){
        segment = segment$array[segment$index];
        uppermostPlace = 0;
        for(node$iterator0 = new ArrayList$1(segment.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            layerIndex = $getIndex_0(node.layer);
            ++nodeCount[layerIndex];
            spacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_EDGE_EDGE))));
            nodeCount[layerIndex] > 0 && !!recentNode[layerIndex] && (spacing = $getVerticalSpacing_0(this$static.spacings, recentNode[layerIndex], node));
            uppermostPlace = $wnd.Math.max(uppermostPlace, node.layer.size_0.y_0 + spacing);
        }
        for(node$iterator = new ArrayList$1(segment.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.pos.y_0 = uppermostPlace + node.margin.top_0;
            layer = node.layer;
            layer.size_0.y_0 = uppermostPlace + node.margin.top_0 + node.size_0.y_0 + node.margin.bottom;
            recentNodeType[$indexOf_3(layer.owner.layers, layer, 0)] = node.type_0;
            recentNode[$indexOf_3(layer.owner.layers, layer, 0)] = node;
        }
    }
}
function $fillSegment(this$static, node, segment) {
    var edgesIter, nodeType, sourcePort, sourcePort$iterator, targetNode, targetNodeType, targetPort, targetPort$iterator;
    nodeType = node.type_0;
    if (node.id_0 >= 0) return false;
    else {
        node.id_0 = segment.id_0;
        $add_3(segment.nodes, node);
    }
    if (nodeType == ($clinit_LNode$NodeType(), LONG_EDGE) || nodeType == NORTH_SOUTH_PORT) for(sourcePort$iterator = new ArrayList$1(node.ports); sourcePort$iterator.i < sourcePort$iterator.this$01.array.length;){
        sourcePort = castTo($next_6(sourcePort$iterator), 11);
        for(targetPort$iterator = (edgesIter = new ArrayList$1(new LPort$2(sourcePort).this$01.outgoingEdges), new LPort$2$1(edgesIter)); $hasNext_3(targetPort$iterator.val$edgesIter2);){
            targetPort = castTo($next_6(targetPort$iterator.val$edgesIter2), 18).target;
            targetNode = targetPort.owner;
            targetNodeType = targetNode.type_0;
            if (node.layer != targetNode.layer) {
                if (targetNodeType == LONG_EDGE || targetNodeType == NORTH_SOUTH_PORT) {
                    if ($fillSegment(this$static, targetNode, segment)) return true;
                }
            }
        }
    }
    return true;
}
function $mergeRegions(this$static, layeredGraph) {
    var changed, layer, layer$iterator, node1, node1Extent, node2, node2Extent, nodeIter, nodeSpacing, region1, region2, spacing, threshold, weightSum;
    changed = false;
    nodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0))));
    threshold = $intern_41 * nodeSpacing;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        nodeIter = new ArrayList$1(layer.nodes);
        node1 = castTo($next_6(nodeIter), 9);
        region1 = $region(this$static.linearSegments[node1.id_0]);
        while(nodeIter.i < nodeIter.this$01.array.length){
            node2 = castTo($next_6(nodeIter), 9);
            region2 = $region(this$static.linearSegments[node2.id_0]);
            if (region1 != region2) {
                spacing = $getVerticalSpacing_0(this$static.spacings, node1, node2);
                node1Extent = node1.pos.y_0 + node1.size_0.y_0 + node1.margin.bottom + region1.deflection + spacing;
                node2Extent = node2.pos.y_0 - node2.margin.top_0 + region2.deflection;
                if (node1Extent > node2Extent + threshold) {
                    weightSum = region1.weight + region2.weight;
                    region2.deflection = (region2.weight * region2.deflection + region1.weight * region1.deflection) / weightSum;
                    region2.weight = weightSum;
                    region1.refSegment = region2;
                    changed = true;
                }
            }
            node1 = node2;
            region1 = region2;
        }
    }
    return changed;
}
function $postProcess(this$static) {
    var d, edge, edge$iterator, firstNode, foundPlace, index_0, lastNode, minDisplacement, minRoomAbove, minRoomBelow, neighbor, node, node$iterator, node$iterator0, pos, roomAbove, roomBelow, segment, segment$array, segment$index, segment$max, source, source$iterator, spacing, target, target$iterator;
    for(segment$array = this$static.linearSegments, segment$index = 0, segment$max = segment$array.length; segment$index < segment$max; ++segment$index){
        segment = segment$array[segment$index];
        minRoomAbove = $intern_0;
        minRoomBelow = $intern_0;
        for(node$iterator0 = new ArrayList$1(segment.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
            node = castTo($next_6(node$iterator0), 9);
            index_0 = !node.layer ? -1 : $indexOf_3(node.layer.nodes, node, 0);
            if (index_0 > 0) {
                neighbor = castTo($get_11(node.layer.nodes, index_0 - 1), 9);
                spacing = $getVerticalSpacing_0(this$static.spacings, node, neighbor);
                roomAbove = node.pos.y_0 - node.margin.top_0 - (neighbor.pos.y_0 + neighbor.size_0.y_0 + neighbor.margin.bottom + spacing);
            } else roomAbove = node.pos.y_0 - node.margin.top_0;
            minRoomAbove = $wnd.Math.min(roomAbove, minRoomAbove);
            if (index_0 < node.layer.nodes.array.length - 1) {
                neighbor = castTo($get_11(node.layer.nodes, index_0 + 1), 9);
                spacing = $getVerticalSpacing_0(this$static.spacings, node, neighbor);
                roomBelow = neighbor.pos.y_0 - neighbor.margin.top_0 - (node.pos.y_0 + node.size_0.y_0 + node.margin.bottom + spacing);
            } else roomBelow = 2 * node.pos.y_0;
            minRoomBelow = $wnd.Math.min(roomBelow, minRoomBelow);
        }
        minDisplacement = $intern_0;
        foundPlace = false;
        firstNode = castTo($get_11(segment.nodes, 0), 9);
        for(target$iterator = new ArrayList$1(firstNode.ports); target$iterator.i < target$iterator.this$01.array.length;){
            target = castTo($next_6(target$iterator), 11);
            pos = firstNode.pos.y_0 + target.pos.y_0 + target.anchor.y_0;
            for(edge$iterator = new ArrayList$1(target.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                source = edge.source;
                d = source.owner.pos.y_0 + source.pos.y_0 + source.anchor.y_0 - pos;
                if ($wnd.Math.abs(d) < $wnd.Math.abs(minDisplacement) && $wnd.Math.abs(d) < (d < 0 ? minRoomAbove : minRoomBelow)) {
                    minDisplacement = d;
                    foundPlace = true;
                }
            }
        }
        lastNode = castTo($get_11(segment.nodes, segment.nodes.array.length - 1), 9);
        for(source$iterator = new ArrayList$1(lastNode.ports); source$iterator.i < source$iterator.this$01.array.length;){
            source = castTo($next_6(source$iterator), 11);
            pos = lastNode.pos.y_0 + source.pos.y_0 + source.anchor.y_0;
            for(edge$iterator = new ArrayList$1(source.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                target = edge.target;
                d = target.owner.pos.y_0 + target.pos.y_0 + target.anchor.y_0 - pos;
                if ($wnd.Math.abs(d) < $wnd.Math.abs(minDisplacement) && $wnd.Math.abs(d) < (d < 0 ? minRoomAbove : minRoomBelow)) {
                    minDisplacement = d;
                    foundPlace = true;
                }
            }
        }
        if (foundPlace && minDisplacement != 0) for(node$iterator = new ArrayList$1(segment.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.pos.y_0 += minDisplacement;
        }
    }
}
function $process_75(this$static, layeredGraph, monitor) {
    monitor.begin('Linear segments node placement', 1);
    this$static.spacings = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    $sortLinearSegments(this$static, layeredGraph);
    $createUnbalancedPlacement(this$static, layeredGraph);
    $balancePlacement(this$static, layeredGraph);
    $postProcess(this$static);
    this$static.linearSegments = null;
    this$static.spacings = null;
    monitor.done_1();
}
function $sortLinearSegments(this$static, layeredGraph) {
    var edge, edge$iterator, edge$iterator0, i, i0, i1, i2, incomingCount, incomingCountList, inprio, layer, layer$iterator, layer$iterator0, ls, newRanks, nextLinearSegmentID, nextRank, noIncoming, node, node$iterator, outgoing, outgoingList, outprio, port, port$iterator, prio, rank, segment, segmentList, segments, target;
    segmentList = new ArrayList;
    for(layer$iterator0 = new ArrayList$1(layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.id_0 = -1;
            inprio = $intern_42;
            outprio = $intern_42;
            for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
                port = castTo($next_6(port$iterator), 11);
                for(edge$iterator0 = new ArrayList$1(port.incomingEdges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
                    edge = castTo($next_6(edge$iterator0), 18);
                    prio = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0;
                    inprio = $wnd.Math.max(inprio, prio);
                }
                for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                    edge = castTo($next_6(edge$iterator), 18);
                    prio = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0;
                    outprio = $wnd.Math.max(outprio, prio);
                }
            }
            $setProperty_0(node, INPUT_PRIO, valueOf_3(inprio));
            $setProperty_0(node, OUTPUT_PRIO, valueOf_3(outprio));
        }
    }
    nextLinearSegmentID = 0;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            if (node.id_0 < 0) {
                segment = new LinearSegmentsNodePlacer$LinearSegment;
                segment.id_0 = nextLinearSegmentID++;
                $fillSegment(this$static, node, segment);
                push_1(segmentList.array, segment);
            }
        }
    }
    outgoingList = newArrayListWithCapacity(segmentList.array.length);
    incomingCountList = newArrayListWithCapacity(segmentList.array.length);
    for(i0 = 0; i0 < segmentList.array.length; i0++){
        $add_3(outgoingList, new ArrayList);
        $add_3(incomingCountList, valueOf_3(0));
    }
    $createDependencyGraphEdges(layeredGraph, segmentList, outgoingList, incomingCountList);
    segments = castTo($toArray_1(segmentList, initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p4nodes_LinearSegmentsNodePlacer$LinearSegment_2_classLit, $intern_114, 261, segmentList.array.length, 0, 1)), 833);
    outgoing = castTo($toArray_1(outgoingList, initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, outgoingList.array.length, 0, 1)), 198);
    incomingCount = initUnidimensionalArray(I_classLit, $intern_48, 30, incomingCountList.array.length, 15, 1);
    for(i1 = 0; i1 < incomingCount.length; i1++)incomingCount[i1] = (checkCriticalElementIndex(i1, incomingCountList.array.length), castTo(incomingCountList.array[i1], 17)).value_0;
    nextRank = 0;
    noIncoming = new ArrayList;
    for(i2 = 0; i2 < segments.length; i2++)incomingCount[i2] == 0 && push_1(noIncoming.array, segments[i2]);
    newRanks = initUnidimensionalArray(I_classLit, $intern_48, 30, segments.length, 15, 1);
    while(noIncoming.array.length != 0){
        segment = castTo($remove_11(noIncoming, 0), 261);
        newRanks[segment.id_0] = nextRank++;
        while(!outgoing[segment.id_0].isEmpty()){
            target = castTo(outgoing[segment.id_0].remove_2(0), 261);
            --incomingCount[target.id_0];
            incomingCount[target.id_0] == 0 && push_1(noIncoming.array, target);
        }
    }
    this$static.linearSegments = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p4nodes_LinearSegmentsNodePlacer$LinearSegment_2_classLit, $intern_114, 261, segments.length, 0, 1);
    for(i = 0; i < segments.length; i++){
        ls = segments[i];
        rank = newRanks[i];
        this$static.linearSegments[rank] = ls;
        ls.id_0 = rank;
        for(node$iterator = new ArrayList$1(ls.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.id_0 = rank;
        }
    }
    return this$static.linearSegments;
}
function LinearSegmentsNodePlacer() {
    $clinit_LinearSegmentsNodePlacer();
}
defineClass(1365, 1, $intern_110, LinearSegmentsNodePlacer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_16(graph) {
    return castTo($getProperty(castTo(graph, 36), ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) ? HIERARCHY_PROCESSING_ADDITIONS_0 : null;
};
_.process = function process_72(layeredGraph, monitor) {
    $process_75(this, castTo(layeredGraph, 36), monitor);
};
var HIERARCHY_PROCESSING_ADDITIONS_0, INPUT_PRIO, OUTPUT_PRIO;
var Lorg_eclipse_elk_alg_layered_p4nodes_LinearSegmentsNodePlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'LinearSegmentsNodePlacer', 1365);
function $compareTo_16(this$static, other) {
    return this$static.id_0 - other.id_0;
}
function $region(this$static) {
    var seg;
    seg = this$static;
    while(seg.refSegment)seg = seg.refSegment;
    return seg;
}
function $split_3(this$static, node, newId) {
    var iterator, movedNode, newSegment, nodeIndex;
    nodeIndex = $indexOf_3(this$static.nodes, node, 0);
    newSegment = new LinearSegmentsNodePlacer$LinearSegment;
    newSegment.id_0 = newId;
    iterator = new AbstractList$ListIteratorImpl(this$static.nodes, nodeIndex);
    while(iterator.i < iterator.this$01_0.size_1()){
        movedNode = (checkCriticalElement(iterator.i < iterator.this$01_0.size_1()), castTo(iterator.this$01_0.get_0(iterator.last = iterator.i++), 9));
        movedNode.id_0 = newId;
        $add_3(newSegment.nodes, movedNode);
        $remove_8(iterator);
    }
    return newSegment;
}
function LinearSegmentsNodePlacer$LinearSegment() {
    this.nodes = new ArrayList;
}
defineClass(261, 1, {
    34: 1,
    261: 1
}, LinearSegmentsNodePlacer$LinearSegment);
_.compareTo_0 = function compareTo_17(other) {
    return $compareTo_16(this, castTo(other, 261));
};
_.equals_0 = function equals_155(object) {
    var other;
    if (instanceOf(object, 261)) {
        other = castTo(object, 261);
        return this.id_0 == other.id_0;
    }
    return false;
};
_.hashCode_1 = function hashCode_63() {
    return this.id_0;
};
_.toString_0 = function toString_100() {
    return 'ls' + $toString_2(this.nodes);
};
_.deflection = 0;
_.id_0 = 0;
_.indexInLastLayer = -1;
_.lastLayer = -1;
_.weight = 0;
var Lorg_eclipse_elk_alg_layered_p4nodes_LinearSegmentsNodePlacer$LinearSegment_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'LinearSegmentsNodePlacer/LinearSegment', 261);
function $clinit_NetworkSimplexPlacer() {
    $clinit_NetworkSimplexPlacer = emptyMethod;
    HIERARCHY_PROCESSING_ADDITIONS_1 = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), HIERARCHICAL_PORT_POSITION_PROCESSOR));
}
function $applyPositions(this$static) {
    var flexibleNode, l, l$iterator, lNode, lNode$iterator, label_0, label$iterator, maxY, minY, nNode, nf, nf0, nodeRep, p, p$iterator, placement, sizeDelta;
    for(l$iterator = new ArrayList$1(this$static.lGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        for(lNode$iterator = new ArrayList$1(l.nodes); lNode$iterator.i < lNode$iterator.this$01.array.length;){
            lNode = castTo($next_6(lNode$iterator), 9);
            nodeRep = this$static.nodeReps[lNode.id_0];
            minY = nodeRep.head.layer;
            maxY = nodeRep.tail.layer;
            lNode.pos.y_0 = minY;
            sizeDelta = maxY - minY - lNode.size_0.y_0;
            flexibleNode = isFlexibleNode(lNode);
            nf0 = ($clinit_NodeFlexibility(), (!lNode.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : lNode.propertyMap).containsKey(($clinit_LayeredOptions(), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0)) ? nf = castTo($getProperty(lNode, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0), 203) : nf = castTo($getProperty($getGraph(lNode), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0), 203), nf);
            flexibleNode && (nf0 == NODE_SIZE_WHERE_SPACE_PERMITS || nf0 == NODE_SIZE) && (lNode.size_0.y_0 += sizeDelta);
            if (flexibleNode && (nf0 == PORT_POSITION || nf0 == NODE_SIZE_WHERE_SPACE_PERMITS || nf0 == NODE_SIZE)) {
                for(p$iterator = new ArrayList$1(lNode.ports); p$iterator.i < p$iterator.this$01.array.length;){
                    p = castTo($next_6(p$iterator), 11);
                    if (($clinit_PortSide(), SIDES_EAST_WEST).contains(p.side)) {
                        nNode = castTo($get_10(this$static.portMap, p), 123);
                        p.pos.y_0 = nNode.layer - minY;
                    }
                }
                for(label$iterator = new ArrayList$1(lNode.labels); label$iterator.i < label$iterator.this$01.array.length;){
                    label_0 = castTo($next_6(label$iterator), 72);
                    placement = castTo($getProperty(lNode, NODE_LABELS_PLACEMENT_1), 22);
                    placement.contains(($clinit_NodeLabelPlacement(), V_BOTTOM_0)) ? label_0.pos.y_0 += sizeDelta : placement.contains(V_CENTER_0) && (label_0.pos.y_0 += sizeDelta / 2);
                }
                (nf0 == NODE_SIZE_WHERE_SPACE_PERMITS || nf0 == NODE_SIZE) && $getPortSideView(lNode, ($clinit_PortSide(), SOUTH_0)).forEach_0(new NetworkSimplexPlacer$lambda$20$Type(sizeDelta));
            }
        }
    }
}
function $buildInitialAuxiliaryGraph(this$static) {
    var l, l$iterator;
    for(l$iterator = new ArrayList$1(this$static.lGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        $transformLayer(this$static, l);
    }
    $forEach_3($filter($flatMap($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.lGraph.layers, 16)), new NetworkSimplexPlacer$lambda$2$Type), new NetworkSimplexPlacer$lambda$3$Type), new NetworkSimplexPlacer$lambda$4$Type), new NetworkSimplexPlacer$lambda$5$Type(this$static));
}
function $follow(this$static, edge, current, path) {
    var incident, incident$iterator, other;
    other = $getOther_1(edge, current);
    push_1(path.array, edge);
    if (this$static.nodeState[other.id_0] == -1 || this$static.nodeState[other.id_0] == 2 || this$static.crossing[edge.id_0]) return path;
    this$static.nodeState[other.id_0] = -1;
    for(incident$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(other).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(incident$iterator);){
        incident = castTo($next_0(incident$iterator), 18);
        if (!(!$isSelfLoop(incident) && !(!$isSelfLoop(incident) && incident.source.owner.layer == incident.target.owner.layer)) || incident == edge) continue;
        return $follow(this$static, incident, other, path);
    }
    return path;
}
function $getEdgeWeight(nodeType1, nodeType2) {
    return nodeType1 == ($clinit_LNode$NodeType(), NORMAL) && nodeType2 == NORMAL ? 4 : nodeType1 == NORMAL || nodeType2 == NORMAL ? 8 : 32;
}
function $improveTwoPath(this$static, path, probe) {
    var a, above, aboveDist, aboveRep, b, below, belowDist, belowRep, c, caseA, caseB, caseC, caseD, centerNode, centerOrigin, d, leftEdge, move, nNode, nodeIndex, rightEdge, spacing;
    leftEdge = this$static.edgeReps[(checkCriticalElementIndex(0, path.array.length), castTo(path.array[0], 18)).id_0];
    rightEdge = this$static.edgeReps[(checkCriticalElementIndex(1, path.array.length), castTo(path.array[1], 18)).id_0];
    if (leftEdge.left.target.layer - leftEdge.left.delta - (leftEdge.right.target.layer - leftEdge.right.delta) == 0 && rightEdge.left.target.layer - rightEdge.left.delta - (rightEdge.right.target.layer - rightEdge.right.delta) == 0) return false;
    centerOrigin = leftEdge.right.target.origin_0;
    if (!instanceOf(centerOrigin, 9)) return false;
    centerNode = castTo(centerOrigin, 9);
    nNode = this$static.nodeReps[centerNode.id_0];
    nodeIndex = !centerNode.layer ? -1 : $indexOf_3(centerNode.layer.nodes, centerNode, 0);
    aboveDist = $intern_60;
    if (nodeIndex > 0) {
        above = castTo($get_11(centerNode.layer.nodes, nodeIndex - 1), 9);
        aboveRep = this$static.nodeReps[above.id_0];
        spacing = $wnd.Math.ceil($getVerticalSpacing_0(this$static.spacings, above, centerNode));
        aboveDist = nNode.head.layer - centerNode.margin.top_0 - (aboveRep.head.layer + above.size_0.y_0 + above.margin.bottom) - spacing;
    }
    belowDist = $intern_60;
    if (nodeIndex < centerNode.layer.nodes.array.length - 1) {
        below = castTo($get_11(centerNode.layer.nodes, nodeIndex + 1), 9);
        belowRep = this$static.nodeReps[below.id_0];
        spacing = $wnd.Math.ceil($getVerticalSpacing_0(this$static.spacings, below, centerNode));
        belowDist = belowRep.head.layer - below.margin.top_0 - (nNode.head.layer + centerNode.size_0.y_0 + centerNode.margin.bottom) - spacing;
    }
    if (probe && ($clinit_DoubleMath(), checkNonNegative($intern_115), $wnd.Math.abs(aboveDist - belowDist) <= $intern_115 || aboveDist == belowDist || isNaN(aboveDist) && isNaN(belowDist))) return true;
    a = length_1(leftEdge.left);
    b = -length_1(leftEdge.right);
    c = -length_1(rightEdge.left);
    d = length_1(rightEdge.right);
    caseD = leftEdge.left.target.layer - leftEdge.left.delta - (leftEdge.right.target.layer - leftEdge.right.delta) > 0 && rightEdge.left.target.layer - rightEdge.left.delta - (rightEdge.right.target.layer - rightEdge.right.delta) < 0;
    caseC = leftEdge.left.target.layer - leftEdge.left.delta - (leftEdge.right.target.layer - leftEdge.right.delta) < 0 && rightEdge.left.target.layer - rightEdge.left.delta - (rightEdge.right.target.layer - rightEdge.right.delta) > 0;
    caseB = leftEdge.left.target.layer + leftEdge.right.delta < rightEdge.right.target.layer + rightEdge.left.delta;
    caseA = leftEdge.left.target.layer + leftEdge.right.delta > rightEdge.right.target.layer + rightEdge.left.delta;
    move = 0;
    !caseD && !caseC && (caseA ? aboveDist + c > 0 ? move = c : belowDist - a > 0 && (move = a) : caseB && (aboveDist + b > 0 ? move = b : belowDist - d > 0 && (move = d)));
    nNode.head.layer += move;
    nNode.isFlexible && (nNode.tail.layer += move);
    return false;
}
function $lambda$1_5(this$static, singleNode_1, p_1) {
    return $put_6(this$static.portMap, p_1, singleNode_1);
}
function $lambda$10(this$static, inLayerEdge_0) {
    var dummyNode, dummyRep, portRep, src_0, srcIsDummy, tgt, thePort;
    srcIsDummy = inLayerEdge_0.source.owner.type_0 != ($clinit_LNode$NodeType(), NORMAL);
    thePort = srcIsDummy ? inLayerEdge_0.target : inLayerEdge_0.source;
    dummyNode = $getOther_2(inLayerEdge_0, thePort).owner;
    portRep = castTo($get_10(this$static.portMap, thePort), 123);
    dummyRep = this$static.nodeReps[dummyNode.id_0].head;
    if ($getIndex(thePort.owner) < (!dummyNode.layer ? -1 : $indexOf_3(dummyNode.layer.nodes, dummyNode, 0))) {
        src_0 = portRep;
        tgt = dummyRep;
    } else {
        src_0 = dummyRep;
        tgt = portRep;
    }
    $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 0), 4), src_0), tgt));
}
function $lambda$12(this$static, n_0) {
    var other, sp, sp$iterator, sp$iterator0;
    for(sp$iterator0 = $getPortSideView(n_0, ($clinit_PortSide(), SOUTH_0)).iterator_0(); sp$iterator0.hasNext_0();){
        sp = castTo(sp$iterator0.next_1(), 11);
        other = castTo($getProperty(sp, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
        !!other && $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 0), 0.1), this$static.nodeReps[n_0.id_0].tail), this$static.nodeReps[other.id_0].head));
    }
    for(sp$iterator = $getPortSideView(n_0, NORTH_1).iterator_0(); sp$iterator.hasNext_0();){
        sp = castTo(sp$iterator.next_1(), 11);
        other = castTo($getProperty(sp, ($clinit_InternalProperties_1(), PORT_DUMMY)), 9);
        !!other && $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, 0), 0.1), this$static.nodeReps[other.id_0].tail), this$static.nodeReps[n_0.id_0].head));
    }
}
function $lambda$22(this$static, n_0) {
    return this$static.nodeState[n_0.id_0] = getNodeState(n_0);
}
function $lambda$25(this$static, n_0) {
    return this$static.nodeState[n_0.id_0] == 2;
}
function $lambda$26(this$static, paths_1, junction_1) {
    var e, e$iterator, path;
    for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(junction_1).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        if (!(!$isSelfLoop(e) && !(!$isSelfLoop(e) && e.source.owner.layer == e.target.owner.layer))) continue;
        path = $follow(this$static, e, junction_1, new NetworkSimplexPlacer$Path);
        path.array.length > 1 && push_1(paths_1.array, path);
    }
}
function $lambda$29(this$static, left_0, right_1) {
    $markCrossingEdges(this$static, left_0, right_1);
    return right_1;
}
function $markCrossingEdges(this$static, left, right) {
    var edge, edge$iterator, last, node, node$iterator, node$iterator0, openEdges, openEdgesIt, port, port$iterator;
    openEdges = new ArrayList;
    for(node$iterator0 = new ArrayList$1(left.nodes); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 9);
        for(port$iterator = $getPortSideView(node, ($clinit_PortSide(), EAST_0)).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if (!$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer || $isSelfLoop(edge) || edge.target.owner.layer != right) continue;
                push_1(openEdges.array, edge);
            }
        }
    }
    for(node$iterator = reverse_0(right.nodes).iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 9);
        for(port$iterator = $getPortSideView(node, ($clinit_PortSide(), WEST_0)).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            for(edge$iterator = new ArrayList$1(port.incomingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if (!$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer || $isSelfLoop(edge) || edge.source.owner.layer != left) continue;
                if (openEdges.array.length != 0) {
                    openEdgesIt = new AbstractList$ListIteratorImpl(openEdges, openEdges.array.length);
                    last = (checkCriticalElement(openEdgesIt.i > 0), castTo(openEdgesIt.this$01.get_0(openEdgesIt.last = --openEdgesIt.i), 18));
                    while(last != edge && openEdgesIt.i > 0){
                        this$static.crossing[last.id_0] = true;
                        this$static.crossing[edge.id_0] = true;
                        last = (checkCriticalElement(openEdgesIt.i > 0), castTo(openEdgesIt.this$01.get_0(openEdgesIt.last = --openEdgesIt.i), 18));
                    }
                    openEdgesIt.i > 0 && $remove_8(openEdgesIt);
                }
            }
        }
    }
}
function $postProcessTwoPaths(this$static) {
    var path, q, s, tryAgain;
    q = new LinkedList;
    $addAll(q, this$static.twoPaths);
    s = new Stack;
    while(q.size_0 != 0){
        path = castTo(q.size_0 == 0 ? null : (checkCriticalElement(q.size_0 != 0), $removeNode_0(q, q.header.next_0)), 499);
        tryAgain = $improveTwoPath(this$static, path, true);
        tryAgain && $add_3(s.arrayList, path);
    }
    while(s.arrayList.array.length != 0){
        path = castTo($pop(s), 499);
        $improveTwoPath(this$static, path, false);
    }
}
function $preferStraightEdges(this$static) {
    var cur, curRep, identifiedPaths, last, oldLeftWeight, oldRightWeight, path, path$iterator, pathIt, weight, paths;
    this$static.nodeState = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.nodeCount, 15, 1);
    this$static.twoPaths = new ArrayList;
    $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.lGraph.layers, 16)), new NetworkSimplexPlacer$lambda$21$Type), new NetworkSimplexPlacer$lambda$22$Type(this$static));
    this$static.crossing = initUnidimensionalArray(Z_classLit, $intern_90, 30, this$static.edgeCount, 16, 1);
    $reduce_0(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.lGraph.layers, 16)), new NetworkSimplexPlacer$lambda$29$Type(this$static));
    identifiedPaths = (paths = new ArrayList, $forEach_3($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.lGraph.layers, 16)), new NetworkSimplexPlacer$lambda$24$Type), new NetworkSimplexPlacer$lambda$25$Type(this$static)), new NetworkSimplexPlacer$lambda$26$Type(this$static, paths)), paths);
    for(path$iterator = new ArrayList$1(identifiedPaths); path$iterator.i < path$iterator.this$01.array.length;){
        path = castTo($next_6(path$iterator), 499);
        if (path.array.length <= 1) continue;
        if (path.array.length == 2) {
            $orderTwoPath(path);
            isFlexibleNode((checkCriticalElementIndex(0, path.array.length), castTo(path.array[0], 18)).target.owner) || $add_3(this$static.twoPaths, path);
            continue;
        }
        if ($containsLongEdgeDummy(path) || $containsFlexibleNode(path, new NetworkSimplexPlacer$lambda$23$Type)) continue;
        pathIt = new ArrayList$1(path);
        last = null;
        while(pathIt.i < pathIt.this$01.array.length){
            cur = castTo($next_6(pathIt), 18);
            curRep = this$static.edgeReps[cur.id_0];
            !last || pathIt.i >= pathIt.this$01.array.length ? weight = $getEdgeWeight(($clinit_LNode$NodeType(), NORMAL), LONG_EDGE) : weight = $getEdgeWeight(($clinit_LNode$NodeType(), LONG_EDGE), LONG_EDGE);
            weight *= 2;
            oldLeftWeight = curRep.left.weight;
            curRep.left.weight = $wnd.Math.max(oldLeftWeight, oldLeftWeight + (weight - oldLeftWeight));
            oldRightWeight = curRep.right.weight;
            curRep.right.weight = $wnd.Math.max(oldRightWeight, oldRightWeight + (weight - oldRightWeight));
            last = cur;
        }
    }
}
function $prepare(this$static) {
    var anchorMustBeInteger, e, e$iterator, edgeIdx, l, l$iterator, lNode, lNode$iterator, nodeIdx, offset, p, p$iterator, y_0, y0;
    this$static.nGraph = new NGraph;
    nodeIdx = 0;
    edgeIdx = 0;
    for(l$iterator = new ArrayList$1(this$static.lGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        for(lNode$iterator = new ArrayList$1(l.nodes); lNode$iterator.i < lNode$iterator.this$01.array.length;){
            lNode = castTo($next_6(lNode$iterator), 9);
            lNode.id_0 = nodeIdx++;
            for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(lNode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
                e = castTo($next_0(e$iterator), 18);
                e.id_0 = edgeIdx++;
            }
            anchorMustBeInteger = isFlexibleNode(lNode);
            for(p$iterator = new ArrayList$1(lNode.ports); p$iterator.i < p$iterator.this$01.array.length;){
                p = castTo($next_6(p$iterator), 11);
                if (anchorMustBeInteger) {
                    y0 = p.anchor.y_0;
                    if (y0 != $wnd.Math.floor(y0)) {
                        offset = y0 - toDouble_0(fromDouble_0($wnd.Math.round(y0)));
                        p.anchor.y_0 -= offset;
                    }
                }
                y_0 = p.pos.y_0 + p.anchor.y_0;
                if (y_0 != $wnd.Math.floor(y_0)) {
                    offset = y_0 - toDouble_0(fromDouble_0($wnd.Math.round(y_0)));
                    p.pos.y_0 -= offset;
                }
            }
        }
    }
    this$static.nodeCount = nodeIdx;
    this$static.edgeCount = edgeIdx;
    this$static.nodeReps = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$NodeRep_2_classLit, $intern_2, 401, nodeIdx, 0, 1);
    this$static.edgeReps = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$EdgeRep_2_classLit, $intern_2, 639, edgeIdx, 0, 1);
    this$static.flexibleWhereSpacePermitsEdges.map_0.clear_0();
}
function $process_76(this$static, layeredGraph, progressMonitor) {
    var edge, edge$iterator, iterLimit, pm, minLayer, maxLayer, usedLayers, globalSource, globalSink;
    progressMonitor.begin('Network simplex node placement', 1);
    this$static.lGraph = layeredGraph;
    this$static.spacings = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    $prepare(this$static);
    $buildInitialAuxiliaryGraph(this$static);
    $forEach_3($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.lGraph.layers, 16)), new NetworkSimplexPlacer$lambda$11$Type), new NetworkSimplexPlacer$lambda$12$Type(this$static));
    $forEach_3($filter($flatMap($filter($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.lGraph.layers, 16)), new NetworkSimplexPlacer$lambda$6$Type), new NetworkSimplexPlacer$lambda$7$Type), new NetworkSimplexPlacer$lambda$8$Type), new NetworkSimplexPlacer$lambda$9$Type), new NetworkSimplexPlacer$lambda$10$Type(this$static));
    if ($booleanValue(castToBoolean($getProperty(this$static.lGraph, ($clinit_LayeredOptions(), NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0))))) {
        pm = progressMonitor.subTask(1);
        pm.begin('Straight Edges Pre-Processing', 1);
        $preferStraightEdges(this$static);
        pm.done_1();
    }
    $makeConnected(this$static.nGraph);
    iterLimit = castTo($getProperty(layeredGraph, THOROUGHNESS_0), 17).value_0 * this$static.nGraph.nodes.array.length;
    $execute_0($withBalancing($withIterationLimit(forGraph(this$static.nGraph), iterLimit), false), progressMonitor.subTask(1));
    if (this$static.flexibleWhereSpacePermitsEdges.map_0.size_1() != 0) {
        pm = progressMonitor.subTask(1);
        pm.begin('Flexible Where Space Processing', 1);
        minLayer = castTo($get_17($min_0($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.nGraph.nodes, 16)), new NetworkSimplexPlacer$lambda$13$Type), new NetworkSimplexPlacer$0methodref$compare$Type)), 17).value_0;
        maxLayer = castTo($get_17($max_1($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.nGraph.nodes, 16)), new NetworkSimplexPlacer$lambda$15$Type), new NetworkSimplexPlacer$1methodref$compare$Type)), 17).value_0;
        usedLayers = maxLayer - minLayer;
        globalSource = $create_2(new NNode$NNodeBuilder, this$static.nGraph);
        globalSink = $create_2(new NNode$NNodeBuilder, this$static.nGraph);
        $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, 20000), usedLayers), globalSource), globalSink));
        $forEach_3($filter($filter(stream_4(this$static.nodeReps), new NetworkSimplexPlacer$lambda$17$Type), new NetworkSimplexPlacer$lambda$18$Type), new NetworkSimplexPlacer$lambda$19$Type(minLayer, globalSource, usedLayers, globalSink));
        for(edge$iterator = this$static.flexibleWhereSpacePermitsEdges.map_0.keySet_0().iterator_0(); edge$iterator.hasNext_0();){
            edge = castTo(edge$iterator.next_1(), 216);
            edge.weight = 1;
        }
        $execute_0($withBalancing($withIterationLimit(forGraph(this$static.nGraph), iterLimit), false), pm.subTask(1));
        pm.done_1();
    }
    if ($booleanValue(castToBoolean($getProperty(layeredGraph, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0)))) {
        pm = progressMonitor.subTask(1);
        pm.begin('Straight Edges Post-Processing', 1);
        $postProcessTwoPaths(this$static);
        pm.done_1();
    }
    $applyPositions(this$static);
    this$static.lGraph = null;
    this$static.nGraph = null;
    this$static.nodeReps = null;
    this$static.edgeReps = null;
    $reset(this$static.portMap);
    this$static.nodeState = null;
    this$static.crossing = null;
    this$static.twoPaths = null;
    this$static.flexibleWhereSpacePermitsEdges.map_0.clear_0();
    progressMonitor.done_1();
}
function $transformEdge_0(this$static, lEdge) {
    var dummy, edgeRep, left, right, srcDelta, srcOffset, srcPort, srcRep, tgtDelta, tgtOffset, tgtPort, tgtRep, weight, priority, edgeTypeWeight;
    dummy = $create_2(new NNode$NNodeBuilder, this$static.nGraph);
    srcRep = this$static.nodeReps[lEdge.source.owner.id_0];
    tgtRep = this$static.nodeReps[lEdge.target.owner.id_0];
    srcPort = lEdge.source;
    tgtPort = lEdge.target;
    srcOffset = srcPort.anchor.y_0;
    tgtOffset = tgtPort.anchor.y_0;
    srcRep.isFlexible || (srcOffset += srcPort.pos.y_0);
    tgtRep.isFlexible || (tgtOffset += tgtPort.pos.y_0);
    tgtDelta = round_int($wnd.Math.max(0, srcOffset - tgtOffset));
    srcDelta = round_int($wnd.Math.max(0, tgtOffset - srcOffset));
    weight = (priority = $wnd.Math.max(1, castTo($getProperty(lEdge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0), edgeTypeWeight = $getEdgeWeight(lEdge.source.owner.type_0, lEdge.target.owner.type_0), priority * edgeTypeWeight);
    left = $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, weight), srcDelta), dummy), castTo($get_10(this$static.portMap, lEdge.source), 123)));
    right = $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, weight), tgtDelta), dummy), castTo($get_10(this$static.portMap, lEdge.target), 123)));
    edgeRep = new NetworkSimplexPlacer$EdgeRep(left, right);
    this$static.edgeReps[lEdge.id_0] = edgeRep;
}
function $transformLayer(this$static, layer) {
    var lNode, lNode$iterator, lastRep, nodeRep, spacing, topLeft, bottomLeft, corners, minHeight, nf0, nf, sizeWeight, nodeSizeEdge, singleNode;
    lastRep = null;
    for(lNode$iterator = new ArrayList$1(layer.nodes); lNode$iterator.i < lNode$iterator.this$01.array.length;){
        lNode = castTo($next_6(lNode$iterator), 9);
        isFlexibleNode(lNode) ? nodeRep = (topLeft = $create_2($origin_0(new NNode$NNodeBuilder, lNode), this$static.nGraph), bottomLeft = $create_2($origin_0(new NNode$NNodeBuilder, lNode), this$static.nGraph), corners = new NetworkSimplexPlacer$NodeRep(lNode, true, topLeft, bottomLeft), minHeight = lNode.size_0.y_0, nf0 = ($clinit_NodeFlexibility(), (!lNode.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : lNode.propertyMap).containsKey(($clinit_LayeredOptions(), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0)) ? nf = castTo($getProperty(lNode, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0), 203) : nf = castTo($getProperty($getGraph(lNode), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0), 203), nf), sizeWeight = 10000, nf0 == NODE_SIZE && (sizeWeight = 1), nodeSizeEdge = $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, sizeWeight), round_int($wnd.Math.ceil(minHeight))), topLeft), bottomLeft)), nf0 == NODE_SIZE_WHERE_SPACE_PERMITS && $add_6(this$static.flexibleWhereSpacePermitsEdges, nodeSizeEdge), $transformPorts(this$static, reverse_0($getPortSideView(lNode, ($clinit_PortSide(), WEST_0))), corners), $transformPorts(this$static, $getPortSideView(lNode, EAST_0), corners), corners) : nodeRep = (singleNode = $create_2($origin_0(new NNode$NNodeBuilder, lNode), this$static.nGraph), $forEach_3($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(lNode.ports, 16)), new NetworkSimplexPlacer$lambda$0$Type), new NetworkSimplexPlacer$lambda$1$Type(this$static, singleNode)), new NetworkSimplexPlacer$NodeRep(lNode, false, singleNode, singleNode));
        this$static.nodeReps[lNode.id_0] = nodeRep;
        if (lastRep) {
            spacing = lastRep.origin_0.margin.bottom + $getVerticalSpacing_0(this$static.spacings, lastRep.origin_0, lNode) + lNode.margin.top_0;
            lastRep.isFlexible || (spacing += lastRep.origin_0.size_0.y_0);
            $create_1($target($source($weight($delta(new NEdge$NEdgeBuilder, round_int($wnd.Math.ceil(spacing))), 0), lastRep.tail), nodeRep.head));
        }
        lastRep = nodeRep;
    }
}
function $transformPorts(this$static, ports, corners) {
    var lastNNode, lastPort, nNode, port, port$iterator, portSpacing, portSurrounding, spacing;
    if (isEmpty_13(ports)) return;
    portSpacing = $doubleValue(castToDouble(getIndividualOrDefault(corners.origin_0, ($clinit_LayeredOptions(), SPACING_PORT_PORT))));
    portSurrounding = castTo(getIndividualOrDefault(corners.origin_0, SPACING_PORTS_SURROUNDING), 139);
    !portSurrounding && (portSurrounding = new ElkMargin);
    lastNNode = corners.head;
    lastPort = null;
    for(port$iterator = ports.iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        spacing = 0;
        if (!lastPort) spacing = portSurrounding.top_0;
        else {
            spacing = portSpacing;
            spacing += lastPort.size_0.y_0;
        }
        nNode = $create_2($origin_0(new NNode$NNodeBuilder, port), this$static.nGraph);
        $put_6(this$static.portMap, port, nNode);
        $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, 0), round_int($wnd.Math.ceil(spacing))), lastNNode), nNode));
        lastPort = port;
        lastNNode = nNode;
    }
    $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, 0), round_int($wnd.Math.ceil(portSurrounding.bottom + lastPort.size_0.y_0))), lastNNode), corners.tail));
}
function NetworkSimplexPlacer() {
    $clinit_NetworkSimplexPlacer();
    this.portMap = new HashMap;
    this.flexibleWhereSpacePermitsEdges = new HashSet;
}
function getNodeState(node) {
    var inco, ouco, p, p$iterator;
    inco = 0;
    ouco = 0;
    for(p$iterator = new ArrayList$1(node.ports); p$iterator.i < p$iterator.this$01.array.length;){
        p = castTo($next_6(p$iterator), 11);
        inco = toInt_0(add_20(inco, $count_0($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(p.incomingEdges, 16)), new NetworkSimplexPlacer$lambda$27$Type))));
        ouco = toInt_0(add_20(ouco, $count_0($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(p.outgoingEdges, 16)), new NetworkSimplexPlacer$lambda$28$Type))));
        if (inco > 1 || ouco > 1) return 2;
    }
    if (inco + ouco == 1) return 2;
    return 0;
}
function isFlexibleNode(lNode) {
    var additionalPortSpacing, eastPorts, nf, nf0, pc, portSpacing, requiredEastHeight, requiredWestHeight, westPorts;
    if (lNode.type_0 != ($clinit_LNode$NodeType(), NORMAL)) return false;
    if (lNode.ports.array.length <= 1) return false;
    pc = castTo($getProperty(lNode, ($clinit_LayeredOptions(), PORT_CONSTRAINTS_0)), 100);
    if (pc == ($clinit_PortConstraints(), FIXED_POS)) return false;
    nf0 = ($clinit_NodeFlexibility(), (!lNode.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : lNode.propertyMap).containsKey(NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0) ? nf = castTo($getProperty(lNode, NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_0), 203) : nf = castTo($getProperty($getGraph(lNode), NODE_PLACEMENT_NETWORK_SIMPLEX_NODE_FLEXIBILITY_DEFAULT_0), 203), nf);
    if (nf0 == NONE_9) return false;
    if (!(nf0 == NODE_SIZE_WHERE_SPACE_PERMITS || nf0 == NODE_SIZE)) {
        portSpacing = $doubleValue(castToDouble(getIndividualOrDefault(lNode, SPACING_PORT_PORT)));
        additionalPortSpacing = castTo($getProperty(lNode, SPACING_PORTS_SURROUNDING), 139);
        !additionalPortSpacing && (additionalPortSpacing = new ElkMargin_1(portSpacing, portSpacing, portSpacing, portSpacing));
        westPorts = $getPortSideView(lNode, ($clinit_PortSide(), WEST_0));
        requiredWestHeight = additionalPortSpacing.top_0 + additionalPortSpacing.bottom + (westPorts.size_1() - 1) * portSpacing;
        if (requiredWestHeight > lNode.size_0.y_0) return false;
        eastPorts = $getPortSideView(lNode, EAST_0);
        requiredEastHeight = additionalPortSpacing.top_0 + additionalPortSpacing.bottom + (eastPorts.size_1() - 1) * portSpacing;
        if (requiredEastHeight > lNode.size_0.y_0) return false;
    }
    return true;
}
function isHandledEdge(edge) {
    $clinit_NetworkSimplexPlacer();
    return !$isSelfLoop(edge) && !(!$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer);
}
function lambda$0_30(p_0) {
    $clinit_NetworkSimplexPlacer();
    return ($clinit_PortSide(), SIDES_EAST_WEST).contains(p_0.side);
}
function lambda$19(minLayer_0, globalSource_1, usedLayers_2, globalSink_3, nr_4) {
    $clinit_NetworkSimplexPlacer();
    $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, 0), nr_4.tail.layer - minLayer_0), globalSource_1), nr_4.tail));
    $create_1($target($source($delta($weight(new NEdge$NEdgeBuilder, 0), usedLayers_2 - nr_4.head.layer), nr_4.head), globalSink_3));
}
function lambda$20(sizeDelta_0, p_1) {
    $clinit_NetworkSimplexPlacer();
    return p_1.pos.y_0 += sizeDelta_0;
}
function length_1(edge) {
    return $wnd.Math.abs(edge.source.layer - edge.target.layer) - edge.delta;
}
defineClass(1367, 1, $intern_110, NetworkSimplexPlacer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_17(graph) {
    return castTo($getProperty(castTo(graph, 36), ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) ? HIERARCHY_PROCESSING_ADDITIONS_1 : null;
};
_.process = function process_73(layeredGraph, progressMonitor) {
    $process_76(this, castTo(layeredGraph, 36), progressMonitor);
};
_.edgeCount = 0;
_.nodeCount = 0;
var HIERARCHY_PROCESSING_ADDITIONS_1;
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer', 1367);
function NetworkSimplexPlacer$0methodref$compare$Type() {}
defineClass(1386, 1, $intern_88, NetworkSimplexPlacer$0methodref$compare$Type);
_.compare_1 = function compare_71(arg0, arg1) {
    return compare_5(castTo(arg0, 17).value_0, castTo(arg1, 17).value_0);
};
_.equals_0 = function equals_156(other) {
    return this === other;
};
_.reversed = function reversed_63() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$0methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/0methodref$compare$Type', 1386);
function NetworkSimplexPlacer$1methodref$compare$Type() {}
defineClass(1388, 1, $intern_88, NetworkSimplexPlacer$1methodref$compare$Type);
_.compare_1 = function compare_72(arg0, arg1) {
    return compare_5(castTo(arg0, 17).value_0, castTo(arg1, 17).value_0);
};
_.equals_0 = function equals_157(other) {
    return this === other;
};
_.reversed = function reversed_64() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$1methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/1methodref$compare$Type', 1388);
function NetworkSimplexPlacer$EdgeRep(left, right) {
    this.left = left;
    this.right = right;
}
defineClass(639, 1, {
    639: 1
}, NetworkSimplexPlacer$EdgeRep);
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$EdgeRep_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/EdgeRep', 639);
function NetworkSimplexPlacer$NodeRep(origin_0, isFlexible, top_0, bottom) {
    this.origin_0 = origin_0;
    this.isFlexible = isFlexible;
    this.head = top_0;
    this.tail = bottom;
}
defineClass(401, 1, {
    401: 1
}, NetworkSimplexPlacer$NodeRep);
_.isFlexible = false;
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$NodeRep_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/NodeRep', 401);
function $containsFlexibleNode(this$static, p) {
    var nf;
    if (this$static.array.length == 0) return false;
    nf = getNodeFlexibility((checkCriticalElementIndex(0, this$static.array.length), castTo(this$static.array[0], 18)).source.owner);
    $clinit_NetworkSimplexPlacer();
    if (nf == ($clinit_NodeFlexibility(), NODE_SIZE_WHERE_SPACE_PERMITS) || nf == NODE_SIZE) return true;
    return $anyMatch($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static, 16)), new NetworkSimplexPlacer$Path$lambda$2$Type), new NetworkSimplexPlacer$Path$lambda$3$Type(p));
}
function $containsLongEdgeDummy(this$static) {
    if (this$static.array.length == 0) return false;
    if ((checkCriticalElementIndex(0, this$static.array.length), castTo(this$static.array[0], 18)).source.owner.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) return true;
    return $anyMatch($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static, 16)), new NetworkSimplexPlacer$Path$lambda$0$Type), new NetworkSimplexPlacer$Path$lambda$1$Type);
}
function $orderTwoPath(this$static) {
    var first, second;
    if (this$static.array.length != 2) throw toJs(new IllegalStateException_0('Order only allowed for two paths.'));
    first = (checkCriticalElementIndex(0, this$static.array.length), castTo(this$static.array[0], 18));
    second = (checkCriticalElementIndex(1, this$static.array.length), castTo(this$static.array[1], 18));
    if (first.target.owner != second.source.owner) {
        this$static.array.length = 0;
        push_1(this$static.array, second);
        push_1(this$static.array, first);
    }
}
function NetworkSimplexPlacer$Path() {
    ArrayList.call(this);
}
defineClass(499, 13, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    13: 1,
    16: 1,
    15: 1,
    59: 1,
    499: 1
}, NetworkSimplexPlacer$Path);
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$Path_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/Path', 499);
function NetworkSimplexPlacer$Path$lambda$0$Type() {}
defineClass(1368, 1, {}, NetworkSimplexPlacer$Path$lambda$0$Type);
_.apply_0 = function apply_112(arg0) {
    return castTo(arg0, 18).target.owner.type_0;
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$Path$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/Path/lambda$0$Type', 1368);
function NetworkSimplexPlacer$Path$lambda$1$Type() {}
defineClass(1369, 1, $intern_39, NetworkSimplexPlacer$Path$lambda$1$Type);
_.test_0 = function test_84(arg0) {
    return castTo(arg0, 247) == ($clinit_LNode$NodeType(), LONG_EDGE);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$Path$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/Path/lambda$1$Type', 1369);
function NetworkSimplexPlacer$Path$lambda$2$Type() {}
defineClass(1370, 1, {}, NetworkSimplexPlacer$Path$lambda$2$Type);
_.apply_0 = function apply_113(arg0) {
    return castTo(arg0, 18).target.owner;
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$Path$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/Path/lambda$2$Type', 1370);
function NetworkSimplexPlacer$Path$lambda$3$Type(p_0) {
    this.p_0 = p_0;
}
defineClass(1371, 1, $intern_39, NetworkSimplexPlacer$Path$lambda$3$Type);
_.test_0 = function test_85(arg0) {
    return $test(getNodeFlexibility(castTo(arg0, 9)));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$Path$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/Path/lambda$3$Type', 1371);
function NetworkSimplexPlacer$lambda$0$Type() {}
defineClass(1372, 1, $intern_39, NetworkSimplexPlacer$lambda$0$Type);
_.test_0 = function test_86(arg0) {
    return lambda$0_30(castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$0$Type', 1372);
function NetworkSimplexPlacer$lambda$1$Type($$outer_0, singleNode_1) {
    this.$$outer_0 = $$outer_0;
    this.singleNode_1 = singleNode_1;
}
defineClass(1373, 1, $intern_19, NetworkSimplexPlacer$lambda$1$Type);
_.accept = function accept_120(arg0) {
    $lambda$1_5(this.$$outer_0, this.singleNode_1, castTo(arg0, 11));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$1$Type', 1373);
function NetworkSimplexPlacer$lambda$10$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1382, 1, $intern_19, NetworkSimplexPlacer$lambda$10$Type);
_.accept = function accept_121(arg0) {
    $lambda$10(this.$$outer_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$10$Type', 1382);
function NetworkSimplexPlacer$lambda$11$Type() {}
defineClass(1383, 1, {}, NetworkSimplexPlacer$lambda$11$Type);
_.apply_0 = function apply_114(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$11$Type', 1383);
function NetworkSimplexPlacer$lambda$12$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1384, 1, $intern_19, NetworkSimplexPlacer$lambda$12$Type);
_.accept = function accept_122(arg0) {
    $lambda$12(this.$$outer_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$12$Type', 1384);
function NetworkSimplexPlacer$lambda$13$Type() {}
defineClass(1385, 1, {}, NetworkSimplexPlacer$lambda$13$Type);
_.apply_0 = function apply_115(arg0) {
    return $clinit_NetworkSimplexPlacer(), valueOf_3(castTo(arg0, 123).layer);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$13$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$13$Type', 1385);
function NetworkSimplexPlacer$lambda$15$Type() {}
defineClass(1387, 1, {}, NetworkSimplexPlacer$lambda$15$Type);
_.apply_0 = function apply_116(arg0) {
    return $clinit_NetworkSimplexPlacer(), valueOf_3(castTo(arg0, 123).layer);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$15$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$15$Type', 1387);
function NetworkSimplexPlacer$lambda$17$Type() {}
defineClass(1389, 1, $intern_39, NetworkSimplexPlacer$lambda$17$Type);
_.test_0 = function test_87(arg0) {
    return $clinit_NetworkSimplexPlacer(), castTo(arg0, 401).origin_0.type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$17$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$17$Type', 1389);
function NetworkSimplexPlacer$lambda$18$Type() {}
defineClass(1390, 1, $intern_39, NetworkSimplexPlacer$lambda$18$Type);
_.test_0 = function test_88(arg0) {
    return $clinit_NetworkSimplexPlacer(), castTo(arg0, 401).origin_0.ports.array.length > 1;
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$18$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$18$Type', 1390);
function NetworkSimplexPlacer$lambda$19$Type(minLayer_0, globalSource_1, usedLayers_2, globalSink_3) {
    this.minLayer_0 = minLayer_0;
    this.globalSource_1 = globalSource_1;
    this.usedLayers_2 = usedLayers_2;
    this.globalSink_3 = globalSink_3;
}
defineClass(1391, 1, $intern_19, NetworkSimplexPlacer$lambda$19$Type);
_.accept = function accept_123(arg0) {
    lambda$19(this.minLayer_0, this.globalSource_1, this.usedLayers_2, this.globalSink_3, castTo(arg0, 401));
};
_.minLayer_0 = 0;
_.usedLayers_2 = 0;
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$19$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$19$Type', 1391);
function NetworkSimplexPlacer$lambda$2$Type() {}
defineClass(1374, 1, {}, NetworkSimplexPlacer$lambda$2$Type);
_.apply_0 = function apply_117(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$2$Type', 1374);
function NetworkSimplexPlacer$lambda$20$Type(sizeDelta_0) {
    this.sizeDelta_0 = sizeDelta_0;
}
defineClass(1392, 1, $intern_19, NetworkSimplexPlacer$lambda$20$Type);
_.accept = function accept_124(arg0) {
    lambda$20(this.sizeDelta_0, castTo(arg0, 11));
};
_.sizeDelta_0 = 0;
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$20$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$20$Type', 1392);
function NetworkSimplexPlacer$lambda$21$Type() {}
defineClass(1393, 1, {}, NetworkSimplexPlacer$lambda$21$Type);
_.apply_0 = function apply_118(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$21$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$21$Type', 1393);
function NetworkSimplexPlacer$lambda$22$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1394, 1, $intern_19, NetworkSimplexPlacer$lambda$22$Type);
_.accept = function accept_125(arg0) {
    $lambda$22(this.$$outer_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$22$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$22$Type', 1394);
function $test(arg0) {
    return $clinit_NetworkSimplexPlacer(), $isFlexibleSizeWhereSpacePermits(castTo(arg0, 203));
}
function NetworkSimplexPlacer$lambda$23$Type() {}
defineClass(1395, 1, $intern_39, NetworkSimplexPlacer$lambda$23$Type);
_.test_0 = function test_89(arg0) {
    return $test(arg0);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$23$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$23$Type', 1395);
function NetworkSimplexPlacer$lambda$24$Type() {}
defineClass(1396, 1, {}, NetworkSimplexPlacer$lambda$24$Type);
_.apply_0 = function apply_119(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$24$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$24$Type', 1396);
function NetworkSimplexPlacer$lambda$25$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1397, 1, $intern_39, NetworkSimplexPlacer$lambda$25$Type);
_.test_0 = function test_90(arg0) {
    return $lambda$25(this.$$outer_0, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$25$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$25$Type', 1397);
function NetworkSimplexPlacer$lambda$26$Type($$outer_0, paths_1) {
    this.$$outer_0 = $$outer_0;
    this.paths_1 = paths_1;
}
defineClass(1398, 1, $intern_19, NetworkSimplexPlacer$lambda$26$Type);
_.accept = function accept_126(arg0) {
    $lambda$26(this.$$outer_0, this.paths_1, castTo(arg0, 9));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$26$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$26$Type', 1398);
function NetworkSimplexPlacer$lambda$27$Type() {}
defineClass(1399, 1, $intern_39, NetworkSimplexPlacer$lambda$27$Type);
_.test_0 = function test_91(arg0) {
    return $clinit_NetworkSimplexPlacer(), !$isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$27$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$27$Type', 1399);
function NetworkSimplexPlacer$lambda$28$Type() {}
defineClass(1400, 1, $intern_39, NetworkSimplexPlacer$lambda$28$Type);
_.test_0 = function test_92(arg0) {
    return $clinit_NetworkSimplexPlacer(), !$isSelfLoop(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$28$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$28$Type', 1400);
function NetworkSimplexPlacer$lambda$29$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1401, 1, {}, NetworkSimplexPlacer$lambda$29$Type);
_.apply_3 = function apply_120(arg0, arg1) {
    return $lambda$29(this.$$outer_0, castTo(arg0, 25), castTo(arg1, 25));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$29$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$29$Type', 1401);
function NetworkSimplexPlacer$lambda$3$Type() {}
defineClass(1375, 1, {}, NetworkSimplexPlacer$lambda$3$Type);
_.apply_0 = function apply_121(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$3$Type', 1375);
function NetworkSimplexPlacer$lambda$4$Type() {}
defineClass(1376, 1, $intern_39, NetworkSimplexPlacer$lambda$4$Type);
_.test_0 = function test_93(arg0) {
    return $clinit_NetworkSimplexPlacer(), isHandledEdge(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$4$Type', 1376);
function NetworkSimplexPlacer$lambda$5$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1377, 1, $intern_19, NetworkSimplexPlacer$lambda$5$Type);
_.accept = function accept_127(arg0) {
    $transformEdge_0(this.$$outer_0, castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$5$Type', 1377);
function NetworkSimplexPlacer$lambda$6$Type() {}
defineClass(1378, 1, {}, NetworkSimplexPlacer$lambda$6$Type);
_.apply_0 = function apply_122(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 25).nodes, 16));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$6$Type', 1378);
function NetworkSimplexPlacer$lambda$7$Type() {}
defineClass(1379, 1, $intern_39, NetworkSimplexPlacer$lambda$7$Type);
_.test_0 = function test_94(arg0) {
    return $clinit_NetworkSimplexPlacer(), castTo(arg0, 9).type_0 == ($clinit_LNode$NodeType(), NORMAL);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$7$Type', 1379);
function NetworkSimplexPlacer$lambda$8$Type() {}
defineClass(1380, 1, {}, NetworkSimplexPlacer$lambda$8$Type);
_.apply_0 = function apply_123(arg0) {
    return $clinit_NetworkSimplexPlacer(), new StreamImpl(null, new Spliterators$IteratorSpliterator_0(new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(castTo(arg0, 9)).val$inputs1.iterator_0(), new Iterables$10))));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$8$Type', 1380);
function NetworkSimplexPlacer$lambda$9$Type() {}
defineClass(1381, 1, $intern_39, NetworkSimplexPlacer$lambda$9$Type);
_.test_0 = function test_95(arg0) {
    return $clinit_NetworkSimplexPlacer(), $isInLayerEdge(castTo(arg0, 18));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_NetworkSimplexPlacer$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'NetworkSimplexPlacer/lambda$9$Type', 1381);
function $clinit_SimpleNodePlacer() {
    $clinit_SimpleNodePlacer = emptyMethod;
    HIERARCHY_PROCESSING_ADDITIONS_2 = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), HIERARCHICAL_PORT_POSITION_PROCESSOR));
}
function $process_77(layeredGraph, monitor) {
    var lastNode, layer, layer$iterator, layer$iterator0, layerSize, maxHeight, node, node$iterator, pos, spacings;
    monitor.begin('Simple node placement', 1);
    spacings = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    maxHeight = 0;
    for(layer$iterator0 = new ArrayList$1(layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        layerSize = layer.size_0;
        layerSize.y_0 = 0;
        lastNode = null;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            !!lastNode && (layerSize.y_0 += $getLocalSpacing_0(node, lastNode, spacings.nodeTypeSpacingOptionsVertical));
            layerSize.y_0 += node.margin.top_0 + node.size_0.y_0 + node.margin.bottom;
            lastNode = node;
        }
        maxHeight = $wnd.Math.max(maxHeight, layerSize.y_0);
    }
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layerSize = layer.size_0;
        pos = (maxHeight - layerSize.y_0) / 2;
        lastNode = null;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            !!lastNode && (pos += $getLocalSpacing_0(node, lastNode, spacings.nodeTypeSpacingOptionsVertical));
            pos += node.margin.top_0;
            node.pos.y_0 = pos;
            pos += node.size_0.y_0 + node.margin.bottom;
            lastNode = node;
        }
    }
    monitor.done_1();
}
function SimpleNodePlacer() {
    $clinit_SimpleNodePlacer();
}
defineClass(1363, 1, $intern_110, SimpleNodePlacer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_18(graph) {
    return castTo($getProperty(castTo(graph, 36), ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) ? HIERARCHY_PROCESSING_ADDITIONS_2 : null;
};
_.process = function process_74(layeredGraph, monitor) {
    $process_77(castTo(layeredGraph, 36), monitor);
};
var HIERARCHY_PROCESSING_ADDITIONS_2;
var Lorg_eclipse_elk_alg_layered_p4nodes_SimpleNodePlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes', 'SimpleNodePlacer', 1363);
function $calculateDelta(this$static, src_0, tgt) {
    var srcPos, tgtPos;
    srcPos = $doubleValue(this$static.y_0[src_0.owner.id_0]) + $doubleValue(this$static.innerShift[src_0.owner.id_0]) + src_0.pos.y_0 + src_0.anchor.y_0;
    tgtPos = $doubleValue(this$static.y_0[tgt.owner.id_0]) + $doubleValue(this$static.innerShift[tgt.owner.id_0]) + tgt.pos.y_0 + tgt.anchor.y_0;
    return tgtPos - srcPos;
}
function $checkSpaceAbove(this$static, blockRoot, delta, ni) {
    var availableSpace, current, maxYNeighbor, minYCurrent, neighbor, rootNode, rootNode0, rootNode1;
    availableSpace = delta;
    rootNode0 = blockRoot;
    current = rootNode0;
    do {
        current = this$static.align_0[current.id_0];
        minYCurrent = (rootNode1 = this$static.root[current.id_0], $doubleValue(this$static.y_0[rootNode1.id_0]) + $doubleValue(this$static.innerShift[current.id_0]) - current.margin.top_0);
        neighbor = $getUpperNeighbor(current, ni);
        if (neighbor) {
            maxYNeighbor = (rootNode = this$static.root[neighbor.id_0], $doubleValue(this$static.y_0[rootNode.id_0]) + $doubleValue(this$static.innerShift[neighbor.id_0]) + neighbor.size_0.y_0 + neighbor.margin.bottom);
            availableSpace = $wnd.Math.min(availableSpace, minYCurrent - (maxYNeighbor + $getVerticalSpacing_0(this$static.spacings, current, neighbor)));
        }
    }while (rootNode0 != current);
    return availableSpace;
}
function $checkSpaceBelow(this$static, blockRoot, delta, ni) {
    var availableSpace, current, maxYCurrent, minYNeighbor, neighbor, rootNode, rootNode0, rootNode1;
    availableSpace = delta;
    rootNode0 = blockRoot;
    current = rootNode0;
    do {
        current = this$static.align_0[current.id_0];
        maxYCurrent = (rootNode1 = this$static.root[current.id_0], $doubleValue(this$static.y_0[rootNode1.id_0]) + $doubleValue(this$static.innerShift[current.id_0]) + current.size_0.y_0 + current.margin.bottom);
        neighbor = $getLowerNeighbor(current, ni);
        if (neighbor) {
            minYNeighbor = (rootNode = this$static.root[neighbor.id_0], $doubleValue(this$static.y_0[rootNode.id_0]) + $doubleValue(this$static.innerShift[neighbor.id_0]) - neighbor.margin.top_0);
            availableSpace = $wnd.Math.min(availableSpace, minYNeighbor - (maxYCurrent + $getVerticalSpacing_0(this$static.spacings, current, neighbor)));
        }
    }while (rootNode0 != current);
    return availableSpace;
}
function $getLowerNeighbor(n, ni) {
    var l, layerIndex;
    l = n.layer;
    layerIndex = ni.nodeIndex[n.id_0];
    if (layerIndex < l.nodes.array.length - 1) return castTo($get_11(l.nodes, layerIndex + 1), 9);
    return null;
}
function $getUpperNeighbor(n, ni) {
    var l, layerIndex;
    l = n.layer;
    layerIndex = ni.nodeIndex[n.id_0];
    if (layerIndex > 0) return castTo($get_11(l.nodes, layerIndex - 1), 9);
    return null;
}
function $layoutSize(this$static) {
    var layer, layer$iterator, max_0, min_0, n, n$iterator, yMax, yMin;
    min_0 = $intern_60;
    max_0 = $intern_61;
    for(layer$iterator = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(n$iterator = new ArrayList$1(layer.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            yMin = $doubleValue(this$static.y_0[n.id_0]);
            yMax = yMin + $doubleValue(this$static.blockSize[this$static.root[n.id_0].id_0]);
            min_0 = $wnd.Math.min(min_0, yMin);
            max_0 = $wnd.Math.max(max_0, yMax);
        }
    }
    return max_0 - min_0;
}
function $shiftBlock(this$static, rootNode, delta) {
    var current, newPos;
    current = rootNode;
    do {
        newPos = $doubleValue(this$static.y_0[current.id_0]) + delta;
        this$static.y_0[current.id_0] = newPos;
        current = this$static.align_0[current.id_0];
    }while (current != rootNode);
}
function BKAlignedLayout(layeredGraph, nodeCount, vdir, hdir) {
    this.layeredGraph = layeredGraph;
    this.spacings = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    this.root = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, nodeCount, 0, 1);
    this.blockSize = initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, nodeCount, 7, 1);
    this.align_0 = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, nodeCount, 0, 1);
    this.innerShift = initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, nodeCount, 7, 1);
    this.sink = initUnidimensionalArray(Lorg_eclipse_elk_alg_layered_graph_LNode_2_classLit, $intern_104, 9, nodeCount, 0, 1);
    this.shift_0 = initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, nodeCount, 7, 1);
    this.y_0 = initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, nodeCount, 7, 1);
    this.su = initUnidimensionalArray(Ljava_lang_Boolean_2_classLit, $intern_16, 471, nodeCount, 8, 1);
    fill_1(this.su, ($clinit_Boolean(), false));
    this.od = initUnidimensionalArray(Ljava_lang_Boolean_2_classLit, $intern_16, 471, nodeCount, 8, 1);
    fill_1(this.od, true);
    this.vdir = vdir;
    this.hdir = hdir;
}
defineClass(185, 1, {
    185: 1
}, BKAlignedLayout);
_.toString_0 = function toString_101() {
    var result;
    result = '';
    this.hdir == ($clinit_BKAlignedLayout$HDirection(), RIGHT_3) ? result += 'RIGHT' : this.hdir == LEFT_3 && (result += 'LEFT');
    this.vdir == ($clinit_BKAlignedLayout$VDirection(), DOWN_0) ? result += 'DOWN' : this.vdir == UP_0 ? result += 'UP' : result += 'BALANCED';
    return result;
};
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKAlignedLayout', 185);
function $clinit_BKAlignedLayout$HDirection() {
    $clinit_BKAlignedLayout$HDirection = emptyMethod;
    RIGHT_3 = new BKAlignedLayout$HDirection('RIGHT', 0);
    LEFT_3 = new BKAlignedLayout$HDirection('LEFT', 1);
}
function BKAlignedLayout$HDirection(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_62(name_0) {
    $clinit_BKAlignedLayout$HDirection();
    return valueOf(($clinit_BKAlignedLayout$HDirection$Map(), $MAP_52), name_0);
}
function values_70() {
    $clinit_BKAlignedLayout$HDirection();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout$HDirection_2_classLit, 1), $intern_36, 507, 0, [
        RIGHT_3,
        LEFT_3
    ]);
}
defineClass(507, 23, {
    3: 1,
    34: 1,
    23: 1,
    507: 1
}, BKAlignedLayout$HDirection);
var LEFT_3, RIGHT_3;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout$HDirection_2_classLit = createForEnum('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKAlignedLayout/HDirection', 507, Ljava_lang_Enum_2_classLit, values_70, valueOf_62);
function $clinit_BKAlignedLayout$HDirection$Map() {
    $clinit_BKAlignedLayout$HDirection$Map = emptyMethod;
    $MAP_52 = createValueOfMap(($clinit_BKAlignedLayout$HDirection(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout$HDirection_2_classLit, 1), $intern_36, 507, 0, [
        RIGHT_3,
        LEFT_3
    ])));
}
var $MAP_52;
function $clinit_BKAlignedLayout$VDirection() {
    $clinit_BKAlignedLayout$VDirection = emptyMethod;
    DOWN_0 = new BKAlignedLayout$VDirection('DOWN', 0);
    UP_0 = new BKAlignedLayout$VDirection('UP', 1);
}
function BKAlignedLayout$VDirection(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_63(name_0) {
    $clinit_BKAlignedLayout$VDirection();
    return valueOf(($clinit_BKAlignedLayout$VDirection$Map(), $MAP_53), name_0);
}
function values_71() {
    $clinit_BKAlignedLayout$VDirection();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout$VDirection_2_classLit, 1), $intern_36, 506, 0, [
        DOWN_0,
        UP_0
    ]);
}
defineClass(506, 23, {
    3: 1,
    34: 1,
    23: 1,
    506: 1
}, BKAlignedLayout$VDirection);
var DOWN_0, UP_0;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout$VDirection_2_classLit = createForEnum('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKAlignedLayout/VDirection', 506, Ljava_lang_Enum_2_classLit, values_71, valueOf_63);
function $clinit_BKAlignedLayout$VDirection$Map() {
    $clinit_BKAlignedLayout$VDirection$Map = emptyMethod;
    $MAP_53 = createValueOfMap(($clinit_BKAlignedLayout$VDirection(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAlignedLayout$VDirection_2_classLit, 1), $intern_36, 506, 0, [
        DOWN_0,
        UP_0
    ])));
}
var $MAP_53;
function $insideBlockShift(bal) {
    var blocks, current, edge, entry, next, nextInnerShift, outerIter, portPosDiff, root, root$iterator, spaceAbove, spaceBelow;
    blocks = getBlocks(bal);
    for(root$iterator = (outerIter = new AbstractMap$1(blocks).this$01.entrySet_0().iterator_0(), new AbstractMap$1$1(outerIter)); root$iterator.val$outerIter2.hasNext_0();){
        root = (entry = castTo(root$iterator.val$outerIter2.next_1(), 43), castTo(entry.getKey(), 9));
        spaceAbove = 0;
        spaceBelow = 0;
        spaceAbove = root.margin.top_0;
        spaceBelow = root.size_0.y_0 + root.margin.bottom;
        bal.innerShift[root.id_0] = 0;
        current = root;
        while((next = bal.align_0[current.id_0]) != root){
            edge = getEdge(current, next);
            portPosDiff = 0;
            bal.hdir == ($clinit_BKAlignedLayout$HDirection(), LEFT_3) ? portPosDiff = edge.target.pos.y_0 + edge.target.anchor.y_0 - edge.source.pos.y_0 - edge.source.anchor.y_0 : portPosDiff = edge.source.pos.y_0 + edge.source.anchor.y_0 - edge.target.pos.y_0 - edge.target.anchor.y_0;
            nextInnerShift = $doubleValue(bal.innerShift[current.id_0]) + portPosDiff;
            bal.innerShift[next.id_0] = nextInnerShift;
            spaceAbove = $wnd.Math.max(spaceAbove, next.margin.top_0 - nextInnerShift);
            spaceBelow = $wnd.Math.max(spaceBelow, nextInnerShift + next.size_0.y_0 + next.margin.bottom);
            current = next;
        }
        current = root;
        do {
            bal.innerShift[current.id_0] = $doubleValue(bal.innerShift[current.id_0]) + spaceAbove;
            current = bal.align_0[current.id_0];
        }while (current != root);
        bal.blockSize[root.id_0] = spaceAbove + spaceBelow;
    }
}
function $verticalAlignment(this$static, bal, markedEdges) {
    var d, high, layer, layer$iterator, layer$iterator0, layers, low, m, neighbors, nodes, r, u_m, u_m_pair, um, um_pair, v, v$iterator, v_i_k, v_i_k$iterator;
    for(layer$iterator0 = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        for(v$iterator = new ArrayList$1(layer.nodes); v$iterator.i < v$iterator.this$01.array.length;){
            v = castTo($next_6(v$iterator), 9);
            bal.root[v.id_0] = v;
            bal.align_0[v.id_0] = v;
            bal.innerShift[v.id_0] = 0;
        }
    }
    layers = this$static.layeredGraph.layers;
    bal.hdir == ($clinit_BKAlignedLayout$HDirection(), LEFT_3) && (layers = reverse_0(layers));
    for(layer$iterator = layers.iterator_0(); layer$iterator.hasNext_0();){
        layer = castTo(layer$iterator.next_1(), 25);
        r = -1;
        nodes = layer.nodes;
        if (bal.vdir == ($clinit_BKAlignedLayout$VDirection(), UP_0)) {
            r = $intern_0;
            nodes = reverse_0(nodes);
        }
        for(v_i_k$iterator = nodes.iterator_0(); v_i_k$iterator.hasNext_0();){
            v_i_k = castTo(v_i_k$iterator.next_1(), 9);
            neighbors = null;
            bal.hdir == LEFT_3 ? neighbors = castTo($get_11(this$static.ni.rightNeighbors, v_i_k.id_0), 15) : neighbors = castTo($get_11(this$static.ni.leftNeighbors, v_i_k.id_0), 15);
            if (neighbors.size_1() > 0) {
                d = neighbors.size_1();
                low = round_int($wnd.Math.floor((d + 1) / 2)) - 1;
                high = round_int($wnd.Math.ceil((d + 1) / 2)) - 1;
                if (bal.vdir == UP_0) {
                    for(m = high; m >= low; m--)if (bal.align_0[v_i_k.id_0] == v_i_k) {
                        u_m_pair = castTo(neighbors.get_0(m), 47);
                        u_m = castTo(u_m_pair.first, 9);
                        if (!$contains_6(markedEdges, u_m_pair.second) && r > this$static.ni.nodeIndex[u_m.id_0]) {
                            bal.align_0[u_m.id_0] = v_i_k;
                            bal.root[v_i_k.id_0] = bal.root[u_m.id_0];
                            bal.align_0[v_i_k.id_0] = bal.root[v_i_k.id_0];
                            bal.od[bal.root[v_i_k.id_0].id_0] = ($clinit_Boolean(), $booleanValue(bal.od[bal.root[v_i_k.id_0].id_0]) & v_i_k.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) ? true : false);
                            r = this$static.ni.nodeIndex[u_m.id_0];
                        }
                    }
                } else {
                    for(m = low; m <= high; m++)if (bal.align_0[v_i_k.id_0] == v_i_k) {
                        um_pair = castTo(neighbors.get_0(m), 47);
                        um = castTo(um_pair.first, 9);
                        if (!$contains_6(markedEdges, um_pair.second) && r < this$static.ni.nodeIndex[um.id_0]) {
                            bal.align_0[um.id_0] = v_i_k;
                            bal.root[v_i_k.id_0] = bal.root[um.id_0];
                            bal.align_0[v_i_k.id_0] = bal.root[v_i_k.id_0];
                            bal.od[bal.root[v_i_k.id_0].id_0] = ($clinit_Boolean(), $booleanValue(bal.od[bal.root[v_i_k.id_0].id_0]) & v_i_k.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE) ? true : false);
                            r = this$static.ni.nodeIndex[um.id_0];
                        }
                    }
                }
            }
        }
    }
}
function BKAligner(layeredGraph, ni) {
    this.layeredGraph = layeredGraph;
    this.ni = ni;
}
defineClass(1640, 1, {}, BKAligner);
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKAligner_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKAligner', 1640);
function $getOrCreateClassNode(this$static, sinkNode) {
    var node;
    node = castTo($get_10(this$static.sinkNodes, sinkNode), 453);
    if (!node) {
        node = new BKCompactor$ClassNode;
        node.node = sinkNode;
        $put_6(this$static.sinkNodes, node.node, node);
    }
    return node;
}
function $horizontalCompaction(this$static, bal) {
    var layer, layer$iterator, layer$iterator0, layer$iterator1, layers, node, node$iterator, nodes, sinkShift, v, v$iterator;
    for(layer$iterator0 = new ArrayList$1(this$static.layeredGraph.layers); layer$iterator0.i < layer$iterator0.this$01.array.length;){
        layer = castTo($next_6(layer$iterator0), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            bal.sink[node.id_0] = node;
            bal.shift_0[node.id_0] = bal.vdir == ($clinit_BKAlignedLayout$VDirection(), UP_0) ? $intern_61 : $intern_60;
        }
    }
    $reset(this$static.sinkNodes);
    layers = this$static.layeredGraph.layers;
    bal.hdir == ($clinit_BKAlignedLayout$HDirection(), LEFT_3) && (layers = reverse_0(layers));
    $init_0(this$static.threshStrategy, bal, this$static.ni);
    fill_1(bal.y_0, null);
    for(layer$iterator1 = layers.iterator_0(); layer$iterator1.hasNext_0();){
        layer = castTo(layer$iterator1.next_1(), 25);
        nodes = layer.nodes;
        bal.vdir == ($clinit_BKAlignedLayout$VDirection(), UP_0) && (nodes = reverse_0(nodes));
        for(v$iterator = nodes.iterator_0(); v$iterator.hasNext_0();){
            v = castTo(v$iterator.next_1(), 9);
            bal.root[v.id_0] == v && $placeBlock(this$static, v, bal);
        }
    }
    $placeClasses(this$static, bal);
    for(layer$iterator = layers.iterator_0(); layer$iterator.hasNext_0();){
        layer = castTo(layer$iterator.next_1(), 25);
        for(v$iterator = new ArrayList$1(layer.nodes); v$iterator.i < v$iterator.this$01.array.length;){
            v = castTo($next_6(v$iterator), 9);
            bal.y_0[v.id_0] = bal.y_0[bal.root[v.id_0].id_0];
            if (v == bal.root[v.id_0]) {
                sinkShift = $doubleValue(bal.shift_0[bal.sink[v.id_0].id_0]);
                (bal.vdir == ($clinit_BKAlignedLayout$VDirection(), UP_0) && sinkShift > $intern_61 || bal.vdir == DOWN_0 && sinkShift < $intern_60) && (bal.y_0[v.id_0] = $doubleValue(bal.y_0[v.id_0]) + sinkShift);
            }
        }
    }
    this$static.threshStrategy.postProcess();
}
function $placeBlock(this$static, root, bal) {
    var currentBlockPosition, currentIndexInLayer, currentLayerSize, currentNode, isInitialAssignment, neighbor, neighborRoot, neighborSink, newPosition, requiredSpace, sinkNode, spacing, thresh;
    if (bal.y_0[root.id_0] != null) return;
    isInitialAssignment = true;
    bal.y_0[root.id_0] = 0;
    currentNode = root;
    thresh = bal.vdir == ($clinit_BKAlignedLayout$VDirection(), DOWN_0) ? $intern_61 : $intern_60;
    do {
        currentIndexInLayer = this$static.ni.nodeIndex[currentNode.id_0];
        currentLayerSize = currentNode.layer.nodes.array.length;
        if (bal.vdir == DOWN_0 && currentIndexInLayer > 0 || bal.vdir == UP_0 && currentIndexInLayer < currentLayerSize - 1) {
            neighbor = null;
            neighborRoot = null;
            bal.vdir == UP_0 ? neighbor = castTo($get_11(currentNode.layer.nodes, currentIndexInLayer + 1), 9) : neighbor = castTo($get_11(currentNode.layer.nodes, currentIndexInLayer - 1), 9);
            neighborRoot = bal.root[neighbor.id_0];
            $placeBlock(this$static, neighborRoot, bal);
            thresh = this$static.threshStrategy.calculateThreshold(thresh, root, currentNode);
            bal.sink[root.id_0] == root && (bal.sink[root.id_0] = bal.sink[neighborRoot.id_0]);
            if (bal.sink[root.id_0] == bal.sink[neighborRoot.id_0]) {
                spacing = $getVerticalSpacing_0(this$static.spacings, currentNode, neighbor);
                if (bal.vdir == UP_0) {
                    currentBlockPosition = $doubleValue(bal.y_0[root.id_0]);
                    newPosition = $doubleValue(bal.y_0[neighborRoot.id_0]) + $doubleValue(bal.innerShift[neighbor.id_0]) - neighbor.margin.top_0 - spacing - currentNode.margin.bottom - currentNode.size_0.y_0 - $doubleValue(bal.innerShift[currentNode.id_0]);
                    if (isInitialAssignment) {
                        isInitialAssignment = false;
                        bal.y_0[root.id_0] = $wnd.Math.min(newPosition, thresh);
                    } else bal.y_0[root.id_0] = $wnd.Math.min(currentBlockPosition, $wnd.Math.min(newPosition, thresh));
                } else {
                    currentBlockPosition = $doubleValue(bal.y_0[root.id_0]);
                    newPosition = $doubleValue(bal.y_0[neighborRoot.id_0]) + $doubleValue(bal.innerShift[neighbor.id_0]) + neighbor.size_0.y_0 + neighbor.margin.bottom + spacing + currentNode.margin.top_0 - $doubleValue(bal.innerShift[currentNode.id_0]);
                    if (isInitialAssignment) {
                        isInitialAssignment = false;
                        bal.y_0[root.id_0] = $wnd.Math.max(newPosition, thresh);
                    } else bal.y_0[root.id_0] = $wnd.Math.max(currentBlockPosition, $wnd.Math.max(newPosition, thresh));
                }
            } else {
                spacing = $doubleValue(castToDouble($getProperty(this$static.layeredGraph, ($clinit_LayeredOptions(), SPACING_NODE_NODE_0))));
                sinkNode = $getOrCreateClassNode(this$static, bal.sink[root.id_0]);
                neighborSink = $getOrCreateClassNode(this$static, bal.sink[neighborRoot.id_0]);
                if (bal.vdir == UP_0) {
                    requiredSpace = $doubleValue(bal.y_0[root.id_0]) + $doubleValue(bal.innerShift[currentNode.id_0]) + currentNode.size_0.y_0 + currentNode.margin.bottom + spacing - ($doubleValue(bal.y_0[neighborRoot.id_0]) + $doubleValue(bal.innerShift[neighbor.id_0]) - neighbor.margin.top_0);
                    $addEdge(sinkNode, neighborSink, requiredSpace);
                } else {
                    requiredSpace = $doubleValue(bal.y_0[root.id_0]) + $doubleValue(bal.innerShift[currentNode.id_0]) - currentNode.margin.top_0 - $doubleValue(bal.y_0[neighborRoot.id_0]) - $doubleValue(bal.innerShift[neighbor.id_0]) - neighbor.size_0.y_0 - neighbor.margin.bottom - spacing;
                    $addEdge(sinkNode, neighborSink, requiredSpace);
                }
            }
        } else thresh = this$static.threshStrategy.calculateThreshold(thresh, root, currentNode);
        currentNode = bal.align_0[currentNode.id_0];
    }while (currentNode != root);
    $finishBlock(this$static.threshStrategy, root);
}
function $placeClasses(this$static, bal) {
    var e, e$iterator, entry, n, n$iterator, n$iterator0, outerIter, outerIter0, sinks;
    sinks = new LinkedList;
    for(n$iterator0 = (outerIter0 = new AbstractMap$2(this$static.sinkNodes).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter0)); n$iterator0.val$outerIter2.hasNext_0();){
        n = (entry = castTo(n$iterator0.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 453));
        n.indegree == 0 && $addNode_0(sinks, n, sinks.tail.prev, sinks.tail);
    }
    while(sinks.size_0 != 0){
        n = castTo(sinks.size_0 == 0 ? null : (checkCriticalElement(sinks.size_0 != 0), $removeNode_0(sinks, sinks.header.next_0)), 453);
        n.classShift == null && (n.classShift = 0);
        for(e$iterator = new ArrayList$1(n.outgoing); e$iterator.i < e$iterator.this$01.array.length;){
            e = castTo($next_6(e$iterator), 647);
            e.target.classShift == null ? e.target.classShift = $doubleValue(n.classShift) + e.separation : bal.vdir == ($clinit_BKAlignedLayout$VDirection(), DOWN_0) ? e.target.classShift = $wnd.Math.min($doubleValue(e.target.classShift), $doubleValue(n.classShift) + e.separation) : e.target.classShift = $wnd.Math.max($doubleValue(e.target.classShift), $doubleValue(n.classShift) + e.separation);
            --e.target.indegree;
            e.target.indegree == 0 && $add_7(sinks, e.target);
        }
    }
    for(n$iterator = (outerIter = new AbstractMap$2(this$static.sinkNodes).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter)); n$iterator.val$outerIter2.hasNext_0();){
        n = (entry = castTo(n$iterator.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 453));
        bal.shift_0[n.node.id_0] = n.classShift;
    }
}
function BKCompactor(layeredGraph, ni) {
    this.sinkNodes = new HashMap;
    this.layeredGraph = layeredGraph;
    this.ni = ni;
    this.spacings = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), SPACINGS)), 313);
    maskUndefined($getProperty(layeredGraph, ($clinit_LayeredOptions(), NODE_PLACEMENT_BK_EDGE_STRAIGHTENING_0))) === maskUndefined(($clinit_EdgeStraighteningStrategy(), IMPROVE_STRAIGHTNESS)) ? this.threshStrategy = new ThresholdStrategy$SimpleThresholdStrategy : this.threshStrategy = new ThresholdStrategy$NullThresholdStrategy;
}
defineClass(1643, 1, {}, BKCompactor);
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKCompactor_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKCompactor', 1643);
function BKCompactor$ClassEdge() {}
defineClass(647, 1, {
    647: 1
}, BKCompactor$ClassEdge);
_.separation = 0;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKCompactor$ClassEdge_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKCompactor/ClassEdge', 647);
function $addEdge(this$static, target, separation) {
    var se;
    se = new BKCompactor$ClassEdge;
    se.target = target;
    se.separation = separation;
    ++target.indegree;
    $add_3(this$static.outgoing, se);
}
function BKCompactor$ClassNode() {
    this.outgoing = new ArrayList;
}
defineClass(453, 1, {
    453: 1
}, BKCompactor$ClassNode);
_.classShift = null;
_.indegree = 0;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKCompactor$ClassNode_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKCompactor/ClassNode', 453);
function $clinit_BKNodePlacer() {
    $clinit_BKNodePlacer = emptyMethod;
    HIERARCHY_PROCESSING_ADDITIONS_3 = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), HIERARCHICAL_PORT_POSITION_PROCESSOR));
}
function $checkOrderConstraint(layeredGraph, bal, monitor) {
    var bottom, feasible, layer, layer$iterator, node, node$iterator, pos, previous, top_0;
    feasible = true;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        pos = $intern_61;
        previous = null;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            top_0 = $doubleValue(bal.y_0[node.id_0]) + $doubleValue(bal.innerShift[node.id_0]) - node.margin.top_0;
            bottom = $doubleValue(bal.y_0[node.id_0]) + $doubleValue(bal.innerShift[node.id_0]) + node.size_0.y_0 + node.margin.bottom;
            if (top_0 > pos && bottom > pos) {
                previous = node;
                pos = $doubleValue(bal.y_0[node.id_0]) + $doubleValue(bal.innerShift[node.id_0]) + node.size_0.y_0 + node.margin.bottom;
            } else {
                feasible = false;
                monitor.isLoggingEnabled() && monitor.log_0('bk node placement breaks on ' + node + ' which should have been after ' + previous);
                break;
            }
        }
        if (!feasible) break;
    }
    monitor.isLoggingEnabled() && monitor.log_0(bal + ' is feasible: ' + feasible);
    return feasible;
}
function $createBalancedLayout(this$static, layouts, nodeCount) {
    var bal, balanced, calculatedYs, i, i0, i1, i2, l, l$iterator, layer, layer$iterator, max_0, min_0, minWidthLayout, n, n$iterator, noOfLayouts, node, node$iterator, nodePosY, shift_0, width_0;
    noOfLayouts = layouts.array.length;
    balanced = new BKAlignedLayout(this$static.lGraph, nodeCount, null, null);
    width_0 = initUnidimensionalArray(D_classLit, $intern_66, 30, noOfLayouts, 15, 1);
    min_0 = initUnidimensionalArray(D_classLit, $intern_66, 30, noOfLayouts, 15, 1);
    max_0 = initUnidimensionalArray(D_classLit, $intern_66, 30, noOfLayouts, 15, 1);
    minWidthLayout = 0;
    for(i0 = 0; i0 < noOfLayouts; i0++){
        min_0[i0] = $intern_0;
        max_0[i0] = $intern_42;
    }
    for(i1 = 0; i1 < noOfLayouts; i1++){
        bal = (checkCriticalElementIndex(i1, layouts.array.length), castTo(layouts.array[i1], 185));
        width_0[i1] = $layoutSize(bal);
        width_0[minWidthLayout] > width_0[i1] && (minWidthLayout = i1);
        for(l$iterator = new ArrayList$1(this$static.lGraph.layers); l$iterator.i < l$iterator.this$01.array.length;){
            l = castTo($next_6(l$iterator), 25);
            for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
                n = castTo($next_6(n$iterator), 9);
                nodePosY = $doubleValue(bal.y_0[n.id_0]) + $doubleValue(bal.innerShift[n.id_0]);
                min_0[i1] = $wnd.Math.min(min_0[i1], nodePosY);
                max_0[i1] = $wnd.Math.max(max_0[i1], nodePosY + n.size_0.y_0);
            }
        }
    }
    shift_0 = initUnidimensionalArray(D_classLit, $intern_66, 30, noOfLayouts, 15, 1);
    for(i2 = 0; i2 < noOfLayouts; i2++)(checkCriticalElementIndex(i2, layouts.array.length), castTo(layouts.array[i2], 185)).vdir == ($clinit_BKAlignedLayout$VDirection(), DOWN_0) ? shift_0[i2] = min_0[minWidthLayout] - min_0[i2] : shift_0[i2] = max_0[minWidthLayout] - max_0[i2];
    calculatedYs = initUnidimensionalArray(D_classLit, $intern_66, 30, noOfLayouts, 15, 1);
    for(layer$iterator = new ArrayList$1(this$static.lGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            for(i = 0; i < noOfLayouts; i++)calculatedYs[i] = $doubleValue((checkCriticalElementIndex(i, layouts.array.length), castTo(layouts.array[i], 185)).y_0[node.id_0]) + $doubleValue((checkCriticalElementIndex(i, layouts.array.length), castTo(layouts.array[i], 185)).innerShift[node.id_0]) + shift_0[i];
            sort_9(calculatedYs, makeLambdaFunction(Arrays$0methodref$compare$Type.prototype.compare_0, Arrays$0methodref$compare$Type, []));
            balanced.y_0[node.id_0] = (calculatedYs[1] + calculatedYs[2]) / 2;
            balanced.innerShift[node.id_0] = 0;
        }
    }
    return balanced;
}
function $incidentToInnerSegment(this$static, node, layer1, layer2) {
    var edge, edge$iterator, sourceNodeType;
    if (node.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        sourceNodeType = edge.source.owner.type_0;
        if (sourceNodeType == LONG_EDGE && this$static.ni.layerIndex[edge.source.owner.layer.id_0] == layer2 && this$static.ni.layerIndex[node.layer.id_0] == layer1) return true;
    }
    return false;
}
function $markConflicts(this$static, layeredGraph) {
    var currentLayer, i, k, k_0, k_1, l, l_1, layer, layer$iterator, layerIndex, layerIterator, layerSize, nodeIterator, numberOfLayers, upperNeighbor, upperNeighbor$iterator, v_l, v_l_i;
    numberOfLayers = layeredGraph.layers.array.length;
    if (numberOfLayers < 3) return;
    layerSize = initUnidimensionalArray(I_classLit, $intern_48, 30, numberOfLayers, 15, 1);
    layerIndex = 0;
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        layerSize[layerIndex++] = layer.nodes.array.length;
    }
    layerIterator = new AbstractList$ListIteratorImpl(layeredGraph.layers, 2);
    for(i = 1; i < numberOfLayers - 1; i++){
        currentLayer = (checkCriticalElement(layerIterator.i < layerIterator.this$01_0.size_1()), castTo(layerIterator.this$01_0.get_0(layerIterator.last = layerIterator.i++), 25));
        nodeIterator = new ArrayList$1(currentLayer.nodes);
        k_0 = 0;
        l = 0;
        for(l_1 = 0; l_1 < layerSize[i + 1]; l_1++){
            v_l_i = castTo($next_6(nodeIterator), 9);
            if (l_1 == layerSize[i + 1] - 1 || $incidentToInnerSegment(this$static, v_l_i, i + 1, i)) {
                k_1 = layerSize[i] - 1;
                $incidentToInnerSegment(this$static, v_l_i, i + 1, i) && (k_1 = this$static.ni.nodeIndex[castTo(castTo(castTo($get_11(this$static.ni.leftNeighbors, v_l_i.id_0), 15).get_0(0), 47).first, 9).id_0]);
                while(l <= l_1){
                    v_l = castTo($get_11(currentLayer.nodes, l), 9);
                    if (!$incidentToInnerSegment(this$static, v_l, i + 1, i)) for(upperNeighbor$iterator = castTo($get_11(this$static.ni.leftNeighbors, v_l.id_0), 15).iterator_0(); upperNeighbor$iterator.hasNext_0();){
                        upperNeighbor = castTo(upperNeighbor$iterator.next_1(), 47);
                        k = this$static.ni.nodeIndex[castTo(upperNeighbor.first, 9).id_0];
                        (k < k_0 || k > k_1) && $add_6(this$static.markedEdges, castTo(upperNeighbor.second, 18));
                    }
                    ++l;
                }
                k_0 = k_1;
            }
        }
    }
}
function $process_78(this$static, layeredGraph, monitor) {
    var align_0, aligner, bal, bal$iterator, bal$iterator0, bal$iterator1, bal$iterator2, balanced, chosenLayout, compacter, favorStraightEdges, layer, layer$iterator, layouts, leftdown, leftup, node, node$iterator, rightdown, rightup;
    monitor.begin('Brandes & Koepf node placement', 1);
    this$static.lGraph = layeredGraph;
    this$static.ni = buildFor(layeredGraph);
    align_0 = castTo($getProperty(layeredGraph, ($clinit_LayeredOptions(), NODE_PLACEMENT_BK_FIXED_ALIGNMENT_0)), 279);
    favorStraightEdges = $booleanValue(castToBoolean($getProperty(layeredGraph, NODE_PLACEMENT_FAVOR_STRAIGHT_EDGES_0)));
    this$static.produceBalancedLayout = align_0 == ($clinit_FixedAlignment(), NONE_4) && !favorStraightEdges || align_0 == BALANCED;
    $markConflicts(this$static, layeredGraph);
    rightdown = null;
    rightup = null;
    leftdown = null;
    leftup = null;
    layouts = (checkNonnegative(4, 'initialArraySize'), new ArrayList_0(4));
    switch(castTo($getProperty(layeredGraph, NODE_PLACEMENT_BK_FIXED_ALIGNMENT_0), 279).ordinal){
        case 3:
            leftdown = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, ($clinit_BKAlignedLayout$VDirection(), DOWN_0), ($clinit_BKAlignedLayout$HDirection(), LEFT_3));
            push_1(layouts.array, leftdown);
            break;
        case 1:
            leftup = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, ($clinit_BKAlignedLayout$VDirection(), UP_0), ($clinit_BKAlignedLayout$HDirection(), LEFT_3));
            push_1(layouts.array, leftup);
            break;
        case 4:
            rightdown = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, ($clinit_BKAlignedLayout$VDirection(), DOWN_0), ($clinit_BKAlignedLayout$HDirection(), RIGHT_3));
            push_1(layouts.array, rightdown);
            break;
        case 2:
            rightup = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, ($clinit_BKAlignedLayout$VDirection(), UP_0), ($clinit_BKAlignedLayout$HDirection(), RIGHT_3));
            push_1(layouts.array, rightup);
            break;
        default:
            leftdown = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, ($clinit_BKAlignedLayout$VDirection(), DOWN_0), ($clinit_BKAlignedLayout$HDirection(), LEFT_3));
            leftup = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, UP_0, LEFT_3);
            rightdown = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, DOWN_0, RIGHT_3);
            rightup = new BKAlignedLayout(layeredGraph, this$static.ni.nodeCount, UP_0, RIGHT_3);
            push_1(layouts.array, rightdown);
            push_1(layouts.array, rightup);
            push_1(layouts.array, leftdown);
            push_1(layouts.array, leftup);
    }
    aligner = new BKAligner(layeredGraph, this$static.ni);
    for(bal$iterator0 = new ArrayList$1(layouts); bal$iterator0.i < bal$iterator0.this$01.array.length;){
        bal = castTo($next_6(bal$iterator0), 185);
        $verticalAlignment(aligner, bal, this$static.markedEdges);
        $insideBlockShift(bal);
    }
    compacter = new BKCompactor(layeredGraph, this$static.ni);
    for(bal$iterator1 = new ArrayList$1(layouts); bal$iterator1.i < bal$iterator1.this$01.array.length;){
        bal = castTo($next_6(bal$iterator1), 185);
        $horizontalCompaction(compacter, bal);
    }
    if (monitor.isLoggingEnabled()) for(bal$iterator2 = new ArrayList$1(layouts); bal$iterator2.i < bal$iterator2.this$01.array.length;){
        bal = castTo($next_6(bal$iterator2), 185);
        monitor.log_0(bal + ' size is ' + $layoutSize(bal));
    }
    chosenLayout = null;
    if (this$static.produceBalancedLayout) {
        balanced = $createBalancedLayout(this$static, layouts, this$static.ni.nodeCount);
        $checkOrderConstraint(layeredGraph, balanced, monitor) && (chosenLayout = balanced);
    }
    if (!chosenLayout) for(bal$iterator2 = new ArrayList$1(layouts); bal$iterator2.i < bal$iterator2.this$01.array.length;){
        bal = castTo($next_6(bal$iterator2), 185);
        $checkOrderConstraint(layeredGraph, bal, monitor) && (!chosenLayout || $layoutSize(chosenLayout) > $layoutSize(bal)) && (chosenLayout = bal);
    }
    !chosenLayout && (chosenLayout = (checkCriticalElementIndex(0, layouts.array.length), castTo(layouts.array[0], 185)));
    for(layer$iterator = new ArrayList$1(layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            node.pos.y_0 = $doubleValue(chosenLayout.y_0[node.id_0]) + $doubleValue(chosenLayout.innerShift[node.id_0]);
        }
    }
    if (monitor.isLoggingEnabled()) {
        monitor.log_0('Chosen node placement: ' + chosenLayout);
        monitor.log_0('Blocks: ' + getBlocks(chosenLayout));
        monitor.log_0('Classes: ' + getClasses(chosenLayout, monitor));
        monitor.log_0('Marked edges: ' + this$static.markedEdges);
    }
    for(bal$iterator = new ArrayList$1(layouts); bal$iterator.i < bal$iterator.this$01.array.length;){
        bal = castTo($next_6(bal$iterator), 185);
        bal.root = null;
        bal.blockSize = null;
        bal.align_0 = null;
        bal.innerShift = null;
        bal.sink = null;
        bal.shift_0 = null;
        bal.y_0 = null;
    }
    $cleanup(this$static.ni);
    this$static.markedEdges.map_0.clear_0();
    monitor.done_1();
}
function BKNodePlacer() {
    $clinit_BKNodePlacer();
    this.markedEdges = new HashSet;
}
function getBlocks(bal) {
    $clinit_BKNodePlacer();
    var blockContents, blocks, layer, layer$iterator, node, node$iterator, root;
    blocks = new LinkedHashMap;
    for(layer$iterator = new ArrayList$1(bal.layeredGraph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            root = bal.root[node.id_0];
            blockContents = castTo($get_16(blocks, root), 15);
            if (!blockContents) {
                blockContents = new ArrayList;
                $put_11(blocks, root, blockContents);
            }
            blockContents.add_2(node);
        }
    }
    return blocks;
}
function getClasses(bal, monitor) {
    var classContents, classes, root, root$iterator, roots, sink;
    classes = new LinkedHashMap;
    roots = newLinkedHashSet(new Arrays$ArrayList(bal.root));
    for(root$iterator = roots.map_0.keySet_0().iterator_0(); root$iterator.hasNext_0();){
        root = castTo(root$iterator.next_1(), 9);
        if (!root) {
            monitor.log_0('There are no classes in a balanced layout.');
            break;
        }
        sink = bal.sink[root.id_0];
        classContents = castTo($get_16(classes, sink), 15);
        if (!classContents) {
            classContents = new ArrayList;
            $put_11(classes, sink, classContents);
        }
        classContents.add_2(root);
    }
    return classes;
}
function getEdge(source, target) {
    $clinit_BKNodePlacer();
    var edge, edge$iterator;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(source).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 18);
        if (edge.target.owner == target || edge.source.owner == target) return edge;
    }
    return null;
}
defineClass(1366, 1, $intern_110, BKNodePlacer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_19(graph) {
    return castTo($getProperty(castTo(graph, 36), ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22).contains(($clinit_GraphProperties(), EXTERNAL_PORTS)) ? HIERARCHY_PROCESSING_ADDITIONS_3 : null;
};
_.process = function process_75(layeredGraph, monitor) {
    $process_78(this, castTo(layeredGraph, 36), monitor);
};
_.produceBalancedLayout = false;
var HIERARCHY_PROCESSING_ADDITIONS_3;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_BKNodePlacer_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'BKNodePlacer', 1366);
function $cleanup(this$static) {
    this$static.layerIndex = null;
    this$static.nodeIndex = null;
    setLength(this$static.leftNeighbors.array, 0);
    setLength(this$static.rightNeighbors.array, 0);
    this$static.neighborComparator = null;
}
function NeighborhoodInformation() {}
function buildFor(graph) {
    var l, l$iterator, lId, lIndex, layer, layer$iterator, n, n$iterator, nId, nIndex, ni;
    ni = new NeighborhoodInformation;
    ni.nodeCount = 0;
    for(layer$iterator = new ArrayList$1(graph.layers); layer$iterator.i < layer$iterator.this$01.array.length;){
        layer = castTo($next_6(layer$iterator), 25);
        ni.nodeCount += layer.nodes.array.length;
    }
    lId = 0;
    lIndex = 0;
    ni.layerIndex = initUnidimensionalArray(I_classLit, $intern_48, 30, graph.layers.array.length, 15, 1);
    nId = 0;
    nIndex = 0;
    ni.nodeIndex = initUnidimensionalArray(I_classLit, $intern_48, 30, ni.nodeCount, 15, 1);
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        l.id_0 = lId++;
        ni.layerIndex[l.id_0] = lIndex++;
        nIndex = 0;
        for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            n.id_0 = nId++;
            ni.nodeIndex[n.id_0] = nIndex++;
        }
    }
    ni.neighborComparator = new NeighborhoodInformation$NeighborComparator(ni);
    ni.leftNeighbors = newArrayListWithCapacity(ni.nodeCount);
    determineAllLeftNeighbors(ni, graph);
    ni.rightNeighbors = newArrayListWithCapacity(ni.nodeCount);
    determineAllRightNeighbors(ni, graph);
    return ni;
}
function determineAllLeftNeighbors(ni, graph) {
    var edge, edge$iterator, edgePrio, l, l$iterator, maxPriority, n, n$iterator, result;
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            result = new ArrayList;
            maxPriority = 0;
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                if ($isSelfLoop(edge) || !$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer) continue;
                edgePrio = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0;
                if (edgePrio > maxPriority) {
                    maxPriority = edgePrio;
                    result.array.length = 0;
                }
                edgePrio == maxPriority && $add_3(result, new Pair(edge.source.owner, edge));
            }
            $clinit_Collections();
            $sort(result, ni.neighborComparator);
            $add_2(ni.leftNeighbors, n.id_0, result);
        }
    }
}
function determineAllRightNeighbors(ni, graph) {
    var edge, edge$iterator, edgePrio, l, l$iterator, maxPriority, n, n$iterator, result;
    for(l$iterator = new ArrayList$1(graph.layers); l$iterator.i < l$iterator.this$01.array.length;){
        l = castTo($next_6(l$iterator), 25);
        for(n$iterator = new ArrayList$1(l.nodes); n$iterator.i < n$iterator.this$01.array.length;){
            n = castTo($next_6(n$iterator), 9);
            result = new ArrayList;
            maxPriority = 0;
            for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(n).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
                edge = castTo($next_0(edge$iterator), 18);
                if ($isSelfLoop(edge) || !$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer) continue;
                edgePrio = castTo($getProperty(edge, ($clinit_LayeredOptions(), PRIORITY_STRAIGHTNESS_0)), 17).value_0;
                if (edgePrio > maxPriority) {
                    maxPriority = edgePrio;
                    result.array.length = 0;
                }
                edgePrio == maxPriority && $add_3(result, new Pair(edge.target.owner, edge));
            }
            $clinit_Collections();
            $sort(result, ni.neighborComparator);
            $add_2(ni.rightNeighbors, n.id_0, result);
        }
    }
}
defineClass(1641, 1, {}, NeighborhoodInformation);
_.nodeCount = 0;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_NeighborhoodInformation_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'NeighborhoodInformation', 1641);
function $compare_18(this$static, o1, o2) {
    var cmp;
    cmp = this$static.this$01.nodeIndex[castTo(o1.first, 9).id_0] - this$static.this$01.nodeIndex[castTo(o2.first, 9).id_0];
    return round_int(signum(cmp));
}
function NeighborhoodInformation$NeighborComparator(this$0) {
    this.this$01 = this$0;
}
defineClass(1642, 1, $intern_88, NeighborhoodInformation$NeighborComparator);
_.compare_1 = function compare_73(o1, o2) {
    return $compare_18(this, castTo(o1, 47), castTo(o2, 47));
};
_.equals_0 = function equals_158(other) {
    return this === other;
};
_.reversed = function reversed_65() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_NeighborhoodInformation$NeighborComparator_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'NeighborhoodInformation/NeighborComparator', 1642);
function $finishBlock(this$static, n) {
    $add_6(this$static.blockFinished, n);
}
function $getOther_3(edge, n) {
    if (edge.source.owner == n) return edge.target.owner;
    else if (edge.target.owner == n) return edge.source.owner;
    else throw toJs(new IllegalArgumentException_0('Node ' + n + ' is neither source nor target of edge ' + edge));
}
function $init_0(this$static, theBal, theNi) {
    this$static.bal = theBal;
    this$static.ni = theNi;
    this$static.blockFinished.map_0.clear_0();
    $reset_0(this$static.postProcessablesQueue);
    setLength(this$static.postProcessablesStack.arrayList.array, 0);
}
function ThresholdStrategy() {
    this.blockFinished = new HashSet;
    this.postProcessablesQueue = new LinkedList;
    this.postProcessablesStack = new Stack;
}
defineClass(802, 1, {});
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_ThresholdStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'ThresholdStrategy', 802);
function ThresholdStrategy$NullThresholdStrategy() {
    ThresholdStrategy.call(this);
}
defineClass(1771, 802, {}, ThresholdStrategy$NullThresholdStrategy);
_.calculateThreshold = function calculateThreshold(oldThresh, blockRoot, currentNode) {
    return this.bal.vdir == ($clinit_BKAlignedLayout$VDirection(), UP_0) ? $intern_60 : $intern_61;
};
_.postProcess = function postProcess() {};
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_ThresholdStrategy$NullThresholdStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'ThresholdStrategy/NullThresholdStrategy', 1771);
function ThresholdStrategy$Postprocessable(free, isRoot) {
    this.free = free;
    this.isRoot = isRoot;
}
defineClass(570, 1, {
    570: 1
}, ThresholdStrategy$Postprocessable);
_.hasEdges = false;
_.isRoot = false;
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_ThresholdStrategy$Postprocessable_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'ThresholdStrategy/Postprocessable', 570);
function $getBound(this$static, blockNode, isRoot) {
    var invalid, left, otherPort, otherRoot, pick, right, rootPort, threshold;
    invalid = this$static.bal.vdir == ($clinit_BKAlignedLayout$VDirection(), UP_0) ? $intern_60 : $intern_61;
    pick = $pickEdge(this$static, new ThresholdStrategy$Postprocessable(blockNode, isRoot));
    if (!pick.edge && pick.hasEdges) {
        $add_7(this$static.postProcessablesQueue, pick);
        return invalid;
    } else if (pick.edge) {
        left = pick.edge.source;
        right = pick.edge.target;
        if (isRoot) {
            rootPort = this$static.bal.hdir == ($clinit_BKAlignedLayout$HDirection(), RIGHT_3) ? right : left;
            otherPort = this$static.bal.hdir == RIGHT_3 ? left : right;
            otherRoot = this$static.bal.root[otherPort.owner.id_0];
            threshold = $doubleValue(this$static.bal.y_0[otherRoot.id_0]) + $doubleValue(this$static.bal.innerShift[otherPort.owner.id_0]) + otherPort.pos.y_0 + otherPort.anchor.y_0 - $doubleValue(this$static.bal.innerShift[rootPort.owner.id_0]) - rootPort.pos.y_0 - rootPort.anchor.y_0;
        } else {
            rootPort = this$static.bal.hdir == ($clinit_BKAlignedLayout$HDirection(), LEFT_3) ? right : left;
            otherPort = this$static.bal.hdir == LEFT_3 ? left : right;
            threshold = $doubleValue(this$static.bal.y_0[this$static.bal.root[otherPort.owner.id_0].id_0]) + $doubleValue(this$static.bal.innerShift[otherPort.owner.id_0]) + otherPort.pos.y_0 + otherPort.anchor.y_0 - $doubleValue(this$static.bal.innerShift[rootPort.owner.id_0]) - rootPort.pos.y_0 - rootPort.anchor.y_0;
        }
        this$static.bal.su[this$static.bal.root[left.owner.id_0].id_0] = ($clinit_Boolean(), true);
        this$static.bal.su[this$static.bal.root[right.owner.id_0].id_0] = true;
        return threshold;
    }
    return invalid;
}
function $pickEdge(this$static, pp) {
    var e, e$iterator, edges, hasEdges, onlyDummies;
    pp.isRoot ? edges = this$static.bal.hdir == ($clinit_BKAlignedLayout$HDirection(), RIGHT_3) ? $getIncomingEdges(pp.free) : $getOutgoingEdges(pp.free) : edges = this$static.bal.hdir == ($clinit_BKAlignedLayout$HDirection(), LEFT_3) ? $getIncomingEdges(pp.free) : $getOutgoingEdges(pp.free);
    hasEdges = false;
    for(e$iterator = new Iterators$ConcatenatedIterator(transform_2(edges.val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        onlyDummies = $booleanValue(this$static.bal.od[this$static.bal.root[pp.free.id_0].id_0]);
        if (!onlyDummies && !$isSelfLoop(e) && e.source.owner.layer == e.target.owner.layer) continue;
        if ($booleanValue(this$static.bal.su[this$static.bal.root[pp.free.id_0].id_0]) || $booleanValue(this$static.bal.su[this$static.bal.root[pp.free.id_0].id_0])) continue;
        hasEdges = true;
        if ($contains_6(this$static.blockFinished, this$static.bal.root[$getOther_3(e, pp.free).id_0])) {
            pp.hasEdges = true;
            pp.edge = e;
            return pp;
        }
    }
    pp.hasEdges = hasEdges;
    pp.edge = null;
    return pp;
}
function $process_79(this$static, pp) {
    var availableSpace, block, delta, edge, fix;
    edge = pp.edge;
    edge.source.owner == pp.free ? fix = edge.target : fix = edge.source;
    edge.source.owner == pp.free ? block = edge.source : block = edge.target;
    delta = $calculateDelta(this$static.bal, fix, block);
    if (delta > 0 && delta < $intern_113) {
        availableSpace = $checkSpaceAbove(this$static.bal, block.owner, delta, this$static.ni);
        $shiftBlock(this$static.bal, block.owner, -availableSpace);
        return availableSpace > 0;
    } else if (delta < 0 && -delta < $intern_113) {
        availableSpace = $checkSpaceBelow(this$static.bal, block.owner, -delta, this$static.ni);
        $shiftBlock(this$static.bal, block.owner, availableSpace);
        return availableSpace > 0;
    }
    return false;
}
function ThresholdStrategy$SimpleThresholdStrategy() {
    ThresholdStrategy.call(this);
}
defineClass(1772, 802, {}, ThresholdStrategy$SimpleThresholdStrategy);
_.calculateThreshold = function calculateThreshold_0(oldThresh, blockRoot, currentNode) {
    var isLast, isRoot, t;
    isRoot = blockRoot == currentNode;
    isLast = this.bal.align_0[currentNode.id_0] == blockRoot;
    if (!(isRoot || isLast)) return oldThresh;
    t = oldThresh;
    if (this.bal.hdir == ($clinit_BKAlignedLayout$HDirection(), RIGHT_3)) {
        isRoot && (t = $getBound(this, blockRoot, true));
        !isNaN(t) && !isFinite(t) && isLast && (t = $getBound(this, currentNode, false));
    } else {
        isRoot && (t = $getBound(this, blockRoot, true));
        !isNaN(t) && !isFinite(t) && isLast && (t = $getBound(this, currentNode, false));
    }
    return t;
};
_.postProcess = function postProcess_0() {
    var edge, moved, onlyDummies, pick, pp;
    while(this.postProcessablesQueue.size_0 != 0){
        pp = castTo($poll(this.postProcessablesQueue), 570);
        pick = $pickEdge(this, pp);
        if (!pick.edge) continue;
        edge = pick.edge;
        onlyDummies = $booleanValue(this.bal.od[this.bal.root[pp.free.id_0].id_0]);
        if (!onlyDummies && !$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer) continue;
        moved = $process_79(this, pp);
        moved || $push(this.postProcessablesStack, pp);
    }
    while(this.postProcessablesStack.arrayList.array.length != 0)$process_79(this, castTo($pop(this.postProcessablesStack), 570));
};
var Lorg_eclipse_elk_alg_layered_p4nodes_bk_ThresholdStrategy$SimpleThresholdStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p4nodes.bk', 'ThresholdStrategy/SimpleThresholdStrategy', 1772);
function $clinit_EdgeRouterFactory() {
    $clinit_EdgeRouterFactory = emptyMethod;
    factoryCache = new EnumMap(Lorg_eclipse_elk_core_options_EdgeRouting_2_classLit);
}
function $create_7(this$static) {
    switch(this$static.edgeRoutingStrategy.ordinal){
        case 1:
            return new PolylineEdgeRouter;
        case 3:
            return new SplineEdgeRouter;
        default:
            return new OrthogonalEdgeRouter;
    }
}
function EdgeRouterFactory() {}
function factoryFor(edgeRoutingStrategy) {
    $clinit_EdgeRouterFactory();
    var factory;
    if (!$containsKey_5(factoryCache, edgeRoutingStrategy)) {
        factory = new EdgeRouterFactory;
        factory.edgeRoutingStrategy = edgeRoutingStrategy;
        $put_8(factoryCache, edgeRoutingStrategy, factory);
    }
    return castTo($get_14(factoryCache, edgeRoutingStrategy), 630);
}
defineClass(630, 1, {
    630: 1,
    188: 1,
    196: 1
}, EdgeRouterFactory);
_.create_1 = function create_16() {
    return $create_7(this);
};
_.create_2 = function create_15() {
    return $create_7(this);
};
var factoryCache;
var Lorg_eclipse_elk_alg_layered_p5edges_EdgeRouterFactory_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges', 'EdgeRouterFactory', 630);
function $clinit_OrthogonalEdgeRouter() {
    $clinit_OrthogonalEdgeRouter = emptyMethod;
    HYPEREDGE_PROCESSING_ADDITIONS = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P4_NODE_PLACEMENT), ($clinit_IntermediateProcessorStrategy(), HYPEREDGE_DUMMY_MERGER));
    INVERTED_PORT_PROCESSING_ADDITIONS = $addBefore(new LayoutProcessorConfiguration, P3_NODE_ORDERING, INVERTED_PORT_PROCESSOR);
    NORTH_SOUTH_PORT_PROCESSING_ADDITIONS = $addAfter($addBefore(new LayoutProcessorConfiguration, P3_NODE_ORDERING, NORTH_SOUTH_PORT_PREPROCESSOR), P5_EDGE_ROUTING, NORTH_SOUTH_PORT_POSTPROCESSOR);
    HIERARCHICAL_PORT_PROCESSING_ADDITIONS = $addAfter($addBefore($addBefore(new LayoutProcessorConfiguration, P3_NODE_ORDERING, HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR), P4_NODE_PLACEMENT, HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR), P5_EDGE_ROUTING, HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER);
    SELF_LOOP_PROCESSING_ADDITIONS = $add_17($add_17($before($addAfter($addBefore(new LayoutProcessorConfiguration, P1_CYCLE_BREAKING, SELF_LOOP_PREPROCESSOR), P5_EDGE_ROUTING, SELF_LOOP_POSTPROCESSOR), P4_NODE_PLACEMENT), SELF_LOOP_PORT_RESTORER), SELF_LOOP_ROUTER);
    HYPERNODE_PROCESSING_ADDITIONS = $addAfter(new LayoutProcessorConfiguration, P5_EDGE_ROUTING, HYPERNODE_PROCESSOR);
    CENTER_EDGE_LABEL_PROCESSING_ADDITIONS = $addAfter($addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, P2_LAYERING, LABEL_DUMMY_INSERTER), P4_NODE_PLACEMENT, LABEL_DUMMY_SWITCHER), P4_NODE_PLACEMENT, LABEL_SIDE_SELECTOR), P5_EDGE_ROUTING, LABEL_DUMMY_REMOVER);
    END_EDGE_LABEL_PROCESSING_ADDITIONS = $addAfter($addBefore($addBefore(new LayoutProcessorConfiguration, P4_NODE_PLACEMENT, LABEL_SIDE_SELECTOR), P4_NODE_PLACEMENT, END_LABEL_PREPROCESSOR), P5_EDGE_ROUTING, END_LABEL_POSTPROCESSOR);
}
function $getLayoutProcessorConfiguration_0(graph) {
    var configuration, graphProperties;
    graphProperties = castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
    configuration = new LayoutProcessorConfiguration;
    if (graphProperties.contains(($clinit_GraphProperties(), HYPEREDGES))) {
        $addAll_6(configuration, HYPEREDGE_PROCESSING_ADDITIONS);
        $addAll_6(configuration, INVERTED_PORT_PROCESSING_ADDITIONS);
    }
    if (graphProperties.contains(NON_FREE_PORTS) || $booleanValue(castToBoolean($getProperty(graph, ($clinit_LayeredOptions(), FEEDBACK_EDGES_0))))) {
        $addAll_6(configuration, INVERTED_PORT_PROCESSING_ADDITIONS);
        graphProperties.contains(NORTH_SOUTH_PORTS) && $addAll_6(configuration, NORTH_SOUTH_PORT_PROCESSING_ADDITIONS);
    }
    graphProperties.contains(EXTERNAL_PORTS) && $addAll_6(configuration, HIERARCHICAL_PORT_PROCESSING_ADDITIONS);
    graphProperties.contains(SELF_LOOPS) && $addAll_6(configuration, SELF_LOOP_PROCESSING_ADDITIONS);
    graphProperties.contains(HYPERNODES) && $addAll_6(configuration, HYPERNODE_PROCESSING_ADDITIONS);
    graphProperties.contains(CENTER_LABELS) && $addAll_6(configuration, CENTER_EDGE_LABEL_PROCESSING_ADDITIONS);
    graphProperties.contains(END_LABELS) && $addAll_6(configuration, END_EDGE_LABEL_PROCESSING_ADDITIONS);
    return configuration;
}
function $process_80(layeredGraph, monitor) {
    var edgeEdgeSpacing, edgeNodeSpacing, isLeftLayerExternal, isRightLayerExternal, layerIter, leftLayer, leftLayerNodes, nodeNodeSpacing, rightLayer, rightLayerNodes, routingGenerator, routingWidth, slotsCount, startPos, xpos;
    monitor.begin('Orthogonal edge routing', 1);
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_NODE_NODE_BETWEEN_LAYERS_0))));
    edgeEdgeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_EDGE_BETWEEN_LAYERS_0)));
    edgeNodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_NODE_BETWEEN_LAYERS_0)));
    routingGenerator = new OrthogonalRoutingGenerator(0, edgeEdgeSpacing);
    xpos = 0;
    layerIter = new AbstractList$ListIteratorImpl(layeredGraph.layers, 0);
    leftLayer = null;
    rightLayer = null;
    leftLayerNodes = null;
    rightLayerNodes = null;
    do {
        rightLayer = layerIter.i < layerIter.this$01_0.size_1() ? (checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25)) : null;
        rightLayerNodes = !rightLayer ? null : rightLayer.nodes;
        if (leftLayer) {
            placeNodesHorizontally(leftLayer, xpos);
            xpos += leftLayer.size_0.x_0;
        }
        startPos = !leftLayer ? xpos : xpos + edgeNodeSpacing;
        slotsCount = $routeEdges_0(routingGenerator, layeredGraph, leftLayerNodes, rightLayerNodes, startPos);
        isLeftLayerExternal = !leftLayer || all_0(leftLayerNodes, ($clinit_PolylineEdgeRouter(), PRED_EXTERNAL_WEST_OR_EAST_PORT));
        isRightLayerExternal = !rightLayer || all_0(rightLayerNodes, ($clinit_PolylineEdgeRouter(), PRED_EXTERNAL_WEST_OR_EAST_PORT));
        if (slotsCount > 0) {
            routingWidth = (slotsCount - 1) * edgeEdgeSpacing;
            !!leftLayer && (routingWidth += edgeNodeSpacing);
            !!rightLayer && (routingWidth += edgeNodeSpacing);
            routingWidth < nodeNodeSpacing && !isLeftLayerExternal && !isRightLayerExternal && (routingWidth = nodeNodeSpacing);
            xpos += routingWidth;
        } else !isLeftLayerExternal && !isRightLayerExternal && (xpos += nodeNodeSpacing);
        leftLayer = rightLayer;
        leftLayerNodes = rightLayerNodes;
    }while (rightLayer);
    layeredGraph.size_0.x_0 = xpos;
    monitor.done_1();
}
function OrthogonalEdgeRouter() {
    $clinit_OrthogonalEdgeRouter();
}
defineClass(1424, 1, $intern_110, OrthogonalEdgeRouter);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_20(graph) {
    return $getLayoutProcessorConfiguration_0(castTo(graph, 36));
};
_.process = function process_76(layeredGraph, monitor) {
    $process_80(castTo(layeredGraph, 36), monitor);
};
var CENTER_EDGE_LABEL_PROCESSING_ADDITIONS, END_EDGE_LABEL_PROCESSING_ADDITIONS, HIERARCHICAL_PORT_PROCESSING_ADDITIONS, HYPEREDGE_PROCESSING_ADDITIONS, HYPERNODE_PROCESSING_ADDITIONS, INVERTED_PORT_PROCESSING_ADDITIONS, NORTH_SOUTH_PORT_PROCESSING_ADDITIONS, SELF_LOOP_PROCESSING_ADDITIONS;
var Lorg_eclipse_elk_alg_layered_p5edges_OrthogonalEdgeRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges', 'OrthogonalEdgeRouter', 1424);
function $clinit_PolylineEdgeRouter() {
    $clinit_PolylineEdgeRouter = emptyMethod;
    PRED_EXTERNAL_WEST_OR_EAST_PORT = new PolylineEdgeRouter$1;
    BASELINE_PROCESSOR_CONFIGURATION = $addBefore(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P3_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy(), INVERTED_PORT_PROCESSOR));
    NORTH_SOUTH_PORT_PROCESSING_ADDITIONS_0 = $addAfter($addBefore(new LayoutProcessorConfiguration, P3_NODE_ORDERING, NORTH_SOUTH_PORT_PREPROCESSOR), P5_EDGE_ROUTING, NORTH_SOUTH_PORT_POSTPROCESSOR);
    SELF_LOOP_PROCESSING_ADDITIONS_0 = $add_17($add_17($before($addAfter($addBefore(new LayoutProcessorConfiguration, P1_CYCLE_BREAKING, SELF_LOOP_PREPROCESSOR), P5_EDGE_ROUTING, SELF_LOOP_POSTPROCESSOR), P4_NODE_PLACEMENT), SELF_LOOP_PORT_RESTORER), SELF_LOOP_ROUTER);
    CENTER_EDGE_LABEL_PROCESSING_ADDITIONS_0 = $addAfter($addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, P2_LAYERING, LABEL_DUMMY_INSERTER), P4_NODE_PLACEMENT, LABEL_DUMMY_SWITCHER), P4_NODE_PLACEMENT, LABEL_SIDE_SELECTOR), P5_EDGE_ROUTING, LABEL_DUMMY_REMOVER);
    END_EDGE_LABEL_PROCESSING_ADDITIONS_0 = $addAfter($addBefore($addBefore(new LayoutProcessorConfiguration, P4_NODE_PLACEMENT, LABEL_SIDE_SELECTOR), P4_NODE_PLACEMENT, END_LABEL_PREPROCESSOR), P5_EDGE_ROUTING, END_LABEL_POSTPROCESSOR);
}
function $addBendPoint(this$static, edge, bendPoint, addJunctionPoint, currPort) {
    var jpoint, junctionPoints;
    if ((!$isSelfLoop(edge) && edge.source.owner.layer == edge.target.owner.layer || !$equals_9(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        currPort.owner.pos,
        currPort.pos,
        currPort.anchor
    ])), bendPoint)) && !$isSelfLoop(edge)) {
        edge.source == currPort ? $add_0(edge.bendPoints, 0, new KVector_2(bendPoint)) : $add_7(edge.bendPoints, new KVector_2(bendPoint));
        if (addJunctionPoint && !$contains_6(this$static.createdJunctionPoints, bendPoint)) {
            junctionPoints = castTo($getProperty(edge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
            if (!junctionPoints) {
                junctionPoints = new KVectorChain;
                $setProperty_0(edge, JUNCTION_POINTS, junctionPoints);
            }
            jpoint = new KVector_2(bendPoint);
            $addNode_0(junctionPoints, jpoint, junctionPoints.tail.prev, junctionPoints.tail);
            $add_6(this$static.createdJunctionPoints, jpoint);
        }
    }
}
function $calculateWestInLayerEdgeYDiff(layer) {
    var maxYDiff, node, node$iterator, outgoingEdge, outgoingEdge$iterator, sourcePos, targetPos;
    maxYDiff = 0;
    for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        for(outgoingEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outgoingEdge$iterator);){
            outgoingEdge = castTo($next_0(outgoingEdge$iterator), 18);
            if (layer == outgoingEdge.target.owner.layer && outgoingEdge.source.side == ($clinit_PortSide(), WEST_0)) {
                sourcePos = $getAbsoluteAnchor(outgoingEdge.source).y_0;
                targetPos = $getAbsoluteAnchor(outgoingEdge.target).y_0;
                maxYDiff = $wnd.Math.max(maxYDiff, $wnd.Math.abs(targetPos - sourcePos));
            }
        }
    }
    return maxYDiff;
}
function $getLayoutProcessorConfiguration_1(graph) {
    var configuration, graphProperties;
    graphProperties = castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
    configuration = createFrom_0(BASELINE_PROCESSOR_CONFIGURATION);
    graphProperties.contains(($clinit_GraphProperties(), NORTH_SOUTH_PORTS)) && $addAll_6(configuration, NORTH_SOUTH_PORT_PROCESSING_ADDITIONS_0);
    graphProperties.contains(SELF_LOOPS) && $addAll_6(configuration, SELF_LOOP_PROCESSING_ADDITIONS_0);
    graphProperties.contains(CENTER_LABELS) && $addAll_6(configuration, CENTER_EDGE_LABEL_PROCESSING_ADDITIONS_0);
    graphProperties.contains(END_LABELS) && $addAll_6(configuration, END_EDGE_LABEL_PROCESSING_ADDITIONS_0);
    return configuration;
}
function $isInLayerDummy_0(node) {
    var e, e$iterator;
    if (node.type_0 == ($clinit_LNode$NodeType(), LONG_EDGE)) for(e$iterator = new Iterators$ConcatenatedIterator(transform_2($getConnectedEdges_0(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
        e = castTo($next_0(e$iterator), 18);
        if (!$isSelfLoop(e) && e.source.owner.layer == e.target.owner.layer) return true;
    }
    return false;
}
function $process_81(this$static, layeredGraph, monitor) {
    var edgeSpaceFac, edgeSpacing, externalLayer, layer, layerIter, layerSpacing, maxCurrOutputYDiff, maxVertDiff, node, node$iterator, nodeSpacing, outgoingEdge, outgoingEdge$iterator, slopedEdgeZoneWidth, sourcePos, targetPos, xpos, yDiff;
    monitor.begin('Polyline edge routing', 1);
    slopedEdgeZoneWidth = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), EDGE_ROUTING_POLYLINE_SLOPED_EDGE_ZONE_WIDTH_0))));
    nodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_NODE_NODE_BETWEEN_LAYERS_0)));
    edgeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_EDGE_BETWEEN_LAYERS_0)));
    edgeSpaceFac = $wnd.Math.min(1, edgeSpacing / nodeSpacing);
    xpos = 0;
    layerSpacing = 0;
    if (layeredGraph.layers.array.length != 0) {
        yDiff = $calculateWestInLayerEdgeYDiff(castTo($get_11(layeredGraph.layers, 0), 25));
        xpos = 0.4 * edgeSpaceFac * yDiff;
    }
    layerIter = new AbstractList$ListIteratorImpl(layeredGraph.layers, 0);
    while(layerIter.i < layerIter.this$01_0.size_1()){
        layer = (checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25));
        externalLayer = all_0(layer, PRED_EXTERNAL_WEST_OR_EAST_PORT);
        externalLayer && xpos > 0 && (xpos -= nodeSpacing);
        placeNodesHorizontally(layer, xpos);
        maxVertDiff = 0;
        for(node$iterator = new ArrayList$1(layer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 9);
            maxCurrOutputYDiff = 0;
            for(outgoingEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outgoingEdge$iterator);){
                outgoingEdge = castTo($next_0(outgoingEdge$iterator), 18);
                sourcePos = $getAbsoluteAnchor(outgoingEdge.source).y_0;
                targetPos = $getAbsoluteAnchor(outgoingEdge.target).y_0;
                if (layer == outgoingEdge.target.owner.layer && !$isSelfLoop(outgoingEdge)) {
                    $processInLayerEdge(outgoingEdge, xpos, 0.4 * edgeSpaceFac * $wnd.Math.abs(sourcePos - targetPos));
                    if (outgoingEdge.source.side == ($clinit_PortSide(), WEST_0)) {
                        sourcePos = 0;
                        targetPos = 0;
                    }
                }
                maxCurrOutputYDiff = $wnd.Math.max(maxCurrOutputYDiff, $wnd.Math.abs(targetPos - sourcePos));
            }
            switch(node.type_0.ordinal){
                case 0:
                case 4:
                case 1:
                case 3:
                case 5:
                    $processNode_6(this$static, node, xpos, slopedEdgeZoneWidth);
            }
            maxVertDiff = $wnd.Math.max(maxVertDiff, maxCurrOutputYDiff);
        }
        if (layerIter.i < layerIter.this$01_0.size_1()) {
            yDiff = $calculateWestInLayerEdgeYDiff((checkCriticalElement(layerIter.i < layerIter.this$01_0.size_1()), castTo(layerIter.this$01_0.get_0(layerIter.last = layerIter.i++), 25)));
            maxVertDiff = $wnd.Math.max(maxVertDiff, yDiff);
            checkCriticalElement(layerIter.i > 0);
            layerIter.this$01.get_0(layerIter.last = --layerIter.i);
        }
        layerSpacing = 0.4 * edgeSpaceFac * maxVertDiff;
        !externalLayer && layerIter.i < layerIter.this$01_0.size_1() && (layerSpacing += nodeSpacing);
        xpos += layer.size_0.x_0 + layerSpacing;
    }
    this$static.createdJunctionPoints.map_0.clear_0();
    layeredGraph.size_0.x_0 = xpos;
    monitor.done_1();
}
function $processInLayerEdge(edge, layerXPos, edgeSpacing) {
    var bendPoint, midY, sourceAnchorY, sourcePort, targetPort;
    sourcePort = edge.source;
    targetPort = edge.target;
    sourceAnchorY = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        sourcePort.owner.pos,
        sourcePort.pos,
        sourcePort.anchor
    ])).y_0;
    midY = (sourceAnchorY + sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        targetPort.owner.pos,
        targetPort.pos,
        targetPort.anchor
    ])).y_0) / 2;
    bendPoint = null;
    sourcePort.side == ($clinit_PortSide(), EAST_0) ? bendPoint = new KVector_1(layerXPos + sourcePort.owner.layer.size_0.x_0 + edgeSpacing, midY) : bendPoint = new KVector_1(layerXPos - edgeSpacing, midY);
    $add_0(edge.bendPoints, 0, bendPoint);
}
function $processNode_6(this$static, node, layerLeftXPos, maxAcceptableXDiff) {
    var absolutePortAnchor, addJunctionPoint, bendPoint, correspondingPort, e, e$iterator, layerRightXPos, otherPort, port, port$iterator, xDistance;
    layerRightXPos = layerLeftXPos + node.layer.size_0.x_0;
    for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        absolutePortAnchor = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ]));
        if (node.type_0 == ($clinit_LNode$NodeType(), NORTH_SOUTH_PORT)) {
            correspondingPort = castTo($getProperty(port, ($clinit_InternalProperties_1(), ORIGIN_0)), 11);
            absolutePortAnchor.x_0 = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                correspondingPort.owner.pos,
                correspondingPort.pos,
                correspondingPort.anchor
            ])).x_0;
            node.pos.x_0 = absolutePortAnchor.x_0;
        }
        bendPoint = new KVector_1(0, absolutePortAnchor.y_0);
        if (port.side == ($clinit_PortSide(), EAST_0)) bendPoint.x_0 = layerRightXPos;
        else if (port.side == WEST_0) bendPoint.x_0 = layerLeftXPos;
        else continue;
        xDistance = $wnd.Math.abs(absolutePortAnchor.x_0 - bendPoint.x_0);
        if (xDistance <= maxAcceptableXDiff && !$isInLayerDummy_0(node)) continue;
        addJunctionPoint = port.outgoingEdges.array.length + port.incomingEdges.array.length > 1;
        for(e$iterator = new LPort$CombineIter$1(port.connectedEdges); $hasNext_3(e$iterator.firstIterator) || $hasNext_3(e$iterator.secondIterator);){
            e = castTo($hasNext_3(e$iterator.firstIterator) ? $next_6(e$iterator.firstIterator) : $next_6(e$iterator.secondIterator), 18);
            otherPort = e.source == port ? e.target : e.source;
            $wnd.Math.abs(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                otherPort.owner.pos,
                otherPort.pos,
                otherPort.anchor
            ])).y_0 - bendPoint.y_0) > 1 && $addBendPoint(this$static, e, bendPoint, addJunctionPoint, port);
        }
    }
}
function PolylineEdgeRouter() {
    $clinit_PolylineEdgeRouter();
    this.createdJunctionPoints = new HashSet;
}
defineClass(1417, 1, $intern_110, PolylineEdgeRouter);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_21(graph) {
    return $getLayoutProcessorConfiguration_1(castTo(graph, 36));
};
_.process = function process_77(layeredGraph, monitor) {
    $process_81(this, castTo(layeredGraph, 36), monitor);
};
var BASELINE_PROCESSOR_CONFIGURATION, CENTER_EDGE_LABEL_PROCESSING_ADDITIONS_0, END_EDGE_LABEL_PROCESSING_ADDITIONS_0, NORTH_SOUTH_PORT_PROCESSING_ADDITIONS_0, PRED_EXTERNAL_WEST_OR_EAST_PORT, SELF_LOOP_PROCESSING_ADDITIONS_0;
var Lorg_eclipse_elk_alg_layered_p5edges_PolylineEdgeRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges', 'PolylineEdgeRouter', 1417);
function $apply_8(node) {
    var extPortSide;
    extPortSide = castTo($getProperty(node, ($clinit_InternalProperties_1(), EXT_PORT_SIDE)), 64);
    return node.type_0 == ($clinit_LNode$NodeType(), EXTERNAL_PORT) && (extPortSide == ($clinit_PortSide(), WEST_0) || extPortSide == EAST_0);
}
function PolylineEdgeRouter$1() {}
defineClass(1418, 1, $intern_89, PolylineEdgeRouter$1);
_.apply_1 = function apply_124(node) {
    return $apply_8(castTo(node, 9));
};
_.equals_0 = function equals_159(other) {
    return this === other;
};
_.test_0 = function test_96(input_0) {
    return $apply_8(castTo(input_0, 9));
};
var Lorg_eclipse_elk_alg_layered_p5edges_PolylineEdgeRouter$1_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges', 'PolylineEdgeRouter/1', 1418);
function computeLinearOrderingMarks(segments, sources, sinks, criticalOnly, random) {
    var markBase, maxNode, maxOutflow, maxSegments, nextSinkMark, nextSourceMark, node, node$iterator, outflow, segment, segment$iterator, shiftBase, sink, source, unprocessed;
    unprocessed = newTreeSet(segments);
    maxSegments = new ArrayList;
    markBase = segments.array.length;
    nextSinkMark = markBase - 1;
    nextSourceMark = markBase + 1;
    while(unprocessed.map_0.size_1() != 0){
        while(sinks.size_0 != 0){
            sink = (checkCriticalElement(sinks.size_0 != 0), castTo($removeNode_0(sinks, sinks.header.next_0), 116));
            unprocessed.map_0.remove_0(sink);
            sink.mark = nextSinkMark--;
            updateNeighbors(sink, sources, sinks, criticalOnly);
        }
        while(sources.size_0 != 0){
            source = (checkCriticalElement(sources.size_0 != 0), castTo($removeNode_0(sources, sources.header.next_0), 116));
            unprocessed.map_0.remove_0(source);
            source.mark = nextSourceMark++;
            updateNeighbors(source, sources, sinks, criticalOnly);
        }
        maxOutflow = $intern_42;
        for(segment$iterator = unprocessed.map_0.keySet_0().iterator_0(); segment$iterator.hasNext_0();){
            segment = castTo(segment$iterator.next_1(), 116);
            if (!criticalOnly && segment.criticalOutDepWeight > 0 && segment.criticalInDepWeight <= 0) {
                maxSegments.array.length = 0;
                push_1(maxSegments.array, segment);
                break;
            }
            outflow = segment.outDepWeight - segment.inDepWeight;
            if (outflow >= maxOutflow) {
                if (outflow > maxOutflow) {
                    maxSegments.array.length = 0;
                    maxOutflow = outflow;
                }
                push_1(maxSegments.array, segment);
            }
        }
        if (maxSegments.array.length != 0) {
            maxNode = castTo($get_11(maxSegments, $nextInt(random, maxSegments.array.length)), 116);
            unprocessed.map_0.remove_0(maxNode);
            maxNode.mark = nextSourceMark++;
            updateNeighbors(maxNode, sources, sinks, criticalOnly);
            maxSegments.array.length = 0;
        }
    }
    shiftBase = segments.array.length + 1;
    for(node$iterator = new ArrayList$1(segments); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 116);
        node.mark < markBase && (node.mark = node.mark + shiftBase);
    }
}
function detectCycles(segments, criticalOnly, random) {
    var outDependency, outDependency$iterator, result, sinks, source, source$iterator, sources;
    result = new ArrayList;
    sources = new LinkedList;
    sinks = new LinkedList;
    initialize_2(segments, sources, sinks, criticalOnly);
    computeLinearOrderingMarks(segments, sources, sinks, criticalOnly, random);
    for(source$iterator = new ArrayList$1(segments); source$iterator.i < source$iterator.this$01.array.length;){
        source = castTo($next_6(source$iterator), 116);
        for(outDependency$iterator = new ArrayList$1(source.outgoingSegmentDependencies); outDependency$iterator.i < outDependency$iterator.this$01.array.length;){
            outDependency = castTo($next_6(outDependency$iterator), 133);
            (!criticalOnly || outDependency.type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL)) && source.mark > outDependency.target.mark && push_1(result.array, outDependency);
        }
    }
    return result;
}
function initialize_2(segments, sources, sinks, criticalOnly) {
    var criticalInWeight, criticalOutWeight, inWeight, nextMark, outWeight, segment, segment$iterator;
    nextMark = -1;
    for(segment$iterator = new ArrayList$1(segments); segment$iterator.i < segment$iterator.this$01.array.length;){
        segment = castTo($next_6(segment$iterator), 116);
        segment.mark = nextMark--;
        criticalInWeight = toInt_0($collect_0($mapToInt($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(segment.incomingSegmentDependencies, 16)), new HyperEdgeCycleDetector$lambda$0$Type), new HyperEdgeCycleDetector$lambda$1$Type)).sum);
        criticalOutWeight = toInt_0($collect_0($mapToInt($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(segment.outgoingSegmentDependencies, 16)), new HyperEdgeCycleDetector$lambda$2$Type), new HyperEdgeCycleDetector$lambda$3$Type)).sum);
        inWeight = criticalInWeight;
        outWeight = criticalOutWeight;
        if (!criticalOnly) {
            inWeight = toInt_0($collect_0($mapToInt(new StreamImpl(null, new Spliterators$IteratorSpliterator(segment.incomingSegmentDependencies, 16)), new HyperEdgeCycleDetector$lambda$4$Type)).sum);
            outWeight = toInt_0($collect_0($mapToInt(new StreamImpl(null, new Spliterators$IteratorSpliterator(segment.outgoingSegmentDependencies, 16)), new HyperEdgeCycleDetector$lambda$5$Type)).sum);
        }
        segment.inDepWeight = inWeight;
        segment.criticalInDepWeight = criticalInWeight;
        segment.outDepWeight = outWeight;
        segment.criticalOutDepWeight = criticalOutWeight;
        outWeight == 0 ? $addNode_0(sinks, segment, sinks.tail.prev, sinks.tail) : inWeight == 0 && $addNode_0(sources, segment, sources.tail.prev, sources.tail);
    }
}
function updateNeighbors(node, sources, sinks, criticalOnly) {
    var dep, dep$iterator, dep$iterator0, source, target;
    for(dep$iterator0 = new ArrayList$1(node.outgoingSegmentDependencies); dep$iterator0.i < dep$iterator0.this$01.array.length;){
        dep = castTo($next_6(dep$iterator0), 133);
        if (!criticalOnly || dep.type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL)) {
            target = dep.target;
            if (target.mark < 0 && dep.weight > 0) {
                $setInWeight(target, target.inDepWeight - dep.weight);
                dep.type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL) && $setCriticalInWeight(target, target.criticalInDepWeight - dep.weight);
                target.inDepWeight <= 0 && target.outDepWeight > 0 && $addNode_0(sources, target, sources.tail.prev, sources.tail);
            }
        }
    }
    for(dep$iterator = new ArrayList$1(node.incomingSegmentDependencies); dep$iterator.i < dep$iterator.this$01.array.length;){
        dep = castTo($next_6(dep$iterator), 133);
        if (!criticalOnly || dep.type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL)) {
            source = dep.source;
            if (source.mark < 0 && dep.weight > 0) {
                $setOutWeight(source, source.outDepWeight - dep.weight);
                dep.type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL) && $setCriticalOutWeight(source, source.criticalOutDepWeight - dep.weight);
                source.outDepWeight <= 0 && source.inDepWeight > 0 && $addNode_0(sinks, source, sinks.tail.prev, sinks.tail);
            }
        }
    }
}
function HyperEdgeCycleDetector$lambda$0$Type() {}
defineClass(1818, 1, $intern_39, HyperEdgeCycleDetector$lambda$0$Type);
_.test_0 = function test_97(arg0) {
    return castTo(arg0, 133).type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL);
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeCycleDetector$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeCycleDetector/lambda$0$Type', 1818);
function HyperEdgeCycleDetector$lambda$1$Type() {}
defineClass(1819, 1, {}, HyperEdgeCycleDetector$lambda$1$Type);
_.applyAsInt = function applyAsInt(arg0) {
    return castTo(arg0, 133).weight;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeCycleDetector$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeCycleDetector/lambda$1$Type', 1819);
function HyperEdgeCycleDetector$lambda$2$Type() {}
defineClass(1820, 1, $intern_39, HyperEdgeCycleDetector$lambda$2$Type);
_.test_0 = function test_98(arg0) {
    return castTo(arg0, 133).type_0 == ($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL);
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeCycleDetector$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeCycleDetector/lambda$2$Type', 1820);
function HyperEdgeCycleDetector$lambda$3$Type() {}
defineClass(1821, 1, {}, HyperEdgeCycleDetector$lambda$3$Type);
_.applyAsInt = function applyAsInt_0(arg0) {
    return castTo(arg0, 133).weight;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeCycleDetector$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeCycleDetector/lambda$3$Type', 1821);
function HyperEdgeCycleDetector$lambda$4$Type() {}
defineClass(1822, 1, {}, HyperEdgeCycleDetector$lambda$4$Type);
_.applyAsInt = function applyAsInt_1(arg0) {
    return castTo(arg0, 133).weight;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeCycleDetector$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeCycleDetector/lambda$4$Type', 1822);
function HyperEdgeCycleDetector$lambda$5$Type() {}
defineClass(1823, 1, {}, HyperEdgeCycleDetector$lambda$5$Type);
_.applyAsInt = function applyAsInt_2(arg0) {
    return castTo(arg0, 133).weight;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeCycleDetector$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeCycleDetector/lambda$5$Type', 1823);
function $addPortPositions(this$static, port, hyperEdgeSegmentMap) {
    var otherPort, otherPort$iterator, portPos;
    hyperEdgeSegmentMap.put(port, this$static);
    $add_3(this$static.ports, port);
    portPos = this$static.routingStrategy.getPortPositionOnHyperNode(port);
    port.side == this$static.routingStrategy.getSourcePortSide() ? insertSorted(this$static.incomingConnectionCoordinates, portPos) : insertSorted(this$static.outgoingConnectionCoordinates, portPos);
    $recomputeExtent(this$static);
    for(otherPort$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        new LPort$1(port),
        new LPort$2(port)
    ]))); $hasNext_1(otherPort$iterator);){
        otherPort = castTo($next_0(otherPort$iterator), 11);
        hyperEdgeSegmentMap.containsKey(otherPort) || $addPortPositions(this$static, otherPort, hyperEdgeSegmentMap);
    }
}
function $compareTo_17(this$static, other) {
    return this$static.mark - other.mark;
}
function $recomputeExtent(this$static) {
    this$static.startPosition = NaN;
    this$static.endPosition = NaN;
    $recomputeExtent_0(this$static, this$static.incomingConnectionCoordinates);
    $recomputeExtent_0(this$static, this$static.outgoingConnectionCoordinates);
}
function $recomputeExtent_0(this$static, positions) {
    if (positions.size_0 != 0) {
        isNaN(this$static.startPosition) ? this$static.startPosition = $doubleValue((checkCriticalElement(positions.size_0 != 0), castToDouble(positions.header.next_0.value_0))) : this$static.startPosition = $wnd.Math.min(this$static.startPosition, $doubleValue((checkCriticalElement(positions.size_0 != 0), castToDouble(positions.header.next_0.value_0))));
        isNaN(this$static.endPosition) ? this$static.endPosition = $doubleValue((checkCriticalElement(positions.size_0 != 0), castToDouble(positions.tail.prev.value_0))) : this$static.endPosition = $wnd.Math.max(this$static.endPosition, $doubleValue((checkCriticalElement(positions.size_0 != 0), castToDouble(positions.tail.prev.value_0))));
    }
}
function $setCriticalInWeight(this$static, inWeight) {
    this$static.criticalInDepWeight = inWeight;
}
function $setCriticalOutWeight(this$static, outWeight) {
    this$static.criticalOutDepWeight = outWeight;
}
function $setInWeight(this$static, inWeight) {
    this$static.inDepWeight = inWeight;
}
function $setOutWeight(this$static, outWeight) {
    this$static.outDepWeight = outWeight;
}
function $setRoutingSlot_0(this$static, slot) {
    this$static.routingSlot = slot;
}
function $setSplitPartner(this$static, splitPartner) {
    this$static.splitPartner = splitPartner;
}
function $splitAt(this$static, splitPosition) {
    this$static.splitPartner = new HyperEdgeSegment(this$static.routingStrategy);
    $setSplitPartner(this$static.splitPartner, this$static);
    $addAll(this$static.splitPartner.outgoingConnectionCoordinates, this$static.outgoingConnectionCoordinates);
    $reset_0(this$static.outgoingConnectionCoordinates);
    $add_7(this$static.outgoingConnectionCoordinates, splitPosition);
    $add_7(this$static.splitPartner.incomingConnectionCoordinates, splitPosition);
    $recomputeExtent(this$static);
    $recomputeExtent(this$static.splitPartner);
    while(this$static.incomingSegmentDependencies.array.length != 0)$remove_31(castTo($get_11(this$static.incomingSegmentDependencies, 0), 133));
    while(this$static.outgoingSegmentDependencies.array.length != 0)$remove_31(castTo($get_11(this$static.outgoingSegmentDependencies, 0), 133));
    return this$static.splitPartner;
}
function HyperEdgeSegment(routingStrategy) {
    this.ports = new ArrayList;
    this.incomingConnectionCoordinates = new LinkedList;
    this.outgoingConnectionCoordinates = new LinkedList;
    this.outgoingSegmentDependencies = new ArrayList;
    this.incomingSegmentDependencies = new ArrayList;
    this.routingStrategy = routingStrategy;
}
function insertSorted(list, value_0) {
    var listIter, next;
    listIter = $listIterator_2(list, 0);
    while(listIter.currentNode != listIter.this$01.tail){
        next = $floatValue(castToDouble($next_9(listIter)));
        if (next == value_0) return;
        else if (next > value_0) {
            $previous_0(listIter);
            break;
        }
    }
    $add_8(listIter, value_0);
}
defineClass(116, 1, {
    34: 1,
    116: 1
}, HyperEdgeSegment);
_.compareTo_0 = function compareTo_18(other) {
    return $compareTo_17(this, castTo(other, 116));
};
_.equals_0 = function equals_160(object) {
    var other;
    if (instanceOf(object, 116)) {
        other = castTo(object, 116);
        return this.mark == other.mark;
    }
    return false;
};
_.hashCode_1 = function hashCode_64() {
    return this.mark;
};
_.toString_0 = function toString_102() {
    var builder, name_0, port, portIter;
    builder = new StringBuilder_1('{');
    portIter = new ArrayList$1(this.ports);
    while(portIter.i < portIter.this$01.array.length){
        port = castTo($next_6(portIter), 11);
        name_0 = $getDesignation_2(port.owner);
        name_0 == null && (name_0 = 'n' + $getIndex(port.owner));
        builder.string += '' + name_0;
        portIter.i < portIter.this$01.array.length && (builder.string += ',', builder);
    }
    builder.string += '}';
    return builder.string;
};
_.criticalInDepWeight = 0;
_.criticalOutDepWeight = 0;
_.endPosition = NaN;
_.inDepWeight = 0;
_.mark = 0;
_.outDepWeight = 0;
_.routingSlot = 0;
_.startPosition = NaN;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegment_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegment', 116);
function $remove_31(this$static) {
    $setSource_1(this$static, null);
    $setTarget_1(this$static, null);
}
function $setSource_1(this$static, newSource) {
    !!this$static.source && $remove_12(this$static.source.outgoingSegmentDependencies, this$static);
    this$static.source = newSource;
    !!this$static.source && $add_3(this$static.source.outgoingSegmentDependencies, this$static);
}
function $setTarget_1(this$static, newTarget) {
    !!this$static.target && $remove_12(this$static.target.incomingSegmentDependencies, this$static);
    this$static.target = newTarget;
    !!this$static.target && $add_3(this$static.target.incomingSegmentDependencies, this$static);
}
function HyperEdgeSegmentDependency(type_0, source, target, weight) {
    this.type_0 = type_0;
    this.weight = weight;
    $setSource_1(this, source);
    $setTarget_1(this, target);
}
defineClass(133, 1, {
    133: 1
}, HyperEdgeSegmentDependency);
_.toString_0 = function toString_103() {
    return this.source + '->' + this.target + ' (' + $name(this.type_0) + ')';
};
_.weight = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentDependency_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentDependency', 133);
function $clinit_HyperEdgeSegmentDependency$DependencyType() {
    $clinit_HyperEdgeSegmentDependency$DependencyType = emptyMethod;
    REGULAR = new HyperEdgeSegmentDependency$DependencyType('REGULAR', 0);
    CRITICAL = new HyperEdgeSegmentDependency$DependencyType('CRITICAL', 1);
}
function HyperEdgeSegmentDependency$DependencyType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_64(name_0) {
    $clinit_HyperEdgeSegmentDependency$DependencyType();
    return valueOf(($clinit_HyperEdgeSegmentDependency$DependencyType$Map(), $MAP_54), name_0);
}
function values_72() {
    $clinit_HyperEdgeSegmentDependency$DependencyType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentDependency$DependencyType_2_classLit, 1), $intern_36, 513, 0, [
        REGULAR,
        CRITICAL
    ]);
}
defineClass(513, 23, {
    3: 1,
    34: 1,
    23: 1,
    513: 1
}, HyperEdgeSegmentDependency$DependencyType);
var CRITICAL, REGULAR;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentDependency$DependencyType_2_classLit = createForEnum('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentDependency/DependencyType', 513, Ljava_lang_Enum_2_classLit, values_72, valueOf_64);
function $clinit_HyperEdgeSegmentDependency$DependencyType$Map() {
    $clinit_HyperEdgeSegmentDependency$DependencyType$Map = emptyMethod;
    $MAP_54 = createValueOfMap(($clinit_HyperEdgeSegmentDependency$DependencyType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentDependency$DependencyType_2_classLit, 1), $intern_36, 513, 0, [
        REGULAR,
        CRITICAL
    ])));
}
var $MAP_54;
function $chooseBestAreaIndex(segment, freeAreas, fromIndex, toIndex) {
    var bestArea, bestAreaIndex, bestRating, currArea, currRating, i, splitPartner, splitSegment, splitSegments, newSplit, newSplitPartner;
    bestAreaIndex = fromIndex;
    if (fromIndex < toIndex) {
        splitSegments = (newSplit = new HyperEdgeSegment(segment.routingStrategy), newSplitPartner = new HyperEdgeSegment(segment.routingStrategy), $addAll(newSplit.incomingConnectionCoordinates, segment.incomingConnectionCoordinates), newSplit.splitBy = segment.splitBy, newSplit.splitPartner = newSplitPartner, $recomputeExtent(newSplit), $addAll(newSplitPartner.outgoingConnectionCoordinates, segment.outgoingConnectionCoordinates), newSplitPartner.splitPartner = newSplit, $recomputeExtent(newSplitPartner), new Pair(newSplit, newSplitPartner));
        splitSegment = castTo(splitSegments.first, 116);
        splitPartner = castTo(splitSegments.second, 116);
        bestArea = (checkCriticalElementIndex(bestAreaIndex, freeAreas.array.length), castTo(freeAreas.array[bestAreaIndex], 335));
        bestRating = $rateArea(segment, splitSegment, splitPartner, bestArea);
        for(i = fromIndex + 1; i <= toIndex; i++){
            currArea = (checkCriticalElementIndex(i, freeAreas.array.length), castTo(freeAreas.array[i], 335));
            currRating = $rateArea(segment, splitSegment, splitPartner, currArea);
            if ($isBetter(currArea, currRating, bestArea, bestRating)) {
                bestArea = currArea;
                bestRating = currRating;
                bestAreaIndex = i;
            }
        }
    }
    return bestAreaIndex;
}
function $computePositionToSplitAndUpdateFreeAreas(segment, freeAreas, criticalConflictThreshold) {
    var bestAreaIndex, currArea, firstPossibleAreaIndex, i, lastPossibleAreaIndex, splitPosition;
    firstPossibleAreaIndex = -1;
    lastPossibleAreaIndex = -1;
    for(i = 0; i < freeAreas.array.length; i++){
        currArea = (checkCriticalElementIndex(i, freeAreas.array.length), castTo(freeAreas.array[i], 335));
        if (currArea.startPosition > segment.endPosition) break;
        else if (currArea.endPosition >= segment.startPosition) {
            firstPossibleAreaIndex < 0 && (firstPossibleAreaIndex = i);
            lastPossibleAreaIndex = i;
        }
    }
    splitPosition = (segment.startPosition + segment.endPosition) / 2;
    if (firstPossibleAreaIndex >= 0) {
        bestAreaIndex = $chooseBestAreaIndex(segment, freeAreas, firstPossibleAreaIndex, lastPossibleAreaIndex);
        splitPosition = center_0((checkCriticalElementIndex(bestAreaIndex, freeAreas.array.length), castTo(freeAreas.array[bestAreaIndex], 335)));
        $useArea(freeAreas, bestAreaIndex, criticalConflictThreshold);
    }
    return splitPosition;
}
function $countCrossingsForSingleOrdering(left, right) {
    return countCrossings(left.outgoingConnectionCoordinates, right.startPosition, right.endPosition) + countCrossings(right.incomingConnectionCoordinates, left.startPosition, left.endPosition);
}
function $decideWhichSegmentsToSplit(dependencies) {
    var dependency, dependency$iterator, segmentCausingSplit, segmentToSplit, segmentsToSplit, sourceSegment, targetSegment;
    segmentsToSplit = new LinkedHashSet;
    for(dependency$iterator = new ArrayList$1(dependencies); dependency$iterator.i < dependency$iterator.this$01.array.length;){
        dependency = castTo($next_6(dependency$iterator), 133);
        sourceSegment = dependency.source;
        targetSegment = dependency.target;
        if (segmentsToSplit.map_0.containsKey(sourceSegment) || segmentsToSplit.map_0.containsKey(targetSegment)) continue;
        segmentToSplit = sourceSegment;
        segmentCausingSplit = targetSegment;
        if (sourceSegment.incomingConnectionCoordinates.size_0 + sourceSegment.outgoingConnectionCoordinates.size_0 > 2 && targetSegment.incomingConnectionCoordinates.size_0 + targetSegment.outgoingConnectionCoordinates.size_0 <= 2) {
            segmentToSplit = targetSegment;
            segmentCausingSplit = sourceSegment;
        }
        segmentsToSplit.map_0.put(segmentToSplit, segmentsToSplit);
        segmentToSplit.splitBy = segmentCausingSplit;
    }
    return segmentsToSplit;
}
function $findFreeAreas(segments, criticalConflictThreshold) {
    var freeAreas, i, inCoordinates, outCoordinates, sortedCoordinates;
    freeAreas = new ArrayList;
    inCoordinates = $flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(segments, 16)), new HyperEdgeSegmentSplitter$lambda$2$Type);
    outCoordinates = $flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(segments, 16)), new HyperEdgeSegmentSplitter$lambda$3$Type);
    sortedCoordinates = $toArray_5($sorted($mapToDouble(concat_1(stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Stream_2_classLit, 1), $intern_2, 827, 0, [
        inCoordinates,
        outCoordinates
    ])), new HyperEdgeSegmentSplitter$lambda$4$Type)));
    for(i = 1; i < sortedCoordinates.length; i++)sortedCoordinates[i] - sortedCoordinates[i - 1] >= 2 * criticalConflictThreshold && $add_3(freeAreas, new HyperEdgeSegmentSplitter$FreeArea(sortedCoordinates[i - 1] + criticalConflictThreshold, sortedCoordinates[i] - criticalConflictThreshold));
    return freeAreas;
}
function $isBetter(currArea, currRating, bestArea, bestRating) {
    if (currRating.crossings < bestRating.crossings) return true;
    else if (currRating.crossings == bestRating.crossings) {
        if (currRating.dependencies < bestRating.dependencies) return true;
        else if (currRating.dependencies == bestRating.dependencies) {
            if (currArea.size_0 > bestArea.size_0) return true;
        }
    }
    return false;
}
function $lambda$1_6(this$static, segments_1, freeAreas_2, criticalConflictThreshold_3, segment_3) {
    var splitPosition;
    splitPosition = $computePositionToSplitAndUpdateFreeAreas(segment_3, freeAreas_2, criticalConflictThreshold_3);
    $add_3(segments_1, $splitAt(segment_3, splitPosition));
    $updateDependencies(this$static, segment_3, segments_1);
}
function $rateArea(segment, splitSegment, splitPartner, area) {
    var areaCentre, dependency, dependency$iterator, dependency$iterator0, otherSegment, rating;
    areaCentre = (area.startPosition + area.endPosition) / 2;
    $reset_0(splitSegment.outgoingConnectionCoordinates);
    $add_7(splitSegment.outgoingConnectionCoordinates, areaCentre);
    $reset_0(splitPartner.incomingConnectionCoordinates);
    $add_7(splitPartner.incomingConnectionCoordinates, areaCentre);
    rating = new HyperEdgeSegmentSplitter$AreaRating;
    for(dependency$iterator0 = new ArrayList$1(segment.incomingSegmentDependencies); dependency$iterator0.i < dependency$iterator0.this$01.array.length;){
        dependency = castTo($next_6(dependency$iterator0), 133);
        otherSegment = dependency.source;
        $updateConsideringBothOrderings(rating, splitSegment, otherSegment);
        $updateConsideringBothOrderings(rating, splitPartner, otherSegment);
    }
    for(dependency$iterator = new ArrayList$1(segment.outgoingSegmentDependencies); dependency$iterator.i < dependency$iterator.this$01.array.length;){
        dependency = castTo($next_6(dependency$iterator), 133);
        otherSegment = dependency.target;
        $updateConsideringBothOrderings(rating, splitSegment, otherSegment);
        $updateConsideringBothOrderings(rating, splitPartner, otherSegment);
    }
    rating.dependencies += 2;
    rating.crossings += $countCrossingsForSingleOrdering(splitSegment, segment.splitBy);
    rating.crossings += $countCrossingsForSingleOrdering(segment.splitBy, splitPartner);
    return rating;
}
function $splitSegments(this$static, dependenciesToResolve, segments, criticalConflictThreshold) {
    var freeAreas, segmentsToSplit;
    if (dependenciesToResolve.array.length == 0) return;
    freeAreas = $findFreeAreas(segments, criticalConflictThreshold);
    segmentsToSplit = $decideWhichSegmentsToSplit(dependenciesToResolve);
    $forEach_3($sorted_1(new StreamImpl(null, new Spliterators$IteratorSpliterator(segmentsToSplit, 1)), new HyperEdgeSegmentSplitter$lambda$0$Type), new HyperEdgeSegmentSplitter$lambda$1$Type(this$static, segments, freeAreas, criticalConflictThreshold));
}
function $updateConsideringBothOrderings(rating, s1, s2) {
    var crossingsS1LeftOfS2, crossingsS2LeftOfS1;
    crossingsS1LeftOfS2 = countCrossings(s1.outgoingConnectionCoordinates, s2.startPosition, s2.endPosition) + countCrossings(s2.incomingConnectionCoordinates, s1.startPosition, s1.endPosition);
    crossingsS2LeftOfS1 = countCrossings(s2.outgoingConnectionCoordinates, s1.startPosition, s1.endPosition) + countCrossings(s1.incomingConnectionCoordinates, s2.startPosition, s2.endPosition);
    if (crossingsS1LeftOfS2 == crossingsS2LeftOfS1) {
        if (crossingsS1LeftOfS2 > 0) {
            rating.dependencies += 2;
            rating.crossings += crossingsS1LeftOfS2;
        }
    } else {
        rating.dependencies += 1;
        rating.crossings += $wnd.Math.min(crossingsS1LeftOfS2, crossingsS2LeftOfS1);
    }
}
function $updateDependencies(this$static, segment, segments) {
    var otherSegment, otherSegment$iterator, splitCausingSegment, splitPartner;
    splitCausingSegment = segment.splitBy;
    splitPartner = segment.splitPartner;
    new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL), segment, splitCausingSegment, 1);
    new HyperEdgeSegmentDependency(CRITICAL, splitCausingSegment, splitPartner, 1);
    for(otherSegment$iterator = new ArrayList$1(segments); otherSegment$iterator.i < otherSegment$iterator.this$01.array.length;){
        otherSegment = castTo($next_6(otherSegment$iterator), 116);
        if (otherSegment != splitCausingSegment && otherSegment != segment && otherSegment != splitPartner) {
            $createDependencyIfNecessary(this$static.routingGenerator, otherSegment, segment);
            $createDependencyIfNecessary(this$static.routingGenerator, otherSegment, splitPartner);
        }
    }
}
function $useArea(freeAreas, usedAreaIndex, criticalConflictThreshold) {
    var insertIndex, newArea1, newArea2, newEnd1, newStart2, oldArea, oldAreaCentre;
    oldArea = (checkCriticalElementIndex(usedAreaIndex, freeAreas.array.length), castTo(freeAreas.array[usedAreaIndex], 335));
    $remove_11(freeAreas, usedAreaIndex);
    if (oldArea.size_0 / 2 >= criticalConflictThreshold) {
        insertIndex = usedAreaIndex;
        oldAreaCentre = (oldArea.startPosition + oldArea.endPosition) / 2;
        newEnd1 = oldAreaCentre - criticalConflictThreshold;
        if (oldArea.startPosition <= oldAreaCentre - criticalConflictThreshold) {
            newArea1 = new HyperEdgeSegmentSplitter$FreeArea(oldArea.startPosition, newEnd1);
            $add_2(freeAreas, insertIndex++, newArea1);
        }
        newStart2 = oldAreaCentre + criticalConflictThreshold;
        if (newStart2 <= oldArea.endPosition) {
            newArea2 = new HyperEdgeSegmentSplitter$FreeArea(newStart2, oldArea.endPosition);
            checkCriticalPositionIndex(insertIndex, freeAreas.array.length);
            insertTo(freeAreas.array, insertIndex, newArea2);
        }
    }
}
function HyperEdgeSegmentSplitter(routingGenerator) {
    this.routingGenerator = routingGenerator;
}
function center_0(a) {
    return (a.startPosition + a.endPosition) / 2;
}
function lambda$0_31(hes1_0, hes2_1) {
    return compare_4(hes1_0.endPosition - hes1_0.startPosition, hes2_1.endPosition - hes2_1.startPosition);
}
defineClass(1824, 1, {}, HyperEdgeSegmentSplitter);
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter', 1824);
function HyperEdgeSegmentSplitter$AreaRating() {
    this.dependencies = 0;
    this.crossings = 0;
}
defineClass(1825, 1, {}, HyperEdgeSegmentSplitter$AreaRating);
_.crossings = 0;
_.dependencies = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$AreaRating_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/AreaRating', 1825);
function HyperEdgeSegmentSplitter$FreeArea(startPosition, endPosition) {
    this.startPosition = startPosition;
    this.endPosition = endPosition;
    this.size_0 = endPosition - startPosition;
}
defineClass(335, 1, {
    335: 1
}, HyperEdgeSegmentSplitter$FreeArea);
_.endPosition = 0;
_.size_0 = 0;
_.startPosition = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$FreeArea_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/FreeArea', 335);
function HyperEdgeSegmentSplitter$lambda$0$Type() {}
defineClass(1826, 1, $intern_88, HyperEdgeSegmentSplitter$lambda$0$Type);
_.compare_1 = function compare_74(arg0, arg1) {
    return lambda$0_31(castTo(arg0, 116), castTo(arg1, 116));
};
_.equals_0 = function equals_161(other) {
    return this === other;
};
_.reversed = function reversed_66() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/lambda$0$Type', 1826);
function HyperEdgeSegmentSplitter$lambda$1$Type($$outer_0, segments_1, freeAreas_2, criticalConflictThreshold_3) {
    this.$$outer_0 = $$outer_0;
    this.segments_1 = segments_1;
    this.freeAreas_2 = freeAreas_2;
    this.criticalConflictThreshold_3 = criticalConflictThreshold_3;
}
defineClass(1827, 1, $intern_19, HyperEdgeSegmentSplitter$lambda$1$Type);
_.accept = function accept_128(arg0) {
    $lambda$1_6(this.$$outer_0, this.segments_1, this.freeAreas_2, this.criticalConflictThreshold_3, castTo(arg0, 116));
};
_.criticalConflictThreshold_3 = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/lambda$1$Type', 1827);
function HyperEdgeSegmentSplitter$lambda$2$Type() {}
defineClass(1828, 1, {}, HyperEdgeSegmentSplitter$lambda$2$Type);
_.apply_0 = function apply_125(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 116).incomingConnectionCoordinates, 16));
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/lambda$2$Type', 1828);
function HyperEdgeSegmentSplitter$lambda$3$Type() {}
defineClass(1829, 1, {}, HyperEdgeSegmentSplitter$lambda$3$Type);
_.apply_0 = function apply_126(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 116).outgoingConnectionCoordinates, 16));
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/lambda$3$Type', 1829);
function HyperEdgeSegmentSplitter$lambda$4$Type() {}
defineClass(1830, 1, {}, HyperEdgeSegmentSplitter$lambda$4$Type);
_.applyAsDouble = function applyAsDouble_3(arg0) {
    return $doubleValue(castToDouble(arg0));
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_HyperEdgeSegmentSplitter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'HyperEdgeSegmentSplitter/lambda$4$Type', 1830);
function $countConflicts(this$static, posis1, posis2) {
    var conflicts, hasMore, iter1, iter2, pos1, pos2;
    conflicts = 0;
    if (posis1.size_0 != 0 && posis2.size_0 != 0) {
        iter1 = $listIterator_2(posis1, 0);
        iter2 = $listIterator_2(posis2, 0);
        pos1 = $doubleValue(castToDouble($next_9(iter1)));
        pos2 = $doubleValue(castToDouble($next_9(iter2)));
        hasMore = true;
        do {
            if (pos1 > pos2 - this$static.criticalConflictThreshold && pos1 < pos2 + this$static.criticalConflictThreshold) return -1;
            else pos1 > pos2 - this$static.conflictThreshold && pos1 < pos2 + this$static.conflictThreshold && ++conflicts;
            pos1 <= pos2 && iter1.currentNode != iter1.this$01.tail ? pos1 = $doubleValue(castToDouble($next_9(iter1))) : pos2 <= pos1 && iter2.currentNode != iter2.this$01.tail ? pos2 = $doubleValue(castToDouble($next_9(iter2))) : hasMore = false;
        }while (hasMore);
    }
    return conflicts;
}
function $createDependencyIfNecessary(this$static, he1, he2) {
    var conflicts1, conflicts2, criticalConflictsDetected, criticalDependencyCount, crossings1, crossings2, depValue1, depValue2;
    if ($wnd.Math.abs(he1.startPosition - he1.endPosition) < $intern_97 || $wnd.Math.abs(he2.startPosition - he2.endPosition) < $intern_97) return 0;
    conflicts1 = $countConflicts(this$static, he1.outgoingConnectionCoordinates, he2.incomingConnectionCoordinates);
    conflicts2 = $countConflicts(this$static, he2.outgoingConnectionCoordinates, he1.incomingConnectionCoordinates);
    criticalConflictsDetected = conflicts1 == -1 || conflicts2 == -1;
    criticalDependencyCount = 0;
    if (criticalConflictsDetected) {
        if (conflicts1 == -1) {
            new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL), he2, he1, 1);
            ++criticalDependencyCount;
        }
        if (conflicts2 == -1) {
            new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), CRITICAL), he1, he2, 1);
            ++criticalDependencyCount;
        }
    } else {
        crossings1 = countCrossings(he1.outgoingConnectionCoordinates, he2.startPosition, he2.endPosition);
        crossings1 += countCrossings(he2.incomingConnectionCoordinates, he1.startPosition, he1.endPosition);
        crossings2 = countCrossings(he2.outgoingConnectionCoordinates, he1.startPosition, he1.endPosition);
        crossings2 += countCrossings(he1.incomingConnectionCoordinates, he2.startPosition, he2.endPosition);
        depValue1 = conflicts1 + 16 * crossings1;
        depValue2 = conflicts2 + 16 * crossings2;
        if (depValue1 < depValue2) new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), REGULAR), he1, he2, depValue2 - depValue1);
        else if (depValue1 > depValue2) new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), REGULAR), he2, he1, depValue1 - depValue2);
        else if (depValue1 > 0 && depValue2 > 0) {
            new HyperEdgeSegmentDependency(($clinit_HyperEdgeSegmentDependency$DependencyType(), REGULAR), he1, he2, 0);
            new HyperEdgeSegmentDependency(REGULAR, he2, he1, 0);
        }
    }
    return criticalDependencyCount;
}
function $createHyperEdgeSegments(this$static, nodes, portSide, hyperEdges, portToHyperEdgeSegmentMap) {
    var hyperEdge, node, node$iterator, port, port$iterator;
    if (nodes) for(node$iterator = nodes.iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 9);
        for(port$iterator = $getPorts_0(node, ($clinit_PortType(), OUTPUT), portSide).iterator_0(); port$iterator.hasNext_0();){
            port = castTo(port$iterator.next_1(), 11);
            hyperEdge = castTo(getEntryValueOrNull($getEntry_0(portToHyperEdgeSegmentMap.hashCodeMap, port)), 116);
            if (!hyperEdge) {
                hyperEdge = new HyperEdgeSegment(this$static.routingStrategy);
                push_1(hyperEdges.array, hyperEdge);
                $addPortPositions(hyperEdge, port, portToHyperEdgeSegmentMap);
            }
        }
    }
}
function $minimumDifference(numberStream) {
    var currentNumber, iter, minDifference, numbers, previousNumber;
    numbers = castTo($collect_1($distinct($sorted_0(numberStream)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    minDifference = $intern_113;
    if (numbers.size_1() >= 2) {
        iter = numbers.iterator_0();
        currentNumber = castToDouble(iter.next_1());
        while(iter.hasNext_0()){
            previousNumber = currentNumber;
            currentNumber = castToDouble(iter.next_1());
            minDifference = $wnd.Math.min(minDifference, (checkCriticalNotNull(currentNumber), currentNumber) - (checkCriticalNotNull(previousNumber), previousNumber));
        }
    }
    return minDifference;
}
function $routeEdges_0(this$static, layeredGraph, sourceLayerNodes, targetLayerNodes, startPos) {
    var criticalDependencyCount, edgeSegments, firstIdx, firstSegment, node, node$iterator, portToEdgeSegmentMap, random, rankCount, secondIdx, minIncomingDistance, minOutgoingDistance, cycleDependencies;
    portToEdgeSegmentMap = new HashMap;
    edgeSegments = new ArrayList;
    $createHyperEdgeSegments(this$static, sourceLayerNodes, this$static.routingStrategy.getSourcePortSide(), edgeSegments, portToEdgeSegmentMap);
    $createHyperEdgeSegments(this$static, targetLayerNodes, this$static.routingStrategy.getTargetPortSide(), edgeSegments, portToEdgeSegmentMap);
    this$static.criticalConflictThreshold = 0.2 * (minIncomingDistance = $minimumDifference($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(edgeSegments, 16)), new OrthogonalRoutingGenerator$lambda$0$Type)), minOutgoingDistance = $minimumDifference($flatMap(new StreamImpl(null, new Spliterators$IteratorSpliterator(edgeSegments, 16)), new OrthogonalRoutingGenerator$lambda$1$Type)), $wnd.Math.min(minIncomingDistance, minOutgoingDistance));
    criticalDependencyCount = 0;
    for(firstIdx = 0; firstIdx < edgeSegments.array.length - 1; firstIdx++){
        firstSegment = (checkCriticalElementIndex(firstIdx, edgeSegments.array.length), castTo(edgeSegments.array[firstIdx], 116));
        for(secondIdx = firstIdx + 1; secondIdx < edgeSegments.array.length; secondIdx++)criticalDependencyCount += $createDependencyIfNecessary(this$static, firstSegment, (checkCriticalElementIndex(secondIdx, edgeSegments.array.length), castTo(edgeSegments.array[secondIdx], 116)));
    }
    random = castTo($getProperty(layeredGraph, ($clinit_InternalProperties_1(), RANDOM_0)), 233);
    criticalDependencyCount >= 2 && (cycleDependencies = detectCycles(edgeSegments, true, random), !this$static.segmentSplitter && (this$static.segmentSplitter = new HyperEdgeSegmentSplitter(this$static)), $splitSegments(this$static.segmentSplitter, cycleDependencies, edgeSegments, this$static.criticalConflictThreshold), undefined);
    breakNonCriticalCycles(edgeSegments, random);
    topologicalNumbering(edgeSegments);
    rankCount = -1;
    for(node$iterator = new ArrayList$1(edgeSegments); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 116);
        if ($wnd.Math.abs(node.startPosition - node.endPosition) < $intern_97) continue;
        rankCount = $wnd.Math.max(rankCount, node.routingSlot);
        this$static.routingStrategy.calculateBendPoints(node, startPos, this$static.edgeSpacing);
    }
    this$static.routingStrategy.createdJunctionPoints.map_0.clear_0();
    return rankCount + 1;
}
function OrthogonalRoutingGenerator(direction, edgeSpacing) {
    this.routingStrategy = forRoutingDirection(direction);
    this.edgeSpacing = edgeSpacing;
    this.conflictThreshold = 0.5 * edgeSpacing;
}
function breakNonCriticalCycles(edgeSegments, random) {
    var cycleDependencies, cycleDependency, cycleDependency$iterator, oldSource, oldTarget;
    cycleDependencies = detectCycles(edgeSegments, false, random);
    for(cycleDependency$iterator = new ArrayList$1(cycleDependencies); cycleDependency$iterator.i < cycleDependency$iterator.this$01.array.length;){
        cycleDependency = castTo($next_6(cycleDependency$iterator), 133);
        cycleDependency.weight == 0 ? ($setSource_1(cycleDependency, null), $setTarget_1(cycleDependency, null)) : (oldSource = cycleDependency.source, oldTarget = cycleDependency.target, $setSource_1(cycleDependency, oldTarget), $setTarget_1(cycleDependency, oldSource), undefined);
    }
}
function countCrossings(posis, start_0, end) {
    var crossings, pos, pos$iterator;
    crossings = 0;
    for(pos$iterator = $listIterator_2(posis, 0); pos$iterator.currentNode != pos$iterator.this$01.tail;){
        pos = $doubleValue(castToDouble($next_9(pos$iterator)));
        if (pos > end) break;
        else pos >= start_0 && ++crossings;
    }
    return crossings;
}
function topologicalNumbering(segments) {
    var dep, dep$iterator, maxRank, node, node$iterator, node$iterator0, rightwardTargets, source, sources, target;
    sources = new ArrayList;
    rightwardTargets = new ArrayList;
    for(node$iterator0 = new ArrayList$1(segments); node$iterator0.i < node$iterator0.this$01.array.length;){
        node = castTo($next_6(node$iterator0), 116);
        $setInWeight(node, node.incomingSegmentDependencies.array.length);
        $setOutWeight(node, node.outgoingSegmentDependencies.array.length);
        node.inDepWeight == 0 && push_1(sources.array, node);
        node.outDepWeight == 0 && node.incomingConnectionCoordinates.size_0 == 0 && push_1(rightwardTargets.array, node);
    }
    maxRank = -1;
    while(sources.array.length != 0){
        node = castTo($remove_11(sources, 0), 116);
        for(dep$iterator = new ArrayList$1(node.outgoingSegmentDependencies); dep$iterator.i < dep$iterator.this$01.array.length;){
            dep = castTo($next_6(dep$iterator), 133);
            target = dep.target;
            $setRoutingSlot_0(target, $wnd.Math.max(target.routingSlot, node.routingSlot + 1));
            maxRank = $wnd.Math.max(maxRank, target.routingSlot);
            $setInWeight(target, target.inDepWeight - 1);
            target.inDepWeight == 0 && push_1(sources.array, target);
        }
    }
    if (maxRank > -1) {
        for(node$iterator = new ArrayList$1(rightwardTargets); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 116);
            node.routingSlot = maxRank;
        }
        while(rightwardTargets.array.length != 0){
            node = castTo($remove_11(rightwardTargets, 0), 116);
            for(dep$iterator = new ArrayList$1(node.incomingSegmentDependencies); dep$iterator.i < dep$iterator.this$01.array.length;){
                dep = castTo($next_6(dep$iterator), 133);
                source = dep.source;
                if (source.incomingConnectionCoordinates.size_0 > 0) continue;
                $setRoutingSlot_0(source, $wnd.Math.min(source.routingSlot, node.routingSlot - 1));
                $setOutWeight(source, source.outDepWeight - 1);
                source.outDepWeight == 0 && push_1(rightwardTargets.array, source);
            }
        }
    }
}
defineClass(648, 1, {}, OrthogonalRoutingGenerator);
_.conflictThreshold = 0;
_.criticalConflictThreshold = 0;
_.edgeSpacing = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_OrthogonalRoutingGenerator_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'OrthogonalRoutingGenerator', 648);
function OrthogonalRoutingGenerator$lambda$0$Type() {}
defineClass(1644, 1, {}, OrthogonalRoutingGenerator$lambda$0$Type);
_.apply_0 = function apply_127(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 116).incomingConnectionCoordinates, 16));
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_OrthogonalRoutingGenerator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'OrthogonalRoutingGenerator/lambda$0$Type', 1644);
function OrthogonalRoutingGenerator$lambda$1$Type() {}
defineClass(1645, 1, {}, OrthogonalRoutingGenerator$lambda$1$Type);
_.apply_0 = function apply_128(arg0) {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(castTo(arg0, 116).outgoingConnectionCoordinates, 16));
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_OrthogonalRoutingGenerator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal', 'OrthogonalRoutingGenerator/lambda$1$Type', 1645);
function $addJunctionPointIfNecessary(this$static, edge, segment, pos, vertical) {
    var jpoint, junctionPoints, p, pointAtSegmentBoundary, pointInsideEdgeSegment;
    p = vertical ? pos.y_0 : pos.x_0;
    if ($contains_6(this$static.createdJunctionPoints, pos)) return;
    pointInsideEdgeSegment = p > segment.startPosition && p < segment.endPosition;
    pointAtSegmentBoundary = false;
    if (segment.incomingConnectionCoordinates.size_0 != 0 && segment.outgoingConnectionCoordinates.size_0 != 0) {
        pointAtSegmentBoundary = pointAtSegmentBoundary | ($wnd.Math.abs(p - $doubleValue(castToDouble($getFirst(segment.incomingConnectionCoordinates)))) < $intern_97 && $wnd.Math.abs(p - $doubleValue(castToDouble($getFirst(segment.outgoingConnectionCoordinates)))) < $intern_97);
        pointAtSegmentBoundary = pointAtSegmentBoundary | ($wnd.Math.abs(p - $doubleValue(castToDouble($getLast(segment.incomingConnectionCoordinates)))) < $intern_97 && $wnd.Math.abs(p - $doubleValue(castToDouble($getLast(segment.outgoingConnectionCoordinates)))) < $intern_97);
    }
    if (pointInsideEdgeSegment || pointAtSegmentBoundary) {
        junctionPoints = castTo($getProperty(edge, ($clinit_LayeredOptions(), JUNCTION_POINTS)), 77);
        if (!junctionPoints) {
            junctionPoints = new KVectorChain;
            $setProperty_0(edge, JUNCTION_POINTS, junctionPoints);
        }
        jpoint = new KVector_2(pos);
        $addNode_0(junctionPoints, jpoint, junctionPoints.tail.prev, junctionPoints.tail);
        $add_6(this$static.createdJunctionPoints, jpoint);
    }
}
function BaseRoutingDirectionStrategy() {
    this.createdJunctionPoints = new HashSet;
}
function forRoutingDirection(direction) {
    switch(direction){
        case 0:
            return new WestToEastRoutingStrategy;
        case 1:
            return new NorthToSouthRoutingStrategy;
        case 2:
            return new SouthToNorthRoutingStrategy;
        default:
            throw toJs(new IllegalArgumentException);
    }
}
defineClass(655, 1, {});
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_direction_BaseRoutingDirectionStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal.direction', 'BaseRoutingDirectionStrategy', 655);
function NorthToSouthRoutingStrategy() {
    BaseRoutingDirectionStrategy.call(this);
}
defineClass(1816, 655, {}, NorthToSouthRoutingStrategy);
_.calculateBendPoints = function calculateBendPoints(segment, startPos, edgeSpacing) {
    var bend, currentSegment, currentY, edge, edge$iterator, port, port$iterator, segmentY, sourceX, splitPartner, splitX, target, targetX;
    if (!!segment.splitPartner && !segment.splitBy) return;
    segmentY = startPos + segment.routingSlot * edgeSpacing;
    for(port$iterator = new ArrayList$1(segment.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        sourceX = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).x_0;
        for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            if (!$isSelfLoop(edge)) {
                target = edge.target;
                targetX = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    target.owner.pos,
                    target.pos,
                    target.anchor
                ])).x_0;
                if ($wnd.Math.abs(sourceX - targetX) > $intern_97) {
                    currentY = segmentY;
                    currentSegment = segment;
                    bend = new KVector_1(sourceX, currentY);
                    $add_7(edge.bendPoints, bend);
                    $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                    splitPartner = segment.splitPartner;
                    if (splitPartner) {
                        splitX = $doubleValue(castToDouble($get_7(splitPartner.incomingConnectionCoordinates, 0)));
                        bend = new KVector_1(splitX, currentY);
                        $add_7(edge.bendPoints, bend);
                        $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                        currentY = startPos + splitPartner.routingSlot * edgeSpacing;
                        currentSegment = splitPartner;
                        bend = new KVector_1(splitX, currentY);
                        $add_7(edge.bendPoints, bend);
                        $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                    }
                    bend = new KVector_1(targetX, currentY);
                    $add_7(edge.bendPoints, bend);
                    $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                }
            }
        }
    }
};
_.getPortPositionOnHyperNode = function getPortPositionOnHyperNode(port) {
    return port.owner.pos.x_0 + port.pos.x_0 + port.anchor.x_0;
};
_.getSourcePortSide = function getSourcePortSide() {
    return $clinit_PortSide(), SOUTH_0;
};
_.getTargetPortSide = function getTargetPortSide() {
    return $clinit_PortSide(), NORTH_1;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_direction_NorthToSouthRoutingStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal.direction', 'NorthToSouthRoutingStrategy', 1816);
function SouthToNorthRoutingStrategy() {
    BaseRoutingDirectionStrategy.call(this);
}
defineClass(1817, 655, {}, SouthToNorthRoutingStrategy);
_.calculateBendPoints = function calculateBendPoints_0(segment, startPos, edgeSpacing) {
    var bend, currentSegment, currentY, edge, edge$iterator, port, port$iterator, segmentY, sourceX, splitPartner, splitX, target, targetX;
    if (!!segment.splitPartner && !segment.splitBy) return;
    segmentY = startPos - segment.routingSlot * edgeSpacing;
    for(port$iterator = new ArrayList$1(segment.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        sourceX = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).x_0;
        for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            if (!$isSelfLoop(edge)) {
                target = edge.target;
                targetX = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    target.owner.pos,
                    target.pos,
                    target.anchor
                ])).x_0;
                if ($wnd.Math.abs(sourceX - targetX) > $intern_97) {
                    currentY = segmentY;
                    currentSegment = segment;
                    bend = new KVector_1(sourceX, currentY);
                    $add_7(edge.bendPoints, bend);
                    $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                    splitPartner = segment.splitPartner;
                    if (splitPartner) {
                        splitX = $doubleValue(castToDouble($get_7(splitPartner.incomingConnectionCoordinates, 0)));
                        bend = new KVector_1(splitX, currentY);
                        $add_7(edge.bendPoints, bend);
                        $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                        currentY = startPos - splitPartner.routingSlot * edgeSpacing;
                        currentSegment = splitPartner;
                        bend = new KVector_1(splitX, currentY);
                        $add_7(edge.bendPoints, bend);
                        $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                    }
                    bend = new KVector_1(targetX, currentY);
                    $add_7(edge.bendPoints, bend);
                    $addJunctionPointIfNecessary(this, edge, currentSegment, bend, false);
                }
            }
        }
    }
};
_.getPortPositionOnHyperNode = function getPortPositionOnHyperNode_0(port) {
    return port.owner.pos.x_0 + port.pos.x_0 + port.anchor.x_0;
};
_.getSourcePortSide = function getSourcePortSide_0() {
    return $clinit_PortSide(), NORTH_1;
};
_.getTargetPortSide = function getTargetPortSide_0() {
    return $clinit_PortSide(), SOUTH_0;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_direction_SouthToNorthRoutingStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal.direction', 'SouthToNorthRoutingStrategy', 1817);
function WestToEastRoutingStrategy() {
    BaseRoutingDirectionStrategy.call(this);
}
defineClass(1815, 655, {}, WestToEastRoutingStrategy);
_.calculateBendPoints = function calculateBendPoints_1(segment, startPos, edgeSpacing) {
    var bend, currentSegment, currentX, edge, edge$iterator, port, port$iterator, segmentX, sourceY, splitPartner, splitY, target, targetY;
    if (!!segment.splitPartner && !segment.splitBy) return;
    segmentX = startPos + segment.routingSlot * edgeSpacing;
    for(port$iterator = new ArrayList$1(segment.ports); port$iterator.i < port$iterator.this$01.array.length;){
        port = castTo($next_6(port$iterator), 11);
        sourceY = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).y_0;
        for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
            edge = castTo($next_6(edge$iterator), 18);
            if (!$isSelfLoop(edge)) {
                target = edge.target;
                targetY = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    target.owner.pos,
                    target.pos,
                    target.anchor
                ])).y_0;
                if ($wnd.Math.abs(sourceY - targetY) > $intern_97) {
                    currentX = segmentX;
                    currentSegment = segment;
                    bend = new KVector_1(currentX, sourceY);
                    $add_7(edge.bendPoints, bend);
                    $addJunctionPointIfNecessary(this, edge, currentSegment, bend, true);
                    splitPartner = segment.splitPartner;
                    if (splitPartner) {
                        splitY = $doubleValue(castToDouble($get_7(splitPartner.incomingConnectionCoordinates, 0)));
                        bend = new KVector_1(currentX, splitY);
                        $add_7(edge.bendPoints, bend);
                        $addJunctionPointIfNecessary(this, edge, currentSegment, bend, true);
                        currentX = startPos + splitPartner.routingSlot * edgeSpacing;
                        currentSegment = splitPartner;
                        bend = new KVector_1(currentX, splitY);
                        $add_7(edge.bendPoints, bend);
                        $addJunctionPointIfNecessary(this, edge, currentSegment, bend, true);
                    }
                    bend = new KVector_1(currentX, targetY);
                    $add_7(edge.bendPoints, bend);
                    $addJunctionPointIfNecessary(this, edge, currentSegment, bend, true);
                }
            }
        }
    }
};
_.getPortPositionOnHyperNode = function getPortPositionOnHyperNode_1(port) {
    return port.owner.pos.y_0 + port.pos.y_0 + port.anchor.y_0;
};
_.getSourcePortSide = function getSourcePortSide_1() {
    return $clinit_PortSide(), EAST_0;
};
_.getTargetPortSide = function getTargetPortSide_1() {
    return $clinit_PortSide(), WEST_0;
};
var Lorg_eclipse_elk_alg_layered_p5edges_orthogonal_direction_WestToEastRoutingStrategy_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.orthogonal.direction', 'WestToEastRoutingStrategy', 1815);
function $createUniformKnotVector(this$static, size_0) {
    var fraction, i, i0, i1, mySize;
    if (size_0 < 2 * this$static.dimNUBS) throw toJs(new IllegalArgumentException_0('The knot vector must have at least two time the dimension elements.'));
    this$static.maxKnot = 1;
    for(i0 = 0; i0 < this$static.dimNUBS; i0++)$add_3(this$static.knotVector, 0);
    mySize = size_0 + 1 - 2 * this$static.dimNUBS;
    fraction = mySize;
    for(i1 = 1; i1 < mySize; i1++)$add_3(this$static.knotVector, i1 / fraction);
    if (this$static.isClamped) for(i = 0; i < this$static.dimNUBS; i++)$add_3(this$static.knotVector, 1);
}
function $getBezierCP(this$static) {
    var iter, retVal;
    this$static.isBezier || $toBezier(this$static);
    retVal = new KVectorChain;
    iter = new ArrayList$1(this$static.controlPoints);
    $next_6(iter);
    while(iter.i < iter.this$01.array.length)$add_7(retVal, castTo($next_6(iter), 407).cp);
    checkCriticalElement(retVal.size_0 != 0);
    $removeNode_0(retVal, retVal.tail.prev);
    return retVal;
}
function $getMultiplicity(this$static, knotToCheck) {
    var count, currentKnot, diff, iter;
    iter = new AbstractList$ListIteratorImpl(this$static.knotVector, 0);
    count = 0;
    while(iter.i < iter.this$01_0.size_1()){
        currentKnot = $doubleValue((checkCriticalElement(iter.i < iter.this$01_0.size_1()), castToDouble(iter.this$01_0.get_0(iter.last = iter.i++))));
        diff = currentKnot - knotToCheck;
        if (diff > $intern_116) return count;
        else diff > -0.000001 && ++count;
    }
    return count;
}
function $insertKnotAtCurrentPosition(this$static, insertions, knotToInsert, iterCP, iterKnot) {
    var cp, cp$iterator, firstCP, i, j, j0, j1, multiplicity, newCPs, secondCP;
    multiplicity = $getMultiplicity(this$static, knotToInsert);
    for(i = 0; i < insertions; i++){
        $add_1(iterKnot, knotToInsert);
        newCPs = new ArrayList;
        secondCP = (checkCriticalElement(iterCP.i < iterCP.this$01_0.size_1()), castTo(iterCP.this$01_0.get_0(iterCP.last = iterCP.i++), 407));
        for(j0 = multiplicity + i; j0 < this$static.dimNUBS; j0++){
            firstCP = secondCP;
            secondCP = (checkCriticalElement(iterCP.i < iterCP.this$01_0.size_1()), castTo(iterCP.this$01_0.get_0(iterCP.last = iterCP.i++), 407));
            $add_3(newCPs, new NubSpline$PolarCP(firstCP, secondCP, knotToInsert));
        }
        for(j1 = multiplicity + i; j1 < this$static.dimNUBS; j1++){
            checkCriticalElement(iterCP.i > 0);
            iterCP.this$01.get_0(iterCP.last = --iterCP.i);
            j1 > multiplicity + i && $remove_8(iterCP);
        }
        for(cp$iterator = new ArrayList$1(newCPs); cp$iterator.i < cp$iterator.this$01.array.length;){
            cp = castTo($next_6(cp$iterator), 407);
            $add_1(iterCP, cp);
        }
        if (i < insertions - 1) for(j = multiplicity + i; j < this$static.dimNUBS; j++){
            checkCriticalElement(iterCP.i > 0);
            iterCP.this$01.get_0(iterCP.last = --iterCP.i);
        }
    }
}
function $toBezier(this$static) {
    var currentKnot, i, iterCP, iterKnot, knotToCount, occurrence;
    iterKnot = new AbstractList$ListIteratorImpl(this$static.knotVector, 0);
    iterCP = new AbstractList$ListIteratorImpl(this$static.controlPoints, 0);
    if (this$static.isClamped) for(i = 0; i < this$static.dimNUBS; i++){
        checkCriticalElement(iterKnot.i < iterKnot.this$01_0.size_1());
        iterKnot.this$01_0.get_0(iterKnot.last = iterKnot.i++);
    }
    else for(i = 0; i < this$static.dimNUBS - 1; i++){
        checkCriticalElement(iterKnot.i < iterKnot.this$01_0.size_1());
        iterKnot.this$01_0.get_0(iterKnot.last = iterKnot.i++);
        $remove_8(iterKnot);
    }
    currentKnot = $doubleValue((checkCriticalElement(iterKnot.i < iterKnot.this$01_0.size_1()), castToDouble(iterKnot.this$01_0.get_0(iterKnot.last = iterKnot.i++))));
    while(this$static.maxKnot - currentKnot > $intern_116){
        knotToCount = currentKnot;
        occurrence = 0;
        while($wnd.Math.abs(currentKnot - knotToCount) < $intern_116){
            ++occurrence;
            currentKnot = $doubleValue((checkCriticalElement(iterKnot.i < iterKnot.this$01_0.size_1()), castToDouble(iterKnot.this$01_0.get_0(iterKnot.last = iterKnot.i++))));
            checkCriticalElement(iterCP.i < iterCP.this$01_0.size_1());
            iterCP.this$01_0.get_0(iterCP.last = iterCP.i++);
        }
        if (occurrence < this$static.dimNUBS) {
            checkCriticalElement(iterKnot.i > 0);
            iterKnot.this$01.get_0(iterKnot.last = --iterKnot.i);
            $insertKnotAtCurrentPosition(this$static, this$static.dimNUBS - occurrence, knotToCount, iterCP, iterKnot);
            checkCriticalElement(iterKnot.i < iterKnot.this$01_0.size_1());
            iterKnot.this$01_0.get_0(iterKnot.last = iterKnot.i++);
        }
        checkCriticalElement(iterCP.i > 0);
        iterCP.this$01.get_0(iterCP.last = --iterCP.i);
    }
    if (!this$static.isClamped) for(i = 0; i < this$static.dimNUBS - 1; i++){
        checkCriticalElement(iterKnot.i < iterKnot.this$01_0.size_1());
        iterKnot.this$01_0.get_0(iterKnot.last = iterKnot.i++);
        $remove_8(iterKnot);
    }
    this$static.isClamped = true;
    this$static.isBezier = true;
}
function NubSpline(kVectors) {
    var i, i0, kVector, kVector$iterator, knotIter, polarCoordinate;
    this.knotVector = new ArrayList;
    this.controlPoints = new ArrayList;
    for(i0 = kVectors.size_0 - 1; i0 < 3; i0++)$add_0(kVectors, 0, castTo($get_7(kVectors, 0), 8));
    if (kVectors.size_0 < 4) throw toJs(new IllegalArgumentException_0('At (least dimension + 1) control points are necessary!'));
    else {
        this.dimNUBS = 3;
        this.isClamped = true;
        this.isBezier = false;
        $createUniformKnotVector(this, kVectors.size_0 + this.dimNUBS - 1);
        polarCoordinate = new ArrayList;
        knotIter = new ArrayList$1(this.knotVector);
        for(i = 0; i < this.dimNUBS - 1; i++)$add_3(polarCoordinate, castToDouble($next_6(knotIter)));
        for(kVector$iterator = $listIterator_2(kVectors, 0); kVector$iterator.currentNode != kVector$iterator.this$01.tail;){
            kVector = castTo($next_9(kVector$iterator), 8);
            $add_3(polarCoordinate, castToDouble($next_6(knotIter)));
            $add_3(this.controlPoints, new NubSpline$PolarCP_0(kVector, polarCoordinate));
            checkCriticalElementIndex(0, polarCoordinate.array.length);
            polarCoordinate.array.splice(0, 1);
        }
    }
}
defineClass(807, 1, {}, NubSpline);
_.toString_0 = function toString_104() {
    return $toString_2(this.controlPoints);
};
_.dimNUBS = 0;
_.isBezier = false;
_.isClamped = false;
_.maxKnot = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_splines_NubSpline_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'NubSpline', 807);
function $setCp(this$static, cp) {
    this$static.cp = cp;
}
function $setPolarCoordinate(this$static, polarCoordinate) {
    this$static.polarCoordinate = polarCoordinate;
}
function NubSpline$PolarCP(firstCP, secondCP, newKnot) {
    var aScaled, bScaled, firstFactor, iter, needsToBeAdded, nextKnot, secondFactor, total;
    firstFactor = $doubleValue(castToDouble(firstCP.polarCoordinate.iterator_0().next_1()));
    secondFactor = $doubleValue(castToDouble(getLast(secondCP.polarCoordinate)));
    aScaled = $scale($clone_1(firstCP.cp), secondFactor - newKnot);
    bScaled = $scale($clone_1(secondCP.cp), newKnot - firstFactor);
    total = $add_19(aScaled, bScaled);
    $scale(total, 1 / (secondFactor - firstFactor));
    this.cp = total;
    this.polarCoordinate = new ArrayList;
    needsToBeAdded = true;
    iter = firstCP.polarCoordinate.iterator_0();
    iter.next_1();
    while(iter.hasNext_0()){
        nextKnot = $doubleValue(castToDouble(iter.next_1()));
        if (needsToBeAdded && nextKnot - newKnot > $intern_116) {
            this.polarCoordinate.add_2(newKnot);
            needsToBeAdded = false;
        }
        this.polarCoordinate.add_2(nextKnot);
    }
    needsToBeAdded && this.polarCoordinate.add_2(newKnot);
}
function NubSpline$PolarCP_0(controlPoint, polarCoordinate) {
    $setCp(this, new KVector_1(controlPoint.x_0, controlPoint.y_0));
    $setPolarCoordinate(this, newLinkedList(polarCoordinate));
}
defineClass(407, 1, {
    407: 1
}, NubSpline$PolarCP, NubSpline$PolarCP_0);
var Lorg_eclipse_elk_alg_layered_p5edges_splines_NubSpline$PolarCP_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'NubSpline/PolarCP', 407);
function $clinit_SplineEdgeRouter() {
    $clinit_SplineEdgeRouter = emptyMethod;
    BASELINE_PROCESSING_ADDITIONS = $addBefore($addAfter(new LayoutProcessorConfiguration, ($clinit_LayeredPhases(), P5_EDGE_ROUTING), ($clinit_IntermediateProcessorStrategy(), FINAL_SPLINE_BENDPOINTS_CALCULATOR)), P3_NODE_ORDERING, INVERTED_PORT_PROCESSOR);
    SELF_LOOP_PROCESSING_ADDITIONS_1 = $add_17($add_17($before($addAfter($addBefore(new LayoutProcessorConfiguration, P1_CYCLE_BREAKING, SELF_LOOP_PREPROCESSOR), P5_EDGE_ROUTING, SELF_LOOP_POSTPROCESSOR), P4_NODE_PLACEMENT), SELF_LOOP_PORT_RESTORER), SELF_LOOP_ROUTER);
    CENTER_EDGE_LABEL_PROCESSING_ADDITIONS_1 = $addAfter($addBefore($addBefore($addBefore(new LayoutProcessorConfiguration, P2_LAYERING, LABEL_DUMMY_INSERTER), P4_NODE_PLACEMENT, LABEL_DUMMY_SWITCHER), P4_NODE_PLACEMENT, LABEL_SIDE_SELECTOR), P5_EDGE_ROUTING, LABEL_DUMMY_REMOVER);
    NORTH_SOUTH_PORT_PROCESSING_ADDITIONS_1 = $addBefore($addBefore(new LayoutProcessorConfiguration, P3_NODE_ORDERING, NORTH_SOUTH_PORT_PREPROCESSOR), P5_EDGE_ROUTING, NORTH_SOUTH_PORT_POSTPROCESSOR);
    END_EDGE_LABEL_PROCESSING_ADDITIONS_1 = $addAfter($addBefore($addBefore(new LayoutProcessorConfiguration, P4_NODE_PLACEMENT, LABEL_SIDE_SELECTOR), P4_NODE_PLACEMENT, END_LABEL_PREPROCESSOR), P5_EDGE_ROUTING, END_LABEL_POSTPROCESSOR);
}
function $clearThenFillMappings(this$static, leftLayer, rightLayer) {
    var edge, edge$iterator, node, node$iterator, nt, port, port$iterator, sourcePort, sourcePort$iterator, targetLayer, targetPort;
    this$static.leftPortsLayer.map_0.clear_0();
    this$static.rightPortsLayer.map_0.clear_0();
    this$static.edgesRemainingLayer.array.length = 0;
    this$static.splineSegmentsLayer.array.length = 0;
    this$static.selfLoopsLayer.map_0.clear_0();
    if (leftLayer) for(node$iterator = new ArrayList$1(leftLayer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        for(sourcePort$iterator = $getPorts_1(node, ($clinit_PortSide(), EAST_0)).iterator_0(); sourcePort$iterator.hasNext_0();){
            sourcePort = castTo(sourcePort$iterator.next_1(), 11);
            $add_6(this$static.leftPortsLayer, sourcePort);
            for(edge$iterator = new ArrayList$1(sourcePort.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if ($isSelfLoop(edge)) continue;
                $add_3(this$static.edgesRemainingLayer, edge);
                $findAndAddSuccessor(this$static, edge);
                nt = edge.source.owner.type_0;
                (nt == ($clinit_LNode$NodeType(), NORMAL) || nt == NORTH_SOUTH_PORT || nt == EXTERNAL_PORT || nt == BREAKING_POINT) && $add_3(this$static.startEdges, edge);
                targetPort = edge.target;
                targetLayer = targetPort.owner.layer;
                targetLayer == rightLayer ? $add_6(this$static.rightPortsLayer, targetPort) : targetLayer == leftLayer ? $add_6(this$static.leftPortsLayer, targetPort) : $remove_12(this$static.edgesRemainingLayer, edge);
            }
        }
    }
    if (rightLayer) for(node$iterator = new ArrayList$1(rightLayer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        for(port$iterator = new ArrayList$1(node.ports); port$iterator.i < port$iterator.this$01.array.length;){
            port = castTo($next_6(port$iterator), 11);
            for(edge$iterator = new ArrayList$1(port.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                $isSelfLoop(edge) && $add_6(this$static.selfLoopsLayer, edge);
            }
        }
        for(sourcePort$iterator = $getPorts_1(node, ($clinit_PortSide(), WEST_0)).iterator_0(); sourcePort$iterator.hasNext_0();){
            sourcePort = castTo(sourcePort$iterator.next_1(), 11);
            $add_6(this$static.rightPortsLayer, sourcePort);
            for(edge$iterator = new ArrayList$1(sourcePort.outgoingEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
                edge = castTo($next_6(edge$iterator), 18);
                if ($isSelfLoop(edge)) continue;
                $add_3(this$static.edgesRemainingLayer, edge);
                $findAndAddSuccessor(this$static, edge);
                nt = edge.source.owner.type_0;
                (nt == ($clinit_LNode$NodeType(), NORMAL) || nt == NORTH_SOUTH_PORT || nt == EXTERNAL_PORT || nt == BREAKING_POINT) && $add_3(this$static.startEdges, edge);
                targetPort = edge.target;
                targetLayer = targetPort.owner.layer;
                targetLayer == rightLayer ? $add_6(this$static.rightPortsLayer, targetPort) : targetLayer == leftLayer ? $add_6(this$static.leftPortsLayer, targetPort) : $remove_12(this$static.edgesRemainingLayer, edge);
            }
        }
    }
}
function $computeSloppySpacing(rightLayer, edgeEdgeSpacing, nodeNodeSpacing, sloppyLayerSpacingFactor) {
    var incomingEdge, incomingEdge$iterator, layerSpacing, maxCurrInputYDiff, maxVertDiff, node, node$iterator, sourcePos, targetPos;
    maxVertDiff = 0;
    for(node$iterator = new ArrayList$1(rightLayer.nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 9);
        maxCurrInputYDiff = 0;
        for(incomingEdge$iterator = new Iterators$ConcatenatedIterator(transform_2($getIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(incomingEdge$iterator);){
            incomingEdge = castTo($next_0(incomingEdge$iterator), 18);
            sourcePos = $getAbsoluteAnchor(incomingEdge.source).y_0;
            targetPos = $getAbsoluteAnchor(incomingEdge.target).y_0;
            maxCurrInputYDiff = $wnd.Math.max(maxCurrInputYDiff, $wnd.Math.abs(targetPos - sourcePos));
        }
        maxVertDiff = $wnd.Math.max(maxVertDiff, maxCurrInputYDiff);
    }
    layerSpacing = sloppyLayerSpacingFactor * $wnd.Math.min(1, edgeEdgeSpacing / nodeNodeSpacing) * maxVertDiff;
    return layerSpacing;
}
function $createDependency(edge0, edge1) {
    var edge0Counter, edge1Counter, port, port$iterator, port$iterator0, port$iterator1, port$iterator2;
    if (edge0.hyperEdgeTopYPos > edge1.hyperEdgeBottomYPos || edge1.hyperEdgeTopYPos > edge0.hyperEdgeBottomYPos) return;
    edge0Counter = 0;
    edge1Counter = 0;
    for(port$iterator0 = edge0.rightPorts.map_0.keySet_0().iterator_0(); port$iterator0.hasNext_0();){
        port = castTo(port$iterator0.next_1(), 11);
        isBetween(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).y_0, edge1.hyperEdgeTopYPos, edge1.hyperEdgeBottomYPos) && ++edge0Counter;
    }
    for(port$iterator1 = edge0.leftPorts.map_0.keySet_0().iterator_0(); port$iterator1.hasNext_0();){
        port = castTo(port$iterator1.next_1(), 11);
        isBetween(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).y_0, edge1.hyperEdgeTopYPos, edge1.hyperEdgeBottomYPos) && --edge0Counter;
    }
    for(port$iterator2 = edge1.rightPorts.map_0.keySet_0().iterator_0(); port$iterator2.hasNext_0();){
        port = castTo(port$iterator2.next_1(), 11);
        isBetween(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).y_0, edge0.hyperEdgeTopYPos, edge0.hyperEdgeBottomYPos) && ++edge1Counter;
    }
    for(port$iterator = edge1.leftPorts.map_0.keySet_0().iterator_0(); port$iterator.hasNext_0();){
        port = castTo(port$iterator.next_1(), 11);
        isBetween(sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            port.owner.pos,
            port.pos,
            port.anchor
        ])).y_0, edge0.hyperEdgeTopYPos, edge0.hyperEdgeBottomYPos) && --edge1Counter;
    }
    if (edge0Counter < edge1Counter) new SplineEdgeRouter$Dependency(edge0, edge1, edge1Counter - edge0Counter);
    else if (edge1Counter < edge0Counter) new SplineEdgeRouter$Dependency(edge1, edge0, edge0Counter - edge1Counter);
    else {
        new SplineEdgeRouter$Dependency(edge1, edge0, 0);
        new SplineEdgeRouter$Dependency(edge0, edge1, 0);
    }
}
function $createSegmentsAndComputeRanking(this$static) {
    var hyperEdge1, hyperEdge2, sourceIter, targetIter;
    $createSplineSegmentsForHyperEdges(this$static, this$static.leftPortsLayer, this$static.rightPortsLayer, ($clinit_SplineEdgeRouter$SideToProcess(), LEFT_4), true, this$static.edgesRemainingLayer, this$static.splineSegmentsLayer);
    $createSplineSegmentsForHyperEdges(this$static, this$static.leftPortsLayer, this$static.rightPortsLayer, LEFT_4, false, this$static.edgesRemainingLayer, this$static.splineSegmentsLayer);
    $createSplineSegmentsForHyperEdges(this$static, this$static.leftPortsLayer, this$static.rightPortsLayer, RIGHT_4, true, this$static.edgesRemainingLayer, this$static.splineSegmentsLayer);
    $createSplineSegmentsForHyperEdges(this$static, this$static.leftPortsLayer, this$static.rightPortsLayer, RIGHT_4, false, this$static.edgesRemainingLayer, this$static.splineSegmentsLayer);
    $createSplineSegments(this$static, this$static.edgesRemainingLayer, this$static.leftPortsLayer, this$static.rightPortsLayer, this$static.splineSegmentsLayer);
    sourceIter = new AbstractList$ListIteratorImpl(this$static.splineSegmentsLayer, 0);
    while(sourceIter.i < sourceIter.this$01_0.size_1()){
        hyperEdge1 = (checkCriticalElement(sourceIter.i < sourceIter.this$01_0.size_1()), castTo(sourceIter.this$01_0.get_0(sourceIter.last = sourceIter.i++), 132));
        targetIter = new AbstractList$ListIteratorImpl(this$static.splineSegmentsLayer, sourceIter.i);
        while(targetIter.i < targetIter.this$01_0.size_1()){
            hyperEdge2 = (checkCriticalElement(targetIter.i < targetIter.this$01_0.size_1()), castTo(targetIter.this$01_0.get_0(targetIter.last = targetIter.i++), 132));
            $createDependency(hyperEdge1, hyperEdge2);
        }
    }
    breakCycles(this$static.splineSegmentsLayer, castTo($getProperty(this$static.lGraph, ($clinit_InternalProperties_1(), RANDOM_0)), 233));
    topologicalNumbering_0(this$static.splineSegmentsLayer);
}
function $createSplineSegments(this$static, edges, leftPorts, rightPorts, hyperEdges) {
    var edge, edge$iterator, seg, sourcePort, sourceSide, targetPort, targetSide;
    for(edge$iterator = new ArrayList$1(edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 18);
        sourcePort = edge.source;
        if (leftPorts.map_0.containsKey(sourcePort)) sourceSide = ($clinit_SplineEdgeRouter$SideToProcess(), LEFT_4);
        else if (rightPorts.map_0.containsKey(sourcePort)) sourceSide = ($clinit_SplineEdgeRouter$SideToProcess(), RIGHT_4);
        else throw toJs(new IllegalArgumentException_0('Source port must be in one of the port sets.'));
        targetPort = edge.target;
        if (leftPorts.map_0.containsKey(targetPort)) targetSide = ($clinit_SplineEdgeRouter$SideToProcess(), LEFT_4);
        else if (rightPorts.map_0.containsKey(targetPort)) targetSide = ($clinit_SplineEdgeRouter$SideToProcess(), RIGHT_4);
        else throw toJs(new IllegalArgumentException_0('Target port must be in one of the port sets.'));
        seg = new SplineSegment(edge, sourceSide, targetSide);
        $put_6(this$static.edgeToSegmentMap, edge, seg);
        push_1(hyperEdges.array, seg);
    }
}
function $createSplineSegmentsForHyperEdges(this$static, leftPorts, rightPorts, sideToProcess, reversed, edgesRemaining, hyperEdges) {
    var downEdges, edge, edge$iterator, pair, pair$iterator, portsToProcess, seg, singlePort, singlePort$iterator, singlePortPosition, targetPort, targetPortPosition, upEdges;
    portsToProcess = null;
    sideToProcess == ($clinit_SplineEdgeRouter$SideToProcess(), LEFT_4) ? portsToProcess = leftPorts : sideToProcess == RIGHT_4 && (portsToProcess = rightPorts);
    for(singlePort$iterator = portsToProcess.map_0.keySet_0().iterator_0(); singlePort$iterator.hasNext_0();){
        singlePort = castTo(singlePort$iterator.next_1(), 11);
        singlePortPosition = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            singlePort.owner.pos,
            singlePort.pos,
            singlePort.anchor
        ])).y_0;
        upEdges = new HashSet;
        downEdges = new HashSet;
        for(edge$iterator = new LPort$CombineIter$1(singlePort.connectedEdges); $hasNext_3(edge$iterator.firstIterator) || $hasNext_3(edge$iterator.secondIterator);){
            edge = castTo($hasNext_3(edge$iterator.firstIterator) ? $next_6(edge$iterator.firstIterator) : $next_6(edge$iterator.secondIterator), 18);
            if ($booleanValue(castToBoolean($getProperty(edge, ($clinit_InternalProperties_1(), REVERSED)))) != reversed) continue;
            if ($indexOf_3(edgesRemaining, edge, 0) != -1) {
                edge.target == singlePort ? targetPort = edge.source : targetPort = edge.target;
                targetPortPosition = sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
                    targetPort.owner.pos,
                    targetPort.pos,
                    targetPort.anchor
                ])).y_0;
                if ($wnd.Math.abs(targetPortPosition - singlePortPosition) < 0.2) continue;
                targetPortPosition < singlePortPosition ? leftPorts.map_0.containsKey(targetPort) ? $add_6(upEdges, new Pair(LEFT_4, edge)) : $add_6(upEdges, new Pair(RIGHT_4, edge)) : leftPorts.map_0.containsKey(targetPort) ? $add_6(downEdges, new Pair(LEFT_4, edge)) : $add_6(downEdges, new Pair(RIGHT_4, edge));
            }
        }
        if (upEdges.map_0.size_1() > 1) {
            seg = new SplineSegment_0(singlePort, upEdges, sideToProcess);
            $forEach_0(upEdges, new SplineEdgeRouter$lambda$2$Type(this$static, seg));
            push_1(hyperEdges.array, seg);
            for(pair$iterator = upEdges.map_0.keySet_0().iterator_0(); pair$iterator.hasNext_0();){
                pair = castTo(pair$iterator.next_1(), 47);
                $remove_12(edgesRemaining, pair.second);
            }
        }
        if (downEdges.map_0.size_1() > 1) {
            seg = new SplineSegment_0(singlePort, downEdges, sideToProcess);
            $forEach_0(downEdges, new SplineEdgeRouter$lambda$3$Type(this$static, seg));
            push_1(hyperEdges.array, seg);
            for(pair$iterator = downEdges.map_0.keySet_0().iterator_0(); pair$iterator.hasNext_0();){
                pair = castTo(pair$iterator.next_1(), 47);
                $remove_12(edgesRemaining, pair.second);
            }
        }
    }
}
function $findAndAddSuccessor(this$static, edge) {
    var iter, nt, targetNode;
    targetNode = edge.target.owner;
    nt = targetNode.type_0;
    if (nt == ($clinit_LNode$NodeType(), NORMAL) || nt == BREAKING_POINT) return;
    iter = new Iterators$ConcatenatedIterator(transform_2($getOutgoingEdges(targetNode).val$inputs1.iterator_0(), new Iterables$10));
    $hasNext_1(iter) && $put_6(this$static.successingEdge, edge, castTo($next_0(iter), 18));
}
function $getEdgeChain(this$static, start_0) {
    var current, edgeChain;
    edgeChain = new ArrayList;
    current = start_0;
    do {
        push_1(edgeChain.array, current);
        current = castTo($get_10(this$static.successingEdge, current), 18);
    }while (current);
    return edgeChain;
}
function $getLayoutProcessorConfiguration_2(graph) {
    var configuration, graphProperties;
    configuration = new LayoutProcessorConfiguration;
    $addAll_6(configuration, BASELINE_PROCESSING_ADDITIONS);
    graphProperties = castTo($getProperty(graph, ($clinit_InternalProperties_1(), GRAPH_PROPERTIES)), 22);
    graphProperties.contains(($clinit_GraphProperties(), SELF_LOOPS)) && $addAll_6(configuration, SELF_LOOP_PROCESSING_ADDITIONS_1);
    graphProperties.contains(CENTER_LABELS) && $addAll_6(configuration, CENTER_EDGE_LABEL_PROCESSING_ADDITIONS_1);
    graphProperties.contains(NORTH_SOUTH_PORTS) && $addAll_6(configuration, NORTH_SOUTH_PORT_PROCESSING_ADDITIONS_1);
    graphProperties.contains(END_LABELS) && $addAll_6(configuration, END_EDGE_LABEL_PROCESSING_ADDITIONS_1);
    return configuration;
}
function $getSplinePath(this$static, start_0) {
    var current, initialSegment, lastSegment, segment, segmentChain;
    segmentChain = new ArrayList;
    current = start_0;
    do {
        segment = castTo($get_10(this$static.edgeToSegmentMap, current), 132);
        segment.sourcePort = current.source;
        segment.targetPort = current.target;
        push_1(segmentChain.array, segment);
        current = castTo($get_10(this$static.successingEdge, current), 18);
    }while (current);
    initialSegment = (checkCriticalElementIndex(0, segmentChain.array.length), castTo(segmentChain.array[0], 132));
    initialSegment.initialSegment = true;
    initialSegment.sourceNode = castTo(initialSegment.edges.map_0.keySet_0().iterator_0().next_1(), 18).source.owner;
    lastSegment = castTo($get_11(segmentChain, segmentChain.array.length - 1), 132);
    lastSegment.lastSegment = true;
    lastSegment.targetNode = castTo(lastSegment.edges.map_0.keySet_0().iterator_0().next_1(), 18).target.owner;
    return segmentChain;
}
function $lambda$2_3(this$static, seg_1, e_1) {
    return $put_6(this$static.edgeToSegmentMap, castTo(e_1.second, 18), seg_1);
}
function $lambda$3_2(this$static, seg_1, e_1) {
    return $put_6(this$static.edgeToSegmentMap, castTo(e_1.second, 18), seg_1);
}
function $process_82(this$static, layeredGraph, monitor) {
    var edge, edge$iterator, edgeChain, edgeEdgeSpacing, edgeNodeSpacing, firstLayer, increment, isLeftLayerExternal, isRightLayerExternal, isSpecialLeftLayer, isSpecialRightLayer, lastLayer, layerIterator, leftLayer, mode, nodeNodeSpacing, rightLayer, rightLayerPosition, segment, segment$iterator, sloppyLayerSpacingFactor, sloppyRouting, slotCount, spline, xSegmentDelta, xpos;
    monitor.begin('Spline edge routing', 1);
    if (layeredGraph.layers.array.length == 0) {
        layeredGraph.size_0.x_0 = 0;
        monitor.done_1();
        return;
    }
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, ($clinit_LayeredOptions(), SPACING_NODE_NODE_BETWEEN_LAYERS_0))));
    edgeNodeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_NODE_BETWEEN_LAYERS_0)));
    edgeEdgeSpacing = $doubleValue(castToDouble($getProperty(layeredGraph, SPACING_EDGE_EDGE_BETWEEN_LAYERS_0)));
    mode = castTo($getProperty(layeredGraph, EDGE_ROUTING_SPLINES_MODE_0), 346);
    sloppyRouting = mode == ($clinit_SplineRoutingMode(), SLOPPY);
    sloppyLayerSpacingFactor = $doubleValue(castToDouble($getProperty(layeredGraph, EDGE_ROUTING_SPLINES_SLOPPY_LAYER_SPACING_FACTOR_0)));
    this$static.lGraph = layeredGraph;
    this$static.startEdges.array.length = 0;
    this$static.allSplineSegments.array.length = 0;
    $reset(this$static.successingEdge);
    firstLayer = castTo($get_11(layeredGraph.layers, 0), 25);
    isLeftLayerExternal = all_0(firstLayer.nodes, ($clinit_PolylineEdgeRouter(), PRED_EXTERNAL_WEST_OR_EAST_PORT));
    lastLayer = castTo($get_11(layeredGraph.layers, layeredGraph.layers.array.length - 1), 25);
    isRightLayerExternal = all_0(lastLayer.nodes, PRED_EXTERNAL_WEST_OR_EAST_PORT);
    layerIterator = new ArrayList$1(layeredGraph.layers);
    leftLayer = null;
    xpos = 0;
    do {
        rightLayer = layerIterator.i < layerIterator.this$01.array.length ? castTo($next_6(layerIterator), 25) : null;
        $clearThenFillMappings(this$static, leftLayer, rightLayer);
        $createSegmentsAndComputeRanking(this$static);
        slotCount = $orElse_1($max_0($mapToInt($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.splineSegmentsLayer, 16)), new SplineEdgeRouter$lambda$0$Type), new SplineEdgeRouter$lambda$1$Type)));
        xSegmentDelta = 0;
        rightLayerPosition = xpos;
        isSpecialLeftLayer = !leftLayer || isLeftLayerExternal && leftLayer == firstLayer;
        isSpecialRightLayer = !rightLayer || isRightLayerExternal && rightLayer == lastLayer;
        if (slotCount > 0) {
            increment = 0;
            !!leftLayer && (increment += edgeNodeSpacing);
            increment += (slotCount - 1) * edgeEdgeSpacing;
            !!rightLayer && (increment += edgeNodeSpacing);
            sloppyRouting && !!rightLayer && (increment = $wnd.Math.max(increment, $computeSloppySpacing(rightLayer, edgeEdgeSpacing, nodeNodeSpacing, sloppyLayerSpacingFactor)));
            if (increment < nodeNodeSpacing && !isSpecialLeftLayer && !isSpecialRightLayer) {
                xSegmentDelta = (nodeNodeSpacing - increment) / 2;
                increment = nodeNodeSpacing;
            }
            rightLayerPosition += increment;
        } else !isSpecialLeftLayer && !isSpecialRightLayer && (rightLayerPosition += nodeNodeSpacing);
        !!rightLayer && placeNodesHorizontally(rightLayer, rightLayerPosition);
        for(segment$iterator = new ArrayList$1(this$static.splineSegmentsLayer); segment$iterator.i < segment$iterator.this$01.array.length;){
            segment = castTo($next_6(segment$iterator), 132);
            segment.boundingBox.x_0 = xpos;
            segment.boundingBox.width_0 = rightLayerPosition - xpos;
            segment.xDelta = xSegmentDelta;
            segment.isWestOfInitialLayer = !leftLayer;
        }
        $addAll_2(this$static.allSplineSegments, this$static.splineSegmentsLayer);
        xpos = rightLayerPosition;
        !!rightLayer && (xpos += rightLayer.size_0.x_0);
        leftLayer = rightLayer;
        isSpecialLeftLayer = isSpecialRightLayer;
    }while (rightLayer);
    for(edge$iterator = new ArrayList$1(this$static.startEdges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 18);
        edgeChain = $getEdgeChain(this$static, edge);
        $setProperty_0(edge, ($clinit_InternalProperties_1(), SPLINE_EDGE_CHAIN), edgeChain);
        spline = $getSplinePath(this$static, edge);
        $setProperty_0(edge, SPLINE_ROUTE_START, spline);
    }
    layeredGraph.size_0.x_0 = xpos;
    this$static.lGraph = null;
    monitor.done_1();
}
function SplineEdgeRouter() {
    $clinit_SplineEdgeRouter();
    this.edgesRemainingLayer = new ArrayList;
    this.splineSegmentsLayer = new ArrayList;
    this.leftPortsLayer = new LinkedHashSet;
    this.rightPortsLayer = new LinkedHashSet;
    this.selfLoopsLayer = new LinkedHashSet;
    this.startEdges = new ArrayList;
    this.allSplineSegments = new ArrayList;
    this.edgeToSegmentMap = new HashMap;
    this.successingEdge = new HashMap;
}
function breakCycles(edges, random) {
    var depIter, dependency, dependency$iterator, dependency$iterator0, edge, edge$iterator, edge$iterator0, edge$iterator1, inweight, markBase, maxEdge, maxEdges, maxOutflow, nextLeft, nextMark, nextRight, outflow, outweight, shiftBase, sink, sinks, source, source$iterator, sources, target, unprocessed;
    sources = new LinkedList;
    sinks = new LinkedList;
    nextMark = -1;
    for(edge$iterator0 = new ArrayList$1(edges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
        edge = castTo($next_6(edge$iterator0), 132);
        edge.mark = nextMark--;
        inweight = 0;
        outweight = 0;
        for(dependency$iterator0 = new ArrayList$1(edge.outgoing); dependency$iterator0.i < dependency$iterator0.this$01.array.length;){
            dependency = castTo($next_6(dependency$iterator0), 270);
            outweight += dependency.weight;
        }
        for(dependency$iterator = new ArrayList$1(edge.incoming); dependency$iterator.i < dependency$iterator.this$01.array.length;){
            dependency = castTo($next_6(dependency$iterator), 270);
            inweight += dependency.weight;
        }
        edge.inweight = inweight;
        edge.outweight = outweight;
        outweight == 0 ? $addNode_0(sinks, edge, sinks.tail.prev, sinks.tail) : inweight == 0 && $addNode_0(sources, edge, sources.tail.prev, sources.tail);
    }
    unprocessed = newLinkedHashSet(edges);
    markBase = edges.array.length;
    nextLeft = markBase + 1;
    nextRight = markBase - 1;
    maxEdges = new ArrayList;
    while(unprocessed.map_0.size_1() != 0){
        while(sinks.size_0 != 0){
            sink = (checkCriticalElement(sinks.size_0 != 0), castTo($removeNode_0(sinks, sinks.header.next_0), 132));
            unprocessed.map_0.remove_0(sink);
            sink.mark = nextRight--;
            updateNeighbors_0(sink, sources, sinks);
        }
        while(sources.size_0 != 0){
            source = (checkCriticalElement(sources.size_0 != 0), castTo($removeNode_0(sources, sources.header.next_0), 132));
            unprocessed.map_0.remove_0(source);
            source.mark = nextLeft++;
            updateNeighbors_0(source, sources, sinks);
        }
        maxOutflow = $intern_42;
        for(edge$iterator1 = unprocessed.map_0.keySet_0().iterator_0(); edge$iterator1.hasNext_0();){
            edge = castTo(edge$iterator1.next_1(), 132);
            outflow = edge.outweight - edge.inweight;
            if (outflow >= maxOutflow) {
                if (outflow > maxOutflow) {
                    maxEdges.array.length = 0;
                    maxOutflow = outflow;
                }
                push_1(maxEdges.array, edge);
            }
        }
        if (maxEdges.array.length != 0) {
            maxEdge = castTo($get_11(maxEdges, $nextInt(random, maxEdges.array.length)), 132);
            unprocessed.map_0.remove_0(maxEdge);
            maxEdge.mark = nextLeft++;
            updateNeighbors_0(maxEdge, sources, sinks);
            maxEdges.array.length = 0;
        }
    }
    shiftBase = edges.array.length + 1;
    for(edge$iterator = new ArrayList$1(edges); edge$iterator.i < edge$iterator.this$01.array.length;){
        edge = castTo($next_6(edge$iterator), 132);
        edge.mark < markBase && (edge.mark += shiftBase);
    }
    for(source$iterator = new ArrayList$1(edges); source$iterator.i < source$iterator.this$01.array.length;){
        source = castTo($next_6(source$iterator), 132);
        depIter = new AbstractList$ListIteratorImpl(source.outgoing, 0);
        while(depIter.i < depIter.this$01_0.size_1()){
            dependency = (checkCriticalElement(depIter.i < depIter.this$01_0.size_1()), castTo(depIter.this$01_0.get_0(depIter.last = depIter.i++), 270));
            target = dependency.target;
            if (source.mark > target.mark) {
                $remove_8(depIter);
                $remove_12(target.incoming, dependency);
                if (dependency.weight > 0) {
                    dependency.source = target;
                    $add_3(target.outgoing, dependency);
                    dependency.target = source;
                    $add_3(source.incoming, dependency);
                }
            }
        }
    }
}
function topologicalNumbering_0(edges) {
    var dep, dep$iterator, edge, edge$iterator, edge$iterator0, maxRank, rightwardTargets, source, sources, target;
    sources = new LinkedList;
    rightwardTargets = new LinkedList;
    for(edge$iterator0 = new ArrayList$1(edges); edge$iterator0.i < edge$iterator0.this$01.array.length;){
        edge = castTo($next_6(edge$iterator0), 132);
        edge.rank = 0;
        edge.inweight = edge.incoming.array.length;
        edge.outweight = edge.outgoing.array.length;
        edge.inweight == 0 && $addNode_0(sources, edge, sources.tail.prev, sources.tail);
        edge.outweight == 0 && edge.leftPorts.map_0.size_1() == 0 && $addNode_0(rightwardTargets, edge, rightwardTargets.tail.prev, rightwardTargets.tail);
    }
    maxRank = -1;
    while(sources.size_0 != 0){
        edge = castTo($remove_4(sources, 0), 132);
        for(dep$iterator = new ArrayList$1(edge.outgoing); dep$iterator.i < dep$iterator.this$01.array.length;){
            dep = castTo($next_6(dep$iterator), 270);
            target = dep.target;
            target.rank = $wnd.Math.max(target.rank, edge.rank + 1);
            maxRank = $wnd.Math.max(maxRank, target.rank);
            --target.inweight;
            target.inweight == 0 && $addNode_0(sources, target, sources.tail.prev, sources.tail);
        }
    }
    if (maxRank > -1) {
        for(edge$iterator = $listIterator_2(rightwardTargets, 0); edge$iterator.currentNode != edge$iterator.this$01.tail;){
            edge = castTo($next_9(edge$iterator), 132);
            edge.rank = maxRank;
        }
        while(rightwardTargets.size_0 != 0){
            edge = castTo($remove_4(rightwardTargets, 0), 132);
            for(dep$iterator = new ArrayList$1(edge.incoming); dep$iterator.i < dep$iterator.this$01.array.length;){
                dep = castTo($next_6(dep$iterator), 270);
                source = dep.source;
                if (source.leftPorts.map_0.size_1() != 0) continue;
                source.rank = $wnd.Math.min(source.rank, edge.rank - 1);
                --source.outweight;
                source.outweight == 0 && $addNode_0(rightwardTargets, source, rightwardTargets.tail.prev, rightwardTargets.tail);
            }
        }
    }
}
function updateNeighbors_0(edge, sources, sinks) {
    var dep, dep$iterator, dep$iterator0;
    for(dep$iterator0 = new ArrayList$1(edge.outgoing); dep$iterator0.i < dep$iterator0.this$01.array.length;){
        dep = castTo($next_6(dep$iterator0), 270);
        if (dep.target.mark < 0 && dep.weight > 0) {
            dep.target.inweight -= dep.weight;
            dep.target.inweight <= 0 && dep.target.outweight > 0 && $add_7(sources, dep.target);
        }
    }
    for(dep$iterator = new ArrayList$1(edge.incoming); dep$iterator.i < dep$iterator.this$01.array.length;){
        dep = castTo($next_6(dep$iterator), 270);
        if (dep.source.mark < 0 && dep.weight > 0) {
            dep.source.outweight -= dep.weight;
            dep.source.outweight <= 0 && dep.source.inweight > 0 && $add_7(sinks, dep.source);
        }
    }
}
defineClass(1419, 1, $intern_110, SplineEdgeRouter);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_22(graph) {
    return $getLayoutProcessorConfiguration_2(castTo(graph, 36));
};
_.process = function process_78(layeredGraph, monitor) {
    $process_82(this, castTo(layeredGraph, 36), monitor);
};
var BASELINE_PROCESSING_ADDITIONS, CENTER_EDGE_LABEL_PROCESSING_ADDITIONS_1, END_EDGE_LABEL_PROCESSING_ADDITIONS_1, NORTH_SOUTH_PORT_PROCESSING_ADDITIONS_1, SELF_LOOP_PROCESSING_ADDITIONS_1;
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter', 1419);
function SplineEdgeRouter$Dependency(source, target, weight) {
    this.source = source;
    this.target = target;
    this.weight = weight;
    $add_3(source.outgoing, this);
    $add_3(target.incoming, this);
}
defineClass(270, 1, {
    270: 1
}, SplineEdgeRouter$Dependency);
_.toString_0 = function toString_105() {
    return this.source + ' ->(' + this.weight + ') ' + this.target;
};
_.weight = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$Dependency_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter/Dependency', 270);
function $clinit_SplineEdgeRouter$SideToProcess() {
    $clinit_SplineEdgeRouter$SideToProcess = emptyMethod;
    LEFT_4 = new SplineEdgeRouter$SideToProcess('LEFT', 0);
    RIGHT_4 = new SplineEdgeRouter$SideToProcess('RIGHT', 1);
}
function SplineEdgeRouter$SideToProcess(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_65(name_0) {
    $clinit_SplineEdgeRouter$SideToProcess();
    return valueOf(($clinit_SplineEdgeRouter$SideToProcess$Map(), $MAP_55), name_0);
}
function values_73() {
    $clinit_SplineEdgeRouter$SideToProcess();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$SideToProcess_2_classLit, 1), $intern_36, 451, 0, [
        LEFT_4,
        RIGHT_4
    ]);
}
defineClass(451, 23, {
    3: 1,
    34: 1,
    23: 1,
    451: 1
}, SplineEdgeRouter$SideToProcess);
var LEFT_4, RIGHT_4;
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$SideToProcess_2_classLit = createForEnum('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter/SideToProcess', 451, Ljava_lang_Enum_2_classLit, values_73, valueOf_65);
function $clinit_SplineEdgeRouter$SideToProcess$Map() {
    $clinit_SplineEdgeRouter$SideToProcess$Map = emptyMethod;
    $MAP_55 = createValueOfMap(($clinit_SplineEdgeRouter$SideToProcess(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$SideToProcess_2_classLit, 1), $intern_36, 451, 0, [
        LEFT_4,
        RIGHT_4
    ])));
}
var $MAP_55;
function SplineEdgeRouter$lambda$0$Type() {}
defineClass(1420, 1, $intern_39, SplineEdgeRouter$lambda$0$Type);
_.test_0 = function test_99(arg0) {
    return $clinit_SplineEdgeRouter(), !castTo(arg0, 132).isStraight;
};
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter/lambda$0$Type', 1420);
function SplineEdgeRouter$lambda$1$Type() {}
defineClass(1421, 1, {}, SplineEdgeRouter$lambda$1$Type);
_.applyAsInt = function applyAsInt_3(arg0) {
    return $clinit_SplineEdgeRouter(), castTo(arg0, 132).rank + 1;
};
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter/lambda$1$Type', 1421);
function SplineEdgeRouter$lambda$2$Type($$outer_0, seg_1) {
    this.$$outer_0 = $$outer_0;
    this.seg_1 = seg_1;
}
defineClass(1422, 1, $intern_19, SplineEdgeRouter$lambda$2$Type);
_.accept = function accept_129(arg0) {
    $lambda$2_3(this.$$outer_0, this.seg_1, castTo(arg0, 47));
};
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter/lambda$2$Type', 1422);
function SplineEdgeRouter$lambda$3$Type($$outer_0, seg_1) {
    this.$$outer_0 = $$outer_0;
    this.seg_1 = seg_1;
}
defineClass(1423, 1, $intern_19, SplineEdgeRouter$lambda$3$Type);
_.accept = function accept_130(arg0) {
    $lambda$3_2(this.$$outer_0, this.seg_1, castTo(arg0, 47));
};
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineEdgeRouter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineEdgeRouter/lambda$3$Type', 1423);
function $$init_8(this$static) {
    this$static.leftPorts = new HashSet;
    this$static.rightPorts = new HashSet;
    this$static.outgoing = new ArrayList;
    this$static.incoming = new ArrayList;
    this$static.edges = new HashSet;
    this$static.boundingBox = new ElkRectangle;
    this$static.edgeInformation = new HashMap;
}
function $addEdge_0(this$static, edge) {
    var ei, nt, nt0;
    $add_6(this$static.edges, edge);
    ei = new SplineSegment$EdgeInformation;
    $put_6(this$static.edgeInformation, edge, ei);
    ei.startY = $anchorY(edge.source);
    ei.endY = $anchorY(edge.target);
    ei.normalSourceNode = ($clinit_SplineEdgeRouter(), nt0 = edge.source.owner.type_0, nt0 == ($clinit_LNode$NodeType(), NORMAL) || nt0 == BREAKING_POINT);
    ei.normalTargetNode = (nt = edge.target.owner.type_0, nt == NORMAL || nt == BREAKING_POINT);
    ei.invertedLeft = edge.source.side == ($clinit_PortSide(), WEST_0);
    ei.invertedRight = edge.target.side == EAST_0;
}
function $anchorY(p) {
    return ($clinit_PortSide(), SIDES_NORTH_SOUTH).contains(p.side) ? $doubleValue(castToDouble($getProperty(p, ($clinit_InternalProperties_1(), SPLINE_NS_PORT_Y_COORD)))) : sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        p.owner.pos,
        p.pos,
        p.anchor
    ])).y_0;
}
function $compareTo_18(this$static, other) {
    return this$static.mark - other.mark;
}
function $setRelevantPositions(this$static, sourceY, targetYMin, targetYMax) {
    this$static.boundingBox.y_0 = $wnd.Math.min(sourceY, targetYMin);
    this$static.boundingBox.height = $wnd.Math.max(sourceY, targetYMax) - this$static.boundingBox.y_0;
    if (sourceY < targetYMin) {
        this$static.centerControlPointY = 0.5 * (sourceY + targetYMin);
        this$static.hyperEdgeTopYPos = $intern_117 * this$static.centerControlPointY + 0.9 * sourceY;
        this$static.hyperEdgeBottomYPos = $intern_117 * this$static.centerControlPointY + 0.9 * targetYMin;
    } else {
        this$static.centerControlPointY = 0.5 * (sourceY + targetYMax);
        this$static.hyperEdgeTopYPos = $intern_117 * this$static.centerControlPointY + 0.9 * targetYMax;
        this$static.hyperEdgeBottomYPos = $intern_117 * this$static.centerControlPointY + 0.9 * sourceY;
    }
}
function SplineSegment(edge, sourceSide, targetSide) {
    var sourceY, targetY;
    $$init_8(this);
    sourceSide == ($clinit_SplineEdgeRouter$SideToProcess(), LEFT_4) ? $add_6(this.leftPorts, edge.source) : $add_6(this.rightPorts, edge.source);
    targetSide == LEFT_4 ? $add_6(this.leftPorts, edge.target) : $add_6(this.rightPorts, edge.target);
    $addEdge_0(this, edge);
    sourceY = $anchorY(edge.source);
    targetY = $anchorY(edge.target);
    $setRelevantPositions(this, sourceY, targetY, targetY);
    this.isStraight = ($clinit_SplineEdgeRouter(), $wnd.Math.abs(sourceY - targetY) < 0.2);
}
function SplineSegment_0(singlePort, edges, sourceSide) {
    var edge, pair, pair$iterator, pair$iterator0, side, tgtPort, yMaxPosOfTarget, yMinPosOfTarget, yPosOfSingleSide, yPosOfTarget;
    $$init_8(this);
    sourceSide == ($clinit_SplineEdgeRouter$SideToProcess(), LEFT_4) ? $add_6(this.leftPorts, singlePort) : $add_6(this.rightPorts, singlePort);
    yMinPosOfTarget = $intern_60;
    yMaxPosOfTarget = $intern_61;
    for(pair$iterator0 = edges.map_0.keySet_0().iterator_0(); pair$iterator0.hasNext_0();){
        pair = castTo(pair$iterator0.next_1(), 47);
        side = castTo(pair.first, 451);
        edge = castTo(pair.second, 18);
        tgtPort = edge.source;
        tgtPort == singlePort && (tgtPort = edge.target);
        side == LEFT_4 ? $add_6(this.leftPorts, tgtPort) : $add_6(this.rightPorts, tgtPort);
        yPosOfTarget = ($clinit_PortSide(), SIDES_NORTH_SOUTH).contains(tgtPort.side) ? $doubleValue(castToDouble($getProperty(tgtPort, ($clinit_InternalProperties_1(), SPLINE_NS_PORT_Y_COORD)))) : sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
            tgtPort.owner.pos,
            tgtPort.pos,
            tgtPort.anchor
        ])).y_0;
        yMinPosOfTarget = $wnd.Math.min(yMinPosOfTarget, yPosOfTarget);
        yMaxPosOfTarget = $wnd.Math.max(yMaxPosOfTarget, yPosOfTarget);
    }
    yPosOfSingleSide = ($clinit_PortSide(), SIDES_NORTH_SOUTH).contains(singlePort.side) ? $doubleValue(castToDouble($getProperty(singlePort, ($clinit_InternalProperties_1(), SPLINE_NS_PORT_Y_COORD)))) : sum_0(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, 1), $intern_16, 8, 0, [
        singlePort.owner.pos,
        singlePort.pos,
        singlePort.anchor
    ])).y_0;
    $setRelevantPositions(this, yPosOfSingleSide, yMinPosOfTarget, yMaxPosOfTarget);
    for(pair$iterator = edges.map_0.keySet_0().iterator_0(); pair$iterator.hasNext_0();){
        pair = castTo(pair$iterator.next_1(), 47);
        $addEdge_0(this, castTo(pair.second, 18));
    }
    this.isStraight = false;
}
defineClass(132, 1, {
    34: 1,
    132: 1
}, SplineSegment, SplineSegment_0);
_.compareTo_0 = function compareTo_19(other) {
    return $compareTo_18(this, castTo(other, 132));
};
_.centerControlPointY = 0;
_.handled = false;
_.hyperEdgeBottomYPos = 0;
_.hyperEdgeTopYPos = 0;
_.initialSegment = false;
_.inverseOrder = false;
_.inweight = 0;
_.isStraight = false;
_.isWestOfInitialLayer = false;
_.lastSegment = false;
_.mark = 0;
_.outweight = 0;
_.rank = 0;
_.xDelta = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineSegment_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineSegment', 132);
function SplineSegment$EdgeInformation() {}
defineClass(454, 1, {
    454: 1
}, SplineSegment$EdgeInformation);
_.endY = 0;
_.invertedLeft = false;
_.invertedRight = false;
_.normalSourceNode = false;
_.normalTargetNode = false;
_.startY = 0;
var Lorg_eclipse_elk_alg_layered_p5edges_splines_SplineSegment$EdgeInformation_2_classLit = createForClass('org.eclipse.elk.alg.layered.p5edges.splines', 'SplineSegment/EdgeInformation', 454);
function isBetween(value_0, boundary0, boundary1) {
    if ($wnd.Math.abs(boundary0 - value_0) < $intern_118 || $wnd.Math.abs(boundary1 - value_0) < $intern_118) return true;
    return boundary0 - value_0 > $intern_118 ? value_0 - boundary1 > $intern_118 : boundary1 - value_0 > $intern_118;
}
function portSideToDirection(side) {
    switch(side.ordinal){
        case 1:
            return $intern_119;
        default:
        case 2:
            return 0;
        case 3:
            return $intern_120;
        case 4:
            return $intern_121;
    }
}
function $applyPaddingAndNormalizePositions(g) {
    var padding;
    padding = castTo($getProperty(g, ($clinit_MrTreeOptions(), PADDING_1)), 107);
    $setProperty_0(g, ($clinit_InternalProperties_2(), BB_UPLEFT_0), new KVector_1(0, 0));
    $moveGraph_1(new TGraph, g, padding.left - $doubleValue(castToDouble($getProperty(g, GRAPH_XMIN))), padding.top_0 - $doubleValue(castToDouble($getProperty(g, GRAPH_YMIN))));
}
function $dfs_5(this$static, node, graph) {
    var component, edge, edge$iterator;
    if (!this$static.visited[node.id_0]) {
        this$static.visited[node.id_0] = true;
        component = graph;
        !component && (component = new TGraph);
        $add_7(component.nodes, node);
        for(edge$iterator = this$static.incidence[node.id_0].iterator_0(); edge$iterator.hasNext_0();){
            edge = castTo(edge$iterator.next_1(), 65);
            edge.source != node && $dfs_5(this$static, edge.source, component);
            edge.target != node && $dfs_5(this$static, edge.target, component);
            $add_7(component.edges, edge);
        }
        return component;
    }
    return null;
}
function $initialize_6(this$static, graph) {
    var edge, edge$iterator, n, node, node$iterator;
    n = graph.nodes.size_0;
    this$static.incidence = initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, n, 0, 1);
    this$static.visited = initUnidimensionalArray(Z_classLit, $intern_90, 30, n, 16, 1);
    for(node$iterator = $listIterator_2(graph.nodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
        node = castTo($next_9(node$iterator), 39);
        this$static.incidence[node.id_0] = new LinkedList;
    }
    for(edge$iterator = $listIterator_2(graph.edges, 0); edge$iterator.currentNode != edge$iterator.this$01.tail;){
        edge = castTo($next_9(edge$iterator), 65);
        this$static.incidence[edge.source.id_0].add_2(edge);
        this$static.incidence[edge.target.id_0].add_2(edge);
    }
}
function $moveGraph_1(destGraph, sourceGraph, offsetx, offsety) {
    var bendpoint, bendpoint$iterator, edge, edge$iterator, graphOffset, node, node$iterator;
    graphOffset = new KVector_1(offsetx, offsety);
    $sub_0(graphOffset, castTo($getProperty(sourceGraph, ($clinit_InternalProperties_2(), BB_UPLEFT_0)), 8));
    for(node$iterator = $listIterator_2(sourceGraph.nodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
        node = castTo($next_9(node$iterator), 39);
        $add_19(node.pos, graphOffset);
        $add_7(destGraph.nodes, node);
    }
    for(edge$iterator = castTo($collect_1($distinct(new StreamImpl(null, new Spliterators$IteratorSpliterator(sourceGraph.edges, 16))), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15).iterator_0(); edge$iterator.hasNext_0();){
        edge = castTo(edge$iterator.next_1(), 65);
        for(bendpoint$iterator = $listIterator_2(edge.bendPoints, 0); bendpoint$iterator.currentNode != bendpoint$iterator.this$01.tail;){
            bendpoint = castTo($next_9(bendpoint$iterator), 8);
            bendpoint.x_0 += graphOffset.x_0;
            bendpoint.y_0 += graphOffset.y_0;
        }
        $add_7(destGraph.edges, edge);
    }
}
function $pack(components) {
    var broadestRow, debug, debugMode, entry, entry$iterator, graph, graph$iterator, graph$iterator0, graph$iterator1, highestBox, maxRowWidth, maxx, maxy, minx, miny, node, node$iterator, priority, propComp, propMerge, result, size_0, spacing, tGraph, tGraph$iterator, totalArea, xpos, ypos;
    if (components.array.length == 1) {
        $applyPaddingAndNormalizePositions((checkCriticalElementIndex(0, components.array.length), castTo(components.array[0], 120)));
        return checkCriticalElementIndex(0, components.array.length), castTo(components.array[0], 120);
    } else if (components.array.length <= 0) return new TGraph;
    for(graph$iterator0 = new ArrayList$1(components); graph$iterator0.i < graph$iterator0.this$01.array.length;){
        graph = castTo($next_6(graph$iterator0), 120);
        priority = 0;
        minx = $intern_0;
        miny = $intern_0;
        maxx = $intern_42;
        maxy = $intern_42;
        for(node$iterator = $listIterator_2(graph.nodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
            node = castTo($next_9(node$iterator), 39);
            priority += castTo($getProperty(node, ($clinit_MrTreeOptions(), PRIORITY_1)), 17).value_0;
            minx = $wnd.Math.min(minx, node.pos.x_0);
            miny = $wnd.Math.min(miny, node.pos.y_0);
            maxx = $wnd.Math.max(maxx, node.pos.x_0 + node.size_0.x_0);
            maxy = $wnd.Math.max(maxy, node.pos.y_0 + node.size_0.y_0);
        }
        $setProperty_0(graph, ($clinit_MrTreeOptions(), PRIORITY_1), valueOf_3(priority));
        $setProperty_0(graph, ($clinit_InternalProperties_2(), BB_UPLEFT_0), new KVector_1(minx, miny));
        $setProperty_0(graph, BB_LOWRIGHT_0, new KVector_1(maxx, maxy));
    }
    $clinit_Collections();
    $sort(components, new ComponentsProcessor$1_0);
    result = new TGraph;
    $copyProperties(result, (checkCriticalElementIndex(0, components.array.length), castTo(components.array[0], 102)));
    maxRowWidth = 0;
    totalArea = 0;
    for(graph$iterator1 = new ArrayList$1(components); graph$iterator1.i < graph$iterator1.this$01.array.length;){
        graph = castTo($next_6(graph$iterator1), 120);
        size_0 = $sub_0($clone_1(castTo($getProperty(graph, ($clinit_InternalProperties_2(), BB_LOWRIGHT_0)), 8)), castTo($getProperty(graph, BB_UPLEFT_0), 8));
        maxRowWidth = $wnd.Math.max(maxRowWidth, size_0.x_0);
        totalArea += size_0.x_0 * size_0.y_0;
    }
    maxRowWidth = $wnd.Math.max(maxRowWidth, $wnd.Math.sqrt(totalArea) * $doubleValue(castToDouble($getProperty(result, ($clinit_MrTreeOptions(), ASPECT_RATIO_1)))));
    spacing = $doubleValue(castToDouble($getProperty(result, SPACING_NODE_NODE_1)));
    xpos = 0;
    ypos = 0;
    highestBox = 0;
    broadestRow = spacing;
    for(graph$iterator = new ArrayList$1(components); graph$iterator.i < graph$iterator.this$01.array.length;){
        graph = castTo($next_6(graph$iterator), 120);
        size_0 = $sub_0($clone_1(castTo($getProperty(graph, ($clinit_InternalProperties_2(), BB_LOWRIGHT_0)), 8)), castTo($getProperty(graph, BB_UPLEFT_0), 8));
        if (xpos + size_0.x_0 > maxRowWidth) {
            xpos = 0;
            ypos += highestBox + spacing;
            highestBox = 0;
        }
        $moveGraph_1(result, graph, xpos, ypos);
        broadestRow = $wnd.Math.max(broadestRow, xpos + size_0.x_0);
        highestBox = $wnd.Math.max(highestBox, size_0.y_0);
        xpos += size_0.x_0 + spacing;
    }
    propMerge = new HashMap;
    debug = new HashMap;
    for(tGraph$iterator = new ArrayList$1(components); tGraph$iterator.i < tGraph$iterator.this$01.array.length;){
        tGraph = castTo($next_6(tGraph$iterator), 120);
        debugMode = $booleanValue(castToBoolean($getProperty(tGraph, ($clinit_CoreOptions(), DEBUG_MODE_3))));
        propComp = !tGraph.propertyMap ? EMPTY_MAP : tGraph.propertyMap;
        for(entry$iterator = propComp.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
            entry = castTo(entry$iterator.next_1(), 43);
            if ($containsKey_3(propMerge, entry.getKey())) {
                if (maskUndefined(castTo(entry.getKey(), 144).getDefault()) !== maskUndefined(entry.getValue())) {
                    if (debugMode && $containsKey_3(debug, entry.getKey())) {
                        $clinit_System();
                        castTo(entry.getKey(), 144).getId();
                        String.fromCharCode(10);
                    } else {
                        $put_6(propMerge, castTo(entry.getKey(), 144), entry.getValue());
                        $setProperty_0(result, castTo(entry.getKey(), 144), entry.getValue());
                        debugMode && $put_6(debug, castTo(entry.getKey(), 144), entry.getValue());
                    }
                }
            } else {
                $put_6(propMerge, castTo(entry.getKey(), 144), entry.getValue());
                $setProperty_0(result, castTo(entry.getKey(), 144), entry.getValue());
            }
        }
    }
    $applyPaddingAndNormalizePositions(result);
    return result;
}
function $split_4(this$static, graph) {
    var comp, comp$iterator, components, id_0, node, node$iterator, node$iterator0, separate;
    separate = castToBoolean($getProperty(graph, ($clinit_MrTreeOptions(), SEPARATE_CONNECTED_COMPONENTS_1)));
    if (separate == null || (checkCriticalNotNull(separate), separate)) {
        $initialize_6(this$static, graph);
        components = new ArrayList;
        for(node$iterator0 = $listIterator_2(graph.nodes, 0); node$iterator0.currentNode != node$iterator0.this$01.tail;){
            node = castTo($next_9(node$iterator0), 39);
            comp = $dfs_5(this$static, node, null);
            if (comp) {
                $copyProperties(comp, graph);
                push_1(components.array, comp);
            }
        }
        this$static.incidence = null;
        this$static.visited = null;
        if (components.array.length > 1) for(comp$iterator = new ArrayList$1(components); comp$iterator.i < comp$iterator.this$01.array.length;){
            comp = castTo($next_6(comp$iterator), 120);
            id_0 = 0;
            for(node$iterator = $listIterator_2(comp.nodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
                node = castTo($next_9(node$iterator), 39);
                node.id_0 = id_0++;
            }
        }
        return components;
    }
    return newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_graph_TGraph_2_classLit, 1), $intern_95, 120, 0, [
        graph
    ]));
}
function ComponentsProcessor_1() {}
defineClass(1162, 1, {}, ComponentsProcessor_1);
var Lorg_eclipse_elk_alg_mrtree_ComponentsProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'ComponentsProcessor', 1162);
function $compare_19(graph1, graph2) {
    var prio, size1, size2;
    prio = castTo($getProperty(graph2, ($clinit_MrTreeOptions(), PRIORITY_1)), 17).value_0 - castTo($getProperty(graph1, PRIORITY_1), 17).value_0;
    if (prio == 0) {
        size1 = $sub_0($clone_1(castTo($getProperty(graph1, ($clinit_InternalProperties_2(), BB_LOWRIGHT_0)), 8)), castTo($getProperty(graph1, BB_UPLEFT_0), 8));
        size2 = $sub_0($clone_1(castTo($getProperty(graph2, BB_LOWRIGHT_0), 8)), castTo($getProperty(graph2, BB_UPLEFT_0), 8));
        return compare_4(size1.x_0 * size1.y_0, size2.x_0 * size2.y_0);
    }
    return prio;
}
function ComponentsProcessor$1_0() {}
defineClass(1163, 1, $intern_88, ComponentsProcessor$1_0);
_.compare_1 = function compare_75(graph1, graph2) {
    return $compare_19(castTo(graph1, 120), castTo(graph2, 120));
};
_.equals_0 = function equals_162(other) {
    return this === other;
};
_.reversed = function reversed_67() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_ComponentsProcessor$1_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'ComponentsProcessor/1', 1163);
function $applyLayout_3(tGraph) {
    var bendPoints, edgeSection, elkedge, elkgraph, elknode, height, maxXPos, maxYPos, minXPos, minYPos, object, padding, pos, size_0, tEdge, tEdge$iterator, tNode, tNode$iterator, tNode$iterator0, width_0;
    elkgraph = castTo($getProperty(tGraph, ($clinit_InternalProperties_2(), ORIGIN_1)), 27);
    minXPos = $intern_0;
    minYPos = $intern_0;
    maxXPos = $intern_42;
    maxYPos = $intern_42;
    for(tNode$iterator0 = $listIterator_2(tGraph.nodes, 0); tNode$iterator0.currentNode != tNode$iterator0.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator0), 39);
        pos = tNode.pos;
        size_0 = tNode.size_0;
        minXPos = $wnd.Math.min(minXPos, pos.x_0 - size_0.x_0 / 2);
        minYPos = $wnd.Math.min(minYPos, pos.y_0 - size_0.y_0 / 2);
        maxXPos = $wnd.Math.max(maxXPos, pos.x_0 + size_0.x_0 / 2);
        maxYPos = $wnd.Math.max(maxYPos, pos.y_0 + size_0.y_0 / 2);
    }
    padding = castTo($getProperty_0(elkgraph, ($clinit_MrTreeOptions(), PADDING_1)), 107);
    for(tNode$iterator = $listIterator_2(tGraph.nodes, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator), 39);
        object = $getProperty(tNode, ORIGIN_1);
        if (instanceOf(object, 206)) {
            elknode = castTo(object, 27);
            $setLocation_1(elknode, tNode.pos.x_0, tNode.pos.y_0);
            $copyProperties_0(elknode, tNode);
        }
    }
    for(tEdge$iterator = $listIterator_2(tGraph.edges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
        tEdge = castTo($next_9(tEdge$iterator), 65);
        elkedge = castTo($getProperty(tEdge, ORIGIN_1), 85);
        if (elkedge) {
            bendPoints = tEdge.bendPoints;
            edgeSection = firstEdgeSection(elkedge);
            applyVectorChain(bendPoints, edgeSection);
        }
    }
    width_0 = maxXPos - minXPos + (padding.left + padding.right);
    height = maxYPos - minYPos + (padding.top_0 + padding.bottom);
    $booleanValue(castToBoolean($getProperty_0(elkgraph, ($clinit_CoreOptions(), NODE_SIZE_FIXED_GRAPH_SIZE_3)))) || resizeNode_1(elkgraph, width_0, height, false, false);
    $setProperty_1(elkgraph, CHILD_AREA_WIDTH, width_0 - (padding.left + padding.right));
    $setProperty_1(elkgraph, CHILD_AREA_HEIGHT, height - (padding.top_0 + padding.bottom));
}
function $transformEdges_1(parentNode, tGraph, elemMap) {
    var elkedge, elkedge$iterator, elknode, elknode$iterator, newEdge, source, target;
    for(elknode$iterator = new AbstractEList$EIterator((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children)); elknode$iterator.cursor != elknode$iterator.this$01_2.size_1();){
        elknode = castTo($doNext(elknode$iterator), 27);
        for(elkedge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(elknode).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(elkedge$iterator);){
            elkedge = castTo($next_0(elkedge$iterator), 85);
            if (!$isHierarchical(elkedge) && !$isHierarchical(elkedge) && !$isSelfloop(elkedge)) {
                source = castTo(getEntryValueOrNull($getEntry_0(elemMap.hashCodeMap, elknode)), 39);
                target = castTo($get_10(elemMap, connectableShapeToNode(castTo($get_20((!elkedge.targets && (elkedge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, elkedge, 5, 8)), elkedge.targets), 0), 84))), 39);
                if (!!source && !!target) {
                    newEdge = new TEdge_0(source, target);
                    $setProperty_0(newEdge, ($clinit_InternalProperties_2(), ORIGIN_1), elkedge);
                    $copyProperties(newEdge, elkedge);
                    $add_7(source.outgoingEdges, newEdge);
                    $add_7(target.incomingEdges, newEdge);
                    $add_7(tGraph.edges, newEdge);
                }
            }
        }
    }
}
function $transformNodes_1(parentNode, tGraph, elemMap) {
    var elknode, elknode$iterator, index_0, label_0, newNode;
    index_0 = 0;
    for(elknode$iterator = new AbstractEList$EIterator((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children)); elknode$iterator.cursor != elknode$iterator.this$01_2.size_1();){
        elknode = castTo($doNext(elknode$iterator), 27);
        label_0 = '';
        (!elknode.labels && (elknode.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elknode, 1, 7)), elknode.labels).size_0 == 0 || (label_0 = castTo($get_20((!elknode.labels && (elknode.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, elknode, 1, 7)), elknode.labels), 0), 153).text_0);
        newNode = new TNode(index_0++, tGraph, label_0);
        $copyProperties(newNode, elknode);
        $setProperty_0(newNode, ($clinit_InternalProperties_2(), ORIGIN_1), elknode);
        newNode.pos.y_0 = elknode.y_0 + elknode.height / 2;
        newNode.size_0.x_0 = $wnd.Math.max(elknode.width_0, 1);
        newNode.pos.x_0 = elknode.x_0 + elknode.width_0 / 2;
        newNode.size_0.y_0 = $wnd.Math.max(elknode.height, 1);
        $add_7(tGraph.nodes, newNode);
        $put_9(elemMap.hashCodeMap, elknode, newNode);
    }
}
function $doLayout_0(this$static, tgraph, progressMonitor) {
    progressMonitor.begin('Tree layout', 1);
    $reset_4(this$static.algorithmAssembler);
    $setPhase(this$static.algorithmAssembler, ($clinit_TreeLayoutPhases(), P1_TREEIFICATION), P1_TREEIFICATION);
    $setPhase(this$static.algorithmAssembler, P2_NODE_ORDERING, P2_NODE_ORDERING);
    $setPhase(this$static.algorithmAssembler, P3_NODE_PLACEMENT, P3_NODE_PLACEMENT);
    $setPhase(this$static.algorithmAssembler, P4_EDGE_ROUTING, P4_EDGE_ROUTING);
    this$static.algorithm = $build_0(this$static.algorithmAssembler, tgraph);
    $layout_2(this$static, tgraph, progressMonitor.subTask(1));
    progressMonitor.done_1();
    return tgraph;
}
function $layout_2(this$static, graph, themonitor) {
    var monitor, processor, processor$iterator;
    monitor = themonitor;
    !monitor && (monitor = new BasicProgressMonitor);
    monitor.begin('Layout', this$static.algorithm.array.length);
    for(processor$iterator = new ArrayList$1(this$static.algorithm); processor$iterator.i < processor$iterator.this$01.array.length;){
        processor = castTo($next_6(processor$iterator), 44);
        if (monitor.isCanceled()) return;
        processor.process(graph, monitor.subTask(1));
    }
    monitor.done_1();
}
function MrTree() {
    this.algorithmAssembler = new AlgorithmAssembler(Lorg_eclipse_elk_alg_mrtree_TreeLayoutPhases_2_classLit);
}
defineClass(1161, 1, {}, MrTree);
var Lorg_eclipse_elk_alg_mrtree_MrTree_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'MrTree', 1161);
function $clinit_TreeLayoutPhases() {
    $clinit_TreeLayoutPhases = emptyMethod;
    P1_TREEIFICATION = new TreeLayoutPhases('P1_TREEIFICATION', 0);
    P2_NODE_ORDERING = new TreeLayoutPhases('P2_NODE_ORDERING', 1);
    P3_NODE_PLACEMENT = new TreeLayoutPhases('P3_NODE_PLACEMENT', 2);
    P4_EDGE_ROUTING = new TreeLayoutPhases('P4_EDGE_ROUTING', 3);
}
function $create_8(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new DFSTreeifyer;
        case 1:
            return new NodeOrderer;
        case 2:
            return new NodePlacer;
        case 3:
            return new EdgeRouter;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout phase ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function TreeLayoutPhases(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_66(name_0) {
    $clinit_TreeLayoutPhases();
    return valueOf(($clinit_TreeLayoutPhases$Map(), $MAP_56), name_0);
}
function values_74() {
    $clinit_TreeLayoutPhases();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_TreeLayoutPhases_2_classLit, 1), $intern_36, 396, 0, [
        P1_TREEIFICATION,
        P2_NODE_ORDERING,
        P3_NODE_PLACEMENT,
        P4_EDGE_ROUTING
    ]);
}
defineClass(396, 23, {
    3: 1,
    34: 1,
    23: 1,
    396: 1,
    188: 1,
    196: 1
}, TreeLayoutPhases);
_.create_1 = function create_18() {
    return $create_8(this);
};
_.create_2 = function create_17() {
    return $create_8(this);
};
var P1_TREEIFICATION, P2_NODE_ORDERING, P3_NODE_PLACEMENT, P4_EDGE_ROUTING;
var Lorg_eclipse_elk_alg_mrtree_TreeLayoutPhases_2_classLit = createForEnum('org.eclipse.elk.alg.mrtree', 'TreeLayoutPhases', 396, Ljava_lang_Enum_2_classLit, values_74, valueOf_66);
function $clinit_TreeLayoutPhases$Map() {
    $clinit_TreeLayoutPhases$Map = emptyMethod;
    $MAP_56 = createValueOfMap(($clinit_TreeLayoutPhases(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_TreeLayoutPhases_2_classLit, 1), $intern_36, 396, 0, [
        P1_TREEIFICATION,
        P2_NODE_ORDERING,
        P3_NODE_PLACEMENT,
        P4_EDGE_ROUTING
    ])));
}
var $MAP_56;
function TreeLayoutProvider() {
    this.klayTree = new MrTree;
    this.componentsProcessor = new ComponentsProcessor_1;
}
defineClass(1077, 222, $intern_96, TreeLayoutProvider);
_.layout = function layout_2(layoutGraph, progressMonitor) {
    var builder, comp, comp$iterator, components, pm, tGraph, tGraph_0, elemMap;
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, ($clinit_MrTreeOptions(), OMIT_NODE_MICRO_LAYOUT_1)))) || $execute((builder = new NodeMicroLayout(($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(layoutGraph))), builder));
    pm = progressMonitor.subTask($intern_122);
    pm.begin('build tGraph', 1);
    tGraph = (tGraph_0 = new TGraph, $copyProperties(tGraph_0, layoutGraph), $setProperty_0(tGraph_0, ($clinit_InternalProperties_2(), ORIGIN_1), layoutGraph), elemMap = new HashMap, $transformNodes_1(layoutGraph, tGraph_0, elemMap), $transformEdges_1(layoutGraph, tGraph_0, elemMap), tGraph_0);
    pm.done_1();
    pm = progressMonitor.subTask($intern_122);
    pm.begin('Split graph', 1);
    components = $split_4(this.componentsProcessor, tGraph);
    pm.done_1();
    for(comp$iterator = new ArrayList$1(components); comp$iterator.i < comp$iterator.this$01.array.length;){
        comp = castTo($next_6(comp$iterator), 120);
        $doLayout_0(this.klayTree, comp, progressMonitor.subTask(0.5999999940395355 / components.array.length));
    }
    pm = progressMonitor.subTask($intern_122);
    pm.begin('Pack components', 1);
    tGraph = $pack(components);
    pm.done_1();
    pm = progressMonitor.subTask($intern_122);
    pm.begin('Apply layout results', 1);
    $applyLayout_3(tGraph);
    pm.done_1();
};
var Lorg_eclipse_elk_alg_mrtree_TreeLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeLayoutProvider', 1077);
function getAllIncomingEdges(n, graph) {
    var e, e$iterator, re;
    re = new ArrayList;
    for(e$iterator = $listIterator_2(graph.edges, 0); e$iterator.currentNode != e$iterator.this$01.tail;){
        e = castTo($next_9(e$iterator), 65);
        e.target.id_0 == n.id_0 && maskUndefined($getProperty(e.source, ($clinit_MrTreeOptions(), TREE_LEVEL_0))) !== maskUndefined($getProperty(e.target, TREE_LEVEL_0)) && !$anyMatch(new StreamImpl(null, new Spliterators$IteratorSpliterator(re, 16)), new TreeUtil$lambda$3$Type(e)) && push_1(re.array, e);
    }
    $sort(re, new TreeUtil$lambda$4$Type);
    return re;
}
function getAllOutgoingEdges(n, graph) {
    var e, e$iterator, re;
    re = new ArrayList;
    for(e$iterator = $listIterator_2(graph.edges, 0); e$iterator.currentNode != e$iterator.this$01.tail;){
        e = castTo($next_9(e$iterator), 65);
        e.source.id_0 == n.id_0 && !$equals_5(e.source.label_0, 'SUPER_ROOT') && maskUndefined($getProperty(e.source, ($clinit_MrTreeOptions(), TREE_LEVEL_0))) !== maskUndefined($getProperty(e.target, TREE_LEVEL_0)) && !$anyMatch(new StreamImpl(null, new Spliterators$IteratorSpliterator(re, 16)), new TreeUtil$lambda$7$Type(e)) && push_1(re.array, e);
    }
    $sort(re, new TreeUtil$lambda$8$Type);
    return re;
}
function getDirectionVector(d) {
    switch(d.ordinal){
        case 4:
            return new KVector_1(0, -1);
        case 1:
            return new KVector_1(1, 0);
        case 2:
            return new KVector_1(-1, 0);
        default:
            return new KVector_1(0, 1);
    }
}
function getLeftMost(currentlevel, depth) {
    var cN, cN$iterator, d, nextLevel;
    if (0 < (instanceOf(currentlevel, 16) ? castTo(currentlevel, 16).size_1() : size_24(currentlevel.iterator_0()))) {
        d = depth;
        if (1 < d) {
            --d;
            nextLevel = new TreeUtil$1;
            for(cN$iterator = currentlevel.iterator_0(); cN$iterator.hasNext_0();){
                cN = castTo(cN$iterator.next_1(), 39);
                nextLevel = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                    nextLevel,
                    new TNode$2(cN)
                ]));
            }
            return getLeftMost(nextLevel, d);
        }
        if (d < 0) {
            nextLevel = new TreeUtil$2;
            for(cN$iterator = currentlevel.iterator_0(); cN$iterator.hasNext_0();){
                cN = castTo(cN$iterator.next_1(), 39);
                nextLevel = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                    nextLevel,
                    new TNode$2(cN)
                ]));
            }
            if (0 < (instanceOf(nextLevel, 16) ? castTo(nextLevel, 16).size_1() : size_24(nextLevel.iterator_0()))) return getLeftMost(nextLevel, d);
        }
    }
    return castTo(getNext(currentlevel.iterator_0()), 39);
}
function getLowestParent(n, g) {
    var dirVec, lowestParent, lowestParentPos, parents, sources;
    dirVec = getDirectionVector(castTo($getProperty(g, ($clinit_MrTreeOptions(), DIRECTION_0)), 86));
    if (n.incomingEdges.size_0 == 0) return null;
    sources = castTo($collect_1($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(n.incomingEdges, 16)), new TreeUtil$lambda$9$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    parents = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(g.nodes, 16)), new TreeUtil$lambda$10$Type(sources)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        IDENTITY_FINISH
    ]))), 15);
    lowestParentPos = castToDouble($get_17($max_1($map(parents.stream(), new TreeUtil$lambda$11$Type(dirVec)), ($clinit_Comparators(), $clinit_Comparators(), NATURAL_ORDER))));
    lowestParent = castTo($get_17($findFirst($filter(parents.stream(), new TreeUtil$lambda$12$Type(dirVec, lowestParentPos)))), 39);
    return lowestParent;
}
function isCycleInducing(e, g) {
    return $dotProduct(getDirectionVector(castTo($getProperty(g, ($clinit_MrTreeOptions(), DIRECTION_0)), 86)), new KVector_1(e.target.pos.x_0 - e.source.pos.x_0, e.target.pos.y_0 - e.source.pos.y_0)) <= 0;
}
function lambda$11_0(dirVec_0, x_1) {
    return $dotProduct(new KVector_1(x_1.pos.x_0 + x_1.size_0.x_0 / 2, x_1.pos.y_0 + x_1.size_0.y_0 / 2), dirVec_0);
}
function lambda$12_0(dirVec_0, lowestParentPos_1, x_2) {
    return $dotProduct(new KVector_1(x_2.pos.x_0 + x_2.size_0.x_0 / 2, x_2.pos.y_0 + x_2.size_0.y_0 / 2), dirVec_0) == (checkCriticalNotNull(lowestParentPos_1), lowestParentPos_1);
}
function lambda$3_5(e_0, x_1) {
    return $equals_5(!!x_1.source && !!x_1.target ? $toString_15(x_1.source) + '->' + $toString_15(x_1.target) : 'e_' + hashCode__I__devirtual$(x_1), !!e_0.source && !!e_0.target ? $toString_15(e_0.source) + '->' + $toString_15(e_0.target) : 'e_' + hashCode__I__devirtual$(e_0));
}
function lambda$4_6(x_0, y_1) {
    return compare_4(x_0.source.pos.x_0, y_1.source.pos.x_0);
}
function lambda$7_2(e_0, x_1) {
    return $equals_5(!!x_1.source && !!x_1.target ? $toString_15(x_1.source) + '->' + $toString_15(x_1.target) : 'e_' + hashCode__I__devirtual$(x_1), !!e_0.source && !!e_0.target ? $toString_15(e_0.source) + '->' + $toString_15(e_0.target) : 'e_' + hashCode__I__devirtual$(e_0));
}
function lambda$8_1(x_0, y_1) {
    return compare_4(x_0.target.pos.x_0, y_1.target.pos.x_0);
}
function toNodeBorder(center, next, size_0) {
    var absx, absy, hh, scale, wh, xscale, yscale;
    wh = size_0.x_0 / 2;
    hh = size_0.y_0 / 2;
    absx = $wnd.Math.abs(next.x_0 - center.x_0);
    absy = $wnd.Math.abs(next.y_0 - center.y_0);
    xscale = 1;
    yscale = 1;
    absx > wh && (xscale = wh / absx);
    absy > hh && (yscale = hh / absy);
    scale = $wnd.Math.min(xscale, yscale);
    center.x_0 += scale * (next.x_0 - center.x_0);
    center.y_0 += scale * (next.y_0 - center.y_0);
}
function TreeUtil$1() {}
defineClass(1840, 1, $intern_23, TreeUtil$1);
_.forEach_0 = function forEach_31(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_73() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$1_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/1', 1840);
function TreeUtil$2() {}
defineClass(1841, 1, $intern_23, TreeUtil$2);
_.forEach_0 = function forEach_32(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_74() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$2_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/2', 1841);
function TreeUtil$lambda$0$Type() {}
defineClass(1831, 1, $intern_39, TreeUtil$lambda$0$Type);
_.test_0 = function test_100(arg0) {
    return $booleanValue(castToBoolean($getProperty(castTo(arg0, 39), ($clinit_InternalProperties_2(), ROOT_0))));
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$0$Type', 1831);
function TreeUtil$lambda$10$Type(sources_0) {
    this.sources_0 = sources_0;
}
defineClass(1837, 1, $intern_39, TreeUtil$lambda$10$Type);
_.test_0 = function test_101(arg0) {
    return this.sources_0.contains(castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$10$Type', 1837);
function TreeUtil$lambda$11$Type(dirVec_0) {
    this.dirVec_0 = dirVec_0;
}
defineClass(1838, 1, {}, TreeUtil$lambda$11$Type);
_.apply_0 = function apply_129(arg0) {
    return lambda$11_0(this.dirVec_0, castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$11$Type', 1838);
function TreeUtil$lambda$12$Type(dirVec_0, lowestParentPos_1) {
    this.dirVec_0 = dirVec_0;
    this.lowestParentPos_1 = lowestParentPos_1;
}
defineClass(1839, 1, $intern_39, TreeUtil$lambda$12$Type);
_.test_0 = function test_102(arg0) {
    return lambda$12_0(this.dirVec_0, this.lowestParentPos_1, castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$12$Type', 1839);
function TreeUtil$lambda$3$Type(e_0) {
    this.e_0 = e_0;
}
defineClass(1832, 1, $intern_39, TreeUtil$lambda$3$Type);
_.test_0 = function test_103(arg0) {
    return lambda$3_5(this.e_0, castTo(arg0, 65));
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$3$Type', 1832);
function TreeUtil$lambda$4$Type() {}
defineClass(1833, 1, $intern_88, TreeUtil$lambda$4$Type);
_.compare_1 = function compare_76(arg0, arg1) {
    return lambda$4_6(castTo(arg0, 65), castTo(arg1, 65));
};
_.equals_0 = function equals_163(other) {
    return this === other;
};
_.reversed = function reversed_68() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$4$Type', 1833);
function TreeUtil$lambda$7$Type(e_0) {
    this.e_0 = e_0;
}
defineClass(1834, 1, $intern_39, TreeUtil$lambda$7$Type);
_.test_0 = function test_104(arg0) {
    return lambda$7_2(this.e_0, castTo(arg0, 65));
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$7$Type', 1834);
function TreeUtil$lambda$8$Type() {}
defineClass(1835, 1, $intern_88, TreeUtil$lambda$8$Type);
_.compare_1 = function compare_77(arg0, arg1) {
    return lambda$8_1(castTo(arg0, 65), castTo(arg1, 65));
};
_.equals_0 = function equals_164(other) {
    return this === other;
};
_.reversed = function reversed_69() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$8$Type', 1835);
function TreeUtil$lambda$9$Type() {}
defineClass(1836, 1, {}, TreeUtil$lambda$9$Type);
_.apply_0 = function apply_130(arg0) {
    return castTo(arg0, 65).source;
};
var Lorg_eclipse_elk_alg_mrtree_TreeUtil$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree', 'TreeUtil/lambda$9$Type', 1836);
defineClass(492, 148, {
    3: 1,
    492: 1,
    102: 1,
    148: 1
});
_.id_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_graph_TGraphElement_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TGraphElement', 492);
function TEdge_0(source, target) {
    new LinkedList;
    this.bendPoints = new KVectorChain;
    this.source = source;
    this.target = target;
}
defineClass(65, 492, {
    3: 1,
    65: 1,
    492: 1,
    102: 1,
    148: 1
}, TEdge_0);
_.toString_0 = function toString_106() {
    return !!this.source && !!this.target ? $toString_15(this.source) + '->' + $toString_15(this.target) : 'e_' + hashCode__I__devirtual$(this);
};
var Lorg_eclipse_elk_alg_mrtree_graph_TEdge_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TEdge', 65);
function TGraph() {
    this.nodes = new LinkedList;
    this.edges = new LinkedList;
    this.nodes = new LinkedList;
    this.edges = new LinkedList;
}
defineClass(120, 148, {
    3: 1,
    120: 1,
    102: 1,
    148: 1
}, TGraph);
_.toString_0 = function toString_107() {
    var tEdge, tEdge$iterator, tNode, tNode$iterator, tmp;
    tmp = null;
    for(tNode$iterator = $listIterator_2(this.nodes, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator), 39);
        tmp += (tNode.label_0 == null || tNode.label_0.length == 0 ? 'n_' + tNode.id_0 : 'n_' + tNode.label_0) + '\n';
    }
    for(tEdge$iterator = $listIterator_2(this.edges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
        tEdge = castTo($next_9(tEdge$iterator), 65);
        tmp += (!!tEdge.source && !!tEdge.target ? $toString_15(tEdge.source) + '->' + $toString_15(tEdge.target) : 'e_' + hashCode__I__devirtual$(tEdge)) + '\n';
    }
    return tmp;
};
var Lorg_eclipse_elk_alg_mrtree_graph_TGraph_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TGraph', 120);
defineClass(628, 492, {
    3: 1,
    492: 1,
    628: 1,
    102: 1,
    148: 1
});
var Lorg_eclipse_elk_alg_mrtree_graph_TShape_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TShape', 628);
function $getChildrenCopy(this$static) {
    var children, iEdge, iEdge$iterator;
    children = new LinkedList;
    for(iEdge$iterator = $listIterator_2(this$static.outgoingEdges, 0); iEdge$iterator.currentNode != iEdge$iterator.this$01.tail;){
        iEdge = castTo($next_9(iEdge$iterator), 65);
        $add_7(children, iEdge.target);
    }
    return children;
}
function $getParent(this$static) {
    var edges;
    edges = this$static.incomingEdges;
    if (edges.size_0 == 0) return null;
    return castTo($get_7(edges, 0), 65).source;
}
function $toString_15(this$static) {
    return this$static.label_0 == null || this$static.label_0.length == 0 ? 'n_' + this$static.id_0 : 'n_' + this$static.label_0;
}
function TNode(id_0, graph, label_0) {
    this.id_0 = id_0;
    this.pos = new KVector;
    this.size_0 = new KVector;
    this.outgoingEdges = new LinkedList;
    this.incomingEdges = new LinkedList;
    this.graph_0 = graph;
    this.label_0 = label_0;
}
defineClass(39, 628, {
    3: 1,
    492: 1,
    39: 1,
    628: 1,
    102: 1,
    148: 1
}, TNode);
_.toString_0 = function toString_108() {
    return $toString_15(this);
};
var Lorg_eclipse_elk_alg_mrtree_graph_TNode_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TNode', 39);
function TNode$2(this$0) {
    this.this$01 = this$0;
}
defineClass(235, 1, $intern_23, TNode$2);
_.forEach_0 = function forEach_33(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_75() {
    var edgesIter;
    return edgesIter = $listIterator_2(this.this$01.outgoingEdges, 0), new TNode$2$1(edgesIter);
};
var Lorg_eclipse_elk_alg_mrtree_graph_TNode$2_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TNode/2', 235);
function TNode$2$1(val$edgesIter) {
    this.val$edgesIter2 = val$edgesIter;
}
defineClass(329, 1, $intern_6, TNode$2$1);
_.forEachRemaining = function forEachRemaining_50(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_40() {
    return castTo($next_9(this.val$edgesIter2), 65).target;
};
_.hasNext_0 = function hasNext_39() {
    return $hasNext_5(this.val$edgesIter2);
};
_.remove = function remove_96() {
    $remove_24(this.val$edgesIter2);
};
var Lorg_eclipse_elk_alg_mrtree_graph_TNode$2$1_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.graph', 'TNode/2/1', 329);
function $computeNodeConstraints(tGraph, nodeNodeSpacing) {
    var actualNodes, cand, d, leftNode, p, p$iterator, points, r, right, rightNode, s;
    d = castTo($getProperty(tGraph, ($clinit_MrTreeOptions(), DIRECTION_0)), 86);
    right = d == ($clinit_Direction(), LEFT_6) || d == RIGHT_6 ? DOWN_1 : RIGHT_6;
    actualNodes = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new CompactionProcessor$lambda$4$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    points = castTo($collect_1($map(actualNodes.stream(), new CompactionProcessor$lambda$5$Type(nodeNodeSpacing)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        IDENTITY_FINISH
    ]))), 15);
    points.addAll(castTo($collect_1($map(actualNodes.stream(), new CompactionProcessor$lambda$6$Type(nodeNodeSpacing)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        IDENTITY_FINISH
    ]))), 16));
    points.sort_0(new CompactionProcessor$lambda$7$Type(right));
    s = new TreeSet_0(new CompactionProcessor$lambda$8$Type(d));
    cand = new HashMap;
    for(p$iterator = points.iterator_0(); p$iterator.hasNext_0();){
        p = castTo(p$iterator.next_1(), 239);
        r = castTo(p.first, 39);
        if ($booleanValue(castToBoolean(p.third))) {
            s.map_0.put(r, ($clinit_Boolean(), FALSE_0));
            new TreeSet_1(s.map_0.headMap(r, false)).map_0.size_1() > 0 && $put_6(cand, r, castTo(new TreeSet_1(s.map_0.headMap(r, false)).map_0.lastKey(), 39));
            new TreeSet_1(s.map_0.tailMap(r, true)).map_0.size_1() > 1 && $put_6(cand, $getRightElement(s, r), r);
        } else {
            if (new TreeSet_1(s.map_0.headMap(r, false)).map_0.size_1() > 0) {
                leftNode = castTo(new TreeSet_1(s.map_0.headMap(r, false)).map_0.lastKey(), 39);
                maskUndefined(leftNode) === maskUndefined(getEntryValueOrNull($getEntry_0(cand.hashCodeMap, r))) && castTo($getProperty(r, ($clinit_InternalProperties_2(), COMPACT_CONSTRAINTS)), 15).add_2(leftNode);
            }
            if (new TreeSet_1(s.map_0.tailMap(r, true)).map_0.size_1() > 1) {
                rightNode = $getRightElement(s, r);
                maskUndefined(getEntryValueOrNull($getEntry_0(cand.hashCodeMap, rightNode))) === maskUndefined(r) && castTo($getProperty(rightNode, ($clinit_InternalProperties_2(), COMPACT_CONSTRAINTS)), 15).add_2(r);
            }
            s.map_0.remove_0(r);
        }
    }
}
function $getLowestDependentNode(n, d) {
    var cons, lowestCons;
    cons = castTo($getProperty(n, ($clinit_InternalProperties_2(), COMPACT_CONSTRAINTS)), 15);
    if (!cons || cons.size_1() < 1) return null;
    else if (cons.size_1() == 1) return castTo(cons.get_0(0), 39);
    lowestCons = null;
    switch(d.ordinal){
        case 2:
            lowestCons = castTo($get_17($min_0(cons.stream(), new CompactionProcessor$lambda$9$Type)), 39);
            break;
        case 1:
            lowestCons = castTo($get_17($max_1(cons.stream(), new CompactionProcessor$lambda$10$Type)), 39);
            break;
        case 4:
            lowestCons = castTo($get_17($min_0(cons.stream(), new CompactionProcessor$lambda$11$Type)), 39);
            break;
        case 3:
            lowestCons = castTo($get_17($max_1(cons.stream(), new CompactionProcessor$lambda$12$Type)), 39);
    }
    return lowestCons;
}
function $getRightElement(s, n) {
    var i, tailSet;
    tailSet = new TreeSet_1(s.map_0.tailMap(n, true));
    if (tailSet.map_0.size_1() <= 1) throw toJs(new NullPointerException);
    i = tailSet.map_0.keySet_0().iterator_0();
    i.next_1();
    return castTo(i.next_1(), 39);
}
function $process_83(this$static, tGraph, progressMonitor) {
    var d, dir_0, finalNewPos, finalNewPosSize, level, n, n$iterator, newIndex, newPos, newPosSize, nodeNodeSpacing, nodes, p, pos;
    progressMonitor.begin('Process compaction', 1);
    if (!$booleanValue(castToBoolean($getProperty(tGraph, ($clinit_MrTreeOptions(), COMPACTION_0))))) return;
    dir_0 = castTo($getProperty(tGraph, DIRECTION_0), 86);
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty(tGraph, SPACING_NODE_NODE_1)));
    $setUpLevels(this$static, tGraph, dir_0);
    $computeNodeConstraints(tGraph, nodeNodeSpacing / 2 / 2);
    nodes = tGraph.nodes;
    $sort_0(nodes, new CompactionProcessor$lambda$0$Type(dir_0));
    for(n$iterator = $listIterator_2(nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        if (!$booleanValue(castToBoolean($getProperty(n, ($clinit_InternalProperties_2(), ROOT_0))))) {
            d = $getLowestDependentNode(n, dir_0);
            p = getLowestParent(n, tGraph);
            newPos = 0;
            newPosSize = 0;
            if (d) {
                pos = d.pos;
                switch(dir_0.ordinal){
                    case 2:
                        newPos = pos.x_0 - nodeNodeSpacing - n.size_0.x_0;
                        p.pos.x_0 - nodeNodeSpacing - n.size_0.x_0 < newPos && (newPos = p.pos.x_0 - nodeNodeSpacing - n.size_0.x_0);
                        newPosSize = newPos + n.size_0.x_0;
                        break;
                    case 1:
                        newPos = pos.x_0 + d.size_0.x_0 + nodeNodeSpacing;
                        p.pos.x_0 + nodeNodeSpacing > newPos && (newPos = p.pos.x_0 + p.size_0.x_0 + nodeNodeSpacing);
                        newPosSize = newPos + n.size_0.x_0;
                        break;
                    case 4:
                        newPos = pos.y_0 - nodeNodeSpacing - n.size_0.y_0;
                        p.pos.y_0 - nodeNodeSpacing - n.size_0.y_0 < newPos && (newPos = p.pos.y_0 - nodeNodeSpacing - n.size_0.y_0);
                        newPosSize = newPos + n.size_0.y_0;
                        break;
                    case 3:
                        newPos = pos.y_0 + d.size_0.y_0 + nodeNodeSpacing;
                        p.pos.y_0 + nodeNodeSpacing > newPos && (newPos = p.pos.y_0 + p.size_0.y_0 + nodeNodeSpacing);
                        newPosSize = newPos + n.size_0.y_0;
                }
            } else if (p) switch(dir_0.ordinal){
                case 2:
                    newPos = p.pos.x_0 - nodeNodeSpacing - n.size_0.x_0;
                    newPosSize = newPos + n.size_0.x_0;
                    break;
                case 1:
                    newPos = p.pos.x_0 + p.size_0.x_0 + nodeNodeSpacing;
                    newPosSize = newPos + n.size_0.x_0;
                    break;
                case 4:
                    newPos = p.pos.y_0 - nodeNodeSpacing - n.size_0.y_0;
                    newPosSize = newPos + n.size_0.y_0;
                    break;
                case 3:
                    newPos = p.pos.y_0 + p.size_0.y_0 + nodeNodeSpacing;
                    newPosSize = newPos + n.size_0.y_0;
            }
            if (maskUndefined($getProperty(tGraph, EDGE_ROUTING_MODE_0)) === maskUndefined(($clinit_EdgeRoutingMode(), AVOID_OVERLAP))) {
                finalNewPos = newPos;
                finalNewPosSize = newPosSize;
                level = $findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.levels, 16)), new CompactionProcessor$lambda$1$Type(finalNewPos, finalNewPosSize)));
                if (level.ref != null) dir_0 == ($clinit_Direction(), LEFT_6) || dir_0 == RIGHT_6 ? n.pos.x_0 = newPos : n.pos.y_0 = newPos;
                else {
                    dir_0 == ($clinit_Direction(), LEFT_6) || dir_0 == UP_1 ? level = $findFirst($filter($skip(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.levels, 16))), new CompactionProcessor$lambda$2$Type(finalNewPos))) : level = $findFirst($filter($skip(new StreamImpl(null, new Spliterators$IteratorSpliterator(this$static.levels, 16))), new CompactionProcessor$lambda$3$Type(finalNewPos)));
                    level.ref != null && (dir_0 == LEFT_6 || dir_0 == RIGHT_6 ? n.pos.x_0 = $doubleValue(castToDouble((checkCriticalElement(level.ref != null), castTo(level.ref, 47)).first)) : n.pos.y_0 = $doubleValue(castToDouble((checkCriticalElement(level.ref != null), castTo(level.ref, 47)).first)));
                }
                if (level.ref != null) {
                    newIndex = $indexOf_3(this$static.levels, (checkCriticalElement(level.ref != null), level.ref), 0);
                    if (newIndex > 0 && newIndex != castTo($getProperty(n, TREE_LEVEL_0), 17).value_0) {
                        $setProperty_0(n, COMPACT_LEVEL_ASCENSION, ($clinit_Boolean(), true));
                        $setProperty_0(n, TREE_LEVEL_0, valueOf_3(newIndex));
                    }
                }
            } else dir_0 == ($clinit_Direction(), LEFT_6) || dir_0 == RIGHT_6 ? n.pos.x_0 = newPos : n.pos.y_0 = newPos;
        }
    }
    progressMonitor.done_1();
}
function $setUpLevels(this$static, tGraph, dir_0) {
    var curLevel, n, n$iterator;
    this$static.levels = new ArrayList;
    for(n$iterator = $listIterator_2(tGraph.nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        while(castTo($getProperty(n, ($clinit_MrTreeOptions(), TREE_LEVEL_0)), 17).value_0 > this$static.levels.array.length - 1)$add_3(this$static.levels, new Pair($intern_113, $intern_123));
        curLevel = castTo($getProperty(n, TREE_LEVEL_0), 17).value_0;
        if (dir_0 == ($clinit_Direction(), LEFT_6) || dir_0 == RIGHT_6) {
            n.pos.x_0 < $doubleValue(castToDouble(castTo($get_11(this$static.levels, curLevel), 47).first)) && $setFirst(castTo($get_11(this$static.levels, curLevel), 47), n.pos.x_0);
            n.pos.x_0 + n.size_0.x_0 > $doubleValue(castToDouble(castTo($get_11(this$static.levels, curLevel), 47).second)) && $setSecond(castTo($get_11(this$static.levels, curLevel), 47), n.pos.x_0 + n.size_0.x_0);
        } else {
            n.pos.y_0 < $doubleValue(castToDouble(castTo($get_11(this$static.levels, curLevel), 47).first)) && $setFirst(castTo($get_11(this$static.levels, curLevel), 47), n.pos.y_0);
            n.pos.y_0 + n.size_0.y_0 > $doubleValue(castToDouble(castTo($get_11(this$static.levels, curLevel), 47).second)) && $setSecond(castTo($get_11(this$static.levels, curLevel), 47), n.pos.y_0 + n.size_0.y_0);
        }
    }
}
function CompactionProcessor() {}
function lambda$0_32(dir_0, x_1, y_2) {
    return compare_4($dotProduct(getDirectionVector(dir_0), new KVector_1(x_1.pos.x_0, x_1.pos.y_0)), $dotProduct(getDirectionVector(dir_0), new KVector_1(y_2.pos.x_0, y_2.pos.y_0)));
}
function lambda$1_16(finalNewPos_0, finalNewPosSize_2, x_2) {
    return $doubleValue(castToDouble(x_2.first)) <= finalNewPos_0 && $doubleValue(castToDouble(x_2.second)) >= finalNewPosSize_2;
}
function lambda$10(x_0, y_1) {
    return compare_4(x_0.pos.x_0 + x_0.size_0.x_0, y_1.pos.x_0 + y_1.size_0.x_0);
}
function lambda$11_1(x_0, y_1) {
    return compare_4(x_0.pos.y_0, y_1.pos.y_0);
}
function lambda$12_1(x_0, y_1) {
    return compare_4(x_0.pos.y_0 + x_0.size_0.y_0, y_1.pos.y_0 + y_1.size_0.y_0);
}
function lambda$2_8(finalNewPos_0, x_1) {
    return $doubleValue(castToDouble(x_1.first)) <= finalNewPos_0;
}
function lambda$3_6(finalNewPos_0, x_1) {
    return $doubleValue(castToDouble(x_1.first)) >= finalNewPos_0;
}
function lambda$5_4(nodeNodeSpacing_0, x_1) {
    return new Triple(x_1, $sub($clone_1(x_1.pos), nodeNodeSpacing_0, nodeNodeSpacing_0), ($clinit_Boolean(), true));
}
function lambda$6_1(nodeNodeSpacing_0, x_1) {
    return new Triple(x_1, $add_18($clone_1(x_1.pos), x_1.size_0.x_0 + nodeNodeSpacing_0, x_1.size_0.y_0 + nodeNodeSpacing_0), ($clinit_Boolean(), false));
}
function lambda$7_3(right_0, x_1, y_2) {
    return compare_4($dotProduct(getDirectionVector(right_0), $clone_1(x_1.second)), $dotProduct(getDirectionVector(right_0), $clone_1(y_2.second)));
}
function lambda$8_2(d_0, x_1, y_2) {
    return compare_4($dotProduct(getDirectionVector(d_0), $clone_1(x_1.pos)), $dotProduct(getDirectionVector(d_0), $clone_1(y_2.pos)));
}
function lambda$9(x_0, y_1) {
    return compare_4(x_0.pos.x_0, y_1.pos.x_0);
}
defineClass(1869, 1, $intern_102, CompactionProcessor);
_.process = function process_79(tGraph, progressMonitor) {
    $process_83(this, castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor', 1869);
function CompactionProcessor$lambda$0$Type(dir_0) {
    this.dir_0 = dir_0;
}
defineClass(1870, 1, $intern_88, CompactionProcessor$lambda$0$Type);
_.compare_1 = function compare_78(arg0, arg1) {
    return lambda$0_32(this.dir_0, castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_165(other) {
    return this === other;
};
_.reversed = function reversed_70() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$0$Type', 1870);
function CompactionProcessor$lambda$1$Type(finalNewPos_0, finalNewPosSize_2) {
    this.finalNewPos_0 = finalNewPos_0;
    this.finalNewPosSize_2 = finalNewPosSize_2;
}
defineClass(1871, 1, $intern_39, CompactionProcessor$lambda$1$Type);
_.test_0 = function test_105(arg0) {
    return lambda$1_16(this.finalNewPos_0, this.finalNewPosSize_2, castTo(arg0, 47));
};
_.finalNewPosSize_2 = 0;
_.finalNewPos_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$1$Type', 1871);
function CompactionProcessor$lambda$10$Type() {}
defineClass(1880, 1, $intern_88, CompactionProcessor$lambda$10$Type);
_.compare_1 = function compare_79(arg0, arg1) {
    return lambda$10(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_166(other) {
    return this === other;
};
_.reversed = function reversed_71() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$10$Type', 1880);
function CompactionProcessor$lambda$11$Type() {}
defineClass(1881, 1, $intern_88, CompactionProcessor$lambda$11$Type);
_.compare_1 = function compare_80(arg0, arg1) {
    return lambda$11_1(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_167(other) {
    return this === other;
};
_.reversed = function reversed_72() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$11$Type', 1881);
function CompactionProcessor$lambda$12$Type() {}
defineClass(1882, 1, $intern_88, CompactionProcessor$lambda$12$Type);
_.compare_1 = function compare_81(arg0, arg1) {
    return lambda$12_1(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_168(other) {
    return this === other;
};
_.reversed = function reversed_73() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$12$Type', 1882);
function CompactionProcessor$lambda$2$Type(finalNewPos_0) {
    this.finalNewPos_0 = finalNewPos_0;
}
defineClass(1872, 1, $intern_39, CompactionProcessor$lambda$2$Type);
_.test_0 = function test_106(arg0) {
    return lambda$2_8(this.finalNewPos_0, castTo(arg0, 47));
};
_.finalNewPos_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$2$Type', 1872);
function CompactionProcessor$lambda$3$Type(finalNewPos_0) {
    this.finalNewPos_0 = finalNewPos_0;
}
defineClass(1873, 1, $intern_39, CompactionProcessor$lambda$3$Type);
_.test_0 = function test_107(arg0) {
    return lambda$3_6(this.finalNewPos_0, castTo(arg0, 47));
};
_.finalNewPos_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$3$Type', 1873);
function CompactionProcessor$lambda$4$Type() {}
defineClass(1874, 1, $intern_39, CompactionProcessor$lambda$4$Type);
_.test_0 = function test_108(arg0) {
    return castTo(arg0, 39).label_0.indexOf('SUPER_ROOT') == -1;
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$4$Type', 1874);
function CompactionProcessor$lambda$5$Type(nodeNodeSpacing_0) {
    this.nodeNodeSpacing_0 = nodeNodeSpacing_0;
}
defineClass(1875, 1, {}, CompactionProcessor$lambda$5$Type);
_.apply_0 = function apply_131(arg0) {
    return lambda$5_4(this.nodeNodeSpacing_0, castTo(arg0, 39));
};
_.nodeNodeSpacing_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$5$Type', 1875);
function CompactionProcessor$lambda$6$Type(nodeNodeSpacing_0) {
    this.nodeNodeSpacing_0 = nodeNodeSpacing_0;
}
defineClass(1876, 1, {}, CompactionProcessor$lambda$6$Type);
_.apply_0 = function apply_132(arg0) {
    return lambda$6_1(this.nodeNodeSpacing_0, castTo(arg0, 39));
};
_.nodeNodeSpacing_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$6$Type', 1876);
function CompactionProcessor$lambda$7$Type(right_0) {
    this.right_0 = right_0;
}
defineClass(1877, 1, $intern_88, CompactionProcessor$lambda$7$Type);
_.compare_1 = function compare_82(arg0, arg1) {
    return lambda$7_3(this.right_0, castTo(arg0, 239), castTo(arg1, 239));
};
_.equals_0 = function equals_169(other) {
    return this === other;
};
_.reversed = function reversed_74() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$7$Type', 1877);
function CompactionProcessor$lambda$8$Type(d_0) {
    this.d_0 = d_0;
}
defineClass(1878, 1, $intern_88, CompactionProcessor$lambda$8$Type);
_.compare_1 = function compare_83(arg0, arg1) {
    return lambda$8_2(this.d_0, castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_170(other) {
    return this === other;
};
_.reversed = function reversed_75() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$8$Type', 1878);
function CompactionProcessor$lambda$9$Type() {}
defineClass(1879, 1, $intern_88, CompactionProcessor$lambda$9$Type);
_.compare_1 = function compare_84(arg0, arg1) {
    return lambda$9(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_171(other) {
    return this === other;
};
_.reversed = function reversed_76() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_CompactionProcessor$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'CompactionProcessor/lambda$9$Type', 1879);
function $process_84(tGraph, progressMonitor) {
    var d, n, n$iterator, tmp, tmp2, x_0, y_0;
    progressMonitor.begin('Process directions', 1);
    d = castTo($getProperty(tGraph, ($clinit_MrTreeOptions(), DIRECTION_0)), 86);
    if (d != ($clinit_Direction(), DOWN_1)) for(n$iterator = $listIterator_2(tGraph.nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        x_0 = castTo($getProperty(n, ($clinit_InternalProperties_2(), XCOOR)), 17).value_0;
        y_0 = castTo($getProperty(n, YCOOR), 17).value_0;
        switch(d.ordinal){
            case 4:
                y_0 *= -1;
                break;
            case 1:
                tmp = x_0;
                x_0 = y_0;
                y_0 = tmp;
                break;
            case 2:
                tmp2 = x_0;
                x_0 = -y_0;
                y_0 = tmp2;
        }
        $setProperty_0(n, XCOOR, valueOf_3(x_0));
        $setProperty_0(n, YCOOR, valueOf_3(y_0));
    }
    progressMonitor.done_1();
}
function DirectionProcessor() {}
defineClass(1867, 1, $intern_102, DirectionProcessor);
_.process = function process_80(tGraph, progressMonitor) {
    $process_84(castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_DirectionProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'DirectionProcessor', 1867);
function $calculateFan(this$static, currentLevel) {
    var blockSize, digits, edgesIter, gloValue, i, id_0, index_0, key, locEntry, locEntry$iterator, locFanMap, nextLevel, pId, tChild, tChild$iterator, tNode, tNode$iterator, tNode$iterator0;
    if (currentLevel.size_0 != 0) {
        nextLevel = new LinkedList;
        id_0 = null;
        pId = null;
        digits = round_int($wnd.Math.floor($wnd.Math.log(currentLevel.size_0) * $wnd.Math.LOG10E) + 1);
        index_0 = 0;
        for(tNode$iterator0 = $listIterator_2(currentLevel, 0); tNode$iterator0.currentNode != tNode$iterator0.this$01.tail;){
            tNode = castTo($next_9(tNode$iterator0), 39);
            if (maskUndefined(pId) !== maskUndefined($getProperty(tNode, ($clinit_InternalProperties_2(), ID)))) {
                pId = castToString($getProperty(tNode, ID));
                index_0 = 0;
            }
            pId != null ? id_0 = pId + formatRight(index_0++, digits) : id_0 = formatRight(index_0++, digits);
            $setProperty_0(tNode, ID, id_0);
            for(tChild$iterator = (edgesIter = $listIterator_2(new TNode$2(tNode).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter)); $hasNext_5(tChild$iterator.val$edgesIter2);){
                tChild = castTo($next_9(tChild$iterator.val$edgesIter2), 65).target;
                $addNode_0(nextLevel, tChild, nextLevel.tail.prev, nextLevel.tail);
                $setProperty_0(tChild, ID, id_0);
            }
        }
        locFanMap = new HashMap;
        for(i = 0; i < id_0.length - digits; i++)for(tNode$iterator = $listIterator_2(currentLevel, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
            tNode = castTo($next_9(tNode$iterator), 39);
            key = $substring_1(castToString($getProperty(tNode, ($clinit_InternalProperties_2(), ID))), 0, i + 1);
            blockSize = (key == null ? getEntryValueOrNull($getEntry_0(locFanMap.hashCodeMap, null)) : $get_15(locFanMap.stringMap, key)) != null ? castTo(key == null ? getEntryValueOrNull($getEntry_0(locFanMap.hashCodeMap, null)) : $get_15(locFanMap.stringMap, key), 17).value_0 + 1 : 1;
            $putStringValue(locFanMap, key, valueOf_3(blockSize));
        }
        for(locEntry$iterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(locFanMap).this$01); locEntry$iterator.hasNext;){
            locEntry = $next_3(locEntry$iterator);
            gloValue = valueOf_3($get_10(this$static.gloDescMap, locEntry.getKey()) != null ? castTo($get_10(this$static.gloDescMap, locEntry.getKey()), 17).value_0 : 0);
            $putStringValue(this$static.gloDescMap, castToString(locEntry.getKey()), valueOf_3(castTo(locEntry.getValue(), 17).value_0 + gloValue.value_0));
            gloValue = castTo($get_10(this$static.gloFanMap, locEntry.getKey()), 17);
            (!gloValue || gloValue.value_0 < castTo(locEntry.getValue(), 17).value_0) && $putStringValue(this$static.gloFanMap, castToString(locEntry.getKey()), castTo(locEntry.getValue(), 17));
        }
        $calculateFan(this$static, nextLevel);
    }
}
function $process_85(this$static, tGraph, progressMonitor) {
    var desc, fan, it, key, root, rootLevel, tNode, tNode$iterator;
    progressMonitor.begin('Processor compute fanout', 1);
    $reset(this$static.gloFanMap);
    $reset(this$static.gloDescMap);
    root = null;
    it = $listIterator_2(tGraph.nodes, 0);
    while(!root && it.currentNode != it.this$01.tail){
        tNode = castTo($next_9(it), 39);
        $booleanValue(castToBoolean($getProperty(tNode, ($clinit_InternalProperties_2(), ROOT_0)))) && (root = tNode);
    }
    rootLevel = new LinkedList;
    $addNode_0(rootLevel, root, rootLevel.tail.prev, rootLevel.tail);
    $calculateFan(this$static, rootLevel);
    for(tNode$iterator = $listIterator_2(tGraph.nodes, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator), 39);
        key = castToString($getProperty(tNode, ($clinit_InternalProperties_2(), ID)));
        fan = $getStringValue(this$static.gloFanMap, key) != null ? castTo($getStringValue(this$static.gloFanMap, key), 17).value_0 : 0;
        $setProperty_0(tNode, FAN, valueOf_3(fan));
        desc = 1 + ($getStringValue(this$static.gloDescMap, key) != null ? castTo($getStringValue(this$static.gloDescMap, key), 17).value_0 : 0);
        $setProperty_0(tNode, DESCENDANTS, valueOf_3(desc));
    }
    progressMonitor.done_1();
}
function FanProcessor() {
    this.gloFanMap = new HashMap;
    this.gloDescMap = new HashMap;
}
function formatRight(value_0, len) {
    var s;
    s = value_0 + '';
    while(s.length < len)s = '0' + s;
    return s;
}
defineClass(1859, 1, $intern_102, FanProcessor);
_.process = function process_81(tGraph, progressMonitor) {
    $process_85(this, castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_FanProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'FanProcessor', 1859);
function $process_86(tGraph, progressMonitor) {
    progressMonitor.begin('Process graph bounds', 1);
    $setProperty_0(tGraph, ($clinit_InternalProperties_2(), GRAPH_XMIN), $getAsDouble($min($mapToDouble(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new GraphBoundsProcessor$lambda$0$Type))));
    $setProperty_0(tGraph, GRAPH_YMIN, $getAsDouble($min($mapToDouble(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new GraphBoundsProcessor$lambda$1$Type))));
    $setProperty_0(tGraph, GRAPH_XMAX, $getAsDouble($max($mapToDouble(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new GraphBoundsProcessor$lambda$2$Type))));
    $setProperty_0(tGraph, GRAPH_YMAX, $getAsDouble($max($mapToDouble(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new GraphBoundsProcessor$lambda$3$Type))));
    progressMonitor.done_1();
}
function GraphBoundsProcessor() {}
function lambda$2_9(x_0) {
    return x_0.pos.x_0 + x_0.size_0.x_0;
}
function lambda$3_7(x_0) {
    return x_0.pos.y_0 + x_0.size_0.y_0;
}
defineClass(1883, 1, $intern_102, GraphBoundsProcessor);
_.process = function process_82(tGraph, progressMonitor) {
    $process_86(castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_GraphBoundsProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'GraphBoundsProcessor', 1883);
function GraphBoundsProcessor$lambda$0$Type() {}
defineClass(1884, 1, {}, GraphBoundsProcessor$lambda$0$Type);
_.applyAsDouble = function applyAsDouble_4(arg0) {
    return castTo(arg0, 39).pos.x_0;
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_GraphBoundsProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'GraphBoundsProcessor/lambda$0$Type', 1884);
function GraphBoundsProcessor$lambda$1$Type() {}
defineClass(1885, 1, {}, GraphBoundsProcessor$lambda$1$Type);
_.applyAsDouble = function applyAsDouble_5(arg0) {
    return castTo(arg0, 39).pos.y_0;
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_GraphBoundsProcessor$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'GraphBoundsProcessor/lambda$1$Type', 1885);
function GraphBoundsProcessor$lambda$2$Type() {}
defineClass(1886, 1, {}, GraphBoundsProcessor$lambda$2$Type);
_.applyAsDouble = function applyAsDouble_6(arg0) {
    return lambda$2_9(castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_GraphBoundsProcessor$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'GraphBoundsProcessor/lambda$2$Type', 1886);
function GraphBoundsProcessor$lambda$3$Type() {}
defineClass(1887, 1, {}, GraphBoundsProcessor$lambda$3$Type);
_.applyAsDouble = function applyAsDouble_7(arg0) {
    return lambda$3_7(castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_GraphBoundsProcessor$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'GraphBoundsProcessor/lambda$3$Type', 1887);
function $clinit_IntermediateProcessorStrategy_0() {
    $clinit_IntermediateProcessorStrategy_0 = emptyMethod;
    ROOT_PROC = new IntermediateProcessorStrategy_0('ROOT_PROC', 0);
    FAN_PROC = new IntermediateProcessorStrategy_0('FAN_PROC', 1);
    LEVEL_PROC = new IntermediateProcessorStrategy_0('LEVEL_PROC', 2);
    NEIGHBORS_PROC = new IntermediateProcessorStrategy_0('NEIGHBORS_PROC', 3);
    LEVEL_HEIGHT = new IntermediateProcessorStrategy_0('LEVEL_HEIGHT', 4);
    DIRECTION_PROC = new IntermediateProcessorStrategy_0('DIRECTION_PROC', 5);
    NODE_POSITION_PROC = new IntermediateProcessorStrategy_0('NODE_POSITION_PROC', 6);
    COMPACTION_PROC = new IntermediateProcessorStrategy_0('COMPACTION_PROC', 7);
    LEVEL_COORDS = new IntermediateProcessorStrategy_0('LEVEL_COORDS', 8);
    GRAPH_BOUNDS_PROC = new IntermediateProcessorStrategy_0('GRAPH_BOUNDS_PROC', 9);
    DETREEIFYING_PROC = new IntermediateProcessorStrategy_0('DETREEIFYING_PROC', 10);
}
function IntermediateProcessorStrategy_0(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_67(name_0) {
    $clinit_IntermediateProcessorStrategy_0();
    return valueOf(($clinit_IntermediateProcessorStrategy$Map_0(), $MAP_57), name_0);
}
function values_75() {
    $clinit_IntermediateProcessorStrategy_0();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_intermediate_IntermediateProcessorStrategy_2_classLit, 1), $intern_36, 262, 0, [
        ROOT_PROC,
        FAN_PROC,
        LEVEL_PROC,
        NEIGHBORS_PROC,
        LEVEL_HEIGHT,
        DIRECTION_PROC,
        NODE_POSITION_PROC,
        COMPACTION_PROC,
        LEVEL_COORDS,
        GRAPH_BOUNDS_PROC,
        DETREEIFYING_PROC
    ]);
}
defineClass(262, 23, {
    3: 1,
    34: 1,
    23: 1,
    262: 1,
    196: 1
}, IntermediateProcessorStrategy_0);
_.create_1 = function create_19() {
    switch(this.ordinal){
        case 0:
            return new RootProcessor;
        case 1:
            return new FanProcessor;
        case 2:
            return new LevelProcessor;
        case 3:
            return new NeighborsProcessor;
        case 4:
            return new LevelHeightProcessor;
        case 8:
            return new LevelCoordinatesProcessor;
        case 5:
            return new DirectionProcessor;
        case 6:
            return new NodePositionProcessor;
        case 7:
            return new CompactionProcessor;
        case 9:
            return new GraphBoundsProcessor;
        case 10:
            return new Untreeifyer;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout processor ' + (this.name_0 != null ? this.name_0 : '' + this.ordinal)));
    }
};
var COMPACTION_PROC, DETREEIFYING_PROC, DIRECTION_PROC, FAN_PROC, GRAPH_BOUNDS_PROC, LEVEL_COORDS, LEVEL_HEIGHT, LEVEL_PROC, NEIGHBORS_PROC, NODE_POSITION_PROC, ROOT_PROC;
var Lorg_eclipse_elk_alg_mrtree_intermediate_IntermediateProcessorStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.mrtree.intermediate', 'IntermediateProcessorStrategy', 262, Ljava_lang_Enum_2_classLit, values_75, valueOf_67);
function $clinit_IntermediateProcessorStrategy$Map_0() {
    $clinit_IntermediateProcessorStrategy$Map_0 = emptyMethod;
    $MAP_57 = createValueOfMap(values_75());
}
var $MAP_57;
function $process_87(tGraph, progressMonitor) {
    var curLevel, levels, n, n$iterator, n$iterator0;
    progressMonitor.begin('Processor determine the coords for each level', 1);
    levels = new ArrayList;
    for(n$iterator0 = $listIterator_2(tGraph.nodes, 0); n$iterator0.currentNode != n$iterator0.this$01.tail;){
        n = castTo($next_9(n$iterator0), 39);
        while(castTo($getProperty(n, ($clinit_MrTreeOptions(), TREE_LEVEL_0)), 17).value_0 > levels.array.length - 1)$add_3(levels, new Pair($intern_113, $intern_123));
        curLevel = castTo($getProperty(n, TREE_LEVEL_0), 17).value_0;
        if ($isHorizontal(castTo($getProperty(tGraph, DIRECTION_0), 86))) {
            n.pos.x_0 < $doubleValue(castToDouble((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)).first)) && $setFirst((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)), n.pos.x_0);
            n.pos.x_0 + n.size_0.x_0 > $doubleValue(castToDouble((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)).second)) && $setSecond((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)), n.pos.x_0 + n.size_0.x_0);
        } else {
            n.pos.y_0 < $doubleValue(castToDouble((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)).first)) && $setFirst((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)), n.pos.y_0);
            n.pos.y_0 + n.size_0.y_0 > $doubleValue(castToDouble((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)).second)) && $setSecond((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)), n.pos.y_0 + n.size_0.y_0);
        }
    }
    for(n$iterator = $listIterator_2(tGraph.nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        curLevel = castTo($getProperty(n, ($clinit_MrTreeOptions(), TREE_LEVEL_0)), 17).value_0;
        $setProperty_0(n, ($clinit_InternalProperties_2(), LEVELMIN), castToDouble((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)).first));
        $setProperty_0(n, LEVELMAX, castToDouble((checkCriticalElementIndex(curLevel, levels.array.length), castTo(levels.array[curLevel], 47)).second));
    }
    progressMonitor.done_1();
}
function LevelCoordinatesProcessor() {}
defineClass(1866, 1, $intern_102, LevelCoordinatesProcessor);
_.process = function process_83(tGraph, progressMonitor) {
    $process_87(castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_LevelCoordinatesProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'LevelCoordinatesProcessor', 1866);
function $process_88(this$static, tGraph, progressMonitor) {
    var it, root, tNode;
    progressMonitor.begin('Processor determine the height for each level', 1);
    this$static.numberOfNodes = tGraph.nodes.size_0 == 0 ? 1 : tGraph.nodes.size_0;
    root = null;
    it = $listIterator_2(tGraph.nodes, 0);
    while(!root && it.currentNode != it.this$01.tail){
        tNode = castTo($next_9(it), 39);
        $booleanValue(castToBoolean($getProperty(tNode, ($clinit_InternalProperties_2(), ROOT_0)))) && (root = tNode);
    }
    !!root && $setNeighbors(this$static, newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_graph_TNode_2_classLit, 1), $intern_124, 39, 0, [
        root
    ])), progressMonitor, castTo($getProperty(tGraph, ($clinit_MrTreeOptions(), DIRECTION_0)), 86));
    progressMonitor.done_1();
}
function $setNeighbors(this$static, currentLevel, progressMonitor, layoutDirection) {
    var cN, cN$iterator, cN$iterator0, height, nextLevel, sT;
    if (!isEmpty_13(currentLevel)) {
        sT = progressMonitor.subTask((instanceOf(currentLevel, 16) ? castTo(currentLevel, 16).size_1() : size_24(currentLevel.iterator_0())) / this$static.numberOfNodes | 0);
        sT.begin('Set neighbors in level', 1);
        nextLevel = new LevelHeightProcessor$1;
        height = 0;
        if (layoutDirection == ($clinit_Direction(), LEFT_6) || layoutDirection == RIGHT_6) for(cN$iterator0 = currentLevel.iterator_0(); cN$iterator0.hasNext_0();){
            cN = castTo(cN$iterator0.next_1(), 39);
            nextLevel = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                nextLevel,
                new TNode$2(cN)
            ]));
            height < cN.size_0.x_0 && (height = cN.size_0.x_0);
        }
        else for(cN$iterator0 = currentLevel.iterator_0(); cN$iterator0.hasNext_0();){
            cN = castTo(cN$iterator0.next_1(), 39);
            nextLevel = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                nextLevel,
                new TNode$2(cN)
            ]));
            height < cN.size_0.y_0 && (height = cN.size_0.y_0);
        }
        for(cN$iterator = currentLevel.iterator_0(); cN$iterator.hasNext_0();){
            cN = castTo(cN$iterator.next_1(), 39);
            $setProperty_0(cN, ($clinit_InternalProperties_2(), LEVELHEIGHT), height);
        }
        sT.done_1();
        $setNeighbors(this$static, nextLevel, progressMonitor, layoutDirection);
    }
}
function LevelHeightProcessor() {}
defineClass(1864, 1, $intern_102, LevelHeightProcessor);
_.process = function process_84(tGraph, progressMonitor) {
    $process_88(this, castTo(tGraph, 120), progressMonitor);
};
_.numberOfNodes = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_LevelHeightProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'LevelHeightProcessor', 1864);
function LevelHeightProcessor$1() {}
defineClass(1865, 1, $intern_23, LevelHeightProcessor$1);
_.forEach_0 = function forEach_34(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_76() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_LevelHeightProcessor$1_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'LevelHeightProcessor/1', 1865);
function $process_89(this$static, tGraph, progressMonitor) {
    var level, roots, tNode, tNode$iterator;
    progressMonitor.begin('Processor compute fanout', 1);
    roots = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new LevelProcessor$lambda$0$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    $setLevel_0(this$static, roots, 0);
    for(tNode$iterator = $listIterator_2(tGraph.nodes, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator), 39);
        level = $get_10(this$static.gloLevelMap, valueOf_3(tNode.id_0)) != null ? castTo($get_10(this$static.gloLevelMap, valueOf_3(tNode.id_0)), 17).value_0 : 0;
        $setProperty_0(tNode, ($clinit_MrTreeOptions(), TREE_LEVEL_0), valueOf_3(level));
    }
    progressMonitor.done_1();
}
function $setLevel_0(this$static, currentLevel, level) {
    var edgesIter, nextLevel, tChild, tChild$iterator, tNode, tNode$iterator;
    if (!currentLevel.isEmpty()) {
        nextLevel = new LinkedList;
        for(tNode$iterator = currentLevel.iterator_0(); tNode$iterator.hasNext_0();){
            tNode = castTo(tNode$iterator.next_1(), 39);
            $put_6(this$static.gloLevelMap, valueOf_3(tNode.id_0), valueOf_3(level));
            for(tChild$iterator = (edgesIter = $listIterator_2(new TNode$2(tNode).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter)); $hasNext_5(tChild$iterator.val$edgesIter2);){
                tChild = castTo($next_9(tChild$iterator.val$edgesIter2), 65).target;
                $addNode_0(nextLevel, tChild, nextLevel.tail.prev, nextLevel.tail);
            }
        }
        $setLevel_0(this$static, nextLevel, level + 1);
    }
}
function LevelProcessor() {
    this.gloLevelMap = new HashMap;
}
defineClass(1860, 1, $intern_102, LevelProcessor);
_.process = function process_85(tGraph, progressMonitor) {
    $process_89(this, castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_LevelProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'LevelProcessor', 1860);
function LevelProcessor$lambda$0$Type() {}
defineClass(1861, 1, $intern_39, LevelProcessor$lambda$0$Type);
_.test_0 = function test_109(arg0) {
    return $booleanValue(castToBoolean($getProperty(castTo(arg0, 39), ($clinit_InternalProperties_2(), ROOT_0))));
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_LevelProcessor$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'LevelProcessor/lambda$0$Type', 1861);
function $process_90(this$static, tGraph, progressMonitor) {
    var it, root, tNode;
    progressMonitor.begin('Processor set neighbors', 1);
    this$static.numberOfNodes = tGraph.nodes.size_0 == 0 ? 1 : tGraph.nodes.size_0;
    root = null;
    it = $listIterator_2(tGraph.nodes, 0);
    while(!root && it.currentNode != it.this$01.tail){
        tNode = castTo($next_9(it), 39);
        $booleanValue(castToBoolean($getProperty(tNode, ($clinit_InternalProperties_2(), ROOT_0)))) && (root = tNode);
    }
    !!root && $setNeighbors_0(this$static, new TNode$2(root), progressMonitor);
    progressMonitor.done_1();
}
function $setNeighbors_0(this$static, currentLevel, progressMonitor) {
    var cN, cN$iterator, lN, nextLevel, sT;
    if (!isEmpty_13(currentLevel)) {
        sT = progressMonitor.subTask((instanceOf(currentLevel, 16) ? castTo(currentLevel, 16).size_1() : size_24(currentLevel.iterator_0())) / this$static.numberOfNodes | 0);
        sT.begin('Set neighbors in level', 1);
        nextLevel = new NeighborsProcessor$1;
        lN = null;
        for(cN$iterator = currentLevel.iterator_0(); cN$iterator.hasNext_0();){
            cN = castTo(cN$iterator.next_1(), 39);
            nextLevel = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
                nextLevel,
                new TNode$2(cN)
            ]));
            if (lN) {
                $setProperty_0(lN, ($clinit_InternalProperties_2(), RIGHTNEIGHBOR), cN);
                $setProperty_0(cN, LEFTNEIGHBOR, lN);
                if ($getParent(cN) == $getParent(lN)) {
                    $setProperty_0(lN, RIGHTSIBLING, cN);
                    $setProperty_0(cN, LEFTSIBLING, lN);
                }
            }
            lN = cN;
        }
        sT.done_1();
        $setNeighbors_0(this$static, nextLevel, progressMonitor);
    }
}
function NeighborsProcessor() {}
defineClass(1862, 1, $intern_102, NeighborsProcessor);
_.process = function process_86(tGraph, progressMonitor) {
    $process_90(this, castTo(tGraph, 120), progressMonitor);
};
_.numberOfNodes = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_NeighborsProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'NeighborsProcessor', 1862);
function NeighborsProcessor$1() {}
defineClass(1863, 1, $intern_23, NeighborsProcessor$1);
_.forEach_0 = function forEach_35(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_77() {
    return $clinit_Collections(), $clinit_Collections$EmptyListIterator(), INSTANCE_4;
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_NeighborsProcessor$1_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'NeighborsProcessor/1', 1863);
function $process_91(this$static, tGraph, progressMonitor) {
    var it, lastArg, n, n$iterator, nextLevel, pos, root, subTasks, tNode;
    progressMonitor.begin('Processor set coordinates', 1);
    this$static.numberOfNodes = tGraph.nodes.size_0 == 0 ? 1 : tGraph.nodes.size_0;
    root = null;
    it = $listIterator_2(tGraph.nodes, 0);
    while(!root && it.currentNode != it.this$01.tail){
        tNode = castTo($next_9(it), 39);
        if ($booleanValue(castToBoolean($getProperty(tNode, ($clinit_InternalProperties_2(), ROOT_0))))) {
            root = tNode;
            pos = tNode.pos;
            pos.x_0 = castTo($getProperty(tNode, XCOOR), 17).value_0;
            pos.y_0 = castTo($getProperty(tNode, YCOOR), 17).value_0;
        }
    }
    nextLevel = $getChildrenCopy(root);
    subTasks = 1;
    do {
        nextLevel = $setCoordinates((lastArg = nextLevel, progressMonitor.subTask(subTasks), lastArg));
        subTasks = nextLevel.size_0 / this$static.numberOfNodes | 0;
    }while (nextLevel.size_0 != 0);
    for(n$iterator = $listIterator_2(tGraph.nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        $sub_0(n.pos, new KVector_1(n.size_0.x_0 / 2, n.size_0.y_0 / 2));
    }
    progressMonitor.done_1();
}
function $setCoordinates(currentLevel) {
    var nextLevel, pos, tNode, tNode$iterator;
    if (currentLevel.size_0 != 0) {
        nextLevel = new LinkedList;
        for(tNode$iterator = $listIterator_2(currentLevel, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
            tNode = castTo($next_9(tNode$iterator), 39);
            $addAll(nextLevel, $getChildrenCopy(tNode));
            pos = tNode.pos;
            pos.x_0 = castTo($getProperty(tNode, ($clinit_InternalProperties_2(), XCOOR)), 17).value_0;
            pos.y_0 = castTo($getProperty(tNode, YCOOR), 17).value_0;
        }
        return nextLevel;
    }
    return new LinkedList;
}
function NodePositionProcessor() {}
defineClass(1868, 1, $intern_102, NodePositionProcessor);
_.process = function process_87(tGraph, progressMonitor) {
    $process_91(this, castTo(tGraph, 120), progressMonitor);
};
_.numberOfNodes = 0;
var Lorg_eclipse_elk_alg_mrtree_intermediate_NodePositionProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'NodePositionProcessor', 1868);
function $process_92(this$static, tGraph, progressMonitor) {
    var node, node$iterator, root, superRoot, tRoot, tRoot$iterator, newEdge;
    progressMonitor.begin('Find roots', 1);
    this$static.roots.array.length = 0;
    for(node$iterator = $listIterator_2(tGraph.nodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
        node = castTo($next_9(node$iterator), 39);
        if (node.incomingEdges.size_0 == 0) {
            $setProperty_0(node, ($clinit_InternalProperties_2(), ROOT_0), ($clinit_Boolean(), true));
            $add_3(this$static.roots, node);
        }
    }
    switch(this$static.roots.array.length){
        case 0:
            root = new TNode(0, tGraph, 'DUMMY_ROOT');
            $setProperty_0(root, ($clinit_InternalProperties_2(), ROOT_0), ($clinit_Boolean(), true));
            $setProperty_0(root, DUMMY, true);
            $add_7(tGraph.nodes, root);
            break;
        case 1:
            break;
        default:
            superRoot = new TNode(0, tGraph, 'SUPER_ROOT');
            for(tRoot$iterator = new ArrayList$1(this$static.roots); tRoot$iterator.i < tRoot$iterator.this$01.array.length;){
                tRoot = castTo($next_6(tRoot$iterator), 39);
                newEdge = new TEdge_0(superRoot, tRoot);
                $setProperty_0(newEdge, ($clinit_InternalProperties_2(), DUMMY), ($clinit_Boolean(), true));
                $add_7(superRoot.graph_0.edges, newEdge);
                $add_7(superRoot.outgoingEdges, newEdge);
                $add_7(tRoot.incomingEdges, newEdge);
                $setProperty_0(tRoot, ROOT_0, false);
            }
            $setProperty_0(superRoot, ($clinit_InternalProperties_2(), ROOT_0), ($clinit_Boolean(), true));
            $setProperty_0(superRoot, DUMMY, true);
            $add_7(tGraph.nodes, superRoot);
    }
    progressMonitor.done_1();
}
function RootProcessor() {
    this.roots = new ArrayList;
}
defineClass(1858, 1, $intern_102, RootProcessor);
_.process = function process_88(tGraph, progressMonitor) {
    $process_92(this, castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_RootProcessor_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'RootProcessor', 1858);
function $process_93(tGraph, progressMonitor) {
    var edges, tEdge, tEdge$iterator;
    progressMonitor.begin('Untreeify', 1);
    edges = castTo($getProperty(tGraph, ($clinit_InternalProperties_2(), REMOVABLE_EDGES)), 15);
    for(tEdge$iterator = edges.iterator_0(); tEdge$iterator.hasNext_0();){
        tEdge = castTo(tEdge$iterator.next_1(), 65);
        $add_7(tEdge.source.outgoingEdges, tEdge);
        $add_7(tEdge.target.incomingEdges, tEdge);
    }
    progressMonitor.done_1();
}
function Untreeifyer() {}
defineClass(1888, 1, $intern_102, Untreeifyer);
_.process = function process_89(tGraph, progressMonitor) {
    $process_93(castTo(tGraph, 120), progressMonitor);
};
var Lorg_eclipse_elk_alg_mrtree_intermediate_Untreeifyer_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.intermediate', 'Untreeifyer', 1888);
function $clinit_EdgeRoutingMode() {
    $clinit_EdgeRoutingMode = emptyMethod;
    NONE_12 = new EdgeRoutingMode('NONE', 0);
    MIDDLE_TO_MIDDLE = new EdgeRoutingMode('MIDDLE_TO_MIDDLE', 1);
    AVOID_OVERLAP = new EdgeRoutingMode('AVOID_OVERLAP', 2);
}
function EdgeRoutingMode(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_68(name_0) {
    $clinit_EdgeRoutingMode();
    return valueOf(($clinit_EdgeRoutingMode$Map(), $MAP_58), name_0);
}
function values_76() {
    $clinit_EdgeRoutingMode();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_options_EdgeRoutingMode_2_classLit, 1), $intern_36, 383, 0, [
        NONE_12,
        MIDDLE_TO_MIDDLE,
        AVOID_OVERLAP
    ]);
}
defineClass(383, 23, {
    3: 1,
    34: 1,
    23: 1,
    383: 1
}, EdgeRoutingMode);
var AVOID_OVERLAP, MIDDLE_TO_MIDDLE, NONE_12;
var Lorg_eclipse_elk_alg_mrtree_options_EdgeRoutingMode_2_classLit = createForEnum('org.eclipse.elk.alg.mrtree.options', 'EdgeRoutingMode', 383, Ljava_lang_Enum_2_classLit, values_76, valueOf_68);
function $clinit_EdgeRoutingMode$Map() {
    $clinit_EdgeRoutingMode$Map = emptyMethod;
    $MAP_58 = createValueOfMap(($clinit_EdgeRoutingMode(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_options_EdgeRoutingMode_2_classLit, 1), $intern_36, 383, 0, [
        NONE_12,
        MIDDLE_TO_MIDDLE,
        AVOID_OVERLAP
    ])));
}
var $MAP_58;
function $clinit_InternalProperties_2() {
    $clinit_InternalProperties_2 = emptyMethod;
    ORIGIN_1 = new Property('origin');
    new Property('random');
    new Property_0('DEPTH', valueOf_3(0));
    FAN = new Property_0('FAN', valueOf_3(0));
    DESCENDANTS = new Property_0('DESCENDANTS', valueOf_3(0));
    ROOT_0 = new Property_0('ROOT', ($clinit_Boolean(), false));
    LEFTNEIGHBOR = new Property_0('LEFTNEIGHBOR', null);
    RIGHTNEIGHBOR = new Property_0('RIGHTNEIGHBOR', null);
    LEFTSIBLING = new Property_0('LEFTSIBLING', null);
    RIGHTSIBLING = new Property_0('RIGHTSIBLING', null);
    DUMMY = new Property_0('DUMMY', false);
    new Property_0('LEVEL', valueOf_3(0));
    REMOVABLE_EDGES = new Property_0('REMOVABLE_EDGES', new LinkedList);
    XCOOR = new Property_0('XCOOR', valueOf_3(0));
    YCOOR = new Property_0('YCOOR', valueOf_3(0));
    LEVELHEIGHT = new Property_0('LEVELHEIGHT', 0);
    LEVELMIN = new Property_0('LEVELMIN', 0);
    LEVELMAX = new Property_0('LEVELMAX', 0);
    GRAPH_XMIN = new Property_0('GRAPH_XMIN', 0);
    GRAPH_YMIN = new Property_0('GRAPH_YMIN', 0);
    GRAPH_XMAX = new Property_0('GRAPH_XMAX', 0);
    GRAPH_YMAX = new Property_0('GRAPH_YMAX', 0);
    COMPACT_LEVEL_ASCENSION = new Property_0('COMPACT_LEVEL_ASCENSION', false);
    COMPACT_CONSTRAINTS = new Property_0('COMPACT_CONSTRAINTS', new ArrayList);
    ID = new Property_0('ID', '');
    POSITION_0 = new Property_0('POSITION', valueOf_3(0));
    PRELIM = new Property_0('PRELIM', 0);
    MODIFIER = new Property_0('MODIFIER', 0);
    BB_UPLEFT_0 = new Property('boundingBox.upLeft');
    BB_LOWRIGHT_0 = new Property('boundingBox.lowRight');
}
var BB_LOWRIGHT_0, BB_UPLEFT_0, COMPACT_CONSTRAINTS, COMPACT_LEVEL_ASCENSION, DESCENDANTS, DUMMY, FAN, GRAPH_XMAX, GRAPH_XMIN, GRAPH_YMAX, GRAPH_YMIN, ID, LEFTNEIGHBOR, LEFTSIBLING, LEVELHEIGHT, LEVELMAX, LEVELMIN, MODIFIER, ORIGIN_1, POSITION_0, PRELIM, REMOVABLE_EDGES, RIGHTNEIGHBOR, RIGHTSIBLING, ROOT_0, XCOOR, YCOOR;
function $clinit_MrTreeMetaDataProvider() {
    $clinit_MrTreeMetaDataProvider = emptyMethod;
    COMPACTION = new Property_1('org.eclipse.elk.mrtree.compaction', ($clinit_Boolean(), false));
    EDGE_END_TEXTURE_LENGTH = new Property_1('org.eclipse.elk.mrtree.edgeEndTextureLength', 7);
    valueOf_3(0);
    TREE_LEVEL = new Property_1('org.eclipse.elk.mrtree.treeLevel', valueOf_3(0));
    POSITION_CONSTRAINT = new Property_1('org.eclipse.elk.mrtree.positionConstraint', valueOf_3(-1));
    WEIGHTING_DEFAULT = ($clinit_OrderWeighting(), MODEL_ORDER_2);
    WEIGHTING = new Property_1('org.eclipse.elk.mrtree.weighting', WEIGHTING_DEFAULT);
    EDGE_ROUTING_MODE_DEFAULT = ($clinit_EdgeRoutingMode(), AVOID_OVERLAP);
    EDGE_ROUTING_MODE = new Property_1('org.eclipse.elk.mrtree.edgeRoutingMode', EDGE_ROUTING_MODE_DEFAULT);
    SEARCH_ORDER_DEFAULT = ($clinit_TreeifyingOrder(), DFS);
    SEARCH_ORDER = new Property_1('org.eclipse.elk.mrtree.searchOrder', SEARCH_ORDER_DEFAULT);
}
function MrTreeMetaDataProvider() {
    $clinit_MrTreeMetaDataProvider();
}
defineClass(841, 1, $intern_98, MrTreeMetaDataProvider);
_.apply_4 = function apply_133(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.compaction'), ''), 'Position Constraint'), 'Turns on Tree compaction which decreases the size of the whole tree by placing nodes of multiple levels in one large level'), ($clinit_Boolean(), false)), ($clinit_LayoutOptionData$Type(), BOOLEAN)), Ljava_lang_Boolean_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.edgeEndTextureLength'), ''), 'Edge End Texture Length'), 'Should be set to the length of the texture at the end of an edge. This value can be used to improve the Edge Routing.'), 7), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.treeLevel'), ''), 'Tree Level'), 'The index for the tree level the node is in'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.positionConstraint'), ''), 'Position Constraint'), 'When set to a positive number this option will force the algorithm to place the node to the specified position within the trees layer if weighting is set to constraint'), valueOf_3(-1)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.weighting'), ''), 'Weighting of Nodes'), 'Which weighting to use when computing a node order.'), WEIGHTING_DEFAULT), ENUM), Lorg_eclipse_elk_alg_mrtree_options_OrderWeighting_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.edgeRoutingMode'), ''), 'Edge Routing Mode'), 'Chooses an Edge Routing algorithm.'), EDGE_ROUTING_MODE_DEFAULT), ENUM), Lorg_eclipse_elk_alg_mrtree_options_EdgeRoutingMode_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.mrtree.searchOrder'), ''), 'Search Order'), 'Which search order to use when computing a spanning tree.'), SEARCH_ORDER_DEFAULT), ENUM), Lorg_eclipse_elk_alg_mrtree_options_TreeifyingOrder_2_classLit), of_1(PARENTS))));
    $apply_9((new MrTreeOptions, registry));
};
var COMPACTION, EDGE_END_TEXTURE_LENGTH, EDGE_ROUTING_MODE, EDGE_ROUTING_MODE_DEFAULT, POSITION_CONSTRAINT, SEARCH_ORDER, SEARCH_ORDER_DEFAULT, TREE_LEVEL, WEIGHTING, WEIGHTING_DEFAULT;
var Lorg_eclipse_elk_alg_mrtree_options_MrTreeMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.options', 'MrTreeMetaDataProvider', 841);
function $clinit_MrTreeOptions() {
    $clinit_MrTreeOptions = emptyMethod;
    PADDING_DEFAULT_1 = new ElkPadding_0(20);
    PADDING_1 = new Property_2(($clinit_CoreOptions(), PADDING_5), PADDING_DEFAULT_1);
    SPACING_NODE_NODE_1 = new Property_2(SPACING_NODE_NODE_6, 20);
    SPACING_EDGE_NODE_0 = new Property_2(SPACING_EDGE_NODE_1, 3);
    ASPECT_RATIO_1 = new Property_2(ASPECT_RATIO_4, $intern_99);
    PRIORITY_1 = new Property_2(PRIORITY_3, valueOf_3(1));
    SEPARATE_CONNECTED_COMPONENTS_1 = new Property_2(SEPARATE_CONNECTED_COMPONENTS_2, ($clinit_Boolean(), true));
    DEBUG_MODE_0 = DEBUG_MODE_3;
    DIRECTION_DEFAULT_0 = ($clinit_Direction(), UNDEFINED_2);
    DIRECTION_0 = new Property_2(DIRECTION_1, DIRECTION_DEFAULT_0);
    INTERACTIVE_5 = INTERACTIVE_8;
    INTERACTIVE_LAYOUT_0 = INTERACTIVE_LAYOUT_2;
    NODE_SIZE_CONSTRAINTS_2 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_FIXED_GRAPH_SIZE_1 = NODE_SIZE_FIXED_GRAPH_SIZE_3;
    NODE_SIZE_MINIMUM_1 = NODE_SIZE_MINIMUM_5;
    NODE_SIZE_OPTIONS_2 = NODE_SIZE_OPTIONS_6;
    NODE_LABELS_PLACEMENT_2 = NODE_LABELS_PLACEMENT_5;
    OMIT_NODE_MICRO_LAYOUT_1 = OMIT_NODE_MICRO_LAYOUT_4;
    PORT_LABELS_PLACEMENT_2 = PORT_LABELS_PLACEMENT_5;
    WEIGHTING_0 = ($clinit_MrTreeMetaDataProvider(), WEIGHTING);
    SEARCH_ORDER_0 = SEARCH_ORDER;
    TOPDOWN_LAYOUT_1 = TOPDOWN_LAYOUT_2;
    TOPDOWN_SCALE_FACTOR_1 = TOPDOWN_SCALE_FACTOR_2;
    TOPDOWN_HIERARCHICAL_NODE_WIDTH_1 = TOPDOWN_HIERARCHICAL_NODE_WIDTH_2;
    TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_1 = TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2;
    TOPDOWN_NODE_TYPE_DEFAULT_1 = ($clinit_TopdownNodeTypes(), HIERARCHICAL_NODE);
    new Property_2(TOPDOWN_NODE_TYPE, TOPDOWN_NODE_TYPE_DEFAULT_1);
    POSITION_CONSTRAINT_0 = POSITION_CONSTRAINT;
    EDGE_ROUTING_MODE_0 = EDGE_ROUTING_MODE;
    TREE_LEVEL_0 = TREE_LEVEL;
    COMPACTION_0 = COMPACTION;
    EDGE_END_TEXTURE_LENGTH_0 = EDGE_END_TEXTURE_LENGTH;
}
function $apply_9(registry) {
    $register(registry, new LayoutAlgorithmData($supportedFeatures($category($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.mrtree'), 'ELK Mr. Tree'), "Tree-based algorithm provided by the Eclipse Layout Kernel. Computes a spanning tree of the input graph and arranges all nodes according to the resulting parent-children hierarchy. I pity the fool who doesn't use Mr. Tree Layout."), new MrTreeOptions$MrtreeFactory), 'org.eclipse.elk.tree'), of_1(($clinit_GraphFeature(), DISCONNECTED)))));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.padding', PADDING_DEFAULT_1);
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.spacing.nodeNode', 20);
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.spacing.edgeNode', 3);
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.aspectRatio', $intern_99);
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.priority', valueOf_3(1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.separateConnectedComponents', ($clinit_Boolean(), true));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.debugMode', $getDefault(DEBUG_MODE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.direction', DIRECTION_DEFAULT_0);
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.interactive', $getDefault(INTERACTIVE_5));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.interactiveLayout', $getDefault(INTERACTIVE_LAYOUT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_2));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.nodeSize.fixedGraphSize', $getDefault(NODE_SIZE_FIXED_GRAPH_SIZE_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS_2));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.nodeLabels.placement', $getDefault(NODE_LABELS_PLACEMENT_2));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.omitNodeMicroLayout', $getDefault(OMIT_NODE_MICRO_LAYOUT_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.portLabels.placement', $getDefault(PORT_LABELS_PLACEMENT_2));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.weighting', $getDefault(WEIGHTING_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.searchOrder', $getDefault(SEARCH_ORDER_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.topdownLayout', $getDefault(TOPDOWN_LAYOUT_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.topdown.scaleFactor', $getDefault(TOPDOWN_SCALE_FACTOR_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.topdown.hierarchicalNodeWidth', $getDefault(TOPDOWN_HIERARCHICAL_NODE_WIDTH_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', $getDefault(TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_1));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.topdown.nodeType', TOPDOWN_NODE_TYPE_DEFAULT_1);
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.positionConstraint', $getDefault(POSITION_CONSTRAINT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.edgeRoutingMode', $getDefault(EDGE_ROUTING_MODE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.treeLevel', $getDefault(TREE_LEVEL_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.compaction', $getDefault(COMPACTION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.mrtree', 'org.eclipse.elk.mrtree.edgeEndTextureLength', $getDefault(EDGE_END_TEXTURE_LENGTH_0));
}
function MrTreeOptions() {
    $clinit_MrTreeOptions();
}
defineClass(983, 1, $intern_98, MrTreeOptions);
_.apply_4 = function apply_134(registry) {
    $apply_9(registry);
};
var ASPECT_RATIO_1, COMPACTION_0, DEBUG_MODE_0, DIRECTION_0, DIRECTION_DEFAULT_0, EDGE_END_TEXTURE_LENGTH_0, EDGE_ROUTING_MODE_0, INTERACTIVE_5, INTERACTIVE_LAYOUT_0, NODE_LABELS_PLACEMENT_2, NODE_SIZE_CONSTRAINTS_2, NODE_SIZE_FIXED_GRAPH_SIZE_1, NODE_SIZE_MINIMUM_1, NODE_SIZE_OPTIONS_2, OMIT_NODE_MICRO_LAYOUT_1, PADDING_1, PADDING_DEFAULT_1, PORT_LABELS_PLACEMENT_2, POSITION_CONSTRAINT_0, PRIORITY_1, SEARCH_ORDER_0, SEPARATE_CONNECTED_COMPONENTS_1, SPACING_EDGE_NODE_0, SPACING_NODE_NODE_1, TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_1, TOPDOWN_HIERARCHICAL_NODE_WIDTH_1, TOPDOWN_LAYOUT_1, TOPDOWN_NODE_TYPE_DEFAULT_1, TOPDOWN_SCALE_FACTOR_1, TREE_LEVEL_0, WEIGHTING_0;
var Lorg_eclipse_elk_alg_mrtree_options_MrTreeOptions_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.options', 'MrTreeOptions', 983);
function MrTreeOptions$MrtreeFactory() {}
defineClass(984, 1, {}, MrTreeOptions$MrtreeFactory);
_.create_0 = function create_20() {
    var provider;
    return provider = new TreeLayoutProvider, provider;
};
_.destroy = function destroy_2(obj) {};
var Lorg_eclipse_elk_alg_mrtree_options_MrTreeOptions$MrtreeFactory_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.options', 'MrTreeOptions/MrtreeFactory', 984);
function $clinit_OrderWeighting() {
    $clinit_OrderWeighting = emptyMethod;
    MODEL_ORDER_2 = new OrderWeighting('MODEL_ORDER', 0);
    DESCENDANTS_0 = new OrderWeighting('DESCENDANTS', 1);
    FAN_0 = new OrderWeighting('FAN', 2);
    CONSTRAINT = new OrderWeighting('CONSTRAINT', 3);
}
function OrderWeighting(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_69(name_0) {
    $clinit_OrderWeighting();
    return valueOf(($clinit_OrderWeighting$Map(), $MAP_59), name_0);
}
function values_77() {
    $clinit_OrderWeighting();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_options_OrderWeighting_2_classLit, 1), $intern_36, 350, 0, [
        MODEL_ORDER_2,
        DESCENDANTS_0,
        FAN_0,
        CONSTRAINT
    ]);
}
defineClass(350, 23, {
    3: 1,
    34: 1,
    23: 1,
    350: 1
}, OrderWeighting);
var CONSTRAINT, DESCENDANTS_0, FAN_0, MODEL_ORDER_2;
var Lorg_eclipse_elk_alg_mrtree_options_OrderWeighting_2_classLit = createForEnum('org.eclipse.elk.alg.mrtree.options', 'OrderWeighting', 350, Ljava_lang_Enum_2_classLit, values_77, valueOf_69);
function $clinit_OrderWeighting$Map() {
    $clinit_OrderWeighting$Map = emptyMethod;
    $MAP_59 = createValueOfMap(($clinit_OrderWeighting(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_options_OrderWeighting_2_classLit, 1), $intern_36, 350, 0, [
        MODEL_ORDER_2,
        DESCENDANTS_0,
        FAN_0,
        CONSTRAINT
    ])));
}
var $MAP_59;
function $clinit_TreeifyingOrder() {
    $clinit_TreeifyingOrder = emptyMethod;
    DFS = new TreeifyingOrder('DFS', 0);
    BFS = new TreeifyingOrder('BFS', 1);
}
function TreeifyingOrder(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_70(name_0) {
    $clinit_TreeifyingOrder();
    return valueOf(($clinit_TreeifyingOrder$Map(), $MAP_60), name_0);
}
function values_78() {
    $clinit_TreeifyingOrder();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_options_TreeifyingOrder_2_classLit, 1), $intern_36, 422, 0, [
        DFS,
        BFS
    ]);
}
defineClass(422, 23, {
    3: 1,
    34: 1,
    23: 1,
    422: 1
}, TreeifyingOrder);
var BFS, DFS;
var Lorg_eclipse_elk_alg_mrtree_options_TreeifyingOrder_2_classLit = createForEnum('org.eclipse.elk.alg.mrtree.options', 'TreeifyingOrder', 422, Ljava_lang_Enum_2_classLit, values_78, valueOf_70);
function $clinit_TreeifyingOrder$Map() {
    $clinit_TreeifyingOrder$Map = emptyMethod;
    $MAP_60 = createValueOfMap(($clinit_TreeifyingOrder(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_options_TreeifyingOrder_2_classLit, 1), $intern_36, 422, 0, [
        DFS,
        BFS
    ])));
}
var $MAP_60;
function $clinit_DFSTreeifyer() {
    $clinit_DFSTreeifyer = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIG = $addAfter(new LayoutProcessorConfiguration, ($clinit_TreeLayoutPhases(), P3_NODE_PLACEMENT), ($clinit_IntermediateProcessorStrategy_0(), DETREEIFYING_PROC));
}
function $bfs(this$static, startNode) {
    var node, nodeQueue, tEdge, tEdge$iterator, target;
    nodeQueue = new LinkedList;
    $addNode_0(nodeQueue, startNode, nodeQueue.tail.prev, nodeQueue.tail);
    do {
        node = (checkCriticalElement(nodeQueue.size_0 != 0), castTo($removeNode_0(nodeQueue, nodeQueue.header.next_0), 39));
        this$static.visited[node.id_0] = 1;
        for(tEdge$iterator = $listIterator_2(node.outgoingEdges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
            tEdge = castTo($next_9(tEdge$iterator), 65);
            target = tEdge.target;
            this$static.visited[target.id_0] == 1 ? $add_7(this$static.eliminated, tEdge) : this$static.visited[target.id_0] == 2 ? this$static.visited[target.id_0] = 1 : $addNode_0(nodeQueue, target, nodeQueue.tail.prev, nodeQueue.tail);
        }
    }while (nodeQueue.size_0 != 0);
}
function $collectEdges(this$static, tGraph) {
    var tEdge, tEdge$iterator, tNode, tNode$iterator, treeifyingOrder;
    treeifyingOrder = castTo($getProperty(tGraph, ($clinit_MrTreeOptions(), SEARCH_ORDER_0)), 422);
    for(tNode$iterator = $listIterator_2(tGraph.nodes, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator), 39);
        if (this$static.visited[tNode.id_0] == 0) {
            switch(treeifyingOrder.ordinal){
                case 0:
                    $dfs_6(this$static, tNode);
                    break;
                case 1:
                    $bfs(this$static, tNode);
            }
            this$static.visited[tNode.id_0] = 2;
        }
    }
    for(tEdge$iterator = $listIterator_2(this$static.eliminated, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
        tEdge = castTo($next_9(tEdge$iterator), 65);
        $advanceToFind(tEdge.source.outgoingEdges, tEdge, true);
        $advanceToFind(tEdge.target.incomingEdges, tEdge, true);
    }
    $setProperty_0(tGraph, ($clinit_InternalProperties_2(), REMOVABLE_EDGES), this$static.eliminated);
}
function $dfs_6(this$static, tNode) {
    var tEdge, tEdge$iterator, target;
    this$static.visited[tNode.id_0] = 1;
    for(tEdge$iterator = $listIterator_2(tNode.outgoingEdges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
        tEdge = castTo($next_9(tEdge$iterator), 65);
        target = tEdge.target;
        this$static.visited[target.id_0] == 1 ? $add_7(this$static.eliminated, tEdge) : this$static.visited[target.id_0] == 2 ? this$static.visited[target.id_0] = 1 : $dfs_6(this$static, target);
    }
}
function $init_1(this$static, tGraph) {
    var id_0, node, node$iterator, size_0;
    size_0 = tGraph.nodes.size_0;
    this$static.eliminated = new LinkedList;
    this$static.visited = initUnidimensionalArray(I_classLit, $intern_48, 30, size_0, 15, 1);
    id_0 = 0;
    for(node$iterator = $listIterator_2(tGraph.nodes, 0); node$iterator.currentNode != node$iterator.this$01.tail;){
        node = castTo($next_9(node$iterator), 39);
        node.id_0 = id_0++;
    }
}
function $process_94(this$static, tGraph, progressMonitor) {
    progressMonitor.begin('DFS Treeifying phase', 1);
    $init_1(this$static, tGraph);
    $collectEdges(this$static, tGraph);
    this$static.eliminated = null;
    this$static.visited = null;
    progressMonitor.done_1();
}
function DFSTreeifyer() {
    $clinit_DFSTreeifyer();
}
defineClass(1425, 1, $intern_110, DFSTreeifyer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_23(graph) {
    return castTo(graph, 120), INTERMEDIATE_PROCESSING_CONFIG;
};
_.process = function process_90(tGraph, progressMonitor) {
    $process_94(this, castTo(tGraph, 120), progressMonitor);
};
var INTERMEDIATE_PROCESSING_CONFIG;
var Lorg_eclipse_elk_alg_mrtree_p1treeify_DFSTreeifyer_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p1treeify', 'DFSTreeifyer', 1425);
function $clinit_NodeOrderer() {
    $clinit_NodeOrderer = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIG_0 = $add_17($add_17($add_17($before(new LayoutProcessorConfiguration, ($clinit_TreeLayoutPhases(), P2_NODE_ORDERING)), ($clinit_IntermediateProcessorStrategy_0(), ROOT_PROC)), FAN_PROC), LEVEL_PROC);
}
function $orderLevelConstraint(this$static, currentLevel, progressMonitor) {
    var children, curNode, i, i0, i1, i2, i3, inBoundNodes, inners, j, newTargetPos, outOfBoundNodes, sortedNodes, sortedOutEdges, tEdge, tEdge$iterator, tNode, tNode$iterator, tPNode, tPNode$array, tPNode$index, tPNode$max, targetPos, undefinedNodes;
    progressMonitor.begin('Processor arrange level', 1);
    undefinedNodes = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(currentLevel, 16)), new NodeOrderer$lambda$1$Type), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    inBoundNodes = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(currentLevel, 16)), new NodeOrderer$lambda$2$Type(currentLevel)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        IDENTITY_FINISH
    ]))), 15);
    outOfBoundNodes = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(currentLevel, 16)), new NodeOrderer$lambda$3$Type(currentLevel)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        IDENTITY_FINISH
    ]))), 15);
    sortedNodes = initUnidimensionalArray(Lorg_eclipse_elk_alg_mrtree_graph_TNode_2_classLit, $intern_124, 39, currentLevel.size_1(), 0, 1);
    for(i0 = 0; i0 < inBoundNodes.size_1(); i0++){
        curNode = castTo(inBoundNodes.get_0(i0), 39);
        targetPos = castTo($getProperty(curNode, ($clinit_MrTreeOptions(), POSITION_CONSTRAINT_0)), 17).value_0;
        if (targetPos >= 0 && targetPos < inBoundNodes.size_1() && !sortedNodes[targetPos]) {
            sortedNodes[targetPos] = curNode;
            inBoundNodes.remove_2(i0);
            --i0;
        }
    }
    for(i1 = 0; i1 < inBoundNodes.size_1(); i1++){
        curNode = castTo(inBoundNodes.get_0(i1), 39);
        targetPos = castTo($getProperty(curNode, ($clinit_MrTreeOptions(), POSITION_CONSTRAINT_0)), 17).value_0;
        for(j = 0;; j++){
            newTargetPos = targetPos + j;
            if (newTargetPos < sortedNodes.length && newTargetPos >= 0 && !sortedNodes[newTargetPos]) {
                sortedNodes[newTargetPos] = curNode;
                inBoundNodes.remove_2(i1);
                --i1;
                break;
            }
            newTargetPos = targetPos - j;
            if (newTargetPos < sortedNodes.length && newTargetPos >= 0 && !sortedNodes[newTargetPos]) {
                sortedNodes[newTargetPos] = curNode;
                inBoundNodes.remove_2(i1);
                --i1;
                break;
            }
        }
    }
    outOfBoundNodes.sort_0(new NodeOrderer$lambda$4$Type);
    for(i2 = sortedNodes.length - 1; i2 >= 0; i2--)if (!sortedNodes[i2] && !outOfBoundNodes.isEmpty()) {
        sortedNodes[i2] = castTo(outOfBoundNodes.get_0(0), 39);
        outOfBoundNodes.remove_2(0);
    }
    for(i3 = 0; i3 < sortedNodes.length; i3++)if (!sortedNodes[i3] && !undefinedNodes.isEmpty()) {
        sortedNodes[i3] = castTo(undefinedNodes.get_0(0), 39);
        undefinedNodes.remove_2(0);
    }
    for(i = 0; i < sortedNodes.length; i++)$setProperty_0(sortedNodes[i], ($clinit_InternalProperties_2(), POSITION_0), valueOf_3(i));
    inners = castTo($toArray_6($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(currentLevel, 16)), new NodeOrderer$lambda$5$Type), new NodeOrderer$0methodref$lambda$6$Type), 519);
    for(tPNode$array = inners, tPNode$index = 0, tPNode$max = tPNode$array.length; tPNode$index < tPNode$max; ++tPNode$index){
        tPNode = tPNode$array[tPNode$index];
        children = $getChildrenCopy(tPNode);
        $orderLevelConstraint(this$static, children, progressMonitor.subTask(1 / inners.length | 0));
        $clinit_Collections();
        $sort_0(children, new PropertyHolderComparator(($clinit_InternalProperties_2(), POSITION_0)));
        sortedOutEdges = new LinkedList;
        for(tNode$iterator = $listIterator_2(children, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
            tNode = castTo($next_9(tNode$iterator), 39);
            for(tEdge$iterator = $listIterator_2(tPNode.outgoingEdges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
                tEdge = castTo($next_9(tEdge$iterator), 65);
                tEdge.target == tNode && $addNode_0(sortedOutEdges, tEdge, sortedOutEdges.tail.prev, sortedOutEdges.tail);
            }
        }
        $reset_0(tPNode.outgoingEdges);
        $addAll(tPNode.outgoingEdges, sortedOutEdges);
    }
    progressMonitor.done_1();
}
function $orderLevelFanDescendants(this$static, currentLevel, progressMonitor) {
    var children, fillGap, firstOcc, inners, it, leaves, notNull, pos, size_0, sortProperty, sortedOutEdges, tENode, tENode$iterator, tEdge, tEdge$iterator, tNode, tNode$iterator, tPNode, tPNode$iterator, tmp;
    progressMonitor.begin('Processor arrange level', 1);
    sortProperty = ($clinit_InternalProperties_2(), FAN);
    this$static.weighting == ($clinit_OrderWeighting(), DESCENDANTS_0) && (sortProperty = DESCENDANTS);
    pos = 0;
    $clinit_Collections();
    currentLevel.sort_0(new PropertyHolderComparator(sortProperty));
    firstOcc = currentLevel.size_1();
    it = currentLevel.listIterator_1(currentLevel.size_1());
    notNull = true;
    while(notNull && it.hasPrevious()){
        tNode = castTo(it.previous_0(), 39);
        castTo($getProperty(tNode, sortProperty), 17).value_0 == 0 ? --firstOcc : notNull = false;
    }
    tmp = currentLevel.subList(0, firstOcc);
    inners = new LinkedList_0(tmp);
    tmp = currentLevel.subList(firstOcc, currentLevel.size_1());
    leaves = new LinkedList_0(tmp);
    if (inners.size_0 == 0) for(tENode$iterator = $listIterator_2(leaves, 0); tENode$iterator.currentNode != tENode$iterator.this$01.tail;){
        tENode = castTo($next_9(tENode$iterator), 39);
        $setProperty_0(tENode, POSITION_0, valueOf_3(pos++));
    }
    else {
        size_0 = inners.size_0;
        for(tPNode$iterator = $listIterator_2(inners, 0); tPNode$iterator.currentNode != tPNode$iterator.this$01.tail;){
            tPNode = castTo($next_9(tPNode$iterator), 39);
            $setProperty_0(tPNode, POSITION_0, valueOf_3(pos++));
            children = $getChildrenCopy(tPNode);
            $orderLevelFanDescendants(this$static, children, progressMonitor.subTask(1 / size_0 | 0));
            $sort_0(children, reverseOrder_0(new PropertyHolderComparator(POSITION_0)));
            sortedOutEdges = new LinkedList;
            for(tNode$iterator = $listIterator_2(children, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
                tNode = castTo($next_9(tNode$iterator), 39);
                for(tEdge$iterator = $listIterator_2(tPNode.outgoingEdges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
                    tEdge = castTo($next_9(tEdge$iterator), 65);
                    tEdge.target == tNode && $addNode_0(sortedOutEdges, tEdge, sortedOutEdges.tail.prev, sortedOutEdges.tail);
                }
            }
            $reset_0(tPNode.outgoingEdges);
            $addAll(tPNode.outgoingEdges, sortedOutEdges);
            it = $listIterator_2(leaves, leaves.size_0);
            fillGap = tPNode.outgoingEdges.size_0;
            notNull = true;
            while(0 < fillGap && notNull && it.hasPrevious()){
                tNode = castTo(it.previous_0(), 39);
                if (castTo($getProperty(tNode, sortProperty), 17).value_0 == 0) {
                    $setProperty_0(tNode, POSITION_0, valueOf_3(pos++));
                    --fillGap;
                    it.remove();
                } else notNull = false;
            }
        }
    }
    progressMonitor.done_1();
}
function $process_95(this$static, tGraph, progressMonitor) {
    var root;
    progressMonitor.begin('Processor arrange node', 1);
    $booleanValue(castToBoolean($getProperty(tGraph, ($clinit_MrTreeOptions(), DEBUG_MODE_0))));
    root = castTo($get_17($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new NodeOrderer$lambda$0$Type))), 39);
    this$static.weighting = castTo($getProperty(tGraph, WEIGHTING_0), 350);
    this$static.weighting == ($clinit_OrderWeighting(), FAN_0) || this$static.weighting == DESCENDANTS_0 ? $orderLevelFanDescendants(this$static, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_graph_TNode_2_classLit, 1), $intern_124, 39, 0, [
        root
    ])), progressMonitor.subTask(1)) : this$static.weighting == CONSTRAINT && $orderLevelConstraint(this$static, new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_mrtree_graph_TNode_2_classLit, 1), $intern_124, 39, 0, [
        root
    ])), progressMonitor.subTask(1));
    progressMonitor.done_1();
}
function NodeOrderer() {
    $clinit_NodeOrderer();
}
function lambda$2_10(currentLevel_0, x_1) {
    $clinit_NodeOrderer();
    return castTo($getProperty(x_1, ($clinit_MrTreeOptions(), POSITION_CONSTRAINT_0)), 17).value_0 < currentLevel_0.size_1() && castTo($getProperty(x_1, POSITION_CONSTRAINT_0), 17).value_0 >= 0;
}
function lambda$3_8(currentLevel_0, x_1) {
    $clinit_NodeOrderer();
    return castTo($getProperty(x_1, ($clinit_MrTreeOptions(), POSITION_CONSTRAINT_0)), 17).value_0 >= currentLevel_0.size_1();
}
function lambda$4_7(x_0, y_1) {
    $clinit_NodeOrderer();
    return -compare_5(castTo($getProperty(x_0, ($clinit_MrTreeOptions(), POSITION_CONSTRAINT_0)), 17).value_0, castTo($getProperty(y_1, POSITION_CONSTRAINT_0), 17).value_0);
}
defineClass(1426, 1, $intern_110, NodeOrderer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_24(graph) {
    return castTo(graph, 120), INTERMEDIATE_PROCESSING_CONFIG_0;
};
_.process = function process_91(tGraph, progressMonitor) {
    $process_95(this, castTo(tGraph, 120), progressMonitor);
};
var INTERMEDIATE_PROCESSING_CONFIG_0;
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer', 1426);
function $apply_10(arg0) {
    return $clinit_NodeOrderer(), initUnidimensionalArray(Lorg_eclipse_elk_alg_mrtree_graph_TNode_2_classLit, $intern_124, 39, arg0, 0, 1);
}
function NodeOrderer$0methodref$lambda$6$Type() {}
defineClass(1433, 1, {}, NodeOrderer$0methodref$lambda$6$Type);
_.apply_2 = function apply_135(arg0) {
    return $apply_10(arg0);
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$0methodref$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/0methodref$lambda$6$Type', 1433);
function NodeOrderer$lambda$0$Type() {}
defineClass(1427, 1, $intern_39, NodeOrderer$lambda$0$Type);
_.test_0 = function test_110(arg0) {
    return $clinit_NodeOrderer(), $booleanValue(castToBoolean($getProperty(castTo(arg0, 39), ($clinit_InternalProperties_2(), ROOT_0))));
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/lambda$0$Type', 1427);
function NodeOrderer$lambda$1$Type() {}
defineClass(1428, 1, $intern_39, NodeOrderer$lambda$1$Type);
_.test_0 = function test_111(arg0) {
    return $clinit_NodeOrderer(), castTo($getProperty(castTo(arg0, 39), ($clinit_MrTreeOptions(), POSITION_CONSTRAINT_0)), 17).value_0 < 0;
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/lambda$1$Type', 1428);
function NodeOrderer$lambda$2$Type(currentLevel_0) {
    this.currentLevel_0 = currentLevel_0;
}
defineClass(1429, 1, $intern_39, NodeOrderer$lambda$2$Type);
_.test_0 = function test_112(arg0) {
    return lambda$2_10(this.currentLevel_0, castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/lambda$2$Type', 1429);
function NodeOrderer$lambda$3$Type(currentLevel_0) {
    this.currentLevel_0 = currentLevel_0;
}
defineClass(1430, 1, $intern_39, NodeOrderer$lambda$3$Type);
_.test_0 = function test_113(arg0) {
    return lambda$3_8(this.currentLevel_0, castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/lambda$3$Type', 1430);
function NodeOrderer$lambda$4$Type() {}
defineClass(1431, 1, $intern_88, NodeOrderer$lambda$4$Type);
_.compare_1 = function compare_85(arg0, arg1) {
    return lambda$4_7(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_172(other) {
    return this === other;
};
_.reversed = function reversed_77() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/lambda$4$Type', 1431);
function NodeOrderer$lambda$5$Type() {}
defineClass(1432, 1, $intern_39, NodeOrderer$lambda$5$Type);
_.test_0 = function test_114(arg0) {
    return $clinit_NodeOrderer(), castTo($getProperty(castTo(arg0, 39), ($clinit_InternalProperties_2(), FAN)), 17).value_0 != 0;
};
var Lorg_eclipse_elk_alg_mrtree_p2order_NodeOrderer$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p2order', 'NodeOrderer/lambda$5$Type', 1432);
function $clinit_NodePlacer() {
    $clinit_NodePlacer = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIG_1 = $add_17($add_17($before($add_17($add_17($before($addBefore(new LayoutProcessorConfiguration, ($clinit_TreeLayoutPhases(), P2_NODE_ORDERING), ($clinit_IntermediateProcessorStrategy_0(), ROOT_PROC)), P3_NODE_PLACEMENT), LEVEL_HEIGHT), NEIGHBORS_PROC), P4_EDGE_ROUTING), DIRECTION_PROC), NODE_POSITION_PROC);
}
function $apportion(this$static, cN) {
    var ancestorLeftmost, ancestorNeighbor, compareDepth, edgesIter, edgesIter0, i, leftModSum, leftSibling, leftSiblings, leftmost, mean, moveDistance, neighbor, newMod, newPr, portion, prL, prN, rightModSum;
    leftmost = castTo(getNext((edgesIter0 = $listIterator_2(new TNode$2(cN).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter0))), 39);
    neighbor = leftmost ? castTo($getProperty(leftmost, ($clinit_InternalProperties_2(), LEFTNEIGHBOR)), 39) : null;
    compareDepth = 1;
    while(!!leftmost && !!neighbor){
        leftModSum = 0;
        rightModSum = 0;
        ancestorLeftmost = leftmost;
        ancestorNeighbor = neighbor;
        for(i = 0; i < compareDepth; i++){
            ancestorLeftmost = $getParent(ancestorLeftmost);
            ancestorNeighbor = $getParent(ancestorNeighbor);
            rightModSum += $doubleValue(castToDouble($getProperty(ancestorLeftmost, ($clinit_InternalProperties_2(), MODIFIER))));
            leftModSum += $doubleValue(castToDouble($getProperty(ancestorNeighbor, MODIFIER)));
        }
        prN = $doubleValue(castToDouble($getProperty(neighbor, ($clinit_InternalProperties_2(), PRELIM))));
        prL = $doubleValue(castToDouble($getProperty(leftmost, PRELIM)));
        mean = $meanNodeWidth(this$static, leftmost, neighbor);
        moveDistance = prN + leftModSum + this$static.spacing + mean - prL - rightModSum;
        if (0 < moveDistance) {
            leftSibling = cN;
            leftSiblings = 0;
            while(!!leftSibling && leftSibling != ancestorNeighbor){
                ++leftSiblings;
                leftSibling = castTo($getProperty(leftSibling, LEFTSIBLING), 39);
            }
            if (leftSibling) {
                portion = moveDistance / leftSiblings;
                leftSibling = cN;
                while(leftSibling != ancestorNeighbor){
                    newPr = $doubleValue(castToDouble($getProperty(leftSibling, PRELIM))) + moveDistance;
                    $setProperty_0(leftSibling, PRELIM, newPr);
                    newMod = $doubleValue(castToDouble($getProperty(leftSibling, MODIFIER))) + moveDistance;
                    $setProperty_0(leftSibling, MODIFIER, newMod);
                    moveDistance -= portion;
                    leftSibling = castTo($getProperty(leftSibling, LEFTSIBLING), 39);
                }
            } else return;
        }
        ++compareDepth;
        leftmost.outgoingEdges.size_0 == 0 ? leftmost = getLeftMost(new TNode$2(cN), compareDepth) : leftmost = castTo(getNext((edgesIter = $listIterator_2(new TNode$2(leftmost).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter))), 39);
        neighbor = leftmost ? castTo($getProperty(leftmost, LEFTNEIGHBOR), 39) : null;
    }
}
function $firstWalk(this$static, cN) {
    var child, child$iterator, edgesIter, edgesIter0, edgesIter1, lM, lS, midPoint, p, rM;
    $setProperty_0(cN, ($clinit_InternalProperties_2(), MODIFIER), 0);
    lS = castTo($getProperty(cN, LEFTSIBLING), 39);
    if (cN.outgoingEdges.size_0 == 0) {
        if (lS) {
            p = $doubleValue(castToDouble($getProperty(lS, PRELIM))) + this$static.spacing + $meanNodeWidth(this$static, lS, cN);
            $setProperty_0(cN, PRELIM, p);
        } else $setProperty_0(cN, PRELIM, 0);
    } else {
        for(child$iterator = (edgesIter0 = $listIterator_2(new TNode$2(cN).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter0)); $hasNext_5(child$iterator.val$edgesIter2);){
            child = castTo($next_9(child$iterator.val$edgesIter2), 65).target;
            $firstWalk(this$static, child);
        }
        lM = castTo(getNext((edgesIter1 = $listIterator_2(new TNode$2(cN).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter1))), 39);
        rM = castTo(getLast_1((edgesIter = $listIterator_2(new TNode$2(cN).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter))), 39);
        midPoint = ($doubleValue(castToDouble($getProperty(rM, PRELIM))) + $doubleValue(castToDouble($getProperty(lM, PRELIM)))) / 2;
        if (lS) {
            p = $doubleValue(castToDouble($getProperty(lS, PRELIM))) + this$static.spacing + $meanNodeWidth(this$static, lS, cN);
            $setProperty_0(cN, PRELIM, p);
            $setProperty_0(cN, MODIFIER, $doubleValue(castToDouble($getProperty(cN, PRELIM))) - midPoint);
            $apportion(this$static, cN);
        } else $setProperty_0(cN, PRELIM, midPoint);
    }
}
function $meanNodeWidth(this$static, leftNode, rightNode) {
    var nodeWidth;
    nodeWidth = 0;
    !!leftNode && ($isVertical(this$static.direction) ? nodeWidth += leftNode.size_0.x_0 / 2 : nodeWidth += leftNode.size_0.y_0 / 2);
    !!rightNode && ($isVertical(this$static.direction) ? nodeWidth += rightNode.size_0.x_0 / 2 : nodeWidth += rightNode.size_0.y_0 / 2);
    return nodeWidth;
}
function $process_96(this$static, tGraph, progressMonitor) {
    var root, roots, tNode, tNode$iterator;
    progressMonitor.begin('Processor order nodes', 2);
    this$static.spacing = $doubleValue(castToDouble($getProperty(tGraph, ($clinit_MrTreeOptions(), SPACING_NODE_NODE_1))));
    this$static.direction = castTo($getProperty(tGraph, DIRECTION_0), 86);
    if (this$static.direction == ($clinit_Direction(), UNDEFINED_2)) {
        this$static.direction = DOWN_1;
        $setProperty_0(tGraph, DIRECTION_0, this$static.direction);
    }
    roots = new LinkedList;
    for(tNode$iterator = $listIterator_2(tGraph.nodes, 0); tNode$iterator.currentNode != tNode$iterator.this$01.tail;){
        tNode = castTo($next_9(tNode$iterator), 39);
        $booleanValue(castToBoolean($getProperty(tNode, ($clinit_InternalProperties_2(), ROOT_0)))) && $addNode_0(roots, tNode, roots.tail.prev, roots.tail);
    }
    root = (checkCriticalElement(roots.size_0 != 0), castTo(roots.header.next_0.value_0, 39));
    $firstWalk(this$static, root);
    progressMonitor.worked(1);
    $secondWalk(this$static, root, 0 - $doubleValue(castToDouble($getProperty(root, ($clinit_InternalProperties_2(), LEVELHEIGHT)))) / 2, 0);
    progressMonitor.worked(1);
    progressMonitor.done_1();
}
function $secondWalk(this$static, tNode, yCoor, modsum) {
    var edgesIter, xTemp, yTemp;
    if (tNode) {
        xTemp = $doubleValue(castToDouble($getProperty(tNode, ($clinit_InternalProperties_2(), PRELIM)))) + modsum;
        yTemp = yCoor + $doubleValue(castToDouble($getProperty(tNode, LEVELHEIGHT))) / 2;
        $setProperty_0(tNode, XCOOR, valueOf_3(toInt_0(fromDouble_0($wnd.Math.round(xTemp)))));
        $setProperty_0(tNode, YCOOR, valueOf_3(toInt_0(fromDouble_0($wnd.Math.round(yTemp)))));
        tNode.outgoingEdges.size_0 == 0 || $secondWalk(this$static, castTo(getNext((edgesIter = $listIterator_2(new TNode$2(tNode).this$01.outgoingEdges, 0), new TNode$2$1(edgesIter))), 39), yCoor + $doubleValue(castToDouble($getProperty(tNode, LEVELHEIGHT))) + this$static.spacing, modsum + $doubleValue(castToDouble($getProperty(tNode, MODIFIER))));
        $getProperty(tNode, RIGHTSIBLING) != null && $secondWalk(this$static, castTo($getProperty(tNode, RIGHTSIBLING), 39), yCoor, modsum);
    }
}
function NodePlacer() {
    $clinit_NodePlacer();
}
defineClass(1434, 1, $intern_110, NodePlacer);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_25(graph) {
    return castTo(graph, 120), INTERMEDIATE_PROCESSING_CONFIG_1;
};
_.process = function process_92(tGraph, progressMonitor) {
    $process_96(this, castTo(tGraph, 120), progressMonitor);
};
_.spacing = 0;
var INTERMEDIATE_PROCESSING_CONFIG_1;
var Lorg_eclipse_elk_alg_mrtree_p3place_NodePlacer_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p3place', 'NodePlacer', 1434);
function $clinit_EdgeRouter() {
    $clinit_EdgeRouter = emptyMethod;
    INTERMEDIATE_PROCESSING_CONFIG_2 = $add_17($add_17($add_17($before(new LayoutProcessorConfiguration, ($clinit_TreeLayoutPhases(), P4_EDGE_ROUTING)), ($clinit_IntermediateProcessorStrategy_0(), LEVEL_COORDS)), COMPACTION_PROC), GRAPH_BOUNDS_PROC);
}
function $avoidOverlapHandleCycleInducingEdges(e, d, tGraph, sideEdges, nodeBendpointPadding, edgeEndTexturePadding, inOuts) {
    var bendTmp, finalSideOneEdges, finalSideTwoEdges, middleTree, s, sideOneEdges, sideTwoEdges, t;
    sideOneEdges = castTo(sideEdges.first, 17).value_0;
    sideTwoEdges = castTo(sideEdges.second, 17).value_0;
    s = e.source;
    t = e.target;
    bendTmp = 0;
    middleTree = 0;
    if (d == ($clinit_Direction(), LEFT_6) || d == RIGHT_6) {
        middleTree = $getAsDouble($average($mapToDouble($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$5$Type), new EdgeRouter$1methodref$doubleValue$Type)));
        if (s.pos.y_0 + s.size_0.y_0 / 2 > middleTree) {
            finalSideTwoEdges = ++sideTwoEdges;
            bendTmp = $doubleValue(castToDouble($get_17($max_1($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$7$Type(nodeBendpointPadding, finalSideTwoEdges)), new EdgeRouter$2methodref$compare$Type))));
        } else {
            finalSideOneEdges = ++sideOneEdges;
            bendTmp = $doubleValue(castToDouble($get_17($min_0($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$9$Type(nodeBendpointPadding, finalSideOneEdges)), new EdgeRouter$3methodref$compare$Type))));
        }
    } else {
        middleTree = $getAsDouble($average($mapToDouble($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$11$Type), new EdgeRouter$4methodref$doubleValue$Type)));
        if (s.pos.x_0 + s.size_0.x_0 / 2 > middleTree) {
            finalSideTwoEdges = ++sideTwoEdges;
            bendTmp = $doubleValue(castToDouble($get_17($max_1($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$13$Type(nodeBendpointPadding, finalSideTwoEdges)), new EdgeRouter$5methodref$compare$Type))));
        } else {
            finalSideOneEdges = ++sideOneEdges;
            bendTmp = $doubleValue(castToDouble($get_17($min_0($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$15$Type(nodeBendpointPadding, finalSideOneEdges)), new EdgeRouter$6methodref$compare$Type))));
        }
    }
    if (d == LEFT_6) {
        $addLast_0(e.bendPoints, new KVector_1($doubleValue(castToDouble($getProperty(s, ($clinit_InternalProperties_2(), LEVELMIN)))) - nodeBendpointPadding, bendTmp));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 + t.size_0.x_0 + nodeBendpointPadding + edgeEndTexturePadding, bendTmp));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 + t.size_0.x_0 + nodeBendpointPadding + edgeEndTexturePadding, t.pos.y_0 + t.size_0.y_0 / 2));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 + t.size_0.x_0, t.pos.y_0 + t.size_0.y_0 / 2));
    } else if (d == RIGHT_6) {
        $addLast_0(e.bendPoints, new KVector_1($doubleValue(castToDouble($getProperty(s, ($clinit_InternalProperties_2(), LEVELMAX)))) + nodeBendpointPadding, s.pos.y_0 + s.size_0.y_0 / 2));
        $addLast_0(e.bendPoints, new KVector_1(s.pos.x_0 + s.size_0.x_0 + nodeBendpointPadding, bendTmp));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 - nodeBendpointPadding - edgeEndTexturePadding, bendTmp));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 - nodeBendpointPadding - edgeEndTexturePadding, t.pos.y_0 + t.size_0.y_0 / 2));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0, t.pos.y_0 + t.size_0.y_0 / 2));
    } else if (d == UP_1) {
        $addLast_0(e.bendPoints, new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(s, ($clinit_InternalProperties_2(), LEVELMIN)))) - nodeBendpointPadding));
        $addLast_0(e.bendPoints, new KVector_1(bendTmp, t.pos.y_0 + t.size_0.y_0 + nodeBendpointPadding + edgeEndTexturePadding));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 + t.size_0.x_0 / 2, t.pos.y_0 + t.size_0.y_0 + nodeBendpointPadding + edgeEndTexturePadding));
        $addLast_0(e.bendPoints, new KVector_1(t.pos.x_0 + t.size_0.x_0 / 2, t.pos.y_0 + t.size_0.y_0 + nodeBendpointPadding));
    } else {
        e.bendPoints.size_0 == 0 || (castTo($getLast(e.bendPoints), 8).y_0 = $doubleValue(castToDouble($getProperty(s, ($clinit_InternalProperties_2(), LEVELMAX)))) + nodeBendpointPadding * castTo(inOuts.second, 17).value_0);
        $addLast_0(e.bendPoints, new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(s, ($clinit_InternalProperties_2(), LEVELMAX)))) + nodeBendpointPadding * castTo(inOuts.second, 17).value_0));
        $addLast_0(e.bendPoints, new KVector_1(bendTmp, t.pos.y_0 - nodeBendpointPadding * castTo(inOuts.first, 17).value_0 - edgeEndTexturePadding));
    }
    return new Pair(valueOf_3(sideOneEdges), valueOf_3(sideTwoEdges));
}
function $avoidOverlapSetEndPoints(tGraph, d, nodeBendpointPadding, edgeEndTexturePadding) {
    var i, ins, interpolation, lastX, lastY, levelStartCoord, n, n$iterator, nextX, nextY, num;
    for(n$iterator = $listIterator_2(tGraph.nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        if ($equals_5(n.label_0, 'SUPER_ROOT')) continue;
        ins = castTo($collect_1(new StreamImpl(null, new Spliterators$IteratorSpliterator(getAllIncomingEdges(n, tGraph), 16)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
            ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
        ]))), 15);
        d == ($clinit_Direction(), LEFT_6) || d == RIGHT_6 ? ins.sort_0(new EdgeRouter$lambda$19$Type) : ins.sort_0(new EdgeRouter$lambda$20$Type);
        num = ins.size_1();
        for(i = 0; i < num; i++){
            interpolation = num == 1 ? 0.5 : (1 + i) / (num + 1);
            if (d == LEFT_6) {
                levelStartCoord = $doubleValue(castToDouble($getProperty(n, ($clinit_InternalProperties_2(), LEVELMAX))));
                if (n.pos.x_0 + n.size_0.x_0 + edgeEndTexturePadding < levelStartCoord) $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(levelStartCoord + nodeBendpointPadding, n.pos.y_0 + n.size_0.y_0 * interpolation));
                else if (castTo(ins.get_0(i), 65).bendPoints.size_0 > 0) {
                    lastX = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).x_0;
                    nextX = n.pos.x_0 + n.size_0.x_0 / 2;
                    lastY = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).y_0;
                    nextY = n.pos.y_0 + n.size_0.y_0 / 2;
                    edgeEndTexturePadding > 0 && $wnd.Math.abs(lastY - nextY) / ($wnd.Math.abs(lastX - nextX) / 40) > 50 && (nextY > lastY ? $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 + edgeEndTexturePadding / 5.3, n.pos.y_0 + n.size_0.y_0 * interpolation - edgeEndTexturePadding / 2)) : $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 + edgeEndTexturePadding / 5.3, n.pos.y_0 + n.size_0.y_0 * interpolation + edgeEndTexturePadding / 2)));
                }
                $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0, n.pos.y_0 + n.size_0.y_0 * interpolation));
            } else if (d == RIGHT_6) {
                levelStartCoord = $doubleValue(castToDouble($getProperty(n, ($clinit_InternalProperties_2(), LEVELMIN))));
                if (n.pos.x_0 - edgeEndTexturePadding > levelStartCoord) $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(levelStartCoord - nodeBendpointPadding, n.pos.y_0 + n.size_0.y_0 * interpolation));
                else if (castTo(ins.get_0(i), 65).bendPoints.size_0 > 0) {
                    lastX = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).x_0;
                    nextX = n.pos.x_0 + n.size_0.x_0 / 2;
                    lastY = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).y_0;
                    nextY = n.pos.y_0 + n.size_0.y_0 / 2;
                    edgeEndTexturePadding > 0 && $wnd.Math.abs(lastY - nextY) / ($wnd.Math.abs(lastX - nextX) / 40) > 50 && (nextY > lastY ? $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 - edgeEndTexturePadding / 5.3, n.pos.y_0 + n.size_0.y_0 * interpolation - edgeEndTexturePadding / 2)) : $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 - edgeEndTexturePadding / 5.3, n.pos.y_0 + n.size_0.y_0 * interpolation + edgeEndTexturePadding / 2)));
                }
                $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0, n.pos.y_0 + n.size_0.y_0 * interpolation));
            } else if (d == UP_1) {
                levelStartCoord = $doubleValue(castToDouble($getProperty(n, ($clinit_InternalProperties_2(), LEVELMAX))));
                if (n.pos.y_0 + n.size_0.y_0 + edgeEndTexturePadding < levelStartCoord) $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation, levelStartCoord + nodeBendpointPadding));
                else if (castTo(ins.get_0(i), 65).bendPoints.size_0 > 0) {
                    lastX = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).x_0;
                    nextX = n.pos.x_0 + n.size_0.x_0 / 2;
                    lastY = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).y_0;
                    nextY = n.pos.y_0 + n.size_0.y_0 / 2;
                    edgeEndTexturePadding > 0 && $wnd.Math.abs(lastX - nextX) / ($wnd.Math.abs(lastY - nextY) / 40) > 50 && (nextX > lastX ? $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation - edgeEndTexturePadding / 2, n.pos.y_0 + edgeEndTexturePadding / 5.3 + n.size_0.y_0)) : $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation + edgeEndTexturePadding / 2, n.pos.y_0 + edgeEndTexturePadding / 5.3 + n.size_0.y_0)));
                }
                $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation, n.pos.y_0 + n.size_0.y_0));
            } else {
                levelStartCoord = $doubleValue(castToDouble($getProperty(n, ($clinit_InternalProperties_2(), LEVELMIN))));
                if (isCycleInducing(castTo(ins.get_0(i), 65), tGraph)) $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation, castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).y_0));
                else if (n.pos.y_0 - edgeEndTexturePadding > levelStartCoord) $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation, levelStartCoord - nodeBendpointPadding));
                else if (castTo(ins.get_0(i), 65).bendPoints.size_0 > 0) {
                    lastX = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).x_0;
                    nextX = n.pos.x_0 + n.size_0.x_0 / 2;
                    lastY = castTo($getLast(castTo(ins.get_0(i), 65).bendPoints), 8).y_0;
                    nextY = n.pos.y_0 + n.size_0.y_0 / 2;
                    edgeEndTexturePadding > 0 && $wnd.Math.abs(lastX - nextX) / ($wnd.Math.abs(lastY - nextY) / 40) > 50 && (nextX > lastX ? $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation - edgeEndTexturePadding / 2, n.pos.y_0 - edgeEndTexturePadding / 5.3)) : $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation + edgeEndTexturePadding / 2, n.pos.y_0 - edgeEndTexturePadding / 5.3)));
                }
                $addLast_0(castTo(ins.get_0(i), 65).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0 * interpolation, n.pos.y_0));
            }
        }
    }
}
function $avoidOverlapSetStartPoints(tGraph, d, nodeBendpointPadding) {
    var i, interpolation, levelEndCoord, n, n$iterator, num, outs, tar, x_0, y_0;
    for(n$iterator = $listIterator_2(tGraph.nodes, 0); n$iterator.currentNode != n$iterator.this$01.tail;){
        n = castTo($next_9(n$iterator), 39);
        if ($equals_5(n.label_0, 'SUPER_ROOT')) continue;
        outs = getAllOutgoingEdges(n, tGraph);
        d == ($clinit_Direction(), LEFT_6) || d == RIGHT_6 ? $sort(outs, new EdgeRouter$lambda$17$Type) : $sort(outs, new EdgeRouter$lambda$18$Type);
        num = outs.array.length;
        for(i = 0; i < num; i++){
            tar = (checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).target;
            $equals_5(tar.label_0, 'n11') && Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter_2_classLit;
            if ($booleanValue(castToBoolean($getProperty(n, ($clinit_InternalProperties_2(), COMPACT_LEVEL_ASCENSION)))) && !isCycleInducing((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)), tGraph)) continue;
            interpolation = num == 1 ? 0.5 : (i + 1) / (num + 1);
            if (d == LEFT_6) {
                levelEndCoord = $doubleValue(castToDouble($getProperty(n, LEVELMIN)));
                y_0 = n.pos.y_0 + n.size_0.y_0 * interpolation;
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1($wnd.Math.min(levelEndCoord, n.pos.x_0 - nodeBendpointPadding), y_0));
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(n.pos.x_0, y_0));
            } else if (d == RIGHT_6) {
                levelEndCoord = $doubleValue(castToDouble($getProperty(n, LEVELMAX))) + nodeBendpointPadding;
                y_0 = n.pos.y_0 + n.size_0.y_0 * interpolation;
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(levelEndCoord, y_0));
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(n.pos.x_0 + n.size_0.x_0, y_0));
            } else if (d == UP_1) {
                levelEndCoord = $doubleValue(castToDouble($getProperty(n, LEVELMIN)));
                x_0 = n.pos.x_0 + n.size_0.x_0 * interpolation;
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(x_0, $wnd.Math.min(n.pos.y_0 - nodeBendpointPadding, levelEndCoord)));
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(x_0, n.pos.y_0));
            } else {
                levelEndCoord = $doubleValue(castToDouble($getProperty(n, LEVELMAX))) + nodeBendpointPadding;
                x_0 = n.pos.x_0 + n.size_0.x_0 * interpolation;
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(x_0, levelEndCoord));
                $addFirst_0((checkCriticalElementIndex(i, outs.array.length), castTo(outs.array[i], 65)).bendPoints, new KVector_1(x_0, n.pos.y_0 + n.size_0.y_0));
            }
        }
    }
}
function $avoidOverlapSpecialEdges(tGraph, d, nodeBendpointPadding, edgeEndTexturePadding) {
    var bend1, bend2, bendTriple, curLevel, distictEdges, e, e$iterator, finalCurlevel, first, gap, i, i0, insPerLevel, interpolation, key, last, levelDiff, maxLevel, nextLevelNodes, nodeGaps, outsPerLevel, sideOneEdges, sideTwoEdges, sides, sourceLevel, start_0, targetLevel;
    sideOneEdges = 0;
    sideTwoEdges = 0;
    nodeGaps = new HashMap;
    maxLevel = castTo($get_17($max_1($map(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$0$Type), new EdgeRouter$0methodref$compare$Type)), 17).value_0 + 1;
    outsPerLevel = initUnidimensionalArray(I_classLit, $intern_48, 30, maxLevel, 15, 1);
    insPerLevel = initUnidimensionalArray(I_classLit, $intern_48, 30, maxLevel, 15, 1);
    for(i0 = 0; i0 < maxLevel; i0++){
        outsPerLevel[i0] = 0;
        insPerLevel[i0] = 0;
    }
    distictEdges = castTo($collect_1($distinct(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.edges, 16))), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
        ($clinit_Collector$Characteristics(), IDENTITY_FINISH)
    ]))), 15);
    for(e$iterator = distictEdges.iterator_0(); e$iterator.hasNext_0();){
        e = castTo(e$iterator.next_1(), 65);
        sourceLevel = castTo($getProperty(e.source, ($clinit_MrTreeOptions(), TREE_LEVEL_0)), 17).value_0;
        targetLevel = castTo($getProperty(e.target, TREE_LEVEL_0), 17).value_0;
        levelDiff = targetLevel - sourceLevel;
        if (levelDiff > 1) for(curLevel = sourceLevel + 1; curLevel < targetLevel; curLevel++){
            finalCurlevel = curLevel;
            nextLevelNodes = castTo($collect_1($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new EdgeRouter$lambda$2$Type(finalCurlevel)), of_4(new Collectors$21methodref$ctor$Type, new Collectors$20methodref$add$Type, new Collectors$lambda$45$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, [
                IDENTITY_FINISH
            ]))), 15);
            i = 0;
            if (d == ($clinit_Direction(), LEFT_6) || d == RIGHT_6) {
                nextLevelNodes.sort_0(new EdgeRouter$lambda$3$Type);
                for(i = 0; i < nextLevelNodes.size_1(); i++){
                    interpolation = (curLevel - sourceLevel) / (targetLevel - sourceLevel);
                    if (castTo(nextLevelNodes.get_0(i), 39).pos.y_0 > e.source.pos.y_0 * (1 - interpolation) + e.target.pos.y_0 * interpolation) break;
                }
                if (nextLevelNodes.size_1() > 0) {
                    start_0 = e.bendPoints.size_0 == 0 ? $clone_1(e.source.pos) : castTo($getLast(e.bendPoints), 8);
                    last = $add_19($clone_1(castTo(nextLevelNodes.get_0(nextLevelNodes.size_1() - 1), 39).pos), castTo(nextLevelNodes.get_0(nextLevelNodes.size_1() - 1), 39).size_0);
                    first = $add_19($clone_1(castTo(nextLevelNodes.get_0(0), 39).pos), castTo(nextLevelNodes.get_0(0), 39).size_0);
                    if (i >= nextLevelNodes.size_1() - 1 && start_0.y_0 > last.y_0 && e.target.pos.y_0 > last.y_0) continue;
                    if (i <= 0 && start_0.y_0 < first.x_0 && e.target.pos.y_0 < first.y_0) continue;
                }
            } else {
                nextLevelNodes.sort_0(new EdgeRouter$lambda$4$Type);
                for(i = 0; i < nextLevelNodes.size_1(); i++){
                    interpolation = (curLevel - sourceLevel) / (targetLevel - sourceLevel);
                    if (castTo(nextLevelNodes.get_0(i), 39).pos.x_0 > e.source.pos.x_0 * (1 - interpolation) + e.target.pos.x_0 * interpolation) break;
                }
                if (nextLevelNodes.size_1() > 0) {
                    start_0 = e.bendPoints.size_0 == 0 ? $clone_1(e.source.pos) : castTo($getLast(e.bendPoints), 8);
                    last = $add_19($clone_1(castTo(nextLevelNodes.get_0(nextLevelNodes.size_1() - 1), 39).pos), castTo(nextLevelNodes.get_0(nextLevelNodes.size_1() - 1), 39).size_0);
                    first = $add_19($clone_1(castTo(nextLevelNodes.get_0(0), 39).pos), castTo(nextLevelNodes.get_0(0), 39).size_0);
                    if (i >= nextLevelNodes.size_1() - 1 && start_0.x_0 > last.x_0 && e.target.pos.x_0 > last.x_0) continue;
                    if (i <= 0 && start_0.x_0 < first.x_0 && e.target.pos.x_0 < first.x_0) continue;
                }
            }
            bend1 = new KVector;
            bend2 = new KVector;
            $add_7(e.bendPoints, bend1);
            $add_7(e.bendPoints, bend2);
            bendTriple = new Triple(bend1, bend2, e);
            key = or_0(shl_0(curLevel, 32), and_0(i, $intern_69));
            if ($containsKey_3(nodeGaps, valueOf_4(key))) {
                gap = castTo($get_10(nodeGaps, valueOf_4(key)), 660);
                $add_7(gap.bendPoints, bendTriple);
                $isHorizontal(gap.d) ? $sort_0(gap.bendPoints, new MultiLevelEdgeNodeNodeGap$lambda$0$Type) : $sort_0(gap.bendPoints, new MultiLevelEdgeNodeNodeGap$lambda$1$Type);
                $updateBendPoints(gap);
            } else {
                gap = new MultiLevelEdgeNodeNodeGap(i == 0 ? null : castTo(nextLevelNodes.get_0(i - 1), 39), i == nextLevelNodes.size_1() ? null : castTo(nextLevelNodes.get_0(i), 39), bendTriple, tGraph);
                $put_6(nodeGaps, valueOf_4(key), gap);
            }
            if (d == LEFT_6 || d == RIGHT_6) {
                gap.onFirstNodeSide && gap.neighborTwo.pos.y_0 <= $doubleValue(castToDouble($getProperty(tGraph, ($clinit_InternalProperties_2(), GRAPH_YMIN)))) && ++sideOneEdges;
                gap.onLastNodeSide && gap.neighborOne.pos.y_0 + gap.neighborOne.size_0.y_0 >= $doubleValue(castToDouble($getProperty(tGraph, ($clinit_InternalProperties_2(), GRAPH_YMAX)))) && ++sideTwoEdges;
            } else {
                gap.onFirstNodeSide && gap.neighborTwo.pos.x_0 <= $doubleValue(castToDouble($getProperty(tGraph, ($clinit_InternalProperties_2(), GRAPH_XMIN)))) && ++sideOneEdges;
                gap.onLastNodeSide && gap.neighborOne.pos.x_0 + gap.neighborOne.size_0.x_0 >= $doubleValue(castToDouble($getProperty(tGraph, ($clinit_InternalProperties_2(), GRAPH_XMAX)))) && ++sideTwoEdges;
            }
        }
        else if (levelDiff == 0) $middleToMiddleEdgeRoute(e);
        else if (levelDiff < 0) {
            ++outsPerLevel[sourceLevel];
            ++insPerLevel[targetLevel];
            sides = $avoidOverlapHandleCycleInducingEdges(e, d, tGraph, new Pair(valueOf_3(sideOneEdges), valueOf_3(sideTwoEdges)), nodeBendpointPadding, edgeEndTexturePadding, new Pair(valueOf_3(insPerLevel[targetLevel]), valueOf_3(outsPerLevel[sourceLevel])));
            sideOneEdges = castTo(sides.first, 17).value_0;
            sideTwoEdges = castTo(sides.second, 17).value_0;
        }
    }
}
function $middleToMiddle(tGraph) {
    var tEdge, tEdge$iterator;
    for(tEdge$iterator = $listIterator_2(tGraph.edges, 0); tEdge$iterator.currentNode != tEdge$iterator.this$01.tail;){
        tEdge = castTo($next_9(tEdge$iterator), 65);
        $middleToMiddleEdgeRoute(tEdge);
    }
}
function $middleToMiddleEdgeRoute(tEdge) {
    var bendPoints, source, sourcePoint, target, targetPoint;
    bendPoints = tEdge.bendPoints;
    source = tEdge.source;
    target = tEdge.target;
    sourcePoint = new KVector_1(source.pos.x_0 + source.size_0.x_0 / 2, source.pos.y_0 + source.size_0.y_0 / 2);
    targetPoint = new KVector_1(target.pos.x_0 + target.size_0.x_0 / 2, target.pos.y_0 + target.size_0.y_0 / 2);
    $addNode_0(bendPoints, sourcePoint, bendPoints.header, bendPoints.header.next_0);
    $addNode_0(bendPoints, targetPoint, bendPoints.tail.prev, bendPoints.tail);
    toNodeBorder(sourcePoint, castTo($get_7(bendPoints, 1), 8), tEdge.source.size_0);
    toNodeBorder(targetPoint, castTo($get_7(bendPoints, bendPoints.size_0 - 2), 8), tEdge.target.size_0);
}
function $process_97(tGraph, progressMonitor) {
    var e, e$iterator, mode, nodeBendpointPadding, edgeEndTexturePadding, d;
    progressMonitor.begin('Edge routing', 1);
    mode = castTo($getProperty(tGraph, ($clinit_MrTreeOptions(), EDGE_ROUTING_MODE_0)), 383);
    if (mode == ($clinit_EdgeRoutingMode(), MIDDLE_TO_MIDDLE)) $middleToMiddle(tGraph);
    else if (mode == AVOID_OVERLAP) {
        castTo($get_17($findFirst($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(tGraph.nodes, 16)), new TreeUtil$lambda$0$Type))), 39);
        nodeBendpointPadding = $doubleValue(castToDouble($getProperty(tGraph, SPACING_EDGE_NODE_0)));
        edgeEndTexturePadding = $doubleValue(castToDouble($getProperty(tGraph, EDGE_END_TEXTURE_LENGTH_0)));
        d = castTo($getProperty(tGraph, DIRECTION_0), 86);
        $avoidOverlapSetStartPoints(tGraph, d, nodeBendpointPadding);
        $avoidOverlapSpecialEdges(tGraph, d, nodeBendpointPadding, edgeEndTexturePadding);
        $avoidOverlapSetEndPoints(tGraph, d, nodeBendpointPadding, edgeEndTexturePadding);
        for(e$iterator = $listIterator_2(tGraph.edges, 0); e$iterator.currentNode != e$iterator.this$01.tail;){
            e = castTo($next_9(e$iterator), 65);
            e.bendPoints.size_0 < 2 && $middleToMiddleEdgeRoute(e);
        }
    }
    progressMonitor.done_1();
}
function EdgeRouter() {
    $clinit_EdgeRouter();
}
function lambda$11_2(x_0) {
    $clinit_EdgeRouter();
    return x_0.pos.x_0 + x_0.size_0.x_0 / 2;
}
function lambda$13_0(nodeBendpointPadding_0, finalSideTwoEdges_2, x_2) {
    $clinit_EdgeRouter();
    return x_2.pos.x_0 + x_2.size_0.x_0 + nodeBendpointPadding_0 * finalSideTwoEdges_2;
}
function lambda$15_0(nodeBendpointPadding_0, finalSideOneEdges_2, x_2) {
    $clinit_EdgeRouter();
    return x_2.pos.x_0 - nodeBendpointPadding_0 * finalSideOneEdges_2;
}
function lambda$17(x_0, y_1) {
    $clinit_EdgeRouter();
    return compare_4((x_0.bendPoints.size_0 == 0 ? new KVector_1(x_0.target.pos.x_0, x_0.target.pos.y_0) : castTo($getFirst(x_0.bendPoints), 8)).y_0, (y_1.bendPoints.size_0 == 0 ? new KVector_1(y_1.target.pos.x_0, y_1.target.pos.y_0) : castTo($getFirst(y_1.bendPoints), 8)).y_0);
}
function lambda$18(x_0, y_1) {
    $clinit_EdgeRouter();
    return compare_4((x_0.bendPoints.size_0 == 0 ? new KVector_1(x_0.target.pos.x_0, x_0.target.pos.y_0) : castTo($getFirst(x_0.bendPoints), 8)).x_0, (y_1.bendPoints.size_0 == 0 ? new KVector_1(y_1.target.pos.x_0, y_1.target.pos.y_0) : castTo($getFirst(y_1.bendPoints), 8)).x_0);
}
function lambda$19_0(x_0, y_1) {
    $clinit_EdgeRouter();
    return compare_4((x_0.bendPoints.size_0 == 0 ? new KVector_1(x_0.source.pos.x_0, x_0.source.pos.y_0) : castTo($getLast(x_0.bendPoints), 8)).y_0, (y_1.bendPoints.size_0 == 0 ? new KVector_1(y_1.source.pos.x_0, y_1.source.pos.y_0) : castTo($getLast(y_1.bendPoints), 8)).y_0);
}
function lambda$2_11(finalCurlevel_0, x_1) {
    $clinit_EdgeRouter();
    return castTo($getProperty(x_1, ($clinit_MrTreeOptions(), TREE_LEVEL_0)), 17).value_0 == finalCurlevel_0;
}
function lambda$20_0(x_0, y_1) {
    $clinit_EdgeRouter();
    return compare_4((x_0.bendPoints.size_0 == 0 ? new KVector_1(x_0.source.pos.x_0, x_0.source.pos.y_0) : castTo($getLast(x_0.bendPoints), 8)).x_0, (y_1.bendPoints.size_0 == 0 ? new KVector_1(y_1.source.pos.x_0, y_1.source.pos.y_0) : castTo($getLast(y_1.bendPoints), 8)).x_0);
}
function lambda$3_9(x_0, y_1) {
    $clinit_EdgeRouter();
    return compare_4(x_0.pos.y_0, y_1.pos.y_0);
}
function lambda$4_8(x_0, y_1) {
    $clinit_EdgeRouter();
    return compare_4(x_0.pos.x_0, y_1.pos.x_0);
}
function lambda$5_5(x_0) {
    $clinit_EdgeRouter();
    return x_0.pos.y_0 + x_0.size_0.y_0 / 2;
}
function lambda$7_4(nodeBendpointPadding_0, finalSideTwoEdges_2, x_2) {
    $clinit_EdgeRouter();
    return x_2.pos.y_0 + x_2.size_0.y_0 + nodeBendpointPadding_0 * finalSideTwoEdges_2;
}
function lambda$9_0(nodeBendpointPadding_0, finalSideOneEdges_2, x_2) {
    $clinit_EdgeRouter();
    return x_2.pos.y_0 - nodeBendpointPadding_0 * finalSideOneEdges_2;
}
defineClass(1435, 1, $intern_110, EdgeRouter);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_26(graph) {
    return castTo(graph, 120), INTERMEDIATE_PROCESSING_CONFIG_2;
};
_.process = function process_93(tGraph, progressMonitor) {
    $process_97(castTo(tGraph, 120), progressMonitor);
};
var INTERMEDIATE_PROCESSING_CONFIG_2;
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter', 1435);
function EdgeRouter$0methodref$compare$Type() {}
defineClass(1437, 1, $intern_88, EdgeRouter$0methodref$compare$Type);
_.compare_1 = function compare_86(arg0, arg1) {
    return compare_5(castTo(arg0, 17).value_0, castTo(arg1, 17).value_0);
};
_.equals_0 = function equals_173(other) {
    return this === other;
};
_.reversed = function reversed_78() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$0methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/0methodref$compare$Type', 1437);
function EdgeRouter$1methodref$doubleValue$Type() {}
defineClass(1442, 1, {}, EdgeRouter$1methodref$doubleValue$Type);
_.applyAsDouble = function applyAsDouble_8(arg0) {
    return $doubleValue(castToDouble(arg0));
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$1methodref$doubleValue$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/1methodref$doubleValue$Type', 1442);
function EdgeRouter$2methodref$compare$Type() {}
defineClass(1444, 1, $intern_88, EdgeRouter$2methodref$compare$Type);
_.compare_1 = function compare_87(arg0, arg1) {
    return compare_4($doubleValue(castToDouble(arg0)), $doubleValue(castToDouble(arg1)));
};
_.equals_0 = function equals_174(other) {
    return this === other;
};
_.reversed = function reversed_79() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$2methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/2methodref$compare$Type', 1444);
function EdgeRouter$3methodref$compare$Type() {}
defineClass(1446, 1, $intern_88, EdgeRouter$3methodref$compare$Type);
_.compare_1 = function compare_88(arg0, arg1) {
    return compare_4($doubleValue(castToDouble(arg0)), $doubleValue(castToDouble(arg1)));
};
_.equals_0 = function equals_175(other) {
    return this === other;
};
_.reversed = function reversed_80() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$3methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/3methodref$compare$Type', 1446);
function EdgeRouter$4methodref$doubleValue$Type() {}
defineClass(1448, 1, {}, EdgeRouter$4methodref$doubleValue$Type);
_.applyAsDouble = function applyAsDouble_9(arg0) {
    return $doubleValue(castToDouble(arg0));
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$4methodref$doubleValue$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/4methodref$doubleValue$Type', 1448);
function EdgeRouter$5methodref$compare$Type() {}
defineClass(1450, 1, $intern_88, EdgeRouter$5methodref$compare$Type);
_.compare_1 = function compare_89(arg0, arg1) {
    return compare_4($doubleValue(castToDouble(arg0)), $doubleValue(castToDouble(arg1)));
};
_.equals_0 = function equals_176(other) {
    return this === other;
};
_.reversed = function reversed_81() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$5methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/5methodref$compare$Type', 1450);
function EdgeRouter$6methodref$compare$Type() {}
defineClass(1452, 1, $intern_88, EdgeRouter$6methodref$compare$Type);
_.compare_1 = function compare_90(arg0, arg1) {
    return compare_4($doubleValue(castToDouble(arg0)), $doubleValue(castToDouble(arg1)));
};
_.equals_0 = function equals_177(other) {
    return this === other;
};
_.reversed = function reversed_82() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$6methodref$compare$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/6methodref$compare$Type', 1452);
function EdgeRouter$lambda$0$Type() {}
defineClass(1436, 1, {}, EdgeRouter$lambda$0$Type);
_.apply_0 = function apply_136(arg0) {
    return $clinit_EdgeRouter(), castTo($getProperty(castTo(arg0, 39), ($clinit_MrTreeOptions(), TREE_LEVEL_0)), 17);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$0$Type', 1436);
function EdgeRouter$lambda$11$Type() {}
defineClass(1447, 1, {}, EdgeRouter$lambda$11$Type);
_.apply_0 = function apply_137(arg0) {
    return lambda$11_2(castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$11$Type', 1447);
function EdgeRouter$lambda$13$Type(nodeBendpointPadding_0, finalSideTwoEdges_2) {
    this.nodeBendpointPadding_0 = nodeBendpointPadding_0;
    this.finalSideTwoEdges_2 = finalSideTwoEdges_2;
}
defineClass(1449, 1, {}, EdgeRouter$lambda$13$Type);
_.apply_0 = function apply_138(arg0) {
    return lambda$13_0(this.nodeBendpointPadding_0, this.finalSideTwoEdges_2, castTo(arg0, 39));
};
_.finalSideTwoEdges_2 = 0;
_.nodeBendpointPadding_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$13$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$13$Type', 1449);
function EdgeRouter$lambda$15$Type(nodeBendpointPadding_0, finalSideOneEdges_2) {
    this.nodeBendpointPadding_0 = nodeBendpointPadding_0;
    this.finalSideOneEdges_2 = finalSideOneEdges_2;
}
defineClass(1451, 1, {}, EdgeRouter$lambda$15$Type);
_.apply_0 = function apply_139(arg0) {
    return lambda$15_0(this.nodeBendpointPadding_0, this.finalSideOneEdges_2, castTo(arg0, 39));
};
_.finalSideOneEdges_2 = 0;
_.nodeBendpointPadding_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$15$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$15$Type', 1451);
function EdgeRouter$lambda$17$Type() {}
defineClass(1453, 1, $intern_88, EdgeRouter$lambda$17$Type);
_.compare_1 = function compare_91(arg0, arg1) {
    return lambda$17(castTo(arg0, 65), castTo(arg1, 65));
};
_.equals_0 = function equals_178(other) {
    return this === other;
};
_.reversed = function reversed_83() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$17$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$17$Type', 1453);
function EdgeRouter$lambda$18$Type() {}
defineClass(1454, 1, $intern_88, EdgeRouter$lambda$18$Type);
_.compare_1 = function compare_92(arg0, arg1) {
    return lambda$18(castTo(arg0, 65), castTo(arg1, 65));
};
_.equals_0 = function equals_179(other) {
    return this === other;
};
_.reversed = function reversed_84() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$18$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$18$Type', 1454);
function EdgeRouter$lambda$19$Type() {}
defineClass(1455, 1, $intern_88, EdgeRouter$lambda$19$Type);
_.compare_1 = function compare_93(arg0, arg1) {
    return lambda$19_0(castTo(arg0, 65), castTo(arg1, 65));
};
_.equals_0 = function equals_180(other) {
    return this === other;
};
_.reversed = function reversed_85() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$19$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$19$Type', 1455);
function EdgeRouter$lambda$2$Type(finalCurlevel_0) {
    this.finalCurlevel_0 = finalCurlevel_0;
}
defineClass(1438, 1, $intern_39, EdgeRouter$lambda$2$Type);
_.test_0 = function test_115(arg0) {
    return lambda$2_11(this.finalCurlevel_0, castTo(arg0, 39));
};
_.finalCurlevel_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$2$Type', 1438);
function EdgeRouter$lambda$20$Type() {}
defineClass(1456, 1, $intern_88, EdgeRouter$lambda$20$Type);
_.compare_1 = function compare_94(arg0, arg1) {
    return lambda$20_0(castTo(arg0, 65), castTo(arg1, 65));
};
_.equals_0 = function equals_181(other) {
    return this === other;
};
_.reversed = function reversed_86() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$20$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$20$Type', 1456);
function EdgeRouter$lambda$3$Type() {}
defineClass(1439, 1, $intern_88, EdgeRouter$lambda$3$Type);
_.compare_1 = function compare_95(arg0, arg1) {
    return lambda$3_9(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_182(other) {
    return this === other;
};
_.reversed = function reversed_87() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$3$Type', 1439);
function EdgeRouter$lambda$4$Type() {}
defineClass(1440, 1, $intern_88, EdgeRouter$lambda$4$Type);
_.compare_1 = function compare_96(arg0, arg1) {
    return lambda$4_8(castTo(arg0, 39), castTo(arg1, 39));
};
_.equals_0 = function equals_183(other) {
    return this === other;
};
_.reversed = function reversed_88() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$4$Type', 1440);
function EdgeRouter$lambda$5$Type() {}
defineClass(1441, 1, {}, EdgeRouter$lambda$5$Type);
_.apply_0 = function apply_140(arg0) {
    return lambda$5_5(castTo(arg0, 39));
};
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$5$Type', 1441);
function EdgeRouter$lambda$7$Type(nodeBendpointPadding_0, finalSideTwoEdges_2) {
    this.nodeBendpointPadding_0 = nodeBendpointPadding_0;
    this.finalSideTwoEdges_2 = finalSideTwoEdges_2;
}
defineClass(1443, 1, {}, EdgeRouter$lambda$7$Type);
_.apply_0 = function apply_141(arg0) {
    return lambda$7_4(this.nodeBendpointPadding_0, this.finalSideTwoEdges_2, castTo(arg0, 39));
};
_.finalSideTwoEdges_2 = 0;
_.nodeBendpointPadding_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$7$Type', 1443);
function EdgeRouter$lambda$9$Type(nodeBendpointPadding_0, finalSideOneEdges_2) {
    this.nodeBendpointPadding_0 = nodeBendpointPadding_0;
    this.finalSideOneEdges_2 = finalSideOneEdges_2;
}
defineClass(1445, 1, {}, EdgeRouter$lambda$9$Type);
_.apply_0 = function apply_142(arg0) {
    return lambda$9_0(this.nodeBendpointPadding_0, this.finalSideOneEdges_2, castTo(arg0, 39));
};
_.finalSideOneEdges_2 = 0;
_.nodeBendpointPadding_0 = 0;
var Lorg_eclipse_elk_alg_mrtree_p4route_EdgeRouter$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'EdgeRouter/lambda$9$Type', 1445);
function $updateBendPoints(this$static) {
    var bend1, bend2, bendTmp, count, i, interpolation, p, p$iterator;
    i = 0;
    count = this$static.bendPoints.size_0;
    for(p$iterator = $listIterator_2(this$static.bendPoints, 0); p$iterator.currentNode != p$iterator.this$01.tail;){
        p = castTo($next_9(p$iterator), 239);
        interpolation = (i + 1) / (count + 1);
        if (!this$static.neighborOne && !this$static.neighborTwo) return;
        else if (!!this$static.neighborOne && !this$static.neighborTwo) {
            this$static.onLastNodeSide = true;
            if (this$static.d == ($clinit_Direction(), LEFT_6)) {
                bendTmp = this$static.neighborOne.pos.y_0 + this$static.neighborOne.size_0.y_0 + this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMAX)))) + this$static.nodeBendpointPadding, bendTmp);
                bend2 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMIN))) - this$static.nodeBendpointPadding, bendTmp);
            } else if (this$static.d == RIGHT_6) {
                bendTmp = this$static.neighborOne.pos.y_0 + this$static.neighborOne.size_0.y_0 + this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMIN)))) - this$static.nodeBendpointPadding, bendTmp);
                bend2 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMAX))) + this$static.nodeBendpointPadding, bendTmp);
            } else if (this$static.d == UP_1) {
                bendTmp = this$static.neighborOne.pos.x_0 + this$static.neighborOne.size_0.x_0 + this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMAX)))) + this$static.nodeBendpointPadding);
                bend2 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMIN))) - this$static.nodeBendpointPadding);
            } else {
                bendTmp = this$static.neighborOne.pos.x_0 + this$static.neighborOne.size_0.x_0 + this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMIN)))) - this$static.nodeBendpointPadding);
                bend2 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMAX))) + this$static.nodeBendpointPadding);
            }
        } else if (!!this$static.neighborOne && !!this$static.neighborTwo) {
            if (this$static.d == ($clinit_Direction(), LEFT_6)) {
                bendTmp = this$static.neighborTwo.pos.y_0 * interpolation + (this$static.neighborOne.pos.y_0 + this$static.neighborOne.size_0.y_0) * (1 - interpolation);
                bend1 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMAX)))) + this$static.nodeBendpointPadding, bendTmp);
                bend2 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMIN))) - this$static.nodeBendpointPadding, bendTmp);
            } else if (this$static.d == RIGHT_6) {
                bendTmp = this$static.neighborTwo.pos.y_0 * interpolation + (this$static.neighborOne.pos.y_0 + this$static.neighborOne.size_0.y_0) * (1 - interpolation);
                bend1 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMIN)))) - this$static.nodeBendpointPadding, bendTmp);
                bend2 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMAX))) + this$static.nodeBendpointPadding, bendTmp);
            } else if (this$static.d == UP_1) {
                bendTmp = this$static.neighborTwo.pos.x_0 * interpolation + (this$static.neighborOne.pos.x_0 + this$static.neighborOne.size_0.x_0) * (1 - interpolation);
                bend1 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMAX)))) + this$static.nodeBendpointPadding);
                bend2 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMIN))) - this$static.nodeBendpointPadding);
            } else {
                bendTmp = this$static.neighborTwo.pos.x_0 * interpolation + (this$static.neighborOne.pos.x_0 + this$static.neighborOne.size_0.x_0) * (1 - interpolation);
                bend1 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, ($clinit_InternalProperties_2(), LEVELMIN)))) - this$static.nodeBendpointPadding);
                bend2 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborOne, LEVELMAX))) + this$static.nodeBendpointPadding);
            }
        } else {
            this$static.onFirstNodeSide = true;
            if (this$static.d == ($clinit_Direction(), LEFT_6)) {
                bendTmp = this$static.neighborTwo.pos.y_0 - this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborTwo, ($clinit_InternalProperties_2(), LEVELMAX)))) + this$static.nodeBendpointPadding, bendTmp);
                bend2 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborTwo, LEVELMIN))) - this$static.nodeBendpointPadding, bendTmp);
            } else if (this$static.d == RIGHT_6) {
                bendTmp = this$static.neighborTwo.pos.y_0 - this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborTwo, ($clinit_InternalProperties_2(), LEVELMIN)))) - this$static.nodeBendpointPadding, bendTmp);
                bend2 = new KVector_1($doubleValue(castToDouble($getProperty(this$static.neighborTwo, LEVELMAX))) + this$static.nodeBendpointPadding, bendTmp);
            } else if (this$static.d == UP_1) {
                bendTmp = this$static.neighborTwo.pos.x_0 - this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborTwo, ($clinit_InternalProperties_2(), LEVELMAX)))) + this$static.nodeBendpointPadding);
                bend2 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborTwo, LEVELMIN))) - this$static.nodeBendpointPadding);
            } else {
                bendTmp = this$static.neighborTwo.pos.x_0 - this$static.nodeBendpointPadding * (i + 1);
                bend1 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborTwo, ($clinit_InternalProperties_2(), LEVELMIN)))) - this$static.nodeBendpointPadding);
                bend2 = new KVector_1(bendTmp, $doubleValue(castToDouble($getProperty(this$static.neighborTwo, LEVELMAX))) + this$static.nodeBendpointPadding);
            }
        }
        castTo(p.first, 8).x_0 = bend1.x_0;
        castTo(p.first, 8).y_0 = bend1.y_0;
        p.second.x_0 = bend2.x_0;
        p.second.y_0 = bend2.y_0;
        ++i;
    }
}
function MultiLevelEdgeNodeNodeGap(neighborOne, neighborTwo, bendTriple, graph) {
    var bends;
    this.neighborOne = neighborOne;
    this.neighborTwo = neighborTwo;
    bends = new LinkedList;
    $addNode_0(bends, bendTriple, bends.tail.prev, bends.tail);
    this.bendPoints = bends;
    this.d = castTo($getProperty(graph, ($clinit_MrTreeOptions(), DIRECTION_0)), 86);
    this.nodeBendpointPadding = $doubleValue(castToDouble($getProperty(graph, SPACING_EDGE_NODE_0)));
    $updateBendPoints(this);
}
function lambda$0_33(x_0, y_1) {
    return compare_4(castTo(x_0.third, 65).target.pos.y_0, castTo(y_1.third, 65).target.pos.y_0);
}
function lambda$1_17(x_0, y_1) {
    return compare_4(castTo(x_0.third, 65).target.pos.x_0, castTo(y_1.third, 65).target.pos.x_0);
}
defineClass(660, 1, {
    660: 1
}, MultiLevelEdgeNodeNodeGap);
_.nodeBendpointPadding = 0;
_.onFirstNodeSide = false;
_.onLastNodeSide = false;
var Lorg_eclipse_elk_alg_mrtree_p4route_MultiLevelEdgeNodeNodeGap_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'MultiLevelEdgeNodeNodeGap', 660);
function MultiLevelEdgeNodeNodeGap$lambda$0$Type() {}
defineClass(1889, 1, $intern_88, MultiLevelEdgeNodeNodeGap$lambda$0$Type);
_.compare_1 = function compare_97(arg0, arg1) {
    return lambda$0_33(castTo(arg0, 239), castTo(arg1, 239));
};
_.equals_0 = function equals_184(other) {
    return this === other;
};
_.reversed = function reversed_89() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_MultiLevelEdgeNodeNodeGap$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'MultiLevelEdgeNodeNodeGap/lambda$0$Type', 1889);
function MultiLevelEdgeNodeNodeGap$lambda$1$Type() {}
defineClass(1890, 1, $intern_88, MultiLevelEdgeNodeNodeGap$lambda$1$Type);
_.compare_1 = function compare_98(arg0, arg1) {
    return lambda$1_17(castTo(arg0, 239), castTo(arg1, 239));
};
_.equals_0 = function equals_185(other) {
    return this === other;
};
_.reversed = function reversed_90() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_mrtree_p4route_MultiLevelEdgeNodeNodeGap$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.mrtree.p4route', 'MultiLevelEdgeNodeNodeGap/lambda$1$Type', 1890);
function $clinit_InternalProperties_3() {
    $clinit_InternalProperties_3 = emptyMethod;
    ROOT_NODE = new Property('root');
}
var ROOT_NODE;
function $clinit_RadialLayoutPhases() {
    $clinit_RadialLayoutPhases = emptyMethod;
    P1_NODE_PLACEMENT = new RadialLayoutPhases('P1_NODE_PLACEMENT', 0);
    P2_EDGE_ROUTING = new RadialLayoutPhases('P2_EDGE_ROUTING', 1);
}
function $create_9(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new EadesRadial;
        case 1:
            return new StraightLineEdgeRouter;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout processor ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function RadialLayoutPhases(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_71(name_0) {
    $clinit_RadialLayoutPhases();
    return valueOf(($clinit_RadialLayoutPhases$Map(), $MAP_61), name_0);
}
function values_79() {
    $clinit_RadialLayoutPhases();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_RadialLayoutPhases_2_classLit, 1), $intern_36, 485, 0, [
        P1_NODE_PLACEMENT,
        P2_EDGE_ROUTING
    ]);
}
defineClass(485, 23, {
    3: 1,
    34: 1,
    23: 1,
    485: 1,
    188: 1,
    196: 1
}, RadialLayoutPhases);
_.create_1 = function create_22() {
    return $create_9(this);
};
_.create_2 = function create_21() {
    return $create_9(this);
};
var P1_NODE_PLACEMENT, P2_EDGE_ROUTING;
var Lorg_eclipse_elk_alg_radial_RadialLayoutPhases_2_classLit = createForEnum('org.eclipse.elk.alg.radial', 'RadialLayoutPhases', 485, Ljava_lang_Enum_2_classLit, values_79, valueOf_71);
function $clinit_RadialLayoutPhases$Map() {
    $clinit_RadialLayoutPhases$Map = emptyMethod;
    $MAP_61 = createValueOfMap(($clinit_RadialLayoutPhases(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_RadialLayoutPhases_2_classLit, 1), $intern_36, 485, 0, [
        P1_NODE_PLACEMENT,
        P2_EDGE_ROUTING
    ])));
}
var $MAP_61;
function $assembleAlgorithm(this$static, layoutGraph) {
    var algorithm, configuration;
    $reset_4(this$static.algorithmAssembler);
    $setPhase(this$static.algorithmAssembler, ($clinit_RadialLayoutPhases(), P1_NODE_PLACEMENT), P1_NODE_PLACEMENT);
    $setPhase(this$static.algorithmAssembler, P2_EDGE_ROUTING, P2_EDGE_ROUTING);
    configuration = new LayoutProcessorConfiguration;
    $addBefore(configuration, P2_EDGE_ROUTING, ($clinit_IntermediateProcessorStrategy_1(), OVERLAP_REMOVAL));
    maskUndefined($getProperty_0(layoutGraph, ($clinit_RadialOptions(), COMPACTOR_0))) !== maskUndefined(($clinit_CompactionStrategy(), NONE_13)) && $addBefore(configuration, P2_EDGE_ROUTING, COMPACTION_1);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, ROTATE_0))) && $addBefore(configuration, P2_EDGE_ROUTING, ROTATION_0);
    $addBefore(configuration, P2_EDGE_ROUTING, GRAPH_SIZE_CALCULATION);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, ROTATION_OUTGOING_EDGE_ANGLES_0))) && $addAfter(configuration, P2_EDGE_ROUTING, OUTGOING_EDGE_ANGLES);
    $addProcessorConfiguration(this$static.algorithmAssembler, configuration);
    algorithm = $build_0(this$static.algorithmAssembler, layoutGraph);
    return algorithm;
}
function RadialLayoutProvider() {
    this.algorithmAssembler = new AlgorithmAssembler(Lorg_eclipse_elk_alg_radial_RadialLayoutPhases_2_classLit);
}
defineClass(1078, 222, $intern_96, RadialLayoutProvider);
_.layout = function layout_3(layoutGraph, progressMonitor) {
    var algorithm, builder, layoutRadius, processor, processor$iterator, root;
    algorithm = $assembleAlgorithm(this, layoutGraph);
    progressMonitor.begin('Radial layout', algorithm.array.length);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, ($clinit_RadialOptions(), OMIT_NODE_MICRO_LAYOUT_2)))) || $execute((builder = new NodeMicroLayout(($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(layoutGraph))), builder));
    root = findRoot(layoutGraph);
    $setProperty_1(layoutGraph, ($clinit_InternalProperties_3(), ROOT_NODE), root);
    if (!root) throw toJs(new IllegalArgumentException_0('The given graph is not a tree!'));
    layoutRadius = $doubleValue(castToDouble($getProperty_0(layoutGraph, RADIUS_0)));
    layoutRadius == 0 && (layoutRadius = findLargestNodeInGraph(layoutGraph));
    $setProperty_1(layoutGraph, RADIUS_0, layoutRadius);
    for(processor$iterator = new ArrayList$1($assembleAlgorithm(this, layoutGraph)); processor$iterator.i < processor$iterator.this$01.array.length;){
        processor = castTo($next_6(processor$iterator), 44);
        processor.process(layoutGraph, progressMonitor.subTask(1));
    }
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_radial_RadialLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.radial', 'RadialLayoutProvider', 1078);
function findLargestNodeInGraph(graph) {
    var child, child$iterator, diameter, height, largestChild, largestChildSize, width_0;
    largestChildSize = 0;
    for(child$iterator = new AbstractEList$EIterator((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
        child = castTo($doNext(child$iterator), 27);
        width_0 = child.width_0;
        height = child.height;
        diameter = $wnd.Math.sqrt(width_0 * width_0 + height * height);
        largestChildSize = $wnd.Math.max(diameter, largestChildSize);
        largestChild = findLargestNodeInGraph(child);
        largestChildSize = $wnd.Math.max(largestChild, largestChildSize);
    }
    return largestChildSize;
}
function findRoot(graph) {
    var child, child$iterator, incomingEdges;
    for(child$iterator = new AbstractEList$EIterator((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
        child = castTo($doNext(child$iterator), 27);
        incomingEdges = allIncomingEdges(child);
        if (!$hasNext_1(new Iterators$ConcatenatedIterator(transform_2(incomingEdges.val$inputs1.iterator_0(), new Iterables$10)))) return child;
    }
    return null;
}
function findRootOfNode(elkNode) {
    var parent_0;
    parent_0 = getTreeParent(elkNode);
    return !parent_0 ? elkNode : findRootOfNode(parent_0);
}
function getNextLevelNodeSet(nodes) {
    var nextLevelSet, node, node$iterator, successors;
    successors = new HashSet;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 27);
        nextLevelSet = getSuccessorSet(node);
        $addAll(successors, nextLevelSet);
    }
    return successors;
}
function getNextLevelNodes(nodes) {
    var nextLevelNodes, node, node$iterator, successors;
    successors = new ArrayList;
    for(node$iterator = nodes.iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 27);
        nextLevelNodes = getSuccessors(node);
        $addAll_2(successors, nextLevelNodes);
    }
    return successors;
}
function getNumberOfLeaves(node) {
    var child, child$iterator, leafs, successors;
    leafs = 0;
    successors = getSuccessors(node);
    if (successors.array.length == 0) return 1;
    else for(child$iterator = new ArrayList$1(successors); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 27);
        leafs += getNumberOfLeaves(child);
    }
    return leafs;
}
function getSuccessorSet(node) {
    var children, old, outgoingEdge, outgoingEdge$iterator, successors, target;
    successors = new HashSet;
    children = new HashSet_1((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children));
    for(outgoingEdge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outgoingEdge$iterator);){
        outgoingEdge = castTo($next_0(outgoingEdge$iterator), 85);
        if (!instanceOf($get_20((!outgoingEdge.sources && (outgoingEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, outgoingEdge, 4, 7)), outgoingEdge.sources), 0), 193)) {
            target = connectableShapeToNode(castTo($get_20((!outgoingEdge.targets && (outgoingEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, outgoingEdge, 5, 8)), outgoingEdge.targets), 0), 84));
            children.map_0.containsKey(target) || (old = successors.map_0.put(target, successors), old);
        }
    }
    return successors;
}
function getSuccessors(node) {
    var children, outgoingEdge, outgoingEdge$iterator, successors, target;
    successors = new ArrayList;
    children = new HashSet_1((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children));
    for(outgoingEdge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(outgoingEdge$iterator);){
        outgoingEdge = castTo($next_0(outgoingEdge$iterator), 85);
        if (!instanceOf($get_20((!outgoingEdge.sources && (outgoingEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, outgoingEdge, 4, 7)), outgoingEdge.sources), 0), 193)) {
            target = connectableShapeToNode(castTo($get_20((!outgoingEdge.targets && (outgoingEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, outgoingEdge, 5, 8)), outgoingEdge.targets), 0), 84));
            children.map_0.containsKey(target) || push_1(successors.array, target);
        }
    }
    return successors;
}
function getTreeParent(node) {
    var edgeFromParent, iterator;
    iterator = allIncomingEdges(node);
    if (isEmpty_13(iterator)) return null;
    else {
        edgeFromParent = (checkNotNull(iterator), castTo(get_23(new Iterators$ConcatenatedIterator(transform_2(iterator.val$inputs1.iterator_0(), new Iterables$10))), 85));
        return connectableShapeToNode(castTo($get_20((!edgeFromParent.sources && (edgeFromParent.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edgeFromParent, 4, 7)), edgeFromParent.sources), 0), 84));
    }
}
function lambda$0_34(nodeOffsetY_0, radialOffset_2, node1_2, node2_3) {
    var arc1, arc2, position1, position2, xPos1, xPos2, yPos1, yPos2;
    position1 = castTo($getProperty_0(node1_2, ($clinit_CoreOptions(), POSITION_2)), 8);
    xPos1 = position1.x_0;
    yPos1 = position1.y_0 + nodeOffsetY_0;
    arc1 = $wnd.Math.atan2(yPos1, xPos1);
    arc1 < 0 && (arc1 += $intern_125);
    arc1 += radialOffset_2;
    arc1 > $intern_125 && (arc1 -= $intern_125);
    position2 = castTo($getProperty_0(node2_3, POSITION_2), 8);
    xPos2 = position2.x_0;
    yPos2 = position2.y_0 + nodeOffsetY_0;
    arc2 = $wnd.Math.atan2(yPos2, xPos2);
    arc2 < 0 && (arc2 += $intern_125);
    arc2 += radialOffset_2;
    arc2 > $intern_125 && (arc2 -= $intern_125);
    return $clinit_DoubleMath(), checkNonNegative(1.0E-10), $wnd.Math.abs(arc1 - arc2) <= 1.0E-10 || arc1 == arc2 || isNaN(arc1) && isNaN(arc2) ? 0 : arc1 < arc2 ? -1 : arc1 > arc2 ? 1 : compare_0(isNaN(arc1), isNaN(arc2));
}
function RadialUtil$lambda$0$Type(radialOffset_2) {
    this.nodeOffsetY_0 = 0;
    this.radialOffset_2 = radialOffset_2;
}
defineClass(541, 1, $intern_88, RadialUtil$lambda$0$Type);
_.compare_1 = function compare_99(arg0, arg1) {
    return lambda$0_34(this.nodeOffsetY_0, this.radialOffset_2, castTo(arg0, 27), castTo(arg1, 27));
};
_.equals_0 = function equals_186(other) {
    return this === other;
};
_.reversed = function reversed_91() {
    return new Comparators$ReversedComparator(this);
};
_.nodeOffsetY_0 = 0;
_.radialOffset_2 = 0;
var Lorg_eclipse_elk_alg_radial_RadialUtil$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.radial', 'RadialUtil/lambda$0$Type', 541);
function $process_98(graph, progressMonitor) {
    var additionalX, additionalY, dx, dy, height, height0, margins, maxXPos, maxYPos, minXPos, minYPos, node, node$iterator, node$iterator0, offset, padding, posX, posY, root, rootMargins, rootX, rootY, width_0, width0;
    progressMonitor.begin('Calculate Graph Size', 1);
    progressMonitor.logGraph(graph, 'Before');
    minXPos = $intern_113;
    minYPos = $intern_113;
    maxXPos = $intern_126;
    maxYPos = $intern_126;
    for(node$iterator0 = new AbstractEList$EIterator((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children)); node$iterator0.cursor != node$iterator0.this$01_2.size_1();){
        node = castTo($doNext(node$iterator0), 27);
        posX = node.x_0;
        posY = node.y_0;
        width0 = node.width_0;
        height0 = node.height;
        margins = castTo($getProperty_0(node, ($clinit_CoreOptions(), MARGINS_0)), 139);
        minXPos = $wnd.Math.min(minXPos, posX - margins.left);
        minYPos = $wnd.Math.min(minYPos, posY - margins.top_0);
        maxXPos = $wnd.Math.max(maxXPos, posX + width0 + margins.right);
        maxYPos = $wnd.Math.max(maxYPos, posY + height0 + margins.bottom);
    }
    padding = castTo($getProperty_0(graph, ($clinit_CoreOptions(), PADDING_5)), 107);
    offset = new KVector_1(minXPos - padding.left, minYPos - padding.top_0);
    width_0 = maxXPos - minXPos + (padding.left + padding.right);
    height = maxYPos - minYPos + (padding.top_0 + padding.bottom);
    if ($booleanValue(castToBoolean($getProperty_0(graph, ($clinit_RadialOptions(), CENTER_ON_ROOT_0))))) {
        root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
        rootMargins = castTo($getProperty_0(root, MARGINS_0), 139);
        rootX = root.x_0 + root.width_0 / 2 + (rootMargins.left + rootMargins.right) / 2 - offset.x_0;
        rootY = root.y_0 + root.height / 2 + (rootMargins.top_0 + rootMargins.bottom) / 2 - offset.y_0;
        dx = width_0 - rootX;
        dy = height - rootY;
        if (dx < width_0 / 2) {
            additionalX = dx - rootX;
            width_0 += additionalX;
            offset.x_0 -= additionalX;
        } else {
            additionalX = rootX - dx;
            width_0 += additionalX;
        }
        if (dy < height / 2) {
            additionalY = dy - rootY;
            height += additionalY;
            offset.y_0 -= additionalY;
        } else {
            additionalY = rootY - dy;
            height += additionalY;
        }
    }
    for(node$iterator = new AbstractEList$EIterator((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children)); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        $setX_1(node, node.x_0 - offset.x_0);
        $setY_2(node, node.y_0 - offset.y_0);
    }
    if (!$booleanValue(castToBoolean($getProperty_0(graph, NODE_SIZE_FIXED_GRAPH_SIZE_3)))) {
        $setWidth_0(graph, width_0);
        $setHeight_0(graph, height);
    }
    $setProperty_1(graph, CHILD_AREA_WIDTH, width_0 - (padding.left + padding.right));
    $setProperty_1(graph, CHILD_AREA_HEIGHT, height - (padding.top_0 + padding.bottom));
    progressMonitor.logGraph(graph, 'After');
}
function CalculateGraphSize() {}
defineClass(1334, 1, $intern_102, CalculateGraphSize);
_.process = function process_94(graph, progressMonitor) {
    $process_98(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_radial_intermediate_CalculateGraphSize_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate', 'CalculateGraphSize', 1334);
function $process_99(graph) {
    var angle, edge, edge$iterator, edgeVector, end, root, start_0;
    root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
    for(edge$iterator = new AbstractEList$EIterator((!root.outgoingEdges && (root.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, root, 7, 4)), root.outgoingEdges)); edge$iterator.cursor != edge$iterator.this$01_2.size_1();){
        edge = castTo($doNext(edge$iterator), 85);
        start_0 = new KVector_1(castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168).startX, castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168).startY);
        end = new KVector_1(castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168).endX, castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168).endY);
        edgeVector = new KVector_1(end.x_0 - start_0.x_0, end.y_0 - start_0.y_0);
        angle = $wnd.Math.atan2(edgeVector.y_0, edgeVector.x_0);
        castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84).setProperty(($clinit_RadialOptions(), ROTATION_TARGET_ANGLE_0), angle);
    }
}
function EdgeAngleCalculator() {}
defineClass(1335, 1, $intern_102, EdgeAngleCalculator);
_.process = function process_95(graph, progressMonitor) {
    $process_99(castTo(graph, 27));
};
var Lorg_eclipse_elk_alg_radial_intermediate_EdgeAngleCalculator_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate', 'EdgeAngleCalculator', 1335);
function $clinit_IntermediateProcessorStrategy_1() {
    $clinit_IntermediateProcessorStrategy_1 = emptyMethod;
    OVERLAP_REMOVAL = new IntermediateProcessorStrategy_1('OVERLAP_REMOVAL', 0);
    COMPACTION_1 = new IntermediateProcessorStrategy_1('COMPACTION', 1);
    ROTATION_0 = new IntermediateProcessorStrategy_1('ROTATION', 2);
    GRAPH_SIZE_CALCULATION = new IntermediateProcessorStrategy_1('GRAPH_SIZE_CALCULATION', 3);
    OUTGOING_EDGE_ANGLES = new IntermediateProcessorStrategy_1('OUTGOING_EDGE_ANGLES', 4);
}
function IntermediateProcessorStrategy_1(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_72(name_0) {
    $clinit_IntermediateProcessorStrategy_1();
    return valueOf(($clinit_IntermediateProcessorStrategy$Map_1(), $MAP_62), name_0);
}
function values_80() {
    $clinit_IntermediateProcessorStrategy_1();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_intermediate_IntermediateProcessorStrategy_2_classLit, 1), $intern_36, 361, 0, [
        OVERLAP_REMOVAL,
        COMPACTION_1,
        ROTATION_0,
        GRAPH_SIZE_CALCULATION,
        OUTGOING_EDGE_ANGLES
    ]);
}
defineClass(361, 23, {
    3: 1,
    34: 1,
    23: 1,
    361: 1,
    196: 1
}, IntermediateProcessorStrategy_1);
_.create_1 = function create_23() {
    switch(this.ordinal){
        case 0:
            return new RadiusExtensionOverlapRemoval;
        case 1:
            return new GeneralCompactor;
        case 2:
            return new GeneralRotator;
        case 3:
            return new CalculateGraphSize;
        case 4:
            return new EdgeAngleCalculator;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout processor ' + (this.name_0 != null ? this.name_0 : '' + this.ordinal)));
    }
};
var COMPACTION_1, GRAPH_SIZE_CALCULATION, OUTGOING_EDGE_ANGLES, OVERLAP_REMOVAL, ROTATION_0;
var Lorg_eclipse_elk_alg_radial_intermediate_IntermediateProcessorStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.radial.intermediate', 'IntermediateProcessorStrategy', 361, Ljava_lang_Enum_2_classLit, values_80, valueOf_72);
function $clinit_IntermediateProcessorStrategy$Map_1() {
    $clinit_IntermediateProcessorStrategy$Map_1 = emptyMethod;
    $MAP_62 = createValueOfMap(($clinit_IntermediateProcessorStrategy_1(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_intermediate_IntermediateProcessorStrategy_2_classLit, 1), $intern_36, 361, 0, [
        OVERLAP_REMOVAL,
        COMPACTION_1,
        ROTATION_0,
        GRAPH_SIZE_CALCULATION,
        OUTGOING_EDGE_ANGLES
    ])));
}
var $MAP_62;
function $contractLayer(this$static, layerNodes, isContracting) {
    var length_0, node, node$iterator, parentX, parentY, treeParent, x_0, xPos, y_0, yPos;
    for(node$iterator = layerNodes.iterator_0(); node$iterator.hasNext_0();){
        node = castTo(node$iterator.next_1(), 27);
        xPos = node.x_0 + node.width_0 / 2;
        yPos = node.y_0 + node.height / 2;
        treeParent = this$static.root_0;
        parentX = treeParent.x_0 + treeParent.width_0 / 2;
        parentY = treeParent.y_0 + treeParent.height / 2;
        x_0 = xPos - parentX;
        y_0 = yPos - parentY;
        length_0 = $wnd.Math.sqrt(x_0 * x_0 + y_0 * y_0);
        x_0 *= this$static.compactionStep / length_0;
        y_0 *= this$static.compactionStep / length_0;
        if (isContracting) {
            xPos -= x_0;
            yPos -= y_0;
        } else {
            xPos += x_0;
            yPos += y_0;
        }
        $setX_1(node, xPos - node.width_0 / 2);
        $setY_2(node, yPos - node.height / 2);
    }
}
function $overlap_1(this$static, node1, node2) {
    var height1, height2, width1, width2, x1, x2, y1, y2;
    x1 = node1.x_0 - this$static.spacing / 2;
    x2 = node2.x_0 - this$static.spacing / 2;
    y1 = node1.y_0 - this$static.spacing / 2;
    y2 = node2.y_0 - this$static.spacing / 2;
    width1 = node1.width_0 + this$static.spacing;
    width2 = node2.width_0 + this$static.spacing;
    height1 = node1.height + this$static.spacing;
    height2 = node2.height + this$static.spacing;
    if (x1 < x2 + width2 && x2 < x1 && y1 < y2 + height2 && y2 < y1) return true;
    else if (x2 < x1 + width1 && x1 < x2 && y2 < y1 + height1 && y1 < y2) return true;
    else if (x1 < x2 + width2 && x2 < x1 && y1 < y2 && y2 < y1 + height1) return true;
    else if (x2 < x1 + width1 && x1 < x2 && y1 < y2 + height2 && y2 < y1) return true;
    return false;
}
function $overlapLayer(this$static, nodes) {
    var i, overlapping;
    overlapping = false;
    if (nodes.size_1() < 2) return false;
    for(i = 0; i < nodes.size_1(); i++)i < nodes.size_1() - 1 ? overlapping = overlapping | $overlap_1(this$static, castTo(nodes.get_0(i), 27), castTo(nodes.get_0(i + 1), 27)) : overlapping = overlapping | $overlap_1(this$static, castTo(nodes.get_0(i), 27), castTo(nodes.get_0(0), 27));
    return overlapping;
}
function $setCompactionStep(this$static, compactionStep) {
    this$static.compactionStep = compactionStep;
}
function $setRoot(this$static, root) {
    this$static.root_0 = root;
}
function $setSpacing(this$static, spacing) {
    this$static.spacing = spacing;
}
defineClass(636, 1, {});
_.compactionStep = 1;
_.spacing = 0;
var Lorg_eclipse_elk_alg_radial_intermediate_compaction_AbstractRadiusExtensionCompaction_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.compaction', 'AbstractRadiusExtensionCompaction', 636);
function $constructContour(this$static, nodes) {
    var node, node$iterator, successors;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 27);
        $put(this$static.leftContour, node, node);
        $put(this$static.rightContour, node, node);
        successors = getSuccessors(node);
        if (successors.array.length != 0) {
            !!this$static.sorter && this$static.sorter.sort_1(successors);
            $put(this$static.leftContour, node, (checkCriticalElementIndex(0, successors.array.length), castTo(successors.array[0], 27)));
            $put(this$static.rightContour, node, castTo($get_11(successors, successors.array.length - 1), 27));
            while(getNextLevelNodes(successors).array.length != 0){
                successors = getNextLevelNodes(successors);
                !!this$static.sorter && this$static.sorter.sort_1(successors);
                $put(this$static.leftContour, node, (checkCriticalElementIndex(0, successors.array.length), castTo(successors.array[0], 27)));
                $put(this$static.rightContour, node, castTo($get_11(successors, successors.array.length - 1), 27));
            }
        }
    }
}
function $contourOverlap(this$static, neighbourWedgeParent, node, left) {
    var contour, contourNode, contourNode$iterator;
    contour = left ? castTo($get(this$static.leftContour, neighbourWedgeParent), 22) : castTo($get(this$static.rightContour, neighbourWedgeParent), 22);
    for(contourNode$iterator = contour.iterator_0(); contourNode$iterator.hasNext_0();){
        contourNode = castTo(contourNode$iterator.next_1(), 27);
        if ($overlap_1(this$static, node, contourNode)) return true;
    }
    return false;
}
function $contractWedge(this$static, predecessors, radialPredecessor, radialSuccessor, currentRadiusNodes) {
    var isOverlapping, nextLevelNodes, wasContracted;
    isOverlapping = $overlapping(this$static, predecessors, radialPredecessor, radialSuccessor, currentRadiusNodes);
    wasContracted = false;
    while(!isOverlapping){
        $contractLayer(this$static, currentRadiusNodes, true);
        wasContracted = true;
        isOverlapping = $overlapping(this$static, predecessors, radialPredecessor, radialSuccessor, currentRadiusNodes);
    }
    wasContracted && $contractLayer(this$static, currentRadiusNodes, false);
    nextLevelNodes = getNextLevelNodes(currentRadiusNodes);
    if (nextLevelNodes.array.length != 0) {
        !!this$static.sorter && this$static.sorter.sort_1(nextLevelNodes);
        $contractWedge(this$static, currentRadiusNodes, radialPredecessor, radialSuccessor, nextLevelNodes);
    }
}
function $overlapping(this$static, predecessors, leftParent, rightParent, layerNodes) {
    var firstNode, lastNode, predecessor, predecessor$iterator, sortedNode, sortedNode$iterator;
    !!this$static.sorter && this$static.sorter.sort_1(layerNodes);
    firstNode = castTo(layerNodes.get_0(0), 27);
    if ($contourOverlap(this$static, leftParent, firstNode, false)) return true;
    lastNode = castTo(layerNodes.get_0(layerNodes.size_1() - 1), 27);
    if ($contourOverlap(this$static, rightParent, lastNode, true)) return true;
    if ($overlapLayer(this$static, layerNodes)) return true;
    for(sortedNode$iterator = layerNodes.iterator_0(); sortedNode$iterator.hasNext_0();){
        sortedNode = castTo(sortedNode$iterator.next_1(), 27);
        for(predecessor$iterator = predecessors.iterator_0(); predecessor$iterator.hasNext_0();){
            predecessor = castTo(predecessor$iterator.next_1(), 27);
            if ($overlap_1(this$static, sortedNode, predecessor)) return true;
        }
    }
    return false;
}
function AnnulusWedgeCompaction() {
    this.leftContour = new HashMultimap;
    this.rightContour = new HashMultimap;
}
defineClass(1780, 636, {}, AnnulusWedgeCompaction);
_.compact_0 = function compact_2(graph) {
    var i, k, leftParent, nodeAsList, rightParent, rootList, spacing, stepSize, successors;
    this.root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
    $setRoot(this, this.root);
    this.sorter = $create_13(castTo($getProperty_0(graph, ($clinit_RadialOptions(), SORTER_0)), 299));
    stepSize = castTo($getProperty_0(graph, COMPACTION_STEP_SIZE_0), 17);
    !!stepSize && $setCompactionStep(this, stepSize.value_0);
    spacing = castToDouble($getProperty_0(graph, ($clinit_CoreOptions(), SPACING_NODE_NODE_6)));
    $setSpacing(this, (checkCriticalNotNull(spacing), spacing));
    successors = getSuccessors(this.root);
    !!this.sorter && this.sorter.sort_1(successors);
    $constructContour(this, successors);
    rootList = new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_ElkNode_2_classLit, 1), $intern_127, 27, 0, [
        this.root
    ]));
    for(k = 0; k < 2; k++)for(i = 0; i < successors.array.length; i++){
        nodeAsList = new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_ElkNode_2_classLit, 1), $intern_127, 27, 0, [
            (checkCriticalElementIndex(i, successors.array.length), castTo(successors.array[i], 27))
        ]));
        rightParent = i < successors.array.length - 1 ? (checkCriticalElementIndex(i + 1, successors.array.length), castTo(successors.array[i + 1], 27)) : (checkCriticalElementIndex(0, successors.array.length), castTo(successors.array[0], 27));
        leftParent = i == 0 ? castTo($get_11(successors, successors.array.length - 1), 27) : (checkCriticalElementIndex(i - 1, successors.array.length), castTo(successors.array[i - 1], 27));
        $contractWedge(this, (checkCriticalElementIndex(i, successors.array.length), castTo(successors.array[i], 27), rootList), leftParent, rightParent, nodeAsList);
    }
};
var Lorg_eclipse_elk_alg_radial_intermediate_compaction_AnnulusWedgeCompaction_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.compaction', 'AnnulusWedgeCompaction', 1780);
function $process_100(graph, progressMonitor) {
    var compactor;
    progressMonitor.begin('General Compactor', 1);
    compactor = $create_11(castTo($getProperty_0(graph, ($clinit_RadialOptions(), COMPACTOR_0)), 384));
    compactor.compact_0(graph);
}
function GeneralCompactor() {}
defineClass(1332, 1, $intern_102, GeneralCompactor);
_.process = function process_96(graph, progressMonitor) {
    $process_100(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_radial_intermediate_compaction_GeneralCompactor_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.compaction', 'GeneralCompactor', 1332);
function $calculateRadius(this$static, node) {
    var radius, root, rootX, rootY, vectorX, vectorY, xPos, yPos;
    xPos = node.x_0;
    yPos = node.y_0;
    root = this$static.root_0;
    rootX = root.x_0;
    rootY = root.y_0;
    vectorX = xPos - rootX;
    vectorY = yPos - rootY;
    radius = $wnd.Math.sqrt(vectorX * vectorX + vectorY * vectorY);
    return radius;
}
function $contract(this$static, nodes) {
    var isOverlapping, nextLevelNodes, wasContracted;
    if (nodes.array.length != 0) {
        isOverlapping = $overlapping_0(this$static, nodes);
        wasContracted = false;
        while(!isOverlapping){
            $contractLayer(this$static, nodes, true);
            wasContracted = true;
            isOverlapping = $overlapping_0(this$static, nodes);
        }
        wasContracted && $contractLayer(this$static, nodes, false);
        nextLevelNodes = getNextLevelNodes(nodes);
        !!this$static.sorter && this$static.sorter.sort_1(nextLevelNodes);
        this$static.lastRadius = $calculateRadius(this$static, (checkCriticalElementIndex(0, nodes.array.length), castTo(nodes.array[0], 27)));
        $contract(this$static, nextLevelNodes);
    }
}
function $overlapping_0(this$static, nodes) {
    var node, node$iterator, parent_0;
    if ($overlapLayer(this$static, nodes)) return true;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 27);
        parent_0 = getTreeParent(node);
        if ($overlap_1(this$static, node, parent_0)) return true;
        if ($calculateRadius(this$static, node) - this$static.spacing <= this$static.lastRadius) return true;
    }
    return false;
}
function RadialCompaction() {}
defineClass(1779, 636, {}, RadialCompaction);
_.compact_0 = function compact_3(graph) {
    var firstLevelNodes, root, spacing, stepSize;
    root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
    this.root_0 = root;
    this.sorter = $create_13(castTo($getProperty_0(graph, ($clinit_RadialOptions(), SORTER_0)), 299));
    stepSize = castTo($getProperty_0(graph, COMPACTION_STEP_SIZE_0), 17);
    !!stepSize && $setCompactionStep(this, stepSize.value_0);
    spacing = castToDouble($getProperty_0(graph, ($clinit_CoreOptions(), SPACING_NODE_NODE_6)));
    $setSpacing(this, (checkCriticalNotNull(spacing), spacing));
    firstLevelNodes = getSuccessors(root);
    !!this.sorter && this.sorter.sort_1(firstLevelNodes);
    $contract(this, firstLevelNodes);
};
_.lastRadius = 0;
var Lorg_eclipse_elk_alg_radial_intermediate_compaction_RadialCompaction_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.compaction', 'RadialCompaction', 1779);
function $isCrossing(this$static, node1, node2) {
    var b1, b2, m1, m2, node1Vector, node2Vector, position1, position2, rootX, rootY, xCut, xPos1, xPos2, yPos1, yPos2;
    rootX = this$static.root.x_0 + this$static.root.width_0 / 2;
    rootY = this$static.root.x_0 + this$static.root.width_0 / 2;
    xPos1 = node1.x_0 + node1.width_0 / 2;
    yPos1 = node1.y_0 + node1.height / 2;
    node1Vector = new KVector_1(xPos1, yPos1);
    position1 = castTo($getProperty_0(node1, ($clinit_CoreOptions(), POSITION_2)), 8);
    position1.x_0 = position1.x_0 + rootX;
    position1.y_0 = position1.y_0 + rootY;
    m1 = (node1Vector.y_0 - position1.y_0) / (node1Vector.x_0 - position1.x_0);
    b1 = node1Vector.y_0 - m1 * node1Vector.x_0;
    xPos2 = node2.x_0 + node2.width_0 / 2;
    yPos2 = node2.y_0 + node2.height / 2;
    node2Vector = new KVector_1(xPos2, yPos2);
    position2 = castTo($getProperty_0(node2, POSITION_2), 8);
    position2.x_0 = position2.x_0 + rootX;
    position2.y_0 = position2.y_0 + rootY;
    m2 = (node2Vector.y_0 - position2.y_0) / (node2Vector.x_0 - position2.x_0);
    b2 = node2Vector.y_0 - m2 * node2Vector.x_0;
    xCut = (b1 - b2) / (m2 - m1);
    if (position1.x_0 < xCut && node1Vector.x_0 < xCut || xCut < position1.x_0 && xCut < node1Vector.x_0) return false;
    else if (position2.x_0 < xCut && node2Vector.x_0 < xCut || xCut < position2.x_0 && xCut < node2Vector.x_0) return false;
    return true;
}
function CrossingMinimizationPosition() {}
defineClass(1788, 1, {}, CrossingMinimizationPosition);
_.evaluate = function evaluate(rootNode) {
    var crossings, i, k, node1, node1$iterator, nodes;
    this.root = rootNode;
    crossings = 0;
    nodes = getSuccessors(rootNode);
    k = 0;
    for(node1$iterator = new ArrayList$1(nodes); node1$iterator.i < node1$iterator.this$01.array.length;){
        node1 = castTo($next_6(node1$iterator), 27);
        ++k;
        for(i = k; i < nodes.array.length; i++)$isCrossing(this, node1, (checkCriticalElementIndex(i, nodes.array.length), castTo(nodes.array[i], 27))) && (crossings += 1);
    }
    return crossings;
};
var Lorg_eclipse_elk_alg_radial_intermediate_optimization_CrossingMinimizationPosition_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.optimization', 'CrossingMinimizationPosition', 1788);
function EdgeLengthOptimization() {}
defineClass(1786, 1, {}, EdgeLengthOptimization);
_.evaluate = function evaluate_0(root) {
    var edge, edge$iterator, edgeLength, rootX, rootY, sourceClip, target, targetClip, targetX, targetY, vector, vectorX, vectorY;
    edgeLength = 0;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(root).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 85);
        target = connectableShapeToNode(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84));
        targetX = target.x_0 + target.width_0 / 2;
        targetY = target.y_0 + target.height / 2;
        rootX = root.x_0 + root.width_0 / 2;
        rootY = root.y_0 + root.height / 2;
        vector = new KVector;
        vector.x_0 = targetX - rootX;
        vector.y_0 = targetY - rootY;
        sourceClip = new KVector_1(vector.x_0, vector.y_0);
        clipVector(sourceClip, root.width_0, root.height);
        vector.x_0 -= sourceClip.x_0;
        vector.y_0 -= sourceClip.y_0;
        rootX = targetX - vector.x_0;
        rootY = targetY - vector.y_0;
        targetClip = new KVector_1(vector.x_0, vector.y_0);
        clipVector(targetClip, target.width_0, target.height);
        vector.x_0 -= targetClip.x_0;
        vector.y_0 -= targetClip.y_0;
        targetX = rootX + vector.x_0;
        targetY = rootY + vector.y_0;
        vectorX = targetX - rootX;
        vectorY = targetY - rootY;
        edgeLength += $wnd.Math.sqrt(vectorX * vectorX + vectorY * vectorY);
    }
    return edgeLength;
};
var Lorg_eclipse_elk_alg_radial_intermediate_optimization_EdgeLengthOptimization_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.optimization', 'EdgeLengthOptimization', 1786);
function EdgeLengthPositionOptimization() {}
defineClass(1787, 1, {}, EdgeLengthPositionOptimization);
_.evaluate = function evaluate_1(root) {
    var edge, edge$iterator, edgeLength, position, rootX, rootY, target, targetX, targetY, vectorX, vectorY;
    edgeLength = 0;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(root).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 85);
        target = connectableShapeToNode(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84));
        targetX = target.x_0 + target.width_0 / 2;
        targetY = target.y_0 + target.height / 2;
        position = castTo($getProperty_0(target, ($clinit_CoreOptions(), POSITION_2)), 8);
        rootX = root.x_0 + position.x_0 + root.width_0 / 2;
        rootY = root.y_0 + position.y_0 + root.height;
        vectorX = targetX - rootX;
        vectorY = targetY - rootY;
        edgeLength += $wnd.Math.sqrt(vectorX * vectorX + vectorY * vectorY);
    }
    return edgeLength;
};
var Lorg_eclipse_elk_alg_radial_intermediate_optimization_EdgeLengthPositionOptimization_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.optimization', 'EdgeLengthPositionOptimization', 1787);
function $extend(this$static, graph, nodes, progressMonitor) {
    var firstNode, index_0, movedDistance, movedX, movedY, nextLevelNode, nextLevelNode$iterator, nextLevelNodes, node, node$iterator, oldPositions, root, rootX, rootY, nodeX, nodeY, differenceX, differenceY, length_0, unitX, unitY;
    if (nodes.array.length != 0) {
        oldPositions = new ArrayList;
        for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
            node = castTo($next_6(node$iterator), 27);
            $add_3(oldPositions, new KVector_1(node.x_0, node.y_0));
        }
        progressMonitor.logGraph(graph, 'Before removing overlaps');
        while($overlapLayer(this$static, nodes))$contractLayer(this$static, nodes, false);
        progressMonitor.logGraph(graph, 'After removing overlaps');
        movedX = 0;
        movedY = 0;
        firstNode = null;
        if (nodes.array.length != 0) {
            firstNode = (checkCriticalElementIndex(0, nodes.array.length), castTo(nodes.array[0], 27));
            movedX = firstNode.x_0 - (checkCriticalElementIndex(0, oldPositions.array.length), castTo(oldPositions.array[0], 8)).x_0;
            movedY = firstNode.y_0 - (checkCriticalElementIndex(0, oldPositions.array.length), castTo(oldPositions.array[0], 8)).y_0;
        }
        movedDistance = $wnd.Math.sqrt(movedX * movedX + movedY * movedY);
        nextLevelNodes = getNextLevelNodeSet(nodes);
        index_0 = 1;
        if (nextLevelNodes.map_0.size_1() != 0) {
            for(nextLevelNode$iterator = nextLevelNodes.map_0.keySet_0().iterator_0(); nextLevelNode$iterator.hasNext_0();){
                nextLevelNode = castTo(nextLevelNode$iterator.next_1(), 27);
                root = this$static.root_0;
                rootX = root.x_0 + root.width_0 / 2;
                rootY = root.y_0 + root.height / 2;
                nodeX = nextLevelNode.x_0 + nextLevelNode.width_0 / 2;
                nodeY = nextLevelNode.y_0 + nextLevelNode.height / 2;
                differenceX = nodeX - rootX;
                differenceY = nodeY - rootY;
                length_0 = $wnd.Math.sqrt(differenceX * differenceX + differenceY * differenceY);
                unitX = differenceX / length_0;
                unitY = differenceY / length_0;
                $setX_1(nextLevelNode, nextLevelNode.x_0 + unitX * movedDistance);
                $setY_2(nextLevelNode, nextLevelNode.y_0 + unitY * movedDistance);
            }
            progressMonitor.logGraph(graph, 'Child movement ' + index_0);
            ++index_0;
        }
        !!this$static.sorter && this$static.sorter.sort_1(new ArrayList_1(nextLevelNodes));
        $extend(this$static, graph, new ArrayList_1(nextLevelNodes), progressMonitor);
    }
}
function $process_101(this$static, graph, progressMonitor) {
    var root, spacing, successors;
    progressMonitor.begin('Remove overlaps', 1);
    progressMonitor.logGraph(graph, 'Before');
    root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
    this$static.root_0 = root;
    this$static.sorter = $create_13(castTo($getProperty_0(graph, ($clinit_RadialOptions(), SORTER_0)), 299));
    spacing = castToDouble($getProperty_0(graph, ($clinit_CoreOptions(), SPACING_NODE_NODE_6)));
    $setSpacing(this$static, (checkCriticalNotNull(spacing), spacing));
    successors = getSuccessors(root);
    $extend(this$static, graph, successors, progressMonitor);
    progressMonitor.logGraph(graph, 'After');
}
function RadiusExtensionOverlapRemoval() {}
defineClass(1331, 636, $intern_102, RadiusExtensionOverlapRemoval);
_.process = function process_97(graph, progressMonitor) {
    $process_101(this, castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_radial_intermediate_overlaps_RadiusExtensionOverlapRemoval_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.overlaps', 'RadiusExtensionOverlapRemoval', 1331);
function $rotate(graph) {
    var alignmentAngle, alpha_0, firstNode, firstVector, lastNode, lastVector, node, node$iterator, pos, root, targetAngle, wedgeAngle, newX;
    targetAngle = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RadialOptions(), ROTATION_TARGET_ANGLE_0))));
    if ($booleanValue(castToBoolean($getProperty_0(graph, ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE_0)))) {
        root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
        lastNode = castTo($get_20($getTargets(castTo($get_20((!root.outgoingEdges && (root.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, root, 7, 4)), root.outgoingEdges), (!root.outgoingEdges && (root.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, root, 7, 4)), root.outgoingEdges).size_0 - 1), 85)), 0), 27);
        firstNode = castTo($get_20($getTargets(castTo($get_20((!root.outgoingEdges && (root.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, root, 7, 4)), root.outgoingEdges), 0), 85)), 0), 27);
        lastVector = new KVector_1(lastNode.x_0 + lastNode.width_0 / 2, lastNode.y_0 + lastNode.height / 2);
        firstVector = new KVector_1(firstNode.x_0 + firstNode.width_0 / 2, firstNode.y_0 + firstNode.height / 2);
        alpha_0 = targetAngle;
        alpha_0 <= 0 && (alpha_0 += $intern_125);
        wedgeAngle = $wnd.Math.acos((lastVector.x_0 * firstVector.x_0 + lastVector.y_0 * firstVector.y_0) / ($wnd.Math.sqrt(lastVector.x_0 * lastVector.x_0 + lastVector.y_0 * lastVector.y_0) * $wnd.Math.sqrt(firstVector.x_0 * firstVector.x_0 + firstVector.y_0 * firstVector.y_0)));
        wedgeAngle <= 0 && (wedgeAngle += $intern_125);
        alignmentAngle = $wnd.Math.atan2(lastVector.y_0, lastVector.x_0);
        alignmentAngle <= 0 && (alignmentAngle += $intern_125);
        targetAngle = $intern_121 - (alignmentAngle - alpha_0 + wedgeAngle / 2);
    }
    for(node$iterator = new AbstractEList$EIterator((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children)); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        pos = new KVector_1(node.x_0 + node.width_0 / 2, node.y_0 + node.height / 2);
        newX = pos.x_0 * $wnd.Math.cos(targetAngle) - pos.y_0 * $wnd.Math.sin(targetAngle);
        pos.y_0 = pos.x_0 * $wnd.Math.sin(targetAngle) + pos.y_0 * $wnd.Math.cos(targetAngle);
        pos.x_0 = newX;
        $setLocation_1(node, pos.x_0 - node.width_0 / 2, pos.y_0 - node.height / 2);
    }
}
function $process_102(graph, progressMonitor) {
    progressMonitor.begin("General 'Rotator", 1);
    $rotate(graph);
}
function GeneralRotator() {}
defineClass(1333, 1, $intern_102, GeneralRotator);
_.process = function process_98(graph, progressMonitor) {
    $process_102(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_radial_intermediate_rotation_GeneralRotator_2_classLit = createForClass('org.eclipse.elk.alg.radial.intermediate.rotation', 'GeneralRotator', 1333);
function $clinit_AnnulusWedgeCriteria() {
    $clinit_AnnulusWedgeCriteria = emptyMethod;
    LEAF_NUMBER = new AnnulusWedgeCriteria('LEAF_NUMBER', 0);
    NODE_SIZE_0 = new AnnulusWedgeCriteria('NODE_SIZE', 1);
}
function $create_10(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new AnnulusWedgeByLeafs;
        case 1:
            return new AnnulusWedgeByNodeSpace;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout option ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function AnnulusWedgeCriteria(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_73(name_0) {
    $clinit_AnnulusWedgeCriteria();
    return valueOf(($clinit_AnnulusWedgeCriteria$Map(), $MAP_63), name_0);
}
function values_81() {
    $clinit_AnnulusWedgeCriteria();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_AnnulusWedgeCriteria_2_classLit, 1), $intern_36, 423, 0, [
        LEAF_NUMBER,
        NODE_SIZE_0
    ]);
}
defineClass(423, 23, {
    3: 1,
    34: 1,
    23: 1,
    423: 1
}, AnnulusWedgeCriteria);
var LEAF_NUMBER, NODE_SIZE_0;
var Lorg_eclipse_elk_alg_radial_options_AnnulusWedgeCriteria_2_classLit = createForEnum('org.eclipse.elk.alg.radial.options', 'AnnulusWedgeCriteria', 423, Ljava_lang_Enum_2_classLit, values_81, valueOf_73);
function $clinit_AnnulusWedgeCriteria$Map() {
    $clinit_AnnulusWedgeCriteria$Map = emptyMethod;
    $MAP_63 = createValueOfMap(($clinit_AnnulusWedgeCriteria(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_AnnulusWedgeCriteria_2_classLit, 1), $intern_36, 423, 0, [
        LEAF_NUMBER,
        NODE_SIZE_0
    ])));
}
var $MAP_63;
function $clinit_CompactionStrategy() {
    $clinit_CompactionStrategy = emptyMethod;
    NONE_13 = new CompactionStrategy('NONE', 0);
    RADIAL_COMPACTION = new CompactionStrategy('RADIAL_COMPACTION', 1);
    WEDGE_COMPACTION = new CompactionStrategy('WEDGE_COMPACTION', 2);
}
function $create_11(this$static) {
    switch(this$static.ordinal){
        case 1:
            return new RadialCompaction;
        case 2:
            return new AnnulusWedgeCompaction;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout option ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function CompactionStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_74(name_0) {
    $clinit_CompactionStrategy();
    return valueOf(($clinit_CompactionStrategy$Map(), $MAP_64), name_0);
}
function values_82() {
    $clinit_CompactionStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_CompactionStrategy_2_classLit, 1), $intern_36, 384, 0, [
        NONE_13,
        RADIAL_COMPACTION,
        WEDGE_COMPACTION
    ]);
}
defineClass(384, 23, {
    3: 1,
    34: 1,
    23: 1,
    384: 1
}, CompactionStrategy);
var NONE_13, RADIAL_COMPACTION, WEDGE_COMPACTION;
var Lorg_eclipse_elk_alg_radial_options_CompactionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.radial.options', 'CompactionStrategy', 384, Ljava_lang_Enum_2_classLit, values_82, valueOf_74);
function $clinit_CompactionStrategy$Map() {
    $clinit_CompactionStrategy$Map = emptyMethod;
    $MAP_64 = createValueOfMap(($clinit_CompactionStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_CompactionStrategy_2_classLit, 1), $intern_36, 384, 0, [
        NONE_13,
        RADIAL_COMPACTION,
        WEDGE_COMPACTION
    ])));
}
var $MAP_64;
function $clinit_RadialMetaDataProvider() {
    $clinit_RadialMetaDataProvider = emptyMethod;
    CENTER_ON_ROOT = new Property_1('org.eclipse.elk.radial.centerOnRoot', ($clinit_Boolean(), false));
    ORDER_ID = new Property_1('org.eclipse.elk.radial.orderId', valueOf_3(0));
    RADIUS = new Property_1('org.eclipse.elk.radial.radius', 0);
    ROTATE = new Property_1('org.eclipse.elk.radial.rotate', false);
    COMPACTOR_DEFAULT = ($clinit_CompactionStrategy(), NONE_13);
    COMPACTOR = new Property_1('org.eclipse.elk.radial.compactor', COMPACTOR_DEFAULT);
    valueOf_3(0);
    COMPACTION_STEP_SIZE = new Property_1('org.eclipse.elk.radial.compactionStepSize', valueOf_3(1));
    SORTER_DEFAULT = ($clinit_SortingStrategy(), NONE_15);
    SORTER = new Property_1('org.eclipse.elk.radial.sorter', SORTER_DEFAULT);
    WEDGE_CRITERIA_DEFAULT = ($clinit_AnnulusWedgeCriteria(), NODE_SIZE_0);
    WEDGE_CRITERIA = new Property_1('org.eclipse.elk.radial.wedgeCriteria', WEDGE_CRITERIA_DEFAULT);
    OPTIMIZATION_CRITERIA_DEFAULT = ($clinit_RadialTranslationStrategy(), NONE_14);
    OPTIMIZATION_CRITERIA = new Property_1('org.eclipse.elk.radial.optimizationCriteria', OPTIMIZATION_CRITERIA_DEFAULT);
    ROTATION_TARGET_ANGLE = new Property_1('org.eclipse.elk.radial.rotation.targetAngle', 0);
    ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE = new Property_1('org.eclipse.elk.radial.rotation.computeAdditionalWedgeSpace', false);
    ROTATION_OUTGOING_EDGE_ANGLES = new Property_1('org.eclipse.elk.radial.rotation.outgoingEdgeAngles', false);
}
function RadialMetaDataProvider() {
    $clinit_RadialMetaDataProvider();
}
defineClass(842, 1, $intern_98, RadialMetaDataProvider);
_.apply_4 = function apply_143(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.centerOnRoot'), ''), 'Center On Root'), 'Centers the layout on the root of the tree i.e. so that the central node is also the center node of the final layout. This introduces additional whitespace.'), ($clinit_Boolean(), false)), ($clinit_LayoutOptionData$Type(), BOOLEAN)), Ljava_lang_Boolean_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.orderId'), ''), 'Order ID'), 'The id can be used to define an order for nodes of one radius. This can be used to sort them in the layer accordingly.'), valueOf_3(0)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.radius'), ''), 'Radius'), 'The radius option can be used to set the initial radius for the radial layouter.'), 0), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.rotate'), ''), 'Rotate'), 'The rotate option determines whether a rotation of the layout should be performed.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.compactor'), ''), 'Compaction'), 'With the compacter option it can be determined how compaction on the graph is done. It can be chosen between none, the radial compaction or the compaction of wedges separately.'), COMPACTOR_DEFAULT), ENUM), Lorg_eclipse_elk_alg_radial_options_CompactionStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.compactionStepSize'), ''), 'Compaction Step Size'), 'Determine the size of steps with which the compaction is done. Step size 1 correlates to a compaction of 1 pixel per Iteration.'), valueOf_3(1)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.radial.compactionStepSize', 'org.eclipse.elk.radial.compactor', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.sorter'), ''), 'Sorter'), 'Sort the nodes per radius according to the sorting algorithm. The strategies are none, by the given order id, or sorting them by polar coordinates.'), SORTER_DEFAULT), ENUM), Lorg_eclipse_elk_alg_radial_options_SortingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.wedgeCriteria'), ''), 'Annulus Wedge Criteria'), 'Determine how the wedge for the node placement is calculated. It can be chosen between wedge determination by the number of leaves or by the maximum sum of diagonals.'), WEDGE_CRITERIA_DEFAULT), ENUM), Lorg_eclipse_elk_alg_radial_options_AnnulusWedgeCriteria_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.optimizationCriteria'), ''), 'Translation Optimization'), 'Find the optimal translation of the nodes of the first radii according to this criteria. For example edge crossings can be minimized.'), OPTIMIZATION_CRITERIA_DEFAULT), ENUM), Lorg_eclipse_elk_alg_radial_options_RadialTranslationStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.rotation.targetAngle'), 'rotation'), 'Target Angle'), 'The angle in radians that the layout should be rotated to after layout.'), 0), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.radial.rotation.targetAngle', 'org.eclipse.elk.radial.rotate', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.rotation.computeAdditionalWedgeSpace'), 'rotation'), 'Additional Wedge Space'), 'If set to true, modifies the target angle by rotating further such that space is left for an edge to pass in between the nodes. This option should only be used in conjunction with top-down layout.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.radial.rotation.computeAdditionalWedgeSpace', 'org.eclipse.elk.radial.rotate', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.radial.rotation.outgoingEdgeAngles'), 'rotation'), 'Outgoing Edge Angles'), 'Calculate the required angle of connected nodes to leave space for an incoming edge. This option should only be used in conjunction with top-down layout.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $apply_11((new RadialOptions, registry));
};
var CENTER_ON_ROOT, COMPACTION_STEP_SIZE, COMPACTOR, COMPACTOR_DEFAULT, OPTIMIZATION_CRITERIA, OPTIMIZATION_CRITERIA_DEFAULT, ORDER_ID, RADIUS, ROTATE, ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE, ROTATION_OUTGOING_EDGE_ANGLES, ROTATION_TARGET_ANGLE, SORTER, SORTER_DEFAULT, WEDGE_CRITERIA, WEDGE_CRITERIA_DEFAULT;
var Lorg_eclipse_elk_alg_radial_options_RadialMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.radial.options', 'RadialMetaDataProvider', 842);
function $clinit_RadialOptions() {
    $clinit_RadialOptions = emptyMethod;
    POSITION_1 = ($clinit_CoreOptions(), POSITION_2);
    SPACING_NODE_NODE_2 = SPACING_NODE_NODE_6;
    NODE_SIZE_CONSTRAINTS_3 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_MINIMUM_2 = NODE_SIZE_MINIMUM_5;
    NODE_SIZE_OPTIONS_3 = NODE_SIZE_OPTIONS_6;
    NODE_LABELS_PLACEMENT_3 = NODE_LABELS_PLACEMENT_5;
    OMIT_NODE_MICRO_LAYOUT_2 = OMIT_NODE_MICRO_LAYOUT_4;
    PORT_LABELS_PLACEMENT_3 = PORT_LABELS_PLACEMENT_5;
    COMPACTION_STEP_SIZE_0 = ($clinit_RadialMetaDataProvider(), COMPACTION_STEP_SIZE);
    COMPACTOR_0 = COMPACTOR;
    ROTATE_0 = ROTATE;
    ROTATION_TARGET_ANGLE_0 = ROTATION_TARGET_ANGLE;
    ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE_0 = ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE;
    ROTATION_OUTGOING_EDGE_ANGLES_0 = ROTATION_OUTGOING_EDGE_ANGLES;
    OPTIMIZATION_CRITERIA_0 = OPTIMIZATION_CRITERIA;
    ORDER_ID_0 = ORDER_ID;
    RADIUS_0 = RADIUS;
    SORTER_0 = SORTER;
    WEDGE_CRITERIA_0 = WEDGE_CRITERIA;
    CENTER_ON_ROOT_0 = CENTER_ON_ROOT;
}
function $apply_11(registry) {
    $register(registry, new LayoutAlgorithmData($category($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.radial'), 'ELK Radial'), 'A radial layout provider which is based on the algorithm of Peter Eades published in "Drawing free trees.", published by International Institute for Advanced Study of Social Information Science, Fujitsu Limited in 1991. The radial layouter takes a tree and places the nodes in radial order around the root. The nodes of the same tree level are placed on the same radius.'), new RadialOptions$RadialFactory), 'org.eclipse.elk.radial')));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.position', $getDefault(POSITION_1));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.spacing.nodeNode', $getDefault(SPACING_NODE_NODE_2));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_3));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM_2));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS_3));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.nodeLabels.placement', $getDefault(NODE_LABELS_PLACEMENT_3));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.omitNodeMicroLayout', $getDefault(OMIT_NODE_MICRO_LAYOUT_2));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.portLabels.placement', $getDefault(PORT_LABELS_PLACEMENT_3));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.compactionStepSize', $getDefault(COMPACTION_STEP_SIZE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.compactor', $getDefault(COMPACTOR_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.rotate', $getDefault(ROTATE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.rotation.targetAngle', $getDefault(ROTATION_TARGET_ANGLE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.rotation.computeAdditionalWedgeSpace', $getDefault(ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.rotation.outgoingEdgeAngles', $getDefault(ROTATION_OUTGOING_EDGE_ANGLES_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.optimizationCriteria', $getDefault(OPTIMIZATION_CRITERIA_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.orderId', $getDefault(ORDER_ID_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.radius', $getDefault(RADIUS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.sorter', $getDefault(SORTER_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.wedgeCriteria', $getDefault(WEDGE_CRITERIA_0));
    $addOptionSupport(registry, 'org.eclipse.elk.radial', 'org.eclipse.elk.radial.centerOnRoot', $getDefault(CENTER_ON_ROOT_0));
}
function RadialOptions() {
    $clinit_RadialOptions();
}
defineClass(985, 1, $intern_98, RadialOptions);
_.apply_4 = function apply_144(registry) {
    $apply_11(registry);
};
var CENTER_ON_ROOT_0, COMPACTION_STEP_SIZE_0, COMPACTOR_0, NODE_LABELS_PLACEMENT_3, NODE_SIZE_CONSTRAINTS_3, NODE_SIZE_MINIMUM_2, NODE_SIZE_OPTIONS_3, OMIT_NODE_MICRO_LAYOUT_2, OPTIMIZATION_CRITERIA_0, ORDER_ID_0, PORT_LABELS_PLACEMENT_3, POSITION_1, RADIUS_0, ROTATE_0, ROTATION_COMPUTE_ADDITIONAL_WEDGE_SPACE_0, ROTATION_OUTGOING_EDGE_ANGLES_0, ROTATION_TARGET_ANGLE_0, SORTER_0, SPACING_NODE_NODE_2, WEDGE_CRITERIA_0;
var Lorg_eclipse_elk_alg_radial_options_RadialOptions_2_classLit = createForClass('org.eclipse.elk.alg.radial.options', 'RadialOptions', 985);
function RadialOptions$RadialFactory() {}
defineClass(986, 1, {}, RadialOptions$RadialFactory);
_.create_0 = function create_24() {
    var provider;
    return provider = new RadialLayoutProvider, provider;
};
_.destroy = function destroy_3(obj) {};
var Lorg_eclipse_elk_alg_radial_options_RadialOptions$RadialFactory_2_classLit = createForClass('org.eclipse.elk.alg.radial.options', 'RadialOptions/RadialFactory', 986);
function $clinit_RadialTranslationStrategy() {
    $clinit_RadialTranslationStrategy = emptyMethod;
    NONE_14 = new RadialTranslationStrategy('NONE', 0);
    EDGE_LENGTH_0 = new RadialTranslationStrategy('EDGE_LENGTH', 1);
    EDGE_LENGTH_BY_POSITION = new RadialTranslationStrategy('EDGE_LENGTH_BY_POSITION', 2);
    CROSSING_MINIMIZATION_BY_POSITION = new RadialTranslationStrategy('CROSSING_MINIMIZATION_BY_POSITION', 3);
}
function $create_12(this$static) {
    switch(this$static.ordinal){
        case 1:
            return new EdgeLengthOptimization;
        case 2:
            return new EdgeLengthPositionOptimization;
        case 3:
            return new CrossingMinimizationPosition;
        case 0:
            return null;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout option ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function RadialTranslationStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_75(name_0) {
    $clinit_RadialTranslationStrategy();
    return valueOf(($clinit_RadialTranslationStrategy$Map(), $MAP_65), name_0);
}
function values_83() {
    $clinit_RadialTranslationStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_RadialTranslationStrategy_2_classLit, 1), $intern_36, 351, 0, [
        NONE_14,
        EDGE_LENGTH_0,
        EDGE_LENGTH_BY_POSITION,
        CROSSING_MINIMIZATION_BY_POSITION
    ]);
}
defineClass(351, 23, {
    3: 1,
    34: 1,
    23: 1,
    351: 1
}, RadialTranslationStrategy);
var CROSSING_MINIMIZATION_BY_POSITION, EDGE_LENGTH_0, EDGE_LENGTH_BY_POSITION, NONE_14;
var Lorg_eclipse_elk_alg_radial_options_RadialTranslationStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.radial.options', 'RadialTranslationStrategy', 351, Ljava_lang_Enum_2_classLit, values_83, valueOf_75);
function $clinit_RadialTranslationStrategy$Map() {
    $clinit_RadialTranslationStrategy$Map = emptyMethod;
    $MAP_65 = createValueOfMap(($clinit_RadialTranslationStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_RadialTranslationStrategy_2_classLit, 1), $intern_36, 351, 0, [
        NONE_14,
        EDGE_LENGTH_0,
        EDGE_LENGTH_BY_POSITION,
        CROSSING_MINIMIZATION_BY_POSITION
    ])));
}
var $MAP_65;
function $clinit_SortingStrategy() {
    $clinit_SortingStrategy = emptyMethod;
    NONE_15 = new SortingStrategy('NONE', 0);
    POLAR_COORDINATE = new SortingStrategy('POLAR_COORDINATE', 1);
    ID_0 = new SortingStrategy('ID', 2);
}
function $create_13(this$static) {
    switch(this$static.ordinal){
        case 0:
            return null;
        case 1:
            return new PolarCoordinateSorter;
        case 2:
            return new IDSorter;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the layout option ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function SortingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_76(name_0) {
    $clinit_SortingStrategy();
    return valueOf(($clinit_SortingStrategy$Map(), $MAP_66), name_0);
}
function values_84() {
    $clinit_SortingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_SortingStrategy_2_classLit, 1), $intern_36, 299, 0, [
        NONE_15,
        POLAR_COORDINATE,
        ID_0
    ]);
}
defineClass(299, 23, {
    3: 1,
    34: 1,
    23: 1,
    299: 1
}, SortingStrategy);
var ID_0, NONE_15, POLAR_COORDINATE;
var Lorg_eclipse_elk_alg_radial_options_SortingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.radial.options', 'SortingStrategy', 299, Ljava_lang_Enum_2_classLit, values_84, valueOf_76);
function $clinit_SortingStrategy$Map() {
    $clinit_SortingStrategy$Map = emptyMethod;
    $MAP_66 = createValueOfMap(($clinit_SortingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_radial_options_SortingStrategy_2_classLit, 1), $intern_36, 299, 0, [
        NONE_15,
        POLAR_COORDINATE,
        ID_0
    ])));
}
var $MAP_66;
function $positionNodes(this$static, node, currentRadius, minAlpha, maxAlpha, optimalOffset) {
    var alpha_0, alphaPoint, child, child$iterator, numberOfChildLeafs, numberOfLeafs, radOffest, s, successors, tau, xPos, yPos, xPosition, yPosition;
    radOffest = optimalOffset;
    alphaPoint = (minAlpha + maxAlpha) / 2 + radOffest;
    xPos = currentRadius * $wnd.Math.cos(alphaPoint);
    yPos = currentRadius * $wnd.Math.sin(alphaPoint);
    xPosition = xPos - node.width_0 / 2;
    yPosition = yPos - node.height / 2;
    $setX_1(node, xPosition);
    $setY_2(node, yPosition);
    numberOfLeafs = this$static.annulusWedgeCriteria.calculateWedgeSpace(node);
    tau = 2 * $wnd.Math.acos(currentRadius / currentRadius + this$static.radius);
    if (tau < maxAlpha - minAlpha) {
        s = tau / numberOfLeafs;
        alpha_0 = (minAlpha + maxAlpha - tau) / 2;
    } else {
        s = (maxAlpha - minAlpha) / numberOfLeafs;
        alpha_0 = minAlpha;
    }
    successors = getSuccessors(node);
    if (this$static.sorter) {
        this$static.sorter.initialize_0(this$static.root);
        this$static.sorter.sort_1(successors);
    }
    for(child$iterator = new ArrayList$1(successors); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 27);
        numberOfChildLeafs = this$static.annulusWedgeCriteria.calculateWedgeSpace(child);
        $positionNodes(this$static, child, currentRadius + this$static.radius, alpha_0, alpha_0 + s * numberOfChildLeafs, optimalOffset);
        alpha_0 += s * numberOfChildLeafs;
    }
}
function $process_103(this$static, graph, progressMonitor) {
    progressMonitor.begin('Eades radial', 1);
    progressMonitor.logGraph(graph, 'After');
    this$static.root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
    this$static.radius = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RadialOptions(), RADIUS_0))));
    this$static.sorter = $create_13(castTo($getProperty_0(graph, SORTER_0), 299));
    this$static.annulusWedgeCriteria = $create_10(castTo($getProperty_0(graph, WEDGE_CRITERIA_0), 423));
    this$static.optimizer = $create_12(castTo($getProperty_0(graph, OPTIMIZATION_CRITERIA_0), 351));
    $translate_0(this$static);
    progressMonitor.logGraph(graph, 'After');
}
function $translate_0(this$static) {
    var i, offset, optimalOffset, optimalValue, translatedValue;
    optimalOffset = 0;
    optimalValue = $intern_113;
    if (this$static.optimizer) for(i = 0; i < 360; i++){
        offset = i * 0.017453292519943295;
        $positionNodes(this$static, this$static.root, 0, 0, $intern_125, offset);
        translatedValue = this$static.optimizer.evaluate(this$static.root);
        if (translatedValue < optimalValue) {
            optimalOffset = offset;
            optimalValue = translatedValue;
        }
    }
    $positionNodes(this$static, this$static.root, 0, 0, $intern_125, optimalOffset);
}
function EadesRadial() {}
defineClass(1415, 1, $intern_110, EadesRadial);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_27(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_99(graph, progressMonitor) {
    $process_103(this, castTo(graph, 27), progressMonitor);
};
_.radius = 0;
var Lorg_eclipse_elk_alg_radial_p1position_EadesRadial_2_classLit = createForClass('org.eclipse.elk.alg.radial.p1position', 'EadesRadial', 1415);
function AnnulusWedgeByLeafs() {}
defineClass(1784, 1, {}, AnnulusWedgeByLeafs);
_.calculateWedgeSpace = function calculateWedgeSpace(node) {
    return getNumberOfLeaves(node);
};
var Lorg_eclipse_elk_alg_radial_p1position_wedge_AnnulusWedgeByLeafs_2_classLit = createForClass('org.eclipse.elk.alg.radial.p1position.wedge', 'AnnulusWedgeByLeafs', 1784);
function $calculateWedgeSpace(this$static, node) {
    var child, child$iterator, childSpace, height, nodeSize, successors, width_0;
    successors = getSuccessors(node);
    height = node.height;
    width_0 = node.width_0;
    nodeSize = $wnd.Math.sqrt(height * height + width_0 * width_0);
    childSpace = 0;
    for(child$iterator = new ArrayList$1(successors); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 27);
        childSpace += $calculateWedgeSpace(this$static, child);
    }
    return $wnd.Math.max(childSpace, nodeSize);
}
function AnnulusWedgeByNodeSpace() {}
defineClass(1785, 1, {}, AnnulusWedgeByNodeSpace);
_.calculateWedgeSpace = function calculateWedgeSpace_0(node) {
    return $calculateWedgeSpace(this, node);
};
var Lorg_eclipse_elk_alg_radial_p1position_wedge_AnnulusWedgeByNodeSpace_2_classLit = createForClass('org.eclipse.elk.alg.radial.p1position.wedge', 'AnnulusWedgeByNodeSpace', 1785);
function $process_104(this$static, graph, progressMonitor) {
    var root;
    progressMonitor.begin('Straight Line Edge Routing', 1);
    progressMonitor.logGraph(graph, 'Before');
    root = castTo($getProperty_0(graph, ($clinit_InternalProperties_3(), ROOT_NODE)), 27);
    $routeEdges_1(this$static, root);
    progressMonitor.logGraph(graph, 'After');
}
function $routeEdges_1(this$static, node) {
    var edge, edge$iterator, section, sourceClip, sourceX, sourceY, target, targetClip, targetX, targetY, vector;
    for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
        edge = castTo($next_0(edge$iterator), 85);
        if (!instanceOf($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 193)) {
            target = connectableShapeToNode(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84));
            if (!$isHierarchical(edge)) {
                sourceX = node.x_0 + node.width_0 / 2;
                sourceY = node.y_0 + node.height / 2;
                targetX = target.x_0 + target.width_0 / 2;
                targetY = target.y_0 + target.height / 2;
                vector = new KVector;
                vector.x_0 = targetX - sourceX;
                vector.y_0 = targetY - sourceY;
                sourceClip = new KVector_1(vector.x_0, vector.y_0);
                clipVector(sourceClip, node.width_0, node.height);
                vector.x_0 -= sourceClip.x_0;
                vector.y_0 -= sourceClip.y_0;
                sourceX = targetX - vector.x_0;
                sourceY = targetY - vector.y_0;
                targetClip = new KVector_1(vector.x_0, vector.y_0);
                clipVector(targetClip, target.width_0, target.height);
                vector.x_0 -= targetClip.x_0;
                vector.y_0 -= targetClip.y_0;
                targetX = sourceX + vector.x_0;
                targetY = sourceY + vector.y_0;
                section = firstEdgeSection(edge);
                $setStartX(section, sourceX);
                $setStartY(section, sourceY);
                $setEndX(section, targetX);
                $setEndY(section, targetY);
                $routeEdges_1(this$static, target);
            }
        }
    }
}
function StraightLineEdgeRouter() {}
defineClass(1416, 1, $intern_110, StraightLineEdgeRouter);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_28(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_100(graph, progressMonitor) {
    $process_104(this, castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_radial_p2routing_StraightLineEdgeRouter_2_classLit = createForClass('org.eclipse.elk.alg.radial.p2routing', 'StraightLineEdgeRouter', 1416);
function $sort_2(this$static, nodes) {
    nodes.sort_0(this$static.idSorter);
}
function IDSorter() {
    this.idSorter = new IDSorter$lambda$0$Type;
}
function lambda$0_35(node1_0, node2_1) {
    var orderID1, orderID2;
    orderID1 = castTo($getProperty_0(node1_0, ($clinit_RadialOptions(), ORDER_ID_0)), 17);
    orderID2 = castTo($getProperty_0(node2_1, ORDER_ID_0), 17);
    return compare_5(orderID1.value_0, orderID2.value_0);
}
defineClass(805, 1, {}, IDSorter);
_.initialize_0 = function initialize_3(root) {};
_.sort_1 = function sort_11(nodes) {
    $sort_2(this, nodes);
};
var Lorg_eclipse_elk_alg_radial_sorting_IDSorter_2_classLit = createForClass('org.eclipse.elk.alg.radial.sorting', 'IDSorter', 805);
function IDSorter$lambda$0$Type() {}
defineClass(1783, 1, $intern_88, IDSorter$lambda$0$Type);
_.compare_1 = function compare_100(arg0, arg1) {
    return lambda$0_35(castTo(arg0, 27), castTo(arg1, 27));
};
_.equals_0 = function equals_187(other) {
    return this === other;
};
_.reversed = function reversed_92() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_radial_sorting_IDSorter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.radial.sorting', 'IDSorter/lambda$0$Type', 1783);
function $initialize_7(this$static, root) {
    var successors;
    this$static.idSorter = new IDSorter;
    successors = getSuccessors(root);
    $sort(successors, this$static.compRight);
    $setIDForNodes(this$static, successors, 0);
}
function $setIDForNodes(this$static, nodes, idOffset) {
    var arc, id_0, nextLayerId, node, node$iterator, nodeSuccessors;
    id_0 = idOffset;
    nextLayerId = 0;
    for(node$iterator = new ArrayList$1(nodes); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 27);
        $setProperty_1(node, ($clinit_RadialOptions(), ORDER_ID_0), valueOf_3(id_0++));
        nodeSuccessors = getSuccessors(node);
        arc = $wnd.Math.atan2(node.y_0 + node.height / 2, node.x_0 + node.width_0 / 2);
        arc += arc < 0 ? $intern_125 : 0;
        arc < 0.7853981633974483 || arc > $intern_128 ? $sort(nodeSuccessors, this$static.compLeft) : arc <= $intern_128 && arc > $intern_129 ? $sort(nodeSuccessors, this$static.compTop) : arc <= $intern_129 && arc > $intern_130 ? $sort(nodeSuccessors, this$static.compRight) : arc <= $intern_130 && $sort(nodeSuccessors, this$static.compBottom);
        nextLayerId = $setIDForNodes(this$static, nodeSuccessors, nextLayerId);
    }
    return id_0;
}
function PolarCoordinateSorter() {
    this.compRight = new RadialUtil$lambda$0$Type(0);
    this.compLeft = new RadialUtil$lambda$0$Type($intern_121);
    this.compTop = new RadialUtil$lambda$0$Type($intern_119);
    this.compBottom = new RadialUtil$lambda$0$Type($intern_120);
}
defineClass(1782, 1, {}, PolarCoordinateSorter);
_.initialize_0 = function initialize_4(root) {
    $initialize_7(this, root);
};
_.sort_1 = function sort_12(nodes) {
    var root;
    if (!nodes.isEmpty()) {
        if (!this.idSorter) {
            root = findRootOfNode(castTo(nodes.get_0(0), 27));
            $initialize_7(this, root);
        }
        $sort_2(this.idSorter, nodes);
    }
};
var Lorg_eclipse_elk_alg_radial_sorting_PolarCoordinateSorter_2_classLit = createForClass('org.eclipse.elk.alg.radial.sorting', 'PolarCoordinateSorter', 1782);
function $clinit_RectPackingLayoutPhases() {
    $clinit_RectPackingLayoutPhases = emptyMethod;
    P1_WIDTH_APPROXIMATION = new RectPackingLayoutPhases('P1_WIDTH_APPROXIMATION', 0);
    P2_PACKING = new RectPackingLayoutPhases('P2_PACKING', 1);
    P3_WHITESPACE_ELIMINATION = new RectPackingLayoutPhases('P3_WHITESPACE_ELIMINATION', 2);
}
function RectPackingLayoutPhases(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_77(name_0) {
    $clinit_RectPackingLayoutPhases();
    return valueOf(($clinit_RectPackingLayoutPhases$Map(), $MAP_67), name_0);
}
function values_85() {
    $clinit_RectPackingLayoutPhases();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_RectPackingLayoutPhases_2_classLit, 1), $intern_36, 433, 0, [
        P1_WIDTH_APPROXIMATION,
        P2_PACKING,
        P3_WHITESPACE_ELIMINATION
    ]);
}
defineClass(433, 23, {
    3: 1,
    34: 1,
    23: 1,
    433: 1
}, RectPackingLayoutPhases);
var P1_WIDTH_APPROXIMATION, P2_PACKING, P3_WHITESPACE_ELIMINATION;
var Lorg_eclipse_elk_alg_rectpacking_RectPackingLayoutPhases_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking', 'RectPackingLayoutPhases', 433, Ljava_lang_Enum_2_classLit, values_85, valueOf_77);
function $clinit_RectPackingLayoutPhases$Map() {
    $clinit_RectPackingLayoutPhases$Map = emptyMethod;
    $MAP_67 = createValueOfMap(($clinit_RectPackingLayoutPhases(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_RectPackingLayoutPhases_2_classLit, 1), $intern_36, 433, 0, [
        P1_WIDTH_APPROXIMATION,
        P2_PACKING,
        P3_WHITESPACE_ELIMINATION
    ])));
}
var $MAP_67;
function RectPackingLayoutProvider() {
    this.algorithmAssembler = new AlgorithmAssembler(Lorg_eclipse_elk_alg_rectpacking_RectPackingLayoutPhases_2_classLit);
}
function applyPadding(rectangles, padding) {
    var rect, rect$iterator;
    for(rect$iterator = new AbstractEList$EIterator(rectangles); rect$iterator.cursor != rect$iterator.this$01_2.size_1();){
        rect = castTo($doNext(rect$iterator), 27);
        $setLocation_1(rect, rect.x_0 + padding.left, rect.y_0 + padding.top_0);
    }
}
defineClass(1082, 222, $intern_96, RectPackingLayoutProvider);
_.layout = function layout_4(layoutGraph, progressMonitor) {
    var algorithm, builder, builder0, counter, elkNode, elkNode$iterator, fixedGraphSize, monitorProgress, nodeNodeSpacing, padding, priority, processor, processor$iterator, realHeight, realWidth, rect, rect$iterator, rectangles, region1, region2, region3, slotIndex, stackable, tryBox, configuration;
    progressMonitor.begin('Rectangle Packing', 1);
    padding = castTo($getProperty_0(layoutGraph, ($clinit_RectPackingOptions(), PADDING_2)), 107);
    fixedGraphSize = $booleanValue(castToBoolean($getProperty_0(layoutGraph, NODE_SIZE_FIXED_GRAPH_SIZE_2)));
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty_0(layoutGraph, SPACING_NODE_NODE_3)));
    tryBox = $booleanValue(castToBoolean($getProperty_0(layoutGraph, TRYBOX_0)));
    rectangles = (!layoutGraph.children && (layoutGraph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutGraph, 10, 11)), layoutGraph.children);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, OMIT_NODE_MICRO_LAYOUT_3))) || $execute((builder0 = new NodeMicroLayout(($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(layoutGraph))), builder0));
    stackable = false;
    if (tryBox && rectangles.size_0 >= 3) {
        region2 = castTo($get_20(rectangles, 0), 27);
        region3 = castTo($get_20(rectangles, 1), 27);
        counter = 0;
        while(counter + 2 < rectangles.size_0){
            region1 = region2;
            region2 = region3;
            region3 = castTo($get_20(rectangles, counter + 2), 27);
            if (region1.height >= region2.height + region3.height + nodeNodeSpacing || region3.height >= region1.height + region2.height + nodeNodeSpacing) {
                stackable = true;
                break;
            } else ++counter;
        }
    } else stackable = true;
    if (!stackable) {
        priority = rectangles.size_0;
        for(elkNode$iterator = new AbstractEList$EIterator(rectangles); elkNode$iterator.cursor != elkNode$iterator.this$01_2.size_1();){
            elkNode = castTo($doNext(elkNode$iterator), 27);
            $setProperty_1(elkNode, ($clinit_CoreOptions(), PRIORITY_3), valueOf_3(priority));
            --priority;
        }
        $layout_4(layoutGraph, new BasicProgressMonitor);
        progressMonitor.done_1();
        return;
    }
    algorithm = ($reset_4(this.algorithmAssembler), $setPhase(this.algorithmAssembler, ($clinit_RectPackingLayoutPhases(), P1_WIDTH_APPROXIMATION), castTo($getProperty_0(layoutGraph, WIDTH_APPROXIMATION_STRATEGY_0), 188)), $setPhase(this.algorithmAssembler, P2_PACKING, castTo($getProperty_0(layoutGraph, PACKING_STRATEGY_0), 188)), $setPhase(this.algorithmAssembler, P3_WHITESPACE_ELIMINATION, castTo($getProperty_0(layoutGraph, WHITE_SPACE_ELIMINATION_STRATEGY_0), 188)), $addProcessorConfiguration(this.algorithmAssembler, (configuration = new LayoutProcessorConfiguration, $addBefore(configuration, P1_WIDTH_APPROXIMATION, ($clinit_IntermediateProcessorStrategy_2(), MIN_SIZE_PRE_PROCESSOR)), $addBefore(configuration, P2_PACKING, MIN_SIZE_POST_PROCESSOR), $booleanValue(castToBoolean($getProperty_0(layoutGraph, ORDER_BY_SIZE_0))) && $addBefore(configuration, P1_WIDTH_APPROXIMATION, NODE_SIZE_REORDERER), $booleanValue(castToBoolean($getProperty_0(layoutGraph, INTERACTIVE_6))) && $addBefore(configuration, P1_WIDTH_APPROXIMATION, INTERACTIVE_NODE_REORDERER), configuration)), $build_0(this.algorithmAssembler, layoutGraph));
    monitorProgress = 1 / algorithm.array.length;
    slotIndex = 0;
    for(processor$iterator = new ArrayList$1(algorithm); processor$iterator.i < processor$iterator.this$01.array.length;){
        processor = castTo($next_6(processor$iterator), 44);
        if (progressMonitor.isCanceled()) return;
        processor.process(layoutGraph, progressMonitor.subTask(monitorProgress));
        ++slotIndex;
    }
    realWidth = 0;
    realHeight = 0;
    for(rect$iterator = new AbstractEList$EIterator(rectangles); rect$iterator.cursor != rect$iterator.this$01_2.size_1();){
        rect = castTo($doNext(rect$iterator), 27);
        realWidth = $wnd.Math.max(realWidth, rect.x_0 + rect.width_0);
        realHeight = $wnd.Math.max(realHeight, rect.y_0 + rect.height);
    }
    translate_1(layoutGraph, new KVector_1($doubleValue(castToDouble($getProperty_0(layoutGraph, ($clinit_InternalProperties_4(), DRAWING_WIDTH)))), $doubleValue(castToDouble($getProperty_0(layoutGraph, DRAWING_HEIGHT)))), new KVector_1(realWidth, realHeight));
    applyPadding(rectangles, padding);
    fixedGraphSize || resizeNode_1(layoutGraph, $doubleValue(castToDouble($getProperty_0(layoutGraph, DRAWING_WIDTH))) + (padding.left + padding.right), $doubleValue(castToDouble($getProperty_0(layoutGraph, DRAWING_HEIGHT))) + (padding.top_0 + padding.bottom), false, true);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, OMIT_NODE_MICRO_LAYOUT_3))) || $execute((builder = new NodeMicroLayout(($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(layoutGraph))), builder));
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_rectpacking_RectPackingLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking', 'RectPackingLayoutProvider', 1082);
function $process_105(graph, progressMonitor) {
    var elkNode, elkNode$iterator, elkNode$iterator0, elkNode$iterator1, elkNode$iterator2, fixedNodes, index_0, position, rectangles;
    progressMonitor.begin('Interactive Node Reorderer', 1);
    rectangles = (!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children);
    fixedNodes = new ArrayList;
    for(elkNode$iterator0 = new AbstractEList$EIterator(rectangles); elkNode$iterator0.cursor != elkNode$iterator0.this$01_2.size_1();){
        elkNode = castTo($doNext(elkNode$iterator0), 27);
        $hasProperty_0(elkNode, ($clinit_RectPackingOptions(), DESIRED_POSITION_0)) && push_1(fixedNodes.array, elkNode);
    }
    for(elkNode$iterator1 = new ArrayList$1(fixedNodes); elkNode$iterator1.i < elkNode$iterator1.this$01.array.length;){
        elkNode = castTo($next_6(elkNode$iterator1), 27);
        $remove_32(rectangles, elkNode);
    }
    $clinit_Collections();
    $sort(fixedNodes, new InteractiveNodeReorderer$lambda$0$Type);
    for(elkNode$iterator2 = new ArrayList$1(fixedNodes); elkNode$iterator2.i < elkNode$iterator2.this$01.array.length;){
        elkNode = castTo($next_6(elkNode$iterator2), 27);
        position = castTo($getProperty_0(elkNode, ($clinit_RectPackingOptions(), DESIRED_POSITION_0)), 17).value_0;
        position = $wnd.Math.min(position, rectangles.size_0);
        $add_20(rectangles, position, elkNode);
    }
    index_0 = 0;
    for(elkNode$iterator = new AbstractEList$EIterator(rectangles); elkNode$iterator.cursor != elkNode$iterator.this$01_2.size_1();){
        elkNode = castTo($doNext(elkNode$iterator), 27);
        $setProperty_1(elkNode, ($clinit_RectPackingOptions(), CURRENT_POSITION_0), valueOf_3(index_0));
        ++index_0;
    }
    progressMonitor.done_1();
}
function InteractiveNodeReorderer() {}
function lambda$0_36(a_0, b_1) {
    var positionA, positionB;
    positionA = castTo($getProperty_0(a_0, ($clinit_RectPackingOptions(), DESIRED_POSITION_0)), 17).value_0;
    positionB = castTo($getProperty_0(b_1, DESIRED_POSITION_0), 17).value_0;
    return positionA == positionB ? -1 : positionA < positionB ? -1 : positionA > positionB ? 1 : 0;
}
defineClass(1458, 1, $intern_102, InteractiveNodeReorderer);
_.process = function process_101(graph, progressMonitor) {
    $process_105(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_intermediate_InteractiveNodeReorderer_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.intermediate', 'InteractiveNodeReorderer', 1458);
function InteractiveNodeReorderer$lambda$0$Type() {}
defineClass(1459, 1, $intern_88, InteractiveNodeReorderer$lambda$0$Type);
_.compare_1 = function compare_101(arg0, arg1) {
    return lambda$0_36(castTo(arg0, 27), castTo(arg1, 27));
};
_.equals_0 = function equals_188(other) {
    return this === other;
};
_.reversed = function reversed_93() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_rectpacking_intermediate_InteractiveNodeReorderer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.intermediate', 'InteractiveNodeReorderer/lambda$0$Type', 1459);
function $clinit_IntermediateProcessorStrategy_2() {
    $clinit_IntermediateProcessorStrategy_2 = emptyMethod;
    NODE_SIZE_REORDERER = new IntermediateProcessorStrategy_2('NODE_SIZE_REORDERER', 0);
    INTERACTIVE_NODE_REORDERER = new IntermediateProcessorStrategy_2('INTERACTIVE_NODE_REORDERER', 1);
    MIN_SIZE_PRE_PROCESSOR = new IntermediateProcessorStrategy_2('MIN_SIZE_PRE_PROCESSOR', 2);
    MIN_SIZE_POST_PROCESSOR = new IntermediateProcessorStrategy_2('MIN_SIZE_POST_PROCESSOR', 3);
}
function IntermediateProcessorStrategy_2(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_78(name_0) {
    $clinit_IntermediateProcessorStrategy_2();
    return valueOf(($clinit_IntermediateProcessorStrategy$Map_2(), $MAP_68), name_0);
}
function values_86() {
    $clinit_IntermediateProcessorStrategy_2();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_intermediate_IntermediateProcessorStrategy_2_classLit, 1), $intern_36, 398, 0, [
        NODE_SIZE_REORDERER,
        INTERACTIVE_NODE_REORDERER,
        MIN_SIZE_PRE_PROCESSOR,
        MIN_SIZE_POST_PROCESSOR
    ]);
}
defineClass(398, 23, {
    3: 1,
    34: 1,
    23: 1,
    398: 1,
    196: 1
}, IntermediateProcessorStrategy_2);
_.create_1 = function create_25() {
    switch(this.ordinal){
        case 0:
            return new NodeSizeReorderer;
        case 1:
            return new InteractiveNodeReorderer;
        case 2:
            return new MinSizePreProcessor;
        case 3:
            return new MinSizePostProcessor;
    }
    return null;
};
var INTERACTIVE_NODE_REORDERER, MIN_SIZE_POST_PROCESSOR, MIN_SIZE_PRE_PROCESSOR, NODE_SIZE_REORDERER;
var Lorg_eclipse_elk_alg_rectpacking_intermediate_IntermediateProcessorStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking.intermediate', 'IntermediateProcessorStrategy', 398, Ljava_lang_Enum_2_classLit, values_86, valueOf_78);
function $clinit_IntermediateProcessorStrategy$Map_2() {
    $clinit_IntermediateProcessorStrategy$Map_2 = emptyMethod;
    $MAP_68 = createValueOfMap(($clinit_IntermediateProcessorStrategy_2(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_intermediate_IntermediateProcessorStrategy_2_classLit, 1), $intern_36, 398, 0, [
        NODE_SIZE_REORDERER,
        INTERACTIVE_NODE_REORDERER,
        MIN_SIZE_PRE_PROCESSOR,
        MIN_SIZE_POST_PROCESSOR
    ])));
}
var $MAP_68;
function $process_106(graph, progressMonitor) {
    progressMonitor.begin('Min Size Postprocessing', 1);
    $setProperty_1(graph, ($clinit_InternalProperties_4(), TARGET_WIDTH), $wnd.Math.max($doubleValue(castToDouble($getProperty_0(graph, TARGET_WIDTH))), $doubleValue(castToDouble($getProperty_0(graph, MIN_WIDTH_0)))));
    progressMonitor.done_1();
}
function MinSizePostProcessor() {}
defineClass(1461, 1, $intern_102, MinSizePostProcessor);
_.process = function process_102(graph, progressMonitor) {
    $process_106(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_intermediate_MinSizePostProcessor_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.intermediate', 'MinSizePostProcessor', 1461);
function $process_107(graph, progressMonitor) {
    var minSize;
    progressMonitor.begin('Min Size Preprocessing', 1);
    minSize = effectiveMinSizeConstraintFor(graph);
    $setProperty_1(graph, ($clinit_InternalProperties_4(), MIN_WIDTH_0), minSize.x_0);
    $setProperty_1(graph, MIN_HEIGHT, minSize.y_0);
    progressMonitor.done_1();
}
function MinSizePreProcessor() {}
defineClass(1460, 1, $intern_102, MinSizePreProcessor);
_.process = function process_103(graph, progressMonitor) {
    $process_107(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_intermediate_MinSizePreProcessor_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.intermediate', 'MinSizePreProcessor', 1460);
function $compare_20(node0, node1) {
    return compare_4(node1.height, node0.height);
}
function NodeSizeComparator() {}
defineClass(1647, 1, $intern_88, NodeSizeComparator);
_.compare_1 = function compare_102(node0, node1) {
    return $compare_20(castTo(node0, 27), castTo(node1, 27));
};
_.equals_0 = function equals_189(other) {
    return this === other;
};
_.reversed = function reversed_94() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_alg_rectpacking_intermediate_NodeSizeComparator_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.intermediate', 'NodeSizeComparator', 1647);
function $process_108(graph) {
    sort_14((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children), new NodeSizeComparator);
}
function NodeSizeReorderer() {}
defineClass(1457, 1, $intern_102, NodeSizeReorderer);
_.process = function process_104(graph, progressMonitor) {
    $process_108(castTo(graph, 27));
};
var Lorg_eclipse_elk_alg_rectpacking_intermediate_NodeSizeReorderer_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.intermediate', 'NodeSizeReorderer', 1457);
function $clinit_InternalProperties_4() {
    $clinit_InternalProperties_4 = emptyMethod;
    ADDITIONAL_HEIGHT = new Property('additionalHeight');
    DRAWING_HEIGHT = new Property('drawingHeight');
    DRAWING_WIDTH = new Property('drawingWidth');
    MIN_HEIGHT = new Property('minHeight');
    MIN_WIDTH_0 = new Property('minWidth');
    ROWS_0 = new Property('rows');
    TARGET_WIDTH = new Property('targetWidth');
    MIN_ROW_INCREASE = new Property_0('minRowIncrease', 0);
    MAX_ROW_INCREASE = new Property_0('maxRowIncrease', 0);
    MIN_ROW_DECREASE = new Property_0('minRowDecrease', 0);
    MAX_ROW_DECREASE = new Property_0('maxRowDecrease', 0);
}
var ADDITIONAL_HEIGHT, DRAWING_HEIGHT, DRAWING_WIDTH, MAX_ROW_DECREASE, MAX_ROW_INCREASE, MIN_HEIGHT, MIN_ROW_DECREASE, MIN_ROW_INCREASE, MIN_WIDTH_0, ROWS_0, TARGET_WIDTH;
function $clinit_OptimizationGoal() {
    $clinit_OptimizationGoal = emptyMethod;
    ASPECT_RATIO_DRIVEN = new OptimizationGoal('ASPECT_RATIO_DRIVEN', 0);
    MAX_SCALE_DRIVEN = new OptimizationGoal('MAX_SCALE_DRIVEN', 1);
    AREA_DRIVEN = new OptimizationGoal('AREA_DRIVEN', 2);
}
function OptimizationGoal(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_79(name_0) {
    $clinit_OptimizationGoal();
    return valueOf(($clinit_OptimizationGoal$Map(), $MAP_69), name_0);
}
function values_87() {
    $clinit_OptimizationGoal();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_options_OptimizationGoal_2_classLit, 1), $intern_36, 385, 0, [
        ASPECT_RATIO_DRIVEN,
        MAX_SCALE_DRIVEN,
        AREA_DRIVEN
    ]);
}
defineClass(385, 23, {
    3: 1,
    34: 1,
    23: 1,
    385: 1
}, OptimizationGoal);
var AREA_DRIVEN, ASPECT_RATIO_DRIVEN, MAX_SCALE_DRIVEN;
var Lorg_eclipse_elk_alg_rectpacking_options_OptimizationGoal_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking.options', 'OptimizationGoal', 385, Ljava_lang_Enum_2_classLit, values_87, valueOf_79);
function $clinit_OptimizationGoal$Map() {
    $clinit_OptimizationGoal$Map = emptyMethod;
    $MAP_69 = createValueOfMap(($clinit_OptimizationGoal(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_options_OptimizationGoal_2_classLit, 1), $intern_36, 385, 0, [
        ASPECT_RATIO_DRIVEN,
        MAX_SCALE_DRIVEN,
        AREA_DRIVEN
    ])));
}
var $MAP_69;
function $clinit_RectPackingMetaDataProvider() {
    $clinit_RectPackingMetaDataProvider = emptyMethod;
    TRYBOX = new Property_1('org.eclipse.elk.rectpacking.trybox', ($clinit_Boolean(), false));
    valueOf_3(-1);
    CURRENT_POSITION = new Property_1('org.eclipse.elk.rectpacking.currentPosition', valueOf_3(-1));
    valueOf_3(-1);
    DESIRED_POSITION = new Property_1('org.eclipse.elk.rectpacking.desiredPosition', valueOf_3(-1));
    IN_NEW_ROW = new Property_1('org.eclipse.elk.rectpacking.inNewRow', false);
    ORDER_BY_SIZE = new Property_1('org.eclipse.elk.rectpacking.orderBySize', false);
    WIDTH_APPROXIMATION_STRATEGY_DEFAULT = ($clinit_WidthApproximationStrategy(), GREEDY_1);
    WIDTH_APPROXIMATION_STRATEGY = new Property_1('org.eclipse.elk.rectpacking.widthApproximation.strategy', WIDTH_APPROXIMATION_STRATEGY_DEFAULT);
    WIDTH_APPROXIMATION_TARGET_WIDTH = new Property_1('org.eclipse.elk.rectpacking.widthApproximation.targetWidth', -1);
    WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_DEFAULT = ($clinit_OptimizationGoal(), MAX_SCALE_DRIVEN);
    WIDTH_APPROXIMATION_OPTIMIZATION_GOAL = new Property_1('org.eclipse.elk.rectpacking.widthApproximation.optimizationGoal', WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_DEFAULT);
    WIDTH_APPROXIMATION_LAST_PLACE_SHIFT = new Property_1('org.eclipse.elk.rectpacking.widthApproximation.lastPlaceShift', true);
    PACKING_STRATEGY_DEFAULT = ($clinit_PackingStrategy(), COMPACTION_2);
    PACKING_STRATEGY = new Property_1('org.eclipse.elk.rectpacking.packing.strategy', PACKING_STRATEGY_DEFAULT);
    PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION = new Property_1('org.eclipse.elk.rectpacking.packing.compaction.rowHeightReevaluation', false);
    valueOf_3(1);
    PACKING_COMPACTION_ITERATIONS = new Property_1('org.eclipse.elk.rectpacking.packing.compaction.iterations', valueOf_3(1));
    WHITE_SPACE_ELIMINATION_STRATEGY_DEFAULT = ($clinit_WhiteSpaceEliminationStrategy(), NONE_17);
    WHITE_SPACE_ELIMINATION_STRATEGY = new Property_1('org.eclipse.elk.rectpacking.whiteSpaceElimination.strategy', WHITE_SPACE_ELIMINATION_STRATEGY_DEFAULT);
}
function RectPackingMetaDataProvider() {
    $clinit_RectPackingMetaDataProvider();
}
defineClass(844, 1, $intern_98, RectPackingMetaDataProvider);
_.apply_4 = function apply_145(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.trybox'), ''), 'Try box layout first'), 'Whether one should check whether the regions are stackable to see whether box layout would do the job. For example, nodes with the same height are not stackable inside a row. Therefore, box layout will perform better and faster.'), ($clinit_Boolean(), false)), ($clinit_LayoutOptionData$Type(), BOOLEAN)), Ljava_lang_Boolean_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.currentPosition'), ''), 'Current position of a node in the order of nodes'), 'The rectangles are ordered. Normally according to their definition the the model. This option specifies the current position of a node.'), valueOf_3(-1)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.desiredPosition'), ''), 'Desired index of node'), 'The rectangles are ordered. Normally according to their definition the the model. This option allows to specify a desired position that has preference over the original position.'), valueOf_3(-1)), INT), Ljava_lang_Integer_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.inNewRow'), ''), 'In new Row'), 'If set to true this node begins in a new row. Consequently this node cannot be moved in a previous layer during compaction. Width approximation does does not take this into account.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.orderBySize'), ''), 'Order nodes by height'), 'If set to true the nodes will be sorted by their height before computing the layout. The highest node will be in the first position.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.widthApproximation.strategy'), 'widthApproximation'), 'Width Approximation Strategy'), 'Strategy for finding an initial width of the drawing.'), WIDTH_APPROXIMATION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_WidthApproximationStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.widthApproximation.targetWidth'), 'widthApproximation'), 'Target Width'), 'Option to place the rectangles in the given target width instead of approximating the width using the desired aspect ratio. The padding is not included in this. Meaning a drawing will have width of targetwidth + horizontal padding.'), -1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.widthApproximation.optimizationGoal'), 'widthApproximation'), 'Optimization Goal'), 'Optimization goal for approximation of the bounding box given by the first iteration. Determines whether layout is sorted by the maximum scaling, aspect ratio, or area. Depending on the strategy the aspect ratio might be nearly ignored.'), WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_DEFAULT), ENUM), Lorg_eclipse_elk_alg_rectpacking_options_OptimizationGoal_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.widthApproximation.lastPlaceShift'), 'widthApproximation'), 'Shift Last Placed.'), 'When placing a rectangle behind or below the last placed rectangle in the first iteration, it is sometimes possible to shift the rectangle further to the left or right, resulting in less whitespace. True (default) enables the shift and false disables it. Disabling the shift produces a greater approximated area by the first iteration and a layout, when using ONLY the first iteration (default not the case), where it is sometimes impossible to implement a size transformation of rectangles that will fill the bounding box and eliminate empty spaces.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.packing.strategy'), 'packing'), 'Compaction Strategy'), 'Strategy for finding an initial placement on nodes.'), PACKING_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_rectpacking_p2packing_PackingStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.packing.compaction.rowHeightReevaluation'), 'packing.compaction'), 'Row Height Reevaluation'), 'During the compaction step the height of a row is normally not changed. If this options is set, the blocks of other rows might be added if they exceed the row height. If this is the case the whole row has to be packed again to be optimal regarding the new row height. This option should, therefore, be used with care since it might be computation heavy.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.packing.compaction.iterations'), 'packing.compaction'), 'Compaction iterations'), 'Defines the number of compaction iterations. E.g. if set to 2 the width is initially approximated, then the drawing is compacted and based on the resulting drawing the target width is decreased or increased and a second compaction step is executed and the result compared to the first one. The best run is used based on the scale measure.'), valueOf_3(1)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.rectpacking.whiteSpaceElimination.strategy'), 'whiteSpaceElimination'), 'White Space Approximation Strategy'), 'Strategy for expanding nodes such that whitespace in the parent is eliminated.'), WHITE_SPACE_ELIMINATION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_rectpacking_p3whitespaceelimination_WhiteSpaceEliminationStrategy_2_classLit), of_1(PARENTS))));
    $apply_12((new RectPackingOptions, registry));
};
var CURRENT_POSITION, DESIRED_POSITION, IN_NEW_ROW, ORDER_BY_SIZE, PACKING_COMPACTION_ITERATIONS, PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION, PACKING_STRATEGY, PACKING_STRATEGY_DEFAULT, TRYBOX, WHITE_SPACE_ELIMINATION_STRATEGY, WHITE_SPACE_ELIMINATION_STRATEGY_DEFAULT, WIDTH_APPROXIMATION_LAST_PLACE_SHIFT, WIDTH_APPROXIMATION_OPTIMIZATION_GOAL, WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_DEFAULT, WIDTH_APPROXIMATION_STRATEGY, WIDTH_APPROXIMATION_STRATEGY_DEFAULT, WIDTH_APPROXIMATION_TARGET_WIDTH;
var Lorg_eclipse_elk_alg_rectpacking_options_RectPackingMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.options', 'RectPackingMetaDataProvider', 844);
function $clinit_RectPackingOptions() {
    $clinit_RectPackingOptions = emptyMethod;
    ASPECT_RATIO_2 = new Property_2(($clinit_CoreOptions(), ASPECT_RATIO_4), 1.3);
    NODE_SIZE_FIXED_GRAPH_SIZE_2 = new Property_2(NODE_SIZE_FIXED_GRAPH_SIZE_3, ($clinit_Boolean(), false));
    PADDING_DEFAULT_2 = new ElkPadding_0(15);
    PADDING_2 = new Property_2(PADDING_5, PADDING_DEFAULT_2);
    SPACING_NODE_NODE_3 = new Property_2(SPACING_NODE_NODE_6, 15);
    CONTENT_ALIGNMENT_0 = CONTENT_ALIGNMENT_2;
    NODE_SIZE_CONSTRAINTS_4 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_MINIMUM_3 = NODE_SIZE_MINIMUM_5;
    NODE_SIZE_OPTIONS_4 = NODE_SIZE_OPTIONS_6;
    NODE_LABELS_PLACEMENT_4 = NODE_LABELS_PLACEMENT_5;
    OMIT_NODE_MICRO_LAYOUT_3 = OMIT_NODE_MICRO_LAYOUT_4;
    PORT_LABELS_PLACEMENT_4 = PORT_LABELS_PLACEMENT_5;
    WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_0 = ($clinit_RectPackingMetaDataProvider(), WIDTH_APPROXIMATION_OPTIMIZATION_GOAL);
    WIDTH_APPROXIMATION_LAST_PLACE_SHIFT_0 = WIDTH_APPROXIMATION_LAST_PLACE_SHIFT;
    WIDTH_APPROXIMATION_TARGET_WIDTH_0 = WIDTH_APPROXIMATION_TARGET_WIDTH;
    WIDTH_APPROXIMATION_STRATEGY_0 = WIDTH_APPROXIMATION_STRATEGY;
    PACKING_STRATEGY_0 = PACKING_STRATEGY;
    PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION_0 = PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION;
    PACKING_COMPACTION_ITERATIONS_0 = PACKING_COMPACTION_ITERATIONS;
    WHITE_SPACE_ELIMINATION_STRATEGY_0 = WHITE_SPACE_ELIMINATION_STRATEGY;
    INTERACTIVE_6 = INTERACTIVE_8;
    INTERACTIVE_LAYOUT_1 = INTERACTIVE_LAYOUT_2;
    DESIRED_POSITION_0 = DESIRED_POSITION;
    CURRENT_POSITION_0 = CURRENT_POSITION;
    IN_NEW_ROW_0 = IN_NEW_ROW;
    TRYBOX_0 = TRYBOX;
    ORDER_BY_SIZE_0 = ORDER_BY_SIZE;
}
function $apply_12(registry) {
    $register(registry, new LayoutAlgorithmData($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.rectpacking'), 'ELK Rectangle Packing'), 'Algorithm for packing of unconnected boxes, i.e. graphs without edges. The given order of the boxes is always preserved and the main reading direction of the boxes is left to right. The algorithm is divided into two phases. One phase approximates the width in which the rectangles can be placed. The next phase places the rectangles in rows using the previously calculated width as bounding width and bundles rectangles with a similar height in blocks. A compaction step reduces the size of the drawing. Finally, the rectangles are expanded to fill their bounding box and eliminate empty unused spaces.'), new RectPackingOptions$RectpackingFactory)));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.aspectRatio', 1.3);
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.nodeSize.fixedGraphSize', ($clinit_Boolean(), false));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.padding', PADDING_DEFAULT_2);
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.spacing.nodeNode', 15);
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.contentAlignment', $getDefault(CONTENT_ALIGNMENT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_4));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM_3));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS_4));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.nodeLabels.placement', $getDefault(NODE_LABELS_PLACEMENT_4));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.omitNodeMicroLayout', $getDefault(OMIT_NODE_MICRO_LAYOUT_3));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.portLabels.placement', $getDefault(PORT_LABELS_PLACEMENT_4));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.widthApproximation.optimizationGoal', $getDefault(WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.widthApproximation.lastPlaceShift', $getDefault(WIDTH_APPROXIMATION_LAST_PLACE_SHIFT_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.widthApproximation.targetWidth', $getDefault(WIDTH_APPROXIMATION_TARGET_WIDTH_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.widthApproximation.strategy', $getDefault(WIDTH_APPROXIMATION_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.packing.strategy', $getDefault(PACKING_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.packing.compaction.rowHeightReevaluation', $getDefault(PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.packing.compaction.iterations', $getDefault(PACKING_COMPACTION_ITERATIONS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.whiteSpaceElimination.strategy', $getDefault(WHITE_SPACE_ELIMINATION_STRATEGY_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.interactive', $getDefault(INTERACTIVE_6));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.interactiveLayout', $getDefault(INTERACTIVE_LAYOUT_1));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.desiredPosition', $getDefault(DESIRED_POSITION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.currentPosition', $getDefault(CURRENT_POSITION_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.inNewRow', $getDefault(IN_NEW_ROW_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.trybox', $getDefault(TRYBOX_0));
    $addOptionSupport(registry, 'org.eclipse.elk.rectpacking', 'org.eclipse.elk.rectpacking.orderBySize', $getDefault(ORDER_BY_SIZE_0));
}
function RectPackingOptions() {
    $clinit_RectPackingOptions();
}
defineClass(991, 1, $intern_98, RectPackingOptions);
_.apply_4 = function apply_146(registry) {
    $apply_12(registry);
};
var ASPECT_RATIO_2, CONTENT_ALIGNMENT_0, CURRENT_POSITION_0, DESIRED_POSITION_0, INTERACTIVE_6, INTERACTIVE_LAYOUT_1, IN_NEW_ROW_0, NODE_LABELS_PLACEMENT_4, NODE_SIZE_CONSTRAINTS_4, NODE_SIZE_FIXED_GRAPH_SIZE_2, NODE_SIZE_MINIMUM_3, NODE_SIZE_OPTIONS_4, OMIT_NODE_MICRO_LAYOUT_3, ORDER_BY_SIZE_0, PACKING_COMPACTION_ITERATIONS_0, PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION_0, PACKING_STRATEGY_0, PADDING_2, PADDING_DEFAULT_2, PORT_LABELS_PLACEMENT_4, SPACING_NODE_NODE_3, TRYBOX_0, WHITE_SPACE_ELIMINATION_STRATEGY_0, WIDTH_APPROXIMATION_LAST_PLACE_SHIFT_0, WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_0, WIDTH_APPROXIMATION_STRATEGY_0, WIDTH_APPROXIMATION_TARGET_WIDTH_0;
var Lorg_eclipse_elk_alg_rectpacking_options_RectPackingOptions_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.options', 'RectPackingOptions', 991);
function RectPackingOptions$RectpackingFactory() {}
defineClass(992, 1, {}, RectPackingOptions$RectpackingFactory);
_.create_0 = function create_26() {
    var provider;
    return provider = new RectPackingLayoutProvider, provider;
};
_.destroy = function destroy_4(obj) {};
var Lorg_eclipse_elk_alg_rectpacking_options_RectPackingOptions$RectpackingFactory_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.options', 'RectPackingOptions/RectpackingFactory', 992);
function $approxBoundingBox(this$static, rectangles, nodeNodeSpacing, padding) {
    var bestOpt, currentValues, firstRect, lastPlaced, opt1, opt2, opt3, opt4, placedRects, rectangleIdx, toPlace;
    firstRect = castTo($get_20(rectangles, 0), 27);
    $setX_1(firstRect, 0);
    $setY_2(firstRect, 0);
    placedRects = new ArrayList;
    push_1(placedRects.array, firstRect);
    lastPlaced = firstRect;
    currentValues = new DrawingData(this$static.aspectRatio, firstRect.width_0, firstRect.height, ($clinit_DrawingDataDescriptor(), WHOLE_DRAWING));
    for(rectangleIdx = 1; rectangleIdx < rectangles.size_0; rectangleIdx++){
        toPlace = castTo($get_20(rectangles, rectangleIdx), 27);
        opt1 = $calcValuesForOpt(this$static, CANDIDATE_POSITION_LAST_PLACED_RIGHT, toPlace, lastPlaced, currentValues, placedRects, nodeNodeSpacing);
        opt2 = $calcValuesForOpt(this$static, CANDIDATE_POSITION_LAST_PLACED_BELOW, toPlace, lastPlaced, currentValues, placedRects, nodeNodeSpacing);
        opt3 = $calcValuesForOpt(this$static, CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT, toPlace, lastPlaced, currentValues, placedRects, nodeNodeSpacing);
        opt4 = $calcValuesForOpt(this$static, CANDIDATE_POSITION_WHOLE_DRAWING_BELOW, toPlace, lastPlaced, currentValues, placedRects, nodeNodeSpacing);
        bestOpt = $findBestCandidate(this$static, opt1, opt2, opt3, opt4, toPlace, lastPlaced, padding);
        $setX_1(toPlace, bestOpt.nextXcoordinate);
        $setY_2(toPlace, bestOpt.nextYcoordinate);
        $setPlacementOption(bestOpt, WHOLE_DRAWING);
        currentValues = bestOpt;
        lastPlaced = toPlace;
        push_1(placedRects.array, toPlace);
    }
    return currentValues;
}
function $calcValuesForOpt(this$static, option, toPlace, lastPlaced, drawing, placedRects, nodeNodeSpacing) {
    var drawingHeight, drawingWidth, height, heightToPlace, newDrawing, width_0, widthToPlace, x_0, y_0;
    x_0 = 0;
    y_0 = 0;
    drawingWidth = drawing.drawingWidth;
    drawingHeight = drawing.drawingHeight;
    heightToPlace = toPlace.height;
    widthToPlace = toPlace.width_0;
    switch(option.ordinal){
        case 0:
            x_0 = lastPlaced.x_0 + lastPlaced.width_0 + nodeNodeSpacing;
            this$static.lpShift ? y_0 = calculateYforLPR(x_0, placedRects, lastPlaced, nodeNodeSpacing) : y_0 = lastPlaced.y_0;
            width_0 = $wnd.Math.max(drawingWidth, x_0 + widthToPlace);
            height = $wnd.Math.max(drawingHeight, y_0 + heightToPlace);
            break;
        case 1:
            y_0 = lastPlaced.y_0 + lastPlaced.height + nodeNodeSpacing;
            this$static.lpShift ? x_0 = calculateXforLPB(y_0, placedRects, lastPlaced, nodeNodeSpacing) : x_0 = lastPlaced.x_0;
            width_0 = $wnd.Math.max(drawingWidth, x_0 + widthToPlace);
            height = $wnd.Math.max(drawingHeight, y_0 + heightToPlace);
            break;
        case 2:
            x_0 = drawingWidth + nodeNodeSpacing;
            y_0 = 0;
            width_0 = drawingWidth + nodeNodeSpacing + widthToPlace;
            height = $wnd.Math.max(drawingHeight, heightToPlace);
            break;
        case 3:
            x_0 = 0;
            y_0 = drawingHeight + nodeNodeSpacing;
            width_0 = $wnd.Math.max(drawingWidth, widthToPlace);
            height = drawingHeight + nodeNodeSpacing + heightToPlace;
            break;
        default:
            throw toJs(new IllegalArgumentException_0('IllegalPlacementOption.'));
    }
    newDrawing = new DrawingData_0(this$static.aspectRatio, width_0, height, option, x_0, y_0);
    return newDrawing;
}
function $checkSpecialCases(drawing1, drawing2, lastPlaced, toPlace) {
    var areaLPB, areaLPR, firstOpt, firstOptLPBorCDB, firstOptLPRorCDR, firstOptLPRorLPB, lpbOpt, lprOpt, secondOpt, secondOptLPBorCDB, secondOptLPRorCDR, secondOptLPRorLPB, lastPlacedBottomBorder, toPlaceBottomBorder, maxYLPR, heightLPR, widthLPR, lastPlacedRightBorder, toPlaceRightBorder, maxXLPB, widthLPB, heightLPB;
    firstOpt = drawing1.placementOption;
    secondOpt = drawing2.placementOption;
    firstOptLPBorCDB = firstOpt == ($clinit_DrawingDataDescriptor(), CANDIDATE_POSITION_LAST_PLACED_BELOW) || firstOpt == CANDIDATE_POSITION_WHOLE_DRAWING_BELOW;
    secondOptLPBorCDB = secondOpt == CANDIDATE_POSITION_LAST_PLACED_BELOW || secondOpt == CANDIDATE_POSITION_WHOLE_DRAWING_BELOW;
    firstOptLPRorCDR = firstOpt == CANDIDATE_POSITION_LAST_PLACED_RIGHT || firstOpt == CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT;
    secondOptLPRorCDR = secondOpt == CANDIDATE_POSITION_LAST_PLACED_RIGHT || secondOpt == CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT;
    firstOptLPRorLPB = firstOpt == CANDIDATE_POSITION_LAST_PLACED_RIGHT || firstOpt == CANDIDATE_POSITION_LAST_PLACED_BELOW;
    secondOptLPRorLPB = secondOpt == CANDIDATE_POSITION_LAST_PLACED_RIGHT || secondOpt == CANDIDATE_POSITION_LAST_PLACED_BELOW;
    if (firstOptLPBorCDB && secondOptLPBorCDB) return drawing1.placementOption == CANDIDATE_POSITION_WHOLE_DRAWING_BELOW ? drawing1 : drawing2;
    else if (firstOptLPRorCDR && secondOptLPRorCDR) return drawing1.placementOption == CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT ? drawing1 : drawing2;
    else if (firstOptLPRorLPB && secondOptLPRorLPB) {
        if (firstOpt == CANDIDATE_POSITION_LAST_PLACED_RIGHT) {
            lprOpt = drawing1;
            lpbOpt = drawing2;
        } else {
            lprOpt = drawing2;
            lpbOpt = drawing1;
        }
        areaLPR = (lastPlacedBottomBorder = lastPlaced.y_0 + lastPlaced.height, toPlaceBottomBorder = lprOpt.nextYcoordinate + toPlace.height, maxYLPR = $wnd.Math.max(lastPlacedBottomBorder, toPlaceBottomBorder), heightLPR = maxYLPR - $wnd.Math.min(lastPlaced.y_0, lprOpt.nextYcoordinate), widthLPR = lprOpt.nextXcoordinate + toPlace.width_0 - lastPlaced.x_0, widthLPR * heightLPR);
        areaLPB = (lastPlacedRightBorder = lastPlaced.x_0 + lastPlaced.width_0, toPlaceRightBorder = lpbOpt.nextXcoordinate + toPlace.width_0, maxXLPB = $wnd.Math.max(lastPlacedRightBorder, toPlaceRightBorder), widthLPB = maxXLPB - $wnd.Math.min(lastPlaced.x_0, lpbOpt.nextXcoordinate), heightLPB = lpbOpt.nextYcoordinate + toPlace.height - lastPlaced.y_0, widthLPB * heightLPB);
        return areaLPR <= areaLPB ? drawing1.placementOption == CANDIDATE_POSITION_LAST_PLACED_RIGHT ? drawing1 : drawing2 : drawing1.placementOption == CANDIDATE_POSITION_LAST_PLACED_BELOW ? drawing1 : drawing2;
    }
    return drawing1;
}
function $findBestCandidate(this$static, opt1, opt2, opt3, opt4, toPlace, lastPlaced, padding) {
    var candidates, filter, filter$iterator, filters;
    candidates = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_util_DrawingData_2_classLit, 1), $intern_2, 237, 0, [
        opt1,
        opt2,
        opt3,
        opt4
    ]));
    filters = null;
    switch(this$static.goal.ordinal){
        case 1:
            filters = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_BestCandidateFilter_2_classLit, 1), $intern_2, 520, 0, [
                new ScaleMeasureFilter,
                new AreaFilter,
                new AspectRatioFilter
            ]));
            break;
        case 0:
            filters = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_BestCandidateFilter_2_classLit, 1), $intern_2, 520, 0, [
                new AspectRatioFilter,
                new AreaFilter,
                new ScaleMeasureFilter
            ]));
            break;
        case 2:
            filters = newArrayList_1(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_BestCandidateFilter_2_classLit, 1), $intern_2, 520, 0, [
                new AreaFilter,
                new ScaleMeasureFilter,
                new AspectRatioFilter
            ]));
    }
    for(filter$iterator = new ArrayList$1(filters); filter$iterator.i < filter$iterator.this$01.array.length;){
        filter = castTo($next_6(filter$iterator), 520);
        candidates.array.length > 1 && (candidates = filter.filterList(candidates, this$static.aspectRatio, padding));
    }
    if (candidates.array.length == 1) return castTo($get_11(candidates, candidates.array.length - 1), 237);
    if (candidates.array.length == 2) return $checkSpecialCases((checkCriticalElementIndex(0, candidates.array.length), castTo(candidates.array[0], 237)), (checkCriticalElementIndex(1, candidates.array.length), castTo(candidates.array[1], 237)), lastPlaced, toPlace);
    return null;
}
function AreaApproximation(aspectRatio, goal, lpShift) {
    this.aspectRatio = aspectRatio;
    this.goal = goal;
    this.lpShift = lpShift;
}
defineClass(1646, 1, {}, AreaApproximation);
_.aspectRatio = 0;
_.lpShift = false;
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_AreaApproximation_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'AreaApproximation', 1646);
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_BestCandidateFilter_2_classLit = createForInterface('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'BestCandidateFilter');
function AreaFilter() {}
defineClass(658, 1, {
    520: 1
}, AreaFilter);
_.filterList = function filterList(candidates, aspectRatio, padding) {
    var candidate, candidate$iterator, minArea, opt, opt$iterator, remainingCandidates;
    remainingCandidates = new ArrayList;
    minArea = $intern_60;
    for(opt$iterator = new ArrayList$1(candidates); opt$iterator.i < opt$iterator.this$01.array.length;){
        opt = castTo($next_6(opt$iterator), 237);
        minArea = $wnd.Math.min(minArea, (opt.drawingWidth + (padding.left + padding.right)) * (opt.drawingHeight + (padding.top_0 + padding.bottom)));
    }
    for(candidate$iterator = new ArrayList$1(candidates); candidate$iterator.i < candidate$iterator.this$01.array.length;){
        candidate = castTo($next_6(candidate$iterator), 237);
        (candidate.drawingWidth + (padding.left + padding.right)) * (candidate.drawingHeight + (padding.top_0 + padding.bottom)) == minArea && push_1(remainingCandidates.array, candidate);
    }
    return remainingCandidates;
};
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_AreaFilter_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'AreaFilter', 658);
function AspectRatioFilter() {}
defineClass(659, 1, {
    520: 1
}, AspectRatioFilter);
_.filterList = function filterList_0(candidates, aspectRatio, padding) {
    var candidate, candidate$iterator, opt, opt$iterator, remainingCandidates, smallestDeviation;
    remainingCandidates = new ArrayList;
    smallestDeviation = $intern_60;
    for(opt$iterator = new ArrayList$1(candidates); opt$iterator.i < opt$iterator.this$01.array.length;){
        opt = castTo($next_6(opt$iterator), 237);
        smallestDeviation = $wnd.Math.min(smallestDeviation, $wnd.Math.abs((opt.drawingWidth + (padding.left + padding.right)) / (opt.drawingHeight + (padding.top_0 + padding.bottom)) - aspectRatio));
    }
    for(candidate$iterator = new ArrayList$1(candidates); candidate$iterator.i < candidate$iterator.this$01.array.length;){
        candidate = castTo($next_6(candidate$iterator), 237);
        $wnd.Math.abs((candidate.drawingWidth + (padding.left + padding.right)) / (candidate.drawingHeight + (padding.top_0 + padding.bottom)) - aspectRatio) == smallestDeviation && push_1(remainingCandidates.array, candidate);
    }
    return remainingCandidates;
};
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_AspectRatioFilter_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'AspectRatioFilter', 659);
function calculateXforLPB(y_0, placedRects, lastPlaced, nodeNodeSpacing) {
    var closestLeftNeighbour, closestNeighborRightBorder, placedRect, placedRect$iterator, placedRectRightBorder;
    closestLeftNeighbour = null;
    closestNeighborRightBorder = 0;
    for(placedRect$iterator = new ArrayList$1(placedRects); placedRect$iterator.i < placedRect$iterator.this$01.array.length;){
        placedRect = castTo($next_6(placedRect$iterator), 27);
        placedRectRightBorder = placedRect.x_0 + placedRect.width_0;
        if (y_0 < placedRect.y_0 + placedRect.height + nodeNodeSpacing) {
            !closestLeftNeighbour ? closestLeftNeighbour = placedRect : lastPlaced.x_0 - placedRectRightBorder < lastPlaced.x_0 - closestNeighborRightBorder && (closestLeftNeighbour = placedRect);
            closestNeighborRightBorder = closestLeftNeighbour.x_0 + closestLeftNeighbour.width_0;
        }
    }
    return !closestLeftNeighbour ? 0 : closestNeighborRightBorder + nodeNodeSpacing;
}
function calculateYforLPR(x_0, placedRects, lastPlaced, nodeNodeSpacing) {
    var closestNeighborBottomBorder, closestUpperNeighbor, placedRect, placedRect$iterator, placedRectBottomBorder;
    closestUpperNeighbor = null;
    closestNeighborBottomBorder = 0;
    for(placedRect$iterator = new ArrayList$1(placedRects); placedRect$iterator.i < placedRect$iterator.this$01.array.length;){
        placedRect = castTo($next_6(placedRect$iterator), 27);
        placedRectBottomBorder = placedRect.y_0 + placedRect.height;
        if (x_0 < placedRect.x_0 + placedRect.width_0 + nodeNodeSpacing) {
            !closestUpperNeighbor ? closestUpperNeighbor = placedRect : lastPlaced.y_0 - placedRectBottomBorder < lastPlaced.y_0 - closestNeighborBottomBorder && (closestUpperNeighbor = placedRect);
            closestNeighborBottomBorder = closestUpperNeighbor.y_0 + closestUpperNeighbor.height;
        }
    }
    return !closestUpperNeighbor ? 0 : closestNeighborBottomBorder + nodeNodeSpacing;
}
function $process_109(graph, progressMonitor) {
    var aspectRatio, drawing, firstIt, goal, lastPlaceShift, nodeNodeSpacing, padding, rectangles;
    progressMonitor.begin('Greedy Width Approximator', 1);
    aspectRatio = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RectPackingOptions(), ASPECT_RATIO_2))));
    padding = castTo($getProperty_0(graph, PADDING_2), 107);
    goal = castTo($getProperty_0(graph, WIDTH_APPROXIMATION_OPTIMIZATION_GOAL_0), 385);
    lastPlaceShift = $booleanValue(castToBoolean($getProperty_0(graph, WIDTH_APPROXIMATION_LAST_PLACE_SHIFT_0)));
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty_0(graph, SPACING_NODE_NODE_3)));
    rectangles = (!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children);
    resetCoordinates(rectangles);
    firstIt = new AreaApproximation(aspectRatio, goal, lastPlaceShift);
    drawing = $approxBoundingBox(firstIt, rectangles, nodeNodeSpacing, padding);
    $setProperty_1(graph, ($clinit_InternalProperties_4(), TARGET_WIDTH), drawing.drawingWidth);
    progressMonitor.done_1();
}
function GreedyWidthApproximator() {}
defineClass(1408, 1, $intern_110, GreedyWidthApproximator);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_29(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_105(graph, progressMonitor) {
    $process_109(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_GreedyWidthApproximator_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'GreedyWidthApproximator', 1408);
function ScaleMeasureFilter() {}
defineClass(657, 1, {
    520: 1
}, ScaleMeasureFilter);
_.filterList = function filterList_1(candidates, aspectRatio, padding) {
    var candidate, candidate$iterator, maxScale, opt, opt$iterator, remainingCandidates;
    remainingCandidates = new ArrayList;
    maxScale = $intern_61;
    for(opt$iterator = new ArrayList$1(candidates); opt$iterator.i < opt$iterator.this$01.array.length;){
        opt = castTo($next_6(opt$iterator), 237);
        maxScale = $wnd.Math.max(maxScale, computeScaleMeasure(opt.drawingWidth + (padding.left + padding.right), opt.drawingHeight + (padding.top_0 + padding.bottom), opt.dar));
    }
    for(candidate$iterator = new ArrayList$1(candidates); candidate$iterator.i < candidate$iterator.this$01.array.length;){
        candidate = castTo($next_6(candidate$iterator), 237);
        computeScaleMeasure(candidate.drawingWidth + (padding.left + padding.right), candidate.drawingHeight + (padding.top_0 + padding.bottom), candidate.dar) == maxScale && push_1(remainingCandidates.array, candidate);
    }
    return remainingCandidates;
};
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_ScaleMeasureFilter_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'ScaleMeasureFilter', 657);
function $process_110(graph, progressMonitor) {
    progressMonitor.begin('Target Width Setter', 1);
    if ($hasProperty_0(graph, ($clinit_RectPackingOptions(), WIDTH_APPROXIMATION_TARGET_WIDTH_0))) $setProperty_1(graph, ($clinit_InternalProperties_4(), TARGET_WIDTH), castToDouble($getProperty_0(graph, WIDTH_APPROXIMATION_TARGET_WIDTH_0)));
    else throw toJs(new UnsupportedConfigurationException_0('A target width has to be set if the TargetWidthWidthApproximator should be used.'));
    progressMonitor.done_1();
}
function TargetWidthWidthApproximator() {}
defineClass(1409, 1, $intern_110, TargetWidthWidthApproximator);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_30(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_106(graph, progressMonitor) {
    $process_110(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_TargetWidthWidthApproximator_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'TargetWidthWidthApproximator', 1409);
function $clinit_WidthApproximationStrategy() {
    $clinit_WidthApproximationStrategy = emptyMethod;
    GREEDY_1 = new WidthApproximationStrategy('GREEDY', 0);
    TARGET_WIDTH_0 = new WidthApproximationStrategy('TARGET_WIDTH', 1);
}
function $create_14(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new GreedyWidthApproximator;
        case 1:
            return new TargetWidthWidthApproximator;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation is available for the width approximator ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function WidthApproximationStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_80(name_0) {
    $clinit_WidthApproximationStrategy();
    return valueOf(($clinit_WidthApproximationStrategy$Map(), $MAP_70), name_0);
}
function values_88() {
    $clinit_WidthApproximationStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_WidthApproximationStrategy_2_classLit, 1), $intern_36, 476, 0, [
        GREEDY_1,
        TARGET_WIDTH_0
    ]);
}
defineClass(476, 23, {
    3: 1,
    34: 1,
    23: 1,
    476: 1,
    188: 1,
    196: 1
}, WidthApproximationStrategy);
_.create_1 = function create_28() {
    return $create_14(this);
};
_.create_2 = function create_27() {
    return $create_14(this);
};
var GREEDY_1, TARGET_WIDTH_0;
var Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_WidthApproximationStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking.p1widthapproximation', 'WidthApproximationStrategy', 476, Ljava_lang_Enum_2_classLit, values_88, valueOf_80);
function $clinit_WidthApproximationStrategy$Map() {
    $clinit_WidthApproximationStrategy$Map = emptyMethod;
    $MAP_70 = createValueOfMap(($clinit_WidthApproximationStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p1widthapproximation_WidthApproximationStrategy_2_classLit, 1), $intern_36, 476, 0, [
        GREEDY_1,
        TARGET_WIDTH_0
    ])));
}
var $MAP_70;
function absorbBlocks(row, block, nextBlock, boundingWidth, nodeNodeSpacing) {
    var rect, somethingWasChanged;
    somethingWasChanged = false;
    rect = castTo($get_11(nextBlock.children, 0), 27);
    while(placeRectInBlock(row, block, rect, boundingWidth, nodeNodeSpacing)){
        somethingWasChanged = true;
        $removeChild(nextBlock, rect);
        if (nextBlock.children.array.length == 0) break;
        rect = castTo($get_11(nextBlock.children, 0), 27);
    }
    nextBlock.children.array.length == 0 && $removeBlock(nextBlock.parentRow, nextBlock);
    somethingWasChanged && $updateDimension(block.stack_0);
    return somethingWasChanged;
}
function compact_4(rowIdx, rows_0, boundingWidth, nodeNodeSpacing, rowHeightReevaluation) {
    var block, blockId, blocks, compactRowAgain, currentStack, nextBlock, nextBlockMinHeight, nextRowIndex, oldRowHeight, row, somethingWasChanged, wasFromNextRow, nextBlock_0;
    somethingWasChanged = false;
    compactRowAgain = false;
    nextRowIndex = rowIdx + 1;
    row = (checkCriticalElementIndex(rowIdx, rows_0.array.length), castTo(rows_0.array[rowIdx], 186));
    blocks = row.children;
    currentStack = null;
    for(blockId = 0; blockId < row.children.array.length; blockId++){
        block = (checkCriticalElementIndex(blockId, blocks.array.length), castTo(blocks.array[blockId], 172));
        if (block.fixed_0) continue;
        if (block.children.array.length == 0) {
            $clinit_System();
            String.fromCharCode(10);
            $removeBlock(row, block);
            --blockId;
            somethingWasChanged = true;
            continue;
        }
        if (!block.positionFixed) {
            !!currentStack && $updateDimension(currentStack);
            currentStack = new BlockStack(!currentStack ? 0 : currentStack.x_0 + currentStack.width_0 + nodeNodeSpacing, row.y_0, nodeNodeSpacing);
            $setLocation(block, currentStack.x_0 + currentStack.width_0, row.y_0);
            $add_3(row.stacks, currentStack);
            $addBlock(currentStack, block);
            block.positionFixed = true;
        }
        nextBlock = null;
        nextBlock = (nextBlock_0 = null, blockId < row.children.array.length - 1 ? nextBlock_0 = castTo($get_11(row.children, blockId + 1), 172) : nextRowIndex < rows_0.array.length && (checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)).children.array.length != 0 && (nextBlock_0 = castTo($get_11((checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)).children, 0), 172)), nextBlock_0);
        wasFromNextRow = false;
        !!nextBlock && (wasFromNextRow = !equals_Ljava_lang_Object__Z__devirtual$(nextBlock.parentRow, row));
        if (nextBlock) {
            if (nextBlock.children.array.length != 0 && !$booleanValue(castToBoolean(castTo($get_11(nextBlock.children, 0), 27).getProperty(($clinit_RectPackingOptions(), IN_NEW_ROW_0))))) {
                $placeRectsIn(block, boundingWidth - block.x_0);
                $updateDimension(block.stack_0);
                somethingWasChanged = somethingWasChanged | absorbBlocks(row, block, nextBlock, boundingWidth, nodeNodeSpacing);
            } else {
                $removeBlock(row, nextBlock);
                break;
            }
            if (nextBlock.children.array.length == 0) {
                rows_0.array.length > nextRowIndex && $removeBlock((checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)), nextBlock);
                nextBlock = null;
                while(rows_0.array.length > nextRowIndex && (checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)).children.array.length == 0)$remove_12(rows_0, (checkCriticalElementIndex(nextRowIndex, rows_0.array.length), rows_0.array[nextRowIndex]));
            }
            if (!nextBlock) {
                --blockId;
                continue;
            }
            if (!$booleanValue(castToBoolean(castTo($get_11(nextBlock.children, 0), 27).getProperty(($clinit_RectPackingOptions(), IN_NEW_ROW_0)))) && placeBelow(rows_0, row, block, nextBlock, wasFromNextRow, boundingWidth, nextRowIndex, nodeNodeSpacing)) {
                somethingWasChanged = true;
                continue;
            }
            if (wasFromNextRow) {
                oldRowHeight = row.height;
                nextBlockMinHeight = nextBlock.minHeight;
                if (!$booleanValue(castToBoolean(castTo($get_11(nextBlock.children, 0), 27).getProperty(IN_NEW_ROW_0))) && placeBeside(rows_0, row, block, nextBlock, boundingWidth, nextRowIndex, nodeNodeSpacing, rowHeightReevaluation)) {
                    somethingWasChanged = true;
                    if (oldRowHeight < nextBlockMinHeight) {
                        compactRowAgain = true;
                        nextBlock.parentRow = row;
                        break;
                    }
                    continue;
                } else if (useRowHeight(row, block)) {
                    block.fixed_0 = true;
                    somethingWasChanged = true;
                    continue;
                }
            } else if (useRowHeight(row, block)) {
                block.fixed_0 = true;
                somethingWasChanged = true;
                continue;
            }
            if (somethingWasChanged) continue;
        }
        if (useRowHeight(row, block)) {
            block.fixed_0 = true;
            somethingWasChanged = true;
            !!nextBlock && (nextBlock.positionFixed = false);
            continue;
        } else $updateDimension(block.stack_0);
    }
    return new Pair(($clinit_Boolean(), somethingWasChanged ? true : false), compactRowAgain ? true : false);
}
function placeBelow(rows_0, row, block, nextBlock, wasFromNextRow, boundingWidth, nextRowIndex, nodeNodeSpacing) {
    var bounds, bounds0, currentBlockMinHeight, nextBlockMinHeight, remainingWidth, somethingWasChanged;
    somethingWasChanged = false;
    remainingWidth = boundingWidth - block.x_0;
    currentBlockMinHeight = block.y_0 - row.y_0 + (bounds0 = $placeRectsIn_1(block, remainingWidth, false), bounds0.height);
    if (nextBlock.minWidth + nodeNodeSpacing > remainingWidth) return false;
    nextBlockMinHeight = (bounds = $placeRectsIn_1(nextBlock, remainingWidth, false), bounds.height);
    if (currentBlockMinHeight + nodeNodeSpacing + nextBlockMinHeight <= row.height) {
        $placeRectsIn(block, boundingWidth - block.x_0);
        block.fixed_0 = true;
        $placeRectsIn(nextBlock, boundingWidth - block.x_0);
        $setLocation(nextBlock, block.x_0, block.y_0 + block.height + nodeNodeSpacing);
        nextBlock.positionFixed = true;
        $addBlock(block.stack_0, nextBlock);
        somethingWasChanged = true;
        if (wasFromNextRow) {
            $addBlock_0(row, nextBlock);
            nextBlock.parentRow = row;
            if (rows_0.array.length > nextRowIndex) {
                $removeBlock((checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)), nextBlock);
                (checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)).children.array.length == 0 && $remove_11(rows_0, nextRowIndex);
            }
        }
    }
    return somethingWasChanged;
}
function placeBeside(rows_0, row, block, nextBlock, boundingWidth, nextRowIndex, nodeNodeSpacing, rowHeightReevaluation) {
    var bounds, currentBlockMinWidth, lastRowOptimization, nextBlockHeight, potentialWidth, shouldRowHeigthBeReevalauted, somethingWasChanged, stack_0, stack$iterator, targetWidthOfNextBlock;
    somethingWasChanged = false;
    currentBlockMinWidth = $getWidthForFixedHeight(block.stack_0, row.y_0 + row.height - block.stack_0.y_0);
    shouldRowHeigthBeReevalauted = nextBlock.minHeight > row.height && rowHeightReevaluation;
    targetWidthOfNextBlock = boundingWidth - (block.stack_0.x_0 + currentBlockMinWidth - nodeNodeSpacing);
    nextBlockHeight = (bounds = $placeRectsIn_1(nextBlock, targetWidthOfNextBlock, false), bounds.height);
    if (shouldRowHeigthBeReevalauted && nextBlockHeight > nextBlock.minHeight) return false;
    if (shouldRowHeigthBeReevalauted) {
        potentialWidth = 0;
        for(stack$iterator = new ArrayList$1(row.stacks); stack$iterator.i < stack$iterator.this$01.array.length;){
            stack_0 = castTo($next_6(stack$iterator), 316);
            potentialWidth += $getWidthForFixedHeight(stack_0, nextBlock.minHeight) + nodeNodeSpacing;
        }
        targetWidthOfNextBlock = boundingWidth - potentialWidth;
    }
    if (targetWidthOfNextBlock < nextBlock.minWidth) return false;
    lastRowOptimization = nextRowIndex == rows_0.array.length - 1 && targetWidthOfNextBlock >= (checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)).width_0;
    if (!shouldRowHeigthBeReevalauted && nextBlockHeight > row.height && !lastRowOptimization) return false;
    if (lastRowOptimization || shouldRowHeigthBeReevalauted || nextBlockHeight <= row.height) {
        if (lastRowOptimization && nextBlockHeight > row.height) {
            block.height = nextBlockHeight;
            $placeRectsIn(block, $getWidthForTargetHeight(block, nextBlockHeight));
        } else {
            $placeRectsIn_2(block.stack_0, currentBlockMinWidth);
            block.fixed_0 = true;
        }
        $placeRectsIn(nextBlock, boundingWidth - (block.x_0 + block.width_0));
        $setLocation(nextBlock, block.stack_0.x_0 + block.stack_0.width_0, row.y_0);
        $addBlock_0(row, nextBlock);
        if (rows_0.array.length > nextRowIndex) {
            $removeBlock((checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)), nextBlock);
            (checkCriticalElementIndex(nextRowIndex, rows_0.array.length), castTo(rows_0.array[nextRowIndex], 186)).children.array.length == 0 && $remove_11(rows_0, nextRowIndex);
        }
        somethingWasChanged = true;
    }
    return somethingWasChanged;
}
function useRowHeight(row, block) {
    var previousWidth, somethingWasChanged, targetWidth;
    somethingWasChanged = false;
    previousWidth = block.stack_0.width_0;
    if (block.height < row.height) {
        targetWidth = $getWidthForFixedHeight(block.stack_0, row.height);
        if (block.stack_0.width_0 > targetWidth) {
            $placeRectsIn_2(block.stack_0, targetWidth);
            somethingWasChanged = previousWidth != block.stack_0.width_0;
        }
    }
    return somethingWasChanged;
}
function $clone_0(node) {
    var child, child$iterator, clone, elkNode, elkNode0, newChild;
    clone = ($clinit_ElkGraphFactory(), elkNode0 = new ElkNodeImpl, elkNode0);
    $copyProperties_0(clone, node);
    for(child$iterator = new AbstractEList$EIterator((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
        child = castTo($doNext(child$iterator), 27);
        newChild = (elkNode = new ElkNodeImpl, elkNode);
        $setParent_2(newChild, clone);
        $setDimensions(newChild, child.width_0, child.height);
        $setIdentifier(newChild, child.identifier);
        $setLocation_1(newChild, child.x_0, child.y_0);
        $add_21((!clone.children && (clone.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, clone, 10, 11)), clone.children), newChild);
        $copyProperties_0(newChild, child);
    }
    return clone;
}
function $copyPosition(this$static, node, other) {
    var i;
    $setDimensions(other, node.width_0, node.height);
    $setLocation_1(other, node.x_0, node.y_0);
    for(i = 0; i < (!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children).size_0; i++)$copyPosition(this$static, castTo($get_20((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children), i), 27), castTo($get_20((!other.children && (other.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, other, 10, 11)), other.children), i), 27));
}
function $copyRowWidthChangeValues(graph, compaction) {
    $setProperty_1(graph, ($clinit_InternalProperties_4(), MIN_ROW_INCREASE), compaction.potentialRowWidthIncreaseMin);
    $setProperty_1(graph, MAX_ROW_INCREASE, compaction.potentialRowWidthIncreaseMax);
    $setProperty_1(graph, MIN_ROW_DECREASE, compaction.potentialRowWidthDecreaseMin);
    $setProperty_1(graph, MAX_ROW_DECREASE, compaction.potentialRowWidthDecreaseMax);
}
function $process_111(this$static, graph, progressMonitor) {
    var aspectRatio, clone, drawing, i, iterations, newDrawing, newSM, nodeNodeSpacing, oldSM, padding, secondIt, padding_0, aspectRatio_0;
    progressMonitor.begin('Compaction', 1);
    !graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11));
    aspectRatio = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RectPackingOptions(), ASPECT_RATIO_2))));
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty_0(graph, SPACING_NODE_NODE_3)));
    padding = castTo($getProperty_0(graph, PADDING_2), 107);
    secondIt = new RowFillingAndCompaction(aspectRatio, nodeNodeSpacing);
    drawing = $start(secondIt, graph, padding);
    $copyRowWidthChangeValues(graph, secondIt);
    iterations = castTo($getProperty_0(graph, PACKING_COMPACTION_ITERATIONS_0), 17).value_0;
    while(iterations > 1){
        clone = $clone_0(graph);
        oldSM = drawing.scaleMeasure;
        padding_0 = castTo($getProperty_0(graph, PADDING_2), 107);
        aspectRatio_0 = $doubleValue(castToDouble($getProperty_0(graph, ASPECT_RATIO_2)));
        (!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children).size_0 > 1 && $doubleValue(castToDouble($getProperty_0(graph, ($clinit_InternalProperties_4(), MIN_ROW_INCREASE)))) != $intern_60 && (drawing.drawingWidth + (padding_0.left + padding_0.right)) / (drawing.drawingHeight + (padding_0.top_0 + padding_0.bottom)) < aspectRatio_0 ? $setProperty_1(clone, ($clinit_InternalProperties_4(), TARGET_WIDTH), $doubleValue(castToDouble($getProperty_0(graph, TARGET_WIDTH))) + $doubleValue(castToDouble($getProperty_0(graph, MIN_ROW_INCREASE)))) : (!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children).size_0 > 1 && $doubleValue(castToDouble($getProperty_0(graph, ($clinit_InternalProperties_4(), MIN_ROW_DECREASE)))) != $intern_60 && (drawing.drawingWidth + (padding_0.left + padding_0.right)) / (drawing.drawingHeight + (padding_0.top_0 + padding_0.bottom)) > aspectRatio_0 && $setProperty_1(clone, ($clinit_InternalProperties_4(), TARGET_WIDTH), $wnd.Math.max($doubleValue(castToDouble($getProperty_0(graph, MIN_WIDTH_0))), $doubleValue(castToDouble($getProperty_0(clone, TARGET_WIDTH))) - $doubleValue(castToDouble($getProperty_0(graph, MIN_ROW_DECREASE)))));
        secondIt = new RowFillingAndCompaction(aspectRatio, nodeNodeSpacing);
        newDrawing = $start(secondIt, clone, padding);
        newSM = newDrawing.scaleMeasure;
        if (newSM >= oldSM && newSM == newSM) {
            for(i = 0; i < (!clone.children && (clone.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, clone, 10, 11)), clone.children).size_0; i++)$copyPosition(this$static, castTo($get_20((!clone.children && (clone.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, clone, 10, 11)), clone.children), i), 27), castTo($get_20((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children), i), 27));
            $copyRowWidthChangeValues(graph, secondIt);
            $setDrawingWidth(drawing, newDrawing.drawingWidth);
            $setDrawingHeight(drawing, newDrawing.drawingHeight);
        }
        --iterations;
    }
    $setProperty_1(graph, ($clinit_InternalProperties_4(), DRAWING_HEIGHT), drawing.drawingHeight);
    $setProperty_1(graph, DRAWING_WIDTH, drawing.drawingWidth);
    progressMonitor.done_1();
}
function Compactor() {}
defineClass(1410, 1, $intern_110, Compactor);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_31(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_107(graph, progressMonitor) {
    $process_111(this, castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_p2packing_Compactor_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p2packing', 'Compactor', 1410);
function place(rectangles, boundingWidth, nodeNodeSpacing) {
    var block, currentWidth, drawingHeight, newBlock, potentialRowWidth, rect, rect$iterator, row, rows_0;
    rows_0 = new ArrayList;
    row = new RectRow(0, nodeNodeSpacing);
    drawingHeight = 0;
    $addBlock_0(row, new Block(0, 0, row, nodeNodeSpacing));
    currentWidth = 0;
    for(rect$iterator = new AbstractEList$EIterator(rectangles); rect$iterator.cursor != rect$iterator.this$01_2.size_1();){
        rect = castTo($doNext(rect$iterator), 27);
        block = castTo($get_11(row.children, row.children.array.length - 1), 172);
        potentialRowWidth = currentWidth + rect.width_0 + (castTo($get_11(row.children, 0), 172).children.array.length == 0 ? 0 : nodeNodeSpacing);
        if (potentialRowWidth > boundingWidth || $booleanValue(castToBoolean($getProperty_0(rect, ($clinit_RectPackingOptions(), IN_NEW_ROW_0))))) {
            currentWidth = 0;
            drawingHeight += row.height + nodeNodeSpacing;
            push_1(rows_0.array, row);
            row = new RectRow(drawingHeight, nodeNodeSpacing);
            block = new Block(0, row.y_0, row, nodeNodeSpacing);
            $addBlock_0(row, block);
            currentWidth = 0;
        }
        if (block.children.array.length == 0 || !$booleanValue(castToBoolean($getProperty_0($getParent_2(rect), ($clinit_RectPackingOptions(), PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION_0)))) && (rect.height >= block.smallestRectHeight && rect.height <= block.minHeight || block.averageHeight * 0.5 <= rect.height && block.averageHeight * 1.5 >= rect.height)) $addChild(block, rect);
        else {
            newBlock = new Block(block.x_0 + block.width_0 + nodeNodeSpacing, row.y_0, row, nodeNodeSpacing);
            $addBlock_0(row, newBlock);
            $addChild(newBlock, rect);
        }
        currentWidth = rect.x_0 + rect.width_0;
    }
    push_1(rows_0.array, row);
    return rows_0;
}
function placeRectInBlock(row, block, rect, boundingWidth, nodeNodeSpacing) {
    var lastRow, lastRow0, lastRow_0;
    if (rect.height >= block.smallestRectHeight && rect.height <= block.minHeight || block.averageHeight * 0.5 <= rect.height && block.averageHeight * 1.5 >= rect.height) {
        lastRow0 = castTo($get_11(block.rows_0, block.rows_0.array.length - 1), 208);
        if (lastRow0.x_0 + lastRow0.width_0 + rect.width_0 + nodeNodeSpacing <= boundingWidth && (lastRow = castTo($get_11(block.rows_0, block.rows_0.array.length - 1), 208), lastRow.y_0 - row.y_0 + rect.height <= row.height || row.children.array.length == 1)) {
            $addChild(block, rect);
            return true;
        } else if (block.x_0 + rect.width_0 <= boundingWidth && (block.y_0 + block.height + rect.height + nodeNodeSpacing <= row.height || row.children.array.length == 1)) {
            $add_3(block.children, rect);
            lastRow_0 = castTo($get_11(block.rows_0, block.rows_0.array.length - 1), 208);
            $add_3(block.rows_0, new BlockRow(block.x_0, lastRow_0.y_0 + lastRow_0.height + block.nodeNodeSpacing, block.nodeNodeSpacing));
            $addRectangle(castTo($get_11(block.rows_0, block.rows_0.array.length - 1), 208), rect);
            $adjustSizeAdd(block, rect);
            return true;
        }
    }
    return false;
}
function $process_112(graph, progressMonitor) {
    var additionalHeight, height, padding, rectangles, size_0, width_0;
    progressMonitor.begin('No Compaction', 1);
    padding = castTo($getProperty_0(graph, ($clinit_RectPackingOptions(), PADDING_2)), 107);
    rectangles = (!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children);
    size_0 = calculateDimensions(rectangles);
    width_0 = $wnd.Math.max(size_0.x_0, $doubleValue(castToDouble($getProperty_0(graph, ($clinit_InternalProperties_4(), MIN_WIDTH_0)))) - (padding.left + padding.right));
    height = $wnd.Math.max(size_0.y_0, $doubleValue(castToDouble($getProperty_0(graph, MIN_HEIGHT))) - (padding.top_0 + padding.bottom));
    additionalHeight = height - size_0.y_0;
    $setProperty_1(graph, ADDITIONAL_HEIGHT, additionalHeight);
    $setProperty_1(graph, DRAWING_WIDTH, width_0);
    $setProperty_1(graph, DRAWING_HEIGHT, height + additionalHeight);
    progressMonitor.done_1();
}
function NoPlacement() {}
defineClass(1412, 1, $intern_110, NoPlacement);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_32(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_108(graph, progressMonitor) {
    $process_112(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_p2packing_NoPlacement_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p2packing', 'NoPlacement', 1412);
function $clinit_PackingStrategy() {
    $clinit_PackingStrategy = emptyMethod;
    COMPACTION_2 = new PackingStrategy('COMPACTION', 0);
    SIMPLE_0 = new PackingStrategy('SIMPLE', 1);
    NONE_16 = new PackingStrategy('NONE', 2);
}
function $create_15(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new Compactor;
        case 1:
            return new SimplePlacement;
        case 2:
            return new NoPlacement;
        default:
            return null;
    }
}
function PackingStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_81(name_0) {
    $clinit_PackingStrategy();
    return valueOf(($clinit_PackingStrategy$Map(), $MAP_71), name_0);
}
function values_89() {
    $clinit_PackingStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p2packing_PackingStrategy_2_classLit, 1), $intern_36, 426, 0, [
        COMPACTION_2,
        SIMPLE_0,
        NONE_16
    ]);
}
defineClass(426, 23, {
    3: 1,
    34: 1,
    23: 1,
    426: 1,
    188: 1,
    196: 1
}, PackingStrategy);
_.create_1 = function create_30() {
    return $create_15(this);
};
_.create_2 = function create_29() {
    return $create_15(this);
};
var COMPACTION_2, NONE_16, SIMPLE_0;
var Lorg_eclipse_elk_alg_rectpacking_p2packing_PackingStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking.p2packing', 'PackingStrategy', 426, Ljava_lang_Enum_2_classLit, values_89, valueOf_81);
function $clinit_PackingStrategy$Map() {
    $clinit_PackingStrategy$Map = emptyMethod;
    $MAP_71 = createValueOfMap(($clinit_PackingStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p2packing_PackingStrategy_2_classLit, 1), $intern_36, 426, 0, [
        COMPACTION_2,
        SIMPLE_0,
        NONE_16
    ])));
}
var $MAP_71;
function $adjustWidthAndHeight(this$static, row) {
    var index_0, maxHeight, maxWidth, stack_0, stack$iterator;
    maxHeight = 0;
    maxWidth = 0;
    index_0 = 0;
    for(stack$iterator = new ArrayList$1(row.stacks); stack$iterator.i < stack$iterator.this$01.array.length;){
        stack_0 = castTo($next_6(stack$iterator), 316);
        $updateDimension(stack_0);
        maxHeight = $wnd.Math.max(maxHeight, stack_0.height);
        maxWidth += stack_0.width_0 + (index_0 > 0 ? this$static.nodeNodeSpacing : 0);
        ++index_0;
    }
    row.height = maxHeight;
    row.width_0 = maxWidth;
}
function $start(this$static, layoutGraph, padding) {
    var additionalHeight, block, block$iterator, blockRow, blockRow$iterator, currentRow, height, lastBlock, lastStack, minHeight, minWidth, previousRow, result, rowIdx, rows_0, size_0, targetWidth, totalWidth;
    targetWidth = $doubleValue(castToDouble($getProperty_0(layoutGraph, ($clinit_InternalProperties_4(), TARGET_WIDTH))));
    minWidth = $doubleValue(castToDouble($getProperty_0(layoutGraph, MIN_WIDTH_0)));
    minHeight = $doubleValue(castToDouble($getProperty_0(layoutGraph, MIN_HEIGHT)));
    resetCoordinates((!layoutGraph.children && (layoutGraph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutGraph, 10, 11)), layoutGraph.children));
    rows_0 = place((!layoutGraph.children && (layoutGraph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutGraph, 10, 11)), layoutGraph.children), targetWidth, this$static.nodeNodeSpacing);
    for(rowIdx = 0; rowIdx < rows_0.array.length; rowIdx++){
        currentRow = (checkCriticalElementIndex(rowIdx, rows_0.array.length), castTo(rows_0.array[rowIdx], 186));
        if (rowIdx != 0) {
            previousRow = (checkCriticalElementIndex(rowIdx - 1, rows_0.array.length), castTo(rows_0.array[rowIdx - 1], 186));
            $setY_0(currentRow, previousRow.y_0 + previousRow.height + this$static.nodeNodeSpacing);
        }
        result = compact_4(rowIdx, rows_0, targetWidth, this$static.nodeNodeSpacing, $booleanValue(castToBoolean($getProperty_0(layoutGraph, ($clinit_RectPackingOptions(), PACKING_COMPACTION_ROW_HEIGHT_REEVALUATION_0)))));
        if ($booleanValue(castToBoolean(result.second))) {
            for(block$iterator = new ArrayList$1(currentRow.children); block$iterator.i < block$iterator.this$01.array.length;){
                block = castTo($next_6(block$iterator), 172);
                block.fixed_0 = false;
                block.positionFixed = false;
                $adjustSizeAfterRemove(block);
            }
            currentRow.stacks = new ArrayList;
            currentRow.width_0 = targetWidth;
            --rowIdx;
        } else {
            $adjustWidthAndHeight(this$static, currentRow);
            if (rowIdx + 1 < rows_0.array.length) {
                this$static.potentialRowWidthIncreaseMax = $wnd.Math.max(currentRow.width_0 + this$static.nodeNodeSpacing + castTo($get_11((checkCriticalElementIndex(rowIdx + 1, rows_0.array.length), castTo(rows_0.array[rowIdx + 1], 186)).children, 0), 172).width_0 - targetWidth, this$static.potentialRowWidthDecreaseMax);
                this$static.potentialRowWidthIncreaseMin = $wnd.Math.min(currentRow.width_0 + this$static.nodeNodeSpacing + castTo($get_11((checkCriticalElementIndex(rowIdx + 1, rows_0.array.length), castTo(rows_0.array[rowIdx + 1], 186)).children, 0), 172).width_0 - targetWidth, this$static.potentialRowWidthDecreaseMin);
                if (currentRow.stacks.array.length != 0) {
                    this$static.potentialRowWidthDecreaseMax = $wnd.Math.max(this$static.potentialRowWidthDecreaseMax, castTo($get_11(currentRow.stacks, currentRow.stacks.array.length - 1), 316).width_0 + (currentRow.stacks.array.length <= 1 ? 0 : this$static.nodeNodeSpacing));
                    this$static.potentialRowWidthDecreaseMin = $wnd.Math.min(this$static.potentialRowWidthDecreaseMax, castTo($get_11(currentRow.stacks, currentRow.stacks.array.length - 1), 316).width_0 + (currentRow.stacks.array.length <= 1 ? 0 : this$static.nodeNodeSpacing));
                }
            }
            if (rows_0.array.length == 1) {
                lastStack = castTo($get_11(currentRow.stacks, currentRow.stacks.array.length - 1), 316);
                lastBlock = castTo($get_11(lastStack.blocks, lastStack.blocks.array.length - 1), 172);
                for(blockRow$iterator = new ArrayList$1(lastBlock.rows_0); blockRow$iterator.i < blockRow$iterator.this$01.array.length;){
                    blockRow = castTo($next_6(blockRow$iterator), 208);
                    this$static.potentialRowWidthDecreaseMax = $wnd.Math.max(this$static.potentialRowWidthDecreaseMax, lastBlock.width_0 - blockRow.width_0);
                    this$static.potentialRowWidthDecreaseMin = $wnd.Math.min(this$static.potentialRowWidthDecreaseMin, lastBlock.width_0 - blockRow.width_0);
                    this$static.potentialRowWidthIncreaseMax = $wnd.Math.max(this$static.potentialRowWidthIncreaseMax, blockRow.width_0 + this$static.nodeNodeSpacing);
                    this$static.potentialRowWidthIncreaseMin = $wnd.Math.min(this$static.potentialRowWidthIncreaseMin, blockRow.width_0 + this$static.nodeNodeSpacing);
                }
            }
        }
    }
    size_0 = calculateDimensions_0(rows_0, this$static.nodeNodeSpacing);
    totalWidth = $wnd.Math.max(size_0.x_0, minWidth - (padding.left + padding.right));
    height = $wnd.Math.max(size_0.y_0, minHeight - (padding.top_0 + padding.bottom));
    additionalHeight = height - size_0.y_0;
    $setProperty_1(layoutGraph, ADDITIONAL_HEIGHT, additionalHeight);
    $setProperty_1(layoutGraph, ROWS_0, rows_0);
    return new DrawingData(this$static.aspectRatio, totalWidth, size_0.y_0 + additionalHeight, ($clinit_DrawingDataDescriptor(), WHOLE_DRAWING));
}
function RowFillingAndCompaction(aspectRatio, nodeNodeSpacing) {
    this.aspectRatio = aspectRatio;
    this.nodeNodeSpacing = nodeNodeSpacing;
}
defineClass(790, 1, {}, RowFillingAndCompaction);
_.aspectRatio = 0;
_.nodeNodeSpacing = 0;
_.potentialRowWidthDecreaseMax = 0;
_.potentialRowWidthDecreaseMin = $intern_60;
_.potentialRowWidthIncreaseMax = 0;
_.potentialRowWidthIncreaseMin = $intern_60;
var Lorg_eclipse_elk_alg_rectpacking_p2packing_RowFillingAndCompaction_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p2packing', 'RowFillingAndCompaction', 790);
function $process_113(graph, progressMonitor) {
    var additionalHeight, block, block$iterator, height, nodeNodeSpacing, padding, row, row$iterator, rows_0, size_0, stack_0, targetWidth, width_0;
    progressMonitor.begin('No Compaction', 1);
    targetWidth = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_InternalProperties_4(), TARGET_WIDTH))));
    nodeNodeSpacing = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RectPackingOptions(), SPACING_NODE_NODE_3))));
    padding = castTo($getProperty_0(graph, PADDING_2), 107);
    resetCoordinates((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children));
    rows_0 = place((!graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11)), graph.children), targetWidth, nodeNodeSpacing);
    !graph.children && (graph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, graph, 10, 11));
    for(row$iterator = new ArrayList$1(rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 186);
        for(block$iterator = new ArrayList$1(row.children); block$iterator.i < block$iterator.this$01.array.length;){
            block = castTo($next_6(block$iterator), 172);
            stack_0 = new BlockStack(block.x_0, block.y_0, $doubleValue(castToDouble($getProperty_0(graph, SPACING_NODE_NODE_3))));
            $addBlock(stack_0, block);
            $add_3(row.stacks, stack_0);
        }
    }
    size_0 = calculateDimensions_0(rows_0, nodeNodeSpacing);
    width_0 = $wnd.Math.max(size_0.x_0, $doubleValue(castToDouble($getProperty_0(graph, MIN_WIDTH_0))) - (padding.left + padding.right));
    height = $wnd.Math.max(size_0.y_0, $doubleValue(castToDouble($getProperty_0(graph, MIN_HEIGHT))) - (padding.top_0 + padding.bottom));
    additionalHeight = height - size_0.y_0;
    $setProperty_1(graph, ADDITIONAL_HEIGHT, additionalHeight);
    $setProperty_1(graph, DRAWING_WIDTH, width_0);
    $setProperty_1(graph, DRAWING_HEIGHT, height + additionalHeight);
    $setProperty_1(graph, ROWS_0, rows_0);
    progressMonitor.done_1();
}
function SimplePlacement() {}
defineClass(1411, 1, $intern_110, SimplePlacement);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_33(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_109(graph, progressMonitor) {
    $process_113(castTo(graph, 27), progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_p2packing_SimplePlacement_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p2packing', 'SimplePlacement', 1411);
function $process_114(graph, progressMonitor) {
    var lastArg;
    progressMonitor.begin('Equal Whitespace Eliminator', 1);
    if ($hasProperty_0(graph, ($clinit_InternalProperties_4(), ROWS_0))) expand(castTo($getProperty_0(graph, ROWS_0), 15), $doubleValue(castToDouble($getProperty_0(graph, DRAWING_WIDTH))), (lastArg = $doubleValue(castToDouble($getProperty_0(graph, ADDITIONAL_HEIGHT))), $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RectPackingOptions(), SPACING_NODE_NODE_3)))), lastArg));
    else throw toJs(new UnsupportedConfigurationException_0('The graph does not contain rows.'));
    progressMonitor.done_1();
}
function EqualWhitespaceEliminator() {}
defineClass(1413, 1, $intern_110, EqualWhitespaceEliminator);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_34(graph) {
    return castTo(graph, 27), null;
};
_.process = function process_110(graph, progressMonitor) {
    this.process_0(castTo(graph, 27), progressMonitor);
};
_.process_0 = function process_111(graph, progressMonitor) {
    $process_114(graph, progressMonitor);
};
var Lorg_eclipse_elk_alg_rectpacking_p3whitespaceelimination_EqualWhitespaceEliminator_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p3whitespaceelimination', 'EqualWhitespaceEliminator', 1413);
function expand(rows_0, drawingWidth, additionalHeight) {
    var heightPerRow, index_0, row, row$iterator;
    heightPerRow = additionalHeight / rows_0.size_1();
    index_0 = 0;
    for(row$iterator = rows_0.iterator_0(); row$iterator.hasNext_0();){
        row = castTo(row$iterator.next_1(), 186);
        $setY_0(row, row.y_0 + heightPerRow * index_0);
        $expand_2(row, drawingWidth, heightPerRow);
        ++index_0;
    }
}
function ToAspectratioNodeExpander() {}
defineClass(1414, 1413, $intern_110, ToAspectratioNodeExpander);
_.process_0 = function process_112(graph, progressMonitor) {
    var additionalHeight, aspectRatio, desiredAspectRatio, height, width_0;
    progressMonitor.begin('To Aspect Ratio Whitesapce Eliminator', 1);
    width_0 = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_InternalProperties_4(), DRAWING_WIDTH))));
    height = $doubleValue(castToDouble($getProperty_0(graph, DRAWING_HEIGHT)));
    desiredAspectRatio = $doubleValue(castToDouble($getProperty_0(graph, ($clinit_RectPackingOptions(), ASPECT_RATIO_2))));
    additionalHeight = $doubleValue(castToDouble($getProperty_0(graph, ADDITIONAL_HEIGHT)));
    aspectRatio = width_0 / height;
    if (aspectRatio < desiredAspectRatio) {
        width_0 = height * desiredAspectRatio;
        $setProperty_1(graph, DRAWING_WIDTH, width_0);
    } else {
        additionalHeight += width_0 / desiredAspectRatio - height;
        $setProperty_1(graph, ADDITIONAL_HEIGHT, additionalHeight);
        $setProperty_1(graph, DRAWING_HEIGHT, height + additionalHeight);
    }
    $process_114(graph, progressMonitor);
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_rectpacking_p3whitespaceelimination_ToAspectratioNodeExpander_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.p3whitespaceelimination', 'ToAspectratioNodeExpander', 1414);
function $clinit_WhiteSpaceEliminationStrategy() {
    $clinit_WhiteSpaceEliminationStrategy = emptyMethod;
    EQUAL_BETWEEN_STRUCTURES = new WhiteSpaceEliminationStrategy('EQUAL_BETWEEN_STRUCTURES', 0);
    TO_ASPECT_RATIO = new WhiteSpaceEliminationStrategy('TO_ASPECT_RATIO', 1);
    NONE_17 = new WhiteSpaceEliminationStrategy('NONE', 2);
}
function $create_16(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new EqualWhitespaceEliminator;
        case 1:
            return new ToAspectratioNodeExpander;
        case 2:
        default:
            return null;
    }
}
function WhiteSpaceEliminationStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_82(name_0) {
    $clinit_WhiteSpaceEliminationStrategy();
    return valueOf(($clinit_WhiteSpaceEliminationStrategy$Map(), $MAP_72), name_0);
}
function values_90() {
    $clinit_WhiteSpaceEliminationStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p3whitespaceelimination_WhiteSpaceEliminationStrategy_2_classLit, 1), $intern_36, 427, 0, [
        EQUAL_BETWEEN_STRUCTURES,
        TO_ASPECT_RATIO,
        NONE_17
    ]);
}
defineClass(427, 23, {
    3: 1,
    34: 1,
    23: 1,
    427: 1,
    188: 1,
    196: 1
}, WhiteSpaceEliminationStrategy);
_.create_1 = function create_32() {
    return $create_16(this);
};
_.create_2 = function create_31() {
    return $create_16(this);
};
var EQUAL_BETWEEN_STRUCTURES, NONE_17, TO_ASPECT_RATIO;
var Lorg_eclipse_elk_alg_rectpacking_p3whitespaceelimination_WhiteSpaceEliminationStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking.p3whitespaceelimination', 'WhiteSpaceEliminationStrategy', 427, Ljava_lang_Enum_2_classLit, values_90, valueOf_82);
function $clinit_WhiteSpaceEliminationStrategy$Map() {
    $clinit_WhiteSpaceEliminationStrategy$Map = emptyMethod;
    $MAP_72 = createValueOfMap(($clinit_WhiteSpaceEliminationStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_p3whitespaceelimination_WhiteSpaceEliminationStrategy_2_classLit, 1), $intern_36, 427, 0, [
        EQUAL_BETWEEN_STRUCTURES,
        TO_ASPECT_RATIO,
        NONE_17
    ])));
}
var $MAP_72;
function $addChild(this$static, rect) {
    this$static.rows_0.array.length == 0 && $add_3(this$static.rows_0, new BlockRow(this$static.x_0, this$static.y_0, this$static.nodeNodeSpacing));
    $add_3(this$static.children, rect);
    $addRectangle(castTo($get_11(this$static.rows_0, this$static.rows_0.array.length - 1), 208), rect);
    $adjustSizeAdd(this$static, rect);
}
function $adjustChildrensXandY(this$static, xChange, yChange) {
    var rect, rect$iterator;
    for(rect$iterator = new ArrayList$1(this$static.children); rect$iterator.i < rect$iterator.this$01.array.length;){
        rect = castTo($next_6(rect$iterator), 27);
        $setLocation_1(rect, rect.x_0 + xChange, rect.y_0 + yChange);
    }
}
function $adjustSizeAdd(this$static, rect) {
    var row, row$iterator, totalHeight, widthOflastRow;
    widthOflastRow = castTo($get_11(this$static.rows_0, this$static.rows_0.array.length - 1), 208).width_0;
    this$static.smallestRectWidth = $wnd.Math.min(this$static.smallestRectWidth, rect.width_0);
    this$static.width_0 = $wnd.Math.max(this$static.width_0, widthOflastRow);
    this$static.minWidth = $wnd.Math.max(this$static.minWidth, rect.width_0 + (this$static.children.array.length == 1 ? 0 : this$static.nodeNodeSpacing));
    this$static.smallestRectHeight = $wnd.Math.min(this$static.smallestRectHeight, rect.height);
    this$static.maxHeight += rect.height + (this$static.children.array.length == 1 ? 0 : this$static.nodeNodeSpacing);
    this$static.minHeight = $wnd.Math.max(this$static.minHeight, rect.height);
    totalHeight = this$static.rows_0.array.length > 0 ? (this$static.rows_0.array.length - 1) * this$static.nodeNodeSpacing : 0;
    for(row$iterator = new ArrayList$1(this$static.rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 208);
        totalHeight += row.height;
    }
    this$static.height = totalHeight;
    this$static.averageHeight = this$static.maxHeight / this$static.children.array.length - this$static.nodeNodeSpacing * ((this$static.children.array.length - 1) / this$static.children.array.length);
    $notifyAboutNodeChange(this$static.parentRow);
}
function $adjustSizeAfterRemove(this$static) {
    var index_0, newHeight, newWidth, rect, rect$iterator, row, row$iterator, rowsToDelete;
    newWidth = 0;
    newHeight = 0;
    rowsToDelete = new LinkedList;
    index_0 = 0;
    for(row$iterator = new ArrayList$1(this$static.rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 208);
        if (row.rects.array.length == 0) $addNode_0(rowsToDelete, row, rowsToDelete.tail.prev, rowsToDelete.tail);
        else {
            newWidth = $wnd.Math.max(newWidth, row.width_0);
            newHeight += row.height + (index_0 > 0 ? this$static.nodeNodeSpacing : 0);
        }
        ++index_0;
    }
    $removeAll_0(this$static.rows_0, rowsToDelete);
    this$static.height = newHeight;
    this$static.width_0 = newWidth;
    this$static.minWidth = 0;
    this$static.minHeight = 0;
    this$static.maxHeight = 0;
    this$static.smallestRectHeight = $intern_60;
    this$static.smallestRectWidth = $intern_60;
    for(rect$iterator = new ArrayList$1(this$static.children); rect$iterator.i < rect$iterator.this$01.array.length;){
        rect = castTo($next_6(rect$iterator), 27);
        this$static.smallestRectWidth = $wnd.Math.min(this$static.smallestRectWidth, rect.width_0);
        this$static.minWidth = $wnd.Math.max(this$static.minWidth, rect.width_0);
        this$static.minHeight = $wnd.Math.max(this$static.minHeight, rect.height);
        this$static.smallestRectHeight = $wnd.Math.min(this$static.smallestRectHeight, rect.height);
        this$static.maxHeight += rect.height + this$static.nodeNodeSpacing;
    }
    this$static.averageHeight = this$static.maxHeight / this$static.children.array.length - this$static.nodeNodeSpacing * ((this$static.children.array.length - 1) / this$static.children.array.length);
    $notifyAboutNodeChange(this$static.parentRow);
}
function $expand(this$static, additionalWidthPerBlock, additionalHeightForBlock) {
    var additionalHeightForRow, index_0, row, row$iterator, widthForRow;
    widthForRow = this$static.width_0 + additionalWidthPerBlock;
    this$static.width_0 += additionalWidthPerBlock;
    this$static.height += additionalHeightForBlock;
    additionalHeightForRow = additionalHeightForBlock / this$static.rows_0.array.length;
    index_0 = 0;
    for(row$iterator = new ArrayList$1(this$static.rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 208);
        $expand_0(row, widthForRow, additionalHeightForRow, index_0);
        ++index_0;
    }
}
function $getWidthForTargetHeight(this$static, height) {
    var bounds, lowerBound, newWidth, upperBound, viableWidth;
    if (this$static.maxHeight <= height) return this$static.minWidth;
    if ($placeRectsIn_0(this$static, this$static.minWidth, height)) return this$static.minWidth;
    upperBound = this$static.width_0;
    lowerBound = this$static.minWidth;
    viableWidth = this$static.width_0;
    newWidth = (upperBound - lowerBound) / 2 + lowerBound;
    while(lowerBound + 1 < upperBound){
        bounds = $placeRectsIn_1(this$static, newWidth, false);
        if (bounds.width_0 <= newWidth && bounds.height <= height) {
            viableWidth = newWidth;
            upperBound = newWidth;
        } else lowerBound = newWidth;
        newWidth = (upperBound - lowerBound) / 2 + lowerBound;
    }
    return viableWidth;
}
function $placeRectsIn(this$static, width_0) {
    var bounds, oldHeight, oldWidth;
    oldWidth = this$static.width_0;
    oldHeight = this$static.height;
    bounds = $placeRectsIn_1(this$static, width_0, true);
    return bounds.width_0 != oldWidth || bounds.height != oldHeight;
}
function $placeRectsIn_0(this$static, width_0, height) {
    var bounds;
    bounds = $placeRectsIn_1(this$static, width_0, false);
    return bounds.width_0 <= width_0 && bounds.height <= height;
}
function $placeRectsIn_1(this$static, width_0, placeRects) {
    var currentHeight, currentWidth, currentX, currentY, index_0, maxHeightInRow, rect, rect$iterator, row, widthInRow;
    currentX = 0;
    currentY = this$static.y_0;
    currentWidth = 0;
    currentHeight = 0;
    maxHeightInRow = 0;
    widthInRow = 0;
    row = 0;
    if (placeRects) {
        this$static.rows_0.array.length = 0;
        $add_3(this$static.rows_0, new BlockRow(this$static.x_0, this$static.y_0, this$static.nodeNodeSpacing));
    }
    index_0 = 0;
    for(rect$iterator = new ArrayList$1(this$static.children); rect$iterator.i < rect$iterator.this$01.array.length;){
        rect = castTo($next_6(rect$iterator), 27);
        if (currentX + rect.width_0 + (index_0 > 0 ? this$static.nodeNodeSpacing : 0) > width_0 && maxHeightInRow > 0) {
            currentX = 0;
            currentY += maxHeightInRow + this$static.nodeNodeSpacing;
            currentWidth = $wnd.Math.max(currentWidth, widthInRow);
            currentHeight += maxHeightInRow + this$static.nodeNodeSpacing;
            maxHeightInRow = 0;
            widthInRow = 0;
            if (placeRects) {
                ++row;
                $add_3(this$static.rows_0, new BlockRow(this$static.x_0, currentY, this$static.nodeNodeSpacing));
            }
            index_0 = 0;
        }
        widthInRow += rect.width_0 + (index_0 > 0 ? this$static.nodeNodeSpacing : 0);
        maxHeightInRow = $wnd.Math.max(maxHeightInRow, rect.height);
        placeRects && $addRectangle(castTo($get_11(this$static.rows_0, row), 208), rect);
        currentX += rect.width_0 + (index_0 > 0 ? this$static.nodeNodeSpacing : 0);
        ++index_0;
    }
    currentWidth = $wnd.Math.max(currentWidth, widthInRow);
    currentHeight += maxHeightInRow;
    if (placeRects) {
        this$static.width_0 = currentWidth;
        this$static.height = currentHeight;
        $notifyAboutNodeChange(this$static.parentRow);
    }
    return new ElkRectangle_0(this$static.x_0, this$static.y_0, currentWidth, currentHeight);
}
function $removeChild(this$static, rect) {
    var row, row$iterator;
    $remove_12(this$static.children, rect);
    for(row$iterator = new ArrayList$1(this$static.rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 208);
        if ($indexOf_3(row.rects, rect, 0) != -1) {
            $remove_12(row.rects, rect);
            $updateRow(row);
            row.rects.array.length == 0 && $remove_12(this$static.rows_0, row);
            break;
        }
    }
    $adjustSizeAfterRemove(this$static);
}
function $setLocation(this$static, xCoord, yCoord) {
    var row, row$iterator;
    $adjustChildrensXandY(this$static, xCoord - this$static.x_0, yCoord - this$static.y_0);
    for(row$iterator = new ArrayList$1(this$static.rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 208);
        $setX(row, row.x_0 + xCoord - this$static.x_0);
        $setY(row, row.y_0 + yCoord - this$static.y_0);
    }
    this$static.x_0 = xCoord;
    this$static.y_0 = yCoord;
}
function Block(xCoord, yCoord, parentRow, nodeNodeSpacing) {
    this.children = new ArrayList;
    this.rows_0 = new ArrayList;
    this.nodeNodeSpacing = nodeNodeSpacing;
    this.parentRow = parentRow;
    this.x_0 = xCoord;
    this.y_0 = yCoord;
    this.width_0 = 0;
    this.height = 0;
}
defineClass(172, 1, {
    172: 1
}, Block);
_.averageHeight = 0;
_.fixed_0 = false;
_.height = 0;
_.maxHeight = 0;
_.minHeight = 0;
_.minWidth = 0;
_.nodeNodeSpacing = 0;
_.positionFixed = false;
_.smallestRectHeight = $intern_60;
_.smallestRectWidth = $intern_60;
_.width_0 = 0;
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_alg_rectpacking_util_Block_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.util', 'Block', 172);
function $addRectangle(this$static, rect) {
    $setX_1(rect, this$static.x_0 + this$static.width_0 + (this$static.rects.array.length == 0 ? 0 : this$static.nodeNodeSpacing));
    $setY_2(rect, this$static.y_0);
    this$static.height = $wnd.Math.max(this$static.height, rect.height);
    this$static.width_0 += rect.width_0 + (this$static.rects.array.length == 0 ? 0 : this$static.nodeNodeSpacing);
    $add_3(this$static.rects, rect);
    return true;
}
function $expand_0(this$static, widthForRow, additionalHeightForRow, index_0) {
    var additionalWidthForRect, i, newHeight, newWidth, oldHeight, oldWidth, rect, rect$iterator;
    additionalWidthForRect = (widthForRow - this$static.width_0) / this$static.rects.array.length;
    i = 0;
    this$static.height += additionalHeightForRow;
    this$static.width_0 = widthForRow;
    for(rect$iterator = new ArrayList$1(this$static.rects); rect$iterator.i < rect$iterator.this$01.array.length;){
        rect = castTo($next_6(rect$iterator), 27);
        oldWidth = rect.width_0;
        oldHeight = rect.height;
        $setX_1(rect, rect.x_0 + i * additionalWidthForRect);
        $setY_2(rect, rect.y_0 + index_0 * additionalHeightForRow);
        $setWidth_0(rect, rect.width_0 + additionalWidthForRect);
        $setHeight_0(rect, this$static.height);
        ++i;
        newWidth = rect.width_0;
        newHeight = rect.height;
        translate_1(rect, new KVector_1(newWidth, newHeight), new KVector_1(oldWidth, oldHeight));
    }
}
function $setX(this$static, x_0) {
    this$static.x_0 = x_0;
}
function $setY(this$static, y_0) {
    this$static.y_0 = y_0;
}
function $updateRow(this$static) {
    var height, rect, rect$iterator, width_0;
    width_0 = 0;
    height = 0;
    for(rect$iterator = new ArrayList$1(this$static.rects); rect$iterator.i < rect$iterator.this$01.array.length;){
        rect = castTo($next_6(rect$iterator), 27);
        $setX_1(rect, this$static.x_0 + width_0);
        $setY_2(rect, this$static.y_0);
        width_0 += rect.width_0 + this$static.nodeNodeSpacing;
        height = $wnd.Math.max(height, rect.height + this$static.nodeNodeSpacing);
    }
    this$static.width_0 = width_0 - this$static.nodeNodeSpacing;
    this$static.height = height - this$static.nodeNodeSpacing;
}
function BlockRow(x_0, y_0, nodeNodeSpacing) {
    this.rects = new ArrayList;
    this.x_0 = x_0;
    this.y_0 = y_0;
    this.nodeNodeSpacing = nodeNodeSpacing;
}
defineClass(208, 1, {
    208: 1
}, BlockRow);
_.height = 0;
_.nodeNodeSpacing = 0;
_.width_0 = 0;
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_alg_rectpacking_util_BlockRow_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.util', 'BlockRow', 208);
function $addBlock(this$static, block) {
    block.stack_0 = this$static;
    this$static.width_0 = $wnd.Math.max(this$static.width_0, block.width_0);
    this$static.height += block.height + (this$static.blocks.array.length == 0 ? 0 : this$static.nodeNodeSpacing);
    $add_3(this$static.blocks, block);
}
function $expand_1(this$static, additionalWidth, additionalHeight) {
    var additionalHeightPerBlock, block, block$iterator, index_0;
    index_0 = 0;
    additionalHeightPerBlock = additionalHeight / this$static.blocks.array.length;
    for(block$iterator = new ArrayList$1(this$static.blocks); block$iterator.i < block$iterator.this$01.array.length;){
        block = castTo($next_6(block$iterator), 172);
        $setLocation(block, block.x_0, block.y_0 + index_0 * additionalHeightPerBlock);
        $expand(block, this$static.width_0 - block.width_0 + additionalWidth, additionalHeightPerBlock);
        ++index_0;
    }
}
function $getMinimumWidth_1(this$static) {
    var block, block$iterator, minWidth;
    minWidth = 0;
    for(block$iterator = new ArrayList$1(this$static.blocks); block$iterator.i < block$iterator.this$01.array.length;){
        block = castTo($next_6(block$iterator), 172);
        minWidth = $wnd.Math.max(minWidth, block.minWidth);
    }
    return minWidth;
}
function $getWidthForFixedHeight(this$static, height) {
    var block, block$iterator, bounds, lowerBound, minWidth, newWidth, totalHeight, upperBound, viableWidth;
    if (this$static.blocks.array.length == 1) return $getWidthForTargetHeight(castTo($get_11(this$static.blocks, 0), 172), height);
    minWidth = $getMinimumWidth_1(this$static);
    totalHeight = 0;
    upperBound = this$static.width_0;
    lowerBound = minWidth;
    viableWidth = this$static.width_0;
    newWidth = (upperBound - lowerBound) / 2 + lowerBound;
    while(lowerBound + 1 < upperBound){
        totalHeight = 0;
        for(block$iterator = new ArrayList$1(this$static.blocks); block$iterator.i < block$iterator.this$01.array.length;){
            block = castTo($next_6(block$iterator), 172);
            totalHeight += (bounds = $placeRectsIn_1(block, newWidth, false), bounds.height);
        }
        if (totalHeight < height) {
            viableWidth = newWidth;
            upperBound = newWidth;
        } else lowerBound = newWidth;
        newWidth = (upperBound - lowerBound) / 2 + lowerBound;
    }
    return viableWidth;
}
function $placeRectsIn_2(this$static, targetWidth) {
    var block, block$iterator, currentHeight, currentWidth, currentY;
    currentY = this$static.y_0;
    currentHeight = 0;
    currentWidth = 0;
    for(block$iterator = new ArrayList$1(this$static.blocks); block$iterator.i < block$iterator.this$01.array.length;){
        block = castTo($next_6(block$iterator), 172);
        $setLocation(block, this$static.x_0, currentY);
        $placeRectsIn(block, targetWidth);
        currentWidth = $wnd.Math.max(currentWidth, block.width_0);
        currentY += block.height + this$static.nodeNodeSpacing;
        currentHeight = currentY;
    }
    this$static.width_0 = currentWidth;
    this$static.height = currentHeight;
}
function $setLocation_0(this$static, x_0, y_0) {
    var block, block$iterator, xDiff, yDiff;
    xDiff = x_0 - this$static.x_0;
    yDiff = y_0 - this$static.y_0;
    for(block$iterator = new ArrayList$1(this$static.blocks); block$iterator.i < block$iterator.this$01.array.length;){
        block = castTo($next_6(block$iterator), 172);
        $setLocation(block, block.x_0 + xDiff, block.y_0 + yDiff);
    }
    this$static.x_0 = x_0;
    this$static.y_0 = y_0;
}
function $updateDimension(this$static) {
    var block, block$iterator, height, index_0, width_0;
    height = 0;
    width_0 = 0;
    index_0 = 0;
    for(block$iterator = new ArrayList$1(this$static.blocks); block$iterator.i < block$iterator.this$01.array.length;){
        block = castTo($next_6(block$iterator), 172);
        width_0 = $wnd.Math.max(width_0, block.width_0);
        height += block.height + (index_0 > 0 ? this$static.nodeNodeSpacing : 0);
        ++index_0;
    }
    this$static.height = height;
    this$static.width_0 = width_0;
}
function BlockStack(x_0, y_0, nodeNodeSpacing) {
    this.blocks = new ArrayList;
    this.x_0 = x_0;
    this.y_0 = y_0;
    this.nodeNodeSpacing = nodeNodeSpacing;
}
defineClass(316, 1, {
    316: 1
}, BlockStack);
_.height = 0;
_.nodeNodeSpacing = 0;
_.width_0 = 0;
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_alg_rectpacking_util_BlockStack_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.util', 'BlockStack', 316);
function $setDrawingHeight(this$static, drawingHeight) {
    this$static.drawingHeight = drawingHeight;
    this$static.drawingWidth > 0 && this$static.drawingHeight > 0 && (this$static.scaleMeasure = computeScaleMeasure(this$static.drawingWidth, this$static.drawingHeight, this$static.dar));
}
function $setDrawingWidth(this$static, drawingWidth) {
    this$static.drawingWidth = drawingWidth;
    this$static.drawingWidth > 0 && this$static.drawingHeight > 0 && (this$static.scaleMeasure = computeScaleMeasure(this$static.drawingWidth, this$static.drawingHeight, this$static.dar));
}
function $setPlacementOption(this$static, placementOption) {
    this$static.placementOption = placementOption;
}
function DrawingData(dar, drawingWidth, drawingHeight, placementOption) {
    DrawingData_0.call(this, dar, drawingWidth, drawingHeight, placementOption, 0, 0);
}
function DrawingData_0(dar, drawingWidth, drawingHeight, placementOption, nextXcoord, nextYcoord) {
    this.dar = dar;
    this.drawingWidth = drawingWidth;
    this.drawingHeight = drawingHeight;
    this.placementOption = placementOption;
    this.nextXcoordinate = nextXcoord;
    this.nextYcoordinate = nextYcoord;
    this.drawingWidth > 0 && this.drawingHeight > 0 && (this.scaleMeasure = computeScaleMeasure(this.drawingWidth, this.drawingHeight, this.dar));
}
defineClass(237, 1, {
    237: 1
}, DrawingData, DrawingData_0);
_.dar = 0;
_.drawingHeight = 0;
_.drawingWidth = 0;
_.nextXcoordinate = 0;
_.nextYcoordinate = 0;
_.scaleMeasure = 0;
var Lorg_eclipse_elk_alg_rectpacking_util_DrawingData_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.util', 'DrawingData', 237);
function $clinit_DrawingDataDescriptor() {
    $clinit_DrawingDataDescriptor = emptyMethod;
    CANDIDATE_POSITION_LAST_PLACED_RIGHT = new DrawingDataDescriptor('CANDIDATE_POSITION_LAST_PLACED_RIGHT', 0);
    CANDIDATE_POSITION_LAST_PLACED_BELOW = new DrawingDataDescriptor('CANDIDATE_POSITION_LAST_PLACED_BELOW', 1);
    CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT = new DrawingDataDescriptor('CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT', 2);
    CANDIDATE_POSITION_WHOLE_DRAWING_BELOW = new DrawingDataDescriptor('CANDIDATE_POSITION_WHOLE_DRAWING_BELOW', 3);
    WHOLE_DRAWING = new DrawingDataDescriptor('WHOLE_DRAWING', 4);
}
function DrawingDataDescriptor(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_83(name_0) {
    $clinit_DrawingDataDescriptor();
    return valueOf(($clinit_DrawingDataDescriptor$Map(), $MAP_73), name_0);
}
function values_91() {
    $clinit_DrawingDataDescriptor();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_util_DrawingDataDescriptor_2_classLit, 1), $intern_36, 366, 0, [
        CANDIDATE_POSITION_LAST_PLACED_RIGHT,
        CANDIDATE_POSITION_LAST_PLACED_BELOW,
        CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT,
        CANDIDATE_POSITION_WHOLE_DRAWING_BELOW,
        WHOLE_DRAWING
    ]);
}
defineClass(366, 23, {
    3: 1,
    34: 1,
    23: 1,
    366: 1
}, DrawingDataDescriptor);
var CANDIDATE_POSITION_LAST_PLACED_BELOW, CANDIDATE_POSITION_LAST_PLACED_RIGHT, CANDIDATE_POSITION_WHOLE_DRAWING_BELOW, CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT, WHOLE_DRAWING;
var Lorg_eclipse_elk_alg_rectpacking_util_DrawingDataDescriptor_2_classLit = createForEnum('org.eclipse.elk.alg.rectpacking.util', 'DrawingDataDescriptor', 366, Ljava_lang_Enum_2_classLit, values_91, valueOf_83);
function $clinit_DrawingDataDescriptor$Map() {
    $clinit_DrawingDataDescriptor$Map = emptyMethod;
    $MAP_73 = createValueOfMap(($clinit_DrawingDataDescriptor(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_rectpacking_util_DrawingDataDescriptor_2_classLit, 1), $intern_36, 366, 0, [
        CANDIDATE_POSITION_LAST_PLACED_RIGHT,
        CANDIDATE_POSITION_LAST_PLACED_BELOW,
        CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT,
        CANDIDATE_POSITION_WHOLE_DRAWING_BELOW,
        WHOLE_DRAWING
    ])));
}
var $MAP_73;
function calculateDimensions(rectangles) {
    var maxHeight, maxWidth, node, node$iterator;
    maxWidth = 0;
    maxHeight = 0;
    for(node$iterator = new AbstractEList$EIterator(rectangles); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        maxWidth = $wnd.Math.max(node.width_0 + node.x_0, maxWidth);
        maxHeight = $wnd.Math.max(node.height + node.y_0, maxHeight);
    }
    return new KVector_1(maxWidth, maxHeight);
}
function calculateDimensions_0(rows_0, nodeNodeSpacing) {
    var index_0, maxWidth, newHeight, row, row$iterator;
    maxWidth = 0;
    newHeight = 0;
    index_0 = 0;
    for(row$iterator = new ArrayList$1(rows_0); row$iterator.i < row$iterator.this$01.array.length;){
        row = castTo($next_6(row$iterator), 186);
        maxWidth = $wnd.Math.max(maxWidth, row.width_0);
        newHeight += row.height + (index_0 > 0 ? nodeNodeSpacing : 0);
        ++index_0;
    }
    return new KVector_1(maxWidth, newHeight);
}
function computeScaleMeasure(width_0, height, dar) {
    return $wnd.Math.min(dar / width_0, 1 / height);
}
function resetCoordinates(graph) {
    var node, node$iterator;
    for(node$iterator = new AbstractEList$EIterator(graph); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        $setX_1(node, 0);
        $setY_2(node, 0);
    }
}
function $addBlock_0(this$static, block) {
    this$static.height = $wnd.Math.max(this$static.height, block.height);
    this$static.width_0 += block.width_0 + (this$static.children.array.length == 0 ? 0 : this$static.nodeNodeSpacing);
    $add_3(this$static.children, block);
}
function $expand_2(this$static, width_0, additionalHeight) {
    var additionalHeightForStack, additionalWidth, additionalWidthPerStack, index_0, stack_0, stack$iterator;
    additionalWidth = width_0 - this$static.width_0;
    additionalWidthPerStack = additionalWidth / this$static.stacks.array.length;
    index_0 = 0;
    for(stack$iterator = new ArrayList$1(this$static.stacks); stack$iterator.i < stack$iterator.this$01.array.length;){
        stack_0 = castTo($next_6(stack$iterator), 316);
        additionalHeightForStack = this$static.height - stack_0.height + additionalHeight;
        $setLocation_0(stack_0, stack_0.x_0 + index_0 * additionalWidthPerStack, stack_0.y_0);
        $expand_1(stack_0, additionalWidthPerStack, additionalHeightForStack);
        ++index_0;
    }
}
function $notifyAboutNodeChange(this$static) {
    var child, child$iterator, index_0, newMaxHeight, totalStackWidth;
    totalStackWidth = 0;
    newMaxHeight = $intern_61;
    index_0 = 0;
    for(child$iterator = new ArrayList$1(this$static.children); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 172);
        totalStackWidth += child.width_0 + (index_0 > 0 ? this$static.nodeNodeSpacing : 0);
        newMaxHeight = $wnd.Math.max(newMaxHeight, child.height);
        ++index_0;
    }
    this$static.width_0 = totalStackWidth;
    this$static.height = newMaxHeight;
}
function $removeBlock(this$static, block) {
    var child, child$iterator, newMaxHeight;
    $remove_12(this$static.children, block);
    this$static.width_0 -= block.width_0 + (this$static.children.array.length == 0 ? 0 : this$static.nodeNodeSpacing);
    newMaxHeight = $intern_126;
    for(child$iterator = new ArrayList$1(this$static.children); child$iterator.i < child$iterator.this$01.array.length;){
        child = castTo($next_6(child$iterator), 172);
        newMaxHeight = $wnd.Math.max(newMaxHeight, child.height);
    }
    this$static.height = newMaxHeight;
}
function $setY_0(this$static, y_0) {
    var stack_0, stack$iterator, yChange;
    yChange = y_0 - this$static.y_0;
    for(stack$iterator = new ArrayList$1(this$static.stacks); stack$iterator.i < stack$iterator.this$01.array.length;){
        stack_0 = castTo($next_6(stack$iterator), 316);
        $setLocation_0(stack_0, stack_0.x_0, stack_0.y_0 + yChange);
    }
    this$static.y_0 = y_0;
}
function RectRow(y_0, nodeNodeSpacing) {
    this.children = new ArrayList;
    this.stacks = new ArrayList;
    this.y_0 = y_0;
    this.nodeNodeSpacing = nodeNodeSpacing;
}
defineClass(186, 1, {
    186: 1
}, RectRow);
_.height = 0;
_.nodeNodeSpacing = 0;
_.width_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_alg_rectpacking_util_RectRow_2_classLit = createForClass('org.eclipse.elk.alg.rectpacking.util', 'RectRow', 186);
function $applyPositions_0(this$static, g) {
    var e, e$iterator, elkNode, endLocation, kedgeSection, maxX, maxY, minX, minY, node, node$iterator, padding, source, startLocation, target, uv, vu;
    minX = $intern_60;
    minY = $intern_60;
    maxX = $intern_61;
    maxY = $intern_61;
    for(node$iterator = new ArrayList$1(g.vertices); node$iterator.i < node$iterator.this$01.array.length;){
        node = castTo($next_6(node$iterator), 68);
        elkNode = castTo(castTo($get_10(this$static.nodeMap, node.originalVertex), 47).second, 27);
        $setLocation_1(elkNode, node.rect.x_0, node.rect.y_0);
        minX = $wnd.Math.min(minX, elkNode.x_0);
        minY = $wnd.Math.min(minY, elkNode.y_0);
        maxX = $wnd.Math.max(maxX, elkNode.x_0 + elkNode.width_0);
        maxY = $wnd.Math.max(maxY, elkNode.y_0 + elkNode.height);
    }
    padding = castTo($getProperty_0(this$static.elkGraph, ($clinit_SporeCompactionOptions(), PADDING_3)), 107);
    resizeNode_1(this$static.elkGraph, maxX - minX + (padding.left + padding.right), maxY - minY + (padding.top_0 + padding.bottom), true, true);
    translate_0(this$static.elkGraph, -minX + padding.left, -minY + padding.top_0);
    for(e$iterator = new AbstractEList$EIterator($getContainedEdges(this$static.elkGraph)); e$iterator.cursor != e$iterator.this$01_2.size_1();){
        e = castTo($doNext(e$iterator), 85);
        kedgeSection = firstEdgeSection(e);
        source = getSourceNode(e);
        target = getTargetNode_0(e);
        startLocation = new KVector_1(source.x_0 + source.width_0 / 2, source.y_0 + source.height / 2);
        endLocation = new KVector_1(target.x_0 + target.width_0 / 2, target.y_0 + target.height / 2);
        uv = $sub_0(new KVector_1(endLocation.x_0, endLocation.y_0), startLocation);
        clipVector(uv, source.width_0, source.height);
        $add_19(startLocation, uv);
        vu = $sub_0(new KVector_1(startLocation.x_0, startLocation.y_0), endLocation);
        clipVector(vu, target.width_0, target.height);
        $add_19(endLocation, vu);
        $setStartLocation(kedgeSection, startLocation.x_0, startLocation.y_0);
        $setEndLocation(kedgeSection, endLocation.x_0, endLocation.y_0);
    }
}
function $importGraph_1(this$static, inputGraph) {
    var adapter, calcu, center, closest, compactionStrategy, costFunction, costFunctionID, distance, elkNode, elkNode$iterator, halfHeight, halfWidth, id_0, margin, node, node$iterator, node$iterator0, preferredRootID, rootSelection, treeConstructionStrategy, vertex;
    this$static.elkGraph = inputGraph;
    this$static.nodeMap = new HashMap;
    adapter = ($clinit_ElkGraphAdapters(), new ElkGraphAdapters$ElkGraphAdapter(this$static.elkGraph));
    calcu = new NodeMarginCalculator(adapter);
    $process(calcu);
    preferredRootID = castToString($getProperty_0(this$static.elkGraph, ($clinit_SporeCompactionOptions(), PROCESSING_ORDER_PREFERRED_ROOT)));
    costFunctionID = castTo($getProperty_0(this$static.elkGraph, PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION), 325);
    treeConstructionStrategy = castTo($getProperty_0(this$static.elkGraph, PROCESSING_ORDER_TREE_CONSTRUCTION), 424);
    compactionStrategy = castTo($getProperty_0(this$static.elkGraph, COMPACTION_COMPACTION_STRATEGY), 475);
    rootSelection = castTo($getProperty_0(this$static.elkGraph, PROCESSING_ORDER_ROOT_SELECTION), 425);
    this$static.spacingNodeNode = $doubleValue(castToDouble($getProperty_0(this$static.elkGraph, SPACING_NODE_NODE_4)));
    costFunction = this$static.centerDistance;
    switch(costFunctionID.ordinal){
        case 0:
            costFunction = this$static.centerDistance;
            break;
        case 1:
            costFunction = this$static.circleUnderlap;
            break;
        case 2:
            costFunction = this$static.rectangleUnderlap;
            break;
        case 3:
            costFunction = this$static.invertedOverlap;
            break;
        case 4:
            costFunction = this$static.minimumRootDistance;
            break;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation available for ' + (costFunctionID.name_0 != null ? costFunctionID.name_0 : '' + costFunctionID.ordinal)));
    }
    this$static.graph_0 = new Graph(costFunction, treeConstructionStrategy, compactionStrategy);
    $setProperty_0(this$static.graph_0, ($clinit_InternalProperties(), DEBUG_SVG), castToBoolean($getProperty_0(this$static.elkGraph, DEBUG_MODE_1)));
    this$static.graph_0.orthogonalCompaction = $booleanValue(castToBoolean($getProperty_0(this$static.elkGraph, COMPACTION_ORTHOGONAL)));
    if ($getChildren(this$static.elkGraph).size_0 == 0) return this$static.graph_0;
    for(elkNode$iterator = new AbstractEList$EIterator($getChildren(this$static.elkGraph)); elkNode$iterator.cursor != elkNode$iterator.this$01_2.size_1();){
        elkNode = castTo($doNext(elkNode$iterator), 27);
        halfWidth = elkNode.width_0 / 2;
        halfHeight = elkNode.height / 2;
        vertex = new KVector_1(elkNode.x_0 + halfWidth, elkNode.y_0 + halfHeight);
        while($containsKey_3(this$static.nodeMap, vertex))$add_18(vertex, ($wnd.Math.random() - 0.5) * $intern_97, ($wnd.Math.random() - 0.5) * $intern_97);
        margin = castTo($getProperty_0(elkNode, ($clinit_CoreOptions(), MARGINS_0)), 139);
        node = new Node_0(vertex, new ElkRectangle_0(vertex.x_0 - halfWidth - this$static.spacingNodeNode / 2 - margin.left, vertex.y_0 - halfHeight - this$static.spacingNodeNode / 2 - margin.top_0, elkNode.width_0 + this$static.spacingNodeNode + (margin.left + margin.right), elkNode.height + this$static.spacingNodeNode + (margin.top_0 + margin.bottom)));
        $add_3(this$static.graph_0.vertices, node);
        $put_6(this$static.nodeMap, vertex, new Pair(node, elkNode));
    }
    switch(rootSelection.ordinal){
        case 0:
            if (preferredRootID == null) this$static.graph_0.preferredRoot = castTo($get_11(this$static.graph_0.vertices, 0), 68);
            else for(node$iterator0 = new ArrayList$1(this$static.graph_0.vertices); node$iterator0.i < node$iterator0.this$01.array.length;){
                node = castTo($next_6(node$iterator0), 68);
                id_0 = castTo(castTo($get_10(this$static.nodeMap, node.originalVertex), 47).second, 27).getIdentifier();
                id_0 != null && $equals_5(id_0, preferredRootID) && (this$static.graph_0.preferredRoot = node);
            }
            break;
        case 1:
            center = new KVector_1(this$static.elkGraph.width_0, this$static.elkGraph.height);
            center.x_0 *= 0.5;
            center.y_0 *= 0.5;
            $add_18(center, this$static.elkGraph.x_0, this$static.elkGraph.y_0);
            closest = $intern_60;
            for(node$iterator = new ArrayList$1(this$static.graph_0.vertices); node$iterator.i < node$iterator.this$01.array.length;){
                node = castTo($next_6(node$iterator), 68);
                distance = $distance_0(node.originalVertex, center);
                if (distance < closest) {
                    closest = distance;
                    this$static.graph_0.preferredRoot = node;
                }
            }
            break;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation available for ' + (rootSelection.name_0 != null ? rootSelection.name_0 : '' + rootSelection.ordinal)));
    }
    return this$static.graph_0;
}
function $lambda$1_7(this$static, e_0) {
    return $wnd.Math.min($distance_0(e_0.u, this$static.graph_0.preferredRoot.vertex), $distance_0(e_0.v, this$static.graph_0.preferredRoot.vertex));
}
function $lambda$2_4(this$static, e_0) {
    var n1, n2;
    n1 = castTo(castTo($get_10(this$static.nodeMap, e_0.u), 47).first, 68);
    n2 = castTo(castTo($get_10(this$static.nodeMap, e_0.v), 47).first, 68);
    return $distance_0(e_0.u, e_0.v) - $distance_0(e_0.u, $getPosition(n1.rect)) - $distance_0(e_0.v, $getPosition(n2.rect));
}
function $lambda$3_3(this$static, e_0) {
    var n1, n2;
    n1 = castTo(castTo($get_10(this$static.nodeMap, e_0.u), 47).first, 68);
    n2 = castTo(castTo($get_10(this$static.nodeMap, e_0.v), 47).first, 68);
    return $underlap(n1, n2);
}
function $lambda$4_2(this$static, e_0) {
    var dist, n1, n2, r1, r2, s;
    n1 = castTo(castTo($get_10(this$static.nodeMap, e_0.u), 47).first, 68);
    n2 = castTo(castTo($get_10(this$static.nodeMap, e_0.v), 47).first, 68);
    r1 = n1.rect;
    r2 = n2.rect;
    dist = shortestDistance(r1, r2);
    if (dist >= 0) return dist;
    s = $length($sub_0(new KVector_1(r2.x_0 + r2.width_0 / 2, r2.y_0 + r2.height / 2), new KVector_1(r1.x_0 + r1.width_0 / 2, r1.y_0 + r1.height / 2)));
    return -(overlap_0(r1, r2) - 1) * s;
}
function $updateGraph(this$static, g) {
    var n, n$iterator, original, updatedNodeMap;
    updatedNodeMap = new HashMap;
    g.tEdges = null;
    g.tree = null;
    for(n$iterator = new ArrayList$1(g.vertices); n$iterator.i < n$iterator.this$01.array.length;){
        n = castTo($next_6(n$iterator), 68);
        original = castTo($get_10(this$static.nodeMap, n.originalVertex), 47);
        n.originalVertex = $getCenter(n.rect);
        $put_6(updatedNodeMap, n.originalVertex, original);
    }
    this$static.nodeMap = updatedNodeMap;
}
function ElkGraphImporter_0() {
    this.centerDistance = new ElkGraphImporter$lambda$0$Type_1;
    this.minimumRootDistance = new ElkGraphImporter$lambda$1$Type_0(this);
    this.circleUnderlap = new ElkGraphImporter$lambda$2$Type_0(this);
    this.rectangleUnderlap = new ElkGraphImporter$lambda$3$Type(this);
    this.invertedOverlap = new ElkGraphImporter$lambda$4$Type_0(this);
}
defineClass(745, 1, {}, ElkGraphImporter_0);
_.spacingNodeNode = 0;
var Lorg_eclipse_elk_alg_spore_ElkGraphImporter_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ElkGraphImporter', 745);
function ElkGraphImporter$lambda$0$Type_1() {}
defineClass(1169, 1, {}, ElkGraphImporter$lambda$0$Type_1);
_.cost = function cost(arg0) {
    return $distance_0(arg0.u, arg0.v);
};
var Lorg_eclipse_elk_alg_spore_ElkGraphImporter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ElkGraphImporter/lambda$0$Type', 1169);
function ElkGraphImporter$lambda$1$Type_0($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1170, 1, {}, ElkGraphImporter$lambda$1$Type_0);
_.cost = function cost_0(arg0) {
    return $lambda$1_7(this.$$outer_0, arg0);
};
var Lorg_eclipse_elk_alg_spore_ElkGraphImporter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ElkGraphImporter/lambda$1$Type', 1170);
function ElkGraphImporter$lambda$2$Type_0($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1171, 1, {}, ElkGraphImporter$lambda$2$Type_0);
_.cost = function cost_1(arg0) {
    return $lambda$2_4(this.$$outer_0, arg0);
};
var Lorg_eclipse_elk_alg_spore_ElkGraphImporter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ElkGraphImporter/lambda$2$Type', 1171);
function ElkGraphImporter$lambda$3$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1172, 1, {}, ElkGraphImporter$lambda$3$Type);
_.cost = function cost_2(arg0) {
    return $lambda$3_3(this.$$outer_0, arg0);
};
var Lorg_eclipse_elk_alg_spore_ElkGraphImporter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ElkGraphImporter/lambda$3$Type', 1172);
function ElkGraphImporter$lambda$4$Type_0($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1173, 1, {}, ElkGraphImporter$lambda$4$Type_0);
_.cost = function cost_3(arg0) {
    return $lambda$4_2(this.$$outer_0, arg0);
};
var Lorg_eclipse_elk_alg_spore_ElkGraphImporter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ElkGraphImporter/lambda$4$Type', 1173);
function OverlapRemovalLayoutProvider() {
    this.algorithmAssembler = new AlgorithmAssembler(Lorg_eclipse_elk_alg_spore_SPOrEPhases_2_classLit);
}
function lambda$0_37(overlapEdges_0, n1_1, n2_2) {
    return $add_6(overlapEdges_0, new TEdge(n1_1.originalVertex, n2_2.originalVertex));
}
defineClass(1079, 222, $intern_96, OverlapRemovalLayoutProvider);
_.layout = function layout_5(layoutGraph, progressMonitor) {
    var graph, graphImporter, iteration, lad, layoutProvider, maxIterations, overlapEdges, overlapHandler, overlapsExisted, processor, processor$iterator, requestedAlgorithm;
    if ($hasProperty_0(layoutGraph, ($clinit_SporeCompactionOptions(), UNDERLYING_LAYOUT_ALGORITHM))) {
        requestedAlgorithm = castToString($getProperty_0(layoutGraph, ($clinit_SporeOverlapRemovalOptions(), UNDERLYING_LAYOUT_ALGORITHM_1)));
        lad = $getAlgorithmDataBySuffix(getInstance(), requestedAlgorithm);
        if (lad) {
            layoutProvider = castTo($fetch(lad.providerPool), 222);
            layoutProvider.layout(layoutGraph, progressMonitor.subTask(1));
        }
    }
    $setProperty_1(layoutGraph, PROCESSING_ORDER_ROOT_SELECTION, ($clinit_RootSelection(), CENTER_NODE));
    $setProperty_1(layoutGraph, PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION, ($clinit_SpanningTreeCostFunction(), INVERTED_OVERLAP));
    $setProperty_1(layoutGraph, PROCESSING_ORDER_TREE_CONSTRUCTION, ($clinit_TreeConstructionStrategy(), MINIMUM_SPANNING_TREE));
    maxIterations = castTo($getProperty_0(layoutGraph, ($clinit_SporeOverlapRemovalOptions(), OVERLAP_REMOVAL_MAX_ITERATIONS_0)), 17).value_0;
    progressMonitor.begin('Overlap removal', 1);
    $booleanValue(castToBoolean($getProperty_0(layoutGraph, DEBUG_MODE_2)));
    overlapEdges = new HashSet;
    overlapHandler = new OverlapRemovalLayoutProvider$lambda$0$Type(overlapEdges);
    graphImporter = new ElkGraphImporter_0;
    graph = $importGraph_1(graphImporter, layoutGraph);
    overlapsExisted = true;
    iteration = 0;
    while(iteration < maxIterations && overlapsExisted){
        if ($booleanValue(castToBoolean($getProperty_0(layoutGraph, OVERLAP_REMOVAL_RUN_SCANLINE_0)))) {
            overlapEdges.map_0.clear_0();
            $sweep_0(new ScanlineOverlapCheck(overlapHandler), graph.vertices);
            if (overlapEdges.map_0.size_1() == 0) break;
            graph.tEdges = overlapEdges;
        }
        $reset_4(this.algorithmAssembler);
        $setPhase(this.algorithmAssembler, ($clinit_SPOrEPhases(), P1_STRUCTURE), ($clinit_StructureExtractionStrategy(), DELAUNAY_TRIANGULATION));
        $setPhase(this.algorithmAssembler, P2_PROCESSING_ORDER, graph.treeConstructionStrategy);
        $setPhase(this.algorithmAssembler, P3_EXECUTION, ($clinit_OverlapRemovalStrategy(), GROW_TREE));
        this.algorithm = $build_0(this.algorithmAssembler, graph);
        for(processor$iterator = new ArrayList$1(this.algorithm); processor$iterator.i < processor$iterator.this$01.array.length;){
            processor = castTo($next_6(processor$iterator), 44);
            processor.process(graph, progressMonitor.subTask(1));
        }
        $updateGraph(graphImporter, graph);
        overlapsExisted = $booleanValue(castToBoolean($getProperty(graph, ($clinit_InternalProperties(), OVERLAPS_EXISTED))));
        ++iteration;
    }
    $applyPositions_0(graphImporter, graph);
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_spore_OverlapRemovalLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'OverlapRemovalLayoutProvider', 1079);
function $handle_4(this$static, arg0, arg1) {
    lambda$0_37(this$static.overlapEdges_0, arg0, arg1);
}
function OverlapRemovalLayoutProvider$lambda$0$Type(overlapEdges_0) {
    this.overlapEdges_0 = overlapEdges_0;
}
defineClass(1080, 1, {}, OverlapRemovalLayoutProvider$lambda$0$Type);
var Lorg_eclipse_elk_alg_spore_OverlapRemovalLayoutProvider$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'OverlapRemovalLayoutProvider/lambda$0$Type', 1080);
function $clinit_SPOrEPhases() {
    $clinit_SPOrEPhases = emptyMethod;
    P1_STRUCTURE = new SPOrEPhases('P1_STRUCTURE', 0);
    P2_PROCESSING_ORDER = new SPOrEPhases('P2_PROCESSING_ORDER', 1);
    P3_EXECUTION = new SPOrEPhases('P3_EXECUTION', 2);
}
function SPOrEPhases(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_84(name_0) {
    $clinit_SPOrEPhases();
    return valueOf(($clinit_SPOrEPhases$Map(), $MAP_74), name_0);
}
function values_92() {
    $clinit_SPOrEPhases();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_SPOrEPhases_2_classLit, 1), $intern_36, 432, 0, [
        P1_STRUCTURE,
        P2_PROCESSING_ORDER,
        P3_EXECUTION
    ]);
}
defineClass(432, 23, {
    3: 1,
    34: 1,
    23: 1,
    432: 1
}, SPOrEPhases);
var P1_STRUCTURE, P2_PROCESSING_ORDER, P3_EXECUTION;
var Lorg_eclipse_elk_alg_spore_SPOrEPhases_2_classLit = createForEnum('org.eclipse.elk.alg.spore', 'SPOrEPhases', 432, Ljava_lang_Enum_2_classLit, values_92, valueOf_84);
function $clinit_SPOrEPhases$Map() {
    $clinit_SPOrEPhases$Map = emptyMethod;
    $MAP_74 = createValueOfMap(($clinit_SPOrEPhases(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_SPOrEPhases_2_classLit, 1), $intern_36, 432, 0, [
        P1_STRUCTURE,
        P2_PROCESSING_ORDER,
        P3_EXECUTION
    ])));
}
var $MAP_74;
function $shrink(this$static, graph, progressMonitor) {
    var processor, processor$iterator;
    $reset_4(this$static.algorithmAssembler);
    $setPhase(this$static.algorithmAssembler, ($clinit_SPOrEPhases(), P1_STRUCTURE), ($clinit_StructureExtractionStrategy(), DELAUNAY_TRIANGULATION));
    $setPhase(this$static.algorithmAssembler, P2_PROCESSING_ORDER, graph.treeConstructionStrategy);
    $setPhase(this$static.algorithmAssembler, P3_EXECUTION, graph.compactionStrategy);
    this$static.algorithm = $build_0(this$static.algorithmAssembler, graph);
    progressMonitor.begin('Compaction by shrinking a tree', this$static.algorithm.array.length);
    if (graph.vertices.array.length > 1) for(processor$iterator = new ArrayList$1(this$static.algorithm); processor$iterator.i < processor$iterator.this$01.array.length;){
        processor = castTo($next_6(processor$iterator), 44);
        processor.process(graph, progressMonitor.subTask(1));
    }
    progressMonitor.done_1();
}
function ShrinkTree() {
    this.algorithmAssembler = new AlgorithmAssembler(Lorg_eclipse_elk_alg_spore_SPOrEPhases_2_classLit);
}
defineClass(1179, 1, {}, ShrinkTree);
var Lorg_eclipse_elk_alg_spore_ShrinkTree_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ShrinkTree', 1179);
function ShrinkTreeLayoutProvider() {
    this.shrinktree = new ShrinkTree;
}
defineClass(1081, 222, $intern_96, ShrinkTreeLayoutProvider);
_.layout = function layout_6(layoutGraph, progressMonitor) {
    var graph, graphImporter, lad, layoutProvider, requestedAlgorithm;
    if ($hasProperty_0(layoutGraph, ($clinit_SporeCompactionOptions(), UNDERLYING_LAYOUT_ALGORITHM))) {
        requestedAlgorithm = castToString($getProperty_0(layoutGraph, UNDERLYING_LAYOUT_ALGORITHM));
        lad = $getAlgorithmDataBySuffix(getInstance(), requestedAlgorithm);
        if (lad) {
            layoutProvider = castTo($fetch(lad.providerPool), 222);
            layoutProvider.layout(layoutGraph, progressMonitor.subTask(1));
        }
    }
    graphImporter = new ElkGraphImporter_0;
    graph = $importGraph_1(graphImporter, layoutGraph);
    $shrink(this.shrinktree, graph, progressMonitor.subTask(1));
    $applyPositions_0(graphImporter, graph);
};
var Lorg_eclipse_elk_alg_spore_ShrinkTreeLayoutProvider_2_classLit = createForClass('org.eclipse.elk.alg.spore', 'ShrinkTreeLayoutProvider', 1081);
function Graph(costFun, treeStrategy, compStrategy) {
    this.vertices = new ArrayList;
    this.costFunction = costFun;
    this.treeConstructionStrategy = treeStrategy;
    this.compactionStrategy = compStrategy;
}
defineClass(307, 148, {
    3: 1,
    307: 1,
    102: 1,
    148: 1
}, Graph);
_.orthogonalCompaction = false;
var Lorg_eclipse_elk_alg_spore_graph_Graph_2_classLit = createForClass('org.eclipse.elk.alg.spore.graph', 'Graph', 307);
function $clinit_CompactionStrategy_0() {
    $clinit_CompactionStrategy_0 = emptyMethod;
    DEPTH_FIRST_0 = new CompactionStrategy_0;
}
function $create_17(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new ShrinkTreeCompactionPhase;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation available for ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function CompactionStrategy_0() {
    Enum.call(this, 'DEPTH_FIRST', 0);
}
function valueOf_85(name_0) {
    $clinit_CompactionStrategy_0();
    return valueOf(($clinit_CompactionStrategy$Map_0(), $MAP_75), name_0);
}
function values_93() {
    $clinit_CompactionStrategy_0();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_CompactionStrategy_2_classLit, 1), $intern_36, 475, 0, [
        DEPTH_FIRST_0
    ]);
}
defineClass(475, 23, {
    3: 1,
    34: 1,
    23: 1,
    475: 1,
    188: 1,
    196: 1
}, CompactionStrategy_0);
_.create_1 = function create_34() {
    return $create_17(this);
};
_.create_2 = function create_33() {
    return $create_17(this);
};
var DEPTH_FIRST_0;
var Lorg_eclipse_elk_alg_spore_options_CompactionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.spore.options', 'CompactionStrategy', 475, Ljava_lang_Enum_2_classLit, values_93, valueOf_85);
function $clinit_CompactionStrategy$Map_0() {
    $clinit_CompactionStrategy$Map_0 = emptyMethod;
    $MAP_75 = createValueOfMap(($clinit_CompactionStrategy_0(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_CompactionStrategy_2_classLit, 1), $intern_36, 475, 0, [
        DEPTH_FIRST_0
    ])));
}
var $MAP_75;
function $clinit_OverlapRemovalStrategy() {
    $clinit_OverlapRemovalStrategy = emptyMethod;
    GROW_TREE = new OverlapRemovalStrategy;
}
function OverlapRemovalStrategy() {
    Enum.call(this, 'GROW_TREE', 0);
}
function valueOf_86(name_0) {
    $clinit_OverlapRemovalStrategy();
    return valueOf(($clinit_OverlapRemovalStrategy$Map(), $MAP_76), name_0);
}
function values_94() {
    $clinit_OverlapRemovalStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_OverlapRemovalStrategy_2_classLit, 1), $intern_36, 543, 0, [
        GROW_TREE
    ]);
}
defineClass(543, 23, {
    3: 1,
    34: 1,
    23: 1,
    543: 1,
    188: 1,
    196: 1
}, OverlapRemovalStrategy);
_.create_1 = function create_36() {
    return new GrowTreePhase;
};
_.create_2 = function create_35() {
    return new GrowTreePhase;
};
var GROW_TREE;
var Lorg_eclipse_elk_alg_spore_options_OverlapRemovalStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.spore.options', 'OverlapRemovalStrategy', 543, Ljava_lang_Enum_2_classLit, values_94, valueOf_86);
function $clinit_OverlapRemovalStrategy$Map() {
    $clinit_OverlapRemovalStrategy$Map = emptyMethod;
    $MAP_76 = createValueOfMap(($clinit_OverlapRemovalStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_OverlapRemovalStrategy_2_classLit, 1), $intern_36, 543, 0, [
        GROW_TREE
    ])));
}
var $MAP_76;
function $clinit_RootSelection() {
    $clinit_RootSelection = emptyMethod;
    FIXED_1 = new RootSelection('FIXED', 0);
    CENTER_NODE = new RootSelection('CENTER_NODE', 1);
}
function RootSelection(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_87(name_0) {
    $clinit_RootSelection();
    return valueOf(($clinit_RootSelection$Map(), $MAP_77), name_0);
}
function values_95() {
    $clinit_RootSelection();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_RootSelection_2_classLit, 1), $intern_36, 425, 0, [
        FIXED_1,
        CENTER_NODE
    ]);
}
defineClass(425, 23, {
    3: 1,
    34: 1,
    23: 1,
    425: 1
}, RootSelection);
var CENTER_NODE, FIXED_1;
var Lorg_eclipse_elk_alg_spore_options_RootSelection_2_classLit = createForEnum('org.eclipse.elk.alg.spore.options', 'RootSelection', 425, Ljava_lang_Enum_2_classLit, values_95, valueOf_87);
function $clinit_RootSelection$Map() {
    $clinit_RootSelection$Map = emptyMethod;
    $MAP_77 = createValueOfMap(($clinit_RootSelection(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_RootSelection_2_classLit, 1), $intern_36, 425, 0, [
        FIXED_1,
        CENTER_NODE
    ])));
}
var $MAP_77;
function $clinit_SpanningTreeCostFunction() {
    $clinit_SpanningTreeCostFunction = emptyMethod;
    CENTER_DISTANCE = new SpanningTreeCostFunction('CENTER_DISTANCE', 0);
    CIRCLE_UNDERLAP = new SpanningTreeCostFunction('CIRCLE_UNDERLAP', 1);
    RECTANGLE_UNDERLAP = new SpanningTreeCostFunction('RECTANGLE_UNDERLAP', 2);
    INVERTED_OVERLAP = new SpanningTreeCostFunction('INVERTED_OVERLAP', 3);
    MINIMUM_ROOT_DISTANCE = new SpanningTreeCostFunction('MINIMUM_ROOT_DISTANCE', 4);
}
function SpanningTreeCostFunction(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_88(name_0) {
    $clinit_SpanningTreeCostFunction();
    return valueOf(($clinit_SpanningTreeCostFunction$Map(), $MAP_78), name_0);
}
function values_96() {
    $clinit_SpanningTreeCostFunction();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_SpanningTreeCostFunction_2_classLit, 1), $intern_36, 325, 0, [
        CENTER_DISTANCE,
        CIRCLE_UNDERLAP,
        RECTANGLE_UNDERLAP,
        INVERTED_OVERLAP,
        MINIMUM_ROOT_DISTANCE
    ]);
}
defineClass(325, 23, {
    3: 1,
    34: 1,
    23: 1,
    325: 1
}, SpanningTreeCostFunction);
var CENTER_DISTANCE, CIRCLE_UNDERLAP, INVERTED_OVERLAP, MINIMUM_ROOT_DISTANCE, RECTANGLE_UNDERLAP;
var Lorg_eclipse_elk_alg_spore_options_SpanningTreeCostFunction_2_classLit = createForEnum('org.eclipse.elk.alg.spore.options', 'SpanningTreeCostFunction', 325, Ljava_lang_Enum_2_classLit, values_96, valueOf_88);
function $clinit_SpanningTreeCostFunction$Map() {
    $clinit_SpanningTreeCostFunction$Map = emptyMethod;
    $MAP_78 = createValueOfMap(($clinit_SpanningTreeCostFunction(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_SpanningTreeCostFunction_2_classLit, 1), $intern_36, 325, 0, [
        CENTER_DISTANCE,
        CIRCLE_UNDERLAP,
        RECTANGLE_UNDERLAP,
        INVERTED_OVERLAP,
        MINIMUM_ROOT_DISTANCE
    ])));
}
var $MAP_78;
function $clinit_SporeCompactionOptions() {
    $clinit_SporeCompactionOptions = emptyMethod;
    UNDERLYING_LAYOUT_ALGORITHM = ($clinit_SporeMetaDataProvider(), UNDERLYING_LAYOUT_ALGORITHM_0);
    PROCESSING_ORDER_TREE_CONSTRUCTION = PROCESSING_ORDER_TREE_CONSTRUCTION_0;
    PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION = PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_0;
    PROCESSING_ORDER_PREFERRED_ROOT = PROCESSING_ORDER_PREFERRED_ROOT_0;
    PROCESSING_ORDER_ROOT_SELECTION = PROCESSING_ORDER_ROOT_SELECTION_0;
    PADDING_DEFAULT_3 = new ElkPadding_0(8);
    PADDING_3 = new Property_2(($clinit_CoreOptions(), PADDING_5), PADDING_DEFAULT_3);
    SPACING_NODE_NODE_4 = new Property_2(SPACING_NODE_NODE_6, 8);
    STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY = STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_0;
    COMPACTION_COMPACTION_STRATEGY = COMPACTION_COMPACTION_STRATEGY_0;
    COMPACTION_ORTHOGONAL = COMPACTION_ORTHOGONAL_0;
    DEBUG_MODE_1 = new Property_2(DEBUG_MODE_3, ($clinit_Boolean(), false));
}
function $apply_13(registry) {
    $register(registry, new LayoutAlgorithmData($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.sporeCompaction'), 'ELK SPOrE Compaction'), 'ShrinkTree is a compaction algorithm that maintains the topology of a layout. The relocation of diagram elements is based on contracting a spanning tree.'), new SporeCompactionOptions$SporeCompactionFactory)));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.underlyingLayoutAlgorithm', $getDefault(UNDERLYING_LAYOUT_ALGORITHM));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.processingOrder.treeConstruction', $getDefault(PROCESSING_ORDER_TREE_CONSTRUCTION));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.processingOrder.spanningTreeCostFunction', $getDefault(PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.processingOrder.preferredRoot', $getDefault(PROCESSING_ORDER_PREFERRED_ROOT));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.processingOrder.rootSelection', $getDefault(PROCESSING_ORDER_ROOT_SELECTION));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.padding', PADDING_DEFAULT_3);
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.spacing.nodeNode', 8);
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.structure.structureExtractionStrategy', $getDefault(STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.compaction.compactionStrategy', $getDefault(COMPACTION_COMPACTION_STRATEGY));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.compaction.orthogonal', $getDefault(COMPACTION_ORTHOGONAL));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeCompaction', 'org.eclipse.elk.debugMode', ($clinit_Boolean(), false));
}
function SporeCompactionOptions() {
    $clinit_SporeCompactionOptions();
}
defineClass(989, 1, $intern_98, SporeCompactionOptions);
_.apply_4 = function apply_147(registry) {
    $apply_13(registry);
};
var COMPACTION_COMPACTION_STRATEGY, COMPACTION_ORTHOGONAL, DEBUG_MODE_1, PADDING_3, PADDING_DEFAULT_3, PROCESSING_ORDER_PREFERRED_ROOT, PROCESSING_ORDER_ROOT_SELECTION, PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION, PROCESSING_ORDER_TREE_CONSTRUCTION, SPACING_NODE_NODE_4, STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY, UNDERLYING_LAYOUT_ALGORITHM;
var Lorg_eclipse_elk_alg_spore_options_SporeCompactionOptions_2_classLit = createForClass('org.eclipse.elk.alg.spore.options', 'SporeCompactionOptions', 989);
function SporeCompactionOptions$SporeCompactionFactory() {}
defineClass(990, 1, {}, SporeCompactionOptions$SporeCompactionFactory);
_.create_0 = function create_37() {
    var provider;
    return provider = new ShrinkTreeLayoutProvider, provider;
};
_.destroy = function destroy_5(obj) {};
var Lorg_eclipse_elk_alg_spore_options_SporeCompactionOptions$SporeCompactionFactory_2_classLit = createForClass('org.eclipse.elk.alg.spore.options', 'SporeCompactionOptions/SporeCompactionFactory', 990);
function $clinit_SporeMetaDataProvider() {
    $clinit_SporeMetaDataProvider = emptyMethod;
    UNDERLYING_LAYOUT_ALGORITHM_0 = new Property('org.eclipse.elk.underlyingLayoutAlgorithm');
    STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_DEFAULT = ($clinit_StructureExtractionStrategy(), DELAUNAY_TRIANGULATION);
    STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_0 = new Property_1('org.eclipse.elk.structure.structureExtractionStrategy', STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_DEFAULT);
    PROCESSING_ORDER_TREE_CONSTRUCTION_DEFAULT = ($clinit_TreeConstructionStrategy(), MINIMUM_SPANNING_TREE);
    PROCESSING_ORDER_TREE_CONSTRUCTION_0 = new Property_1('org.eclipse.elk.processingOrder.treeConstruction', PROCESSING_ORDER_TREE_CONSTRUCTION_DEFAULT);
    PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_DEFAULT = ($clinit_SpanningTreeCostFunction(), CIRCLE_UNDERLAP);
    PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_0 = new Property_1('org.eclipse.elk.processingOrder.spanningTreeCostFunction', PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_DEFAULT);
    PROCESSING_ORDER_PREFERRED_ROOT_0 = new Property_1('org.eclipse.elk.processingOrder.preferredRoot', null);
    PROCESSING_ORDER_ROOT_SELECTION_DEFAULT = ($clinit_RootSelection(), CENTER_NODE);
    PROCESSING_ORDER_ROOT_SELECTION_0 = new Property_1('org.eclipse.elk.processingOrder.rootSelection', PROCESSING_ORDER_ROOT_SELECTION_DEFAULT);
    COMPACTION_COMPACTION_STRATEGY_DEFAULT = ($clinit_CompactionStrategy_0(), DEPTH_FIRST_0);
    COMPACTION_COMPACTION_STRATEGY_0 = new Property_1('org.eclipse.elk.compaction.compactionStrategy', COMPACTION_COMPACTION_STRATEGY_DEFAULT);
    COMPACTION_ORTHOGONAL_0 = new Property_1('org.eclipse.elk.compaction.orthogonal', ($clinit_Boolean(), false));
    OVERLAP_REMOVAL_MAX_ITERATIONS = new Property_1('org.eclipse.elk.overlapRemoval.maxIterations', valueOf_3(64));
    OVERLAP_REMOVAL_RUN_SCANLINE = new Property_1('org.eclipse.elk.overlapRemoval.runScanline', true);
    PROCESSING_ORDER_PREFERRED_ROOT_DEP_PROCESSING_ORDER_ROOT_SELECTION_0 = FIXED_1;
}
function SporeMetaDataProvider() {
    $clinit_SporeMetaDataProvider();
}
defineClass(843, 1, $intern_98, SporeMetaDataProvider);
_.apply_4 = function apply_148(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.underlyingLayoutAlgorithm'), ''), 'Underlying Layout Algorithm'), 'A layout algorithm that is applied to the graph before it is compacted. If this is null, nothing is applied before compaction.'), ($clinit_LayoutOptionData$Type(), STRING)), Ljava_lang_String_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.structure.structureExtractionStrategy'), 'structure'), 'Structure Extraction Strategy'), 'This option defines what kind of triangulation or other partitioning of the plane is applied to the vertices.'), STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_spore_options_StructureExtractionStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.processingOrder.treeConstruction'), 'processingOrder'), 'Tree Construction Strategy'), 'Whether a minimum spanning tree or a maximum spanning tree should be constructed.'), PROCESSING_ORDER_TREE_CONSTRUCTION_DEFAULT), ENUM), Lorg_eclipse_elk_alg_spore_options_TreeConstructionStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.processingOrder.spanningTreeCostFunction'), 'processingOrder'), 'Cost Function for Spanning Tree'), 'The cost function is used in the creation of the spanning tree.'), PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_DEFAULT), ENUM), Lorg_eclipse_elk_alg_spore_options_SpanningTreeCostFunction_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.processingOrder.preferredRoot'), 'processingOrder'), 'Root node for spanning tree construction'), 'The identifier of the node that is preferred as the root of the spanning tree. If this is null, the first node is chosen.'), null), STRING), Ljava_lang_String_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.processingOrder.preferredRoot', 'org.eclipse.elk.processingOrder.rootSelection', PROCESSING_ORDER_PREFERRED_ROOT_DEP_PROCESSING_ORDER_ROOT_SELECTION_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.processingOrder.rootSelection'), 'processingOrder'), 'Root selection for spanning tree'), 'This sets the method used to select a root node for the construction of a spanning tree'), PROCESSING_ORDER_ROOT_SELECTION_DEFAULT), ENUM), Lorg_eclipse_elk_alg_spore_options_RootSelection_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.compaction.compactionStrategy'), 'compaction'), 'Compaction Strategy'), 'This option defines how the compaction is applied.'), COMPACTION_COMPACTION_STRATEGY_DEFAULT), ENUM), Lorg_eclipse_elk_alg_spore_options_CompactionStrategy_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.compaction.orthogonal'), 'compaction'), 'Orthogonal Compaction'), 'Restricts the translation of nodes to orthogonal directions in the compaction phase.'), ($clinit_Boolean(), false)), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.overlapRemoval.maxIterations'), 'overlapRemoval'), 'Upper limit for iterations of overlap removal'), null), valueOf_3(64)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.overlapRemoval.runScanline'), 'overlapRemoval'), 'Whether to run a supplementary scanline overlap check.'), null), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $apply_14((new SporeOverlapRemovalOptions, registry));
    $apply_13((new SporeCompactionOptions, registry));
};
var COMPACTION_COMPACTION_STRATEGY_0, COMPACTION_COMPACTION_STRATEGY_DEFAULT, COMPACTION_ORTHOGONAL_0, OVERLAP_REMOVAL_MAX_ITERATIONS, OVERLAP_REMOVAL_RUN_SCANLINE, PROCESSING_ORDER_PREFERRED_ROOT_0, PROCESSING_ORDER_PREFERRED_ROOT_DEP_PROCESSING_ORDER_ROOT_SELECTION_0, PROCESSING_ORDER_ROOT_SELECTION_0, PROCESSING_ORDER_ROOT_SELECTION_DEFAULT, PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_0, PROCESSING_ORDER_SPANNING_TREE_COST_FUNCTION_DEFAULT, PROCESSING_ORDER_TREE_CONSTRUCTION_0, PROCESSING_ORDER_TREE_CONSTRUCTION_DEFAULT, STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_0, STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_DEFAULT, UNDERLYING_LAYOUT_ALGORITHM_0;
var Lorg_eclipse_elk_alg_spore_options_SporeMetaDataProvider_2_classLit = createForClass('org.eclipse.elk.alg.spore.options', 'SporeMetaDataProvider', 843);
function $clinit_SporeOverlapRemovalOptions() {
    $clinit_SporeOverlapRemovalOptions = emptyMethod;
    UNDERLYING_LAYOUT_ALGORITHM_1 = ($clinit_SporeMetaDataProvider(), UNDERLYING_LAYOUT_ALGORITHM_0);
    PADDING_DEFAULT_4 = new ElkPadding_0(8);
    new Property_2(($clinit_CoreOptions(), PADDING_5), PADDING_DEFAULT_4);
    new Property_2(SPACING_NODE_NODE_6, 8);
    STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_1 = STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_0;
    OVERLAP_REMOVAL_MAX_ITERATIONS_0 = OVERLAP_REMOVAL_MAX_ITERATIONS;
    OVERLAP_REMOVAL_RUN_SCANLINE_0 = OVERLAP_REMOVAL_RUN_SCANLINE;
    DEBUG_MODE_2 = new Property_2(DEBUG_MODE_3, ($clinit_Boolean(), false));
}
function $apply_14(registry) {
    $register(registry, new LayoutAlgorithmData($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.sporeOverlap'), 'ELK SPOrE Overlap Removal'), 'A node overlap removal algorithm proposed by Nachmanson et al. in "Node overlap removal by growing a tree".'), new SporeOverlapRemovalOptions$SporeOverlapFactory)));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.underlyingLayoutAlgorithm', $getDefault(UNDERLYING_LAYOUT_ALGORITHM_1));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.padding', PADDING_DEFAULT_4);
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.spacing.nodeNode', 8);
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.structure.structureExtractionStrategy', $getDefault(STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_1));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.overlapRemoval.maxIterations', $getDefault(OVERLAP_REMOVAL_MAX_ITERATIONS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.overlapRemoval.runScanline', $getDefault(OVERLAP_REMOVAL_RUN_SCANLINE_0));
    $addOptionSupport(registry, 'org.eclipse.elk.sporeOverlap', 'org.eclipse.elk.debugMode', ($clinit_Boolean(), false));
}
function SporeOverlapRemovalOptions() {
    $clinit_SporeOverlapRemovalOptions();
}
defineClass(987, 1, $intern_98, SporeOverlapRemovalOptions);
_.apply_4 = function apply_149(registry) {
    $apply_14(registry);
};
var DEBUG_MODE_2, OVERLAP_REMOVAL_MAX_ITERATIONS_0, OVERLAP_REMOVAL_RUN_SCANLINE_0, PADDING_DEFAULT_4, STRUCTURE_STRUCTURE_EXTRACTION_STRATEGY_1, UNDERLYING_LAYOUT_ALGORITHM_1;
var Lorg_eclipse_elk_alg_spore_options_SporeOverlapRemovalOptions_2_classLit = createForClass('org.eclipse.elk.alg.spore.options', 'SporeOverlapRemovalOptions', 987);
function SporeOverlapRemovalOptions$SporeOverlapFactory() {}
defineClass(988, 1, {}, SporeOverlapRemovalOptions$SporeOverlapFactory);
_.create_0 = function create_38() {
    var provider;
    return provider = new OverlapRemovalLayoutProvider, provider;
};
_.destroy = function destroy_6(obj) {};
var Lorg_eclipse_elk_alg_spore_options_SporeOverlapRemovalOptions$SporeOverlapFactory_2_classLit = createForClass('org.eclipse.elk.alg.spore.options', 'SporeOverlapRemovalOptions/SporeOverlapFactory', 988);
function $clinit_StructureExtractionStrategy() {
    $clinit_StructureExtractionStrategy = emptyMethod;
    DELAUNAY_TRIANGULATION = new StructureExtractionStrategy;
}
function $create_18(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new DelaunayTriangulationPhase;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation available for ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function StructureExtractionStrategy() {
    Enum.call(this, 'DELAUNAY_TRIANGULATION', 0);
}
function valueOf_89(name_0) {
    $clinit_StructureExtractionStrategy();
    return valueOf(($clinit_StructureExtractionStrategy$Map(), $MAP_79), name_0);
}
function values_97() {
    $clinit_StructureExtractionStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_StructureExtractionStrategy_2_classLit, 1), $intern_36, 524, 0, [
        DELAUNAY_TRIANGULATION
    ]);
}
defineClass(524, 23, {
    3: 1,
    34: 1,
    23: 1,
    524: 1,
    188: 1,
    196: 1
}, StructureExtractionStrategy);
_.create_1 = function create_40() {
    return $create_18(this);
};
_.create_2 = function create_39() {
    return $create_18(this);
};
var DELAUNAY_TRIANGULATION;
var Lorg_eclipse_elk_alg_spore_options_StructureExtractionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.spore.options', 'StructureExtractionStrategy', 524, Ljava_lang_Enum_2_classLit, values_97, valueOf_89);
function $clinit_StructureExtractionStrategy$Map() {
    $clinit_StructureExtractionStrategy$Map = emptyMethod;
    $MAP_79 = createValueOfMap(($clinit_StructureExtractionStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_StructureExtractionStrategy_2_classLit, 1), $intern_36, 524, 0, [
        DELAUNAY_TRIANGULATION
    ])));
}
var $MAP_79;
function $clinit_TreeConstructionStrategy() {
    $clinit_TreeConstructionStrategy = emptyMethod;
    MINIMUM_SPANNING_TREE = new TreeConstructionStrategy('MINIMUM_SPANNING_TREE', 0);
    MAXIMUM_SPANNING_TREE = new TreeConstructionStrategy('MAXIMUM_SPANNING_TREE', 1);
}
function $create_19(this$static) {
    switch(this$static.ordinal){
        case 0:
            return new MinSTPhase;
        case 1:
            return new MaxSTPhase;
        default:
            throw toJs(new IllegalArgumentException_0('No implementation available for ' + (this$static.name_0 != null ? this$static.name_0 : '' + this$static.ordinal)));
    }
}
function TreeConstructionStrategy(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_90(name_0) {
    $clinit_TreeConstructionStrategy();
    return valueOf(($clinit_TreeConstructionStrategy$Map(), $MAP_80), name_0);
}
function values_98() {
    $clinit_TreeConstructionStrategy();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_TreeConstructionStrategy_2_classLit, 1), $intern_36, 424, 0, [
        MINIMUM_SPANNING_TREE,
        MAXIMUM_SPANNING_TREE
    ]);
}
defineClass(424, 23, {
    3: 1,
    34: 1,
    23: 1,
    424: 1,
    188: 1,
    196: 1
}, TreeConstructionStrategy);
_.create_1 = function create_42() {
    return $create_19(this);
};
_.create_2 = function create_41() {
    return $create_19(this);
};
var MAXIMUM_SPANNING_TREE, MINIMUM_SPANNING_TREE;
var Lorg_eclipse_elk_alg_spore_options_TreeConstructionStrategy_2_classLit = createForEnum('org.eclipse.elk.alg.spore.options', 'TreeConstructionStrategy', 424, Ljava_lang_Enum_2_classLit, values_98, valueOf_90);
function $clinit_TreeConstructionStrategy$Map() {
    $clinit_TreeConstructionStrategy$Map = emptyMethod;
    $MAP_80 = createValueOfMap(($clinit_TreeConstructionStrategy(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_alg_spore_options_TreeConstructionStrategy_2_classLit, 1), $intern_36, 424, 0, [
        MINIMUM_SPANNING_TREE,
        MAXIMUM_SPANNING_TREE
    ])));
}
var $MAP_80;
function $process_115(graph, progressMonitor) {
    var vertices;
    progressMonitor.begin('Delaunay triangulation', 1);
    vertices = new ArrayList;
    $forEach_1(graph.vertices, new DelaunayTriangulationPhase$lambda$0$Type(vertices));
    $booleanValue(castToBoolean($getProperty(graph, ($clinit_InternalProperties(), DEBUG_SVG))));
    !graph.tEdges ? graph.tEdges = triangulate(vertices) : $addAll(graph.tEdges, triangulate(vertices));
    progressMonitor.done_1();
}
function DelaunayTriangulationPhase() {}
defineClass(1402, 1, $intern_110, DelaunayTriangulationPhase);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_35(graph) {
    return castTo(graph, 307), new LayoutProcessorConfiguration;
};
_.process = function process_113(graph, progressMonitor) {
    $process_115(castTo(graph, 307), progressMonitor);
};
var Lorg_eclipse_elk_alg_spore_p1structure_DelaunayTriangulationPhase_2_classLit = createForClass('org.eclipse.elk.alg.spore.p1structure', 'DelaunayTriangulationPhase', 1402);
function DelaunayTriangulationPhase$lambda$0$Type(vertices_0) {
    this.vertices_0 = vertices_0;
}
defineClass(1403, 1, $intern_19, DelaunayTriangulationPhase$lambda$0$Type);
_.accept = function accept_131(arg0) {
    $add_3(this.vertices_0, castTo(arg0, 68).originalVertex);
};
var Lorg_eclipse_elk_alg_spore_p1structure_DelaunayTriangulationPhase$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore.p1structure', 'DelaunayTriangulationPhase/lambda$0$Type', 1403);
function $addNode_1(this$static, s, t) {
    var child, tTree, tTree$iterator;
    for(tTree$iterator = new ArrayList$1(t.children); tTree$iterator.i < tTree$iterator.this$01.array.length;){
        tTree = castTo($next_6(tTree$iterator), 224);
        child = new Tree(castTo($get_10(this$static.nodeMap, tTree.node), 68));
        $add_3(s.children, child);
        $addNode_1(this$static, child, tTree);
    }
}
function $convert(this$static, tTree, graph) {
    var root;
    $reset(this$static.nodeMap);
    $forEach_1(graph.vertices, new MinSTPhase$lambda$0$Type(this$static));
    root = new Tree(castTo($get_10(this$static.nodeMap, tTree.node), 68));
    $addNode_1(this$static, root, tTree);
    graph.tree = root;
}
function $lambda$0_10(this$static, n_0) {
    return $put_6(this$static.nodeMap, n_0.originalVertex, n_0);
}
function MinSTPhase() {
    this.nodeMap = new HashMap;
}
defineClass(774, 1, $intern_110, MinSTPhase);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_36(graph) {
    return castTo(graph, 307), new LayoutProcessorConfiguration;
};
_.process = function process_114(graph, progressMonitor) {
    this.process_1(castTo(graph, 307), progressMonitor);
};
_.process_1 = function process_115(graph, progressMonitor) {
    var lastArg, root, tTree;
    progressMonitor.begin('Minimum spanning tree construction', 1);
    graph.preferredRoot ? root = graph.preferredRoot.originalVertex : root = castTo($get_11(graph.vertices, 0), 68).originalVertex;
    $booleanValue(castToBoolean($getProperty(graph, ($clinit_InternalProperties(), DEBUG_SVG)))) ? tTree = createSpanningTree(graph.tEdges, root, (lastArg = graph.costFunction, lastArg)) : tTree = createSpanningTree(graph.tEdges, root, graph.costFunction);
    $convert(this, tTree, graph);
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_spore_p2processingorder_MinSTPhase_2_classLit = createForClass('org.eclipse.elk.alg.spore.p2processingorder', 'MinSTPhase', 774);
function MaxSTPhase() {
    MinSTPhase.call(this);
}
function lambda$0_38(graph_0, e_1) {
    return -graph_0.costFunction.cost(e_1);
}
defineClass(1405, 774, $intern_110, MaxSTPhase);
_.process_1 = function process_116(graph, progressMonitor) {
    var invertedCF, lastArg, root, tree;
    progressMonitor.begin('Maximum spanning tree construction', 1);
    invertedCF = new MaxSTPhase$lambda$0$Type(graph);
    graph.preferredRoot ? root = graph.preferredRoot.vertex : root = castTo($get_11(graph.vertices, 0), 68).vertex;
    $booleanValue(castToBoolean($getProperty(graph, ($clinit_InternalProperties(), DEBUG_SVG)))) ? tree = createSpanningTree(graph.tEdges, root, (lastArg = invertedCF, lastArg)) : tree = createSpanningTree(graph.tEdges, root, invertedCF);
    $convert(this, tree, graph);
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_alg_spore_p2processingorder_MaxSTPhase_2_classLit = createForClass('org.eclipse.elk.alg.spore.p2processingorder', 'MaxSTPhase', 1405);
function MaxSTPhase$lambda$0$Type(graph_0) {
    this.graph_0 = graph_0;
}
defineClass(1406, 1, {}, MaxSTPhase$lambda$0$Type);
_.cost = function cost_4(arg0) {
    return lambda$0_38(this.graph_0, arg0);
};
var Lorg_eclipse_elk_alg_spore_p2processingorder_MaxSTPhase$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore.p2processingorder', 'MaxSTPhase/lambda$0$Type', 1406);
function MinSTPhase$lambda$0$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1404, 1, $intern_19, MinSTPhase$lambda$0$Type);
_.accept = function accept_132(arg0) {
    $lambda$0_10(this.$$outer_0, castTo(arg0, 68));
};
var Lorg_eclipse_elk_alg_spore_p2processingorder_MinSTPhase$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore.p2processingorder', 'MinSTPhase/lambda$0$Type', 1404);
function $debugOut(this$static, c) {
    $drawTree(this$static, this$static.root, this$static.svg);
    castTo(this$static.root.node, 68);
    !!c && castTo(c.node, 68).rect;
}
function $drawTree(this$static, t, img) {
    castTo(t.node, 68);
    $forEach_1(t.children, new GrowTreePhase$lambda$0$Type(this$static, img, t));
}
function $growAt(this$static, r) {
    var c, c$iterator, t;
    for(c$iterator = new ArrayList$1(r.children); c$iterator.i < c$iterator.this$01.array.length;){
        c = castTo($next_6(c$iterator), 224);
        $translate(castTo(c.node, 68), $sub_0($clone_1(castTo(r.node, 68).vertex), castTo(r.node, 68).originalVertex));
        t = overlap_0(castTo(r.node, 68).rect, castTo(c.node, 68).rect);
        t > 1 && (this$static.overlapsExisted = true);
        $setCenterPosition(castTo(c.node, 68), $add_19($clone_1(castTo(r.node, 68).vertex), $scale($sub_0($clone_1(castTo(c.node, 68).originalVertex), castTo(r.node, 68).originalVertex), t)));
        $debugOut(this$static, r);
        $growAt(this$static, c);
    }
}
function $lambda$0_11(this$static, img_1, t_2, c_2) {
    castTo(t_2.node, 68);
    castTo(t_2.node, 68);
    castTo(c_2.node, 68);
    castTo(c_2.node, 68);
    castTo(c_2.node, 68);
    $forEach_1(c_2.children, new GrowTreePhase$lambda$0$Type(this$static, img_1, c_2));
}
function $process_116(this$static, graph, progressMonitor) {
    progressMonitor.begin('Grow Tree', 1);
    this$static.root = graph.tree;
    if ($booleanValue(castToBoolean($getProperty(graph, ($clinit_InternalProperties(), DEBUG_SVG))))) {
        this$static.svg = new SVGImage;
        $debugOut(this$static, null);
    } else this$static.svg = new SVGImage;
    this$static.overlapsExisted = false;
    $growAt(this$static, graph.tree);
    $setProperty_0(graph, OVERLAPS_EXISTED, ($clinit_Boolean(), this$static.overlapsExisted ? true : false));
    progressMonitor.done_1();
}
function GrowTreePhase() {}
defineClass(776, 1, $intern_110, GrowTreePhase);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_37(graph) {
    return castTo(graph, 307), new LayoutProcessorConfiguration;
};
_.process = function process_117(graph, progressMonitor) {
    $process_116(this, castTo(graph, 307), progressMonitor);
};
_.overlapsExisted = false;
var Lorg_eclipse_elk_alg_spore_p3execution_GrowTreePhase_2_classLit = createForClass('org.eclipse.elk.alg.spore.p3execution', 'GrowTreePhase', 776);
function GrowTreePhase$lambda$0$Type($$outer_0, img_1, t_2) {
    this.$$outer_0 = $$outer_0;
    this.img_1 = img_1;
    this.t_2 = t_2;
}
defineClass(777, 1, $intern_19, GrowTreePhase$lambda$0$Type);
_.accept = function accept_133(arg0) {
    $lambda$0_11(this.$$outer_0, this.img_1, this.t_2, castTo(arg0, 224));
};
var Lorg_eclipse_elk_alg_spore_p3execution_GrowTreePhase$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore.p3execution', 'GrowTreePhase/lambda$0$Type', 777);
function $debugOut_0(this$static, tree) {
    var svg;
    svg = new SVGImage;
    castTo(tree.node, 68);
    castTo(tree.node, 68);
    castTo(tree.node, 68);
    $forEach_1(tree.children, new ShrinkTreeCompactionPhase$lambda$0$Type(this$static, svg, tree));
}
function $lambda$0_12(this$static, svg_1, t_2, c_2) {
    var cv;
    castTo(t_2.node, 68);
    castTo(t_2.node, 68);
    castTo(c_2.node, 68);
    castTo(c_2.node, 68);
    cv = $sub_0($clone_1(castTo(t_2.node, 68).vertex), castTo(c_2.node, 68).vertex);
    $scaleToLength(cv, $distance(castTo(t_2.node, 68), castTo(c_2.node, 68), cv));
    castTo(c_2.node, 68);
    castTo(c_2.node, 68);
    castTo(c_2.node, 68).vertex.x_0, cv.x_0;
    castTo(c_2.node, 68).vertex.y_0, cv.y_0;
    castTo(c_2.node, 68);
    $forEach_1(c_2.children, new ShrinkTreeCompactionPhase$lambda$0$Type(this$static, svg_1, c_2));
}
function $process_117(this$static, graph, progressMonitor) {
    var lastArg;
    progressMonitor.begin('Shrinking tree compaction', 1);
    if ($booleanValue(castToBoolean($getProperty(graph, ($clinit_InternalProperties(), DEBUG_SVG))))) {
        $debugOut_0(this$static, graph.tree);
        compact_0(graph.tree, (lastArg = graph.orthogonalCompaction, lastArg));
    } else compact_0(graph.tree, graph.orthogonalCompaction);
    progressMonitor.done_1();
}
function ShrinkTreeCompactionPhase() {}
defineClass(1407, 1, $intern_110, ShrinkTreeCompactionPhase);
_.getLayoutProcessorConfiguration = function getLayoutProcessorConfiguration_38(graph) {
    return castTo(graph, 307), new LayoutProcessorConfiguration;
};
_.process = function process_118(graph, progressMonitor) {
    $process_117(this, castTo(graph, 307), progressMonitor);
};
var Lorg_eclipse_elk_alg_spore_p3execution_ShrinkTreeCompactionPhase_2_classLit = createForClass('org.eclipse.elk.alg.spore.p3execution', 'ShrinkTreeCompactionPhase', 1407);
function ShrinkTreeCompactionPhase$lambda$0$Type($$outer_0, svg_1, t_2) {
    this.$$outer_0 = $$outer_0;
    this.svg_1 = svg_1;
    this.t_2 = t_2;
}
defineClass(775, 1, $intern_19, ShrinkTreeCompactionPhase$lambda$0$Type);
_.accept = function accept_134(arg0) {
    $lambda$0_12(this.$$outer_0, this.svg_1, this.t_2, castTo(arg0, 224));
};
var Lorg_eclipse_elk_alg_spore_p3execution_ShrinkTreeCompactionPhase$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.alg.spore.p3execution', 'ShrinkTreeCompactionPhase/lambda$0$Type', 775);
var Lorg_eclipse_elk_core_util_IGraphElementVisitor_2_classLit = createForInterface('org.eclipse.elk.core.util', 'IGraphElementVisitor');
function $clinit_LayoutConfigurator() {
    $clinit_LayoutConfigurator = emptyMethod;
    new Property('org.eclipse.elk.addLayoutConfig');
    NO_OVERWRITE_HOLDER = new LayoutConfigurator$lambda$2$Type;
    NO_OVERWRITE = new LayoutConfigurator$lambda$0$Type;
    OPTION_TARGET_FILTER = new LayoutConfigurator$lambda$1$Type;
}
function $addFilter(this$static, filter) {
    $add_3(this$static.optionFilters, filter);
    return this$static;
}
function $applyProperties(this$static, element, properties) {
    var accept, clone, entry, entry$iterator, filters, value_0;
    filters = this$static.optionFilters;
    for(entry$iterator = (!properties.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : properties.propertyMap).entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        accept = !$spliterator($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(filters, 16)), new Predicate$lambda$2$Type(new LayoutConfigurator$lambda$3$Type(element, entry)))).tryAdvance(($clinit_StreamImpl(), NULL_CONSUMER));
        if (accept) {
            value_0 = entry.getValue();
            if (instanceOf(value_0, 4)) {
                clone = clone_11(value_0);
                clone != null && (value_0 = clone);
            }
            element.setProperty(castTo(entry.getKey(), 144), value_0);
        }
    }
}
function $configure(this$static, elementClass) {
    var result;
    result = castTo($get_10(this$static.classOptionMap, elementClass), 148);
    if (!result) {
        result = new MapPropertyHolder;
        $put_6(this$static.classOptionMap, elementClass, result);
    }
    return result;
}
function $findClassOptions(this$static, element) {
    var combined;
    combined = new MapPropertyHolder;
    !!element && $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit), 102));
    instanceOf(element, 273) && $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkShape_2_classLit), 102));
    if (instanceOf(element, 359)) {
        $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkLabel_2_classLit), 102));
        return combined;
    }
    instanceOf(element, 84) && $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit), 102));
    if (instanceOf(element, 206)) {
        $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkNode_2_classLit), 102));
        return combined;
    }
    if (instanceOf(element, 193)) {
        $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkPort_2_classLit), 102));
        return combined;
    }
    instanceOf(element, 268) && $copyProperties(combined, castTo($get_10(this$static.classOptionMap, Lorg_eclipse_elk_graph_ElkEdge_2_classLit), 102));
    return combined;
}
function LayoutConfigurator() {
    $clinit_LayoutConfigurator();
    this.elementOptionMap = new HashMap;
    this.classOptionMap = new HashMap;
    this.optionFilters = new ArrayList;
}
function lambda$1_18(e_0, property_1) {
    $clinit_LayoutConfigurator();
    var optionData, targets;
    optionData = $getOptionData(getInstance(), property_1.getId());
    if (optionData) {
        targets = optionData.targets;
        if (instanceOf(e_0, 206)) return $isHierarchical_0(castTo(e_0, 27)) ? $containsEnum(targets, ($clinit_LayoutOptionData$Target(), NODES)) || $containsEnum(targets, PARENTS) : $containsEnum(targets, ($clinit_LayoutOptionData$Target(), NODES));
        else if (instanceOf(e_0, 268)) return $containsEnum(targets, ($clinit_LayoutOptionData$Target(), EDGES));
        else if (instanceOf(e_0, 193)) return $containsEnum(targets, ($clinit_LayoutOptionData$Target(), PORTS));
        else if (instanceOf(e_0, 359)) return $containsEnum(targets, ($clinit_LayoutOptionData$Target(), LABELS));
    }
    return true;
}
function lambda$3_10(element_0, entry_1, filter_2) {
    $clinit_LayoutConfigurator();
    return filter_2.accept_3(element_0, castTo(entry_1.getKey(), 144));
}
defineClass(848, 1, {
    521: 1
}, LayoutConfigurator);
_.visit = function visit(element) {
    var combined;
    combined = $findClassOptions(this, element);
    $copyProperties(combined, castTo($get_10(this.elementOptionMap, element), 102));
    $applyProperties(this, element, combined);
};
var NO_OVERWRITE, NO_OVERWRITE_HOLDER, OPTION_TARGET_FILTER;
var Lorg_eclipse_elk_core_LayoutConfigurator_2_classLit = createForClass('org.eclipse.elk.core', 'LayoutConfigurator', 848);
var Lorg_eclipse_elk_core_LayoutConfigurator$IPropertyHolderOptionFilter_2_classLit = createForInterface('org.eclipse.elk.core', 'LayoutConfigurator/IPropertyHolderOptionFilter');
function LayoutConfigurator$lambda$0$Type() {}
defineClass(922, 1, {
    1978: 1
}, LayoutConfigurator$lambda$0$Type);
_.accept_3 = function accept_135(e, p) {
    return $clinit_LayoutConfigurator(), !e.hasProperty(p);
};
var Lorg_eclipse_elk_core_LayoutConfigurator$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core', 'LayoutConfigurator/lambda$0$Type', 922);
function $accept_3(e, p) {
    return lambda$1_18(e, p);
}
function LayoutConfigurator$lambda$1$Type() {}
defineClass(923, 1, {
    1978: 1
}, LayoutConfigurator$lambda$1$Type);
_.accept_3 = function accept_136(e, p) {
    return $accept_3(e, p);
};
var Lorg_eclipse_elk_core_LayoutConfigurator$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core', 'LayoutConfigurator/lambda$1$Type', 923);
function LayoutConfigurator$lambda$2$Type() {}
defineClass(921, 1, {
    824: 1
}, LayoutConfigurator$lambda$2$Type);
_.accept_4 = function accept_137(holder, property) {
    return $clinit_LayoutConfigurator(), !holder.hasProperty(property);
};
var Lorg_eclipse_elk_core_LayoutConfigurator$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core', 'LayoutConfigurator/lambda$2$Type', 921);
function LayoutConfigurator$lambda$3$Type(element_0, entry_1) {
    this.element_0 = element_0;
    this.entry_1 = entry_1;
}
defineClass(924, 1, $intern_39, LayoutConfigurator$lambda$3$Type);
_.test_0 = function test_116(arg0) {
    return lambda$3_10(this.element_0, this.entry_1, castTo(arg0, 1978));
};
var Lorg_eclipse_elk_core_LayoutConfigurator$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.core', 'LayoutConfigurator/lambda$3$Type', 924);
function $countNodesRecursively(this$static, layoutNode, countAncestors) {
    var childNode, childNode$iterator, count, parent_0;
    count = (!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children).size_0;
    for(childNode$iterator = new AbstractEList$EIterator((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)); childNode$iterator.cursor != childNode$iterator.this$01_2.size_1();){
        childNode = castTo($doNext(childNode$iterator), 27);
        (!childNode.children && (childNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, childNode, 10, 11)), childNode.children).size_0 == 0 || (count += $countNodesRecursively(this$static, childNode, false));
    }
    if (countAncestors) {
        parent_0 = $getParent_2(layoutNode);
        while(parent_0){
            count += (!parent_0.children && (parent_0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parent_0, 10, 11)), parent_0.children).size_0;
            parent_0 = $getParent_2(parent_0);
        }
    }
    return count;
}
function $countNodesWithHierarchy(this$static, parentNode) {
    var childData, childNode, childNode$iterator, count, parentData;
    count = (!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children).size_0;
    for(childNode$iterator = new AbstractEList$EIterator((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children)); childNode$iterator.cursor != childNode$iterator.this$01_2.size_1();){
        childNode = castTo($doNext(childNode$iterator), 27);
        if (maskUndefined($getProperty_0(childNode, ($clinit_CoreOptions(), HIERARCHY_HANDLING_0))) !== maskUndefined(($clinit_HierarchyHandling(), SEPARATE_CHILDREN))) {
            parentData = castTo($getProperty_0(parentNode, RESOLVED_ALGORITHM), 149);
            childData = castTo($getProperty_0(childNode, RESOLVED_ALGORITHM), 149);
            (parentData == childData || !!parentData && $equals_8(parentData, childData)) && (!childNode.children && (childNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, childNode, 10, 11)), childNode.children).size_0 != 0 && (count += $countNodesWithHierarchy(this$static, childNode));
        }
    }
    return count;
}
function $evaluateHierarchyHandlingInheritance(layoutNode) {
    var parentHandling;
    if (maskUndefined($getProperty_0(layoutNode, ($clinit_CoreOptions(), HIERARCHY_HANDLING_0))) === maskUndefined(($clinit_HierarchyHandling(), INHERIT_0))) {
        if (!$getParent_2(layoutNode)) $setProperty_1(layoutNode, HIERARCHY_HANDLING_0, SEPARATE_CHILDREN);
        else {
            parentHandling = castTo($getProperty_0($getParent_2(layoutNode), HIERARCHY_HANDLING_0), 342);
            $setProperty_1(layoutNode, HIERARCHY_HANDLING_0, parentHandling);
        }
    }
}
function $executeAlgorithm(layoutNode, algorithmData, progressMonitor) {
    var exception, layoutProvider;
    layoutProvider = castTo($fetch(algorithmData.providerPool), 222);
    try {
        layoutProvider.layout(layoutNode, progressMonitor);
        $release(algorithmData.providerPool, layoutProvider);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            exception = $e0;
            throw toJs(exception);
        } else throw toJs($e0);
    }
}
function $gatherInsideSelfLoops(node) {
    var edge, edge$iterator, insideSelfLoops;
    if ($booleanValue(castToBoolean($getProperty_0(node, ($clinit_CoreOptions(), INSIDE_SELF_LOOPS_ACTIVATE_0))))) {
        insideSelfLoops = new ArrayList;
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 85);
            $isSelfloop(edge) && $booleanValue(castToBoolean($getProperty_0(edge, INSIDE_SELF_LOOPS_YO_0))) && push_1(insideSelfLoops.array, edge);
        }
        return insideSelfLoops;
    } else return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function $layout_3(this$static, layoutGraph, progressMonitor) {
    var nodeCount;
    nodeCount = $countNodesRecursively(this$static, layoutGraph, true);
    $begin(progressMonitor, 'Recursive Graph Layout', nodeCount);
    applyVisitors(layoutGraph, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_IGraphElementVisitor_2_classLit, 1), $intern_2, 521, 0, [
        new DeprecatedLayoutOptionReplacer
    ]));
    $hasProperty_0(layoutGraph, ($clinit_CoreOptions(), RESOLVED_ALGORITHM)) || applyVisitors(layoutGraph, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_IGraphElementVisitor_2_classLit, 1), $intern_2, 521, 0, [
        new LayoutAlgorithmResolver
    ]));
    $layoutRecursively(this$static, layoutGraph, null, progressMonitor);
    $done_0(progressMonitor);
}
function $layoutRecursively(this$static, layoutNode, testController, progressMonitor) {
    var algorithmData, alignmentShiftX, alignmentShiftY, approximator, bendPoint, bendPoint$iterator, child, child$iterator, childAreaAvailableHeight, childAreaAvailableWidth, childAreaDesiredHeight, childAreaDesiredWidth, childLayoutSelfLoops, childNode, childNode$iterator, childrenInsideSelfLoops, contentAlignment, edge, edge$iterator, hasChildren, hasInsideSelfLoops, insideSelfLoops, junctionPoint, junctionPoint$iterator, junctionPoints, label_0, label$iterator, localAlgorithmData, node, node$iterator, nodeCount, nodeQueue, padding, padding0, scaleFactor, scaleFactorX, scaleFactorY, section, section$iterator, selfLoop, selfLoop$iterator, size_0, stopHierarchy, supportsInsideSelfLoops, topdownLayoutMonitor, xShift, yShift;
    if (progressMonitor.isCanceled()) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    if ($booleanValue(castToBoolean($getProperty_0(layoutNode, ($clinit_CoreOptions(), NO_LAYOUT_0))))) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
    hasChildren = (!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children).size_0 != 0;
    insideSelfLoops = $gatherInsideSelfLoops(layoutNode);
    hasInsideSelfLoops = !insideSelfLoops.isEmpty();
    if (hasChildren || hasInsideSelfLoops) {
        algorithmData = castTo($getProperty_0(layoutNode, RESOLVED_ALGORITHM), 149);
        if (!algorithmData) throw toJs(new UnsupportedConfigurationException_0('Resolved algorithm is not set; apply a LayoutAlgorithmResolver before computing layout.'));
        supportsInsideSelfLoops = $supportsFeature(algorithmData, ($clinit_GraphFeature(), INSIDE_SELF_LOOPS));
        $evaluateHierarchyHandlingInheritance(layoutNode);
        if (!hasChildren && hasInsideSelfLoops && !supportsInsideSelfLoops) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
        childrenInsideSelfLoops = new ArrayList;
        if (maskUndefined($getProperty_0(layoutNode, HIERARCHY_HANDLING_0)) === maskUndefined(($clinit_HierarchyHandling(), INCLUDE_CHILDREN)) && ($supportsFeature(algorithmData, COMPOUND) || $supportsFeature(algorithmData, CLUSTERS))) {
            if ($booleanValue(castToBoolean($getProperty_0(layoutNode, TOPDOWN_LAYOUT_2)))) throw toJs(new UnsupportedConfigurationException_0('Topdown layout cannot be used together with hierarchy handling.'));
            nodeCount = $countNodesWithHierarchy(this$static, layoutNode);
            nodeQueue = new LinkedList;
            $addAll(nodeQueue, (!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children));
            while(nodeQueue.size_0 != 0){
                node = castTo(nodeQueue.size_0 == 0 ? null : (checkCriticalElement(nodeQueue.size_0 != 0), $removeNode_0(nodeQueue, nodeQueue.header.next_0)), 27);
                $evaluateHierarchyHandlingInheritance(node);
                stopHierarchy = maskUndefined($getProperty_0(node, HIERARCHY_HANDLING_0)) === maskUndefined(SEPARATE_CHILDREN);
                if (stopHierarchy || $hasProperty_0(node, ALGORITHM) && !$equals_8(algorithmData, $getProperty_0(node, RESOLVED_ALGORITHM))) {
                    childLayoutSelfLoops = $layoutRecursively(this$static, node, testController, progressMonitor);
                    $addAll_2(childrenInsideSelfLoops, childLayoutSelfLoops);
                    $setProperty_1(node, HIERARCHY_HANDLING_0, SEPARATE_CHILDREN);
                    applyConfiguredNodeScaling(node);
                } else $addAll(nodeQueue, (!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children));
            }
        } else {
            nodeCount = (!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children).size_0;
            if ($booleanValue(castToBoolean($getProperty_0(layoutNode, TOPDOWN_LAYOUT_2)))) {
                topdownLayoutMonitor = progressMonitor.subTask(1);
                topdownLayoutMonitor.begin('Topdown Layout', 1);
                if ($getProperty_0(layoutNode, TOPDOWN_NODE_TYPE) == null) throw toJs(new UnsupportedConfigurationException_0(layoutNode.identifier + ' has not been assigned a top-down node type.'));
                if (castTo($getProperty_0(layoutNode, TOPDOWN_NODE_TYPE), 278) == ($clinit_TopdownNodeTypes(), HIERARCHICAL_NODE) || castTo($getProperty_0(layoutNode, TOPDOWN_NODE_TYPE), 278) == ROOT_NODE_0) for(childNode$iterator = new AbstractEList$EIterator((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)); childNode$iterator.cursor != childNode$iterator.this$01_2.size_1();){
                    childNode = castTo($doNext(childNode$iterator), 27);
                    localAlgorithmData = castTo($getProperty_0(childNode, RESOLVED_ALGORITHM), 149);
                    (!childNode.children && (childNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, childNode, 10, 11)), childNode.children).size_0 > 0 && $fetch(localAlgorithmData.providerPool);
                    if ($getProperty_0(childNode, TOPDOWN_SIZE_APPROXIMATOR) != null) {
                        approximator = castTo($getProperty_0(childNode, TOPDOWN_SIZE_APPROXIMATOR), 343);
                        size_0 = approximator.getSize_0(childNode);
                        padding0 = castTo($getProperty_0(childNode, PADDING_5), 107);
                        $setDimensions(childNode, $wnd.Math.max(childNode.width_0, size_0.x_0 + padding0.left + padding0.right), $wnd.Math.max(childNode.height, size_0.y_0 + padding0.top_0 + padding0.bottom));
                    } else (!childNode.children && (childNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, childNode, 10, 11)), childNode.children).size_0 != 0 && $setDimensions(childNode, $doubleValue(castToDouble($getProperty_0(childNode, TOPDOWN_HIERARCHICAL_NODE_WIDTH_2))), $doubleValue(castToDouble($getProperty_0(childNode, TOPDOWN_HIERARCHICAL_NODE_WIDTH_2))) / $doubleValue(castToDouble($getProperty_0(childNode, TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2))));
                }
                padding = castTo($getProperty_0(layoutNode, PADDING_5), 107);
                childAreaAvailableWidth = layoutNode.width_0 - (padding.left + padding.right);
                childAreaAvailableHeight = layoutNode.height - (padding.top_0 + padding.bottom);
                topdownLayoutMonitor.log_0('Available Child Area: (' + childAreaAvailableWidth + '|' + childAreaAvailableHeight + ')');
                $setProperty_1(layoutNode, ASPECT_RATIO_4, childAreaAvailableWidth / childAreaAvailableHeight);
                $executeAlgorithm(layoutNode, algorithmData, progressMonitor.subTask(nodeCount));
                if (castTo($getProperty_0(layoutNode, TOPDOWN_NODE_TYPE), 278) == ROOT_NODE_0) {
                    computeChildAreaDimensions(layoutNode);
                    $setDimensions(layoutNode, padding.left + $doubleValue(castToDouble($getProperty_0(layoutNode, CHILD_AREA_WIDTH))) + padding.right, padding.top_0 + $doubleValue(castToDouble($getProperty_0(layoutNode, CHILD_AREA_HEIGHT))) + padding.bottom);
                }
                topdownLayoutMonitor.log_0('Executed layout algorithm: ' + castToString($getProperty_0(layoutNode, ALGORITHM)) + ' on node ' + layoutNode.identifier);
                if (castTo($getProperty_0(layoutNode, TOPDOWN_NODE_TYPE), 278) == HIERARCHICAL_NODE) {
                    if (childAreaAvailableWidth < 0 || childAreaAvailableHeight < 0) throw toJs(new UnsupportedConfigurationException_0('The size defined by the parent parallel node is too small for the space provided by the paddings of the child hierarchical node. ' + layoutNode.identifier));
                    $hasProperty_0(layoutNode, CHILD_AREA_WIDTH) || $hasProperty_0(layoutNode, CHILD_AREA_HEIGHT) || computeChildAreaDimensions(layoutNode);
                    childAreaDesiredWidth = $doubleValue(castToDouble($getProperty_0(layoutNode, CHILD_AREA_WIDTH)));
                    childAreaDesiredHeight = $doubleValue(castToDouble($getProperty_0(layoutNode, CHILD_AREA_HEIGHT)));
                    topdownLayoutMonitor.log_0('Desired Child Area: (' + childAreaDesiredWidth + '|' + childAreaDesiredHeight + ')');
                    scaleFactorX = childAreaAvailableWidth / childAreaDesiredWidth;
                    scaleFactorY = childAreaAvailableHeight / childAreaDesiredHeight;
                    scaleFactor = $wnd.Math.min(scaleFactorX, $wnd.Math.min(scaleFactorY, $doubleValue(castToDouble($getProperty_0(layoutNode, TOPDOWN_SCALE_CAP)))));
                    $setProperty_1(layoutNode, TOPDOWN_SCALE_FACTOR_2, scaleFactor);
                    topdownLayoutMonitor.log_0(layoutNode.identifier + ' -- Local Scale Factor (X|Y): (' + scaleFactorX + '|' + scaleFactorY + ')');
                    contentAlignment = castTo($getProperty_0(layoutNode, CONTENT_ALIGNMENT_2), 22);
                    alignmentShiftX = 0;
                    alignmentShiftY = 0;
                    scaleFactor < scaleFactorX && (contentAlignment.contains(($clinit_ContentAlignment(), H_CENTER)) ? alignmentShiftX = (childAreaAvailableWidth / 2 - childAreaDesiredWidth * scaleFactor / 2) / scaleFactor : contentAlignment.contains(H_RIGHT) && (alignmentShiftX = (childAreaAvailableWidth - childAreaDesiredWidth * scaleFactor) / scaleFactor));
                    scaleFactor < scaleFactorY && (contentAlignment.contains(($clinit_ContentAlignment(), V_CENTER)) ? alignmentShiftY = (childAreaAvailableHeight / 2 - childAreaDesiredHeight * scaleFactor / 2) / scaleFactor : contentAlignment.contains(V_BOTTOM) && (alignmentShiftY = (childAreaAvailableHeight - childAreaDesiredHeight * scaleFactor) / scaleFactor));
                    xShift = alignmentShiftX + (padding.left / scaleFactor - padding.left);
                    yShift = alignmentShiftY + (padding.top_0 / scaleFactor - padding.top_0);
                    topdownLayoutMonitor.log_0('Shift: (' + xShift + '|' + yShift + ')');
                    for(node$iterator = new AbstractEList$EIterator((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)); node$iterator.cursor != node$iterator.this$01_2.size_1();){
                        node = castTo($doNext(node$iterator), 27);
                        $setX_1(node, node.x_0 + xShift);
                        $setY_2(node, node.y_0 + yShift);
                    }
                    for(edge$iterator = new AbstractEList$EIterator((!layoutNode.containedEdges && (layoutNode.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, layoutNode, 12, 3)), layoutNode.containedEdges)); edge$iterator.cursor != edge$iterator.this$01_2.size_1();){
                        edge = castTo($doNext(edge$iterator), 85);
                        for(section$iterator = new AbstractEList$EIterator((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections)); section$iterator.cursor != section$iterator.this$01_2.size_1();){
                            section = castTo($doNext(section$iterator), 168);
                            $setStartLocation(section, section.startX + xShift, section.startY + yShift);
                            $setEndLocation(section, section.endX + xShift, section.endY + yShift);
                            for(bendPoint$iterator = new AbstractEList$EIterator((!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints)); bendPoint$iterator.cursor != bendPoint$iterator.this$01_2.size_1();){
                                bendPoint = castTo($doNext(bendPoint$iterator), 369);
                                $set_8(bendPoint, bendPoint.x_0 + xShift, bendPoint.y_0 + yShift);
                            }
                        }
                        for(label$iterator = new AbstractEList$EIterator((!edge.labels && (edge.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, edge, 1, 7)), edge.labels)); label$iterator.cursor != label$iterator.this$01_2.size_1();){
                            label_0 = castTo($doNext(label$iterator), 153);
                            $setLocation_1(label_0, label_0.x_0 + xShift, label_0.y_0 + yShift);
                        }
                        junctionPoints = castTo($getProperty_0(edge, JUNCTION_POINTS_0), 77);
                        for(junctionPoint$iterator = $listIterator_2(junctionPoints, 0); junctionPoint$iterator.currentNode != junctionPoint$iterator.this$01.tail;){
                            junctionPoint = castTo($next_9(junctionPoint$iterator), 8);
                            junctionPoint.x_0 += xShift;
                            junctionPoint.y_0 += yShift;
                        }
                        $setProperty_1(edge, JUNCTION_POINTS_0, junctionPoints);
                    }
                }
                topdownLayoutMonitor.done_1();
            }
            for(child$iterator = new AbstractEList$EIterator((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
                child = castTo($doNext(child$iterator), 27);
                childLayoutSelfLoops = $layoutRecursively(this$static, child, testController, progressMonitor);
                $addAll_2(childrenInsideSelfLoops, childLayoutSelfLoops);
                applyConfiguredNodeScaling(child);
            }
        }
        if (progressMonitor.isCanceled()) return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
        for(selfLoop$iterator = new ArrayList$1(childrenInsideSelfLoops); selfLoop$iterator.i < selfLoop$iterator.this$01.array.length;){
            selfLoop = castTo($next_6(selfLoop$iterator), 85);
            $setProperty_1(selfLoop, NO_LAYOUT_0, ($clinit_Boolean(), true));
        }
        $booleanValue(castToBoolean($getProperty_0(layoutNode, TOPDOWN_LAYOUT_2))) || $executeAlgorithm(layoutNode, algorithmData, progressMonitor.subTask(nodeCount));
        $postProcessInsideSelfLoops(childrenInsideSelfLoops);
        return hasInsideSelfLoops && supportsInsideSelfLoops ? insideSelfLoops : ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST);
    } else return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function $postProcessInsideSelfLoops(insideSelfLoops) {
    var bend, bend$iterator, node, section, selfLoop, selfLoop$iterator, xOffset, yOffset;
    for(selfLoop$iterator = new ArrayList$1(insideSelfLoops); selfLoop$iterator.i < selfLoop$iterator.this$01.array.length;){
        selfLoop = castTo($next_6(selfLoop$iterator), 85);
        node = connectableShapeToNode(castTo($get_20((!selfLoop.sources && (selfLoop.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, selfLoop, 4, 7)), selfLoop.sources), 0), 84));
        xOffset = node.x_0;
        yOffset = node.y_0;
        section = castTo($get_20((!selfLoop.sections && (selfLoop.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, selfLoop, 6, 6)), selfLoop.sections), 0), 168);
        $setStartLocation(section, section.startX + xOffset, section.startY + yOffset);
        $setEndLocation(section, section.endX + xOffset, section.endY + yOffset);
        for(bend$iterator = new AbstractEList$EIterator((!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints)); bend$iterator.cursor != bend$iterator.this$01_2.size_1();){
            bend = castTo($doNext(bend$iterator), 369);
            $set_8(bend, bend.x_0 + xOffset, bend.y_0 + yOffset);
        }
        $offset_1(castTo($getProperty_0(selfLoop, ($clinit_CoreOptions(), JUNCTION_POINTS_0)), 77), xOffset, yOffset);
    }
}
function RecursiveGraphLayoutEngine() {}
defineClass(846, 1, {}, RecursiveGraphLayoutEngine);
var Lorg_eclipse_elk_core_RecursiveGraphLayoutEngine_2_classLit = createForClass('org.eclipse.elk.core', 'RecursiveGraphLayoutEngine', 846);
function UnsupportedConfigurationException() {
    RuntimeException.call(this);
}
function UnsupportedConfigurationException_0(message) {
    RuntimeException_0.call(this, message);
}
defineClass(223, 63, $intern_43, UnsupportedConfigurationException, UnsupportedConfigurationException_0);
var Lorg_eclipse_elk_core_UnsupportedConfigurationException_2_classLit = createForClass('org.eclipse.elk.core', 'UnsupportedConfigurationException', 223);
function UnsupportedGraphException(message) {
    RuntimeException_0.call(this, message);
}
defineClass(363, 63, $intern_43, UnsupportedGraphException);
var Lorg_eclipse_elk_core_UnsupportedGraphException_2_classLit = createForClass('org.eclipse.elk.core', 'UnsupportedGraphException', 363);
function $ensureListSize(this$static, size_0) {
    var i;
    for(i = this$static.list.array.length; i < size_0; i++)$add_3(this$static.list, this$static.provideDefault());
}
function $getListItem(this$static, index_0) {
    if (index_0 < 0) throw toJs(new IndexOutOfBoundsException_0('Invalid index: ' + index_0));
    $ensureListSize(this$static, index_0 + 1);
    return $get_11(this$static.list, index_0);
}
function $setListItem(this$static, index_0, value_0) {
    if (index_0 < 0) throw toJs(new IndexOutOfBoundsException_0('Invalid index: ' + index_0));
    if (index_0 < this$static.list.array.length) $set_1(this$static.list, index_0, value_0);
    else {
        $ensureListSize(this$static, index_0);
        $add_3(this$static.list, value_0);
    }
}
function AbstractRandomListAccessor() {
    this.list = new ArrayList;
}
defineClass(744, 1, {});
var Lorg_eclipse_elk_core_util_AbstractRandomListAccessor_2_classLit = createForClass('org.eclipse.elk.core.util', 'AbstractRandomListAccessor', 744);
function $addProcessorConfiguration(this$static, config) {
    $addAll_6(this$static.additionalProcessors, config);
    return this$static;
}
function $build_0(this$static, graph) {
    var algorithm, phase, phase$array, phase$array0, phase$index, phase$index0, phase$max, phase$max0, phaseEnumConstants, phaseFactory, phaseImplementation, phaseImplementations, processorConfiguration;
    if (this$static.failOnMissingPhase && this$static.configuredPhases.size_0 < this$static.numberOfPhases) throw toJs(new IllegalStateException_0('Expected ' + this$static.numberOfPhases + ' phases to be configured; ' + 'only found ' + this$static.configuredPhases.size_0));
    phaseEnumConstants = castTo($getEnumConstants(this$static.phasesEnumClass), 10);
    phaseImplementations = newArrayListWithCapacity(this$static.numberOfPhases);
    for(phase$array0 = phaseEnumConstants, phase$index0 = 0, phase$max0 = phase$array0.length; phase$index0 < phase$max0; ++phase$index0){
        phase = phase$array0[phase$index0];
        phaseFactory = castTo($getListItem(this$static, phase.ordinal), 188);
        phaseFactory ? $add_3(phaseImplementations, castTo($retrieveProcessor(this$static, phaseFactory), 106)) : (phaseImplementations.array.push(null), undefined);
    }
    processorConfiguration = new LayoutProcessorConfiguration;
    $forEach_3($filter($map($filter(new StreamImpl(null, new Spliterators$IteratorSpliterator(phaseImplementations, 16)), new AlgorithmAssembler$lambda$0$Type), new AlgorithmAssembler$lambda$1$Type(graph)), new AlgorithmAssembler$lambda$2$Type), new AlgorithmAssembler$lambda$3$Type(processorConfiguration));
    $addAll_6(processorConfiguration, this$static.additionalProcessors);
    algorithm = new ArrayList;
    for(phase$array = phaseEnumConstants, phase$index = 0, phase$max = phase$array.length; phase$index < phase$max; ++phase$index){
        phase = phase$array[phase$index];
        $addAll_2(algorithm, $retrieveProcessors(this$static, newHashSet(castTo($getListItem(processorConfiguration, phase.ordinal), 20))));
        phaseImplementation = castTo($get_11(phaseImplementations, phase.ordinal), 106);
        !!phaseImplementation && push_1(algorithm.array, phaseImplementation);
    }
    $addAll_2(algorithm, $retrieveProcessors(this$static, newHashSet(castTo($getListItem(processorConfiguration, phaseEnumConstants[phaseEnumConstants.length - 1].ordinal + 1), 20))));
    return algorithm;
}
function $lambda$4_3(this$static, processors_1, factory_1) {
    return $add_3(processors_1, $retrieveProcessor(this$static, factory_1));
}
function $reset_4(this$static) {
    this$static.list.array.length = 0;
    $clear_0(this$static.configuredPhases);
    $clear_10(this$static.additionalProcessors);
    return this$static;
}
function $retrieveProcessor(this$static, factory) {
    var processor;
    if (this$static.enableCaching) {
        if ($containsKey_3(this$static.cache, factory)) return castTo($get_10(this$static.cache, factory), 44);
        else {
            processor = factory.create_1();
            $put_6(this$static.cache, factory, processor);
            return processor;
        }
    } else return factory.create_1();
}
function $retrieveProcessors(this$static, factories) {
    var processors;
    processors = newArrayListWithCapacity(factories.map_0.size_1());
    $forEach_3($sorted_1(new StreamImpl(null, new Spliterators$IteratorSpliterator(factories, 1)), this$static.processorComparator), new AlgorithmAssembler$lambda$4$Type(this$static, processors));
    return processors;
}
function $setPhase(this$static, phase, phaseFactory) {
    $setListItem(this$static, phase.ordinal, phaseFactory);
    $add_5(this$static.configuredPhases, phase);
    return this$static;
}
function AlgorithmAssembler(phaseEnum) {
    var all;
    AbstractRandomListAccessor.call(this);
    this.processorComparator = new EnumBasedFactoryComparator;
    this.phasesEnumClass = phaseEnum;
    this.numberOfPhases = castTo(phaseEnum.enumConstantsFunc && phaseEnum.enumConstantsFunc(), 10).length;
    if (this.numberOfPhases == 0) throw toJs(new IllegalArgumentException_0('There must be at least one phase in the phase enumeration.'));
    this.configuredPhases = (all = castTo($getEnumConstants(this.phasesEnumClass), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    this.additionalProcessors = new LayoutProcessorConfiguration;
    this.cache = new HashMap;
}
function lambda$1_19(graph_0, phase_1) {
    return phase_1.getLayoutProcessorConfiguration(graph_0);
}
defineClass(438, 744, {}, AlgorithmAssembler);
_.provideDefault = function provideDefault() {
    return null;
};
_.enableCaching = true;
_.failOnMissingPhase = true;
_.numberOfPhases = 0;
var Lorg_eclipse_elk_core_alg_AlgorithmAssembler_2_classLit = createForClass('org.eclipse.elk.core.alg', 'AlgorithmAssembler', 438);
function AlgorithmAssembler$lambda$0$Type() {}
defineClass(1164, 1, $intern_39, AlgorithmAssembler$lambda$0$Type);
_.test_0 = function test_117(arg0) {
    return !!castTo(arg0, 106);
};
var Lorg_eclipse_elk_core_alg_AlgorithmAssembler$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.alg', 'AlgorithmAssembler/lambda$0$Type', 1164);
function AlgorithmAssembler$lambda$1$Type(graph_0) {
    this.graph_0 = graph_0;
}
defineClass(1165, 1, {}, AlgorithmAssembler$lambda$1$Type);
_.apply_0 = function apply_150(arg0) {
    return lambda$1_19(this.graph_0, castTo(arg0, 106));
};
var Lorg_eclipse_elk_core_alg_AlgorithmAssembler$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core.alg', 'AlgorithmAssembler/lambda$1$Type', 1165);
function AlgorithmAssembler$lambda$2$Type() {}
defineClass(1166, 1, $intern_39, AlgorithmAssembler$lambda$2$Type);
_.test_0 = function test_118(arg0) {
    return !!castTo(arg0, 78);
};
var Lorg_eclipse_elk_core_alg_AlgorithmAssembler$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core.alg', 'AlgorithmAssembler/lambda$2$Type', 1166);
function AlgorithmAssembler$lambda$3$Type(processorConfiguration_0) {
    this.processorConfiguration_0 = processorConfiguration_0;
}
defineClass(1167, 1, $intern_19, AlgorithmAssembler$lambda$3$Type);
_.accept = function accept_138(arg0) {
    $addAll_6(this.processorConfiguration_0, castTo(arg0, 78));
};
var Lorg_eclipse_elk_core_alg_AlgorithmAssembler$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.core.alg', 'AlgorithmAssembler/lambda$3$Type', 1167);
function AlgorithmAssembler$lambda$4$Type($$outer_0, processors_1) {
    this.$$outer_0 = $$outer_0;
    this.processors_1 = processors_1;
}
defineClass(1168, 1, $intern_19, AlgorithmAssembler$lambda$4$Type);
_.accept = function accept_139(arg0) {
    $lambda$4_3(this.$$outer_0, this.processors_1, castTo(arg0, 196));
};
var Lorg_eclipse_elk_core_alg_AlgorithmAssembler$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.core.alg', 'AlgorithmAssembler/lambda$4$Type', 1168);
function $compare_21(factory1, factory2) {
    getClass__Ljava_lang_Class___devirtual$(factory1);
    getClass__Ljava_lang_Class___devirtual$(factory2);
    return $compareTo(castTo(factory1, 23), castTo(factory2, 23));
}
function EnumBasedFactoryComparator() {}
defineClass(1284, 1, $intern_88, EnumBasedFactoryComparator);
_.compare_1 = function compare_103(factory1, factory2) {
    return $compare_21(castTo(factory1, 196), castTo(factory2, 196));
};
_.equals_0 = function equals_190(other) {
    return this === other;
};
_.reversed = function reversed_95() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_core_alg_EnumBasedFactoryComparator_2_classLit = createForClass('org.eclipse.elk.core.alg', 'EnumBasedFactoryComparator', 1284);
function $add_17(this$static, processor) {
    if (this$static.currentIndex < 0) throw toJs(new IllegalStateException_0('Did not call before(...) or after(...) before calling add(...).'));
    $doAdd(this$static, this$static.currentIndex, processor);
    return this$static;
}
function $addAfter(this$static, phase, processor) {
    this$static.currentIndex = -1;
    $doAdd(this$static, phase.ordinal + 1, processor);
    return this$static;
}
function $addAll_6(this$static, configuration) {
    var i;
    for(i = 0; i < configuration.list.array.length; i++)castTo($getListItem(this$static, i), 22).addAll(castTo($getListItem(configuration, i), 16));
    return this$static;
}
function $addBefore(this$static, phase, processor) {
    this$static.currentIndex = -1;
    $doAdd(this$static, phase.ordinal, processor);
    return this$static;
}
function $after(this$static, phase) {
    this$static.currentIndex = phase.ordinal + 1;
    return this$static;
}
function $before(this$static, phase) {
    this$static.currentIndex = phase.ordinal;
    return this$static;
}
function $clear_10(this$static) {
    setLength(this$static.list.array, 0);
    this$static.currentIndex = -1;
    return this$static;
}
function $doAdd(this$static, index_0, processor) {
    castTo($getListItem(this$static, index_0), 22).add_2(processor);
}
function LayoutProcessorConfiguration() {
    AbstractRandomListAccessor.call(this);
    setLength(this.list.array, 0);
    this.currentIndex = -1;
}
function createFrom_0(source) {
    return $addAll_6(new LayoutProcessorConfiguration, source);
}
defineClass(78, 744, {
    78: 1
}, LayoutProcessorConfiguration);
_.provideDefault = function provideDefault_0() {
    return new HashSet;
};
_.currentIndex = 0;
var Lorg_eclipse_elk_core_alg_LayoutProcessorConfiguration_2_classLit = createForClass('org.eclipse.elk.core.alg', 'LayoutProcessorConfiguration', 78);
function $clinit_DeprecatedLayoutOptionReplacer() {
    $clinit_DeprecatedLayoutOptionReplacer = emptyMethod;
    NEXT_TO_PORT_IF_POSSIBLE = new DeprecatedLayoutOptionReplacer$lambda$0$Type;
    SPACE_EFFICIENT = new DeprecatedLayoutOptionReplacer$lambda$1$Type;
    RULES = of_0(($clinit_CoreOptions(), PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE_0), NEXT_TO_PORT_IF_POSSIBLE, NODE_SIZE_OPTIONS_6, SPACE_EFFICIENT);
}
function DeprecatedLayoutOptionReplacer() {
    $clinit_DeprecatedLayoutOptionReplacer();
}
function lambda$0_39(e_0) {
    $clinit_DeprecatedLayoutOptionReplacer();
    castTo(e_0.getProperty(($clinit_CoreOptions(), PORT_LABELS_PLACEMENT_5)), 181).add_2(($clinit_PortLabelPlacement(), NEXT_TO_PORT_IF_POSSIBLE_0));
    e_0.setProperty(PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE_0, null);
}
function lambda$1_20(e_0) {
    $clinit_DeprecatedLayoutOptionReplacer();
    if (castTo(e_0.getProperty(($clinit_CoreOptions(), NODE_SIZE_OPTIONS_6)), 181).contains(($clinit_SizeOptions(), SPACE_EFFICIENT_PORT_LABELS))) {
        castTo(e_0.getProperty(PORT_LABELS_PLACEMENT_5), 181).add_2(($clinit_PortLabelPlacement(), SPACE_EFFICIENT_0));
        castTo(e_0.getProperty(NODE_SIZE_OPTIONS_6), 181).remove_1(SPACE_EFFICIENT_PORT_LABELS);
    }
}
function lambda$2_12(element_0, option_1, replacer_2) {
    $clinit_DeprecatedLayoutOptionReplacer();
    element_0.hasProperty(option_1) && replacer_2.accept(element_0);
}
defineClass($intern_45, 1, {
    521: 1
}, DeprecatedLayoutOptionReplacer);
_.visit = function visit_0(element) {
    $forEach_2(RULES, new DeprecatedLayoutOptionReplacer$lambda$2$Type(element));
};
var NEXT_TO_PORT_IF_POSSIBLE, RULES, SPACE_EFFICIENT;
var Lorg_eclipse_elk_core_data_DeprecatedLayoutOptionReplacer_2_classLit = createForClass('org.eclipse.elk.core.data', 'DeprecatedLayoutOptionReplacer', $intern_45);
function DeprecatedLayoutOptionReplacer$lambda$0$Type() {}
defineClass(1001, 1, $intern_19, DeprecatedLayoutOptionReplacer$lambda$0$Type);
_.accept = function accept_140(arg0) {
    lambda$0_39(castTo(arg0, 173));
};
var Lorg_eclipse_elk_core_data_DeprecatedLayoutOptionReplacer$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'DeprecatedLayoutOptionReplacer/lambda$0$Type', 1001);
function DeprecatedLayoutOptionReplacer$lambda$1$Type() {}
defineClass(1002, 1, $intern_19, DeprecatedLayoutOptionReplacer$lambda$1$Type);
_.accept = function accept_141(arg0) {
    lambda$1_20(castTo(arg0, 173));
};
var Lorg_eclipse_elk_core_data_DeprecatedLayoutOptionReplacer$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'DeprecatedLayoutOptionReplacer/lambda$1$Type', 1002);
function DeprecatedLayoutOptionReplacer$lambda$2$Type(element_0) {
    this.element_0 = element_0;
}
defineClass(1003, 1, {}, DeprecatedLayoutOptionReplacer$lambda$2$Type);
_.accept_1 = function accept_142(arg0, arg1) {
    lambda$2_12(this.element_0, castTo(arg0, 144), castTo(arg1, 40));
};
var Lorg_eclipse_elk_core_data_DeprecatedLayoutOptionReplacer$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'DeprecatedLayoutOptionReplacer/lambda$2$Type', 1003);
function $addKnownOption(this$static, property, defaultValue) {
    $putStringValue(this$static.knownOptions, property.id_0, defaultValue);
}
function $equals_8(this$static, obj) {
    if (instanceOf(obj, 149)) return $equals_5(this$static.id_0, castTo(obj, 149).id_0);
    return false;
}
function $supportsFeature(this$static, graphFeature) {
    return $containsEnum(this$static.supportedFeatures, graphFeature);
}
function LayoutAlgorithmData(builder) {
    var all;
    this.knownOptions = new HashMap;
    this.id_0 = builder.id_0;
    this.name_0 = builder.name_0;
    this.description = builder.description;
    this.providerPool = new InstancePool(builder.providerFactory);
    this.category = builder.category;
    !builder.supportedFeatures ? this.supportedFeatures = (all = castTo($getEnumConstants(Lorg_eclipse_elk_graph_properties_GraphFeature_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)) : this.supportedFeatures = builder.supportedFeatures;
}
defineClass(149, 1, {
    685: 1,
    149: 1
}, LayoutAlgorithmData);
_.equals_0 = function equals_191(obj) {
    return $equals_8(this, obj);
};
_.getDescription = function getDescription() {
    return this.description;
};
_.getId = function getId() {
    return this.id_0;
};
_.getName = function getName_2() {
    return this.name_0;
};
_.hashCode_1 = function hashCode_65() {
    return $hashCode_2(this.id_0);
};
_.toString_0 = function toString_109() {
    return 'Layout Algorithm: ' + this.id_0;
};
var Lorg_eclipse_elk_core_data_LayoutAlgorithmData_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutAlgorithmData', 149);
function $category(this$static, acategory) {
    this$static.category = acategory;
    return this$static;
}
function $description(this$static, adescription) {
    this$static.description = adescription;
    return this$static;
}
function $id(this$static, aid) {
    this$static.id_0 = aid;
    return this$static;
}
function $name_0(this$static, aname) {
    this$static.name_0 = aname;
    return this$static;
}
function $providerFactory(this$static, aproviderFactory) {
    this$static.providerFactory = aproviderFactory;
    return this$static;
}
function $supportedFeatures(this$static, asupportedFeatures) {
    this$static.supportedFeatures = asupportedFeatures;
    return this$static;
}
function LayoutAlgorithmData$Builder() {}
defineClass(285, 1, {}, LayoutAlgorithmData$Builder);
var Lorg_eclipse_elk_core_data_LayoutAlgorithmData$Builder_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutAlgorithmData/Builder', 285);
function $resolveAlgorithm(node) {
    var algorithmId, message;
    algorithmId = castToString($getProperty_0(node, ($clinit_CoreOptions(), ALGORITHM)));
    if ($resolveAndSetAlgorithm(algorithmId, node)) return;
    if (!$hasProperty_0(node, RESOLVED_ALGORITHM) && ((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children).size_0 != 0 || $booleanValue(castToBoolean($getProperty_0(node, INSIDE_SELF_LOOPS_ACTIVATE_0))))) {
        if (algorithmId == null || $trim(algorithmId).length == 0) {
            if (!$resolveAndSetAlgorithm('org.eclipse.elk.layered', node)) {
                message = $append_11($append_11(new StringBuilder_1('Unable to load default layout algorithm '), 'org.eclipse.elk.layered'), ' for unconfigured node ');
                printElementPath(node, message);
                throw toJs(new UnsupportedConfigurationException_0(message.string));
            }
        } else {
            message = $append_11($append_11(new StringBuilder_1("Layout algorithm '"), algorithmId), "' not found for ");
            printElementPath(node, message);
            throw toJs(new UnsupportedConfigurationException_0(message.string));
        }
    }
}
function $resolveAndSetAlgorithm(algorithmId, node) {
    var algorithmData;
    algorithmData = $getAlgorithmDataBySuffix(getInstance(), algorithmId);
    if (algorithmData) {
        $setProperty_1(node, ($clinit_CoreOptions(), RESOLVED_ALGORITHM), algorithmData);
        return true;
    } else return false;
}
function LayoutAlgorithmResolver() {}
defineClass(1004, 1, {
    521: 1
}, LayoutAlgorithmResolver);
_.visit = function visit_1(element) {
    instanceOf(element, 206) && !$booleanValue(castToBoolean(element.getProperty(($clinit_CoreOptions(), NO_LAYOUT_0)))) && $resolveAlgorithm(castTo(element, 27));
};
var Lorg_eclipse_elk_core_data_LayoutAlgorithmResolver_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutAlgorithmResolver', 1004);
function LayoutCategoryData(builder) {
    this.layouters = new LinkedList;
    this.id_0 = builder.id_0;
    this.name_0 = builder.name_0;
    this.description = builder.description;
}
defineClass(232, 1, {
    685: 1,
    232: 1
}, LayoutCategoryData);
_.equals_0 = function equals_192(obj) {
    if (instanceOf(obj, 232)) return $equals_5(this.id_0, castTo(obj, 232).id_0);
    return false;
};
_.getDescription = function getDescription_0() {
    return this.description;
};
_.getId = function getId_0() {
    return this.id_0;
};
_.getName = function getName_3() {
    return this.name_0;
};
_.hashCode_1 = function hashCode_66() {
    return $hashCode_2(this.id_0);
};
_.toString_0 = function toString_110() {
    return 'Layout Type: ' + this.id_0;
};
var Lorg_eclipse_elk_core_data_LayoutCategoryData_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutCategoryData', 232);
function $description_0(this$static, adescription) {
    this$static.description = adescription;
    return this$static;
}
function $id_0(this$static, aid) {
    this$static.id_0 = aid;
    return this$static;
}
function $name_1(this$static, aname) {
    this$static.name_0 = aname;
    return this$static;
}
function LayoutCategoryData$Builder() {}
defineClass(354, 1, {}, LayoutCategoryData$Builder);
var Lorg_eclipse_elk_core_data_LayoutCategoryData$Builder_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutCategoryData/Builder', 354);
function $getAlgorithmData(this$static, id_0) {
    return castTo($get_16(this$static.layoutAlgorithmMap, id_0), 149);
}
function $getAlgorithmDataBySuffix(this$static, suffix) {
    var d, d$iterator, data_0, entry, id_0, outerIter, suffixlength;
    if (suffix == null || suffix.length == 0) return null;
    data_0 = castTo($getStringValue(this$static.algorithmSuffixMap, suffix), 149);
    if (!data_0) {
        for(d$iterator = (outerIter = new AbstractMap$2(this$static.layoutAlgorithmMap).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter)); d$iterator.val$outerIter2.hasNext_0();){
            d = (entry = castTo(d$iterator.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 149));
            id_0 = d.id_0;
            suffixlength = suffix.length;
            if ($equals_5(id_0.substr(id_0.length - suffixlength, suffixlength), suffix) && (suffix.length == id_0.length || $charAt(id_0, id_0.length - suffix.length - 1) == 46)) {
                if (data_0) return null;
                data_0 = d;
            }
        }
        !!data_0 && $putStringValue(this$static.algorithmSuffixMap, suffix, data_0);
    }
    return data_0;
}
function $getCategoryData(this$static, id_0) {
    return castTo($get_16(this$static.layoutCategoryMap, id_0), 232);
}
function $getOptionData(this$static, id_0) {
    var data_0;
    data_0 = castTo($get_16(this$static.layoutOptionMap, id_0), 21);
    return data_0 ? data_0 : castTo($get_16(this$static.legacyLayoutOptionMap, id_0), 21);
}
function $getOptionDataBySuffix(this$static, suffix) {
    var d, d$iterator, d$iterator0, data_0, entry, id_0, id$array, id$index, id$max, legacyIds, outerIter, outerIter0, suffixlength;
    if (suffix == null || suffix.length == 0) return null;
    data_0 = castTo($getStringValue(this$static.optionSuffixMap, suffix), 21);
    if (!data_0) {
        for(d$iterator0 = (outerIter0 = new AbstractMap$2(this$static.layoutOptionMap).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter0)); d$iterator0.val$outerIter2.hasNext_0();){
            d = (entry = castTo(d$iterator0.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 21));
            id_0 = d.id_0;
            suffixlength = suffix.length;
            if ($equals_5(id_0.substr(id_0.length - suffixlength, suffixlength), suffix) && (suffix.length == id_0.length || $charAt(id_0, id_0.length - suffix.length - 1) == 46)) {
                if (data_0) return null;
                data_0 = d;
            }
        }
        if (!data_0) for(d$iterator = (outerIter = new AbstractMap$2(this$static.layoutOptionMap).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter)); d$iterator.val$outerIter2.hasNext_0();){
            d = (entry = castTo(d$iterator.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 21));
            legacyIds = d.legacyIds;
            if (legacyIds != null) for(id$array = legacyIds, id$index = 0, id$max = id$array.length; id$index < id$max; ++id$index){
                id_0 = id$array[id$index];
                suffixlength = suffix.length;
                if ($equals_5(id_0.substr(id_0.length - suffixlength, suffixlength), suffix) && (suffix.length == id_0.length || $charAt(id_0, id_0.length - suffix.length - 1) == 46)) {
                    if (data_0) return null;
                    data_0 = d;
                }
            }
        }
        !!data_0 && $putStringValue(this$static.optionSuffixMap, suffix, data_0);
    }
    return data_0;
}
function $registerLayoutMetaDataProviders(this$static, providers) {
    var provider, provider$array, provider$index, provider$max, registry;
    for(provider$array = providers, provider$index = 0, provider$max = provider$array.length; provider$index < provider$max; ++provider$index){
        provider = provider$array[provider$index];
        registry = new LayoutMetaDataService$Registry(this$static);
        provider.apply_4(registry);
        $applyDependencies(registry);
    }
    $reset(this$static.optionSuffixMap);
}
function LayoutMetaDataService() {
    this.layoutAlgorithmMap = new LinkedHashMap;
    this.layoutOptionMap = new LinkedHashMap;
    this.legacyLayoutOptionMap = new LinkedHashMap;
    this.layoutCategoryMap = new LinkedHashMap;
    this.algorithmSuffixMap = new HashMap;
    this.optionSuffixMap = new HashMap;
    register(Lorg_eclipse_elk_core_math_KVector_2_classLit, new LayoutMetaDataService$lambda$0$Type, new LayoutMetaDataService$lambda$1$Type);
    register(Lorg_eclipse_elk_core_math_KVectorChain_2_classLit, new LayoutMetaDataService$lambda$2$Type, new LayoutMetaDataService$lambda$3$Type);
    register(Lorg_eclipse_elk_core_math_ElkMargin_2_classLit, new LayoutMetaDataService$lambda$4$Type, new LayoutMetaDataService$lambda$5$Type);
    register(Lorg_eclipse_elk_core_math_ElkPadding_2_classLit, new LayoutMetaDataService$lambda$6$Type, new LayoutMetaDataService$lambda$7$Type);
    register(Lorg_eclipse_elk_core_util_IndividualSpacings_2_classLit, new LayoutMetaDataService$lambda$8$Type, new LayoutMetaDataService$lambda$9$Type);
    register(Ljava_util_ArrayList_2_classLit, new LayoutMetaDataService$lambda$10$Type, new LayoutMetaDataService$lambda$11$Type);
    register(Ljava_util_LinkedList_2_classLit, new LayoutMetaDataService$lambda$12$Type, new LayoutMetaDataService$lambda$13$Type);
    register(Ljava_util_HashSet_2_classLit, new LayoutMetaDataService$lambda$14$Type, new LayoutMetaDataService$lambda$15$Type);
    register(Ljava_util_LinkedHashSet_2_classLit, new LayoutMetaDataService$lambda$16$Type, new LayoutMetaDataService$lambda$17$Type);
    register(Ljava_util_TreeSet_2_classLit, new LayoutMetaDataService$lambda$18$Type, new LayoutMetaDataService$lambda$19$Type);
}
function getInstance() {
    if (!instance_2) {
        instance_2 = new LayoutMetaDataService;
        $registerLayoutMetaDataProviders(instance_2, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new CoreOptions
        ]));
    }
    return instance_2;
}
defineClass(855, 1, {}, LayoutMetaDataService);
var instance_2;
var Lorg_eclipse_elk_core_data_LayoutMetaDataService_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService', 855);
function $addDependency(this$static, sourceOption, targetOption, requiredValue) {
    var dep;
    dep = new LayoutMetaDataService$Registry$Triple;
    dep.firstId = sourceOption;
    dep.secondId = targetOption;
    dep.value_0 = requiredValue;
    $add_7(this$static.optionDependencies, dep);
}
function $addOptionSupport(this$static, algorithm, option, defaultValue) {
    var sup_0;
    sup_0 = new LayoutMetaDataService$Registry$Triple;
    sup_0.firstId = algorithm;
    sup_0.secondId = option;
    sup_0.value_0 = defaultValue;
    $add_7(this$static.optionSupport, sup_0);
}
function $applyDependencies(this$static) {
    var algorithm, algorithm$iterator, category, categoryId, dep, dep$iterator, entry, option, outerIter, source, sup_0, sup$iterator, target;
    for(algorithm$iterator = (outerIter = new AbstractMap$2(this$static.this$01.layoutAlgorithmMap).this$01.entrySet_0().iterator_0(), new AbstractMap$2$1(outerIter)); algorithm$iterator.val$outerIter2.hasNext_0();){
        algorithm = (entry = castTo(algorithm$iterator.val$outerIter2.next_1(), 43), castTo(entry.getValue(), 149));
        categoryId = algorithm.category;
        categoryId == null && (categoryId = '');
        category = $getCategoryData(this$static.this$01, categoryId);
        !category && categoryId.length == 0 && (category = $retrieveBackupCategory(this$static));
        !!category && !$advanceToFind(category.layouters, algorithm, false) && $add_7(category.layouters, algorithm);
    }
    for(dep$iterator = $listIterator_2(this$static.optionDependencies, 0); dep$iterator.currentNode != dep$iterator.this$01.tail;){
        dep = castTo($next_9(dep$iterator), 473);
        source = $getOptionData(this$static.this$01, dep.firstId);
        target = $getOptionData(this$static.this$01, dep.secondId);
        !!source && !!target && $add_7(source.dependencies, new Pair(target, dep.value_0));
    }
    $reset_0(this$static.optionDependencies);
    for(sup$iterator = $listIterator_2(this$static.optionSupport, 0); sup$iterator.currentNode != sup$iterator.this$01.tail;){
        sup_0 = castTo($next_9(sup$iterator), 473);
        algorithm = $getAlgorithmData(this$static.this$01, sup_0.firstId);
        option = $getOptionData(this$static.this$01, sup_0.secondId);
        !!algorithm && !!option && $addKnownOption(algorithm, option, sup_0.value_0);
    }
    $reset_0(this$static.optionSupport);
}
function $register(this$static, algorithmData) {
    $put_11(this$static.this$01.layoutAlgorithmMap, algorithmData.id_0, algorithmData);
}
function $register_0(this$static, categoryData) {
    $put_11(this$static.this$01.layoutCategoryMap, categoryData.id_0, categoryData);
}
function $register_1(this$static, optionData) {
    var id_0, legacyId, legacyId$array, legacyId$index, legacyId$max;
    id_0 = optionData.id_0;
    $put_11(this$static.this$01.layoutOptionMap, id_0, optionData);
    if (optionData.legacyIds != null) for(legacyId$array = optionData.legacyIds, legacyId$index = 0, legacyId$max = legacyId$array.length; legacyId$index < legacyId$max; ++legacyId$index){
        legacyId = legacyId$array[legacyId$index];
        $put_11(this$static.this$01.legacyLayoutOptionMap, legacyId, optionData);
    }
}
function $retrieveBackupCategory(this$static) {
    var otherCategory;
    otherCategory = castTo($get_16(this$static.this$01.layoutCategoryMap, ''), 232);
    if (!otherCategory) {
        otherCategory = new LayoutCategoryData($name_1($id_0(new LayoutCategoryData$Builder, ''), 'Other'));
        $put_11(this$static.this$01.layoutCategoryMap, '', otherCategory);
    }
    return otherCategory;
}
function LayoutMetaDataService$Registry(this$0) {
    this.this$01 = this$0;
    this.optionDependencies = new LinkedList;
    this.optionSupport = new LinkedList;
}
defineClass(856, 1, {}, LayoutMetaDataService$Registry);
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$Registry_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/Registry', 856);
function LayoutMetaDataService$Registry$Triple() {}
defineClass(473, 1, {
    473: 1
}, LayoutMetaDataService$Registry$Triple);
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$Registry$Triple_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/Registry/Triple', 473);
function LayoutMetaDataService$lambda$0$Type() {}
defineClass(857, 1, $intern_131, LayoutMetaDataService$lambda$0$Type);
_.newInstance = function newInstance_0() {
    return new KVector;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$0$Type', 857);
function LayoutMetaDataService$lambda$1$Type() {}
defineClass(858, 1, $intern_132, LayoutMetaDataService$lambda$1$Type);
_.clone = function clone_1(arg0) {
    return $clone_1(castTo(arg0, 8));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$1$Type', 858);
function LayoutMetaDataService$lambda$10$Type() {}
defineClass(867, 1, $intern_131, LayoutMetaDataService$lambda$10$Type);
_.newInstance = function newInstance_1() {
    return new ArrayList;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$10$Type', 867);
function LayoutMetaDataService$lambda$11$Type() {}
defineClass(868, 1, $intern_132, LayoutMetaDataService$lambda$11$Type);
_.clone = function clone_2(arg0) {
    return new ArrayList_1(castTo(arg0, 13));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$11$Type', 868);
function LayoutMetaDataService$lambda$12$Type() {}
defineClass(869, 1, $intern_131, LayoutMetaDataService$lambda$12$Type);
_.newInstance = function newInstance_2() {
    return new LinkedList;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$12$Type', 869);
function LayoutMetaDataService$lambda$13$Type() {}
defineClass(870, 1, $intern_132, LayoutMetaDataService$lambda$13$Type);
_.clone = function clone_3(arg0) {
    return newLinkedList(castTo(arg0, 67));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$13$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$13$Type', 870);
function LayoutMetaDataService$lambda$14$Type() {}
defineClass(871, 1, $intern_131, LayoutMetaDataService$lambda$14$Type);
_.newInstance = function newInstance_3() {
    return new HashSet;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$14$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$14$Type', 871);
function LayoutMetaDataService$lambda$15$Type() {}
defineClass(872, 1, $intern_132, LayoutMetaDataService$lambda$15$Type);
_.clone = function clone_4(arg0) {
    return newHashSet(castTo(arg0, 50));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$15$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$15$Type', 872);
function LayoutMetaDataService$lambda$16$Type() {}
defineClass(873, 1, $intern_131, LayoutMetaDataService$lambda$16$Type);
_.newInstance = function newInstance_4() {
    return new LinkedHashSet;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$16$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$16$Type', 873);
function LayoutMetaDataService$lambda$17$Type() {}
defineClass(874, 1, $intern_132, LayoutMetaDataService$lambda$17$Type);
_.clone = function clone_5(arg0) {
    return newLinkedHashSet(castTo(arg0, 50));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$17$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$17$Type', 874);
function LayoutMetaDataService$lambda$18$Type() {}
defineClass(875, 1, $intern_131, LayoutMetaDataService$lambda$18$Type);
_.newInstance = function newInstance_5() {
    return new TreeSet;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$18$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$18$Type', 875);
function LayoutMetaDataService$lambda$19$Type() {}
defineClass(876, 1, $intern_132, LayoutMetaDataService$lambda$19$Type);
_.clone = function clone_6(arg0) {
    return newTreeSet(castTo(arg0, 156));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$19$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$19$Type', 876);
function LayoutMetaDataService$lambda$2$Type() {}
defineClass(859, 1, $intern_131, LayoutMetaDataService$lambda$2$Type);
_.newInstance = function newInstance_6() {
    return new KVectorChain;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$2$Type', 859);
function LayoutMetaDataService$lambda$3$Type() {}
defineClass(860, 1, $intern_132, LayoutMetaDataService$lambda$3$Type);
_.clone = function clone_7(arg0) {
    return new KVectorChain_0(castTo(arg0, 77));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$3$Type', 860);
function LayoutMetaDataService$lambda$4$Type() {}
defineClass(861, 1, $intern_131, LayoutMetaDataService$lambda$4$Type);
_.newInstance = function newInstance_7() {
    return new ElkMargin;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$4$Type', 861);
function LayoutMetaDataService$lambda$5$Type() {}
defineClass(862, 1, $intern_132, LayoutMetaDataService$lambda$5$Type);
_.clone = function clone_8(arg0) {
    return new ElkMargin_2(castTo(arg0, 139));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$5$Type', 862);
function LayoutMetaDataService$lambda$6$Type() {}
defineClass(863, 1, $intern_131, LayoutMetaDataService$lambda$6$Type);
_.newInstance = function newInstance_8() {
    return new ElkPadding;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$6$Type', 863);
function LayoutMetaDataService$lambda$7$Type() {}
defineClass(864, 1, $intern_132, LayoutMetaDataService$lambda$7$Type);
_.clone = function clone_9(arg0) {
    return new ElkPadding_1(castTo(arg0, 107));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$7$Type', 864);
function LayoutMetaDataService$lambda$8$Type() {}
defineClass(865, 1, $intern_131, LayoutMetaDataService$lambda$8$Type);
_.newInstance = function newInstance_9() {
    return new IndividualSpacings;
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$8$Type', 865);
function LayoutMetaDataService$lambda$9$Type() {}
defineClass(866, 1, $intern_132, LayoutMetaDataService$lambda$9$Type);
_.clone = function clone_10(arg0) {
    return new IndividualSpacings_0(castTo(arg0, 377));
};
var Lorg_eclipse_elk_core_data_LayoutMetaDataService$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutMetaDataService/lambda$9$Type', 866);
var Lorg_eclipse_elk_graph_properties_IProperty_2_classLit = createForInterface('org.eclipse.elk.graph.properties', 'IProperty');
function $checkEnumClass(this$static) {
    if (!this$static.clazz || (this$static.clazz.modifiers & 8) == 0) throw toJs(new IllegalStateException_0('Enumeration class expected for layout option ' + this$static.id_0));
}
function $compareTo_19(this$static, other) {
    return $compareTo_9(this$static.id_0, other.getId());
}
function $createDataInstance(this$static) {
    var instance;
    if (!this$static.clazz) throw toJs(new IllegalStateException_0('IDataType class expected for layout option ' + this$static.id_0));
    instance = newInstance_10(this$static.clazz);
    if (instance == null) throw toJs(new IllegalStateException_0("Couldn't create new instance of property '" + this$static.id_0 + "'. " + 'Make sure its type is registered with the ' + ($ensureNamesAreInitialized(Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit), Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit.simpleName) + ' utility class.'));
    return castTo(instance, 411);
}
function $enumForString(this$static, leString) {
    var constants, index_0, value_0;
    try {
        value_0 = valueOf_0(this$static.clazz, leString);
        return value_0;
    } catch ($e1) {
        $e1 = toJava($e1);
        if (instanceOf($e1, 32)) {
            try {
                index_0 = __parseAndValidateInt(leString, $intern_42, $intern_0);
                constants = $getEnumConstants(this$static.clazz);
                if (index_0 >= 0 && index_0 < constants.length) return constants[index_0];
            } catch ($e0) {
                $e0 = toJava($e0);
                if (!instanceOf($e0, 130)) throw toJs($e0);
            }
            return null;
        } else throw toJs($e1);
    }
}
function $enumSetForStringArray(this$static, leClazz, leString) {
    var all, component, component$array, component$index, component$max, components, o, set_0;
    set_0 = (all = castTo(leClazz.enumConstantsFunc && leClazz.enumConstantsFunc(), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    components = $split_0(leString, '[\\[\\]\\s,]+');
    for(component$array = components, component$index = 0, component$max = component$array.length; component$index < component$max; ++component$index){
        component = component$array[component$index];
        if ($trim(component).length == 0) continue;
        o = $enumForString(this$static, component);
        if (o == null) return null;
        else $add_5(set_0, castTo(o, 23));
    }
    return set_0;
}
function $parseValue(this$static, valueString) {
    var value_0;
    if (valueString == null || $equals_5(valueString, 'null')) return null;
    if (valueString.length == 0 && this$static.type_0 != ($clinit_LayoutOptionData$Type(), ENUMSET)) return null;
    switch(this$static.type_0.ordinal){
        case 1:
            return $equalsIgnoreCase(valueString, 'true') ? ($clinit_Boolean(), TRUE_0) : $equalsIgnoreCase(valueString, 'false') ? ($clinit_Boolean(), FALSE_0) : null;
        case 2:
            try {
                return valueOf_3(__parseAndValidateInt(valueString, $intern_42, $intern_0));
            } catch ($e0) {
                $e0 = toJava($e0);
                if (instanceOf($e0, 130)) return null;
                else throw toJs($e0);
            }
        case 4:
            try {
                return __parseAndValidateDouble(valueString);
            } catch ($e1) {
                $e1 = toJava($e1);
                if (instanceOf($e1, 130)) return null;
                else throw toJs($e1);
            }
        case 3:
            return valueString;
        case 5:
            $checkEnumClass(this$static);
            return $enumForString(this$static, valueString);
        case 6:
            $checkEnumClass(this$static);
            return $enumSetForStringArray(this$static, this$static.clazz, valueString);
        case 7:
            try {
                value_0 = $createDataInstance(this$static);
                value_0.parse_0(valueString);
                return value_0;
            } catch ($e2) {
                $e2 = toJava($e2);
                if (instanceOf($e2, 32)) return null;
                else throw toJs($e2);
            }
        default:
            throw toJs(new IllegalStateException_0('Invalid type set for this layout option.'));
    }
}
function LayoutOptionData(builder) {
    var all;
    this.dependencies = new LinkedList;
    this.id_0 = builder.id_0;
    this.group_0 = builder.group_0;
    this.name_0 = builder.name_0;
    this.description = builder.description;
    this.defaultValue = builder.defaultValue;
    this.type_0 = builder.type_0;
    this.clazz = builder.clazz;
    !builder.targets ? this.targets = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)) : this.targets = builder.targets;
    this.legacyIds = builder.legacyIds;
}
defineClass(21, 1, {
    34: 1,
    685: 1,
    21: 1,
    144: 1
}, LayoutOptionData);
_.compareTo_0 = function compareTo_20(other) {
    return $compareTo_19(this, castTo(other, 144));
};
_.equals_0 = function equals_193(obj) {
    return instanceOf(obj, 21) ? $equals_5(this.id_0, castTo(obj, 21).id_0) : instanceOf(obj, 144) && $equals_5(this.id_0, castTo(obj, 144).getId());
};
_.getDefault = function getDefault() {
    var clone;
    if (instanceOf(this.defaultValue, 4)) {
        clone = clone_11(this.defaultValue);
        if (clone == null) throw toJs(new IllegalStateException_0("Couldn't clone property '" + this.id_0 + "'. " + "Make sure it's type is registered with the " + ($ensureNamesAreInitialized(Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit), Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit.simpleName) + ' utility class.'));
        return clone;
    } else return this.defaultValue;
};
_.getDescription = function getDescription_1() {
    return this.description;
};
_.getId = function getId_1() {
    return this.id_0;
};
_.getName = function getName_4() {
    return this.name_0;
};
_.hashCode_1 = function hashCode_67() {
    return $hashCode_2(this.id_0);
};
_.toString_0 = function toString_111() {
    return 'Layout Option: ' + this.id_0;
};
var Lorg_eclipse_elk_core_data_LayoutOptionData_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutOptionData', 21);
function $defaultValue(this$static, adefaultValue) {
    this$static.defaultValue = adefaultValue;
    return this$static;
}
function $description_1(this$static, adescription) {
    this$static.description = adescription;
    return this$static;
}
function $group(this$static, agroup) {
    this$static.group_0 = agroup;
    return this$static;
}
function $id_1(this$static, aid) {
    this$static.id_0 = aid;
    return this$static;
}
function $legacyIds(this$static, alegacyIds) {
    this$static.legacyIds = alegacyIds;
    return this$static;
}
function $name_2(this$static, aname) {
    this$static.name_0 = aname;
    return this$static;
}
function $optionClass(this$static, aclazz) {
    this$static.clazz = aclazz;
    return this$static;
}
function $targets(this$static, atargets) {
    this$static.targets = atargets;
    return this$static;
}
function $type(this$static, atype) {
    this$static.type_0 = atype;
    return this$static;
}
function LayoutOptionData$Builder() {}
defineClass(24, 1, {}, LayoutOptionData$Builder);
var Lorg_eclipse_elk_core_data_LayoutOptionData$Builder_2_classLit = createForClass('org.eclipse.elk.core.data', 'LayoutOptionData/Builder', 24);
function $clinit_LayoutOptionData$Target() {
    $clinit_LayoutOptionData$Target = emptyMethod;
    PARENTS = new LayoutOptionData$Target('PARENTS', 0);
    NODES = new LayoutOptionData$Target('NODES', 1);
    EDGES = new LayoutOptionData$Target('EDGES', 2);
    PORTS = new LayoutOptionData$Target('PORTS', 3);
    LABELS = new LayoutOptionData$Target('LABELS', 4);
}
function LayoutOptionData$Target(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_91(name_0) {
    $clinit_LayoutOptionData$Target();
    return valueOf(($clinit_LayoutOptionData$Target$Map(), $MAP_81), name_0);
}
function values_99() {
    $clinit_LayoutOptionData$Target();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        PARENTS,
        NODES,
        EDGES,
        PORTS,
        LABELS
    ]);
}
defineClass(170, 23, {
    3: 1,
    34: 1,
    23: 1,
    170: 1
}, LayoutOptionData$Target);
var EDGES, LABELS, NODES, PARENTS, PORTS;
var Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit = createForEnum('org.eclipse.elk.core.data', 'LayoutOptionData/Target', 170, Ljava_lang_Enum_2_classLit, values_99, valueOf_91);
function $clinit_LayoutOptionData$Target$Map() {
    $clinit_LayoutOptionData$Target$Map = emptyMethod;
    $MAP_81 = createValueOfMap(($clinit_LayoutOptionData$Target(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        PARENTS,
        NODES,
        EDGES,
        PORTS,
        LABELS
    ])));
}
var $MAP_81;
function $clinit_LayoutOptionData$Type() {
    $clinit_LayoutOptionData$Type = emptyMethod;
    UNDEFINED_1 = new LayoutOptionData$Type('UNDEFINED', 0);
    BOOLEAN = new LayoutOptionData$Type('BOOLEAN', 1);
    INT = new LayoutOptionData$Type('INT', 2);
    STRING = new LayoutOptionData$Type('STRING', 3);
    DOUBLE = new LayoutOptionData$Type('DOUBLE', 4);
    ENUM = new LayoutOptionData$Type('ENUM', 5);
    ENUMSET = new LayoutOptionData$Type('ENUMSET', 6);
    OBJECT = new LayoutOptionData$Type('OBJECT', 7);
}
function LayoutOptionData$Type(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_92(name_0) {
    $clinit_LayoutOptionData$Type();
    return valueOf(($clinit_LayoutOptionData$Type$Map(), $MAP_82), name_0);
}
function values_100() {
    $clinit_LayoutOptionData$Type();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Type_2_classLit, 1), $intern_36, 282, 0, [
        UNDEFINED_1,
        BOOLEAN,
        INT,
        STRING,
        DOUBLE,
        ENUM,
        ENUMSET,
        OBJECT
    ]);
}
defineClass(282, 23, {
    3: 1,
    34: 1,
    23: 1,
    282: 1
}, LayoutOptionData$Type);
var BOOLEAN, DOUBLE, ENUM, ENUMSET, INT, OBJECT, STRING, UNDEFINED_1;
var Lorg_eclipse_elk_core_data_LayoutOptionData$Type_2_classLit = createForEnum('org.eclipse.elk.core.data', 'LayoutOptionData/Type', 282, Ljava_lang_Enum_2_classLit, values_100, valueOf_92);
function $clinit_LayoutOptionData$Type$Map() {
    $clinit_LayoutOptionData$Type$Map = emptyMethod;
    $MAP_82 = createValueOfMap(($clinit_LayoutOptionData$Type(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Type_2_classLit, 1), $intern_36, 282, 0, [
        UNDEFINED_1,
        BOOLEAN,
        INT,
        STRING,
        DOUBLE,
        ENUM,
        ENUMSET,
        OBJECT
    ])));
}
var $MAP_82;
function $clinit_LabelManagementOptions() {
    $clinit_LabelManagementOptions = emptyMethod;
    LABEL_MANAGER = new Property('org.eclipse.elk.labels.labelManager');
}
var LABEL_MANAGER;
function $clinit_ElkMath() {
    $clinit_ElkMath = emptyMethod;
    FACT_TABLE = stampJavaTypeInfo(getClassLiteralForArray(J_classLit, 1), $intern_63, 30, 14, [
        1,
        1,
        2,
        6,
        24,
        120,
        720,
        5040,
        40320,
        362880,
        3628800,
        39916800,
        479001600,
        6227020800,
        87178291200,
        1307674368000,
        {
            l: 3506176,
            m: 794077,
            h: 1
        },
        {
            l: 884736,
            m: 916411,
            h: 20
        },
        {
            l: 3342336,
            m: 3912489,
            h: 363
        },
        {
            l: 589824,
            m: 3034138,
            h: 6914
        },
        {
            l: 3407872,
            m: 1962506,
            h: 138294
        }
    ]);
    $wnd.Math.pow(2, -65);
}
function approximateBezierSegment(controlPoints) {
    $clinit_ElkMath();
    var i, result, t;
    result = initUnidimensionalArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, $intern_16, 8, 2, 0, 1);
    t = 0;
    for(i = 0; i < 2; i++){
        t += 0.5;
        result[i] = getPointOnBezierSegment(t, controlPoints);
    }
    return result;
}
function binomiald(n, k) {
    if (n < 0 || k < 0) throw toJs(new IllegalArgumentException_0('k and n must be positive'));
    else if (k > n) throw toJs(new IllegalArgumentException_0('k must be smaller than n'));
    else return k == 0 || k == n ? 1 : n == 0 ? 0 : factd(n) / (factd(k) * factd(n - k));
}
function clipVector(v, width_0, height) {
    $clinit_ElkMath();
    var absx, absy, hh, wh, xscale, yscale;
    wh = width_0 / 2;
    hh = height / 2;
    absx = $wnd.Math.abs(v.x_0);
    absy = $wnd.Math.abs(v.y_0);
    xscale = 1;
    yscale = 1;
    absx > wh && (xscale = wh / absx);
    absy > hh && (yscale = hh / absy);
    $scale(v, $wnd.Math.min(xscale, yscale));
    return v;
}
function contains_49(rect, p) {
    var maxX, maxY, minX, minY;
    minX = rect.x_0;
    maxX = rect.x_0 + rect.width_0;
    minY = rect.y_0;
    maxY = rect.y_0 + rect.height;
    return p.x_0 > minX && p.x_0 < maxX && p.y_0 > minY && p.y_0 < maxY;
}
function contains_50(rect, p1, p2) {
    $clinit_ElkMath();
    return contains_49(rect, p1) && contains_49(rect, p2);
}
function distance_0(a1, a2, b1, b2, v) {
    $clinit_ElkMath();
    return $wnd.Math.min(traceRays(a1, a2, b1, b2, v), traceRays(b1, b2, a1, a2, $negate_0(new KVector_1(v.x_0, v.y_0))));
}
function factd(x_0) {
    if (x_0 < 0) throw toJs(new IllegalArgumentException_0('The input must be positive'));
    else return x_0 < FACT_TABLE.length ? toDouble_0(FACT_TABLE[x_0]) : $wnd.Math.sqrt($intern_125 * x_0) * (powf(x_0, x_0) / powd(2.718281828459045, x_0));
}
function getPointOnBezierSegment(t, controlPoints) {
    var factor, j, n, p, px, py;
    n = controlPoints.length - 1;
    px = 0;
    py = 0;
    for(j = 0; j <= n; j++){
        p = controlPoints[j];
        factor = binomiald(n, j) * powd(1 - t, n - j) * powd(t, j);
        px += p.x_0 * factor;
        py += p.y_0 * factor;
    }
    return new KVector_1(px, py);
}
function intersects_0(rect, p1, p2) {
    $clinit_ElkMath();
    if (contains_49(rect, p1) && contains_49(rect, p2)) return false;
    return intersects_1(new KVector_1(rect.x_0, rect.y_0), new KVector_1(rect.x_0 + rect.width_0, rect.y_0), p1, p2) || intersects_1(new KVector_1(rect.x_0 + rect.width_0, rect.y_0), new KVector_1(rect.x_0 + rect.width_0, rect.y_0 + rect.height), p1, p2) || intersects_1(new KVector_1(rect.x_0 + rect.width_0, rect.y_0 + rect.height), new KVector_1(rect.x_0, rect.y_0 + rect.height), p1, p2) || intersects_1(new KVector_1(rect.x_0, rect.y_0 + rect.height), new KVector_1(rect.x_0, rect.y_0), p1, p2);
}
function intersects_1(l11, l12, l21, l22) {
    var d, intersects, s, t, u0, u1, v0, v1, x00, x01, x10, x11, y00, y01, y10, y11;
    u0 = l11;
    v0 = $sub_0(new KVector_1(l12.x_0, l12.y_0), l11);
    u1 = l21;
    v1 = $sub_0(new KVector_1(l22.x_0, l22.y_0), l21);
    x00 = u0.x_0;
    y00 = u0.y_0;
    x10 = u1.x_0;
    y10 = u1.y_0;
    x01 = v0.x_0;
    y01 = v0.y_0;
    x11 = v1.x_0;
    y11 = v1.y_0;
    d = x11 * y01 - x01 * y11;
    $clinit_DoubleMath();
    checkNonNegative($intern_115);
    if ($wnd.Math.abs(0 - d) <= $intern_115 || 0 == d || isNaN(0) && isNaN(d)) return false;
    s = 1 / d * ((x00 - x10) * y01 - (y00 - y10) * x01);
    t = 1 / d * -(-(x00 - x10) * y11 + (y00 - y10) * x11);
    intersects = (checkNonNegative($intern_115), ($wnd.Math.abs(0 - s) <= $intern_115 || 0 == s || isNaN(0) && isNaN(s) ? 0 : 0 < s ? -1 : 0 > s ? 1 : compare_0(isNaN(0), isNaN(s))) < 0 && (checkNonNegative($intern_115), ($wnd.Math.abs(s - 1) <= $intern_115 || s == 1 || isNaN(s) && isNaN(1) ? 0 : s < 1 ? -1 : s > 1 ? 1 : compare_0(isNaN(s), isNaN(1))) < 0) && (checkNonNegative($intern_115), ($wnd.Math.abs(0 - t) <= $intern_115 || 0 == t || isNaN(0) && isNaN(t) ? 0 : 0 < t ? -1 : 0 > t ? 1 : compare_0(isNaN(0), isNaN(t))) < 0) && (checkNonNegative($intern_115), ($wnd.Math.abs(t - 1) <= $intern_115 || t == 1 || isNaN(t) && isNaN(1) ? 0 : t < 1 ? -1 : t > 1 ? 1 : compare_0(isNaN(t), isNaN(1))) < 0));
    return intersects;
}
function intersects2(p, r, q, s) {
    var center, d1, d2, l, pq, pqXr, rXs, t, u;
    pq = $sub_0(new KVector_1(q.x_0, q.y_0), p);
    pqXr = pq.x_0 * r.y_0 - pq.y_0 * r.x_0;
    rXs = r.x_0 * s.y_0 - r.y_0 * s.x_0;
    t = (pq.x_0 * s.y_0 - pq.y_0 * s.x_0) / rXs;
    u = pqXr / rXs;
    if (rXs == 0) {
        if (pqXr == 0) {
            center = $add_19(new KVector_1(q.x_0, q.y_0), $scale(new KVector_1(s.x_0, s.y_0), 0.5));
            d1 = $distance_0(p, center);
            d2 = $distance_0($add_19(new KVector_1(p.x_0, p.y_0), r), center);
            l = $wnd.Math.sqrt(s.x_0 * s.x_0 + s.y_0 * s.y_0) * 0.5;
            if (d1 < d2 && d1 <= l) return new KVector_1(p.x_0, p.y_0);
            if (d2 <= l) return $add_19(new KVector_1(p.x_0, p.y_0), r);
            return null;
        } else return null;
    } else return t >= 0 && t <= 1 && u >= 0 && u <= 1 ? $add_19(new KVector_1(p.x_0, p.y_0), $scale(new KVector_1(r.x_0, r.y_0), t)) : null;
}
function maxd(values) {
    $clinit_ElkMath();
    var i, max_0;
    max_0 = $intern_123;
    for(i = 0; i < values.length; i++)values[i] > max_0 && (max_0 = values[i]);
    return max_0;
}
function powd(a, b) {
    var base, exp_0, result;
    result = 1;
    base = a;
    exp_0 = b >= 0 ? b : -b;
    while(exp_0 > 0)if (exp_0 % 2 == 0) {
        base *= base;
        exp_0 = exp_0 / 2 | 0;
    } else {
        result *= base;
        exp_0 -= 1;
    }
    return b < 0 ? 1 / result : result;
}
function powf(a, b) {
    var base, exp_0, result;
    result = 1;
    base = a;
    exp_0 = b >= 0 ? b : -b;
    while(exp_0 > 0)if (exp_0 % 2 == 0) {
        base *= base;
        exp_0 = exp_0 / 2 | 0;
    } else {
        result *= base;
        exp_0 -= 1;
    }
    return b < 0 ? 1 / result : result;
}
function shortestDistance(r1, r2) {
    $clinit_ElkMath();
    var bottomDist, horzDist, leftDist, rightDist, topDist, vertDist;
    rightDist = r2.x_0 - (r1.x_0 + r1.width_0);
    leftDist = r1.x_0 - (r2.x_0 + r2.width_0);
    topDist = r1.y_0 - (r2.y_0 + r2.height);
    bottomDist = r2.y_0 - (r1.y_0 + r1.height);
    horzDist = $wnd.Math.max(leftDist, rightDist);
    vertDist = $wnd.Math.max(topDist, bottomDist);
    $clinit_DoubleMath();
    checkNonNegative($intern_115);
    if (($wnd.Math.abs(horzDist) <= $intern_115 || horzDist == 0 || isNaN(horzDist) && isNaN(0) ? 0 : horzDist < 0 ? -1 : horzDist > 0 ? 1 : compare_0(isNaN(horzDist), isNaN(0))) >= 0 ^ (checkNonNegative($intern_115), ($wnd.Math.abs(vertDist) <= $intern_115 || vertDist == 0 || isNaN(vertDist) && isNaN(0) ? 0 : vertDist < 0 ? -1 : vertDist > 0 ? 1 : compare_0(isNaN(vertDist), isNaN(0))) >= 0)) return $wnd.Math.max(vertDist, horzDist);
    checkNonNegative($intern_115);
    if (($wnd.Math.abs(horzDist) <= $intern_115 || horzDist == 0 || isNaN(horzDist) && isNaN(0) ? 0 : horzDist < 0 ? -1 : horzDist > 0 ? 1 : compare_0(isNaN(horzDist), isNaN(0))) > 0) return $wnd.Math.sqrt(vertDist * vertDist + horzDist * horzDist);
    return -$wnd.Math.sqrt(vertDist * vertDist + horzDist * horzDist);
}
function traceRays(a1, a2, b1, b2, v) {
    var edgeCase, endpointHit, intersection, result;
    result = $intern_60;
    endpointHit = false;
    intersection = intersects2(a1, $sub_0(new KVector_1(a2.x_0, a2.y_0), a1), $add_19(new KVector_1(b1.x_0, b1.y_0), v), $sub_0(new KVector_1(b2.x_0, b2.y_0), b1));
    edgeCase = !!intersection && !($wnd.Math.abs(intersection.x_0 - a1.x_0) <= $intern_133 && $wnd.Math.abs(intersection.y_0 - a1.y_0) <= $intern_133 || $wnd.Math.abs(intersection.x_0 - a2.x_0) <= $intern_133 && $wnd.Math.abs(intersection.y_0 - a2.y_0) <= $intern_133);
    intersection = intersects2(a1, $sub_0(new KVector_1(a2.x_0, a2.y_0), a1), b1, v);
    !!intersection && (($wnd.Math.abs(intersection.x_0 - a1.x_0) <= $intern_133 && $wnd.Math.abs(intersection.y_0 - a1.y_0) <= $intern_133) == ($wnd.Math.abs(intersection.x_0 - a2.x_0) <= $intern_133 && $wnd.Math.abs(intersection.y_0 - a2.y_0) <= $intern_133) || edgeCase ? result = $wnd.Math.min(result, $length($sub_0(intersection, b1))) : endpointHit = true);
    intersection = intersects2(a1, $sub_0(new KVector_1(a2.x_0, a2.y_0), a1), b2, v);
    !!intersection && (endpointHit || ($wnd.Math.abs(intersection.x_0 - a1.x_0) <= $intern_133 && $wnd.Math.abs(intersection.y_0 - a1.y_0) <= $intern_133) == ($wnd.Math.abs(intersection.x_0 - a2.x_0) <= $intern_133 && $wnd.Math.abs(intersection.y_0 - a2.y_0) <= $intern_133) || edgeCase) && (result = $wnd.Math.min(result, $length($sub_0(intersection, b2))));
    return result;
}
var FACT_TABLE;
function $getBottomLeft(this$static) {
    return new KVector_1(this$static.x_0, this$static.y_0 + this$static.height);
}
function $getBottomRight(this$static) {
    return new KVector_1(this$static.x_0 + this$static.width_0, this$static.y_0 + this$static.height);
}
function $getCenter(this$static) {
    return new KVector_1(this$static.x_0 + this$static.width_0 / 2, this$static.y_0 + this$static.height / 2);
}
function $getPosition(this$static) {
    return new KVector_1(this$static.x_0, this$static.y_0);
}
function $getTopLeft(this$static) {
    return new KVector_1(this$static.x_0, this$static.y_0);
}
function $setRect(this$static, nx, ny, nw, nh) {
    this$static.x_0 = nx;
    this$static.y_0 = ny;
    this$static.width_0 = nw;
    this$static.height = nh;
}
function $union(this$static, other) {
    var t, x1, x2, y1, y2;
    x1 = $wnd.Math.min(this$static.x_0, other.x_0);
    y1 = $wnd.Math.min(this$static.y_0, other.y_0);
    x2 = $wnd.Math.max(this$static.x_0 + this$static.width_0, other.x_0 + other.width_0);
    y2 = $wnd.Math.max(this$static.y_0 + this$static.height, other.y_0 + other.height);
    if (x2 < x1) {
        t = x1;
        x1 = x2;
        x2 = t;
    }
    if (y2 < y1) {
        t = y1;
        y1 = y2;
        y2 = t;
    }
    $setRect(this$static, x1, y1, x2 - x1, y2 - y1);
}
function ElkRectangle() {
    ElkRectangle_0.call(this, 0, 0, 0, 0);
}
function ElkRectangle_0(x_0, y_0, w, h) {
    this.x_0 = x_0;
    this.y_0 = y_0;
    this.width_0 = w;
    this.height = h;
}
function ElkRectangle_1(rect) {
    this.x_0 = rect.x_0;
    this.y_0 = rect.y_0;
    this.width_0 = rect.width_0;
    this.height = rect.height;
}
defineClass(119, 1, {
    119: 1
}, ElkRectangle, ElkRectangle_0, ElkRectangle_1);
_.equals_0 = function equals_194(obj) {
    var other;
    if (obj == null || !instanceOf(obj, 119)) return false;
    other = castTo(obj, 119);
    return equals_57(this.x_0, other.x_0) && equals_57(this.y_0, other.y_0) && equals_57(this.width_0, other.width_0) && equals_57(this.height, other.height);
};
_.hashCode_1 = function hashCode_68() {
    return hashCode_47(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        this.x_0,
        this.y_0,
        this.width_0,
        this.height
    ]));
};
_.toString_0 = function toString_112() {
    return 'Rect[x=' + this.x_0 + ',y=' + this.y_0 + ',w=' + this.width_0 + ',h=' + this.height + ']';
};
_.height = 0;
_.width_0 = 0;
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_core_math_ElkRectangle_2_classLit = createForClass('org.eclipse.elk.core.math', 'ElkRectangle', 119);
function $add_18(this$static, dx, dy) {
    this$static.x_0 += dx;
    this$static.y_0 += dy;
    return this$static;
}
function $add_19(this$static, v) {
    this$static.x_0 += v.x_0;
    this$static.y_0 += v.y_0;
    return this$static;
}
function $bound(this$static, lowx, lowy, highx, highy) {
    if (highx < lowx || highy < lowy) throw toJs(new IllegalArgumentException_0('The highx must be bigger then lowx and the highy must be bigger then lowy'));
    this$static.x_0 < lowx ? this$static.x_0 = lowx : this$static.x_0 > highx && (this$static.x_0 = highx);
    this$static.y_0 < lowy ? this$static.y_0 = lowy : this$static.y_0 > highy && (this$static.y_0 = highy);
    return this$static;
}
function $clone_1(this$static) {
    return new KVector_1(this$static.x_0, this$static.y_0);
}
function $distance_0(this$static, v2) {
    var dx, dy;
    dx = this$static.x_0 - v2.x_0;
    dy = this$static.y_0 - v2.y_0;
    return $wnd.Math.sqrt(dx * dx + dy * dy);
}
function $dotProduct(this$static, v2) {
    return this$static.x_0 * v2.x_0 + this$static.y_0 * v2.y_0;
}
function $equals_9(this$static, obj) {
    var other;
    if (instanceOf(obj, 8)) {
        other = castTo(obj, 8);
        return this$static.x_0 == other.x_0 && this$static.y_0 == other.y_0;
    } else return false;
}
function $length(this$static) {
    return $wnd.Math.sqrt(this$static.x_0 * this$static.x_0 + this$static.y_0 * this$static.y_0);
}
function $negate_0(this$static) {
    this$static.x_0 = -this$static.x_0;
    this$static.y_0 = -this$static.y_0;
    return this$static;
}
function $normalize_0(this$static) {
    var length_0;
    length_0 = $wnd.Math.sqrt(this$static.x_0 * this$static.x_0 + this$static.y_0 * this$static.y_0);
    if (length_0 > 0) {
        this$static.x_0 /= length_0;
        this$static.y_0 /= length_0;
    }
    return this$static;
}
function $reset_5(this$static) {
    this$static.x_0 = 0;
    this$static.y_0 = 0;
    return this$static;
}
function $scale(this$static, scale) {
    this$static.x_0 *= scale;
    this$static.y_0 *= scale;
    return this$static;
}
function $scaleToLength(this$static, length_0) {
    $normalize_0(this$static);
    this$static.x_0 *= length_0;
    this$static.y_0 *= length_0;
    return this$static;
}
function $set_6(this$static, newX, newY) {
    this$static.x_0 = newX;
    this$static.y_0 = newY;
    return this$static;
}
function $set_7(this$static, other) {
    this$static.x_0 = other.x_0;
    this$static.y_0 = other.y_0;
    return this$static;
}
function $sub(this$static, dx, dy) {
    this$static.x_0 -= dx;
    this$static.y_0 -= dy;
    return this$static;
}
function $sub_0(this$static, v) {
    this$static.x_0 -= v.x_0;
    this$static.y_0 -= v.y_0;
    return this$static;
}
function KVector() {
    this.x_0 = 0;
    this.y_0 = 0;
}
function KVector_0(angle) {
    this.x_0 = $wnd.Math.cos(angle);
    this.y_0 = $wnd.Math.sin(angle);
}
function KVector_1(thex, they) {
    this.x_0 = thex;
    this.y_0 = they;
}
function KVector_2(v) {
    this.x_0 = v.x_0;
    this.y_0 = v.y_0;
}
function isdelim_0(c, delims) {
    var i;
    for(i = 0; i < delims.length; i++){
        if (c == (checkCriticalStringElementIndex(i, delims.length), delims.charCodeAt(i))) return true;
    }
    return false;
}
function sum_0(vs) {
    var sum, v, v$array, v$index, v$max;
    sum = new KVector;
    for(v$array = vs, v$index = 0, v$max = v$array.length; v$index < v$max; ++v$index){
        v = v$array[v$index];
        sum.x_0 += v.x_0;
        sum.y_0 += v.y_0;
    }
    return sum;
}
defineClass(8, 1, {
    3: 1,
    4: 1,
    8: 1,
    411: 1
}, KVector, KVector_0, KVector_1, KVector_2);
_.equals_0 = function equals_195(obj) {
    return $equals_9(this, obj);
};
_.hashCode_1 = function hashCode_69() {
    return $hashCode_1(this.x_0) + reverse_1($hashCode_1(this.y_0));
};
_.parse_0 = function parse_1(string) {
    var end, exception, start_0, tokens;
    start_0 = 0;
    while(start_0 < string.length && isdelim_0((checkCriticalStringElementIndex(start_0, string.length), string.charCodeAt(start_0)), '([{"\' \t\r\n'))++start_0;
    end = string.length;
    while(end > 0 && isdelim_0((checkCriticalStringElementIndex(end - 1, string.length), string.charCodeAt(end - 1)), ')]}"\' \t\r\n'))--end;
    if (start_0 >= end) throw toJs(new IllegalArgumentException_0('The given string does not contain any numbers.'));
    tokens = $split_0((checkCriticalStringBounds(start_0, end, string.length), string.substr(start_0, end - start_0)), ',|;|\r|\n');
    if (tokens.length != 2) throw toJs(new IllegalArgumentException_0('Exactly two numbers are expected, ' + tokens.length + ' were found.'));
    try {
        this.x_0 = __parseAndValidateDouble($trim(tokens[0]));
        this.y_0 = __parseAndValidateDouble($trim(tokens[1]));
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 130)) {
            exception = $e0;
            throw toJs(new IllegalArgumentException_0('The given string contains parts that cannot be parsed as numbers.' + exception));
        } else throw toJs($e0);
    }
};
_.toString_0 = function toString_113() {
    return '(' + this.x_0 + ',' + this.y_0 + ')';
};
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_core_math_KVector_2_classLit = createForClass('org.eclipse.elk.core.math', 'KVector', 8);
function $addAll_7(this$static, vectors) {
    var vector, vector$array, vector$index, vector$max;
    for(vector$array = vectors, vector$index = 0, vector$max = vector$array.length; vector$index < vector$max; ++vector$index){
        vector = vector$array[vector$index];
        $addNode_0(this$static, vector, this$static.tail.prev, this$static.tail);
    }
}
function $addAllAsCopies(this$static, index_0, chain) {
    var copies, v, v$iterator;
    copies = new LinkedList;
    for(v$iterator = $listIterator_2(chain, 0); v$iterator.currentNode != v$iterator.this$01.tail;){
        v = castTo($next_9(v$iterator), 8);
        $add_7(copies, new KVector_2(v));
    }
    $addAll_0(this$static, index_0, copies);
}
function $offset_1(this$static, dx, dy) {
    var vector, vector$iterator;
    for(vector$iterator = $listIterator_2(this$static, 0); vector$iterator.currentNode != vector$iterator.this$01.tail;){
        vector = castTo($next_9(vector$iterator), 8);
        vector.x_0 += dx;
        vector.y_0 += dy;
    }
    return this$static;
}
function $offset_2(this$static, offset) {
    var vector, vector$iterator;
    for(vector$iterator = $listIterator_2(this$static, 0); vector$iterator.currentNode != vector$iterator.this$01.tail;){
        vector = castTo($next_9(vector$iterator), 8);
        vector.x_0 += offset.x_0;
        vector.y_0 += offset.y_0;
    }
    return this$static;
}
function $toArray_7(this$static) {
    var i, iter, result;
    i = 0;
    result = initUnidimensionalArray(Lorg_eclipse_elk_core_math_KVector_2_classLit, $intern_16, 8, this$static.size_0, 0, 1);
    iter = $listIterator_2(this$static, 0);
    while(iter.currentNode != iter.this$01.tail)result[i++] = castTo($next_9(iter), 8);
    return result;
}
function KVectorChain() {
    LinkedList.call(this);
}
function KVectorChain_0(collection) {
    LinkedList_0.call(this, collection);
}
function KVectorChain_1(vectors) {
    LinkedList.call(this);
    $addAll_7(this, vectors);
}
function reverse_3(chain) {
    var result, vector, vector$iterator;
    result = new KVectorChain;
    for(vector$iterator = $listIterator_2(chain, 0); vector$iterator.currentNode != vector$iterator.this$01.tail;){
        vector = castTo($next_9(vector$iterator), 8);
        $add_0(result, 0, new KVector_2(vector));
    }
    return result;
}
defineClass(77, 67, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    67: 1,
    15: 1,
    77: 1,
    411: 1
}, KVectorChain, KVectorChain_0, KVectorChain_1);
_.toArray = function toArray_25() {
    return $toArray_7(this);
};
_.parse_0 = function parse_2(string) {
    var exception, i, tokens, x_0, xy, y_0;
    tokens = $split_0(string, ',|;|\\(|\\)|\\[|\\]|\\{|\\}| |\t|\n');
    $reset_0(this);
    try {
        i = 0;
        xy = 0;
        x_0 = 0;
        y_0 = 0;
        while(i < tokens.length){
            if (tokens[i] != null && $trim(tokens[i]).length > 0) {
                xy % 2 == 0 ? x_0 = __parseAndValidateDouble(tokens[i]) : y_0 = __parseAndValidateDouble(tokens[i]);
                xy > 0 && xy % 2 != 0 && $add_7(this, new KVector_1(x_0, y_0));
                ++xy;
            }
            ++i;
        }
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 130)) {
            exception = $e0;
            throw toJs(new IllegalArgumentException_0('The given string does not match the expected format for vectors.' + exception));
        } else throw toJs($e0);
    }
};
_.toString_0 = function toString_114() {
    var builder, iter, vector;
    builder = new StringBuilder_1('(');
    iter = $listIterator_2(this, 0);
    while(iter.currentNode != iter.this$01.tail){
        vector = castTo($next_9(iter), 8);
        $append_11(builder, vector.x_0 + ',' + vector.y_0);
        iter.currentNode != iter.this$01.tail && (builder.string += '; ', builder);
    }
    return (builder.string += ')', builder).string;
};
var Lorg_eclipse_elk_core_math_KVectorChain_2_classLit = createForClass('org.eclipse.elk.core.math', 'KVectorChain', 77);
function $clinit_Alignment() {
    $clinit_Alignment = emptyMethod;
    AUTOMATIC = new Alignment('AUTOMATIC', 0);
    LEFT_5 = new Alignment('LEFT', 1);
    RIGHT_5 = new Alignment('RIGHT', 2);
    TOP_2 = new Alignment('TOP', 3);
    BOTTOM_1 = new Alignment('BOTTOM', 4);
    CENTER_4 = new Alignment('CENTER', 5);
}
function Alignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_93(name_0) {
    $clinit_Alignment();
    return valueOf(($clinit_Alignment$Map(), $MAP_83), name_0);
}
function values_101() {
    $clinit_Alignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Alignment_2_classLit, 1), $intern_36, 254, 0, [
        AUTOMATIC,
        LEFT_5,
        RIGHT_5,
        TOP_2,
        BOTTOM_1,
        CENTER_4
    ]);
}
defineClass(254, 23, {
    3: 1,
    34: 1,
    23: 1,
    254: 1
}, Alignment);
var AUTOMATIC, BOTTOM_1, CENTER_4, LEFT_5, RIGHT_5, TOP_2;
var Lorg_eclipse_elk_core_options_Alignment_2_classLit = createForEnum('org.eclipse.elk.core.options', 'Alignment', 254, Ljava_lang_Enum_2_classLit, values_101, valueOf_93);
function $clinit_Alignment$Map() {
    $clinit_Alignment$Map = emptyMethod;
    $MAP_83 = createValueOfMap(($clinit_Alignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Alignment_2_classLit, 1), $intern_36, 254, 0, [
        AUTOMATIC,
        LEFT_5,
        RIGHT_5,
        TOP_2,
        BOTTOM_1,
        CENTER_4
    ])));
}
var $MAP_83;
function $clinit_BoxLayouterOptions() {
    $clinit_BoxLayouterOptions = emptyMethod;
    PADDING_DEFAULT_5 = new ElkPadding_0(15);
    PADDING_4 = new Property_2(($clinit_CoreOptions(), PADDING_5), PADDING_DEFAULT_5);
    SPACING_NODE_NODE_5 = new Property_2(SPACING_NODE_NODE_6, 15);
    PRIORITY_2 = new Property_2(PRIORITY_3, valueOf_3(0));
    EXPAND_NODES = EXPAND_NODES_0;
    NODE_SIZE_CONSTRAINTS_5 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_OPTIONS_5 = NODE_SIZE_OPTIONS_6;
    ASPECT_RATIO_3 = new Property_2(ASPECT_RATIO_4, $intern_134);
    INTERACTIVE_7 = INTERACTIVE_8;
    NODE_SIZE_MINIMUM_4 = NODE_SIZE_MINIMUM_5;
    BOX_PACKING_MODE = BOX_PACKING_MODE_0;
    CONTENT_ALIGNMENT_1 = CONTENT_ALIGNMENT_2;
}
function $apply_15(registry) {
    $register(registry, new LayoutAlgorithmData($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.box'), 'ELK Box'), 'Algorithm for packing of unconnected boxes, i.e. graphs without edges.'), new BoxLayouterOptions$BoxFactory)));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.padding', PADDING_DEFAULT_5);
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.spacing.nodeNode', 15);
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.priority', valueOf_3(0));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.expandNodes', $getDefault(EXPAND_NODES));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_5));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.nodeSize.options', $getDefault(NODE_SIZE_OPTIONS_5));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.aspectRatio', $intern_134);
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.interactive', $getDefault(INTERACTIVE_7));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM_4));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.box.packingMode', $getDefault(BOX_PACKING_MODE));
    $addOptionSupport(registry, 'org.eclipse.elk.box', 'org.eclipse.elk.contentAlignment', $getDefault(CONTENT_ALIGNMENT_1));
}
function BoxLayouterOptions() {
    $clinit_BoxLayouterOptions();
}
defineClass(968, 1, $intern_98, BoxLayouterOptions);
_.apply_4 = function apply_151(registry) {
    $apply_15(registry);
};
var ASPECT_RATIO_3, BOX_PACKING_MODE, CONTENT_ALIGNMENT_1, EXPAND_NODES, INTERACTIVE_7, NODE_SIZE_CONSTRAINTS_5, NODE_SIZE_MINIMUM_4, NODE_SIZE_OPTIONS_5, PADDING_4, PADDING_DEFAULT_5, PRIORITY_2, SPACING_NODE_NODE_5;
var Lorg_eclipse_elk_core_options_BoxLayouterOptions_2_classLit = createForClass('org.eclipse.elk.core.options', 'BoxLayouterOptions', 968);
function BoxLayouterOptions$BoxFactory() {}
defineClass(969, 1, {}, BoxLayouterOptions$BoxFactory);
_.create_0 = function create_43() {
    var provider;
    return provider = new BoxLayoutProvider, provider;
};
_.destroy = function destroy_7(obj) {};
var Lorg_eclipse_elk_core_options_BoxLayouterOptions$BoxFactory_2_classLit = createForClass('org.eclipse.elk.core.options', 'BoxLayouterOptions/BoxFactory', 969);
function $clinit_ContentAlignment() {
    $clinit_ContentAlignment = emptyMethod;
    V_TOP = new ContentAlignment('V_TOP', 0);
    V_CENTER = new ContentAlignment('V_CENTER', 1);
    V_BOTTOM = new ContentAlignment('V_BOTTOM', 2);
    H_LEFT = new ContentAlignment('H_LEFT', 3);
    H_CENTER = new ContentAlignment('H_CENTER', 4);
    H_RIGHT = new ContentAlignment('H_RIGHT', 5);
}
function ContentAlignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_94(name_0) {
    $clinit_ContentAlignment();
    return valueOf(($clinit_ContentAlignment$Map(), $MAP_84), name_0);
}
function values_102() {
    $clinit_ContentAlignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_ContentAlignment_2_classLit, 1), $intern_36, 296, 0, [
        V_TOP,
        V_CENTER,
        V_BOTTOM,
        H_LEFT,
        H_CENTER,
        H_RIGHT
    ]);
}
defineClass(296, 23, {
    3: 1,
    34: 1,
    23: 1,
    296: 1
}, ContentAlignment);
var H_CENTER, H_LEFT, H_RIGHT, V_BOTTOM, V_CENTER, V_TOP;
var Lorg_eclipse_elk_core_options_ContentAlignment_2_classLit = createForEnum('org.eclipse.elk.core.options', 'ContentAlignment', 296, Ljava_lang_Enum_2_classLit, values_102, valueOf_94);
function $clinit_ContentAlignment$Map() {
    $clinit_ContentAlignment$Map = emptyMethod;
    $MAP_84 = createValueOfMap(($clinit_ContentAlignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_ContentAlignment_2_classLit, 1), $intern_36, 296, 0, [
        V_TOP,
        V_CENTER,
        V_BOTTOM,
        H_LEFT,
        H_CENTER,
        H_RIGHT
    ])));
}
var $MAP_84;
function $clinit_CoreOptions() {
    $clinit_CoreOptions = emptyMethod;
    var all, all0;
    ALGORITHM = new Property('org.eclipse.elk.algorithm');
    RESOLVED_ALGORITHM = new Property('org.eclipse.elk.resolvedAlgorithm');
    ALIGNMENT_DEFAULT = ($clinit_Alignment(), AUTOMATIC);
    ALIGNMENT_0 = new Property_1('org.eclipse.elk.alignment', ALIGNMENT_DEFAULT);
    new ExclusiveBounds$ExclusiveLowerBound;
    ASPECT_RATIO_4 = new Property_1('org.eclipse.elk.aspectRatio', null);
    BEND_POINTS = new Property('org.eclipse.elk.bendPoints');
    CONTENT_ALIGNMENT_DEFAULT = ($clinit_ContentAlignment(), of_2(V_TOP, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_ContentAlignment_2_classLit, 1), $intern_36, 296, 0, [
        H_LEFT
    ])));
    CONTENT_ALIGNMENT_2 = new Property_1('org.eclipse.elk.contentAlignment', CONTENT_ALIGNMENT_DEFAULT);
    DEBUG_MODE_3 = new Property_1('org.eclipse.elk.debugMode', ($clinit_Boolean(), false));
    DIRECTION_DEFAULT_1 = ($clinit_Direction(), UNDEFINED_2);
    DIRECTION_1 = new Property_1('org.eclipse.elk.direction', DIRECTION_DEFAULT_1);
    EDGE_ROUTING_DEFAULT_0 = ($clinit_EdgeRouting(), UNDEFINED_3);
    EDGE_ROUTING_0 = new Property_1('org.eclipse.elk.edgeRouting', EDGE_ROUTING_DEFAULT_0);
    EXPAND_NODES_0 = new Property_1('org.eclipse.elk.expandNodes', false);
    HIERARCHY_HANDLING_DEFAULT = ($clinit_HierarchyHandling(), INHERIT_0);
    HIERARCHY_HANDLING_0 = new Property_1('org.eclipse.elk.hierarchyHandling', HIERARCHY_HANDLING_DEFAULT);
    PADDING_DEFAULT_6 = new ElkPadding_0(12);
    PADDING_5 = new Property_1('org.eclipse.elk.padding', PADDING_DEFAULT_6);
    INTERACTIVE_8 = new Property_1('org.eclipse.elk.interactive', false);
    INTERACTIVE_LAYOUT_2 = new Property_1('org.eclipse.elk.interactiveLayout', false);
    OMIT_NODE_MICRO_LAYOUT_4 = new Property_1('org.eclipse.elk.omitNodeMicroLayout', false);
    PORT_CONSTRAINTS_DEFAULT = ($clinit_PortConstraints(), UNDEFINED_4);
    PORT_CONSTRAINTS_1 = new Property_1('org.eclipse.elk.portConstraints', PORT_CONSTRAINTS_DEFAULT);
    POSITION_2 = new Property('org.eclipse.elk.position');
    PRIORITY_3 = new Property('org.eclipse.elk.priority');
    RANDOM_SEED_1 = new Property('org.eclipse.elk.randomSeed');
    SEPARATE_CONNECTED_COMPONENTS_2 = new Property('org.eclipse.elk.separateConnectedComponents');
    JUNCTION_POINTS_DEFAULT = new KVectorChain;
    JUNCTION_POINTS_0 = new Property_1('org.eclipse.elk.junctionPoints', JUNCTION_POINTS_DEFAULT);
    COMMENT_BOX_0 = new Property_1('org.eclipse.elk.commentBox', false);
    HYPERNODE_0 = new Property_1('org.eclipse.elk.hypernode', false);
    new Property('org.eclipse.elk.labelManager');
    new Property_1('org.eclipse.elk.softwrappingFuzziness', 0);
    MARGINS_DEFAULT = new ElkMargin;
    MARGINS_0 = new Property_1('org.eclipse.elk.margins', MARGINS_DEFAULT);
    NO_LAYOUT_0 = new Property_1('org.eclipse.elk.noLayout', false);
    new ExclusiveBounds$ExclusiveLowerBound;
    SCALE_FACTOR = new Property_1('org.eclipse.elk.scaleFactor', 1);
    CHILD_AREA_WIDTH = new Property('org.eclipse.elk.childAreaWidth');
    CHILD_AREA_HEIGHT = new Property('org.eclipse.elk.childAreaHeight');
    TOPDOWN_LAYOUT_2 = new Property_1('org.eclipse.elk.topdownLayout', false);
    new Property_1('org.eclipse.elk.animate', true);
    valueOf_3(0);
    new Property_1('org.eclipse.elk.animTimeFactor', valueOf_3(100));
    new Property_1('org.eclipse.elk.layoutAncestors', false);
    valueOf_3(0);
    new Property_1('org.eclipse.elk.maxAnimTime', valueOf_3(4000));
    valueOf_3(0);
    new Property_1('org.eclipse.elk.minAnimTime', valueOf_3(400));
    new Property_1('org.eclipse.elk.progressBar', false);
    new Property_1('org.eclipse.elk.validateGraph', false);
    new Property_1('org.eclipse.elk.validateOptions', true);
    new Property_1('org.eclipse.elk.zoomToFit', false);
    BOX_PACKING_MODE_DEFAULT = ($clinit_BoxLayoutProvider$PackingMode(), SIMPLE_1);
    BOX_PACKING_MODE_0 = new Property_1('org.eclipse.elk.box.packingMode', BOX_PACKING_MODE_DEFAULT);
    JSON_SHAPE_COORDS_DEFAULT = ($clinit_ShapeCoords(), INHERIT_1);
    JSON_SHAPE_COORDS = new Property_1('org.eclipse.elk.json.shapeCoords', JSON_SHAPE_COORDS_DEFAULT);
    JSON_EDGE_COORDS_DEFAULT = ($clinit_EdgeCoords(), INHERIT);
    JSON_EDGE_COORDS = new Property_1('org.eclipse.elk.json.edgeCoords', JSON_EDGE_COORDS_DEFAULT);
    SPACING_COMMENT_COMMENT_0 = new Property_1('org.eclipse.elk.spacing.commentComment', 10);
    SPACING_COMMENT_NODE_0 = new Property_1('org.eclipse.elk.spacing.commentNode', 10);
    SPACING_COMPONENT_COMPONENT_0 = new Property_1('org.eclipse.elk.spacing.componentComponent', 20);
    SPACING_EDGE_EDGE_0 = new Property_1('org.eclipse.elk.spacing.edgeEdge', 10);
    SPACING_EDGE_LABEL_1 = new Property_1('org.eclipse.elk.spacing.edgeLabel', 2);
    SPACING_EDGE_NODE_1 = new Property_1('org.eclipse.elk.spacing.edgeNode', 10);
    SPACING_LABEL_LABEL_0 = new Property_1('org.eclipse.elk.spacing.labelLabel', 0);
    SPACING_LABEL_NODE_0 = new Property_1('org.eclipse.elk.spacing.labelNode', 5);
    SPACING_LABEL_PORT_HORIZONTAL_0 = new Property_1('org.eclipse.elk.spacing.labelPortHorizontal', 1);
    SPACING_LABEL_PORT_VERTICAL_0 = new Property_1('org.eclipse.elk.spacing.labelPortVertical', 1);
    SPACING_NODE_NODE_6 = new Property_1('org.eclipse.elk.spacing.nodeNode', 20);
    SPACING_NODE_SELF_LOOP_0 = new Property_1('org.eclipse.elk.spacing.nodeSelfLoop', 10);
    SPACING_PORT_PORT_0 = new Property_1('org.eclipse.elk.spacing.portPort', 10);
    SPACING_INDIVIDUAL_0 = new Property('org.eclipse.elk.spacing.individual');
    SPACING_PORTS_SURROUNDING_DEFAULT = new ElkMargin_0;
    SPACING_PORTS_SURROUNDING_0 = new Property_1('org.eclipse.elk.spacing.portsSurrounding', SPACING_PORTS_SURROUNDING_DEFAULT);
    PARTITIONING_PARTITION_0 = new Property('org.eclipse.elk.partitioning.partition');
    PARTITIONING_ACTIVATE_DEFAULT = false;
    PARTITIONING_ACTIVATE_0 = new Property_1('org.eclipse.elk.partitioning.activate', PARTITIONING_ACTIVATE_DEFAULT);
    NODE_LABELS_PADDING_DEFAULT = new ElkPadding_0(5);
    NODE_LABELS_PADDING_0 = new Property_1('org.eclipse.elk.nodeLabels.padding', NODE_LABELS_PADDING_DEFAULT);
    NODE_LABELS_PLACEMENT_DEFAULT = ($clinit_NodeLabelPlacement(), all0 = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit), 10), new EnumSet$EnumSetImpl(all0, castTo(createFrom(all0, all0.length), 10), 0));
    NODE_LABELS_PLACEMENT_5 = new Property_1('org.eclipse.elk.nodeLabels.placement', NODE_LABELS_PLACEMENT_DEFAULT);
    PORT_ALIGNMENT_DEFAULT_DEFAULT_0 = ($clinit_PortAlignment(), DISTRIBUTED);
    PORT_ALIGNMENT_DEFAULT = new Property_1('org.eclipse.elk.portAlignment.default', PORT_ALIGNMENT_DEFAULT_DEFAULT_0);
    PORT_ALIGNMENT_NORTH_0 = new Property('org.eclipse.elk.portAlignment.north');
    PORT_ALIGNMENT_SOUTH_0 = new Property('org.eclipse.elk.portAlignment.south');
    PORT_ALIGNMENT_WEST_0 = new Property('org.eclipse.elk.portAlignment.west');
    PORT_ALIGNMENT_EAST_0 = new Property('org.eclipse.elk.portAlignment.east');
    NODE_SIZE_CONSTRAINTS_DEFAULT = (all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0));
    NODE_SIZE_CONSTRAINTS_6 = new Property_1('org.eclipse.elk.nodeSize.constraints', NODE_SIZE_CONSTRAINTS_DEFAULT);
    NODE_SIZE_OPTIONS_DEFAULT = of_1(($clinit_SizeOptions(), DEFAULT_MINIMUM_SIZE));
    NODE_SIZE_OPTIONS_6 = new Property_1('org.eclipse.elk.nodeSize.options', NODE_SIZE_OPTIONS_DEFAULT);
    NODE_SIZE_MINIMUM_DEFAULT = new KVector_1(0, 0);
    NODE_SIZE_MINIMUM_5 = new Property_1('org.eclipse.elk.nodeSize.minimum', NODE_SIZE_MINIMUM_DEFAULT);
    NODE_SIZE_FIXED_GRAPH_SIZE_3 = new Property_1('org.eclipse.elk.nodeSize.fixedGraphSize', false);
    EDGE_LABELS_PLACEMENT_DEFAULT = ($clinit_EdgeLabelPlacement(), CENTER_5);
    EDGE_LABELS_PLACEMENT_0 = new Property_1('org.eclipse.elk.edgeLabels.placement', EDGE_LABELS_PLACEMENT_DEFAULT);
    EDGE_LABELS_INLINE_1 = new Property_1('org.eclipse.elk.edgeLabels.inline', false);
    new Property('org.eclipse.elk.font.name');
    valueOf_3(1);
    new Property_1('org.eclipse.elk.font.size', null);
    PORT_ANCHOR_0 = new Property('org.eclipse.elk.port.anchor');
    PORT_INDEX_0 = new Property('org.eclipse.elk.port.index');
    PORT_SIDE_DEFAULT = ($clinit_PortSide(), UNDEFINED_5);
    PORT_SIDE_0 = new Property_1('org.eclipse.elk.port.side', PORT_SIDE_DEFAULT);
    PORT_BORDER_OFFSET_0 = new Property('org.eclipse.elk.port.borderOffset');
    PORT_LABELS_PLACEMENT_DEFAULT = ($clinit_PortLabelPlacement(), of_1(OUTSIDE_0));
    PORT_LABELS_PLACEMENT_5 = new Property_1('org.eclipse.elk.portLabels.placement', PORT_LABELS_PLACEMENT_DEFAULT);
    PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE_0 = new Property_1('org.eclipse.elk.portLabels.nextToPortIfPossible', false);
    PORT_LABELS_TREAT_AS_GROUP_0 = new Property_1('org.eclipse.elk.portLabels.treatAsGroup', true);
    new ExclusiveBounds$ExclusiveLowerBound;
    TOPDOWN_SCALE_FACTOR_2 = new Property_1('org.eclipse.elk.topdown.scaleFactor', 1);
    TOPDOWN_SIZE_APPROXIMATOR = new Property_1('org.eclipse.elk.topdown.sizeApproximator', null);
    TOPDOWN_HIERARCHICAL_NODE_WIDTH_2 = new Property_1('org.eclipse.elk.topdown.hierarchicalNodeWidth', 150);
    TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2 = new Property_1('org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', 1.414);
    TOPDOWN_NODE_TYPE = new Property_1('org.eclipse.elk.topdown.nodeType', null);
    TOPDOWN_SCALE_CAP = new Property_1('org.eclipse.elk.topdown.scaleCap', 1);
    INSIDE_SELF_LOOPS_ACTIVATE_0 = new Property_1('org.eclipse.elk.insideSelfLoops.activate', false);
    INSIDE_SELF_LOOPS_YO_0 = new Property_1('org.eclipse.elk.insideSelfLoops.yo', false);
    EDGE_THICKNESS_0 = new Property_1('org.eclipse.elk.edge.thickness', 1);
    EDGE_TYPE_DEFAULT = ($clinit_EdgeType(), NONE_18);
    new Property_1('org.eclipse.elk.edge.type', EDGE_TYPE_DEFAULT);
    PARTITIONING_PARTITION_DEP_PARTITIONING_ACTIVATE_0 = true;
    TOPDOWN_SCALE_FACTOR_DEP_TOPDOWN_NODE_TYPE_0 = ($clinit_TopdownNodeTypes(), HIERARCHICAL_NODE);
    TOPDOWN_SIZE_APPROXIMATOR_DEP_TOPDOWN_NODE_TYPE_0 = HIERARCHICAL_NODE;
    TOPDOWN_SCALE_CAP_DEP_TOPDOWN_NODE_TYPE_0 = HIERARCHICAL_NODE;
}
function CoreOptions() {
    $clinit_CoreOptions();
}
defineClass(684, 1, $intern_98, CoreOptions);
_.apply_4 = function apply_152(registry) {
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.algorithm'), ''), 'Layout Algorithm'), 'Select a specific layout algorithm.'), ($clinit_LayoutOptionData$Type(), STRING)), Ljava_lang_String_2_classLit), of_1(($clinit_LayoutOptionData$Target(), PARENTS)))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.resolvedAlgorithm'), ''), 'Resolved Layout Algorithm'), 'Meta data associated with the selected algorithm.'), OBJECT), Lorg_eclipse_elk_core_data_LayoutAlgorithmData_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.alignment'), ''), 'Alignment'), 'Alignment of the selected node relative to other nodes; the exact meaning depends on the used algorithm.'), ALIGNMENT_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_Alignment_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.aspectRatio'), ''), 'Aspect Ratio'), 'The desired aspect ratio of the drawing, that is the quotient of width by height.'), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.bendPoints'), ''), 'Bend Points'), "A fixed list of bend points for the edge. This is used by the 'Fixed Layout' algorithm to specify a pre-defined routing for an edge. The vector chain must include the source point, any bend points, and the target point, so it must have at least two points."), OBJECT), Lorg_eclipse_elk_core_math_KVectorChain_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.contentAlignment'), ''), 'Content Alignment'), 'Specifies how the content of a node are aligned. Each node can individually control the alignment of its contents. I.e. if a node should be aligned top left in its parent node, the parent node should specify that option.'), CONTENT_ALIGNMENT_DEFAULT), ENUMSET), Lorg_eclipse_elk_core_options_ContentAlignment_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.debugMode'), ''), 'Debug Mode'), 'Whether additional debug information shall be generated.'), ($clinit_Boolean(), false)), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.direction'), ''), 'Direction'), 'Overall direction of edges: horizontal (right / left) or vertical (down / up).'), DIRECTION_DEFAULT_1), ENUM), Lorg_eclipse_elk_core_options_Direction_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.edgeRouting'), ''), 'Edge Routing'), 'What kind of edge routing style should be applied for the content of a parent node. Algorithms may also set this option to single edges in order to mark them as splines. The bend point list of edges with this option set to SPLINES must be interpreted as control points for a piecewise cubic spline.'), EDGE_ROUTING_DEFAULT_0), ENUM), Lorg_eclipse_elk_core_options_EdgeRouting_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.expandNodes'), ''), 'Expand Nodes'), 'If active, nodes are expanded to fill the area of their parent.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.hierarchyHandling'), ''), 'Hierarchy Handling'), "Determines whether separate layout runs are triggered for different compound nodes in a hierarchical graph. Setting a node's hierarchy handling to `INCLUDE_CHILDREN` will lay out that node and all of its descendants in a single layout run, until a descendant is encountered which has its hierarchy handling set to `SEPARATE_CHILDREN`. In general, `SEPARATE_CHILDREN` will ensure that a new layout run is triggered for a node with that setting. Including multiple levels of hierarchy in a single layout run may allow cross-hierarchical edges to be laid out properly. If the root node is set to `INHERIT` (or not set at all), the default behavior is `SEPARATE_CHILDREN`."), HIERARCHY_HANDLING_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_HierarchyHandling_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        NODES
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.padding'), ''), 'Padding'), "The padding to be left to a parent element's border when placing child elements. This can also serve as an output option of a layout algorithm if node size calculation is setup appropriately."), PADDING_DEFAULT_6), OBJECT), Lorg_eclipse_elk_core_math_ElkPadding_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        NODES
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.interactive'), ''), 'Interactive'), 'Whether the algorithm should be run in interactive mode for the content of a parent node. What this means exactly depends on how the specific algorithm interprets this option. Usually in the interactive mode algorithms try to modify the current layout as little as possible.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.interactiveLayout'), ''), 'interactive Layout'), 'Whether the graph should be changeable interactively and by setting constraints'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.omitNodeMicroLayout'), ''), 'Omit Node Micro Layout'), "Node micro layout comprises the computation of node dimensions (if requested), the placement of ports and their labels, and the placement of node labels. The functionality is implemented independent of any specific layout algorithm and shouldn't have any negative impact on the layout algorithm's performance itself. Yet, if any unforeseen behavior occurs, this option allows to deactivate the micro layout."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portConstraints'), ''), 'Port Constraints'), 'Defines constraints of the position of the ports of a node.'), PORT_CONSTRAINTS_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_PortConstraints_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.position'), ''), 'Position'), "The position of a node, port, or label. This is used by the 'Fixed Layout' algorithm to specify a pre-defined position."), OBJECT), Lorg_eclipse_elk_core_math_KVector_2_classLit), of_2(NODES, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        PORTS,
        LABELS
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.priority'), ''), 'Priority'), 'Defines the priority of an object; its meaning depends on the specific layout algorithm and the context where it is used.'), INT), Ljava_lang_Integer_2_classLit), of_2(NODES, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        EDGES
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.randomSeed'), ''), 'Randomization Seed'), 'Seed used for pseudo-random number generators to control the layout algorithm. If the value is 0, the seed shall be determined pseudo-randomly (e.g. from the system time).'), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.separateConnectedComponents'), ''), 'Separate Connected Components'), 'Whether each connected component should be processed separately.'), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.junctionPoints'), ''), 'Junction Points'), 'This option is not used as option, but as output of the layout algorithms. It is attached to edges and determines the points where junction symbols should be drawn in order to represent hyperedges with orthogonal routing. Whether such points are computed depends on the chosen layout algorithm and edge routing style. The points are put into the vector chain with no specific order.'), JUNCTION_POINTS_DEFAULT), OBJECT), Lorg_eclipse_elk_core_math_KVectorChain_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.commentBox'), ''), 'Comment Box'), 'Whether the node should be regarded as a comment box instead of a regular node. In that case its placement should be similar to how labels are handled. Any edges incident to a comment box specify to which graph elements the comment is related.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.hypernode'), ''), 'Hypernode'), 'Whether the node should be handled as a hypernode.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.labelManager'), ''), 'Label Manager'), "Label managers can shorten labels upon a layout algorithm's request."), OBJECT), Lorg_eclipse_elk_core_labels_ILabelManager_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        LABELS
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.softwrappingFuzziness'), ''), 'Softwrapping Fuzziness'), 'Determines the amount of fuzziness to be used when performing softwrapping on labels. The value expresses the percent of overhang that is permitted for each line. If the next line would take up less space than this threshold, it is appended to the current line instead of being placed in a new line.'), 0), DOUBLE), Ljava_lang_Double_2_classLit), of_1(LABELS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.margins'), ''), 'Margins'), "Margins define additional space around the actual bounds of a graph element. For instance, ports or labels being placed on the outside of a node's border might introduce such a margin. The margin is used to guarantee non-overlap of other graph elements with those ports or labels."), MARGINS_DEFAULT), OBJECT), Lorg_eclipse_elk_core_math_ElkMargin_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.noLayout'), ''), 'No Layout'), "No layout is done for the associated element. This is used to mark parts of a diagram to avoid their inclusion in the layout graph, or to mark parts of the layout graph to prevent layout engines from processing them. If you wish to exclude the contents of a compound node from automatic layout, while the node itself is still considered on its own layer, use the 'Fixed Layout' algorithm for that node."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_2(NODES, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        EDGES,
        PORTS,
        LABELS
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.scaleFactor'), ''), 'Scale Factor'), "The scaling factor to be applied to the corresponding node in recursive layout. It causes the corresponding node's size to be adjusted, and its ports and labels to be sized and placed accordingly after the layout of that node has been determined (and before the node itself and its siblings are arranged). The scaling is not reverted afterwards, so the resulting layout graph contains the adjusted size and position data. This option is currently not supported if 'Layout Hierarchy' is set."), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.childAreaWidth'), ''), 'Child Area Width'), 'The width of the area occupied by the laid out children of a node.'), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.childAreaHeight'), ''), 'Child Area Height'), 'The height of the area occupied by the laid out children of a node.'), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdownLayout'), ''), 'Topdown Layout'), "Turns topdown layout on and off. If this option is enabled, hierarchical layout will be computed first for the root node and then for its children recursively. Layouts are then scaled down to fit the area provided by their parents. Graphs must follow a certain structure for topdown layout to work properly. {@link TopdownNodeTypes.PARALLEL_NODE} nodes must have children of type {@link TopdownNodeTypes.HIERARCHICAL_NODE} and must define {@link topdown.hierarchicalNodeWidth} and {@link topdown.hierarchicalNodeAspectRatio} for their children. Furthermore they need to be laid out using an algorithm that is a {@link TopdownLayoutProvider}. Hierarchical nodes can also be parents of other hierarchical nodes and can optionally use a {@link TopdownSizeApproximator} to dynamically set sizes during topdown layout. In this case {@link topdown.hierarchicalNodeWidth} and {@link topdown.hierarchicalNodeAspectRatio} should be set on the node itself rather than the parent. The values are then used by the size approximator as base values. Hierarchical nodes require the layout option {@link nodeSize.fixedGraphSize} to be true to prevent the algorithm used there from resizing the hierarchical node. This option is not supported if 'Hierarchy Handling' is set to 'INCLUDE_CHILDREN'"), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.topdownLayout', 'org.eclipse.elk.topdown.nodeType', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.animate'), ''), 'Animate'), 'Whether the shift from the old layout to the new computed layout shall be animated.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.animTimeFactor'), ''), 'Animation Time Factor'), "Factor for computation of animation time. The higher the value, the longer the animation time. If the value is 0, the resulting time is always equal to the minimum defined by 'Minimal Animation Time'."), valueOf_3(100)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.layoutAncestors'), ''), 'Layout Ancestors'), 'Whether the hierarchy levels on the path from the selected element to the root of the diagram shall be included in the layout process.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.maxAnimTime'), ''), 'Maximal Animation Time'), 'The maximal time for animations, in milliseconds.'), valueOf_3(4000)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.minAnimTime'), ''), 'Minimal Animation Time'), 'The minimal time for animations, in milliseconds.'), valueOf_3(400)), INT), Ljava_lang_Integer_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.progressBar'), ''), 'Progress Bar'), 'Whether a progress bar shall be displayed during layout computations.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.validateGraph'), ''), 'Validate Graph'), 'Whether the graph shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.validateOptions'), ''), 'Validate Options'), 'Whether layout options shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.zoomToFit'), ''), 'Zoom to Fit'), 'Whether the zoom level shall be set to view the whole diagram after layout.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.box.packingMode'), 'box'), 'Box Layout Mode'), 'Configures the packing mode used by the {@link BoxLayoutProvider}. If SIMPLE is not required (neither priorities are used nor the interactive mode), GROUP_DEC can improve the packing and decrease the area. GROUP_MIXED and GROUP_INC may, in very specific scenarios, work better.'), BOX_PACKING_MODE_DEFAULT), ENUM), Lorg_eclipse_elk_core_util_BoxLayoutProvider$PackingMode_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.json.shapeCoords'), 'json'), 'Shape Coords'), 'For layouts transferred into JSON graphs, specify the coordinate system to be used for nodes, ports, and labels of nodes and ports.'), JSON_SHAPE_COORDS_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_ShapeCoords_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.json.edgeCoords'), 'json'), 'Edge Coords'), 'For layouts transferred into JSON graphs, specify the coordinate system to be used for edge route points and edge labels.'), JSON_EDGE_COORDS_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_EdgeCoords_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.commentComment'), 'spacing'), 'Comment Comment Spacing'), 'Spacing to be preserved between a comment box and other comment boxes connected to the same node. The space left between comment boxes of different nodes is controlled by the node-node spacing.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.commentNode'), 'spacing'), 'Comment Node Spacing'), 'Spacing to be preserved between a node and its connected comment boxes. The space left between a node and the comments of another node is controlled by the node-node spacing.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.componentComponent'), 'spacing'), 'Components Spacing'), "Spacing to be preserved between pairs of connected components. This option is only relevant if 'separateConnectedComponents' is activated."), 20), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.edgeEdge'), 'spacing'), 'Edge Spacing'), 'Spacing to be preserved between any two edges. Note that while this can somewhat easily be satisfied for the segments of orthogonally drawn edges, it is harder for general polylines or splines.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.edgeLabel'), 'spacing'), 'Edge Label Spacing'), "The minimal distance to be preserved between a label and the edge it is associated with. Note that the placement of a label is influenced by the 'edgelabels.placement' option."), 2), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.edgeNode'), 'spacing'), 'Edge Node Spacing'), 'Spacing to be preserved between nodes and edges.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.labelLabel'), 'spacing'), 'Label Spacing'), 'Determines the amount of space to be left between two labels of the same graph element.'), 0), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.labelNode'), 'spacing'), 'Label Node Spacing'), "Spacing to be preserved between labels and the border of node they are associated with. Note that the placement of a label is influenced by the 'nodelabels.placement' option."), 5), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.labelPortHorizontal'), 'spacing'), 'Horizontal spacing between Label and Port'), "Horizontal spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.labelPortVertical'), 'spacing'), 'Vertical spacing between Label and Port'), "Vertical spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.nodeNode'), 'spacing'), 'Node Spacing'), 'The minimal distance to be preserved between each two nodes.'), 20), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.nodeSelfLoop'), 'spacing'), 'Node Self Loop Spacing'), 'Spacing to be preserved between a node and its self loops.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.portPort'), 'spacing'), 'Port Spacing'), 'Spacing between pairs of ports of the same node.'), 10), DOUBLE), Ljava_lang_Double_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        NODES
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.individual'), 'spacing'), 'Individual Spacing'), "Allows to specify individual spacing values for graph elements that shall be different from the value specified for the element's parent."), OBJECT), Lorg_eclipse_elk_core_util_IndividualSpacings_2_classLit), of_2(NODES, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        EDGES,
        PORTS,
        LABELS
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.spacing.portsSurrounding'), 'spacing'), 'Additional Port Space'), 'Additional space around the sets of ports on each node side. For each side of a node, this option can reserve additional space before and after the ports on each side. For example, a top spacing of 20 makes sure that the first port on the western and eastern side is 20 units away from the northern border.'), SPACING_PORTS_SURROUNDING_DEFAULT), OBJECT), Lorg_eclipse_elk_core_math_ElkMargin_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.partitioning.partition'), 'partitioning'), 'Layout Partition'), 'Partition to which the node belongs. This requires Layout Partitioning to be active. Nodes with lower partition IDs will appear to the left of nodes with higher partition IDs (assuming a left-to-right layout direction).'), INT), Ljava_lang_Integer_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        NODES
    ])))));
    $addDependency(registry, 'org.eclipse.elk.partitioning.partition', 'org.eclipse.elk.partitioning.activate', PARTITIONING_PARTITION_DEP_PARTITIONING_ACTIVATE_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.partitioning.activate'), 'partitioning'), 'Layout Partitioning'), 'Whether to activate partitioned layout. This will allow to group nodes through the Layout Partition option. a pair of nodes with different partition indices is then placed such that the node with lower index is placed to the left of the other node (with left-to-right layout direction). Depending on the layout algorithm, this may only be guaranteed to work if all nodes have a layout partition configured, or at least if edges that cross partitions are not part of a partition-crossing cycle.'), PARTITIONING_ACTIVATE_DEFAULT), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.nodeLabels.padding'), 'nodeLabels'), 'Node Label Padding'), 'Define padding for node labels that are placed inside of a node.'), NODE_LABELS_PADDING_DEFAULT), OBJECT), Lorg_eclipse_elk_core_math_ElkPadding_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.nodeLabels.placement'), 'nodeLabels'), 'Node Label Placement'), "Hints for where node labels are to be placed; if empty, the node label's position is not modified."), NODE_LABELS_PLACEMENT_DEFAULT), ENUMSET), Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit), of_2(NODES, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        LABELS
    ])))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portAlignment.default'), 'portAlignment'), 'Port Alignment'), 'Defines the default port distribution for a node. May be overridden for each side individually.'), PORT_ALIGNMENT_DEFAULT_DEFAULT_0), ENUM), Lorg_eclipse_elk_core_options_PortAlignment_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portAlignment.north'), 'portAlignment'), 'Port Alignment (North)'), "Defines how ports on the northern side are placed, overriding the node's general port alignment."), ENUM), Lorg_eclipse_elk_core_options_PortAlignment_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portAlignment.south'), 'portAlignment'), 'Port Alignment (South)'), "Defines how ports on the southern side are placed, overriding the node's general port alignment."), ENUM), Lorg_eclipse_elk_core_options_PortAlignment_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portAlignment.west'), 'portAlignment'), 'Port Alignment (West)'), "Defines how ports on the western side are placed, overriding the node's general port alignment."), ENUM), Lorg_eclipse_elk_core_options_PortAlignment_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portAlignment.east'), 'portAlignment'), 'Port Alignment (East)'), "Defines how ports on the eastern side are placed, overriding the node's general port alignment."), ENUM), Lorg_eclipse_elk_core_options_PortAlignment_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.nodeSize.constraints'), 'nodeSize'), 'Node Size Constraints'), "What should be taken into account when calculating a node's size. Empty size constraints specify that a node's size is already fixed and should not be changed."), NODE_SIZE_CONSTRAINTS_DEFAULT), ENUMSET), Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.nodeSize.options'), 'nodeSize'), 'Node Size Options'), 'Options modifying the behavior of the size constraints set on a node. Each member of the set specifies something that should be taken into account when calculating node sizes. The empty set corresponds to no further modifications.'), NODE_SIZE_OPTIONS_DEFAULT), ENUMSET), Lorg_eclipse_elk_core_options_SizeOptions_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.nodeSize.minimum'), 'nodeSize'), 'Node Size Minimum'), 'The minimal size to which a node can be reduced.'), NODE_SIZE_MINIMUM_DEFAULT), OBJECT), Lorg_eclipse_elk_core_math_KVector_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.nodeSize.fixedGraphSize'), 'nodeSize'), 'Fixed Graph Size'), "By default, the fixed layout provider will enlarge a graph until it is large enough to contain its children. If this option is set, it won't do so."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(PARENTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.edgeLabels.placement'), 'edgeLabels'), 'Edge Label Placement'), 'Gives a hint on where to put edge labels.'), EDGE_LABELS_PLACEMENT_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_EdgeLabelPlacement_2_classLit), of_1(LABELS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.edgeLabels.inline'), 'edgeLabels'), 'Inline Edge Labels'), "If true, an edge label is placed directly on its edge. May only apply to center edge labels. This kind of label placement is only advisable if the label's rendering is such that it is not crossed by its edge and thus stays legible."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(LABELS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.font.name'), 'font'), 'Font Name'), 'Font name used for a label.'), STRING), Ljava_lang_String_2_classLit), of_1(LABELS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.font.size'), 'font'), 'Font Size'), 'Font size used for a label.'), INT), Ljava_lang_Integer_2_classLit), of_1(LABELS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.port.anchor'), 'port'), 'Port Anchor Offset'), 'The offset to the port position where connections shall be attached.'), OBJECT), Lorg_eclipse_elk_core_math_KVector_2_classLit), of_1(PORTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.port.index'), 'port'), 'Port Index'), "The index of a port in the fixed order around a node. The order is assumed as clockwise, starting with the leftmost port on the top side. This option must be set if 'Port Constraints' is set to FIXED_ORDER and no specific positions are given for the ports. Additionally, the option 'Port Side' must be defined in this case."), INT), Ljava_lang_Integer_2_classLit), of_1(PORTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.port.side'), 'port'), 'Port Side'), "The side of a node on which a port is situated. This option must be set if 'Port Constraints' is set to FIXED_SIDE or FIXED_ORDER and no specific positions are given for the ports."), PORT_SIDE_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_PortSide_2_classLit), of_1(PORTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.port.borderOffset'), 'port'), 'Port Border Offset'), "The offset of ports on the node border. With a positive offset the port is moved outside of the node, while with a negative offset the port is moved towards the inside. An offset of 0 means that the port is placed directly on the node border, i.e. if the port side is north, the port's south border touches the nodes's north border; if the port side is east, the port's west border touches the nodes's east border; if the port side is south, the port's north border touches the node's south border; if the port side is west, the port's east border touches the node's west border."), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PORTS))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portLabels.placement'), 'portLabels'), 'Port Label Placement'), "Decides on a placement method for port labels; if empty, the node label's position is not modified."), PORT_LABELS_PLACEMENT_DEFAULT), ENUMSET), Lorg_eclipse_elk_core_options_PortLabelPlacement_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portLabels.nextToPortIfPossible'), 'portLabels'), 'Port Labels Next to Port'), "Use 'portLabels.placement': NEXT_TO_PORT_OF_POSSIBLE."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.portLabels.treatAsGroup'), 'portLabels'), 'Treat Port Labels as Group'), 'If this option is true (default), the labels of a port will be treated as a group when it comes to centering them next to their port. If this option is false, only the first label will be centered next to the port, with the others being placed below. This only applies to labels of eastern and western ports and will have no effect if labels are not placed next to their port.'), true), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdown.scaleFactor'), 'topdown'), 'Topdown Scale Factor'), "The scaling factor to be applied to the nodes laid out within the node in recursive topdown layout. The difference to 'Scale Factor' is that the node itself is not scaled. This value has to be set on hierarchical nodes."), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.topdown.scaleFactor', 'org.eclipse.elk.topdown.nodeType', TOPDOWN_SCALE_FACTOR_DEP_TOPDOWN_NODE_TYPE_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdown.sizeApproximator'), 'topdown'), 'Topdown Size Approximator'), 'The size approximator to be used to set sizes of hierarchical nodes during topdown layout. The default value is null, which results in nodes keeping whatever size is defined for them e.g. through parent parallel node or by manually setting the size.'), null), ENUM), Lorg_eclipse_elk_core_options_TopdownSizeApproximator_2_classLit), of_1(NODES))));
    $addDependency(registry, 'org.eclipse.elk.topdown.sizeApproximator', 'org.eclipse.elk.topdown.nodeType', TOPDOWN_SIZE_APPROXIMATOR_DEP_TOPDOWN_NODE_TYPE_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdown.hierarchicalNodeWidth'), 'topdown'), 'Topdown Hierarchical Node Width'), 'The fixed size of a hierarchical node when using topdown layout. If this value is set on a parallel node it applies to its children, when set on a hierarchical node it applies to the node itself.'), 150), DOUBLE), Ljava_lang_Double_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        NODES
    ])))));
    $addDependency(registry, 'org.eclipse.elk.topdown.hierarchicalNodeWidth', 'org.eclipse.elk.topdown.nodeType', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio'), 'topdown'), 'Topdown Hierarchical Node Aspect Ratio'), 'The fixed aspect ratio of a hierarchical node when using topdown layout. Default is 1/sqrt(2). If this value is set on a parallel node it applies to its children, when set on a hierarchical node it applies to the node itself.'), 1.414), DOUBLE), Ljava_lang_Double_2_classLit), of_2(PARENTS, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_LayoutOptionData$Target_2_classLit, 1), $intern_36, 170, 0, [
        NODES
    ])))));
    $addDependency(registry, 'org.eclipse.elk.topdown.hierarchicalNodeAspectRatio', 'org.eclipse.elk.topdown.nodeType', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdown.nodeType'), 'topdown'), 'Topdown Node Type'), 'The different node types used for topdown layout. If the node type is set to {@link TopdownNodeTypes.PARALLEL_NODE} the algorithm must be set to a {@link TopdownLayoutProvider} such as {@link TopdownPacking}. The {@link nodeSize.fixedGraphSize} option is technically only required for hierarchical nodes.'), null), ENUM), Lorg_eclipse_elk_core_options_TopdownNodeTypes_2_classLit), of_1(NODES))));
    $addDependency(registry, 'org.eclipse.elk.topdown.nodeType', 'org.eclipse.elk.nodeSize.fixedGraphSize', null);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.topdown.scaleCap'), 'topdown'), 'Topdown Scale Cap'), 'Determines the upper limit for the topdown scale factor. The default value is 1.0 which ensures that nested children never end up appearing larger than their parents in terms of unit sizes such as the font size. If the limit is larger, nodes will fully utilize the available space, but it is counteriniuitive for inner nodes to have a larger scale than outer nodes.'), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(PARENTS))));
    $addDependency(registry, 'org.eclipse.elk.topdown.scaleCap', 'org.eclipse.elk.topdown.nodeType', TOPDOWN_SCALE_CAP_DEP_TOPDOWN_NODE_TYPE_0);
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.insideSelfLoops.activate'), 'insideSelfLoops'), 'Activate Inside Self Loops'), "Whether this node allows to route self loops inside of it instead of around it. If set to true, this will make the node a compound node if it isn't already, and will require the layout algorithm to support compound nodes with hierarchical ports."), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(NODES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.insideSelfLoops.yo'), 'insideSelfLoops'), 'Inside Self Loop'), 'Whether a self loop should be routed inside a node instead of around that node.'), false), BOOLEAN), Ljava_lang_Boolean_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.edge.thickness'), 'edge'), 'Edge Thickness'), 'The thickness of an edge. This is a hint on the line width used to draw an edge, possibly requiring more space to be reserved for it.'), 1), DOUBLE), Ljava_lang_Double_2_classLit), of_1(EDGES))));
    $register_1(registry, new LayoutOptionData($targets($optionClass($type($defaultValue($description_1($name_2($group($id_1(new LayoutOptionData$Builder, 'org.eclipse.elk.edge.type'), 'edge'), 'Edge Type'), 'The type of an edge. This is usually used for UML class diagrams, where associations must be handled differently from generalizations.'), EDGE_TYPE_DEFAULT), ENUM), Lorg_eclipse_elk_core_options_EdgeType_2_classLit), of_1(EDGES))));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.layered'), 'Layered'), 'The layer-based method was introduced by Sugiyama, Tagawa and Toda in 1981. It emphasizes the direction of edges by pointing as many edges as possible into the same direction. The nodes are arranged in layers, which are sometimes called "hierarchies", and then reordered such that the number of edge crossings is minimized. Afterwards, concrete coordinates are computed for the nodes and edge bend points.')));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.orthogonal'), 'Orthogonal'), 'Orthogonal methods that follow the "topology-shape-metrics" approach by Batini, Nardelli and Tamassia \'86. The first phase determines the topology of the drawing by applying a planarization technique, which results in a planar representation of the graph. The orthogonal shape is computed in the second phase, which aims at minimizing the number of edge bends, and is called orthogonalization. The third phase leads to concrete coordinates for nodes and edge bend points by applying a compaction method, thus defining the metrics.')));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.force'), 'Force'), 'Layout algorithms that follow physical analogies by simulating a system of attractive and repulsive forces. The first successful method of this kind was proposed by Eades in 1984.')));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.circle'), 'Circle'), 'Circular layout algorithms emphasize cycles or biconnected components of a graph by arranging them in circles. This is useful if a drawing is desired where such components are clearly grouped, or where cycles are shown as prominent OPTIONS of the graph.')));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.tree'), 'Tree'), 'Specialized layout methods for trees, i.e. acyclic graphs. The regular structure of graphs that have no undirected cycles can be emphasized using an algorithm of this type.')));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.planar'), 'Planar'), 'Algorithms that require a planar or upward planar graph. Most of these algorithms are theoretically interesting, but not practically usable.')));
    $register_0(registry, new LayoutCategoryData($description_0($name_1($id_0(new LayoutCategoryData$Builder, 'org.eclipse.elk.radial'), 'Radial'), 'Radial layout algorithms usually position the nodes of the graph on concentric circles.')));
    $apply_16((new FixedLayouterOptions, registry));
    $apply_15((new BoxLayouterOptions, registry));
    $apply_17((new RandomLayouterOptions, registry));
};
var ALGORITHM, ALIGNMENT_0, ALIGNMENT_DEFAULT, ASPECT_RATIO_4, BEND_POINTS, BOX_PACKING_MODE_0, BOX_PACKING_MODE_DEFAULT, CHILD_AREA_HEIGHT, CHILD_AREA_WIDTH, COMMENT_BOX_0, CONTENT_ALIGNMENT_2, CONTENT_ALIGNMENT_DEFAULT, DEBUG_MODE_3, DIRECTION_1, DIRECTION_DEFAULT_1, EDGE_LABELS_INLINE_1, EDGE_LABELS_PLACEMENT_0, EDGE_LABELS_PLACEMENT_DEFAULT, EDGE_ROUTING_0, EDGE_ROUTING_DEFAULT_0, EDGE_THICKNESS_0, EDGE_TYPE_DEFAULT, EXPAND_NODES_0, HIERARCHY_HANDLING_0, HIERARCHY_HANDLING_DEFAULT, HYPERNODE_0, INSIDE_SELF_LOOPS_ACTIVATE_0, INSIDE_SELF_LOOPS_YO_0, INTERACTIVE_8, INTERACTIVE_LAYOUT_2, JSON_EDGE_COORDS, JSON_EDGE_COORDS_DEFAULT, JSON_SHAPE_COORDS, JSON_SHAPE_COORDS_DEFAULT, JUNCTION_POINTS_0, JUNCTION_POINTS_DEFAULT, MARGINS_0, MARGINS_DEFAULT, NODE_LABELS_PADDING_0, NODE_LABELS_PADDING_DEFAULT, NODE_LABELS_PLACEMENT_5, NODE_LABELS_PLACEMENT_DEFAULT, NODE_SIZE_CONSTRAINTS_6, NODE_SIZE_CONSTRAINTS_DEFAULT, NODE_SIZE_FIXED_GRAPH_SIZE_3, NODE_SIZE_MINIMUM_5, NODE_SIZE_MINIMUM_DEFAULT, NODE_SIZE_OPTIONS_6, NODE_SIZE_OPTIONS_DEFAULT, NO_LAYOUT_0, OMIT_NODE_MICRO_LAYOUT_4, PADDING_5, PADDING_DEFAULT_6, PARTITIONING_ACTIVATE_0, PARTITIONING_ACTIVATE_DEFAULT, PARTITIONING_PARTITION_0, PARTITIONING_PARTITION_DEP_PARTITIONING_ACTIVATE_0, PORT_ALIGNMENT_DEFAULT, PORT_ALIGNMENT_DEFAULT_DEFAULT_0, PORT_ALIGNMENT_EAST_0, PORT_ALIGNMENT_NORTH_0, PORT_ALIGNMENT_SOUTH_0, PORT_ALIGNMENT_WEST_0, PORT_ANCHOR_0, PORT_BORDER_OFFSET_0, PORT_CONSTRAINTS_1, PORT_CONSTRAINTS_DEFAULT, PORT_INDEX_0, PORT_LABELS_NEXT_TO_PORT_IF_POSSIBLE_0, PORT_LABELS_PLACEMENT_5, PORT_LABELS_PLACEMENT_DEFAULT, PORT_LABELS_TREAT_AS_GROUP_0, PORT_SIDE_0, PORT_SIDE_DEFAULT, POSITION_2, PRIORITY_3, RANDOM_SEED_1, RESOLVED_ALGORITHM, SCALE_FACTOR, SEPARATE_CONNECTED_COMPONENTS_2, SPACING_COMMENT_COMMENT_0, SPACING_COMMENT_NODE_0, SPACING_COMPONENT_COMPONENT_0, SPACING_EDGE_EDGE_0, SPACING_EDGE_LABEL_1, SPACING_EDGE_NODE_1, SPACING_INDIVIDUAL_0, SPACING_LABEL_LABEL_0, SPACING_LABEL_NODE_0, SPACING_LABEL_PORT_HORIZONTAL_0, SPACING_LABEL_PORT_VERTICAL_0, SPACING_NODE_NODE_6, SPACING_NODE_SELF_LOOP_0, SPACING_PORTS_SURROUNDING_0, SPACING_PORTS_SURROUNDING_DEFAULT, SPACING_PORT_PORT_0, TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2, TOPDOWN_HIERARCHICAL_NODE_WIDTH_2, TOPDOWN_LAYOUT_2, TOPDOWN_NODE_TYPE, TOPDOWN_SCALE_CAP, TOPDOWN_SCALE_CAP_DEP_TOPDOWN_NODE_TYPE_0, TOPDOWN_SCALE_FACTOR_2, TOPDOWN_SCALE_FACTOR_DEP_TOPDOWN_NODE_TYPE_0, TOPDOWN_SIZE_APPROXIMATOR, TOPDOWN_SIZE_APPROXIMATOR_DEP_TOPDOWN_NODE_TYPE_0;
var Lorg_eclipse_elk_core_options_CoreOptions_2_classLit = createForClass('org.eclipse.elk.core.options', 'CoreOptions', 684);
function $clinit_Direction() {
    $clinit_Direction = emptyMethod;
    UNDEFINED_2 = new Direction('UNDEFINED', 0);
    RIGHT_6 = new Direction('RIGHT', 1);
    LEFT_6 = new Direction('LEFT', 2);
    DOWN_1 = new Direction('DOWN', 3);
    UP_1 = new Direction('UP', 4);
}
function $isHorizontal(this$static) {
    return this$static == LEFT_6 || this$static == RIGHT_6;
}
function $isVertical(this$static) {
    return this$static == UP_1 || this$static == DOWN_1;
}
function $opposite(this$static) {
    switch(this$static.ordinal){
        case 2:
            return RIGHT_6;
        case 1:
            return LEFT_6;
        case 4:
            return DOWN_1;
        case 3:
            return UP_1;
        default:
            return UNDEFINED_2;
    }
}
function Direction(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_95(name_0) {
    $clinit_Direction();
    return valueOf(($clinit_Direction$Map(), $MAP_85), name_0);
}
function values_103() {
    $clinit_Direction();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Direction_2_classLit, 1), $intern_36, 86, 0, [
        UNDEFINED_2,
        RIGHT_6,
        LEFT_6,
        DOWN_1,
        UP_1
    ]);
}
defineClass(86, 23, {
    3: 1,
    34: 1,
    23: 1,
    86: 1
}, Direction);
var DOWN_1, LEFT_6, RIGHT_6, UNDEFINED_2, UP_1;
var Lorg_eclipse_elk_core_options_Direction_2_classLit = createForEnum('org.eclipse.elk.core.options', 'Direction', 86, Ljava_lang_Enum_2_classLit, values_103, valueOf_95);
function $clinit_Direction$Map() {
    $clinit_Direction$Map = emptyMethod;
    $MAP_85 = createValueOfMap(($clinit_Direction(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_Direction_2_classLit, 1), $intern_36, 86, 0, [
        UNDEFINED_2,
        RIGHT_6,
        LEFT_6,
        DOWN_1,
        UP_1
    ])));
}
var $MAP_85;
function $clinit_EdgeCoords() {
    $clinit_EdgeCoords = emptyMethod;
    INHERIT = new EdgeCoords('INHERIT', 0);
    CONTAINER = new EdgeCoords('CONTAINER', 1);
    PARENT = new EdgeCoords('PARENT', 2);
    ROOT_1 = new EdgeCoords('ROOT', 3);
}
function EdgeCoords(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_96(name_0) {
    $clinit_EdgeCoords();
    return valueOf(($clinit_EdgeCoords$Map(), $MAP_86), name_0);
}
function values_104() {
    $clinit_EdgeCoords();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeCoords_2_classLit, 1), $intern_36, 275, 0, [
        INHERIT,
        CONTAINER,
        PARENT,
        ROOT_1
    ]);
}
defineClass(275, 23, {
    3: 1,
    34: 1,
    23: 1,
    275: 1
}, EdgeCoords);
var CONTAINER, INHERIT, PARENT, ROOT_1;
var Lorg_eclipse_elk_core_options_EdgeCoords_2_classLit = createForEnum('org.eclipse.elk.core.options', 'EdgeCoords', 275, Ljava_lang_Enum_2_classLit, values_104, valueOf_96);
function $clinit_EdgeCoords$Map() {
    $clinit_EdgeCoords$Map = emptyMethod;
    $MAP_86 = createValueOfMap(($clinit_EdgeCoords(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeCoords_2_classLit, 1), $intern_36, 275, 0, [
        INHERIT,
        CONTAINER,
        PARENT,
        ROOT_1
    ])));
}
var $MAP_86;
function $clinit_EdgeLabelPlacement() {
    $clinit_EdgeLabelPlacement = emptyMethod;
    CENTER_5 = new EdgeLabelPlacement('CENTER', 0);
    HEAD = new EdgeLabelPlacement('HEAD', 1);
    TAIL = new EdgeLabelPlacement('TAIL', 2);
}
function EdgeLabelPlacement(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_97(name_0) {
    $clinit_EdgeLabelPlacement();
    return valueOf(($clinit_EdgeLabelPlacement$Map(), $MAP_87), name_0);
}
function values_105() {
    $clinit_EdgeLabelPlacement();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeLabelPlacement_2_classLit, 1), $intern_36, 276, 0, [
        CENTER_5,
        HEAD,
        TAIL
    ]);
}
defineClass(276, 23, {
    3: 1,
    34: 1,
    23: 1,
    276: 1
}, EdgeLabelPlacement);
var CENTER_5, HEAD, TAIL;
var Lorg_eclipse_elk_core_options_EdgeLabelPlacement_2_classLit = createForEnum('org.eclipse.elk.core.options', 'EdgeLabelPlacement', 276, Ljava_lang_Enum_2_classLit, values_105, valueOf_97);
function $clinit_EdgeLabelPlacement$Map() {
    $clinit_EdgeLabelPlacement$Map = emptyMethod;
    $MAP_87 = createValueOfMap(($clinit_EdgeLabelPlacement(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeLabelPlacement_2_classLit, 1), $intern_36, 276, 0, [
        CENTER_5,
        HEAD,
        TAIL
    ])));
}
var $MAP_87;
function $clinit_EdgeRouting() {
    $clinit_EdgeRouting = emptyMethod;
    UNDEFINED_3 = new EdgeRouting('UNDEFINED', 0);
    POLYLINE = new EdgeRouting('POLYLINE', 1);
    ORTHOGONAL = new EdgeRouting('ORTHOGONAL', 2);
    SPLINES = new EdgeRouting('SPLINES', 3);
}
function EdgeRouting(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_98(name_0) {
    $clinit_EdgeRouting();
    return valueOf(($clinit_EdgeRouting$Map(), $MAP_88), name_0);
}
function values_106() {
    $clinit_EdgeRouting();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeRouting_2_classLit, 1), $intern_36, 220, 0, [
        UNDEFINED_3,
        POLYLINE,
        ORTHOGONAL,
        SPLINES
    ]);
}
defineClass(220, 23, {
    3: 1,
    34: 1,
    23: 1,
    220: 1
}, EdgeRouting);
var ORTHOGONAL, POLYLINE, SPLINES, UNDEFINED_3;
var Lorg_eclipse_elk_core_options_EdgeRouting_2_classLit = createForEnum('org.eclipse.elk.core.options', 'EdgeRouting', 220, Ljava_lang_Enum_2_classLit, values_106, valueOf_98);
function $clinit_EdgeRouting$Map() {
    $clinit_EdgeRouting$Map = emptyMethod;
    $MAP_88 = createValueOfMap(($clinit_EdgeRouting(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeRouting_2_classLit, 1), $intern_36, 220, 0, [
        UNDEFINED_3,
        POLYLINE,
        ORTHOGONAL,
        SPLINES
    ])));
}
var $MAP_88;
function $clinit_EdgeType() {
    $clinit_EdgeType = emptyMethod;
    NONE_18 = new EdgeType('NONE', 0);
    DIRECTED = new EdgeType('DIRECTED', 1);
    UNDIRECTED = new EdgeType('UNDIRECTED', 2);
    ASSOCIATION = new EdgeType('ASSOCIATION', 3);
    GENERALIZATION = new EdgeType('GENERALIZATION', 4);
    DEPENDENCY = new EdgeType('DEPENDENCY', 5);
}
function EdgeType(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_99(name_0) {
    $clinit_EdgeType();
    return valueOf(($clinit_EdgeType$Map(), $MAP_89), name_0);
}
function values_107() {
    $clinit_EdgeType();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeType_2_classLit, 1), $intern_36, 322, 0, [
        NONE_18,
        DIRECTED,
        UNDIRECTED,
        ASSOCIATION,
        GENERALIZATION,
        DEPENDENCY
    ]);
}
defineClass(322, 23, {
    3: 1,
    34: 1,
    23: 1,
    322: 1
}, EdgeType);
var ASSOCIATION, DEPENDENCY, DIRECTED, GENERALIZATION, NONE_18, UNDIRECTED;
var Lorg_eclipse_elk_core_options_EdgeType_2_classLit = createForEnum('org.eclipse.elk.core.options', 'EdgeType', 322, Ljava_lang_Enum_2_classLit, values_107, valueOf_99);
function $clinit_EdgeType$Map() {
    $clinit_EdgeType$Map = emptyMethod;
    $MAP_89 = createValueOfMap(($clinit_EdgeType(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_EdgeType_2_classLit, 1), $intern_36, 322, 0, [
        NONE_18,
        DIRECTED,
        UNDIRECTED,
        ASSOCIATION,
        GENERALIZATION,
        DEPENDENCY
    ])));
}
var $MAP_89;
function $clinit_FixedLayouterOptions() {
    $clinit_FixedLayouterOptions = emptyMethod;
    PADDING_DEFAULT_7 = new ElkPadding_0(15);
    PADDING_6 = new Property_2(($clinit_CoreOptions(), PADDING_5), PADDING_DEFAULT_7);
    POSITION_3 = POSITION_2;
    BEND_POINTS_0 = BEND_POINTS;
    NODE_SIZE_CONSTRAINTS_7 = NODE_SIZE_CONSTRAINTS_6;
    NODE_SIZE_MINIMUM_6 = NODE_SIZE_MINIMUM_5;
    NODE_SIZE_FIXED_GRAPH_SIZE_4 = NODE_SIZE_FIXED_GRAPH_SIZE_3;
}
function $apply_16(registry) {
    $register(registry, new LayoutAlgorithmData($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.fixed'), 'ELK Fixed'), 'Keeps the current layout as it is, without any automatic modification. Optional coordinates can be given for nodes and edge bend points.'), new FixedLayouterOptions$FixedFactory)));
    $addOptionSupport(registry, 'org.eclipse.elk.fixed', 'org.eclipse.elk.padding', PADDING_DEFAULT_7);
    $addOptionSupport(registry, 'org.eclipse.elk.fixed', 'org.eclipse.elk.position', $getDefault(POSITION_3));
    $addOptionSupport(registry, 'org.eclipse.elk.fixed', 'org.eclipse.elk.bendPoints', $getDefault(BEND_POINTS_0));
    $addOptionSupport(registry, 'org.eclipse.elk.fixed', 'org.eclipse.elk.nodeSize.constraints', $getDefault(NODE_SIZE_CONSTRAINTS_7));
    $addOptionSupport(registry, 'org.eclipse.elk.fixed', 'org.eclipse.elk.nodeSize.minimum', $getDefault(NODE_SIZE_MINIMUM_6));
    $addOptionSupport(registry, 'org.eclipse.elk.fixed', 'org.eclipse.elk.nodeSize.fixedGraphSize', $getDefault(NODE_SIZE_FIXED_GRAPH_SIZE_4));
}
function FixedLayouterOptions() {
    $clinit_FixedLayouterOptions();
}
defineClass(966, 1, $intern_98, FixedLayouterOptions);
_.apply_4 = function apply_153(registry) {
    $apply_16(registry);
};
var BEND_POINTS_0, NODE_SIZE_CONSTRAINTS_7, NODE_SIZE_FIXED_GRAPH_SIZE_4, NODE_SIZE_MINIMUM_6, PADDING_6, PADDING_DEFAULT_7, POSITION_3;
var Lorg_eclipse_elk_core_options_FixedLayouterOptions_2_classLit = createForClass('org.eclipse.elk.core.options', 'FixedLayouterOptions', 966);
function FixedLayouterOptions$FixedFactory() {}
defineClass(967, 1, {}, FixedLayouterOptions$FixedFactory);
_.create_0 = function create_44() {
    var provider;
    return provider = new FixedLayoutProvider, provider;
};
_.destroy = function destroy_8(obj) {};
var Lorg_eclipse_elk_core_options_FixedLayouterOptions$FixedFactory_2_classLit = createForClass('org.eclipse.elk.core.options', 'FixedLayouterOptions/FixedFactory', 967);
function $clinit_HierarchyHandling() {
    $clinit_HierarchyHandling = emptyMethod;
    INHERIT_0 = new HierarchyHandling('INHERIT', 0);
    INCLUDE_CHILDREN = new HierarchyHandling('INCLUDE_CHILDREN', 1);
    SEPARATE_CHILDREN = new HierarchyHandling('SEPARATE_CHILDREN', 2);
}
function HierarchyHandling(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_100(name_0) {
    $clinit_HierarchyHandling();
    return valueOf(($clinit_HierarchyHandling$Map(), $MAP_90), name_0);
}
function values_108() {
    $clinit_HierarchyHandling();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_HierarchyHandling_2_classLit, 1), $intern_36, 342, 0, [
        INHERIT_0,
        INCLUDE_CHILDREN,
        SEPARATE_CHILDREN
    ]);
}
defineClass(342, 23, {
    3: 1,
    34: 1,
    23: 1,
    342: 1
}, HierarchyHandling);
var INCLUDE_CHILDREN, INHERIT_0, SEPARATE_CHILDREN;
var Lorg_eclipse_elk_core_options_HierarchyHandling_2_classLit = createForEnum('org.eclipse.elk.core.options', 'HierarchyHandling', 342, Ljava_lang_Enum_2_classLit, values_108, valueOf_100);
function $clinit_HierarchyHandling$Map() {
    $clinit_HierarchyHandling$Map = emptyMethod;
    $MAP_90 = createValueOfMap(($clinit_HierarchyHandling(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_HierarchyHandling_2_classLit, 1), $intern_36, 342, 0, [
        INHERIT_0,
        INCLUDE_CHILDREN,
        SEPARATE_CHILDREN
    ])));
}
var $MAP_90;
function $clinit_LabelSide() {
    $clinit_LabelSide = emptyMethod;
    UNKNOWN = new LabelSide('UNKNOWN', 0);
    ABOVE = new LabelSide('ABOVE', 1);
    BELOW = new LabelSide('BELOW', 2);
    INLINE = new LabelSide('INLINE', 3);
    new Property_0('org.eclipse.elk.labelSide', UNKNOWN);
}
function $opposite_0(this$static) {
    switch(this$static.ordinal){
        case 1:
            return BELOW;
        case 2:
            return ABOVE;
        case 3:
            return INLINE;
        default:
            return UNKNOWN;
    }
}
function LabelSide(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_101(name_0) {
    $clinit_LabelSide();
    return valueOf(($clinit_LabelSide$Map(), $MAP_91), name_0);
}
function values_109() {
    $clinit_LabelSide();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_LabelSide_2_classLit, 1), $intern_36, 289, 0, [
        UNKNOWN,
        ABOVE,
        BELOW,
        INLINE
    ]);
}
defineClass(289, 23, {
    3: 1,
    34: 1,
    23: 1,
    289: 1
}, LabelSide);
var ABOVE, BELOW, INLINE, UNKNOWN;
var Lorg_eclipse_elk_core_options_LabelSide_2_classLit = createForEnum('org.eclipse.elk.core.options', 'LabelSide', 289, Ljava_lang_Enum_2_classLit, values_109, valueOf_101);
function $clinit_LabelSide$Map() {
    $clinit_LabelSide$Map = emptyMethod;
    $MAP_91 = createValueOfMap(($clinit_LabelSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_LabelSide_2_classLit, 1), $intern_36, 289, 0, [
        UNKNOWN,
        ABOVE,
        BELOW,
        INLINE
    ])));
}
var $MAP_91;
function $clinit_NodeLabelPlacement() {
    $clinit_NodeLabelPlacement = emptyMethod;
    H_LEFT_0 = new NodeLabelPlacement('H_LEFT', 0);
    H_CENTER_0 = new NodeLabelPlacement('H_CENTER', 1);
    H_RIGHT_0 = new NodeLabelPlacement('H_RIGHT', 2);
    V_TOP_0 = new NodeLabelPlacement('V_TOP', 3);
    V_CENTER_0 = new NodeLabelPlacement('V_CENTER', 4);
    V_BOTTOM_0 = new NodeLabelPlacement('V_BOTTOM', 5);
    INSIDE = new NodeLabelPlacement('INSIDE', 6);
    OUTSIDE = new NodeLabelPlacement('OUTSIDE', 7);
    H_PRIORITY = new NodeLabelPlacement('H_PRIORITY', 8);
}
function NodeLabelPlacement(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function isValid_0(placement) {
    $clinit_NodeLabelPlacement();
    var validHorizontal, validInsideOutside, validVertical;
    validInsideOutside = of_2(INSIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
        OUTSIDE
    ]));
    if ($size_1(intersection_0(validInsideOutside, placement)) > 1) return false;
    validHorizontal = of_2(H_LEFT_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
        H_CENTER_0,
        H_RIGHT_0
    ]));
    if ($size_1(intersection_0(validHorizontal, placement)) > 1) return false;
    validVertical = of_2(V_TOP_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
        V_CENTER_0,
        V_BOTTOM_0
    ]));
    if ($size_1(intersection_0(validVertical, placement)) > 1) return false;
    return true;
}
function valueOf_102(name_0) {
    $clinit_NodeLabelPlacement();
    return valueOf(($clinit_NodeLabelPlacement$Map(), $MAP_92), name_0);
}
function values_110() {
    $clinit_NodeLabelPlacement();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
        H_LEFT_0,
        H_CENTER_0,
        H_RIGHT_0,
        V_TOP_0,
        V_CENTER_0,
        V_BOTTOM_0,
        INSIDE,
        OUTSIDE,
        H_PRIORITY
    ]);
}
defineClass(94, 23, {
    3: 1,
    34: 1,
    23: 1,
    94: 1
}, NodeLabelPlacement);
var H_CENTER_0, H_LEFT_0, H_PRIORITY, H_RIGHT_0, INSIDE, OUTSIDE, V_BOTTOM_0, V_CENTER_0, V_TOP_0;
var Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit = createForEnum('org.eclipse.elk.core.options', 'NodeLabelPlacement', 94, Ljava_lang_Enum_2_classLit, values_110, valueOf_102);
function $clinit_NodeLabelPlacement$Map() {
    $clinit_NodeLabelPlacement$Map = emptyMethod;
    $MAP_92 = createValueOfMap(($clinit_NodeLabelPlacement(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_NodeLabelPlacement_2_classLit, 1), $intern_36, 94, 0, [
        H_LEFT_0,
        H_CENTER_0,
        H_RIGHT_0,
        V_TOP_0,
        V_CENTER_0,
        V_BOTTOM_0,
        INSIDE,
        OUTSIDE,
        H_PRIORITY
    ])));
}
var $MAP_92;
function $clinit_PortAlignment() {
    $clinit_PortAlignment = emptyMethod;
    DISTRIBUTED = new PortAlignment('DISTRIBUTED', 0);
    JUSTIFIED = new PortAlignment('JUSTIFIED', 1);
    BEGIN_0 = new PortAlignment('BEGIN', 2);
    CENTER_6 = new PortAlignment('CENTER', 3);
    END_1 = new PortAlignment('END', 4);
}
function PortAlignment(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_103(name_0) {
    $clinit_PortAlignment();
    return valueOf(($clinit_PortAlignment$Map(), $MAP_93), name_0);
}
function values_111() {
    $clinit_PortAlignment();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortAlignment_2_classLit, 1), $intern_36, 255, 0, [
        DISTRIBUTED,
        JUSTIFIED,
        BEGIN_0,
        CENTER_6,
        END_1
    ]);
}
defineClass(255, 23, {
    3: 1,
    34: 1,
    23: 1,
    255: 1
}, PortAlignment);
var BEGIN_0, CENTER_6, DISTRIBUTED, END_1, JUSTIFIED;
var Lorg_eclipse_elk_core_options_PortAlignment_2_classLit = createForEnum('org.eclipse.elk.core.options', 'PortAlignment', 255, Ljava_lang_Enum_2_classLit, values_111, valueOf_103);
function $clinit_PortAlignment$Map() {
    $clinit_PortAlignment$Map = emptyMethod;
    $MAP_93 = createValueOfMap(($clinit_PortAlignment(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortAlignment_2_classLit, 1), $intern_36, 255, 0, [
        DISTRIBUTED,
        JUSTIFIED,
        BEGIN_0,
        CENTER_6,
        END_1
    ])));
}
var $MAP_93;
function $clinit_PortConstraints() {
    $clinit_PortConstraints = emptyMethod;
    UNDEFINED_4 = new PortConstraints('UNDEFINED', 0);
    FREE = new PortConstraints('FREE', 1);
    FIXED_SIDE = new PortConstraints('FIXED_SIDE', 2);
    FIXED_ORDER = new PortConstraints('FIXED_ORDER', 3);
    FIXED_RATIO = new PortConstraints('FIXED_RATIO', 4);
    FIXED_POS = new PortConstraints('FIXED_POS', 5);
}
function $isOrderFixed(this$static) {
    return this$static == FIXED_ORDER || this$static == FIXED_RATIO || this$static == FIXED_POS;
}
function $isSideFixed(this$static) {
    return this$static != FREE && this$static != UNDEFINED_4;
}
function PortConstraints(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_104(name_0) {
    $clinit_PortConstraints();
    return valueOf(($clinit_PortConstraints$Map(), $MAP_94), name_0);
}
function values_112() {
    $clinit_PortConstraints();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortConstraints_2_classLit, 1), $intern_36, 100, 0, [
        UNDEFINED_4,
        FREE,
        FIXED_SIDE,
        FIXED_ORDER,
        FIXED_RATIO,
        FIXED_POS
    ]);
}
defineClass(100, 23, {
    3: 1,
    34: 1,
    23: 1,
    100: 1
}, PortConstraints);
var FIXED_ORDER, FIXED_POS, FIXED_RATIO, FIXED_SIDE, FREE, UNDEFINED_4;
var Lorg_eclipse_elk_core_options_PortConstraints_2_classLit = createForEnum('org.eclipse.elk.core.options', 'PortConstraints', 100, Ljava_lang_Enum_2_classLit, values_112, valueOf_104);
function $clinit_PortConstraints$Map() {
    $clinit_PortConstraints$Map = emptyMethod;
    $MAP_94 = createValueOfMap(($clinit_PortConstraints(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortConstraints_2_classLit, 1), $intern_36, 100, 0, [
        UNDEFINED_4,
        FREE,
        FIXED_SIDE,
        FIXED_ORDER,
        FIXED_RATIO,
        FIXED_POS
    ])));
}
var $MAP_94;
function $clinit_PortLabelPlacement() {
    $clinit_PortLabelPlacement = emptyMethod;
    OUTSIDE_0 = new PortLabelPlacement('OUTSIDE', 0);
    INSIDE_0 = new PortLabelPlacement('INSIDE', 1);
    NEXT_TO_PORT_IF_POSSIBLE_0 = new PortLabelPlacement('NEXT_TO_PORT_IF_POSSIBLE', 2);
    ALWAYS_SAME_SIDE = new PortLabelPlacement('ALWAYS_SAME_SIDE', 3);
    ALWAYS_OTHER_SAME_SIDE = new PortLabelPlacement('ALWAYS_OTHER_SAME_SIDE', 4);
    SPACE_EFFICIENT_0 = new PortLabelPlacement('SPACE_EFFICIENT', 5);
}
function PortLabelPlacement(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function isFixed(placement) {
    $clinit_PortLabelPlacement();
    return !placement.contains(INSIDE_0) && !placement.contains(OUTSIDE_0);
}
function isValid_1(placement) {
    $clinit_PortLabelPlacement();
    var validInsideOutside, validPosition;
    validInsideOutside = of_2(INSIDE_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortLabelPlacement_2_classLit, 1), $intern_36, 277, 0, [
        OUTSIDE_0
    ]));
    if ($size_1(intersection_0(validInsideOutside, placement)) > 1) return false;
    validPosition = of_2(ALWAYS_SAME_SIDE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortLabelPlacement_2_classLit, 1), $intern_36, 277, 0, [
        ALWAYS_OTHER_SAME_SIDE,
        SPACE_EFFICIENT_0
    ]));
    if ($size_1(intersection_0(validPosition, placement)) > 1) return false;
    return true;
}
function valueOf_105(name_0) {
    $clinit_PortLabelPlacement();
    return valueOf(($clinit_PortLabelPlacement$Map(), $MAP_95), name_0);
}
function values_113() {
    $clinit_PortLabelPlacement();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortLabelPlacement_2_classLit, 1), $intern_36, 277, 0, [
        OUTSIDE_0,
        INSIDE_0,
        NEXT_TO_PORT_IF_POSSIBLE_0,
        ALWAYS_SAME_SIDE,
        ALWAYS_OTHER_SAME_SIDE,
        SPACE_EFFICIENT_0
    ]);
}
defineClass(277, 23, {
    3: 1,
    34: 1,
    23: 1,
    277: 1
}, PortLabelPlacement);
var ALWAYS_OTHER_SAME_SIDE, ALWAYS_SAME_SIDE, INSIDE_0, NEXT_TO_PORT_IF_POSSIBLE_0, OUTSIDE_0, SPACE_EFFICIENT_0;
var Lorg_eclipse_elk_core_options_PortLabelPlacement_2_classLit = createForEnum('org.eclipse.elk.core.options', 'PortLabelPlacement', 277, Ljava_lang_Enum_2_classLit, values_113, valueOf_105);
function $clinit_PortLabelPlacement$Map() {
    $clinit_PortLabelPlacement$Map = emptyMethod;
    $MAP_95 = createValueOfMap(($clinit_PortLabelPlacement(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortLabelPlacement_2_classLit, 1), $intern_36, 277, 0, [
        OUTSIDE_0,
        INSIDE_0,
        NEXT_TO_PORT_IF_POSSIBLE_0,
        ALWAYS_SAME_SIDE,
        ALWAYS_OTHER_SAME_SIDE,
        SPACE_EFFICIENT_0
    ])));
}
var $MAP_95;
function $clinit_PortSide() {
    $clinit_PortSide = emptyMethod;
    var all;
    UNDEFINED_5 = new PortSide('UNDEFINED', 0);
    NORTH_1 = new PortSide('NORTH', 1);
    EAST_0 = new PortSide('EAST', 2);
    SOUTH_0 = new PortSide('SOUTH', 3);
    WEST_0 = new PortSide('WEST', 4);
    SIDES_NONE = ($clinit_Collections(), new Collections$UnmodifiableSet((all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_PortSide_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0))));
    SIDES_NORTH = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [])));
    SIDES_EAST = asImmutable(of_2(EAST_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [])));
    SIDES_SOUTH = asImmutable(of_2(SOUTH_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [])));
    SIDES_WEST = asImmutable(of_2(WEST_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [])));
    SIDES_NORTH_SOUTH = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        SOUTH_0
    ])));
    SIDES_EAST_WEST = asImmutable(of_2(EAST_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        WEST_0
    ])));
    SIDES_NORTH_WEST = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        WEST_0
    ])));
    SIDES_NORTH_EAST = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        EAST_0
    ])));
    SIDES_SOUTH_WEST = asImmutable(of_2(SOUTH_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        WEST_0
    ])));
    SIDES_EAST_SOUTH = asImmutable(of_2(EAST_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        SOUTH_0
    ])));
    SIDES_NORTH_EAST_WEST = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        EAST_0,
        WEST_0
    ])));
    SIDES_EAST_SOUTH_WEST = asImmutable(of_2(EAST_0, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        SOUTH_0,
        WEST_0
    ])));
    SIDES_NORTH_SOUTH_WEST = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        SOUTH_0,
        WEST_0
    ])));
    SIDES_NORTH_EAST_SOUTH = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        EAST_0,
        SOUTH_0
    ])));
    SIDES_NORTH_EAST_SOUTH_WEST = asImmutable(of_2(NORTH_1, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        EAST_0,
        SOUTH_0,
        WEST_0
    ])));
}
function $left(this$static) {
    switch(this$static.ordinal){
        case 1:
            return WEST_0;
        case 2:
            return NORTH_1;
        case 3:
            return EAST_0;
        case 4:
            return SOUTH_0;
        default:
            return UNDEFINED_5;
    }
}
function $opposed(this$static) {
    switch(this$static.ordinal){
        case 1:
            return SOUTH_0;
        case 2:
            return WEST_0;
        case 3:
            return NORTH_1;
        case 4:
            return EAST_0;
        default:
            return UNDEFINED_5;
    }
}
function $right(this$static) {
    switch(this$static.ordinal){
        case 1:
            return EAST_0;
        case 2:
            return SOUTH_0;
        case 3:
            return WEST_0;
        case 4:
            return NORTH_1;
        default:
            return UNDEFINED_5;
    }
}
function PortSide(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function fromDirection(direction) {
    $clinit_PortSide();
    switch(direction.ordinal){
        case 4:
            return NORTH_1;
        case 1:
            return EAST_0;
        case 3:
            return SOUTH_0;
        case 2:
            return WEST_0;
        default:
            return UNDEFINED_5;
    }
}
function valueOf_106(name_0) {
    $clinit_PortSide();
    return valueOf(($clinit_PortSide$Map(), $MAP_96), name_0);
}
function values_114() {
    $clinit_PortSide();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ]);
}
defineClass(64, 23, {
    3: 1,
    34: 1,
    23: 1,
    64: 1
}, PortSide);
var EAST_0, NORTH_1, SIDES_EAST, SIDES_EAST_SOUTH, SIDES_EAST_SOUTH_WEST, SIDES_EAST_WEST, SIDES_NONE, SIDES_NORTH, SIDES_NORTH_EAST, SIDES_NORTH_EAST_SOUTH, SIDES_NORTH_EAST_SOUTH_WEST, SIDES_NORTH_EAST_WEST, SIDES_NORTH_SOUTH, SIDES_NORTH_SOUTH_WEST, SIDES_NORTH_WEST, SIDES_SOUTH, SIDES_SOUTH_WEST, SIDES_WEST, SOUTH_0, UNDEFINED_5, WEST_0;
var Lorg_eclipse_elk_core_options_PortSide_2_classLit = createForEnum('org.eclipse.elk.core.options', 'PortSide', 64, Ljava_lang_Enum_2_classLit, values_114, valueOf_106);
function $clinit_PortSide$Map() {
    $clinit_PortSide$Map = emptyMethod;
    $MAP_96 = createValueOfMap(($clinit_PortSide(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_PortSide_2_classLit, 1), $intern_100, 64, 0, [
        UNDEFINED_5,
        NORTH_1,
        EAST_0,
        SOUTH_0,
        WEST_0
    ])));
}
var $MAP_96;
function $clinit_RandomLayouterOptions() {
    $clinit_RandomLayouterOptions = emptyMethod;
    PADDING_DEFAULT_8 = new ElkPadding_0(15);
    PADDING_7 = new Property_2(($clinit_CoreOptions(), PADDING_5), PADDING_DEFAULT_8);
    SPACING_NODE_NODE_7 = new Property_2(SPACING_NODE_NODE_6, 15);
    RANDOM_SEED_2 = new Property_2(RANDOM_SEED_1, valueOf_3(0));
    ASPECT_RATIO_5 = new Property_2(ASPECT_RATIO_4, $intern_99);
}
function $apply_17(registry) {
    $register(registry, new LayoutAlgorithmData($providerFactory($description($name_0($id(new LayoutAlgorithmData$Builder, 'org.eclipse.elk.random'), 'ELK Randomizer'), 'Distributes the nodes randomly on the plane, leading to very obfuscating layouts. Can be useful to demonstrate the power of "real" layout algorithms.'), new RandomLayouterOptions$RandomFactory)));
    $addOptionSupport(registry, 'org.eclipse.elk.random', 'org.eclipse.elk.padding', PADDING_DEFAULT_8);
    $addOptionSupport(registry, 'org.eclipse.elk.random', 'org.eclipse.elk.spacing.nodeNode', 15);
    $addOptionSupport(registry, 'org.eclipse.elk.random', 'org.eclipse.elk.randomSeed', valueOf_3(0));
    $addOptionSupport(registry, 'org.eclipse.elk.random', 'org.eclipse.elk.aspectRatio', $intern_99);
}
function RandomLayouterOptions() {
    $clinit_RandomLayouterOptions();
}
defineClass(970, 1, $intern_98, RandomLayouterOptions);
_.apply_4 = function apply_154(registry) {
    $apply_17(registry);
};
var ASPECT_RATIO_5, PADDING_7, PADDING_DEFAULT_8, RANDOM_SEED_2, SPACING_NODE_NODE_7;
var Lorg_eclipse_elk_core_options_RandomLayouterOptions_2_classLit = createForClass('org.eclipse.elk.core.options', 'RandomLayouterOptions', 970);
function RandomLayouterOptions$RandomFactory() {}
defineClass(971, 1, {}, RandomLayouterOptions$RandomFactory);
_.create_0 = function create_45() {
    var provider;
    return provider = new RandomLayoutProvider, provider;
};
_.destroy = function destroy_9(obj) {};
var Lorg_eclipse_elk_core_options_RandomLayouterOptions$RandomFactory_2_classLit = createForClass('org.eclipse.elk.core.options', 'RandomLayouterOptions/RandomFactory', 971);
function $clinit_ShapeCoords() {
    $clinit_ShapeCoords = emptyMethod;
    INHERIT_1 = new ShapeCoords('INHERIT', 0);
    PARENT_0 = new ShapeCoords('PARENT', 1);
    ROOT_2 = new ShapeCoords('ROOT', 2);
}
function ShapeCoords(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_107(name_0) {
    $clinit_ShapeCoords();
    return valueOf(($clinit_ShapeCoords$Map(), $MAP_97), name_0);
}
function values_115() {
    $clinit_ShapeCoords();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_ShapeCoords_2_classLit, 1), $intern_36, 297, 0, [
        INHERIT_1,
        PARENT_0,
        ROOT_2
    ]);
}
defineClass(297, 23, {
    3: 1,
    34: 1,
    23: 1,
    297: 1
}, ShapeCoords);
var INHERIT_1, PARENT_0, ROOT_2;
var Lorg_eclipse_elk_core_options_ShapeCoords_2_classLit = createForEnum('org.eclipse.elk.core.options', 'ShapeCoords', 297, Ljava_lang_Enum_2_classLit, values_115, valueOf_107);
function $clinit_ShapeCoords$Map() {
    $clinit_ShapeCoords$Map = emptyMethod;
    $MAP_97 = createValueOfMap(($clinit_ShapeCoords(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_ShapeCoords_2_classLit, 1), $intern_36, 297, 0, [
        INHERIT_1,
        PARENT_0,
        ROOT_2
    ])));
}
var $MAP_97;
function $clinit_SizeConstraint() {
    $clinit_SizeConstraint = emptyMethod;
    PORTS_0 = new SizeConstraint('PORTS', 0);
    PORT_LABELS = new SizeConstraint('PORT_LABELS', 1);
    NODE_LABELS = new SizeConstraint('NODE_LABELS', 2);
    MINIMUM_SIZE = new SizeConstraint('MINIMUM_SIZE', 3);
}
function SizeConstraint(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_108(name_0) {
    $clinit_SizeConstraint();
    return valueOf(($clinit_SizeConstraint$Map(), $MAP_98), name_0);
}
function values_116() {
    $clinit_SizeConstraint();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit, 1), $intern_36, 378, 0, [
        PORTS_0,
        PORT_LABELS,
        NODE_LABELS,
        MINIMUM_SIZE
    ]);
}
defineClass(378, 23, {
    3: 1,
    34: 1,
    23: 1,
    378: 1
}, SizeConstraint);
var MINIMUM_SIZE, NODE_LABELS, PORTS_0, PORT_LABELS;
var Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit = createForEnum('org.eclipse.elk.core.options', 'SizeConstraint', 378, Ljava_lang_Enum_2_classLit, values_116, valueOf_108);
function $clinit_SizeConstraint$Map() {
    $clinit_SizeConstraint$Map = emptyMethod;
    $MAP_98 = createValueOfMap(($clinit_SizeConstraint(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit, 1), $intern_36, 378, 0, [
        PORTS_0,
        PORT_LABELS,
        NODE_LABELS,
        MINIMUM_SIZE
    ])));
}
var $MAP_98;
function $clinit_SizeOptions() {
    $clinit_SizeOptions = emptyMethod;
    DEFAULT_MINIMUM_SIZE = new SizeOptions('DEFAULT_MINIMUM_SIZE', 0);
    MINIMUM_SIZE_ACCOUNTS_FOR_PADDING = new SizeOptions('MINIMUM_SIZE_ACCOUNTS_FOR_PADDING', 1);
    COMPUTE_PADDING = new SizeOptions('COMPUTE_PADDING', 2);
    OUTSIDE_NODE_LABELS_OVERHANG = new SizeOptions('OUTSIDE_NODE_LABELS_OVERHANG', 3);
    PORTS_OVERHANG = new SizeOptions('PORTS_OVERHANG', 4);
    UNIFORM_PORT_SPACING = new SizeOptions('UNIFORM_PORT_SPACING', 5);
    SPACE_EFFICIENT_PORT_LABELS = new SizeOptions('SPACE_EFFICIENT_PORT_LABELS', 6);
    FORCE_TABULAR_NODE_LABELS = new SizeOptions('FORCE_TABULAR_NODE_LABELS', 7);
    ASYMMETRICAL = new SizeOptions('ASYMMETRICAL', 8);
}
function SizeOptions(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_109(name_0) {
    $clinit_SizeOptions();
    return valueOf(($clinit_SizeOptions$Map(), $MAP_99), name_0);
}
function values_117() {
    $clinit_SizeOptions();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_SizeOptions_2_classLit, 1), $intern_36, 264, 0, [
        DEFAULT_MINIMUM_SIZE,
        MINIMUM_SIZE_ACCOUNTS_FOR_PADDING,
        COMPUTE_PADDING,
        OUTSIDE_NODE_LABELS_OVERHANG,
        PORTS_OVERHANG,
        UNIFORM_PORT_SPACING,
        SPACE_EFFICIENT_PORT_LABELS,
        FORCE_TABULAR_NODE_LABELS,
        ASYMMETRICAL
    ]);
}
defineClass(264, 23, {
    3: 1,
    34: 1,
    23: 1,
    264: 1
}, SizeOptions);
var ASYMMETRICAL, COMPUTE_PADDING, DEFAULT_MINIMUM_SIZE, FORCE_TABULAR_NODE_LABELS, MINIMUM_SIZE_ACCOUNTS_FOR_PADDING, OUTSIDE_NODE_LABELS_OVERHANG, PORTS_OVERHANG, SPACE_EFFICIENT_PORT_LABELS, UNIFORM_PORT_SPACING;
var Lorg_eclipse_elk_core_options_SizeOptions_2_classLit = createForEnum('org.eclipse.elk.core.options', 'SizeOptions', 264, Ljava_lang_Enum_2_classLit, values_117, valueOf_109);
function $clinit_SizeOptions$Map() {
    $clinit_SizeOptions$Map = emptyMethod;
    $MAP_99 = createValueOfMap(($clinit_SizeOptions(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_SizeOptions_2_classLit, 1), $intern_36, 264, 0, [
        DEFAULT_MINIMUM_SIZE,
        MINIMUM_SIZE_ACCOUNTS_FOR_PADDING,
        COMPUTE_PADDING,
        OUTSIDE_NODE_LABELS_OVERHANG,
        PORTS_OVERHANG,
        UNIFORM_PORT_SPACING,
        SPACE_EFFICIENT_PORT_LABELS,
        FORCE_TABULAR_NODE_LABELS,
        ASYMMETRICAL
    ])));
}
var $MAP_99;
function $clinit_TopdownNodeTypes() {
    $clinit_TopdownNodeTypes = emptyMethod;
    PARALLEL_NODE = new TopdownNodeTypes('PARALLEL_NODE', 0);
    HIERARCHICAL_NODE = new TopdownNodeTypes('HIERARCHICAL_NODE', 1);
    ROOT_NODE_0 = new TopdownNodeTypes('ROOT_NODE', 2);
}
function TopdownNodeTypes(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_110(name_0) {
    $clinit_TopdownNodeTypes();
    return valueOf(($clinit_TopdownNodeTypes$Map(), $MAP_100), name_0);
}
function values_118() {
    $clinit_TopdownNodeTypes();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_TopdownNodeTypes_2_classLit, 1), $intern_36, 278, 0, [
        PARALLEL_NODE,
        HIERARCHICAL_NODE,
        ROOT_NODE_0
    ]);
}
defineClass(278, 23, {
    3: 1,
    34: 1,
    23: 1,
    278: 1
}, TopdownNodeTypes);
var HIERARCHICAL_NODE, PARALLEL_NODE, ROOT_NODE_0;
var Lorg_eclipse_elk_core_options_TopdownNodeTypes_2_classLit = createForEnum('org.eclipse.elk.core.options', 'TopdownNodeTypes', 278, Ljava_lang_Enum_2_classLit, values_118, valueOf_110);
function $clinit_TopdownNodeTypes$Map() {
    $clinit_TopdownNodeTypes$Map = emptyMethod;
    $MAP_100 = createValueOfMap(($clinit_TopdownNodeTypes(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_TopdownNodeTypes_2_classLit, 1), $intern_36, 278, 0, [
        PARALLEL_NODE,
        HIERARCHICAL_NODE,
        ROOT_NODE_0
    ])));
}
var $MAP_100;
function $clinit_TopdownSizeApproximator() {
    $clinit_TopdownSizeApproximator = emptyMethod;
    COUNT_CHILDREN = new TopdownSizeApproximator$1;
    LOOKAHEAD_LAYOUT = new TopdownSizeApproximator$2;
}
function TopdownSizeApproximator(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_111(name_0) {
    $clinit_TopdownSizeApproximator();
    return valueOf(($clinit_TopdownSizeApproximator$Map(), $MAP_101), name_0);
}
function values_119() {
    $clinit_TopdownSizeApproximator();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_TopdownSizeApproximator_2_classLit, 1), $intern_36, 343, 0, [
        COUNT_CHILDREN,
        LOOKAHEAD_LAYOUT
    ]);
}
defineClass(343, 23, $intern_135);
var COUNT_CHILDREN, LOOKAHEAD_LAYOUT;
var Lorg_eclipse_elk_core_options_TopdownSizeApproximator_2_classLit = createForEnum('org.eclipse.elk.core.options', 'TopdownSizeApproximator', 343, Ljava_lang_Enum_2_classLit, values_119, valueOf_111);
function $getSize(node) {
    var size_0;
    size_0 = $doubleValue(castToDouble($getProperty_0(node, ($clinit_CoreOptions(), TOPDOWN_HIERARCHICAL_NODE_WIDTH_2)))) * $wnd.Math.sqrt((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children).size_0);
    return new KVector_1(size_0, size_0 / $doubleValue(castToDouble($getProperty_0(node, TOPDOWN_HIERARCHICAL_NODE_ASPECT_RATIO_2))));
}
function TopdownSizeApproximator$1() {
    TopdownSizeApproximator.call(this, 'COUNT_CHILDREN', 0);
}
defineClass(964, 343, $intern_135, TopdownSizeApproximator$1);
_.getSize_0 = function getSize_1(node) {
    return $getSize(node);
};
var Lorg_eclipse_elk_core_options_TopdownSizeApproximator$1_2_classLit = createForEnum('org.eclipse.elk.core.options', 'TopdownSizeApproximator/1', 964, Lorg_eclipse_elk_core_options_TopdownSizeApproximator_2_classLit, null, null);
function TopdownSizeApproximator$2() {
    TopdownSizeApproximator.call(this, 'LOOKAHEAD_LAYOUT', 1);
}
defineClass(965, 343, $intern_135, TopdownSizeApproximator$2);
_.getSize_0 = function getSize_2(originalGraph) {
    var algorithmData, baseSize, child, child$iterator, child$iterator0, childAreaDesiredAspectRatio, childAreaDesiredHeight, childAreaDesiredWidth, edge, edge$iterator, elkEdge, elkNode, elkNode0, exception, layoutProvider, minHeight, minWidth, newChild, newEdge, newSrc, newTar, node, oldToNewNodeMap, padding, size_0;
    algorithmData = castTo($getProperty_0(originalGraph, ($clinit_CoreOptions(), RESOLVED_ALGORITHM)), 149);
    node = ($clinit_ElkGraphFactory(), elkNode0 = new ElkNodeImpl, elkNode0);
    $copyProperties_0(node, originalGraph);
    oldToNewNodeMap = new HashMap;
    for(child$iterator0 = new AbstractEList$EIterator((!originalGraph.children && (originalGraph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, originalGraph, 10, 11)), originalGraph.children)); child$iterator0.cursor != child$iterator0.this$01_2.size_1();){
        child = castTo($doNext(child$iterator0), 27);
        newChild = (elkNode = new ElkNodeImpl, elkNode);
        $setParent_2(newChild, node);
        $copyProperties_0(newChild, child);
        size_0 = $getSize(child);
        $setDimensions(newChild, $wnd.Math.max(child.width_0, size_0.x_0), $wnd.Math.max(child.height, size_0.y_0));
        $put_9(oldToNewNodeMap.hashCodeMap, child, newChild);
    }
    for(child$iterator = new AbstractEList$EIterator((!originalGraph.children && (originalGraph.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, originalGraph, 10, 11)), originalGraph.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
        child = castTo($doNext(child$iterator), 27);
        for(edge$iterator = new AbstractEList$EIterator((!child.outgoingEdges && (child.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, child, 7, 4)), child.outgoingEdges)); edge$iterator.cursor != edge$iterator.this$01_2.size_1();){
            edge = castTo($doNext(edge$iterator), 85);
            newSrc = castTo(getEntryValueOrNull($getEntry_0(oldToNewNodeMap.hashCodeMap, child)), 27);
            newTar = castTo($get_10(oldToNewNodeMap, $get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0)), 27);
            newEdge = (elkEdge = new ElkEdgeImpl, elkEdge);
            $add_21((!newEdge.sources && (newEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, newEdge, 4, 7)), newEdge.sources), newSrc);
            $add_21((!newEdge.targets && (newEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, newEdge, 5, 8)), newEdge.targets), newTar);
            $setContainingNode(newEdge, $getParent_2(newSrc));
            $copyProperties_0(newEdge, edge);
        }
    }
    layoutProvider = castTo($fetch(algorithmData.providerPool), 222);
    try {
        layoutProvider.layout(node, new NullElkProgressMonitor);
        $release(algorithmData.providerPool, layoutProvider);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            exception = $e0;
            throw toJs(exception);
        } else throw toJs($e0);
    }
    $hasProperty_0(node, CHILD_AREA_WIDTH) || $hasProperty_0(node, CHILD_AREA_HEIGHT) || computeChildAreaDimensions(node);
    childAreaDesiredWidth = $doubleValue(castToDouble($getProperty_0(node, CHILD_AREA_WIDTH)));
    childAreaDesiredHeight = $doubleValue(castToDouble($getProperty_0(node, CHILD_AREA_HEIGHT)));
    childAreaDesiredAspectRatio = childAreaDesiredWidth / childAreaDesiredHeight;
    baseSize = $doubleValue(castToDouble($getProperty_0(node, TOPDOWN_HIERARCHICAL_NODE_WIDTH_2))) * $wnd.Math.sqrt((!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children).size_0);
    padding = castTo($getProperty_0(node, PADDING_5), 107);
    minWidth = padding.left + padding.right + 1;
    minHeight = padding.top_0 + padding.bottom + 1;
    return new KVector_1($wnd.Math.max(minWidth, baseSize), $wnd.Math.max(minHeight, baseSize / childAreaDesiredAspectRatio));
};
var Lorg_eclipse_elk_core_options_TopdownSizeApproximator$2_2_classLit = createForEnum('org.eclipse.elk.core.options', 'TopdownSizeApproximator/2', 965, Lorg_eclipse_elk_core_options_TopdownSizeApproximator_2_classLit, null, null);
function $clinit_TopdownSizeApproximator$Map() {
    $clinit_TopdownSizeApproximator$Map = emptyMethod;
    $MAP_101 = createValueOfMap(($clinit_TopdownSizeApproximator(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_options_TopdownSizeApproximator_2_classLit, 1), $intern_36, 343, 0, [
        COUNT_CHILDREN,
        LOOKAHEAD_LAYOUT
    ])));
}
var $MAP_101;
function $begin(this$static, name_0, thetotalWork) {
    if (this$static.closed_0) throw toJs(new IllegalStateException_0('The task is already done.'));
    else if (this$static.taskName != null) return false;
    else {
        this$static.taskName = name_0;
        this$static.totalWork = thetotalWork;
        this$static.recordExecutionTime && (this$static.startTime = ($clinit_System(), mul_0(fromDouble_0(Date.now()), $intern_45)));
        return true;
    }
}
function $doSubTask(this$static, maxHierarchyLevels) {
    var newMaxHierarchyLevels;
    newMaxHierarchyLevels = maxHierarchyLevels > 0 ? maxHierarchyLevels - 1 : maxHierarchyLevels;
    return $withExecutionTimeMeasurement($withLogPersistence($withLogging($withMaxHierarchyLevels(new BasicProgressMonitor, newMaxHierarchyLevels), this$static.recordLogs), this$static.persistLogs), this$static.recordExecutionTime);
}
function $done_0(this$static) {
    var endTime;
    if (this$static.taskName == null) throw toJs(new IllegalStateException_0('The task has not begun yet.'));
    if (!this$static.closed_0) {
        if (this$static.recordExecutionTime) {
            endTime = ($clinit_System(), mul_0(fromDouble_0(Date.now()), $intern_45));
            this$static.totalTime = toDouble_0(sub_2(endTime, this$static.startTime)) * 1.0E-9;
        }
        this$static.completedWork < this$static.totalWork && $internalWorked(this$static, this$static.totalWork - this$static.completedWork);
        this$static.closed_0 = true;
    }
}
function $internalWorked(this$static, work) {
    if (this$static.totalWork > 0 && this$static.completedWork < this$static.totalWork) {
        this$static.completedWork += work;
        !!this$static.parentMonitor && this$static.parentMonitor.currentChildWork > 0 && this$static.maxLevels != 0 && $internalWorked(this$static.parentMonitor, work / this$static.totalWork * this$static.parentMonitor.currentChildWork);
    }
}
function $logGraph(this$static, object, graphType) {
    var loggedGraph;
    if (this$static.recordLogs && !!object && !!graphType) {
        loggedGraph = new LoggedGraph;
        $add_3(this$static.logGraphs, loggedGraph);
    }
}
function $withExecutionTimeMeasurement(this$static, enabled) {
    this$static.recordExecutionTime = enabled;
    return this$static;
}
function $withLogPersistence(this$static, enabled) {
    this$static.persistLogs = enabled;
    return this$static;
}
function $withLogging(this$static, enabled) {
    this$static.recordLogs = enabled;
    if (this$static.recordLogs) {
        this$static.logMessages = new ArrayList;
        this$static.logGraphs = new ArrayList;
    } else {
        this$static.logMessages = null;
        this$static.logGraphs = null;
    }
    return this$static;
}
function $withMaxHierarchyLevels(this$static, levels) {
    levels < 0 ? this$static.maxLevels = -1 : this$static.maxLevels = levels;
    return this$static;
}
function BasicProgressMonitor() {
    this.children = new LinkedList;
}
defineClass(340, 1, {
    847: 1
}, BasicProgressMonitor);
_.begin = function begin_0(name_0, thetotalWork) {
    return $begin(this, name_0, thetotalWork);
};
_.done_1 = function done() {
    $done_0(this);
};
_.getExecutionTime = function getExecutionTime() {
    return this.totalTime;
};
_.getLogs = function getLogs() {
    return !this.logMessages ? null : unmodifiableList(this.logMessages);
};
_.getSubMonitors = function getSubMonitors() {
    return unmodifiableList(this.children);
};
_.getTaskName = function getTaskName() {
    return this.taskName;
};
_.isCanceled = function isCanceled() {
    return false;
};
_.isLoggingEnabled = function isLoggingEnabled() {
    return this.recordLogs;
};
_.isRunning = function isRunning() {
    return this.taskName != null && !this.closed_0;
};
_.log_0 = function log_0(object) {
    var logMessage;
    if (this.recordLogs) {
        logMessage = object;
        $add_3(this.logMessages, logMessage);
    }
};
_.logGraph = function logGraph(graph, tag) {
    var copier, result;
    this.recordLogs && !!graph && $logGraph(this, (copier = new EcoreUtil$Copier, result = $copy_1(copier, graph), $copyReferences(copier), result), ($clinit_LoggedGraph$Type(), ELK));
};
_.subTask = function subTask(work) {
    var subMonitor;
    if (this.closed_0) return null;
    else {
        subMonitor = $doSubTask(this, this.maxLevels);
        $add_7(this.children, subMonitor);
        subMonitor.parentMonitor = this;
        this.currentChildWork = work;
        return subMonitor;
    }
};
_.worked = function worked(work) {
    work > 0 && !this.closed_0 && $internalWorked(this, work);
};
_.closed_0 = false;
_.completedWork = 0;
_.currentChildWork = -1;
_.logGraphs = null;
_.logMessages = null;
_.maxLevels = -1;
_.persistLogs = false;
_.recordExecutionTime = false;
_.recordLogs = false;
_.startTime = 0;
_.totalTime = 0;
_.totalWork = 0;
var Lorg_eclipse_elk_core_util_BasicProgressMonitor_2_classLit = createForClass('org.eclipse.elk.core.util', 'BasicProgressMonitor', 340);
function $areaStdDev(boxes, mean) {
    var box, box$iterator, stddev, variance;
    variance = 0;
    for(box$iterator = new ArrayList$1(boxes); box$iterator.i < box$iterator.this$01.array.length;){
        box = castTo($next_6(box$iterator), 27);
        variance += $wnd.Math.pow(box.width_0 * box.height - mean, 2);
    }
    stddev = $wnd.Math.sqrt(variance / (boxes.array.length - 1));
    return stddev;
}
function $areaStdDev2(boxes, mean) {
    var box, box$iterator, stddev, variance;
    variance = 0;
    for(box$iterator = new ArrayList$1(boxes); box$iterator.i < box$iterator.this$01.array.length;){
        box = castTo($next_6(box$iterator), 162);
        variance += $wnd.Math.pow($getWidth(box) * $getHeight(box) - mean, 2);
    }
    stddev = $wnd.Math.sqrt(variance / (boxes.array.length - 1));
    return stddev;
}
function $layout_4(layoutNode, progressMonitor) {
    var expandNodes, interactive, objSpacing, padding, sortedBoxes, minSize, aspectRatio, parentSize, sortedBoxes_0;
    progressMonitor.begin('Box layout', 2);
    objSpacing = $floatValue(castToDouble($getProperty_0(layoutNode, ($clinit_BoxLayouterOptions(), SPACING_NODE_NODE_5))));
    padding = castTo($getProperty_0(layoutNode, PADDING_4), 107);
    expandNodes = $booleanValue(castToBoolean($getProperty_0(layoutNode, EXPAND_NODES)));
    interactive = $booleanValue(castToBoolean($getProperty_0(layoutNode, INTERACTIVE_7)));
    switch(castTo($getProperty_0(layoutNode, BOX_PACKING_MODE), 321).ordinal){
        case 0:
            sortedBoxes = (sortedBoxes_0 = new ArrayList_1((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)), $clinit_Collections(), $sort(sortedBoxes_0, new BoxLayoutProvider$1(interactive)), sortedBoxes_0);
            minSize = effectiveMinSizeConstraintFor(layoutNode);
            aspectRatio = castToDouble($getProperty_0(layoutNode, ASPECT_RATIO_3));
            (aspectRatio == null || (checkCriticalNotNull(aspectRatio), aspectRatio) <= 0) && (aspectRatio = 1.3);
            parentSize = $placeBoxes(sortedBoxes, objSpacing, padding, minSize.x_0, minSize.y_0, expandNodes, (checkCriticalNotNull(aspectRatio), aspectRatio));
            resizeNode_1(layoutNode, parentSize.x_0, parentSize.y_0, false, true);
            break;
        default:
            $placeBoxesGrouping(layoutNode, objSpacing, padding, expandNodes);
    }
    progressMonitor.done_1();
}
function $mergeAndPlaceDec(groups, objSpacing, minWidth, minHeight, expandNodes) {
    var box, boxQueue, boxToBeat, collectedArea, groupSize, innerAspectRatio, innerGroup, maybeGroup, toBePlaced;
    $clinit_Collections();
    $sort(groups, new BoxLayoutProvider$lambda$0$Type);
    boxQueue = newLinkedList(groups);
    toBePlaced = new ArrayList;
    maybeGroup = new ArrayList;
    boxToBeat = null;
    collectedArea = 0;
    while(boxQueue.size_0 != 0){
        box = castTo(boxQueue.size_0 == 0 ? null : (checkCriticalElement(boxQueue.size_0 != 0), $removeNode_0(boxQueue, boxQueue.header.next_0)), 162);
        if (!boxToBeat || $getWidth(boxToBeat) * $getHeight(boxToBeat) / 2 < $getWidth(box) * $getHeight(box)) {
            boxToBeat = box;
            push_1(toBePlaced.array, box);
        } else {
            collectedArea += $getWidth(box) * $getHeight(box);
            push_1(maybeGroup.array, box);
            if (maybeGroup.array.length > 1 && (collectedArea > $getWidth(boxToBeat) * $getHeight(boxToBeat) / 2 || boxQueue.size_0 == 0)) {
                innerGroup = new BoxLayoutProvider$Group(maybeGroup);
                innerAspectRatio = $getWidth(boxToBeat) / $getHeight(boxToBeat);
                groupSize = $placeInnerBoxes(innerGroup, objSpacing, new ElkPadding, minWidth, minHeight, expandNodes, innerAspectRatio);
                $add_19($reset_5(innerGroup.size_0), groupSize);
                boxToBeat = innerGroup;
                push_1(toBePlaced.array, innerGroup);
                collectedArea = 0;
                maybeGroup.array.length = 0;
            }
        }
    }
    $addAll_2(toBePlaced, maybeGroup);
    return toBePlaced;
}
function $mergeAndPlaceInc(groups, objSpacing, minWidth, minHeight, expandNodes) {
    var commonArea, g, groupIterator, groupSize, innerAspectRatio, merged, toBePlaced;
    $clinit_Collections();
    $sort(groups, new BoxLayoutProvider$lambda$2$Type);
    groupIterator = new AbstractList$ListIteratorImpl(groups, 0);
    toBePlaced = new ArrayList;
    commonArea = 0;
    while(groupIterator.i < groupIterator.this$01_0.size_1()){
        g = (checkCriticalElement(groupIterator.i < groupIterator.this$01_0.size_1()), castTo(groupIterator.this$01_0.get_0(groupIterator.last = groupIterator.i++), 162));
        if (toBePlaced.array.length != 0 && $getWidth(g) * $getHeight(g) > commonArea * 2) {
            merged = new BoxLayoutProvider$Group(toBePlaced);
            innerAspectRatio = $getWidth(g) / $getHeight(g);
            groupSize = $placeInnerBoxes(merged, objSpacing, new ElkPadding, minWidth, minHeight, expandNodes, innerAspectRatio);
            $add_19($reset_5(merged.size_0), groupSize);
            toBePlaced.array.length = 0;
            commonArea = 0;
            push_1(toBePlaced.array, merged);
            push_1(toBePlaced.array, g);
            commonArea = $getWidth(merged) * $getHeight(merged) + $getWidth(g) * $getHeight(g);
        } else {
            push_1(toBePlaced.array, g);
            commonArea += $getWidth(g) * $getHeight(g);
        }
    }
    return toBePlaced;
}
function $mergeAndPlaceMixed(groups, objSpacing, minWidth, minHeight, expandNodes) {
    var anIndex, box, cumAreaArray, groupSize, index_0, innerAspectRatio, innerGroup, pq, remain, select, toBePlaced, value_0;
    cumAreaArray = initUnidimensionalArray(D_classLit, $intern_66, 30, groups.array.length, 15, 1);
    pq = new PriorityQueue(new BoxLayoutProvider$lambda$1$Type);
    $addAll_4(pq, groups);
    index_0 = 0;
    toBePlaced = new ArrayList;
    while(pq.heap.array.length != 0){
        box = castTo(pq.heap.array.length == 0 ? null : $get_11(pq.heap, 0), 162);
        if (index_0 > 1 && $getWidth(box) * $getHeight(box) / 2 > cumAreaArray[0]) {
            anIndex = 0;
            while(anIndex < toBePlaced.array.length - 1 && $getWidth(box) * $getHeight(box) / 2 > cumAreaArray[anIndex])++anIndex;
            select = new AbstractList$SubList(toBePlaced, 0, anIndex + 1);
            innerGroup = new BoxLayoutProvider$Group(select);
            innerAspectRatio = $getWidth(box) / $getHeight(box);
            groupSize = $placeInnerBoxes(innerGroup, objSpacing, new ElkPadding, minWidth, minHeight, expandNodes, innerAspectRatio);
            $add_19($reset_5(innerGroup.size_0), groupSize);
            checkCriticalState_0($offer(pq, innerGroup), 'Unable to add element to queue');
            remain = new AbstractList$SubList(toBePlaced, anIndex + 1, toBePlaced.array.length);
            $addAll_4(pq, remain);
            toBePlaced.array.length = 0;
            index_0 = 0;
            fill0_0(cumAreaArray, cumAreaArray.length, 0);
        } else {
            value_0 = pq.heap.array.length == 0 ? null : $get_11(pq.heap, 0);
            value_0 != null && $removeAtIndex_0(pq, 0);
            index_0 > 0 && (cumAreaArray[index_0] = cumAreaArray[index_0 - 1]);
            cumAreaArray[index_0] += $getWidth(box) * $getHeight(box);
            ++index_0;
            push_1(toBePlaced.array, box);
        }
    }
    return toBePlaced;
}
function $placeBoxes(sortedBoxes, minSpacing, padding, minTotalWidth, minTotalHeight, expandNodes, aspectRatio) {
    var box, box$iterator, boxIter, broadestRow, height, highestBox, maxRowWidth, mean, newHeight, newWidth, nextRowIndex, oldHeight, oldWidth, rowHeight, rowHeightIter, rowHeights, rowIndexIter, rowIndices, stddev, totalArea, totalHeight, width_0, xpos, ypos;
    maxRowWidth = 0;
    totalArea = 0;
    for(box$iterator = new ArrayList$1(sortedBoxes); box$iterator.i < box$iterator.this$01.array.length;){
        box = castTo($next_6(box$iterator), 27);
        resizeNode_0(box);
        maxRowWidth = $wnd.Math.max(maxRowWidth, box.width_0);
        totalArea += box.width_0 * box.height;
    }
    mean = totalArea / sortedBoxes.array.length;
    stddev = $areaStdDev(sortedBoxes, mean);
    totalArea += sortedBoxes.array.length * stddev;
    maxRowWidth = $wnd.Math.max(maxRowWidth, $wnd.Math.sqrt(totalArea * aspectRatio)) + padding.left;
    xpos = padding.left;
    ypos = padding.top_0;
    highestBox = 0;
    broadestRow = padding.left + padding.right;
    rowIndices = new LinkedList;
    $add_7(rowIndices, valueOf_3(0));
    rowHeights = new LinkedList;
    boxIter = new AbstractList$ListIteratorImpl(sortedBoxes, 0);
    while(boxIter.i < boxIter.this$01_0.size_1()){
        box = (checkCriticalElement(boxIter.i < boxIter.this$01_0.size_1()), castTo(boxIter.this$01_0.get_0(boxIter.last = boxIter.i++), 27));
        width_0 = box.width_0;
        height = box.height;
        if (xpos + width_0 > maxRowWidth) {
            if (expandNodes) {
                $addLast_0(rowHeights, highestBox);
                $addLast_0(rowIndices, valueOf_3(boxIter.i - 1));
            }
            xpos = padding.left;
            ypos += highestBox + minSpacing;
            highestBox = 0;
            broadestRow = $wnd.Math.max(broadestRow, padding.left + padding.right + width_0);
        }
        $setX_1(box, xpos);
        $setY_2(box, ypos);
        broadestRow = $wnd.Math.max(broadestRow, xpos + width_0 + padding.right);
        highestBox = $wnd.Math.max(highestBox, height);
        xpos += width_0 + minSpacing;
    }
    broadestRow = $wnd.Math.max(broadestRow, minTotalWidth);
    totalHeight = ypos + highestBox + padding.bottom;
    if (totalHeight < minTotalHeight) {
        highestBox += minTotalHeight - totalHeight;
        totalHeight = minTotalHeight;
    }
    if (expandNodes) {
        xpos = padding.left;
        boxIter = new AbstractList$ListIteratorImpl(sortedBoxes, 0);
        $addLast_0(rowIndices, valueOf_3(sortedBoxes.array.length));
        rowIndexIter = $listIterator_2(rowIndices, 0);
        nextRowIndex = castTo($next_9(rowIndexIter), 17).value_0;
        $addLast_0(rowHeights, highestBox);
        rowHeightIter = $listIterator_2(rowHeights, 0);
        rowHeight = 0;
        while(boxIter.i < boxIter.this$01_0.size_1()){
            if (boxIter.i == nextRowIndex) {
                xpos = padding.left;
                rowHeight = $doubleValue(castToDouble($next_9(rowHeightIter)));
                nextRowIndex = castTo($next_9(rowIndexIter), 17).value_0;
            }
            box = (checkCriticalElement(boxIter.i < boxIter.this$01_0.size_1()), castTo(boxIter.this$01_0.get_0(boxIter.last = boxIter.i++), 27));
            oldHeight = box.height;
            $setHeight_0(box, rowHeight);
            newHeight = rowHeight;
            if (boxIter.i == nextRowIndex) {
                newWidth = broadestRow - xpos - padding.right;
                oldWidth = box.width_0;
                $setWidth_0(box, newWidth);
                translate_1(box, new KVector_1(newWidth, newHeight), new KVector_1(oldWidth, oldHeight));
            }
            xpos += box.width_0 + minSpacing;
        }
    }
    return new KVector_1(broadestRow, totalHeight);
}
function $placeBoxesGrouping(parentNode, objSpacing, padding, expandNodes) {
    var aspectRatio, finalGroup, g, groups, lastArg, lastArg0, lastArg1, minSize, mode, node, node$iterator, parentSize, toBePlaced;
    minSize = new KVector_2(castTo($getProperty_0(parentNode, ($clinit_BoxLayouterOptions(), NODE_SIZE_MINIMUM_4)), 8));
    minSize.x_0 = $wnd.Math.max(minSize.x_0 - padding.left - padding.right, 0);
    minSize.y_0 = $wnd.Math.max(minSize.y_0 - padding.top_0 - padding.bottom, 0);
    aspectRatio = castToDouble($getProperty_0(parentNode, ASPECT_RATIO_3));
    (aspectRatio == null || (checkCriticalNotNull(aspectRatio), aspectRatio) <= 0) && (aspectRatio = 1.3);
    groups = new ArrayList;
    for(node$iterator = new AbstractEList$EIterator((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children)); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        g = new BoxLayoutProvider$Group_0(node);
        push_1(groups.array, g);
    }
    mode = castTo($getProperty_0(parentNode, BOX_PACKING_MODE), 321);
    switch(mode.ordinal){
        case 3:
            toBePlaced = $mergeAndPlaceInc(groups, objSpacing, minSize.x_0, minSize.y_0, (lastArg0 = expandNodes, checkCriticalNotNull(aspectRatio), aspectRatio, lastArg0));
            break;
        case 1:
            toBePlaced = $mergeAndPlaceDec(groups, objSpacing, minSize.x_0, minSize.y_0, (lastArg1 = expandNodes, checkCriticalNotNull(aspectRatio), aspectRatio, lastArg1));
            break;
        default:
            toBePlaced = $mergeAndPlaceMixed(groups, objSpacing, minSize.x_0, minSize.y_0, (lastArg = expandNodes, checkCriticalNotNull(aspectRatio), aspectRatio, lastArg));
    }
    finalGroup = new BoxLayoutProvider$Group(toBePlaced);
    parentSize = $placeInnerBoxes(finalGroup, objSpacing, padding, minSize.x_0, minSize.y_0, expandNodes, (checkCriticalNotNull(aspectRatio), aspectRatio));
    resizeNode_1(parentNode, parentSize.x_0, parentSize.y_0, false, true);
}
function $placeInnerBoxes(group, minSpacing, padding, minTotalWidth, minTotalHeight, expandNodes, aspectRatio) {
    var bottoms, box, box$iterator, boxIter, broadestRow, height, highestBox, last, maxRowWidth, mean, newWidth, nextRowIndex, oldWidth, rowHeight, rowHeightIter, rowHeights, rowIndexIter, rowIndices, stddev, totalArea, totalHeight, width_0, xpos, ypos;
    maxRowWidth = 0;
    totalArea = 0;
    for(box$iterator = new ArrayList$1(group.groups); box$iterator.i < box$iterator.this$01.array.length;){
        box = castTo($next_6(box$iterator), 162);
        !!box.node && resizeNode_0(box.node);
        maxRowWidth = $wnd.Math.max(maxRowWidth, $getWidth(box));
        totalArea += $getWidth(box) * $getHeight(box);
    }
    mean = totalArea / group.groups.array.length;
    stddev = $areaStdDev2(group.groups, mean);
    totalArea += group.groups.array.length * stddev;
    maxRowWidth = $wnd.Math.max(maxRowWidth, $wnd.Math.sqrt(totalArea * aspectRatio)) + padding.left;
    xpos = padding.left;
    ypos = padding.top_0;
    highestBox = 0;
    broadestRow = padding.left + padding.right;
    rowIndices = new LinkedList;
    $add_7(rowIndices, valueOf_3(0));
    rowHeights = new LinkedList;
    boxIter = new AbstractList$ListIteratorImpl(group.groups, 0);
    last = null;
    bottoms = new ArrayList;
    while(boxIter.i < boxIter.this$01_0.size_1()){
        box = (checkCriticalElement(boxIter.i < boxIter.this$01_0.size_1()), castTo(boxIter.this$01_0.get_0(boxIter.last = boxIter.i++), 162));
        width_0 = $getWidth(box);
        height = $getHeight(box);
        if (xpos + width_0 > maxRowWidth) {
            if (expandNodes) {
                $addLast_0(rowHeights, highestBox);
                $addLast_0(rowIndices, valueOf_3(boxIter.i - 1));
                $add_3(group.right, last);
                bottoms.array.length = 0;
            }
            xpos = padding.left;
            ypos += highestBox + minSpacing;
            highestBox = 0;
            broadestRow = $wnd.Math.max(broadestRow, padding.left + padding.right + width_0);
        }
        push_1(bottoms.array, box);
        $translate_1(box, xpos, ypos);
        broadestRow = $wnd.Math.max(broadestRow, xpos + width_0 + padding.right);
        highestBox = $wnd.Math.max(highestBox, height);
        xpos += width_0 + minSpacing;
        last = box;
    }
    $addAll_2(group.bottom, bottoms);
    $add_3(group.right, castTo($get_11(bottoms, bottoms.array.length - 1), 162));
    broadestRow = $wnd.Math.max(broadestRow, minTotalWidth);
    totalHeight = ypos + highestBox + padding.bottom;
    if (totalHeight < minTotalHeight) {
        highestBox += minTotalHeight - totalHeight;
        totalHeight = minTotalHeight;
    }
    if (expandNodes) {
        xpos = padding.left;
        boxIter = new AbstractList$ListIteratorImpl(group.groups, 0);
        $addLast_0(rowIndices, valueOf_3(group.groups.array.length));
        rowIndexIter = $listIterator_2(rowIndices, 0);
        nextRowIndex = castTo($next_9(rowIndexIter), 17).value_0;
        $addLast_0(rowHeights, highestBox);
        rowHeightIter = $listIterator_2(rowHeights, 0);
        rowHeight = 0;
        while(boxIter.i < boxIter.this$01_0.size_1()){
            if (boxIter.i == nextRowIndex) {
                xpos = padding.left;
                rowHeight = $doubleValue(castToDouble($next_9(rowHeightIter)));
                nextRowIndex = castTo($next_9(rowIndexIter), 17).value_0;
            }
            box = (checkCriticalElement(boxIter.i < boxIter.this$01_0.size_1()), castTo(boxIter.this$01_0.get_0(boxIter.last = boxIter.i++), 162));
            $setHeight(box, rowHeight);
            if (boxIter.i == nextRowIndex) {
                newWidth = broadestRow - xpos - padding.right;
                oldWidth = $getWidth(box);
                $setWidth(box, newWidth);
                $translateInnerNodes(box, (newWidth - oldWidth) / 2, 0);
            }
            xpos += $getWidth(box) + minSpacing;
        }
    }
    return new KVector_1(broadestRow, totalHeight);
}
function BoxLayoutProvider() {}
function lambda$0_40(g1_0, g2_1) {
    return -compare_4($getWidth(g1_0) * $getHeight(g1_0), $getWidth(g2_1) * $getHeight(g2_1));
}
function lambda$1_21(g1_0, g2_1) {
    return compare_4($getWidth(g1_0) * $getHeight(g1_0), $getWidth(g2_1) * $getHeight(g2_1));
}
function lambda$2_13(g1_0, g2_1) {
    return compare_4($getWidth(g1_0) * $getHeight(g1_0), $getWidth(g2_1) * $getHeight(g2_1));
}
defineClass(701, 222, $intern_96, BoxLayoutProvider);
_.layout = function layout_7(layoutNode, progressMonitor) {
    $layout_4(layoutNode, progressMonitor);
};
var Lorg_eclipse_elk_core_util_BoxLayoutProvider_2_classLit = createForClass('org.eclipse.elk.core.util', 'BoxLayoutProvider', 701);
function $compare_22(this$static, child1, child2) {
    var c, prio1, prio2, size1, size2;
    prio1 = castTo($getProperty_0(child1, ($clinit_BoxLayouterOptions(), PRIORITY_2)), 17);
    !prio1 && (prio1 = valueOf_3(0));
    prio2 = castTo($getProperty_0(child2, PRIORITY_2), 17);
    !prio2 && (prio2 = valueOf_3(0));
    if (prio1.value_0 > prio2.value_0) return -1;
    else if (prio1.value_0 < prio2.value_0) return 1;
    else {
        if (this$static.val$interactive2) {
            c = compare_4(child1.y_0, child2.y_0);
            if (c != 0) return c;
            c = compare_4(child1.x_0, child2.x_0);
            if (c != 0) return c;
        }
        size1 = child1.width_0 * child1.height;
        size2 = child2.width_0 * child2.height;
        return compare_4(size1, size2);
    }
}
function BoxLayoutProvider$1(val$interactive) {
    this.val$interactive2 = val$interactive;
}
defineClass(960, 1, $intern_88, BoxLayoutProvider$1);
_.compare_1 = function compare_104(child1, child2) {
    return $compare_22(this, castTo(child1, 27), castTo(child2, 27));
};
_.equals_0 = function equals_196(other) {
    return this === other;
};
_.reversed = function reversed_96() {
    return new Comparators$ReversedComparator(this);
};
_.val$interactive2 = false;
var Lorg_eclipse_elk_core_util_BoxLayoutProvider$1_2_classLit = createForClass('org.eclipse.elk.core.util', 'BoxLayoutProvider/1', 960);
function $getHeight(this$static) {
    if (this$static.node) return this$static.node.height;
    return this$static.size_0.y_0;
}
function $getWidth(this$static) {
    if (this$static.node) return this$static.node.width_0;
    return this$static.size_0.x_0;
}
function $setHeight(this$static, h) {
    var delta, g, g$iterator;
    if (this$static.node) $setHeight_0(this$static.node, h);
    else {
        delta = h - $getHeight(this$static);
        for(g$iterator = new ArrayList$1(this$static.bottom); g$iterator.i < g$iterator.this$01.array.length;){
            g = castTo($next_6(g$iterator), 162);
            $setHeight(g, $getHeight(g) + delta);
        }
    }
}
function $setWidth(this$static, w) {
    var delta, g, g$iterator;
    if (this$static.node) $setWidth_0(this$static.node, w);
    else {
        delta = w - $getWidth(this$static);
        for(g$iterator = new ArrayList$1(this$static.right); g$iterator.i < g$iterator.this$01.array.length;){
            g = castTo($next_6(g$iterator), 162);
            $setWidth(g, $getWidth(g) + delta);
        }
    }
}
function $translate_1(this$static, x_0, y_0) {
    var g, g$iterator;
    if (this$static.node) {
        $setX_1(this$static.node, this$static.node.x_0 + x_0);
        $setY_2(this$static.node, this$static.node.y_0 + y_0);
    } else for(g$iterator = new ArrayList$1(this$static.groups); g$iterator.i < g$iterator.this$01.array.length;){
        g = castTo($next_6(g$iterator), 162);
        $translate_1(g, x_0, y_0);
    }
}
function $translateInnerNodes(this$static, x_0, y_0) {
    var g, g$iterator;
    if (this$static.node) translate_0(this$static.node, x_0, y_0);
    else for(g$iterator = new ArrayList$1(this$static.groups); g$iterator.i < g$iterator.this$01.array.length;){
        g = castTo($next_6(g$iterator), 162);
        $translateInnerNodes(g, x_0, y_0);
    }
}
function BoxLayoutProvider$Group(groups) {
    this.groups = (checkNotNull(groups), new ArrayList_1(groups));
    this.bottom = new ArrayList;
    this.right = new ArrayList;
    this.size_0 = new KVector;
}
function BoxLayoutProvider$Group_0(node) {
    this.node = node;
    $setX_1(node, 0);
    $setY_2(node, 0);
}
defineClass(162, 1, {
    162: 1
}, BoxLayoutProvider$Group, BoxLayoutProvider$Group_0);
_.toString_0 = function toString_115() {
    return this.node ? $toString_23(this.node) : $toString_2(this.groups);
};
var Lorg_eclipse_elk_core_util_BoxLayoutProvider$Group_2_classLit = createForClass('org.eclipse.elk.core.util', 'BoxLayoutProvider/Group', 162);
function $clinit_BoxLayoutProvider$PackingMode() {
    $clinit_BoxLayoutProvider$PackingMode = emptyMethod;
    SIMPLE_1 = new BoxLayoutProvider$PackingMode('SIMPLE', 0);
    GROUP_DEC = new BoxLayoutProvider$PackingMode('GROUP_DEC', 1);
    GROUP_MIXED = new BoxLayoutProvider$PackingMode('GROUP_MIXED', 2);
    GROUP_INC = new BoxLayoutProvider$PackingMode('GROUP_INC', 3);
}
function BoxLayoutProvider$PackingMode(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_112(name_0) {
    $clinit_BoxLayoutProvider$PackingMode();
    return valueOf(($clinit_BoxLayoutProvider$PackingMode$Map(), $MAP_102), name_0);
}
function values_120() {
    $clinit_BoxLayoutProvider$PackingMode();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_BoxLayoutProvider$PackingMode_2_classLit, 1), $intern_36, 321, 0, [
        SIMPLE_1,
        GROUP_DEC,
        GROUP_MIXED,
        GROUP_INC
    ]);
}
defineClass(321, 23, {
    3: 1,
    34: 1,
    23: 1,
    321: 1
}, BoxLayoutProvider$PackingMode);
var GROUP_DEC, GROUP_INC, GROUP_MIXED, SIMPLE_1;
var Lorg_eclipse_elk_core_util_BoxLayoutProvider$PackingMode_2_classLit = createForEnum('org.eclipse.elk.core.util', 'BoxLayoutProvider/PackingMode', 321, Ljava_lang_Enum_2_classLit, values_120, valueOf_112);
function $clinit_BoxLayoutProvider$PackingMode$Map() {
    $clinit_BoxLayoutProvider$PackingMode$Map = emptyMethod;
    $MAP_102 = createValueOfMap(($clinit_BoxLayoutProvider$PackingMode(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_BoxLayoutProvider$PackingMode_2_classLit, 1), $intern_36, 321, 0, [
        SIMPLE_1,
        GROUP_DEC,
        GROUP_MIXED,
        GROUP_INC
    ])));
}
var $MAP_102;
function BoxLayoutProvider$lambda$0$Type() {}
defineClass(961, 1, $intern_88, BoxLayoutProvider$lambda$0$Type);
_.compare_1 = function compare_105(arg0, arg1) {
    return lambda$0_40(castTo(arg0, 162), castTo(arg1, 162));
};
_.equals_0 = function equals_197(other) {
    return this === other;
};
_.reversed = function reversed_97() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_core_util_BoxLayoutProvider$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'BoxLayoutProvider/lambda$0$Type', 961);
function BoxLayoutProvider$lambda$1$Type() {}
defineClass(962, 1, $intern_88, BoxLayoutProvider$lambda$1$Type);
_.compare_1 = function compare_106(arg0, arg1) {
    return lambda$1_21(castTo(arg0, 162), castTo(arg1, 162));
};
_.equals_0 = function equals_198(other) {
    return this === other;
};
_.reversed = function reversed_98() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_core_util_BoxLayoutProvider$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'BoxLayoutProvider/lambda$1$Type', 962);
function BoxLayoutProvider$lambda$2$Type() {}
defineClass(963, 1, $intern_88, BoxLayoutProvider$lambda$2$Type);
_.compare_1 = function compare_107(arg0, arg1) {
    return lambda$2_13(castTo(arg0, 162), castTo(arg1, 162));
};
_.equals_0 = function equals_199(other) {
    return this === other;
};
_.reversed = function reversed_99() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_core_util_BoxLayoutProvider$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'BoxLayoutProvider/lambda$2$Type', 963);
function ElkSpacings$AbstractSpacingsBuilder$lambda$0$Type() {}
defineClass(1323, 1, {
    824: 1
}, ElkSpacings$AbstractSpacingsBuilder$lambda$0$Type);
_.accept_4 = function accept_143(arg0, arg1) {
    return $clinit_ElkSpacings$AbstractSpacingsBuilder(), !instanceOf(arg1, 173) || $accept_3(($clinit_LayoutConfigurator(), OPTION_TARGET_FILTER, castTo(arg0, 173)), arg1);
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$0$Type', 1323);
function ElkSpacings$AbstractSpacingsBuilder$lambda$1$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1324, 1, $intern_19, ElkSpacings$AbstractSpacingsBuilder$lambda$1$Type);
_.accept = function accept_144(arg0) {
    $lambda$1_2(this.$$outer_0, castTo(arg0, 144));
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$1$Type', 1324);
function ElkSpacings$AbstractSpacingsBuilder$lambda$2$Type() {}
defineClass(1325, 1, $intern_19, ElkSpacings$AbstractSpacingsBuilder$lambda$2$Type);
_.accept = function accept_145(arg0) {
    castTo(arg0, 102);
    $clinit_ElkSpacings$AbstractSpacingsBuilder();
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$2$Type', 1325);
function ElkSpacings$AbstractSpacingsBuilder$lambda$3$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(1329, 1, $intern_19, ElkSpacings$AbstractSpacingsBuilder$lambda$3$Type);
_.accept = function accept_146(arg0) {
    $lambda$3_0(this.$$outer_0, castTo(arg0, 102));
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$3$Type', 1329);
function ElkSpacings$AbstractSpacingsBuilder$lambda$4$Type($$outer_0, element_1) {
    this.$$outer_0 = $$outer_0;
    this.element_1 = element_1;
}
defineClass(1327, 1, $intern_39, ElkSpacings$AbstractSpacingsBuilder$lambda$4$Type);
_.test_0 = function test_119(arg0) {
    return $lambda$4_1(this.$$outer_0, this.element_1, castTo(arg0, 144));
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$4$Type', 1327);
function ElkSpacings$AbstractSpacingsBuilder$lambda$5$Type(element_0, p_1) {
    this.element_0 = element_0;
    this.p_1 = p_1;
}
defineClass(1326, 1, $intern_39, ElkSpacings$AbstractSpacingsBuilder$lambda$5$Type);
_.test_0 = function test_120(arg0) {
    return lambda$5_2(this.element_0, this.p_1, castTo(arg0, 824));
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$5$Type', 1326);
function ElkSpacings$AbstractSpacingsBuilder$lambda$6$Type($$outer_0, element_1) {
    this.$$outer_0 = $$outer_0;
    this.element_1 = element_1;
}
defineClass(1328, 1, $intern_19, ElkSpacings$AbstractSpacingsBuilder$lambda$6$Type);
_.accept = function accept_147(arg0) {
    $lambda$6(this.$$outer_0, this.element_1, castTo(arg0, 144));
};
var Lorg_eclipse_elk_core_util_ElkSpacings$AbstractSpacingsBuilder$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkSpacings/AbstractSpacingsBuilder/lambda$6$Type', 1328);
function applyConfiguredNodeScaling(node) {
    var anchor, portLabels, scalingFactor, shape_0, shape$iterator;
    scalingFactor = $doubleValue(castToDouble($getProperty_0(node, ($clinit_CoreOptions(), SCALE_FACTOR))));
    if (scalingFactor == 1) return;
    $setDimensions(node, scalingFactor * node.width_0, scalingFactor * node.height);
    portLabels = concat_0(transform_1((!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports), new ElkUtil$lambda$0$Type));
    for(shape$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        (!node.labels && (node.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, node, 1, 7)), node.labels),
        (!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports),
        portLabels
    ]))); $hasNext_1(shape$iterator);){
        shape_0 = castTo($next_0(shape$iterator), 273);
        shape_0.setLocation(scalingFactor * shape_0.getX(), scalingFactor * shape_0.getY());
        shape_0.setDimensions(scalingFactor * shape_0.getWidth(), scalingFactor * shape_0.getHeight());
        anchor = castTo(shape_0.getProperty(PORT_ANCHOR_0), 8);
        if (anchor) {
            anchor.x_0 *= scalingFactor;
            anchor.y_0 *= scalingFactor;
        }
    }
}
function applyVectorChain(vectorChain, section) {
    var bendpoint, elkBendPoint, firstPoint, lastPoint, newPointIter, nextPoint, oldPointIter;
    if (vectorChain.size_0 < 2) throw toJs(new IllegalArgumentException_0('The vector chain must contain at least a source and a target point.'));
    firstPoint = (checkCriticalElement(vectorChain.size_0 != 0), castTo(vectorChain.header.next_0.value_0, 8));
    $setStartLocation(section, firstPoint.x_0, firstPoint.y_0);
    oldPointIter = new AbstractEList$EListIterator((!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints));
    newPointIter = $listIterator_2(vectorChain, 1);
    while(newPointIter.currentIndex < vectorChain.size_0 - 1){
        nextPoint = castTo($next_9(newPointIter), 8);
        if (oldPointIter.cursor != oldPointIter.this$01_2.size_1()) bendpoint = castTo($doNext(oldPointIter), 369);
        else {
            bendpoint = ($clinit_ElkGraphFactory(), elkBendPoint = new ElkBendPointImpl, elkBendPoint);
            $doAdd_0(oldPointIter, bendpoint);
        }
        $set_8(bendpoint, nextPoint.x_0, nextPoint.y_0);
    }
    while(oldPointIter.cursor != oldPointIter.this$01_2.size_1()){
        $doNext(oldPointIter);
        $remove_36(oldPointIter);
    }
    lastPoint = (checkCriticalElement(vectorChain.size_0 != 0), castTo(vectorChain.tail.prev.value_0, 8));
    $setEndLocation(section, lastPoint.x_0, lastPoint.y_0);
}
function applyVisitors(graph, visitors) {
    var allElements, graphElement, i, nextElement;
    allElements = new ElkGraphUtil$PropertiesSkippingTreeIterator(graph);
    while(allElements.data_0 == null && !allElements.includeRoot ? $hasAnyChildren(allElements) : allElements.data_0 == null || allElements.size_0 != 0 && castTo(allElements.data_0[allElements.size_0 - 1], 49).hasNext_0()){
        nextElement = castTo($next_13(allElements), 57);
        if (instanceOf(nextElement, 173)) {
            graphElement = castTo(nextElement, 173);
            for(i = 0; i < visitors.length; i++)visitors[i].visit(graphElement);
        }
    }
}
function calcPortOffset_0(port, side) {
    var node;
    if (!$getParent_3(port)) throw toJs(new IllegalStateException_0('port must have a parent node to calculate the port side'));
    node = $getParent_3(port);
    switch(side.ordinal){
        case 1:
            return -(port.y_0 + port.height);
        case 2:
            return port.x_0 - node.width_0;
        case 3:
            return port.y_0 - node.height;
        case 4:
            return -(port.x_0 + port.width_0);
    }
    return 0;
}
function calcPortSide_0(port, direction) {
    var heightPercent, node, nodeHeight, nodeWidth, widthPercent, xpos, ypos;
    if (!$getParent_3(port)) throw toJs(new IllegalStateException_0('port must have a parent node to calculate the port side'));
    node = $getParent_3(port);
    nodeWidth = node.width_0;
    nodeHeight = node.height;
    if (nodeWidth <= 0 && nodeHeight <= 0) return $clinit_PortSide(), UNDEFINED_5;
    xpos = port.x_0;
    ypos = port.y_0;
    switch(direction.ordinal){
        case 2:
        case 1:
            if (xpos < 0) return $clinit_PortSide(), WEST_0;
            else if (xpos + port.width_0 > nodeWidth) return $clinit_PortSide(), EAST_0;
            break;
        case 4:
        case 3:
            if (ypos < 0) return $clinit_PortSide(), NORTH_1;
            else if (ypos + port.height > nodeHeight) return $clinit_PortSide(), SOUTH_0;
    }
    widthPercent = (xpos + port.width_0 / 2) / nodeWidth;
    heightPercent = (ypos + port.height / 2) / nodeHeight;
    return widthPercent + heightPercent <= 1 && widthPercent - heightPercent <= 0 ? ($clinit_PortSide(), WEST_0) : widthPercent + heightPercent >= 1 && widthPercent - heightPercent >= 0 ? ($clinit_PortSide(), EAST_0) : heightPercent < 0.5 ? ($clinit_PortSide(), NORTH_1) : ($clinit_PortSide(), SOUTH_0);
}
function computeChildAreaDimensions(node) {
    var bendpoint, bendpoint$iterator, eX, eY, edge, edge$iterator, edge$iterator0, edgeLabels, margins, maxX, maxY, minX, minY, sX, sY, section, section$iterator, shape_0, shape$iterator;
    minX = $intern_60;
    minY = $intern_60;
    maxX = 0;
    maxY = 0;
    edgeLabels = new ArrayList;
    for(edge$iterator0 = new AbstractEList$EIterator((!node.containedEdges && (node.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, node, 12, 3)), node.containedEdges)); edge$iterator0.cursor != edge$iterator0.this$01_2.size_1();){
        edge = castTo($doNext(edge$iterator0), 85);
        edgeLabels = concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
            edgeLabels,
            (!edge.labels && (edge.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, edge, 1, 7)), edge.labels)
        ]));
    }
    for(shape$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        (!node.labels && (node.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, node, 1, 7)), node.labels),
        (!node.children && (node.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, node, 10, 11)), node.children),
        edgeLabels
    ]))); $hasNext_1(shape$iterator);){
        shape_0 = castTo($next_0(shape$iterator), 273);
        margins = castTo(shape_0.getProperty(($clinit_CoreOptions(), MARGINS_0)), 139);
        minX > shape_0.getX() - margins.left && (minX = shape_0.getX() - margins.left);
        minY > shape_0.getY() - margins.top_0 && (minY = shape_0.getY() - margins.top_0);
        maxX < shape_0.getX() + shape_0.getWidth() + margins.right && (maxX = shape_0.getX() + shape_0.getWidth() + margins.right);
        maxY < shape_0.getY() + shape_0.getHeight() + margins.bottom && (maxY = shape_0.getY() + shape_0.getHeight() + margins.bottom);
    }
    for(edge$iterator = new AbstractEList$EIterator((!node.containedEdges && (node.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, node, 12, 3)), node.containedEdges)); edge$iterator.cursor != edge$iterator.this$01_2.size_1();){
        edge = castTo($doNext(edge$iterator), 85);
        for(section$iterator = new AbstractEList$EIterator((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections)); section$iterator.cursor != section$iterator.this$01_2.size_1();){
            section = castTo($doNext(section$iterator), 168);
            sX = section.startX;
            eX = section.endX;
            sY = section.startY;
            eY = section.endY;
            minX = $wnd.Math.min(minX, sX);
            minX = $wnd.Math.min(minX, eX);
            maxX = $wnd.Math.max(maxX, sX);
            maxX = $wnd.Math.max(maxX, eX);
            minY = $wnd.Math.min(minY, sY);
            minY = $wnd.Math.min(minY, eY);
            maxY = $wnd.Math.max(maxY, sY);
            maxY = $wnd.Math.max(maxY, eY);
            for(bendpoint$iterator = new AbstractEList$EIterator((!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints)); bendpoint$iterator.cursor != bendpoint$iterator.this$01_2.size_1();){
                bendpoint = castTo($doNext(bendpoint$iterator), 369);
                minX = $wnd.Math.min(minX, bendpoint.x_0);
                maxX = $wnd.Math.max(maxX, bendpoint.x_0);
                minY = $wnd.Math.min(minY, bendpoint.y_0);
                maxY = $wnd.Math.max(maxY, bendpoint.y_0);
            }
        }
    }
    $setProperty_1(node, ($clinit_CoreOptions(), CHILD_AREA_WIDTH), maxX - minX);
    $setProperty_1(node, CHILD_AREA_HEIGHT, maxY - minY);
}
function computeInsidePart(labelPosition, labelSize, portSize, portBorderOffset, portSide) {
    var insidePart;
    insidePart = 0;
    switch(portSide.ordinal){
        case 1:
            insidePart = $wnd.Math.max(0, labelSize.y_0 + labelPosition.y_0 - (portSize.y_0 + portBorderOffset));
            break;
        case 3:
            insidePart = $wnd.Math.max(0, -labelPosition.y_0 - portBorderOffset);
            break;
        case 2:
            insidePart = $wnd.Math.max(0, -labelPosition.x_0 - portBorderOffset);
            break;
        case 4:
            insidePart = $wnd.Math.max(0, labelSize.x_0 + labelPosition.x_0 - (portSize.x_0 + portBorderOffset));
    }
    return insidePart;
}
function computeInsidePart_0(port, portBorderOffset) {
    var labelBounds;
    labelBounds = getLabelsBounds(port);
    return computeInsidePart(new KVector_1(labelBounds.x_0, labelBounds.y_0), new KVector_1(labelBounds.width_0, labelBounds.height), port.getSize(), portBorderOffset, port.getSide());
}
function createVectorChain(edgeSection) {
    var bendPoint, bendPoint$iterator, chain;
    chain = new KVectorChain;
    $add_7(chain, new KVector_1(edgeSection.startX, edgeSection.startY));
    for(bendPoint$iterator = new AbstractEList$EIterator((!edgeSection.bendPoints && (edgeSection.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, edgeSection, 5)), edgeSection.bendPoints)); bendPoint$iterator.cursor != bendPoint$iterator.this$01_2.size_1();){
        bendPoint = castTo($doNext(bendPoint$iterator), 369);
        $add_7(chain, new KVector_1(bendPoint.x_0, bendPoint.y_0));
    }
    $add_7(chain, new KVector_1(edgeSection.endX, edgeSection.endY));
    return chain;
}
function determineJunctionPoints(edge) {
    var junctionPoints;
    if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 != 1) throw toJs(new IllegalArgumentException_0('The edge needs to have exactly one edge section. Found: ' + (!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0));
    junctionPoints = new KVectorChain;
    !!connectableShapeToPort(castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84)) && $addAll(junctionPoints, determineJunctionPoints_0(edge, connectableShapeToPort(castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84)), false));
    !!connectableShapeToPort(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84)) && $addAll(junctionPoints, determineJunctionPoints_0(edge, connectableShapeToPort(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84)), true));
    return junctionPoints;
}
function determineJunctionPoints_0(edge, port, reverse) {
    var allConnectedSections, allSectIter, dx2, dx3, dy2, dy3, i, junctionPoints, offset, offsetMap, otherEdge, otherEdge$iterator, otherPoints, otherSection, p1, p2, p3, pointsMap, section, sectionPoints;
    section = castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168);
    junctionPoints = new KVectorChain;
    pointsMap = new HashMap;
    sectionPoints = getPoints(section);
    $put_9(pointsMap.hashCodeMap, section, sectionPoints);
    offsetMap = new HashMap;
    allConnectedSections = new LinkedList;
    for(otherEdge$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        (!port.incomingEdges && (port.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, port, 8, 5)), port.incomingEdges),
        (!port.outgoingEdges && (port.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, port, 7, 4)), port.outgoingEdges)
    ]))); $hasNext_1(otherEdge$iterator);){
        otherEdge = castTo($next_0(otherEdge$iterator), 85);
        if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 != 1) throw toJs(new IllegalArgumentException_0('The edge needs to have exactly one edge section. Found: ' + (!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0));
        if (otherEdge != edge) {
            otherSection = castTo($get_20((!otherEdge.sections && (otherEdge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, otherEdge, 6, 6)), otherEdge.sections), 0), 168);
            $addNode_0(allConnectedSections, otherSection, allConnectedSections.tail.prev, allConnectedSections.tail);
            otherPoints = castTo(getEntryValueOrNull($getEntry_0(pointsMap.hashCodeMap, otherSection)), 13);
            if (!otherPoints) {
                otherPoints = getPoints(otherSection);
                $put_9(pointsMap.hashCodeMap, otherSection, otherPoints);
            }
            offset = reverse ? $sub_0(new KVector_2(castTo($get_11(sectionPoints, sectionPoints.array.length - 1), 8)), castTo($get_11(otherPoints, otherPoints.array.length - 1), 8)) : $sub_0(new KVector_2((checkCriticalElementIndex(0, sectionPoints.array.length), castTo(sectionPoints.array[0], 8))), (checkCriticalElementIndex(0, otherPoints.array.length), castTo(otherPoints.array[0], 8)));
            $put_9(offsetMap.hashCodeMap, otherSection, offset);
        }
    }
    if (allConnectedSections.size_0 != 0) {
        p1 = castTo($get_11(sectionPoints, reverse ? sectionPoints.array.length - 1 : 0), 8);
        for(i = 1; i < sectionPoints.array.length; i++){
            p2 = castTo($get_11(sectionPoints, reverse ? sectionPoints.array.length - 1 - i : i), 8);
            allSectIter = $listIterator_2(allConnectedSections, 0);
            while(allSectIter.currentNode != allSectIter.this$01.tail){
                otherSection = castTo($next_9(allSectIter), 168);
                otherPoints = castTo(getEntryValueOrNull($getEntry_0(pointsMap.hashCodeMap, otherSection)), 13);
                if (otherPoints.array.length <= i) $remove_24(allSectIter);
                else {
                    p3 = $add_19(new KVector_2(castTo($get_11(otherPoints, reverse ? otherPoints.array.length - 1 - i : i), 8)), castTo(getEntryValueOrNull($getEntry_0(offsetMap.hashCodeMap, otherSection)), 8));
                    if (p2.x_0 != p3.x_0 || p2.y_0 != p3.y_0) {
                        dx2 = p2.x_0 - p1.x_0;
                        dy2 = p2.y_0 - p1.y_0;
                        dx3 = p3.x_0 - p1.x_0;
                        dy3 = p3.y_0 - p1.y_0;
                        dx3 * dy2 == dy3 * dx2 && (dx2 == 0 || isNaN(dx2) ? dx2 : dx2 < 0 ? -1 : 1) == (dx3 == 0 || isNaN(dx3) ? dx3 : dx3 < 0 ? -1 : 1) && (dy2 == 0 || isNaN(dy2) ? dy2 : dy2 < 0 ? -1 : 1) == (dy3 == 0 || isNaN(dy3) ? dy3 : dy3 < 0 ? -1 : 1) ? ($wnd.Math.abs(dx2) < $wnd.Math.abs(dx3) || $wnd.Math.abs(dy2) < $wnd.Math.abs(dy3)) && $addNode_0(junctionPoints, p2, junctionPoints.tail.prev, junctionPoints.tail) : i > 1 && $addNode_0(junctionPoints, p1, junctionPoints.tail.prev, junctionPoints.tail);
                        $remove_24(allSectIter);
                    }
                }
            }
            p1 = p2;
        }
    }
    return junctionPoints;
}
function effectiveMinSizeConstraintFor(node) {
    var minSize, sizeConstraint, sizeOptions;
    sizeConstraint = castTo($getProperty_0(node, ($clinit_CoreOptions(), NODE_SIZE_CONSTRAINTS_6)), 22);
    if (sizeConstraint.contains(($clinit_SizeConstraint(), MINIMUM_SIZE))) {
        sizeOptions = castTo($getProperty_0(node, NODE_SIZE_OPTIONS_6), 22);
        minSize = new KVector_2(castTo($getProperty_0(node, NODE_SIZE_MINIMUM_5), 8));
        if (sizeOptions.contains(($clinit_SizeOptions(), DEFAULT_MINIMUM_SIZE))) {
            minSize.x_0 <= 0 && (minSize.x_0 = 20);
            minSize.y_0 <= 0 && (minSize.y_0 = 20);
        }
        return minSize;
    } else return new KVector;
}
function getLabelsBounds(port) {
    var bounds, currentLabelBounds, label_0, label$iterator;
    bounds = null;
    for(label$iterator = new ArrayList$1(port.getLabels()); label$iterator.i < label$iterator.this$01.array.length;){
        label_0 = castTo($next_6(label$iterator), 187);
        currentLabelBounds = new ElkRectangle_0(label_0.getPosition().x_0, label_0.getPosition().y_0, label_0.getSize().x_0, label_0.getSize().y_0);
        !bounds ? bounds = currentLabelBounds : $union(bounds, currentLabelBounds);
    }
    !bounds && (bounds = new ElkRectangle);
    return bounds;
}
function getPoints(section) {
    var i, n, p1, p2, p3, points;
    n = (!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints).size_0 + 2;
    points = new ArrayList_0(n);
    $add_3(points, new KVector_1(section.startX, section.startY));
    $forEach_3(new StreamImpl(null, (!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), new Spliterators$IteratorSpliterator(section.bendPoints, 16))), new ElkUtil$lambda$4$Type(points));
    $add_3(points, new KVector_1(section.endX, section.endY));
    i = 1;
    while(i < points.array.length - 1){
        p1 = (checkCriticalElementIndex(i - 1, points.array.length), castTo(points.array[i - 1], 8));
        p2 = (checkCriticalElementIndex(i, points.array.length), castTo(points.array[i], 8));
        p3 = (checkCriticalElementIndex(i + 1, points.array.length), castTo(points.array[i + 1], 8));
        p1.x_0 == p2.x_0 && p2.x_0 == p3.x_0 || p1.y_0 == p2.y_0 && p2.y_0 == p3.y_0 ? $remove_11(points, i) : ++i;
    }
    return points;
}
function lambda$1_22(xoffset_0, yoffset_2, edge_2) {
    var junctionPoints;
    $forEach_3(new StreamImpl(null, (!edge_2.sections && (edge_2.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge_2, 6, 6)), new Spliterators$IteratorSpliterator(edge_2.sections, 16))), new ElkUtil$lambda$2$Type(xoffset_0, yoffset_2));
    $forEach_3(new StreamImpl(null, (!edge_2.labels && (edge_2.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, edge_2, 1, 7)), new Spliterators$IteratorSpliterator(edge_2.labels, 16))), new ElkUtil$lambda$3$Type(xoffset_0, yoffset_2));
    junctionPoints = castTo($getProperty_0(edge_2, ($clinit_CoreOptions(), JUNCTION_POINTS_0)), 77);
    !!junctionPoints && $offset_1(junctionPoints, xoffset_0, yoffset_2);
}
function lambda$2_14(xoffset_0, yoffset_2, s_2) {
    translate(s_2, xoffset_0, yoffset_2);
}
function lambda$3_11(xoffset_0, yoffset_2, label_2) {
    $setLocation_1(label_2, label_2.x_0 + xoffset_0, label_2.y_0 + yoffset_2);
}
function lambda$4_9(points_0, bendPoint_1) {
    return $add_3(points_0, new KVector_1(bendPoint_1.x_0, bendPoint_1.y_0));
}
function printElementPath(element, builder) {
    var className, edge, identifier, label_0, label$iterator, sourceIter, targetIter, text_0;
    if (instanceOf(element.eContainer_0(), 173)) {
        printElementPath(castTo(element.eContainer_0(), 173), builder);
        builder.string += ' > ';
    } else builder.string += 'Root ';
    className = element.eClass_0().name_0;
    $equals_5(className.substr(0, 3), 'Elk') ? $append_11(builder, (checkCriticalStringElementIndex(3, className.length + 1), className.substr(3))) : (builder.string += '' + className, builder);
    identifier = element.getIdentifier();
    if (identifier) {
        $append_11((builder.string += ' ', builder), identifier);
        return;
    }
    if (instanceOf(element, 359)) {
        text_0 = castTo(element, 153).text_0;
        if (text_0) {
            $append_11((builder.string += ' ', builder), text_0);
            return;
        }
    }
    for(label$iterator = new AbstractEList$EIterator(element.getLabels_0()); label$iterator.cursor != label$iterator.this$01_2.size_1();){
        label_0 = castTo($doNext(label$iterator), 153);
        text_0 = label_0.text_0;
        if (text_0) {
            $append_11((builder.string += ' ', builder), text_0);
            return;
        }
    }
    if (instanceOf(element, 268)) {
        edge = castTo(element, 85);
        !edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7));
        if (edge.sources.size_0 != 0 && (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets.size_0 != 0)) {
            builder.string += ' (';
            sourceIter = new AbstractEList$EListIterator((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources));
            while(sourceIter.cursor != sourceIter.this$01_2.size_1()){
                sourceIter.cursor > 0 && (builder.string += ', ', builder);
                printElementPath(castTo($doNext(sourceIter), 173), builder);
            }
            builder.string += ' -> ';
            targetIter = new AbstractEList$EListIterator((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets));
            while(targetIter.cursor != targetIter.this$01_2.size_1()){
                targetIter.cursor > 0 && (builder.string += ', ', builder);
                printElementPath(castTo($doNext(targetIter), 173), builder);
            }
            builder.string += ')';
        }
    }
}
function resizeNode_0(node) {
    var direction, minEast, minNorth, minSouth, minWest, newHeight, newWidth, port, port$iterator, portConstraints, portSide, sizeConstraint;
    sizeConstraint = castTo($getProperty_0(node, ($clinit_CoreOptions(), NODE_SIZE_CONSTRAINTS_6)), 22);
    if (sizeConstraint.isEmpty()) return null;
    newWidth = 0;
    newHeight = 0;
    if (sizeConstraint.contains(($clinit_SizeConstraint(), PORTS_0))) {
        portConstraints = castTo($getProperty_0(node, PORT_CONSTRAINTS_1), 100);
        minNorth = 2;
        minEast = 2;
        minSouth = 2;
        minWest = 2;
        direction = !$getParent_2(node) ? castTo($getProperty_0(node, DIRECTION_1), 86) : castTo($getProperty_0($getParent_2(node), DIRECTION_1), 86);
        for(port$iterator = new AbstractEList$EIterator((!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports)); port$iterator.cursor != port$iterator.this$01_2.size_1();){
            port = castTo($doNext(port$iterator), 124);
            portSide = castTo($getProperty_0(port, PORT_SIDE_0), 64);
            if (portSide == ($clinit_PortSide(), UNDEFINED_5)) {
                portSide = calcPortSide_0(port, direction);
                $setProperty_1(port, PORT_SIDE_0, portSide);
            }
            if (portConstraints == ($clinit_PortConstraints(), FIXED_POS)) switch(portSide.ordinal){
                case 1:
                    minNorth = $wnd.Math.max(minNorth, port.x_0 + port.width_0);
                    break;
                case 2:
                    minEast = $wnd.Math.max(minEast, port.y_0 + port.height);
                    break;
                case 3:
                    minSouth = $wnd.Math.max(minSouth, port.x_0 + port.width_0);
                    break;
                case 4:
                    minWest = $wnd.Math.max(minWest, port.y_0 + port.height);
            }
            else switch(portSide.ordinal){
                case 1:
                    minNorth += port.width_0 + 2;
                    break;
                case 2:
                    minEast += port.height + 2;
                    break;
                case 3:
                    minSouth += port.width_0 + 2;
                    break;
                case 4:
                    minWest += port.height + 2;
            }
        }
        newWidth = $wnd.Math.max(minNorth, minSouth);
        newHeight = $wnd.Math.max(minEast, minWest);
    }
    return resizeNode_1(node, newWidth, newHeight, true, true);
}
function resizeNode_1(node, newWidth, newHeight, movePorts, moveLabels) {
    var all, direction, fixedPorts, heightDiff, heightPercent, heightRatio, label_0, label$iterator, midx, midy, newSize, oldSize, port, port$iterator, portSide, widthDiff, widthPercent, widthRatio;
    oldSize = new KVector_1(node.width_0, node.height);
    newSize = effectiveMinSizeConstraintFor(node);
    newSize.x_0 = $wnd.Math.max(newSize.x_0, newWidth);
    newSize.y_0 = $wnd.Math.max(newSize.y_0, newHeight);
    widthRatio = newSize.x_0 / oldSize.x_0;
    heightRatio = newSize.y_0 / oldSize.y_0;
    widthDiff = newSize.x_0 - oldSize.x_0;
    heightDiff = newSize.y_0 - oldSize.y_0;
    if (movePorts) {
        direction = !$getParent_2(node) ? castTo($getProperty_0(node, ($clinit_CoreOptions(), DIRECTION_1)), 86) : castTo($getProperty_0($getParent_2(node), ($clinit_CoreOptions(), DIRECTION_1)), 86);
        fixedPorts = maskUndefined($getProperty_0(node, ($clinit_CoreOptions(), PORT_CONSTRAINTS_1))) === maskUndefined(($clinit_PortConstraints(), FIXED_POS));
        for(port$iterator = new AbstractEList$EIterator((!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports)); port$iterator.cursor != port$iterator.this$01_2.size_1();){
            port = castTo($doNext(port$iterator), 124);
            portSide = castTo($getProperty_0(port, PORT_SIDE_0), 64);
            if (portSide == ($clinit_PortSide(), UNDEFINED_5)) {
                portSide = calcPortSide_0(port, direction);
                $setProperty_1(port, PORT_SIDE_0, portSide);
            }
            switch(portSide.ordinal){
                case 1:
                    fixedPorts || $setX_1(port, port.x_0 * widthRatio);
                    break;
                case 2:
                    $setX_1(port, port.x_0 + widthDiff);
                    fixedPorts || $setY_2(port, port.y_0 * heightRatio);
                    break;
                case 3:
                    fixedPorts || $setX_1(port, port.x_0 * widthRatio);
                    $setY_2(port, port.y_0 + heightDiff);
                    break;
                case 4:
                    fixedPorts || $setY_2(port, port.y_0 * heightRatio);
            }
        }
    }
    $setDimensions(node, newSize.x_0, newSize.y_0);
    if (moveLabels) for(label$iterator = new AbstractEList$EIterator((!node.labels && (node.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, node, 1, 7)), node.labels)); label$iterator.cursor != label$iterator.this$01_2.size_1();){
        label_0 = castTo($doNext(label$iterator), 153);
        midx = label_0.x_0 + label_0.width_0 / 2;
        midy = label_0.y_0 + label_0.height / 2;
        widthPercent = midx / oldSize.x_0;
        heightPercent = midy / oldSize.y_0;
        if (widthPercent + heightPercent >= 1) {
            if (widthPercent - heightPercent > 0 && midy >= 0) {
                $setX_1(label_0, label_0.x_0 + widthDiff);
                $setY_2(label_0, label_0.y_0 + heightDiff * heightPercent);
            } else if (widthPercent - heightPercent < 0 && midx >= 0) {
                $setX_1(label_0, label_0.x_0 + widthDiff * widthPercent);
                $setY_2(label_0, label_0.y_0 + heightDiff);
            }
        }
    }
    $setProperty_1(node, ($clinit_CoreOptions(), NODE_SIZE_CONSTRAINTS_6), ($clinit_SizeConstraint(), all = castTo($getEnumConstants(Lorg_eclipse_elk_core_options_SizeConstraint_2_classLit), 10), new EnumSet$EnumSetImpl(all, castTo(createFrom(all, all.length), 10), 0)));
    return new KVector_1(widthRatio, heightRatio);
}
function toAbsolute(point, parent_0) {
    var node;
    node = parent_0;
    while(node){
        $add_18(point, node.x_0, node.y_0);
        node = $getParent_2(node);
    }
    return point;
}
function toRelative(point, parent_0) {
    var node;
    node = parent_0;
    while(node){
        $add_18(point, -node.x_0, -node.y_0);
        node = $getParent_2(node);
    }
    return point;
}
function translate(section, xoffset, yoffset) {
    var bendPoint, bendPoint$iterator;
    $setStartLocation(section, section.startX + xoffset, section.startY + yoffset);
    for(bendPoint$iterator = new AbstractEList$EIterator((!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints)); bendPoint$iterator.cursor != bendPoint$iterator.this$01_2.size_1();){
        bendPoint = castTo($doNext(bendPoint$iterator), 369);
        $set_8(bendPoint, bendPoint.x_0 + xoffset, bendPoint.y_0 + yoffset);
    }
    $setEndLocation(section, section.endX + xoffset, section.endY + yoffset);
}
function translate_0(parent_0, xoffset, yoffset) {
    var child, child$iterator;
    for(child$iterator = new AbstractEList$EIterator((!parent_0.children && (parent_0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parent_0, 10, 11)), parent_0.children)); child$iterator.cursor != child$iterator.this$01_2.size_1();){
        child = castTo($doNext(child$iterator), 27);
        $setLocation_1(child, child.x_0 + xoffset, child.y_0 + yoffset);
    }
    $forEach_0((!parent_0.containedEdges && (parent_0.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, parent_0, 12, 3)), parent_0.containedEdges), new ElkUtil$lambda$1$Type(xoffset, yoffset));
}
function translate_1(parent_0, newSize, oldSize) {
    var contentAlignment, xTranslate, yTranslate;
    contentAlignment = castTo($getProperty_0(parent_0, ($clinit_CoreOptions(), CONTENT_ALIGNMENT_2)), 22);
    xTranslate = 0;
    yTranslate = 0;
    newSize.x_0 > oldSize.x_0 && (contentAlignment.contains(($clinit_ContentAlignment(), H_CENTER)) ? xTranslate = (newSize.x_0 - oldSize.x_0) / 2 : contentAlignment.contains(H_RIGHT) && (xTranslate = newSize.x_0 - oldSize.x_0));
    newSize.y_0 > oldSize.y_0 && (contentAlignment.contains(($clinit_ContentAlignment(), V_CENTER)) ? yTranslate = (newSize.y_0 - oldSize.y_0) / 2 : contentAlignment.contains(V_BOTTOM) && (yTranslate = newSize.y_0 - oldSize.y_0));
    translate_0(parent_0, xTranslate, yTranslate);
}
function $apply_18(arg0) {
    return $getLabels_1(castTo(arg0, 124));
}
function ElkUtil$lambda$0$Type() {}
defineClass(925, 1, {}, ElkUtil$lambda$0$Type);
_.apply_0 = function apply_155(arg0) {
    return $apply_18(arg0);
};
_.equals_0 = function equals_200(other) {
    return this === other;
};
var Lorg_eclipse_elk_core_util_ElkUtil$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkUtil/lambda$0$Type', 925);
function ElkUtil$lambda$1$Type(xoffset_0, yoffset_2) {
    this.xoffset_0 = xoffset_0;
    this.yoffset_2 = yoffset_2;
}
defineClass(926, 1, $intern_19, ElkUtil$lambda$1$Type);
_.accept = function accept_148(arg0) {
    lambda$1_22(this.xoffset_0, this.yoffset_2, castTo(arg0, 85));
};
_.xoffset_0 = 0;
_.yoffset_2 = 0;
var Lorg_eclipse_elk_core_util_ElkUtil$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkUtil/lambda$1$Type', 926);
function ElkUtil$lambda$2$Type(xoffset_0, yoffset_2) {
    this.xoffset_0 = xoffset_0;
    this.yoffset_2 = yoffset_2;
}
defineClass(927, 1, $intern_19, ElkUtil$lambda$2$Type);
_.accept = function accept_149(arg0) {
    lambda$2_14(this.xoffset_0, this.yoffset_2, castTo(arg0, 168));
};
_.xoffset_0 = 0;
_.yoffset_2 = 0;
var Lorg_eclipse_elk_core_util_ElkUtil$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkUtil/lambda$2$Type', 927);
function ElkUtil$lambda$3$Type(xoffset_0, yoffset_2) {
    this.xoffset_0 = xoffset_0;
    this.yoffset_2 = yoffset_2;
}
defineClass(928, 1, $intern_19, ElkUtil$lambda$3$Type);
_.accept = function accept_150(arg0) {
    lambda$3_11(this.xoffset_0, this.yoffset_2, castTo(arg0, 153));
};
_.xoffset_0 = 0;
_.yoffset_2 = 0;
var Lorg_eclipse_elk_core_util_ElkUtil$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkUtil/lambda$3$Type', 928);
function ElkUtil$lambda$4$Type(points_0) {
    this.points_0 = points_0;
}
defineClass(929, 1, $intern_19, ElkUtil$lambda$4$Type);
_.accept = function accept_151(arg0) {
    lambda$4_9(this.points_0, castTo(arg0, 369));
};
var Lorg_eclipse_elk_core_util_ElkUtil$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'ElkUtil/lambda$4$Type', 929);
function $compareTo_20(this$static, x_0) {
    return this$static.exclusiveLowerBound < doubleValue__D__devirtual$(x_0) ? -1 : 1;
}
function ExclusiveBounds$ExclusiveLowerBound() {
    this.exclusiveLowerBound = 0;
}
defineClass(326, 1, {
    34: 1,
    326: 1
}, ExclusiveBounds$ExclusiveLowerBound);
_.compareTo_0 = function compareTo_21(x_0) {
    return $compareTo_20(this, castTo(x_0, 241));
};
_.equals_0 = function equals_201(obj) {
    var other;
    if (instanceOf(obj, 326)) {
        other = castTo(obj, 326);
        return this.exclusiveLowerBound == other.exclusiveLowerBound;
    }
    return false;
};
_.hashCode_1 = function hashCode_70() {
    return round_int(this.exclusiveLowerBound);
};
_.toString_0 = function toString_116() {
    return this.exclusiveLowerBound + ' (exclusive)';
};
_.exclusiveLowerBound = 0;
var Lorg_eclipse_elk_core_util_ExclusiveBounds$ExclusiveLowerBound_2_classLit = createForClass('org.eclipse.elk.core.util', 'ExclusiveBounds/ExclusiveLowerBound', 326);
function $processEdge(edge) {
    var bendPoints, edgeSection, edgeSection$iterator, elkEdgeSection, label_0, label$iterator, maxv, point, point$iterator, pos, sameHierarchy, sections, sourceParent, targetParent;
    sourceParent = $getParent_2(connectableShapeToNode(castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84)));
    targetParent = $getParent_2(connectableShapeToNode(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84)));
    sameHierarchy = sourceParent == targetParent;
    maxv = new KVector;
    bendPoints = castTo($getProperty_0(edge, ($clinit_FixedLayouterOptions(), BEND_POINTS_0)), 77);
    if (!!bendPoints && bendPoints.size_0 >= 2) {
        if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 == 0) {
            edgeSection = ($clinit_ElkGraphFactory(), elkEdgeSection = new ElkEdgeSectionImpl, elkEdgeSection);
            $add_21((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), edgeSection);
        } else if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 > 1) {
            sections = new AbstractEList$EListIterator((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections));
            while(sections.cursor != sections.this$01_2.size_1())$remove_36(sections);
        }
        applyVectorChain(bendPoints, castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168));
    }
    if (sameHierarchy) for(edgeSection$iterator = new AbstractEList$EIterator((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections)); edgeSection$iterator.cursor != edgeSection$iterator.this$01_2.size_1();){
        edgeSection = castTo($doNext(edgeSection$iterator), 168);
        for(point$iterator = new AbstractEList$EIterator((!edgeSection.bendPoints && (edgeSection.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, edgeSection, 5)), edgeSection.bendPoints)); point$iterator.cursor != point$iterator.this$01_2.size_1();){
            point = castTo($doNext(point$iterator), 369);
            maxv.x_0 = $wnd.Math.max(maxv.x_0, point.x_0);
            maxv.y_0 = $wnd.Math.max(maxv.y_0, point.y_0);
        }
    }
    for(label$iterator = new AbstractEList$EIterator((!edge.labels && (edge.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, edge, 1, 7)), edge.labels)); label$iterator.cursor != label$iterator.this$01_2.size_1();){
        label_0 = castTo($doNext(label$iterator), 153);
        pos = castTo($getProperty_0(label_0, POSITION_3), 8);
        !!pos && $setLocation_1(label_0, pos.x_0, pos.y_0);
        if (sameHierarchy) {
            maxv.x_0 = $wnd.Math.max(maxv.x_0, label_0.x_0 + label_0.width_0);
            maxv.y_0 = $wnd.Math.max(maxv.y_0, label_0.y_0 + label_0.height);
        }
    }
    return maxv;
}
function FixedLayoutProvider() {}
defineClass(1083, 222, $intern_96, FixedLayoutProvider);
_.layout = function layout_8(layoutNode, progressMonitor) {
    var edge, edge$iterator, edge$iterator0, edgeRouting, junctionPoints, label_0, label$iterator, label$iterator0, maxv, maxx, maxy, minSize, newHeight, newWidth, node, node$iterator, node$iterator0, padding, port, port$iterator, portx, porty, pos;
    progressMonitor.begin('Fixed Layout', 1);
    edgeRouting = castTo($getProperty_0(layoutNode, ($clinit_CoreOptions(), EDGE_ROUTING_0)), 220);
    maxx = 0;
    maxy = 0;
    for(node$iterator0 = new AbstractEList$EIterator((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)); node$iterator0.cursor != node$iterator0.this$01_2.size_1();){
        node = castTo($doNext(node$iterator0), 27);
        pos = castTo($getProperty_0(node, ($clinit_FixedLayouterOptions(), POSITION_3)), 8);
        if (pos) {
            $setLocation_1(node, pos.x_0, pos.y_0);
            if (castTo($getProperty_0(node, NODE_SIZE_CONSTRAINTS_7), 181).contains(($clinit_SizeConstraint(), MINIMUM_SIZE))) {
                minSize = castTo($getProperty_0(node, NODE_SIZE_MINIMUM_6), 8);
                minSize.x_0 > 0 && minSize.y_0 > 0 && resizeNode_1(node, minSize.x_0, minSize.y_0, true, true);
            }
        }
        maxx = $wnd.Math.max(maxx, node.x_0 + node.width_0);
        maxy = $wnd.Math.max(maxy, node.y_0 + node.height);
        for(label$iterator0 = new AbstractEList$EIterator((!node.labels && (node.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, node, 1, 7)), node.labels)); label$iterator0.cursor != label$iterator0.this$01_2.size_1();){
            label_0 = castTo($doNext(label$iterator0), 153);
            pos = castTo($getProperty_0(label_0, POSITION_3), 8);
            !!pos && $setLocation_1(label_0, pos.x_0, pos.y_0);
            maxx = $wnd.Math.max(maxx, node.x_0 + label_0.x_0 + label_0.width_0);
            maxy = $wnd.Math.max(maxy, node.y_0 + label_0.y_0 + label_0.height);
        }
        for(port$iterator = new AbstractEList$EIterator((!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports)); port$iterator.cursor != port$iterator.this$01_2.size_1();){
            port = castTo($doNext(port$iterator), 124);
            pos = castTo($getProperty_0(port, POSITION_3), 8);
            !!pos && $setLocation_1(port, pos.x_0, pos.y_0);
            portx = node.x_0 + port.x_0;
            porty = node.y_0 + port.y_0;
            maxx = $wnd.Math.max(maxx, portx + port.width_0);
            maxy = $wnd.Math.max(maxy, porty + port.height);
            for(label$iterator = new AbstractEList$EIterator((!port.labels && (port.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, port, 1, 7)), port.labels)); label$iterator.cursor != label$iterator.this$01_2.size_1();){
                label_0 = castTo($doNext(label$iterator), 153);
                pos = castTo($getProperty_0(label_0, POSITION_3), 8);
                !!pos && $setLocation_1(label_0, pos.x_0, pos.y_0);
                maxx = $wnd.Math.max(maxx, portx + label_0.x_0 + label_0.width_0);
                maxy = $wnd.Math.max(maxy, porty + label_0.y_0 + label_0.height);
            }
        }
        for(edge$iterator0 = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator0);){
            edge = castTo($next_0(edge$iterator0), 85);
            maxv = $processEdge(edge);
            maxx = $wnd.Math.max(maxx, maxv.x_0);
            maxy = $wnd.Math.max(maxy, maxv.y_0);
        }
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allIncomingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 85);
            if ($getParent_2(getSourceNode(edge)) != layoutNode) {
                maxv = $processEdge(edge);
                maxx = $wnd.Math.max(maxx, maxv.x_0);
                maxy = $wnd.Math.max(maxy, maxv.y_0);
            }
        }
    }
    if (edgeRouting == ($clinit_EdgeRouting(), ORTHOGONAL)) for(node$iterator = new AbstractEList$EIterator((!layoutNode.children && (layoutNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, layoutNode, 10, 11)), layoutNode.children)); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 85);
            junctionPoints = determineJunctionPoints(edge);
            junctionPoints.size_0 == 0 ? $setProperty_1(edge, JUNCTION_POINTS_0, null) : $setProperty_1(edge, JUNCTION_POINTS_0, junctionPoints);
        }
    }
    if (!$booleanValue(castToBoolean($getProperty_0(layoutNode, ($clinit_FixedLayouterOptions(), NODE_SIZE_FIXED_GRAPH_SIZE_4))))) {
        padding = castTo($getProperty_0(layoutNode, PADDING_6), 107);
        newWidth = maxx + padding.left + padding.right;
        newHeight = maxy + padding.top_0 + padding.bottom;
        resizeNode_1(layoutNode, newWidth, newHeight, true, true);
    }
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_core_util_FixedLayoutProvider_2_classLit = createForClass('org.eclipse.elk.core.util', 'FixedLayoutProvider', 1083);
function IndividualSpacings() {}
function IndividualSpacings_0(other) {
    (!this.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : this.propertyMap).putAll(!other.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : other.propertyMap);
}
function getIndividualOrInherited_0(node, property) {
    var individualSpacings, result;
    result = null;
    if (node.hasProperty(($clinit_CoreOptions(), SPACING_INDIVIDUAL_0))) {
        individualSpacings = castTo(node.getProperty(SPACING_INDIVIDUAL_0), 102);
        individualSpacings.hasProperty(property) && (result = individualSpacings.getProperty(property));
    }
    result == null && !!node.getGraph() && (result = node.getGraph().getProperty(property));
    result == null && (result = $getDefault(property));
    return result;
}
function lambda$0_41(entry_0) {
    return castTo(entry_0.getKey(), 144).getId() + ':' + toString_40(entry_0.getValue());
}
defineClass(377, 148, {
    3: 1,
    411: 1,
    377: 1,
    102: 1,
    148: 1
}, IndividualSpacings, IndividualSpacings_0);
_.parse_0 = function parse_3(string) {
    var e, option, optionData, optionString, optionString$array, optionString$index, optionString$max, options, value_0;
    if (!string) return;
    try {
        options = $split_0(string, ';,;');
        for(optionString$array = options, optionString$index = 0, optionString$max = optionString$array.length; optionString$index < optionString$max; ++optionString$index){
            optionString = optionString$array[optionString$index];
            option = $split_0(optionString, '\\:');
            optionData = $getOptionDataBySuffix(getInstance(), option[0]);
            if (!optionData) throw toJs(new IllegalArgumentException_0('Invalid option id: ' + option[0]));
            value_0 = $parseValue(optionData, option[1]);
            if (value_0 == null) throw toJs(new IllegalArgumentException_0('Invalid option value: ' + option[1]));
            value_0 == null ? (!this.propertyMap && (this.propertyMap = new HashMap), $remove_6(this.propertyMap, optionData)) : (!this.propertyMap && (this.propertyMap = new HashMap), $put_6(this.propertyMap, optionData, value_0));
        }
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            e = $e0;
            throw toJs(new IllegalArgumentException_1(e));
        } else throw toJs($e0);
    }
};
_.toString_0 = function toString_117() {
    var serialized;
    serialized = castToString($collect_1($map((!this.propertyMap ? ($clinit_Collections(), $clinit_Collections(), EMPTY_MAP) : this.propertyMap).entrySet_0().stream(), new IndividualSpacings$lambda$0$Type), of_3(new Collectors$lambda$15$Type, new Collectors$9methodref$add$Type, new Collectors$10methodref$merge$Type, new Collectors$11methodref$toString$Type, stampJavaTypeInfo(getClassLiteralForArray(Ljava_util_stream_Collector$Characteristics_2_classLit, 1), $intern_36, 131, 0, []))));
    return serialized;
};
var Lorg_eclipse_elk_core_util_IndividualSpacings_2_classLit = createForClass('org.eclipse.elk.core.util', 'IndividualSpacings', 377);
function IndividualSpacings$lambda$0$Type() {}
defineClass(959, 1, {}, IndividualSpacings$lambda$0$Type);
_.apply_0 = function apply_156(arg0) {
    return lambda$0_41(castTo(arg0, 43));
};
var Lorg_eclipse_elk_core_util_IndividualSpacings$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.core.util', 'IndividualSpacings/lambda$0$Type', 959);
function $fetch(this$static) {
    if (this$static.instances.size_0 == 0) return this$static.factory.create_0();
    return $removeFirst_0(this$static.instances);
}
function $release(this$static, obj) {
    this$static.limit < 0 || this$static.instances.size_0 < this$static.limit ? $addLast_0(this$static.instances, obj) : this$static.factory.destroy(obj);
}
function InstancePool(thefactory) {
    this.instances = new LinkedList;
    this.factory = thefactory;
    this.limit = -1;
}
defineClass(702, 1, {}, InstancePool);
_.limit = 0;
var Lorg_eclipse_elk_core_util_InstancePool_2_classLit = createForClass('org.eclipse.elk.core.util', 'InstancePool', 702);
function LoggedGraph() {}
defineClass(1781, 1, {}, LoggedGraph);
var Lorg_eclipse_elk_core_util_LoggedGraph_2_classLit = createForClass('org.eclipse.elk.core.util', 'LoggedGraph', 1781);
function $clinit_LoggedGraph$Type() {
    $clinit_LoggedGraph$Type = emptyMethod;
    ELK = new LoggedGraph$Type('ELK', 0);
    JSON_0 = new LoggedGraph$Type('JSON', 1);
    DOT = new LoggedGraph$Type('DOT', 2);
    SVG = new LoggedGraph$Type('SVG', 3);
}
function LoggedGraph$Type(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_113(name_0) {
    $clinit_LoggedGraph$Type();
    return valueOf(($clinit_LoggedGraph$Type$Map(), $MAP_103), name_0);
}
function values_121() {
    $clinit_LoggedGraph$Type();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_LoggedGraph$Type_2_classLit, 1), $intern_36, 404, 0, [
        ELK,
        JSON_0,
        DOT,
        SVG
    ]);
}
defineClass(404, 23, {
    3: 1,
    34: 1,
    23: 1,
    404: 1
}, LoggedGraph$Type);
var DOT, ELK, JSON_0, SVG;
var Lorg_eclipse_elk_core_util_LoggedGraph$Type_2_classLit = createForEnum('org.eclipse.elk.core.util', 'LoggedGraph/Type', 404, Ljava_lang_Enum_2_classLit, values_121, valueOf_113);
function $clinit_LoggedGraph$Type$Map() {
    $clinit_LoggedGraph$Type$Map = emptyMethod;
    $MAP_103 = createValueOfMap(($clinit_LoggedGraph$Type(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_LoggedGraph$Type_2_classLit, 1), $intern_36, 404, 0, [
        ELK,
        JSON_0,
        DOT,
        SVG
    ])));
}
var $MAP_103;
function NullElkProgressMonitor() {}
defineClass(1038, 1, {
    847: 1
}, NullElkProgressMonitor);
_.begin = function begin_1(name_0, totalWork) {
    return false;
};
_.done_1 = function done_0() {};
_.getExecutionTime = function getExecutionTime_0() {
    return 0;
};
_.getLogs = function getLogs_0() {
    return null;
};
_.getSubMonitors = function getSubMonitors_0() {
    return null;
};
_.getTaskName = function getTaskName_0() {
    return null;
};
_.isCanceled = function isCanceled_0() {
    return false;
};
_.isLoggingEnabled = function isLoggingEnabled_0() {
    return false;
};
_.isRunning = function isRunning_0() {
    return false;
};
_.log_0 = function log_1(object) {};
_.logGraph = function logGraph_0(graph, tag) {};
_.subTask = function subTask_0(work) {
    return this;
};
_.worked = function worked_0(work) {};
var Lorg_eclipse_elk_core_util_NullElkProgressMonitor_2_classLit = createForClass('org.eclipse.elk.core.util', 'NullElkProgressMonitor', 1038);
function $setFirst(this$static, thefirst) {
    this$static.first = thefirst;
}
function $setSecond(this$static, thesecond) {
    this$static.second = thesecond;
}
function Pair(thefirst, thesecond) {
    this.first = thefirst;
    this.second = thesecond;
}
defineClass(47, 1, {
    20: 1,
    47: 1
}, Pair);
_.forEach_0 = function forEach_36(action) {
    $forEach_0(this, action);
};
_.equals_0 = function equals_202(obj) {
    var firstEqual, other, secondEqual;
    if (instanceOf(obj, 47)) {
        other = castTo(obj, 47);
        firstEqual = this.first == null ? other.first == null : equals_Ljava_lang_Object__Z__devirtual$(this.first, other.first);
        secondEqual = this.second == null ? other.second == null : equals_Ljava_lang_Object__Z__devirtual$(this.second, other.second);
        return firstEqual && secondEqual;
    } else return false;
};
_.hashCode_1 = function hashCode_71() {
    var first1, first2, firstCode, second1, second2, secondCode;
    firstCode = this.first == null ? 0 : hashCode__I__devirtual$(this.first);
    first1 = firstCode & $intern_46;
    first2 = firstCode & -65536;
    secondCode = this.second == null ? 0 : hashCode__I__devirtual$(this.second);
    second1 = secondCode & $intern_46;
    second2 = secondCode & -65536;
    return first1 ^ second2 >> 16 & $intern_46 | first2 ^ second1 << 16;
};
_.iterator_0 = function iterator_78() {
    return new Pair$1(this);
};
_.toString_0 = function toString_118() {
    return this.first == null && this.second == null ? 'pair(null,null)' : this.first == null ? 'pair(null,' + toString_40(this.second) + ')' : this.second == null ? 'pair(' + toString_40(this.first) + ',null)' : 'pair(' + toString_40(this.first) + ',' + toString_40(this.second) + ')';
};
var Lorg_eclipse_elk_core_util_Pair_2_classLit = createForClass('org.eclipse.elk.core.util', 'Pair', 47);
function Pair$1(this$0) {
    this.this$01 = this$0;
}
defineClass(972, 1, $intern_6, Pair$1);
_.forEachRemaining = function forEachRemaining_51(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_40() {
    return !this.visitedSecond && (!this.visitedFirst && this.this$01.first != null || this.this$01.second != null);
};
_.next_1 = function next_41() {
    if (!this.visitedSecond && !this.visitedFirst && this.this$01.first != null) {
        this.visitedFirst = true;
        return this.this$01.first;
    } else if (!this.visitedSecond && this.this$01.second != null) {
        this.visitedSecond = true;
        return this.this$01.second;
    }
    throw toJs(new NoSuchElementException);
};
_.remove = function remove_97() {
    this.visitedSecond && this.this$01.second != null ? this.this$01.second = null : this.visitedFirst && this.this$01.first != null && (this.this$01.first = null);
    throw toJs(new IllegalStateException);
};
_.visitedFirst = false;
_.visitedSecond = false;
var Lorg_eclipse_elk_core_util_Pair$1_2_classLit = createForClass('org.eclipse.elk.core.util', 'Pair/1', 972);
function $randomize(edge, random, drawWidth, drawHeight) {
    var bendPoint, bendsNum, edgeSection, edgeSection0, elkBendPoint, elkEdgeSection, i, maxRand, randx, randy, sections, sourceHeight, sourcePX, sourcePY, sourcePort, sourceShape, sourceWidth, sourceX, sourceY, targetHeight, targetPX, targetPY, targetPort, targetShape, targetWidth, targetX, targetY, totalDist, x_0, xdiff, xincr, y_0, ydiff, yincr;
    sourceShape = castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84);
    sourceX = sourceShape.getX();
    sourceY = sourceShape.getY();
    sourceWidth = sourceShape.getWidth() / 2;
    sourceHeight = sourceShape.getHeight() / 2;
    if (instanceOf(sourceShape, 193)) {
        sourcePort = castTo(sourceShape, 124);
        sourceX += $getParent_3(sourcePort).x_0;
        sourceX += $getParent_3(sourcePort).x_0;
    }
    sourceX += sourceWidth;
    sourceY += sourceHeight;
    targetShape = castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84);
    targetX = targetShape.getX();
    targetY = targetShape.getY();
    targetWidth = targetShape.getWidth() / 2;
    targetHeight = targetShape.getHeight() / 2;
    if (instanceOf(targetShape, 193)) {
        targetPort = castTo(targetShape, 124);
        targetX += $getParent_3(targetPort).x_0;
        targetX += $getParent_3(targetPort).x_0;
    }
    targetX += targetWidth;
    targetY += targetHeight;
    if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 == 0) {
        edgeSection0 = ($clinit_ElkGraphFactory(), elkEdgeSection = new ElkEdgeSectionImpl, elkEdgeSection);
        $add_21((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), edgeSection0);
    } else if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 > 1) {
        sections = new AbstractEList$EListIterator((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections));
        while(sections.cursor != sections.this$01_2.size_1())$remove_36(sections);
    }
    edgeSection = castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168);
    sourcePX = targetX;
    targetX > sourceX + sourceWidth ? sourcePX = sourceX + sourceWidth : targetX < sourceX - sourceWidth && (sourcePX = sourceX - sourceWidth);
    sourcePY = targetY;
    targetY > sourceY + sourceHeight ? sourcePY = sourceY + sourceHeight : targetY < sourceY - sourceHeight && (sourcePY = sourceY - sourceHeight);
    sourcePX > sourceX - sourceWidth && sourcePX < sourceX + sourceWidth && sourcePY > sourceY - sourceHeight && sourcePY < sourceY + sourceHeight && (sourcePX = sourceX + sourceWidth);
    $setStartX(edgeSection, sourcePX);
    $setStartY(edgeSection, sourcePY);
    targetPX = sourceX;
    sourceX > targetX + targetWidth ? targetPX = targetX + targetWidth : sourceX < targetX - targetWidth && (targetPX = targetX - targetWidth);
    targetPY = sourceY;
    sourceY > targetY + targetHeight ? targetPY = targetY + targetHeight : sourceY < targetY - targetHeight && (targetPY = targetY - targetHeight);
    targetPX > targetX - targetWidth && targetPX < targetX + targetWidth && targetPY > targetY - targetHeight && targetPY < targetY + targetHeight && (targetPY = targetY + targetHeight);
    $setEndX(edgeSection, targetPX);
    $setEndY(edgeSection, targetPY);
    $clear_13((!edgeSection.bendPoints && (edgeSection.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, edgeSection, 5)), edgeSection.bendPoints));
    bendsNum = $nextInt(random, 5);
    sourceShape == targetShape && ++bendsNum;
    xdiff = targetPX - sourcePX;
    ydiff = targetPY - sourcePY;
    totalDist = $wnd.Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    maxRand = totalDist * 0.20000000298023224;
    xincr = xdiff / (bendsNum + 1);
    yincr = ydiff / (bendsNum + 1);
    x_0 = sourcePX;
    y_0 = sourcePY;
    for(i = 0; i < bendsNum; i++){
        x_0 += xincr;
        y_0 += yincr;
        randx = x_0 + $nextInternal(random, 24) * $intern_81 * maxRand - maxRand / 2;
        randx < 0 ? randx = 1 : randx > drawWidth && (randx = drawWidth - 1);
        randy = y_0 + $nextInternal(random, 24) * $intern_81 * maxRand - maxRand / 2;
        randy < 0 ? randy = 1 : randy > drawHeight && (randy = drawHeight - 1);
        bendPoint = ($clinit_ElkGraphFactory(), elkBendPoint = new ElkBendPointImpl, elkBendPoint);
        $setX_0(bendPoint, randx);
        $setY_1(bendPoint, randy);
        $add_21((!edgeSection.bendPoints && (edgeSection.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, edgeSection, 5)), edgeSection.bendPoints), bendPoint);
    }
}
function $randomize_0(parent_0, random, aspectRatio, spacing, padding) {
    var areaSqrt, drawArea, drawHeight, drawWidth, edge, edge$iterator, height, m, maxHeight, maxWidth, n, node, node$iterator, node$iterator0, nodesArea, source, source$iterator, totalHeight, totalWidth, width_0, x_0, y_0;
    nodesArea = 0;
    maxWidth = 0;
    maxHeight = 0;
    m = 1;
    for(node$iterator0 = new AbstractEList$EIterator((!parent_0.children && (parent_0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parent_0, 10, 11)), parent_0.children)); node$iterator0.cursor != node$iterator0.this$01_2.size_1();){
        node = castTo($doNext(node$iterator0), 27);
        m += size_24(new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(node).val$inputs1.iterator_0(), new Iterables$10)));
        width_0 = node.width_0;
        maxWidth = $wnd.Math.max(maxWidth, width_0);
        height = node.height;
        maxHeight = $wnd.Math.max(maxHeight, height);
        nodesArea += width_0 * height;
    }
    n = (!parent_0.children && (parent_0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parent_0, 10, 11)), parent_0.children).size_0;
    drawArea = nodesArea + 2 * spacing * spacing * m * n;
    areaSqrt = $wnd.Math.sqrt(drawArea);
    drawWidth = $wnd.Math.max(areaSqrt * aspectRatio, maxWidth);
    drawHeight = $wnd.Math.max(areaSqrt / aspectRatio, maxHeight);
    for(node$iterator = new AbstractEList$EIterator((!parent_0.children && (parent_0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parent_0, 10, 11)), parent_0.children)); node$iterator.cursor != node$iterator.this$01_2.size_1();){
        node = castTo($doNext(node$iterator), 27);
        x_0 = padding.left + ($nextInternal(random, 26) * $intern_78 + $nextInternal(random, 27) * $intern_79) * (drawWidth - node.width_0);
        y_0 = padding.left + ($nextInternal(random, 26) * $intern_78 + $nextInternal(random, 27) * $intern_79) * (drawHeight - node.height);
        $setX_1(node, x_0);
        $setY_2(node, y_0);
    }
    totalWidth = drawWidth + (padding.left + padding.right);
    totalHeight = drawHeight + (padding.top_0 + padding.bottom);
    for(source$iterator = new AbstractEList$EIterator((!parent_0.children && (parent_0.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parent_0, 10, 11)), parent_0.children)); source$iterator.cursor != source$iterator.this$01_2.size_1();){
        source = castTo($doNext(source$iterator), 27);
        for(edge$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(source).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(edge$iterator);){
            edge = castTo($next_0(edge$iterator), 85);
            $isHierarchical(edge) || $randomize(edge, random, totalWidth, totalHeight);
        }
    }
    totalWidth += padding.left + padding.right;
    totalHeight += padding.top_0 + padding.bottom;
    resizeNode_1(parent_0, totalWidth, totalHeight, false, true);
}
function RandomLayoutProvider() {}
defineClass(1073, 222, $intern_96, RandomLayoutProvider);
_.layout = function layout_9(parentNode, progressMonitor) {
    var aspectRatio, padding, random, randomSeed, spacing;
    progressMonitor.begin('Random Layout', 1);
    if ((!parentNode.children && (parentNode.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, parentNode, 10, 11)), parentNode.children).size_0 == 0) {
        progressMonitor.done_1();
        return;
    }
    randomSeed = castTo($getProperty_0(parentNode, ($clinit_RandomLayouterOptions(), RANDOM_SEED_2)), 17);
    !!randomSeed && randomSeed.value_0 != 0 ? random = new Random_0(randomSeed.value_0) : random = new Random;
    aspectRatio = $floatValue(castToDouble($getProperty_0(parentNode, ASPECT_RATIO_5)));
    spacing = $floatValue(castToDouble($getProperty_0(parentNode, SPACING_NODE_NODE_7)));
    padding = castTo($getProperty_0(parentNode, PADDING_7), 107);
    $randomize_0(parentNode, random, aspectRatio, spacing, padding);
    progressMonitor.done_1();
};
var Lorg_eclipse_elk_core_util_RandomLayoutProvider_2_classLit = createForClass('org.eclipse.elk.core.util', 'RandomLayoutProvider', 1073);
function Triple(f, s, t) {
    this.first = f;
    this.second = s;
    this.third = t;
}
defineClass(239, 1, {
    239: 1
}, Triple);
_.equals_0 = function equals_203(obj) {
    return equals_57(this.first, castTo(obj, 239).first) && equals_57(this.second, castTo(obj, 239).second) && equals_57(this.third, castTo(obj, 239).third);
};
_.hashCode_1 = function hashCode_72() {
    return hashCode_47(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        this.first,
        this.second,
        this.third
    ]));
};
_.toString_0 = function toString_119() {
    return '(' + this.first + ', ' + this.second + ', ' + this.third + ')';
};
var Lorg_eclipse_elk_core_util_Triple_2_classLit = createForClass('org.eclipse.elk.core.util', 'Triple', 239);
function $clinit_ElkGraphAdapters() {
    $clinit_ElkGraphAdapters = emptyMethod;
    DEFAULT_PORTLIST_SORTER_0 = new ElkGraphAdapters$PortComparator;
}
var DEFAULT_PORTLIST_SORTER_0;
function $clinit_ElkGraphAdapters$AbstractElkGraphElementAdapter() {
    $clinit_ElkGraphAdapters$AbstractElkGraphElementAdapter = emptyMethod;
    OFFSET_PROXY = new Property_2(($clinit_CoreOptions(), PORT_BORDER_OFFSET_0), 0);
}
defineClass(547, 1, {});
_.getPosition = function getPosition_1() {
    return new KVector_1(this.element.x_0, this.element.y_0);
};
_.getProperty = function getProperty_2(prop) {
    if ($equals_10(prop, ($clinit_CoreOptions(), PORT_BORDER_OFFSET_0))) return $getProperty_0(this.element, OFFSET_PROXY);
    return $getProperty_0(this.element, prop);
};
_.getSize = function getSize_3() {
    return new KVector_1(this.element.width_0, this.element.height);
};
_.getVolatileId = function getVolatileId_1() {
    return this.id_0;
};
_.hasProperty = function hasProperty_2(prop) {
    return $hasProperty_0(this.element, prop);
};
_.setPosition = function setPosition_1(pos) {
    $setX_1(this.element, pos.x_0);
    $setY_2(this.element, pos.y_0);
};
_.setSize = function setSize_1(size_0) {
    $setWidth_0(this.element, size_0.x_0);
    $setHeight_0(this.element, size_0.y_0);
};
_.setVolatileId = function setVolatileId_1(volatileId) {
    this.id_0 = volatileId;
};
_.id_0 = 0;
var OFFSET_PROXY;
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$AbstractElkGraphElementAdapter_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/AbstractElkGraphElementAdapter', 547);
function ElkGraphAdapters$ElkEdgeAdapter(edge) {
    this.element = edge;
}
defineClass(548, 1, {
    832: 1
}, ElkGraphAdapters$ElkEdgeAdapter);
_.getLabels = function getLabels_2() {
    var l, l$iterator;
    if (!this.labelAdapters) {
        this.labelAdapters = newArrayListWithExpectedSize($getLabels_1(this.element).size_0);
        for(l$iterator = new AbstractEList$EIterator($getLabels_1(this.element)); l$iterator.cursor != l$iterator.this$01_2.size_1();){
            l = castTo($doNext(l$iterator), 153);
            $add_3(this.labelAdapters, new ElkGraphAdapters$ElkLabelAdapter(l));
        }
    }
    return this.labelAdapters;
};
_.labelAdapters = null;
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$ElkEdgeAdapter_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/ElkEdgeAdapter', 548);
function $getNodes(this$static) {
    var n, n$iterator;
    if (!this$static.childNodes) {
        this$static.childNodes = newArrayListWithExpectedSize($getChildren(castTo(this$static.element, 27)).size_0);
        for(n$iterator = new AbstractEList$EIterator($getChildren(castTo(this$static.element, 27))); n$iterator.cursor != n$iterator.this$01_2.size_1();){
            n = castTo($doNext(n$iterator), 27);
            $add_3(this$static.childNodes, new ElkGraphAdapters$ElkNodeAdapter(this$static, n));
        }
    }
    return this$static.childNodes;
}
function ElkGraphAdapters$ElkGraphAdapter(node) {
    $clinit_ElkGraphAdapters$AbstractElkGraphElementAdapter();
    this.element = node;
}
defineClass(287, 547, {}, ElkGraphAdapters$ElkGraphAdapter);
_.getNodes = function getNodes_0() {
    return $getNodes(this);
};
_.childNodes = null;
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$ElkGraphAdapter_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/ElkGraphAdapter', 287);
function ElkGraphAdapters$ElkLabelAdapter(label_0) {
    $clinit_ElkGraphAdapters$AbstractElkGraphElementAdapter();
    this.element = label_0;
}
defineClass(625, 547, {
    187: 1
}, ElkGraphAdapters$ElkLabelAdapter);
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$ElkLabelAdapter_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/ElkLabelAdapter', 625);
function $getLabels(this$static) {
    var l, l$iterator;
    if (!this$static.labelAdapters) {
        this$static.labelAdapters = newArrayListWithExpectedSize(castTo(this$static.element, 27).getLabels_0().size_0);
        for(l$iterator = new AbstractEList$EIterator(castTo(this$static.element, 27).getLabels_0()); l$iterator.cursor != l$iterator.this$01_2.size_1();){
            l = castTo($doNext(l$iterator), 153);
            $add_3(this$static.labelAdapters, new ElkGraphAdapters$ElkLabelAdapter(l));
        }
    }
    return this$static.labelAdapters;
}
function $getPorts_2(this$static) {
    var p, p$iterator;
    if (!this$static.portAdapters) {
        this$static.portAdapters = newArrayListWithExpectedSize($getPorts_3(castTo(this$static.element, 27)).size_0);
        for(p$iterator = new AbstractEList$EIterator($getPorts_3(castTo(this$static.element, 27))); p$iterator.cursor != p$iterator.this$01_2.size_1();){
            p = castTo($doNext(p$iterator), 124);
            $add_3(this$static.portAdapters, new ElkGraphAdapters$ElkPortAdapter(p));
        }
    }
    return this$static.portAdapters;
}
function $sortPortList_1(this$static, comparator) {
    $isOrderFixed(castTo(castTo(this$static.element, 27).getProperty(($clinit_CoreOptions(), PORT_CONSTRAINTS_1)), 100)) && sort_14($getPorts_3(castTo(this$static.element, 27)), comparator);
}
function ElkGraphAdapters$ElkNodeAdapter(parent_0, node) {
    $clinit_ElkGraphAdapters$AbstractElkGraphElementAdapter();
    this.element = node;
    this.parentGraphAdapter = parent_0;
}
defineClass(624, 547, {
    680: 1
}, ElkGraphAdapters$ElkNodeAdapter);
_.getLabels = function getLabels_3() {
    return $getLabels(this);
};
_.getMargin = function getMargin_0() {
    var margins;
    return margins = castTo($getProperty_0(this.element, ($clinit_CoreOptions(), MARGINS_0)), 139), !margins && (margins = new ElkMargin), margins;
};
_.getPorts = function getPorts_0() {
    return $getPorts_2(this);
};
_.setMargin = function setMargin_0(margin) {
    var newMargin;
    newMargin = new ElkMargin_2(margin);
    $setProperty_1(this.element, ($clinit_CoreOptions(), MARGINS_0), newMargin);
};
_.setPadding = function setPadding_0(padding) {
    $setProperty_1(this.element, ($clinit_CoreOptions(), PADDING_5), new ElkPadding_1(padding));
};
_.getGraph = function getGraph_0() {
    return this.parentGraphAdapter;
};
_.getIncomingEdges = function getIncomingEdges_1() {
    var e, e$iterator;
    if (!this.incomingEdgeAdapters) {
        this.incomingEdgeAdapters = new ArrayList;
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2(allIncomingEdges(castTo(this.element, 27)).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 85);
            $add_3(this.incomingEdgeAdapters, new ElkGraphAdapters$ElkEdgeAdapter(e));
        }
    }
    return this.incomingEdgeAdapters;
};
_.getOutgoingEdges = function getOutgoingEdges_1() {
    var e, e$iterator;
    if (!this.outgoingEdgeAdapters) {
        this.outgoingEdgeAdapters = new ArrayList;
        for(e$iterator = new Iterators$ConcatenatedIterator(transform_2(allOutgoingEdges(castTo(this.element, 27)).val$inputs1.iterator_0(), new Iterables$10)); $hasNext_1(e$iterator);){
            e = castTo($next_0(e$iterator), 85);
            $add_3(this.outgoingEdgeAdapters, new ElkGraphAdapters$ElkEdgeAdapter(e));
        }
    }
    return this.outgoingEdgeAdapters;
};
_.isCompoundNode = function isCompoundNode_0() {
    return $getChildren(castTo(this.element, 27)).size_0 != 0 || $booleanValue(castToBoolean(castTo(this.element, 27).getProperty(($clinit_CoreOptions(), INSIDE_SELF_LOOPS_ACTIVATE_0))));
};
_.sortPortList = function sortPortList_0() {
    $sortPortList_1(this, ($clinit_ElkGraphAdapters(), DEFAULT_PORTLIST_SORTER_0));
};
_.incomingEdgeAdapters = null;
_.labelAdapters = null;
_.outgoingEdgeAdapters = null;
_.parentGraphAdapter = null;
_.portAdapters = null;
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$ElkNodeAdapter_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/ElkNodeAdapter', 624);
function $getLabels_0(this$static) {
    var l, l$iterator;
    if (!this$static.labelAdapters) {
        this$static.labelAdapters = newArrayListWithExpectedSize(castTo(this$static.element, 124).getLabels_0().size_0);
        for(l$iterator = new AbstractEList$EIterator(castTo(this$static.element, 124).getLabels_0()); l$iterator.cursor != l$iterator.this$01_2.size_1();){
            l = castTo($doNext(l$iterator), 153);
            $add_3(this$static.labelAdapters, new ElkGraphAdapters$ElkLabelAdapter(l));
        }
    }
    return this$static.labelAdapters;
}
function ElkGraphAdapters$ElkPortAdapter(port) {
    this.element = port;
}
defineClass(1244, 547, {
    831: 1
}, ElkGraphAdapters$ElkPortAdapter);
_.getLabels = function getLabels_4() {
    return $getLabels_0(this);
};
_.getIncomingEdges = function getIncomingEdges_2() {
    var e, e$iterator;
    if (!this.incomingEdgeAdapters) {
        this.incomingEdgeAdapters = newArrayListWithCapacity(castTo(this.element, 124).getIncomingEdges_0().size_0);
        for(e$iterator = new AbstractEList$EIterator(castTo(this.element, 124).getIncomingEdges_0()); e$iterator.cursor != e$iterator.this$01_2.size_1();){
            e = castTo($doNext(e$iterator), 85);
            $add_3(this.incomingEdgeAdapters, new ElkGraphAdapters$ElkEdgeAdapter(e));
        }
    }
    return this.incomingEdgeAdapters;
};
_.getOutgoingEdges = function getOutgoingEdges_2() {
    var e, e$iterator;
    if (!this.outgoingEdgeAdapters) {
        this.outgoingEdgeAdapters = newArrayListWithCapacity(castTo(this.element, 124).getOutgoingEdges_0().size_0);
        for(e$iterator = new AbstractEList$EIterator(castTo(this.element, 124).getOutgoingEdges_0()); e$iterator.cursor != e$iterator.this$01_2.size_1();){
            e = castTo($doNext(e$iterator), 85);
            $add_3(this.outgoingEdgeAdapters, new ElkGraphAdapters$ElkEdgeAdapter(e));
        }
    }
    return this.outgoingEdgeAdapters;
};
_.getSide = function getSide_0() {
    return castTo(castTo(this.element, 124).getProperty(($clinit_CoreOptions(), PORT_SIDE_0)), 64);
};
_.hasCompoundConnections = function hasCompoundConnections_0() {
    var edge, edge$iterator, edge$iterator0, node, source, source$iterator, target, target$iterator;
    node = $getParent_3(castTo(this.element, 124));
    for(edge$iterator0 = new AbstractEList$EIterator(castTo(this.element, 124).getOutgoingEdges_0()); edge$iterator0.cursor != edge$iterator0.this$01_2.size_1();){
        edge = castTo($doNext(edge$iterator0), 85);
        for(target$iterator = new AbstractEList$EIterator((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets)); target$iterator.cursor != target$iterator.this$01_2.size_1();){
            target = castTo($doNext(target$iterator), 84);
            if (isDescendant_0(connectableShapeToNode(target), node)) return true;
            else if (connectableShapeToNode(target) == node && $booleanValue(castToBoolean($getProperty_0(edge, ($clinit_CoreOptions(), INSIDE_SELF_LOOPS_YO_0))))) return true;
        }
    }
    for(edge$iterator = new AbstractEList$EIterator(castTo(this.element, 124).getIncomingEdges_0()); edge$iterator.cursor != edge$iterator.this$01_2.size_1();){
        edge = castTo($doNext(edge$iterator), 85);
        for(source$iterator = new AbstractEList$EIterator((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources)); source$iterator.cursor != source$iterator.this$01_2.size_1();){
            source = castTo($doNext(source$iterator), 84);
            if (isDescendant_0(connectableShapeToNode(source), node)) return true;
        }
    }
    return false;
};
_.incomingEdgeAdapters = null;
_.labelAdapters = null;
_.outgoingEdgeAdapters = null;
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$ElkPortAdapter_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/ElkPortAdapter', 1244);
function $compare_23(port1, port2) {
    var index1, index2, indexDifference, ordinalDifference;
    ordinalDifference = castTo($getProperty_0(port1, ($clinit_CoreOptions(), PORT_SIDE_0)), 64).ordinal - castTo($getProperty_0(port2, PORT_SIDE_0), 64).ordinal;
    if (ordinalDifference != 0) return ordinalDifference;
    index1 = castTo($getProperty_0(port1, PORT_INDEX_0), 17);
    index2 = castTo($getProperty_0(port2, PORT_INDEX_0), 17);
    if (!!index1 && !!index2) {
        indexDifference = index1.value_0 - index2.value_0;
        if (indexDifference != 0) return indexDifference;
    }
    switch(castTo($getProperty_0(port1, PORT_SIDE_0), 64).ordinal){
        case 1:
            return compare_4(port1.x_0, port2.x_0);
        case 2:
            return compare_4(port1.y_0, port2.y_0);
        case 3:
            return compare_4(port2.x_0, port1.x_0);
        case 4:
            return compare_4(port2.y_0, port1.y_0);
        default:
            throw toJs(new IllegalStateException_0('Port side is undefined'));
    }
}
function ElkGraphAdapters$PortComparator() {}
defineClass(1245, 1, $intern_88, ElkGraphAdapters$PortComparator);
_.compare_1 = function compare_108(port1, port2) {
    return $compare_23(castTo(port1, 124), castTo(port2, 124));
};
_.equals_0 = function equals_204(other) {
    return this === other;
};
_.reversed = function reversed_100() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_core_util_adapters_ElkGraphAdapters$PortComparator_2_classLit = createForClass('org.eclipse.elk.core.util.adapters', 'ElkGraphAdapters/PortComparator', 1245);
var Lorg_eclipse_emf_ecore_EObject_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EObject');
var Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit = createForInterface('org.eclipse.elk.graph', 'EMapPropertyHolder');
var Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkBendPoint');
var Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkGraphElement');
var Lorg_eclipse_elk_graph_ElkShape_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkShape');
var Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkConnectableShape');
var Lorg_eclipse_elk_graph_ElkEdge_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkEdge');
var Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkEdgeSection');
var Lorg_eclipse_emf_ecore_EModelElement_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EModelElement');
var Lorg_eclipse_emf_ecore_EFactory_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EFactory');
function $clinit_ElkGraphFactory() {
    $clinit_ElkGraphFactory = emptyMethod;
    eINSTANCE = init_1();
}
var eINSTANCE;
var Lorg_eclipse_emf_ecore_ENamedElement_2_classLit = createForInterface('org.eclipse.emf.ecore', 'ENamedElement');
var Lorg_eclipse_emf_ecore_EPackage_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EPackage');
function $clinit_ElkGraphPackage() {
    $clinit_ElkGraphPackage = emptyMethod;
    eINSTANCE_0 = init_2();
}
var eINSTANCE_0;
function $clinit_ElkGraphPackage$Literals() {
    $clinit_ElkGraphPackage$Literals = emptyMethod;
    $clinit_ElkGraphPackage();
    EMAP_PROPERTY_HOLDER = eINSTANCE_0.eMapPropertyHolderEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.eMapPropertyHolderEClass), 0), 19);
    ELK_GRAPH_ELEMENT = eINSTANCE_0.elkGraphElementEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkGraphElementEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkGraphElementEClass), 1), 35);
    ELK_SHAPE = eINSTANCE_0.elkShapeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkShapeEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkShapeEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkShapeEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkShapeEClass), 3), 35);
    ELK_LABEL = eINSTANCE_0.elkLabelEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkLabelEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkLabelEClass), 1), 35);
    ELK_CONNECTABLE_SHAPE = eINSTANCE_0.elkConnectableShapeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkConnectableShapeEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkConnectableShapeEClass), 1), 19);
    ELK_NODE = eINSTANCE_0.elkNodeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkNodeEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkNodeEClass), 1), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkNodeEClass), 2), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkNodeEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkNodeEClass), 4), 35);
    ELK_PORT = eINSTANCE_0.elkPortEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkPortEClass), 0), 19);
    ELK_EDGE = eINSTANCE_0.elkEdgeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 1), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 2), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 4), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 5), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 6), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeEClass), 7), 35);
    ELK_BEND_POINT = eINSTANCE_0.elkBendPointEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkBendPointEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkBendPointEClass), 1), 35);
    ELK_EDGE_SECTION = eINSTANCE_0.elkEdgeSectionEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 3), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 4), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 5), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 6), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 7), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 8), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 9), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkEdgeSectionEClass), 10), 35);
    ELK_PROPERTY_TO_VALUE_MAP_ENTRY = eINSTANCE_0.elkPropertyToValueMapEntryEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkPropertyToValueMapEntryEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_0.elkPropertyToValueMapEntryEClass), 1), 35);
}
var ELK_BEND_POINT, ELK_CONNECTABLE_SHAPE, ELK_EDGE, ELK_EDGE_SECTION, ELK_GRAPH_ELEMENT, ELK_LABEL, ELK_NODE, ELK_PORT, ELK_PROPERTY_TO_VALUE_MAP_ENTRY, ELK_SHAPE, EMAP_PROPERTY_HOLDER;
var Lorg_eclipse_elk_graph_ElkLabel_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkLabel');
var Lorg_eclipse_elk_graph_ElkNode_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkNode');
var Lorg_eclipse_elk_graph_ElkPort_2_classLit = createForInterface('org.eclipse.elk.graph', 'ElkPort');
function $eNotify(this$static, notification) {
    var eAdapters, i, size_0;
    eAdapters = this$static.eBasicAdapterArray();
    if (eAdapters != null && this$static.eDeliver()) for(i = 0, size_0 = eAdapters.length; i < size_0; ++i)eAdapters[i].notifyChanged(notification);
}
defineClass(92, 1, $intern_136);
_.eBasicAdapterArray = function eBasicAdapterArray() {
    this.eBasicAdapters();
    return null;
};
_.eBasicAdapters = function eBasicAdapters() {
    return null;
};
_.eBasicHasAdapters = function eBasicHasAdapters() {
    return this.eBasicAdapters(), false;
};
_.eDeliver = function eDeliver() {
    return false;
};
_.eNotify = function eNotify(notification) {
    $eNotify(this, notification);
};
var Lorg_eclipse_emf_common_notify_impl_BasicNotifierImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'BasicNotifierImpl', 92);
function $eAttribute(eClass, name_0) {
    var eStructuralFeature;
    eStructuralFeature = $getEStructuralFeature_0(eClass, name_0);
    if (instanceOf(eStructuralFeature, 330)) return castTo(eStructuralFeature, 35);
    throw toJs(new IllegalArgumentException_0("The feature '" + name_0 + "' is not a valid attribute"));
}
function $eBasicSetContainer(this$static, newContainer, newContainerFeatureID, msgs) {
    var newResource, notification, oldContainer, oldContainerFeatureID, oldResource;
    oldContainer = this$static.eInternalContainer();
    oldResource = this$static.eDirectResource();
    newResource = null;
    if (oldResource) {
        if (!!newContainer && (eContainmentFeature(this$static, newContainer, newContainerFeatureID).eFlags & $intern_64) == 0) {
            msgs = $basicRemove_0(oldResource.getContents(), this$static, msgs);
            this$static.eSetDirectResource(null);
            newResource = newContainer.eInternalResource();
        } else oldResource = null;
    } else {
        !!oldContainer && (oldResource = oldContainer.eInternalResource());
        !!newContainer && (newResource = newContainer.eInternalResource());
    }
    oldResource != newResource && !!oldResource && oldResource.detached(this$static);
    oldContainerFeatureID = this$static.eContainerFeatureID_0();
    this$static.eBasicSetContainer(newContainer, newContainerFeatureID);
    oldResource != newResource && !!newResource && newResource.attached(this$static);
    if (this$static.eBasicHasAdapters() && this$static.eDeliver()) {
        if (!!oldContainer && oldContainerFeatureID >= 0 && oldContainerFeatureID != newContainerFeatureID) {
            notification = new ENotificationImpl_1(this$static, 1, oldContainerFeatureID, oldContainer, null);
            !msgs ? msgs = notification : msgs.add_5(notification);
        }
        if (newContainerFeatureID >= 0) {
            notification = new ENotificationImpl_1(this$static, 1, newContainerFeatureID, oldContainerFeatureID == newContainerFeatureID ? oldContainer : null, newContainer);
            !msgs ? msgs = notification : msgs.add_5(notification);
        }
    }
    return msgs;
}
function $eContainer(this$static) {
    var eContainerFeatureID, eContainerFeatureID0, notificationChain, resolved, result;
    result = this$static.eInternalContainer();
    if (result) {
        if (result.eIsProxy()) {
            resolved = $eResolveProxy(this$static, result);
            if (resolved != result) {
                eContainerFeatureID0 = this$static.eContainerFeatureID_0();
                notificationChain = (eContainerFeatureID = this$static.eContainerFeatureID_0(), eContainerFeatureID >= 0 ? this$static.eBasicRemoveFromContainerFeature(null) : this$static.eInternalContainer().eInverseRemove(this$static, -1 - eContainerFeatureID, null, null));
                this$static.eBasicSetContainer(castTo(resolved, 52), eContainerFeatureID0);
                !!notificationChain && notificationChain.dispatch_0();
                this$static.eBasicHasAdapters() && this$static.eDeliver() && eContainerFeatureID0 > -1 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, eContainerFeatureID0, result, resolved));
                return resolved;
            }
        }
    }
    return result;
}
function $eDynamicGet(this$static, dynamicFeatureID, eFeature, resolve, coreType) {
    return dynamicFeatureID < 0 ? $eOpenGet(this$static, eFeature, resolve) : castTo(eFeature, 69).getSettingDelegate().dynamicGet_0(this$static, this$static.eSettings_0(), dynamicFeatureID, resolve, coreType);
}
function $eDynamicIsSet(this$static, dynamicFeatureID, eFeature) {
    return dynamicFeatureID < 0 ? $eOpenIsSet(this$static, eFeature) : castTo(eFeature, 69).getSettingDelegate().dynamicIsSet(this$static, this$static.eSettings_0(), dynamicFeatureID);
}
function $eDynamicSet(this$static, dynamicFeatureID, eFeature, newValue) {
    if (dynamicFeatureID < 0) $eOpenSet(this$static, eFeature, newValue);
    else {
        if (!eFeature.isChangeable()) throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
        castTo(eFeature, 69).getSettingDelegate().dynamicSet_0(this$static, this$static.eSettings_0(), dynamicFeatureID, newValue);
    }
}
function $eDynamicUnset(this$static, dynamicFeatureID, eFeature) {
    if (dynamicFeatureID < 0) $eOpenUnset(this$static, eFeature);
    else {
        if (!eFeature.isChangeable()) throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
        castTo(eFeature, 69).getSettingDelegate().dynamicUnset_0(this$static, this$static.eSettings_0(), dynamicFeatureID);
    }
}
function $eGet(this$static, featureID0, resolve, coreType) {
    var dynamicFeatureID, eFeature, featureID;
    eFeature = $getEStructuralFeature(this$static.eClass_0(), featureID0);
    dynamicFeatureID = featureID0 - this$static.eStaticFeatureCount();
    return dynamicFeatureID < 0 ? (featureID = this$static.eDerivedStructuralFeatureID_0(eFeature), featureID >= 0 ? this$static.eGet(featureID, resolve, true) : $eOpenGet(this$static, eFeature, resolve)) : castTo(eFeature, 69).getSettingDelegate().dynamicGet_0(this$static, this$static.eSettings_0(), dynamicFeatureID, resolve, coreType);
}
function $eGet_0(this$static, eFeature) {
    var featureID;
    return featureID = this$static.eDerivedStructuralFeatureID_0(eFeature), featureID >= 0 ? this$static.eGet(featureID, true, true) : $eOpenGet(this$static, eFeature, true);
}
function $eGet_1(this$static, eFeature, resolve) {
    var featureID;
    return featureID = this$static.eDerivedStructuralFeatureID_0(eFeature), featureID >= 0 ? this$static.eGet(featureID, resolve, true) : $eOpenGet(this$static, eFeature, resolve);
}
function $eGet_2(this$static, eFeature) {
    var featureID;
    featureID = $getFeatureID(this$static.eClass, eFeature);
    return featureID >= 0 ? $eGet(this$static, featureID, true, true) : $eOpenGet(this$static, eFeature, true);
}
function $eInternalResource(this$static) {
    var count, eContainer, result;
    result = this$static.eDirectResource();
    if (!result) {
        count = 0;
        for(eContainer = this$static.eInternalContainer(); eContainer; eContainer = eContainer.eInternalContainer()){
            if (++count > $intern_67) return eContainer.eInternalResource();
            result = eContainer.eDirectResource();
            if (!!result || eContainer == this$static) break;
        }
    }
    return result;
}
function $eInverseAdd(this$static, otherEnd, featureID, msgs) {
    var eContainerFeatureID;
    if (featureID >= 0) return this$static.eInverseAdd_0(otherEnd, featureID, msgs);
    else {
        !!this$static.eInternalContainer() && (msgs = (eContainerFeatureID = this$static.eContainerFeatureID_0(), eContainerFeatureID >= 0 ? this$static.eBasicRemoveFromContainerFeature(msgs) : this$static.eInternalContainer().eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        return this$static.eBasicSetContainer_0(otherEnd, featureID, msgs);
    }
}
function $eInverseRemove(this$static, otherEnd, featureID, msgs) {
    return featureID >= 0 ? this$static.eInverseRemove_0(otherEnd, featureID, msgs) : this$static.eBasicSetContainer_0(null, featureID, msgs);
}
function $eIsSet(this$static, featureID0) {
    var dynamicFeatureID, eFeature, featureID;
    eFeature = $getEStructuralFeature(this$static.eClass_0(), featureID0);
    dynamicFeatureID = featureID0 - this$static.eStaticFeatureCount();
    return dynamicFeatureID < 0 ? (featureID = this$static.eDerivedStructuralFeatureID_0(eFeature), featureID >= 0 ? this$static.eIsSet(featureID) : $eOpenIsSet(this$static, eFeature)) : dynamicFeatureID < 0 ? $eOpenIsSet(this$static, eFeature) : castTo(eFeature, 69).getSettingDelegate().dynamicIsSet(this$static, this$static.eSettings_0(), dynamicFeatureID);
}
function $eIsSet_0(this$static, eFeature) {
    var featureID;
    featureID = this$static.eDerivedStructuralFeatureID_0(eFeature);
    return featureID >= 0 ? this$static.eIsSet(featureID) : $eOpenIsSet(this$static, eFeature);
}
function $eNotificationRequired(this$static) {
    return this$static.eBasicHasAdapters() && this$static.eDeliver();
}
function $eObjectForURIFragmentPredicate(this$static, predicate, eReference) {
    var eAttribute, eDataType, eFactory, eReferenceType, end, featureMapEntries, i, index_0, length_0, values;
    featureMapEntries = new ArrayList;
    length_0 = predicate.length;
    eReferenceType = $getEReferenceType(eReference);
    for(i = 0; i < length_0; ++i){
        index_0 = $indexOf_2(predicate, fromCodePoint(61), i);
        eAttribute = $eAttribute(eReferenceType, (checkCriticalStringBounds(i, index_0, predicate.length), predicate.substr(i, index_0 - i)));
        eDataType = $getEAttributeType(eAttribute);
        eFactory = eDataType.getEPackage().getEFactoryInstance();
        switch($charAt(predicate, ++index_0)){
            case 39:
                end = $indexOf_0(predicate, 39, ++index_0);
                $add_3(featureMapEntries, new BasicEObjectImpl$1(eAttribute, eDecodeValue((checkCriticalStringBounds(index_0, end, predicate.length), predicate.substr(index_0, end - index_0)), eFactory, eDataType)));
                i = end + 1;
                break;
            case 34:
                end = $indexOf_0(predicate, 34, ++index_0);
                $add_3(featureMapEntries, new BasicEObjectImpl$1(eAttribute, eDecodeValue((checkCriticalStringBounds(index_0, end, predicate.length), predicate.substr(index_0, end - index_0)), eFactory, eDataType)));
                i = end + 1;
                break;
            case 91:
                values = new ArrayList;
                $add_3(featureMapEntries, new BasicEObjectImpl$1(eAttribute, values));
                LOOP: for(;;){
                    switch($charAt(predicate, ++index_0)){
                        case 39:
                            end = $indexOf_0(predicate, 39, ++index_0);
                            $add_3(values, eDecodeValue((checkCriticalStringBounds(index_0, end, predicate.length), predicate.substr(index_0, end - index_0)), eFactory, eDataType));
                            index_0 = end + 1;
                            break;
                        case 34:
                            end = $indexOf_0(predicate, 34, ++index_0);
                            $add_3(values, eDecodeValue((checkCriticalStringBounds(index_0, end, predicate.length), predicate.substr(index_0, end - index_0)), eFactory, eDataType));
                            index_0 = end + 1;
                            break;
                        case 110:
                            ++index_0;
                            if (predicate.indexOf('ull', index_0) == index_0) values.array.push(null);
                            else throw toJs(new RuntimeException_0('Expecting null'));
                            index_0 += 3;
                            break;
                    }
                    if (index_0 < length_0) switch(checkCriticalStringElementIndex(index_0, predicate.length), predicate.charCodeAt(index_0)){
                        case 44:
                            break;
                        case 93:
                            break LOOP;
                        default:
                            throw toJs(new RuntimeException_0('Expecting , or ]'));
                    }
                    else break;
                }
                i = index_0 + 1;
                break;
            case 110:
                ++index_0;
                if (predicate.indexOf('ull', index_0) == index_0) $add_3(featureMapEntries, new BasicEObjectImpl$1(eAttribute, null));
                else throw toJs(new RuntimeException_0('Expecting null'));
                i = index_0 + 3;
                break;
        }
        if (i < length_0) {
            checkCriticalStringElementIndex(i, predicate.length);
            if (predicate.charCodeAt(i) != 44) throw toJs(new RuntimeException_0('Expecting ,'));
        } else break;
    }
    return $eObjectForURIFragmentPredicate_0(this$static, featureMapEntries, eReference);
}
function $eObjectForURIFragmentPredicate_0(this$static, predicate, eReference) {
    var actualValue, eObject, eObject$iterator, entry, entryFeature, entryValue, featureID, i, list, size_0;
    size_0 = predicate.array.length;
    list = (featureID = this$static.eDerivedStructuralFeatureID_0(eReference), castTo(featureID >= 0 ? this$static.eGet(featureID, false, true) : $eOpenGet(this$static, eReference, false), 61));
    LOOP: for(eObject$iterator = list.iterator_0(); eObject$iterator.hasNext_0();){
        eObject = castTo(eObject$iterator.next_1(), 57);
        for(i = 0; i < size_0; ++i){
            entry = (checkCriticalElementIndex(i, predicate.array.length), castTo(predicate.array[i], 74));
            entryValue = entry.getValue();
            entryFeature = entry.getEStructuralFeature();
            actualValue = eObject.eGet_1(entryFeature, false);
            if (entryValue == null ? actualValue != null : !equals_Ljava_lang_Object__Z__devirtual$(entryValue, actualValue)) continue LOOP;
        }
        return eObject;
    }
    return null;
}
function $eObjectForURIFragmentSegment(this$static, uriFragmentSegment) {
    var dotIndex, eList, eReference, exception, index_0, lastChar, lastIndex, position, predicate, result;
    lastIndex = uriFragmentSegment.length - 1;
    lastChar = (checkCriticalStringElementIndex(lastIndex, uriFragmentSegment.length), uriFragmentSegment.charCodeAt(lastIndex));
    if (lastChar == 93) {
        index_0 = $indexOf_1(uriFragmentSegment, fromCodePoint(91));
        if (index_0 >= 0) {
            eReference = $eReference(this$static, (checkCriticalStringBounds(1, index_0, uriFragmentSegment.length), uriFragmentSegment.substr(1, index_0 - 1)));
            predicate = (checkCriticalStringBounds(index_0 + 1, lastIndex, uriFragmentSegment.length), uriFragmentSegment.substr(index_0 + 1, lastIndex - (index_0 + 1)));
            return $eObjectForURIFragmentPredicate(this$static, predicate, eReference);
        }
    } else {
        dotIndex = -1;
        digitRegex == null && (digitRegex = new RegExp('\\d'));
        if (digitRegex.test(String.fromCharCode(lastChar))) {
            dotIndex = $lastIndexOf_0(uriFragmentSegment, fromCodePoint(46), lastIndex - 1);
            if (dotIndex >= 0) {
                eList = castTo($eGet_1(this$static, $eStructuralFeature(this$static, (checkCriticalStringBounds(1, dotIndex, uriFragmentSegment.length), uriFragmentSegment.substr(1, dotIndex - 1))), false), 61);
                position = 0;
                try {
                    position = __parseAndValidateInt((checkCriticalStringElementIndex(dotIndex + 1, uriFragmentSegment.length + 1), uriFragmentSegment.substr(dotIndex + 1)), $intern_42, $intern_0);
                } catch ($e0) {
                    $e0 = toJava($e0);
                    if (instanceOf($e0, 130)) {
                        exception = $e0;
                        throw toJs(new WrappedException(exception));
                    } else throw toJs($e0);
                }
                if (position < eList.size_1()) {
                    result = eList.get_0(position);
                    instanceOf(result, 74) && (result = castTo(result, 74).getValue());
                    return castTo(result, 57);
                }
            }
        }
        if (dotIndex < 0) return castTo($eGet_1(this$static, $eStructuralFeature(this$static, (checkCriticalStringElementIndex(1, uriFragmentSegment.length + 1), uriFragmentSegment.substr(1))), false), 57);
    }
    return null;
}
function $eOpenGet(this$static, eFeature, resolve) {
    var featureID, featureMap, openFeature;
    openFeature = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), this$static.eClass_0(), eFeature);
    if (openFeature) {
        $clinit_FeatureMapUtil();
        castTo(openFeature, 69).isFeatureMap_0() || (openFeature = $getGroup($getExtendedMetaData_1(INSTANCE_11, openFeature)));
        featureMap = (featureID = this$static.eDerivedStructuralFeatureID_0(openFeature), castTo(featureID >= 0 ? this$static.eGet(featureID, true, true) : $eOpenGet(this$static, openFeature, true), 159));
        return castTo(featureMap, 218).get_7(eFeature, resolve);
    } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid feature"));
}
function $eOpenIsSet(this$static, eFeature) {
    var featureID, featureMap, openFeature;
    openFeature = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), this$static.eClass_0(), eFeature);
    if (openFeature) {
        $clinit_FeatureMapUtil();
        castTo(openFeature, 69).isFeatureMap_0() || (openFeature = $getGroup($getExtendedMetaData_1(INSTANCE_11, openFeature)));
        featureMap = (featureID = this$static.eDerivedStructuralFeatureID_0(openFeature), castTo(featureID >= 0 ? this$static.eGet(featureID, true, true) : $eOpenGet(this$static, openFeature, true), 159));
        return castTo(featureMap, 218).isSet_1(eFeature);
    } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid feature"));
}
function $eOpenSet(this$static, eFeature, newValue) {
    var featureID, featureMap, openFeature;
    openFeature = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), this$static.eClass_0(), eFeature);
    if (openFeature) {
        $clinit_FeatureMapUtil();
        if (!castTo(openFeature, 69).isFeatureMap_0()) {
            openFeature = $getGroup($getExtendedMetaData_1(INSTANCE_11, openFeature));
            if (!openFeature) throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
        }
        featureMap = (featureID = this$static.eDerivedStructuralFeatureID_0(openFeature), castTo(featureID >= 0 ? this$static.eGet(featureID, true, true) : $eOpenGet(this$static, openFeature, true), 159));
        castTo(featureMap, 218).set_3(eFeature, newValue);
    } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
}
function $eOpenUnset(this$static, eFeature) {
    var featureID, featureMap, openFeature;
    openFeature = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), this$static.eClass_0(), eFeature);
    if (openFeature) {
        $clinit_FeatureMapUtil();
        castTo(openFeature, 69).isFeatureMap_0() || (openFeature = $getGroup($getExtendedMetaData_1(INSTANCE_11, openFeature)));
        featureMap = (featureID = this$static.eDerivedStructuralFeatureID_0(openFeature), castTo(featureID >= 0 ? this$static.eGet(featureID, true, true) : $eOpenGet(this$static, openFeature, true), 159));
        castTo(featureMap, 218).unset_0(eFeature);
    } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
}
function $eReference(this$static, name_0) {
    var eStructuralFeature;
    eStructuralFeature = $getEStructuralFeature_0(this$static.eClass_0(), name_0);
    if (instanceOf(eStructuralFeature, 101)) return castTo(eStructuralFeature, 19);
    throw toJs(new IllegalArgumentException_0("The feature '" + name_0 + "' is not a valid reference"));
}
function $eResolveProxy(this$static, proxy) {
    var eResource, lastArg, resourceContext, result;
    result = (resourceContext = this$static ? $eInternalResource(this$static) : null, resolve_20((lastArg = proxy, resourceContext && resourceContext.getResourceSet(), lastArg)));
    if (result == proxy) {
        eResource = $eInternalResource(this$static);
        !!eResource && eResource.getResourceSet();
    }
    return result;
}
function $eSet(this$static, featureID0, newValue) {
    var dynamicFeatureID, eFeature, featureID;
    eFeature = $getEStructuralFeature(this$static.eClass_0(), featureID0);
    dynamicFeatureID = featureID0 - this$static.eStaticFeatureCount();
    if (dynamicFeatureID < 0) {
        if (!eFeature) throw toJs(new IllegalArgumentException_0('The feature ID' + featureID0 + ' is not a valid feature ID'));
        else if (eFeature.isChangeable()) {
            featureID = this$static.eDerivedStructuralFeatureID_0(eFeature);
            featureID >= 0 ? this$static.eSet(featureID, newValue) : $eOpenSet(this$static, eFeature, newValue);
        } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
    } else $eDynamicSet(this$static, dynamicFeatureID, eFeature, newValue);
}
function $eSet_0(this$static, eFeature, newValue) {
    var featureID;
    featureID = this$static.eDerivedStructuralFeatureID_0(eFeature);
    featureID >= 0 ? this$static.eSet(featureID, newValue) : $eOpenSet(this$static, eFeature, newValue);
}
function $eSettings(this$static) {
    var size_0;
    if (!this$static.eHasSettings()) {
        size_0 = $getFeatureCount(this$static.eClass_0()) - this$static.eStaticFeatureCount();
        this$static.eProperties_0().allocateSettings(size_0);
    }
    return this$static.eBasicProperties();
}
function $eStructuralFeature(this$static, name_0) {
    var eStructuralFeature;
    eStructuralFeature = $getEStructuralFeature_0(this$static.eClass_0(), name_0);
    if (!eStructuralFeature) throw toJs(new IllegalArgumentException_0("The feature '" + name_0 + "' is not a valid feature"));
    return eStructuralFeature;
}
function $eUnset(this$static, featureID0) {
    var dynamicFeatureID, eFeature, featureID;
    eFeature = $getEStructuralFeature(this$static.eClass_0(), featureID0);
    dynamicFeatureID = featureID0 - this$static.eStaticFeatureCount();
    if (dynamicFeatureID < 0) {
        if (!eFeature) throw toJs(new IllegalArgumentException_0('The feature ID' + featureID0 + ' is not a valid feature ID'));
        else if (eFeature.isChangeable()) {
            featureID = this$static.eDerivedStructuralFeatureID_0(eFeature);
            featureID >= 0 ? this$static.eUnset(featureID) : $eOpenUnset(this$static, eFeature);
        } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid changeable feature"));
    } else $eDynamicUnset(this$static, dynamicFeatureID, eFeature);
}
function $eUnset_0(this$static, eFeature) {
    var featureID;
    featureID = this$static.eDerivedStructuralFeatureID_0(eFeature);
    featureID >= 0 ? this$static.eUnset(featureID) : $eOpenUnset(this$static, eFeature);
}
function $toString_16(this$static) {
    var number, result;
    result = new StringBuilder_1($getName(this$static.___clazz));
    result.string += '@';
    $append_11(result, (number = hashCode__I__devirtual$(this$static) >>> 0, number.toString(16)));
    if (this$static.eIsProxy()) {
        result.string += ' (eProxyURI: ';
        $append_10(result, this$static.eProxyURI_0());
        if (this$static.eDynamicClass()) {
            result.string += ' eClass: ';
            $append_10(result, this$static.eDynamicClass());
        }
        result.string += ')';
    } else if (this$static.eDynamicClass()) {
        result.string += ' (eClass: ';
        $append_10(result, this$static.eDynamicClass());
        result.string += ')';
    }
    return result.string;
}
function eContainmentFeature(eObject, eContainer, eContainerFeatureID) {
    var eFeature, entryFeature, entryReference, featureMap, i, size_0;
    if (!eContainer) return null;
    else {
        if (eContainerFeatureID <= -1) {
            eFeature = $getEStructuralFeature(eContainer.eClass_0(), -1 - eContainerFeatureID);
            if (instanceOf(eFeature, 101)) return castTo(eFeature, 19);
            else {
                featureMap = castTo(eContainer.eGet_0(eFeature), 159);
                for(i = 0, size_0 = featureMap.size_1(); i < size_0; ++i)if (maskUndefined(featureMap.getValue_1(i)) === maskUndefined(eObject)) {
                    entryFeature = featureMap.getEStructuralFeature_0(i);
                    if (instanceOf(entryFeature, 101)) {
                        entryReference = castTo(entryFeature, 19);
                        if ((entryReference.eFlags & $intern_137) != 0) return entryReference;
                    }
                }
                throw toJs(new IllegalStateException_0('The containment feature could not be located'));
            }
        } else return $getEOpposite(castTo($getEStructuralFeature(eObject.eClass_0(), eContainerFeatureID), 19));
    }
}
function eDecodeValue(encodedValue, eFactory, eDataType) {
    var literal, value_0;
    literal = decode(encodedValue);
    value_0 = eFactory.createFromString(eDataType, literal);
    return value_0;
}
defineClass(98, 92, $intern_138);
_.eNotificationRequired = function eNotificationRequired() {
    return $eNotificationRequired(this);
};
_.eBaseStructuralFeatureID = function eBaseStructuralFeatureID(derivedFeatureID, baseClass) {
    return derivedFeatureID;
};
_.eBasicProperties = function eBasicProperties() {
    throw toJs(new UnsupportedOperationException);
};
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature(msgs) {
    var inverseFeature;
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature(this.eClass_0(), this.eContainerFeatureID_0()), 19)), this.eInternalContainer().eInverseRemove(this, inverseFeature.featureID, inverseFeature.containerClass, msgs);
};
_.eBasicSetContainer = function eBasicSetContainer(newContainer, newContainerFeatureID) {
    throw toJs(new UnsupportedOperationException);
};
_.eBasicSetContainer_0 = function eBasicSetContainer_0(newContainer, newContainerFeatureID, msgs) {
    return $eBasicSetContainer(this, newContainer, newContainerFeatureID, msgs);
};
_.eClass_0 = function eClass_0() {
    var result;
    if (this.eBasicProperties()) {
        result = this.eBasicProperties().getEClass();
        if (result) return result;
    }
    return this.eStaticClass();
};
_.eContainer_0 = function eContainer_0() {
    return $eContainer(this);
};
_.eContainerFeatureID_0 = function eContainerFeatureID_0() {
    throw toJs(new UnsupportedOperationException);
};
_.eContents_0 = function eContents_0() {
    var eStructuralFeatures, result;
    result = this.eProperties_0().getEContents();
    !result && this.eBasicProperties().setEContents(result = ($clinit_EContentsEList(), eStructuralFeatures = $containments($getEAllStructuralFeatures(this.eClass_0())), eStructuralFeatures == null ? EMPTY_CONTENTS_ELIST : new EContentsEList(this, eStructuralFeatures)));
    return result;
};
_.eDerivedStructuralFeatureID = function eDerivedStructuralFeatureID(baseFeatureID, baseClass) {
    return baseFeatureID;
};
_.eDerivedStructuralFeatureID_0 = function eDerivedStructuralFeatureID_0(eStructuralFeature) {
    var containerClass;
    containerClass = eStructuralFeature.getContainerClass();
    return !containerClass ? $getFeatureID(this.eClass_0(), eStructuralFeature) : eStructuralFeature.getFeatureID_0();
};
_.eDirectResource = function eDirectResource() {
    var eProperties;
    eProperties = this.eBasicProperties();
    return !eProperties ? null : eProperties.getEResource();
};
_.eDynamicClass = function eDynamicClass() {
    return !this.eBasicProperties() ? null : this.eBasicProperties().getEClass();
};
_.eGet = function eGet(featureID, resolve, coreType) {
    return $eGet(this, featureID, resolve, coreType);
};
_.eGet_0 = function eGet_0(eFeature) {
    return $eGet_0(this, eFeature);
};
_.eGet_1 = function eGet_1(eFeature, resolve) {
    return $eGet_1(this, eFeature, resolve);
};
_.eHasSettings = function eHasSettings() {
    var eProperties;
    eProperties = this.eBasicProperties();
    return !!eProperties && eProperties.hasSettings();
};
_.eInternalContainer = function eInternalContainer_0() {
    throw toJs(new UnsupportedOperationException);
};
_.eInternalResource = function eInternalResource() {
    return $eInternalResource(this);
};
_.eInverseAdd = function eInverseAdd(otherEnd, featureID, baseClass, msgs) {
    return $eInverseAdd(this, otherEnd, featureID, msgs);
};
_.eInverseAdd_0 = function eInverseAdd_0(otherEnd, featureID, msgs) {
    var feature;
    return feature = castTo($getEStructuralFeature(this.eClass_0(), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, this.eSettings_0(), featureID - this.eStaticFeatureCount(), otherEnd, msgs);
};
_.eInverseRemove = function eInverseRemove(otherEnd, featureID, baseClass, msgs) {
    return $eInverseRemove(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_0(otherEnd, featureID, msgs) {
    var feature;
    return feature = castTo($getEStructuralFeature(this.eClass_0(), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, this.eSettings_0(), featureID - this.eStaticFeatureCount(), otherEnd, msgs);
};
_.eIsProxy = function eIsProxy() {
    return !!this.eBasicProperties() && !!this.eBasicProperties().getEProxyURI();
};
_.eIsSet = function eIsSet(featureID) {
    return $eIsSet(this, featureID);
};
_.eIsSet_0 = function eIsSet_0(eFeature) {
    return $eIsSet_0(this, eFeature);
};
_.eObjectForURIFragmentSegment = function eObjectForURIFragmentSegment(uriFragmentSegment) {
    return $eObjectForURIFragmentSegment(this, uriFragmentSegment);
};
_.eProperties_0 = function eProperties_0() {
    throw toJs(new UnsupportedOperationException);
};
_.eProxyURI_0 = function eProxyURI_0() {
    return !this.eBasicProperties() ? null : this.eBasicProperties().getEProxyURI();
};
_.eResource_0 = function eResource_0() {
    return $eInternalResource(this);
};
_.eSet = function eSet(featureID, newValue) {
    $eSet(this, featureID, newValue);
};
_.eSetClass = function eSetClass(eClass) {
    this.eProperties_0().setEClass(eClass);
};
_.eSetDirectResource = function eSetDirectResource(resource) {
    this.eProperties_0().setEResource(resource);
};
_.eSetProxyURI = function eSetProxyURI(uri_0) {
    this.eProperties_0().setEProxyURI(uri_0);
};
_.eSetResource = function eSetResource(resource, notifications) {
    var eContainerFeatureID, oldContainer, oldContainerResource, oldResource;
    oldResource = this.eDirectResource();
    if (!!oldResource && !!resource) {
        notifications = $basicRemove_0(oldResource.getContents(), this, notifications);
        oldResource.detached(this);
    }
    oldContainer = this.eInternalContainer();
    if (oldContainer) {
        if ((eContainmentFeature(this, this.eInternalContainer(), this.eContainerFeatureID_0()).eFlags & $intern_64) != 0) {
            oldContainerResource = oldContainer.eInternalResource();
            !!oldContainerResource && (!resource ? oldContainerResource.attached(this) : !oldResource && oldContainerResource.detached(this));
        } else {
            notifications = (eContainerFeatureID = this.eContainerFeatureID_0(), eContainerFeatureID >= 0 ? this.eBasicRemoveFromContainerFeature(notifications) : this.eInternalContainer().eInverseRemove(this, -1 - eContainerFeatureID, null, notifications));
            notifications = this.eBasicSetContainer_0(null, -1, notifications);
        }
    }
    this.eSetDirectResource(resource);
    return notifications;
};
_.eSetting = function eSetting(eFeature) {
    var dynamicIndex, eClass, featureID, featureMap, index_0, openFeature, setting, upperBound;
    eClass = this.eClass_0();
    index_0 = $getFeatureID(eClass, eFeature);
    dynamicIndex = this.eStaticFeatureCount();
    if (index_0 >= dynamicIndex) return castTo(eFeature, 69).getSettingDelegate().dynamicSetting(this, this.eSettings_0(), index_0 - dynamicIndex);
    else if (index_0 <= -1) {
        openFeature = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), eClass, eFeature);
        if (openFeature) {
            $clinit_FeatureMapUtil();
            castTo(openFeature, 69).isFeatureMap_0() || (openFeature = $getGroup($getExtendedMetaData_1(INSTANCE_11, openFeature)));
            featureMap = (featureID = this.eDerivedStructuralFeatureID_0(openFeature), castTo(featureID >= 0 ? this.eGet(featureID, true, true) : $eOpenGet(this, openFeature, true), 159));
            upperBound = openFeature.getUpperBound();
            if (upperBound > 1 || upperBound == -1) return castTo(castTo(featureMap, 218).get_7(eFeature, false), 76);
        } else throw toJs(new IllegalArgumentException_0("The feature '" + eFeature.getName() + "' is not a valid feature"));
    } else if (eFeature.isMany()) return featureID = this.eDerivedStructuralFeatureID_0(eFeature), castTo(featureID >= 0 ? this.eGet(featureID, false, true) : $eOpenGet(this, eFeature, false), 76);
    setting = new BasicEObjectImpl$4(this, eFeature);
    return setting;
};
_.eSettings_0 = function eSettings() {
    return $eSettings(this);
};
_.eStaticClass = function eStaticClass() {
    return ($clinit_EcorePackage(), eINSTANCE_2).eObjectEClass;
};
_.eStaticFeatureCount = function eStaticFeatureCount() {
    return $getFeatureCount(this.eStaticClass());
};
_.eUnset = function eUnset(featureID) {
    $eUnset(this, featureID);
};
_.toString_0 = function toString_120() {
    return $toString_16(this);
};
var Lorg_eclipse_emf_ecore_impl_BasicEObjectImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'BasicEObjectImpl', 98);
function $clinit_EStructuralFeature$Internal$DynamicValueHolder() {
    $clinit_EStructuralFeature$Internal$DynamicValueHolder = emptyMethod;
    NIL = new EStructuralFeature$Internal$DynamicValueHolder$1;
}
var NIL;
function $addField(this$static, field, value_0) {
    var bit, fieldCount, fieldIndex, oldStorage, result, sourceIndex, targetIndex;
    fieldCount = bitCount(this$static.eFlags_0 & 254);
    if (fieldCount == 0) this$static.eStorage = value_0;
    else {
        if (fieldCount == 1) {
            result = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 2, 5, 1);
            fieldIndex = $fieldIndex(this$static, field);
            if (fieldIndex == 0) {
                result[0] = value_0;
                result[1] = this$static.eStorage;
            } else {
                result[0] = this$static.eStorage;
                result[1] = value_0;
            }
        } else {
            result = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, fieldCount + 1, 5, 1);
            oldStorage = castToArray(this$static.eStorage);
            for(bit = 2, sourceIndex = 0, targetIndex = 0; bit <= 128; bit <<= 1)bit == field ? result[targetIndex++] = value_0 : (this$static.eFlags_0 & bit) != 0 && (result[targetIndex++] = oldStorage[sourceIndex++]);
        }
        this$static.eStorage = result;
    }
    this$static.eFlags_0 |= field;
}
function $eClass(this$static) {
    var eClass;
    eClass = castTo($getField(this$static, 16), 29);
    return !eClass ? this$static.eStaticClass() : eClass;
}
function $eDynamicSettings(this$static) {
    var settings;
    settings = castToArray($getField(this$static, 32));
    if (settings == null) {
        $eSettings_0(this$static);
        settings = castToArray($getField(this$static, 32));
    }
    return settings;
}
function $eSettings_0(this$static) {
    var eClass, size_0;
    if ((this$static.eFlags_0 & 32) == 0) {
        size_0 = (eClass = castTo($getField(this$static, 16), 29), $getFeatureCount(!eClass ? this$static.eStaticClass() : eClass) - $getFeatureCount(this$static.eStaticClass()));
        size_0 != 0 && $setField(this$static, 32, initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, size_0, 5, 1));
    }
    return this$static;
}
function $fieldIndex(this$static, field) {
    var bit, bit0, result;
    result = 0;
    for(bit0 = 2; bit0 < field; bit0 <<= 1)(this$static.eFlags_0 & bit0) != 0 && ++result;
    if (result == 0) {
        for(bit = field <<= 1; bit <= 128; bit <<= 1){
            if ((this$static.eFlags_0 & bit) != 0) return 0;
        }
        return -1;
    } else return result;
}
function $getField(this$static, field) {
    var fieldIndex;
    if ((this$static.eFlags_0 & field) != 0) {
        fieldIndex = $fieldIndex(this$static, field);
        return fieldIndex == -1 ? this$static.eStorage : castToArray(this$static.eStorage)[fieldIndex];
    } else return null;
}
function $removeField(this$static, field) {
    var bit, fieldCount, fieldIndex, oldStorage, result, sourceIndex, targetIndex;
    fieldCount = bitCount(this$static.eFlags_0 & 254);
    if (fieldCount == 1) this$static.eStorage = null;
    else {
        oldStorage = castToArray(this$static.eStorage);
        if (fieldCount == 2) {
            fieldIndex = $fieldIndex(this$static, field);
            this$static.eStorage = oldStorage[fieldIndex == 0 ? 1 : 0];
        } else {
            result = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, fieldCount - 1, 5, 1);
            for(bit = 2, sourceIndex = 0, targetIndex = 0; bit <= 128; bit <<= 1)bit == field ? ++sourceIndex : (this$static.eFlags_0 & bit) != 0 && (result[targetIndex++] = oldStorage[sourceIndex++]);
            this$static.eStorage = result;
        }
    }
    this$static.eFlags_0 &= ~field;
}
function $setField(this$static, field, value_0) {
    var fieldIndex;
    if ((this$static.eFlags_0 & field) != 0) {
        if (value_0 == null) $removeField(this$static, field);
        else {
            fieldIndex = $fieldIndex(this$static, field);
            fieldIndex == -1 ? this$static.eStorage = value_0 : setCheck(castToArray(this$static.eStorage), fieldIndex, value_0);
        }
    } else value_0 != null && $addField(this$static, field, value_0);
}
defineClass(117, 98, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1
});
_.dynamicGet = function dynamicGet(dynamicFeatureID) {
    var settings;
    settings = $eDynamicSettings(this);
    return settings[dynamicFeatureID];
};
_.dynamicSet = function dynamicSet(dynamicFeatureID, newValue) {
    var settings;
    settings = $eDynamicSettings(this);
    setCheck(settings, dynamicFeatureID, newValue);
};
_.dynamicUnset = function dynamicUnset(dynamicFeatureID) {
    var settings;
    settings = $eDynamicSettings(this);
    setCheck(settings, dynamicFeatureID, null);
};
_.eBasicAdapterArray = function eBasicAdapterArray_0() {
    return castTo($getField(this, 4), 128);
};
_.eBasicAdapters = function eBasicAdapters_0() {
    throw toJs(new UnsupportedOperationException);
};
_.eBasicHasAdapters = function eBasicHasAdapters_0() {
    return (this.eFlags_0 & 4) != 0;
};
_.eBasicProperties = function eBasicProperties_0() {
    throw toJs(new UnsupportedOperationException);
};
_.eBasicSetContainer_1 = function eBasicSetContainer_1(newContainer) {
    $setField(this, 2, newContainer);
};
_.eBasicSetContainer = function eBasicSetContainer_2(newContainer, newContainerFeatureID) {
    this.eFlags_0 = newContainerFeatureID << 16 | this.eFlags_0 & 255;
    this.eBasicSetContainer_1(newContainer);
};
_.eClass_0 = function eClass_1() {
    return $eClass(this);
};
_.eContainerFeatureID_0 = function eContainerFeatureID_1() {
    return this.eFlags_0 >> 16;
};
_.eContents_0 = function eContents_1() {
    var eClass, eStructuralFeatures;
    return $clinit_EContentsEList(), eStructuralFeatures = $containments($getEAllStructuralFeatures((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass))), eStructuralFeatures == null ? EMPTY_CONTENTS_ELIST : new EContentsEList(this, eStructuralFeatures);
};
_.eDeliver = function eDeliver_0() {
    return (this.eFlags_0 & 1) == 0;
};
_.eDirectResource = function eDirectResource_0() {
    return castTo($getField(this, 128), 1980);
};
_.eDynamicClass = function eDynamicClass_0() {
    return castTo($getField(this, 16), 29);
};
_.eHasSettings = function eHasSettings_0() {
    return (this.eFlags_0 & 32) != 0;
};
_.eInternalContainer = function eInternalContainer_1() {
    return castTo($getField(this, 2), 52);
};
_.eIsProxy = function eIsProxy_0() {
    return (this.eFlags_0 & 64) != 0;
};
_.eProperties_0 = function eProperties_1() {
    throw toJs(new UnsupportedOperationException);
};
_.eProxyURI_0 = function eProxyURI_1() {
    return castTo($getField(this, 64), 286);
};
_.eSetClass = function eSetClass_0(eClass) {
    $setField(this, 16, eClass);
};
_.eSetDirectResource = function eSetDirectResource_0(resource) {
    $setField(this, 128, resource);
};
_.eSetProxyURI = function eSetProxyURI_0(uri_0) {
    $setField(this, 64, uri_0);
};
_.eSettings_0 = function eSettings_0() {
    return $eSettings_0(this);
};
_.eFlags_0 = 0;
var Lorg_eclipse_emf_ecore_impl_MinimalEObjectImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'MinimalEObjectImpl', 117);
defineClass(118, 117, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.eBasicSetContainer_1 = function eBasicSetContainer_3(newContainer) {
    this.eContainer = newContainer;
};
_.eInternalContainer = function eInternalContainer_2() {
    return this.eContainer;
};
var Lorg_eclipse_emf_ecore_impl_MinimalEObjectImpl$Container_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'MinimalEObjectImpl/Container', 118);
function $copyProperties_0(this$static, source) {
    var entry, entry$iterator, other, ourProps, value_0;
    if (!source) return this$static;
    if (instanceOf(source, 338)) {
        other = castTo(source, 338);
        ourProps = (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), this$static.properties);
        for(entry$iterator = other.getProperties().delegateEList.iterator_0(); entry$iterator.cursor != entry$iterator.this$01_2.size_1();){
            entry = castTo(entry$iterator.doNext(), 43);
            value_0 = entry.getValue();
            $put_14(ourProps, castTo(entry.getKey(), 144), value_0);
        }
    } else {
        !this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0));
        $putAll_1(this$static.properties, source.getAllProperties());
    }
    return this$static;
}
function $eGet_3(this$static, featureID, resolve, coreType) {
    if (featureID == 0) return coreType ? (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), this$static.properties) : (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $map_0(this$static.properties));
    return $eGet(this$static, featureID, resolve, coreType);
}
function $eInverseRemove_0(this$static, otherEnd, featureID, msgs) {
    var eClass, feature;
    if (featureID == 0) return !this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $basicRemove_1(this$static.properties, otherEnd, msgs);
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? this$static.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this$static, $eSettings_0(this$static), featureID - $getFeatureCount(this$static.eStaticClass()), otherEnd, msgs);
}
function $eIsSet_1(this$static, featureID) {
    if (featureID == 0) return !!this$static.properties && this$static.properties.size_0 != 0;
    return $eIsSet(this$static, featureID);
}
function $eSet_1(this$static, featureID, newValue) {
    switch(featureID){
        case 0:
            !this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0));
            $set_12(this$static.properties, newValue);
            return;
    }
    $eSet(this$static, featureID, newValue);
}
function $eUnset_1(this$static, featureID) {
    switch(featureID){
        case 0:
            !this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0));
            this$static.properties.delegateEList.clear_0();
            return;
    }
    $eUnset(this$static, featureID);
}
function $getAllProperties_0(this$static) {
    var entry, entry$iterator, props;
    props = (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), this$static.properties);
    for(entry$iterator = props.delegateEList.iterator_0(); entry$iterator.cursor != entry$iterator.this$01_2.size_1();){
        entry = castTo(entry$iterator.doNext(), 43);
        entry.getValue();
    }
    return $map_0(props);
}
function $getProperty_0(this$static, property) {
    var defaultValue, value_0;
    value_0 = (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $get_21(this$static.properties, property));
    if (value_0 != null) return value_0;
    defaultValue = property.getDefault();
    instanceOf(defaultValue, 4) && (defaultValue == null ? (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $removeKey(this$static.properties, property)) : (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $put_14(this$static.properties, property, defaultValue)), this$static);
    return defaultValue;
}
function $hasProperty_0(this$static, property) {
    return !this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $containsKey_7(this$static.properties, property);
}
function $setProperty_1(this$static, property, value_0) {
    value_0 == null ? (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $removeKey(this$static.properties, property)) : (!this$static.properties && (this$static.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this$static, 0)), $put_14(this$static.properties, property, value_0));
    return this$static;
}
defineClass(2029, 118, {
    109: 1,
    338: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.eGet = function eGet_2(featureID, resolve, coreType) {
    return $eGet_3(this, featureID, resolve, coreType);
};
_.eInverseRemove_0 = function eInverseRemove_1(otherEnd, featureID, msgs) {
    return $eInverseRemove_0(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_1(featureID) {
    return $eIsSet_1(this, featureID);
};
_.eSet = function eSet_0(featureID, newValue) {
    $eSet_1(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_0() {
    return $clinit_ElkGraphPackage$Literals(), EMAP_PROPERTY_HOLDER;
};
_.eUnset = function eUnset_0(featureID) {
    $eUnset_1(this, featureID);
};
_.getAllProperties = function getAllProperties_0() {
    return $getAllProperties_0(this);
};
_.getProperties = function getProperties() {
    return !this.properties && (this.properties = new EcoreEMap(($clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY), Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit, this, 0)), this.properties;
};
_.getProperty = function getProperty_3(property) {
    return $getProperty_0(this, property);
};
_.hasProperty = function hasProperty_3(property) {
    return $hasProperty_0(this, property);
};
_.setProperty = function setProperty_0(property, value_0) {
    return $setProperty_1(this, property, value_0);
};
var Lorg_eclipse_elk_graph_impl_EMapPropertyHolderImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'EMapPropertyHolderImpl', 2029);
function $set_8(this$static, x_0, y_0) {
    $setX_0(this$static, x_0);
    $setY_1(this$static, y_0);
}
function $setX_0(this$static, newX) {
    var oldX;
    oldX = this$static.x_0;
    this$static.x_0 = newX;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 0, oldX, this$static.x_0));
}
function $setY_1(this$static, newY) {
    var oldY;
    oldY = this$static.y_0;
    this$static.y_0 = newY;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 1, oldY, this$static.y_0));
}
function ElkBendPointImpl() {}
defineClass(555, 118, {
    109: 1,
    369: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkBendPointImpl);
_.eGet = function eGet_3(featureID, resolve, coreType) {
    switch(featureID){
        case 0:
            return this.x_0;
        case 1:
            return this.y_0;
    }
    return $eGet(this, featureID, resolve, coreType);
};
_.eIsSet = function eIsSet_2(featureID) {
    switch(featureID){
        case 0:
            return this.x_0 != 0;
        case 1:
            return this.y_0 != 0;
    }
    return $eIsSet(this, featureID);
};
_.eSet = function eSet_1(featureID, newValue) {
    switch(featureID){
        case 0:
            $setX_0(this, $doubleValue(castToDouble(newValue)));
            return;
        case 1:
            $setY_1(this, $doubleValue(castToDouble(newValue)));
            return;
    }
    $eSet(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_1() {
    return $clinit_ElkGraphPackage$Literals(), ELK_BEND_POINT;
};
_.eUnset = function eUnset_1(featureID) {
    switch(featureID){
        case 0:
            $setX_0(this, 0);
            return;
        case 1:
            $setY_1(this, 0);
            return;
    }
    $eUnset(this, featureID);
};
_.toString_0 = function toString_121() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_16(this);
    result = new StringBuffer_1($toString_16(this));
    result.string += ' (x: ';
    $append_0(result, this.x_0);
    result.string += ', y: ';
    $append_0(result, this.y_0);
    result.string += ')';
    return result.string;
};
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_graph_impl_ElkBendPointImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkBendPointImpl', 555);
function $eGet_4(this$static, featureID, resolve, coreType) {
    switch(featureID){
        case 1:
            return !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7)), this$static.labels;
        case 2:
            return this$static.identifier;
    }
    return $eGet_3(this$static, featureID, resolve, coreType);
}
function $eInverseAdd_0(this$static, otherEnd, featureID, msgs) {
    var eClass, feature;
    if (featureID == 1) return !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7)), $basicAdd_0(this$static.labels, otherEnd, msgs);
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? this$static.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this$static, $eSettings_0(this$static), featureID - $getFeatureCount(this$static.eStaticClass()), otherEnd, msgs);
}
function $eInverseRemove_1(this$static, otherEnd, featureID, msgs) {
    if (featureID == 1) return !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7)), $basicRemove_0(this$static.labels, otherEnd, msgs);
    return $eInverseRemove_0(this$static, otherEnd, featureID, msgs);
}
function $eIsSet_2(this$static, featureID) {
    switch(featureID){
        case 1:
            return !!this$static.labels && this$static.labels.size_0 != 0;
        case 2:
            return this$static.identifier != null;
    }
    return $eIsSet_1(this$static, featureID);
}
function $eSet_2(this$static, featureID, newValue) {
    switch(featureID){
        case 1:
            !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
            $clear_13(this$static.labels);
            !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
            $addAll_9(this$static.labels, castTo(newValue, 16));
            return;
        case 2:
            $setIdentifier(this$static, castToString(newValue));
            return;
    }
    $eSet_1(this$static, featureID, newValue);
}
function $eUnset_2(this$static, featureID) {
    switch(featureID){
        case 1:
            !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
            $clear_13(this$static.labels);
            return;
        case 2:
            $setIdentifier(this$static, null);
            return;
    }
    $eUnset_1(this$static, featureID);
}
function $getLabels_1(this$static) {
    !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
    return this$static.labels;
}
function $setIdentifier(this$static, newIdentifier) {
    var oldIdentifier;
    oldIdentifier = this$static.identifier;
    this$static.identifier = newIdentifier;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 2, oldIdentifier, this$static.identifier));
}
function $toString_17(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_16(this$static);
    result = new StringBuffer_1($toString_16(this$static));
    result.string += ' (identifier: ';
    $append_3(result, this$static.identifier);
    result.string += ')';
    return result.string;
}
defineClass(722, 2029, {
    109: 1,
    338: 1,
    173: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.eGet = function eGet_4(featureID, resolve, coreType) {
    return $eGet_4(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_1(otherEnd, featureID, msgs) {
    return $eInverseAdd_0(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_2(otherEnd, featureID, msgs) {
    return $eInverseRemove_1(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_3(featureID) {
    return $eIsSet_2(this, featureID);
};
_.eSet = function eSet_2(featureID, newValue) {
    $eSet_2(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_2() {
    return $clinit_ElkGraphPackage$Literals(), ELK_GRAPH_ELEMENT;
};
_.eUnset = function eUnset_2(featureID) {
    $eUnset_2(this, featureID);
};
_.getIdentifier = function getIdentifier_0() {
    return this.identifier;
};
_.getLabels_0 = function getLabels_5() {
    return $getLabels_1(this);
};
_.toString_0 = function toString_122() {
    return $toString_17(this);
};
_.identifier = null;
var Lorg_eclipse_elk_graph_impl_ElkGraphElementImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkGraphElementImpl', 722);
function $eGet_5(this$static, featureID, resolve, coreType) {
    switch(featureID){
        case 3:
            return this$static.height;
        case 4:
            return this$static.width_0;
        case 5:
            return this$static.x_0;
        case 6:
            return this$static.y_0;
    }
    return $eGet_4(this$static, featureID, resolve, coreType);
}
function $eIsSet_3(this$static, featureID) {
    switch(featureID){
        case 3:
            return this$static.height != 0;
        case 4:
            return this$static.width_0 != 0;
        case 5:
            return this$static.x_0 != 0;
        case 6:
            return this$static.y_0 != 0;
    }
    return $eIsSet_2(this$static, featureID);
}
function $eSet_3(this$static, featureID, newValue) {
    switch(featureID){
        case 3:
            $setHeight_0(this$static, $doubleValue(castToDouble(newValue)));
            return;
        case 4:
            $setWidth_0(this$static, $doubleValue(castToDouble(newValue)));
            return;
        case 5:
            $setX_1(this$static, $doubleValue(castToDouble(newValue)));
            return;
        case 6:
            $setY_2(this$static, $doubleValue(castToDouble(newValue)));
            return;
    }
    $eSet_2(this$static, featureID, newValue);
}
function $eUnset_3(this$static, featureID) {
    switch(featureID){
        case 3:
            $setHeight_0(this$static, 0);
            return;
        case 4:
            $setWidth_0(this$static, 0);
            return;
        case 5:
            $setX_1(this$static, 0);
            return;
        case 6:
            $setY_2(this$static, 0);
            return;
    }
    $eUnset_2(this$static, featureID);
}
function $setDimensions(this$static, width_0, height) {
    $setWidth_0(this$static, width_0);
    $setHeight_0(this$static, height);
}
function $setHeight_0(this$static, newHeight) {
    var oldHeight;
    oldHeight = this$static.height;
    this$static.height = newHeight;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 3, oldHeight, this$static.height));
}
function $setLocation_1(this$static, x_0, y_0) {
    $setX_1(this$static, x_0);
    $setY_2(this$static, y_0);
}
function $setWidth_0(this$static, newWidth) {
    var oldWidth;
    oldWidth = this$static.width_0;
    this$static.width_0 = newWidth;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 4, oldWidth, this$static.width_0));
}
function $setX_1(this$static, newX) {
    var oldX;
    oldX = this$static.x_0;
    this$static.x_0 = newX;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 5, oldX, this$static.x_0));
}
function $setY_2(this$static, newY) {
    var oldY;
    oldY = this$static.y_0;
    this$static.y_0 = newY;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 6, oldY, this$static.y_0));
}
function $toString_18(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_17(this$static);
    result = new StringBuffer_1($toString_17(this$static));
    result.string += ' (height: ';
    $append_0(result, this$static.height);
    result.string += ', width: ';
    $append_0(result, this$static.width_0);
    result.string += ', x: ';
    $append_0(result, this$static.x_0);
    result.string += ', y: ';
    $append_0(result, this$static.y_0);
    result.string += ')';
    return result.string;
}
defineClass(723, 722, {
    109: 1,
    338: 1,
    173: 1,
    273: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.eGet = function eGet_5(featureID, resolve, coreType) {
    return $eGet_5(this, featureID, resolve, coreType);
};
_.eIsSet = function eIsSet_4(featureID) {
    return $eIsSet_3(this, featureID);
};
_.eSet = function eSet_3(featureID, newValue) {
    $eSet_3(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_3() {
    return $clinit_ElkGraphPackage$Literals(), ELK_SHAPE;
};
_.eUnset = function eUnset_3(featureID) {
    $eUnset_3(this, featureID);
};
_.getHeight = function getHeight() {
    return this.height;
};
_.getWidth = function getWidth() {
    return this.width_0;
};
_.getX = function getX() {
    return this.x_0;
};
_.getY = function getY() {
    return this.y_0;
};
_.setDimensions = function setDimensions(width_0, height) {
    $setDimensions(this, width_0, height);
};
_.setLocation = function setLocation(x_0, y_0) {
    $setLocation_1(this, x_0, y_0);
};
_.toString_0 = function toString_123() {
    return $toString_18(this);
};
_.height = 0;
_.width_0 = 0;
_.x_0 = 0;
_.y_0 = 0;
var Lorg_eclipse_elk_graph_impl_ElkShapeImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkShapeImpl', 723);
function $eGet_6(this$static, featureID, resolve, coreType) {
    switch(featureID){
        case 7:
            return !this$static.outgoingEdges && (this$static.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 7, 4)), this$static.outgoingEdges;
        case 8:
            return !this$static.incomingEdges && (this$static.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 8, 5)), this$static.incomingEdges;
    }
    return $eGet_5(this$static, featureID, resolve, coreType);
}
function $eInverseAdd_1(this$static, otherEnd, featureID, msgs) {
    switch(featureID){
        case 7:
            return !this$static.outgoingEdges && (this$static.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 7, 4)), $basicAdd_0(this$static.outgoingEdges, otherEnd, msgs);
        case 8:
            return !this$static.incomingEdges && (this$static.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 8, 5)), $basicAdd_0(this$static.incomingEdges, otherEnd, msgs);
    }
    return $eInverseAdd_0(this$static, otherEnd, featureID, msgs);
}
function $eInverseRemove_2(this$static, otherEnd, featureID, msgs) {
    switch(featureID){
        case 7:
            return !this$static.outgoingEdges && (this$static.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 7, 4)), $basicRemove_0(this$static.outgoingEdges, otherEnd, msgs);
        case 8:
            return !this$static.incomingEdges && (this$static.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 8, 5)), $basicRemove_0(this$static.incomingEdges, otherEnd, msgs);
    }
    return $eInverseRemove_1(this$static, otherEnd, featureID, msgs);
}
function $eIsSet_4(this$static, featureID) {
    switch(featureID){
        case 7:
            return !!this$static.outgoingEdges && this$static.outgoingEdges.size_0 != 0;
        case 8:
            return !!this$static.incomingEdges && this$static.incomingEdges.size_0 != 0;
    }
    return $eIsSet_3(this$static, featureID);
}
function $eSet_4(this$static, featureID, newValue) {
    switch(featureID){
        case 7:
            !this$static.outgoingEdges && (this$static.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 7, 4));
            $clear_13(this$static.outgoingEdges);
            !this$static.outgoingEdges && (this$static.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 7, 4));
            $addAll_9(this$static.outgoingEdges, castTo(newValue, 16));
            return;
        case 8:
            !this$static.incomingEdges && (this$static.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 8, 5));
            $clear_13(this$static.incomingEdges);
            !this$static.incomingEdges && (this$static.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 8, 5));
            $addAll_9(this$static.incomingEdges, castTo(newValue, 16));
            return;
    }
    $eSet_3(this$static, featureID, newValue);
}
function $eUnset_4(this$static, featureID) {
    switch(featureID){
        case 7:
            !this$static.outgoingEdges && (this$static.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 7, 4));
            $clear_13(this$static.outgoingEdges);
            return;
        case 8:
            !this$static.incomingEdges && (this$static.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 8, 5));
            $clear_13(this$static.incomingEdges);
            return;
    }
    $eUnset_3(this$static, featureID);
}
function ElkConnectableShapeImpl() {}
defineClass(724, 723, {
    109: 1,
    338: 1,
    84: 1,
    173: 1,
    273: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
});
_.eGet = function eGet_6(featureID, resolve, coreType) {
    return $eGet_6(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_2(otherEnd, featureID, msgs) {
    return $eInverseAdd_1(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_3(otherEnd, featureID, msgs) {
    return $eInverseRemove_2(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_5(featureID) {
    return $eIsSet_4(this, featureID);
};
_.eSet = function eSet_4(featureID, newValue) {
    $eSet_4(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_4() {
    return $clinit_ElkGraphPackage$Literals(), ELK_CONNECTABLE_SHAPE;
};
_.eUnset = function eUnset_4(featureID) {
    $eUnset_4(this, featureID);
};
_.getIncomingEdges_0 = function getIncomingEdges_3() {
    return !this.incomingEdges && (this.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 8, 5)), this.incomingEdges;
};
_.getOutgoingEdges_0 = function getOutgoingEdges_3() {
    return !this.outgoingEdges && (this.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 7, 4)), this.outgoingEdges;
};
var Lorg_eclipse_elk_graph_impl_ElkConnectableShapeImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkConnectableShapeImpl', 724);
function $basicSetContainingNode(this$static, newContainingNode, msgs) {
    msgs = $eBasicSetContainer(this$static, newContainingNode, 3, msgs);
    return msgs;
}
function $eBasicRemoveFromContainerFeature(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 3) return this$static.eContainer.eInverseRemove(this$static, 12, Lorg_eclipse_elk_graph_ElkNode_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_ElkGraphPackage$Literals(), ELK_EDGE) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getContainingNode(this$static) {
    if (this$static.eFlags_0 >> 16 != 3) return null;
    return castTo(this$static.eContainer, 27);
}
function $getSources(this$static) {
    !this$static.sources && (this$static.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 4, 7));
    return this$static.sources;
}
function $getTargets(this$static) {
    !this$static.targets && (this$static.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 5, 8));
    return this$static.targets;
}
function $isHierarchical(this$static) {
    var commonRepresentingNode, incidentShape, incidentShape$iterator, shapeNode;
    commonRepresentingNode = null;
    for(incidentShape$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        (!this$static.sources && (this$static.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 4, 7)), this$static.sources),
        (!this$static.targets && (this$static.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 5, 8)), this$static.targets)
    ]))); $hasNext_1(incidentShape$iterator);){
        incidentShape = castTo($next_0(incidentShape$iterator), 84);
        shapeNode = connectableShapeToNode(incidentShape);
        if (!commonRepresentingNode) commonRepresentingNode = $getParent_2(shapeNode);
        else if (commonRepresentingNode != $getParent_2(shapeNode)) return true;
    }
    return false;
}
function $isSelfloop(this$static) {
    var commonNode, incidentShape, incidentShape$iterator, shapeNode;
    commonNode = null;
    for(incidentShape$iterator = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        (!this$static.sources && (this$static.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 4, 7)), this$static.sources),
        (!this$static.targets && (this$static.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 5, 8)), this$static.targets)
    ]))); $hasNext_1(incidentShape$iterator);){
        incidentShape = castTo($next_0(incidentShape$iterator), 84);
        shapeNode = connectableShapeToNode(incidentShape);
        if (!commonNode) commonNode = shapeNode;
        else if (commonNode != shapeNode) return false;
    }
    return true;
}
function $setContainingNode(this$static, newContainingNode) {
    var eContainerFeatureID, msgs;
    if (newContainingNode != this$static.eContainer || this$static.eFlags_0 >> 16 != 3 && !!newContainingNode) {
        if (isAncestor(this$static, newContainingNode)) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + $toString_19(this$static)));
        msgs = null;
        !!this$static.eContainer && (msgs = (eContainerFeatureID = this$static.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature(this$static, msgs) : this$static.eContainer.eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        !!newContainingNode && (msgs = $eInverseAdd(newContainingNode, this$static, 12, msgs));
        msgs = $basicSetContainingNode(this$static, newContainingNode, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 3, newContainingNode, newContainingNode));
}
function $toString_19(this$static) {
    var builder, hyperedge, id_0, text_0;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_17(this$static);
    builder = new StringBuilder_1('ElkEdge');
    id_0 = this$static.identifier;
    if (!id_0) {
        !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
        if (this$static.labels.size_0 > 0) {
            text_0 = (!this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7)), castTo($get_20(this$static.labels, 0), 153)).text_0;
            !text_0 || $append_11($append_11((builder.string += ' "', builder), text_0), '"');
        }
    } else $append_11($append_11((builder.string += ' "', builder), id_0), '"');
    hyperedge = (!this$static.sources && (this$static.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 4, 7)), !(this$static.sources.size_0 <= 1 && (!this$static.targets && (this$static.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this$static, 5, 8)), this$static.targets.size_0 <= 1)));
    hyperedge ? (builder.string += ' [', builder) : (builder.string += ' ', builder);
    $append_11(builder, $join(new Joiner, new AbstractEList$EIterator(this$static.sources)));
    hyperedge && (builder.string += ']', builder);
    builder.string += ' -> ';
    hyperedge && (builder.string += '[', builder);
    $append_11(builder, $join(new Joiner, new AbstractEList$EIterator(this$static.targets)));
    hyperedge && (builder.string += ']', builder);
    return builder.string;
}
function ElkEdgeImpl() {}
defineClass(268, 722, {
    109: 1,
    338: 1,
    85: 1,
    173: 1,
    268: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkEdgeImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_0(msgs) {
    return $eBasicRemoveFromContainerFeature(this, msgs);
};
_.eGet = function eGet_7(featureID, resolve, coreType) {
    switch(featureID){
        case 3:
            return $getContainingNode(this);
        case 4:
            return !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), this.sources;
        case 5:
            return !this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), this.targets;
        case 6:
            return !this.sections && (this.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 6, 6)), this.sections;
        case 7:
            return $clinit_Boolean(), !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), this.sources.size_0 <= 1 && (!this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), this.targets.size_0 <= 1) ? false : true;
        case 8:
            return $clinit_Boolean(), $isHierarchical(this) ? true : false;
        case 9:
            return $clinit_Boolean(), $isSelfloop(this) ? true : false;
        case 10:
            return $clinit_Boolean(), !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), this.sources.size_0 != 0 && (!this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), this.targets.size_0 != 0) ? true : false;
    }
    return $eGet_4(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_3(otherEnd, featureID, msgs) {
    var eContainerFeatureID;
    switch(featureID){
        case 3:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $basicSetContainingNode(this, castTo(otherEnd, 27), msgs);
        case 4:
            return !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), $basicAdd_0(this.sources, otherEnd, msgs);
        case 5:
            return !this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), $basicAdd_0(this.targets, otherEnd, msgs);
        case 6:
            return !this.sections && (this.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 6, 6)), $basicAdd_0(this.sections, otherEnd, msgs);
    }
    return $eInverseAdd_0(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_4(otherEnd, featureID, msgs) {
    switch(featureID){
        case 3:
            return $basicSetContainingNode(this, null, msgs);
        case 4:
            return !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), $basicRemove_0(this.sources, otherEnd, msgs);
        case 5:
            return !this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), $basicRemove_0(this.targets, otherEnd, msgs);
        case 6:
            return !this.sections && (this.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 6, 6)), $basicRemove_0(this.sections, otherEnd, msgs);
    }
    return $eInverseRemove_1(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_6(featureID) {
    switch(featureID){
        case 3:
            return !!$getContainingNode(this);
        case 4:
            return !!this.sources && this.sources.size_0 != 0;
        case 5:
            return !!this.targets && this.targets.size_0 != 0;
        case 6:
            return !!this.sections && this.sections.size_0 != 0;
        case 7:
            return !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), !(this.sources.size_0 <= 1 && (!this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), this.targets.size_0 <= 1));
        case 8:
            return $isHierarchical(this);
        case 9:
            return $isSelfloop(this);
        case 10:
            return !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7)), this.sources.size_0 != 0 && (!this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8)), this.targets.size_0 != 0);
    }
    return $eIsSet_2(this, featureID);
};
_.eSet = function eSet_5(featureID, newValue) {
    switch(featureID){
        case 3:
            $setContainingNode(this, castTo(newValue, 27));
            return;
        case 4:
            !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7));
            $clear_13(this.sources);
            !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7));
            $addAll_9(this.sources, castTo(newValue, 16));
            return;
        case 5:
            !this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8));
            $clear_13(this.targets);
            !this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8));
            $addAll_9(this.targets, castTo(newValue, 16));
            return;
        case 6:
            !this.sections && (this.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 6, 6));
            $clear_13(this.sections);
            !this.sections && (this.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 6, 6));
            $addAll_9(this.sections, castTo(newValue, 16));
            return;
    }
    $eSet_2(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_5() {
    return $clinit_ElkGraphPackage$Literals(), ELK_EDGE;
};
_.eUnset = function eUnset_5(featureID) {
    switch(featureID){
        case 3:
            $setContainingNode(this, null);
            return;
        case 4:
            !this.sources && (this.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 4, 7));
            $clear_13(this.sources);
            return;
        case 5:
            !this.targets && (this.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, this, 5, 8));
            $clear_13(this.targets);
            return;
        case 6:
            !this.sections && (this.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 6, 6));
            $clear_13(this.sections);
            return;
    }
    $eUnset_2(this, featureID);
};
_.toString_0 = function toString_124() {
    return $toString_19(this);
};
var Lorg_eclipse_elk_graph_impl_ElkEdgeImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkEdgeImpl', 268);
function $basicSetParent(this$static, newParent, msgs) {
    msgs = $eBasicSetContainer(this$static, newParent, 6, msgs);
    return msgs;
}
function $eBasicRemoveFromContainerFeature_0(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 6) return this$static.eContainer.eInverseRemove(this$static, 6, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_ElkGraphPackage$Literals(), ELK_EDGE_SECTION) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getIncomingShape(this$static) {
    var oldIncomingShape;
    if (!!this$static.incomingShape && this$static.incomingShape.eIsProxy()) {
        oldIncomingShape = castTo(this$static.incomingShape, 52);
        this$static.incomingShape = castTo($eResolveProxy(this$static, oldIncomingShape), 84);
        this$static.incomingShape != oldIncomingShape && (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, 8, oldIncomingShape, this$static.incomingShape));
    }
    return this$static.incomingShape;
}
function $getOutgoingShape(this$static) {
    var oldOutgoingShape;
    if (!!this$static.outgoingShape && this$static.outgoingShape.eIsProxy()) {
        oldOutgoingShape = castTo(this$static.outgoingShape, 52);
        this$static.outgoingShape = castTo($eResolveProxy(this$static, oldOutgoingShape), 84);
        this$static.outgoingShape != oldOutgoingShape && (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, 7, oldOutgoingShape, this$static.outgoingShape));
    }
    return this$static.outgoingShape;
}
function $getParent_0(this$static) {
    if (this$static.eFlags_0 >> 16 != 6) return null;
    return castTo(this$static.eContainer, 85);
}
function $setEndLocation(this$static, x_0, y_0) {
    $setEndX(this$static, x_0);
    $setEndY(this$static, y_0);
}
function $setEndX(this$static, newEndX) {
    var oldEndX;
    oldEndX = this$static.endX;
    this$static.endX = newEndX;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 3, oldEndX, this$static.endX));
}
function $setEndY(this$static, newEndY) {
    var oldEndY;
    oldEndY = this$static.endY;
    this$static.endY = newEndY;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 4, oldEndY, this$static.endY));
}
function $setIdentifier_0(this$static, newIdentifier) {
    var oldIdentifier;
    oldIdentifier = this$static.identifier;
    this$static.identifier = newIdentifier;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 11, oldIdentifier, this$static.identifier));
}
function $setIncomingShape(this$static, newIncomingShape) {
    var oldIncomingShape;
    oldIncomingShape = this$static.incomingShape;
    this$static.incomingShape = newIncomingShape;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 8, oldIncomingShape, this$static.incomingShape));
}
function $setOutgoingShape(this$static, newOutgoingShape) {
    var oldOutgoingShape;
    oldOutgoingShape = this$static.outgoingShape;
    this$static.outgoingShape = newOutgoingShape;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 7, oldOutgoingShape, this$static.outgoingShape));
}
function $setParent_0(this$static, newParent) {
    var eContainerFeatureID, msgs;
    if (newParent != this$static.eContainer || this$static.eFlags_0 >> 16 != 6 && !!newParent) {
        if (isAncestor(this$static, newParent)) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + $toString_20(this$static)));
        msgs = null;
        !!this$static.eContainer && (msgs = (eContainerFeatureID = this$static.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_0(this$static, msgs) : this$static.eContainer.eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        !!newParent && (msgs = $eInverseAdd(newParent, this$static, 6, msgs));
        msgs = $basicSetParent(this$static, newParent, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 6, newParent, newParent));
}
function $setStartLocation(this$static, x_0, y_0) {
    $setStartX(this$static, x_0);
    $setStartY(this$static, y_0);
}
function $setStartX(this$static, newStartX) {
    var oldStartX;
    oldStartX = this$static.startX;
    this$static.startX = newStartX;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 1, oldStartX, this$static.startX));
}
function $setStartY(this$static, newStartY) {
    var oldStartY;
    oldStartY = this$static.startY;
    this$static.startY = newStartY;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl(this$static, 2, oldStartY, this$static.startY));
}
function $toString_20(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_16(this$static);
    result = new StringBuffer_1($toString_16(this$static));
    result.string += ' (startX: ';
    $append_0(result, this$static.startX);
    result.string += ', startY: ';
    $append_0(result, this$static.startY);
    result.string += ', endX: ';
    $append_0(result, this$static.endX);
    result.string += ', endY: ';
    $append_0(result, this$static.endY);
    result.string += ', identifier: ';
    $append_3(result, this$static.identifier);
    result.string += ')';
    return result.string;
}
function ElkEdgeSectionImpl() {}
defineClass(440, 2029, {
    109: 1,
    338: 1,
    168: 1,
    440: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkEdgeSectionImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_1(msgs) {
    return $eBasicRemoveFromContainerFeature_0(this, msgs);
};
_.eGet = function eGet_8(featureID, resolve, coreType) {
    switch(featureID){
        case 1:
            return this.startX;
        case 2:
            return this.startY;
        case 3:
            return this.endX;
        case 4:
            return this.endY;
        case 5:
            return !this.bendPoints && (this.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, this, 5)), this.bendPoints;
        case 6:
            return $getParent_0(this);
        case 7:
            if (resolve) return $getOutgoingShape(this);
            return this.outgoingShape;
        case 8:
            if (resolve) return $getIncomingShape(this);
            return this.incomingShape;
        case 9:
            return !this.outgoingSections && (this.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 9, 10)), this.outgoingSections;
        case 10:
            return !this.incomingSections && (this.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 10, 9)), this.incomingSections;
        case 11:
            return this.identifier;
    }
    return $eGet_3(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_4(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 6:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_0(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $basicSetParent(this, castTo(otherEnd, 85), msgs);
        case 9:
            return !this.outgoingSections && (this.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 9, 10)), $basicAdd_0(this.outgoingSections, otherEnd, msgs);
        case 10:
            return !this.incomingSections && (this.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 10, 9)), $basicAdd_0(this.incomingSections, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_ElkGraphPackage$Literals(), ELK_EDGE_SECTION) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_ElkGraphPackage$Literals(), ELK_EDGE_SECTION)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_5(otherEnd, featureID, msgs) {
    switch(featureID){
        case 5:
            return !this.bendPoints && (this.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, this, 5)), $basicRemove_0(this.bendPoints, otherEnd, msgs);
        case 6:
            return $basicSetParent(this, null, msgs);
        case 9:
            return !this.outgoingSections && (this.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 9, 10)), $basicRemove_0(this.outgoingSections, otherEnd, msgs);
        case 10:
            return !this.incomingSections && (this.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 10, 9)), $basicRemove_0(this.incomingSections, otherEnd, msgs);
    }
    return $eInverseRemove_0(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_7(featureID) {
    switch(featureID){
        case 1:
            return this.startX != 0;
        case 2:
            return this.startY != 0;
        case 3:
            return this.endX != 0;
        case 4:
            return this.endY != 0;
        case 5:
            return !!this.bendPoints && this.bendPoints.size_0 != 0;
        case 6:
            return !!$getParent_0(this);
        case 7:
            return !!this.outgoingShape;
        case 8:
            return !!this.incomingShape;
        case 9:
            return !!this.outgoingSections && this.outgoingSections.size_0 != 0;
        case 10:
            return !!this.incomingSections && this.incomingSections.size_0 != 0;
        case 11:
            return this.identifier != null;
    }
    return $eIsSet_1(this, featureID);
};
_.eSet = function eSet_6(featureID, newValue) {
    switch(featureID){
        case 1:
            $setStartX(this, $doubleValue(castToDouble(newValue)));
            return;
        case 2:
            $setStartY(this, $doubleValue(castToDouble(newValue)));
            return;
        case 3:
            $setEndX(this, $doubleValue(castToDouble(newValue)));
            return;
        case 4:
            $setEndY(this, $doubleValue(castToDouble(newValue)));
            return;
        case 5:
            !this.bendPoints && (this.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, this, 5));
            $clear_13(this.bendPoints);
            !this.bendPoints && (this.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, this, 5));
            $addAll_9(this.bendPoints, castTo(newValue, 16));
            return;
        case 6:
            $setParent_0(this, castTo(newValue, 85));
            return;
        case 7:
            $setOutgoingShape(this, castTo(newValue, 84));
            return;
        case 8:
            $setIncomingShape(this, castTo(newValue, 84));
            return;
        case 9:
            !this.outgoingSections && (this.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 9, 10));
            $clear_13(this.outgoingSections);
            !this.outgoingSections && (this.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 9, 10));
            $addAll_9(this.outgoingSections, castTo(newValue, 16));
            return;
        case 10:
            !this.incomingSections && (this.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 10, 9));
            $clear_13(this.incomingSections);
            !this.incomingSections && (this.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 10, 9));
            $addAll_9(this.incomingSections, castTo(newValue, 16));
            return;
        case 11:
            $setIdentifier_0(this, castToString(newValue));
            return;
    }
    $eSet_1(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_6() {
    return $clinit_ElkGraphPackage$Literals(), ELK_EDGE_SECTION;
};
_.eUnset = function eUnset_6(featureID) {
    switch(featureID){
        case 1:
            $setStartX(this, 0);
            return;
        case 2:
            $setStartY(this, 0);
            return;
        case 3:
            $setEndX(this, 0);
            return;
        case 4:
            $setEndY(this, 0);
            return;
        case 5:
            !this.bendPoints && (this.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, this, 5));
            $clear_13(this.bendPoints);
            return;
        case 6:
            $setParent_0(this, null);
            return;
        case 7:
            $setOutgoingShape(this, null);
            return;
        case 8:
            $setIncomingShape(this, null);
            return;
        case 9:
            !this.outgoingSections && (this.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 9, 10));
            $clear_13(this.outgoingSections);
            return;
        case 10:
            !this.incomingSections && (this.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, this, 10, 9));
            $clear_13(this.incomingSections);
            return;
        case 11:
            $setIdentifier_0(this, null);
            return;
    }
    $eUnset_1(this, featureID);
};
_.toString_0 = function toString_125() {
    return $toString_20(this);
};
_.endX = 0;
_.endY = 0;
_.identifier = null;
_.startX = 0;
_.startY = 0;
var Lorg_eclipse_elk_graph_impl_ElkEdgeSectionImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkEdgeSectionImpl', 440);
function $eObjectForURIFragmentSegment_0(this$static, uriFragmentSegment) {
    var count, count0, eAnnotation, eNamedElement, encodedSource, exception, firstCharacter, hasCount, index_0, index0, length_0, name_0, object, object$iterator, object$iterator0, otherName, otherSource, source;
    length_0 = uriFragmentSegment.length;
    if (length_0 > 0) {
        firstCharacter = (checkCriticalStringElementIndex(0, uriFragmentSegment.length), uriFragmentSegment.charCodeAt(0));
        if (firstCharacter != 64) {
            if (firstCharacter == 37) {
                index0 = uriFragmentSegment.lastIndexOf('%');
                hasCount = false;
                if (index0 != 0 && (index0 == length_0 - 1 || (hasCount = (checkCriticalStringElementIndex(index0 + 1, uriFragmentSegment.length), uriFragmentSegment.charCodeAt(index0 + 1) == 46)))) {
                    encodedSource = (checkCriticalStringBounds(1, index0, uriFragmentSegment.length), uriFragmentSegment.substr(1, index0 - 1));
                    source = $equals_5('%', encodedSource) ? null : decode(encodedSource);
                    count0 = 0;
                    if (hasCount) try {
                        count0 = __parseAndValidateInt((checkCriticalStringElementIndex(index0 + 2, uriFragmentSegment.length + 1), uriFragmentSegment.substr(index0 + 2)), $intern_42, $intern_0);
                    } catch ($e0) {
                        $e0 = toJava($e0);
                        if (instanceOf($e0, 130)) {
                            exception = $e0;
                            throw toJs(new WrappedException(exception));
                        } else throw toJs($e0);
                    }
                    for(object$iterator0 = $iterator_1(this$static.eContents_0()); object$iterator0.hasNext_0();){
                        object = $next_14(object$iterator0);
                        if (instanceOf(object, 503)) {
                            eAnnotation = castTo(object, 582);
                            otherSource = eAnnotation.source;
                            if ((source == null ? otherSource == null : $equals_5(source, otherSource)) && count0-- == 0) return eAnnotation;
                        }
                    }
                    return null;
                }
            }
            index_0 = uriFragmentSegment.lastIndexOf('.');
            name_0 = index_0 == -1 ? uriFragmentSegment : (checkCriticalStringBounds(0, index_0, uriFragmentSegment.length), uriFragmentSegment.substr(0, index_0));
            count = 0;
            if (index_0 != -1) try {
                count = __parseAndValidateInt((checkCriticalStringElementIndex(index_0 + 1, uriFragmentSegment.length + 1), uriFragmentSegment.substr(index_0 + 1)), $intern_42, $intern_0);
            } catch ($e1) {
                $e1 = toJava($e1);
                if (instanceOf($e1, 130)) name_0 = uriFragmentSegment;
                else throw toJs($e1);
            }
            name_0 = $equals_5('%', name_0) ? null : decode(name_0);
            for(object$iterator = $iterator_1(this$static.eContents_0()); object$iterator.hasNext_0();){
                object = $next_14(object$iterator);
                if (instanceOf(object, 197)) {
                    eNamedElement = castTo(object, 197);
                    otherName = eNamedElement.getName();
                    if ((name_0 == null ? otherName == null : $equals_5(name_0, otherName)) && count-- == 0) return eNamedElement;
                }
            }
            return null;
        }
    }
    return $eObjectForURIFragmentSegment(this$static, uriFragmentSegment);
}
function $freeze(eModelElement) {
    instanceOf(eModelElement, 157) && castTo(eModelElement, 157).freeze();
}
function $getEAnnotation(this$static, source) {
    var eAnnotation, eAnnotation$iterator, eAnnotationArray, i, size_0;
    if (this$static.eAnnotations) {
        if (this$static.eAnnotations) {
            size_0 = this$static.eAnnotations.size_0;
            if (size_0 > 0) {
                eAnnotationArray = castTo(this$static.eAnnotations.data_0, 1979);
                if (source == null) for(i = 0; i < size_0; ++i){
                    eAnnotation = eAnnotationArray[i];
                    if (eAnnotation.source == null) return eAnnotation;
                }
                else for(i = 0; i < size_0; ++i){
                    eAnnotation = eAnnotationArray[i];
                    if ($equals_5(source, eAnnotation.source)) return eAnnotation;
                }
            }
        } else {
            if (source == null) for(eAnnotation$iterator = new AbstractEList$EIterator(this$static.eAnnotations); eAnnotation$iterator.cursor != eAnnotation$iterator.this$01_2.size_1();){
                eAnnotation = castTo($doNext(eAnnotation$iterator), 582);
                if (eAnnotation.source == null) return eAnnotation;
            }
            else for(eAnnotation$iterator = new AbstractEList$EIterator(this$static.eAnnotations); eAnnotation$iterator.cursor != eAnnotation$iterator.this$01_2.size_1();){
                eAnnotation = castTo($doNext(eAnnotation$iterator), 582);
                if ($equals_5(source, eAnnotation.source)) return eAnnotation;
            }
        }
    }
    return null;
}
defineClass(157, 118, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
});
_.eGet = function eGet_9(featureID, resolve, coreType) {
    var eClass;
    if (featureID == 0) return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_5(otherEnd, featureID, msgs) {
    var eClass, feature;
    if (featureID == 0) return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_6(otherEnd, featureID, msgs) {
    var eClass, feature;
    if (featureID == 0) return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eIsSet = function eIsSet_8(featureID) {
    var eClass;
    if (featureID == 0) return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.eObjectForURIFragmentSegment = function eObjectForURIFragmentSegment_0(uriFragmentSegment) {
    return $eObjectForURIFragmentSegment_0(this, uriFragmentSegment);
};
_.eSet = function eSet_7(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), newValue);
};
_.eSetDirectResource = function eSetDirectResource_1(resource) {
    $setField(this, 128, resource);
};
_.eStaticClass = function eStaticClass_7() {
    return $clinit_EcorePackage$Literals(), EMODEL_ELEMENT;
};
_.eUnset = function eUnset_7(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.freeze = function freeze() {
    this.eFlags |= 1;
};
_.getEAnnotation = function getEAnnotation(source) {
    return $getEAnnotation(this, source);
};
_.eFlags = 0;
var Lorg_eclipse_emf_ecore_impl_EModelElementImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EModelElementImpl', 157);
function $clinit_EFactoryImpl() {
    $clinit_EFactoryImpl = emptyMethod;
    HEX_DIGITS = stampJavaTypeInfo(getClassLiteralForArray(C_classLit, 1), $intern_44, 30, 15, [
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        65,
        66,
        67,
        68,
        69,
        70
    ]);
    WHITE_SPACE = new RegExp('[ \t\n\r\f]+');
    try {
        EDATE_FORMATS = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_impl_EFactoryImpl$InternalEDateTimeFormat_2_classLit, 1), $intern_2, 2060, 0, [
            new EFactoryImpl$1ClientInternalEDateTimeFormat(($clinit_DateTimeFormat_0(), getFormat("yyyy-MM-dd'T'HH:mm:ss'.'SSSZ", $getDateTimeFormatInfo(($clinit_LocaleInfo(), $clinit_LocaleInfo(), instance_0))))),
            new EFactoryImpl$1ClientInternalEDateTimeFormat(getFormat("yyyy-MM-dd'T'HH:mm:ss'.'SSS", $getDateTimeFormatInfo(instance_0))),
            new EFactoryImpl$1ClientInternalEDateTimeFormat(getFormat("yyyy-MM-dd'T'HH:mm:ss", $getDateTimeFormatInfo(instance_0))),
            new EFactoryImpl$1ClientInternalEDateTimeFormat(getFormat("yyyy-MM-dd'T'HH:mm", $getDateTimeFormatInfo(instance_0))),
            new EFactoryImpl$1ClientInternalEDateTimeFormat(getFormat('yyyy-MM-dd', $getDateTimeFormatInfo(instance_0)))
        ]);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (!instanceOf($e0, 80)) throw toJs($e0);
    }
}
function $basicSetEPackage(this$static, newEPackage, msgs) {
    var notification, oldEPackage;
    oldEPackage = this$static.ePackage;
    this$static.ePackage = newEPackage;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 1, oldEPackage, newEPackage);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    return msgs;
}
function $bytesToHexString(bytes, count) {
    var high, i, j, low, result;
    if (bytes == null) return null;
    else {
        result = initUnidimensionalArray(C_classLit, $intern_44, 30, 2 * count, 15, 1);
        for(i = 0, j = 0; i < count; ++i){
            high = bytes[i] >> 4 & 15;
            low = bytes[i] & 15;
            result[j++] = HEX_DIGITS[high];
            result[j++] = HEX_DIGITS[low];
        }
        return valueOf_8(result, 0, result.length);
    }
}
function $convertToString(this$static, eDataType, objectValue) {
    var baseType, item_0, item$iterator, itemType, list, memberType, memberType$iterator, memberTypes, result;
    if (this$static.ePackage != eDataType.getEPackage()) throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    baseType = $getExtendedMetaData(($clinit_ExtendedMetaData(), INSTANCE_11), eDataType).getBaseType();
    if (baseType) return baseType.getEPackage().getEFactoryInstance().convertToString(baseType, objectValue);
    itemType = $getExtendedMetaData(INSTANCE_11, eDataType).getItemType();
    if (itemType) {
        if (objectValue == null) return null;
        list = castTo(objectValue, 15);
        if (list.isEmpty()) return '';
        result = new StringBuffer;
        for(item$iterator = list.iterator_0(); item$iterator.hasNext_0();){
            item_0 = item$iterator.next_1();
            $append_3(result, itemType.getEPackage().getEFactoryInstance().convertToString(itemType, item_0));
            result.string += ' ';
        }
        return $substring(result, result.string.length - 1);
    }
    memberTypes = $getExtendedMetaData(INSTANCE_11, eDataType).getMemberTypes();
    if (!memberTypes.isEmpty()) {
        for(memberType$iterator = memberTypes.iterator_0(); memberType$iterator.hasNext_0();){
            memberType = castTo(memberType$iterator.next_1(), 155);
            if (memberType.isInstance(objectValue)) try {
                result = memberType.getEPackage().getEFactoryInstance().convertToString(memberType, objectValue);
                if (result != null) return result;
            } catch ($e0) {
                $e0 = toJava($e0);
                if (!instanceOf($e0, 103)) throw toJs($e0);
            }
        }
        throw toJs(new IllegalArgumentException_0("Invalid value: '" + objectValue + "' for datatype :" + eDataType.getName()));
    }
    castTo(eDataType, 826).getConversionDelegate();
    return objectValue == null ? null : instanceOf(objectValue, 179) ? '' + castTo(objectValue, 179).value_0 : getClass__Ljava_lang_Class___devirtual$(objectValue) == Ljava_util_Date_2_classLit ? $format_0(EDATE_FORMATS[0], castTo(objectValue, 205)) : toString_40(objectValue);
}
function $createFromString(this$static, eDataType, stringValue) {
    var baseType, c, carray, charValue, i, item_0, item$array, item$index, item$max, itemType, memberType, memberType$iterator, memberTypes, result;
    if (stringValue == null) return null;
    if (this$static.ePackage != eDataType.getEPackage()) throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    if (instanceOf(eDataType, 455)) {
        result = $getEEnumLiteralByLiteral(castTo(eDataType, 670), stringValue);
        if (!result) throw toJs(new IllegalArgumentException_0("The value '" + stringValue + "' is not a valid enumerator of '" + eDataType.getName() + "'"));
        return result;
    }
    switch($getExtendedMetaData(($clinit_ExtendedMetaData(), INSTANCE_11), eDataType).getWhiteSpaceFacet()){
        case 2:
            stringValue = normalize(stringValue, false);
            break;
        case 3:
            stringValue = normalize(stringValue, true);
            break;
    }
    baseType = $getExtendedMetaData(INSTANCE_11, eDataType).getBaseType();
    if (baseType) return baseType.getEPackage().getEFactoryInstance().createFromString(baseType, stringValue);
    itemType = $getExtendedMetaData(INSTANCE_11, eDataType).getItemType();
    if (itemType) {
        result = new ArrayList;
        for(item$array = $split_5(stringValue), item$index = 0, item$max = item$array.length; item$index < item$max; ++item$index){
            item_0 = item$array[item$index];
            $add_3(result, itemType.getEPackage().getEFactoryInstance().createFromString(itemType, item_0));
        }
        return result;
    }
    memberTypes = $getExtendedMetaData(INSTANCE_11, eDataType).getMemberTypes();
    if (!memberTypes.isEmpty()) {
        for(memberType$iterator = memberTypes.iterator_0(); memberType$iterator.hasNext_0();){
            memberType = castTo(memberType$iterator.next_1(), 155);
            try {
                result = memberType.getEPackage().getEFactoryInstance().createFromString(memberType, stringValue);
                if (result != null) return result;
            } catch ($e0) {
                $e0 = toJava($e0);
                if (!instanceOf($e0, 63)) throw toJs($e0);
            }
        }
        throw toJs(new IllegalArgumentException_0("The value '" + stringValue + "' does not match any member types of the union datatype '" + eDataType.getName() + "'"));
    }
    castTo(eDataType, 826).getConversionDelegate();
    c = wrapperClassFor(eDataType.getInstanceClass());
    if (!c) return null;
    if (c == Ljava_lang_Character_2_classLit) {
        charValue = 0;
        try {
            charValue = __parseAndValidateInt(stringValue, $intern_42, $intern_0) & $intern_46;
        } catch ($e1) {
            $e1 = toJava($e1);
            if (instanceOf($e1, 130)) {
                carray = $toCharArray(stringValue);
                charValue = carray[0];
            } else throw toJs($e1);
        }
        return valueOf_2(charValue);
    }
    if (c == Ljava_util_Date_2_classLit) {
        for(i = 0; i < EDATE_FORMATS.length; ++i)try {
            return $parse_2(EDATE_FORMATS[i], stringValue);
        } catch ($e2) {
            $e2 = toJava($e2);
            if (!instanceOf($e2, 32)) throw toJs($e2);
        }
        throw toJs(new IllegalArgumentException_0("The value '" + stringValue + "' is not a date formatted string of the form yyyy-MM-dd'T'HH:mm:ss'.'SSSZ or a valid subset thereof"));
    }
    throw toJs(new IllegalArgumentException_0("The value '" + stringValue + "' is invalid. "));
}
function $hexStringToBytes(initialValue) {
    var high, i, j, limit, low, result, size_0;
    if (initialValue == null) return null;
    size_0 = initialValue.length;
    limit = (size_0 + 1) / 2 | 0;
    result = initUnidimensionalArray(B_classLit, $intern_139, 30, limit, 15, 1);
    size_0 % 2 != 0 && (result[--limit] = hexCharToByte((checkCriticalStringElementIndex(size_0 - 1, initialValue.length), initialValue.charCodeAt(size_0 - 1))));
    for(i = 0, j = 0; i < limit; ++i){
        high = hexCharToByte($charAt(initialValue, j++));
        low = hexCharToByte($charAt(initialValue, j++));
        result[i] = (high << 4 | low) << 24 >> 24;
    }
    return result;
}
function $setEPackage(this$static, newEPackage) {
    var msgs;
    if (newEPackage != this$static.ePackage) {
        msgs = null;
        !!this$static.ePackage && (msgs = castTo(this$static.ePackage, 52).eInverseRemove(this$static, 4, Lorg_eclipse_emf_ecore_EPackage_2_classLit, msgs));
        !!newEPackage && (msgs = castTo(newEPackage, 52).eInverseAdd(this$static, 4, Lorg_eclipse_emf_ecore_EPackage_2_classLit, msgs));
        msgs = $basicSetEPackage(this$static, newEPackage, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 1, newEPackage, newEPackage));
}
function $split_5(value_0) {
    var i, length_0, result, split_0;
    split_0 = $split(WHITE_SPACE, value_0);
    length_0 = split_0.length;
    result = initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, length_0, 6, 1);
    for(i = 0; i < length_0; ++i)result[i] = split_0[i];
    return result;
}
function EFactoryImpl() {
    $clinit_EFactoryImpl();
}
function hexCharToByte(character) {
    switch(character){
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return character - 48 << 24 >> 24;
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
            return character - 97 + 10 << 24 >> 24;
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
            return character - 65 + 10 << 24 >> 24;
        default:
            throw toJs(new NumberFormatException('Invalid hexadecimal'));
    }
}
defineClass(704, 157, {
    109: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
}, EFactoryImpl);
_.convertToString = function convertToString(eDataType, objectValue) {
    return $convertToString(this, eDataType, objectValue);
};
_.create_3 = function create_46(eClass) {
    var eGenericType, eSuperType, eSuperTypes, result, result0;
    if (this.ePackage != $getEPackage(eClass) || (eClass.eFlags & 256) != 0) throw toJs(new IllegalArgumentException_0("The class '" + eClass.name_0 + "' is not a valid classifier"));
    for(eSuperTypes = $getESuperTypes(eClass); $getEGenericSuperTypes(eSuperTypes.this$01).size_0 != 0;){
        eSuperType = castTo($resolve_1(eSuperTypes, 0, (eGenericType = castTo($get_20($getEGenericSuperTypes(eSuperTypes.this$01), 0), 87), result0 = eGenericType.eRawType, instanceOf(result0, 88) ? castTo(result0, 29) : ($clinit_EcorePackage$Literals(), EOBJECT))), 29);
        if ($getInstanceClass(eSuperType)) {
            result = $getEPackage(eSuperType).getEFactoryInstance().create_3(eSuperType);
            castTo(result, 52).eSetClass(eClass);
            return result;
        }
        eSuperTypes = $getESuperTypes(eSuperType);
    }
    return (eClass.instanceClassName != null ? eClass.instanceClassName : eClass.generatedInstanceClassName) == 'java.util.Map$Entry' ? new DynamicEObjectImpl$BasicEMapEntry(eClass) : new DynamicEObjectImpl(eClass);
};
_.createFromString = function createFromString(eDataType, stringValue) {
    return $createFromString(this, eDataType, stringValue);
};
_.eGet = function eGet_10(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.ePackage;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EFACTORY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EFACTORY : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_6(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 1:
            !!this.ePackage && (msgs = castTo(this.ePackage, 52).eInverseRemove(this, 4, Lorg_eclipse_emf_ecore_EPackage_2_classLit, msgs));
            return $basicSetEPackage(this, castTo(otherEnd, 240), msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EFACTORY) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EFACTORY)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_7(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 1:
            return $basicSetEPackage(this, null, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EFACTORY) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EFACTORY)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_9(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return !!this.ePackage;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EFACTORY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EFACTORY : eClass), featureID));
};
_.eSet = function eSet_8(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setEPackage(this, castTo(newValue, 240));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EFACTORY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EFACTORY : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_8() {
    return $clinit_EcorePackage$Literals(), EFACTORY;
};
_.eUnset = function eUnset_8(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            $setEPackage(this, null);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EFACTORY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EFACTORY : eClass), featureID));
};
var EDATE_FORMATS, HEX_DIGITS, WHITE_SPACE;
var Lorg_eclipse_emf_ecore_impl_EFactoryImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EFactoryImpl', 704);
function ElkGraphFactoryImpl() {}
function init_1() {
    $clinit_EFactoryImpl();
    var exception, theElkGraphFactory;
    try {
        theElkGraphFactory = castTo($getEFactory(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/elk/ElkGraph'), 2059);
        if (theElkGraphFactory) return theElkGraphFactory;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            exception = $e0;
            $log_2(($clinit_EcorePlugin(), exception));
        } else throw toJs($e0);
    }
    return new ElkGraphFactoryImpl;
}
defineClass(1012, 704, {
    109: 1,
    2059: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
}, ElkGraphFactoryImpl);
_.convertToString = function convertToString_0(eDataType, instanceValue) {
    switch(eDataType.getClassifierID()){
        case 12:
            return castTo(instanceValue, 144).getId();
        case 13:
            return toString_40(instanceValue);
        default:
            throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    }
};
_.create_3 = function create_47(eClass) {
    var ePackage, elkBendPoint, elkEdge, elkEdgeSection, elkLabel, elkNode, elkPort, elkPropertyToValueMapEntry;
    switch(eClass.metaObjectID == -1 && (eClass.metaObjectID = (ePackage = $getEPackage(eClass), ePackage ? $indexOf_6(ePackage.getEClassifiers(), eClass) : -1)), eClass.metaObjectID){
        case 4:
            return elkLabel = new ElkLabelImpl, elkLabel;
        case 6:
            return elkNode = new ElkNodeImpl, elkNode;
        case 7:
            return elkPort = new ElkPortImpl, elkPort;
        case 8:
            return elkEdge = new ElkEdgeImpl, elkEdge;
        case 9:
            return elkBendPoint = new ElkBendPointImpl, elkBendPoint;
        case 10:
            return elkEdgeSection = new ElkEdgeSectionImpl, elkEdgeSection;
        case 11:
            return elkPropertyToValueMapEntry = new ElkPropertyToValueMapEntryImpl, elkPropertyToValueMapEntry;
        default:
            throw toJs(new IllegalArgumentException_0("The class '" + eClass.name_0 + "' is not a valid classifier"));
    }
};
_.createFromString = function createFromString_0(eDataType, initialValue) {
    switch(eDataType.getClassifierID()){
        case 13:
        case 12:
            return null;
        default:
            throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    }
};
var Lorg_eclipse_elk_graph_impl_ElkGraphFactoryImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkGraphFactoryImpl', 1012);
function $setName(this$static, newName) {
    var oldName;
    oldName = this$static.name_0;
    this$static.name_0 = newName;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 1, oldName, this$static.name_0));
}
function $toString_21(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_16(this$static);
    result = new StringBuffer_1($toString_16(this$static));
    result.string += ' (name: ';
    $append_3(result, this$static.name_0);
    result.string += ')';
    return result.string;
}
defineClass(436, 157, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
});
_.eContents_0 = function eContents_2() {
    var eClass, eStructuralFeatures;
    eStructuralFeatures = (eClass = castTo($getField(this, 16), 29), $containments($getEAllStructuralFeatures(!eClass ? this.eStaticClass() : eClass)));
    return eStructuralFeatures == null ? ($clinit_EContentsEList(), $clinit_EContentsEList(), EMPTY_CONTENTS_ELIST) : new ENamedElementImpl$1(this, eStructuralFeatures);
};
_.eGet = function eGet_11(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.getName();
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_10(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.eSet = function eSet_9(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            this.setName(castToString(newValue));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_9() {
    return $clinit_EcorePackage$Literals(), ENAMED_ELEMENT;
};
_.eUnset = function eUnset_9(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            this.setName(null);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.getName = function getName_5() {
    return this.name_0;
};
_.setName = function setName(newName) {
    $setName(this, newName);
};
_.toString_0 = function toString_126() {
    return $toString_21(this);
};
_.name_0 = null;
var Lorg_eclipse_emf_ecore_impl_ENamedElementImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ENamedElementImpl', 436);
function $addAnnotation(eNamedElement, source, details) {
    var annotations, childAnnotations, eAnnotation, eAnnotation0, i, i0, theDetails;
    eAnnotation0 = (eAnnotation = new EAnnotationImpl, eAnnotation);
    $setSourceGen(eAnnotation0, (checkCriticalNotNull(source), source));
    theDetails = (!eAnnotation0.details && (eAnnotation0.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation0)), eAnnotation0.details);
    for(i0 = 1; i0 < details.length; i0 += 2)$put_14(theDetails, details[i0 - 1], details[i0]);
    annotations = (!eNamedElement.eAnnotations && (eNamedElement.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, eNamedElement, 0, 3)), eNamedElement.eAnnotations);
    for(i = 0; i < 0; ++i){
        childAnnotations = $getContents(castTo($get_20(annotations, annotations.size_0 - 1), 582));
        annotations = childAnnotations;
    }
    $add_21(annotations, eAnnotation0);
}
function $addEException(owner, exception) {
    $add_21((!owner.eExceptions && (owner.eExceptions = new EOperationImpl$1(owner, owner)), owner.eExceptions), exception);
}
function $addEOperation(owner, type_0, name_0) {
    var eOperation, o;
    o = (eOperation = new EOperationImpl, eOperation);
    $initEOperation(o, type_0, name_0);
    $add_21((!owner.eOperations && (owner.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, owner, 11, 10)), owner.eOperations), o);
    return o;
}
function $addEParameter(owner, type_0, name_0) {
    var p, p_0;
    p = (p_0 = new EParameterImpl, $setEType(p_0, type_0), $setName(p_0, name_0), $add_21((!owner.eParameters && (owner.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, owner, 12, 10)), owner.eParameters), p_0), p_0);
    $setLowerBound(p, 0);
    $setUpperBound(p, 1);
    $setUnique_2(p, true);
    $setOrdered(p, true);
    return p;
}
function $addEParameter_0(owner, type_0, name_0) {
    var eParameter, msgs, p;
    p = (eParameter = new EParameterImpl, eParameter);
    msgs = $setEGenericType(p, type_0, null);
    !!msgs && msgs.dispatch_0();
    $setName(p, name_0);
    $add_21((!owner.eParameters && (owner.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, owner, 12, 10)), owner.eParameters), p);
    $setLowerBound(p, 0);
    $setUpperBound(p, 1);
    $setUnique_2(p, true);
    $setOrdered(p, true);
}
function $addETypeParameter(owner, name_0) {
    var eTypeParameter, eTypeParameter0;
    eTypeParameter0 = (eTypeParameter = new ETypeParameterImpl, eTypeParameter);
    $setName(eTypeParameter0, name_0);
    $add_21((!owner.eTypeParameters && (owner.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, owner, 7)), owner.eTypeParameters), eTypeParameter0);
    return eTypeParameter0;
}
function $addETypeParameter_0(owner) {
    var eTypeParameter, eTypeParameter0;
    eTypeParameter0 = (eTypeParameter = new ETypeParameterImpl, eTypeParameter);
    $setName(eTypeParameter0, 'T');
    $add_21((!owner.eTypeParameters && (owner.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, owner, 11)), owner.eTypeParameters), eTypeParameter0);
    return eTypeParameter0;
}
function $basicGetESuperPackage(this$static) {
    if (this$static.eFlags_0 >> 16 != 7) return null;
    return castTo(this$static.eContainer, 240);
}
function $basicSetEFactoryInstance(this$static, newEFactoryInstance, msgs) {
    var notification, oldEFactoryInstance;
    oldEFactoryInstance = this$static.eFactoryInstance;
    this$static.eFactoryInstance = newEFactoryInstance;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 4, oldEFactoryInstance, newEFactoryInstance);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    return msgs;
}
function $createEAttribute(owner, id_0) {
    var a, eAttribute;
    a = (eAttribute = new EAttributeImpl, eAttribute);
    a.featureID = id_0;
    $add_21((!owner.eStructuralFeatures && (owner.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, owner, 21, 17)), owner.eStructuralFeatures), a);
}
function $createEClass(this$static, id_0) {
    var c, eClass;
    c = (eClass = new EClassImpl, eClass);
    c.metaObjectID = id_0;
    !this$static.eClassifiers && (this$static.eClassifiers = new EPackageImpl$2(this$static, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this$static));
    $add_21(this$static.eClassifiers, c);
    return c;
}
function $createEDataType(this$static, id_0) {
    var d, eDataType;
    d = (eDataType = new EDataTypeImpl, eDataType);
    d.metaObjectID = id_0;
    !this$static.eClassifiers && (this$static.eClassifiers = new EPackageImpl$2(this$static, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this$static));
    $add_21(this$static.eClassifiers, d);
    return d;
}
function $createEGenericType(eClassifier) {
    var eGenericType, eGenericType0;
    eGenericType0 = (eGenericType = new EGenericTypeImpl, eGenericType);
    $setEClassifier(eGenericType0, eClassifier);
    return eGenericType0;
}
function $createEGenericType_0(eTypeParameter) {
    var eGenericType, eGenericType0;
    eGenericType0 = (eGenericType = new EGenericTypeImpl, eGenericType);
    $setETypeParameter(eGenericType0, eTypeParameter);
    return eGenericType0;
}
function $createEOperation(owner) {
    var eOperation, o;
    o = (eOperation = new EOperationImpl, eOperation);
    $add_21((!owner.eOperations && (owner.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, owner, 11, 10)), owner.eOperations), o);
}
function $createEReference(owner, id_0) {
    var eReference, r;
    r = (eReference = new EReferenceImpl, eReference);
    r.featureID = id_0;
    $add_21((!owner.eStructuralFeatures && (owner.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, owner, 21, 17)), owner.eStructuralFeatures), r);
}
function $createResource(this$static, uri_0) {
    var actualURI, resource;
    resource = $eInternalResource(this$static);
    if (!resource) {
        !resourceFactory && (resourceFactory = new EPackageImpl$3);
        actualURI = ($clinit_URI(), createURIWithCache(uri_0));
        resource = new BinaryResourceImpl(actualURI);
        $add_21(resource.getContents(), this$static);
    }
    return resource;
}
function $eBasicRemoveFromContainerFeature_1(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 7) return this$static.eContainer.eInverseRemove(this$static, 6, Lorg_eclipse_emf_ecore_EPackage_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EPACKAGE) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $freeze_0(this$static) {
    var i, size_0;
    if (this$static.eClassifiers) for(i = 0, size_0 = this$static.eClassifiers.size_0; i < size_0; ++i)$freeze($get_20(this$static.eClassifiers, i));
    if (this$static.eSubpackages) for(i = 0, size_0 = this$static.eSubpackages.size_0; i < size_0; ++i)$freeze($get_20(this$static.eSubpackages, i));
    $getNamespace(($clinit_ExtendedMetaData(), INSTANCE_11), this$static);
    this$static.eFlags |= 1;
}
function $getEClassifierGen(this$static, name_0) {
    var duplicate, eClassifier, eClassifier$iterator, eClassifiers, key, result;
    if (!this$static.eNameToEClassifierMap) {
        eClassifiers = (!this$static.eClassifiers && (this$static.eClassifiers = new EPackageImpl$2(this$static, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this$static)), this$static.eClassifiers);
        result = new HashMap_0(eClassifiers.size_0);
        for(eClassifier$iterator = new AbstractEList$EIterator(eClassifiers); eClassifier$iterator.cursor != eClassifier$iterator.this$01_2.size_1();){
            eClassifier = castTo($doNext(eClassifier$iterator), 141);
            key = eClassifier.getName();
            duplicate = castTo(key == null ? $put_9(result.hashCodeMap, null, eClassifier) : $put_10(result.stringMap, key, eClassifier), 141);
            !!duplicate && (key == null ? $put_9(result.hashCodeMap, null, duplicate) : $put_10(result.stringMap, key, duplicate));
        }
        this$static.eNameToEClassifierMap = result;
    }
    return castTo($getStringValue(this$static.eNameToEClassifierMap, name_0), 141);
}
function $initEAttribute(a, type_0, name_0, defaultValue, lowerBound, upperBound, containerClass, isTransient, isVolatile, isChangeable, isUnsettable, isUnique, isDerived) {
    $initEStructuralFeature(a, type_0, name_0, defaultValue, lowerBound, upperBound, containerClass, isTransient, isVolatile, isChangeable, isUnsettable, isUnique, isDerived);
    $setID(a, false);
    return a;
}
function $initEAttribute_0(a, type_0, name_0, containerClass, isTransient, isVolatile, isChangeable, isDerived) {
    var msgs;
    instanceOf(a.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(a.eContainer, 88)), 4);
    $setName(a, name_0);
    a.containerClass = containerClass;
    $setTransient(a, isTransient);
    $setVolatile(a, isVolatile);
    $setChangeable(a, isChangeable);
    $setUnsettable(a, false);
    $setUnique_2(a, true);
    $setDerived(a, isDerived);
    $setOrdered(a, true);
    $setLowerBound(a, 0);
    a.effectiveIsMany = 0;
    $setUpperBound(a, 1);
    msgs = $setEGenericType(a, type_0, null);
    !!msgs && msgs.dispatch_0();
    $setID(a, false);
    return a;
}
function $initEClass(c, instanceClass, name_0, isAbstract, isInterface, isGenerated) {
    $initEClassifier(c, instanceClass, name_0, isGenerated);
    $setAbstract(c, isAbstract);
    $setInterface(c, isInterface);
    return c;
}
function $initEClassifier(o, instanceClass, name_0, isGenerated) {
    instanceOf(o.eContainer, 184) && (castTo(o.eContainer, 184).eNameToEClassifierMap = null);
    $setName(o, name_0);
    !!instanceClass && $setInstanceClass(o, instanceClass);
    isGenerated && o.setGeneratedInstanceClass(true);
}
function $initEDataType(d, instanceClass, name_0, isSerializable) {
    $initEClassifier(d, instanceClass, name_0, false);
    $setSerializable(d, isSerializable);
    return d;
}
function $initEOperation(eOperation, type_0, name_0) {
    $setEType(eOperation, type_0);
    $setName(eOperation, name_0);
    $setLowerBound(eOperation, 0);
    $setUpperBound(eOperation, 1);
    $setUnique_2(eOperation, true);
    $setOrdered(eOperation, true);
    return eOperation;
}
function $initEReference(r, type_0, otherEnd, name_0, lowerBound, upperBound, containerClass, isTransient, isVolatile, isChangeable, isContainment, isResolveProxies, isUnsettable, isDerived) {
    $initEStructuralFeature(r, type_0, name_0, null, lowerBound, upperBound, containerClass, isTransient, isVolatile, isChangeable, isUnsettable, true, isDerived);
    $setContainmentGen(r, isContainment);
    instanceOf(r.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(r.eContainer, 88)), 2);
    !!otherEnd && $setEOpposite(r, otherEnd);
    $setResolveProxies(r, isResolveProxies);
    return r;
}
function $initEStructuralFeature(s, type_0, name_0, defaultValue, lowerBound, upperBound, containerClass, isTransient, isVolatile, isChangeable, isUnsettable, isUnique, isDerived) {
    instanceOf(s.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(s.eContainer, 88)), 4);
    $setName(s, name_0);
    s.containerClass = containerClass;
    $setTransient(s, isTransient);
    $setVolatile(s, isVolatile);
    $setChangeable(s, isChangeable);
    $setUnsettable(s, isUnsettable);
    $setUnique_2(s, isUnique);
    $setDerived(s, isDerived);
    $setOrdered(s, true);
    $setLowerBound(s, lowerBound);
    s.setUpperBound(upperBound);
    $setEType(s, type_0);
    defaultValue != null && (s.defaultValueFactory = null, $setDefaultValueLiteralGen(s, defaultValue));
}
function $setEFactoryInstance(this$static, newEFactoryInstance) {
    var msgs;
    if (newEFactoryInstance != this$static.eFactoryInstance) {
        msgs = null;
        !!this$static.eFactoryInstance && (msgs = castTo(this$static.eFactoryInstance, 52).eInverseRemove(this$static, 1, Lorg_eclipse_emf_ecore_EFactory_2_classLit, msgs));
        !!newEFactoryInstance && (msgs = castTo(newEFactoryInstance, 52).eInverseAdd(this$static, 1, Lorg_eclipse_emf_ecore_EFactory_2_classLit, msgs));
        msgs = $basicSetEFactoryInstance(this$static, newEFactoryInstance, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 4, newEFactoryInstance, newEFactoryInstance));
}
function $setNsPrefix(this$static, newNsPrefix) {
    var oldNsPrefix;
    oldNsPrefix = this$static.nsPrefix;
    this$static.nsPrefix = newNsPrefix;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 3, oldNsPrefix, this$static.nsPrefix));
}
function $setNsURI(this$static, newNsURI) {
    var oldNsURI;
    oldNsURI = this$static.nsURI;
    this$static.nsURI = newNsURI;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 2, oldNsURI, this$static.nsURI));
}
function EPackageImpl() {
    $setEFactoryInstance(this, new EFactoryImpl);
    this.ecorePackage = ($clinit_EcorePackage(), eINSTANCE_2);
    $clinit_EcoreFactory();
}
function EPackageImpl_0(packageURI, factory) {
    var registration;
    registration = $getStringValue(($clinit_EPackage$Registry(), INSTANCE_6), packageURI);
    instanceOf(registration, 491) ? $putStringValue(INSTANCE_6, packageURI, new EPackageImpl$1(this, factory)) : $putStringValue(INSTANCE_6, packageURI, this);
    $setEFactoryInstance(this, factory);
    if (factory == ($clinit_EcoreFactory(), eINSTANCE_1)) {
        this.ecorePackage = castTo(this, 1984);
        castTo(factory, 1986);
    } else this.ecorePackage = ($clinit_EcorePackage(), eINSTANCE_2);
}
defineClass(184, 436, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    117: 1,
    118: 1,
    675: 1
}, EPackageImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_2(msgs) {
    return $eBasicRemoveFromContainerFeature_1(this, msgs);
};
_.eGet = function eGet_12(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return this.nsURI;
        case 3:
            return this.nsPrefix;
        case 4:
            return this.eFactoryInstance;
        case 5:
            return !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this)), this.eClassifiers;
        case 6:
            return !this.eSubpackages && (this.eSubpackages = new EObjectContainmentWithInverseEList$Resolving(Lorg_eclipse_emf_ecore_EPackage_2_classLit, this, 6, 7)), this.eSubpackages;
        case 7:
            if (resolve) return this.eFlags_0 >> 16 == 7 ? castTo(this.eContainer, 240) : null;
            return $basicGetESuperPackage(this);
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPACKAGE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EPACKAGE : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_7(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 4:
            !!this.eFactoryInstance && (msgs = castTo(this.eFactoryInstance, 52).eInverseRemove(this, 1, Lorg_eclipse_emf_ecore_EFactory_2_classLit, msgs));
            return $basicSetEFactoryInstance(this, castTo(otherEnd, 466), msgs);
        case 5:
            return !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this)), $basicAdd_0(this.eClassifiers, otherEnd, msgs);
        case 6:
            return !this.eSubpackages && (this.eSubpackages = new EObjectContainmentWithInverseEList$Resolving(Lorg_eclipse_emf_ecore_EPackage_2_classLit, this, 6, 7)), $basicAdd_0(this.eSubpackages, otherEnd, msgs);
        case 7:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_1(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 7, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EPACKAGE) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPACKAGE)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_8(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 4:
            return $basicSetEFactoryInstance(this, null, msgs);
        case 5:
            return !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this)), $basicRemove_0(this.eClassifiers, otherEnd, msgs);
        case 6:
            return !this.eSubpackages && (this.eSubpackages = new EObjectContainmentWithInverseEList$Resolving(Lorg_eclipse_emf_ecore_EPackage_2_classLit, this, 6, 7)), $basicRemove_0(this.eSubpackages, otherEnd, msgs);
        case 7:
            return $eBasicSetContainer(this, null, 7, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EPACKAGE) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPACKAGE)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_11(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return this.nsURI != null;
        case 3:
            return this.nsPrefix != null;
        case 4:
            return !!this.eFactoryInstance;
        case 5:
            return !!this.eClassifiers && this.eClassifiers.size_0 != 0;
        case 6:
            return !!this.eSubpackages && this.eSubpackages.size_0 != 0;
        case 7:
            return !!$basicGetESuperPackage(this);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPACKAGE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EPACKAGE : eClass), featureID));
};
_.eObjectForURIFragmentSegment = function eObjectForURIFragmentSegment_1(uriFragmentSegment) {
    var result;
    result = $getEClassifierGen(this, uriFragmentSegment);
    return result ? result : $eObjectForURIFragmentSegment_0(this, uriFragmentSegment);
};
_.eSet = function eSet_10(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName(this, castToString(newValue));
            return;
        case 2:
            $setNsURI(this, castToString(newValue));
            return;
        case 3:
            $setNsPrefix(this, castToString(newValue));
            return;
        case 4:
            $setEFactoryInstance(this, castTo(newValue, 466));
            return;
        case 5:
            !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this));
            $clear_13(this.eClassifiers);
            !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this));
            $addAll_9(this.eClassifiers, castTo(newValue, 16));
            return;
        case 6:
            !this.eSubpackages && (this.eSubpackages = new EObjectContainmentWithInverseEList$Resolving(Lorg_eclipse_emf_ecore_EPackage_2_classLit, this, 6, 7));
            $clear_13(this.eSubpackages);
            !this.eSubpackages && (this.eSubpackages = new EObjectContainmentWithInverseEList$Resolving(Lorg_eclipse_emf_ecore_EPackage_2_classLit, this, 6, 7));
            $addAll_9(this.eSubpackages, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPACKAGE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EPACKAGE : eClass), featureID), newValue);
};
_.eSetProxyURI = function eSetProxyURI_1(uri_0) {
    var eClassifier, eClassifier$iterator;
    if (!!uri_0 && !!this.eClassifiers) for(eClassifier$iterator = new AbstractEList$EIterator(this.eClassifiers); eClassifier$iterator.cursor != eClassifier$iterator.this$01_2.size_1();){
        eClassifier = $doNext(eClassifier$iterator);
        instanceOf(eClassifier, 357) && (castTo(eClassifier, 357).ePackage = null);
    }
    $setField(this, 64, uri_0);
};
_.eStaticClass = function eStaticClass_10() {
    return $clinit_EcorePackage$Literals(), EPACKAGE;
};
_.eUnset = function eUnset_10(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            $setName(this, null);
            return;
        case 2:
            $setNsURI(this, null);
            return;
        case 3:
            $setNsPrefix(this, null);
            return;
        case 4:
            $setEFactoryInstance(this, null);
            return;
        case 5:
            !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this));
            $clear_13(this.eClassifiers);
            return;
        case 6:
            !this.eSubpackages && (this.eSubpackages = new EObjectContainmentWithInverseEList$Resolving(Lorg_eclipse_emf_ecore_EPackage_2_classLit, this, 6, 7));
            $clear_13(this.eSubpackages);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPACKAGE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EPACKAGE : eClass), featureID));
};
_.freeze = function freeze_0() {
    $freeze_0(this);
};
_.getEClassifiers = function getEClassifiers() {
    return !this.eClassifiers && (this.eClassifiers = new EPackageImpl$2(this, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, this)), this.eClassifiers;
};
_.getEFactoryInstance = function getEFactoryInstance() {
    return this.eFactoryInstance;
};
_.getExtendedMetaData = function getExtendedMetaData() {
    return this.ePackageExtendedMetaData;
};
_.getNsPrefix = function getNsPrefix() {
    return this.nsPrefix;
};
_.getNsURI = function getNsURI() {
    return this.nsURI;
};
_.setExtendedMetaData = function setExtendedMetaData(ePackageExtendedMetaData) {
    this.ePackageExtendedMetaData = ePackageExtendedMetaData;
};
_.toString_0 = function toString_127() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_21(this);
    result = new StringBuffer_1($toString_21(this));
    result.string += ' (nsURI: ';
    $append_3(result, this.nsURI);
    result.string += ', nsPrefix: ';
    $append_3(result, this.nsPrefix);
    result.string += ')';
    return result.string;
};
_.nsPrefix = null;
_.nsURI = null;
var resourceFactory;
var Lorg_eclipse_emf_ecore_impl_EPackageImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EPackageImpl', 184);
function $createPackageContents(this$static) {
    if (this$static.isCreated) return;
    this$static.isCreated = true;
    this$static.iPropertyHolderEClass = $createEClass(this$static, 0);
    this$static.eMapPropertyHolderEClass = $createEClass(this$static, 1);
    $createEReference(this$static.eMapPropertyHolderEClass, 0);
    this$static.elkGraphElementEClass = $createEClass(this$static, 2);
    $createEReference(this$static.elkGraphElementEClass, 1);
    $createEAttribute(this$static.elkGraphElementEClass, 2);
    this$static.elkShapeEClass = $createEClass(this$static, 3);
    $createEAttribute(this$static.elkShapeEClass, 3);
    $createEAttribute(this$static.elkShapeEClass, 4);
    $createEAttribute(this$static.elkShapeEClass, 5);
    $createEAttribute(this$static.elkShapeEClass, 6);
    this$static.elkLabelEClass = $createEClass(this$static, 4);
    $createEReference(this$static.elkLabelEClass, 7);
    $createEAttribute(this$static.elkLabelEClass, 8);
    this$static.elkConnectableShapeEClass = $createEClass(this$static, 5);
    $createEReference(this$static.elkConnectableShapeEClass, 7);
    $createEReference(this$static.elkConnectableShapeEClass, 8);
    this$static.elkNodeEClass = $createEClass(this$static, 6);
    $createEReference(this$static.elkNodeEClass, 9);
    $createEReference(this$static.elkNodeEClass, 10);
    $createEReference(this$static.elkNodeEClass, 11);
    $createEReference(this$static.elkNodeEClass, 12);
    $createEAttribute(this$static.elkNodeEClass, 13);
    this$static.elkPortEClass = $createEClass(this$static, 7);
    $createEReference(this$static.elkPortEClass, 9);
    this$static.elkEdgeEClass = $createEClass(this$static, 8);
    $createEReference(this$static.elkEdgeEClass, 3);
    $createEReference(this$static.elkEdgeEClass, 4);
    $createEReference(this$static.elkEdgeEClass, 5);
    $createEReference(this$static.elkEdgeEClass, 6);
    $createEAttribute(this$static.elkEdgeEClass, 7);
    $createEAttribute(this$static.elkEdgeEClass, 8);
    $createEAttribute(this$static.elkEdgeEClass, 9);
    $createEAttribute(this$static.elkEdgeEClass, 10);
    this$static.elkBendPointEClass = $createEClass(this$static, 9);
    $createEAttribute(this$static.elkBendPointEClass, 0);
    $createEAttribute(this$static.elkBendPointEClass, 1);
    this$static.elkEdgeSectionEClass = $createEClass(this$static, 10);
    $createEAttribute(this$static.elkEdgeSectionEClass, 1);
    $createEAttribute(this$static.elkEdgeSectionEClass, 2);
    $createEAttribute(this$static.elkEdgeSectionEClass, 3);
    $createEAttribute(this$static.elkEdgeSectionEClass, 4);
    $createEReference(this$static.elkEdgeSectionEClass, 5);
    $createEReference(this$static.elkEdgeSectionEClass, 6);
    $createEReference(this$static.elkEdgeSectionEClass, 7);
    $createEReference(this$static.elkEdgeSectionEClass, 8);
    $createEReference(this$static.elkEdgeSectionEClass, 9);
    $createEReference(this$static.elkEdgeSectionEClass, 10);
    $createEAttribute(this$static.elkEdgeSectionEClass, 11);
    this$static.elkPropertyToValueMapEntryEClass = $createEClass(this$static, 11);
    $createEAttribute(this$static.elkPropertyToValueMapEntryEClass, 0);
    $createEAttribute(this$static.elkPropertyToValueMapEntryEClass, 1);
    this$static.iPropertyEDataType = $createEDataType(this$static, 12);
    this$static.propertyValueEDataType = $createEDataType(this$static, 13);
}
function $initializePackageContents(this$static) {
    var eGenericType, eGenericType0, eGenericType1, eGenericType2, eGenericType3, eGenericType4, eGenericType5, eGenericType6, g1, g2, g3, msgs, msgs0, op, t1;
    if (this$static.isInitialized) return;
    this$static.isInitialized = true;
    $setName(this$static, 'graph');
    $setNsPrefix(this$static, 'graph');
    $setNsURI(this$static, 'http://www.eclipse.org/elk/ElkGraph');
    $addETypeParameter(this$static.iPropertyEDataType, 'T');
    $add_21($getESuperTypes(this$static.eMapPropertyHolderEClass), this$static.iPropertyHolderEClass);
    $add_21($getESuperTypes(this$static.elkGraphElementEClass), this$static.eMapPropertyHolderEClass);
    $add_21($getESuperTypes(this$static.elkShapeEClass), this$static.elkGraphElementEClass);
    $add_21($getESuperTypes(this$static.elkLabelEClass), this$static.elkShapeEClass);
    $add_21($getESuperTypes(this$static.elkConnectableShapeEClass), this$static.elkShapeEClass);
    $add_21($getESuperTypes(this$static.elkNodeEClass), this$static.elkConnectableShapeEClass);
    $add_21($getESuperTypes(this$static.elkPortEClass), this$static.elkConnectableShapeEClass);
    $add_21($getESuperTypes(this$static.elkEdgeEClass), this$static.elkGraphElementEClass);
    $add_21($getESuperTypes(this$static.elkEdgeSectionEClass), this$static.eMapPropertyHolderEClass);
    $initEClass(this$static.iPropertyHolderEClass, Lorg_eclipse_elk_graph_properties_IPropertyHolder_2_classLit, 'IPropertyHolder', true, true, false);
    op = $addEOperation(this$static.iPropertyHolderEClass, this$static.iPropertyHolderEClass, 'setProperty');
    t1 = $addETypeParameter_0(op);
    g1 = $createEGenericType(this$static.iPropertyEDataType);
    g2 = (eGenericType0 = (eGenericType1 = new EGenericTypeImpl, eGenericType1), eGenericType0);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    g3 = $createEGenericType_0(t1);
    $setELowerBound(g2, g3);
    $addEParameter_0(op, g1, 'property');
    g1 = $createEGenericType_0(t1);
    $addEParameter_0(op, g1, 'value');
    op = $addEOperation(this$static.iPropertyHolderEClass, null, 'getProperty');
    t1 = $addETypeParameter_0(op);
    g1 = $createEGenericType(this$static.iPropertyEDataType);
    g2 = $createEGenericType_0(t1);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    $addEParameter_0(op, g1, 'property');
    g1 = $createEGenericType_0(t1);
    msgs0 = $setEGenericType(op, g1, null);
    !!msgs0 && msgs0.dispatch_0();
    op = $addEOperation(this$static.iPropertyHolderEClass, this$static.ecorePackage.eBooleanEDataType, 'hasProperty');
    g1 = $createEGenericType(this$static.iPropertyEDataType);
    g2 = (eGenericType2 = (eGenericType3 = new EGenericTypeImpl, eGenericType3), eGenericType2);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    $addEParameter_0(op, g1, 'property');
    op = $addEOperation(this$static.iPropertyHolderEClass, this$static.iPropertyHolderEClass, 'copyProperties');
    $addEParameter(op, this$static.iPropertyHolderEClass, 'source');
    op = $addEOperation(this$static.iPropertyHolderEClass, null, 'getAllProperties');
    g1 = $createEGenericType(this$static.ecorePackage.eMapEDataType);
    g2 = $createEGenericType(this$static.iPropertyEDataType);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    g3 = (eGenericType4 = (eGenericType5 = new EGenericTypeImpl, eGenericType5), eGenericType4);
    $add_21((!g2.eTypeArguments && (g2.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g2, 1)), g2.eTypeArguments), g3);
    g2 = $createEGenericType(this$static.ecorePackage.eJavaObjectEDataType);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    msgs = $setEGenericType(op, g1, null);
    !!msgs && msgs.dispatch_0();
    $initEClass(this$static.eMapPropertyHolderEClass, Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit, 'EMapPropertyHolder', true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eMapPropertyHolderEClass), 0), 19), this$static.elkPropertyToValueMapEntryEClass, null, 'properties', 0, -1, Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit, false, false, true, true, false, false, false);
    $initEClass(this$static.elkGraphElementEClass, Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit, 'ElkGraphElement', true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkGraphElementEClass), 0), 19), this$static.elkLabelEClass, castTo($get_20($getEStructuralFeatures(this$static.elkLabelEClass), 0), 19), 'labels', 0, -1, Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit, false, false, true, true, false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkGraphElementEClass), 1), 35), this$static.ecorePackage.eStringEDataType, 'identifier', null, 0, 1, Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit, false, false, true, false, true, false);
    $initEClass(this$static.elkShapeEClass, Lorg_eclipse_elk_graph_ElkShape_2_classLit, 'ElkShape', true, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkShapeEClass), 0), 35), this$static.ecorePackage.eDoubleEDataType, 'height', '0.0', 1, 1, Lorg_eclipse_elk_graph_ElkShape_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkShapeEClass), 1), 35), this$static.ecorePackage.eDoubleEDataType, 'width', '0.0', 1, 1, Lorg_eclipse_elk_graph_ElkShape_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkShapeEClass), 2), 35), this$static.ecorePackage.eDoubleEDataType, 'x', '0.0', 1, 1, Lorg_eclipse_elk_graph_ElkShape_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkShapeEClass), 3), 35), this$static.ecorePackage.eDoubleEDataType, 'y', '0.0', 1, 1, Lorg_eclipse_elk_graph_ElkShape_2_classLit, false, false, true, false, true, false);
    op = $addEOperation(this$static.elkShapeEClass, null, 'setDimensions');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'width');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'height');
    op = $addEOperation(this$static.elkShapeEClass, null, 'setLocation');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'x');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'y');
    $initEClass(this$static.elkLabelEClass, Lorg_eclipse_elk_graph_ElkLabel_2_classLit, 'ElkLabel', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkLabelEClass), 0), 19), this$static.elkGraphElementEClass, castTo($get_20($getEStructuralFeatures(this$static.elkGraphElementEClass), 0), 19), 'parent', 0, 1, Lorg_eclipse_elk_graph_ElkLabel_2_classLit, false, false, true, false, false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkLabelEClass), 1), 35), this$static.ecorePackage.eStringEDataType, 'text', '', 0, 1, Lorg_eclipse_elk_graph_ElkLabel_2_classLit, false, false, true, false, true, false);
    $initEClass(this$static.elkConnectableShapeEClass, Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, 'ElkConnectableShape', true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkConnectableShapeEClass), 0), 19), this$static.elkEdgeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 1), 19), 'outgoingEdges', 0, -1, Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkConnectableShapeEClass), 1), 19), this$static.elkEdgeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 2), 19), 'incomingEdges', 0, -1, Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, false, false, true, false, true, false, false);
    $initEClass(this$static.elkNodeEClass, Lorg_eclipse_elk_graph_ElkNode_2_classLit, 'ElkNode', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 0), 19), this$static.elkPortEClass, castTo($get_20($getEStructuralFeatures(this$static.elkPortEClass), 0), 19), 'ports', 0, -1, Lorg_eclipse_elk_graph_ElkNode_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 1), 19), this$static.elkNodeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 2), 19), 'children', 0, -1, Lorg_eclipse_elk_graph_ElkNode_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 2), 19), this$static.elkNodeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 1), 19), 'parent', 0, 1, Lorg_eclipse_elk_graph_ElkNode_2_classLit, false, false, true, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 3), 19), this$static.elkEdgeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 0), 19), 'containedEdges', 0, -1, Lorg_eclipse_elk_graph_ElkNode_2_classLit, false, false, true, true, false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 4), 35), this$static.ecorePackage.eBooleanEDataType, 'hierarchical', null, 0, 1, Lorg_eclipse_elk_graph_ElkNode_2_classLit, true, true, false, false, true, true);
    $initEClass(this$static.elkPortEClass, Lorg_eclipse_elk_graph_ElkPort_2_classLit, 'ElkPort', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkPortEClass), 0), 19), this$static.elkNodeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 0), 19), 'parent', 0, 1, Lorg_eclipse_elk_graph_ElkPort_2_classLit, false, false, true, false, false, false, false);
    $initEClass(this$static.elkEdgeEClass, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, 'ElkEdge', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 0), 19), this$static.elkNodeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkNodeEClass), 3), 19), 'containingNode', 0, 1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, false, false, true, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 1), 19), this$static.elkConnectableShapeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkConnectableShapeEClass), 0), 19), 'sources', 0, -1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 2), 19), this$static.elkConnectableShapeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkConnectableShapeEClass), 1), 19), 'targets', 0, -1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 3), 19), this$static.elkEdgeSectionEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 5), 19), 'sections', 0, -1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, false, false, true, true, false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 4), 35), this$static.ecorePackage.eBooleanEDataType, 'hyperedge', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 5), 35), this$static.ecorePackage.eBooleanEDataType, 'hierarchical', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 6), 35), this$static.ecorePackage.eBooleanEDataType, 'selfloop', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 7), 35), this$static.ecorePackage.eBooleanEDataType, 'connected', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdge_2_classLit, true, true, false, false, true, true);
    $initEClass(this$static.elkBendPointEClass, Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, 'ElkBendPoint', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkBendPointEClass), 0), 35), this$static.ecorePackage.eDoubleEDataType, 'x', '0.0', 1, 1, Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkBendPointEClass), 1), 35), this$static.ecorePackage.eDoubleEDataType, 'y', '0.0', 1, 1, Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, false, false, true, false, true, false);
    op = $addEOperation(this$static.elkBendPointEClass, null, 'set');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'x');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'y');
    $initEClass(this$static.elkEdgeSectionEClass, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, 'ElkEdgeSection', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 0), 35), this$static.ecorePackage.eDoubleEDataType, 'startX', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 1), 35), this$static.ecorePackage.eDoubleEDataType, 'startY', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 2), 35), this$static.ecorePackage.eDoubleEDataType, 'endX', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 3), 35), this$static.ecorePackage.eDoubleEDataType, 'endY', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 4), 19), this$static.elkBendPointEClass, null, 'bendPoints', 0, -1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 5), 19), this$static.elkEdgeEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeEClass), 3), 19), 'parent', 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 6), 19), this$static.elkConnectableShapeEClass, null, 'outgoingShape', 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 7), 19), this$static.elkConnectableShapeEClass, null, 'incomingShape', 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 8), 19), this$static.elkEdgeSectionEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 9), 19), 'outgoingSections', 0, -1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 9), 19), this$static.elkEdgeSectionEClass, castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 8), 19), 'incomingSections', 0, -1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkEdgeSectionEClass), 10), 35), this$static.ecorePackage.eStringEDataType, 'identifier', null, 0, 1, Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, false, false, true, false, true, false);
    op = $addEOperation(this$static.elkEdgeSectionEClass, null, 'setStartLocation');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'x');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'y');
    op = $addEOperation(this$static.elkEdgeSectionEClass, null, 'setEndLocation');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'x');
    $addEParameter(op, this$static.ecorePackage.eDoubleEDataType, 'y');
    $initEClass(this$static.elkPropertyToValueMapEntryEClass, Ljava_util_Map$Entry_2_classLit, 'ElkPropertyToValueMapEntry', false, false, false);
    g1 = $createEGenericType(this$static.iPropertyEDataType);
    g2 = (eGenericType6 = (eGenericType = new EGenericTypeImpl, eGenericType), eGenericType6);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    $initEAttribute_0(castTo($get_20($getEStructuralFeatures(this$static.elkPropertyToValueMapEntryEClass), 0), 35), g1, 'key', Ljava_util_Map$Entry_2_classLit, false, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.elkPropertyToValueMapEntryEClass), 1), 35), this$static.propertyValueEDataType, 'value', null, 0, 1, Ljava_util_Map$Entry_2_classLit, false, false, true, false, true, false);
    $initEDataType(this$static.iPropertyEDataType, Lorg_eclipse_elk_graph_properties_IProperty_2_classLit, 'IProperty', true);
    $initEDataType(this$static.propertyValueEDataType, Ljava_lang_Object_2_classLit, 'PropertyValue', true);
    $createResource(this$static, 'http://www.eclipse.org/elk/ElkGraph');
}
function ElkGraphPackageImpl() {
    EPackageImpl_0.call(this, 'http://www.eclipse.org/elk/ElkGraph', ($clinit_ElkGraphFactory(), eINSTANCE));
    this.iPropertyHolderEClass = null;
    this.eMapPropertyHolderEClass = null;
    this.elkGraphElementEClass = null;
    this.elkShapeEClass = null;
    this.elkLabelEClass = null;
    this.elkConnectableShapeEClass = null;
    this.elkNodeEClass = null;
    this.elkPortEClass = null;
    this.elkEdgeEClass = null;
    this.elkBendPointEClass = null;
    this.elkEdgeSectionEClass = null;
    this.elkPropertyToValueMapEntryEClass = null;
    this.iPropertyEDataType = null;
    this.propertyValueEDataType = null;
    this.isCreated = false;
    this.isInitialized = false;
}
function init_2() {
    var theElkGraphPackage;
    if (isInited) return castTo($getEPackage_0(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/elk/ElkGraph'), 2061);
    theElkGraphPackage = castTo(instanceOf($getStringValue(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/elk/ElkGraph'), 552) ? $getStringValue(INSTANCE_6, 'http://www.eclipse.org/elk/ElkGraph') : new ElkGraphPackageImpl, 552);
    isInited = true;
    $createPackageContents(theElkGraphPackage);
    $initializePackageContents(theElkGraphPackage);
    $freeze_0(theElkGraphPackage);
    $putStringValue(INSTANCE_6, 'http://www.eclipse.org/elk/ElkGraph', theElkGraphPackage);
    return theElkGraphPackage;
}
defineClass(552, 184, {
    109: 1,
    2061: 1,
    552: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    117: 1,
    118: 1,
    675: 1
}, ElkGraphPackageImpl);
_.isCreated = false;
_.isInitialized = false;
var isInited = false;
var Lorg_eclipse_elk_graph_impl_ElkGraphPackageImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkGraphPackageImpl', 552);
function $basicSetParent_0(this$static, newParent, msgs) {
    msgs = $eBasicSetContainer(this$static, castTo(newParent, 52), 7, msgs);
    return msgs;
}
function $eBasicRemoveFromContainerFeature_2(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 7) return this$static.eContainer.eInverseRemove(this$static, 1, Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_ElkGraphPackage$Literals(), ELK_LABEL) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getParent_1(this$static) {
    if (this$static.eFlags_0 >> 16 != 7) return null;
    return castTo(this$static.eContainer, 173);
}
function $setParent_1(this$static, newParent) {
    var eContainerFeatureID, msgs;
    if (newParent != this$static.eContainer || this$static.eFlags_0 >> 16 != 7 && !!newParent) {
        if (isAncestor(this$static, newParent)) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + $toString_22(this$static)));
        msgs = null;
        !!this$static.eContainer && (msgs = (eContainerFeatureID = this$static.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_2(this$static, msgs) : this$static.eContainer.eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        !!newParent && (msgs = castTo(newParent, 52).eInverseAdd(this$static, 1, Lorg_eclipse_elk_graph_ElkGraphElement_2_classLit, msgs));
        msgs = $basicSetParent_0(this$static, newParent, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 7, newParent, newParent));
}
function $setText(this$static, newText) {
    var oldText;
    oldText = this$static.text_0;
    this$static.text_0 = newText;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 8, oldText, this$static.text_0));
}
function $toString_22(this$static) {
    var builder;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_18(this$static);
    builder = new StringBuilder_1('ElkLabel');
    !this$static.text_0 || $append_11($append_11((builder.string += ' "', builder), this$static.text_0), '"');
    $append_11($append_6($append_11($append_6($append_11($append_6($append_11($append_6((builder.string += ' (', builder), this$static.x_0), ','), this$static.y_0), ' | '), this$static.width_0), ','), this$static.height), ')');
    return builder.string;
}
function ElkLabelImpl() {}
defineClass(359, 723, {
    109: 1,
    338: 1,
    173: 1,
    153: 1,
    273: 1,
    359: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkLabelImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_3(msgs) {
    return $eBasicRemoveFromContainerFeature_2(this, msgs);
};
_.eGet = function eGet_13(featureID, resolve, coreType) {
    switch(featureID){
        case 7:
            return $getParent_1(this);
        case 8:
            return this.text_0;
    }
    return $eGet_5(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_8(otherEnd, featureID, msgs) {
    var eContainerFeatureID;
    switch(featureID){
        case 7:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_2(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $basicSetParent_0(this, castTo(otherEnd, 173), msgs);
    }
    return $eInverseAdd_0(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_9(otherEnd, featureID, msgs) {
    if (featureID == 7) return $basicSetParent_0(this, null, msgs);
    return $eInverseRemove_1(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_12(featureID) {
    switch(featureID){
        case 7:
            return !!$getParent_1(this);
        case 8:
            return !$equals_5('', this.text_0);
    }
    return $eIsSet_3(this, featureID);
};
_.eSet = function eSet_11(featureID, newValue) {
    switch(featureID){
        case 7:
            $setParent_1(this, castTo(newValue, 173));
            return;
        case 8:
            $setText(this, castToString(newValue));
            return;
    }
    $eSet_3(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_11() {
    return $clinit_ElkGraphPackage$Literals(), ELK_LABEL;
};
_.eUnset = function eUnset_11(featureID) {
    switch(featureID){
        case 7:
            $setParent_1(this, null);
            return;
        case 8:
            $setText(this, '');
            return;
    }
    $eUnset_3(this, featureID);
};
_.toString_0 = function toString_128() {
    return $toString_22(this);
};
_.text_0 = '';
var Lorg_eclipse_elk_graph_impl_ElkLabelImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkLabelImpl', 359);
function $basicSetParent_1(this$static, newParent, msgs) {
    msgs = $eBasicSetContainer(this$static, newParent, 11, msgs);
    return msgs;
}
function $eBasicRemoveFromContainerFeature_3(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 11) return this$static.eContainer.eInverseRemove(this$static, 10, Lorg_eclipse_elk_graph_ElkNode_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_ElkGraphPackage$Literals(), ELK_NODE) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getChildren(this$static) {
    !this$static.children && (this$static.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this$static, 10, 11));
    return this$static.children;
}
function $getContainedEdges(this$static) {
    !this$static.containedEdges && (this$static.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this$static, 12, 3));
    return this$static.containedEdges;
}
function $getParent_2(this$static) {
    if (this$static.eFlags_0 >> 16 != 11) return null;
    return castTo(this$static.eContainer, 27);
}
function $getPorts_3(this$static) {
    !this$static.ports && (this$static.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this$static, 9, 9));
    return this$static.ports;
}
function $isHierarchical_0(this$static) {
    return !this$static.children && (this$static.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this$static, 10, 11)), this$static.children.size_0 > 0;
}
function $setParent_2(this$static, newParent) {
    var eContainerFeatureID, msgs;
    if (newParent != this$static.eContainer || this$static.eFlags_0 >> 16 != 11 && !!newParent) {
        if (isAncestor(this$static, newParent)) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + $toString_23(this$static)));
        msgs = null;
        !!this$static.eContainer && (msgs = (eContainerFeatureID = this$static.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_3(this$static, msgs) : this$static.eContainer.eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        !!newParent && (msgs = $eInverseAdd(newParent, this$static, 10, msgs));
        msgs = $basicSetParent_1(this$static, newParent, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 11, newParent, newParent));
}
function $toString_23(this$static) {
    var builder, id_0, text_0;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_18(this$static);
    builder = new StringBuilder_1('ElkNode');
    id_0 = this$static.identifier;
    if (!id_0) {
        !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
        if (this$static.labels.size_0 > 0) {
            text_0 = (!this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7)), castTo($get_20(this$static.labels, 0), 153)).text_0;
            !text_0 || $append_11($append_11((builder.string += ' "', builder), text_0), '"');
        }
    } else $append_11($append_11((builder.string += ' "', builder), id_0), '"');
    $append_11($append_6($append_11($append_6($append_11($append_6($append_11($append_6((builder.string += ' (', builder), this$static.x_0), ','), this$static.y_0), ' | '), this$static.width_0), ','), this$static.height), ')');
    return builder.string;
}
function ElkNodeImpl() {
    ElkConnectableShapeImpl.call(this);
}
defineClass(206, 724, {
    109: 1,
    338: 1,
    84: 1,
    173: 1,
    27: 1,
    273: 1,
    206: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkNodeImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_4(msgs) {
    return $eBasicRemoveFromContainerFeature_3(this, msgs);
};
_.eGet = function eGet_14(featureID, resolve, coreType) {
    switch(featureID){
        case 9:
            return !this.ports && (this.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this, 9, 9)), this.ports;
        case 10:
            return !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11)), this.children;
        case 11:
            return $getParent_2(this);
        case 12:
            return !this.containedEdges && (this.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 12, 3)), this.containedEdges;
        case 13:
            return $clinit_Boolean(), !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11)), this.children.size_0 > 0 ? true : false;
    }
    return $eGet_6(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_9(otherEnd, featureID, msgs) {
    var eContainerFeatureID;
    switch(featureID){
        case 9:
            return !this.ports && (this.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this, 9, 9)), $basicAdd_0(this.ports, otherEnd, msgs);
        case 10:
            return !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11)), $basicAdd_0(this.children, otherEnd, msgs);
        case 11:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_3(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $basicSetParent_1(this, castTo(otherEnd, 27), msgs);
        case 12:
            return !this.containedEdges && (this.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 12, 3)), $basicAdd_0(this.containedEdges, otherEnd, msgs);
    }
    return $eInverseAdd_1(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_10(otherEnd, featureID, msgs) {
    switch(featureID){
        case 9:
            return !this.ports && (this.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this, 9, 9)), $basicRemove_0(this.ports, otherEnd, msgs);
        case 10:
            return !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11)), $basicRemove_0(this.children, otherEnd, msgs);
        case 11:
            return $basicSetParent_1(this, null, msgs);
        case 12:
            return !this.containedEdges && (this.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 12, 3)), $basicRemove_0(this.containedEdges, otherEnd, msgs);
    }
    return $eInverseRemove_2(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_13(featureID) {
    switch(featureID){
        case 9:
            return !!this.ports && this.ports.size_0 != 0;
        case 10:
            return !!this.children && this.children.size_0 != 0;
        case 11:
            return !!$getParent_2(this);
        case 12:
            return !!this.containedEdges && this.containedEdges.size_0 != 0;
        case 13:
            return !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11)), this.children.size_0 > 0;
    }
    return $eIsSet_4(this, featureID);
};
_.eSet = function eSet_12(featureID, newValue) {
    switch(featureID){
        case 9:
            !this.ports && (this.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this, 9, 9));
            $clear_13(this.ports);
            !this.ports && (this.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this, 9, 9));
            $addAll_9(this.ports, castTo(newValue, 16));
            return;
        case 10:
            !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11));
            $clear_13(this.children);
            !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11));
            $addAll_9(this.children, castTo(newValue, 16));
            return;
        case 11:
            $setParent_2(this, castTo(newValue, 27));
            return;
        case 12:
            !this.containedEdges && (this.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 12, 3));
            $clear_13(this.containedEdges);
            !this.containedEdges && (this.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 12, 3));
            $addAll_9(this.containedEdges, castTo(newValue, 16));
            return;
    }
    $eSet_4(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_12() {
    return $clinit_ElkGraphPackage$Literals(), ELK_NODE;
};
_.eUnset = function eUnset_12(featureID) {
    switch(featureID){
        case 9:
            !this.ports && (this.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, this, 9, 9));
            $clear_13(this.ports);
            return;
        case 10:
            !this.children && (this.children = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkNode_2_classLit, this, 10, 11));
            $clear_13(this.children);
            return;
        case 11:
            $setParent_2(this, null);
            return;
        case 12:
            !this.containedEdges && (this.containedEdges = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, this, 12, 3));
            $clear_13(this.containedEdges);
            return;
    }
    $eUnset_4(this, featureID);
};
_.toString_0 = function toString_129() {
    return $toString_23(this);
};
var Lorg_eclipse_elk_graph_impl_ElkNodeImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkNodeImpl', 206);
function $basicSetParent_2(this$static, newParent, msgs) {
    msgs = $eBasicSetContainer(this$static, newParent, 9, msgs);
    return msgs;
}
function $eBasicRemoveFromContainerFeature_4(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 9) return this$static.eContainer.eInverseRemove(this$static, 9, Lorg_eclipse_elk_graph_ElkNode_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_ElkGraphPackage$Literals(), ELK_PORT) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getParent_3(this$static) {
    if (this$static.eFlags_0 >> 16 != 9) return null;
    return castTo(this$static.eContainer, 27);
}
function $setParent_3(this$static, newParent) {
    var eContainerFeatureID, msgs;
    if (newParent != this$static.eContainer || this$static.eFlags_0 >> 16 != 9 && !!newParent) {
        if (isAncestor(this$static, newParent)) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + $toString_24(this$static)));
        msgs = null;
        !!this$static.eContainer && (msgs = (eContainerFeatureID = this$static.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_4(this$static, msgs) : this$static.eContainer.eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        !!newParent && (msgs = $eInverseAdd(newParent, this$static, 9, msgs));
        msgs = $basicSetParent_2(this$static, newParent, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 9, newParent, newParent));
}
function $toString_24(this$static) {
    var builder, id_0, text_0;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_18(this$static);
    builder = new StringBuilder_1('ElkPort');
    id_0 = this$static.identifier;
    if (!id_0) {
        !this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7));
        if (this$static.labels.size_0 > 0) {
            text_0 = (!this$static.labels && (this$static.labels = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkLabel_2_classLit, this$static, 1, 7)), castTo($get_20(this$static.labels, 0), 153)).text_0;
            !text_0 || $append_11($append_11((builder.string += ' "', builder), text_0), '"');
        }
    } else $append_11($append_11((builder.string += ' "', builder), id_0), '"');
    $append_11($append_6($append_11($append_6($append_11($append_6($append_11($append_6((builder.string += ' (', builder), this$static.x_0), ','), this$static.y_0), ' | '), this$static.width_0), ','), this$static.height), ')');
    return builder.string;
}
function ElkPortImpl() {
    ElkConnectableShapeImpl.call(this);
}
defineClass(193, 724, {
    109: 1,
    338: 1,
    84: 1,
    173: 1,
    124: 1,
    273: 1,
    193: 1,
    102: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkPortImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_5(msgs) {
    return $eBasicRemoveFromContainerFeature_4(this, msgs);
};
_.eGet = function eGet_15(featureID, resolve, coreType) {
    if (featureID == 9) return $getParent_3(this);
    return $eGet_6(this, featureID, resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_10(otherEnd, featureID, msgs) {
    var eContainerFeatureID;
    switch(featureID){
        case 9:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_4(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $basicSetParent_2(this, castTo(otherEnd, 27), msgs);
    }
    return $eInverseAdd_1(this, otherEnd, featureID, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_11(otherEnd, featureID, msgs) {
    if (featureID == 9) return $basicSetParent_2(this, null, msgs);
    return $eInverseRemove_2(this, otherEnd, featureID, msgs);
};
_.eIsSet = function eIsSet_14(featureID) {
    if (featureID == 9) return !!$getParent_3(this);
    return $eIsSet_4(this, featureID);
};
_.eSet = function eSet_13(featureID, newValue) {
    switch(featureID){
        case 9:
            $setParent_3(this, castTo(newValue, 27));
            return;
    }
    $eSet_4(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_13() {
    return $clinit_ElkGraphPackage$Literals(), ELK_PORT;
};
_.eUnset = function eUnset_13(featureID) {
    switch(featureID){
        case 9:
            $setParent_3(this, null);
            return;
    }
    $eUnset_4(this, featureID);
};
_.toString_0 = function toString_130() {
    return $toString_24(this);
};
var Lorg_eclipse_elk_graph_impl_ElkPortImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkPortImpl', 193);
var Lorg_eclipse_emf_common_util_BasicEMap$Entry_2_classLit = createForInterface('org.eclipse.emf.common.util', 'BasicEMap/Entry');
function $setTypedKey(this$static, newKey) {
    var oldKey;
    oldKey = this$static.key;
    this$static.key = newKey;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 0, oldKey, this$static.key));
}
function $setTypedValue(this$static, newValue) {
    var oldValue;
    oldValue = this$static.value_0;
    this$static.value_0 = newValue;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 1, oldValue, this$static.value_0));
}
function ElkPropertyToValueMapEntryImpl() {}
defineClass(1086, 118, {
    109: 1,
    43: 1,
    93: 1,
    92: 1,
    135: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    117: 1,
    118: 1
}, ElkPropertyToValueMapEntryImpl);
_.equals_0 = function equals_205(other) {
    return this === other;
};
_.getKey = function getKey_8() {
    return this.key;
};
_.hashCode_1 = function hashCode_73() {
    return getObjectIdentityHashCode(this);
};
_.setKey = function setKey(key) {
    $setTypedKey(this, castTo(key, 144));
};
_.eGet = function eGet_16(featureID, resolve, coreType) {
    switch(featureID){
        case 0:
            return this.key;
        case 1:
            return this.value_0;
    }
    return $eGet(this, featureID, resolve, coreType);
};
_.eIsSet = function eIsSet_15(featureID) {
    switch(featureID){
        case 0:
            return !!this.key;
        case 1:
            return this.value_0 != null;
    }
    return $eIsSet(this, featureID);
};
_.eSet = function eSet_14(featureID, newValue) {
    switch(featureID){
        case 0:
            $setTypedKey(this, castTo(newValue, 144));
            return;
        case 1:
            $setTypedValue(this, newValue);
            return;
    }
    $eSet(this, featureID, newValue);
};
_.eStaticClass = function eStaticClass_14() {
    return $clinit_ElkGraphPackage$Literals(), ELK_PROPERTY_TO_VALUE_MAP_ENTRY;
};
_.eUnset = function eUnset_14(featureID) {
    switch(featureID){
        case 0:
            $setTypedKey(this, null);
            return;
        case 1:
            $setTypedValue(this, null);
            return;
    }
    $eUnset(this, featureID);
};
_.getHash = function getHash() {
    var theKey;
    if (this.hash == -1) {
        theKey = this.key;
        this.hash = !theKey ? 0 : hashCode__I__devirtual$(theKey);
    }
    return this.hash;
};
_.getValue = function getValue_10() {
    return this.value_0;
};
_.setHash = function setHash(hash) {
    this.hash = hash;
};
_.setValue = function setValue_11(value_0) {
    var oldValue;
    oldValue = this.value_0;
    $setTypedValue(this, value_0);
    return oldValue;
};
_.toString_0 = function toString_131() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_16(this);
    result = new StringBuilder;
    $append_11($append_11($append_11(result, this.key ? this.key.getId() : 'null'), ' -> '), valueOf_6(this.value_0));
    return result.string;
};
_.hash = -1;
_.value_0 = null;
var Lorg_eclipse_elk_graph_impl_ElkPropertyToValueMapEntryImpl_2_classLit = createForClass('org.eclipse.elk.graph.impl', 'ElkPropertyToValueMapEntryImpl', 1086);
function $addJsonArr(arr, jv) {
    var size_0;
    size_0 = arr.jsArray.length;
    $get_8(arr, size_0);
    $set0(arr, size_0, jv);
}
function $addJsonArr_0(arr, o) {
    var _doubleValue, _matched;
    _matched = false;
    if (instanceOfString(o)) {
        _matched = true;
        $addJsonArr(arr, new JSONString(castToString(o)));
    }
    if (!_matched) {
        if (instanceOf(o, 241)) {
            _matched = true;
            $addJsonArr(arr, (_doubleValue = doubleValue__D__devirtual$(castTo(o, 241)), new JSONNumber(_doubleValue)));
        }
    }
    if (!_matched) throw toJs(new Error_0('Severe implementation error in the Json to ElkGraph importer.'));
}
function $addJsonObj(o, element, n) {
    var _doubleValue, _jSONNumber;
    _doubleValue = doubleValue__D__devirtual$(n);
    _jSONNumber = new JSONNumber(_doubleValue);
    $put_5(o, element, _jSONNumber);
}
function $addJsonObj_0(this$static, o, element, obj) {
    var _matched;
    _matched = false;
    if (instanceOfString(obj)) {
        _matched = true;
        $addJsonObj_1(o, element, castToString(obj));
    }
    if (!_matched) {
        if (instanceOfBoolean(obj)) {
            _matched = true;
            $addJsonObj_0(this$static, o, element, obj);
        }
    }
    if (!_matched) {
        if (instanceOf(obj, 241)) {
            _matched = true;
            $addJsonObj(o, element, castTo(obj, 241));
        }
    }
    if (!_matched) throw toJs(new Error_0('Severe implementation error in the Json to ElkGraph importer.'));
}
function $addJsonObj_1(o, element, s) {
    var _jSONString;
    _jSONString = new JSONString(s);
    $put_5(o, element, _jSONString);
}
function $asId(id_0) {
    var _isInt, _matched;
    _matched = false;
    if (instanceOf(id_0, 210)) {
        _matched = true;
        return castTo(id_0, 210).value_0;
    }
    if (!_matched) {
        if (instanceOf(id_0, 263)) {
            _isInt = castTo(id_0, 263).value_0 % 1 == 0;
            if (_isInt) {
                _matched = true;
                return valueOf_3($intValue(castTo(id_0, 263).value_0));
            }
        }
    }
    throw toJs(new JsonImportException("Id must be a string or an integer: '" + id_0 + "'."));
}
function $getId(o) {
    var _containsKey, _not, _xblockexpression;
    _xblockexpression = null;
    _containsKey = 'id' in o.jsObject;
    _not = !_containsKey;
    if (_not) throw toJs(new JsonImportException('Every element must have an id.'));
    _xblockexpression = $asId($get_9(o, 'id'));
    return _xblockexpression;
}
function $optDouble(o, element) {
    var _containsKey, num;
    _containsKey = element in o.jsObject;
    if (_containsKey) {
        num = $get_9(o, element).isNumber();
        if (num) return num.value_0;
    }
    return null;
}
function $optJSONArray(arr, element) {
    var _get, _isArray;
    _get = $get_9(arr, element);
    _isArray = null;
    !!_get && (_isArray = _get.isArray_0());
    return _isArray;
}
function $optJSONObject(arr, i) {
    var _get, _isObject;
    _get = $get_8(arr, i);
    _isObject = null;
    !!_get && (_isObject = _get.isObject());
    return _isObject;
}
function $optJSONObject_0(o, element) {
    var _get, _isObject;
    _get = $get_9(o, element);
    _isObject = null;
    !!_get && (_isObject = _get.isObject());
    return _isObject;
}
function $optString(o, element) {
    var _get, _stringVal;
    _get = $get_9(o, element);
    _stringVal = null;
    !!_get && (_stringVal = $stringVal(_get));
    return _stringVal;
}
function $stringVal(v) {
    var _matched, _switchResult;
    _switchResult = null;
    _matched = false;
    if (instanceOf(v, 210)) {
        _matched = true;
        _switchResult = castTo(v, 210).value_0;
    }
    if (!_matched) {
        if (instanceOf(v, 263)) {
            _matched = true;
            _switchResult = '' + castTo(v, 263).value_0;
        }
    }
    if (!_matched) {
        if (instanceOf(v, 477)) {
            _matched = true;
            _switchResult = '' + castTo(v, 477).value_0;
        }
    }
    if (!_matched) throw toJs(new Error_0('Severe implementation error in the Json to ElkGraph importer.'));
    return _switchResult;
}
function JsonAdapter() {}
defineClass(973, 1, {}, JsonAdapter);
var Lorg_eclipse_elk_graph_json_JsonAdapter_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonAdapter', 973);
function JsonImportException(message) {
    RuntimeException_0.call(this, message);
}
defineClass(214, 63, $intern_43, JsonImportException);
var Lorg_eclipse_elk_graph_json_JsonImportException_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImportException', 214);
function $_adjustX(this$static, edge, x_0) {
    var _globalX, _globalX_1, _globalX_2, _plus, _switchResult, mode;
    mode = $edgeCoordsMode(this$static, castTo($get_10(this$static.edgeOriginalParentMap, edge), 27));
    _switchResult = null;
    if (mode) switch(mode.ordinal){
        case 3:
            _globalX = $globalX(this$static, $getContainingNode(edge));
            _switchResult = (checkCriticalNotNull(x_0), x_0) + (checkCriticalNotNull(_globalX), _globalX);
            break;
        case 2:
            _globalX_1 = $globalX(this$static, $getContainingNode(edge));
            _plus = (checkCriticalNotNull(x_0), x_0) + (checkCriticalNotNull(_globalX_1), _globalX_1);
            _globalX_2 = $globalX(this$static, castTo($get_10(this$static.edgeOriginalParentMap, edge), 27));
            _switchResult = _plus - (checkCriticalNotNull(_globalX_2), _globalX_2);
            break;
        default:
            _switchResult = x_0;
    }
    else _switchResult = x_0;
    return _switchResult;
}
function $_adjustX_0(this$static, shape_0, x_0) {
    var _globalX, _switchResult, mode;
    mode = castTo($get_10(this$static.shapeCoordsMap, shape_0), 297);
    _switchResult = null;
    if (mode) switch(mode.ordinal){
        case 2:
            _globalX = castToDouble($get_10(this$static.globalXMap, shape_0));
            _switchResult = (checkCriticalNotNull(x_0), x_0) + (checkCriticalNotNull(_globalX), _globalX);
            break;
        default:
            _switchResult = x_0;
    }
    else _switchResult = x_0;
    return _switchResult;
}
function $_adjustY(this$static, edge, y_0) {
    var _globalY, _globalY_1, _globalY_2, _plus, _switchResult, mode;
    mode = $edgeCoordsMode(this$static, castTo($get_10(this$static.edgeOriginalParentMap, edge), 27));
    _switchResult = null;
    if (mode) switch(mode.ordinal){
        case 3:
            _globalY = $globalY(this$static, $getContainingNode(edge));
            _switchResult = (checkCriticalNotNull(y_0), y_0) + (checkCriticalNotNull(_globalY), _globalY);
            break;
        case 2:
            _globalY_1 = $globalY(this$static, $getContainingNode(edge));
            _plus = (checkCriticalNotNull(y_0), y_0) + (checkCriticalNotNull(_globalY_1), _globalY_1);
            _globalY_2 = $globalY(this$static, castTo($get_10(this$static.edgeOriginalParentMap, edge), 27));
            _switchResult = _plus - (checkCriticalNotNull(_globalY_2), _globalY_2);
            break;
        default:
            _switchResult = y_0;
    }
    else _switchResult = y_0;
    return _switchResult;
}
function $_adjustY_0(this$static, shape_0, y_0) {
    var _globalY, _switchResult, mode;
    mode = castTo($get_10(this$static.shapeCoordsMap, shape_0), 297);
    _switchResult = null;
    if (mode) switch(mode.ordinal){
        case 2:
            _globalY = castToDouble($get_10(this$static.globalYMap, shape_0));
            _switchResult = (checkCriticalNotNull(y_0), y_0) + (checkCriticalNotNull(_globalY), _globalY);
            break;
        default:
            _switchResult = y_0;
    }
    else _switchResult = y_0;
    return _switchResult;
}
function $_idByElement(this$static, section) {
    return $get_5($inverse(this$static.edgeSectionIdMap), section);
}
function $_idByElement_0(this$static, node) {
    return $get_5($inverse(this$static.nodeIdMap), node);
}
function $_idByElement_1(this$static, port) {
    return $get_5($inverse(this$static.portIdMap), port);
}
function $_jsonParent(this$static, edge) {
    return castTo($get_10(this$static.edgeOriginalParentMap, edge), 27);
}
function $_shapeAncestor(this$static, edge) {
    return castTo($get_10(this$static.edgeOriginalParentMap, edge), 27);
}
function $_transferLayoutInt1(this$static, node) {
    var jsonObj;
    jsonObj = $get_4(this$static.nodeJsonMap, node);
    if (jsonObj == null) throw toJs(new JsonImportException('Node did not exist in input.'));
    $recordGlobalCoords(this$static, node);
    $recordCoordinateModes(this$static, node);
    $transferShapeLayout(this$static, node, jsonObj);
    return null;
}
function $_transferLayoutInt1_0(this$static, port) {
    var jsonObj;
    jsonObj = $get_10(this$static.portJsonMap, port);
    if (jsonObj == null) throw toJs(new JsonImportException('Port did not exist in input.'));
    $recordGlobalCoords(this$static, port);
    $recordCoordinateModes(this$static, port);
    $transferShapeLayout(this$static, port, jsonObj);
    return null;
}
function $_transferLayoutInt2(this$static, edge) {
    var _edgeCoordsMode, _function, _function_1, _hasProperty, _isNullOrEmpty, _isNullOrEmpty_1, _not, _not_1, _tripleEquals, edgeId, jps, jsonJPs, jsonObj, sections;
    jsonObj = castTo($get_10(this$static.edgeJsonMap, edge), 147);
    if (!jsonObj) throw toJs(new JsonImportException('Edge did not exist in input.'));
    $recordCoordinateModes(this$static, edge);
    edgeId = $getId(jsonObj);
    _isNullOrEmpty = isNullOrEmpty((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections));
    _not = !_isNullOrEmpty;
    if (_not) {
        sections = new JSONArray;
        _function = new JsonImporter$lambda$37$Type(this$static, edgeId, sections, edge);
        forEach_42((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), _function);
        $put_5(jsonObj, 'sections', null);
        $put_5(jsonObj, 'sections', sections);
    }
    _hasProperty = $hasProperty_0(edge, ($clinit_CoreOptions(), JUNCTION_POINTS_0));
    if (_hasProperty) {
        jps = castTo($getProperty_0(edge, JUNCTION_POINTS_0), 77);
        _isNullOrEmpty_1 = !jps || isEmpty_35(jps);
        _not_1 = !_isNullOrEmpty_1;
        if (_not_1) {
            jsonJPs = new JSONArray;
            _function_1 = new JsonImporter$lambda$41$Type(this$static, edge, jsonJPs);
            $forEach_0(jps, _function_1);
            $put_5(jsonObj, 'junctionPoints', jsonJPs);
        }
    }
    _edgeCoordsMode = $edgeCoordsMode(this$static, castTo($get_10(this$static.edgeOriginalParentMap, edge), 27));
    _tripleEquals = _edgeCoordsMode == ($clinit_EdgeCoords(), CONTAINER);
    _tripleEquals && $addJsonObj_1(jsonObj, 'container', $getContainingNode(edge).identifier);
    return null;
}
function $_transferLayoutInt2_0(this$static, label_0) {
    var jsonObj;
    jsonObj = $get_10(this$static.labelJsonMap, label_0);
    $recordGlobalCoords(this$static, label_0);
    $recordCoordinateModes(this$static, label_0);
    $transferShapeLayout(this$static, label_0, jsonObj);
    return null;
}
function $adjustX(this$static, edge, x_0) {
    if (instanceOf(edge, 268)) return $_adjustX(this$static, castTo(edge, 85), x_0);
    else if (instanceOf(edge, 273)) return $_adjustX_0(this$static, castTo(edge, 273), x_0);
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        edge,
        x_0
    ])))));
}
function $adjustY(this$static, edge, y_0) {
    if (instanceOf(edge, 268)) return $_adjustY(this$static, castTo(edge, 85), y_0);
    else if (instanceOf(edge, 273)) return $_adjustY_0(this$static, castTo(edge, 273), y_0);
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        edge,
        y_0
    ])))));
}
function $edgeCoordsMode(this$static, element) {
    return castTo($get_10(this$static.edgeCoordsMap, element), 275);
}
function $globalX(this$static, shape_0) {
    return castToDouble($get_10(this$static.globalXMap, shape_0));
}
function $globalY(this$static, shape_0) {
    return castToDouble($get_10(this$static.globalYMap, shape_0));
}
function $idByElement(this$static, node) {
    if (instanceOf(node, 206)) return $_idByElement_0(this$static, castTo(node, 27));
    else if (instanceOf(node, 193)) return $_idByElement_1(this$static, castTo(node, 124));
    else if (instanceOf(node, 440)) return $_idByElement(this$static, castTo(node, 168));
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        node
    ])))));
}
function $jsonParent(this$static, node) {
    if (instanceOf(node, 206)) return $getParent_2(castTo(node, 27));
    else if (instanceOf(node, 193)) return $getParent_3(castTo(node, 124));
    else if (instanceOf(node, 359)) return $getParent_1(castTo(node, 153));
    else if (instanceOf(node, 268)) return $_jsonParent(this$static, castTo(node, 85));
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        node
    ])))));
}
function $lambda$0_13(this$static, parent_1, children_1) {
    var _doubleDotLessThan, _optJSONObject, _sizeJsonArr, i, i$iterator;
    if (children_1) {
        _sizeJsonArr = children_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            _optJSONObject = $optJSONObject(children_1, i.value_0);
            !!_optJSONObject && $transformNode_0(this$static, _optJSONObject, parent_1);
        }
    }
}
function $lambda$1_8(this$static, node_1, edges_1) {
    var _doubleDotLessThan, _sizeJsonArr, edge, i, i$iterator;
    if (edges_1) {
        _sizeJsonArr = edges_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            edge = $optJSONObject(edges_1, i.value_0);
            'sources' in edge.jsObject || 'targets' in edge.jsObject ? $transformEdge_1(this$static, edge, node_1) : $transformPrimitiveEdge(this$static, edge, node_1);
            updateContainment(castTo($get_10(this$static.edgeIdMap, $getId(edge)), 85));
        }
    }
}
function $lambda$10_0(section_1, bendPoint_1) {
    createBendPoint(section_1, $doubleValue($optDouble(bendPoint_1, 'x')), $doubleValue($optDouble(bendPoint_1, 'y')));
}
function $lambda$11(this$static, edge_1, sources_1) {
    var _doubleDotLessThan, _sizeJsonArr, _sources, i, i$iterator, sourceElement;
    if (sources_1) {
        _sizeJsonArr = sources_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            sourceElement = $shapeById(this$static, $asId($get_8(sources_1, i.value_0)));
            if (sourceElement) {
                _sources = (!edge_1.sources && (edge_1.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge_1, 4, 7)), edge_1.sources);
                $add_21(_sources, sourceElement);
            }
        }
    }
}
function $lambda$12_0(this$static, edge_1, targets_1) {
    var _doubleDotLessThan, _sizeJsonArr, _targets, i, i$iterator, targetElement;
    if (targets_1) {
        _sizeJsonArr = targets_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            targetElement = $shapeById(this$static, $asId($get_8(targets_1, i.value_0)));
            if (targetElement) {
                _targets = (!edge_1.targets && (edge_1.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge_1, 5, 8)), edge_1.targets);
                $add_21(_targets, targetElement);
            }
        }
    }
}
function $lambda$13(this$static, edge_1, incomingSectionIdentifiers_2, outgoingSectionIdentifiers_3, sections_3) {
    var _doubleDotLessThan, _function_1, _optJSONObject, _sizeJsonArr, i, i$iterator;
    if (sections_3) {
        _sizeJsonArr = sections_3.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            _optJSONObject = $optJSONObject(sections_3, i.value_0);
            _function_1 = new JsonImporter$lambda$14$Type(this$static, edge_1, incomingSectionIdentifiers_2, outgoingSectionIdentifiers_3);
            $lambda$14_0(_function_1.$$outer_0, _function_1.edge_1, _function_1.incomingSectionIdentifiers_2, _function_1.outgoingSectionIdentifiers_3, _optJSONObject);
        }
    }
}
function $lambda$14_0(this$static, edge_1, incomingSectionIdentifiers_2, outgoingSectionIdentifiers_3, jsonSection_3) {
    var _function_2, _function_3, _function_4, _function_5, _optJSONArray_1, _optJSONArray_2, _optString, _optString_1, elkSection, jsonObj, _optJSONObject, _function, _optJSONObject_1, _function_1, _optJSONArray, _function_2_0;
    elkSection = $register_3(this$static, createEdgeSection(edge_1), jsonSection_3);
    $setIdentifier_0(elkSection, $optString(jsonSection_3, 'id'));
    _xblockexpression = null;
    jsonObj = jsonSection_3;
    _optJSONObject = $optJSONObject_0(jsonObj, 'startPoint');
    _function = new JsonImporter$lambda$19$Type(elkSection);
    $lambda$19_0(_function.section_1, _optJSONObject);
    _optJSONObject_1 = $optJSONObject_0(jsonObj, 'endPoint');
    _function_1 = new JsonImporter$lambda$22$Type(elkSection);
    $lambda$22_0(_function_1.section_1, _optJSONObject_1);
    _optJSONArray = $optJSONArray(jsonObj, 'bendPoints');
    _function_2_0 = new JsonImporter$lambda$25$Type(elkSection);
    $lambda$25_0(_function_2_0.section_1, _optJSONArray);
    _optString = $optString(jsonSection_3, 'incomingShape');
    _function_2 = new JsonImporter$lambda$15$Type(this$static, elkSection);
    $lambda$15(_function_2.$$outer_0, _function_2.elkSection_1, _optString);
    _optString_1 = $optString(jsonSection_3, 'outgoingShape');
    _function_3 = new JsonImporter$lambda$16$Type(this$static, elkSection);
    $lambda$16(_function_3.$$outer_0, _function_3.elkSection_1, _optString_1);
    _optJSONArray_1 = $optJSONArray(jsonSection_3, 'incomingSections');
    _function_4 = new JsonImporter$lambda$17$Type(incomingSectionIdentifiers_2, elkSection);
    $lambda$17(_function_4.incomingSectionIdentifiers_1, _function_4.elkSection_2, _optJSONArray_1);
    _optJSONArray_2 = $optJSONArray(jsonSection_3, 'outgoingSections');
    _function_5 = new JsonImporter$lambda$18$Type(outgoingSectionIdentifiers_3, elkSection);
    $lambda$18_0(_function_5.outgoingSectionIdentifiers_1, _function_5.elkSection_2, _optJSONArray_2);
}
function $lambda$15(this$static, elkSection_1, jsonShapeId_1) {
    jsonShapeId_1 != null && $setIncomingShape(elkSection_1, $shapeById(this$static, jsonShapeId_1));
}
function $lambda$16(this$static, elkSection_1, jsonShapeId_1) {
    jsonShapeId_1 != null && $setOutgoingShape(elkSection_1, $shapeById(this$static, jsonShapeId_1));
}
function $lambda$17(incomingSectionIdentifiers_1, elkSection_2, jsonSectionIds_2) {
    var _doubleDotLessThan_1, _sizeJsonArr_1, j, j$iterator;
    if (jsonSectionIds_2) {
        _sizeJsonArr_1 = jsonSectionIds_2.jsArray.length;
        _doubleDotLessThan_1 = new ExclusiveRange(_sizeJsonArr_1);
        for(j$iterator = (_doubleDotLessThan_1.last - _doubleDotLessThan_1.first) * _doubleDotLessThan_1.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan_1); j$iterator.hasNext_0();){
            j = castTo(j$iterator.next_1(), 17);
            $put(incomingSectionIdentifiers_1, elkSection_2, $asId($get_8(jsonSectionIds_2, j.value_0)));
        }
    }
}
function $lambda$18_0(outgoingSectionIdentifiers_1, elkSection_2, jsonSectionIds_2) {
    var _doubleDotLessThan_1, _sizeJsonArr_1, j, j$iterator;
    if (jsonSectionIds_2) {
        _sizeJsonArr_1 = jsonSectionIds_2.jsArray.length;
        _doubleDotLessThan_1 = new ExclusiveRange(_sizeJsonArr_1);
        for(j$iterator = (_doubleDotLessThan_1.last - _doubleDotLessThan_1.first) * _doubleDotLessThan_1.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan_1); j$iterator.hasNext_0();){
            j = castTo(j$iterator.next_1(), 17);
            $put(outgoingSectionIdentifiers_1, elkSection_2, $asId($get_8(jsonSectionIds_2, j.value_0)));
        }
    }
}
function $lambda$19_0(section_1, startPoint_1) {
    var _function_1, _function_2, _optDouble, _optDouble_1;
    if (startPoint_1) {
        _optDouble = $optDouble(startPoint_1, 'x');
        _function_1 = new JsonImporter$lambda$20$Type(section_1);
        $setStartX(_function_1.section_0, (checkCriticalNotNull(_optDouble), _optDouble));
        _optDouble_1 = $optDouble(startPoint_1, 'y');
        _function_2 = new JsonImporter$lambda$21$Type(section_1);
        $setStartY(_function_2.section_0, (checkCriticalNotNull(_optDouble_1), _optDouble_1));
    } else throw toJs(new JsonImportException('All edge sections need a start point.'));
}
function $lambda$2_5(this$static, children_0) {
    var _doubleDotLessThan, _optJSONObject, _sizeJsonArr, i, i$iterator;
    if (children_0) {
        _sizeJsonArr = children_0.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            _optJSONObject = $optJSONObject(children_0, i.value_0);
            !!_optJSONObject && $transformEdges_2(this$static, _optJSONObject);
        }
    }
}
function $lambda$22_0(section_1, endPoint_1) {
    var _function_2, _function_3, _optDouble, _optDouble_1;
    if (endPoint_1) {
        _optDouble = $optDouble(endPoint_1, 'x');
        _function_2 = new JsonImporter$lambda$23$Type(section_1);
        $setEndX(_function_2.section_0, (checkCriticalNotNull(_optDouble), _optDouble));
        _optDouble_1 = $optDouble(endPoint_1, 'y');
        _function_3 = new JsonImporter$lambda$24$Type(section_1);
        $setEndY(_function_3.section_0, (checkCriticalNotNull(_optDouble_1), _optDouble_1));
    } else throw toJs(new JsonImportException('All edge sections need an end point.'));
}
function $lambda$25_0(section_1, bendPoints_1) {
    var _doubleDotLessThan, _function_3, _optJSONObject_2, _sizeJsonArr, i, i$iterator;
    if (bendPoints_1) {
        _sizeJsonArr = bendPoints_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            _optJSONObject_2 = $optJSONObject(bendPoints_1, i.value_0);
            _function_3 = new JsonImporter$lambda$26$Type(section_1);
            $lambda$26_0(_function_3.section_1, _optJSONObject_2);
        }
    }
}
function $lambda$26_0(section_1, bendPoint_1) {
    createBendPoint(section_1, $doubleValue($optDouble(bendPoint_1, 'x')), $doubleValue($optDouble(bendPoint_1, 'y')));
}
function $lambda$27_0(opts_1, layoutData_2, k_2) {
    var _jsonObj, _stringVal, value_0;
    _jsonObj = $get_9(opts_1, k_2);
    _stringVal = null;
    !!_jsonObj && (_stringVal = $stringVal(_jsonObj));
    value_0 = _stringVal;
    $setOption(layoutData_2, k_2, value_0);
}
function $lambda$28(opts_1, individualSpacings_2, k_2) {
    var _jsonObj, _stringVal, value_0;
    _jsonObj = $get_9(opts_1, k_2);
    _stringVal = null;
    !!_jsonObj && (_stringVal = $stringVal(_jsonObj));
    value_0 = _stringVal;
    $setOption(individualSpacings_2, k_2, value_0);
}
function $lambda$29_0(this$static, element_1, labels_1) {
    var _doubleDotLessThan, _hasJsonObj, _sizeJsonArr, i, i$iterator, jsonLabel, label_0;
    if (labels_1) {
        _sizeJsonArr = labels_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            jsonLabel = $optJSONObject(labels_1, i.value_0);
            if (jsonLabel) {
                label_0 = createLabel($optString(jsonLabel, 'text'), element_1);
                $put_6(this$static.labelJsonMap, label_0, jsonLabel);
                _hasJsonObj = 'id' in jsonLabel.jsObject;
                _hasJsonObj && $setIdentifier(label_0, $optString(jsonLabel, 'id'));
                $transformProperties(jsonLabel, label_0);
                $transformShapeLayout(jsonLabel, label_0);
            }
        }
    }
}
function $lambda$3_4(section_1, srcPnt_1) {
    var _function_1, _function_2, _optDouble, _optDouble_1;
    if (srcPnt_1) {
        _optDouble = $optDouble(srcPnt_1, 'x');
        _function_1 = new JsonImporter$lambda$4$Type(section_1);
        $setStartX(_function_1.section_0, (checkCriticalNotNull(_optDouble), _optDouble));
        _optDouble_1 = $optDouble(srcPnt_1, 'y');
        _function_2 = new JsonImporter$lambda$5$Type(section_1);
        $setStartY(_function_2.section_0, (checkCriticalNotNull(_optDouble_1), _optDouble_1));
    }
}
function $lambda$30(this$static, parent_1, ports_1) {
    var _doubleDotLessThan, _optJSONObject, _sizeJsonArr, i, i$iterator, port, port_0, elkPort;
    if (ports_1) {
        _sizeJsonArr = ports_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            _optJSONObject = $optJSONObject(ports_1, i.value_0);
            !!_optJSONObject && (_xblockexpression = null, port = $register_5(this$static, (port_0 = ($clinit_ElkGraphFactory(), elkPort = new ElkPortImpl, elkPort), !!parent_1 && $setParent_3(port_0, parent_1), port_0), _optJSONObject), $setIdentifier(port, $optString(_optJSONObject, 'id')), $transformProperties(_optJSONObject, port), $transformShapeLayout(_optJSONObject, port), $transformLabels(this$static, _optJSONObject, port));
        }
    }
}
function $lambda$31(shape_1, it_1) {
    $setX_1(shape_1, it_1 == null || isInfinite((checkCriticalNotNull(it_1), it_1)) || isNaN((checkCriticalNotNull(it_1), it_1)) ? 0 : (checkCriticalNotNull(it_1), it_1));
}
function $lambda$32(shape_1, it_1) {
    $setY_2(shape_1, it_1 == null || isInfinite((checkCriticalNotNull(it_1), it_1)) || isNaN((checkCriticalNotNull(it_1), it_1)) ? 0 : (checkCriticalNotNull(it_1), it_1));
}
function $lambda$33(shape_1, it_1) {
    $setWidth_0(shape_1, it_1 == null || isInfinite((checkCriticalNotNull(it_1), it_1)) || isNaN((checkCriticalNotNull(it_1), it_1)) ? 0 : (checkCriticalNotNull(it_1), it_1));
}
function $lambda$34(shape_1, it_1) {
    $setHeight_0(shape_1, it_1 == null || isInfinite((checkCriticalNotNull(it_1), it_1)) || isNaN((checkCriticalNotNull(it_1), it_1)) ? 0 : (checkCriticalNotNull(it_1), it_1));
}
function $lambda$37(this$static, edgeId_1, sections_2, edge_3, elkSection_3, i_4) {
    var _function_1, _function_2, _function_3, _incomingShape, _isEmpty, _isEmpty_1, _isNullOrEmpty_1, _jSONString, _jsonObject, _not_1, _not_2, _not_3, _outgoingShape, _plus, _plus_1, _tripleNotEquals, _tripleNotEquals_1, bendPoints, endPoint, incomingSections, jsonSection, maybeSection, outgoingSections, startPoint;
    maybeSection = $get_10(this$static.edgeSectionJsonMap, elkSection_3);
    if (maybeSection == null) {
        maybeSection = new JSONObject;
        _jsonObject = castTo(maybeSection, 147);
        _plus = edgeId_1 + '_s';
        _plus_1 = _plus + i_4;
        _jSONString = new JSONString(_plus_1);
        $put_5(_jsonObject, 'id', _jSONString);
    }
    jsonSection = castTo(maybeSection, 147);
    $addJsonArr(sections_2, jsonSection);
    startPoint = new JSONObject;
    $addJsonObj(startPoint, 'x', $adjustX(this$static, edge_3, elkSection_3.startX));
    $addJsonObj(startPoint, 'y', $adjustY(this$static, edge_3, elkSection_3.startY));
    $put_5(jsonSection, 'startPoint', startPoint);
    endPoint = new JSONObject;
    $addJsonObj(endPoint, 'x', $adjustX(this$static, edge_3, elkSection_3.endX));
    $addJsonObj(endPoint, 'y', $adjustY(this$static, edge_3, elkSection_3.endY));
    $put_5(jsonSection, 'endPoint', endPoint);
    _isNullOrEmpty_1 = isNullOrEmpty((!elkSection_3.bendPoints && (elkSection_3.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, elkSection_3, 5)), elkSection_3.bendPoints));
    _not_1 = !_isNullOrEmpty_1;
    if (_not_1) {
        bendPoints = new JSONArray;
        _function_1 = new JsonImporter$lambda$38$Type(this$static, edge_3, bendPoints);
        $forEach_0((!elkSection_3.bendPoints && (elkSection_3.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, elkSection_3, 5)), elkSection_3.bendPoints), _function_1);
        $put_5(jsonSection, 'bendPoints', bendPoints);
    }
    _incomingShape = $getIncomingShape(elkSection_3);
    _tripleNotEquals = !!_incomingShape;
    _tripleNotEquals && $addJsonObj_0(this$static._jsonAdapter, jsonSection, 'incomingShape', $idByElement(this$static, $getIncomingShape(elkSection_3)));
    _outgoingShape = $getOutgoingShape(elkSection_3);
    _tripleNotEquals_1 = !!_outgoingShape;
    _tripleNotEquals_1 && $addJsonObj_0(this$static._jsonAdapter, jsonSection, 'outgoingShape', $idByElement(this$static, $getOutgoingShape(elkSection_3)));
    _isEmpty = (!elkSection_3.incomingSections && (elkSection_3.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, elkSection_3, 10, 9)), elkSection_3.incomingSections).size_0 == 0;
    _not_2 = !_isEmpty;
    if (_not_2) {
        incomingSections = new JSONArray;
        _function_2 = new JsonImporter$lambda$39$Type(this$static, incomingSections);
        $forEach_0((!elkSection_3.incomingSections && (elkSection_3.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, elkSection_3, 10, 9)), elkSection_3.incomingSections), _function_2);
        $put_5(jsonSection, 'incomingSections', incomingSections);
    }
    _isEmpty_1 = (!elkSection_3.outgoingSections && (elkSection_3.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, elkSection_3, 9, 10)), elkSection_3.outgoingSections).size_0 == 0;
    _not_3 = !_isEmpty_1;
    if (_not_3) {
        outgoingSections = new JSONArray;
        _function_3 = new JsonImporter$lambda$40$Type(this$static, outgoingSections);
        $forEach_0((!elkSection_3.outgoingSections && (elkSection_3.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, elkSection_3, 9, 10)), elkSection_3.outgoingSections), _function_3);
        $put_5(jsonSection, 'outgoingSections', outgoingSections);
    }
}
function $lambda$38(this$static, edge_1, bendPoints_2, pnt_2) {
    var jsonPnt;
    jsonPnt = new JSONObject;
    $addJsonObj(jsonPnt, 'x', $adjustX(this$static, edge_1, pnt_2.x_0));
    $addJsonObj(jsonPnt, 'y', $adjustY(this$static, edge_1, pnt_2.y_0));
    $addJsonArr(bendPoints_2, jsonPnt);
}
function $lambda$39(this$static, incomingSections_1, sec_1) {
    $addJsonArr_0(incomingSections_1, $idByElement(this$static, sec_1));
}
function $lambda$40(this$static, outgoingSections_1, sec_1) {
    $addJsonArr_0(outgoingSections_1, $idByElement(this$static, sec_1));
}
function $lambda$41(this$static, edge_1, jsonJPs_2, jp_2) {
    var jsonPnt;
    jsonPnt = new JSONObject;
    $addJsonObj(jsonPnt, 'x', $adjustX(this$static, edge_1, jp_2.x_0));
    $addJsonObj(jsonPnt, 'y', $adjustY(this$static, edge_1, jp_2.y_0));
    $addJsonArr(jsonJPs_2, jsonPnt);
}
function $lambda$6_0(section_1, tgtPnt_1) {
    var _function_2, _function_3, _optDouble, _optDouble_1;
    if (tgtPnt_1) {
        _optDouble = $optDouble(tgtPnt_1, 'x');
        _function_2 = new JsonImporter$lambda$7$Type(section_1);
        $setEndX(_function_2.section_0, (checkCriticalNotNull(_optDouble), _optDouble));
        _optDouble_1 = $optDouble(tgtPnt_1, 'y');
        _function_3 = new JsonImporter$lambda$8$Type(section_1);
        $setEndY(_function_3.section_0, (checkCriticalNotNull(_optDouble_1), _optDouble_1));
    }
}
function $lambda$9_1(section_1, bendPoints_1) {
    var _doubleDotLessThan, _function_3, _optJSONObject_2, _sizeJsonArr, i, i$iterator;
    if (bendPoints_1) {
        _sizeJsonArr = bendPoints_1.jsArray.length;
        _doubleDotLessThan = new ExclusiveRange(_sizeJsonArr);
        for(i$iterator = (_doubleDotLessThan.last - _doubleDotLessThan.first) * _doubleDotLessThan.step < 0 ? ($clinit_ExclusiveRange(), EMPTY_LIST_ITERATOR) : new ExclusiveRange$RangeIterator(_doubleDotLessThan); i$iterator.hasNext_0();){
            i = castTo(i$iterator.next_1(), 17);
            _optJSONObject_2 = $optJSONObject(bendPoints_1, i.value_0);
            _function_3 = new JsonImporter$lambda$10$Type(section_1);
            $lambda$10_0(_function_3.section_1, _optJSONObject_2);
        }
    }
}
function $recordCoordinateModes(this$static, element) {
    var _edgeCoordsMode, _elvis, _elvis_1, _elvis_2, _elvis_3, _property, _property_1, _shapeCoordsMode, _xblockexpression, ecm, parent_0, scm;
    _xblockexpression = null;
    parent_0 = $jsonParent(this$static, element);
    _elvis = null;
    _property = castTo($getProperty_0(element, ($clinit_CoreOptions(), JSON_SHAPE_COORDS)), 297);
    _property ? _elvis = _property : _elvis = ($clinit_ShapeCoords(), INHERIT_1);
    scm = _elvis;
    if (scm == ($clinit_ShapeCoords(), INHERIT_1)) {
        _elvis_1 = null;
        _shapeCoordsMode = castTo($get_10(this$static.shapeCoordsMap, parent_0), 297);
        _shapeCoordsMode ? _elvis_1 = _shapeCoordsMode : _elvis_1 = PARENT_0;
        scm = _elvis_1;
    }
    $put_6(this$static.shapeCoordsMap, element, scm);
    _elvis_2 = null;
    _property_1 = castTo($getProperty_0(element, JSON_EDGE_COORDS), 275);
    _property_1 ? _elvis_2 = _property_1 : _elvis_2 = ($clinit_EdgeCoords(), INHERIT);
    ecm = _elvis_2;
    if (ecm == ($clinit_EdgeCoords(), INHERIT)) {
        _elvis_3 = null;
        _edgeCoordsMode = castTo($get_10(this$static.edgeCoordsMap, parent_0), 275);
        _edgeCoordsMode ? _elvis_3 = _edgeCoordsMode : _elvis_3 = CONTAINER;
        ecm = _elvis_3;
    }
    _xblockexpression = castTo($put_6(this$static.edgeCoordsMap, element, ecm), 275);
    return _xblockexpression;
}
function $recordGlobalCoords(this$static, shape_0) {
    var _elvis, _elvis_1, _globalX, _globalY, _plus, _plus_1, _shapeAncestor, _x, _xblockexpression, _y, dx, dy, parent_0, shapeA;
    _xblockexpression = null;
    parent_0 = $jsonParent(this$static, shape_0);
    _shapeAncestor = null;
    !!parent_0 && (_shapeAncestor = $shapeAncestor(this$static, parent_0));
    shapeA = _shapeAncestor;
    _elvis = null;
    _globalX = castToDouble($get_10(this$static.globalXMap, shapeA));
    _globalX != null ? _elvis = _globalX : _elvis = valueOf_3(0);
    dx = _elvis;
    _elvis_1 = null;
    _globalY = castToDouble($get_10(this$static.globalYMap, shapeA));
    _globalY != null ? _elvis_1 = _globalY : _elvis_1 = valueOf_3(0);
    dy = _elvis_1;
    _x = shape_0.x_0;
    _plus = operator_plus(_x, dx);
    $put_6(this$static.globalXMap, shape_0, _plus);
    _y = shape_0.y_0;
    _plus_1 = operator_plus(_y, dy);
    _xblockexpression = castToDouble($put_6(this$static.globalYMap, shape_0, _plus_1));
    return _xblockexpression;
}
function $register_2(this$static, edge, obj) {
    var id_0;
    id_0 = $getId(obj);
    $put_6(this$static.edgeIdMap, id_0, edge);
    $put_6(this$static.edgeJsonMap, edge, obj);
    $put_6(this$static.edgeOriginalParentMap, edge, $getContainingNode(edge));
    return edge;
}
function $register_3(this$static, edgeSection, obj) {
    var id_0;
    id_0 = $getId(obj);
    $put_3(this$static.edgeSectionIdMap, id_0, edgeSection);
    $put_6(this$static.edgeSectionJsonMap, edgeSection, obj);
    return edgeSection;
}
function $register_4(this$static, node, obj) {
    var id_0;
    id_0 = $getId(obj);
    $put_3(this$static.nodeIdMap, id_0, node);
    $put_3(this$static.nodeJsonMap, node, obj);
    return node;
}
function $register_5(this$static, port, obj) {
    var id_0;
    id_0 = $getId(obj);
    $put_3(this$static.portIdMap, id_0, port);
    $put_6(this$static.portJsonMap, port, obj);
    return port;
}
function $setOption(e, id_0, value_0) {
    var _xblockexpression, _xblockexpression_1, _xifexpression, _xifexpression_1, optionData, parsed;
    _xblockexpression = null;
    optionData = $getOptionDataBySuffix(getInstance(), id_0);
    _xifexpression = null;
    if (optionData) {
        _xblockexpression_1 = null;
        parsed = $parseValue(optionData, value_0);
        _xifexpression_1 = null;
        parsed != null && (_xifexpression_1 = e.setProperty(optionData, parsed));
        _xblockexpression_1 = _xifexpression_1;
        _xifexpression = _xblockexpression_1;
    }
    _xblockexpression = _xifexpression;
    return _xblockexpression;
}
function $shapeAncestor(this$static, edge) {
    if (instanceOf(edge, 268)) return $_shapeAncestor(this$static, castTo(edge, 85));
    else if (instanceOf(edge, 273)) return castTo(edge, 273);
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        edge
    ])))));
}
function $shapeById(this$static, id_0) {
    var node, port;
    node = castTo($get_4(this$static.nodeIdMap, id_0), 27);
    if (node) return node;
    port = castTo($get_4(this$static.portIdMap, id_0), 124);
    if (port) return port;
    throw toJs(new JsonImportException('Referenced shape does not exist: ' + id_0));
}
function $transferLayoutInt1(this$static, node) {
    if (instanceOf(node, 206)) return $_transferLayoutInt1(this$static, castTo(node, 27));
    else if (instanceOf(node, 193)) return $_transferLayoutInt1_0(this$static, castTo(node, 124));
    else if (node) return null;
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        node
    ])))));
}
function $transferLayoutInt2(this$static, label_0) {
    if (instanceOf(label_0, 359)) return $_transferLayoutInt2_0(this$static, castTo(label_0, 153));
    else if (instanceOf(label_0, 268)) return $_transferLayoutInt2(this$static, castTo(label_0, 85));
    else if (label_0) return null;
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        label_0
    ])))));
}
function $transferShapeLayout(this$static, shape_0, jsonObjA) {
    var _adjustX, _adjustY, _elvis, _elvis_1, _x, _y, jsonObj, parent_0;
    jsonObj = castTo(jsonObjA, 147);
    parent_0 = $jsonParent(this$static, shape_0);
    _elvis = null;
    _adjustX = null;
    !!parent_0 && (_adjustX = $adjustX(this$static, parent_0, shape_0.x_0));
    if (_adjustX != null) _elvis = _adjustX;
    else {
        _x = shape_0.x_0;
        _elvis = _x;
    }
    $addJsonObj(jsonObj, 'x', _elvis);
    _elvis_1 = null;
    _adjustY = null;
    !!parent_0 && (_adjustY = $adjustY(this$static, parent_0, shape_0.y_0));
    if (_adjustY != null) _elvis_1 = _adjustY;
    else {
        _y = shape_0.y_0;
        _elvis_1 = _y;
    }
    $addJsonObj(jsonObj, 'y', _elvis_1);
    $addJsonObj(jsonObj, 'width', shape_0.width_0);
    $addJsonObj(jsonObj, 'height', shape_0.height);
}
function $transformChildNodes(this$static, jsonNodeA, parent_0) {
    var _function, _optJSONArray, _xblockexpression, jsonNode;
    _xblockexpression = null;
    jsonNode = jsonNodeA;
    _optJSONArray = $optJSONArray(jsonNode, 'children');
    _function = new JsonImporter$lambda$0$Type(this$static, parent_0);
    _xblockexpression = ($lambda$0_13(_function.$$outer_0, _function.parent_1, _optJSONArray), _optJSONArray);
    return _xblockexpression;
}
function $transformEdge_1(this$static, jsonObjA, parent_0) {
    var _function, _function_1, _idSave, _optJSONArray, _optJSONArray_1, _plus, _plus_1, _xblockexpression, edge, jsonObj;
    _xblockexpression = null;
    jsonObj = jsonObjA;
    edge = $register_2(this$static, createEdge(parent_0), jsonObj);
    $setIdentifier(edge, $optString(jsonObj, 'id'));
    _optJSONArray = $optJSONArray(jsonObj, 'sources');
    _function = new JsonImporter$lambda$11$Type(this$static, edge);
    $lambda$11(_function.$$outer_0, _function.edge_1, _optJSONArray);
    _optJSONArray_1 = $optJSONArray(jsonObj, 'targets');
    _function_1 = new JsonImporter$lambda$12$Type(this$static, edge);
    $lambda$12_0(_function_1.$$outer_0, _function_1.edge_1, _optJSONArray_1);
    if ((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources).size_0 == 0 || (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets).size_0 == 0) {
        _idSave = $optString(jsonObj, 'id');
        _plus = "An edge must have at least one source and one target (edge id: '" + _idSave;
        _plus_1 = _plus + "').";
        throw toJs(new JsonImportException(_plus_1));
    }
    $transformProperties(jsonObj, edge);
    $transformEdgeSections(this$static, jsonObj, edge);
    _xblockexpression = $transformLabels(this$static, jsonObj, edge);
    return _xblockexpression;
}
function $transformEdgeSections(this$static, jsonObjA, edge) {
    var _function, _get, _get_1, _idSave, _incomingSections, _keySet, _keySet_1, _optJSONArray, _outgoingSections, _plus, _plus_1, id_0, id$iterator, id_1, id_1$iterator, incomingSectionIdentifiers, jsonObj, outgoingSectionIdentifiers, referencedSection, result, result0, section, section$iterator, section_1, section_1$iterator, section_2;
    jsonObj = jsonObjA;
    incomingSectionIdentifiers = new HashMultimap;
    outgoingSectionIdentifiers = new HashMultimap;
    _optJSONArray = $optJSONArray(jsonObj, 'sections');
    _function = new JsonImporter$lambda$13$Type(this$static, edge, incomingSectionIdentifiers, outgoingSectionIdentifiers);
    $lambda$13(_function.$$outer_0, _function.edge_1, _function.incomingSectionIdentifiers_2, _function.outgoingSectionIdentifiers_3, _optJSONArray);
    _keySet = (result0 = incomingSectionIdentifiers.keySet, !result0 ? incomingSectionIdentifiers.keySet = new AbstractMapBasedMultimap$KeySet(incomingSectionIdentifiers, incomingSectionIdentifiers.map_0) : result0);
    for(section$iterator = _keySet.iterator_0(); section$iterator.hasNext_0();){
        section = castTo(section$iterator.next_1(), 168);
        _get = castTo($get(incomingSectionIdentifiers, section), 22);
        for(id$iterator = _get.iterator_0(); id$iterator.hasNext_0();){
            id_0 = id$iterator.next_1();
            referencedSection = castTo($get_4(this$static.edgeSectionIdMap, id_0), 168);
            if (referencedSection) {
                _incomingSections = (!section.incomingSections && (section.incomingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, section, 10, 9)), section.incomingSections);
                $add_21(_incomingSections, referencedSection);
            } else {
                _idSave = $optString(jsonObj, 'id');
                _plus = 'Referenced edge section does not exist: ' + id_0 + " (edge id: '" + _idSave;
                _plus_1 = _plus + "').";
                throw toJs(new JsonImportException(_plus_1));
            }
        }
    }
    _keySet_1 = (result = outgoingSectionIdentifiers.keySet, !result ? outgoingSectionIdentifiers.keySet = new AbstractMapBasedMultimap$KeySet(outgoingSectionIdentifiers, outgoingSectionIdentifiers.map_0) : result);
    for(section_1$iterator = _keySet_1.iterator_0(); section_1$iterator.hasNext_0();){
        section_1 = castTo(section_1$iterator.next_1(), 168);
        _get_1 = castTo($get(outgoingSectionIdentifiers, section_1), 22);
        for(id_1$iterator = _get_1.iterator_0(); id_1$iterator.hasNext_0();){
            id_1 = id_1$iterator.next_1();
            referencedSection = castTo($get_4(this$static.edgeSectionIdMap, id_1), 168);
            if (referencedSection) {
                _outgoingSections = (!section_1.outgoingSections && (section_1.outgoingSections = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, section_1, 9, 10)), section_1.outgoingSections);
                $add_21(_outgoingSections, referencedSection);
            } else {
                _idSave = $optString(jsonObj, 'id');
                _plus = 'Referenced edge section does not exist: ' + id_1 + " (edge id: '" + _idSave;
                _plus_1 = _plus + "').";
                throw toJs(new JsonImportException(_plus_1));
            }
        }
    }
    !edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7));
    if (edge.sources.size_0 != 0 && (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets.size_0 != 0) && (!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources.size_0 <= 1 && (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets.size_0 <= 1)) && (!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 == 1) {
        section_2 = castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168);
        if (!$getIncomingShape(section_2) && !$getOutgoingShape(section_2)) {
            $setIncomingShape(section_2, castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84));
            $setOutgoingShape(section_2, castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84));
        }
    }
}
function $transformEdges_2(this$static, jsonObjA) {
    var _function, _function_1, _idSave, _optJSONArray, _optJSONArray_1, _plus, _plus_1, jsonObj, node;
    jsonObj = jsonObjA;
    node = castTo($get_5($inverse(this$static.nodeJsonMap), jsonObj), 27);
    if (!node) {
        _idSave = $optString(jsonObj, 'id');
        _plus = "Unable to find elk node for json object '" + _idSave;
        _plus_1 = _plus + "' Panic!";
        throw toJs(new JsonImportException(_plus_1));
    }
    _optJSONArray = $optJSONArray(jsonObj, 'edges');
    _function = new JsonImporter$lambda$1$Type(this$static, node);
    $lambda$1_8(_function.$$outer_0, _function.node_1, _optJSONArray);
    _optJSONArray_1 = $optJSONArray(jsonObj, 'children');
    _function_1 = new JsonImporter$lambda$2$Type(this$static);
    $lambda$2_5(_function_1.$$outer_0, _optJSONArray_1);
}
function $transformIndividualSpacings(jsonObjA, layoutData) {
    var _function, _hasProperty, _individualSpacings, _keysJsonObj, _not, individualSpacings, jsonIndividualSpacings, jsonObj, keys_0, opts;
    jsonObj = jsonObjA;
    jsonIndividualSpacings = $optJSONObject_0(jsonObj, 'individualSpacings');
    if (jsonIndividualSpacings) {
        _hasProperty = $hasProperty_0(layoutData, ($clinit_CoreOptions(), SPACING_INDIVIDUAL_0));
        _not = !_hasProperty;
        if (_not) {
            _individualSpacings = new IndividualSpacings;
            $setProperty_1(layoutData, SPACING_INDIVIDUAL_0, _individualSpacings);
        }
        individualSpacings = castTo($getProperty_0(layoutData, SPACING_INDIVIDUAL_0), 377);
        opts = jsonIndividualSpacings;
        _keysJsonObj = null;
        !!opts && (_keysJsonObj = (keys_0 = $computeKeys0(opts, initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 0, 6, 1)), new JSONObject$1(opts, keys_0)));
        if (_keysJsonObj) {
            _function = new JsonImporter$lambda$28$Type(opts, individualSpacings);
            $forEach_0(_keysJsonObj, _function);
        }
    }
}
function $transformLabels(this$static, jsonObjA, element) {
    var _function, _optJSONArray, _xblockexpression, jsonObj;
    _xblockexpression = null;
    jsonObj = jsonObjA;
    _optJSONArray = $optJSONArray(jsonObj, 'labels');
    _function = new JsonImporter$lambda$29$Type(this$static, element);
    _xblockexpression = ($lambda$29_0(_function.$$outer_0, _function.element_1, _optJSONArray), _optJSONArray);
    return _xblockexpression;
}
function $transformNode_0(this$static, jsonNode, parent_0) {
    var node, node_0, elkNode, jsonObj, _optJSONArray, _function;
    node = $register_4(this$static, (node_0 = ($clinit_ElkGraphFactory(), elkNode = new ElkNodeImpl, elkNode), !!parent_0 && $setParent_2(node_0, parent_0), node_0), jsonNode);
    $setIdentifier(node, $optString(jsonNode, 'id'));
    $transformProperties(jsonNode, node);
    $transformIndividualSpacings(jsonNode, node);
    $transformShapeLayout(jsonNode, node);
    _xblockexpression = null;
    jsonObj = jsonNode;
    _optJSONArray = $optJSONArray(jsonObj, 'ports');
    _function = new JsonImporter$lambda$30$Type(this$static, node);
    $lambda$30(_function.$$outer_0, _function.parent_1, _optJSONArray);
    $transformLabels(this$static, jsonNode, node);
    $transformChildNodes(this$static, jsonNode, node);
    return node;
}
function $transformPrimitiveEdge(this$static, jsonObjA, parent_0) {
    var _asId, _asId_1, _elvis, _elvis_1, _id, _idSave, _idSave_1, _idSave_2, _id_1, _jsonObj, _jsonObj_1, _plus, _plus_1, _plus_2, _plus_3, _plus_4, _plus_5, _plus_6, _plus_7, _plus_8, _plus_9, _sources, _targets, _xblockexpression, edge, jsonObj, srcNode, srcPort, tgtNode, tgtPort;
    _xblockexpression = null;
    jsonObj = jsonObjA;
    edge = $register_2(this$static, createEdge(parent_0), jsonObj);
    $setIdentifier(edge, $optString(jsonObj, 'id'));
    srcNode = castTo($get_4(this$static.nodeIdMap, $asId($get_9(jsonObj, 'source'))), 27);
    _jsonObj = $get_9(jsonObj, 'sourcePort');
    _asId = null;
    !!_jsonObj && (_asId = $asId(_jsonObj));
    srcPort = castTo($get_4(this$static.portIdMap, _asId), 124);
    if (!srcNode) {
        _id = $getId(jsonObj);
        _plus = "An edge must have a source node (edge id: '" + _id;
        _plus_1 = _plus + "').";
        throw toJs(new JsonImportException(_plus_1));
    }
    if (!!srcPort && !equal($getParent_3(srcPort), srcNode)) {
        _idSave = $optString(jsonObj, 'id');
        _plus_2 = "The source port of an edge must be a port of the edge's source node (edge id: '" + _idSave;
        _plus_3 = _plus_2 + "').";
        throw toJs(new JsonImportException(_plus_3));
    }
    _sources = (!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources);
    _elvis = null;
    srcPort ? _elvis = srcPort : _elvis = srcNode;
    $add_21(_sources, _elvis);
    tgtNode = castTo($get_4(this$static.nodeIdMap, $asId($get_9(jsonObj, 'target'))), 27);
    _jsonObj_1 = $get_9(jsonObj, 'targetPort');
    _asId_1 = null;
    !!_jsonObj_1 && (_asId_1 = $asId(_jsonObj_1));
    tgtPort = castTo($get_4(this$static.portIdMap, _asId_1), 124);
    if (!tgtNode) {
        _id_1 = $getId(jsonObj);
        _plus_4 = "An edge must have a target node (edge id: '" + _id_1;
        _plus_5 = _plus_4 + "').";
        throw toJs(new JsonImportException(_plus_5));
    }
    if (!!tgtPort && !equal($getParent_3(tgtPort), tgtNode)) {
        _idSave_1 = $optString(jsonObj, 'id');
        _plus_6 = "The target port of an edge must be a port of the edge's target node (edge id: '" + _idSave_1;
        _plus_7 = _plus_6 + "').";
        throw toJs(new JsonImportException(_plus_7));
    }
    _targets = (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets);
    _elvis_1 = null;
    tgtPort ? _elvis_1 = tgtPort : _elvis_1 = tgtNode;
    $add_21(_targets, _elvis_1);
    if ((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources).size_0 == 0 || (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets).size_0 == 0) {
        _idSave_2 = $optString(jsonObj, 'id');
        _plus_8 = "An edge must have at least one source and one target (edge id: '" + _idSave_2;
        _plus_9 = _plus_8 + "').";
        throw toJs(new JsonImportException(_plus_9));
    }
    $transformProperties(jsonObj, edge);
    $transformPrimitiveEdgeLayout(jsonObj, edge);
    _xblockexpression = $transformLabels(this$static, jsonObj, edge);
    return _xblockexpression;
}
function $transformPrimitiveEdgeLayout(jsonObjA, edge) {
    var _function, _function_1, _function_2, _optJSONArray, _optJSONObject, _optJSONObject_1, _xblockexpression, _xblockexpression_1, _xifexpression, jsonObj, section;
    _xblockexpression = null;
    jsonObj = jsonObjA;
    _xifexpression = null;
    if ('sourcePoint' in jsonObj.jsObject || 'targetPoint' in jsonObj.jsObject || 'bendPoints' in jsonObj.jsObject) {
        _xblockexpression_1 = null;
        section = createEdgeSection(edge);
        _optJSONObject = $optJSONObject_0(jsonObj, 'sourcePoint');
        _function = new JsonImporter$lambda$3$Type(section);
        $lambda$3_4(_function.section_1, _optJSONObject);
        _optJSONObject_1 = $optJSONObject_0(jsonObj, 'targetPoint');
        _function_1 = new JsonImporter$lambda$6$Type(section);
        $lambda$6_0(_function_1.section_1, _optJSONObject_1);
        _optJSONArray = $optJSONArray(jsonObj, 'bendPoints');
        _function_2 = new JsonImporter$lambda$9$Type(section);
        _xblockexpression_1 = ($lambda$9_1(_function_2.section_1, _optJSONArray), _optJSONArray);
        _xifexpression = _xblockexpression_1;
    }
    _xblockexpression = _xifexpression;
    return _xblockexpression;
}
function $transformProperties(jsonObjA, layoutData) {
    var _function, _keysJsonObj, jsonObj, keys_0, layoutOptions, opts;
    jsonObj = jsonObjA;
    layoutOptions = $optJSONObject_0(jsonObj, 'layoutOptions');
    !layoutOptions && (layoutOptions = $optJSONObject_0(jsonObj, 'properties'));
    if (layoutOptions) {
        opts = layoutOptions;
        _keysJsonObj = null;
        !!opts && (_keysJsonObj = (keys_0 = $computeKeys0(opts, initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 0, 6, 1)), new JSONObject$1(opts, keys_0)));
        if (_keysJsonObj) {
            _function = new JsonImporter$lambda$27$Type(opts, layoutData);
            $forEach_0(_keysJsonObj, _function);
        }
    }
}
function $transformShapeLayout(jsonObjA, shape_0) {
    var _function, _function_1, _function_2, _function_3, _optDouble, _optDouble_1, _optDouble_2, _optDouble_3, _xblockexpression, jsonObj;
    _xblockexpression = null;
    jsonObj = jsonObjA;
    _optDouble = $optDouble(jsonObj, 'x');
    _function = new JsonImporter$lambda$31$Type(shape_0);
    $lambda$31(_function.shape_1, _optDouble);
    _optDouble_1 = $optDouble(jsonObj, 'y');
    _function_1 = new JsonImporter$lambda$32$Type(shape_0);
    $lambda$32(_function_1.shape_1, _optDouble_1);
    _optDouble_2 = $optDouble(jsonObj, 'width');
    _function_2 = new JsonImporter$lambda$33$Type(shape_0);
    $lambda$33(_function_2.shape_1, _optDouble_2);
    _optDouble_3 = $optDouble(jsonObj, 'height');
    _function_3 = new JsonImporter$lambda$34$Type(shape_0);
    _xblockexpression = ($lambda$34(_function_3.shape_1, _optDouble_3), _optDouble_3);
    return _xblockexpression;
}
function JsonImporter() {
    this._jsonAdapter = new JsonAdapter;
    this.nodeIdMap = new HashBiMap;
    this.portIdMap = new HashBiMap;
    this.edgeIdMap = new HashMap;
    this.edgeSectionIdMap = new HashBiMap;
    this.nodeJsonMap = new HashBiMap;
    this.portJsonMap = new HashMap;
    this.edgeJsonMap = new HashMap;
    this.edgeSectionJsonMap = new HashMap;
    this.labelJsonMap = new HashMap;
    this.edgeOriginalParentMap = new HashMap;
    this.globalXMap = new HashMap;
    this.globalYMap = new HashMap;
    this.shapeCoordsMap = new HashMap;
    this.edgeCoordsMap = new HashMap;
}
defineClass(845, 1, {}, JsonImporter);
var Lorg_eclipse_elk_graph_json_JsonImporter_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter', 845);
function JsonImporter$lambda$0$Type($$outer_0, parent_1) {
    this.$$outer_0 = $$outer_0;
    this.parent_1 = parent_1;
}
defineClass(879, 1, {}, JsonImporter$lambda$0$Type);
_.apply_5 = function apply_157(arg0) {
    $lambda$0_13(this.$$outer_0, this.parent_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$0$Type', 879);
function JsonImporter$lambda$1$Type($$outer_0, node_1) {
    this.$$outer_0 = $$outer_0;
    this.node_1 = node_1;
}
defineClass(880, 1, {}, JsonImporter$lambda$1$Type);
_.apply_5 = function apply_158(arg0) {
    $lambda$1_8(this.$$outer_0, this.node_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$1$Type', 880);
function JsonImporter$lambda$10$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(888, 1, {}, JsonImporter$lambda$10$Type);
_.apply_5 = function apply_159(arg0) {
    $lambda$10_0(this.section_1, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$10$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$10$Type', 888);
function JsonImporter$lambda$11$Type($$outer_0, edge_1) {
    this.$$outer_0 = $$outer_0;
    this.edge_1 = edge_1;
}
defineClass(890, 1, {}, JsonImporter$lambda$11$Type);
_.apply_5 = function apply_160(arg0) {
    $lambda$11(this.$$outer_0, this.edge_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$11$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$11$Type', 890);
function JsonImporter$lambda$12$Type($$outer_0, edge_1) {
    this.$$outer_0 = $$outer_0;
    this.edge_1 = edge_1;
}
defineClass(891, 1, {}, JsonImporter$lambda$12$Type);
_.apply_5 = function apply_161(arg0) {
    $lambda$12_0(this.$$outer_0, this.edge_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$12$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$12$Type', 891);
function JsonImporter$lambda$13$Type($$outer_0, edge_1, incomingSectionIdentifiers_2, outgoingSectionIdentifiers_3) {
    this.$$outer_0 = $$outer_0;
    this.edge_1 = edge_1;
    this.incomingSectionIdentifiers_2 = incomingSectionIdentifiers_2;
    this.outgoingSectionIdentifiers_3 = outgoingSectionIdentifiers_3;
}
defineClass(897, 1, {}, JsonImporter$lambda$13$Type);
_.apply_5 = function apply_162(arg0) {
    $lambda$13(this.$$outer_0, this.edge_1, this.incomingSectionIdentifiers_2, this.outgoingSectionIdentifiers_3, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$13$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$13$Type', 897);
function JsonImporter$lambda$14$Type($$outer_0, edge_1, incomingSectionIdentifiers_2, outgoingSectionIdentifiers_3) {
    this.$$outer_0 = $$outer_0;
    this.edge_1 = edge_1;
    this.incomingSectionIdentifiers_2 = incomingSectionIdentifiers_2;
    this.outgoingSectionIdentifiers_3 = outgoingSectionIdentifiers_3;
}
defineClass(896, 1, {}, JsonImporter$lambda$14$Type);
_.apply_5 = function apply_163(arg0) {
    $lambda$14_0(this.$$outer_0, this.edge_1, this.incomingSectionIdentifiers_2, this.outgoingSectionIdentifiers_3, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$14$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$14$Type', 896);
function JsonImporter$lambda$15$Type($$outer_0, elkSection_1) {
    this.$$outer_0 = $$outer_0;
    this.elkSection_1 = elkSection_1;
}
defineClass(892, 1, {}, JsonImporter$lambda$15$Type);
_.apply_5 = function apply_164(arg0) {
    $lambda$15(this.$$outer_0, this.elkSection_1, castToString(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$15$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$15$Type', 892);
function JsonImporter$lambda$16$Type($$outer_0, elkSection_1) {
    this.$$outer_0 = $$outer_0;
    this.elkSection_1 = elkSection_1;
}
defineClass(893, 1, {}, JsonImporter$lambda$16$Type);
_.apply_5 = function apply_165(arg0) {
    $lambda$16(this.$$outer_0, this.elkSection_1, castToString(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$16$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$16$Type', 893);
function JsonImporter$lambda$17$Type(incomingSectionIdentifiers_1, elkSection_2) {
    this.incomingSectionIdentifiers_1 = incomingSectionIdentifiers_1;
    this.elkSection_2 = elkSection_2;
}
defineClass(894, 1, {}, JsonImporter$lambda$17$Type);
_.apply_5 = function apply_166(arg0) {
    $lambda$17(this.incomingSectionIdentifiers_1, this.elkSection_2, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$17$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$17$Type', 894);
function JsonImporter$lambda$18$Type(outgoingSectionIdentifiers_1, elkSection_2) {
    this.outgoingSectionIdentifiers_1 = outgoingSectionIdentifiers_1;
    this.elkSection_2 = elkSection_2;
}
defineClass(895, 1, {}, JsonImporter$lambda$18$Type);
_.apply_5 = function apply_167(arg0) {
    $lambda$18_0(this.outgoingSectionIdentifiers_1, this.elkSection_2, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$18$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$18$Type', 895);
function JsonImporter$lambda$19$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(900, 1, {}, JsonImporter$lambda$19$Type);
_.apply_5 = function apply_168(arg0) {
    $lambda$19_0(this.section_1, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$19$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$19$Type', 900);
function JsonImporter$lambda$2$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(881, 1, {}, JsonImporter$lambda$2$Type);
_.apply_5 = function apply_169(arg0) {
    $lambda$2_5(this.$$outer_0, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$2$Type', 881);
function JsonImporter$lambda$20$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(898, 1, {}, JsonImporter$lambda$20$Type);
_.apply_5 = function apply_170(arg0) {
    $setStartX(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$20$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$20$Type', 898);
function JsonImporter$lambda$21$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(899, 1, {}, JsonImporter$lambda$21$Type);
_.apply_5 = function apply_171(arg0) {
    $setStartY(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$21$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$21$Type', 899);
function JsonImporter$lambda$22$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(903, 1, {}, JsonImporter$lambda$22$Type);
_.apply_5 = function apply_172(arg0) {
    $lambda$22_0(this.section_1, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$22$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$22$Type', 903);
function JsonImporter$lambda$23$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(901, 1, {}, JsonImporter$lambda$23$Type);
_.apply_5 = function apply_173(arg0) {
    $setEndX(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$23$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$23$Type', 901);
function JsonImporter$lambda$24$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(902, 1, {}, JsonImporter$lambda$24$Type);
_.apply_5 = function apply_174(arg0) {
    $setEndY(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$24$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$24$Type', 902);
function JsonImporter$lambda$25$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(905, 1, {}, JsonImporter$lambda$25$Type);
_.apply_5 = function apply_175(arg0) {
    $lambda$25_0(this.section_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$25$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$25$Type', 905);
function JsonImporter$lambda$26$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(904, 1, {}, JsonImporter$lambda$26$Type);
_.apply_5 = function apply_176(arg0) {
    $lambda$26_0(this.section_1, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$26$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$26$Type', 904);
function JsonImporter$lambda$27$Type(opts_1, layoutData_2) {
    this.opts_1 = opts_1;
    this.layoutData_2 = layoutData_2;
}
defineClass(906, 1, $intern_19, JsonImporter$lambda$27$Type);
_.accept = function accept_152(arg0) {
    $lambda$27_0(this.opts_1, this.layoutData_2, castToString(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$27$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$27$Type', 906);
function JsonImporter$lambda$28$Type(opts_1, individualSpacings_2) {
    this.opts_1 = opts_1;
    this.individualSpacings_2 = individualSpacings_2;
}
defineClass(907, 1, $intern_19, JsonImporter$lambda$28$Type);
_.accept = function accept_153(arg0) {
    $lambda$28(this.opts_1, this.individualSpacings_2, castToString(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$28$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$28$Type', 907);
function JsonImporter$lambda$29$Type($$outer_0, element_1) {
    this.$$outer_0 = $$outer_0;
    this.element_1 = element_1;
}
defineClass(908, 1, {}, JsonImporter$lambda$29$Type);
_.apply_5 = function apply_177(arg0) {
    $lambda$29_0(this.$$outer_0, this.element_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$29$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$29$Type', 908);
function JsonImporter$lambda$3$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(884, 1, {}, JsonImporter$lambda$3$Type);
_.apply_5 = function apply_178(arg0) {
    $lambda$3_4(this.section_1, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$3$Type', 884);
function JsonImporter$lambda$30$Type($$outer_0, parent_1) {
    this.$$outer_0 = $$outer_0;
    this.parent_1 = parent_1;
}
defineClass(909, 1, {}, JsonImporter$lambda$30$Type);
_.apply_5 = function apply_179(arg0) {
    $lambda$30(this.$$outer_0, this.parent_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$30$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$30$Type', 909);
function JsonImporter$lambda$31$Type(shape_1) {
    this.shape_1 = shape_1;
}
defineClass(910, 1, {}, JsonImporter$lambda$31$Type);
_.apply_5 = function apply_180(arg0) {
    $lambda$31(this.shape_1, castToDouble(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$31$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$31$Type', 910);
function JsonImporter$lambda$32$Type(shape_1) {
    this.shape_1 = shape_1;
}
defineClass(911, 1, {}, JsonImporter$lambda$32$Type);
_.apply_5 = function apply_181(arg0) {
    $lambda$32(this.shape_1, castToDouble(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$32$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$32$Type', 911);
function JsonImporter$lambda$33$Type(shape_1) {
    this.shape_1 = shape_1;
}
defineClass(912, 1, {}, JsonImporter$lambda$33$Type);
_.apply_5 = function apply_182(arg0) {
    $lambda$33(this.shape_1, castToDouble(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$33$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$33$Type', 912);
function JsonImporter$lambda$34$Type(shape_1) {
    this.shape_1 = shape_1;
}
defineClass(913, 1, {}, JsonImporter$lambda$34$Type);
_.apply_5 = function apply_183(arg0) {
    $lambda$34(this.shape_1, castToDouble(arg0));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$34$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$34$Type', 913);
function JsonImporter$lambda$35$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(914, 1, {}, JsonImporter$lambda$35$Type);
_.apply_5 = function apply_184(arg0) {
    $transferLayoutInt1(this.$$outer_0, castTo(arg0, 57));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$35$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$35$Type', 914);
function JsonImporter$lambda$36$Type($$outer_0) {
    this.$$outer_0 = $$outer_0;
}
defineClass(915, 1, {}, JsonImporter$lambda$36$Type);
_.apply_5 = function apply_185(arg0) {
    $transferLayoutInt2(this.$$outer_0, castTo(arg0, 57));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$36$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$36$Type', 915);
function $apply_19(this$static, arg0, arg1) {
    $lambda$37(this$static.$$outer_0, this$static.edgeId_1, this$static.sections_2, this$static.edge_3, castTo(arg0, 168), arg1);
}
function JsonImporter$lambda$37$Type($$outer_0, edgeId_1, sections_2, edge_3) {
    this.$$outer_0 = $$outer_0;
    this.edgeId_1 = edgeId_1;
    this.sections_2 = sections_2;
    this.edge_3 = edge_3;
}
defineClass(919, 1, {}, JsonImporter$lambda$37$Type);
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$37$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$37$Type', 919);
function JsonImporter$lambda$38$Type($$outer_0, edge_1, bendPoints_2) {
    this.$$outer_0 = $$outer_0;
    this.edge_1 = edge_1;
    this.bendPoints_2 = bendPoints_2;
}
defineClass(916, 1, $intern_19, JsonImporter$lambda$38$Type);
_.accept = function accept_154(arg0) {
    $lambda$38(this.$$outer_0, this.edge_1, this.bendPoints_2, castTo(arg0, 369));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$38$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$38$Type', 916);
function JsonImporter$lambda$39$Type($$outer_0, incomingSections_1) {
    this.$$outer_0 = $$outer_0;
    this.incomingSections_1 = incomingSections_1;
}
defineClass(917, 1, $intern_19, JsonImporter$lambda$39$Type);
_.accept = function accept_155(arg0) {
    $lambda$39(this.$$outer_0, this.incomingSections_1, castTo(arg0, 168));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$39$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$39$Type', 917);
function JsonImporter$lambda$4$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(882, 1, {}, JsonImporter$lambda$4$Type);
_.apply_5 = function apply_186(arg0) {
    $setStartX(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$4$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$4$Type', 882);
function JsonImporter$lambda$40$Type($$outer_0, outgoingSections_1) {
    this.$$outer_0 = $$outer_0;
    this.outgoingSections_1 = outgoingSections_1;
}
defineClass(918, 1, $intern_19, JsonImporter$lambda$40$Type);
_.accept = function accept_156(arg0) {
    $lambda$40(this.$$outer_0, this.outgoingSections_1, castTo(arg0, 168));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$40$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$40$Type', 918);
function JsonImporter$lambda$41$Type($$outer_0, edge_1, jsonJPs_2) {
    this.$$outer_0 = $$outer_0;
    this.edge_1 = edge_1;
    this.jsonJPs_2 = jsonJPs_2;
}
defineClass(920, 1, $intern_19, JsonImporter$lambda$41$Type);
_.accept = function accept_157(arg0) {
    $lambda$41(this.$$outer_0, this.edge_1, this.jsonJPs_2, castTo(arg0, 8));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$41$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$41$Type', 920);
function JsonImporter$lambda$5$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(883, 1, {}, JsonImporter$lambda$5$Type);
_.apply_5 = function apply_187(arg0) {
    $setStartY(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$5$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$5$Type', 883);
function JsonImporter$lambda$6$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(887, 1, {}, JsonImporter$lambda$6$Type);
_.apply_5 = function apply_188(arg0) {
    $lambda$6_0(this.section_1, castTo(arg0, 147));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$6$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$6$Type', 887);
function JsonImporter$lambda$7$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(885, 1, {}, JsonImporter$lambda$7$Type);
_.apply_5 = function apply_189(arg0) {
    $setEndX(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$7$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$7$Type', 885);
function JsonImporter$lambda$8$Type(section_0) {
    this.section_0 = section_0;
}
defineClass(886, 1, {}, JsonImporter$lambda$8$Type);
_.apply_5 = function apply_190(arg0) {
    $setEndY(this.section_0, $doubleValue(castToDouble(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$8$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$8$Type', 886);
function JsonImporter$lambda$9$Type(section_1) {
    this.section_1 = section_1;
}
defineClass(889, 1, {}, JsonImporter$lambda$9$Type);
_.apply_5 = function apply_191(arg0) {
    $lambda$9_1(this.section_1, castTo(arg0, 138));
};
var Lorg_eclipse_elk_graph_json_JsonImporter$lambda$9$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonImporter/lambda$9$Type', 889);
function _toJson(lad) {
    var _categoryId, _function, _function_1, _isNullOrEmpty, _isNullOrEmpty_1, _not, _not_1, _tripleNotEquals, jsonArr, jsonArr_1, jsonObj;
    jsonObj = createCommon(lad);
    _categoryId = lad.category;
    _tripleNotEquals = _categoryId != null;
    _tripleNotEquals && $addJsonObj_1(jsonObj, 'category', lad.category);
    _isNullOrEmpty = isNullOrEmpty(new AbstractMap$1(lad.knownOptions));
    _not = !_isNullOrEmpty;
    if (_not) {
        jsonArr = new JSONArray;
        $put_5(jsonObj, 'knownOptions', jsonArr);
        _function = new JsonMetaDataConverter$lambda$0$Type(jsonArr);
        $forEach_0(new AbstractMap$1(lad.knownOptions), _function);
    }
    _isNullOrEmpty_1 = isNullOrEmpty(lad.supportedFeatures);
    _not_1 = !_isNullOrEmpty_1;
    if (_not_1) {
        jsonArr_1 = new JSONArray;
        $put_5(jsonObj, 'supportedFeatures', jsonArr_1);
        _function_1 = new JsonMetaDataConverter$lambda$1$Type(jsonArr_1);
        $forEach_0(lad.supportedFeatures, _function_1);
    }
    return jsonObj;
}
function _toJson_0(lcd) {
    var _function, _isNullOrEmpty, _not, jsonArr, jsonObj;
    jsonObj = createCommon(lcd);
    _isNullOrEmpty = isNullOrEmpty(lcd.layouters);
    _not = !_isNullOrEmpty;
    if (_not) {
        jsonArr = new JSONArray;
        $put_5(jsonObj, 'knownLayouters', jsonArr);
        _function = new JsonMetaDataConverter$lambda$2$Type(jsonArr);
        $forEach_0(lcd.layouters, _function);
    }
    return jsonObj;
}
function _toJson_1(lod) {
    var _function, _group, _isNullOrEmpty, _not, _tripleNotEquals, _tripleNotEquals_1, _type, jsonArr, jsonObj;
    jsonObj = createCommon(lod);
    _group = lod.group_0;
    _tripleNotEquals = _group != null;
    _tripleNotEquals && $addJsonObj_1(jsonObj, 'group', lod.group_0);
    _type = lod.type_0;
    _tripleNotEquals_1 = !!_type;
    _tripleNotEquals_1 && $addJsonObj_1(jsonObj, 'type', $toString_3(lod.type_0));
    _isNullOrEmpty = isNullOrEmpty(lod.targets);
    _not = !_isNullOrEmpty;
    if (_not) {
        jsonArr = new JSONArray;
        $put_5(jsonObj, 'targets', jsonArr);
        _function = new JsonMetaDataConverter$lambda$3$Type(jsonArr);
        $forEach_0(lod.targets, _function);
    }
    return jsonObj;
}
function createCommon(data_0) {
    var _description, _id, _name, _tripleNotEquals, _tripleNotEquals_1, _tripleNotEquals_2, jsonObj;
    jsonObj = new JSONObject;
    _id = data_0.getId();
    _tripleNotEquals = _id != null;
    _tripleNotEquals && $addJsonObj_1(jsonObj, 'id', data_0.getId());
    _name = data_0.getName();
    _tripleNotEquals_1 = _name != null;
    _tripleNotEquals_1 && $addJsonObj_1(jsonObj, 'name', data_0.getName());
    _description = data_0.getDescription();
    _tripleNotEquals_2 = _description != null;
    _tripleNotEquals_2 && $addJsonObj_1(jsonObj, 'description', data_0.getDescription());
    return jsonObj;
}
function lambda$1_23(jsonArr_1_0, f_1) {
    $addJsonArr(jsonArr_1_0, new JSONString(f_1.name_0 != null ? f_1.name_0 : '' + f_1.ordinal));
}
function lambda$2_15(jsonArr_0, l_1) {
    var _id, _tripleNotEquals;
    _id = l_1.id_0;
    _tripleNotEquals = _id != null;
    _tripleNotEquals && $addJsonArr(jsonArr_0, new JSONString(l_1.id_0));
}
function lambda$3_12(jsonArr_0, t_1) {
    $addJsonArr(jsonArr_0, new JSONString(t_1.name_0 != null ? t_1.name_0 : '' + t_1.ordinal));
}
function toJson(lad) {
    if (instanceOf(lad, 149)) return _toJson(castTo(lad, 149));
    else if (instanceOf(lad, 232)) return _toJson_0(castTo(lad, 232));
    else if (instanceOf(lad, 21)) return _toJson_1(castTo(lad, 21));
    else throw toJs(new IllegalArgumentException_0('Unhandled parameter types: ' + $toString_2(new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Object_2_classLit, 1), $intern_2, 1, 5, [
        lad
    ])))));
}
function JsonMetaDataConverter$lambda$0$Type(jsonArr_0) {
    this.jsonArr_0 = jsonArr_0;
}
defineClass(939, 1, $intern_19, JsonMetaDataConverter$lambda$0$Type);
_.accept = function accept_158(arg0) {
    $addJsonArr(this.jsonArr_0, new JSONString(castToString(arg0)));
};
var Lorg_eclipse_elk_graph_json_JsonMetaDataConverter$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonMetaDataConverter/lambda$0$Type', 939);
function JsonMetaDataConverter$lambda$1$Type(jsonArr_1_0) {
    this.jsonArr_1_0 = jsonArr_1_0;
}
defineClass(940, 1, $intern_19, JsonMetaDataConverter$lambda$1$Type);
_.accept = function accept_159(arg0) {
    lambda$1_23(this.jsonArr_1_0, castTo(arg0, 243));
};
var Lorg_eclipse_elk_graph_json_JsonMetaDataConverter$lambda$1$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonMetaDataConverter/lambda$1$Type', 940);
function JsonMetaDataConverter$lambda$2$Type(jsonArr_0) {
    this.jsonArr_0 = jsonArr_0;
}
defineClass(941, 1, $intern_19, JsonMetaDataConverter$lambda$2$Type);
_.accept = function accept_160(arg0) {
    lambda$2_15(this.jsonArr_0, castTo(arg0, 149));
};
var Lorg_eclipse_elk_graph_json_JsonMetaDataConverter$lambda$2$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonMetaDataConverter/lambda$2$Type', 941);
function JsonMetaDataConverter$lambda$3$Type(jsonArr_0) {
    this.jsonArr_0 = jsonArr_0;
}
defineClass(942, 1, $intern_19, JsonMetaDataConverter$lambda$3$Type);
_.accept = function accept_161(arg0) {
    lambda$3_12(this.jsonArr_0, castTo(arg0, 170));
};
var Lorg_eclipse_elk_graph_json_JsonMetaDataConverter$lambda$3$Type_2_classLit = createForClass('org.eclipse.elk.graph.json', 'JsonMetaDataConverter/lambda$3$Type', 942);
function $clinit_GraphFeature() {
    $clinit_GraphFeature = emptyMethod;
    SELF_LOOPS_0 = new GraphFeature('SELF_LOOPS', 0);
    INSIDE_SELF_LOOPS = new GraphFeature('INSIDE_SELF_LOOPS', 1);
    MULTI_EDGES = new GraphFeature('MULTI_EDGES', 2);
    EDGE_LABELS = new GraphFeature('EDGE_LABELS', 3);
    PORTS_1 = new GraphFeature('PORTS', 4);
    COMPOUND = new GraphFeature('COMPOUND', 5);
    CLUSTERS = new GraphFeature('CLUSTERS', 6);
    DISCONNECTED = new GraphFeature('DISCONNECTED', 7);
}
function GraphFeature(enum$name, enum$ordinal) {
    Enum.call(this, enum$name, enum$ordinal);
}
function valueOf_114(name_0) {
    $clinit_GraphFeature();
    return valueOf(($clinit_GraphFeature$Map(), $MAP_104), name_0);
}
function values_122() {
    $clinit_GraphFeature();
    return stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_properties_GraphFeature_2_classLit, 1), $intern_36, 243, 0, [
        SELF_LOOPS_0,
        INSIDE_SELF_LOOPS,
        MULTI_EDGES,
        EDGE_LABELS,
        PORTS_1,
        COMPOUND,
        CLUSTERS,
        DISCONNECTED
    ]);
}
defineClass(243, 23, {
    3: 1,
    34: 1,
    23: 1,
    243: 1
}, GraphFeature);
var CLUSTERS, COMPOUND, DISCONNECTED, EDGE_LABELS, INSIDE_SELF_LOOPS, MULTI_EDGES, PORTS_1, SELF_LOOPS_0;
var Lorg_eclipse_elk_graph_properties_GraphFeature_2_classLit = createForEnum('org.eclipse.elk.graph.properties', 'GraphFeature', 243, Ljava_lang_Enum_2_classLit, values_122, valueOf_114);
function $clinit_GraphFeature$Map() {
    $clinit_GraphFeature$Map = emptyMethod;
    $MAP_104 = createValueOfMap(($clinit_GraphFeature(), stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_graph_properties_GraphFeature_2_classLit, 1), $intern_36, 243, 0, [
        SELF_LOOPS_0,
        INSIDE_SELF_LOOPS,
        MULTI_EDGES,
        EDGE_LABELS,
        PORTS_1,
        COMPOUND,
        CLUSTERS,
        DISCONNECTED
    ])));
}
var $MAP_104;
function $compareTo_21(this$static, other) {
    return $compareTo_9(this$static.id_0, other.getId());
}
function $equals_10(this$static, obj) {
    return instanceOf(obj, 144) && $equals_5(this$static.id_0, castTo(obj, 144).getId());
}
function $getDefault(this$static) {
    var clone;
    if (instanceOf(this$static.defaultValue, 4)) {
        clone = clone_11(this$static.defaultValue);
        if (clone == null) throw toJs(new IllegalStateException_0("Couldn't clone property '" + this$static.id_0 + "'. " + 'Make sure its type is registered with the ' + ($ensureNamesAreInitialized(Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit), Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit.simpleName) + ' utility class.'));
        return clone;
    } else return this$static.defaultValue;
}
function Property(theid) {
    this.id_0 = theid;
}
function Property_0(theid, thedefaultValue) {
    Property.call(this, theid);
    this.defaultValue = thedefaultValue;
}
function Property_1(theid, thedefaultValue) {
    Property_0.call(this, theid, thedefaultValue);
}
function Property_2(other, thedefaultValue) {
    Property_0.call(this, other.id_0, thedefaultValue);
}
defineClass(12, 1, {
    34: 1,
    144: 1
}, Property, Property_0, Property_1, Property_2);
_.compareTo_0 = function compareTo_22(other) {
    return $compareTo_21(this, castTo(other, 144));
};
_.equals_0 = function equals_206(obj) {
    return $equals_10(this, obj);
};
_.getDefault = function getDefault_0() {
    return $getDefault(this);
};
_.getId = function getId_2() {
    return this.id_0;
};
_.hashCode_1 = function hashCode_74() {
    return $hashCode_2(this.id_0);
};
_.toString_0 = function toString_132() {
    return this.id_0;
};
var Lorg_eclipse_elk_graph_properties_Property_2_classLit = createForClass('org.eclipse.elk.graph.properties', 'Property', 12);
function $compare_24(this$static, ph1, ph2) {
    var p1, p2;
    p1 = castTo(ph1.getProperty(this$static.property), 34);
    p2 = castTo(ph2.getProperty(this$static.property), 34);
    return p1 != null && p2 != null ? compareTo_Ljava_lang_Object__I__devirtual$(p1, p2) : p1 != null ? -1 : p2 != null ? 1 : 0;
}
function PropertyHolderComparator(property) {
    this.property = property;
}
defineClass(656, 1, $intern_88, PropertyHolderComparator);
_.compare_1 = function compare_109(ph1, ph2) {
    return $compare_24(this, castTo(ph1, 102), castTo(ph2, 102));
};
_.equals_0 = function equals_207(other) {
    return this === other;
};
_.reversed = function reversed_101() {
    return new Comparators$ReversedComparator(this);
};
var Lorg_eclipse_elk_graph_properties_PropertyHolderComparator_2_classLit = createForClass('org.eclipse.elk.graph.properties', 'PropertyHolderComparator', 656);
function allIncomingEdges(node) {
    var incomingEdgeIterables, port, port$iterator;
    incomingEdgeIterables = newArrayListWithCapacity(1 + (!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports).size_0);
    $add_3(incomingEdgeIterables, (!node.incomingEdges && (node.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, node, 8, 5)), node.incomingEdges));
    for(port$iterator = new AbstractEList$EIterator((!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports)); port$iterator.cursor != port$iterator.this$01_2.size_1();){
        port = castTo($doNext(port$iterator), 124);
        $add_3(incomingEdgeIterables, (!port.incomingEdges && (port.incomingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, port, 8, 5)), port.incomingEdges));
    }
    return checkNotNull(incomingEdgeIterables), new FluentIterable$2(incomingEdgeIterables);
}
function allOutgoingEdges(node) {
    var outgoingEdgeIterables, port, port$iterator;
    outgoingEdgeIterables = newArrayListWithCapacity(1 + (!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports).size_0);
    $add_3(outgoingEdgeIterables, (!node.outgoingEdges && (node.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, node, 7, 4)), node.outgoingEdges));
    for(port$iterator = new AbstractEList$EIterator((!node.ports && (node.ports = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkPort_2_classLit, node, 9, 9)), node.ports)); port$iterator.cursor != port$iterator.this$01_2.size_1();){
        port = castTo($doNext(port$iterator), 124);
        $add_3(outgoingEdgeIterables, (!port.outgoingEdges && (port.outgoingEdges = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkEdge_2_classLit, port, 7, 4)), port.outgoingEdges));
    }
    return checkNotNull(outgoingEdgeIterables), new FluentIterable$2(outgoingEdgeIterables);
}
function connectableShapeToNode(connectableShape) {
    if (instanceOf(connectableShape, 206)) return castTo(connectableShape, 27);
    else if (instanceOf(connectableShape, 193)) return $getParent_3(castTo(connectableShape, 124));
    else if (!connectableShape) throw toJs(new NullPointerException_0('connectableShape cannot be null'));
    else throw toJs(new UnsupportedOperationException_0('Only support nodes and ports.'));
}
function connectableShapeToPort(connectableShape) {
    if (instanceOf(connectableShape, 193)) return castTo(connectableShape, 124);
    else if (!connectableShape) throw toJs(new NullPointerException_0('connectableShape cannot be null'));
    else return null;
}
function createBendPoint(edgeSection, x_0, y_0) {
    var bendPoint, elkBendPoint;
    bendPoint = ($clinit_ElkGraphFactory(), elkBendPoint = new ElkBendPointImpl, elkBendPoint);
    $setX_0(bendPoint, x_0);
    $setY_1(bendPoint, y_0);
    !!edgeSection && $add_21((!edgeSection.bendPoints && (edgeSection.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, edgeSection, 5)), edgeSection.bendPoints), bendPoint);
    return bendPoint;
}
function createEdge(containingNode) {
    var edge, elkEdge;
    edge = ($clinit_ElkGraphFactory(), elkEdge = new ElkEdgeImpl, elkEdge);
    !!containingNode && $setContainingNode(edge, containingNode);
    return edge;
}
function createEdgeSection(edge) {
    var elkEdgeSection, section;
    section = ($clinit_ElkGraphFactory(), elkEdgeSection = new ElkEdgeSectionImpl, elkEdgeSection);
    !!edge && $add_21((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), section);
    return section;
}
function createLabel(text_0, parent_0) {
    var label_0, label_1, elkLabel;
    label_0 = (label_1 = ($clinit_ElkGraphFactory(), elkLabel = new ElkLabelImpl, elkLabel), !!parent_0 && $setParent_1(label_1, parent_0), label_1);
    $setText(label_0, text_0);
    return label_0;
}
function findBestEdgeContainment(edge) {
    var commonAncestor, incidentNode, incidentShapes, sourceNode, targetNode;
    requireNonNull_0(edge, 'edge cannot be null');
    switch((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources).size_0 + (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets).size_0){
        case 0:
            throw toJs(new IllegalArgumentException_0('The edge must have at least one source or target.'));
        case 1:
            return (!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources).size_0 == 0 ? $getParent_2(connectableShapeToNode(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84))) : $getParent_2(connectableShapeToNode(castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84)));
    }
    if ((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources).size_0 == 1 && (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets).size_0 == 1) {
        sourceNode = connectableShapeToNode(castTo($get_20((!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources), 0), 84));
        targetNode = connectableShapeToNode(castTo($get_20((!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets), 0), 84));
        if ($getParent_2(sourceNode) == $getParent_2(targetNode)) return $getParent_2(sourceNode);
        else if (sourceNode == $getParent_2(targetNode)) return sourceNode;
        else if (targetNode == $getParent_2(sourceNode)) return targetNode;
    }
    incidentShapes = $iterator(concatNoDefensiveCopy(stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_Iterable_2_classLit, 1), $intern_2, 20, 0, [
        (!edge.sources && (edge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 4, 7)), edge.sources),
        (!edge.targets && (edge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, edge, 5, 8)), edge.targets)
    ])));
    commonAncestor = connectableShapeToNode(castTo($next_0(incidentShapes), 84));
    while($hasNext_1(incidentShapes)){
        incidentNode = connectableShapeToNode(castTo($next_0(incidentShapes), 84));
        if (incidentNode != commonAncestor && !isDescendant_0(incidentNode, commonAncestor)) {
            if ($getParent_2(incidentNode) == $getParent_2(commonAncestor)) commonAncestor = $getParent_2(incidentNode);
            else {
                commonAncestor = findLowestCommonAncestor(commonAncestor, incidentNode);
                if (!commonAncestor) return null;
            }
        }
    }
    return commonAncestor;
}
function findLowestCommonAncestor(node1, node2) {
    var ancestor1, ancestor2, ancestors1, ancestors2, commonAncestor, iterator1, iterator2;
    ancestors1 = newArrayList_0(new ElkGraphUtil$AncestorIterator(node1));
    iterator1 = new AbstractList$ListIteratorImpl(ancestors1, ancestors1.array.length);
    ancestors2 = newArrayList_0(new ElkGraphUtil$AncestorIterator(node2));
    iterator2 = new AbstractList$ListIteratorImpl(ancestors2, ancestors2.array.length);
    commonAncestor = null;
    while(iterator1.i > 0 && iterator2.i > 0){
        ancestor1 = (checkCriticalElement(iterator1.i > 0), castTo(iterator1.this$01.get_0(iterator1.last = --iterator1.i), 27));
        ancestor2 = (checkCriticalElement(iterator2.i > 0), castTo(iterator2.this$01.get_0(iterator2.last = --iterator2.i), 27));
        if (ancestor1 == ancestor2) commonAncestor = ancestor1;
        else break;
    }
    return commonAncestor;
}
function firstEdgeSection(edge) {
    var section, sections;
    if ((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections).size_0 == 0) return createEdgeSection(edge);
    else {
        section = castTo($get_20((!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections), 0), 168);
        $clear_13((!section.bendPoints && (section.bendPoints = new EObjectContainmentEList(Lorg_eclipse_elk_graph_ElkBendPoint_2_classLit, section, 5)), section.bendPoints));
        $setStartX(section, 0);
        $setStartY(section, 0);
        $setEndX(section, 0);
        $setEndY(section, 0);
        sections = (!edge.sections && (edge.sections = new EObjectContainmentWithInverseEList(Lorg_eclipse_elk_graph_ElkEdgeSection_2_classLit, edge, 6, 6)), edge.sections);
        while(sections.size_0 > 1)$remove_35(sections, sections.size_0 - 1);
        return section;
    }
}
function getSourceNode(simpleEdge) {
    if ((!simpleEdge.sources && (simpleEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, simpleEdge, 4, 7)), simpleEdge.sources).size_0 != 1 || (!simpleEdge.targets && (simpleEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, simpleEdge, 5, 8)), simpleEdge.targets).size_0 != 1) throw toJs(new IllegalArgumentException_0("Passed edge is not 'simple'."));
    return connectableShapeToNode(castTo($get_20((!simpleEdge.sources && (simpleEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, simpleEdge, 4, 7)), simpleEdge.sources), 0), 84));
}
function getTargetNode_0(simpleEdge) {
    if ((!simpleEdge.sources && (simpleEdge.sources = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, simpleEdge, 4, 7)), simpleEdge.sources).size_0 != 1 || (!simpleEdge.targets && (simpleEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, simpleEdge, 5, 8)), simpleEdge.targets).size_0 != 1) throw toJs(new IllegalArgumentException_0("Passed edge is not 'simple'."));
    return connectableShapeToNode(castTo($get_20((!simpleEdge.targets && (simpleEdge.targets = new EObjectWithInverseResolvingEList$ManyInverse(Lorg_eclipse_elk_graph_ElkConnectableShape_2_classLit, simpleEdge, 5, 8)), simpleEdge.targets), 0), 84));
}
function isDescendant_0(child, ancestor) {
    var current;
    current = child;
    while($getParent_2(current)){
        current = $getParent_2(current);
        if (current == ancestor) return true;
    }
    return false;
}
function updateContainment(edge) {
    requireNonNull_0(edge, 'edge cannot be null');
    $setContainingNode(edge, findBestEdgeContainment(edge));
}
function $next_12(this$static) {
    var next;
    if (!this$static.nextNode) throw toJs(new NoSuchElementException_0);
    next = this$static.nextNode;
    this$static.nextNode = $getParent_2(this$static.nextNode);
    return next;
}
function ElkGraphUtil$AncestorIterator(startNode) {
    this.nextNode = startNode;
}
defineClass(693, 1, $intern_6, ElkGraphUtil$AncestorIterator);
_.forEachRemaining = function forEachRemaining_52(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_42() {
    return $next_12(this);
};
_.remove = function remove_98() {
    $remove_21();
};
_.hasNext_0 = function hasNext_41() {
    return !!this.nextNode;
};
var Lorg_eclipse_elk_graph_util_ElkGraphUtil$AncestorIterator_2_classLit = createForClass('org.eclipse.elk.graph.util', 'ElkGraphUtil/AncestorIterator', 693);
var Lorg_eclipse_emf_common_util_EList_2_classLit = createForInterface('org.eclipse.emf.common.util', 'EList');
function $add_20(this$static, index_0, object) {
    var size_0;
    size_0 = this$static.size_1();
    if (index_0 > size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    if (this$static.isUnique() && this$static.contains(object)) throw toJs(new IllegalArgumentException_0("The 'no duplicates' constraint is violated"));
    this$static.addUnique(index_0, object);
}
function $add_21(this$static, object) {
    if (this$static.isUnique() && this$static.contains(object)) return false;
    else {
        this$static.addUnique_0(object);
        return true;
    }
}
function $addAll_8(this$static, index_0, collection) {
    var size_0;
    size_0 = this$static.size_1();
    if (index_0 > size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    this$static.isUnique() && (collection = $getNonDuplicates(this$static, collection));
    return this$static.addAllUnique(index_0, collection);
}
function $addAll_9(this$static, collection) {
    this$static.isUnique() && (collection = $getNonDuplicates(this$static, collection));
    return this$static.addAllUnique_0(collection);
}
function $basicListIterator(this$static, index_0) {
    var size_0;
    size_0 = this$static.size_1();
    if (index_0 < 0 || index_0 > size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    return new AbstractEList$NonResolvingEListIterator_0(this$static, index_0);
}
function $didClear(this$static, size_0, oldObjects) {
    var i, object;
    if (oldObjects != null) for(i = 0; i < size_0; ++i){
        object = oldObjects[i];
        this$static.didRemove(i, object);
    }
}
function $equals_11(this$static, object) {
    var i, list, o1, o2, objects, size_0;
    if (maskUndefined(object) === maskUndefined(this$static)) return true;
    if (!instanceOf(object, 15)) return false;
    list = castTo(object, 15);
    size_0 = this$static.size_1();
    if (list.size_1() != size_0) return false;
    objects = list.iterator_0();
    if (this$static.useEquals()) for(i = 0; i < size_0; ++i){
        o1 = this$static.primitiveGet(i);
        o2 = objects.next_1();
        if (o1 == null ? o2 != null : !equals_Ljava_lang_Object__Z__devirtual$(o1, o2)) return false;
    }
    else for(i = 0; i < size_0; ++i){
        o1 = this$static.primitiveGet(i);
        o2 = objects.next_1();
        if (maskUndefined(o1) !== maskUndefined(o2)) return false;
    }
    return true;
}
function $getDuplicates(this$static, collection) {
    var filteredResult, object, object$iterator;
    if (collection.isEmpty()) return $clinit_ECollections(), $clinit_ECollections(), EMPTY_ELIST;
    else {
        filteredResult = new AbstractEList$1(this$static, collection.size_1());
        for(object$iterator = new AbstractEList$EIterator(this$static); object$iterator.cursor != object$iterator.this$01_2.size_1();){
            object = $doNext(object$iterator);
            collection.contains(object) && $add_21(filteredResult, object);
        }
        return filteredResult;
    }
}
function $getNonDuplicates(this$static, collection) {
    var result;
    result = new LinkedHashSet_1(collection);
    $removeAll_1(result, this$static);
    return new ArrayList_1(result);
}
function $hashCode_4(this$static) {
    var hashCode, i, object, size_0;
    hashCode = 1;
    for(i = 0, size_0 = this$static.size_1(); i < size_0; ++i){
        object = this$static.primitiveGet(i);
        hashCode = 31 * hashCode + (object == null ? 0 : hashCode__I__devirtual$(object));
    }
    return hashCode;
}
function $remove_32(this$static, object) {
    var index_0;
    index_0 = this$static.indexOf_0(object);
    if (index_0 >= 0) {
        this$static.remove_2(index_0);
        return true;
    } else return false;
}
function $set_9(this$static, index_0, object) {
    var currentIndex, size_0;
    size_0 = this$static.size_1();
    if (index_0 >= size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    if (this$static.isUnique()) {
        currentIndex = this$static.indexOf_0(object);
        if (currentIndex >= 0 && currentIndex != index_0) throw toJs(new IllegalArgumentException_0("The 'no duplicates' constraint is violated"));
    }
    return this$static.setUnique(index_0, object);
}
function $toString_25(this$static) {
    var i, size_0, stringBuffer;
    stringBuffer = new StringBuffer;
    stringBuffer.string += '[';
    for(i = 0, size_0 = this$static.size_1(); i < size_0;){
        $append_3(stringBuffer, valueOf_6(this$static.primitiveGet(i)));
        ++i < size_0 && (stringBuffer.string += ', ', stringBuffer);
    }
    stringBuffer.string += ']';
    return stringBuffer.string;
}
function $validate(this$static, object) {
    if (!this$static.canContainNull() && object == null) throw toJs(new IllegalArgumentException_0("The 'no null' constraint is violated"));
    return object;
}
defineClass(70, 55, {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1
});
_.add_3 = function add_46(index_0, object) {
    $add_20(this, index_0, object);
};
_.add_2 = function add_47(object) {
    return $add_21(this, object);
};
_.addAll_0 = function addAll_23(index_0, collection) {
    return $addAll_8(this, index_0, collection);
};
_.addAll = function addAll_24(collection) {
    return $addAll_9(this, collection);
};
_.basicIterator = function basicIterator() {
    return new AbstractEList$NonResolvingEIterator(this);
};
_.basicListIterator = function basicListIterator() {
    return new AbstractEList$NonResolvingEListIterator(this);
};
_.basicListIterator_0 = function basicListIterator_0(index_0) {
    return $basicListIterator(this, index_0);
};
_.canContainNull = function canContainNull() {
    return true;
};
_.didAdd = function didAdd(index_0, newObject) {};
_.didChange = function didChange() {};
_.didClear = function didClear(size_0, oldObjects) {
    $didClear(this, size_0, oldObjects);
};
_.didMove = function didMove(index_0, movedObject, oldIndex) {};
_.didRemove = function didRemove(index_0, oldObject) {};
_.didSet = function didSet(index_0, newObject, oldObject) {};
_.equals_0 = function equals_208(object) {
    return $equals_11(this, object);
};
_.hashCode_1 = function hashCode_75() {
    return $hashCode_4(this);
};
_.isUnique = function isUnique_0() {
    return false;
};
_.iterator_0 = function iterator_79() {
    return new AbstractEList$EIterator(this);
};
_.listIterator_0 = function listIterator_17() {
    return new AbstractEList$EListIterator(this);
};
_.listIterator_1 = function listIterator_18(index_0) {
    var size_0;
    size_0 = this.size_1();
    if (index_0 < 0 || index_0 > size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    return new AbstractEList$EListIterator_0(this, index_0);
};
_.move_0 = function move_0(index_0, object) {
    this.move(index_0, this.indexOf_0(object));
};
_.remove_1 = function remove_99(object) {
    return $remove_32(this, object);
};
_.resolve = function resolve_0(index_0, object) {
    return object;
};
_.set_2 = function set_21(index_0, object) {
    return $set_9(this, index_0, object);
};
_.toString_0 = function toString_133() {
    return $toString_25(this);
};
_.useEquals = function useEquals() {
    return true;
};
_.validate = function validate(index_0, object) {
    return $validate(this, object);
};
var Lorg_eclipse_emf_common_util_AbstractEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList', 70);
function $addAllUnique(this$static, index_0, collection) {
    var growth, i, object, objects, shifted;
    growth = collection.size_1();
    this$static.grow(this$static.size_0 + growth);
    shifted = this$static.size_0 - index_0;
    shifted > 0 && arraycopy(this$static.data_0, index_0, this$static.data_0, index_0 + growth, shifted);
    objects = collection.iterator_0();
    this$static.size_0 += growth;
    for(i = 0; i < growth; ++i){
        object = objects.next_1();
        $assign(this$static, index_0, this$static.validate(index_0, object));
        this$static.didAdd(index_0, object);
        this$static.didChange();
        ++index_0;
    }
    return growth != 0;
}
function $addAllUnique_0(this$static, collection) {
    var growth, i, object, objects, oldSize;
    growth = collection.size_1();
    this$static.grow(this$static.size_0 + growth);
    objects = collection.iterator_0();
    oldSize = this$static.size_0;
    this$static.size_0 += growth;
    for(i = oldSize; i < this$static.size_0; ++i){
        object = objects.next_1();
        $assign(this$static, i, this$static.validate(i, object));
        this$static.didAdd(i, object);
        this$static.didChange();
    }
    return growth != 0;
}
function $addUnique(this$static, index_0, object) {
    var validatedObject;
    this$static.grow(this$static.size_0 + 1);
    validatedObject = this$static.validate(index_0, object);
    index_0 != this$static.size_0 && arraycopy(this$static.data_0, index_0, this$static.data_0, index_0 + 1, this$static.size_0 - index_0);
    setCheck(this$static.data_0, index_0, validatedObject);
    ++this$static.size_0;
    this$static.didAdd(index_0, object);
    this$static.didChange();
}
function $addUnique_0(this$static, object) {
    this$static.grow(this$static.size_0 + 1);
    $assign(this$static, this$static.size_0, this$static.validate(this$static.size_0, object));
    this$static.didAdd(this$static.size_0++, object);
    this$static.didChange();
}
function $assign(this$static, index_0, object) {
    setCheck(this$static.data_0, index_0, object);
    return object;
}
function $basicGet(this$static, index_0) {
    if (this$static.data_0 == null || index_0 >= this$static.size_0) throw toJs(new BasicEList$BasicIndexOutOfBoundsException(index_0, this$static.size_0));
    return this$static.data_0[index_0];
}
function $clear_11(this$static) {
    var oldData, oldSize;
    ++this$static.modCount;
    oldData = this$static.data_0;
    oldSize = this$static.size_0;
    this$static.data_0 = null;
    this$static.size_0 = 0;
    this$static.didClear(oldSize, oldData);
    this$static.didChange();
}
function $contains_10(this$static, object) {
    var i;
    if (this$static.useEquals() && object != null) for(i = 0; i < this$static.size_0; ++i){
        if (equals_Ljava_lang_Object__Z__devirtual$(object, this$static.data_0[i])) return true;
    }
    else for(i = 0; i < this$static.size_0; ++i){
        if (maskUndefined(this$static.data_0[i]) === maskUndefined(object)) return true;
    }
    return false;
}
function $get_20(this$static, index_0) {
    if (this$static.data_0 == null || index_0 >= this$static.size_0) throw toJs(new BasicEList$BasicIndexOutOfBoundsException(index_0, this$static.size_0));
    return this$static.resolve(index_0, this$static.data_0[index_0]);
}
function $indexOf_4(this$static, object) {
    var i;
    if (this$static.useEquals() && object != null) for(i = 0; i < this$static.size_0; ++i){
        if (equals_Ljava_lang_Object__Z__devirtual$(object, this$static.data_0[i])) return i;
    }
    else for(i = 0; i < this$static.size_0; ++i){
        if (maskUndefined(this$static.data_0[i]) === maskUndefined(object)) return i;
    }
    return -1;
}
function $move(this$static, targetIndex, sourceIndex) {
    var object;
    ++this$static.modCount;
    if (targetIndex >= this$static.size_0) throw toJs(new IndexOutOfBoundsException_0('targetIndex=' + targetIndex + ', size=' + this$static.size_0));
    if (sourceIndex >= this$static.size_0) throw toJs(new IndexOutOfBoundsException_0('sourceIndex=' + sourceIndex + ', size=' + this$static.size_0));
    object = this$static.data_0[sourceIndex];
    if (targetIndex != sourceIndex) {
        targetIndex < sourceIndex ? arraycopy(this$static.data_0, targetIndex, this$static.data_0, targetIndex + 1, sourceIndex - targetIndex) : arraycopy(this$static.data_0, sourceIndex + 1, this$static.data_0, sourceIndex, targetIndex - sourceIndex);
        setCheck(this$static.data_0, targetIndex, object);
        this$static.didMove(targetIndex, object, sourceIndex);
        this$static.didChange();
    }
    return object;
}
function $remove_33(this$static, index_0) {
    var oldObject, shifted;
    if (index_0 >= this$static.size_0) throw toJs(new BasicEList$BasicIndexOutOfBoundsException(index_0, this$static.size_0));
    ++this$static.modCount;
    oldObject = this$static.data_0[index_0];
    shifted = this$static.size_0 - index_0 - 1;
    shifted > 0 && arraycopy(this$static.data_0, index_0 + 1, this$static.data_0, index_0, shifted);
    setCheck(this$static.data_0, --this$static.size_0, null);
    this$static.didRemove(index_0, oldObject);
    this$static.didChange();
    return oldObject;
}
function $setUnique(this$static, index_0, object) {
    var oldObject;
    oldObject = this$static.data_0[index_0];
    $assign(this$static, index_0, this$static.validate(index_0, object));
    this$static.didSet(index_0, object, oldObject);
    this$static.didChange();
    return oldObject;
}
function $shrink_0(this$static) {
    var oldData;
    ++this$static.modCount;
    if (this$static.size_0 == 0) this$static.data_0 = null;
    else if (this$static.size_0 < this$static.data_0.length) {
        oldData = this$static.data_0;
        this$static.data_0 = this$static.newData(this$static.size_0);
        arraycopy(oldData, 0, this$static.data_0, 0, this$static.size_0);
    }
}
function $toArray_8(this$static) {
    var result;
    result = this$static.newData(this$static.size_0);
    this$static.size_0 > 0 && arraycopy(this$static.data_0, 0, result, 0, this$static.size_0);
    return result;
}
function $toArray_9(this$static, array) {
    var newArray;
    if (this$static.size_0 > 0) {
        if (array.length < this$static.size_0) {
            newArray = newInstance_11(getClass__Ljava_lang_Class___devirtual$(array).componentType, this$static.size_0);
            array = newArray;
        }
        arraycopy(this$static.data_0, 0, array, 0, this$static.size_0);
    }
    array.length > this$static.size_0 && setCheck(array, this$static.size_0, null);
    return array;
}
function BasicEList() {}
function BasicEList_0(initialCapacity) {
    if (initialCapacity < 0) throw toJs(new IllegalArgumentException_0('Illegal Capacity: ' + initialCapacity));
    this.data_0 = this.newData(initialCapacity);
}
function BasicEList_1(collection) {
    this.size_0 = collection.size_1();
    if (this.size_0 > 0) {
        this.data_0 = this.newData(this.size_0 + (this.size_0 / 8 | 0) + 1);
        collection.toArray_0(this.data_0);
    }
}
defineClass(66, 70, $intern_140, BasicEList, BasicEList_0, BasicEList_1);
_.addAllUnique = function addAllUnique(index_0, collection) {
    return $addAllUnique(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_0(collection) {
    return $addAllUnique_0(this, collection);
};
_.addUnique = function addUnique(index_0, object) {
    $addUnique(this, index_0, object);
};
_.addUnique_0 = function addUnique_0(object) {
    $addUnique_0(this, object);
};
_.basicGet = function basicGet(index_0) {
    return $basicGet(this, index_0);
};
_.clear_0 = function clear_52() {
    $clear_11(this);
};
_.contains = function contains_51(object) {
    return $contains_10(this, object);
};
_.get_0 = function get_49(index_0) {
    return $get_20(this, index_0);
};
_.grow = function grow(minimumCapacity) {
    var newCapacity, oldCapacity, oldData;
    ++this.modCount;
    oldCapacity = this.data_0 == null ? 0 : this.data_0.length;
    if (minimumCapacity > oldCapacity) {
        oldData = this.data_0;
        newCapacity = oldCapacity + (oldCapacity / 2 | 0) + 4;
        newCapacity < minimumCapacity && (newCapacity = minimumCapacity);
        this.data_0 = this.newData(newCapacity);
        oldData != null && arraycopy(oldData, 0, this.data_0, 0, this.size_0);
    }
};
_.indexOf_0 = function indexOf_8(object) {
    return $indexOf_4(this, object);
};
_.isEmpty = function isEmpty_26() {
    return this.size_0 == 0;
};
_.move = function move_1(targetIndex, sourceIndex) {
    return $move(this, targetIndex, sourceIndex);
};
_.newData = function newData_0(capacity) {
    return initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, capacity, 5, 1);
};
_.primitiveGet = function primitiveGet(index_0) {
    return this.data_0[index_0];
};
_.remove_2 = function remove_100(index_0) {
    return $remove_33(this, index_0);
};
_.setUnique = function setUnique(index_0, object) {
    return $setUnique(this, index_0, object);
};
_.size_1 = function size_66() {
    return this.size_0;
};
_.toArray = function toArray_26() {
    return $toArray_8(this);
};
_.toArray_0 = function toArray_27(array) {
    return $toArray_9(this, array);
};
_.size_0 = 0;
var Lorg_eclipse_emf_common_util_BasicEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEList', 66);
var Lorg_eclipse_emf_common_util_TreeIterator_2_classLit = createForInterface('org.eclipse.emf.common.util', 'TreeIterator');
function $hasAnyChildren(this$static) {
    var nextPruneIterator;
    nextPruneIterator = this$static.nextPruneIterator;
    nextPruneIterator = this$static.getChildren(this$static.object);
    $add_21(this$static, nextPruneIterator);
    return nextPruneIterator.hasNext_0();
}
function $next_13(this$static) {
    var currentIterator, iterator, nextIterator, result, result0;
    if (this$static.data_0 == null) {
        this$static.nextPruneIterator = this$static.getChildren(this$static.object);
        $add_21(this$static, this$static.nextPruneIterator);
        if (this$static.includeRoot) {
            result0 = this$static.object;
            return result0;
        }
    }
    currentIterator = castTo(this$static.data_0[this$static.size_0 - 1], 49);
    result = currentIterator.next_1();
    this$static.nextRemoveIterator = currentIterator;
    iterator = this$static.getChildren(result);
    if (iterator.hasNext_0()) {
        this$static.nextPruneIterator = iterator;
        $add_21(this$static, iterator);
    } else {
        this$static.nextPruneIterator = null;
        while(!currentIterator.hasNext_0()){
            setCheck(this$static.data_0, --this$static.size_0, null);
            if (this$static.size_0 == 0) break;
            nextIterator = castTo(this$static.data_0[this$static.size_0 - 1], 49);
            currentIterator = nextIterator;
        }
    }
    return result;
}
function AbstractTreeIterator(object, includeRoot) {
    this.object = object;
    this.includeRoot = includeRoot;
}
defineClass(692, 66, $intern_141);
_.forEachRemaining = function forEachRemaining_53(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_42() {
    return this.data_0 == null && !this.includeRoot ? $hasAnyChildren(this) : this.data_0 == null || this.size_0 != 0 && castTo(this.data_0[this.size_0 - 1], 49).hasNext_0();
};
_.next_1 = function next_43() {
    return $next_13(this);
};
_.remove = function remove_101() {
    if (!this.nextRemoveIterator) throw toJs(new IllegalStateException_0('There is no valid object to remove.'));
    this.nextRemoveIterator.remove();
};
_.includeRoot = false;
var Lorg_eclipse_emf_common_util_AbstractTreeIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractTreeIterator', 692);
function ElkGraphUtil$PropertiesSkippingTreeIterator(object) {
    AbstractTreeIterator.call(this, object, true);
}
defineClass(599, 692, $intern_141, ElkGraphUtil$PropertiesSkippingTreeIterator);
_.getChildren = function getChildren(object) {
    var iterator;
    iterator = castTo(object, 57).eContents_0().iterator_0();
    instanceOf(iterator, 284) && castTo(iterator, 284).filter_0(new ElkGraphUtil$PropertiesSkippingTreeIterator$1);
    return iterator;
};
var Lorg_eclipse_elk_graph_util_ElkGraphUtil$PropertiesSkippingTreeIterator_2_classLit = createForClass('org.eclipse.elk.graph.util', 'ElkGraphUtil/PropertiesSkippingTreeIterator', 599);
function ElkGraphUtil$PropertiesSkippingTreeIterator$1() {}
defineClass(943, 1, {}, ElkGraphUtil$PropertiesSkippingTreeIterator$1);
var Lorg_eclipse_elk_graph_util_ElkGraphUtil$PropertiesSkippingTreeIterator$1_2_classLit = createForClass('org.eclipse.elk.graph.util', 'ElkGraphUtil/PropertiesSkippingTreeIterator/1', 943);
function $clinit_ElkReflect() {
    $clinit_ElkReflect = emptyMethod;
    REGISTRY_NEW = new HashMap;
    REGISTRY_CLONE = new HashMap;
    registerClone(Ljava_util_EnumSet_2_classLit, new ElkReflect$lambda$0$Type);
}
function clone_11(clonee) {
    $clinit_ElkReflect();
    if (instanceOf(clonee, 161)) return castTo($get_10(REGISTRY_CLONE, Ljava_util_EnumSet_2_classLit), 293).clone(clonee);
    if ($containsKey_3(REGISTRY_CLONE, getClass__Ljava_lang_Class___devirtual$(clonee))) return castTo($get_10(REGISTRY_CLONE, getClass__Ljava_lang_Class___devirtual$(clonee)), 293).clone(clonee);
    return null;
}
function newInstance_10(clazz) {
    $clinit_ElkReflect();
    return $containsKey_3(REGISTRY_NEW, clazz) ? castTo($get_10(REGISTRY_NEW, clazz), 337).newInstance() : null;
}
function register(clazz, newFun, cloneFun) {
    $clinit_ElkReflect();
    !!clazz && $put_6(REGISTRY_NEW, clazz, newFun);
    !!clazz && $put_6(REGISTRY_CLONE, clazz, cloneFun);
}
function registerClone(clazz, cloneFun) {
    !!clazz && $put_6(REGISTRY_CLONE, clazz, cloneFun);
}
var REGISTRY_CLONE, REGISTRY_NEW;
var Lorg_eclipse_elk_graph_util_ElkReflect_2_classLit = createForClass('org.eclipse.elk.graph.util', 'ElkReflect', null);
function ElkReflect$lambda$0$Type() {}
defineClass(877, 1, $intern_132, ElkReflect$lambda$0$Type);
_.clone = function clone_12(o) {
    return $clinit_ElkReflect(), $clone(castTo(o, 181));
};
var Lorg_eclipse_elk_graph_util_ElkReflect$lambda$0$Type_2_classLit = createForClass('org.eclipse.elk.graph.util', 'ElkReflect/lambda$0$Type', 877);
function $clinit_ElkJs() {
    $clinit_ElkJs = emptyMethod;
    SERVICE = getInstance();
}
function collectLogs(currentPM, logObject, recordLogs, recordExecutionTime) {
    var child, child$iterator, children, i, jsonChild, jsonExecTime, jsonLogs, jsonString, jsonTaskName, s, s$iterator;
    jsonTaskName = new JSONString(currentPM.getTaskName());
    $put_5(logObject, 'name', jsonTaskName);
    if (recordLogs && !currentPM.getLogs().list.isEmpty()) {
        jsonLogs = new JSONArray;
        $put_5(logObject, 'logs', jsonLogs);
        i = 0;
        for(s$iterator = new Collections$UnmodifiableCollectionIterator(currentPM.getLogs().coll.iterator_0()); s$iterator.it.hasNext_0();){
            s = castToString(s$iterator.it.next_1());
            jsonString = new JSONString(s);
            $get_8(jsonLogs, i);
            $set0(jsonLogs, i, jsonString);
            ++i;
        }
    }
    if (recordExecutionTime) {
        jsonExecTime = new JSONNumber(currentPM.getExecutionTime());
        $put_5(logObject, 'executionTime', jsonExecTime);
    }
    if (!currentPM.getSubMonitors().list.isEmpty()) {
        children = new JSONArray;
        $put_5(logObject, 'children', children);
        i = 0;
        for(child$iterator = new Collections$UnmodifiableCollectionIterator(currentPM.getSubMonitors().coll.iterator_0()); child$iterator.it.hasNext_0();){
            child = castTo(child$iterator.it.next_1(), 847);
            jsonChild = new JSONObject;
            $get_8(children, i);
            $set0(children, i, jsonChild);
            collectLogs(child, jsonChild, recordLogs, recordExecutionTime);
            ++i;
        }
    }
}
function exportLayout() {
    $clinit_ElkJs();
    function Dispatcher(worker) {
        var _this = this;
        this.dispatch = function(event_0) {
            var data_0 = event_0.data;
            switch(data_0.cmd){
                case 'algorithms':
                    var algs = getLayoutData(($clinit_Collections(), new Collections$UnmodifiableCollection(new AbstractMap$2(SERVICE.layoutAlgorithmMap))));
                    worker.postMessage({
                        id: data_0.id,
                        data: algs
                    });
                    break;
                case 'categories':
                    var cats = getLayoutData(($clinit_Collections(), new Collections$UnmodifiableCollection(new AbstractMap$2(SERVICE.layoutCategoryMap))));
                    worker.postMessage({
                        id: data_0.id,
                        data: cats
                    });
                    break;
                case 'options':
                    var opts = getLayoutData(($clinit_Collections(), new Collections$UnmodifiableCollection(new AbstractMap$2(SERVICE.layoutOptionMap))));
                    worker.postMessage({
                        id: data_0.id,
                        data: opts
                    });
                    break;
                case 'register':
                    registerLayoutAlgorithms(data_0.algorithms);
                    worker.postMessage({
                        id: data_0.id
                    });
                    break;
                case 'layout':
                    layout_10(data_0.graph, data_0.layoutOptions || {}, data_0.options || {});
                    worker.postMessage({
                        id: data_0.id,
                        data: data_0.graph
                    });
                    break;
            }
        };
        this.saveDispatch = function(event_0) {
            try {
                _this.dispatch(event_0);
            } catch (err) {
                worker.postMessage({
                    id: event_0.data.id,
                    error: err
                });
            }
        };
    }
    function FakeWorker(url_0) {
        var _this = this;
        this.dispatcher = new Dispatcher({
            postMessage: function(msg) {
                _this.onmessage({
                    data: msg
                });
            }
        });
        this.postMessage = function(msg) {
            setTimeout(function() {
                _this.dispatcher.saveDispatch({
                    data: msg
                });
            }, 0);
        };
    }
    if (typeof document === 'undefined' && typeof self !== 'undefined') {
        var dispatcher = new Dispatcher(self);
        self.onmessage = dispatcher.saveDispatch;
    } else if (0, module.exports) {
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        module.exports = {
            'default': FakeWorker,
            Worker: FakeWorker
        };
    }
}
function getLayoutData(data_0) {
    var arr, json, ld, ld$iterator;
    arr = new JSONArray;
    for(ld$iterator = new Collections$UnmodifiableCollectionIterator(data_0.coll.iterator_0()); ld$iterator.it.hasNext_0();){
        ld = castTo(ld$iterator.it.next_1(), 685);
        json = toJson(ld);
        $set_0(arr, arr.jsArray.length, json);
    }
    return arr.jsArray;
}
function layout_10(graphObj, layoutOptionsObj, optionsObj) {
    var elkGraph, graph, importer, lc, logs, options, pm, recordExecutionTime, recordLogs, root, _function, _function_1;
    graph = new JSONObject_0(graphObj);
    importer = new JsonImporter;
    elkGraph = ($clear_2(importer.nodeIdMap), $clear_2(importer.portIdMap), $reset(importer.edgeIdMap), $clear_2(importer.edgeSectionIdMap), $clear_2(importer.nodeJsonMap), $reset(importer.portJsonMap), $reset(importer.edgeJsonMap), $reset(importer.edgeSectionJsonMap), $reset(importer.labelJsonMap), $reset(importer.edgeOriginalParentMap), $reset(importer.globalXMap), $reset(importer.globalYMap), $reset(importer.shapeCoordsMap), $reset(importer.edgeCoordsMap), root = $transformNode_0(importer, graph, null), $transformEdges_2(importer, graph), root);
    if (layoutOptionsObj) {
        options = new JSONObject_0(layoutOptionsObj);
        lc = optsToCfg(options);
        applyVisitors(elkGraph, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_util_IGraphElementVisitor_2_classLit, 1), $intern_2, 521, 0, [
            lc
        ]));
    }
    recordLogs = false;
    recordExecutionTime = false;
    if (optionsObj) {
        options = new JSONObject_0(optionsObj);
        'logging' in options.jsObject && (recordLogs = $get_9(options, 'logging').isBoolean().value_0);
        'measureExecutionTime' in options.jsObject && (recordExecutionTime = $get_9(options, 'measureExecutionTime').isBoolean().value_0);
    }
    pm = $withExecutionTimeMeasurement($withLogging(new BasicProgressMonitor, recordLogs), recordExecutionTime);
    $layout_3(new RecursiveGraphLayoutEngine, elkGraph, pm);
    'logging' in graph.jsObject && $put_5(graph, 'logging', null);
    if (recordLogs || recordExecutionTime) {
        logs = new JSONObject;
        collectLogs(pm, logs, recordLogs, recordExecutionTime);
        $put_5(graph, 'logging', logs);
    }
    _function = new JsonImporter$lambda$35$Type(importer);
    forEach_43(new ElkGraphUtil$PropertiesSkippingTreeIterator(elkGraph), _function);
    _function_1 = new JsonImporter$lambda$36$Type(importer);
    forEach_43(new ElkGraphUtil$PropertiesSkippingTreeIterator(elkGraph), _function_1);
}
function optsToCfg(opts) {
    var jsonVal, key, key$iterator, keys_0, lc, option, serialized, value_0;
    lc = new LayoutConfigurator;
    $addFilter(lc, ($clinit_LayoutConfigurator(), NO_OVERWRITE));
    for(key$iterator = (keys_0 = $computeKeys0(opts, initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 0, 6, 1)), new AbstractList$IteratorImpl(new Arrays$ArrayList(new JSONObject$1(opts, keys_0).val$keys2))); key$iterator.i < key$iterator.this$01_0.size_1();){
        key = (checkCriticalElement(key$iterator.i < key$iterator.this$01_0.size_1()), castToString(key$iterator.this$01_0.get_0(key$iterator.last = key$iterator.i++)));
        option = $getOptionDataBySuffix(SERVICE, key);
        if (option) {
            jsonVal = $get_9(opts, key);
            jsonVal.isString() ? serialized = jsonVal.isString().value_0 : jsonVal.isBoolean() ? serialized = '' + jsonVal.isBoolean().value_0 : jsonVal.isNumber() ? serialized = '' + jsonVal.isNumber().value_0 : serialized = jsonVal.toString_0();
            value_0 = $parseValue(option, serialized);
            if (value_0 != null) {
                ($containsEnum(option.targets, ($clinit_LayoutOptionData$Target(), NODES)) || $containsEnum(option.targets, PARENTS)) && $setProperty($configure(lc, Lorg_eclipse_elk_graph_ElkNode_2_classLit), option, value_0);
                $containsEnum(option.targets, EDGES) && $setProperty($configure(lc, Lorg_eclipse_elk_graph_ElkEdge_2_classLit), option, value_0);
                $containsEnum(option.targets, PORTS) && $setProperty($configure(lc, Lorg_eclipse_elk_graph_ElkPort_2_classLit), option, value_0);
                $containsEnum(option.targets, LABELS) && $setProperty($configure(lc, Lorg_eclipse_elk_graph_ElkLabel_2_classLit), option, value_0);
            }
        }
    }
    return lc;
}
function registerLayoutAlgorithms(arrayObj) {
    var alg, arr, i;
    $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
        new CoreOptions
    ]));
    arr = new JSONArray_0(arrayObj);
    for(i = 0; i < arr.jsArray.length; ++i){
        alg = $get_8(arr, i).isString().value_0;
        $equals_5(alg, 'layered') ? $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new LayeredMetaDataProvider
        ])) : $equals_5(alg, 'force') ? $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new ForceMetaDataProvider
        ])) : $equals_5(alg, 'stress') ? $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new StressMetaDataProvider
        ])) : $equals_5(alg, 'mrtree') ? $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new MrTreeMetaDataProvider
        ])) : $equals_5(alg, 'radial') ? $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new RadialMetaDataProvider
        ])) : $equals_5(alg, 'sporeOverlap') || $equals_5(alg, 'sporeCompaction') ? $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new SporeMetaDataProvider
        ])) : $equals_5(alg, 'rectpacking') && $registerLayoutMetaDataProviders(SERVICE, stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_elk_core_data_ILayoutMetaDataProvider_2_classLit, 1), $intern_2, 146, 0, [
            new RectPackingMetaDataProvider
        ]));
    }
}
var SERVICE;
var Lorg_eclipse_emf_common_util_ResourceLocator_2_classLit = createForInterface('org.eclipse.emf.common.util', 'ResourceLocator');
function $getString(key) {
    return $equals_5('_UI_EMFDiagnostic_marker', key) ? 'EMF Problem' : $equals_5('_UI_CircularContainment_diagnostic', key) ? 'An object may not circularly contain itself' : $equals_5('parser.parse.1', key) ? 'Wrong character.' : $equals_5('parser.parse.2', key) ? 'Invalid reference number.' : $equals_5('parser.next.1', key) ? 'A character is required after \\.' : $equals_5('parser.next.2', key) ? "'?' is not expected.  '(?:' or '(?=' or '(?!' or '(?<' or '(?#' or '(?>'?" : $equals_5('parser.next.3', key) ? "'(?<' or '(?<!' is expected." : $equals_5('parser.next.4', key) ? 'A comment is not terminated.' : $equals_5('parser.factor.1', key) ? "')' is expected." : $equals_5('parser.factor.2', key) ? 'Unexpected end of the pattern in a modifier group.' : $equals_5('parser.factor.3', key) ? "':' is expected." : $equals_5('parser.factor.4', key) ? 'Unexpected end of the pattern in a conditional group.' : $equals_5('parser.factor.5', key) ? 'A back reference or an anchor or a lookahead or a look-behind is expected in a conditional pattern.' : $equals_5('parser.factor.6', key) ? 'There are more than three choices in a conditional group.' : $equals_5('parser.atom.1', key) ? 'A character in U+0040-U+005f must follow \\c.' : $equals_5('parser.atom.2', key) ? "A '{' is required before a character category." : $equals_5('parser.atom.3', key) ? "A property name is not closed by '}'." : $equals_5('parser.atom.4', key) ? 'Unexpected meta character.' : $equals_5('parser.atom.5', key) ? 'Unknown property.' : $equals_5('parser.cc.1', key) ? "A POSIX character class must be closed by ':]'." : $equals_5('parser.cc.2', key) ? 'Unexpected end of the pattern in a character class.' : $equals_5('parser.cc.3', key) ? 'Unknown name for a POSIX character class.' : $equals_5('parser.cc.4', key) ? "'-' is invalid here." : $equals_5('parser.cc.5', key) ? "']' is expected." : $equals_5('parser.cc.6', key) ? "'[' is invalid in a character class.  Write '\\['." : $equals_5('parser.cc.7', key) ? "']' is invalid in a character class.  Write '\\]'." : $equals_5('parser.cc.8', key) ? "'-' is an invalid character range. Write '\\-'." : $equals_5('parser.ope.1', key) ? "'[' is expected." : $equals_5('parser.ope.2', key) ? "')' or '-[' or '+[' or '&[' is expected." : $equals_5('parser.ope.3', key) ? 'The range end code point is less than the start code point.' : $equals_5('parser.descape.1', key) ? 'Invalid Unicode hex notation.' : $equals_5('parser.descape.2', key) ? 'Overflow in a hex notation.' : $equals_5('parser.descape.3', key) ? "'\\x{' must be closed by '}'." : $equals_5('parser.descape.4', key) ? 'Invalid Unicode code point.' : $equals_5('parser.descape.5', key) ? 'An anchor must not be here.' : $equals_5('parser.process.1', key) ? 'This expression is not supported in the current option setting.' : $equals_5('parser.quantifier.1', key) ? 'Invalid quantifier. A digit is expected.' : $equals_5('parser.quantifier.2', key) ? "Invalid quantifier. Invalid quantity or a '}' is missing." : $equals_5('parser.quantifier.3', key) ? "Invalid quantifier. A digit or '}' is expected." : $equals_5('parser.quantifier.4', key) ? 'Invalid quantifier. A min quantity must be <= a max quantity.' : $equals_5('parser.quantifier.5', key) ? 'Invalid quantifier. A quantity value overflow.' : $equals_5('_UI_PackageRegistry_extensionpoint', key) ? 'Ecore Package Registry for Generated Packages' : $equals_5('_UI_DynamicPackageRegistry_extensionpoint', key) ? 'Ecore Package Registry for Dynamic Packages' : $equals_5('_UI_FactoryRegistry_extensionpoint', key) ? 'Ecore Factory Override Registry' : $equals_5('_UI_URIExtensionParserRegistry_extensionpoint', key) ? 'URI Extension Parser Registry' : $equals_5('_UI_URIProtocolParserRegistry_extensionpoint', key) ? 'URI Protocol Parser Registry' : $equals_5('_UI_URIContentParserRegistry_extensionpoint', key) ? 'URI Content Parser Registry' : $equals_5('_UI_ContentHandlerRegistry_extensionpoint', key) ? 'Content Handler Registry' : $equals_5('_UI_URIMappingRegistry_extensionpoint', key) ? 'URI Converter Mapping Registry' : $equals_5('_UI_PackageRegistryImplementation_extensionpoint', key) ? 'Ecore Package Registry Implementation' : $equals_5('_UI_ValidationDelegateRegistry_extensionpoint', key) ? 'Validation Delegate Registry' : $equals_5('_UI_SettingDelegateRegistry_extensionpoint', key) ? 'Feature Setting Delegate Factory Registry' : $equals_5('_UI_InvocationDelegateRegistry_extensionpoint', key) ? 'Operation Invocation Delegate Factory Registry' : $equals_5('_UI_EClassInterfaceNotAbstract_diagnostic', key) ? 'A class that is an interface must also be abstract' : $equals_5('_UI_EClassNoCircularSuperTypes_diagnostic', key) ? 'A class may not be a super type of itself' : $equals_5('_UI_EClassNotWellFormedMapEntryNoInstanceClassName_diagnostic', key) ? "A class that inherits from a map entry class must have instance class name 'java.util.Map$Entry'" : $equals_5('_UI_EReferenceOppositeOfOppositeInconsistent_diagnostic', key) ? 'The opposite of the opposite may not be a reference different from this one' : $equals_5('_UI_EReferenceOppositeNotFeatureOfType_diagnostic', key) ? "The opposite must be a feature of the reference's type" : $equals_5('_UI_EReferenceTransientOppositeNotTransient_diagnostic', key) ? 'The opposite of a transient reference must be transient if it is proxy resolving' : $equals_5('_UI_EReferenceOppositeBothContainment_diagnostic', key) ? 'The opposite of a containment reference must not be a containment reference' : $equals_5('_UI_EReferenceConsistentUnique_diagnostic', key) ? 'A containment or bidirectional reference must be unique if its upper bound is different from 1' : $equals_5('_UI_ETypedElementNoType_diagnostic', key) ? 'The typed element must have a type' : $equals_5('_UI_EAttributeNoDataType_diagnostic', key) ? 'The generic attribute type must not refer to a class' : $equals_5('_UI_EReferenceNoClass_diagnostic', key) ? 'The generic reference type must not refer to a data type' : $equals_5('_UI_EGenericTypeNoTypeParameterAndClassifier_diagnostic', key) ? "A generic type can't refer to both a type parameter and a classifier" : $equals_5('_UI_EGenericTypeNoClass_diagnostic', key) ? 'A generic super type must refer to a class' : $equals_5('_UI_EGenericTypeNoTypeParameterOrClassifier_diagnostic', key) ? 'A generic type in this context must refer to a classifier or a type parameter' : $equals_5('_UI_EGenericTypeBoundsOnlyForTypeArgument_diagnostic', key) ? 'A generic type may have bounds only when used as a type argument' : $equals_5('_UI_EGenericTypeNoUpperAndLowerBound_diagnostic', key) ? 'A generic type must not have both a lower and an upper bound' : $equals_5('_UI_EGenericTypeNoTypeParameterOrClassifierAndBound_diagnostic', key) ? 'A generic type with bounds must not also refer to a type parameter or classifier' : $equals_5('_UI_EGenericTypeNoArguments_diagnostic', key) ? 'A generic type may have arguments only if it refers to a classifier' : $equals_5('_UI_EGenericTypeOutOfScopeTypeParameter_diagnostic', key) ? 'A generic type may only refer to a type parameter that is in scope' : key;
}
defineClass(1040, 1, {});
var Lorg_eclipse_emf_common_util_DelegatingResourceLocator_2_classLit = createForClass('org.eclipse.emf.common.util', 'DelegatingResourceLocator', 1040);
function $log_2(logEntry) {
    logEntry ? $printStackTraceImpl(logEntry, ($clinit_System(), err_0), '') : $println(($clinit_System(), logEntry));
}
defineClass(1041, 1040, {});
var Lorg_eclipse_emf_common_EMFPlugin_2_classLit = createForClass('org.eclipse.emf.common', 'EMFPlugin', 1041);
var Lorg_eclipse_emf_common_notify_Adapter_2_classLit = createForInterface('org.eclipse.emf.common.notify', 'Adapter');
var Lorg_eclipse_emf_common_notify_Notification_2_classLit = createForInterface('org.eclipse.emf.common.notify', 'Notification');
defineClass(1138, 1, $intern_142);
_.getTarget = function getTarget() {
    return this.target;
};
_.notifyChanged = function notifyChanged(msg) {};
_.setTarget = function setTarget(newTarget) {
    this.target = newTarget;
};
_.unsetTarget = function unsetTarget(oldTarget) {
    this.target == oldTarget && (this.target = null);
};
_.target = null;
var Lorg_eclipse_emf_common_notify_impl_AdapterImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'AdapterImpl', 1138);
function $addAllUnique_1(this$static, index_0, collection) {
    var object, object$iterator;
    ++this$static.modCount;
    if (collection.isEmpty()) return false;
    else {
        for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
            object = object$iterator.next_1();
            this$static.delegateAdd(index_0, this$static.validate(index_0, object));
            ++index_0;
        }
        return true;
    }
}
function $addUnique_1(this$static, index_0, object) {
    ++this$static.modCount;
    this$static.delegateAdd(index_0, this$static.validate(index_0, object));
}
function $addUnique_2(this$static, object) {
    var size_0;
    ++this$static.modCount;
    size_0 = this$static.delegateSize();
    this$static.delegateAdd_0(this$static.validate(size_0, object));
}
function $doClear(this$static, oldSize, oldData) {
    ++this$static.modCount;
    this$static.delegateClear();
    $didClear(this$static, oldSize, oldData);
}
function $move_0(this$static, targetIndex, sourceIndex) {
    var object, size_0, result;
    ++this$static.modCount;
    size_0 = this$static.delegateSize();
    if (targetIndex >= size_0 || targetIndex < 0) throw toJs(new IndexOutOfBoundsException_0('targetIndex=' + targetIndex + ', size=' + size_0));
    if (sourceIndex >= size_0 || sourceIndex < 0) throw toJs(new IndexOutOfBoundsException_0('sourceIndex=' + sourceIndex + ', size=' + size_0));
    targetIndex != sourceIndex ? object = (result = this$static.delegateRemove(sourceIndex), this$static.delegateAdd(targetIndex, result), result) : object = this$static.delegateGet(sourceIndex);
    return object;
}
function $remove_34(this$static, index_0) {
    var oldObject;
    ++this$static.modCount;
    oldObject = this$static.delegateRemove(index_0);
    return oldObject;
}
defineClass(2039, 70, $intern_143);
_.addAllUnique = function addAllUnique_1(index_0, collection) {
    return $addAllUnique_1(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_2(collection) {
    var i, object, object$iterator;
    ++this.modCount;
    if (collection.isEmpty()) return false;
    else {
        i = this.delegateSize();
        for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
            object = object$iterator.next_1();
            this.delegateAdd_0(this.validate(i, object));
            ++i;
        }
        return true;
    }
};
_.addUnique = function addUnique_1(index_0, object) {
    $addUnique_1(this, index_0, object);
};
_.addUnique_0 = function addUnique_2(object) {
    $addUnique_2(this, object);
};
_.basicList = function basicList() {
    return this.delegateBasicList();
};
_.clear_0 = function clear_53() {
    $doClear(this, this.delegateSize(), this.delegateToArray());
};
_.contains = function contains_52(object) {
    return this.delegateContains(object);
};
_.containsAll = function containsAll_11(collection) {
    return this.delegateContainsAll(collection);
};
_.delegateAdd = function delegateAdd(index_0, object) {
    this.delegateList_1().$_nullMethod();
};
_.delegateAdd_0 = function delegateAdd_0(object) {
    this.delegateList_1().$_nullMethod();
};
_.delegateBasicList = function delegateBasicList() {
    return this.delegateList_1();
};
_.delegateClear = function delegateClear() {
    this.delegateList_1().$_nullMethod();
};
_.delegateContains = function delegateContains(object) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateContainsAll = function delegateContainsAll(collection) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateEquals = function delegateEquals(object) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateGet = function delegateGet(index_0) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateHashCode = function delegateHashCode() {
    return this.delegateList_1().$_nullMethod();
};
_.delegateIndexOf = function delegateIndexOf(object) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateIsEmpty = function delegateIsEmpty() {
    return this.delegateList_1().$_nullMethod();
};
_.delegateRemove = function delegateRemove(index_0) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateSet = function delegateSet(index_0, object) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateSize = function delegateSize() {
    return this.delegateList_1().$_nullMethod();
};
_.delegateToArray = function delegateToArray() {
    return this.delegateList_1().$_nullMethod();
};
_.delegateToArray_0 = function delegateToArray_0(array) {
    return this.delegateList_1().$_nullMethod();
};
_.delegateToString = function delegateToString() {
    return this.delegateList_1().$_nullMethod();
};
_.equals_0 = function equals_209(object) {
    return this.delegateEquals(object);
};
_.get_0 = function get_50(index_0) {
    return this.resolve(index_0, this.delegateGet(index_0));
};
_.hashCode_1 = function hashCode_76() {
    return this.delegateHashCode();
};
_.indexOf_0 = function indexOf_9(object) {
    return this.delegateIndexOf(object);
};
_.isEmpty = function isEmpty_27() {
    return this.delegateIsEmpty();
};
_.move = function move_2(targetIndex, sourceIndex) {
    return $move_0(this, targetIndex, sourceIndex);
};
_.primitiveGet = function primitiveGet_0(index_0) {
    return this.delegateGet(index_0);
};
_.remove_2 = function remove_102(index_0) {
    return $remove_34(this, index_0);
};
_.remove_1 = function remove_103(object) {
    var index_0;
    index_0 = this.indexOf_0(object);
    if (index_0 >= 0) {
        this.remove_2(index_0);
        return true;
    } else return false;
};
_.setUnique = function setUnique_0(index_0, object) {
    return this.delegateSet(index_0, this.validate(index_0, object));
};
_.size_1 = function size_67() {
    return this.delegateSize();
};
_.toArray = function toArray_28() {
    return this.delegateToArray();
};
_.toArray_0 = function toArray_29(array) {
    return this.delegateToArray_0(array);
};
_.toString_0 = function toString_134() {
    return this.delegateToString();
};
var Lorg_eclipse_emf_common_util_DelegatingEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'DelegatingEList', 2039);
function $addAllUnique_2(this$static, index_0, collection) {
    var collectionSize, i, lastIndex, notification, notifications, oldIsSet, value_0;
    collectionSize = collection.size_1();
    if (collectionSize == 0) return false;
    else {
        if (this$static.isNotificationRequired()) {
            oldIsSet = this$static.isSet_0();
            $addAllUnique_1(this$static, index_0, collection);
            notification = collectionSize == 1 ? this$static.createNotification(3, null, collection.iterator_0().next_1(), index_0, oldIsSet) : this$static.createNotification(5, null, collection, index_0, oldIsSet);
            if (this$static.hasInverse()) {
                notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
                lastIndex = index_0 + collectionSize;
                for(i = index_0; i < lastIndex; ++i){
                    value_0 = this$static.delegateGet(i);
                    notifications = this$static.inverseAdd(value_0, notifications);
                    notifications;
                }
                if (!notifications) this$static.dispatchNotification(notification);
                else {
                    notifications.add_5(notification);
                    notifications.dispatch_0();
                }
            } else this$static.dispatchNotification(notification);
        } else {
            $addAllUnique_1(this$static, index_0, collection);
            if (this$static.hasInverse()) {
                notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
                lastIndex = index_0 + collectionSize;
                for(i = index_0; i < lastIndex; ++i)notifications = this$static.inverseAdd(this$static.delegateGet(i), notifications);
                !!notifications && notifications.dispatch_0();
            }
        }
        return true;
    }
}
function $addUnique_3(this$static, index_0, object) {
    var notification, notifications, oldIsSet;
    if (this$static.isNotificationRequired()) {
        oldIsSet = this$static.isSet_0();
        ++this$static.modCount;
        this$static.delegateAdd(index_0, this$static.validate(index_0, object));
        notification = this$static.createNotification(3, null, object, index_0, oldIsSet);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else this$static.dispatchNotification(notification);
    } else {
        ++this$static.modCount;
        this$static.delegateAdd(index_0, this$static.validate(index_0, object));
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            !!notifications && notifications.dispatch_0();
        }
    }
}
function $addUnique_4(this$static, object) {
    var index_0, notification, notifications, oldIsSet;
    if (this$static.isNotificationRequired()) {
        index_0 = this$static.delegateSize();
        oldIsSet = this$static.isSet_0();
        ++this$static.modCount;
        this$static.delegateAdd(index_0, this$static.validate(index_0, object));
        notification = this$static.createNotification(3, null, object, index_0, oldIsSet);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else this$static.dispatchNotification(notification);
    } else {
        $addUnique_2(this$static, object);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            !!notifications && notifications.dispatch_0();
        }
    }
}
function $basicAdd(this$static, object, notifications) {
    var index_0, notification, oldIsSet;
    if (this$static.isNotificationRequired()) {
        index_0 = this$static.delegateSize();
        oldIsSet = this$static.isSet_0();
        ++this$static.modCount;
        this$static.delegateAdd(index_0, this$static.validate(index_0, object));
        notification = this$static.createNotification(3, null, object, index_0, oldIsSet);
        !notifications ? notifications = notification : notifications.add_5(notification);
    } else $addUnique_1(this$static, this$static.delegateSize(), object);
    return notifications;
}
function $basicRemove(this$static, object, notifications) {
    var index_0, notification, oldIsSet, oldObject;
    index_0 = this$static.indexOf_0(object);
    if (index_0 != -1) {
        if (this$static.isNotificationRequired()) {
            oldIsSet = this$static.isSet_0();
            oldObject = $remove_34(this$static, index_0);
            notification = this$static.createNotification(4, oldObject, null, index_0, oldIsSet);
            !notifications ? notifications = notification : notifications.add_5(notification);
        } else $remove_34(this$static, index_0);
    }
    return notifications;
}
function $clear_12(this$static) {
    var collection, collectionSize, i, notification, notifications, object, oldData, oldIsSet, oldSize, size_0;
    if (this$static.isNotificationRequired()) {
        size_0 = this$static.delegateSize();
        oldIsSet = this$static.isSet_0();
        if (size_0 > 0) {
            collection = new BasicEList_1(this$static.basicList());
            collectionSize = size_0;
            notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
            $doClear(this$static, collectionSize, collection.data_0);
            notification = collectionSize == 1 ? this$static.createNotification(4, $get_20(collection, 0), null, 0, oldIsSet) : this$static.createNotification(6, collection, null, -1, oldIsSet);
            if (this$static.hasInverse()) {
                for(i = new AbstractEList$EIterator(collection); i.cursor != i.this$01_2.size_1();)notifications = this$static.inverseRemove($doNext(i), notifications);
                if (!notifications) this$static.dispatchNotification(notification);
                else {
                    notifications.add_5(notification);
                    notifications.dispatch_0();
                }
            } else if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else {
            $doClear(this$static, this$static.delegateSize(), this$static.delegateToArray());
            this$static.dispatchNotification(this$static.createNotification(6, ($clinit_Collections(), EMPTY_LIST), null, -1, oldIsSet));
        }
    } else if (this$static.hasInverse()) {
        size_0 = this$static.delegateSize();
        if (size_0 > 0) {
            oldData = this$static.delegateToArray();
            oldSize = size_0;
            $doClear(this$static, size_0, oldData);
            notifications = oldSize < 100 ? null : new NotificationChainImpl_0(oldSize);
            for(i = 0; i < oldSize; ++i){
                object = oldData[i];
                notifications = this$static.inverseRemove(object, notifications);
            }
            !!notifications && notifications.dispatch_0();
        } else $doClear(this$static, this$static.delegateSize(), this$static.delegateToArray());
    } else $doClear(this$static, this$static.delegateSize(), this$static.delegateToArray());
}
function $setUnique_0(this$static, index_0, object) {
    var notification, notifications, oldIsSet, oldObject, oldObject0;
    if (this$static.isNotificationRequired()) {
        notifications = null;
        oldIsSet = this$static.isSet_0();
        notification = this$static.createNotification(1, oldObject0 = (oldObject = this$static.delegateSet(index_0, this$static.validate(index_0, object)), oldObject), object, index_0, oldIsSet);
        if (this$static.hasInverse() && !(this$static.useEquals() && !!oldObject0 ? equals_Ljava_lang_Object__Z__devirtual$(oldObject0, object) : maskUndefined(oldObject0) === maskUndefined(object))) {
            !!oldObject0 && (notifications = this$static.inverseRemove(oldObject0, notifications));
            notifications = this$static.inverseAdd(object, notifications);
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else if (!notifications) this$static.dispatchNotification(notification);
        else {
            notifications.add_5(notification);
            notifications.dispatch_0();
        }
        return oldObject0;
    } else {
        oldObject0 = (oldObject = this$static.delegateSet(index_0, this$static.validate(index_0, object)), oldObject);
        if (this$static.hasInverse() && !(this$static.useEquals() && !!oldObject0 ? equals_Ljava_lang_Object__Z__devirtual$(oldObject0, object) : maskUndefined(oldObject0) === maskUndefined(object))) {
            notifications = null;
            !!oldObject0 && (notifications = this$static.inverseRemove(oldObject0, null));
            notifications = this$static.inverseAdd(object, notifications);
            !!notifications && notifications.dispatch_0();
        }
        return oldObject0;
    }
}
defineClass(2040, 2039, $intern_143);
_.addAllUnique = function addAllUnique_3(index_0, collection) {
    return $addAllUnique_2(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_4(collection) {
    return this.addAllUnique(this.delegateSize(), collection);
};
_.addUnique = function addUnique_3(index_0, object) {
    $addUnique_3(this, index_0, object);
};
_.addUnique_0 = function addUnique_4(object) {
    $addUnique_4(this, object);
};
_.canContainNull = function canContainNull_0() {
    return !this.hasInverse();
};
_.clear_0 = function clear_54() {
    $clear_12(this);
};
_.createNotification = function createNotification(eventType, oldObject, newObject, index_0, wasSet) {
    return new DelegatingNotifyingListImpl$1(this, eventType, oldObject, newObject, index_0, wasSet);
};
_.dispatchNotification = function dispatchNotification(notification) {
    $eNotify(this.getNotifier(), notification);
};
_.getFeature = function getFeature() {
    return null;
};
_.getFeatureID_0 = function getFeatureID() {
    return -1;
};
_.getNotifier = function getNotifier() {
    return null;
};
_.hasInverse = function hasInverse() {
    return false;
};
_.inverseAdd = function inverseAdd(object, notifications) {
    return notifications;
};
_.inverseRemove = function inverseRemove(object, notifications) {
    return notifications;
};
_.isNotificationRequired = function isNotificationRequired() {
    return false;
};
_.isSet_0 = function isSet() {
    return !this.delegateIsEmpty();
};
_.move = function move_3(targetIndex, sourceIndex) {
    var object, oldIsSet;
    if (this.isNotificationRequired()) {
        oldIsSet = this.isSet_0();
        object = $move_0(this, targetIndex, sourceIndex);
        this.dispatchNotification(this.createNotification(7, valueOf_3(sourceIndex), object, targetIndex, oldIsSet));
        return object;
    } else return $move_0(this, targetIndex, sourceIndex);
};
_.remove_2 = function remove_104(index_0) {
    var notification, notifications, oldIsSet, oldObject;
    if (this.isNotificationRequired()) {
        notifications = null;
        oldIsSet = this.isSet_0();
        notification = this.createNotification(4, oldObject = $remove_34(this, index_0), null, index_0, oldIsSet);
        if (this.hasInverse() && !!oldObject) {
            notifications = this.inverseRemove(oldObject, notifications);
            if (!notifications) this.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else if (!notifications) this.dispatchNotification(notification);
        else {
            notifications.add_5(notification);
            notifications.dispatch_0();
        }
        return oldObject;
    } else {
        oldObject = $remove_34(this, index_0);
        if (this.hasInverse() && !!oldObject) {
            notifications = this.inverseRemove(oldObject, null);
            !!notifications && notifications.dispatch_0();
        }
        return oldObject;
    }
};
_.setUnique = function setUnique_1(index_0, object) {
    return $setUnique_0(this, index_0, object);
};
var Lorg_eclipse_emf_common_notify_impl_DelegatingNotifyingListImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'DelegatingNotifyingListImpl', 2040);
function $add_22(this$static, newNotification) {
    if (!newNotification) return false;
    else {
        if (this$static.merge(newNotification)) return false;
        if (!this$static.next_0) {
            if (instanceOf(newNotification, 150)) {
                this$static.next_0 = castTo(newNotification, 150);
                return true;
            } else {
                this$static.next_0 = new NotificationChainImpl;
                return this$static.next_0.add_5(newNotification);
            }
        } else return this$static.next_0.add_5(newNotification);
    }
}
function $dispatch(this$static) {
    var notifier;
    notifier = this$static.getNotifier();
    notifier != null && this$static.eventType != -1 && castTo(notifier, 93).eNotify(this$static);
    !!this$static.next_0 && this$static.next_0.dispatch_0();
}
function $getNewBooleanValue(this$static) {
    if (this$static.primitiveType != 0) throw toJs(new IllegalStateException);
    return neq(this$static.newSimplePrimitiveValue, 0);
}
function $getNewByteValue(this$static) {
    if (this$static.primitiveType != 1) throw toJs(new IllegalStateException);
    return toInt_0(this$static.newSimplePrimitiveValue) << 24 >> 24;
}
function $getNewCharValue(this$static) {
    if (this$static.primitiveType != 2) throw toJs(new IllegalStateException);
    return toInt_0(this$static.newSimplePrimitiveValue) & $intern_46;
}
function $getNewDoubleValue(this$static) {
    if (this$static.primitiveType != 3) throw toJs(new IllegalStateException);
    return this$static.newIEEEPrimitiveValue;
}
function $getNewFloatValue(this$static) {
    if (this$static.primitiveType != 4) throw toJs(new IllegalStateException);
    return this$static.newIEEEPrimitiveValue;
}
function $getNewIntValue(this$static) {
    if (this$static.primitiveType != 5) throw toJs(new IllegalStateException);
    return toInt_0(this$static.newSimplePrimitiveValue);
}
function $getNewLongValue(this$static) {
    if (this$static.primitiveType != 6) throw toJs(new IllegalStateException);
    return this$static.newSimplePrimitiveValue;
}
function $getNewShortValue(this$static) {
    if (this$static.primitiveType != 7) throw toJs(new IllegalStateException);
    return toInt_0(this$static.newSimplePrimitiveValue) << 16 >> 16;
}
function $getNewValue(this$static) {
    if (this$static.newValue == null) switch(this$static.primitiveType){
        case 0:
            this$static.newValue = $getNewBooleanValue(this$static) ? ($clinit_Boolean(), TRUE_0) : ($clinit_Boolean(), FALSE_0);
            break;
        case 1:
            this$static.newValue = get_32($getNewByteValue(this$static));
            break;
        case 2:
            this$static.newValue = valueOf_2($getNewCharValue(this$static));
            break;
        case 3:
            this$static.newValue = $getNewDoubleValue(this$static);
            break;
        case 4:
            this$static.newValue = new Float($getNewFloatValue(this$static));
            break;
        case 6:
            this$static.newValue = valueOf_4($getNewLongValue(this$static));
            break;
        case 5:
            this$static.newValue = valueOf_3($getNewIntValue(this$static));
            break;
        case 7:
            this$static.newValue = valueOf_5($getNewShortValue(this$static));
    }
    return this$static.newValue;
}
function $getOldBooleanValue(this$static) {
    if (this$static.primitiveType != 0) throw toJs(new IllegalStateException);
    return neq(this$static.oldSimplePrimitiveValue, 0);
}
function $getOldByteValue(this$static) {
    if (this$static.primitiveType != 1) throw toJs(new IllegalStateException);
    return toInt_0(this$static.oldSimplePrimitiveValue) << 24 >> 24;
}
function $getOldCharValue(this$static) {
    if (this$static.primitiveType != 2) throw toJs(new IllegalStateException);
    return toInt_0(this$static.oldSimplePrimitiveValue) & $intern_46;
}
function $getOldDoubleValue(this$static) {
    if (this$static.primitiveType != 3) throw toJs(new IllegalStateException);
    return this$static.oldIEEEPrimitiveValue;
}
function $getOldFloatValue(this$static) {
    if (this$static.primitiveType != 4) throw toJs(new IllegalStateException);
    return this$static.oldIEEEPrimitiveValue;
}
function $getOldIntValue(this$static) {
    if (this$static.primitiveType != 5) throw toJs(new IllegalStateException);
    return toInt_0(this$static.oldSimplePrimitiveValue);
}
function $getOldLongValue(this$static) {
    if (this$static.primitiveType != 6) throw toJs(new IllegalStateException);
    return this$static.oldSimplePrimitiveValue;
}
function $getOldShortValue(this$static) {
    if (this$static.primitiveType != 7) throw toJs(new IllegalStateException);
    return toInt_0(this$static.oldSimplePrimitiveValue) << 16 >> 16;
}
function $getOldValue(this$static) {
    if (this$static.oldValue == null) switch(this$static.primitiveType){
        case 0:
            this$static.oldValue = $getOldBooleanValue(this$static) ? ($clinit_Boolean(), TRUE_0) : ($clinit_Boolean(), FALSE_0);
            break;
        case 1:
            this$static.oldValue = get_32($getOldByteValue(this$static));
            break;
        case 2:
            this$static.oldValue = valueOf_2($getOldCharValue(this$static));
            break;
        case 3:
            this$static.oldValue = $getOldDoubleValue(this$static);
            break;
        case 4:
            this$static.oldValue = new Float($getOldFloatValue(this$static));
            break;
        case 6:
            this$static.oldValue = valueOf_4($getOldLongValue(this$static));
            break;
        case 5:
            this$static.oldValue = valueOf_3($getOldIntValue(this$static));
            break;
        case 7:
            this$static.oldValue = valueOf_5($getOldShortValue(this$static));
    }
    return this$static.oldValue;
}
function $isTouch(this$static) {
    switch(this$static.eventType){
        case 9:
        case 8:
            return true;
        case 3:
        case 5:
        case 4:
        case 6:
            return false;
        case 7:
            return castTo($getOldValue(this$static), 17).value_0 == this$static.position;
        case 1:
        case 2:
            if (this$static.position == -2) return false;
            else switch(this$static.primitiveType){
                case 0:
                case 1:
                case 2:
                case 6:
                case 5:
                case 7:
                    return eq(this$static.oldSimplePrimitiveValue, this$static.newSimplePrimitiveValue);
                case 3:
                case 4:
                    return this$static.oldIEEEPrimitiveValue == this$static.newIEEEPrimitiveValue;
                default:
                    return this$static.oldValue == null ? this$static.newValue == null : equals_Ljava_lang_Object__Z__devirtual$(this$static.oldValue, this$static.newValue);
            }
        default:
            return false;
    }
}
function $wasSet(this$static) {
    var defaultValue;
    switch(this$static.eventType){
        case 1:
            if (this$static.isFeatureUnsettable()) return this$static.position != -2;
            break;
        case 2:
            if (this$static.isFeatureUnsettable()) return this$static.position == -2;
            break;
        case 3:
        case 5:
        case 4:
        case 6:
        case 7:
            return this$static.position > -2;
        default:
            return false;
    }
    defaultValue = this$static.getFeatureDefaultValue();
    switch(this$static.primitiveType){
        case 0:
            return defaultValue != null && $booleanValue(castToBoolean(defaultValue)) != neq(this$static.oldSimplePrimitiveValue, 0);
        case 1:
            return defaultValue != null && castTo(defaultValue, 219).value_0 != toInt_0(this$static.oldSimplePrimitiveValue) << 24 >> 24;
        case 2:
            return defaultValue != null && castTo(defaultValue, 179).value_0 != (toInt_0(this$static.oldSimplePrimitiveValue) & $intern_46);
        case 6:
            return defaultValue != null && neq(castTo(defaultValue, 190).value_0, this$static.oldSimplePrimitiveValue);
        case 5:
            return defaultValue != null && castTo(defaultValue, 17).value_0 != toInt_0(this$static.oldSimplePrimitiveValue);
        case 7:
            return defaultValue != null && castTo(defaultValue, 191).value_0 != toInt_0(this$static.oldSimplePrimitiveValue) << 16 >> 16;
        case 3:
            return defaultValue != null && $doubleValue(castToDouble(defaultValue)) != this$static.oldIEEEPrimitiveValue;
        case 4:
            return defaultValue != null && castTo(defaultValue, 160).value_0 != this$static.oldIEEEPrimitiveValue;
        default:
            return defaultValue == null ? this$static.oldValue != null : !equals_Ljava_lang_Object__Z__devirtual$(defaultValue, this$static.oldValue);
    }
}
function NotificationImpl(eventType, oldDoubleValue, newDoubleValue) {
    this.eventType = eventType;
    this.oldIEEEPrimitiveValue = oldDoubleValue;
    this.newIEEEPrimitiveValue = newDoubleValue;
    this.position = -1;
    this.primitiveType = 3;
}
function NotificationImpl_0(eventType, oldIntValue, newIntValue) {
    this.eventType = eventType;
    this.oldSimplePrimitiveValue = oldIntValue;
    this.newSimplePrimitiveValue = newIntValue;
    this.position = -1;
    this.primitiveType = 5;
}
function NotificationImpl_1(eventType, oldValue, newValue, position) {
    this.eventType = eventType;
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.position = position;
    this.primitiveType = -1;
}
function NotificationImpl_2(eventType, oldValue, newValue, position, wasSet) {
    this.eventType = eventType;
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.position = position;
    this.primitiveType = -1;
    wasSet || (this.position = -2 - position - 1);
}
function NotificationImpl_3(eventType, oldBooleanValue, newBooleanValue) {
    this.eventType = eventType;
    this.oldSimplePrimitiveValue = oldBooleanValue ? 1 : 0;
    this.newSimplePrimitiveValue = newBooleanValue ? 1 : 0;
    this.position = -1;
    this.primitiveType = 0;
}
defineClass(150, 1, $intern_144);
_.add_5 = function add_48(newNotification) {
    return $add_22(this, newNotification);
};
_.dispatch_0 = function dispatch() {
    $dispatch(this);
};
_.getEventType = function getEventType() {
    return this.eventType;
};
_.getFeature = function getFeature_0() {
    return null;
};
_.getFeatureDefaultValue = function getFeatureDefaultValue() {
    return null;
};
_.getFeatureID = function getFeatureID_0(expectedClass) {
    return -1;
};
_.getNewValue = function getNewValue() {
    return $getNewValue(this);
};
_.getNotifier = function getNotifier_0() {
    return null;
};
_.getOldValue = function getOldValue() {
    return $getOldValue(this);
};
_.getPosition_0 = function getPosition_2() {
    return this.position < 0 ? this.position < -2 ? -2 - this.position - 1 : -1 : this.position;
};
_.isFeatureUnsettable = function isFeatureUnsettable() {
    return false;
};
_.merge = function merge_0(notification) {
    var index_0, list, newPositions, notificationEventType, notificationNotifier, notificationPosition, oldPosition, originalPosition, originalWasSet, positions, removedValues;
    switch(this.eventType){
        case 1:
        case 2:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 1:
                case 2:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.getNotifier()) && this.getFeatureID(null) == notification.getFeatureID(null)) {
                        this.newValue = notification.getNewValue();
                        notification.getEventType() == 1 && (this.eventType = 1);
                        return true;
                    }
            }
        case 4:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 4:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.getNotifier()) && this.getFeatureID(null) == notification.getFeatureID(null)) {
                        originalWasSet = $wasSet(this);
                        originalPosition = this.position < 0 ? this.position < -2 ? -2 - this.position - 1 : -1 : this.position;
                        notificationPosition = notification.getPosition_0();
                        this.eventType = 6;
                        removedValues = new BasicEList_0(2);
                        if (originalPosition <= notificationPosition) {
                            $add_21(removedValues, this.oldValue);
                            $add_21(removedValues, notification.getOldValue());
                            this.newValue = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
                                this.position = originalPosition,
                                notificationPosition + 1
                            ]);
                        } else {
                            $add_21(removedValues, notification.getOldValue());
                            $add_21(removedValues, this.oldValue);
                            this.newValue = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
                                this.position = notificationPosition,
                                originalPosition
                            ]);
                        }
                        this.oldValue = removedValues;
                        originalWasSet || (this.position = -2 - this.position - 1);
                        return true;
                    }
                    break;
            }
            break;
        case 6:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 4:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.getNotifier()) && this.getFeatureID(null) == notification.getFeatureID(null)) {
                        originalWasSet = $wasSet(this);
                        notificationPosition = notification.getPosition_0();
                        positions = castTo(this.newValue, 54);
                        newPositions = initUnidimensionalArray(I_classLit, $intern_48, 30, positions.length + 1, 15, 1);
                        index_0 = 0;
                        while(index_0 < positions.length){
                            oldPosition = positions[index_0];
                            if (oldPosition <= notificationPosition) {
                                newPositions[index_0++] = oldPosition;
                                ++notificationPosition;
                            } else break;
                        }
                        list = castTo(this.oldValue, 15);
                        list.add_3(index_0, notification.getOldValue());
                        newPositions[index_0] = notificationPosition;
                        while(++index_0 < newPositions.length)newPositions[index_0] = positions[index_0 - 1];
                        this.newValue = newPositions;
                        originalWasSet || (this.position = -2 - newPositions[0]);
                        return true;
                    }
                    break;
            }
            break;
    }
    return false;
};
_.toString_0 = function toString_135() {
    var i, number, positions, result;
    result = new StringBuffer_1($getName(this.___clazz) + '@' + (number = hashCode__I__devirtual$(this) >>> 0, number.toString(16)));
    result.string += ' (eventType: ';
    switch(this.eventType){
        case 1:
            result.string += 'SET';
            break;
        case 2:
            result.string += 'UNSET';
            break;
        case 3:
            result.string += 'ADD';
            break;
        case 5:
            result.string += 'ADD_MANY';
            break;
        case 4:
            result.string += 'REMOVE';
            break;
        case 6:
            result.string += 'REMOVE_MANY';
            break;
        case 7:
            result.string += 'MOVE';
            break;
        case 8:
            result.string += 'REMOVING_ADAPTER';
            break;
        case 9:
            result.string += 'RESOLVE';
            break;
        default:
            $append_1(result, this.eventType);
            break;
    }
    $isTouch(this) && (result.string += ', touch: true', result);
    result.string += ', position: ';
    $append_1(result, this.position < 0 ? this.position < -2 ? -2 - this.position - 1 : -1 : this.position);
    result.string += ', notifier: ';
    $append_2(result, this.getNotifier());
    result.string += ', feature: ';
    $append_2(result, this.getFeature());
    result.string += ', oldValue: ';
    $append_2(result, $getOldValue(this));
    result.string += ', newValue: ';
    if (this.eventType == 6 && instanceOf(this.newValue, 54)) {
        positions = castTo(this.newValue, 54);
        result.string += '[';
        for(i = 0; i < positions.length;){
            result.string += positions[i];
            ++i < positions.length && (result.string += ', ', result);
        }
        result.string += ']';
    } else $append_2(result, $getNewValue(this));
    result.string += ', isTouch: ';
    $append_4(result, $isTouch(this));
    result.string += ', wasSet: ';
    $append_4(result, $wasSet(this));
    result.string += ')';
    return result.string;
};
_.eventType = 0;
_.newIEEEPrimitiveValue = 0;
_.newSimplePrimitiveValue = 0;
_.oldIEEEPrimitiveValue = 0;
_.oldSimplePrimitiveValue = 0;
_.position = 0;
_.primitiveType = 0;
var Lorg_eclipse_emf_common_notify_impl_NotificationImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'NotificationImpl', 150);
function DelegatingNotifyingListImpl$1(this$0, $anonymous0, $anonymous1, $anonymous2, $anonymous3, $anonymous4) {
    this.this$01 = this$0;
    NotificationImpl_2.call(this, $anonymous0, $anonymous1, $anonymous2, $anonymous3, $anonymous4);
}
defineClass(1152, 150, $intern_144, DelegatingNotifyingListImpl$1);
_.getFeature = function getFeature_1() {
    return this.this$01.getFeature();
};
_.getFeatureID = function getFeatureID_1(expectedClass) {
    return this.this$01.getFeatureID_0();
};
_.getNotifier = function getNotifier_1() {
    return this.this$01.getNotifier();
};
var Lorg_eclipse_emf_common_notify_impl_DelegatingNotifyingListImpl$1_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'DelegatingNotifyingListImpl/1', 1152);
function $add_23(this$static, newNotification) {
    var i, notification;
    if (!newNotification) return false;
    else {
        for(i = 0; i < this$static.size_0; ++i){
            notification = castTo(this$static.data_0[i], 370);
            if (notification.merge(newNotification)) return false;
        }
        return $add_21(this$static, newNotification);
    }
}
function NotificationChainImpl() {}
function NotificationChainImpl_0(initialCapacity) {
    BasicEList_0.call(this, initialCapacity);
}
defineClass(250, 66, $intern_140, NotificationChainImpl, NotificationChainImpl_0);
_.add_2 = function add_49(newNotification) {
    return $add_23(this, castTo(newNotification, 370));
};
_.add_5 = function add_50(newNotification) {
    return $add_23(this, newNotification);
};
_.dispatch_0 = function dispatch_0() {
    var i, notification, notifier;
    for(i = 0; i < this.size_0; ++i){
        notification = castTo(this.data_0[i], 370);
        notifier = notification.getNotifier();
        notifier != null && notification.getEventType() != -1 && castTo(notifier, 93).eNotify(notification);
    }
};
_.newData = function newData_1(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_notify_Notification_2_classLit, $intern_2, 370, capacity, 0, 1);
};
var Lorg_eclipse_emf_common_notify_impl_NotificationChainImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'NotificationChainImpl', 250);
defineClass(1464, 92, $intern_136);
_.eBasicAdapters = function eBasicAdapters_1() {
    return this.eAdapters;
};
_.eDeliver = function eDeliver_1() {
    return (this.eFlags & 1) != 0;
};
_.eFlags = 1;
var Lorg_eclipse_emf_common_notify_impl_NotifierImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'NotifierImpl', 1464);
function $addAllUnique_3(this$static, index_0, collection) {
    var collectionSize, i, lastIndex, notification, notifications, object, oldIsSet, value_0;
    collectionSize = collection.size_1();
    if (collectionSize == 0) return false;
    else {
        if (this$static.isNotificationRequired()) {
            oldIsSet = this$static.isSet_0();
            $addAllUnique(this$static, index_0, collection);
            notification = collectionSize == 1 ? this$static.createNotification(3, null, collection.iterator_0().next_1(), index_0, oldIsSet) : this$static.createNotification(5, null, collection, index_0, oldIsSet);
            if (this$static.hasInverse()) {
                notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
                lastIndex = index_0 + collectionSize;
                for(i = index_0; i < lastIndex; ++i){
                    value_0 = this$static.data_0[i];
                    notifications = this$static.inverseAdd(value_0, notifications);
                    notifications = this$static.shadowAdd(value_0, notifications);
                }
                if (!notifications) this$static.dispatchNotification(notification);
                else {
                    notifications.add_5(notification);
                    notifications.dispatch_0();
                }
            } else this$static.dispatchNotification(notification);
        } else {
            $addAllUnique(this$static, index_0, collection);
            if (this$static.hasInverse()) {
                notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
                lastIndex = index_0 + collectionSize;
                for(i = index_0; i < lastIndex; ++i){
                    object = this$static.data_0[i];
                    notifications = this$static.inverseAdd(object, notifications);
                }
                !!notifications && notifications.dispatch_0();
            }
        }
        return true;
    }
}
function $addUnique_5(this$static, index_0, object) {
    var notification, notifications, oldIsSet;
    if (this$static.isNotificationRequired()) {
        oldIsSet = this$static.isSet_0();
        $addUnique(this$static, index_0, object);
        notification = this$static.createNotification(3, null, object, index_0, oldIsSet);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            this$static.hasShadow() && (notifications = this$static.shadowAdd(object, notifications));
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else this$static.dispatchNotification(notification);
    } else {
        $addUnique(this$static, index_0, object);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            !!notifications && notifications.dispatch_0();
        }
    }
}
function $addUnique_6(this$static, object) {
    var index_0, notification, notifications, oldIsSet;
    if (this$static.isNotificationRequired()) {
        index_0 = this$static.size_0;
        oldIsSet = this$static.isSet_0();
        $addUnique_0(this$static, object);
        notification = this$static.createNotification(3, null, object, index_0, oldIsSet);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            this$static.hasShadow() && (notifications = this$static.shadowAdd(object, notifications));
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else this$static.dispatchNotification(notification);
    } else {
        $addUnique_0(this$static, object);
        if (this$static.hasInverse()) {
            notifications = this$static.inverseAdd(object, null);
            !!notifications && notifications.dispatch_0();
        }
    }
}
function $basicAdd_0(this$static, object, notifications) {
    var index_0, notification, oldIsSet;
    if (this$static.isNotificationRequired()) {
        index_0 = this$static.size_0;
        oldIsSet = this$static.isSet_0();
        $addUnique(this$static, index_0, object);
        notification = this$static.createNotification(3, null, object, index_0, oldIsSet);
        !notifications ? notifications = notification : notifications.add_5(notification);
    } else $addUnique(this$static, this$static.size_0, object);
    return notifications;
}
function $basicRemove_0(this$static, object, notifications) {
    var index_0, notification, oldIsSet, oldObject;
    index_0 = this$static.indexOf_0(object);
    if (index_0 != -1) {
        if (this$static.isNotificationRequired()) {
            oldIsSet = this$static.isSet_0();
            oldObject = $remove_33(this$static, index_0);
            notification = this$static.createNotification(4, oldObject, null, index_0, oldIsSet);
            !notifications ? notifications = notification : notifications.add_5(notification);
        } else $remove_33(this$static, index_0);
    }
    return notifications;
}
function $clear_13(this$static) {
    var collection, collectionSize, i, notification, notifications, object, oldData, oldIsSet, oldSize;
    if (this$static.isNotificationRequired()) {
        oldIsSet = this$static.isSet_0();
        if (this$static.size_0 > 0) {
            collection = new BasicEList$UnmodifiableEList(this$static.size_0, this$static.data_0);
            collectionSize = this$static.size_0;
            notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
            if (this$static.hasShadow()) for(i = 0; i < this$static.size_0; ++i){
                object = this$static.data_0[i];
                notifications = this$static.shadowRemove(object, notifications);
            }
            $clear_11(this$static);
            notification = collectionSize == 1 ? this$static.createNotification(4, $get_20(collection, 0), null, 0, oldIsSet) : this$static.createNotification(6, collection, null, -1, oldIsSet);
            if (this$static.hasInverse()) {
                for(i = new AbstractEList$NonResolvingEIterator(collection); i.cursor != i.this$01_2.size_1();)notifications = this$static.inverseRemove($doNext_0(i), notifications);
                if (!notifications) this$static.dispatchNotification(notification);
                else {
                    notifications.add_5(notification);
                    notifications.dispatch_0();
                }
            } else if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else {
            $clear_11(this$static);
            this$static.dispatchNotification(this$static.createNotification(6, ($clinit_Collections(), EMPTY_LIST), null, -1, oldIsSet));
        }
    } else if (this$static.hasInverse()) {
        if (this$static.size_0 > 0) {
            oldData = this$static.data_0;
            oldSize = this$static.size_0;
            $clear_11(this$static);
            notifications = oldSize < 100 ? null : new NotificationChainImpl_0(oldSize);
            for(i = 0; i < oldSize; ++i){
                object = oldData[i];
                notifications = this$static.inverseRemove(object, notifications);
            }
            !!notifications && notifications.dispatch_0();
        } else $clear_11(this$static);
    } else $clear_11(this$static);
}
function $createNotificationChain(capacity) {
    return capacity < 100 ? null : new NotificationChainImpl_0(capacity);
}
function $move_1(this$static, targetIndex, sourceIndex) {
    var object, oldIsSet;
    if (this$static.isNotificationRequired()) {
        oldIsSet = this$static.isSet_0();
        object = $move(this$static, targetIndex, sourceIndex);
        this$static.dispatchNotification(this$static.createNotification(7, valueOf_3(sourceIndex), object, targetIndex, oldIsSet));
        return object;
    } else return $move(this$static, targetIndex, sourceIndex);
}
function $remove_35(this$static, index_0) {
    var notification, notifications, oldIsSet, oldObject;
    if (this$static.isNotificationRequired()) {
        notifications = null;
        oldIsSet = this$static.isSet_0();
        this$static.hasShadow() && (notifications = this$static.shadowRemove(this$static.basicGet(index_0), null));
        notification = this$static.createNotification(4, oldObject = $remove_33(this$static, index_0), null, index_0, oldIsSet);
        if (this$static.hasInverse() && oldObject != null) {
            notifications = this$static.inverseRemove(oldObject, notifications);
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else if (!notifications) this$static.dispatchNotification(notification);
        else {
            notifications.add_5(notification);
            notifications.dispatch_0();
        }
        return oldObject;
    } else {
        oldObject = $remove_33(this$static, index_0);
        if (this$static.hasInverse() && oldObject != null) {
            notifications = this$static.inverseRemove(oldObject, null);
            !!notifications && notifications.dispatch_0();
        }
        return oldObject;
    }
}
function $removeAll_4(this$static, collection) {
    var collectionSize, count, i, i0, i1, initialObject, j, list, listSize, notification, notifications, object, objects, oldIsSet, oldPositions, positions, repeat, result, resultList;
    oldIsSet = this$static.size_0 != 0;
    result = false;
    positions = null;
    if ($eNotificationRequired(this$static.owner)) {
        listSize = collection.size_1();
        if (listSize > 0) {
            notifications = listSize < 100 ? null : new NotificationChainImpl_0(listSize);
            list = new BasicEList_1(collection);
            objects = list.data_0;
            positions = initUnidimensionalArray(I_classLit, $intern_48, 30, listSize, 15, 1);
            count = 0;
            resultList = new BasicEList_0(listSize);
            for(i = 0; i < this$static.size_0; ++i){
                initialObject = this$static.data_0[i];
                object = initialObject;
                LOOP: for(repeat = 0; repeat < 2; ++repeat){
                    for(j = listSize; --j >= 0;)if (object != null ? equals_Ljava_lang_Object__Z__devirtual$(object, objects[j]) : maskUndefined(object) === maskUndefined(objects[j])) {
                        if (positions.length <= count) {
                            oldPositions = positions;
                            positions = initUnidimensionalArray(I_classLit, $intern_48, 30, 2 * positions.length, 15, 1);
                            arraycopy(oldPositions, 0, positions, 0, count);
                        }
                        positions[count++] = i;
                        $add_21(resultList, objects[j]);
                        break LOOP;
                    }
                    object;
                    if (maskUndefined(object) === maskUndefined(initialObject)) break;
                }
            }
            list = resultList;
            objects = resultList.data_0;
            listSize = count;
            if (count > positions.length) {
                oldPositions = positions;
                positions = initUnidimensionalArray(I_classLit, $intern_48, 30, count, 15, 1);
                arraycopy(oldPositions, 0, positions, 0, count);
            }
            if (count > 0) {
                result = true;
                for(i0 = 0; i0 < count; ++i0){
                    object = objects[i0];
                    notifications = $shadowRemove_2(this$static, castTo(object, 74), notifications);
                }
                for(i1 = count; --i1 >= 0;)$remove_33(this$static, positions[i1]);
                if (count != listSize) {
                    for(i = listSize; --i >= count;)$remove_33(list, i);
                    oldPositions = positions;
                    positions = initUnidimensionalArray(I_classLit, $intern_48, 30, count, 15, 1);
                    arraycopy(oldPositions, 0, positions, 0, count);
                }
                collection = list;
            }
        }
    } else {
        collection = $getDuplicates(this$static, collection);
        for(i = this$static.size_0; --i >= 0;)if (collection.contains(this$static.data_0[i])) {
            $remove_33(this$static, i);
            result = true;
        }
    }
    if (result) {
        if (positions != null) {
            collectionSize = collection.size_1();
            notification = collectionSize == 1 ? $createNotification(this$static, 4, collection.iterator_0().next_1(), null, positions[0], oldIsSet) : $createNotification(this$static, 6, collection, positions, positions[0], oldIsSet);
            notifications = collectionSize < 100 ? null : new NotificationChainImpl_0(collectionSize);
            for(i = collection.iterator_0(); i.hasNext_0();){
                object = i.next_1();
                notifications = $inverseRemove_3(this$static, castTo(object, 74), notifications);
            }
            if (!notifications) $eNotify(this$static.owner, notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else {
            notifications = $createNotificationChain(collection.size_1());
            for(i = collection.iterator_0(); i.hasNext_0();){
                object = i.next_1();
                notifications = $inverseRemove_3(this$static, castTo(object, 74), notifications);
            }
            !!notifications && notifications.dispatch_0();
        }
        return true;
    } else return false;
}
function $setUnique_1(this$static, index_0, object) {
    var notification, notifications, oldIsSet, oldObject;
    if (this$static.isNotificationRequired()) {
        notifications = null;
        oldIsSet = this$static.isSet_0();
        notification = this$static.createNotification(1, oldObject = $setUnique(this$static, index_0, object), object, index_0, oldIsSet);
        if (this$static.hasInverse() && !(this$static.useEquals() && oldObject != null ? equals_Ljava_lang_Object__Z__devirtual$(oldObject, object) : maskUndefined(oldObject) === maskUndefined(object))) {
            oldObject != null && (notifications = this$static.inverseRemove(oldObject, notifications));
            notifications = this$static.inverseAdd(object, notifications);
            this$static.hasShadow() && (notifications = this$static.shadowSet(oldObject, object, notifications));
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        } else {
            this$static.hasShadow() && (notifications = this$static.shadowSet(oldObject, object, notifications));
            if (!notifications) this$static.dispatchNotification(notification);
            else {
                notifications.add_5(notification);
                notifications.dispatch_0();
            }
        }
        return oldObject;
    } else {
        oldObject = $setUnique(this$static, index_0, object);
        if (this$static.hasInverse() && !(this$static.useEquals() && oldObject != null ? equals_Ljava_lang_Object__Z__devirtual$(oldObject, object) : maskUndefined(oldObject) === maskUndefined(object))) {
            notifications = null;
            oldObject != null && (notifications = this$static.inverseRemove(oldObject, null));
            notifications = this$static.inverseAdd(object, notifications);
            !!notifications && notifications.dispatch_0();
        }
        return oldObject;
    }
}
defineClass(2037, 66, $intern_140);
_.addAllUnique = function addAllUnique_5(index_0, collection) {
    return $addAllUnique_3(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_6(collection) {
    return this.addAllUnique(this.size_0, collection);
};
_.addUnique = function addUnique_5(index_0, object) {
    $addUnique_5(this, index_0, object);
};
_.addUnique_0 = function addUnique_6(object) {
    $addUnique_6(this, object);
};
_.canContainNull = function canContainNull_1() {
    return !this.hasInverse();
};
_.clear_0 = function clear_55() {
    $clear_13(this);
};
_.createNotification = function createNotification_0(eventType, oldObject, newObject, index_0, wasSet) {
    return new NotifyingListImpl$1(this, eventType, oldObject, newObject, index_0, wasSet);
};
_.dispatchNotification = function dispatchNotification_0(notification) {
    $eNotify(this.getNotifier(), notification);
};
_.getFeature = function getFeature_2() {
    return null;
};
_.getFeatureID_0 = function getFeatureID_2() {
    return -1;
};
_.getNotifier = function getNotifier_2() {
    return null;
};
_.hasInverse = function hasInverse_0() {
    return false;
};
_.hasShadow = function hasShadow() {
    return false;
};
_.inverseAdd = function inverseAdd_0(object, notifications) {
    return notifications;
};
_.inverseRemove = function inverseRemove_0(object, notifications) {
    return notifications;
};
_.isNotificationRequired = function isNotificationRequired_0() {
    return false;
};
_.isSet_0 = function isSet_0() {
    return this.size_0 != 0;
};
_.move = function move_4(targetIndex, sourceIndex) {
    return $move_1(this, targetIndex, sourceIndex);
};
_.remove_2 = function remove_105(index_0) {
    return $remove_35(this, index_0);
};
_.setUnique = function setUnique_2(index_0, object) {
    return $setUnique_1(this, index_0, object);
};
_.shadowAdd = function shadowAdd(object, notifications) {
    return notifications;
};
_.shadowRemove = function shadowRemove(object, notifications) {
    return notifications;
};
_.shadowSet = function shadowSet(oldObject, newObject, notifications) {
    return notifications;
};
var Lorg_eclipse_emf_common_notify_impl_NotifyingListImpl_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'NotifyingListImpl', 2037);
function NotifyingListImpl$1(this$0, $anonymous0, $anonymous1, $anonymous2, $anonymous3, $anonymous4) {
    this.this$01 = this$0;
    NotificationImpl_2.call(this, $anonymous0, $anonymous1, $anonymous2, $anonymous3, $anonymous4);
}
defineClass(1151, 150, $intern_144, NotifyingListImpl$1);
_.getFeature = function getFeature_3() {
    return this.this$01.getFeature();
};
_.getFeatureID = function getFeatureID_3(expectedClass) {
    return this.this$01.getFeatureID_0();
};
_.getNotifier = function getNotifier_3() {
    return this.this$01.getNotifier();
};
var Lorg_eclipse_emf_common_notify_impl_NotifyingListImpl$1_2_classLit = createForClass('org.eclipse.emf.common.notify.impl', 'NotifyingListImpl/1', 1151);
function AbstractEList$1(this$0, $anonymous0) {
    this.this$01 = this$0;
    BasicEList_0.call(this, $anonymous0);
}
defineClass(944, 66, $intern_140, AbstractEList$1);
_.contains = function contains_53(object) {
    if (this.size_0 > 10) {
        if (!this.set_0 || this.this$01.modCount != this.expectedModCount) {
            this.set_0 = new HashSet_1(this);
            this.expectedModCount = this.modCount;
        }
        return $contains_6(this.set_0, object);
    } else return $contains_10(this, object);
};
_.useEquals = function useEquals_0() {
    return true;
};
_.expectedModCount = 0;
var Lorg_eclipse_emf_common_util_AbstractEList$1_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList/1', 944);
function AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0) {
    IndexOutOfBoundsException_0.call(this, 'index=' + index_0 + ', size=' + size_0);
}
defineClass(301, 97, $intern_58, AbstractEList$BasicIndexOutOfBoundsException);
var Lorg_eclipse_emf_common_util_AbstractEList$BasicIndexOutOfBoundsException_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList/BasicIndexOutOfBoundsException', 301);
function $doNext(this$static) {
    var next;
    try {
        next = this$static.this$01_2.get_0(this$static.cursor);
        this$static.checkModCount();
        this$static.lastCursor = this$static.cursor++;
        return next;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) {
            this$static.checkModCount();
            throw toJs(new NoSuchElementException);
        } else throw toJs($e0);
    }
}
function $remove_36(this$static) {
    if (this$static.lastCursor == -1) throw toJs(new IllegalStateException);
    this$static.checkModCount();
    try {
        this$static.this$01_2.remove_2(this$static.lastCursor);
        this$static.expectedModCount = this$static.this$01_2.modCount;
        this$static.lastCursor < this$static.cursor && --this$static.cursor;
        this$static.lastCursor = -1;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) throw toJs(new ConcurrentModificationException);
        else throw toJs($e0);
    }
}
function AbstractEList$EIterator(this$0) {
    this.this$01_2 = this$0;
    this.expectedModCount = this.this$01_2.modCount;
}
defineClass(42, 1, $intern_6, AbstractEList$EIterator);
_.forEachRemaining = function forEachRemaining_54(consumer) {
    $forEachRemaining(this, consumer);
};
_.checkModCount = function checkModCount() {
    if (this.this$01_2.modCount != this.expectedModCount) throw toJs(new ConcurrentModificationException);
};
_.doNext = function doNext() {
    return $doNext(this);
};
_.hasNext_0 = function hasNext_43() {
    return this.cursor != this.this$01_2.size_1();
};
_.next_1 = function next_44() {
    return this.doNext();
};
_.remove = function remove_106() {
    $remove_36(this);
};
_.cursor = 0;
_.expectedModCount = 0;
_.lastCursor = -1;
var Lorg_eclipse_emf_common_util_AbstractEList$EIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList/EIterator', 42);
function $doAdd_0(this$static, object) {
    this$static.checkModCount();
    try {
        this$static.this$01_1.add_3(this$static.cursor++, object);
        this$static.expectedModCount = this$static.this$01_1.modCount;
        this$static.lastCursor = -1;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) throw toJs(new ConcurrentModificationException);
        else throw toJs($e0);
    }
}
function $doSet(this$static, object) {
    if (this$static.lastCursor == -1) throw toJs(new IllegalStateException);
    this$static.checkModCount();
    try {
        this$static.this$01_1.set_2(this$static.lastCursor, object);
        this$static.expectedModCount = this$static.this$01_1.modCount;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) throw toJs(new ConcurrentModificationException);
        else throw toJs($e0);
    }
}
function AbstractEList$EListIterator(this$0) {
    this.this$01_1 = this$0;
    AbstractEList$EIterator.call(this, this$0);
}
function AbstractEList$EListIterator_0(this$0, index_0) {
    this.this$01_1 = this$0;
    AbstractEList$EIterator.call(this, this$0);
    this.cursor = index_0;
}
defineClass(283, 42, $intern_14, AbstractEList$EListIterator, AbstractEList$EListIterator_0);
_.remove = function remove_107() {
    $remove_36(this);
};
_.add_1 = function add_51(object) {
    $doAdd_0(this, object);
};
_.doPrevious = function doPrevious() {
    var previous;
    try {
        previous = this.this$01_1.get_0(--this.cursor);
        this.checkModCount();
        this.lastCursor = this.cursor;
        return previous;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) {
            this.checkModCount();
            throw toJs(new NoSuchElementException);
        } else throw toJs($e0);
    }
};
_.doSet = function doSet(object) {
    $doSet(this, object);
};
_.hasPrevious = function hasPrevious_7() {
    return this.cursor != 0;
};
_.nextIndex_0 = function nextIndex_8() {
    return this.cursor;
};
_.previous_0 = function previous_8() {
    return this.doPrevious();
};
_.previousIndex = function previousIndex_7() {
    return this.cursor - 1;
};
_.set_1 = function set_22(object) {
    this.doSet(object);
};
var Lorg_eclipse_emf_common_util_AbstractEList$EListIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList/EListIterator', 283);
function $doNext_0(this$static) {
    var next;
    try {
        next = this$static.this$01_0.primitiveGet(this$static.cursor);
        this$static.checkModCount();
        this$static.lastCursor = this$static.cursor++;
        return next;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) {
            this$static.checkModCount();
            throw toJs(new NoSuchElementException);
        } else throw toJs($e0);
    }
}
function AbstractEList$NonResolvingEIterator(this$0) {
    this.this$01_0 = this$0;
    AbstractEList$EIterator.call(this, this$0);
}
defineClass(352, 42, $intern_6, AbstractEList$NonResolvingEIterator);
_.doNext = function doNext_0() {
    return $doNext_0(this);
};
_.remove = function remove_108() {
    throw toJs(new UnsupportedOperationException);
};
var Lorg_eclipse_emf_common_util_AbstractEList$NonResolvingEIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList/NonResolvingEIterator', 352);
function AbstractEList$NonResolvingEListIterator(this$0) {
    this.this$01_0 = this$0;
    AbstractEList$EListIterator.call(this, this$0);
}
function AbstractEList$NonResolvingEListIterator_0(this$0, index_0) {
    this.this$01_0 = this$0;
    AbstractEList$EListIterator_0.call(this, this$0, index_0);
}
defineClass(389, 283, $intern_14, AbstractEList$NonResolvingEListIterator, AbstractEList$NonResolvingEListIterator_0);
_.add_1 = function add_52(object) {
    throw toJs(new UnsupportedOperationException);
};
_.doNext = function doNext_1() {
    var next;
    try {
        next = this.this$01_0.primitiveGet(this.cursor);
        this.checkModCount();
        this.lastCursor = this.cursor++;
        return next;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) {
            this.checkModCount();
            throw toJs(new NoSuchElementException);
        } else throw toJs($e0);
    }
};
_.doPrevious = function doPrevious_0() {
    var previous;
    try {
        previous = this.this$01_0.primitiveGet(--this.cursor);
        this.checkModCount();
        this.lastCursor = this.cursor;
        return previous;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) {
            this.checkModCount();
            throw toJs(new NoSuchElementException);
        } else throw toJs($e0);
    }
};
_.remove = function remove_109() {
    throw toJs(new UnsupportedOperationException);
};
_.set_1 = function set_23(object) {
    throw toJs(new UnsupportedOperationException);
};
var Lorg_eclipse_emf_common_util_AbstractEList$NonResolvingEListIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'AbstractEList/NonResolvingEListIterator', 389);
function newInstance_11(componentType, size_0) {
    var helper;
    helper = castTo($get_10(($clinit_Reflect(), HELPER_REGISTRY), componentType), 58);
    return helper ? helper.newArrayInstance(size_0) : initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, size_0, 5, 1);
}
function $clinit_ArrayDelegatingEList() {
    $clinit_ArrayDelegatingEList = emptyMethod;
    EMPTY_ARRAY = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1);
}
function $assign_0(data_0, index_0, object) {
    setCheck(data_0, index_0, object);
    return object;
}
function $copy_0(this$static) {
    var data_0, newData;
    data_0 = castTo($getField(this$static.this$01, 4), 128);
    if (data_0 != null) {
        newData = initUnidimensionalArray(Lorg_eclipse_emf_common_notify_Adapter_2_classLit, $intern_145, 412, data_0.length, 0, 1);
        arraycopy(data_0, 0, newData, 0, data_0.length);
        return newData;
    } else return EMPTY_ARRAY;
}
function $grow(this$static, size_0) {
    var data_0, oldData;
    oldData = castTo($getField(this$static.this$01, 4), 128);
    data_0 = initUnidimensionalArray(Lorg_eclipse_emf_common_notify_Adapter_2_classLit, $intern_145, 412, size_0, 0, 1);
    oldData != null && arraycopy(oldData, 0, data_0, 0, oldData.length);
    return data_0;
}
function $remove_37(this$static, index_0) {
    var data_0, newData, oldObject, shifted, size_0;
    data_0 = castTo($getField(this$static.this$01, 4), 128);
    size_0 = data_0 == null ? 0 : data_0.length;
    if (index_0 >= size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    oldObject = data_0[index_0];
    if (size_0 == 1) newData = null;
    else {
        newData = initUnidimensionalArray(Lorg_eclipse_emf_common_notify_Adapter_2_classLit, $intern_145, 412, size_0 - 1, 0, 1);
        arraycopy(data_0, 0, newData, 0, index_0);
        shifted = size_0 - index_0 - 1;
        shifted > 0 && arraycopy(data_0, index_0 + 1, newData, index_0, shifted);
    }
    $setData(this$static, newData);
    $didRemove_0(this$static, index_0, oldObject);
    return oldObject;
}
defineClass(2026, 70, $intern_146);
_.addAllUnique = function addAllUnique_7(index_0, collection) {
    var currentIndex, data_0, growth, i, i0, object, objects, oldData, oldSize, shifted, size_0;
    growth = collection.size_1();
    if (growth != 0) {
        oldData = castTo($getField(this.this$01, 4), 128);
        oldSize = oldData == null ? 0 : oldData.length;
        size_0 = oldSize + growth;
        data_0 = $grow(this, size_0);
        shifted = oldSize - index_0;
        shifted > 0 && arraycopy(oldData, index_0, data_0, index_0 + growth, shifted);
        objects = collection.iterator_0();
        for(i0 = 0; i0 < growth; ++i0){
            object = objects.next_1();
            currentIndex = index_0 + i0;
            $assign_0(data_0, currentIndex, $validate(this, object));
        }
        $setData(this, data_0);
        for(i = 0; i < growth; ++i){
            object = data_0[index_0];
            this.didAdd(index_0, object);
            ++index_0;
        }
        return true;
    } else {
        ++this.modCount;
        return false;
    }
};
_.addAllUnique_0 = function addAllUnique_8(collection) {
    var data_0, data0, growth, i, i0, object, objects, oldSize, size_0;
    growth = collection.size_1();
    if (growth != 0) {
        oldSize = (data0 = castTo($getField(this.this$01, 4), 128), data0 == null ? 0 : data0.length);
        size_0 = oldSize + growth;
        data_0 = $grow(this, size_0);
        objects = collection.iterator_0();
        for(i0 = oldSize; i0 < size_0; ++i0){
            object = objects.next_1();
            $assign_0(data_0, i0, $validate(this, object));
        }
        $setData(this, data_0);
        for(i = oldSize; i < size_0; ++i){
            object = data_0[i];
            this.didAdd(i, object);
        }
        return true;
    } else {
        ++this.modCount;
        return false;
    }
};
_.addUnique = function addUnique_7(index_0, object) {
    var data_0, oldData, size_0, validatedObject;
    oldData = castTo($getField(this.this$01, 4), 128);
    size_0 = oldData == null ? 0 : oldData.length;
    data_0 = $grow(this, size_0 + 1);
    validatedObject = $validate(this, object);
    index_0 != size_0 && arraycopy(oldData, index_0, data_0, index_0 + 1, size_0 - index_0);
    setCheck(data_0, index_0, validatedObject);
    $setData(this, data_0);
    this.didAdd(index_0, object);
};
_.addUnique_0 = function addUnique_8(object) {
    var data_0, data0, size_0;
    size_0 = (data0 = castTo($getField(this.this$01, 4), 128), data0 == null ? 0 : data0.length);
    data_0 = $grow(this, size_0 + 1);
    $assign_0(data_0, size_0, $validate(this, object));
    $setData(this, data_0);
    this.didAdd(size_0, object);
};
_.basicIterator = function basicIterator_0() {
    return new ArrayDelegatingEList$NonResolvingEIterator(this);
};
_.basicListIterator = function basicListIterator_1() {
    return new ArrayDelegatingEList$NonResolvingEListIterator(this);
};
_.basicListIterator_0 = function basicListIterator_2(index_0) {
    var data_0, size_0;
    size_0 = (data_0 = castTo($getField(this.this$01, 4), 128), data_0 == null ? 0 : data_0.length);
    if (index_0 < 0 || index_0 > size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    return new ArrayDelegatingEList$NonResolvingEListIterator_0(this, index_0);
};
_.clear_0 = function clear_56() {
    var oldData, oldSize;
    ++this.modCount;
    oldData = castTo($getField(this.this$01, 4), 128);
    oldSize = oldData == null ? 0 : oldData.length;
    $setData(this, null);
    $didClear(this, oldSize, oldData);
};
_.contains = function contains_54(object) {
    var data_0, datum, datum$array, datum$index, datum$max;
    data_0 = castTo($getField(this.this$01, 4), 128);
    if (data_0 != null) {
        if (object != null) for(datum$array = data_0, datum$index = 0, datum$max = datum$array.length; datum$index < datum$max; ++datum$index){
            datum = datum$array[datum$index];
            if (equals_Ljava_lang_Object__Z__devirtual$(object, datum)) return true;
        }
        else for(datum$array = data_0, datum$index = 0, datum$max = datum$array.length; datum$index < datum$max; ++datum$index){
            datum = datum$array[datum$index];
            if (maskUndefined(datum) === maskUndefined(object)) return true;
        }
    }
    return false;
};
_.get_0 = function get_51(index_0) {
    var data_0, size_0;
    data_0 = castTo($getField(this.this$01, 4), 128);
    size_0 = data_0 == null ? 0 : data_0.length;
    if (index_0 >= size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    return data_0[index_0];
};
_.indexOf_0 = function indexOf_10(object) {
    var data_0, i, size_0;
    data_0 = castTo($getField(this.this$01, 4), 128);
    if (data_0 != null) {
        if (object != null) for(i = 0, size_0 = data_0.length; i < size_0; ++i){
            if (equals_Ljava_lang_Object__Z__devirtual$(object, data_0[i])) return i;
        }
        else for(i = 0, size_0 = data_0.length; i < size_0; ++i){
            if (maskUndefined(data_0[i]) === maskUndefined(object)) return i;
        }
    }
    return -1;
};
_.isEmpty = function isEmpty_28() {
    return castTo($getField(this.this$01, 4), 128) == null;
};
_.iterator_0 = function iterator_80() {
    return new ArrayDelegatingEList$EIterator(this);
};
_.listIterator_0 = function listIterator_19() {
    return new ArrayDelegatingEList$EListIterator(this);
};
_.listIterator_1 = function listIterator_20(index_0) {
    var data_0, size_0;
    size_0 = (data_0 = castTo($getField(this.this$01, 4), 128), data_0 == null ? 0 : data_0.length);
    if (index_0 < 0 || index_0 > size_0) throw toJs(new AbstractEList$BasicIndexOutOfBoundsException(index_0, size_0));
    return new ArrayDelegatingEList$EListIterator_0(this, index_0);
};
_.move = function move_5(targetIndex, sourceIndex) {
    var data_0, object, size_0;
    data_0 = $copy_0(this);
    size_0 = data_0 == null ? 0 : data_0.length;
    if (targetIndex >= size_0) throw toJs(new IndexOutOfBoundsException_0('targetIndex=' + targetIndex + ', size=' + size_0));
    if (sourceIndex >= size_0) throw toJs(new IndexOutOfBoundsException_0('sourceIndex=' + sourceIndex + ', size=' + size_0));
    object = data_0[sourceIndex];
    if (targetIndex != sourceIndex) {
        targetIndex < sourceIndex ? arraycopy(data_0, targetIndex, data_0, targetIndex + 1, sourceIndex - targetIndex) : arraycopy(data_0, sourceIndex + 1, data_0, sourceIndex, targetIndex - sourceIndex);
        setCheck(data_0, targetIndex, object);
        $setData(this, data_0);
    }
    return object;
};
_.primitiveGet = function primitiveGet_1(index_0) {
    return castTo($getField(this.this$01, 4), 128)[index_0];
};
_.remove_2 = function remove_110(index_0) {
    return $remove_37(this, index_0);
};
_.setUnique = function setUnique_3(index_0, object) {
    var data_0, oldObject;
    data_0 = $copy_0(this);
    oldObject = data_0[index_0];
    $assign_0(data_0, index_0, $validate(this, object));
    $setData(this, data_0);
    return oldObject;
};
_.size_1 = function size_68() {
    var data_0;
    return data_0 = castTo($getField(this.this$01, 4), 128), data_0 == null ? 0 : data_0.length;
};
_.toArray = function toArray_30() {
    var data_0, result, size_0;
    data_0 = castTo($getField(this.this$01, 4), 128);
    size_0 = data_0 == null ? 0 : data_0.length;
    result = initUnidimensionalArray(Lorg_eclipse_emf_common_notify_Adapter_2_classLit, $intern_145, 412, size_0, 0, 1);
    size_0 > 0 && arraycopy(data_0, 0, result, 0, size_0);
    return result;
};
_.toArray_0 = function toArray_31(array) {
    var data_0, newArray, size_0;
    data_0 = castTo($getField(this.this$01, 4), 128);
    size_0 = data_0 == null ? 0 : data_0.length;
    if (size_0 > 0) {
        if (array.length < size_0) {
            newArray = newInstance_11(getClass__Ljava_lang_Class___devirtual$(array).componentType, size_0);
            array = newArray;
        }
        arraycopy(data_0, 0, array, 0, size_0);
    }
    array.length > size_0 && setCheck(array, size_0, null);
    return array;
};
var EMPTY_ARRAY;
var Lorg_eclipse_emf_common_util_ArrayDelegatingEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'ArrayDelegatingEList', 2026);
function ArrayDelegatingEList$EIterator(this$0) {
    this.this$01 = this$0;
    AbstractEList$EIterator.call(this, this$0);
    this.expectedData = castTo($getField(this.this$01.this$01, 4), 128);
}
defineClass(1026, 42, $intern_6, ArrayDelegatingEList$EIterator);
_.checkModCount = function checkModCount_0() {
    if (this.this$01.modCount != this.expectedModCount || maskUndefined(castTo($getField(this.this$01.this$01, 4), 128)) !== maskUndefined(this.expectedData)) throw toJs(new ConcurrentModificationException);
};
_.remove = function remove_111() {
    $remove_36(this);
    this.expectedData = castTo($getField(this.this$01.this$01, 4), 128);
};
var Lorg_eclipse_emf_common_util_ArrayDelegatingEList$EIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'ArrayDelegatingEList/EIterator', 1026);
function $$init_9(this$static) {
    this$static.expectedData = castTo($getField(this$static.this$01.this$01, 4), 128);
}
function ArrayDelegatingEList$EListIterator(this$0) {
    this.this$01 = this$0;
    AbstractEList$EListIterator.call(this, this$0);
    $$init_9(this);
}
function ArrayDelegatingEList$EListIterator_0(this$0, index_0) {
    this.this$01 = this$0;
    AbstractEList$EListIterator_0.call(this, this$0, index_0);
    $$init_9(this);
}
defineClass(706, 283, $intern_14, ArrayDelegatingEList$EListIterator, ArrayDelegatingEList$EListIterator_0);
_.checkModCount = function checkModCount_1() {
    if (this.this$01.modCount != this.expectedModCount || maskUndefined(castTo($getField(this.this$01.this$01, 4), 128)) !== maskUndefined(this.expectedData)) throw toJs(new ConcurrentModificationException);
};
_.doSet = function doSet_0(object) {
    $doSet(this, object);
    this.expectedData = castTo($getField(this.this$01.this$01, 4), 128);
};
_.remove = function remove_112() {
    $remove_36(this);
    this.expectedData = castTo($getField(this.this$01.this$01, 4), 128);
};
var Lorg_eclipse_emf_common_util_ArrayDelegatingEList$EListIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'ArrayDelegatingEList/EListIterator', 706);
function ArrayDelegatingEList$NonResolvingEIterator(this$0) {
    this.this$01 = this$0;
    AbstractEList$NonResolvingEIterator.call(this, this$0);
    this.expectedData = castTo($getField(this.this$01.this$01, 4), 128);
}
defineClass(1027, 352, $intern_6, ArrayDelegatingEList$NonResolvingEIterator);
_.checkModCount = function checkModCount_2() {
    if (this.this$01.modCount != this.expectedModCount || maskUndefined(castTo($getField(this.this$01.this$01, 4), 128)) !== maskUndefined(this.expectedData)) throw toJs(new ConcurrentModificationException);
};
var Lorg_eclipse_emf_common_util_ArrayDelegatingEList$NonResolvingEIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'ArrayDelegatingEList/NonResolvingEIterator', 1027);
function $$init_10(this$static) {
    this$static.expectedData = castTo($getField(this$static.this$01.this$01, 4), 128);
}
function ArrayDelegatingEList$NonResolvingEListIterator(this$0) {
    this.this$01 = this$0;
    AbstractEList$NonResolvingEListIterator.call(this, this$0);
    $$init_10(this);
}
function ArrayDelegatingEList$NonResolvingEListIterator_0(this$0, index_0) {
    this.this$01 = this$0;
    AbstractEList$NonResolvingEListIterator_0.call(this, this$0, index_0);
    $$init_10(this);
}
defineClass(707, 389, $intern_14, ArrayDelegatingEList$NonResolvingEListIterator, ArrayDelegatingEList$NonResolvingEListIterator_0);
_.checkModCount = function checkModCount_3() {
    if (this.this$01.modCount != this.expectedModCount || maskUndefined(castTo($getField(this.this$01.this$01, 4), 128)) !== maskUndefined(this.expectedData)) throw toJs(new ConcurrentModificationException);
};
var Lorg_eclipse_emf_common_util_ArrayDelegatingEList$NonResolvingEListIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'ArrayDelegatingEList/NonResolvingEListIterator', 707);
function BasicEList$BasicIndexOutOfBoundsException(index_0, size_0) {
    AbstractEList$BasicIndexOutOfBoundsException.call(this, index_0, size_0);
}
defineClass(600, 301, $intern_58, BasicEList$BasicIndexOutOfBoundsException);
var Lorg_eclipse_emf_common_util_BasicEList$BasicIndexOutOfBoundsException_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEList/BasicIndexOutOfBoundsException', 600);
function BasicEList$UnmodifiableEList(size_0, data_0) {
    this.size_0 = size_0;
    this.data_0 = data_0;
}
defineClass(694, 66, $intern_140, BasicEList$UnmodifiableEList);
_.add_3 = function add_53(index_0, object) {
    throw toJs(new UnsupportedOperationException);
};
_.add_2 = function add_54(object) {
    throw toJs(new UnsupportedOperationException);
};
_.addAll_0 = function addAll_25(index_0, collection) {
    throw toJs(new UnsupportedOperationException);
};
_.addAll = function addAll_26(collection) {
    throw toJs(new UnsupportedOperationException);
};
_.clear_0 = function clear_57() {
    throw toJs(new UnsupportedOperationException);
};
_.grow = function grow_0(minimumCapacity) {
    throw toJs(new UnsupportedOperationException);
};
_.iterator_0 = function iterator_81() {
    return this.basicIterator();
};
_.listIterator_0 = function listIterator_21() {
    return this.basicListIterator();
};
_.listIterator_1 = function listIterator_22(index_0) {
    return this.basicListIterator_0(index_0);
};
_.move = function move_6(targetIndex, sourceIndex) {
    throw toJs(new UnsupportedOperationException);
};
_.move_0 = function move_7(index_0, object) {
    throw toJs(new UnsupportedOperationException);
};
_.remove_2 = function remove_113(index_0) {
    throw toJs(new UnsupportedOperationException);
};
_.remove_1 = function remove_114(object) {
    throw toJs(new UnsupportedOperationException);
};
_.set_2 = function set_24(index_0, object) {
    throw toJs(new UnsupportedOperationException);
};
var Lorg_eclipse_emf_common_util_BasicEList$UnmodifiableEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEList/UnmodifiableEList', 694);
function $add_24(this$static, index_0, object) {
    this$static.delegateEList.add_3(index_0, castTo(object, 135));
}
function $add_25(this$static, object) {
    return this$static.delegateEList.add_2(castTo(object, 135));
}
function $containsKey_7(this$static, key) {
    var entryIndex, hash, index_0;
    if (this$static.size_0 > 0) {
        this$static.ensureEntryDataExists();
        hash = key == null ? 0 : hashCode__I__devirtual$(key);
        index_0 = (hash & $intern_0) % this$static.entryData.length;
        entryIndex = $entryIndexForKey(this$static, index_0, hash, key);
        return entryIndex != -1;
    } else return false;
}
function $containsValue_4(this$static, value_0) {
    var eList, entries, entry, i, j, size_0;
    if (this$static.size_0 > 0) {
        this$static.ensureEntryDataExists();
        if (value_0 != null) for(i = 0; i < this$static.entryData.length; ++i){
            eList = this$static.entryData[i];
            if (eList) {
                entries = castTo(eList.data_0, 371);
                size_0 = eList.size_0;
                for(j = 0; j < size_0; ++j){
                    entry = entries[j];
                    if (equals_Ljava_lang_Object__Z__devirtual$(value_0, entry.getValue())) return true;
                }
            }
        }
        else for(i = 0; i < this$static.entryData.length; ++i){
            eList = this$static.entryData[i];
            if (eList) {
                entries = castTo(eList.data_0, 371);
                size_0 = eList.size_0;
                for(j = 0; j < size_0; ++j){
                    entry = entries[j];
                    if (maskUndefined(value_0) === maskUndefined(entry.getValue())) return true;
                }
            }
        }
    }
    return false;
}
function $didClear_0(oldEntryData) {
    var eList, i, j, size_0;
    if (oldEntryData != null) for(i = 0; i < oldEntryData.length; ++i){
        eList = oldEntryData[i];
        if (eList) {
            castTo(eList.data_0, 371);
            size_0 = eList.size_0;
            for(j = 0; j < size_0; ++j);
        }
    }
}
function $doClear_0(this$static) {
    var oldEntryData;
    if (this$static.entryData == null) {
        ++this$static.modCount;
        this$static.size_0 = 0;
        $didClear_0(null);
    } else {
        ++this$static.modCount;
        oldEntryData = this$static.entryData;
        this$static.entryData = null;
        this$static.size_0 = 0;
        $didClear_0(oldEntryData);
    }
}
function $doPut(this$static, entry) {
    var eList, hash, index_0;
    if (this$static.entryData == null) {
        ++this$static.modCount;
        ++this$static.size_0;
    } else {
        hash = entry.getHash();
        $grow_0(this$static, this$static.size_0 + 1);
        index_0 = (hash & $intern_0) % this$static.entryData.length;
        eList = this$static.entryData[index_0];
        !eList && (eList = this$static.entryData[index_0] = this$static.newList());
        eList.add_2(entry);
        ++this$static.size_0;
    }
}
function $doRemove(this$static, entry) {
    var hash, index_0, key;
    if (this$static.entryData == null) {
        ++this$static.modCount;
        --this$static.size_0;
    } else {
        key = entry.getKey();
        hash = entry.getHash();
        index_0 = (hash & $intern_0) % this$static.entryData.length;
        $removeEntry_0(this$static, index_0, $entryIndexForKey(this$static, index_0, hash, key));
    }
}
function $entryForKey(this$static, index_0, hash, key) {
    var eList, entries, entry, j, size_0;
    eList = this$static.entryData[index_0];
    if (eList) {
        entries = eList.data_0;
        size_0 = eList.size_0;
        if (key != null) for(j = 0; j < size_0; ++j){
            entry = castTo(entries[j], 135);
            if (entry.getHash() == hash && equals_Ljava_lang_Object__Z__devirtual$(key, entry.getKey())) return entry;
        }
        else for(j = 0; j < size_0; ++j){
            entry = castTo(entries[j], 135);
            if (maskUndefined(entry.getKey()) === maskUndefined(key)) return entry;
        }
    }
    return null;
}
function $entryIndexForKey(this$static, index_0, hash, key) {
    var eList, entries, entry, j, size_0;
    if (key != null) {
        eList = this$static.entryData[index_0];
        if (eList) {
            entries = eList.data_0;
            size_0 = eList.size_0;
            for(j = 0; j < size_0; ++j){
                entry = castTo(entries[j], 135);
                if (entry.getHash() == hash && equals_Ljava_lang_Object__Z__devirtual$(key, entry.getKey())) return j;
            }
        }
    } else {
        eList = this$static.entryData[index_0];
        if (eList) {
            entries = eList.data_0;
            size_0 = eList.size_0;
            for(j = 0; j < size_0; ++j){
                entry = castTo(entries[j], 135);
                if (maskUndefined(entry.getKey()) === maskUndefined(key)) return j;
            }
        }
    }
    return -1;
}
function $entrySet_3(this$static) {
    !this$static.view && (this$static.view = new BasicEMap$View);
    !this$static.view.entrySet && (this$static.view.entrySet = new BasicEMap$5(this$static));
    return this$static.view.entrySet;
}
function $equals_12(this$static, object) {
    return instanceOf(object, 15) && $equals_11(this$static.delegateEList, object);
}
function $get_21(this$static, key) {
    var entry, hash, index_0;
    if (this$static.size_0 > 0) {
        this$static.ensureEntryDataExists();
        hash = key == null ? 0 : hashCode__I__devirtual$(key);
        index_0 = (hash & $intern_0) % this$static.entryData.length;
        entry = $entryForKey(this$static, index_0, hash, key);
        if (entry) return entry.getValue();
    }
    return null;
}
function $grow_0(this$static, minimumCapacity) {
    var eList, entries, entry, i, index_0, j, oldCapacity, oldEList, oldEntryData, size_0;
    ++this$static.modCount;
    oldCapacity = this$static.entryData == null ? 0 : this$static.entryData.length;
    if (minimumCapacity > oldCapacity) {
        oldEntryData = this$static.entryData;
        this$static.entryData = initUnidimensionalArray(Lorg_eclipse_emf_common_util_BasicEList_2_classLit, $intern_147, 66, 2 * oldCapacity + 4, 0, 1);
        for(i = 0; i < oldCapacity; ++i){
            oldEList = oldEntryData[i];
            if (oldEList) {
                entries = oldEList.data_0;
                size_0 = oldEList.size_0;
                for(j = 0; j < size_0; ++j){
                    entry = castTo(entries[j], 135);
                    index_0 = $indexOf_5(this$static, entry.getHash());
                    eList = this$static.entryData[index_0];
                    !eList && (eList = this$static.entryData[index_0] = this$static.newList());
                    eList.add_2(entry);
                }
            }
        }
        return true;
    } else return false;
}
function $hashOf(key) {
    return key == null ? 0 : hashCode__I__devirtual$(key);
}
function $indexOf_5(this$static, hash) {
    return (hash & $intern_0) % this$static.entryData.length;
}
function $keySet_2(this$static) {
    !this$static.view && (this$static.view = new BasicEMap$View);
    !this$static.view.keySet && (this$static.view.keySet = new BasicEMap$3(this$static));
    return this$static.view.keySet;
}
function $map_0(this$static) {
    !this$static.view && (this$static.view = new BasicEMap$View);
    !this$static.view.map_0 && (this$static.view.map_0 = new BasicEMap$DelegatingMap(this$static));
    return this$static.view.map_0;
}
function $move_2(this$static, index_0, object) {
    this$static.delegateEList.move_0(index_0, castTo(object, 135));
}
function $put_14(this$static, key, value_0) {
    var entry, entry0, hash, index_0, result;
    this$static.ensureEntryDataExists();
    hash = key == null ? 0 : hashCode__I__devirtual$(key);
    if (this$static.size_0 > 0) {
        index_0 = (hash & $intern_0) % this$static.entryData.length;
        entry0 = $entryForKey(this$static, index_0, hash, key);
        if (entry0) {
            result = entry0.setValue(value_0);
            return result;
        }
    }
    entry = this$static.newEntry(hash, key, value_0);
    this$static.delegateEList.add_2(entry);
    return null;
}
function $putAll_1(this$static, map_0) {
    var entry, entry$iterator;
    for(entry$iterator = map_0.entrySet_0().iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 43);
        $put_14(this$static, entry.getKey(), entry.getValue());
    }
}
function $remove_38(this$static, object) {
    var result;
    if (instanceOf(object, 43)) return this$static.delegateEList.remove_1(object);
    else {
        result = $containsKey_7(this$static, object);
        $removeKey(this$static, object);
        return result;
    }
}
function $removeEntry_0(this$static, index_0, entryIndex) {
    var entry;
    ++this$static.modCount;
    --this$static.size_0;
    entry = castTo(this$static.entryData[index_0].remove_2(entryIndex), 135);
    return entry.getValue();
}
function $removeKey(this$static, key) {
    var entry, hash, index_0;
    this$static.ensureEntryDataExists();
    hash = key == null ? 0 : hashCode__I__devirtual$(key);
    index_0 = (hash & $intern_0) % this$static.entryData.length;
    entry = $entryForKey(this$static, index_0, hash, key);
    if (entry) {
        $remove_38(this$static, entry);
        return entry.getValue();
    } else return null;
}
function $set_10(this$static, index_0, object) {
    return castTo(this$static.delegateEList.set_2(index_0, castTo(object, 135)), 43);
}
function $values_3(this$static) {
    !this$static.view && (this$static.view = new BasicEMap$View);
    !this$static.view.values && (this$static.view.values = new BasicEMap$4(this$static));
    return this$static.view.values;
}
defineClass(705, 1, {
    3: 1,
    20: 1,
    16: 1,
    15: 1,
    61: 1,
    581: 1
});
_.add_3 = function add_55(index_0, object) {
    $add_24(this, index_0, castTo(object, 43));
};
_.add_2 = function add_56(object) {
    return $add_25(this, castTo(object, 43));
};
_.forEach_0 = function forEach_37(action) {
    $forEach_0(this, action);
};
_.get_0 = function get_52(index_0) {
    return castTo($get_20(this.delegateEList, index_0), 135);
};
_.move = function move_8(targetIndex, sourceIndex) {
    return castTo(this.delegateEList.move(targetIndex, sourceIndex), 43);
};
_.move_0 = function move_9(index_0, object) {
    $move_2(this, index_0, castTo(object, 43));
};
_.remove_2 = function remove_115(index_0) {
    return castTo(this.delegateEList.remove_2(index_0), 43);
};
_.set_2 = function set_25(index_0, object) {
    return $set_10(this, index_0, castTo(object, 43));
};
_.sort_0 = function sort_13(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_38() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.stream = function stream_7() {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(this, 16));
};
_.addAll_0 = function addAll_27(index_0, collection) {
    return this.delegateEList.addAll_0(index_0, collection);
};
_.addAll = function addAll_28(collection) {
    return this.delegateEList.addAll(collection);
};
_.clear_0 = function clear_58() {
    this.delegateEList.clear_0();
};
_.contains = function contains_55(object) {
    return this.delegateEList.contains(object);
};
_.containsAll = function containsAll_12(collection) {
    return $containsAll(this.delegateEList, collection);
};
_.ensureEntryDataExists = function ensureEntryDataExists() {
    var entry, entry$iterator, oldModCount;
    if (this.entryData == null) {
        this.entryData = initUnidimensionalArray(Lorg_eclipse_emf_common_util_BasicEList_2_classLit, $intern_147, 66, 2 * this.size_0 + 1, 0, 1);
        oldModCount = this.modCount;
        this.size_0 = 0;
        for(entry$iterator = this.delegateEList.iterator_0(); entry$iterator.cursor != entry$iterator.this$01_2.size_1();){
            entry = castTo(entry$iterator.doNext(), 135);
            $doPut(this, entry);
        }
        this.modCount = oldModCount;
    }
};
_.equals_0 = function equals_210(object) {
    return $equals_12(this, object);
};
_.hashCode_1 = function hashCode_77() {
    return $hashCode_4(this.delegateEList);
};
_.indexOf_0 = function indexOf_11(object) {
    return this.delegateEList.indexOf_0(object);
};
_.initializeDelegateEList = function initializeDelegateEList() {
    this.delegateEList = new BasicEMap$1(this);
};
_.isEmpty = function isEmpty_29() {
    return this.size_0 == 0;
};
_.iterator_0 = function iterator_82() {
    return this.delegateEList.iterator_0();
};
_.listIterator_0 = function listIterator_23() {
    return this.delegateEList.listIterator_0();
};
_.listIterator_1 = function listIterator_24(index_0) {
    return this.delegateEList.listIterator_1(index_0);
};
_.map_2 = function map_5() {
    return $map_0(this);
};
_.newEntry = function newEntry_0(hash, key, value_0) {
    return new BasicEMap$EntryImpl(hash, key, value_0);
};
_.newList = function newList() {
    return new BasicEMap$2;
};
_.remove_1 = function remove_116(object) {
    return $remove_38(this, object);
};
_.size_1 = function size_69() {
    return this.size_0;
};
_.subList = function subList_10(start_0, end) {
    return new AbstractList$SubList(this.delegateEList, start_0, end);
};
_.toArray = function toArray_32() {
    return this.delegateEList.toArray();
};
_.toArray_0 = function toArray_33(array) {
    return this.delegateEList.toArray_0(array);
};
_.toString_0 = function toString_136() {
    return $toString_25(this.delegateEList);
};
_.modCount = 0;
_.size_0 = 0;
var Lorg_eclipse_emf_common_util_BasicEMap_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap', 705);
function $didAdd(this$static, newObject) {
    $doPut(this$static.this$01, newObject);
}
function $didRemove(this$static, oldObject) {
    $doRemove(this$static.this$01, oldObject);
}
function $didSet(this$static, newObject, oldObject) {
    $doRemove(this$static.this$01, oldObject);
    $doPut(this$static.this$01, newObject);
}
function BasicEMap$1(this$0) {
    this.this$01 = this$0;
}
defineClass(1021, 66, $intern_140, BasicEMap$1);
_.didAdd = function didAdd_0(index_0, newObject) {
    $didAdd(this, castTo(newObject, 135));
};
_.didMove = function didMove_0(index_0, movedObject, oldIndex) {
    var lastArg;
    ++(lastArg = this, castTo(movedObject, 135), lastArg).this$01.modCount;
};
_.didRemove = function didRemove_0(index_0, oldObject) {
    $didRemove(this, castTo(oldObject, 135));
};
_.didSet = function didSet_0(index_0, newObject, oldObject) {
    $didSet(this, castTo(newObject, 135), castTo(oldObject, 135));
};
_.didClear = function didClear_0(size_0, oldObjects) {
    $doClear_0(this.this$01);
};
var Lorg_eclipse_emf_common_util_BasicEMap$1_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/1', 1021);
function BasicEMap$2() {}
defineClass(1022, 66, $intern_140, BasicEMap$2);
_.newData = function newData_2(listCapacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_util_BasicEMap$EntryImpl_2_classLit, $intern_148, 606, listCapacity, 0, 1);
};
var Lorg_eclipse_emf_common_util_BasicEMap$2_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/2', 1022);
function BasicEMap$3(this$0) {
    this.this$01 = this$0;
}
defineClass(1023, $intern_9, $intern_10, BasicEMap$3);
_.clear_0 = function clear_59() {
    this.this$01.delegateEList.clear_0();
};
_.contains = function contains_56(key) {
    return $containsKey_7(this.this$01, key);
};
_.iterator_0 = function iterator_83() {
    return this.this$01.size_0 == 0 ? ($clinit_ECollections(), EMPTY_ELIST.listIterator) : new BasicEMap$BasicEMapKeyIterator(this.this$01);
};
_.remove_1 = function remove_117(key) {
    var oldSize;
    oldSize = this.this$01.size_0;
    $removeKey(this.this$01, key);
    return this.this$01.size_0 != oldSize;
};
_.size_1 = function size_70() {
    return this.this$01.size_0;
};
var Lorg_eclipse_emf_common_util_BasicEMap$3_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/3', 1023);
function BasicEMap$4(this$0) {
    this.this$01 = this$0;
}
defineClass($intern_149, 31, $intern_8, BasicEMap$4);
_.clear_0 = function clear_60() {
    this.this$01.delegateEList.clear_0();
};
_.contains = function contains_57(value_0) {
    return $containsValue_4(this.this$01, value_0);
};
_.iterator_0 = function iterator_84() {
    return this.this$01.size_0 == 0 ? ($clinit_ECollections(), EMPTY_ELIST.listIterator) : new BasicEMap$BasicEMapValueIterator(this.this$01);
};
_.size_1 = function size_71() {
    return this.this$01.size_0;
};
var Lorg_eclipse_emf_common_util_BasicEMap$4_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/4', $intern_149);
function $remove_39(this$static, object) {
    var eList, entries, entry, hash, index_0, j, key, otherEntry, size_0;
    if (this$static.this$01.size_0 > 0 && instanceOf(object, 43)) {
        this$static.this$01.ensureEntryDataExists();
        otherEntry = castTo(object, 43);
        key = otherEntry.getKey();
        hash = key == null ? 0 : hashCode__I__devirtual$(key);
        index_0 = $indexOf_5(this$static.this$01, hash);
        eList = this$static.this$01.entryData[index_0];
        if (eList) {
            entries = castTo(eList.data_0, 371);
            size_0 = eList.size_0;
            for(j = 0; j < size_0; ++j){
                entry = entries[j];
                if (entry.getHash() == hash && entry.equals_0(otherEntry)) {
                    $remove_39(this$static, otherEntry);
                    return true;
                }
            }
        }
    }
    return false;
}
function BasicEMap$5(this$0) {
    this.this$01 = this$0;
}
defineClass(1025, $intern_9, $intern_10, BasicEMap$5);
_.clear_0 = function clear_61() {
    this.this$01.delegateEList.clear_0();
};
_.contains = function contains_58(object) {
    var eList, entries, entry, hash, index_0, j, key, otherEntry, size_0;
    if (this.this$01.size_0 > 0 && instanceOf(object, 43)) {
        this.this$01.ensureEntryDataExists();
        otherEntry = castTo(object, 43);
        key = otherEntry.getKey();
        hash = key == null ? 0 : hashCode__I__devirtual$(key);
        index_0 = $indexOf_5(this.this$01, hash);
        eList = this.this$01.entryData[index_0];
        if (eList) {
            entries = castTo(eList.data_0, 371);
            size_0 = eList.size_0;
            for(j = 0; j < size_0; ++j){
                entry = entries[j];
                if (entry.getHash() == hash && entry.equals_0(otherEntry)) return true;
            }
        }
    }
    return false;
};
_.iterator_0 = function iterator_85() {
    return this.this$01.size_0 == 0 ? ($clinit_ECollections(), EMPTY_ELIST.listIterator) : new BasicEMap$BasicEMapIterator(this.this$01);
};
_.remove_1 = function remove_118(object) {
    return $remove_39(this, object);
};
_.size_1 = function size_72() {
    return this.this$01.size_0;
};
var Lorg_eclipse_emf_common_util_BasicEMap$5_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/5', 1025);
function $scan(this$static) {
    var eList;
    this$static.this$01.ensureEntryDataExists();
    if (this$static.entryCursor != -1) {
        ++this$static.entryCursor;
        eList = this$static.this$01.entryData[this$static.cursor];
        if (this$static.entryCursor < eList.size_0) return;
        ++this$static.cursor;
    }
    for(; this$static.cursor < this$static.this$01.entryData.length; ++this$static.cursor){
        eList = this$static.this$01.entryData[this$static.cursor];
        if (!!eList && eList.size_0 != 0) {
            this$static.entryCursor = 0;
            return;
        }
    }
    this$static.entryCursor = -1;
}
function BasicEMap$BasicEMapIterator(this$0) {
    this.this$01 = this$0;
    this.expectedModCount = this.this$01.modCount;
    this$0.size_0 > 0 && $scan(this);
}
defineClass(607, 1, $intern_6, BasicEMap$BasicEMapIterator);
_.forEachRemaining = function forEachRemaining_55(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_44() {
    return this.entryCursor != -1;
};
_.next_1 = function next_45() {
    var result;
    if (this.this$01.modCount != this.expectedModCount) throw toJs(new ConcurrentModificationException);
    if (this.entryCursor == -1) throw toJs(new NoSuchElementException);
    this.lastCursor = this.cursor;
    this.lastEntryCursor = this.entryCursor;
    $scan(this);
    result = castTo(this.this$01.entryData[this.lastCursor].data_0[this.lastEntryCursor], 135);
    return this.yield_0(result);
};
_.remove = function remove_119() {
    if (this.this$01.modCount != this.expectedModCount) throw toJs(new ConcurrentModificationException);
    if (this.lastEntryCursor == -1) throw toJs(new IllegalStateException);
    this.this$01.delegateEList.remove_1($get_20(this.this$01.entryData[this.lastCursor], this.lastEntryCursor));
    this.expectedModCount = this.this$01.modCount;
    this.lastEntryCursor = -1;
    this.cursor == this.lastCursor && this.entryCursor != -1 && --this.entryCursor;
};
_.yield_0 = function yield_0(entry) {
    return entry;
};
_.cursor = 0;
_.entryCursor = -1;
_.expectedModCount = 0;
_.lastCursor = 0;
_.lastEntryCursor = 0;
var Lorg_eclipse_emf_common_util_BasicEMap$BasicEMapIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/BasicEMapIterator', 607);
function BasicEMap$BasicEMapKeyIterator(this$0) {
    BasicEMap$BasicEMapIterator.call(this, this$0);
}
defineClass(1019, 607, $intern_6, BasicEMap$BasicEMapKeyIterator);
_.yield_0 = function yield_1(entry) {
    return entry.getKey();
};
var Lorg_eclipse_emf_common_util_BasicEMap$BasicEMapKeyIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/BasicEMapKeyIterator', 1019);
function BasicEMap$BasicEMapValueIterator(this$0) {
    BasicEMap$BasicEMapIterator.call(this, this$0);
}
defineClass(1020, 607, $intern_6, BasicEMap$BasicEMapValueIterator);
_.yield_0 = function yield_2(entry) {
    return entry.getValue();
};
var Lorg_eclipse_emf_common_util_BasicEMap$BasicEMapValueIterator_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/BasicEMapValueIterator', 1020);
function $containsKey_8(this$static, key) {
    return $containsKey_7(this$static.this$01, key);
}
function BasicEMap$DelegatingMap(this$0) {
    this.this$01 = this$0;
}
defineClass(1018, 1, $intern_7, BasicEMap$DelegatingMap);
_.forEach = function forEach_38(consumer) {
    $forEach_2(this, consumer);
};
_.clear_0 = function clear_62() {
    this.this$01.delegateEList.clear_0();
};
_.containsKey = function containsKey_15(key) {
    return $containsKey_8(this, key);
};
_.containsValue = function containsValue_8(value_0) {
    return $containsValue_4(this.this$01, value_0);
};
_.entrySet_0 = function entrySet_10() {
    return $entrySet_3(this.this$01);
};
_.equals_0 = function equals_211(object) {
    return $equals_12(this.this$01, object);
};
_.get_3 = function get_53(key) {
    return $get_21(this.this$01, key);
};
_.hashCode_1 = function hashCode_78() {
    return $hashCode_4(this.this$01.delegateEList);
};
_.isEmpty = function isEmpty_30() {
    return this.this$01.size_0 == 0;
};
_.keySet_0 = function keySet_19() {
    return $keySet_2(this.this$01);
};
_.put = function put_11(key, value_0) {
    return $put_14(this.this$01, key, value_0);
};
_.remove_0 = function remove_120(key) {
    return $removeKey(this.this$01, key);
};
_.size_1 = function size_73() {
    return this.this$01.size_0;
};
_.toString_0 = function toString_137() {
    return $toString_25(this.this$01.delegateEList);
};
_.values_0 = function values_123() {
    return $values_3(this.this$01);
};
var Lorg_eclipse_emf_common_util_BasicEMap$DelegatingMap_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/DelegatingMap', 1018);
function BasicEMap$EntryImpl(hash, key, value_0) {
    this.hash = hash;
    this.key = key;
    this.value_0 = value_0;
}
defineClass(606, 1, {
    43: 1,
    135: 1,
    606: 1
}, BasicEMap$EntryImpl);
_.equals_0 = function equals_212(object) {
    var entry;
    if (instanceOf(object, 43)) {
        entry = castTo(object, 43);
        return (this.key != null ? equals_Ljava_lang_Object__Z__devirtual$(this.key, entry.getKey()) : maskUndefined(this.key) === maskUndefined(entry.getKey())) && (this.value_0 != null ? equals_Ljava_lang_Object__Z__devirtual$(this.value_0, entry.getValue()) : maskUndefined(this.value_0) === maskUndefined(entry.getValue()));
    } else return false;
};
_.getHash = function getHash_0() {
    return this.hash;
};
_.getKey = function getKey_9() {
    return this.key;
};
_.getValue = function getValue_11() {
    return this.value_0;
};
_.hashCode_1 = function hashCode_79() {
    return this.hash ^ (this.value_0 == null ? 0 : hashCode__I__devirtual$(this.value_0));
};
_.setHash = function setHash_0(hash) {
    this.hash = hash;
};
_.setKey = function setKey_0(key) {
    throw toJs(new RuntimeException);
};
_.setValue = function setValue_12(value_0) {
    var oldValue;
    oldValue = this.value_0;
    this.value_0 = value_0;
    return oldValue;
};
_.toString_0 = function toString_138() {
    return this.key + '->' + this.value_0;
};
_.hash = 0;
var Lorg_eclipse_emf_common_util_BasicEMap$EntryImpl_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/EntryImpl', 606);
function BasicEMap$View() {}
defineClass(531, 1, {}, BasicEMap$View);
var Lorg_eclipse_emf_common_util_BasicEMap$View_2_classLit = createForClass('org.eclipse.emf.common.util', 'BasicEMap/View', 531);
function $clinit_ECollections() {
    $clinit_ECollections = emptyMethod;
    EMPTY_ELIST = new ECollections$EmptyUnmodifiableEList;
    new ECollections$EmptyUnmodifiableEMap;
}
function indexOf_12(list, o, fromIndex) {
    var element, i, size_0;
    fromIndex < 0 && (fromIndex = 0);
    size_0 = list.size_0;
    for(i = fromIndex; i < size_0; i++){
        element = $get_20(list, i);
        if (o == null) {
            if (element == null) return i;
        } else if (maskUndefined(o) === maskUndefined(element) || equals_Ljava_lang_Object__Z__devirtual$(o, element)) return i;
    }
    return -1;
}
function sort_14(list, comparator) {
    $clinit_ECollections();
    var i, listAsArray, objectComparator, oldIndex;
    listAsArray = $toArray_10(list);
    objectComparator = comparator;
    mergeSort(listAsArray, 0, listAsArray.length, objectComparator);
    for(i = 0; i < listAsArray.length; i++){
        oldIndex = indexOf_12(list, listAsArray[i], i);
        i != oldIndex && $move_1(list, i, oldIndex);
    }
}
var EMPTY_ELIST;
function $add_26() {
    throw toJs(new UnsupportedOperationException);
}
function $add_27() {
    throw toJs(new UnsupportedOperationException);
}
function $addAll_10() {
    throw toJs(new UnsupportedOperationException);
}
function $addAll_11() {
    throw toJs(new UnsupportedOperationException);
}
function $clear_14() {
    throw toJs(new UnsupportedOperationException);
}
function $move_3() {
    throw toJs(new UnsupportedOperationException);
}
function $move_4() {
    throw toJs(new UnsupportedOperationException);
}
function $remove_40() {
    throw toJs(new UnsupportedOperationException);
}
function $remove_41() {
    throw toJs(new UnsupportedOperationException);
}
function $set_11() {
    throw toJs(new UnsupportedOperationException);
}
function ECollections$BasicEmptyUnmodifiableEList() {
    this.listIterator = new ECollections$BasicEmptyUnmodifiableEList$1;
}
defineClass(763, 1, {});
_.equals_0 = function equals_213(o) {
    return $equals_2(($clinit_Collections(), EMPTY_LIST), o);
};
_.hashCode_1 = function hashCode_80() {
    return hashCode_49(($clinit_Collections(), EMPTY_LIST));
};
_.toString_0 = function toString_139() {
    return $toString_2(($clinit_Collections(), EMPTY_LIST));
};
var Lorg_eclipse_emf_common_util_ECollections$BasicEmptyUnmodifiableEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'ECollections/BasicEmptyUnmodifiableEList', 763);
function ECollections$BasicEmptyUnmodifiableEList$1() {}
defineClass(1287, 1, $intern_14, ECollections$BasicEmptyUnmodifiableEList$1);
_.forEachRemaining = function forEachRemaining_56(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_57(o) {
    throw toJs(new UnsupportedOperationException);
};
_.hasNext_0 = function hasNext_45() {
    return false;
};
_.hasPrevious = function hasPrevious_8() {
    return false;
};
_.next_1 = function next_46() {
    throw toJs(new NoSuchElementException);
};
_.nextIndex_0 = function nextIndex_9() {
    return 0;
};
_.previous_0 = function previous_9() {
    throw toJs(new NoSuchElementException);
};
_.previousIndex = function previousIndex_8() {
    return -1;
};
_.remove = function remove_121() {
    throw toJs(new UnsupportedOperationException);
};
_.set_1 = function set_26(o) {
    throw toJs(new UnsupportedOperationException);
};
var Lorg_eclipse_emf_common_util_ECollections$BasicEmptyUnmodifiableEList$1_2_classLit = createForClass('org.eclipse.emf.common.util', 'ECollections/BasicEmptyUnmodifiableEList/1', 1287);
function ECollections$EmptyUnmodifiableEList() {
    ECollections$BasicEmptyUnmodifiableEList.call(this);
}
defineClass(1285, 763, {
    20: 1,
    16: 1,
    15: 1,
    61: 1
}, ECollections$EmptyUnmodifiableEList);
_.add_3 = function add_58(index_0, element) {
    $add_26();
};
_.add_2 = function add_59(o) {
    return $add_27();
};
_.addAll_0 = function addAll_29(index_0, collection) {
    return $addAll_10();
};
_.addAll = function addAll_30(coll) {
    return $addAll_11();
};
_.clear_0 = function clear_63() {
    $clear_14();
};
_.contains = function contains_59(o) {
    return false;
};
_.containsAll = function containsAll_13(coll) {
    return false;
};
_.forEach_0 = function forEach_39(action) {
    $forEach_0(this, action);
};
_.get_0 = function get_54(index_0) {
    return $get_13(($clinit_Collections(), EMPTY_LIST, index_0)), null;
};
_.indexOf_0 = function indexOf_13(o) {
    return -1;
};
_.isEmpty = function isEmpty_31() {
    return true;
};
_.iterator_0 = function iterator_86() {
    return this.listIterator;
};
_.listIterator_0 = function listIterator_25() {
    return this.listIterator;
};
_.listIterator_1 = function listIterator_26(index_0) {
    return this.listIterator;
};
_.move = function move_10(newPosition, oldPosition) {
    return $move_3();
};
_.move_0 = function move_11(newPosition, o) {
    $move_4();
};
_.remove_2 = function remove_122(index_0) {
    return $remove_40();
};
_.remove_1 = function remove_123(o) {
    return $remove_41();
};
_.set_2 = function set_27(index_0, element) {
    return $set_11();
};
_.size_1 = function size_74() {
    return 0;
};
_.sort_0 = function sort_15(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_39() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.stream = function stream_8() {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(this, 16));
};
_.subList = function subList_11(fromIndex, toIndex) {
    return $clinit_Collections(), new AbstractList$SubList(EMPTY_LIST, fromIndex, toIndex);
};
_.toArray = function toArray_34() {
    return $toArray(($clinit_Collections(), EMPTY_LIST));
};
_.toArray_0 = function toArray_35(a) {
    return $clinit_Collections(), $toArray_0(EMPTY_LIST, a);
};
var Lorg_eclipse_emf_common_util_ECollections$EmptyUnmodifiableEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'ECollections/EmptyUnmodifiableEList', 1285);
function ECollections$EmptyUnmodifiableEMap() {
    ECollections$BasicEmptyUnmodifiableEList.call(this);
}
defineClass(1286, 763, {
    20: 1,
    16: 1,
    15: 1,
    61: 1,
    581: 1
}, ECollections$EmptyUnmodifiableEMap);
_.add_3 = function add_60(index_0, element) {
    $add_26();
};
_.add_2 = function add_61(o) {
    return $add_27();
};
_.addAll_0 = function addAll_31(index_0, collection) {
    return $addAll_10();
};
_.addAll = function addAll_32(coll) {
    return $addAll_11();
};
_.clear_0 = function clear_64() {
    $clear_14();
};
_.contains = function contains_60(o) {
    return false;
};
_.containsAll = function containsAll_14(coll) {
    return false;
};
_.forEach_0 = function forEach_40(action) {
    $forEach_0(this, action);
};
_.get_0 = function get_55(index_0) {
    return $get_13(($clinit_Collections(), EMPTY_LIST, index_0)), null;
};
_.indexOf_0 = function indexOf_14(o) {
    return -1;
};
_.isEmpty = function isEmpty_32() {
    return true;
};
_.iterator_0 = function iterator_87() {
    return this.listIterator;
};
_.listIterator_0 = function listIterator_27() {
    return this.listIterator;
};
_.listIterator_1 = function listIterator_28(index_0) {
    return this.listIterator;
};
_.move = function move_12(newPosition, oldPosition) {
    return $move_3();
};
_.move_0 = function move_13(newPosition, o) {
    $move_4();
};
_.remove_2 = function remove_124(index_0) {
    return $remove_40();
};
_.remove_1 = function remove_125(o) {
    return $remove_41();
};
_.set_2 = function set_28(index_0, element) {
    return $set_11();
};
_.size_1 = function size_75() {
    return 0;
};
_.sort_0 = function sort_16(c) {
    $sort_0(this, c);
};
_.spliterator_0 = function spliterator_40() {
    return new Spliterators$IteratorSpliterator(this, 16);
};
_.stream = function stream_9() {
    return new StreamImpl(null, new Spliterators$IteratorSpliterator(this, 16));
};
_.subList = function subList_12(fromIndex, toIndex) {
    return $clinit_Collections(), new AbstractList$SubList(EMPTY_LIST, fromIndex, toIndex);
};
_.toArray = function toArray_36() {
    return $toArray(($clinit_Collections(), EMPTY_LIST));
};
_.toArray_0 = function toArray_37(a) {
    return $clinit_Collections(), $toArray_0(EMPTY_LIST, a);
};
_.map_2 = function map_6() {
    return $clinit_Collections(), $clinit_Collections(), EMPTY_MAP;
};
var Lorg_eclipse_emf_common_util_ECollections$EmptyUnmodifiableEMap_2_classLit = createForClass('org.eclipse.emf.common.util', 'ECollections/EmptyUnmodifiableEMap', 1286);
var Lorg_eclipse_emf_common_util_Enumerator_2_classLit = createForInterface('org.eclipse.emf.common.util', 'Enumerator');
function $clinit_Reflect() {
    $clinit_Reflect = emptyMethod;
    HELPER_REGISTRY = new HashMap;
}
function isInstance(class_, instance) {
    $clinit_Reflect();
    var helper;
    helper = castTo($get_10(HELPER_REGISTRY, class_), 58);
    return !helper || helper.isInstance(instance);
}
function register_0(class_, helper) {
    $clinit_Reflect();
    $put_6(HELPER_REGISTRY, class_, helper);
}
var HELPER_REGISTRY;
function $clinit_URI() {
    $clinit_URI = emptyMethod;
    var set_0;
    uriCache = new URI$URICache;
    NO_SEGMENTS = initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, 0, 6, 1);
    ALPHA_HI = or_0(lowBitmask_0(33, 58), lowBitmask_0(1, 26));
    ALPHA_LO = or_0(lowBitmask_0(97, 122), lowBitmask_0(65, 90));
    DIGIT_LO = lowBitmask_0(48, 57);
    ALPHANUM_HI = or_0(ALPHA_HI, 0);
    ALPHANUM_LO = or_0(ALPHA_LO, DIGIT_LO);
    HEX_HI = or_0(or_0(0, lowBitmask_0(1, 6)), lowBitmask_0(33, 38));
    HEX_LO = or_0(or_0(DIGIT_LO, lowBitmask_0(65, 70)), lowBitmask_0(97, 102));
    UNRESERVED_HI = or_0(ALPHANUM_HI, highBitmask_0("-_.!~*'()"));
    UNRESERVED_LO = or_0(ALPHANUM_LO, lowBitmask_1("-_.!~*'()"));
    highBitmask_0(';/?:@&=+$,');
    lowBitmask_1(';/?:@&=+$,');
    or_0(UNRESERVED_HI, highBitmask_0(';:@&=+$,'));
    or_0(UNRESERVED_LO, lowBitmask_1(';:@&=+$,'));
    MAJOR_SEPARATOR_HI = highBitmask_0(':/?#');
    MAJOR_SEPARATOR_LO = lowBitmask_1(':/?#');
    SEGMENT_END_HI = highBitmask_0('/?#');
    SEGMENT_END_LO = lowBitmask_1('/?#');
    set_0 = new HashSet;
    set_0.map_0.put('jar', set_0);
    set_0.map_0.put('zip', set_0);
    set_0.map_0.put('archive', set_0);
    archiveSchemes = ($clinit_Collections(), new Collections$UnmodifiableSet(set_0));
}
function $appendFragment(this$static, fragment) {
    var result;
    result = new URI((this$static.hashCode_0 & 256) != 0, this$static.scheme, this$static.authority, this$static.device, (this$static.hashCode_0 & 16) != 0, this$static.segments, this$static.query, fragment);
    this$static.fragment != null || (result.cachedTrimFragment = this$static);
    return result;
}
function $segmentsEqual(this$static, uri_0) {
    var i, len;
    if (this$static.segments.length != uri_0.segments.length) return false;
    for(i = 0, len = this$static.segments.length; i < len; i++){
        if (!$equals_5(this$static.segments[i], uri_0.segments[i])) return false;
    }
    return true;
}
function $toString_26(this$static) {
    var i, len, result;
    if (this$static.cachedToString == null) {
        result = new StringBuffer;
        if (this$static.scheme != null) {
            $append_3(result, this$static.scheme);
            result.string += ':';
        }
        if ((this$static.hashCode_0 & 256) != 0) {
            if ((this$static.hashCode_0 & 256) != 0 && this$static.authority != null) {
                isArchiveScheme(this$static.scheme) || (result.string += '//', result);
                $append_3(result, this$static.authority);
            }
            if (this$static.device != null) {
                result.string += '/';
                $append_3(result, this$static.device);
            }
            (this$static.hashCode_0 & 16) != 0 && (result.string += '/', result);
            for(i = 0, len = this$static.segments.length; i < len; i++){
                i != 0 && (result.string += '/', result);
                $append_3(result, this$static.segments[i]);
            }
            if (this$static.query != null) {
                result.string += '?';
                $append_3(result, this$static.query);
            }
        } else $append_3(result, this$static.authority);
        if (this$static.fragment != null) {
            result.string += '#';
            $append_3(result, this$static.fragment);
        }
        this$static.cachedToString = result.string;
    }
    return this$static.cachedToString;
}
function $trimFragment(this$static) {
    if (this$static.fragment == null) return this$static;
    else !this$static.cachedTrimFragment && (this$static.cachedTrimFragment = new URI((this$static.hashCode_0 & 256) != 0, this$static.scheme, this$static.authority, this$static.device, (this$static.hashCode_0 & 16) != 0, this$static.segments, this$static.query, null));
    return this$static.cachedTrimFragment;
}
function URI(hierarchical, scheme, authority, device, absolutePath, segments, query, fragment) {
    var hashCode, i, len;
    hashCode = 0;
    scheme != null && (hashCode ^= $hashCode_2(scheme.toLowerCase()));
    authority != null && (hashCode ^= $hashCode_2(authority));
    device != null && (hashCode ^= $hashCode_2(device));
    query != null && (hashCode ^= $hashCode_2(query));
    fragment != null && (hashCode ^= $hashCode_2(fragment));
    for(i = 0, len = segments.length; i < len; i++)hashCode ^= $hashCode_2(segments[i]);
    hierarchical ? hashCode |= 256 : hashCode &= -257;
    absolutePath ? hashCode |= 16 : hashCode &= -17;
    this.hashCode_0 = hashCode;
    this.scheme = scheme == null ? null : (checkCriticalNotNull(scheme), scheme);
    this.authority = authority;
    this.device = device;
    this.segments = segments;
    this.query = query;
    this.fragment = fragment;
}
function contains_61(s, highBitmask, lowBitmask) {
    var i, len;
    for(i = 0, len = s.length; i < len; i++){
        if (matches((checkCriticalStringElementIndex(i, s.length), s.charCodeAt(i)), highBitmask, lowBitmask)) return true;
    }
    return false;
}
function createURIWithCache(uri_0) {
    $clinit_URI();
    var base, fragment, i, result;
    i = $indexOf_1(uri_0, fromCodePoint(35));
    base = i == -1 ? uri_0 : (checkCriticalStringBounds(0, i, uri_0.length), uri_0.substr(0, i));
    fragment = i == -1 ? null : (checkCriticalStringElementIndex(i + 1, uri_0.length + 1), uri_0.substr(i + 1));
    result = $get_22(uriCache, base);
    if (!result) {
        result = parseIntoURI(base);
        $put_15(uriCache, base, result);
        fragment != null && (result = $appendFragment(result, fragment));
    } else fragment != null && (result = $appendFragment(result, (checkCriticalNotNull(fragment), fragment)));
    return result;
}
function decode(value_0) {
    $clinit_URI();
    var bytes, character, expectedBytes, i, j, len, receivedBytes, result;
    if (value_0 == null) return null;
    i = $indexOf_1(value_0, fromCodePoint(37));
    if (i < 0) return value_0;
    else {
        result = new StringBuilder_1((checkCriticalStringBounds(0, i, value_0.length), value_0.substr(0, i)));
        bytes = initUnidimensionalArray(B_classLit, $intern_139, 30, 4, 15, 1);
        receivedBytes = 0;
        expectedBytes = 0;
        for(len = value_0.length; i < len; i++){
            checkCriticalStringElementIndex(i, value_0.length);
            if (value_0.charCodeAt(i) == 37 && value_0.length > i + 2 && matches((checkCriticalStringElementIndex(i + 1, value_0.length), value_0.charCodeAt(i + 1)), HEX_HI, HEX_LO) && matches((checkCriticalStringElementIndex(i + 2, value_0.length), value_0.charCodeAt(i + 2)), HEX_HI, HEX_LO)) {
                character = unescape_0((checkCriticalStringElementIndex(i + 1, value_0.length), value_0.charCodeAt(i + 1)), (checkCriticalStringElementIndex(i + 2, value_0.length), value_0.charCodeAt(i + 2)));
                i += 2;
                if (expectedBytes > 0) (character & 192) == 128 ? bytes[receivedBytes++] = character << 24 >> 24 : expectedBytes = 0;
                else if (character >= 128) {
                    if ((character & 224) == 192) {
                        bytes[receivedBytes++] = character << 24 >> 24;
                        expectedBytes = 2;
                    } else if ((character & 240) == 224) {
                        bytes[receivedBytes++] = character << 24 >> 24;
                        expectedBytes = 3;
                    } else if ((character & 248) == 240) {
                        bytes[receivedBytes++] = character << 24 >> 24;
                        expectedBytes = 4;
                    }
                }
                if (expectedBytes > 0) {
                    if (receivedBytes == expectedBytes) {
                        switch(receivedBytes){
                            case 2:
                                $append_5(result, ((bytes[0] & 31) << 6 | bytes[1] & 63) & $intern_46);
                                break;
                            case 3:
                                $append_5(result, ((bytes[0] & 15) << 12 | (bytes[1] & 63) << 6 | bytes[2] & 63) & $intern_46);
                                break;
                        }
                        receivedBytes = 0;
                        expectedBytes = 0;
                    }
                } else {
                    for(j = 0; j < receivedBytes; ++j)$append_5(result, bytes[j] & $intern_46);
                    receivedBytes = 0;
                    result.string += String.fromCharCode(character);
                }
            } else {
                for(j = 0; j < receivedBytes; ++j)$append_5(result, bytes[j] & $intern_46);
                receivedBytes = 0;
                $append_5(result, (checkCriticalStringElementIndex(i, value_0.length), value_0.charCodeAt(i)));
            }
        }
        return result.string;
    }
}
function equals_215(o1, o2) {
    return o1 == null ? o2 == null : $equals_5(o1, o2);
}
function equals_216(s1, s2) {
    return s1 == null ? s2 == null : $equalsIgnoreCase(s1, s2);
}
function find_0(s, i, highBitmask, lowBitmask) {
    var len;
    len = s.length;
    if (i >= len) return len;
    for(i = i > 0 ? i : 0; i < len; i++){
        if (matches((checkCriticalStringElementIndex(i, s.length), s.charCodeAt(i)), highBitmask, lowBitmask)) break;
    }
    return i;
}
function firstInvalidSegment(value_0) {
    var i, len;
    if (value_0 == null) return null;
    for(i = 0, len = value_0.length; i < len; i++){
        if (!validSegment(value_0[i])) return value_0[i];
    }
    return null;
}
function highBitmask_0(chars) {
    var c, i, len, result;
    result = 0;
    for(i = 0, len = chars.length; i < len; i++){
        c = (checkCriticalStringElementIndex(i, chars.length), chars.charCodeAt(i));
        c >= 64 && c < 128 && (result = or_0(result, shl_0(1, c - 64)));
    }
    return result;
}
function isArchiveScheme(value_0) {
    return value_0 != null && $contains_2(archiveSchemes, value_0.toLowerCase());
}
function lowBitmask_0(from, to) {
    var c, result;
    result = 0;
    if (from < 64 && from <= to) {
        to = to < 64 ? to : 63;
        for(c = from; c <= to; c++)result = or_0(result, shl_0(1, c));
    }
    return result;
}
function lowBitmask_1(chars) {
    var c, i, len, result;
    result = 0;
    for(i = 0, len = chars.length; i < len; i++){
        c = (checkCriticalStringElementIndex(i, chars.length), chars.charCodeAt(i));
        c < 64 && (result = or_0(result, shl_0(1, c)));
    }
    return result;
}
function matches(c, highBitmask, lowBitmask) {
    if (c >= 128) return false;
    return c < 64 ? neq(and_0(shl_0(1, c), lowBitmask), 0) : neq(and_0(shl_0(1, c - 64), highBitmask), 0);
}
function parseIntoURI(uri_0) {
    var absolutePath, archiveScheme, authority, device, fragment, hierarchical, i, j, query, s, scheme, segmentList, segments;
    hierarchical = true;
    scheme = null;
    authority = null;
    device = null;
    absolutePath = false;
    segments = NO_SEGMENTS;
    query = null;
    fragment = null;
    i = 0;
    j = find_0(uri_0, i, MAJOR_SEPARATOR_HI, MAJOR_SEPARATOR_LO);
    if (j < uri_0.length && (checkCriticalStringElementIndex(j, uri_0.length), uri_0.charCodeAt(j) == 58)) {
        scheme = (checkCriticalStringBounds(i, j, uri_0.length), uri_0.substr(i, j - i));
        i = j + 1;
    }
    archiveScheme = scheme != null && $contains_2(archiveSchemes, scheme.toLowerCase());
    if (archiveScheme) {
        j = uri_0.lastIndexOf('!/');
        if (j == -1) throw toJs(new IllegalArgumentException_0('no archive separator'));
        hierarchical = true;
        authority = $substring_1(uri_0, i, ++j);
        i = j;
    } else if (i >= 0 && $equals_5(uri_0.substr(i, 2), '//')) {
        i += 2;
        j = find_0(uri_0, i, SEGMENT_END_HI, SEGMENT_END_LO);
        authority = (checkCriticalStringBounds(i, j, uri_0.length), uri_0.substr(i, j - i));
        i = j;
    } else if (scheme != null && (i == uri_0.length || (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 47))) {
        hierarchical = false;
        j = $indexOf_2(uri_0, fromCodePoint(35), i);
        j == -1 && (j = uri_0.length);
        authority = (checkCriticalStringBounds(i, j, uri_0.length), uri_0.substr(i, j - i));
        i = j;
    }
    if (!archiveScheme && i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) == 47)) {
        j = find_0(uri_0, i + 1, SEGMENT_END_HI, SEGMENT_END_LO);
        s = (checkCriticalStringBounds(i + 1, j, uri_0.length), uri_0.substr(i + 1, j - (i + 1)));
        if (s.length > 0 && $charAt(s, s.length - 1) == 58) {
            device = s;
            i = j;
        }
    }
    if (i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) == 47)) {
        ++i;
        absolutePath = true;
    }
    if (i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 63) && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 35)) {
        segmentList = new ArrayList;
        while(i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 63) && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 35)){
            j = find_0(uri_0, i, SEGMENT_END_HI, SEGMENT_END_LO);
            $add_3(segmentList, (checkCriticalStringBounds(i, j, uri_0.length), uri_0.substr(i, j - i)));
            i = j;
            i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) == 47) && (segmentsRemain(uri_0, ++i) || (segmentList.array.push(''), undefined));
        }
        segments = initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, segmentList.array.length, 6, 1);
        $toArray_1(segmentList, segments);
    }
    if (i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) == 63)) {
        j = $indexOf_0(uri_0, 35, ++i);
        j == -1 && (j = uri_0.length);
        query = (checkCriticalStringBounds(i, j, uri_0.length), uri_0.substr(i, j - i));
        i = j;
    }
    i < uri_0.length && (fragment = $substring_0(uri_0, ++i));
    validateURI(hierarchical, scheme, authority, device, segments, query);
    return new URI(hierarchical, scheme, authority, device, absolutePath, segments, query, fragment);
}
function segmentsRemain(uri_0, i) {
    return i < uri_0.length && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 63) && (checkCriticalStringElementIndex(i, uri_0.length), uri_0.charCodeAt(i) != 35);
}
function unescape_0(highHexDigit, lowHexDigit) {
    return (valueOf_115(highHexDigit) << 4 | valueOf_115(lowHexDigit)) & $intern_46;
}
function validArchiveAuthority(value_0) {
    var archiveURI;
    if (value_0 != null && value_0.length > 0 && $charAt(value_0, value_0.length - 1) == 33) try {
        archiveURI = createURIWithCache($substring_1(value_0, 0, value_0.length - 1));
        return archiveURI.fragment == null;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (!instanceOf($e0, 32)) throw toJs($e0);
    }
    return false;
}
function validDevice(value_0) {
    var len;
    if (value_0 == null) return true;
    len = value_0.length;
    return len > 0 && (checkCriticalStringElementIndex(len - 1, value_0.length), value_0.charCodeAt(len - 1) == 58) && !contains_61(value_0, SEGMENT_END_HI, SEGMENT_END_LO);
}
function validSegment(value_0) {
    return value_0 != null && !contains_61(value_0, SEGMENT_END_HI, SEGMENT_END_LO);
}
function validSegments(value_0) {
    var i, len;
    if (value_0 == null) return false;
    for(i = 0, len = value_0.length; i < len; i++){
        if (!validSegment(value_0[i])) return false;
    }
    return true;
}
function validateURI(hierarchical, scheme, authority, device, segments, query) {
    var s;
    if (!(scheme == null || !contains_61(scheme, MAJOR_SEPARATOR_HI, MAJOR_SEPARATOR_LO))) throw toJs(new IllegalArgumentException_0('invalid scheme: ' + scheme));
    if (!hierarchical && !(authority != null && $indexOf_1(authority, fromCodePoint(35)) == -1 && authority.length > 0 && (checkCriticalStringElementIndex(0, authority.length), authority.charCodeAt(0) != 47))) throw toJs(new IllegalArgumentException_0('invalid opaquePart: ' + authority));
    if (hierarchical && !(scheme != null && $contains_2(archiveSchemes, scheme.toLowerCase())) && !(authority == null || !contains_61(authority, SEGMENT_END_HI, SEGMENT_END_LO))) throw toJs(new IllegalArgumentException_0('invalid authority: ' + authority));
    if (hierarchical && scheme != null && $contains_2(archiveSchemes, scheme.toLowerCase()) && !validArchiveAuthority(authority)) throw toJs(new IllegalArgumentException_0('invalid authority: ' + authority));
    if (!validDevice(device)) throw toJs(new IllegalArgumentException_0('invalid device: ' + device));
    if (!validSegments(segments)) {
        s = segments == null ? 'invalid segments: null' : 'invalid segment: ' + firstInvalidSegment(segments);
        throw toJs(new IllegalArgumentException_0(s));
    }
    if (!(query == null || $indexOf_1(query, fromCodePoint(35)) == -1)) throw toJs(new IllegalArgumentException_0('invalid query: ' + query));
}
function valueOf_115(hexDigit) {
    if (hexDigit >= 65 && hexDigit <= 70) return hexDigit - 65 + 10;
    if (hexDigit >= 97 && hexDigit <= 102) return hexDigit - 97 + 10;
    if (hexDigit >= 48 && hexDigit <= 57) return hexDigit - 48;
    return 0;
}
defineClass(286, 1, {
    286: 1
}, URI);
_.equals_0 = function equals_214(object) {
    var uri_0;
    if (this === object) return true;
    if (!instanceOf(object, 286)) return false;
    uri_0 = castTo(object, 286);
    return this.hashCode_0 == uri_0.hashCode_0 && equals_216(this.scheme, uri_0.scheme) && equals_215(this.authority, (this.hashCode_0 & 256) != 0 ? (uri_0.hashCode_0 & 256) != 0 ? uri_0.authority : null : (uri_0.hashCode_0 & 256) != 0 ? null : uri_0.authority) && equals_215(this.device, uri_0.device) && equals_215(this.query, uri_0.query) && equals_215(this.fragment, uri_0.fragment) && $segmentsEqual(this, uri_0);
};
_.hashCode_1 = function hashCode_81() {
    return this.hashCode_0;
};
_.toString_0 = function toString_140() {
    return $toString_26(this);
};
_.hashCode_0 = 0;
var ALPHANUM_HI = 0, ALPHANUM_LO = 0, ALPHA_HI = 0, ALPHA_LO = 0, DIGIT_LO = 0, HEX_HI = 0, HEX_LO = 0, MAJOR_SEPARATOR_HI = 0, MAJOR_SEPARATOR_LO = 0, NO_SEGMENTS, SEGMENT_END_HI = 0, SEGMENT_END_LO = 0, UNRESERVED_HI = 0, UNRESERVED_LO = 0, archiveSchemes, uriCache;
var Lorg_eclipse_emf_common_util_URI_2_classLit = createForClass('org.eclipse.emf.common.util', 'URI', 286);
function $get_22(this$static, key) {
    return castTo(key == null ? getEntryValueOrNull($getEntry_0(this$static.hashCodeMap, null)) : $get_15(this$static.stringMap, key), 286);
}
function $put_15(this$static, key, value_0) {
    return castTo(key == null ? $put_9(this$static.hashCodeMap, null, value_0) : $put_10(this$static.stringMap, key, value_0), 286);
}
function URI$URICache() {
    HashMap.call(this);
}
defineClass(1085, 45, $intern_76, URI$URICache);
_.put = function put_12(key, value_0) {
    return castTo($putStringValue(this, castToString(key), castTo(value_0, 286)), 286);
};
var Lorg_eclipse_emf_common_util_URI$URICache_2_classLit = createForClass('org.eclipse.emf.common.util', 'URI/URICache', 1085);
function UniqueEList() {}
function UniqueEList_0(collection) {
    BasicEList_0.call(this, collection.size_1());
    $addAll_9(this, collection);
}
defineClass(490, 66, $intern_140, UniqueEList, UniqueEList_0);
_.isUnique = function isUnique_1() {
    return true;
};
var Lorg_eclipse_emf_common_util_UniqueEList_2_classLit = createForClass('org.eclipse.emf.common.util', 'UniqueEList', 490);
function WrappedException(exception) {
    $$init_0(this);
    this.detailMessage = !exception ? null : $toString_4(exception, exception.getMessage());
    this.cause_0 = exception;
    $fillInStackTrace(this);
    this.initializeBackingError();
}
defineClass(573, 63, $intern_43, WrappedException);
var Lorg_eclipse_emf_common_util_WrappedException_2_classLit = createForClass('org.eclipse.emf.common.util', 'WrappedException', 573);
var Lorg_eclipse_emf_ecore_EAnnotation_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EAnnotation');
var Lorg_eclipse_emf_ecore_ETypedElement_2_classLit = createForInterface('org.eclipse.emf.ecore', 'ETypedElement');
var Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EStructuralFeature');
var Lorg_eclipse_emf_ecore_EAttribute_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EAttribute');
var Lorg_eclipse_emf_ecore_EClassifier_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EClassifier');
var Lorg_eclipse_emf_ecore_EClass_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EClass');
var Lorg_eclipse_emf_ecore_EDataType_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EDataType');
function $clinit_EDataType$Internal$ConversionDelegate$Factory$Registry() {
    $clinit_EDataType$Internal$ConversionDelegate$Factory$Registry = emptyMethod;
    INSTANCE_5 = new EDataType$Internal$ConversionDelegate$Factory$Registry$Impl;
}
var INSTANCE_5;
function $getFactory(this$static, uri_0) {
    var factory;
    return factory = uri_0 != null ? $getStringValue(this$static, uri_0) : getEntryValueOrNull($getEntry_0(this$static.hashCodeMap, uri_0)), throwClassCastExceptionUnlessNull(factory);
}
function EDataType$Internal$ConversionDelegate$Factory$Registry$Impl() {
    HashMap.call(this);
}
defineClass(1193, 45, $intern_76, EDataType$Internal$ConversionDelegate$Factory$Registry$Impl);
_.get_3 = function get_56(key) {
    return instanceOfString(key) ? $getStringValue(this, key) : getEntryValueOrNull($getEntry_0(this.hashCodeMap, key));
};
var Lorg_eclipse_emf_ecore_EDataType$Internal$ConversionDelegate$Factory$Registry$Impl_2_classLit = createForClass('org.eclipse.emf.ecore', 'EDataType/Internal/ConversionDelegate/Factory/Registry/Impl', 1193);
var Lorg_eclipse_emf_ecore_EEnum_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EEnum');
var Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EEnumLiteral');
var Lorg_eclipse_emf_ecore_EGenericType_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EGenericType');
var Lorg_eclipse_emf_ecore_EOperation_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EOperation');
function $clinit_EPackage$Registry() {
    $clinit_EPackage$Registry = emptyMethod;
    INSTANCE_6 = new EPackageRegistryImpl;
}
var INSTANCE_6;
var Lorg_eclipse_emf_ecore_EParameter_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EParameter');
var Lorg_eclipse_emf_ecore_EReference_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EReference');
function EStructuralFeature$Internal$DynamicValueHolder$1() {}
defineClass(1017, 1, {}, EStructuralFeature$Internal$DynamicValueHolder$1);
_.toString_0 = function toString_141() {
    return 'NIL';
};
var Lorg_eclipse_emf_ecore_EStructuralFeature$Internal$DynamicValueHolder$1_2_classLit = createForClass('org.eclipse.emf.ecore', 'EStructuralFeature/Internal/DynamicValueHolder/1', 1017);
function $clinit_EStructuralFeature$Internal$SettingDelegate$Factory$Registry() {
    $clinit_EStructuralFeature$Internal$SettingDelegate$Factory$Registry = emptyMethod;
    INSTANCE_7 = new EStructuralFeature$Internal$SettingDelegate$Factory$Registry$Impl;
}
var INSTANCE_7;
function $getFactory_0(this$static, uri_0) {
    var factory;
    return factory = uri_0 != null ? $getStringValue(this$static, uri_0) : getEntryValueOrNull($getEntry_0(this$static.hashCodeMap, uri_0)), throwClassCastExceptionUnlessNull(factory);
}
function EStructuralFeature$Internal$SettingDelegate$Factory$Registry$Impl() {
    HashMap.call(this);
}
defineClass(1016, 45, $intern_76, EStructuralFeature$Internal$SettingDelegate$Factory$Registry$Impl);
_.get_3 = function get_57(key) {
    return instanceOfString(key) ? $getStringValue(this, key) : getEntryValueOrNull($getEntry_0(this.hashCodeMap, key));
};
var Lorg_eclipse_emf_ecore_EStructuralFeature$Internal$SettingDelegate$Factory$Registry$Impl_2_classLit = createForClass('org.eclipse.emf.ecore', 'EStructuralFeature/Internal/SettingDelegate/Factory/Registry/Impl', 1016);
var Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit = createForInterface('org.eclipse.emf.ecore', 'ETypeParameter');
var Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit = createForInterface('org.eclipse.emf.ecore', 'EValidator/PatternMatcher');
function $clinit_EValidator$Registry() {
    $clinit_EValidator$Registry = emptyMethod;
    INSTANCE_8 = new EValidatorRegistryImpl;
}
var INSTANCE_8;
function $clinit_EcoreFactory() {
    $clinit_EcoreFactory = emptyMethod;
    eINSTANCE_1 = init_3();
}
var eINSTANCE_1;
function $clinit_EcorePackage() {
    $clinit_EcorePackage = emptyMethod;
    eINSTANCE_2 = init_4();
    !!($clinit_EcorePackage$Literals(), EATTRIBUTE) && internalBootstrap();
}
var eINSTANCE_2;
function $clinit_EcorePackage$Literals() {
    $clinit_EcorePackage$Literals = emptyMethod;
    EATTRIBUTE = ($clinit_EcorePackage(), eINSTANCE_2).eAttributeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAttributeEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAttributeEClass), 1), 19);
    EANNOTATION = eINSTANCE_2.eAnnotationEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAnnotationEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAnnotationEClass), 1), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAnnotationEClass), 2), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAnnotationEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eAnnotationEClass), 4), 19);
    ECLASS = eINSTANCE_2.eClassEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 1), 35);
    ECLASS__ESUPER_TYPES = castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 2), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 4), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 5), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 6), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 7), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 8), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 9), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 10), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 11), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 12), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 13), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 14), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 15), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 1), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 2), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 3), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 4), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 5), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 6), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 7), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 8), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassEClass), 9), 62);
    ECLASSIFIER = eINSTANCE_2.eClassifierEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassifierEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassifierEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassifierEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassifierEClass), 3), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassifierEClass), 4), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassifierEClass), 5), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassifierEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eClassifierEClass), 1), 62);
    EDATA_TYPE = eINSTANCE_2.eDataTypeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eDataTypeEClass), 0), 35);
    EENUM = eINSTANCE_2.eEnumEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eEnumEClass), 0), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eEnumEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eEnumEClass), 1), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eEnumEClass), 2), 62);
    EENUM_LITERAL = eINSTANCE_2.eEnumLiteralEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eEnumLiteralEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eEnumLiteralEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eEnumLiteralEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eEnumLiteralEClass), 3), 19);
    EFACTORY = eINSTANCE_2.eFactoryEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eFactoryEClass), 0), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eFactoryEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eFactoryEClass), 1), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eFactoryEClass), 2), 62);
    EMODEL_ELEMENT = eINSTANCE_2.eModelElementEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eModelElementEClass), 0), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eModelElementEClass), 0), 62);
    ENAMED_ELEMENT = eINSTANCE_2.eNamedElementEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eNamedElementEClass), 0), 35);
    EOBJECT = eINSTANCE_2.eObjectEClass;
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 1), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 2), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 3), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 4), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 5), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 6), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 7), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 8), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 9), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 10), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 11), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 12), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 13), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eObjectEClass), 14), 62);
    EOPERATION = eINSTANCE_2.eOperationEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eOperationEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eOperationEClass), 2), 19);
    EOPERATION__EEXCEPTIONS = castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eOperationEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eOperationEClass), 4), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eOperationEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eOperationEClass), 1), 62);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eOperationEClass), 1), 19);
    EPACKAGE = eINSTANCE_2.ePackageEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.ePackageEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.ePackageEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.ePackageEClass), 2), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.ePackageEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.ePackageEClass), 4), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.ePackageEClass), 5), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.ePackageEClass), 0), 62);
    EPARAMETER = eINSTANCE_2.eParameterEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eParameterEClass), 0), 19);
    EREFERENCE = eINSTANCE_2.eReferenceEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eReferenceEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eReferenceEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eReferenceEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eReferenceEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eReferenceEClass), 4), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eReferenceEClass), 5), 19);
    ESTRUCTURAL_FEATURE = eINSTANCE_2.eStructuralFeatureEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 3), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 4), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 5), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 6), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStructuralFeatureEClass), 7), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eStructuralFeatureEClass), 0), 62);
    castTo($get_20($getEOperations(eINSTANCE_2.eStructuralFeatureEClass), 1), 62);
    ETYPED_ELEMENT = eINSTANCE_2.eTypedElementEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 2), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 3), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 4), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 5), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 6), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypedElementEClass), 7), 19);
    ESTRING_TO_STRING_MAP_ENTRY = eINSTANCE_2.eStringToStringMapEntryEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStringToStringMapEntryEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eStringToStringMapEntryEClass), 1), 35);
    EGENERIC_TYPE = eINSTANCE_2.eGenericTypeEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eGenericTypeEClass), 0), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eGenericTypeEClass), 1), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eGenericTypeEClass), 2), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eGenericTypeEClass), 3), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eGenericTypeEClass), 4), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eGenericTypeEClass), 5), 19);
    castTo($get_20($getEOperations(eINSTANCE_2.eGenericTypeEClass), 0), 62);
    ETYPE_PARAMETER = eINSTANCE_2.eTypeParameterEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eTypeParameterEClass), 0), 19);
    EJAVA_OBJECT = eINSTANCE_2.eJavaObjectEDataType;
}
var EANNOTATION, EATTRIBUTE, ECLASS, ECLASSIFIER, ECLASS__ESUPER_TYPES, EDATA_TYPE, EENUM, EENUM_LITERAL, EFACTORY, EGENERIC_TYPE, EJAVA_OBJECT, EMODEL_ELEMENT, ENAMED_ELEMENT, EOBJECT, EOPERATION, EOPERATION__EEXCEPTIONS, EPACKAGE, EPARAMETER, EREFERENCE, ESTRING_TO_STRING_MAP_ENTRY, ESTRUCTURAL_FEATURE, ETYPED_ELEMENT, ETYPE_PARAMETER;
var Lorg_eclipse_emf_ecore_util_FeatureMap$Entry_2_classLit = createForInterface('org.eclipse.emf.ecore.util', 'FeatureMap/Entry');
function BasicEObjectImpl$1(val$eAttribute, val$value) {
    this.val$eAttribute1 = val$eAttribute;
    this.val$value2 = val$value;
}
defineClass(530, 1, {
    74: 1
}, BasicEObjectImpl$1);
_.getEStructuralFeature = function getEStructuralFeature() {
    return this.val$eAttribute1;
};
_.getValue = function getValue_12() {
    return this.val$value2;
};
var Lorg_eclipse_emf_ecore_impl_BasicEObjectImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'BasicEObjectImpl/1', 530);
function BasicEObjectImpl$4(this$0, val$eFeature) {
    this.this$01 = this$0;
    this.val$eFeature2 = val$eFeature;
}
defineClass(1015, 1, $intern_150, BasicEObjectImpl$4);
_.get_6 = function get_58(resolve) {
    return $eGet_1(this.this$01, this.val$eFeature2, resolve);
};
_.isSet_0 = function isSet_1() {
    return $eIsSet_0(this.this$01, this.val$eFeature2);
};
_.set_1 = function set_29(newValue) {
    $eSet_0(this.this$01, this.val$eFeature2, newValue);
};
_.unset = function unset() {
    $eUnset_0(this.this$01, this.val$eFeature2);
};
var Lorg_eclipse_emf_ecore_impl_BasicEObjectImpl$4_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'BasicEObjectImpl/4', 1015);
function $clinit_BasicEObjectImpl$EPropertiesHolderBaseImpl() {
    $clinit_BasicEObjectImpl$EPropertiesHolderBaseImpl = emptyMethod;
    NO_SETTINGS = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1);
}
defineClass(2027, 1, {
    113: 1
});
_.allocateSettings = function allocateSettings(dynamicFeatureCount) {
    this.eSettings = dynamicFeatureCount == 0 ? NO_SETTINGS : initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, dynamicFeatureCount, 5, 1);
};
_.dynamicGet = function dynamicGet_0(dynamicFeatureID) {
    return this.eSettings[dynamicFeatureID];
};
_.dynamicSet = function dynamicSet_0(dynamicFeatureID, value_0) {
    this.eSettings[dynamicFeatureID] = value_0;
};
_.dynamicUnset = function dynamicUnset_0(dynamicFeatureID) {
    this.eSettings[dynamicFeatureID] = null;
};
_.getEClass = function getEClass() {
    return this.eClass;
};
_.getEContents = function getEContents() {
    throw toJs(new UnsupportedOperationException);
};
_.getEProxyURI = function getEProxyURI() {
    throw toJs(new UnsupportedOperationException);
};
_.getEResource = function getEResource() {
    return this.eResource;
};
_.hasSettings = function hasSettings() {
    return this.eSettings != null;
};
_.setEClass = function setEClass(eClass) {
    this.eClass = eClass;
};
_.setEContents = function setEContents(eContents) {
    throw toJs(new UnsupportedOperationException);
};
_.setEProxyURI = function setEProxyURI(eProxyURI) {
    throw toJs(new UnsupportedOperationException);
};
_.setEResource = function setEResource(eResource) {
    this.eResource = eResource;
};
var NO_SETTINGS;
var Lorg_eclipse_emf_ecore_impl_BasicEObjectImpl$EPropertiesHolderBaseImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'BasicEObjectImpl/EPropertiesHolderBaseImpl', 2027);
function BasicEObjectImpl$EPropertiesHolderImpl() {
    $clinit_BasicEObjectImpl$EPropertiesHolderBaseImpl();
}
defineClass(192, 2027, {
    113: 1
}, BasicEObjectImpl$EPropertiesHolderImpl);
_.getEContents = function getEContents_0() {
    return this.eContents;
};
_.getEProxyURI = function getEProxyURI_0() {
    return this.eProxyURI;
};
_.setEContents = function setEContents_0(eContents) {
    this.eContents = eContents;
};
_.setEProxyURI = function setEProxyURI_0(eProxyURI) {
    this.eProxyURI = eProxyURI;
};
var Lorg_eclipse_emf_ecore_impl_BasicEObjectImpl$EPropertiesHolderImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'BasicEObjectImpl/EPropertiesHolderImpl', 192);
function EObjectImpl() {}
defineClass(500, 98, $intern_138, EObjectImpl);
_.eBasicAdapters = function eBasicAdapters_2() {
    return this.eAdapters;
};
_.eBasicProperties = function eBasicProperties_1() {
    return this.eProperties;
};
_.eBasicSetContainer = function eBasicSetContainer_4(newContainer, newContainerFeatureID) {
    this.eContainer = newContainer;
    this.eContainerFeatureID = newContainerFeatureID;
};
_.eClass_0 = function eClass_2() {
    return (this.eFlags & 2) == 0 ? this.eStaticClass() : this.eProperties_0().getEClass();
};
_.eContainerFeatureID_0 = function eContainerFeatureID_2() {
    return this.eContainerFeatureID;
};
_.eDeliver = function eDeliver_2() {
    return (this.eFlags & 1) != 0;
};
_.eInternalContainer = function eInternalContainer_3() {
    return this.eContainer;
};
_.eIsProxy = function eIsProxy_1() {
    return (this.eFlags & 4) != 0;
};
_.eProperties_0 = function eProperties_2() {
    return !this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties;
};
_.eSetClass = function eSetClass_1(eClass) {
    this.eProperties_0().setEClass(eClass);
    eClass ? this.eFlags |= 2 : this.eFlags &= -3;
};
_.eSetProxyURI = function eSetProxyURI_2(uri_0) {
    this.eProperties_0().setEProxyURI(uri_0);
    uri_0 ? this.eFlags |= 4 : this.eFlags &= -5;
};
_.eStaticClass = function eStaticClass_15() {
    return ($clinit_EcorePackage(), eINSTANCE_2).eObjectEClass;
};
_.eContainerFeatureID = 0;
_.eFlags = 1;
var Lorg_eclipse_emf_ecore_impl_EObjectImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EObjectImpl', 500);
function $clinit_DynamicEObjectImpl() {
    $clinit_DynamicEObjectImpl = emptyMethod;
    ENO_SETTINGS = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, 0, 5, 1);
}
function DynamicEObjectImpl(eClass) {
    $clinit_DynamicEObjectImpl();
    EObjectImpl.call(this);
    this.eSetClass(eClass);
}
defineClass(778, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1
}, DynamicEObjectImpl);
_.dynamicGet = function dynamicGet_1(dynamicFeatureID) {
    return this.eSettings[dynamicFeatureID];
};
_.dynamicSet = function dynamicSet_1(dynamicFeatureID, value_0) {
    this.eSettings[dynamicFeatureID] = value_0;
};
_.dynamicUnset = function dynamicUnset_1(dynamicFeatureID) {
    this.eSettings[dynamicFeatureID] = null;
};
_.eClass_0 = function eClass_3() {
    return this.eClass;
};
_.eDerivedStructuralFeatureID_0 = function eDerivedStructuralFeatureID_1(eStructuralFeature) {
    return $getFeatureID(this.eClass, eStructuralFeature);
};
_.eDynamicClass = function eDynamicClass_1() {
    return this.eClass;
};
_.eHasSettings = function eHasSettings_1() {
    return this.eSettings != null;
};
_.eProperties_0 = function eProperties_3() {
    !this.eProperties && (this.eProperties = new DynamicEObjectImpl$DynamicEPropertiesHolderImpl);
    return this.eProperties;
};
_.eSetClass = function eSetClass_2(eClass) {
    this.eClass = eClass;
};
_.eSettings_0 = function eSettings_1() {
    var size_0;
    if (this.eSettings == null) {
        size_0 = $getFeatureCount(this.eClass);
        this.eSettings = size_0 == 0 ? ENO_SETTINGS : initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, size_0, 5, 1);
    }
    return this;
};
_.eStaticFeatureCount = function eStaticFeatureCount_0() {
    return 0;
};
var ENO_SETTINGS;
var Lorg_eclipse_emf_ecore_impl_DynamicEObjectImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'DynamicEObjectImpl', 778);
function DynamicEObjectImpl$BasicEMapEntry(eClass) {
    $clinit_DynamicEObjectImpl();
    DynamicEObjectImpl.call(this, eClass);
    this.hash = -1;
}
defineClass(1462, 778, {
    109: 1,
    43: 1,
    93: 1,
    92: 1,
    135: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1
}, DynamicEObjectImpl$BasicEMapEntry);
_.equals_0 = function equals_217(other) {
    return this === other;
};
_.hashCode_1 = function hashCode_82() {
    return getObjectIdentityHashCode(this);
};
_.eSetClass = function eSetClass_3(eClass) {
    this.eClass = eClass;
    this.keyFeature = $getEStructuralFeature_0(eClass, 'key');
    this.valueFeature = $getEStructuralFeature_0(eClass, 'value');
};
_.getHash = function getHash_1() {
    var theKey;
    if (this.hash == -1) {
        theKey = $eGet_2(this, this.keyFeature);
        this.hash = theKey == null ? 0 : hashCode__I__devirtual$(theKey);
    }
    return this.hash;
};
_.getKey = function getKey_10() {
    return $eGet_2(this, this.keyFeature);
};
_.getValue = function getValue_13() {
    return $eGet_2(this, this.valueFeature);
};
_.setHash = function setHash_1(hash) {
    this.hash = hash;
};
_.setKey = function setKey_1(key) {
    $eSet_0(this, this.keyFeature, key);
};
_.setValue = function setValue_13(value_0) {
    var result;
    result = $eGet_2(this, this.valueFeature);
    $eSet_0(this, this.valueFeature, value_0);
    return result;
};
_.hash = 0;
var Lorg_eclipse_emf_ecore_impl_DynamicEObjectImpl$BasicEMapEntry_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'DynamicEObjectImpl/BasicEMapEntry', 1462);
function DynamicEObjectImpl$DynamicEPropertiesHolderImpl() {}
defineClass(1463, 1, {
    113: 1
}, DynamicEObjectImpl$DynamicEPropertiesHolderImpl);
_.allocateSettings = function allocateSettings_0(maximumDynamicFeatureID) {
    throw toJs(new UnsupportedOperationException);
};
_.dynamicGet = function dynamicGet_2(dynamicFeatureID) {
    throw toJs(new UnsupportedOperationException);
};
_.dynamicSet = function dynamicSet_2(dynamicFeatureID, value_0) {
    throw toJs(new UnsupportedOperationException);
};
_.dynamicUnset = function dynamicUnset_2(dynamicFeatureID) {
    throw toJs(new UnsupportedOperationException);
};
_.getEClass = function getEClass_0() {
    throw toJs(new UnsupportedOperationException);
};
_.getEContents = function getEContents_1() {
    return this.eContents;
};
_.getEProxyURI = function getEProxyURI_1() {
    return this.eProxyURI;
};
_.getEResource = function getEResource_0() {
    return this.eResource;
};
_.hasSettings = function hasSettings_0() {
    throw toJs(new UnsupportedOperationException);
};
_.setEClass = function setEClass_0(eClass) {
    throw toJs(new UnsupportedOperationException);
};
_.setEContents = function setEContents_1(eContents) {
    this.eContents = eContents;
};
_.setEProxyURI = function setEProxyURI_1(eProxyURI) {
    this.eProxyURI = eProxyURI;
};
_.setEResource = function setEResource_0(eResource) {
    this.eResource = eResource;
};
var Lorg_eclipse_emf_ecore_impl_DynamicEObjectImpl$DynamicEPropertiesHolderImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'DynamicEObjectImpl/DynamicEPropertiesHolderImpl', 1463);
function $basicSetEModelElement(this$static, newEModelElement, msgs) {
    msgs = $eBasicSetContainer(this$static, castTo(newEModelElement, 52), 3, msgs);
    return msgs;
}
function $eBasicRemoveFromContainerFeature_5(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 3) return this$static.eContainer.eInverseRemove(this$static, 0, Lorg_eclipse_emf_ecore_EModelElement_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EANNOTATION) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getContents(this$static) {
    !this$static.contents && (this$static.contents = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this$static, 4));
    return this$static.contents;
}
function $getEModelElement(this$static) {
    if (this$static.eFlags_0 >> 16 != 3) return null;
    return castTo(this$static.eContainer, 154);
}
function $setEModelElement(this$static, newEModelElement) {
    var eContainerFeatureID, msgs;
    if (newEModelElement != this$static.eContainer || this$static.eFlags_0 >> 16 != 3 && !!newEModelElement) {
        if (isAncestor(this$static, newEModelElement)) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + $toString_27(this$static)));
        msgs = null;
        !!this$static.eContainer && (msgs = (eContainerFeatureID = this$static.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_5(this$static, msgs) : this$static.eContainer.eInverseRemove(this$static, -1 - eContainerFeatureID, null, msgs)));
        !!newEModelElement && (msgs = castTo(newEModelElement, 52).eInverseAdd(this$static, 0, Lorg_eclipse_emf_ecore_EModelElement_2_classLit, msgs));
        msgs = $basicSetEModelElement(this$static, newEModelElement, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 3, newEModelElement, newEModelElement));
}
function $setSource_2(this$static, newSource) {
    $setSourceGen(this$static, newSource == null ? null : (checkCriticalNotNull(newSource), newSource));
}
function $setSourceGen(this$static, newSource) {
    var oldSource;
    oldSource = this$static.source;
    this$static.source = newSource;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 1, oldSource, this$static.source));
}
function $toString_27(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_16(this$static);
    result = new StringBuffer_1($toString_16(this$static));
    result.string += ' (source: ';
    $append_3(result, this$static.source);
    result.string += ')';
    return result.string;
}
function EAnnotationImpl() {}
defineClass(503, 157, {
    109: 1,
    93: 1,
    92: 1,
    582: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    503: 1,
    157: 1,
    117: 1,
    118: 1
}, EAnnotationImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_6(msgs) {
    return $eBasicRemoveFromContainerFeature_5(this, msgs);
};
_.eGet = function eGet_17(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.source;
        case 2:
            return coreType ? (!this.details && (this.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this)), this.details) : (!this.details && (this.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this)), $map_0(this.details));
        case 3:
            return $getEModelElement(this);
        case 4:
            return !this.contents && (this.contents = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 4)), this.contents;
        case 5:
            return !this.references && (this.references = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 5)), this.references;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EANNOTATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EANNOTATION : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_11(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 3:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_5(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $basicSetEModelElement(this, castTo(otherEnd, 154), msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EANNOTATION) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EANNOTATION)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_12(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 2:
            return !this.details && (this.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this)), $basicRemove_1(this.details, otherEnd, msgs);
        case 3:
            return $basicSetEModelElement(this, null, msgs);
        case 4:
            return !this.contents && (this.contents = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 4)), $basicRemove_0(this.contents, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EANNOTATION) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EANNOTATION)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_16(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.source != null;
        case 2:
            return !!this.details && this.details.size_0 != 0;
        case 3:
            return !!$getEModelElement(this);
        case 4:
            return !!this.contents && this.contents.size_0 != 0;
        case 5:
            return !!this.references && this.references.size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EANNOTATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EANNOTATION : eClass), featureID));
};
_.eSet = function eSet_15(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setSource_2(this, castToString(newValue));
            return;
        case 2:
            !this.details && (this.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this));
            $set_12(this.details, newValue);
            return;
        case 3:
            $setEModelElement(this, castTo(newValue, 154));
            return;
        case 4:
            !this.contents && (this.contents = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 4));
            $clear_13(this.contents);
            !this.contents && (this.contents = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 4));
            $addAll_9(this.contents, castTo(newValue, 16));
            return;
        case 5:
            !this.references && (this.references = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 5));
            $clear_13(this.references);
            !this.references && (this.references = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 5));
            $addAll_9(this.references, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EANNOTATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EANNOTATION : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_16() {
    return $clinit_EcorePackage$Literals(), EANNOTATION;
};
_.eUnset = function eUnset_15(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            $setSourceGen(this, null);
            return;
        case 2:
            !this.details && (this.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this));
            this.details.delegateEList.clear_0();
            return;
        case 3:
            $setEModelElement(this, null);
            return;
        case 4:
            !this.contents && (this.contents = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 4));
            $clear_13(this.contents);
            return;
        case 5:
            !this.references && (this.references = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EObject_2_classLit, this, 5));
            $clear_13(this.references);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EANNOTATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EANNOTATION : eClass), featureID));
};
_.toString_0 = function toString_142() {
    return $toString_27(this);
};
_.source = null;
var Lorg_eclipse_emf_ecore_impl_EAnnotationImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EAnnotationImpl', 503);
function $addUnique_7(this$static, index_0, object) {
    castTo(this$static.delegateEList, 71).addUnique(index_0, object);
}
function $basicAdd_1(this$static, object, notifications) {
    return castTo(this$static.delegateEList, 71).basicAdd(object, notifications);
}
function $basicRemove_1(this$static, object, notifications) {
    return castTo(this$static.delegateEList, 71).basicRemove(object, notifications);
}
function $set_12(this$static, value_0) {
    var mapValue;
    if (instanceOf(value_0, 91)) {
        castTo(this$static.delegateEList, 76).unset();
        mapValue = castTo(value_0, 91);
        $putAll_1(this$static, mapValue);
    } else castTo(this$static.delegateEList, 76).set_1(value_0);
}
function EcoreEMap(entryEClass, entryClass, owner, featureID) {
    this.initializeDelegateEList();
    this.entryClass = entryClass;
    this.entryEClass = entryEClass;
    this.delegateEList = new EcoreEMap$DelegateEObjectContainmentEList(this, entryClass, owner, featureID);
}
defineClass(140, 705, $intern_151, EcoreEMap);
_.addUnique = function addUnique_9(index_0, object) {
    $addUnique_7(this, index_0, castTo(object, 43));
};
_.basicAdd = function basicAdd(object, notifications) {
    return $basicAdd_1(this, castTo(object, 43), notifications);
};
_.basicGet = function basicGet_0(index_0) {
    return castTo(castTo(this.delegateEList, 71).basicGet(index_0), 135);
};
_.basicIterator = function basicIterator_1() {
    return castTo(this.delegateEList, 71).basicIterator();
};
_.basicListIterator = function basicListIterator_3() {
    return castTo(this.delegateEList, 71).basicListIterator();
};
_.basicListIterator_0 = function basicListIterator_4(index_0) {
    return castTo(this.delegateEList, 71).basicListIterator_0(index_0);
};
_.basicRemove = function basicRemove(object, notifications) {
    return $basicRemove_1(this, object, notifications);
};
_.get_6 = function get_59(resolve) {
    return castTo(this.delegateEList, 76).get_6(resolve);
};
_.initializeDelegateEList = function initializeDelegateEList_0() {};
_.isSet_0 = function isSet_2() {
    return castTo(this.delegateEList, 76).isSet_0();
};
_.newEntry = function newEntry_1(hash, key, value_0) {
    var entry;
    entry = castTo($getEPackage(this.entryEClass).getEFactoryInstance().create_3(this.entryEClass), 135);
    entry.setHash(hash);
    entry.setKey(key);
    entry.setValue(value_0);
    return entry;
};
_.newList = function newList_0() {
    return new EcoreEMap$1(this);
};
_.set_1 = function set_30(value_0) {
    $set_12(this, value_0);
};
_.unset = function unset_0() {
    castTo(this.delegateEList, 76).unset();
};
var Lorg_eclipse_emf_ecore_util_EcoreEMap_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEMap', 140);
function EAnnotationImpl$1($anonymous0, $anonymous1, $anonymous2) {
    EcoreEMap.call(this, $anonymous0, $anonymous1, $anonymous2, 2);
}
defineClass(167, 140, $intern_151, EAnnotationImpl$1);
_.ensureEntryDataExists = function ensureEntryDataExists_0() {
    var eList, entry, entry$iterator, hash, index_0, result;
    if (this.entryData == null) {
        result = initUnidimensionalArray(Lorg_eclipse_emf_common_util_BasicEList_2_classLit, $intern_147, 66, 2 * this.size_0 + 1, 0, 1);
        for(entry$iterator = this.delegateEList.iterator_0(); entry$iterator.cursor != entry$iterator.this$01_2.size_1();){
            entry = castTo(entry$iterator.doNext(), 135);
            hash = entry.getHash();
            index_0 = (hash & $intern_0) % result.length;
            eList = result[index_0];
            !eList && (eList = result[index_0] = new EcoreEMap$1(this));
            eList.add_2(entry);
        }
        this.entryData = result;
    }
};
var Lorg_eclipse_emf_ecore_impl_EAnnotationImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EAnnotationImpl/1', 167);
function $basicSetEGenericType(this$static, newEGenericType, msgs) {
    var newEType, notification, oldEGenericType;
    oldEGenericType = this$static.eGenericType;
    this$static.eGenericType = newEGenericType;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 9, oldEGenericType, newEGenericType);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    if (!newEGenericType) !!this$static.eType && (msgs = this$static.setEType(null, msgs));
    else {
        newEType = newEGenericType.eRawType;
        newEType != this$static.eType && (msgs = this$static.setEType(newEType, msgs));
    }
    return msgs;
}
function $basicUnsetEGenericType(this$static, msgs) {
    msgs = this$static.setEType(null, msgs);
    return $basicSetEGenericType(this$static, null, msgs);
}
function $getEType(this$static) {
    var oldEType;
    if ((this$static.eFlags & 1) == 0 && !!this$static.eType && this$static.eType.eIsProxy()) {
        oldEType = castTo(this$static.eType, 52);
        this$static.eType = castTo($eResolveProxy(this$static, oldEType), 141);
        this$static.eType != oldEType && (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, 8, oldEType, this$static.eType));
    }
    return this$static.eType;
}
function $setEGenericType(this$static, newEGenericType, msgs) {
    var notification;
    if (newEGenericType != this$static.eGenericType) {
        !!this$static.eGenericType && (msgs = $eInverseRemove(this$static.eGenericType, this$static, -10, msgs));
        !!newEGenericType && (msgs = $eInverseAdd(newEGenericType, this$static, -10, msgs));
        msgs = $basicSetEGenericType(this$static, newEGenericType, msgs);
    } else if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 9, newEGenericType, newEGenericType);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    return msgs;
}
function $setEType(this$static, newEType) {
    var eGenericType, msgs, newEGenericType;
    msgs = this$static.setEType(newEType, null);
    newEGenericType = null;
    if (newEType) {
        newEGenericType = ($clinit_EcoreFactory(), eGenericType = new EGenericTypeImpl, eGenericType);
        $setEClassifier(newEGenericType, this$static.eType);
    }
    msgs = $setEGenericType(this$static, newEGenericType, msgs);
    !!msgs && msgs.dispatch_0();
}
function $setEType_0(this$static, newEType, msgs) {
    var notification, oldEType;
    oldEType = this$static.eType;
    this$static.eType = newEType;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 8, oldEType, this$static.eType);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    return msgs;
}
function $setLowerBound(this$static, newLowerBound) {
    var oldLowerBound;
    oldLowerBound = this$static.lowerBound;
    this$static.lowerBound = newLowerBound;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_0(this$static, 4, oldLowerBound, this$static.lowerBound));
}
function $setOrdered(this$static, newOrdered) {
    var oldOrdered;
    oldOrdered = (this$static.eFlags & 256) != 0;
    newOrdered ? this$static.eFlags |= 256 : this$static.eFlags &= -257;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 2, oldOrdered, newOrdered));
}
function $setUnique_2(this$static, newUnique) {
    var oldUnique;
    oldUnique = (this$static.eFlags & 512) != 0;
    newUnique ? this$static.eFlags |= 512 : this$static.eFlags &= -513;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 3, oldUnique, newUnique));
}
function $setUpperBound(this$static, newUpperBound) {
    var oldUpperBound;
    oldUpperBound = this$static.upperBound;
    this$static.upperBound = newUpperBound;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_0(this$static, 5, oldUpperBound, this$static.upperBound));
}
function $toString_28(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_21(this$static);
    result = new StringBuffer_1($toString_21(this$static));
    result.string += ' (ordered: ';
    $append_4(result, (this$static.eFlags & 256) != 0);
    result.string += ', unique: ';
    $append_4(result, (this$static.eFlags & 512) != 0);
    result.string += ', lowerBound: ';
    $append_1(result, this$static.lowerBound);
    result.string += ', upperBound: ';
    $append_1(result, this$static.upperBound);
    result.string += ')';
    return result.string;
}
function ETypedElementImpl() {
    this.eFlags |= 256;
    this.eFlags |= 512;
}
defineClass(290, 436, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    290: 1,
    117: 1,
    118: 1
});
_.eGet = function eGet_18(featureID, resolve, coreType) {
    var eClass, lower;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 3:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 4:
            return valueOf_3(this.lowerBound);
        case 5:
            return valueOf_3(this.upperBound);
        case 6:
            return $clinit_Boolean(), this.isMany() ? true : false;
        case 7:
            return $clinit_Boolean(), lower = this.lowerBound, lower >= 1 ? true : false;
        case 8:
            if (resolve) return $getEType(this);
            return this.eType;
        case 9:
            return this.eGenericType;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), resolve, coreType);
};
_.eInverseRemove_0 = function eInverseRemove_13(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 9:
            return $basicUnsetEGenericType(this, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eIsSet = function eIsSet_17(featureID) {
    var eClass, lower;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return (this.eFlags & 256) == 0;
        case 3:
            return (this.eFlags & 512) == 0;
        case 4:
            return this.lowerBound != 0;
        case 5:
            return this.upperBound != 1;
        case 6:
            return this.isMany();
        case 7:
            return lower = this.lowerBound, lower >= 1;
        case 8:
            return !!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0;
        case 9:
            return !!this.eGenericType && !(!!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.eSet = function eSet_16(featureID, newValue) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            this.setName(castToString(newValue));
            return;
        case 2:
            $setOrdered(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 3:
            $setUnique_2(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 4:
            $setLowerBound(this, castTo(newValue, 17).value_0);
            return;
        case 5:
            this.setUpperBound(castTo(newValue, 17).value_0);
            return;
        case 8:
            $setEType(this, castTo(newValue, 141));
            return;
        case 9:
            msgs = $setEGenericType(this, castTo(newValue, 87), null);
            !!msgs && msgs.dispatch_0();
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_17() {
    return $clinit_EcorePackage$Literals(), ETYPED_ELEMENT;
};
_.eUnset = function eUnset_16(featureID) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            this.setName(null);
            return;
        case 2:
            $setOrdered(this, true);
            return;
        case 3:
            $setUnique_2(this, true);
            return;
        case 4:
            $setLowerBound(this, 0);
            return;
        case 5:
            this.setUpperBound(1);
            return;
        case 8:
            $setEType(this, null);
            return;
        case 9:
            msgs = $setEGenericType(this, null, null);
            !!msgs && msgs.dispatch_0();
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.freeze = function freeze_1() {
    $getEType(this);
    this.eFlags |= 1;
};
_.getEType = function getEType() {
    return $getEType(this);
};
_.getUpperBound = function getUpperBound() {
    return this.upperBound;
};
_.isMany = function isMany() {
    var upper;
    return upper = this.upperBound, upper > 1 || upper == -1;
};
_.isUnique = function isUnique_2() {
    return (this.eFlags & 512) != 0;
};
_.setEType = function setEType(newEType, msgs) {
    return $setEType_0(this, newEType, msgs);
};
_.setUpperBound = function setUpperBound(newUpperBound) {
    $setUpperBound(this, newUpperBound);
};
_.toString_0 = function toString_143() {
    return $toString_28(this);
};
_.lowerBound = 0;
_.upperBound = 1;
var Lorg_eclipse_emf_ecore_impl_ETypedElementImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ETypedElementImpl', 290);
function $eBasicRemoveFromContainerFeature_6(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 17) return this$static.eContainer.eInverseRemove(this$static, 21, Lorg_eclipse_emf_ecore_EClass_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? this$static.eStaticClass() : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getDefaultValue(this$static) {
    var eDataType, ePackage, eType, factory, literal;
    eType = $getEType(this$static);
    literal = this$static.defaultValueLiteral;
    if (literal == null && !!eType) return this$static.isMany() ? null : eType.getDefaultValue();
    else if (instanceOf(eType, 155)) {
        ePackage = eType.getEPackage();
        if (ePackage) {
            factory = ePackage.getEFactoryInstance();
            if (factory != this$static.defaultValueFactory) {
                eDataType = castTo(eType, 155);
                if (eDataType.isSerializable()) try {
                    this$static.defaultValue = factory.createFromString(eDataType, literal);
                } catch ($e0) {
                    $e0 = toJava($e0);
                    if (instanceOf($e0, 80)) this$static.defaultValue = null;
                    else throw toJs($e0);
                }
                this$static.defaultValueFactory = factory;
            }
        }
        return this$static.defaultValue;
    }
    return null;
}
function $getEContainingClass(this$static) {
    if (this$static.eFlags_0 >> 16 != 17) return null;
    return castTo(this$static.eContainer, 29);
}
function $getFeatureMapEntryPrototype(this$static) {
    var eOpposite;
    if (!this$static.prototypeFeatureMapEntry) {
        eOpposite = this$static.getEOpposite();
        eOpposite ? this$static.prototypeFeatureMapEntry = new EStructuralFeatureImpl$InverseUpdatingFeatureMapEntry(this$static, this$static, null) : this$static.isContainment() ? this$static.prototypeFeatureMapEntry = new EStructuralFeatureImpl$ContainmentUpdatingFeatureMapEntry(this$static, null) : $getFeatureKind($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), this$static)) == 1 ? this$static.prototypeFeatureMapEntry = new EStructuralFeatureImpl$SimpleContentFeatureMapEntry(this$static) : this$static.prototypeFeatureMapEntry = new EStructuralFeatureImpl$SimpleFeatureMapEntry(this$static, null);
    }
    return this$static.prototypeFeatureMapEntry;
}
function $isFeatureMap(this$static) {
    var eType;
    if (this$static.cachedEType != this$static.eType) {
        eType = $getEType(this$static);
        this$static.cachedIsFeatureMap = !!eType && eType.getInstanceClassName() == 'org.eclipse.emf.ecore.util.FeatureMap$Entry';
        this$static.cachedEType = eType;
    }
    return this$static.cachedIsFeatureMap;
}
function $setChangeable(this$static, newChangeable) {
    var oldChangeable;
    oldChangeable = (this$static.eFlags & $intern_149) != 0;
    newChangeable ? this$static.eFlags |= $intern_149 : this$static.eFlags &= -1025;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 10, oldChangeable, newChangeable));
}
function $setDefaultValueLiteral(this$static, newDefaultValueLiteral) {
    this$static.defaultValueFactory = null;
    $setDefaultValueLiteralGen(this$static, newDefaultValueLiteral);
}
function $setDefaultValueLiteralGen(this$static, newDefaultValueLiteral) {
    var oldDefaultValueLiteral;
    oldDefaultValueLiteral = this$static.defaultValueLiteral;
    this$static.defaultValueLiteral = newDefaultValueLiteral;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 13, oldDefaultValueLiteral, this$static.defaultValueLiteral));
}
function $setDerived(this$static, newDerived) {
    var oldDerived;
    oldDerived = (this$static.eFlags & $intern_17) != 0;
    newDerived ? this$static.eFlags |= $intern_17 : this$static.eFlags &= -16385;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 16, oldDerived, newDerived));
}
function $setFeatureID(this$static, featureID) {
    this$static.featureID = featureID;
}
function $setName_0(this$static, newName) {
    instanceOf(this$static.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(this$static.eContainer, 88)), 4);
    $setName(this$static, newName);
}
function $setTransient(this$static, newTransient) {
    var oldTransient;
    oldTransient = (this$static.eFlags & $intern_62) != 0;
    newTransient ? this$static.eFlags |= $intern_62 : this$static.eFlags &= -4097;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 12, oldTransient, newTransient));
}
function $setUnsettable(this$static, newUnsettable) {
    var oldUnsettable;
    oldUnsettable = (this$static.eFlags & $intern_152) != 0;
    newUnsettable ? this$static.eFlags |= $intern_152 : this$static.eFlags &= -8193;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 15, oldUnsettable, newUnsettable));
}
function $setVolatile(this$static, newVolatile) {
    var oldVolatile;
    oldVolatile = (this$static.eFlags & $intern_49) != 0;
    newVolatile ? this$static.eFlags |= $intern_49 : this$static.eFlags &= -2049;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 11, oldVolatile, newVolatile));
}
function $toString_29(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_28(this$static);
    result = new StringBuffer_1($toString_28(this$static));
    result.string += ' (changeable: ';
    $append_4(result, (this$static.eFlags & $intern_149) != 0);
    result.string += ', volatile: ';
    $append_4(result, (this$static.eFlags & $intern_49) != 0);
    result.string += ', transient: ';
    $append_4(result, (this$static.eFlags & $intern_62) != 0);
    result.string += ', defaultValueLiteral: ';
    $append_3(result, this$static.defaultValueLiteral);
    result.string += ', unsettable: ';
    $append_4(result, (this$static.eFlags & $intern_152) != 0);
    result.string += ', derived: ';
    $append_4(result, (this$static.eFlags & $intern_17) != 0);
    result.string += ')';
    return result.string;
}
function EStructuralFeatureImpl() {
    ETypedElementImpl.call(this);
    this.featureID = -1;
    this.defaultValue = null;
    this.defaultValueFactory = null;
    this.defaultValueLiteral = null;
    this.eFlags |= $intern_149;
}
defineClass(448, 290, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    178: 1,
    69: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    448: 1,
    290: 1,
    117: 1,
    118: 1,
    677: 1
});
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_7(msgs) {
    return $eBasicRemoveFromContainerFeature_6(this, msgs);
};
_.eGet = function eGet_19(featureID, resolve, coreType) {
    var eClass, lower;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 3:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 4:
            return valueOf_3(this.lowerBound);
        case 5:
            return valueOf_3(this.upperBound);
        case 6:
            return $clinit_Boolean(), this.isMany() ? true : false;
        case 7:
            return $clinit_Boolean(), lower = this.lowerBound, lower >= 1 ? true : false;
        case 8:
            if (resolve) return $getEType(this);
            return this.eType;
        case 9:
            return this.eGenericType;
        case 10:
            return $clinit_Boolean(), (this.eFlags & $intern_149) != 0 ? true : false;
        case 11:
            return $clinit_Boolean(), (this.eFlags & $intern_49) != 0 ? true : false;
        case 12:
            return $clinit_Boolean(), (this.eFlags & $intern_62) != 0 ? true : false;
        case 13:
            return this.defaultValueLiteral;
        case 14:
            return $getDefaultValue(this);
        case 15:
            return $clinit_Boolean(), (this.eFlags & $intern_152) != 0 ? true : false;
        case 16:
            return $clinit_Boolean(), (this.eFlags & $intern_17) != 0 ? true : false;
        case 17:
            return $getEContainingClass(this);
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_12(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 17:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_6(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 17, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_14(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 9:
            return $basicUnsetEGenericType(this, msgs);
        case 17:
            return $eBasicSetContainer(this, null, 17, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eIsSet = function eIsSet_18(featureID) {
    var eClass, lower;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return (this.eFlags & 256) == 0;
        case 3:
            return (this.eFlags & 512) == 0;
        case 4:
            return this.lowerBound != 0;
        case 5:
            return this.upperBound != 1;
        case 6:
            return this.isMany();
        case 7:
            return lower = this.lowerBound, lower >= 1;
        case 8:
            return !!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0;
        case 9:
            return !!this.eGenericType && !(!!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0);
        case 10:
            return (this.eFlags & $intern_149) == 0;
        case 11:
            return (this.eFlags & $intern_49) != 0;
        case 12:
            return (this.eFlags & $intern_62) != 0;
        case 13:
            return this.defaultValueLiteral != null;
        case 14:
            return $getDefaultValue(this) != null;
        case 15:
            return (this.eFlags & $intern_152) != 0;
        case 16:
            return (this.eFlags & $intern_17) != 0;
        case 17:
            return !!$getEContainingClass(this);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.eSet = function eSet_17(featureID, newValue) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_0(this, castToString(newValue));
            return;
        case 2:
            $setOrdered(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 3:
            $setUnique_2(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 4:
            $setLowerBound(this, castTo(newValue, 17).value_0);
            return;
        case 5:
            this.setUpperBound(castTo(newValue, 17).value_0);
            return;
        case 8:
            $setEType(this, castTo(newValue, 141));
            return;
        case 9:
            msgs = $setEGenericType(this, castTo(newValue, 87), null);
            !!msgs && msgs.dispatch_0();
            return;
        case 10:
            $setChangeable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 11:
            $setVolatile(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 12:
            $setTransient(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 13:
            $setDefaultValueLiteral(this, castToString(newValue));
            return;
        case 15:
            $setUnsettable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 16:
            $setDerived(this, $booleanValue(castToBoolean(newValue)));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_18() {
    return $clinit_EcorePackage$Literals(), ESTRUCTURAL_FEATURE;
};
_.eUnset = function eUnset_17(featureID) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(this.eContainer, 88)), 4);
            $setName(this, null);
            return;
        case 2:
            $setOrdered(this, true);
            return;
        case 3:
            $setUnique_2(this, true);
            return;
        case 4:
            $setLowerBound(this, 0);
            return;
        case 5:
            this.setUpperBound(1);
            return;
        case 8:
            $setEType(this, null);
            return;
        case 9:
            msgs = $setEGenericType(this, null, null);
            !!msgs && msgs.dispatch_0();
            return;
        case 10:
            $setChangeable(this, true);
            return;
        case 11:
            $setVolatile(this, false);
            return;
        case 12:
            $setTransient(this, false);
            return;
        case 13:
            this.defaultValueFactory = null;
            $setDefaultValueLiteralGen(this, null);
            return;
        case 15:
            $setUnsettable(this, false);
            return;
        case 16:
            $setDerived(this, false);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.freeze = function freeze_2() {
    $getName_0($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), this));
    $getEType(this);
    this.eFlags |= 1;
};
_.getContainerClass = function getContainerClass() {
    return this.containerClass;
};
_.getDefaultValue = function getDefaultValue() {
    return $getDefaultValue(this);
};
_.getEContainingClass = function getEContainingClass() {
    return $getEContainingClass(this);
};
_.getEOpposite = function getEOpposite() {
    return null;
};
_.getExtendedMetaData_0 = function getExtendedMetaData_0() {
    return this.eStructuralFeatureExtendedMetaData;
};
_.getFeatureID_0 = function getFeatureID_4() {
    return this.featureID;
};
_.getFeatureMapEntryPrototype = function getFeatureMapEntryPrototype() {
    return $getFeatureMapEntryPrototype(this);
};
_.getSettingDelegate = function getSettingDelegate() {
    var dataClass, defaultValue, eClass, eOpposite, eType, featureMapFeature, instanceClass, intrinsicDefaultValue, upper;
    if (!this.settingDelegate) {
        eClass = $getEContainingClass(this);
        (eClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(eClass), eClass.eAllStructuralFeaturesData).length;
        eOpposite = this.getEOpposite();
        !!eOpposite && $getFeatureCount($getEContainingClass(eOpposite));
        eType = $getEType(this);
        instanceClass = eType.getInstanceClass();
        dataClass = !instanceClass ? null : (instanceClass.modifiers & 1) != 0 ? instanceClass == Z_classLit ? Ljava_lang_Boolean_2_classLit : instanceClass == I_classLit ? Ljava_lang_Integer_2_classLit : instanceClass == F_classLit ? Ljava_lang_Float_2_classLit : instanceClass == D_classLit ? Ljava_lang_Double_2_classLit : instanceClass == J_classLit ? Ljava_lang_Long_2_classLit : instanceClass == S_classLit ? Ljava_lang_Short_2_classLit : instanceClass == B_classLit ? Ljava_lang_Byte_2_classLit : Ljava_lang_Character_2_classLit : instanceClass;
        defaultValue = $getDefaultValue(this);
        intrinsicDefaultValue = eType.getDefaultValue();
        getSettingDelegateFactory(this);
        (this.eFlags & $intern_17) != 0 && (!!(featureMapFeature = $getMixedFeature(($clinit_ExtendedMetaData(), INSTANCE_11), eClass)) && featureMapFeature != this || !!(featureMapFeature = $getGroup($getExtendedMetaData_1(INSTANCE_11, this)))) ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateFeatureMapDelegator(this, featureMapFeature) : this.isMany() ? this.isContainment() ? !eOpposite ? (this.eFlags & $intern_152) != 0 ? !dataClass ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(42, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(0, this) : dataClass == Ljava_util_Map$Entry_2_classLit ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(50, Lorg_eclipse_emf_common_util_BasicEMap$Entry_2_classLit, this) : this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(43, dataClass, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(1, dataClass, this) : !dataClass ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(44, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(2, this) : dataClass == Ljava_util_Map$Entry_2_classLit ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(41, Lorg_eclipse_emf_common_util_BasicEMap$Entry_2_classLit, this) : this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(45, dataClass, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(3, dataClass, this) : (this.eFlags & $intern_152) != 0 ? !dataClass ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(46, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(4, this, eOpposite) : this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(47, dataClass, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(5, dataClass, this, eOpposite) : !dataClass ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(48, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(6, this, eOpposite) : this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(49, dataClass, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(7, dataClass, this, eOpposite) : instanceOf(eType, 155) ? dataClass == Lorg_eclipse_emf_ecore_util_FeatureMap$Entry_2_classLit ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(40, this) : (this.eFlags & 512) != 0 ? (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(8, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(9, dataClass, this) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(10, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(11, dataClass, this) : (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(12, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(13, dataClass, this) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(14, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(15, dataClass, this) : !eOpposite ? this.isResolveProxies_0() ? (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(16, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(17, dataClass, this) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(18, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(19, dataClass, this) : (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(20, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(21, dataClass, this) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(22, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany(23, dataClass, this) : (upper = eOpposite.upperBound, upper > 1 || upper == -1 ? this.isResolveProxies_0() ? (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(24, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(25, dataClass, this, eOpposite) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(26, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(27, dataClass, this, eOpposite) : (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(28, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(29, dataClass, this, eOpposite) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(30, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(31, dataClass, this, eOpposite) : this.isResolveProxies_0() ? (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(32, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(33, dataClass, this, eOpposite) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(34, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(35, dataClass, this, eOpposite) : (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(36, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(37, dataClass, this, eOpposite) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_2(38, this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_0(39, dataClass, this, eOpposite)) : this.isContainer() ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleContainerResolving(castTo(eType, 29), this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleContainer(castTo(eType, 29), this, eOpposite) : instanceOf(eType, 155) ? dataClass == Lorg_eclipse_emf_ecore_util_FeatureMap$Entry_2_classLit ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateMany_1(40, this) : (this.eFlags & $intern_152) != 0 ? !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableDynamic(castTo(eType, 155), defaultValue, intrinsicDefaultValue, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableStatic(defaultValue, intrinsicDefaultValue, this, ($clinit_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator(), instanceClass == I_classLit ? INT_NOTIFICATION_CREATOR : instanceClass == Z_classLit ? BOOLEAN_NOTIFICATION_CREATOR : instanceClass == J_classLit ? LONG_NOTIFICATION_CREATOR : instanceClass == F_classLit ? FLOAT_NOTIFICATION_CREATOR : instanceClass == D_classLit ? DOUBLE_NOTIFICATION_CREATOR : instanceClass == S_classLit ? SHORT_NOTIFICATION_CREATOR : instanceClass == B_classLit ? BYTE_NOTIFICATION_CREATOR : instanceClass == C_classLit ? CHAR_NOTIFICATION_CREATOR : OBJECT_NOTIFICATION_CREATOR)) : !dataClass ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleDataDynamic(castTo(eType, 155), defaultValue, intrinsicDefaultValue, this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleDataStatic(defaultValue, intrinsicDefaultValue, this, ($clinit_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator(), instanceClass == I_classLit ? INT_NOTIFICATION_CREATOR : instanceClass == Z_classLit ? BOOLEAN_NOTIFICATION_CREATOR : instanceClass == J_classLit ? LONG_NOTIFICATION_CREATOR : instanceClass == F_classLit ? FLOAT_NOTIFICATION_CREATOR : instanceClass == D_classLit ? DOUBLE_NOTIFICATION_CREATOR : instanceClass == S_classLit ? SHORT_NOTIFICATION_CREATOR : instanceClass == B_classLit ? BYTE_NOTIFICATION_CREATOR : instanceClass == C_classLit ? CHAR_NOTIFICATION_CREATOR : OBJECT_NOTIFICATION_CREATOR)) : this.isContainment() ? !eOpposite ? (this.eFlags & $intern_152) != 0 ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettableResolving(castTo(eType, 29), this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettable(castTo(eType, 29), this) : this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentResolving(castTo(eType, 29), this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainment(castTo(eType, 29), this) : (this.eFlags & $intern_152) != 0 ? this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving(castTo(eType, 29), this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable(castTo(eType, 29), this, eOpposite) : this.isResolveProxies_0() ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseResolving(castTo(eType, 29), this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverse(castTo(eType, 29), this, eOpposite) : this.isResolveProxies_0() ? !eOpposite ? (this.eFlags & $intern_152) != 0 ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingUnsettable(castTo(eType, 29), this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolving(castTo(eType, 29), this) : (this.eFlags & $intern_152) != 0 ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable(castTo(eType, 29), this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverse(castTo(eType, 29), this, eOpposite) : !eOpposite ? (this.eFlags & $intern_152) != 0 ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectUnsettable(castTo(eType, 29), this) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObject(castTo(eType, 29), this) : (this.eFlags & $intern_152) != 0 ? this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverseUnsettable(castTo(eType, 29), this, eOpposite) : this.settingDelegate = new EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverse(castTo(eType, 29), this, eOpposite);
    }
    return this.settingDelegate;
};
_.isChangeable = function isChangeable_0() {
    return (this.eFlags & $intern_149) != 0;
};
_.isContainer = function isContainer() {
    return false;
};
_.isContainment = function isContainment_0() {
    return false;
};
_.isDerived = function isDerived_0() {
    return (this.eFlags & $intern_17) != 0;
};
_.isFeatureMap_0 = function isFeatureMap_0() {
    return $isFeatureMap(this);
};
_.isResolveProxies_0 = function isResolveProxies_0() {
    return false;
};
_.isUnsettable = function isUnsettable_0() {
    return (this.eFlags & $intern_152) != 0;
};
_.setExtendedMetaData_0 = function setExtendedMetaData_0(eStructuralFeatureExtendedMetaData) {
    this.eStructuralFeatureExtendedMetaData = eStructuralFeatureExtendedMetaData;
};
_.setName = function setName_0(newName) {
    $setName_0(this, newName);
};
_.toString_0 = function toString_144() {
    return $toString_29(this);
};
_.cachedIsFeatureMap = false;
_.featureID = 0;
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl', 448);
function $basicGetEAttributeType(this$static) {
    var eType;
    if (!this$static.eAttributeType) {
        eType = this$static.eType;
        instanceOf(eType, 155) && (this$static.eAttributeType = castTo(eType, 155));
    }
    return this$static.eAttributeType;
}
function $getEAttributeType(this$static) {
    var eType;
    if (!this$static.eAttributeType || (this$static.eFlags & 1) == 0 && this$static.eAttributeType.eIsProxy()) {
        eType = $getEType(this$static);
        instanceOf(eType, 155) && (this$static.eAttributeType = castTo(eType, 155));
    }
    return this$static.eAttributeType;
}
function $isMany(this$static) {
    var eType, upper;
    switch(this$static.effectiveIsMany){
        case -1:
            return true;
        case 0:
            upper = this$static.upperBound;
            if (upper > 1 || upper == -1) {
                this$static.effectiveIsMany = -1;
                return true;
            } else {
                eType = $getEType(this$static);
                if (!!eType && ($clinit_FeatureMapUtil(), eType.getInstanceClassName() == 'org.eclipse.emf.ecore.util.FeatureMap$Entry')) {
                    this$static.effectiveIsMany = -1;
                    return true;
                } else {
                    this$static.effectiveIsMany = 1;
                    return false;
                }
            }
        default:
        case 1:
            return false;
    }
}
function $setID(this$static, newID) {
    var oldID;
    oldID = (this$static.eFlags & $intern_137) != 0;
    newID ? this$static.eFlags |= $intern_137 : this$static.eFlags &= -32769;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 18, oldID, newID));
}
function $setUpperBound_0(this$static, upperBound) {
    this$static.effectiveIsMany = 0;
    $setUpperBound(this$static, upperBound);
}
function EAttributeImpl() {
    EStructuralFeatureImpl.call(this);
}
defineClass(330, 448, {
    109: 1,
    93: 1,
    92: 1,
    35: 1,
    154: 1,
    197: 1,
    57: 1,
    178: 1,
    69: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    330: 1,
    157: 1,
    448: 1,
    290: 1,
    117: 1,
    118: 1,
    677: 1
}, EAttributeImpl);
_.eGet = function eGet_20(featureID, resolve, coreType) {
    var eClass, lower;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 3:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 4:
            return valueOf_3(this.lowerBound);
        case 5:
            return valueOf_3(this.upperBound);
        case 6:
            return $clinit_Boolean(), $isMany(this) ? true : false;
        case 7:
            return $clinit_Boolean(), lower = this.lowerBound, lower >= 1 ? true : false;
        case 8:
            if (resolve) return $getEType(this);
            return this.eType;
        case 9:
            return this.eGenericType;
        case 10:
            return $clinit_Boolean(), (this.eFlags & $intern_149) != 0 ? true : false;
        case 11:
            return $clinit_Boolean(), (this.eFlags & $intern_49) != 0 ? true : false;
        case 12:
            return $clinit_Boolean(), (this.eFlags & $intern_62) != 0 ? true : false;
        case 13:
            return this.defaultValueLiteral;
        case 14:
            return $getDefaultValue(this);
        case 15:
            return $clinit_Boolean(), (this.eFlags & $intern_152) != 0 ? true : false;
        case 16:
            return $clinit_Boolean(), (this.eFlags & $intern_17) != 0 ? true : false;
        case 17:
            return $getEContainingClass(this);
        case 18:
            return $clinit_Boolean(), (this.eFlags & $intern_137) != 0 ? true : false;
        case 19:
            if (resolve) return $getEAttributeType(this);
            return $basicGetEAttributeType(this);
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EATTRIBUTE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EATTRIBUTE : eClass), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_19(featureID) {
    var eClass, lower;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return (this.eFlags & 256) == 0;
        case 3:
            return (this.eFlags & 512) == 0;
        case 4:
            return this.lowerBound != 0;
        case 5:
            return this.upperBound != 1;
        case 6:
            return $isMany(this);
        case 7:
            return lower = this.lowerBound, lower >= 1;
        case 8:
            return !!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0;
        case 9:
            return !!this.eGenericType && !(!!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0);
        case 10:
            return (this.eFlags & $intern_149) == 0;
        case 11:
            return (this.eFlags & $intern_49) != 0;
        case 12:
            return (this.eFlags & $intern_62) != 0;
        case 13:
            return this.defaultValueLiteral != null;
        case 14:
            return $getDefaultValue(this) != null;
        case 15:
            return (this.eFlags & $intern_152) != 0;
        case 16:
            return (this.eFlags & $intern_17) != 0;
        case 17:
            return !!$getEContainingClass(this);
        case 18:
            return (this.eFlags & $intern_137) != 0;
        case 19:
            return !!$basicGetEAttributeType(this);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EATTRIBUTE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EATTRIBUTE : eClass), featureID));
};
_.eSet = function eSet_18(featureID, newValue) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_0(this, castToString(newValue));
            return;
        case 2:
            $setOrdered(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 3:
            $setUnique_2(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 4:
            $setLowerBound(this, castTo(newValue, 17).value_0);
            return;
        case 5:
            $setUpperBound_0(this, castTo(newValue, 17).value_0);
            return;
        case 8:
            $setEType(this, castTo(newValue, 141));
            return;
        case 9:
            msgs = $setEGenericType(this, castTo(newValue, 87), null);
            !!msgs && msgs.dispatch_0();
            return;
        case 10:
            $setChangeable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 11:
            $setVolatile(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 12:
            $setTransient(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 13:
            $setDefaultValueLiteral(this, castToString(newValue));
            return;
        case 15:
            $setUnsettable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 16:
            $setDerived(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 18:
            $setID(this, $booleanValue(castToBoolean(newValue)));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EATTRIBUTE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EATTRIBUTE : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_19() {
    return $clinit_EcorePackage$Literals(), EATTRIBUTE;
};
_.eUnset = function eUnset_18(featureID) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(this.eContainer, 88)), 4);
            $setName(this, null);
            return;
        case 2:
            $setOrdered(this, true);
            return;
        case 3:
            $setUnique_2(this, true);
            return;
        case 4:
            $setLowerBound(this, 0);
            return;
        case 5:
            this.effectiveIsMany = 0;
            $setUpperBound(this, 1);
            return;
        case 8:
            $setEType(this, null);
            return;
        case 9:
            msgs = $setEGenericType(this, null, null);
            !!msgs && msgs.dispatch_0();
            return;
        case 10:
            $setChangeable(this, true);
            return;
        case 11:
            $setVolatile(this, false);
            return;
        case 12:
            $setTransient(this, false);
            return;
        case 13:
            this.defaultValueFactory = null;
            $setDefaultValueLiteralGen(this, null);
            return;
        case 15:
            $setUnsettable(this, false);
            return;
        case 16:
            $setDerived(this, false);
            return;
        case 18:
            $setID(this, false);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EATTRIBUTE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EATTRIBUTE : eClass), featureID));
};
_.freeze = function freeze_3() {
    $getEAttributeType(this);
    $getName_0($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), this));
    $getEType(this);
    this.eFlags |= 1;
};
_.isMany = function isMany_0() {
    return $isMany(this);
};
_.setEType = function setEType_0(newEType, msgs) {
    this.effectiveIsMany = 0;
    this.eAttributeType = null;
    return $setEType_0(this, newEType, msgs);
};
_.setUpperBound = function setUpperBound_0(upperBound) {
    $setUpperBound_0(this, upperBound);
};
_.toString_0 = function toString_145() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_29(this);
    result = new StringBuffer_1($toString_29(this));
    result.string += ' (iD: ';
    $append_4(result, (this.eFlags & $intern_137) != 0);
    result.string += ')';
    return result.string;
};
_.effectiveIsMany = 0;
var Lorg_eclipse_emf_ecore_impl_EAttributeImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EAttributeImpl', 330);
function $basicGetEPackage(this$static) {
    if (this$static.eFlags_0 >> 16 != 6) return null;
    return castTo(this$static.eContainer, 240);
}
function $basicSetInstanceClassName(this$static, value_0) {
    if (this$static.instanceClassName == null && this$static.generatedInstanceClassName != null) {
        this$static.instanceClassName = this$static.generatedInstanceClassName;
        this$static.generatedInstanceClassName = null;
    }
    $setInstanceClassNameGen(this$static, value_0 == null ? null : (checkCriticalNotNull(value_0), value_0));
    !!this$static.instanceClass && this$static.setInstanceClassGen(null);
}
function $basicSetInstanceTypeName(this$static, newInstanceTypeName) {
    var oldInstanceTypeName;
    oldInstanceTypeName = this$static.instanceTypeName;
    this$static.instanceTypeName = newInstanceTypeName;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 5, oldInstanceTypeName, newInstanceTypeName));
}
function $eBasicRemoveFromContainerFeature_7(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 6) return this$static.eContainer.eInverseRemove(this$static, 5, Lorg_eclipse_emf_ecore_EPackage_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? this$static.eStaticClass() : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getEPackage(this$static) {
    var result;
    if (this$static.ePackage) return this$static.ePackage;
    else {
        result = $getEPackageGen(this$static);
        !!result && !result.eIsProxy() && (this$static.ePackage = result);
        return result;
    }
}
function $getEPackageGen(this$static) {
    if (this$static.eFlags_0 >> 16 != 6) return null;
    return castTo($eContainer(this$static), 240);
}
function $getInstanceClass(this$static) {
    var primitiveClass;
    if (!this$static.instanceClass && (this$static.instanceClassName != null || this$static.generatedInstanceClassName != null)) {
        primitiveClass = $getPrimitiveOrArrayClass(this$static);
        if (primitiveClass) this$static.setInstanceClassGen(primitiveClass);
        else try {
            this$static.setInstanceClassGen(null);
        } catch ($e0) {
            $e0 = toJava($e0);
            if (!instanceOf($e0, 63)) throw toJs($e0);
        }
    }
    return this$static.instanceClass;
}
function $getPrimitiveOrArrayClass(this$static) {
    var arrayIndex, className, componentClassName, result;
    className = this$static.instanceClassName != null ? this$static.instanceClassName : this$static.generatedInstanceClassName;
    arrayIndex = $indexOf_1(className, fromCodePoint(91));
    if (arrayIndex != -1) {
        componentClassName = (checkCriticalStringBounds(0, arrayIndex, className.length), className.substr(0, arrayIndex));
        result = new StringBuffer;
        do result.string += '[';
        while ((arrayIndex = $indexOf_0(className, 91, ++arrayIndex)) != -1);
        if ($equals_5(componentClassName, 'boolean')) result.string += 'Z';
        else if ($equals_5(componentClassName, 'byte')) result.string += 'B';
        else if ($equals_5(componentClassName, 'char')) result.string += 'C';
        else if ($equals_5(componentClassName, 'double')) result.string += 'D';
        else if ($equals_5(componentClassName, 'float')) result.string += 'F';
        else if ($equals_5(componentClassName, 'int')) result.string += 'I';
        else if ($equals_5(componentClassName, 'long')) result.string += 'J';
        else if ($equals_5(componentClassName, 'short')) result.string += 'S';
        else {
            result.string += 'L';
            result.string += '' + componentClassName;
            result.string += ';';
        }
        try {
            return null;
        } catch ($e0) {
            $e0 = toJava($e0);
            if (!instanceOf($e0, 63)) throw toJs($e0);
        }
    } else if ($indexOf_1(className, fromCodePoint(46)) == -1) {
        if ($equals_5(className, 'boolean')) return Z_classLit;
        else if ($equals_5(className, 'byte')) return B_classLit;
        else if ($equals_5(className, 'char')) return C_classLit;
        else if ($equals_5(className, 'double')) return D_classLit;
        else if ($equals_5(className, 'float')) return F_classLit;
        else if ($equals_5(className, 'int')) return I_classLit;
        else if ($equals_5(className, 'long')) return J_classLit;
        else if ($equals_5(className, 'short')) return S_classLit;
    }
    return null;
}
function $isInstance(this$static, object) {
    var helper, instanceClass;
    if (object != null) {
        instanceClass = $getInstanceClass(this$static);
        if (instanceClass) {
            if ((instanceClass.modifiers & 1) != 0) {
                if (instanceClass == Z_classLit) return instanceOfBoolean(object);
                else if (instanceClass == I_classLit) return instanceOf(object, 17);
                else if (instanceClass == F_classLit) return instanceOf(object, 160);
                else if (instanceClass == B_classLit) return instanceOf(object, 219);
                else if (instanceClass == C_classLit) return instanceOf(object, 179);
                else if (instanceClass == D_classLit) return instanceOfDouble(object);
                else if (instanceClass == S_classLit) return instanceOf(object, 191);
                else if (instanceClass == J_classLit) return instanceOf(object, 190);
            } else return $clinit_Reflect(), helper = castTo($get_10(HELPER_REGISTRY, instanceClass), 58), !helper || helper.isInstance(object);
        } else if (instanceOf(object, 57)) return this$static.dynamicIsInstance(castTo(object, 57));
    }
    return false;
}
function $setGeneratedInstanceClass(this$static, isGenerated) {
    if (isGenerated) {
        if (this$static.generatedInstanceClassName == null) {
            this$static.generatedInstanceClassName = this$static.instanceClassName;
            this$static.instanceClassName = null;
        }
    } else if (this$static.generatedInstanceClassName != null) {
        this$static.instanceClassName = this$static.generatedInstanceClassName;
        this$static.generatedInstanceClassName = null;
    }
}
function $setInstanceClass(this$static, value_0) {
    var component, indices, name_0;
    if (!value_0) {
        $setInstanceClassNameGen(this$static, null);
        $basicSetInstanceTypeName(this$static, null);
    } else if ((value_0.modifiers & 4) != 0) {
        indices = '[]';
        for(component = value_0.componentType;; component = component.componentType){
            if ((component.modifiers & 4) == 0) {
                name_0 = $intern(($ensureNamesAreInitialized(component), component.typeName + indices));
                $setInstanceClassNameGen(this$static, name_0);
                $basicSetInstanceTypeName(this$static, name_0);
                break;
            }
            indices += '[]';
        }
    } else {
        name_0 = $intern(($ensureNamesAreInitialized(value_0), value_0.typeName));
        $setInstanceClassNameGen(this$static, name_0);
        $basicSetInstanceTypeName(this$static, name_0);
    }
    this$static.setInstanceClassGen(value_0);
}
function $setInstanceClassName(this$static, value_0) {
    $basicSetInstanceClassName(this$static, value_0);
    $basicSetInstanceTypeName(this$static, this$static.instanceClassName);
}
function $setInstanceClassNameGen(this$static, newInstanceClassName) {
    var oldInstanceClassName;
    oldInstanceClassName = this$static.instanceClassName;
    this$static.instanceClassName = newInstanceClassName;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 2, oldInstanceClassName, this$static.instanceClassName));
}
function $setInstanceTypeName(this$static, newInstanceTypeName) {
    var end, index_0, newInstanceClassName, oldInstanceTypeName;
    oldInstanceTypeName = this$static.instanceTypeName;
    if (newInstanceTypeName == null) {
        this$static.instanceTypeName = null;
        $basicSetInstanceClassName(this$static, null);
    } else {
        this$static.instanceTypeName = (checkCriticalNotNull(newInstanceTypeName), newInstanceTypeName);
        index_0 = $indexOf_1(newInstanceTypeName, fromCodePoint(60));
        if (index_0 != -1) {
            newInstanceClassName = (checkCriticalStringBounds(0, index_0, newInstanceTypeName.length), newInstanceTypeName.substr(0, index_0));
            $indexOf_1(newInstanceTypeName, fromCodePoint(46)) == -1 && !$equals_5(newInstanceClassName, 'boolean') && !$equals_5(newInstanceClassName, 'byte') && !$equals_5(newInstanceClassName, 'char') && !$equals_5(newInstanceClassName, 'double') && !$equals_5(newInstanceClassName, 'float') && !$equals_5(newInstanceClassName, 'int') && !$equals_5(newInstanceClassName, 'long') && !$equals_5(newInstanceClassName, 'short') && (newInstanceClassName = 'java.lang.Object');
            end = $lastIndexOf(newInstanceTypeName, fromCodePoint(62));
            end != -1 && (newInstanceClassName += '' + (checkCriticalStringElementIndex(end + 1, newInstanceTypeName.length + 1), newInstanceTypeName.substr(end + 1)));
            $basicSetInstanceClassName(this$static, newInstanceClassName);
        } else {
            newInstanceClassName = newInstanceTypeName;
            if ($indexOf_1(newInstanceTypeName, fromCodePoint(46)) == -1) {
                index_0 = $indexOf_1(newInstanceTypeName, fromCodePoint(91));
                index_0 != -1 && (newInstanceClassName = (checkCriticalStringBounds(0, index_0, newInstanceTypeName.length), newInstanceTypeName.substr(0, index_0)));
                if (!$equals_5(newInstanceClassName, 'boolean') && !$equals_5(newInstanceClassName, 'byte') && !$equals_5(newInstanceClassName, 'char') && !$equals_5(newInstanceClassName, 'double') && !$equals_5(newInstanceClassName, 'float') && !$equals_5(newInstanceClassName, 'int') && !$equals_5(newInstanceClassName, 'long') && !$equals_5(newInstanceClassName, 'short')) {
                    newInstanceClassName = 'java.lang.Object';
                    index_0 != -1 && (newInstanceClassName += '' + (checkCriticalStringElementIndex(index_0, newInstanceTypeName.length + 1), newInstanceTypeName.substr(index_0)));
                } else newInstanceClassName = newInstanceTypeName;
            }
            $basicSetInstanceClassName(this$static, newInstanceClassName);
            newInstanceClassName == newInstanceTypeName && (this$static.instanceTypeName = this$static.instanceClassName);
        }
    }
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 5, oldInstanceTypeName, newInstanceTypeName));
}
function $setName_1(this$static, newName) {
    instanceOf(this$static.eContainer, 184) && (castTo(this$static.eContainer, 184).eNameToEClassifierMap = null);
    $setName(this$static, newName);
}
function $toString_30(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_21(this$static);
    result = new StringBuffer_1($toString_21(this$static));
    result.string += ' (instanceClassName: ';
    $append_3(result, this$static.instanceClassName);
    result.string += ')';
    return result.string;
}
defineClass(357, 436, {
    109: 1,
    93: 1,
    92: 1,
    141: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    357: 1,
    157: 1,
    117: 1,
    118: 1,
    676: 1
});
_.dynamicIsInstance = function dynamicIsInstance(eObject) {
    return eObject.eClass_0() == this;
};
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_8(msgs) {
    return $eBasicRemoveFromContainerFeature_7(this, msgs);
};
_.eBasicSetContainer = function eBasicSetContainer_5(newContainer, newContainerFeatureID) {
    this.ePackage = null;
    this.eFlags_0 = newContainerFeatureID << 16 | this.eFlags_0 & 255;
    this.eContainer = newContainer;
};
_.eGet = function eGet_21(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return this.instanceClassName != null ? this.instanceClassName : this.generatedInstanceClassName;
        case 3:
            return $getInstanceClass(this);
        case 4:
            return this.getDefaultValue();
        case 5:
            return this.instanceTypeName;
        case 6:
            if (resolve) return $getEPackage(this);
            return $basicGetEPackage(this);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), this.eTypeParameters;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_13(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 6:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_7(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 6, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_15(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 6:
            return $eBasicSetContainer(this, null, 6, msgs);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), $basicRemove_0(this.eTypeParameters, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eIsSet = function eIsSet_20(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return this.instanceClassName != null && this.instanceClassName == this.instanceTypeName;
        case 3:
            return !!$getInstanceClass(this);
        case 4:
            return this.getDefaultValue() != null;
        case 5:
            return this.instanceTypeName != null && this.instanceTypeName != this.instanceClassName && this.instanceTypeName != this.generatedInstanceClassName;
        case 6:
            return !!$basicGetEPackage(this);
        case 7:
            return !!this.eTypeParameters && this.eTypeParameters.size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.eSet = function eSet_19(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_1(this, castToString(newValue));
            return;
        case 2:
            $setInstanceClassName(this, castToString(newValue));
            return;
        case 5:
            $setInstanceTypeName(this, castToString(newValue));
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $addAll_9(this.eTypeParameters, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_20() {
    return $clinit_EcorePackage$Literals(), ECLASSIFIER;
};
_.eUnset = function eUnset_19(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 184) && (castTo(this.eContainer, 184).eNameToEClassifierMap = null);
            $setName(this, null);
            return;
        case 2:
            $basicSetInstanceClassName(this, null);
            $basicSetInstanceTypeName(this, this.instanceClassName);
            return;
        case 5:
            $setInstanceTypeName(this, null);
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.getClassifierID = function getClassifierID() {
    var ePackage;
    return this.metaObjectID == -1 && (this.metaObjectID = (ePackage = $getEPackage(this), ePackage ? $indexOf_6(ePackage.getEClassifiers(), this) : -1)), this.metaObjectID;
};
_.getDefaultValue = function getDefaultValue_0() {
    return null;
};
_.getEPackage = function getEPackage() {
    return $getEPackage(this);
};
_.getExtendedMetaData_1 = function getExtendedMetaData_1() {
    return this.eClassifierExtendedMetaData;
};
_.getInstanceClass = function getInstanceClass() {
    return $getInstanceClass(this);
};
_.getInstanceClassName = function getInstanceClassName() {
    return this.instanceClassName != null ? this.instanceClassName : this.generatedInstanceClassName;
};
_.getInstanceTypeName = function getInstanceTypeName() {
    return this.instanceTypeName;
};
_.isInstance = function isInstance_0(object) {
    return $isInstance(this, object);
};
_.setExtendedMetaData_1 = function setExtendedMetaData_1(eClassifierExtendedMetaData) {
    this.eClassifierExtendedMetaData = eClassifierExtendedMetaData;
};
_.setGeneratedInstanceClass = function setGeneratedInstanceClass(isGenerated) {
    $setGeneratedInstanceClass(this, isGenerated);
};
_.setInstanceClassGen = function setInstanceClassGen(newInstanceClass) {
    this.instanceClass = newInstanceClass;
};
_.setName = function setName_1(newName) {
    $setName_1(this, newName);
};
_.toString_0 = function toString_146() {
    return $toString_30(this);
};
_.instanceClass = null;
_.instanceClassName = null;
_.metaObjectID = -1;
var Lorg_eclipse_emf_ecore_impl_EClassifierImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassifierImpl', 357);
function $clinit_EClassImpl() {
    $clinit_EClassImpl = emptyMethod;
    COMPUTATION_IN_PROGRESS = new EClassImpl$MyHashSet;
    NO_EALL_STRUCTURE_FEATURES_DATA = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, 1), $intern_153, 178, 0, []);
    NO_EALL_OPERATIONS_DATA = stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EOperation_2_classLit, 1), $intern_154, 62, 0, []);
}
function $getEAllAttributes(this$static) {
    var attributes, computationInProgress, eStructuralFeature, eStructuralFeature$iterator, eSuperType, eSuperType$iterator, old, result;
    if (!this$static.eAllAttributes) {
        this$static.eIDAttribute = null;
        result = new EClassImpl$2(this$static);
        attributes = new EClassImpl$3;
        computationInProgress = COMPUTATION_IN_PROGRESS;
        old = computationInProgress.map_0.put(this$static, computationInProgress);
        if (old == null) {
            for(eSuperType$iterator = new AbstractEList$EIterator($getESuperTypes(this$static)); eSuperType$iterator.cursor != eSuperType$iterator.this$01_2.size_1();){
                eSuperType = castTo($doNext(eSuperType$iterator), 29);
                $addAll_9(result, $getEAllAttributes(eSuperType));
            }
            computationInProgress.map_0.remove_0(this$static);
            computationInProgress.map_0.size_1() == 0 && undefined;
        }
        for(eStructuralFeature$iterator = (!this$static.eStructuralFeatures && (this$static.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this$static, 21, 17)), new AbstractEList$EIterator(this$static.eStructuralFeatures)); eStructuralFeature$iterator.cursor != eStructuralFeature$iterator.this$01_2.size_1();){
            eStructuralFeature = castTo($doNext(eStructuralFeature$iterator), 178);
            instanceOf(eStructuralFeature, 330) && $add_21(attributes, castTo(eStructuralFeature, 35));
        }
        $shrink_0(attributes);
        this$static.eAttributes = new EClassImpl$4(this$static, (castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 7), 19), attributes.size_0), attributes.data_0);
        $addAll_9(result, this$static.eAttributes);
        $shrink_0(result);
        this$static.eAllAttributes = new EcoreEList$UnmodifiableEList$FastCompare((castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 4), 19), result.size_0), result.data_0);
        $getESuperAdapter(this$static).modifiedState &= -2;
    }
    return this$static.eAllAttributes;
}
function $getEAllContainments(this$static) {
    var eReference, eReference$iterator, result;
    if (!this$static.eAllContainments) {
        result = new EClassImpl$7;
        for(eReference$iterator = new AbstractEList$NonResolvingEIterator($getEAllReferences(this$static)); eReference$iterator.cursor != eReference$iterator.this$01_2.size_1();){
            eReference = castTo($doNext_0(eReference$iterator), 19);
            (eReference.eFlags & $intern_137) != 0 && $add_21(result, eReference);
        }
        $shrink_0(result);
        this$static.eAllContainments = new EcoreEList$UnmodifiableEList$FastCompare((castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 8), 19), result.size_0), result.data_0);
        $getESuperAdapter(this$static).modifiedState &= -9;
    }
    return this$static.eAllContainments;
}
function $getEAllGenericSuperTypes(this$static) {
    var computationInProgress, eGenericSuperType, eGenericSuperType$iterator, eSuperType, old, result;
    if (!this$static.eAllGenericSuperTypes) {
        result = new EClassImpl$1EGenericSuperTypeEList;
        computationInProgress = COMPUTATION_IN_PROGRESS;
        old = computationInProgress.map_0.put(this$static, computationInProgress);
        if (old == null) {
            for(eGenericSuperType$iterator = new AbstractEList$EIterator($getEGenericSuperTypes(this$static)); eGenericSuperType$iterator.cursor != eGenericSuperType$iterator.this$01_2.size_1();){
                eGenericSuperType = castTo($doNext(eGenericSuperType$iterator), 87);
                eSuperType = $getERawType(eGenericSuperType);
                instanceOf(eSuperType, 88) && $addAll_9(result, $getEAllGenericSuperTypes(castTo(eSuperType, 29)));
                $add_21(result, eGenericSuperType);
            }
            computationInProgress.map_0.remove_0(this$static);
            computationInProgress.map_0.size_1() == 0 && undefined;
        }
        $eliminateEquivalentDuplicates(result);
        $shrink_0(result);
        this$static.eAllGenericSuperTypes = new EcoreEList$UnmodifiableEList$FastCompare((castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 15), 19), result.size_0), result.data_0);
        $getESuperAdapter(this$static).modifiedState &= -33;
    }
    return this$static.eAllGenericSuperTypes;
}
function $getEAllOperations(this$static) {
    var computationInProgress, eSuperType, eSuperType$iterator, i, old, operationID, result;
    if (!this$static.eAllOperations) {
        result = new EClassImpl$6;
        computationInProgress = COMPUTATION_IN_PROGRESS;
        old = computationInProgress.map_0.put(this$static, computationInProgress);
        if (old == null) {
            for(eSuperType$iterator = new AbstractEList$EIterator($getESuperTypes(this$static)); eSuperType$iterator.cursor != eSuperType$iterator.this$01_2.size_1();){
                eSuperType = castTo($doNext(eSuperType$iterator), 29);
                $addAll_9(result, $getEAllOperations(eSuperType));
            }
            computationInProgress.map_0.remove_0(this$static);
            computationInProgress.map_0.size_1() == 0 && undefined;
        }
        operationID = result.size_0;
        for(i = (!this$static.eOperations && (this$static.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this$static, 11, 10)), new AbstractEList$EIterator(this$static.eOperations)); i.cursor != i.this$01_2.size_1(); ++operationID)castTo($doNext(i), 400);
        $addAll_9(result, (!this$static.eOperations && (this$static.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this$static, 11, 10)), this$static.eOperations));
        $shrink_0(result);
        this$static.eAllOperations = new EcoreEList$UnmodifiableEList$FastCompare((castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 9), 19), result.size_0), result.data_0);
        this$static.eAllOperationsData = castTo(result.data_0, 673);
        this$static.eAllOperationsData == null && (this$static.eAllOperationsData = NO_EALL_OPERATIONS_DATA);
        $getESuperAdapter(this$static).modifiedState &= -17;
    }
    return this$static.eAllOperations;
}
function $getEAllReferences(this$static) {
    var computationInProgress, eStructuralFeature, eStructuralFeature$iterator, eSuperType, eSuperType$iterator, old, references, result;
    if (!this$static.eAllReferences) {
        result = new EClassImpl$1ReferenceList;
        references = new EClassImpl$1ReferenceList;
        computationInProgress = COMPUTATION_IN_PROGRESS;
        old = computationInProgress.map_0.put(this$static, computationInProgress);
        if (old == null) {
            for(eSuperType$iterator = new AbstractEList$EIterator($getESuperTypes(this$static)); eSuperType$iterator.cursor != eSuperType$iterator.this$01_2.size_1();){
                eSuperType = castTo($doNext(eSuperType$iterator), 29);
                $addAll_9(result, $getEAllReferences(eSuperType));
            }
            computationInProgress.map_0.remove_0(this$static);
            computationInProgress.map_0.size_1() == 0 && undefined;
        }
        for(eStructuralFeature$iterator = (!this$static.eStructuralFeatures && (this$static.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this$static, 21, 17)), new AbstractEList$EIterator(this$static.eStructuralFeatures)); eStructuralFeature$iterator.cursor != eStructuralFeature$iterator.this$01_2.size_1();){
            eStructuralFeature = castTo($doNext(eStructuralFeature$iterator), 178);
            instanceOf(eStructuralFeature, 101) && $add_21(references, castTo(eStructuralFeature, 19));
        }
        $shrink_0(references);
        this$static.eReferences = new EClassImpl$5(this$static, (castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 6), 19), references.size_0), references.data_0);
        $addAll_9(result, this$static.eReferences);
        $shrink_0(result);
        this$static.eAllReferences = new EcoreEList$UnmodifiableEList$FastCompare((castTo($get_20($getEStructuralFeatures(eINSTANCE_2.eClassEClass), 5), 19), result.size_0), result.data_0);
        $getESuperAdapter(this$static).modifiedState &= -3;
    }
    return this$static.eAllReferences;
}
function $getEAllStructuralFeatures(this$static) {
    var computationInProgress, eSuperType, eSuperType$iterator, featureID, i, old, result;
    if (!this$static.eAllStructuralFeatures) {
        result = new EClassImpl$1EStructuralFeatureUniqueEList;
        computationInProgress = COMPUTATION_IN_PROGRESS;
        old = computationInProgress.map_0.put(this$static, computationInProgress);
        if (old == null) {
            for(eSuperType$iterator = new AbstractEList$EIterator($getESuperTypes(this$static)); eSuperType$iterator.cursor != eSuperType$iterator.this$01_2.size_1();){
                eSuperType = castTo($doNext(eSuperType$iterator), 29);
                $addAll_9(result, $getEAllStructuralFeatures(eSuperType));
            }
            computationInProgress.map_0.remove_0(this$static);
            computationInProgress.map_0.size_1() == 0 && undefined;
        }
        featureID = result.size_0;
        for(i = (!this$static.eStructuralFeatures && (this$static.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this$static, 21, 17)), new AbstractEList$EIterator(this$static.eStructuralFeatures)); i.cursor != i.this$01_2.size_1(); ++featureID)$setFeatureID(castTo($doNext(i), 448), featureID);
        $addAll_9(result, (!this$static.eStructuralFeatures && (this$static.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this$static, 21, 17)), this$static.eStructuralFeatures));
        $shrink_0(result);
        this$static.eAllStructuralFeatures = new EClassImpl$1EAllStructuralFeaturesList(this$static, result);
        this$static.eAllStructuralFeaturesData = castTo(result.data_0, 253);
        this$static.eAllStructuralFeaturesData == null && (this$static.eAllStructuralFeaturesData = NO_EALL_STRUCTURE_FEATURES_DATA);
        this$static.eNameToFeatureMap = null;
        $getESuperAdapter(this$static).modifiedState &= -5;
    }
    return this$static.eAllStructuralFeatures;
}
function $getEAllSuperTypes(this$static) {
    var computationInProgress, eSuperType, eSuperType$iterator, higherSupers, old, result;
    if (!this$static.eAllSuperTypes) {
        result = new EClassImpl$9;
        computationInProgress = COMPUTATION_IN_PROGRESS;
        old = computationInProgress.map_0.put(this$static, computationInProgress);
        if (old == null) {
            for(eSuperType$iterator = new AbstractEList$EIterator($getESuperTypes(this$static)); eSuperType$iterator.cursor != eSuperType$iterator.this$01_2.size_1();){
                eSuperType = castTo($doNext(eSuperType$iterator), 29);
                higherSupers = $getEAllSuperTypes(eSuperType);
                $addAll_9(result, higherSupers);
                $add_21(result, eSuperType);
            }
            computationInProgress.map_0.remove_0(this$static);
        }
        $shrink_0(result);
        this$static.eAllSuperTypes = new EcoreEList$UnmodifiableEList$FastCompare((castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 11), 19), result.size_0), result.data_0);
        $getESuperAdapter(this$static).modifiedState &= -33;
    }
    return this$static.eAllSuperTypes;
}
function $getEGenericSuperTypes(this$static) {
    if (!this$static.eGenericSuperTypes) {
        $getESuperAdapter(this$static);
        this$static.eGenericSuperTypes = new EClassImpl$1(this$static, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this$static);
        $getESuperTypes(this$static);
    }
    return this$static.eGenericSuperTypes;
}
function $getEOperations(this$static) {
    !this$static.eOperations && (this$static.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this$static, 11, 10));
    return this$static.eOperations;
}
function $getEStructuralFeature(this$static, featureID) {
    var eAllStructuralFeaturesData;
    eAllStructuralFeaturesData = (this$static.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(this$static), this$static.eAllStructuralFeaturesData);
    return featureID >= 0 && featureID < eAllStructuralFeaturesData.length ? eAllStructuralFeaturesData[featureID] : null;
}
function $getEStructuralFeature_0(this$static, name_0) {
    var duplicate, eStructuralFeature, eStructuralFeature$iterator, key, result;
    (this$static.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(this$static), this$static.eAllStructuralFeaturesData).length;
    if (!this$static.eNameToFeatureMap) {
        result = new HashMap_0((3 * this$static.eAllStructuralFeatures.size_0 / 2 | 0) + 1);
        for(eStructuralFeature$iterator = new AbstractEList$NonResolvingEIterator(this$static.eAllStructuralFeatures); eStructuralFeature$iterator.cursor != eStructuralFeature$iterator.this$01_2.size_1();){
            eStructuralFeature = castTo($doNext_0(eStructuralFeature$iterator), 178);
            key = eStructuralFeature.getName();
            duplicate = castTo(key == null ? $put_9(result.hashCodeMap, null, eStructuralFeature) : $put_10(result.stringMap, key, eStructuralFeature), 178);
            !!duplicate && (key == null ? $put_9(result.hashCodeMap, null, duplicate) : $put_10(result.stringMap, key, duplicate));
        }
        this$static.eNameToFeatureMap = result;
    }
    return castTo($getStringValue(this$static.eNameToFeatureMap, name_0), 178);
}
function $getEStructuralFeatures(this$static) {
    !this$static.eStructuralFeatures && (this$static.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this$static, 21, 17));
    return this$static.eStructuralFeatures;
}
function $getESuperAdapter(this$static) {
    if (!this$static.eSuperAdapter) {
        this$static.eSuperAdapter = new EClassImpl$10(this$static);
        $add_20(new MinimalEObjectImpl$1ArrayDelegatingAdapterList(this$static), 0, this$static.eSuperAdapter);
    }
    return this$static.eSuperAdapter;
}
function $getESuperTypes(this$static) {
    if (!this$static.eSuperTypes) {
        $getESuperAdapter(this$static);
        this$static.eSuperTypes = new EClassImpl$8(this$static, this$static);
    }
    return this$static.eSuperTypes;
}
function $getFeatureCount(this$static) {
    return (this$static.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(this$static), this$static.eAllStructuralFeaturesData).length;
}
function $getFeatureID(this$static, feature) {
    var eAllStructuralFeaturesData, index_0, last;
    eAllStructuralFeaturesData = (this$static.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(this$static), this$static.eAllStructuralFeaturesData);
    index_0 = feature.getFeatureID_0();
    if (index_0 != -1) for(last = eAllStructuralFeaturesData.length; index_0 < last; ++index_0){
        if (eAllStructuralFeaturesData[index_0] == feature) return index_0;
    }
    return -1;
}
function $isSetESuperTypes(this$static) {
    return !!this$static.eSuperTypes && $getEGenericSuperTypes(this$static.eSuperTypes.this$01).size_0 != 0 && !(!!this$static.eGenericSuperTypes && $isSet(this$static.eGenericSuperTypes));
}
function $isSuperTypeOf(this$static, someClass) {
    return someClass == this$static || $contains_10($getEAllSuperTypes(someClass), this$static);
}
function $setAbstract(this$static, newAbstract) {
    var oldAbstract;
    oldAbstract = (this$static.eFlags & 256) != 0;
    newAbstract ? this$static.eFlags |= 256 : this$static.eFlags &= -257;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 8, oldAbstract, newAbstract));
}
function $setInterface(this$static, newInterface) {
    var oldInterface;
    oldInterface = (this$static.eFlags & 512) != 0;
    newInterface ? this$static.eFlags |= 512 : this$static.eFlags &= -513;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 9, oldInterface, newInterface));
}
function $toString_31(this$static) {
    var result;
    if ((this$static.eFlags_0 & 64) != 0) return $toString_30(this$static);
    result = new StringBuffer_1($toString_30(this$static));
    result.string += ' (abstract: ';
    $append_4(result, (this$static.eFlags & 256) != 0);
    result.string += ', interface: ';
    $append_4(result, (this$static.eFlags & 512) != 0);
    result.string += ')';
    return result.string;
}
function EClassImpl() {
    $clinit_EClassImpl();
}
defineClass(88, 357, {
    109: 1,
    93: 1,
    92: 1,
    29: 1,
    141: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    88: 1,
    357: 1,
    157: 1,
    468: 1,
    117: 1,
    118: 1,
    676: 1
}, EClassImpl);
_.dynamicIsInstance = function dynamicIsInstance_0(eObject) {
    return $isSuperTypeOf(this, eObject.eClass_0());
};
_.eGet = function eGet_22(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return this.instanceClassName != null ? this.instanceClassName : this.generatedInstanceClassName;
        case 3:
            return $getInstanceClass(this);
        case 4:
            return null;
        case 5:
            return this.instanceTypeName;
        case 6:
            if (resolve) return $getEPackage(this);
            return $basicGetEPackage(this);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), this.eTypeParameters;
        case 8:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 9:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 10:
            return $getESuperTypes(this);
        case 11:
            return !this.eOperations && (this.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this, 11, 10)), this.eOperations;
        case 12:
            return $getEAllAttributes(this);
        case 13:
            return $getEAllReferences(this);
        case 14:
            return $getEAllReferences(this), this.eReferences;
        case 15:
            return $getEAllAttributes(this), this.eAttributes;
        case 16:
            return $getEAllContainments(this);
        case 17:
            return $getEAllOperations(this);
        case 18:
            return $getEAllStructuralFeatures(this);
        case 19:
            return $getEAllSuperTypes(this);
        case 20:
            return $getEAllAttributes(this), this.eIDAttribute;
        case 21:
            return !this.eStructuralFeatures && (this.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this, 21, 17)), this.eStructuralFeatures;
        case 22:
            return $getEGenericSuperTypes(this);
        case 23:
            return $getEAllGenericSuperTypes(this);
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ECLASS)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ECLASS : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_14(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 6:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_7(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 6, msgs);
        case 11:
            return !this.eOperations && (this.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this, 11, 10)), $basicAdd_0(this.eOperations, otherEnd, msgs);
        case 21:
            return !this.eStructuralFeatures && (this.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this, 21, 17)), $basicAdd_0(this.eStructuralFeatures, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), ECLASS) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ECLASS)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_16(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 6:
            return $eBasicSetContainer(this, null, 6, msgs);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), $basicRemove_0(this.eTypeParameters, otherEnd, msgs);
        case 11:
            return !this.eOperations && (this.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this, 11, 10)), $basicRemove_0(this.eOperations, otherEnd, msgs);
        case 21:
            return !this.eStructuralFeatures && (this.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this, 21, 17)), $basicRemove_0(this.eStructuralFeatures, otherEnd, msgs);
        case 22:
            return $basicRemove_0($getEGenericSuperTypes(this), otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), ECLASS) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ECLASS)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_21(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return this.instanceClassName != null && this.instanceClassName == this.instanceTypeName;
        case 3:
            return !!$getInstanceClass(this);
        case 4:
            return false;
        case 5:
            return this.instanceTypeName != null && this.instanceTypeName != this.instanceClassName && this.instanceTypeName != this.generatedInstanceClassName;
        case 6:
            return !!$basicGetEPackage(this);
        case 7:
            return !!this.eTypeParameters && this.eTypeParameters.size_0 != 0;
        case 8:
            return (this.eFlags & 256) != 0;
        case 9:
            return (this.eFlags & 512) != 0;
        case 10:
            return !!this.eSuperTypes && $getEGenericSuperTypes(this.eSuperTypes.this$01).size_0 != 0 && !(!!this.eGenericSuperTypes && $isSet(this.eGenericSuperTypes));
        case 11:
            return !!this.eOperations && this.eOperations.size_0 != 0;
        case 12:
            return $getEAllAttributes(this).size_0 != 0;
        case 13:
            return $getEAllReferences(this).size_0 != 0;
        case 14:
            return $getEAllReferences(this), this.eReferences.size_0 != 0;
        case 15:
            return $getEAllAttributes(this), this.eAttributes.size_0 != 0;
        case 16:
            return $getEAllContainments(this).size_0 != 0;
        case 17:
            return $getEAllOperations(this).size_0 != 0;
        case 18:
            return $getEAllStructuralFeatures(this).size_0 != 0;
        case 19:
            return $getEAllSuperTypes(this).size_0 != 0;
        case 20:
            return $getEAllAttributes(this), !!this.eIDAttribute;
        case 21:
            return !!this.eStructuralFeatures && this.eStructuralFeatures.size_0 != 0;
        case 22:
            return !!this.eGenericSuperTypes && $isSet(this.eGenericSuperTypes);
        case 23:
            return $getEAllGenericSuperTypes(this).size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ECLASS)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ECLASS : eClass), featureID));
};
_.eObjectForURIFragmentSegment = function eObjectForURIFragmentSegment_2(uriFragmentSegment) {
    var result;
    result = this.eAllStructuralFeaturesData == null || !!this.eOperations && this.eOperations.size_0 != 0 ? null : $getEStructuralFeature_0(this, uriFragmentSegment);
    return result ? result : $eObjectForURIFragmentSegment_0(this, uriFragmentSegment);
};
_.eSet = function eSet_20(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_1(this, castToString(newValue));
            return;
        case 2:
            $setInstanceClassName(this, castToString(newValue));
            return;
        case 5:
            $setInstanceTypeName(this, castToString(newValue));
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $addAll_9(this.eTypeParameters, castTo(newValue, 16));
            return;
        case 8:
            $setAbstract(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 9:
            $setInterface(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 10:
            $clear_12($getESuperTypes(this));
            $addAll_9($getESuperTypes(this), castTo(newValue, 16));
            return;
        case 11:
            !this.eOperations && (this.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this, 11, 10));
            $clear_13(this.eOperations);
            !this.eOperations && (this.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this, 11, 10));
            $addAll_9(this.eOperations, castTo(newValue, 16));
            return;
        case 21:
            !this.eStructuralFeatures && (this.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this, 21, 17));
            $clear_13(this.eStructuralFeatures);
            !this.eStructuralFeatures && (this.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this, 21, 17));
            $addAll_9(this.eStructuralFeatures, castTo(newValue, 16));
            return;
        case 22:
            $clear_13($getEGenericSuperTypes(this));
            $addAll_9($getEGenericSuperTypes(this), castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ECLASS)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ECLASS : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_21() {
    return $clinit_EcorePackage$Literals(), ECLASS;
};
_.eUnset = function eUnset_20(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 184) && (castTo(this.eContainer, 184).eNameToEClassifierMap = null);
            $setName(this, null);
            return;
        case 2:
            $basicSetInstanceClassName(this, null);
            $basicSetInstanceTypeName(this, this.instanceClassName);
            return;
        case 5:
            $setInstanceTypeName(this, null);
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            return;
        case 8:
            $setAbstract(this, false);
            return;
        case 9:
            $setInterface(this, false);
            return;
        case 10:
            !!this.eSuperTypes && $clear_12(this.eSuperTypes);
            return;
        case 11:
            !this.eOperations && (this.eOperations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EOperation_2_classLit, this, 11, 10));
            $clear_13(this.eOperations);
            return;
        case 21:
            !this.eStructuralFeatures && (this.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, this, 21, 17));
            $clear_13(this.eStructuralFeatures);
            return;
        case 22:
            !!this.eGenericSuperTypes && $clear_13(this.eGenericSuperTypes);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ECLASS)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ECLASS : eClass), featureID));
};
_.freeze = function freeze_4() {
    var i, size_0;
    $getEAllAttributes(this);
    $getEAllReferences(this);
    $getEAllContainments(this);
    $getEAllOperations(this);
    $getEAllStructuralFeatures(this);
    $getEAllSuperTypes(this);
    $getEAllGenericSuperTypes(this);
    $clear_11($getSubclasses($getESuperAdapter(this)));
    if (this.eStructuralFeatures) for(i = 0, size_0 = this.eStructuralFeatures.size_0; i < size_0; ++i)$freeze($get_20(this.eStructuralFeatures, i));
    if (this.eOperations) for(i = 0, size_0 = this.eOperations.size_0; i < size_0; ++i)$freeze($get_20(this.eOperations, i));
    $getExtendedMetaData(($clinit_ExtendedMetaData(), INSTANCE_11), this).getName();
    this.eFlags |= 1;
};
_.toString_0 = function toString_147() {
    return $toString_31(this);
};
_.eAttributes = null;
_.eReferences = null;
var COMPUTATION_IN_PROGRESS, NO_EALL_OPERATIONS_DATA, NO_EALL_STRUCTURE_FEATURES_DATA;
var Lorg_eclipse_emf_ecore_impl_EClassImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl', 88);
defineClass(2038, 2037, $intern_155);
_.addAllUnique = function addAllUnique_9(index_0, collection) {
    return $addAllUnique_3(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_10(collection) {
    return $addAllUnique_3(this, this.size_0, collection);
};
_.addUnique = function addUnique_10(index_0, object) {
    $addUnique_5(this, index_0, object);
};
_.addUnique_0 = function addUnique_11(object) {
    $addUnique_6(this, object);
};
_.basicAdd = function basicAdd_0(object, notifications) {
    return $basicAdd_0(this, object, notifications);
};
_.basicGet = function basicGet_1(index_0) {
    return $basicGet(this, index_0);
};
_.basicRemove = function basicRemove_0(object, notifications) {
    return $basicRemove_0(this, object, notifications);
};
_.setUnique = function setUnique_4(index_0, object) {
    return $setUnique_1(this, index_0, object);
};
_.basicIterator = function basicIterator_2() {
    return new AbstractEList$NonResolvingEIterator(this);
};
_.basicListIterator = function basicListIterator_5() {
    return new AbstractEList$NonResolvingEListIterator(this);
};
_.basicListIterator_0 = function basicListIterator_6(index_0) {
    return $basicListIterator(this, index_0);
};
var Lorg_eclipse_emf_ecore_util_NotifyingInternalEListImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'NotifyingInternalEListImpl', 2038);
function $contains_11(this$static, object) {
    var containedEObject, eContainer, eObject, i, opposite, result, result0;
    if (this$static.isEObject()) {
        if (this$static.size_0 > 4) {
            if (this$static.isInstance(object)) {
                if (this$static.isContainment()) {
                    eObject = castTo(object, 52);
                    eContainer = eObject.eContainer_0();
                    result0 = eContainer == this$static.owner && (this$static.hasNavigableInverse() ? eObject.eBaseStructuralFeatureID(eObject.eContainerFeatureID_0(), this$static.getInverseFeatureClass()) == this$static.getInverseFeatureID() : -1 - eObject.eContainerFeatureID_0() == this$static.getFeatureID_0());
                    if (this$static.hasProxies() && !result0 && !eContainer && !!eObject.eDirectResource()) for(i = 0; i < this$static.size_0; ++i){
                        containedEObject = this$static.resolveProxy(castTo(this$static.data_0[i], 57));
                        if (maskUndefined(containedEObject) === maskUndefined(object)) return true;
                    }
                    return result0;
                } else if (this$static.hasNavigableInverse() && !this$static.hasManyInverse()) {
                    opposite = castTo(object, 57).eGet_0($getEOpposite(castTo(this$static.getEStructuralFeature(), 19)));
                    if (maskUndefined(opposite) === maskUndefined(this$static.owner)) return true;
                    else if (opposite == null || !castTo(opposite, 57).eIsProxy()) return false;
                }
            } else return false;
        }
        result = $contains_10(this$static, object);
        if (this$static.hasProxies() && !result) for(i = 0; i < this$static.size_0; ++i){
            eObject = this$static.resolveProxy(castTo(this$static.data_0[i], 57));
            if (maskUndefined(eObject) === maskUndefined(object)) return true;
        }
        return result;
    } else return $contains_10(this$static, object);
}
function $createNotification(this$static, eventType, oldObject, newObject, index_0, wasSet) {
    return new ENotificationImpl_3(this$static.owner, eventType, this$static.getFeatureID_0(), oldObject, newObject, index_0, wasSet);
}
function $dispatchNotification(this$static, notification) {
    $eNotify(this$static.owner, notification);
}
function $indexOf_6(this$static, object) {
    var eObject, i, index_0;
    index_0 = $indexOf_4(this$static, object);
    if (index_0 >= 0) return index_0;
    if (this$static.isEObject()) for(i = 0; i < this$static.size_0; ++i){
        eObject = this$static.resolveProxy(castTo(this$static.data_0[i], 57));
        if (maskUndefined(eObject) === maskUndefined(object)) return i;
    }
    return -1;
}
function $resolve(this$static, index_0, eObject) {
    var element, notificationChain, oldElement, oldObject, resolved, resolvedElement;
    resolved = this$static.resolveProxy(eObject);
    if (resolved != eObject) {
        oldObject = this$static.data_0[index_0];
        resolvedElement = resolved;
        $assign(this$static, index_0, this$static.validate(index_0, resolvedElement));
        oldElement = oldObject;
        this$static.didSet(index_0, resolvedElement, oldElement);
        if (this$static.isContainment()) {
            element = eObject;
            notificationChain = this$static.inverseRemove(element, null);
            !castTo(resolved, 52).eInternalContainer() && (notificationChain = this$static.inverseAdd(resolvedElement, notificationChain));
            !!notificationChain && notificationChain.dispatch_0();
        }
        $eNotificationRequired(this$static.owner) && $dispatchNotification(this$static, this$static.createNotification(9, eObject, resolved, index_0, false));
        return resolved;
    } else return eObject;
}
function $set_13(this$static, newValue) {
    $clear_13(this$static);
    this$static.addAll(castTo(newValue, 15));
}
function $toArray_10(this$static) {
    var i;
    if (this$static.hasProxies()) for(i = this$static.size_0 - 1; i >= 0; --i)$get_20(this$static, i);
    return $toArray_8(this$static);
}
function $validate_0(this$static, index_0, object) {
    $validate(this$static, object);
    if (!this$static.hasInstanceClass() && object != null && !this$static.isInstance(object)) throw toJs(new ArrayStoreException);
    return object;
}
function EcoreEList(dataClass, owner) {
    this.dataClass = dataClass;
    this.owner = owner;
}
defineClass(617, 2038, $intern_156);
_.contains = function contains_62(object) {
    return $contains_11(this, object);
};
_.createNotification = function createNotification_1(eventType, oldObject, newObject, index_0, wasSet) {
    return $createNotification(this, eventType, oldObject, newObject, index_0, wasSet);
};
_.dispatchNotification = function dispatchNotification_1(notification) {
    $dispatchNotification(this, notification);
};
_.get_6 = function get_60(resolve) {
    return this;
};
_.getEStructuralFeature = function getEStructuralFeature_0() {
    return $getEStructuralFeature(this.owner.eClass_0(), this.getFeatureID_0());
};
_.getFeature = function getFeature_4() {
    return this.getEStructuralFeature();
};
_.getFeatureID_0 = function getFeatureID_5() {
    return $getFeatureID(this.owner.eClass_0(), this.getEStructuralFeature());
};
_.getInverseFeatureClass = function getInverseFeatureClass() {
    return castTo(this.getEStructuralFeature().getEType(), 29).getInstanceClass();
};
_.getInverseFeatureID = function getInverseFeatureID() {
    return $getEOpposite(castTo(this.getEStructuralFeature(), 19)).featureID;
};
_.getNotifier = function getNotifier_4() {
    return this.owner;
};
_.hasInstanceClass = function hasInstanceClass() {
    return true;
};
_.hasManyInverse = function hasManyInverse() {
    return false;
};
_.hasNavigableInverse = function hasNavigableInverse() {
    return false;
};
_.hasProxies = function hasProxies() {
    return false;
};
_.indexOf_0 = function indexOf_15(object) {
    return $indexOf_6(this, object);
};
_.inverseAdd = function inverseAdd_1(object, notifications) {
    var internalEObject;
    return internalEObject = castTo(object, 52), this.hasNavigableInverse() ? this.hasInstanceClass() ? internalEObject.eInverseAdd(this.owner, this.getInverseFeatureID(), this.getInverseFeatureClass(), notifications) : internalEObject.eInverseAdd(this.owner, $getFeatureID(internalEObject.eClass_0(), $getEOpposite(castTo(this.getEStructuralFeature(), 19))), null, notifications) : internalEObject.eInverseAdd(this.owner, -1 - this.getFeatureID_0(), null, notifications);
};
_.inverseRemove = function inverseRemove_1(object, notifications) {
    var internalEObject;
    return internalEObject = castTo(object, 52), this.hasNavigableInverse() ? this.hasInstanceClass() ? internalEObject.eInverseRemove(this.owner, this.getInverseFeatureID(), this.getInverseFeatureClass(), notifications) : internalEObject.eInverseRemove(this.owner, $getFeatureID(internalEObject.eClass_0(), $getEOpposite(castTo(this.getEStructuralFeature(), 19))), null, notifications) : internalEObject.eInverseRemove(this.owner, -1 - this.getFeatureID_0(), null, notifications);
};
_.isContainment = function isContainment_1() {
    return false;
};
_.isEObject = function isEObject() {
    return true;
};
_.isInstance = function isInstance_1(object) {
    return isInstance(this.dataClass, object);
};
_.isNotificationRequired = function isNotificationRequired_1() {
    return $eNotificationRequired(this.owner);
};
_.isSet_0 = function isSet_3() {
    return this.size_0 != 0;
};
_.newData = function newData_3(capacity) {
    return newInstance_11(this.dataClass, capacity);
};
_.resolve = function resolve_1(index_0, object) {
    return this.isEObject() && this.hasProxies() ? $resolve(this, index_0, castTo(object, 57)) : object;
};
_.resolveProxy = function resolveProxy(eObject) {
    return eObject.eIsProxy() ? $eResolveProxy(this.owner, castTo(eObject, 52)) : eObject;
};
_.set_1 = function set_31(newValue) {
    $set_13(this, newValue);
};
_.toArray = function toArray_38() {
    return $toArray_10(this);
};
_.toArray_0 = function toArray_39(array) {
    var i;
    if (this.hasProxies()) for(i = this.size_0 - 1; i >= 0; --i)$get_20(this, i);
    return $toArray_9(this, array);
};
_.unset = function unset_1() {
    $clear_13(this);
};
_.validate = function validate_0(index_0, object) {
    return $validate_0(this, index_0, object);
};
var Lorg_eclipse_emf_ecore_util_EcoreEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEList', 617);
function EObjectEList(dataClass, owner, featureID) {
    EcoreEList.call(this, dataClass, owner);
    this.featureID = featureID;
}
defineClass(489, 617, $intern_156, EObjectEList);
_.canContainNull = function canContainNull_2() {
    return false;
};
_.getFeatureID_0 = function getFeatureID_6() {
    return this.featureID;
};
_.hasInverse = function hasInverse_1() {
    return false;
};
_.isEObject = function isEObject_0() {
    return true;
};
_.isUnique = function isUnique_3() {
    return true;
};
_.resolve = function resolve_2(index_0, object) {
    return object;
};
_.useEquals = function useEquals_1() {
    return false;
};
_.featureID = 0;
var Lorg_eclipse_emf_ecore_util_EObjectEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectEList', 489);
function EObjectContainmentEList(dataClass, owner, featureID) {
    EObjectEList.call(this, dataClass, owner, featureID);
}
defineClass(81, 489, $intern_156, EObjectContainmentEList);
_.hasInverse = function hasInverse_2() {
    return true;
};
_.hasNavigableInverse = function hasNavigableInverse_0() {
    return false;
};
_.isContainment = function isContainment_2() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EObjectContainmentEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentEList', 81);
function EObjectContainmentEList$Unsettable(dataClass, owner, featureID) {
    EObjectContainmentEList.call(this, dataClass, owner, featureID);
}
defineClass(540, 81, $intern_156, EObjectContainmentEList$Unsettable);
_.didChange = function didChange_0() {
    this.isSet = true;
};
_.isSet_0 = function isSet_4() {
    return this.isSet;
};
_.unset = function unset_2() {
    var oldIsSet;
    $clear_13(this);
    if ($eNotificationRequired(this.owner)) {
        oldIsSet = this.isSet;
        this.isSet = false;
        $eNotify(this.owner, new ENotificationImpl_4(this.owner, 2, this.featureID, oldIsSet, false));
    } else this.isSet = false;
};
_.isSet = false;
var Lorg_eclipse_emf_ecore_util_EObjectContainmentEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentEList/Unsettable', 540);
function $isSet(this$static) {
    var eGenericType, eGenericType$iterator;
    for(eGenericType$iterator = new AbstractEList$EIterator(this$static); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        if (!!eGenericType.eTypeParameter || (!eGenericType.eTypeArguments && (eGenericType.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, eGenericType, 1)), eGenericType.eTypeArguments).size_0 != 0) return true;
    }
    return false;
}
function $shadowAdd(this$static, eGenericType, notifications) {
    var notification, result;
    notification = new ENotificationImpl_3(this$static.owner, 3, 10, null, (result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT)), $indexOf_6(this$static, eGenericType), false);
    !notifications ? notifications = notification : notifications.add_5(notification);
    return notifications;
}
function $shadowRemove(this$static, eGenericType, notifications) {
    var notification, result;
    notification = new ENotificationImpl_3(this$static.owner, 4, 10, (result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT)), null, $indexOf_6(this$static, eGenericType), false);
    !notifications ? notifications = notification : notifications.add_5(notification);
    return notifications;
}
function $shadowSet(this$static, oldEGenericType, newEGenericType, notifications) {
    var notification, result, result0;
    notification = new ENotificationImpl_3(this$static.owner, 1, 10, (result0 = oldEGenericType.eRawType, instanceOf(result0, 88) ? castTo(result0, 29) : ($clinit_EcorePackage$Literals(), EOBJECT)), (result = newEGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT)), $indexOf_6(this$static, oldEGenericType), false);
    !notifications ? notifications = notification : notifications.add_5(notification);
    return notifications;
}
function EClassImpl$1(this$0, $anonymous0, $anonymous1) {
    this.this$01 = this$0;
    EObjectContainmentEList$Unsettable.call(this, $anonymous0, $anonymous1, 22);
}
defineClass(1125, 540, $intern_156, EClassImpl$1);
_.move = function move_14(targetIndex, sourceIndex) {
    var result0, result;
    return result0 = castTo($move_1(this, targetIndex, sourceIndex), 87), $eNotificationRequired(this.owner) && $dispatchNotification(this, new ENotificationImpl_18(this.this$01, 7, ($clinit_EcorePackage$Literals(), ECLASS__ESUPER_TYPES), valueOf_3(sourceIndex), (result = result0.eRawType, instanceOf(result, 88) ? castTo(result, 29) : EOBJECT), targetIndex)), result0;
};
_.shadowAdd = function shadowAdd_0(eGenericType, notifications) {
    return $shadowAdd(this, castTo(eGenericType, 87), notifications);
};
_.shadowRemove = function shadowRemove_0(eGenericType, notifications) {
    return $shadowRemove(this, castTo(eGenericType, 87), notifications);
};
_.shadowSet = function shadowSet_0(oldEGenericType, newEGenericType, notifications) {
    return $shadowSet(this, castTo(oldEGenericType, 87), castTo(newEGenericType, 87), notifications);
};
_.createNotification = function createNotification_2(eventType, oldObject, newObject, index_0, wasSet) {
    switch(eventType){
        case 3:
            return $createNotification(this, eventType, oldObject, newObject, index_0, this.size_0 > 1);
        case 5:
            return $createNotification(this, eventType, oldObject, newObject, index_0, this.size_0 - castTo(newObject, 15).size_1() > 0);
        default:
            return new ENotificationImpl_3(this.owner, eventType, this.featureID, oldObject, newObject, index_0, true);
    }
};
_.hasShadow = function hasShadow_0() {
    return true;
};
_.isSet_0 = function isSet_5() {
    return $isSet(this);
};
_.unset = function unset_3() {
    $clear_13(this);
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/1', 1125);
function $getSubclasses(this$static) {
    !this$static.subclasses && (this$static.subclasses = new ESuperAdapter$1);
    return this$static.subclasses;
}
function $setFlags(this$static, featureId) {
    var eSuperAdapter, i, oldModifiedState, subclass;
    oldModifiedState = this$static.modifiedState;
    switch(featureId){
        case 1:
            this$static.modifiedState |= 1;
            this$static.modifiedState |= 4;
            this$static.modifiedState |= 8;
            break;
        case 2:
            this$static.modifiedState |= 2;
            this$static.modifiedState |= 4;
            this$static.modifiedState |= 8;
            break;
        case 4:
            this$static.modifiedState |= 1;
            this$static.modifiedState |= 2;
            this$static.modifiedState |= 4;
            this$static.modifiedState |= 8;
            break;
        case 3:
            this$static.modifiedState |= 16;
            this$static.modifiedState |= 8;
            break;
        case 0:
            this$static.modifiedState |= 32;
            this$static.modifiedState |= 16;
            this$static.modifiedState |= 8;
            this$static.modifiedState |= 1;
            this$static.modifiedState |= 2;
            this$static.modifiedState |= 4;
            break;
    }
    if (this$static.modifiedState != oldModifiedState && !!this$static.subclasses) for(i = new AbstractEList$EIterator(this$static.subclasses); i.cursor != i.this$01_2.size_1();){
        subclass = castTo($doNext(i), 468);
        eSuperAdapter = $getESuperAdapter(subclass);
        $setFlags_0(eSuperAdapter, featureId);
    }
}
function getFeatureID_7(notification) {
    var featureID;
    featureID = notification.getFeatureID(null);
    switch(featureID){
        case 10:
            return 0;
        case 15:
            return 1;
        case 14:
            return 2;
        case 11:
            return 3;
        case 21:
            return 4;
    }
    return -1;
}
defineClass(1139, 1138, $intern_142);
_.notifyChanged = function notifyChanged_0(notification) {
    var eSuperAdapter, eventType, featureID, holder, i, newValue, oldValue;
    eventType = notification.getEventType();
    if (eventType != 8) {
        featureID = getFeatureID_7(notification);
        if (featureID == 0) switch(eventType){
            case 1:
            case 9:
                oldValue = notification.getOldValue();
                if (oldValue != null) {
                    eSuperAdapter = $getESuperAdapter(castTo(oldValue, 468));
                    !eSuperAdapter.subclasses && (eSuperAdapter.subclasses = new ESuperAdapter$1);
                    $remove_32(eSuperAdapter.subclasses, notification.getNotifier());
                }
                newValue = notification.getNewValue();
                if (newValue != null) {
                    holder = castTo(newValue, 468);
                    if ((holder.eFlags & 1) == 0) {
                        eSuperAdapter = $getESuperAdapter(holder);
                        !eSuperAdapter.subclasses && (eSuperAdapter.subclasses = new ESuperAdapter$1);
                        $add_21(eSuperAdapter.subclasses, castTo(notification.getNotifier(), 29));
                    }
                }
                break;
            case 3:
                newValue = notification.getNewValue();
                if (newValue != null) {
                    holder = castTo(newValue, 468);
                    if ((holder.eFlags & 1) == 0) {
                        eSuperAdapter = $getESuperAdapter(holder);
                        !eSuperAdapter.subclasses && (eSuperAdapter.subclasses = new ESuperAdapter$1);
                        $add_21(eSuperAdapter.subclasses, castTo(notification.getNotifier(), 29));
                    }
                }
                break;
            case 5:
                newValue = notification.getNewValue();
                if (newValue != null) for(i = castTo(newValue, 16).iterator_0(); i.hasNext_0();){
                    holder = castTo(i.next_1(), 468);
                    if ((holder.eFlags & 1) == 0) {
                        eSuperAdapter = $getESuperAdapter(holder);
                        !eSuperAdapter.subclasses && (eSuperAdapter.subclasses = new ESuperAdapter$1);
                        $add_21(eSuperAdapter.subclasses, castTo(notification.getNotifier(), 29));
                    }
                }
                break;
            case 4:
                oldValue = notification.getOldValue();
                if (oldValue != null) {
                    holder = castTo(oldValue, 468);
                    if ((holder.eFlags & 1) == 0) {
                        eSuperAdapter = $getESuperAdapter(holder);
                        !eSuperAdapter.subclasses && (eSuperAdapter.subclasses = new ESuperAdapter$1);
                        $remove_32(eSuperAdapter.subclasses, notification.getNotifier());
                    }
                }
                break;
            case 6:
                oldValue = notification.getOldValue();
                if (oldValue != null) for(i = castTo(oldValue, 16).iterator_0(); i.hasNext_0();){
                    holder = castTo(i.next_1(), 468);
                    if ((holder.eFlags & 1) == 0) {
                        eSuperAdapter = $getESuperAdapter(holder);
                        !eSuperAdapter.subclasses && (eSuperAdapter.subclasses = new ESuperAdapter$1);
                        $remove_32(eSuperAdapter.subclasses, notification.getNotifier());
                    }
                }
                break;
        }
        this.setFlags(featureID);
    }
};
_.setFlags = function setFlags(featureId) {
    $setFlags(this, featureId);
};
_.modifiedState = 63;
var Lorg_eclipse_emf_ecore_impl_ESuperAdapter_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ESuperAdapter', 1139);
function $setFlags_0(this$static, featureId) {
    $setFlags(this$static, featureId);
    (this$static.modifiedState & 1) != 0 && (this$static.this$01.eAllAttributes = null);
    (this$static.modifiedState & 2) != 0 && (this$static.this$01.eAllReferences = null);
    if ((this$static.modifiedState & 4) != 0) {
        this$static.this$01.eAllStructuralFeatures = null;
        this$static.this$01.eAllStructuralFeaturesData = null;
    }
    if ((this$static.modifiedState & 16) != 0) {
        this$static.this$01.eAllOperations = null;
        this$static.this$01.eAllOperationsData = null;
    }
    (this$static.modifiedState & 8) != 0 && (this$static.this$01.eAllContainments = null);
    if ((this$static.modifiedState & 32) != 0) {
        this$static.this$01.eAllSuperTypes = null;
        this$static.this$01.eAllGenericSuperTypes = null;
    }
}
function EClassImpl$10(this$0) {
    this.this$01 = this$0;
}
defineClass(1140, 1139, $intern_142, EClassImpl$10);
_.setFlags = function setFlags_0(featureId) {
    $setFlags_0(this, featureId);
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$10_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/10', 1140);
defineClass(1129, 694, $intern_156);
_.addAllUnique = function addAllUnique_11(index_0, collection) {
    return $addAllUnique(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_12(collection) {
    return $addAllUnique_0(this, collection);
};
_.addUnique = function addUnique_12(index_0, object) {
    $addUnique(this, index_0, object);
};
_.addUnique_0 = function addUnique_13(object) {
    $addUnique_0(this, object);
};
_.basicGet = function basicGet_2(index_0) {
    return $basicGet(this, index_0);
};
_.setUnique = function setUnique_5(index_0, object) {
    return $setUnique(this, index_0, object);
};
_.basicAdd = function basicAdd_1(object, notifications) {
    throw toJs(new UnsupportedOperationException);
};
_.basicIterator = function basicIterator_3() {
    return new AbstractEList$NonResolvingEIterator(this);
};
_.basicListIterator = function basicListIterator_7() {
    return new AbstractEList$NonResolvingEListIterator(this);
};
_.basicListIterator_0 = function basicListIterator_8(index_0) {
    return $basicListIterator(this, index_0);
};
_.basicRemove = function basicRemove_1(object, notifications) {
    throw toJs(new UnsupportedOperationException);
};
_.get_6 = function get_61(resolve) {
    return this;
};
_.isSet_0 = function isSet_6() {
    return this.size_0 != 0;
};
_.set_1 = function set_32(newValue) {
    throw toJs(new UnsupportedOperationException);
};
_.unset = function unset_4() {
    throw toJs(new UnsupportedOperationException);
};
var Lorg_eclipse_emf_ecore_util_EcoreEList$UnmodifiableEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEList/UnmodifiableEList', 1129);
function EcoreEList$UnmodifiableEList$FastCompare(size_0, data_0) {
    BasicEList$UnmodifiableEList.call(this, size_0, data_0);
}
defineClass(328, 1129, $intern_156, EcoreEList$UnmodifiableEList$FastCompare);
_.useEquals = function useEquals_2() {
    return false;
};
var Lorg_eclipse_emf_ecore_util_EcoreEList$UnmodifiableEList$FastCompare_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEList/UnmodifiableEList/FastCompare', 328);
function $containments(this$static) {
    maskUndefined(this$static.containments) === maskUndefined(($clinit_EClassImpl(), NO_EALL_STRUCTURE_FEATURES_DATA)) && $init_2(this$static);
    return this$static.containments;
}
function $init_2(this$static) {
    var containmentsList, crossReferencesList, eAnnotation, eAnnotation0, eAnnotation1, eReference, eStructuralFeature, i, isMixed, theOpposite;
    containmentsList = new EClassImpl$1EStructuralFeatureUniqueEList;
    crossReferencesList = new EClassImpl$1EStructuralFeatureUniqueEList;
    isMixed = $equals_5('mixed', (eAnnotation0 = $getEAnnotation(this$static.this$01, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData'), !eAnnotation0 ? null : castToString($get_21((!eAnnotation0.details && (eAnnotation0.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation0)), eAnnotation0.details), 'kind'))));
    for(i = 0; i < this$static.size_0; ++i){
        eStructuralFeature = castTo(this$static.data_0[i], 178);
        if (instanceOf(eStructuralFeature, 101)) {
            eReference = castTo(eStructuralFeature, 19);
            (eReference.eFlags & $intern_137) != 0 ? ((eReference.eFlags & $intern_17) == 0 || !isMixed && (eAnnotation1 = $getEAnnotation(eReference, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData'), (!eAnnotation1 ? null : castToString($get_21((!eAnnotation1.details && (eAnnotation1.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation1)), eAnnotation1.details), 'group'))) == null)) && $add_21(containmentsList, eReference) : (theOpposite = $getEOpposite(eReference), !!theOpposite && (theOpposite.eFlags & $intern_137) != 0 || ((eReference.eFlags & $intern_17) == 0 || !isMixed && (eAnnotation = $getEAnnotation(eReference, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData'), (!eAnnotation ? null : castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'group'))) == null)) && $add_21(crossReferencesList, eReference));
        } else {
            $clinit_FeatureMapUtil();
            if (castTo(eStructuralFeature, 69).isFeatureMap_0()) {
                if (!eStructuralFeature.isDerived()) {
                    $add_21(containmentsList, eStructuralFeature);
                    $add_21(crossReferencesList, eStructuralFeature);
                }
            }
        }
    }
    $shrink_0(containmentsList);
    $shrink_0(crossReferencesList);
    this$static.containments = castTo(containmentsList.data_0, 253);
    castTo(crossReferencesList.data_0, 253);
}
function EClassImpl$1EAllStructuralFeaturesList(this$0, eAllStructuralFeatures) {
    this.this$01 = this$0;
    EcoreEList$UnmodifiableEList$FastCompare.call(this, (castTo($get_20($getEStructuralFeatures(($clinit_EcorePackage(), eINSTANCE_2).eClassEClass), 10), 19), eAllStructuralFeatures.size_0), eAllStructuralFeatures.data_0);
    this.containments = ($clinit_EClassImpl(), NO_EALL_STRUCTURE_FEATURES_DATA);
}
defineClass(1132, 328, $intern_156, EClassImpl$1EAllStructuralFeaturesList);
_.indexOf_0 = function indexOf_16(object) {
    var eStructuralFeature, index_0, last;
    if (instanceOf(object, 178)) {
        eStructuralFeature = castTo(object, 178);
        index_0 = eStructuralFeature.getFeatureID_0();
        if (index_0 != -1) for(last = this.size_0; index_0 < last; ++index_0){
            if (maskUndefined(this.data_0[index_0]) === maskUndefined(object)) return index_0;
        }
    }
    return -1;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$1EAllStructuralFeaturesList_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/1EAllStructuralFeaturesList', 1132);
function $eliminateEquivalentDuplicates(this$static) {
    var eGenericType, eGenericTypes, i, j, otherEGenericType;
    eGenericTypes = castTo(this$static.data_0, 674);
    for(i = this$static.size_0 - 1; i >= 0; --i){
        eGenericType = eGenericTypes[i];
        for(j = 0; j < i; ++j){
            otherEGenericType = eGenericTypes[j];
            if ($equivalent(this$static, eGenericType, otherEGenericType)) {
                $remove_33(this$static, i);
                break;
            }
        }
    }
}
function $equivalent(this$static, eGenericType, otherEGenericType) {
    var eClassifier, eTypeArgument, eTypeArgumentSize, eTypeArguments, eTypeParameter, instanceTypeName, j, otherEClassifier, otherETypeArgument, otherETypeArguments, otherETypeParameter, otherInstanceTypeName;
    if (eGenericType == otherEGenericType) return true;
    else {
        eGenericType = $resolve_0(this$static, eGenericType);
        otherEGenericType = $resolve_0(this$static, otherEGenericType);
        eClassifier = $getEClassifier(eGenericType);
        if (eClassifier) {
            otherEClassifier = $getEClassifier(otherEGenericType);
            if (otherEClassifier != eClassifier) {
                if (!otherEClassifier) return false;
                else {
                    instanceTypeName = eClassifier.getInstanceTypeName();
                    otherInstanceTypeName = otherEClassifier.getInstanceTypeName();
                    return instanceTypeName == otherInstanceTypeName && instanceTypeName != null;
                }
            } else {
                eTypeArguments = (!eGenericType.eTypeArguments && (eGenericType.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, eGenericType, 1)), eGenericType.eTypeArguments);
                eTypeArgumentSize = eTypeArguments.size_0;
                otherETypeArguments = (!otherEGenericType.eTypeArguments && (otherEGenericType.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, otherEGenericType, 1)), otherEGenericType.eTypeArguments);
                if (eTypeArgumentSize == otherETypeArguments.size_0) for(j = 0; j < eTypeArgumentSize; ++j){
                    eTypeArgument = castTo($get_20(eTypeArguments, j), 87);
                    otherETypeArgument = castTo($get_20(otherETypeArguments, j), 87);
                    if (!$equivalent(this$static, eTypeArgument, otherETypeArgument)) return false;
                }
                return true;
            }
        } else {
            eTypeParameter = eGenericType.eTypeParameter;
            otherETypeParameter = otherEGenericType.eTypeParameter;
            return eTypeParameter == otherETypeParameter;
        }
    }
}
function $resolve_0(this$static, eGenericType) {
    var eContainer, eGenericTypes, eTypeArguments, eTypeParameter, i, index_0, otherEGenericType;
    eTypeParameter = eGenericType.eTypeParameter;
    if (eTypeParameter) {
        eContainer = $eContainer(eTypeParameter);
        eGenericTypes = castTo(this$static.data_0, 674);
        for(i = 0; i < this$static.size_0; ++i){
            otherEGenericType = eGenericTypes[i];
            if ($getEClassifier(otherEGenericType) == eContainer) {
                eTypeArguments = (!otherEGenericType.eTypeArguments && (otherEGenericType.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, otherEGenericType, 1)), otherEGenericType.eTypeArguments);
                index_0 = castTo(eContainer.eGet_0(eContainmentFeature(eTypeParameter, eTypeParameter.eContainer, eTypeParameter.eFlags_0 >> 16)), 15).indexOf_0(eTypeParameter);
                if (index_0 < eTypeArguments.size_0) return $resolve_0(this$static, castTo($get_20(eTypeArguments, index_0), 87));
            }
        }
    }
    return eGenericType;
}
function EClassImpl$1EGenericSuperTypeEList() {}
defineClass(1126, 490, $intern_140, EClassImpl$1EGenericSuperTypeEList);
_.newData = function newData_4(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, $intern_157, 87, capacity, 0, 1);
};
_.useEquals = function useEquals_3() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$1EGenericSuperTypeEList_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/1EGenericSuperTypeEList', 1126);
function EClassImpl$1EStructuralFeatureUniqueEList() {}
defineClass(618, 490, $intern_140, EClassImpl$1EStructuralFeatureUniqueEList);
_.newData = function newData_5(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, $intern_153, 178, capacity, 0, 1);
};
_.useEquals = function useEquals_4() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$1EStructuralFeatureUniqueEList_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/1EStructuralFeatureUniqueEList', 618);
function EClassImpl$1ReferenceList() {}
defineClass(738, 490, $intern_140, EClassImpl$1ReferenceList);
_.newData = function newData_6(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EReference_2_classLit, $intern_153, 19, capacity, 0, 1);
};
_.useEquals = function useEquals_5() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$1ReferenceList_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/1ReferenceList', 738);
function $didAdd_0(this$static, eAttribute) {
    (eAttribute.eFlags & $intern_137) != 0 && !this$static.this$01.eIDAttribute && (this$static.this$01.eIDAttribute = eAttribute);
}
function EClassImpl$2(this$0) {
    this.this$01 = this$0;
}
defineClass(1127, 490, $intern_140, EClassImpl$2);
_.didAdd = function didAdd_1(index_0, eAttribute) {
    $didAdd_0(this, castTo(eAttribute, 35));
};
_.newData = function newData_7(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, $intern_153, 35, capacity, 0, 1);
};
_.useEquals = function useEquals_6() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/2', 1127);
function EClassImpl$3() {}
defineClass(1128, 490, $intern_140, EClassImpl$3);
_.newData = function newData_8(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, $intern_153, 35, capacity, 0, 1);
};
_.useEquals = function useEquals_7() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$3_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/3', 1128);
function $add_28(this$static, object) {
    $clinit_System();
    String.fromCharCode(10);
    return $add_21($getEStructuralFeatures(this$static.this$01), object);
}
function $addUnique_8(this$static, object) {
    $addUnique_6($getEStructuralFeatures(this$static.this$01), object);
}
function EClassImpl$4(this$0, $anonymous2, $anonymous3) {
    this.this$01 = this$0;
    EcoreEList$UnmodifiableEList$FastCompare.call(this, $anonymous2, $anonymous3);
}
defineClass(1130, 328, $intern_156, EClassImpl$4);
_.add_2 = function add_62(object) {
    return $add_28(this, castTo(object, 35));
};
_.addUnique_0 = function addUnique_14(object) {
    $addUnique_8(this, castTo(object, 35));
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$4_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/4', 1130);
function $add_29(this$static, object) {
    $clinit_System();
    String.fromCharCode(10);
    return $add_21($getEStructuralFeatures(this$static.this$01), object);
}
function $addUnique_9(this$static, object) {
    $addUnique_6($getEStructuralFeatures(this$static.this$01), object);
}
function EClassImpl$5(this$0, $anonymous2, $anonymous3) {
    this.this$01 = this$0;
    EcoreEList$UnmodifiableEList$FastCompare.call(this, $anonymous2, $anonymous3);
}
defineClass(1131, 328, $intern_156, EClassImpl$5);
_.add_2 = function add_63(object) {
    return $add_29(this, castTo(object, 19));
};
_.addUnique_0 = function addUnique_15(object) {
    $addUnique_9(this, castTo(object, 19));
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$5_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/5', 1131);
function EClassImpl$6() {}
defineClass(1133, 490, $intern_140, EClassImpl$6);
_.newData = function newData_9(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EOperation_2_classLit, $intern_154, 62, capacity, 0, 1);
};
_.useEquals = function useEquals_8() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$6_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/6', 1133);
function EClassImpl$7() {}
defineClass(1134, 490, $intern_140, EClassImpl$7);
_.newData = function newData_10(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EReference_2_classLit, $intern_153, 19, capacity, 0, 1);
};
_.useEquals = function useEquals_9() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$7_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/7', 1134);
defineClass(2041, 2040, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    70: 1,
    61: 1,
    71: 1
});
_.addAllUnique = function addAllUnique_13(index_0, collection) {
    return $addAllUnique_2(this, index_0, collection);
};
_.addAllUnique_0 = function addAllUnique_14(collection) {
    return $addAllUnique_2(this, this.delegateSize(), collection);
};
_.addUnique = function addUnique_16(index_0, object) {
    $addUnique_3(this, index_0, object);
};
_.addUnique_0 = function addUnique_17(object) {
    $addUnique_4(this, object);
};
_.basicAdd = function basicAdd_2(object, notifications) {
    return $basicAdd(this, object, notifications);
};
_.basicRemove = function basicRemove_2(object, notifications) {
    return $basicRemove(this, object, notifications);
};
_.setUnique = function setUnique_6(index_0, object) {
    return $setUnique_0(this, index_0, object);
};
_.basicGet = function basicGet_3(index_0) {
    return this.delegateGet(index_0);
};
_.basicIterator = function basicIterator_4() {
    return new AbstractEList$NonResolvingEIterator(this);
};
_.basicList = function basicList_0() {
    return this.delegateBasicList();
};
_.basicListIterator = function basicListIterator_9() {
    return new AbstractEList$NonResolvingEListIterator(this);
};
_.basicListIterator_0 = function basicListIterator_10(index_0) {
    return $basicListIterator(this, index_0);
};
var Lorg_eclipse_emf_ecore_util_DelegatingNotifyingInternalEListImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'DelegatingNotifyingInternalEListImpl', 2041);
function $resolve_1(this$static, index_0, object) {
    var internalEObject, internalEObject0, notificationChain, resolved;
    if (this$static.isEObject() && this$static.hasProxies()) {
        resolved = $resolveProxy(this$static, castTo(object, 57));
        if (maskUndefined(resolved) !== maskUndefined(object)) {
            this$static.delegateGet(index_0);
            this$static.delegateSet(index_0, $validate_1(this$static, index_0, resolved));
            if (this$static.isContainment()) {
                notificationChain = (internalEObject0 = castTo(object, 52), this$static.hasNavigableInverse() ? this$static.hasInstanceClass() ? internalEObject0.eInverseRemove(this$static.owner, $getEOpposite(castTo($getEStructuralFeature($eClass(this$static.owner), this$static.getFeatureID_0()), 19)).featureID, castTo($getEStructuralFeature($eClass(this$static.owner), this$static.getFeatureID_0()).getEType(), 29).getInstanceClass(), null) : internalEObject0.eInverseRemove(this$static.owner, $getFeatureID(internalEObject0.eClass_0(), $getEOpposite(castTo($getEStructuralFeature($eClass(this$static.owner), this$static.getFeatureID_0()), 19))), null, null) : internalEObject0.eInverseRemove(this$static.owner, -1 - this$static.getFeatureID_0(), null, null));
                !castTo(resolved, 52).eInternalContainer() && (notificationChain = (internalEObject = castTo(resolved, 52), this$static.hasNavigableInverse() ? this$static.hasInstanceClass() ? internalEObject.eInverseAdd(this$static.owner, $getEOpposite(castTo($getEStructuralFeature($eClass(this$static.owner), this$static.getFeatureID_0()), 19)).featureID, castTo($getEStructuralFeature($eClass(this$static.owner), this$static.getFeatureID_0()).getEType(), 29).getInstanceClass(), notificationChain) : internalEObject.eInverseAdd(this$static.owner, $getFeatureID(internalEObject.eClass_0(), $getEOpposite(castTo($getEStructuralFeature($eClass(this$static.owner), this$static.getFeatureID_0()), 19))), null, notificationChain) : internalEObject.eInverseAdd(this$static.owner, -1 - this$static.getFeatureID_0(), null, notificationChain)));
                !!notificationChain && notificationChain.dispatch_0();
            }
            $eNotificationRequired(this$static.owner) && this$static.dispatchNotification(this$static.createNotification(9, object, resolved, index_0, false));
            return resolved;
        }
    }
    return object;
}
function $resolveProxy(this$static, eObject) {
    return eObject.eIsProxy() ? $eResolveProxy(this$static.owner, castTo(eObject, 52)) : eObject;
}
function $validate_1(this$static, index_0, object) {
    $validate(this$static, object);
    if (object != null && !this$static.isInstance(object)) throw toJs(new ArrayStoreException);
    return object;
}
function DelegatingEcoreEList(owner) {
    this.owner = owner;
}
defineClass(739, 2041, $intern_158);
_.canContainNull = function canContainNull_3() {
    var eClassifier;
    eClassifier = $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType();
    return instanceOf(eClassifier, 155) && !instanceOf(eClassifier, 455) && (eClassifier.getInstanceClass().modifiers & 1) == 0;
};
_.contains = function contains_63(object) {
    var containedEObject, eContainer, eObject, i, opposite, result, result0, size_0;
    if (this.isEObject()) {
        size_0 = this.delegateSize();
        if (size_0 > 4) {
            if (this.isInstance(object)) {
                if (this.isContainment()) {
                    eObject = castTo(object, 52);
                    eContainer = eObject.eContainer_0();
                    result0 = eContainer == this.owner && (this.hasNavigableInverse() ? eObject.eBaseStructuralFeatureID(eObject.eContainerFeatureID_0(), castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType(), 29).getInstanceClass()) == $getEOpposite(castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()), 19)).featureID : -1 - eObject.eContainerFeatureID_0() == this.getFeatureID_0());
                    if (this.hasProxies() && !result0 && !eContainer && !!eObject.eDirectResource()) for(i = 0; i < size_0; ++i){
                        containedEObject = $resolveProxy(this, this.delegateGet(i));
                        if (maskUndefined(containedEObject) === maskUndefined(object)) return true;
                    }
                    return result0;
                } else if (this.hasNavigableInverse() && !this.hasManyInverse()) {
                    opposite = castTo(object, 57).eGet_0($getEOpposite(castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()), 19)));
                    if (maskUndefined(opposite) === maskUndefined(this.owner)) return true;
                    else if (opposite == null || !castTo(opposite, 57).eIsProxy()) return false;
                }
            } else return false;
        }
        result = this.delegateContains(object);
        if (this.hasProxies() && !result) for(i = 0; i < size_0; ++i){
            eObject = $resolveProxy(this, this.delegateGet(i));
            if (maskUndefined(eObject) === maskUndefined(object)) return true;
        }
        return result;
    } else return this.delegateContains(object);
};
_.createNotification = function createNotification_3(eventType, oldObject, newObject, index_0, wasSet) {
    return new ENotificationImpl_3(this.owner, eventType, this.getFeatureID_0(), oldObject, newObject, index_0, wasSet);
};
_.dispatchNotification = function dispatchNotification_2(notification) {
    $eNotify(this.owner, notification);
};
_.get_6 = function get_62(resolve) {
    return this;
};
_.getFeature = function getFeature_5() {
    return $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0());
};
_.getFeatureID_0 = function getFeatureID_8() {
    return $getFeatureID($eClass(this.owner), $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()));
};
_.getNotifier = function getNotifier_5() {
    return this.owner;
};
_.hasInstanceClass = function hasInstanceClass_0() {
    return !!$getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType().getInstanceClass();
};
_.hasInverse = function hasInverse_3() {
    var eReference, eStructuralFeature;
    eStructuralFeature = $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0());
    if (instanceOf(eStructuralFeature, 101)) {
        eReference = castTo(eStructuralFeature, 19);
        return (eReference.eFlags & $intern_137) != 0 || !!$getEOpposite(castTo(eStructuralFeature, 19));
    } else return false;
};
_.hasManyInverse = function hasManyInverse_0() {
    var eReference, eStructuralFeature, oppositeEReference, upper;
    eStructuralFeature = $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0());
    if (instanceOf(eStructuralFeature, 101)) {
        eReference = castTo(eStructuralFeature, 19);
        oppositeEReference = $getEOpposite(eReference);
        return !!oppositeEReference && (upper = oppositeEReference.upperBound, upper > 1 || upper == -1);
    } else return false;
};
_.hasNavigableInverse = function hasNavigableInverse_1() {
    var eReference, eStructuralFeature, oppositeEReference;
    eStructuralFeature = $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0());
    if (instanceOf(eStructuralFeature, 101)) {
        eReference = castTo(eStructuralFeature, 19);
        oppositeEReference = $getEOpposite(eReference);
        return !!oppositeEReference;
    } else return false;
};
_.hasProxies = function hasProxies_0() {
    var eReference, eStructuralFeature;
    eStructuralFeature = $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0());
    if (instanceOf(eStructuralFeature, 101)) {
        eReference = castTo(eStructuralFeature, 19);
        return (eReference.eFlags & $intern_64) != 0;
    } else return false;
};
_.indexOf_0 = function indexOf_17(object) {
    var eObject, i, index_0, size_0;
    index_0 = this.delegateIndexOf(object);
    if (index_0 >= 0) return index_0;
    if (this.isEObject()) for(i = 0, size_0 = this.delegateSize(); i < size_0; ++i){
        eObject = $resolveProxy(this, this.delegateGet(i));
        if (maskUndefined(eObject) === maskUndefined(object)) return i;
    }
    return -1;
};
_.inverseAdd = function inverseAdd_2(object, notifications) {
    var internalEObject;
    return internalEObject = castTo(object, 52), this.hasNavigableInverse() ? this.hasInstanceClass() ? internalEObject.eInverseAdd(this.owner, $getEOpposite(castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()), 19)).featureID, castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType(), 29).getInstanceClass(), notifications) : internalEObject.eInverseAdd(this.owner, $getFeatureID(internalEObject.eClass_0(), $getEOpposite(castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()), 19))), null, notifications) : internalEObject.eInverseAdd(this.owner, -1 - this.getFeatureID_0(), null, notifications);
};
_.inverseRemove = function inverseRemove_2(object, notifications) {
    var internalEObject;
    return internalEObject = castTo(object, 52), this.hasNavigableInverse() ? this.hasInstanceClass() ? internalEObject.eInverseRemove(this.owner, $getEOpposite(castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()), 19)).featureID, castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType(), 29).getInstanceClass(), notifications) : internalEObject.eInverseRemove(this.owner, $getFeatureID(internalEObject.eClass_0(), $getEOpposite(castTo($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()), 19))), null, notifications) : internalEObject.eInverseRemove(this.owner, -1 - this.getFeatureID_0(), null, notifications);
};
_.isContainment = function isContainment_3() {
    var eReference, eStructuralFeature;
    eStructuralFeature = $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0());
    if (instanceOf(eStructuralFeature, 101)) {
        eReference = castTo(eStructuralFeature, 19);
        return (eReference.eFlags & $intern_137) != 0;
    } else return false;
};
_.isEObject = function isEObject_1() {
    return instanceOf($getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType(), 88);
};
_.isInstance = function isInstance_2(object) {
    return $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).getEType().isInstance(object);
};
_.isNotificationRequired = function isNotificationRequired_2() {
    return $eNotificationRequired(this.owner);
};
_.isSet_0 = function isSet_7() {
    return !this.delegateIsEmpty();
};
_.isUnique = function isUnique_4() {
    return $getEStructuralFeature($eClass(this.owner), this.getFeatureID_0()).isUnique();
};
_.resolve = function resolve_3(index_0, object) {
    return $resolve_1(this, index_0, object);
};
_.set_1 = function set_33(newValue) {
    $clear_12(this);
    $addAll_9(this, castTo(newValue, 15));
};
_.toArray = function toArray_40() {
    var i;
    if (this.hasProxies()) for(i = this.delegateSize() - 1; i >= 0; --i)$resolve_1(this, i, this.delegateGet(i));
    return this.delegateToArray();
};
_.toArray_0 = function toArray_41(array) {
    var i;
    if (this.hasProxies()) for(i = this.delegateSize() - 1; i >= 0; --i)$resolve_1(this, i, this.delegateGet(i));
    return this.delegateToArray_0(array);
};
_.unset = function unset_5() {
    $clear_12(this);
};
_.validate = function validate_1(index_0, object) {
    return $validate_1(this, index_0, object);
};
var Lorg_eclipse_emf_ecore_util_DelegatingEcoreEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'DelegatingEcoreEList', 739);
function $delegateAdd(this$static, index_0, eClass) {
    $add_20($getEGenericSuperTypes(this$static.this$01), index_0, $wrap_0(eClass));
}
function $delegateAdd_0(this$static, eClass) {
    $add_21($getEGenericSuperTypes(this$static.this$01), $wrap_0(eClass));
}
function $delegateContains(this$static, object) {
    var eClass, eClass$iterator;
    for(eClass$iterator = new AbstractEList$EIterator(this$static); eClass$iterator.cursor != eClass$iterator.this$01_2.size_1();){
        eClass = castTo($doNext(eClass$iterator), 29);
        if (maskUndefined(object) === maskUndefined(eClass)) return true;
    }
    return false;
}
function $delegateSet(this$static, index_0, eClass) {
    var eGenericType, result, result0;
    eGenericType = castTo($get_20($getEGenericSuperTypes(this$static.this$01), index_0), 87);
    result0 = (result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT));
    ((result0.eFlags_0 & 64) != 0 ? $eResolveProxy(this$static.owner, result0) : result0) == eClass ? $getERawType(eGenericType) : $setEClassifier(eGenericType, eClass);
    return result0;
}
function $wrap_0(eClass) {
    var eGenericType, eGenericType0;
    eGenericType0 = ($clinit_EcoreFactory(), eGenericType = new EGenericTypeImpl, eGenericType);
    $setEClassifier(eGenericType0, eClass);
    return eGenericType0;
}
function EClassImpl$8(this$0, $anonymous0) {
    this.this$01 = this$0;
    DelegatingEcoreEList.call(this, $anonymous0);
}
defineClass(1135, 739, $intern_158, EClassImpl$8);
_.delegateAdd = function delegateAdd_1(index_0, eClass) {
    $delegateAdd(this, index_0, castTo(eClass, 29));
};
_.delegateAdd_0 = function delegateAdd_2(eClass) {
    $delegateAdd_0(this, castTo(eClass, 29));
};
_.delegateGet = function delegateGet_0(index_0) {
    var eGenericType, result;
    return eGenericType = castTo($get_20($getEGenericSuperTypes(this.this$01), index_0), 87), result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT);
};
_.delegateRemove = function delegateRemove_0(index_0) {
    var eGenericType, result;
    return eGenericType = castTo($remove_35($getEGenericSuperTypes(this.this$01), index_0), 87), result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT);
};
_.delegateSet = function delegateSet_0(index_0, eClass) {
    return $delegateSet(this, index_0, castTo(eClass, 29));
};
_.canContainNull = function canContainNull_4() {
    return false;
};
_.createNotification = function createNotification_4(eventType, oldObject, newObject, index_0, wasSet) {
    return null;
};
_.delegateBasicList = function delegateBasicList_0() {
    return new EClassImpl$8$1(this);
};
_.delegateClear = function delegateClear_0() {
    $clear_13($getEGenericSuperTypes(this.this$01));
};
_.delegateContains = function delegateContains_0(object) {
    return $delegateContains(this, object);
};
_.delegateContainsAll = function delegateContainsAll_0(collection) {
    var object, object$iterator;
    for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
        object = object$iterator.next_1();
        if (!$delegateContains(this, object)) return false;
    }
    return true;
};
_.delegateEquals = function delegateEquals_0(object) {
    var i, j, list;
    if (instanceOf(object, 15)) {
        list = castTo(object, 15);
        if (list.size_1() == $getEGenericSuperTypes(this.this$01).size_0) {
            for(i = list.iterator_0(), j = new AbstractEList$EIterator(this); i.hasNext_0();){
                if (maskUndefined(i.next_1()) !== maskUndefined($doNext(j))) return false;
            }
            return true;
        }
    }
    return false;
};
_.delegateHashCode = function delegateHashCode_0() {
    var eGenericType, eGenericType$iterator, hashCode, object, result;
    hashCode = 1;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericSuperTypes(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        object = (result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT));
        hashCode = 31 * hashCode + (!object ? 0 : getObjectIdentityHashCode(object));
    }
    return hashCode;
};
_.delegateIndexOf = function delegateIndexOf_0(object) {
    var eGenericType, eGenericType$iterator, index_0, result;
    index_0 = 0;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericSuperTypes(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        if (maskUndefined(object) === maskUndefined((result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT)))) return index_0;
        ++index_0;
    }
    return -1;
};
_.delegateIsEmpty = function delegateIsEmpty_0() {
    return $getEGenericSuperTypes(this.this$01).size_0 == 0;
};
_.delegateList_1 = function delegateList_2() {
    return null;
};
_.delegateSize = function delegateSize_0() {
    return $getEGenericSuperTypes(this.this$01).size_0;
};
_.delegateToArray = function delegateToArray_1() {
    var eGenericType, eGenericType$iterator, index_0, result, result0, size_0;
    size_0 = $getEGenericSuperTypes(this.this$01).size_0;
    result0 = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, size_0, 5, 1);
    index_0 = 0;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericSuperTypes(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        result0[index_0++] = (result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT));
    }
    return result0;
};
_.delegateToArray_0 = function delegateToArray_2(array) {
    var eGenericType, eGenericType$iterator, index_0, newArray, rawType, result, size_0;
    size_0 = $getEGenericSuperTypes(this.this$01).size_0;
    if (array.length < size_0) {
        newArray = newInstance_11(getClass__Ljava_lang_Class___devirtual$(array).componentType, size_0);
        array = newArray;
    }
    array.length > size_0 && setCheck(array, size_0, null);
    index_0 = 0;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericSuperTypes(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        rawType = (result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT));
        setCheck(array, index_0++, rawType);
    }
    return array;
};
_.delegateToString = function delegateToString_0() {
    var eGenericSuperTypes, i, result, size_0, stringBuffer;
    stringBuffer = new StringBuffer;
    stringBuffer.string += '[';
    eGenericSuperTypes = $getEGenericSuperTypes(this.this$01);
    for(i = 0, size_0 = $getEGenericSuperTypes(this.this$01).size_0; i < size_0;){
        $append_3(stringBuffer, valueOf_6((result = castTo($get_20(eGenericSuperTypes, i), 87).eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT))));
        ++i < size_0 && (stringBuffer.string += ', ', stringBuffer);
    }
    stringBuffer.string += ']';
    return stringBuffer.string;
};
_.dispatchNotification = function dispatchNotification_3(notification) {};
_.getFeatureID_0 = function getFeatureID_9() {
    return 10;
};
_.hasInstanceClass = function hasInstanceClass_1() {
    return true;
};
_.hasInverse = function hasInverse_4() {
    return false;
};
_.hasManyInverse = function hasManyInverse_1() {
    return false;
};
_.hasNavigableInverse = function hasNavigableInverse_2() {
    return false;
};
_.hasProxies = function hasProxies_1() {
    return true;
};
_.isContainment = function isContainment_4() {
    return false;
};
_.isEObject = function isEObject_2() {
    return true;
};
_.isInstance = function isInstance_3(object) {
    return instanceOf(object, 88);
};
_.isSet_0 = function isSet_8() {
    return $isSetESuperTypes(this.this$01);
};
_.isUnique = function isUnique_5() {
    return true;
};
_.useEquals = function useEquals_10() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$8_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/8', 1135);
function EClassImpl$8$1(this$1) {
    this.this$11 = this$1;
}
defineClass(1136, 2008, $intern_37, EClassImpl$8$1);
_.listIterator_1 = function listIterator_29(index_0) {
    return $basicListIterator(this.this$11, index_0);
};
_.size_1 = function size_76() {
    return $getEGenericSuperTypes(this.this$11.this$01).size_0;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$8$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/8/1', 1136);
function EClassImpl$9() {}
defineClass(1137, 490, $intern_140, EClassImpl$9);
_.newData = function newData_11(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EClassifier_2_classLit, $intern_2, 141, capacity, 0, 1);
};
_.useEquals = function useEquals_11() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EClassImpl$9_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/9', 1137);
function EClassImpl$MyHashSet() {
    HashSet.call(this);
}
defineClass(1124, 50, $intern_77, EClassImpl$MyHashSet);
var Lorg_eclipse_emf_ecore_impl_EClassImpl$MyHashSet_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EClassImpl/MyHashSet', 1124);
function $setSerializable(this$static, newSerializable) {
    var oldSerializable;
    oldSerializable = (this$static.eFlags & 256) != 0;
    newSerializable ? this$static.eFlags |= 256 : this$static.eFlags &= -257;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 8, oldSerializable, newSerializable));
}
function EDataTypeImpl() {
    this.eFlags |= 256;
}
defineClass(559, 357, {
    109: 1,
    93: 1,
    92: 1,
    141: 1,
    155: 1,
    826: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    357: 1,
    157: 1,
    117: 1,
    118: 1,
    676: 1
}, EDataTypeImpl);
_.eGet = function eGet_23(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return this.instanceClassName != null ? this.instanceClassName : this.generatedInstanceClassName;
        case 3:
            return $getInstanceClass(this);
        case 4:
            return this.getDefaultValue();
        case 5:
            return this.instanceTypeName;
        case 6:
            if (resolve) return $getEPackage(this);
            return $basicGetEPackage(this);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), this.eTypeParameters;
        case 8:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_22(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return this.instanceClassName != null && this.instanceClassName == this.instanceTypeName;
        case 3:
            return !!$getInstanceClass(this);
        case 4:
            return this.getDefaultValue() != null;
        case 5:
            return this.instanceTypeName != null && this.instanceTypeName != this.instanceClassName && this.instanceTypeName != this.generatedInstanceClassName;
        case 6:
            return !!$basicGetEPackage(this);
        case 7:
            return !!this.eTypeParameters && this.eTypeParameters.size_0 != 0;
        case 8:
            return (this.eFlags & 256) == 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.eSet = function eSet_21(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_1(this, castToString(newValue));
            return;
        case 2:
            $setInstanceClassName(this, castToString(newValue));
            return;
        case 5:
            $setInstanceTypeName(this, castToString(newValue));
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $addAll_9(this.eTypeParameters, castTo(newValue, 16));
            return;
        case 8:
            $setSerializable(this, $booleanValue(castToBoolean(newValue)));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_22() {
    return $clinit_EcorePackage$Literals(), EDATA_TYPE;
};
_.eUnset = function eUnset_21(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 184) && (castTo(this.eContainer, 184).eNameToEClassifierMap = null);
            $setName(this, null);
            return;
        case 2:
            $basicSetInstanceClassName(this, null);
            $basicSetInstanceTypeName(this, this.instanceClassName);
            return;
        case 5:
            $setInstanceTypeName(this, null);
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            return;
        case 8:
            $setSerializable(this, true);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? this.eStaticClass() : eClass), featureID));
};
_.freeze = function freeze_5() {
    $getExtendedMetaData(($clinit_ExtendedMetaData(), INSTANCE_11), this).getName();
    this.eFlags |= 1;
};
_.getConversionDelegate = function getConversionDelegate() {
    var conversionDelegates, eDataTypeDelegateURI, eDataTypeDelegateURI$iterator;
    if (!this.conversionDelegateIsSet) {
        conversionDelegates = getConversionDelegates($getEPackage(this));
        if (!conversionDelegates.isEmpty()) for(eDataTypeDelegateURI$iterator = conversionDelegates.iterator_0(); eDataTypeDelegateURI$iterator.hasNext_0();){
            eDataTypeDelegateURI = castToString(eDataTypeDelegateURI$iterator.next_1());
            !!$getEAnnotation(this, eDataTypeDelegateURI) && getConversionDelegateFactory(this);
        }
    }
    return this.conversionDelegate;
};
_.getDefaultValue = function getDefaultValue_1() {
    var instanceClass;
    if (!this.defaultValueIsSet) {
        instanceClass = null;
        try {
            instanceClass = $getInstanceClass(this);
        } catch ($e0) {
            $e0 = toJava($e0);
            if (!instanceOf($e0, 103)) throw toJs($e0);
        }
        this.defaultValue = null;
        !!instanceClass && (instanceClass.modifiers & 1) != 0 && (instanceClass == Z_classLit ? this.defaultValue = ($clinit_Boolean(), FALSE_0) : instanceClass == I_classLit ? this.defaultValue = valueOf_3(0) : instanceClass == F_classLit ? this.defaultValue = new Float(0) : instanceClass == D_classLit ? this.defaultValue = 0 : instanceClass == J_classLit ? this.defaultValue = valueOf_4(0) : instanceClass == S_classLit ? this.defaultValue = valueOf_5(0) : instanceClass == B_classLit ? this.defaultValue = get_32(0) : this.defaultValue = valueOf_2(0));
        this.defaultValueIsSet = true;
    }
    return this.defaultValue;
};
_.isSerializable = function isSerializable_0() {
    return (this.eFlags & 256) != 0;
};
_.setDataTypeGeneratedInstanceClass = function setDataTypeGeneratedInstanceClass(isGenerated) {
    isGenerated && (this.instanceClassName = 'org.eclipse.emf.common.util.AbstractEnumerator');
};
_.setGeneratedInstanceClass = function setGeneratedInstanceClass_0(isGenerated) {
    $setGeneratedInstanceClass(this, isGenerated);
    this.setDataTypeGeneratedInstanceClass(isGenerated);
};
_.setInstanceClassGen = function setInstanceClassGen_0(instanceClass) {
    this.instanceClass = instanceClass;
    this.defaultValueIsSet = false;
};
_.toString_0 = function toString_148() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_30(this);
    result = new StringBuffer_1($toString_30(this));
    result.string += ' (serializable: ';
    $append_4(result, (this.eFlags & 256) != 0);
    result.string += ')';
    return result.string;
};
_.conversionDelegateIsSet = false;
_.defaultValue = null;
_.defaultValueIsSet = false;
var Lorg_eclipse_emf_ecore_impl_EDataTypeImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EDataTypeImpl', 559);
function $getDefaultValue_0(this$static) {
    var eLiterals;
    eLiterals = (!this$static.eLiterals && (this$static.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this$static, 9, 5)), this$static.eLiterals);
    if (eLiterals.size_0 != 0) return $getInstance(castTo($get_20(eLiterals, 0), 679));
    return null;
}
function $getEEnumLiteralByLiteral(this$static, literal) {
    var eEnumLiteral, eEnumLiteral$iterator, result;
    if (literal == null) for(eEnumLiteral$iterator = (!this$static.eLiterals && (this$static.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this$static, 9, 5)), new AbstractEList$EIterator(this$static.eLiterals)); eEnumLiteral$iterator.cursor != eEnumLiteral$iterator.this$01_2.size_1();){
        eEnumLiteral = castTo($doNext(eEnumLiteral$iterator), 679);
        result = eEnumLiteral.literal;
        if ((result == null ? eEnumLiteral.name_0 : result) == null) return eEnumLiteral;
    }
    else for(eEnumLiteral$iterator = (!this$static.eLiterals && (this$static.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this$static, 9, 5)), new AbstractEList$EIterator(this$static.eLiterals)); eEnumLiteral$iterator.cursor != eEnumLiteral$iterator.this$01_2.size_1();){
        eEnumLiteral = castTo($doNext(eEnumLiteral$iterator), 679);
        if ($equals_5(literal, (result = eEnumLiteral.literal, result == null ? eEnumLiteral.name_0 : result))) return eEnumLiteral;
    }
    return null;
}
function EEnumImpl() {
    EDataTypeImpl.call(this);
}
defineClass(455, 559, {
    109: 1,
    93: 1,
    92: 1,
    141: 1,
    155: 1,
    826: 1,
    670: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    357: 1,
    455: 1,
    157: 1,
    117: 1,
    118: 1,
    676: 1
}, EEnumImpl);
_.eGet = function eGet_24(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return this.instanceClassName != null ? this.instanceClassName : this.generatedInstanceClassName;
        case 3:
            return $getInstanceClass(this);
        case 4:
            return $getDefaultValue_0(this);
        case 5:
            return this.instanceTypeName;
        case 6:
            if (resolve) return $getEPackage(this);
            return $basicGetEPackage(this);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), this.eTypeParameters;
        case 8:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 9:
            return !this.eLiterals && (this.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this, 9, 5)), this.eLiterals;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_15(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 6:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_7(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 6, msgs);
        case 9:
            return !this.eLiterals && (this.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this, 9, 5)), $basicAdd_0(this.eLiterals, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EENUM) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_17(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 6:
            return $eBasicSetContainer(this, null, 6, msgs);
        case 7:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7)), $basicRemove_0(this.eTypeParameters, otherEnd, msgs);
        case 9:
            return !this.eLiterals && (this.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this, 9, 5)), $basicRemove_0(this.eLiterals, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EENUM) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_23(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return this.instanceClassName != null && this.instanceClassName == this.instanceTypeName;
        case 3:
            return !!$getInstanceClass(this);
        case 4:
            return !!$getDefaultValue_0(this);
        case 5:
            return this.instanceTypeName != null && this.instanceTypeName != this.instanceClassName && this.instanceTypeName != this.generatedInstanceClassName;
        case 6:
            return !!$basicGetEPackage(this);
        case 7:
            return !!this.eTypeParameters && this.eTypeParameters.size_0 != 0;
        case 8:
            return (this.eFlags & 256) == 0;
        case 9:
            return !!this.eLiterals && this.eLiterals.size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM : eClass), featureID));
};
_.eSet = function eSet_22(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_1(this, castToString(newValue));
            return;
        case 2:
            $setInstanceClassName(this, castToString(newValue));
            return;
        case 5:
            $setInstanceTypeName(this, castToString(newValue));
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $addAll_9(this.eTypeParameters, castTo(newValue, 16));
            return;
        case 8:
            $setSerializable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 9:
            !this.eLiterals && (this.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this, 9, 5));
            $clear_13(this.eLiterals);
            !this.eLiterals && (this.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this, 9, 5));
            $addAll_9(this.eLiterals, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_23() {
    return $clinit_EcorePackage$Literals(), EENUM;
};
_.eUnset = function eUnset_22(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 184) && (castTo(this.eContainer, 184).eNameToEClassifierMap = null);
            $setName(this, null);
            return;
        case 2:
            $basicSetInstanceClassName(this, null);
            $basicSetInstanceTypeName(this, this.instanceClassName);
            return;
        case 5:
            $setInstanceTypeName(this, null);
            return;
        case 7:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 7));
            $clear_13(this.eTypeParameters);
            return;
        case 8:
            $setSerializable(this, true);
            return;
        case 9:
            !this.eLiterals && (this.eLiterals = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, this, 9, 5));
            $clear_13(this.eLiterals);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM : eClass), featureID));
};
_.freeze = function freeze_6() {
    var i, size_0;
    if (this.eLiterals) for(i = 0, size_0 = this.eLiterals.size_0; i < size_0; ++i)$freeze($get_20(this.eLiterals, i));
    $getExtendedMetaData(($clinit_ExtendedMetaData(), INSTANCE_11), this).getName();
    this.eFlags |= 1;
};
_.getDefaultValue = function getDefaultValue_2() {
    return $getDefaultValue_0(this);
};
_.isInstance = function isInstance_4(object) {
    if (object != null) return true;
    return false;
};
_.setDataTypeGeneratedInstanceClass = function setDataTypeGeneratedInstanceClass_0(isGenerated) {};
var Lorg_eclipse_emf_ecore_impl_EEnumImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EEnumImpl', 455);
function $eBasicRemoveFromContainerFeature_8(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 5) return this$static.eContainer.eInverseRemove(this$static, 9, Lorg_eclipse_emf_ecore_EEnum_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EENUM_LITERAL) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getInstance(this$static) {
    return this$static.instance ? this$static.instance : this$static.generatedInstance;
}
function $setInstance(this$static, newInstance) {
    var literal, result, oldInstance;
    oldInstance = this$static.instance;
    this$static.instance = newInstance;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 3, oldInstance, this$static.instance));
    if (!newInstance) {
        $setName(this$static, null);
        $setValue_1(this$static, 0);
        $setLiteral(this$static, null);
    } else if (newInstance != this$static) {
        $setName(this$static, newInstance.name_0);
        $setValue_1(this$static, newInstance.value_0);
        literal = (result = newInstance.literal, result == null ? newInstance.name_0 : result);
        $setLiteral(this$static, literal == null || $equals_5(literal, newInstance.name_0) ? null : literal);
    }
}
function $setLiteral(this$static, newLiteral) {
    var oldLiteral;
    oldLiteral = this$static.literal;
    this$static.literal = newLiteral;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 4, oldLiteral, this$static.literal));
}
function $setValue_1(this$static, newValue) {
    var oldValue;
    oldValue = this$static.value_0;
    this$static.value_0 = newValue;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_0(this$static, 2, oldValue, this$static.value_0));
}
function EEnumLiteralImpl() {
    this.generatedInstance = this;
}
defineClass(564, 436, {
    109: 1,
    93: 1,
    92: 1,
    1985: 1,
    679: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    564: 1,
    157: 1,
    117: 1,
    118: 1
}, EEnumLiteralImpl);
_.getName = function getName_6() {
    return this.name_0;
};
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_9(msgs) {
    return $eBasicRemoveFromContainerFeature_8(this, msgs);
};
_.eGet = function eGet_25(featureID, resolve, coreType) {
    var eClass, result;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return valueOf_3(this.value_0);
        case 3:
            return this.instance ? this.instance : this.generatedInstance;
        case 4:
            return result = this.literal, result == null ? this.name_0 : result;
        case 5:
            return this.eFlags_0 >> 16 == 5 ? castTo(this.eContainer, 670) : null;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM_LITERAL)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM_LITERAL : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_16(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 5:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_8(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 5, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EENUM_LITERAL) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM_LITERAL)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_18(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 5:
            return $eBasicSetContainer(this, null, 5, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EENUM_LITERAL) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM_LITERAL)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_24(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return this.value_0 != 0;
        case 3:
            return !!this.instance;
        case 4:
            return this.literal != null;
        case 5:
            return !!(this.eFlags_0 >> 16 == 5 ? castTo(this.eContainer, 670) : null);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM_LITERAL)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM_LITERAL : eClass), featureID));
};
_.eSet = function eSet_23(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName(this, castToString(newValue));
            return;
        case 2:
            $setValue_1(this, castTo(newValue, 17).value_0);
            return;
        case 3:
            $setInstance(this, castTo(newValue, 1985));
            return;
        case 4:
            $setLiteral(this, castToString(newValue));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM_LITERAL)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM_LITERAL : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_24() {
    return $clinit_EcorePackage$Literals(), EENUM_LITERAL;
};
_.eUnset = function eUnset_23(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            $setName(this, null);
            return;
        case 2:
            $setValue_1(this, 0);
            return;
        case 3:
            $setInstance(this, null);
            return;
        case 4:
            $setLiteral(this, null);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EENUM_LITERAL)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EENUM_LITERAL : eClass), featureID));
};
_.toString_0 = function toString_149() {
    var result;
    return result = this.literal, result == null ? this.name_0 : result;
};
_.instance = null;
_.literal = null;
_.value_0 = 0;
var Lorg_eclipse_emf_ecore_impl_EEnumLiteralImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EEnumLiteralImpl', 564);
var Lorg_eclipse_emf_ecore_impl_EFactoryImpl$InternalEDateTimeFormat_2_classLit = createForInterface('org.eclipse.emf.ecore.impl', 'EFactoryImpl/InternalEDateTimeFormat');
function $format_0(this$static, value_0) {
    return $format(this$static.dateTimeFormat, value_0, null);
}
function $parse_2(this$static, value_0) {
    return $parse_1(this$static.dateTimeFormat, value_0);
}
function EFactoryImpl$1ClientInternalEDateTimeFormat(dateTimeFormat) {
    this.dateTimeFormat = dateTimeFormat;
}
defineClass(483, 1, {
    2060: 1
}, EFactoryImpl$1ClientInternalEDateTimeFormat);
var Lorg_eclipse_emf_ecore_impl_EFactoryImpl$1ClientInternalEDateTimeFormat_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EFactoryImpl/1ClientInternalEDateTimeFormat', 483);
function $basicSetELowerBound(this$static, newELowerBound, msgs) {
    var notification, oldELowerBound;
    oldELowerBound = this$static.eLowerBound;
    this$static.eLowerBound = newELowerBound;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 3, oldELowerBound, newELowerBound);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    return msgs;
}
function $basicSetETypeParameter(this$static, newETypeParameter, msgs) {
    var notification, oldETypeParameter;
    oldETypeParameter = this$static.eTypeParameter;
    this$static.eTypeParameter = newETypeParameter;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 4, oldETypeParameter, newETypeParameter);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    oldETypeParameter != newETypeParameter && (newETypeParameter ? msgs = $setERawType(this$static, $getErasure(this$static, newETypeParameter), msgs) : msgs = $setERawType(this$static, this$static.eClassifier, msgs));
    return msgs;
}
function $basicSetEUpperBound(this$static, newEUpperBound, msgs) {
    var notification, oldEUpperBound;
    oldEUpperBound = this$static.eUpperBound;
    this$static.eUpperBound = newEUpperBound;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 0, oldEUpperBound, newEUpperBound);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    return msgs;
}
function $getEClassifier(this$static) {
    var oldEClassifier;
    if (!!this$static.eClassifier && this$static.eClassifier.eIsProxy()) {
        oldEClassifier = castTo(this$static.eClassifier, 52);
        this$static.eClassifier = castTo($eResolveProxy(this$static, oldEClassifier), 141);
        this$static.eClassifier != oldEClassifier && (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, 5, oldEClassifier, this$static.eClassifier));
    }
    return this$static.eClassifier;
}
function $getERawType(this$static) {
    var newERawType, oldERawType;
    if (!!this$static.eRawType && this$static.eRawType.eIsProxy()) {
        oldERawType = castTo(this$static.eRawType, 52);
        this$static.eRawType = castTo($eResolveProxy(this$static, oldERawType), 141);
        if (this$static.eRawType != oldERawType) {
            (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, 2, oldERawType, this$static.eRawType));
            if (instanceOf(this$static.eContainer, 400)) this$static.eFlags_0 >> 16 == -15 && this$static.eContainer.eNotificationRequired() && $dispatch(new ENotificationImpl_2(this$static.eContainer, 9, 13, oldERawType, this$static.eRawType, $indexOf_6($getEGenericExceptions(castTo(this$static.eContainer, 62)), this$static)));
            else if (instanceOf(this$static.eContainer, 88)) {
                if (this$static.eFlags_0 >> 16 == -23 && this$static.eContainer.eNotificationRequired()) {
                    newERawType = this$static.eRawType;
                    instanceOf(newERawType, 88) || (newERawType = ($clinit_EcorePackage$Literals(), EOBJECT));
                    instanceOf(oldERawType, 88) || (oldERawType = ($clinit_EcorePackage$Literals(), EOBJECT));
                    $dispatch(new ENotificationImpl_2(this$static.eContainer, 9, 10, oldERawType, newERawType, $indexOf_6($getEGenericSuperTypes(castTo(this$static.eContainer, 29)), this$static)));
                }
            }
        }
    }
    return this$static.eRawType;
}
function $getETypeArguments(this$static) {
    !this$static.eTypeArguments && (this$static.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this$static, 1));
    return this$static.eTypeArguments;
}
function $getErasure(this$static, eTypeParameter) {
    var eBound, eBound$iterator, eRawType, needEClass, needEDataType;
    if (!eTypeParameter) return null;
    else {
        needEClass = instanceOf(this$static.eContainer, 88) || instanceOf(this$static.eContainer, 101);
        needEDataType = !needEClass && instanceOf(this$static.eContainer, 330);
        for(eBound$iterator = new AbstractEList$EIterator((!eTypeParameter.eBounds && (eTypeParameter.eBounds = new ETypeParameterImpl$1(eTypeParameter, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, eTypeParameter)), eTypeParameter.eBounds)); eBound$iterator.cursor != eBound$iterator.this$01_2.size_1();){
            eBound = castTo($doNext(eBound$iterator), 87);
            eRawType = $getERawType(eBound);
            if (needEClass ? instanceOf(eRawType, 88) : needEDataType ? instanceOf(eRawType, 155) : !!eRawType) return eRawType;
        }
        return needEClass ? ($clinit_EcorePackage$Literals(), EOBJECT) : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT);
    }
}
function $setEClassifier(this$static, newEClassifier) {
    var msgs, oldEClassifier;
    oldEClassifier = this$static.eClassifier;
    msgs = $setEClassifier_0(this$static, newEClassifier, null);
    oldEClassifier != newEClassifier && !this$static.eTypeParameter && (msgs = $setERawType(this$static, newEClassifier, msgs));
    !!msgs && msgs.dispatch_0();
}
function $setEClassifier_0(this$static, newEClassifier, msgs) {
    var notification, oldEClassifier;
    oldEClassifier = this$static.eClassifier;
    this$static.eClassifier = newEClassifier;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 5, oldEClassifier, this$static.eClassifier);
        !msgs ? msgs = notification : $add_22(msgs, notification);
    }
    return msgs;
}
function $setELowerBound(this$static, newELowerBound) {
    var msgs;
    if (newELowerBound != this$static.eLowerBound) {
        msgs = null;
        !!this$static.eLowerBound && (msgs = $eInverseRemove(this$static.eLowerBound, this$static, -4, msgs));
        !!newELowerBound && (msgs = $eInverseAdd(newELowerBound, this$static, -4, msgs));
        msgs = $basicSetELowerBound(this$static, newELowerBound, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 3, newELowerBound, newELowerBound));
}
function $setERawType(this$static, newERawType, msgs) {
    var delegateIterator, eGenericType, eGenericType$iterator, eGenericTypes, eTypeParameter, notification, oldERawType;
    oldERawType = this$static.eRawType;
    !newERawType && (newERawType = eJavaObject);
    this$static.eRawType = newERawType;
    if ((this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0) {
        notification = new ENotificationImpl_1(this$static, 1, 2, oldERawType, this$static.eRawType);
        !msgs ? msgs = notification : msgs.add_5(notification);
    }
    if (oldERawType != newERawType) {
        if (instanceOf(this$static.eContainer, 290)) {
            if (this$static.eFlags_0 >> 16 == -10) msgs = castTo(this$static.eContainer, 290).setEType(newERawType, msgs);
            else if (this$static.eFlags_0 >> 16 == -15) {
                !newERawType && (newERawType = ($clinit_EcorePackage$Literals(), EJAVA_OBJECT));
                !oldERawType && (oldERawType = ($clinit_EcorePackage$Literals(), EJAVA_OBJECT));
                if (this$static.eContainer.eNotificationRequired()) {
                    notification = new ENotificationImpl_3(this$static.eContainer, 1, 13, oldERawType, newERawType, $indexOf_6($getEGenericExceptions(castTo(this$static.eContainer, 62)), this$static), false);
                    !msgs ? msgs = notification : msgs.add_5(notification);
                }
            }
        } else if (instanceOf(this$static.eContainer, 88)) {
            if (this$static.eFlags_0 >> 16 == -23) {
                instanceOf(newERawType, 88) || (newERawType = ($clinit_EcorePackage$Literals(), EOBJECT));
                instanceOf(oldERawType, 88) || (oldERawType = ($clinit_EcorePackage$Literals(), EOBJECT));
                if (this$static.eContainer.eNotificationRequired()) {
                    notification = new ENotificationImpl_3(this$static.eContainer, 1, 10, oldERawType, newERawType, $indexOf_6($getEGenericSuperTypes(castTo(this$static.eContainer, 29)), this$static), false);
                    !msgs ? msgs = notification : msgs.add_5(notification);
                }
            }
        } else if (instanceOf(this$static.eContainer, 443)) {
            eTypeParameter = castTo(this$static.eContainer, 829);
            eGenericTypes = (!eTypeParameter.eGenericTypes && (eTypeParameter.eGenericTypes = new ETypeParameterImpl$2$1(new ETypeParameterImpl$2)), eTypeParameter.eGenericTypes);
            for(eGenericType$iterator = (delegateIterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(eGenericTypes.this$11).this$01), new ETypeParameterImpl$2$1$1(delegateIterator)); eGenericType$iterator.val$delegateIterator2.hasNext;){
                eGenericType = castTo($next_3(eGenericType$iterator.val$delegateIterator2).getKey(), 87);
                msgs = $setERawType(eGenericType, $getErasure(eGenericType, eTypeParameter), msgs);
            }
        }
    }
    return msgs;
}
function $setETypeParameter(this$static, newETypeParameter) {
    var msgs;
    if (newETypeParameter != this$static.eTypeParameter) {
        !!this$static.eTypeParameter && $remove_42($getEGenericTypes(this$static.eTypeParameter), this$static);
        !!newETypeParameter && (!newETypeParameter.eGenericTypes && (newETypeParameter.eGenericTypes = new ETypeParameterImpl$2$1(new ETypeParameterImpl$2)), $add_30(newETypeParameter.eGenericTypes, this$static));
        msgs = $basicSetETypeParameter(this$static, newETypeParameter, null);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 4, newETypeParameter, newETypeParameter));
}
function $setEUpperBound(this$static, newEUpperBound) {
    var msgs;
    if (newEUpperBound != this$static.eUpperBound) {
        msgs = null;
        !!this$static.eUpperBound && (msgs = $eInverseRemove(this$static.eUpperBound, this$static, -1, msgs));
        !!newEUpperBound && (msgs = $eInverseAdd(newEUpperBound, this$static, -1, msgs));
        msgs = $basicSetEUpperBound(this$static, newEUpperBound, msgs);
        !!msgs && msgs.dispatch_0();
    } else (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 0, newEUpperBound, newEUpperBound));
}
function $toString_32(this$static, result) {
    var eTypeArgument, eTypeArgument$iterator, first, index_0, instanceTypeName, label_0, tail;
    if (this$static.eClassifier) {
        label_0 = this$static.eClassifier.getName();
        tail = null;
        if (label_0 != null) result.string += '' + label_0;
        else {
            instanceTypeName = this$static.eClassifier.getInstanceTypeName();
            if (instanceTypeName != null) {
                index_0 = $indexOf_1(instanceTypeName, fromCodePoint(91));
                if (index_0 != -1) {
                    tail = (checkCriticalStringElementIndex(index_0, instanceTypeName.length + 1), instanceTypeName.substr(index_0));
                    result.string += '' + $substring_1(instanceTypeName == null ? 'null' : (checkCriticalNotNull(instanceTypeName), instanceTypeName), 0, index_0);
                } else result.string += '' + instanceTypeName;
            }
        }
        if (!!this$static.eTypeArguments && this$static.eTypeArguments.size_0 != 0) {
            first = true;
            result.string += '<';
            for(eTypeArgument$iterator = new AbstractEList$EIterator(this$static.eTypeArguments); eTypeArgument$iterator.cursor != eTypeArgument$iterator.this$01_2.size_1();){
                eTypeArgument = castTo($doNext(eTypeArgument$iterator), 87);
                first ? first = false : (result.string += ', ', result);
                $toString_32(eTypeArgument, result);
            }
            result.string += '>';
        }
        tail != null && (result.string += '' + tail, result);
    } else if (this$static.eTypeParameter) {
        label_0 = this$static.eTypeParameter.name_0;
        label_0 != null && (result.string += '' + label_0, result);
    } else {
        result.string += '?';
        if (this$static.eLowerBound) {
            result.string += ' super ';
            $toString_32(this$static.eLowerBound, result);
        } else if (this$static.eUpperBound) {
            result.string += ' extends ';
            $toString_32(this$static.eUpperBound, result);
        }
    }
}
function EGenericTypeImpl() {
    this.eRawType = eJavaObject;
}
defineClass(246, 118, {
    109: 1,
    93: 1,
    92: 1,
    87: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    246: 1,
    117: 1,
    118: 1
}, EGenericTypeImpl);
_.eBasicSetContainer_0 = function eBasicSetContainer_6(newContainer, newContainerFeatureID, msgs) {
    var newERawType;
    msgs = $eBasicSetContainer(this, newContainer, newContainerFeatureID, msgs);
    if (!!this.eTypeParameter && instanceOf(newContainer, 178)) {
        newERawType = $getErasure(this, this.eTypeParameter);
        newERawType != this.eRawType && (msgs = $setERawType(this, newERawType, msgs));
    }
    return msgs;
};
_.eGet = function eGet_26(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return this.eUpperBound;
        case 1:
            return !this.eTypeArguments && (this.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this, 1)), this.eTypeArguments;
        case 2:
            if (resolve) return $getERawType(this);
            return this.eRawType;
        case 3:
            return this.eLowerBound;
        case 4:
            return this.eTypeParameter;
        case 5:
            if (resolve) return $getEClassifier(this);
            return this.eClassifier;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EGENERIC_TYPE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EGENERIC_TYPE : eClass), featureID), resolve, coreType);
};
_.eInverseRemove_0 = function eInverseRemove_19(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return $basicSetEUpperBound(this, null, msgs);
        case 1:
            return !this.eTypeArguments && (this.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this, 1)), $basicRemove_0(this.eTypeArguments, otherEnd, msgs);
        case 3:
            return $basicSetELowerBound(this, null, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EGENERIC_TYPE) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EGENERIC_TYPE)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_25(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eUpperBound;
        case 1:
            return !!this.eTypeArguments && this.eTypeArguments.size_0 != 0;
        case 2:
            return !!this.eRawType;
        case 3:
            return !!this.eLowerBound;
        case 4:
            return !!this.eTypeParameter;
        case 5:
            return !!this.eClassifier;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EGENERIC_TYPE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EGENERIC_TYPE : eClass), featureID));
};
_.eSet = function eSet_24(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            $setEUpperBound(this, castTo(newValue, 87));
            return;
        case 1:
            !this.eTypeArguments && (this.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this, 1));
            $clear_13(this.eTypeArguments);
            !this.eTypeArguments && (this.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this, 1));
            $addAll_9(this.eTypeArguments, castTo(newValue, 16));
            return;
        case 3:
            $setELowerBound(this, castTo(newValue, 87));
            return;
        case 4:
            $setETypeParameter(this, castTo(newValue, 829));
            return;
        case 5:
            $setEClassifier(this, castTo(newValue, 141));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EGENERIC_TYPE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EGENERIC_TYPE : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_25() {
    return $clinit_EcorePackage$Literals(), EGENERIC_TYPE;
};
_.eUnset = function eUnset_24(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            $setEUpperBound(this, null);
            return;
        case 1:
            !this.eTypeArguments && (this.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this, 1));
            $clear_13(this.eTypeArguments);
            return;
        case 3:
            $setELowerBound(this, null);
            return;
        case 4:
            $setETypeParameter(this, null);
            return;
        case 5:
            $setEClassifier(this, null);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EGENERIC_TYPE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EGENERIC_TYPE : eClass), featureID));
};
_.toString_0 = function toString_150() {
    var result;
    result = new StringBuilder_1($toString_16(this));
    result.string += ' (expression: ';
    $toString_32(this, result);
    result.string += ')';
    return result.string;
};
var eJavaObject;
var Lorg_eclipse_emf_ecore_impl_EGenericTypeImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EGenericTypeImpl', 246);
function $addUnique_10(this$static, index_0, object) {
    var iter;
    iter = this$static.listIterator_1(index_0);
    iter.add_1(object);
}
defineClass(2013, 2008, $intern_159);
_.addUnique = function addUnique_18(index_0, object) {
    $addUnique_10(this, index_0, object);
};
_.basicAdd = function basicAdd_3(object, notifications) {
    $addUnique_10(this, this.size_1(), object);
    return notifications;
};
_.basicGet = function basicGet_4(index_0) {
    return $get_7(this.basicList(), index_0);
};
_.basicIterator = function basicIterator_5() {
    return this.basicListIterator();
};
_.basicList = function basicList_1() {
    return new AbstractSequentialInternalEList$1(this);
};
_.basicListIterator = function basicListIterator_11() {
    return this.basicListIterator_0(0);
};
_.basicListIterator_0 = function basicListIterator_12(index_0) {
    return this.basicList().listIterator_1(index_0);
};
_.basicRemove = function basicRemove_3(object, notifications) {
    $advanceToFind(this, object, true);
    return notifications;
};
_.move = function move_15(newPosition, oldPosition) {
    var iter, movedObject;
    movedObject = $remove_4(this, oldPosition);
    iter = this.listIterator_1(newPosition);
    iter.add_1(movedObject);
    return movedObject;
};
_.move_0 = function move_16(newPosition, object) {
    var iter;
    $advanceToFind(this, object, true);
    iter = this.listIterator_1(newPosition);
    iter.add_1(object);
};
var Lorg_eclipse_emf_ecore_util_AbstractSequentialInternalEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'AbstractSequentialInternalEList', 2013);
function $clinit_EContentsEList() {
    $clinit_EContentsEList = emptyMethod;
    EMPTY_CONTENTS_ELIST = new EContentsEList$1;
}
function $isIncludedEntry(eStructuralFeature) {
    return instanceOf(eStructuralFeature, 101) && (castTo(eStructuralFeature, 19).eFlags & $intern_137) != 0;
}
function $iterator_1(this$static) {
    var result;
    if (this$static.eStructuralFeatures == null) return $clinit_EContentsEList$FeatureIteratorImpl(), $clinit_EContentsEList$FeatureIteratorImpl(), EMPTY_ITERATOR;
    result = this$static.resolve_0() ? this$static.newResolvingListIterator() : this$static.newNonResolvingListIterator();
    return result;
}
function EContentsEList(eObject, eStructuralFeatures) {
    $clinit_EContentsEList();
    this.eObject = eObject;
    this.eStructuralFeatures = eStructuralFeatures;
}
defineClass(480, 2013, $intern_159, EContentsEList);
_.basicGet = function basicGet_5(index_0) {
    return $get_7(this.basicList(), index_0);
};
_.basicIterator = function basicIterator_6() {
    if (this.eStructuralFeatures == null) return $clinit_EContentsEList$FeatureIteratorImpl(), $clinit_EContentsEList$FeatureIteratorImpl(), EMPTY_ITERATOR;
    return this.newNonResolvingListIterator();
};
_.basicList = function basicList_2() {
    return new EContentsEList$2(this.eObject, this.eStructuralFeatures);
};
_.basicListIterator = function basicListIterator_13() {
    if (this.eStructuralFeatures == null) return $clinit_EContentsEList$FeatureIteratorImpl(), $clinit_EContentsEList$FeatureIteratorImpl(), EMPTY_ITERATOR;
    return this.newNonResolvingListIterator();
};
_.basicListIterator_0 = function basicListIterator_14(index_0) {
    var i, result;
    if (this.eStructuralFeatures == null) {
        if (index_0 < 0 || index_0 > 1) throw toJs(new IndexOutOfBoundsException_0('index=' + index_0 + ', size=0'));
        return $clinit_EContentsEList$FeatureIteratorImpl(), $clinit_EContentsEList$FeatureIteratorImpl(), EMPTY_ITERATOR;
    }
    result = this.newNonResolvingListIterator();
    for(i = 0; i < index_0; ++i)$next_14(result);
    return result;
};
_.isEmpty = function isEmpty_33() {
    var feature, featureMap, i, j, size_0, value_0;
    if (this.eStructuralFeatures != null) for(i = 0; i < this.eStructuralFeatures.length; ++i){
        feature = this.eStructuralFeatures[i];
        if (!this.useIsSet() || this.eObject.eIsSet_0(feature)) {
            value_0 = this.eObject.eGet_1(feature, false);
            $clinit_FeatureMapUtil();
            if (castTo(feature, 69).isFeatureMap_0()) {
                featureMap = castTo(value_0, 159);
                for(j = 0, size_0 = featureMap.size_1(); j < size_0; ++j){
                    if ($isIncludedEntry(featureMap.getEStructuralFeature_0(j)) && featureMap.getValue_1(j) != null) return false;
                }
            } else if (feature.isMany()) {
                if (!castTo(value_0, 16).isEmpty()) return false;
            } else if (value_0 != null) return false;
        }
    }
    return true;
};
_.iterator_0 = function iterator_88() {
    return $iterator_1(this);
};
_.listIterator_1 = function listIterator_30(index_0) {
    var i, result;
    if (this.eStructuralFeatures == null) {
        if (index_0 != 0) throw toJs(new IndexOutOfBoundsException_0('index=' + index_0 + ', size=0'));
        return $clinit_EContentsEList$FeatureIteratorImpl(), $clinit_EContentsEList$FeatureIteratorImpl(), EMPTY_ITERATOR;
    }
    result = this.resolve_0() ? this.newResolvingListIterator() : this.newNonResolvingListIterator();
    for(i = 0; i < index_0; ++i)$next_14(result);
    return result;
};
_.move = function move_17(newPosition, oldPosition) {
    throw toJs(new UnsupportedOperationException);
};
_.move_0 = function move_18(newPosition, o) {
    throw toJs(new UnsupportedOperationException);
};
_.newNonResolvingListIterator = function newNonResolvingListIterator() {
    return new EContentsEList$FeatureIteratorImpl(this.eObject, this.eStructuralFeatures);
};
_.newResolvingListIterator = function newResolvingListIterator() {
    return new EContentsEList$ResolvingFeatureIteratorImpl(this.eObject, this.eStructuralFeatures);
};
_.resolve_0 = function resolve_4() {
    return true;
};
_.size_1 = function size_77() {
    var feature, featureMap, i, j, result, size_0, value_0;
    result = 0;
    if (this.eStructuralFeatures != null) for(i = 0; i < this.eStructuralFeatures.length; ++i){
        feature = this.eStructuralFeatures[i];
        if (!this.useIsSet() || this.eObject.eIsSet_0(feature)) {
            value_0 = this.eObject.eGet_1(feature, false);
            $clinit_FeatureMapUtil();
            if (castTo(feature, 69).isFeatureMap_0()) {
                featureMap = castTo(value_0, 159);
                for(j = 0, size_0 = featureMap.size_1(); j < size_0; ++j)$isIncludedEntry(featureMap.getEStructuralFeature_0(j)) && featureMap.getValue_1(j) != null && ++result;
            } else feature.isMany() ? result += castTo(value_0, 16).size_1() : value_0 != null && ++result;
        }
    }
    return result;
};
_.useIsSet = function useIsSet() {
    return true;
};
var EMPTY_CONTENTS_ELIST;
var Lorg_eclipse_emf_ecore_util_EContentsEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EContentsEList', 480);
function ENamedElementImpl$1($anonymous0, $anonymous1) {
    $clinit_EContentsEList();
    EContentsEList.call(this, $anonymous0, $anonymous1);
}
defineClass(1141, 480, $intern_159, ENamedElementImpl$1);
_.newNonResolvingListIterator = function newNonResolvingListIterator_0() {
    return new ENamedElementImpl$1$2(this.eObject, this.eStructuralFeatures);
};
_.newResolvingListIterator = function newResolvingListIterator_0() {
    return new ENamedElementImpl$1$1(this.eObject, this.eStructuralFeatures);
};
_.useIsSet = function useIsSet_0() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_ENamedElementImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ENamedElementImpl/1', 1141);
function $clinit_EContentsEList$FeatureIteratorImpl() {
    $clinit_EContentsEList$FeatureIteratorImpl = emptyMethod;
    EMPTY_ITERATOR = new EContentsEList$FeatureIteratorImpl$1;
}
function $next_14(this$static) {
    var result;
    if (this$static.prepared > 1 || this$static.hasNext_0()) {
        ++this$static.cursor;
        this$static.prepared = 0;
        result = this$static.preparedResult;
        this$static.hasNext_0();
        return result;
    } else throw toJs(new NoSuchElementException);
}
function $scanNext(this$static) {
    var entry, entryFeature;
    if (this$static.isHandlingFeatureMap) {
        while(this$static.valueListIndex < this$static.valueListSize){
            entry = castTo(!this$static.valueInternalEList ? this$static.valueList.get_0(this$static.valueListIndex) : this$static.valueInternalEList.basicGet(this$static.valueListIndex), 74);
            entryFeature = entry.getEStructuralFeature();
            if (instanceOf(entryFeature, 101) && (castTo(entryFeature, 19).eFlags & $intern_137) != 0 && (!this$static.featureFilter || entryFeature.getContainerClass() != Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit || entryFeature.getFeatureID_0() != 0) && entry.getValue() != null) return true;
            else ++this$static.valueListIndex;
        }
        return false;
    } else return this$static.valueListIndex < this$static.valueListSize;
}
function $scanNext_0(this$static, values) {
    var entry, entryFeature;
    if (this$static.isHandlingFeatureMap) {
        while(values.hasNext_0()){
            entry = castTo(values.next_1(), 74);
            entryFeature = entry.getEStructuralFeature();
            if (instanceOf(entryFeature, 101) && (castTo(entryFeature, 19).eFlags & $intern_137) != 0 && (!this$static.featureFilter || entryFeature.getContainerClass() != Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit || entryFeature.getFeatureID_0() != 0) && entry.getValue() != null) {
                values.previous_0();
                return true;
            }
        }
        return false;
    } else return values.hasNext_0();
}
function $scanPrevious(this$static) {
    var entry, entryFeature;
    if (this$static.isHandlingFeatureMap) {
        while(this$static.valueListIndex > 0){
            entry = castTo(this$static.valueList.get_0(this$static.valueListIndex - 1), 74);
            entryFeature = entry.getEStructuralFeature();
            if (instanceOf(entryFeature, 101) && (castTo(entryFeature, 19).eFlags & $intern_137) != 0 && (!this$static.featureFilter || entryFeature.getContainerClass() != Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit || entryFeature.getFeatureID_0() != 0) && entry.getValue() != null) return true;
            else --this$static.valueListIndex;
        }
        return false;
    } else return this$static.valueListIndex > 0;
}
function $scanPrevious_0(this$static, values) {
    var entry, entryFeature;
    if (this$static.isHandlingFeatureMap) {
        while(values.hasPrevious()){
            entry = castTo(values.previous_0(), 74);
            entryFeature = entry.getEStructuralFeature();
            if (instanceOf(entryFeature, 101) && (castTo(entryFeature, 19).eFlags & $intern_137) != 0 && (!this$static.featureFilter || entryFeature.getContainerClass() != Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit || entryFeature.getFeatureID_0() != 0) && entry.getValue() != null) {
                values.next_1();
                return true;
            }
        }
        return false;
    } else return values.hasPrevious();
}
function EContentsEList$FeatureIteratorImpl(eObject, eStructuralFeatures) {
    $clinit_EContentsEList$FeatureIteratorImpl();
    this.eObject = eObject;
    this.eStructuralFeatures = eStructuralFeatures;
}
defineClass(284, 1, $intern_160, EContentsEList$FeatureIteratorImpl);
_.forEachRemaining = function forEachRemaining_57(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_64(o) {
    throw toJs(new UnsupportedOperationException);
};
_.filter_0 = function filter_3(featureFilter) {
    if (this.prepared != 0 || !!this.featureFilter) throw toJs(new IllegalStateException_0('Iterator already in use or already filtered'));
    this.featureFilter = featureFilter;
};
_.hasNext_0 = function hasNext_46() {
    var entry, feature, newPreparedResult, newValueList, result, value_0;
    switch(this.prepared){
        case 3:
        case 2:
            return true;
        case 1:
            return false;
        case -3:
            !this.values ? ++this.valueListIndex : this.values.next_1();
        default:
            if (!this.valueList || (!this.values ? !$scanNext(this) : !$scanNext_0(this, this.values))) {
                while(this.featureCursor < this.eStructuralFeatures.length){
                    feature = this.eStructuralFeatures[this.featureCursor++];
                    if ((!this.featureFilter || feature.getContainerClass() != Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit || feature.getFeatureID_0() != 0) && (!this.useIsSet() || this.eObject.eIsSet_0(feature))) {
                        value_0 = this.eObject.eGet_1(feature, this.resolve_0());
                        this.isHandlingFeatureMap = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0());
                        if (this.isHandlingFeatureMap || feature.isMany()) {
                            if (this.resolve_0()) {
                                newValueList = castTo(value_0, 15);
                                this.valueList = newValueList;
                            } else {
                                newValueList = castTo(value_0, 71);
                                this.valueList = this.valueInternalEList = newValueList;
                            }
                            if (instanceOf(this.valueList, 59)) {
                                this.values = null;
                                this.valueListSize = this.valueList.size_1();
                                this.valueListIndex = 0;
                            } else this.values = !this.valueInternalEList ? this.valueList.listIterator_0() : this.valueInternalEList.basicListIterator();
                            if (!this.values ? $scanNext(this) : $scanNext_0(this, this.values)) {
                                result = !this.values ? !this.valueInternalEList ? this.valueList.get_0(this.valueListIndex++) : this.valueInternalEList.basicGet(this.valueListIndex++) : this.values.next_1();
                                if (this.isHandlingFeatureMap) {
                                    entry = castTo(result, 74);
                                    entry.getEStructuralFeature();
                                    newPreparedResult = entry.getValue();
                                    this.preparedResult = newPreparedResult;
                                } else {
                                    newPreparedResult = result;
                                    this.preparedResult = newPreparedResult;
                                }
                                this.prepared = 3;
                                return true;
                            }
                        } else if (value_0 != null) {
                            this.valueList = null;
                            this.values = null;
                            newPreparedResult = value_0;
                            this.preparedResult = newPreparedResult;
                            this.prepared = 2;
                            return true;
                        }
                    }
                }
                this.valueList = null;
                this.values = null;
                this.isHandlingFeatureMap = false;
                this.prepared = 1;
                return false;
            } else {
                result = !this.values ? !this.valueInternalEList ? this.valueList.get_0(this.valueListIndex++) : this.valueInternalEList.basicGet(this.valueListIndex++) : this.values.next_1();
                if (this.isHandlingFeatureMap) {
                    entry = castTo(result, 74);
                    entry.getEStructuralFeature();
                    newPreparedResult = entry.getValue();
                    this.preparedResult = newPreparedResult;
                } else {
                    newPreparedResult = result;
                    this.preparedResult = newPreparedResult;
                }
                this.prepared = 3;
                return true;
            }
    }
};
_.hasPrevious = function hasPrevious_9() {
    var entry, feature, newPreparedResult, newValueList, result, value_0;
    switch(this.prepared){
        case -3:
        case -2:
            return true;
        case -1:
            return false;
        case 3:
            !this.values ? --this.valueListIndex : this.values.previous_0();
        default:
            if (!this.valueList || (!this.values ? !$scanPrevious(this) : !$scanPrevious_0(this, this.values))) {
                while(this.featureCursor > 0){
                    feature = this.eStructuralFeatures[--this.featureCursor];
                    if ((!this.featureFilter || feature.getContainerClass() != Lorg_eclipse_elk_graph_EMapPropertyHolder_2_classLit || feature.getFeatureID_0() != 0) && (!this.useIsSet() || this.eObject.eIsSet_0(feature))) {
                        value_0 = this.eObject.eGet_1(feature, this.resolve_0());
                        this.isHandlingFeatureMap = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0());
                        if (this.isHandlingFeatureMap || feature.isMany()) {
                            if (this.resolve_0()) {
                                newValueList = castTo(value_0, 15);
                                this.valueList = newValueList;
                            } else {
                                newValueList = castTo(value_0, 71);
                                this.valueList = this.valueInternalEList = newValueList;
                            }
                            if (instanceOf(this.valueList, 59)) {
                                this.valueListSize = this.valueList.size_1();
                                this.valueListIndex = this.valueListSize;
                            } else this.values = !this.valueInternalEList ? this.valueList.listIterator_1(this.valueList.size_1()) : this.valueInternalEList.basicListIterator_0(this.valueList.size_1());
                            if (!this.values ? $scanPrevious(this) : $scanPrevious_0(this, this.values)) {
                                result = !this.values ? !this.valueInternalEList ? this.valueList.get_0(--this.valueListIndex) : this.valueInternalEList.basicGet(--this.valueListIndex) : this.values.previous_0();
                                if (this.isHandlingFeatureMap) {
                                    entry = castTo(result, 74);
                                    entry.getEStructuralFeature();
                                    newPreparedResult = entry.getValue();
                                    this.preparedResult = newPreparedResult;
                                } else {
                                    newPreparedResult = result;
                                    this.preparedResult = newPreparedResult;
                                }
                                this.prepared = -3;
                                return true;
                            }
                        } else if (value_0 != null) {
                            this.valueList = null;
                            this.values = null;
                            newPreparedResult = value_0;
                            this.preparedResult = newPreparedResult;
                            this.prepared = -2;
                            return true;
                        }
                    }
                }
                this.valueList = null;
                this.values = null;
                this.prepared = -1;
                return false;
            } else {
                result = !this.values ? !this.valueInternalEList ? this.valueList.get_0(--this.valueListIndex) : this.valueInternalEList.basicGet(--this.valueListIndex) : this.values.previous_0();
                if (this.isHandlingFeatureMap) {
                    entry = castTo(result, 74);
                    entry.getEStructuralFeature();
                    newPreparedResult = entry.getValue();
                    this.preparedResult = newPreparedResult;
                } else {
                    newPreparedResult = result;
                    this.preparedResult = newPreparedResult;
                }
                this.prepared = -3;
                return true;
            }
    }
};
_.next_1 = function next_47() {
    return $next_14(this);
};
_.nextIndex_0 = function nextIndex_10() {
    return this.cursor;
};
_.previous_0 = function previous_10() {
    var result;
    if (this.prepared < -1 || this.hasPrevious()) {
        --this.cursor;
        this.prepared = 0;
        result = this.preparedResult;
        this.hasPrevious();
        return result;
    } else throw toJs(new NoSuchElementException);
};
_.previousIndex = function previousIndex_9() {
    return this.cursor - 1;
};
_.remove = function remove_126() {
    throw toJs(new UnsupportedOperationException);
};
_.resolve_0 = function resolve_5() {
    return false;
};
_.set_1 = function set_34(o) {
    throw toJs(new UnsupportedOperationException);
};
_.useIsSet = function useIsSet_1() {
    return true;
};
_.cursor = 0;
_.featureCursor = 0;
_.isHandlingFeatureMap = false;
_.prepared = 0;
_.valueListIndex = 0;
_.valueListSize = 0;
var EMPTY_ITERATOR;
var Lorg_eclipse_emf_ecore_util_EContentsEList$FeatureIteratorImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EContentsEList/FeatureIteratorImpl', 284);
function EContentsEList$ResolvingFeatureIteratorImpl(eObject, eStructuralFeatures) {
    $clinit_EContentsEList$FeatureIteratorImpl();
    EContentsEList$FeatureIteratorImpl.call(this, eObject, eStructuralFeatures);
}
defineClass(695, 284, $intern_160, EContentsEList$ResolvingFeatureIteratorImpl);
_.resolve_0 = function resolve_6() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EContentsEList$ResolvingFeatureIteratorImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EContentsEList/ResolvingFeatureIteratorImpl', 695);
function ENamedElementImpl$1$1($anonymous0, $anonymous1) {
    $clinit_EContentsEList$FeatureIteratorImpl();
    EContentsEList$ResolvingFeatureIteratorImpl.call(this, $anonymous0, $anonymous1);
}
defineClass(1142, 695, $intern_160, ENamedElementImpl$1$1);
_.useIsSet = function useIsSet_2() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_ENamedElementImpl$1$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ENamedElementImpl/1/1', 1142);
function ENamedElementImpl$1$2($anonymous0, $anonymous1) {
    $clinit_EContentsEList$FeatureIteratorImpl();
    EContentsEList$FeatureIteratorImpl.call(this, $anonymous0, $anonymous1);
}
defineClass(1143, 284, $intern_160, ENamedElementImpl$1$2);
_.useIsSet = function useIsSet_3() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_ENamedElementImpl$1$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ENamedElementImpl/1/2', 1143);
function $$init_11(this$static) {}
function $getFeature(this$static) {
    var eClass;
    if (!this$static.feature && this$static.featureID != -1) {
        eClass = this$static.notifier.eClass_0();
        this$static.feature = $getEStructuralFeature(eClass, this$static.featureID);
    }
    return this$static.feature;
}
function ENotificationImpl(notifier, featureID, oldDoubleValue, newDoubleValue) {
    NotificationImpl.call(this, 1, oldDoubleValue, newDoubleValue);
    $$init_11(this);
    this.notifier = notifier;
    this.featureID = featureID;
}
function ENotificationImpl_0(notifier, featureID, oldIntValue, newIntValue) {
    NotificationImpl_0.call(this, 1, oldIntValue, newIntValue);
    $$init_11(this);
    this.notifier = notifier;
    this.featureID = featureID;
}
function ENotificationImpl_1(notifier, eventType, featureID, oldValue, newValue) {
    ENotificationImpl_2.call(this, notifier, eventType, featureID, oldValue, newValue, -1);
}
function ENotificationImpl_2(notifier, eventType, featureID, oldValue, newValue, position) {
    NotificationImpl_1.call(this, eventType, oldValue, newValue, position);
    $$init_11(this);
    this.notifier = notifier;
    this.featureID = featureID;
}
function ENotificationImpl_3(notifier, eventType, featureID, oldValue, newValue, position, wasSet) {
    NotificationImpl_2.call(this, eventType, oldValue, newValue, position, wasSet);
    $$init_11(this);
    this.notifier = notifier;
    this.featureID = featureID;
}
function ENotificationImpl_4(notifier, eventType, featureID, oldBooleanValue, newBooleanValue) {
    NotificationImpl_3.call(this, eventType, oldBooleanValue, newBooleanValue);
    $$init_11(this);
    this.notifier = notifier;
    this.featureID = featureID;
}
function ENotificationImpl_5(notifier, eventType, feature, oldByteValue, newByteValue) {
    this.eventType = eventType;
    this.oldSimplePrimitiveValue = oldByteValue;
    this.newSimplePrimitiveValue = newByteValue;
    this.position = -1;
    this.primitiveType = 1;
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_6(notifier, eventType, feature, oldByteValue, newByteValue, isSetChange) {
    ENotificationImpl_5.call(this, notifier, eventType, feature, oldByteValue, newByteValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_7(notifier, eventType, feature, oldCharValue, newCharValue) {
    this.eventType = eventType;
    this.oldSimplePrimitiveValue = oldCharValue;
    this.newSimplePrimitiveValue = newCharValue;
    this.position = -1;
    this.primitiveType = 2;
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_8(notifier, eventType, feature, oldCharValue, newCharValue, isSetChange) {
    ENotificationImpl_7.call(this, notifier, eventType, feature, oldCharValue, newCharValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_9(notifier, eventType, feature, oldDoubleValue, newDoubleValue) {
    NotificationImpl.call(this, eventType, oldDoubleValue, newDoubleValue);
    $$init_11(this);
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_10(notifier, eventType, feature, oldDoubleValue, newDoubleValue, isSetChange) {
    ENotificationImpl_9.call(this, notifier, eventType, feature, oldDoubleValue, newDoubleValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_11(notifier, eventType, feature, oldFloatValue, newFloatValue) {
    this.eventType = eventType;
    this.oldIEEEPrimitiveValue = oldFloatValue;
    this.newIEEEPrimitiveValue = newFloatValue;
    this.position = -1;
    this.primitiveType = 4;
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_12(notifier, eventType, feature, oldFloatValue, newFloatValue, isSetChange) {
    ENotificationImpl_11.call(this, notifier, eventType, feature, oldFloatValue, newFloatValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_13(notifier, eventType, feature, oldIntValue, newIntValue) {
    NotificationImpl_0.call(this, eventType, oldIntValue, newIntValue);
    $$init_11(this);
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_14(notifier, eventType, feature, oldIntValue, newIntValue, isSetChange) {
    ENotificationImpl_13.call(this, notifier, eventType, feature, oldIntValue, newIntValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_15(notifier, eventType, feature, oldLongValue, newLongValue) {
    this.eventType = eventType;
    this.oldSimplePrimitiveValue = oldLongValue;
    this.newSimplePrimitiveValue = newLongValue;
    this.position = -1;
    this.primitiveType = 6;
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_16(notifier, eventType, feature, oldLongValue, newLongValue, isSetChange) {
    ENotificationImpl_15.call(this, notifier, eventType, feature, oldLongValue, newLongValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_17(notifier, eventType, feature, oldValue, newValue) {
    ENotificationImpl_18.call(this, notifier, eventType, feature, oldValue, newValue, -1);
}
function ENotificationImpl_18(notifier, eventType, feature, oldValue, newValue, position) {
    NotificationImpl_1.call(this, eventType, oldValue, newValue, position);
    $$init_11(this);
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_19(notifier, eventType, feature, oldValue, newValue, isSetChange) {
    ENotificationImpl_18.call(this, notifier, eventType, feature, oldValue, newValue, isSetChange ? -2 : -1);
}
function ENotificationImpl_20(notifier, eventType, feature, oldShortValue, newShortValue) {
    this.eventType = eventType;
    this.oldSimplePrimitiveValue = oldShortValue;
    this.newSimplePrimitiveValue = newShortValue;
    this.position = -1;
    this.primitiveType = 7;
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_21(notifier, eventType, feature, oldShortValue, newShortValue, isSetChange) {
    ENotificationImpl_20.call(this, notifier, eventType, feature, oldShortValue, newShortValue);
    isSetChange && (this.position = -2);
}
function ENotificationImpl_22(notifier, eventType, feature, oldBooleanValue, newBooleanValue) {
    NotificationImpl_3.call(this, eventType, oldBooleanValue, newBooleanValue);
    $$init_11(this);
    this.notifier = notifier;
    this.feature = feature;
}
function ENotificationImpl_23(notifier, eventType, feature, oldBooleanValue, newBooleanValue, isSetChange) {
    ENotificationImpl_22.call(this, notifier, eventType, feature, oldBooleanValue, newBooleanValue);
    isSetChange && (this.position = -2);
}
defineClass(38, 150, $intern_144, ENotificationImpl, ENotificationImpl_0, ENotificationImpl_1, ENotificationImpl_2, ENotificationImpl_3, ENotificationImpl_4, ENotificationImpl_5, ENotificationImpl_6, ENotificationImpl_7, ENotificationImpl_8, ENotificationImpl_9, ENotificationImpl_10, ENotificationImpl_11, ENotificationImpl_12, ENotificationImpl_13, ENotificationImpl_14, ENotificationImpl_15, ENotificationImpl_16, ENotificationImpl_17, ENotificationImpl_18, ENotificationImpl_19, ENotificationImpl_20, ENotificationImpl_21, ENotificationImpl_22, ENotificationImpl_23);
_.getFeature = function getFeature_6() {
    return $getFeature(this);
};
_.getFeatureDefaultValue = function getFeatureDefaultValue_0() {
    var feature;
    feature = $getFeature(this);
    if (feature) return feature.getDefaultValue();
    return null;
};
_.getFeatureID = function getFeatureID_10(expectedClass) {
    this.featureID == -1 && !!this.feature && (this.featureID = this.notifier.eDerivedStructuralFeatureID(this.feature.getFeatureID_0(), this.feature.getContainerClass()));
    return this.notifier.eBaseStructuralFeatureID(this.featureID, expectedClass);
};
_.getNotifier = function getNotifier_6() {
    return this.notifier;
};
_.isFeatureUnsettable = function isFeatureUnsettable_0() {
    var feature;
    feature = $getFeature(this);
    if (feature) return feature.isUnsettable();
    return false;
};
_.featureID = -1;
var Lorg_eclipse_emf_ecore_impl_ENotificationImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ENotificationImpl', 38);
function $eBasicRemoveFromContainerFeature_9(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 10) return this$static.eContainer.eInverseRemove(this$static, 11, Lorg_eclipse_emf_ecore_EClass_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EOPERATION) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function $getEGenericExceptions(this$static) {
    if (!this$static.eGenericExceptions) {
        this$static.eGenericExceptions = new EOperationImpl$2(this$static, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this$static);
        !this$static.eExceptions && (this$static.eExceptions = new EOperationImpl$1(this$static, this$static));
    }
    return this$static.eGenericExceptions;
}
function $isSetEExceptions(this$static) {
    return !!this$static.eExceptions && $getEGenericExceptions(this$static.eExceptions.this$01).size_0 != 0 && !(!!this$static.eGenericExceptions && $isSet_0(this$static.eGenericExceptions));
}
function EOperationImpl() {
    ETypedElementImpl.call(this);
}
defineClass(400, 290, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    62: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    400: 1,
    290: 1,
    117: 1,
    118: 1
}, EOperationImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_10(msgs) {
    return $eBasicRemoveFromContainerFeature_9(this, msgs);
};
_.eGet = function eGet_27(featureID, resolve, coreType) {
    var eClass, lower, upper;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 3:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 4:
            return valueOf_3(this.lowerBound);
        case 5:
            return valueOf_3(this.upperBound);
        case 6:
            return $clinit_Boolean(), upper = this.upperBound, upper > 1 || upper == -1 ? true : false;
        case 7:
            return $clinit_Boolean(), lower = this.lowerBound, lower >= 1 ? true : false;
        case 8:
            if (resolve) return $getEType(this);
            return this.eType;
        case 9:
            return this.eGenericType;
        case 10:
            return this.eFlags_0 >> 16 == 10 ? castTo(this.eContainer, 29) : null;
        case 11:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 11)), this.eTypeParameters;
        case 12:
            return !this.eParameters && (this.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, this, 12, 10)), this.eParameters;
        case 13:
            return !this.eExceptions && (this.eExceptions = new EOperationImpl$1(this, this)), this.eExceptions;
        case 14:
            return $getEGenericExceptions(this);
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EOPERATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EOPERATION : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_17(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 10:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_9(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 10, msgs);
        case 12:
            return !this.eParameters && (this.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, this, 12, 10)), $basicAdd_0(this.eParameters, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EOPERATION) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EOPERATION)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_20(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 9:
            return $basicUnsetEGenericType(this, msgs);
        case 10:
            return $eBasicSetContainer(this, null, 10, msgs);
        case 11:
            return !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 11)), $basicRemove_0(this.eTypeParameters, otherEnd, msgs);
        case 12:
            return !this.eParameters && (this.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, this, 12, 10)), $basicRemove_0(this.eParameters, otherEnd, msgs);
        case 14:
            return $basicRemove_0($getEGenericExceptions(this), otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EOPERATION) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EOPERATION)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_26(featureID) {
    var eClass, lower, upper;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return (this.eFlags & 256) == 0;
        case 3:
            return (this.eFlags & 512) == 0;
        case 4:
            return this.lowerBound != 0;
        case 5:
            return this.upperBound != 1;
        case 6:
            return upper = this.upperBound, upper > 1 || upper == -1;
        case 7:
            return lower = this.lowerBound, lower >= 1;
        case 8:
            return !!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0;
        case 9:
            return !!this.eGenericType && !(!!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0);
        case 10:
            return !!(this.eFlags_0 >> 16 == 10 ? castTo(this.eContainer, 29) : null);
        case 11:
            return !!this.eTypeParameters && this.eTypeParameters.size_0 != 0;
        case 12:
            return !!this.eParameters && this.eParameters.size_0 != 0;
        case 13:
            return !!this.eExceptions && $getEGenericExceptions(this.eExceptions.this$01).size_0 != 0 && !(!!this.eGenericExceptions && $isSet_0(this.eGenericExceptions));
        case 14:
            return !!this.eGenericExceptions && $isSet_0(this.eGenericExceptions);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EOPERATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EOPERATION : eClass), featureID));
};
_.eSet = function eSet_25(featureID, newValue) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName(this, castToString(newValue));
            return;
        case 2:
            $setOrdered(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 3:
            $setUnique_2(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 4:
            $setLowerBound(this, castTo(newValue, 17).value_0);
            return;
        case 5:
            $setUpperBound(this, castTo(newValue, 17).value_0);
            return;
        case 8:
            $setEType(this, castTo(newValue, 141));
            return;
        case 9:
            msgs = $setEGenericType(this, castTo(newValue, 87), null);
            !!msgs && msgs.dispatch_0();
            return;
        case 11:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 11));
            $clear_13(this.eTypeParameters);
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 11));
            $addAll_9(this.eTypeParameters, castTo(newValue, 16));
            return;
        case 12:
            !this.eParameters && (this.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, this, 12, 10));
            $clear_13(this.eParameters);
            !this.eParameters && (this.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, this, 12, 10));
            $addAll_9(this.eParameters, castTo(newValue, 16));
            return;
        case 13:
            !this.eExceptions && (this.eExceptions = new EOperationImpl$1(this, this));
            $clear_12(this.eExceptions);
            !this.eExceptions && (this.eExceptions = new EOperationImpl$1(this, this));
            $addAll_9(this.eExceptions, castTo(newValue, 16));
            return;
        case 14:
            $clear_13($getEGenericExceptions(this));
            $addAll_9($getEGenericExceptions(this), castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EOPERATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EOPERATION : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_26() {
    return $clinit_EcorePackage$Literals(), EOPERATION;
};
_.eUnset = function eUnset_25(featureID) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            $setName(this, null);
            return;
        case 2:
            $setOrdered(this, true);
            return;
        case 3:
            $setUnique_2(this, true);
            return;
        case 4:
            $setLowerBound(this, 0);
            return;
        case 5:
            $setUpperBound(this, 1);
            return;
        case 8:
            $setEType(this, null);
            return;
        case 9:
            msgs = $setEGenericType(this, null, null);
            !!msgs && msgs.dispatch_0();
            return;
        case 11:
            !this.eTypeParameters && (this.eTypeParameters = new EObjectContainmentEList$Resolving(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, this, 11));
            $clear_13(this.eTypeParameters);
            return;
        case 12:
            !this.eParameters && (this.eParameters = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EParameter_2_classLit, this, 12, 10));
            $clear_13(this.eParameters);
            return;
        case 13:
            !!this.eExceptions && $clear_12(this.eExceptions);
            return;
        case 14:
            !!this.eGenericExceptions && $clear_13(this.eGenericExceptions);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EOPERATION)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EOPERATION : eClass), featureID));
};
_.freeze = function freeze_7() {
    var i, size_0;
    if (this.eParameters) for(i = 0, size_0 = this.eParameters.size_0; i < size_0; ++i)$freeze($get_20(this.eParameters, i));
    $getEType(this);
    this.eFlags |= 1;
};
var Lorg_eclipse_emf_ecore_impl_EOperationImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EOperationImpl', 400);
function $delegateAdd_1(this$static, index_0, eClassifier) {
    $add_20($getEGenericExceptions(this$static.this$01), index_0, $wrap_1(eClassifier));
}
function $delegateAdd_2(this$static, eClassifier) {
    $add_21($getEGenericExceptions(this$static.this$01), $wrap_1(eClassifier));
}
function $delegateContains_0(this$static, object) {
    var eClassifier, eClassifier$iterator;
    for(eClassifier$iterator = new AbstractEList$EIterator(this$static); eClassifier$iterator.cursor != eClassifier$iterator.this$01_2.size_1();){
        eClassifier = castTo($doNext(eClassifier$iterator), 141);
        if (maskUndefined(object) === maskUndefined(eClassifier)) return true;
    }
    return false;
}
function $delegateSet_0(this$static, index_0, eClassifier) {
    var eGenericType, result, result0;
    eGenericType = castTo($get_20($getEGenericExceptions(this$static.this$01), index_0), 87);
    result0 = (result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT));
    (result0.eIsProxy() ? $eResolveProxy(this$static.owner, castTo(result0, 52)) : result0) == eClassifier ? $getERawType(eGenericType) : $setEClassifier(eGenericType, eClassifier);
    return result0;
}
function $wrap_1(eClassifier) {
    var eGenericType, eGenericType0;
    eGenericType0 = ($clinit_EcoreFactory(), eGenericType = new EGenericTypeImpl, eGenericType);
    $setEClassifier(eGenericType0, eClassifier);
    return eGenericType0;
}
function EOperationImpl$1(this$0, $anonymous0) {
    this.this$01 = this$0;
    DelegatingEcoreEList.call(this, $anonymous0);
}
defineClass(497, 739, $intern_158, EOperationImpl$1);
_.delegateAdd = function delegateAdd_3(index_0, eClassifier) {
    $delegateAdd_1(this, index_0, castTo(eClassifier, 141));
};
_.delegateAdd_0 = function delegateAdd_4(eClassifier) {
    $delegateAdd_2(this, castTo(eClassifier, 141));
};
_.delegateGet = function delegateGet_1(index_0) {
    var eGenericType, result;
    return eGenericType = castTo($get_20($getEGenericExceptions(this.this$01), index_0), 87), result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT);
};
_.delegateRemove = function delegateRemove_1(index_0) {
    var eGenericType, result;
    return eGenericType = castTo($remove_35($getEGenericExceptions(this.this$01), index_0), 87), result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT);
};
_.delegateSet = function delegateSet_1(index_0, eClassifier) {
    return $delegateSet_0(this, index_0, castTo(eClassifier, 141));
};
_.canContainNull = function canContainNull_5() {
    return false;
};
_.createNotification = function createNotification_5(eventType, oldObject, newObject, index_0, wasSet) {
    return null;
};
_.delegateBasicList = function delegateBasicList_1() {
    return new EOperationImpl$1$1(this);
};
_.delegateClear = function delegateClear_1() {
    $clear_13($getEGenericExceptions(this.this$01));
};
_.delegateContains = function delegateContains_1(object) {
    return $delegateContains_0(this, object);
};
_.delegateContainsAll = function delegateContainsAll_1(collection) {
    var object, object$iterator;
    for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
        object = object$iterator.next_1();
        if (!$delegateContains_0(this, object)) return false;
    }
    return true;
};
_.delegateEquals = function delegateEquals_1(object) {
    var i, j, list;
    if (instanceOf(object, 15)) {
        list = castTo(object, 15);
        if (list.size_1() == $getEGenericExceptions(this.this$01).size_0) {
            for(i = list.iterator_0(), j = new AbstractEList$EIterator(this); i.hasNext_0();){
                if (maskUndefined(i.next_1()) !== maskUndefined($doNext(j))) return false;
            }
            return true;
        }
    }
    return false;
};
_.delegateHashCode = function delegateHashCode_1() {
    var eGenericType, eGenericType$iterator, hashCode, object, result;
    hashCode = 1;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericExceptions(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        object = (result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT));
        hashCode = 31 * hashCode + (!object ? 0 : hashCode__I__devirtual$(object));
    }
    return hashCode;
};
_.delegateIndexOf = function delegateIndexOf_1(object) {
    var eGenericType, eGenericType$iterator, index_0, result;
    index_0 = 0;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericExceptions(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        if (maskUndefined(object) === maskUndefined((result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT)))) return index_0;
        ++index_0;
    }
    return -1;
};
_.delegateIsEmpty = function delegateIsEmpty_1() {
    return $getEGenericExceptions(this.this$01).size_0 == 0;
};
_.delegateList_1 = function delegateList_3() {
    return null;
};
_.delegateSize = function delegateSize_1() {
    return $getEGenericExceptions(this.this$01).size_0;
};
_.delegateToArray = function delegateToArray_3() {
    var eGenericType, eGenericType$iterator, index_0, result, result0, size_0;
    size_0 = $getEGenericExceptions(this.this$01).size_0;
    result0 = initUnidimensionalArray(Ljava_lang_Object_2_classLit, $intern_2, 1, size_0, 5, 1);
    index_0 = 0;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericExceptions(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        result0[index_0++] = (result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT));
    }
    return result0;
};
_.delegateToArray_0 = function delegateToArray_4(array) {
    var eGenericType, eGenericType$iterator, index_0, newArray, rawType, result, size_0;
    size_0 = $getEGenericExceptions(this.this$01).size_0;
    if (array.length < size_0) {
        newArray = newInstance_11(getClass__Ljava_lang_Class___devirtual$(array).componentType, size_0);
        array = newArray;
    }
    array.length > size_0 && setCheck(array, size_0, null);
    index_0 = 0;
    for(eGenericType$iterator = new AbstractEList$EIterator($getEGenericExceptions(this.this$01)); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        rawType = (result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT));
        setCheck(array, index_0++, rawType);
    }
    return array;
};
_.delegateToString = function delegateToString_1() {
    var eGenericExceptions, i, result, size_0, stringBuffer;
    stringBuffer = new StringBuffer;
    stringBuffer.string += '[';
    eGenericExceptions = $getEGenericExceptions(this.this$01);
    for(i = 0, size_0 = $getEGenericExceptions(this.this$01).size_0; i < size_0;){
        $append_3(stringBuffer, valueOf_6((result = castTo($get_20(eGenericExceptions, i), 87).eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT))));
        ++i < size_0 && (stringBuffer.string += ', ', stringBuffer);
    }
    stringBuffer.string += ']';
    return stringBuffer.string;
};
_.dispatchNotification = function dispatchNotification_4(notification) {};
_.getFeatureID_0 = function getFeatureID_11() {
    return 13;
};
_.hasInstanceClass = function hasInstanceClass_2() {
    return true;
};
_.hasInverse = function hasInverse_5() {
    return false;
};
_.hasManyInverse = function hasManyInverse_2() {
    return false;
};
_.hasNavigableInverse = function hasNavigableInverse_3() {
    return false;
};
_.hasProxies = function hasProxies_2() {
    return true;
};
_.isContainment = function isContainment_5() {
    return false;
};
_.isEObject = function isEObject_3() {
    return true;
};
_.isInstance = function isInstance_5(object) {
    return instanceOf(object, 141);
};
_.isSet_0 = function isSet_9() {
    return $isSetEExceptions(this.this$01);
};
_.isUnique = function isUnique_6() {
    return true;
};
_.useEquals = function useEquals_12() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EOperationImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EOperationImpl/1', 497);
function EOperationImpl$1$1(this$1) {
    this.this$11 = this$1;
}
defineClass(1315, 2008, $intern_37, EOperationImpl$1$1);
_.listIterator_1 = function listIterator_31(index_0) {
    return $basicListIterator(this.this$11, index_0);
};
_.size_1 = function size_78() {
    return $getEGenericExceptions(this.this$11.this$01).size_0;
};
var Lorg_eclipse_emf_ecore_impl_EOperationImpl$1$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EOperationImpl/1/1', 1315);
function $isSet_0(this$static) {
    var eGenericType, eGenericType$iterator;
    for(eGenericType$iterator = new AbstractEList$EIterator(this$static); eGenericType$iterator.cursor != eGenericType$iterator.this$01_2.size_1();){
        eGenericType = castTo($doNext(eGenericType$iterator), 87);
        if (!!eGenericType.eTypeParameter || (!eGenericType.eTypeArguments && (eGenericType.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, eGenericType, 1)), eGenericType.eTypeArguments).size_0 != 0) return true;
    }
    return false;
}
function $shadowAdd_0(this$static, eGenericType, notifications) {
    var notification, result;
    notification = new ENotificationImpl_3(this$static.owner, 3, 13, null, (result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT)), $indexOf_6(this$static, eGenericType), false);
    !notifications ? notifications = notification : notifications.add_5(notification);
    return notifications;
}
function $shadowRemove_0(this$static, eGenericType, notifications) {
    var notification, result;
    notification = new ENotificationImpl_3(this$static.owner, 4, 13, (result = eGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT)), null, $indexOf_6(this$static, eGenericType), false);
    !notifications ? notifications = notification : notifications.add_5(notification);
    return notifications;
}
function $shadowSet_0(this$static, oldEGenericType, newEGenericType, notifications) {
    var notification, result, result0;
    notification = new ENotificationImpl_3(this$static.owner, 1, 13, (result0 = oldEGenericType.eRawType, result0 ? result0 : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT)), (result = newEGenericType.eRawType, result ? result : ($clinit_EcorePackage$Literals(), EJAVA_OBJECT)), $indexOf_6(this$static, oldEGenericType), false);
    !notifications ? notifications = notification : notifications.add_5(notification);
    return notifications;
}
function EOperationImpl$2(this$0, $anonymous0, $anonymous1) {
    this.this$01 = this$0;
    EObjectContainmentEList$Unsettable.call(this, $anonymous0, $anonymous1, 14);
}
defineClass(1316, 540, $intern_156, EOperationImpl$2);
_.move = function move_19(targetIndex, sourceIndex) {
    var result0, result;
    return result0 = castTo($move_1(this, targetIndex, sourceIndex), 87), $eNotificationRequired(this.owner) && $dispatchNotification(this, new ENotificationImpl_18(this.this$01, 7, ($clinit_EcorePackage$Literals(), EOPERATION__EEXCEPTIONS), valueOf_3(sourceIndex), (result = result0.eRawType, result ? result : EJAVA_OBJECT), targetIndex)), result0;
};
_.shadowAdd = function shadowAdd_1(eGenericType, notifications) {
    return $shadowAdd_0(this, castTo(eGenericType, 87), notifications);
};
_.shadowRemove = function shadowRemove_1(eGenericType, notifications) {
    return $shadowRemove_0(this, castTo(eGenericType, 87), notifications);
};
_.shadowSet = function shadowSet_1(oldEGenericType, newEGenericType, notifications) {
    return $shadowSet_0(this, castTo(oldEGenericType, 87), castTo(newEGenericType, 87), notifications);
};
_.createNotification = function createNotification_6(eventType, oldObject, newObject, index_0, wasSet) {
    switch(eventType){
        case 3:
            return $createNotification(this, eventType, oldObject, newObject, index_0, this.size_0 > 1);
        case 5:
            return $createNotification(this, eventType, oldObject, newObject, index_0, this.size_0 - castTo(newObject, 15).size_1() > 0);
        default:
            return new ENotificationImpl_3(this.owner, eventType, this.featureID, oldObject, newObject, index_0, true);
    }
};
_.hasShadow = function hasShadow_1() {
    return true;
};
_.isSet_0 = function isSet_10() {
    return $isSet_0(this);
};
_.unset = function unset_6() {
    $clear_13(this);
};
var Lorg_eclipse_emf_ecore_impl_EOperationImpl$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EOperationImpl/2', 1316);
function EPackageImpl$1(this$0, val$factory) {
    this.this$01 = this$0;
    this.val$factory2 = val$factory;
}
defineClass(491, 1, {
    1983: 1,
    491: 1
}, EPackageImpl$1);
var Lorg_eclipse_emf_ecore_impl_EPackageImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EPackageImpl/1', 491);
function EObjectContainmentWithInverseEList(dataClass, owner, featureID, inverseFeatureID) {
    EObjectContainmentEList.call(this, dataClass, owner, featureID);
    this.inverseFeatureID = inverseFeatureID;
}
defineClass(14, 81, $intern_156, EObjectContainmentWithInverseEList);
_.getInverseFeatureClass = function getInverseFeatureClass_0() {
    return this.dataClass;
};
_.getInverseFeatureID = function getInverseFeatureID_0() {
    return this.inverseFeatureID;
};
_.hasNavigableInverse = function hasNavigableInverse_4() {
    return true;
};
_.inverseFeatureID = 0;
var Lorg_eclipse_emf_ecore_util_EObjectContainmentWithInverseEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentWithInverseEList', 14);
function EObjectContainmentWithInverseEList$Resolving(dataClass, owner, featureID, inverseFeatureID) {
    EObjectContainmentWithInverseEList.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(358, 14, $intern_156, EObjectContainmentWithInverseEList$Resolving);
_.hasProxies = function hasProxies_3() {
    return true;
};
_.resolve = function resolve_7(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectContainmentWithInverseEList$Resolving_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentWithInverseEList/Resolving', 358);
function EPackageImpl$2(this$0, $anonymous0, $anonymous1) {
    this.this$01 = this$0;
    EObjectContainmentWithInverseEList$Resolving.call(this, $anonymous0, $anonymous1, 5, 6);
}
defineClass(309, 358, $intern_156, EPackageImpl$2);
_.didChange = function didChange_1() {
    this.this$01.eNameToEClassifierMap = null;
};
var Lorg_eclipse_emf_ecore_impl_EPackageImpl$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EPackageImpl/2', 309);
function EPackageImpl$3() {}
defineClass(1238, 1, {}, EPackageImpl$3);
var Lorg_eclipse_emf_ecore_impl_EPackageImpl$3_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EPackageImpl/3', 1238);
function $getEFactory(this$static, nsURI) {
    var ePackage, ePackageDescriptor, result;
    ePackage = $get_15(this$static.stringMap, nsURI);
    if (instanceOf(ePackage, 240)) {
        result = castTo(ePackage, 240);
        result.getNsURI() == null && undefined;
        return result.getEFactoryInstance();
    } else if (instanceOf(ePackage, 491)) {
        ePackageDescriptor = castTo(ePackage, 1983);
        result = ePackageDescriptor.val$factory2;
        return result;
    } else return null;
}
function $getEPackage_0(this$static, nsURI) {
    var ePackage, ePackageDescriptor, result;
    ePackage = nsURI == null ? getEntryValueOrNull($getEntry_0(this$static.hashCodeMap, null)) : $get_15(this$static.stringMap, nsURI);
    if (instanceOf(ePackage, 240)) {
        result = castTo(ePackage, 240);
        result.getNsURI() == null && undefined;
        return result;
    } else if (instanceOf(ePackage, 491)) {
        ePackageDescriptor = castTo(ePackage, 1983);
        result = ePackageDescriptor.this$01;
        !!result && (result.nsURI == null ? undefined : nsURI == null ? $put_9(this$static.hashCodeMap, null, result) : $put_10(this$static.stringMap, nsURI, result));
        return result;
    } else return null;
}
function EPackageRegistryImpl() {
    HashMap.call(this);
}
defineClass(716, 45, $intern_76, EPackageRegistryImpl);
_.containsKey = function containsKey_16(key) {
    return instanceOfString(key) ? $hasStringValue(this, key) : !!$getEntry_0(this.hashCodeMap, key);
};
var Lorg_eclipse_emf_ecore_impl_EPackageRegistryImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EPackageRegistryImpl', 716);
function $eBasicRemoveFromContainerFeature_10(this$static, msgs) {
    var eClass, inverseFeature;
    if (this$static.eFlags_0 >> 16 == 10) return this$static.eContainer.eInverseRemove(this$static, 12, Lorg_eclipse_emf_ecore_EOperation_2_classLit, msgs);
    return inverseFeature = $getEOpposite(castTo($getEStructuralFeature((eClass = castTo($getField(this$static, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EPARAMETER) : eClass), this$static.eFlags_0 >> 16), 19)), this$static.eContainer.eInverseRemove(this$static, inverseFeature.featureID, inverseFeature.containerClass, msgs);
}
function EParameterImpl() {
    ETypedElementImpl.call(this);
}
defineClass(502, 290, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    2062: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    502: 1,
    290: 1,
    117: 1,
    118: 1
}, EParameterImpl);
_.eBasicRemoveFromContainerFeature = function eBasicRemoveFromContainerFeature_11(msgs) {
    return $eBasicRemoveFromContainerFeature_10(this, msgs);
};
_.eGet = function eGet_28(featureID, resolve, coreType) {
    var eClass, lower, upper;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 3:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 4:
            return valueOf_3(this.lowerBound);
        case 5:
            return valueOf_3(this.upperBound);
        case 6:
            return $clinit_Boolean(), upper = this.upperBound, upper > 1 || upper == -1 ? true : false;
        case 7:
            return $clinit_Boolean(), lower = this.lowerBound, lower >= 1 ? true : false;
        case 8:
            if (resolve) return $getEType(this);
            return this.eType;
        case 9:
            return this.eGenericType;
        case 10:
            return this.eFlags_0 >> 16 == 10 ? castTo(this.eContainer, 62) : null;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPARAMETER)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EPARAMETER : eClass), featureID), resolve, coreType);
};
_.eInverseAdd_0 = function eInverseAdd_18(otherEnd, featureID, msgs) {
    var eClass, eContainerFeatureID, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicAdd_0(this.eAnnotations, otherEnd, msgs);
        case 10:
            !!this.eContainer && (msgs = (eContainerFeatureID = this.eFlags_0 >> 16, eContainerFeatureID >= 0 ? $eBasicRemoveFromContainerFeature_10(this, msgs) : this.eContainer.eInverseRemove(this, -1 - eContainerFeatureID, null, msgs)));
            return $eBasicSetContainer(this, otherEnd, 10, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EPARAMETER) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseAdd(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPARAMETER)), otherEnd, msgs);
};
_.eInverseRemove_0 = function eInverseRemove_21(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 9:
            return $basicUnsetEGenericType(this, msgs);
        case 10:
            return $eBasicSetContainer(this, null, 10, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), EPARAMETER) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPARAMETER)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_27(featureID) {
    var eClass, lower, upper;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return (this.eFlags & 256) == 0;
        case 3:
            return (this.eFlags & 512) == 0;
        case 4:
            return this.lowerBound != 0;
        case 5:
            return this.upperBound != 1;
        case 6:
            return upper = this.upperBound, upper > 1 || upper == -1;
        case 7:
            return lower = this.lowerBound, lower >= 1;
        case 8:
            return !!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0;
        case 9:
            return !!this.eGenericType && !(!!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0);
        case 10:
            return !!(this.eFlags_0 >> 16 == 10 ? castTo(this.eContainer, 62) : null);
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EPARAMETER)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EPARAMETER : eClass), featureID));
};
_.eStaticClass = function eStaticClass_27() {
    return $clinit_EcorePackage$Literals(), EPARAMETER;
};
var Lorg_eclipse_emf_ecore_impl_EParameterImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EParameterImpl', 502);
function $basicGetEReferenceType(this$static) {
    var eType;
    if (!this$static.eReferenceType) {
        eType = this$static.eType;
        instanceOf(eType, 88) && (this$static.eReferenceType = castTo(eType, 29));
    }
    return this$static.eReferenceType;
}
function $getEOpposite(this$static) {
    var oldEOpposite;
    if (!!this$static.eOpposite && (this$static.eOpposite.eFlags_0 & 64) != 0) {
        oldEOpposite = this$static.eOpposite;
        this$static.eOpposite = castTo($eResolveProxy(this$static, oldEOpposite), 19);
        this$static.eOpposite != oldEOpposite && (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 9, 21, oldEOpposite, this$static.eOpposite));
    }
    return this$static.eOpposite;
}
function $getEReferenceType(this$static) {
    var eType;
    if (!this$static.eReferenceType || (this$static.eFlags & 1) == 0 && (this$static.eReferenceType.eFlags_0 & 64) != 0) {
        eType = $getEType(this$static);
        instanceOf(eType, 88) && (this$static.eReferenceType = castTo(eType, 29));
    }
    return this$static.eReferenceType;
}
function $setContainment(this$static, value_0) {
    $setContainmentGen(this$static, value_0);
    instanceOf(this$static.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(this$static.eContainer, 88)), 2);
}
function $setContainmentGen(this$static, newContainment) {
    var oldContainment;
    oldContainment = (this$static.eFlags & $intern_137) != 0;
    newContainment ? this$static.eFlags |= $intern_137 : this$static.eFlags &= -32769;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 18, oldContainment, newContainment));
}
function $setEOpposite(this$static, newEOpposite) {
    var oldEOpposite;
    oldEOpposite = this$static.eOpposite;
    this$static.eOpposite = newEOpposite;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 21, oldEOpposite, this$static.eOpposite));
}
function $setResolveProxies(this$static, newResolveProxies) {
    var oldResolveProxies;
    oldResolveProxies = (this$static.eFlags & $intern_64) != 0;
    newResolveProxies ? this$static.eFlags |= $intern_64 : this$static.eFlags &= -65537;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_4(this$static, 1, 20, oldResolveProxies, newResolveProxies));
}
function EReferenceImpl() {
    EStructuralFeatureImpl.call(this);
    this.eFlags |= $intern_64;
}
defineClass(101, 448, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    19: 1,
    178: 1,
    69: 1,
    113: 1,
    467: 1,
    52: 1,
    98: 1,
    157: 1,
    101: 1,
    448: 1,
    290: 1,
    117: 1,
    118: 1,
    677: 1
}, EReferenceImpl);
_.eGet = function eGet_29(featureID, resolve, coreType) {
    var eClass, lower, theOpposite, upper;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return $clinit_Boolean(), (this.eFlags & 256) != 0 ? true : false;
        case 3:
            return $clinit_Boolean(), (this.eFlags & 512) != 0 ? true : false;
        case 4:
            return valueOf_3(this.lowerBound);
        case 5:
            return valueOf_3(this.upperBound);
        case 6:
            return $clinit_Boolean(), upper = this.upperBound, upper > 1 || upper == -1 ? true : false;
        case 7:
            return $clinit_Boolean(), lower = this.lowerBound, lower >= 1 ? true : false;
        case 8:
            if (resolve) return $getEType(this);
            return this.eType;
        case 9:
            return this.eGenericType;
        case 10:
            return $clinit_Boolean(), (this.eFlags & $intern_149) != 0 ? true : false;
        case 11:
            return $clinit_Boolean(), (this.eFlags & $intern_49) != 0 ? true : false;
        case 12:
            return $clinit_Boolean(), (this.eFlags & $intern_62) != 0 ? true : false;
        case 13:
            return this.defaultValueLiteral;
        case 14:
            return $getDefaultValue(this);
        case 15:
            return $clinit_Boolean(), (this.eFlags & $intern_152) != 0 ? true : false;
        case 16:
            return $clinit_Boolean(), (this.eFlags & $intern_17) != 0 ? true : false;
        case 17:
            return $getEContainingClass(this);
        case 18:
            return $clinit_Boolean(), (this.eFlags & $intern_137) != 0 ? true : false;
        case 19:
            return $clinit_Boolean(), theOpposite = $getEOpposite(this), !!theOpposite && (theOpposite.eFlags & $intern_137) != 0 ? true : false;
        case 20:
            return $clinit_Boolean(), (this.eFlags & $intern_64) != 0 ? true : false;
        case 21:
            if (resolve) return $getEOpposite(this);
            return this.eOpposite;
        case 22:
            if (resolve) return $getEReferenceType(this);
            return $basicGetEReferenceType(this);
        case 23:
            return !this.eKeys && (this.eKeys = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, this, 23)), this.eKeys;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EREFERENCE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EREFERENCE : eClass), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_28(featureID) {
    var eClass, lower, theOpposite, upper;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return (this.eFlags & 256) == 0;
        case 3:
            return (this.eFlags & 512) == 0;
        case 4:
            return this.lowerBound != 0;
        case 5:
            return this.upperBound != 1;
        case 6:
            return upper = this.upperBound, upper > 1 || upper == -1;
        case 7:
            return lower = this.lowerBound, lower >= 1;
        case 8:
            return !!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0;
        case 9:
            return !!this.eGenericType && !(!!this.eType && !this.eGenericType.eTypeParameter && $getETypeArguments(this.eGenericType).size_0 == 0);
        case 10:
            return (this.eFlags & $intern_149) == 0;
        case 11:
            return (this.eFlags & $intern_49) != 0;
        case 12:
            return (this.eFlags & $intern_62) != 0;
        case 13:
            return this.defaultValueLiteral != null;
        case 14:
            return $getDefaultValue(this) != null;
        case 15:
            return (this.eFlags & $intern_152) != 0;
        case 16:
            return (this.eFlags & $intern_17) != 0;
        case 17:
            return !!$getEContainingClass(this);
        case 18:
            return (this.eFlags & $intern_137) != 0;
        case 19:
            return theOpposite = $getEOpposite(this), !!theOpposite && (theOpposite.eFlags & $intern_137) != 0;
        case 20:
            return (this.eFlags & $intern_64) == 0;
        case 21:
            return !!this.eOpposite;
        case 22:
            return !!$basicGetEReferenceType(this);
        case 23:
            return !!this.eKeys && this.eKeys.size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EREFERENCE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EREFERENCE : eClass), featureID));
};
_.eSet = function eSet_26(featureID, newValue) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName_0(this, castToString(newValue));
            return;
        case 2:
            $setOrdered(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 3:
            $setUnique_2(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 4:
            $setLowerBound(this, castTo(newValue, 17).value_0);
            return;
        case 5:
            $setUpperBound(this, castTo(newValue, 17).value_0);
            return;
        case 8:
            $setEType(this, castTo(newValue, 141));
            return;
        case 9:
            msgs = $setEGenericType(this, castTo(newValue, 87), null);
            !!msgs && msgs.dispatch_0();
            return;
        case 10:
            $setChangeable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 11:
            $setVolatile(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 12:
            $setTransient(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 13:
            $setDefaultValueLiteral(this, castToString(newValue));
            return;
        case 15:
            $setUnsettable(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 16:
            $setDerived(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 18:
            $setContainment(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 20:
            $setResolveProxies(this, $booleanValue(castToBoolean(newValue)));
            return;
        case 21:
            $setEOpposite(this, castTo(newValue, 19));
            return;
        case 23:
            !this.eKeys && (this.eKeys = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, this, 23));
            $clear_13(this.eKeys);
            !this.eKeys && (this.eKeys = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, this, 23));
            $addAll_9(this.eKeys, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EREFERENCE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EREFERENCE : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_28() {
    return $clinit_EcorePackage$Literals(), EREFERENCE;
};
_.eUnset = function eUnset_26(featureID) {
    var eClass, msgs;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            instanceOf(this.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(this.eContainer, 88)), 4);
            $setName(this, null);
            return;
        case 2:
            $setOrdered(this, true);
            return;
        case 3:
            $setUnique_2(this, true);
            return;
        case 4:
            $setLowerBound(this, 0);
            return;
        case 5:
            $setUpperBound(this, 1);
            return;
        case 8:
            $setEType(this, null);
            return;
        case 9:
            msgs = $setEGenericType(this, null, null);
            !!msgs && msgs.dispatch_0();
            return;
        case 10:
            $setChangeable(this, true);
            return;
        case 11:
            $setVolatile(this, false);
            return;
        case 12:
            $setTransient(this, false);
            return;
        case 13:
            this.defaultValueFactory = null;
            $setDefaultValueLiteralGen(this, null);
            return;
        case 15:
            $setUnsettable(this, false);
            return;
        case 16:
            $setDerived(this, false);
            return;
        case 18:
            $setContainmentGen(this, false);
            instanceOf(this.eContainer, 88) && $setFlags_0($getESuperAdapter(castTo(this.eContainer, 88)), 2);
            return;
        case 20:
            $setResolveProxies(this, true);
            return;
        case 21:
            $setEOpposite(this, null);
            return;
        case 23:
            !this.eKeys && (this.eKeys = new EObjectResolvingEList(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, this, 23));
            $clear_13(this.eKeys);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), EREFERENCE)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? EREFERENCE : eClass), featureID));
};
_.freeze = function freeze_8() {
    $getEReferenceType(this);
    $getName_0($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), this));
    $getEType(this);
    this.eFlags |= 1;
};
_.getEOpposite = function getEOpposite_0() {
    return $getEOpposite(this);
};
_.isContainer = function isContainer_0() {
    var theOpposite;
    return theOpposite = $getEOpposite(this), !!theOpposite && (theOpposite.eFlags & $intern_137) != 0;
};
_.isContainment = function isContainment_6() {
    return (this.eFlags & $intern_137) != 0;
};
_.isResolveProxies_0 = function isResolveProxies_1() {
    return (this.eFlags & $intern_64) != 0;
};
_.setEType = function setEType_1(newEType, msgs) {
    this.eReferenceType = null;
    return $setEType_0(this, newEType, msgs);
};
_.toString_0 = function toString_151() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_29(this);
    result = new StringBuffer_1($toString_29(this));
    result.string += ' (containment: ';
    $append_4(result, (this.eFlags & $intern_137) != 0);
    result.string += ', resolveProxies: ';
    $append_4(result, (this.eFlags & $intern_64) != 0);
    result.string += ')';
    return result.string;
};
var Lorg_eclipse_emf_ecore_impl_EReferenceImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EReferenceImpl', 101);
function $setKey(this$static, key) {
    $setTypedKeyGen(this$static, key == null ? null : (checkCriticalNotNull(key), key));
}
function $setTypedKey_0(this$static, newKey) {
    $setTypedKeyGen(this$static, newKey == null ? null : (checkCriticalNotNull(newKey), newKey));
}
function $setTypedKeyGen(this$static, newKey) {
    var oldKey;
    oldKey = this$static.key;
    this$static.key = newKey;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 0, oldKey, this$static.key));
}
function $setTypedValue_0(this$static, newValue) {
    var oldValue;
    oldValue = this$static.value_0;
    this$static.value_0 = newValue;
    (this$static.eFlags_0 & 4) != 0 && (this$static.eFlags_0 & 1) == 0 && $eNotify(this$static, new ENotificationImpl_1(this$static, 1, 1, oldValue, this$static.value_0));
}
function $setValue_2(this$static, value_0) {
    var oldValue;
    oldValue = this$static.value_0;
    $setTypedValue_0(this$static, value_0);
    return oldValue;
}
function EStringToStringMapEntryImpl() {}
defineClass(546, 118, {
    109: 1,
    43: 1,
    93: 1,
    92: 1,
    135: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    546: 1,
    117: 1,
    118: 1
}, EStringToStringMapEntryImpl);
_.equals_0 = function equals_218(other) {
    return this === other;
};
_.getKey = function getKey_11() {
    return this.key;
};
_.getValue = function getValue_14() {
    return this.value_0;
};
_.hashCode_1 = function hashCode_83() {
    return getObjectIdentityHashCode(this);
};
_.setKey = function setKey_2(key) {
    $setKey(this, castToString(key));
};
_.setValue = function setValue_14(value_0) {
    return $setValue_2(this, castToString(value_0));
};
_.eGet = function eGet_30(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return this.key;
        case 1:
            return this.value_0;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ESTRING_TO_STRING_MAP_ENTRY : eClass), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_29(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return this.key != null;
        case 1:
            return this.value_0 != null;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ESTRING_TO_STRING_MAP_ENTRY : eClass), featureID));
};
_.eSet = function eSet_27(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            $setTypedKey_0(this, castToString(newValue));
            return;
        case 1:
            $setTypedValue_0(this, castToString(newValue));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ESTRING_TO_STRING_MAP_ENTRY : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_29() {
    return $clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY;
};
_.eUnset = function eUnset_27(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            $setTypedKeyGen(this, null);
            return;
        case 1:
            $setTypedValue_0(this, null);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ESTRING_TO_STRING_MAP_ENTRY : eClass), featureID));
};
_.getHash = function getHash_2() {
    var theKey;
    if (this.hash == -1) {
        theKey = this.key;
        this.hash = theKey == null ? 0 : $hashCode_2(theKey);
    }
    return this.hash;
};
_.setHash = function setHash_2(hash) {
    this.hash = hash;
};
_.toString_0 = function toString_152() {
    var result;
    if ((this.eFlags_0 & 64) != 0) return $toString_16(this);
    result = new StringBuffer_1($toString_16(this));
    result.string += ' (key: ';
    $append_3(result, this.key);
    result.string += ', value: ';
    $append_3(result, this.value_0);
    result.string += ')';
    return result.string;
};
_.hash = -1;
_.key = null;
_.value_0 = null;
var Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStringToStringMapEntryImpl', 546);
var Lorg_eclipse_emf_ecore_util_FeatureMap$Entry$Internal_2_classLit = createForInterface('org.eclipse.emf.ecore.util', 'FeatureMap/Entry/Internal');
function $validate_2(this$static, value_0) {
    var valueClass;
    if (value_0 != null && !this$static.eStructuralFeature.getEType().isInstance(value_0)) {
        valueClass = instanceOf(value_0, 57) ? castTo(value_0, 57).eClass_0().name_0 : $getName(getClass__Ljava_lang_Class___devirtual$(value_0));
        throw toJs(new ClassCastException_0("The feature '" + this$static.eStructuralFeature.getName() + "'s type '" + this$static.eStructuralFeature.getEType().getName() + "' does not permit a value of type '" + valueClass + "'"));
    }
}
function EStructuralFeatureImpl$BasicFeatureMapEntry(eStructuralFeature) {
    this.eStructuralFeature = eStructuralFeature;
}
defineClass(558, 1, $intern_161);
_.createEntry = function createEntry(value_0) {
    return this.createEntry_0(castTo(value_0, 52));
};
_.createEntry_0 = function createEntry_0(value_0) {
    return this.createEntry(value_0);
};
_.equals_0 = function equals_219(that) {
    var entry, value_0;
    if (this === that) return true;
    else if (instanceOf(that, 74)) {
        entry = castTo(that, 74);
        if (entry.getEStructuralFeature() == this.eStructuralFeature) {
            value_0 = this.getValue();
            return value_0 == null ? entry.getValue() == null : equals_Ljava_lang_Object__Z__devirtual$(value_0, entry.getValue());
        } else return false;
    } else return false;
};
_.getEStructuralFeature = function getEStructuralFeature_1() {
    return this.eStructuralFeature;
};
_.hashCode_1 = function hashCode_84() {
    var value_0;
    value_0 = this.getValue();
    return hashCode__I__devirtual$(this.eStructuralFeature) ^ (value_0 == null ? 0 : hashCode__I__devirtual$(value_0));
};
_.toString_0 = function toString_153() {
    var eStructuralFeature, prefix;
    eStructuralFeature = this.eStructuralFeature;
    prefix = $getEPackage(eStructuralFeature.getEContainingClass()).getNsPrefix();
    eStructuralFeature.getName();
    return (prefix != null && prefix.length != 0 ? prefix + ':' + eStructuralFeature.getName() : eStructuralFeature.getName()) + '=' + this.getValue();
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$BasicFeatureMapEntry_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/BasicFeatureMapEntry', 558);
function $inverseAdd(this$static, owner, otherEnd, featureID, notifications) {
    var containmentFeatureID;
    if (otherEnd) {
        containmentFeatureID = $getFeatureID(owner.eClass_0(), this$static.eStructuralFeature);
        notifications = otherEnd.eInverseAdd(owner, -1 - (containmentFeatureID == -1 ? featureID : containmentFeatureID), null, notifications);
    }
    return notifications;
}
function $inverseRemove(this$static, owner, otherEnd, featureID, notifications) {
    var containmentFeatureID;
    if (otherEnd) {
        containmentFeatureID = $getFeatureID(owner.eClass_0(), this$static.eStructuralFeature);
        notifications = otherEnd.eInverseRemove(owner, -1 - (containmentFeatureID == -1 ? featureID : containmentFeatureID), null, notifications);
    }
    return notifications;
}
function EStructuralFeatureImpl$ContainmentUpdatingFeatureMapEntry(eStructuralFeature, value_0) {
    EStructuralFeatureImpl$BasicFeatureMapEntry.call(this, eStructuralFeature);
    this.value_0 = value_0;
}
defineClass(771, 558, $intern_161, EStructuralFeatureImpl$ContainmentUpdatingFeatureMapEntry);
_.createEntry_0 = function createEntry_1(value_0) {
    return new EStructuralFeatureImpl$ContainmentUpdatingFeatureMapEntry(this.eStructuralFeature, value_0);
};
_.getValue = function getValue_15() {
    return this.value_0;
};
_.inverseAdd_0 = function inverseAdd_3(owner, featureID, notifications) {
    return $inverseAdd(this, owner, this.value_0, featureID, notifications);
};
_.inverseRemove_0 = function inverseRemove_3(owner, featureID, notifications) {
    return $inverseRemove(this, owner, this.value_0, featureID, notifications);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$ContainmentUpdatingFeatureMapEntry_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/ContainmentUpdatingFeatureMapEntry', 771);
function EStructuralFeatureImpl$InternalSettingDelegateFeatureMapDelegator(feature, featureMapFeature) {
    this.feature = feature;
    this.featureMapFeature = featureMapFeature;
}
defineClass(1289, 1, {}, EStructuralFeatureImpl$InternalSettingDelegateFeatureMapDelegator);
_.dynamicGet_0 = function dynamicGet_3(owner, settings, index_0, resolve, coreType) {
    var featureMap;
    featureMap = castTo($eGet_0(owner, this.featureMapFeature), 218);
    return featureMap.setting(this.feature).get_6(resolve);
};
_.dynamicInverseAdd = function dynamicInverseAdd(owner, settings, index_0, otherEnd, notifications) {
    var featureMap;
    featureMap = castTo($eGet_0(owner, this.featureMapFeature), 218);
    return featureMap.basicAdd_0(this.feature, otherEnd, notifications);
};
_.dynamicInverseRemove = function dynamicInverseRemove(owner, settings, index_0, otherEnd, notifications) {
    var featureMap;
    featureMap = castTo($eGet_0(owner, this.featureMapFeature), 218);
    return featureMap.basicRemove_0(this.feature, otherEnd, notifications);
};
_.dynamicIsSet = function dynamicIsSet(owner, settings, index_0) {
    var featureMap;
    featureMap = castTo($eGet_0(owner, this.featureMapFeature), 218);
    return featureMap.setting(this.feature).isSet_0();
};
_.dynamicSet_0 = function dynamicSet_3(owner, settings, index_0, newValue) {
    var featureMap;
    featureMap = castTo($eGet_0(owner, this.featureMapFeature), 218);
    featureMap.setting(this.feature).set_1(newValue);
};
_.dynamicSetting = function dynamicSetting(owner, settings, index_0) {
    return castTo($eGet_0(owner, this.featureMapFeature), 218).setting(this.feature);
};
_.dynamicUnset_0 = function dynamicUnset_3(owner, settings, index_0) {
    var featureMap;
    featureMap = castTo($eGet_0(owner, this.featureMapFeature), 218);
    featureMap.setting(this.feature).unset();
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateFeatureMapDelegator_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateFeatureMapDelegator', 1289);
function $createDynamicSetting(this$static, owner) {
    switch(this$static.style){
        case 0:
        case 2:
        case 4:
        case 6:
        case 42:
        case 44:
        case 46:
        case 48:
        case 8:
        case 10:
        case 12:
        case 14:
        case 16:
        case 18:
        case 20:
        case 22:
        case 24:
        case 26:
        case 28:
        case 30:
        case 32:
        case 34:
        case 36:
        case 38:
            return new EcoreEList$Dynamic(this$static.dynamicKind, this$static.dataClass, owner, this$static.feature);
        case 1:
            return new EObjectContainmentEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 43:
            return new EObjectContainmentEList$Unsettable$Resolving(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 3:
            return new EObjectContainmentEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 45:
            return new EObjectContainmentEList$Resolving(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 41:
            return new EcoreEMap(castTo($getEType(this$static.feature), 29), this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 50:
            return new EcoreEMap$Unsettable(castTo($getEType(this$static.feature), 29), this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 5:
            return new EObjectContainmentWithInverseEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 47:
            return new EObjectContainmentWithInverseEList$Unsettable$Resolving(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 7:
            return new EObjectContainmentWithInverseEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 49:
            return new EObjectContainmentWithInverseEList$Resolving(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 9:
            return new EDataTypeUniqueEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 11:
            return new EDataTypeUniqueEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 13:
            return new EDataTypeEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 15:
            return new EDataTypeEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 17:
            return new EObjectResolvingEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 19:
            return new EObjectResolvingEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 21:
            return new EObjectEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 23:
            return new EObjectEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        case 25:
            return new EObjectWithInverseResolvingEList$Unsettable$ManyInverse(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 27:
            return new EObjectWithInverseResolvingEList$ManyInverse(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 29:
            return new EObjectWithInverseEList$Unsettable$ManyInverse(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 31:
            return new EObjectWithInverseEList$ManyInverse(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 33:
            return new EObjectWithInverseResolvingEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 35:
            return new EObjectWithInverseResolvingEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 37:
            return new EObjectWithInverseEList$Unsettable(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 39:
            return new EObjectWithInverseEList(this$static.dataClass, owner, $getFeatureID(owner.eClass_0(), this$static.feature), this$static.inverseFeature.featureID);
        case 40:
            return new BasicFeatureMap(owner, $getFeatureID(owner.eClass_0(), this$static.feature));
        default:
            throw toJs(new RuntimeException_0('Unknown feature style: ' + this$static.style));
    }
}
function EStructuralFeatureImpl$InternalSettingDelegateMany(style, dataClass, feature) {
    this.style = style;
    this.dataClass = dataClass;
    this.feature = feature;
}
function EStructuralFeatureImpl$InternalSettingDelegateMany_0(style, dataClass, feature, inverseFeature) {
    this.style = style;
    this.dataClass = dataClass;
    this.feature = feature;
    this.inverseFeature = inverseFeature;
}
function EStructuralFeatureImpl$InternalSettingDelegateMany_1(style, feature) {
    this.style = style;
    this.dataClass = Ljava_lang_Object_2_classLit;
    this.dynamicKind = kind_0(feature);
    this.feature = feature;
}
function EStructuralFeatureImpl$InternalSettingDelegateMany_2(style, feature, inverseFeature) {
    this.style = style;
    this.dataClass = Ljava_lang_Object_2_classLit;
    this.dynamicKind = kind_0(feature);
    this.feature = feature;
    this.inverseFeature = inverseFeature;
}
defineClass(89, 1, {}, EStructuralFeatureImpl$InternalSettingDelegateMany, EStructuralFeatureImpl$InternalSettingDelegateMany_0, EStructuralFeatureImpl$InternalSettingDelegateMany_1, EStructuralFeatureImpl$InternalSettingDelegateMany_2);
_.dynamicGet_0 = function dynamicGet_4(owner, settings, index_0, resolve, coreType) {
    var result;
    result = settings.dynamicGet(index_0);
    result == null && settings.dynamicSet(index_0, result = $createDynamicSetting(this, owner));
    if (!coreType) switch(this.style){
        case 50:
        case 41:
            return castTo(result, 581).map_2();
        case 40:
            return castTo(result, 218).getWrapper();
    }
    return result;
};
_.dynamicInverseAdd = function dynamicInverseAdd_0(owner, settings, index_0, otherEnd, notifications) {
    var result, setting;
    setting = settings.dynamicGet(index_0);
    setting == null && settings.dynamicSet(index_0, setting = $createDynamicSetting(this, owner));
    result = castTo(setting, 71).basicAdd(otherEnd, notifications);
    return result;
};
_.dynamicInverseRemove = function dynamicInverseRemove_0(owner, settings, index_0, otherEnd, notifications) {
    var setting;
    setting = settings.dynamicGet(index_0);
    setting != null && (notifications = castTo(setting, 71).basicRemove(otherEnd, notifications));
    return notifications;
};
_.dynamicIsSet = function dynamicIsSet_0(owner, settings, index_0) {
    var setting;
    setting = settings.dynamicGet(index_0);
    return setting != null && castTo(setting, 76).isSet_0();
};
_.dynamicSet_0 = function dynamicSet_4(owner, settings, index_0, newValue) {
    var setting;
    setting = castTo(settings.dynamicGet(index_0), 76);
    !setting && settings.dynamicSet(index_0, setting = $createDynamicSetting(this, owner));
    setting.set_1(newValue);
};
_.dynamicSetting = function dynamicSetting_0(owner, settings, index_0) {
    var result, setting;
    setting = settings.dynamicGet(index_0);
    setting == null && settings.dynamicSet(index_0, setting = $createDynamicSetting(this, owner));
    if (instanceOf(setting, 76)) return castTo(setting, 76);
    else {
        result = castTo(settings.dynamicGet(index_0), 15);
        return new EStructuralFeatureImpl$SettingMany(result);
    }
};
_.dynamicUnset_0 = function dynamicUnset_4(owner, settings, index_0) {
    var setting;
    setting = castTo(settings.dynamicGet(index_0), 76);
    !setting && settings.dynamicSet(index_0, setting = $createDynamicSetting(this, owner));
    setting.unset();
};
_.dynamicKind = 0;
_.style = 0;
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateMany_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateMany', 89);
function $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle() {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle = emptyMethod;
    NIL_0 = ($clinit_EStructuralFeature$Internal$DynamicValueHolder(), NIL);
}
function EStructuralFeatureImpl$InternalSettingDelegateSingle(feature) {
    this.feature = feature;
}
defineClass(496, 1, {});
_.dynamicInverseAdd = function dynamicInverseAdd_1(owner, settings, index_0, otherEnd, notifications) {
    throw toJs(new UnsupportedOperationException);
};
_.dynamicInverseRemove = function dynamicInverseRemove_1(owner, settings, index_0, otherEnd, notifications) {
    throw toJs(new UnsupportedOperationException);
};
_.dynamicSetting = function dynamicSetting_1(owner, settings, index_0) {
    return new EStructuralFeatureImpl$InternalSettingDelegateSingle$1(this, owner, settings, index_0);
};
var NIL_0;
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingle_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingle', 496);
function EStructuralFeatureImpl$InternalSettingDelegateSingle$1(this$1, val$owner, val$settings, val$index) {
    this.this$11 = this$1;
    this.val$owner2 = val$owner;
    this.val$settings3 = val$settings;
    this.val$index4 = val$index;
}
defineClass(1306, 1, $intern_150, EStructuralFeatureImpl$InternalSettingDelegateSingle$1);
_.get_6 = function get_63(resolve) {
    return this.this$11.dynamicGet_0(this.val$owner2, this.val$settings3, this.val$index4, resolve, true);
};
_.isSet_0 = function isSet_11() {
    return this.this$11.dynamicIsSet(this.val$owner2, this.val$settings3, this.val$index4);
};
_.set_1 = function set_35(newValue) {
    this.this$11.dynamicSet_0(this.val$owner2, this.val$settings3, this.val$index4, newValue);
};
_.unset = function unset_7() {
    this.this$11.dynamicUnset_0(this.val$owner2, this.val$settings3, this.val$index4);
};
_.val$index4 = 0;
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingle$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingle/1', 1306);
function EStructuralFeatureImpl$InternalSettingDelegateSingleContainer(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingle.call(this, feature);
    this.eClass = eClass;
    this.inverseFeature = inverseFeature;
}
defineClass(764, 496, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleContainer);
_.dynamicGet_0 = function dynamicGet_5(owner, settings, index_0, resolve, coreType) {
    return eContainmentFeature(owner, owner.eInternalContainer(), owner.eContainerFeatureID_0()) == this.inverseFeature ? this.isResolveProxies_0() && resolve ? $eContainer(owner) : owner.eInternalContainer() : null;
};
_.dynamicInverseAdd = function dynamicInverseAdd_2(owner, settings, index_0, otherEnd, notifications) {
    var eContainerFeatureID, featureID;
    !!owner.eInternalContainer() && (notifications = (eContainerFeatureID = owner.eContainerFeatureID_0(), eContainerFeatureID >= 0 ? owner.eBasicRemoveFromContainerFeature(notifications) : owner.eInternalContainer().eInverseRemove(owner, -1 - eContainerFeatureID, null, notifications)));
    featureID = $getFeatureID(owner.eClass_0(), this.feature);
    return owner.eBasicSetContainer_0(otherEnd, featureID, notifications);
};
_.dynamicInverseRemove = function dynamicInverseRemove_2(owner, settings, index_0, otherEnd, notifications) {
    var featureID;
    featureID = $getFeatureID(owner.eClass_0(), this.feature);
    return owner.eBasicSetContainer_0(null, featureID, notifications);
};
_.dynamicIsSet = function dynamicIsSet_1(owner, settings, index_0) {
    var featureID;
    featureID = $getFeatureID(owner.eClass_0(), this.feature);
    return !!owner.eInternalContainer() && owner.eContainerFeatureID_0() == featureID;
};
_.dynamicSet_0 = function dynamicSet_5(owner, settings, index_0, newValue) {
    var eContainer, eContainerFeatureID, featureID, internalEObject, notifications;
    if (newValue != null && !$isInstance(this.eClass, newValue)) throw toJs(new ClassCastException_0("The value of type '" + (instanceOf(newValue, 57) ? $toString_31(castTo(newValue, 57).eClass_0()) : $toString_5(getClass__Ljava_lang_Class___devirtual$(newValue))) + "' must be of type '" + this.eClass + "'"));
    eContainer = owner.eInternalContainer();
    featureID = $getFeatureID(owner.eClass_0(), this.feature);
    if (maskUndefined(newValue) !== maskUndefined(eContainer) || owner.eContainerFeatureID_0() != featureID && newValue != null) {
        if (isAncestor(owner, castTo(newValue, 57))) throw toJs(new IllegalArgumentException_0('Recursive containment not allowed for ' + owner.toString_0()));
        notifications = null;
        !!eContainer && (notifications = (eContainerFeatureID = owner.eContainerFeatureID_0(), eContainerFeatureID >= 0 ? owner.eBasicRemoveFromContainerFeature(notifications) : owner.eInternalContainer().eInverseRemove(owner, -1 - eContainerFeatureID, null, notifications)));
        internalEObject = castTo(newValue, 52);
        !!internalEObject && (notifications = internalEObject.eInverseAdd(owner, $getFeatureID(internalEObject.eClass_0(), this.inverseFeature), null, notifications));
        notifications = owner.eBasicSetContainer_0(internalEObject, featureID, notifications);
        !!notifications && notifications.dispatch_0();
    } else owner.eBasicHasAdapters() && owner.eDeliver() && $eNotify(owner, new ENotificationImpl_1(owner, 1, featureID, newValue, newValue));
};
_.dynamicUnset_0 = function dynamicUnset_5(owner, settings, index_0) {
    var eContainer, eContainerFeatureID, featureID, notifications;
    eContainer = owner.eInternalContainer();
    if (eContainer) {
        notifications = (eContainerFeatureID = owner.eContainerFeatureID_0(), eContainerFeatureID >= 0 ? owner.eBasicRemoveFromContainerFeature(null) : owner.eInternalContainer().eInverseRemove(owner, -1 - eContainerFeatureID, null, null));
        featureID = $getFeatureID(owner.eClass_0(), this.feature);
        notifications = owner.eBasicSetContainer_0(null, featureID, notifications);
        !!notifications && notifications.dispatch_0();
    } else owner.eBasicHasAdapters() && owner.eDeliver() && $eNotify(owner, new ENotificationImpl_17(owner, 1, this.feature, null, null));
};
_.isResolveProxies_0 = function isResolveProxies_2() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleContainer_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleContainer', 764);
function EStructuralFeatureImpl$InternalSettingDelegateSingleContainerResolving(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleContainer.call(this, eClass, feature, inverseFeature);
}
defineClass(1290, 764, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleContainerResolving);
_.isResolveProxies_0 = function isResolveProxies_3() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleContainerResolving_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleContainerResolving', 1290);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData(defaultValue, intrinsicDefaultValue, feature) {
    EStructuralFeatureImpl$InternalSettingDelegateSingle.call(this, feature);
    this.defaultValue = defaultValue;
    this.intrinsicDefaultValue = intrinsicDefaultValue;
    this.notificationCreator = ($clinit_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator(), OBJECT_NOTIFICATION_CREATOR);
}
function EStructuralFeatureImpl$InternalSettingDelegateSingleData_0(defaultValue, intrinsicDefaultValue, feature, notificationCreator) {
    EStructuralFeatureImpl$InternalSettingDelegateSingle.call(this, feature);
    this.defaultValue = defaultValue;
    this.intrinsicDefaultValue = intrinsicDefaultValue;
    this.notificationCreator = notificationCreator;
}
defineClass(556, 496, {});
_.dynamicGet_0 = function dynamicGet_6(owner, settings, index_0, resolve, coreType) {
    var result;
    return result = settings.dynamicGet(index_0), result == null ? this.defaultValue : maskUndefined(result) === maskUndefined(NIL_0) ? null : result;
};
_.dynamicIsSet = function dynamicIsSet_2(owner, settings, index_0) {
    var setting;
    setting = settings.dynamicGet(index_0);
    return setting != null && (maskUndefined(setting) === maskUndefined(NIL_0) || !equals_Ljava_lang_Object__Z__devirtual$(setting, this.defaultValue));
};
_.dynamicSet_0 = function dynamicSet_6(owner, settings, index_0, newValue) {
    var oldValue, result;
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        oldValue = (result = settings.dynamicGet(index_0), result == null ? this.defaultValue : maskUndefined(result) === maskUndefined(NIL_0) ? null : result);
        if (newValue == null) {
            if (this.intrinsicDefaultValue != null) {
                settings.dynamicSet(index_0, null);
                newValue = this.defaultValue;
            } else this.defaultValue != null ? settings.dynamicSet(index_0, NIL_0) : settings.dynamicSet(index_0, null);
        } else {
            this.validate_0(newValue);
            settings.dynamicSet(index_0, newValue);
        }
        $eNotify(owner, this.notificationCreator.createNotification_0(owner, 1, this.feature, oldValue, newValue));
    } else if (newValue == null) this.intrinsicDefaultValue != null ? settings.dynamicSet(index_0, null) : this.defaultValue != null ? settings.dynamicSet(index_0, NIL_0) : settings.dynamicSet(index_0, null);
    else {
        this.validate_0(newValue);
        settings.dynamicSet(index_0, newValue);
    }
};
_.dynamicUnset_0 = function dynamicUnset_6(owner, settings, index_0) {
    var oldValue, result;
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        oldValue = (result = settings.dynamicGet(index_0), result == null ? this.defaultValue : maskUndefined(result) === maskUndefined(NIL_0) ? null : result);
        settings.dynamicUnset(index_0);
        $eNotify(owner, this.notificationCreator.createNotification_0(owner, 1, this.feature, oldValue, this.defaultValue));
    } else settings.dynamicUnset(index_0);
};
_.validate_0 = function validate_2(object) {
    throw toJs(new ClassCastException);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData', 556);
function $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator() {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator = emptyMethod;
    OBJECT_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator;
    BOOLEAN_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$1;
    BYTE_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$2;
    CHAR_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$3;
    DOUBLE_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$4;
    FLOAT_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$5;
    INT_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$6;
    LONG_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$7;
    SHORT_NOTIFICATION_CREATOR = new EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$8;
}
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator() {}
defineClass($intern_162, 1, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator);
_.createNotification_0 = function createNotification_7(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_17(notifier, eventType, feature, oldValue, newValue);
};
_.createNotification_1 = function createNotification_8(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_19(notifier, eventType, feature, oldValue, newValue, wasSet);
};
var BOOLEAN_NOTIFICATION_CREATOR, BYTE_NOTIFICATION_CREATOR, CHAR_NOTIFICATION_CREATOR, DOUBLE_NOTIFICATION_CREATOR, FLOAT_NOTIFICATION_CREATOR, INT_NOTIFICATION_CREATOR, LONG_NOTIFICATION_CREATOR, OBJECT_NOTIFICATION_CREATOR, SHORT_NOTIFICATION_CREATOR;
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator', $intern_162);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$1() {}
defineClass(1307, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$1);
_.createNotification_0 = function createNotification_9(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_22(notifier, eventType, feature, $booleanValue(castToBoolean(oldValue)), $booleanValue(castToBoolean(newValue)));
};
_.createNotification_1 = function createNotification_10(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_23(notifier, eventType, feature, $booleanValue(castToBoolean(oldValue)), $booleanValue(castToBoolean(newValue)), wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/1', 1307);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$2() {}
defineClass(1308, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$2);
_.createNotification_0 = function createNotification_11(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_5(notifier, eventType, feature, castTo(oldValue, 219).value_0, castTo(newValue, 219).value_0);
};
_.createNotification_1 = function createNotification_12(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_6(notifier, eventType, feature, castTo(oldValue, 219).value_0, castTo(newValue, 219).value_0, wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/2', 1308);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$3() {}
defineClass(1309, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$3);
_.createNotification_0 = function createNotification_13(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_7(notifier, eventType, feature, castTo(oldValue, 179).value_0, castTo(newValue, 179).value_0);
};
_.createNotification_1 = function createNotification_14(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_8(notifier, eventType, feature, castTo(oldValue, 179).value_0, castTo(newValue, 179).value_0, wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$3_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/3', 1309);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$4() {}
defineClass(1310, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$4);
_.createNotification_0 = function createNotification_15(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_9(notifier, eventType, feature, $doubleValue(castToDouble(oldValue)), $doubleValue(castToDouble(newValue)));
};
_.createNotification_1 = function createNotification_16(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_10(notifier, eventType, feature, $doubleValue(castToDouble(oldValue)), $doubleValue(castToDouble(newValue)), wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$4_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/4', 1310);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$5() {}
defineClass(1311, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$5);
_.createNotification_0 = function createNotification_17(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_11(notifier, eventType, feature, castTo(oldValue, 160).value_0, castTo(newValue, 160).value_0);
};
_.createNotification_1 = function createNotification_18(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_12(notifier, eventType, feature, castTo(oldValue, 160).value_0, castTo(newValue, 160).value_0, wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$5_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/5', 1311);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$6() {}
defineClass(1312, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$6);
_.createNotification_0 = function createNotification_19(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_13(notifier, eventType, feature, castTo(oldValue, 17).value_0, castTo(newValue, 17).value_0);
};
_.createNotification_1 = function createNotification_20(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_14(notifier, eventType, feature, castTo(oldValue, 17).value_0, castTo(newValue, 17).value_0, wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$6_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/6', 1312);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$7() {}
defineClass(1313, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$7);
_.createNotification_0 = function createNotification_21(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_15(notifier, eventType, feature, castTo(oldValue, 190).value_0, castTo(newValue, 190).value_0);
};
_.createNotification_1 = function createNotification_22(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_16(notifier, eventType, feature, castTo(oldValue, 190).value_0, castTo(newValue, 190).value_0, wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$7_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/7', 1313);
function EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$8() {}
defineClass(1314, $intern_162, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$8);
_.createNotification_0 = function createNotification_23(notifier, eventType, feature, oldValue, newValue) {
    return new ENotificationImpl_20(notifier, eventType, feature, castTo(oldValue, 191).value_0, castTo(newValue, 191).value_0);
};
_.createNotification_1 = function createNotification_24(notifier, eventType, feature, oldValue, newValue, wasSet) {
    return new ENotificationImpl_21(notifier, eventType, feature, castTo(oldValue, 191).value_0, castTo(newValue, 191).value_0, wasSet);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleData$NotificationCreator$8_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/8', 1314);
function EStructuralFeatureImpl$InternalSettingDelegateSingleDataDynamic(eDataType, defaultValue, intrinsicDefaultValue, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleData.call(this, defaultValue, intrinsicDefaultValue, feature);
    this.eDataType = eDataType;
}
defineClass(1292, 556, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleDataDynamic);
_.validate_0 = function validate_3(object) {
    if (!this.eDataType.isInstance(object)) throw toJs(new ClassCastException_0("The value of type '" + getClass__Ljava_lang_Class___devirtual$(object) + "' must be of type '" + this.eDataType + "'"));
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleDataDynamic_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataDynamic', 1292);
function EStructuralFeatureImpl$InternalSettingDelegateSingleDataStatic(defaultValue, intrinsicDefaultValue, feature, notificationCreator) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleData_0.call(this, defaultValue, intrinsicDefaultValue, feature, notificationCreator);
}
defineClass(1293, 556, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleDataStatic);
_.validate_0 = function validate_4(object) {};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleDataStatic_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataStatic', 1293);
defineClass(765, 556, {});
_.dynamicIsSet = function dynamicIsSet_3(owner, settings, index_0) {
    var setting;
    setting = settings.dynamicGet(index_0);
    return setting != null;
};
_.dynamicSet_0 = function dynamicSet_7(owner, settings, index_0, newValue) {
    var oldIsSet, oldValue;
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        oldIsSet = true;
        oldValue = settings.dynamicGet(index_0);
        if (oldValue == null) {
            oldIsSet = false;
            oldValue = this.defaultValue;
        } else maskUndefined(oldValue) === maskUndefined(NIL_0) && (oldValue = null);
        if (newValue == null) {
            if (this.intrinsicDefaultValue != null) {
                settings.dynamicSet(index_0, null);
                newValue = this.defaultValue;
            } else settings.dynamicSet(index_0, NIL_0);
        } else {
            this.validate_0(newValue);
            settings.dynamicSet(index_0, newValue);
        }
        $eNotify(owner, this.notificationCreator.createNotification_1(owner, 1, this.feature, oldValue, newValue, !oldIsSet));
    } else if (newValue == null) this.intrinsicDefaultValue != null ? settings.dynamicSet(index_0, null) : settings.dynamicSet(index_0, NIL_0);
    else {
        this.validate_0(newValue);
        settings.dynamicSet(index_0, newValue);
    }
};
_.dynamicUnset_0 = function dynamicUnset_7(owner, settings, index_0) {
    var oldIsSet, oldValue;
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        oldIsSet = true;
        oldValue = settings.dynamicGet(index_0);
        if (oldValue == null) {
            oldIsSet = false;
            oldValue = this.defaultValue;
        } else maskUndefined(oldValue) === maskUndefined(NIL_0) && (oldValue = null);
        settings.dynamicUnset(index_0);
        $eNotify(owner, this.notificationCreator.createNotification_1(owner, 2, this.feature, oldValue, this.defaultValue, oldIsSet));
    } else settings.dynamicUnset(index_0);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettable', 765);
function EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableDynamic(eDataType, defaultValue, intrinsicDefaultValue, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleData.call(this, defaultValue, intrinsicDefaultValue, feature);
    this.eDataType = eDataType;
}
defineClass(1294, 765, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableDynamic);
_.validate_0 = function validate_5(object) {
    if (!this.eDataType.isInstance(object)) throw toJs(new ClassCastException_0("The value of type '" + getClass__Ljava_lang_Class___devirtual$(object) + "' must be of type '" + this.eDataType + "'"));
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableDynamic_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableDynamic', 1294);
function EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableStatic(defaultValue, intrinsicDefaultValue, feature, notificationCreator) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleData_0.call(this, defaultValue, intrinsicDefaultValue, feature, notificationCreator);
}
defineClass(1295, 765, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableStatic);
_.validate_0 = function validate_6(object) {};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleDataUnsettableStatic_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableStatic', 1295);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObject(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingle.call(this, feature);
    this.eClass = eClass;
}
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObject_0(eClass, feature, inverseFeature) {
    EStructuralFeatureImpl$InternalSettingDelegateSingle.call(this, feature);
    this.eClass = eClass;
    this.inverseFeature = inverseFeature;
}
defineClass(399, 496, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObject);
_.dynamicGet_0 = function dynamicGet_7(owner, settings, index_0, resolve, coreType) {
    var newEObject, notificationChain, oldEObject, resolvedEObject, result;
    result = settings.dynamicGet(index_0);
    if (this.isUnsettable() && maskUndefined(result) === maskUndefined(NIL_0)) return null;
    else if (this.isResolveProxies_0() && resolve && result != null) {
        oldEObject = castTo(result, 52);
        if (oldEObject.eIsProxy()) {
            resolvedEObject = $eResolveProxy(owner, oldEObject);
            if (oldEObject != resolvedEObject) {
                if (!$isInstance(this.eClass, resolvedEObject)) throw toJs(new ClassCastException_0("The value of type '" + getClass__Ljava_lang_Class___devirtual$(resolvedEObject) + "' must be of type '" + this.eClass + "'"));
                settings.dynamicSet(index_0, result = resolvedEObject);
                if (this.isContainment()) {
                    newEObject = castTo(resolvedEObject, 52);
                    notificationChain = oldEObject.eInverseRemove(owner, !this.inverseFeature ? -1 - $getFeatureID(owner.eClass_0(), this.feature) : $getFeatureID(oldEObject.eClass_0(), this.inverseFeature), null, null);
                    !newEObject.eInternalContainer() && (notificationChain = newEObject.eInverseAdd(owner, !this.inverseFeature ? -1 - $getFeatureID(owner.eClass_0(), this.feature) : $getFeatureID(newEObject.eClass_0(), this.inverseFeature), null, notificationChain));
                    !!notificationChain && notificationChain.dispatch_0();
                }
                owner.eBasicHasAdapters() && owner.eDeliver() && $eNotify(owner, new ENotificationImpl_17(owner, 9, this.feature, oldEObject, resolvedEObject));
            }
        }
        return result;
    } else return result;
};
_.dynamicInverseAdd = function dynamicInverseAdd_3(owner, settings, index_0, otherEnd, notifications) {
    var internalEObject, oldValue;
    oldValue = settings.dynamicGet(index_0);
    maskUndefined(oldValue) === maskUndefined(NIL_0) && (oldValue = null);
    settings.dynamicSet(index_0, otherEnd);
    if (this.hasInverse()) {
        if (maskUndefined(oldValue) !== maskUndefined(otherEnd) && oldValue != null) {
            internalEObject = castTo(oldValue, 52);
            notifications = internalEObject.eInverseRemove(owner, $getFeatureID(internalEObject.eClass_0(), this.inverseFeature), null, notifications);
        }
    } else this.isContainment() && oldValue != null && (notifications = castTo(oldValue, 52).eInverseRemove(owner, -1 - $getFeatureID(owner.eClass_0(), this.feature), null, notifications));
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        !notifications && (notifications = new NotificationChainImpl_0(4));
        notifications.add_5(new ENotificationImpl_17(owner, 1, this.feature, oldValue, otherEnd));
    }
    return notifications;
};
_.dynamicInverseRemove = function dynamicInverseRemove_3(owner, settings, index_0, otherEnd, notifications) {
    var oldValue;
    oldValue = settings.dynamicGet(index_0);
    maskUndefined(oldValue) === maskUndefined(NIL_0) && (oldValue = null);
    settings.dynamicUnset(index_0);
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        !notifications && (notifications = new NotificationChainImpl_0(4));
        this.isUnsettable() ? notifications.add_5(new ENotificationImpl_17(owner, 2, this.feature, oldValue, null)) : notifications.add_5(new ENotificationImpl_17(owner, 1, this.feature, oldValue, null));
    }
    return notifications;
};
_.dynamicIsSet = function dynamicIsSet_4(owner, settings, index_0) {
    var setting;
    setting = settings.dynamicGet(index_0);
    return setting != null;
};
_.dynamicSet_0 = function dynamicSet_8(owner, settings, index_0, newValue) {
    var internalEObject, notification, notifications, oldIsSet, oldValue;
    if (newValue != null && !$isInstance(this.eClass, newValue)) throw toJs(new ClassCastException_0("The value of type '" + (instanceOf(newValue, 57) ? $toString_31(castTo(newValue, 57).eClass_0()) : $toString_5(getClass__Ljava_lang_Class___devirtual$(newValue))) + "' must be of type '" + this.eClass + "'"));
    oldValue = settings.dynamicGet(index_0);
    oldIsSet = oldValue != null;
    this.isUnsettable() && maskUndefined(oldValue) === maskUndefined(NIL_0) && (oldValue = null);
    notifications = null;
    if (this.hasInverse()) {
        if (maskUndefined(oldValue) !== maskUndefined(newValue)) {
            if (oldValue != null) {
                internalEObject = castTo(oldValue, 52);
                notifications = internalEObject.eInverseRemove(owner, $getFeatureID(internalEObject.eClass_0(), this.inverseFeature), null, notifications);
            }
            if (newValue != null) {
                internalEObject = castTo(newValue, 52);
                notifications = internalEObject.eInverseAdd(owner, $getFeatureID(internalEObject.eClass_0(), this.inverseFeature), null, notifications);
            }
        }
    } else if (this.isContainment()) {
        if (maskUndefined(oldValue) !== maskUndefined(newValue)) {
            oldValue != null && (notifications = castTo(oldValue, 52).eInverseRemove(owner, -1 - $getFeatureID(owner.eClass_0(), this.feature), null, notifications));
            newValue != null && (notifications = castTo(newValue, 52).eInverseAdd(owner, -1 - $getFeatureID(owner.eClass_0(), this.feature), null, notifications));
        }
    }
    newValue == null && this.isUnsettable() ? settings.dynamicSet(index_0, NIL_0) : settings.dynamicSet(index_0, newValue);
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        notification = new ENotificationImpl_19(owner, 1, this.feature, oldValue, newValue, this.isUnsettable() && !oldIsSet);
        if (!notifications) $eNotify(owner, notification);
        else {
            notifications.add_5(notification);
            notifications.dispatch_0();
        }
    } else !!notifications && notifications.dispatch_0();
};
_.dynamicUnset_0 = function dynamicUnset_8(owner, settings, index_0) {
    var internalEObject, notification, notifications, oldIsSet, oldValue;
    oldValue = settings.dynamicGet(index_0);
    oldIsSet = oldValue != null;
    this.isUnsettable() && maskUndefined(oldValue) === maskUndefined(NIL_0) && (oldValue = null);
    notifications = null;
    if (oldValue != null) {
        if (this.hasInverse()) {
            internalEObject = castTo(oldValue, 52);
            notifications = internalEObject.eInverseRemove(owner, $getFeatureID(internalEObject.eClass_0(), this.inverseFeature), null, notifications);
        } else this.isContainment() && (notifications = castTo(oldValue, 52).eInverseRemove(owner, -1 - $getFeatureID(owner.eClass_0(), this.feature), null, notifications));
    }
    settings.dynamicUnset(index_0);
    if (owner.eBasicHasAdapters() && owner.eDeliver()) {
        notification = new ENotificationImpl_19(owner, this.isUnsettable() ? 2 : 1, this.feature, oldValue, null, oldIsSet);
        if (!notifications) $eNotify(owner, notification);
        else {
            notifications.add_5(notification);
            notifications.dispatch_0();
        }
    } else !!notifications && notifications.dispatch_0();
};
_.hasInverse = function hasInverse_6() {
    return false;
};
_.isContainment = function isContainment_7() {
    return false;
};
_.isResolveProxies_0 = function isResolveProxies_4() {
    return false;
};
_.isUnsettable = function isUnsettable_1() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObject_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObject', 399);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainment(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObject.call(this, eClass, feature);
}
defineClass(557, 399, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainment);
_.isContainment = function isContainment_8() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainment_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainment', 557);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentResolving(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainment.call(this, eClass, feature);
}
defineClass(1298, 557, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentResolving);
_.isResolveProxies_0 = function isResolveProxies_5() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentResolving_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentResolving', 1298);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettable(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainment.call(this, eClass, feature);
}
defineClass(767, 557, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettable);
_.isUnsettable = function isUnsettable_2() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettable', 767);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettableResolving(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettable.call(this, eClass, feature);
}
defineClass(1300, 767, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettableResolving);
_.isResolveProxies_0 = function isResolveProxies_6() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentUnsettableResolving_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettableResolving', 1300);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverse(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObject_0.call(this, eClass, feature, inverseFeature);
}
defineClass(633, 557, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverse);
_.hasInverse = function hasInverse_7() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverse_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverse', 633);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseResolving(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverse.call(this, eClass, feature, inverseFeature);
}
defineClass(1299, 633, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseResolving);
_.isResolveProxies_0 = function isResolveProxies_7() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseResolving_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseResolving', 1299);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverse.call(this, eClass, feature, inverseFeature);
}
defineClass(768, 633, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable);
_.isUnsettable = function isUnsettable_3() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable', 768);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable.call(this, eClass, feature, inverseFeature);
}
defineClass(1301, 768, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving);
_.isResolveProxies_0 = function isResolveProxies_8() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving', 1301);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolving(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObject.call(this, eClass, feature);
}
defineClass(634, 399, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolving);
_.isResolveProxies_0 = function isResolveProxies_9() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolving_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolving', 634);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingUnsettable(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolving.call(this, eClass, feature);
}
defineClass(1302, 634, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingUnsettable);
_.isUnsettable = function isUnsettable_4() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingUnsettable', 1302);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverse(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObject_0.call(this, eClass, feature, inverseFeature);
}
defineClass(769, 634, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverse);
_.hasInverse = function hasInverse_8() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverse_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverse', 769);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverse.call(this, eClass, feature, inverseFeature);
}
defineClass(1303, 769, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable);
_.isUnsettable = function isUnsettable_5() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable', 1303);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectUnsettable(eClass, feature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObject.call(this, eClass, feature);
}
defineClass(1296, 399, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectUnsettable);
_.isUnsettable = function isUnsettable_6() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectUnsettable', 1296);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverse(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObject_0.call(this, eClass, feature, inverseFeature);
}
defineClass(766, 399, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverse);
_.hasInverse = function hasInverse_9() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverse_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverse', 766);
function EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverseUnsettable(eClass, feature, inverseFeature) {
    $clinit_EStructuralFeatureImpl$InternalSettingDelegateSingle();
    EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverse.call(this, eClass, feature, inverseFeature);
}
defineClass(1297, 766, {}, EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverseUnsettable);
_.isUnsettable = function isUnsettable_7() {
    return true;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InternalSettingDelegateSingleEObjectWithInverseUnsettable_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverseUnsettable', 1297);
function $inverseAdd_0(this$static, owner, otherEnd, notifications) {
    !!otherEnd && (notifications = otherEnd.eInverseAdd(owner, $getFeatureID(otherEnd.eClass_0(), this$static.eStructuralFeature.getEOpposite()), null, notifications));
    return notifications;
}
function $inverseRemove_0(this$static, owner, otherEnd, notifications) {
    !!otherEnd && (notifications = otherEnd.eInverseRemove(owner, $getFeatureID(otherEnd.eClass_0(), this$static.eStructuralFeature.getEOpposite()), null, notifications));
    return notifications;
}
function EStructuralFeatureImpl$InverseUpdatingFeatureMapEntry(this$0, eStructuralFeature, value_0) {
    this.this$01 = this$0;
    EStructuralFeatureImpl$BasicFeatureMapEntry.call(this, eStructuralFeature);
    this.value_0 = value_0;
}
defineClass(770, 558, $intern_161, EStructuralFeatureImpl$InverseUpdatingFeatureMapEntry);
_.createEntry_0 = function createEntry_2(value_0) {
    return new EStructuralFeatureImpl$InverseUpdatingFeatureMapEntry(this.this$01, this.eStructuralFeature, value_0);
};
_.getValue = function getValue_16() {
    return this.value_0;
};
_.inverseAdd_0 = function inverseAdd_4(owner, featureID, notifications) {
    return $inverseAdd_0(this, owner, this.value_0, notifications);
};
_.inverseRemove_0 = function inverseRemove_4(owner, featureID, notifications) {
    return $inverseRemove_0(this, owner, this.value_0, notifications);
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$InverseUpdatingFeatureMapEntry_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/InverseUpdatingFeatureMapEntry', 770);
function EStructuralFeatureImpl$SettingMany(list) {
    this.list = list;
}
defineClass(1304, 1, $intern_150, EStructuralFeatureImpl$SettingMany);
_.get_6 = function get_64(resolve) {
    return this.list;
};
_.isSet_0 = function isSet_12() {
    return instanceOf(this.list, 96) ? castTo(this.list, 96).isSet_0() : !this.list.isEmpty();
};
_.set_1 = function set_36(newValue) {
    this.list.clear_0();
    this.list.addAll(castTo(newValue, 15));
};
_.unset = function unset_8() {
    instanceOf(this.list, 96) ? castTo(this.list, 96).unset() : this.list.clear_0();
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$SettingMany_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/SettingMany', 1304);
function EStructuralFeatureImpl$SimpleContentFeatureMapEntry(eStructuralFeature) {
    this.eStructuralFeature = eStructuralFeature;
    this.eDataType = castTo($getEType(eStructuralFeature), 155);
    this.eFactory = this.eDataType.getEPackage().getEFactoryInstance();
}
defineClass(1305, 558, $intern_161, EStructuralFeatureImpl$SimpleContentFeatureMapEntry);
_.createEntry = function createEntry_3(value_0) {
    return new EStructuralFeatureImpl$SimpleFeatureMapEntry(($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__TEXT), this.eFactory.convertToString(this.eDataType, value_0));
};
_.getValue = function getValue_17() {
    return null;
};
_.inverseAdd_0 = function inverseAdd_5(owner, featureID, notifications) {
    return notifications;
};
_.inverseRemove_0 = function inverseRemove_5(owner, featureID, notifications) {
    return notifications;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$SimpleContentFeatureMapEntry_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/SimpleContentFeatureMapEntry', 1305);
function EStructuralFeatureImpl$SimpleFeatureMapEntry(eStructuralFeature, value_0) {
    EStructuralFeatureImpl$BasicFeatureMapEntry.call(this, eStructuralFeature);
    this.value_0 = value_0;
}
defineClass(635, 558, $intern_161, EStructuralFeatureImpl$SimpleFeatureMapEntry);
_.createEntry = function createEntry_4(value_0) {
    return new EStructuralFeatureImpl$SimpleFeatureMapEntry(this.eStructuralFeature, value_0);
};
_.getValue = function getValue_18() {
    return this.value_0;
};
_.inverseAdd_0 = function inverseAdd_6(owner, featureID, notifications) {
    return notifications;
};
_.inverseRemove_0 = function inverseRemove_6(owner, featureID, notifications) {
    return notifications;
};
var Lorg_eclipse_emf_ecore_impl_EStructuralFeatureImpl$SimpleFeatureMapEntry_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EStructuralFeatureImpl/SimpleFeatureMapEntry', 635);
function ESuperAdapter$1() {}
defineClass(394, 490, $intern_140, ESuperAdapter$1);
_.newData = function newData_12(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EClass_2_classLit, $intern_2, 29, capacity, 0, 1);
};
_.useEquals = function useEquals_13() {
    return false;
};
var Lorg_eclipse_emf_ecore_impl_ESuperAdapter$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ESuperAdapter/1', 394);
function $getEGenericTypes(this$static) {
    !this$static.eGenericTypes && (this$static.eGenericTypes = new ETypeParameterImpl$2$1(new ETypeParameterImpl$2));
    return this$static.eGenericTypes;
}
function ETypeParameterImpl() {}
defineClass(443, 436, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    113: 1,
    829: 1,
    52: 1,
    98: 1,
    157: 1,
    443: 1,
    117: 1,
    118: 1
}, ETypeParameterImpl);
_.eGet = function eGet_31(featureID, resolve, coreType) {
    var eClass;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), this.eAnnotations;
        case 1:
            return this.name_0;
        case 2:
            return !this.eBounds && (this.eBounds = new ETypeParameterImpl$1(this, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this)), this.eBounds;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ETYPE_PARAMETER)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ETYPE_PARAMETER : eClass), featureID), resolve, coreType);
};
_.eInverseRemove_0 = function eInverseRemove_22(otherEnd, featureID, msgs) {
    var eClass, feature;
    switch(featureID){
        case 0:
            return !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3)), $basicRemove_0(this.eAnnotations, otherEnd, msgs);
        case 2:
            return !this.eBounds && (this.eBounds = new ETypeParameterImpl$1(this, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this)), $basicRemove_0(this.eBounds, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ($clinit_EcorePackage$Literals(), ETYPE_PARAMETER) : eClass), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings_0(this), featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ETYPE_PARAMETER)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_30(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            return !!this.eAnnotations && this.eAnnotations.size_0 != 0;
        case 1:
            return this.name_0 != null;
        case 2:
            return !!this.eBounds && this.eBounds.size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ETYPE_PARAMETER)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ETYPE_PARAMETER : eClass), featureID));
};
_.eSet = function eSet_28(featureID, newValue) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $addAll_9(this.eAnnotations, castTo(newValue, 16));
            return;
        case 1:
            $setName(this, castToString(newValue));
            return;
        case 2:
            !this.eBounds && (this.eBounds = new ETypeParameterImpl$1(this, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this));
            $clear_13(this.eBounds);
            !this.eBounds && (this.eBounds = new ETypeParameterImpl$1(this, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this));
            $addAll_9(this.eBounds, castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ETYPE_PARAMETER)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ETYPE_PARAMETER : eClass), featureID), newValue);
};
_.eStaticClass = function eStaticClass_30() {
    return $clinit_EcorePackage$Literals(), ETYPE_PARAMETER;
};
_.eUnset = function eUnset_28(featureID) {
    var eClass;
    switch(featureID){
        case 0:
            !this.eAnnotations && (this.eAnnotations = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, this, 0, 3));
            $clear_13(this.eAnnotations);
            return;
        case 1:
            $setName(this, null);
            return;
        case 2:
            !this.eBounds && (this.eBounds = new ETypeParameterImpl$1(this, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, this));
            $clear_13(this.eBounds);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_EcorePackage$Literals(), ETYPE_PARAMETER)), $getEStructuralFeature((eClass = castTo($getField(this, 16), 29), !eClass ? ETYPE_PARAMETER : eClass), featureID));
};
var Lorg_eclipse_emf_ecore_impl_ETypeParameterImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ETypeParameterImpl', 443);
function $inverseAdd_1(this$static, object, notifications) {
    var delegateIterator, eGenericType, eGenericType$iterator, eGenericTypes, internalEObject;
    notifications = (internalEObject = object, $eInverseAdd(internalEObject, this$static.owner, -1 - this$static.featureID, notifications));
    eGenericTypes = $getEGenericTypes(this$static.this$01);
    for(eGenericType$iterator = (delegateIterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(eGenericTypes.this$11).this$01), new ETypeParameterImpl$2$1$1(delegateIterator)); eGenericType$iterator.val$delegateIterator2.hasNext;){
        eGenericType = castTo($next_3(eGenericType$iterator.val$delegateIterator2).getKey(), 87);
        notifications = $setERawType(eGenericType, $getErasure(eGenericType, this$static.this$01), notifications);
    }
    return notifications;
}
function $inverseRemove_1(this$static, object, notifications) {
    var delegateIterator, eGenericType, eGenericType$iterator, eGenericTypes, internalEObject;
    notifications = (internalEObject = object, $eInverseRemove(internalEObject, this$static.owner, -1 - this$static.featureID, notifications));
    eGenericTypes = $getEGenericTypes(this$static.this$01);
    for(eGenericType$iterator = (delegateIterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(eGenericTypes.this$11).this$01), new ETypeParameterImpl$2$1$1(delegateIterator)); eGenericType$iterator.val$delegateIterator2.hasNext;){
        eGenericType = castTo($next_3(eGenericType$iterator.val$delegateIterator2).getKey(), 87);
        notifications = $setERawType(eGenericType, $getErasure(eGenericType, this$static.this$01), notifications);
    }
    return notifications;
}
function ETypeParameterImpl$1(this$0, $anonymous0, $anonymous1) {
    this.this$01 = this$0;
    EObjectContainmentEList.call(this, $anonymous0, $anonymous1, 2);
}
defineClass(444, 81, $intern_156, ETypeParameterImpl$1);
_.inverseAdd = function inverseAdd_7(object, notifications) {
    return $inverseAdd_1(this, castTo(object, 87), notifications);
};
_.inverseRemove = function inverseRemove_7(object, notifications) {
    return $inverseRemove_1(this, castTo(object, 87), notifications);
};
var Lorg_eclipse_emf_ecore_impl_ETypeParameterImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ETypeParameterImpl/1', 444);
function ETypeParameterImpl$2() {
    HashMap.call(this);
}
defineClass(632, 45, $intern_76, ETypeParameterImpl$2);
_.keySet_0 = function keySet_20() {
    return new ETypeParameterImpl$2$1(this);
};
var Lorg_eclipse_emf_ecore_impl_ETypeParameterImpl$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ETypeParameterImpl/2', 632);
function $add_30(this$static, eGenericType) {
    return $put_6(this$static.this$11, eGenericType, '') == null;
}
function $remove_42(this$static, object) {
    if ($containsKey_3(this$static.this$11, object)) {
        $remove_6(this$static.this$11, object);
        return true;
    } else return false;
}
function ETypeParameterImpl$2$1(this$1) {
    this.this$11 = this$1;
}
defineClass(553, $intern_9, $intern_10, ETypeParameterImpl$2$1);
_.add_2 = function add_65(eGenericType) {
    return $add_30(this, castTo(eGenericType, 87));
};
_.addAll = function addAll_33(eGenericTypes) {
    var eGenericType, eGenericType$iterator, result;
    result = false;
    for(eGenericType$iterator = eGenericTypes.iterator_0(); eGenericType$iterator.hasNext_0();){
        eGenericType = castTo(eGenericType$iterator.next_1(), 87);
        $put_6(this.this$11, eGenericType, '') == null && (result = true);
    }
    return result;
};
_.clear_0 = function clear_65() {
    $reset(this.this$11);
};
_.contains = function contains_64(object) {
    return $containsKey_3(this.this$11, object);
};
_.iterator_0 = function iterator_89() {
    var delegateIterator;
    return delegateIterator = new AbstractHashMap$EntrySetIterator(new AbstractHashMap$EntrySet(this.this$11).this$01), new ETypeParameterImpl$2$1$1(delegateIterator);
};
_.remove_1 = function remove_127(object) {
    return $remove_42(this, object);
};
_.size_1 = function size_79() {
    return $size_2(this.this$11);
};
var Lorg_eclipse_emf_ecore_impl_ETypeParameterImpl$2$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ETypeParameterImpl/2/1', 553);
function ETypeParameterImpl$2$1$1(val$delegateIterator) {
    this.val$delegateIterator2 = val$delegateIterator;
}
defineClass(554, 1, $intern_6, ETypeParameterImpl$2$1$1);
_.forEachRemaining = function forEachRemaining_58(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_48() {
    return castTo($next_3(this.val$delegateIterator2).getKey(), 87);
};
_.hasNext_0 = function hasNext_47() {
    return this.val$delegateIterator2.hasNext;
};
_.remove = function remove_128() {
    $remove_7(this.val$delegateIterator2);
};
var Lorg_eclipse_emf_ecore_impl_ETypeParameterImpl$2$1$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'ETypeParameterImpl/2/1/1', 554);
function EValidatorRegistryImpl() {
    HashMap.call(this);
}
defineClass(1270, 45, $intern_76, EValidatorRegistryImpl);
_.containsKey = function containsKey_17(key) {
    return instanceOfString(key) ? $hasStringValue(this, key) : !!$getEntry_0(this.hashCodeMap, key);
};
_.get_3 = function get_65(key) {
    var eValidator, eValidatorDescriptor;
    eValidator = instanceOfString(key) ? $getStringValue(this, key) : getEntryValueOrNull($getEntry_0(this.hashCodeMap, key));
    if (instanceOf(eValidator, 830)) {
        eValidatorDescriptor = castTo(eValidator, 830);
        eValidator = eValidatorDescriptor.getEValidator();
        $put_6(this, castTo(key, 240), eValidator);
        return eValidator;
    } else return eValidator != null ? eValidator : key == null ? ($clinit_EObjectValidator(), INSTANCE_9) : null;
};
var Lorg_eclipse_emf_ecore_impl_EValidatorRegistryImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EValidatorRegistryImpl', 1270);
function $booleanValueOf(initialValue) {
    if ($equalsIgnoreCase('true', initialValue)) return $clinit_Boolean(), TRUE_0;
    else if ($equalsIgnoreCase('false', initialValue)) return $clinit_Boolean(), FALSE_0;
    else throw toJs(new IllegalArgumentException_0('Expecting true or false'));
}
function $convertEByteArrayToString(instanceValue) {
    var bytes;
    if (instanceValue == null) return null;
    else {
        bytes = castTo(instanceValue, 195);
        return $bytesToHexString(bytes, bytes.length);
    }
}
function $convertECharToString(instanceValue) {
    if (instanceOf(instanceValue, 179)) return '' + castTo(instanceValue, 179).value_0;
    return instanceValue == null ? null : toString_40(instanceValue);
}
function $convertECharacterObjectToString(instanceValue) {
    if (instanceOf(instanceValue, 179)) return '' + castTo(instanceValue, 179).value_0;
    return instanceValue == null ? null : toString_40(instanceValue);
}
function $createECharFromString(initialValue) {
    var carray, charValue;
    if (initialValue == null) return null;
    charValue = 0;
    try {
        charValue = __parseAndValidateInt(initialValue, $intern_42, $intern_0) & $intern_46;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 130)) {
            carray = $toCharArray(initialValue);
            charValue = carray[0];
        } else throw toJs($e0);
    }
    return valueOf_2(charValue);
}
function $createECharacterObjectFromString(initialValue) {
    var carray, charValue;
    if (initialValue == null) return null;
    charValue = 0;
    try {
        charValue = __parseAndValidateInt(initialValue, $intern_42, $intern_0) & $intern_46;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 130)) {
            carray = $toCharArray(initialValue);
            charValue = carray[0];
        } else throw toJs($e0);
    }
    return valueOf_2(charValue);
}
function $createEDateFromString(initialValue) {
    var exception, i, parseException;
    if (initialValue == null) return null;
    exception = null;
    for(i = 0; i < EDATE_FORMATS.length; ++i)try {
        return $parse_2(EDATE_FORMATS[i], initialValue);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 32)) {
            parseException = $e0;
            exception = parseException;
        } else throw toJs($e0);
    }
    throw toJs(new WrappedException(exception));
}
function EcoreFactoryImpl() {}
function init_3() {
    $clinit_EFactoryImpl();
    var exception, theEcoreFactory;
    try {
        theEcoreFactory = castTo($getEFactory(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2002/Ecore'), 1986);
        if (theEcoreFactory) return theEcoreFactory;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            exception = $e0;
            $log_2(($clinit_EcorePlugin(), exception));
        } else throw toJs($e0);
    }
    return new EcoreFactoryImpl;
}
defineClass(1288, 704, {
    109: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    1986: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1
}, EcoreFactoryImpl);
_.convertToString = function convertToString_1(eDataType, instanceValue) {
    switch(eDataType.getClassifierID()){
        case 21:
        case 22:
        case 23:
        case 24:
        case 26:
        case 31:
        case 32:
        case 37:
        case 38:
        case 39:
        case 40:
        case 43:
        case 44:
        case 48:
        case 49:
        case 20:
            return instanceValue == null ? null : toString_40(instanceValue);
        case 25:
            return $convertEByteArrayToString(instanceValue);
        case 27:
            return $convertECharToString(instanceValue);
        case 28:
            return $convertECharacterObjectToString(instanceValue);
        case 29:
            return instanceValue == null ? null : $format_0(EDATE_FORMATS[0], castTo(instanceValue, 205));
        case 41:
            return instanceValue == null ? '' : $getName(castTo(instanceValue, 295));
        case 42:
            return toString_40(instanceValue);
        case 50:
            return castToString(instanceValue);
        default:
            throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    }
};
_.create_3 = function create_48(eClass0) {
    var eAnnotation, eAttribute, eClass, eDataType, eEnum, eEnumLiteral, eFactory, eGenericType, eObject, eOperation, ePackage, ePackage0, eParameter, eReference, eStringToStringMapEntry, eTypeParameter;
    switch(eClass0.metaObjectID == -1 && (eClass0.metaObjectID = (ePackage0 = $getEPackage(eClass0), ePackage0 ? $indexOf_6(ePackage0.getEClassifiers(), eClass0) : -1)), eClass0.metaObjectID){
        case 0:
            return eAttribute = new EAttributeImpl, eAttribute;
        case 1:
            return eAnnotation = new EAnnotationImpl, eAnnotation;
        case 2:
            return eClass = new EClassImpl, eClass;
        case 4:
            return eDataType = new EDataTypeImpl, eDataType;
        case 5:
            return eEnum = new EEnumImpl, eEnum;
        case 6:
            return eEnumLiteral = new EEnumLiteralImpl, eEnumLiteral;
        case 7:
            return eFactory = new EFactoryImpl, eFactory;
        case 10:
            return eObject = new EObjectImpl, eObject;
        case 11:
            return eOperation = new EOperationImpl, eOperation;
        case 12:
            return ePackage = new EPackageImpl, ePackage;
        case 13:
            return eParameter = new EParameterImpl, eParameter;
        case 14:
            return eReference = new EReferenceImpl, eReference;
        case 17:
            return eStringToStringMapEntry = new EStringToStringMapEntryImpl, eStringToStringMapEntry;
        case 18:
            return eGenericType = new EGenericTypeImpl, eGenericType;
        case 19:
            return eTypeParameter = new ETypeParameterImpl, eTypeParameter;
        default:
            throw toJs(new IllegalArgumentException_0("The class '" + eClass0.name_0 + "' is not a valid classifier"));
    }
};
_.createFromString = function createFromString_1(eDataType, initialValue) {
    switch(eDataType.getClassifierID()){
        case 20:
            return initialValue == null ? null : new BigDecimal_0(initialValue);
        case 21:
            return initialValue == null ? null : new BigInteger_3(initialValue);
        case 23:
        case 22:
            return initialValue == null ? null : $booleanValueOf(initialValue);
        case 26:
        case 24:
            return initialValue == null ? null : get_32(__parseAndValidateInt(initialValue, -128, 127) << 24 >> 24);
        case 25:
            return $hexStringToBytes(initialValue);
        case 27:
            return $createECharFromString(initialValue);
        case 28:
            return $createECharacterObjectFromString(initialValue);
        case 29:
            return $createEDateFromString(initialValue);
        case 32:
        case 31:
            return initialValue == null ? null : __parseAndValidateDouble(initialValue);
        case 38:
        case 37:
            return initialValue == null ? null : new Float_0(initialValue);
        case 40:
        case 39:
            return initialValue == null ? null : valueOf_3(__parseAndValidateInt(initialValue, $intern_42, $intern_0));
        case 41:
            return null;
        case 42:
            return initialValue == null ? null : null;
        case 44:
        case 43:
            return initialValue == null ? null : valueOf_4(__parseAndValidateLong(initialValue));
        case 49:
        case 48:
            return initialValue == null ? null : valueOf_5(__parseAndValidateInt(initialValue, $intern_163, 32767) << 16 >> 16);
        case 50:
            return initialValue;
        default:
            throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    }
};
var Lorg_eclipse_emf_ecore_impl_EcoreFactoryImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcoreFactoryImpl', 1288);
function $clinit_EcorePackageImpl() {
    $clinit_EcorePackageImpl = emptyMethod;
    eGenericTypes_0 = new ArrayList;
}
function $$init_12(this$static) {
    this$static.eAttributeEClass = null;
    this$static.eAnnotationEClass = null;
    this$static.eClassEClass = null;
    this$static.eDataTypeEClass = null;
    this$static.eEnumEClass = null;
    this$static.eEnumLiteralEClass = null;
    this$static.eFactoryEClass = null;
    this$static.eClassifierEClass = null;
    this$static.eModelElementEClass = null;
    this$static.eNamedElementEClass = null;
    this$static.eObjectEClass = null;
    this$static.eOperationEClass = null;
    this$static.ePackageEClass = null;
    this$static.eParameterEClass = null;
    this$static.eReferenceEClass = null;
    this$static.eStructuralFeatureEClass = null;
    this$static.eTypedElementEClass = null;
    this$static.eStringToStringMapEntryEClass = null;
    this$static.eGenericTypeEClass = null;
    this$static.eTypeParameterEClass = null;
    this$static.eBigDecimalEDataType = null;
    this$static.eBigIntegerEDataType = null;
    this$static.eBooleanObjectEDataType = null;
    this$static.eCharacterObjectEDataType = null;
    this$static.eDateEDataType = null;
    this$static.eDiagnosticChainEDataType = null;
    this$static.eDoubleObjectEDataType = null;
    this$static.eFloatObjectEDataType = null;
    this$static.eIntegerObjectEDataType = null;
    this$static.eBooleanEDataType = null;
    this$static.eByteObjectEDataType = null;
    this$static.eByteEDataType = null;
    this$static.eByteArrayEDataType = null;
    this$static.eCharEDataType = null;
    this$static.eDoubleEDataType = null;
    this$static.eFloatEDataType = null;
    this$static.eIntEDataType = null;
    this$static.eJavaClassEDataType = null;
    this$static.eJavaObjectEDataType = null;
    this$static.eLongObjectEDataType = null;
    this$static.eMapEDataType = null;
    this$static.eShortObjectEDataType = null;
    this$static.eLongEDataType = null;
    this$static.eShortEDataType = null;
    this$static.eTreeIteratorEDataType = null;
    this$static.eInvocationTargetExceptionEDataType = null;
    this$static.eFeatureMapEntryEDataType = null;
    this$static.eEnumeratorEDataType = null;
    this$static.eFeatureMapEDataType = null;
    this$static.eStringEDataType = null;
    this$static.eeListEDataType = null;
    this$static.eResourceEDataType = null;
    this$static.eResourceSetEDataType = null;
    this$static.isCreated = false;
    this$static.isInitialized = false;
}
function $createEGenericType_1() {
    var eGenericType, eGenericType0, eGenericType1;
    eGenericType0 = (eGenericType1 = (eGenericType = new EGenericTypeImpl, eGenericType), eGenericType1);
    $add_3(eGenericTypes_0, eGenericType0);
    return eGenericType0;
}
function $createEcoreAnnotations(this$static) {
    $addAnnotation(this$static.eAttributeEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'ConsistentTransient'
    ]));
    $addAnnotation(this$static.eAnnotationEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'WellFormedSourceURI'
    ]));
    $addAnnotation(this$static.eClassEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'InterfaceIsAbstract AtMostOneID UniqueFeatureNames UniqueOperationSignatures NoCircularSuperTypes WellFormedMapEntryClass ConsistentSuperTypes DisjointFeatureAndOperationSignatures'
    ]));
    $addAnnotation(this$static.eClassifierEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'WellFormedInstanceTypeName UniqueTypeParameterNames'
    ]));
    $addAnnotation(this$static.eEnumEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'UniqueEnumeratorNames UniqueEnumeratorLiterals'
    ]));
    $addAnnotation(this$static.eNamedElementEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'WellFormedName'
    ]));
    $addAnnotation(this$static.eOperationEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'UniqueParameterNames UniqueTypeParameterNames NoRepeatingVoid'
    ]));
    $addAnnotation(this$static.ePackageEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'WellFormedNsURI WellFormedNsPrefix UniqueSubpackageNames UniqueClassifierNames UniqueNsURIs'
    ]));
    $addAnnotation(this$static.eReferenceEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'ConsistentOpposite SingleContainer ConsistentKeys ConsistentUnique ConsistentContainer'
    ]));
    $addAnnotation(this$static.eStructuralFeatureEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'ValidDefaultValueLiteral'
    ]));
    $addAnnotation(this$static.eTypedElementEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'ValidLowerBound ValidUpperBound ConsistentBounds ValidType'
    ]));
    $addAnnotation(this$static.eGenericTypeEClass, 'http://www.eclipse.org/emf/2002/Ecore', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'constraints',
        'ConsistentType ConsistentBounds ConsistentArguments'
    ]));
}
function $createExtendedMetaDataAnnotations(this$static) {
    $addAnnotation(this$static.eBigDecimalEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#decimal'
    ]));
    $addAnnotation(this$static.eBigIntegerEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#integer'
    ]));
    $addAnnotation(this$static.eBooleanEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#boolean'
    ]));
    $addAnnotation(this$static.eBooleanObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EBoolean',
        'name',
        'EBoolean:Object'
    ]));
    $addAnnotation(this$static.eByteEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#byte'
    ]));
    $addAnnotation(this$static.eByteArrayEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#hexBinary'
    ]));
    $addAnnotation(this$static.eByteObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EByte',
        'name',
        'EByte:Object'
    ]));
    $addAnnotation(this$static.eCharacterObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EChar',
        'name',
        'EChar:Object'
    ]));
    $addAnnotation(this$static.eDoubleEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#double'
    ]));
    $addAnnotation(this$static.eDoubleObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EDouble',
        'name',
        'EDouble:Object'
    ]));
    $addAnnotation(this$static.eFloatEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#float'
    ]));
    $addAnnotation(this$static.eFloatObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EFloat',
        'name',
        'EFloat:Object'
    ]));
    $addAnnotation(this$static.eIntEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#int'
    ]));
    $addAnnotation(this$static.eIntegerObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EInt',
        'name',
        'EInt:Object'
    ]));
    $addAnnotation(this$static.eLongEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#long'
    ]));
    $addAnnotation(this$static.eLongObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'ELong',
        'name',
        'ELong:Object'
    ]));
    $addAnnotation(this$static.eShortEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#short'
    ]));
    $addAnnotation(this$static.eShortObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'EShort',
        'name',
        'EShort:Object'
    ]));
    $addAnnotation(this$static.eStringEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'baseType',
        'http://www.w3.org/2001/XMLSchema#string'
    ]));
}
function $createPackageContents_0(this$static) {
    if (this$static.isCreated) return;
    this$static.isCreated = true;
    this$static.eAttributeEClass = $createEClass(this$static, 0);
    $createEAttribute(this$static.eAttributeEClass, 18);
    $createEReference(this$static.eAttributeEClass, 19);
    this$static.eAnnotationEClass = $createEClass(this$static, 1);
    $createEAttribute(this$static.eAnnotationEClass, 1);
    $createEReference(this$static.eAnnotationEClass, 2);
    $createEReference(this$static.eAnnotationEClass, 3);
    $createEReference(this$static.eAnnotationEClass, 4);
    $createEReference(this$static.eAnnotationEClass, 5);
    this$static.eClassEClass = $createEClass(this$static, 2);
    $createEAttribute(this$static.eClassEClass, 8);
    $createEAttribute(this$static.eClassEClass, 9);
    $createEReference(this$static.eClassEClass, 10);
    $createEReference(this$static.eClassEClass, 11);
    $createEReference(this$static.eClassEClass, 12);
    $createEReference(this$static.eClassEClass, 13);
    $createEReference(this$static.eClassEClass, 14);
    $createEReference(this$static.eClassEClass, 15);
    $createEReference(this$static.eClassEClass, 16);
    $createEReference(this$static.eClassEClass, 17);
    $createEReference(this$static.eClassEClass, 18);
    $createEReference(this$static.eClassEClass, 19);
    $createEReference(this$static.eClassEClass, 20);
    $createEReference(this$static.eClassEClass, 21);
    $createEReference(this$static.eClassEClass, 22);
    $createEReference(this$static.eClassEClass, 23);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    $createEOperation(this$static.eClassEClass);
    this$static.eClassifierEClass = $createEClass(this$static, 3);
    $createEAttribute(this$static.eClassifierEClass, 2);
    $createEAttribute(this$static.eClassifierEClass, 3);
    $createEAttribute(this$static.eClassifierEClass, 4);
    $createEAttribute(this$static.eClassifierEClass, 5);
    $createEReference(this$static.eClassifierEClass, 6);
    $createEReference(this$static.eClassifierEClass, 7);
    $createEOperation(this$static.eClassifierEClass);
    $createEOperation(this$static.eClassifierEClass);
    this$static.eDataTypeEClass = $createEClass(this$static, 4);
    $createEAttribute(this$static.eDataTypeEClass, 8);
    this$static.eEnumEClass = $createEClass(this$static, 5);
    $createEReference(this$static.eEnumEClass, 9);
    $createEOperation(this$static.eEnumEClass);
    $createEOperation(this$static.eEnumEClass);
    $createEOperation(this$static.eEnumEClass);
    this$static.eEnumLiteralEClass = $createEClass(this$static, 6);
    $createEAttribute(this$static.eEnumLiteralEClass, 2);
    $createEAttribute(this$static.eEnumLiteralEClass, 3);
    $createEAttribute(this$static.eEnumLiteralEClass, 4);
    $createEReference(this$static.eEnumLiteralEClass, 5);
    this$static.eFactoryEClass = $createEClass(this$static, 7);
    $createEReference(this$static.eFactoryEClass, 1);
    $createEOperation(this$static.eFactoryEClass);
    $createEOperation(this$static.eFactoryEClass);
    $createEOperation(this$static.eFactoryEClass);
    this$static.eModelElementEClass = $createEClass(this$static, 8);
    $createEReference(this$static.eModelElementEClass, 0);
    $createEOperation(this$static.eModelElementEClass);
    this$static.eNamedElementEClass = $createEClass(this$static, 9);
    $createEAttribute(this$static.eNamedElementEClass, 1);
    this$static.eObjectEClass = $createEClass(this$static, 10);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    $createEOperation(this$static.eObjectEClass);
    this$static.eOperationEClass = $createEClass(this$static, 11);
    $createEReference(this$static.eOperationEClass, 10);
    $createEReference(this$static.eOperationEClass, 11);
    $createEReference(this$static.eOperationEClass, 12);
    $createEReference(this$static.eOperationEClass, 13);
    $createEReference(this$static.eOperationEClass, 14);
    $createEOperation(this$static.eOperationEClass);
    $createEOperation(this$static.eOperationEClass);
    this$static.ePackageEClass = $createEClass(this$static, 12);
    $createEAttribute(this$static.ePackageEClass, 2);
    $createEAttribute(this$static.ePackageEClass, 3);
    $createEReference(this$static.ePackageEClass, 4);
    $createEReference(this$static.ePackageEClass, 5);
    $createEReference(this$static.ePackageEClass, 6);
    $createEReference(this$static.ePackageEClass, 7);
    $createEOperation(this$static.ePackageEClass);
    this$static.eParameterEClass = $createEClass(this$static, 13);
    $createEReference(this$static.eParameterEClass, 10);
    this$static.eReferenceEClass = $createEClass(this$static, 14);
    $createEAttribute(this$static.eReferenceEClass, 18);
    $createEAttribute(this$static.eReferenceEClass, 19);
    $createEAttribute(this$static.eReferenceEClass, 20);
    $createEReference(this$static.eReferenceEClass, 21);
    $createEReference(this$static.eReferenceEClass, 22);
    $createEReference(this$static.eReferenceEClass, 23);
    this$static.eStructuralFeatureEClass = $createEClass(this$static, 15);
    $createEAttribute(this$static.eStructuralFeatureEClass, 10);
    $createEAttribute(this$static.eStructuralFeatureEClass, 11);
    $createEAttribute(this$static.eStructuralFeatureEClass, 12);
    $createEAttribute(this$static.eStructuralFeatureEClass, 13);
    $createEAttribute(this$static.eStructuralFeatureEClass, 14);
    $createEAttribute(this$static.eStructuralFeatureEClass, 15);
    $createEAttribute(this$static.eStructuralFeatureEClass, 16);
    $createEReference(this$static.eStructuralFeatureEClass, 17);
    $createEOperation(this$static.eStructuralFeatureEClass);
    $createEOperation(this$static.eStructuralFeatureEClass);
    this$static.eTypedElementEClass = $createEClass(this$static, 16);
    $createEAttribute(this$static.eTypedElementEClass, 2);
    $createEAttribute(this$static.eTypedElementEClass, 3);
    $createEAttribute(this$static.eTypedElementEClass, 4);
    $createEAttribute(this$static.eTypedElementEClass, 5);
    $createEAttribute(this$static.eTypedElementEClass, 6);
    $createEAttribute(this$static.eTypedElementEClass, 7);
    $createEReference(this$static.eTypedElementEClass, 8);
    $createEReference(this$static.eTypedElementEClass, 9);
    this$static.eStringToStringMapEntryEClass = $createEClass(this$static, 17);
    $createEAttribute(this$static.eStringToStringMapEntryEClass, 0);
    $createEAttribute(this$static.eStringToStringMapEntryEClass, 1);
    this$static.eGenericTypeEClass = $createEClass(this$static, 18);
    $createEReference(this$static.eGenericTypeEClass, 0);
    $createEReference(this$static.eGenericTypeEClass, 1);
    $createEReference(this$static.eGenericTypeEClass, 2);
    $createEReference(this$static.eGenericTypeEClass, 3);
    $createEReference(this$static.eGenericTypeEClass, 4);
    $createEReference(this$static.eGenericTypeEClass, 5);
    $createEOperation(this$static.eGenericTypeEClass);
    this$static.eTypeParameterEClass = $createEClass(this$static, 19);
    $createEReference(this$static.eTypeParameterEClass, 2);
    this$static.eBigDecimalEDataType = $createEDataType(this$static, 20);
    this$static.eBigIntegerEDataType = $createEDataType(this$static, 21);
    this$static.eBooleanEDataType = $createEDataType(this$static, 22);
    this$static.eBooleanObjectEDataType = $createEDataType(this$static, 23);
    this$static.eByteEDataType = $createEDataType(this$static, 24);
    this$static.eByteArrayEDataType = $createEDataType(this$static, 25);
    this$static.eByteObjectEDataType = $createEDataType(this$static, 26);
    this$static.eCharEDataType = $createEDataType(this$static, 27);
    this$static.eCharacterObjectEDataType = $createEDataType(this$static, 28);
    this$static.eDateEDataType = $createEDataType(this$static, 29);
    this$static.eDiagnosticChainEDataType = $createEDataType(this$static, 30);
    this$static.eDoubleEDataType = $createEDataType(this$static, 31);
    this$static.eDoubleObjectEDataType = $createEDataType(this$static, 32);
    this$static.eeListEDataType = $createEDataType(this$static, 33);
    this$static.eEnumeratorEDataType = $createEDataType(this$static, 34);
    this$static.eFeatureMapEDataType = $createEDataType(this$static, 35);
    this$static.eFeatureMapEntryEDataType = $createEDataType(this$static, 36);
    this$static.eFloatEDataType = $createEDataType(this$static, 37);
    this$static.eFloatObjectEDataType = $createEDataType(this$static, 38);
    this$static.eIntEDataType = $createEDataType(this$static, 39);
    this$static.eIntegerObjectEDataType = $createEDataType(this$static, 40);
    this$static.eJavaClassEDataType = $createEDataType(this$static, 41);
    this$static.eJavaObjectEDataType = $createEDataType(this$static, 42);
    this$static.eLongEDataType = $createEDataType(this$static, 43);
    this$static.eLongObjectEDataType = $createEDataType(this$static, 44);
    this$static.eMapEDataType = $createEDataType(this$static, 45);
    this$static.eResourceEDataType = $createEDataType(this$static, 46);
    this$static.eResourceSetEDataType = $createEDataType(this$static, 47);
    this$static.eShortEDataType = $createEDataType(this$static, 48);
    this$static.eShortObjectEDataType = $createEDataType(this$static, 49);
    this$static.eStringEDataType = $createEDataType(this$static, 50);
    this$static.eTreeIteratorEDataType = $createEDataType(this$static, 51);
    this$static.eInvocationTargetExceptionEDataType = $createEDataType(this$static, 52);
}
function $initializePackageContents_0(this$static) {
    var g1, g2, msgs, msgs0, msgs1, msgs2, op;
    if (this$static.isInitialized) return;
    this$static.isInitialized = true;
    $setName(this$static, 'ecore');
    $setNsPrefix(this$static, 'ecore');
    $setNsURI(this$static, 'http://www.eclipse.org/emf/2002/Ecore');
    $addETypeParameter(this$static.eeListEDataType, 'E');
    $addETypeParameter(this$static.eJavaClassEDataType, 'T');
    $addETypeParameter(this$static.eMapEDataType, 'K');
    $addETypeParameter(this$static.eMapEDataType, 'V');
    $addETypeParameter(this$static.eTreeIteratorEDataType, 'E');
    $add_21($getESuperTypes(this$static.eAttributeEClass), this$static.eStructuralFeatureEClass);
    $add_21($getESuperTypes(this$static.eAnnotationEClass), this$static.eModelElementEClass);
    $add_21($getESuperTypes(this$static.eClassEClass), this$static.eClassifierEClass);
    $add_21($getESuperTypes(this$static.eClassifierEClass), this$static.eNamedElementEClass);
    $add_21($getESuperTypes(this$static.eDataTypeEClass), this$static.eClassifierEClass);
    $add_21($getESuperTypes(this$static.eEnumEClass), this$static.eDataTypeEClass);
    $add_21($getESuperTypes(this$static.eEnumLiteralEClass), this$static.eNamedElementEClass);
    $add_21($getESuperTypes(this$static.eFactoryEClass), this$static.eModelElementEClass);
    $add_21($getESuperTypes(this$static.eNamedElementEClass), this$static.eModelElementEClass);
    $add_21($getESuperTypes(this$static.eOperationEClass), this$static.eTypedElementEClass);
    $add_21($getESuperTypes(this$static.ePackageEClass), this$static.eNamedElementEClass);
    $add_21($getESuperTypes(this$static.eParameterEClass), this$static.eTypedElementEClass);
    $add_21($getESuperTypes(this$static.eReferenceEClass), this$static.eStructuralFeatureEClass);
    $add_21($getESuperTypes(this$static.eStructuralFeatureEClass), this$static.eTypedElementEClass);
    $add_21($getESuperTypes(this$static.eTypedElementEClass), this$static.eNamedElementEClass);
    $add_21($getESuperTypes(this$static.eTypeParameterEClass), this$static.eNamedElementEClass);
    $initEClass(this$static.eAttributeEClass, Lorg_eclipse_emf_ecore_EAttribute_2_classLit, 'EAttribute', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eAttributeEClass), 0), 35), this$static.eBooleanEDataType, 'iD', null, 0, 1, Lorg_eclipse_emf_ecore_EAttribute_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eAttributeEClass), 1), 19), this$static.eDataTypeEClass, null, 'eAttributeType', 1, 1, Lorg_eclipse_emf_ecore_EAttribute_2_classLit, true, true, false, false, true, false, true);
    $initEClass(this$static.eAnnotationEClass, Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, 'EAnnotation', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eAnnotationEClass), 0), 35), this$static.eStringEDataType, 'source', null, 0, 1, Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eAnnotationEClass), 1), 19), this$static.eStringToStringMapEntryEClass, null, 'details', 0, -1, Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eAnnotationEClass), 2), 19), this$static.eModelElementEClass, castTo($get_20($getEStructuralFeatures(this$static.eModelElementEClass), 0), 19), 'eModelElement', 0, 1, Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, true, false, true, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eAnnotationEClass), 3), 19), this$static.eObjectEClass, null, 'contents', 0, -1, Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eAnnotationEClass), 4), 19), this$static.eObjectEClass, null, 'references', 0, -1, Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, false, false, true, false, true, false, false);
    $initEClass(this$static.eClassEClass, Lorg_eclipse_emf_ecore_EClass_2_classLit, 'EClass', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 0), 35), this$static.eBooleanEDataType, 'abstract', null, 0, 1, Lorg_eclipse_emf_ecore_EClass_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 1), 35), this$static.eBooleanEDataType, 'interface', null, 0, 1, Lorg_eclipse_emf_ecore_EClass_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 2), 19), this$static.eClassEClass, null, 'eSuperTypes', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, false, false, true, false, true, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 3), 19), this$static.eOperationEClass, castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 0), 19), 'eOperations', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 4), 19), this$static.eAttributeEClass, null, 'eAllAttributes', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 5), 19), this$static.eReferenceEClass, null, 'eAllReferences', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 6), 19), this$static.eReferenceEClass, null, 'eReferences', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 7), 19), this$static.eAttributeEClass, null, 'eAttributes', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 8), 19), this$static.eReferenceEClass, null, 'eAllContainments', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 9), 19), this$static.eOperationEClass, null, 'eAllOperations', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 10), 19), this$static.eStructuralFeatureEClass, null, 'eAllStructuralFeatures', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 11), 19), this$static.eClassEClass, null, 'eAllSuperTypes', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 12), 19), this$static.eAttributeEClass, null, 'eIDAttribute', 0, 1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 13), 19), this$static.eStructuralFeatureEClass, castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 7), 19), 'eStructuralFeatures', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 14), 19), this$static.eGenericTypeEClass, null, 'eGenericSuperTypes', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, false, false, true, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 15), 19), this$static.eGenericTypeEClass, null, 'eAllGenericSuperTypes', 0, -1, Lorg_eclipse_emf_ecore_EClass_2_classLit, true, true, false, false, true, false, true);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 0), 62), this$static.eBooleanEDataType, 'isSuperTypeOf');
    $addEParameter(op, this$static.eClassEClass, 'someClass');
    $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 1), 62), this$static.eIntEDataType, 'getFeatureCount');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 2), 62), this$static.eStructuralFeatureEClass, 'getEStructuralFeature');
    $addEParameter(op, this$static.eIntEDataType, 'featureID');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 3), 62), this$static.eIntEDataType, 'getFeatureID');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 4), 62), this$static.eStructuralFeatureEClass, 'getEStructuralFeature');
    $addEParameter(op, this$static.eStringEDataType, 'featureName');
    $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 5), 62), this$static.eIntEDataType, 'getOperationCount');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 6), 62), this$static.eOperationEClass, 'getEOperation');
    $addEParameter(op, this$static.eIntEDataType, 'operationID');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 7), 62), this$static.eIntEDataType, 'getOperationID');
    $addEParameter(op, this$static.eOperationEClass, 'operation');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 8), 62), this$static.eOperationEClass, 'getOverride');
    $addEParameter(op, this$static.eOperationEClass, 'operation');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassEClass), 9), 62), this$static.eGenericTypeEClass, 'getFeatureType');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    $initEClass(this$static.eClassifierEClass, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, 'EClassifier', true, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 0), 35), this$static.eStringEDataType, 'instanceClassName', null, 0, 1, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, false, true, true, true, true, false);
    g1 = $createEGenericType(this$static.eJavaClassEDataType);
    g2 = $createEGenericType_1();
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    $initEAttribute_0(castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 1), 35), g1, 'instanceClass', Lorg_eclipse_emf_ecore_EClassifier_2_classLit, true, true, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 2), 35), this$static.eJavaObjectEDataType, 'defaultValue', null, 0, 1, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 3), 35), this$static.eStringEDataType, 'instanceTypeName', null, 0, 1, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, false, true, true, true, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 4), 19), this$static.ePackageEClass, castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 3), 19), 'ePackage', 0, 1, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, true, false, false, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 5), 19), this$static.eTypeParameterEClass, null, 'eTypeParameters', 0, -1, Lorg_eclipse_emf_ecore_EClassifier_2_classLit, false, false, true, true, true, false, false);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eClassifierEClass), 0), 62), this$static.eBooleanEDataType, 'isInstance');
    $addEParameter(op, this$static.eJavaObjectEDataType, 'object');
    $initEOperation(castTo($get_20($getEOperations(this$static.eClassifierEClass), 1), 62), this$static.eIntEDataType, 'getClassifierID');
    $initEClass(this$static.eDataTypeEClass, Lorg_eclipse_emf_ecore_EDataType_2_classLit, 'EDataType', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eDataTypeEClass), 0), 35), this$static.eBooleanEDataType, 'serializable', 'true', 0, 1, Lorg_eclipse_emf_ecore_EDataType_2_classLit, false, false, true, false, true, false);
    $initEClass(this$static.eEnumEClass, Lorg_eclipse_emf_ecore_EEnum_2_classLit, 'EEnum', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eEnumEClass), 0), 19), this$static.eEnumLiteralEClass, castTo($get_20($getEStructuralFeatures(this$static.eEnumLiteralEClass), 3), 19), 'eLiterals', 0, -1, Lorg_eclipse_emf_ecore_EEnum_2_classLit, false, false, true, true, false, false, false);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eEnumEClass), 0), 62), this$static.eEnumLiteralEClass, 'getEEnumLiteral');
    $addEParameter(op, this$static.eStringEDataType, 'name');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eEnumEClass), 1), 62), this$static.eEnumLiteralEClass, 'getEEnumLiteral');
    $addEParameter(op, this$static.eIntEDataType, 'value');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eEnumEClass), 2), 62), this$static.eEnumLiteralEClass, 'getEEnumLiteralByLiteral');
    $addEParameter(op, this$static.eStringEDataType, 'literal');
    $initEClass(this$static.eEnumLiteralEClass, Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, 'EEnumLiteral', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eEnumLiteralEClass), 0), 35), this$static.eIntEDataType, 'value', null, 0, 1, Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eEnumLiteralEClass), 1), 35), this$static.eEnumeratorEDataType, 'instance', null, 0, 1, Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, true, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eEnumLiteralEClass), 2), 35), this$static.eStringEDataType, 'literal', null, 0, 1, Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eEnumLiteralEClass), 3), 19), this$static.eEnumEClass, castTo($get_20($getEStructuralFeatures(this$static.eEnumEClass), 0), 19), 'eEnum', 0, 1, Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, true, false, false, false, false, false, false);
    $initEClass(this$static.eFactoryEClass, Lorg_eclipse_emf_ecore_EFactory_2_classLit, 'EFactory', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eFactoryEClass), 0), 19), this$static.ePackageEClass, castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 2), 19), 'ePackage', 1, 1, Lorg_eclipse_emf_ecore_EFactory_2_classLit, true, false, true, false, false, false, false);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eFactoryEClass), 0), 62), this$static.eObjectEClass, 'create');
    $addEParameter(op, this$static.eClassEClass, 'eClass');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eFactoryEClass), 1), 62), this$static.eJavaObjectEDataType, 'createFromString');
    $addEParameter(op, this$static.eDataTypeEClass, 'eDataType');
    $addEParameter(op, this$static.eStringEDataType, 'literalValue');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eFactoryEClass), 2), 62), this$static.eStringEDataType, 'convertToString');
    $addEParameter(op, this$static.eDataTypeEClass, 'eDataType');
    $addEParameter(op, this$static.eJavaObjectEDataType, 'instanceValue');
    $initEClass(this$static.eModelElementEClass, Lorg_eclipse_emf_ecore_EModelElement_2_classLit, 'EModelElement', true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eModelElementEClass), 0), 19), this$static.eAnnotationEClass, castTo($get_20($getEStructuralFeatures(this$static.eAnnotationEClass), 2), 19), 'eAnnotations', 0, -1, Lorg_eclipse_emf_ecore_EModelElement_2_classLit, false, false, true, true, false, false, false);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eModelElementEClass), 0), 62), this$static.eAnnotationEClass, 'getEAnnotation');
    $addEParameter(op, this$static.eStringEDataType, 'source');
    $initEClass(this$static.eNamedElementEClass, Lorg_eclipse_emf_ecore_ENamedElement_2_classLit, 'ENamedElement', true, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eNamedElementEClass), 0), 35), this$static.eStringEDataType, 'name', null, 0, 1, Lorg_eclipse_emf_ecore_ENamedElement_2_classLit, false, false, true, false, true, false);
    $initEClass(this$static.eObjectEClass, Lorg_eclipse_emf_ecore_EObject_2_classLit, 'EObject', false, false, true);
    $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 0), 62), this$static.eClassEClass, 'eClass');
    $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 1), 62), this$static.eBooleanEDataType, 'eIsProxy');
    $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 2), 62), this$static.eResourceEDataType, 'eResource');
    $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 3), 62), this$static.eObjectEClass, 'eContainer');
    $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 4), 62), this$static.eStructuralFeatureEClass, 'eContainingFeature');
    $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 5), 62), this$static.eReferenceEClass, 'eContainmentFeature');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 6), 62), null, 'eContents');
    g1 = $createEGenericType(this$static.eeListEDataType);
    g2 = $createEGenericType(this$static.eObjectEClass);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    msgs0 = $setEGenericType(op, g1, null);
    !!msgs0 && msgs0.dispatch_0();
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 7), 62), null, 'eAllContents');
    g1 = $createEGenericType(this$static.eTreeIteratorEDataType);
    g2 = $createEGenericType(this$static.eObjectEClass);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    msgs1 = $setEGenericType(op, g1, null);
    !!msgs1 && msgs1.dispatch_0();
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 8), 62), null, 'eCrossReferences');
    g1 = $createEGenericType(this$static.eeListEDataType);
    g2 = $createEGenericType(this$static.eObjectEClass);
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    msgs2 = $setEGenericType(op, g1, null);
    !!msgs2 && msgs2.dispatch_0();
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 9), 62), this$static.eJavaObjectEDataType, 'eGet');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 10), 62), this$static.eJavaObjectEDataType, 'eGet');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    $addEParameter(op, this$static.eBooleanEDataType, 'resolve');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 11), 62), null, 'eSet');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    $addEParameter(op, this$static.eJavaObjectEDataType, 'newValue');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 12), 62), this$static.eBooleanEDataType, 'eIsSet');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 13), 62), null, 'eUnset');
    $addEParameter(op, this$static.eStructuralFeatureEClass, 'feature');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eObjectEClass), 14), 62), this$static.eJavaObjectEDataType, 'eInvoke');
    $addEParameter(op, this$static.eOperationEClass, 'operation');
    g1 = $createEGenericType(this$static.eeListEDataType);
    g2 = $createEGenericType_1();
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    $addEParameter_0(op, g1, 'arguments');
    $addEException(op, this$static.eInvocationTargetExceptionEDataType);
    $initEClass(this$static.eOperationEClass, Lorg_eclipse_emf_ecore_EOperation_2_classLit, 'EOperation', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 0), 19), this$static.eClassEClass, castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 3), 19), 'eContainingClass', 0, 1, Lorg_eclipse_emf_ecore_EOperation_2_classLit, true, false, false, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 1), 19), this$static.eTypeParameterEClass, null, 'eTypeParameters', 0, -1, Lorg_eclipse_emf_ecore_EOperation_2_classLit, false, false, true, true, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 2), 19), this$static.eParameterEClass, castTo($get_20($getEStructuralFeatures(this$static.eParameterEClass), 0), 19), 'eParameters', 0, -1, Lorg_eclipse_emf_ecore_EOperation_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 3), 19), this$static.eClassifierEClass, null, 'eExceptions', 0, -1, Lorg_eclipse_emf_ecore_EOperation_2_classLit, false, false, true, false, true, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 4), 19), this$static.eGenericTypeEClass, null, 'eGenericExceptions', 0, -1, Lorg_eclipse_emf_ecore_EOperation_2_classLit, false, false, true, true, false, true, false);
    $initEOperation(castTo($get_20($getEOperations(this$static.eOperationEClass), 0), 62), this$static.eIntEDataType, 'getOperationID');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eOperationEClass), 1), 62), this$static.eBooleanEDataType, 'isOverrideOf');
    $addEParameter(op, this$static.eOperationEClass, 'someOperation');
    $initEClass(this$static.ePackageEClass, Lorg_eclipse_emf_ecore_EPackage_2_classLit, 'EPackage', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 0), 35), this$static.eStringEDataType, 'nsURI', null, 0, 1, Lorg_eclipse_emf_ecore_EPackage_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 1), 35), this$static.eStringEDataType, 'nsPrefix', null, 0, 1, Lorg_eclipse_emf_ecore_EPackage_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 2), 19), this$static.eFactoryEClass, castTo($get_20($getEStructuralFeatures(this$static.eFactoryEClass), 0), 19), 'eFactoryInstance', 1, 1, Lorg_eclipse_emf_ecore_EPackage_2_classLit, true, false, true, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 3), 19), this$static.eClassifierEClass, castTo($get_20($getEStructuralFeatures(this$static.eClassifierEClass), 4), 19), 'eClassifiers', 0, -1, Lorg_eclipse_emf_ecore_EPackage_2_classLit, false, false, true, true, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 4), 19), this$static.ePackageEClass, castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 5), 19), 'eSubpackages', 0, -1, Lorg_eclipse_emf_ecore_EPackage_2_classLit, false, false, true, true, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 5), 19), this$static.ePackageEClass, castTo($get_20($getEStructuralFeatures(this$static.ePackageEClass), 4), 19), 'eSuperPackage', 0, 1, Lorg_eclipse_emf_ecore_EPackage_2_classLit, true, false, false, false, true, false, false);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.ePackageEClass), 0), 62), this$static.eClassifierEClass, 'getEClassifier');
    $addEParameter(op, this$static.eStringEDataType, 'name');
    $initEClass(this$static.eParameterEClass, Lorg_eclipse_emf_ecore_EParameter_2_classLit, 'EParameter', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eParameterEClass), 0), 19), this$static.eOperationEClass, castTo($get_20($getEStructuralFeatures(this$static.eOperationEClass), 2), 19), 'eOperation', 0, 1, Lorg_eclipse_emf_ecore_EParameter_2_classLit, true, false, false, false, false, false, false);
    $initEClass(this$static.eReferenceEClass, Lorg_eclipse_emf_ecore_EReference_2_classLit, 'EReference', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eReferenceEClass), 0), 35), this$static.eBooleanEDataType, 'containment', null, 0, 1, Lorg_eclipse_emf_ecore_EReference_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eReferenceEClass), 1), 35), this$static.eBooleanEDataType, 'container', null, 0, 1, Lorg_eclipse_emf_ecore_EReference_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eReferenceEClass), 2), 35), this$static.eBooleanEDataType, 'resolveProxies', 'true', 0, 1, Lorg_eclipse_emf_ecore_EReference_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eReferenceEClass), 3), 19), this$static.eReferenceEClass, null, 'eOpposite', 0, 1, Lorg_eclipse_emf_ecore_EReference_2_classLit, false, false, true, false, true, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eReferenceEClass), 4), 19), this$static.eClassEClass, null, 'eReferenceType', 1, 1, Lorg_eclipse_emf_ecore_EReference_2_classLit, true, true, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eReferenceEClass), 5), 19), this$static.eAttributeEClass, null, 'eKeys', 0, -1, Lorg_eclipse_emf_ecore_EReference_2_classLit, false, false, true, false, true, false, false);
    $initEClass(this$static.eStructuralFeatureEClass, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, 'EStructuralFeature', true, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 0), 35), this$static.eBooleanEDataType, 'changeable', 'true', 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 1), 35), this$static.eBooleanEDataType, 'volatile', null, 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 2), 35), this$static.eBooleanEDataType, 'transient', null, 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 3), 35), this$static.eStringEDataType, 'defaultValueLiteral', null, 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 4), 35), this$static.eJavaObjectEDataType, 'defaultValue', null, 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 5), 35), this$static.eBooleanEDataType, 'unsettable', null, 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 6), 35), this$static.eBooleanEDataType, 'derived', null, 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, false, false, true, false, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eStructuralFeatureEClass), 7), 19), this$static.eClassEClass, castTo($get_20($getEStructuralFeatures(this$static.eClassEClass), 13), 19), 'eContainingClass', 0, 1, Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, true, false, false, false, false, false, false);
    $initEOperation(castTo($get_20($getEOperations(this$static.eStructuralFeatureEClass), 0), 62), this$static.eIntEDataType, 'getFeatureID');
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eStructuralFeatureEClass), 1), 62), null, 'getContainerClass');
    g1 = $createEGenericType(this$static.eJavaClassEDataType);
    g2 = $createEGenericType_1();
    $add_21((!g1.eTypeArguments && (g1.eTypeArguments = new EObjectContainmentEList(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, g1, 1)), g1.eTypeArguments), g2);
    msgs = $setEGenericType(op, g1, null);
    !!msgs && msgs.dispatch_0();
    $initEClass(this$static.eTypedElementEClass, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, 'ETypedElement', true, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 0), 35), this$static.eBooleanEDataType, 'ordered', 'true', 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 1), 35), this$static.eBooleanEDataType, 'unique', 'true', 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 2), 35), this$static.eIntEDataType, 'lowerBound', null, 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 3), 35), this$static.eIntEDataType, 'upperBound', '1', 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 4), 35), this$static.eBooleanEDataType, 'many', null, 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, true, true, false, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 5), 35), this$static.eBooleanEDataType, 'required', null, 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, true, true, false, false, true, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 6), 19), this$static.eClassifierEClass, null, 'eType', 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, false, true, true, false, true, true, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eTypedElementEClass), 7), 19), this$static.eGenericTypeEClass, null, 'eGenericType', 0, 1, Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, false, true, true, true, false, true, false);
    $initEClass(this$static.eStringToStringMapEntryEClass, Ljava_util_Map$Entry_2_classLit, 'EStringToStringMapEntry', false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStringToStringMapEntryEClass), 0), 35), this$static.eStringEDataType, 'key', null, 0, 1, Ljava_util_Map$Entry_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.eStringToStringMapEntryEClass), 1), 35), this$static.eStringEDataType, 'value', null, 0, 1, Ljava_util_Map$Entry_2_classLit, false, false, true, false, true, false);
    $initEClass(this$static.eGenericTypeEClass, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, 'EGenericType', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eGenericTypeEClass), 0), 19), this$static.eGenericTypeEClass, null, 'eUpperBound', 0, 1, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eGenericTypeEClass), 1), 19), this$static.eGenericTypeEClass, null, 'eTypeArguments', 0, -1, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eGenericTypeEClass), 2), 19), this$static.eClassifierEClass, null, 'eRawType', 1, 1, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, true, false, false, false, true, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eGenericTypeEClass), 3), 19), this$static.eGenericTypeEClass, null, 'eLowerBound', 0, 1, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, false, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eGenericTypeEClass), 4), 19), this$static.eTypeParameterEClass, null, 'eTypeParameter', 0, 1, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, false, false, true, false, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eGenericTypeEClass), 5), 19), this$static.eClassifierEClass, null, 'eClassifier', 0, 1, Lorg_eclipse_emf_ecore_EGenericType_2_classLit, false, false, true, false, true, false, false);
    op = $initEOperation(castTo($get_20($getEOperations(this$static.eGenericTypeEClass), 0), 62), this$static.eBooleanEDataType, 'isInstance');
    $addEParameter(op, this$static.eJavaObjectEDataType, 'object');
    $initEClass(this$static.eTypeParameterEClass, Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, 'ETypeParameter', false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.eTypeParameterEClass), 0), 19), this$static.eGenericTypeEClass, null, 'eBounds', 0, -1, Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, false, false, true, true, false, false, false);
    $initEDataType(this$static.eBigDecimalEDataType, Ljava_math_BigDecimal_2_classLit, 'EBigDecimal', true);
    $initEDataType(this$static.eBigIntegerEDataType, Ljava_math_BigInteger_2_classLit, 'EBigInteger', true);
    $initEDataType(this$static.eBooleanEDataType, Z_classLit, 'EBoolean', true);
    $initEDataType(this$static.eBooleanObjectEDataType, Ljava_lang_Boolean_2_classLit, 'EBooleanObject', true);
    $initEDataType(this$static.eByteEDataType, B_classLit, 'EByte', true);
    $initEDataType(this$static.eByteArrayEDataType, getClassLiteralForArray(B_classLit, 1), 'EByteArray', true);
    $initEDataType(this$static.eByteObjectEDataType, Ljava_lang_Byte_2_classLit, 'EByteObject', true);
    $initEDataType(this$static.eCharEDataType, C_classLit, 'EChar', true);
    $initEDataType(this$static.eCharacterObjectEDataType, Ljava_lang_Character_2_classLit, 'ECharacterObject', true);
    $initEDataType(this$static.eDateEDataType, Ljava_util_Date_2_classLit, 'EDate', true);
    $initEDataType(this$static.eDiagnosticChainEDataType, Lorg_eclipse_emf_common_util_DiagnosticChain_2_classLit, 'EDiagnosticChain', false);
    $initEDataType(this$static.eDoubleEDataType, D_classLit, 'EDouble', true);
    $initEDataType(this$static.eDoubleObjectEDataType, Ljava_lang_Double_2_classLit, 'EDoubleObject', true);
    $initEDataType(this$static.eeListEDataType, Lorg_eclipse_emf_common_util_EList_2_classLit, 'EEList', false);
    $initEDataType(this$static.eEnumeratorEDataType, Lorg_eclipse_emf_common_util_Enumerator_2_classLit, 'EEnumerator', false);
    $initEDataType(this$static.eFeatureMapEDataType, Lorg_eclipse_emf_ecore_util_FeatureMap_2_classLit, 'EFeatureMap', false);
    $initEDataType(this$static.eFeatureMapEntryEDataType, Lorg_eclipse_emf_ecore_util_FeatureMap$Entry_2_classLit, 'EFeatureMapEntry', false);
    $initEDataType(this$static.eFloatEDataType, F_classLit, 'EFloat', true);
    $initEDataType(this$static.eFloatObjectEDataType, Ljava_lang_Float_2_classLit, 'EFloatObject', true);
    $initEDataType(this$static.eIntEDataType, I_classLit, 'EInt', true);
    $initEDataType(this$static.eIntegerObjectEDataType, Ljava_lang_Integer_2_classLit, 'EIntegerObject', true);
    $initEDataType(this$static.eJavaClassEDataType, Ljava_lang_Class_2_classLit, 'EJavaClass', true);
    $initEDataType(this$static.eJavaObjectEDataType, Ljava_lang_Object_2_classLit, 'EJavaObject', true);
    $initEDataType(this$static.eLongEDataType, J_classLit, 'ELong', true);
    $initEDataType(this$static.eLongObjectEDataType, Ljava_lang_Long_2_classLit, 'ELongObject', true);
    $initEDataType(this$static.eMapEDataType, Ljava_util_Map_2_classLit, 'EMap', false);
    $initEDataType(this$static.eResourceEDataType, Lorg_eclipse_emf_ecore_resource_Resource_2_classLit, 'EResource', false);
    $initEDataType(this$static.eResourceSetEDataType, Lorg_eclipse_emf_ecore_resource_ResourceSet_2_classLit, 'EResourceSet', false);
    $initEDataType(this$static.eShortEDataType, S_classLit, 'EShort', true);
    $initEDataType(this$static.eShortObjectEDataType, Ljava_lang_Short_2_classLit, 'EShortObject', true);
    $initEDataType(this$static.eStringEDataType, Ljava_lang_String_2_classLit, 'EString', true);
    $initEDataType(this$static.eTreeIteratorEDataType, Lorg_eclipse_emf_common_util_TreeIterator_2_classLit, 'ETreeIterator', false);
    $initEDataType(this$static.eInvocationTargetExceptionEDataType, Lorg_eclipse_emf_common_util_InvocationTargetException_2_classLit, 'EInvocationTargetException', false);
    $createResource(this$static, 'http://www.eclipse.org/emf/2002/Ecore');
}
function EcorePackageImpl() {
    EPackageImpl_0.call(this, 'http://www.eclipse.org/emf/2002/Ecore', ($clinit_EcoreFactory(), eINSTANCE_1));
    $$init_12(this);
}
function init_4() {
    $clinit_EcorePackageImpl();
    var theEcorePackage;
    if (isInited_0) return castTo($getEPackage_0(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2002/Ecore'), 1984);
    register_0(Ljava_util_Map$Entry_2_classLit, new EcorePackageImpl$44);
    initializeRegistryHelpersGen();
    theEcorePackage = castTo(instanceOf($getStringValue(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2002/Ecore'), 545) ? $getStringValue(INSTANCE_6, 'http://www.eclipse.org/emf/2002/Ecore') : new EcorePackageImpl, 545);
    isInited_0 = true;
    $createPackageContents_0(theEcorePackage);
    $initializePackageContents_0(theEcorePackage);
    $put_6(($clinit_EValidator$Registry(), INSTANCE_8), theEcorePackage, new EcorePackageImpl$1);
    $putStringValue(INSTANCE_6, 'http://www.eclipse.org/emf/2002/Ecore', theEcorePackage);
    return theEcorePackage;
}
function initializeRegistryHelpersGen() {
    register_0(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, new EcorePackageImpl$2);
    register_0(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, new EcorePackageImpl$3);
    register_0(Lorg_eclipse_emf_ecore_EClass_2_classLit, new EcorePackageImpl$4);
    register_0(Lorg_eclipse_emf_ecore_EClassifier_2_classLit, new EcorePackageImpl$5);
    register_0(Lorg_eclipse_emf_ecore_EDataType_2_classLit, new EcorePackageImpl$6);
    register_0(Lorg_eclipse_emf_ecore_EEnum_2_classLit, new EcorePackageImpl$7);
    register_0(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, new EcorePackageImpl$8);
    register_0(Lorg_eclipse_emf_ecore_EFactory_2_classLit, new EcorePackageImpl$9);
    register_0(Lorg_eclipse_emf_ecore_EModelElement_2_classLit, new EcorePackageImpl$10);
    register_0(Lorg_eclipse_emf_ecore_ENamedElement_2_classLit, new EcorePackageImpl$11);
    register_0(Lorg_eclipse_emf_ecore_EObject_2_classLit, new EcorePackageImpl$12);
    register_0(Lorg_eclipse_emf_ecore_EOperation_2_classLit, new EcorePackageImpl$13);
    register_0(Lorg_eclipse_emf_ecore_EPackage_2_classLit, new EcorePackageImpl$14);
    register_0(Lorg_eclipse_emf_ecore_EParameter_2_classLit, new EcorePackageImpl$15);
    register_0(Lorg_eclipse_emf_ecore_EReference_2_classLit, new EcorePackageImpl$16);
    register_0(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, new EcorePackageImpl$17);
    register_0(Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, new EcorePackageImpl$18);
    register_0(Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, new EcorePackageImpl$19);
    register_0(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, new EcorePackageImpl$20);
    register_0(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, new EcorePackageImpl$21);
    register_0(Ljava_lang_Boolean_2_classLit, new EcorePackageImpl$22);
    register_0(getClassLiteralForArray(B_classLit, 1), new EcorePackageImpl$23);
    register_0(Ljava_lang_Byte_2_classLit, new EcorePackageImpl$24);
    register_0(Ljava_lang_Character_2_classLit, new EcorePackageImpl$25);
    register_0(Ljava_util_Date_2_classLit, new EcorePackageImpl$26);
    register_0(Lorg_eclipse_emf_common_util_DiagnosticChain_2_classLit, new EcorePackageImpl$27);
    register_0(Ljava_lang_Double_2_classLit, new EcorePackageImpl$28);
    register_0(Lorg_eclipse_emf_common_util_EList_2_classLit, new EcorePackageImpl$29);
    register_0(Lorg_eclipse_emf_common_util_Enumerator_2_classLit, new EcorePackageImpl$30);
    register_0(Lorg_eclipse_emf_ecore_util_FeatureMap_2_classLit, new EcorePackageImpl$31);
    register_0(Lorg_eclipse_emf_ecore_util_FeatureMap$Entry_2_classLit, new EcorePackageImpl$32);
    register_0(Ljava_lang_Float_2_classLit, new EcorePackageImpl$33);
    register_0(Ljava_lang_Integer_2_classLit, new EcorePackageImpl$34);
    register_0(Ljava_lang_Class_2_classLit, new EcorePackageImpl$35);
    register_0(Ljava_lang_Long_2_classLit, new EcorePackageImpl$36);
    register_0(Ljava_util_Map_2_classLit, new EcorePackageImpl$37);
    register_0(Lorg_eclipse_emf_ecore_resource_Resource_2_classLit, new EcorePackageImpl$38);
    register_0(Lorg_eclipse_emf_ecore_resource_ResourceSet_2_classLit, new EcorePackageImpl$39);
    register_0(Ljava_lang_Short_2_classLit, new EcorePackageImpl$40);
    register_0(Ljava_lang_String_2_classLit, new EcorePackageImpl$41);
    register_0(Lorg_eclipse_emf_common_util_TreeIterator_2_classLit, new EcorePackageImpl$42);
    register_0(Lorg_eclipse_emf_common_util_InvocationTargetException_2_classLit, new EcorePackageImpl$43);
}
function internalBootstrap() {
    $clinit_EcorePackageImpl();
    var eGenericType, eGenericType$iterator;
    $createExtendedMetaDataAnnotations(($clinit_EcorePackage(), eINSTANCE_2));
    $createEcoreAnnotations(eINSTANCE_2);
    $freeze_0(eINSTANCE_2);
    eJavaObject = ($clinit_EcorePackage$Literals(), EJAVA_OBJECT);
    for(eGenericType$iterator = new ArrayList$1(eGenericTypes_0); eGenericType$iterator.i < eGenericType$iterator.this$01.array.length;){
        eGenericType = castTo($next_6(eGenericType$iterator), 246);
        $setERawType(eGenericType, EJAVA_OBJECT, null);
    }
    return true;
}
defineClass(545, 184, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    1984: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    545: 1,
    117: 1,
    118: 1,
    675: 1
}, EcorePackageImpl);
_.isCreated = false;
_.isInitialized = false;
var eGenericTypes_0, isInited_0 = false;
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl', 545);
function EcorePackageImpl$1() {}
defineClass(1194, 1, {
    830: 1
}, EcorePackageImpl$1);
_.getEValidator = function getEValidator() {
    return $clinit_EcoreValidator(), INSTANCE_10;
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/1', 1194);
function EcorePackageImpl$10() {}
defineClass(1203, 1, $intern_164, EcorePackageImpl$10);
_.isInstance = function isInstance_6(instance) {
    return instanceOf(instance, 154);
};
_.newArrayInstance = function newArrayInstance(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EModelElement_2_classLit, $intern_2, 154, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$10_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/10', 1203);
function EcorePackageImpl$11() {}
defineClass(1204, 1, $intern_164, EcorePackageImpl$11);
_.isInstance = function isInstance_7(instance) {
    return instanceOf(instance, 197);
};
_.newArrayInstance = function newArrayInstance_0(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_ENamedElement_2_classLit, $intern_2, 197, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$11_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/11', 1204);
function EcorePackageImpl$12() {}
defineClass(1205, 1, $intern_164, EcorePackageImpl$12);
_.isInstance = function isInstance_8(instance) {
    return instanceOf(instance, 57);
};
_.newArrayInstance = function newArrayInstance_1(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EObject_2_classLit, $intern_2, 57, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$12_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/12', 1205);
function EcorePackageImpl$13() {}
defineClass(1206, 1, $intern_164, EcorePackageImpl$13);
_.isInstance = function isInstance_9(instance) {
    return instanceOf(instance, 400);
};
_.newArrayInstance = function newArrayInstance_2(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EOperation_2_classLit, $intern_154, 62, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$13_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/13', 1206);
function EcorePackageImpl$14() {}
defineClass(1207, 1, $intern_164, EcorePackageImpl$14);
_.isInstance = function isInstance_10(instance) {
    return instanceOf(instance, 240);
};
_.newArrayInstance = function newArrayInstance_3(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EPackage_2_classLit, $intern_2, 240, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$14_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/14', 1207);
function EcorePackageImpl$15() {}
defineClass(1208, 1, $intern_164, EcorePackageImpl$15);
_.isInstance = function isInstance_11(instance) {
    return instanceOf(instance, 502);
};
_.newArrayInstance = function newArrayInstance_4(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EParameter_2_classLit, $intern_2, 2062, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$15_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/15', 1208);
function EcorePackageImpl$16() {}
defineClass(1209, 1, $intern_164, EcorePackageImpl$16);
_.isInstance = function isInstance_12(instance) {
    return instanceOf(instance, 101);
};
_.newArrayInstance = function newArrayInstance_5(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EReference_2_classLit, $intern_153, 19, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$16_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/16', 1209);
function EcorePackageImpl$17() {}
defineClass(1210, 1, $intern_164, EcorePackageImpl$17);
_.isInstance = function isInstance_13(instance) {
    return instanceOf(instance, 178);
};
_.newArrayInstance = function newArrayInstance_6(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, $intern_153, 178, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$17_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/17', 1210);
function EcorePackageImpl$18() {}
defineClass(1211, 1, $intern_164, EcorePackageImpl$18);
_.isInstance = function isInstance_14(instance) {
    return instanceOf(instance, 467);
};
_.newArrayInstance = function newArrayInstance_7(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_ETypedElement_2_classLit, $intern_2, 467, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$18_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/18', 1211);
function EcorePackageImpl$19() {}
defineClass(1212, 1, $intern_164, EcorePackageImpl$19);
_.isInstance = function isInstance_15(instance) {
    return instanceOf(instance, 546);
};
_.newArrayInstance = function newArrayInstance_8(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, $intern_148, 546, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$19_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/19', 1212);
function EcorePackageImpl$2() {}
defineClass(1195, 1, $intern_164, EcorePackageImpl$2);
_.isInstance = function isInstance_16(instance) {
    return instanceOf(instance, 330);
};
_.newArrayInstance = function newArrayInstance_9(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EAttribute_2_classLit, $intern_153, 35, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$2_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/2', 1195);
function EcorePackageImpl$20() {}
defineClass(1213, 1, $intern_164, EcorePackageImpl$20);
_.isInstance = function isInstance_17(instance) {
    return instanceOf(instance, 246);
};
_.newArrayInstance = function newArrayInstance_10(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EGenericType_2_classLit, $intern_157, 87, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$20_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/20', 1213);
function EcorePackageImpl$21() {}
defineClass(1214, 1, $intern_164, EcorePackageImpl$21);
_.isInstance = function isInstance_18(instance) {
    return instanceOf(instance, 443);
};
_.newArrayInstance = function newArrayInstance_11(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_ETypeParameter_2_classLit, $intern_2, 829, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$21_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/21', 1214);
function EcorePackageImpl$22() {}
defineClass(1215, 1, $intern_164, EcorePackageImpl$22);
_.isInstance = function isInstance_19(instance) {
    return instanceOfBoolean(instance);
};
_.newArrayInstance = function newArrayInstance_12(size_0) {
    return initUnidimensionalArray(Ljava_lang_Boolean_2_classLit, $intern_16, 471, size_0, 8, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$22_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/22', 1215);
function EcorePackageImpl$23() {}
defineClass(1216, 1, $intern_164, EcorePackageImpl$23);
_.isInstance = function isInstance_20(instance) {
    return instanceOf(instance, 195);
};
_.newArrayInstance = function newArrayInstance_13(size_0) {
    return initUnidimensionalArray(B_classLit, $intern_16, 195, size_0, 0, 2);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$23_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/23', 1216);
function EcorePackageImpl$24() {}
defineClass(1217, 1, $intern_164, EcorePackageImpl$24);
_.isInstance = function isInstance_21(instance) {
    return instanceOf(instance, 219);
};
_.newArrayInstance = function newArrayInstance_14(size_0) {
    return initUnidimensionalArray(Ljava_lang_Byte_2_classLit, $intern_16, 219, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$24_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/24', 1217);
function EcorePackageImpl$25() {}
defineClass(1218, 1, $intern_164, EcorePackageImpl$25);
_.isInstance = function isInstance_22(instance) {
    return instanceOf(instance, 179);
};
_.newArrayInstance = function newArrayInstance_15(size_0) {
    return initUnidimensionalArray(Ljava_lang_Character_2_classLit, $intern_16, 179, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$25_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/25', 1218);
function EcorePackageImpl$26() {}
defineClass(1219, 1, $intern_164, EcorePackageImpl$26);
_.isInstance = function isInstance_23(instance) {
    return instanceOf(instance, 205);
};
_.newArrayInstance = function newArrayInstance_16(size_0) {
    return initUnidimensionalArray(Ljava_util_Date_2_classLit, $intern_16, 205, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$26_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/26', 1219);
function EcorePackageImpl$27() {}
defineClass(1220, 1, $intern_164, EcorePackageImpl$27);
_.isInstance = function isInstance_24(instance) {
    return false;
};
_.newArrayInstance = function newArrayInstance_17(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_util_DiagnosticChain_2_classLit, $intern_2, 2159, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$27_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/27', 1220);
function EcorePackageImpl$28() {}
defineClass(1221, 1, $intern_164, EcorePackageImpl$28);
_.isInstance = function isInstance_25(instance) {
    return instanceOfDouble(instance);
};
_.newArrayInstance = function newArrayInstance_18(size_0) {
    return initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, size_0, 7, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$28_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/28', 1221);
function EcorePackageImpl$29() {}
defineClass(1222, 1, $intern_164, EcorePackageImpl$29);
_.isInstance = function isInstance_26(instance) {
    return instanceOf(instance, 61);
};
_.newArrayInstance = function newArrayInstance_19(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_util_EList_2_classLit, $intern_94, 61, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$29_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/29', 1222);
function EcorePackageImpl$3() {}
defineClass(1196, 1, $intern_164, EcorePackageImpl$3);
_.isInstance = function isInstance_27(instance) {
    return instanceOf(instance, 503);
};
_.newArrayInstance = function newArrayInstance_20(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EAnnotation_2_classLit, {
        3: 1,
        4: 1,
        5: 1,
        1979: 1
    }, 582, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$3_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/3', 1196);
function EcorePackageImpl$30() {}
defineClass(1223, 1, $intern_164, EcorePackageImpl$30);
_.isInstance = function isInstance_28(instance) {
    return instanceOf(instance, 564);
};
_.newArrayInstance = function newArrayInstance_21(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_util_Enumerator_2_classLit, $intern_2, 1985, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$30_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/30', 1223);
function EcorePackageImpl$31() {}
defineClass(1224, 1, $intern_164, EcorePackageImpl$31);
_.isInstance = function isInstance_29(instance) {
    return instanceOf(instance, 159);
};
_.newArrayInstance = function newArrayInstance_22(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_util_FeatureMap_2_classLit, $intern_94, 159, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$31_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/31', 1224);
function EcorePackageImpl$32() {}
defineClass(1225, 1, $intern_164, EcorePackageImpl$32);
_.isInstance = function isInstance_30(instance) {
    return instanceOf(instance, 74);
};
_.newArrayInstance = function newArrayInstance_23(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_util_FeatureMap$Entry_2_classLit, $intern_165, 74, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$32_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/32', 1225);
function EcorePackageImpl$33() {}
defineClass(1226, 1, $intern_164, EcorePackageImpl$33);
_.isInstance = function isInstance_31(instance) {
    return instanceOf(instance, 160);
};
_.newArrayInstance = function newArrayInstance_24(size_0) {
    return initUnidimensionalArray(Ljava_lang_Float_2_classLit, $intern_16, 160, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$33_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/33', 1226);
function EcorePackageImpl$34() {}
defineClass(1227, 1, $intern_164, EcorePackageImpl$34);
_.isInstance = function isInstance_32(instance) {
    return instanceOf(instance, 17);
};
_.newArrayInstance = function newArrayInstance_25(size_0) {
    return initUnidimensionalArray(Ljava_lang_Integer_2_classLit, $intern_16, 17, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$34_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/34', 1227);
function EcorePackageImpl$35() {}
defineClass(1228, 1, $intern_164, EcorePackageImpl$35);
_.isInstance = function isInstance_33(instance) {
    return instanceOf(instance, 295);
};
_.newArrayInstance = function newArrayInstance_26(size_0) {
    return initUnidimensionalArray(Ljava_lang_Class_2_classLit, $intern_2, 295, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$35_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/35', 1228);
function EcorePackageImpl$36() {}
defineClass(1229, 1, $intern_164, EcorePackageImpl$36);
_.isInstance = function isInstance_34(instance) {
    return instanceOf(instance, 190);
};
_.newArrayInstance = function newArrayInstance_27(size_0) {
    return initUnidimensionalArray(Ljava_lang_Long_2_classLit, $intern_16, 190, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$36_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/36', 1229);
function EcorePackageImpl$37() {}
defineClass(1230, 1, $intern_164, EcorePackageImpl$37);
_.isInstance = function isInstance_35(instance) {
    return instanceOf(instance, 91);
};
_.newArrayInstance = function newArrayInstance_28(size_0) {
    return initUnidimensionalArray(Ljava_util_Map_2_classLit, $intern_2, 91, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$37_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/37', 1230);
function EcorePackageImpl$38() {}
defineClass(1231, 1, $intern_164, EcorePackageImpl$38);
_.isInstance = function isInstance_36(instance) {
    return instanceOf(instance, 583);
};
_.newArrayInstance = function newArrayInstance_29(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_resource_Resource_2_classLit, $intern_2, 583, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$38_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/38', 1231);
function EcorePackageImpl$39() {}
defineClass(1232, 1, $intern_164, EcorePackageImpl$39);
_.isInstance = function isInstance_37(instance) {
    return false;
};
_.newArrayInstance = function newArrayInstance_30(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_resource_ResourceSet_2_classLit, $intern_2, 2160, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$39_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/39', 1232);
function EcorePackageImpl$4() {}
defineClass(1197, 1, $intern_164, EcorePackageImpl$4);
_.isInstance = function isInstance_38(instance) {
    return instanceOf(instance, 88);
};
_.newArrayInstance = function newArrayInstance_31(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EClass_2_classLit, $intern_2, 29, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$4_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/4', 1197);
function EcorePackageImpl$40() {}
defineClass(1233, 1, $intern_164, EcorePackageImpl$40);
_.isInstance = function isInstance_39(instance) {
    return instanceOf(instance, 191);
};
_.newArrayInstance = function newArrayInstance_32(size_0) {
    return initUnidimensionalArray(Ljava_lang_Short_2_classLit, $intern_16, 191, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$40_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/40', 1233);
function EcorePackageImpl$41() {}
defineClass(1234, 1, $intern_164, EcorePackageImpl$41);
_.isInstance = function isInstance_40(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_33(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$41_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/41', 1234);
function EcorePackageImpl$42() {}
defineClass(1235, 1, $intern_164, EcorePackageImpl$42);
_.isInstance = function isInstance_41(instance) {
    return instanceOf(instance, 580);
};
_.newArrayInstance = function newArrayInstance_34(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_util_TreeIterator_2_classLit, $intern_2, 580, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$42_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/42', 1235);
function EcorePackageImpl$43() {}
defineClass(1236, 1, $intern_164, EcorePackageImpl$43);
_.isInstance = function isInstance_42(instance) {
    return false;
};
_.newArrayInstance = function newArrayInstance_35(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_common_util_InvocationTargetException_2_classLit, $intern_16, 2161, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$43_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/43', 1236);
function EcorePackageImpl$44() {}
defineClass(1237, 1, $intern_164, EcorePackageImpl$44);
_.isInstance = function isInstance_43(instance) {
    return instanceOf(instance, 43);
};
_.newArrayInstance = function newArrayInstance_36(size_0) {
    return initUnidimensionalArray(Ljava_util_Map$Entry_2_classLit, $intern_27, 43, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$44_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/44', 1237);
function EcorePackageImpl$5() {}
defineClass(1198, 1, $intern_164, EcorePackageImpl$5);
_.isInstance = function isInstance_44(instance) {
    return instanceOf(instance, 141);
};
_.newArrayInstance = function newArrayInstance_37(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EClassifier_2_classLit, $intern_2, 141, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$5_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/5', 1198);
function EcorePackageImpl$6() {}
defineClass(1199, 1, $intern_164, EcorePackageImpl$6);
_.isInstance = function isInstance_45(instance) {
    return instanceOf(instance, 155);
};
_.newArrayInstance = function newArrayInstance_38(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EDataType_2_classLit, $intern_2, 155, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$6_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/6', 1199);
function EcorePackageImpl$7() {}
defineClass(1200, 1, $intern_164, EcorePackageImpl$7);
_.isInstance = function isInstance_46(instance) {
    return instanceOf(instance, 455);
};
_.newArrayInstance = function newArrayInstance_39(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EEnum_2_classLit, $intern_2, 670, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$7_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/7', 1200);
function EcorePackageImpl$8() {}
defineClass(1201, 1, $intern_164, EcorePackageImpl$8);
_.isInstance = function isInstance_47(instance) {
    return instanceOf(instance, 564);
};
_.newArrayInstance = function newArrayInstance_40(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EEnumLiteral_2_classLit, $intern_2, 679, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$8_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/8', 1201);
function EcorePackageImpl$9() {}
defineClass(1202, 1, $intern_164, EcorePackageImpl$9);
_.isInstance = function isInstance_48(instance) {
    return instanceOf(instance, 466);
};
_.newArrayInstance = function newArrayInstance_41(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EFactory_2_classLit, $intern_2, 466, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_impl_EcorePackageImpl$9_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'EcorePackageImpl/9', 1202);
function $didAdd_1(this$static, newAdapter) {
    var listener$array, listener$index, listener$max, listeners;
    newAdapter.setTarget(this$static.this$01);
    listeners = castTo($getField(this$static.this$01, 8), 1981);
    if (listeners != null) for(listener$array = listeners, listener$index = 0, listener$max = listener$array.length; listener$index < listener$max; ++listener$index)null.$_nullMethod();
}
function $didRemove_0(this$static, index_0, oldAdapter) {
    var adapter, listener$array, listener$index, listener$max, listeners, notification;
    listeners = castTo($getField(this$static.this$01, 8), 1981);
    if (listeners != null) for(listener$array = listeners, listener$index = 0, listener$max = listener$array.length; listener$index < listener$max; ++listener$index)null.$_nullMethod();
    adapter = oldAdapter;
    if ((this$static.this$01.eFlags_0 & 1) == 0) {
        notification = new MinimalEObjectImpl$1ArrayDelegatingAdapterList$1(this$static, oldAdapter, index_0);
        adapter.notifyChanged(notification);
    }
    instanceOf(adapter, 671) ? castTo(adapter, 671).unsetTarget(this$static.this$01) : adapter.getTarget() == this$static.this$01 && adapter.setTarget(null);
}
function $setData(this$static, data_0) {
    var eContainerAdapterArray, eInternalContainer;
    ++this$static.modCount;
    if (data_0 != null) {
        eContainerAdapterArray = (eInternalContainer = this$static.this$01.eContainer, instanceOf(eInternalContainer, 98) ? castTo(eInternalContainer, 98).eBasicAdapterArray() : null);
        if (equals_46(data_0, eContainerAdapterArray)) {
            $setField(this$static.this$01, 4, eContainerAdapterArray);
            return;
        }
    }
    $setField(this$static.this$01, 4, castTo(data_0, 128));
}
function MinimalEObjectImpl$1ArrayDelegatingAdapterList(this$0) {
    $clinit_ArrayDelegatingEList();
    this.this$01 = this$0;
}
defineClass(1013, 2026, $intern_146, MinimalEObjectImpl$1ArrayDelegatingAdapterList);
_.didAdd = function didAdd_2(index_0, newAdapter) {
    $didAdd_1(this, castTo(newAdapter, 412));
};
_.didRemove = function didRemove_1(index_0, oldAdapter) {
    $didRemove_0(this, index_0, castTo(oldAdapter, 412));
};
var Lorg_eclipse_emf_ecore_impl_MinimalEObjectImpl$1ArrayDelegatingAdapterList_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'MinimalEObjectImpl/1ArrayDelegatingAdapterList', 1013);
function MinimalEObjectImpl$1ArrayDelegatingAdapterList$1(this$1, $anonymous1, $anonymous3) {
    this.this$11 = this$1;
    NotificationImpl_1.call(this, 8, $anonymous1, null, $anonymous3);
}
defineClass(1014, 150, $intern_144, MinimalEObjectImpl$1ArrayDelegatingAdapterList$1);
_.getNotifier = function getNotifier_7() {
    return this.this$11.this$01;
};
var Lorg_eclipse_emf_ecore_impl_MinimalEObjectImpl$1ArrayDelegatingAdapterList$1_2_classLit = createForClass('org.eclipse.emf.ecore.impl', 'MinimalEObjectImpl/1ArrayDelegatingAdapterList/1', 1014);
function $clinit_EcorePlugin() {
    $clinit_EcorePlugin = emptyMethod;
    new EcorePlugin;
    new ArrayList;
}
function EcorePlugin() {
    new HashMap;
    new HashMap;
    new HashMap;
}
defineClass(1042, 1041, {}, EcorePlugin);
var Lorg_eclipse_emf_ecore_plugin_EcorePlugin_2_classLit = createForClass('org.eclipse.emf.ecore.plugin', 'EcorePlugin', 1042);
var Lorg_eclipse_emf_ecore_resource_Resource_2_classLit = createForInterface('org.eclipse.emf.ecore.resource', 'Resource');
function $getEObject(this$static, uriFragmentPath) {
    var eObject, i, size_0;
    size_0 = uriFragmentPath.array.length;
    eObject = $getEObjectForURIFragmentRootSegment(this$static, size_0 == 0 ? '' : (checkCriticalElementIndex(0, uriFragmentPath.array.length), castToString(uriFragmentPath.array[0])));
    for(i = 1; i < size_0 && !!eObject; ++i)eObject = castTo(eObject, 52).eObjectForURIFragmentSegment((checkCriticalElementIndex(i, uriFragmentPath.array.length), castToString(uriFragmentPath.array[i])));
    return eObject;
}
function $getEObjectByID(this$static, id_0) {
    var eObject, eObjectId, i, result, eClass, eIDAttribute;
    result = null;
    for(i = new ResourceImpl$5((!this$static.contents && (this$static.contents = new ResourceImpl$ContentsEList(this$static)), this$static.contents)); $hasNext_7(i);){
        eObject = castTo($next_13(i), 57);
        eObjectId = (eClass = eObject.eClass_0(), eIDAttribute = ($getEAllAttributes(eClass), eClass.eIDAttribute), !eIDAttribute || !eObject.eIsSet_0(eIDAttribute) ? null : convertToString_2($getEAttributeType(eIDAttribute), eObject.eGet_0(eIDAttribute)));
        if (eObjectId != null) {
            if ($equals_5(eObjectId, id_0)) {
                result = eObject;
                break;
            }
        }
    }
    return result;
}
function $getEObjectForURIFragmentRootSegment(this$static, uriFragmentRootSegment) {
    var contents, exception, position;
    position = 0;
    if (uriFragmentRootSegment.length > 0) try {
        position = __parseAndValidateInt(uriFragmentRootSegment, $intern_42, $intern_0);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 130)) {
            exception = $e0;
            throw toJs(new WrappedException(exception));
        } else throw toJs($e0);
    }
    contents = (!this$static.contents && (this$static.contents = new ResourceImpl$ContentsEList(this$static)), this$static.contents);
    return position < contents.size_0 && position >= 0 ? castTo($get_20(contents, position), 57) : null;
}
defineClass(779, 1464, $intern_166);
_.attached = function attached(eObject) {};
_.detached = function detached(eObject) {};
_.getContents = function getContents() {
    return !this.contents && (this.contents = new ResourceImpl$ContentsEList(this)), this.contents;
};
_.getEObject = function getEObject(uriFragment) {
    var i, index_0, length_0, start_0, uriFragmentPath;
    length_0 = uriFragment.length;
    if (length_0 > 0) {
        checkCriticalStringElementIndex(0, uriFragment.length);
        if (uriFragment.charCodeAt(0) == 47) {
            uriFragmentPath = new ArrayList_0(4);
            start_0 = 1;
            for(i = 1; i < length_0; ++i){
                checkCriticalStringElementIndex(i, uriFragment.length);
                if (uriFragment.charCodeAt(i) == 47) {
                    $add_3(uriFragmentPath, start_0 == i ? '' : (checkCriticalStringBounds(start_0, i, uriFragment.length), uriFragment.substr(start_0, i - start_0)));
                    start_0 = i + 1;
                }
            }
            $add_3(uriFragmentPath, (checkCriticalStringElementIndex(start_0, uriFragment.length + 1), uriFragment.substr(start_0)));
            return $getEObject(this, uriFragmentPath);
        } else {
            checkCriticalStringElementIndex(length_0 - 1, uriFragment.length);
            if (uriFragment.charCodeAt(length_0 - 1) == 63) {
                index_0 = $lastIndexOf_0(uriFragment, fromCodePoint(63), length_0 - 2);
                index_0 > 0 && (uriFragment = (checkCriticalStringBounds(0, index_0, uriFragment.length), uriFragment.substr(0, index_0)));
            }
        }
    }
    return $getEObjectByID(this, uriFragment);
};
_.getResourceSet = function getResourceSet() {
    return this.resourceSet;
};
_.toString_0 = function toString_154() {
    var number;
    return $getName(this.___clazz) + '@' + (number = hashCode__I__devirtual$(this) >>> 0, number.toString(16)) + " uri='" + this.uri_0 + "'";
};
_.isLoaded = false;
var Lorg_eclipse_emf_ecore_resource_impl_ResourceImpl_2_classLit = createForClass('org.eclipse.emf.ecore.resource.impl', 'ResourceImpl', 779);
function BinaryResourceImpl(uri_0) {
    this.uri_0 = uri_0;
}
defineClass(1465, 779, $intern_166, BinaryResourceImpl);
var Lorg_eclipse_emf_ecore_resource_impl_BinaryResourceImpl_2_classLit = createForClass('org.eclipse.emf.ecore.resource.impl', 'BinaryResourceImpl', 1465);
function $getEObjectChildren(this$static, eObject) {
    return this$static.isResolveProxies ? eObject.eContents_0().iterator_0() : castTo(eObject.eContents_0(), 71).basicIterator();
}
function $hasNext_7(this$static) {
    var iterator;
    if (!this$static.includeRoot && this$static.data_0 == null) {
        this$static.nextPruneIterator = this$static.getChildren(this$static.object);
        $add_21(this$static, this$static.nextPruneIterator);
        iterator = this$static.nextPruneIterator;
    } else {
        if (this$static.data_0 == null) return true;
        else if (this$static.size_0 == 0) return false;
        else iterator = castTo(this$static.data_0[this$static.size_0 - 1], 49);
    }
    if (iterator == this$static.resourceSetIterator && null.$_nullField >= null.$_nullMethod()) {
        $next_13(this$static);
        return $hasNext_7(this$static);
    } else return iterator.hasNext_0();
}
defineClass(1154, 692, $intern_141);
_.getChildren = function getChildren_0(object) {
    return instanceOf(object, 57) ? $getEObjectChildren(this, castTo(object, 57)) : instanceOf(object, 583) ? new AbstractEList$EIterator(castTo(object, 583).getContents()) : maskUndefined(object) === maskUndefined(this.object) ? castTo(object, 16).iterator_0() : ($clinit_ECollections(), EMPTY_ELIST.listIterator);
};
_.hasNext_0 = function hasNext_48() {
    return $hasNext_7(this);
};
_.isResolveProxies = false;
var Lorg_eclipse_emf_ecore_util_EcoreUtil$ContentTreeIterator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreUtil/ContentTreeIterator', 1154);
function ResourceImpl$5($anonymous0) {
    AbstractTreeIterator.call(this, $anonymous0, false);
    this.isResolveProxies = false;
}
defineClass(1466, 1154, $intern_141, ResourceImpl$5);
_.getChildren = function getChildren_1(object) {
    return maskUndefined(object) === maskUndefined(this.object) ? castTo(object, 15).iterator_0() : new EcoreUtil$ProperContentIterator(castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_resource_impl_ResourceImpl$5_2_classLit = createForClass('org.eclipse.emf.ecore.resource.impl', 'ResourceImpl/5', 1466);
function ResourceImpl$ContentsEList(this$0) {
    this.this$01 = this$0;
}
defineClass(642, 2038, $intern_155, ResourceImpl$ContentsEList);
_.contains = function contains_65(object) {
    return this.size_0 <= 4 ? $contains_10(this, object) : instanceOf(object, 52) && castTo(object, 52).eDirectResource() == this.this$01;
};
_.didAdd = function didAdd_3(index_0, object) {
    index_0 == this.size_0 - 1 && (this.this$01.isLoaded || (this.this$01.isLoaded = true));
};
_.didClear = function didClear_1(oldSize, oldData) {
    oldSize == 0 ? this.this$01.isLoaded || (this.this$01.isLoaded = true) : $didClear(this, oldSize, oldData);
};
_.didRemove = function didRemove_2(index_0, object) {};
_.didSet = function didSet_1(index_0, newObject, oldObject) {};
_.getFeatureID_0 = function getFeatureID_12() {
    return 2;
};
_.getNotifier = function getNotifier_8() {
    return this.this$01;
};
_.hasInverse = function hasInverse_10() {
    return true;
};
_.inverseAdd = function inverseAdd_8(object, notifications) {
    var eObject;
    eObject = castTo(object, 52);
    notifications = eObject.eSetResource(this.this$01, notifications);
    return notifications;
};
_.inverseRemove = function inverseRemove_8(object, notifications) {
    var eObject;
    eObject = castTo(object, 52);
    return eObject.eSetResource(null, notifications);
};
_.isNotificationRequired = function isNotificationRequired_3() {
    return false;
};
_.isUnique = function isUnique_7() {
    return true;
};
_.newData = function newData_13(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_EObject_2_classLit, $intern_2, 57, capacity, 0, 1);
};
_.useEquals = function useEquals_14() {
    return false;
};
var Lorg_eclipse_emf_ecore_resource_impl_ResourceImpl$ContentsEList_2_classLit = createForClass('org.eclipse.emf.ecore.resource.impl', 'ResourceImpl/ContentsEList', 642);
function AbstractSequentialInternalEList$1(this$0) {
    this.this$01 = this$0;
}
defineClass(948, 2008, $intern_37, AbstractSequentialInternalEList$1);
_.listIterator_1 = function listIterator_32(index_0) {
    return this.this$01.basicListIterator_0(index_0);
};
_.size_1 = function size_80() {
    return this.this$01.size_1();
};
var Lorg_eclipse_emf_ecore_util_AbstractSequentialInternalEList$1_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'AbstractSequentialInternalEList/1', 948);
function $clinit_ExtendedMetaData() {
    $clinit_ExtendedMetaData = emptyMethod;
    FEATURE_KINDS = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'unspecified',
        'simple',
        'attribute',
        'attributeWildcard',
        'element',
        'elementWildcard',
        'group'
    ]);
    CONTENT_KINDS = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'unspecified',
        'empty',
        'simple',
        'mixed',
        'elementOnly'
    ]);
    WHITE_SPACE_KINDS = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'unspecified',
        'preserve',
        'replace',
        'collapse'
    ]);
    INSTANCE_11 = new BasicExtendedMetaData;
}
var CONTENT_KINDS, FEATURE_KINDS, INSTANCE_11, WHITE_SPACE_KINDS;
function $clinit_BasicExtendedMetaData() {
    $clinit_BasicExtendedMetaData = emptyMethod;
    var eAttribute, eDataType;
    UNINITIALIZED_EDATA_TYPE = ($clinit_EcoreFactory(), eDataType = new EDataTypeImpl, eDataType);
    UNINITIALIZED_ESTRUCTURAL_FEATURE = (eAttribute = new EAttributeImpl, eAttribute);
}
function $basicGetAffiliation(this$static, eStructuralFeature) {
    var eAnnotation, fragmentIndex, qualifiedName;
    eAnnotation = eStructuralFeature.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        qualifiedName = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'affiliation'));
        if (qualifiedName != null) {
            fragmentIndex = $lastIndexOf(qualifiedName, fromCodePoint(35));
            return fragmentIndex == -1 ? $getElement(this$static, $getNamespace(this$static, $getEPackage(eStructuralFeature.getEContainingClass())), qualifiedName) : fragmentIndex == 0 ? $getElement(this$static, null, (checkCriticalStringElementIndex(1, qualifiedName.length + 1), qualifiedName.substr(1))) : $getElement(this$static, (checkCriticalStringBounds(0, fragmentIndex, qualifiedName.length), qualifiedName.substr(0, fragmentIndex)), (checkCriticalStringElementIndex(fragmentIndex + 1, qualifiedName.length + 1), qualifiedName.substr(fragmentIndex + 1)));
        }
    }
    return null;
}
function $basicGetBaseType(this$static, eDataType) {
    var baseType, details, eAnnotation, index_0, type_0;
    eAnnotation = eDataType.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        details = (!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details);
        baseType = castToString($get_21(details, 'baseType'));
        if (baseType != null) {
            index_0 = baseType.lastIndexOf('#');
            type_0 = index_0 == -1 ? $getType_0(this$static, eDataType.getEPackage(), baseType) : index_0 == 0 ? $getType(this$static, null, (checkCriticalStringElementIndex(1, baseType.length + 1), baseType.substr(1))) : $getType(this$static, (checkCriticalStringBounds(0, index_0, baseType.length), baseType.substr(0, index_0)), (checkCriticalStringElementIndex(index_0 + 1, baseType.length + 1), baseType.substr(index_0 + 1)));
            if (instanceOf(type_0, 155)) return castTo(type_0, 155);
        }
    }
    return null;
}
function $basicGetContentKind(this$static, eClass) {
    var eAnnotation, i, kind;
    eAnnotation = eClass.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        kind = $get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'kind');
        if (kind != null) for(i = 1; i < ($clinit_ExtendedMetaData(), CONTENT_KINDS).length; ++i){
            if ($equals_5(CONTENT_KINDS[i], kind)) return i;
        }
    }
    return 0;
}
function $basicGetFeatureKind(this$static, eStructuralFeature) {
    var eAnnotation, i, kind;
    eAnnotation = eStructuralFeature.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        kind = $get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'kind');
        if (kind != null) for(i = 1; i < ($clinit_ExtendedMetaData(), FEATURE_KINDS).length; ++i){
            if ($equals_5(FEATURE_KINDS[i], kind)) return i;
        }
    }
    return 0;
}
function $basicGetGroup(this$static, eStructuralFeature) {
    var eAnnotation, eContainingClass, fragmentIndex, name_0, namespace, qualifiedName;
    eAnnotation = eStructuralFeature.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        qualifiedName = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'group'));
        if (qualifiedName != null) {
            fragmentIndex = $lastIndexOf(qualifiedName, fromCodePoint(35));
            eContainingClass = eStructuralFeature.getEContainingClass();
            if (fragmentIndex == -1) {
                namespace = $getNamespace(this$static, $getEPackage(eContainingClass));
                name_0 = qualifiedName;
            } else if (fragmentIndex == 0) {
                namespace = null;
                name_0 = (checkCriticalStringElementIndex(1, qualifiedName.length + 1), qualifiedName.substr(1));
            } else {
                namespace = (checkCriticalStringBounds(0, fragmentIndex, qualifiedName.length), qualifiedName.substr(0, fragmentIndex));
                name_0 = (checkCriticalStringElementIndex(fragmentIndex + 1, qualifiedName.length + 1), qualifiedName.substr(fragmentIndex + 1));
            }
            switch($getFeatureKind($getExtendedMetaData_1(this$static, eStructuralFeature))){
                case 2:
                case 3:
                    return $getAttribute_0(this$static, eContainingClass, namespace, name_0);
                case 0:
                case 4:
                case 5:
                case 6:
                    return $getElement_0(this$static, eContainingClass, namespace, name_0);
            }
        }
    }
    return null;
}
function $basicGetItemType(this$static, eDataType) {
    var details, eAnnotation, index_0, itemType, type_0;
    eAnnotation = eDataType.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        details = (!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details);
        itemType = castToString($get_21(details, 'itemType'));
        if (itemType != null) {
            index_0 = itemType.lastIndexOf('#');
            type_0 = index_0 == -1 ? $getType_0(this$static, eDataType.getEPackage(), itemType) : index_0 == 0 ? $getType(this$static, null, (checkCriticalStringElementIndex(1, itemType.length + 1), itemType.substr(1))) : $getType(this$static, (checkCriticalStringBounds(0, index_0, itemType.length), itemType.substr(0, index_0)), (checkCriticalStringElementIndex(index_0 + 1, itemType.length + 1), itemType.substr(index_0 + 1)));
            if (instanceOf(type_0, 155)) return castTo(type_0, 155);
        }
    }
    return null;
}
function $basicGetMemberTypes(this$static, eDataType) {
    var eAnnotation, index_0, member, member$array, member$index, member$max, memberTypes, result, type_0;
    eAnnotation = eDataType.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        memberTypes = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'memberTypes'));
        if (memberTypes != null) {
            result = new ArrayList;
            for(member$array = $split_0(memberTypes, '\\w'), member$index = 0, member$max = member$array.length; member$index < member$max; ++member$index){
                member = member$array[member$index];
                index_0 = member.lastIndexOf('#');
                type_0 = index_0 == -1 ? $getType_0(this$static, eDataType.getEPackage(), member) : index_0 == 0 ? $getType(this$static, null, (checkCriticalStringElementIndex(1, member.length + 1), member.substr(1))) : $getType(this$static, (checkCriticalStringBounds(0, index_0, member.length), member.substr(0, index_0)), (checkCriticalStringElementIndex(index_0 + 1, member.length + 1), member.substr(index_0 + 1)));
                instanceOf(type_0, 155) && $add_3(result, castTo(type_0, 155));
            }
            return result;
        }
    }
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function $basicGetName(this$static, eClassifier) {
    var eAnnotation, result;
    eAnnotation = eClassifier.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        result = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'name'));
        if (result != null) return result;
    }
    return eClassifier.getName();
}
function $basicGetName_0(this$static, eStructuralFeature) {
    var eAnnotation, result;
    eAnnotation = eStructuralFeature.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        result = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'name'));
        if (result != null) return result;
    }
    return eStructuralFeature.getName();
}
function $basicGetNamespace(this$static, eStructuralFeature) {
    var eAnnotation, result;
    eAnnotation = eStructuralFeature.getEAnnotation(this$static.annotationURI);
    if (!eAnnotation) return null;
    else {
        result = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'namespace'));
        return $equals_5('##targetNamespace', result) ? $getNamespace(this$static, $getEPackage(eStructuralFeature.getEContainingClass())) : result;
    }
}
function $basicGetWhiteSpaceFacet(this$static, eDataType) {
    var eAnnotation, i, whiteSpaceLiteral;
    eAnnotation = eDataType.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        whiteSpaceLiteral = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'whiteSpace'));
        for(i = 1; i < ($clinit_ExtendedMetaData(), WHITE_SPACE_KINDS).length; ++i){
            if ($equals_5(WHITE_SPACE_KINDS[i], whiteSpaceLiteral)) return i;
        }
    }
    return 0;
}
function $basicGetWildcards(this$static, eStructuralFeature) {
    var eAnnotation, result, wildcard, wildcard$array, wildcard$index, wildcard$max, wildcards;
    eAnnotation = eStructuralFeature.getEAnnotation(this$static.annotationURI);
    if (eAnnotation) {
        wildcards = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'wildcards'));
        if (wildcards != null) {
            result = new ArrayList;
            for(wildcard$array = $split_0(wildcards, '\\w'), wildcard$index = 0, wildcard$max = wildcard$array.length; wildcard$index < wildcard$max; ++wildcard$index){
                wildcard = wildcard$array[wildcard$index];
                $equals_5(wildcard, '##other') ? $add_3(result, '!##' + $getNamespace(this$static, $getEPackage(eStructuralFeature.getEContainingClass()))) : $equals_5(wildcard, '##local') ? (result.array.push(null), undefined) : $equals_5(wildcard, '##targetNamespace') ? $add_3(result, $getNamespace(this$static, $getEPackage(eStructuralFeature.getEContainingClass()))) : push_1(result.array, wildcard);
            }
            return result;
        }
    }
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function $getAffiliation(this$static, eClass, eStructuralFeature) {
    var affiliation, allAttributes, allElements, i, name_0, namespace, namespace0, result, size_0;
    if ($getFeatureID(eClass, eStructuralFeature) >= 0) return eStructuralFeature;
    switch($getFeatureKind($getExtendedMetaData_1(this$static, eStructuralFeature))){
        case 2:
            if ($equals_5('', $getExtendedMetaData(this$static, eStructuralFeature.getEContainingClass()).getName())) {
                namespace = $getNamespace_0($getExtendedMetaData_1(this$static, eStructuralFeature));
                name_0 = $getName_0($getExtendedMetaData_1(this$static, eStructuralFeature));
                result = $getLocalAttribute(this$static, eClass, namespace, name_0);
                if (result) return result;
                allAttributes = $getAllAttributes(this$static, eClass);
                for(i = 0, size_0 = allAttributes.size_1(); i < size_0; ++i){
                    result = castTo(allAttributes.get_0(i), 178);
                    if ($matches($getWildcards($getExtendedMetaData_1(this$static, result)), namespace)) return result;
                }
            }
            return null;
        case 4:
            if ($equals_5('', $getExtendedMetaData(this$static, eStructuralFeature.getEContainingClass()).getName())) {
                for(affiliation = eStructuralFeature; affiliation; affiliation = $getAffiliation_0($getExtendedMetaData_1(this$static, affiliation))){
                    namespace0 = $getNamespace_0($getExtendedMetaData_1(this$static, affiliation));
                    name_0 = $getName_0($getExtendedMetaData_1(this$static, affiliation));
                    result = $getLocalElement(this$static, eClass, namespace0, name_0);
                    if (result) return result;
                }
                namespace = $getNamespace_0($getExtendedMetaData_1(this$static, eStructuralFeature));
                if ($equals_5('http://www.eclipse.org/emf/2003/XMLType', namespace)) return $getMixedFeature(this$static, eClass);
                else {
                    allElements = $getAllElements(this$static, eClass);
                    for(i = 0, size_0 = allElements.size_1(); i < size_0; ++i){
                        result = castTo(allElements.get_0(i), 178);
                        if ($matches($getWildcards($getExtendedMetaData_1(this$static, result)), namespace)) return result;
                    }
                }
            }
            return null;
        default:
            return null;
    }
}
function $getAllAttributes(this$static, eClass) {
    var allAttributes, attributes, changeable, eGenericType, eSuperType, i, result, result0, size_0, superTypes;
    superTypes = $getESuperTypes(eClass);
    result0 = null;
    changeable = false;
    for(i = 0, size_0 = $getEGenericSuperTypes(superTypes.this$01).size_0; i < size_0; ++i){
        eSuperType = castTo($resolve_1(superTypes, i, (eGenericType = castTo($get_20($getEGenericSuperTypes(superTypes.this$01), i), 87), result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT))), 29);
        allAttributes = $getAllAttributes(this$static, eSuperType);
        if (!allAttributes.isEmpty()) {
            if (!result0) result0 = allAttributes;
            else {
                if (!changeable) {
                    changeable = true;
                    result0 = new UniqueEList_0(result0);
                }
                result0.addAll(allAttributes);
            }
        }
    }
    attributes = $getAttributes(this$static, eClass);
    if (attributes.isEmpty()) return !result0 ? ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST) : result0;
    else {
        if (!result0) return attributes;
        else {
            changeable || (result0 = new UniqueEList_0(result0));
            result0.addAll(attributes);
            return result0;
        }
    }
}
function $getAllElements(this$static, eClass) {
    var allElements, changeable, eGenericType, eSuperType, elements, i, result, result0, size_0, superTypes;
    superTypes = $getESuperTypes(eClass);
    result0 = null;
    changeable = false;
    for(i = 0, size_0 = $getEGenericSuperTypes(superTypes.this$01).size_0; i < size_0; ++i){
        eSuperType = castTo($resolve_1(superTypes, i, (eGenericType = castTo($get_20($getEGenericSuperTypes(superTypes.this$01), i), 87), result = eGenericType.eRawType, instanceOf(result, 88) ? castTo(result, 29) : ($clinit_EcorePackage$Literals(), EOBJECT))), 29);
        allElements = $getAllElements(this$static, eSuperType);
        if (!allElements.isEmpty()) {
            if (!result0) result0 = allElements;
            else {
                if (!changeable) {
                    changeable = true;
                    result0 = new UniqueEList_0(result0);
                }
                result0.addAll(allElements);
            }
        }
    }
    elements = $getElements(this$static, eClass);
    if (elements.isEmpty()) return !result0 ? ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST) : result0;
    else {
        if (!result0) return elements;
        else {
            changeable || (result0 = new UniqueEList_0(result0));
            result0.addAll(elements);
            return result0;
        }
    }
}
function $getAnnotation(this$static, eModelElement) {
    var result;
    result = eModelElement.getEAnnotation(this$static.annotationURI);
    return result;
}
function $getAttribute(this$static, namespace, name_0) {
    var documentRoot, ePackage, ePackage0;
    ePackage0 = (ePackage = $getEPackage_0(this$static.registry, namespace), ePackage);
    if (ePackage0) {
        documentRoot = castTo($getType_1($getExtendedMetaData_0(this$static, ePackage0), ''), 29);
        if (documentRoot) return $getLocalAttribute(this$static, documentRoot, namespace, name_0);
    }
    return null;
}
function $getAttribute_0(this$static, eClass, namespace, name_0) {
    var result;
    result = $getLocalAttribute(this$static, eClass, namespace, name_0);
    if (!result) {
        result = $getAttribute(this$static, namespace, name_0);
        if (!!result && !$getAffiliation(this$static, eClass, result)) return null;
    }
    return result;
}
function $getAttributes(this$static, eClass) {
    var eStructuralFeature, eStructuralFeatures, i, result, size_0;
    eStructuralFeatures = (!eClass.eStructuralFeatures && (eClass.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, eClass, 21, 17)), eClass.eStructuralFeatures);
    result = null;
    for(i = 0, size_0 = eStructuralFeatures.size_0; i < size_0; ++i){
        eStructuralFeature = castTo($get_20(eStructuralFeatures, i), 178);
        switch($getFeatureKind($getExtendedMetaData_1(this$static, eStructuralFeature))){
            case 2:
            case 3:
                !result && (result = new ArrayList);
                push_1(result.array, eStructuralFeature);
        }
    }
    return !result ? ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST) : result;
}
function $getElement(this$static, namespace, name_0) {
    var documentRoot, ePackage, ePackage0;
    ePackage0 = (ePackage = $getEPackage_0(this$static.registry, namespace), ePackage);
    if (ePackage0) {
        documentRoot = castTo($getType_1($getExtendedMetaData_0(this$static, ePackage0), ''), 29);
        if (documentRoot) return $getLocalElement(this$static, documentRoot, namespace, name_0);
    }
    return null;
}
function $getElement_0(this$static, eClass, namespace, name_0) {
    var result;
    result = $getLocalElement(this$static, eClass, namespace, name_0);
    if (!result) {
        result = $getElement(this$static, namespace, name_0);
        if (!!result && !$getAffiliation(this$static, eClass, result)) return null;
    }
    return result;
}
function $getElements(this$static, eClass) {
    var eStructuralFeature, eStructuralFeatures, i, result, size_0;
    eStructuralFeatures = (!eClass.eStructuralFeatures && (eClass.eStructuralFeatures = new EObjectContainmentWithInverseEList(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, eClass, 21, 17)), eClass.eStructuralFeatures);
    result = null;
    for(i = 0, size_0 = eStructuralFeatures.size_0; i < size_0; ++i){
        eStructuralFeature = castTo($get_20(eStructuralFeatures, i), 178);
        switch($getFeatureKind($getExtendedMetaData_1(this$static, eStructuralFeature))){
            case 4:
            case 5:
            case 6:
                !result && (result = new ArrayList);
                push_1(result.array, eStructuralFeature);
                break;
        }
    }
    return !result ? ($clinit_Collections(), $clinit_Collections(), EMPTY_LIST) : result;
}
function $getExtendedMetaData(this$static, eClassifier) {
    var holder, result;
    holder = castTo(eClassifier, 676);
    result = holder.getExtendedMetaData_1();
    !result && holder.setExtendedMetaData_1(result = instanceOf(eClassifier, 88) ? new BasicExtendedMetaData$EClassExtendedMetaDataImpl(this$static, castTo(eClassifier, 29)) : new BasicExtendedMetaData$EDataTypeExtendedMetaDataImpl(this$static, castTo(eClassifier, 155)));
    return result;
}
function $getExtendedMetaData_0(this$static, ePackage) {
    var holder, result;
    holder = castTo(ePackage, 675);
    result = holder.getExtendedMetaData();
    !result && holder.setExtendedMetaData(result = new BasicExtendedMetaData$EPackageExtendedMetaDataImpl(this$static, ePackage));
    return result;
}
function $getExtendedMetaData_1(this$static, eStructuralFeature) {
    var holder, result;
    holder = castTo(eStructuralFeature, 677);
    result = holder.getExtendedMetaData_0();
    !result && holder.setExtendedMetaData_0(result = new BasicExtendedMetaData$EStructuralFeatureExtendedMetaDataImpl(this$static, eStructuralFeature));
    return result;
}
function $getLocalAttribute(this$static, eClass, namespace, name_0) {
    var allAttributes, eStructuralFeature, featureNamespace, i, result, size_0;
    result = null;
    allAttributes = $getAllAttributes(this$static, eClass);
    for(i = 0, size_0 = allAttributes.size_1(); i < size_0; ++i){
        eStructuralFeature = castTo(allAttributes.get_0(i), 178);
        if ($equals_5(name_0, $getName_0($getExtendedMetaData_1(this$static, eStructuralFeature)))) {
            featureNamespace = $getNamespace_0($getExtendedMetaData_1(this$static, eStructuralFeature));
            if (namespace == null) {
                if (featureNamespace == null) return eStructuralFeature;
                else !result && (result = eStructuralFeature);
            } else if ($equals_5(namespace, featureNamespace)) return eStructuralFeature;
            else featureNamespace == null && !result && (result = eStructuralFeature);
        }
    }
    return null;
}
function $getLocalElement(this$static, eClass, namespace, name_0) {
    var allElements, eStructuralFeature, featureNamespace, i, result, size_0;
    result = null;
    allElements = $getAllElements(this$static, eClass);
    for(i = 0, size_0 = allElements.size_1(); i < size_0; ++i){
        eStructuralFeature = castTo(allElements.get_0(i), 178);
        if ($equals_5(name_0, $getName_0($getExtendedMetaData_1(this$static, eStructuralFeature)))) {
            featureNamespace = $getNamespace_0($getExtendedMetaData_1(this$static, eStructuralFeature));
            if (namespace == null) {
                if (featureNamespace == null) return eStructuralFeature;
                else !result && (result = eStructuralFeature);
            } else if ($equals_5(namespace, featureNamespace)) return eStructuralFeature;
            else featureNamespace == null && !result && (result = eStructuralFeature);
        }
    }
    return null;
}
function $getMixedFeature(this$static, eClass) {
    var eAllAttributes, eAttribute, i, size_0;
    switch($getExtendedMetaData(this$static, eClass).getContentKind()){
        case 3:
        case 2:
            eAllAttributes = $getEAllAttributes(eClass);
            for(i = 0, size_0 = eAllAttributes.size_0; i < size_0; ++i){
                eAttribute = castTo($get_20(eAllAttributes, i), 35);
                if ($getFeatureKind($getExtendedMetaData_1(this$static, eAttribute)) == 5) return eAttribute;
            }
            break;
    }
    return null;
}
function $getNamespace(this$static, ePackage) {
    return $isQualified($getExtendedMetaData_0(this$static, ePackage)) ? ePackage.getNsURI() : null;
}
function $getType(this$static, namespace, name_0) {
    var ePackage, ePackage0;
    ePackage0 = (ePackage = $getEPackage_0(this$static.registry, namespace), ePackage);
    return !ePackage0 ? null : $getType_1($getExtendedMetaData_0(this$static, ePackage0), name_0);
}
function $getType_0(this$static, ePackage, name_0) {
    return $getType_1($getExtendedMetaData_0(this$static, ePackage), name_0);
}
function $matches(wildcards, namespace) {
    var i, size_0, suffixlength, wildcard;
    if (!wildcards.isEmpty()) for(i = 0, size_0 = wildcards.size_1(); i < size_0; ++i){
        wildcard = castToString(wildcards.get_0(i));
        if (wildcard == null ? namespace == null : $equals_5(wildcard.substr(0, 3), '!##') ? namespace != null && (suffixlength = namespace.length, !$equals_5(wildcard.substr(wildcard.length - suffixlength, suffixlength), namespace) || wildcard.length != namespace.length + 3) && !$equals_5('http://www.eclipse.org/emf/2003/XMLType', namespace) : $equals_5(wildcard, '##any') && !$equals_5('http://www.eclipse.org/emf/2003/XMLType', namespace) || $equals_5(wildcard, namespace)) return true;
    }
    return false;
}
function BasicExtendedMetaData() {
    $clinit_BasicExtendedMetaData();
    BasicExtendedMetaData_0.call(this, ($clinit_EPackage$Registry(), INSTANCE_6));
}
function BasicExtendedMetaData_0(registry) {
    this.annotationURI = (checkCriticalNotNull('http:///org/eclipse/emf/ecore/util/ExtendedMetaData'), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData');
    this.registry = registry;
    new EPackageRegistryImpl;
}
defineClass(619, 1, {}, BasicExtendedMetaData);
var UNINITIALIZED_EDATA_TYPE, UNINITIALIZED_ESTRUCTURAL_FEATURE;
var Lorg_eclipse_emf_ecore_util_BasicExtendedMetaData_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicExtendedMetaData', 619);
function $setContentKind(this$static, kind) {
    this$static.contentKind = kind;
}
function $setName_2(this$static, name_0) {
    this$static.name_0 = name_0;
}
function BasicExtendedMetaData$EClassExtendedMetaDataImpl(this$0, eClass) {
    this.this$01 = this$0;
    this.eClass = eClass;
}
defineClass(1145, 1, {}, BasicExtendedMetaData$EClassExtendedMetaDataImpl);
_.getBaseType = function getBaseType() {
    return null;
};
_.getContentKind = function getContentKind() {
    this.contentKind == -2 && $setContentKind(this, $basicGetContentKind(this.this$01, this.eClass));
    return this.contentKind;
};
_.getItemType = function getItemType() {
    return null;
};
_.getMemberTypes = function getMemberTypes() {
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
};
_.getName = function getName_7() {
    this.name_0 == 'uninitialized' && $setName_2(this, $basicGetName(this.this$01, this.eClass));
    return this.name_0;
};
_.getWhiteSpaceFacet = function getWhiteSpaceFacet() {
    return 0;
};
_.contentKind = -2;
_.name_0 = 'uninitialized';
var Lorg_eclipse_emf_ecore_util_BasicExtendedMetaData$EClassExtendedMetaDataImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicExtendedMetaData/EClassExtendedMetaDataImpl', 1145);
function $setBaseType(this$static, baseType) {
    this$static.baseType = baseType;
}
function $setItemType(this$static, itemType) {
    this$static.itemType = itemType;
}
function $setMemberTypes(this$static, memberTypes) {
    this$static.memberTypes = memberTypes;
}
function $setName_3(this$static, name_0) {
    this$static.name_0 = name_0;
}
function $setWhiteSpaceFacet(this$static, whiteSpace) {
    this$static.whiteSpace = whiteSpace;
}
function BasicExtendedMetaData$EDataTypeExtendedMetaDataImpl(this$0, eDataType) {
    this.this$01 = this$0;
    this.baseType = ($clinit_BasicExtendedMetaData(), UNINITIALIZED_EDATA_TYPE);
    this.itemType = UNINITIALIZED_EDATA_TYPE;
    this.eDataType = eDataType;
}
defineClass(1146, 1, {}, BasicExtendedMetaData$EDataTypeExtendedMetaDataImpl);
_.getBaseType = function getBaseType_0() {
    this.baseType == ($clinit_BasicExtendedMetaData(), UNINITIALIZED_EDATA_TYPE) && $setBaseType(this, $basicGetBaseType(this.this$01, this.eDataType));
    return this.baseType;
};
_.getContentKind = function getContentKind_0() {
    return 0;
};
_.getItemType = function getItemType_0() {
    this.itemType == ($clinit_BasicExtendedMetaData(), UNINITIALIZED_EDATA_TYPE) && $setItemType(this, $basicGetItemType(this.this$01, this.eDataType));
    return this.itemType;
};
_.getMemberTypes = function getMemberTypes_0() {
    !this.memberTypes && $setMemberTypes(this, $basicGetMemberTypes(this.this$01, this.eDataType));
    return this.memberTypes;
};
_.getName = function getName_8() {
    this.name_0 == 'uninitialized' && $setName_3(this, $basicGetName(this.this$01, this.eDataType));
    return this.name_0;
};
_.getWhiteSpaceFacet = function getWhiteSpaceFacet_0() {
    this.whiteSpace == -2 && $setWhiteSpaceFacet(this, $basicGetWhiteSpaceFacet(this.this$01, this.eDataType));
    return this.whiteSpace;
};
_.name_0 = 'uninitialized';
_.whiteSpace = -2;
var Lorg_eclipse_emf_ecore_util_BasicExtendedMetaData$EDataTypeExtendedMetaDataImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicExtendedMetaData/EDataTypeExtendedMetaDataImpl', 1146);
function $getType_1(this$static, name_0) {
    var conflictingEClassifier, eClassifier, eClassifierName, eClassifiers, i, i0, nameToClassifierMap, originalMapSize, result, size_0;
    result = null;
    !!this$static.nameToClassifierMap && (result = castTo($getStringValue(this$static.nameToClassifierMap, name_0), 141));
    if (!result) {
        eClassifiers = this$static.ePackage.getEClassifiers();
        size_0 = eClassifiers.size_0;
        if (!this$static.nameToClassifierMap || $size_2(this$static.nameToClassifierMap) != size_0) {
            nameToClassifierMap = new HashMap;
            !!this$static.nameToClassifierMap && $putAll(nameToClassifierMap, this$static.nameToClassifierMap);
            originalMapSize = nameToClassifierMap.hashCodeMap.size_0 + nameToClassifierMap.stringMap.size_0;
            for(i0 = originalMapSize; i0 < size_0; ++i0){
                eClassifier = castTo($get_20(eClassifiers, i0), 141);
                eClassifierName = $getExtendedMetaData(this$static.this$01, eClassifier).getName();
                conflictingEClassifier = castTo(eClassifierName == null ? $put_9(nameToClassifierMap.hashCodeMap, null, eClassifier) : $put_10(nameToClassifierMap.stringMap, eClassifierName, eClassifier), 141);
                !!conflictingEClassifier && conflictingEClassifier != eClassifier && (eClassifierName == null ? $put_9(nameToClassifierMap.hashCodeMap, null, conflictingEClassifier) : $put_10(nameToClassifierMap.stringMap, eClassifierName, conflictingEClassifier));
            }
            if (nameToClassifierMap.hashCodeMap.size_0 + nameToClassifierMap.stringMap.size_0 != size_0) for(i = 0; i < originalMapSize; ++i){
                eClassifier = castTo($get_20(eClassifiers, i), 141);
                eClassifierName = $getExtendedMetaData(this$static.this$01, eClassifier).getName();
                conflictingEClassifier = castTo(eClassifierName == null ? $put_9(nameToClassifierMap.hashCodeMap, null, eClassifier) : $put_10(nameToClassifierMap.stringMap, eClassifierName, eClassifier), 141);
                !!conflictingEClassifier && conflictingEClassifier != eClassifier && (eClassifierName == null ? $put_9(nameToClassifierMap.hashCodeMap, null, conflictingEClassifier) : $put_10(nameToClassifierMap.stringMap, eClassifierName, conflictingEClassifier));
            }
            this$static.nameToClassifierMap = nameToClassifierMap;
        }
        result = castTo($getStringValue(this$static.nameToClassifierMap, name_0), 141);
    }
    return result;
}
function $isQualified(this$static) {
    var eAnnotation;
    this$static.isInitialized || $setQualified(this$static, (eAnnotation = $getAnnotation(this$static.this$01, this$static.ePackage), !eAnnotation || !$equals_5('false', $get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'qualified'))));
    return this$static.isQualified;
}
function $setQualified(this$static, isQualified) {
    this$static.isQualified = isQualified;
    this$static.isInitialized = true;
}
function BasicExtendedMetaData$EPackageExtendedMetaDataImpl(this$0, ePackage) {
    this.this$01 = this$0;
    this.ePackage = ePackage;
}
defineClass(1144, 1, {}, BasicExtendedMetaData$EPackageExtendedMetaDataImpl);
_.isInitialized = false;
_.isQualified = false;
var Lorg_eclipse_emf_ecore_util_BasicExtendedMetaData$EPackageExtendedMetaDataImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicExtendedMetaData/EPackageExtendedMetaDataImpl', 1144);
function $getAffiliation_0(this$static) {
    this$static.affiliation == ($clinit_BasicExtendedMetaData(), UNINITIALIZED_ESTRUCTURAL_FEATURE) && $setAffiliation(this$static, $basicGetAffiliation(this$static.this$01, this$static.eStructuralFeature));
    return this$static.affiliation;
}
function $getFeatureKind(this$static) {
    this$static.featureKind == -2 && $setFeatureKind(this$static, $basicGetFeatureKind(this$static.this$01, this$static.eStructuralFeature));
    return this$static.featureKind;
}
function $getGroup(this$static) {
    this$static.group_0 == ($clinit_BasicExtendedMetaData(), UNINITIALIZED_ESTRUCTURAL_FEATURE) && $setGroup(this$static, $basicGetGroup(this$static.this$01, this$static.eStructuralFeature));
    return this$static.group_0;
}
function $getName_0(this$static) {
    this$static.name_0 == 'uninitialized' && $setName_4(this$static, $basicGetName_0(this$static.this$01, this$static.eStructuralFeature));
    return this$static.name_0;
}
function $getNamespace_0(this$static) {
    this$static.namespace == 'uninitialized' && $setNamespace(this$static, $basicGetNamespace(this$static.this$01, this$static.eStructuralFeature));
    return this$static.namespace;
}
function $getWildcards(this$static) {
    !this$static.wildcards && $setWildcards(this$static, $basicGetWildcards(this$static.this$01, this$static.eStructuralFeature));
    return this$static.wildcards;
}
function $setAffiliation(this$static, affiliation) {
    this$static.affiliation = affiliation;
}
function $setFeatureKind(this$static, kind) {
    this$static.featureKind = kind;
}
function $setGroup(this$static, group) {
    this$static.group_0 = group;
}
function $setName_4(this$static, name_0) {
    this$static.name_0 = name_0;
}
function $setNamespace(this$static, namespace) {
    this$static.namespace = namespace;
}
function $setWildcards(this$static, wildcards) {
    this$static.wildcards = wildcards;
}
function BasicExtendedMetaData$EStructuralFeatureExtendedMetaDataImpl(this$0, eStructuralFeature) {
    this.this$01 = this$0;
    this.group_0 = ($clinit_BasicExtendedMetaData(), UNINITIALIZED_ESTRUCTURAL_FEATURE);
    this.affiliation = UNINITIALIZED_ESTRUCTURAL_FEATURE;
    this.eStructuralFeature = eStructuralFeature;
}
defineClass(1147, 1, {}, BasicExtendedMetaData$EStructuralFeatureExtendedMetaDataImpl);
_.featureKind = -2;
_.name_0 = 'uninitialized';
_.namespace = 'uninitialized';
var Lorg_eclipse_emf_ecore_util_BasicExtendedMetaData$EStructuralFeatureExtendedMetaDataImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicExtendedMetaData/EStructuralFeatureExtendedMetaDataImpl', 1147);
function EDataTypeEList(dataClass, owner, featureID) {
    EcoreEList.call(this, dataClass, owner);
    this.featureID = featureID;
}
defineClass(576, 617, $intern_156, EDataTypeEList);
_.getFeatureID_0 = function getFeatureID_13() {
    return this.featureID;
};
_.isEObject = function isEObject_4() {
    return false;
};
_.resolve = function resolve_8(index_0, object) {
    return object;
};
_.featureID = 0;
var Lorg_eclipse_emf_ecore_util_EDataTypeEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EDataTypeEList', 576);
var Lorg_eclipse_emf_ecore_util_FeatureMap_2_classLit = createForInterface('org.eclipse.emf.ecore.util', 'FeatureMap');
function $add_31(this$static, index_0, object) {
    var entries, entry, entryFeature, i, otherEntry, validator;
    entry = object;
    entryFeature = entry.getEStructuralFeature();
    if (isMany_1(this$static.owner, entryFeature)) {
        if (entryFeature.isUnique()) {
            entries = castTo(this$static.data_0, 122);
            for(i = 0; i < this$static.size_0; ++i){
                otherEntry = entries[i];
                if (equals_Ljava_lang_Object__Z__devirtual$(otherEntry, entry) && i != index_0) throw toJs(new IllegalArgumentException_0("The 'no duplicates' constraint is violated"));
            }
        }
    } else {
        validator = getValidator(this$static.owner.eClass_0(), entryFeature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            otherEntry = entries[i];
            if (validator.isValid(otherEntry.getEStructuralFeature())) throw toJs(new IllegalArgumentException_0('The multiplicity constraint is violated'));
        }
    }
    $add_20(this$static, index_0, object);
}
function $add_32(this$static, feature, index_0, object) {
    var entries, entry, i, isFeatureMap, validator;
    isFeatureMap = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0());
    if (isMany_1(this$static.owner, feature)) {
        if (feature.isUnique() && $contains_13(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0)) throw toJs(new IllegalArgumentException_0("The 'no duplicates' constraint is violated"));
    } else {
        validator = getValidator(this$static.owner.eClass_0(), feature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) throw toJs(new IllegalArgumentException_0('The multiplicity constraint is violated'));
        }
    }
    $add_20(this$static, $entryIndex(this$static, feature, index_0), isFeatureMap ? castTo(object, 74) : createEntry_5(feature, object));
}
function $add_33(this$static, feature, object) {
    var entries, entry, i, isFeatureMap, validator;
    isFeatureMap = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0());
    if (isMany_1(this$static.owner, feature)) {
        if (feature.isUnique() && $contains_13(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0)) return false;
    } else {
        validator = getValidator(this$static.owner.eClass_0(), feature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) {
                if (isFeatureMap ? equals_Ljava_lang_Object__Z__devirtual$(entry, object) : object == null ? entry.getValue() == null : equals_Ljava_lang_Object__Z__devirtual$(object, entry.getValue())) return false;
                else {
                    castTo($set_9(this$static, i, isFeatureMap ? castTo(object, 74) : createEntry_5(feature, object)), 74);
                    return true;
                }
            }
        }
    }
    return $add_21(this$static, isFeatureMap ? castTo(object, 74) : createEntry_5(feature, object));
}
function $add_34(this$static, object) {
    var entries, entry, entryFeature, i, otherEntry, validator;
    entry = object;
    entryFeature = entry.getEStructuralFeature();
    if (isMany_1(this$static.owner, entryFeature)) {
        if (entryFeature.isUnique() && $contains_12(this$static, entryFeature, entry.getValue())) return false;
    } else {
        validator = getValidator(this$static.owner.eClass_0(), entryFeature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            otherEntry = entries[i];
            if (validator.isValid(otherEntry.getEStructuralFeature())) {
                if (equals_Ljava_lang_Object__Z__devirtual$(otherEntry, entry)) return false;
                else {
                    castTo($set_9(this$static, i, object), 74);
                    return true;
                }
            }
        }
    }
    return $add_21(this$static, object);
}
function $addAll_12(this$static, feature, index_0, collection) {
    var entries, entry, entryCollection, i, isFeatureMap, object, object$iterator, validator;
    if (collection.size_1() == 0) return false;
    isFeatureMap = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0());
    entryCollection = isFeatureMap ? collection : new BasicEList_0(collection.size_1());
    if (isMany_1(this$static.owner, feature)) {
        if (feature.isUnique()) for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
            object = object$iterator.next_1();
            if (!$contains_13(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0)) {
                entry = createEntry_5(feature, object);
                entryCollection.add_2(entry);
            }
        }
        else if (!isFeatureMap) for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
            object = object$iterator.next_1();
            entry = createEntry_5(feature, object);
            entryCollection.add_2(entry);
        }
    } else {
        validator = getValidator(this$static.owner.eClass_0(), feature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) throw toJs(new IllegalArgumentException_0('The multiplicity constraint is violated'));
        }
        if (collection.size_1() > 1) throw toJs(new IllegalArgumentException_0('The multiplicity constraint is violated'));
        if (!isFeatureMap) {
            entry = createEntry_5(feature, collection.iterator_0().next_1());
            entryCollection.add_2(entry);
        }
    }
    return $addAll_8(this$static, $entryIndex(this$static, feature, index_0), entryCollection);
}
function $addAll_13(this$static, feature, collection) {
    var entries, entry, entryCollection, i, isFeatureMap, object, object$iterator, validator;
    if (collection.size_1() == 0) return false;
    isFeatureMap = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0());
    entryCollection = isFeatureMap ? collection : new BasicEList_0(collection.size_1());
    if (isMany_1(this$static.owner, feature)) {
        if (feature.isUnique()) for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
            object = object$iterator.next_1();
            if (!$contains_13(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0)) {
                entry = createEntry_5(feature, object);
                entryCollection.contains(entry) || entryCollection.add_2(entry);
            }
        }
        else if (!isFeatureMap) for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
            object = object$iterator.next_1();
            entry = createEntry_5(feature, object);
            entryCollection.add_2(entry);
        }
    } else {
        if (collection.size_1() > 1) throw toJs(new IllegalArgumentException_0('The multiplicity constraint is violated'));
        validator = getValidator(this$static.owner.eClass_0(), feature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) {
                if (collection.contains(isFeatureMap ? entry : entry.getValue())) return false;
                else {
                    for(object$iterator = collection.iterator_0(); object$iterator.hasNext_0();){
                        object = object$iterator.next_1();
                        castTo($set_9(this$static, i, isFeatureMap ? castTo(object, 74) : createEntry_5(feature, object)), 74);
                    }
                    return true;
                }
            }
        }
        if (!isFeatureMap) {
            entry = createEntry_5(feature, collection.iterator_0().next_1());
            entryCollection.add_2(entry);
        }
    }
    return $addAll_9(this$static, entryCollection);
}
function $addUnique_11(this$static, feature, index_0, object) {
    var prototype_0;
    this$static.modCount = -1;
    $addUnique_5(this$static, $entryIndex(this$static, feature, index_0), ($clinit_FeatureMapUtil(), prototype_0 = castTo(feature, 69).getFeatureMapEntryPrototype(), prototype_0.createEntry(object)));
}
function $addUnique_12(this$static, entry) {
    var index_0, notification, notifications, oldIsSet;
    this$static.modCount = -1;
    if ($eNotificationRequired(this$static.owner)) {
        index_0 = this$static.size_0;
        oldIsSet = this$static.size_0 != 0;
        $addUnique_0(this$static, entry);
        notification = new ENotificationImpl_3(this$static.owner, 3, this$static.featureID, null, entry, index_0, oldIsSet);
        notifications = entry.inverseAdd_0(this$static.owner, this$static.featureID, null);
        notifications = $shadowAdd_1(this$static, entry, notifications);
        if (!notifications) $eNotify(this$static.owner, notification);
        else {
            notifications.add_5(notification);
            notifications.dispatch_0();
        }
    } else {
        $addUnique_0(this$static, entry);
        notifications = entry.inverseAdd_0(this$static.owner, this$static.featureID, null);
        !!notifications && notifications.dispatch_0();
    }
}
function $addUnique_13(this$static, object) {
    ++this$static.modCount;
    $validate_3(this$static, this$static.size_0, object);
    $addUnique_12(this$static, castTo(object, 339));
}
function $basicAdd_2(this$static, feature, object, notifications) {
    var entries, entry, entry0, i, notification, oldIsSet;
    if (object == null) {
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry0 = entries[i];
            if (entry0.getEStructuralFeature() == feature) return $basicRemove_0(this$static, entry0, notifications);
        }
    }
    entry = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? castTo(object, 74) : createEntry_5(feature, object));
    if ($eNotificationRequired(this$static.owner)) {
        oldIsSet = !$isEmpty_0(this$static, feature);
        notifications = $basicAdd_0(this$static, entry, notifications);
        notification = feature.isMany() ? $createNotification_0(this$static, 3, feature, null, object, $indexOf_8(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0), oldIsSet) : $createNotification_0(this$static, 1, feature, feature.getDefaultValue(), object, -1, oldIsSet);
        notifications ? notifications.add_5(notification) : notifications = notification;
    } else notifications = $basicAdd_0(this$static, entry, notifications);
    return notifications;
}
function $basicIterator(this$static, feature) {
    return new BasicFeatureMap$FeatureEIterator(feature, this$static);
}
function $basicListIterator_0(this$static, feature) {
    return new BasicFeatureMap$FeatureEIterator(feature, this$static);
}
function $basicListIterator_1(this$static, feature, index_0) {
    var i, result;
    result = new BasicFeatureMap$FeatureEIterator(feature, this$static);
    for(i = 0; i < index_0; ++i)$next_15(result);
    return result;
}
function $basicRemove_2(this$static, object, notifications) {
    var entries, entry, feature, i, match_0, notification;
    if (instanceOf(object, 74)) return $basicRemove_0(this$static, object, notifications);
    else {
        match_0 = null;
        feature = null;
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (equals_Ljava_lang_Object__Z__devirtual$(object, entry.getValue())) {
                feature = entry.getEStructuralFeature();
                if (instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_137) != 0) {
                    match_0 = entry;
                    break;
                }
            }
        }
        if (match_0) {
            if ($eNotificationRequired(this$static.owner)) {
                notification = feature.isMany() ? $createNotification_0(this$static, 4, feature, object, null, $indexOf_8(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0), true) : $createNotification_0(this$static, feature.isUnsettable() ? 2 : 1, feature, object, feature.getDefaultValue(), -1, true);
                notifications ? notifications.add_5(notification) : notifications = notification;
            }
            notifications = $basicRemove_2(this$static, match_0, notifications);
        }
        return notifications;
    }
}
function $basicRemove_3(this$static, feature, object, notifications) {
    var count, entries, entry, i, match_0, notification, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    count = 0;
    entries = castTo(this$static.data_0, 122);
    match_0 = null;
    $clinit_FeatureMapUtil();
    if (castTo(feature, 69).isFeatureMap_0()) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (equals_Ljava_lang_Object__Z__devirtual$(entry, object)) {
                match_0 = entry;
                break;
            }
            ++count;
        }
    }
    else if (object != null) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (equals_Ljava_lang_Object__Z__devirtual$(object, entry.getValue())) {
                match_0 = entry;
                break;
            }
            ++count;
        }
    }
    else for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (entry.getValue() == null) {
                match_0 = entry;
                break;
            }
            ++count;
        }
    }
    if (match_0) {
        if ($eNotificationRequired(this$static.owner)) {
            notification = feature.isMany() ? new FeatureMapUtil$FeatureENotificationImpl(this$static.owner, 4, feature, object, null, count, true) : $createNotification_0(this$static, feature.isUnsettable() ? 2 : 1, feature, object, feature.getDefaultValue(), -1, true);
            notifications ? notifications.add_5(notification) : notifications = notification;
        }
        notifications = $basicRemove_2(this$static, match_0, notifications);
    }
    return notifications;
}
function $clear_15(this$static, feature) {
    var entries, entry, entryCollection, i, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entryCollection = new BasicEList;
    entries = castTo(this$static.data_0, 122);
    for(i = this$static.size_0; --i >= 0;){
        entry = entries[i];
        validator.isValid(entry.getEStructuralFeature()) && $add_21(entryCollection, entry);
    }
    !$removeAll_4(this$static, entryCollection) && $eNotificationRequired(this$static.owner) && $dispatchNotification(this$static, feature.isMany() ? $createNotification_0(this$static, 6, feature, ($clinit_Collections(), EMPTY_LIST), null, -1, false) : $createNotification_0(this$static, feature.isUnsettable() ? 2 : 1, feature, null, null, -1, false));
}
function $contains_12(this$static, feature, object) {
    return $contains_13(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0);
}
function $contains_13(this$static, feature, object, resolve) {
    var entries, entry, i, i0, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    $clinit_FeatureMapUtil();
    if (castTo(feature, 69).isFeatureMap_0()) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature()) && equals_Ljava_lang_Object__Z__devirtual$(entry, object)) return true;
    }
    else if (object != null) {
        for(i0 = 0; i0 < this$static.size_0; ++i0){
            entry = entries[i0];
            if (validator.isValid(entry.getEStructuralFeature()) && equals_Ljava_lang_Object__Z__devirtual$(object, entry.getValue())) return true;
        }
        if (resolve) for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature()) && maskUndefined(object) === maskUndefined($resolveProxy_0(this$static, castTo(entry.getValue(), 57)))) return true;
        }
    } else for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature()) && entry.getValue() == null) return false;
    }
    return false;
}
function $containsAll_1(this$static, feature, collection) {
    var i;
    for(i = collection.iterator_0(); i.hasNext_0();){
        if (!$contains_12(this$static, feature, i.next_1())) return false;
    }
    return true;
}
function $createNotification_0(this$static, eventType, feature, oldObject, newObject, index_0, wasSet) {
    return new FeatureMapUtil$FeatureENotificationImpl(this$static.owner, eventType, feature, oldObject, newObject, index_0, wasSet);
}
function $entryIndex(this$static, feature, index_0) {
    var count, entries, entry, i, result, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    count = 0;
    result = this$static.size_0;
    entries = castTo(this$static.data_0, 122);
    for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (index_0 == count) return i;
            ++count;
            result = i + 1;
        }
    }
    if (index_0 == count) return result;
    else throw toJs(new IndexOutOfBoundsException_0('index=' + index_0 + ', size=' + count));
}
function $get_23(this$static, feature, index_0, resolve) {
    var count, entries, entry, i, validator, value_0;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    if (isMany_1(this$static.owner, feature)) {
        count = 0;
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) {
                if (count == index_0) {
                    $clinit_FeatureMapUtil();
                    if (castTo(feature, 69).isFeatureMap_0()) return entry;
                    else {
                        value_0 = entry.getValue();
                        value_0 != null && resolve && instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0 && (value_0 = $resolveProxy_1(this$static, feature, i, count, value_0));
                        return value_0;
                    }
                }
                ++count;
            }
        }
        throw toJs(new IndexOutOfBoundsException_0('index=' + index_0 + ', size=' + count));
    } else {
        count = 0;
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) {
                $clinit_FeatureMapUtil();
                if (castTo(feature, 69).isFeatureMap_0()) return entry;
                else {
                    value_0 = entry.getValue();
                    value_0 != null && resolve && instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0 && (value_0 = $resolveProxy_1(this$static, feature, i, count, value_0));
                    return value_0;
                }
            }
            ++count;
        }
        return feature.getDefaultValue();
    }
}
function $get_24(this$static, feature, resolve) {
    var count, entries, entry, entryFeature, i, result, validator, value_0;
    entries = castTo(this$static.data_0, 122);
    if (isMany_1(this$static.owner, feature)) return $clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? new FeatureMapUtil$FeatureFeatureMap(feature, this$static) : new FeatureMapUtil$FeatureEList(feature, this$static);
    else {
        validator = getValidator(this$static.owner.eClass_0(), feature);
        count = 0;
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            entryFeature = entry.getEStructuralFeature();
            if (validator.isValid(entryFeature)) {
                $clinit_FeatureMapUtil();
                if (castTo(feature, 69).isFeatureMap_0()) return entry;
                else if (entryFeature == ($clinit_XMLTypeFeatures(), TEXT) || entryFeature == CDATA) {
                    result = new StringBuilder_1(toString_40(entry.getValue()));
                    while(++i < this$static.size_0){
                        entry = entries[i];
                        entryFeature = entry.getEStructuralFeature();
                        (entryFeature == TEXT || entryFeature == CDATA) && $append_11(result, toString_40(entry.getValue()));
                    }
                    return createFromString_2(castTo(feature.getEType(), 155), result.string);
                } else {
                    value_0 = entry.getValue();
                    value_0 != null && resolve && instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0 && (value_0 = $resolveProxy_1(this$static, feature, i, count, value_0));
                    return value_0;
                }
            }
            ++count;
        }
        return feature.getDefaultValue();
    }
}
function $indexOf_7(this$static, feature, object) {
    return $indexOf_8(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0);
}
function $indexOf_8(this$static, feature, object, resolve) {
    var entries, entry, i, i0, result, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    result = 0;
    entries = castTo(this$static.data_0, 122);
    $clinit_FeatureMapUtil();
    if (castTo(feature, 69).isFeatureMap_0()) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (equals_Ljava_lang_Object__Z__devirtual$(entry, object)) return result;
            ++result;
        }
    }
    else if (object != null) {
        for(i0 = 0; i0 < this$static.size_0; ++i0){
            entry = entries[i0];
            if (validator.isValid(entry.getEStructuralFeature())) {
                if (equals_Ljava_lang_Object__Z__devirtual$(object, entry.getValue())) return result;
                ++result;
            }
        }
        if (resolve) {
            result = 0;
            for(i = 0; i < this$static.size_0; ++i){
                entry = entries[i];
                if (validator.isValid(entry.getEStructuralFeature())) {
                    if (maskUndefined(object) === maskUndefined($resolveProxy_0(this$static, castTo(entry.getValue(), 57)))) return result;
                    ++result;
                }
            }
        }
    } else for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (entry.getValue() == null) return result;
            ++result;
        }
    }
    return -1;
}
function $inverseAdd_2(this$static, entry, notifications) {
    return entry.inverseAdd_0(this$static.owner, this$static.featureID, notifications);
}
function $inverseAdd_3(this$static, object, notifications) {
    return $inverseAdd_2(this$static, castTo(object, 339), notifications);
}
function $inverseRemove_2(this$static, entry, notifications) {
    return entry.inverseRemove_0(this$static.owner, this$static.featureID, notifications);
}
function $inverseRemove_3(this$static, object, notifications) {
    return $inverseRemove_2(this$static, castTo(object, 339), notifications);
}
function $isEmpty_0(this$static, feature) {
    var entries, entry, i, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) return false;
    }
    return true;
}
function $iterator_2(this$static, feature) {
    return instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0 ? new BasicFeatureMap$ResolvingFeatureEIterator(feature, this$static) : new BasicFeatureMap$FeatureEIterator(feature, this$static);
}
function $list(this$static, feature) {
    return $clinit_FeatureMapUtil(), $isFeatureMap(feature) ? new FeatureMapUtil$FeatureFeatureMap(feature, this$static) : new FeatureMapUtil$FeatureEList(feature, this$static);
}
function $listIterator_3(this$static, feature) {
    return instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0 ? new BasicFeatureMap$ResolvingFeatureEIterator(feature, this$static) : new BasicFeatureMap$FeatureEIterator(feature, this$static);
}
function $listIterator_4(this$static, feature, index_0) {
    var i, result;
    result = instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0 ? new BasicFeatureMap$ResolvingFeatureEIterator(feature, this$static) : new BasicFeatureMap$FeatureEIterator(feature, this$static);
    for(i = 0; i < index_0; ++i)$next_15(result);
    return result;
}
function $move_5(this$static, targetIndex, sourceIndex) {
    var count, entries, entry, feature, featureSourceIndex, featureTargetIndex, i, isValid, maxIndex, result, sourceEntry, validator;
    if ($eNotificationRequired(this$static.owner)) {
        if (targetIndex != sourceIndex) {
            entries = castTo(this$static.data_0, 122);
            sourceEntry = entries[sourceIndex];
            feature = sourceEntry.getEStructuralFeature();
            if (isMany_1(this$static.owner, feature)) {
                validator = getValidator(this$static.owner.eClass_0(), feature);
                featureTargetIndex = -1;
                featureSourceIndex = -1;
                count = 0;
                for(i = 0, maxIndex = targetIndex > sourceIndex ? targetIndex : sourceIndex; i <= maxIndex; ++i)if (i == sourceIndex) featureSourceIndex = count++;
                else {
                    entry = entries[i];
                    isValid = validator.isValid(entry.getEStructuralFeature());
                    i == targetIndex && (featureTargetIndex = i == maxIndex && !isValid ? count - 1 : count);
                    isValid && ++count;
                }
                result = castTo($move_1(this$static, targetIndex, sourceIndex), 74);
                featureSourceIndex != featureTargetIndex && $dispatchNotification(this$static, new ENotificationImpl_18(this$static.owner, 7, feature, valueOf_3(featureSourceIndex), sourceEntry.getValue(), featureTargetIndex));
                return result;
            }
        }
    } else return castTo($move(this$static, targetIndex, sourceIndex), 74);
    return castTo($move_1(this$static, targetIndex, sourceIndex), 74);
}
function $move_6(this$static, feature, targetIndex, sourceIndex) {
    var count, entries, entry, entrySourceIndex, entryTargetIndex, i, result, validator;
    if (isMany_1(this$static.owner, feature)) {
        validator = getValidator(this$static.owner.eClass_0(), feature);
        entries = castTo(this$static.data_0, 122);
        result = null;
        entryTargetIndex = -1;
        entrySourceIndex = -1;
        count = 0;
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) {
                count == targetIndex && (entryTargetIndex = i);
                if (count == sourceIndex) {
                    entrySourceIndex = i;
                    result = entry.getValue();
                }
                ++count;
            }
        }
        if (entryTargetIndex == -1) throw toJs(new IndexOutOfBoundsException_0('targetIndex=' + targetIndex + ', size=' + count));
        if (entrySourceIndex == -1) throw toJs(new IndexOutOfBoundsException_0('sourceIndex=' + sourceIndex + ', size=' + count));
        $move_1(this$static, entryTargetIndex, entrySourceIndex);
        $eNotificationRequired(this$static.owner) && $dispatchNotification(this$static, $createNotification_0(this$static, 7, feature, valueOf_3(sourceIndex), result, targetIndex, true));
        return result;
    } else throw toJs(new IllegalArgumentException_0('The feature must be many-valued to support move'));
}
function $move_7(this$static, feature, index_0, object) {
    $move_6(this$static, feature, index_0, $indexOf_8(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0));
}
function $remove_43(this$static, feature, index_0) {
    var count, entries, entry, i, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    count = 0;
    for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (count == index_0) {
                $remove_35(this$static, i);
                return $clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? entry : entry.getValue();
            }
            ++count;
        }
    }
    throw toJs(new IndexOutOfBoundsException_0('index=' + index_0 + ', size=' + count));
}
function $remove_44(this$static, feature, object) {
    var entries, entry, i, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    $clinit_FeatureMapUtil();
    if (castTo(feature, 69).isFeatureMap_0()) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (equals_Ljava_lang_Object__Z__devirtual$(entry, object)) {
                $remove_35(this$static, i);
                return true;
            }
        }
    }
    else if (object != null) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (equals_Ljava_lang_Object__Z__devirtual$(object, entry.getValue())) {
                $remove_35(this$static, i);
                return true;
            }
        }
    }
    else for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            if (entry.getValue() == null) {
                $remove_35(this$static, i);
                return true;
            }
        }
    }
    return false;
}
function $resolve_2(this$static, index_0, entry) {
    var affiliatedFeature, affliatedEntry, entries, feature, featureIndex, i, inverseFeatureID, newEntry, notifications, object, opposite, reference, resolved, validator;
    feature = entry.getEStructuralFeature();
    if (instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0) {
        object = castTo(entry.getValue(), 52);
        resolved = $eResolveProxy(this$static.owner, object);
        if (resolved != object) {
            newEntry = createEntry_5(feature, resolved);
            $assign(this$static, index_0, $validate_3(this$static, index_0, newEntry));
            notifications = null;
            if ($eNotificationRequired(this$static.owner)) {
                affiliatedFeature = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), this$static.owner.eClass_0(), feature);
                if (affiliatedFeature != $getEStructuralFeature(this$static.owner.eClass_0(), this$static.featureID)) {
                    validator = getValidator(this$static.owner.eClass_0(), feature);
                    featureIndex = 0;
                    entries = castTo(this$static.data_0, 122);
                    for(i = 0; i < index_0; ++i){
                        affliatedEntry = entries[i];
                        validator.isValid(affliatedEntry.getEStructuralFeature()) && ++featureIndex;
                    }
                    notifications = new FeatureMapUtil$FeatureENotificationImpl(this$static.owner, 9, affiliatedFeature, object, resolved, featureIndex, false);
                    notifications.add_5(new ENotificationImpl_3(this$static.owner, 9, this$static.featureID, entry, newEntry, index_0, false));
                }
            }
            reference = castTo(feature, 19);
            opposite = $getEOpposite(reference);
            if (opposite) {
                notifications = object.eInverseRemove(this$static.owner, $getFeatureID(object.eClass_0(), opposite), null, notifications);
                notifications = castTo(resolved, 52).eInverseAdd(this$static.owner, $getFeatureID(resolved.eClass_0(), opposite), null, notifications);
            } else if ((reference.eFlags & $intern_137) != 0) {
                inverseFeatureID = -1 - $getFeatureID(this$static.owner.eClass_0(), reference);
                notifications = object.eInverseRemove(this$static.owner, inverseFeatureID, null, null);
                !castTo(resolved, 52).eInternalContainer() && (notifications = castTo(resolved, 52).eInverseAdd(this$static.owner, inverseFeatureID, null, notifications));
            }
            !!notifications && notifications.dispatch_0();
            return newEntry;
        }
    }
    return entry;
}
function $resolveProxy_0(this$static, eObject) {
    return $eResolveProxy(this$static.owner, castTo(eObject, 52));
}
function $resolveProxy_1(this$static, feature, entryIndex, index_0, object) {
    var entry, notifications, oldObject, resolved;
    resolved = $resolveProxy_0(this$static, castTo(object, 57));
    if (maskUndefined(resolved) !== maskUndefined(object)) {
        oldObject = castTo(this$static.data_0[entryIndex], 74);
        entry = createEntry_5(feature, resolved);
        $assign(this$static, entryIndex, $validate_3(this$static, entryIndex, entry));
        if ($eNotificationRequired(this$static.owner)) {
            notifications = $createNotification_0(this$static, 9, entry.getEStructuralFeature(), object, resolved, index_0, false);
            $add_22(notifications, new ENotificationImpl_3(this$static.owner, 9, this$static.featureID, oldObject, entry, index_0, false));
            $dispatch(notifications);
        }
        return resolved;
    }
    return object;
}
function $set_14(this$static, index_0, object) {
    var entries, entry, entryFeature, i, otherEntry, validator;
    entry = object;
    entryFeature = entry.getEStructuralFeature();
    if (isMany_1(this$static.owner, entryFeature)) {
        if (entryFeature.isUnique()) {
            entries = castTo(this$static.data_0, 122);
            for(i = 0; i < this$static.size_0; ++i){
                otherEntry = entries[i];
                if (equals_Ljava_lang_Object__Z__devirtual$(otherEntry, entry) && i != index_0) throw toJs(new IllegalArgumentException_0("The 'no duplicates' constraint is violated"));
            }
        }
    } else {
        validator = getValidator(this$static.owner.eClass_0(), entryFeature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            otherEntry = entries[i];
            if (validator.isValid(otherEntry.getEStructuralFeature()) && i != index_0) throw toJs(new IllegalArgumentException_0('The multiplicity constraint is violated'));
        }
    }
    return castTo($set_9(this$static, index_0, object), 74);
}
function $set_15(this$static, newValue) {
    $set_13(this$static, instanceOf(newValue, 159) ? newValue : castTo(newValue, 1982).featureMap_0());
}
function $set_16(this$static, feature, index_0, object) {
    var count, currentIndex, entries, entry, i, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    if (isMany_1(this$static.owner, feature)) {
        if (feature.isUnique()) {
            currentIndex = $indexOf_8(this$static, feature, object, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0);
            if (currentIndex >= 0 && currentIndex != index_0) throw toJs(new IllegalArgumentException_0("The 'no duplicates' constraint is violated"));
        }
        count = 0;
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) {
                if (count == index_0) return castTo($set_9(this$static, i, ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? castTo(object, 74) : createEntry_5(feature, object))), 74);
                ++count;
            }
        }
        throw toJs(new IndexOutOfBoundsException_0('index=' + index_0 + ', size=' + count));
    } else {
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            if (validator.isValid(entry.getEStructuralFeature())) return $clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? entry : entry.getValue();
        }
        return null;
    }
}
function $set_17(this$static, feature, object) {
    var entries, entry, entryFeature, i, index_0, list, shouldUnset, validator;
    if (isMany_1(this$static.owner, feature)) {
        list = ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? new FeatureMapUtil$FeatureFeatureMap(feature, this$static) : new FeatureMapUtil$FeatureEList(feature, this$static));
        $clear_15(list.featureMap, list.feature);
        $addAll_14(list, castTo(object, 16));
    } else {
        validator = getValidator(this$static.owner.eClass_0(), feature);
        entries = castTo(this$static.data_0, 122);
        for(i = 0; i < this$static.size_0; ++i){
            entry = entries[i];
            entryFeature = entry.getEStructuralFeature();
            if (validator.isValid(entryFeature)) {
                if (entryFeature == ($clinit_XMLTypeFeatures(), TEXT) || entryFeature == CDATA) {
                    shouldUnset = $shouldUnset(this$static, feature, object);
                    index_0 = i;
                    shouldUnset ? $remove_35(this$static, i) : ++i;
                    while(i < this$static.size_0){
                        entry = entries[i];
                        entryFeature = entry.getEStructuralFeature();
                        entryFeature == TEXT || entryFeature == CDATA ? $remove_35(this$static, i) : ++i;
                    }
                    shouldUnset || castTo($set_9(this$static, index_0, createEntry_5(feature, object)), 74);
                } else $shouldUnset(this$static, feature, object) ? $remove_35(this$static, i) : castTo($set_9(this$static, i, ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? castTo(object, 74) : createEntry_5(feature, object))), 74);
                return;
            }
        }
        $shouldUnset(this$static, feature, object) || $add_21(this$static, ($clinit_FeatureMapUtil(), castTo(feature, 69).isFeatureMap_0() ? castTo(object, 74) : createEntry_5(feature, object)));
    }
}
function $setting(this$static, feature) {
    return isMany_1(this$static.owner, feature) ? ($clinit_FeatureMapUtil(), $isFeatureMap(feature) ? new FeatureMapUtil$FeatureFeatureMap(feature, this$static) : new FeatureMapUtil$FeatureEList(feature, this$static)) : new FeatureMapUtil$FeatureValue(feature, this$static);
}
function $shadowAdd_1(this$static, entry, notifications) {
    var feature, notification, value_0;
    feature = entry.getEStructuralFeature();
    value_0 = entry.getValue();
    notification = feature.isMany() ? $createNotification_0(this$static, 3, feature, null, value_0, $indexOf_8(this$static, feature, value_0, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0), true) : $createNotification_0(this$static, 1, feature, feature.getDefaultValue(), value_0, -1, true);
    notifications ? notifications.add_5(notification) : notifications = notification;
    return notifications;
}
function $shadowAdd_2(this$static, object, notifications) {
    return $shadowAdd_1(this$static, castTo(object, 339), notifications);
}
function $shadowRemove_1(this$static, entry, notifications) {
    var feature, notification, value_0;
    feature = entry.getEStructuralFeature();
    value_0 = entry.getValue();
    notification = feature.isMany() ? $createNotification_0(this$static, 4, feature, value_0, null, $indexOf_8(this$static, feature, value_0, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0), true) : $createNotification_0(this$static, feature.isUnsettable() ? 2 : 1, feature, value_0, feature.getDefaultValue(), -1, true);
    notifications ? notifications.add_5(notification) : notifications = notification;
    return notifications;
}
function $shadowRemove_2(this$static, object, notifications) {
    return $shadowRemove_1(this$static, castTo(object, 339), notifications);
}
function $shadowSet_1(this$static, oldObject, newObject, notifications) {
    var feature, newValue, notification, oldValue;
    if ($eNotificationRequired(this$static.owner)) {
        feature = oldObject.getEStructuralFeature();
        oldValue = oldObject.getValue();
        newValue = newObject.getValue();
        notification = $createNotification_0(this$static, 1, feature, oldValue, newValue, feature.isMany() ? $indexOf_8(this$static, feature, newValue, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0) : -1, true);
        notifications ? notifications.add_5(notification) : notifications = notification;
    }
    return notifications;
}
function $shouldUnset(this$static, feature, value_0) {
    var defaultValue;
    if (feature.isUnsettable()) return false;
    else if (feature.getUpperBound() != -2) {
        defaultValue = feature.getDefaultValue();
        return defaultValue == null ? value_0 == null : equals_Ljava_lang_Object__Z__devirtual$(defaultValue, value_0);
    } else return feature.getEContainingClass() == this$static.owner.eClass_0() && value_0 == null;
}
function $size_3(this$static, feature) {
    var entries, entry, i, result, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    result = 0;
    entries = castTo(this$static.data_0, 122);
    for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        validator.isValid(entry.getEStructuralFeature()) && ++result;
    }
    return result;
}
function $toArray_11(this$static, feature) {
    return $toArray_12(this$static, feature, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0);
}
function $toArray_12(this$static, feature, resolve) {
    var entries, entry, i, result, validator, value_0;
    result = new BasicEList;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    $clinit_FeatureMapUtil();
    if (castTo(feature, 69).isFeatureMap_0()) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        validator.isValid(entry.getEStructuralFeature()) && $add_21(result, entry);
    }
    else for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            value_0 = entry.getValue();
            $add_21(result, resolve ? $resolveProxy_1(this$static, feature, i, result.size_0, value_0) : value_0);
        }
    }
    return $toArray_8(result);
}
function $toArray_13(this$static, feature, array) {
    return $toArray_14(this$static, feature, array, instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_64) != 0);
}
function $toArray_14(this$static, feature, array, resolve) {
    var entries, entry, i, result, validator, value_0;
    result = new BasicEList;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    entries = castTo(this$static.data_0, 122);
    $clinit_FeatureMapUtil();
    if (castTo(feature, 69).isFeatureMap_0()) for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        validator.isValid(entry.getEStructuralFeature()) && $add_21(result, entry);
    }
    else for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            value_0 = entry.getValue();
            $add_21(result, resolve ? $resolveProxy_1(this$static, feature, i, result.size_0, value_0) : value_0);
        }
    }
    return $toArray_9(result, array);
}
function $unset(this$static, feature) {
    var entries, entry, i, removals, validator;
    validator = getValidator(this$static.owner.eClass_0(), feature);
    removals = null;
    entries = castTo(this$static.data_0, 122);
    for(i = 0; i < this$static.size_0; ++i){
        entry = entries[i];
        if (validator.isValid(entry.getEStructuralFeature())) {
            !removals && (removals = new BasicEList);
            $add_21(removals, entry);
        }
    }
    !!removals && $removeAll_4(this$static, removals);
}
function $validate_3(this$static, index_0, object) {
    var eStructuralFeature, result;
    if (this$static.modCount == 0) return object;
    result = castTo($validate_0(this$static, index_0, object), 74);
    eStructuralFeature = object.getEStructuralFeature();
    if (!eStructuralFeature.isChangeable() || !this$static.featureMapValidator.isValid(eStructuralFeature)) throw toJs(new RuntimeException_0("Invalid entry feature '" + eStructuralFeature.getEContainingClass().name_0 + '.' + eStructuralFeature.getName() + "'"));
    return result;
}
function BasicFeatureMap(owner, featureID) {
    EDataTypeEList.call(this, Lorg_eclipse_emf_ecore_util_FeatureMap$Entry$Internal_2_classLit, owner, featureID);
    this.wrapper = this;
    this.featureMapValidator = getValidator(owner.eClass_0(), $getEStructuralFeature(this.owner.eClass_0(), this.featureID));
}
defineClass(75, 576, {
    3: 1,
    4: 1,
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    59: 1,
    70: 1,
    66: 1,
    61: 1,
    76: 1,
    159: 1,
    218: 1,
    1982: 1,
    71: 1,
    96: 1
}, BasicFeatureMap);
_.add_3 = function add_66(index_0, object) {
    $add_31(this, index_0, castTo(object, 74));
};
_.add_2 = function add_67(object) {
    return $add_34(this, castTo(object, 74));
};
_.addUnique_0 = function addUnique_19(object) {
    $addUnique_13(this, castTo(object, 74));
};
_.inverseAdd = function inverseAdd_9(object, notifications) {
    return $inverseAdd_3(this, castTo(object, 74), notifications);
};
_.inverseRemove = function inverseRemove_9(object, notifications) {
    return $inverseRemove_3(this, castTo(object, 74), notifications);
};
_.move = function move_20(targetIndex, sourceIndex) {
    return $move_5(this, targetIndex, sourceIndex);
};
_.resolve = function resolve_9(index_0, entry) {
    return $resolve_2(this, index_0, castTo(entry, 74));
};
_.set_2 = function set_37(index_0, object) {
    return $set_14(this, index_0, castTo(object, 74));
};
_.shadowAdd = function shadowAdd_2(object, notifications) {
    return $shadowAdd_2(this, castTo(object, 74), notifications);
};
_.shadowRemove = function shadowRemove_2(object, notifications) {
    return $shadowRemove_2(this, castTo(object, 74), notifications);
};
_.shadowSet = function shadowSet_2(oldObject, newObject, notifications) {
    return $shadowSet_1(this, castTo(oldObject, 74), castTo(newObject, 74), notifications);
};
_.validate = function validate_7(index_0, object) {
    return $validate_3(this, index_0, castTo(object, 74));
};
_.add_6 = function add_68(feature, object) {
    return $add_33(this, feature, object);
};
_.addAll_0 = function addAll_34(index_0, collection) {
    var entries, entry, entry$iterator, entryFeature, include, j, otherEntry, uniqueCollection, validator;
    uniqueCollection = new BasicEList_0(collection.size_1());
    for(entry$iterator = collection.iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 74);
        entryFeature = entry.getEStructuralFeature();
        if (isMany_1(this.owner, entryFeature)) (!entryFeature.isUnique() || !$contains_12(this, entryFeature, entry.getValue()) && !$contains_10(uniqueCollection, entry)) && $add_21(uniqueCollection, entry);
        else {
            validator = getValidator(this.owner.eClass_0(), entryFeature);
            entries = castTo(this.data_0, 122);
            include = true;
            for(j = 0; j < this.size_0; ++j){
                otherEntry = entries[j];
                if (validator.isValid(otherEntry.getEStructuralFeature())) {
                    castTo($set_9(this, j, entry), 74);
                    include = false;
                    break;
                }
            }
            include && $add_21(uniqueCollection, entry);
        }
    }
    return $addAll_8(this, index_0, uniqueCollection);
};
_.addAll = function addAll_35(collection) {
    var entries, entry, entry$iterator, entryFeature, include, j, otherEntry, uniqueCollection, validator;
    uniqueCollection = new BasicEList_0(collection.size_1());
    for(entry$iterator = collection.iterator_0(); entry$iterator.hasNext_0();){
        entry = castTo(entry$iterator.next_1(), 74);
        entryFeature = entry.getEStructuralFeature();
        if (isMany_1(this.owner, entryFeature)) (!entryFeature.isUnique() || !$contains_12(this, entryFeature, entry.getValue()) && !$contains_10(uniqueCollection, entry)) && $add_21(uniqueCollection, entry);
        else {
            validator = getValidator(this.owner.eClass_0(), entryFeature);
            entries = castTo(this.data_0, 122);
            include = true;
            for(j = 0; j < this.size_0; ++j){
                otherEntry = entries[j];
                if (validator.isValid(otherEntry.getEStructuralFeature())) {
                    castTo($set_9(this, j, entry), 74);
                    include = false;
                    break;
                }
            }
            include && $add_21(uniqueCollection, entry);
        }
    }
    return $addAll_9(this, uniqueCollection);
};
_.addAllUnique_0 = function addAllUnique_15(collection) {
    this.modCount = -1;
    return $addAllUnique_3(this, this.size_0, collection);
};
_.basicAdd_0 = function basicAdd_4(feature, object, notifications) {
    return $basicAdd_2(this, feature, object, notifications);
};
_.basicRemove = function basicRemove_4(object, notifications) {
    return $basicRemove_2(this, object, notifications);
};
_.basicRemove_0 = function basicRemove_5(feature, object, notifications) {
    return $basicRemove_3(this, feature, object, notifications);
};
_.featureMap_0 = function featureMap_0() {
    return this;
};
_.get_7 = function get_66(feature, resolve) {
    return $get_24(this, feature, resolve);
};
_.getEStructuralFeature_0 = function getEStructuralFeature_2(index_0) {
    return castTo($get_20(this, index_0), 74).getEStructuralFeature();
};
_.getValue_1 = function getValue_19(index_0) {
    return castTo($get_20(this, index_0), 74).getValue();
};
_.getWrapper = function getWrapper() {
    return this.wrapper;
};
_.hasInverse = function hasInverse_11() {
    return true;
};
_.hasShadow = function hasShadow_2() {
    return true;
};
_.isSet_1 = function isSet_13(feature) {
    return !$isEmpty_0(this, feature);
};
_.newData = function newData_14(capacity) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_util_FeatureMap$Entry$Internal_2_classLit, $intern_165, 339, capacity, 0, 1);
};
_.resolveProxy = function resolveProxy_0(eObject) {
    return $resolveProxy_0(this, eObject);
};
_.set_1 = function set_38(newValue) {
    $set_15(this, newValue);
};
_.set_3 = function set_39(feature, object) {
    $set_17(this, feature, object);
};
_.setting = function setting_0(feature) {
    return $setting(this, feature);
};
_.unset_0 = function unset_9(feature) {
    $unset(this, feature);
};
var Lorg_eclipse_emf_ecore_util_BasicFeatureMap_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicFeatureMap', 75);
function $checkModCount(this$static) {
    if (this$static.featureMap.modCount != this$static.expectedModCount) throw toJs(new ConcurrentModificationException);
}
function $hasNext_8(this$static) {
    switch(this$static.prepared){
        case 2:
            return true;
        case 1:
            return false;
        case -1:
            ++this$static.entryCursor;
        default:
            return this$static.scanNext();
    }
}
function $hasPrevious(this$static) {
    switch(this$static.prepared){
        case -2:
            return true;
        case -1:
            return false;
        case 1:
            --this$static.entryCursor;
        default:
            return this$static.scanPrevious();
    }
}
function $next_15(this$static) {
    var newPreparedResult;
    if ($hasNext_8(this$static)) {
        $checkModCount(this$static);
        if (this$static.resolve_0()) {
            newPreparedResult = $resolveProxy_1(this$static.featureMap, this$static.eStructuralFeature, this$static.entryCursor, this$static.cursor, this$static.preparedResult);
            this$static.preparedResult = newPreparedResult;
        }
        this$static.lastCursor = this$static.cursor;
        ++this$static.cursor;
        ++this$static.entryCursor;
        this$static.prepared = 0;
        return this$static.preparedResult;
    } else throw toJs(new NoSuchElementException);
}
defineClass(1906, 1, $intern_14);
_.forEachRemaining = function forEachRemaining_59(consumer) {
    $forEachRemaining(this, consumer);
};
_.add_1 = function add_69(o) {
    if (this.lastCursor == -1) throw toJs(new IllegalStateException);
    $checkModCount(this);
    try {
        $add_32(this.featureMap, this.eStructuralFeature, this.cursor, o);
        this.expectedModCount = this.featureMap.modCount;
        $next_15(this);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) throw toJs(new ConcurrentModificationException);
        else throw toJs($e0);
    }
};
_.hasNext_0 = function hasNext_49() {
    return $hasNext_8(this);
};
_.hasPrevious = function hasPrevious_10() {
    return $hasPrevious(this);
};
_.next_1 = function next_49() {
    return $next_15(this);
};
_.nextIndex_0 = function nextIndex_11() {
    return this.cursor;
};
_.previous_0 = function previous_11() {
    var newPreparedResult;
    if ($hasPrevious(this)) {
        $checkModCount(this);
        this.lastCursor = --this.cursor;
        if (this.resolve_0()) {
            newPreparedResult = $resolveProxy_1(this.featureMap, this.eStructuralFeature, this.entryCursor, this.cursor, this.preparedResult);
            this.preparedResult = newPreparedResult;
        }
        this.prepared = 0;
        return this.preparedResult;
    } else throw toJs(new NoSuchElementException);
};
_.previousIndex = function previousIndex_10() {
    return this.cursor - 1;
};
_.remove = function remove_129() {
    if (this.lastCursor == -1) throw toJs(new IllegalStateException);
    $checkModCount(this);
    try {
        $remove_43(this.featureMap, this.eStructuralFeature, this.lastCursor);
        this.expectedModCount = this.featureMap.modCount;
        if (this.lastCursor < this.cursor) {
            --this.cursor;
            --this.entryCursor;
        }
        --this.lastCursor;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) throw toJs(new ConcurrentModificationException);
        else throw toJs($e0);
    }
};
_.resolve_0 = function resolve_10() {
    return false;
};
_.set_1 = function set_40(o) {
    if (this.lastCursor == -1) throw toJs(new IllegalStateException);
    $checkModCount(this);
    try {
        $set_16(this.featureMap, this.eStructuralFeature, this.lastCursor, o);
        this.expectedModCount = this.featureMap.modCount;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 97)) throw toJs(new ConcurrentModificationException);
        else throw toJs($e0);
    }
};
_.cursor = 0;
_.entryCursor = 0;
_.expectedModCount = 0;
_.isFeatureMap = false;
_.lastCursor = 0;
_.prepared = 0;
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$BasicFeatureEIterator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/BasicFeatureEIterator', 1906);
function BasicFeatureMap$FeatureEIterator(eStructuralFeature, featureMap) {
    this.eStructuralFeature = eStructuralFeature;
    this.featureMap = featureMap;
    this.expectedModCount = featureMap.modCount;
    this.isFeatureMap = ($clinit_FeatureMapUtil(), castTo(eStructuralFeature, 69).isFeatureMap_0());
    this.validator = getValidator(featureMap.owner.eClass_0(), eStructuralFeature);
}
defineClass(409, 1906, $intern_14, BasicFeatureMap$FeatureEIterator);
_.scanNext = function scanNext() {
    var entries, entry, size_0;
    size_0 = this.featureMap.size_0;
    entries = castTo(this.featureMap.data_0, 122);
    while(this.entryCursor < size_0){
        entry = entries[this.entryCursor];
        if (this.validator.isValid(entry.getEStructuralFeature())) {
            this.preparedResult = this.isFeatureMap ? entry : entry.getValue();
            this.prepared = 2;
            return true;
        }
        ++this.entryCursor;
    }
    this.prepared = 1;
    this.lastCursor = -1;
    return false;
};
_.scanPrevious = function scanPrevious() {
    var entries, entry;
    entries = castTo(this.featureMap.data_0, 122);
    while(--this.entryCursor >= 0){
        entry = entries[this.entryCursor];
        if (this.validator.isValid(entry.getEStructuralFeature())) {
            this.preparedResult = this.isFeatureMap ? entry : entry.getValue();
            this.prepared = -2;
            return true;
        }
    }
    this.prepared = -1;
    this.lastCursor = -1;
    return false;
};
var Lorg_eclipse_emf_ecore_util_BasicFeatureMap$FeatureEIterator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicFeatureMap/FeatureEIterator', 409);
function BasicFeatureMap$ResolvingFeatureEIterator(eStructuralFeature, featureMap) {
    BasicFeatureMap$FeatureEIterator.call(this, eStructuralFeature, featureMap);
}
defineClass(661, 409, $intern_14, BasicFeatureMap$ResolvingFeatureEIterator);
_.resolve_0 = function resolve_11() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_BasicFeatureMap$ResolvingFeatureEIterator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'BasicFeatureMap/ResolvingFeatureEIterator', 661);
function EContentsEList$1() {
    EContentsEList.call(this, null, null);
}
defineClass(946, 480, $intern_159, EContentsEList$1);
_.basicList = function basicList_3() {
    return this;
};
var Lorg_eclipse_emf_ecore_util_EContentsEList$1_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EContentsEList/1', 946);
function EContentsEList$2($anonymous0, $anonymous1) {
    EContentsEList.call(this, $anonymous0, $anonymous1);
}
defineClass(947, 480, $intern_159, EContentsEList$2);
_.resolve_0 = function resolve_12() {
    return false;
};
var Lorg_eclipse_emf_ecore_util_EContentsEList$2_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EContentsEList/2', 947);
function EContentsEList$FeatureIteratorImpl$1() {
    EContentsEList$FeatureIteratorImpl.call(this, null, null);
}
defineClass(945, 284, $intern_160, EContentsEList$FeatureIteratorImpl$1);
_.filter_0 = function filter_4(featureFilter) {};
_.hasNext_0 = function hasNext_50() {
    return false;
};
_.hasPrevious = function hasPrevious_11() {
    return false;
};
var Lorg_eclipse_emf_ecore_util_EContentsEList$FeatureIteratorImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EContentsEList/FeatureIteratorImpl/1', 945);
function EDataTypeEList$Unsettable(dataClass, owner, featureID) {
    EDataTypeEList.call(this, dataClass, owner, featureID);
}
defineClass(819, 576, $intern_156, EDataTypeEList$Unsettable);
_.didChange = function didChange_2() {
    this.isSet = true;
};
_.isSet_0 = function isSet_14() {
    return this.isSet;
};
_.unset = function unset_10() {
    var oldIsSet;
    $clear_13(this);
    if ($eNotificationRequired(this.owner)) {
        oldIsSet = this.isSet;
        this.isSet = false;
        $eNotify(this.owner, new ENotificationImpl_4(this.owner, 2, this.featureID, oldIsSet, false));
    } else this.isSet = false;
};
_.isSet = false;
var Lorg_eclipse_emf_ecore_util_EDataTypeEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EDataTypeEList/Unsettable', 819);
function EDataTypeUniqueEList(dataClass, owner, featureID) {
    EDataTypeEList.call(this, dataClass, owner, featureID);
}
defineClass(1904, 576, $intern_156, EDataTypeUniqueEList);
_.isUnique = function isUnique_8() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EDataTypeUniqueEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EDataTypeUniqueEList', 1904);
function EDataTypeUniqueEList$Unsettable(dataClass, owner, featureID) {
    EDataTypeEList$Unsettable.call(this, dataClass, owner, featureID);
}
defineClass(1905, 819, $intern_156, EDataTypeUniqueEList$Unsettable);
_.isUnique = function isUnique_9() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EDataTypeUniqueEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EDataTypeUniqueEList/Unsettable', 1905);
function EObjectContainmentEList$Resolving(dataClass, owner, featureID) {
    EObjectContainmentEList.call(this, dataClass, owner, featureID);
}
defineClass(142, 81, $intern_156, EObjectContainmentEList$Resolving);
_.hasProxies = function hasProxies_4() {
    return true;
};
_.resolve = function resolve_13(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectContainmentEList$Resolving_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentEList/Resolving', 142);
function EObjectContainmentEList$Unsettable$Resolving(dataClass, owner, featureID) {
    EObjectContainmentEList$Unsettable.call(this, dataClass, owner, featureID);
}
defineClass(1148, 540, $intern_156, EObjectContainmentEList$Unsettable$Resolving);
_.hasProxies = function hasProxies_5() {
    return true;
};
_.resolve = function resolve_14(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectContainmentEList$Unsettable$Resolving_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentEList/Unsettable/Resolving', 1148);
function EObjectContainmentWithInverseEList$Unsettable(dataClass, owner, featureID, inverseFeatureID) {
    EObjectContainmentWithInverseEList.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(748, 14, $intern_156, EObjectContainmentWithInverseEList$Unsettable);
_.didChange = function didChange_3() {
    this.isSet = true;
};
_.isSet_0 = function isSet_15() {
    return this.isSet;
};
_.unset = function unset_11() {
    var oldIsSet;
    $clear_13(this);
    if ($eNotificationRequired(this.owner)) {
        oldIsSet = this.isSet;
        this.isSet = false;
        $eNotify(this.owner, new ENotificationImpl_4(this.owner, 2, this.featureID, oldIsSet, false));
    } else this.isSet = false;
};
_.isSet = false;
var Lorg_eclipse_emf_ecore_util_EObjectContainmentWithInverseEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentWithInverseEList/Unsettable', 748);
function EObjectContainmentWithInverseEList$Unsettable$Resolving(dataClass, owner, featureID, inverseFeatureID) {
    EObjectContainmentWithInverseEList$Unsettable.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(1182, 748, $intern_156, EObjectContainmentWithInverseEList$Unsettable$Resolving);
_.hasProxies = function hasProxies_6() {
    return true;
};
_.resolve = function resolve_15(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectContainmentWithInverseEList$Unsettable$Resolving_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectContainmentWithInverseEList/Unsettable/Resolving', 1182);
function EObjectEList$Unsettable(dataClass, owner, featureID) {
    EObjectEList.call(this, dataClass, owner, featureID);
}
defineClass(740, 489, $intern_156, EObjectEList$Unsettable);
_.didChange = function didChange_4() {
    this.isSet = true;
};
_.isSet_0 = function isSet_16() {
    return this.isSet;
};
_.unset = function unset_12() {
    var oldIsSet;
    $clear_13(this);
    if ($eNotificationRequired(this.owner)) {
        oldIsSet = this.isSet;
        this.isSet = false;
        $eNotify(this.owner, new ENotificationImpl_4(this.owner, 2, this.featureID, oldIsSet, false));
    } else this.isSet = false;
};
_.isSet = false;
var Lorg_eclipse_emf_ecore_util_EObjectEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectEList/Unsettable', 740);
function EObjectResolvingEList(dataClass, owner, featureID) {
    EObjectEList.call(this, dataClass, owner, featureID);
}
defineClass(334, 489, $intern_156, EObjectResolvingEList);
_.hasProxies = function hasProxies_7() {
    return true;
};
_.resolve = function resolve_16(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectResolvingEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectResolvingEList', 334);
function EObjectResolvingEList$Unsettable(dataClass, owner, featureID) {
    EObjectEList$Unsettable.call(this, dataClass, owner, featureID);
}
defineClass(1790, 740, $intern_156, EObjectResolvingEList$Unsettable);
_.hasProxies = function hasProxies_8() {
    return true;
};
_.resolve = function resolve_17(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectResolvingEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectResolvingEList/Unsettable', 1790);
function $clinit_EObjectValidator() {
    $clinit_EObjectValidator = emptyMethod;
    INSTANCE_9 = new EObjectValidator;
}
function EObjectValidator() {}
defineClass(1467, 1, {}, EObjectValidator);
var INSTANCE_9;
var Lorg_eclipse_emf_ecore_util_EObjectValidator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectValidator', 1467);
function EObjectWithInverseEList(dataClass, owner, featureID, inverseFeatureID) {
    EObjectEList.call(this, dataClass, owner, featureID);
    this.inverseFeatureID = inverseFeatureID;
}
defineClass(544, 489, $intern_156, EObjectWithInverseEList);
_.getInverseFeatureClass = function getInverseFeatureClass_1() {
    return this.dataClass;
};
_.getInverseFeatureID = function getInverseFeatureID_1() {
    return this.inverseFeatureID;
};
_.hasInverse = function hasInverse_12() {
    return true;
};
_.hasNavigableInverse = function hasNavigableInverse_5() {
    return true;
};
_.inverseFeatureID = 0;
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseEList', 544);
function EObjectWithInverseEList$ManyInverse(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseEList.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(1185, 544, $intern_156, EObjectWithInverseEList$ManyInverse);
_.hasManyInverse = function hasManyInverse_3() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseEList$ManyInverse_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseEList/ManyInverse', 1185);
function EObjectWithInverseEList$Unsettable(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseEList.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(620, 544, $intern_156, EObjectWithInverseEList$Unsettable);
_.didChange = function didChange_5() {
    this.isSet = true;
};
_.isSet_0 = function isSet_17() {
    return this.isSet;
};
_.unset = function unset_13() {
    var oldIsSet;
    $clear_13(this);
    if ($eNotificationRequired(this.owner)) {
        oldIsSet = this.isSet;
        this.isSet = false;
        $eNotify(this.owner, new ENotificationImpl_4(this.owner, 2, this.featureID, oldIsSet, false));
    } else this.isSet = false;
};
_.isSet = false;
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseEList/Unsettable', 620);
function EObjectWithInverseEList$Unsettable$ManyInverse(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseEList$Unsettable.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(1184, 620, $intern_156, EObjectWithInverseEList$Unsettable$ManyInverse);
_.hasManyInverse = function hasManyInverse_4() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseEList$Unsettable$ManyInverse_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseEList/Unsettable/ManyInverse', 1184);
function EObjectWithInverseResolvingEList(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseEList.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(749, 544, $intern_156, EObjectWithInverseResolvingEList);
_.hasProxies = function hasProxies_9() {
    return true;
};
_.resolve = function resolve_18(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseResolvingEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseResolvingEList', 749);
function EObjectWithInverseResolvingEList$ManyInverse(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseResolvingEList.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(33, 749, $intern_156, EObjectWithInverseResolvingEList$ManyInverse);
_.hasManyInverse = function hasManyInverse_5() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseResolvingEList$ManyInverse_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseResolvingEList/ManyInverse', 33);
function EObjectWithInverseResolvingEList$Unsettable(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseEList$Unsettable.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(750, 620, $intern_156, EObjectWithInverseResolvingEList$Unsettable);
_.hasProxies = function hasProxies_10() {
    return true;
};
_.resolve = function resolve_19(index_0, object) {
    return $resolve(this, index_0, castTo(object, 57));
};
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseResolvingEList$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseResolvingEList/Unsettable', 750);
function EObjectWithInverseResolvingEList$Unsettable$ManyInverse(dataClass, owner, featureID, inverseFeatureID) {
    EObjectWithInverseResolvingEList$Unsettable.call(this, dataClass, owner, featureID, inverseFeatureID);
}
defineClass(1183, 750, $intern_156, EObjectWithInverseResolvingEList$Unsettable$ManyInverse);
_.hasManyInverse = function hasManyInverse_6() {
    return true;
};
var Lorg_eclipse_emf_ecore_util_EObjectWithInverseResolvingEList$Unsettable$ManyInverse_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EObjectWithInverseResolvingEList/Unsettable/ManyInverse', 1183);
function kind_0(eStructuralFeature) {
    var eClassifier, eReference, instanceClass, inverseEReference, result, upper;
    result = 0;
    eClassifier = $getEType(eStructuralFeature);
    !!eClassifier.getInstanceClass() && (result |= 4);
    (eStructuralFeature.eFlags & $intern_152) != 0 && (result |= 2);
    if (instanceOf(eStructuralFeature, 101)) {
        eReference = castTo(eStructuralFeature, 19);
        inverseEReference = $getEOpposite(eReference);
        (eReference.eFlags & $intern_137) != 0 && (result |= 32);
        if (inverseEReference) {
            $getFeatureCount($getEContainingClass(inverseEReference));
            result |= 8;
            upper = inverseEReference.upperBound;
            (upper > 1 || upper == -1) && (result |= 16);
            (inverseEReference.eFlags & $intern_137) != 0 && (result |= 64);
        }
        (eReference.eFlags & $intern_64) != 0 && (result |= $intern_49);
        result |= $intern_149;
    } else if (instanceOf(eClassifier, 455)) result |= 512;
    else {
        instanceClass = eClassifier.getInstanceClass();
        !!instanceClass && (instanceClass.modifiers & 1) != 0 && (result |= 256);
    }
    (eStructuralFeature.eFlags & 512) != 0 && (result |= 128);
    return result;
}
defineClass(1149, 617, $intern_156);
_.canContainNull = function canContainNull_6() {
    return (this.kind & 1792) == 0;
};
_.didChange = function didChange_6() {
    this.kind |= 1;
};
_.hasInstanceClass = function hasInstanceClass_3() {
    return (this.kind & 4) != 0;
};
_.hasInverse = function hasInverse_13() {
    return (this.kind & 40) != 0;
};
_.hasManyInverse = function hasManyInverse_7() {
    return (this.kind & 16) != 0;
};
_.hasNavigableInverse = function hasNavigableInverse_6() {
    return (this.kind & 8) != 0;
};
_.hasProxies = function hasProxies_11() {
    return (this.kind & $intern_49) != 0;
};
_.isContainment = function isContainment_9() {
    return (this.kind & 32) != 0;
};
_.isEObject = function isEObject_5() {
    return (this.kind & $intern_149) != 0;
};
_.isInstance = function isInstance_49(object) {
    return !this.dataClass ? this.getEStructuralFeature().getEType().isInstance(object) : isInstance(this.dataClass, object);
};
_.isSet_0 = function isSet_18() {
    return (this.kind & 2) != 0 ? (this.kind & 1) != 0 : this.size_0 != 0;
};
_.isUnique = function isUnique_10() {
    return (this.kind & 128) != 0;
};
_.unset = function unset_14() {
    var oldIsSet;
    $clear_13(this);
    if ((this.kind & 2) != 0) {
        if ($eNotificationRequired(this.owner)) {
            oldIsSet = (this.kind & 1) != 0;
            this.kind &= -2;
            $dispatchNotification(this, new ENotificationImpl_4(this.owner, 2, $getFeatureID(this.owner.eClass_0(), this.getEStructuralFeature()), oldIsSet, false));
        } else this.kind &= -2;
    }
};
_.useEquals = function useEquals_15() {
    return (this.kind & 1536) == 0;
};
_.kind = 0;
var Lorg_eclipse_emf_ecore_util_EcoreEList$Generic_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEList/Generic', 1149);
function EcoreEList$Dynamic(kind, dataClass, owner, eStructuralFeature) {
    EcoreEList.call(this, dataClass, owner);
    this.kind = kind;
    this.eStructuralFeature = eStructuralFeature;
}
defineClass(1150, 1149, $intern_156, EcoreEList$Dynamic);
_.getEStructuralFeature = function getEStructuralFeature_3() {
    return this.eStructuralFeature;
};
var Lorg_eclipse_emf_ecore_util_EcoreEList$Dynamic_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEList/Dynamic', 1150);
function EcoreEMap$1(this$0) {
    this.this$01 = this$0;
}
defineClass(747, 66, $intern_140, EcoreEMap$1);
_.newData = function newData_15(listCapacity) {
    return newInstance_11(this.this$01.entryClass, listCapacity);
};
var Lorg_eclipse_emf_ecore_util_EcoreEMap$1_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEMap/1', 747);
function EcoreEMap$DelegateEObjectContainmentEList(this$0, entryClass, owner, featureID) {
    this.this$01 = this$0;
    EObjectContainmentEList.call(this, entryClass, owner, featureID);
}
defineClass(746, 81, $intern_156, EcoreEMap$DelegateEObjectContainmentEList);
_.didAdd = function didAdd_4(index_0, newObject) {
    $doPut(this.this$01, castTo(newObject, 135));
};
_.didClear = function didClear_2(size_0, oldObjects) {
    $doClear_0(this.this$01);
};
_.didMove = function didMove_1(index_0, movedObject, oldIndex) {
    var lastArg;
    ++(lastArg = this.this$01, castTo(movedObject, 135), lastArg).modCount;
};
_.didRemove = function didRemove_3(index_0, oldObject) {
    $doRemove(this.this$01, castTo(oldObject, 135));
};
_.didSet = function didSet_2(index_0, newObject, oldObject) {
    $doRemove(this.this$01, castTo(oldObject, 135));
    maskUndefined(oldObject) === maskUndefined(newObject) && castTo(oldObject, 135).setHash($hashOf(castTo(newObject, 135).getKey()));
    $doPut(this.this$01, castTo(newObject, 135));
};
var Lorg_eclipse_emf_ecore_util_EcoreEMap$DelegateEObjectContainmentEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEMap/DelegateEObjectContainmentEList', 746);
function EcoreEMap$Unsettable(entryEClass, entryClass, owner, featureID) {
    this.initializeDelegateEList();
    this.entryClass = entryClass;
    this.entryEClass = entryEClass;
    this.delegateEList = null;
    this.delegateEList = new EcoreEMap$Unsettable$UnsettableDelegateEObjectContainmentEList(this, entryClass, owner, featureID);
}
defineClass(1180, 140, $intern_151, EcoreEMap$Unsettable);
var Lorg_eclipse_emf_ecore_util_EcoreEMap$Unsettable_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEMap/Unsettable', 1180);
function EcoreEMap$Unsettable$UnsettableDelegateEObjectContainmentEList(this$1, dataClass, owner, featureID) {
    EcoreEMap$DelegateEObjectContainmentEList.call(this, this$1, dataClass, owner, featureID);
}
defineClass(1181, 746, $intern_156, EcoreEMap$Unsettable$UnsettableDelegateEObjectContainmentEList);
_.didChange = function didChange_7() {
    this.isSet = true;
};
_.isSet_0 = function isSet_19() {
    return this.isSet;
};
_.unset = function unset_15() {
    var oldIsSet;
    $clear_13(this);
    if ($eNotificationRequired(this.owner)) {
        oldIsSet = this.isSet;
        this.isSet = false;
        $eNotify(this.owner, new ENotificationImpl_4(this.owner, 2, this.featureID, oldIsSet, false));
    } else this.isSet = false;
};
_.isSet = false;
var Lorg_eclipse_emf_ecore_util_EcoreEMap$Unsettable$UnsettableDelegateEObjectContainmentEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreEMap/Unsettable/UnsettableDelegateEObjectContainmentEList', 1181);
function convertToString_2(eDataType, value_0) {
    return eDataType.getEPackage().getEFactoryInstance().convertToString(eDataType, value_0);
}
function createFromString_2(eDataType, literal) {
    return eDataType.getEPackage().getEFactoryInstance().createFromString(eDataType, literal);
}
function getConversionDelegateFactory(eDataType) {
    var eDataTypeDelegate, eDataTypeDelegate$iterator;
    for(eDataTypeDelegate$iterator = getConversionDelegates($getEPackage(eDataType)).iterator_0(); eDataTypeDelegate$iterator.hasNext_0();){
        eDataTypeDelegate = castToString(eDataTypeDelegate$iterator.next_1());
        if ($getEAnnotation(eDataType, eDataTypeDelegate)) return $getFactory(($clinit_EDataType$Internal$ConversionDelegate$Factory$Registry(), INSTANCE_5), eDataTypeDelegate);
    }
    return null;
}
function getConversionDelegates(ePackage) {
    var eAnnotation, eDataTypeDelegate, eDataTypeDelegate$array, eDataTypeDelegate$index, eDataTypeDelegate$max, eDataTypeDelegates, result;
    if (ePackage) {
        eAnnotation = ePackage.getEAnnotation('http://www.eclipse.org/emf/2002/Ecore');
        if (eAnnotation) {
            eDataTypeDelegates = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'conversionDelegates'));
            if (eDataTypeDelegates != null) {
                result = new ArrayList;
                for(eDataTypeDelegate$array = $split_0(eDataTypeDelegates, '\\w+'), eDataTypeDelegate$index = 0, eDataTypeDelegate$max = eDataTypeDelegate$array.length; eDataTypeDelegate$index < eDataTypeDelegate$max; ++eDataTypeDelegate$index){
                    eDataTypeDelegate = eDataTypeDelegate$array[eDataTypeDelegate$index];
                    push_1(result.array, eDataTypeDelegate);
                }
                return result;
            }
        }
    }
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function getRootContainer(eObject) {
    var count, parent_0, result;
    result = eObject;
    if (eObject) {
        count = 0;
        for(parent_0 = eObject.eContainer_0(); parent_0; parent_0 = parent_0.eContainer_0()){
            if (++count > $intern_67) return getRootContainer(parent_0);
            result = parent_0;
            if (parent_0 == eObject) throw toJs(new IllegalStateException_0('There is a cycle in the containment hierarchy of ' + eObject));
        }
    }
    return result;
}
function getSettingDelegateFactory(eStructuralFeature) {
    var settingDelegate, settingDelegate$iterator;
    for(settingDelegate$iterator = getSettingDelegates($getEPackage($getEContainingClass(eStructuralFeature))).iterator_0(); settingDelegate$iterator.hasNext_0();){
        settingDelegate = castToString(settingDelegate$iterator.next_1());
        if ($getEAnnotation(eStructuralFeature, settingDelegate)) return $getFactory_0(($clinit_EStructuralFeature$Internal$SettingDelegate$Factory$Registry(), INSTANCE_7), settingDelegate);
    }
    return null;
}
function getSettingDelegates(ePackage) {
    var eAnnotation, result, settingDelegate, settingDelegate$array, settingDelegate$index, settingDelegate$max, settingDelegates;
    eAnnotation = ePackage.getEAnnotation('http://www.eclipse.org/emf/2002/Ecore');
    if (eAnnotation) {
        settingDelegates = castToString($get_21((!eAnnotation.details && (eAnnotation.details = new EAnnotationImpl$1(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, eAnnotation)), eAnnotation.details), 'settingDelegates'));
        if (settingDelegates != null) {
            result = new ArrayList;
            for(settingDelegate$array = $split_0(settingDelegates, '\\w+'), settingDelegate$index = 0, settingDelegate$max = settingDelegate$array.length; settingDelegate$index < settingDelegate$max; ++settingDelegate$index){
                settingDelegate = settingDelegate$array[settingDelegate$index];
                push_1(result.array, settingDelegate);
            }
            return result;
        }
    }
    return $clinit_Collections(), $clinit_Collections(), EMPTY_LIST;
}
function isAncestor(ancestorEObject, eObject) {
    var count, eContainer;
    if (eObject) {
        if (eObject == ancestorEObject) return true;
        count = 0;
        for(eContainer = castTo(eObject, 52).eInternalContainer(); !!eContainer && eContainer != eObject; eContainer = eContainer.eInternalContainer()){
            if (++count > $intern_67) return isAncestor(ancestorEObject, eContainer);
            if (eContainer == ancestorEObject) return true;
        }
    }
    return false;
}
function resolve_20(proxy) {
    var ePackage, proxyURI, resolvedObject, resource;
    proxyURI = castTo(proxy, 52).eProxyURI_0();
    if (proxyURI) try {
        resolvedObject = null;
        ePackage = $getEPackage_0(($clinit_EPackage$Registry(), INSTANCE_6), $toString_26($trimFragment(proxyURI)));
        if (ePackage) {
            resource = ePackage.eResource_0();
            !!resource && (resolvedObject = resource.getEObject($toString_7(proxyURI.fragment)));
        }
        if (!!resolvedObject && resolvedObject != proxy) return resolve_20(resolvedObject);
    } catch ($e0) {
        $e0 = toJava($e0);
        if (!instanceOf($e0, 63)) throw toJs($e0);
    }
    return proxy;
}
function wrapperClassFor(javaClass) {
    return !javaClass ? null : (javaClass.modifiers & 1) != 0 ? javaClass == Z_classLit ? Ljava_lang_Boolean_2_classLit : javaClass == I_classLit ? Ljava_lang_Integer_2_classLit : javaClass == F_classLit ? Ljava_lang_Float_2_classLit : javaClass == D_classLit ? Ljava_lang_Double_2_classLit : javaClass == J_classLit ? Ljava_lang_Long_2_classLit : javaClass == S_classLit ? Ljava_lang_Short_2_classLit : javaClass == B_classLit ? Ljava_lang_Byte_2_classLit : Ljava_lang_Character_2_classLit : javaClass;
}
function $copy_1(this$static, eObject) {
    var copyEObject, eAllStructuralFeaturesData, eClass, eClass0, eReference, eStructuralFeature, i, size_0;
    if (!eObject) return null;
    else {
        copyEObject = (eClass0 = eObject.eClass_0(), !eClass0 ? null : $getEPackage(eClass0).getEFactoryInstance().create_3(eClass0));
        if (copyEObject) {
            $put_11(this$static, eObject, copyEObject);
            eClass = eObject.eClass_0();
            for(i = 0, size_0 = (eClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(eClass), eClass.eAllStructuralFeaturesData).length; i < size_0; ++i){
                eStructuralFeature = (eAllStructuralFeaturesData = (eClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(eClass), eClass.eAllStructuralFeaturesData), i >= 0 && i < eAllStructuralFeaturesData.length ? eAllStructuralFeaturesData[i] : null);
                if (eStructuralFeature.isChangeable() && !eStructuralFeature.isDerived()) {
                    if (instanceOf(eStructuralFeature, 330)) $copyAttribute(this$static, castTo(eStructuralFeature, 35), eObject, copyEObject);
                    else {
                        eReference = castTo(eStructuralFeature, 19);
                        (eReference.eFlags & $intern_137) != 0 && $copyContainment(this$static, eReference, eObject, copyEObject);
                    }
                }
            }
            eObject.eIsProxy() && castTo(copyEObject, 52).eSetProxyURI(castTo(eObject, 52).eProxyURI_0());
        }
        return copyEObject;
    }
}
function $copyAll(this$static, eObjects) {
    var object, object$iterator, result, t;
    result = new ArrayList_0(eObjects.size_1());
    for(object$iterator = eObjects.iterator_0(); object$iterator.hasNext_0();){
        object = object$iterator.next_1();
        t = $copy_1(this$static, castTo(object, 57));
        !!t && push_1(result.array, t);
    }
    return result;
}
function $copyAttribute(this$static, eAttribute, eObject, copyEObject) {
    var featureMap, setting, targetEStructuralFeature;
    if (eObject.eIsSet_0(eAttribute)) {
        $clinit_FeatureMapUtil();
        if ($isFeatureMap(eAttribute)) {
            featureMap = castTo(eObject.eGet_0(eAttribute), 159);
            $copyFeatureMap(this$static, featureMap);
        } else {
            setting = (targetEStructuralFeature = eAttribute, !targetEStructuralFeature ? null : castTo(copyEObject, 52).eSetting(targetEStructuralFeature));
            !!setting && $copyAttributeValue(eObject.eGet_0(eAttribute), setting);
        }
    }
}
function $copyAttributeValue(value_0, setting) {
    setting.set_1(value_0);
}
function $copyContainment(this$static, eReference, eObject, copyEObject) {
    var setting, target, targetEStructuralFeature, upper, value_0;
    if (eObject.eIsSet_0(eReference)) {
        setting = (targetEStructuralFeature = eReference, !targetEStructuralFeature ? null : castTo(copyEObject, 52).eSetting(targetEStructuralFeature));
        if (setting) {
            value_0 = eObject.eGet_0(eReference);
            upper = eReference.upperBound;
            if (upper > 1 || upper == -1) {
                target = castTo(value_0, 15);
                setting.set_1($copyAll(this$static, target));
            } else setting.set_1($copy_1(this$static, castTo(value_0, 57)));
        }
    }
}
function $copyFeatureMap(this$static, featureMap) {
    var feature, i, size_0, value_0;
    for(i = 0, size_0 = featureMap.size_1(); i < size_0; ++i){
        feature = featureMap.getEStructuralFeature_0(i);
        if (instanceOf(feature, 101) && (castTo(feature, 19).eFlags & $intern_137) != 0) {
            value_0 = featureMap.getValue_1(i);
            value_0 != null && $copy_1(this$static, castTo(value_0, 57));
        }
    }
}
function $copyReference(this$static, eReference, eObject, copyEObject) {
    var copyReferencedEObject, index_0, isBidirectional, k, position, referencedEObject, setting, source, target, targetEStructuralFeature, upper, value_0;
    if (eObject.eIsSet_0(eReference)) {
        setting = (targetEStructuralFeature = eReference, !targetEStructuralFeature ? null : castTo(copyEObject, 52).eSetting(targetEStructuralFeature));
        if (setting) {
            value_0 = eObject.eGet_1(eReference, this$static.resolveProxies);
            upper = eReference.upperBound;
            if (upper > 1 || upper == -1) {
                source = castTo(value_0, 71);
                target = castTo(setting, 71);
                if (source.isEmpty()) target.clear_0();
                else {
                    isBidirectional = !!$getEOpposite(eReference);
                    index_0 = 0;
                    for(k = this$static.resolveProxies ? source.iterator_0() : source.basicIterator(); k.hasNext_0();){
                        referencedEObject = castTo(k.next_1(), 57);
                        copyReferencedEObject = castTo($get_16(this$static, referencedEObject), 57);
                        if (!copyReferencedEObject) {
                            if (this$static.useOriginalReferences && !isBidirectional) {
                                target.addUnique(index_0, referencedEObject);
                                ++index_0;
                            }
                        } else {
                            if (isBidirectional) {
                                position = target.indexOf_0(copyReferencedEObject);
                                position == -1 ? target.addUnique(index_0, copyReferencedEObject) : index_0 != position && target.move_0(index_0, copyReferencedEObject);
                            } else target.addUnique(index_0, copyReferencedEObject);
                            ++index_0;
                        }
                    }
                }
            } else if (value_0 == null) setting.set_1(null);
            else {
                copyReferencedEObject = $get_16(this$static, value_0);
                copyReferencedEObject == null ? this$static.useOriginalReferences && !$getEOpposite(eReference) && setting.set_1(value_0) : setting.set_1(copyReferencedEObject);
            }
        }
    }
}
function $copyReferences(this$static) {
    var copyEObject, copyFeatureMap, copyFeatureMapSize, copyReferencedEObject, eAllStructuralFeaturesData, eClass, eObject, eReference, eStructuralFeature, entry, entry$iterator, feature, featureMap, featureMapSize, j, k, l, reference, referencedEObject, size_0, targetEStructuralFeature, theOpposite;
    for(entry$iterator = new LinkedHashMap$EntrySet$EntryIterator(new LinkedHashMap$EntrySet(this$static)); entry$iterator.next_0 != entry$iterator.this$11.this$01.head;){
        entry = $next_8(entry$iterator);
        eObject = castTo(entry.key, 57);
        copyEObject = castTo(entry.value_0, 57);
        eClass = eObject.eClass_0();
        for(j = 0, size_0 = (eClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(eClass), eClass.eAllStructuralFeaturesData).length; j < size_0; ++j){
            eStructuralFeature = (eAllStructuralFeaturesData = (eClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(eClass), eClass.eAllStructuralFeaturesData), j >= 0 && j < eAllStructuralFeaturesData.length ? eAllStructuralFeaturesData[j] : null);
            if (eStructuralFeature.isChangeable() && !eStructuralFeature.isDerived()) {
                if (instanceOf(eStructuralFeature, 101)) {
                    eReference = castTo(eStructuralFeature, 19);
                    (eReference.eFlags & $intern_137) == 0 && (theOpposite = $getEOpposite(eReference), !(!!theOpposite && (theOpposite.eFlags & $intern_137) != 0)) && $copyReference(this$static, eReference, eObject, copyEObject);
                } else {
                    $clinit_FeatureMapUtil();
                    if (castTo(eStructuralFeature, 69).isFeatureMap_0()) {
                        copyFeatureMap = (targetEStructuralFeature = eStructuralFeature, castTo(!targetEStructuralFeature ? null : castTo(copyEObject, 52).eSetting(targetEStructuralFeature), 159));
                        if (copyFeatureMap) {
                            featureMap = castTo(eObject.eGet_0(eStructuralFeature), 159);
                            copyFeatureMapSize = copyFeatureMap.size_1();
                            for(k = 0, featureMapSize = featureMap.size_1(); k < featureMapSize; ++k){
                                feature = featureMap.getEStructuralFeature_0(k);
                                if (instanceOf(feature, 101)) {
                                    referencedEObject = featureMap.getValue_1(k);
                                    copyReferencedEObject = $get_16(this$static, referencedEObject);
                                    if (copyReferencedEObject == null && referencedEObject != null) {
                                        reference = castTo(feature, 19);
                                        if (!this$static.useOriginalReferences || (reference.eFlags & $intern_137) != 0 || !!$getEOpposite(reference)) continue;
                                        copyReferencedEObject = referencedEObject;
                                    }
                                    if (!copyFeatureMap.add_6(feature, copyReferencedEObject)) {
                                        for(l = 0; l < copyFeatureMapSize; ++l)if (copyFeatureMap.getEStructuralFeature_0(l) == feature && maskUndefined(copyFeatureMap.getValue_1(l)) === maskUndefined(copyReferencedEObject)) {
                                            copyFeatureMap.move(copyFeatureMap.size_1() - 1, l);
                                            --copyFeatureMapSize;
                                            break;
                                        }
                                    }
                                } else copyFeatureMap.add_6(featureMap.getEStructuralFeature_0(k), featureMap.getValue_1(k));
                            }
                        }
                    }
                }
            }
        }
    }
}
function EcoreUtil$Copier() {
    LinkedHashMap.call(this);
    this.resolveProxies = true;
    this.useOriginalReferences = true;
}
defineClass(1153, 221, $intern_76, EcoreUtil$Copier);
_.resolveProxies = false;
_.useOriginalReferences = false;
var Lorg_eclipse_emf_ecore_util_EcoreUtil$Copier_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreUtil/Copier', 1153);
function $hasNext_9(this$static) {
    if (this$static.preparedResult == null) {
        while(this$static.iterator.hasNext_0()){
            this$static.preparedResult = this$static.iterator.next_1();
            if (!castTo(this$static.preparedResult, 52).eDirectResource()) return true;
        }
        this$static.preparedResult = null;
        return false;
    } else return true;
}
function EcoreUtil$ProperContentIterator(eObject) {
    var contents;
    contents = eObject.eContents_0();
    this.iterator = instanceOf(contents, 71) ? castTo(contents, 71).basicIterator() : contents.iterator_0();
}
defineClass(742, 1, $intern_6, EcoreUtil$ProperContentIterator);
_.forEachRemaining = function forEachRemaining_60(consumer) {
    $forEachRemaining(this, consumer);
};
_.hasNext_0 = function hasNext_51() {
    return $hasNext_9(this);
};
_.next_1 = function next_50() {
    var result;
    $hasNext_9(this);
    result = this.preparedResult;
    this.preparedResult = null;
    return result;
};
_.remove = function remove_130() {
    this.iterator.remove();
};
var Lorg_eclipse_emf_ecore_util_EcoreUtil$ProperContentIterator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreUtil/ProperContentIterator', 742);
function $clinit_EcoreValidator() {
    $clinit_EcoreValidator = emptyMethod;
    $clinit_EObjectValidator();
    INSTANCE_10 = new EcoreValidator;
}
function EcoreValidator() {
    $clinit_XMLTypeValidator();
}
defineClass(1468, 1467, {}, EcoreValidator);
var INSTANCE_10;
var Lorg_eclipse_emf_ecore_util_EcoreValidator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'EcoreValidator', 1468);
function $clinit_FeatureMapUtil() {
    $clinit_FeatureMapUtil = emptyMethod;
    NULL_VALIDATOR = new FeatureMapUtil$1;
}
function createEntry_5(eStructuralFeature, value_0) {
    $clinit_FeatureMapUtil();
    var prototype_0;
    prototype_0 = castTo(eStructuralFeature, 69).getFeatureMapEntryPrototype();
    $validate_2(prototype_0, value_0);
    return prototype_0.createEntry(value_0);
}
function getValidator(containingClass, eStructuralFeature) {
    $clinit_FeatureMapUtil();
    var extendedMetaData, holder, result, validatorMap;
    if (!eStructuralFeature) return NULL_VALIDATOR;
    else if (eStructuralFeature == ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__MIXED) || (eStructuralFeature == ANY_TYPE__MIXED || eStructuralFeature == ANY_TYPE__ANY || eStructuralFeature == ANY_TYPE__ANY_ATTRIBUTE) && containingClass != ANY_TYPE) return new FeatureMapUtil$BasicValidator(containingClass, eStructuralFeature);
    else {
        holder = castTo(eStructuralFeature, 677);
        extendedMetaData = holder.getExtendedMetaData_0();
        if (!extendedMetaData) {
            $getName_0($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), eStructuralFeature));
            extendedMetaData = holder.getExtendedMetaData_0();
        }
        validatorMap = (!extendedMetaData.validatorMap && (extendedMetaData.validatorMap = new HashMap), extendedMetaData.validatorMap);
        result = castTo(getEntryValueOrNull($getEntry_0(validatorMap.hashCodeMap, containingClass)), 1987);
        !result && $put_6(validatorMap, containingClass, result = new FeatureMapUtil$BasicValidator(containingClass, eStructuralFeature));
        return result;
    }
}
function isMany_1(owner, feature) {
    $clinit_FeatureMapUtil();
    var affiliation, affiliationUpperBound, eClass;
    if (feature.isMany()) return true;
    else if (feature.getUpperBound() == -2) {
        if (feature == ($clinit_XMLTypeFeatures(), TEXT) || feature == CDATA || feature == COMMENT || feature == PROCESSING_INSTRUCTION) return true;
        else {
            eClass = owner.eClass_0();
            if ($getFeatureID(eClass, feature) >= 0) return false;
            else {
                affiliation = $getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), eClass, feature);
                if (!affiliation) return true;
                else {
                    affiliationUpperBound = affiliation.getUpperBound();
                    return (affiliationUpperBound > 1 || affiliationUpperBound == -1) && $getFeatureKind($getExtendedMetaData_1(INSTANCE_11, affiliation)) != 3;
                }
            }
        }
    } else return false;
}
var NULL_VALIDATOR;
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$Validator_2_classLit = createForInterface('org.eclipse.emf.ecore.util', 'FeatureMapUtil/Validator');
function FeatureMapUtil$1() {}
defineClass(1248, 1, {
    1987: 1
}, FeatureMapUtil$1);
_.isValid = function isValid_2(eStructuralFeature) {
    return true;
};
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$1_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/1', 1248);
function $clinit_FeatureMapUtil$BasicValidator() {
    $clinit_FeatureMapUtil$BasicValidator = emptyMethod;
    ANY_WILDCARD = ($clinit_Collections(), new Collections$SingletonList('##any'));
}
function $isIncluded(this$static, feature) {
    var featureKind;
    if (this$static.wildcards == ANY_WILDCARD) {
        featureKind = $getFeatureKind($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), feature));
        return this$static.isElement ? featureKind == 4 && feature != ($clinit_XMLTypeFeatures(), TEXT) && feature != ($clinit_XMLTypeFeatures(), CDATA) && feature != ($clinit_XMLTypeFeatures(), COMMENT) && feature != ($clinit_XMLTypeFeatures(), PROCESSING_INSTRUCTION) : featureKind == 2;
    }
    if (!!this$static.groupMembers && (this$static.groupMembers.contains(feature) || this$static.groupMembers.contains($getGroup($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), feature))) || this$static.groupMembers.contains($getAffiliation(($clinit_ExtendedMetaData(), INSTANCE_11), this$static.containingClass, feature)))) return true;
    if (this$static.wildcards) {
        if ($matches(($clinit_ExtendedMetaData(), this$static.wildcards), $getNamespace_0($getExtendedMetaData_1(INSTANCE_11, feature)))) {
            featureKind = $getFeatureKind($getExtendedMetaData_1(INSTANCE_11, feature));
            return this$static.isElement ? featureKind == 4 : featureKind == 2;
        }
    }
    return false;
}
function FeatureMapUtil$BasicValidator(containingClass, eStructuralFeature) {
    $clinit_FeatureMapUtil$BasicValidator();
    var eAllStructuralFeaturesData, feature, feature$iterator, group, i, mixedFeature, size_0;
    this.cache = new FeatureMapUtil$BasicValidator$Cache(this);
    this.containingClass = containingClass;
    this.eStructuralFeature = eStructuralFeature;
    this.wildcards = $getWildcards($getExtendedMetaData_1(($clinit_ExtendedMetaData(), INSTANCE_11), eStructuralFeature));
    if (this.wildcards.isEmpty()) {
        if ((mixedFeature = $getMixedFeature(INSTANCE_11, containingClass)) == eStructuralFeature) {
            this.isElement = true;
            this.groupMembers = new ArrayList;
            this.wildcards = new UniqueEList;
            this.wildcards.add_2('http://www.eclipse.org/emf/2003/XMLType');
            castTo($getType_1($getExtendedMetaData_0(INSTANCE_11, $getEPackage(containingClass)), ''), 29) == containingClass && this.wildcards.add_2($getNamespace(INSTANCE_11, $getEPackage(containingClass)));
            for(feature$iterator = $getAllElements(INSTANCE_11, containingClass).iterator_0(); feature$iterator.hasNext_0();){
                feature = castTo(feature$iterator.next_1(), 178);
                switch($getFeatureKind($getExtendedMetaData_1(INSTANCE_11, feature))){
                    case 4:
                        this.groupMembers.add_2(feature);
                        break;
                    case 5:
                        this.wildcards.addAll($getWildcards($getExtendedMetaData_1(INSTANCE_11, feature)));
                        break;
                }
            }
        } else {
            $clinit_FeatureMapUtil();
            if (castTo(eStructuralFeature, 69).isFeatureMap_0()) {
                this.isElement = true;
                this.wildcards = null;
                this.groupMembers = new ArrayList;
                for(i = 0, size_0 = (containingClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(containingClass), containingClass.eAllStructuralFeaturesData).length; i < size_0; ++i){
                    feature = (eAllStructuralFeaturesData = (containingClass.eAllStructuralFeaturesData == null && $getEAllStructuralFeatures(containingClass), containingClass.eAllStructuralFeaturesData), i >= 0 && i < eAllStructuralFeaturesData.length ? eAllStructuralFeaturesData[i] : null);
                    for(group = $getGroup($getExtendedMetaData_1(INSTANCE_11, feature)); group; group = $getGroup($getExtendedMetaData_1(INSTANCE_11, group)))group == eStructuralFeature && this.groupMembers.add_2(feature);
                }
            } else if ($getFeatureKind($getExtendedMetaData_1(INSTANCE_11, eStructuralFeature)) == 1 && !!mixedFeature) {
                this.wildcards = null;
                this.groupMembers = ($clinit_XMLTypeFeatures(), TEXTUAL_FEATURES);
            } else {
                this.wildcards = null;
                this.isElement = true;
                this.groupMembers = ($clinit_Collections(), new Collections$SingletonList(eStructuralFeature));
            }
        }
    } else {
        this.isElement = $getFeatureKind($getExtendedMetaData_1(INSTANCE_11, eStructuralFeature)) == 5;
        this.wildcards.equals_0(ANY_WILDCARD) && (this.wildcards = ANY_WILDCARD);
    }
}
defineClass(755, 1, {
    1987: 1
}, FeatureMapUtil$BasicValidator);
_.isValid = function isValid_3(feature) {
    var result;
    if (this.eStructuralFeature == feature) return true;
    result = castToBoolean($get_10(this.cache, feature));
    if (result == null) {
        if ($isIncluded(this, feature)) {
            $put_16(this.cache, feature, ($clinit_Boolean(), TRUE_0));
            return true;
        } else {
            $put_16(this.cache, feature, ($clinit_Boolean(), FALSE_0));
            return false;
        }
    } else return result == ($clinit_Boolean(), TRUE_0);
};
_.isElement = false;
var ANY_WILDCARD;
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$BasicValidator_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/BasicValidator', 755);
function $put_16(this$static, eStructuralFeature, isValid) {
    var newCache;
    newCache = new FeatureMapUtil$BasicValidator$Cache(this$static.this$11);
    $putAll(newCache, this$static.this$11.cache);
    $put_9(newCache.hashCodeMap, eStructuralFeature, isValid);
    this$static.this$11.cache = newCache;
}
function FeatureMapUtil$BasicValidator$Cache(this$1) {
    this.this$11 = this$1;
    HashMap.call(this);
}
defineClass(756, 45, $intern_76, FeatureMapUtil$BasicValidator$Cache);
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$BasicValidator$Cache_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/BasicValidator/Cache', 756);
function $addAll_14(this$static, collection) {
    return $addAll_13(this$static.featureMap, this$static.feature, collection);
}
function $basicRemove_4(this$static, object, notifications) {
    return $basicRemove_3(this$static.featureMap, this$static.feature, object, notifications);
}
function $clear_16(this$static) {
    $clear_15(this$static.featureMap, this$static.feature);
}
function $isEmpty_1(this$static) {
    return $isEmpty_0(this$static.featureMap, this$static.feature);
}
function FeatureMapUtil$FeatureEList(feature, featureMap) {
    this.feature = feature;
    this.featureMap = featureMap;
}
defineClass(493, 55, {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    61: 1,
    76: 1,
    71: 1,
    96: 1
}, FeatureMapUtil$FeatureEList);
_.add_3 = function add_70(index_0, object) {
    $add_32(this.featureMap, this.feature, index_0, object);
};
_.add_2 = function add_71(object) {
    return $add_33(this.featureMap, this.feature, object);
};
_.addAll_0 = function addAll_36(index_0, collection) {
    return $addAll_12(this.featureMap, this.feature, index_0, collection);
};
_.addAll = function addAll_37(collection) {
    return $addAll_14(this, collection);
};
_.addUnique = function addUnique_20(index_0, object) {
    $addUnique_11(this.featureMap, this.feature, index_0, object);
};
_.basicAdd = function basicAdd_5(object, notifications) {
    return $basicAdd_2(this.featureMap, this.feature, object, notifications);
};
_.basicGet = function basicGet_6(index_0) {
    return $get_23(this.featureMap, this.feature, index_0, false);
};
_.basicIterator = function basicIterator_7() {
    return $basicIterator(this.featureMap, this.feature);
};
_.basicListIterator = function basicListIterator_15() {
    return $basicListIterator_0(this.featureMap, this.feature);
};
_.basicListIterator_0 = function basicListIterator_16(index_0) {
    return $basicListIterator_1(this.featureMap, this.feature, index_0);
};
_.basicRemove = function basicRemove_6(object, notifications) {
    return $basicRemove_4(this, object, notifications);
};
_.clear_0 = function clear_66() {
    $clear_16(this);
};
_.contains = function contains_66(object) {
    return $contains_12(this.featureMap, this.feature, object);
};
_.containsAll = function containsAll_15(collection) {
    return $containsAll_1(this.featureMap, this.feature, collection);
};
_.get_0 = function get_67(index_0) {
    return $get_23(this.featureMap, this.feature, index_0, true);
};
_.get_6 = function get_68(resolve) {
    return this;
};
_.indexOf_0 = function indexOf_18(object) {
    return $indexOf_7(this.featureMap, this.feature, object);
};
_.isEmpty = function isEmpty_34() {
    return $isEmpty_1(this);
};
_.isSet_0 = function isSet_20() {
    return !$isEmpty_0(this.featureMap, this.feature);
};
_.iterator_0 = function iterator_90() {
    return $iterator_2(this.featureMap, this.feature);
};
_.listIterator_0 = function listIterator_33() {
    return $listIterator_3(this.featureMap, this.feature);
};
_.listIterator_1 = function listIterator_34(index_0) {
    return $listIterator_4(this.featureMap, this.feature, index_0);
};
_.move = function move_21(targetIndex, sourceIndex) {
    return $move_6(this.featureMap, this.feature, targetIndex, sourceIndex);
};
_.move_0 = function move_22(index_0, object) {
    $move_7(this.featureMap, this.feature, index_0, object);
};
_.remove_2 = function remove_131(index_0) {
    return $remove_43(this.featureMap, this.feature, index_0);
};
_.remove_1 = function remove_132(object) {
    return $remove_44(this.featureMap, this.feature, object);
};
_.set_2 = function set_41(index_0, object) {
    return $set_16(this.featureMap, this.feature, index_0, object);
};
_.set_1 = function set_42(newValue) {
    $clear_15(this.featureMap, this.feature);
    $addAll_14(this, castTo(newValue, 15));
};
_.size_1 = function size_81() {
    return $size_3(this.featureMap, this.feature);
};
_.toArray = function toArray_42() {
    return $toArray_11(this.featureMap, this.feature);
};
_.toArray_0 = function toArray_43(array) {
    return $toArray_13(this.featureMap, this.feature, array);
};
_.toString_0 = function toString_155() {
    var i, stringBuffer;
    stringBuffer = new StringBuffer;
    stringBuffer.string += '[';
    for(i = $basicIterator(this.featureMap, this.feature); $hasNext_8(i);){
        $append_3(stringBuffer, valueOf_6($next_15(i)));
        $hasNext_8(i) && (stringBuffer.string += ', ', stringBuffer);
    }
    stringBuffer.string += ']';
    return stringBuffer.string;
};
_.unset = function unset_16() {
    $clear_15(this.featureMap, this.feature);
};
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$FeatureEList_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/FeatureEList', 493);
function $getFeatureID_0(this$static, expectedClass) {
    var containerClass;
    if (this$static.featureID == -1 && !!this$static.feature) {
        containerClass = this$static.feature.getContainerClass();
        this$static.featureID = !containerClass ? $getFeatureID(this$static.notifier.eClass_0(), this$static.feature) : this$static.notifier.eDerivedStructuralFeatureID(this$static.feature.getFeatureID_0(), containerClass);
    }
    return this$static.notifier.eBaseStructuralFeatureID(this$static.featureID, expectedClass);
}
function FeatureMapUtil$FeatureENotificationImpl(owner, eventType, feature, oldObject, newObject, index_0, wasSet) {
    NotificationImpl_2.call(this, eventType, oldObject, newObject, index_0, wasSet);
    this.notifier = owner;
    this.feature = feature;
}
defineClass(629, 38, $intern_144, FeatureMapUtil$FeatureENotificationImpl);
_.getFeatureID = function getFeatureID_14(expectedClass) {
    return $getFeatureID_0(this, expectedClass);
};
_.merge = function merge_1(notification) {
    var addedValues, collection, newPositions, notificationEventType, notificationNotifier, positions, removedValues;
    switch(this.eventType){
        case 1:
        case 2:
            notificationNotifier = notification.getNotifier();
            if (maskUndefined(notificationNotifier) === maskUndefined(this.notifier) && $getFeatureID_0(this, null) == notification.getFeatureID(null)) {
                this.newValue = notification.getNewValue();
                notification.getEventType() == 1 && (this.eventType = 1);
                return true;
            }
            break;
        case 3:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 3:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.notifier) && $getFeatureID_0(this, null) == notification.getFeatureID(null)) {
                        this.eventType = 5;
                        addedValues = new BasicEList_0(2);
                        $add_21(addedValues, this.newValue);
                        $add_21(addedValues, notification.getNewValue());
                        this.newValue = addedValues;
                        return true;
                    }
                    break;
            }
            break;
        case 5:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 3:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.notifier) && $getFeatureID_0(this, null) == notification.getFeatureID(null)) {
                        collection = castTo(this.newValue, 16);
                        collection.add_2(notification.getNewValue());
                        return true;
                    }
                    break;
            }
            break;
        case 4:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 3:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.notifier) && $getFeatureID_0(this, null) == notification.getFeatureID(null)) {
                        this.eventType = 1;
                        this.newValue = notification.getNewValue();
                        return true;
                    }
                    break;
                case 4:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.notifier) && $getFeatureID_0(this, null) == notification.getFeatureID(null)) {
                        this.eventType = 6;
                        removedValues = new BasicEList_0(2);
                        $add_21(removedValues, this.oldValue);
                        $add_21(removedValues, notification.getOldValue());
                        this.oldValue = removedValues;
                        positions = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
                            this.position,
                            notification.getPosition_0()
                        ]);
                        this.newValue = positions;
                        return true;
                    }
                    break;
            }
            break;
        case 6:
            notificationEventType = notification.getEventType();
            switch(notificationEventType){
                case 4:
                    notificationNotifier = notification.getNotifier();
                    if (maskUndefined(notificationNotifier) === maskUndefined(this.notifier) && $getFeatureID_0(this, null) == notification.getFeatureID(null)) {
                        collection = castTo(this.oldValue, 16);
                        collection.add_2(notification.getOldValue());
                        positions = castTo(this.newValue, 54);
                        newPositions = initUnidimensionalArray(I_classLit, $intern_48, 30, positions.length + 1, 15, 1);
                        arraycopy(positions, 0, newPositions, 0, positions.length);
                        newPositions[positions.length] = notification.getPosition_0();
                        this.newValue = newPositions;
                        return true;
                    }
                    break;
            }
            break;
    }
    return false;
};
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$FeatureENotificationImpl_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/FeatureENotificationImpl', 629);
function FeatureMapUtil$FeatureFeatureMap(feature, featureMap) {
    FeatureMapUtil$FeatureEList.call(this, feature, featureMap);
    this.wrapper = this;
}
defineClass(549, 493, {
    20: 1,
    31: 1,
    55: 1,
    16: 1,
    15: 1,
    61: 1,
    76: 1,
    159: 1,
    218: 1,
    1982: 1,
    71: 1,
    96: 1
}, FeatureMapUtil$FeatureFeatureMap);
_.add_6 = function add_72(feature, value_0) {
    return $add_33(this.featureMap, feature, value_0);
};
_.basicAdd_0 = function basicAdd_6(feature, object, notifications) {
    return $basicAdd_2(this.featureMap, feature, object, notifications);
};
_.basicRemove_0 = function basicRemove_7(feature, object, notifications) {
    return $basicRemove_3(this.featureMap, feature, object, notifications);
};
_.featureMap_0 = function featureMap_1() {
    return this;
};
_.get_7 = function get_69(feature, resolve) {
    return $get_24(this.featureMap, feature, resolve);
};
_.getEStructuralFeature_0 = function getEStructuralFeature_4(index_0) {
    return castTo($get_23(this.featureMap, this.feature, index_0, false), 74).getEStructuralFeature();
};
_.getValue_1 = function getValue_20(index_0) {
    return castTo($get_23(this.featureMap, this.feature, index_0, false), 74).getValue();
};
_.getWrapper = function getWrapper_0() {
    return this.wrapper;
};
_.isSet_1 = function isSet_21(feature) {
    return !$isEmpty_0(this.featureMap, feature);
};
_.set_3 = function set_43(feature, object) {
    $set_17(this.featureMap, feature, object);
};
_.setting = function setting_1(feature) {
    return $setting(this.featureMap, feature);
};
_.unset_0 = function unset_17(feature) {
    $unset(this.featureMap, feature);
};
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$FeatureFeatureMap_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/FeatureFeatureMap', 549);
function FeatureMapUtil$FeatureValue(feature, featureMap) {
    this.feature = feature;
    this.featureMap = featureMap;
}
defineClass(1247, 1, $intern_150, FeatureMapUtil$FeatureValue);
_.get_6 = function get_70(resolve) {
    return $get_23(this.featureMap, this.feature, -1, resolve);
};
_.isSet_0 = function isSet_22() {
    return !$isEmpty_0(this.featureMap, this.feature);
};
_.set_1 = function set_44(newValue) {
    $set_17(this.featureMap, this.feature, newValue);
};
_.unset = function unset_18() {
    $clear_15(this.featureMap, this.feature);
};
var Lorg_eclipse_emf_ecore_util_FeatureMapUtil$FeatureValue_2_classLit = createForClass('org.eclipse.emf.ecore.util', 'FeatureMapUtil/FeatureValue', 1247);
function $clinit_XMLTypeFeatures() {
    $clinit_XMLTypeFeatures = emptyMethod;
    TEXT = castTo($get_20($getEStructuralFeatures(($clinit_XMLTypePackage(), eINSTANCE_4).xmlTypeDocumentRootEClass), 6), 35);
    CDATA = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 3), 35);
    COMMENT = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 4), 35);
    PROCESSING_INSTRUCTION = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 5), 19);
    $getFeatureMapEntryPrototype(TEXT);
    $getFeatureMapEntryPrototype(CDATA);
    $getFeatureMapEntryPrototype(COMMENT);
    $getFeatureMapEntryPrototype(PROCESSING_INSTRUCTION);
    TEXTUAL_FEATURES = new Arrays$ArrayList(stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EStructuralFeature_2_classLit, 1), $intern_153, 178, 0, [
        TEXT,
        CDATA
    ]));
}
var CDATA, COMMENT, PROCESSING_INSTRUCTION, TEXT, TEXTUAL_FEATURES;
var Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit = createForInterface('org.eclipse.emf.ecore.xml.type', 'AnyType');
function InvalidDatatypeValueException(reason) {
    RuntimeException_0.call(this, reason);
}
defineClass(665, 63, $intern_43, InvalidDatatypeValueException);
var Lorg_eclipse_emf_ecore_xml_type_InvalidDatatypeValueException_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type', 'InvalidDatatypeValueException', 665);
var Lorg_eclipse_emf_ecore_xml_type_ProcessingInstruction_2_classLit = createForInterface('org.eclipse.emf.ecore.xml.type', 'ProcessingInstruction');
var Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit = createForInterface('org.eclipse.emf.ecore.xml.type', 'SimpleAnyType');
var Lorg_eclipse_emf_ecore_xml_type_XMLTypeDocumentRoot_2_classLit = createForInterface('org.eclipse.emf.ecore.xml.type', 'XMLTypeDocumentRoot');
function $clinit_XMLTypeFactory() {
    $clinit_XMLTypeFactory = emptyMethod;
    eINSTANCE_3 = init_5();
}
var eINSTANCE_3;
function $clinit_XMLTypePackage() {
    $clinit_XMLTypePackage = emptyMethod;
    eINSTANCE_4 = init_6();
}
var eINSTANCE_4;
function $clinit_XMLTypePackage$Literals() {
    $clinit_XMLTypePackage$Literals = emptyMethod;
    ANY_TYPE = ($clinit_XMLTypePackage(), eINSTANCE_4).anyTypeEClass;
    ANY_TYPE__MIXED = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.anyTypeEClass), 0), 35);
    ANY_TYPE__ANY = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.anyTypeEClass), 1), 35);
    ANY_TYPE__ANY_ATTRIBUTE = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.anyTypeEClass), 2), 35);
    PROCESSING_INSTRUCTION_0 = eINSTANCE_4.processingInstructionEClass;
    castTo($get_20($getEStructuralFeatures(eINSTANCE_4.processingInstructionEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_4.processingInstructionEClass), 1), 35);
    SIMPLE_ANY_TYPE = eINSTANCE_4.simpleAnyTypeEClass;
    SIMPLE_ANY_TYPE__RAW_VALUE = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.simpleAnyTypeEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_4.simpleAnyTypeEClass), 1), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_4.simpleAnyTypeEClass), 2), 19);
    XML_TYPE_DOCUMENT_ROOT = eINSTANCE_4.xmlTypeDocumentRootEClass;
    XML_TYPE_DOCUMENT_ROOT__MIXED = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 0), 35);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 1), 19);
    castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 2), 19);
    XML_TYPE_DOCUMENT_ROOT__CDATA = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 3), 35);
    XML_TYPE_DOCUMENT_ROOT__COMMENT = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 4), 35);
    XML_TYPE_DOCUMENT_ROOT__TEXT = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 6), 35);
    XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION = castTo($get_20($getEStructuralFeatures(eINSTANCE_4.xmlTypeDocumentRootEClass), 5), 19);
    DATE = eINSTANCE_4.dateEDataType;
    DATE_TIME = eINSTANCE_4.dateTimeEDataType;
    DURATION = eINSTANCE_4.durationEDataType;
    GDAY = eINSTANCE_4.gDayEDataType;
    GMONTH = eINSTANCE_4.gMonthEDataType;
    GMONTH_DAY = eINSTANCE_4.gMonthDayEDataType;
    GYEAR = eINSTANCE_4.gYearEDataType;
    GYEAR_MONTH = eINSTANCE_4.gYearMonthEDataType;
    NOTATION = eINSTANCE_4.notationEDataType;
    QNAME = eINSTANCE_4.qNameEDataType;
    TIME = eINSTANCE_4.timeEDataType;
}
var ANY_TYPE, ANY_TYPE__ANY, ANY_TYPE__ANY_ATTRIBUTE, ANY_TYPE__MIXED, DATE, DATE_TIME, DURATION, GDAY, GMONTH, GMONTH_DAY, GYEAR, GYEAR_MONTH, NOTATION, PROCESSING_INSTRUCTION_0, QNAME, SIMPLE_ANY_TYPE, SIMPLE_ANY_TYPE__RAW_VALUE, TIME, XML_TYPE_DOCUMENT_ROOT, XML_TYPE_DOCUMENT_ROOT__CDATA, XML_TYPE_DOCUMENT_ROOT__COMMENT, XML_TYPE_DOCUMENT_ROOT__MIXED, XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION, XML_TYPE_DOCUMENT_ROOT__TEXT;
function AnyTypeImpl() {
    EObjectImpl.call(this);
}
defineClass(823, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    836: 1
}, AnyTypeImpl);
_.eGet = function eGet_32(featureID, resolve, coreType) {
    switch(featureID){
        case 0:
            if (coreType) return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), this.mixed;
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), this.mixed.wrapper;
        case 1:
            if (coreType) return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159);
            return (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo(castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159), 218)).getWrapper();
        case 2:
            if (coreType) return !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2)), this.anyAttribute;
            return !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2)), this.anyAttribute.wrapper;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((this.eFlags & 2) == 0 ? this.eStaticClass() : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), resolve, coreType);
};
_.eInverseRemove_0 = function eInverseRemove_23(otherEnd, featureID, msgs) {
    var feature;
    switch(featureID){
        case 0:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $basicRemove_2(this.mixed, otherEnd, msgs);
        case 1:
            return (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo(castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159), 71)).basicRemove(otherEnd, msgs);
        case 2:
            return !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2)), $basicRemove_2(this.anyAttribute, otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((this.eFlags & 2) == 0 ? this.eStaticClass() : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings(this), featureID - $getFeatureCount(this.eStaticClass()), otherEnd, msgs);
};
_.eIsSet = function eIsSet_31(featureID) {
    switch(featureID){
        case 0:
            return !!this.mixed && this.mixed.size_0 != 0;
        case 1:
            return !(!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159)).isEmpty();
        case 2:
            return !!this.anyAttribute && this.anyAttribute.size_0 != 0;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((this.eFlags & 2) == 0 ? this.eStaticClass() : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.eSet = function eSet_29(featureID, newValue) {
    switch(featureID){
        case 0:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $set_15(this.mixed, newValue);
            return;
        case 1:
            (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo(castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159), 218)).set_1(newValue);
            return;
        case 2:
            !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2));
            $set_15(this.anyAttribute, newValue);
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((this.eFlags & 2) == 0 ? this.eStaticClass() : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), newValue);
};
_.eStaticClass = function eStaticClass_31() {
    return $clinit_XMLTypePackage$Literals(), ANY_TYPE;
};
_.eUnset = function eUnset_29(featureID) {
    switch(featureID){
        case 0:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_13(this.mixed);
            return;
        case 1:
            (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159)).clear_0();
            return;
        case 2:
            !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2));
            $clear_13(this.anyAttribute);
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(this.eStaticClass()), $getEStructuralFeature((this.eFlags & 2) == 0 ? this.eStaticClass() : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.toString_0 = function toString_156() {
    var result;
    if ((this.eFlags & 4) != 0) return $toString_16(this);
    result = new StringBuffer_1($toString_16(this));
    result.string += ' (mixed: ';
    $append_2(result, this.mixed);
    result.string += ', anyAttribute: ';
    $append_2(result, this.anyAttribute);
    result.string += ')';
    return result.string;
};
var Lorg_eclipse_emf_ecore_xml_type_impl_AnyTypeImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'AnyTypeImpl', 823);
function $setData_0(this$static, newData) {
    this$static.data_0 = newData;
}
function $setTarget_2(this$static, newTarget) {
    this$static.target = newTarget;
}
function ProcessingInstructionImpl() {}
defineClass(666, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    2065: 1,
    666: 1
}, ProcessingInstructionImpl);
_.eGet = function eGet_33(featureID, resolve, coreType) {
    switch(featureID){
        case 0:
            return this.data_0;
        case 1:
            return this.target;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), PROCESSING_INSTRUCTION_0)), $getEStructuralFeature((this.eFlags & 2) == 0 ? PROCESSING_INSTRUCTION_0 : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_32(featureID) {
    switch(featureID){
        case 0:
            return this.data_0 != null;
        case 1:
            return this.target != null;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), PROCESSING_INSTRUCTION_0)), $getEStructuralFeature((this.eFlags & 2) == 0 ? PROCESSING_INSTRUCTION_0 : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.eSet = function eSet_30(featureID, newValue) {
    switch(featureID){
        case 0:
            $setData_0(this, castToString(newValue));
            return;
        case 1:
            $setTarget_2(this, castToString(newValue));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), PROCESSING_INSTRUCTION_0)), $getEStructuralFeature((this.eFlags & 2) == 0 ? PROCESSING_INSTRUCTION_0 : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), newValue);
};
_.eStaticClass = function eStaticClass_32() {
    return $clinit_XMLTypePackage$Literals(), PROCESSING_INSTRUCTION_0;
};
_.eUnset = function eUnset_30(featureID) {
    switch(featureID){
        case 0:
            this.data_0 = null;
            return;
        case 1:
            this.target = null;
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), PROCESSING_INSTRUCTION_0)), $getEStructuralFeature((this.eFlags & 2) == 0 ? PROCESSING_INSTRUCTION_0 : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.toString_0 = function toString_157() {
    var result;
    if ((this.eFlags & 4) != 0) return $toString_16(this);
    result = new StringBuffer_1($toString_16(this));
    result.string += ' (data: ';
    $append_3(result, this.data_0);
    result.string += ', target: ';
    $append_3(result, this.target);
    result.string += ')';
    return result.string;
};
_.data_0 = null;
_.target = null;
var Lorg_eclipse_emf_ecore_xml_type_impl_ProcessingInstructionImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'ProcessingInstructionImpl', 666);
function $setInstanceType(this$static, newInstanceType) {
    this$static.instanceType = newInstanceType;
}
function $setRawValue(this$static, newRawValue) {
    !this$static.mixed && (this$static.mixed = new BasicFeatureMap(this$static, 0));
    $set_17(this$static.mixed, ($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE__RAW_VALUE), newRawValue);
}
function SimpleAnyTypeImpl() {
    AnyTypeImpl.call(this);
}
defineClass(667, 823, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    836: 1,
    2066: 1,
    667: 1
}, SimpleAnyTypeImpl);
_.eGet = function eGet_34(featureID, resolve, coreType) {
    switch(featureID){
        case 0:
            if (coreType) return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), this.mixed;
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), this.mixed.wrapper;
        case 1:
            if (coreType) return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159);
            return (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo(castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159), 218)).getWrapper();
        case 2:
            if (coreType) return !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2)), this.anyAttribute;
            return !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2)), this.anyAttribute.wrapper;
        case 3:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castToString($get_24(this.mixed, ($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE__RAW_VALUE), true));
        case 4:
            return createFromString_2(this.instanceType, (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castToString($get_24(this.mixed, ($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE__RAW_VALUE), true))));
        case 5:
            return this.instanceType;
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE)), $getEStructuralFeature((this.eFlags & 2) == 0 ? SIMPLE_ANY_TYPE : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), resolve, coreType);
};
_.eIsSet = function eIsSet_33(featureID) {
    switch(featureID){
        case 0:
            return !!this.mixed && this.mixed.size_0 != 0;
        case 1:
            return !(!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159)).isEmpty();
        case 2:
            return !!this.anyAttribute && this.anyAttribute.size_0 != 0;
        case 3:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castToString($get_24(this.mixed, ($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE__RAW_VALUE), true)) != null;
        case 4:
            return createFromString_2(this.instanceType, (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castToString($get_24(this.mixed, ($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE__RAW_VALUE), true)))) != null;
        case 5:
            return !!this.instanceType;
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE)), $getEStructuralFeature((this.eFlags & 2) == 0 ? SIMPLE_ANY_TYPE : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.eSet = function eSet_31(featureID, newValue) {
    switch(featureID){
        case 0:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $set_15(this.mixed, newValue);
            return;
        case 1:
            (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo(castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159), 218)).set_1(newValue);
            return;
        case 2:
            !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2));
            $set_15(this.anyAttribute, newValue);
            return;
        case 3:
            $setRawValue(this, castToString(newValue));
            return;
        case 4:
            $setRawValue(this, convertToString_2(this.instanceType, newValue));
            return;
        case 5:
            $setInstanceType(this, castTo(newValue, 155));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE)), $getEStructuralFeature((this.eFlags & 2) == 0 ? SIMPLE_ANY_TYPE : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), newValue);
};
_.eStaticClass = function eStaticClass_33() {
    return $clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE;
};
_.eUnset = function eUnset_31(featureID) {
    switch(featureID){
        case 0:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_13(this.mixed);
            return;
        case 1:
            (!this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), castTo($list(this.mixed, ($clinit_XMLTypePackage$Literals(), ANY_TYPE__ANY)), 159)).clear_0();
            return;
        case 2:
            !this.anyAttribute && (this.anyAttribute = new BasicFeatureMap(this, 2));
            $clear_13(this.anyAttribute);
            return;
        case 3:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $set_17(this.mixed, ($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE__RAW_VALUE), null);
            return;
        case 4:
            $setRawValue(this, convertToString_2(this.instanceType, null));
            return;
        case 5:
            this.instanceType = null;
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), SIMPLE_ANY_TYPE)), $getEStructuralFeature((this.eFlags & 2) == 0 ? SIMPLE_ANY_TYPE : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
var Lorg_eclipse_emf_ecore_xml_type_impl_SimpleAnyTypeImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'SimpleAnyTypeImpl', 667);
function XMLTypeDocumentRootImpl() {
    EObjectImpl.call(this);
}
defineClass(668, 500, {
    109: 1,
    93: 1,
    92: 1,
    57: 1,
    52: 1,
    98: 1,
    2067: 1,
    668: 1
}, XMLTypeDocumentRootImpl);
_.eGet = function eGet_35(featureID, resolve, coreType) {
    switch(featureID){
        case 0:
            if (coreType) return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), this.mixed;
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), this.mixed.wrapper;
        case 1:
            return coreType ? (!this.xMLNSPrefixMap && (this.xMLNSPrefixMap = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 1)), this.xMLNSPrefixMap) : (!this.xMLNSPrefixMap && (this.xMLNSPrefixMap = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 1)), $map_0(this.xMLNSPrefixMap));
        case 2:
            return coreType ? (!this.xSISchemaLocation && (this.xSISchemaLocation = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 2)), this.xSISchemaLocation) : (!this.xSISchemaLocation && (this.xSISchemaLocation = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 2)), $map_0(this.xSISchemaLocation));
        case 3:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__CDATA));
        case 4:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__COMMENT));
        case 5:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION));
        case 6:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__TEXT));
    }
    return $eDynamicGet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT)), $getEStructuralFeature((this.eFlags & 2) == 0 ? XML_TYPE_DOCUMENT_ROOT : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), resolve, coreType);
};
_.eInverseRemove_0 = function eInverseRemove_24(otherEnd, featureID, msgs) {
    var feature;
    switch(featureID){
        case 0:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $basicRemove_2(this.mixed, otherEnd, msgs);
        case 1:
            return !this.xMLNSPrefixMap && (this.xMLNSPrefixMap = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 1)), $basicRemove_1(this.xMLNSPrefixMap, otherEnd, msgs);
        case 2:
            return !this.xSISchemaLocation && (this.xSISchemaLocation = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 2)), $basicRemove_1(this.xSISchemaLocation, otherEnd, msgs);
        case 5:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), $basicRemove_4($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION)), otherEnd, msgs);
    }
    return feature = castTo($getEStructuralFeature((this.eFlags & 2) == 0 ? ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT) : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), 69), feature.getSettingDelegate().dynamicInverseRemove(this, $eSettings(this), featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT)), otherEnd, msgs);
};
_.eIsSet = function eIsSet_34(featureID) {
    switch(featureID){
        case 0:
            return !!this.mixed && this.mixed.size_0 != 0;
        case 1:
            return !!this.xMLNSPrefixMap && this.xMLNSPrefixMap.size_0 != 0;
        case 2:
            return !!this.xSISchemaLocation && this.xSISchemaLocation.size_0 != 0;
        case 3:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), !$isEmpty_1($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__CDATA)));
        case 4:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), !$isEmpty_1($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__COMMENT)));
        case 5:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), !$isEmpty_1($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION)));
        case 6:
            return !this.mixed && (this.mixed = new BasicFeatureMap(this, 0)), !$isEmpty_1($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__TEXT)));
    }
    return $eDynamicIsSet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT)), $getEStructuralFeature((this.eFlags & 2) == 0 ? XML_TYPE_DOCUMENT_ROOT : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.eSet = function eSet_32(featureID, newValue) {
    switch(featureID){
        case 0:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $set_15(this.mixed, newValue);
            return;
        case 1:
            !this.xMLNSPrefixMap && (this.xMLNSPrefixMap = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 1));
            $set_12(this.xMLNSPrefixMap, newValue);
            return;
        case 2:
            !this.xSISchemaLocation && (this.xSISchemaLocation = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 2));
            $set_12(this.xSISchemaLocation, newValue);
            return;
        case 3:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__CDATA)));
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $addAll_14($list(this.mixed, XML_TYPE_DOCUMENT_ROOT__CDATA), castTo(newValue, 16));
            return;
        case 4:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__COMMENT)));
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $addAll_14($list(this.mixed, XML_TYPE_DOCUMENT_ROOT__COMMENT), castTo(newValue, 16));
            return;
        case 5:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION)));
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $addAll_14($list(this.mixed, XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION), castTo(newValue, 16));
            return;
        case 6:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__TEXT)));
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $addAll_14($list(this.mixed, XML_TYPE_DOCUMENT_ROOT__TEXT), castTo(newValue, 16));
            return;
    }
    $eDynamicSet(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT)), $getEStructuralFeature((this.eFlags & 2) == 0 ? XML_TYPE_DOCUMENT_ROOT : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID), newValue);
};
_.eStaticClass = function eStaticClass_34() {
    return $clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT;
};
_.eUnset = function eUnset_32(featureID) {
    switch(featureID){
        case 0:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_13(this.mixed);
            return;
        case 1:
            !this.xMLNSPrefixMap && (this.xMLNSPrefixMap = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 1));
            this.xMLNSPrefixMap.delegateEList.clear_0();
            return;
        case 2:
            !this.xSISchemaLocation && (this.xSISchemaLocation = new EcoreEMap(($clinit_EcorePackage$Literals(), ESTRING_TO_STRING_MAP_ENTRY), Lorg_eclipse_emf_ecore_impl_EStringToStringMapEntryImpl_2_classLit, this, 2));
            this.xSISchemaLocation.delegateEList.clear_0();
            return;
        case 3:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__CDATA)));
            return;
        case 4:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__COMMENT)));
            return;
        case 5:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__PROCESSING_INSTRUCTION)));
            return;
        case 6:
            !this.mixed && (this.mixed = new BasicFeatureMap(this, 0));
            $clear_16($list(this.mixed, ($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT__TEXT)));
            return;
    }
    $eDynamicUnset(this, featureID - $getFeatureCount(($clinit_XMLTypePackage$Literals(), XML_TYPE_DOCUMENT_ROOT)), $getEStructuralFeature((this.eFlags & 2) == 0 ? XML_TYPE_DOCUMENT_ROOT : (!this.eProperties && (this.eProperties = new BasicEObjectImpl$EPropertiesHolderImpl), this.eProperties).getEClass(), featureID));
};
_.toString_0 = function toString_158() {
    var result;
    if ((this.eFlags & 4) != 0) return $toString_16(this);
    result = new StringBuffer_1($toString_16(this));
    result.string += ' (mixed: ';
    $append_2(result, this.mixed);
    result.string += ')';
    return result.string;
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypeDocumentRootImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypeDocumentRootImpl', 668);
function $clinit_XMLTypeFactoryImpl() {
    $clinit_XMLTypeFactoryImpl = emptyMethod;
    $clinit_EFactoryImpl();
    DOUBLE_POSITIVE_INFINITY = $intern_60;
    DOUBLE_NEGATIVE_INFINITY = $intern_61;
    FLOAT_POSITIVE_INFINITY = new Float($intern_60);
    FLOAT_NEGATIVE_INFINITY = new Float($intern_61);
}
function $booleanValueOf_0(initialValue) {
    initialValue = normalize(initialValue, true);
    if ($equals_5('true', initialValue) || $equals_5('1', initialValue)) return $clinit_Boolean(), TRUE_0;
    else if ($equals_5('false', initialValue) || $equals_5('0', initialValue)) return $clinit_Boolean(), FALSE_0;
    throw toJs(new InvalidDatatypeValueException("Invalid boolean value: '" + initialValue + "'"));
}
function $convertBase64Binary(instanceValue) {
    return instanceValue == null ? null : encode(instanceValue);
}
function $convertDouble(instanceValue) {
    return instanceValue == $intern_60 ? 'INF' : instanceValue == $intern_61 ? '-INF' : '' + instanceValue;
}
function $convertENTITIESBaseToString(instanceValue) {
    var i, list, result;
    if (instanceValue == null) return null;
    list = castTo(instanceValue, 15);
    if (list.isEmpty()) return '';
    result = new StringBuffer;
    for(i = list.iterator_0(); i.hasNext_0();){
        $append_3(result, ($clinit_XMLTypePackage$Literals(), castToString(i.next_1())));
        result.string += ' ';
    }
    return $substring(result, result.string.length - 1);
}
function $convertFloat(instanceValue) {
    return instanceValue == $intern_60 ? 'INF' : instanceValue == $intern_61 ? '-INF' : '' + instanceValue;
}
function $convertHexBinary(instanceValue) {
    return instanceValue == null ? null : encode_0(instanceValue);
}
function $convertIDREFSBase(instanceValue) {
    var item_0, item$iterator, result;
    if (!instanceValue) return null;
    if (instanceValue.isEmpty()) return '';
    result = new StringBuffer;
    for(item$iterator = instanceValue.iterator_0(); item$iterator.hasNext_0();){
        item_0 = item$iterator.next_1();
        $append_3(result, castToString(item_0));
        result.string += ' ';
    }
    return $substring(result, result.string.length - 1);
}
function $convertNMTOKENSBaseToString(instanceValue) {
    var i, list, result;
    if (instanceValue == null) return null;
    list = castTo(instanceValue, 15);
    if (list.isEmpty()) return '';
    result = new StringBuffer;
    for(i = list.iterator_0(); i.hasNext_0();){
        $append_3(result, ($clinit_XMLTypePackage$Literals(), castToString(i.next_1())));
        result.string += ' ';
    }
    return $substring(result, result.string.length - 1);
}
function $convertNonNegativeIntegerToString(instanceValue) {
    return instanceValue == null ? null : toString_40(instanceValue);
}
function $convertNonPositiveIntegerToString(instanceValue) {
    return instanceValue == null ? null : toString_40(instanceValue);
}
function $createBase64Binary(literal) {
    var value_0;
    if (literal == null) return null;
    value_0 = decode_0(normalize(literal, true));
    if (value_0 == null) throw toJs(new InvalidDatatypeValueException("Invalid base64Binary value: '" + literal + "'"));
    return value_0;
}
function $createDoubleObject(literal) {
    var ch_0, length_0, normalizedLiteral, suffixlength;
    if (literal == null) return null;
    else {
        normalizedLiteral = normalize(literal, true);
        suffixlength = 3;
        if ($equals_5(normalizedLiteral.substr(normalizedLiteral.length - suffixlength, suffixlength), 'INF')) {
            length_0 = normalizedLiteral.length;
            if (length_0 == 4) {
                ch_0 = (checkCriticalStringElementIndex(0, normalizedLiteral.length), normalizedLiteral.charCodeAt(0));
                if (ch_0 == 43) return DOUBLE_POSITIVE_INFINITY;
                else if (ch_0 == 45) return DOUBLE_NEGATIVE_INFINITY;
            } else if (length_0 == 3) return DOUBLE_POSITIVE_INFINITY;
        }
        return __parseAndValidateDouble(normalizedLiteral);
    }
}
function $createENTITIESBase(literal) {
    var item_0, item$array, item$index, item$max, result;
    if (literal == null) return null;
    result = new ArrayList;
    for(item$array = $split_5(literal), item$index = 0, item$max = item$array.length; item$index < item$max; ++item$index){
        item_0 = item$array[item$index];
        $add_3(result, normalize(item_0, true));
    }
    return result;
}
function $createFloatObject(literal) {
    var ch_0, length_0, normalizedLiteral, suffixlength;
    if (literal == null) return null;
    else {
        normalizedLiteral = normalize(literal, true);
        suffixlength = 3;
        if ($equals_5(normalizedLiteral.substr(normalizedLiteral.length - suffixlength, suffixlength), 'INF')) {
            length_0 = normalizedLiteral.length;
            if (length_0 == 4) {
                ch_0 = (checkCriticalStringElementIndex(0, normalizedLiteral.length), normalizedLiteral.charCodeAt(0));
                if (ch_0 == 43) return FLOAT_POSITIVE_INFINITY;
                else if (ch_0 == 45) return FLOAT_NEGATIVE_INFINITY;
            } else if (length_0 == 3) return FLOAT_POSITIVE_INFINITY;
        }
        return new Float_0(normalizedLiteral);
    }
}
function $createHexBinary(literal) {
    var value_0;
    if (literal == null) return null;
    value_0 = decode_1(normalize(literal, true));
    if (value_0 == null) throw toJs(new InvalidDatatypeValueException("Invalid hexBinary value: '" + literal + "'"));
    return value_0;
}
function $createIDREFSBase(literal) {
    var item_0, item$array, item$index, item$max, result;
    if (literal == null) return null;
    result = new ArrayList;
    for(item$array = $split_5(literal), item$index = 0, item$max = item$array.length; item$index < item$max; ++item$index){
        item_0 = item$array[item$index];
        $add_3(result, normalize(item_0, true));
    }
    return result;
}
function $createNMTOKENSBase(literal) {
    var item_0, item$array, item$index, item$max, result;
    if (literal == null) return null;
    result = new ArrayList;
    for(item$array = $split_5(literal), item$index = 0, item$max = item$array.length; item$index < item$max; ++item$index){
        item_0 = item$array[item$index];
        $add_3(result, normalize(item_0, true));
    }
    return result;
}
function $createNonNegativeIntegerFromString(initialValue) {
    var result;
    return initialValue == null ? null : new BigInteger_3((result = normalize(initialValue, true), result.length > 0 && (checkCriticalStringElementIndex(0, result.length), result.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result.length + 1), result.substr(1)) : result));
}
function $createNonPositiveIntegerFromString(initialValue) {
    var result;
    return initialValue == null ? null : new BigInteger_3((result = normalize(initialValue, true), result.length > 0 && (checkCriticalStringElementIndex(0, result.length), result.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result.length + 1), result.substr(1)) : result));
}
function XMLTypeFactoryImpl() {}
function init_5() {
    $clinit_XMLTypeFactoryImpl();
    var exception, theXMLTypeFactory;
    try {
        theXMLTypeFactory = castTo($getEFactory(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2003/XMLType'), 2068);
        if (theXMLTypeFactory) return theXMLTypeFactory;
    } catch ($e0) {
        $e0 = toJava($e0);
        if (instanceOf($e0, 103)) {
            exception = $e0;
            $log_2(($clinit_EcorePlugin(), exception));
        } else throw toJs($e0);
    }
    return new XMLTypeFactoryImpl;
}
defineClass(1974, 704, {
    109: 1,
    93: 1,
    92: 1,
    466: 1,
    154: 1,
    57: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    117: 1,
    118: 1,
    2068: 1
}, XMLTypeFactoryImpl);
_.convertToString = function convertToString_3(eDataType, instanceValue) {
    switch(eDataType.getClassifierID()){
        case 7:
        case 8:
        case 9:
        case 10:
        case 16:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 32:
        case 33:
        case 34:
        case 36:
        case 37:
        case 44:
        case 45:
        case 50:
        case 51:
        case 53:
        case 55:
        case 56:
        case 57:
        case 58:
        case 60:
        case 61:
        case 4:
            return instanceValue == null ? null : toString_40(instanceValue);
        case 19:
        case 28:
        case 29:
        case 35:
        case 38:
        case 39:
        case 41:
        case 46:
        case 52:
        case 54:
        case 5:
            return castToString(instanceValue);
        case 6:
            return $convertBase64Binary(castTo(instanceValue, 195));
        case 12:
        case 47:
        case 49:
        case 11:
            return $convertToString(this, eDataType, instanceValue);
        case 13:
            return instanceValue == null ? null : $toPlainString(castTo(instanceValue, 245));
        case 15:
        case 14:
            return instanceValue == null ? null : $convertDouble($doubleValue(castToDouble(instanceValue)));
        case 17:
            return $convertENTITIESBaseToString(($clinit_XMLTypePackage$Literals(), instanceValue));
        case 18:
            return $convertENTITIESBaseToString(instanceValue);
        case 21:
        case 20:
            return instanceValue == null ? null : $convertFloat(castTo(instanceValue, 160).value_0);
        case 27:
            return $convertHexBinary(castTo(instanceValue, 195));
        case 30:
            return $convertIDREFSBase(($clinit_XMLTypePackage$Literals(), castTo(instanceValue, 15)));
        case 31:
            return $convertIDREFSBase(castTo(instanceValue, 15));
        case 40:
            return $convertNonPositiveIntegerToString(($clinit_XMLTypePackage$Literals(), instanceValue));
        case 42:
            return $convertNMTOKENSBaseToString(($clinit_XMLTypePackage$Literals(), instanceValue));
        case 43:
            return $convertNMTOKENSBaseToString(instanceValue);
        case 59:
        case 48:
            return $convertNonNegativeIntegerToString(($clinit_XMLTypePackage$Literals(), instanceValue));
        default:
            throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    }
};
_.create_3 = function create_49(eClass) {
    var anyType, ePackage, processingInstruction, simpleAnyType, xmlTypeDocumentRoot;
    switch(eClass.metaObjectID == -1 && (eClass.metaObjectID = (ePackage = $getEPackage(eClass), ePackage ? $indexOf_6(ePackage.getEClassifiers(), eClass) : -1)), eClass.metaObjectID){
        case 0:
            return anyType = new AnyTypeImpl, anyType;
        case 1:
            return processingInstruction = new ProcessingInstructionImpl, processingInstruction;
        case 2:
            return simpleAnyType = new SimpleAnyTypeImpl, simpleAnyType;
        case 3:
            return xmlTypeDocumentRoot = new XMLTypeDocumentRootImpl, xmlTypeDocumentRoot;
        default:
            throw toJs(new IllegalArgumentException_0("The class '" + eClass.name_0 + "' is not a valid classifier"));
    }
};
_.createFromString = function createFromString_3(eDataType, initialValue) {
    var result, result0, result1, result10, result11, result12, result13, result14, result2, result3, result4, result5, result6, result7, result8, result9;
    switch(eDataType.getClassifierID()){
        case 5:
        case 52:
        case 4:
            return initialValue;
        case 6:
            return $createBase64Binary(initialValue);
        case 8:
        case 7:
            return initialValue == null ? null : $booleanValueOf_0(initialValue);
        case 9:
            return initialValue == null ? null : get_32(__parseAndValidateInt((result0 = normalize(initialValue, true), result0.length > 0 && (checkCriticalStringElementIndex(0, result0.length), result0.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result0.length + 1), result0.substr(1)) : result0), -128, 127) << 24 >> 24);
        case 10:
            return initialValue == null ? null : get_32(__parseAndValidateInt((result1 = normalize(initialValue, true), result1.length > 0 && (checkCriticalStringElementIndex(0, result1.length), result1.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result1.length + 1), result1.substr(1)) : result1), -128, 127) << 24 >> 24);
        case 11:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), DATE), initialValue));
        case 12:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), DATE_TIME), initialValue));
        case 13:
            return initialValue == null ? null : new BigDecimal_0(normalize(initialValue, true));
        case 15:
        case 14:
            return $createDoubleObject(initialValue);
        case 16:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), DURATION), initialValue));
        case 17:
            return $createENTITIESBase(($clinit_XMLTypePackage$Literals(), initialValue));
        case 18:
            return $createENTITIESBase(initialValue);
        case 28:
        case 29:
        case 35:
        case 38:
        case 39:
        case 41:
        case 54:
        case 19:
            return normalize(initialValue, true);
        case 21:
        case 20:
            return $createFloatObject(initialValue);
        case 22:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), GDAY), initialValue));
        case 23:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), GMONTH), initialValue));
        case 24:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), GMONTH_DAY), initialValue));
        case 25:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), GYEAR), initialValue));
        case 26:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), GYEAR_MONTH), initialValue));
        case 27:
            return $createHexBinary(initialValue);
        case 30:
            return $createIDREFSBase(($clinit_XMLTypePackage$Literals(), initialValue));
        case 31:
            return $createIDREFSBase(initialValue);
        case 32:
            return initialValue == null ? null : valueOf_3(__parseAndValidateInt((result2 = normalize(initialValue, true), result2.length > 0 && (checkCriticalStringElementIndex(0, result2.length), result2.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result2.length + 1), result2.substr(1)) : result2), $intern_42, $intern_0));
        case 33:
            return initialValue == null ? null : new BigInteger_3((result3 = normalize(initialValue, true), result3.length > 0 && (checkCriticalStringElementIndex(0, result3.length), result3.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result3.length + 1), result3.substr(1)) : result3));
        case 34:
            return initialValue == null ? null : valueOf_3(__parseAndValidateInt((result4 = normalize(initialValue, true), result4.length > 0 && (checkCriticalStringElementIndex(0, result4.length), result4.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result4.length + 1), result4.substr(1)) : result4), $intern_42, $intern_0));
        case 36:
            return initialValue == null ? null : valueOf_4(__parseAndValidateLong((result5 = normalize(initialValue, true), result5.length > 0 && (checkCriticalStringElementIndex(0, result5.length), result5.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result5.length + 1), result5.substr(1)) : result5)));
        case 37:
            return initialValue == null ? null : valueOf_4(__parseAndValidateLong((result6 = normalize(initialValue, true), result6.length > 0 && (checkCriticalStringElementIndex(0, result6.length), result6.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result6.length + 1), result6.substr(1)) : result6)));
        case 40:
            return $createNonPositiveIntegerFromString(($clinit_XMLTypePackage$Literals(), initialValue));
        case 42:
            return $createNMTOKENSBase(($clinit_XMLTypePackage$Literals(), initialValue));
        case 43:
            return $createNMTOKENSBase(initialValue);
        case 44:
            return initialValue == null ? null : new BigInteger_3((result7 = normalize(initialValue, true), result7.length > 0 && (checkCriticalStringElementIndex(0, result7.length), result7.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result7.length + 1), result7.substr(1)) : result7));
        case 45:
            return initialValue == null ? null : new BigInteger_3((result8 = normalize(initialValue, true), result8.length > 0 && (checkCriticalStringElementIndex(0, result8.length), result8.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result8.length + 1), result8.substr(1)) : result8));
        case 46:
            return normalize(initialValue, false);
        case 47:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), NOTATION), initialValue));
        case 59:
        case 48:
            return $createNonNegativeIntegerFromString(($clinit_XMLTypePackage$Literals(), initialValue));
        case 49:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), QNAME), initialValue));
        case 50:
            return initialValue == null ? null : valueOf_5(__parseAndValidateInt((result9 = normalize(initialValue, true), result9.length > 0 && (checkCriticalStringElementIndex(0, result9.length), result9.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result9.length + 1), result9.substr(1)) : result9), $intern_163, 32767) << 16 >> 16);
        case 51:
            return initialValue == null ? null : valueOf_5(__parseAndValidateInt((result10 = normalize(initialValue, true), result10.length > 0 && (checkCriticalStringElementIndex(0, result10.length), result10.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result10.length + 1), result10.substr(1)) : result10), $intern_163, 32767) << 16 >> 16);
        case 53:
            return castToString($createFromString(this, ($clinit_XMLTypePackage$Literals(), TIME), initialValue));
        case 55:
            return initialValue == null ? null : valueOf_5(__parseAndValidateInt((result11 = normalize(initialValue, true), result11.length > 0 && (checkCriticalStringElementIndex(0, result11.length), result11.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result11.length + 1), result11.substr(1)) : result11), $intern_163, 32767) << 16 >> 16);
        case 56:
            return initialValue == null ? null : valueOf_5(__parseAndValidateInt((result12 = normalize(initialValue, true), result12.length > 0 && (checkCriticalStringElementIndex(0, result12.length), result12.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result12.length + 1), result12.substr(1)) : result12), $intern_163, 32767) << 16 >> 16);
        case 57:
            return initialValue == null ? null : valueOf_4(__parseAndValidateLong((result13 = normalize(initialValue, true), result13.length > 0 && (checkCriticalStringElementIndex(0, result13.length), result13.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result13.length + 1), result13.substr(1)) : result13)));
        case 58:
            return initialValue == null ? null : valueOf_4(__parseAndValidateLong((result14 = normalize(initialValue, true), result14.length > 0 && (checkCriticalStringElementIndex(0, result14.length), result14.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result14.length + 1), result14.substr(1)) : result14)));
        case 60:
            return initialValue == null ? null : valueOf_3(__parseAndValidateInt((result = normalize(initialValue, true), result.length > 0 && (checkCriticalStringElementIndex(0, result.length), result.charCodeAt(0) == 43) ? (checkCriticalStringElementIndex(1, result.length + 1), result.substr(1)) : result), $intern_42, $intern_0));
        case 61:
            return initialValue == null ? null : valueOf_3(__parseAndValidateInt(normalize(initialValue, true), $intern_42, $intern_0));
        default:
            throw toJs(new IllegalArgumentException_0("The datatype '" + eDataType.getName() + "' is not a valid classifier"));
    }
};
var DOUBLE_NEGATIVE_INFINITY, DOUBLE_POSITIVE_INFINITY, FLOAT_NEGATIVE_INFINITY, FLOAT_POSITIVE_INFINITY;
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypeFactoryImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypeFactoryImpl', 1974);
function $$init_13(this$static) {
    this$static.anyTypeEClass = null;
    this$static.processingInstructionEClass = null;
    this$static.simpleAnyTypeEClass = null;
    this$static.xmlTypeDocumentRootEClass = null;
    this$static.anySimpleTypeEDataType = null;
    this$static.anyURIEDataType = null;
    this$static.base64BinaryEDataType = null;
    this$static.booleanEDataType = null;
    this$static.booleanObjectEDataType = null;
    this$static.decimalEDataType = null;
    this$static.integerEDataType = null;
    this$static.intObjectEDataType = null;
    this$static.longEDataType = null;
    this$static.longObjectEDataType = null;
    this$static.intEDataType = null;
    this$static.shortEDataType = null;
    this$static.shortObjectEDataType = null;
    this$static.byteEDataType = null;
    this$static.byteObjectEDataType = null;
    this$static.dateEDataType = null;
    this$static.dateTimeEDataType = null;
    this$static.stringEDataType = null;
    this$static.doubleEDataType = null;
    this$static.doubleObjectEDataType = null;
    this$static.durationEDataType = null;
    this$static.entitiesBaseEDataType = null;
    this$static.normalizedStringEDataType = null;
    this$static.tokenEDataType = null;
    this$static.nameEDataType = null;
    this$static.ncNameEDataType = null;
    this$static.entityEDataType = null;
    this$static.entitiesEDataType = null;
    this$static.floatEDataType = null;
    this$static.floatObjectEDataType = null;
    this$static.gDayEDataType = null;
    this$static.gMonthEDataType = null;
    this$static.gMonthDayEDataType = null;
    this$static.gYearEDataType = null;
    this$static.gYearMonthEDataType = null;
    this$static.hexBinaryEDataType = null;
    this$static.idEDataType = null;
    this$static.idrefEDataType = null;
    this$static.idrefsBaseEDataType = null;
    this$static.idrefsEDataType = null;
    this$static.languageEDataType = null;
    this$static.nonPositiveIntegerEDataType = null;
    this$static.negativeIntegerEDataType = null;
    this$static.nmtokenEDataType = null;
    this$static.nmtokensBaseEDataType = null;
    this$static.nmtokensEDataType = null;
    this$static.nonNegativeIntegerEDataType = null;
    this$static.notationEDataType = null;
    this$static.positiveIntegerEDataType = null;
    this$static.qNameEDataType = null;
    this$static.timeEDataType = null;
    this$static.unsignedLongEDataType = null;
    this$static.unsignedIntEDataType = null;
    this$static.unsignedIntObjectEDataType = null;
    this$static.unsignedShortEDataType = null;
    this$static.unsignedShortObjectEDataType = null;
    this$static.unsignedByteEDataType = null;
    this$static.unsignedByteObjectEDataType = null;
    this$static.isCreated = false;
    this$static.isInitialized = false;
}
function $createExtendedMetaDataAnnotations_0(this$static) {
    $addAnnotation(this$static.anySimpleTypeEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'anySimpleType'
    ]));
    $addAnnotation(this$static.anyTypeEClass, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'anyType',
        'kind',
        'mixed'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.anyTypeEClass), 0), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'elementWildcard',
        'name',
        ':mixed'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.anyTypeEClass), 1), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'elementWildcard',
        'wildcards',
        '##any',
        'name',
        ':1',
        'processing',
        'lax'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.anyTypeEClass), 2), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'attributeWildcard',
        'wildcards',
        '##any',
        'name',
        ':2',
        'processing',
        'lax'
    ]));
    $addAnnotation(this$static.anyURIEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'anyURI',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.base64BinaryEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'base64Binary',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.booleanEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'boolean',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.booleanObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'boolean:Object',
        'baseType',
        'boolean'
    ]));
    $addAnnotation(this$static.byteEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'byte'
    ]));
    $addAnnotation(this$static.byteObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'byte:Object',
        'baseType',
        'byte'
    ]));
    $addAnnotation(this$static.dateEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'date',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.dateTimeEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'dateTime',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.decimalEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'decimal',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.doubleEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'double',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.doubleObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'double:Object',
        'baseType',
        'double'
    ]));
    $addAnnotation(this$static.durationEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'duration',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.entitiesEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'ENTITIES',
        'baseType',
        'ENTITIES_._base',
        'minLength',
        '1'
    ]));
    $addAnnotation(this$static.entitiesBaseEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'ENTITIES_._base',
        'itemType',
        'ENTITY'
    ]));
    $addAnnotation(this$static.entityEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'ENTITY',
        'baseType',
        'NCName'
    ]));
    $addAnnotation(this$static.floatEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'float',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.floatObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'float:Object',
        'baseType',
        'float'
    ]));
    $addAnnotation(this$static.gDayEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'gDay',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.gMonthEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'gMonth',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.gMonthDayEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'gMonthDay',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.gYearEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'gYear',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.gYearMonthEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'gYearMonth',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.hexBinaryEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'hexBinary',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.idEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'ID',
        'baseType',
        'NCName'
    ]));
    $addAnnotation(this$static.idrefEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'IDREF',
        'baseType',
        'NCName'
    ]));
    $addAnnotation(this$static.idrefsEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'IDREFS',
        'baseType',
        'IDREFS_._base',
        'minLength',
        '1'
    ]));
    $addAnnotation(this$static.idrefsBaseEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'IDREFS_._base',
        'itemType',
        'IDREF'
    ]));
    $addAnnotation(this$static.intEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'int'
    ]));
    $addAnnotation(this$static.integerEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'integer'
    ]));
    $addAnnotation(this$static.intObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'int:Object',
        'baseType',
        'int'
    ]));
    $addAnnotation(this$static.languageEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'language',
        'baseType',
        'token',
        'pattern',
        '[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*'
    ]));
    $addAnnotation(this$static.longEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'long'
    ]));
    $addAnnotation(this$static.longObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'long:Object',
        'baseType',
        'long'
    ]));
    $addAnnotation(this$static.nameEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'Name',
        'baseType',
        'token',
        'pattern',
        '\\i\\c*'
    ]));
    $addAnnotation(this$static.ncNameEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'NCName',
        'baseType',
        'Name',
        'pattern',
        '[\\i-[:]][\\c-[:]]*'
    ]));
    $addAnnotation(this$static.negativeIntegerEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'negativeInteger',
        'baseType',
        'nonPositiveInteger',
        'maxInclusive',
        '-1'
    ]));
    $addAnnotation(this$static.nmtokenEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'NMTOKEN',
        'baseType',
        'token',
        'pattern',
        '\\c+'
    ]));
    $addAnnotation(this$static.nmtokensEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'NMTOKENS',
        'baseType',
        'NMTOKENS_._base',
        'minLength',
        '1'
    ]));
    $addAnnotation(this$static.nmtokensBaseEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'NMTOKENS_._base',
        'itemType',
        'NMTOKEN'
    ]));
    $addAnnotation(this$static.nonNegativeIntegerEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'nonNegativeInteger',
        'baseType',
        'integer',
        'minInclusive',
        '0'
    ]));
    $addAnnotation(this$static.nonPositiveIntegerEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'nonPositiveInteger',
        'baseType',
        'integer',
        'maxInclusive',
        '0'
    ]));
    $addAnnotation(this$static.normalizedStringEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'normalizedString',
        'baseType',
        'string',
        'whiteSpace',
        'replace'
    ]));
    $addAnnotation(this$static.notationEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'NOTATION',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.positiveIntegerEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'positiveInteger',
        'baseType',
        'nonNegativeInteger',
        'minInclusive',
        '1'
    ]));
    $addAnnotation(this$static.processingInstructionEClass, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'processingInstruction_._type',
        'kind',
        'empty'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.processingInstructionEClass), 0), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'attribute',
        'name',
        'data'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.processingInstructionEClass), 1), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'attribute',
        'name',
        'target'
    ]));
    $addAnnotation(this$static.qNameEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'QName',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.shortEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'short'
    ]));
    $addAnnotation(this$static.shortObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'short:Object',
        'baseType',
        'short'
    ]));
    $addAnnotation(this$static.simpleAnyTypeEClass, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'simpleAnyType',
        'kind',
        'simple'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.simpleAnyTypeEClass), 0), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        ':3',
        'kind',
        'simple'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.simpleAnyTypeEClass), 1), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        ':4',
        'kind',
        'simple'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.simpleAnyTypeEClass), 2), 19), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        ':5',
        'kind',
        'simple'
    ]));
    $addAnnotation(this$static.stringEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'string',
        'whiteSpace',
        'preserve'
    ]));
    $addAnnotation(this$static.timeEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'time',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.tokenEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'token',
        'baseType',
        'normalizedString',
        'whiteSpace',
        'collapse'
    ]));
    $addAnnotation(this$static.unsignedByteEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedByte',
        'maxInclusive',
        '255',
        'minInclusive',
        '0'
    ]));
    $addAnnotation(this$static.unsignedByteObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedByte:Object',
        'baseType',
        'unsignedByte'
    ]));
    $addAnnotation(this$static.unsignedIntEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedInt',
        'maxInclusive',
        '4294967295',
        'minInclusive',
        '0'
    ]));
    $addAnnotation(this$static.unsignedIntObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedInt:Object',
        'baseType',
        'unsignedInt'
    ]));
    $addAnnotation(this$static.unsignedLongEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedLong',
        'baseType',
        'nonNegativeInteger',
        'maxInclusive',
        '18446744073709551615',
        'minInclusive',
        '0'
    ]));
    $addAnnotation(this$static.unsignedShortEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedShort',
        'maxInclusive',
        '65535',
        'minInclusive',
        '0'
    ]));
    $addAnnotation(this$static.unsignedShortObjectEDataType, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        'unsignedShort:Object',
        'baseType',
        'unsignedShort'
    ]));
    $addAnnotation(this$static.xmlTypeDocumentRootEClass, 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'name',
        '',
        'kind',
        'mixed'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 0), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'elementWildcard',
        'name',
        ':mixed'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 1), 19), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'attribute',
        'name',
        'xmlns:prefix'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 2), 19), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'attribute',
        'name',
        'xsi:schemaLocation'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 3), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'element',
        'name',
        'cDATA',
        'namespace',
        '##targetNamespace'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 4), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'element',
        'name',
        'comment',
        'namespace',
        '##targetNamespace'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 5), 19), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'element',
        'name',
        'processingInstruction',
        'namespace',
        '##targetNamespace'
    ]));
    $addAnnotation(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 6), 35), 'http:///org/eclipse/emf/ecore/util/ExtendedMetaData', stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'kind',
        'element',
        'name',
        'text',
        'namespace',
        '##targetNamespace'
    ]));
}
function $createPackageContents_1(this$static) {
    if (this$static.isCreated) return;
    this$static.isCreated = true;
    this$static.anyTypeEClass = $createEClass(this$static, 0);
    $createEAttribute(this$static.anyTypeEClass, 0);
    $createEAttribute(this$static.anyTypeEClass, 1);
    $createEAttribute(this$static.anyTypeEClass, 2);
    this$static.processingInstructionEClass = $createEClass(this$static, 1);
    $createEAttribute(this$static.processingInstructionEClass, 0);
    $createEAttribute(this$static.processingInstructionEClass, 1);
    this$static.simpleAnyTypeEClass = $createEClass(this$static, 2);
    $createEAttribute(this$static.simpleAnyTypeEClass, 3);
    $createEAttribute(this$static.simpleAnyTypeEClass, 4);
    $createEReference(this$static.simpleAnyTypeEClass, 5);
    this$static.xmlTypeDocumentRootEClass = $createEClass(this$static, 3);
    $createEAttribute(this$static.xmlTypeDocumentRootEClass, 0);
    $createEReference(this$static.xmlTypeDocumentRootEClass, 1);
    $createEReference(this$static.xmlTypeDocumentRootEClass, 2);
    $createEAttribute(this$static.xmlTypeDocumentRootEClass, 3);
    $createEAttribute(this$static.xmlTypeDocumentRootEClass, 4);
    $createEReference(this$static.xmlTypeDocumentRootEClass, 5);
    $createEAttribute(this$static.xmlTypeDocumentRootEClass, 6);
    this$static.anySimpleTypeEDataType = $createEDataType(this$static, 4);
    this$static.anyURIEDataType = $createEDataType(this$static, 5);
    this$static.base64BinaryEDataType = $createEDataType(this$static, 6);
    this$static.booleanEDataType = $createEDataType(this$static, 7);
    this$static.booleanObjectEDataType = $createEDataType(this$static, 8);
    this$static.byteEDataType = $createEDataType(this$static, 9);
    this$static.byteObjectEDataType = $createEDataType(this$static, 10);
    this$static.dateEDataType = $createEDataType(this$static, 11);
    this$static.dateTimeEDataType = $createEDataType(this$static, 12);
    this$static.decimalEDataType = $createEDataType(this$static, 13);
    this$static.doubleEDataType = $createEDataType(this$static, 14);
    this$static.doubleObjectEDataType = $createEDataType(this$static, 15);
    this$static.durationEDataType = $createEDataType(this$static, 16);
    this$static.entitiesEDataType = $createEDataType(this$static, 17);
    this$static.entitiesBaseEDataType = $createEDataType(this$static, 18);
    this$static.entityEDataType = $createEDataType(this$static, 19);
    this$static.floatEDataType = $createEDataType(this$static, 20);
    this$static.floatObjectEDataType = $createEDataType(this$static, 21);
    this$static.gDayEDataType = $createEDataType(this$static, 22);
    this$static.gMonthEDataType = $createEDataType(this$static, 23);
    this$static.gMonthDayEDataType = $createEDataType(this$static, 24);
    this$static.gYearEDataType = $createEDataType(this$static, 25);
    this$static.gYearMonthEDataType = $createEDataType(this$static, 26);
    this$static.hexBinaryEDataType = $createEDataType(this$static, 27);
    this$static.idEDataType = $createEDataType(this$static, 28);
    this$static.idrefEDataType = $createEDataType(this$static, 29);
    this$static.idrefsEDataType = $createEDataType(this$static, 30);
    this$static.idrefsBaseEDataType = $createEDataType(this$static, 31);
    this$static.intEDataType = $createEDataType(this$static, 32);
    this$static.integerEDataType = $createEDataType(this$static, 33);
    this$static.intObjectEDataType = $createEDataType(this$static, 34);
    this$static.languageEDataType = $createEDataType(this$static, 35);
    this$static.longEDataType = $createEDataType(this$static, 36);
    this$static.longObjectEDataType = $createEDataType(this$static, 37);
    this$static.nameEDataType = $createEDataType(this$static, 38);
    this$static.ncNameEDataType = $createEDataType(this$static, 39);
    this$static.negativeIntegerEDataType = $createEDataType(this$static, 40);
    this$static.nmtokenEDataType = $createEDataType(this$static, 41);
    this$static.nmtokensEDataType = $createEDataType(this$static, 42);
    this$static.nmtokensBaseEDataType = $createEDataType(this$static, 43);
    this$static.nonNegativeIntegerEDataType = $createEDataType(this$static, 44);
    this$static.nonPositiveIntegerEDataType = $createEDataType(this$static, 45);
    this$static.normalizedStringEDataType = $createEDataType(this$static, 46);
    this$static.notationEDataType = $createEDataType(this$static, 47);
    this$static.positiveIntegerEDataType = $createEDataType(this$static, 48);
    this$static.qNameEDataType = $createEDataType(this$static, 49);
    this$static.shortEDataType = $createEDataType(this$static, 50);
    this$static.shortObjectEDataType = $createEDataType(this$static, 51);
    this$static.stringEDataType = $createEDataType(this$static, 52);
    this$static.timeEDataType = $createEDataType(this$static, 53);
    this$static.tokenEDataType = $createEDataType(this$static, 54);
    this$static.unsignedByteEDataType = $createEDataType(this$static, 55);
    this$static.unsignedByteObjectEDataType = $createEDataType(this$static, 56);
    this$static.unsignedIntEDataType = $createEDataType(this$static, 57);
    this$static.unsignedIntObjectEDataType = $createEDataType(this$static, 58);
    this$static.unsignedLongEDataType = $createEDataType(this$static, 59);
    this$static.unsignedShortEDataType = $createEDataType(this$static, 60);
    this$static.unsignedShortObjectEDataType = $createEDataType(this$static, 61);
}
function $initializePackageContents_1(this$static) {
    var theXMLTypePackage_1;
    if (this$static.isInitialized) return;
    this$static.isInitialized = true;
    $setName(this$static, 'type');
    $setNsPrefix(this$static, 'ecore.xml.type');
    $setNsURI(this$static, 'http://www.eclipse.org/emf/2003/XMLType');
    theXMLTypePackage_1 = castTo($getEPackage_0(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2003/XMLType'), 1990);
    $add_21($getESuperTypes(this$static.simpleAnyTypeEClass), this$static.anyTypeEClass);
    $initEClass(this$static.anyTypeEClass, Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit, 'AnyType', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.anyTypeEClass), 0), 35), this$static.ecorePackage.eFeatureMapEntryEDataType, 'mixed', null, 0, -1, Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit, false, false, true, false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.anyTypeEClass), 1), 35), this$static.ecorePackage.eFeatureMapEntryEDataType, 'any', null, 0, -1, Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit, true, true, true, false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.anyTypeEClass), 2), 35), this$static.ecorePackage.eFeatureMapEntryEDataType, 'anyAttribute', null, 0, -1, Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit, false, false, true, false, false, false);
    $initEClass(this$static.processingInstructionEClass, Lorg_eclipse_emf_ecore_xml_type_ProcessingInstruction_2_classLit, 'ProcessingInstruction', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.processingInstructionEClass), 0), 35), this$static.stringEDataType, 'data', null, 0, 1, Lorg_eclipse_emf_ecore_xml_type_ProcessingInstruction_2_classLit, false, false, true, false, true, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.processingInstructionEClass), 1), 35), this$static.stringEDataType, 'target', null, 1, 1, Lorg_eclipse_emf_ecore_xml_type_ProcessingInstruction_2_classLit, false, false, true, false, true, false);
    $initEClass(this$static.simpleAnyTypeEClass, Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit, 'SimpleAnyType', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.simpleAnyTypeEClass), 0), 35), theXMLTypePackage_1.stringEDataType, 'rawValue', null, 0, 1, Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit, true, true, true, false, true, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.simpleAnyTypeEClass), 1), 35), theXMLTypePackage_1.anySimpleTypeEDataType, 'value', null, 0, 1, Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit, true, true, true, false, true, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.simpleAnyTypeEClass), 2), 19), this$static.ecorePackage.eDataTypeEClass, null, 'instanceType', 1, 1, Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit, false, false, true, false, false, false, false);
    $initEClass(this$static.xmlTypeDocumentRootEClass, Lorg_eclipse_emf_ecore_xml_type_XMLTypeDocumentRoot_2_classLit, 'XMLTypeDocumentRoot', false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 0), 35), this$static.ecorePackage.eFeatureMapEntryEDataType, 'mixed', null, 0, -1, null, false, false, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 1), 19), this$static.ecorePackage.eStringToStringMapEntryEClass, null, 'xMLNSPrefixMap', 0, -1, null, true, false, true, true, false, false, false);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 2), 19), this$static.ecorePackage.eStringToStringMapEntryEClass, null, 'xSISchemaLocation', 0, -1, null, true, false, true, true, false, false, false);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 3), 35), this$static.stringEDataType, 'cDATA', null, 0, -2, null, true, true, true, false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 4), 35), this$static.stringEDataType, 'comment', null, 0, -2, null, true, true, true, false, false, true);
    $initEReference(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 5), 19), this$static.processingInstructionEClass, null, 'processingInstruction', 0, -2, null, true, true, true, true, false, false, true);
    $initEAttribute(castTo($get_20($getEStructuralFeatures(this$static.xmlTypeDocumentRootEClass), 6), 35), this$static.stringEDataType, 'text', null, 0, -2, null, true, true, true, false, false, true);
    $initEDataType(this$static.anySimpleTypeEDataType, Ljava_lang_Object_2_classLit, 'AnySimpleType', true);
    $initEDataType(this$static.anyURIEDataType, Ljava_lang_String_2_classLit, 'AnyURI', true);
    $initEDataType(this$static.base64BinaryEDataType, getClassLiteralForArray(B_classLit, 1), 'Base64Binary', true);
    $initEDataType(this$static.booleanEDataType, Z_classLit, 'Boolean', true);
    $initEDataType(this$static.booleanObjectEDataType, Ljava_lang_Boolean_2_classLit, 'BooleanObject', true);
    $initEDataType(this$static.byteEDataType, B_classLit, 'Byte', true);
    $initEDataType(this$static.byteObjectEDataType, Ljava_lang_Byte_2_classLit, 'ByteObject', true);
    $initEDataType(this$static.dateEDataType, Ljava_lang_String_2_classLit, 'Date', true);
    $initEDataType(this$static.dateTimeEDataType, Ljava_lang_String_2_classLit, 'DateTime', true);
    $initEDataType(this$static.decimalEDataType, Ljava_math_BigDecimal_2_classLit, 'Decimal', true);
    $initEDataType(this$static.doubleEDataType, D_classLit, 'Double', true);
    $initEDataType(this$static.doubleObjectEDataType, Ljava_lang_Double_2_classLit, 'DoubleObject', true);
    $initEDataType(this$static.durationEDataType, Ljava_lang_String_2_classLit, 'Duration', true);
    $initEDataType(this$static.entitiesEDataType, Ljava_util_List_2_classLit, 'ENTITIES', true);
    $initEDataType(this$static.entitiesBaseEDataType, Ljava_util_List_2_classLit, 'ENTITIESBase', true);
    $initEDataType(this$static.entityEDataType, Ljava_lang_String_2_classLit, 'ENTITY', true);
    $initEDataType(this$static.floatEDataType, F_classLit, 'Float', true);
    $initEDataType(this$static.floatObjectEDataType, Ljava_lang_Float_2_classLit, 'FloatObject', true);
    $initEDataType(this$static.gDayEDataType, Ljava_lang_String_2_classLit, 'GDay', true);
    $initEDataType(this$static.gMonthEDataType, Ljava_lang_String_2_classLit, 'GMonth', true);
    $initEDataType(this$static.gMonthDayEDataType, Ljava_lang_String_2_classLit, 'GMonthDay', true);
    $initEDataType(this$static.gYearEDataType, Ljava_lang_String_2_classLit, 'GYear', true);
    $initEDataType(this$static.gYearMonthEDataType, Ljava_lang_String_2_classLit, 'GYearMonth', true);
    $initEDataType(this$static.hexBinaryEDataType, getClassLiteralForArray(B_classLit, 1), 'HexBinary', true);
    $initEDataType(this$static.idEDataType, Ljava_lang_String_2_classLit, 'ID', true);
    $initEDataType(this$static.idrefEDataType, Ljava_lang_String_2_classLit, 'IDREF', true);
    $initEDataType(this$static.idrefsEDataType, Ljava_util_List_2_classLit, 'IDREFS', true);
    $initEDataType(this$static.idrefsBaseEDataType, Ljava_util_List_2_classLit, 'IDREFSBase', true);
    $initEDataType(this$static.intEDataType, I_classLit, 'Int', true);
    $initEDataType(this$static.integerEDataType, Ljava_math_BigInteger_2_classLit, 'Integer', true);
    $initEDataType(this$static.intObjectEDataType, Ljava_lang_Integer_2_classLit, 'IntObject', true);
    $initEDataType(this$static.languageEDataType, Ljava_lang_String_2_classLit, 'Language', true);
    $initEDataType(this$static.longEDataType, J_classLit, 'Long', true);
    $initEDataType(this$static.longObjectEDataType, Ljava_lang_Long_2_classLit, 'LongObject', true);
    $initEDataType(this$static.nameEDataType, Ljava_lang_String_2_classLit, 'Name', true);
    $initEDataType(this$static.ncNameEDataType, Ljava_lang_String_2_classLit, 'NCName', true);
    $initEDataType(this$static.negativeIntegerEDataType, Ljava_math_BigInteger_2_classLit, 'NegativeInteger', true);
    $initEDataType(this$static.nmtokenEDataType, Ljava_lang_String_2_classLit, 'NMTOKEN', true);
    $initEDataType(this$static.nmtokensEDataType, Ljava_util_List_2_classLit, 'NMTOKENS', true);
    $initEDataType(this$static.nmtokensBaseEDataType, Ljava_util_List_2_classLit, 'NMTOKENSBase', true);
    $initEDataType(this$static.nonNegativeIntegerEDataType, Ljava_math_BigInteger_2_classLit, 'NonNegativeInteger', true);
    $initEDataType(this$static.nonPositiveIntegerEDataType, Ljava_math_BigInteger_2_classLit, 'NonPositiveInteger', true);
    $initEDataType(this$static.normalizedStringEDataType, Ljava_lang_String_2_classLit, 'NormalizedString', true);
    $initEDataType(this$static.notationEDataType, Ljava_lang_String_2_classLit, 'NOTATION', true);
    $initEDataType(this$static.positiveIntegerEDataType, Ljava_lang_String_2_classLit, 'PositiveInteger', true);
    $initEDataType(this$static.qNameEDataType, Ljava_lang_String_2_classLit, 'QName', true);
    $initEDataType(this$static.shortEDataType, S_classLit, 'Short', true);
    $initEDataType(this$static.shortObjectEDataType, Ljava_lang_Short_2_classLit, 'ShortObject', true);
    $initEDataType(this$static.stringEDataType, Ljava_lang_String_2_classLit, 'String', true);
    $initEDataType(this$static.timeEDataType, Ljava_lang_String_2_classLit, 'Time', true);
    $initEDataType(this$static.tokenEDataType, Ljava_lang_String_2_classLit, 'Token', true);
    $initEDataType(this$static.unsignedByteEDataType, S_classLit, 'UnsignedByte', true);
    $initEDataType(this$static.unsignedByteObjectEDataType, Ljava_lang_Short_2_classLit, 'UnsignedByteObject', true);
    $initEDataType(this$static.unsignedIntEDataType, J_classLit, 'UnsignedInt', true);
    $initEDataType(this$static.unsignedIntObjectEDataType, Ljava_lang_Long_2_classLit, 'UnsignedIntObject', true);
    $initEDataType(this$static.unsignedLongEDataType, Ljava_math_BigInteger_2_classLit, 'UnsignedLong', true);
    $initEDataType(this$static.unsignedShortEDataType, I_classLit, 'UnsignedShort', true);
    $initEDataType(this$static.unsignedShortObjectEDataType, Ljava_lang_Integer_2_classLit, 'UnsignedShortObject', true);
    $createResource(this$static, 'http://www.eclipse.org/emf/2003/XMLType');
    $createExtendedMetaDataAnnotations_0(this$static);
}
function XMLTypePackageImpl() {
    EPackageImpl_0.call(this, 'http://www.eclipse.org/emf/2003/XMLType', ($clinit_XMLTypeFactory(), eINSTANCE_3));
    $$init_13(this);
}
function init_6() {
    var theXMLTypePackage;
    if (isInited_1) return castTo($getEPackage_0(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2003/XMLType'), 1990);
    initializeRegistryHelpers();
    theXMLTypePackage = castTo(instanceOf($getStringValue(($clinit_EPackage$Registry(), INSTANCE_6), 'http://www.eclipse.org/emf/2003/XMLType'), 577) ? $getStringValue(INSTANCE_6, 'http://www.eclipse.org/emf/2003/XMLType') : new XMLTypePackageImpl, 577);
    isInited_1 = true;
    $createPackageContents_1(theXMLTypePackage);
    $initializePackageContents_1(theXMLTypePackage);
    $put_6(($clinit_EValidator$Registry(), INSTANCE_8), theXMLTypePackage, new XMLTypePackageImpl$1);
    $freeze_0(theXMLTypePackage);
    $putStringValue(INSTANCE_6, 'http://www.eclipse.org/emf/2003/XMLType', theXMLTypePackage);
    return theXMLTypePackage;
}
function initializeRegistryHelpers() {
    register_0(Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit, new XMLTypePackageImpl$2);
    register_0(Lorg_eclipse_emf_ecore_xml_type_ProcessingInstruction_2_classLit, new XMLTypePackageImpl$3);
    register_0(Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit, new XMLTypePackageImpl$4);
    register_0(Lorg_eclipse_emf_ecore_xml_type_XMLTypeDocumentRoot_2_classLit, new XMLTypePackageImpl$5);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$6);
    register_0(getClassLiteralForArray(B_classLit, 1), new XMLTypePackageImpl$7);
    register_0(Ljava_lang_Boolean_2_classLit, new XMLTypePackageImpl$8);
    register_0(Ljava_lang_Byte_2_classLit, new XMLTypePackageImpl$9);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$10);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$11);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$12);
    register_0(Ljava_lang_Double_2_classLit, new XMLTypePackageImpl$13);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$14);
    register_0(Ljava_util_List_2_classLit, new XMLTypePackageImpl$15);
    register_0(Ljava_util_List_2_classLit, new XMLTypePackageImpl$16);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$17);
    register_0(Ljava_lang_Float_2_classLit, new XMLTypePackageImpl$18);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$19);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$20);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$21);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$22);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$23);
    register_0(getClassLiteralForArray(B_classLit, 1), new XMLTypePackageImpl$24);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$25);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$26);
    register_0(Ljava_util_List_2_classLit, new XMLTypePackageImpl$27);
    register_0(Ljava_util_List_2_classLit, new XMLTypePackageImpl$28);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$29);
    register_0(Ljava_lang_Integer_2_classLit, new XMLTypePackageImpl$30);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$31);
    register_0(Ljava_lang_Long_2_classLit, new XMLTypePackageImpl$32);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$33);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$34);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$35);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$36);
    register_0(Ljava_util_List_2_classLit, new XMLTypePackageImpl$37);
    register_0(Ljava_util_List_2_classLit, new XMLTypePackageImpl$38);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$39);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$40);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$41);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$42);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$43);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$44);
    register_0(Ljava_lang_Short_2_classLit, new XMLTypePackageImpl$45);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$46);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$47);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$48);
    register_0(Ljava_lang_Short_2_classLit, new XMLTypePackageImpl$49);
    register_0(Ljava_lang_Long_2_classLit, new XMLTypePackageImpl$50);
    register_0(Ljava_lang_String_2_classLit, new XMLTypePackageImpl$51);
    register_0(Ljava_lang_Integer_2_classLit, new XMLTypePackageImpl$52);
}
defineClass(577, 184, {
    109: 1,
    93: 1,
    92: 1,
    154: 1,
    197: 1,
    57: 1,
    240: 1,
    113: 1,
    52: 1,
    98: 1,
    157: 1,
    184: 1,
    117: 1,
    118: 1,
    675: 1,
    1990: 1,
    577: 1
}, XMLTypePackageImpl);
_.isCreated = false;
_.isInitialized = false;
var isInited_1 = false;
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl', 577);
function XMLTypePackageImpl$1() {}
defineClass(1907, 1, {
    830: 1
}, XMLTypePackageImpl$1);
_.getEValidator = function getEValidator_0() {
    return $clinit_XMLTypeValidator(), INSTANCE_12;
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$1_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/1', 1907);
function XMLTypePackageImpl$10() {}
defineClass(1916, 1, $intern_164, XMLTypePackageImpl$10);
_.isInstance = function isInstance_50(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_42(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$10_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/10', 1916);
function XMLTypePackageImpl$11() {}
defineClass(1917, 1, $intern_164, XMLTypePackageImpl$11);
_.isInstance = function isInstance_51(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_43(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$11_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/11', 1917);
function XMLTypePackageImpl$12() {}
defineClass(1918, 1, $intern_164, XMLTypePackageImpl$12);
_.isInstance = function isInstance_52(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_44(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$12_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/12', 1918);
function XMLTypePackageImpl$13() {}
defineClass(1919, 1, $intern_164, XMLTypePackageImpl$13);
_.isInstance = function isInstance_53(instance) {
    return instanceOfDouble(instance);
};
_.newArrayInstance = function newArrayInstance_45(size_0) {
    return initUnidimensionalArray(Ljava_lang_Double_2_classLit, $intern_16, 341, size_0, 7, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$13_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/13', 1919);
function XMLTypePackageImpl$14() {}
defineClass(1920, 1, $intern_164, XMLTypePackageImpl$14);
_.isInstance = function isInstance_54(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_46(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$14_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/14', 1920);
function XMLTypePackageImpl$15() {}
defineClass(1921, 1, $intern_164, XMLTypePackageImpl$15);
_.isInstance = function isInstance_55(instance) {
    return instanceOf(instance, 15);
};
_.newArrayInstance = function newArrayInstance_47(size_0) {
    return initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$15_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/15', 1921);
function XMLTypePackageImpl$16() {}
defineClass(1922, 1, $intern_164, XMLTypePackageImpl$16);
_.isInstance = function isInstance_56(instance) {
    return instanceOf(instance, 15);
};
_.newArrayInstance = function newArrayInstance_48(size_0) {
    return initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$16_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/16', 1922);
function XMLTypePackageImpl$17() {}
defineClass(1923, 1, $intern_164, XMLTypePackageImpl$17);
_.isInstance = function isInstance_57(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_49(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$17_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/17', 1923);
function XMLTypePackageImpl$18() {}
defineClass(1924, 1, $intern_164, XMLTypePackageImpl$18);
_.isInstance = function isInstance_58(instance) {
    return instanceOf(instance, 160);
};
_.newArrayInstance = function newArrayInstance_50(size_0) {
    return initUnidimensionalArray(Ljava_lang_Float_2_classLit, $intern_16, 160, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$18_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/18', 1924);
function XMLTypePackageImpl$19() {}
defineClass(1925, 1, $intern_164, XMLTypePackageImpl$19);
_.isInstance = function isInstance_59(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_51(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$19_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/19', 1925);
function XMLTypePackageImpl$2() {}
defineClass(1908, 1, $intern_164, XMLTypePackageImpl$2);
_.isInstance = function isInstance_60(instance) {
    return instanceOf(instance, 836);
};
_.newArrayInstance = function newArrayInstance_52(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_xml_type_AnyType_2_classLit, $intern_2, 836, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$2_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/2', 1908);
function XMLTypePackageImpl$20() {}
defineClass(1926, 1, $intern_164, XMLTypePackageImpl$20);
_.isInstance = function isInstance_61(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_53(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$20_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/20', 1926);
function XMLTypePackageImpl$21() {}
defineClass(1927, 1, $intern_164, XMLTypePackageImpl$21);
_.isInstance = function isInstance_62(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_54(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$21_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/21', 1927);
function XMLTypePackageImpl$22() {}
defineClass(1928, 1, $intern_164, XMLTypePackageImpl$22);
_.isInstance = function isInstance_63(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_55(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$22_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/22', 1928);
function XMLTypePackageImpl$23() {}
defineClass(1929, 1, $intern_164, XMLTypePackageImpl$23);
_.isInstance = function isInstance_64(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_56(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$23_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/23', 1929);
function XMLTypePackageImpl$24() {}
defineClass(1930, 1, $intern_164, XMLTypePackageImpl$24);
_.isInstance = function isInstance_65(instance) {
    return instanceOf(instance, 195);
};
_.newArrayInstance = function newArrayInstance_57(size_0) {
    return initUnidimensionalArray(B_classLit, $intern_16, 195, size_0, 0, 2);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$24_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/24', 1930);
function XMLTypePackageImpl$25() {}
defineClass(1931, 1, $intern_164, XMLTypePackageImpl$25);
_.isInstance = function isInstance_66(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_58(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$25_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/25', 1931);
function XMLTypePackageImpl$26() {}
defineClass(1932, 1, $intern_164, XMLTypePackageImpl$26);
_.isInstance = function isInstance_67(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_59(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$26_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/26', 1932);
function XMLTypePackageImpl$27() {}
defineClass(1933, 1, $intern_164, XMLTypePackageImpl$27);
_.isInstance = function isInstance_68(instance) {
    return instanceOf(instance, 15);
};
_.newArrayInstance = function newArrayInstance_60(size_0) {
    return initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$27_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/27', 1933);
function XMLTypePackageImpl$28() {}
defineClass(1934, 1, $intern_164, XMLTypePackageImpl$28);
_.isInstance = function isInstance_69(instance) {
    return instanceOf(instance, 15);
};
_.newArrayInstance = function newArrayInstance_61(size_0) {
    return initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$28_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/28', 1934);
function XMLTypePackageImpl$29() {}
defineClass(1935, 1, $intern_164, XMLTypePackageImpl$29);
_.isInstance = function isInstance_70(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_62(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$29_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/29', 1935);
function XMLTypePackageImpl$3() {}
defineClass(1909, 1, $intern_164, XMLTypePackageImpl$3);
_.isInstance = function isInstance_71(instance) {
    return instanceOf(instance, 666);
};
_.newArrayInstance = function newArrayInstance_63(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_xml_type_ProcessingInstruction_2_classLit, $intern_2, 2065, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$3_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/3', 1909);
function XMLTypePackageImpl$30() {}
defineClass(1936, 1, $intern_164, XMLTypePackageImpl$30);
_.isInstance = function isInstance_72(instance) {
    return instanceOf(instance, 17);
};
_.newArrayInstance = function newArrayInstance_64(size_0) {
    return initUnidimensionalArray(Ljava_lang_Integer_2_classLit, $intern_16, 17, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$30_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/30', 1936);
function XMLTypePackageImpl$31() {}
defineClass(1937, 1, $intern_164, XMLTypePackageImpl$31);
_.isInstance = function isInstance_73(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_65(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$31_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/31', 1937);
function XMLTypePackageImpl$32() {}
defineClass(1938, 1, $intern_164, XMLTypePackageImpl$32);
_.isInstance = function isInstance_74(instance) {
    return instanceOf(instance, 190);
};
_.newArrayInstance = function newArrayInstance_66(size_0) {
    return initUnidimensionalArray(Ljava_lang_Long_2_classLit, $intern_16, 190, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$32_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/32', 1938);
function XMLTypePackageImpl$33() {}
defineClass(1939, 1, $intern_164, XMLTypePackageImpl$33);
_.isInstance = function isInstance_75(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_67(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$33_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/33', 1939);
function XMLTypePackageImpl$34() {}
defineClass(1940, 1, $intern_164, XMLTypePackageImpl$34);
_.isInstance = function isInstance_76(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_68(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$34_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/34', 1940);
function XMLTypePackageImpl$35() {}
defineClass(1941, 1, $intern_164, XMLTypePackageImpl$35);
_.isInstance = function isInstance_77(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_69(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$35_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/35', 1941);
function XMLTypePackageImpl$36() {}
defineClass(1942, 1, $intern_164, XMLTypePackageImpl$36);
_.isInstance = function isInstance_78(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_70(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$36_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/36', 1942);
function XMLTypePackageImpl$37() {}
defineClass(1943, 1, $intern_164, XMLTypePackageImpl$37);
_.isInstance = function isInstance_79(instance) {
    return instanceOf(instance, 15);
};
_.newArrayInstance = function newArrayInstance_71(size_0) {
    return initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$37_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/37', 1943);
function XMLTypePackageImpl$38() {}
defineClass(1944, 1, $intern_164, XMLTypePackageImpl$38);
_.isInstance = function isInstance_80(instance) {
    return instanceOf(instance, 15);
};
_.newArrayInstance = function newArrayInstance_72(size_0) {
    return initUnidimensionalArray(Ljava_util_List_2_classLit, $intern_94, 15, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$38_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/38', 1944);
function XMLTypePackageImpl$39() {}
defineClass(1945, 1, $intern_164, XMLTypePackageImpl$39);
_.isInstance = function isInstance_81(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_73(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$39_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/39', 1945);
function XMLTypePackageImpl$4() {}
defineClass(1910, 1, $intern_164, XMLTypePackageImpl$4);
_.isInstance = function isInstance_82(instance) {
    return instanceOf(instance, 667);
};
_.newArrayInstance = function newArrayInstance_74(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_xml_type_SimpleAnyType_2_classLit, $intern_2, 2066, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$4_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/4', 1910);
function XMLTypePackageImpl$40() {}
defineClass(1946, 1, $intern_164, XMLTypePackageImpl$40);
_.isInstance = function isInstance_83(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_75(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$40_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/40', 1946);
function XMLTypePackageImpl$41() {}
defineClass(1947, 1, $intern_164, XMLTypePackageImpl$41);
_.isInstance = function isInstance_84(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_76(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$41_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/41', 1947);
function XMLTypePackageImpl$42() {}
defineClass(1948, 1, $intern_164, XMLTypePackageImpl$42);
_.isInstance = function isInstance_85(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_77(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$42_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/42', 1948);
function XMLTypePackageImpl$43() {}
defineClass(1949, 1, $intern_164, XMLTypePackageImpl$43);
_.isInstance = function isInstance_86(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_78(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$43_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/43', 1949);
function XMLTypePackageImpl$44() {}
defineClass(1950, 1, $intern_164, XMLTypePackageImpl$44);
_.isInstance = function isInstance_87(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_79(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$44_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/44', 1950);
function XMLTypePackageImpl$45() {}
defineClass(1951, 1, $intern_164, XMLTypePackageImpl$45);
_.isInstance = function isInstance_88(instance) {
    return instanceOf(instance, 191);
};
_.newArrayInstance = function newArrayInstance_80(size_0) {
    return initUnidimensionalArray(Ljava_lang_Short_2_classLit, $intern_16, 191, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$45_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/45', 1951);
function XMLTypePackageImpl$46() {}
defineClass(1952, 1, $intern_164, XMLTypePackageImpl$46);
_.isInstance = function isInstance_89(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_81(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$46_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/46', 1952);
function XMLTypePackageImpl$47() {}
defineClass(1953, 1, $intern_164, XMLTypePackageImpl$47);
_.isInstance = function isInstance_90(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_82(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$47_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/47', 1953);
function XMLTypePackageImpl$48() {}
defineClass(1954, 1, $intern_164, XMLTypePackageImpl$48);
_.isInstance = function isInstance_91(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_83(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$48_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/48', 1954);
function XMLTypePackageImpl$49() {}
defineClass(1955, 1, $intern_164, XMLTypePackageImpl$49);
_.isInstance = function isInstance_92(instance) {
    return instanceOf(instance, 191);
};
_.newArrayInstance = function newArrayInstance_84(size_0) {
    return initUnidimensionalArray(Ljava_lang_Short_2_classLit, $intern_16, 191, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$49_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/49', 1955);
function XMLTypePackageImpl$5() {}
defineClass(1911, 1, $intern_164, XMLTypePackageImpl$5);
_.isInstance = function isInstance_93(instance) {
    return instanceOf(instance, 668);
};
_.newArrayInstance = function newArrayInstance_85(size_0) {
    return initUnidimensionalArray(Lorg_eclipse_emf_ecore_xml_type_XMLTypeDocumentRoot_2_classLit, $intern_2, 2067, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$5_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/5', 1911);
function XMLTypePackageImpl$50() {}
defineClass(1956, 1, $intern_164, XMLTypePackageImpl$50);
_.isInstance = function isInstance_94(instance) {
    return instanceOf(instance, 190);
};
_.newArrayInstance = function newArrayInstance_86(size_0) {
    return initUnidimensionalArray(Ljava_lang_Long_2_classLit, $intern_16, 190, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$50_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/50', 1956);
function XMLTypePackageImpl$51() {}
defineClass(1957, 1, $intern_164, XMLTypePackageImpl$51);
_.isInstance = function isInstance_95(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_87(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$51_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/51', 1957);
function XMLTypePackageImpl$52() {}
defineClass(1958, 1, $intern_164, XMLTypePackageImpl$52);
_.isInstance = function isInstance_96(instance) {
    return instanceOf(instance, 17);
};
_.newArrayInstance = function newArrayInstance_88(size_0) {
    return initUnidimensionalArray(Ljava_lang_Integer_2_classLit, $intern_16, 17, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$52_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/52', 1958);
function XMLTypePackageImpl$6() {}
defineClass(1912, 1, $intern_164, XMLTypePackageImpl$6);
_.isInstance = function isInstance_97(instance) {
    return instanceOfString(instance);
};
_.newArrayInstance = function newArrayInstance_89(size_0) {
    return initUnidimensionalArray(Ljava_lang_String_2_classLit, $intern_16, 2, size_0, 6, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$6_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/6', 1912);
function XMLTypePackageImpl$7() {}
defineClass(1913, 1, $intern_164, XMLTypePackageImpl$7);
_.isInstance = function isInstance_98(instance) {
    return instanceOf(instance, 195);
};
_.newArrayInstance = function newArrayInstance_90(size_0) {
    return initUnidimensionalArray(B_classLit, $intern_16, 195, size_0, 0, 2);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$7_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/7', 1913);
function XMLTypePackageImpl$8() {}
defineClass(1914, 1, $intern_164, XMLTypePackageImpl$8);
_.isInstance = function isInstance_99(instance) {
    return instanceOfBoolean(instance);
};
_.newArrayInstance = function newArrayInstance_91(size_0) {
    return initUnidimensionalArray(Ljava_lang_Boolean_2_classLit, $intern_16, 471, size_0, 8, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$8_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/8', 1914);
function XMLTypePackageImpl$9() {}
defineClass(1915, 1, $intern_164, XMLTypePackageImpl$9);
_.isInstance = function isInstance_100(instance) {
    return instanceOf(instance, 219);
};
_.newArrayInstance = function newArrayInstance_92(size_0) {
    return initUnidimensionalArray(Ljava_lang_Byte_2_classLit, $intern_16, 219, size_0, 0, 1);
};
var Lorg_eclipse_emf_ecore_xml_type_impl_XMLTypePackageImpl$9_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.impl', 'XMLTypePackageImpl/9', 1915);
function $clinit_DataValue$Base64() {
    $clinit_DataValue$Base64 = emptyMethod;
    var i, i0, i1, i2, i3, i4, i5, j, j0;
    base64Alphabet = initUnidimensionalArray(B_classLit, $intern_139, 30, 255, 15, 1);
    lookUpBase64Alphabet = initUnidimensionalArray(C_classLit, $intern_44, 30, 64, 15, 1);
    for(i0 = 0; i0 < 255; i0++)base64Alphabet[i0] = -1;
    for(i1 = 90; i1 >= 65; i1--)base64Alphabet[i1] = i1 - 65 << 24 >> 24;
    for(i2 = 122; i2 >= 97; i2--)base64Alphabet[i2] = i2 - 97 + 26 << 24 >> 24;
    for(i3 = 57; i3 >= 48; i3--)base64Alphabet[i3] = i3 - 48 + 52 << 24 >> 24;
    base64Alphabet[43] = 62;
    base64Alphabet[47] = 63;
    for(i4 = 0; i4 <= 25; i4++)lookUpBase64Alphabet[i4] = 65 + i4 & $intern_46;
    for(i5 = 26, j0 = 0; i5 <= 51; ++i5, j0++)lookUpBase64Alphabet[i5] = 97 + j0 & $intern_46;
    for(i = 52, j = 0; i <= 61; ++i, j++)lookUpBase64Alphabet[i] = 48 + j & $intern_46;
    lookUpBase64Alphabet[62] = 43;
    lookUpBase64Alphabet[63] = 47;
}
function decode_0(encoded) {
    $clinit_DataValue$Base64();
    var b1, b2, b3, b4, base64Data, d1, d2, d3, d4, dataIndex, decodedData, encodedIndex, i, len, numberQuadruple, tmp;
    if (encoded == null) return null;
    base64Data = $toCharArray(encoded);
    len = removeWhiteSpace(base64Data);
    if (len % 4 != 0) return null;
    numberQuadruple = len / 4 | 0;
    if (numberQuadruple == 0) return initUnidimensionalArray(B_classLit, $intern_139, 30, 0, 15, 1);
    decodedData = null;
    b1 = 0;
    b2 = 0;
    b3 = 0;
    b4 = 0;
    d1 = 0;
    d2 = 0;
    d3 = 0;
    d4 = 0;
    i = 0;
    encodedIndex = 0;
    dataIndex = 0;
    decodedData = initUnidimensionalArray(B_classLit, $intern_139, 30, numberQuadruple * 3, 15, 1);
    for(; i < numberQuadruple - 1; i++){
        if (!isData(d1 = base64Data[dataIndex++]) || !isData(d2 = base64Data[dataIndex++]) || !isData(d3 = base64Data[dataIndex++]) || !isData(d4 = base64Data[dataIndex++])) return null;
        b1 = base64Alphabet[d1];
        b2 = base64Alphabet[d2];
        b3 = base64Alphabet[d3];
        b4 = base64Alphabet[d4];
        decodedData[encodedIndex++] = (b1 << 2 | b2 >> 4) << 24 >> 24;
        decodedData[encodedIndex++] = ((b2 & 15) << 4 | b3 >> 2 & 15) << 24 >> 24;
        decodedData[encodedIndex++] = (b3 << 6 | b4) << 24 >> 24;
    }
    if (!isData(d1 = base64Data[dataIndex++]) || !isData(d2 = base64Data[dataIndex++])) return null;
    b1 = base64Alphabet[d1];
    b2 = base64Alphabet[d2];
    d3 = base64Data[dataIndex++];
    d4 = base64Data[dataIndex++];
    if (base64Alphabet[d3] == -1 || base64Alphabet[d4] == -1) {
        if (d3 == 61 && d4 == 61) {
            if ((b2 & 15) != 0) return null;
            tmp = initUnidimensionalArray(B_classLit, $intern_139, 30, i * 3 + 1, 15, 1);
            arraycopy(decodedData, 0, tmp, 0, i * 3);
            tmp[encodedIndex] = (b1 << 2 | b2 >> 4) << 24 >> 24;
            return tmp;
        } else if (d3 != 61 && d4 == 61) {
            b3 = base64Alphabet[d3];
            if ((b3 & 3) != 0) return null;
            tmp = initUnidimensionalArray(B_classLit, $intern_139, 30, i * 3 + 2, 15, 1);
            arraycopy(decodedData, 0, tmp, 0, i * 3);
            tmp[encodedIndex++] = (b1 << 2 | b2 >> 4) << 24 >> 24;
            tmp[encodedIndex] = ((b2 & 15) << 4 | b3 >> 2 & 15) << 24 >> 24;
            return tmp;
        } else return null;
    } else {
        b3 = base64Alphabet[d3];
        b4 = base64Alphabet[d4];
        decodedData[encodedIndex++] = (b1 << 2 | b2 >> 4) << 24 >> 24;
        decodedData[encodedIndex++] = ((b2 & 15) << 4 | b3 >> 2 & 15) << 24 >> 24;
        decodedData[encodedIndex++] = (b3 << 6 | b4) << 24 >> 24;
    }
    return decodedData;
}
function encode(binaryData) {
    $clinit_DataValue$Base64();
    var b1, b2, b3, dataIndex, encodedData, encodedIndex, fewerThan24bits, i, k, l, lengthDataBits, numberQuartet, numberTriplets, val1, val2, val3;
    if (binaryData == null) return null;
    lengthDataBits = binaryData.length * 8;
    if (lengthDataBits == 0) return '';
    fewerThan24bits = lengthDataBits % 24;
    numberTriplets = lengthDataBits / 24 | 0;
    numberQuartet = fewerThan24bits != 0 ? numberTriplets + 1 : numberTriplets;
    encodedData = null;
    encodedData = initUnidimensionalArray(C_classLit, $intern_44, 30, numberQuartet * 4, 15, 1);
    k = 0;
    l = 0;
    b1 = 0;
    b2 = 0;
    b3 = 0;
    encodedIndex = 0;
    dataIndex = 0;
    for(i = 0; i < numberTriplets; i++){
        b1 = binaryData[dataIndex++];
        b2 = binaryData[dataIndex++];
        b3 = binaryData[dataIndex++];
        l = (b2 & 15) << 24 >> 24;
        k = (b1 & 3) << 24 >> 24;
        val1 = (b1 & -128) == 0 ? b1 >> 2 << 24 >> 24 : (b1 >> 2 ^ 192) << 24 >> 24;
        val2 = (b2 & -128) == 0 ? b2 >> 4 << 24 >> 24 : (b2 >> 4 ^ 240) << 24 >> 24;
        val3 = (b3 & -128) == 0 ? b3 >> 6 << 24 >> 24 : (b3 >> 6 ^ 252) << 24 >> 24;
        encodedData[encodedIndex++] = lookUpBase64Alphabet[val1];
        encodedData[encodedIndex++] = lookUpBase64Alphabet[val2 | k << 4];
        encodedData[encodedIndex++] = lookUpBase64Alphabet[l << 2 | val3];
        encodedData[encodedIndex++] = lookUpBase64Alphabet[b3 & 63];
    }
    if (fewerThan24bits == 8) {
        b1 = binaryData[dataIndex];
        k = (b1 & 3) << 24 >> 24;
        val1 = (b1 & -128) == 0 ? b1 >> 2 << 24 >> 24 : (b1 >> 2 ^ 192) << 24 >> 24;
        encodedData[encodedIndex++] = lookUpBase64Alphabet[val1];
        encodedData[encodedIndex++] = lookUpBase64Alphabet[k << 4];
        encodedData[encodedIndex++] = 61;
        encodedData[encodedIndex++] = 61;
    } else if (fewerThan24bits == 16) {
        b1 = binaryData[dataIndex];
        b2 = binaryData[dataIndex + 1];
        l = (b2 & 15) << 24 >> 24;
        k = (b1 & 3) << 24 >> 24;
        val1 = (b1 & -128) == 0 ? b1 >> 2 << 24 >> 24 : (b1 >> 2 ^ 192) << 24 >> 24;
        val2 = (b2 & -128) == 0 ? b2 >> 4 << 24 >> 24 : (b2 >> 4 ^ 240) << 24 >> 24;
        encodedData[encodedIndex++] = lookUpBase64Alphabet[val1];
        encodedData[encodedIndex++] = lookUpBase64Alphabet[val2 | k << 4];
        encodedData[encodedIndex++] = lookUpBase64Alphabet[l << 2];
        encodedData[encodedIndex++] = 61;
    }
    return valueOf_8(encodedData, 0, encodedData.length);
}
function isData(octect) {
    return base64Alphabet[octect] != -1;
}
function removeWhiteSpace(data_0) {
    var i, len, newSize;
    newSize = 0;
    len = data_0.length;
    for(i = 0; i < len; i++)data_0[i] == 32 || data_0[i] == 13 || data_0[i] == 10 || data_0[i] == 9 || (data_0[newSize++] = data_0[i]);
    return newSize;
}
var base64Alphabet, lookUpBase64Alphabet;
function $clinit_DataValue$HexBin() {
    $clinit_DataValue$HexBin = emptyMethod;
    var i, i0, i1, i2, i3, i4;
    hexNumberTable = initUnidimensionalArray(B_classLit, $intern_139, 30, 255, 15, 1);
    lookUpHexAlphabet = initUnidimensionalArray(C_classLit, $intern_44, 30, 16, 15, 1);
    for(i0 = 0; i0 < 255; i0++)hexNumberTable[i0] = -1;
    for(i1 = 57; i1 >= 48; i1--)hexNumberTable[i1] = i1 - 48 << 24 >> 24;
    for(i2 = 70; i2 >= 65; i2--)hexNumberTable[i2] = i2 - 65 + 10 << 24 >> 24;
    for(i3 = 102; i3 >= 97; i3--)hexNumberTable[i3] = i3 - 97 + 10 << 24 >> 24;
    for(i4 = 0; i4 < 10; i4++)lookUpHexAlphabet[i4] = 48 + i4 & $intern_46;
    for(i = 10; i <= 15; i++)lookUpHexAlphabet[i] = 65 + i - 10 & $intern_46;
}
function decode_1(encoded) {
    $clinit_DataValue$HexBin();
    var binaryData, decodedData, i, lengthData, lengthDecode, temp1, temp2;
    if (encoded == null) return null;
    lengthData = encoded.length;
    if (lengthData % 2 != 0) return null;
    binaryData = $toCharArray(encoded);
    lengthDecode = lengthData / 2 | 0;
    decodedData = initUnidimensionalArray(B_classLit, $intern_139, 30, lengthDecode, 15, 1);
    for(i = 0; i < lengthDecode; i++){
        temp1 = hexNumberTable[binaryData[i * 2]];
        if (temp1 == -1) return null;
        temp2 = hexNumberTable[binaryData[i * 2 + 1]];
        if (temp2 == -1) return null;
        decodedData[i] = (temp1 << 4 | temp2) << 24 >> 24;
    }
    return decodedData;
}
function encode_0(binaryData) {
    $clinit_DataValue$HexBin();
    var encodedData, i, lengthData, lengthEncode, temp;
    if (binaryData == null) return null;
    lengthData = binaryData.length;
    lengthEncode = lengthData * 2;
    encodedData = initUnidimensionalArray(C_classLit, $intern_44, 30, lengthEncode, 15, 1);
    for(i = 0; i < lengthData; i++){
        temp = binaryData[i];
        temp < 0 && (temp += 256);
        encodedData[i * 2] = lookUpHexAlphabet[temp >> 4];
        encodedData[i * 2 + 1] = lookUpHexAlphabet[temp & 15];
    }
    return valueOf_8(encodedData, 0, encodedData.length);
}
var hexNumberTable, lookUpHexAlphabet;
function $clinit_DataValue$XMLChar() {
    $clinit_DataValue$XMLChar = emptyMethod;
    CHARS = initUnidimensionalArray(B_classLit, $intern_139, 30, $intern_64, 15, 1);
    CHARS[9] = 35;
    CHARS[10] = 19;
    CHARS[13] = 19;
    CHARS[32] = 51;
    CHARS[33] = 49;
    CHARS[34] = 33;
    fill(CHARS, 35, 38, 49);
    CHARS[38] = 1;
    fill(CHARS, 39, 45, 49);
    fill(CHARS, 45, 47, -71);
    CHARS[47] = 49;
    fill(CHARS, 48, 58, -71);
    CHARS[58] = 61;
    CHARS[59] = 49;
    CHARS[60] = 1;
    CHARS[61] = 49;
    CHARS[62] = 33;
    fill(CHARS, 63, 65, 49);
    fill(CHARS, 65, 91, -3);
    fill(CHARS, 91, 93, 33);
    CHARS[93] = 1;
    CHARS[94] = 33;
    CHARS[95] = -3;
    CHARS[96] = 33;
    fill(CHARS, 97, 123, -3);
    fill(CHARS, 123, 183, 33);
    CHARS[183] = -87;
    fill(CHARS, 184, 192, 33);
    fill(CHARS, 192, 215, -19);
    CHARS[215] = 33;
    fill(CHARS, 216, 247, -19);
    CHARS[247] = 33;
    fill(CHARS, 248, 306, -19);
    fill(CHARS, 306, 308, 33);
    fill(CHARS, 308, 319, -19);
    fill(CHARS, 319, 321, 33);
    fill(CHARS, 321, 329, -19);
    CHARS[329] = 33;
    fill(CHARS, 330, 383, -19);
    CHARS[383] = 33;
    fill(CHARS, 384, 452, -19);
    fill(CHARS, 452, 461, 33);
    fill(CHARS, 461, 497, -19);
    fill(CHARS, 497, 500, 33);
    fill(CHARS, 500, 502, -19);
    fill(CHARS, 502, 506, 33);
    fill(CHARS, 506, 536, -19);
    fill(CHARS, 536, 592, 33);
    fill(CHARS, 592, 681, -19);
    fill(CHARS, 681, 699, 33);
    fill(CHARS, 699, 706, -19);
    fill(CHARS, 706, 720, 33);
    fill(CHARS, 720, 722, -87);
    fill(CHARS, 722, 768, 33);
    fill(CHARS, 768, 838, -87);
    fill(CHARS, 838, 864, 33);
    fill(CHARS, 864, 866, -87);
    fill(CHARS, 866, 902, 33);
    CHARS[902] = -19;
    CHARS[903] = -87;
    fill(CHARS, 904, 907, -19);
    CHARS[907] = 33;
    CHARS[908] = -19;
    CHARS[909] = 33;
    fill(CHARS, 910, 930, -19);
    CHARS[930] = 33;
    fill(CHARS, 931, 975, -19);
    CHARS[975] = 33;
    fill(CHARS, 976, 983, -19);
    fill(CHARS, 983, 986, 33);
    CHARS[986] = -19;
    CHARS[987] = 33;
    CHARS[988] = -19;
    CHARS[989] = 33;
    CHARS[990] = -19;
    CHARS[991] = 33;
    CHARS[992] = -19;
    CHARS[993] = 33;
    fill(CHARS, 994, 1012, -19);
    fill(CHARS, 1012, 1025, 33);
    fill(CHARS, 1025, 1037, -19);
    CHARS[1037] = 33;
    fill(CHARS, 1038, 1104, -19);
    CHARS[1104] = 33;
    fill(CHARS, 1105, 1117, -19);
    CHARS[1117] = 33;
    fill(CHARS, 1118, 1154, -19);
    CHARS[1154] = 33;
    fill(CHARS, 1155, 1159, -87);
    fill(CHARS, 1159, 1168, 33);
    fill(CHARS, 1168, 1221, -19);
    fill(CHARS, 1221, 1223, 33);
    fill(CHARS, 1223, 1225, -19);
    fill(CHARS, 1225, 1227, 33);
    fill(CHARS, 1227, 1229, -19);
    fill(CHARS, 1229, 1232, 33);
    fill(CHARS, 1232, 1260, -19);
    fill(CHARS, 1260, 1262, 33);
    fill(CHARS, 1262, 1270, -19);
    fill(CHARS, 1270, 1272, 33);
    fill(CHARS, 1272, 1274, -19);
    fill(CHARS, 1274, 1329, 33);
    fill(CHARS, 1329, 1367, -19);
    fill(CHARS, 1367, 1369, 33);
    CHARS[1369] = -19;
    fill(CHARS, 1370, 1377, 33);
    fill(CHARS, 1377, 1415, -19);
    fill(CHARS, 1415, 1425, 33);
    fill(CHARS, 1425, 1442, -87);
    CHARS[1442] = 33;
    fill(CHARS, 1443, 1466, -87);
    CHARS[1466] = 33;
    fill(CHARS, 1467, 1470, -87);
    CHARS[1470] = 33;
    CHARS[1471] = -87;
    CHARS[1472] = 33;
    fill(CHARS, 1473, 1475, -87);
    CHARS[1475] = 33;
    CHARS[1476] = -87;
    fill(CHARS, 1477, 1488, 33);
    fill(CHARS, 1488, 1515, -19);
    fill(CHARS, 1515, 1520, 33);
    fill(CHARS, 1520, 1523, -19);
    fill(CHARS, 1523, 1569, 33);
    fill(CHARS, 1569, 1595, -19);
    fill(CHARS, 1595, 1600, 33);
    CHARS[1600] = -87;
    fill(CHARS, 1601, 1611, -19);
    fill(CHARS, 1611, 1619, -87);
    fill(CHARS, 1619, 1632, 33);
    fill(CHARS, 1632, 1642, -87);
    fill(CHARS, 1642, 1648, 33);
    CHARS[1648] = -87;
    fill(CHARS, 1649, 1720, -19);
    fill(CHARS, 1720, 1722, 33);
    fill(CHARS, 1722, 1727, -19);
    CHARS[1727] = 33;
    fill(CHARS, 1728, 1743, -19);
    CHARS[1743] = 33;
    fill(CHARS, 1744, 1748, -19);
    CHARS[1748] = 33;
    CHARS[1749] = -19;
    fill(CHARS, 1750, 1765, -87);
    fill(CHARS, 1765, 1767, -19);
    fill(CHARS, 1767, 1769, -87);
    CHARS[1769] = 33;
    fill(CHARS, 1770, 1774, -87);
    fill(CHARS, 1774, 1776, 33);
    fill(CHARS, 1776, 1786, -87);
    fill(CHARS, 1786, 2305, 33);
    fill(CHARS, 2305, 2308, -87);
    CHARS[2308] = 33;
    fill(CHARS, 2309, 2362, -19);
    fill(CHARS, 2362, 2364, 33);
    CHARS[2364] = -87;
    CHARS[2365] = -19;
    fill(CHARS, 2366, 2382, -87);
    fill(CHARS, 2382, 2385, 33);
    fill(CHARS, 2385, 2389, -87);
    fill(CHARS, 2389, 2392, 33);
    fill(CHARS, 2392, 2402, -19);
    fill(CHARS, 2402, 2404, -87);
    fill(CHARS, 2404, 2406, 33);
    fill(CHARS, 2406, 2416, -87);
    fill(CHARS, 2416, 2433, 33);
    fill(CHARS, 2433, 2436, -87);
    CHARS[2436] = 33;
    fill(CHARS, 2437, 2445, -19);
    fill(CHARS, 2445, 2447, 33);
    fill(CHARS, 2447, 2449, -19);
    fill(CHARS, 2449, 2451, 33);
    fill(CHARS, 2451, 2473, -19);
    CHARS[2473] = 33;
    fill(CHARS, 2474, 2481, -19);
    CHARS[2481] = 33;
    CHARS[2482] = -19;
    fill(CHARS, 2483, 2486, 33);
    fill(CHARS, 2486, 2490, -19);
    fill(CHARS, 2490, 2492, 33);
    CHARS[2492] = -87;
    CHARS[2493] = 33;
    fill(CHARS, 2494, 2501, -87);
    fill(CHARS, 2501, 2503, 33);
    fill(CHARS, 2503, 2505, -87);
    fill(CHARS, 2505, 2507, 33);
    fill(CHARS, 2507, 2510, -87);
    fill(CHARS, 2510, 2519, 33);
    CHARS[2519] = -87;
    fill(CHARS, 2520, 2524, 33);
    fill(CHARS, 2524, 2526, -19);
    CHARS[2526] = 33;
    fill(CHARS, 2527, 2530, -19);
    fill(CHARS, 2530, 2532, -87);
    fill(CHARS, 2532, 2534, 33);
    fill(CHARS, 2534, 2544, -87);
    fill(CHARS, 2544, 2546, -19);
    fill(CHARS, 2546, 2562, 33);
    CHARS[2562] = -87;
    fill(CHARS, 2563, 2565, 33);
    fill(CHARS, 2565, 2571, -19);
    fill(CHARS, 2571, 2575, 33);
    fill(CHARS, 2575, 2577, -19);
    fill(CHARS, 2577, 2579, 33);
    fill(CHARS, 2579, 2601, -19);
    CHARS[2601] = 33;
    fill(CHARS, 2602, 2609, -19);
    CHARS[2609] = 33;
    fill(CHARS, 2610, 2612, -19);
    CHARS[2612] = 33;
    fill(CHARS, 2613, 2615, -19);
    CHARS[2615] = 33;
    fill(CHARS, 2616, 2618, -19);
    fill(CHARS, 2618, 2620, 33);
    CHARS[2620] = -87;
    CHARS[2621] = 33;
    fill(CHARS, 2622, 2627, -87);
    fill(CHARS, 2627, 2631, 33);
    fill(CHARS, 2631, 2633, -87);
    fill(CHARS, 2633, 2635, 33);
    fill(CHARS, 2635, 2638, -87);
    fill(CHARS, 2638, 2649, 33);
    fill(CHARS, 2649, 2653, -19);
    CHARS[2653] = 33;
    CHARS[2654] = -19;
    fill(CHARS, 2655, 2662, 33);
    fill(CHARS, 2662, 2674, -87);
    fill(CHARS, 2674, 2677, -19);
    fill(CHARS, 2677, 2689, 33);
    fill(CHARS, 2689, 2692, -87);
    CHARS[2692] = 33;
    fill(CHARS, 2693, 2700, -19);
    CHARS[2700] = 33;
    CHARS[2701] = -19;
    CHARS[2702] = 33;
    fill(CHARS, 2703, 2706, -19);
    CHARS[2706] = 33;
    fill(CHARS, 2707, 2729, -19);
    CHARS[2729] = 33;
    fill(CHARS, 2730, 2737, -19);
    CHARS[2737] = 33;
    fill(CHARS, 2738, 2740, -19);
    CHARS[2740] = 33;
    fill(CHARS, 2741, 2746, -19);
    fill(CHARS, 2746, 2748, 33);
    CHARS[2748] = -87;
    CHARS[2749] = -19;
    fill(CHARS, 2750, 2758, -87);
    CHARS[2758] = 33;
    fill(CHARS, 2759, 2762, -87);
    CHARS[2762] = 33;
    fill(CHARS, 2763, 2766, -87);
    fill(CHARS, 2766, 2784, 33);
    CHARS[2784] = -19;
    fill(CHARS, 2785, 2790, 33);
    fill(CHARS, 2790, 2800, -87);
    fill(CHARS, 2800, 2817, 33);
    fill(CHARS, 2817, 2820, -87);
    CHARS[2820] = 33;
    fill(CHARS, 2821, 2829, -19);
    fill(CHARS, 2829, 2831, 33);
    fill(CHARS, 2831, 2833, -19);
    fill(CHARS, 2833, 2835, 33);
    fill(CHARS, 2835, 2857, -19);
    CHARS[2857] = 33;
    fill(CHARS, 2858, 2865, -19);
    CHARS[2865] = 33;
    fill(CHARS, 2866, 2868, -19);
    fill(CHARS, 2868, 2870, 33);
    fill(CHARS, 2870, 2874, -19);
    fill(CHARS, 2874, 2876, 33);
    CHARS[2876] = -87;
    CHARS[2877] = -19;
    fill(CHARS, 2878, 2884, -87);
    fill(CHARS, 2884, 2887, 33);
    fill(CHARS, 2887, 2889, -87);
    fill(CHARS, 2889, 2891, 33);
    fill(CHARS, 2891, 2894, -87);
    fill(CHARS, 2894, 2902, 33);
    fill(CHARS, 2902, 2904, -87);
    fill(CHARS, 2904, 2908, 33);
    fill(CHARS, 2908, 2910, -19);
    CHARS[2910] = 33;
    fill(CHARS, 2911, 2914, -19);
    fill(CHARS, 2914, 2918, 33);
    fill(CHARS, 2918, 2928, -87);
    fill(CHARS, 2928, 2946, 33);
    fill(CHARS, 2946, 2948, -87);
    CHARS[2948] = 33;
    fill(CHARS, 2949, 2955, -19);
    fill(CHARS, 2955, 2958, 33);
    fill(CHARS, 2958, 2961, -19);
    CHARS[2961] = 33;
    fill(CHARS, 2962, 2966, -19);
    fill(CHARS, 2966, 2969, 33);
    fill(CHARS, 2969, 2971, -19);
    CHARS[2971] = 33;
    CHARS[2972] = -19;
    CHARS[2973] = 33;
    fill(CHARS, 2974, 2976, -19);
    fill(CHARS, 2976, 2979, 33);
    fill(CHARS, 2979, 2981, -19);
    fill(CHARS, 2981, 2984, 33);
    fill(CHARS, 2984, 2987, -19);
    fill(CHARS, 2987, 2990, 33);
    fill(CHARS, 2990, 2998, -19);
    CHARS[2998] = 33;
    fill(CHARS, 2999, 3002, -19);
    fill(CHARS, 3002, 3006, 33);
    fill(CHARS, 3006, 3011, -87);
    fill(CHARS, 3011, 3014, 33);
    fill(CHARS, 3014, 3017, -87);
    CHARS[3017] = 33;
    fill(CHARS, 3018, 3022, -87);
    fill(CHARS, 3022, 3031, 33);
    CHARS[3031] = -87;
    fill(CHARS, 3032, 3047, 33);
    fill(CHARS, 3047, 3056, -87);
    fill(CHARS, 3056, 3073, 33);
    fill(CHARS, 3073, 3076, -87);
    CHARS[3076] = 33;
    fill(CHARS, 3077, 3085, -19);
    CHARS[3085] = 33;
    fill(CHARS, 3086, 3089, -19);
    CHARS[3089] = 33;
    fill(CHARS, 3090, 3113, -19);
    CHARS[3113] = 33;
    fill(CHARS, 3114, 3124, -19);
    CHARS[3124] = 33;
    fill(CHARS, 3125, 3130, -19);
    fill(CHARS, 3130, 3134, 33);
    fill(CHARS, 3134, 3141, -87);
    CHARS[3141] = 33;
    fill(CHARS, 3142, 3145, -87);
    CHARS[3145] = 33;
    fill(CHARS, 3146, 3150, -87);
    fill(CHARS, 3150, 3157, 33);
    fill(CHARS, 3157, 3159, -87);
    fill(CHARS, 3159, 3168, 33);
    fill(CHARS, 3168, 3170, -19);
    fill(CHARS, 3170, 3174, 33);
    fill(CHARS, 3174, 3184, -87);
    fill(CHARS, 3184, 3202, 33);
    fill(CHARS, 3202, 3204, -87);
    CHARS[3204] = 33;
    fill(CHARS, 3205, 3213, -19);
    CHARS[3213] = 33;
    fill(CHARS, 3214, 3217, -19);
    CHARS[3217] = 33;
    fill(CHARS, 3218, 3241, -19);
    CHARS[3241] = 33;
    fill(CHARS, 3242, 3252, -19);
    CHARS[3252] = 33;
    fill(CHARS, 3253, 3258, -19);
    fill(CHARS, 3258, 3262, 33);
    fill(CHARS, 3262, 3269, -87);
    CHARS[3269] = 33;
    fill(CHARS, 3270, 3273, -87);
    CHARS[3273] = 33;
    fill(CHARS, 3274, 3278, -87);
    fill(CHARS, 3278, 3285, 33);
    fill(CHARS, 3285, 3287, -87);
    fill(CHARS, 3287, 3294, 33);
    CHARS[3294] = -19;
    CHARS[3295] = 33;
    fill(CHARS, 3296, 3298, -19);
    fill(CHARS, 3298, 3302, 33);
    fill(CHARS, 3302, 3312, -87);
    fill(CHARS, 3312, 3330, 33);
    fill(CHARS, 3330, 3332, -87);
    CHARS[3332] = 33;
    fill(CHARS, 3333, 3341, -19);
    CHARS[3341] = 33;
    fill(CHARS, 3342, 3345, -19);
    CHARS[3345] = 33;
    fill(CHARS, 3346, 3369, -19);
    CHARS[3369] = 33;
    fill(CHARS, 3370, 3386, -19);
    fill(CHARS, 3386, 3390, 33);
    fill(CHARS, 3390, 3396, -87);
    fill(CHARS, 3396, 3398, 33);
    fill(CHARS, 3398, 3401, -87);
    CHARS[3401] = 33;
    fill(CHARS, 3402, 3406, -87);
    fill(CHARS, 3406, 3415, 33);
    CHARS[3415] = -87;
    fill(CHARS, 3416, 3424, 33);
    fill(CHARS, 3424, 3426, -19);
    fill(CHARS, 3426, 3430, 33);
    fill(CHARS, 3430, 3440, -87);
    fill(CHARS, 3440, 3585, 33);
    fill(CHARS, 3585, 3631, -19);
    CHARS[3631] = 33;
    CHARS[3632] = -19;
    CHARS[3633] = -87;
    fill(CHARS, 3634, 3636, -19);
    fill(CHARS, 3636, 3643, -87);
    fill(CHARS, 3643, 3648, 33);
    fill(CHARS, 3648, 3654, -19);
    fill(CHARS, 3654, 3663, -87);
    CHARS[3663] = 33;
    fill(CHARS, 3664, 3674, -87);
    fill(CHARS, 3674, 3713, 33);
    fill(CHARS, 3713, 3715, -19);
    CHARS[3715] = 33;
    CHARS[3716] = -19;
    fill(CHARS, 3717, 3719, 33);
    fill(CHARS, 3719, 3721, -19);
    CHARS[3721] = 33;
    CHARS[3722] = -19;
    fill(CHARS, 3723, 3725, 33);
    CHARS[3725] = -19;
    fill(CHARS, 3726, 3732, 33);
    fill(CHARS, 3732, 3736, -19);
    CHARS[3736] = 33;
    fill(CHARS, 3737, 3744, -19);
    CHARS[3744] = 33;
    fill(CHARS, 3745, 3748, -19);
    CHARS[3748] = 33;
    CHARS[3749] = -19;
    CHARS[3750] = 33;
    CHARS[3751] = -19;
    fill(CHARS, 3752, 3754, 33);
    fill(CHARS, 3754, 3756, -19);
    CHARS[3756] = 33;
    fill(CHARS, 3757, 3759, -19);
    CHARS[3759] = 33;
    CHARS[3760] = -19;
    CHARS[3761] = -87;
    fill(CHARS, 3762, 3764, -19);
    fill(CHARS, 3764, 3770, -87);
    CHARS[3770] = 33;
    fill(CHARS, 3771, 3773, -87);
    CHARS[3773] = -19;
    fill(CHARS, 3774, 3776, 33);
    fill(CHARS, 3776, 3781, -19);
    CHARS[3781] = 33;
    CHARS[3782] = -87;
    CHARS[3783] = 33;
    fill(CHARS, 3784, 3790, -87);
    fill(CHARS, 3790, 3792, 33);
    fill(CHARS, 3792, 3802, -87);
    fill(CHARS, 3802, 3864, 33);
    fill(CHARS, 3864, 3866, -87);
    fill(CHARS, 3866, 3872, 33);
    fill(CHARS, 3872, 3882, -87);
    fill(CHARS, 3882, 3893, 33);
    CHARS[3893] = -87;
    CHARS[3894] = 33;
    CHARS[3895] = -87;
    CHARS[3896] = 33;
    CHARS[3897] = -87;
    fill(CHARS, 3898, 3902, 33);
    fill(CHARS, 3902, 3904, -87);
    fill(CHARS, 3904, 3912, -19);
    CHARS[3912] = 33;
    fill(CHARS, 3913, 3946, -19);
    fill(CHARS, 3946, 3953, 33);
    fill(CHARS, 3953, 3973, -87);
    CHARS[3973] = 33;
    fill(CHARS, 3974, 3980, -87);
    fill(CHARS, 3980, 3984, 33);
    fill(CHARS, 3984, 3990, -87);
    CHARS[3990] = 33;
    CHARS[3991] = -87;
    CHARS[3992] = 33;
    fill(CHARS, 3993, 4014, -87);
    fill(CHARS, 4014, 4017, 33);
    fill(CHARS, 4017, 4024, -87);
    CHARS[4024] = 33;
    CHARS[4025] = -87;
    fill(CHARS, 4026, 4256, 33);
    fill(CHARS, 4256, 4294, -19);
    fill(CHARS, 4294, 4304, 33);
    fill(CHARS, 4304, 4343, -19);
    fill(CHARS, 4343, 4352, 33);
    CHARS[4352] = -19;
    CHARS[4353] = 33;
    fill(CHARS, 4354, 4356, -19);
    CHARS[4356] = 33;
    fill(CHARS, 4357, 4360, -19);
    CHARS[4360] = 33;
    CHARS[4361] = -19;
    CHARS[4362] = 33;
    fill(CHARS, 4363, 4365, -19);
    CHARS[4365] = 33;
    fill(CHARS, 4366, 4371, -19);
    fill(CHARS, 4371, 4412, 33);
    CHARS[4412] = -19;
    CHARS[4413] = 33;
    CHARS[4414] = -19;
    CHARS[4415] = 33;
    CHARS[4416] = -19;
    fill(CHARS, 4417, 4428, 33);
    CHARS[4428] = -19;
    CHARS[4429] = 33;
    CHARS[4430] = -19;
    CHARS[4431] = 33;
    CHARS[4432] = -19;
    fill(CHARS, 4433, 4436, 33);
    fill(CHARS, 4436, 4438, -19);
    fill(CHARS, 4438, 4441, 33);
    CHARS[4441] = -19;
    fill(CHARS, 4442, 4447, 33);
    fill(CHARS, 4447, 4450, -19);
    CHARS[4450] = 33;
    CHARS[4451] = -19;
    CHARS[4452] = 33;
    CHARS[4453] = -19;
    CHARS[4454] = 33;
    CHARS[4455] = -19;
    CHARS[4456] = 33;
    CHARS[4457] = -19;
    fill(CHARS, 4458, 4461, 33);
    fill(CHARS, 4461, 4463, -19);
    fill(CHARS, 4463, 4466, 33);
    fill(CHARS, 4466, 4468, -19);
    CHARS[4468] = 33;
    CHARS[4469] = -19;
    fill(CHARS, 4470, 4510, 33);
    CHARS[4510] = -19;
    fill(CHARS, 4511, 4520, 33);
    CHARS[4520] = -19;
    fill(CHARS, 4521, 4523, 33);
    CHARS[4523] = -19;
    fill(CHARS, 4524, 4526, 33);
    fill(CHARS, 4526, 4528, -19);
    fill(CHARS, 4528, 4535, 33);
    fill(CHARS, 4535, 4537, -19);
    CHARS[4537] = 33;
    CHARS[4538] = -19;
    CHARS[4539] = 33;
    fill(CHARS, 4540, 4547, -19);
    fill(CHARS, 4547, 4587, 33);
    CHARS[4587] = -19;
    fill(CHARS, 4588, 4592, 33);
    CHARS[4592] = -19;
    fill(CHARS, 4593, 4601, 33);
    CHARS[4601] = -19;
    fill(CHARS, 4602, 7680, 33);
    fill(CHARS, 7680, 7836, -19);
    fill(CHARS, 7836, 7840, 33);
    fill(CHARS, 7840, 7930, -19);
    fill(CHARS, 7930, 7936, 33);
    fill(CHARS, 7936, 7958, -19);
    fill(CHARS, 7958, 7960, 33);
    fill(CHARS, 7960, 7966, -19);
    fill(CHARS, 7966, 7968, 33);
    fill(CHARS, 7968, 8006, -19);
    fill(CHARS, 8006, 8008, 33);
    fill(CHARS, 8008, 8014, -19);
    fill(CHARS, 8014, 8016, 33);
    fill(CHARS, 8016, 8024, -19);
    CHARS[8024] = 33;
    CHARS[8025] = -19;
    CHARS[8026] = 33;
    CHARS[8027] = -19;
    CHARS[8028] = 33;
    CHARS[8029] = -19;
    CHARS[8030] = 33;
    fill(CHARS, 8031, 8062, -19);
    fill(CHARS, 8062, 8064, 33);
    fill(CHARS, 8064, 8117, -19);
    CHARS[8117] = 33;
    fill(CHARS, 8118, 8125, -19);
    CHARS[8125] = 33;
    CHARS[8126] = -19;
    fill(CHARS, 8127, 8130, 33);
    fill(CHARS, 8130, 8133, -19);
    CHARS[8133] = 33;
    fill(CHARS, 8134, 8141, -19);
    fill(CHARS, 8141, 8144, 33);
    fill(CHARS, 8144, 8148, -19);
    fill(CHARS, 8148, 8150, 33);
    fill(CHARS, 8150, 8156, -19);
    fill(CHARS, 8156, 8160, 33);
    fill(CHARS, 8160, 8173, -19);
    fill(CHARS, 8173, 8178, 33);
    fill(CHARS, 8178, 8181, -19);
    CHARS[8181] = 33;
    fill(CHARS, 8182, 8189, -19);
    fill(CHARS, 8189, 8400, 33);
    fill(CHARS, 8400, 8413, -87);
    fill(CHARS, 8413, 8417, 33);
    CHARS[8417] = -87;
    fill(CHARS, 8418, 8486, 33);
    CHARS[8486] = -19;
    fill(CHARS, 8487, 8490, 33);
    fill(CHARS, 8490, 8492, -19);
    fill(CHARS, 8492, 8494, 33);
    CHARS[8494] = -19;
    fill(CHARS, 8495, 8576, 33);
    fill(CHARS, 8576, 8579, -19);
    fill(CHARS, 8579, 12293, 33);
    CHARS[12293] = -87;
    CHARS[12294] = 33;
    CHARS[12295] = -19;
    fill(CHARS, 12296, 12321, 33);
    fill(CHARS, 12321, 12330, -19);
    fill(CHARS, 12330, 12336, -87);
    CHARS[12336] = 33;
    fill(CHARS, 12337, 12342, -87);
    fill(CHARS, 12342, 12353, 33);
    fill(CHARS, 12353, 12437, -19);
    fill(CHARS, 12437, 12441, 33);
    fill(CHARS, 12441, 12443, -87);
    fill(CHARS, 12443, 12445, 33);
    fill(CHARS, 12445, 12447, -87);
    fill(CHARS, 12447, 12449, 33);
    fill(CHARS, 12449, 12539, -19);
    CHARS[12539] = 33;
    fill(CHARS, 12540, 12543, -87);
    fill(CHARS, 12543, 12549, 33);
    fill(CHARS, 12549, 12589, -19);
    fill(CHARS, 12589, 19968, 33);
    fill(CHARS, 19968, 40870, -19);
    fill(CHARS, 40870, 44032, 33);
    fill(CHARS, 44032, 55204, -19);
    fill(CHARS, 55204, $intern_65, 33);
    fill(CHARS, 57344, 65534, 33);
}
var CHARS;
function RegEx$ParseException(mes) {
    RuntimeException_0.call(this, mes);
}
defineClass(53, 63, $intern_43, RegEx$ParseException);
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$ParseException_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/ParseException', 53);
function $next_16(this$static) {
    var ch_0, low, ret;
    if (this$static.offset >= this$static.regexlen) {
        this$static.chardata = -1;
        this$static.nexttoken = 1;
        return;
    }
    ch_0 = $charAt(this$static.regex, this$static.offset++);
    this$static.chardata = ch_0;
    if (this$static.context == 1) {
        switch(ch_0){
            case 92:
                ret = 10;
                if (this$static.offset >= this$static.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.1'))));
                this$static.chardata = $charAt(this$static.regex, this$static.offset++);
                break;
            case 45:
                if ((this$static.options_0 & 512) == 512 && this$static.offset < this$static.regexlen && $charAt(this$static.regex, this$static.offset) == 91) {
                    ++this$static.offset;
                    ret = 24;
                } else ret = 0;
                break;
            case 91:
                if ((this$static.options_0 & 512) != 512 && this$static.offset < this$static.regexlen && $charAt(this$static.regex, this$static.offset) == 58) {
                    ++this$static.offset;
                    ret = 20;
                    break;
                }
            default:
                if ((ch_0 & 64512) == $intern_65 && this$static.offset < this$static.regexlen) {
                    low = $charAt(this$static.regex, this$static.offset);
                    if ((low & 64512) == 56320) {
                        this$static.chardata = $intern_64 + (ch_0 - $intern_65 << 10) + low - 56320;
                        ++this$static.offset;
                    }
                }
                ret = 0;
        }
        this$static.nexttoken = ret;
        return;
    }
    switch(ch_0){
        case 124:
            ret = 2;
            break;
        case 42:
            ret = 3;
            break;
        case 43:
            ret = 4;
            break;
        case 63:
            ret = 5;
            break;
        case 41:
            ret = 7;
            break;
        case 46:
            ret = 8;
            break;
        case 91:
            ret = 9;
            break;
        case 94:
            ret = 11;
            break;
        case 36:
            ret = 12;
            break;
        case 40:
            ret = 6;
            if (this$static.offset >= this$static.regexlen) break;
            if ($charAt(this$static.regex, this$static.offset) != 63) break;
            if (++this$static.offset >= this$static.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.2'))));
            ch_0 = $charAt(this$static.regex, this$static.offset++);
            switch(ch_0){
                case 58:
                    ret = 13;
                    break;
                case 61:
                    ret = 14;
                    break;
                case 33:
                    ret = 15;
                    break;
                case 91:
                    ret = 19;
                    break;
                case 62:
                    ret = 18;
                    break;
                case 60:
                    if (this$static.offset >= this$static.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.2'))));
                    ch_0 = $charAt(this$static.regex, this$static.offset++);
                    if (ch_0 == 61) ret = 16;
                    else if (ch_0 == 33) ret = 17;
                    else throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.3'))));
                    break;
                case 35:
                    while(this$static.offset < this$static.regexlen){
                        ch_0 = $charAt(this$static.regex, this$static.offset++);
                        if (ch_0 == 41) break;
                    }
                    if (ch_0 != 41) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.4'))));
                    ret = 21;
                    break;
                default:
                    if (ch_0 == 45 || 97 <= ch_0 && ch_0 <= 122 || 65 <= ch_0 && ch_0 <= 90) {
                        --this$static.offset;
                        ret = 22;
                        break;
                    } else if (ch_0 == 40) {
                        ret = 23;
                        break;
                    }
                    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.2'))));
            }
            break;
        case 92:
            ret = 10;
            if (this$static.offset >= this$static.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.1'))));
            this$static.chardata = $charAt(this$static.regex, this$static.offset++);
            break;
        default:
            ret = 0;
    }
    this$static.nexttoken = ret;
}
function $parse_3(this$static, regex, options) {
    var i, position, ret;
    this$static.options_0 = options;
    this$static.offset = 0;
    this$static.context = 0;
    this$static.parennumber = 1;
    this$static.regex = regex;
    (this$static.options_0 & 16) == 16 && (this$static.regex = stripExtendedComment(this$static.regex));
    this$static.regexlen = this$static.regex.length;
    $next_16(this$static);
    ret = $parseRegex(this$static);
    if (this$static.offset != this$static.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.parse.1'))));
    if (this$static.references) {
        for(i = 0; i < this$static.references.arrayList.array.length; i++){
            position = castTo($elementAt(this$static.references, i), 575);
            if (this$static.parennumber <= position.refNumber) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.parse.2'))));
        }
        this$static.references.arrayList.array.length = 0;
    }
    return ret;
}
function $parseAtom(this$static) {
    var ch_0, ch2, high, sur, tok;
    ch_0 = this$static.nexttoken;
    tok = null;
    switch(ch_0){
        case 6:
            return this$static.processParen();
        case 13:
            return this$static.processParen2();
        case 23:
            return this$static.processCondition();
        case 22:
            return this$static.processModifiers();
        case 18:
            return this$static.processIndependent();
        case 8:
            $next_16(this$static);
            tok = ($clinit_RegEx$Token(), token_dot);
            break;
        case 9:
            return this$static.parseCharacterClass(true);
        case 19:
            return this$static.parseSetOperations();
        case 10:
            switch(this$static.chardata){
                case 100:
                case 68:
                case 119:
                case 87:
                case 115:
                case 83:
                    tok = this$static.getTokenForShorthand(this$static.chardata);
                    $next_16(this$static);
                    return tok;
                case 101:
                case 102:
                case 110:
                case 114:
                case 116:
                case 117:
                case 118:
                case 120:
                    ch2 = this$static.decodeEscaped();
                    ch2 < $intern_64 ? tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$CharToken(0, ch2)) : tok = createString_0(decomposeToSurrogates(ch2));
                    break;
                case 99:
                    return this$static.processBacksolidus_c();
                case 67:
                    return this$static.processBacksolidus_C();
                case 105:
                    return this$static.processBacksolidus_i();
                case 73:
                    return this$static.processBacksolidus_I();
                case 103:
                    return this$static.processBacksolidus_g();
                case 88:
                    return this$static.processBacksolidus_X();
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    return this$static.processBackreference();
                case 80:
                case 112:
                    tok = $processBacksolidus_pP(this$static, this$static.chardata);
                    if (!tok) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.5'))));
                    break;
                default:
                    tok = createChar(this$static.chardata);
            }
            $next_16(this$static);
            break;
        case 0:
            if (this$static.chardata == 93 || this$static.chardata == 123 || this$static.chardata == 125) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.4'))));
            tok = createChar(this$static.chardata);
            high = this$static.chardata;
            $next_16(this$static);
            if ((high & 64512) == $intern_65 && this$static.nexttoken == 0 && (this$static.chardata & 64512) == 56320) {
                sur = initUnidimensionalArray(C_classLit, $intern_44, 30, 2, 15, 1);
                sur[0] = high & $intern_46;
                sur[1] = this$static.chardata & $intern_46;
                tok = createParen(createString_0(valueOf_8(sur, 0, sur.length)), 0);
                $next_16(this$static);
            }
            break;
        default:
            throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.4'))));
    }
    return tok;
}
function $parseFactor(this$static) {
    var ch_0, max_0, min_0, off, tok;
    ch_0 = this$static.nexttoken;
    switch(ch_0){
        case 11:
            return this$static.processCaret();
        case 12:
            return this$static.processDollar();
        case 14:
            return this$static.processLookahead();
        case 15:
            return this$static.processNegativelookahead();
        case 16:
            return this$static.processLookbehind();
        case 17:
            return this$static.processNegativelookbehind();
        case 21:
            $next_16(this$static);
            return $clinit_RegEx$Token(), $clinit_RegEx$Token(), token_empty;
        case 10:
            switch(this$static.chardata){
                case 65:
                    return this$static.processBacksolidus_A();
                case 90:
                    return this$static.processBacksolidus_Z();
                case 122:
                    return this$static.processBacksolidus_z();
                case 98:
                    return this$static.processBacksolidus_b();
                case 66:
                    return this$static.processBacksolidus_B();
                case 60:
                    return this$static.processBacksolidus_lt();
                case 62:
                    return this$static.processBacksolidus_gt();
            }
    }
    tok = $parseAtom(this$static);
    ch_0 = this$static.nexttoken;
    switch(ch_0){
        case 3:
            return this$static.processStar(tok);
        case 4:
            return this$static.processPlus(tok);
        case 5:
            return this$static.processQuestion(tok);
        case 0:
            if (this$static.chardata == 123 && this$static.offset < this$static.regexlen) {
                off = this$static.offset;
                min_0 = 0;
                max_0 = -1;
                if ((ch_0 = $charAt(this$static.regex, off++)) >= 48 && ch_0 <= 57) {
                    min_0 = ch_0 - 48;
                    while(off < this$static.regexlen && (ch_0 = $charAt(this$static.regex, off++)) >= 48 && ch_0 <= 57){
                        min_0 = min_0 * 10 + ch_0 - 48;
                        if (min_0 < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.quantifier.5'))));
                    }
                } else throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.quantifier.1'))));
                max_0 = min_0;
                if (ch_0 == 44) {
                    if (off >= this$static.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.quantifier.3'))));
                    else if ((ch_0 = $charAt(this$static.regex, off++)) >= 48 && ch_0 <= 57) {
                        max_0 = ch_0 - 48;
                        while(off < this$static.regexlen && (ch_0 = $charAt(this$static.regex, off++)) >= 48 && ch_0 <= 57){
                            max_0 = max_0 * 10 + ch_0 - 48;
                            if (max_0 < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.quantifier.5'))));
                        }
                        if (min_0 > max_0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.quantifier.4'))));
                    } else max_0 = -1;
                }
                if (ch_0 != 125) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.quantifier.2'))));
                if (this$static.checkQuestion(off)) {
                    tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(9, tok));
                    this$static.offset = off + 1;
                } else {
                    tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(3, tok));
                    this$static.offset = off;
                }
                tok.setMin(min_0);
                tok.setMax(max_0);
                $next_16(this$static);
            }
    }
    return tok;
}
function $parseRegex(this$static) {
    var parent_0, tok;
    tok = $parseTerm(this$static);
    parent_0 = null;
    while(this$static.nexttoken == 2){
        $next_16(this$static);
        if (!parent_0) {
            parent_0 = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$UnionToken(2));
            $addChild_0(parent_0, tok);
            tok = parent_0;
        }
        tok.addChild($parseTerm(this$static));
    }
    return tok;
}
function $parseTerm(this$static) {
    var ch_0, concat, tok;
    ch_0 = this$static.nexttoken;
    if (ch_0 == 2 || ch_0 == 7 || ch_0 == 1) return $clinit_RegEx$Token(), $clinit_RegEx$Token(), token_empty;
    else {
        tok = $parseFactor(this$static);
        concat = null;
        while((ch_0 = this$static.nexttoken) != 2 && ch_0 != 7 && ch_0 != 1){
            if (!concat) {
                concat = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$UnionToken(1));
                $addChild_0(concat, tok);
                tok = concat;
            }
            $addChild_0(concat, $parseFactor(this$static));
        }
        return tok;
    }
}
function $processBacksolidus_pP(this$static, c) {
    var nameend, namestart, pname, positive;
    $next_16(this$static);
    if (this$static.nexttoken != 0 || this$static.chardata != 123) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.2'))));
    positive = c == 112;
    namestart = this$static.offset;
    nameend = $indexOf_0(this$static.regex, 125, namestart);
    if (nameend < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.3'))));
    pname = $substring_1(this$static.regex, namestart, nameend);
    this$static.offset = nameend + 1;
    return getRange_1(pname, positive, (this$static.options_0 & 512) == 512);
}
function RegEx$RegexParser() {}
function hexChar(ch_0) {
    if (ch_0 < 48) return -1;
    if (ch_0 > 102) return -1;
    if (ch_0 <= 57) return ch_0 - 48;
    if (ch_0 < 65) return -1;
    if (ch_0 <= 70) return ch_0 - 65 + 10;
    if (ch_0 < 97) return -1;
    return ch_0 - 97 + 10;
}
defineClass(815, 1, {}, RegEx$RegexParser);
_.checkQuestion = function checkQuestion(off) {
    return off < this.regexlen && $charAt(this.regex, off) == 63;
};
_.decodeEscaped = function decodeEscaped() {
    var c, uv, uv0, v1, v10;
    if (this.nexttoken != 10) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.1'))));
    c = this.chardata;
    switch(c){
        case 101:
            c = 27;
            break;
        case 102:
            c = 12;
            break;
        case 110:
            c = 10;
            break;
        case 114:
            c = 13;
            break;
        case 116:
            c = 9;
            break;
        case 120:
            $next_16(this);
            if (this.nexttoken != 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            if (this.chardata == 123) {
                v10 = 0;
                uv0 = 0;
                do {
                    $next_16(this);
                    if (this.nexttoken != 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
                    if ((v10 = hexChar(this.chardata)) < 0) break;
                    if (uv0 > uv0 * 16) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.2'))));
                    uv0 = uv0 * 16 + v10;
                }while (true);
                if (this.chardata != 125) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.3'))));
                if (uv0 > $intern_167) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.4'))));
                c = uv0;
            } else {
                v10 = 0;
                if (this.nexttoken != 0 || (v10 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
                uv0 = v10;
                $next_16(this);
                if (this.nexttoken != 0 || (v10 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
                uv0 = uv0 * 16 + v10;
                c = uv0;
            }
            break;
        case 117:
            v1 = 0;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            c = uv;
            break;
        case 118:
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            $next_16(this);
            if (this.nexttoken != 0 || (v1 = hexChar(this.chardata)) < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.1'))));
            uv = uv * 16 + v1;
            if (uv > $intern_167) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descappe.4'))));
            c = uv;
            break;
        case 65:
        case 90:
        case 122:
            throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.descape.5'))));
    }
    return c;
};
_.getTokenForShorthand = function getTokenForShorthand(ch_0) {
    var number, tok;
    switch(ch_0){
        case 100:
            tok = (this.options_0 & 32) == 32 ? getRange_0('Nd', true) : ($clinit_RegEx$Token(), token_0to9);
            break;
        case 68:
            tok = (this.options_0 & 32) == 32 ? getRange_0('Nd', false) : ($clinit_RegEx$Token(), token_not_0to9);
            break;
        case 119:
            tok = (this.options_0 & 32) == 32 ? getRange_0('IsWord', true) : ($clinit_RegEx$Token(), token_wordchars);
            break;
        case 87:
            tok = (this.options_0 & 32) == 32 ? getRange_0('IsWord', false) : ($clinit_RegEx$Token(), token_not_wordchars);
            break;
        case 115:
            tok = (this.options_0 & 32) == 32 ? getRange_0('IsSpace', true) : ($clinit_RegEx$Token(), token_spaces);
            break;
        case 83:
            tok = (this.options_0 & 32) == 32 ? getRange_0('IsSpace', false) : ($clinit_RegEx$Token(), token_not_spaces);
            break;
        default:
            throw toJs(new RuntimeException_0((number = ch_0, 'Internal Error: shorthands: \\u' + number.toString(16))));
    }
    return tok;
};
_.parseCharacterClass = function parseCharacterClass(useNrange) {
    var base, c, end, firstloop, name_0, nameend, positive, range, rangeend, tok, tok2, type_0;
    this.context = 1;
    $next_16(this);
    base = null;
    if (this.nexttoken == 0 && this.chardata == 94) {
        $next_16(this);
        if (useNrange) tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$RangeToken(5));
        else {
            base = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$RangeToken(4));
            $addRange(base, 0, $intern_167);
            tok = (++tokens_0, new RegEx$RangeToken(4));
        }
    } else tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$RangeToken(4));
    firstloop = true;
    while((type_0 = this.nexttoken) != 1){
        if (type_0 == 0 && this.chardata == 93 && !firstloop) break;
        firstloop = false;
        c = this.chardata;
        end = false;
        if (type_0 == 10) switch(c){
            case 100:
            case 68:
            case 119:
            case 87:
            case 115:
            case 83:
                $mergeRanges(tok, this.getTokenForShorthand(c));
                end = true;
                break;
            case 105:
            case 73:
            case 99:
            case 67:
                c = this.processCIinCharacterClass(tok, c);
                c < 0 && (end = true);
                break;
            case 112:
            case 80:
                tok2 = $processBacksolidus_pP(this, c);
                if (!tok2) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.5'))));
                $mergeRanges(tok, tok2);
                end = true;
                break;
            default:
                c = this.decodeEscaped();
        }
        else if (type_0 == 20) {
            nameend = $indexOf_0(this.regex, 58, this.offset);
            if (nameend < 0) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.1'))));
            positive = true;
            if ($charAt(this.regex, this.offset) == 94) {
                ++this.offset;
                positive = false;
            }
            name_0 = $substring_1(this.regex, this.offset, nameend);
            range = getRange_1(name_0, positive, (this.options_0 & 512) == 512);
            if (!range) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.3'))));
            $mergeRanges(tok, range);
            end = true;
            if (nameend + 1 >= this.regexlen || $charAt(this.regex, nameend + 1) != 93) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.1'))));
            this.offset = nameend + 2;
        }
        $next_16(this);
        if (!end) {
            if (this.nexttoken != 0 || this.chardata != 45) $addRange(tok, c, c);
            else {
                $next_16(this);
                if ((type_0 = this.nexttoken) == 1) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.2'))));
                if (type_0 == 0 && this.chardata == 93) {
                    $addRange(tok, c, c);
                    $addRange(tok, 45, 45);
                } else {
                    rangeend = this.chardata;
                    type_0 == 10 && (rangeend = this.decodeEscaped());
                    $next_16(this);
                    $addRange(tok, c, rangeend);
                }
            }
        }
        (this.options_0 & $intern_149) == $intern_149 && this.nexttoken == 0 && this.chardata == 44 && $next_16(this);
    }
    if (this.nexttoken == 1) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.2'))));
    if (base) {
        $subtractRanges(base, tok);
        tok = base;
    }
    $sortRanges(tok);
    $compactRanges(tok);
    this.context = 0;
    $next_16(this);
    return tok;
};
_.parseSetOperations = function parseSetOperations() {
    var ch_0, t2, tok, type_0;
    tok = this.parseCharacterClass(false);
    while((type_0 = this.nexttoken) != 7){
        ch_0 = this.chardata;
        if (type_0 == 0 && (ch_0 == 45 || ch_0 == 38) || type_0 == 4) {
            $next_16(this);
            if (this.nexttoken != 9) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.ope.1'))));
            t2 = this.parseCharacterClass(false);
            if (type_0 == 4) $mergeRanges(tok, t2);
            else if (ch_0 == 45) $subtractRanges(tok, t2);
            else if (ch_0 == 38) $intersectRanges(tok, t2);
            else throw toJs(new RuntimeException_0('ASSERT'));
        } else throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.ope.2'))));
    }
    $next_16(this);
    return tok;
};
_.processBackreference = function processBackreference() {
    var refnum, tok;
    refnum = this.chardata - 48;
    tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$StringToken(12, null, refnum));
    !this.references && (this.references = new Vector);
    $addElement(this.references, new RegEx$RegexParser$ReferencePosition(refnum));
    $next_16(this);
    return tok;
};
_.processBacksolidus_A = function processBacksolidus_A() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_stringbeginning;
};
_.processBacksolidus_B = function processBacksolidus_B() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_not_wordedge;
};
_.processBacksolidus_C = function processBacksolidus_C() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_I = function processBacksolidus_I() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_X = function processBacksolidus_X() {
    $next_16(this);
    return getCombiningCharacterSequence();
};
_.processBacksolidus_Z = function processBacksolidus_Z() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_stringend2;
};
_.processBacksolidus_b = function processBacksolidus_b() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_wordedge;
};
_.processBacksolidus_c = function processBacksolidus_c() {
    var ch2;
    if (this.offset >= this.regexlen || ((ch2 = $charAt(this.regex, this.offset++)) & 65504) != 64) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.1'))));
    $next_16(this);
    return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$CharToken(0, ch2 - 64);
};
_.processBacksolidus_g = function processBacksolidus_g() {
    $next_16(this);
    return getGraphemePattern();
};
_.processBacksolidus_gt = function processBacksolidus_gt() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_wordend;
};
_.processBacksolidus_i = function processBacksolidus_i() {
    var tok;
    tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$CharToken(0, 105));
    $next_16(this);
    return tok;
};
_.processBacksolidus_lt = function processBacksolidus_lt() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_wordbeginning;
};
_.processBacksolidus_z = function processBacksolidus_z() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_stringend;
};
_.processCIinCharacterClass = function processCIinCharacterClass(tok, c) {
    return this.decodeEscaped();
};
_.processCaret = function processCaret() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_linebeginning;
};
_.processCondition = function processCondition() {
    var ch_0, condition, noPattern, refno, yesPattern;
    if (this.offset + 1 >= this.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.4'))));
    refno = -1;
    condition = null;
    ch_0 = $charAt(this.regex, this.offset);
    if (49 <= ch_0 && ch_0 <= 57) {
        refno = ch_0 - 48;
        !this.references && (this.references = new Vector);
        $addElement(this.references, new RegEx$RegexParser$ReferencePosition(refno));
        ++this.offset;
        if ($charAt(this.regex, this.offset) != 41) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
        ++this.offset;
    } else {
        ch_0 == 63 && --this.offset;
        $next_16(this);
        condition = $parseFactor(this);
        switch(condition.type_0){
            case 20:
            case 21:
            case 22:
            case 23:
                break;
            case 8:
                if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
                break;
            default:
                throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.5'))));
        }
    }
    $next_16(this);
    yesPattern = $parseRegex(this);
    noPattern = null;
    if (yesPattern.type_0 == 2) {
        if (yesPattern.size_2() != 2) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.6'))));
        noPattern = yesPattern.getChild(1);
        yesPattern = yesPattern.getChild(0);
    }
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ConditionToken(refno, condition, yesPattern, noPattern);
};
_.processDollar = function processDollar() {
    $next_16(this);
    return $clinit_RegEx$Token(), token_lineend;
};
_.processIndependent = function processIndependent() {
    var tok;
    $next_16(this);
    tok = createLook(24, $parseRegex(this));
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processLookahead = function processLookahead() {
    var tok;
    $next_16(this);
    tok = createLook(20, $parseRegex(this));
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processLookbehind = function processLookbehind() {
    var tok;
    $next_16(this);
    tok = createLook(22, $parseRegex(this));
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processModifiers = function processModifiers() {
    var add_0, ch_0, mask, tok, v;
    add_0 = 0;
    mask = 0;
    ch_0 = -1;
    while(this.offset < this.regexlen){
        ch_0 = $charAt(this.regex, this.offset);
        v = getOptionValue(ch_0);
        if (v == 0) break;
        add_0 |= v;
        ++this.offset;
    }
    if (this.offset >= this.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.2'))));
    if (ch_0 == 45) {
        ++this.offset;
        while(this.offset < this.regexlen){
            ch_0 = $charAt(this.regex, this.offset);
            v = getOptionValue(ch_0);
            if (v == 0) break;
            mask |= v;
            ++this.offset;
        }
        if (this.offset >= this.regexlen) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.2'))));
    }
    if (ch_0 == 58) {
        ++this.offset;
        $next_16(this);
        tok = createModifierGroup($parseRegex(this), add_0, mask);
        if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
        $next_16(this);
    } else if (ch_0 == 41) {
        ++this.offset;
        $next_16(this);
        tok = createModifierGroup($parseRegex(this), add_0, mask);
    } else throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.3'))));
    return tok;
};
_.processNegativelookahead = function processNegativelookahead() {
    var tok;
    $next_16(this);
    tok = createLook(21, $parseRegex(this));
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processNegativelookbehind = function processNegativelookbehind() {
    var tok;
    $next_16(this);
    tok = createLook(23, $parseRegex(this));
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processParen = function processParen() {
    var p, tok;
    $next_16(this);
    p = this.parennumber++;
    tok = createParen($parseRegex(this), p);
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processParen2 = function processParen2() {
    var tok;
    $next_16(this);
    tok = createParen($parseRegex(this), 0);
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processPlus = function processPlus(tok) {
    $next_16(this);
    if (this.nexttoken == 5) {
        $next_16(this);
        return createConcat(tok, ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(9, tok)));
    } else return createConcat(tok, ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(3, tok)));
};
_.processQuestion = function processQuestion(tok) {
    var par;
    $next_16(this);
    par = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$UnionToken(2));
    if (this.nexttoken == 5) {
        $next_16(this);
        $addChild_0(par, token_empty);
        $addChild_0(par, tok);
    } else {
        $addChild_0(par, tok);
        $addChild_0(par, token_empty);
    }
    return par;
};
_.processStar = function processStar(tok) {
    $next_16(this);
    if (this.nexttoken == 5) {
        $next_16(this);
        return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(9, tok);
    } else return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(3, tok);
};
_.chardata = 0;
_.context = 0;
_.nexttoken = 0;
_.offset = 0;
_.options_0 = 0;
_.parennumber = 1;
_.references = null;
_.regexlen = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$RegexParser_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/RegexParser', 815);
function $decodeEscaped(this$static) {
    var c;
    if (this$static.nexttoken != 10) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.next.1'))));
    c = this$static.chardata;
    switch(c){
        case 110:
            c = 10;
            break;
        case 114:
            c = 13;
            break;
        case 116:
            c = 9;
            break;
        case 92:
        case 124:
        case 46:
        case 94:
        case 45:
        case 63:
        case 42:
        case 43:
        case 123:
        case 125:
        case 40:
        case 41:
        case 91:
        case 93:
            break;
        default:
            throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
    }
    return c;
}
function $getTokenForShorthand(ch_0) {
    var number;
    switch(ch_0){
        case 100:
            return getRange('xml:isDigit', true);
        case 68:
            return getRange('xml:isDigit', false);
        case 119:
            return getRange('xml:isWord', true);
        case 87:
            return getRange('xml:isWord', false);
        case 115:
            return getRange('xml:isSpace', true);
        case 83:
            return getRange('xml:isSpace', false);
        case 99:
            return getRange('xml:isNameChar', true);
        case 67:
            return getRange('xml:isNameChar', false);
        case 105:
            return getRange('xml:isInitialNameChar', true);
        case 73:
            return getRange('xml:isInitialNameChar', false);
        default:
            throw toJs(new RuntimeException_0((number = ch_0, 'Internal Error: shorthands: \\u' + number.toString(16))));
    }
}
function $parseCharacterClass(this$static) {
    var base, c, end, firstloop, range2, rangeend, tok, tok2, type_0;
    this$static.context = 1;
    $next_16(this$static);
    base = null;
    if (this$static.nexttoken == 0 && this$static.chardata == 94) {
        $next_16(this$static);
        base = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$RangeToken(4));
        $addRange(base, 0, $intern_167);
        tok = (++tokens_0, new RegEx$RangeToken(4));
    } else tok = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$RangeToken(4));
    firstloop = true;
    while((type_0 = this$static.nexttoken) != 1){
        if (type_0 == 0 && this$static.chardata == 93 && !firstloop) {
            if (base) {
                $subtractRanges(base, tok);
                tok = base;
            }
            break;
        }
        c = this$static.chardata;
        end = false;
        if (type_0 == 10) switch(c){
            case 100:
            case 68:
            case 119:
            case 87:
            case 115:
            case 83:
                $mergeRanges(tok, $getTokenForShorthand(c));
                end = true;
                break;
            case 105:
            case 73:
            case 99:
            case 67:
                c = ($mergeRanges(tok, $getTokenForShorthand(c)), -1);
                c < 0 && (end = true);
                break;
            case 112:
            case 80:
                tok2 = $processBacksolidus_pP(this$static, c);
                if (!tok2) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.atom.5'))));
                $mergeRanges(tok, tok2);
                end = true;
                break;
            default:
                c = $decodeEscaped(this$static);
        }
        else if (type_0 == 24 && !firstloop) {
            if (base) {
                $subtractRanges(base, tok);
                tok = base;
            }
            range2 = $parseCharacterClass(this$static);
            $subtractRanges(tok, range2);
            if (this$static.nexttoken != 0 || this$static.chardata != 93) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.5'))));
            break;
        }
        $next_16(this$static);
        if (!end) {
            if (type_0 == 0) {
                if (c == 91) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.6'))));
                if (c == 93) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.7'))));
                if (c == 45 && !firstloop && this$static.chardata != 93) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.8'))));
            }
            if (this$static.nexttoken != 0 || this$static.chardata != 45 || c == 45 && firstloop) $addRange(tok, c, c);
            else {
                $next_16(this$static);
                if ((type_0 = this$static.nexttoken) == 1) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.2'))));
                if (type_0 == 0 && this$static.chardata == 93) {
                    $addRange(tok, c, c);
                    $addRange(tok, 45, 45);
                } else if (type_0 == 0 && this$static.chardata == 93 || type_0 == 24) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.8'))));
                else {
                    rangeend = this$static.chardata;
                    if (type_0 == 0) {
                        if (rangeend == 91) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.6'))));
                        if (rangeend == 93) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.7'))));
                        if (rangeend == 45) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.8'))));
                    } else type_0 == 10 && (rangeend = $decodeEscaped(this$static));
                    $next_16(this$static);
                    if (c > rangeend) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.ope.3'))));
                    $addRange(tok, c, rangeend);
                }
            }
        }
        firstloop = false;
    }
    if (this$static.nexttoken == 1) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.cc.2'))));
    $sortRanges(tok);
    $compactRanges(tok);
    this$static.context = 0;
    $next_16(this$static);
    return tok;
}
function RegEx$ParserForXMLSchema() {
    RegEx$RegexParser.call(this);
}
function getRange(name_0, positive) {
    var tok, tok0;
    if (!ranges_0) {
        ranges_0 = new HashMap;
        ranges2 = new HashMap;
        tok0 = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$RangeToken(4));
        setupRange(tok0, '\t\n\r\r  ');
        $putStringValue(ranges_0, 'xml:isSpace', tok0);
        $putStringValue(ranges2, 'xml:isSpace', complementRanges(tok0));
        tok0 = (++tokens_0, new RegEx$RangeToken(4));
        setupRange(tok0, '09\u0660\u0669\u06F0\u06F9\u0966\u096F\u09E6\u09EF\u0A66\u0A6F\u0AE6\u0AEF\u0B66\u0B6F\u0BE7\u0BEF\u0C66\u0C6F\u0CE6\u0CEF\u0D66\u0D6F\u0E50\u0E59\u0ED0\u0ED9\u0F20\u0F29');
        $putStringValue(ranges_0, 'xml:isDigit', tok0);
        $putStringValue(ranges2, 'xml:isDigit', complementRanges(tok0));
        tok0 = (++tokens_0, new RegEx$RangeToken(4));
        setupRange(tok0, '09\u0660\u0669\u06F0\u06F9\u0966\u096F\u09E6\u09EF\u0A66\u0A6F\u0AE6\u0AEF\u0B66\u0B6F\u0BE7\u0BEF\u0C66\u0C6F\u0CE6\u0CEF\u0D66\u0D6F\u0E50\u0E59\u0ED0\u0ED9\u0F20\u0F29');
        $putStringValue(ranges_0, 'xml:isDigit', tok0);
        $putStringValue(ranges2, 'xml:isDigit', complementRanges(tok0));
        tok0 = (++tokens_0, new RegEx$RangeToken(4));
        setupRange(tok0, 'AZaz\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u0386\u0386\u0388\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0641\u064A\u0671\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06D5\u06E5\u06E6\u0905\u0939\u093D\u093D\u0958\u0961\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09DC\u09DD\u09DF\u09E1\u09F0\u09F1\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59\u0A5C\u0A5E\u0A5E\u0A72\u0A74\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABD\u0ABD\u0AE0\u0AE0\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3D\u0B3D\u0B5C\u0B5D\u0B5F\u0B61\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C60\u0C61\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CDE\u0CDE\u0CE0\u0CE1\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D60\u0D61\u0E01\u0E2E\u0E30\u0E30\u0E32\u0E33\u0E40\u0E45\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB0\u0EB2\u0EB3\u0EBD\u0EBD\u0EC0\u0EC4\u0F40\u0F47\u0F49\u0F69\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3007\u3007\u3021\u3029\u3041\u3094\u30A1\u30FA\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3');
        $mergeRanges(tok0, castTo($getStringValue(ranges_0, 'xml:isDigit'), 121));
        $putStringValue(ranges_0, 'xml:isWord', tok0);
        $putStringValue(ranges2, 'xml:isWord', complementRanges(tok0));
        tok0 = (++tokens_0, new RegEx$RangeToken(4));
        setupRange(tok0, '-.0:AZ__az\xB7\xB7\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u02D0\u02D1\u0300\u0345\u0360\u0361\u0386\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0483\u0486\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u0591\u05A1\u05A3\u05B9\u05BB\u05BD\u05BF\u05BF\u05C1\u05C2\u05C4\u05C4\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0640\u0652\u0660\u0669\u0670\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06E8\u06EA\u06ED\u06F0\u06F9\u0901\u0903\u0905\u0939\u093C\u094D\u0951\u0954\u0958\u0963\u0966\u096F\u0981\u0983\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09BC\u09BC\u09BE\u09C4\u09C7\u09C8\u09CB\u09CD\u09D7\u09D7\u09DC\u09DD\u09DF\u09E3\u09E6\u09F1\u0A02\u0A02\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3C\u0A3E\u0A42\u0A47\u0A48\u0A4B\u0A4D\u0A59\u0A5C\u0A5E\u0A5E\u0A66\u0A74\u0A81\u0A83\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABC\u0AC5\u0AC7\u0AC9\u0ACB\u0ACD\u0AE0\u0AE0\u0AE6\u0AEF\u0B01\u0B03\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3C\u0B43\u0B47\u0B48\u0B4B\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F\u0B61\u0B66\u0B6F\u0B82\u0B83\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0BBE\u0BC2\u0BC6\u0BC8\u0BCA\u0BCD\u0BD7\u0BD7\u0BE7\u0BEF\u0C01\u0C03\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C3E\u0C44\u0C46\u0C48\u0C4A\u0C4D\u0C55\u0C56\u0C60\u0C61\u0C66\u0C6F\u0C82\u0C83\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CBE\u0CC4\u0CC6\u0CC8\u0CCA\u0CCD\u0CD5\u0CD6\u0CDE\u0CDE\u0CE0\u0CE1\u0CE6\u0CEF\u0D02\u0D03\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D3E\u0D43\u0D46\u0D48\u0D4A\u0D4D\u0D57\u0D57\u0D60\u0D61\u0D66\u0D6F\u0E01\u0E2E\u0E30\u0E3A\u0E40\u0E4E\u0E50\u0E59\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB9\u0EBB\u0EBD\u0EC0\u0EC4\u0EC6\u0EC6\u0EC8\u0ECD\u0ED0\u0ED9\u0F18\u0F19\u0F20\u0F29\u0F35\u0F35\u0F37\u0F37\u0F39\u0F39\u0F3E\u0F47\u0F49\u0F69\u0F71\u0F84\u0F86\u0F8B\u0F90\u0F95\u0F97\u0F97\u0F99\u0FAD\u0FB1\u0FB7\u0FB9\u0FB9\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u20D0\u20DC\u20E1\u20E1\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3005\u3005\u3007\u3007\u3021\u302F\u3031\u3035\u3041\u3094\u3099\u309A\u309D\u309E\u30A1\u30FA\u30FC\u30FE\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3');
        $putStringValue(ranges_0, 'xml:isNameChar', tok0);
        $putStringValue(ranges2, 'xml:isNameChar', complementRanges(tok0));
        tok0 = (++tokens_0, new RegEx$RangeToken(4));
        setupRange(tok0, 'AZaz\xC0\xD6\xD8\xF6\xF8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u0386\u0386\u0388\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0641\u064A\u0671\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06D5\u06E5\u06E6\u0905\u0939\u093D\u093D\u0958\u0961\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09DC\u09DD\u09DF\u09E1\u09F0\u09F1\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59\u0A5C\u0A5E\u0A5E\u0A72\u0A74\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABD\u0ABD\u0AE0\u0AE0\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3D\u0B3D\u0B5C\u0B5D\u0B5F\u0B61\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C60\u0C61\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CDE\u0CDE\u0CE0\u0CE1\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D60\u0D61\u0E01\u0E2E\u0E30\u0E30\u0E32\u0E33\u0E40\u0E45\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB0\u0EB2\u0EB3\u0EBD\u0EBD\u0EC0\u0EC4\u0F40\u0F47\u0F49\u0F69\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3007\u3007\u3021\u3029\u3041\u3094\u30A1\u30FA\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3');
        $addRange(tok0, 95, 95);
        $addRange(tok0, 58, 58);
        $putStringValue(ranges_0, 'xml:isInitialNameChar', tok0);
        $putStringValue(ranges2, 'xml:isInitialNameChar', complementRanges(tok0));
    }
    tok = positive ? castTo($getStringValue(ranges_0, name_0), 136) : castTo($getStringValue(ranges2, name_0), 136);
    return tok;
}
function setupRange(range, src_0) {
    var i, len;
    len = src_0.length;
    for(i = 0; i < len; i += 2)$addRange(range, (checkCriticalStringElementIndex(i, src_0.length), src_0.charCodeAt(i)), (checkCriticalStringElementIndex(i + 1, src_0.length), src_0.charCodeAt(i + 1)));
}
defineClass(1893, 815, {}, RegEx$ParserForXMLSchema);
_.checkQuestion = function checkQuestion_0(off) {
    return false;
};
_.decodeEscaped = function decodeEscaped_0() {
    return $decodeEscaped(this);
};
_.getTokenForShorthand = function getTokenForShorthand_0(ch_0) {
    return $getTokenForShorthand(ch_0);
};
_.parseCharacterClass = function parseCharacterClass_0(useNrange) {
    return $parseCharacterClass(this);
};
_.parseSetOperations = function parseSetOperations_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBackreference = function processBackreference_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_A = function processBacksolidus_A_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_B = function processBacksolidus_B_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_C = function processBacksolidus_C_0() {
    $next_16(this);
    return $getTokenForShorthand(67);
};
_.processBacksolidus_I = function processBacksolidus_I_0() {
    $next_16(this);
    return $getTokenForShorthand(73);
};
_.processBacksolidus_X = function processBacksolidus_X_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_Z = function processBacksolidus_Z_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_b = function processBacksolidus_b_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_c = function processBacksolidus_c_0() {
    $next_16(this);
    return $getTokenForShorthand(99);
};
_.processBacksolidus_g = function processBacksolidus_g_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_gt = function processBacksolidus_gt_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_i = function processBacksolidus_i_0() {
    $next_16(this);
    return $getTokenForShorthand(105);
};
_.processBacksolidus_lt = function processBacksolidus_lt_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processBacksolidus_z = function processBacksolidus_z_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processCIinCharacterClass = function processCIinCharacterClass_0(tok, c) {
    return $mergeRanges(tok, $getTokenForShorthand(c)), -1;
};
_.processCaret = function processCaret_0() {
    $next_16(this);
    return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$CharToken(0, 94);
};
_.processCondition = function processCondition_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processDollar = function processDollar_0() {
    $next_16(this);
    return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$CharToken(0, 36);
};
_.processIndependent = function processIndependent_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processLookahead = function processLookahead_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processLookbehind = function processLookbehind_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processModifiers = function processModifiers_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processNegativelookahead = function processNegativelookahead_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processNegativelookbehind = function processNegativelookbehind_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processParen = function processParen_0() {
    var tok;
    $next_16(this);
    tok = createParen($parseRegex(this), 0);
    if (this.nexttoken != 7) throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.factor.1'))));
    $next_16(this);
    return tok;
};
_.processParen2 = function processParen2_0() {
    throw toJs(new RegEx$ParseException($getString(($clinit_EcorePlugin(), 'parser.process.1'))));
};
_.processPlus = function processPlus_0(tok) {
    $next_16(this);
    return createConcat(tok, ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(3, tok)));
};
_.processQuestion = function processQuestion_0(tok) {
    var par;
    $next_16(this);
    par = ($clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$UnionToken(2));
    $addChild_0(par, tok);
    $addChild_0(par, token_empty);
    return par;
};
_.processStar = function processStar_0(tok) {
    $next_16(this);
    return $clinit_RegEx$Token(), $clinit_RegEx$Token(), ++tokens_0, new RegEx$Token$ClosureToken(3, tok);
};
var ranges_0 = null, ranges2 = null;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$ParserForXMLSchema_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/ParserForXMLSchema', 1893);
function createOptionString(options) {
    var sb;
    sb = new StringBuffer_0;
    (options & 256) != 0 && (sb.string += 'F', sb);
    (options & 128) != 0 && (sb.string += 'H', sb);
    (options & 512) != 0 && (sb.string += 'X', sb);
    (options & 2) != 0 && (sb.string += 'i', sb);
    (options & 8) != 0 && (sb.string += 'm', sb);
    (options & 4) != 0 && (sb.string += 's', sb);
    (options & 32) != 0 && (sb.string += 'u', sb);
    (options & 64) != 0 && (sb.string += 'w', sb);
    (options & 16) != 0 && (sb.string += 'x', sb);
    (options & $intern_149) != 0 && (sb.string += ',', sb);
    return $intern(sb.string);
}
function decomposeToSurrogates(ch_0) {
    var chs;
    chs = initUnidimensionalArray(C_classLit, $intern_44, 30, 2, 15, 1);
    ch_0 -= $intern_64;
    chs[0] = (ch_0 >> 10) + $intern_65 & $intern_46;
    chs[1] = (ch_0 & 1023) + 56320 & $intern_46;
    return valueOf_8(chs, 0, chs.length);
}
function getOptionValue(ch_0) {
    var ret;
    ret = 0;
    switch(ch_0){
        case 105:
            ret = 2;
            break;
        case 109:
            ret = 8;
            break;
        case 115:
            ret = 4;
            break;
        case 120:
            ret = 16;
            break;
        case 117:
            ret = 32;
            break;
        case 119:
            ret = 64;
            break;
        case 70:
            ret = 256;
            break;
        case 72:
            ret = 128;
            break;
        case 88:
            ret = 512;
            break;
        case 44:
            ret = $intern_149;
    }
    return ret;
}
function parseOptions() {
    var i, options, v;
    options = 0;
    for(i = 0; i < 1; i++){
        v = getOptionValue((checkCriticalStringElementIndex(i, 1), 'X'.charCodeAt(i)));
        if (v == 0) throw toJs(new RegEx$ParseException((checkCriticalStringElementIndex(i, 2), 'Unknown Option: ' + 'X'.substr(i))));
        options |= v;
    }
    return options;
}
function quoteMeta(literal) {
    var buffer, ch_0, i, len;
    len = literal.length;
    buffer = null;
    for(i = 0; i < len; i++){
        ch_0 = (checkCriticalStringElementIndex(i, literal.length), literal.charCodeAt(i));
        if ($indexOf_1('.*+?{[()|\\^$', fromCodePoint(ch_0)) >= 0) {
            if (!buffer) {
                buffer = new StringBuffer_0;
                i > 0 && $append_3(buffer, (checkCriticalStringBounds(0, i, literal.length), literal.substr(0, i)));
            }
            buffer.string += '\\';
            $append(buffer, ch_0 & $intern_46);
        } else !!buffer && $append(buffer, ch_0 & $intern_46);
    }
    return buffer ? buffer.string : literal;
}
function stripExtendedComment(regex) {
    var buffer, ch_0, len, next, offset;
    len = regex.length;
    buffer = new StringBuffer_0;
    offset = 0;
    while(offset < len){
        ch_0 = $charAt(regex, offset++);
        if (ch_0 == 9 || ch_0 == 10 || ch_0 == 12 || ch_0 == 13 || ch_0 == 32) continue;
        if (ch_0 == 35) {
            while(offset < len){
                ch_0 = $charAt(regex, offset++);
                if (ch_0 == 13 || ch_0 == 10) break;
            }
            continue;
        }
        if (ch_0 == 92 && offset < len) {
            if ((next = (checkCriticalStringElementIndex(offset, regex.length), regex.charCodeAt(offset))) == 35 || next == 9 || next == 10 || next == 12 || next == 13 || next == 32) {
                $append(buffer, next & $intern_46);
                ++offset;
            } else {
                buffer.string += '\\';
                $append(buffer, next & $intern_46);
                ++offset;
            }
        } else $append(buffer, ch_0 & $intern_46);
    }
    return buffer.string;
}
function $clinit_RegEx$Token() {
    $clinit_RegEx$Token = emptyMethod;
    token_empty = new RegEx$Token(7);
    token_linebeginning = (++tokens_0, new RegEx$Token$CharToken(8, 94));
    ++tokens_0;
    new RegEx$Token$CharToken(8, 64);
    token_lineend = (++tokens_0, new RegEx$Token$CharToken(8, 36));
    token_stringbeginning = (++tokens_0, new RegEx$Token$CharToken(8, 65));
    token_stringend = (++tokens_0, new RegEx$Token$CharToken(8, 122));
    token_stringend2 = (++tokens_0, new RegEx$Token$CharToken(8, 90));
    token_wordedge = (++tokens_0, new RegEx$Token$CharToken(8, 98));
    token_not_wordedge = (++tokens_0, new RegEx$Token$CharToken(8, 66));
    token_wordbeginning = (++tokens_0, new RegEx$Token$CharToken(8, 60));
    token_wordend = (++tokens_0, new RegEx$Token$CharToken(8, 62));
    token_dot = new RegEx$Token(11);
    token_0to9 = (++tokens_0, new RegEx$RangeToken(4));
    $addRange(token_0to9, 48, 57);
    token_wordchars = (++tokens_0, new RegEx$RangeToken(4));
    $addRange(token_wordchars, 48, 57);
    $addRange(token_wordchars, 65, 90);
    $addRange(token_wordchars, 95, 95);
    $addRange(token_wordchars, 97, 122);
    token_spaces = (++tokens_0, new RegEx$RangeToken(4));
    $addRange(token_spaces, 9, 9);
    $addRange(token_spaces, 10, 10);
    $addRange(token_spaces, 12, 12);
    $addRange(token_spaces, 13, 13);
    $addRange(token_spaces, 32, 32);
    token_not_0to9 = complementRanges(token_0to9);
    token_not_wordchars = complementRanges(token_wordchars);
    token_not_spaces = complementRanges(token_spaces);
    categories = new HashMap;
    categories2 = new HashMap;
    categoryNames = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Cn',
        'Lu',
        'Ll',
        'Lt',
        'Lm',
        'Lo',
        'Mn',
        'Me',
        'Mc',
        'Nd',
        'Nl',
        'No',
        'Zs',
        'Zl',
        'Zp',
        'Cc',
        'Cf',
        null,
        'Co',
        'Cs',
        'Pd',
        'Ps',
        'Pe',
        'Pc',
        'Po',
        'Sm',
        'Sc',
        'Sk',
        'So',
        'Pi',
        'Pf',
        'L',
        'M',
        'N',
        'Z',
        'C',
        'P',
        'S'
    ]);
    blockNames = stampJavaTypeInfo(getClassLiteralForArray(Ljava_lang_String_2_classLit, 1), $intern_16, 2, 6, [
        'Basic Latin',
        'Latin-1 Supplement',
        'Latin Extended-A',
        'Latin Extended-B',
        'IPA Extensions',
        'Spacing Modifier Letters',
        'Combining Diacritical Marks',
        'Greek',
        'Cyrillic',
        'Armenian',
        'Hebrew',
        'Arabic',
        'Syriac',
        'Thaana',
        'Devanagari',
        'Bengali',
        'Gurmukhi',
        'Gujarati',
        'Oriya',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhala',
        'Thai',
        'Lao',
        'Tibetan',
        'Myanmar',
        'Georgian',
        'Hangul Jamo',
        'Ethiopic',
        'Cherokee',
        'Unified Canadian Aboriginal Syllabics',
        'Ogham',
        'Runic',
        'Khmer',
        'Mongolian',
        'Latin Extended Additional',
        'Greek Extended',
        'General Punctuation',
        'Superscripts and Subscripts',
        'Currency Symbols',
        'Combining Marks for Symbols',
        'Letterlike Symbols',
        'Number Forms',
        'Arrows',
        'Mathematical Operators',
        'Miscellaneous Technical',
        'Control Pictures',
        'Optical Character Recognition',
        'Enclosed Alphanumerics',
        'Box Drawing',
        'Block Elements',
        'Geometric Shapes',
        'Miscellaneous Symbols',
        'Dingbats',
        'Braille Patterns',
        'CJK Radicals Supplement',
        'Kangxi Radicals',
        'Ideographic Description Characters',
        'CJK Symbols and Punctuation',
        'Hiragana',
        'Katakana',
        'Bopomofo',
        'Hangul Compatibility Jamo',
        'Kanbun',
        'Bopomofo Extended',
        'Enclosed CJK Letters and Months',
        'CJK Compatibility',
        'CJK Unified Ideographs Extension A',
        'CJK Unified Ideographs',
        'Yi Syllables',
        'Yi Radicals',
        'Hangul Syllables',
        'Private Use',
        'CJK Compatibility Ideographs',
        'Alphabetic Presentation Forms',
        'Arabic Presentation Forms-A',
        'Combining Half Marks',
        'CJK Compatibility Forms',
        'Small Form Variants',
        'Arabic Presentation Forms-B',
        'Specials',
        'Halfwidth and Fullwidth Forms',
        'Old Italic',
        'Gothic',
        'Deseret',
        'Byzantine Musical Symbols',
        'Musical Symbols',
        'Mathematical Alphanumeric Symbols',
        'CJK Unified Ideographs Extension B',
        'CJK Compatibility Ideographs Supplement',
        'Tags'
    ]);
    nonBMPBlockRanges = stampJavaTypeInfo(getClassLiteralForArray(I_classLit, 1), $intern_48, 30, 15, [
        66304,
        66351,
        66352,
        66383,
        66560,
        66639,
        118784,
        119039,
        119040,
        119295,
        119808,
        120831,
        131072,
        173782,
        194560,
        195103,
        917504,
        917631
    ]);
}
function RegEx$Token(type_0) {
    this.type_0 = type_0;
}
function createChar(ch_0) {
    $clinit_RegEx$Token();
    ++tokens_0;
    return new RegEx$Token$CharToken(0, ch_0);
}
function createClosure(tok) {
    ++tokens_0;
    return new RegEx$Token$ClosureToken(3, tok);
}
function createConcat(tok1, tok2) {
    $clinit_RegEx$Token();
    ++tokens_0;
    return new RegEx$Token$ConcatToken(tok1, tok2);
}
function createLook(type_0, child) {
    $clinit_RegEx$Token();
    ++tokens_0;
    return new RegEx$Token$ParenToken(type_0, child, 0);
}
function createModifierGroup(child, add_0, mask) {
    $clinit_RegEx$Token();
    ++tokens_0;
    return new RegEx$Token$ModifierToken(child, add_0, mask);
}
function createParen(child, pnumber) {
    $clinit_RegEx$Token();
    ++tokens_0;
    return new RegEx$Token$ParenToken(6, child, pnumber);
}
function createString_0(str) {
    $clinit_RegEx$Token();
    ++tokens_0;
    return new RegEx$Token$StringToken(10, str, 0);
}
function getCombiningCharacterSequence() {
    $clinit_RegEx$Token();
    var foo;
    if (token_ccs) return token_ccs;
    foo = createClosure(getRange_0('M', true));
    foo = createConcat(getRange_0('M', false), foo);
    token_ccs = foo;
    return token_ccs;
}
function getGraphemePattern() {
    $clinit_RegEx$Token();
    var base_char, combiner_wo_virama, foo, i, left, virama;
    if (token_grapheme) return token_grapheme;
    base_char = (++tokens_0, new RegEx$RangeToken(4));
    $mergeRanges(base_char, getRange_0('ASSIGNED', true));
    $subtractRanges(base_char, getRange_0('M', true));
    $subtractRanges(base_char, getRange_0('C', true));
    virama = (++tokens_0, new RegEx$RangeToken(4));
    for(i = 0; i < 11; i++)$addRange(virama, i, i);
    combiner_wo_virama = (++tokens_0, new RegEx$RangeToken(4));
    $mergeRanges(combiner_wo_virama, getRange_0('M', true));
    $addRange(combiner_wo_virama, 4448, 4607);
    $addRange(combiner_wo_virama, 65438, 65439);
    left = (++tokens_0, new RegEx$Token$UnionToken(2));
    $addChild_0(left, base_char);
    $addChild_0(left, token_empty);
    foo = (++tokens_0, new RegEx$Token$UnionToken(2));
    foo.addChild(createConcat(virama, getRange_0('L', true)));
    foo.addChild(combiner_wo_virama);
    foo = (++tokens_0, new RegEx$Token$ClosureToken(3, foo));
    foo = (++tokens_0, new RegEx$Token$ConcatToken(left, foo));
    token_grapheme = foo;
    return token_grapheme;
}
function getRange_0(name_0, positive) {
    $clinit_RegEx$Token();
    var all, buffer, ci, i, i0, location_0, n, oldLength, r1, ranges, rend, rstart, tok;
    if ($size_2(categories) == 0) {
        ranges = initUnidimensionalArray(Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token_2_classLit, $intern_16, 121, categoryNames.length, 0, 1);
        for(i0 = 0; i0 < ranges.length; i0++)ranges[i0] = (++tokens_0, new RegEx$RangeToken(4));
        buffer = new StringBuffer_0;
        for(i = 0; i < blockNames.length; i++){
            r1 = (++tokens_0, new RegEx$RangeToken(4));
            if (i < 84) {
                location_0 = i * 2;
                rstart = (checkCriticalStringElementIndex(location_0, 168), '\x00\x7F\x80\xFF\u0100\u017F\u0180\u024F\u0250\u02AF\u02B0\u02FF\u0300\u036F\u0370\u03FF\u0400\u04FF\u0530\u058F\u0590\u05FF\u0600\u06FF\u0700\u074F\u0780\u07BF\u0900\u097F\u0980\u09FF\u0A00\u0A7F\u0A80\u0AFF\u0B00\u0B7F\u0B80\u0BFF\u0C00\u0C7F\u0C80\u0CFF\u0D00\u0D7F\u0D80\u0DFF\u0E00\u0E7F\u0E80\u0EFF\u0F00\u0FFF\u1000\u109F\u10A0\u10FF\u1100\u11FF\u1200\u137F\u13A0\u13FF\u1400\u167F\u1680\u169F\u16A0\u16FF\u1780\u17FF\u1800\u18AF\u1E00\u1EFF\u1F00\u1FFF\u2000\u206F\u2070\u209F\u20A0\u20CF\u20D0\u20FF\u2100\u214F\u2150\u218F\u2190\u21FF\u2200\u22FF\u2300\u23FF\u2400\u243F\u2440\u245F\u2460\u24FF\u2500\u257F\u2580\u259F\u25A0\u25FF\u2600\u26FF\u2700\u27BF\u2800\u28FF\u2E80\u2EFF\u2F00\u2FDF\u2FF0\u2FFF\u3000\u303F\u3040\u309F\u30A0\u30FF\u3100\u312F\u3130\u318F\u3190\u319F\u31A0\u31BF\u3200\u32FF\u3300\u33FF\u3400\u4DB5\u4E00\u9FFF\uA000\uA48F\uA490\uA4CF\uAC00\uD7A3\uE000\uF8FF\uF900\uFAFF\uFB00\uFB4F\uFB50\uFDFF\uFE20\uFE2F\uFE30\uFE4F\uFE50\uFE6F\uFE70\uFEFE\uFEFF\uFEFF\uFF00\uFFEF'.charCodeAt(location_0));
                rend = (checkCriticalStringElementIndex(location_0 + 1, 168), '\x00\x7F\x80\xFF\u0100\u017F\u0180\u024F\u0250\u02AF\u02B0\u02FF\u0300\u036F\u0370\u03FF\u0400\u04FF\u0530\u058F\u0590\u05FF\u0600\u06FF\u0700\u074F\u0780\u07BF\u0900\u097F\u0980\u09FF\u0A00\u0A7F\u0A80\u0AFF\u0B00\u0B7F\u0B80\u0BFF\u0C00\u0C7F\u0C80\u0CFF\u0D00\u0D7F\u0D80\u0DFF\u0E00\u0E7F\u0E80\u0EFF\u0F00\u0FFF\u1000\u109F\u10A0\u10FF\u1100\u11FF\u1200\u137F\u13A0\u13FF\u1400\u167F\u1680\u169F\u16A0\u16FF\u1780\u17FF\u1800\u18AF\u1E00\u1EFF\u1F00\u1FFF\u2000\u206F\u2070\u209F\u20A0\u20CF\u20D0\u20FF\u2100\u214F\u2150\u218F\u2190\u21FF\u2200\u22FF\u2300\u23FF\u2400\u243F\u2440\u245F\u2460\u24FF\u2500\u257F\u2580\u259F\u25A0\u25FF\u2600\u26FF\u2700\u27BF\u2800\u28FF\u2E80\u2EFF\u2F00\u2FDF\u2FF0\u2FFF\u3000\u303F\u3040\u309F\u30A0\u30FF\u3100\u312F\u3130\u318F\u3190\u319F\u31A0\u31BF\u3200\u32FF\u3300\u33FF\u3400\u4DB5\u4E00\u9FFF\uA000\uA48F\uA490\uA4CF\uAC00\uD7A3\uE000\uF8FF\uF900\uFAFF\uFB00\uFB4F\uFB50\uFDFF\uFE20\uFE2F\uFE30\uFE4F\uFE50\uFE6F\uFE70\uFEFE\uFEFF\uFEFF\uFF00\uFFEF'.charCodeAt(location_0 + 1));
                $addRange(r1, rstart, rend);
            } else {
                location_0 = (i - 84) * 2;
                $addRange(r1, nonBMPBlockRanges[location_0], nonBMPBlockRanges[location_0 + 1]);
            }
            n = blockNames[i];
            $equals_5(n, 'Specials') && $addRange(r1, 65520, 65533);
            if ($equals_5(n, 'Private Use')) {
                $addRange(r1, 983040, 1048573);
                $addRange(r1, 1048576, 1114109);
            }
            $putStringValue(categories, n, r1);
            $putStringValue(categories2, n, complementRanges(r1));
            oldLength = buffer.string.length;
            0 < oldLength ? buffer.string = $substring_1(buffer.string, 0, 0) : 0 > oldLength && (buffer.string += valueOf_7(initUnidimensionalArray(C_classLit, $intern_44, 30, -oldLength, 15, 1)));
            buffer.string += 'Is';
            if ($indexOf_1(n, fromCodePoint(32)) >= 0) for(ci = 0; ci < n.length; ci++){
                checkCriticalStringElementIndex(ci, n.length);
                n.charCodeAt(ci) != 32 && $append(buffer, (checkCriticalStringElementIndex(ci, n.length), n.charCodeAt(ci)));
            }
            else buffer.string += '' + n;
            setAlias(buffer.string, n, true);
        }
        setAlias('ASSIGNED', 'Cn', false);
        setAlias('UNASSIGNED', 'Cn', true);
        all = (++tokens_0, new RegEx$RangeToken(4));
        $addRange(all, 0, $intern_167);
        $putStringValue(categories, 'ALL', all);
        $putStringValue(categories2, 'ALL', complementRanges(all));
        !nonxs && (nonxs = new HashMap);
        $putStringValue(nonxs, 'ASSIGNED', 'ASSIGNED');
        !nonxs && (nonxs = new HashMap);
        $putStringValue(nonxs, 'UNASSIGNED', 'UNASSIGNED');
        !nonxs && (nonxs = new HashMap);
        $putStringValue(nonxs, 'ALL', 'ALL');
    }
    tok = positive ? castTo($getStringValue(categories, name_0), 136) : castTo($getStringValue(categories2, name_0), 136);
    return tok;
}
function getRange_1(name_0, positive, xs) {
    $clinit_RegEx$Token();
    var range;
    range = getRange_0(name_0, positive);
    xs && !!range && isRegisterNonXS(name_0) && (range = null);
    return range;
}
function isRegisterNonXS(name_0) {
    if (!nonxs) return false;
    return $hasStringValue(nonxs, name_0);
}
function setAlias(newName, name_0, positive) {
    var t1, t2;
    t1 = castTo($getStringValue(categories, name_0), 121);
    t2 = castTo($getStringValue(categories2, name_0), 121);
    if (positive) {
        $putStringValue(categories, newName, t1);
        $putStringValue(categories2, newName, t2);
    } else {
        $putStringValue(categories2, newName, t1);
        $putStringValue(categories, newName, t2);
    }
}
defineClass(121, 1, $intern_168, RegEx$Token);
_.addChild = function addChild(tok) {
    throw toJs(new RuntimeException_0('Not supported.'));
};
_.getChar = function getChar() {
    return -1;
};
_.getChild = function getChild(index_0) {
    return null;
};
_.getString = function getString() {
    return null;
};
_.setMax = function setMax(max_0) {};
_.setMin = function setMin(min_0) {};
_.size_2 = function size_82() {
    return 0;
};
_.toString_0 = function toString_159() {
    return this.toString_1(0);
};
_.toString_1 = function toString_160(options) {
    return this.type_0 == 11 ? '.' : '';
};
_.type_0 = 0;
var blockNames, categories, categories2, categoryNames, nonBMPBlockRanges, nonxs = null, token_0to9, token_ccs = null, token_dot, token_empty, token_grapheme = null, token_linebeginning, token_lineend, token_not_0to9, token_not_spaces, token_not_wordchars, token_not_wordedge, token_spaces, token_stringbeginning, token_stringend, token_stringend2, token_wordbeginning, token_wordchars, token_wordedge, token_wordend, tokens_0 = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token', 121);
function $addRange(this$static, start_0, end) {
    var pos, r1, r2, temp;
    if (start_0 <= end) {
        r1 = start_0;
        r2 = end;
    } else {
        r1 = end;
        r2 = start_0;
    }
    pos = 0;
    if (this$static.ranges == null) {
        this$static.ranges = initUnidimensionalArray(I_classLit, $intern_48, 30, 2, 15, 1);
        this$static.ranges[0] = r1;
        this$static.ranges[1] = r2;
        this$static.sorted = true;
    } else {
        pos = this$static.ranges.length;
        if (this$static.ranges[pos - 1] + 1 == r1) {
            this$static.ranges[pos - 1] = r2;
            return;
        }
        temp = initUnidimensionalArray(I_classLit, $intern_48, 30, pos + 2, 15, 1);
        arraycopy(this$static.ranges, 0, temp, 0, pos);
        this$static.ranges = temp;
        this$static.ranges[pos - 1] >= r1 && (this$static.sorted = false, this$static.compacted = false);
        this$static.ranges[pos++] = r1;
        this$static.ranges[pos] = r2;
        this$static.sorted || $sortRanges(this$static);
    }
}
function $compactRanges(this$static) {
    var base, baseend, result, target;
    if (this$static.ranges == null || this$static.ranges.length <= 2) return;
    if (this$static.compacted) return;
    base = 0;
    target = 0;
    while(target < this$static.ranges.length){
        if (base != target) {
            this$static.ranges[base] = this$static.ranges[target++];
            this$static.ranges[base + 1] = this$static.ranges[target++];
        } else target += 2;
        baseend = this$static.ranges[base + 1];
        while(target < this$static.ranges.length){
            if (baseend + 1 < this$static.ranges[target]) break;
            if (baseend + 1 == this$static.ranges[target]) {
                this$static.ranges[base + 1] = this$static.ranges[target + 1];
                baseend = this$static.ranges[base + 1];
                target += 2;
            } else if (baseend >= this$static.ranges[target + 1]) target += 2;
            else if (baseend < this$static.ranges[target + 1]) {
                this$static.ranges[base + 1] = this$static.ranges[target + 1];
                baseend = this$static.ranges[base + 1];
                target += 2;
            } else throw toJs(new RuntimeException_0('Token#compactRanges(): Internel Error: [' + this$static.ranges[base] + ',' + this$static.ranges[base + 1] + '] [' + this$static.ranges[target] + ',' + this$static.ranges[target + 1] + ']'));
        }
        base += 2;
    }
    if (base != this$static.ranges.length) {
        result = initUnidimensionalArray(I_classLit, $intern_48, 30, base, 15, 1);
        arraycopy(this$static.ranges, 0, result, 0, base);
        this$static.ranges = result;
    }
    this$static.compacted = true;
}
function $intersectRanges(this$static, token) {
    var result, src1, src1begin, src1end, src2, src2begin, src2end, tok, wp;
    tok = token;
    if (tok.ranges == null || this$static.ranges == null) return;
    $sortRanges(this$static);
    $compactRanges(this$static);
    $sortRanges(tok);
    $compactRanges(tok);
    result = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.ranges.length + tok.ranges.length, 15, 1);
    wp = 0;
    src1 = 0;
    src2 = 0;
    while(src1 < this$static.ranges.length && src2 < tok.ranges.length){
        src1begin = this$static.ranges[src1];
        src1end = this$static.ranges[src1 + 1];
        src2begin = tok.ranges[src2];
        src2end = tok.ranges[src2 + 1];
        if (src1end < src2begin) src1 += 2;
        else if (src1end >= src2begin && src1begin <= src2end) {
            if (src2begin <= src1begin && src1end <= src2end) {
                result[wp++] = src1begin;
                result[wp++] = src1end;
                src1 += 2;
            } else if (src2begin <= src1begin) {
                result[wp++] = src1begin;
                result[wp++] = src2end;
                this$static.ranges[src1] = src2end + 1;
                src2 += 2;
            } else if (src1end <= src2end) {
                result[wp++] = src2begin;
                result[wp++] = src1end;
                src1 += 2;
            } else {
                result[wp++] = src2begin;
                result[wp++] = src2end;
                this$static.ranges[src1] = src2end + 1;
            }
        } else if (src2end < src1begin) src2 += 2;
        else throw toJs(new RuntimeException_0('Token#intersectRanges(): Internal Error: [' + this$static.ranges[src1] + ',' + this$static.ranges[src1 + 1] + '] & [' + tok.ranges[src2] + ',' + tok.ranges[src2 + 1] + ']'));
    }
    while(src1 < this$static.ranges.length){
        result[wp++] = this$static.ranges[src1++];
        result[wp++] = this$static.ranges[src1++];
    }
    this$static.ranges = initUnidimensionalArray(I_classLit, $intern_48, 30, wp, 15, 1);
    arraycopy(result, 0, this$static.ranges, 0, wp);
}
function $mergeRanges(this$static, token) {
    var i, j, k, result, tok;
    tok = castTo(token, 136);
    $sortRanges(this$static);
    $sortRanges(tok);
    if (tok.ranges == null) return;
    this$static.sorted = true;
    if (this$static.ranges == null) {
        this$static.ranges = initUnidimensionalArray(I_classLit, $intern_48, 30, tok.ranges.length, 15, 1);
        arraycopy(tok.ranges, 0, this$static.ranges, 0, tok.ranges.length);
        return;
    }
    result = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.ranges.length + tok.ranges.length, 15, 1);
    for(i = 0, j = 0, k = 0; i < this$static.ranges.length || j < tok.ranges.length;){
        if (i >= this$static.ranges.length) {
            result[k++] = tok.ranges[j++];
            result[k++] = tok.ranges[j++];
        } else if (j >= tok.ranges.length) {
            result[k++] = this$static.ranges[i++];
            result[k++] = this$static.ranges[i++];
        } else if (tok.ranges[j] < this$static.ranges[i] || tok.ranges[j] === this$static.ranges[i] && tok.ranges[j + 1] < this$static.ranges[i + 1]) {
            result[k++] = tok.ranges[j++];
            result[k++] = tok.ranges[j++];
        } else {
            result[k++] = this$static.ranges[i++];
            result[k++] = this$static.ranges[i++];
        }
    }
    this$static.ranges = result;
}
function $sortRanges(this$static) {
    var i, j, tmp;
    if (this$static.sorted) return;
    if (this$static.ranges == null) return;
    for(i = this$static.ranges.length - 4; i >= 0; i -= 2){
        for(j = 0; j <= i; j += 2)if (this$static.ranges[j] > this$static.ranges[j + 2] || this$static.ranges[j] === this$static.ranges[j + 2] && this$static.ranges[j + 1] > this$static.ranges[j + 3]) {
            tmp = this$static.ranges[j + 2];
            this$static.ranges[j + 2] = this$static.ranges[j];
            this$static.ranges[j] = tmp;
            tmp = this$static.ranges[j + 3];
            this$static.ranges[j + 3] = this$static.ranges[j + 1];
            this$static.ranges[j + 1] = tmp;
        }
    }
    this$static.sorted = true;
}
function $subtractRanges(this$static, token) {
    var result, src_0, srcbegin, srcend, sub_0, subbegin, subend, tok, wp;
    if (token.type_0 == 5) {
        $intersectRanges(this$static, token);
        return;
    }
    tok = token;
    if (tok.ranges == null || this$static.ranges == null) return;
    $sortRanges(this$static);
    $compactRanges(this$static);
    $sortRanges(tok);
    $compactRanges(tok);
    result = initUnidimensionalArray(I_classLit, $intern_48, 30, this$static.ranges.length + tok.ranges.length, 15, 1);
    wp = 0;
    src_0 = 0;
    sub_0 = 0;
    while(src_0 < this$static.ranges.length && sub_0 < tok.ranges.length){
        srcbegin = this$static.ranges[src_0];
        srcend = this$static.ranges[src_0 + 1];
        subbegin = tok.ranges[sub_0];
        subend = tok.ranges[sub_0 + 1];
        if (srcend < subbegin) {
            result[wp++] = this$static.ranges[src_0++];
            result[wp++] = this$static.ranges[src_0++];
        } else if (srcend >= subbegin && srcbegin <= subend) {
            if (subbegin <= srcbegin && srcend <= subend) src_0 += 2;
            else if (subbegin <= srcbegin) {
                this$static.ranges[src_0] = subend + 1;
                sub_0 += 2;
            } else if (srcend <= subend) {
                result[wp++] = srcbegin;
                result[wp++] = subbegin - 1;
                src_0 += 2;
            } else {
                result[wp++] = srcbegin;
                result[wp++] = subbegin - 1;
                this$static.ranges[src_0] = subend + 1;
                sub_0 += 2;
            }
        } else if (subend < srcbegin) sub_0 += 2;
        else throw toJs(new RuntimeException_0('Token#subtractRanges(): Internal Error: [' + this$static.ranges[src_0] + ',' + this$static.ranges[src_0 + 1] + '] - [' + tok.ranges[sub_0] + ',' + tok.ranges[sub_0 + 1] + ']'));
    }
    while(src_0 < this$static.ranges.length){
        result[wp++] = this$static.ranges[src_0++];
        result[wp++] = this$static.ranges[src_0++];
    }
    this$static.ranges = initUnidimensionalArray(I_classLit, $intern_48, 30, wp, 15, 1);
    arraycopy(result, 0, this$static.ranges, 0, wp);
}
function RegEx$RangeToken(type_0) {
    $clinit_RegEx$Token();
    RegEx$Token.call(this, type_0);
    this.sorted = false;
    this.compacted = false;
}
function complementRanges(token) {
    $clinit_RegEx$Token();
    var i, last, len, ret, tok, wp;
    if (token.type_0 != 4 && token.type_0 != 5) throw toJs(new IllegalArgumentException_0('Token#complementRanges(): must be RANGE: ' + token.type_0));
    tok = token;
    $sortRanges(tok);
    $compactRanges(tok);
    len = tok.ranges.length + 2;
    tok.ranges[0] == 0 && (len -= 2);
    last = tok.ranges[tok.ranges.length - 1];
    last == $intern_167 && (len -= 2);
    ret = (++tokens_0, new RegEx$RangeToken(4));
    ret.ranges = initUnidimensionalArray(I_classLit, $intern_48, 30, len, 15, 1);
    wp = 0;
    if (tok.ranges[0] > 0) {
        ret.ranges[wp++] = 0;
        ret.ranges[wp++] = tok.ranges[0] - 1;
    }
    for(i = 1; i < tok.ranges.length - 2; i += 2){
        ret.ranges[wp++] = tok.ranges[i] + 1;
        ret.ranges[wp++] = tok.ranges[i + 1] - 1;
    }
    if (last != $intern_167) {
        ret.ranges[wp++] = last + 1;
        ret.ranges[wp] = $intern_167;
    }
    ret.compacted = true;
    return ret;
}
function escapeCharInCharClass(ch_0) {
    var number, pre, ret;
    switch(ch_0){
        case 91:
        case 93:
        case 45:
        case 94:
        case 44:
        case 92:
            ret = '\\' + String.fromCharCode(ch_0 & $intern_46);
            break;
        case 12:
            ret = '\\f';
            break;
        case 10:
            ret = '\\n';
            break;
        case 13:
            ret = '\\r';
            break;
        case 9:
            ret = '\\t';
            break;
        case 27:
            ret = '\\e';
            break;
        default:
            if (ch_0 < 32) {
                pre = (number = ch_0 >>> 0, '0' + number.toString(16));
                ret = '\\x' + $substring_1(pre, pre.length - 2, pre.length);
            } else if (ch_0 >= $intern_64) {
                pre = (number = ch_0 >>> 0, '0' + number.toString(16));
                ret = '\\v' + $substring_1(pre, pre.length - 6, pre.length);
            } else ret = '' + String.fromCharCode(ch_0 & $intern_46);
    }
    return ret;
}
defineClass(136, 121, {
    3: 1,
    136: 1,
    121: 1
}, RegEx$RangeToken);
_.toString_1 = function toString_161(options) {
    var i, ret, sb;
    if (this.type_0 == 4) {
        if (this == token_dot) ret = '.';
        else if (this == token_0to9) ret = '\\d';
        else if (this == token_wordchars) ret = '\\w';
        else if (this == token_spaces) ret = '\\s';
        else {
            sb = new StringBuffer;
            sb.string += '[';
            for(i = 0; i < this.ranges.length; i += 2){
                (options & $intern_149) != 0 && i > 0 && (sb.string += ',', sb);
                if (this.ranges[i] === this.ranges[i + 1]) $append_3(sb, escapeCharInCharClass(this.ranges[i]));
                else {
                    $append_3(sb, escapeCharInCharClass(this.ranges[i]));
                    sb.string += '-';
                    $append_3(sb, escapeCharInCharClass(this.ranges[i + 1]));
                }
            }
            sb.string += ']';
            ret = sb.string;
        }
    } else {
        if (this == token_not_0to9) ret = '\\D';
        else if (this == token_not_wordchars) ret = '\\W';
        else if (this == token_not_spaces) ret = '\\S';
        else {
            sb = new StringBuffer;
            sb.string += '[^';
            for(i = 0; i < this.ranges.length; i += 2){
                (options & $intern_149) != 0 && i > 0 && (sb.string += ',', sb);
                if (this.ranges[i] === this.ranges[i + 1]) $append_3(sb, escapeCharInCharClass(this.ranges[i]));
                else {
                    $append_3(sb, escapeCharInCharClass(this.ranges[i]));
                    sb.string += '-';
                    $append_3(sb, escapeCharInCharClass(this.ranges[i + 1]));
                }
            }
            sb.string += ']';
            ret = sb.string;
        }
    }
    return ret;
};
_.compacted = false;
_.sorted = false;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$RangeToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/RangeToken', 136);
function RegEx$RegexParser$ReferencePosition(n) {
    this.refNumber = n;
}
defineClass(575, 1, {
    575: 1
}, RegEx$RegexParser$ReferencePosition);
_.refNumber = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$RegexParser$ReferencePosition_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/RegexParser/ReferencePosition', 575);
function $setPattern(this$static, newPattern, options) {
    var rp;
    this$static.regex = newPattern;
    this$static.options_0 = options;
    rp = (this$static.options_0 & 512) == 512 ? new RegEx$ParserForXMLSchema : new RegEx$RegexParser;
    this$static.tokentree = $parse_3(rp, this$static.regex, this$static.options_0);
}
function RegEx$RegularExpression(regex) {
    $setPattern(this, regex, parseOptions());
}
defineClass(574, 1, {
    3: 1,
    574: 1
}, RegEx$RegularExpression);
_.equals_0 = function equals_220(obj) {
    var r;
    if (obj == null) return false;
    if (!instanceOf(obj, 574)) return false;
    r = castTo(obj, 574);
    return $equals_5(this.regex, r.regex) && this.options_0 == r.options_0;
};
_.hashCode_1 = function hashCode_85() {
    return $hashCode_2(this.regex + '/' + createOptionString(this.options_0));
};
_.toString_0 = function toString_162() {
    return this.tokentree.toString_1(this.options_0);
};
_.options_0 = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$RegularExpression_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/RegularExpression', 574);
function RegEx$Token$CharToken(type_0, ch_0) {
    $clinit_RegEx$Token();
    RegEx$Token.call(this, type_0);
    this.chardata = ch_0;
}
defineClass(227, 121, $intern_168, RegEx$Token$CharToken);
_.getChar = function getChar_0() {
    return this.chardata;
};
_.toString_1 = function toString_163(options) {
    var number, pre, ret;
    switch(this.type_0){
        case 0:
            switch(this.chardata){
                case 124:
                case 42:
                case 43:
                case 63:
                case 40:
                case 41:
                case 46:
                case 91:
                case 123:
                case 92:
                    ret = '\\' + charToString(this.chardata & $intern_46);
                    break;
                case 12:
                    ret = '\\f';
                    break;
                case 10:
                    ret = '\\n';
                    break;
                case 13:
                    ret = '\\r';
                    break;
                case 9:
                    ret = '\\t';
                    break;
                case 27:
                    ret = '\\e';
                    break;
                default:
                    if (this.chardata >= $intern_64) {
                        pre = (number = this.chardata >>> 0, '0' + number.toString(16));
                        ret = '\\v' + $substring_1(pre, pre.length - 6, pre.length);
                    } else ret = '' + charToString(this.chardata & $intern_46);
            }
            break;
        case 8:
            this == token_linebeginning || this == token_lineend ? ret = '' + charToString(this.chardata & $intern_46) : ret = '\\' + charToString(this.chardata & $intern_46);
            break;
        default:
            ret = null;
    }
    return ret;
};
_.chardata = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$CharToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/CharToken', 227);
function RegEx$Token$ClosureToken(type_0, tok) {
    $clinit_RegEx$Token();
    RegEx$Token.call(this, type_0);
    this.child = tok;
    this.min_0 = -1;
    this.max_0 = -1;
}
defineClass(319, 121, $intern_168, RegEx$Token$ClosureToken);
_.getChild = function getChild_0(index_0) {
    return this.child;
};
_.setMax = function setMax_0(max_0) {
    this.max_0 = max_0;
};
_.setMin = function setMin_0(min_0) {
    this.min_0 = min_0;
};
_.size_2 = function size_83() {
    return 1;
};
_.toString_1 = function toString_164(options) {
    var ret;
    if (this.type_0 == 3) {
        if (this.min_0 < 0 && this.max_0 < 0) ret = this.child.toString_1(options) + '*';
        else if (this.min_0 == this.max_0) ret = this.child.toString_1(options) + '{' + this.min_0 + '}';
        else if (this.min_0 >= 0 && this.max_0 >= 0) ret = this.child.toString_1(options) + '{' + this.min_0 + ',' + this.max_0 + '}';
        else if (this.min_0 >= 0 && this.max_0 < 0) ret = this.child.toString_1(options) + '{' + this.min_0 + ',}';
        else throw toJs(new RuntimeException_0('Token#toString(): CLOSURE ' + this.min_0 + ', ' + this.max_0));
    } else {
        if (this.min_0 < 0 && this.max_0 < 0) ret = this.child.toString_1(options) + '*?';
        else if (this.min_0 == this.max_0) ret = this.child.toString_1(options) + '{' + this.min_0 + '}?';
        else if (this.min_0 >= 0 && this.max_0 >= 0) ret = this.child.toString_1(options) + '{' + this.min_0 + ',' + this.max_0 + '}?';
        else if (this.min_0 >= 0 && this.max_0 < 0) ret = this.child.toString_1(options) + '{' + this.min_0 + ',}?';
        else throw toJs(new RuntimeException_0('Token#toString(): NONGREEDYCLOSURE ' + this.min_0 + ', ' + this.max_0));
    }
    return ret;
};
_.max_0 = 0;
_.min_0 = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$ClosureToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/ClosureToken', 319);
function RegEx$Token$ConcatToken(t1, t2) {
    RegEx$Token.call(this, 1);
    this.child = t1;
    this.child2 = t2;
}
defineClass(816, 121, $intern_168, RegEx$Token$ConcatToken);
_.getChild = function getChild_1(index_0) {
    return index_0 == 0 ? this.child : this.child2;
};
_.size_2 = function size_84() {
    return 2;
};
_.toString_1 = function toString_165(options) {
    var ret;
    this.child2.type_0 == 3 && this.child2.getChild(0) == this.child ? ret = this.child.toString_1(options) + '+' : this.child2.type_0 == 9 && this.child2.getChild(0) == this.child ? ret = this.child.toString_1(options) + '+?' : ret = this.child.toString_1(options) + ('' + this.child2.toString_1(options));
    return ret;
};
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$ConcatToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/ConcatToken', 816);
function RegEx$Token$ConditionToken(refno, cond, yespat, nopat) {
    $clinit_RegEx$Token();
    RegEx$Token.call(this, 26);
    this.refNumber = refno;
    this.condition = cond;
    this.yes = yespat;
    this.no = nopat;
}
defineClass(1891, 121, $intern_168, RegEx$Token$ConditionToken);
_.getChild = function getChild_2(index_0) {
    if (index_0 == 0) return this.yes;
    if (index_0 == 1) return this.no;
    throw toJs(new RuntimeException_0('Internal Error: ' + index_0));
};
_.size_2 = function size_85() {
    return !this.no ? 1 : 2;
};
_.toString_1 = function toString_166(options) {
    var ret;
    this.refNumber > 0 ? ret = '(?(' + this.refNumber + ')' : this.condition.type_0 == 8 ? ret = '(?(' + this.condition + ')' : ret = '(?' + this.condition;
    !this.no ? ret += this.yes + ')' : ret += this.yes + '|' + this.no + ')';
    return ret;
};
_.refNumber = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$ConditionToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/ConditionToken', 1891);
function RegEx$Token$ModifierToken(tok, add_0, mask) {
    RegEx$Token.call(this, 25);
    this.child = tok;
    this.add_0 = add_0;
    this.mask = mask;
}
defineClass(1892, 121, $intern_168, RegEx$Token$ModifierToken);
_.getChild = function getChild_3(index_0) {
    return this.child;
};
_.size_2 = function size_86() {
    return 1;
};
_.toString_1 = function toString_167(options) {
    return '(?' + (this.add_0 == 0 ? '' : createOptionString(this.add_0)) + (this.mask == 0 ? '' : createOptionString(this.mask)) + ':' + this.child.toString_1(options) + ')';
};
_.add_0 = 0;
_.mask = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$ModifierToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/ModifierToken', 1892);
function RegEx$Token$ParenToken(type_0, tok, paren) {
    RegEx$Token.call(this, type_0);
    this.child = tok;
    this.parennumber = paren;
}
defineClass(817, 121, $intern_168, RegEx$Token$ParenToken);
_.getChild = function getChild_4(index_0) {
    return this.child;
};
_.size_2 = function size_87() {
    return 1;
};
_.toString_1 = function toString_168(options) {
    var ret;
    ret = null;
    switch(this.type_0){
        case 6:
            this.parennumber == 0 ? ret = '(?:' + this.child.toString_1(options) + ')' : ret = '(' + this.child.toString_1(options) + ')';
            break;
        case 20:
            ret = '(?=' + this.child.toString_1(options) + ')';
            break;
        case 21:
            ret = '(?!' + this.child.toString_1(options) + ')';
            break;
        case 22:
            ret = '(?<=' + this.child.toString_1(options) + ')';
            break;
        case 23:
            ret = '(?<!' + this.child.toString_1(options) + ')';
            break;
        case 24:
            ret = '(?>' + this.child.toString_1(options) + ')';
    }
    return ret;
};
_.parennumber = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$ParenToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/ParenToken', 817);
function RegEx$Token$StringToken(type_0, str, n) {
    $clinit_RegEx$Token();
    RegEx$Token.call(this, type_0);
    this.string = str;
    this.refNumber = n;
}
defineClass(515, 121, {
    3: 1,
    121: 1,
    515: 1
}, RegEx$Token$StringToken);
_.getString = function getString_0() {
    return this.string;
};
_.toString_1 = function toString_169(options) {
    return this.type_0 == 12 ? '\\' + this.refNumber : quoteMeta(this.string);
};
_.refNumber = 0;
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$StringToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/StringToken', 515);
function $addChild_0(this$static, tok) {
    var buffer, ch_0, i, nextMaxLength, previous, size_0;
    if (!tok) return;
    !this$static.children && (this$static.children = new Vector);
    if (this$static.type_0 == 2) {
        $addElement(this$static.children, tok);
        return;
    }
    if (tok.type_0 == 1) {
        for(i = 0; i < tok.size_2(); i++)$addChild_0(this$static, tok.getChild(i));
        return;
    }
    size_0 = this$static.children.arrayList.array.length;
    if (size_0 == 0) {
        $addElement(this$static.children, tok);
        return;
    }
    previous = castTo($elementAt(this$static.children, size_0 - 1), 121);
    if (!((previous.type_0 == 0 || previous.type_0 == 10) && (tok.type_0 == 0 || tok.type_0 == 10))) {
        $addElement(this$static.children, tok);
        return;
    }
    nextMaxLength = tok.type_0 == 0 ? 2 : tok.getString().length;
    if (previous.type_0 == 0) {
        buffer = new StringBuffer_0;
        ch_0 = previous.getChar();
        ch_0 >= $intern_64 ? $append_3(buffer, decomposeToSurrogates(ch_0)) : $append(buffer, ch_0 & $intern_46);
        previous = (++tokens_0, new RegEx$Token$StringToken(10, null, 0));
        $setElementAt(this$static.children, previous, size_0 - 1);
    } else {
        buffer = (previous.getString().length, new StringBuffer_0);
        $append_3(buffer, previous.getString());
    }
    if (tok.type_0 == 0) {
        ch_0 = tok.getChar();
        ch_0 >= $intern_64 ? $append_3(buffer, decomposeToSurrogates(ch_0)) : $append(buffer, ch_0 & $intern_46);
    } else $append_3(buffer, tok.getString());
    castTo(previous, 515).string = buffer.string;
}
function RegEx$Token$UnionToken(type_0) {
    $clinit_RegEx$Token();
    RegEx$Token.call(this, type_0);
}
defineClass(463, 121, $intern_168, RegEx$Token$UnionToken);
_.addChild = function addChild_0(tok) {
    $addChild_0(this, tok);
};
_.getChild = function getChild_5(index_0) {
    return castTo($elementAt(this.children, index_0), 121);
};
_.size_2 = function size_88() {
    return !this.children ? 0 : this.children.arrayList.array.length;
};
_.toString_1 = function toString_170(options) {
    var ch_0, ch2, i, ret, sb;
    if (this.type_0 == 1) {
        if (this.children.arrayList.array.length == 2) {
            ch_0 = castTo($elementAt(this.children, 0), 121);
            ch2 = castTo($elementAt(this.children, 1), 121);
            ch2.type_0 == 3 && ch2.getChild(0) == ch_0 ? ret = ch_0.toString_1(options) + '+' : ch2.type_0 == 9 && ch2.getChild(0) == ch_0 ? ret = ch_0.toString_1(options) + '+?' : ret = ch_0.toString_1(options) + ('' + ch2.toString_1(options));
        } else {
            sb = new StringBuffer;
            for(i = 0; i < this.children.arrayList.array.length; i++)$append_3(sb, castTo($elementAt(this.children, i), 121).toString_1(options));
            ret = sb.string;
        }
        return ret;
    }
    if (this.children.arrayList.array.length == 2 && castTo($elementAt(this.children, 1), 121).type_0 == 7) ret = castTo($elementAt(this.children, 0), 121).toString_1(options) + '?';
    else if (this.children.arrayList.array.length == 2 && castTo($elementAt(this.children, 0), 121).type_0 == 7) ret = castTo($elementAt(this.children, 1), 121).toString_1(options) + '??';
    else {
        sb = new StringBuffer;
        $append_3(sb, castTo($elementAt(this.children, 0), 121).toString_1(options));
        for(i = 1; i < this.children.arrayList.array.length; i++){
            sb.string += '|';
            $append_3(sb, castTo($elementAt(this.children, i), 121).toString_1(options));
        }
        ret = sb.string;
    }
    return ret;
};
var Lorg_eclipse_emf_ecore_xml_type_internal_RegEx$Token$UnionToken_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.internal', 'RegEx/Token/UnionToken', 463);
function normalize(value_0, collapse) {
    var buffer, c, i, length_0, offset, skipSpace, valueArray;
    if (value_0 == null) return null;
    length_0 = value_0.length;
    if (length_0 == 0) return '';
    valueArray = initUnidimensionalArray(C_classLit, $intern_44, 30, length_0, 15, 1);
    checkCriticalStringBounds(0, length_0, value_0.length);
    checkCriticalStringBounds(0, length_0, valueArray.length);
    $getChars0(value_0, 0, length_0, valueArray, 0);
    buffer = null;
    skipSpace = collapse;
    for(i = 0, offset = 0; i < length_0; i++){
        c = valueArray[i];
        $clinit_DataValue$XMLChar();
        if (c <= 32 && (CHARS[c] & 2) != 0) {
            if (skipSpace) {
                !buffer && (buffer = new StringBuffer_1(value_0));
                $deleteCharAt(buffer, i - offset++);
            } else {
                skipSpace = collapse;
                if (c != 32) {
                    !buffer && (buffer = new StringBuffer_1(value_0));
                    $replace0(buffer, i - offset, i - offset + 1, String.fromCharCode(32));
                }
            }
        } else skipSpace = false;
    }
    if (skipSpace) {
        if (!buffer) return checkCriticalStringBounds(0, length_0 - 1, value_0.length), value_0.substr(0, length_0 - 1);
        else {
            length_0 = buffer.string.length;
            return length_0 > 0 ? $substring_1(buffer.string, 0, length_0 - 1) : '';
        }
    } else return !buffer ? value_0 : buffer.string;
}
function XMLTypeUtil$PatternMatcherImpl(pattern) {
    this.regularExpression = new RegEx$RegularExpression(pattern);
}
defineClass(512, 1, {
    584: 1
}, XMLTypeUtil$PatternMatcherImpl);
_.toString_0 = function toString_171() {
    return this.regularExpression.regex;
};
var Lorg_eclipse_emf_ecore_xml_type_util_XMLTypeUtil$PatternMatcherImpl_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.util', 'XMLTypeUtil/PatternMatcherImpl', 512);
function $clinit_XMLTypeValidator() {
    $clinit_XMLTypeValidator = emptyMethod;
    $clinit_EObjectValidator();
    INSTANCE_12 = new XMLTypeValidator;
    stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 2), $intern_16, 373, 0, [
        stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 1), $intern_169, 584, 0, [
            new XMLTypeUtil$PatternMatcherImpl('[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*')
        ])
    ]);
    stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 2), $intern_16, 373, 0, [
        stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 1), $intern_169, 584, 0, [
            new XMLTypeUtil$PatternMatcherImpl('\\i\\c*')
        ])
    ]);
    stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 2), $intern_16, 373, 0, [
        stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 1), $intern_169, 584, 0, [
            new XMLTypeUtil$PatternMatcherImpl('[\\i-[:]][\\c-[:]]*')
        ]),
        stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 1), $intern_169, 584, 0, [
            new XMLTypeUtil$PatternMatcherImpl('\\i\\c*')
        ])
    ]);
    new BigInteger_3('-1');
    stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 2), $intern_16, 373, 0, [
        stampJavaTypeInfo(getClassLiteralForArray(Lorg_eclipse_emf_ecore_EValidator$PatternMatcher_2_classLit, 1), $intern_169, 584, 0, [
            new XMLTypeUtil$PatternMatcherImpl('\\c+')
        ])
    ]);
    new BigInteger_3('0');
    new BigInteger_3('0');
    new BigInteger_3('1');
    new BigInteger_3('0');
    new BigInteger_3('18446744073709551615');
}
function XMLTypeValidator() {}
defineClass(1649, 1467, {}, XMLTypeValidator);
var INSTANCE_12;
var Lorg_eclipse_emf_ecore_xml_type_util_XMLTypeValidator_2_classLit = createForClass('org.eclipse.emf.ecore.xml.type.util', 'XMLTypeValidator', 1649);
function operator_plus(a, b) {
    return (checkCriticalNotNull(a), a) + doubleValue__D__devirtual$(b);
}
function $clinit_ExclusiveRange() {
    $clinit_ExclusiveRange = emptyMethod;
    EMPTY_LIST_ITERATOR = new ExclusiveRange$1;
}
function ExclusiveRange(end) {
    $clinit_ExclusiveRange();
    this.first = 0;
    this.last = end - 1;
    this.step = 1;
}
defineClass(267, 1, $intern_23, ExclusiveRange);
_.forEach_0 = function forEach_41(action) {
    $forEach_0(this, action);
};
_.iterator_0 = function iterator_91() {
    return (this.last - this.first) * this.step < 0 ? EMPTY_LIST_ITERATOR : new ExclusiveRange$RangeIterator(this);
};
_.first = 0;
_.last = 0;
_.step = 0;
var EMPTY_LIST_ITERATOR;
var Lorg_eclipse_xtext_xbase_lib_ExclusiveRange_2_classLit = createForClass('org.eclipse.xtext.xbase.lib', 'ExclusiveRange', 267);
function $add_35() {
    throw toJs(new UnsupportedOperationException_0('Cannot add elements to a Range'));
}
function $next_17() {
    throw toJs(new NoSuchElementException);
}
function $previous_1() {
    throw toJs(new NoSuchElementException);
}
function $set_18() {
    throw toJs(new UnsupportedOperationException_0('Cannot set elements in a Range'));
}
function ExclusiveRange$1() {}
defineClass(1049, 1, $intern_14, ExclusiveRange$1);
_.add_1 = function add_73(e) {
    castTo(e, 17);
    $add_35();
};
_.forEachRemaining = function forEachRemaining_61(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_51() {
    return $next_17();
};
_.previous_0 = function previous_12() {
    return $previous_1();
};
_.set_1 = function set_45(e) {
    castTo(e, 17);
    $set_18();
};
_.hasNext_0 = function hasNext_52() {
    return false;
};
_.hasPrevious = function hasPrevious_12() {
    return false;
};
_.nextIndex_0 = function nextIndex_12() {
    return -1;
};
_.previousIndex = function previousIndex_11() {
    return -1;
};
_.remove = function remove_133() {
    throw toJs(new UnsupportedOperationException_0('Cannot remove elements from a Range'));
};
var Lorg_eclipse_xtext_xbase_lib_ExclusiveRange$1_2_classLit = createForClass('org.eclipse.xtext.xbase.lib', 'ExclusiveRange/1', 1049);
function $add_36() {
    throw toJs(new UnsupportedOperationException_0('Cannot add elements to a Range'));
}
function $next_18(this$static) {
    var value_0;
    if (!(this$static.this$01.step < 0 ? this$static.next_0 >= this$static.this$01.last : this$static.next_0 <= this$static.this$01.last)) throw toJs(new NoSuchElementException);
    value_0 = this$static.next_0;
    this$static.next_0 += this$static.this$01.step;
    ++this$static.nextIndex;
    return valueOf_3(value_0);
}
function $previous_2(this$static) {
    if (this$static.nextIndex <= 0) throw toJs(new NoSuchElementException);
    --this$static.nextIndex;
    this$static.next_0 -= this$static.this$01.step;
    return valueOf_3(this$static.next_0);
}
function $set_19() {
    throw toJs(new UnsupportedOperationException_0('Cannot set elements in a Range'));
}
function ExclusiveRange$RangeIterator(this$0) {
    this.this$01 = this$0;
    this.next_0 = this.this$01.first;
}
defineClass(258, 1, $intern_14, ExclusiveRange$RangeIterator);
_.add_1 = function add_74(e) {
    castTo(e, 17);
    $add_36();
};
_.forEachRemaining = function forEachRemaining_62(consumer) {
    $forEachRemaining(this, consumer);
};
_.next_1 = function next_52() {
    return $next_18(this);
};
_.previous_0 = function previous_13() {
    return $previous_2(this);
};
_.set_1 = function set_46(e) {
    castTo(e, 17);
    $set_19();
};
_.hasNext_0 = function hasNext_53() {
    return this.this$01.step < 0 ? this.next_0 >= this.this$01.last : this.next_0 <= this.this$01.last;
};
_.hasPrevious = function hasPrevious_13() {
    return this.nextIndex > 0;
};
_.nextIndex_0 = function nextIndex_13() {
    return this.nextIndex;
};
_.previousIndex = function previousIndex_12() {
    return this.nextIndex - 1;
};
_.remove = function remove_134() {
    throw toJs(new UnsupportedOperationException_0('Cannot remove elements from a Range'));
};
_.next_0 = 0;
_.nextIndex = 0;
var Lorg_eclipse_xtext_xbase_lib_ExclusiveRange$RangeIterator_2_classLit = createForClass('org.eclipse.xtext.xbase.lib', 'ExclusiveRange/RangeIterator', 258);
function forEach_42(iterable, procedure) {
    forEach_44(new AbstractEList$EIterator(iterable), procedure);
}
function isEmpty_35(iterable) {
    if (iterable) return iterable.isEmpty();
    return !iterable.iterator_0().hasNext_0();
}
function isNullOrEmpty(iterable) {
    return !iterable || isEmpty_35(iterable);
}
function forEach_43(iterator, procedure) {
    while(iterator.data_0 == null && !iterator.includeRoot ? $hasAnyChildren(iterator) : iterator.data_0 == null || iterator.size_0 != 0 && castTo(iterator.data_0[iterator.size_0 - 1], 49).hasNext_0())procedure.apply_5($next_13(iterator));
}
function forEach_44(iterator, procedure) {
    var i;
    i = 0;
    while(iterator.cursor != iterator.this$01_2.size_1()){
        $apply_19(procedure, $doNext(iterator), valueOf_3(i));
        i != $intern_0 && ++i;
    }
}
var C_classLit = createForPrimitive('char', 'C');
var I_classLit = createForPrimitive('int', 'I');
var Z_classLit = createForPrimitive('boolean', 'Z');
var J_classLit = createForPrimitive('long', 'J');
var B_classLit = createForPrimitive('byte', 'B');
var D_classLit = createForPrimitive('double', 'D');
var F_classLit = createForPrimitive('float', 'F');
var S_classLit = createForPrimitive('short', 'S');
var Lorg_eclipse_elk_core_labels_ILabelManager_2_classLit = createForInterface('org.eclipse.elk.core.labels', 'ILabelManager');
var Lorg_eclipse_emf_common_util_DiagnosticChain_2_classLit = createForInterface('org.eclipse.emf.common.util', 'DiagnosticChain');
var Lorg_eclipse_emf_ecore_resource_ResourceSet_2_classLit = createForInterface('org.eclipse.emf.ecore.resource', 'ResourceSet');
var Lorg_eclipse_emf_common_util_InvocationTargetException_2_classLit = createForClass('org.eclipse.emf.common.util', 'InvocationTargetException', null);
var $entry = ($clinit_Impl(), entry_2);
var gwtOnLoad = gwtOnLoad = gwtOnLoad_0;
addInitFunctions(init);
setGwtProperty('permProps', [
    [
        [
            'locale',
            'default'
        ],
        [
            'user.agent',
            'gecko1_8'
        ]
    ],
    [
        [
            'locale',
            'default'
        ],
        [
            'user.agent',
            'safari'
        ]
    ]
]);
// --------------    RUN GWT INITIALIZATION CODE    -------------- 
gwtOnLoad(null, 'elk', null);

},{}],"eODwE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setPopup", ()=>setPopup);
parcelHelpers.export(exports, "popupSlice", ()=>popupSlice);
parcelHelpers.export(exports, "popupValueSelector", ()=>popupValueSelector);
var _toolkit = require("@reduxjs/toolkit");
var _runtimeSliceJs = require("./runtimeSlice.js");
var _selectionSliceJs = require("./selectionSlice.js");
var _createSliceSelectorJs = require("./utils/createSliceSelector.js");
const setPopup = (0, _toolkit.createAction)('setPopup');
const initialState = null;
const popupSlice = (0, _toolkit.createSlice)({
    name: 'popup',
    initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase(setPopup, (state, action)=>action.payload);
    }
});
const popupSelector = (0, _createSliceSelectorJs.createSliceSelector)(popupSlice);
const popupValueSelector = (0, _toolkit.createSelector)(popupSelector, (0, _runtimeSliceJs.graphSelector), (0, _selectionSliceJs.selectedValuesSelector), (popup, graph, values)=>popup === null || graph === null ? null : popup.type === 'node' ? {
        node: graph.nodes[popup.id],
        value: values === null ? null : values[popup.id] ?? null,
        ...popup,
        type: 'node'
    } : {
        edge: graph.edges[popup.id],
        ...popup,
        type: 'edge'
    });

},{"@reduxjs/toolkit":"6q4uk","./runtimeSlice.js":"iZrZf","./selectionSlice.js":"bBSOy","./utils/createSliceSelector.js":"fnXHV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iVDT3":[function() {},{}],"jsETu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _react = require("react");
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
var _reactRouterDom = require("react-router-dom");
function mapStateToProps(state) {
    return {
        configEditorString: state.configEditorString,
        editorRef: state.editorRef,
        isAuthenticated: state.isAuthenticated,
        lastPosition: state.lastPosition,
        manualParse: state.manualParse,
        mode: state.mode,
        name: state.name,
        profilePicUrl: state.profilePicUrl,
        settings: state.settings,
        vegaLiteSpec: state.vegaLiteSpec,
        vegaSpec: state.vegaSpec,
        view: state.view
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        clearConfig: _editorJs.clearConfig,
        exportVega: _editorJs.exportVega,
        parseSpec: _editorJs.parseSpec,
        receiveCurrentUser: _editorJs.receiveCurrentUser,
        setConfig: _editorJs.setConfig,
        setConfigEditorString: _editorJs.setConfigEditorString,
        setScrollPosition: _editorJs.setScrollPosition,
        setSettingsState: _editorJs.setSettingsState,
        setThemeName: _editorJs.setThemeName,
        toggleAutoParse: _editorJs.toggleAutoParse,
        updateVegaSpec: _editorJs.updateVegaSpec
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)((0, _rendererJsDefault.default)));

},{"react":"bmhQu","react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./renderer.js":"gs53d","react-router-dom":"b9X5n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gs53d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _reactFeather = require("react-feather");
var _reactPortal = require("react-portal");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _indexJs = require("../../constants/index.js");
var _constsJs = require("../../constants/consts.js");
var _specsJs = require("../../constants/specs.js");
var _browserJs = require("../../utils/browser.js");
var _indexJs1 = require("./export-modal/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./gist-modal/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./help-modal/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexCss = require("./index.css");
var _indexJs4 = require("./share-modal/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
const formatExampleName = (name)=>name.split(/[_-]/).map((i)=>i[0].toUpperCase() + i.substring(1)).join(' ');
class Header extends _react.PureComponent {
    examplePortal = /*#__PURE__*/ _react.createRef();
    listenerAttached = false;
    constructor(props){
        super(props);
        this.state = {
            open: false,
            scrollPosition: 0,
            showVega: props.mode === (0, _indexJs.Mode).Vega,
            mode: props.mode
        };
    }
    async componentDidMount() {
        const className = [
            'profile-img',
            'arrow-down',
            'profile-container'
        ];
        window.addEventListener('click', (e)=>{
            const key = 'className';
            if (className.includes(e.target[key])) this.setState({
                open: !this.state.open
            });
            else this.setState({
                open: false
            });
        });
        if (window.location.hash.includes('auth_token=') || window.location.hash.includes('logout=')) {
            let hashContent = window.location.hash.substring(1);
            if (hashContent.startsWith('/')) hashContent = hashContent.substring(1);
            const hashParams = new URLSearchParams(hashContent);
            const tokenFromHash = hashParams.get('auth_token');
            const logoutFlag = hashParams.get('logout');
            window.history.replaceState(null, '', window.location.pathname + window.location.search + '#/');
            if (logoutFlag === 'true') {
                (0, _browserJs.clearAuthFromLocalStorage)();
                localStorage.removeItem('vega_editor_auth_token');
                this.props.receiveCurrentUser(false, '', '', '');
                return;
            }
            if (tokenFromHash) {
                localStorage.setItem('vega_editor_auth_token', tokenFromHash);
                const tokenData = await this.verifyTokenLocally(tokenFromHash);
                if (tokenData && tokenData.isAuthenticated) {
                    (0, _browserJs.saveAuthToLocalStorage)({
                        isAuthenticated: tokenData.isAuthenticated,
                        handle: tokenData.handle,
                        name: tokenData.name,
                        profilePicUrl: tokenData.profilePicUrl,
                        authToken: tokenData.authToken
                    });
                    this.props.receiveCurrentUser(tokenData.isAuthenticated, tokenData.handle, tokenData.name, tokenData.profilePicUrl);
                    return;
                }
            }
        }
        const localAuthData = (0, _browserJs.getAuthFromLocalStorage)();
        const auth_token = localStorage.getItem('vega_editor_auth_token');
        if (localAuthData && localAuthData.isAuthenticated && localAuthData.authToken) {
            console.log('Using localStorage auth data:', localAuthData.handle);
            try {
                const isValid = await this.verifyTokenLocally(localAuthData.authToken);
                if (isValid) {
                    this.props.receiveCurrentUser(localAuthData.isAuthenticated, localAuthData.handle, localAuthData.name, localAuthData.profilePicUrl);
                    return;
                }
            } catch (error) {
                console.error('Error verifying stored token:', error);
            }
        }
        if (auth_token) try {
            const headers = {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0',
                'X-Auth-Token': auth_token
            };
            const response = await fetch(`${(0, _indexJs.BACKEND_URL)}auth/github/check`, {
                cache: 'no-store',
                headers
            });
            const data = await response.json();
            const { isAuthenticated, handle, name, profilePicUrl, authToken } = data;
            if (isAuthenticated && authToken) {
                console.log('Saving new auth token to localStorage');
                (0, _browserJs.saveAuthToLocalStorage)({
                    isAuthenticated,
                    handle,
                    name,
                    profilePicUrl,
                    authToken
                });
                this.props.receiveCurrentUser(isAuthenticated, handle, name, profilePicUrl);
                return;
            }
        } catch (error) {
            console.error('Token verification failed:', error);
        }
        (0, _browserJs.clearAuthFromLocalStorage)();
        localStorage.removeItem('vega_editor_auth_token');
        this.props.receiveCurrentUser(false, '', '', '');
        window.addEventListener('message', async (e)=>{
            if (e.data && e.data.type === 'auth') {
                if (e.data.token) {
                    console.log('Received auth token from popup:', e.data.token.substring(0, 10) + '...');
                    localStorage.setItem('vega_editor_auth_token', e.data.token);
                    try {
                        const tokenData = await this.verifyTokenLocally(e.data.token);
                        if (tokenData && tokenData.isAuthenticated) {
                            (0, _browserJs.saveAuthToLocalStorage)({
                                isAuthenticated: tokenData.isAuthenticated,
                                handle: tokenData.handle,
                                name: tokenData.name,
                                profilePicUrl: tokenData.profilePicUrl,
                                authToken: tokenData.authToken
                            });
                            this.props.receiveCurrentUser(tokenData.isAuthenticated, tokenData.handle, tokenData.name, tokenData.profilePicUrl);
                            return;
                        }
                    } catch (error) {
                        console.error('Error verifying token locally:', error);
                    }
                }
                try {
                    const headers = {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        Pragma: 'no-cache',
                        Expires: '0'
                    };
                    const token = e.data.token || localStorage.getItem('vega_editor_auth_token');
                    if (token) headers['X-Auth-Token'] = token;
                    const response = await fetch(`${(0, _indexJs.BACKEND_URL)}auth/github/check`, {
                        headers,
                        cache: 'no-store'
                    });
                    const data = await response.json();
                    const { isAuthenticated, handle, name, profilePicUrl, authToken } = data;
                    if (isAuthenticated) (0, _browserJs.saveAuthToLocalStorage)({
                        isAuthenticated,
                        handle,
                        name,
                        profilePicUrl,
                        authToken
                    });
                    this.props.receiveCurrentUser(isAuthenticated, handle, name, profilePicUrl);
                } catch (error) {
                    console.error('Authentication check failed:', error);
                    this.props.receiveCurrentUser(false, '', '', '');
                }
            }
        });
    }
    onSelectVega(name) {
        this.props.history.push(`/examples/vega/${name}`);
    }
    onSelectNewVega() {
        this.props.history.push('/custom/vega');
    }
    onSelectVegaLite(name) {
        this.props.history.push(`/examples/vega-lite/${name}`);
    }
    onSelectNewVegaLite() {
        this.props.history.push('/custom/vega-lite');
    }
    onSwitchMode(option) {
        if (option.value === (0, _indexJs.Mode).Vega) {
            this.props.updateVegaSpec((0, _jsonStringifyPrettyCompactDefault.default)(this.props.vegaSpec));
            this.onSelectNewVega();
        } else this.onSelectNewVegaLite();
        this.props.clearConfig();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.mode !== prevState.mode) return {
            showVega: nextProps.mode === (0, _indexJs.Mode).Vega,
            mode: nextProps.mode
        };
        else return null;
    }
    handleHelpModalToggle(Toggleevent, openPortal, closePortal, isOpen) {
        window.addEventListener('keydown', (event1)=>{
            if (event1.keyCode === (0, _indexJs.KEYCODES).SINGLE_QUOTE && event1.metaKey && !event1.shiftKey || // Handle key press in Mac
            event1.keyCode === (0, _indexJs.KEYCODES).SLASH && event1.ctrlKey && event1.shiftKey // Handle Key press in PC
            ) {
                if (!isOpen) openPortal();
                else closePortal();
            }
            this.listenerAttached = true;
        });
    }
    handleSettingsClick() {
        this.props.setSettingsState(!this.props.settings);
    }
    openCommandPalette() {
        this.props.editorRef.focus();
        this.props.editorRef.trigger('', 'editor.action.quickCommand', '');
    }
    async verifyTokenLocally(token) {
        try {
            // TODO: verify the token signature
            const decoded = atob(token);
            const tokenData = JSON.parse(decoded);
            if (tokenData && tokenData.data) {
                const userData = JSON.parse(tokenData.data);
                return {
                    isAuthenticated: true,
                    handle: userData.login,
                    name: userData.name,
                    profilePicUrl: userData.avatar_url,
                    authToken: token
                };
            }
            return null;
        } catch (error) {
            console.error('Error verifying token locally:', error);
            return null;
        }
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', ()=>{
            return;
        });
        this.listenerAttached = false;
    }
    signIn() {
        const popup = window.open(`${(0, _indexJs.BACKEND_URL)}auth/github`, 'github-login', 'width=600,height=600,resizable=yes');
        if (popup) popup.focus();
        else window.location.href = `${0, _indexJs.BACKEND_URL}auth/github`;
    }
    signOut() {
        (0, _browserJs.clearAuthFromLocalStorage)();
        const token = localStorage.getItem('vega_editor_auth_token');
        if (token) {
            // Creating hidden iframe (to handle CORS issues)
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = `${0, _indexJs.BACKEND_URL}auth/github/logout?token=${encodeURIComponent(token)}`;
            document.body.appendChild(iframe);
            iframe.onload = iframe.onerror = ()=>{
                setTimeout(()=>{
                    document.body.removeChild(iframe);
                }, 500);
            };
            localStorage.removeItem('vega_editor_auth_token');
        }
        const popup = window.open(`${(0, _indexJs.BACKEND_URL)}auth/github/logout`, 'github-logout', 'width=600,height=600,resizable=yes');
        if (popup) popup.focus();
        else // If popup is blocked or fails, redirect directly
        window.location.href = `${0, _indexJs.BACKEND_URL}auth/github/logout`;
        // Also clear local state
        this.props.receiveCurrentUser(false, '', '', '');
    }
    render() {
        const modeOptions = this.props.mode === (0, _indexJs.Mode).Vega ? [
            {
                value: (0, _indexJs.Mode).VegaLite,
                label: (0, _constsJs.NAMES)[(0, _indexJs.Mode).VegaLite]
            }
        ] : [
            {
                value: (0, _indexJs.Mode).Vega,
                label: (0, _constsJs.NAMES)[(0, _indexJs.Mode).Vega]
            }
        ];
        const value = {
            label: `${(0, _constsJs.NAMES)[this.props.mode]}`,
            value: this.props.mode
        };
        const modeSwitcher = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
            className: "mode-switcher-wrapper",
            classNamePrefix: "mode-switcher",
            value: value,
            options: modeOptions,
            isClearable: false,
            isSearchable: false,
            onChange: this.onSwitchMode.bind(this)
        });
        const examplesButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Grid), {
                    className: "header-icon"
                }),
                'Examples'
            ]
        });
        const gistButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.GitHub), {
                    className: "header-icon"
                }),
                'Gist'
            ]
        });
        const settingsButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button settings-button",
            style: {
                backgroundColor: this.props.settings ? 'rgba(0, 0, 0, 0.08)' : ''
            },
            onClick: ()=>this.props.setSettingsState(!this.props.settings),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Settings), {
                    className: "header-icon"
                }),
                'Settings'
            ]
        });
        const exportButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.ExternalLink), {
                    className: "header-icon"
                }),
                'Export'
            ]
        });
        const shareButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Share2), {
                    className: "header-icon"
                }),
                'Share'
            ]
        });
        const HelpButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button help",
            onClick: ()=>this.setState((current)=>({
                        ...current
                    })),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.HelpCircle), {
                    className: "header-icon"
                }),
                'Help'
            ]
        });
        const optionsButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button",
            onClick: this.openCommandPalette.bind(this),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Terminal), {
                    className: "header-icon"
                }),
                'Commands'
            ]
        });
        const authButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "auth-button-container",
            children: this.props.isAuthenticated ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "profile-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "profile-img",
                            src: this.props.profilePicUrl
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "arrow-down"
                        }),
                        this.state.open && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "profile-menu",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "welcome",
                                    children: "Logged in as"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "whoami",
                                    children: this.props.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        className: "sign-out",
                                        type: "submit",
                                        value: "Sign out",
                                        onClick: this.signOut.bind(this)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "sign-in",
                    type: "submit",
                    onClick: this.signIn.bind(this),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "sign-in-text",
                            "aria-label": "Sign in with GitHub",
                            children: "Sign in with"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.GitHub), {})
                    ]
                })
            })
        });
        const runOptions = this.props.manualParse ? [
            {
                label: 'Auto'
            }
        ] : [
            {
                label: 'Manual'
            }
        ];
        const autoRunToggle = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
            className: "auto-run-wrapper",
            classNamePrefix: "auto-run",
            value: {
                label: ''
            },
            options: runOptions,
            isClearable: false,
            isSearchable: false,
            onChange: this.props.toggleAutoParse
        });
        const runButton = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "header-button",
            id: "run-button",
            onClick: ()=>{
                this.props.parseSpec(true);
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Play), {
                    className: "header-icon"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "run-button",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "parse-label",
                            children: "Run"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "parse-mode",
                            children: this.props.manualParse ? 'Manual' : 'Auto'
                        })
                    ]
                })
            ]
        });
        const splitClass = 'split-button' + (this.props.manualParse ? '' : ' auto-run');
        const vega = (closePortal)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "vega",
                children: Object.keys((0, _specsJs.VEGA_SPECS)).map((specType, i)=>{
                    const specs = (0, _specsJs.VEGA_SPECS)[specType];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "item-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "spec-type",
                                children: specType
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "items",
                                onClick: closePortal,
                                children: specs.map((spec, j)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        onClick: ()=>{
                                            this.onSelectVega(spec.name);
                                            closePortal();
                                        },
                                        className: "item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                style: {
                                                    backgroundImage: `url(images/examples/vg/${spec.name}.vg.png)`
                                                },
                                                className: "img"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "name",
                                                children: formatExampleName(spec.name)
                                            })
                                        ]
                                    }, j))
                            })
                        ]
                    }, i);
                })
            });
        const vegalite = (closePortal)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "vega-Lite",
                children: Object.keys((0, _specsJs.VEGA_LITE_SPECS)).map((specGroup, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: specGroup
                            }),
                            Object.keys((0, _specsJs.VEGA_LITE_SPECS)[specGroup]).map((specType, j)=>{
                                const specs = (0, _specsJs.VEGA_LITE_SPECS)[specGroup][specType];
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "item-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "spec-type",
                                            children: specType
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "items",
                                            children: specs.map((spec, k)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    onClick: ()=>{
                                                        this.onSelectVegaLite(spec.name);
                                                        closePortal();
                                                    },
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            style: {
                                                                backgroundImage: `url(images/examples/vl/${spec.name}.vl.png)`
                                                            },
                                                            className: "img"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "name",
                                                            children: spec.title
                                                        })
                                                    ]
                                                }, k))
                                        })
                                    ]
                                }, j);
                            })
                        ]
                    }, i))
            });
        const gist = (closePortal)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault1.default), {
                closePortal: ()=>closePortal()
            });
        const exportContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {});
        const shareContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault3.default), {});
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "app-header",
            role: "banner",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "left-section",
                    children: [
                        modeSwitcher,
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            ref: "splitButton",
                            className: splitClass,
                            children: [
                                runButton,
                                autoRunToggle
                            ]
                        }),
                        optionsButton,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPortal.PortalWithState), {
                            closeOnEsc: true,
                            children: ({ openPortal, closePortal, portal })=>[
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        onClick: openPortal,
                                        children: exportButton
                                    }, "0"),
                                    portal(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-background",
                                        onClick: closePortal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "modal",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "close-button",
                                                        onClick: closePortal,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.X), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modal-body",
                                                    children: exportContent
                                                })
                                            ]
                                        })
                                    }))
                                ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPortal.PortalWithState), {
                            closeOnEsc: true,
                            children: ({ openPortal, closePortal, portal })=>[
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        onClick: openPortal,
                                        children: shareButton
                                    }, "0"),
                                    portal(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-background",
                                        onClick: closePortal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "modal",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "close-button",
                                                        onClick: closePortal,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.X), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modal-body",
                                                    children: shareContent
                                                })
                                            ]
                                        })
                                    }))
                                ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPortal.PortalWithState), {
                            closeOnEsc: true,
                            children: ({ openPortal, closePortal, portal })=>[
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        onClick: openPortal,
                                        children: gistButton
                                    }, "0"),
                                    portal(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-background",
                                        onClick: closePortal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "modal",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "close-button",
                                                        onClick: closePortal,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.X), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modal-body",
                                                    children: gist(closePortal)
                                                })
                                            ]
                                        })
                                    }))
                                ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPortal.PortalWithState), {
                            closeOnEsc: true,
                            defaultOpen: this.props.showExample,
                            onOpen: ()=>{
                                const node = (0, _reactDomDefault.default).findDOMNode(this.examplePortal.current);
                                node.scrollTop = this.props.lastPosition;
                                node.addEventListener('scroll', ()=>{
                                    this.setState({
                                        scrollPosition: node.scrollTop
                                    });
                                });
                            },
                            onClose: ()=>{
                                this.props.setScrollPosition(this.state.scrollPosition);
                            },
                            children: ({ openPortal, closePortal, portal })=>[
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        onClick: openPortal,
                                        children: examplesButton
                                    }, "0"),
                                    portal(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-background",
                                        onClick: closePortal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "modal",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "button-groups",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: this.state.showVega ? 'selected' : '',
                                                                    onClick: ()=>{
                                                                        this.setState({
                                                                            showVega: true
                                                                        });
                                                                        const node = (0, _reactDomDefault.default).findDOMNode(this.examplePortal.current);
                                                                        node.scrollTop = 0;
                                                                    },
                                                                    children: "Vega"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: this.state.showVega ? '' : 'selected',
                                                                    onClick: ()=>{
                                                                        this.setState({
                                                                            showVega: false
                                                                        });
                                                                        const node = (0, _reactDomDefault.default).findDOMNode(this.examplePortal.current);
                                                                        node.scrollTop = 0;
                                                                    },
                                                                    children: "Vega-Lite"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "close-button",
                                                            onClick: closePortal,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.X), {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modal-body",
                                                    ref: this.examplePortal,
                                                    children: this.state.showVega ? vega(closePortal) : vegalite(closePortal)
                                                })
                                            ]
                                        })
                                    }))
                                ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "right-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPortal.PortalWithState), {
                            closeOnEsc: true,
                            children: ({ openPortal, closePortal, isOpen, portal })=>{
                                if (!this.listenerAttached) this.handleHelpModalToggle(event, openPortal, closePortal, isOpen);
                                return [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        onClick: openPortal,
                                        children: HelpButton
                                    }, "0"),
                                    portal(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "modal-background",
                                        onClick: closePortal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "modal",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "close-button",
                                                        onClick: closePortal,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.X), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modal-body",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault2.default), {})
                                                })
                                            ]
                                        })
                                    }))
                                ];
                            }
                        }),
                        settingsButton,
                        authButton
                    ]
                })
            ]
        });
    }
}
exports.default = Header;

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","react":"bmhQu","react-dom":"82aNB","react-feather":"40SDF","react-portal":"18Y94","react-select":"9WAWN","../../constants/index.js":"4z2sr","../../constants/consts.js":"1PtM7","../../constants/specs.js":"gKJCt","../../utils/browser.js":"77ZrV","./export-modal/index.js":"9VdfZ","./gist-modal/index.js":"8ED1L","./help-modal/index.js":"2eUrg","./index.css":"iGclQ","./share-modal/index.js":"5hljF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"40SDF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Activity", ()=>(0, _activityDefault.default));
parcelHelpers.export(exports, "Airplay", ()=>(0, _airplayDefault.default));
parcelHelpers.export(exports, "AlertCircle", ()=>(0, _alertCircleDefault.default));
parcelHelpers.export(exports, "AlertOctagon", ()=>(0, _alertOctagonDefault.default));
parcelHelpers.export(exports, "AlertTriangle", ()=>(0, _alertTriangleDefault.default));
parcelHelpers.export(exports, "AlignCenter", ()=>(0, _alignCenterDefault.default));
parcelHelpers.export(exports, "AlignJustify", ()=>(0, _alignJustifyDefault.default));
parcelHelpers.export(exports, "AlignLeft", ()=>(0, _alignLeftDefault.default));
parcelHelpers.export(exports, "AlignRight", ()=>(0, _alignRightDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "Aperture", ()=>(0, _apertureDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveDefault.default));
parcelHelpers.export(exports, "ArrowDownCircle", ()=>(0, _arrowDownCircleDefault.default));
parcelHelpers.export(exports, "ArrowDownLeft", ()=>(0, _arrowDownLeftDefault.default));
parcelHelpers.export(exports, "ArrowDownRight", ()=>(0, _arrowDownRightDefault.default));
parcelHelpers.export(exports, "ArrowDown", ()=>(0, _arrowDownDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircle", ()=>(0, _arrowLeftCircleDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftDefault.default));
parcelHelpers.export(exports, "ArrowRightCircle", ()=>(0, _arrowRightCircleDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightDefault.default));
parcelHelpers.export(exports, "ArrowUpCircle", ()=>(0, _arrowUpCircleDefault.default));
parcelHelpers.export(exports, "ArrowUpLeft", ()=>(0, _arrowUpLeftDefault.default));
parcelHelpers.export(exports, "ArrowUpRight", ()=>(0, _arrowUpRightDefault.default));
parcelHelpers.export(exports, "ArrowUp", ()=>(0, _arrowUpDefault.default));
parcelHelpers.export(exports, "AtSign", ()=>(0, _atSignDefault.default));
parcelHelpers.export(exports, "Award", ()=>(0, _awardDefault.default));
parcelHelpers.export(exports, "BarChart2", ()=>(0, _barChart2Default.default));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChartDefault.default));
parcelHelpers.export(exports, "BatteryCharging", ()=>(0, _batteryChargingDefault.default));
parcelHelpers.export(exports, "Battery", ()=>(0, _batteryDefault.default));
parcelHelpers.export(exports, "BellOff", ()=>(0, _bellOffDefault.default));
parcelHelpers.export(exports, "Bell", ()=>(0, _bellDefault.default));
parcelHelpers.export(exports, "Bluetooth", ()=>(0, _bluetoothDefault.default));
parcelHelpers.export(exports, "Bold", ()=>(0, _boldDefault.default));
parcelHelpers.export(exports, "BookOpen", ()=>(0, _bookOpenDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Briefcase", ()=>(0, _briefcaseDefault.default));
parcelHelpers.export(exports, "Calendar", ()=>(0, _calendarDefault.default));
parcelHelpers.export(exports, "CameraOff", ()=>(0, _cameraOffDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraDefault.default));
parcelHelpers.export(exports, "Cast", ()=>(0, _castDefault.default));
parcelHelpers.export(exports, "CheckCircle", ()=>(0, _checkCircleDefault.default));
parcelHelpers.export(exports, "CheckSquare", ()=>(0, _checkSquareDefault.default));
parcelHelpers.export(exports, "Check", ()=>(0, _checkDefault.default));
parcelHelpers.export(exports, "ChevronDown", ()=>(0, _chevronDownDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightDefault.default));
parcelHelpers.export(exports, "ChevronUp", ()=>(0, _chevronUpDefault.default));
parcelHelpers.export(exports, "ChevronsDown", ()=>(0, _chevronsDownDefault.default));
parcelHelpers.export(exports, "ChevronsLeft", ()=>(0, _chevronsLeftDefault.default));
parcelHelpers.export(exports, "ChevronsRight", ()=>(0, _chevronsRightDefault.default));
parcelHelpers.export(exports, "ChevronsUp", ()=>(0, _chevronsUpDefault.default));
parcelHelpers.export(exports, "Chrome", ()=>(0, _chromeDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "Clipboard", ()=>(0, _clipboardDefault.default));
parcelHelpers.export(exports, "Clock", ()=>(0, _clockDefault.default));
parcelHelpers.export(exports, "CloudDrizzle", ()=>(0, _cloudDrizzleDefault.default));
parcelHelpers.export(exports, "CloudLightning", ()=>(0, _cloudLightningDefault.default));
parcelHelpers.export(exports, "CloudOff", ()=>(0, _cloudOffDefault.default));
parcelHelpers.export(exports, "CloudRain", ()=>(0, _cloudRainDefault.default));
parcelHelpers.export(exports, "CloudSnow", ()=>(0, _cloudSnowDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeDefault.default));
parcelHelpers.export(exports, "Codepen", ()=>(0, _codepenDefault.default));
parcelHelpers.export(exports, "Codesandbox", ()=>(0, _codesandboxDefault.default));
parcelHelpers.export(exports, "Coffee", ()=>(0, _coffeeDefault.default));
parcelHelpers.export(exports, "Columns", ()=>(0, _columnsDefault.default));
parcelHelpers.export(exports, "Command", ()=>(0, _commandDefault.default));
parcelHelpers.export(exports, "Compass", ()=>(0, _compassDefault.default));
parcelHelpers.export(exports, "Copy", ()=>(0, _copyDefault.default));
parcelHelpers.export(exports, "CornerDownLeft", ()=>(0, _cornerDownLeftDefault.default));
parcelHelpers.export(exports, "CornerDownRight", ()=>(0, _cornerDownRightDefault.default));
parcelHelpers.export(exports, "CornerLeftDown", ()=>(0, _cornerLeftDownDefault.default));
parcelHelpers.export(exports, "CornerLeftUp", ()=>(0, _cornerLeftUpDefault.default));
parcelHelpers.export(exports, "CornerRightDown", ()=>(0, _cornerRightDownDefault.default));
parcelHelpers.export(exports, "CornerRightUp", ()=>(0, _cornerRightUpDefault.default));
parcelHelpers.export(exports, "CornerUpLeft", ()=>(0, _cornerUpLeftDefault.default));
parcelHelpers.export(exports, "CornerUpRight", ()=>(0, _cornerUpRightDefault.default));
parcelHelpers.export(exports, "Cpu", ()=>(0, _cpuDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropDefault.default));
parcelHelpers.export(exports, "Crosshair", ()=>(0, _crosshairDefault.default));
parcelHelpers.export(exports, "Database", ()=>(0, _databaseDefault.default));
parcelHelpers.export(exports, "Delete", ()=>(0, _deleteDefault.default));
parcelHelpers.export(exports, "Disc", ()=>(0, _discDefault.default));
parcelHelpers.export(exports, "DivideCircle", ()=>(0, _divideCircleDefault.default));
parcelHelpers.export(exports, "DivideSquare", ()=>(0, _divideSquareDefault.default));
parcelHelpers.export(exports, "Divide", ()=>(0, _divideDefault.default));
parcelHelpers.export(exports, "DollarSign", ()=>(0, _dollarSignDefault.default));
parcelHelpers.export(exports, "DownloadCloud", ()=>(0, _downloadCloudDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadDefault.default));
parcelHelpers.export(exports, "Dribbble", ()=>(0, _dribbbleDefault.default));
parcelHelpers.export(exports, "Droplet", ()=>(0, _dropletDefault.default));
parcelHelpers.export(exports, "Edit2", ()=>(0, _edit2Default.default));
parcelHelpers.export(exports, "Edit3", ()=>(0, _edit3Default.default));
parcelHelpers.export(exports, "Edit", ()=>(0, _editDefault.default));
parcelHelpers.export(exports, "ExternalLink", ()=>(0, _externalLinkDefault.default));
parcelHelpers.export(exports, "EyeOff", ()=>(0, _eyeOffDefault.default));
parcelHelpers.export(exports, "Eye", ()=>(0, _eyeDefault.default));
parcelHelpers.export(exports, "Facebook", ()=>(0, _facebookDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardDefault.default));
parcelHelpers.export(exports, "Feather", ()=>(0, _featherDefault.default));
parcelHelpers.export(exports, "Figma", ()=>(0, _figmaDefault.default));
parcelHelpers.export(exports, "FileMinus", ()=>(0, _fileMinusDefault.default));
parcelHelpers.export(exports, "FilePlus", ()=>(0, _filePlusDefault.default));
parcelHelpers.export(exports, "FileText", ()=>(0, _fileTextDefault.default));
parcelHelpers.export(exports, "File", ()=>(0, _fileDefault.default));
parcelHelpers.export(exports, "Film", ()=>(0, _filmDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _filterDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "FolderMinus", ()=>(0, _folderMinusDefault.default));
parcelHelpers.export(exports, "FolderPlus", ()=>(0, _folderPlusDefault.default));
parcelHelpers.export(exports, "Folder", ()=>(0, _folderDefault.default));
parcelHelpers.export(exports, "Framer", ()=>(0, _framerDefault.default));
parcelHelpers.export(exports, "Frown", ()=>(0, _frownDefault.default));
parcelHelpers.export(exports, "Gift", ()=>(0, _giftDefault.default));
parcelHelpers.export(exports, "GitBranch", ()=>(0, _gitBranchDefault.default));
parcelHelpers.export(exports, "GitCommit", ()=>(0, _gitCommitDefault.default));
parcelHelpers.export(exports, "GitMerge", ()=>(0, _gitMergeDefault.default));
parcelHelpers.export(exports, "GitPullRequest", ()=>(0, _gitPullRequestDefault.default));
parcelHelpers.export(exports, "GitHub", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "Gitlab", ()=>(0, _gitlabDefault.default));
parcelHelpers.export(exports, "Globe", ()=>(0, _globeDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "HardDrive", ()=>(0, _hardDriveDefault.default));
parcelHelpers.export(exports, "Hash", ()=>(0, _hashDefault.default));
parcelHelpers.export(exports, "Headphones", ()=>(0, _headphonesDefault.default));
parcelHelpers.export(exports, "Heart", ()=>(0, _heartDefault.default));
parcelHelpers.export(exports, "HelpCircle", ()=>(0, _helpCircleDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonDefault.default));
parcelHelpers.export(exports, "Home", ()=>(0, _homeDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxDefault.default));
parcelHelpers.export(exports, "Info", ()=>(0, _infoDefault.default));
parcelHelpers.export(exports, "Instagram", ()=>(0, _instagramDefault.default));
parcelHelpers.export(exports, "Italic", ()=>(0, _italicDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersDefault.default));
parcelHelpers.export(exports, "Layout", ()=>(0, _layoutDefault.default));
parcelHelpers.export(exports, "LifeBuoy", ()=>(0, _lifeBuoyDefault.default));
parcelHelpers.export(exports, "Link2", ()=>(0, _link2Default.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "Linkedin", ()=>(0, _linkedinDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "Loader", ()=>(0, _loaderDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockDefault.default));
parcelHelpers.export(exports, "LogIn", ()=>(0, _logInDefault.default));
parcelHelpers.export(exports, "LogOut", ()=>(0, _logOutDefault.default));
parcelHelpers.export(exports, "Mail", ()=>(0, _mailDefault.default));
parcelHelpers.export(exports, "MapPin", ()=>(0, _mapPinDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "Maximize2", ()=>(0, _maximize2Default.default));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximizeDefault.default));
parcelHelpers.export(exports, "Meh", ()=>(0, _mehDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MessageCircle", ()=>(0, _messageCircleDefault.default));
parcelHelpers.export(exports, "MessageSquare", ()=>(0, _messageSquareDefault.default));
parcelHelpers.export(exports, "MicOff", ()=>(0, _micOffDefault.default));
parcelHelpers.export(exports, "Mic", ()=>(0, _micDefault.default));
parcelHelpers.export(exports, "Minimize2", ()=>(0, _minimize2Default.default));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimizeDefault.default));
parcelHelpers.export(exports, "MinusCircle", ()=>(0, _minusCircleDefault.default));
parcelHelpers.export(exports, "MinusSquare", ()=>(0, _minusSquareDefault.default));
parcelHelpers.export(exports, "Minus", ()=>(0, _minusDefault.default));
parcelHelpers.export(exports, "Monitor", ()=>(0, _monitorDefault.default));
parcelHelpers.export(exports, "Moon", ()=>(0, _moonDefault.default));
parcelHelpers.export(exports, "MoreHorizontal", ()=>(0, _moreHorizontalDefault.default));
parcelHelpers.export(exports, "MoreVertical", ()=>(0, _moreVerticalDefault.default));
parcelHelpers.export(exports, "MousePointer", ()=>(0, _mousePointerDefault.default));
parcelHelpers.export(exports, "Move", ()=>(0, _moveDefault.default));
parcelHelpers.export(exports, "Music", ()=>(0, _musicDefault.default));
parcelHelpers.export(exports, "Navigation2", ()=>(0, _navigation2Default.default));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationDefault.default));
parcelHelpers.export(exports, "Octagon", ()=>(0, _octagonDefault.default));
parcelHelpers.export(exports, "Package", ()=>(0, _packageDefault.default));
parcelHelpers.export(exports, "Paperclip", ()=>(0, _paperclipDefault.default));
parcelHelpers.export(exports, "PauseCircle", ()=>(0, _pauseCircleDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseDefault.default));
parcelHelpers.export(exports, "PenTool", ()=>(0, _penToolDefault.default));
parcelHelpers.export(exports, "Percent", ()=>(0, _percentDefault.default));
parcelHelpers.export(exports, "PhoneCall", ()=>(0, _phoneCallDefault.default));
parcelHelpers.export(exports, "PhoneForwarded", ()=>(0, _phoneForwardedDefault.default));
parcelHelpers.export(exports, "PhoneIncoming", ()=>(0, _phoneIncomingDefault.default));
parcelHelpers.export(exports, "PhoneMissed", ()=>(0, _phoneMissedDefault.default));
parcelHelpers.export(exports, "PhoneOff", ()=>(0, _phoneOffDefault.default));
parcelHelpers.export(exports, "PhoneOutgoing", ()=>(0, _phoneOutgoingDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChartDefault.default));
parcelHelpers.export(exports, "PlayCircle", ()=>(0, _playCircleDefault.default));
parcelHelpers.export(exports, "Play", ()=>(0, _playDefault.default));
parcelHelpers.export(exports, "PlusCircle", ()=>(0, _plusCircleDefault.default));
parcelHelpers.export(exports, "PlusSquare", ()=>(0, _plusSquareDefault.default));
parcelHelpers.export(exports, "Plus", ()=>(0, _plusDefault.default));
parcelHelpers.export(exports, "Pocket", ()=>(0, _pocketDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerDefault.default));
parcelHelpers.export(exports, "Printer", ()=>(0, _printerDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioDefault.default));
parcelHelpers.export(exports, "RefreshCcw", ()=>(0, _refreshCcwDefault.default));
parcelHelpers.export(exports, "RefreshCw", ()=>(0, _refreshCwDefault.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatDefault.default));
parcelHelpers.export(exports, "Rewind", ()=>(0, _rewindDefault.default));
parcelHelpers.export(exports, "RotateCcw", ()=>(0, _rotateCcwDefault.default));
parcelHelpers.export(exports, "RotateCw", ()=>(0, _rotateCwDefault.default));
parcelHelpers.export(exports, "Rss", ()=>(0, _rssDefault.default));
parcelHelpers.export(exports, "Save", ()=>(0, _saveDefault.default));
parcelHelpers.export(exports, "Scissors", ()=>(0, _scissorsDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchDefault.default));
parcelHelpers.export(exports, "Send", ()=>(0, _sendDefault.default));
parcelHelpers.export(exports, "Server", ()=>(0, _serverDefault.default));
parcelHelpers.export(exports, "Settings", ()=>(0, _settingsDefault.default));
parcelHelpers.export(exports, "Share2", ()=>(0, _share2Default.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareDefault.default));
parcelHelpers.export(exports, "ShieldOff", ()=>(0, _shieldOffDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldDefault.default));
parcelHelpers.export(exports, "ShoppingBag", ()=>(0, _shoppingBagDefault.default));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCartDefault.default));
parcelHelpers.export(exports, "Shuffle", ()=>(0, _shuffleDefault.default));
parcelHelpers.export(exports, "Sidebar", ()=>(0, _sidebarDefault.default));
parcelHelpers.export(exports, "SkipBack", ()=>(0, _skipBackDefault.default));
parcelHelpers.export(exports, "SkipForward", ()=>(0, _skipForwardDefault.default));
parcelHelpers.export(exports, "Slack", ()=>(0, _slackDefault.default));
parcelHelpers.export(exports, "Slash", ()=>(0, _slashDefault.default));
parcelHelpers.export(exports, "Sliders", ()=>(0, _slidersDefault.default));
parcelHelpers.export(exports, "Smartphone", ()=>(0, _smartphoneDefault.default));
parcelHelpers.export(exports, "Smile", ()=>(0, _smileDefault.default));
parcelHelpers.export(exports, "Speaker", ()=>(0, _speakerDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starDefault.default));
parcelHelpers.export(exports, "StopCircle", ()=>(0, _stopCircleDefault.default));
parcelHelpers.export(exports, "Sun", ()=>(0, _sunDefault.default));
parcelHelpers.export(exports, "Sunrise", ()=>(0, _sunriseDefault.default));
parcelHelpers.export(exports, "Sunset", ()=>(0, _sunsetDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "Tablet", ()=>(0, _tabletDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagDefault.default));
parcelHelpers.export(exports, "Target", ()=>(0, _targetDefault.default));
parcelHelpers.export(exports, "Terminal", ()=>(0, _terminalDefault.default));
parcelHelpers.export(exports, "Thermometer", ()=>(0, _thermometerDefault.default));
parcelHelpers.export(exports, "ThumbsDown", ()=>(0, _thumbsDownDefault.default));
parcelHelpers.export(exports, "ThumbsUp", ()=>(0, _thumbsUpDefault.default));
parcelHelpers.export(exports, "ToggleLeft", ()=>(0, _toggleLeftDefault.default));
parcelHelpers.export(exports, "ToggleRight", ()=>(0, _toggleRightDefault.default));
parcelHelpers.export(exports, "Tool", ()=>(0, _toolDefault.default));
parcelHelpers.export(exports, "Trash2", ()=>(0, _trash2Default.default));
parcelHelpers.export(exports, "Trash", ()=>(0, _trashDefault.default));
parcelHelpers.export(exports, "Trello", ()=>(0, _trelloDefault.default));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDownDefault.default));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUpDefault.default));
parcelHelpers.export(exports, "Triangle", ()=>(0, _triangleDefault.default));
parcelHelpers.export(exports, "Truck", ()=>(0, _truckDefault.default));
parcelHelpers.export(exports, "Tv", ()=>(0, _tvDefault.default));
parcelHelpers.export(exports, "Twitch", ()=>(0, _twitchDefault.default));
parcelHelpers.export(exports, "Twitter", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "Type", ()=>(0, _typeDefault.default));
parcelHelpers.export(exports, "Umbrella", ()=>(0, _umbrellaDefault.default));
parcelHelpers.export(exports, "Underline", ()=>(0, _underlineDefault.default));
parcelHelpers.export(exports, "Unlock", ()=>(0, _unlockDefault.default));
parcelHelpers.export(exports, "UploadCloud", ()=>(0, _uploadCloudDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadDefault.default));
parcelHelpers.export(exports, "UserCheck", ()=>(0, _userCheckDefault.default));
parcelHelpers.export(exports, "UserMinus", ()=>(0, _userMinusDefault.default));
parcelHelpers.export(exports, "UserPlus", ()=>(0, _userPlusDefault.default));
parcelHelpers.export(exports, "UserX", ()=>(0, _userXDefault.default));
parcelHelpers.export(exports, "User", ()=>(0, _userDefault.default));
parcelHelpers.export(exports, "Users", ()=>(0, _usersDefault.default));
parcelHelpers.export(exports, "VideoOff", ()=>(0, _videoOffDefault.default));
parcelHelpers.export(exports, "Video", ()=>(0, _videoDefault.default));
parcelHelpers.export(exports, "Voicemail", ()=>(0, _voicemailDefault.default));
parcelHelpers.export(exports, "Volume1", ()=>(0, _volume1Default.default));
parcelHelpers.export(exports, "Volume2", ()=>(0, _volume2Default.default));
parcelHelpers.export(exports, "VolumeX", ()=>(0, _volumeXDefault.default));
parcelHelpers.export(exports, "Volume", ()=>(0, _volumeDefault.default));
parcelHelpers.export(exports, "Watch", ()=>(0, _watchDefault.default));
parcelHelpers.export(exports, "WifiOff", ()=>(0, _wifiOffDefault.default));
parcelHelpers.export(exports, "Wifi", ()=>(0, _wifiDefault.default));
parcelHelpers.export(exports, "Wind", ()=>(0, _windDefault.default));
parcelHelpers.export(exports, "XCircle", ()=>(0, _xCircleDefault.default));
parcelHelpers.export(exports, "XOctagon", ()=>(0, _xOctagonDefault.default));
parcelHelpers.export(exports, "XSquare", ()=>(0, _xSquareDefault.default));
parcelHelpers.export(exports, "X", ()=>(0, _xDefault.default));
parcelHelpers.export(exports, "Youtube", ()=>(0, _youtubeDefault.default));
parcelHelpers.export(exports, "ZapOff", ()=>(0, _zapOffDefault.default));
parcelHelpers.export(exports, "Zap", ()=>(0, _zapDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutDefault.default));
var _activity = require("./icons/activity");
var _activityDefault = parcelHelpers.interopDefault(_activity);
var _airplay = require("./icons/airplay");
var _airplayDefault = parcelHelpers.interopDefault(_airplay);
var _alertCircle = require("./icons/alert-circle");
var _alertCircleDefault = parcelHelpers.interopDefault(_alertCircle);
var _alertOctagon = require("./icons/alert-octagon");
var _alertOctagonDefault = parcelHelpers.interopDefault(_alertOctagon);
var _alertTriangle = require("./icons/alert-triangle");
var _alertTriangleDefault = parcelHelpers.interopDefault(_alertTriangle);
var _alignCenter = require("./icons/align-center");
var _alignCenterDefault = parcelHelpers.interopDefault(_alignCenter);
var _alignJustify = require("./icons/align-justify");
var _alignJustifyDefault = parcelHelpers.interopDefault(_alignJustify);
var _alignLeft = require("./icons/align-left");
var _alignLeftDefault = parcelHelpers.interopDefault(_alignLeft);
var _alignRight = require("./icons/align-right");
var _alignRightDefault = parcelHelpers.interopDefault(_alignRight);
var _anchor = require("./icons/anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _aperture = require("./icons/aperture");
var _apertureDefault = parcelHelpers.interopDefault(_aperture);
var _archive = require("./icons/archive");
var _archiveDefault = parcelHelpers.interopDefault(_archive);
var _arrowDownCircle = require("./icons/arrow-down-circle");
var _arrowDownCircleDefault = parcelHelpers.interopDefault(_arrowDownCircle);
var _arrowDownLeft = require("./icons/arrow-down-left");
var _arrowDownLeftDefault = parcelHelpers.interopDefault(_arrowDownLeft);
var _arrowDownRight = require("./icons/arrow-down-right");
var _arrowDownRightDefault = parcelHelpers.interopDefault(_arrowDownRight);
var _arrowDown = require("./icons/arrow-down");
var _arrowDownDefault = parcelHelpers.interopDefault(_arrowDown);
var _arrowLeftCircle = require("./icons/arrow-left-circle");
var _arrowLeftCircleDefault = parcelHelpers.interopDefault(_arrowLeftCircle);
var _arrowLeft = require("./icons/arrow-left");
var _arrowLeftDefault = parcelHelpers.interopDefault(_arrowLeft);
var _arrowRightCircle = require("./icons/arrow-right-circle");
var _arrowRightCircleDefault = parcelHelpers.interopDefault(_arrowRightCircle);
var _arrowRight = require("./icons/arrow-right");
var _arrowRightDefault = parcelHelpers.interopDefault(_arrowRight);
var _arrowUpCircle = require("./icons/arrow-up-circle");
var _arrowUpCircleDefault = parcelHelpers.interopDefault(_arrowUpCircle);
var _arrowUpLeft = require("./icons/arrow-up-left");
var _arrowUpLeftDefault = parcelHelpers.interopDefault(_arrowUpLeft);
var _arrowUpRight = require("./icons/arrow-up-right");
var _arrowUpRightDefault = parcelHelpers.interopDefault(_arrowUpRight);
var _arrowUp = require("./icons/arrow-up");
var _arrowUpDefault = parcelHelpers.interopDefault(_arrowUp);
var _atSign = require("./icons/at-sign");
var _atSignDefault = parcelHelpers.interopDefault(_atSign);
var _award = require("./icons/award");
var _awardDefault = parcelHelpers.interopDefault(_award);
var _barChart2 = require("./icons/bar-chart-2");
var _barChart2Default = parcelHelpers.interopDefault(_barChart2);
var _barChart = require("./icons/bar-chart");
var _barChartDefault = parcelHelpers.interopDefault(_barChart);
var _batteryCharging = require("./icons/battery-charging");
var _batteryChargingDefault = parcelHelpers.interopDefault(_batteryCharging);
var _battery = require("./icons/battery");
var _batteryDefault = parcelHelpers.interopDefault(_battery);
var _bellOff = require("./icons/bell-off");
var _bellOffDefault = parcelHelpers.interopDefault(_bellOff);
var _bell = require("./icons/bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _bluetooth = require("./icons/bluetooth");
var _bluetoothDefault = parcelHelpers.interopDefault(_bluetooth);
var _bold = require("./icons/bold");
var _boldDefault = parcelHelpers.interopDefault(_bold);
var _bookOpen = require("./icons/book-open");
var _bookOpenDefault = parcelHelpers.interopDefault(_bookOpen);
var _book = require("./icons/book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _bookmark = require("./icons/bookmark");
var _bookmarkDefault = parcelHelpers.interopDefault(_bookmark);
var _box = require("./icons/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _briefcase = require("./icons/briefcase");
var _briefcaseDefault = parcelHelpers.interopDefault(_briefcase);
var _calendar = require("./icons/calendar");
var _calendarDefault = parcelHelpers.interopDefault(_calendar);
var _cameraOff = require("./icons/camera-off");
var _cameraOffDefault = parcelHelpers.interopDefault(_cameraOff);
var _camera = require("./icons/camera");
var _cameraDefault = parcelHelpers.interopDefault(_camera);
var _cast = require("./icons/cast");
var _castDefault = parcelHelpers.interopDefault(_cast);
var _checkCircle = require("./icons/check-circle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _checkSquare = require("./icons/check-square");
var _checkSquareDefault = parcelHelpers.interopDefault(_checkSquare);
var _check = require("./icons/check");
var _checkDefault = parcelHelpers.interopDefault(_check);
var _chevronDown = require("./icons/chevron-down");
var _chevronDownDefault = parcelHelpers.interopDefault(_chevronDown);
var _chevronLeft = require("./icons/chevron-left");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("./icons/chevron-right");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _chevronUp = require("./icons/chevron-up");
var _chevronUpDefault = parcelHelpers.interopDefault(_chevronUp);
var _chevronsDown = require("./icons/chevrons-down");
var _chevronsDownDefault = parcelHelpers.interopDefault(_chevronsDown);
var _chevronsLeft = require("./icons/chevrons-left");
var _chevronsLeftDefault = parcelHelpers.interopDefault(_chevronsLeft);
var _chevronsRight = require("./icons/chevrons-right");
var _chevronsRightDefault = parcelHelpers.interopDefault(_chevronsRight);
var _chevronsUp = require("./icons/chevrons-up");
var _chevronsUpDefault = parcelHelpers.interopDefault(_chevronsUp);
var _chrome = require("./icons/chrome");
var _chromeDefault = parcelHelpers.interopDefault(_chrome);
var _circle = require("./icons/circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _clipboard = require("./icons/clipboard");
var _clipboardDefault = parcelHelpers.interopDefault(_clipboard);
var _clock = require("./icons/clock");
var _clockDefault = parcelHelpers.interopDefault(_clock);
var _cloudDrizzle = require("./icons/cloud-drizzle");
var _cloudDrizzleDefault = parcelHelpers.interopDefault(_cloudDrizzle);
var _cloudLightning = require("./icons/cloud-lightning");
var _cloudLightningDefault = parcelHelpers.interopDefault(_cloudLightning);
var _cloudOff = require("./icons/cloud-off");
var _cloudOffDefault = parcelHelpers.interopDefault(_cloudOff);
var _cloudRain = require("./icons/cloud-rain");
var _cloudRainDefault = parcelHelpers.interopDefault(_cloudRain);
var _cloudSnow = require("./icons/cloud-snow");
var _cloudSnowDefault = parcelHelpers.interopDefault(_cloudSnow);
var _cloud = require("./icons/cloud");
var _cloudDefault = parcelHelpers.interopDefault(_cloud);
var _code = require("./icons/code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _codepen = require("./icons/codepen");
var _codepenDefault = parcelHelpers.interopDefault(_codepen);
var _codesandbox = require("./icons/codesandbox");
var _codesandboxDefault = parcelHelpers.interopDefault(_codesandbox);
var _coffee = require("./icons/coffee");
var _coffeeDefault = parcelHelpers.interopDefault(_coffee);
var _columns = require("./icons/columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _command = require("./icons/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _compass = require("./icons/compass");
var _compassDefault = parcelHelpers.interopDefault(_compass);
var _copy = require("./icons/copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _cornerDownLeft = require("./icons/corner-down-left");
var _cornerDownLeftDefault = parcelHelpers.interopDefault(_cornerDownLeft);
var _cornerDownRight = require("./icons/corner-down-right");
var _cornerDownRightDefault = parcelHelpers.interopDefault(_cornerDownRight);
var _cornerLeftDown = require("./icons/corner-left-down");
var _cornerLeftDownDefault = parcelHelpers.interopDefault(_cornerLeftDown);
var _cornerLeftUp = require("./icons/corner-left-up");
var _cornerLeftUpDefault = parcelHelpers.interopDefault(_cornerLeftUp);
var _cornerRightDown = require("./icons/corner-right-down");
var _cornerRightDownDefault = parcelHelpers.interopDefault(_cornerRightDown);
var _cornerRightUp = require("./icons/corner-right-up");
var _cornerRightUpDefault = parcelHelpers.interopDefault(_cornerRightUp);
var _cornerUpLeft = require("./icons/corner-up-left");
var _cornerUpLeftDefault = parcelHelpers.interopDefault(_cornerUpLeft);
var _cornerUpRight = require("./icons/corner-up-right");
var _cornerUpRightDefault = parcelHelpers.interopDefault(_cornerUpRight);
var _cpu = require("./icons/cpu");
var _cpuDefault = parcelHelpers.interopDefault(_cpu);
var _creditCard = require("./icons/credit-card");
var _creditCardDefault = parcelHelpers.interopDefault(_creditCard);
var _crop = require("./icons/crop");
var _cropDefault = parcelHelpers.interopDefault(_crop);
var _crosshair = require("./icons/crosshair");
var _crosshairDefault = parcelHelpers.interopDefault(_crosshair);
var _database = require("./icons/database");
var _databaseDefault = parcelHelpers.interopDefault(_database);
var _delete = require("./icons/delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _disc = require("./icons/disc");
var _discDefault = parcelHelpers.interopDefault(_disc);
var _divideCircle = require("./icons/divide-circle");
var _divideCircleDefault = parcelHelpers.interopDefault(_divideCircle);
var _divideSquare = require("./icons/divide-square");
var _divideSquareDefault = parcelHelpers.interopDefault(_divideSquare);
var _divide = require("./icons/divide");
var _divideDefault = parcelHelpers.interopDefault(_divide);
var _dollarSign = require("./icons/dollar-sign");
var _dollarSignDefault = parcelHelpers.interopDefault(_dollarSign);
var _downloadCloud = require("./icons/download-cloud");
var _downloadCloudDefault = parcelHelpers.interopDefault(_downloadCloud);
var _download = require("./icons/download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _dribbble = require("./icons/dribbble");
var _dribbbleDefault = parcelHelpers.interopDefault(_dribbble);
var _droplet = require("./icons/droplet");
var _dropletDefault = parcelHelpers.interopDefault(_droplet);
var _edit2 = require("./icons/edit-2");
var _edit2Default = parcelHelpers.interopDefault(_edit2);
var _edit3 = require("./icons/edit-3");
var _edit3Default = parcelHelpers.interopDefault(_edit3);
var _edit = require("./icons/edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _externalLink = require("./icons/external-link");
var _externalLinkDefault = parcelHelpers.interopDefault(_externalLink);
var _eyeOff = require("./icons/eye-off");
var _eyeOffDefault = parcelHelpers.interopDefault(_eyeOff);
var _eye = require("./icons/eye");
var _eyeDefault = parcelHelpers.interopDefault(_eye);
var _facebook = require("./icons/facebook");
var _facebookDefault = parcelHelpers.interopDefault(_facebook);
var _fastForward = require("./icons/fast-forward");
var _fastForwardDefault = parcelHelpers.interopDefault(_fastForward);
var _feather = require("./icons/feather");
var _featherDefault = parcelHelpers.interopDefault(_feather);
var _figma = require("./icons/figma");
var _figmaDefault = parcelHelpers.interopDefault(_figma);
var _fileMinus = require("./icons/file-minus");
var _fileMinusDefault = parcelHelpers.interopDefault(_fileMinus);
var _filePlus = require("./icons/file-plus");
var _filePlusDefault = parcelHelpers.interopDefault(_filePlus);
var _fileText = require("./icons/file-text");
var _fileTextDefault = parcelHelpers.interopDefault(_fileText);
var _file = require("./icons/file");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _film = require("./icons/film");
var _filmDefault = parcelHelpers.interopDefault(_film);
var _filter = require("./icons/filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _flag = require("./icons/flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _folderMinus = require("./icons/folder-minus");
var _folderMinusDefault = parcelHelpers.interopDefault(_folderMinus);
var _folderPlus = require("./icons/folder-plus");
var _folderPlusDefault = parcelHelpers.interopDefault(_folderPlus);
var _folder = require("./icons/folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _framer = require("./icons/framer");
var _framerDefault = parcelHelpers.interopDefault(_framer);
var _frown = require("./icons/frown");
var _frownDefault = parcelHelpers.interopDefault(_frown);
var _gift = require("./icons/gift");
var _giftDefault = parcelHelpers.interopDefault(_gift);
var _gitBranch = require("./icons/git-branch");
var _gitBranchDefault = parcelHelpers.interopDefault(_gitBranch);
var _gitCommit = require("./icons/git-commit");
var _gitCommitDefault = parcelHelpers.interopDefault(_gitCommit);
var _gitMerge = require("./icons/git-merge");
var _gitMergeDefault = parcelHelpers.interopDefault(_gitMerge);
var _gitPullRequest = require("./icons/git-pull-request");
var _gitPullRequestDefault = parcelHelpers.interopDefault(_gitPullRequest);
var _github = require("./icons/github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _gitlab = require("./icons/gitlab");
var _gitlabDefault = parcelHelpers.interopDefault(_gitlab);
var _globe = require("./icons/globe");
var _globeDefault = parcelHelpers.interopDefault(_globe);
var _grid = require("./icons/grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _hardDrive = require("./icons/hard-drive");
var _hardDriveDefault = parcelHelpers.interopDefault(_hardDrive);
var _hash = require("./icons/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _headphones = require("./icons/headphones");
var _headphonesDefault = parcelHelpers.interopDefault(_headphones);
var _heart = require("./icons/heart");
var _heartDefault = parcelHelpers.interopDefault(_heart);
var _helpCircle = require("./icons/help-circle");
var _helpCircleDefault = parcelHelpers.interopDefault(_helpCircle);
var _hexagon = require("./icons/hexagon");
var _hexagonDefault = parcelHelpers.interopDefault(_hexagon);
var _home = require("./icons/home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _image = require("./icons/image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _inbox = require("./icons/inbox");
var _inboxDefault = parcelHelpers.interopDefault(_inbox);
var _info = require("./icons/info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _instagram = require("./icons/instagram");
var _instagramDefault = parcelHelpers.interopDefault(_instagram);
var _italic = require("./icons/italic");
var _italicDefault = parcelHelpers.interopDefault(_italic);
var _key = require("./icons/key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _layers = require("./icons/layers");
var _layersDefault = parcelHelpers.interopDefault(_layers);
var _layout = require("./icons/layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _lifeBuoy = require("./icons/life-buoy");
var _lifeBuoyDefault = parcelHelpers.interopDefault(_lifeBuoy);
var _link2 = require("./icons/link-2");
var _link2Default = parcelHelpers.interopDefault(_link2);
var _link = require("./icons/link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _linkedin = require("./icons/linkedin");
var _linkedinDefault = parcelHelpers.interopDefault(_linkedin);
var _list = require("./icons/list");
var _listDefault = parcelHelpers.interopDefault(_list);
var _loader = require("./icons/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _lock = require("./icons/lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _logIn = require("./icons/log-in");
var _logInDefault = parcelHelpers.interopDefault(_logIn);
var _logOut = require("./icons/log-out");
var _logOutDefault = parcelHelpers.interopDefault(_logOut);
var _mail = require("./icons/mail");
var _mailDefault = parcelHelpers.interopDefault(_mail);
var _mapPin = require("./icons/map-pin");
var _mapPinDefault = parcelHelpers.interopDefault(_mapPin);
var _map = require("./icons/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _maximize2 = require("./icons/maximize-2");
var _maximize2Default = parcelHelpers.interopDefault(_maximize2);
var _maximize = require("./icons/maximize");
var _maximizeDefault = parcelHelpers.interopDefault(_maximize);
var _meh = require("./icons/meh");
var _mehDefault = parcelHelpers.interopDefault(_meh);
var _menu = require("./icons/menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _messageCircle = require("./icons/message-circle");
var _messageCircleDefault = parcelHelpers.interopDefault(_messageCircle);
var _messageSquare = require("./icons/message-square");
var _messageSquareDefault = parcelHelpers.interopDefault(_messageSquare);
var _micOff = require("./icons/mic-off");
var _micOffDefault = parcelHelpers.interopDefault(_micOff);
var _mic = require("./icons/mic");
var _micDefault = parcelHelpers.interopDefault(_mic);
var _minimize2 = require("./icons/minimize-2");
var _minimize2Default = parcelHelpers.interopDefault(_minimize2);
var _minimize = require("./icons/minimize");
var _minimizeDefault = parcelHelpers.interopDefault(_minimize);
var _minusCircle = require("./icons/minus-circle");
var _minusCircleDefault = parcelHelpers.interopDefault(_minusCircle);
var _minusSquare = require("./icons/minus-square");
var _minusSquareDefault = parcelHelpers.interopDefault(_minusSquare);
var _minus = require("./icons/minus");
var _minusDefault = parcelHelpers.interopDefault(_minus);
var _monitor = require("./icons/monitor");
var _monitorDefault = parcelHelpers.interopDefault(_monitor);
var _moon = require("./icons/moon");
var _moonDefault = parcelHelpers.interopDefault(_moon);
var _moreHorizontal = require("./icons/more-horizontal");
var _moreHorizontalDefault = parcelHelpers.interopDefault(_moreHorizontal);
var _moreVertical = require("./icons/more-vertical");
var _moreVerticalDefault = parcelHelpers.interopDefault(_moreVertical);
var _mousePointer = require("./icons/mouse-pointer");
var _mousePointerDefault = parcelHelpers.interopDefault(_mousePointer);
var _move = require("./icons/move");
var _moveDefault = parcelHelpers.interopDefault(_move);
var _music = require("./icons/music");
var _musicDefault = parcelHelpers.interopDefault(_music);
var _navigation2 = require("./icons/navigation-2");
var _navigation2Default = parcelHelpers.interopDefault(_navigation2);
var _navigation = require("./icons/navigation");
var _navigationDefault = parcelHelpers.interopDefault(_navigation);
var _octagon = require("./icons/octagon");
var _octagonDefault = parcelHelpers.interopDefault(_octagon);
var _package = require("./icons/package");
var _packageDefault = parcelHelpers.interopDefault(_package);
var _paperclip = require("./icons/paperclip");
var _paperclipDefault = parcelHelpers.interopDefault(_paperclip);
var _pauseCircle = require("./icons/pause-circle");
var _pauseCircleDefault = parcelHelpers.interopDefault(_pauseCircle);
var _pause = require("./icons/pause");
var _pauseDefault = parcelHelpers.interopDefault(_pause);
var _penTool = require("./icons/pen-tool");
var _penToolDefault = parcelHelpers.interopDefault(_penTool);
var _percent = require("./icons/percent");
var _percentDefault = parcelHelpers.interopDefault(_percent);
var _phoneCall = require("./icons/phone-call");
var _phoneCallDefault = parcelHelpers.interopDefault(_phoneCall);
var _phoneForwarded = require("./icons/phone-forwarded");
var _phoneForwardedDefault = parcelHelpers.interopDefault(_phoneForwarded);
var _phoneIncoming = require("./icons/phone-incoming");
var _phoneIncomingDefault = parcelHelpers.interopDefault(_phoneIncoming);
var _phoneMissed = require("./icons/phone-missed");
var _phoneMissedDefault = parcelHelpers.interopDefault(_phoneMissed);
var _phoneOff = require("./icons/phone-off");
var _phoneOffDefault = parcelHelpers.interopDefault(_phoneOff);
var _phoneOutgoing = require("./icons/phone-outgoing");
var _phoneOutgoingDefault = parcelHelpers.interopDefault(_phoneOutgoing);
var _phone = require("./icons/phone");
var _phoneDefault = parcelHelpers.interopDefault(_phone);
var _pieChart = require("./icons/pie-chart");
var _pieChartDefault = parcelHelpers.interopDefault(_pieChart);
var _playCircle = require("./icons/play-circle");
var _playCircleDefault = parcelHelpers.interopDefault(_playCircle);
var _play = require("./icons/play");
var _playDefault = parcelHelpers.interopDefault(_play);
var _plusCircle = require("./icons/plus-circle");
var _plusCircleDefault = parcelHelpers.interopDefault(_plusCircle);
var _plusSquare = require("./icons/plus-square");
var _plusSquareDefault = parcelHelpers.interopDefault(_plusSquare);
var _plus = require("./icons/plus");
var _plusDefault = parcelHelpers.interopDefault(_plus);
var _pocket = require("./icons/pocket");
var _pocketDefault = parcelHelpers.interopDefault(_pocket);
var _power = require("./icons/power");
var _powerDefault = parcelHelpers.interopDefault(_power);
var _printer = require("./icons/printer");
var _printerDefault = parcelHelpers.interopDefault(_printer);
var _radio = require("./icons/radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _refreshCcw = require("./icons/refresh-ccw");
var _refreshCcwDefault = parcelHelpers.interopDefault(_refreshCcw);
var _refreshCw = require("./icons/refresh-cw");
var _refreshCwDefault = parcelHelpers.interopDefault(_refreshCw);
var _repeat = require("./icons/repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _rewind = require("./icons/rewind");
var _rewindDefault = parcelHelpers.interopDefault(_rewind);
var _rotateCcw = require("./icons/rotate-ccw");
var _rotateCcwDefault = parcelHelpers.interopDefault(_rotateCcw);
var _rotateCw = require("./icons/rotate-cw");
var _rotateCwDefault = parcelHelpers.interopDefault(_rotateCw);
var _rss = require("./icons/rss");
var _rssDefault = parcelHelpers.interopDefault(_rss);
var _save = require("./icons/save");
var _saveDefault = parcelHelpers.interopDefault(_save);
var _scissors = require("./icons/scissors");
var _scissorsDefault = parcelHelpers.interopDefault(_scissors);
var _search = require("./icons/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _send = require("./icons/send");
var _sendDefault = parcelHelpers.interopDefault(_send);
var _server = require("./icons/server");
var _serverDefault = parcelHelpers.interopDefault(_server);
var _settings = require("./icons/settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _share2 = require("./icons/share-2");
var _share2Default = parcelHelpers.interopDefault(_share2);
var _share = require("./icons/share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _shieldOff = require("./icons/shield-off");
var _shieldOffDefault = parcelHelpers.interopDefault(_shieldOff);
var _shield = require("./icons/shield");
var _shieldDefault = parcelHelpers.interopDefault(_shield);
var _shoppingBag = require("./icons/shopping-bag");
var _shoppingBagDefault = parcelHelpers.interopDefault(_shoppingBag);
var _shoppingCart = require("./icons/shopping-cart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _shuffle = require("./icons/shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _sidebar = require("./icons/sidebar");
var _sidebarDefault = parcelHelpers.interopDefault(_sidebar);
var _skipBack = require("./icons/skip-back");
var _skipBackDefault = parcelHelpers.interopDefault(_skipBack);
var _skipForward = require("./icons/skip-forward");
var _skipForwardDefault = parcelHelpers.interopDefault(_skipForward);
var _slack = require("./icons/slack");
var _slackDefault = parcelHelpers.interopDefault(_slack);
var _slash = require("./icons/slash");
var _slashDefault = parcelHelpers.interopDefault(_slash);
var _sliders = require("./icons/sliders");
var _slidersDefault = parcelHelpers.interopDefault(_sliders);
var _smartphone = require("./icons/smartphone");
var _smartphoneDefault = parcelHelpers.interopDefault(_smartphone);
var _smile = require("./icons/smile");
var _smileDefault = parcelHelpers.interopDefault(_smile);
var _speaker = require("./icons/speaker");
var _speakerDefault = parcelHelpers.interopDefault(_speaker);
var _square = require("./icons/square");
var _squareDefault = parcelHelpers.interopDefault(_square);
var _star = require("./icons/star");
var _starDefault = parcelHelpers.interopDefault(_star);
var _stopCircle = require("./icons/stop-circle");
var _stopCircleDefault = parcelHelpers.interopDefault(_stopCircle);
var _sun = require("./icons/sun");
var _sunDefault = parcelHelpers.interopDefault(_sun);
var _sunrise = require("./icons/sunrise");
var _sunriseDefault = parcelHelpers.interopDefault(_sunrise);
var _sunset = require("./icons/sunset");
var _sunsetDefault = parcelHelpers.interopDefault(_sunset);
var _table = require("./icons/table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tablet = require("./icons/tablet");
var _tabletDefault = parcelHelpers.interopDefault(_tablet);
var _tag = require("./icons/tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _target = require("./icons/target");
var _targetDefault = parcelHelpers.interopDefault(_target);
var _terminal = require("./icons/terminal");
var _terminalDefault = parcelHelpers.interopDefault(_terminal);
var _thermometer = require("./icons/thermometer");
var _thermometerDefault = parcelHelpers.interopDefault(_thermometer);
var _thumbsDown = require("./icons/thumbs-down");
var _thumbsDownDefault = parcelHelpers.interopDefault(_thumbsDown);
var _thumbsUp = require("./icons/thumbs-up");
var _thumbsUpDefault = parcelHelpers.interopDefault(_thumbsUp);
var _toggleLeft = require("./icons/toggle-left");
var _toggleLeftDefault = parcelHelpers.interopDefault(_toggleLeft);
var _toggleRight = require("./icons/toggle-right");
var _toggleRightDefault = parcelHelpers.interopDefault(_toggleRight);
var _tool = require("./icons/tool");
var _toolDefault = parcelHelpers.interopDefault(_tool);
var _trash2 = require("./icons/trash-2");
var _trash2Default = parcelHelpers.interopDefault(_trash2);
var _trash = require("./icons/trash");
var _trashDefault = parcelHelpers.interopDefault(_trash);
var _trello = require("./icons/trello");
var _trelloDefault = parcelHelpers.interopDefault(_trello);
var _trendingDown = require("./icons/trending-down");
var _trendingDownDefault = parcelHelpers.interopDefault(_trendingDown);
var _trendingUp = require("./icons/trending-up");
var _trendingUpDefault = parcelHelpers.interopDefault(_trendingUp);
var _triangle = require("./icons/triangle");
var _triangleDefault = parcelHelpers.interopDefault(_triangle);
var _truck = require("./icons/truck");
var _truckDefault = parcelHelpers.interopDefault(_truck);
var _tv = require("./icons/tv");
var _tvDefault = parcelHelpers.interopDefault(_tv);
var _twitch = require("./icons/twitch");
var _twitchDefault = parcelHelpers.interopDefault(_twitch);
var _twitter = require("./icons/twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _type = require("./icons/type");
var _typeDefault = parcelHelpers.interopDefault(_type);
var _umbrella = require("./icons/umbrella");
var _umbrellaDefault = parcelHelpers.interopDefault(_umbrella);
var _underline = require("./icons/underline");
var _underlineDefault = parcelHelpers.interopDefault(_underline);
var _unlock = require("./icons/unlock");
var _unlockDefault = parcelHelpers.interopDefault(_unlock);
var _uploadCloud = require("./icons/upload-cloud");
var _uploadCloudDefault = parcelHelpers.interopDefault(_uploadCloud);
var _upload = require("./icons/upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _userCheck = require("./icons/user-check");
var _userCheckDefault = parcelHelpers.interopDefault(_userCheck);
var _userMinus = require("./icons/user-minus");
var _userMinusDefault = parcelHelpers.interopDefault(_userMinus);
var _userPlus = require("./icons/user-plus");
var _userPlusDefault = parcelHelpers.interopDefault(_userPlus);
var _userX = require("./icons/user-x");
var _userXDefault = parcelHelpers.interopDefault(_userX);
var _user = require("./icons/user");
var _userDefault = parcelHelpers.interopDefault(_user);
var _users = require("./icons/users");
var _usersDefault = parcelHelpers.interopDefault(_users);
var _videoOff = require("./icons/video-off");
var _videoOffDefault = parcelHelpers.interopDefault(_videoOff);
var _video = require("./icons/video");
var _videoDefault = parcelHelpers.interopDefault(_video);
var _voicemail = require("./icons/voicemail");
var _voicemailDefault = parcelHelpers.interopDefault(_voicemail);
var _volume1 = require("./icons/volume-1");
var _volume1Default = parcelHelpers.interopDefault(_volume1);
var _volume2 = require("./icons/volume-2");
var _volume2Default = parcelHelpers.interopDefault(_volume2);
var _volumeX = require("./icons/volume-x");
var _volumeXDefault = parcelHelpers.interopDefault(_volumeX);
var _volume = require("./icons/volume");
var _volumeDefault = parcelHelpers.interopDefault(_volume);
var _watch = require("./icons/watch");
var _watchDefault = parcelHelpers.interopDefault(_watch);
var _wifiOff = require("./icons/wifi-off");
var _wifiOffDefault = parcelHelpers.interopDefault(_wifiOff);
var _wifi = require("./icons/wifi");
var _wifiDefault = parcelHelpers.interopDefault(_wifi);
var _wind = require("./icons/wind");
var _windDefault = parcelHelpers.interopDefault(_wind);
var _xCircle = require("./icons/x-circle");
var _xCircleDefault = parcelHelpers.interopDefault(_xCircle);
var _xOctagon = require("./icons/x-octagon");
var _xOctagonDefault = parcelHelpers.interopDefault(_xOctagon);
var _xSquare = require("./icons/x-square");
var _xSquareDefault = parcelHelpers.interopDefault(_xSquare);
var _x = require("./icons/x");
var _xDefault = parcelHelpers.interopDefault(_x);
var _youtube = require("./icons/youtube");
var _youtubeDefault = parcelHelpers.interopDefault(_youtube);
var _zapOff = require("./icons/zap-off");
var _zapOffDefault = parcelHelpers.interopDefault(_zapOff);
var _zap = require("./icons/zap");
var _zapDefault = parcelHelpers.interopDefault(_zap);
var _zoomIn = require("./icons/zoom-in");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _zoomOut = require("./icons/zoom-out");
var _zoomOutDefault = parcelHelpers.interopDefault(_zoomOut);

},{"./icons/activity":false,"./icons/airplay":false,"./icons/alert-circle":"cuIji","./icons/alert-octagon":false,"./icons/alert-triangle":false,"./icons/align-center":false,"./icons/align-justify":false,"./icons/align-left":false,"./icons/align-right":false,"./icons/anchor":false,"./icons/aperture":false,"./icons/archive":false,"./icons/arrow-down-circle":false,"./icons/arrow-down-left":false,"./icons/arrow-down-right":false,"./icons/arrow-down":false,"./icons/arrow-left-circle":false,"./icons/arrow-left":false,"./icons/arrow-right-circle":false,"./icons/arrow-right":false,"./icons/arrow-up-circle":false,"./icons/arrow-up-left":false,"./icons/arrow-up-right":false,"./icons/arrow-up":false,"./icons/at-sign":false,"./icons/award":false,"./icons/bar-chart-2":false,"./icons/bar-chart":false,"./icons/battery-charging":false,"./icons/battery":false,"./icons/bell-off":false,"./icons/bell":false,"./icons/bluetooth":false,"./icons/bold":false,"./icons/book-open":"4pkds","./icons/book":"bFZMP","./icons/bookmark":false,"./icons/box":false,"./icons/briefcase":false,"./icons/calendar":false,"./icons/camera-off":false,"./icons/camera":false,"./icons/cast":false,"./icons/check-circle":false,"./icons/check-square":false,"./icons/check":false,"./icons/chevron-down":"f1dHI","./icons/chevron-left":false,"./icons/chevron-right":false,"./icons/chevron-up":"9zsXa","./icons/chevrons-down":false,"./icons/chevrons-left":false,"./icons/chevrons-right":false,"./icons/chevrons-up":false,"./icons/chrome":false,"./icons/circle":false,"./icons/clipboard":false,"./icons/clock":false,"./icons/cloud-drizzle":false,"./icons/cloud-lightning":false,"./icons/cloud-off":false,"./icons/cloud-rain":false,"./icons/cloud-snow":false,"./icons/cloud":false,"./icons/code":"ln6WV","./icons/codepen":false,"./icons/codesandbox":false,"./icons/coffee":false,"./icons/columns":false,"./icons/command":false,"./icons/compass":false,"./icons/copy":"hRtdg","./icons/corner-down-left":false,"./icons/corner-down-right":false,"./icons/corner-left-down":false,"./icons/corner-left-up":false,"./icons/corner-right-down":false,"./icons/corner-right-up":false,"./icons/corner-up-left":false,"./icons/corner-up-right":false,"./icons/cpu":false,"./icons/credit-card":false,"./icons/crop":false,"./icons/crosshair":false,"./icons/database":false,"./icons/delete":false,"./icons/disc":false,"./icons/divide-circle":false,"./icons/divide-square":false,"./icons/divide":false,"./icons/dollar-sign":false,"./icons/download-cloud":false,"./icons/download":false,"./icons/dribbble":false,"./icons/droplet":false,"./icons/edit-2":false,"./icons/edit-3":false,"./icons/edit":false,"./icons/external-link":"jrJr9","./icons/eye-off":false,"./icons/eye":false,"./icons/facebook":false,"./icons/fast-forward":false,"./icons/feather":false,"./icons/figma":false,"./icons/file-minus":false,"./icons/file-plus":false,"./icons/file-text":false,"./icons/file":"97Xiq","./icons/film":false,"./icons/filter":false,"./icons/flag":false,"./icons/folder-minus":false,"./icons/folder-plus":false,"./icons/folder":false,"./icons/framer":false,"./icons/frown":false,"./icons/gift":false,"./icons/git-branch":false,"./icons/git-commit":false,"./icons/git-merge":false,"./icons/git-pull-request":false,"./icons/github":"8203T","./icons/gitlab":false,"./icons/globe":false,"./icons/grid":"bT9xC","./icons/hard-drive":false,"./icons/hash":false,"./icons/headphones":false,"./icons/heart":false,"./icons/help-circle":"6HJrf","./icons/hexagon":false,"./icons/home":false,"./icons/image":"l2CET","./icons/inbox":false,"./icons/info":false,"./icons/instagram":false,"./icons/italic":false,"./icons/key":false,"./icons/layers":false,"./icons/layout":false,"./icons/life-buoy":false,"./icons/link-2":false,"./icons/link":"a1DEC","./icons/linkedin":false,"./icons/list":false,"./icons/loader":false,"./icons/lock":"5vtH0","./icons/log-in":false,"./icons/log-out":false,"./icons/mail":false,"./icons/map-pin":false,"./icons/map":"cMZsT","./icons/maximize-2":false,"./icons/maximize":"e2Tzn","./icons/meh":false,"./icons/menu":false,"./icons/message-circle":false,"./icons/message-square":false,"./icons/mic-off":false,"./icons/mic":false,"./icons/minimize-2":false,"./icons/minimize":false,"./icons/minus-circle":false,"./icons/minus-square":false,"./icons/minus":false,"./icons/monitor":false,"./icons/moon":false,"./icons/more-horizontal":false,"./icons/more-vertical":false,"./icons/mouse-pointer":false,"./icons/move":false,"./icons/music":false,"./icons/navigation-2":false,"./icons/navigation":false,"./icons/octagon":false,"./icons/package":false,"./icons/paperclip":false,"./icons/pause-circle":false,"./icons/pause":false,"./icons/pen-tool":false,"./icons/percent":false,"./icons/phone-call":false,"./icons/phone-forwarded":false,"./icons/phone-incoming":false,"./icons/phone-missed":false,"./icons/phone-off":false,"./icons/phone-outgoing":false,"./icons/phone":false,"./icons/pie-chart":false,"./icons/play-circle":false,"./icons/play":"8lBeI","./icons/plus-circle":false,"./icons/plus-square":false,"./icons/plus":false,"./icons/pocket":false,"./icons/power":false,"./icons/printer":false,"./icons/radio":false,"./icons/refresh-ccw":false,"./icons/refresh-cw":false,"./icons/repeat":false,"./icons/rewind":false,"./icons/rotate-ccw":false,"./icons/rotate-cw":false,"./icons/rss":false,"./icons/save":"3zJ4R","./icons/scissors":false,"./icons/search":"labfd","./icons/send":false,"./icons/server":false,"./icons/settings":"6Jg3X","./icons/share-2":"elw3J","./icons/share":false,"./icons/shield-off":false,"./icons/shield":false,"./icons/shopping-bag":false,"./icons/shopping-cart":false,"./icons/shuffle":false,"./icons/sidebar":false,"./icons/skip-back":false,"./icons/skip-forward":false,"./icons/slack":"52Q0x","./icons/slash":false,"./icons/sliders":false,"./icons/smartphone":false,"./icons/smile":false,"./icons/speaker":false,"./icons/square":false,"./icons/star":false,"./icons/stop-circle":false,"./icons/sun":false,"./icons/sunrise":false,"./icons/sunset":false,"./icons/table":false,"./icons/tablet":false,"./icons/tag":false,"./icons/target":false,"./icons/terminal":"s9cq3","./icons/thermometer":false,"./icons/thumbs-down":false,"./icons/thumbs-up":false,"./icons/toggle-left":false,"./icons/toggle-right":false,"./icons/tool":false,"./icons/trash-2":false,"./icons/trash":false,"./icons/trello":false,"./icons/trending-down":false,"./icons/trending-up":false,"./icons/triangle":false,"./icons/truck":false,"./icons/tv":false,"./icons/twitch":false,"./icons/twitter":"j0HVe","./icons/type":false,"./icons/umbrella":false,"./icons/underline":false,"./icons/unlock":false,"./icons/upload-cloud":false,"./icons/upload":false,"./icons/user-check":false,"./icons/user-minus":false,"./icons/user-plus":false,"./icons/user-x":false,"./icons/user":false,"./icons/users":false,"./icons/video-off":false,"./icons/video":false,"./icons/voicemail":false,"./icons/volume-1":false,"./icons/volume-2":false,"./icons/volume-x":false,"./icons/volume":false,"./icons/watch":false,"./icons/wifi-off":false,"./icons/wifi":false,"./icons/wind":false,"./icons/x-circle":false,"./icons/x-octagon":false,"./icons/x-square":false,"./icons/x":"d2WlV","./icons/youtube":false,"./icons/zap-off":false,"./icons/zap":false,"./icons/zoom-in":false,"./icons/zoom-out":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cuIji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var AlertCircle = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "12",
        y1: "8",
        x2: "12",
        y2: "12"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "12",
        y1: "16",
        x2: "12.01",
        y2: "16"
    }));
});
AlertCircle.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
AlertCircle.displayName = 'AlertCircle';
exports.default = AlertCircle;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pkds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BookOpen = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
    }));
});
BookOpen.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
BookOpen.displayName = 'BookOpen';
exports.default = BookOpen;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bFZMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Book = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
    }));
});
Book.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Book.displayName = 'Book';
exports.default = Book;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f1dHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ChevronDown = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "6 9 12 15 18 9"
    }));
});
ChevronDown.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
ChevronDown.displayName = 'ChevronDown';
exports.default = ChevronDown;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9zsXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ChevronUp = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "18 15 12 9 6 15"
    }));
});
ChevronUp.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
ChevronUp.displayName = 'ChevronUp';
exports.default = ChevronUp;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ln6WV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Code = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "16 18 22 12 16 6"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "8 6 2 12 8 18"
    }));
});
Code.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Code.displayName = 'Code';
exports.default = Code;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hRtdg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Copy = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "9",
        y: "9",
        width: "13",
        height: "13",
        rx: "2",
        ry: "2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }));
});
Copy.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Copy.displayName = 'Copy';
exports.default = Copy;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jrJr9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ExternalLink = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "10",
        y1: "14",
        x2: "21",
        y2: "3"
    }));
});
ExternalLink.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
ExternalLink.displayName = 'ExternalLink';
exports.default = ExternalLink;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"97Xiq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var File = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "13 2 13 9 20 9"
    }));
});
File.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
File.displayName = 'File';
exports.default = File;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8203T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var GitHub = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
    }));
});
GitHub.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
GitHub.displayName = 'GitHub';
exports.default = GitHub;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bT9xC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Grid = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "3",
        width: "7",
        height: "7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "14",
        y: "3",
        width: "7",
        height: "7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "14",
        y: "14",
        width: "7",
        height: "7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "14",
        width: "7",
        height: "7"
    }));
});
Grid.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Grid.displayName = 'Grid';
exports.default = Grid;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6HJrf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HelpCircle = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "12",
        y1: "17",
        x2: "12.01",
        y2: "17"
    }));
});
HelpCircle.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
HelpCircle.displayName = 'HelpCircle';
exports.default = HelpCircle;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l2CET":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Image = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2",
        ry: "2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "8.5",
        cy: "8.5",
        r: "1.5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "21 15 16 10 5 21"
    }));
});
Image.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Image.displayName = 'Image';
exports.default = Image;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a1DEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Link = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
    }));
});
Link.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Link.displayName = 'Link';
exports.default = Link;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vtH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Lock = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "11",
        width: "18",
        height: "11",
        rx: "2",
        ry: "2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7 11V7a5 5 0 0 1 10 0v4"
    }));
});
Lock.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Lock.displayName = 'Lock';
exports.default = Lock;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cMZsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Map = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "8",
        y1: "2",
        x2: "8",
        y2: "18"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "16",
        y1: "6",
        x2: "16",
        y2: "22"
    }));
});
Map.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Map.displayName = 'Map';
exports.default = Map;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e2Tzn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Maximize = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
    }));
});
Maximize.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Maximize.displayName = 'Maximize';
exports.default = Maximize;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8lBeI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Play = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        points: "5 3 19 12 5 21 5 3"
    }));
});
Play.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Play.displayName = 'Play';
exports.default = Play;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3zJ4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Save = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "17 21 17 13 7 13 7 21"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "7 3 7 8 15 8"
    }));
});
Save.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Save.displayName = 'Save';
exports.default = Save;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"labfd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Search = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }));
});
Search.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Search.displayName = 'Search';
exports.default = Search;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Jg3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Settings = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
    }));
});
Settings.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Settings.displayName = 'Settings';
exports.default = Settings;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"elw3J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Share2 = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "18",
        cy: "5",
        r: "3"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "6",
        cy: "12",
        r: "3"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "18",
        cy: "19",
        r: "3"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "8.59",
        y1: "13.51",
        x2: "15.42",
        y2: "17.49"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "15.41",
        y1: "6.51",
        x2: "8.59",
        y2: "10.49"
    }));
});
Share2.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Share2.displayName = 'Share2';
exports.default = Share2;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"52Q0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Slack = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
    }));
});
Slack.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Slack.displayName = 'Slack';
exports.default = Slack;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"s9cq3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Terminal = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "4 17 10 11 4 5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "12",
        y1: "19",
        x2: "20",
        y2: "19"
    }));
});
Terminal.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Terminal.displayName = 'Terminal';
exports.default = Terminal;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j0HVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Twitter = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
    }));
});
Twitter.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
Twitter.displayName = 'Twitter';
exports.default = Twitter;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d2WlV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var X = (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = _objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
    }));
});
X.propTypes = {
    color: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ])
};
X.displayName = 'X';
exports.default = X;

},{"react":"bmhQu","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"18Y94":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>(0, _portalCompatDefault.default));
parcelHelpers.export(exports, "PortalWithState", ()=>(0, _portalWithStateDefault.default));
var _portalCompat = require("./PortalCompat");
var _portalCompatDefault = parcelHelpers.interopDefault(_portalCompat);
var _portalWithState = require("./PortalWithState");
var _portalWithStateDefault = parcelHelpers.interopDefault(_portalWithState);

},{"./PortalCompat":"lS0Gh","./PortalWithState":"2THJL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lS0Gh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _legacyPortal = require("./LegacyPortal");
var _legacyPortalDefault = parcelHelpers.interopDefault(_legacyPortal);
var Portal = void 0;
if ((0, _reactDomDefault.default).createPortal) Portal = (0, _portalDefault.default);
else Portal = (0, _legacyPortalDefault.default);
exports.default = Portal;

},{"react-dom":"82aNB","./Portal":"e3c3U","./LegacyPortal":"kO9Mm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e3c3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _utils = require("./utils");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Portal = function(_React$Component) {
    _inherits(Portal, _React$Component);
    function Portal() {
        _classCallCheck(this, Portal);
        return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
    }
    _createClass(Portal, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
            }
        },
        {
            key: 'render',
            value: function render() {
                if (!(0, _utils.canUseDOM)) return null;
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement('div');
                    document.body.appendChild(this.defaultNode);
                }
                return (0, _reactDomDefault.default).createPortal(this.props.children, this.props.node || this.defaultNode);
            }
        }
    ]);
    return Portal;
}((0, _reactDefault.default).Component);
Portal.propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    node: (0, _propTypesDefault.default).any
};
exports.default = Portal;

},{"react":"bmhQu","prop-types":"gLXGb","react-dom":"82aNB","./utils":"3aZWM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aZWM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kO9Mm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// This file is a fallback for a consumer who is not yet on React 16
// as createPortal was introduced in React 16
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Portal = function(_React$Component) {
    _inherits(Portal, _React$Component);
    function Portal() {
        _classCallCheck(this, Portal);
        return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
    }
    _createClass(Portal, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.renderPortal();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(props) {
                this.renderPortal();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                (0, _reactDomDefault.default).unmountComponentAtNode(this.defaultNode || this.props.node);
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
                this.portal = null;
            }
        },
        {
            key: 'renderPortal',
            value: function renderPortal(props) {
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement('div');
                    document.body.appendChild(this.defaultNode);
                }
                var children = this.props.children;
                // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
                if (typeof this.props.children.type === 'function') children = (0, _reactDefault.default).cloneElement(this.props.children);
                this.portal = (0, _reactDomDefault.default).unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return Portal;
}((0, _reactDefault.default).Component);
exports.default = Portal;
Portal.propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    node: (0, _propTypesDefault.default).any
};

},{"react":"bmhQu","react-dom":"82aNB","prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2THJL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _portalCompat = require("./PortalCompat");
var _portalCompatDefault = parcelHelpers.interopDefault(_portalCompat);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var KEYCODES = {
    ESCAPE: 27
};
var PortalWithState = function(_React$Component) {
    _inherits(PortalWithState, _React$Component);
    function PortalWithState(props) {
        _classCallCheck(this, PortalWithState);
        var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
        _this.portalNode = null;
        _this.state = {
            active: !!props.defaultOpen
        };
        _this.openPortal = _this.openPortal.bind(_this);
        _this.closePortal = _this.closePortal.bind(_this);
        _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
        _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
        _this.handleKeydown = _this.handleKeydown.bind(_this);
        return _this;
    }
    _createClass(PortalWithState, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.props.closeOnEsc) document.addEventListener('keydown', this.handleKeydown);
                if (this.props.closeOnOutsideClick) document.addEventListener('click', this.handleOutsideMouseClick);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.props.closeOnEsc) document.removeEventListener('keydown', this.handleKeydown);
                if (this.props.closeOnOutsideClick) document.removeEventListener('click', this.handleOutsideMouseClick);
            }
        },
        {
            key: 'openPortal',
            value: function openPortal(e) {
                if (this.state.active) return;
                if (e && e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
                this.setState({
                    active: true
                }, this.props.onOpen);
            }
        },
        {
            key: 'closePortal',
            value: function closePortal() {
                if (!this.state.active) return;
                this.setState({
                    active: false
                }, this.props.onClose);
            }
        },
        {
            key: 'wrapWithPortal',
            value: function wrapWithPortal(children) {
                var _this2 = this;
                if (!this.state.active) return null;
                return (0, _reactDefault.default).createElement((0, _portalCompatDefault.default), {
                    node: this.props.node,
                    key: 'react-portal',
                    ref: function ref(portalNode) {
                        return _this2.portalNode = portalNode;
                    }
                }, children);
            }
        },
        {
            key: 'handleOutsideMouseClick',
            value: function handleOutsideMouseClick(e) {
                if (!this.state.active) return;
                var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
                if (!root || root.contains(e.target) || e.button && e.button !== 0) return;
                this.closePortal();
            }
        },
        {
            key: 'handleKeydown',
            value: function handleKeydown(e) {
                if (e.keyCode === KEYCODES.ESCAPE && this.state.active) this.closePortal();
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children({
                    openPortal: this.openPortal,
                    closePortal: this.closePortal,
                    portal: this.wrapWithPortal,
                    isOpen: this.state.active
                });
            }
        }
    ]);
    return PortalWithState;
}((0, _reactDefault.default).Component);
PortalWithState.propTypes = {
    children: (0, _propTypesDefault.default).func.isRequired,
    defaultOpen: (0, _propTypesDefault.default).bool,
    node: (0, _propTypesDefault.default).any,
    closeOnEsc: (0, _propTypesDefault.default).bool,
    closeOnOutsideClick: (0, _propTypesDefault.default).bool,
    onOpen: (0, _propTypesDefault.default).func,
    onClose: (0, _propTypesDefault.default).func
};
PortalWithState.defaultProps = {
    onOpen: function onOpen() {},
    onClose: function onClose() {}
};
exports.default = PortalWithState;

},{"react":"bmhQu","prop-types":"gLXGb","./PortalCompat":"lS0Gh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9WAWN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManager7E1E8489EsmJs.u));
parcelHelpers.export(exports, "createFilter", ()=>(0, _selectAab027F3EsmJs.c));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _selectAab027F3EsmJs.d));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _selectAab027F3EsmJs.m));
parcelHelpers.export(exports, "components", ()=>(0, _index641Ee5B8EsmJs.c));
parcelHelpers.export(exports, "NonceProvider", ()=>NonceProvider);
parcelHelpers.export(exports, "default", ()=>StateManagedSelect$1);
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _selectAab027F3EsmJs = require("./Select-aab027f3.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _selectAab027F3EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};

},{"./useStateManager-7e1e8489.esm.js":"7wMmn","@babel/runtime/helpers/esm/extends":"85Hd3","react":"bmhQu","./Select-aab027f3.esm.js":"daMXZ","@emotion/react":"3ILVC","@emotion/cache":"csFJU","./index-641ee5b8.esm.js":false,"@babel/runtime/helpers/objectSpread2":"dn9qZ","@babel/runtime/helpers/slicedToArray":"bem4D","@babel/runtime/helpers/objectWithoutProperties":"dRtLA","@babel/runtime/helpers/classCallCheck":"1eYFn","@babel/runtime/helpers/createClass":"89Fc8","@babel/runtime/helpers/inherits":"9qeOz","@babel/runtime/helpers/createSuper":"4Z7nH","@babel/runtime/helpers/toConsumableArray":"inIie","memoize-one":"ca891","@babel/runtime/helpers/typeof":"8oq3j","@babel/runtime/helpers/taggedTemplateLiteral":"ejLIB","@babel/runtime/helpers/defineProperty":"ibVzI","react-dom":"82aNB","@floating-ui/dom":"3J4Yg","use-isomorphic-layout-effect":"aB0wL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7wMmn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useStateManager);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/slicedToArray":"bem4D","@babel/runtime/helpers/esm/objectWithoutProperties":"dRtLA","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bem4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(r, e) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayLimitJsDefault.default)(r, e) || (0, _unsupportedIterableToArrayJsDefault.default)(r, e) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"6HY0K","./iterableToArrayLimit.js":"eqjO6","./unsupportedIterableToArray.js":"cL2qX","./nonIterableRest.js":"g4mey","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6HY0K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eqjO6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cL2qX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"9oYS4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9oYS4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g4mey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRtLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutProperties);
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = (0, _objectWithoutPropertiesLooseJsDefault.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

},{"./objectWithoutPropertiesLoose.js":"ds1mq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"daMXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Select);
parcelHelpers.export(exports, "a", ()=>defaultProps);
parcelHelpers.export(exports, "b", ()=>getOptionLabel$1);
parcelHelpers.export(exports, "c", ()=>createFilter);
parcelHelpers.export(exports, "d", ()=>defaultTheme);
parcelHelpers.export(exports, "g", ()=>getOptionValue$1);
parcelHelpers.export(exports, "m", ()=>mergeStyles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, _objectSpread2Default.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, _react1.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, _react1.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)(A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, _react1.jsx)(A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp('[' + diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, _objectSpread2Default.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var _excluded = [
    "innerRef"
];
function DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, _index641Ee5B8EsmJs.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _index641Ee5B8EsmJs.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _react.Fragment), null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2$1
    }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, _react1.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: _ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var RequiredInput$1 = RequiredInput;
/// <reference types="user-agent-data-types" />
function testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _index641Ee5B8EsmJs.a),
    container: (0, _index641Ee5B8EsmJs.b),
    control: (0, _index641Ee5B8EsmJs.d),
    dropdownIndicator: (0, _index641Ee5B8EsmJs.e),
    group: (0, _index641Ee5B8EsmJs.g),
    groupHeading: (0, _index641Ee5B8EsmJs.f),
    indicatorsContainer: (0, _index641Ee5B8EsmJs.i),
    indicatorSeparator: (0, _index641Ee5B8EsmJs.h),
    input: (0, _index641Ee5B8EsmJs.j),
    loadingIndicator: (0, _index641Ee5B8EsmJs.l),
    loadingMessage: (0, _index641Ee5B8EsmJs.k),
    menu: (0, _index641Ee5B8EsmJs.m),
    menuList: (0, _index641Ee5B8EsmJs.n),
    menuPortal: (0, _index641Ee5B8EsmJs.o),
    multiValue: (0, _index641Ee5B8EsmJs.p),
    multiValueLabel: (0, _index641Ee5B8EsmJs.q),
    multiValueRemove: (0, _index641Ee5B8EsmJs.t),
    noOptionsMessage: (0, _index641Ee5B8EsmJs.u),
    option: (0, _index641Ee5B8EsmJs.v),
    placeholder: (0, _index641Ee5B8EsmJs.w),
    singleValue: (0, _index641Ee5B8EsmJs.x),
    valueContainer: (0, _index641Ee5B8EsmJs.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _objectSpread2Default.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _index641Ee5B8EsmJs.z)(),
    captureMenuScroll: !(0, _index641Ee5B8EsmJs.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _index641Ee5B8EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, _index641Ee5B8EsmJs.K));
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _createSuperDefault.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _index641Ee5B8EsmJs.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _index641Ee5B8EsmJs.B)([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, _index641Ee5B8EsmJs.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, _index641Ee5B8EsmJs.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _index641Ee5B8EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _index641Ee5B8EsmJs.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _index641Ee5B8EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _index641Ee5B8EsmJs.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _index641Ee5B8EsmJs.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread2Default.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, _index641Ee5B8EsmJs.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _index641Ee5B8EsmJs.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, _index641Ee5B8EsmJs.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _index641Ee5B8EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return defaultTheme;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme(defaultTheme);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ _react.createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _index641Ee5B8EsmJs.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ _react.createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ _react.createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ _react.createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ _react.createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ _react.createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ _react.createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ _react.createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ _react.createElement((0, _index641Ee5B8EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ _react.createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ _react.createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ _react.createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ _react.createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ _react.createElement(RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ _react.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ _react.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ _react.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ _react.createElement(LiveRegion$1, (0, _extendsDefault.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ _react.createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ _react.createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ _react.createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ _react.createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _index641Ee5B8EsmJs.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _index641Ee5B8EsmJs.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/inherits":"9qeOz","@babel/runtime/helpers/esm/createSuper":"4Z7nH","@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","./index-641ee5b8.esm.js":"cQBRQ","@emotion/react":"3ILVC","memoize-one":"ca891","@babel/runtime/helpers/esm/objectWithoutProperties":"dRtLA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1eYFn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89Fc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"awXxm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9qeOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"9xLGZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Z7nH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"39SJu","./isNativeReflectConstruct.js":"iMk6t","./possibleConstructorReturn.js":"h1JP8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39SJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMk6t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h1JP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"8oq3j","./assertThisInitialized.js":"9WIi6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9WIi6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"inIie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"7Gi0e","./iterableToArray.js":"aiqkl","./unsupportedIterableToArray.js":"cL2qX","./nonIterableSpread.js":"7hnyW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Gi0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"9oYS4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aiqkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hnyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cQBRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>isMobileDevice);
parcelHelpers.export(exports, "B", ()=>multiValueAsValue);
parcelHelpers.export(exports, "C", ()=>singleValueAsValue);
parcelHelpers.export(exports, "D", ()=>valueTernary);
parcelHelpers.export(exports, "E", ()=>classNames);
parcelHelpers.export(exports, "F", ()=>defaultComponents);
parcelHelpers.export(exports, "G", ()=>isDocumentElement);
parcelHelpers.export(exports, "H", ()=>cleanValue);
parcelHelpers.export(exports, "I", ()=>scrollIntoView);
parcelHelpers.export(exports, "J", ()=>noop);
parcelHelpers.export(exports, "K", ()=>notNullish);
parcelHelpers.export(exports, "L", ()=>handleInputChange);
parcelHelpers.export(exports, "M", ()=>MenuPlacer);
parcelHelpers.export(exports, "a", ()=>clearIndicatorCSS);
parcelHelpers.export(exports, "b", ()=>containerCSS);
parcelHelpers.export(exports, "c", ()=>components);
parcelHelpers.export(exports, "d", ()=>css$1);
parcelHelpers.export(exports, "e", ()=>dropdownIndicatorCSS);
parcelHelpers.export(exports, "f", ()=>groupHeadingCSS);
parcelHelpers.export(exports, "g", ()=>groupCSS);
parcelHelpers.export(exports, "h", ()=>indicatorSeparatorCSS);
parcelHelpers.export(exports, "i", ()=>indicatorsContainerCSS);
parcelHelpers.export(exports, "j", ()=>inputCSS);
parcelHelpers.export(exports, "k", ()=>loadingMessageCSS);
parcelHelpers.export(exports, "l", ()=>loadingIndicatorCSS);
parcelHelpers.export(exports, "m", ()=>menuCSS);
parcelHelpers.export(exports, "n", ()=>menuListCSS);
parcelHelpers.export(exports, "o", ()=>menuPortalCSS);
parcelHelpers.export(exports, "p", ()=>multiValueCSS);
parcelHelpers.export(exports, "q", ()=>multiValueLabelCSS);
parcelHelpers.export(exports, "r", ()=>removeProps);
parcelHelpers.export(exports, "s", ()=>supportsPassiveEvents);
parcelHelpers.export(exports, "t", ()=>multiValueRemoveCSS);
parcelHelpers.export(exports, "u", ()=>noOptionsMessageCSS);
parcelHelpers.export(exports, "v", ()=>optionCSS);
parcelHelpers.export(exports, "w", ()=>placeholderCSS);
parcelHelpers.export(exports, "x", ()=>css);
parcelHelpers.export(exports, "y", ()=>valueContainerCSS);
parcelHelpers.export(exports, "z", ()=>isTouchCapable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded$4);
    return (0, _objectSpread2Default.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener('p', noop, options);
    w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
    return item != null;
}
function isArray(arg) {
    return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
    return singleValue;
}
function multiValueAsValue(multiValue) {
    return multiValue;
}
var removeProps = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, _slicedToArrayDefault.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var _excluded$3 = [
    "children",
    "innerProps"
], _excluded2$1 = [
    "children",
    "innerProps"
];
function getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, _objectSpread2Default.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, _definePropertyDefault.default)(_objectSpread2, alignToControl(placement), '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "position", 'absolute'), (0, _definePropertyDefault.default)(_objectSpread2, "width", '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)(null);
// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, _react1.useContext)(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, _react1.useRef)(null);
    var _useState = (0, _react1.useState)(maxMenuHeight), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, _react1.useState)(null), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var Menu$1 = Menu;
// ==============================
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, _objectSpread2Default.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded$3);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, _react1.useRef)(null);
    var cleanupRef = (0, _react1.useRef)(null);
    var _useState5 = (0, _react1.useState)(coercePlacement(menuPlacement)), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, _react1.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, _react1.useState)(null), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, _react1.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react1.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react1.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: setMenuPortalElement
    }, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, _react.jsx)(PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var _templateObject;
var _excluded$2 = [
    "size"
], _excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, _react.jsx)(CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var css$1 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef
    }, getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var Control$1 = Control;
var _excluded$1 = [
    "data"
];
var groupCSS = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var Group$1 = Group;
var _excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var inputCSS = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, _objectSpread2Default.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
    return (0, _objectSpread2Default.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, spacingStyle);
};
var Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, _objectSpread2Default.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        role: "button"
    }, innerProps), children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)(Container, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, _react.jsx)(Label, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, _react.jsx)(Remove, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control$1,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group$1,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input$1,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu$1,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue$1,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder$1,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue$1,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, components), props.components);
};

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/extends":"85Hd3","@emotion/react":"3ILVC","@babel/runtime/helpers/esm/slicedToArray":"bem4D","@babel/runtime/helpers/esm/objectWithoutProperties":"dRtLA","@babel/runtime/helpers/esm/typeof":"8oq3j","@babel/runtime/helpers/esm/taggedTemplateLiteral":"ejLIB","@babel/runtime/helpers/esm/defineProperty":"ibVzI","react":"bmhQu","react-dom":"82aNB","@floating-ui/dom":"3J4Yg","use-isomorphic-layout-effect":"aB0wL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ILVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElement5486C51CBrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElement5486C51CBrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElement5486C51CBrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElement5486C51CBrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElement5486C51CBrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElement5486C51CBrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElement5486C51CBrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElement5486C51CBrowserEsmJs = require("./emotion-element-5486c51c.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement5486C51CBrowserEsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement5486C51CBrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement5486C51CBrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElement5486C51CBrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElement5486C51CBrowserEsmJs.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function css() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var keyframes = function /*: Keyframes */ keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var ClassNames = /* #__PURE__ */ (0, _emotionElement5486C51CBrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElement5486C51CBrowserEsmJs.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElement5486C51CBrowserEsmJs.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElement5486C51CBrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"./emotion-element-5486c51c.browser.esm.js":"dPCWO","react":"bmhQu","@emotion/utils":"aIfq9","@emotion/use-insertion-effect-with-fallbacks":"claft","@emotion/serialize":"h6Euq","@emotion/cache":"csFJU","@babel/runtime/helpers/extends":"85Hd3","@emotion/weak-memoize":"beW73","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"iAzdo","hoist-non-react-statics":"ldTzE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dPCWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isDevelopment);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
/* import { type EmotionCache } from '@emotion/utils' */ var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== 'css' && key !== typePropName && !isDevelopment) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"bmhQu","@emotion/cache":"csFJU","@babel/runtime/helpers/esm/extends":"85Hd3","@emotion/weak-memoize":"beW73","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"iAzdo","@emotion/utils":"aIfq9","@emotion/serialize":"h6Euq","@emotion/use-insertion-effect-with-fallbacks":"claft","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"csFJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"7JZko","stylis":"cHz0a","@emotion/weak-memoize":"beW73","@emotion/memoize":"kMK0P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7JZko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cHz0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumJs = require("./src/Enum.js");
parcelHelpers.exportAll(_enumJs, exports);
var _utilityJs = require("./src/Utility.js");
parcelHelpers.exportAll(_utilityJs, exports);
var _parserJs = require("./src/Parser.js");
parcelHelpers.exportAll(_parserJs, exports);
var _prefixerJs = require("./src/Prefixer.js");
parcelHelpers.exportAll(_prefixerJs, exports);
var _tokenizerJs = require("./src/Tokenizer.js");
parcelHelpers.exportAll(_tokenizerJs, exports);
var _serializerJs = require("./src/Serializer.js");
parcelHelpers.exportAll(_serializerJs, exports);
var _middlewareJs = require("./src/Middleware.js");
parcelHelpers.exportAll(_middlewareJs, exports);

},{"./src/Enum.js":"jhnTg","./src/Utility.js":"czbcq","./src/Parser.js":"d6r8d","./src/Prefixer.js":false,"./src/Tokenizer.js":"fzUtK","./src/Serializer.js":"bHQnz","./src/Middleware.js":"1Ywxn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jhnTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MS", ()=>MS);
parcelHelpers.export(exports, "MOZ", ()=>MOZ);
parcelHelpers.export(exports, "WEBKIT", ()=>WEBKIT);
parcelHelpers.export(exports, "COMMENT", ()=>COMMENT);
parcelHelpers.export(exports, "RULESET", ()=>RULESET);
parcelHelpers.export(exports, "DECLARATION", ()=>DECLARATION);
parcelHelpers.export(exports, "PAGE", ()=>PAGE);
parcelHelpers.export(exports, "MEDIA", ()=>MEDIA);
parcelHelpers.export(exports, "IMPORT", ()=>IMPORT);
parcelHelpers.export(exports, "CHARSET", ()=>CHARSET);
parcelHelpers.export(exports, "VIEWPORT", ()=>VIEWPORT);
parcelHelpers.export(exports, "SUPPORTS", ()=>SUPPORTS);
parcelHelpers.export(exports, "DOCUMENT", ()=>DOCUMENT);
parcelHelpers.export(exports, "NAMESPACE", ()=>NAMESPACE);
parcelHelpers.export(exports, "KEYFRAMES", ()=>KEYFRAMES);
parcelHelpers.export(exports, "FONT_FACE", ()=>FONT_FACE);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>COUNTER_STYLE);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>FONT_FEATURE_VALUES);
parcelHelpers.export(exports, "LAYER", ()=>LAYER);
var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';
var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var PAGE = '@page';
var MEDIA = '@media';
var IMPORT = '@import';
var CHARSET = '@charset';
var VIEWPORT = '@viewport';
var SUPPORTS = '@supports';
var DOCUMENT = '@document';
var NAMESPACE = '@namespace';
var KEYFRAMES = '@keyframes';
var FONT_FACE = '@font-face';
var COUNTER_STYLE = '@counter-style';
var FONT_FEATURE_VALUES = '@font-feature-values';
var LAYER = '@layer';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"czbcq":[function(require,module,exports,__globalThis) {
/**
 * @param {number}
 * @return {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "from", ()=>from);
parcelHelpers.export(exports, "assign", ()=>assign);
/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */ parcelHelpers.export(exports, "hash", ()=>hash);
/**
 * @param {string} value
 * @return {string}
 */ parcelHelpers.export(exports, "trim", ()=>trim);
/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */ parcelHelpers.export(exports, "match", ()=>match);
/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */ parcelHelpers.export(exports, "replace", ()=>replace);
/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */ parcelHelpers.export(exports, "indexof", ()=>indexof);
/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */ parcelHelpers.export(exports, "charat", ()=>charat);
/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */ parcelHelpers.export(exports, "substr", ()=>substr);
/**
 * @param {string} value
 * @return {number}
 */ parcelHelpers.export(exports, "strlen", ()=>strlen);
/**
 * @param {any[]} value
 * @return {number}
 */ parcelHelpers.export(exports, "sizeof", ()=>sizeof);
/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */ parcelHelpers.export(exports, "append", ()=>append);
/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "combine", ()=>combine);
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length) {
    return charat(value, 0) ^ 45 ? (((length << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
    return value.trim();
}
function match(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function indexof(value, search) {
    return value.indexOf(search);
}
function charat(value, index) {
    return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
    return value.slice(begin, end);
}
function strlen(value) {
    return value.length;
}
function sizeof(value) {
    return value.length;
}
function append(value, array) {
    return array.push(value), value;
}
function combine(array, callback) {
    return array.map(callback).join('');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d6r8d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} value
 * @return {object[]}
 */ parcelHelpers.export(exports, "compile", ()=>compile);
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */ parcelHelpers.export(exports, "ruleset", ()=>ruleset);
/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */ parcelHelpers.export(exports, "comment", ()=>comment);
/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */ parcelHelpers.export(exports, "declaration", ()=>declaration);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
var _tokenizerJs = require("./Tokenizer.js");
function compile(value) {
    return (0, _tokenizerJs.dealloc)(parse('', null, null, null, [
        ''
    ], value = (0, _tokenizerJs.alloc)(value), 0, [
        0
    ], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, _tokenizerJs.next)()){
        // (
        case 40:
            if (previous != 108 && (0, _utilityJs.charat)(characters, length - 1) == 58) {
                if ((0, _utilityJs.indexof)(characters += (0, _utilityJs.replace)((0, _tokenizerJs.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, _tokenizerJs.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, _tokenizerJs.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, _tokenizerJs.escaping)((0, _tokenizerJs.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, _tokenizerJs.peek)()){
                case 42:
                case 47:
                    (0, _utilityJs.append)(comment((0, _tokenizerJs.commenter)((0, _tokenizerJs.next)(), (0, _tokenizerJs.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, _utilityJs.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, _utilityJs.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, _utilityJs.strlen)(characters) - length) (0, _utilityJs.append)(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration((0, _utilityJs.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, _utilityJs.append)(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) parse(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, _utilityJs.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                parse(value, reference, reference, rule && (0, _utilityJs.append)(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                parse(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, _utilityJs.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, _tokenizerJs.prev)() == 125) continue;
            }
            switch(characters += (0, _utilityJs.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, _utilityJs.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, _tokenizerJs.peek)() === 45) characters += (0, _tokenizerJs.delimit)((0, _tokenizerJs.next)());
                    atrule = (0, _tokenizerJs.peek)(), offset = length = (0, _utilityJs.strlen)(type = characters += (0, _tokenizerJs.identifier)((0, _tokenizerJs.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, _utilityJs.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, _utilityJs.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, _utilityJs.substr)(value, post + 1, post = (0, _utilityJs.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, _utilityJs.trim)(j > 0 ? rule[x] + ' ' + y : (0, _utilityJs.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, _tokenizerJs.node)(value, root, parent, offset === 0 ? (0, _enumJs.RULESET) : type, props, children, length);
}
function comment(value, root, parent) {
    return (0, _tokenizerJs.node)(value, root, parent, (0, _enumJs.COMMENT), (0, _utilityJs.from)((0, _tokenizerJs.char)()), (0, _utilityJs.substr)(value, 2, -2), 0);
}
function declaration(value, root, parent, length) {
    return (0, _tokenizerJs.node)(value, root, parent, (0, _enumJs.DECLARATION), (0, _utilityJs.substr)(value, 0, length), (0, _utilityJs.substr)(value, length + 1, -1), length);
}

},{"./Enum.js":"jhnTg","./Utility.js":"czbcq","./Tokenizer.js":"fzUtK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fzUtK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "line", ()=>line);
parcelHelpers.export(exports, "column", ()=>column);
parcelHelpers.export(exports, "length", ()=>length);
parcelHelpers.export(exports, "position", ()=>position);
parcelHelpers.export(exports, "character", ()=>character);
parcelHelpers.export(exports, "characters", ()=>characters);
/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */ parcelHelpers.export(exports, "node", ()=>node);
/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */ parcelHelpers.export(exports, "copy", ()=>copy);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "char", ()=>char);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "prev", ()=>prev);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "next", ()=>next);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "peek", ()=>peek);
/**
 * @return {number}
 */ parcelHelpers.export(exports, "caret", ()=>caret);
/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */ parcelHelpers.export(exports, "slice", ()=>slice);
/**
 * @param {number} type
 * @return {number}
 */ parcelHelpers.export(exports, "token", ()=>token);
/**
 * @param {string} value
 * @return {any[]}
 */ parcelHelpers.export(exports, "alloc", ()=>alloc);
/**
 * @param {any} value
 * @return {any}
 */ parcelHelpers.export(exports, "dealloc", ()=>dealloc);
/**
 * @param {number} type
 * @return {string}
 */ parcelHelpers.export(exports, "delimit", ()=>delimit);
/**
 * @param {string} value
 * @return {string[]}
 */ parcelHelpers.export(exports, "tokenize", ()=>tokenize);
/**
 * @param {number} type
 * @return {string}
 */ parcelHelpers.export(exports, "whitespace", ()=>whitespace);
/**
 * @param {string[]} children
 * @return {string[]}
 */ parcelHelpers.export(exports, "tokenizer", ()=>tokenizer);
/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */ parcelHelpers.export(exports, "escaping", ()=>escaping);
/**
 * @param {number} type
 * @return {number}
 */ parcelHelpers.export(exports, "delimiter", ()=>delimiter);
/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */ parcelHelpers.export(exports, "commenter", ()=>commenter);
/**
 * @param {number} index
 * @return {string}
 */ parcelHelpers.export(exports, "identifier", ()=>identifier);
var _utilityJs = require("./Utility.js");
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';
function node(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: line,
        column: column,
        length: length,
        return: ''
    };
}
function copy(root, props) {
    return (0, _utilityJs.assign)(node('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function char() {
    return character;
}
function prev() {
    character = position > 0 ? (0, _utilityJs.charat)(characters, --position) : 0;
    if (column--, character === 10) column = 1, line--;
    return character;
}
function next() {
    character = position < length ? (0, _utilityJs.charat)(characters, position++) : 0;
    if (column++, character === 10) column = 1, line++;
    return character;
}
function peek() {
    return (0, _utilityJs.charat)(characters, position);
}
function caret() {
    return position;
}
function slice(begin, end) {
    return (0, _utilityJs.substr)(characters, begin, end);
}
function token(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function alloc(value) {
    return line = column = 1, length = (0, _utilityJs.strlen)(characters = value), position = 0, [];
}
function dealloc(value) {
    return characters = '', value;
}
function delimit(type) {
    return (0, _utilityJs.trim)(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function tokenize(value) {
    return dealloc(tokenizer(alloc(value)));
}
function whitespace(type) {
    while(character = peek())if (character < 33) next();
    else break;
    return token(type) > 2 || token(character) > 3 ? '' : ' ';
}
function tokenizer(children) {
    while(next())switch(token(character)){
        case 0:
            (0, _utilityJs.append)(identifier(position - 1), children);
            break;
        case 2:
            (0, _utilityJs.append)(delimit(character), children);
            break;
        default:
            (0, _utilityJs.append)((0, _utilityJs.from)(character), children);
    }
    return children;
}
function escaping(index, count) {
    while(--count && next())// not 0-9 A-F a-f
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
    return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
    while(next())switch(character){
        // ] ) " '
        case type:
            return position;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) delimiter(character);
            break;
        // (
        case 40:
            if (type === 41) delimiter(type);
            break;
        // \
        case 92:
            next();
            break;
    }
    return position;
}
function commenter(type, index) {
    while(next())// //
    if (type + character === 57) break;
    else if (type + character === 84 && peek() === 47) break;
    return '/*' + slice(index, position - 1) + '*' + (0, _utilityJs.from)(type === 47 ? type : next());
}
function identifier(index) {
    while(!token(peek()))next();
    return slice(index, position);
}

},{"./Utility.js":"czbcq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lmHa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {string} value
 * @param {number} length
 * @param {object[]} children
 * @return {string}
 */ parcelHelpers.export(exports, "prefix", ()=>prefix);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
function prefix(value, length, children) {
    switch((0, _utilityJs.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _enumJs.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _enumJs.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, _enumJs.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MOZ) + value + (0, _enumJs.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, _utilityJs.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + value + value;
        // order
        case 6165:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _enumJs.WEBKIT) + value + (0, _utilityJs.replace)(value, /(\w+).+(:[^]+)/, (0, _enumJs.WEBKIT) + 'box-$1$2' + (0, _enumJs.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-item-' + (0, _utilityJs.replace)(value, /flex-|-self/g, '') + (!(0, _utilityJs.match)(value, /flex-|baseline/) ? (0, _enumJs.MS) + 'grid-row-' + (0, _utilityJs.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + 'flex-line-pack' + (0, _utilityJs.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _enumJs.WEBKIT) + 'box-' + (0, _utilityJs.replace)(value, '-grow', '') + (0, _enumJs.WEBKIT) + value + (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _enumJs.WEBKIT) + (0, _utilityJs.replace)(value, /([^-])(transform)/g, '$1' + (0, _enumJs.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _utilityJs.replace)((0, _utilityJs.replace)((0, _utilityJs.replace)(value, /(zoom-|grab)/, (0, _enumJs.WEBKIT) + '$1'), /(image-set)/, (0, _enumJs.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _utilityJs.replace)(value, /(image-set\([^]*)/, (0, _enumJs.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _utilityJs.replace)((0, _utilityJs.replace)(value, /(.+:)(flex-)?(.*)/, (0, _enumJs.WEBKIT) + 'box-pack:$3' + (0, _enumJs.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _enumJs.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, _utilityJs.match)(value, /flex-|baseline/)) return (0, _enumJs.MS) + 'grid-column-align' + (0, _utilityJs.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, _enumJs.MS) + (0, _utilityJs.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, _utilityJs.match)(element.props, /grid-\w+-end/);
            })) return ~(0, _utilityJs.indexof)(value + (children = children[length].value), 'span') ? value : (0, _enumJs.MS) + (0, _utilityJs.replace)(value, '-start', '') + value + (0, _enumJs.MS) + 'grid-row-span:' + (~(0, _utilityJs.indexof)(children, 'span') ? (0, _utilityJs.match)(children, /\d+/) : +(0, _utilityJs.match)(children, /\d+/) - +(0, _utilityJs.match)(value, /\d+/)) + ';';
            return (0, _enumJs.MS) + (0, _utilityJs.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, _utilityJs.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, _enumJs.MS) + (0, _utilityJs.replace)((0, _utilityJs.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _utilityJs.replace)(value, /(.+)-inline(.+)/, (0, _enumJs.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _utilityJs.strlen)(value) - 1 - length > 6) switch((0, _utilityJs.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _utilityJs.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _utilityJs.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _enumJs.WEBKIT) + '$2-$3' + '$1' + (0, _enumJs.MOZ) + ((0, _utilityJs.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _utilityJs.indexof)(value, 'stretch') ? prefix((0, _utilityJs.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, _utilityJs.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, _enumJs.MS) + a + ':' + b + f + (c ? (0, _enumJs.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, _utilityJs.charat)(value, length + 6) === 121) return (0, _utilityJs.replace)(value, ':', ':' + (0, _enumJs.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, _utilityJs.charat)(value, (0, _utilityJs.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, _utilityJs.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, _enumJs.WEBKIT) + ((0, _utilityJs.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _enumJs.WEBKIT) + '$2$3' + '$1' + (0, _enumJs.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, _utilityJs.replace)(value, ':', ':' + (0, _enumJs.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, _utilityJs.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

},{"./Enum.js":"jhnTg","./Utility.js":"czbcq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bHQnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "serialize", ()=>serialize);
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */ parcelHelpers.export(exports, "stringify", ()=>stringify);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
function serialize(children, callback) {
    var output = '';
    var length = (0, _utilityJs.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function stringify(element, index, children, callback) {
    switch(element.type){
        case 0, _enumJs.LAYER:
            if (element.children.length) break;
        case 0, _enumJs.IMPORT:
        case 0, _enumJs.DECLARATION:
            return element.return = element.return || element.value;
        case 0, _enumJs.COMMENT:
            return '';
        case 0, _enumJs.KEYFRAMES:
            return element.return = element.value + '{' + serialize(element.children, callback) + '}';
        case 0, _enumJs.RULESET:
            element.value = element.props.join(',');
    }
    return (0, _utilityJs.strlen)(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

},{"./Enum.js":"jhnTg","./Utility.js":"czbcq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Ywxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {function[]} collection
 * @return {function}
 */ parcelHelpers.export(exports, "middleware", ()=>middleware);
/**
 * @param {function} callback
 * @return {function}
 */ parcelHelpers.export(exports, "rulesheet", ()=>rulesheet);
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */ parcelHelpers.export(exports, "prefixer", ()=>prefixer);
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */ parcelHelpers.export(exports, "namespace", ()=>namespace);
var _enumJs = require("./Enum.js");
var _utilityJs = require("./Utility.js");
var _tokenizerJs = require("./Tokenizer.js");
var _serializerJs = require("./Serializer.js");
var _prefixerJs = require("./Prefixer.js");
function middleware(collection) {
    var length = (0, _utilityJs.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function rulesheet(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, _enumJs.DECLARATION:
                element.return = (0, _prefixerJs.prefix)(element.value, element.length, children);
                return;
            case 0, _enumJs.KEYFRAMES:
                return (0, _serializerJs.serialize)([
                    (0, _tokenizerJs.copy)(element, {
                        value: (0, _utilityJs.replace)(element.value, '@', '@' + (0, _enumJs.WEBKIT))
                    })
                ], callback);
            case 0, _enumJs.RULESET:
                if (element.length) return (0, _utilityJs.combine)(element.props, function(value) {
                    switch((0, _utilityJs.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _serializerJs.serialize)([
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(read-\w+)/, ':' + (0, _enumJs.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _serializerJs.serialize)([
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, ':' + (0, _enumJs.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, ':' + (0, _enumJs.MOZ) + '$1')
                                    ]
                                }),
                                (0, _tokenizerJs.copy)(element, {
                                    props: [
                                        (0, _utilityJs.replace)(value, /:(plac\w+)/, (0, _enumJs.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function namespace(element) {
    switch(element.type){
        case 0, _enumJs.RULESET:
            element.props = element.props.map(function(value) {
                return (0, _utilityJs.combine)((0, _tokenizerJs.tokenize)(value), function(value, index, children) {
                    switch((0, _utilityJs.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, _utilityJs.substr)(value, 1, (0, _utilityJs.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, _utilityJs.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, _utilityJs.sizeof)(children) > 1 ? '' : value;
                                case index = (0, _utilityJs.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

},{"./Enum.js":"jhnTg","./Utility.js":"czbcq","./Tokenizer.js":"fzUtK","./Serializer.js":"bHQnz","./Prefixer.js":"lmHa6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"beW73":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMK0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iAzdo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"ldTzE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aIfq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h6Euq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"56EYe","@emotion/unitless":"fosl3","@emotion/memoize":"kMK0P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"56EYe":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fosl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"claft":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ejLIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_taggedTemplateLiteral);
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3J4Yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left, top, width, height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"li54S","@floating-ui/utils":"5MNGj","@floating-ui/utils/dom":"aCCJF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"li54S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"5MNGj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5MNGj":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    return [
        'top',
        'bottom'
    ].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aCCJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].includes(getNodeName(element));
}
function isTopLayer(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function isContainingBlock(elementOrCss) {
    const webkit = isWebKit();
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aB0wL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ca891":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoizeOne);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"77ZrV":[function(require,module,exports,__globalThis) {
/**
 * User authentication data stored in localStorage
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveAuthToLocalStorage", ()=>saveAuthToLocalStorage);
parcelHelpers.export(exports, "getAuthFromLocalStorage", ()=>getAuthFromLocalStorage);
parcelHelpers.export(exports, "clearAuthFromLocalStorage", ()=>clearAuthFromLocalStorage);
const AUTH_KEY = 'vega_editor_auth_data';
const saveAuthToLocalStorage = (data)=>{
    localStorage.setItem(AUTH_KEY, JSON.stringify(data));
};
const getAuthFromLocalStorage = ()=>{
    const data = localStorage.getItem(AUTH_KEY);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (e) {
        console.error('Failed to parse auth data from localStorage', e);
        return null;
    }
};
const clearAuthFromLocalStorage = ()=>{
    localStorage.removeItem(AUTH_KEY);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9VdfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
var _reactRedux = require("react-redux");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        baseURL: state.baseURL,
        config: state.config,
        editorString: state.editorString,
        mode: state.mode,
        vegaLiteSpec: state.vegaLiteSpec,
        vegaSpec: state.vegaSpec,
        view: state.view
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","./renderer.js":"4v22f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4v22f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _react = require("react");
var _reactFeather = require("react-feather");
var _reactRouterDom = require("react-router-dom");
var _vega = require("vega");
var _vegaEmbed = require("vega-embed");
var _vegaLite = require("vega-lite");
var _constsJs = require("../../../constants/consts.js");
var _indexCss = require("./index.css");
class ExportModal extends _react.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            downloadVegaJSON: false,
            includeConfig: true,
            loadingPDF: false,
            errorLoadingPdf: null
        };
    }
    async downloadViz(ext) {
        const url = await this.props.view.toImageURL(ext, 2);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('target', '_blank');
        link.setAttribute('download', `visualization.${ext}`);
        link.dispatchEvent(new MouseEvent('click'));
    }
    async openViz(ext) {
        const url = await this.props.view.toImageURL(ext);
        const tab = window.open('about:blank', '_blank');
        tab.document.write(`<title>Chart</title><img src="${url}" />`);
        tab.document.close();
    }
    async downloadPDF() {
        this.setState({
            loadingPDF: true
        });
        const isVega = this.props.mode === (0, _constsJs.Mode).Vega;
        const spec = isVega ? this.props.vegaSpec : this.props.vegaLiteSpec;
        const pdf = await fetch(`https://vl-convert.vercel.app/api/${isVega ? 'vg' : 'vl'}2pdf/?baseURL=${this.props.baseURL}`, {
            body: JSON.stringify(spec),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/pdf'
            },
            method: 'post',
            mode: 'cors'
        });
        if (!pdf.ok) {
            console.error('Error loading PDF', pdf);
            this.setState({
                loadingPDF: false,
                errorLoadingPdf: pdf.statusText || `Unknown error (code ${pdf.status})`
            });
            return;
        }
        this.setState({
            loadingPDF: false,
            errorLoadingPdf: null
        });
        const blob = await pdf.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('target', '_blank');
        link.setAttribute('download', `visualization.pdf`);
        link.dispatchEvent(new MouseEvent('click'));
    }
    updateIncludeConfig(e) {
        this.setState({
            includeConfig: e.target.checked
        });
    }
    downloadJSON(event) {
        if (event.target?.matches(`input`) || event.target?.matches(`label`) || event.target?.matches(`div.type-input-container`)) return;
        let content;
        let filename;
        if (this.props.mode === (0, _constsJs.Mode).Vega) {
            content = this.props.vegaSpec;
            filename = `visualization.vg.json`;
        } else {
            content = this.state.downloadVegaJSON ? this.props.vegaSpec : this.props.vegaLiteSpec;
            filename = this.state.downloadVegaJSON ? `visualization.vg.json` : `visualization.vl.json`;
        }
        if (this.state.includeConfig && this.props.config) {
            content = {
                ...content
            };
            content.config = (0, _vega.mergeConfig)({}, this.props.config, content.config);
        }
        const blob = new Blob([
            (0, _jsonStringifyPrettyCompactDefault.default)(content)
        ], {
            type: `application/json`
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement(`a`);
        link.setAttribute(`href`, url);
        link.setAttribute(`target`, `_blank`);
        link.setAttribute(`download`, filename);
        link.dispatchEvent(new MouseEvent(`click`));
    }
    updateDownloadJSONType(event) {
        this.setState({
            downloadVegaJSON: event.currentTarget.value === 'vega'
        });
    }
    downloadHTML() {
        const { mode, vegaSpec, vegaLiteSpec, config } = this.props;
        let content = mode === (0, _constsJs.Mode).Vega ? vegaSpec : vegaLiteSpec;
        if (config) {
            content = {
                ...content
            };
            content.config = (0, _vega.mergeConfig)({}, config, content.config);
        }
        const htmlTemplate = `<!DOCTYPE html>
<html>
<head>
  <script src="https://cdn.jsdelivr.net/npm/vega@${(0, _vega.version)}"></script>
  <script src="https://cdn.jsdelivr.net/npm/vega-lite@${(0, _vegaLite.version)}"></script>
  <script src="https://cdn.jsdelivr.net/npm/vega-embed@${(0, _vegaEmbed.version)}"></script>
</head>
<body>
  <div id="vis"/>
  <script>
    const spec = ${(0, _jsonStringifyPrettyCompactDefault.default)(content)};
    vegaEmbed("#vis", spec, {mode: "${mode}"}).then(console.log).catch(console.warn);
  </script>
</body>
</html>`;
        const blob = new Blob([
            htmlTemplate
        ], {
            type: `text/html;charset=utf-8`
        });
        const link = document.createElement(`a`);
        link.setAttribute(`href`, window.URL.createObjectURL(blob));
        link.setAttribute(`target`, `_blank`);
        link.setAttribute(`download`, 'visualization.html');
        link.dispatchEvent(new MouseEvent(`click`));
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Export"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "exports",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "export-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Image), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "PNG"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "PNG is a bitmap image format which is made up of a fixed number of pixels."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>this.downloadViz('png'),
                                    children: "Download "
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "export-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Code), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "JSON"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "JSON is a lightweight data-interchange format."
                                }),
                                this.props.mode === (0, _constsJs.Mode).VegaLite && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "input-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "radio",
                                                    name: "json-type",
                                                    id: "json-type[vega]",
                                                    value: "vega",
                                                    checked: this.state.downloadVegaJSON,
                                                    onChange: this.updateDownloadJSONType.bind(this)
                                                }),
                                                ' ',
                                                "Compiled Vega"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            htmlFor: "json-type[vega-lite]",
                                            className: "vl-label",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "radio",
                                                    name: "json-type",
                                                    id: "json-type[vega-lite]",
                                                    value: "vega-lite",
                                                    checked: !this.state.downloadVegaJSON,
                                                    onChange: this.updateDownloadJSONType.bind(this)
                                                }),
                                                "Vega-Lite"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "input-container",
                                    children: this.state.downloadVegaJSON ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "The compiled Vega includes the config and is formatted."
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "config-include",
                                                        id: "config-include",
                                                        value: "config-select",
                                                        checked: this.state.includeConfig,
                                                        onChange: this.updateIncludeConfig.bind(this)
                                                    }),
                                                    "Include config"
                                                ]
                                            }),
                                            this.state.includeConfig && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: "The downloaded spec will be formatted. "
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: (e)=>this.downloadJSON(e),
                                    children: "Download"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "export-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Map), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "SVG"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: "SVG is a vector image format which uses geometric forms to represent different parts as discrete objects and are infinitely scalable."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>this.openViz('svg'),
                                    children: "Open"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>this.downloadViz('svg'),
                                    className: "export-button download",
                                    children: "Download"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "export-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Book), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "PDF"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        " PDF is a vector format usually used for documents. This might take a few seconds. Please be patient. Use absolute URLs to data or ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://github.com/vega/vega-datasets",
                                            children: "Vega datasets"
                                        }),
                                        " at",
                                        ' ',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                            children: "/data/..."
                                        }),
                                        ". Your chart is sent to",
                                        ' ',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://github.com/vega/vl-convert",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: "vl-convert.vercel.app"
                                        }),
                                        ' ',
                                        "for rendering."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>this.downloadPDF(),
                                    disabled: this.state.loadingPDF,
                                    children: this.state.loadingPDF ? 'Downloading...' : 'Download'
                                }),
                                this.state.errorLoadingPdf && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    style: {
                                        color: 'red'
                                    },
                                    children: [
                                        "Render service failed with error: ",
                                        this.state.errorLoadingPdf,
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "export-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.BookOpen), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "HTML"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        " HTML is a document format to be displayed in a browser. Your chart is embedded in the downloaded html file. Use absolute URLs to ensure that the data is loaded correctly."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>this.downloadHTML(),
                                    children: "Download"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "user-notes",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Note:"
                            }),
                            " To get a PDF, open the SVG which you can print as a PDF from your browser."
                        ]
                    })
                })
            ]
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(ExportModal);

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","react":"bmhQu","react-feather":"40SDF","react-router-dom":"b9X5n","vega":"jxCvh","vega-embed":"aAWYH","vega-lite":"eTD5L","../../../constants/consts.js":"1PtM7","./index.css":"2hF1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2hF1e":[function() {},{}],"8ED1L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
var _reactRedux = require("react-redux");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state, ownProps) {
    return {
        handle: state.handle,
        isAuthenticated: state.isAuthenticated,
        mode: state.mode,
        private: state.private
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","./renderer.js":"8ITFU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ITFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactFeather = require("react-feather");
var _reactRouterDom = require("react-router-dom");
var _indexJs = require("../../gist-select-widget/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexCss = require("./index.css");
var _jsoncParser = require("jsonc-parser");
var _githubJs = require("../../../utils/github.js");
class GistModal extends _react.PureComponent {
    refGistForm;
    constructor(props){
        super(props);
        this.state = {
            gist: {
                filename: '',
                image: '',
                imageStyle: {
                    bottom: 0
                },
                revision: '',
                type: props.mode,
                url: ''
            },
            gistLoadClicked: false,
            invalidFilename: false,
            invalidRevision: false,
            invalidUrl: false,
            latestRevision: false,
            syntaxError: false
        };
    }
    updateGist(gist) {
        this.setState({
            gist: {
                ...this.state.gist,
                ...gist
            }
        });
    }
    updateGistUrl(event) {
        this.updateGist({
            url: event.currentTarget.value
        });
        this.setState({
            invalidUrl: false
        });
    }
    updateGistRevision(event) {
        this.updateGist({
            revision: event.currentTarget.value
        });
        this.setState({
            invalidRevision: false
        });
    }
    updateGistFile(event) {
        this.updateGist({
            filename: event.currentTarget.value
        });
        this.setState({
            invalidFilename: false
        });
    }
    async onSelectGist(closePortal) {
        const url = this.state.gist.url.trim().toLowerCase();
        this.setState({
            gist: {
                ...this.state.gist,
                filename: this.state.gist.filename.trim(),
                revision: this.state.gist.revision.trim().toLowerCase()
            }
        });
        if (url.length === 0) {
            this.refGistForm.reportValidity();
            return;
        }
        this.setState({
            gistLoadClicked: true
        });
        let gistUrl;
        if (url.match(/gist\.githubusercontent\.com/)) {
            gistUrl = new URL(url, 'https://gist.githubusercontent.com');
            const [revision, filename] = gistUrl.pathname.split('/').slice(4);
            this.setState({
                gist: {
                    ...this.state.gist,
                    filename,
                    revision
                }
            });
        } else if (url.match(/gist\.github\.com/)) gistUrl = new URL(url, 'https://gist.github.com');
        const gistId = gistUrl.pathname.split('/')[2];
        try {
            const headers = {
                'Content-Type': 'application/json'
            };
            let githubToken;
            try {
                githubToken = await (0, _githubJs.getGithubToken)();
                if (githubToken) headers['Authorization'] = `token ${githubToken}`;
            } catch (error) {
                console.error('Failed to get GitHub token:', error);
            }
            const gistCommitsResponse = await fetch(`https://api.github.com/gists/${gistId}/commits`, {
                headers
            });
            this.setState({
                invalidUrl: !gistCommitsResponse.ok
            });
            if (!gistCommitsResponse.ok) {
                this.setState({
                    gistLoadClicked: false
                });
                throw new Error(`Failed to fetch gist commits: ${gistCommitsResponse.status}`);
            }
            const gistCommits = await gistCommitsResponse.json();
            if (!this.state.gist.revision && !this.state.invalidUrl) this.setState({
                gist: {
                    ...this.state.gist,
                    revision: gistCommits[0].version
                }
            });
            else if (this.state.invalidUrl) {
                this.setState({
                    gistLoadClicked: false
                });
                throw new Error('Invalid Gist URL');
            }
            if (gistCommits[0].version === this.state.gist.revision) this.setState({
                latestRevision: true
            });
            const gistSummaryResponse = await fetch(`https://api.github.com/gists/${gistId}/${this.state.gist.revision}`, {
                headers
            });
            this.setState({
                invalidRevision: !gistSummaryResponse.ok
            });
            if (!gistSummaryResponse.ok) {
                this.setState({
                    gistLoadClicked: false
                });
                throw new Error(`Failed to fetch gist summary: ${gistSummaryResponse.status}`);
            }
            const gistSummary = await gistSummaryResponse.json();
            if (this.state.invalidRevision) {
                this.setState({
                    gistLoadClicked: false
                });
                throw new Error('Invalid Revision');
            } else if (!this.state.invalidRevision && this.state.gist.filename === '') {
                const jsonFiles = Object.keys(gistSummary.files).filter((file)=>{
                    if (file.split('.').slice(-1)[0] === 'json') return true;
                });
                if (jsonFiles.length === 0) {
                    this.setState({
                        gistLoadClicked: false,
                        invalidUrl: true
                    });
                    throw new Error('No JSON file exists in the gist');
                } else this.setState({
                    gist: {
                        ...this.state.gist,
                        filename: jsonFiles[0]
                    }
                }, ()=>{
                    const { revision, filename } = this.state.gist;
                    (0, _jsoncParser.parse)(gistSummary.files[jsonFiles[0]].content);
                    if (this.state.latestRevision) this.props.history.push(`/gist/${gistId}/${filename}`);
                    else this.props.history.push(`/gist/${gistId}/${revision}/${filename}`);
                    closePortal();
                });
            } else {
                if (gistSummary.files[this.state.gist.filename] === undefined) {
                    this.setState({
                        gistLoadClicked: false,
                        invalidFilename: true
                    });
                    throw new Error('Invalid file name');
                }
                try {
                    const content = await this.fetchGistContent(gistSummary, this.state.gist.filename);
                    const errors = [];
                    (0, _jsoncParser.parse)(content, errors);
                    if (errors.length > 0) throw SyntaxError; // check if the loaded file is a JSON
                    const { revision, filename } = this.state.gist;
                    if (this.state.latestRevision) this.props.history.push(`/gist/${gistId}/${filename}`);
                    else this.props.history.push(`/gist/${gistId}/${revision}/${filename}`);
                    closePortal();
                } catch (error) {
                    if (error instanceof SyntaxError) this.setState({
                        gistLoadClicked: false,
                        syntaxError: true
                    });
                }
            }
        } catch (error) {
            if (error instanceof SyntaxError) this.setState({
                gistLoadClicked: false,
                syntaxError: true
            });
        }
    }
    async fetchGistContent(gistSummary, filename) {
        let githubToken;
        const headers = {
            'Content-Type': 'application/json'
        };
        try {
            githubToken = await (0, _githubJs.getGithubToken)();
            if (githubToken) headers['Authorization'] = `token ${githubToken}`;
        } catch (error) {
            console.error('Failed to get GitHub token:', error);
        }
        try {
            const content = gistSummary.files[filename].content;
            if (!content && gistSummary.files[filename].truncated) {
                console.warn('File content truncated, would need backend proxy for full content');
                throw new Error('File too large to load directly');
            }
            return content;
        } catch (error) {
            console.error('Error fetching gist content:', error);
            throw error;
        }
    }
    preview(id, file, image) {
        this.setState({
            gist: {
                ...this.state.gist,
                filename: file,
                image: image || '',
                imageStyle: {
                    ...this.state.gist.imageStyle,
                    bottom: 0
                },
                revision: '',
                url: `https://gist.github.com/${this.props.handle}/${id}`
            },
            invalidFilename: false,
            invalidRevision: false,
            invalidUrl: false,
            syntaxError: false
        });
    }
    slideImage(event) {
        const imageHeight = event.target.height;
        this.setState({
            gist: {
                ...this.state.gist,
                imageStyle: {
                    ...this.state.gist.imageStyle,
                    bottom: imageHeight > 100 ? imageHeight - 100 : 0
                }
            }
        });
    }
    slideImageBack() {
        this.setState({
            gist: {
                ...this.state.gist,
                imageStyle: {
                    ...this.state.gist.imageStyle,
                    bottom: 0
                }
            }
        });
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                    children: [
                        "Load",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://gist.github.com/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "GitHub Gist"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "gist-split",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "personal-gist",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "Your gists"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        "To load a gist, select it in the list below or specify its details on the right. View all your Gists on",
                                        ' ',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: `https://gist.github.com/${this.props.handle}`,
                                            children: "GitHub"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
                                    selectGist: this.preview.bind(this)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "load-gist",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "Load gists"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                    ref: (form)=>this.refGistForm = form,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "gist-input-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                    children: [
                                                        "Gist URL",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            style: {
                                                                marginTop: '2px'
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                                                children: [
                                                                    "Example:",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gist-url",
                                                                        onClick: ()=>this.setState({
                                                                                gist: {
                                                                                    ...this.state.gist,
                                                                                    filename: '',
                                                                                    image: '',
                                                                                    revision: '',
                                                                                    url: 'https://gist.github.com/domoritz/455e1c7872c4b38a58b90df0c3d7b1b9'
                                                                                }
                                                                            }),
                                                                        children: 'https://gist.github.com/domoritz/455e1c7872c4b38a58b90df0c3d7b1b9'
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            required: true,
                                                            className: "gist-input",
                                                            type: "text",
                                                            placeholder: "Enter URL",
                                                            value: this.state.gist.url,
                                                            onChange: this.updateGistUrl.bind(this)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "error-message",
                                                    children: this.state.invalidUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Please enter a valid URL."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "gist-optional",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "gist-input-container gist-optional-input-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                            children: [
                                                                "Revision (optional)",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    className: "gist-input",
                                                                    type: "text",
                                                                    placeholder: "Enter revision",
                                                                    value: this.state.gist.revision,
                                                                    onChange: this.updateGistRevision.bind(this)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "error-message",
                                                            children: this.state.invalidRevision && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "Please enter a valid revision."
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "gist-input-container gist-optional-input-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                            children: [
                                                                "Filename (optional)",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    className: "gist-input",
                                                                    type: "text",
                                                                    placeholder: "Enter filename",
                                                                    value: this.state.gist.filename,
                                                                    onChange: this.updateGistFile.bind(this)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "error-message",
                                                            children: this.state.invalidFilename ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "Please enter a valid JSON file"
                                                            }) : this.state.syntaxError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "JSON is syntactically incorrect"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        this.state.gist.url && this.state.gist.filename ? this.state.gist.image ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "preview-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "preview-text",
                                                    children: "Preview:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "preview-image-container",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "preview-image-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: this.state.gist.image,
                                                            onMouseOver: this.slideImage.bind(this),
                                                            onMouseOut: this.slideImageBack.bind(this),
                                                            style: {
                                                                transform: `translateY(-${this.state.gist.imageStyle.bottom}px)`
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "preview-error-message-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "preview-error-message",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.AlertCircle), {
                                                            className: "preview-error-icon"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: "No preview available for this gist file."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "preview-error-fix",
                                                    children: [
                                                        "Upload an image file with name ",
                                                        this.state.gist.filename.replace(/\.json/i, '.(png/jpg)'),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>this.onSelectGist(this.props.closePortal),
                                            children: this.state.gistLoadClicked ? 'Loading..' : 'Load'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(GistModal);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","react-router-dom":"b9X5n","../../gist-select-widget/index.js":"5ySLl","./index.css":"ad6k7","jsonc-parser":"81Jm5","../../../utils/github.js":"GBWwL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ySLl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        isAuthenticated: state.isAuthenticated,
        private: state.private
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        receiveCurrentUser: _editorJs.receiveCurrentUser,
        toggleGistPrivacy: _editorJs.toggleGistPrivacy
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./renderer.js":"8DBIN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8DBIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFeather = require("react-feather");
var _reactPaginate = require("react-paginate");
var _reactPaginateDefault = parcelHelpers.interopDefault(_reactPaginate);
var _indexJs = require("../../constants/index.js");
var _indexJs1 = require("../login-conditional/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexCss = require("./index.css");
var _githubJs = require("../../utils/github.js");
class GistSelectWidget extends (0, _reactDefault.default).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            currentPage: 0,
            loaded: false,
            personalGist: [],
            pages: {},
            loading: true,
            selected: {
                gist: null,
                file: null
            }
        };
    }
    componentDidMount() {
        this.handlePageChange({
            selected: 0
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAuthenticated !== prevProps.isAuthenticated) this.setState({
            currentPage: 0,
            loading: true
        }, ()=>{
            this.handlePageChange({
                selected: this.state.currentPage
            });
        });
        if (this.props.private !== prevProps.private) this.setState({
            currentPage: 0,
            loading: true
        }, ()=>{
            this.handlePageChange({
                selected: this.state.currentPage
            });
        });
    }
    async handlePageChange(page) {
        if (this.state.loading) this.setState({
            loading: false
        }, async ()=>{
            try {
                let githubToken;
                try {
                    githubToken = await (0, _githubJs.getGithubToken)();
                } catch (error) {
                    console.error('Failed to get GitHub token:', error);
                    this.props.receiveCurrentUser(false);
                    return;
                }
                const response = await fetch(`https://api.github.com/gists?per_page=30&page=${page.selected + 1}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `token ${githubToken}`
                    }
                });
                if (!response.ok) throw new Error(`Failed to fetch gists: ${response.status}`);
                const gists = await response.json();
                let pageCount = 1;
                const linkHeader = response.headers.get('Link');
                if (linkHeader) {
                    const lastPageMatch = linkHeader.match(/page=(\d+)>; rel="last"/);
                    if (lastPageMatch && lastPageMatch[1]) pageCount = parseInt(lastPageMatch[1], 10);
                }
                const pages = {};
                for(let i = 0; i < pageCount; i++)pages[i] = i + 1;
                const filteredGists = gists.filter((gist)=>{
                    return Object.keys(gist.files || {}).some((filename)=>filename.endsWith('.json'));
                });
                const formattedGists = filteredGists.map((gist)=>{
                    const jsonFiles = Object.keys(gist.files || {}).filter((filename)=>filename.endsWith('.json')).map((filename)=>({
                            name: filename,
                            previewUrl: ''
                        }));
                    return {
                        name: gist.id,
                        isPublic: gist.public,
                        title: gist.description || '',
                        spec: jsonFiles,
                        id: gist.id,
                        url: gist.html_url,
                        owner: gist.owner?.login || ''
                    };
                });
                this.setState({
                    currentPage: page.selected,
                    loaded: true,
                    pages: pages,
                    loading: true,
                    personalGist: formattedGists
                });
            } catch (error) {
                console.error('Error fetching gists:', error);
                this.props.receiveCurrentUser(false);
            }
        });
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
            children: this.state.loaded ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "privacy-toggle",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                name: "privacy",
                                id: "privacy",
                                checked: this.props.private === (0, _indexJs.GistPrivacy).ALL,
                                onChange: this.props.toggleGistPrivacy
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "privacy",
                                children: "Show private gists"
                            })
                        ]
                    }),
                    this.state.personalGist.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            Object.keys(this.state.pages).length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPaginateDefault.default), {
                                previousLabel: '<',
                                nextLabel: '>',
                                breakClassName: 'break',
                                containerClassName: 'pagination',
                                activeClassName: 'active',
                                pageCount: Object.keys(this.state.pages).length,
                                onPageChange: this.handlePageChange.bind(this),
                                forcePage: this.state.currentPage,
                                marginPagesDisplayed: 2,
                                pageRangeDisplayed: 2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `gist-wrapper ${!this.state.loading && 'loading'}`,
                                children: this.state.personalGist.map((gist)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: `gist-container ${this.state.selected.gist === gist.name && 'gist-active'}`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "personal-gist-description",
                                                children: [
                                                    gist.isPublic ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.File), {
                                                        width: "14",
                                                        height: "14"
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Lock), {
                                                        width: "14",
                                                        height: "14",
                                                        fill: "#FDD300"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: `text ${gist.title ? '' : 'play-down'}`,
                                                        children: gist.title || 'No description provided'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "personal-gist-files",
                                                children: gist.spec && gist.spec.length > 0 ? gist.spec.map((spec, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "file",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "arrow"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: `filename ${this.state.selected.file === spec.name && this.state.selected.gist === gist.name && 'file-active'}`,
                                                                onClick: ()=>{
                                                                    this.props.selectGist(gist.name, spec.name, spec.previewUrl);
                                                                    this.setState({
                                                                        selected: {
                                                                            gist: gist.name,
                                                                            file: spec.name
                                                                        }
                                                                    });
                                                                },
                                                                children: spec.name
                                                            })
                                                        ]
                                                    }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "no-files",
                                                    children: "No JSON files found"
                                                })
                                            })
                                        ]
                                    }, gist.id || gist.name))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "no-gists",
                        children: "You have no Vega or Vega-Lite compatible gists."
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "loader-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "Loading your GISTS..."
                })
            })
        });
    }
}
exports.default = GistSelectWidget;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","react-paginate":"8fLnr","../../constants/index.js":"4z2sr","../login-conditional/index.js":"aztfM","./index.css":"bBFwt","../../utils/github.js":"GBWwL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8fLnr":[function(require,module,exports,__globalThis) {
!function(e, a) {
    module.exports = a(require("c3c8cf1c03af2bce"));
}(this, (e)=>(()=>{
        var a = {
            703: (e, a, t)=>{
                "use strict";
                var r = t(414);
                function n() {}
                function i() {}
                i.resetWarningCache = n, e.exports = function() {
                    function e(e, a, t, n, i, s) {
                        if (s !== r) {
                            var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                            throw o.name = "Invariant Violation", o;
                        }
                    }
                    function a() {
                        return e;
                    }
                    e.isRequired = e;
                    var t = {
                        array: e,
                        bigint: e,
                        bool: e,
                        func: e,
                        number: e,
                        object: e,
                        string: e,
                        symbol: e,
                        any: e,
                        arrayOf: a,
                        element: e,
                        elementType: e,
                        instanceOf: a,
                        node: e,
                        objectOf: a,
                        oneOf: a,
                        oneOfType: a,
                        shape: a,
                        exact: a,
                        checkPropTypes: i,
                        resetWarningCache: n
                    };
                    return t.PropTypes = t, t;
                };
            },
            697: (e, a, t)=>{
                e.exports = t(703)();
            },
            414: (e)=>{
                "use strict";
                e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            },
            98: (a)=>{
                "use strict";
                a.exports = e;
            }
        }, t = {};
        function r(e) {
            var n = t[e];
            if (void 0 !== n) return n.exports;
            var i = t[e] = {
                exports: {}
            };
            return a[e](i, i.exports, r), i.exports;
        }
        r.n = (e)=>{
            var a = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(a, {
                a
            }), a;
        }, r.d = (e, a)=>{
            for(var t in a)r.o(a, t) && !r.o(e, t) && Object.defineProperty(e, t, {
                enumerable: !0,
                get: a[t]
            });
        }, r.o = (e, a)=>Object.prototype.hasOwnProperty.call(e, a), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            r.r(n), r.d(n, {
                default: ()=>k
            });
            var e = r(98), a = r.n(e), t = r(697), i = r.n(t);
            function s() {
                return s = Object.assign ? Object.assign.bind() : function(e) {
                    for(var a = 1; a < arguments.length; a++){
                        var t = arguments[a];
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }
                    return e;
                }, s.apply(this, arguments);
            }
            var o = function(e) {
                var t = e.pageClassName, r = e.pageLinkClassName, n = e.page, i = e.selected, o = e.activeClassName, l = e.activeLinkClassName, c = e.getEventListener, p = e.pageSelectedHandler, u = e.href, g = e.extraAriaContext, d = e.pageLabelBuilder, f = e.rel, b = e.ariaLabel || "Page " + n + (g ? " " + g : ""), v = null;
                return i && (v = "page", b = e.ariaLabel || "Page " + n + " is your current page", t = void 0 !== t ? t + " " + o : o, void 0 !== r ? void 0 !== l && (r = r + " " + l) : r = l), a().createElement("li", {
                    className: t
                }, a().createElement("a", s({
                    rel: f,
                    role: u ? void 0 : "button",
                    className: r,
                    href: u,
                    tabIndex: i ? "-1" : "0",
                    "aria-label": b,
                    "aria-current": v,
                    onKeyPress: p
                }, c(p)), d(n)));
            };
            o.propTypes = {
                pageSelectedHandler: i().func.isRequired,
                selected: i().bool.isRequired,
                pageClassName: i().string,
                pageLinkClassName: i().string,
                activeClassName: i().string,
                activeLinkClassName: i().string,
                extraAriaContext: i().string,
                href: i().string,
                ariaLabel: i().string,
                page: i().number.isRequired,
                getEventListener: i().func.isRequired,
                pageLabelBuilder: i().func.isRequired,
                rel: i().string
            };
            const l = o;
            function c() {
                return c = Object.assign ? Object.assign.bind() : function(e) {
                    for(var a = 1; a < arguments.length; a++){
                        var t = arguments[a];
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }
                    return e;
                }, c.apply(this, arguments);
            }
            var p = function(e) {
                var t = e.breakLabel, r = e.breakAriaLabel, n = e.breakClassName, i = e.breakLinkClassName, s = e.breakHandler, o = e.getEventListener, l = n || "break";
                return a().createElement("li", {
                    className: l
                }, a().createElement("a", c({
                    className: i,
                    role: "button",
                    tabIndex: "0",
                    "aria-label": r,
                    onKeyPress: s
                }, o(s)), t));
            };
            p.propTypes = {
                breakLabel: i().oneOfType([
                    i().string,
                    i().node
                ]),
                breakAriaLabel: i().string,
                breakClassName: i().string,
                breakLinkClassName: i().string,
                breakHandler: i().func.isRequired,
                getEventListener: i().func.isRequired
            };
            const u = p;
            function g(e) {
                var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                return null != e ? e : a;
            }
            function d(e) {
                return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, d(e);
            }
            function f() {
                return f = Object.assign ? Object.assign.bind() : function(e) {
                    for(var a = 1; a < arguments.length; a++){
                        var t = arguments[a];
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }
                    return e;
                }, f.apply(this, arguments);
            }
            function b(e, a) {
                for(var t = 0; t < a.length; t++){
                    var r = a[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function v(e, a) {
                return v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, a) {
                    return e.__proto__ = a, e;
                }, v(e, a);
            }
            function h(e, a) {
                if (a && ("object" === d(a) || "function" == typeof a)) return a;
                if (void 0 !== a) throw new TypeError("Derived constructors may only return object or undefined");
                return m(e);
            }
            function m(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function y(e) {
                return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, y(e);
            }
            function C(e, a, t) {
                return a in e ? Object.defineProperty(e, a, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[a] = t, e;
            }
            var P = function(e) {
                !function(e, a) {
                    if ("function" != typeof a && null !== a) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(a && a.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), a && v(e, a);
                }(o, e);
                var t, r, n, i, s = (n = o, i = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, a = y(n);
                    if (i) {
                        var t = y(this).constructor;
                        e = Reflect.construct(a, arguments, t);
                    } else e = a.apply(this, arguments);
                    return h(this, e);
                });
                function o(e) {
                    var t, r;
                    return function(e, a) {
                        if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
                    }(this, o), C(m(t = s.call(this, e)), "handlePreviousPage", function(e) {
                        var a = t.state.selected;
                        t.handleClick(e, null, a > 0 ? a - 1 : void 0, {
                            isPrevious: !0
                        });
                    }), C(m(t), "handleNextPage", function(e) {
                        var a = t.state.selected, r = t.props.pageCount;
                        t.handleClick(e, null, a < r - 1 ? a + 1 : void 0, {
                            isNext: !0
                        });
                    }), C(m(t), "handlePageSelected", function(e, a) {
                        if (t.state.selected === e) return t.callActiveCallback(e), void t.handleClick(a, null, void 0, {
                            isActive: !0
                        });
                        t.handleClick(a, null, e);
                    }), C(m(t), "handlePageChange", function(e) {
                        t.state.selected !== e && (t.setState({
                            selected: e
                        }), t.callCallback(e));
                    }), C(m(t), "getEventListener", function(e) {
                        return C({}, t.props.eventListener, e);
                    }), C(m(t), "handleClick", function(e, a, r) {
                        var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = n.isPrevious, s = void 0 !== i && i, o = n.isNext, l = void 0 !== o && o, c = n.isBreak, p = void 0 !== c && c, u = n.isActive, g = void 0 !== u && u;
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var d = t.state.selected, f = t.props.onClick, b = r;
                        if (f) {
                            var v = f({
                                index: a,
                                selected: d,
                                nextSelectedPage: r,
                                event: e,
                                isPrevious: s,
                                isNext: l,
                                isBreak: p,
                                isActive: g
                            });
                            if (!1 === v) return;
                            Number.isInteger(v) && (b = v);
                        }
                        void 0 !== b && t.handlePageChange(b);
                    }), C(m(t), "handleBreakClick", function(e, a) {
                        var r = t.state.selected;
                        t.handleClick(a, e, r < e ? t.getForwardJump() : t.getBackwardJump(), {
                            isBreak: !0
                        });
                    }), C(m(t), "callCallback", function(e) {
                        void 0 !== t.props.onPageChange && "function" == typeof t.props.onPageChange && t.props.onPageChange({
                            selected: e
                        });
                    }), C(m(t), "callActiveCallback", function(e) {
                        void 0 !== t.props.onPageActive && "function" == typeof t.props.onPageActive && t.props.onPageActive({
                            selected: e
                        });
                    }), C(m(t), "getElementPageRel", function(e) {
                        var a = t.state.selected, r = t.props, n = r.nextPageRel, i = r.prevPageRel, s = r.selectedPageRel;
                        return a - 1 === e ? i : a === e ? s : a + 1 === e ? n : void 0;
                    }), C(m(t), "pagination", function() {
                        var e = [], r = t.props, n = r.pageRangeDisplayed, i = r.pageCount, s = r.marginPagesDisplayed, o = r.breakLabel, l = r.breakClassName, c = r.breakLinkClassName, p = r.breakAriaLabels, g = t.state.selected;
                        if (i <= n) for(var d = 0; d < i; d++)e.push(t.getPageElement(d));
                        else {
                            var f = n / 2, b = n - f;
                            g > i - n / 2 ? f = n - (b = i - g) : g < n / 2 && (b = n - (f = g));
                            var v, h, m = function(e) {
                                return t.getPageElement(e);
                            }, y = [];
                            for(v = 0; v < i; v++){
                                var C = v + 1;
                                if (C <= s) y.push({
                                    type: "page",
                                    index: v,
                                    display: m(v)
                                });
                                else if (C > i - s) y.push({
                                    type: "page",
                                    index: v,
                                    display: m(v)
                                });
                                else if (v >= g - f && v <= g + (0 === g && n > 1 ? b - 1 : b)) y.push({
                                    type: "page",
                                    index: v,
                                    display: m(v)
                                });
                                else if (o && y.length > 0 && y[y.length - 1].display !== h && (n > 0 || s > 0)) {
                                    var P = v < g ? p.backward : p.forward;
                                    h = a().createElement(u, {
                                        key: v,
                                        breakAriaLabel: P,
                                        breakLabel: o,
                                        breakClassName: l,
                                        breakLinkClassName: c,
                                        breakHandler: t.handleBreakClick.bind(null, v),
                                        getEventListener: t.getEventListener
                                    }), y.push({
                                        type: "break",
                                        index: v,
                                        display: h
                                    });
                                }
                            }
                            y.forEach(function(a, t) {
                                var r = a;
                                "break" === a.type && y[t - 1] && "page" === y[t - 1].type && y[t + 1] && "page" === y[t + 1].type && y[t + 1].index - y[t - 1].index <= 2 && (r = {
                                    type: "page",
                                    index: a.index,
                                    display: m(a.index)
                                }), e.push(r.display);
                            });
                        }
                        return e;
                    }), void 0 !== e.initialPage && void 0 !== e.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e.initialPage, ") and forcePage (").concat(e.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), r = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, t.state = {
                        selected: r
                    }, t;
                }
                return t = o, r = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            var e = this.props, a = e.initialPage, t = e.disableInitialCallback, r = e.extraAriaContext, n = e.pageCount, i = e.forcePage;
                            void 0 === a || t || this.callCallback(a), r && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(n) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n, "). Did you forget a Math.ceil()?")), void 0 !== a && a > n - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(a, " > ").concat(n - 1, ").")), void 0 !== i && i > n - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i, " > ").concat(n - 1, ")."));
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            void 0 !== this.props.forcePage && this.props.forcePage !== e.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                                selected: this.props.forcePage
                            })), Number.isInteger(e.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                        }
                    },
                    {
                        key: "getForwardJump",
                        value: function() {
                            var e = this.state.selected, a = this.props, t = a.pageCount, r = e + a.pageRangeDisplayed;
                            return r >= t ? t - 1 : r;
                        }
                    },
                    {
                        key: "getBackwardJump",
                        value: function() {
                            var e = this.state.selected - this.props.pageRangeDisplayed;
                            return e < 0 ? 0 : e;
                        }
                    },
                    {
                        key: "getElementHref",
                        value: function(e) {
                            var a = this.props, t = a.hrefBuilder, r = a.pageCount, n = a.hrefAllControls;
                            if (t) return n || e >= 0 && e < r ? t(e + 1, r, this.state.selected) : void 0;
                        }
                    },
                    {
                        key: "ariaLabelBuilder",
                        value: function(e) {
                            var a = e === this.state.selected;
                            if (this.props.ariaLabelBuilder && e >= 0 && e < this.props.pageCount) {
                                var t = this.props.ariaLabelBuilder(e + 1, a);
                                return this.props.extraAriaContext && !a && (t = t + " " + this.props.extraAriaContext), t;
                            }
                        }
                    },
                    {
                        key: "getPageElement",
                        value: function(e) {
                            var t = this.state.selected, r = this.props, n = r.pageClassName, i = r.pageLinkClassName, s = r.activeClassName, o = r.activeLinkClassName, c = r.extraAriaContext, p = r.pageLabelBuilder;
                            return a().createElement(l, {
                                key: e,
                                pageSelectedHandler: this.handlePageSelected.bind(null, e),
                                selected: t === e,
                                rel: this.getElementPageRel(e),
                                pageClassName: n,
                                pageLinkClassName: i,
                                activeClassName: s,
                                activeLinkClassName: o,
                                extraAriaContext: c,
                                href: this.getElementHref(e),
                                ariaLabel: this.ariaLabelBuilder(e),
                                page: e + 1,
                                pageLabelBuilder: p,
                                getEventListener: this.getEventListener
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.props.renderOnZeroPageCount;
                            if (0 === this.props.pageCount && void 0 !== e) return e ? e(this.props) : e;
                            var t = this.props, r = t.disabledClassName, n = t.disabledLinkClassName, i = t.pageCount, s = t.className, o = t.containerClassName, l = t.previousLabel, c = t.previousClassName, p = t.previousLinkClassName, u = t.previousAriaLabel, d = t.prevRel, b = t.nextLabel, v = t.nextClassName, h = t.nextLinkClassName, m = t.nextAriaLabel, y = t.nextRel, C = this.state.selected, P = 0 === C, k = C === i - 1, x = "".concat(g(c)).concat(P ? " ".concat(g(r)) : ""), L = "".concat(g(v)).concat(k ? " ".concat(g(r)) : ""), N = "".concat(g(p)).concat(P ? " ".concat(g(n)) : ""), O = "".concat(g(h)).concat(k ? " ".concat(g(n)) : ""), R = P ? "true" : "false", E = k ? "true" : "false";
                            return a().createElement("ul", {
                                className: s || o,
                                role: "navigation",
                                "aria-label": "Pagination"
                            }, a().createElement("li", {
                                className: x
                            }, a().createElement("a", f({
                                className: N,
                                href: this.getElementHref(C - 1),
                                tabIndex: P ? "-1" : "0",
                                role: "button",
                                onKeyPress: this.handlePreviousPage,
                                "aria-disabled": R,
                                "aria-label": u,
                                rel: d
                            }, this.getEventListener(this.handlePreviousPage)), l)), this.pagination(), a().createElement("li", {
                                className: L
                            }, a().createElement("a", f({
                                className: O,
                                href: this.getElementHref(C + 1),
                                tabIndex: k ? "-1" : "0",
                                role: "button",
                                onKeyPress: this.handleNextPage,
                                "aria-disabled": E,
                                "aria-label": m,
                                rel: y
                            }, this.getEventListener(this.handleNextPage)), b)));
                        }
                    }
                ], b(t.prototype, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), o;
            }(e.Component);
            C(P, "propTypes", {
                pageCount: i().number.isRequired,
                pageRangeDisplayed: i().number,
                marginPagesDisplayed: i().number,
                previousLabel: i().node,
                previousAriaLabel: i().string,
                prevPageRel: i().string,
                prevRel: i().string,
                nextLabel: i().node,
                nextAriaLabel: i().string,
                nextPageRel: i().string,
                nextRel: i().string,
                breakLabel: i().oneOfType([
                    i().string,
                    i().node
                ]),
                breakAriaLabels: i().shape({
                    forward: i().string,
                    backward: i().string
                }),
                hrefBuilder: i().func,
                hrefAllControls: i().bool,
                onPageChange: i().func,
                onPageActive: i().func,
                onClick: i().func,
                initialPage: i().number,
                forcePage: i().number,
                disableInitialCallback: i().bool,
                containerClassName: i().string,
                className: i().string,
                pageClassName: i().string,
                pageLinkClassName: i().string,
                pageLabelBuilder: i().func,
                activeClassName: i().string,
                activeLinkClassName: i().string,
                previousClassName: i().string,
                nextClassName: i().string,
                previousLinkClassName: i().string,
                nextLinkClassName: i().string,
                disabledClassName: i().string,
                disabledLinkClassName: i().string,
                breakClassName: i().string,
                breakLinkClassName: i().string,
                extraAriaContext: i().string,
                ariaLabelBuilder: i().func,
                eventListener: i().string,
                renderOnZeroPageCount: i().func,
                selectedPageRel: i().string
            }), C(P, "defaultProps", {
                pageRangeDisplayed: 2,
                marginPagesDisplayed: 3,
                activeClassName: "selected",
                previousLabel: "Previous",
                previousClassName: "previous",
                previousAriaLabel: "Previous page",
                prevPageRel: "prev",
                prevRel: "prev",
                nextLabel: "Next",
                nextClassName: "next",
                nextAriaLabel: "Next page",
                nextPageRel: "next",
                nextRel: "next",
                breakLabel: "...",
                breakAriaLabels: {
                    forward: "Jump forward",
                    backward: "Jump backward"
                },
                disabledClassName: "disabled",
                disableInitialCallback: !1,
                pageLabelBuilder: function(e) {
                    return e;
                },
                eventListener: "onClick",
                renderOnZeroPageCount: void 0,
                selectedPageRel: "canonical",
                hrefAllControls: !1
            });
            const k = P;
        })(), n;
    })());

},{"c3c8cf1c03af2bce":"bmhQu"}],"aztfM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
var _reactRedux = require("react-redux");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        isAuthenticated: state.isAuthenticated
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","./renderer.js":"16ZxC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"16ZxC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexJs = require("../../constants/index.js");
class LoginConditional extends (0, _reactDefault.default).PureComponent {
    constructor(props){
        super(props);
        this.state = {};
    }
    handleLogin = (e)=>{
        e.preventDefault();
        const popup = window.open(`${(0, _indexJs.BACKEND_URL)}auth/github`, 'github-login', 'width=600,height=600,resizable=yes');
        if (popup) popup.focus();
        else window.location.href = `${0, _indexJs.BACKEND_URL}auth/github`;
        return false;
    };
    render() {
        const githubLink = /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            href: `${(0, _indexJs.BACKEND_URL)}auth/github`,
            onClick: this.handleLogin,
            children: "Login with GitHub"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: this.props.isAuthenticated ? this.props.children : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    githubLink,
                    " to use the Gist feature."
                ]
            })
        });
    }
}
exports.default = LoginConditional;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../constants/index.js":"4z2sr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bBFwt":[function() {},{}],"GBWwL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGithubToken", ()=>getGithubToken);
var _indexJs = require("../constants/index.js");
const getGithubToken = async ()=>{
    const headers = {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0'
    };
    const authToken = localStorage.getItem('vega_editor_auth_token');
    if (authToken) headers['X-Auth-Token'] = authToken;
    try {
        const response = await fetch(`${(0, _indexJs.BACKEND_URL)}auth/github/token`, {
            cache: 'no-store',
            headers
        });
        if (!response.ok) throw new Error(`Failed to fetch GitHub token: ${response.status}`);
        const data = await response.json();
        return data.githubAccessToken;
    } catch (error) {
        console.error('Failed to retrieve GitHub token:', error);
        throw error;
    }
};

},{"../constants/index.js":"4z2sr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ad6k7":[function() {},{}],"2eUrg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMMIT_HASH", ()=>COMMIT_HASH);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFeather = require("react-feather");
var _vega = require("vega");
var _vegaLite = require("vega-lite");
var _vegaTooltip = require("vega-tooltip");
var _isMacJs = require("../../../utils/isMac.js");
var _isMacJsDefault = parcelHelpers.interopDefault(_isMacJs);
var _keyboardShortcutsJs = require("../../../utils/keyboardShortcuts.js");
var _keyboardShortcutsJsDefault = parcelHelpers.interopDefault(_keyboardShortcutsJs);
var _indexCss = require("./index.css");
// Will generate keyboard shortcuts based on OS
// 1. Check OS (isMac)
// 2. Then get the shortcuts
// 3. Map over shorcuts and render os specific
// 4. Get shortcut, split it, and map over it to render
// 5. To add shortcuts go to utils/keyboardShortcuts.ts, changes will be reflected here
const keyBoardShortcuts = (0, _keyboardShortcutsJsDefault.default).map((shortcut, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
        children: [
            ((0, _isMacJsDefault.default)() ? shortcut.mac : shortcut.windows).split(' ').map((key)=>key === '+' ? '+' : /*#__PURE__*/ (0, _jsxRuntime.jsx)("kbd", {
                    children: key
                }, `${key}${i}`)),
            ": ",
            shortcut.text
        ]
    }, i));
const COMMIT_HASH = "13a8a485b7dfc77593341b8d2e40efe6cd7ddeab";
const HelpModal = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "help-modal",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Help"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "References"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "doc-link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "https://vega.github.io/vega-lite/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Vega-Lite Docs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "doc-link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "https://vega.github.io/vega/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Vega Docs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Keyboard Shortcuts"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "keyboard-shortcuts",
                children: keyBoardShortcuts
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Access editor actions by clicking the Commands button or pressing ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("kbd", {
                        children: "f1"
                    }),
                    ".",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    "Here you can clear the spec, extract or merge the config, or format the specification."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: `https://github.com/vega/editor/issues/new?body=**Vega-Editor ${COMMIT_HASH}**`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "report-button button",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.AlertCircle), {
                        className: "header-icon"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "Report a Bug"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Send us your feedback"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: "https://bit.ly/join-vega-slack-2022",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "doc-link",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Slack), {
                        className: "doc-image"
                    }),
                    "Join our Slack channel"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: "https://twitter.com/vega_vis",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "doc-link",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Twitter), {
                        className: "doc-image"
                    }),
                    "Follow us on Twitter"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Tip"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "You can access Vega, Vega-Lite, and the",
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://vega.github.io/vega/docs/api/view/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Vega view"
                    }),
                    ' ',
                    "at ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: "(VEGA_DEBUG)"
                    }),
                    " using your browser's developer console."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Versions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            "Vega: ",
                            (0, _vega.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            "Vega-Lite: ",
                            (0, _vegaLite.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            "Vega-Tooltip: ",
                            (0, _vegaTooltip.version)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            "Editor: ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: `https://github.com/vega/editor/commit/${COMMIT_HASH}`,
                                children: COMMIT_HASH.slice(0, 7)
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = HelpModal;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","vega":"jxCvh","vega-lite":"eTD5L","vega-tooltip":"jfqql","../../../utils/isMac.js":"gHOBK","../../../utils/keyboardShortcuts.js":"69Cbe","./index.css":"hgcwy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gHOBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isMac = ()=>navigator.platform.toUpperCase().indexOf('MAC') >= 0;
exports.default = isMac;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"69Cbe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shortcuts = [
    {
        mac: "\u2318 + b",
        text: 'Parse the specification and render visualization',
        windows: 'Ctrl + b'
    },
    {
        mac: "\u2318 + ?",
        text: 'Open the help window',
        windows: 'Ctrl + ?'
    },
    {
        mac: "\u2318 + Space",
        text: 'Open Intellisense in the editor',
        windows: 'Ctrl + Space'
    },
    {
        mac: "\u2318 + f11",
        text: 'Toggle fullscreen mode',
        windows: 'Ctrl + f11'
    },
    {
        mac: "\u2318 + Shift + o",
        text: `Navigate to a symbol in the specification`,
        windows: 'Ctrl + Shift + o'
    }
];
exports.default = shortcuts;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hgcwy":[function() {},{}],"iGclQ":[function() {},{}],"5hljF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
var _editorJs = require("../../../actions/editor.js");
function mapStateToProps(state) {
    return {
        editorString: state.editorString,
        isAuthenticated: state.isAuthenticated,
        mode: state.mode,
        handle: state.handle
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        receiveCurrentUser: _editorJs.receiveCurrentUser
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","./renderer.js":"6TDEk","../../../actions/editor.js":"wC9No","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6TDEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _jsoncParser = require("jsonc-parser");
var _lzString = require("lz-string");
var _lzStringDefault = parcelHelpers.interopDefault(_lzString);
var _react = require("react");
var _reactClipboardJs = require("react-clipboard.js");
var _reactClipboardJsDefault = parcelHelpers.interopDefault(_reactClipboardJs);
var _reactFeather = require("react-feather");
var _reactRouterDom = require("react-router-dom");
var _constsJs = require("../../../constants/consts.js");
var _indexJs = require("../../gist-select-widget/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../login-conditional/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexCss = require("./index.css");
var _githubJs = require("../../../utils/github.js");
const EDITOR_BASE = window.location.origin + window.location.pathname;
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift() || '';
    return '';
}
class ShareModal extends _react.PureComponent {
    constructor(props){
        super(props);
        const date = new Date().toDateString();
        this.state = {
            copied: false,
            creating: undefined,
            createError: false,
            updateError: false,
            fullScreen: false,
            whitespace: false,
            generatedURL: '',
            gistFileName: 'spec.json',
            gistFileNameSelected: '',
            gistPrivate: false,
            gistTitle: `${(0, _constsJs.NAMES)[this.props.mode]} spec from ${date}`,
            gistId: '',
            updating: undefined,
            gistEditorURL: ''
        };
    }
    exportURL() {
        const specString = this.state.whitespace ? this.props.editorString : JSON.stringify((0, _jsoncParser.parse)(this.props.editorString));
        const serializedSpec = (0, _lzStringDefault.default).compressToEncodedURIComponent(specString) + (this.state.fullScreen ? '/view' : '');
        if (serializedSpec) {
            const url = `${document.location.href.split('#')[0]}#/url/${this.props.mode}/${serializedSpec}`;
            this.setState({
                generatedURL: url
            });
        }
    }
    previewURL() {
        const win = window.open(this.state.generatedURL, '_blank');
        win.focus();
    }
    onCopy() {
        if (!this.state.copied) this.setState({
            copied: true
        }, ()=>{
            setTimeout(()=>{
                this.setState({
                    copied: false
                });
            }, 2500);
        });
    }
    handleFulscreenCheck(event) {
        this.setState({
            fullScreen: event.target.checked
        }, ()=>{
            this.exportURL();
        });
    }
    handleWhitespaceCheck(event) {
        this.setState({
            whitespace: event.target.checked
        }, ()=>{
            this.exportURL();
        });
    }
    componentDidMount() {
        this.exportURL();
    }
    updatePrivacy(event) {
        this.setState({
            gistPrivate: event.target.checked
        });
    }
    fileNameChange(event) {
        this.setState({
            gistFileName: event.target.value
        });
    }
    gistFileNameSelectedChange(event) {
        this.setState({
            gistFileNameSelected: event.target.value
        });
    }
    titleChange(event) {
        this.setState({
            gistTitle: event.target.value
        });
    }
    async createGist() {
        this.setState({
            creating: true
        });
        const body = {
            content: this.state.whitespace ? this.props.editorString : (0, _jsonStringifyPrettyCompactDefault.default)((0, _jsoncParser.parse)(this.props.editorString)),
            name: this.state.gistFileName || 'spec',
            title: this.state.gistTitle,
            privacy: this.state.gistPrivate
        };
        try {
            // Get GitHub access token just-in-time
            let githubToken;
            try {
                githubToken = await (0, _githubJs.getGithubToken)();
            } catch (error) {
                console.error('Failed to get GitHub token:', error);
                this.setState({
                    creating: false,
                    createError: true
                });
                this.props.receiveCurrentUser(false);
                return;
            }
            const gistBody = {
                description: body.title,
                public: !body.privacy,
                files: {
                    [body.name.endsWith('.json') ? body.name : `${body.name}.json`]: {
                        content: body.content
                    }
                }
            };
            // Direct API call to GitHub
            const res = await fetch('https://api.github.com/gists', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `token ${githubToken}`
                },
                body: JSON.stringify(gistBody)
            });
            if (!res.ok) throw new Error(`Failed to create gist: ${res.status}`);
            const data = await res.json();
            this.setState({
                creating: false,
                updating: undefined
            }, ()=>{
                if (!data.id) this.setState({
                    createError: true
                }, ()=>{
                    if (res.status === 401) this.props.receiveCurrentUser(false);
                });
                else {
                    const fileName = Object.keys(data.files)[0];
                    this.setState({
                        createError: false,
                        gistEditorURL: `${EDITOR_BASE}#/gist/${data.id}/${fileName}`
                    });
                }
            });
        } catch (error) {
            console.error('Error creating gist:', error);
            this.setState({
                creating: false,
                createError: true
            });
        }
    }
    selectGist(id, fileName) {
        this.setState({
            gistFileNameSelected: fileName,
            gistId: id
        });
    }
    async updateGist() {
        this.setState({
            updating: true
        });
        const fileName = this.state.gistFileNameSelected;
        try {
            if (this.state.gistId) {
                // Get GitHub access token just-in-time
                let githubToken;
                try {
                    githubToken = await (0, _githubJs.getGithubToken)();
                } catch (error) {
                    console.error('Failed to get GitHub token:', error);
                    this.setState({
                        updating: false,
                        updateError: true
                    });
                    this.props.receiveCurrentUser(false);
                    return;
                }
                const gistBody = {
                    files: {
                        [fileName]: {
                            content: this.props.editorString
                        }
                    }
                };
                const res = await fetch(`https://api.github.com/gists/${this.state.gistId}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `token ${githubToken}`
                    },
                    body: JSON.stringify(gistBody)
                });
                if (!res.ok) throw new Error(`Failed to update gist: ${res.status}`);
                const data = await res.json();
                if (data.id) this.setState({
                    gistEditorURL: `${EDITOR_BASE}#/gist/${data.id}/${fileName}`,
                    creating: undefined,
                    updating: false,
                    updateError: false
                });
                else this.setState({
                    creating: undefined,
                    updating: false,
                    updateError: true
                });
            }
        } catch (error) {
            console.error('Error updating gist:', error);
            this.setState({
                creating: undefined,
                updating: false,
                updateError: true
            });
        }
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "share-modal",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Share"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Via URL"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        "We pack the ",
                        (0, _constsJs.NAMES)[this.props.mode],
                        " specification as an encoded string in the URL. We use a LZ-based compression algorithm. When whitespaces are not preserved, the editor will automatically format the specification when it is loaded."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "user-pref",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    defaultChecked: this.state.fullScreen,
                                    name: "fullscreen",
                                    onChange: this.handleFulscreenCheck.bind(this)
                                }),
                                "Open visualization in fullscreen"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: "user-pref",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    defaultChecked: this.state.whitespace,
                                    name: "whitespace",
                                    onChange: this.handleWhitespaceCheck.bind(this)
                                }),
                                "Preserve whitespace, comments, and trailing commas"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "sharing-buttons",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            onClick: ()=>this.previewURL(),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Link), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Open Link"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactClipboardJsDefault.default), {
                            className: "copy-icon",
                            "data-clipboard-text": this.state.generatedURL,
                            onSuccess: this.onCopy.bind(this),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Copy), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Copy Link to Clipboard"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactClipboardJsDefault.default), {
                            className: "copy-icon",
                            "data-clipboard-text": `[Open the Chart in the Vega Editor](${this.state.generatedURL})`,
                            onSuccess: this.onCopy.bind(this),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Copy), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Copy Markdown Link to Clipboard"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `copied + ${this.state.copied ? ' visible' : ''}`,
                            children: "Copied!"
                        })
                    ]
                }),
                "Number of characters in the URL: ",
                this.state.generatedURL.length,
                ' ',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "url-warning",
                    children: this.state.generatedURL.length > 2083 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            "Warning:",
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "https://support.microsoft.com/en-us/help/208427/maximum-url-length-is-2-083-characters-in-internet-explorer",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "URLs over 2083 characters may not be supported in Internet Explorer."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "spacer"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    children: [
                        "Via",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://gist.github.com/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "GitHub Gist"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _indexJsDefault1.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Here, you can save your ",
                                (0, _constsJs.NAMES)[this.props.mode],
                                " specification as a new Gist or update an existing Gist. You can view all of your Gists on ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: `https://gist.github.com/${this.props.handle}`,
                                    children: "GitHub"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "share-gist-split",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "update-gist",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Update an existing Gist"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: "To update an existing Gist, select it in the list and then click the button below to confirm."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
                                            selectGist: this.selectGist.bind(this)
                                        }),
                                        this.props.isAuthenticated && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "share-input-container",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                    children: [
                                                        "File name:",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            value: this.state.gistFileNameSelected,
                                                            onChange: this.gistFileNameSelectedChange.bind(this),
                                                            type: "text"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                            children: "Change the filename to create a new file in the selected Gist"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "sharing-buttons",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                    onClick: this.updateGist.bind(this),
                                                    disabled: !this.state.gistFileNameSelected || this.state.updating,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Save), {}),
                                                        this.state.updating ? 'Updating...' : 'Update'
                                                    ]
                                                }),
                                                this.state.gistEditorURL && this.state.updating !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactClipboardJsDefault.default), {
                                                    className: "copy-icon",
                                                    "data-clipboard-text": this.state.gistEditorURL,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Copy), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: "Copy Link to Clipboard"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        this.state.updateError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "error-message share-error",
                                            children: "Gist could not be updated."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Create a new Gist"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            children: [
                                                "Save the current ",
                                                (0, _constsJs.NAMES)[this.props.mode],
                                                " specification as a Gist. When you save it, you will get a link that you can share. You can also load the specification via the Gist loading functionality in the editor."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                className: "user-pref",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "checkbox",
                                                        defaultChecked: this.state.whitespace,
                                                        name: "whitespace",
                                                        onChange: this.handleWhitespaceCheck.bind(this)
                                                    }),
                                                    "Preserve whitespace, comments, and trailing commas"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "share-input-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                children: [
                                                    "Title:",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        value: this.state.gistTitle,
                                                        onChange: this.titleChange.bind(this),
                                                        type: "text",
                                                        placeholder: "Enter title of gist"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "share-input-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                children: [
                                                    "File name:",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        value: this.state.gistFileName,
                                                        onChange: this.fileNameChange.bind(this),
                                                        type: "text",
                                                        placeholder: "Enter file name"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "share-input-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "checkbox",
                                                        name: "private-gist",
                                                        id: "private-gist",
                                                        value: "private-select",
                                                        checked: this.state.gistPrivate,
                                                        onChange: this.updatePrivacy.bind(this)
                                                    }),
                                                    "Create a Private Gist"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "sharing-buttons",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                    onClick: this.createGist.bind(this),
                                                    disabled: this.state.creating,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Save), {}),
                                                        this.state.creating ? 'Creating...' : 'Create'
                                                    ]
                                                }),
                                                this.state.gistEditorURL && this.state.creating !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactClipboardJsDefault.default), {
                                                    className: "copy-icon",
                                                    "data-clipboard-text": this.state.gistEditorURL,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Copy), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: "Copy Link to Clipboard"
                                                        })
                                                    ]
                                                }),
                                                this.state.createError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "error-message share-error",
                                                    children: "Gist could not be created"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(ShareModal);

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","jsonc-parser":"81Jm5","lz-string":"20emn","react":"bmhQu","react-clipboard.js":"7pPlq","react-feather":"40SDF","react-router-dom":"b9X5n","../../../constants/consts.js":"1PtM7","../../gist-select-widget/index.js":"5ySLl","../../login-conditional/index.js":"aztfM","./index.css":"9yGLH","../../../utils/github.js":"GBWwL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"20emn":[function(require,module,exports,__globalThis) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

},{}],"7pPlq":[function(require,module,exports,__globalThis) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory(require("a91ad7c1587ae477"), require("b9980ea00fdbe125"), require("4a68d810898c2d4a"), require("b146d78b0a6cfd0"));
})(this, function(__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./index.js");
    /******/ }({
        /***/ "./index.js": /*!******************!*\
  !*** ./index.js ***!
  \******************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    var ownKeys = Object.keys(source);
                    if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }));
                    ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            var ClipboardButton = /*#__PURE__*/ function(_React$Component) {
                _inherits(ClipboardButton, _React$Component);
                function ClipboardButton() {
                    _classCallCheck(this, ClipboardButton);
                    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
                }
                _createClass(ClipboardButton, [
                    {
                        key: "propsWith",
                        value: function propsWith(regexp) {
                            var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var object = {};
                            Object.keys(this.props).forEach(function(key) {
                                if (key.search(regexp) !== -1) {
                                    var objectKey = remove ? key.replace(regexp, '') : key;
                                    object[objectKey] = this.props[key];
                                }
                            }, this);
                            return object;
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            this.clipboard && this.clipboard.destroy();
                        }
                    },
                    {
                        key: "componentDidMount",
                        value: function componentDidMount() {
                            // Support old API by trying to assign this.props.options first;
                            var options = this.props.options || this.propsWith(/^option-/, true);
                            var element = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this.element);
                            if (!element) return;
                            var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");
                            this.clipboard = new Clipboard(element, options);
                            var callbacks = this.propsWith(/^on/, true);
                            Object.keys(callbacks).forEach(function(callback) {
                                this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
                            }, this);
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            var _this = this;
                            var attributes = _objectSpread({
                                title: this.props.title || '',
                                type: this.getType(),
                                className: this.props.className || '',
                                style: this.props.style || {},
                                ref: function ref(element) {
                                    return _this.element = element;
                                },
                                onClick: this.props.onClick
                            }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
                            var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");
                            if (!this.props.isVisibleWhenUnsupported && !Clipboard.isSupported()) return null;
                            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);
                        }
                    },
                    {
                        key: "getType",
                        value: function getType() {
                            if (this.getComponent() === 'button' || this.getComponent() === 'input') return this.props.type || 'button';
                            else return undefined;
                        }
                    },
                    {
                        key: "getComponent",
                        value: function getComponent() {
                            return this.props.component || 'button';
                        }
                    }
                ]);
                return ClipboardButton;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _defineProperty(ClipboardButton, "propTypes", {
                options: function options(props, propName, componentName) {
                    var options = props[propName];
                    if (options && _typeof(options) !== 'object' || Array.isArray(options)) return new Error("Invalid props '".concat(propName, "' supplied to '").concat(componentName, "'. ") + "'".concat(propName, "' is not an object."));
                    if (props['option-text'] !== undefined) {
                        var optionText = props['option-text'];
                        if (typeof optionText !== 'function') return new Error("Invalid props 'option-text' supplied to '".concat(componentName, "'. ") + "'option-text' is not a function.");
                    }
                },
                title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
                component: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
                children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any
            });
            _defineProperty(ClipboardButton, "defaultProps", {
                isVisibleWhenUnsupported: true,
                onClick: function onClick() {}
            });
            /* harmony default export */ __webpack_exports__["default"] = ClipboardButton;
        /***/ },
        /***/ "clipboard": /*!********************************************************************************************************!*\
  !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
  \********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;
        /***/ },
        /***/ "prop-types": /*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
  \*********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ },
        /***/ "react-dom": /*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom"} ***!
  \*****************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;
        /***/ }
    });
});

},{"a91ad7c1587ae477":"a8BC6","b9980ea00fdbe125":"gLXGb","4a68d810898c2d4a":"bmhQu","b146d78b0a6cfd0":"82aNB"}],"a8BC6":[function(require,module,exports,__globalThis) {
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(this, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command('cut');
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
                    var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS
                    fakeElement.style.fontSize = '12pt'; // Reset box model
                    fakeElement.style.border = '0';
                    fakeElement.style.padding = '0';
                    fakeElement.style.margin = '0'; // Move element out of screen horizontally
                    fakeElement.style.position = 'absolute';
                    fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute('readonly', '');
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command('copy');
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = '';
                    if (typeof target === 'string') selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        'text',
                        'search',
                        'url',
                        'tel',
                        'password'
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command('copy');
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? 'copy' : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== 'copy' && action !== 'cut') throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
                            if (action === 'copy' && target.hasAttribute('disabled')) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === 'cut' ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, 'click', function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || 'copy';
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? 'success' : 'error', {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue('action', trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue('target', trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue('text', trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    'copy',
                                    'cut'
                                ];
                                var actions = typeof action === 'string' ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== 'undefined' && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === 'function' && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === 'function') return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === 'function') // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === 'string') elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === 'string' || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === '[object Function]';
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error('Missing required arguments');
                    if (!is.string(type)) throw new TypeError('Second argument must be a String');
                    if (!is.fn(callback)) throw new TypeError('Third argument must be a Function');
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === 'SELECT') {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                        var isReadOnly = element.hasAttribute('readonly');
                        if (!isReadOnly) element.setAttribute('readonly', '');
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute('readonly');
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute('contenteditable')) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});

},{}],"9yGLH":[function() {},{}],"bk4m3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactSplitPaneR17 = require("react-split-pane-r17");
var _reactSplitPaneR17Default = parcelHelpers.interopDefault(_reactSplitPaneR17);
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _indexJs = require("../../constants/index.js");
var _indexJs1 = require("../config-editor/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./compiled-spec-display/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./compiled-spec-header/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexCss = require("./index.css");
var _indexJs4 = require("./spec-editor/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./spec-editor-header/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
class InputPanel extends _react.PureComponent {
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(size) {
        this.props.setCompiledVegaPaneSize(size);
        if (size > (0, _indexJs.LAYOUT).MinPaneSize && !this.props.compiledVegaSpec || size === (0, _indexJs.LAYOUT).MinPaneSize && this.props.compiledVegaSpec) this.props.toggleCompiledVegaSpec();
    }
    componentDidUpdate() {
        if (this.props.mode === (0, _indexJs.Mode).VegaLite) {
            if (this.props.compiledVegaPaneSize === (0, _indexJs.LAYOUT).MinPaneSize) this.props.setCompiledVegaPaneSize((window.innerHeight - (0, _indexJs.LAYOUT).HeaderHeight) * 0.3);
        }
    }
    getInnerPanes() {
        return [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "full-height-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault4.default), {}, "specEditorHeader"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            height: 'calc(100% - 30px)',
                            display: this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Editor ? '' : 'none'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault3.default), {}, "editor")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            height: 'calc(100% - 30px)',
                            display: this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config ? '' : 'none'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {}, "configEditor")
                    })
                ]
            }, "editor"),
            this.props.compiledVegaSpec ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault1.default), {}, "compiled") : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault2.default), {}, "compiledSpecHeader")
        ];
    }
    render() {
        const innerPanes = this.getInnerPanes();
        return(// ! Never make this conditional based on modes
        // ! we will loose support for undo across modes
        // ! because the editor will be unmounted
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            role: "group",
            "aria-label": "spec editors",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSplitPaneR17Default.default), {
                split: "horizontal",
                primary: "second",
                className: "editor-spitPane",
                minSize: (0, _indexJs.LAYOUT).MinPaneSize,
                defaultSize: this.props.compiledVegaSpec ? this.props.compiledVegaPaneSize : (0, _indexJs.LAYOUT).MinPaneSize,
                onChange: this.handleChange,
                pane1Style: {
                    minHeight: `${(0, _indexJs.LAYOUT).MinPaneSize}px`
                },
                pane2Style: {
                    display: this.props.mode === (0, _indexJs.Mode).Vega ? 'none' : 'block',
                    height: this.props.compiledVegaSpec ? (this.props.compiledVegaPaneSize || window.innerHeight * 0.4) + 'px' : (0, _indexJs.LAYOUT).MinPaneSize + 'px'
                },
                onDragFinished: ()=>{
                    if (this.props.compiledVegaPaneSize === (0, _indexJs.LAYOUT).MinPaneSize) this.props.setCompiledVegaPaneSize((window.innerHeight - (0, _indexJs.LAYOUT).HeaderHeight) * 0.5);
                },
                children: innerPanes
            })
        }));
    }
}
function mapStateToProps(state) {
    return {
        compiledVegaPaneSize: state.compiledVegaPaneSize,
        compiledVegaSpec: state.compiledVegaSpec,
        mode: state.mode,
        sidePaneItem: state.sidePaneItem
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setCompiledVegaPaneSize: _editorJs.setCompiledVegaPaneSize,
        toggleCompiledVegaSpec: _editorJs.toggleCompiledVegaSpec
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InputPanel);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-redux":"dwYd3","react-split-pane-r17":"Q6ksT","redux":"jTcSr","../../actions/editor.js":"wC9No","../../constants/index.js":"4z2sr","../config-editor/index.js":"ku3WF","./compiled-spec-display/index.js":"a1uQv","./compiled-spec-header/index.js":"7PNNL","./index.css":"krUIm","./spec-editor/index.js":"6QWhv","./spec-editor-header/index.js":"lbvAy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ku3WF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _configEditorCss = require("./config-editor.css");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        compiledVegaPaneSize: state.compiledVegaPaneSize,
        compiledVegaSpec: state.compiledVegaSpec,
        config: state.config,
        configEditorString: state.configEditorString,
        decorations: state.decorations,
        editorString: state.editorString,
        gist: state.gist,
        manualParse: state.manualParse,
        mode: state.mode,
        parse: state.parse,
        selectedExample: state.selectedExample,
        sidePaneItem: state.sidePaneItem,
        themeName: state.themeName,
        value: state.editorString
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        extractConfig: _editorJs.extractConfigSpec,
        mergeConfigSpec: _editorJs.mergeConfigSpec,
        setConfig: _editorJs.setConfig,
        setConfigEditorString: _editorJs.setConfigEditorString,
        setEditorReference: _editorJs.setEditorReference,
        setThemeName: _editorJs.setThemeName
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./config-editor.css":"52XWi","./renderer.js":"dg0nc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"52XWi":[function() {},{}],"dg0nc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react1 = require("@monaco-editor/react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _rcResizeObserver = require("rc-resize-observer");
var _rcResizeObserverDefault = parcelHelpers.interopDefault(_rcResizeObserver);
var _reactRouterDom = require("react-router-dom");
var _vega = require("vega");
var _indexJs = require("../../constants/index.js");
var _configEditorCss = require("./config-editor.css");
class ConfigEditor extends _react.PureComponent {
    editor;
    handleEditorChange = (spec)=>{
        const newSpec = spec === '' ? '{}' : spec;
        this.props.setConfigEditorString(newSpec);
        this.props.setThemeName('custom');
        if (this.props.manualParse) return;
        this.props.setConfig(this.props.configEditorString);
    };
    handleMergeConfig() {
        const confirmation = confirm('The spec will be formatted on merge.');
        if (!confirmation) return;
        if (this.props.history.location.pathname !== '/edited') this.props.history.push('/edited');
        this.props.mergeConfigSpec();
    }
    handleExtractConfig() {
        const confirmation = confirm('The spec and config will be formatted.');
        if (!confirmation) return;
        this.props.extractConfig();
    }
    handleEditorMount(editor) {
        editor.onDidFocusEditorText(()=>{
            editor.deltaDecorations(this.props.decorations, []);
            this.props.setEditorReference(editor);
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 0,
            id: 'MERGE_CONFIG',
            label: 'Merge Config Into Spec',
            run: this.handleMergeConfig.bind(this)
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 1,
            id: 'EXTRACT_CONFIG',
            label: 'Extract Config From Spec',
            run: this.handleExtractConfig.bind(this)
        });
        this.editor = editor;
        if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config) {
            this.editor.focus();
            this.editor.layout();
        }
    }
    componentDidMount() {
        if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config) this.props.setEditorReference(this.editor);
    }
    componentDidUpdate() {
        if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config) {
            this.editor.focus();
            this.editor.layout();
            this.props.setEditorReference(this.editor);
        }
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rcResizeObserverDefault.default), {
            onResize: ({ width, height })=>{
                this.editor?.layout({
                    width,
                    height
                });
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default), {
                defaultLanguage: "json",
                options: {
                    cursorBlinking: 'smooth',
                    folding: true,
                    lineNumbersMinChars: 4,
                    minimap: {
                        enabled: false
                    },
                    scrollBeyondLastLine: false,
                    wordWrap: 'on',
                    quickSuggestions: true,
                    stickyScroll: {
                        enabled: false
                    }
                },
                onChange: (0, _vega.debounce)(700, this.handleEditorChange),
                defaultValue: this.props.configEditorString,
                onMount: (e)=>this.handleEditorMount(e)
            })
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(ConfigEditor);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@monaco-editor/react":"495Y5","rc-resize-observer":"6IMii","react-router-dom":"b9X5n","vega":"jxCvh","../../constants/index.js":"4z2sr","./config-editor.css":"52XWi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6IMii":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_rs", ()=>(0, _observerUtil._rs));
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _toArray = require("rc-util/es/Children/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _warning = require("rc-util/es/warning");
var _singleObserver = require("./SingleObserver");
var _singleObserverDefault = parcelHelpers.interopDefault(_singleObserver);
var _collection = require("./Collection");
var _observerUtil = require("./utils/observerUtil");
var INTERNAL_PREFIX_KEY = 'rc-observer-key';
function ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, _toArrayDefault.default)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ _react.createElement((0, _singleObserverDefault.default), (0, _extendsDefault.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var RefResizeObserver = /*#__PURE__*/ _react.forwardRef(ResizeObserver);
RefResizeObserver.Collection = (0, _collection.Collection);
exports.default = RefResizeObserver;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","react":"bmhQu","rc-util/es/Children/toArray":"4Xhk6","rc-util/es/warning":"46EIg","./SingleObserver":"6ICMe","./Collection":"lOmcb","./utils/observerUtil":"3aZ0B","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Xhk6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toArray);
var _isFragment = require("../React/isFragment");
var _isFragmentDefault = parcelHelpers.interopDefault(_isFragment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function toArray(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, _reactDefault.default).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat(toArray(child));
        else if ((0, _isFragmentDefault.default)(child) && child.props) ret = ret.concat(toArray(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

},{"../React/isFragment":"8VLz0","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8VLz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFragment);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function isFragment(object) {
    return(// Base object type
    object && (0, _typeofDefault.default)(object) === 'object' && // React Element type
    (object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === REACT_FRAGMENT_TYPE);
}

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"46EIg":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preMessage", ()=>preMessage);
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ parcelHelpers.export(exports, "warning", ()=>warning);
/** @see Similar to {@link warning} */ parcelHelpers.export(exports, "note", ()=>note);
parcelHelpers.export(exports, "resetWarned", ()=>resetWarned);
parcelHelpers.export(exports, "call", ()=>call);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "warningOnce", ()=>warningOnce);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "noteOnce", ()=>noteOnce);
var warned = {};
var preWarningFns = [];
var preMessage = function preMessage(fn) {
    preWarningFns.push(fn);
};
function warning(valid, message) {
    var finalMessage;
}
function note(valid, message) {
    var finalMessage;
}
function resetWarned() {
    warned = {};
}
function call(method, valid, message) {
    if (!valid && !warned[message]) {
        method(false, message);
        warned[message] = true;
    }
}
function warningOnce(valid, message) {
    call(warning, valid, message);
}
function noteOnce(valid, message) {
    call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
exports.default = warningOnce;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ICMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _findDOMNode = require("rc-util/es/Dom/findDOMNode");
var _findDOMNodeDefault = parcelHelpers.interopDefault(_findDOMNode);
var _ref = require("rc-util/es/ref");
var _react = require("react");
var _collection = require("../Collection");
var _observerUtil = require("../utils/observerUtil");
var _domWrapper = require("./DomWrapper");
var _domWrapperDefault = parcelHelpers.interopDefault(_domWrapper);
function SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = _react.useRef(null);
    var wrapperRef = _react.useRef(null);
    var onCollectionResize = _react.useContext((0, _collection.CollectionContext));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = _react.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ _react.isValidElement(mergedChildren) && (0, _ref.supportRef)(mergedChildren);
    var originRef = canRef ? (0, _ref.getNodeRef)(mergedChildren) : null;
    var mergedRef = (0, _ref.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, _findDOMNodeDefault.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, _typeofDefault.default)(elementRef.current) === 'object' ? (0, _findDOMNodeDefault.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, _findDOMNodeDefault.default)(wrapperRef.current);
    };
    _react.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = _react.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = _react.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    _react.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, _observerUtil.observe)(currentElement, onInternalResize);
        return function() {
            return (0, _observerUtil.unobserve)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ _react.createElement((0, _domWrapperDefault.default), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ _react.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var RefSingleObserver = /*#__PURE__*/ _react.forwardRef(SingleObserver);
exports.default = RefSingleObserver;

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/typeof":"8oq3j","rc-util/es/Dom/findDOMNode":"atqIM","rc-util/es/ref":"3rcz9","react":"bmhQu","../Collection":"lOmcb","../utils/observerUtil":"3aZ0B","./DomWrapper":"kUvDL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"atqIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOM", ()=>isDOM);
/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */ parcelHelpers.export(exports, "getDOM", ()=>getDOM);
parcelHelpers.export(exports, "default", ()=>findDOMNode);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function isDOM(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function getDOM(node) {
    if (node && (0, _typeofDefault.default)(node) === 'object' && isDOM(node.nativeElement)) return node.nativeElement;
    if (isDOM(node)) return node;
    return null;
}
function findDOMNode(node) {
    var domNode = getDOM(node);
    if (domNode) return domNode;
    if (node instanceof (0, _reactDefault.default).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, _reactDomDefault.default).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, _reactDomDefault.default), node);
    }
    return null;
}

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","react":"bmhQu","react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3rcz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillRef", ()=>fillRef);
parcelHelpers.export(exports, "composeRef", ()=>composeRef);
parcelHelpers.export(exports, "useComposeRef", ()=>useComposeRef);
parcelHelpers.export(exports, "supportRef", ()=>supportRef);
parcelHelpers.export(exports, "supportNodeRef", ()=>supportNodeRef);
parcelHelpers.export(exports, "getNodeRef", ()=>getNodeRef);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _react = require("react");
var _reactIs = require("react-is");
var _useMemo = require("./hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isFragment = require("./React/isFragment");
var _isFragmentDefault = parcelHelpers.interopDefault(_isFragment);
var ReactMajorVersion = Number((0, _react.version).split('.')[0]);
var fillRef = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, _typeofDefault.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var composeRef = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            fillRef(ref, node);
        });
    };
};
var useComposeRef = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, _useMemoDefault.default)(function() {
        return composeRef.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var supportRef = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) return true;
    var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    return true;
};
function isReactElement(node) {
    return /*#__PURE__*/ (0, _react.isValidElement)(node) && !(0, _isFragmentDefault.default)(node);
}
var supportNodeRef = function supportNodeRef(node) {
    return isReactElement(node) && supportRef(node);
};
var getNodeRef = function getNodeRef(node) {
    if (node && isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","react":"bmhQu","react-is":"j9Tbe","./hooks/useMemo":"bpFug","./React/isFragment":"8VLz0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j9Tbe":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("7998368c99c862ed");

},{"7998368c99c862ed":"hN35w"}],"hN35w":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"bpFug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMemo);
var _react = require("react");
function useMemo(getValue, condition, shouldUpdate) {
    var cacheRef = _react.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lOmcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollectionContext", ()=>CollectionContext);
/**
 * Collect all the resize event from children ResizeObserver
 */ parcelHelpers.export(exports, "Collection", ()=>Collection);
var _react = require("react");
var CollectionContext = /*#__PURE__*/ _react.createContext(null);
function Collection(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = _react.useRef(0);
    var resizeInfosRef = _react.useRef([]);
    var onCollectionResize = _react.useContext(CollectionContext);
    var onResize = _react.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ _react.createElement(CollectionContext.Provider, {
        value: onResize
    }, children);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aZ0B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_el", ()=>_el);
parcelHelpers.export(exports, "_rs", ()=>_rs);
// ============================== Observe ==============================
parcelHelpers.export(exports, "observe", ()=>observe);
parcelHelpers.export(exports, "unobserve", ()=>unobserve);
var _resizeObserverPolyfill = require("resize-observer-polyfill");
var _resizeObserverPolyfillDefault = parcelHelpers.interopDefault(_resizeObserverPolyfill);
// =============================== Const ===============================
var elementListeners = new Map();
function onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var resizeObserver = new (0, _resizeObserverPolyfillDefault.default)(onResize);
var _el = null; // eslint-disable-line
var _rs = null; // eslint-disable-line
function observe(element, callback) {
    if (!elementListeners.has(element)) {
        elementListeners.set(element, new Set());
        resizeObserver.observe(element);
    }
    elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
    if (elementListeners.has(element)) {
        elementListeners.get(element).delete(callback);
        if (!elementListeners.get(element).size) {
            resizeObserver.unobserve(element);
            elementListeners.delete(element);
        }
    }
}

},{"resize-observer-polyfill":"2C9RD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2C9RD":[function(require,module,exports,__globalThis) {
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var global$1 = function() {
    if (typeof global !== 'undefined' && global.Math === Math) return global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};
// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return emptyRect;
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function getContentRect(target) {
    if (!isBrowser) return emptyRect;
    if (isSVGGraphicsElement(target)) return getSVGContentRect(target);
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});
var index = function() {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') return global$1.ResizeObserver;
    return ResizeObserver;
}();
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kUvDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DomWrapper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _react = require("react");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsDefault.default)(DomWrapper, _React$Component);
    var _super = (0, _createSuperDefault.default)(DomWrapper);
    function DomWrapper() {
        (0, _classCallCheckDefault.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, _createClassDefault.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}(_react.Component);

},{"@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/inherits":"9qeOz","@babel/runtime/helpers/esm/createSuper":"4Z7nH","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"52XWi":[function() {},{}],"a1uQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _react = require("react");
var _react1 = require("@monaco-editor/react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../../actions/editor.js");
var _indexJs = require("../../../constants/index.js");
var _indexJs1 = require("../compiled-spec-header/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _rcResizeObserver = require("rc-resize-observer");
var _rcResizeObserverDefault = parcelHelpers.interopDefault(_rcResizeObserver);
class CompiledSpecDisplay extends _react.PureComponent {
    editor;
    componentDidMount() {
        this.props.setCompiledEditorReference(this.editor);
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: 'full-height-wrapper',
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rcResizeObserverDefault.default), {
                    onResize: ({ width, height })=>{
                        this.editor?.layout({
                            width,
                            height
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default), {
                        height: this.props.compiledVegaPaneSize - (0, _indexJs.LAYOUT).MinPaneSize,
                        options: {
                            folding: true,
                            minimap: {
                                enabled: false
                            },
                            readOnly: true,
                            scrollBeyondLastLine: false,
                            wordWrap: 'on',
                            stickyScroll: {
                                enabled: false
                            }
                        },
                        language: "json",
                        value: (0, _jsonStringifyPrettyCompactDefault.default)(this.props.value),
                        onMount: (editor)=>{
                            editor.onDidFocusEditorText(()=>{
                                this.props.compiledEditorRef && this.props.compiledEditorRef.deltaDecorations(this.props.decorations, []);
                                this.props.editorRef && this.props.editorRef.deltaDecorations(this.props.decorations, []);
                                this.props.setEditorFocus((0, _indexJs.EDITOR_FOCUS).CompiledEditor);
                            });
                            this.editor = editor;
                        }
                    })
                })
            ]
        });
    }
}
function mapStateToProps(state) {
    return {
        compiledEditorRef: state.compiledEditorRef,
        compiledVegaPaneSize: state.compiledVegaPaneSize,
        decorations: state.decorations,
        editorRef: state.editorRef,
        mode: state.mode,
        sidePaneItem: state.sidePaneItem,
        value: state.compiledPaneItem == (0, _indexJs.COMPILEDPANE).Vega ? state.vegaSpec : state.normalizedVegaLiteSpec
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setCompiledEditorReference: _editorJs.setCompiledEditorRef,
        setEditorFocus: _editorJs.setEditorFocus
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CompiledSpecDisplay);

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","react":"bmhQu","@monaco-editor/react":"495Y5","react-redux":"dwYd3","redux":"jTcSr","../../../actions/editor.js":"wC9No","../../../constants/index.js":"4z2sr","../compiled-spec-header/index.js":"7PNNL","rc-resize-observer":"6IMii","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7PNNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _react = require("react");
var _reactFeather = require("react-feather");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _redux = require("redux");
var _editorJs = require("../../../actions/editor.js");
var _indexJs = require("../../../constants/index.js");
const toggleStyle = {
    cursor: 'pointer'
};
class CompiledSpecDisplayHeader extends _react.PureComponent {
    constructor(props){
        super(props);
        this.editVegaSpec = this.editVegaSpec.bind(this);
    }
    editVegaSpec() {
        if (this.props.history.location.pathname.indexOf('/edited') === -1) this.props.history.push('/edited');
        this.props.clearConfig();
        if (this.props.compiledPaneItem == (0, _indexJs.COMPILEDPANE).Vega) this.props.updateVegaSpec((0, _jsonStringifyPrettyCompactDefault.default)(this.props.value));
        else this.props.updateVegaLiteSpec((0, _jsonStringifyPrettyCompactDefault.default)(this.props.value));
    }
    render() {
        if (this.props.compiledVegaSpec) {
            const toggleStyleUp = {
                ...toggleStyle,
                position: 'static'
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "editor-header",
                style: toggleStyleUp,
                onClick: this.props.toggleCompiledVegaSpec,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        className: "tabs-nav",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: this.props.compiledPaneItem == (0, _indexJs.COMPILEDPANE).Vega ? 'active-tab' : undefined,
                                onClick: (e)=>{
                                    this.props.setCompiledPaneItem((0, _indexJs.COMPILEDPANE).Vega);
                                    e.stopPropagation();
                                },
                                children: "Compiled Vega"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                className: this.props.compiledPaneItem == (0, _indexJs.COMPILEDPANE).NormalizedVegaLite ? 'active-tab' : undefined,
                                onClick: (e)=>{
                                    this.props.setCompiledPaneItem((0, _indexJs.COMPILEDPANE).NormalizedVegaLite);
                                    e.stopPropagation();
                                },
                                children: "Extended Vega-Lite Spec"
                            })
                        ]
                    }),
                    this.props.compiledPaneItem === (0, _indexJs.COMPILEDPANE).Vega ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: this.editVegaSpec,
                        style: {
                            cursor: 'pointer'
                        },
                        children: "Edit Vega Spec"
                    }) : null,
                    this.props.compiledPaneItem === (0, _indexJs.COMPILEDPANE).NormalizedVegaLite ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: this.editVegaSpec,
                        style: {
                            cursor: 'pointer'
                        },
                        children: "Edit Extended Vega-Lite Spec"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.ChevronDown), {})
                ]
            });
        } else return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            onClick: this.props.toggleCompiledVegaSpec,
            className: "editor-header",
            style: toggleStyle,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "tabs-nav",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: this.props.compiledPaneItem == (0, _indexJs.COMPILEDPANE).Vega ? 'active-tab' : undefined,
                            onClick: ()=>{
                                this.props.setCompiledPaneItem((0, _indexJs.COMPILEDPANE).Vega);
                            },
                            children: "Compiled Vega"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: this.props.compiledPaneItem == (0, _indexJs.COMPILEDPANE).NormalizedVegaLite ? 'active-tab' : undefined,
                            onClick: ()=>{
                                this.props.setCompiledPaneItem((0, _indexJs.COMPILEDPANE).NormalizedVegaLite);
                            },
                            children: "Extended Vega-Lite Spec"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.ChevronUp), {})
            ]
        });
    }
}
function mapStateToProps(state) {
    return {
        compiledVegaSpec: state.compiledVegaSpec,
        value: state.compiledPaneItem == (0, _indexJs.COMPILEDPANE).Vega ? state.vegaSpec : state.normalizedVegaLiteSpec,
        compiledPaneItem: state.compiledPaneItem
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        clearConfig: _editorJs.clearConfig,
        toggleCompiledVegaSpec: _editorJs.toggleCompiledVegaSpec,
        updateVegaSpec: _editorJs.updateVegaSpec,
        updateVegaLiteSpec: _editorJs.updateVegaLiteSpec,
        setCompiledPaneItem: _editorJs.setCompiledPaneItem
    }, dispatch);
}
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CompiledSpecDisplayHeader));

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","react":"bmhQu","react-feather":"40SDF","react-redux":"dwYd3","react-router-dom":"b9X5n","redux":"jTcSr","../../../actions/editor.js":"wC9No","../../../constants/index.js":"4z2sr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"krUIm":[function() {},{}],"6QWhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        compiledEditorRef: state.compiledEditorRef,
        compiledVegaPaneSize: state.compiledVegaPaneSize,
        compiledVegaSpec: state.compiledVegaSpec,
        configEditorString: state.configEditorString,
        decorations: state.decorations,
        editorFocus: state.editorFocus,
        editorRef: state.editorRef,
        editorString: state.editorString,
        gist: state.gist,
        manualParse: state.manualParse,
        mode: state.mode,
        parse: state.parse,
        selectedExample: state.selectedExample,
        sidePaneItem: state.sidePaneItem,
        themeName: state.themeName,
        value: state.editorString,
        view: state.view
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        clearConfig: _editorJs.clearConfig,
        extractConfigSpec: _editorJs.extractConfigSpec,
        logError: _editorJs.logError,
        mergeConfigSpec: _editorJs.mergeConfigSpec,
        parseSpec: _editorJs.parseSpec,
        setConfig: _editorJs.setConfig,
        setDecorations: _editorJs.setDecorations,
        setEditorFocus: _editorJs.setEditorFocus,
        setEditorReference: _editorJs.setEditorReference,
        updateEditorString: _editorJs.updateEditorString,
        updateVegaLiteSpec: _editorJs.updateVegaLiteSpec,
        updateVegaSpec: _editorJs.updateVegaSpec
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../../actions/editor.js":"wC9No","./renderer.js":"4RREo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4RREo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _lzString = require("lz-string");
var _lzStringDefault = parcelHelpers.interopDefault(_lzString);
var _react = require("react");
var _react1 = require("@monaco-editor/react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
var _rcResizeObserver = require("rc-resize-observer");
var _rcResizeObserverDefault = parcelHelpers.interopDefault(_rcResizeObserver);
var _reactRouterDom = require("react-router-dom");
var _vega = require("vega");
var _vegaSchemaUrlParser = require("vega-schema-url-parser");
var _vegaSchemaUrlParserDefault = parcelHelpers.interopDefault(_vegaSchemaUrlParser);
var _indexJs = require("../../../constants/index.js");
var _indexCss = require("./index.css");
var _jsoncParser = require("jsonc-parser");
class Editor extends _react.PureComponent {
    editor;
    constructor(props){
        super(props);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.editorWillMount = this.editorWillMount.bind(this);
        this.editorDidMount = this.editorDidMount.bind(this);
        this.onSelectNewVegaLite = this.onSelectNewVegaLite.bind(this);
    }
    handleKeydown(e) {
        if (this.props.manualParse) {
            if ((e.keyCode === (0, _indexJs.KEYCODES).B || e.keyCode === (0, _indexJs.KEYCODES).S) && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                this.props.parseSpec(true);
                const parseButton = this.refs.parse;
                parseButton.classList.add('pressed');
                setTimeout(()=>{
                    parseButton.classList.remove('pressed');
                }, 250);
            }
        }
    }
    handleMergeConfig() {
        const confirmation = confirm('The spec will be formatted on merge.');
        if (!confirmation) return;
        if (this.props.history.location.pathname !== '/edited') this.props.history.push('/edited');
        this.props.mergeConfigSpec();
    }
    handleExtractConfig() {
        const confirmation = confirm('The spec and config will be formatted.');
        if (!confirmation) return;
        this.props.extractConfigSpec();
    }
    onSelectNewVega() {
        this.props.history.push('/custom/vega');
    }
    onSelectNewVegaLite() {
        this.props.history.push('/custom/vega-lite');
    }
    onClear() {
        this.props.mode === (0, _indexJs.Mode).Vega ? this.onSelectNewVega() : this.onSelectNewVegaLite();
    }
    addVegaSchemaURL() {
        let spec = (0, _jsoncParser.parse)(this.props.editorString);
        if (spec.$schema === undefined) {
            spec = {
                $schema: (0, _indexJs.SCHEMA)[(0, _indexJs.Mode).Vega],
                ...spec
            };
            if (confirm('Adding schema URL will format the specification too.')) this.props.updateVegaSpec((0, _jsonStringifyPrettyCompactDefault.default)(spec));
        }
    }
    addVegaLiteSchemaURL() {
        let spec = (0, _jsoncParser.parse)(this.props.editorString);
        if (spec.$schema === undefined) {
            spec = {
                $schema: (0, _indexJs.SCHEMA)[(0, _indexJs.Mode).VegaLite],
                ...spec
            };
            if (confirm('Adding schema URL will format the specification too.')) this.props.updateVegaLiteSpec((0, _jsonStringifyPrettyCompactDefault.default)(spec));
        }
    }
    editorDidMount(editor) {
        editor.onDidFocusEditorText(()=>{
            this.props.compiledEditorRef && this.props.compiledEditorRef.deltaDecorations(this.props.decorations, []);
            editor.createDecorationsCollection(this.props.decorations);
            this.props.setEditorFocus((0, _indexJs.EDITOR_FOCUS).SpecEditor);
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 0,
            id: 'ADD_VEGA_SCHEMA',
            label: 'Add Vega schema URL',
            run: this.addVegaSchemaURL.bind(this)
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 1,
            id: 'ADD_VEGA_LITE_SCHEMA',
            label: 'Add Vega-Lite schema URL',
            run: this.addVegaLiteSchemaURL.bind(this)
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 2,
            id: 'CLEAR_EDITOR',
            label: 'Clear Spec',
            run: this.onClear.bind(this)
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 3,
            id: 'MERGE_CONFIG',
            label: 'Merge Config Into Spec',
            run: this.handleMergeConfig.bind(this)
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 4,
            id: 'EXTRACT_CONFIG',
            label: 'Extract Config From Spec',
            run: this.handleExtractConfig.bind(this)
        });
        editor.getModel().getOptions();
        this.editor = editor;
        this.props.setEditorReference(editor);
        if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Editor) {
            editor.focus();
            editor.layout();
            this.props.setEditorFocus((0, _indexJs.EDITOR_FOCUS).SpecEditor);
        }
    }
    handleEditorChange(spec) {
        this.props.manualParse ? this.props.updateEditorString(spec) : this.updateSpec(spec);
        if (this.props.history.location.pathname.indexOf('/edited') === -1) this.props.history.push('/edited');
    }
    editorWillMount() {
        const compressed = this.props.match.params.compressed;
        if (compressed) {
            let spec = (0, _lzStringDefault.default).decompressFromEncodedURIComponent(compressed);
            if (spec) {
                const newlines = (spec.match(/\n/g) || '').length + 1;
                if (newlines <= 1) {
                    console.log('Formatting spec string from URL that did not contain newlines.');
                    spec = (0, _jsonStringifyPrettyCompactDefault.default)((0, _jsoncParser.parse)(spec));
                }
                this.updateSpec(spec);
            } else this.props.logError(new Error(`Failed to decompress URL. Expected a specification, but received ${spec}`));
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Editor) {
            if (prevProps.sidePaneItem !== this.props.sidePaneItem) {
                this.editor.focus();
                this.editor.layout();
            }
        }
        if (prevProps.view !== this.props.view) {
            prevProps.compiledEditorRef && prevProps.compiledEditorRef.deltaDecorations(prevProps.decorations, []);
            prevProps.editorRef && prevProps.editorRef.deltaDecorations(prevProps.decorations, []);
        }
        if (this.editor && this.props.parse) {
            this.editor.focus();
            this.editor.layout();
            this.updateSpec(this.props.value, this.props.configEditorString);
            prevProps.parseSpec(false);
        }
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeydown);
        if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Editor) this.props.setEditorReference(this.editor);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeydown);
    }
    updateSpec(spec, config) {
        let parsedMode = this.props.mode;
        const schema = (0, _jsoncParser.parse)(spec).$schema;
        if (schema) switch((0, _vegaSchemaUrlParserDefault.default)(schema).library){
            case 'vega-lite':
                parsedMode = (0, _indexJs.Mode).VegaLite;
                break;
            case 'vega':
                parsedMode = (0, _indexJs.Mode).Vega;
                break;
        }
        switch(parsedMode){
            case (0, _indexJs.Mode).Vega:
                this.props.updateVegaSpec(spec, config);
                break;
            case (0, _indexJs.Mode).VegaLite:
                this.props.updateVegaLiteSpec(spec, config);
                break;
            default:
                console.error(`Unknown mode:  ${parsedMode}`);
                break;
        }
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rcResizeObserverDefault.default), {
            onResize: ({ width, height })=>{
                this.editor?.layout({
                    width,
                    height
                });
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default), {
                defaultLanguage: "json",
                options: {
                    cursorBlinking: 'smooth',
                    folding: true,
                    lineNumbersMinChars: 4,
                    minimap: {
                        enabled: false
                    },
                    scrollBeyondLastLine: false,
                    wordWrap: 'on',
                    quickSuggestions: true,
                    stickyScroll: {
                        enabled: false
                    }
                },
                value: this.props.value,
                onChange: (0, _vega.debounce)(700, this.handleEditorChange),
                beforeMount: this.editorWillMount,
                onMount: this.editorDidMount
            })
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(Editor);

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","lz-string":"20emn","react":"bmhQu","@monaco-editor/react":"495Y5","rc-resize-observer":"6IMii","react-router-dom":"b9X5n","vega":"jxCvh","vega-schema-url-parser":"k72H2","../../../constants/index.js":"4z2sr","./index.css":"aDwP3","jsonc-parser":"81Jm5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aDwP3":[function() {},{}],"lbvAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _redux = require("redux");
var _editorJs = require("../../../actions/editor.js");
var _indexJs = require("../../../constants/index.js");
var _configEditorHeaderJs = require("../../config-editor/config-editor-header.js");
var _configEditorHeaderJsDefault = parcelHelpers.interopDefault(_configEditorHeaderJs);
var _indexCss = require("./index.css");
class SpecEditorHeader extends _react.PureComponent {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "editor-header spec-editor-header",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "tabs-nav",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Editor ? 'active-tab' : undefined,
                            onClick: (e)=>{
                                if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Editor) e.stopPropagation();
                                e.stopPropagation();
                                this.props.setSidePaneItem((0, _indexJs.SIDEPANE).Editor);
                            },
                            children: this.props.mode
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config ? 'active-tab' : undefined,
                            onClick: (e)=>{
                                if (this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config) e.stopPropagation();
                                e.stopPropagation();
                                this.props.setSidePaneItem((0, _indexJs.SIDEPANE).Config);
                            },
                            children: "Config"
                        })
                    ]
                }),
                this.props.sidePaneItem === (0, _indexJs.SIDEPANE).Config && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configEditorHeaderJsDefault.default), {})
            ]
        });
    }
}
function mapStateToProps(state) {
    return {
        compiledVegaSpec: state.compiledVegaSpec,
        configEditorString: state.configEditorString,
        editorString: state.editorString,
        manualParse: state.manualParse,
        mode: state.mode,
        sidePaneItem: state.sidePaneItem,
        themeName: state.themeName,
        value: state.vegaSpec
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setSidePaneItem: _editorJs.setSidePaneItem
    }, dispatch);
}
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SpecEditorHeader));

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-redux":"dwYd3","react-router-dom":"b9X5n","redux":"jTcSr","../../../actions/editor.js":"wC9No","../../../constants/index.js":"4z2sr","../../config-editor/config-editor-header.js":"kxD8I","./index.css":"jPRwO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kxD8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _jsxRuntime = require("react/jsx-runtime");
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _react = require("react");
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _vegaLite = require("vega-lite");
var _vegaThemes = require("vega-themes");
var _editorJs = require("../../actions/editor.js");
var _configEditorCss = require("./config-editor.css");
class ConfigEditorHeader extends _react.PureComponent {
    render() {
        const vegaThemes = (0, _vegaLite.omit)(_vegaThemes, [
            'version'
        ]);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
            className: "config-header",
            children: [
                "Theme:",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                    value: this.props.themeName,
                    onClick: (e)=>e.stopPropagation(),
                    id: "config-select",
                    onChange: (e)=>{
                        e.stopPropagation();
                        if (e.target.value === 'custom') {
                            this.props.setConfig('{}');
                            this.props.setConfigEditorString('{}');
                        } else {
                            this.props.setConfig((0, _jsonStringifyPrettyCompactDefault.default)(vegaThemes[e.target.value]));
                            this.props.setConfigEditorString((0, _jsonStringifyPrettyCompactDefault.default)(vegaThemes[e.target.value]));
                        }
                        this.props.setThemeName(e.target.value);
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                            value: "custom",
                            children: "Custom"
                        }),
                        Object.keys(vegaThemes).map((keyName)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: keyName,
                                children: keyName
                            }, keyName))
                    ]
                })
            ]
        });
    }
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setConfig: _editorJs.setConfig,
        setConfigEditorString: _editorJs.setConfigEditorString,
        setThemeName: _editorJs.setThemeName
    }, dispatch);
}
function mapStateToProps(state) {
    return {
        manualParse: state.manualParse,
        themeName: state.themeName
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConfigEditorHeader);

},{"react/jsx-runtime":"gonF6","json-stringify-pretty-compact":"jn76Q","react":"bmhQu","react-redux":"dwYd3","redux":"jTcSr","vega-lite":"eTD5L","vega-themes":"2t6BP","../../actions/editor.js":"wC9No","./config-editor.css":"52XWi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"52XWi":[function() {},{}],"jPRwO":[function() {},{}],"aJ7i1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        hoverEnable: state.hoverEnable,
        logLevel: state.logLevel,
        renderer: state.renderer,
        tooltipEnable: state.tooltipEnable,
        backgroundColor: state.backgroundColor,
        expressionInterpreter: state.expressionInterpreter
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setHover: _editorJs.setHover,
        setLogLevel: _editorJs.setLogLevel,
        setRenderer: _editorJs.setRenderer,
        setSettingsState: _editorJs.setSettingsState,
        setTooltip: _editorJs.setTooltip,
        setBackgroundColor: _editorJs.setBackgroundColor,
        setExpressionInterpreter: _editorJs.setExpressionInterpreter
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./renderer.js":"ltO4g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ltO4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _indexCss = require("./index.css");
/**
 * Window size in pizels after which we make the settings panel a popover.
 */ const SIZE_THRESHOLD = 1000;
const LEVEL_NAMES = {
    0: 'None',
    1: 'Error',
    2: 'Warn',
    3: 'Info',
    4: 'Debug'
};
const LOG_OPTIONS = [
    {
        label: LEVEL_NAMES[0],
        value: 0
    },
    {
        label: LEVEL_NAMES[1],
        value: 1
    },
    {
        label: LEVEL_NAMES[2],
        value: 2
    },
    {
        label: LEVEL_NAMES[3],
        value: 3
    },
    {
        label: LEVEL_NAMES[4],
        value: 4
    }
];
const HOVER_OPTIONS = [
    {
        label: 'Auto',
        value: 'Auto'
    },
    {
        label: 'On',
        value: 'On'
    },
    {
        label: 'Off',
        value: 'Off'
    }
];
class Sidebar extends (0, _react.Component) {
    listenerAttached = false;
    constructor(props){
        super(props);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleEscClick = this.handleEscClick.bind(this);
        this.setHover = this.setHover.bind(this);
    }
    componentDidMount() {
        // add click event listener depending on the screen size
        document.body.addEventListener('click', this.handleOutsideClick, true);
        // add escape event listener depending on the screen size
        window.addEventListener('keydown', this.handleEscClick, true);
        // remove or add event listeners if the window is resized;
        window.addEventListener('resize', ()=>{
            if (this.listenerAttached && window.innerWidth > SIZE_THRESHOLD) document.body.removeEventListener('click', this.handleOutsideClick, true);
            if (!this.listenerAttached && window.innerWidth <= SIZE_THRESHOLD) document.body.addEventListener('click', this.handleOutsideClick, true);
        });
    }
    handleEscClick(event) {
        // check if the window size is smaller than 1000(threshold)
        if (window.innerWidth <= SIZE_THRESHOLD && event.key === 'Escape') this.props.setSettingsState(false);
    }
    handleOutsideClick(event) {
        if (!this.listenerAttached && window.innerWidth <= SIZE_THRESHOLD) {
            const target = event.target;
            if (target.closest('.settings') || target.closest('.settings-button') || target.classList.contains('log-level-dropdown__option') || target.classList.contains('renderer-dropdown__option')) return;
            this.props.setSettingsState(false);
            this.listenerAttached = true;
        }
    }
    setHover(e) {
        let newHover = null;
        switch(e.label){
            case 'On':
                newHover = true;
                break;
            case 'Off':
                newHover = false;
                break;
            case 'Auto':
                newHover = 'auto';
        }
        this.props.setHover(newHover);
    }
    render() {
        const { logLevel, renderer, setRenderer, setBackgroundColor, backgroundColor, setLogLevel, setTooltip, tooltipEnable, expressionInterpreter, setExpressionInterpreter } = this.props;
        const hover = typeof this.props.hoverEnable !== 'boolean' ? 'Auto' : this.props.hoverEnable ? 'On' : 'Off';
        const renderers = [
            {
                value: 'svg',
                label: 'SVG'
            },
            {
                value: 'canvas',
                label: 'Canvas'
            }
        ].map((d)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "radio",
                        name: "renderer",
                        value: d.value,
                        defaultChecked: renderer === d.value,
                        onClick: (e)=>setRenderer(e.currentTarget.value)
                    }),
                    d.label
                ]
            }, d.label));
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "settings",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "select-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Renderer:"
                        }),
                        renderers
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "settings-description",
                    children: "Set Vega renderer. Canvas creates pixel graphics. SVG creates vector graphics."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "select-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Background Color:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "color",
                                id: "head",
                                name: "head",
                                defaultValue: backgroundColor,
                                onInput: (e)=>setBackgroundColor(e.target.value)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "settings-description",
                    children: "Background color of the visualization panel."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "select-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Log Level:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                className: "log-level-dropdown-wrapper",
                                classNamePrefix: "log-level-dropdown",
                                value: {
                                    value: logLevel,
                                    label: LEVEL_NAMES[logLevel]
                                },
                                options: LOG_OPTIONS,
                                onChange: (e)=>setLogLevel(e.value),
                                isClearable: false,
                                isSearchable: false
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "settings-description",
                    children: "Set log level for Vega."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "select-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Hover:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "hover-enable-select",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                className: "hover-enable-dropdown-wrapper",
                                classNamePrefix: "hover-enable-dropdown",
                                value: {
                                    label: hover,
                                    value: hover
                                },
                                options: HOVER_OPTIONS,
                                onChange: this.setHover,
                                isClearable: false,
                                isSearchable: false
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "settings-description",
                    children: [
                        "Enable or disable",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://vega.github.io/vega/docs/api/view/#view_hover",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "hover"
                        }),
                        ' ',
                        "event processing. In auto mode, Vega-Lite disables hover event processing."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "tooltips",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                onChange: (e)=>setTooltip(e.target.checked),
                                type: "checkbox",
                                name: "",
                                id: "tooltip",
                                checked: tooltipEnable
                            }),
                            "Tooltips"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "settings-description",
                    children: [
                        "Enable the default",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://github.com/vega/vega-tooltip",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: "Vega Tooltip"
                        }),
                        ' ',
                        "handler."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "expression-interpreter",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                onChange: (e)=>setExpressionInterpreter(e.target.checked),
                                type: "checkbox",
                                name: "",
                                id: "expressionInterpreter",
                                checked: expressionInterpreter
                            }),
                            "Expression Interpreter"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "settings-description",
                    children: [
                        "Enables the",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://vega.github.io/vega/usage/interpreter/",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: "Expression Interpreter"
                        }),
                        ", which is",
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: "CSP"
                        }),
                        ' ',
                        "compliant."
                    ]
                })
            ]
        });
    }
}
exports.default = Sidebar;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-select":"9WAWN","./index.css":"8x7TK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8x7TK":[function() {},{}],"bQpN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        compiledEditorRef: state.compiledEditorRef,
        debugPane: state.debugPane,
        debugPaneSize: state.debugPaneSize,
        decorations: state.decorations,
        editorFocus: state.editorFocus,
        editorRef: state.editorRef,
        error: state.error,
        errors: state.errors,
        logs: state.logs,
        navItem: state.navItem,
        settings: state.settings,
        view: state.view
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setDebugPaneSize: _editorJs.setDebugPaneSize,
        setDecorations: _editorJs.setDecorations,
        showLogs: _editorJs.showLogs,
        toggleDebugPane: _editorJs.toggleDebugPane,
        toggleNavbar: _editorJs.toggleNavbar
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./renderer.js":"1svyD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1svyD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSplitPaneR17 = require("react-split-pane-r17");
var _reactSplitPaneR17Default = parcelHelpers.interopDefault(_reactSplitPaneR17);
var _indexJs = require("../../constants/index.js");
var _indexJs1 = require("../data-viewer/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../error-boundary/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../error-pane/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../renderer/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../signal-viewer/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./debug-pane-header/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs6);
var _indexCss = require("./index.css");
var _vega = require("vega");
var _vegaLite = require("vega-lite");
var _vegaTooltip = require("vega-tooltip");
var _indexJs7 = require("../header/help-modal/index.js");
var _dataflowViewerJs = require("../../features/dataflow/DataflowViewer.js");
const defaultState = {
    header: '',
    maxRange: 0,
    range: 0
};
class VizPane extends _react.PureComponent {
    constructor(props){
        super(props);
        this.state = defaultState;
        this.handleChange = this.handleChange.bind(this);
        this.getContextViewer = this.getContextViewer.bind(this);
    }
    componentDidMount() {
        if (this.props.logs) this.props.showLogs(true);
    }
    onClickHandler(header) {
        const mainEditor = this.props.editorRef;
        const compiledEditor = this.props.compiledEditorRef;
        const editor = this.props.editorFocus === (0, _indexJs.EDITOR_FOCUS).SpecEditor ? mainEditor : compiledEditor;
        const model = editor.getModel();
        const rangeValue = model.findMatches(header, true, true, true, (0, _indexJs.WORD_SEPARATORS), true);
        editor && editor.deltaDecorations(this.props.decorations, []);
        const decorations = editor.deltaDecorations([], rangeValue.map((match)=>({
                options: {
                    inlineClassName: 'myInlineDecoration'
                },
                range: match.range
            })));
        this.props.setDecorations(decorations);
        if (rangeValue[0]) {
            editor.revealRangeInCenter(rangeValue[0].range);
            editor.focus();
            editor.layout();
            Promise.resolve().then(()=>{
                document.activeElement.blur();
            });
        }
    }
    handleChange(size) {
        this.props.setDebugPaneSize(size);
        if (size > (0, _indexJs.LAYOUT).MinPaneSize && !this.props.debugPane || size === (0, _indexJs.LAYOUT).MinPaneSize && this.props.debugPane) this.props.toggleDebugPane();
    }
    componentDidUpdate() {
        if (this.props.debugPaneSize === (0, _indexJs.LAYOUT).MinPaneSize) this.props.setDebugPaneSize((0, _indexJs.LAYOUT).DebugPaneSize);
        if (this.props.error || this.props.errors.length) this.props.showLogs(true);
    }
    /**
   *  Get the Component to be rendered in the Context Viewer.
   */ getContextViewer() {
        if (!this.props.debugPane) return null;
        if (this.props.view) switch(this.props.navItem){
            case (0, _indexJs.NAVBAR).DataViewer:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
                    onClickHandler: (header)=>this.onClickHandler(header)
                });
            case (0, _indexJs.NAVBAR).SignalViewer:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault4.default), {
                    onClickHandler: (header)=>this.onClickHandler(header)
                });
            case (0, _indexJs.NAVBAR).DataflowViewer:
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataflowViewerJs.DataflowViewer), {});
            default:
                return null;
        }
        else return null;
    }
    render() {
        const container = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "chart-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault1.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault3.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "versions",
                    children: [
                        "Vega ",
                        (0, _vega.version),
                        ", Vega-Lite ",
                        (0, _vegaLite.version),
                        ", Vega-Tooltip ",
                        (0, _vegaTooltip.version),
                        ", Editor ",
                        (0, _indexJs7.COMMIT_HASH).slice(0, 7)
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSplitPaneR17Default.default), {
            split: "horizontal",
            primary: "second",
            minSize: (0, _indexJs.LAYOUT).MinPaneSize,
            defaultSize: this.props.debugPane ? this.props.debugPaneSize : (0, _indexJs.LAYOUT).MinPaneSize,
            onChange: this.handleChange,
            pane1Style: {
                minHeight: `${(0, _indexJs.LAYOUT).MinPaneSize}px`
            },
            pane2Style: {
                height: this.props.debugPane ? (this.props.debugPaneSize || window.innerHeight * 0.4) + 'px' : (0, _indexJs.LAYOUT).MinPaneSize + 'px'
            },
            paneStyle: {
                display: 'flex'
            },
            onDragStarted: ()=>{
                if (this.props.navItem === (0, _indexJs.NAVBAR).Logs) this.props.showLogs(true);
            },
            onDragFinished: ()=>{
                if (this.props.debugPaneSize === (0, _indexJs.LAYOUT).MinPaneSize) this.props.setDebugPaneSize((0, _indexJs.LAYOUT).DebugPaneSize);
            },
            children: [
                container,
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "debug-pane",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault5.default), {}),
                        this.props.error || this.props.logs && this.props.navItem === (0, _indexJs.NAVBAR).Logs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault2.default), {}) : this.getContextViewer()
                    ]
                })
            ]
        });
    }
}
exports.default = VizPane;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-split-pane-r17":"Q6ksT","../../constants/index.js":"4z2sr","../data-viewer/index.js":"xdtk9","../error-boundary/index.js":"kfHLV","../error-pane/index.js":"lQqUc","../renderer/index.js":"87gmm","../signal-viewer/index.js":"7fe3e","./debug-pane-header/index.js":"kfKXo","./index.css":"h6kg5","vega":"jxCvh","vega-lite":"eTD5L","vega-tooltip":"jfqql","../header/help-modal/index.js":"2eUrg","../../features/dataflow/DataflowViewer.js":"9Fjpb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"xdtk9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
var _reactRedux = require("react-redux");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        editorRef: state.editorRef,
        view: state.view
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","./renderer.js":"30Vyc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"30Vyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactPaginate = require("react-paginate");
var _reactPaginateDefault = parcelHelpers.interopDefault(_reactPaginate);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _vega = require("vega");
var _indexJs = require("../error-boundary/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../table/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexCss = require("./index.css");
const initialState = {
    currentPage: 0,
    selectedData: ''
};
const ROWS_PER_PAGE = 50;
class DataViewer extends _react.PureComponent {
    state = initialState;
    debouncedDataChanged;
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.debouncedDataChanged = (0, _vega.debounce)(100, ()=>{
            this.forceUpdate();
        });
    }
    handleChange(option) {
        this.setState({
            selectedData: option.value,
            currentPage: 0
        });
    }
    handlePageChange(option) {
        const selected = option.selected;
        this.setState({
            currentPage: selected
        });
    }
    getDatasets() {
        return Object.keys(this.props.view.getState({
            data: _vega.truthy,
            signals: _vega.falsy,
            recurse: true
        }).data);
    }
    setDefaultDataset() {
        const datasets = this.getDatasets();
        if (datasets.length) this.setState({
            currentPage: 0,
            selectedData: datasets[datasets.length > 1 ? 1 : 0]
        });
    }
    componentDidMount() {
        this.setDefaultDataset();
    }
    componentWillUnmount() {
        if (this.state.selectedData) this.props.view.removeDataListener(this.state.selectedData, this.debouncedDataChanged);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.view !== prevProps.view) {
            const datasets = this.getDatasets();
            if (datasets.indexOf(this.state.selectedData) === -1) // the new view has different dataset so let's reset everything
            this.setState(initialState);
            else // the new view has the same dataset so let's not change the state but add a new listener
            this.props.view.addDataListener(this.state.selectedData, this.debouncedDataChanged);
            return;
        }
        if (this.state.selectedData === '') this.setDefaultDataset();
        else if (this.state.selectedData !== prevState.selectedData) {
            if (prevState.selectedData) this.props.view.removeDataListener(prevState.selectedData, this.debouncedDataChanged);
            this.props.view.addDataListener(this.state.selectedData, this.debouncedDataChanged);
        }
    }
    render() {
        const datasets = this.getDatasets();
        if (datasets.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "data-viewer",
            children: "Spec has no data"
        });
        datasets.push(datasets.shift()); // Move root to the end
        let selected = this.state.selectedData;
        if (datasets.indexOf(selected) < 0) selected = datasets[0];
        let pagination;
        const data = this.props.view.data(selected) || [];
        const pageCount = Math.ceil(data.length / ROWS_PER_PAGE);
        if (pageCount > 1) pagination = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPaginateDefault.default), {
            previousLabel: '<',
            nextLabel: '>',
            breakClassName: 'break',
            pageCount: pageCount,
            marginPagesDisplayed: 1,
            pageRangeDisplayed: 3,
            onPageChange: this.handlePageChange,
            containerClassName: 'pagination',
            activeClassName: 'active'
        });
        const start = ROWS_PER_PAGE * this.state.currentPage;
        const end = start + ROWS_PER_PAGE;
        const visibleData = data.slice(start, end);
        const table = data.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault1.default), {
            onClickHandler: (header)=>this.props.onClickHandler(header),
            header: Object.keys(data[0]),
            data: visibleData
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "error",
            children: "The table is empty."
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "data-viewer-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                            className: "data-dropdown",
                            value: {
                                label: selected,
                                value: selected
                            },
                            onChange: this.handleChange,
                            options: datasets.map((d)=>({
                                    label: d,
                                    value: d
                                })),
                            isClearable: false,
                            isSearchable: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pagination-wrapper",
                            children: pagination
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "data-table",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsDefault.default), {
                        children: table
                    })
                })
            ]
        });
    }
}
exports.default = DataViewer;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-paginate":"8fLnr","react-select":"9WAWN","vega":"jxCvh","../error-boundary/index.js":"kfHLV","../table/index.js":"loH5i","./index.css":"iiOz1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kfHLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        error: state.error
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        logError: _editorJs.logError,
        toggleDebugPane: _editorJs.toggleDebugPane
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./renderer.js":"6W2bz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6W2bz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _indexCss = require("./index.css");
class ErrorBoundary extends _react.PureComponent {
    componentDidCatch(error) {
        this.props.logError(error);
    }
    render() {
        if (this.props.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: "error-indicator",
            onClick: this.props.toggleDebugPane,
            children: this.props.error.message
        });
        return this.props.children;
    }
}
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./index.css":"f0Wd2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f0Wd2":[function() {},{}],"loH5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
exports.default = (0, _rendererJsDefault.default);

},{"./renderer.js":"afC8u","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"afC8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatValueLong", ()=>formatValueLong);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactFeather = require("react-feather");
var _vega = require("vega");
var _vegaTooltip = require("vega-tooltip");
var _indexCss = require("./index.css");
const MAX_DEPTH = 3;
const MAX_LENGTH = 150;
class Table extends _react.PureComponent {
    render() {
        let { header } = this.props;
        const { data, onClickHandler } = this.props;
        const singleColumn = this.props.header.length == 0;
        if (singleColumn) header = [
            'datum'
        ];
        const headerNodes = header.map((h)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                onClick: ()=>onClickHandler && onClickHandler(h),
                children: [
                    h,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Search), {})
                ]
            }, h));
        const tableBody = data.map((row, i)=>{
            if (singleColumn) row = {
                datum: row
            };
            const rowNodes = header.map((field, j)=>{
                let tooLong = false;
                let formatted = '';
                if (!(0, _vega.isDate)(row[field])) {
                    tooLong = formatValueLong(row[field]).tooLong;
                    formatted = formatValueLong(row[field]).formatted;
                } else {
                    tooLong = false;
                    formatted = new Date(row[field]).toUTCString();
                }
                const key = `${field} ${j}`;
                if (tooLong) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    title: "The field is too large to be displayed. Please use the view API (see JS console).",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "(...)"
                    })
                }, key);
                else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    children: formatted
                }, key);
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                children: rowNodes
            }, i);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "editor-table",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                        children: headerNodes
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: tableBody
                })
            ]
        });
    }
}
exports.default = Table;
function formatNumberValue(value) {
    return isNaN(value) ? 'NaN' : value === Number.POSITIVE_INFINITY ? 'Infinity' : value === Number.NEGATIVE_INFINITY ? '-Infinity' : (0, _vegaTooltip.stringify)(value, MAX_DEPTH);
}
function formatValueLong(value) {
    const formatted = value === undefined ? 'undefined' : typeof value == 'number' ? formatNumberValue(value) : (0, _vega.isFunction)(value) ? value.toString() : (0, _vegaTooltip.stringify)(value, MAX_DEPTH);
    if (formatted.length > MAX_LENGTH) return {
        formatted: null,
        tooLong: true
    };
    return {
        formatted,
        tooLong: false
    };
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","vega":"jxCvh","vega-tooltip":"jfqql","./index.css":"beSQk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"beSQk":[function() {},{}],"iiOz1":[function() {},{}],"lQqUc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
var _reactRedux = require("react-redux");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        error: state.error,
        errors: state.errors,
        warns: state.warns,
        debugs: state.debugs,
        infos: state.infos
    };
}
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","./renderer.js":"9yA34","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9yA34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _indexCss = require("./index.css");
class ErrorPane extends _react.Component {
    render() {
        const list = [];
        let i = 1;
        if (this.props.error) list.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "error",
                    children: "[Error] "
                }),
                this.props.error.message
            ]
        }, 0));
        this.props.errors.forEach((error)=>{
            list.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "error",
                        children: "[Error] "
                    }),
                    error
                ]
            }, i++));
        });
        this.props.warns.forEach((warning)=>{
            list.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "warning",
                        children: "[Warning] "
                    }),
                    warning
                ]
            }, i++));
        });
        this.props.infos.forEach((info)=>{
            list.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "info",
                        children: "[Info] "
                    }),
                    info
                ]
            }, i++));
        });
        if (this.props.debugs.length > 0) /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "debug",
                    children: "[Debug] "
                }),
                "Debug messages are not shown in the editor. Open the browser console to view debug logs."
            ]
        }, i++);
        if (list.length === 0) list.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "info",
                    children: "[Info] "
                }),
                "No error, infos, or warnings"
            ]
        }, 'no error'));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "error-pane",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                children: list
            })
        });
    }
}
exports.default = ErrorPane;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./index.css":"eXTlZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eXTlZ":[function() {},{}],"87gmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _pulsesSliceJs = require("../../features/dataflow/pulsesSlice.js");
var _runtimeSliceJs = require("../../features/dataflow/runtimeSlice.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        baseURL: state.baseURL,
        config: state.config,
        editorString: state.editorString,
        hoverEnable: state.hoverEnable,
        logLevel: state.logLevel,
        mode: state.mode,
        renderer: state.renderer,
        tooltipEnable: state.tooltipEnable,
        vegaLiteSpec: state.vegaLiteSpec,
        normalizedVegaLiteSpec: state.normalizedVegaLiteSpec,
        vegaSpec: state.vegaSpec,
        view: state.view,
        backgroundColor: state.backgroundColor,
        expressionInterpreter: state.expressionInterpreter
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        setView: _editorJs.setView,
        setRuntime: (0, _runtimeSliceJs.setRuntime),
        recordPulse: (0, _pulsesSliceJs.recordPulse)
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","../../features/dataflow/pulsesSlice.js":"eeulL","../../features/dataflow/runtimeSlice.js":"iZrZf","./renderer.js":"aUGmZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aUGmZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactFeather = require("react-feather");
var _reactPortal = require("react-portal");
var _reactRouterDom = require("react-router-dom");
var _vega = require("vega");
var _vegaLite = require("vega-lite");
var _vegaTooltip = require("vega-tooltip");
var _vegaTooltipDefault = parcelHelpers.interopDefault(_vegaTooltip);
var _indexJs = require("../../constants/index.js");
var _addProjectionsJs = require("../../utils/addProjections.js");
var _addProjectionsJsDefault = parcelHelpers.interopDefault(_addProjectionsJs);
var _loggerJs = require("../../utils/logger.js");
var _indexJs1 = require("../popup/index.js");
var _indexCss = require("./index.css");
var _vegaInterpreter = require("vega-interpreter");
// Add additional projections
(0, _addProjectionsJsDefault.default)(_vega.projection);
const defaultState = {
    fullscreen: false,
    width: 500,
    height: 300
};
class Editor extends _react.PureComponent {
    static pathname;
    constructor(props){
        super(props);
        this.state = defaultState;
        this.handleKeydown = this.handleKeydown.bind(this);
        this.onOpenPortal = this.onOpenPortal.bind(this);
        this.onClosePortal = this.onClosePortal.bind(this);
        this.runAfter = this.runAfter.bind(this);
    }
    onOpenPortal() {
        const { pathname } = Editor;
        if (pathname !== '/' && pathname !== '/edited' && !pathname.endsWith('/view')) this.props.history.push(pathname + '/view');
    }
    onClosePortal() {
        let pathname = Editor.pathname;
        pathname = pathname.split('/').filter((e)=>e !== 'view').join('/');
        if (pathname !== '/' && pathname !== '/edited') this.props.history.push(pathname);
    }
    handleKeydown(e) {
        // Close portal on pressing escape key
        if (e.keyCode === (0, _indexJs.KEYCODES).ESCAPE && this.state.fullscreen) this.setState({
            fullscreen: false
        }, this.onClosePortal);
    }
    // Determine if the Vega spec has responsive width/height.
    // Current criteria:
    // - Width(height) is defined as a signal
    // - The init property of the signal uses "containerSize".
    isResponsive() {
        const spec = this.props.vegaSpec;
        let responsiveWidth = false;
        let responsiveHeight = false;
        if (spec.signals) for (const signal of spec.signals){
            if (signal.name == 'width' && signal.init && signal.init.indexOf('containerSize') >= 0) responsiveWidth = true;
            if (signal.name == 'height' && signal.init && signal.init.indexOf('containerSize') >= 0) responsiveHeight = true;
        }
        return {
            responsiveWidth,
            responsiveHeight
        };
    }
    handleResizeMouseDown(eDown) {
        const { responsiveWidth, responsiveHeight } = this.isResponsive();
        // Record initial mouse position and view size
        const x0 = eDown.pageX;
        const y0 = eDown.pageY;
        const width0 = this.state.width;
        const height0 = this.state.height;
        // Update size on window.mousemove
        const onMove = (eMove)=>{
            const x1 = eMove.pageX;
            const y1 = eMove.pageY;
            const factor = this.state.fullscreen ? 2 : 1;
            this.setState({
                width: responsiveWidth ? Math.max(10, width0 + (x1 - x0) * factor) : this.state.width,
                height: responsiveHeight ? Math.max(10, height0 + (y1 - y0) * factor) : this.state.height
            }, ()=>{
                // Dispatch window.resize, that currently the only way to inform Vega about container size change.
                this.triggerResize();
            });
        };
        const onUp = ()=>{
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    }
    initView() {
        const { vegaSpec, vegaLiteSpec, normalizedVegaLiteSpec, config, baseURL, mode, setView, setRuntime, hoverEnable, expressionInterpreter } = this.props;
        const parseOptions = expressionInterpreter ? {
            ast: true
        } : {};
        // In vl mode, we compile Vega-Lite spec along with config to Vega spec
        const runtime = _vega.parse(vegaSpec, mode === (0, _indexJs.Mode).VegaLite ? {} : config, parseOptions);
        const loader = _vega.loader();
        const originalLoad = loader.load.bind(loader);
        // Custom Loader
        loader.load = async (url, options)=>{
            try {
                if (options) return await originalLoad(url, {
                    ...options,
                    baseURL: baseURL
                });
                return await originalLoad(url, {
                    baseURL: baseURL
                });
            } catch  {
                return await originalLoad(url, options);
            }
        };
        // Finalize previous view so that memory can be freed
        if (this.props.view) {
            // Remove run after callback for the previous view
            // to disable logging from an evaluate that will run after we finalize it
            this.props.view._postrun = [];
            this.props.view.finalize();
        }
        const hover = typeof hoverEnable === 'boolean' ? hoverEnable : mode === (0, _indexJs.Mode).Vega;
        const view = new _vega.View(runtime, {
            hover,
            loader,
            expr: expressionInterpreter ? (0, _vegaInterpreter.expressionInterpreter) : undefined
        });
        view.runAfter(this.runAfter, true);
        view.logger((0, _loggerJs.dispatchingLogger));
        const debug = window.VEGA_DEBUG;
        debug.view = view;
        debug.vegaSpec = vegaSpec;
        debug.config = config;
        if (mode === (0, _indexJs.Mode).VegaLite) {
            debug.vegaLiteSpec = vegaLiteSpec;
            debug.normalizedVegaLiteSpec = normalizedVegaLiteSpec;
        } else debug.vegaLiteSpec = debug.normalizedVegaLiteSpec = undefined;
        setRuntime(runtime);
        setView(view);
    }
    runAfter(df) {
        const clock = df._clock;
        // Mapping from ID to value
        const values = {};
        const toProcessContexts = new Set([
            df._runtime
        ]);
        const processedContexts = new Set();
        while(toProcessContexts.size > 0){
            const context = toProcessContexts.values().next().value;
            toProcessContexts.delete(context);
            processedContexts.add(context);
            for (const [id, operator] of Object.entries(context.nodes))if (operator.stamp === clock) values[id] = operator.value;
            for (const subContext of context.subcontext ?? [])if (!processedContexts.has(subContext)) toProcessContexts.add(subContext);
        }
        this.props.recordPulse(clock, values);
        // Set it up to run again
        df.runAfter(this.runAfter, true, 10);
    }
    async renderVega() {
        // Selecting chart for rendering vega
        const chart = this.state.fullscreen ? this.refs.fchart : this.refs.chart;
        if (!(this.isResponsive().responsiveWidth || this.isResponsive().responsiveHeight)) {
            chart.style.width = chart.getBoundingClientRect().width + 'px';
            chart.style.width = 'auto';
        }
        // Parsing pathname from URL
        Editor.pathname = window.location.hash.split('#')[1];
        const { view, renderer, tooltipEnable } = this.props;
        if (!view) return;
        view.renderer(renderer).initialize(chart);
        await view.runAsync();
        if (tooltipEnable) // Tooltip needs to be added after initializing the view with `chart`
        (0, _vegaTooltipDefault.default)(view);
    }
    triggerResize() {
        try {
            window.dispatchEvent(new Event('resize'));
        } catch (e) {
            console.error(e);
        }
    }
    componentDidMount() {
        this.initView();
        this.renderVega();
        // Add Event Listener to ctrl+f11 key
        document.addEventListener('keydown', (e)=>{
            // Keycode of f11 is 122
            if (e.keyCode === 122 && (e.ctrlKey || e.metaKey)) this.setState((current)=>({
                    ...current,
                    fullscreen: !current.fullscreen
                }));
        });
        document.addEventListener('keydown', this.handleKeydown);
        // Enter fullscreen mode if url ends with /view
        const params = Editor.pathname.split('/');
        if (params[params.length - 1] === 'view') this.setState({
            fullscreen: true
        });
    }
    componentDidUpdate(prevProps) {
        if (!(0, _vegaLite.deepEqual)(prevProps.vegaSpec, this.props.vegaSpec) || !(0, _vegaLite.deepEqual)(prevProps.vegaLiteSpec, this.props.vegaLiteSpec) || prevProps.baseURL !== this.props.baseURL || !(0, _vegaLite.deepEqual)(prevProps.config, this.props.config) || !(0, _vegaLite.deepEqual)(prevProps.logLevel, this.props.logLevel) || !(0, _vegaLite.deepEqual)(prevProps.mode, this.props.mode) || !(0, _vegaLite.deepEqual)(prevProps.hoverEnable, this.props.hoverEnable) || !(0, _vegaLite.deepEqual)(prevProps.tooltipEnable, this.props.tooltipEnable) || prevProps.expressionInterpreter !== this.props.expressionInterpreter) this.initView();
        this.renderVega();
    }
    componentWillUnmount() {
        // Remove listener to event keydown
        document.removeEventListener('keydown', this.handleKeydown);
    }
    // Render resize handle for responsive charts
    renderResizeHandle() {
        const { responsiveWidth, responsiveHeight } = this.isResponsive();
        if (responsiveWidth || responsiveHeight) // The handle is defined as a inline SVG
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "chart-resize-handle",
            onMouseDown: this.handleResizeMouseDown.bind(this),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                width: "10",
                height: "10",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M-2,13L13,-2 M-2,16L16,-2 M-2,19L19,-2"
                })
            })
        });
    }
    render() {
        const { responsiveWidth, responsiveHeight } = this.isResponsive();
        // Determine chart element style based on responsiveness
        const chartStyle = responsiveWidth || responsiveHeight ? {
            width: responsiveWidth ? this.state.width + 'px' : null,
            height: responsiveHeight ? this.state.height + 'px' : null
        } : {};
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "chart",
                    style: {
                        backgroundColor: this.props.backgroundColor
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.Popup), {
                            content: `Click on "Continue Recording" to make the chart interactive`,
                            placement: "right",
                            // Make skinnier so it fits on the right side of the chart
                            maxWidth: 200,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "chart-overlay"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            "aria-label": "visualization",
                            ref: "chart",
                            style: chartStyle
                        }),
                        this.renderResizeHandle()
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "fullscreen-open",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs1.Popup), {
                        content: "Fullscreen",
                        placement: "left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Maximize), {
                            onClick: ()=>{
                                this.setState({
                                    fullscreen: true
                                }, this.onOpenPortal);
                            }
                        })
                    })
                }),
                this.state.fullscreen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "fullscreen-chart",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "chart",
                                style: {
                                    backgroundColor: this.props.backgroundColor
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        ref: "fchart",
                                        style: chartStyle
                                    }),
                                    this.renderResizeHandle()
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "fullscreen-close",
                                onClick: ()=>{
                                    this.setState({
                                        fullscreen: false
                                    }, this.onClosePortal);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Edit Visualization"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(Editor);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","react-portal":"18Y94","react-router-dom":"b9X5n","vega":"jxCvh","vega-lite":"eTD5L","vega-tooltip":"jfqql","../../constants/index.js":"4z2sr","../../utils/addProjections.js":"eEQSi","../../utils/logger.js":"2yOzg","../popup/index.js":"iYrgc","./index.css":"9r15c","vega-interpreter":"gqRSK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eEQSi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(vegaProjections) {
        for (const p of [
            'airy',
            'aitoff',
            'armadillo',
            'august',
            'baker',
            'berghaus',
            'bertin1953',
            'boggs',
            'bonne',
            'bottomley',
            'bromley',
            'chamberlinAfrica',
            'collignon',
            'craig',
            'craster',
            'cylindricalEqualArea',
            'cylindricalStereographic',
            'eckert1',
            'eckert2',
            'eckert3',
            'eckert4',
            'eckert5',
            'eckert6',
            'eisenlohr',
            'fahey',
            'foucaut',
            'foucautSinusoidal',
            'gilbert',
            'gingery',
            'ginzburg4',
            'ginzburg5',
            'ginzburg6',
            'ginzburg8',
            'ginzburg9',
            'gringorten',
            'guyou',
            'hammer',
            'hammerRetroazimuthal',
            'healpix',
            'hill',
            'homolosine',
            'hufnagel',
            'hyperElliptical',
            'interruptedBoggs',
            'interruptedHomolosine',
            'interruptedMollweide',
            'interruptedMollweideHemispheres',
            'interruptedSinuMollweide',
            'interruptedSinusoidal',
            'interruptedQuarticAuthalic',
            'kavrayskiy7',
            'lagrange',
            'larrivee',
            'laskowski',
            'littrow',
            'loximuthal',
            'miller',
            'modifiedStereographicAlaska',
            'modifiedStereographicGs48',
            'modifiedStereographicGs50',
            'modifiedStereographicMiller',
            'modifiedStereographicLee',
            // 'mollweide', // included in vega-projection
            'mtFlatPolarParabolic',
            'mtFlatPolarQuartic',
            'mtFlatPolarSinusoidal',
            'naturalEarth2',
            'nellHammer',
            'nicolosi',
            'patterson',
            'polyconic',
            'polyhedralButterfly',
            'polyhedralCollignon',
            'polyhedralWaterman',
            'gringortenQuincuncial',
            'peirceQuincuncial',
            'rectangularPolyconic',
            'robinson',
            'satellite',
            'sinuMollweide',
            'sinusoidal',
            'times',
            'twoPointAzimuthalUsa',
            'twoPointEquidistantUsa',
            'vanDerGrinten',
            'vanDerGrinten2',
            'vanDerGrinten3',
            'vanDerGrinten4',
            'wagner',
            'wagner4',
            'wagner6',
            'wagner7',
            'wiechel',
            'winkel3'
        ])vegaProjections(p, _d3GeoProjection[`geo${p[0].toUpperCase()}${p.slice(1)}`]);
    });
var _d3GeoProjection = require("d3-geo-projection");

},{"d3-geo-projection":"50OFW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2yOzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalLogger", ()=>LocalLogger);
parcelHelpers.export(exports, "DispatchingLogger", ()=>DispatchingLogger);
parcelHelpers.export(exports, "dispatchingLogger", ()=>dispatchingLogger);
var _indexJs = require("./../index.js");
var _vega = require("vega");
class LocalLogger {
    warns = [];
    infos = [];
    debugs = [];
    #level = 0;
    level(_) {
        if (arguments.length) {
            this.#level = +_;
            return this;
        } else return this.#level;
    }
    warn(...args) {
        if (this.#level >= _vega.Warn) this.warns.push(...args);
        return this;
    }
    info(...args) {
        if (this.#level >= _vega.Info) this.infos.push(...args);
        return this;
    }
    debug(...args) {
        if (this.#level >= _vega.Debug) this.debugs.push(...args);
        return this;
    }
    error(...args) {
        throw new Error(...args);
    }
}
class DispatchingLogger {
    level = (_)=>{
        if (_ !== undefined) {
            (0, _indexJs.store).dispatch({
                type: 'SET_LOG_LEVEL',
                logLevel: _
            });
            return this;
        } else return (0, _indexJs.store).getState().logLevel;
    };
    warn = (...args)=>{
        if (this.level() >= _vega.Warn) {
            console.warn(...args);
            (0, _indexJs.store).dispatch({
                type: 'WARN',
                warn: args[0]
            });
        }
        return this;
    };
    info = (...args)=>{
        if (this.level() >= _vega.Info) {
            console.info(...args);
            (0, _indexJs.store).dispatch({
                type: 'INFO',
                info: args[0]
            });
        }
        return this;
    };
    debug = (...args)=>{
        if (this.level() >= _vega.Debug) {
            console.debug(...args);
            (0, _indexJs.store).dispatch({
                type: 'DEBUG',
                debug: args[0]
            });
        }
        return this;
    };
    error = (...args)=>{
        // TODO: remove as any
        if (this.level() >= _vega.Error) {
            console.warn(...args);
            (0, _indexJs.store).dispatch({
                type: 'ERROR',
                error: 'message' in args[0] ? args[0].message : args[0]
            });
        }
        return this;
    };
}
const dispatchingLogger = new DispatchingLogger();

},{"./../index.js":"5DEId","vega":"jxCvh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iYrgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popup", ()=>Popup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _tippyCss = require("tippy.js/dist/tippy.css");
var _lightBorderCss = require("tippy.js/themes/light-border.css");
var _react1 = require("@tippyjs/react");
var _reactDefault = parcelHelpers.interopDefault(_react1);
function Popup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default), {
        theme: "light-border",
        ...props
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","tippy.js/dist/tippy.css":"eWT1n","tippy.js/themes/light-border.css":"b3gtp","@tippyjs/react":"anF3m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eWT1n":[function() {},{}],"b3gtp":[function() {},{}],"anF3m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tippy", ()=>(0, _tippyJsDefault.default));
parcelHelpers.export(exports, "useSingleton", ()=>useSingleton);
var _tippyJs = require("tippy.js");
var _tippyJsDefault = parcelHelpers.interopDefault(_tippyJs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === 'function') ref(node);
        if (({}).hasOwnProperty.call(ref, 'current')) ref.current = node;
    }
}
function ssrSafeCreateDiv() {
    return isBrowser && document.createElement('div');
}
function toDataAttributes(attrs) {
    var dataAttrs = {
        'data-placement': attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs['data-reference-hidden'] = '';
    if (attrs.escaped) dataAttrs['data-escaped'] = '';
    return dataAttrs;
}
function deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var useIsomorphicLayoutEffect = isBrowser ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, _react.useRef)();
    if (!ref.current) ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    return ref.current;
}
function updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            updateClassName(box, 'add', instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) updateClassName(box, 'remove', instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = _objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, _react.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, _react.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, _react.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = useMutableBox(function() {
            return {
                container: ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = 'manual';
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(instance, event) {
                                var node = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                });
                                instance.state.$$activeSingletonInstance = node.instance;
                                setSingletonContent(node.content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty('current')) element = reference.current;
            var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
        });
        useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== '$$tippyReact';
                    }), [
                        {
                            name: '$$tippyReact',
                            enabled: true,
                            phase: 'beforeWrite',
                            requires: [
                                'computeStyles'
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children ? /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, _reactDom.createPortal)(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, _react.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = useMutableBox({
            children: [],
            renders: 1
        });
        useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = _objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps(deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, _react.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                    mutableBox.setSingletonContent = data.setSingletonContent;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    var _mutableBox$instance, _mutableBox$instance2;
                    mutableBox.children = mutableBox.children.filter(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance !== instance;
                    });
                    mutableBox.children.push(data);
                    if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) mutableBox.setSingletonContent == null || mutableBox.setSingletonContent(data.content);
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = _objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, _reactDefault.default).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: function ref(node) {
                preserveRef(_ref2, node);
                preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var useSingleton = /*#__PURE__*/ useSingletonGenerator((0, _tippyJs.createSingleton));
var index = /*#__PURE__*/ forwardRef(/*#__PURE__*/ TippyGenerator((0, _tippyJsDefault.default)));
exports.default = index;

},{"tippy.js":"4N7WL","react":"bmhQu","react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4N7WL":[function(require,module,exports,__globalThis) {
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateFill", ()=>animateFill);
parcelHelpers.export(exports, "createSingleton", ()=>createSingleton);
parcelHelpers.export(exports, "delegate", ()=>delegate);
parcelHelpers.export(exports, "followCursor", ()=>followCursor);
parcelHelpers.export(exports, "hideAll", ()=>hideAll);
parcelHelpers.export(exports, "inlinePositioning", ()=>inlinePositioning);
parcelHelpers.export(exports, "roundArrow", ()=>ROUND_ARROW);
parcelHelpers.export(exports, "sticky", ()=>sticky);
var _core = require("@popperjs/core");
var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
    return [].concat(value);
}
function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function getBasePlacement(placement) {
    return placement.split('-')[0];
}
function arrayFrom(value) {
    return [].slice.call(value);
}
function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function div() {
    return document.createElement('div');
}
function isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return isType(value, type);
    });
}
function isNodeList(value) {
    return isType(value, 'NodeList');
}
function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
    if (isElement(value)) return [
        value
    ];
    if (isNodeList(value)) return arrayFrom(value);
    if (Array.isArray(value)) return value;
    return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var currentInput = {
    isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function onDocumentTouchStart() {
    if (currentInput.isTouch) return;
    currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function onDocumentMouseMove() {
    var now = performance.now();
    if (now - lastMouseMoveTime < 20) {
        currentInput.isTouch = false;
        document.removeEventListener('mousemove', onDocumentMouseMove);
    }
    lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function onWindowBlur() {
    var activeElement = document.activeElement;
    if (isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
}
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? !!window.msCrypto : false;
function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function getFormattedMessage(message) {
    return [
        getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var visitedMessages;
function resetVisitedMessages() {
    visitedMessages = new Set();
}
function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
        var _console;
        visitedMessages.add(message);
        (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
}
function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
        var _console2;
        visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
}
function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        defaultProps[key] = partialProps[key];
    });
};
function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
        plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
        var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var innerHTML = function innerHTML() {
    return 'innerHTML';
};
function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
}
function createArrowElement(value) {
    var arrow = div();
    if (value === true) arrow.className = ARROW_CLASS;
    else {
        arrow.className = SVG_ARROW_CLASS;
        if (isElement(value)) arrow.appendChild(value);
        else dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function setContent(content, props) {
    if (isElement(props.content)) {
        dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains(CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains(BACKDROP_CLASS);
        })
    };
}
function render(instance) {
    var popper = div();
    var box = div();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild(createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild(createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`
var mountedInstances = [];
function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if (currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if (normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return actualContains(el, actualTarget);
        })) {
            if (currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, _core.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if (currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                setTransitionDuration([
                    _box,
                    _content
                ], duration);
                setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                setTransitionDuration([
                    box,
                    content
                ], duration);
                setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        mountedInstances = mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return isElement(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var applyStylesModifier = Object.assign({}, (0, _core.applyStyles), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var createSingleton = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function delegate(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = tippy(targets, parentProps);
    var normalizedReturnValue = normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var animateFill = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function createBackdropElement() {
    var backdrop = div();
    backdrop.className = BACKDROP_CLASS;
    setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var mouseCoords = {
    clientX: 0,
    clientY: 0
};
var activeInstances = [];
function storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', storeMouseCoords);
}
function removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', storeMouseCoords);
}
var followCursor = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            activeInstances = activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if (activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove(mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var inlinePositioning = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps(getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) {
                    var rects = arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var sticky = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
tippy.setDefaultProps({
    render: render
});
exports.default = tippy;

},{"@popperjs/core":"gMjEJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gMjEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":"79wNe","./createPopper.js":false,"./popper.js":"kMmqe","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9CWfx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"79wNe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyles", ()=>(0, _applyStylesJsDefault.default));
parcelHelpers.export(exports, "arrow", ()=>(0, _arrowJsDefault.default));
parcelHelpers.export(exports, "computeStyles", ()=>(0, _computeStylesJsDefault.default));
parcelHelpers.export(exports, "eventListeners", ()=>(0, _eventListenersJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "hide", ()=>(0, _hideJsDefault.default));
parcelHelpers.export(exports, "offset", ()=>(0, _offsetJsDefault.default));
parcelHelpers.export(exports, "popperOffsets", ()=>(0, _popperOffsetsJsDefault.default));
parcelHelpers.export(exports, "preventOverflow", ()=>(0, _preventOverflowJsDefault.default));
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _arrowJs = require("./arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _computeStylesJs = require("./computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _eventListenersJs = require("./eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _hideJs = require("./hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _offsetJs = require("./offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _popperOffsetsJs = require("./popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _preventOverflowJs = require("./preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);

},{"./applyStyles.js":"3cXVv","./arrow.js":false,"./computeStyles.js":false,"./eventListeners.js":false,"./flip.js":false,"./hide.js":false,"./offset.js":false,"./popperOffsets.js":false,"./preventOverflow.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cXVv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"7oCwI","../dom-utils/instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7oCwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4TIRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8w2sO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ix8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"7BYT3","../dom-utils/getLayoutRect.js":"b8HWl","../dom-utils/contains.js":"7KsA7","../dom-utils/getOffsetParent.js":"8UGZD","../utils/getMainAxisFromPlacement.js":"buXVK","../utils/within.js":"kgqKD","../utils/mergePaddingObject.js":"hDP2R","../utils/expandToHashMap.js":"5s8A5","../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7BYT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8HWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"9Cf34","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Cf34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"4TIRi","../utils/math.js":"1EWdm","./getWindow.js":"8w2sO","./isLayoutViewport.js":"6Av1k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EWdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Av1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6dyvO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6dyvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KsA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8UGZD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"8w2sO","./getNodeName.js":"7oCwI","./getComputedStyle.js":"jVooW","./instanceOf.js":"4TIRi","./isTableElement.js":"gponE","./getParentNode.js":"lDflw","../utils/userAgent.js":"6dyvO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jVooW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gponE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"7oCwI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDflw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"7oCwI","./getDocumentElement.js":"6ADI2","./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ADI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"buXVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kgqKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hDP2R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"kAN9N","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kAN9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5s8A5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"01Efw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"9CWfx","../dom-utils/getOffsetParent.js":"8UGZD","../dom-utils/getWindow.js":"8w2sO","../dom-utils/getDocumentElement.js":"6ADI2","../dom-utils/getComputedStyle.js":"jVooW","../utils/getBasePlacement.js":"7BYT3","../utils/getVariation.js":"2Us86","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Us86":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bVIhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cogtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"fKKnP","../utils/getBasePlacement.js":"7BYT3","../utils/getOppositeVariationPlacement.js":"76l4A","../utils/detectOverflow.js":"e1TOL","../utils/computeAutoPlacement.js":"hsHYl","../enums.js":"9CWfx","../utils/getVariation.js":"2Us86","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fKKnP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76l4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e1TOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"csGCt","../dom-utils/getDocumentElement.js":"6ADI2","../dom-utils/getBoundingClientRect.js":"9Cf34","./computeOffsets.js":"5fJUw","./rectToClientRect.js":"aYxjG","../enums.js":"9CWfx","../dom-utils/instanceOf.js":"4TIRi","./mergePaddingObject.js":"hDP2R","./expandToHashMap.js":"5s8A5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"csGCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"9CWfx","./getViewportRect.js":"1uEvb","./getDocumentRect.js":"4xDfl","./listScrollParents.js":"6EVlq","./getOffsetParent.js":"8UGZD","./getDocumentElement.js":"6ADI2","./getComputedStyle.js":"jVooW","./instanceOf.js":"4TIRi","./getBoundingClientRect.js":"9Cf34","./getParentNode.js":"lDflw","./contains.js":"7KsA7","./getNodeName.js":"7oCwI","../utils/rectToClientRect.js":"aYxjG","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1uEvb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"8w2sO","./getDocumentElement.js":"6ADI2","./getWindowScrollBarX.js":"h4IJk","./isLayoutViewport.js":"6Av1k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4IJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"9Cf34","./getDocumentElement.js":"6ADI2","./getWindowScroll.js":"7wuKP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7wuKP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4xDfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"6ADI2","./getComputedStyle.js":"jVooW","./getWindowScrollBarX.js":"h4IJk","./getWindowScroll.js":"7wuKP","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6EVlq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"fCJLI","./getParentNode.js":"lDflw","./getWindow.js":"8w2sO","./isScrollParent.js":"fupCg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fCJLI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"lDflw","./isScrollParent.js":"fupCg","./getNodeName.js":"7oCwI","./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fupCg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"jVooW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aYxjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fJUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"7BYT3","./getVariation.js":"2Us86","./getMainAxisFromPlacement.js":"buXVK","../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hsHYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"2Us86","../enums.js":"9CWfx","./detectOverflow.js":"e1TOL","./getBasePlacement.js":"7BYT3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9wu2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"9CWfx","../utils/detectOverflow.js":"e1TOL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3jaKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"7BYT3","../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2U77E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"5fJUw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2yxg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"9CWfx","../utils/getBasePlacement.js":"7BYT3","../utils/getMainAxisFromPlacement.js":"buXVK","../utils/getAltAxis.js":"jelFJ","../utils/within.js":"kgqKD","../dom-utils/getLayoutRect.js":"b8HWl","../dom-utils/getOffsetParent.js":"8UGZD","../utils/detectOverflow.js":"e1TOL","../utils/getVariation.js":"2Us86","../utils/getFreshSideObject.js":"kAN9N","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jelFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyyyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"eA0dC","./dom-utils/getLayoutRect.js":"b8HWl","./dom-utils/listScrollParents.js":"6EVlq","./dom-utils/getOffsetParent.js":"8UGZD","./utils/orderModifiers.js":"3cWku","./utils/debounce.js":"1Z8l1","./utils/mergeByName.js":"4SGnj","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eA0dC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"9Cf34","./getNodeScroll.js":"eRLN3","./getNodeName.js":"7oCwI","./instanceOf.js":"4TIRi","./getWindowScrollBarX.js":"h4IJk","./getDocumentElement.js":"6ADI2","./isScrollParent.js":"fupCg","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eRLN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"7wuKP","./getWindow.js":"8w2sO","./instanceOf.js":"4TIRi","./getHTMLElementScroll.js":"4j4AY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4j4AY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cWku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Z8l1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4SGnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMmqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"lyyyk","./modifiers/eventListeners.js":"bVIhS","./modifiers/popperOffsets.js":"2U77E","./modifiers/computeStyles.js":"01Efw","./modifiers/applyStyles.js":"3cXVv","./modifiers/offset.js":"3jaKS","./modifiers/flip.js":"cogtI","./modifiers/preventOverflow.js":"2yxg5","./modifiers/arrow.js":"9ix8f","./modifiers/hide.js":"9wu2u","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9r15c":[function() {},{}],"7fe3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _editorJs = require("../../actions/editor.js");
var _rendererJs = require("./renderer.js");
var _rendererJsDefault = parcelHelpers.interopDefault(_rendererJs);
function mapStateToProps(state) {
    return {
        signals: state.signals,
        view: state.view
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        addSignal: _editorJs.addSignal,
        setSignals: _editorJs.setSignals,
        setView: _editorJs.setView
    }, dispatch);
}
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _rendererJsDefault.default));

},{"react-redux":"dwYd3","redux":"jTcSr","../../actions/editor.js":"wC9No","./renderer.js":"3IRKl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3IRKl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _vega = require("vega");
var _indexCss = require("./index.css");
var _signalRowJs = require("./signalRow.js");
var _signalRowJsDefault = parcelHelpers.interopDefault(_signalRowJs);
var _timelineRowJs = require("./TimelineRow.js");
var _timelineRowJsDefault = parcelHelpers.interopDefault(_timelineRowJs);
class SignalViewer extends (0, _reactDefault.default).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            countSignal: {},
            hoverValue: {},
            isTimelineSelected: false,
            isHovered: false,
            keys: [],
            maskListener: false,
            maxLength: 0,
            signal: {},
            xCount: 0,
            timeline: false
        };
    }
    getKeys(ref = this.props) {
        return Object.keys(ref.view.getState({
            data: _vega.falsy,
            signals: _vega.truthy,
            recurse: true
        }).signals);
    }
    getSignals(changedSignal = null) {
        if (!this.state.timeline) return;
        if (changedSignal) {
            const obj = {
                value: this.props.view.signal(changedSignal)
            };
            const lastObj = this.props.signals[changedSignal];
            const prevObj = {
                ...lastObj[lastObj && lastObj.length - 1]
            };
            delete prevObj.xCount;
            obj.xCount = this.state.xCount;
            const newSignals = this.props.signals[changedSignal].concat(obj);
            this.props.setSignals({
                ...this.props.signals,
                [changedSignal]: newSignals
            });
            this.setState((current)=>({
                    ...current,
                    xCount: current.xCount + 1
                }));
        } else {
            const obj = {};
            this.state.keys.map((key)=>{
                if (obj[key]) obj[key].push({
                    value: this.props.view.signal(key),
                    xCount: this.state.xCount
                });
                else obj[key] = [
                    {
                        value: this.props.view.signal(key),
                        xCount: this.state.xCount
                    }
                ];
            });
            this.props.setSignals(obj);
            this.setState({
                xCount: this.state.xCount + 1
            });
        }
    }
    onClickInit(key, hoverValue) {
        this.setState({
            maskListener: true
        });
        const overlay = document.querySelector('.chart-overlay');
        overlay.style.display = 'block';
        this.onHoverInit(key, hoverValue, true); // hover calculation with persist
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.view !== nextProps.view) {
            const keys = this.getKeys(nextProps);
            this.setState({
                keys,
                signal: {},
                xCount: 0,
                timeline: false,
                isHovered: false,
                isTimelineSelected: false,
                hoverValue: {},
                countSignal: {},
                maskListener: false
            }, ()=>{
                const overlay = document.querySelector('.chart-overlay');
                // remove the overlay
                overlay.style.display = 'none';
                if (this.state.timeline) {
                    const obj = {};
                    this.state.keys.map((key)=>{
                        if (obj[key]) obj[key].push({
                            value: this.props.view.signal(key),
                            xCount: this.state.xCount
                        });
                        else obj[key] = [
                            {
                                value: this.props.view.signal(key),
                                xCount: this.state.xCount
                            }
                        ];
                    });
                    this.props.setSignals(obj);
                    this.setState({
                        xCount: 1
                    });
                }
            });
        }
    }
    resetTimeline() {
        // get the chart
        const overlay = document.querySelector('.chart-overlay');
        // remove the overlay
        overlay.style.display = 'none';
        // setState to current value
        const currentValueObj = {};
        this.state.keys.map((signal)=>{
            currentValueObj[signal] = this.props.signals[signal][this.props.signals[signal].length - 1].value;
        });
        this.props.view.setState({
            signals: currentValueObj
        });
        // remove isTimelineSelected, isHovered, hoverValue, signal and CountValue
        this.setState({
            isTimelineSelected: false,
            signal: {},
            countSignal: {},
            hoverValue: {},
            isHovered: false
        }, ()=>{
            Promise.resolve().then(()=>this.setState({
                    // remove the maskListener
                    maskListener: false
                }));
        });
    }
    onHoverInit(signalKey, hoverValue, shouldPersist = false) {
        const hoverObj = {
            [signalKey]: hoverValue.value
        };
        const countObj = {
            [signalKey]: hoverValue.xCount
        };
        for(const key in this.props.signals){
            let i = 0;
            while(this.props.signals[key][i] && this.props.signals[key][i].xCount <= hoverValue.xCount)i++;
            --i;
            hoverObj[key] = this.props.signals[key][i].value;
            countObj[key] = this.props.signals[key][i].xCount;
        }
        if (!shouldPersist) this.setState({
            hoverValue: hoverObj,
            isHovered: true
        });
        else this.setState({
            countSignal: countObj,
            hoverValue: {},
            isTimelineSelected: true,
            isHovered: false,
            signal: hoverObj
        }, ()=>{
            this.props.view.setState({
                signals: hoverObj
            });
        });
    }
    componentDidMount() {
        const keys = this.getKeys();
        this.setState({
            keys
        });
    }
    valueChange = (key, value)=>{
        if (this.state.timeline && !this.state.maskListener) this.getSignals(key);
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "timeline-control-buttons",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            style: {
                                backgroundColor: this.state.timeline ? 'red' : '',
                                color: this.state.timeline ? 'white' : 'black'
                            },
                            onClick: ()=>{
                                this.setState({
                                    timeline: !this.state.timeline,
                                    xCount: 0
                                }, ()=>{
                                    this.props.setSignals({});
                                    this.getSignals();
                                    if (!this.state.timeline) this.resetTimeline();
                                });
                            },
                            children: this.state.timeline ? 'Stop Recording & Reset' : 'Record signal changes'
                        }),
                        this.state.timeline && !this.state.maskListener && this.state.xCount > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>{
                                this.setState({
                                    xCount: 0
                                }, ()=>{
                                    this.props.setSignals({});
                                    this.getSignals();
                                });
                            },
                            children: "Clear Timeline"
                        }),
                        this.state.maskListener && this.state.timeline && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>this.resetTimeline(),
                            children: "Continue Recording"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "signal-viewer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        className: "editor-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Signal"
                                        }),
                                        this.state.timeline && /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Timeline"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: "Value"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: this.state.keys.map((signal)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signalRowJsDefault.default), {
                                        isHovered: this.state.isHovered,
                                        isTimelineSelected: this.state.isTimelineSelected,
                                        clickedSignal: this.state.signal[signal],
                                        hoverValue: this.state.hoverValue[signal],
                                        maskListener: this.state.maskListener,
                                        onValueChange: (key, value)=>this.valueChange(key, value),
                                        signal: signal,
                                        view: this.props.view,
                                        timeline: this.state.timeline,
                                        onClickHandler: this.props.onClickHandler,
                                        children: this.state.timeline && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timelineRowJsDefault.default), {
                                            onHoverInit: (hoverValue)=>this.onHoverInit(signal, hoverValue),
                                            onClickInit: (hoverValue)=>this.onClickInit(signal, hoverValue),
                                            onHoverEnd: ()=>{
                                                this.setState({
                                                    hoverValue: {},
                                                    isHovered: false
                                                });
                                            },
                                            isTimelineSelected: this.state.isTimelineSelected,
                                            clickedValue: this.state.countSignal[signal],
                                            data: this.props.signals[signal],
                                            width: window.innerWidth * 0.3,
                                            xCount: this.state.xCount
                                        })
                                    }, signal))
                            })
                        ]
                    })
                })
            ]
        });
    }
}
exports.default = SignalViewer;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","vega":"jxCvh","./index.css":"13V7q","./signalRow.js":"6dKfo","./TimelineRow.js":"4YON5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"13V7q":[function() {},{}],"6dKfo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFeather = require("react-feather");
var _vega = require("vega");
var _rendererJs = require("../table/renderer.js");
class SignalRow extends (0, _reactDefault.default).PureComponent {
    listenerAttached = false;
    constructor(props){
        super(props);
        this.state = {
            signalValue: this.props.view.signal(this.props.signal)
        };
        this.signalHandler = this.signalHandler.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.view !== this.props.view) {
            prevProps.view.removeSignalListener(prevProps.signal, this.signalHandler);
            this.props.view.addSignalListener(this.props.signal, this.signalHandler);
            this.setState({
                signalValue: this.props.view.signal(this.props.signal)
            }, ()=>this.props.onValueChange(this.props.signal, this.props.view.signal(this.props.signal)));
        }
    }
    componentDidMount() {
        if (!this.props.maskListener) {
            this.props.view.addSignalListener(this.props.signal, this.signalHandler);
            this.listenerAttached = true;
        }
    }
    componentWillUnmount() {
        this.props.view.removeSignalListener(this.props.signal, this.signalHandler);
        this.listenerAttached = false;
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.maskListener && this.listenerAttached) {
            this.props.view.removeSignalListener(this.props.signal, this.signalHandler);
            this.listenerAttached = false;
        } else if (!this.listenerAttached && !nextProps.maskListener) {
            this.props.view.addSignalListener(this.props.signal, this.signalHandler);
            this.listenerAttached = true;
        }
    }
    renderSignal = ()=>{
        const { isTimelineSelected, isHovered, clickedSignal, hoverValue } = this.props;
        if (isTimelineSelected && isHovered) return hoverValue;
        if (isTimelineSelected) return clickedSignal;
        else if (isHovered) return hoverValue;
        else return null;
    };
    getBackgroundColor = ()=>{
        if (this.props.isTimelineSelected && this.props.isHovered) return '#fce57e';
        if (this.props.isTimelineSelected && this.props.clickedSignal !== undefined) return '#A4F9C8';
        else if (this.props.isHovered && this.props.hoverValue !== undefined) return '#fce57e';
        else return '';
    };
    render() {
        let tooLong = false;
        let formatted = '';
        const value = this.renderSignal();
        if (!(0, _vega.isDate)(this.state.signalValue)) {
            const formatValue = (0, _rendererJs.formatValueLong)(value ? value : this.state.signalValue);
            if (formatValue !== undefined) {
                tooLong = formatValue.tooLong;
                formatted = formatValue.formatted;
            } else {
                tooLong = false;
                formatted = 'undefined';
            }
        } else {
            tooLong = false;
            formatted = new Date(value ? value : this.state.signalValue).toUTCString();
        }
        if (tooLong) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                    className: "pointer",
                    onClick: ()=>this.props.onClickHandler && this.props.onClickHandler(this.props.signal),
                    children: [
                        this.props.signal,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Search), {})
                    ]
                }),
                this.props.timeline && /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    style: {
                        padding: 0
                    },
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    style: {
                        backgroundColor: this.getBackgroundColor()
                    },
                    title: "The field is too large to be displayed. Please use the view API (see JS console).",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "(...)"
                    })
                }, this.props.signal)
            ]
        });
        else return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                    style: {
                        whiteSpace: 'nowrap'
                    },
                    className: "pointer",
                    onClick: ()=>this.props.onClickHandler && this.props.onClickHandler(this.props.signal),
                    children: [
                        this.props.signal,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.Search), {})
                    ]
                }),
                this.props.timeline && /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    style: {
                        padding: 0
                    },
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    style: {
                        whiteSpace: 'nowrap',
                        backgroundColor: this.getBackgroundColor()
                    },
                    children: formatted
                }, this.props.signal)
            ]
        });
    }
    signalHandler(signalName, currentValue) {
        this.setState({
            signalValue: currentValue
        }, ()=>{
            this.props.onValueChange(this.props.signal, currentValue);
        });
    }
}
exports.default = SignalRow;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","vega":"jxCvh","../table/renderer.js":"afC8u","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4YON5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _d3Array = require("d3-array");
var _d3Scale = require("d3-scale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
class TimelineRow extends (0, _reactDefault.default).PureComponent {
    render() {
        const { data, width, xCount, clickedValue } = this.props;
        const scaleNew = (0, _d3Scale.scaleBand);
        const scale = scaleNew((0, _d3Array.range)(0, xCount), [
            0,
            width
        ]);
        const row = data?.map((d)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                onMouseOver: ()=>this.props.onHoverInit(d),
                onClick: ()=>this.props.onClickInit(d),
                onMouseLeave: ()=>this.props.onHoverEnd(),
                className: "svg-rect",
                height: 31,
                style: {
                    cursor: 'pointer',
                    fill: clickedValue === d.xCount ? '#A4F9C8' : '#b7b7b7',
                    pointerEvents: 'all',
                    stroke: 'white',
                    strokeWidth: '0.5px'
                },
                width: scale.bandwidth(),
                x: scale(d.xCount)
            }, d.xCount));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            style: {
                width: window.innerWidth * 0.3,
                height: 31
            },
            width: window.innerWidth * 0.3,
            height: 31,
            children: row
        });
    }
}
exports.default = TimelineRow;

},{"react/jsx-runtime":"gonF6","d3-array":"4pSqo","d3-scale":"33tt3","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kfKXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactFeather = require("react-feather");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _redux = require("redux");
var _editorJs = require("../../../actions/editor.js");
var _constsJs = require("../../../constants/consts.js");
class DebugPaneHeader extends _react.PureComponent {
    componentDidMount() {
        if (this.props.logs || this.props.navItem === (0, _constsJs.NAVBAR).Logs) this.props.showLogs(true);
    }
    render() {
        const { toggleDebugPane, debugPane, showLogs, error, logs, navItem, toggleNavbar, warns, errors } = this.props;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "pane-header",
            onClick: toggleDebugPane,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "tabs-nav",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            className: error || logs && navItem === (0, _constsJs.NAVBAR).Logs ? 'active-tab' : undefined,
                            onClick: (e)=>{
                                if (debugPane) e.stopPropagation();
                                showLogs(true);
                                toggleNavbar((0, _constsJs.NAVBAR).Logs);
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "logs-text",
                                    children: "Logs"
                                }),
                                error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error",
                                    children: "(Error)"
                                }) : errors.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "error",
                                    children: [
                                        "(",
                                        errors.length,
                                        ")"
                                    ]
                                }) : warns.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "warnings-count",
                                    children: [
                                        "(",
                                        warns.length,
                                        ")"
                                    ]
                                }) : ''
                            ]
                        }),
                        error === null && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: navItem === (0, _constsJs.NAVBAR).DataViewer ? 'active-tab' : undefined,
                            onClick: (e)=>{
                                if (debugPane) e.stopPropagation();
                                showLogs(false);
                                toggleNavbar((0, _constsJs.NAVBAR).DataViewer);
                            },
                            children: "Data Viewer"
                        }),
                        error === null && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: navItem === (0, _constsJs.NAVBAR).SignalViewer ? 'active-tab' : undefined,
                            onClick: (e)=>{
                                if (debugPane) e.stopPropagation();
                                showLogs(false);
                                toggleNavbar((0, _constsJs.NAVBAR).SignalViewer);
                            },
                            children: "Signal Viewer"
                        }),
                        error === null && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: navItem === (0, _constsJs.NAVBAR).DataflowViewer ? 'active-tab' : undefined,
                            onClick: (e)=>{
                                if (debugPane) e.stopPropagation();
                                showLogs(false);
                                toggleNavbar((0, _constsJs.NAVBAR).DataflowViewer);
                            },
                            children: "Dataflow Viewer"
                        })
                    ]
                }),
                debugPane ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.ChevronDown), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFeather.ChevronUp), {})
            ]
        });
    }
}
function mapStateToProps(state, ownProps) {
    return {
        debugPane: state.debugPane,
        error: state.error,
        errors: state.errors,
        logs: state.logs,
        navItem: state.navItem,
        warns: state.warns
    };
}
function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        showLogs: _editorJs.showLogs,
        toggleDebugPane: _editorJs.toggleDebugPane,
        toggleNavbar: _editorJs.toggleNavbar
    }, dispatch);
}
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DebugPaneHeader));

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-feather":"40SDF","react-redux":"dwYd3","react-router-dom":"b9X5n","redux":"jTcSr","../../../actions/editor.js":"wC9No","../../../constants/consts.js":"1PtM7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h6kg5":[function() {},{}],"9Fjpb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wrap the component so we can catch the errors. We don't use the previously defined
 * error boundary component, since we want to seperate errors in graph generation from
 * errors in spec rendering
 * **/ parcelHelpers.export(exports, "DataflowViewer", ()=>DataflowViewer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _sidebarJs = require("./Sidebar.js");
var _dataflowViewerCss = require("./DataflowViewer.css");
var _graphJs = require("./Graph.js");
class DataflowViewer extends _react.Component {
    state = {
        error: null
    };
    componentDidCatch(error) {
        this.setState({
            error
        });
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: "error-indicator",
            children: this.state.error.message
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "dataflow-pane",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graphJs.Graph), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarJs.Sidebar), {})
            ]
        });
    }
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Sidebar.js":"eiK5x","./DataflowViewer.css":"lYyNk","./Graph.js":"3lhMA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eiK5x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _hooksJs = require("../../hooks.js");
var _pulsesSliceJs = require("./pulsesSlice.js");
var _sidebarCss = require("./Sidebar.css");
var _selectionSliceJs = require("./selectionSlice.js");
var _graphJs = require("./utils/graph.js");
function Sidebar() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "sidebar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Types, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Id, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pulses, {})
        ]
    });
}
function Types() {
    const selectedTypes = (0, _hooksJs.useAppSelector)((0, _selectionSliceJs.selectedTypesSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "type-filter",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                children: "Filter by type"
            }),
            Object.entries((0, _graphJs.types)).map(([type, { label }])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Type, {
                    type: type,
                    selected: selectedTypes[type],
                    label: label
                }, type))
        ]
    });
}
function Type({ type, label, selected }) {
    const dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                checked: selected,
                onChange: (event)=>dispatch((0, _selectionSliceJs.setSelectedType)({
                        type,
                        enabled: event.target.checked
                    }))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: label
            })
        ]
    });
}
function Id() {
    const [searchTerm, setSearchTerm] = _react.useState(null);
    const dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "id-filter",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                children: "Filter by ID"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "search",
                        title: "Pulse Id Search",
                        onChange: (e)=>setSearchTerm(e.target.value)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>{
                            if (!searchTerm) return;
                            dispatch((0, _selectionSliceJs.setSelectedElements)({
                                nodes: [
                                    searchTerm
                                ],
                                edges: []
                            }));
                            setSearchTerm(null);
                        },
                        children: "Search"
                    })
                ]
            })
        ]
    });
}
function Pulses() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                children: "Filter by pulse"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Clicking on a pulse filters the nodes to those that were updated in that pulse and displays their values on hover."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PulsesButtons, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "editor-table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Clock"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "Touched Nodes"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PulsesRows, {})
                ]
            })
        ]
    });
}
function PulsesButtons() {
    const dispatch = (0, _reactRedux.useDispatch)();
    const selectedPulse = (0, _hooksJs.useAppSelector)((0, _selectionSliceJs.selectedPulseSelector));
    const pulsesEmpty = (0, _hooksJs.useAppSelector)((0, _pulsesSliceJs.pulsesEmptySelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>dispatch((0, _selectionSliceJs.setSelectedPulse)(null)),
                disabled: selectedPulse === null,
                children: "Unselect pulse"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>dispatch((0, _pulsesSliceJs.resetPulses)()),
                disabled: pulsesEmpty,
                children: "Clear recorded pulses"
            })
        ]
    });
}
function PulsesRows() {
    const pulses = (0, _hooksJs.useAppSelector)((0, _pulsesSliceJs.sortedPulsesSelector));
    const selectedPulse = (0, _hooksJs.useAppSelector)((0, _selectionSliceJs.selectedPulseSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
        children: pulses.map(({ clock, nValues })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MemoPulse, {
                clock: clock,
                nValues: nValues,
                isSelected: clock === selectedPulse
            }, clock))
    });
}
const MemoPulse = /*#__PURE__*/ _react.memo(Pulse);
function Pulse({ clock, isSelected, nValues }) {
    const dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        className: isSelected ? 'active-pulse' : '',
        onClick: ()=>dispatch((0, _selectionSliceJs.setSelectedPulse)(clock)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: clock
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                children: nValues
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-redux":"dwYd3","../../hooks.js":"cg1kA","./pulsesSlice.js":"eeulL","./Sidebar.css":"4FtLH","./selectionSlice.js":"bBSOy","./utils/graph.js":"l0ZC0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4FtLH":[function() {},{}],"lYyNk":[function() {},{}],"3lhMA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Graph", ()=>Graph);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooksJs = require("../../hooks.js");
var _layoutSliceJs = require("./layoutSlice.js");
var _cytoscapeJs = require("./Cytoscape.js");
var _popupJs = require("./Popup.js");
var _graphCss = require("./Graph.css");
var _reactRedux = require("react-redux");
var _selectionSliceJs = require("./selectionSlice.js");
function Graph() {
    // Trigger starting the async layout computation, when this node is rendered
    (0, _layoutSliceJs.useRecomputeLayout)();
    const cytoscape = _react.useMemo(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cytoscapeJs.Cytoscape), {}), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "graph",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UnselectElements, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Overlay, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popupJs.Popup), {}),
            cytoscape
        ]
    });
}
function UnselectElements() {
    const dispatch = (0, _reactRedux.useDispatch)();
    const elementsSelected = (0, _hooksJs.useAppSelector)((0, _selectionSliceJs.elementsSelectedSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: "unselect-elements",
        onClick: ()=>dispatch((0, _selectionSliceJs.setSelectedElements)(null)),
        disabled: !elementsSelected,
        children: "Unselect elements"
    });
}
function Overlay() {
    const layout = (0, _hooksJs.useAppSelector)((0, _layoutSliceJs.currentLayoutSelector));
    if (layout === null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "overlay center-text",
        children: "No active dataflow runtime"
    });
    switch(layout.type){
        case 'loading':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "overlay center-text",
                children: "Laying out graph..."
            });
        case 'done':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
        case 'error':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlay",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Encountered an error running ELK layout:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                        children: layout.error.stack
                    })
                ]
            });
    }
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../hooks.js":"cg1kA","./layoutSlice.js":"67Uyo","./Cytoscape.js":"7WuWF","./Popup.js":"pKmVO","./Graph.css":"gHfW4","react-redux":"dwYd3","./selectionSlice.js":"bBSOy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7WuWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cytoscape", ()=>Cytoscape);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _hooksJs = require("../../hooks.js");
var _layoutSliceJs = require("./layoutSlice.js");
var _selectionSliceJs = require("./selectionSlice.js");
var _popupSliceJs = require("./popupSlice.js");
var _cytoscapeControlledJs = require("./CytoscapeControlled.js");
var _runtimeSliceJs = require("./runtimeSlice.js");
function Cytoscape() {
    const dispatch = (0, _reactRedux.useDispatch)();
    const elements = (0, _hooksJs.useAppSelector)((0, _runtimeSliceJs.cytoscapeElementsSelector));
    const positions = (0, _hooksJs.useAppSelector)((0, _layoutSliceJs.currentPositionsSelector));
    const selected = (0, _hooksJs.useAppSelector)((0, _selectionSliceJs.selectedElementsSelector));
    const onSelect = _react.useCallback((el)=>dispatch((0, _selectionSliceJs.setSelectedElements)(el)), [
        dispatch
    ]);
    const onHover = _react.useCallback((target)=>dispatch((0, _popupSliceJs.setPopup)(target)), [
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cytoscapeControlledJs.CytoscapeControlled), {
        elements: elements,
        positions: positions,
        selected: selected,
        onSelect: onSelect,
        onHover: onHover
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-redux":"dwYd3","../../hooks.js":"cg1kA","./layoutSlice.js":"67Uyo","./selectionSlice.js":"bBSOy","./popupSlice.js":"eODwE","./CytoscapeControlled.js":"knKZm","./runtimeSlice.js":"iZrZf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"knKZm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A controlled Cytoscape component, which is meant to be rendered once with a given set of elements and list of visible
 * nodes, and then re-rendered updating the positions and which elements are visible, before being re-rendered with new elements.
 */ parcelHelpers.export(exports, "CytoscapeControlled", ()=>CytoscapeControlled);
var _jsxRuntime = require("react/jsx-runtime");
var _cytoscape = require("cytoscape");
var _cytoscapeDefault = parcelHelpers.interopDefault(_cytoscape);
var _react = require("react");
var _cytoscapePopper = require("cytoscape-popper");
var _cytoscapePopperDefault = parcelHelpers.interopDefault(_cytoscapePopper);
var _cytoscapeStyleJs = require("./utils/cytoscapeStyle.js");
var _cytoscapeControlledCss = require("./CytoscapeControlled.css");
var _setsEqualJs = require("./utils/setsEqual.js");
var _dom = require("@floating-ui/dom");
function popperFactory(ref, content, opts) {
    // see https://floating-ui.com/docs/computePosition#options
    const popperOptions = {
        // matching the default behaviour from Popper@2
        // https://floating-ui.com/docs/migration#configure-middleware
        middleware: [
            (0, _dom.flip)(),
            (0, _dom.shift)({
                limiter: (0, _dom.limitShift)()
            })
        ],
        ...opts
    };
    function update() {
        (0, _dom.computePosition)(ref, content, popperOptions).then(({ x, y })=>{
            Object.assign(content.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    }
    update();
    return {
        update
    };
}
(0, _cytoscapeDefault.default).use((0, _cytoscapePopperDefault.default)(popperFactory));
// https://js.cytoscape.org/#core/initialisation
const OPTIONS = {
    style: (0, _cytoscapeStyleJs.style),
    // Make zoom more constrained than default so we don't get lost
    minZoom: 1e-2,
    maxZoom: 1e1
};
function CytoscapeControlled({ elements, positions, selected, onHover, onSelect }) {
    const divRef = _react.useRef(null);
    const cyRef = _react.useRef(null);
    const layoutRef = _react.useRef(null);
    // The elements that have been removed, from a selection
    const removedRef = _react.useRef(null);
    const getRemovedNodeIDs = ()=>new Set(removedRef.current?.map((n)=>n.id()) ?? []);
    // Set cytoscape ref in first effect and set up callbacks
    _react.useEffect(()=>{
        const cy = cyRef.current = (0, _cytoscapeDefault.default)({
            container: divRef.current,
            ...OPTIONS
        });
        layoutRef.current = cy.makeLayout({
            name: 'preset'
        });
        removedRef.current = null;
        cy.on('select', (event)=>{
            event.preventDefault();
            onSelect({
                edges: cy.edges(':selected').map((e)=>e.id()),
                nodes: cy.nodes(':selected').map((n)=>n.id())
            });
        });
        cy.on('unselect', (event)=>{
            event.preventDefault();
        });
        // Unselect when clicking on background
        // We need this extra handler, instead of just relying on "unselect", because we can have a node semantically selected,
        // but not visible anymore, so that cytoscope doesn't consider it selected
        cy.on('click', ({ target })=>{
            if (target === cy) onSelect(null);
        });
        cy.on('mouseover', ({ target })=>{
            if (target === cy) // mouseover background
            return;
            onHover({
                type: target.isNode() ? 'node' : 'edge',
                id: target.id(),
                referenceClientRect: target.popperRef().getBoundingClientRect()
            });
        });
        cy.on('mouseout', ({ target })=>{
            if (target === cy) return;
            onHover(null);
        });
        return ()=>{
            cy.destroy();
            onHover(null);
        };
    }, [
        divRef.current,
        onHover,
        onSelect
    ]);
    // Update the elements
    _react.useEffect(()=>{
        const cy = cyRef.current;
        // Toggle off hovering when changing elements
        onHover(null);
        cy.batch(()=>{
            // Delete all old new elements, add new ones, and reset temporarily
            // removed elements reference
            cy.elements().remove();
            if (elements === null) removedRef.current = null;
            else // Remove all the new elements after adding,
            // so that when their layouts are updated, they aren't animated,
            // since they were previously off screen
            removedRef.current = cy.add(elements).remove();
        });
    }, [
        cyRef.current,
        elements
    ]);
    // Update the positions
    _react.useEffect(()=>{
        const layout = layoutRef.current;
        layout.stop();
        if (positions === null) return;
        const cy = cyRef.current;
        // Record nodes we will restore, so don't animate them
        const restoredNodeIDs = getRemovedNodeIDs();
        // Restore all previously removed nodes
        if (removedRef.current) removedRef.current.restore();
        // Remove all nodes that don't have positions
        removedRef.current = cy.collection(Object.keys(positions).map((id)=>cy.$id(id))).absoluteComplement().nodes().remove();
        // If the previously removed nodes are equal to the current removed nodes, dont layout,
        // the nodes haven't changed
        if ((0, _setsEqualJs.setsEqual)(restoredNodeIDs, getRemovedNodeIDs())) return;
        // Toggle off hovering when moving positions
        onHover(null);
        // Update the layouts
        const allNodes = cy.nodes();
        const wasNotRestored = (n)=>!restoredNodeIDs.has(n.id());
        // Only animate fit if there are some nodes that weren't restored
        const animate = allNodes.some(wasNotRestored);
        cy.nodes().layoutPositions(layout, {
            eles: allNodes,
            fit: true,
            animate,
            animationDuration: 1500,
            animationEasing: 'ease-in-out-sine',
            padding: 10,
            // Only animate if the node was not just restored, b/c just restored
            // nodes positions aren't meaningful
            animateFilter: wasNotRestored
        }, (node)=>positions[node.id()]);
    }, [
        cyRef.current,
        positions,
        onHover
    ]);
    // Update the selected elements
    _react.useEffect(()=>{
        const cy = cyRef.current;
        cy.batch(()=>{
            const selectedElements = cy.collection(selected ? [
                ...selected.edges,
                ...selected.nodes
            ].map((id)=>cy.$id(id)) : []);
            selectedElements.select();
            selectedElements.absoluteComplement().unselect();
        });
    }, [
        cyRef.current,
        selected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "cytoscape",
        ref: divRef
    });
}

},{"react/jsx-runtime":"gonF6","cytoscape":"1zc5V","react":"bmhQu","cytoscape-popper":"axyKi","./utils/cytoscapeStyle.js":"gLnUw","./CytoscapeControlled.css":"1ZPto","./utils/setsEqual.js":"aZMPq","@floating-ui/dom":"3J4Yg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1zc5V":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2016-2025, The Cytoscape Consortium.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the “Software”), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cytoscape);
var global = arguments[3];
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = true, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _defineProperty$1(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (undefined !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : undefined;
    }
}
var _window = typeof window === 'undefined' ? null : window; // eslint-disable-line no-undef
var navigator = _window ? _window.navigator : null;
_window && _window.document;
var typeofstr = _typeof('');
var typeofobj = _typeof({});
var typeoffn = _typeof(function() {});
var typeofhtmlele = typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement);
var instanceStr = function instanceStr(obj) {
    return obj && obj.instanceString && fn$6(obj.instanceString) ? obj.instanceString() : null;
};
var string = function string(obj) {
    return obj != null && _typeof(obj) == typeofstr;
};
var fn$6 = function fn(obj) {
    return obj != null && _typeof(obj) === typeoffn;
};
var array = function array(obj) {
    return !elementOrCollection(obj) && (Array.isArray ? Array.isArray(obj) : obj != null && obj instanceof Array);
};
var plainObject = function plainObject(obj) {
    return obj != null && _typeof(obj) === typeofobj && !array(obj) && obj.constructor === Object;
};
var object = function object(obj) {
    return obj != null && _typeof(obj) === typeofobj;
};
var number$1 = function number(obj) {
    return obj != null && _typeof(obj) === _typeof(1) && !isNaN(obj);
};
var integer = function integer(obj) {
    return number$1(obj) && Math.floor(obj) === obj;
};
var htmlElement = function htmlElement(obj) {
    if ('undefined' === typeofhtmlele) return undefined;
    else return null != obj && obj instanceof HTMLElement;
};
var elementOrCollection = function elementOrCollection(obj) {
    return element(obj) || collection(obj);
};
var element = function element(obj) {
    return instanceStr(obj) === 'collection' && obj._private.single;
};
var collection = function collection(obj) {
    return instanceStr(obj) === 'collection' && !obj._private.single;
};
var core = function core(obj) {
    return instanceStr(obj) === 'core';
};
var stylesheet = function stylesheet(obj) {
    return instanceStr(obj) === 'stylesheet';
};
var event = function event(obj) {
    return instanceStr(obj) === 'event';
};
var emptyString = function emptyString(obj) {
    if (obj === undefined || obj === null) // null is empty
    return true;
    else if (obj === '' || obj.match(/^\s+$/)) return true; // empty string is empty
    return false; // otherwise, we don't know what we've got
};
var domElement = function domElement(obj) {
    if (typeof HTMLElement === 'undefined') return false; // we're not in a browser so it doesn't matter
    else return obj instanceof HTMLElement;
};
var boundingBox = function boundingBox(obj) {
    return plainObject(obj) && number$1(obj.x1) && number$1(obj.x2) && number$1(obj.y1) && number$1(obj.y2);
};
var promise = function promise(obj) {
    return object(obj) && fn$6(obj.then);
};
var ms = function ms() {
    return navigator && navigator.userAgent.match(/msie|trident|edge/i);
}; // probably a better way to detect this...
var memoize = function memoize(fn, keyFn) {
    if (!keyFn) keyFn = function keyFn() {
        if (arguments.length === 1) return arguments[0];
        else if (arguments.length === 0) return 'undefined';
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        return args.join('$');
    };
    var _memoizedFn = function memoizedFn() {
        var self1 = this;
        var args = arguments;
        var ret;
        var k = keyFn.apply(self1, args);
        var cache = _memoizedFn.cache;
        if (!(ret = cache[k])) ret = cache[k] = fn.apply(self1, args);
        return ret;
    };
    _memoizedFn.cache = {};
    return _memoizedFn;
};
var camel2dash = memoize(function(str) {
    return str.replace(/([A-Z])/g, function(v) {
        return '-' + v.toLowerCase();
    });
});
var dash2camel = memoize(function(str) {
    return str.replace(/(-\w)/g, function(v) {
        return v[1].toUpperCase();
    });
});
var prependCamel = memoize(function(prefix, str) {
    return prefix + str[0].toUpperCase() + str.substring(1);
}, function(prefix, str) {
    return prefix + '$' + str;
});
var capitalize = function capitalize(str) {
    if (emptyString(str)) return str;
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var number = '(?:[-+]?(?:(?:\\d+|\\d*\\.\\d+)(?:[Ee][+-]?\\d+)?))';
var rgba = 'rgb[a]?\\((' + number + '[%]?)\\s*,\\s*(' + number + '[%]?)\\s*,\\s*(' + number + '[%]?)(?:\\s*,\\s*(' + number + '))?\\)';
var rgbaNoBackRefs = 'rgb[a]?\\((?:' + number + '[%]?)\\s*,\\s*(?:' + number + '[%]?)\\s*,\\s*(?:' + number + '[%]?)(?:\\s*,\\s*(?:' + number + '))?\\)';
var hsla = 'hsl[a]?\\((' + number + ')\\s*,\\s*(' + number + '[%])\\s*,\\s*(' + number + '[%])(?:\\s*,\\s*(' + number + '))?\\)';
var hslaNoBackRefs = 'hsl[a]?\\((?:' + number + ')\\s*,\\s*(?:' + number + '[%])\\s*,\\s*(?:' + number + '[%])(?:\\s*,\\s*(?:' + number + '))?\\)';
var hex3 = '\\#[0-9a-fA-F]{3}';
var hex6 = '\\#[0-9a-fA-F]{6}';
var ascending = function ascending(a, b) {
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
};
var descending = function descending(a, b) {
    return -1 * ascending(a, b);
};
var extend = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
    var args = arguments;
    for(var i = 1; i < args.length; i++){
        var obj = args[i];
        if (obj == null) continue;
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; j++){
            var k = keys[j];
            tgt[k] = obj[k];
        }
    }
    return tgt;
};
// get [r, g, b] from #abc or #aabbcc
var hex2tuple = function hex2tuple(hex) {
    if (!(hex.length === 4 || hex.length === 7) || hex[0] !== '#') return;
    var shortHex = hex.length === 4;
    var r, g, b;
    var base = 16;
    if (shortHex) {
        r = parseInt(hex[1] + hex[1], base);
        g = parseInt(hex[2] + hex[2], base);
        b = parseInt(hex[3] + hex[3], base);
    } else {
        r = parseInt(hex[1] + hex[2], base);
        g = parseInt(hex[3] + hex[4], base);
        b = parseInt(hex[5] + hex[6], base);
    }
    return [
        r,
        g,
        b
    ];
};
// get [r, g, b, a] from hsl(0, 0, 0) or hsla(0, 0, 0, 0)
var hsl2tuple = function hsl2tuple(hsl) {
    var ret;
    var h, s, l, a, r, g, b;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var m1 = new RegExp('^' + hsla + '$').exec(hsl);
    if (m1) {
        // get hue
        h = parseInt(m1[1]);
        if (h < 0) h = (360 - -1 * h % 360) % 360;
        else if (h > 360) h = h % 360;
        h /= 360; // normalise on [0, 1]
        s = parseFloat(m1[2]);
        if (s < 0 || s > 100) return;
         // saturation is [0, 100]
        s = s / 100; // normalise on [0, 1]
        l = parseFloat(m1[3]);
        if (l < 0 || l > 100) return;
         // lightness is [0, 100]
        l = l / 100; // normalise on [0, 1]
        a = m1[4];
        if (a !== undefined) {
            a = parseFloat(a);
            if (a < 0 || a > 1) return;
             // alpha is [0, 1]
        }
        // now, convert to rgb
        // code from http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
        if (s === 0) r = g = b = Math.round(l * 255); // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = Math.round(255 * hue2rgb(p, q, h + 1 / 3));
            g = Math.round(255 * hue2rgb(p, q, h));
            b = Math.round(255 * hue2rgb(p, q, h - 1 / 3));
        }
        ret = [
            r,
            g,
            b,
            a
        ];
    }
    return ret;
};
// get [r, g, b, a] from rgb(0, 0, 0) or rgba(0, 0, 0, 0)
var rgb2tuple = function rgb2tuple(rgb) {
    var ret;
    var m1 = new RegExp('^' + rgba + '$').exec(rgb);
    if (m1) {
        ret = [];
        var isPct = [];
        for(var i = 1; i <= 3; i++){
            var channel = m1[i];
            if (channel[channel.length - 1] === '%') isPct[i] = true;
            channel = parseFloat(channel);
            if (isPct[i]) channel = channel / 100 * 255; // normalise to [0, 255]
            if (channel < 0 || channel > 255) return;
             // invalid channel value
            ret.push(Math.floor(channel));
        }
        var atLeastOneIsPct = isPct[1] || isPct[2] || isPct[3];
        var allArePct = isPct[1] && isPct[2] && isPct[3];
        if (atLeastOneIsPct && !allArePct) return;
         // must all be percent values if one is
        var alpha = m1[4];
        if (alpha !== undefined) {
            alpha = parseFloat(alpha);
            if (alpha < 0 || alpha > 1) return;
             // invalid alpha value
            ret.push(alpha);
        }
    }
    return ret;
};
var colorname2tuple = function colorname2tuple(color) {
    return colors[color.toLowerCase()];
};
var color2tuple = function color2tuple(color) {
    return (array(color) ? color : null) || colorname2tuple(color) || hex2tuple(color) || rgb2tuple(color) || hsl2tuple(color);
};
var colors = {
    // special colour names
    transparent: [
        0,
        0,
        0,
        0
    ],
    // NB alpha === 0
    // regular colours
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
// sets the value in a map (map may not be built)
var setMap = function setMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if (plainObject(key)) throw Error('Tried to set map with object key');
        if (i < keys.length - 1) {
            // extend the map if necessary
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        } else // set the value
        obj[key] = options.value;
    }
};
// gets the value in a map even if it's not built in places
var getMap = function getMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if (plainObject(key)) throw Error('Tried to get map with object key');
        obj = obj[key];
        if (obj == null) return obj;
    }
    return obj;
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var isObject_1;
var hasRequiredIsObject;
function requireIsObject() {
    if (hasRequiredIsObject) return isObject_1;
    hasRequiredIsObject = 1;
    function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
    }
    isObject_1 = isObject;
    return isObject_1;
}
/** Detect free variable `global` from Node.js. */ var _freeGlobal;
var hasRequired_freeGlobal;
function require_freeGlobal() {
    if (hasRequired_freeGlobal) return _freeGlobal;
    hasRequired_freeGlobal = 1;
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    _freeGlobal = freeGlobal;
    return _freeGlobal;
}
var _root;
var hasRequired_root;
function require_root() {
    if (hasRequired_root) return _root;
    hasRequired_root = 1;
    var freeGlobal = require_freeGlobal();
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    _root = root;
    return _root;
}
var now_1;
var hasRequiredNow;
function requireNow() {
    if (hasRequiredNow) return now_1;
    hasRequiredNow = 1;
    var root = require_root();
    /**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */ var now = function() {
        return root.Date.now();
    };
    now_1 = now;
    return now_1;
}
/** Used to match a single whitespace character. */ var _trimmedEndIndex;
var hasRequired_trimmedEndIndex;
function require_trimmedEndIndex() {
    if (hasRequired_trimmedEndIndex) return _trimmedEndIndex;
    hasRequired_trimmedEndIndex = 1;
    var reWhitespace = /\s/;
    /**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    _trimmedEndIndex = trimmedEndIndex;
    return _trimmedEndIndex;
}
var _baseTrim;
var hasRequired_baseTrim;
function require_baseTrim() {
    if (hasRequired_baseTrim) return _baseTrim;
    hasRequired_baseTrim = 1;
    var trimmedEndIndex = require_trimmedEndIndex();
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    _baseTrim = baseTrim;
    return _baseTrim;
}
var _Symbol;
var hasRequired_Symbol;
function require_Symbol() {
    if (hasRequired_Symbol) return _Symbol;
    hasRequired_Symbol = 1;
    var root = require_root();
    /** Built-in value references. */ var Symbol1 = root.Symbol;
    _Symbol = Symbol1;
    return _Symbol;
}
var _getRawTag;
var hasRequired_getRawTag;
function require_getRawTag() {
    if (hasRequired_getRawTag) return _getRawTag;
    hasRequired_getRawTag = 1;
    var Symbol1 = require_Symbol();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var nativeObjectToString = objectProto.toString;
    /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */ function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
            value[symToStringTag] = undefined;
            var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
            if (isOwn) value[symToStringTag] = tag;
            else delete value[symToStringTag];
        }
        return result;
    }
    _getRawTag = getRawTag;
    return _getRawTag;
}
/** Used for built-in method references. */ var _objectToString;
var hasRequired_objectToString;
function require_objectToString() {
    if (hasRequired_objectToString) return _objectToString;
    hasRequired_objectToString = 1;
    var objectProto = Object.prototype;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var nativeObjectToString = objectProto.toString;
    /**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */ function objectToString(value) {
        return nativeObjectToString.call(value);
    }
    _objectToString = objectToString;
    return _objectToString;
}
var _baseGetTag;
var hasRequired_baseGetTag;
function require_baseGetTag() {
    if (hasRequired_baseGetTag) return _baseGetTag;
    hasRequired_baseGetTag = 1;
    var Symbol1 = require_Symbol(), getRawTag = require_getRawTag(), objectToString = require_objectToString();
    /** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
    /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */ function baseGetTag(value) {
        if (value == null) return value === undefined ? undefinedTag : nullTag;
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    _baseGetTag = baseGetTag;
    return _baseGetTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var isObjectLike_1;
var hasRequiredIsObjectLike;
function requireIsObjectLike() {
    if (hasRequiredIsObjectLike) return isObjectLike_1;
    hasRequiredIsObjectLike = 1;
    function isObjectLike(value) {
        return value != null && typeof value == 'object';
    }
    isObjectLike_1 = isObjectLike;
    return isObjectLike_1;
}
var isSymbol_1;
var hasRequiredIsSymbol;
function requireIsSymbol() {
    if (hasRequiredIsSymbol) return isSymbol_1;
    hasRequiredIsSymbol = 1;
    var baseGetTag = require_baseGetTag(), isObjectLike = requireIsObjectLike();
    /** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
    /**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */ function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    isSymbol_1 = isSymbol;
    return isSymbol_1;
}
var toNumber_1;
var hasRequiredToNumber;
function requireToNumber() {
    if (hasRequiredToNumber) return toNumber_1;
    hasRequiredToNumber = 1;
    var baseTrim = require_baseTrim(), isObject = requireIsObject(), isSymbol = requireIsSymbol();
    /** Used as references for various `Number` constants. */ var NAN = 0 / 0;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
    /**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */ function toNumber(value) {
        if (typeof value == 'number') return value;
        if (isSymbol(value)) return NAN;
        if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    toNumber_1 = toNumber;
    return toNumber_1;
}
var debounce_1;
var hasRequiredDebounce;
function requireDebounce() {
    if (hasRequiredDebounce) return debounce_1;
    hasRequiredDebounce = 1;
    var isObject = requireIsObject(), now = requireNow(), toNumber = requireToNumber();
    /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
    /**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */ function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) return trailingEdge(time);
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    // Handle invocations in a tight loop.
                    clearTimeout(timerId);
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    debounce_1 = debounce;
    return debounce_1;
}
var debounceExports = requireDebounce();
var debounce = /*@__PURE__*/ getDefaultExportFromCjs(debounceExports);
var performance$1 = _window ? _window.performance : null;
var pnow = performance$1 && performance$1.now ? function() {
    return performance$1.now();
} : function() {
    return Date.now();
};
var raf = function() {
    if (_window) {
        if (_window.requestAnimationFrame) return function(fn) {
            _window.requestAnimationFrame(fn);
        };
        else if (_window.mozRequestAnimationFrame) return function(fn) {
            _window.mozRequestAnimationFrame(fn);
        };
        else if (_window.webkitRequestAnimationFrame) return function(fn) {
            _window.webkitRequestAnimationFrame(fn);
        };
        else if (_window.msRequestAnimationFrame) return function(fn) {
            _window.msRequestAnimationFrame(fn);
        };
    }
    return function(fn) {
        if (fn) setTimeout(function() {
            fn(pnow());
        }, 1000 / 60);
    };
}();
var requestAnimationFrame = function requestAnimationFrame(fn) {
    return raf(fn);
};
var performanceNow = pnow;
var DEFAULT_HASH_SEED = 9261;
var K = 65599; // 37 also works pretty well
var DEFAULT_HASH_SEED_ALT = 5381;
var hashIterableInts = function hashIterableInts(iterator) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HASH_SEED;
    // sdbm/string-hash
    var hash = seed;
    var entry;
    for(;;){
        entry = iterator.next();
        if (entry.done) break;
        hash = hash * K + entry.value | 0;
    }
    return hash;
};
var hashInt = function hashInt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HASH_SEED;
    // sdbm/string-hash
    return seed * K + num | 0;
};
var hashIntAlt = function hashIntAlt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_HASH_SEED_ALT;
    // djb2/string-hash
    return (seed << 5) + seed + num | 0;
};
var combineHashes = function combineHashes(hash1, hash2) {
    return hash1 * 0x200000 + hash2;
};
var combineHashesArray = function combineHashesArray(hashes) {
    return hashes[0] * 0x200000 + hashes[1];
};
var hashArrays = function hashArrays(hashes1, hashes2) {
    return [
        hashInt(hashes1[0], hashes2[0]),
        hashIntAlt(hashes1[1], hashes2[1])
    ];
};
var hashIntsArray = function hashIntsArray(ints, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = ints.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = ints[i++];
            else entry.done = true;
            return entry;
        }
    };
    return hashIterableInts(iterator, seed);
};
var hashString = function hashString(str, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = str.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = str.charCodeAt(i++);
            else entry.done = true;
            return entry;
        }
    };
    return hashIterableInts(iterator, seed);
};
var hashStrings = function hashStrings() {
    return hashStringsArray(arguments);
};
var hashStringsArray = function hashStringsArray(strs) {
    var hash;
    for(var i = 0; i < strs.length; i++){
        var str = strs[i];
        if (i === 0) hash = hashString(str);
        else hash = hashString(str, hash);
    }
    return hash;
};
var warningsEnabled = true;
var warnSupported = console.warn != null;
var traceSupported = console.trace != null;
var MAX_INT$1 = Number.MAX_SAFE_INTEGER || 9007199254740991;
var trueify = function trueify() {
    return true;
};
var falsify = function falsify() {
    return false;
};
var zeroify = function zeroify() {
    return 0;
};
var noop$1 = function noop() {};
var error = function error(msg) {
    throw new Error(msg);
};
var warnings = function warnings(enabled) {
    if (enabled !== undefined) warningsEnabled = !!enabled;
    else return warningsEnabled;
};
var warn = function warn(msg) {
    if (!warnings()) return;
    if (warnSupported) console.warn(msg);
    else {
        console.log(msg);
        if (traceSupported) console.trace();
    }
};
var clone = function clone(obj) {
    return extend({}, obj);
};
// gets a shallow copy of the argument
var copy = function copy(obj) {
    if (obj == null) return obj;
    if (array(obj)) return obj.slice();
    else if (plainObject(obj)) return clone(obj);
    else return obj;
};
var copyArray = function copyArray(arr) {
    return arr.slice();
};
var uuid = function uuid(a, b /* placeholders */ ) {
    for(// loop :)
    b = a = ''; // b - result , a - numeric letiable
    a++ < 36; //
    b += a * 51 & 52 // if "a" is not 9 or 14 or 19 or 24
     ? //  return a random number or 4
    (a ^ 15 // if "a" is not 15
     ? // generate a random number from 0 to 15
    8 ^ Math.random() * (a ^ 20 ? 16 : 4 // unless "a" is 20, in which case a random number from 8 to 11
    ) : 4 //  otherwise 4
    ).toString(16) : '-' //  in other cases (if "a" is 9,14,19,24) insert "-"
    );
    return b;
};
var _staticEmptyObject = {};
var staticEmptyObject = function staticEmptyObject() {
    return _staticEmptyObject;
};
var defaults$g = function defaults(_defaults) {
    var keys = Object.keys(_defaults);
    return function(opts) {
        var filledOpts = {};
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var optVal = opts == null ? undefined : opts[key];
            filledOpts[key] = optVal === undefined ? _defaults[key] : optVal;
        }
        return filledOpts;
    };
};
var removeFromArray = function removeFromArray(arr, ele, oneCopy) {
    for(var i = arr.length - 1; i >= 0; i--)if (arr[i] === ele) arr.splice(i, 1);
};
var clearArray = function clearArray(arr) {
    arr.splice(0, arr.length);
};
var push = function push(arr, otherArr) {
    for(var i = 0; i < otherArr.length; i++){
        var el = otherArr[i];
        arr.push(el);
    }
};
var getPrefixedProperty = function getPrefixedProperty(obj, propName, prefix) {
    if (prefix) propName = prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    return obj[propName];
};
var setPrefixedProperty = function setPrefixedProperty(obj, propName, prefix, value) {
    if (prefix) propName = prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    obj[propName] = value;
};
/* global Map */ var ObjectMap = /*#__PURE__*/ function() {
    function ObjectMap() {
        _classCallCheck(this, ObjectMap);
        this._obj = {};
    }
    return _createClass(ObjectMap, [
        {
            key: "set",
            value: function set(key, val) {
                this._obj[key] = val;
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this._obj[key] = undefined;
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = {};
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._obj[key] !== undefined;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this._obj[key];
            }
        }
    ]);
}();
var Map$1 = typeof Map !== 'undefined' ? Map : ObjectMap;
/* global Set */ var undef = "undefined";
var ObjectSet = /*#__PURE__*/ function() {
    function ObjectSet(arrayOrObjectSet) {
        _classCallCheck(this, ObjectSet);
        this._obj = Object.create(null);
        this.size = 0;
        if (arrayOrObjectSet != null) {
            var arr;
            if (arrayOrObjectSet.instanceString != null && arrayOrObjectSet.instanceString() === this.instanceString()) arr = arrayOrObjectSet.toArray();
            else arr = arrayOrObjectSet;
            for(var i = 0; i < arr.length; i++)this.add(arr[i]);
        }
    }
    return _createClass(ObjectSet, [
        {
            key: "instanceString",
            value: function instanceString() {
                return 'set';
            }
        },
        {
            key: "add",
            value: function add(val) {
                var o = this._obj;
                if (o[val] !== 1) {
                    o[val] = 1;
                    this.size++;
                }
            }
        },
        {
            key: "delete",
            value: function _delete(val) {
                var o = this._obj;
                if (o[val] === 1) {
                    o[val] = 0;
                    this.size--;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = Object.create(null);
            }
        },
        {
            key: "has",
            value: function has(val) {
                return this._obj[val] === 1;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var _this = this;
                return Object.keys(this._obj).filter(function(key) {
                    return _this.has(key);
                });
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, thisArg) {
                return this.toArray().forEach(callback, thisArg);
            }
        }
    ]);
}();
var Set$1 = (typeof Set === "undefined" ? "undefined" : _typeof(Set)) !== undef ? Set : ObjectSet;
// represents a node or an edge
var Element = function Element(cy, params) {
    var restore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (cy === undefined || params === undefined || !core(cy)) {
        error('An element must have a core reference and parameters set');
        return;
    }
    var group = params.group;
    // try to automatically infer the group if unspecified
    if (group == null) {
        if (params.data && params.data.source != null && params.data.target != null) group = 'edges';
        else group = 'nodes';
    }
    // validate group
    if (group !== 'nodes' && group !== 'edges') {
        error('An element must be of type `nodes` or `edges`; you specified `' + group + '`');
        return;
    }
    // make the element array-like, just like a collection
    this.length = 1;
    this[0] = this;
    // NOTE: when something is added here, add also to ele.json()
    var _p = this._private = {
        cy: cy,
        single: true,
        // indicates this is an element
        data: params.data || {},
        // data object
        position: params.position || {
            x: 0,
            y: 0
        },
        // (x, y) position pair
        autoWidth: undefined,
        // width and height of nodes calculated by the renderer when set to special 'auto' value
        autoHeight: undefined,
        autoPadding: undefined,
        compoundBoundsClean: false,
        // whether the compound dimensions need to be recalculated the next time dimensions are read
        listeners: [],
        // array of bound listeners
        group: group,
        // string; 'nodes' or 'edges'
        style: {},
        // properties as set by the style
        rstyle: {},
        // properties for style sent from the renderer to the core
        styleCxts: [],
        // applied style contexts from the styler
        styleKeys: {},
        // per-group keys of style property values
        removed: true,
        // whether it's inside the vis; true if removed (set true here since we call restore)
        selected: params.selected ? true : false,
        // whether it's selected
        selectable: params.selectable === undefined ? true : params.selectable ? true : false,
        // whether it's selectable
        locked: params.locked ? true : false,
        // whether the element is locked (cannot be moved)
        grabbed: false,
        // whether the element is grabbed by the mouse; renderer sets this privately
        grabbable: params.grabbable === undefined ? true : params.grabbable ? true : false,
        // whether the element can be grabbed
        pannable: params.pannable === undefined ? group === 'edges' ? true : false : params.pannable ? true : false,
        // whether the element has passthrough panning enabled
        active: false,
        // whether the element is active from user interaction
        classes: new Set$1(),
        // map ( className => true )
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        rscratch: {},
        // object in which the renderer can store information
        scratch: params.scratch || {},
        // scratch objects
        edges: [],
        // array of connected edges
        children: [],
        // array of children
        parent: params.parent && params.parent.isNode() ? params.parent : null,
        // parent ref
        traversalCache: {},
        // cache of output of traversal functions
        backgrounding: false,
        // whether background images are loading
        bbCache: null,
        // cache of the current bounding box
        bbCacheShift: {
            x: 0,
            y: 0
        },
        // shift applied to cached bb to be applied on next get
        bodyBounds: null,
        // bounds cache of element body, w/o overlay
        overlayBounds: null,
        // bounds cache of element body, including overlay
        labelBounds: {
            // bounds cache of labels
            all: null,
            source: null,
            target: null,
            main: null
        },
        arrowBounds: {
            // bounds cache of edge arrows
            source: null,
            target: null,
            'mid-source': null,
            'mid-target': null
        }
    };
    if (_p.position.x == null) _p.position.x = 0;
    if (_p.position.y == null) _p.position.y = 0;
    // renderedPosition overrides if specified
    if (params.renderedPosition) {
        var rpos = params.renderedPosition;
        var pan = cy.pan();
        var zoom = cy.zoom();
        _p.position = {
            x: (rpos.x - pan.x) / zoom,
            y: (rpos.y - pan.y) / zoom
        };
    }
    var classes = [];
    if (array(params.classes)) classes = params.classes;
    else if (string(params.classes)) classes = params.classes.split(/\s+/);
    for(var i = 0, l = classes.length; i < l; i++){
        var cls = classes[i];
        if (!cls || cls === '') continue;
        _p.classes.add(cls);
    }
    this.createEmitter();
    if (restore === undefined || restore) this.restore();
    var bypass = params.style || params.css;
    if (bypass) {
        warn('Setting a `style` bypass at element creation should be done only when absolutely necessary.  Try to use the stylesheet instead.');
        this.style(bypass);
    }
};
var defineSearch = function defineSearch(params) {
    params = {
        bfs: params.bfs || !params.dfs,
        dfs: params.dfs || !params.bfs
    };
    // from pseudocode on wikipedia
    return function searchFn(roots, fn, directed) {
        var options;
        if (plainObject(roots) && !elementOrCollection(roots)) {
            options = roots;
            roots = options.roots || options.root;
            fn = options.visit;
            directed = options.directed;
        }
        directed = arguments.length === 2 && !fn$6(fn) ? fn : directed;
        fn = fn$6(fn) ? fn : function() {};
        var cy = this._private.cy;
        var v = roots = string(roots) ? this.filter(roots) : roots;
        var Q = [];
        var connectedNodes = [];
        var connectedBy = {};
        var id2depth = {};
        var V = {};
        var j = 0;
        var found;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        // enqueue v
        for(var i = 0; i < v.length; i++){
            var vi = v[i];
            var viId = vi.id();
            if (vi.isNode()) {
                Q.unshift(vi);
                if (params.bfs) {
                    V[viId] = true;
                    connectedNodes.push(vi);
                }
                id2depth[viId] = 0;
            }
        }
        var _loop = function _loop() {
            var v = params.bfs ? Q.shift() : Q.pop();
            var vId = v.id();
            if (params.dfs) {
                if (V[vId]) return 0; // continue
                V[vId] = true;
                connectedNodes.push(v);
            }
            var depth = id2depth[vId];
            var prevEdge = connectedBy[vId];
            var src = prevEdge != null ? prevEdge.source() : null;
            var tgt = prevEdge != null ? prevEdge.target() : null;
            var prevNode = prevEdge == null ? undefined : v.same(src) ? tgt[0] : src[0];
            var ret;
            ret = fn(v, prevEdge, prevNode, j++, depth);
            if (ret === true) {
                found = v;
                return 1; // break
            }
            if (ret === false) return 1; // break
            var vwEdges = v.connectedEdges().filter(function(e) {
                return (!directed || e.source().same(v)) && edges.has(e);
            });
            for(var _i2 = 0; _i2 < vwEdges.length; _i2++){
                var e = vwEdges[_i2];
                var w = e.connectedNodes().filter(function(n) {
                    return !n.same(v) && nodes.has(n);
                });
                var wId = w.id();
                if (w.length !== 0 && !V[wId]) {
                    w = w[0];
                    Q.push(w);
                    if (params.bfs) {
                        V[wId] = true;
                        connectedNodes.push(w);
                    }
                    connectedBy[wId] = e;
                    id2depth[wId] = id2depth[vId] + 1;
                }
            }
        }, _ret;
        while(Q.length !== 0){
            _ret = _loop();
            if (_ret === 0) continue;
            if (_ret === 1) break;
        }
        var connectedEles = cy.collection();
        for(var _i = 0; _i < connectedNodes.length; _i++){
            var node = connectedNodes[_i];
            var edge = connectedBy[node.id()];
            if (edge != null) connectedEles.push(edge);
            connectedEles.push(node);
        }
        return {
            path: cy.collection(connectedEles),
            found: cy.collection(found)
        };
    };
};
// search, spanning trees, etc
var elesfn$v = {
    breadthFirstSearch: defineSearch({
        bfs: true
    }),
    depthFirstSearch: defineSearch({
        dfs: true
    })
};
// nice, short mathematical alias
elesfn$v.bfs = elesfn$v.breadthFirstSearch;
elesfn$v.dfs = elesfn$v.depthFirstSearch;
var heap$2 = {
    exports: {}
};
var heap$1 = heap$2.exports;
var hasRequiredHeap$1;
function requireHeap$1() {
    if (hasRequiredHeap$1) return heap$2.exports;
    hasRequiredHeap$1 = 1;
    (function(module, exports) {
        // Generated by CoffeeScript 1.8.0
        (function() {
            var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;
            floor = Math.floor, min = Math.min;
            /*
		  Default comparison function to be used
		   */ defaultCmp = function(x, y) {
                if (x < y) return -1;
                if (x > y) return 1;
                return 0;
            };
            /*
		  Insert item x in list a, and keep it sorted assuming a is sorted.
		  
		  If x is already in a, insert it to the right of the rightmost x.
		  
		  Optional args lo (default 0) and hi (default a.length) bound the slice
		  of a to be searched.
		   */ insort = function(a, x, lo, hi, cmp) {
                var mid;
                if (lo == null) lo = 0;
                if (cmp == null) cmp = defaultCmp;
                if (lo < 0) throw new Error('lo must be non-negative');
                if (hi == null) hi = a.length;
                while(lo < hi){
                    mid = floor((lo + hi) / 2);
                    if (cmp(x, a[mid]) < 0) hi = mid;
                    else lo = mid + 1;
                }
                return [].splice.apply(a, [
                    lo,
                    lo - lo
                ].concat(x)), x;
            };
            /*
		  Push item onto heap, maintaining the heap invariant.
		   */ heappush = function(array, item, cmp) {
                if (cmp == null) cmp = defaultCmp;
                array.push(item);
                return _siftdown(array, 0, array.length - 1, cmp);
            };
            /*
		  Pop the smallest item off the heap, maintaining the heap invariant.
		   */ heappop = function(array, cmp) {
                var lastelt, returnitem;
                if (cmp == null) cmp = defaultCmp;
                lastelt = array.pop();
                if (array.length) {
                    returnitem = array[0];
                    array[0] = lastelt;
                    _siftup(array, 0, cmp);
                } else returnitem = lastelt;
                return returnitem;
            };
            /*
		  Pop and return the current smallest value, and add the new item.
		  
		  This is more efficient than heappop() followed by heappush(), and can be
		  more appropriate when using a fixed size heap. Note that the value
		  returned may be larger than item! That constrains reasonable use of
		  this routine unless written as part of a conditional replacement:
		      if item > array[0]
		        item = heapreplace(array, item)
		   */ heapreplace = function(array, item, cmp) {
                var returnitem;
                if (cmp == null) cmp = defaultCmp;
                returnitem = array[0];
                array[0] = item;
                _siftup(array, 0, cmp);
                return returnitem;
            };
            /*
		  Fast version of a heappush followed by a heappop.
		   */ heappushpop = function(array, item, cmp) {
                var _ref;
                if (cmp == null) cmp = defaultCmp;
                if (array.length && cmp(array[0], item) < 0) {
                    _ref = [
                        array[0],
                        item
                    ], item = _ref[0], array[0] = _ref[1];
                    _siftup(array, 0, cmp);
                }
                return item;
            };
            /*
		  Transform list into a heap, in-place, in O(array.length) time.
		   */ heapify = function(array, cmp) {
                var i, _i, _len, _ref1, _results, _results1;
                if (cmp == null) cmp = defaultCmp;
                _ref1 = (function() {
                    _results1 = [];
                    for(var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--)_results1.push(_j);
                    return _results1;
                }).apply(this).reverse();
                _results = [];
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    i = _ref1[_i];
                    _results.push(_siftup(array, i, cmp));
                }
                return _results;
            };
            /*
		  Update the position of the given item in the heap.
		  This function should be called every time the item is being modified.
		   */ updateItem = function(array, item, cmp) {
                var pos;
                if (cmp == null) cmp = defaultCmp;
                pos = array.indexOf(item);
                if (pos === -1) return;
                _siftdown(array, 0, pos, cmp);
                return _siftup(array, pos, cmp);
            };
            /*
		  Find the n largest elements in a dataset.
		   */ nlargest = function(array, n, cmp) {
                var elem, result, _i, _len, _ref;
                if (cmp == null) cmp = defaultCmp;
                result = array.slice(0, n);
                if (!result.length) return result;
                heapify(result, cmp);
                _ref = array.slice(n);
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    elem = _ref[_i];
                    heappushpop(result, elem, cmp);
                }
                return result.sort(cmp).reverse();
            };
            /*
		  Find the n smallest elements in a dataset.
		   */ nsmallest = function(array, n, cmp) {
                var elem, los, result, _i, _j, _len, _ref, _ref1, _results;
                if (cmp == null) cmp = defaultCmp;
                if (n * 10 <= array.length) {
                    result = array.slice(0, n).sort(cmp);
                    if (!result.length) return result;
                    los = result[result.length - 1];
                    _ref = array.slice(n);
                    for(_i = 0, _len = _ref.length; _i < _len; _i++){
                        elem = _ref[_i];
                        if (cmp(elem, los) < 0) {
                            insort(result, elem, 0, null, cmp);
                            result.pop();
                            los = result[result.length - 1];
                        }
                    }
                    return result;
                }
                heapify(array, cmp);
                _results = [];
                for(_j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; 0 <= _ref1 ? ++_j : --_j)_results.push(heappop(array, cmp));
                return _results;
            };
            _siftdown = function(array, startpos, pos, cmp) {
                var newitem, parent, parentpos;
                if (cmp == null) cmp = defaultCmp;
                newitem = array[pos];
                while(pos > startpos){
                    parentpos = pos - 1 >> 1;
                    parent = array[parentpos];
                    if (cmp(newitem, parent) < 0) {
                        array[pos] = parent;
                        pos = parentpos;
                        continue;
                    }
                    break;
                }
                return array[pos] = newitem;
            };
            _siftup = function(array, pos, cmp) {
                var childpos, endpos, newitem, rightpos, startpos;
                if (cmp == null) cmp = defaultCmp;
                endpos = array.length;
                startpos = pos;
                newitem = array[pos];
                childpos = 2 * pos + 1;
                while(childpos < endpos){
                    rightpos = childpos + 1;
                    if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) childpos = rightpos;
                    array[pos] = array[childpos];
                    pos = childpos;
                    childpos = 2 * pos + 1;
                }
                array[pos] = newitem;
                return _siftdown(array, startpos, pos, cmp);
            };
            Heap = function() {
                Heap.push = heappush;
                Heap.pop = heappop;
                Heap.replace = heapreplace;
                Heap.pushpop = heappushpop;
                Heap.heapify = heapify;
                Heap.updateItem = updateItem;
                Heap.nlargest = nlargest;
                Heap.nsmallest = nsmallest;
                function Heap(cmp) {
                    this.cmp = cmp != null ? cmp : defaultCmp;
                    this.nodes = [];
                }
                Heap.prototype.push = function(x) {
                    return heappush(this.nodes, x, this.cmp);
                };
                Heap.prototype.pop = function() {
                    return heappop(this.nodes, this.cmp);
                };
                Heap.prototype.peek = function() {
                    return this.nodes[0];
                };
                Heap.prototype.contains = function(x) {
                    return this.nodes.indexOf(x) !== -1;
                };
                Heap.prototype.replace = function(x) {
                    return heapreplace(this.nodes, x, this.cmp);
                };
                Heap.prototype.pushpop = function(x) {
                    return heappushpop(this.nodes, x, this.cmp);
                };
                Heap.prototype.heapify = function() {
                    return heapify(this.nodes, this.cmp);
                };
                Heap.prototype.updateItem = function(x) {
                    return updateItem(this.nodes, x, this.cmp);
                };
                Heap.prototype.clear = function() {
                    return this.nodes = [];
                };
                Heap.prototype.empty = function() {
                    return this.nodes.length === 0;
                };
                Heap.prototype.size = function() {
                    return this.nodes.length;
                };
                Heap.prototype.clone = function() {
                    var heap;
                    heap = new Heap();
                    heap.nodes = this.nodes.slice(0);
                    return heap;
                };
                Heap.prototype.toArray = function() {
                    return this.nodes.slice(0);
                };
                Heap.prototype.insert = Heap.prototype.push;
                Heap.prototype.top = Heap.prototype.peek;
                Heap.prototype.front = Heap.prototype.peek;
                Heap.prototype.has = Heap.prototype.contains;
                Heap.prototype.copy = Heap.prototype.clone;
                return Heap;
            }();
            (function(root, factory) {
                return module.exports = factory();
            })(this, function() {
                return Heap;
            });
        }).call(heap$1);
    })(heap$2);
    return heap$2.exports;
}
var heap;
var hasRequiredHeap;
function requireHeap() {
    if (hasRequiredHeap) return heap;
    hasRequiredHeap = 1;
    heap = requireHeap$1();
    return heap;
}
var heapExports = requireHeap();
var Heap = /*@__PURE__*/ getDefaultExportFromCjs(heapExports);
var dijkstraDefaults = defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var elesfn$u = {
    dijkstra: function dijkstra(options) {
        if (!plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                weight: args[1],
                directed: args[2]
            };
        }
        var _dijkstraDefaults = dijkstraDefaults(options), root = _dijkstraDefaults.root, weight = _dijkstraDefaults.weight, directed = _dijkstraDefaults.directed;
        var eles = this;
        var weightFn = weight;
        var source = string(root) ? this.filter(root)[0] : root[0];
        var dist = {};
        var prev = {};
        var knownDist = {};
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(ele) {
            return ele.isLoop();
        });
        var getDist = function getDist(node) {
            return dist[node.id()];
        };
        var setDist = function setDist(node, d) {
            dist[node.id()] = d;
            Q.updateItem(node);
        };
        var Q = new Heap(function(a, b) {
            return getDist(a) - getDist(b);
        });
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            dist[node.id()] = node.same(source) ? 0 : Infinity;
            Q.push(node);
        }
        var distBetween = function distBetween(u, v) {
            var uvs = (directed ? u.edgesTo(v) : u.edgesWith(v)).intersect(edges);
            var smallestDistance = Infinity;
            var smallestEdge;
            for(var _i = 0; _i < uvs.length; _i++){
                var edge = uvs[_i];
                var _weight = weightFn(edge);
                if (_weight < smallestDistance || !smallestEdge) {
                    smallestDistance = _weight;
                    smallestEdge = edge;
                }
            }
            return {
                edge: smallestEdge,
                dist: smallestDistance
            };
        };
        while(Q.size() > 0){
            var u = Q.pop();
            var smalletsDist = getDist(u);
            var uid = u.id();
            knownDist[uid] = smalletsDist;
            if (smalletsDist === Infinity) continue;
            var neighbors = u.neighborhood().intersect(nodes);
            for(var _i2 = 0; _i2 < neighbors.length; _i2++){
                var v = neighbors[_i2];
                var vid = v.id();
                var vDist = distBetween(u, v);
                var alt = smalletsDist + vDist.dist;
                if (alt < getDist(v)) {
                    setDist(v, alt);
                    prev[vid] = {
                        node: u,
                        edge: vDist.edge
                    };
                }
            } // for
        } // while
        return {
            distanceTo: function distanceTo(node) {
                var target = string(node) ? nodes.filter(node)[0] : node[0];
                return knownDist[target.id()];
            },
            pathTo: function pathTo(node) {
                var target = string(node) ? nodes.filter(node)[0] : node[0];
                var S = [];
                var u = target;
                var uid = u.id();
                if (target.length > 0) {
                    S.unshift(target);
                    while(prev[uid]){
                        var p = prev[uid];
                        S.unshift(p.edge);
                        S.unshift(p.node);
                        u = p.node;
                        uid = u.id();
                    }
                }
                return eles.spawn(S);
            }
        };
    }
};
var elesfn$t = {
    // kruskal's algorithm (finds min spanning tree, assuming undirected graph)
    // implemented from pseudocode from wikipedia
    kruskal: function kruskal(weightFn) {
        weightFn = weightFn || function(edge) {
            return 1;
        };
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var forest = new Array(numNodes);
        var A = nodes; // assumes byGroup() creates new collections that can be safely mutated
        var findSetIndex = function findSetIndex(ele) {
            for(var i = 0; i < forest.length; i++){
                var eles = forest[i];
                if (eles.has(ele)) return i;
            }
        };
        // start with one forest per node
        for(var i = 0; i < numNodes; i++)forest[i] = this.spawn(nodes[i]);
        var S = edges.sort(function(a, b) {
            return weightFn(a) - weightFn(b);
        });
        for(var _i = 0; _i < S.length; _i++){
            var edge = S[_i];
            var u = edge.source()[0];
            var v = edge.target()[0];
            var setUIndex = findSetIndex(u);
            var setVIndex = findSetIndex(v);
            var setU = forest[setUIndex];
            var setV = forest[setVIndex];
            if (setUIndex !== setVIndex) {
                A.merge(edge);
                // combine forests for u and v
                setU.merge(setV);
                forest.splice(setVIndex, 1);
            }
        }
        return A;
    }
};
var aStarDefaults = defaults$g({
    root: null,
    goal: null,
    weight: function weight(edge) {
        return 1;
    },
    heuristic: function heuristic(edge) {
        return 0;
    },
    directed: false
});
var elesfn$s = {
    // Implemented from pseudocode from wikipedia
    aStar: function aStar(options) {
        var cy = this.cy();
        var _aStarDefaults = aStarDefaults(options), root = _aStarDefaults.root, goal = _aStarDefaults.goal, heuristic = _aStarDefaults.heuristic, directed = _aStarDefaults.directed, weight = _aStarDefaults.weight;
        root = cy.collection(root)[0];
        goal = cy.collection(goal)[0];
        var sid = root.id();
        var tid = goal.id();
        var gScore = {};
        var fScore = {};
        var closedSetIds = {};
        var openSet = new Heap(function(a, b) {
            return fScore[a.id()] - fScore[b.id()];
        });
        var openSetIds = new Set$1();
        var cameFrom = {};
        var cameFromEdge = {};
        var addToOpenSet = function addToOpenSet(ele, id) {
            openSet.push(ele);
            openSetIds.add(id);
        };
        var cMin, cMinId;
        var popFromOpenSet = function popFromOpenSet() {
            cMin = openSet.pop();
            cMinId = cMin.id();
            openSetIds["delete"](cMinId);
        };
        var isInOpenSet = function isInOpenSet(id) {
            return openSetIds.has(id);
        };
        addToOpenSet(root, sid);
        gScore[sid] = 0;
        fScore[sid] = heuristic(root);
        // Counter
        var steps = 0;
        // Main loop
        while(openSet.size() > 0){
            popFromOpenSet();
            steps++;
            // If we've found our goal, then we are done
            if (cMinId === tid) {
                var path = [];
                var pathNode = goal;
                var pathNodeId = tid;
                var pathEdge = cameFromEdge[pathNodeId];
                for(;;){
                    path.unshift(pathNode);
                    if (pathEdge != null) path.unshift(pathEdge);
                    pathNode = cameFrom[pathNodeId];
                    if (pathNode == null) break;
                    pathNodeId = pathNode.id();
                    pathEdge = cameFromEdge[pathNodeId];
                }
                return {
                    found: true,
                    distance: gScore[cMinId],
                    path: this.spawn(path),
                    steps: steps
                };
            }
            // Add cMin to processed nodes
            closedSetIds[cMinId] = true;
            // Update scores for neighbors of cMin
            // Take into account if graph is directed or not
            var vwEdges = cMin._private.edges;
            for(var i = 0; i < vwEdges.length; i++){
                var e = vwEdges[i];
                // edge must be in set of calling eles
                if (!this.hasElementWithId(e.id())) continue;
                // cMin must be the source of edge if directed
                if (directed && e.data('source') !== cMinId) continue;
                var wSrc = e.source();
                var wTgt = e.target();
                var w = wSrc.id() !== cMinId ? wSrc : wTgt;
                var wid = w.id();
                // node must be in set of calling eles
                if (!this.hasElementWithId(wid)) continue;
                // if node is in closedSet, ignore it
                if (closedSetIds[wid]) continue;
                // New tentative score for node w
                var tempScore = gScore[cMinId] + weight(e);
                // Update gScore for node w if:
                //   w not present in openSet
                // OR
                //   tentative gScore is less than previous value
                // w not in openSet
                if (!isInOpenSet(wid)) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    addToOpenSet(w, wid);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                    continue;
                }
                // w already in openSet, but with greater gScore
                if (tempScore < gScore[wid]) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                }
            } // End of neighbors update
        } // End of main loop
        // If we've reached here, then we've not reached our goal
        return {
            found: false,
            distance: undefined,
            path: undefined,
            steps: steps
        };
    }
}; // elesfn
var floydWarshallDefaults = defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var elesfn$r = {
    // Implemented from pseudocode from wikipedia
    floydWarshall: function floydWarshall(options) {
        var cy = this.cy();
        var _floydWarshallDefault = floydWarshallDefaults(options), weight = _floydWarshallDefault.weight, directed = _floydWarshallDefault.directed;
        var weightFn = weight;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var N = nodes.length;
        var Nsq = N * N;
        var indexOf = function indexOf(node) {
            return nodes.indexOf(node);
        };
        var atIndex = function atIndex(i) {
            return nodes[i];
        };
        // Initialize distance matrix
        var dist = new Array(Nsq);
        for(var n = 0; n < Nsq; n++){
            var j = n % N;
            var i = (n - j) / N;
            if (i === j) dist[n] = 0;
            else dist[n] = Infinity;
        }
        // Initialize matrix used for path reconstruction
        // Initialize distance matrix
        var next = new Array(Nsq);
        var edgeNext = new Array(Nsq);
        // Process edges
        for(var _i = 0; _i < edges.length; _i++){
            var edge = edges[_i];
            var src = edge.source()[0];
            var tgt = edge.target()[0];
            if (src === tgt) continue;
             // exclude loops
            var s = indexOf(src);
            var t = indexOf(tgt);
            var st = s * N + t; // source to target index
            var _weight = weightFn(edge);
            // Check if already process another edge between same 2 nodes
            if (dist[st] > _weight) {
                dist[st] = _weight;
                next[st] = t;
                edgeNext[st] = edge;
            }
            // If undirected graph, process 'reversed' edge
            if (!directed) {
                var ts = t * N + s; // target to source index
                if (!directed && dist[ts] > _weight) {
                    dist[ts] = _weight;
                    next[ts] = s;
                    edgeNext[ts] = edge;
                }
            }
        }
        // Main loop
        for(var k = 0; k < N; k++)for(var _i2 = 0; _i2 < N; _i2++){
            var ik = _i2 * N + k;
            for(var _j = 0; _j < N; _j++){
                var ij = _i2 * N + _j;
                var kj = k * N + _j;
                if (dist[ik] + dist[kj] < dist[ij]) {
                    dist[ij] = dist[ik] + dist[kj];
                    next[ij] = next[ik];
                }
            }
        }
        var getArgEle = function getArgEle(ele) {
            return (string(ele) ? cy.filter(ele) : ele)[0];
        };
        var indexOfArgEle = function indexOfArgEle(ele) {
            return indexOf(getArgEle(ele));
        };
        var res = {
            distance: function distance(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                return dist[i * N + j];
            },
            path: function path(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                var fromNode = atIndex(i);
                if (i === j) return fromNode.collection();
                if (next[i * N + j] == null) return cy.collection();
                var path = cy.collection();
                var prev = i;
                var edge;
                path.merge(fromNode);
                while(i !== j){
                    prev = i;
                    i = next[i * N + j];
                    edge = edgeNext[prev * N + i];
                    path.merge(edge);
                    path.merge(atIndex(i));
                }
                return path;
            }
        };
        return res;
    } // floydWarshall
}; // elesfn
var bellmanFordDefaults = defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    root: null
});
var elesfn$q = {
    // Implemented from pseudocode from wikipedia
    bellmanFord: function bellmanFord(options) {
        var _this = this;
        var _bellmanFordDefaults = bellmanFordDefaults(options), weight = _bellmanFordDefaults.weight, directed = _bellmanFordDefaults.directed, root = _bellmanFordDefaults.root;
        var weightFn = weight;
        var eles = this;
        var cy = this.cy();
        var _this$byGroup = this.byGroup(), edges = _this$byGroup.edges, nodes = _this$byGroup.nodes;
        var numNodes = nodes.length;
        var infoMap = new Map$1();
        var hasNegativeWeightCycle = false;
        var negativeWeightCycles = [];
        root = cy.collection(root)[0]; // in case selector passed
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numEdges = edges.length;
        var getInfo = function getInfo(node) {
            var obj = infoMap.get(node.id());
            if (!obj) {
                obj = {};
                infoMap.set(node.id(), obj);
            }
            return obj;
        };
        var getNodeFromTo = function getNodeFromTo(to) {
            return (string(to) ? cy.$(to) : to)[0];
        };
        var distanceTo = function distanceTo(to) {
            return getInfo(getNodeFromTo(to)).dist;
        };
        var pathTo = function pathTo(to) {
            var thisStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : root;
            var end = getNodeFromTo(to);
            var path = [];
            var node = end;
            for(;;){
                if (node == null) return _this.spawn();
                var _getInfo = getInfo(node), edge = _getInfo.edge, pred = _getInfo.pred;
                path.unshift(node[0]);
                if (node.same(thisStart) && path.length > 0) break;
                if (edge != null) path.unshift(edge);
                node = pred;
            }
            return eles.spawn(path);
        };
        // Initializations { dist, pred, edge }
        for(var i = 0; i < numNodes; i++){
            var node = nodes[i];
            var info = getInfo(node);
            if (node.same(root)) info.dist = 0;
            else info.dist = Infinity;
            info.pred = null;
            info.edge = null;
        }
        // Edges relaxation
        var replacedEdge = false;
        var checkForEdgeReplacement = function checkForEdgeReplacement(node1, node2, edge, info1, info2, weight) {
            var dist = info1.dist + weight;
            if (dist < info2.dist && !edge.same(info1.edge)) {
                info2.dist = dist;
                info2.pred = node1;
                info2.edge = edge;
                replacedEdge = true;
            }
        };
        for(var _i = 1; _i < numNodes; _i++){
            replacedEdge = false;
            for(var e = 0; e < numEdges; e++){
                var edge = edges[e];
                var src = edge.source();
                var tgt = edge.target();
                var _weight = weightFn(edge);
                var srcInfo = getInfo(src);
                var tgtInfo = getInfo(tgt);
                checkForEdgeReplacement(src, tgt, edge, srcInfo, tgtInfo, _weight);
                // If undirected graph, we need to take into account the 'reverse' edge
                if (!directed) checkForEdgeReplacement(tgt, src, edge, tgtInfo, srcInfo, _weight);
            }
            if (!replacedEdge) break;
        }
        if (replacedEdge) {
            // Check for negative weight cycles
            var negativeWeightCycleIds = [];
            for(var _e = 0; _e < numEdges; _e++){
                var _edge = edges[_e];
                var _src = _edge.source();
                var _tgt = _edge.target();
                var _weight2 = weightFn(_edge);
                var srcDist = getInfo(_src).dist;
                var tgtDist = getInfo(_tgt).dist;
                if (srcDist + _weight2 < tgtDist || !directed && tgtDist + _weight2 < srcDist) {
                    if (!hasNegativeWeightCycle) {
                        warn('Graph contains a negative weight cycle for Bellman-Ford');
                        hasNegativeWeightCycle = true;
                    }
                    if (options.findNegativeWeightCycles !== false) {
                        var negativeNodes = [];
                        if (srcDist + _weight2 < tgtDist) negativeNodes.push(_src);
                        if (!directed && tgtDist + _weight2 < srcDist) negativeNodes.push(_tgt);
                        var numNegativeNodes = negativeNodes.length;
                        for(var n = 0; n < numNegativeNodes; n++){
                            var start = negativeNodes[n];
                            var cycle = [
                                start
                            ];
                            cycle.push(getInfo(start).edge);
                            var _node = getInfo(start).pred;
                            while(cycle.indexOf(_node) === -1){
                                cycle.push(_node);
                                cycle.push(getInfo(_node).edge);
                                _node = getInfo(_node).pred;
                            }
                            cycle = cycle.slice(cycle.indexOf(_node));
                            var smallestId = cycle[0].id();
                            var smallestIndex = 0;
                            for(var c = 2; c < cycle.length; c += 2)if (cycle[c].id() < smallestId) {
                                smallestId = cycle[c].id();
                                smallestIndex = c;
                            }
                            cycle = cycle.slice(smallestIndex).concat(cycle.slice(0, smallestIndex));
                            cycle.push(cycle[0]);
                            var cycleId = cycle.map(function(el) {
                                return el.id();
                            }).join(",");
                            if (negativeWeightCycleIds.indexOf(cycleId) === -1) {
                                negativeWeightCycles.push(eles.spawn(cycle));
                                negativeWeightCycleIds.push(cycleId);
                            }
                        }
                    } else break;
                }
            }
        }
        return {
            distanceTo: distanceTo,
            pathTo: pathTo,
            hasNegativeWeightCycle: hasNegativeWeightCycle,
            negativeWeightCycles: negativeWeightCycles
        };
    } // bellmanFord
}; // elesfn
var sqrt2 = Math.sqrt(2);
// Function which colapses 2 (meta) nodes into one
// Updates the remaining edge lists
// Receives as a paramater the edge which causes the collapse
var collapse = function collapse(edgeIndex, nodeMap, remainingEdges) {
    if (remainingEdges.length === 0) error("Karger-Stein must be run on a connected (sub)graph");
    var edgeInfo = remainingEdges[edgeIndex];
    var sourceIn = edgeInfo[1];
    var targetIn = edgeInfo[2];
    var partition1 = nodeMap[sourceIn];
    var partition2 = nodeMap[targetIn];
    var newEdges = remainingEdges; // re-use array
    // Delete all edges between partition1 and partition2
    for(var i = newEdges.length - 1; i >= 0; i--){
        var edge = newEdges[i];
        var src = edge[1];
        var tgt = edge[2];
        if (nodeMap[src] === partition1 && nodeMap[tgt] === partition2 || nodeMap[src] === partition2 && nodeMap[tgt] === partition1) newEdges.splice(i, 1);
    }
    // All edges pointing to partition2 should now point to partition1
    for(var _i = 0; _i < newEdges.length; _i++){
        var _edge = newEdges[_i];
        if (_edge[1] === partition2) {
            // Check source
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][1] = partition1;
        } else if (_edge[2] === partition2) {
            // Check target
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][2] = partition1;
        }
    }
    // Move all nodes from partition2 to partition1
    for(var _i2 = 0; _i2 < nodeMap.length; _i2++)if (nodeMap[_i2] === partition2) nodeMap[_i2] = partition1;
    return newEdges;
};
// Contracts a graph until we reach a certain number of meta nodes
var contractUntil = function contractUntil(metaNodeMap, remainingEdges, size, sizeLimit) {
    while(size > sizeLimit){
        // Choose an edge randomly
        var edgeIndex = Math.floor(Math.random() * remainingEdges.length);
        // Collapse graph based on edge
        remainingEdges = collapse(edgeIndex, metaNodeMap, remainingEdges);
        size--;
    }
    return remainingEdges;
};
var elesfn$p = {
    // Computes the minimum cut of an undirected graph
    // Returns the correct answer with high probability
    kargerStein: function kargerStein() {
        var _this = this;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numNodes = nodes.length;
        var numEdges = edges.length;
        var numIter = Math.ceil(Math.pow(Math.log(numNodes) / Math.LN2, 2));
        var stopSize = Math.floor(numNodes / sqrt2);
        if (numNodes < 2) {
            error('At least 2 nodes are required for Karger-Stein algorithm');
            return undefined;
        }
        // Now store edge destination as indexes
        // Format for each edge (edge index, source node index, target node index)
        var edgeIndexes = [];
        for(var i = 0; i < numEdges; i++){
            var e = edges[i];
            edgeIndexes.push([
                i,
                nodes.indexOf(e.source()),
                nodes.indexOf(e.target())
            ]);
        }
        // We will store the best cut found here
        var minCutSize = Infinity;
        var minCutEdgeIndexes = [];
        var minCutNodeMap = new Array(numNodes);
        // Initial meta node partition
        var metaNodeMap = new Array(numNodes);
        var metaNodeMap2 = new Array(numNodes);
        var copyNodesMap = function copyNodesMap(from, to) {
            for(var _i3 = 0; _i3 < numNodes; _i3++)to[_i3] = from[_i3];
        };
        // Main loop
        for(var iter = 0; iter <= numIter; iter++){
            // Reset meta node partition
            for(var _i4 = 0; _i4 < numNodes; _i4++)metaNodeMap[_i4] = _i4;
            // Contract until stop point (stopSize nodes)
            var edgesState = contractUntil(metaNodeMap, edgeIndexes.slice(), numNodes, stopSize);
            var edgesState2 = edgesState.slice(); // copy
            // Create a copy of the colapsed nodes state
            copyNodesMap(metaNodeMap, metaNodeMap2);
            // Run 2 iterations starting in the stop state
            var res1 = contractUntil(metaNodeMap, edgesState, stopSize, 2);
            var res2 = contractUntil(metaNodeMap2, edgesState2, stopSize, 2);
            // Is any of the 2 results the best cut so far?
            if (res1.length <= res2.length && res1.length < minCutSize) {
                minCutSize = res1.length;
                minCutEdgeIndexes = res1;
                copyNodesMap(metaNodeMap, minCutNodeMap);
            } else if (res2.length <= res1.length && res2.length < minCutSize) {
                minCutSize = res2.length;
                minCutEdgeIndexes = res2;
                copyNodesMap(metaNodeMap2, minCutNodeMap);
            }
        } // end of main loop
        // Construct result
        var cut = this.spawn(minCutEdgeIndexes.map(function(e) {
            return edges[e[0]];
        }));
        var partition1 = this.spawn();
        var partition2 = this.spawn();
        // traverse metaNodeMap for best cut
        var witnessNodePartition = minCutNodeMap[0];
        for(var _i5 = 0; _i5 < minCutNodeMap.length; _i5++){
            var partitionId = minCutNodeMap[_i5];
            var node = nodes[_i5];
            if (partitionId === witnessNodePartition) partition1.merge(node);
            else partition2.merge(node);
        }
        // construct components corresponding to each disjoint subset of nodes
        var constructComponent = function constructComponent(subset) {
            var component = _this.spawn();
            subset.forEach(function(node) {
                component.merge(node);
                node.connectedEdges().forEach(function(edge) {
                    // ensure edge is within calling collection and edge is not in cut
                    if (_this.contains(edge) && !cut.contains(edge)) component.merge(edge);
                });
            });
            return component;
        };
        var components = [
            constructComponent(partition1),
            constructComponent(partition2)
        ];
        var ret = {
            cut: cut,
            components: components,
            // n.b. partitions are included to be compatible with the old api spec
            // (could be removed in a future major version)
            partition1: partition1,
            partition2: partition2
        };
        return ret;
    }
}; // elesfn
var copyPosition = function copyPosition(p) {
    return {
        x: p.x,
        y: p.y
    };
};
var modelToRenderedPosition$1 = function modelToRenderedPosition(p, zoom, pan) {
    return {
        x: p.x * zoom + pan.x,
        y: p.y * zoom + pan.y
    };
};
var renderedToModelPosition = function renderedToModelPosition(p, zoom, pan) {
    return {
        x: (p.x - pan.x) / zoom,
        y: (p.y - pan.y) / zoom
    };
};
var array2point = function array2point(arr) {
    return {
        x: arr[0],
        y: arr[1]
    };
};
var min = function min(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var min = Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) min = Math.min(val, min);
    }
    return min;
};
var max = function max(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var max = -Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) max = Math.max(val, max);
    }
    return max;
};
var mean = function mean(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var total = 0;
    var n = 0;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) {
            total += val;
            n++;
        }
    }
    return total / n;
};
var median = function median(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var copy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var includeHoles = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    if (copy) arr = arr.slice(begin, end);
    else {
        if (end < arr.length) arr.splice(end, arr.length - end);
        if (begin > 0) arr.splice(0, begin);
    }
    // all non finite (e.g. Infinity, NaN) elements must be -Infinity so they go to the start
    var off = 0; // offset from non-finite values
    for(var i = arr.length - 1; i >= 0; i--){
        var v = arr[i];
        if (includeHoles) {
            if (!isFinite(v)) {
                arr[i] = -Infinity;
                off++;
            }
        } else // just remove it if we don't want to consider holes
        arr.splice(i, 1);
    }
    if (sort) arr.sort(function(a, b) {
        return a - b;
    }); // requires copy = true if you don't want to change the orig
    var len = arr.length;
    var mid = Math.floor(len / 2);
    if (len % 2 !== 0) return arr[mid + 1 + off];
    else return (arr[mid - 1 + off] + arr[mid + off]) / 2;
};
var deg2rad = function deg2rad(deg) {
    return Math.PI * deg / 180;
};
var getAngleFromDisp = function getAngleFromDisp(dispX, dispY) {
    return Math.atan2(dispY, dispX) - Math.PI / 2;
};
var log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.log(2);
};
var signum = function signum(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var dist = function dist(p1, p2) {
    return Math.sqrt(sqdist(p1, p2));
};
var sqdist = function sqdist(p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return dx * dx + dy * dy;
};
var inPlaceSumNormalize = function inPlaceSumNormalize(v) {
    var length = v.length;
    // First, get sum of all elements
    var total = 0;
    for(var i = 0; i < length; i++)total += v[i];
    // Now, divide each by the sum of all elements
    for(var _i = 0; _i < length; _i++)v[_i] = v[_i] / total;
    return v;
};
// from http://en.wikipedia.org/wiki/Bézier_curve#Quadratic_curves
var qbezierAt = function qbezierAt(p0, p1, p2, t) {
    return (1 - t) * (1 - t) * p0 + 2 * (1 - t) * t * p1 + t * t * p2;
};
var qbezierPtAt = function qbezierPtAt(p0, p1, p2, t) {
    return {
        x: qbezierAt(p0.x, p1.x, p2.x, t),
        y: qbezierAt(p0.y, p1.y, p2.y, t)
    };
};
var lineAt = function lineAt(p0, p1, t, d) {
    var vec = {
        x: p1.x - p0.x,
        y: p1.y - p0.y
    };
    var vecDist = dist(p0, p1);
    var normVec = {
        x: vec.x / vecDist,
        y: vec.y / vecDist
    };
    t = t == null ? 0 : t;
    d = d != null ? d : t * vecDist;
    return {
        x: p0.x + normVec.x * d,
        y: p0.y + normVec.y * d
    };
};
var bound = function bound(min, val, max) {
    return Math.max(min, Math.min(max, val));
};
// makes a full bb (x1, y1, x2, y2, w, h) from implicit params
var makeBoundingBox = function makeBoundingBox(bb) {
    if (bb == null) return {
        x1: Infinity,
        y1: Infinity,
        x2: -Infinity,
        y2: -Infinity,
        w: 0,
        h: 0
    };
    else if (bb.x1 != null && bb.y1 != null) {
        if (bb.x2 != null && bb.y2 != null && bb.x2 >= bb.x1 && bb.y2 >= bb.y1) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x2,
            y2: bb.y2,
            w: bb.x2 - bb.x1,
            h: bb.y2 - bb.y1
        };
        else if (bb.w != null && bb.h != null && bb.w >= 0 && bb.h >= 0) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x1 + bb.w,
            y2: bb.y1 + bb.h,
            w: bb.w,
            h: bb.h
        };
    }
};
var copyBoundingBox = function copyBoundingBox(bb) {
    return {
        x1: bb.x1,
        x2: bb.x2,
        w: bb.w,
        y1: bb.y1,
        y2: bb.y2,
        h: bb.h
    };
};
var clearBoundingBox = function clearBoundingBox(bb) {
    bb.x1 = Infinity;
    bb.y1 = Infinity;
    bb.x2 = -Infinity;
    bb.y2 = -Infinity;
    bb.w = 0;
    bb.h = 0;
};
var shiftBoundingBox = function shiftBoundingBox(bb, dx, dy) {
    return {
        x1: bb.x1 + dx,
        x2: bb.x2 + dx,
        y1: bb.y1 + dy,
        y2: bb.y2 + dy,
        w: bb.w,
        h: bb.h
    };
};
var updateBoundingBox = function updateBoundingBox(bb1, bb2) {
    // update bb1 with bb2 bounds
    bb1.x1 = Math.min(bb1.x1, bb2.x1);
    bb1.x2 = Math.max(bb1.x2, bb2.x2);
    bb1.w = bb1.x2 - bb1.x1;
    bb1.y1 = Math.min(bb1.y1, bb2.y1);
    bb1.y2 = Math.max(bb1.y2, bb2.y2);
    bb1.h = bb1.y2 - bb1.y1;
};
var expandBoundingBoxByPoint = function expandBoundingBoxByPoint(bb, x, y) {
    bb.x1 = Math.min(bb.x1, x);
    bb.x2 = Math.max(bb.x2, x);
    bb.w = bb.x2 - bb.x1;
    bb.y1 = Math.min(bb.y1, y);
    bb.y2 = Math.max(bb.y2, y);
    bb.h = bb.y2 - bb.y1;
};
var expandBoundingBox = function expandBoundingBox(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    bb.x1 -= padding;
    bb.x2 += padding;
    bb.y1 -= padding;
    bb.y2 += padding;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
var expandBoundingBoxSides = function expandBoundingBoxSides(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        0
    ];
    var top, right, bottom, left;
    if (padding.length === 1) top = right = bottom = left = padding[0];
    else if (padding.length === 2) {
        top = bottom = padding[0];
        left = right = padding[1];
    } else if (padding.length === 4) {
        var _padding = _slicedToArray(padding, 4);
        top = _padding[0];
        right = _padding[1];
        bottom = _padding[2];
        left = _padding[3];
    }
    bb.x1 -= left;
    bb.x2 += right;
    bb.y1 -= top;
    bb.y2 += bottom;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
// assign the values of bb2 into bb1
var assignBoundingBox = function assignBoundingBox(bb1, bb2) {
    bb1.x1 = bb2.x1;
    bb1.y1 = bb2.y1;
    bb1.x2 = bb2.x2;
    bb1.y2 = bb2.y2;
    bb1.w = bb1.x2 - bb1.x1;
    bb1.h = bb1.y2 - bb1.y1;
};
var boundingBoxesIntersect = function boundingBoxesIntersect(bb1, bb2) {
    // case: one bb to right of other
    if (bb1.x1 > bb2.x2) return false;
    if (bb2.x1 > bb1.x2) return false;
    // case: one bb to left of other
    if (bb1.x2 < bb2.x1) return false;
    if (bb2.x2 < bb1.x1) return false;
    // case: one bb above other
    if (bb1.y2 < bb2.y1) return false;
    if (bb2.y2 < bb1.y1) return false;
    // case: one bb below other
    if (bb1.y1 > bb2.y2) return false;
    if (bb2.y1 > bb1.y2) return false;
    // otherwise, must have some overlap
    return true;
};
var inBoundingBox = function inBoundingBox(bb, x, y) {
    return bb.x1 <= x && x <= bb.x2 && bb.y1 <= y && y <= bb.y2;
};
var pointInBoundingBox = function pointInBoundingBox(bb, pt) {
    return inBoundingBox(bb, pt.x, pt.y);
};
var boundingBoxInBoundingBox = function boundingBoxInBoundingBox(bb1, bb2) {
    return inBoundingBox(bb1, bb2.x1, bb2.y1) && inBoundingBox(bb1, bb2.x2, bb2.y2);
};
var roundRectangleIntersectLine = function roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding) {
    var radius = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'auto';
    var cornerRadius = radius === 'auto' ? getRoundRectangleRadius(width, height) : radius;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    cornerRadius = Math.min(cornerRadius, halfWidth, halfHeight);
    var doWidth = cornerRadius !== halfWidth, doHeight = cornerRadius !== halfHeight;
    // Check intersections with straight line segments
    var straightLineIntersections;
    // Top segment, left to right
    if (doWidth) {
        var topStartX = nodeX - halfWidth + cornerRadius - padding;
        var topStartY = nodeY - halfHeight - padding;
        var topEndX = nodeX + halfWidth - cornerRadius + padding;
        var topEndY = topStartY;
        straightLineIntersections = finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Right segment, top to bottom
    if (doHeight) {
        var rightStartX = nodeX + halfWidth + padding;
        var rightStartY = nodeY - halfHeight + cornerRadius - padding;
        var rightEndX = rightStartX;
        var rightEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = finiteLinesIntersect(x, y, nodeX, nodeY, rightStartX, rightStartY, rightEndX, rightEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Bottom segment, left to right
    if (doWidth) {
        var bottomStartX = nodeX - halfWidth + cornerRadius - padding;
        var bottomStartY = nodeY + halfHeight + padding;
        var bottomEndX = nodeX + halfWidth - cornerRadius + padding;
        var bottomEndY = bottomStartY;
        straightLineIntersections = finiteLinesIntersect(x, y, nodeX, nodeY, bottomStartX, bottomStartY, bottomEndX, bottomEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Left segment, top to bottom
    if (doHeight) {
        var leftStartX = nodeX - halfWidth - padding;
        var leftStartY = nodeY - halfHeight + cornerRadius - padding;
        var leftEndX = leftStartX;
        var leftEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = finiteLinesIntersect(x, y, nodeX, nodeY, leftStartX, leftStartY, leftEndX, leftEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Check intersections with arc segments
    var arcIntersections;
    var topLeftCenterX = nodeX - halfWidth + cornerRadius;
    var topLeftCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = intersectLineCircle(x, y, nodeX, nodeY, topLeftCenterX, topLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= topLeftCenterX && arcIntersections[1] <= topLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var topRightCenterX = nodeX + halfWidth - cornerRadius;
    var topRightCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = intersectLineCircle(x, y, nodeX, nodeY, topRightCenterX, topRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= topRightCenterX && arcIntersections[1] <= topRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomRightCenterX = nodeX + halfWidth - cornerRadius;
    var bottomRightCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = intersectLineCircle(x, y, nodeX, nodeY, bottomRightCenterX, bottomRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= bottomRightCenterX && arcIntersections[1] >= bottomRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomLeftCenterX = nodeX - halfWidth + cornerRadius;
    var bottomLeftCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = intersectLineCircle(x, y, nodeX, nodeY, bottomLeftCenterX, bottomLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= bottomLeftCenterX && arcIntersections[1] >= bottomLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    return []; // if nothing
};
var inLineVicinity = function inLineVicinity(x, y, lx1, ly1, lx2, ly2, tolerance) {
    var t = tolerance;
    var x1 = Math.min(lx1, lx2);
    var x2 = Math.max(lx1, lx2);
    var y1 = Math.min(ly1, ly2);
    var y2 = Math.max(ly1, ly2);
    return x1 - t <= x && x <= x2 + t && y1 - t <= y && y <= y2 + t;
};
var inBezierVicinity = function inBezierVicinity(x, y, x1, y1, x2, y2, x3, y3, tolerance) {
    var bb = {
        x1: Math.min(x1, x3, x2) - tolerance,
        x2: Math.max(x1, x3, x2) + tolerance,
        y1: Math.min(y1, y3, y2) - tolerance,
        y2: Math.max(y1, y3, y2) + tolerance
    };
    // if outside the rough bounding box for the bezier, then it can't be a hit
    if (x < bb.x1 || x > bb.x2 || y < bb.y1 || y > bb.y2) // console.log('bezier out of rough bb')
    return false;
    else // console.log('do more expensive check');
    return true;
};
var solveQuadratic = function solveQuadratic(a, b, c, val) {
    c -= val;
    var r = b * b - 4 * a * c;
    if (r < 0) return [];
    var sqrtR = Math.sqrt(r);
    var denom = 2 * a;
    var root1 = (-b + sqrtR) / denom;
    var root2 = (-b - sqrtR) / denom;
    return [
        root1,
        root2
    ];
};
var solveCubic = function solveCubic(a, b, c, d, result) {
    // Solves a cubic function, returns root in form [r1, i1, r2, i2, r3, i3], where
    // r is the real component, i is the imaginary component
    // An implementation of the Cardano method from the year 1545
    // http://en.wikipedia.org/wiki/Cubic_function#The_nature_of_the_roots
    var epsilon = 0.00001;
    // avoid division by zero while keeping the overall expression close in value
    if (a === 0) a = epsilon;
    b /= a;
    c /= a;
    d /= a;
    var discriminant, q, r, dum1, s, t, term1, r13;
    q = (3.0 * c - b * b) / 9.0;
    r = -(27.0 * d) + b * (9.0 * c - 2.0 * (b * b));
    r /= 54.0;
    discriminant = q * q * q + r * r;
    result[1] = 0;
    term1 = b / 3.0;
    if (discriminant > 0) {
        s = r + Math.sqrt(discriminant);
        s = s < 0 ? -Math.pow(-s, 1.0 / 3.0) : Math.pow(s, 1.0 / 3.0);
        t = r - Math.sqrt(discriminant);
        t = t < 0 ? -Math.pow(-t, 1.0 / 3.0) : Math.pow(t, 1.0 / 3.0);
        result[0] = -term1 + s + t;
        term1 += (s + t) / 2.0;
        result[4] = result[2] = -term1;
        term1 = Math.sqrt(3.0) * (-t + s) / 2;
        result[3] = term1;
        result[5] = -term1;
        return;
    }
    result[5] = result[3] = 0;
    if (discriminant === 0) {
        r13 = r < 0 ? -Math.pow(-r, 1.0 / 3.0) : Math.pow(r, 1.0 / 3.0);
        result[0] = -term1 + 2.0 * r13;
        result[4] = result[2] = -(r13 + term1);
        return;
    }
    q = -q;
    dum1 = q * q * q;
    dum1 = Math.acos(r / Math.sqrt(dum1));
    r13 = 2.0 * Math.sqrt(q);
    result[0] = -term1 + r13 * Math.cos(dum1 / 3.0);
    result[2] = -term1 + r13 * Math.cos((dum1 + 2.0 * Math.PI) / 3.0);
    result[4] = -term1 + r13 * Math.cos((dum1 + 4.0 * Math.PI) / 3.0);
    return;
};
var sqdistToQuadraticBezier = function sqdistToQuadraticBezier(x, y, x1, y1, x2, y2, x3, y3) {
    // Find minimum distance by using the minimum of the distance
    // function between the given point and the curve
    // This gives the coefficients of the resulting cubic equation
    // whose roots tell us where a possible minimum is
    // (Coefficients are divided by 4)
    var a = 1.0 * x1 * x1 - 4 * x1 * x2 + 2 * x1 * x3 + 4 * x2 * x2 - 4 * x2 * x3 + x3 * x3 + y1 * y1 - 4 * y1 * y2 + 2 * y1 * y3 + 4 * y2 * y2 - 4 * y2 * y3 + y3 * y3;
    var b = 9 * x1 * x2 - 3 * x1 * x1 - 3 * x1 * x3 - 6 * x2 * x2 + 3 * x2 * x3 + 9 * y1 * y2 - 3 * y1 * y1 - 3 * y1 * y3 - 6 * y2 * y2 + 3 * y2 * y3;
    var c = 3 * x1 * x1 - 6 * x1 * x2 + x1 * x3 - x1 * x + 2 * x2 * x2 + 2 * x2 * x - x3 * x + 3 * y1 * y1 - 6 * y1 * y2 + y1 * y3 - y1 * y + 2 * y2 * y2 + 2 * y2 * y - y3 * y;
    var d = 1.0 * x1 * x2 - x1 * x1 + x1 * x - x2 * x + y1 * y2 - y1 * y1 + y1 * y - y2 * y;
    // debug("coefficients: " + a / a + ", " + b / a + ", " + c / a + ", " + d / a);
    var roots = [];
    // Use the cubic solving algorithm
    solveCubic(a, b, c, d, roots);
    var zeroThreshold = 0.0000001;
    var params = [];
    for(var index = 0; index < 6; index += 2)if (Math.abs(roots[index + 1]) < zeroThreshold && roots[index] >= 0 && roots[index] <= 1.0) params.push(roots[index]);
    params.push(1.0);
    params.push(0.0);
    var minDistanceSquared = -1;
    var curX, curY, distSquared;
    for(var i = 0; i < params.length; i++){
        curX = Math.pow(1.0 - params[i], 2.0) * x1 + 2.0 * (1 - params[i]) * params[i] * x2 + params[i] * params[i] * x3;
        curY = Math.pow(1 - params[i], 2.0) * y1 + 2 * (1.0 - params[i]) * params[i] * y2 + params[i] * params[i] * y3;
        distSquared = Math.pow(curX - x, 2) + Math.pow(curY - y, 2);
        // debug('distance for param ' + params[i] + ": " + Math.sqrt(distSquared));
        if (minDistanceSquared >= 0) {
            if (distSquared < minDistanceSquared) minDistanceSquared = distSquared;
        } else minDistanceSquared = distSquared;
    }
    return minDistanceSquared;
};
var sqdistToFiniteLine = function sqdistToFiniteLine(x, y, x1, y1, x2, y2) {
    var offset = [
        x - x1,
        y - y1
    ];
    var line = [
        x2 - x1,
        y2 - y1
    ];
    var lineSq = line[0] * line[0] + line[1] * line[1];
    var hypSq = offset[0] * offset[0] + offset[1] * offset[1];
    var dotProduct = offset[0] * line[0] + offset[1] * line[1];
    var adjSq = dotProduct * dotProduct / lineSq;
    if (dotProduct < 0) return hypSq;
    if (adjSq > lineSq) return (x - x2) * (x - x2) + (y - y2) * (y - y2);
    return hypSq - adjSq;
};
var pointInsidePolygonPoints = function pointInsidePolygonPoints(x, y, points) {
    var x1, y1, x2, y2;
    var y3;
    // Intersect with vertical line through (x, y)
    var up = 0;
    // let down = 0;
    for(var i = 0; i < points.length / 2; i++){
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        if (i + 1 < points.length / 2) {
            x2 = points[(i + 1) * 2];
            y2 = points[(i + 1) * 2 + 1];
        } else {
            x2 = points[(i + 1 - points.length / 2) * 2];
            y2 = points[(i + 1 - points.length / 2) * 2 + 1];
        }
        if (x1 == x && x2 == x) ;
        else if (x1 >= x && x >= x2 || x1 <= x && x <= x2) {
            y3 = (x - x1) / (x2 - x1) * (y2 - y1) + y1;
            if (y3 > y) up++;
        // if( y3 < y ){
        // down++;
        // }
        } else continue;
    }
    if (up % 2 === 0) return false;
    else return true;
};
var pointInsidePolygon = function pointInsidePolygon(x, y, basePoints, centerX, centerY, width, height, direction, padding) {
    var transformedPoints = new Array(basePoints.length);
    // Gives negative angle
    var angle;
    if (direction[0] != null) {
        angle = Math.atan(direction[1] / direction[0]);
        if (direction[0] < 0) angle = angle + Math.PI / 2;
        else angle = -angle - Math.PI / 2;
    } else angle = direction;
    var cos = Math.cos(-angle);
    var sin = Math.sin(-angle);
    //    console.log("base: " + basePoints);
    for(var i = 0; i < transformedPoints.length / 2; i++){
        transformedPoints[i * 2] = width / 2 * (basePoints[i * 2] * cos - basePoints[i * 2 + 1] * sin);
        transformedPoints[i * 2 + 1] = height / 2 * (basePoints[i * 2 + 1] * cos + basePoints[i * 2] * sin);
        transformedPoints[i * 2] += centerX;
        transformedPoints[i * 2 + 1] += centerY;
    }
    var points;
    if (padding > 0) {
        var expandedLineSet = expandPolygon(transformedPoints, -padding);
        points = joinLines(expandedLineSet);
    } else points = transformedPoints;
    return pointInsidePolygonPoints(x, y, points);
};
var pointInsideRoundPolygon = function pointInsideRoundPolygon(x, y, basePoints, centerX, centerY, width, height, corners) {
    var cutPolygonPoints = new Array(basePoints.length * 2);
    for(var i = 0; i < corners.length; i++){
        var corner = corners[i];
        cutPolygonPoints[i * 4 + 0] = corner.startX;
        cutPolygonPoints[i * 4 + 1] = corner.startY;
        cutPolygonPoints[i * 4 + 2] = corner.stopX;
        cutPolygonPoints[i * 4 + 3] = corner.stopY;
        var squaredDistance = Math.pow(corner.cx - x, 2) + Math.pow(corner.cy - y, 2);
        if (squaredDistance <= Math.pow(corner.radius, 2)) return true;
    }
    return pointInsidePolygonPoints(x, y, cutPolygonPoints);
};
var joinLines = function joinLines(lineSet) {
    var vertices = new Array(lineSet.length / 2);
    var currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY;
    var nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY;
    for(var i = 0; i < lineSet.length / 4; i++){
        currentLineStartX = lineSet[i * 4];
        currentLineStartY = lineSet[i * 4 + 1];
        currentLineEndX = lineSet[i * 4 + 2];
        currentLineEndY = lineSet[i * 4 + 3];
        if (i < lineSet.length / 4 - 1) {
            nextLineStartX = lineSet[(i + 1) * 4];
            nextLineStartY = lineSet[(i + 1) * 4 + 1];
            nextLineEndX = lineSet[(i + 1) * 4 + 2];
            nextLineEndY = lineSet[(i + 1) * 4 + 3];
        } else {
            nextLineStartX = lineSet[0];
            nextLineStartY = lineSet[1];
            nextLineEndX = lineSet[2];
            nextLineEndY = lineSet[3];
        }
        var intersection = finiteLinesIntersect(currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY, nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY, true);
        vertices[i * 2] = intersection[0];
        vertices[i * 2 + 1] = intersection[1];
    }
    return vertices;
};
var expandPolygon = function expandPolygon(points, pad) {
    var expandedLineSet = new Array(points.length * 2);
    var currentPointX, currentPointY, nextPointX, nextPointY;
    for(var i = 0; i < points.length / 2; i++){
        currentPointX = points[i * 2];
        currentPointY = points[i * 2 + 1];
        if (i < points.length / 2 - 1) {
            nextPointX = points[(i + 1) * 2];
            nextPointY = points[(i + 1) * 2 + 1];
        } else {
            nextPointX = points[0];
            nextPointY = points[1];
        }
        // Current line: [currentPointX, currentPointY] to [nextPointX, nextPointY]
        // Assume CCW polygon winding
        var offsetX = nextPointY - currentPointY;
        var offsetY = -(nextPointX - currentPointX);
        // Normalize
        var offsetLength = Math.sqrt(offsetX * offsetX + offsetY * offsetY);
        var normalizedOffsetX = offsetX / offsetLength;
        var normalizedOffsetY = offsetY / offsetLength;
        expandedLineSet[i * 4] = currentPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 1] = currentPointY + normalizedOffsetY * pad;
        expandedLineSet[i * 4 + 2] = nextPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 3] = nextPointY + normalizedOffsetY * pad;
    }
    return expandedLineSet;
};
var intersectLineEllipse = function intersectLineEllipse(x, y, centerX, centerY, ellipseWradius, ellipseHradius) {
    var dispX = centerX - x;
    var dispY = centerY - y;
    dispX /= ellipseWradius;
    dispY /= ellipseHradius;
    var len = Math.sqrt(dispX * dispX + dispY * dispY);
    var newLength = len - 1;
    if (newLength < 0) return [];
    var lenProportion = newLength / len;
    return [
        (centerX - x) * lenProportion + x,
        (centerY - y) * lenProportion + y
    ];
};
var checkInEllipse = function checkInEllipse(x, y, width, height, centerX, centerY, padding) {
    x -= centerX;
    y -= centerY;
    x /= width / 2 + padding;
    y /= height / 2 + padding;
    return x * x + y * y <= 1;
};
// Returns intersections of increasing distance from line's start point
var intersectLineCircle = function intersectLineCircle(x1, y1, x2, y2, centerX, centerY, radius) {
    // Calculate d, direction vector of line
    var d = [
        x2 - x1,
        y2 - y1
    ]; // Direction vector of line
    var f = [
        x1 - centerX,
        y1 - centerY
    ];
    var a = d[0] * d[0] + d[1] * d[1];
    var b = 2 * (f[0] * d[0] + f[1] * d[1]);
    var c = f[0] * f[0] + f[1] * f[1] - radius * radius;
    var discriminant = b * b - 4 * a * c;
    if (discriminant < 0) return [];
    var t1 = (-b + Math.sqrt(discriminant)) / (2 * a);
    var t2 = (-b - Math.sqrt(discriminant)) / (2 * a);
    var tMin = Math.min(t1, t2);
    var tMax = Math.max(t1, t2);
    var inRangeParams = [];
    if (tMin >= 0 && tMin <= 1) inRangeParams.push(tMin);
    if (tMax >= 0 && tMax <= 1) inRangeParams.push(tMax);
    if (inRangeParams.length === 0) return [];
    var nearIntersectionX = inRangeParams[0] * d[0] + x1;
    var nearIntersectionY = inRangeParams[0] * d[1] + y1;
    if (inRangeParams.length > 1) {
        if (inRangeParams[0] == inRangeParams[1]) return [
            nearIntersectionX,
            nearIntersectionY
        ];
        else {
            var farIntersectionX = inRangeParams[1] * d[0] + x1;
            var farIntersectionY = inRangeParams[1] * d[1] + y1;
            return [
                nearIntersectionX,
                nearIntersectionY,
                farIntersectionX,
                farIntersectionY
            ];
        }
    } else return [
        nearIntersectionX,
        nearIntersectionY
    ];
};
var midOfThree = function midOfThree(a, b, c) {
    if (b <= a && a <= c || c <= a && a <= b) return a;
    else if (a <= b && b <= c || c <= b && b <= a) return b;
    else return c;
};
// (x1,y1)=>(x2,y2) intersect with (x3,y3)=>(x4,y4)
var finiteLinesIntersect = function finiteLinesIntersect(x1, y1, x2, y2, x3, y3, x4, y4, infiniteLines) {
    var dx13 = x1 - x3;
    var dx21 = x2 - x1;
    var dx43 = x4 - x3;
    var dy13 = y1 - y3;
    var dy21 = y2 - y1;
    var dy43 = y4 - y3;
    var ua_t = dx43 * dy13 - dy43 * dx13;
    var ub_t = dx21 * dy13 - dy21 * dx13;
    var u_b = dy43 * dx21 - dx43 * dy21;
    if (u_b !== 0) {
        var ua = ua_t / u_b;
        var ub = ub_t / u_b;
        var flptThreshold = 0.001;
        var _min = 0 - flptThreshold;
        var _max = 1 + flptThreshold;
        if (_min <= ua && ua <= _max && _min <= ub && ub <= _max) return [
            x1 + ua * dx21,
            y1 + ua * dy21
        ];
        else {
            if (!infiniteLines) return [];
            else return [
                x1 + ua * dx21,
                y1 + ua * dy21
            ];
        }
    } else {
        if (ua_t === 0 || ub_t === 0) {
            // Parallel, coincident lines. Check if overlap
            // Check endpoint of second line
            if (midOfThree(x1, x2, x4) === x4) return [
                x4,
                y4
            ];
            // Check start point of second line
            if (midOfThree(x1, x2, x3) === x3) return [
                x3,
                y3
            ];
            // Endpoint of first line
            if (midOfThree(x3, x4, x2) === x2) return [
                x2,
                y2
            ];
            return [];
        } else // Parallel, non-coincident
        return [];
    }
};
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY, width, height, padding )
// intersect a node polygon (pts transformed)
//
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY )
// intersect the points (no transform)
var polygonIntersectLine = function polygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding) {
    var intersections = [];
    var intersection;
    var transformedPoints = new Array(basePoints.length);
    var doTransform = true;
    if (width == null) doTransform = false;
    var points;
    if (doTransform) {
        for(var i = 0; i < transformedPoints.length / 2; i++){
            transformedPoints[i * 2] = basePoints[i * 2] * width + centerX;
            transformedPoints[i * 2 + 1] = basePoints[i * 2 + 1] * height + centerY;
        }
        if (padding > 0) {
            var expandedLineSet = expandPolygon(transformedPoints, -padding);
            points = joinLines(expandedLineSet);
        } else points = transformedPoints;
    } else points = basePoints;
    var currentX, currentY, nextX, nextY;
    for(var _i2 = 0; _i2 < points.length / 2; _i2++){
        currentX = points[_i2 * 2];
        currentY = points[_i2 * 2 + 1];
        if (_i2 < points.length / 2 - 1) {
            nextX = points[(_i2 + 1) * 2];
            nextY = points[(_i2 + 1) * 2 + 1];
        } else {
            nextX = points[0];
            nextY = points[1];
        }
        intersection = finiteLinesIntersect(x, y, centerX, centerY, currentX, currentY, nextX, nextY);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    return intersections;
};
var roundPolygonIntersectLine = function roundPolygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding, corners) {
    var intersections = [];
    var intersection;
    var lines = new Array(basePoints.length * 2);
    corners.forEach(function(corner, i) {
        if (i === 0) {
            lines[lines.length - 2] = corner.startX;
            lines[lines.length - 1] = corner.startY;
        } else {
            lines[i * 4 - 2] = corner.startX;
            lines[i * 4 - 1] = corner.startY;
        }
        lines[i * 4] = corner.stopX;
        lines[i * 4 + 1] = corner.stopY;
        intersection = intersectLineCircle(x, y, centerX, centerY, corner.cx, corner.cy, corner.radius);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    });
    for(var i = 0; i < lines.length / 4; i++){
        intersection = finiteLinesIntersect(x, y, centerX, centerY, lines[i * 4], lines[i * 4 + 1], lines[i * 4 + 2], lines[i * 4 + 3], false);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    if (intersections.length > 2) {
        var lowestIntersection = [
            intersections[0],
            intersections[1]
        ];
        var lowestSquaredDistance = Math.pow(lowestIntersection[0] - x, 2) + Math.pow(lowestIntersection[1] - y, 2);
        for(var _i3 = 1; _i3 < intersections.length / 2; _i3++){
            var squaredDistance = Math.pow(intersections[_i3 * 2] - x, 2) + Math.pow(intersections[_i3 * 2 + 1] - y, 2);
            if (squaredDistance <= lowestSquaredDistance) {
                lowestIntersection[0] = intersections[_i3 * 2];
                lowestIntersection[1] = intersections[_i3 * 2 + 1];
                lowestSquaredDistance = squaredDistance;
            }
        }
        return lowestIntersection;
    }
    return intersections;
};
var shortenIntersection = function shortenIntersection(intersection, offset, amount) {
    var disp = [
        intersection[0] - offset[0],
        intersection[1] - offset[1]
    ];
    var length = Math.sqrt(disp[0] * disp[0] + disp[1] * disp[1]);
    var lenRatio = (length - amount) / length;
    if (lenRatio < 0) lenRatio = 0.00001;
    return [
        offset[0] + lenRatio * disp[0],
        offset[1] + lenRatio * disp[1]
    ];
};
var generateUnitNgonPointsFitToSquare = function generateUnitNgonPointsFitToSquare(sides, rotationRadians) {
    var points = generateUnitNgonPoints(sides, rotationRadians);
    points = fitPolygonToSquare(points);
    return points;
};
var fitPolygonToSquare = function fitPolygonToSquare(points) {
    var x, y;
    var sides = points.length / 2;
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for(var i = 0; i < sides; i++){
        x = points[2 * i];
        y = points[2 * i + 1];
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    // stretch factors
    var sx = 2 / (maxX - minX);
    var sy = 2 / (maxY - minY);
    for(var _i4 = 0; _i4 < sides; _i4++){
        x = points[2 * _i4] = points[2 * _i4] * sx;
        y = points[2 * _i4 + 1] = points[2 * _i4 + 1] * sy;
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    if (minY < -1) for(var _i5 = 0; _i5 < sides; _i5++)y = points[2 * _i5 + 1] = points[2 * _i5 + 1] + (-1 - minY);
    return points;
};
var generateUnitNgonPoints = function generateUnitNgonPoints(sides, rotationRadians) {
    var increment = 1.0 / sides * 2 * Math.PI;
    var startAngle = sides % 2 === 0 ? Math.PI / 2.0 + increment / 2.0 : Math.PI / 2.0;
    startAngle += rotationRadians;
    var points = new Array(sides * 2);
    var currentAngle;
    for(var i = 0; i < sides; i++){
        currentAngle = i * increment + startAngle;
        points[2 * i] = Math.cos(currentAngle); // x
        points[2 * i + 1] = Math.sin(-currentAngle); // y
    }
    return points;
};
// Set the default radius, unless half of width or height is smaller than default
var getRoundRectangleRadius = function getRoundRectangleRadius(width, height) {
    return Math.min(width / 4, height / 4, 8);
};
// Set the default radius
var getRoundPolygonRadius = function getRoundPolygonRadius(width, height) {
    return Math.min(width / 10, height / 10, 8);
};
var getCutRectangleCornerLength = function getCutRectangleCornerLength() {
    return 8;
};
var bezierPtsToQuadCoeff = function bezierPtsToQuadCoeff(p0, p1, p2) {
    return [
        p0 - 2 * p1 + p2,
        2 * (p1 - p0),
        p0
    ];
};
// get curve width, height, and control point position offsets as a percentage of node height / width
var getBarrelCurveConstants = function getBarrelCurveConstants(width, height) {
    return {
        heightOffset: Math.min(15, 0.05 * height),
        widthOffset: Math.min(100, 0.25 * width),
        ctrlPtOffsetPct: 0.05
    };
};
var pageRankDefaults = defaults$g({
    dampingFactor: 0.8,
    precision: 0.000001,
    iterations: 200,
    weight: function weight(edge) {
        return 1;
    }
});
var elesfn$o = {
    pageRank: function pageRank(options) {
        var _pageRankDefaults = pageRankDefaults(options), dampingFactor = _pageRankDefaults.dampingFactor, precision = _pageRankDefaults.precision, iterations = _pageRankDefaults.iterations, weight = _pageRankDefaults.weight;
        var cy = this._private.cy;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var numNodesSqd = numNodes * numNodes;
        var numEdges = edges.length;
        // Construct transposed adjacency matrix
        // First lets have a zeroed matrix of the right size
        // We'll also keep track of the sum of each column
        var matrix = new Array(numNodesSqd);
        var columnSum = new Array(numNodes);
        var additionalProb = (1 - dampingFactor) / numNodes;
        // Create null matrix
        for(var i = 0; i < numNodes; i++){
            for(var j = 0; j < numNodes; j++){
                var n = i * numNodes + j;
                matrix[n] = 0;
            }
            columnSum[i] = 0;
        }
        // Now, process edges
        for(var _i = 0; _i < numEdges; _i++){
            var edge = edges[_i];
            var srcId = edge.data('source');
            var tgtId = edge.data('target');
            // Don't include loops in the matrix
            if (srcId === tgtId) continue;
            var s = nodes.indexOfId(srcId);
            var t = nodes.indexOfId(tgtId);
            var w = weight(edge);
            var _n = t * numNodes + s;
            // Update matrix
            matrix[_n] += w;
            // Update column sum
            columnSum[s] += w;
        }
        // Add additional probability based on damping factor
        // Also, take into account columns that have sum = 0
        var p = 1.0 / numNodes + additionalProb; // Shorthand
        // Traverse matrix, column by column
        for(var _j = 0; _j < numNodes; _j++){
            if (columnSum[_j] === 0) // No 'links' out from node jth, assume equal probability for each possible node
            for(var _i2 = 0; _i2 < numNodes; _i2++){
                var _n2 = _i2 * numNodes + _j;
                matrix[_n2] = p;
            }
            else // Node jth has outgoing link, compute normalized probabilities
            for(var _i3 = 0; _i3 < numNodes; _i3++){
                var _n3 = _i3 * numNodes + _j;
                matrix[_n3] = matrix[_n3] / columnSum[_j] + additionalProb;
            }
        }
        // Compute dominant eigenvector using power method
        var eigenvector = new Array(numNodes);
        var temp = new Array(numNodes);
        var previous;
        // Start with a vector of all 1's
        // Also, initialize a null vector which will be used as shorthand
        for(var _i4 = 0; _i4 < numNodes; _i4++)eigenvector[_i4] = 1;
        for(var iter = 0; iter < iterations; iter++){
            // Temp array with all 0's
            for(var _i5 = 0; _i5 < numNodes; _i5++)temp[_i5] = 0;
            // Multiply matrix with previous result
            for(var _i6 = 0; _i6 < numNodes; _i6++)for(var _j2 = 0; _j2 < numNodes; _j2++){
                var _n4 = _i6 * numNodes + _j2;
                temp[_i6] += matrix[_n4] * eigenvector[_j2];
            }
            inPlaceSumNormalize(temp);
            previous = eigenvector;
            eigenvector = temp;
            temp = previous;
            var diff = 0;
            // Compute difference (squared module) of both vectors
            for(var _i7 = 0; _i7 < numNodes; _i7++){
                var delta = previous[_i7] - eigenvector[_i7];
                diff += delta * delta;
            }
            // If difference is less than the desired threshold, stop iterating
            if (diff < precision) break;
        }
        // Construct result
        var res = {
            rank: function rank(node) {
                node = cy.collection(node)[0];
                return eigenvector[nodes.indexOf(node)];
            }
        };
        return res;
    } // pageRank
}; // elesfn
var defaults$f = defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    alpha: 0
});
var elesfn$n = {
    degreeCentralityNormalized: function degreeCentralityNormalized(options) {
        options = defaults$f(options);
        var cy = this.cy();
        var nodes = this.nodes();
        var numNodes = nodes.length;
        if (!options.directed) {
            var degrees = {};
            var maxDegree = 0;
            for(var i = 0; i < numNodes; i++){
                var node = nodes[i];
                // add current node to the current options object and call degreeCentrality
                options.root = node;
                var currDegree = this.degreeCentrality(options);
                if (maxDegree < currDegree.degree) maxDegree = currDegree.degree;
                degrees[node.id()] = currDegree.degree;
            }
            return {
                degree: function degree(node) {
                    if (maxDegree === 0) return 0;
                    if (string(node)) // from is a selector string
                    node = cy.filter(node);
                    return degrees[node.id()] / maxDegree;
                }
            };
        } else {
            var indegrees = {};
            var outdegrees = {};
            var maxIndegree = 0;
            var maxOutdegree = 0;
            for(var _i = 0; _i < numNodes; _i++){
                var _node = nodes[_i];
                var id = _node.id();
                // add current node to the current options object and call degreeCentrality
                options.root = _node;
                var _currDegree = this.degreeCentrality(options);
                if (maxIndegree < _currDegree.indegree) maxIndegree = _currDegree.indegree;
                if (maxOutdegree < _currDegree.outdegree) maxOutdegree = _currDegree.outdegree;
                indegrees[id] = _currDegree.indegree;
                outdegrees[id] = _currDegree.outdegree;
            }
            return {
                indegree: function indegree(node) {
                    if (maxIndegree == 0) return 0;
                    if (string(node)) // from is a selector string
                    node = cy.filter(node);
                    return indegrees[node.id()] / maxIndegree;
                },
                outdegree: function outdegree(node) {
                    if (maxOutdegree === 0) return 0;
                    if (string(node)) // from is a selector string
                    node = cy.filter(node);
                    return outdegrees[node.id()] / maxOutdegree;
                }
            };
        }
    },
    // degreeCentralityNormalized
    // Implemented from the algorithm in Opsahl's paper
    // "Node centrality in weighted networks: Generalizing degree and shortest paths"
    // check the heading 2 "Degree"
    degreeCentrality: function degreeCentrality(options) {
        options = defaults$f(options);
        var cy = this.cy();
        var callingEles = this;
        var _options = options, root = _options.root, weight = _options.weight, directed = _options.directed, alpha = _options.alpha;
        root = cy.collection(root)[0];
        if (!directed) {
            var connEdges = root.connectedEdges().intersection(callingEles);
            var k = connEdges.length;
            var s = 0;
            // Now, sum edge weights
            for(var i = 0; i < connEdges.length; i++)s += weight(connEdges[i]);
            return {
                degree: Math.pow(k, 1 - alpha) * Math.pow(s, alpha)
            };
        } else {
            var edges = root.connectedEdges();
            var incoming = edges.filter(function(edge) {
                return edge.target().same(root) && callingEles.has(edge);
            });
            var outgoing = edges.filter(function(edge) {
                return edge.source().same(root) && callingEles.has(edge);
            });
            var k_in = incoming.length;
            var k_out = outgoing.length;
            var s_in = 0;
            var s_out = 0;
            // Now, sum incoming edge weights
            for(var _i2 = 0; _i2 < incoming.length; _i2++)s_in += weight(incoming[_i2]);
            // Now, sum outgoing edge weights
            for(var _i3 = 0; _i3 < outgoing.length; _i3++)s_out += weight(outgoing[_i3]);
            return {
                indegree: Math.pow(k_in, 1 - alpha) * Math.pow(s_in, alpha),
                outdegree: Math.pow(k_out, 1 - alpha) * Math.pow(s_out, alpha)
            };
        }
    } // degreeCentrality
}; // elesfn
// nice, short mathematical alias
elesfn$n.dc = elesfn$n.degreeCentrality;
elesfn$n.dcn = elesfn$n.degreeCentralityNormalised = elesfn$n.degreeCentralityNormalized;
var defaults$e = defaults$g({
    harmonic: true,
    weight: function weight() {
        return 1;
    },
    directed: false,
    root: null
});
var elesfn$m = {
    closenessCentralityNormalized: function closenessCentralityNormalized(options) {
        var _defaults = defaults$e(options), harmonic = _defaults.harmonic, weight = _defaults.weight, directed = _defaults.directed;
        var cy = this.cy();
        var closenesses = {};
        var maxCloseness = 0;
        var nodes = this.nodes();
        var fw = this.floydWarshall({
            weight: weight,
            directed: directed
        });
        // Compute closeness for every node and find the maximum closeness
        for(var i = 0; i < nodes.length; i++){
            var currCloseness = 0;
            var node_i = nodes[i];
            for(var j = 0; j < nodes.length; j++)if (i !== j) {
                var d = fw.distance(node_i, nodes[j]);
                if (harmonic) currCloseness += 1 / d;
                else currCloseness += d;
            }
            if (!harmonic) currCloseness = 1 / currCloseness;
            if (maxCloseness < currCloseness) maxCloseness = currCloseness;
            closenesses[node_i.id()] = currCloseness;
        }
        return {
            closeness: function closeness(node) {
                if (maxCloseness == 0) return 0;
                if (string(node)) // from is a selector string
                node = cy.filter(node)[0].id();
                else // from is a node
                node = node.id();
                return closenesses[node] / maxCloseness;
            }
        };
    },
    // Implemented from pseudocode from wikipedia
    closenessCentrality: function closenessCentrality(options) {
        var _defaults2 = defaults$e(options), root = _defaults2.root, weight = _defaults2.weight, directed = _defaults2.directed, harmonic = _defaults2.harmonic;
        root = this.filter(root)[0];
        // we need distance from this node to every other node
        var dijkstra = this.dijkstra({
            root: root,
            weight: weight,
            directed: directed
        });
        var totalDistance = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var n = nodes[i];
            if (!n.same(root)) {
                var d = dijkstra.distanceTo(n);
                if (harmonic) totalDistance += 1 / d;
                else totalDistance += d;
            }
        }
        return harmonic ? totalDistance : 1 / totalDistance;
    } // closenessCentrality
}; // elesfn
// nice, short mathematical alias
elesfn$m.cc = elesfn$m.closenessCentrality;
elesfn$m.ccn = elesfn$m.closenessCentralityNormalised = elesfn$m.closenessCentralityNormalized;
var defaults$d = defaults$g({
    weight: null,
    directed: false
});
var elesfn$l = {
    // Implemented from the algorithm in the paper "On Variants of Shortest-Path Betweenness Centrality and their Generic Computation" by Ulrik Brandes
    betweennessCentrality: function betweennessCentrality(options) {
        var _defaults = defaults$d(options), directed = _defaults.directed, weight = _defaults.weight;
        var weighted = weight != null;
        var cy = this.cy();
        // starting
        var V = this.nodes();
        var A = {};
        var _C = {};
        var max = 0;
        var C = {
            set: function set(key, val) {
                _C[key] = val;
                if (val > max) max = val;
            },
            get: function get(key) {
                return _C[key];
            }
        };
        // A contains the neighborhoods of every node
        for(var i = 0; i < V.length; i++){
            var v = V[i];
            var vid = v.id();
            if (directed) A[vid] = v.outgoers().nodes(); // get outgoers of every node
            else A[vid] = v.openNeighborhood().nodes(); // get neighbors of every node
            C.set(vid, 0);
        }
        var _loop = function _loop() {
            var sid = V[s].id();
            var S = []; // stack
            var P = {};
            var g = {};
            var d = {};
            var Q = new Heap(function(a, b) {
                return d[a] - d[b];
            }); // queue
            // init dictionaries
            for(var _i = 0; _i < V.length; _i++){
                var _vid = V[_i].id();
                P[_vid] = [];
                g[_vid] = 0;
                d[_vid] = Infinity;
            }
            g[sid] = 1; // sigma
            d[sid] = 0; // distance to s
            Q.push(sid);
            while(!Q.empty()){
                var _v = Q.pop();
                S.push(_v);
                if (weighted) for(var j = 0; j < A[_v].length; j++){
                    var w = A[_v][j];
                    var vEle = cy.getElementById(_v);
                    var edge = undefined;
                    if (vEle.edgesTo(w).length > 0) edge = vEle.edgesTo(w)[0];
                    else edge = w.edgesTo(vEle)[0];
                    var edgeWeight = weight(edge);
                    w = w.id();
                    if (d[w] > d[_v] + edgeWeight) {
                        d[w] = d[_v] + edgeWeight;
                        if (Q.nodes.indexOf(w) < 0) //if w is not in Q
                        Q.push(w);
                        else // update position if w is in Q
                        Q.updateItem(w);
                        g[w] = 0;
                        P[w] = [];
                    }
                    if (d[w] == d[_v] + edgeWeight) {
                        g[w] = g[w] + g[_v];
                        P[w].push(_v);
                    }
                }
                else for(var _j = 0; _j < A[_v].length; _j++){
                    var _w = A[_v][_j].id();
                    if (d[_w] == Infinity) {
                        Q.push(_w);
                        d[_w] = d[_v] + 1;
                    }
                    if (d[_w] == d[_v] + 1) {
                        g[_w] = g[_w] + g[_v];
                        P[_w].push(_v);
                    }
                }
            }
            var e = {};
            for(var _i2 = 0; _i2 < V.length; _i2++)e[V[_i2].id()] = 0;
            while(S.length > 0){
                var _w2 = S.pop();
                for(var _j2 = 0; _j2 < P[_w2].length; _j2++){
                    var _v2 = P[_w2][_j2];
                    e[_v2] = e[_v2] + g[_v2] / g[_w2] * (1 + e[_w2]);
                }
                if (_w2 != V[s].id()) C.set(_w2, C.get(_w2) + e[_w2]);
            }
        };
        for(var s = 0; s < V.length; s++)_loop();
        var ret = {
            betweenness: function betweenness(node) {
                var id = cy.collection(node).id();
                return C.get(id);
            },
            betweennessNormalized: function betweennessNormalized(node) {
                if (max == 0) return 0;
                var id = cy.collection(node).id();
                return C.get(id) / max;
            }
        };
        // alias
        ret.betweennessNormalised = ret.betweennessNormalized;
        return ret;
    } // betweennessCentrality
}; // elesfn
// nice, short mathematical alias
elesfn$l.bc = elesfn$l.betweennessCentrality;
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-markov-cluster
/* eslint-disable no-unused-vars */ var defaults$c = defaults$g({
    expandFactor: 2,
    // affects time of computation and cluster granularity to some extent: M * M
    inflateFactor: 2,
    // affects cluster granularity (the greater the value, the more clusters): M(i,j) / E(j)
    multFactor: 1,
    // optional self loops for each node. Use a neutral value to improve cluster computations.
    maxIterations: 20,
    // maximum number of iterations of the MCL algorithm in a single run
    attributes: [
        // attributes/features used to group nodes, ie. similarity values between nodes
        function(edge) {
            return 1;
        }
    ]
});
/* eslint-enable */ var setOptions$3 = function setOptions(options) {
    return defaults$c(options);
};
/* eslint-enable */ var getSimilarity$1 = function getSimilarity(edge, attributes) {
    var total = 0;
    for(var i = 0; i < attributes.length; i++)total += attributes[i](edge);
    return total;
};
var addLoops = function addLoops(M, n, val) {
    for(var i = 0; i < n; i++)M[i * n + i] = val;
};
var normalize = function normalize(M, n) {
    var sum;
    for(var col = 0; col < n; col++){
        sum = 0;
        for(var row = 0; row < n; row++)sum += M[row * n + col];
        for(var _row = 0; _row < n; _row++)M[_row * n + col] = M[_row * n + col] / sum;
    }
};
// TODO: blocked matrix multiplication?
var mmult = function mmult(A, B, n) {
    var C = new Array(n * n);
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++)C[i * n + j] = 0;
        for(var k = 0; k < n; k++)for(var _j = 0; _j < n; _j++)C[i * n + _j] += A[i * n + k] * B[k * n + _j];
    }
    return C;
};
var expand = function expand(M, n, expandFactor /** power **/ ) {
    var _M = M.slice(0);
    for(var p = 1; p < expandFactor; p++)M = mmult(M, _M, n);
    return M;
};
var inflate = function inflate(M, n, inflateFactor /** r **/ ) {
    var _M = new Array(n * n);
    // M(i,j) ^ inflatePower
    for(var i = 0; i < n * n; i++)_M[i] = Math.pow(M[i], inflateFactor);
    normalize(_M, n);
    return _M;
};
var hasConverged = function hasConverged(M, _M, n2, roundFactor) {
    // Check that both matrices have the same elements (i,j)
    for(var i = 0; i < n2; i++){
        var v1 = Math.round(M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor); // truncate to 'roundFactor' decimal places
        var v2 = Math.round(_M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        if (v1 !== v2) return false;
    }
    return true;
};
var assign$2 = function assign(M, n, nodes, cy) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var cluster = [];
        for(var j = 0; j < n; j++)// Row-wise attractors and elements that they attract belong in same cluster
        if (Math.round(M[i * n + j] * 1000) / 1000 > 0) cluster.push(nodes[j]);
        if (cluster.length !== 0) clusters.push(cy.collection(cluster));
    }
    return clusters;
};
var isDuplicate = function isDuplicate(c1, c2) {
    for(var i = 0; i < c1.length; i++){
        if (!c2[i] || c1[i].id() !== c2[i].id()) return false;
    }
    return true;
};
var removeDuplicates = function removeDuplicates(clusters) {
    for(var i = 0; i < clusters.length; i++){
        for(var j = 0; j < clusters.length; j++)if (i != j && isDuplicate(clusters[i], clusters[j])) clusters.splice(j, 1);
    }
    return clusters;
};
var markovClustering = function markovClustering(options) {
    var nodes = this.nodes();
    var edges = this.edges();
    var cy = this.cy();
    // Set parameters of algorithm:
    var opts = setOptions$3(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Generate stochastic matrix M from input graph G (should be symmetric/undirected)
    var n = nodes.length, n2 = n * n;
    var M = new Array(n2), _M;
    for(var _i = 0; _i < n2; _i++)M[_i] = 0;
    for(var e = 0; e < edges.length; e++){
        var edge = edges[e];
        var _i2 = id2position[edge.source().id()];
        var j = id2position[edge.target().id()];
        var sim = getSimilarity$1(edge, opts.attributes);
        M[_i2 * n + j] += sim; // G should be symmetric and undirected
        M[j * n + _i2] += sim;
    }
    // Begin Markov cluster algorithm
    // Step 1: Add self loops to each node, ie. add multFactor to matrix diagonal
    addLoops(M, n, opts.multFactor);
    // Step 2: M = normalize( M );
    normalize(M, n);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 3:
        _M = expand(M, n, opts.expandFactor);
        // Step 4:
        M = inflate(_M, n, opts.inflateFactor);
        // Step 5: check to see if ~steady state has been reached
        if (!hasConverged(M, _M, n2, 4)) isStillMoving = true;
        iterations++;
    }
    // Build clusters from matrix
    var clusters = assign$2(M, n, nodes, cy);
    // Remove duplicate clusters due to symmetry of graph and M matrix
    clusters = removeDuplicates(clusters);
    return clusters;
};
var markovClustering$1 = {
    markovClustering: markovClustering,
    mcl: markovClustering
};
// Common distance metrics for clustering algorithms
// https://en.wikipedia.org/wiki/Hierarchical_clustering#Metric
var identity$1 = function identity(x) {
    return x;
};
var absDiff = function absDiff(p, q) {
    return Math.abs(q - p);
};
var addAbsDiff = function addAbsDiff(total, p, q) {
    return total + absDiff(p, q);
};
var addSquaredDiff = function addSquaredDiff(total, p, q) {
    return total + Math.pow(q - p, 2);
};
var sqrt = function sqrt(x) {
    return Math.sqrt(x);
};
var maxAbsDiff = function maxAbsDiff(currentMax, p, q) {
    return Math.max(currentMax, absDiff(p, q));
};
var getDistance = function getDistance(length, getP, getQ, init, visit) {
    var post = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : identity$1;
    var ret = init;
    var p, q;
    for(var dim = 0; dim < length; dim++){
        p = getP(dim);
        q = getQ(dim);
        ret = visit(ret, p, q);
    }
    return post(ret);
};
var distances = {
    euclidean: function euclidean(length, getP, getQ) {
        if (length >= 2) return getDistance(length, getP, getQ, 0, addSquaredDiff, sqrt);
        else // for single attr case, more efficient to avoid sqrt
        return getDistance(length, getP, getQ, 0, addAbsDiff);
    },
    squaredEuclidean: function squaredEuclidean(length, getP, getQ) {
        return getDistance(length, getP, getQ, 0, addSquaredDiff);
    },
    manhattan: function manhattan(length, getP, getQ) {
        return getDistance(length, getP, getQ, 0, addAbsDiff);
    },
    max: function max(length, getP, getQ) {
        return getDistance(length, getP, getQ, -Infinity, maxAbsDiff);
    }
};
// in case the user accidentally doesn't use camel case
distances['squared-euclidean'] = distances['squaredEuclidean'];
distances['squaredeuclidean'] = distances['squaredEuclidean'];
function clusteringDistance(method, length, getP, getQ, nodeP, nodeQ) {
    var impl;
    if (fn$6(method)) impl = method;
    else impl = distances[method] || distances.euclidean;
    if (length === 0 && fn$6(method)) return impl(nodeP, nodeQ);
    else return impl(length, getP, getQ, nodeP, nodeQ);
}
var defaults$b = defaults$g({
    k: 2,
    m: 2,
    sensitivityThreshold: 0.0001,
    distance: 'euclidean',
    maxIterations: 10,
    attributes: [],
    testMode: false,
    testCentroids: null
});
var setOptions$2 = function setOptions(options) {
    return defaults$b(options);
};
var getDist = function getDist(type, node, centroid, attributes, mode) {
    var noNodeP = mode !== 'kMedoids';
    var getP = noNodeP ? function(i) {
        return centroid[i];
    } : function(i) {
        return attributes[i](centroid);
    };
    var getQ = function getQ(i) {
        return attributes[i](node);
    };
    var nodeP = centroid;
    var nodeQ = node;
    return clusteringDistance(type, attributes.length, getP, getQ, nodeP, nodeQ);
};
var randomCentroids = function randomCentroids(nodes, k, attributes) {
    var ndim = attributes.length;
    var min = new Array(ndim);
    var max = new Array(ndim);
    var centroids = new Array(k);
    var centroid = null;
    // Find min, max values for each attribute dimension
    for(var i = 0; i < ndim; i++){
        min[i] = nodes.min(attributes[i]).value;
        max[i] = nodes.max(attributes[i]).value;
    }
    // Build k centroids, each represented as an n-dim feature vector
    for(var c = 0; c < k; c++){
        centroid = [];
        for(var _i = 0; _i < ndim; _i++)centroid[_i] = Math.random() * (max[_i] - min[_i]) + min[_i]; // random initial value
        centroids[c] = centroid;
    }
    return centroids;
};
var classify = function classify(node, centroids, distance, attributes, type) {
    var min = Infinity;
    var index = 0;
    for(var i = 0; i < centroids.length; i++){
        var dist = getDist(distance, node, centroids[i], attributes, type);
        if (dist < min) {
            min = dist;
            index = i;
        }
    }
    return index;
};
var buildCluster = function buildCluster(centroid, nodes, assignment) {
    var cluster = [];
    var node = null;
    for(var n = 0; n < nodes.length; n++){
        node = nodes[n];
        if (assignment[node.id()] === centroid) //console.log("Node " + node.id() + " is associated with medoid #: " + m);
        cluster.push(node);
    }
    return cluster;
};
var haveValuesConverged = function haveValuesConverged(v1, v2, sensitivityThreshold) {
    return Math.abs(v2 - v1) <= sensitivityThreshold;
};
var haveMatricesConverged = function haveMatricesConverged(v1, v2, sensitivityThreshold) {
    for(var i = 0; i < v1.length; i++)for(var j = 0; j < v1[i].length; j++){
        var diff = Math.abs(v1[i][j] - v2[i][j]);
        if (diff > sensitivityThreshold) return false;
    }
    return true;
};
var seenBefore = function seenBefore(node, medoids, n) {
    for(var i = 0; i < n; i++){
        if (node === medoids[i]) return true;
    }
    return false;
};
var randomMedoids = function randomMedoids(nodes, k) {
    var medoids = new Array(k);
    // For small data sets, the probability of medoid conflict is greater,
    // so we need to check to see if we've already seen or chose this node before.
    if (nodes.length < 50) // Randomly select k medoids from the n nodes
    for(var i = 0; i < k; i++){
        var node = nodes[Math.floor(Math.random() * nodes.length)];
        // If we've already chosen this node to be a medoid, don't choose it again (for small data sets).
        // Instead choose a different random node.
        while(seenBefore(node, medoids, i))node = nodes[Math.floor(Math.random() * nodes.length)];
        medoids[i] = node;
    }
    else // Relatively large data set, so pretty safe to not check and just select random nodes
    for(var _i2 = 0; _i2 < k; _i2++)medoids[_i2] = nodes[Math.floor(Math.random() * nodes.length)];
    return medoids;
};
var findCost = function findCost(potentialNewMedoid, cluster, attributes) {
    var cost = 0;
    for(var n = 0; n < cluster.length; n++)cost += getDist('manhattan', cluster[n], potentialNewMedoid, attributes, 'kMedoids');
    return cost;
};
var kMeans = function kMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    // Set parameters of algorithm: # of clusters, distance metric, etc.
    var opts = setOptions$2(options);
    // Begin k-means algorithm
    var clusters = new Array(opts.k);
    var assignment = {};
    var centroids;
    // Step 1: Initialize centroid positions
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') {
            // TODO: implement a seeded random number generator.
            opts.testCentroids;
            centroids = randomCentroids(nodes, opts.k, opts.attributes);
        } else if (_typeof(opts.testCentroids) === 'object') centroids = opts.testCentroids;
        else centroids = randomCentroids(nodes, opts.k, opts.attributes);
    } else centroids = randomCentroids(nodes, opts.k, opts.attributes);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest centroid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = classify(node, centroids, opts.distance, opts.attributes, 'kMeans');
        }
        // Step 3: For each of the k clusters, update its centroid
        isStillMoving = false;
        for(var c = 0; c < opts.k; c++){
            // Get all nodes that belong to this cluster
            var cluster = buildCluster(c, nodes, assignment);
            if (cluster.length === 0) continue;
            // Update centroids by calculating avg of all nodes within the cluster.
            var ndim = opts.attributes.length;
            var centroid = centroids[c]; // [ dim_1, dim_2, dim_3, ... , dim_n ]
            var newCentroid = new Array(ndim);
            var sum = new Array(ndim);
            for(var d = 0; d < ndim; d++){
                sum[d] = 0.0;
                for(var i = 0; i < cluster.length; i++){
                    node = cluster[i];
                    sum[d] += opts.attributes[d](node);
                }
                newCentroid[d] = sum[d] / cluster.length;
                // Check to see if algorithm has converged, i.e. when centroids no longer change
                if (!haveValuesConverged(newCentroid[d], centroid[d], opts.sensitivityThreshold)) isStillMoving = true;
            }
            centroids[c] = newCentroid;
            clusters[c] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var kMedoids = function kMedoids(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    var opts = setOptions$2(options);
    // Begin k-medoids algorithm
    var clusters = new Array(opts.k);
    var medoids;
    var assignment = {};
    var curCost;
    var minCosts = new Array(opts.k); // minimum cost configuration for each cluster
    // Step 1: Initialize k medoids
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') ;
        else if (_typeof(opts.testCentroids) === 'object') medoids = opts.testCentroids;
        else medoids = randomMedoids(nodes, opts.k);
    } else medoids = randomMedoids(nodes, opts.k);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest medoid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = classify(node, medoids, opts.distance, opts.attributes, 'kMedoids');
        }
        isStillMoving = false;
        // Step 3: For each medoid m, and for each node associated with mediod m,
        // select the node with the lowest configuration cost as new medoid.
        for(var m1 = 0; m1 < medoids.length; m1++){
            // Get all nodes that belong to this medoid
            var cluster = buildCluster(m1, nodes, assignment);
            if (cluster.length === 0) continue;
            minCosts[m1] = findCost(medoids[m1], cluster, opts.attributes); // original cost
            // Select different medoid if its configuration has the lowest cost
            for(var _n = 0; _n < cluster.length; _n++){
                curCost = findCost(cluster[_n], cluster, opts.attributes);
                if (curCost < minCosts[m1]) {
                    minCosts[m1] = curCost;
                    medoids[m1] = cluster[_n];
                    isStillMoving = true;
                }
            }
            clusters[m1] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var updateCentroids = function updateCentroids(centroids, nodes, U, weight, opts) {
    var numerator, denominator;
    for(var n = 0; n < nodes.length; n++)for(var c = 0; c < centroids.length; c++)weight[n][c] = Math.pow(U[n][c], opts.m);
    for(var _c = 0; _c < centroids.length; _c++)for(var dim = 0; dim < opts.attributes.length; dim++){
        numerator = 0;
        denominator = 0;
        for(var _n2 = 0; _n2 < nodes.length; _n2++){
            numerator += weight[_n2][_c] * opts.attributes[dim](nodes[_n2]);
            denominator += weight[_n2][_c];
        }
        centroids[_c][dim] = numerator / denominator;
    }
};
var updateMembership = function updateMembership(U, _U, centroids, nodes, opts) {
    // Save previous step
    for(var i = 0; i < U.length; i++)_U[i] = U[i].slice();
    var sum, numerator, denominator;
    var pow = 2 / (opts.m - 1);
    for(var c = 0; c < centroids.length; c++)for(var n = 0; n < nodes.length; n++){
        sum = 0;
        for(var k = 0; k < centroids.length; k++){
            // against all other centroids
            numerator = getDist(opts.distance, nodes[n], centroids[c], opts.attributes, 'cmeans');
            denominator = getDist(opts.distance, nodes[n], centroids[k], opts.attributes, 'cmeans');
            sum += Math.pow(numerator / denominator, pow);
        }
        U[n][c] = 1 / sum;
    }
};
var assign$1 = function assign(nodes, U, opts, cy) {
    var clusters = new Array(opts.k);
    for(var c = 0; c < clusters.length; c++)clusters[c] = [];
    var max;
    var index;
    for(var n = 0; n < U.length; n++){
        // for each node (U is N x C matrix)
        max = -Infinity;
        index = -1;
        // Determine which cluster the node is most likely to belong in
        for(var _c2 = 0; _c2 < U[0].length; _c2++)if (U[n][_c2] > max) {
            max = U[n][_c2];
            index = _c2;
        }
        clusters[index].push(nodes[n]);
    }
    // Turn every array into a collection of nodes
    for(var _c3 = 0; _c3 < clusters.length; _c3++)clusters[_c3] = cy.collection(clusters[_c3]);
    return clusters;
};
var fuzzyCMeans = function fuzzyCMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = setOptions$2(options);
    // Begin fuzzy c-means algorithm
    var clusters;
    var centroids;
    var U;
    var _U;
    var weight;
    // Step 1: Initialize letiables.
    _U = new Array(nodes.length);
    for(var i = 0; i < nodes.length; i++)// N x C matrix
    _U[i] = new Array(opts.k);
    U = new Array(nodes.length);
    for(var _i3 = 0; _i3 < nodes.length; _i3++)// N x C matrix
    U[_i3] = new Array(opts.k);
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        var total = 0;
        for(var j = 0; j < opts.k; j++){
            U[_i4][j] = Math.random();
            total += U[_i4][j];
        }
        for(var _j = 0; _j < opts.k; _j++)U[_i4][_j] = U[_i4][_j] / total;
    }
    centroids = new Array(opts.k);
    for(var _i5 = 0; _i5 < opts.k; _i5++)centroids[_i5] = new Array(opts.attributes.length);
    weight = new Array(nodes.length);
    for(var _i6 = 0; _i6 < nodes.length; _i6++)// N x C matrix
    weight[_i6] = new Array(opts.k);
    // end init FCM
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 2: Calculate the centroids for each step.
        updateCentroids(centroids, nodes, U, weight, opts);
        // Step 3: Update the partition matrix U.
        updateMembership(U, _U, centroids, nodes, opts);
        // Step 4: Check for convergence.
        if (!haveMatricesConverged(U, _U, opts.sensitivityThreshold)) isStillMoving = true;
        iterations++;
    }
    // Assign nodes to clusters with highest probability.
    clusters = assign$1(nodes, U, opts, cy);
    return {
        clusters: clusters,
        degreeOfMembership: U
    };
};
var kClustering = {
    kMeans: kMeans,
    kMedoids: kMedoids,
    fuzzyCMeans: fuzzyCMeans,
    fcm: fuzzyCMeans
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-hierarchical
var defaults$a = defaults$g({
    distance: 'euclidean',
    // distance metric to compare nodes
    linkage: 'min',
    // linkage criterion : how to determine the distance between clusters of nodes
    mode: 'threshold',
    // mode:'threshold' => clusters must be threshold distance apart
    threshold: Infinity,
    // the distance threshold
    // mode:'dendrogram' => the nodes are organised as leaves in a tree (siblings are close), merging makes clusters
    addDendrogram: false,
    // whether to add the dendrogram to the graph for viz
    dendrogramDepth: 0,
    // depth at which dendrogram branches are merged into the returned clusters
    attributes: [] // array of attr functions
});
var linkageAliases = {
    'single': 'min',
    'complete': 'max'
};
var setOptions$1 = function setOptions(options) {
    var opts = defaults$a(options);
    var preferredAlias = linkageAliases[opts.linkage];
    if (preferredAlias != null) opts.linkage = preferredAlias;
    return opts;
};
var mergeClosest = function mergeClosest(clusters, index, dists, mins, opts) {
    // Find two closest clusters from cached mins
    var minKey = 0;
    var min = Infinity;
    var dist;
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    for(var i = 0; i < clusters.length; i++){
        var key = clusters[i].key;
        var _dist = dists[key][mins[key]];
        if (_dist < min) {
            minKey = key;
            min = _dist;
        }
    }
    if (opts.mode === 'threshold' && min >= opts.threshold || opts.mode === 'dendrogram' && clusters.length === 1) return false;
    var c1 = index[minKey];
    var c2 = index[mins[minKey]];
    var merged;
    // Merge two closest clusters
    if (opts.mode === 'dendrogram') merged = {
        left: c1,
        right: c2,
        key: c1.key
    };
    else merged = {
        value: c1.value.concat(c2.value),
        key: c1.key
    };
    clusters[c1.index] = merged;
    clusters.splice(c2.index, 1);
    index[c1.key] = merged;
    // Update distances with new merged cluster
    for(var _i = 0; _i < clusters.length; _i++){
        var cur = clusters[_i];
        if (c1.key === cur.key) dist = Infinity;
        else if (opts.linkage === 'min') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] > dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'max') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] < dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'mean') dist = (dists[c1.key][cur.key] * c1.size + dists[c2.key][cur.key] * c2.size) / (c1.size + c2.size);
        else if (opts.mode === 'dendrogram') dist = getDist(cur.value, c1.value);
        else dist = getDist(cur.value[0], c1.value[0]);
        dists[c1.key][cur.key] = dists[cur.key][c1.key] = dist; // distance matrix is symmetric
    }
    // Update cached mins
    for(var _i2 = 0; _i2 < clusters.length; _i2++){
        var key1 = clusters[_i2].key;
        if (mins[key1] === c1.key || mins[key1] === c2.key) {
            var _min = key1;
            for(var j = 0; j < clusters.length; j++){
                var key2 = clusters[j].key;
                if (dists[key1][key2] < dists[key1][_min]) _min = key2;
            }
            mins[key1] = _min;
        }
        clusters[_i2].index = _i2;
    }
    // Clean up meta data used for clustering
    c1.key = c2.key = c1.index = c2.index = null;
    return true;
};
var _getAllChildren = function getAllChildren(root, arr, cy) {
    if (!root) return;
    if (root.value) arr.push(root.value);
    else {
        if (root.left) _getAllChildren(root.left, arr);
        if (root.right) _getAllChildren(root.right, arr);
    }
};
var _buildDendrogram = function buildDendrogram(root, cy) {
    if (!root) return '';
    if (root.left && root.right) {
        var leftStr = _buildDendrogram(root.left, cy);
        var rightStr = _buildDendrogram(root.right, cy);
        var node = cy.add({
            group: 'nodes',
            data: {
                id: leftStr + ',' + rightStr
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: leftStr,
                target: node.id()
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: rightStr,
                target: node.id()
            }
        });
        return node.id();
    } else if (root.value) return root.value.id();
};
var _buildClustersFromTree = function buildClustersFromTree(root, k, cy) {
    if (!root) return [];
    var left = [], right = [], leaves = [];
    if (k === 0) {
        // don't cut tree, simply return all nodes as 1 single cluster
        if (root.left) _getAllChildren(root.left, left);
        if (root.right) _getAllChildren(root.right, right);
        leaves = left.concat(right);
        return [
            cy.collection(leaves)
        ];
    } else if (k === 1) {
        // cut at root
        if (root.value) // leaf node
        return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) _getAllChildren(root.left, left);
            if (root.right) _getAllChildren(root.right, right);
            return [
                cy.collection(left),
                cy.collection(right)
            ];
        }
    } else {
        if (root.value) return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) left = _buildClustersFromTree(root.left, k - 1, cy);
            if (root.right) right = _buildClustersFromTree(root.right, k - 1, cy);
            return left.concat(right);
        }
    }
};
var hierarchicalClustering = function hierarchicalClustering(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    // Set parameters of algorithm: linkage type, distance metric, etc.
    var opts = setOptions$1(options);
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    // Begin hierarchical algorithm
    var clusters = [];
    var dists = []; // distances between each pair of clusters
    var mins = []; // closest cluster for each cluster
    var index = []; // hash of all clusters by key
    // In agglomerative (bottom-up) clustering, each node starts as its own cluster
    for(var n = 0; n < nodes.length; n++){
        var cluster = {
            value: opts.mode === 'dendrogram' ? nodes[n] : [
                nodes[n]
            ],
            key: n,
            index: n
        };
        clusters[n] = cluster;
        index[n] = cluster;
        dists[n] = [];
        mins[n] = 0;
    }
    // Calculate the distance between each pair of clusters
    for(var i = 0; i < clusters.length; i++)for(var j = 0; j <= i; j++){
        var dist = undefined;
        if (opts.mode === 'dendrogram') // modes store cluster values differently
        dist = i === j ? Infinity : getDist(clusters[i].value, clusters[j].value);
        else dist = i === j ? Infinity : getDist(clusters[i].value[0], clusters[j].value[0]);
        dists[i][j] = dist;
        dists[j][i] = dist;
        if (dist < dists[i][mins[i]]) mins[i] = j; // Cache mins: closest cluster to cluster i is cluster j
    }
    // Find the closest pair of clusters and merge them into a single cluster.
    // Update distances between new cluster and each of the old clusters, and loop until threshold reached.
    var merged = mergeClosest(clusters, index, dists, mins, opts);
    while(merged)merged = mergeClosest(clusters, index, dists, mins, opts);
    var retClusters;
    // Dendrogram mode builds the hierarchy and adds intermediary nodes + edges
    // in addition to returning the clusters.
    if (opts.mode === 'dendrogram') {
        retClusters = _buildClustersFromTree(clusters[0], opts.dendrogramDepth, cy);
        if (opts.addDendrogram) _buildDendrogram(clusters[0], cy);
    } else {
        // Regular mode simply returns the clusters
        retClusters = new Array(clusters.length);
        clusters.forEach(function(cluster, i) {
            // Clean up meta data used for clustering
            cluster.key = cluster.index = null;
            retClusters[i] = cy.collection(cluster.value);
        });
    }
    return retClusters;
};
var hierarchicalClustering$1 = {
    hierarchicalClustering: hierarchicalClustering,
    hca: hierarchicalClustering
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-affinity-propagation
var defaults$9 = defaults$g({
    distance: 'euclidean',
    // distance metric to compare attributes between two nodes
    preference: 'median',
    // suitability of a data point to serve as an exemplar
    damping: 0.8,
    // damping factor between [0.5, 1)
    maxIterations: 1000,
    // max number of iterations to run
    minIterations: 100,
    // min number of iterations to run in order for clustering to stop
    attributes: []
});
var setOptions = function setOptions(options) {
    var dmp = options.damping;
    var pref = options.preference;
    if (!(0.5 <= dmp && dmp < 1)) error("Damping must range on [0.5, 1).  Got: ".concat(dmp));
    var validPrefs = [
        'median',
        'mean',
        'min',
        'max'
    ];
    if (!(validPrefs.some(function(v) {
        return v === pref;
    }) || number$1(pref))) error("Preference must be one of [".concat(validPrefs.map(function(p) {
        return "'".concat(p, "'");
    }).join(', '), "] or a number.  Got: ").concat(pref));
    return defaults$9(options);
};
var getSimilarity = function getSimilarity(type, n1, n2, attributes) {
    var attr = function attr(n, i) {
        return attributes[i](n);
    };
    // nb negative because similarity should have an inverse relationship to distance
    return -clusteringDistance(type, attributes.length, function(i) {
        return attr(n1, i);
    }, function(i) {
        return attr(n2, i);
    }, n1, n2);
};
var getPreference = function getPreference(S, preference) {
    // larger preference = greater # of clusters
    var p = null;
    if (preference === 'median') p = median(S);
    else if (preference === 'mean') p = mean(S);
    else if (preference === 'min') p = min(S);
    else if (preference === 'max') p = max(S);
    else // Custom preference number, as set by user
    p = preference;
    return p;
};
var findExemplars = function findExemplars(n, R, A) {
    var indices = [];
    for(var i = 0; i < n; i++)if (R[i * n + i] + A[i * n + i] > 0) indices.push(i);
    return indices;
};
var assignClusters = function assignClusters(n, S, exemplars) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var index = -1;
        var max = -Infinity;
        for(var ei = 0; ei < exemplars.length; ei++){
            var e = exemplars[ei];
            if (S[i * n + e] > max) {
                index = e;
                max = S[i * n + e];
            }
        }
        if (index > 0) clusters.push(index);
    }
    for(var _ei = 0; _ei < exemplars.length; _ei++)clusters[exemplars[_ei]] = exemplars[_ei];
    return clusters;
};
var assign = function assign(n, S, exemplars) {
    var clusters = assignClusters(n, S, exemplars);
    for(var ei = 0; ei < exemplars.length; ei++){
        var ii = [];
        for(var c = 0; c < clusters.length; c++)if (clusters[c] === exemplars[ei]) ii.push(c);
        var maxI = -1;
        var maxSum = -Infinity;
        for(var i = 0; i < ii.length; i++){
            var sum = 0;
            for(var j = 0; j < ii.length; j++)sum += S[ii[j] * n + ii[i]];
            if (sum > maxSum) {
                maxI = i;
                maxSum = sum;
            }
        }
        exemplars[ei] = ii[maxI];
    }
    clusters = assignClusters(n, S, exemplars);
    return clusters;
};
var affinityPropagation = function affinityPropagation(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = setOptions(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Begin affinity propagation algorithm
    var n; // number of data points
    var n2; // size of matrices
    var S; // similarity matrix (1D array)
    var p; // preference/suitability of a data point to serve as an exemplar
    var R; // responsibility matrix (1D array)
    var A; // availability matrix (1D array)
    n = nodes.length;
    n2 = n * n;
    // Initialize and build S similarity matrix
    S = new Array(n2);
    for(var _i = 0; _i < n2; _i++)S[_i] = -Infinity; // for cases where two data points shouldn't be linked together
    for(var _i2 = 0; _i2 < n; _i2++){
        for(var j = 0; j < n; j++)if (_i2 !== j) S[_i2 * n + j] = getSimilarity(opts.distance, nodes[_i2], nodes[j], opts.attributes);
    }
    // Place preferences on the diagonal of S
    p = getPreference(S, opts.preference);
    for(var _i3 = 0; _i3 < n; _i3++)S[_i3 * n + _i3] = p;
    // Initialize R responsibility matrix
    R = new Array(n2);
    for(var _i4 = 0; _i4 < n2; _i4++)R[_i4] = 0.0;
    // Initialize A availability matrix
    A = new Array(n2);
    for(var _i5 = 0; _i5 < n2; _i5++)A[_i5] = 0.0;
    var old = new Array(n);
    var Rp = new Array(n);
    var se = new Array(n);
    for(var _i6 = 0; _i6 < n; _i6++){
        old[_i6] = 0.0;
        Rp[_i6] = 0.0;
        se[_i6] = 0;
    }
    var e = new Array(n * opts.minIterations);
    for(var _i7 = 0; _i7 < e.length; _i7++)e[_i7] = 0;
    var iter;
    for(iter = 0; iter < opts.maxIterations; iter++){
        // main algorithmic loop
        // Update R responsibility matrix
        for(var _i8 = 0; _i8 < n; _i8++){
            var max = -Infinity, max2 = -Infinity, maxI = -1, AS = 0.0;
            for(var _j = 0; _j < n; _j++){
                old[_j] = R[_i8 * n + _j];
                AS = A[_i8 * n + _j] + S[_i8 * n + _j];
                if (AS >= max) {
                    max2 = max;
                    max = AS;
                    maxI = _j;
                } else if (AS > max2) max2 = AS;
            }
            for(var _j2 = 0; _j2 < n; _j2++)R[_i8 * n + _j2] = (1 - opts.damping) * (S[_i8 * n + _j2] - max) + opts.damping * old[_j2];
            R[_i8 * n + maxI] = (1 - opts.damping) * (S[_i8 * n + maxI] - max2) + opts.damping * old[maxI];
        }
        // Update A availability matrix
        for(var _i9 = 0; _i9 < n; _i9++){
            var sum = 0;
            for(var _j3 = 0; _j3 < n; _j3++){
                old[_j3] = A[_j3 * n + _i9];
                Rp[_j3] = Math.max(0, R[_j3 * n + _i9]);
                sum += Rp[_j3];
            }
            sum -= Rp[_i9];
            Rp[_i9] = R[_i9 * n + _i9];
            sum += Rp[_i9];
            for(var _j4 = 0; _j4 < n; _j4++)A[_j4 * n + _i9] = (1 - opts.damping) * Math.min(0, sum - Rp[_j4]) + opts.damping * old[_j4];
            A[_i9 * n + _i9] = (1 - opts.damping) * (sum - Rp[_i9]) + opts.damping * old[_i9];
        }
        // Check for convergence
        var K = 0;
        for(var _i10 = 0; _i10 < n; _i10++){
            var E = A[_i10 * n + _i10] + R[_i10 * n + _i10] > 0 ? 1 : 0;
            e[iter % opts.minIterations * n + _i10] = E;
            K += E;
        }
        if (K > 0 && (iter >= opts.minIterations - 1 || iter == opts.maxIterations - 1)) {
            var _sum = 0;
            for(var _i11 = 0; _i11 < n; _i11++){
                se[_i11] = 0;
                for(var _j5 = 0; _j5 < opts.minIterations; _j5++)se[_i11] += e[_j5 * n + _i11];
                if (se[_i11] === 0 || se[_i11] === opts.minIterations) _sum++;
            }
            if (_sum === n) break;
        }
    }
    // Identify exemplars (cluster centers)
    var exemplarsIndices = findExemplars(n, R, A);
    // Assign nodes to clusters
    var clusterIndices = assign(n, S, exemplarsIndices);
    var clusters = {};
    for(var c = 0; c < exemplarsIndices.length; c++)clusters[exemplarsIndices[c]] = [];
    for(var _i12 = 0; _i12 < nodes.length; _i12++){
        var pos = id2position[nodes[_i12].id()];
        var clusterIndex = clusterIndices[pos];
        if (clusterIndex != null) // the node may have not been assigned a cluster if no valid attributes were specified
        clusters[clusterIndex].push(nodes[_i12]);
    }
    var retClusters = new Array(exemplarsIndices.length);
    for(var _c = 0; _c < exemplarsIndices.length; _c++)retClusters[_c] = cy.collection(clusters[exemplarsIndices[_c]]);
    return retClusters;
};
var affinityPropagation$1 = {
    affinityPropagation: affinityPropagation,
    ap: affinityPropagation
};
var hierholzerDefaults = defaults$g({
    root: undefined,
    directed: false
});
var elesfn$k = {
    hierholzer: function hierholzer(options) {
        if (!plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                directed: args[1]
            };
        }
        var _hierholzerDefaults = hierholzerDefaults(options), root = _hierholzerDefaults.root, directed = _hierholzerDefaults.directed;
        var eles = this;
        var dflag = false;
        var oddIn;
        var oddOut;
        var startVertex;
        if (root) startVertex = string(root) ? this.filter(root)[0].id() : root[0].id();
        var nodes = {};
        var edges = {};
        if (directed) eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var ind = ele.indegree(true);
                var outd = ele.outdegree(true);
                var d1 = ind - outd;
                var d2 = outd - ind;
                if (d1 == 1) {
                    if (oddIn) dflag = true;
                    else oddIn = id;
                } else if (d2 == 1) {
                    if (oddOut) dflag = true;
                    else oddOut = id;
                } else if (d2 > 1 || d1 > 1) dflag = true;
                nodes[id] = [];
                ele.outgoers().forEach(function(e) {
                    if (e.isEdge()) nodes[id].push(e.id());
                });
            } else edges[id] = [
                undefined,
                ele.target().id()
            ];
        });
        else eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var d = ele.degree(true);
                if (d % 2) {
                    if (!oddIn) oddIn = id;
                    else if (!oddOut) oddOut = id;
                    else dflag = true;
                }
                nodes[id] = [];
                ele.connectedEdges().forEach(function(e) {
                    return nodes[id].push(e.id());
                });
            } else edges[id] = [
                ele.source().id(),
                ele.target().id()
            ];
        });
        var result = {
            found: false,
            trail: undefined
        };
        if (dflag) return result;
        else if (oddOut && oddIn) {
            if (directed) {
                if (startVertex && oddOut != startVertex) return result;
                startVertex = oddOut;
            } else {
                if (startVertex && oddOut != startVertex && oddIn != startVertex) return result;
                else if (!startVertex) startVertex = oddOut;
            }
        } else if (!startVertex) startVertex = eles[0].id();
        var walk = function walk(v) {
            var currentNode = v;
            var subtour = [
                v
            ];
            var adj, adjTail, adjHead;
            while(nodes[currentNode].length){
                adj = nodes[currentNode].shift();
                adjTail = edges[adj][0];
                adjHead = edges[adj][1];
                if (currentNode != adjHead) {
                    nodes[adjHead] = nodes[adjHead].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjHead;
                } else if (!directed && currentNode != adjTail) {
                    nodes[adjTail] = nodes[adjTail].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjTail;
                }
                subtour.unshift(adj);
                subtour.unshift(currentNode);
            }
            return subtour;
        };
        var trail = [];
        var subtour = [];
        subtour = walk(startVertex);
        while(subtour.length != 1)if (nodes[subtour[0]].length == 0) {
            trail.unshift(eles.getElementById(subtour.shift()));
            trail.unshift(eles.getElementById(subtour.shift()));
        } else subtour = walk(subtour.shift()).concat(subtour);
        trail.unshift(eles.getElementById(subtour.shift())); // final node
        for(var d in nodes){
            if (nodes[d].length) return result;
        }
        result.found = true;
        result.trail = this.spawn(trail, true);
        return result;
    }
};
var hopcroftTarjanBiconnected = function hopcroftTarjanBiconnected() {
    var eles = this;
    var nodes = {};
    var id = 0;
    var edgeCount = 0;
    var components = [];
    var stack = [];
    var visitedEdges = {};
    var buildComponent = function buildComponent(x, y) {
        var i = stack.length - 1;
        var cutset = [];
        var component = eles.spawn();
        while(stack[i].x != x || stack[i].y != y){
            cutset.push(stack.pop().edge);
            i--;
        }
        cutset.push(stack.pop().edge);
        cutset.forEach(function(edge) {
            var connectedNodes = edge.connectedNodes().intersection(eles);
            component.merge(edge);
            connectedNodes.forEach(function(node) {
                var nodeId = node.id();
                var connectedEdges = node.connectedEdges().intersection(eles);
                component.merge(node);
                if (!nodes[nodeId].cutVertex) component.merge(connectedEdges);
                else component.merge(connectedEdges.filter(function(edge) {
                    return edge.isLoop();
                }));
            });
        });
        components.push(component);
    };
    var _biconnectedSearch = function biconnectedSearch(root, currentNode, parent) {
        if (root === parent) edgeCount += 1;
        nodes[currentNode] = {
            id: id,
            low: id++,
            cutVertex: false
        };
        var edges = eles.getElementById(currentNode).connectedEdges().intersection(eles);
        if (edges.size() === 0) components.push(eles.spawn(eles.getElementById(currentNode)));
        else {
            var sourceId, targetId, otherNodeId, edgeId;
            edges.forEach(function(edge) {
                sourceId = edge.source().id();
                targetId = edge.target().id();
                otherNodeId = sourceId === currentNode ? targetId : sourceId;
                if (otherNodeId !== parent) {
                    edgeId = edge.id();
                    if (!visitedEdges[edgeId]) {
                        visitedEdges[edgeId] = true;
                        stack.push({
                            x: currentNode,
                            y: otherNodeId,
                            edge: edge
                        });
                    }
                    if (!(otherNodeId in nodes)) {
                        _biconnectedSearch(root, otherNodeId, currentNode);
                        nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].low);
                        if (nodes[currentNode].id <= nodes[otherNodeId].low) {
                            nodes[currentNode].cutVertex = true;
                            buildComponent(currentNode, otherNodeId);
                        }
                    } else nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].id);
                }
            });
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) {
                edgeCount = 0;
                _biconnectedSearch(nodeId, nodeId);
                nodes[nodeId].cutVertex = edgeCount > 1;
            }
        }
    });
    var cutVertices = Object.keys(nodes).filter(function(id) {
        return nodes[id].cutVertex;
    }).map(function(id) {
        return eles.getElementById(id);
    });
    return {
        cut: eles.spawn(cutVertices),
        components: components
    };
};
var hopcroftTarjanBiconnected$1 = {
    hopcroftTarjanBiconnected: hopcroftTarjanBiconnected,
    htbc: hopcroftTarjanBiconnected,
    htb: hopcroftTarjanBiconnected,
    hopcroftTarjanBiconnectedComponents: hopcroftTarjanBiconnected
};
var tarjanStronglyConnected = function tarjanStronglyConnected() {
    var eles = this;
    var nodes = {};
    var index = 0;
    var components = [];
    var stack = [];
    var cut = eles.spawn(eles);
    var _stronglyConnectedSearch = function stronglyConnectedSearch(sourceNodeId) {
        stack.push(sourceNodeId);
        nodes[sourceNodeId] = {
            index: index,
            low: index++,
            explored: false
        };
        var connectedEdges = eles.getElementById(sourceNodeId).connectedEdges().intersection(eles);
        connectedEdges.forEach(function(edge) {
            var targetNodeId = edge.target().id();
            if (targetNodeId !== sourceNodeId) {
                if (!(targetNodeId in nodes)) _stronglyConnectedSearch(targetNodeId);
                if (!nodes[targetNodeId].explored) nodes[sourceNodeId].low = Math.min(nodes[sourceNodeId].low, nodes[targetNodeId].low);
            }
        });
        if (nodes[sourceNodeId].index === nodes[sourceNodeId].low) {
            var componentNodes = eles.spawn();
            for(;;){
                var nodeId = stack.pop();
                componentNodes.merge(eles.getElementById(nodeId));
                nodes[nodeId].low = nodes[sourceNodeId].index;
                nodes[nodeId].explored = true;
                if (nodeId === sourceNodeId) break;
            }
            var componentEdges = componentNodes.edgesWith(componentNodes);
            var component = componentNodes.merge(componentEdges);
            components.push(component);
            cut = cut.difference(component);
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) _stronglyConnectedSearch(nodeId);
        }
    });
    return {
        cut: cut,
        components: components
    };
};
var tarjanStronglyConnected$1 = {
    tarjanStronglyConnected: tarjanStronglyConnected,
    tsc: tarjanStronglyConnected,
    tscc: tarjanStronglyConnected,
    tarjanStronglyConnectedComponents: tarjanStronglyConnected
};
var elesfn$j = {};
[
    elesfn$v,
    elesfn$u,
    elesfn$t,
    elesfn$s,
    elesfn$r,
    elesfn$q,
    elesfn$p,
    elesfn$o,
    elesfn$n,
    elesfn$m,
    elesfn$l,
    markovClustering$1,
    kClustering,
    hierarchicalClustering$1,
    affinityPropagation$1,
    elesfn$k,
    hopcroftTarjanBiconnected$1,
    tarjanStronglyConnected$1
].forEach(function(props) {
    extend(elesfn$j, props);
});
/*!
Embeddable Minimum Strictly-Compliant Promises/A+ 1.1.1 Thenable
Copyright (c) 2013-2014 Ralf S. Engelschall (http://engelschall.com)
Licensed under The MIT License (http://opensource.org/licenses/MIT)
*/ /*  promise states [Promises/A+ 2.1]  */ var STATE_PENDING = 0; /*  [Promises/A+ 2.1.1]  */ 
var STATE_FULFILLED = 1; /*  [Promises/A+ 2.1.2]  */ 
var STATE_REJECTED = 2; /*  [Promises/A+ 2.1.3]  */ 
/*  promise object constructor  */ var _api = function api(executor) {
    /*  optionally support non-constructor/plain-function call  */ if (!(this instanceof _api)) return new _api(executor);
    /*  initialize object  */ this.id = 'Thenable/1.0.7';
    this.state = STATE_PENDING; /*  initial state  */ 
    this.fulfillValue = undefined; /*  initial value  */  /*  [Promises/A+ 1.3, 2.1.2.2]  */ 
    this.rejectReason = undefined; /*  initial reason */  /*  [Promises/A+ 1.5, 2.1.3.2]  */ 
    this.onFulfilled = []; /*  initial handlers  */ 
    this.onRejected = []; /*  initial handlers  */ 
    /*  provide optional information-hiding proxy  */ this.proxy = {
        then: this.then.bind(this)
    };
    /*  support optional executor function  */ if (typeof executor === 'function') executor.call(this, this.fulfill.bind(this), this.reject.bind(this));
};
/*  promise API methods  */ _api.prototype = {
    /*  promise resolving methods  */ fulfill: function fulfill(value) {
        return deliver(this, STATE_FULFILLED, 'fulfillValue', value);
    },
    reject: function reject(value) {
        return deliver(this, STATE_REJECTED, 'rejectReason', value);
    },
    /*  "The then Method" [Promises/A+ 1.1, 1.2, 2.2]  */ then: function then(onFulfilled, onRejected) {
        var curr = this;
        var next = new _api(); /*  [Promises/A+ 2.2.7]  */ 
        curr.onFulfilled.push(resolver(onFulfilled, next, 'fulfill')); /*  [Promises/A+ 2.2.2/2.2.6]  */ 
        curr.onRejected.push(resolver(onRejected, next, 'reject')); /*  [Promises/A+ 2.2.3/2.2.6]  */ 
        execute(curr);
        return next.proxy; /*  [Promises/A+ 2.2.7, 3.3]  */ 
    }
};
/*  deliver an action  */ var deliver = function deliver(curr, state, name, value) {
    if (curr.state === STATE_PENDING) {
        curr.state = state; /*  [Promises/A+ 2.1.2.1, 2.1.3.1]  */ 
        curr[name] = value; /*  [Promises/A+ 2.1.2.2, 2.1.3.2]  */ 
        execute(curr);
    }
    return curr;
};
/*  execute all handlers  */ var execute = function execute(curr) {
    if (curr.state === STATE_FULFILLED) execute_handlers(curr, 'onFulfilled', curr.fulfillValue);
    else if (curr.state === STATE_REJECTED) execute_handlers(curr, 'onRejected', curr.rejectReason);
};
/*  execute particular set of handlers  */ var execute_handlers = function execute_handlers(curr, name, value) {
    /* global setImmediate: true */ /* global setTimeout: true */ /*  short-circuit processing  */ if (curr[name].length === 0) return;
    /*  iterate over all handlers, exactly once  */ var handlers = curr[name];
    curr[name] = []; /*  [Promises/A+ 2.2.2.3, 2.2.3.3]  */ 
    var func = function func() {
        for(var i = 0; i < handlers.length; i++)handlers[i](value); /*  [Promises/A+ 2.2.5]  */ 
    };
    /*  execute procedure asynchronously  */ /*  [Promises/A+ 2.2.4, 3.1]  */ if (typeof setImmediate === 'function') setImmediate(func);
    else setTimeout(func, 0);
};
/*  generate a resolver function  */ var resolver = function resolver(cb, next, method) {
    return function(value) {
        if (typeof cb !== 'function') /*  [Promises/A+ 2.2.1, 2.2.7.3, 2.2.7.4]  */ next[method].call(next, value); /*  [Promises/A+ 2.2.7.3, 2.2.7.4]  */ 
        else {
            var result;
            try {
                result = cb(value);
            } catch (e) {
                next.reject(e); /*  [Promises/A+ 2.2.7.2]  */ 
                return;
            }
            _resolve(next, result); /*  [Promises/A+ 2.2.7.1]  */ 
        }
    };
};
/*  "Promise Resolution Procedure"  */ /*  [Promises/A+ 2.3]  */ var _resolve = function resolve(promise, x) {
    /*  sanity check arguments  */ /*  [Promises/A+ 2.3.1]  */ if (promise === x || promise.proxy === x) {
        promise.reject(new TypeError('cannot resolve promise with itself'));
        return;
    }
    /*  surgically check for a "then" method
    (mainly to just call the "getter" of "then" only once)  */ var then;
    if (_typeof(x) === 'object' && x !== null || typeof x === 'function') try {
        then = x.then;
    } catch (e) {
        promise.reject(e); /*  [Promises/A+ 2.3.3.2]  */ 
        return;
    }
    /*  handle own Thenables    [Promises/A+ 2.3.2]
    and similar "thenables" [Promises/A+ 2.3.3]  */ if (typeof then === 'function') {
        var resolved = false;
        try {
            /*  call retrieved "then" method */ /*  [Promises/A+ 2.3.3.3]  */ then.call(x, /*  resolvePromise  */ /*  [Promises/A+ 2.3.3.3.1]  */ function(y) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                if (y === x) /*  [Promises/A+ 3.6]  */ promise.reject(new TypeError('circular thenable chain'));
                else _resolve(promise, y);
            }, /*  rejectPromise  */ /*  [Promises/A+ 2.3.3.3.2]  */ function(r) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                promise.reject(r);
            });
        } catch (e) {
            if (!resolved) /*  [Promises/A+ 2.3.3.3.3]  */ promise.reject(e); /*  [Promises/A+ 2.3.3.3.4]  */ 
        }
        return;
    }
    /*  handle other values  */ promise.fulfill(x); /*  [Promises/A+ 2.3.4, 2.3.3.4]  */ 
};
// so we always have Promise.all()
_api.all = function(ps) {
    return new _api(function(resolveAll, rejectAll) {
        var vals = new Array(ps.length);
        var doneCount = 0;
        var fulfill = function fulfill(i, val) {
            vals[i] = val;
            doneCount++;
            if (doneCount === ps.length) resolveAll(vals);
        };
        for(var i = 0; i < ps.length; i++)(function(i) {
            var p = ps[i];
            var isPromise = p != null && p.then != null;
            if (isPromise) p.then(function(val) {
                fulfill(i, val);
            }, function(err) {
                rejectAll(err);
            });
            else {
                var val = p;
                fulfill(i, val);
            }
        })(i);
    });
};
_api.resolve = function(val) {
    return new _api(function(resolve, reject) {
        resolve(val);
    });
};
_api.reject = function(val) {
    return new _api(function(resolve, reject) {
        reject(val);
    });
};
var Promise$1 = typeof Promise !== 'undefined' ? Promise : _api; // eslint-disable-line no-undef
var Animation = function Animation(target, opts, opts2) {
    var isCore = core(target);
    var isEle = !isCore;
    var _p = this._private = extend({
        duration: 1000
    }, opts, opts2);
    _p.target = target;
    _p.style = _p.style || _p.css;
    _p.started = false;
    _p.playing = false;
    _p.hooked = false;
    _p.applying = false;
    _p.progress = 0;
    _p.completes = [];
    _p.frames = [];
    if (_p.complete && fn$6(_p.complete)) _p.completes.push(_p.complete);
    if (isEle) {
        var pos = target.position();
        _p.startPosition = _p.startPosition || {
            x: pos.x,
            y: pos.y
        };
        _p.startStyle = _p.startStyle || target.cy().style().getAnimationStartStyle(target, _p.style);
    }
    if (isCore) {
        var pan = target.pan();
        _p.startPan = {
            x: pan.x,
            y: pan.y
        };
        _p.startZoom = target.zoom();
    }
    // for future timeline/animations impl
    this.length = 1;
    this[0] = this;
};
var anifn = Animation.prototype;
extend(anifn, {
    instanceString: function instanceString() {
        return 'animation';
    },
    hook: function hook() {
        var _p = this._private;
        if (!_p.hooked) {
            // add to target's animation queue
            var q;
            var tAni = _p.target._private.animation;
            if (_p.queue) q = tAni.queue;
            else q = tAni.current;
            q.push(this);
            // add to the animation loop pool
            if (elementOrCollection(_p.target)) _p.target.cy().addToAnimationPool(_p.target);
            _p.hooked = true;
        }
        return this;
    },
    play: function play() {
        var _p = this._private;
        // autorewind
        if (_p.progress === 1) _p.progress = 0;
        _p.playing = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will start the animation...
        return this;
    },
    playing: function playing() {
        return this._private.playing;
    },
    apply: function apply() {
        var _p = this._private;
        _p.applying = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will apply the animation at this progress
        return this;
    },
    applying: function applying() {
        return this._private.applying;
    },
    pause: function pause() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        return this;
    },
    stop: function stop() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        _p.stopped = true; // to be removed from animation queues
        return this;
    },
    rewind: function rewind() {
        return this.progress(0);
    },
    fastforward: function fastforward() {
        return this.progress(1);
    },
    time: function time(t) {
        var _p = this._private;
        if (t === undefined) return _p.progress * _p.duration;
        else return this.progress(t / _p.duration);
    },
    progress: function progress(p) {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (p === undefined) return _p.progress;
        else {
            if (wasPlaying) this.pause();
            _p.progress = p;
            _p.started = false;
            if (wasPlaying) this.play();
        }
        return this;
    },
    completed: function completed() {
        return this._private.progress === 1;
    },
    reverse: function reverse() {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (wasPlaying) this.pause();
        _p.progress = 1 - _p.progress;
        _p.started = false;
        var swap = function swap(a, b) {
            var _pa = _p[a];
            if (_pa == null) return;
            _p[a] = _p[b];
            _p[b] = _pa;
        };
        swap('zoom', 'startZoom');
        swap('pan', 'startPan');
        swap('position', 'startPosition');
        // swap styles
        if (_p.style) for(var i = 0; i < _p.style.length; i++){
            var prop = _p.style[i];
            var name = prop.name;
            var startStyleProp = _p.startStyle[name];
            _p.startStyle[name] = prop;
            _p.style[i] = startStyleProp;
        }
        if (wasPlaying) this.play();
        return this;
    },
    promise: function promise(type) {
        var _p = this._private;
        var arr;
        switch(type){
            case 'frame':
                arr = _p.frames;
                break;
            default:
            case 'complete':
            case 'completed':
                arr = _p.completes;
        }
        return new Promise$1(function(resolve, reject) {
            arr.push(function() {
                resolve();
            });
        });
    }
});
anifn.complete = anifn.completed;
anifn.run = anifn.play;
anifn.running = anifn.playing;
var define$3 = {
    animated: function animated() {
        return function animatedImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return false;
            var ele = all[0];
            if (ele) return ele._private.animation.current.length > 0;
        };
    },
    // animated
    clearQueue: function clearQueue() {
        return function clearQueueImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                ele._private.animation.queue = [];
            }
            return this;
        };
    },
    // clearQueue
    delay: function delay() {
        return function delayImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animate({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    delayAnimation: function delayAnimation() {
        return function delayAnimationImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animation({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    animation: function animation() {
        return function animationImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            var isCore = !selfIsArrayLike;
            var isEles = !isCore;
            if (!cy.styleEnabled()) return this;
            var style = cy.style();
            properties = extend({}, properties, params);
            var propertiesEmpty = Object.keys(properties).length === 0;
            if (propertiesEmpty) return new Animation(all[0], properties); // nothing to animate
            if (properties.duration === undefined) properties.duration = 400;
            switch(properties.duration){
                case 'slow':
                    properties.duration = 600;
                    break;
                case 'fast':
                    properties.duration = 200;
                    break;
            }
            if (isEles) {
                properties.style = style.getPropsList(properties.style || properties.css);
                properties.css = undefined;
            }
            if (isEles && properties.renderedPosition != null) {
                var rpos = properties.renderedPosition;
                var pan = cy.pan();
                var zoom = cy.zoom();
                properties.position = renderedToModelPosition(rpos, zoom, pan);
            }
            // override pan w/ panBy if set
            if (isCore && properties.panBy != null) {
                var panBy = properties.panBy;
                var cyPan = cy.pan();
                properties.pan = {
                    x: cyPan.x + panBy.x,
                    y: cyPan.y + panBy.y
                };
            }
            // override pan w/ center if set
            var center = properties.center || properties.centre;
            if (isCore && center != null) {
                var centerPan = cy.getCenterPan(center.eles, properties.zoom);
                if (centerPan != null) properties.pan = centerPan;
            }
            // override pan & zoom w/ fit if set
            if (isCore && properties.fit != null) {
                var fit = properties.fit;
                var fitVp = cy.getFitViewport(fit.eles || fit.boundingBox, fit.padding);
                if (fitVp != null) {
                    properties.pan = fitVp.pan;
                    properties.zoom = fitVp.zoom;
                }
            }
            // override zoom (& potentially pan) w/ zoom obj if set
            if (isCore && plainObject(properties.zoom)) {
                var vp = cy.getZoomedViewport(properties.zoom);
                if (vp != null) {
                    if (vp.zoomed) properties.zoom = vp.zoom;
                    if (vp.panned) properties.pan = vp.pan;
                } else properties.zoom = null; // an inavalid zoom (e.g. no delta) gets automatically destroyed
            }
            return new Animation(all[0], properties);
        };
    },
    // animate
    animate: function animate() {
        return function animateImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            if (params) properties = extend({}, properties, params);
            // manually hook and run the animation
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var queue = ele.animated() && (properties.queue === undefined || properties.queue);
                var ani = ele.animation(properties, queue ? {
                    queue: true
                } : undefined);
                ani.play();
            }
            return this; // chaining
        };
    },
    // animate
    stop: function stop() {
        return function stopImpl(clearQueue, jumpToEnd) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var _p = ele._private;
                var anis = _p.animation.current;
                for(var j = 0; j < anis.length; j++){
                    var ani = anis[j];
                    var ani_p = ani._private;
                    if (jumpToEnd) // next iteration of the animation loop, the animation
                    // will go straight to the end and be removed
                    ani_p.duration = 0;
                }
                // clear the queue of future animations
                if (clearQueue) _p.animation.queue = [];
                if (!jumpToEnd) _p.animation.current = [];
            }
            // we have to notify (the animation loop doesn't do it for us on `stop`)
            cy.notify('draw');
            return this;
        };
    } // stop
}; // define
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray_1;
var hasRequiredIsArray;
function requireIsArray() {
    if (hasRequiredIsArray) return isArray_1;
    hasRequiredIsArray = 1;
    var isArray = Array.isArray;
    isArray_1 = isArray;
    return isArray_1;
}
var _isKey;
var hasRequired_isKey;
function require_isKey() {
    if (hasRequired_isKey) return _isKey;
    hasRequired_isKey = 1;
    var isArray = requireIsArray(), isSymbol = requireIsSymbol();
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
    /**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */ function isKey(value, object) {
        if (isArray(value)) return false;
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    _isKey = isKey;
    return _isKey;
}
var isFunction_1;
var hasRequiredIsFunction;
function requireIsFunction() {
    if (hasRequiredIsFunction) return isFunction_1;
    hasRequiredIsFunction = 1;
    var baseGetTag = require_baseGetTag(), isObject = requireIsObject();
    /** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
    /**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */ function isFunction(value) {
        if (!isObject(value)) return false;
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    isFunction_1 = isFunction;
    return isFunction_1;
}
var _coreJsData;
var hasRequired_coreJsData;
function require_coreJsData() {
    if (hasRequired_coreJsData) return _coreJsData;
    hasRequired_coreJsData = 1;
    var root = require_root();
    /** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
    _coreJsData = coreJsData;
    return _coreJsData;
}
var _isMasked;
var hasRequired_isMasked;
function require_isMasked() {
    if (hasRequired_isMasked) return _isMasked;
    hasRequired_isMasked = 1;
    var coreJsData = require_coreJsData();
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    _isMasked = isMasked;
    return _isMasked;
}
/** Used for built-in method references. */ var _toSource;
var hasRequired_toSource;
function require_toSource() {
    if (hasRequired_toSource) return _toSource;
    hasRequired_toSource = 1;
    var funcProto = Function.prototype;
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + '';
            } catch (e) {}
        }
        return '';
    }
    _toSource = toSource;
    return _toSource;
}
var _baseIsNative;
var hasRequired_baseIsNative;
function require_baseIsNative() {
    if (hasRequired_baseIsNative) return _baseIsNative;
    hasRequired_baseIsNative = 1;
    var isFunction = requireIsFunction(), isMasked = require_isMasked(), isObject = requireIsObject(), toSource = require_toSource();
    /**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */ function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) return false;
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    _baseIsNative = baseIsNative;
    return _baseIsNative;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var _getValue;
var hasRequired_getValue;
function require_getValue() {
    if (hasRequired_getValue) return _getValue;
    hasRequired_getValue = 1;
    function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    _getValue = getValue;
    return _getValue;
}
var _getNative;
var hasRequired_getNative;
function require_getNative() {
    if (hasRequired_getNative) return _getNative;
    hasRequired_getNative = 1;
    var baseIsNative = require_baseIsNative(), getValue = require_getValue();
    /**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    _getNative = getNative;
    return _getNative;
}
var _nativeCreate;
var hasRequired_nativeCreate;
function require_nativeCreate() {
    if (hasRequired_nativeCreate) return _nativeCreate;
    hasRequired_nativeCreate = 1;
    var getNative = require_getNative();
    /* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
    _nativeCreate = nativeCreate;
    return _nativeCreate;
}
var _hashClear;
var hasRequired_hashClear;
function require_hashClear() {
    if (hasRequired_hashClear) return _hashClear;
    hasRequired_hashClear = 1;
    var nativeCreate = require_nativeCreate();
    /**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
    }
    _hashClear = hashClear;
    return _hashClear;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var _hashDelete;
var hasRequired_hashDelete;
function require_hashDelete() {
    if (hasRequired_hashDelete) return _hashDelete;
    hasRequired_hashDelete = 1;
    function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
    }
    _hashDelete = hashDelete;
    return _hashDelete;
}
var _hashGet;
var hasRequired_hashGet;
function require_hashGet() {
    if (hasRequired_hashGet) return _hashGet;
    hasRequired_hashGet = 1;
    var nativeCreate = require_nativeCreate();
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    _hashGet = hashGet;
    return _hashGet;
}
var _hashHas;
var hasRequired_hashHas;
function require_hashHas() {
    if (hasRequired_hashHas) return _hashHas;
    hasRequired_hashHas = 1;
    var nativeCreate = require_nativeCreate();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    _hashHas = hashHas;
    return _hashHas;
}
var _hashSet;
var hasRequired_hashSet;
function require_hashSet() {
    if (hasRequired_hashSet) return _hashSet;
    hasRequired_hashSet = 1;
    var nativeCreate = require_nativeCreate();
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */ function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    _hashSet = hashSet;
    return _hashSet;
}
var _Hash;
var hasRequired_Hash;
function require_Hash() {
    if (hasRequired_Hash) return _Hash;
    hasRequired_Hash = 1;
    var hashClear = require_hashClear(), hashDelete = require_hashDelete(), hashGet = require_hashGet(), hashHas = require_hashHas(), hashSet = require_hashSet();
    /**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    _Hash = Hash;
    return _Hash;
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var _listCacheClear;
var hasRequired_listCacheClear;
function require_listCacheClear() {
    if (hasRequired_listCacheClear) return _listCacheClear;
    hasRequired_listCacheClear = 1;
    function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
    }
    _listCacheClear = listCacheClear;
    return _listCacheClear;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var eq_1;
var hasRequiredEq;
function requireEq() {
    if (hasRequiredEq) return eq_1;
    hasRequiredEq = 1;
    function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    eq_1 = eq;
    return eq_1;
}
var _assocIndexOf;
var hasRequired_assocIndexOf;
function require_assocIndexOf() {
    if (hasRequired_assocIndexOf) return _assocIndexOf;
    hasRequired_assocIndexOf = 1;
    var eq = requireEq();
    /**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    _assocIndexOf = assocIndexOf;
    return _assocIndexOf;
}
var _listCacheDelete;
var hasRequired_listCacheDelete;
function require_listCacheDelete() {
    if (hasRequired_listCacheDelete) return _listCacheDelete;
    hasRequired_listCacheDelete = 1;
    var assocIndexOf = require_assocIndexOf();
    /** Used for built-in method references. */ var arrayProto = Array.prototype;
    /** Built-in value references. */ var splice = arrayProto.splice;
    /**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        --this.size;
        return true;
    }
    _listCacheDelete = listCacheDelete;
    return _listCacheDelete;
}
var _listCacheGet;
var hasRequired_listCacheGet;
function require_listCacheGet() {
    if (hasRequired_listCacheGet) return _listCacheGet;
    hasRequired_listCacheGet = 1;
    var assocIndexOf = require_assocIndexOf();
    /**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    _listCacheGet = listCacheGet;
    return _listCacheGet;
}
var _listCacheHas;
var hasRequired_listCacheHas;
function require_listCacheHas() {
    if (hasRequired_listCacheHas) return _listCacheHas;
    hasRequired_listCacheHas = 1;
    var assocIndexOf = require_assocIndexOf();
    /**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    _listCacheHas = listCacheHas;
    return _listCacheHas;
}
var _listCacheSet;
var hasRequired_listCacheSet;
function require_listCacheSet() {
    if (hasRequired_listCacheSet) return _listCacheSet;
    hasRequired_listCacheSet = 1;
    var assocIndexOf = require_assocIndexOf();
    /**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
            ++this.size;
            data.push([
                key,
                value
            ]);
        } else data[index][1] = value;
        return this;
    }
    _listCacheSet = listCacheSet;
    return _listCacheSet;
}
var _ListCache;
var hasRequired_ListCache;
function require_ListCache() {
    if (hasRequired_ListCache) return _ListCache;
    hasRequired_ListCache = 1;
    var listCacheClear = require_listCacheClear(), listCacheDelete = require_listCacheDelete(), listCacheGet = require_listCacheGet(), listCacheHas = require_listCacheHas(), listCacheSet = require_listCacheSet();
    /**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    _ListCache = ListCache;
    return _ListCache;
}
var _Map;
var hasRequired_Map;
function require_Map() {
    if (hasRequired_Map) return _Map;
    hasRequired_Map = 1;
    var getNative = require_getNative(), root = require_root();
    /* Built-in method references that are verified to be native. */ var Map1 = getNative(root, 'Map');
    _Map = Map1;
    return _Map;
}
var _mapCacheClear;
var hasRequired_mapCacheClear;
function require_mapCacheClear() {
    if (hasRequired_mapCacheClear) return _mapCacheClear;
    hasRequired_mapCacheClear = 1;
    var Hash = require_Hash(), ListCache = require_ListCache(), Map1 = require_Map();
    /**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */ function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
            'hash': new Hash,
            'map': new (Map1 || ListCache),
            'string': new Hash
        };
    }
    _mapCacheClear = mapCacheClear;
    return _mapCacheClear;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var _isKeyable;
var hasRequired_isKeyable;
function require_isKeyable() {
    if (hasRequired_isKeyable) return _isKeyable;
    hasRequired_isKeyable = 1;
    function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    _isKeyable = isKeyable;
    return _isKeyable;
}
var _getMapData;
var hasRequired_getMapData;
function require_getMapData() {
    if (hasRequired_getMapData) return _getMapData;
    hasRequired_getMapData = 1;
    var isKeyable = require_isKeyable();
    /**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    _getMapData = getMapData;
    return _getMapData;
}
var _mapCacheDelete;
var hasRequired_mapCacheDelete;
function require_mapCacheDelete() {
    if (hasRequired_mapCacheDelete) return _mapCacheDelete;
    hasRequired_mapCacheDelete = 1;
    var getMapData = require_getMapData();
    /**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
    }
    _mapCacheDelete = mapCacheDelete;
    return _mapCacheDelete;
}
var _mapCacheGet;
var hasRequired_mapCacheGet;
function require_mapCacheGet() {
    if (hasRequired_mapCacheGet) return _mapCacheGet;
    hasRequired_mapCacheGet = 1;
    var getMapData = require_getMapData();
    /**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    _mapCacheGet = mapCacheGet;
    return _mapCacheGet;
}
var _mapCacheHas;
var hasRequired_mapCacheHas;
function require_mapCacheHas() {
    if (hasRequired_mapCacheHas) return _mapCacheHas;
    hasRequired_mapCacheHas = 1;
    var getMapData = require_getMapData();
    /**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    _mapCacheHas = mapCacheHas;
    return _mapCacheHas;
}
var _mapCacheSet;
var hasRequired_mapCacheSet;
function require_mapCacheSet() {
    if (hasRequired_mapCacheSet) return _mapCacheSet;
    hasRequired_mapCacheSet = 1;
    var getMapData = require_getMapData();
    /**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */ function mapCacheSet(key, value) {
        var data = getMapData(this, key), size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
    }
    _mapCacheSet = mapCacheSet;
    return _mapCacheSet;
}
var _MapCache;
var hasRequired_MapCache;
function require_MapCache() {
    if (hasRequired_MapCache) return _MapCache;
    hasRequired_MapCache = 1;
    var mapCacheClear = require_mapCacheClear(), mapCacheDelete = require_mapCacheDelete(), mapCacheGet = require_mapCacheGet(), mapCacheHas = require_mapCacheHas(), mapCacheSet = require_mapCacheSet();
    /**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    _MapCache = MapCache;
    return _MapCache;
}
var memoize_1;
var hasRequiredMemoize;
function requireMemoize() {
    if (hasRequiredMemoize) return memoize_1;
    hasRequiredMemoize = 1;
    var MapCache = require_MapCache();
    /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */ function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) return cache.get(key);
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
    }
    // Expose `MapCache`.
    memoize.Cache = MapCache;
    memoize_1 = memoize;
    return memoize_1;
}
var _memoizeCapped;
var hasRequired_memoizeCapped;
function require_memoizeCapped() {
    if (hasRequired_memoizeCapped) return _memoizeCapped;
    hasRequired_memoizeCapped = 1;
    var memoize = requireMemoize();
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */ function memoizeCapped(func) {
        var result = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
            return key;
        });
        var cache = result.cache;
        return result;
    }
    _memoizeCapped = memoizeCapped;
    return _memoizeCapped;
}
var _stringToPath;
var hasRequired_stringToPath;
function require_stringToPath() {
    if (hasRequired_stringToPath) return _stringToPath;
    hasRequired_stringToPath = 1;
    var memoizeCapped = require_memoizeCapped();
    /** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */ var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
        string.replace(rePropName, function(match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
    });
    _stringToPath = stringToPath;
    return _stringToPath;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var _arrayMap;
var hasRequired_arrayMap;
function require_arrayMap() {
    if (hasRequired_arrayMap) return _arrayMap;
    hasRequired_arrayMap = 1;
    function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    _arrayMap = arrayMap;
    return _arrayMap;
}
var _baseToString;
var hasRequired_baseToString;
function require_baseToString() {
    if (hasRequired_baseToString) return _baseToString;
    hasRequired_baseToString = 1;
    var Symbol1 = require_Symbol(), arrayMap = require_arrayMap(), isArray = requireIsArray(), isSymbol = requireIsSymbol();
    /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
    /**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */ function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') return value;
        if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
        if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
        var result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    _baseToString = baseToString;
    return _baseToString;
}
var toString_1;
var hasRequiredToString;
function requireToString() {
    if (hasRequiredToString) return toString_1;
    hasRequiredToString = 1;
    var baseToString = require_baseToString();
    /**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */ function toString(value) {
        return value == null ? '' : baseToString(value);
    }
    toString_1 = toString;
    return toString_1;
}
var _castPath;
var hasRequired_castPath;
function require_castPath() {
    if (hasRequired_castPath) return _castPath;
    hasRequired_castPath = 1;
    var isArray = requireIsArray(), isKey = require_isKey(), stringToPath = require_stringToPath(), toString = requireToString();
    /**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */ function castPath(value, object) {
        if (isArray(value)) return value;
        return isKey(value, object) ? [
            value
        ] : stringToPath(toString(value));
    }
    _castPath = castPath;
    return _castPath;
}
var _toKey;
var hasRequired_toKey;
function require_toKey() {
    if (hasRequired_toKey) return _toKey;
    hasRequired_toKey = 1;
    var isSymbol = requireIsSymbol();
    /**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */ function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) return value;
        var result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    _toKey = toKey;
    return _toKey;
}
var _baseGet;
var hasRequired_baseGet;
function require_baseGet() {
    if (hasRequired_baseGet) return _baseGet;
    hasRequired_baseGet = 1;
    var castPath = require_castPath(), toKey = require_toKey();
    /**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */ function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0, length = path.length;
        while(object != null && index < length)object = object[toKey(path[index++])];
        return index && index == length ? object : undefined;
    }
    _baseGet = baseGet;
    return _baseGet;
}
var get_1;
var hasRequiredGet;
function requireGet() {
    if (hasRequiredGet) return get_1;
    hasRequiredGet = 1;
    var baseGet = require_baseGet();
    /**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */ function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
    }
    get_1 = get;
    return get_1;
}
var getExports = requireGet();
var get = /*@__PURE__*/ getDefaultExportFromCjs(getExports);
var _defineProperty;
var hasRequired_defineProperty;
function require_defineProperty() {
    if (hasRequired_defineProperty) return _defineProperty;
    hasRequired_defineProperty = 1;
    var getNative = require_getNative();
    var defineProperty = function() {
        try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
        } catch (e) {}
    }();
    _defineProperty = defineProperty;
    return _defineProperty;
}
var _baseAssignValue;
var hasRequired_baseAssignValue;
function require_baseAssignValue() {
    if (hasRequired_baseAssignValue) return _baseAssignValue;
    hasRequired_baseAssignValue = 1;
    var defineProperty = require_defineProperty();
    /**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */ function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
        else object[key] = value;
    }
    _baseAssignValue = baseAssignValue;
    return _baseAssignValue;
}
var _assignValue;
var hasRequired_assignValue;
function require_assignValue() {
    if (hasRequired_assignValue) return _assignValue;
    hasRequired_assignValue = 1;
    var baseAssignValue = require_baseAssignValue(), eq = requireEq();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */ function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
    }
    _assignValue = assignValue;
    return _assignValue;
}
/** Used as references for various `Number` constants. */ var _isIndex;
var hasRequired_isIndex;
function require_isIndex() {
    if (hasRequired_isIndex) return _isIndex;
    hasRequired_isIndex = 1;
    var MAX_SAFE_INTEGER = 9007199254740991;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */ function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    _isIndex = isIndex;
    return _isIndex;
}
var _baseSet;
var hasRequired_baseSet;
function require_baseSet() {
    if (hasRequired_baseSet) return _baseSet;
    hasRequired_baseSet = 1;
    var assignValue = require_assignValue(), castPath = require_castPath(), isIndex = require_isIndex(), isObject = requireIsObject(), toKey = require_toKey();
    /**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */ function baseSet(object, path, value, customizer) {
        if (!isObject(object)) return object;
        path = castPath(path, object);
        var index = -1, length = path.length, lastIndex = length - 1, nested = object;
        while(nested != null && ++index < length){
            var key = toKey(path[index]), newValue = value;
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
            if (index != lastIndex) {
                var objValue = nested[key];
                newValue = customizer ? customizer(objValue, key, nested) : undefined;
                if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
        }
        return object;
    }
    _baseSet = baseSet;
    return _baseSet;
}
var set_1;
var hasRequiredSet;
function requireSet() {
    if (hasRequiredSet) return set_1;
    hasRequiredSet = 1;
    var baseSet = require_baseSet();
    /**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */ function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
    }
    set_1 = set;
    return set_1;
}
var setExports = requireSet();
var set = /*@__PURE__*/ getDefaultExportFromCjs(setExports);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var _copyArray;
var hasRequired_copyArray;
function require_copyArray() {
    if (hasRequired_copyArray) return _copyArray;
    hasRequired_copyArray = 1;
    function copyArray(source, array) {
        var index = -1, length = source.length;
        array || (array = Array(length));
        while(++index < length)array[index] = source[index];
        return array;
    }
    _copyArray = copyArray;
    return _copyArray;
}
var toPath_1;
var hasRequiredToPath;
function requireToPath() {
    if (hasRequiredToPath) return toPath_1;
    hasRequiredToPath = 1;
    var arrayMap = require_arrayMap(), copyArray = require_copyArray(), isArray = requireIsArray(), isSymbol = requireIsSymbol(), stringToPath = require_stringToPath(), toKey = require_toKey(), toString = requireToString();
    /**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */ function toPath(value) {
        if (isArray(value)) return arrayMap(value, toKey);
        return isSymbol(value) ? [
            value
        ] : copyArray(stringToPath(toString(value)));
    }
    toPath_1 = toPath;
    return toPath_1;
}
var toPathExports = requireToPath();
var toPath = /*@__PURE__*/ getDefaultExportFromCjs(toPathExports);
var define$2 = {
    // access data field
    data: function data(params) {
        var defaults = {
            field: 'data',
            bindingEvent: 'data',
            allowBinding: false,
            allowSetting: false,
            allowGetting: false,
            settingEvent: 'data',
            settingTriggersEvent: false,
            triggerFnName: 'trigger',
            immutableKeys: {},
            // key => true if immutable
            updateStyle: false,
            beforeGet: function beforeGet(self1) {},
            beforeSet: function beforeSet(self1, obj) {},
            onSet: function onSet(self1) {},
            canSet: function canSet(self1) {
                return true;
            }
        };
        params = extend({}, defaults, params);
        return function dataImpl(name, value) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var single = selfIsArrayLike ? self1[0] : self1;
            // .data('foo', ...)
            if (string(name)) {
                // set or get property
                var isPathLike = name.indexOf('.') !== -1; // there might be a normal field with a dot 
                var path = isPathLike && toPath(name);
                // .data('foo')
                if (p.allowGetting && value === undefined) {
                    // get
                    var ret;
                    if (single) {
                        p.beforeGet(single);
                        // check if it's path and a field with the same name doesn't exist
                        if (path && single._private[p.field][name] === undefined) ret = get(single._private[p.field], path);
                        else ret = single._private[p.field][name];
                    }
                    return ret;
                // .data('foo', 'bar')
                } else if (p.allowSetting && value !== undefined) {
                    // set
                    var valid = !p.immutableKeys[name];
                    if (valid) {
                        var change = _defineProperty$1({}, name, value);
                        p.beforeSet(self1, change);
                        for(var i = 0, l = all.length; i < l; i++){
                            var ele = all[i];
                            if (p.canSet(ele)) {
                                if (path && single._private[p.field][name] === undefined) set(ele._private[p.field], path, value);
                                else ele._private[p.field][name] = value;
                            }
                        }
                        // update mappers if asked
                        if (p.updateStyle) self1.updateStyle();
                        // call onSet callback
                        p.onSet(self1);
                        if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
                    }
                }
            // .data({ 'foo': 'bar' })
            } else if (p.allowSetting && plainObject(name)) {
                // extend
                var obj = name;
                var k, v;
                var keys = Object.keys(obj);
                p.beforeSet(self1, obj);
                for(var _i = 0; _i < keys.length; _i++){
                    k = keys[_i];
                    v = obj[k];
                    var _valid = !p.immutableKeys[k];
                    if (_valid) for(var j = 0; j < all.length; j++){
                        var _ele = all[j];
                        if (p.canSet(_ele)) _ele._private[p.field][k] = v;
                    }
                }
                // update mappers if asked
                if (p.updateStyle) self1.updateStyle();
                // call onSet callback
                p.onSet(self1);
                if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
            // .data(function(){ ... })
            } else if (p.allowBinding && fn$6(name)) {
                // bind to event
                var fn = name;
                self1.on(p.bindingEvent, fn);
            // .data()
            } else if (p.allowGetting && name === undefined) {
                // get whole object
                var _ret;
                if (single) {
                    p.beforeGet(single);
                    _ret = single._private[p.field];
                }
                return _ret;
            }
            return self1; // maintain chainability
        }; // function
    },
    // data
    // remove data field
    removeData: function removeData(params) {
        var defaults = {
            field: 'data',
            event: 'data',
            triggerFnName: 'trigger',
            triggerEvent: false,
            immutableKeys: {} // key => true if immutable
        };
        params = extend({}, defaults, params);
        return function removeDataImpl(names) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            // .removeData('foo bar')
            if (string(names)) {
                // then get the list of keys, and delete them
                var keys = names.split(/\s+/);
                var l = keys.length;
                for(var i = 0; i < l; i++){
                    // delete each non-empty key
                    var key = keys[i];
                    if (emptyString(key)) continue;
                    var valid = !p.immutableKeys[key]; // not valid if immutable
                    if (valid) for(var i_a = 0, l_a = all.length; i_a < l_a; i_a++)all[i_a]._private[p.field][key] = undefined;
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            // .removeData()
            } else if (names === undefined) {
                // then delete all keys
                for(var _i_a = 0, _l_a = all.length; _i_a < _l_a; _i_a++){
                    var _privateFields = all[_i_a]._private[p.field];
                    var _keys = Object.keys(_privateFields);
                    for(var _i2 = 0; _i2 < _keys.length; _i2++){
                        var _key = _keys[_i2];
                        var validKeyToDelete = !p.immutableKeys[_key];
                        if (validKeyToDelete) _privateFields[_key] = undefined;
                    }
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            }
            return self1; // maintain chaining
        }; // function
    } // removeData
}; // define
var define$1 = {
    eventAliasesOn: function eventAliasesOn(proto) {
        var p = proto;
        p.addListener = p.listen = p.bind = p.on;
        p.unlisten = p.unbind = p.off = p.removeListener;
        p.trigger = p.emit;
        // this is just a wrapper alias of .on()
        p.pon = p.promiseOn = function(events, selector) {
            var self1 = this;
            var args = Array.prototype.slice.call(arguments, 0);
            return new Promise$1(function(resolve, reject) {
                var callback = function callback(e) {
                    self1.off.apply(self1, offArgs);
                    resolve(e);
                };
                var onArgs = args.concat([
                    callback
                ]);
                var offArgs = onArgs.concat([]);
                self1.on.apply(self1, onArgs);
            });
        };
    }
}; // define
// use this module to cherry pick functions into your prototype
// (useful for functions shared between the core and collections, for example)
var define = {};
[
    define$3,
    define$2,
    define$1
].forEach(function(m1) {
    extend(define, m1);
});
var elesfn$i = {
    animate: define.animate(),
    animation: define.animation(),
    animated: define.animated(),
    clearQueue: define.clearQueue(),
    delay: define.delay(),
    delayAnimation: define.delayAnimation(),
    stop: define.stop()
};
var elesfn$h = {
    classes: function classes(_classes) {
        var self1 = this;
        if (_classes === undefined) {
            var ret = [];
            self1[0]._private.classes.forEach(function(cls) {
                return ret.push(cls);
            });
            return ret;
        } else if (!array(_classes)) // extract classes from string
        _classes = (_classes || '').match(/\S+/g) || [];
        var changed = [];
        var classesSet = new Set$1(_classes);
        // check and update each ele
        for(var j = 0; j < self1.length; j++){
            var ele = self1[j];
            var _p = ele._private;
            var eleClasses = _p.classes;
            var changedEle = false;
            // check if ele has all of the passed classes
            for(var i = 0; i < _classes.length; i++){
                var cls = _classes[i];
                var eleHasClass = eleClasses.has(cls);
                if (!eleHasClass) {
                    changedEle = true;
                    break;
                }
            }
            // check if ele has classes outside of those passed
            if (!changedEle) changedEle = eleClasses.size !== _classes.length;
            if (changedEle) {
                _p.classes = classesSet;
                changed.push(ele);
            }
        }
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    addClass: function addClass(classes) {
        return this.toggleClass(classes, true);
    },
    hasClass: function hasClass(className) {
        var ele = this[0];
        return ele != null && ele._private.classes.has(className);
    },
    toggleClass: function toggleClass(classes, toggle) {
        if (!array(classes)) // extract classes from string
        classes = classes.match(/\S+/g) || [];
        var self1 = this;
        var toggleUndefd = toggle === undefined;
        var changed = []; // eles who had classes changed
        for(var i = 0, il = self1.length; i < il; i++){
            var ele = self1[i];
            var eleClasses = ele._private.classes;
            var changedEle = false;
            for(var j = 0; j < classes.length; j++){
                var cls = classes[j];
                var hasClass = eleClasses.has(cls);
                var changedNow = false;
                if (toggle || toggleUndefd && !hasClass) {
                    eleClasses.add(cls);
                    changedNow = true;
                } else if (!toggle || toggleUndefd && hasClass) {
                    eleClasses["delete"](cls);
                    changedNow = true;
                }
                if (!changedEle && changedNow) {
                    changed.push(ele);
                    changedEle = true;
                }
            } // for j classes
        } // for i eles
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    removeClass: function removeClass(classes) {
        return this.toggleClass(classes, false);
    },
    flashClass: function flashClass(classes, duration) {
        var self1 = this;
        if (duration == null) duration = 250;
        else if (duration === 0) return self1; // nothing to do really
        self1.addClass(classes);
        setTimeout(function() {
            self1.removeClass(classes);
        }, duration);
        return self1;
    }
};
elesfn$h.className = elesfn$h.classNames = elesfn$h.classes;
// tokens in the query language
var tokens = {
    metaChar: '[\\!\\"\\#\\$\\%\\&\\\'\\(\\)\\*\\+\\,\\.\\/\\:\\;\\<\\=\\>\\?\\@\\[\\]\\^\\`\\{\\|\\}\\~]',
    // chars we need to escape in let names, etc
    comparatorOp: '=|\\!=|>|>=|<|<=|\\$=|\\^=|\\*=',
    // binary comparison op (used in data selectors)
    boolOp: '\\?|\\!|\\^',
    // boolean (unary) operators (used in data selectors)
    string: "\"(?:\\\\\"|[^\"])*\"|'(?:\\\\'|[^'])*'",
    // string literals (used in data selectors) -- doublequotes | singlequotes
    number: number,
    // number literal (used in data selectors) --- e.g. 0.1234, 1234, 12e123
    meta: 'degree|indegree|outdegree',
    // allowed metadata fields (i.e. allowed functions to use from Collection)
    separator: '\\s*,\\s*',
    // queries are separated by commas, e.g. edge[foo = 'bar'], node.someClass
    descendant: '\\s+',
    child: '\\s+>\\s+',
    subject: '\\$',
    group: 'node|edge|\\*',
    directedEdge: '\\s+->\\s+',
    undirectedEdge: '\\s+<->\\s+'
};
tokens.variable = '(?:[\\w-.]|(?:\\\\' + tokens.metaChar + '))+'; // a variable name can have letters, numbers, dashes, and periods
tokens.className = '(?:[\\w-]|(?:\\\\' + tokens.metaChar + '))+'; // a class name has the same rules as a variable except it can't have a '.' in the name
tokens.value = tokens.string + '|' + tokens.number; // a value literal, either a string or number
tokens.id = tokens.variable; // an element id (follows variable conventions)
(function() {
    var ops, op, i;
    // add @ variants to comparatorOp
    ops = tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        tokens.comparatorOp += '|@' + op;
    }
    // add ! variants to comparatorOp
    ops = tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        if (op.indexOf('!') >= 0) continue;
         // skip ops that explicitly contain !
        if (op === '=') continue;
         // skip = b/c != is explicitly defined
        tokens.comparatorOp += '|\\!' + op;
    }
})();
/**
 * Make a new query object
 *
 * @prop type {Type} The type enum (int) of the query
 * @prop checks List of checks to make against an ele to test for a match
 */ var newQuery = function newQuery() {
    return {
        checks: []
    };
};
/**
 * A check type enum-like object.  Uses integer values for fast match() lookup.
 * The ordering does not matter as long as the ints are unique.
 */ var Type = {
    /** E.g. node */ GROUP: 0,
    /** A collection of elements */ COLLECTION: 1,
    /** A filter(ele) function */ FILTER: 2,
    /** E.g. [foo > 1] */ DATA_COMPARE: 3,
    /** E.g. [foo] */ DATA_EXIST: 4,
    /** E.g. [?foo] */ DATA_BOOL: 5,
    /** E.g. [[degree > 2]] */ META_COMPARE: 6,
    /** E.g. :selected */ STATE: 7,
    /** E.g. #foo */ ID: 8,
    /** E.g. .foo */ CLASS: 9,
    /** E.g. #foo <-> #bar */ UNDIRECTED_EDGE: 10,
    /** E.g. #foo -> #bar */ DIRECTED_EDGE: 11,
    /** E.g. $#foo -> #bar */ NODE_SOURCE: 12,
    /** E.g. #foo -> $#bar */ NODE_TARGET: 13,
    /** E.g. $#foo <-> #bar */ NODE_NEIGHBOR: 14,
    /** E.g. #foo > #bar */ CHILD: 15,
    /** E.g. #foo #bar */ DESCENDANT: 16,
    /** E.g. $#foo > #bar */ PARENT: 17,
    /** E.g. $#foo #bar */ ANCESTOR: 18,
    /** E.g. #foo > $bar > #baz */ COMPOUND_SPLIT: 19,
    /** Always matches, useful placeholder for subject in `COMPOUND_SPLIT` */ TRUE: 20
};
var stateSelectors = [
    {
        selector: ':selected',
        matches: function matches(ele) {
            return ele.selected();
        }
    },
    {
        selector: ':unselected',
        matches: function matches(ele) {
            return !ele.selected();
        }
    },
    {
        selector: ':selectable',
        matches: function matches(ele) {
            return ele.selectable();
        }
    },
    {
        selector: ':unselectable',
        matches: function matches(ele) {
            return !ele.selectable();
        }
    },
    {
        selector: ':locked',
        matches: function matches(ele) {
            return ele.locked();
        }
    },
    {
        selector: ':unlocked',
        matches: function matches(ele) {
            return !ele.locked();
        }
    },
    {
        selector: ':visible',
        matches: function matches(ele) {
            return ele.visible();
        }
    },
    {
        selector: ':hidden',
        matches: function matches(ele) {
            return !ele.visible();
        }
    },
    {
        selector: ':transparent',
        matches: function matches(ele) {
            return ele.transparent();
        }
    },
    {
        selector: ':grabbed',
        matches: function matches(ele) {
            return ele.grabbed();
        }
    },
    {
        selector: ':free',
        matches: function matches(ele) {
            return !ele.grabbed();
        }
    },
    {
        selector: ':removed',
        matches: function matches(ele) {
            return ele.removed();
        }
    },
    {
        selector: ':inside',
        matches: function matches(ele) {
            return !ele.removed();
        }
    },
    {
        selector: ':grabbable',
        matches: function matches(ele) {
            return ele.grabbable();
        }
    },
    {
        selector: ':ungrabbable',
        matches: function matches(ele) {
            return !ele.grabbable();
        }
    },
    {
        selector: ':animated',
        matches: function matches(ele) {
            return ele.animated();
        }
    },
    {
        selector: ':unanimated',
        matches: function matches(ele) {
            return !ele.animated();
        }
    },
    {
        selector: ':parent',
        matches: function matches(ele) {
            return ele.isParent();
        }
    },
    {
        selector: ':childless',
        matches: function matches(ele) {
            return ele.isChildless();
        }
    },
    {
        selector: ':child',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':orphan',
        matches: function matches(ele) {
            return ele.isOrphan();
        }
    },
    {
        selector: ':nonorphan',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':compound',
        matches: function matches(ele) {
            if (ele.isNode()) return ele.isParent();
            else return ele.source().isParent() || ele.target().isParent();
        }
    },
    {
        selector: ':loop',
        matches: function matches(ele) {
            return ele.isLoop();
        }
    },
    {
        selector: ':simple',
        matches: function matches(ele) {
            return ele.isSimple();
        }
    },
    {
        selector: ':active',
        matches: function matches(ele) {
            return ele.active();
        }
    },
    {
        selector: ':inactive',
        matches: function matches(ele) {
            return !ele.active();
        }
    },
    {
        selector: ':backgrounding',
        matches: function matches(ele) {
            return ele.backgrounding();
        }
    },
    {
        selector: ':nonbackgrounding',
        matches: function matches(ele) {
            return !ele.backgrounding();
        }
    }
].sort(function(a, b) {
    // n.b. selectors that are starting substrings of others must have the longer ones first
    return descending(a.selector, b.selector);
});
var lookup = function() {
    var selToFn = {};
    var s;
    for(var i = 0; i < stateSelectors.length; i++){
        s = stateSelectors[i];
        selToFn[s.selector] = s.matches;
    }
    return selToFn;
}();
var stateSelectorMatches = function stateSelectorMatches(sel, ele) {
    return lookup[sel](ele);
};
var stateSelectorRegex = '(' + stateSelectors.map(function(s) {
    return s.selector;
}).join('|') + ')';
// when a token like a variable has escaped meta characters, we need to clean the backslashes out
// so that values get compared properly in Selector.filter()
var cleanMetaChars = function cleanMetaChars(str) {
    return str.replace(new RegExp('\\\\(' + tokens.metaChar + ')', 'g'), function(match, $1) {
        return $1;
    });
};
var replaceLastQuery = function replaceLastQuery(selector, examiningQuery, replacementQuery) {
    selector[selector.length - 1] = replacementQuery;
};
// NOTE: add new expression syntax here to have it recognised by the parser;
// - a query contains all adjacent (i.e. no separator in between) expressions;
// - the current query is stored in selector[i]
// - you need to check the query objects in match() for it actually filter properly, but that's pretty straight forward
var exprs = [
    {
        name: 'group',
        // just used for identifying when debugging
        query: true,
        regex: '(' + tokens.group + ')',
        populate: function populate(selector, query, _ref) {
            var _ref2 = _slicedToArray(_ref, 1), group = _ref2[0];
            query.checks.push({
                type: Type.GROUP,
                value: group === '*' ? group : group + 's'
            });
        }
    },
    {
        name: 'state',
        query: true,
        regex: stateSelectorRegex,
        populate: function populate(selector, query, _ref3) {
            var _ref4 = _slicedToArray(_ref3, 1), state = _ref4[0];
            query.checks.push({
                type: Type.STATE,
                value: state
            });
        }
    },
    {
        name: 'id',
        query: true,
        regex: '\\#(' + tokens.id + ')',
        populate: function populate(selector, query, _ref5) {
            var _ref6 = _slicedToArray(_ref5, 1), id = _ref6[0];
            query.checks.push({
                type: Type.ID,
                value: cleanMetaChars(id)
            });
        }
    },
    {
        name: 'className',
        query: true,
        regex: '\\.(' + tokens.className + ')',
        populate: function populate(selector, query, _ref7) {
            var _ref8 = _slicedToArray(_ref7, 1), className = _ref8[0];
            query.checks.push({
                type: Type.CLASS,
                value: cleanMetaChars(className)
            });
        }
    },
    {
        name: 'dataExists',
        query: true,
        regex: '\\[\\s*(' + tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref9) {
            var _ref10 = _slicedToArray(_ref9, 1), variable = _ref10[0];
            query.checks.push({
                type: Type.DATA_EXIST,
                field: cleanMetaChars(variable)
            });
        }
    },
    {
        name: 'dataCompare',
        query: true,
        regex: '\\[\\s*(' + tokens.variable + ')\\s*(' + tokens.comparatorOp + ')\\s*(' + tokens.value + ')\\s*\\]',
        populate: function populate(selector, query, _ref11) {
            var _ref12 = _slicedToArray(_ref11, 3), variable = _ref12[0], comparatorOp = _ref12[1], value = _ref12[2];
            var valueIsString = new RegExp('^' + tokens.string + '$').exec(value) != null;
            if (valueIsString) value = value.substring(1, value.length - 1);
            else value = parseFloat(value);
            query.checks.push({
                type: Type.DATA_COMPARE,
                field: cleanMetaChars(variable),
                operator: comparatorOp,
                value: value
            });
        }
    },
    {
        name: 'dataBool',
        query: true,
        regex: '\\[\\s*(' + tokens.boolOp + ')\\s*(' + tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref13) {
            var _ref14 = _slicedToArray(_ref13, 2), boolOp = _ref14[0], variable = _ref14[1];
            query.checks.push({
                type: Type.DATA_BOOL,
                field: cleanMetaChars(variable),
                operator: boolOp
            });
        }
    },
    {
        name: 'metaCompare',
        query: true,
        regex: '\\[\\[\\s*(' + tokens.meta + ')\\s*(' + tokens.comparatorOp + ')\\s*(' + tokens.number + ')\\s*\\]\\]',
        populate: function populate(selector, query, _ref15) {
            var _ref16 = _slicedToArray(_ref15, 3), meta = _ref16[0], comparatorOp = _ref16[1], number = _ref16[2];
            query.checks.push({
                type: Type.META_COMPARE,
                field: cleanMetaChars(meta),
                operator: comparatorOp,
                value: parseFloat(number)
            });
        }
    },
    {
        name: 'nextQuery',
        separator: true,
        regex: tokens.separator,
        populate: function populate(selector, query) {
            var currentSubject = selector.currentSubject;
            var edgeCount = selector.edgeCount;
            var compoundCount = selector.compoundCount;
            var lastQ = selector[selector.length - 1];
            if (currentSubject != null) {
                lastQ.subject = currentSubject;
                selector.currentSubject = null;
            }
            lastQ.edgeCount = edgeCount;
            lastQ.compoundCount = compoundCount;
            selector.edgeCount = 0;
            selector.compoundCount = 0;
            // go on to next query
            var nextQuery = selector[selector.length++] = newQuery();
            return nextQuery; // this is the new query to be filled by the following exprs
        }
    },
    {
        name: 'directedEdge',
        separator: true,
        regex: tokens.directedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = newQuery();
                var source = query;
                var target = newQuery();
                edgeQuery.checks.push({
                    type: Type.DIRECTED_EDGE,
                    source: source,
                    target: target
                });
                // the query in the selector should be the edge rather than the source
                replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // source/target
                var srcTgtQ = newQuery();
                var _source = query;
                var _target = newQuery();
                srcTgtQ.checks.push({
                    type: Type.NODE_SOURCE,
                    source: _source,
                    target: _target
                });
                // the query in the selector should be the neighbourhood rather than the node
                replaceLastQuery(selector, query, srcTgtQ);
                selector.edgeCount++;
                return _target; // now populating the target with the following expressions
            }
        }
    },
    {
        name: 'undirectedEdge',
        separator: true,
        regex: tokens.undirectedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = newQuery();
                var source = query;
                var target = newQuery();
                edgeQuery.checks.push({
                    type: Type.UNDIRECTED_EDGE,
                    nodes: [
                        source,
                        target
                    ]
                });
                // the query in the selector should be the edge rather than the source
                replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // neighbourhood
                var nhoodQ = newQuery();
                var node = query;
                var neighbor = newQuery();
                nhoodQ.checks.push({
                    type: Type.NODE_NEIGHBOR,
                    node: node,
                    neighbor: neighbor
                });
                // the query in the selector should be the neighbourhood rather than the node
                replaceLastQuery(selector, query, nhoodQ);
                return neighbor; // now populating the neighbor with following expressions
            }
        }
    },
    {
        name: 'child',
        separator: true,
        regex: tokens.child,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: child query
                var parentChildQuery = newQuery();
                var child = newQuery();
                var parent = selector[selector.length - 1];
                parentChildQuery.checks.push({
                    type: Type.CHILD,
                    parent: parent,
                    child: child
                });
                // the query in the selector should be the '>' itself
                replaceLastQuery(selector, query, parentChildQuery);
                selector.compoundCount++;
                // we're now populating the child query with expressions that follow
                return child;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = newQuery();
                var left = selector[selector.length - 1];
                var right = newQuery();
                var subject = newQuery();
                var _child = newQuery();
                var _parent = newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _parent.checks.push({
                    type: Type.TRUE
                }); // parent implicitly refs the subject
                right.checks.push({
                    type: Type.PARENT,
                    // type is swapped on right side queries
                    parent: _parent,
                    child: _child // empty for now
                });
                replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _child; // now populating the right side's child
            } else {
                // parent query
                // info for parent query
                var _parent2 = newQuery();
                var _child2 = newQuery();
                var pcQChecks = [
                    {
                        type: Type.PARENT,
                        parent: _parent2,
                        child: _child2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _parent2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = pcQChecks; // pc query takes over
                selector.compoundCount++;
                return _child2; // we're now populating the child
            }
        }
    },
    {
        name: 'descendant',
        separator: true,
        regex: tokens.descendant,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: descendant query
                var ancChQuery = newQuery();
                var descendant = newQuery();
                var ancestor = selector[selector.length - 1];
                ancChQuery.checks.push({
                    type: Type.DESCENDANT,
                    ancestor: ancestor,
                    descendant: descendant
                });
                // the query in the selector should be the '>' itself
                replaceLastQuery(selector, query, ancChQuery);
                selector.compoundCount++;
                // we're now populating the descendant query with expressions that follow
                return descendant;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = newQuery();
                var left = selector[selector.length - 1];
                var right = newQuery();
                var subject = newQuery();
                var _descendant = newQuery();
                var _ancestor = newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _ancestor.checks.push({
                    type: Type.TRUE
                }); // ancestor implicitly refs the subject
                right.checks.push({
                    type: Type.ANCESTOR,
                    // type is swapped on right side queries
                    ancestor: _ancestor,
                    descendant: _descendant // empty for now
                });
                replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _descendant; // now populating the right side's descendant
            } else {
                // ancestor query
                // info for parent query
                var _ancestor2 = newQuery();
                var _descendant2 = newQuery();
                var adQChecks = [
                    {
                        type: Type.ANCESTOR,
                        ancestor: _ancestor2,
                        descendant: _descendant2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _ancestor2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = adQChecks; // pc query takes over
                selector.compoundCount++;
                return _descendant2; // we're now populating the child
            }
        }
    },
    {
        name: 'subject',
        modifier: true,
        regex: tokens.subject,
        populate: function populate(selector, query) {
            if (selector.currentSubject != null && selector.currentSubject !== query) {
                warn('Redefinition of subject in selector `' + selector.toString() + '`');
                return false;
            }
            selector.currentSubject = query;
            var topQ = selector[selector.length - 1];
            var topChk = topQ.checks[0];
            var topType = topChk == null ? null : topChk.type;
            if (topType === Type.DIRECTED_EDGE) // directed edge with subject on the target
            // change to target node check
            topChk.type = Type.NODE_TARGET;
            else if (topType === Type.UNDIRECTED_EDGE) {
                // undirected edge with subject on the second node
                // change to neighbor check
                topChk.type = Type.NODE_NEIGHBOR;
                topChk.node = topChk.nodes[1]; // second node is subject
                topChk.neighbor = topChk.nodes[0];
                // clean up unused fields for new type
                topChk.nodes = null;
            }
        }
    }
];
exprs.forEach(function(e) {
    return e.regexObj = new RegExp('^' + e.regex);
});
/**
 * Of all the expressions, find the first match in the remaining text.
 * @param {string} remaining The remaining text to parse
 * @returns The matched expression and the newly remaining text `{ expr, match, name, remaining }`
 */ var consumeExpr = function consumeExpr(remaining) {
    var expr;
    var match;
    var name;
    for(var j = 0; j < exprs.length; j++){
        var e = exprs[j];
        var n = e.name;
        var m1 = remaining.match(e.regexObj);
        if (m1 != null) {
            match = m1;
            expr = e;
            name = n;
            var consumed = m1[0];
            remaining = remaining.substring(consumed.length);
            break; // we've consumed one expr, so we can return now
        }
    }
    return {
        expr: expr,
        match: match,
        name: name,
        remaining: remaining
    };
};
/**
 * Consume all the leading whitespace
 * @param {string} remaining The text to consume
 * @returns The text with the leading whitespace removed
 */ var consumeWhitespace = function consumeWhitespace(remaining) {
    var match = remaining.match(/^\s+/);
    if (match) {
        var consumed = match[0];
        remaining = remaining.substring(consumed.length);
    }
    return remaining;
};
/**
 * Parse the string and store the parsed representation in the Selector.
 * @param {string} selector The selector string
 * @returns `true` if the selector was successfully parsed, `false` otherwise
 */ var parse = function parse(selector) {
    var self1 = this;
    var remaining = self1.inputText = selector;
    var currentQuery = self1[0] = newQuery();
    self1.length = 1;
    remaining = consumeWhitespace(remaining); // get rid of leading whitespace
    for(;;){
        var exprInfo = consumeExpr(remaining);
        if (exprInfo.expr == null) {
            warn('The selector `' + selector + '`is invalid');
            return false;
        } else {
            var args = exprInfo.match.slice(1);
            // let the token populate the selector object in currentQuery
            var ret = exprInfo.expr.populate(self1, currentQuery, args);
            if (ret === false) return false; // exit if population failed
            else if (ret != null) currentQuery = ret; // change the current query to be filled if the expr specifies
        }
        remaining = exprInfo.remaining;
        // we're done when there's nothing left to parse
        if (remaining.match(/^\s*$/)) break;
    }
    var lastQ = self1[self1.length - 1];
    if (self1.currentSubject != null) lastQ.subject = self1.currentSubject;
    lastQ.edgeCount = self1.edgeCount;
    lastQ.compoundCount = self1.compoundCount;
    for(var i = 0; i < self1.length; i++){
        var q = self1[i];
        // in future, this could potentially be allowed if there were operator precedence and detection of invalid combinations
        if (q.compoundCount > 0 && q.edgeCount > 0) {
            warn('The selector `' + selector + '` is invalid because it uses both a compound selector and an edge selector');
            return false;
        }
        if (q.edgeCount > 1) {
            warn('The selector `' + selector + '` is invalid because it uses multiple edge selectors');
            return false;
        } else if (q.edgeCount === 1) warn('The selector `' + selector + '` is deprecated.  Edge selectors do not take effect on changes to source and target nodes after an edge is added, for performance reasons.  Use a class or data selector on edges instead, updating the class or data of an edge when your app detects a change in source or target nodes.');
    }
    return true; // success
};
/**
 * Get the selector represented as a string.  This value uses default formatting,
 * so things like spacing may differ from the input text passed to the constructor.
 * @returns {string} The selector string
 */ var toString = function toString() {
    if (this.toStringCache != null) return this.toStringCache;
    var clean = function clean(obj) {
        if (obj == null) return '';
        else return obj;
    };
    var cleanVal = function cleanVal(val) {
        if (string(val)) return '"' + val + '"';
        else return clean(val);
    };
    var space = function space(val) {
        return ' ' + val + ' ';
    };
    var checkToString = function checkToString(check, subject) {
        var type = check.type, value = check.value;
        switch(type){
            case Type.GROUP:
                var group = clean(value);
                return group.substring(0, group.length - 1);
            case Type.DATA_COMPARE:
                var field = check.field, operator = check.operator;
                return '[' + field + space(clean(operator)) + cleanVal(value) + ']';
            case Type.DATA_BOOL:
                var _operator = check.operator, _field = check.field;
                return '[' + clean(_operator) + _field + ']';
            case Type.DATA_EXIST:
                var _field2 = check.field;
                return '[' + _field2 + ']';
            case Type.META_COMPARE:
                var _operator2 = check.operator, _field3 = check.field;
                return '[[' + _field3 + space(clean(_operator2)) + cleanVal(value) + ']]';
            case Type.STATE:
                return value;
            case Type.ID:
                return '#' + value;
            case Type.CLASS:
                return '.' + value;
            case Type.PARENT:
            case Type.CHILD:
                return queryToString(check.parent, subject) + space('>') + queryToString(check.child, subject);
            case Type.ANCESTOR:
            case Type.DESCENDANT:
                return queryToString(check.ancestor, subject) + ' ' + queryToString(check.descendant, subject);
            case Type.COMPOUND_SPLIT:
                var lhs = queryToString(check.left, subject);
                var sub = queryToString(check.subject, subject);
                var rhs = queryToString(check.right, subject);
                return lhs + (lhs.length > 0 ? ' ' : '') + sub + rhs;
            case Type.TRUE:
                return '';
        }
    };
    var queryToString = function queryToString(query, subject) {
        return query.checks.reduce(function(str, chk, i) {
            return str + (subject === query && i === 0 ? '$' : '') + checkToString(chk, subject);
        }, '');
    };
    var str = '';
    for(var i = 0; i < this.length; i++){
        var query = this[i];
        str += queryToString(query, query.subject);
        if (this.length > 1 && i < this.length - 1) str += ', ';
    }
    this.toStringCache = str;
    return str;
};
var parse$1 = {
    parse: parse,
    toString: toString
};
var valCmp = function valCmp(fieldVal, operator, value) {
    var matches;
    var isFieldStr = string(fieldVal);
    var isFieldNum = number$1(fieldVal);
    var isValStr = string(value);
    var fieldStr, valStr;
    var caseInsensitive = false;
    var notExpr = false;
    var isIneqCmp = false;
    if (operator.indexOf('!') >= 0) {
        operator = operator.replace('!', '');
        notExpr = true;
    }
    if (operator.indexOf('@') >= 0) {
        operator = operator.replace('@', '');
        caseInsensitive = true;
    }
    if (isFieldStr || isValStr || caseInsensitive) {
        fieldStr = !isFieldStr && !isFieldNum ? '' : '' + fieldVal;
        valStr = '' + value;
    }
    // if we're doing a case insensitive comparison, then we're using a STRING comparison
    // even if we're comparing numbers
    if (caseInsensitive) {
        fieldVal = fieldStr = fieldStr.toLowerCase();
        value = valStr = valStr.toLowerCase();
    }
    switch(operator){
        case '*=':
            matches = fieldStr.indexOf(valStr) >= 0;
            break;
        case '$=':
            matches = fieldStr.indexOf(valStr, fieldStr.length - valStr.length) >= 0;
            break;
        case '^=':
            matches = fieldStr.indexOf(valStr) === 0;
            break;
        case '=':
            matches = fieldVal === value;
            break;
        case '>':
            isIneqCmp = true;
            matches = fieldVal > value;
            break;
        case '>=':
            isIneqCmp = true;
            matches = fieldVal >= value;
            break;
        case '<':
            isIneqCmp = true;
            matches = fieldVal < value;
            break;
        case '<=':
            isIneqCmp = true;
            matches = fieldVal <= value;
            break;
        default:
            matches = false;
            break;
    }
    // apply the not op, but null vals for inequalities should always stay non-matching
    if (notExpr && (fieldVal != null || !isIneqCmp)) matches = !matches;
    return matches;
};
var boolCmp = function boolCmp(fieldVal, operator) {
    switch(operator){
        case '?':
            return fieldVal ? true : false;
        case '!':
            return fieldVal ? false : true;
        case '^':
            return fieldVal === undefined;
    }
};
var existCmp = function existCmp(fieldVal) {
    return fieldVal !== undefined;
};
var data$1 = function data(ele, field) {
    return ele.data(field);
};
var meta = function meta(ele, field) {
    return ele[field]();
};
/** A lookup of `match(check, ele)` functions by `Type` int */ var match = [];
/**
 * Returns whether the query matches for the element
 * @param query The `{ type, value, ... }` query object
 * @param ele The element to compare against
*/ var matches$1 = function matches(query, ele) {
    return query.checks.every(function(chk) {
        return match[chk.type](chk, ele);
    });
};
match[Type.GROUP] = function(check, ele) {
    var group = check.value;
    return group === '*' || group === ele.group();
};
match[Type.STATE] = function(check, ele) {
    var stateSelector = check.value;
    return stateSelectorMatches(stateSelector, ele);
};
match[Type.ID] = function(check, ele) {
    var id = check.value;
    return ele.id() === id;
};
match[Type.CLASS] = function(check, ele) {
    var cls = check.value;
    return ele.hasClass(cls);
};
match[Type.META_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return valCmp(meta(ele, field), operator, value);
};
match[Type.DATA_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return valCmp(data$1(ele, field), operator, value);
};
match[Type.DATA_BOOL] = function(check, ele) {
    var field = check.field, operator = check.operator;
    return boolCmp(data$1(ele, field), operator);
};
match[Type.DATA_EXIST] = function(check, ele) {
    var field = check.field;
    check.operator;
    return existCmp(data$1(ele, field));
};
match[Type.UNDIRECTED_EDGE] = function(check, ele) {
    var qA = check.nodes[0];
    var qB = check.nodes[1];
    var src = ele.source();
    var tgt = ele.target();
    return matches$1(qA, src) && matches$1(qB, tgt) || matches$1(qB, src) && matches$1(qA, tgt);
};
match[Type.NODE_NEIGHBOR] = function(check, ele) {
    return matches$1(check.node, ele) && ele.neighborhood().some(function(n) {
        return n.isNode() && matches$1(check.neighbor, n);
    });
};
match[Type.DIRECTED_EDGE] = function(check, ele) {
    return matches$1(check.source, ele.source()) && matches$1(check.target, ele.target());
};
match[Type.NODE_SOURCE] = function(check, ele) {
    return matches$1(check.source, ele) && ele.outgoers().some(function(n) {
        return n.isNode() && matches$1(check.target, n);
    });
};
match[Type.NODE_TARGET] = function(check, ele) {
    return matches$1(check.target, ele) && ele.incomers().some(function(n) {
        return n.isNode() && matches$1(check.source, n);
    });
};
match[Type.CHILD] = function(check, ele) {
    return matches$1(check.child, ele) && matches$1(check.parent, ele.parent());
};
match[Type.PARENT] = function(check, ele) {
    return matches$1(check.parent, ele) && ele.children().some(function(c) {
        return matches$1(check.child, c);
    });
};
match[Type.DESCENDANT] = function(check, ele) {
    return matches$1(check.descendant, ele) && ele.ancestors().some(function(a) {
        return matches$1(check.ancestor, a);
    });
};
match[Type.ANCESTOR] = function(check, ele) {
    return matches$1(check.ancestor, ele) && ele.descendants().some(function(d) {
        return matches$1(check.descendant, d);
    });
};
match[Type.COMPOUND_SPLIT] = function(check, ele) {
    return matches$1(check.subject, ele) && matches$1(check.left, ele) && matches$1(check.right, ele);
};
match[Type.TRUE] = function() {
    return true;
};
match[Type.COLLECTION] = function(check, ele) {
    var collection = check.value;
    return collection.has(ele);
};
match[Type.FILTER] = function(check, ele) {
    var filter = check.value;
    return filter(ele);
};
// filter an existing collection
var filter = function filter(collection) {
    var self1 = this;
    // for 1 id #foo queries, just get the element
    if (self1.length === 1 && self1[0].checks.length === 1 && self1[0].checks[0].type === Type.ID) return collection.getElementById(self1[0].checks[0].value).collection();
    var selectorFunction = function selectorFunction(element) {
        for(var j = 0; j < self1.length; j++){
            var query = self1[j];
            if (matches$1(query, element)) return true;
        }
        return false;
    };
    if (self1.text() == null) selectorFunction = function selectorFunction() {
        return true;
    };
    return collection.filter(selectorFunction);
}; // filter
// does selector match a single element?
var matches = function matches(ele) {
    var self1 = this;
    for(var j = 0; j < self1.length; j++){
        var query = self1[j];
        if (matches$1(query, ele)) return true;
    }
    return false;
}; // matches
var matching = {
    matches: matches,
    filter: filter
};
var Selector = function Selector(selector) {
    this.inputText = selector;
    this.currentSubject = null;
    this.compoundCount = 0;
    this.edgeCount = 0;
    this.length = 0;
    if (selector == null || string(selector) && selector.match(/^\s*$/)) ;
    else if (elementOrCollection(selector)) this.addQuery({
        checks: [
            {
                type: Type.COLLECTION,
                value: selector.collection()
            }
        ]
    });
    else if (fn$6(selector)) this.addQuery({
        checks: [
            {
                type: Type.FILTER,
                value: selector
            }
        ]
    });
    else if (string(selector)) {
        if (!this.parse(selector)) this.invalid = true;
    } else error('A selector must be created from a string; found ');
};
var selfn = Selector.prototype;
[
    parse$1,
    matching
].forEach(function(p) {
    return extend(selfn, p);
});
selfn.text = function() {
    return this.inputText;
};
selfn.size = function() {
    return this.length;
};
selfn.eq = function(i) {
    return this[i];
};
selfn.sameText = function(otherSel) {
    return !this.invalid && !otherSel.invalid && this.text() === otherSel.text();
};
selfn.addQuery = function(q) {
    this[this.length++] = q;
};
selfn.selector = selfn.toString;
var elesfn$g = {
    allAre: function allAre(selector) {
        var selObj = new Selector(selector);
        return this.every(function(ele) {
            return selObj.matches(ele);
        });
    },
    is: function is(selector) {
        var selObj = new Selector(selector);
        return this.some(function(ele) {
            return selObj.matches(ele);
        });
    },
    some: function some(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (ret) return true;
        }
        return false;
    },
    every: function every(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (!ret) return false;
        }
        return true;
    },
    same: function same(collection) {
        // cheap collection ref check
        if (this === collection) return true;
        collection = this.cy().collection(collection);
        var thisLength = this.length;
        var collectionLength = collection.length;
        // cheap length check
        if (thisLength !== collectionLength) return false;
        // cheap element ref check
        if (thisLength === 1) return this[0] === collection[0];
        return this.every(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    anySame: function anySame(collection) {
        collection = this.cy().collection(collection);
        return this.some(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    allAreNeighbors: function allAreNeighbors(collection) {
        collection = this.cy().collection(collection);
        var nhood = this.neighborhood();
        return collection.every(function(ele) {
            return nhood.hasElementWithId(ele.id());
        });
    },
    contains: function contains(collection) {
        collection = this.cy().collection(collection);
        var self1 = this;
        return collection.every(function(ele) {
            return self1.hasElementWithId(ele.id());
        });
    }
};
elesfn$g.allAreNeighbours = elesfn$g.allAreNeighbors;
elesfn$g.has = elesfn$g.contains;
elesfn$g.equal = elesfn$g.equals = elesfn$g.same;
var cache = function cache(fn, name) {
    return function traversalCache(arg1, arg2, arg3, arg4) {
        var selectorOrEles = arg1;
        var eles = this;
        var key;
        if (selectorOrEles == null) key = '';
        else if (elementOrCollection(selectorOrEles) && selectorOrEles.length === 1) key = selectorOrEles.id();
        if (eles.length === 1 && key) {
            var _p = eles[0]._private;
            var tch = _p.traversalCache = _p.traversalCache || {};
            var ch = tch[name] = tch[name] || [];
            var hash = hashString(key);
            var cacheHit = ch[hash];
            if (cacheHit) return cacheHit;
            else return ch[hash] = fn.call(eles, arg1, arg2, arg3, arg4);
        } else return fn.call(eles, arg1, arg2, arg3, arg4);
    };
};
var elesfn$f = {
    parent: function parent(selector) {
        var parents = [];
        // optimisation for single ele call
        if (this.length === 1) {
            var parent = this[0]._private.parent;
            if (parent) return parent;
        }
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _parent = ele._private.parent;
            if (_parent) parents.push(_parent);
        }
        return this.spawn(parents, true).filter(selector);
    },
    parents: function parents(selector) {
        var parents = [];
        var eles = this.parent();
        while(eles.nonempty()){
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                parents.push(ele);
            }
            eles = eles.parent();
        }
        return this.spawn(parents, true).filter(selector);
    },
    commonAncestors: function commonAncestors(selector) {
        var ancestors;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var parents = ele.parents();
            ancestors = ancestors || parents;
            ancestors = ancestors.intersect(parents); // current list must be common with current ele parents set
        }
        return ancestors.filter(selector);
    },
    orphans: function orphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isOrphan();
        }).filter(selector);
    },
    nonorphans: function nonorphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isChild();
        }).filter(selector);
    },
    children: cache(function(selector) {
        var children = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var eleChildren = ele._private.children;
            for(var j = 0; j < eleChildren.length; j++)children.push(eleChildren[j]);
        }
        return this.spawn(children, true).filter(selector);
    }, 'children'),
    siblings: function siblings(selector) {
        return this.parent().children().not(this).filter(selector);
    },
    isParent: function isParent() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length !== 0;
    },
    isChildless: function isChildless() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length === 0;
    },
    isChild: function isChild() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent != null;
    },
    isOrphan: function isOrphan() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent == null;
    },
    descendants: function descendants(selector) {
        var elements = [];
        function add(eles) {
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                elements.push(ele);
                if (ele.children().nonempty()) add(ele.children());
            }
        }
        add(this.children());
        return this.spawn(elements, true).filter(selector);
    }
};
function forEachCompound(eles, fn, includeSelf, recursiveStep) {
    var q = [];
    var did = new Set$1();
    var cy = eles.cy();
    var hasCompounds = cy.hasCompoundNodes();
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (includeSelf) q.push(ele);
        else if (hasCompounds) recursiveStep(q, did, ele);
    }
    while(q.length > 0){
        var _ele = q.shift();
        fn(_ele);
        did.add(_ele.id());
        if (hasCompounds) recursiveStep(q, did, _ele);
    }
    return eles;
}
function addChildren(q, did, ele) {
    if (ele.isParent()) {
        var children = ele._private.children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (!did.has(child.id())) q.push(child);
        }
    }
}
// very efficient version of eles.add( eles.descendants() ).forEach()
// for internal use
elesfn$f.forEachDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return forEachCompound(this, fn, includeSelf, addChildren);
};
function addParent(q, did, ele) {
    if (ele.isChild()) {
        var parent = ele._private.parent;
        if (!did.has(parent.id())) q.push(parent);
    }
}
elesfn$f.forEachUp = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return forEachCompound(this, fn, includeSelf, addParent);
};
function addParentAndChildren(q, did, ele) {
    addParent(q, did, ele);
    addChildren(q, did, ele);
}
elesfn$f.forEachUpAndDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return forEachCompound(this, fn, includeSelf, addParentAndChildren);
};
// aliases
elesfn$f.ancestors = elesfn$f.parents;
var fn$5, elesfn$e;
fn$5 = elesfn$e = {
    data: define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    removeData: define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    scratch: define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    rscratch: define.data({
        field: 'rscratch',
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: true
    }),
    removeRscratch: define.removeData({
        field: 'rscratch',
        triggerEvent: false
    }),
    id: function id() {
        var ele = this[0];
        if (ele) return ele._private.data.id;
    }
};
// aliases
fn$5.attr = fn$5.data;
fn$5.removeAttr = fn$5.removeData;
var data = elesfn$e;
var elesfn$d = {};
function defineDegreeFunction(callback) {
    return function(includeLoops) {
        var self1 = this;
        if (includeLoops === undefined) includeLoops = true;
        if (self1.length === 0) return;
        if (self1.isNode() && !self1.removed()) {
            var degree = 0;
            var node = self1[0];
            var connectedEdges = node._private.edges;
            for(var i = 0; i < connectedEdges.length; i++){
                var edge = connectedEdges[i];
                if (!includeLoops && edge.isLoop()) continue;
                degree += callback(node, edge);
            }
            return degree;
        } else return;
    };
}
extend(elesfn$d, {
    degree: defineDegreeFunction(function(node, edge) {
        if (edge.source().same(edge.target())) return 2;
        else return 1;
    }),
    indegree: defineDegreeFunction(function(node, edge) {
        if (edge.target().same(node)) return 1;
        else return 0;
    }),
    outdegree: defineDegreeFunction(function(node, edge) {
        if (edge.source().same(node)) return 1;
        else return 0;
    })
});
function defineDegreeBoundsFunction(degreeFn, callback) {
    return function(includeLoops) {
        var ret;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var ele = nodes[i];
            var degree = ele[degreeFn](includeLoops);
            if (degree !== undefined && (ret === undefined || callback(degree, ret))) ret = degree;
        }
        return ret;
    };
}
extend(elesfn$d, {
    minDegree: defineDegreeBoundsFunction('degree', function(degree, min) {
        return degree < min;
    }),
    maxDegree: defineDegreeBoundsFunction('degree', function(degree, max) {
        return degree > max;
    }),
    minIndegree: defineDegreeBoundsFunction('indegree', function(degree, min) {
        return degree < min;
    }),
    maxIndegree: defineDegreeBoundsFunction('indegree', function(degree, max) {
        return degree > max;
    }),
    minOutdegree: defineDegreeBoundsFunction('outdegree', function(degree, min) {
        return degree < min;
    }),
    maxOutdegree: defineDegreeBoundsFunction('outdegree', function(degree, max) {
        return degree > max;
    })
});
extend(elesfn$d, {
    totalDegree: function totalDegree(includeLoops) {
        var total = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++)total += nodes[i].degree(includeLoops);
        return total;
    }
});
var fn$4, elesfn$c;
var beforePositionSet = function beforePositionSet(eles, newPos, silent) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.locked()) {
            var oldPos = ele._private.position;
            var delta = {
                x: newPos.x != null ? newPos.x - oldPos.x : 0,
                y: newPos.y != null ? newPos.y - oldPos.y : 0
            };
            if (ele.isParent() && !(delta.x === 0 && delta.y === 0)) ele.children().shift(delta, silent);
            ele.dirtyBoundingBoxCache();
        }
    }
};
var positionDef = {
    field: 'position',
    bindingEvent: 'position',
    allowBinding: true,
    allowSetting: true,
    settingEvent: 'position',
    settingTriggersEvent: true,
    triggerFnName: 'emitAndNotify',
    allowGetting: true,
    validKeys: [
        'x',
        'y'
    ],
    beforeGet: function beforeGet(ele) {
        ele.updateCompoundBounds();
    },
    beforeSet: function beforeSet(eles, newPos) {
        beforePositionSet(eles, newPos, false);
    },
    onSet: function onSet(eles) {
        eles.dirtyCompoundBoundsCache();
    },
    canSet: function canSet(ele) {
        return !ele.locked();
    }
};
fn$4 = elesfn$c = {
    position: define.data(positionDef),
    // position but no notification to renderer
    silentPosition: define.data(extend({}, positionDef, {
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: false,
        beforeSet: function beforeSet(eles, newPos) {
            beforePositionSet(eles, newPos, true);
        },
        onSet: function onSet(eles) {
            eles.dirtyCompoundBoundsCache();
        }
    })),
    positions: function positions(pos, silent) {
        if (plainObject(pos)) {
            if (silent) this.silentPosition(pos);
            else this.position(pos);
        } else if (fn$6(pos)) {
            var _fn = pos;
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var _pos = undefined;
                if (_pos = _fn(ele, i)) {
                    if (silent) ele.silentPosition(_pos);
                    else ele.position(_pos);
                }
            }
            cy.endBatch();
        }
        return this; // chaining
    },
    silentPositions: function silentPositions(pos) {
        return this.positions(pos, true);
    },
    shift: function shift(dim, val, silent) {
        var delta;
        if (plainObject(dim)) {
            delta = {
                x: number$1(dim.x) ? dim.x : 0,
                y: number$1(dim.y) ? dim.y : 0
            };
            silent = val;
        } else if (string(dim) && number$1(val)) {
            delta = {
                x: 0,
                y: 0
            };
            delta[dim] = val;
        }
        if (delta != null) {
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                // exclude any node that is a descendant of the calling collection
                if (cy.hasCompoundNodes() && ele.isChild() && ele.ancestors().anySame(this)) continue;
                var pos = ele.position();
                var newPos = {
                    x: pos.x + delta.x,
                    y: pos.y + delta.y
                };
                if (silent) ele.silentPosition(newPos);
                else ele.position(newPos);
            }
            cy.endBatch();
        }
        return this;
    },
    silentShift: function silentShift(dim, val) {
        if (plainObject(dim)) this.shift(dim, true);
        else if (string(dim) && number$1(val)) this.shift(dim, val, true);
        return this;
    },
    // get/set the rendered (i.e. on screen) positon of the element
    renderedPosition: function renderedPosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var zoom = cy.zoom();
        var pan = cy.pan();
        var rpos = plainObject(dim) ? dim : undefined;
        var setting = rpos !== undefined || val !== undefined && string(dim);
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele = this[i];
                if (val !== undefined) // set one dimension
                _ele.position(dim, (val - pan[dim]) / zoom);
                else if (rpos !== undefined) // set whole position
                _ele.position(renderedToModelPosition(rpos, zoom, pan));
            }
            else {
                // getting
                var pos = ele.position();
                rpos = modelToRenderedPosition$1(pos, zoom, pan);
                if (dim === undefined) // then return the whole rendered position
                return rpos;
                else // then return the specified dimension
                return rpos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    },
    // get/set the position relative to the parent
    relativePosition: function relativePosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var ppos = plainObject(dim) ? dim : undefined;
        var setting = ppos !== undefined || val !== undefined && string(dim);
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele2 = this[i];
                var parent = hasCompoundNodes ? _ele2.parent() : null;
                var hasParent = parent && parent.length > 0;
                var relativeToParent = hasParent;
                if (hasParent) parent = parent[0];
                var origin = relativeToParent ? parent.position() : {
                    x: 0,
                    y: 0
                };
                if (val !== undefined) // set one dimension
                _ele2.position(dim, val + origin[dim]);
                else if (ppos !== undefined) // set whole position
                _ele2.position({
                    x: ppos.x + origin.x,
                    y: ppos.y + origin.y
                });
            }
            else {
                // getting
                var pos = ele.position();
                var _parent = hasCompoundNodes ? ele.parent() : null;
                var _hasParent = _parent && _parent.length > 0;
                var _relativeToParent = _hasParent;
                if (_hasParent) _parent = _parent[0];
                var _origin = _relativeToParent ? _parent.position() : {
                    x: 0,
                    y: 0
                };
                ppos = {
                    x: pos.x - _origin.x,
                    y: pos.y - _origin.y
                };
                if (dim === undefined) // then return the whole rendered position
                return ppos;
                else // then return the specified dimension
                return ppos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    }
};
// aliases
fn$4.modelPosition = fn$4.point = fn$4.position;
fn$4.modelPositions = fn$4.points = fn$4.positions;
fn$4.renderedPoint = fn$4.renderedPosition;
fn$4.relativePoint = fn$4.relativePosition;
var position = elesfn$c;
var fn$3, elesfn$b;
fn$3 = elesfn$b = {};
elesfn$b.renderedBoundingBox = function(options) {
    var bb = this.boundingBox(options);
    var cy = this.cy();
    var zoom = cy.zoom();
    var pan = cy.pan();
    var x1 = bb.x1 * zoom + pan.x;
    var x2 = bb.x2 * zoom + pan.x;
    var y1 = bb.y1 * zoom + pan.y;
    var y2 = bb.y2 * zoom + pan.y;
    return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2,
        w: x2 - x1,
        h: y2 - y1
    };
};
elesfn$b.dirtyCompoundBoundsCache = function() {
    var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    this.forEachUp(function(ele) {
        if (ele.isParent()) {
            var _p = ele._private;
            _p.compoundBoundsClean = false;
            _p.bbCache = null;
            if (!silent) ele.emitAndNotify('bounds');
        }
    });
    return this;
};
elesfn$b.updateCompoundBounds = function() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    // not possible to do on non-compound graphs or with the style disabled
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    // save cycles when batching -- but bounds will be stale (or not exist yet)
    if (!force && cy.batching()) return this;
    function update(parent) {
        if (!parent.isParent()) return;
        var _p = parent._private;
        var children = parent.children();
        var includeLabels = parent.pstyle('compound-sizing-wrt-labels').value === 'include';
        var min = {
            width: {
                val: parent.pstyle('min-width').pfValue,
                left: parent.pstyle('min-width-bias-left'),
                right: parent.pstyle('min-width-bias-right')
            },
            height: {
                val: parent.pstyle('min-height').pfValue,
                top: parent.pstyle('min-height-bias-top'),
                bottom: parent.pstyle('min-height-bias-bottom')
            }
        };
        var bb = children.boundingBox({
            includeLabels: includeLabels,
            includeOverlays: false,
            // updating the compound bounds happens outside of the regular
            // cache cycle (i.e. before fired events)
            useCache: false
        });
        var pos = _p.position;
        // if children take up zero area then keep position and fall back on stylesheet w/h
        if (bb.w === 0 || bb.h === 0) {
            bb = {
                w: parent.pstyle('width').pfValue,
                h: parent.pstyle('height').pfValue
            };
            bb.x1 = pos.x - bb.w / 2;
            bb.x2 = pos.x + bb.w / 2;
            bb.y1 = pos.y - bb.h / 2;
            bb.y2 = pos.y + bb.h / 2;
        }
        function computeBiasValues(propDiff, propBias, propBiasComplement) {
            var biasDiff = 0;
            var biasComplementDiff = 0;
            var biasTotal = propBias + propBiasComplement;
            if (propDiff > 0 && biasTotal > 0) {
                biasDiff = propBias / biasTotal * propDiff;
                biasComplementDiff = propBiasComplement / biasTotal * propDiff;
            }
            return {
                biasDiff: biasDiff,
                biasComplementDiff: biasComplementDiff
            };
        }
        function computePaddingValues(width, height, paddingObject, relativeTo) {
            // Assuming percentage is number from 0 to 1
            if (paddingObject.units === '%') switch(relativeTo){
                case 'width':
                    return width > 0 ? paddingObject.pfValue * width : 0;
                case 'height':
                    return height > 0 ? paddingObject.pfValue * height : 0;
                case 'average':
                    return width > 0 && height > 0 ? paddingObject.pfValue * (width + height) / 2 : 0;
                case 'min':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * height : paddingObject.pfValue * width : 0;
                case 'max':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * width : paddingObject.pfValue * height : 0;
                default:
                    return 0;
            }
            else if (paddingObject.units === 'px') return paddingObject.pfValue;
            else return 0;
        }
        var leftVal = min.width.left.value;
        if (min.width.left.units === 'px' && min.width.val > 0) leftVal = leftVal * 100 / min.width.val;
        var rightVal = min.width.right.value;
        if (min.width.right.units === 'px' && min.width.val > 0) rightVal = rightVal * 100 / min.width.val;
        var topVal = min.height.top.value;
        if (min.height.top.units === 'px' && min.height.val > 0) topVal = topVal * 100 / min.height.val;
        var bottomVal = min.height.bottom.value;
        if (min.height.bottom.units === 'px' && min.height.val > 0) bottomVal = bottomVal * 100 / min.height.val;
        var widthBiasDiffs = computeBiasValues(min.width.val - bb.w, leftVal, rightVal);
        var diffLeft = widthBiasDiffs.biasDiff;
        var diffRight = widthBiasDiffs.biasComplementDiff;
        var heightBiasDiffs = computeBiasValues(min.height.val - bb.h, topVal, bottomVal);
        var diffTop = heightBiasDiffs.biasDiff;
        var diffBottom = heightBiasDiffs.biasComplementDiff;
        _p.autoPadding = computePaddingValues(bb.w, bb.h, parent.pstyle('padding'), parent.pstyle('padding-relative-to').value);
        _p.autoWidth = Math.max(bb.w, min.width.val);
        pos.x = (-diffLeft + bb.x1 + bb.x2 + diffRight) / 2;
        _p.autoHeight = Math.max(bb.h, min.height.val);
        pos.y = (-diffTop + bb.y1 + bb.y2 + diffBottom) / 2;
    }
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var _p = ele._private;
        if (!_p.compoundBoundsClean || force) {
            update(ele);
            if (!cy.batching()) _p.compoundBoundsClean = true;
        }
    }
    return this;
};
var noninf = function noninf(x) {
    if (x === Infinity || x === -Infinity) return 0;
    return x;
};
var updateBounds = function updateBounds(b, x1, y1, x2, y2) {
    // don't update with zero area boxes
    if (x2 - x1 === 0 || y2 - y1 === 0) return;
    // don't update with null dim
    if (x1 == null || y1 == null || x2 == null || y2 == null) return;
    b.x1 = x1 < b.x1 ? x1 : b.x1;
    b.x2 = x2 > b.x2 ? x2 : b.x2;
    b.y1 = y1 < b.y1 ? y1 : b.y1;
    b.y2 = y2 > b.y2 ? y2 : b.y2;
    b.w = b.x2 - b.x1;
    b.h = b.y2 - b.y1;
};
var updateBoundsFromBox = function updateBoundsFromBox(b, b2) {
    if (b2 == null) return b;
    return updateBounds(b, b2.x1, b2.y1, b2.x2, b2.y2);
};
var prefixedProperty = function prefixedProperty(obj, field, prefix) {
    return getPrefixedProperty(obj, field, prefix);
};
var updateBoundsFromArrow = function updateBoundsFromArrow(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var halfArW = rstyle.arrowWidth / 2;
    var arrowType = ele.pstyle(prefix + '-arrow-shape').value;
    var x;
    var y;
    if (arrowType !== 'none') {
        if (prefix === 'source') {
            x = rstyle.srcX;
            y = rstyle.srcY;
        } else if (prefix === 'target') {
            x = rstyle.tgtX;
            y = rstyle.tgtY;
        } else {
            x = rstyle.midX;
            y = rstyle.midY;
        }
        // always store the individual arrow bounds
        var bbs = _p.arrowBounds = _p.arrowBounds || {};
        var bb = bbs[prefix] = bbs[prefix] || {};
        bb.x1 = x - halfArW;
        bb.y1 = y - halfArW;
        bb.x2 = x + halfArW;
        bb.y2 = y + halfArW;
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
        expandBoundingBox(bb, 1);
        updateBounds(bounds, bb.x1, bb.y1, bb.x2, bb.y2);
    }
};
var updateBoundsFromLabel = function updateBoundsFromLabel(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var prefixDash;
    if (prefix) prefixDash = prefix + '-';
    else prefixDash = '';
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var label = ele.pstyle(prefixDash + 'label').strValue;
    if (label) {
        var halign = ele.pstyle('text-halign');
        var valign = ele.pstyle('text-valign');
        var labelWidth = prefixedProperty(rstyle, 'labelWidth', prefix);
        var labelHeight = prefixedProperty(rstyle, 'labelHeight', prefix);
        var labelX = prefixedProperty(rstyle, 'labelX', prefix);
        var labelY = prefixedProperty(rstyle, 'labelY', prefix);
        var marginX = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var rotation = ele.pstyle(prefixDash + 'text-rotation');
        var outlineWidth = ele.pstyle('text-outline-width').pfValue;
        var borderWidth = ele.pstyle('text-border-width').pfValue;
        var halfBorderWidth = borderWidth / 2;
        var padding = ele.pstyle('text-background-padding').pfValue;
        var marginOfError = 2; // expand to work around browser dimension inaccuracies
        var lh = labelHeight;
        var lw = labelWidth;
        var lw_2 = lw / 2;
        var lh_2 = lh / 2;
        var lx1, lx2, ly1, ly2;
        if (isEdge) {
            lx1 = labelX - lw_2;
            lx2 = labelX + lw_2;
            ly1 = labelY - lh_2;
            ly2 = labelY + lh_2;
        } else {
            switch(halign.value){
                case 'left':
                    lx1 = labelX - lw;
                    lx2 = labelX;
                    break;
                case 'center':
                    lx1 = labelX - lw_2;
                    lx2 = labelX + lw_2;
                    break;
                case 'right':
                    lx1 = labelX;
                    lx2 = labelX + lw;
                    break;
            }
            switch(valign.value){
                case 'top':
                    ly1 = labelY - lh;
                    ly2 = labelY;
                    break;
                case 'center':
                    ly1 = labelY - lh_2;
                    ly2 = labelY + lh_2;
                    break;
                case 'bottom':
                    ly1 = labelY;
                    ly2 = labelY + lh;
                    break;
            }
        }
        // shift by margin and expand by outline and border
        var leftPad = marginX - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var rightPad = marginX + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        var topPad = marginY - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var botPad = marginY + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        lx1 += leftPad;
        lx2 += rightPad;
        ly1 += topPad;
        ly2 += botPad;
        // always store the unrotated label bounds separately
        var bbPrefix = prefix || 'main';
        var bbs = _p.labelBounds;
        var bb = bbs[bbPrefix] = bbs[bbPrefix] || {};
        bb.x1 = lx1;
        bb.y1 = ly1;
        bb.x2 = lx2;
        bb.y2 = ly2;
        bb.w = lx2 - lx1;
        bb.h = ly2 - ly1;
        bb.leftPad = leftPad;
        bb.rightPad = rightPad;
        bb.topPad = topPad;
        bb.botPad = botPad;
        var isAutorotate = isEdge && rotation.strValue === 'autorotate';
        var isPfValue = rotation.pfValue != null && rotation.pfValue !== 0;
        if (isAutorotate || isPfValue) {
            var theta = isAutorotate ? prefixedProperty(_p.rstyle, 'labelAngle', prefix) : rotation.pfValue;
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            // rotation point (default value for center-center)
            var xo = (lx1 + lx2) / 2;
            var yo = (ly1 + ly2) / 2;
            if (!isEdge) {
                switch(halign.value){
                    case 'left':
                        xo = lx2;
                        break;
                    case 'right':
                        xo = lx1;
                        break;
                }
                switch(valign.value){
                    case 'top':
                        yo = ly2;
                        break;
                    case 'bottom':
                        yo = ly1;
                        break;
                }
            }
            var rotate = function rotate(x, y) {
                x = x - xo;
                y = y - yo;
                return {
                    x: x * cos - y * sin + xo,
                    y: x * sin + y * cos + yo
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            lx1 = Math.min(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            lx2 = Math.max(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            ly1 = Math.min(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
            ly2 = Math.max(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
        }
        var bbPrefixRot = bbPrefix + 'Rot';
        var bbRot = bbs[bbPrefixRot] = bbs[bbPrefixRot] || {};
        bbRot.x1 = lx1;
        bbRot.y1 = ly1;
        bbRot.x2 = lx2;
        bbRot.y2 = ly2;
        bbRot.w = lx2 - lx1;
        bbRot.h = ly2 - ly1;
        updateBounds(bounds, lx1, ly1, lx2, ly2);
        updateBounds(_p.labelBounds.all, lx1, ly1, lx2, ly2);
    }
    return bounds;
};
var updateBoundsFromOutline = function updateBoundsFromOutline(bounds, ele) {
    if (ele.cy().headless()) return;
    var outlineOpacity = ele.pstyle('outline-opacity').value;
    var outlineWidth = ele.pstyle('outline-width').value;
    if (outlineOpacity > 0 && outlineWidth > 0) {
        var outlineOffset = ele.pstyle('outline-offset').value;
        var nodeShape = ele.pstyle('shape').value;
        var outlineSize = outlineWidth + outlineOffset;
        var scaleX = (bounds.w + outlineSize * 2) / bounds.w;
        var scaleY = (bounds.h + outlineSize * 2) / bounds.h;
        var xOffset = 0;
        var yOffset = 0;
        if ([
            "diamond",
            "pentagon",
            "round-triangle"
        ].includes(nodeShape)) {
            scaleX = (bounds.w + outlineSize * 2.4) / bounds.w;
            yOffset = -outlineSize / 3.6;
        } else if ([
            "concave-hexagon",
            "rhomboid",
            "right-rhomboid"
        ].includes(nodeShape)) scaleX = (bounds.w + outlineSize * 2.4) / bounds.w;
        else if (nodeShape === "star") {
            scaleX = (bounds.w + outlineSize * 2.8) / bounds.w;
            scaleY = (bounds.h + outlineSize * 2.6) / bounds.h;
            yOffset = -outlineSize / 3.8;
        } else if (nodeShape === "triangle") {
            scaleX = (bounds.w + outlineSize * 2.8) / bounds.w;
            scaleY = (bounds.h + outlineSize * 2.4) / bounds.h;
            yOffset = -outlineSize / 1.4;
        } else if (nodeShape === "vee") {
            scaleX = (bounds.w + outlineSize * 4.4) / bounds.w;
            scaleY = (bounds.h + outlineSize * 3.8) / bounds.h;
            yOffset = -outlineSize * .5;
        }
        var hDelta = bounds.h * scaleY - bounds.h;
        var wDelta = bounds.w * scaleX - bounds.w;
        expandBoundingBoxSides(bounds, [
            Math.ceil(hDelta / 2),
            Math.ceil(wDelta / 2)
        ]);
        if (xOffset != 0 || yOffset !== 0) {
            var oBounds = shiftBoundingBox(bounds, xOffset, yOffset);
            updateBoundingBox(bounds, oBounds);
        }
    }
};
// get the bounding box of the elements (in raw model position)
var boundingBoxImpl = function boundingBoxImpl(ele, options) {
    var cy = ele._private.cy;
    var styleEnabled = cy.styleEnabled();
    var headless = cy.headless();
    var bounds = makeBoundingBox();
    var _p = ele._private;
    var isNode = ele.isNode();
    var isEdge = ele.isEdge();
    var ex1, ex2, ey1, ey2; // extrema of body / lines
    var x, y; // node pos
    var rstyle = _p.rstyle;
    var manualExpansion = isNode && styleEnabled ? ele.pstyle('bounds-expansion').pfValue : [
        0
    ];
    // must use `display` prop only, as reading `compound.width()` causes recursion
    // (other factors like width values will be considered later in this function anyway)
    var isDisplayed = function isDisplayed(ele) {
        return ele.pstyle('display').value !== 'none';
    };
    var displayed = !styleEnabled || isDisplayed(ele) && (!isEdge || isDisplayed(ele.source()) && isDisplayed(ele.target()));
    if (displayed) {
        // displayed suffices, since we will find zero area eles anyway
        var overlayOpacity = 0;
        var overlayPadding = 0;
        if (styleEnabled && options.includeOverlays) {
            overlayOpacity = ele.pstyle('overlay-opacity').value;
            if (overlayOpacity !== 0) overlayPadding = ele.pstyle('overlay-padding').value;
        }
        var underlayOpacity = 0;
        var underlayPadding = 0;
        if (styleEnabled && options.includeUnderlays) {
            underlayOpacity = ele.pstyle('underlay-opacity').value;
            if (underlayOpacity !== 0) underlayPadding = ele.pstyle('underlay-padding').value;
        }
        var padding = Math.max(overlayPadding, underlayPadding);
        var w = 0;
        var wHalf = 0;
        if (styleEnabled) {
            w = ele.pstyle('width').pfValue;
            wHalf = w / 2;
        }
        if (isNode && options.includeNodes) {
            var pos = ele.position();
            x = pos.x;
            y = pos.y;
            var _w = ele.outerWidth();
            var halfW = _w / 2;
            var h = ele.outerHeight();
            var halfH = h / 2;
            // handle node dimensions
            /////////////////////////
            ex1 = x - halfW;
            ex2 = x + halfW;
            ey1 = y - halfH;
            ey2 = y + halfH;
            updateBounds(bounds, ex1, ey1, ex2, ey2);
            if (styleEnabled && options.includeOutlines) updateBoundsFromOutline(bounds, ele);
        } else if (isEdge && options.includeEdges) {
            if (styleEnabled && !headless) {
                var curveStyle = ele.pstyle('curve-style').strValue;
                // handle edge dimensions (rough box estimate)
                //////////////////////////////////////////////
                ex1 = Math.min(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ex2 = Math.max(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ey1 = Math.min(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                ey2 = Math.max(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                updateBounds(bounds, ex1, ey1, ex2, ey2);
                // precise edges
                ////////////////
                if (curveStyle === 'haystack') {
                    var hpts = rstyle.haystackPts;
                    if (hpts && hpts.length === 2) {
                        ex1 = hpts[0].x;
                        ey1 = hpts[0].y;
                        ex2 = hpts[1].x;
                        ey2 = hpts[1].y;
                        if (ex1 > ex2) {
                            var temp = ex1;
                            ex1 = ex2;
                            ex2 = temp;
                        }
                        if (ey1 > ey2) {
                            var _temp = ey1;
                            ey1 = ey2;
                            ey2 = _temp;
                        }
                        updateBounds(bounds, ex1 - wHalf, ey1 - wHalf, ex2 + wHalf, ey2 + wHalf);
                    }
                } else if (curveStyle === 'bezier' || curveStyle === 'unbundled-bezier' || curveStyle.endsWith('segments') || curveStyle.endsWith('taxi')) {
                    var pts;
                    switch(curveStyle){
                        case 'bezier':
                        case 'unbundled-bezier':
                            pts = rstyle.bezierPts;
                            break;
                        case 'segments':
                        case 'taxi':
                        case 'round-segments':
                        case 'round-taxi':
                            pts = rstyle.linePts;
                            break;
                    }
                    if (pts != null) for(var j = 0; j < pts.length; j++){
                        var pt = pts[j];
                        ex1 = pt.x - wHalf;
                        ex2 = pt.x + wHalf;
                        ey1 = pt.y - wHalf;
                        ey2 = pt.y + wHalf;
                        updateBounds(bounds, ex1, ey1, ex2, ey2);
                    }
                } // bezier-like or segment-like edge
            } else {
                // headless or style disabled
                // fallback on source and target positions
                //////////////////////////////////////////
                var n1 = ele.source();
                var n1pos = n1.position();
                var n2 = ele.target();
                var n2pos = n2.position();
                ex1 = n1pos.x;
                ex2 = n2pos.x;
                ey1 = n1pos.y;
                ey2 = n2pos.y;
                if (ex1 > ex2) {
                    var _temp2 = ex1;
                    ex1 = ex2;
                    ex2 = _temp2;
                }
                if (ey1 > ey2) {
                    var _temp3 = ey1;
                    ey1 = ey2;
                    ey2 = _temp3;
                }
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                updateBounds(bounds, ex1, ey1, ex2, ey2);
            } // headless or style disabled
        } // edges
        // handle edge arrow size
        /////////////////////////
        if (styleEnabled && options.includeEdges && isEdge) {
            updateBoundsFromArrow(bounds, ele, 'mid-source');
            updateBoundsFromArrow(bounds, ele, 'mid-target');
            updateBoundsFromArrow(bounds, ele, 'source');
            updateBoundsFromArrow(bounds, ele, 'target');
        }
        // ghost
        ////////
        if (styleEnabled) {
            var ghost = ele.pstyle('ghost').value === 'yes';
            if (ghost) {
                var gx = ele.pstyle('ghost-offset-x').pfValue;
                var gy = ele.pstyle('ghost-offset-y').pfValue;
                updateBounds(bounds, bounds.x1 + gx, bounds.y1 + gy, bounds.x2 + gx, bounds.y2 + gy);
            }
        }
        // always store the body bounds separately from the labels
        var bbBody = _p.bodyBounds = _p.bodyBounds || {};
        assignBoundingBox(bbBody, bounds);
        expandBoundingBoxSides(bbBody, manualExpansion);
        expandBoundingBox(bbBody, 1); // expand to work around browser dimension inaccuracies
        // overlay
        //////////
        if (styleEnabled) {
            ex1 = bounds.x1;
            ex2 = bounds.x2;
            ey1 = bounds.y1;
            ey2 = bounds.y2;
            updateBounds(bounds, ex1 - padding, ey1 - padding, ex2 + padding, ey2 + padding);
        }
        // always store the body bounds separately from the labels
        var bbOverlay = _p.overlayBounds = _p.overlayBounds || {};
        assignBoundingBox(bbOverlay, bounds);
        expandBoundingBoxSides(bbOverlay, manualExpansion);
        expandBoundingBox(bbOverlay, 1); // expand to work around browser dimension inaccuracies
        // handle label dimensions
        //////////////////////////
        var bbLabels = _p.labelBounds = _p.labelBounds || {};
        if (bbLabels.all != null) clearBoundingBox(bbLabels.all);
        else bbLabels.all = makeBoundingBox();
        if (styleEnabled && options.includeLabels) {
            if (options.includeMainLabels) updateBoundsFromLabel(bounds, ele, null);
            if (isEdge) {
                if (options.includeSourceLabels) updateBoundsFromLabel(bounds, ele, 'source');
                if (options.includeTargetLabels) updateBoundsFromLabel(bounds, ele, 'target');
            }
        } // style enabled for labels
    } // if displayed
    bounds.x1 = noninf(bounds.x1);
    bounds.y1 = noninf(bounds.y1);
    bounds.x2 = noninf(bounds.x2);
    bounds.y2 = noninf(bounds.y2);
    bounds.w = noninf(bounds.x2 - bounds.x1);
    bounds.h = noninf(bounds.y2 - bounds.y1);
    if (bounds.w > 0 && bounds.h > 0 && displayed) {
        expandBoundingBoxSides(bounds, manualExpansion);
        // expand bounds by 1 because antialiasing can increase the visual/effective size by 1 on all sides
        expandBoundingBox(bounds, 1);
    }
    return bounds;
};
var getKey = function getKey(opts) {
    var i = 0;
    var tf = function tf(val) {
        return (val ? 1 : 0) << i++;
    };
    var key = 0;
    key += tf(opts.incudeNodes);
    key += tf(opts.includeEdges);
    key += tf(opts.includeLabels);
    key += tf(opts.includeMainLabels);
    key += tf(opts.includeSourceLabels);
    key += tf(opts.includeTargetLabels);
    key += tf(opts.includeOverlays);
    key += tf(opts.includeOutlines);
    return key;
};
var getBoundingBoxPosKey = function getBoundingBoxPosKey(ele) {
    if (ele.isEdge()) {
        var p1 = ele.source().position();
        var p2 = ele.target().position();
        var r = function r(x) {
            return Math.round(x);
        };
        return hashIntsArray([
            r(p1.x),
            r(p1.y),
            r(p2.x),
            r(p2.y)
        ]);
    } else return 0;
};
var cachedBoundingBoxImpl = function cachedBoundingBoxImpl(ele, opts) {
    var _p = ele._private;
    var bb;
    var isEdge = ele.isEdge();
    var key = opts == null ? defBbOptsKey : getKey(opts);
    var usingDefOpts = key === defBbOptsKey;
    var currPosKey = getBoundingBoxPosKey(ele);
    var isPosKeySame = _p.bbCachePosKey === currPosKey;
    var useCache = opts.useCache;
    var isDirty = function isDirty(ele) {
        return ele._private.bbCache == null || ele._private.styleDirty;
    };
    var needRecalc = !useCache || isDirty(ele) || isEdge && (isDirty(ele.source()) || isDirty(ele.target()));
    if (needRecalc) {
        if (!isPosKeySame) ele.recalculateRenderedStyle(useCache);
        bb = boundingBoxImpl(ele, defBbOpts);
        _p.bbCache = bb;
        _p.bbCachePosKey = currPosKey;
    } else bb = _p.bbCache;
    // not using def opts => need to build up bb from combination of sub bbs
    if (!usingDefOpts) {
        var isNode = ele.isNode();
        bb = makeBoundingBox();
        if (opts.includeNodes && isNode || opts.includeEdges && !isNode) {
            if (opts.includeOverlays) updateBoundsFromBox(bb, _p.overlayBounds);
            else updateBoundsFromBox(bb, _p.bodyBounds);
        }
        if (opts.includeLabels) {
            if (opts.includeMainLabels && (!isEdge || opts.includeSourceLabels && opts.includeTargetLabels)) updateBoundsFromBox(bb, _p.labelBounds.all);
            else {
                if (opts.includeMainLabels) updateBoundsFromBox(bb, _p.labelBounds.mainRot);
                if (opts.includeSourceLabels) updateBoundsFromBox(bb, _p.labelBounds.sourceRot);
                if (opts.includeTargetLabels) updateBoundsFromBox(bb, _p.labelBounds.targetRot);
            }
        }
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
    }
    return bb;
};
var defBbOpts = {
    includeNodes: true,
    includeEdges: true,
    includeLabels: true,
    includeMainLabels: true,
    includeSourceLabels: true,
    includeTargetLabels: true,
    includeOverlays: true,
    includeUnderlays: true,
    includeOutlines: true,
    useCache: true
};
var defBbOptsKey = getKey(defBbOpts);
var filledBbOpts = defaults$g(defBbOpts);
elesfn$b.boundingBox = function(options) {
    var bounds;
    // the main usecase is ele.boundingBox() for a single element with no/def options
    // specified s.t. the cache is used, so check for this case to make it faster by
    // avoiding the overhead of the rest of the function
    if (this.length === 1 && this[0]._private.bbCache != null && !this[0]._private.styleDirty && (options === undefined || options.useCache === undefined || options.useCache === true)) {
        if (options === undefined) options = defBbOpts;
        else options = filledBbOpts(options);
        bounds = cachedBoundingBoxImpl(this[0], options);
    } else {
        bounds = makeBoundingBox();
        options = options || defBbOpts;
        var opts = filledBbOpts(options);
        var eles = this;
        var cy = eles.cy();
        var styleEnabled = cy.styleEnabled();
        if (styleEnabled) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var _p = ele._private;
            var currPosKey = getBoundingBoxPosKey(ele);
            var isPosKeySame = _p.bbCachePosKey === currPosKey;
            var useCache = opts.useCache && isPosKeySame && !_p.styleDirty;
            ele.recalculateRenderedStyle(useCache);
        }
        this.updateCompoundBounds(!options.useCache);
        for(var _i = 0; _i < eles.length; _i++){
            var _ele = eles[_i];
            updateBoundsFromBox(bounds, cachedBoundingBoxImpl(_ele, opts));
        }
    }
    bounds.x1 = noninf(bounds.x1);
    bounds.y1 = noninf(bounds.y1);
    bounds.x2 = noninf(bounds.x2);
    bounds.y2 = noninf(bounds.y2);
    bounds.w = noninf(bounds.x2 - bounds.x1);
    bounds.h = noninf(bounds.y2 - bounds.y1);
    return bounds;
};
elesfn$b.dirtyBoundingBoxCache = function() {
    for(var i = 0; i < this.length; i++){
        var _p = this[i]._private;
        _p.bbCache = null;
        _p.bbCachePosKey = null;
        _p.bodyBounds = null;
        _p.overlayBounds = null;
        _p.labelBounds.all = null;
        _p.labelBounds.source = null;
        _p.labelBounds.target = null;
        _p.labelBounds.main = null;
        _p.labelBounds.sourceRot = null;
        _p.labelBounds.targetRot = null;
        _p.labelBounds.mainRot = null;
        _p.arrowBounds.source = null;
        _p.arrowBounds.target = null;
        _p.arrowBounds['mid-source'] = null;
        _p.arrowBounds['mid-target'] = null;
    }
    this.emitAndNotify('bounds');
    return this;
};
// private helper to get bounding box for custom node positions
// - good for perf in certain cases but currently requires dirtying the rendered style
// - would be better to not modify the nodes but the nodes are read directly everywhere in the renderer...
// - try to use for only things like discrete layouts where the node position would change anyway
elesfn$b.boundingBoxAt = function(fn) {
    var nodes = this.nodes();
    var cy = this.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    var parents = cy.collection();
    if (hasCompoundNodes) {
        parents = nodes.filter(function(node) {
            return node.isParent();
        });
        nodes = nodes.not(parents);
    }
    if (plainObject(fn)) {
        var obj = fn;
        fn = function fn() {
            return obj;
        };
    }
    var storeOldPos = function storeOldPos(node, i) {
        return node._private.bbAtOldPos = fn(node, i);
    };
    var getOldPos = function getOldPos(node) {
        return node._private.bbAtOldPos;
    };
    cy.startBatch();
    nodes.forEach(storeOldPos).silentPositions(fn);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    var bb = copyBoundingBox(this.boundingBox({
        useCache: false
    }));
    nodes.silentPositions(getOldPos);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    cy.endBatch();
    return bb;
};
fn$3.boundingbox = fn$3.bb = fn$3.boundingBox;
fn$3.renderedBoundingbox = fn$3.renderedBoundingBox;
var bounds = elesfn$b;
var fn$2, elesfn$a;
fn$2 = elesfn$a = {};
var defineDimFns = function defineDimFns(opts) {
    opts.uppercaseName = capitalize(opts.name);
    opts.autoName = 'auto' + opts.uppercaseName;
    opts.labelName = 'label' + opts.uppercaseName;
    opts.outerName = 'outer' + opts.uppercaseName;
    opts.uppercaseOuterName = capitalize(opts.outerName);
    fn$2[opts.name] = function dimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                if (ele.isParent()) {
                    ele.updateCompoundBounds();
                    return _p[opts.autoName] || 0;
                }
                var d = ele.pstyle(opts.name);
                switch(d.strValue){
                    case 'label':
                        ele.recalculateRenderedStyle();
                        return _p.rstyle[opts.labelName] || 0;
                    default:
                        return d.pfValue;
                }
            } else return 1;
        }
    };
    fn$2['outer' + opts.uppercaseName] = function outerDimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                var dim = ele[opts.name]();
                var border = ele.pstyle('border-width').pfValue; // n.b. 1/2 each side
                var padding = 2 * ele.padding();
                return dim + border + padding;
            } else return 1;
        }
    };
    fn$2['rendered' + opts.uppercaseName] = function renderedDimImpl() {
        var ele = this[0];
        if (ele) {
            var d = ele[opts.name]();
            return d * this.cy().zoom();
        }
    };
    fn$2['rendered' + opts.uppercaseOuterName] = function renderedOuterDimImpl() {
        var ele = this[0];
        if (ele) {
            var od = ele[opts.outerName]();
            return od * this.cy().zoom();
        }
    };
};
defineDimFns({
    name: 'width'
});
defineDimFns({
    name: 'height'
});
elesfn$a.padding = function() {
    var ele = this[0];
    var _p = ele._private;
    if (ele.isParent()) {
        ele.updateCompoundBounds();
        if (_p.autoPadding !== undefined) return _p.autoPadding;
        else return ele.pstyle('padding').pfValue;
    } else return ele.pstyle('padding').pfValue;
};
elesfn$a.paddedHeight = function() {
    var ele = this[0];
    return ele.height() + 2 * ele.padding();
};
elesfn$a.paddedWidth = function() {
    var ele = this[0];
    return ele.width() + 2 * ele.padding();
};
var widthHeight = elesfn$a;
var ifEdge = function ifEdge(ele, getValue) {
    if (ele.isEdge() && ele.takesUpSpace()) return getValue(ele);
};
var ifEdgeRenderedPosition = function ifEdgeRenderedPosition(ele, getPoint) {
    if (ele.isEdge() && ele.takesUpSpace()) {
        var cy = ele.cy();
        return modelToRenderedPosition$1(getPoint(ele), cy.zoom(), cy.pan());
    }
};
var ifEdgeRenderedPositions = function ifEdgeRenderedPositions(ele, getPoints) {
    if (ele.isEdge() && ele.takesUpSpace()) {
        var cy = ele.cy();
        var pan = cy.pan();
        var zoom = cy.zoom();
        return getPoints(ele).map(function(p) {
            return modelToRenderedPosition$1(p, zoom, pan);
        });
    }
};
var controlPoints = function controlPoints(ele) {
    return ele.renderer().getControlPoints(ele);
};
var segmentPoints = function segmentPoints(ele) {
    return ele.renderer().getSegmentPoints(ele);
};
var sourceEndpoint = function sourceEndpoint(ele) {
    return ele.renderer().getSourceEndpoint(ele);
};
var targetEndpoint = function targetEndpoint(ele) {
    return ele.renderer().getTargetEndpoint(ele);
};
var midpoint = function midpoint(ele) {
    return ele.renderer().getEdgeMidpoint(ele);
};
var pts = {
    controlPoints: {
        get: controlPoints,
        mult: true
    },
    segmentPoints: {
        get: segmentPoints,
        mult: true
    },
    sourceEndpoint: {
        get: sourceEndpoint
    },
    targetEndpoint: {
        get: targetEndpoint
    },
    midpoint: {
        get: midpoint
    }
};
var renderedName = function renderedName(name) {
    return 'rendered' + name[0].toUpperCase() + name.substr(1);
};
var edgePoints = Object.keys(pts).reduce(function(obj, name) {
    var spec = pts[name];
    var rName = renderedName(name);
    obj[name] = function() {
        return ifEdge(this, spec.get);
    };
    if (spec.mult) obj[rName] = function() {
        return ifEdgeRenderedPositions(this, spec.get);
    };
    else obj[rName] = function() {
        return ifEdgeRenderedPosition(this, spec.get);
    };
    return obj;
}, {});
var dimensions = extend({}, position, bounds, widthHeight, edgePoints);
/*!
Event object based on jQuery events, MIT license

https://jquery.org/license/
https://tldrlegal.com/license/mit-license
https://github.com/jquery/jquery/blob/master/src/event.js
*/ var Event = function Event(src, props) {
    this.recycle(src, props);
};
function returnFalse() {
    return false;
}
function returnTrue() {
    return true;
}
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
Event.prototype = {
    instanceString: function instanceString() {
        return 'event';
    },
    recycle: function recycle(src, props) {
        this.isImmediatePropagationStopped = this.isPropagationStopped = this.isDefaultPrevented = returnFalse;
        if (src != null && src.preventDefault) {
            // Browser Event object
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
        } else if (src != null && src.type) // Plain object containing all event details
        props = src;
        else // Event string
        this.type = src;
        // Put explicitly provided properties onto the event object
        if (props != null) {
            // more efficient to manually copy fields we use
            this.originalEvent = props.originalEvent;
            this.type = props.type != null ? props.type : this.type;
            this.cy = props.cy;
            this.target = props.target;
            this.position = props.position;
            this.renderedPosition = props.renderedPosition;
            this.namespace = props.namespace;
            this.layout = props.layout;
        }
        if (this.cy != null && this.position != null && this.renderedPosition == null) {
            // create a rendered position based on the passed position
            var pos = this.position;
            var zoom = this.cy.zoom();
            var pan = this.cy.pan();
            this.renderedPosition = {
                x: pos.x * zoom + pan.x,
                y: pos.y * zoom + pan.y
            };
        }
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
    },
    preventDefault: function preventDefault() {
        this.isDefaultPrevented = returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if preventDefault exists run it on the original event
        if (e.preventDefault) e.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        this.isPropagationStopped = returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if stopPropagation exists run it on the original event
        if (e.stopPropagation) e.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = returnTrue;
        this.stopPropagation();
    },
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse
};
var eventRegex = /^([^.]+)(\.(?:[^.]+))?$/; // regex for matching event strings (e.g. "click.namespace")
var universalNamespace = '.*'; // matches as if no namespace specified and prevents users from unbinding accidentally
var defaults$8 = {
    qualifierCompare: function qualifierCompare(q1, q2) {
        return q1 === q2;
    },
    eventMatches: function eventMatches() {
        return true;
    },
    addEventFields: function addEventFields() {},
    callbackContext: function callbackContext(context /*, listener, eventObj*/ ) {
        return context;
    },
    beforeEmit: function beforeEmit() {},
    afterEmit: function afterEmit() {},
    bubble: function bubble() {
        return false;
    },
    parent: function parent() {
        return null;
    },
    context: null
};
var defaultsKeys = Object.keys(defaults$8);
var emptyOpts = {};
function Emitter() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyOpts;
    var context = arguments.length > 1 ? arguments[1] : undefined;
    // micro-optimisation vs Object.assign() -- reduces Element instantiation time
    for(var i = 0; i < defaultsKeys.length; i++){
        var key = defaultsKeys[i];
        this[key] = opts[key] || defaults$8[key];
    }
    this.context = context || this.context;
    this.listeners = [];
    this.emitting = 0;
}
var p = Emitter.prototype;
var forEachEvent = function forEachEvent(self1, handler, events, qualifier, callback, conf, confOverrides) {
    if (fn$6(qualifier)) {
        callback = qualifier;
        qualifier = null;
    }
    if (confOverrides) {
        if (conf == null) conf = confOverrides;
        else conf = extend({}, conf, confOverrides);
    }
    var eventList = array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if (emptyString(evt)) continue;
        var match = evt.match(eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var ret = handler(self1, evt, type, namespace, qualifier, callback, conf);
            if (ret === false) break;
             // allow exiting early
        }
    }
};
var makeEventObj = function makeEventObj(self1, obj) {
    self1.addEventFields(self1.context, obj);
    return new Event(obj.type, obj);
};
var forEachEventObj = function forEachEventObj(self1, handler, events) {
    if (event(events)) {
        handler(self1, events);
        return;
    } else if (plainObject(events)) {
        handler(self1, makeEventObj(self1, events));
        return;
    }
    var eventList = array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if (emptyString(evt)) continue;
        var match = evt.match(eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var eventObj = makeEventObj(self1, {
                type: type,
                namespace: namespace,
                target: self1.context
            });
            handler(self1, eventObj);
        }
    }
};
p.on = p.addListener = function(events, qualifier, callback, conf, confOverrides) {
    forEachEvent(this, function(self1, event, type, namespace, qualifier, callback, conf) {
        if (fn$6(callback)) self1.listeners.push({
            event: event,
            // full event string
            callback: callback,
            // callback to run
            type: type,
            // the event type (e.g. 'click')
            namespace: namespace,
            // the event namespace (e.g. ".foo")
            qualifier: qualifier,
            // a restriction on whether to match this emitter
            conf: conf // additional configuration
        });
    }, events, qualifier, callback, conf, confOverrides);
    return this;
};
p.one = function(events, qualifier, callback, conf) {
    return this.on(events, qualifier, callback, conf, {
        one: true
    });
};
p.removeListener = p.off = function(events, qualifier, callback, conf) {
    var _this = this;
    if (this.emitting !== 0) this.listeners = copyArray(this.listeners);
    var listeners = this.listeners;
    var _loop = function _loop(i) {
        var listener = listeners[i];
        forEachEvent(_this, function(self1, event, type, namespace, qualifier, callback /*, conf*/ ) {
            if ((listener.type === type || events === '*') && (!namespace && listener.namespace !== '.*' || listener.namespace === namespace) && (!qualifier || self1.qualifierCompare(listener.qualifier, qualifier)) && (!callback || listener.callback === callback)) {
                listeners.splice(i, 1);
                return false;
            }
        }, events, qualifier, callback, conf);
    };
    for(var i = listeners.length - 1; i >= 0; i--)_loop(i);
    return this;
};
p.removeAllListeners = function() {
    return this.removeListener('*');
};
p.emit = p.trigger = function(events, extraParams, manualCallback) {
    var listeners = this.listeners;
    var numListenersBeforeEmit = listeners.length;
    this.emitting++;
    if (!array(extraParams)) extraParams = [
        extraParams
    ];
    forEachEventObj(this, function(self1, eventObj) {
        if (manualCallback != null) {
            listeners = [
                {
                    event: eventObj.event,
                    type: eventObj.type,
                    namespace: eventObj.namespace,
                    callback: manualCallback
                }
            ];
            numListenersBeforeEmit = listeners.length;
        }
        var _loop2 = function _loop2() {
            var listener = listeners[i];
            if (listener.type === eventObj.type && (!listener.namespace || listener.namespace === eventObj.namespace || listener.namespace === universalNamespace) && self1.eventMatches(self1.context, listener, eventObj)) {
                var args = [
                    eventObj
                ];
                if (extraParams != null) push(args, extraParams);
                self1.beforeEmit(self1.context, listener, eventObj);
                if (listener.conf && listener.conf.one) self1.listeners = self1.listeners.filter(function(l) {
                    return l !== listener;
                });
                var context = self1.callbackContext(self1.context, listener, eventObj);
                var ret = listener.callback.apply(context, args);
                self1.afterEmit(self1.context, listener, eventObj);
                if (ret === false) {
                    eventObj.stopPropagation();
                    eventObj.preventDefault();
                }
            } // if listener matches
        };
        for(var i = 0; i < numListenersBeforeEmit; i++)_loop2();
         // for listener
        if (self1.bubble(self1.context) && !eventObj.isPropagationStopped()) self1.parent(self1.context).emit(eventObj, extraParams);
    }, events);
    this.emitting--;
    return this;
};
var emitterOptions$1 = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(ele, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return ele !== eventObj.target && element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(ele, evt) {
        evt.cy = ele.cy();
        evt.target = ele;
    },
    callbackContext: function callbackContext(ele, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : ele;
    },
    beforeEmit: function beforeEmit(context, listener /*, eventObj*/ ) {
        if (listener.conf && listener.conf.once) listener.conf.onceCollection.removeListener(listener.event, listener.qualifier, listener.callback);
    },
    bubble: function bubble() {
        return true;
    },
    parent: function parent(ele) {
        return ele.isChild() ? ele.parent() : ele.cy();
    }
};
var argSelector$1 = function argSelector(arg) {
    if (string(arg)) return new Selector(arg);
    else return arg;
};
var elesfn$9 = {
    createEmitter: function createEmitter() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _p = ele._private;
            if (!_p.emitter) _p.emitter = new Emitter(emitterOptions$1, ele);
        }
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        var argSel = argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback);
        }
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        var argSel = argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeListener(events, argSel, callback);
        }
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeAllListeners();
        }
        return this;
    },
    one: function one(events, selector, callback) {
        var argSel = argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().one(events, argSel, callback);
        }
        return this;
    },
    once: function once(events, selector, callback) {
        var argSel = argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback, {
                once: true,
                onceCollection: this
            });
        }
    },
    emit: function emit(events, extraParams) {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().emit(events, extraParams);
        }
        return this;
    },
    emitAndNotify: function emitAndNotify(event, extraParams) {
        // for internal use only
        if (this.length === 0) return;
         // empty collections don't need to notify anything
        // notify renderer
        this.cy().notify(event, this);
        this.emit(event, extraParams);
        return this;
    }
};
define.eventAliasesOn(elesfn$9);
var elesfn$8 = {
    nodes: function nodes(selector) {
        return this.filter(function(ele) {
            return ele.isNode();
        }).filter(selector);
    },
    edges: function edges(selector) {
        return this.filter(function(ele) {
            return ele.isEdge();
        }).filter(selector);
    },
    // internal helper to get nodes and edges as separate collections with single iteration over elements
    byGroup: function byGroup() {
        var nodes = this.spawn();
        var edges = this.spawn();
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele.isNode()) nodes.push(ele);
            else edges.push(ele);
        }
        return {
            nodes: nodes,
            edges: edges
        };
    },
    filter: function filter(_filter, thisArg) {
        if (_filter === undefined) // check this first b/c it's the most common/performant case
        return this;
        else if (string(_filter) || elementOrCollection(_filter)) return new Selector(_filter).filter(this);
        else if (fn$6(_filter)) {
            var filterEles = this.spawn();
            var eles = this;
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                var include = thisArg ? _filter.apply(thisArg, [
                    ele,
                    i,
                    eles
                ]) : _filter(ele, i, eles);
                if (include) filterEles.push(ele);
            }
            return filterEles;
        }
        return this.spawn(); // if not handled by above, give 'em an empty collection
    },
    not: function not(toRemove) {
        if (!toRemove) return this;
        else {
            if (string(toRemove)) toRemove = this.filter(toRemove);
            var elements = this.spawn();
            for(var i = 0; i < this.length; i++){
                var element = this[i];
                var remove = toRemove.has(element);
                if (!remove) elements.push(element);
            }
            return elements;
        }
    },
    absoluteComplement: function absoluteComplement() {
        var cy = this.cy();
        return cy.mutableElements().not(this);
    },
    intersect: function intersect(other) {
        // if a selector is specified, then filter by it instead
        if (string(other)) {
            var selector = other;
            return this.filter(selector);
        }
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var col1Smaller = this.length < other.length;
        var colS = col1Smaller ? col1 : col2;
        var colL = col1Smaller ? col2 : col1;
        for(var i = 0; i < colS.length; i++){
            var ele = colS[i];
            if (colL.has(ele)) elements.push(ele);
        }
        return elements;
    },
    xor: function xor(other) {
        var cy = this._private.cy;
        if (string(other)) other = cy.$(other);
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (!inOther) elements.push(ele);
            }
        };
        add(col1, col2);
        add(col2, col1);
        return elements;
    },
    diff: function diff(other) {
        var cy = this._private.cy;
        if (string(other)) other = cy.$(other);
        var left = this.spawn();
        var right = this.spawn();
        var both = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other, retEles) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (inOther) both.merge(ele);
                else retEles.push(ele);
            }
        };
        add(col1, col2, left);
        add(col2, col1, right);
        return {
            left: left,
            right: right,
            both: both
        };
    },
    add: function add(toAdd) {
        var cy = this._private.cy;
        if (!toAdd) return this;
        if (string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var elements = this.spawnSelf();
        for(var i = 0; i < toAdd.length; i++){
            var ele = toAdd[i];
            var add = !this.has(ele);
            if (add) elements.push(ele);
        }
        return elements;
    },
    // in place merge on calling collection
    merge: function merge(toAdd) {
        var _p = this._private;
        var cy = _p.cy;
        if (!toAdd) return this;
        if (toAdd && string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var map = _p.map;
        for(var i = 0; i < toAdd.length; i++){
            var toAddEle = toAdd[i];
            var id = toAddEle._private.data.id;
            var add = !map.has(id);
            if (add) {
                var index = this.length++;
                this[index] = toAddEle;
                map.set(id, {
                    ele: toAddEle,
                    index: index
                });
            }
        }
        return this; // chaining
    },
    unmergeAt: function unmergeAt(i) {
        var ele = this[i];
        var id = ele.id();
        var _p = this._private;
        var map = _p.map;
        // remove ele
        this[i] = undefined;
        map["delete"](id);
        var unmergedLastEle = i === this.length - 1;
        // replace empty spot with last ele in collection
        if (this.length > 1 && !unmergedLastEle) {
            var lastEleI = this.length - 1;
            var lastEle = this[lastEleI];
            var lastEleId = lastEle._private.data.id;
            this[lastEleI] = undefined;
            this[i] = lastEle;
            map.set(lastEleId, {
                ele: lastEle,
                index: i
            });
        }
        // the collection is now 1 ele smaller
        this.length--;
        return this;
    },
    // remove single ele in place in calling collection
    unmergeOne: function unmergeOne(ele) {
        ele = ele[0];
        var _p = this._private;
        var id = ele._private.data.id;
        var map = _p.map;
        var entry = map.get(id);
        if (!entry) return this; // no need to remove
        var i = entry.index;
        this.unmergeAt(i);
        return this;
    },
    // remove eles in place on calling collection
    unmerge: function unmerge(toRemove) {
        var cy = this._private.cy;
        if (!toRemove) return this;
        if (toRemove && string(toRemove)) {
            var selector = toRemove;
            toRemove = cy.mutableElements().filter(selector);
        }
        for(var i = 0; i < toRemove.length; i++)this.unmergeOne(toRemove[i]);
        return this; // chaining
    },
    unmergeBy: function unmergeBy(toRmFn) {
        for(var i = this.length - 1; i >= 0; i--){
            var ele = this[i];
            if (toRmFn(ele)) this.unmergeAt(i);
        }
        return this;
    },
    map: function map(mapFn, thisArg) {
        var arr = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var ret = thisArg ? mapFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : mapFn(ele, i, eles);
            arr.push(ret);
        }
        return arr;
    },
    reduce: function reduce(fn, initialValue) {
        var val = initialValue;
        var eles = this;
        for(var i = 0; i < eles.length; i++)val = fn(val, eles[i], i, eles);
        return val;
    },
    max: function max(valFn, thisArg) {
        var max = -Infinity;
        var maxEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val > max) {
                max = val;
                maxEle = ele;
            }
        }
        return {
            value: max,
            ele: maxEle
        };
    },
    min: function min(valFn, thisArg) {
        var min = Infinity;
        var minEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val < min) {
                min = val;
                minEle = ele;
            }
        }
        return {
            value: min,
            ele: minEle
        };
    }
};
// aliases
var fn$1 = elesfn$8;
fn$1['u'] = fn$1['|'] = fn$1['+'] = fn$1.union = fn$1.or = fn$1.add;
fn$1['\\'] = fn$1['!'] = fn$1['-'] = fn$1.difference = fn$1.relativeComplement = fn$1.subtract = fn$1.not;
fn$1['n'] = fn$1['&'] = fn$1['.'] = fn$1.and = fn$1.intersection = fn$1.intersect;
fn$1['^'] = fn$1['(+)'] = fn$1['(-)'] = fn$1.symmetricDifference = fn$1.symdiff = fn$1.xor;
fn$1.fnFilter = fn$1.filterFn = fn$1.stdFilter = fn$1.filter;
fn$1.complement = fn$1.abscomp = fn$1.absoluteComplement;
var elesfn$7 = {
    isNode: function isNode() {
        return this.group() === 'nodes';
    },
    isEdge: function isEdge() {
        return this.group() === 'edges';
    },
    isLoop: function isLoop() {
        return this.isEdge() && this.source()[0] === this.target()[0];
    },
    isSimple: function isSimple() {
        return this.isEdge() && this.source()[0] !== this.target()[0];
    },
    group: function group() {
        var ele = this[0];
        if (ele) return ele._private.group;
    }
};
/**
 *  Elements are drawn in a specific order based on compound depth (low to high), the element type (nodes above edges),
 *  and z-index (low to high).  These styles affect how this applies:
 *
 *  z-compound-depth: May be `bottom | orphan | auto | top`.  The first drawn is `bottom`, then `orphan` which is the
 *      same depth as the root of the compound graph, followed by the default value `auto` which draws in order from
 *      root to leaves of the compound graph.  The last drawn is `top`.
 *  z-index-compare: May be `auto | manual`.  The default value is `auto` which always draws edges under nodes.
 *      `manual` ignores this convention and draws based on the `z-index` value setting.
 *  z-index: An integer value that affects the relative draw order of elements.  In general, an element with a higher
 *      `z-index` will be drawn on top of an element with a lower `z-index`.
 */ var zIndexSort = function zIndexSort(a, b) {
    var cy = a.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    function getDepth(ele) {
        var style = ele.pstyle('z-compound-depth');
        if (style.value === 'auto') return hasCompoundNodes ? ele.zDepth() : 0;
        else if (style.value === 'bottom') return -1;
        else if (style.value === 'top') return MAX_INT$1;
        // 'orphan'
        return 0;
    }
    var depthDiff = getDepth(a) - getDepth(b);
    if (depthDiff !== 0) return depthDiff;
    function getEleDepth(ele) {
        var style = ele.pstyle('z-index-compare');
        if (style.value === 'auto') return ele.isNode() ? 1 : 0;
        // 'manual'
        return 0;
    }
    var eleDiff = getEleDepth(a) - getEleDepth(b);
    if (eleDiff !== 0) return eleDiff;
    var zDiff = a.pstyle('z-index').value - b.pstyle('z-index').value;
    if (zDiff !== 0) return zDiff;
    // compare indices in the core (order added to graph w/ last on top)
    return a.poolIndex() - b.poolIndex();
};
var elesfn$6 = {
    forEach: function forEach(fn, thisArg) {
        if (fn$6(fn)) {
            var N = this.length;
            for(var i = 0; i < N; i++){
                var ele = this[i];
                var ret = thisArg ? fn.apply(thisArg, [
                    ele,
                    i,
                    this
                ]) : fn(ele, i, this);
                if (ret === false) break;
                 // exit each early on return false
            }
        }
        return this;
    },
    toArray: function toArray() {
        var array = [];
        for(var i = 0; i < this.length; i++)array.push(this[i]);
        return array;
    },
    slice: function slice(start, end) {
        var array = [];
        var thisSize = this.length;
        if (end == null) end = thisSize;
        if (start == null) start = 0;
        if (start < 0) start = thisSize + start;
        if (end < 0) end = thisSize + end;
        for(var i = start; i >= 0 && i < end && i < thisSize; i++)array.push(this[i]);
        return this.spawn(array);
    },
    size: function size() {
        return this.length;
    },
    eq: function eq(i) {
        return this[i] || this.spawn();
    },
    first: function first() {
        return this[0] || this.spawn();
    },
    last: function last() {
        return this[this.length - 1] || this.spawn();
    },
    empty: function empty() {
        return this.length === 0;
    },
    nonempty: function nonempty() {
        return !this.empty();
    },
    sort: function sort(sortFn) {
        if (!fn$6(sortFn)) return this;
        var sorted = this.toArray().sort(sortFn);
        return this.spawn(sorted);
    },
    sortByZIndex: function sortByZIndex() {
        return this.sort(zIndexSort);
    },
    zDepth: function zDepth() {
        var ele = this[0];
        if (!ele) return undefined;
        // let cy = ele.cy();
        var _p = ele._private;
        var group = _p.group;
        if (group === 'nodes') {
            var depth = _p.data.parent ? ele.parents().size() : 0;
            if (!ele.isParent()) return MAX_INT$1 - 1; // childless nodes always on top
            return depth;
        } else {
            var src = _p.source;
            var tgt = _p.target;
            var srcDepth = src.zDepth();
            var tgtDepth = tgt.zDepth();
            return Math.max(srcDepth, tgtDepth, 0); // depth of deepest parent
        }
    }
};
elesfn$6.each = elesfn$6.forEach;
var defineSymbolIterator = function defineSymbolIterator() {
    var typeofUndef = "undefined";
    var isIteratorSupported = (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) != typeofUndef && _typeof(Symbol.iterator) != typeofUndef;
    if (isIteratorSupported) elesfn$6[Symbol.iterator] = function() {
        var _this = this;
        var entry = {
            value: undefined,
            done: false
        };
        var i = 0;
        var length = this.length;
        return _defineProperty$1({
            next: function next() {
                if (i < length) entry.value = _this[i++];
                else {
                    entry.value = undefined;
                    entry.done = true;
                }
                return entry;
            }
        }, Symbol.iterator, function() {
            return this;
        });
    };
};
defineSymbolIterator();
var getLayoutDimensionOptions = defaults$g({
    nodeDimensionsIncludeLabels: false
});
var elesfn$5 = {
    // Calculates and returns node dimensions { x, y } based on options given
    layoutDimensions: function layoutDimensions(options) {
        options = getLayoutDimensionOptions(options);
        var dims;
        if (!this.takesUpSpace()) dims = {
            w: 0,
            h: 0
        };
        else if (options.nodeDimensionsIncludeLabels) {
            var bbDim = this.boundingBox();
            dims = {
                w: bbDim.w,
                h: bbDim.h
            };
        } else dims = {
            w: this.outerWidth(),
            h: this.outerHeight()
        };
        // sanitise the dimensions for external layouts (avoid division by zero)
        if (dims.w === 0 || dims.h === 0) dims.w = dims.h = 1;
        return dims;
    },
    // using standard layout options, apply position function (w/ or w/o animation)
    layoutPositions: function layoutPositions(layout, options, fn) {
        var nodes = this.nodes().filter(function(n) {
            return !n.isParent();
        });
        var cy = this.cy();
        var layoutEles = options.eles; // nodes & edges
        var getMemoizeKey = function getMemoizeKey(node) {
            return node.id();
        };
        var fnMem = memoize(fn, getMemoizeKey); // memoized version of position function
        layout.emit({
            type: 'layoutstart',
            layout: layout
        });
        layout.animations = [];
        var calculateSpacing = function calculateSpacing(spacing, nodesBb, pos) {
            var center = {
                x: nodesBb.x1 + nodesBb.w / 2,
                y: nodesBb.y1 + nodesBb.h / 2
            };
            var spacingVector = {
                // scale from center of bounding box (not necessarily 0,0)
                x: (pos.x - center.x) * spacing,
                y: (pos.y - center.y) * spacing
            };
            return {
                x: center.x + spacingVector.x,
                y: center.y + spacingVector.y
            };
        };
        var useSpacingFactor = options.spacingFactor && options.spacingFactor !== 1;
        var spacingBb = function spacingBb() {
            if (!useSpacingFactor) return null;
            var bb = makeBoundingBox();
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var pos = fnMem(node, i);
                expandBoundingBoxByPoint(bb, pos.x, pos.y);
            }
            return bb;
        };
        var bb = spacingBb();
        var getFinalPos = memoize(function(node, i) {
            var newPos = fnMem(node, i);
            if (useSpacingFactor) {
                var spacing = Math.abs(options.spacingFactor);
                newPos = calculateSpacing(spacing, bb, newPos);
            }
            if (options.transform != null) newPos = options.transform(node, newPos);
            return newPos;
        }, getMemoizeKey);
        if (options.animate) {
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var newPos = getFinalPos(node, i);
                var animateNode = options.animateFilter == null || options.animateFilter(node, i);
                if (animateNode) {
                    var ani = node.animation({
                        position: newPos,
                        duration: options.animationDuration,
                        easing: options.animationEasing
                    });
                    layout.animations.push(ani);
                } else node.position(newPos);
            }
            if (options.fit) {
                var fitAni = cy.animation({
                    fit: {
                        boundingBox: layoutEles.boundingBoxAt(getFinalPos),
                        padding: options.padding
                    },
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(fitAni);
            } else if (options.zoom !== undefined && options.pan !== undefined) {
                var zoomPanAni = cy.animation({
                    zoom: options.zoom,
                    pan: options.pan,
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(zoomPanAni);
            }
            layout.animations.forEach(function(ani) {
                return ani.play();
            });
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            Promise$1.all(layout.animations.map(function(ani) {
                return ani.promise();
            })).then(function() {
                layout.one('layoutstop', options.stop);
                layout.emit({
                    type: 'layoutstop',
                    layout: layout
                });
            });
        } else {
            nodes.positions(getFinalPos);
            if (options.fit) cy.fit(options.eles, options.padding);
            if (options.zoom != null) cy.zoom(options.zoom);
            if (options.pan) cy.pan(options.pan);
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        }
        return this; // chaining
    },
    layout: function layout(options) {
        var cy = this.cy();
        return cy.makeLayout(extend({}, options, {
            eles: this
        }));
    }
};
// aliases:
elesfn$5.createLayout = elesfn$5.makeLayout = elesfn$5.layout;
function styleCache(key, fn, ele) {
    var _p = ele._private;
    var cache = _p.styleCache = _p.styleCache || [];
    var val;
    if ((val = cache[key]) != null) return val;
    else {
        val = cache[key] = fn(ele);
        return val;
    }
}
function cacheStyleFunction(key, fn) {
    key = hashString(key);
    return function cachedStyleFunction(ele) {
        return styleCache(key, fn, ele);
    };
}
function cachePrototypeStyleFunction(key, fn) {
    key = hashString(key);
    var selfFn = function selfFn(ele) {
        return fn.call(ele);
    };
    return function cachedPrototypeStyleFunction() {
        var ele = this[0];
        if (ele) return styleCache(key, selfFn, ele);
    };
}
var elesfn$4 = {
    recalculateRenderedStyle: function recalculateRenderedStyle(useCache) {
        var cy = this.cy();
        var renderer = cy.renderer();
        var styleEnabled = cy.styleEnabled();
        if (renderer && styleEnabled) renderer.recalculateRenderedStyle(this, useCache);
        return this;
    },
    dirtyStyleCache: function dirtyStyleCache() {
        var cy = this.cy();
        var dirty = function dirty(ele) {
            return ele._private.styleCache = null;
        };
        if (cy.hasCompoundNodes()) {
            var eles;
            eles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
            eles.merge(eles.connectedEdges());
            eles.forEach(dirty);
        } else this.forEach(function(ele) {
            dirty(ele);
            ele.connectedEdges().forEach(dirty);
        });
        return this;
    },
    // fully updates (recalculates) the style for the elements
    updateStyle: function updateStyle(notifyRenderer) {
        var cy = this._private.cy;
        if (!cy.styleEnabled()) return this;
        if (cy.batching()) {
            var bEles = cy._private.batchStyleEles;
            bEles.merge(this);
            return this; // chaining and exit early when batching
        }
        var hasCompounds = cy.hasCompoundNodes();
        var updatedEles = this;
        notifyRenderer = notifyRenderer || notifyRenderer === undefined ? true : false;
        if (hasCompounds) // then add everything up and down for compound selector checks
        updatedEles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
        // let changedEles = style.apply( updatedEles );
        var changedEles = updatedEles;
        if (notifyRenderer) changedEles.emitAndNotify('style'); // let renderer know we changed style
        else changedEles.emit('style'); // just fire the event
        updatedEles.forEach(function(ele) {
            return ele._private.styleDirty = true;
        });
        return this; // chaining
    },
    // private: clears dirty flag and recalculates style
    cleanStyle: function cleanStyle() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
        }
    },
    // get the internal parsed style object for the specified property
    parsedStyle: function parsedStyle(property) {
        var includeNonDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var ele = this[0];
        var cy = ele.cy();
        if (!cy.styleEnabled()) return;
        if (ele) {
            // this.cleanStyle();
            // Inline the important part of cleanStyle(), for raw performance
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
            var overriddenStyle = ele._private.style[property];
            if (overriddenStyle != null) return overriddenStyle;
            else if (includeNonDefault) return cy.style().getDefaultProperty(property);
            else return null;
        }
    },
    numericStyle: function numericStyle(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) {
            var pstyle = ele.pstyle(property);
            return pstyle.pfValue !== undefined ? pstyle.pfValue : pstyle.value;
        }
    },
    numericStyleUnits: function numericStyleUnits(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) return ele.pstyle(property).units;
    },
    // get the specified css property as a rendered value (i.e. on-screen value)
    // or get the whole rendered style if no property specified (NB doesn't allow setting)
    renderedStyle: function renderedStyle(property) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var ele = this[0];
        if (ele) return cy.style().getRenderedStyle(ele, property);
    },
    // read the calculated css style of the element or override the style (via a bypass)
    style: function style(name, value) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        if (plainObject(name)) {
            // then extend the bypass
            var props = name;
            style.applyBypass(this, props, updateTransitions);
            this.emitAndNotify('style'); // let the renderer know we've updated style
        } else if (string(name)) {
            if (value === undefined) {
                // then get the property from the style
                var ele = this[0];
                if (ele) return style.getStylePropertyValue(ele, name);
                else // empty collection => can't get any value
                return;
            } else {
                // then set the bypass with the property value
                style.applyBypass(this, name, value, updateTransitions);
                this.emitAndNotify('style'); // let the renderer know we've updated style
            }
        } else if (name === undefined) {
            var _ele = this[0];
            if (_ele) return style.getRawStyle(_ele);
            else // empty collection => can't get any value
            return;
        }
        return this; // chaining
    },
    removeStyle: function removeStyle(names) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        var eles = this;
        if (names === undefined) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            style.removeAllBypasses(ele, updateTransitions);
        }
        else {
            names = names.split(/\s+/);
            for(var _i = 0; _i < eles.length; _i++){
                var _ele2 = eles[_i];
                style.removeBypasses(_ele2, names, updateTransitions);
            }
        }
        this.emitAndNotify('style'); // let the renderer know we've updated style
        return this; // chaining
    },
    show: function show() {
        this.css('display', 'element');
        return this; // chaining
    },
    hide: function hide() {
        this.css('display', 'none');
        return this; // chaining
    },
    effectiveOpacity: function effectiveOpacity() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return 1;
        var hasCompoundNodes = cy.hasCompoundNodes();
        var ele = this[0];
        if (ele) {
            var _p = ele._private;
            var parentOpacity = ele.pstyle('opacity').value;
            if (!hasCompoundNodes) return parentOpacity;
            var parents = !_p.data.parent ? null : ele.parents();
            if (parents) for(var i = 0; i < parents.length; i++){
                var parent = parents[i];
                var opacity = parent.pstyle('opacity').value;
                parentOpacity = opacity * parentOpacity;
            }
            return parentOpacity;
        }
    },
    transparent: function transparent() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        var hasCompoundNodes = ele.cy().hasCompoundNodes();
        if (ele) {
            if (!hasCompoundNodes) return ele.pstyle('opacity').value === 0;
            else return ele.effectiveOpacity() === 0;
        }
    },
    backgrounding: function backgrounding() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        return ele._private.backgrounding ? true : false;
    }
};
function checkCompound(ele, parentOk) {
    var _p = ele._private;
    var parents = _p.data.parent ? ele.parents() : null;
    if (parents) for(var i = 0; i < parents.length; i++){
        var parent = parents[i];
        if (!parentOk(parent)) return false;
    }
    return true;
}
function defineDerivedStateFunction(specs) {
    var ok = specs.ok;
    var edgeOkViaNode = specs.edgeOkViaNode || specs.ok;
    var parentOk = specs.parentOk || specs.ok;
    return function() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return true;
        var ele = this[0];
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele) {
            var _p = ele._private;
            if (!ok(ele)) return false;
            if (ele.isNode()) return !hasCompoundNodes || checkCompound(ele, parentOk);
            else {
                var src = _p.source;
                var tgt = _p.target;
                return edgeOkViaNode(src) && (!hasCompoundNodes || checkCompound(src, edgeOkViaNode)) && (src === tgt || edgeOkViaNode(tgt) && (!hasCompoundNodes || checkCompound(tgt, edgeOkViaNode)));
            }
        }
    };
}
var eleTakesUpSpace = cacheStyleFunction('eleTakesUpSpace', function(ele) {
    return ele.pstyle('display').value === 'element' && ele.width() !== 0 && (ele.isNode() ? ele.height() !== 0 : true);
});
elesfn$4.takesUpSpace = cachePrototypeStyleFunction('takesUpSpace', defineDerivedStateFunction({
    ok: eleTakesUpSpace
}));
var eleInteractive = cacheStyleFunction('eleInteractive', function(ele) {
    return ele.pstyle('events').value === 'yes' && ele.pstyle('visibility').value === 'visible' && eleTakesUpSpace(ele);
});
var parentInteractive = cacheStyleFunction('parentInteractive', function(parent) {
    return parent.pstyle('visibility').value === 'visible' && eleTakesUpSpace(parent);
});
elesfn$4.interactive = cachePrototypeStyleFunction('interactive', defineDerivedStateFunction({
    ok: eleInteractive,
    parentOk: parentInteractive,
    edgeOkViaNode: eleTakesUpSpace
}));
elesfn$4.noninteractive = function() {
    var ele = this[0];
    if (ele) return !ele.interactive();
};
var eleVisible = cacheStyleFunction('eleVisible', function(ele) {
    return ele.pstyle('visibility').value === 'visible' && ele.pstyle('opacity').pfValue !== 0 && eleTakesUpSpace(ele);
});
var edgeVisibleViaNode = eleTakesUpSpace;
elesfn$4.visible = cachePrototypeStyleFunction('visible', defineDerivedStateFunction({
    ok: eleVisible,
    edgeOkViaNode: edgeVisibleViaNode
}));
elesfn$4.hidden = function() {
    var ele = this[0];
    if (ele) return !ele.visible();
};
elesfn$4.isBundledBezier = cachePrototypeStyleFunction('isBundledBezier', function() {
    if (!this.cy().styleEnabled()) return false;
    return !this.removed() && this.pstyle('curve-style').value === 'bezier' && this.takesUpSpace();
});
elesfn$4.bypass = elesfn$4.css = elesfn$4.style;
elesfn$4.renderedCss = elesfn$4.renderedStyle;
elesfn$4.removeBypass = elesfn$4.removeCss = elesfn$4.removeStyle;
elesfn$4.pstyle = elesfn$4.parsedStyle;
var elesfn$3 = {};
function defineSwitchFunction(params) {
    return function() {
        var args = arguments;
        var changedEles = [];
        // e.g. cy.nodes().select( data, handler )
        if (args.length === 2) {
            var data = args[0];
            var handler = args[1];
            this.on(params.event, data, handler);
        } else if (args.length === 1 && fn$6(args[0])) {
            var _handler = args[0];
            this.on(params.event, _handler);
        } else if (args.length === 0 || args.length === 1 && array(args[0])) {
            var addlEvents = args.length === 1 ? args[0] : null;
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var able = !params.ableField || ele._private[params.ableField];
                var changed = ele._private[params.field] != params.value;
                if (params.overrideAble) {
                    var overrideAble = params.overrideAble(ele);
                    if (overrideAble !== undefined) {
                        able = overrideAble;
                        if (!overrideAble) return this;
                         // to save cycles assume not able for all on override
                    }
                }
                if (able) {
                    ele._private[params.field] = params.value;
                    if (changed) changedEles.push(ele);
                }
            }
            var changedColl = this.spawn(changedEles);
            changedColl.updateStyle(); // change of state => possible change of style
            changedColl.emit(params.event);
            if (addlEvents) changedColl.emit(addlEvents);
        }
        return this;
    };
}
function defineSwitchSet(params) {
    elesfn$3[params.field] = function() {
        var ele = this[0];
        if (ele) {
            if (params.overrideField) {
                var val = params.overrideField(ele);
                if (val !== undefined) return val;
            }
            return ele._private[params.field];
        }
    };
    elesfn$3[params.on] = defineSwitchFunction({
        event: params.on,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: true
    });
    elesfn$3[params.off] = defineSwitchFunction({
        event: params.off,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: false
    });
}
defineSwitchSet({
    field: 'locked',
    overrideField: function overrideField(ele) {
        return ele.cy().autolock() ? true : undefined;
    },
    on: 'lock',
    off: 'unlock'
});
defineSwitchSet({
    field: 'grabbable',
    overrideField: function overrideField(ele) {
        return ele.cy().autoungrabify() || ele.pannable() ? false : undefined;
    },
    on: 'grabify',
    off: 'ungrabify'
});
defineSwitchSet({
    field: 'selected',
    ableField: 'selectable',
    overrideAble: function overrideAble(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'select',
    off: 'unselect'
});
defineSwitchSet({
    field: 'selectable',
    overrideField: function overrideField(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'selectify',
    off: 'unselectify'
});
elesfn$3.deselect = elesfn$3.unselect;
elesfn$3.grabbed = function() {
    var ele = this[0];
    if (ele) return ele._private.grabbed;
};
defineSwitchSet({
    field: 'active',
    on: 'activate',
    off: 'unactivate'
});
defineSwitchSet({
    field: 'pannable',
    on: 'panify',
    off: 'unpanify'
});
elesfn$3.inactive = function() {
    var ele = this[0];
    if (ele) return !ele._private.active;
};
var elesfn$2 = {};
// DAG functions
////////////////
var defineDagExtremity = function defineDagExtremity(params) {
    return function dagExtremityImpl(selector) {
        var eles = this;
        var ret = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var disqualified = false;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.noIncomingEdges && tgt === ele && src !== ele || params.noOutgoingEdges && src === ele && tgt !== ele) {
                    disqualified = true;
                    break;
                }
            }
            if (!disqualified) ret.push(ele);
        }
        return this.spawn(ret, true).filter(selector);
    };
};
var defineDagOneHop = function defineDagOneHop(params) {
    return function(selector) {
        var eles = this;
        var oEles = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.outgoing && src === ele) {
                    oEles.push(edge);
                    oEles.push(tgt);
                } else if (params.incoming && tgt === ele) {
                    oEles.push(edge);
                    oEles.push(src);
                }
            }
        }
        return this.spawn(oEles, true).filter(selector);
    };
};
var defineDagAllHops = function defineDagAllHops(params) {
    return function(selector) {
        var eles = this;
        var sEles = [];
        var sElesIds = {};
        for(;;){
            var next = params.outgoing ? eles.outgoers() : eles.incomers();
            if (next.length === 0) break;
             // done if none left
            var newNext = false;
            for(var i = 0; i < next.length; i++){
                var n = next[i];
                var nid = n.id();
                if (!sElesIds[nid]) {
                    sElesIds[nid] = true;
                    sEles.push(n);
                    newNext = true;
                }
            }
            if (!newNext) break;
             // done if touched all outgoers already
            eles = next;
        }
        return this.spawn(sEles, true).filter(selector);
    };
};
elesfn$2.clearTraversalCache = function() {
    for(var i = 0; i < this.length; i++)this[i]._private.traversalCache = null;
};
extend(elesfn$2, {
    // get the root nodes in the DAG
    roots: defineDagExtremity({
        noIncomingEdges: true
    }),
    // get the leaf nodes in the DAG
    leaves: defineDagExtremity({
        noOutgoingEdges: true
    }),
    // normally called children in graph theory
    // these nodes =edges=> outgoing nodes
    outgoers: cache(defineDagOneHop({
        outgoing: true
    }), 'outgoers'),
    // aka DAG descendants
    successors: defineDagAllHops({
        outgoing: true
    }),
    // normally called parents in graph theory
    // these nodes <=edges= incoming nodes
    incomers: cache(defineDagOneHop({
        incoming: true
    }), 'incomers'),
    // aka DAG ancestors
    predecessors: defineDagAllHops({})
});
// Neighbourhood functions
//////////////////////////
extend(elesfn$2, {
    neighborhood: cache(function(selector) {
        var elements = [];
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            // for all nodes
            var node = nodes[i];
            var connectedEdges = node.connectedEdges();
            // for each connected edge, add the edge and the other node
            for(var j = 0; j < connectedEdges.length; j++){
                var edge = connectedEdges[j];
                var src = edge.source();
                var tgt = edge.target();
                var otherNode = node === src ? tgt : src;
                // need check in case of loop
                if (otherNode.length > 0) elements.push(otherNode[0]); // add node 1 hop away
                // add connected edge
                elements.push(edge[0]);
            }
        }
        return this.spawn(elements, true).filter(selector);
    }, 'neighborhood'),
    closedNeighborhood: function closedNeighborhood(selector) {
        return this.neighborhood().add(this).filter(selector);
    },
    openNeighborhood: function openNeighborhood(selector) {
        return this.neighborhood(selector);
    }
});
// aliases
elesfn$2.neighbourhood = elesfn$2.neighborhood;
elesfn$2.closedNeighbourhood = elesfn$2.closedNeighborhood;
elesfn$2.openNeighbourhood = elesfn$2.openNeighborhood;
// Edge functions
/////////////////
extend(elesfn$2, {
    source: cache(function sourceImpl(selector) {
        var ele = this[0];
        var src;
        if (ele) src = ele._private.source || ele.cy().collection();
        return src && selector ? src.filter(selector) : src;
    }, 'source'),
    target: cache(function targetImpl(selector) {
        var ele = this[0];
        var tgt;
        if (ele) tgt = ele._private.target || ele.cy().collection();
        return tgt && selector ? tgt.filter(selector) : tgt;
    }, 'target'),
    sources: defineSourceFunction({
        attr: 'source'
    }),
    targets: defineSourceFunction({
        attr: 'target'
    })
});
function defineSourceFunction(params) {
    return function sourceImpl(selector) {
        var sources = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var src = ele._private[params.attr];
            if (src) sources.push(src);
        }
        return this.spawn(sources, true).filter(selector);
    };
}
extend(elesfn$2, {
    edgesWith: cache(defineEdgesWithFunction(), 'edgesWith'),
    edgesTo: cache(defineEdgesWithFunction({
        thisIsSrc: true
    }), 'edgesTo')
});
function defineEdgesWithFunction(params) {
    return function edgesWithImpl(otherNodes) {
        var elements = [];
        var cy = this._private.cy;
        var p = params || {};
        // get elements if a selector is specified
        if (string(otherNodes)) otherNodes = cy.$(otherNodes);
        for(var h = 0; h < otherNodes.length; h++){
            var edges = otherNodes[h]._private.edges;
            for(var i = 0; i < edges.length; i++){
                var edge = edges[i];
                var edgeData = edge._private.data;
                var thisToOther = this.hasElementWithId(edgeData.source) && otherNodes.hasElementWithId(edgeData.target);
                var otherToThis = otherNodes.hasElementWithId(edgeData.source) && this.hasElementWithId(edgeData.target);
                var edgeConnectsThisAndOther = thisToOther || otherToThis;
                if (!edgeConnectsThisAndOther) continue;
                if (p.thisIsSrc || p.thisIsTgt) {
                    if (p.thisIsSrc && !thisToOther) continue;
                    if (p.thisIsTgt && !otherToThis) continue;
                }
                elements.push(edge);
            }
        }
        return this.spawn(elements, true);
    };
}
extend(elesfn$2, {
    connectedEdges: cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var node = eles[i];
            if (!node.isNode()) continue;
            var edges = node._private.edges;
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                retEles.push(edge);
            }
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedEdges'),
    connectedNodes: cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var edge = eles[i];
            if (!edge.isEdge()) continue;
            retEles.push(edge.source()[0]);
            retEles.push(edge.target()[0]);
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedNodes'),
    parallelEdges: cache(defineParallelEdgesFunction(), 'parallelEdges'),
    codirectedEdges: cache(defineParallelEdgesFunction({
        codirected: true
    }), 'codirectedEdges')
});
function defineParallelEdgesFunction(params) {
    var defaults = {
        codirected: false
    };
    params = extend({}, defaults, params);
    return function parallelEdgesImpl(selector) {
        // micro-optimised for renderer
        var elements = [];
        var edges = this.edges();
        var p = params;
        // look at all the edges in the collection
        for(var i = 0; i < edges.length; i++){
            var edge1 = edges[i];
            var edge1_p = edge1._private;
            var src1 = edge1_p.source;
            var srcid1 = src1._private.data.id;
            var tgtid1 = edge1_p.data.target;
            var srcEdges1 = src1._private.edges;
            // look at edges connected to the src node of this edge
            for(var j = 0; j < srcEdges1.length; j++){
                var edge2 = srcEdges1[j];
                var edge2data = edge2._private.data;
                var tgtid2 = edge2data.target;
                var srcid2 = edge2data.source;
                var codirected = tgtid2 === tgtid1 && srcid2 === srcid1;
                var oppdirected = srcid1 === tgtid2 && tgtid1 === srcid2;
                if (p.codirected && codirected || !p.codirected && (codirected || oppdirected)) elements.push(edge2);
            }
        }
        return this.spawn(elements, true).filter(selector);
    };
}
// Misc functions
/////////////////
extend(elesfn$2, {
    components: function components(root) {
        var self1 = this;
        var cy = self1.cy();
        var visited = cy.collection();
        var unvisited = root == null ? self1.nodes() : root.nodes();
        var components = [];
        if (root != null && unvisited.empty()) // root may contain only edges
        unvisited = root.sources(); // doesn't matter which node to use (undirected), so just use the source sides
        var visitInComponent = function visitInComponent(node, component) {
            visited.merge(node);
            unvisited.unmerge(node);
            component.merge(node);
        };
        if (unvisited.empty()) return self1.spawn();
        var _loop = function _loop() {
            // each iteration yields a component
            var cmpt = cy.collection();
            components.push(cmpt);
            var root = unvisited[0];
            visitInComponent(root, cmpt);
            self1.bfs({
                directed: false,
                roots: root,
                visit: function visit(v) {
                    return visitInComponent(v, cmpt);
                }
            });
            cmpt.forEach(function(node) {
                node.connectedEdges().forEach(function(e) {
                    // connectedEdges() usually cached
                    if (self1.has(e) && cmpt.has(e.source()) && cmpt.has(e.target())) // has() is cheap
                    cmpt.merge(e); // forEach() only considers nodes -- sets N at call time
                });
            });
        };
        do _loop();
        while (unvisited.length > 0);
        return components;
    },
    component: function component() {
        var ele = this[0];
        return ele.cy().mutableElements().components(ele)[0];
    }
});
elesfn$2.componentsOf = elesfn$2.components;
// represents a set of nodes, edges, or both together
var Collection = function Collection(cy, elements) {
    var unique = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var removed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (cy === undefined) {
        error('A collection must have a reference to the core');
        return;
    }
    var map = new Map$1();
    var createdElements = false;
    if (!elements) elements = [];
    else if (elements.length > 0 && plainObject(elements[0]) && !element(elements[0])) {
        createdElements = true;
        // make elements from json and restore all at once later
        var eles = [];
        var elesIds = new Set$1();
        for(var i = 0, l = elements.length; i < l; i++){
            var json = elements[i];
            if (json.data == null) json.data = {};
            var _data = json.data;
            // make sure newly created elements have valid ids
            if (_data.id == null) _data.id = uuid();
            else if (cy.hasElementWithId(_data.id) || elesIds.has(_data.id)) continue; // can't create element if prior id already exists
            var ele = new Element(cy, json, false);
            eles.push(ele);
            elesIds.add(_data.id);
        }
        elements = eles;
    }
    this.length = 0;
    for(var _i = 0, _l = elements.length; _i < _l; _i++){
        var element$1 = elements[_i][0]; // [0] in case elements is an array of collections, rather than array of elements
        if (element$1 == null) continue;
        var id = element$1._private.data.id;
        if (!unique || !map.has(id)) {
            if (unique) map.set(id, {
                index: this.length,
                ele: element$1
            });
            this[this.length] = element$1;
            this.length++;
        }
    }
    this._private = {
        eles: this,
        cy: cy,
        get map () {
            if (this.lazyMap == null) this.rebuildMap();
            return this.lazyMap;
        },
        set map (m){
            this.lazyMap = m;
        },
        rebuildMap: function rebuildMap() {
            var m1 = this.lazyMap = new Map$1();
            var eles = this.eles;
            for(var _i2 = 0; _i2 < eles.length; _i2++){
                var _ele = eles[_i2];
                m1.set(_ele.id(), {
                    index: _i2,
                    ele: _ele
                });
            }
        }
    };
    if (unique) this._private.map = map;
    // restore the elements if we created them from json
    if (createdElements && !removed) this.restore();
};
// Functions
////////////////////////////////////////////////////////////////////////////////////////////////////
// keep the prototypes in sync (an element has the same functions as a collection)
// and use elefn and elesfn as shorthands to the prototypes
var elesfn$1 = Element.prototype = Collection.prototype = Object.create(Array.prototype);
elesfn$1.instanceString = function() {
    return 'collection';
};
elesfn$1.spawn = function(eles, unique) {
    return new Collection(this.cy(), eles, unique);
};
elesfn$1.spawnSelf = function() {
    return this.spawn(this);
};
elesfn$1.cy = function() {
    return this._private.cy;
};
elesfn$1.renderer = function() {
    return this._private.cy.renderer();
};
elesfn$1.element = function() {
    return this[0];
};
elesfn$1.collection = function() {
    if (collection(this)) return this;
    else // an element
    return new Collection(this._private.cy, [
        this
    ]);
};
elesfn$1.unique = function() {
    return new Collection(this._private.cy, this, true);
};
elesfn$1.hasElementWithId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.has(id);
};
elesfn$1.getElementById = function(id) {
    id = '' + id; // id must be string
    var cy = this._private.cy;
    var entry = this._private.map.get(id);
    return entry ? entry.ele : new Collection(cy); // get ele or empty collection
};
elesfn$1.$id = elesfn$1.getElementById;
elesfn$1.poolIndex = function() {
    var cy = this._private.cy;
    var eles = cy._private.elements;
    var id = this[0]._private.data.id;
    return eles._private.map.get(id).index;
};
elesfn$1.indexOf = function(ele) {
    var id = ele[0]._private.data.id;
    return this._private.map.get(id).index;
};
elesfn$1.indexOfId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.get(id).index;
};
elesfn$1.json = function(obj) {
    var ele = this.element();
    var cy = this.cy();
    if (ele == null && obj) return this;
     // can't set to no eles
    if (ele == null) return undefined;
     // can't get from no eles
    var p = ele._private;
    if (plainObject(obj)) {
        // set
        cy.startBatch();
        if (obj.data) {
            ele.data(obj.data);
            var _data2 = p.data;
            if (ele.isEdge()) {
                // source and target are immutable via data()
                var move = false;
                var spec = {};
                var src = obj.data.source;
                var tgt = obj.data.target;
                if (src != null && src != _data2.source) {
                    spec.source = '' + src; // id must be string
                    move = true;
                }
                if (tgt != null && tgt != _data2.target) {
                    spec.target = '' + tgt; // id must be string
                    move = true;
                }
                if (move) ele = ele.move(spec);
            } else {
                // parent is immutable via data()
                var newParentValSpecd = 'parent' in obj.data;
                var parent = obj.data.parent;
                if (newParentValSpecd && (parent != null || _data2.parent != null) && parent != _data2.parent) {
                    if (parent === undefined) // can't set undefined imperatively, so use null
                    parent = null;
                    if (parent != null) parent = '' + parent; // id must be string
                    ele = ele.move({
                        parent: parent
                    });
                }
            }
        }
        if (obj.position) ele.position(obj.position);
        // ignore group -- immutable
        var checkSwitch = function checkSwitch(k, trueFnName, falseFnName) {
            var obj_k = obj[k];
            if (obj_k != null && obj_k !== p[k]) {
                if (obj_k) ele[trueFnName]();
                else ele[falseFnName]();
            }
        };
        checkSwitch('removed', 'remove', 'restore');
        checkSwitch('selected', 'select', 'unselect');
        checkSwitch('selectable', 'selectify', 'unselectify');
        checkSwitch('locked', 'lock', 'unlock');
        checkSwitch('grabbable', 'grabify', 'ungrabify');
        checkSwitch('pannable', 'panify', 'unpanify');
        if (obj.classes != null) ele.classes(obj.classes);
        cy.endBatch();
        return this;
    } else if (obj === undefined) {
        // get
        var json = {
            data: copy(p.data),
            position: copy(p.position),
            group: p.group,
            removed: p.removed,
            selected: p.selected,
            selectable: p.selectable,
            locked: p.locked,
            grabbable: p.grabbable,
            pannable: p.pannable,
            classes: null
        };
        json.classes = '';
        var i = 0;
        p.classes.forEach(function(cls) {
            return json.classes += i++ === 0 ? cls : ' ' + cls;
        });
        return json;
    }
};
elesfn$1.jsons = function() {
    var jsons = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        jsons.push(json);
    }
    return jsons;
};
elesfn$1.clone = function() {
    var cy = this.cy();
    var elesArr = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        var clone = new Element(cy, json, false); // NB no restore
        elesArr.push(clone);
    }
    return new Collection(cy, elesArr);
};
elesfn$1.copy = elesfn$1.clone;
elesfn$1.restore = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var addToPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var cy = self1.cy();
    var cy_p = cy._private;
    // create arrays of nodes and edges, since we need to
    // restore the nodes first
    var nodes = [];
    var edges = [];
    var elements;
    for(var _i3 = 0, l = self1.length; _i3 < l; _i3++){
        var ele = self1[_i3];
        if (addToPool && !ele.removed()) continue;
        // keep nodes first in the array and edges after
        if (ele.isNode()) // put to front of array if node
        nodes.push(ele);
        else // put to end of array if edge
        edges.push(ele);
    }
    elements = nodes.concat(edges);
    var i;
    var removeFromElements = function removeFromElements() {
        elements.splice(i, 1);
        i--;
    };
    // now, restore each element
    for(i = 0; i < elements.length; i++){
        var _ele2 = elements[i];
        var _private = _ele2._private;
        var _data3 = _private.data;
        // the traversal cache should start fresh when ele is added
        _ele2.clearTraversalCache();
        // set id and validate
        if (!addToPool && !_private.removed) ;
        else if (_data3.id === undefined) _data3.id = uuid();
        else if (number$1(_data3.id)) _data3.id = '' + _data3.id; // now it's a string
        else if (emptyString(_data3.id) || !string(_data3.id)) {
            error('Can not create element with invalid string ID `' + _data3.id + '`');
            // can't create element if it has empty string as id or non-string id
            removeFromElements();
            continue;
        } else if (cy.hasElementWithId(_data3.id)) {
            error('Can not create second element with ID `' + _data3.id + '`');
            // can't create element if one already has that id
            removeFromElements();
            continue;
        }
        var id = _data3.id; // id is finalised, now let's keep a ref
        if (_ele2.isNode()) {
            // extra checks for nodes
            var pos = _private.position;
            // make sure the nodes have a defined position
            if (pos.x == null) pos.x = 0;
            if (pos.y == null) pos.y = 0;
        }
        if (_ele2.isEdge()) {
            // extra checks for edges
            var edge = _ele2;
            var fields = [
                'source',
                'target'
            ];
            var fieldsLength = fields.length;
            var badSourceOrTarget = false;
            for(var j = 0; j < fieldsLength; j++){
                var field = fields[j];
                var val = _data3[field];
                if (number$1(val)) val = _data3[field] = '' + _data3[field]; // now string
                if (val == null || val === '') {
                    // can't create if source or target is not defined properly
                    error('Can not create edge `' + id + '` with unspecified ' + field);
                    badSourceOrTarget = true;
                } else if (!cy.hasElementWithId(val)) {
                    // can't create edge if one of its nodes doesn't exist
                    error('Can not create edge `' + id + '` with nonexistant ' + field + ' `' + val + '`');
                    badSourceOrTarget = true;
                }
            }
            if (badSourceOrTarget) {
                removeFromElements();
                continue;
            } // can't create this
            var src = cy.getElementById(_data3.source);
            var tgt = cy.getElementById(_data3.target);
            // only one edge in node if loop
            if (src.same(tgt)) src._private.edges.push(edge);
            else {
                src._private.edges.push(edge);
                tgt._private.edges.push(edge);
            }
            edge._private.source = src;
            edge._private.target = tgt;
        } // if is edge
        // create mock ids / indexes maps for element so it can be used like collections
        _private.map = new Map$1();
        _private.map.set(id, {
            ele: _ele2,
            index: 0
        });
        _private.removed = false;
        if (addToPool) cy.addToPool(_ele2);
    } // for each element
    // do compound node sanity checks
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        // each node
        var node = nodes[_i4];
        var _data4 = node._private.data;
        if (number$1(_data4.parent)) // then automake string
        _data4.parent = '' + _data4.parent;
        var parentId = _data4.parent;
        var specifiedParent = parentId != null;
        if (specifiedParent || node._private.parent) {
            var parent = node._private.parent ? cy.collection().merge(node._private.parent) : cy.getElementById(parentId);
            if (parent.empty()) // non-existant parent; just remove it
            _data4.parent = undefined;
            else if (parent[0].removed()) {
                warn('Node added with missing parent, reference to parent removed');
                _data4.parent = undefined;
                node._private.parent = null;
            } else {
                var selfAsParent = false;
                var ancestor = parent;
                while(!ancestor.empty()){
                    if (node.same(ancestor)) {
                        // mark self as parent and remove from data
                        selfAsParent = true;
                        _data4.parent = undefined; // remove parent reference
                        break;
                    }
                    ancestor = ancestor.parent();
                }
                if (!selfAsParent) {
                    // connect with children
                    parent[0]._private.children.push(node);
                    node._private.parent = parent[0];
                    // let the core know we have a compound graph
                    cy_p.hasCompoundNodes = true;
                }
            } // else
        } // if specified parent
    } // for each node
    if (elements.length > 0) {
        var restored = elements.length === self1.length ? self1 : new Collection(cy, elements);
        for(var _i5 = 0; _i5 < restored.length; _i5++){
            var _ele3 = restored[_i5];
            if (_ele3.isNode()) continue;
            // adding an edge invalidates the traversal caches for the parallel edges
            _ele3.parallelEdges().clearTraversalCache();
            // adding an edge invalidates the traversal cache for the connected nodes
            _ele3.source().clearTraversalCache();
            _ele3.target().clearTraversalCache();
        }
        var toUpdateStyle;
        if (cy_p.hasCompoundNodes) toUpdateStyle = cy.collection().merge(restored).merge(restored.connectedNodes()).merge(restored.parent());
        else toUpdateStyle = restored;
        toUpdateStyle.dirtyCompoundBoundsCache().dirtyBoundingBoxCache().updateStyle(notifyRenderer);
        if (notifyRenderer) restored.emitAndNotify('add');
        else if (addToPool) restored.emit('add');
    }
    return self1; // chainability
};
elesfn$1.removed = function() {
    var ele = this[0];
    return ele && ele._private.removed;
};
elesfn$1.inside = function() {
    var ele = this[0];
    return ele && !ele._private.removed;
};
elesfn$1.remove = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var removeFromPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var elesToRemove = [];
    var elesToRemoveIds = {};
    var cy = self1._private.cy;
    // add connected edges
    function addConnectedEdges(node) {
        var edges = node._private.edges;
        for(var i = 0; i < edges.length; i++)add(edges[i]);
    }
    // add descendant nodes
    function addChildren(node) {
        var children = node._private.children;
        for(var i = 0; i < children.length; i++)add(children[i]);
    }
    function add(ele) {
        var alreadyAdded = elesToRemoveIds[ele.id()];
        if (removeFromPool && ele.removed() || alreadyAdded) return;
        else elesToRemoveIds[ele.id()] = true;
        if (ele.isNode()) {
            elesToRemove.push(ele); // nodes are removed last
            addConnectedEdges(ele);
            addChildren(ele);
        } else elesToRemove.unshift(ele); // edges are removed first
    }
    // make the list of elements to remove
    // (may be removing more than specified due to connected edges etc)
    for(var i = 0, l = self1.length; i < l; i++){
        var ele = self1[i];
        add(ele);
    }
    function removeEdgeRef(node, edge) {
        var connectedEdges = node._private.edges;
        removeFromArray(connectedEdges, edge);
        // removing an edges invalidates the traversal cache for its nodes
        node.clearTraversalCache();
    }
    function removeParallelRef(pllEdge) {
        // removing an edge invalidates the traversal caches for the parallel edges
        pllEdge.clearTraversalCache();
    }
    var alteredParents = [];
    alteredParents.ids = {};
    function removeChildRef(parent, ele) {
        ele = ele[0];
        parent = parent[0];
        var children = parent._private.children;
        var pid = parent.id();
        removeFromArray(children, ele); // remove parent => child ref
        ele._private.parent = null; // remove child => parent ref
        if (!alteredParents.ids[pid]) {
            alteredParents.ids[pid] = true;
            alteredParents.push(parent);
        }
    }
    self1.dirtyCompoundBoundsCache();
    if (removeFromPool) cy.removeFromPool(elesToRemove); // remove from core pool
    for(var _i6 = 0; _i6 < elesToRemove.length; _i6++){
        var _ele4 = elesToRemove[_i6];
        if (_ele4.isEdge()) {
            // remove references to this edge in its connected nodes
            var src = _ele4.source()[0];
            var tgt = _ele4.target()[0];
            removeEdgeRef(src, _ele4);
            removeEdgeRef(tgt, _ele4);
            var pllEdges = _ele4.parallelEdges();
            for(var j = 0; j < pllEdges.length; j++){
                var pllEdge = pllEdges[j];
                removeParallelRef(pllEdge);
                if (pllEdge.isBundledBezier()) pllEdge.dirtyBoundingBoxCache();
            }
        } else {
            // remove reference to parent
            var parent = _ele4.parent();
            if (parent.length !== 0) removeChildRef(parent, _ele4);
        }
        if (removeFromPool) // mark as removed
        _ele4._private.removed = true;
    }
    // check to see if we have a compound graph or not
    var elesStillInside = cy._private.elements;
    cy._private.hasCompoundNodes = false;
    for(var _i7 = 0; _i7 < elesStillInside.length; _i7++){
        var _ele5 = elesStillInside[_i7];
        if (_ele5.isParent()) {
            cy._private.hasCompoundNodes = true;
            break;
        }
    }
    var removedElements = new Collection(this.cy(), elesToRemove);
    if (removedElements.size() > 0) {
        // must manually notify since trigger won't do this automatically once removed
        if (notifyRenderer) removedElements.emitAndNotify('remove');
        else if (removeFromPool) removedElements.emit('remove');
    }
    // the parents who were modified by the removal need their style updated
    for(var _i8 = 0; _i8 < alteredParents.length; _i8++){
        var _ele6 = alteredParents[_i8];
        if (!removeFromPool || !_ele6.removed()) _ele6.updateStyle();
    }
    return removedElements;
};
elesfn$1.move = function(struct) {
    var cy = this._private.cy;
    var eles = this;
    // just clean up refs, caches, etc. in the same way as when removing and then restoring
    // (our calls to remove/restore do not remove from the graph or make events)
    var notifyRenderer = false;
    var modifyPool = false;
    var toString = function toString(id) {
        return id == null ? id : '' + id;
    }; // id must be string
    if (struct.source !== undefined || struct.target !== undefined) {
        var srcId = toString(struct.source);
        var tgtId = toString(struct.target);
        var srcExists = srcId != null && cy.hasElementWithId(srcId);
        var tgtExists = tgtId != null && cy.hasElementWithId(tgtId);
        if (srcExists || tgtExists) {
            cy.batch(function() {
                // avoid duplicate style updates
                eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                eles.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data5 = ele._private.data;
                    if (ele.isEdge()) {
                        if (srcExists) _data5.source = srcId;
                        if (tgtExists) _data5.target = tgtId;
                    }
                }
                eles.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    } else if (struct.parent !== undefined) {
        // move node to new parent
        var parentId = toString(struct.parent);
        var parentExists = parentId === null || cy.hasElementWithId(parentId);
        if (parentExists) {
            var pidToAssign = parentId === null ? undefined : parentId;
            cy.batch(function() {
                // avoid duplicate style updates
                var updated = eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                updated.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data6 = ele._private.data;
                    if (ele.isNode()) _data6.parent = pidToAssign;
                }
                updated.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    }
    return this;
};
[
    elesfn$j,
    elesfn$i,
    elesfn$h,
    elesfn$g,
    elesfn$f,
    data,
    elesfn$d,
    dimensions,
    elesfn$9,
    elesfn$8,
    elesfn$7,
    elesfn$6,
    elesfn$5,
    elesfn$4,
    elesfn$3,
    elesfn$2
].forEach(function(props) {
    extend(elesfn$1, props);
});
var corefn$9 = {
    add: function add(opts) {
        var elements;
        var cy = this;
        // add the elements
        if (elementOrCollection(opts)) {
            var eles = opts;
            if (eles._private.cy === cy) // same instance => just restore
            elements = eles.restore();
            else {
                // otherwise, copy from json
                var jsons = [];
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    jsons.push(ele.json());
                }
                elements = new Collection(cy, jsons);
            }
        } else if (array(opts)) {
            var _jsons = opts;
            elements = new Collection(cy, _jsons);
        } else if (plainObject(opts) && (array(opts.nodes) || array(opts.edges))) {
            var elesByGroup = opts;
            var _jsons2 = [];
            var grs = [
                'nodes',
                'edges'
            ];
            for(var _i = 0, il = grs.length; _i < il; _i++){
                var group = grs[_i];
                var elesArray = elesByGroup[group];
                if (array(elesArray)) for(var j = 0, jl = elesArray.length; j < jl; j++){
                    var json = extend({
                        group: group
                    }, elesArray[j]);
                    _jsons2.push(json);
                }
            }
            elements = new Collection(cy, _jsons2);
        } else {
            var _json = opts;
            elements = new Element(cy, _json).collection();
        }
        return elements;
    },
    remove: function remove(collection) {
        if (elementOrCollection(collection)) ;
        else if (string(collection)) {
            var selector = collection;
            collection = this.$(selector);
        }
        return collection.remove();
    }
};
/* global Float32Array */ /*! Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */ function generateCubicBezier(mX1, mY1, mX2, mY2) {
    var NEWTON_ITERATIONS = 4, NEWTON_MIN_SLOPE = 0.001, SUBDIVISION_PRECISION = 0.0000001, SUBDIVISION_MAX_ITERATIONS = 10, kSplineTableSize = 11, kSampleStepSize = 1.0 / (kSplineTableSize - 1.0), float32ArraySupported = typeof Float32Array !== 'undefined';
    /* Must contain four arguments. */ if (arguments.length !== 4) return false;
    /* Arguments must be numbers. */ for(var i = 0; i < 4; ++i){
        if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) return false;
    }
    /* X values must be in the [0, 1] range. */ mX1 = Math.min(mX1, 1);
    mX2 = Math.min(mX2, 1);
    mX1 = Math.max(mX1, 0);
    mX2 = Math.max(mX2, 0);
    var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function newtonRaphsonIterate(aX, aGuessT) {
        for(var _i = 0; _i < NEWTON_ITERATIONS; ++_i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function calcSampleValues() {
        for(var _i2 = 0; _i2 < kSplineTableSize; ++_i2)mSampleValues[_i2] = calcBezier(_i2 * kSampleStepSize, mX1, mX2);
    }
    function binarySubdivide(aX, aA, aB) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }
    function getTForX(aX) {
        var intervalStart = 0.0, currentSample = 1, lastSample = kSplineTableSize - 1;
        for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
        --currentSample;
        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]), guessForT = intervalStart + dist * kSampleStepSize, initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT);
        else if (initialSlope === 0.0) return guessForT;
        else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
    }
    var _precomputed = false;
    function precompute() {
        _precomputed = true;
        if (mX1 !== mY1 || mX2 !== mY2) calcSampleValues();
    }
    var f = function f(aX) {
        if (!_precomputed) precompute();
        if (mX1 === mY1 && mX2 === mY2) return aX;
        if (aX === 0) return 0;
        if (aX === 1) return 1;
        return calcBezier(getTForX(aX), mY1, mY2);
    };
    f.getControlPoints = function() {
        return [
            {
                x: mX1,
                y: mY1
            },
            {
                x: mX2,
                y: mY2
            }
        ];
    };
    var str = "generateBezier(" + [
        mX1,
        mY1,
        mX2,
        mY2
    ] + ")";
    f.toString = function() {
        return str;
    };
    return f;
}
/*! Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */ /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
   then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */ var generateSpringRK4 = function() {
    function springAccelerationForState(state) {
        return -state.tension * state.x - state.friction * state.v;
    }
    function springEvaluateStateWithDerivative(initialState, dt, derivative) {
        var state = {
            x: initialState.x + derivative.dx * dt,
            v: initialState.v + derivative.dv * dt,
            tension: initialState.tension,
            friction: initialState.friction
        };
        return {
            dx: state.v,
            dv: springAccelerationForState(state)
        };
    }
    function springIntegrateState(state, dt) {
        var a = {
            dx: state.v,
            dv: springAccelerationForState(state)
        }, b = springEvaluateStateWithDerivative(state, dt * 0.5, a), c = springEvaluateStateWithDerivative(state, dt * 0.5, b), d = springEvaluateStateWithDerivative(state, dt, c), dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx), dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
        state.x = state.x + dxdt * dt;
        state.v = state.v + dvdt * dt;
        return state;
    }
    return function springRK4Factory(tension, friction, duration) {
        var initState = {
            x: -1,
            v: 0,
            tension: null,
            friction: null
        }, path = [
            0
        ], time_lapsed = 0, tolerance = 0.0001, DT = 0.016, have_duration, dt, last_state;
        tension = parseFloat(tension) || 500;
        friction = parseFloat(friction) || 20;
        duration = duration || null;
        initState.tension = tension;
        initState.friction = friction;
        have_duration = duration !== null;
        /* Calculate the actual time it takes for this animation to complete with the provided conditions. */ if (have_duration) {
            /* Run the simulation without a duration. */ time_lapsed = springRK4Factory(tension, friction);
            /* Compute the adjusted time delta. */ dt = time_lapsed / duration * DT;
        } else dt = DT;
        for(;;){
            /* Next/step function .*/ last_state = springIntegrateState(last_state || initState, dt);
            /* Store the position. */ path.push(1 + last_state.x);
            time_lapsed += 16;
            /* If the change threshold is reached, break. */ if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) break;
        }
        /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
       computed path and returns a snapshot of the position according to a given percentComplete. */ return !have_duration ? time_lapsed : function(percentComplete) {
            return path[percentComplete * (path.length - 1) | 0];
        };
    };
}();
var cubicBezier = function cubicBezier(t1, p1, t2, p2) {
    var bezier = generateCubicBezier(t1, p1, t2, p2);
    return function(start, end, percent) {
        return start + (end - start) * bezier(percent);
    };
};
var easings = {
    'linear': function linear(start, end, percent) {
        return start + (end - start) * percent;
    },
    // default easings
    'ease': cubicBezier(0.25, 0.1, 0.25, 1),
    'ease-in': cubicBezier(0.42, 0, 1, 1),
    'ease-out': cubicBezier(0, 0, 0.58, 1),
    'ease-in-out': cubicBezier(0.42, 0, 0.58, 1),
    // sine
    'ease-in-sine': cubicBezier(0.47, 0, 0.745, 0.715),
    'ease-out-sine': cubicBezier(0.39, 0.575, 0.565, 1),
    'ease-in-out-sine': cubicBezier(0.445, 0.05, 0.55, 0.95),
    // quad
    'ease-in-quad': cubicBezier(0.55, 0.085, 0.68, 0.53),
    'ease-out-quad': cubicBezier(0.25, 0.46, 0.45, 0.94),
    'ease-in-out-quad': cubicBezier(0.455, 0.03, 0.515, 0.955),
    // cubic
    'ease-in-cubic': cubicBezier(0.55, 0.055, 0.675, 0.19),
    'ease-out-cubic': cubicBezier(0.215, 0.61, 0.355, 1),
    'ease-in-out-cubic': cubicBezier(0.645, 0.045, 0.355, 1),
    // quart
    'ease-in-quart': cubicBezier(0.895, 0.03, 0.685, 0.22),
    'ease-out-quart': cubicBezier(0.165, 0.84, 0.44, 1),
    'ease-in-out-quart': cubicBezier(0.77, 0, 0.175, 1),
    // quint
    'ease-in-quint': cubicBezier(0.755, 0.05, 0.855, 0.06),
    'ease-out-quint': cubicBezier(0.23, 1, 0.32, 1),
    'ease-in-out-quint': cubicBezier(0.86, 0, 0.07, 1),
    // expo
    'ease-in-expo': cubicBezier(0.95, 0.05, 0.795, 0.035),
    'ease-out-expo': cubicBezier(0.19, 1, 0.22, 1),
    'ease-in-out-expo': cubicBezier(1, 0, 0, 1),
    // circ
    'ease-in-circ': cubicBezier(0.6, 0.04, 0.98, 0.335),
    'ease-out-circ': cubicBezier(0.075, 0.82, 0.165, 1),
    'ease-in-out-circ': cubicBezier(0.785, 0.135, 0.15, 0.86),
    // user param easings...
    'spring': function spring(tension, friction, duration) {
        if (duration === 0) // can't get a spring w/ duration 0
        return easings.linear; // duration 0 => jump to end so impl doesn't matter
        var spring = generateSpringRK4(tension, friction, duration);
        return function(start, end, percent) {
            return start + (end - start) * spring(percent);
        };
    },
    'cubic-bezier': cubicBezier
};
function getEasedValue(type, start, end, percent, easingFn) {
    if (percent === 1) return end;
    if (start === end) return end;
    var val = easingFn(start, end, percent);
    if (type == null) return val;
    if (type.roundValue || type.color) val = Math.round(val);
    if (type.min !== undefined) val = Math.max(val, type.min);
    if (type.max !== undefined) val = Math.min(val, type.max);
    return val;
}
function getValue(prop, spec) {
    if (prop.pfValue != null || prop.value != null) {
        if (prop.pfValue != null && (spec == null || spec.type.units !== '%')) return prop.pfValue;
        else return prop.value;
    } else return prop;
}
function ease(startProp, endProp, percent, easingFn, propSpec) {
    var type = propSpec != null ? propSpec.type : null;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    var start = getValue(startProp, propSpec);
    var end = getValue(endProp, propSpec);
    if (number$1(start) && number$1(end)) return getEasedValue(type, start, end, percent, easingFn);
    else if (array(start) && array(end)) {
        var easedArr = [];
        for(var i = 0; i < end.length; i++){
            var si = start[i];
            var ei = end[i];
            if (si != null && ei != null) {
                var val = getEasedValue(type, si, ei, percent, easingFn);
                easedArr.push(val);
            } else easedArr.push(ei);
        }
        return easedArr;
    }
    return undefined;
}
function step$1(self1, ani, now, isCore) {
    var isEles = !isCore;
    var _p = self1._private;
    var ani_p = ani._private;
    var pEasing = ani_p.easing;
    var startTime = ani_p.startTime;
    var cy = isCore ? self1 : self1.cy();
    var style = cy.style();
    if (!ani_p.easingImpl) {
        if (pEasing == null) // use default
        ani_p.easingImpl = easings['linear'];
        else {
            // then define w/ name
            var easingVals;
            if (string(pEasing)) {
                var easingProp = style.parse('transition-timing-function', pEasing);
                easingVals = easingProp.value;
            } else // then assume preparsed array
            easingVals = pEasing;
            var name, args;
            if (string(easingVals)) {
                name = easingVals;
                args = [];
            } else {
                name = easingVals[1];
                args = easingVals.slice(2).map(function(n) {
                    return +n;
                });
            }
            if (args.length > 0) {
                // create with args
                if (name === 'spring') args.push(ani_p.duration); // need duration to generate spring
                ani_p.easingImpl = easings[name].apply(null, args);
            } else // static impl by name
            ani_p.easingImpl = easings[name];
        }
    }
    var easing = ani_p.easingImpl;
    var percent;
    if (ani_p.duration === 0) percent = 1;
    else percent = (now - startTime) / ani_p.duration;
    if (ani_p.applying) percent = ani_p.progress;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    if (ani_p.delay == null) {
        // then update
        var startPos = ani_p.startPosition;
        var endPos = ani_p.position;
        if (endPos && isEles && !self1.locked()) {
            var newPos = {};
            if (valid(startPos.x, endPos.x)) newPos.x = ease(startPos.x, endPos.x, percent, easing);
            if (valid(startPos.y, endPos.y)) newPos.y = ease(startPos.y, endPos.y, percent, easing);
            self1.position(newPos);
        }
        var startPan = ani_p.startPan;
        var endPan = ani_p.pan;
        var pan = _p.pan;
        var animatingPan = endPan != null && isCore;
        if (animatingPan) {
            if (valid(startPan.x, endPan.x)) pan.x = ease(startPan.x, endPan.x, percent, easing);
            if (valid(startPan.y, endPan.y)) pan.y = ease(startPan.y, endPan.y, percent, easing);
            self1.emit('pan');
        }
        var startZoom = ani_p.startZoom;
        var endZoom = ani_p.zoom;
        var animatingZoom = endZoom != null && isCore;
        if (animatingZoom) {
            if (valid(startZoom, endZoom)) _p.zoom = bound(_p.minZoom, ease(startZoom, endZoom, percent, easing), _p.maxZoom);
            self1.emit('zoom');
        }
        if (animatingPan || animatingZoom) self1.emit('viewport');
        var props = ani_p.style;
        if (props && props.length > 0 && isEles) {
            for(var i = 0; i < props.length; i++){
                var prop = props[i];
                var _name = prop.name;
                var end = prop;
                var start = ani_p.startStyle[_name];
                var propSpec = style.properties[start.name];
                var easedVal = ease(start, end, percent, easing, propSpec);
                style.overrideBypass(self1, _name, easedVal);
            } // for props
            self1.emit('style');
        } // if
    }
    ani_p.progress = percent;
    return percent;
}
function valid(start, end) {
    if (start == null || end == null) return false;
    if (number$1(start) && number$1(end)) return true;
    else if (start && end) return true;
    return false;
}
function startAnimation(self1, ani, now, isCore) {
    var ani_p = ani._private;
    ani_p.started = true;
    ani_p.startTime = now - ani_p.progress * ani_p.duration;
}
function stepAll(now, cy) {
    var eles = cy._private.aniEles;
    var doneEles = [];
    function stepOne(ele, isCore) {
        var _p = ele._private;
        var current = _p.animation.current;
        var queue = _p.animation.queue;
        var ranAnis = false;
        // if nothing currently animating, get something from the queue
        if (current.length === 0) {
            var next = queue.shift();
            if (next) current.push(next);
        }
        var callbacks = function callbacks(_callbacks) {
            for(var j = _callbacks.length - 1; j >= 0; j--){
                var cb = _callbacks[j];
                cb();
            }
            _callbacks.splice(0, _callbacks.length);
        };
        // step and remove if done
        for(var i = current.length - 1; i >= 0; i--){
            var ani = current[i];
            var ani_p = ani._private;
            if (ani_p.stopped) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.frames);
                continue;
            }
            if (!ani_p.playing && !ani_p.applying) continue;
            // an apply() while playing shouldn't do anything
            if (ani_p.playing && ani_p.applying) ani_p.applying = false;
            if (!ani_p.started) startAnimation(ele, ani, now);
            step$1(ele, ani, now, isCore);
            if (ani_p.applying) ani_p.applying = false;
            callbacks(ani_p.frames);
            if (ani_p.step != null) ani_p.step(now);
            if (ani.completed()) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.completes);
            }
            ranAnis = true;
        }
        if (!isCore && current.length === 0 && queue.length === 0) doneEles.push(ele);
        return ranAnis;
    } // stepElement
    // handle all eles
    var ranEleAni = false;
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        var handledThisEle = stepOne(ele);
        ranEleAni = ranEleAni || handledThisEle;
    } // each element
    var ranCoreAni = stepOne(cy, true);
    // notify renderer
    if (ranEleAni || ranCoreAni) {
        if (eles.length > 0) cy.notify('draw', eles);
        else cy.notify('draw');
    }
    // remove elements from list of currently animating if its queues are empty
    eles.unmerge(doneEles);
    cy.emit('step');
} // stepAll
var corefn$8 = {
    // pull in animation functions
    animate: define.animate(),
    animation: define.animation(),
    animated: define.animated(),
    clearQueue: define.clearQueue(),
    delay: define.delay(),
    delayAnimation: define.delayAnimation(),
    stop: define.stop(),
    addToAnimationPool: function addToAnimationPool(eles) {
        var cy = this;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        cy._private.aniEles.merge(eles);
    },
    stopAnimationLoop: function stopAnimationLoop() {
        this._private.animationsRunning = false;
    },
    startAnimationLoop: function startAnimationLoop() {
        var cy = this;
        cy._private.animationsRunning = true;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        // NB the animation loop will exec in headless environments if style enabled
        // and explicit cy.destroy() is necessary to stop the loop
        function headlessStep() {
            if (!cy._private.animationsRunning) return;
            requestAnimationFrame(function animationStep(now) {
                stepAll(now, cy);
                headlessStep();
            });
        }
        var renderer = cy.renderer();
        if (renderer && renderer.beforeRender) // let the renderer schedule animations
        renderer.beforeRender(function rendererAnimationStep(willDraw, now) {
            stepAll(now, cy);
        }, renderer.beforeRenderPriorities.animations);
        else // manage the animation loop ourselves
        headlessStep(); // first call
    }
};
var emitterOptions = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(cy, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return cy !== eventObj.target && element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(cy, evt) {
        evt.cy = cy;
        evt.target = cy;
    },
    callbackContext: function callbackContext(cy, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : cy;
    }
};
var argSelector = function argSelector(arg) {
    if (string(arg)) return new Selector(arg);
    else return arg;
};
var elesfn = {
    createEmitter: function createEmitter() {
        var _p = this._private;
        if (!_p.emitter) _p.emitter = new Emitter(emitterOptions, this);
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        this.emitter().on(events, argSelector(selector), callback);
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        this.emitter().removeListener(events, argSelector(selector), callback);
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        this.emitter().removeAllListeners();
        return this;
    },
    one: function one(events, selector, callback) {
        this.emitter().one(events, argSelector(selector), callback);
        return this;
    },
    once: function once(events, selector, callback) {
        this.emitter().one(events, argSelector(selector), callback);
        return this;
    },
    emit: function emit(events, extraParams) {
        this.emitter().emit(events, extraParams);
        return this;
    },
    emitAndNotify: function emitAndNotify(event, eles) {
        this.emit(event);
        this.notify(event, eles);
        return this;
    }
};
define.eventAliasesOn(elesfn);
var corefn$7 = {
    png: function png(options) {
        var renderer = this._private.renderer;
        options = options || {};
        return renderer.png(options);
    },
    jpg: function jpg(options) {
        var renderer = this._private.renderer;
        options = options || {};
        options.bg = options.bg || '#fff';
        return renderer.jpg(options);
    }
};
corefn$7.jpeg = corefn$7.jpg;
var corefn$6 = {
    layout: function layout(options) {
        var cy = this;
        if (options == null) {
            error('Layout options must be specified to make a layout');
            return;
        }
        if (options.name == null) {
            error('A `name` must be specified to make a layout');
            return;
        }
        var name = options.name;
        var Layout = cy.extension('layout', name);
        if (Layout == null) {
            error('No such layout `' + name + '` found.  Did you forget to import it and `cytoscape.use()` it?');
            return;
        }
        var eles;
        if (string(options.eles)) eles = cy.$(options.eles);
        else eles = options.eles != null ? options.eles : cy.$();
        var layout = new Layout(extend({}, options, {
            cy: cy,
            eles: eles
        }));
        return layout;
    }
};
corefn$6.createLayout = corefn$6.makeLayout = corefn$6.layout;
var corefn$5 = {
    notify: function notify(eventName, eventEles) {
        var _p = this._private;
        if (this.batching()) {
            _p.batchNotifications = _p.batchNotifications || {};
            var eles = _p.batchNotifications[eventName] = _p.batchNotifications[eventName] || this.collection();
            if (eventEles != null) eles.merge(eventEles);
            return; // notifications are disabled during batching
        }
        if (!_p.notificationsEnabled) return;
         // exit on disabled
        var renderer = this.renderer();
        // exit if destroy() called on core or renderer in between frames #1499 #1528
        if (this.destroyed() || !renderer) return;
        renderer.notify(eventName, eventEles);
    },
    notifications: function notifications(bool) {
        var p = this._private;
        if (bool === undefined) return p.notificationsEnabled;
        else p.notificationsEnabled = bool ? true : false;
        return this;
    },
    noNotifications: function noNotifications(callback) {
        this.notifications(false);
        callback();
        this.notifications(true);
    },
    batching: function batching() {
        return this._private.batchCount > 0;
    },
    startBatch: function startBatch() {
        var _p = this._private;
        if (_p.batchCount == null) _p.batchCount = 0;
        if (_p.batchCount === 0) {
            _p.batchStyleEles = this.collection();
            _p.batchNotifications = {};
        }
        _p.batchCount++;
        return this;
    },
    endBatch: function endBatch() {
        var _p = this._private;
        if (_p.batchCount === 0) return this;
        _p.batchCount--;
        if (_p.batchCount === 0) {
            // update style for dirty eles
            _p.batchStyleEles.updateStyle();
            var renderer = this.renderer();
            // notify the renderer of queued eles and event types
            Object.keys(_p.batchNotifications).forEach(function(eventName) {
                var eles = _p.batchNotifications[eventName];
                if (eles.empty()) renderer.notify(eventName);
                else renderer.notify(eventName, eles);
            });
        }
        return this;
    },
    batch: function batch(callback) {
        this.startBatch();
        callback();
        this.endBatch();
        return this;
    },
    // for backwards compatibility
    batchData: function batchData(map) {
        var cy = this;
        return this.batch(function() {
            var ids = Object.keys(map);
            for(var i = 0; i < ids.length; i++){
                var id = ids[i];
                var data = map[id];
                var ele = cy.getElementById(id);
                ele.data(data);
            }
        });
    }
};
var rendererDefaults = defaults$g({
    hideEdgesOnViewport: false,
    textureOnViewport: false,
    motionBlur: false,
    motionBlurOpacity: 0.05,
    pixelRatio: undefined,
    desktopTapThreshold: 4,
    touchTapThreshold: 8,
    wheelSensitivity: 1,
    debug: false,
    showFps: false,
    // webgl options
    webgl: false,
    webglDebug: false,
    webglDebugShowAtlases: false,
    // defaults good for mobile
    webglTexSize: 2048,
    webglTexRows: 36,
    webglTexRowsNodes: 18,
    webglBatchSize: 2048,
    webglTexPerBatch: 14,
    webglBgColor: [
        255,
        255,
        255
    ]
});
var corefn$4 = {
    renderTo: function renderTo(context, zoom, pan, pxRatio) {
        var r = this._private.renderer;
        r.renderTo(context, zoom, pan, pxRatio);
        return this;
    },
    renderer: function renderer() {
        return this._private.renderer;
    },
    forceRender: function forceRender() {
        this.notify('draw');
        return this;
    },
    resize: function resize() {
        this.invalidateSize();
        this.emitAndNotify('resize');
        return this;
    },
    initRenderer: function initRenderer(options) {
        var cy = this;
        var RendererProto = cy.extension('renderer', options.name);
        if (RendererProto == null) {
            error("Can not initialise: No such renderer `".concat(options.name, "` found. Did you forget to import it and `cytoscape.use()` it?"));
            return;
        }
        if (options.wheelSensitivity !== undefined) warn("You have set a custom wheel sensitivity.  This will make your app zoom unnaturally when using mainstream mice.  You should change this value from the default only if you can guarantee that all your users will use the same hardware and OS configuration as your current machine.");
        var rOpts = rendererDefaults(options);
        rOpts.cy = cy;
        cy._private.renderer = new RendererProto(rOpts);
        this.notify('init');
    },
    destroyRenderer: function destroyRenderer() {
        var cy = this;
        cy.notify('destroy'); // destroy the renderer
        var domEle = cy.container();
        if (domEle) {
            domEle._cyreg = null;
            while(domEle.childNodes.length > 0)domEle.removeChild(domEle.childNodes[0]);
        }
        cy._private.renderer = null; // to be extra safe, remove the ref
        cy.mutableElements().forEach(function(ele) {
            var _p = ele._private;
            _p.rscratch = {};
            _p.rstyle = {};
            _p.animation.current = [];
            _p.animation.queue = [];
        });
    },
    onRender: function onRender(fn) {
        return this.on('render', fn);
    },
    offRender: function offRender(fn) {
        return this.off('render', fn);
    }
};
corefn$4.invalidateDimensions = corefn$4.resize;
var corefn$3 = {
    // get a collection
    // - empty collection on no args
    // - collection of elements in the graph on selector arg
    // - guarantee a returned collection when elements or collection specified
    collection: function collection(eles, opts) {
        if (string(eles)) return this.$(eles);
        else if (elementOrCollection(eles)) return eles.collection();
        else if (array(eles)) {
            if (!opts) opts = {};
            return new Collection(this, eles, opts.unique, opts.removed);
        }
        return new Collection(this);
    },
    nodes: function nodes(selector) {
        var nodes = this.$(function(ele) {
            return ele.isNode();
        });
        if (selector) return nodes.filter(selector);
        return nodes;
    },
    edges: function edges(selector) {
        var edges = this.$(function(ele) {
            return ele.isEdge();
        });
        if (selector) return edges.filter(selector);
        return edges;
    },
    // search the graph like jQuery
    $: function $(selector) {
        var eles = this._private.elements;
        if (selector) return eles.filter(selector);
        else return eles.spawnSelf();
    },
    mutableElements: function mutableElements() {
        return this._private.elements;
    }
};
// aliases
corefn$3.elements = corefn$3.filter = corefn$3.$;
var styfn$8 = {};
// keys for style blocks, e.g. ttfftt
var TRUE = 't';
var FALSE = 'f';
// (potentially expensive calculation)
// apply the style to the element based on
// - its bypass
// - what selectors match it
styfn$8.apply = function(eles) {
    var self1 = this;
    var _p = self1._private;
    var cy = _p.cy;
    var updatedEles = cy.collection();
    for(var ie = 0; ie < eles.length; ie++){
        var ele = eles[ie];
        var cxtMeta = self1.getContextMeta(ele);
        if (cxtMeta.empty) continue;
        var cxtStyle = self1.getContextStyle(cxtMeta);
        var app = self1.applyContextStyle(cxtMeta, cxtStyle, ele);
        if (ele._private.appliedInitStyle) self1.updateTransitions(ele, app.diffProps);
        else ele._private.appliedInitStyle = true;
        var hintsDiff = self1.updateStyleHints(ele);
        if (hintsDiff) updatedEles.push(ele);
    } // for elements
    return updatedEles;
};
styfn$8.getPropertiesDiff = function(oldCxtKey, newCxtKey) {
    var self1 = this;
    var cache = self1._private.propDiffs = self1._private.propDiffs || {};
    var dualCxtKey = oldCxtKey + '-' + newCxtKey;
    var cachedVal = cache[dualCxtKey];
    if (cachedVal) return cachedVal;
    var diffProps = [];
    var addedProp = {};
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var oldHasCxt = oldCxtKey[i] === TRUE;
        var newHasCxt = newCxtKey[i] === TRUE;
        var cxtHasDiffed = oldHasCxt !== newHasCxt;
        var cxtHasMappedProps = cxt.mappedProperties.length > 0;
        if (cxtHasDiffed || newHasCxt && cxtHasMappedProps) {
            var props = undefined;
            if (cxtHasDiffed && cxtHasMappedProps) props = cxt.properties; // suffices b/c mappedProperties is a subset of properties
            else if (cxtHasDiffed) props = cxt.properties; // need to check them all
            else if (cxtHasMappedProps) props = cxt.mappedProperties; // only need to check mapped
            for(var j = 0; j < props.length; j++){
                var prop = props[j];
                var name = prop.name;
                // if a later context overrides this property, then the fact that this context has switched/diffed doesn't matter
                // (semi expensive check since it makes this function O(n^2) on context length, but worth it since overall result
                // is cached)
                var laterCxtOverrides = false;
                for(var k = i + 1; k < self1.length; k++){
                    var laterCxt = self1[k];
                    var hasLaterCxt = newCxtKey[k] === TRUE;
                    if (!hasLaterCxt) continue;
                     // can't override unless the context is active
                    laterCxtOverrides = laterCxt.properties[prop.name] != null;
                    if (laterCxtOverrides) break;
                     // exit early as long as one later context overrides
                }
                if (!addedProp[name] && !laterCxtOverrides) {
                    addedProp[name] = true;
                    diffProps.push(name);
                }
            } // for props
        } // if
    } // for contexts
    cache[dualCxtKey] = diffProps;
    return diffProps;
};
styfn$8.getContextMeta = function(ele) {
    var self1 = this;
    var cxtKey = '';
    var diffProps;
    var prevKey = ele._private.styleCxtKey || '';
    // get the cxt key
    for(var i = 0; i < self1.length; i++){
        var context = self1[i];
        var contextSelectorMatches = context.selector && context.selector.matches(ele); // NB: context.selector may be null for 'core'
        if (contextSelectorMatches) cxtKey += TRUE;
        else cxtKey += FALSE;
    } // for context
    diffProps = self1.getPropertiesDiff(prevKey, cxtKey);
    ele._private.styleCxtKey = cxtKey;
    return {
        key: cxtKey,
        diffPropNames: diffProps,
        empty: diffProps.length === 0
    };
};
// gets a computed ele style object based on matched contexts
styfn$8.getContextStyle = function(cxtMeta) {
    var cxtKey = cxtMeta.key;
    var self1 = this;
    var cxtStyles = this._private.contextStyles = this._private.contextStyles || {};
    // if already computed style, returned cached copy
    if (cxtStyles[cxtKey]) return cxtStyles[cxtKey];
    var style = {
        _private: {
            key: cxtKey
        }
    };
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var hasCxt = cxtKey[i] === TRUE;
        if (!hasCxt) continue;
        for(var j = 0; j < cxt.properties.length; j++){
            var prop = cxt.properties[j];
            style[prop.name] = prop;
        }
    }
    cxtStyles[cxtKey] = style;
    return style;
};
styfn$8.applyContextStyle = function(cxtMeta, cxtStyle, ele) {
    var self1 = this;
    var diffProps = cxtMeta.diffPropNames;
    var retDiffProps = {};
    var types = self1.types;
    for(var i = 0; i < diffProps.length; i++){
        var diffPropName = diffProps[i];
        var cxtProp = cxtStyle[diffPropName];
        var eleProp = ele.pstyle(diffPropName);
        if (!cxtProp) {
            // no context prop means delete
            if (!eleProp) continue; // no existing prop means nothing needs to be removed
            else if (eleProp.bypass) cxtProp = {
                name: diffPropName,
                deleteBypassed: true
            };
            else cxtProp = {
                name: diffPropName,
                "delete": true
            };
        }
        // save cycles when the context prop doesn't need to be applied
        if (eleProp === cxtProp) continue;
        // save cycles when a mapped context prop doesn't need to be applied
        if (cxtProp.mapped === types.fn // context prop is function mapper
         && eleProp != null // some props can be null even by default (e.g. a prop that overrides another one)
         && eleProp.mapping != null // ele prop is a concrete value from from a mapper
         && eleProp.mapping.value === cxtProp.value // the current prop on the ele is a flat prop value for the function mapper
        ) {
            // NB don't write to cxtProp, as it's shared among eles (stored in stylesheet)
            var mapping = eleProp.mapping; // can write to mapping, as it's a per-ele copy
            var fnValue = mapping.fnValue = cxtProp.value(ele); // temporarily cache the value in case of a miss
            if (fnValue === mapping.prevFnValue) continue;
        }
        var retDiffProp = retDiffProps[diffPropName] = {
            prev: eleProp
        };
        self1.applyParsedProperty(ele, cxtProp);
        retDiffProp.next = ele.pstyle(diffPropName);
        if (retDiffProp.next && retDiffProp.next.bypass) retDiffProp.next = retDiffProp.next.bypassed;
    }
    return {
        diffProps: retDiffProps
    };
};
styfn$8.updateStyleHints = function(ele) {
    var _p = ele._private;
    var self1 = this;
    var propNames = self1.propertyGroupNames;
    var propGrKeys = self1.propertyGroupKeys;
    var propHash = function propHash(ele, propNames, seedKey) {
        return self1.getPropertiesHash(ele, propNames, seedKey);
    };
    var oldStyleKey = _p.styleKey;
    if (ele.removed()) return false;
    var isNode = _p.group === 'nodes';
    // get the style key hashes per prop group
    // but lazily -- only use non-default prop values to reduce the number of hashes
    //
    var overriddenStyles = ele._private.style;
    propNames = Object.keys(overriddenStyles);
    for(var i = 0; i < propGrKeys.length; i++){
        var grKey = propGrKeys[i];
        _p.styleKeys[grKey] = [
            DEFAULT_HASH_SEED,
            DEFAULT_HASH_SEED_ALT
        ];
    }
    var updateGrKey1 = function updateGrKey1(val, grKey) {
        return _p.styleKeys[grKey][0] = hashInt(val, _p.styleKeys[grKey][0]);
    };
    var updateGrKey2 = function updateGrKey2(val, grKey) {
        return _p.styleKeys[grKey][1] = hashIntAlt(val, _p.styleKeys[grKey][1]);
    };
    var updateGrKey = function updateGrKey(val, grKey) {
        updateGrKey1(val, grKey);
        updateGrKey2(val, grKey);
    };
    var updateGrKeyWStr = function updateGrKeyWStr(strVal, grKey) {
        for(var j = 0; j < strVal.length; j++){
            var ch = strVal.charCodeAt(j);
            updateGrKey1(ch, grKey);
            updateGrKey2(ch, grKey);
        }
    };
    // - hashing works on 32 bit ints b/c we use bitwise ops
    // - small numbers get cut off (e.g. 0.123 is seen as 0 by the hashing function)
    // - raise up small numbers so more significant digits are seen by hashing
    // - make small numbers larger than a normal value to avoid collisions
    // - works in practice and it's relatively cheap
    var N = 2000000000;
    var cleanNum = function cleanNum(val) {
        return -128 < val && val < 128 && Math.floor(val) !== val ? N - (val * 1024 | 0) : val;
    };
    for(var _i = 0; _i < propNames.length; _i++){
        var name = propNames[_i];
        var parsedProp = overriddenStyles[name];
        if (parsedProp == null) continue;
        var propInfo = this.properties[name];
        var type = propInfo.type;
        var _grKey = propInfo.groupKey;
        var normalizedNumberVal = undefined;
        if (propInfo.hashOverride != null) normalizedNumberVal = propInfo.hashOverride(ele, parsedProp);
        else if (parsedProp.pfValue != null) normalizedNumberVal = parsedProp.pfValue;
        // might not be a number if it allows enums
        var numberVal = propInfo.enums == null ? parsedProp.value : null;
        var haveNormNum = normalizedNumberVal != null;
        var haveUnitedNum = numberVal != null;
        var haveNum = haveNormNum || haveUnitedNum;
        var units = parsedProp.units;
        // numbers are cheaper to hash than strings
        // 1 hash op vs n hash ops (for length n string)
        if (type.number && haveNum && !type.multiple) {
            var v = haveNormNum ? normalizedNumberVal : numberVal;
            updateGrKey(cleanNum(v), _grKey);
            if (!haveNormNum && units != null) updateGrKeyWStr(units, _grKey);
        } else updateGrKeyWStr(parsedProp.strValue, _grKey);
    }
    // overall style key
    //
    var hash = [
        DEFAULT_HASH_SEED,
        DEFAULT_HASH_SEED_ALT
    ];
    for(var _i2 = 0; _i2 < propGrKeys.length; _i2++){
        var _grKey2 = propGrKeys[_i2];
        var grHash = _p.styleKeys[_grKey2];
        hash[0] = hashInt(grHash[0], hash[0]);
        hash[1] = hashIntAlt(grHash[1], hash[1]);
    }
    _p.styleKey = combineHashes(hash[0], hash[1]);
    // label dims
    //
    var sk = _p.styleKeys;
    _p.labelDimsKey = combineHashesArray(sk.labelDimensions);
    var labelKeys = propHash(ele, [
        'label'
    ], sk.labelDimensions);
    _p.labelKey = combineHashesArray(labelKeys);
    _p.labelStyleKey = combineHashesArray(hashArrays(sk.commonLabel, labelKeys));
    if (!isNode) {
        var sourceLabelKeys = propHash(ele, [
            'source-label'
        ], sk.labelDimensions);
        _p.sourceLabelKey = combineHashesArray(sourceLabelKeys);
        _p.sourceLabelStyleKey = combineHashesArray(hashArrays(sk.commonLabel, sourceLabelKeys));
        var targetLabelKeys = propHash(ele, [
            'target-label'
        ], sk.labelDimensions);
        _p.targetLabelKey = combineHashesArray(targetLabelKeys);
        _p.targetLabelStyleKey = combineHashesArray(hashArrays(sk.commonLabel, targetLabelKeys));
    }
    // node
    //
    if (isNode) {
        var _p$styleKeys = _p.styleKeys, nodeBody = _p$styleKeys.nodeBody, nodeBorder = _p$styleKeys.nodeBorder, nodeOutline = _p$styleKeys.nodeOutline, backgroundImage = _p$styleKeys.backgroundImage, compound = _p$styleKeys.compound, pie = _p$styleKeys.pie;
        var nodeKeys = [
            nodeBody,
            nodeBorder,
            nodeOutline,
            backgroundImage,
            compound,
            pie
        ].filter(function(k) {
            return k != null;
        }).reduce(hashArrays, [
            DEFAULT_HASH_SEED,
            DEFAULT_HASH_SEED_ALT
        ]);
        _p.nodeKey = combineHashesArray(nodeKeys);
        _p.hasPie = pie != null && pie[0] !== DEFAULT_HASH_SEED && pie[1] !== DEFAULT_HASH_SEED_ALT;
    }
    return oldStyleKey !== _p.styleKey;
};
styfn$8.clearStyleHints = function(ele) {
    var _p = ele._private;
    _p.styleCxtKey = '';
    _p.styleKeys = {};
    _p.styleKey = null;
    _p.labelKey = null;
    _p.labelStyleKey = null;
    _p.sourceLabelKey = null;
    _p.sourceLabelStyleKey = null;
    _p.targetLabelKey = null;
    _p.targetLabelStyleKey = null;
    _p.nodeKey = null;
    _p.hasPie = null;
};
// apply a property to the style (for internal use)
// returns whether application was successful
//
// now, this function flattens the property, and here's how:
//
// for parsedProp:{ bypass: true, deleteBypass: true }
// no property is generated, instead the bypass property in the
// element's style is replaced by what's pointed to by the `bypassed`
// field in the bypass property (i.e. restoring the property the
// bypass was overriding)
//
// for parsedProp:{ mapped: truthy }
// the generated flattenedProp:{ mapping: prop }
//
// for parsedProp:{ bypass: true }
// the generated flattenedProp:{ bypassed: parsedProp }
styfn$8.applyParsedProperty = function(ele, parsedProp) {
    var self1 = this;
    var prop = parsedProp;
    var style = ele._private.style;
    var flatProp;
    var types = self1.types;
    var type = self1.properties[prop.name].type;
    var propIsBypass = prop.bypass;
    var origProp = style[prop.name];
    var origPropIsBypass = origProp && origProp.bypass;
    var _p = ele._private;
    var flatPropMapping = 'mapping';
    var getVal = function getVal(p) {
        if (p == null) return null;
        else if (p.pfValue != null) return p.pfValue;
        else return p.value;
    };
    var checkTriggers = function checkTriggers() {
        var fromVal = getVal(origProp);
        var toVal = getVal(prop);
        self1.checkTriggers(ele, prop.name, fromVal, toVal);
    };
    // edge sanity checks to prevent the client from making serious mistakes
    if (parsedProp.name === 'curve-style' && ele.isEdge() && // loops must be bundled beziers
    (parsedProp.value !== 'bezier' && ele.isLoop() || // edges connected to compound nodes can not be haystacks
    parsedProp.value === 'haystack' && (ele.source().isParent() || ele.target().isParent()))) prop = parsedProp = this.parse(parsedProp.name, 'bezier', propIsBypass);
    if (prop["delete"]) {
        // delete the property and use the default value on falsey value
        style[prop.name] = undefined;
        checkTriggers();
        return true;
    }
    if (prop.deleteBypassed) {
        // delete the property that the
        if (!origProp) {
            checkTriggers();
            return true; // can't delete if no prop
        } else if (origProp.bypass) {
            // delete bypassed
            origProp.bypassed = undefined;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypassed
    }
    // check if we need to delete the current bypass
    if (prop.deleteBypass) {
        // then this property is just here to indicate we need to delete
        if (!origProp) {
            checkTriggers();
            return true; // property is already not defined
        } else if (origProp.bypass) {
            // then replace the bypass property with the original
            // because the bypassed property was already applied (and therefore parsed), we can just replace it (no reapplying necessary)
            style[prop.name] = origProp.bypassed;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypass
    }
    var printMappingErr = function printMappingErr() {
        warn('Do not assign mappings to elements without corresponding data (i.e. ele `' + ele.id() + '` has no mapping for property `' + prop.name + '` with data field `' + prop.field + '`); try a `[' + prop.field + ']` selector to limit scope to elements with `' + prop.field + '` defined');
    };
    // put the property in the style objects
    switch(prop.mapped){
        // flatten the property if mapped
        case types.mapData:
            // flatten the field (e.g. data.foo.bar)
            var fields = prop.field.split('.');
            var fieldVal = _p.data;
            for(var i = 0; i < fields.length && fieldVal; i++){
                var field = fields[i];
                fieldVal = fieldVal[field];
            }
            if (fieldVal == null) {
                printMappingErr();
                return false;
            }
            var percent;
            if (!number$1(fieldVal)) {
                // then don't apply and fall back on the existing style
                warn('Do not use continuous mappers without specifying numeric data (i.e. `' + prop.field + ': ' + fieldVal + '` for `' + ele.id() + '` is non-numeric)');
                return false;
            } else {
                var fieldWidth = prop.fieldMax - prop.fieldMin;
                if (fieldWidth === 0) // safety check -- not strictly necessary as no props of zero range should be passed here
                percent = 0;
                else percent = (fieldVal - prop.fieldMin) / fieldWidth;
            }
            // make sure to bound percent value
            if (percent < 0) percent = 0;
            else if (percent > 1) percent = 1;
            if (type.color) {
                var r1 = prop.valueMin[0];
                var r2 = prop.valueMax[0];
                var g1 = prop.valueMin[1];
                var g2 = prop.valueMax[1];
                var b1 = prop.valueMin[2];
                var b2 = prop.valueMax[2];
                var a1 = prop.valueMin[3] == null ? 1 : prop.valueMin[3];
                var a2 = prop.valueMax[3] == null ? 1 : prop.valueMax[3];
                var clr = [
                    Math.round(r1 + (r2 - r1) * percent),
                    Math.round(g1 + (g2 - g1) * percent),
                    Math.round(b1 + (b2 - b1) * percent),
                    Math.round(a1 + (a2 - a1) * percent)
                ];
                flatProp = {
                    // colours are simple, so just create the flat property instead of expensive string parsing
                    bypass: prop.bypass,
                    // we're a bypass if the mapping property is a bypass
                    name: prop.name,
                    value: clr,
                    strValue: 'rgb(' + clr[0] + ', ' + clr[1] + ', ' + clr[2] + ')'
                };
            } else if (type.number) {
                var calcValue = prop.valueMin + (prop.valueMax - prop.valueMin) * percent;
                flatProp = this.parse(prop.name, calcValue, prop.bypass, flatPropMapping);
            } else return false; // can only map to colours and numbers
            if (!flatProp) {
                // if we can't flatten the property, then don't apply the property and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        // direct mapping
        case types.data:
            // flatten the field (e.g. data.foo.bar)
            var _fields = prop.field.split('.');
            var _fieldVal = _p.data;
            for(var _i3 = 0; _i3 < _fields.length && _fieldVal; _i3++){
                var _field = _fields[_i3];
                _fieldVal = _fieldVal[_field];
            }
            if (_fieldVal != null) flatProp = this.parse(prop.name, _fieldVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                // if we can't flatten the property, then don't apply and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case types.fn:
            var fn = prop.value;
            var fnRetVal = prop.fnValue != null ? prop.fnValue : fn(ele); // check for cached value before calling function
            prop.prevFnValue = fnRetVal;
            if (fnRetVal == null) {
                warn('Custom function mappers may not return null (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is null)');
                return false;
            }
            flatProp = this.parse(prop.name, fnRetVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                warn('Custom function mappers may not return invalid values for the property type (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is invalid)');
                return false;
            }
            flatProp.mapping = copy(prop); // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case undefined:
            break;
        // just set the property
        default:
            return false;
    }
    // if the property is a bypass property, then link the resultant property to the original one
    if (propIsBypass) {
        if (origPropIsBypass) // then this bypass overrides the existing one
        prop.bypassed = origProp.bypassed; // steal bypassed prop from old bypass
        else // then link the orig prop to the new bypass
        prop.bypassed = origProp;
        style[prop.name] = prop; // and set
    } else // prop is not bypass
    if (origPropIsBypass) // then keep the orig prop (since it's a bypass) and link to the new prop
    origProp.bypassed = prop;
    else // then just replace the old prop with the new one
    style[prop.name] = prop;
    checkTriggers();
    return true;
};
styfn$8.cleanElements = function(eles, keepBypasses) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        this.clearStyleHints(ele);
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
        if (!keepBypasses) ele._private.style = {};
        else {
            var style = ele._private.style;
            var propNames = Object.keys(style);
            for(var j = 0; j < propNames.length; j++){
                var propName = propNames[j];
                var eleProp = style[propName];
                if (eleProp != null) {
                    if (eleProp.bypass) eleProp.bypassed = null;
                    else style[propName] = null;
                }
            }
        }
    }
};
// updates the visual style for all elements (useful for manual style modification after init)
styfn$8.update = function() {
    var cy = this._private.cy;
    var eles = cy.mutableElements();
    eles.updateStyle();
};
// diffProps : { name => { prev, next } }
styfn$8.updateTransitions = function(ele, diffProps) {
    var self1 = this;
    var _p = ele._private;
    var props = ele.pstyle('transition-property').value;
    var duration = ele.pstyle('transition-duration').pfValue;
    var delay = ele.pstyle('transition-delay').pfValue;
    if (props.length > 0 && duration > 0) {
        var style = {};
        // build up the style to animate towards
        var anyPrev = false;
        for(var i = 0; i < props.length; i++){
            var prop = props[i];
            var styProp = ele.pstyle(prop);
            var diffProp = diffProps[prop];
            if (!diffProp) continue;
            var prevProp = diffProp.prev;
            var fromProp = prevProp;
            var toProp = diffProp.next != null ? diffProp.next : styProp;
            var diff = false;
            var initVal = undefined;
            var initDt = 0.000001; // delta time % value for initVal (allows animating out of init zero opacity)
            if (!fromProp) continue;
            // consider px values
            if (number$1(fromProp.pfValue) && number$1(toProp.pfValue)) {
                diff = toProp.pfValue - fromProp.pfValue; // nonzero is truthy
                initVal = fromProp.pfValue + initDt * diff;
            // consider numerical values
            } else if (number$1(fromProp.value) && number$1(toProp.value)) {
                diff = toProp.value - fromProp.value; // nonzero is truthy
                initVal = fromProp.value + initDt * diff;
            // consider colour values
            } else if (array(fromProp.value) && array(toProp.value)) {
                diff = fromProp.value[0] !== toProp.value[0] || fromProp.value[1] !== toProp.value[1] || fromProp.value[2] !== toProp.value[2];
                initVal = fromProp.strValue;
            }
            // the previous value is good for an animation only if it's different
            if (diff) {
                style[prop] = toProp.strValue; // to val
                this.applyBypass(ele, prop, initVal); // from val
                anyPrev = true;
            }
        } // end if props allow ani
        // can't transition if there's nothing previous to transition from
        if (!anyPrev) return;
        _p.transitioning = true;
        new Promise$1(function(resolve) {
            if (delay > 0) ele.delayAnimation(delay).play().promise().then(resolve);
            else resolve();
        }).then(function() {
            return ele.animation({
                style: style,
                duration: duration,
                easing: ele.pstyle('transition-timing-function').value,
                queue: false
            }).play().promise();
        }).then(function() {
            // if( !isBypass ){
            self1.removeBypasses(ele, props);
            ele.emitAndNotify('style');
            // }
            _p.transitioning = false;
        });
    } else if (_p.transitioning) {
        this.removeBypasses(ele, props);
        ele.emitAndNotify('style');
        _p.transitioning = false;
    }
};
styfn$8.checkTrigger = function(ele, name, fromValue, toValue, getTrigger, onTrigger) {
    var prop = this.properties[name];
    var triggerCheck = getTrigger(prop);
    if (ele.removed()) return;
    if (triggerCheck != null && triggerCheck(fromValue, toValue, ele)) onTrigger(prop);
};
styfn$8.checkZOrderTrigger = function(ele, name, fromValue, toValue) {
    var _this = this;
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersZOrder;
    }, function() {
        _this._private.cy.notify('zorder', ele);
    });
};
styfn$8.checkBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBounds;
    }, function(prop) {
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
    });
};
styfn$8.checkConnectedEdgesBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBoundsOfConnectedEdges;
    }, function(prop) {
        ele.connectedEdges().forEach(function(edge) {
            edge.dirtyBoundingBoxCache();
        });
    });
};
styfn$8.checkParallelEdgesBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBoundsOfParallelEdges;
    }, function(prop) {
        ele.parallelEdges().forEach(function(pllEdge) {
            pllEdge.dirtyBoundingBoxCache();
        });
    });
};
styfn$8.checkTriggers = function(ele, name, fromValue, toValue) {
    ele.dirtyStyleCache();
    this.checkZOrderTrigger(ele, name, fromValue, toValue);
    this.checkBoundsTrigger(ele, name, fromValue, toValue);
    this.checkConnectedEdgesBoundsTrigger(ele, name, fromValue, toValue);
    this.checkParallelEdgesBoundsTrigger(ele, name, fromValue, toValue);
};
var styfn$7 = {};
// bypasses are applied to an existing style on an element, and just tacked on temporarily
// returns true iff application was successful for at least 1 specified property
styfn$7.applyBypass = function(eles, name, value, updateTransitions) {
    var self1 = this;
    var props = [];
    var isBypass = true;
    // put all the properties (can specify one or many) in an array after parsing them
    if (name === '*' || name === '**') {
        // apply to all property names
        if (value !== undefined) for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var _name = prop.name;
            var parsedProp = this.parse(_name, value, true);
            if (parsedProp) props.push(parsedProp);
        }
    } else if (string(name)) {
        // then parse the single property
        var _parsedProp = this.parse(name, value, true);
        if (_parsedProp) props.push(_parsedProp);
    } else if (plainObject(name)) {
        // then parse each property
        var specifiedProps = name;
        updateTransitions = value;
        var names = Object.keys(specifiedProps);
        for(var _i = 0; _i < names.length; _i++){
            var _name2 = names[_i];
            var _value = specifiedProps[_name2];
            if (_value === undefined) // try camel case name too
            _value = specifiedProps[dash2camel(_name2)];
            if (_value !== undefined) {
                var _parsedProp2 = this.parse(_name2, _value, true);
                if (_parsedProp2) props.push(_parsedProp2);
            }
        }
    } else // can't do anything without well defined properties
    return false;
    // we've failed if there are no valid properties
    if (props.length === 0) return false;
    // now, apply the bypass properties on the elements
    var ret = false; // return true if at least one succesful bypass applied
    for(var _i2 = 0; _i2 < eles.length; _i2++){
        // for each ele
        var ele = eles[_i2];
        var diffProps = {};
        var diffProp = undefined;
        for(var j = 0; j < props.length; j++){
            // for each prop
            var _prop = props[j];
            if (updateTransitions) {
                var prevProp = ele.pstyle(_prop.name);
                diffProp = diffProps[_prop.name] = {
                    prev: prevProp
                };
            }
            ret = this.applyParsedProperty(ele, copy(_prop)) || ret;
            if (updateTransitions) diffProp.next = ele.pstyle(_prop.name);
        } // for props
        if (ret) this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
    return ret;
};
// only useful in specific cases like animation
styfn$7.overrideBypass = function(eles, name, value) {
    name = camel2dash(name);
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var prop = ele._private.style[name];
        var type = this.properties[name].type;
        var isColor = type.color;
        var isMulti = type.mutiple;
        var oldValue = !prop ? null : prop.pfValue != null ? prop.pfValue : prop.value;
        if (!prop || !prop.bypass) // need a bypass if one doesn't exist
        this.applyBypass(ele, name, value);
        else {
            prop.value = value;
            if (prop.pfValue != null) prop.pfValue = value;
            if (isColor) prop.strValue = 'rgb(' + value.join(',') + ')';
            else if (isMulti) prop.strValue = value.join(' ');
            else prop.strValue = '' + value;
            this.updateStyleHints(ele);
        }
        this.checkTriggers(ele, name, oldValue, value);
    }
};
styfn$7.removeAllBypasses = function(eles, updateTransitions) {
    return this.removeBypasses(eles, this.propertyNames, updateTransitions);
};
styfn$7.removeBypasses = function(eles, props, updateTransitions) {
    var isBypass = true;
    for(var j = 0; j < eles.length; j++){
        var ele = eles[j];
        var diffProps = {};
        for(var i = 0; i < props.length; i++){
            var name = props[i];
            var prop = this.properties[name];
            var prevProp = ele.pstyle(prop.name);
            if (!prevProp || !prevProp.bypass) continue;
            var value = ''; // empty => remove bypass
            var parsedProp = this.parse(name, value, true);
            var diffProp = diffProps[prop.name] = {
                prev: prevProp
            };
            this.applyParsedProperty(ele, parsedProp);
            diffProp.next = ele.pstyle(prop.name);
        } // for props
        this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
};
var styfn$6 = {};
// gets what an em size corresponds to in pixels relative to a dom element
styfn$6.getEmSizeInPixels = function() {
    var px = this.containerCss('font-size');
    if (px != null) return parseFloat(px);
    else return 1; // for headless
};
// gets css property from the core container
styfn$6.containerCss = function(propName) {
    var cy = this._private.cy;
    var domElement = cy.container();
    var containerWindow = cy.window();
    if (containerWindow && domElement && containerWindow.getComputedStyle) return containerWindow.getComputedStyle(domElement).getPropertyValue(propName);
};
var styfn$5 = {};
// gets the rendered style for an element
styfn$5.getRenderedStyle = function(ele, prop) {
    if (prop) return this.getStylePropertyValue(ele, prop, true);
    else return this.getRawStyle(ele, true);
};
// gets the raw style for an element
styfn$5.getRawStyle = function(ele, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var rstyle = {};
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var val = self1.getStylePropertyValue(ele, prop.name, isRenderedVal);
            if (val != null) {
                rstyle[prop.name] = val;
                rstyle[dash2camel(prop.name)] = val;
            }
        }
        return rstyle;
    }
};
styfn$5.getIndexedStyle = function(ele, property, subproperty, index) {
    var pstyle = ele.pstyle(property)[subproperty][index];
    return pstyle != null ? pstyle : ele.cy().style().getDefaultProperty(property)[subproperty][0];
};
styfn$5.getStylePropertyValue = function(ele, propName, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var prop = self1.properties[propName];
        if (prop.alias) prop = prop.pointsTo;
        var type = prop.type;
        var styleProp = ele.pstyle(prop.name);
        if (styleProp) {
            var value = styleProp.value, units = styleProp.units, strValue = styleProp.strValue;
            if (isRenderedVal && type.number && value != null && number$1(value)) {
                var zoom = ele.cy().zoom();
                var getRenderedValue = function getRenderedValue(val) {
                    return val * zoom;
                };
                var getValueStringWithUnits = function getValueStringWithUnits(val, units) {
                    return getRenderedValue(val) + units;
                };
                var isArrayValue = array(value);
                var haveUnits = isArrayValue ? units.every(function(u) {
                    return u != null;
                }) : units != null;
                if (haveUnits) {
                    if (isArrayValue) return value.map(function(v, i) {
                        return getValueStringWithUnits(v, units[i]);
                    }).join(' ');
                    else return getValueStringWithUnits(value, units);
                } else {
                    if (isArrayValue) return value.map(function(v) {
                        return string(v) ? v : '' + getRenderedValue(v);
                    }).join(' ');
                    else return '' + getRenderedValue(value);
                }
            } else if (strValue != null) return strValue;
        }
        return null;
    }
};
styfn$5.getAnimationStartStyle = function(ele, aniProps) {
    var rstyle = {};
    for(var i = 0; i < aniProps.length; i++){
        var aniProp = aniProps[i];
        var name = aniProp.name;
        var styleProp = ele.pstyle(name);
        if (styleProp !== undefined) {
            // then make a prop of it
            if (plainObject(styleProp)) styleProp = this.parse(name, styleProp.strValue);
            else styleProp = this.parse(name, styleProp);
        }
        if (styleProp) rstyle[name] = styleProp;
    }
    return rstyle;
};
styfn$5.getPropsList = function(propsObj) {
    var self1 = this;
    var rstyle = [];
    var style = propsObj;
    var props = self1.properties;
    if (style) {
        var names = Object.keys(style);
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            var val = style[name];
            var prop = props[name] || props[camel2dash(name)];
            var styleProp = this.parse(prop.name, val);
            if (styleProp) rstyle.push(styleProp);
        }
    }
    return rstyle;
};
styfn$5.getNonDefaultPropertiesHash = function(ele, propNames, seed) {
    var hash = seed.slice();
    var name, val, strVal, chVal;
    var i, j;
    for(i = 0; i < propNames.length; i++){
        name = propNames[i];
        val = ele.pstyle(name, false);
        if (val == null) continue;
        else if (val.pfValue != null) {
            hash[0] = hashInt(chVal, hash[0]);
            hash[1] = hashIntAlt(chVal, hash[1]);
        } else {
            strVal = val.strValue;
            for(j = 0; j < strVal.length; j++){
                chVal = strVal.charCodeAt(j);
                hash[0] = hashInt(chVal, hash[0]);
                hash[1] = hashIntAlt(chVal, hash[1]);
            }
        }
    }
    return hash;
};
styfn$5.getPropertiesHash = styfn$5.getNonDefaultPropertiesHash;
var styfn$4 = {};
styfn$4.appendFromJson = function(json) {
    var style = this;
    for(var i = 0; i < json.length; i++){
        var context = json[i];
        var selector = context.selector;
        var props = context.style || context.css;
        var names = Object.keys(props);
        style.selector(selector); // apply selector
        for(var j = 0; j < names.length; j++){
            var name = names[j];
            var value = props[name];
            style.css(name, value); // apply property
        }
    }
    return style;
};
// accessible cy.style() function
styfn$4.fromJson = function(json) {
    var style = this;
    style.resetToDefault();
    style.appendFromJson(json);
    return style;
};
// get json from cy.style() api
styfn$4.json = function() {
    var json = [];
    for(var i = this.defaultLength; i < this.length; i++){
        var cxt = this[i];
        var selector = cxt.selector;
        var props = cxt.properties;
        var css = {};
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            css[prop.name] = prop.strValue;
        }
        json.push({
            selector: !selector ? 'core' : selector.toString(),
            style: css
        });
    }
    return json;
};
var styfn$3 = {};
styfn$3.appendFromString = function(string) {
    var self1 = this;
    var style = this;
    var remaining = '' + string;
    var selAndBlockStr;
    var blockRem;
    var propAndValStr;
    // remove comments from the style string
    remaining = remaining.replace(/[/][*](\s|.)+?[*][/]/g, '');
    function removeSelAndBlockFromRemaining() {
        // remove the parsed selector and block from the remaining text to parse
        if (remaining.length > selAndBlockStr.length) remaining = remaining.substr(selAndBlockStr.length);
        else remaining = '';
    }
    function removePropAndValFromRem() {
        // remove the parsed property and value from the remaining block text to parse
        if (blockRem.length > propAndValStr.length) blockRem = blockRem.substr(propAndValStr.length);
        else blockRem = '';
    }
    for(;;){
        var nothingLeftToParse = remaining.match(/^\s*$/);
        if (nothingLeftToParse) break;
        var selAndBlock = remaining.match(/^\s*((?:.|\s)+?)\s*\{((?:.|\s)+?)\}/);
        if (!selAndBlock) {
            warn('Halting stylesheet parsing: String stylesheet contains more to parse but no selector and block found in: ' + remaining);
            break;
        }
        selAndBlockStr = selAndBlock[0];
        // parse the selector
        var selectorStr = selAndBlock[1];
        if (selectorStr !== 'core') {
            var selector = new Selector(selectorStr);
            if (selector.invalid) {
                warn('Skipping parsing of block: Invalid selector found in string stylesheet: ' + selectorStr);
                // skip this selector and block
                removeSelAndBlockFromRemaining();
                continue;
            }
        }
        // parse the block of properties and values
        var blockStr = selAndBlock[2];
        var invalidBlock = false;
        blockRem = blockStr;
        var props = [];
        for(;;){
            var _nothingLeftToParse = blockRem.match(/^\s*$/);
            if (_nothingLeftToParse) break;
            var propAndVal = blockRem.match(/^\s*(.+?)\s*:\s*(.+?)(?:\s*;|\s*$)/);
            if (!propAndVal) {
                warn('Skipping parsing of block: Invalid formatting of style property and value definitions found in:' + blockStr);
                invalidBlock = true;
                break;
            }
            propAndValStr = propAndVal[0];
            var propStr = propAndVal[1];
            var valStr = propAndVal[2];
            var prop = self1.properties[propStr];
            if (!prop) {
                warn('Skipping property: Invalid property name in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            var parsedProp = style.parse(propStr, valStr);
            if (!parsedProp) {
                warn('Skipping property: Invalid property definition in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            props.push({
                name: propStr,
                val: valStr
            });
            removePropAndValFromRem();
        }
        if (invalidBlock) {
            removeSelAndBlockFromRemaining();
            break;
        }
        // put the parsed block in the style
        style.selector(selectorStr);
        for(var i = 0; i < props.length; i++){
            var _prop = props[i];
            style.css(_prop.name, _prop.val);
        }
        removeSelAndBlockFromRemaining();
    }
    return style;
};
styfn$3.fromString = function(string) {
    var style = this;
    style.resetToDefault();
    style.appendFromString(string);
    return style;
};
var styfn$2 = {};
(function() {
    var number$1 = number;
    var rgba = rgbaNoBackRefs;
    var hsla = hslaNoBackRefs;
    var hex3$1 = hex3;
    var hex6$1 = hex6;
    var data = function data(prefix) {
        return '^' + prefix + '\\s*\\(\\s*([\\w\\.]+)\\s*\\)$';
    };
    var mapData = function mapData(prefix) {
        var mapArg = number$1 + '|\\w+|' + rgba + '|' + hsla + '|' + hex3$1 + '|' + hex6$1;
        return '^' + prefix + '\\s*\\(([\\w\\.]+)\\s*\\,\\s*(' + number$1 + ')\\s*\\,\\s*(' + number$1 + ')\\s*,\\s*(' + mapArg + ')\\s*\\,\\s*(' + mapArg + ')\\)$';
    };
    var urlRegexes = [
        '^url\\s*\\(\\s*[\'"]?(.+?)[\'"]?\\s*\\)$',
        '^(none)$',
        '^(.+)$'
    ];
    // each visual style property has a type and needs to be validated according to it
    styfn$2.types = {
        time: {
            number: true,
            min: 0,
            units: 's|ms',
            implicitUnits: 'ms'
        },
        percent: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%'
        },
        percentages: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%',
            multiple: true
        },
        zeroOneNumber: {
            number: true,
            min: 0,
            max: 1,
            unitless: true
        },
        zeroOneNumbers: {
            number: true,
            min: 0,
            max: 1,
            unitless: true,
            multiple: true
        },
        nOneOneNumber: {
            number: true,
            min: -1,
            max: 1,
            unitless: true
        },
        nonNegativeInt: {
            number: true,
            min: 0,
            integer: true,
            unitless: true
        },
        nonNegativeNumber: {
            number: true,
            min: 0,
            unitless: true
        },
        position: {
            enums: [
                'parent',
                'origin'
            ]
        },
        nodeSize: {
            number: true,
            min: 0,
            enums: [
                'label'
            ]
        },
        number: {
            number: true,
            unitless: true
        },
        numbers: {
            number: true,
            unitless: true,
            multiple: true
        },
        positiveNumber: {
            number: true,
            unitless: true,
            min: 0,
            strictMin: true
        },
        size: {
            number: true,
            min: 0
        },
        bidirectionalSize: {
            number: true
        },
        // allows negative
        bidirectionalSizeMaybePercent: {
            number: true,
            allowPercent: true
        },
        // allows negative
        bidirectionalSizes: {
            number: true,
            multiple: true
        },
        // allows negative
        sizeMaybePercent: {
            number: true,
            min: 0,
            allowPercent: true
        },
        axisDirection: {
            enums: [
                'horizontal',
                'leftward',
                'rightward',
                'vertical',
                'upward',
                'downward',
                'auto'
            ]
        },
        paddingRelativeTo: {
            enums: [
                'width',
                'height',
                'average',
                'min',
                'max'
            ]
        },
        bgWH: {
            number: true,
            min: 0,
            allowPercent: true,
            enums: [
                'auto'
            ],
            multiple: true
        },
        bgPos: {
            number: true,
            allowPercent: true,
            multiple: true
        },
        bgRelativeTo: {
            enums: [
                'inner',
                'include-padding'
            ],
            multiple: true
        },
        bgRepeat: {
            enums: [
                'repeat',
                'repeat-x',
                'repeat-y',
                'no-repeat'
            ],
            multiple: true
        },
        bgFit: {
            enums: [
                'none',
                'contain',
                'cover'
            ],
            multiple: true
        },
        bgCrossOrigin: {
            enums: [
                'anonymous',
                'use-credentials',
                'null'
            ],
            multiple: true
        },
        bgClip: {
            enums: [
                'none',
                'node'
            ],
            multiple: true
        },
        bgContainment: {
            enums: [
                'inside',
                'over'
            ],
            multiple: true
        },
        color: {
            color: true
        },
        colors: {
            color: true,
            multiple: true
        },
        fill: {
            enums: [
                'solid',
                'linear-gradient',
                'radial-gradient'
            ]
        },
        bool: {
            enums: [
                'yes',
                'no'
            ]
        },
        bools: {
            enums: [
                'yes',
                'no'
            ],
            multiple: true
        },
        lineStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed'
            ]
        },
        lineCap: {
            enums: [
                'butt',
                'round',
                'square'
            ]
        },
        linePosition: {
            enums: [
                'center',
                'inside',
                'outside'
            ]
        },
        lineJoin: {
            enums: [
                'round',
                'bevel',
                'miter'
            ]
        },
        borderStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed',
                'double'
            ]
        },
        curveStyle: {
            enums: [
                'bezier',
                'unbundled-bezier',
                'haystack',
                'segments',
                'straight',
                'straight-triangle',
                'taxi',
                'round-segments',
                'round-taxi'
            ]
        },
        radiusType: {
            enums: [
                'arc-radius',
                'influence-radius'
            ],
            multiple: true
        },
        fontFamily: {
            regex: '^([\\w- \\"]+(?:\\s*,\\s*[\\w- \\"]+)*)$'
        },
        fontStyle: {
            enums: [
                'italic',
                'normal',
                'oblique'
            ]
        },
        fontWeight: {
            enums: [
                'normal',
                'bold',
                'bolder',
                'lighter',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '800',
                '900',
                100,
                200,
                300,
                400,
                500,
                600,
                700,
                800,
                900
            ]
        },
        textDecoration: {
            enums: [
                'none',
                'underline',
                'overline',
                'line-through'
            ]
        },
        textTransform: {
            enums: [
                'none',
                'uppercase',
                'lowercase'
            ]
        },
        textWrap: {
            enums: [
                'none',
                'wrap',
                'ellipsis'
            ]
        },
        textOverflowWrap: {
            enums: [
                'whitespace',
                'anywhere'
            ]
        },
        textBackgroundShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle'
            ]
        },
        nodeShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle',
                'cutrectangle',
                'cut-rectangle',
                'bottomroundrectangle',
                'bottom-round-rectangle',
                'barrel',
                'ellipse',
                'triangle',
                'round-triangle',
                'square',
                'pentagon',
                'round-pentagon',
                'hexagon',
                'round-hexagon',
                'concavehexagon',
                'concave-hexagon',
                'heptagon',
                'round-heptagon',
                'octagon',
                'round-octagon',
                'tag',
                'round-tag',
                'star',
                'diamond',
                'round-diamond',
                'vee',
                'rhomboid',
                'right-rhomboid',
                'polygon'
            ]
        },
        overlayShape: {
            enums: [
                'roundrectangle',
                'round-rectangle',
                'ellipse'
            ]
        },
        cornerRadius: {
            number: true,
            min: 0,
            units: 'px|em',
            implicitUnits: 'px',
            enums: [
                'auto'
            ]
        },
        compoundIncludeLabels: {
            enums: [
                'include',
                'exclude'
            ]
        },
        arrowShape: {
            enums: [
                'tee',
                'triangle',
                'triangle-tee',
                'circle-triangle',
                'triangle-cross',
                'triangle-backcurve',
                'vee',
                'square',
                'circle',
                'diamond',
                'chevron',
                'none'
            ]
        },
        arrowFill: {
            enums: [
                'filled',
                'hollow'
            ]
        },
        arrowWidth: {
            number: true,
            units: '%|px|em',
            implicitUnits: 'px',
            enums: [
                'match-line'
            ]
        },
        display: {
            enums: [
                'element',
                'none'
            ]
        },
        visibility: {
            enums: [
                'hidden',
                'visible'
            ]
        },
        zCompoundDepth: {
            enums: [
                'bottom',
                'orphan',
                'auto',
                'top'
            ]
        },
        zIndexCompare: {
            enums: [
                'auto',
                'manual'
            ]
        },
        valign: {
            enums: [
                'top',
                'center',
                'bottom'
            ]
        },
        halign: {
            enums: [
                'left',
                'center',
                'right'
            ]
        },
        justification: {
            enums: [
                'left',
                'center',
                'right',
                'auto'
            ]
        },
        text: {
            string: true
        },
        data: {
            mapping: true,
            regex: data('data')
        },
        layoutData: {
            mapping: true,
            regex: data('layoutData')
        },
        scratch: {
            mapping: true,
            regex: data('scratch')
        },
        mapData: {
            mapping: true,
            regex: mapData('mapData')
        },
        mapLayoutData: {
            mapping: true,
            regex: mapData('mapLayoutData')
        },
        mapScratch: {
            mapping: true,
            regex: mapData('mapScratch')
        },
        fn: {
            mapping: true,
            fn: true
        },
        url: {
            regexes: urlRegexes,
            singleRegexMatchValue: true
        },
        urls: {
            regexes: urlRegexes,
            singleRegexMatchValue: true,
            multiple: true
        },
        propList: {
            propList: true
        },
        angle: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad'
        },
        textRotation: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad',
            enums: [
                'none',
                'autorotate'
            ]
        },
        polygonPointList: {
            number: true,
            multiple: true,
            evenMultiple: true,
            min: -1,
            max: 1,
            unitless: true
        },
        edgeDistances: {
            enums: [
                'intersection',
                'node-position',
                'endpoints'
            ]
        },
        edgeEndpoint: {
            number: true,
            multiple: true,
            units: '%|px|em|deg|rad',
            implicitUnits: 'px',
            enums: [
                'inside-to-node',
                'outside-to-node',
                'outside-to-node-or-label',
                'outside-to-line',
                'outside-to-line-or-label'
            ],
            singleEnum: true,
            validate: function validate(valArr, unitsArr) {
                switch(valArr.length){
                    case 2:
                        // can be % or px only
                        return unitsArr[0] !== 'deg' && unitsArr[0] !== 'rad' && unitsArr[1] !== 'deg' && unitsArr[1] !== 'rad';
                    case 1:
                        // can be enum, deg, or rad only
                        return string(valArr[0]) || unitsArr[0] === 'deg' || unitsArr[0] === 'rad';
                    default:
                        return false;
                }
            }
        },
        easing: {
            regexes: [
                '^(spring)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$',
                '^(cubic-bezier)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$'
            ],
            enums: [
                'linear',
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'ease-in-sine',
                'ease-out-sine',
                'ease-in-out-sine',
                'ease-in-quad',
                'ease-out-quad',
                'ease-in-out-quad',
                'ease-in-cubic',
                'ease-out-cubic',
                'ease-in-out-cubic',
                'ease-in-quart',
                'ease-out-quart',
                'ease-in-out-quart',
                'ease-in-quint',
                'ease-out-quint',
                'ease-in-out-quint',
                'ease-in-expo',
                'ease-out-expo',
                'ease-in-out-expo',
                'ease-in-circ',
                'ease-out-circ',
                'ease-in-out-circ'
            ]
        },
        gradientDirection: {
            enums: [
                'to-bottom',
                'to-top',
                'to-left',
                'to-right',
                'to-bottom-right',
                'to-bottom-left',
                'to-top-right',
                'to-top-left',
                'to-right-bottom',
                'to-left-bottom',
                'to-right-top',
                'to-left-top' // different order
            ]
        },
        boundsExpansion: {
            number: true,
            multiple: true,
            min: 0,
            validate: function validate(valArr) {
                var length = valArr.length;
                return length === 1 || length === 2 || length === 4;
            }
        }
    };
    var diff = {
        zeroNonZero: function zeroNonZero(val1, val2) {
            if ((val1 == null || val2 == null) && val1 !== val2) return true; // null cases could represent any value
            if (val1 == 0 && val2 != 0) return true;
            else if (val1 != 0 && val2 == 0) return true;
            else return false;
        },
        any: function any(val1, val2) {
            return val1 != val2;
        },
        emptyNonEmpty: function emptyNonEmpty(str1, str2) {
            var empty1 = emptyString(str1);
            var empty2 = emptyString(str2);
            return empty1 && !empty2 || !empty1 && empty2;
        }
    };
    // define visual style properties
    //
    // - n.b. adding a new group of props may require updates to updateStyleHints()
    // - adding new props to an existing group gets handled automatically
    var t = styfn$2.types;
    var mainLabel = [
        {
            name: 'label',
            type: t.text,
            triggersBounds: diff.any,
            triggersZOrder: diff.emptyNonEmpty
        },
        {
            name: 'text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        }
    ];
    var sourceLabel = [
        {
            name: 'source-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var targetLabel = [
        {
            name: 'target-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var labelDimensions = [
        {
            name: 'font-family',
            type: t.fontFamily,
            triggersBounds: diff.any
        },
        {
            name: 'font-style',
            type: t.fontStyle,
            triggersBounds: diff.any
        },
        {
            name: 'font-weight',
            type: t.fontWeight,
            triggersBounds: diff.any
        },
        {
            name: 'font-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-transform',
            type: t.textTransform,
            triggersBounds: diff.any
        },
        {
            name: 'text-wrap',
            type: t.textWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-overflow-wrap',
            type: t.textOverflowWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-max-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'line-height',
            type: t.positiveNumber,
            triggersBounds: diff.any
        }
    ];
    var commonLabel = [
        {
            name: 'text-valign',
            type: t.valign,
            triggersBounds: diff.any
        },
        {
            name: 'text-halign',
            type: t.halign,
            triggersBounds: diff.any
        },
        {
            name: 'color',
            type: t.color
        },
        {
            name: 'text-outline-color',
            type: t.color
        },
        {
            name: 'text-outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-color',
            type: t.color
        },
        {
            name: 'text-background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-border-color',
            type: t.color
        },
        {
            name: 'text-border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-style',
            type: t.borderStyle,
            triggersBounds: diff.any
        },
        {
            name: 'text-background-shape',
            type: t.textBackgroundShape,
            triggersBounds: diff.any
        },
        {
            name: 'text-justification',
            type: t.justification
        }
    ];
    var behavior = [
        {
            name: 'events',
            type: t.bool,
            triggersZOrder: diff.any
        },
        {
            name: 'text-events',
            type: t.bool,
            triggersZOrder: diff.any
        }
    ];
    var visibility = [
        {
            name: 'display',
            type: t.display,
            triggersZOrder: diff.any,
            triggersBounds: diff.any,
            triggersBoundsOfConnectedEdges: diff.any,
            triggersBoundsOfParallelEdges: function triggersBoundsOfParallelEdges(fromValue, toValue, ele) {
                if (fromValue === toValue) return false;
                // only if edge is bundled bezier (so as not to affect performance of other edges)
                return ele.pstyle('curve-style').value === 'bezier';
            }
        },
        {
            name: 'visibility',
            type: t.visibility,
            triggersZOrder: diff.any
        },
        {
            name: 'opacity',
            type: t.zeroOneNumber,
            triggersZOrder: diff.zeroNonZero
        },
        {
            name: 'text-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'min-zoomed-font-size',
            type: t.size
        },
        {
            name: 'z-compound-depth',
            type: t.zCompoundDepth,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index-compare',
            type: t.zIndexCompare,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index',
            type: t.number,
            triggersZOrder: diff.any
        }
    ];
    var overlay = [
        {
            name: 'overlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-color',
            type: t.color
        },
        {
            name: 'overlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'overlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var underlay = [
        {
            name: 'underlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-color',
            type: t.color
        },
        {
            name: 'underlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'underlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var transition = [
        {
            name: 'transition-property',
            type: t.propList
        },
        {
            name: 'transition-duration',
            type: t.time
        },
        {
            name: 'transition-delay',
            type: t.time
        },
        {
            name: 'transition-timing-function',
            type: t.easing
        }
    ];
    var nodeSizeHashOverride = function nodeSizeHashOverride(ele, parsedProp) {
        if (parsedProp.value === 'label') return -ele.poolIndex(); // no hash key hits is using label size (hitrate for perf probably low anyway)
        else return parsedProp.pfValue;
    };
    var nodeBody = [
        {
            name: 'height',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'width',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'shape',
            type: t.nodeShape,
            triggersBounds: diff.any
        },
        {
            name: 'shape-polygon-points',
            type: t.polygonPointList,
            triggersBounds: diff.any
        },
        {
            name: 'corner-radius',
            type: t.cornerRadius
        },
        {
            name: 'background-color',
            type: t.color
        },
        {
            name: 'background-fill',
            type: t.fill
        },
        {
            name: 'background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'background-blacken',
            type: t.nOneOneNumber
        },
        {
            name: 'background-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'background-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'background-gradient-direction',
            type: t.gradientDirection
        },
        {
            name: 'padding',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'padding-relative-to',
            type: t.paddingRelativeTo,
            triggersBounds: diff.any
        },
        {
            name: 'bounds-expansion',
            type: t.boundsExpansion,
            triggersBounds: diff.any
        }
    ];
    var nodeBorder = [
        {
            name: 'border-color',
            type: t.color
        },
        {
            name: 'border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'border-style',
            type: t.borderStyle
        },
        {
            name: 'border-cap',
            type: t.lineCap
        },
        {
            name: 'border-join',
            type: t.lineJoin
        },
        {
            name: 'border-dash-pattern',
            type: t.numbers
        },
        {
            name: 'border-dash-offset',
            type: t.number
        },
        {
            name: 'border-position',
            type: t.linePosition
        }
    ];
    var nodeOutline = [
        {
            name: 'outline-color',
            type: t.color
        },
        {
            name: 'outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'outline-style',
            type: t.borderStyle
        },
        {
            name: 'outline-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var backgroundImage = [
        {
            name: 'background-image',
            type: t.urls
        },
        {
            name: 'background-image-crossorigin',
            type: t.bgCrossOrigin
        },
        {
            name: 'background-image-opacity',
            type: t.zeroOneNumbers
        },
        {
            name: 'background-image-containment',
            type: t.bgContainment
        },
        {
            name: 'background-image-smoothing',
            type: t.bools
        },
        {
            name: 'background-position-x',
            type: t.bgPos
        },
        {
            name: 'background-position-y',
            type: t.bgPos
        },
        {
            name: 'background-width-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-height-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-repeat',
            type: t.bgRepeat
        },
        {
            name: 'background-fit',
            type: t.bgFit
        },
        {
            name: 'background-clip',
            type: t.bgClip
        },
        {
            name: 'background-width',
            type: t.bgWH
        },
        {
            name: 'background-height',
            type: t.bgWH
        },
        {
            name: 'background-offset-x',
            type: t.bgPos
        },
        {
            name: 'background-offset-y',
            type: t.bgPos
        }
    ];
    var compound = [
        {
            name: 'position',
            type: t.position,
            triggersBounds: diff.any
        },
        {
            name: 'compound-sizing-wrt-labels',
            type: t.compoundIncludeLabels,
            triggersBounds: diff.any
        },
        {
            name: 'min-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-left',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-right',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-top',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-bottom',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        }
    ];
    var edgeLine = [
        {
            name: 'line-style',
            type: t.lineStyle
        },
        {
            name: 'line-color',
            type: t.color
        },
        {
            name: 'line-fill',
            type: t.fill
        },
        {
            name: 'line-cap',
            type: t.lineCap
        },
        {
            name: 'line-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'line-dash-pattern',
            type: t.numbers
        },
        {
            name: 'line-dash-offset',
            type: t.number
        },
        {
            name: 'line-outline-width',
            type: t.size
        },
        {
            name: 'line-outline-color',
            type: t.color
        },
        {
            name: 'line-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'line-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'curve-style',
            type: t.curveStyle,
            triggersBounds: diff.any,
            triggersBoundsOfParallelEdges: function triggersBoundsOfParallelEdges(fromValue, toValue) {
                if (fromValue === toValue) return false;
                 // must have diff
                return fromValue === 'bezier' || // remove from bundle
                toValue === 'bezier'; // add to bundle
            }
        },
        {
            name: 'haystack-radius',
            type: t.zeroOneNumber,
            triggersBounds: diff.any
        },
        {
            name: 'source-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'target-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-step-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'segment-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-radii',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'radius-type',
            type: t.radiusType,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn',
            type: t.bidirectionalSizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn-min-distance',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-direction',
            type: t.axisDirection,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-radius',
            type: t.number,
            triggersBounds: diff.any
        },
        {
            name: 'edge-distances',
            type: t.edgeDistances,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-scale',
            type: t.positiveNumber,
            triggersBounds: diff.any
        },
        {
            name: 'loop-direction',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'loop-sweep',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'source-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'target-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var ghost = [
        {
            name: 'ghost',
            type: t.bool,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-opacity',
            type: t.zeroOneNumber
        }
    ];
    var core = [
        {
            name: 'selection-box-color',
            type: t.color
        },
        {
            name: 'selection-box-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'selection-box-border-color',
            type: t.color
        },
        {
            name: 'selection-box-border-width',
            type: t.size
        },
        {
            name: 'active-bg-color',
            type: t.color
        },
        {
            name: 'active-bg-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'active-bg-size',
            type: t.size
        },
        {
            name: 'outside-texture-bg-color',
            type: t.color
        },
        {
            name: 'outside-texture-bg-opacity',
            type: t.zeroOneNumber
        }
    ];
    // pie backgrounds for nodes
    var pie = [];
    styfn$2.pieBackgroundN = 16; // because the pie properties are numbered, give access to a constant N (for renderer use)
    pie.push({
        name: 'pie-size',
        type: t.sizeMaybePercent
    });
    for(var i = 1; i <= styfn$2.pieBackgroundN; i++){
        pie.push({
            name: 'pie-' + i + '-background-color',
            type: t.color
        });
        pie.push({
            name: 'pie-' + i + '-background-size',
            type: t.percent
        });
        pie.push({
            name: 'pie-' + i + '-background-opacity',
            type: t.zeroOneNumber
        });
    }
    // edge arrows
    var edgeArrow = [];
    var arrowPrefixes = styfn$2.arrowPrefixes = [
        'source',
        'mid-source',
        'target',
        'mid-target'
    ];
    [
        {
            name: 'arrow-shape',
            type: t.arrowShape,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-color',
            type: t.color
        },
        {
            name: 'arrow-fill',
            type: t.arrowFill
        },
        {
            name: 'arrow-width',
            type: t.arrowWidth
        }
    ].forEach(function(prop) {
        arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var type = prop.type, triggersBounds = prop.triggersBounds;
            edgeArrow.push({
                name: name,
                type: type,
                triggersBounds: triggersBounds
            });
        });
    }, {});
    var props = styfn$2.properties = [].concat(behavior, transition, visibility, overlay, underlay, ghost, commonLabel, labelDimensions, mainLabel, sourceLabel, targetLabel, nodeBody, nodeBorder, nodeOutline, backgroundImage, pie, compound, edgeLine, edgeArrow, core);
    var propGroups = styfn$2.propertyGroups = {
        // common to all eles
        behavior: behavior,
        transition: transition,
        visibility: visibility,
        overlay: overlay,
        underlay: underlay,
        ghost: ghost,
        // labels
        commonLabel: commonLabel,
        labelDimensions: labelDimensions,
        mainLabel: mainLabel,
        sourceLabel: sourceLabel,
        targetLabel: targetLabel,
        // node props
        nodeBody: nodeBody,
        nodeBorder: nodeBorder,
        nodeOutline: nodeOutline,
        backgroundImage: backgroundImage,
        pie: pie,
        compound: compound,
        // edge props
        edgeLine: edgeLine,
        edgeArrow: edgeArrow,
        core: core
    };
    var propGroupNames = styfn$2.propertyGroupNames = {};
    var propGroupKeys = styfn$2.propertyGroupKeys = Object.keys(propGroups);
    propGroupKeys.forEach(function(key) {
        propGroupNames[key] = propGroups[key].map(function(prop) {
            return prop.name;
        });
        propGroups[key].forEach(function(prop) {
            return prop.groupKey = key;
        });
    });
    // define aliases
    var aliases = styfn$2.aliases = [
        {
            name: 'content',
            pointsTo: 'label'
        },
        {
            name: 'control-point-distance',
            pointsTo: 'control-point-distances'
        },
        {
            name: 'control-point-weight',
            pointsTo: 'control-point-weights'
        },
        {
            name: 'segment-distance',
            pointsTo: 'segment-distances'
        },
        {
            name: 'segment-weight',
            pointsTo: 'segment-weights'
        },
        {
            name: 'segment-radius',
            pointsTo: 'segment-radii'
        },
        {
            name: 'edge-text-rotation',
            pointsTo: 'text-rotation'
        },
        {
            name: 'padding-left',
            pointsTo: 'padding'
        },
        {
            name: 'padding-right',
            pointsTo: 'padding'
        },
        {
            name: 'padding-top',
            pointsTo: 'padding'
        },
        {
            name: 'padding-bottom',
            pointsTo: 'padding'
        }
    ];
    // list of property names
    styfn$2.propertyNames = props.map(function(p) {
        return p.name;
    });
    // allow access of properties by name ( e.g. style.properties.height )
    for(var _i = 0; _i < props.length; _i++){
        var prop = props[_i];
        props[prop.name] = prop; // allow lookup by name
    }
    // map aliases
    for(var _i2 = 0; _i2 < aliases.length; _i2++){
        var alias = aliases[_i2];
        var pointsToProp = props[alias.pointsTo];
        var aliasProp = {
            name: alias.name,
            alias: true,
            pointsTo: pointsToProp
        };
        // add alias prop for parsing
        props.push(aliasProp);
        props[alias.name] = aliasProp; // allow lookup by name
    }
})();
styfn$2.getDefaultProperty = function(name) {
    return this.getDefaultProperties()[name];
};
styfn$2.getDefaultProperties = function() {
    var _p = this._private;
    if (_p.defaultProperties != null) return _p.defaultProperties;
    var rawProps = extend({
        // core props
        'selection-box-color': '#ddd',
        'selection-box-opacity': 0.65,
        'selection-box-border-color': '#aaa',
        'selection-box-border-width': 1,
        'active-bg-color': 'black',
        'active-bg-opacity': 0.15,
        'active-bg-size': 30,
        'outside-texture-bg-color': '#000',
        'outside-texture-bg-opacity': 0.125,
        // common node/edge props
        'events': 'yes',
        'text-events': 'no',
        'text-valign': 'top',
        'text-halign': 'center',
        'text-justification': 'auto',
        'line-height': 1,
        'color': '#000',
        'text-outline-color': '#000',
        'text-outline-width': 0,
        'text-outline-opacity': 1,
        'text-opacity': 1,
        'text-decoration': 'none',
        'text-transform': 'none',
        'text-wrap': 'none',
        'text-overflow-wrap': 'whitespace',
        'text-max-width': 9999,
        'text-background-color': '#000',
        'text-background-opacity': 0,
        'text-background-shape': 'rectangle',
        'text-background-padding': 0,
        'text-border-opacity': 0,
        'text-border-width': 0,
        'text-border-style': 'solid',
        'text-border-color': '#000',
        'font-family': 'Helvetica Neue, Helvetica, sans-serif',
        'font-style': 'normal',
        'font-weight': 'normal',
        'font-size': 16,
        'min-zoomed-font-size': 0,
        'text-rotation': 'none',
        'source-text-rotation': 'none',
        'target-text-rotation': 'none',
        'visibility': 'visible',
        'display': 'element',
        'opacity': 1,
        'z-compound-depth': 'auto',
        'z-index-compare': 'auto',
        'z-index': 0,
        'label': '',
        'text-margin-x': 0,
        'text-margin-y': 0,
        'source-label': '',
        'source-text-offset': 0,
        'source-text-margin-x': 0,
        'source-text-margin-y': 0,
        'target-label': '',
        'target-text-offset': 0,
        'target-text-margin-x': 0,
        'target-text-margin-y': 0,
        'overlay-opacity': 0,
        'overlay-color': '#000',
        'overlay-padding': 10,
        'overlay-shape': 'round-rectangle',
        'overlay-corner-radius': 'auto',
        'underlay-opacity': 0,
        'underlay-color': '#000',
        'underlay-padding': 10,
        'underlay-shape': 'round-rectangle',
        'underlay-corner-radius': 'auto',
        'transition-property': 'none',
        'transition-duration': 0,
        'transition-delay': 0,
        'transition-timing-function': 'linear',
        // node props
        'background-blacken': 0,
        'background-color': '#999',
        'background-fill': 'solid',
        'background-opacity': 1,
        'background-image': 'none',
        'background-image-crossorigin': 'anonymous',
        'background-image-opacity': 1,
        'background-image-containment': 'inside',
        'background-image-smoothing': 'yes',
        'background-position-x': '50%',
        'background-position-y': '50%',
        'background-offset-x': 0,
        'background-offset-y': 0,
        'background-width-relative-to': 'include-padding',
        'background-height-relative-to': 'include-padding',
        'background-repeat': 'no-repeat',
        'background-fit': 'none',
        'background-clip': 'node',
        'background-width': 'auto',
        'background-height': 'auto',
        'border-color': '#000',
        'border-opacity': 1,
        'border-width': 0,
        'border-style': 'solid',
        'border-dash-pattern': [
            4,
            2
        ],
        'border-dash-offset': 0,
        'border-cap': 'butt',
        'border-join': 'miter',
        'border-position': 'center',
        'outline-color': '#999',
        'outline-opacity': 1,
        'outline-width': 0,
        'outline-offset': 0,
        'outline-style': 'solid',
        'height': 30,
        'width': 30,
        'shape': 'ellipse',
        'shape-polygon-points': '-1, -1,   1, -1,   1, 1,   -1, 1',
        'corner-radius': 'auto',
        'bounds-expansion': 0,
        // node gradient
        'background-gradient-direction': 'to-bottom',
        'background-gradient-stop-colors': '#999',
        'background-gradient-stop-positions': '0%',
        // ghost props
        'ghost': 'no',
        'ghost-offset-y': 0,
        'ghost-offset-x': 0,
        'ghost-opacity': 0,
        // compound props
        'padding': 0,
        'padding-relative-to': 'width',
        'position': 'origin',
        'compound-sizing-wrt-labels': 'include',
        'min-width': 0,
        'min-width-bias-left': 0,
        'min-width-bias-right': 0,
        'min-height': 0,
        'min-height-bias-top': 0,
        'min-height-bias-bottom': 0
    }, {
        // node pie bg
        'pie-size': '100%'
    }, [
        {
            name: 'pie-{{i}}-background-color',
            value: 'black'
        },
        {
            name: 'pie-{{i}}-background-size',
            value: '0%'
        },
        {
            name: 'pie-{{i}}-background-opacity',
            value: 1
        }
    ].reduce(function(css, prop) {
        for(var i = 1; i <= styfn$2.pieBackgroundN; i++){
            var name = prop.name.replace('{{i}}', i);
            var val = prop.value;
            css[name] = val;
        }
        return css;
    }, {}), {
        // edge props
        'line-style': 'solid',
        'line-color': '#999',
        'line-fill': 'solid',
        'line-cap': 'butt',
        'line-opacity': 1,
        'line-outline-width': 0,
        'line-outline-color': '#000',
        'line-gradient-stop-colors': '#999',
        'line-gradient-stop-positions': '0%',
        'control-point-step-size': 40,
        'control-point-weights': 0.5,
        'segment-weights': 0.5,
        'segment-distances': 20,
        'segment-radii': 15,
        'radius-type': 'arc-radius',
        'taxi-turn': '50%',
        'taxi-radius': 15,
        'taxi-turn-min-distance': 10,
        'taxi-direction': 'auto',
        'edge-distances': 'intersection',
        'curve-style': 'haystack',
        'haystack-radius': 0,
        'arrow-scale': 1,
        'loop-direction': '-45deg',
        'loop-sweep': '-90deg',
        'source-distance-from-node': 0,
        'target-distance-from-node': 0,
        'source-endpoint': 'outside-to-node',
        'target-endpoint': 'outside-to-node',
        'line-dash-pattern': [
            6,
            3
        ],
        'line-dash-offset': 0
    }, [
        {
            name: 'arrow-shape',
            value: 'none'
        },
        {
            name: 'arrow-color',
            value: '#999'
        },
        {
            name: 'arrow-fill',
            value: 'filled'
        },
        {
            name: 'arrow-width',
            value: 1
        }
    ].reduce(function(css, prop) {
        styfn$2.arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var val = prop.value;
            css[name] = val;
        });
        return css;
    }, {}));
    var parsedProps = {};
    for(var i = 0; i < this.properties.length; i++){
        var prop = this.properties[i];
        if (prop.pointsTo) continue;
        var name = prop.name;
        var val = rawProps[name];
        var parsedProp = this.parse(name, val);
        parsedProps[name] = parsedProp;
    }
    _p.defaultProperties = parsedProps;
    return _p.defaultProperties;
};
styfn$2.addDefaultStylesheet = function() {
    this.selector(':parent').css({
        'shape': 'rectangle',
        'padding': 10,
        'background-color': '#eee',
        'border-color': '#ccc',
        'border-width': 1
    }).selector('edge').css({
        'width': 3
    }).selector(':loop').css({
        'curve-style': 'bezier'
    }).selector('edge:compound').css({
        'curve-style': 'bezier',
        'source-endpoint': 'outside-to-line',
        'target-endpoint': 'outside-to-line'
    }).selector(':selected').css({
        'background-color': '#0169D9',
        'line-color': '#0169D9',
        'source-arrow-color': '#0169D9',
        'target-arrow-color': '#0169D9',
        'mid-source-arrow-color': '#0169D9',
        'mid-target-arrow-color': '#0169D9'
    }).selector(':parent:selected').css({
        'background-color': '#CCE1F9',
        'border-color': '#aec8e5'
    }).selector(':active').css({
        'overlay-color': 'black',
        'overlay-padding': 10,
        'overlay-opacity': 0.25
    });
    this.defaultLength = this.length;
};
var styfn$1 = {};
// a caching layer for property parsing
styfn$1.parse = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    // function values can't be cached in all cases, and there isn't much benefit of caching them anyway
    if (fn$6(value)) return self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    var flatKey = propIsFlat === 'mapping' || propIsFlat === true || propIsFlat === false || propIsFlat == null ? 'dontcare' : propIsFlat;
    var bypassKey = propIsBypass ? 't' : 'f';
    var valueKey = '' + value;
    var argHash = hashStrings(name, valueKey, bypassKey, flatKey);
    var propCache = self1.propCache = self1.propCache || [];
    var ret;
    if (!(ret = propCache[argHash])) ret = propCache[argHash] = self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    // - bypasses can't be shared b/c the value can be changed by animations or otherwise overridden
    // - mappings can't be shared b/c mappings are per-element
    if (propIsBypass || propIsFlat === 'mapping') {
        // need a copy since props are mutated later in their lifecycles
        ret = copy(ret);
        if (ret) ret.value = copy(ret.value); // because it could be an array, e.g. colour
    }
    return ret;
};
styfn$1.parseImplWarn = function(name, value, propIsBypass, propIsFlat) {
    var prop = this.parseImpl(name, value, propIsBypass, propIsFlat);
    if (!prop && value != null) warn("The style property `".concat(name, ": ").concat(value, "` is invalid"));
    if (prop && (prop.name === 'width' || prop.name === 'height') && value === 'label') warn('The style value of `label` is deprecated for `' + prop.name + '`');
    return prop;
};
// parse a property; return null on invalid; return parsed property otherwise
// fields :
// - name : the name of the property
// - value : the parsed, native-typed value of the property
// - strValue : a string value that represents the property value in valid css
// - bypass : true iff the property is a bypass property
styfn$1.parseImpl = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    name = camel2dash(name); // make sure the property name is in dash form (e.g. 'property-name' not 'propertyName')
    var property = self1.properties[name];
    var passedValue = value;
    var types = self1.types;
    if (!property) return null;
     // return null on property of unknown name
    if (value === undefined) return null;
     // can't assign undefined
    // the property may be an alias
    if (property.alias) {
        property = property.pointsTo;
        name = property.name;
    }
    var valueIsString = string(value);
    if (valueIsString) // trim the value to make parsing easier
    value = value.trim();
    var type = property.type;
    if (!type) return null;
     // no type, no luck
    // check if bypass is null or empty string (i.e. indication to delete bypass property)
    if (propIsBypass && (value === '' || value === null)) return {
        name: name,
        value: value,
        bypass: true,
        deleteBypass: true
    };
    // check if value is a function used as a mapper
    if (fn$6(value)) return {
        name: name,
        value: value,
        strValue: 'fn',
        mapped: types.fn,
        bypass: propIsBypass
    };
    // check if value is mapped
    var data, mapData;
    if (!valueIsString || propIsFlat || value.length < 7 || value[1] !== 'a') ;
    else if (value.length >= 7 && value[0] === 'd' && (data = new RegExp(types.data.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        var mapped = types.data;
        return {
            name: name,
            value: data,
            strValue: '' + value,
            mapped: mapped,
            field: data[1],
            bypass: propIsBypass
        };
    } else if (value.length >= 10 && value[0] === 'm' && (mapData = new RegExp(types.mapData.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        if (type.multiple) return false;
         // impossible to map to num
        var _mapped = types.mapData;
        // we can map only if the type is a colour or a number
        if (!(type.color || type.number)) return false;
        var valueMin = this.parse(name, mapData[4]); // parse to validate
        if (!valueMin || valueMin.mapped) return false;
         // can't be invalid or mapped
        var valueMax = this.parse(name, mapData[5]); // parse to validate
        if (!valueMax || valueMax.mapped) return false;
         // can't be invalid or mapped
        // check if valueMin and valueMax are the same
        if (valueMin.pfValue === valueMax.pfValue || valueMin.strValue === valueMax.strValue) {
            warn('`' + name + ': ' + value + '` is not a valid mapper because the output range is zero; converting to `' + name + ': ' + valueMin.strValue + '`');
            return this.parse(name, valueMin.strValue); // can't make much of a mapper without a range
        } else if (type.color) {
            var c1 = valueMin.value;
            var c2 = valueMax.value;
            var same = c1[0] === c2[0] // red
             && c1[1] === c2[1] // green
             && c1[2] === c2[2] // blue
             && // optional alpha
            (c1[3] === c2[3] // same alpha outright
             || (c1[3] == null || c1[3] === 1 // full opacity for colour 1?
            ) && (c2[3] == null || c2[3] === 1 // full opacity for colour 2?
            ));
            if (same) return false;
             // can't make a mapper without a range
        }
        return {
            name: name,
            value: mapData,
            strValue: '' + value,
            mapped: _mapped,
            field: mapData[1],
            fieldMin: parseFloat(mapData[2]),
            // min & max are numeric
            fieldMax: parseFloat(mapData[3]),
            valueMin: valueMin.value,
            valueMax: valueMax.value,
            bypass: propIsBypass
        };
    }
    if (type.multiple && propIsFlat !== 'multiple') {
        var vals;
        if (valueIsString) vals = value.split(/\s+/);
        else if (array(value)) vals = value;
        else vals = [
            value
        ];
        if (type.evenMultiple && vals.length % 2 !== 0) return null;
        var valArr = [];
        var unitsArr = [];
        var pfValArr = [];
        var strVal = '';
        var hasEnum = false;
        for(var i = 0; i < vals.length; i++){
            var p = self1.parse(name, vals[i], propIsBypass, 'multiple');
            hasEnum = hasEnum || string(p.value);
            valArr.push(p.value);
            pfValArr.push(p.pfValue != null ? p.pfValue : p.value);
            unitsArr.push(p.units);
            strVal += (i > 0 ? ' ' : '') + p.strValue;
        }
        if (type.validate && !type.validate(valArr, unitsArr)) return null;
        if (type.singleEnum && hasEnum) {
            if (valArr.length === 1 && string(valArr[0])) return {
                name: name,
                value: valArr[0],
                strValue: valArr[0],
                bypass: propIsBypass
            };
            else return null;
        }
        return {
            name: name,
            value: valArr,
            pfValue: pfValArr,
            strValue: strVal,
            bypass: propIsBypass,
            units: unitsArr
        };
    }
    // several types also allow enums
    var checkEnums = function checkEnums() {
        for(var _i = 0; _i < type.enums.length; _i++){
            var en = type.enums[_i];
            if (en === value) return {
                name: name,
                value: value,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null;
    };
    // check the type and return the appropriate object
    if (type.number) {
        var units;
        var implicitUnits = 'px'; // not set => px
        if (type.units) // use specified units if set
        units = type.units;
        if (type.implicitUnits) implicitUnits = type.implicitUnits;
        if (!type.unitless) {
            if (valueIsString) {
                var unitsRegex = 'px|em' + (type.allowPercent ? '|\\%' : '');
                if (units) unitsRegex = units;
                 // only allow explicit units if so set
                var match = value.match('^(' + number + ')(' + unitsRegex + ')?' + '$');
                if (match) {
                    value = match[1];
                    units = match[2] || implicitUnits;
                }
            } else if (!units || type.implicitUnits) units = implicitUnits; // implicitly px if unspecified
        }
        value = parseFloat(value);
        // if not a number and enums not allowed, then the value is invalid
        if (isNaN(value) && type.enums === undefined) return null;
        // check if this number type also accepts special keywords in place of numbers
        // (i.e. `left`, `auto`, etc)
        if (isNaN(value) && type.enums !== undefined) {
            value = passedValue;
            return checkEnums();
        }
        // check if value must be an integer
        if (type.integer && !integer(value)) return null;
        // check value is within range
        if (type.min !== undefined && (value < type.min || type.strictMin && value === type.min) || type.max !== undefined && (value > type.max || type.strictMax && value === type.max)) return null;
        var ret = {
            name: name,
            value: value,
            strValue: '' + value + (units ? units : ''),
            units: units,
            bypass: propIsBypass
        };
        // normalise value in pixels
        if (type.unitless || units !== 'px' && units !== 'em') ret.pfValue = value;
        else ret.pfValue = units === 'px' || !units ? value : this.getEmSizeInPixels() * value;
        // normalise value in ms
        if (units === 'ms' || units === 's') ret.pfValue = units === 'ms' ? value : 1000 * value;
        // normalise value in rad
        if (units === 'deg' || units === 'rad') ret.pfValue = units === 'rad' ? value : deg2rad(value);
        // normalize value in %
        if (units === '%') ret.pfValue = value / 100;
        return ret;
    } else if (type.propList) {
        var props = [];
        var propsStr = '' + value;
        if (propsStr === 'none') ;
        else {
            // go over each prop
            var propsSplit = propsStr.split(/\s*,\s*|\s+/);
            for(var _i2 = 0; _i2 < propsSplit.length; _i2++){
                var propName = propsSplit[_i2].trim();
                if (self1.properties[propName]) props.push(propName);
                else warn('`' + propName + '` is not a valid property name');
            }
            if (props.length === 0) return null;
        }
        return {
            name: name,
            value: props,
            strValue: props.length === 0 ? 'none' : props.join(' '),
            bypass: propIsBypass
        };
    } else if (type.color) {
        var tuple = color2tuple(value);
        if (!tuple) return null;
        return {
            name: name,
            value: tuple,
            pfValue: tuple,
            strValue: 'rgb(' + tuple[0] + ',' + tuple[1] + ',' + tuple[2] + ')',
            // n.b. no spaces b/c of multiple support
            bypass: propIsBypass
        };
    } else if (type.regex || type.regexes) {
        // first check enums
        if (type.enums) {
            var enumProp = checkEnums();
            if (enumProp) return enumProp;
        }
        var regexes = type.regexes ? type.regexes : [
            type.regex
        ];
        for(var _i3 = 0; _i3 < regexes.length; _i3++){
            var regex = new RegExp(regexes[_i3]); // make a regex from the type string
            var m1 = regex.exec(value);
            if (m1) // regex matches
            return {
                name: name,
                value: type.singleRegexMatchValue ? m1[1] : m1,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null; // didn't match any
    } else if (type.string) // just return
    return {
        name: name,
        value: '' + value,
        strValue: '' + value,
        bypass: propIsBypass
    };
    else if (type.enums) // check enums last because it's a combo type in others
    return checkEnums();
    else return null; // not a type we can handle
};
var _Style = function Style(cy) {
    if (!(this instanceof _Style)) return new _Style(cy);
    if (!core(cy)) {
        error('A style must have a core reference');
        return;
    }
    this._private = {
        cy: cy,
        coreStyle: {}
    };
    this.length = 0;
    this.resetToDefault();
};
var styfn = _Style.prototype;
styfn.instanceString = function() {
    return 'style';
};
// remove all contexts
styfn.clear = function() {
    var _p = this._private;
    var cy = _p.cy;
    var eles = cy.elements();
    for(var i = 0; i < this.length; i++)this[i] = undefined;
    this.length = 0;
    _p.contextStyles = {};
    _p.propDiffs = {};
    this.cleanElements(eles, true);
    eles.forEach(function(ele) {
        var ele_p = ele[0]._private;
        ele_p.styleDirty = true;
        ele_p.appliedInitStyle = false;
    });
    return this; // chaining
};
styfn.resetToDefault = function() {
    this.clear();
    this.addDefaultStylesheet();
    return this;
};
// builds a style object for the 'core' selector
styfn.core = function(propName) {
    return this._private.coreStyle[propName] || this.getDefaultProperty(propName);
};
// create a new context from the specified selector string and switch to that context
styfn.selector = function(selectorStr) {
    // 'core' is a special case and does not need a selector
    var selector = selectorStr === 'core' ? null : new Selector(selectorStr);
    var i = this.length++; // new context means new index
    this[i] = {
        selector: selector,
        properties: [],
        mappedProperties: [],
        index: i
    };
    return this; // chaining
};
// add one or many css rules to the current context
styfn.css = function() {
    var self1 = this;
    var args = arguments;
    if (args.length === 1) {
        var map = args[0];
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var mapVal = map[prop.name];
            if (mapVal === undefined) mapVal = map[dash2camel(prop.name)];
            if (mapVal !== undefined) this.cssRule(prop.name, mapVal);
        }
    } else if (args.length === 2) this.cssRule(args[0], args[1]);
    // do nothing if args are invalid
    return this; // chaining
};
styfn.style = styfn.css;
// add a single css rule to the current context
styfn.cssRule = function(name, value) {
    // name-value pair
    var property = this.parse(name, value);
    // add property to current context if valid
    if (property) {
        var i = this.length - 1;
        this[i].properties.push(property);
        this[i].properties[property.name] = property; // allow access by name as well
        if (property.name.match(/pie-(\d+)-background-size/) && property.value) this._private.hasPie = true;
        if (property.mapped) this[i].mappedProperties.push(property);
        // add to core style if necessary
        var currentSelectorIsCore = !this[i].selector;
        if (currentSelectorIsCore) this._private.coreStyle[property.name] = property;
    }
    return this; // chaining
};
styfn.append = function(style) {
    if (stylesheet(style)) style.appendToStyle(this);
    else if (array(style)) this.appendFromJson(style);
    else if (string(style)) this.appendFromString(style);
     // you probably wouldn't want to append a Style, since you'd duplicate the default parts
    return this;
};
// static function
_Style.fromJson = function(cy, json) {
    var style = new _Style(cy);
    style.fromJson(json);
    return style;
};
_Style.fromString = function(cy, string) {
    return new _Style(cy).fromString(string);
};
[
    styfn$8,
    styfn$7,
    styfn$6,
    styfn$5,
    styfn$4,
    styfn$3,
    styfn$2,
    styfn$1
].forEach(function(props) {
    extend(styfn, props);
});
_Style.types = styfn.types;
_Style.properties = styfn.properties;
_Style.propertyGroups = styfn.propertyGroups;
_Style.propertyGroupNames = styfn.propertyGroupNames;
_Style.propertyGroupKeys = styfn.propertyGroupKeys;
var corefn$2 = {
    style: function style(newStyle) {
        if (newStyle) {
            var s = this.setStyle(newStyle);
            s.update();
        }
        return this._private.style;
    },
    setStyle: function setStyle(style) {
        var _p = this._private;
        if (stylesheet(style)) _p.style = style.generateStyle(this);
        else if (array(style)) _p.style = _Style.fromJson(this, style);
        else if (string(style)) _p.style = _Style.fromString(this, style);
        else _p.style = _Style(this);
        return _p.style;
    },
    // e.g. cy.data() changed => recalc ele mappers
    updateStyle: function updateStyle() {
        this.mutableElements().updateStyle(); // just send to all eles
    }
};
var defaultSelectionType = 'single';
var corefn$1 = {
    autolock: function autolock(bool) {
        if (bool !== undefined) this._private.autolock = bool ? true : false;
        else return this._private.autolock;
        return this; // chaining
    },
    autoungrabify: function autoungrabify(bool) {
        if (bool !== undefined) this._private.autoungrabify = bool ? true : false;
        else return this._private.autoungrabify;
        return this; // chaining
    },
    autounselectify: function autounselectify(bool) {
        if (bool !== undefined) this._private.autounselectify = bool ? true : false;
        else return this._private.autounselectify;
        return this; // chaining
    },
    selectionType: function selectionType(selType) {
        var _p = this._private;
        if (_p.selectionType == null) _p.selectionType = defaultSelectionType;
        if (selType !== undefined) {
            if (selType === 'additive' || selType === 'single') _p.selectionType = selType;
        } else return _p.selectionType;
        return this;
    },
    panningEnabled: function panningEnabled(bool) {
        if (bool !== undefined) this._private.panningEnabled = bool ? true : false;
        else return this._private.panningEnabled;
        return this; // chaining
    },
    userPanningEnabled: function userPanningEnabled(bool) {
        if (bool !== undefined) this._private.userPanningEnabled = bool ? true : false;
        else return this._private.userPanningEnabled;
        return this; // chaining
    },
    zoomingEnabled: function zoomingEnabled(bool) {
        if (bool !== undefined) this._private.zoomingEnabled = bool ? true : false;
        else return this._private.zoomingEnabled;
        return this; // chaining
    },
    userZoomingEnabled: function userZoomingEnabled(bool) {
        if (bool !== undefined) this._private.userZoomingEnabled = bool ? true : false;
        else return this._private.userZoomingEnabled;
        return this; // chaining
    },
    boxSelectionEnabled: function boxSelectionEnabled(bool) {
        if (bool !== undefined) this._private.boxSelectionEnabled = bool ? true : false;
        else return this._private.boxSelectionEnabled;
        return this; // chaining
    },
    pan: function pan() {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        switch(args.length){
            case 0:
                // .pan()
                return pan;
            case 1:
                if (string(args[0])) {
                    // .pan('x')
                    dim = args[0];
                    return pan[dim];
                } else if (plainObject(args[0])) {
                    // .pan({ x: 0, y: 100 })
                    if (!this._private.panningEnabled) return this;
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if (number$1(x)) pan.x = x;
                    if (number$1(y)) pan.y = y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .pan('x', 100)
                if (!this._private.panningEnabled) return this;
                dim = args[0];
                val = args[1];
                if ((dim === 'x' || dim === 'y') && number$1(val)) pan[dim] = val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    panBy: function panBy(arg0, arg1) {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        if (!this._private.panningEnabled) return this;
        switch(args.length){
            case 1:
                if (plainObject(arg0)) {
                    // .panBy({ x: 0, y: 100 })
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if (number$1(x)) pan.x += x;
                    if (number$1(y)) pan.y += y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .panBy('x', 100)
                dim = arg0;
                val = arg1;
                if ((dim === 'x' || dim === 'y') && number$1(val)) pan[dim] += val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    gc: function gc() {
        this.notify('gc');
    },
    fit: function fit(elements, padding) {
        var viewportState = this.getFitViewport(elements, padding);
        if (viewportState) {
            var _p = this._private;
            _p.zoom = viewportState.zoom;
            _p.pan = viewportState.pan;
            this.emit('pan zoom viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getFitViewport: function getFitViewport(elements, padding) {
        if (number$1(elements) && padding === undefined) {
            // elements is optional
            padding = elements;
            elements = undefined;
        }
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return;
        var bb;
        if (string(elements)) {
            var sel = elements;
            elements = this.$(sel);
        } else if (boundingBox(elements)) {
            // assume bb
            var bbe = elements;
            bb = {
                x1: bbe.x1,
                y1: bbe.y1,
                x2: bbe.x2,
                y2: bbe.y2
            };
            bb.w = bb.x2 - bb.x1;
            bb.h = bb.y2 - bb.y1;
        } else if (!elementOrCollection(elements)) elements = this.mutableElements();
        if (elementOrCollection(elements) && elements.empty()) return;
         // can't fit to nothing
        bb = bb || elements.boundingBox();
        var w = this.width();
        var h = this.height();
        var zoom;
        padding = number$1(padding) ? padding : 0;
        if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0 && !isNaN(bb.w) && !isNaN(bb.h) && bb.w > 0 && bb.h > 0) {
            zoom = Math.min((w - 2 * padding) / bb.w, (h - 2 * padding) / bb.h);
            // crop zoom
            zoom = zoom > this._private.maxZoom ? this._private.maxZoom : zoom;
            zoom = zoom < this._private.minZoom ? this._private.minZoom : zoom;
            var pan = {
                // now pan to middle
                x: (w - zoom * (bb.x1 + bb.x2)) / 2,
                y: (h - zoom * (bb.y1 + bb.y2)) / 2
            };
            return {
                zoom: zoom,
                pan: pan
            };
        }
        return;
    },
    zoomRange: function zoomRange(min, max) {
        var _p = this._private;
        if (max == null) {
            var opts = min;
            min = opts.min;
            max = opts.max;
        }
        if (number$1(min) && number$1(max) && min <= max) {
            _p.minZoom = min;
            _p.maxZoom = max;
        } else if (number$1(min) && max === undefined && min <= _p.maxZoom) _p.minZoom = min;
        else if (number$1(max) && min === undefined && max >= _p.minZoom) _p.maxZoom = max;
        return this;
    },
    minZoom: function minZoom(zoom) {
        if (zoom === undefined) return this._private.minZoom;
        else return this.zoomRange({
            min: zoom
        });
    },
    maxZoom: function maxZoom(zoom) {
        if (zoom === undefined) return this._private.maxZoom;
        else return this.zoomRange({
            max: zoom
        });
    },
    getZoomedViewport: function getZoomedViewport(params) {
        var _p = this._private;
        var currentPan = _p.pan;
        var currentZoom = _p.zoom;
        var pos; // in rendered px
        var zoom;
        var bail = false;
        if (!_p.zoomingEnabled) // zooming disabled
        bail = true;
        if (number$1(params)) // then set the zoom
        zoom = params;
        else if (plainObject(params)) {
            // then zoom about a point
            zoom = params.level;
            if (params.position != null) pos = modelToRenderedPosition$1(params.position, currentZoom, currentPan);
            else if (params.renderedPosition != null) pos = params.renderedPosition;
            if (pos != null && !_p.panningEnabled) // panning disabled
            bail = true;
        }
        // crop zoom
        zoom = zoom > _p.maxZoom ? _p.maxZoom : zoom;
        zoom = zoom < _p.minZoom ? _p.minZoom : zoom;
        // can't zoom with invalid params
        if (bail || !number$1(zoom) || zoom === currentZoom || pos != null && (!number$1(pos.x) || !number$1(pos.y))) return null;
        if (pos != null) {
            // set zoom about position
            var pan1 = currentPan;
            var zoom1 = currentZoom;
            var zoom2 = zoom;
            var pan2 = {
                x: -zoom2 / zoom1 * (pos.x - pan1.x) + pos.x,
                y: -zoom2 / zoom1 * (pos.y - pan1.y) + pos.y
            };
            return {
                zoomed: true,
                panned: true,
                zoom: zoom2,
                pan: pan2
            };
        } else // just set the zoom
        return {
            zoomed: true,
            panned: false,
            zoom: zoom,
            pan: currentPan
        };
    },
    zoom: function zoom(params) {
        if (params === undefined) // get
        return this._private.zoom;
        else {
            // set
            var vp = this.getZoomedViewport(params);
            var _p = this._private;
            if (vp == null || !vp.zoomed) return this;
            _p.zoom = vp.zoom;
            if (vp.panned) {
                _p.pan.x = vp.pan.x;
                _p.pan.y = vp.pan.y;
            }
            this.emit('zoom' + (vp.panned ? ' pan' : '') + ' viewport');
            this.notify('viewport');
            return this; // chaining
        }
    },
    viewport: function viewport(opts) {
        var _p = this._private;
        var zoomDefd = true;
        var panDefd = true;
        var events = []; // to trigger
        var zoomFailed = false;
        var panFailed = false;
        if (!opts) return this;
        if (!number$1(opts.zoom)) zoomDefd = false;
        if (!plainObject(opts.pan)) panDefd = false;
        if (!zoomDefd && !panDefd) return this;
        if (zoomDefd) {
            var z = opts.zoom;
            if (z < _p.minZoom || z > _p.maxZoom || !_p.zoomingEnabled) zoomFailed = true;
            else {
                _p.zoom = z;
                events.push('zoom');
            }
        }
        if (panDefd && (!zoomFailed || !opts.cancelOnFailedZoom) && _p.panningEnabled) {
            var p = opts.pan;
            if (number$1(p.x)) {
                _p.pan.x = p.x;
                panFailed = false;
            }
            if (number$1(p.y)) {
                _p.pan.y = p.y;
                panFailed = false;
            }
            if (!panFailed) events.push('pan');
        }
        if (events.length > 0) {
            events.push('viewport');
            this.emit(events.join(' '));
            this.notify('viewport');
        }
        return this; // chaining
    },
    center: function center(elements) {
        var pan = this.getCenterPan(elements);
        if (pan) {
            this._private.pan = pan;
            this.emit('pan viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getCenterPan: function getCenterPan(elements, zoom) {
        if (!this._private.panningEnabled) return;
        if (string(elements)) {
            var selector = elements;
            elements = this.mutableElements().filter(selector);
        } else if (!elementOrCollection(elements)) elements = this.mutableElements();
        if (elements.length === 0) return;
         // can't centre pan to nothing
        var bb = elements.boundingBox();
        var w = this.width();
        var h = this.height();
        zoom = zoom === undefined ? this._private.zoom : zoom;
        var pan = {
            // middle
            x: (w - zoom * (bb.x1 + bb.x2)) / 2,
            y: (h - zoom * (bb.y1 + bb.y2)) / 2
        };
        return pan;
    },
    reset: function reset() {
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return this;
        this.viewport({
            pan: {
                x: 0,
                y: 0
            },
            zoom: 1
        });
        return this; // chaining
    },
    invalidateSize: function invalidateSize() {
        this._private.sizeCache = null;
    },
    size: function size() {
        var _p = this._private;
        var container = _p.container;
        var cy = this;
        return _p.sizeCache = _p.sizeCache || (container ? function() {
            var style = cy.window().getComputedStyle(container);
            var val = function val(name) {
                return parseFloat(style.getPropertyValue(name));
            };
            return {
                width: container.clientWidth - val('padding-left') - val('padding-right'),
                height: container.clientHeight - val('padding-top') - val('padding-bottom')
            };
        }() : {
            // fallback if no container (not 0 b/c can be used for dividing etc)
            width: 1,
            height: 1
        });
    },
    width: function width() {
        return this.size().width;
    },
    height: function height() {
        return this.size().height;
    },
    extent: function extent() {
        var pan = this._private.pan;
        var zoom = this._private.zoom;
        var rb = this.renderedExtent();
        var b = {
            x1: (rb.x1 - pan.x) / zoom,
            x2: (rb.x2 - pan.x) / zoom,
            y1: (rb.y1 - pan.y) / zoom,
            y2: (rb.y2 - pan.y) / zoom
        };
        b.w = b.x2 - b.x1;
        b.h = b.y2 - b.y1;
        return b;
    },
    renderedExtent: function renderedExtent() {
        var width = this.width();
        var height = this.height();
        return {
            x1: 0,
            y1: 0,
            x2: width,
            y2: height,
            w: width,
            h: height
        };
    },
    multiClickDebounceTime: function multiClickDebounceTime(_int) {
        if (_int) this._private.multiClickDebounceTime = _int;
        else return this._private.multiClickDebounceTime;
        return this; // chaining
    }
};
// aliases
corefn$1.centre = corefn$1.center;
// backwards compatibility
corefn$1.autolockNodes = corefn$1.autolock;
corefn$1.autoungrabifyNodes = corefn$1.autoungrabify;
var fn = {
    data: define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeData: define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    scratch: define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    })
};
// aliases
fn.attr = fn.data;
fn.removeAttr = fn.removeData;
var Core = function Core(opts) {
    var cy = this;
    opts = extend({}, opts);
    var container = opts.container;
    // allow for passing a wrapped jquery object
    // e.g. cytoscape({ container: $('#cy') })
    if (container && !htmlElement(container) && htmlElement(container[0])) container = container[0];
    var reg = container ? container._cyreg : null; // e.g. already registered some info (e.g. readies) via jquery
    reg = reg || {};
    if (reg && reg.cy) {
        reg.cy.destroy();
        reg = {}; // old instance => replace reg completely
    }
    var readies = reg.readies = reg.readies || [];
    if (container) container._cyreg = reg;
     // make sure container assoc'd reg points to this cy
    reg.cy = cy;
    var head = _window !== undefined && container !== undefined && !opts.headless;
    var options = opts;
    options.layout = extend({
        name: head ? 'grid' : 'null'
    }, options.layout);
    options.renderer = extend({
        name: head ? 'canvas' : 'null'
    }, options.renderer);
    var defVal = function defVal(def, val, altVal) {
        if (val !== undefined) return val;
        else if (altVal !== undefined) return altVal;
        else return def;
    };
    var _p = this._private = {
        container: container,
        // html dom ele container
        ready: false,
        // whether ready has been triggered
        options: options,
        // cached options
        elements: new Collection(this),
        // elements in the graph
        listeners: [],
        // list of listeners
        aniEles: new Collection(this),
        // elements being animated
        data: options.data || {},
        // data for the core
        scratch: {},
        // scratch object for core
        layout: null,
        renderer: null,
        destroyed: false,
        // whether destroy was called
        notificationsEnabled: true,
        // whether notifications are sent to the renderer
        minZoom: 1e-50,
        maxZoom: 1e50,
        zoomingEnabled: defVal(true, options.zoomingEnabled),
        userZoomingEnabled: defVal(true, options.userZoomingEnabled),
        panningEnabled: defVal(true, options.panningEnabled),
        userPanningEnabled: defVal(true, options.userPanningEnabled),
        boxSelectionEnabled: defVal(true, options.boxSelectionEnabled),
        autolock: defVal(false, options.autolock, options.autolockNodes),
        autoungrabify: defVal(false, options.autoungrabify, options.autoungrabifyNodes),
        autounselectify: defVal(false, options.autounselectify),
        styleEnabled: options.styleEnabled === undefined ? head : options.styleEnabled,
        zoom: number$1(options.zoom) ? options.zoom : 1,
        pan: {
            x: plainObject(options.pan) && number$1(options.pan.x) ? options.pan.x : 0,
            y: plainObject(options.pan) && number$1(options.pan.y) ? options.pan.y : 0
        },
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        hasCompoundNodes: false,
        multiClickDebounceTime: defVal(250, options.multiClickDebounceTime)
    };
    this.createEmitter();
    // set selection type
    this.selectionType(options.selectionType);
    // init zoom bounds
    this.zoomRange({
        min: options.minZoom,
        max: options.maxZoom
    });
    var loadExtData = function loadExtData(extData, next) {
        var anyIsPromise = extData.some(promise);
        if (anyIsPromise) return Promise$1.all(extData).then(next); // load all data asynchronously, then exec rest of init
        else next(extData); // exec synchronously for convenience
    };
    // start with the default stylesheet so we have something before loading an external stylesheet
    if (_p.styleEnabled) cy.setStyle([]);
    // create the renderer
    var rendererOptions = extend({}, options, options.renderer); // allow rendering hints in top level options
    cy.initRenderer(rendererOptions);
    var setElesAndLayout = function setElesAndLayout(elements, onload, ondone) {
        cy.notifications(false);
        // remove old elements
        var oldEles = cy.mutableElements();
        if (oldEles.length > 0) oldEles.remove();
        if (elements != null) {
            if (plainObject(elements) || array(elements)) cy.add(elements);
        }
        cy.one('layoutready', function(e) {
            cy.notifications(true);
            cy.emit(e); // we missed this event by turning notifications off, so pass it on
            cy.one('load', onload);
            cy.emitAndNotify('load');
        }).one('layoutstop', function() {
            cy.one('done', ondone);
            cy.emit('done');
        });
        var layoutOpts = extend({}, cy._private.options.layout);
        layoutOpts.eles = cy.elements();
        cy.layout(layoutOpts).run();
    };
    loadExtData([
        options.style,
        options.elements
    ], function(thens) {
        var initStyle = thens[0];
        var initEles = thens[1];
        // init style
        if (_p.styleEnabled) cy.style().append(initStyle);
        // initial load
        setElesAndLayout(initEles, function() {
            // onready
            cy.startAnimationLoop();
            _p.ready = true;
            // if a ready callback is specified as an option, the bind it
            if (fn$6(options.ready)) cy.on('ready', options.ready);
            // bind all the ready handlers registered before creating this instance
            for(var i = 0; i < readies.length; i++){
                var fn = readies[i];
                cy.on('ready', fn);
            }
            if (reg) reg.readies = [];
             // clear b/c we've bound them all and don't want to keep it around in case a new core uses the same div etc
            cy.emit('ready');
        }, options.done);
    });
};
var corefn = Core.prototype; // short alias
extend(corefn, {
    instanceString: function instanceString() {
        return 'core';
    },
    isReady: function isReady() {
        return this._private.ready;
    },
    destroyed: function destroyed() {
        return this._private.destroyed;
    },
    ready: function ready(fn) {
        if (this.isReady()) this.emitter().emit('ready', [], fn); // just calls fn as though triggered via ready event
        else this.on('ready', fn);
        return this;
    },
    destroy: function destroy() {
        var cy = this;
        if (cy.destroyed()) return;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        this.emit('destroy');
        cy._private.destroyed = true;
        return cy;
    },
    hasElementWithId: function hasElementWithId(id) {
        return this._private.elements.hasElementWithId(id);
    },
    getElementById: function getElementById(id) {
        return this._private.elements.getElementById(id);
    },
    hasCompoundNodes: function hasCompoundNodes() {
        return this._private.hasCompoundNodes;
    },
    headless: function headless() {
        return this._private.renderer.isHeadless();
    },
    styleEnabled: function styleEnabled() {
        return this._private.styleEnabled;
    },
    addToPool: function addToPool(eles) {
        this._private.elements.merge(eles);
        return this; // chaining
    },
    removeFromPool: function removeFromPool(eles) {
        this._private.elements.unmerge(eles);
        return this;
    },
    container: function container() {
        return this._private.container || null;
    },
    window: function window1() {
        var container = this._private.container;
        if (container == null) return _window;
        var ownerDocument = this._private.container.ownerDocument;
        if (ownerDocument === undefined || ownerDocument == null) return _window;
        return ownerDocument.defaultView || _window;
    },
    mount: function mount(container) {
        if (container == null) return;
        var cy = this;
        var _p = cy._private;
        var options = _p.options;
        if (!htmlElement(container) && htmlElement(container[0])) container = container[0];
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        _p.container = container;
        _p.styleEnabled = true;
        cy.invalidateSize();
        cy.initRenderer(extend({}, options, options.renderer, {
            // allow custom renderer name to be re-used, otherwise use canvas
            name: options.renderer.name === 'null' ? 'canvas' : options.renderer.name
        }));
        cy.startAnimationLoop();
        cy.style(options.style);
        cy.emit('mount');
        return cy;
    },
    unmount: function unmount() {
        var cy = this;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        cy.initRenderer({
            name: 'null'
        });
        cy.emit('unmount');
        return cy;
    },
    options: function options() {
        return copy(this._private.options);
    },
    json: function json(obj) {
        var cy = this;
        var _p = cy._private;
        var eles = cy.mutableElements();
        var getFreshRef = function getFreshRef(ele) {
            return cy.getElementById(ele.id());
        };
        if (plainObject(obj)) {
            // set
            cy.startBatch();
            if (obj.elements) {
                var idInJson = {};
                var updateEles = function updateEles(jsons, gr) {
                    var toAdd = [];
                    var toMod = [];
                    for(var i = 0; i < jsons.length; i++){
                        var json = jsons[i];
                        if (!json.data.id) {
                            warn('cy.json() cannot handle elements without an ID attribute');
                            continue;
                        }
                        var id = '' + json.data.id; // id must be string
                        var ele = cy.getElementById(id);
                        idInJson[id] = true;
                        if (ele.length !== 0) // existing element should be updated
                        toMod.push({
                            ele: ele,
                            json: json
                        });
                        else // otherwise should be added
                        if (gr) {
                            json.group = gr;
                            toAdd.push(json);
                        } else toAdd.push(json);
                    }
                    cy.add(toAdd);
                    for(var _i = 0; _i < toMod.length; _i++){
                        var _toMod$_i = toMod[_i], _ele = _toMod$_i.ele, _json = _toMod$_i.json;
                        _ele.json(_json);
                    }
                };
                if (array(obj.elements)) // elements: []
                updateEles(obj.elements);
                else {
                    // elements: { nodes: [], edges: [] }
                    var grs = [
                        'nodes',
                        'edges'
                    ];
                    for(var i = 0; i < grs.length; i++){
                        var gr = grs[i];
                        var elements = obj.elements[gr];
                        if (array(elements)) updateEles(elements, gr);
                    }
                }
                var parentsToRemove = cy.collection();
                eles.filter(function(ele) {
                    return !idInJson[ele.id()];
                }).forEach(function(ele) {
                    if (ele.isParent()) parentsToRemove.merge(ele);
                    else ele.remove();
                });
                // so that children are not removed w/parent
                parentsToRemove.forEach(function(ele) {
                    return ele.children().move({
                        parent: null
                    });
                });
                // intermediate parents may be moved by prior line, so make sure we remove by fresh refs
                parentsToRemove.forEach(function(ele) {
                    return getFreshRef(ele).remove();
                });
            }
            if (obj.style) cy.style(obj.style);
            if (obj.zoom != null && obj.zoom !== _p.zoom) cy.zoom(obj.zoom);
            if (obj.pan) {
                if (obj.pan.x !== _p.pan.x || obj.pan.y !== _p.pan.y) cy.pan(obj.pan);
            }
            if (obj.data) cy.data(obj.data);
            var fields = [
                'minZoom',
                'maxZoom',
                'zoomingEnabled',
                'userZoomingEnabled',
                'panningEnabled',
                'userPanningEnabled',
                'boxSelectionEnabled',
                'autolock',
                'autoungrabify',
                'autounselectify',
                'multiClickDebounceTime'
            ];
            for(var _i2 = 0; _i2 < fields.length; _i2++){
                var f = fields[_i2];
                if (obj[f] != null) cy[f](obj[f]);
            }
            cy.endBatch();
            return this; // chaining
        } else {
            // get
            var flat = !!obj;
            var json = {};
            if (flat) json.elements = this.elements().map(function(ele) {
                return ele.json();
            });
            else {
                json.elements = {};
                eles.forEach(function(ele) {
                    var group = ele.group();
                    if (!json.elements[group]) json.elements[group] = [];
                    json.elements[group].push(ele.json());
                });
            }
            if (this._private.styleEnabled) json.style = cy.style().json();
            json.data = copy(cy.data());
            var options = _p.options;
            json.zoomingEnabled = _p.zoomingEnabled;
            json.userZoomingEnabled = _p.userZoomingEnabled;
            json.zoom = _p.zoom;
            json.minZoom = _p.minZoom;
            json.maxZoom = _p.maxZoom;
            json.panningEnabled = _p.panningEnabled;
            json.userPanningEnabled = _p.userPanningEnabled;
            json.pan = copy(_p.pan);
            json.boxSelectionEnabled = _p.boxSelectionEnabled;
            json.renderer = copy(options.renderer);
            json.hideEdgesOnViewport = options.hideEdgesOnViewport;
            json.textureOnViewport = options.textureOnViewport;
            json.wheelSensitivity = options.wheelSensitivity;
            json.motionBlur = options.motionBlur;
            json.multiClickDebounceTime = options.multiClickDebounceTime;
            return json;
        }
    }
});
corefn.$id = corefn.getElementById;
[
    corefn$9,
    corefn$8,
    elesfn,
    corefn$7,
    corefn$6,
    corefn$5,
    corefn$4,
    corefn$3,
    corefn$2,
    corefn$1,
    fn
].forEach(function(props) {
    extend(corefn, props);
});
/* eslint-disable no-unused-vars */ var defaults$7 = {
    fit: true,
    // whether to fit the viewport to the graph
    directed: false,
    // whether the tree is directed downwards (or edges can point in any direction if false)
    padding: 30,
    // padding on fit
    circle: false,
    // put depths in concentric circles if true, put depths top down if false
    grid: false,
    // whether to create an even grid into which the DAG is placed (circle:false only)
    spacingFactor: 1.75,
    // positive spacing factor, larger => more space between nodes (N.B. n/a if causes overlap)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    roots: undefined,
    // the roots of the trees
    depthSort: undefined,
    // a sorting function to order nodes at equal depth. e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled,
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
var deprecatedOptionDefaults = {
    maximal: false,
    // whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only); setting acyclic to true sets maximal to true also
    acyclic: false // whether the tree is acyclic and thus a node could be shifted (due to the maximal option) multiple times without causing an infinite loop; setting to true sets maximal to true also; if you are uncertain whether a tree is acyclic, set to false to avoid potential infinite loops
};
/* eslint-enable */ var getInfo = function getInfo(ele) {
    return ele.scratch('breadthfirst');
};
var setInfo = function setInfo(ele, obj) {
    return ele.scratch('breadthfirst', obj);
};
function BreadthFirstLayout(options) {
    this.options = extend({}, defaults$7, deprecatedOptionDefaults, options);
}
BreadthFirstLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var nodes = eles.nodes().filter(function(n) {
        return n.isChildless();
    });
    var graph = eles;
    var directed = options.directed;
    var maximal = options.acyclic || options.maximal || options.maximalAdjustments > 0; // maximalAdjustments for compat. w/ old code; also, setting acyclic to true sets maximal to true
    var hasBoundingBox = !!options.boundingBox;
    var cyExtent = cy.extent();
    var bb = makeBoundingBox(hasBoundingBox ? options.boundingBox : {
        x1: cyExtent.x1,
        y1: cyExtent.y1,
        w: cyExtent.w,
        h: cyExtent.h
    });
    var roots;
    if (elementOrCollection(options.roots)) roots = options.roots;
    else if (array(options.roots)) {
        var rootsArray = [];
        for(var i = 0; i < options.roots.length; i++){
            var id = options.roots[i];
            var ele = cy.getElementById(id);
            rootsArray.push(ele);
        }
        roots = cy.collection(rootsArray);
    } else if (string(options.roots)) roots = cy.$(options.roots);
    else if (directed) roots = nodes.roots();
    else {
        var components = eles.components();
        roots = cy.collection();
        var _loop = function _loop() {
            var comp = components[_i];
            var maxDegree = comp.maxDegree(false);
            var compRoots = comp.filter(function(ele) {
                return ele.degree(false) === maxDegree;
            });
            roots = roots.add(compRoots);
        };
        for(var _i = 0; _i < components.length; _i++)_loop();
    }
    var depths = [];
    var foundByBfs = {};
    var addToDepth = function addToDepth(ele, d) {
        if (depths[d] == null) depths[d] = [];
        var i = depths[d].length;
        depths[d].push(ele);
        setInfo(ele, {
            index: i,
            depth: d
        });
    };
    var changeDepth = function changeDepth(ele, newDepth) {
        var _getInfo = getInfo(ele), depth = _getInfo.depth, index = _getInfo.index;
        depths[depth][index] = null;
        // add only childless nodes
        if (ele.isChildless()) addToDepth(ele, newDepth);
    };
    // find the depths of the nodes
    graph.bfs({
        roots: roots,
        directed: options.directed,
        visit: function visit(node, edge, pNode, i, depth) {
            var ele = node[0];
            var id = ele.id();
            // add only childless nodes
            if (ele.isChildless()) addToDepth(ele, depth);
            foundByBfs[id] = true;
        }
    });
    // check for nodes not found by bfs
    var orphanNodes = [];
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        if (foundByBfs[_ele.id()]) continue;
        else orphanNodes.push(_ele);
    }
    // assign the nodes a depth and index
    var assignDepthsAt = function assignDepthsAt(i) {
        var eles = depths[i];
        for(var j = 0; j < eles.length; j++){
            var _ele2 = eles[j];
            if (_ele2 == null) {
                eles.splice(j, 1);
                j--;
                continue;
            }
            setInfo(_ele2, {
                depth: i,
                index: j
            });
        }
    };
    var adjustMaximally = function adjustMaximally(ele, shifted) {
        var eInfo = getInfo(ele);
        var incomers = ele.incomers().filter(function(el) {
            return el.isNode() && eles.has(el);
        });
        var maxDepth = -1;
        var id = ele.id();
        for(var k = 0; k < incomers.length; k++){
            var incmr = incomers[k];
            var iInfo = getInfo(incmr);
            maxDepth = Math.max(maxDepth, iInfo.depth);
        }
        if (eInfo.depth <= maxDepth) {
            if (!options.acyclic && shifted[id]) return null;
            var newDepth = maxDepth + 1;
            changeDepth(ele, newDepth);
            shifted[id] = newDepth;
            return true;
        }
        return false;
    };
    // for the directed case, try to make the edges all go down (i.e. depth i => depth i + 1)
    if (directed && maximal) {
        var Q = [];
        var shifted = {};
        var enqueue = function enqueue(n) {
            return Q.push(n);
        };
        var dequeue = function dequeue() {
            return Q.shift();
        };
        nodes.forEach(function(n) {
            return Q.push(n);
        });
        while(Q.length > 0){
            var _ele3 = dequeue();
            var didShift = adjustMaximally(_ele3, shifted);
            if (didShift) _ele3.outgoers().filter(function(el) {
                return el.isNode() && eles.has(el);
            }).forEach(enqueue);
            else if (didShift === null) {
                warn('Detected double maximal shift for node `' + _ele3.id() + '`.  Bailing maximal adjustment due to cycle.  Use `options.maximal: true` only on DAGs.');
                break; // exit on failure
            }
        }
    }
    // find min distance we need to leave between nodes
    var minDistance = 0;
    if (options.avoidOverlap) for(var _i3 = 0; _i3 < nodes.length; _i3++){
        var n = nodes[_i3];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    // get the weighted percent for an element based on its connectivity to other levels
    var cachedWeightedPercent = {};
    var getWeightedPercent = function getWeightedPercent(ele) {
        if (cachedWeightedPercent[ele.id()]) return cachedWeightedPercent[ele.id()];
        var eleDepth = getInfo(ele).depth;
        var neighbors = ele.neighborhood();
        var percent = 0;
        var samples = 0;
        for(var _i4 = 0; _i4 < neighbors.length; _i4++){
            var neighbor = neighbors[_i4];
            if (neighbor.isEdge() || neighbor.isParent() || !nodes.has(neighbor)) continue;
            var bf = getInfo(neighbor);
            if (bf == null) continue;
            var index = bf.index;
            var depth = bf.depth;
            // unassigned neighbours shouldn't affect the ordering
            if (index == null || depth == null) continue;
            var nDepth = depths[depth].length;
            if (depth < eleDepth) {
                // only get influenced by elements above
                percent += index / nDepth;
                samples++;
            }
        }
        samples = Math.max(1, samples);
        percent = percent / samples;
        if (samples === 0) // put lone nodes at the start
        percent = 0;
        cachedWeightedPercent[ele.id()] = percent;
        return percent;
    };
    // rearrange the indices in each depth level based on connectivity
    var sortFn = function sortFn(a, b) {
        var apct = getWeightedPercent(a);
        var bpct = getWeightedPercent(b);
        var diff = apct - bpct;
        if (diff === 0) return ascending(a.id(), b.id()); // make sure sort doesn't have don't-care comparisons
        else return diff;
    };
    if (options.depthSort !== undefined) sortFn = options.depthSort;
    var depthsLen = depths.length;
    // sort each level to make connected nodes closer
    for(var _i5 = 0; _i5 < depthsLen; _i5++){
        depths[_i5].sort(sortFn);
        assignDepthsAt(_i5);
    }
    // assign orphan nodes to a new top-level depth
    var orphanDepth = [];
    for(var _i6 = 0; _i6 < orphanNodes.length; _i6++)orphanDepth.push(orphanNodes[_i6]);
    var assignDepths = function assignDepths() {
        for(var _i7 = 0; _i7 < depthsLen; _i7++)assignDepthsAt(_i7);
    };
    // add a new top-level depth only when there are orphan nodes
    if (orphanDepth.length) {
        depths.unshift(orphanDepth);
        depthsLen = depths.length;
        assignDepths();
    }
    var biggestDepthSize = 0;
    for(var _i8 = 0; _i8 < depthsLen; _i8++)biggestDepthSize = Math.max(depths[_i8].length, biggestDepthSize);
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    // average node size
    var aveNodeSize = nodes.reduce(function(acc, node) {
        return function(box) {
            return {
                w: acc.w === -1 ? box.w : (acc.w + box.w) / 2,
                h: acc.h === -1 ? box.h : (acc.h + box.h) / 2
            };
        }(node.boundingBox({
            includeLabels: options.nodeDimensionsIncludeLabels
        }));
    }, {
        w: -1,
        h: -1
    });
    var distanceY = Math.max(// only one depth
    depthsLen === 1 ? 0 : // inside a bounding box, no need for top & bottom padding
    hasBoundingBox ? (bb.h - options.padding * 2 - aveNodeSize.h) / (depthsLen - 1) : (bb.h - options.padding * 2 - aveNodeSize.h) / (depthsLen + 1), minDistance);
    var maxDepthSize = depths.reduce(function(max, eles) {
        return Math.max(max, eles.length);
    }, 0);
    var getPosition = function getPosition(ele) {
        var _getInfo2 = getInfo(ele), depth = _getInfo2.depth, index = _getInfo2.index;
        if (options.circle) {
            var radiusStepSize = Math.min(bb.w / 2 / depthsLen, bb.h / 2 / depthsLen);
            radiusStepSize = Math.max(radiusStepSize, minDistance);
            var radius = radiusStepSize * depth + radiusStepSize - (depthsLen > 0 && depths[0].length <= 3 ? radiusStepSize / 2 : 0);
            var theta = 2 * Math.PI / depths[depth].length * index;
            if (depth === 0 && depths[0].length === 1) radius = 1;
            return {
                x: center.x + radius * Math.cos(theta),
                y: center.y + radius * Math.sin(theta)
            };
        } else {
            var depthSize = depths[depth].length;
            var distanceX = Math.max(// only one depth
            depthSize === 1 ? 0 : // inside a bounding box, no need for left & right padding
            hasBoundingBox ? (bb.w - options.padding * 2 - aveNodeSize.w) / ((options.grid ? maxDepthSize : depthSize) - 1) : (bb.w - options.padding * 2 - aveNodeSize.w) / ((options.grid ? maxDepthSize : depthSize) + 1), minDistance);
            var epos = {
                x: center.x + (index + 1 - (depthSize + 1) / 2) * distanceX,
                y: center.y + (depth + 1 - (depthsLen + 1) / 2) * distanceY
            };
            return epos;
        }
    };
    eles.nodes().layoutPositions(this, options, getPosition);
    return this; // chaining
};
var defaults$6 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox and radius if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    radius: undefined,
    // the radius of the circle
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function CircleLayout(options) {
    this.options = extend({}, defaults$6, options);
}
CircleLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / nodes.length : options.sweep;
    var dTheta = sweep / Math.max(1, nodes.length - 1);
    var r;
    var minDistance = 0;
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    if (number$1(options.radius)) r = options.radius;
    else if (nodes.length <= 1) r = 0;
    else r = Math.min(bb.h, bb.w) / 2 - minDistance;
    // calculate the radius
    if (nodes.length > 1 && options.avoidOverlap) {
        // but only if more than one node (can't overlap)
        minDistance *= 1.75; // just to have some nice spacing
        var dcos = Math.cos(dTheta) - Math.cos(0);
        var dsin = Math.sin(dTheta) - Math.sin(0);
        var rMin = Math.sqrt(minDistance * minDistance / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
        r = Math.max(rMin, r);
    }
    var getPos = function getPos(ele, i) {
        var theta = options.startAngle + i * dTheta * (clockwise ? 1 : -1);
        var rx = r * Math.cos(theta);
        var ry = r * Math.sin(theta);
        var pos = {
            x: center.x + rx,
            y: center.y + ry
        };
        return pos;
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var defaults$5 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    equidistant: false,
    // whether levels have an equal radial distance betwen them, may cause bounding box overflow
    minNodeSpacing: 10,
    // min spacing between outside of nodes (used for radius adjustment)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    height: undefined,
    // height of layout area (overrides container height)
    width: undefined,
    // width of layout area (overrides container width)
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    concentric: function concentric(node) {
        // returns numeric value for each node, placing higher nodes in levels towards the centre
        return node.degree();
    },
    levelWidth: function levelWidth(nodes) {
        // the variation of concentric values in each level
        return nodes.maxDegree() / 4;
    },
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function ConcentricLayout(options) {
    this.options = extend({}, defaults$5, options);
}
ConcentricLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    var bb = makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var nodeValues = []; // { node, value }
    var maxNodeSize = 0;
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var value = undefined;
        // calculate the node value
        value = options.concentric(node);
        nodeValues.push({
            value: value,
            node: node
        });
        // for style mapping
        node._private.scratch.concentric = value;
    }
    // in case we used the `concentric` in style
    nodes.updateStyle();
    // calculate max size now based on potentially updated mappers
    for(var _i = 0; _i < nodes.length; _i++){
        var _node = nodes[_i];
        var nbb = _node.layoutDimensions(options);
        maxNodeSize = Math.max(maxNodeSize, nbb.w, nbb.h);
    }
    // sort node values in descreasing order
    nodeValues.sort(function(a, b) {
        return b.value - a.value;
    });
    var levelWidth = options.levelWidth(nodes);
    // put the values into levels
    var levels = [
        []
    ];
    var currentLevel = levels[0];
    for(var _i2 = 0; _i2 < nodeValues.length; _i2++){
        var val = nodeValues[_i2];
        if (currentLevel.length > 0) {
            var diff = Math.abs(currentLevel[0].value - val.value);
            if (diff >= levelWidth) {
                currentLevel = [];
                levels.push(currentLevel);
            }
        }
        currentLevel.push(val);
    }
    // create positions from levels
    var minDist = maxNodeSize + options.minNodeSpacing; // min dist between nodes
    if (!options.avoidOverlap) {
        // then strictly constrain to bb
        var firstLvlHasMulti = levels.length > 0 && levels[0].length > 1;
        var maxR = Math.min(bb.w, bb.h) / 2 - minDist;
        var rStep = maxR / (levels.length + firstLvlHasMulti ? 1 : 0);
        minDist = Math.min(minDist, rStep);
    }
    // find the metrics for each level
    var r = 0;
    for(var _i3 = 0; _i3 < levels.length; _i3++){
        var level = levels[_i3];
        var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / level.length : options.sweep;
        var dTheta = level.dTheta = sweep / Math.max(1, level.length - 1);
        // calculate the radius
        if (level.length > 1 && options.avoidOverlap) {
            // but only if more than one node (can't overlap)
            var dcos = Math.cos(dTheta) - Math.cos(0);
            var dsin = Math.sin(dTheta) - Math.sin(0);
            var rMin = Math.sqrt(minDist * minDist / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
            r = Math.max(rMin, r);
        }
        level.r = r;
        r += minDist;
    }
    if (options.equidistant) {
        var rDeltaMax = 0;
        var _r = 0;
        for(var _i4 = 0; _i4 < levels.length; _i4++){
            var _level = levels[_i4];
            var rDelta = _level.r - _r;
            rDeltaMax = Math.max(rDeltaMax, rDelta);
        }
        _r = 0;
        for(var _i5 = 0; _i5 < levels.length; _i5++){
            var _level2 = levels[_i5];
            if (_i5 === 0) _r = _level2.r;
            _level2.r = _r;
            _r += rDeltaMax;
        }
    }
    // calculate the node positions
    var pos = {}; // id => position
    for(var _i6 = 0; _i6 < levels.length; _i6++){
        var _level3 = levels[_i6];
        var _dTheta = _level3.dTheta;
        var _r2 = _level3.r;
        for(var j = 0; j < _level3.length; j++){
            var _val = _level3[j];
            var theta = options.startAngle + (clockwise ? 1 : -1) * _dTheta * j;
            var p = {
                x: center.x + _r2 * Math.cos(theta),
                y: center.y + _r2 * Math.sin(theta)
            };
            pos[_val.node.id()] = p;
        }
    }
    // position the nodes
    eles.nodes().layoutPositions(this, options, function(ele) {
        var id = ele.id();
        return pos[id];
    });
    return this; // chaining
};
/*
The CoSE layout was written by Gerardo Huck.
https://www.linkedin.com/in/gerardohuck/

Based on the following article:
http://dl.acm.org/citation.cfm?id=1498047

Modifications tracked on Github.
*/ var DEBUG;
/**
 * @brief :  default layout options
 */ var defaults$4 = {
    // Called on `layoutready`
    ready: function ready() {},
    // Called on `layoutstop`
    stop: function stop() {},
    // Whether to animate while running the layout
    // true : Animate continuously as the layout is running
    // false : Just show the end result
    // 'end' : Animate with the end result, from the initial positions to the end positions
    animate: true,
    // Easing of the animation for animate:'end'
    animationEasing: undefined,
    // The duration of the animation for animate:'end'
    animationDuration: undefined,
    // A function that determines whether the node should be animated
    // All nodes animated by default on animate enabled
    // Non-animated nodes are positioned immediately when the layout starts
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // The layout animates only after this many milliseconds for animate:true
    // (prevents flashing on fast runs)
    animationThreshold: 250,
    // Number of iterations between consecutive screen positions update
    refresh: 20,
    // Whether to fit the network view after when done
    fit: true,
    // Padding on fit
    padding: 30,
    // Constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    boundingBox: undefined,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    nodeDimensionsIncludeLabels: false,
    // Randomize the initial positions of the nodes (true) or use existing positions (false)
    randomize: false,
    // Extra spacing between components in non-compound graphs
    componentSpacing: 40,
    // Node repulsion (non overlapping) multiplier
    nodeRepulsion: function nodeRepulsion(node) {
        return 2048;
    },
    // Node repulsion (overlapping) multiplier
    nodeOverlap: 4,
    // Ideal edge (non nested) length
    idealEdgeLength: function idealEdgeLength(edge) {
        return 32;
    },
    // Divisor to compute edge forces
    edgeElasticity: function edgeElasticity(edge) {
        return 32;
    },
    // Nesting factor (multiplier) to compute ideal edge length for nested edges
    nestingFactor: 1.2,
    // Gravity force (constant)
    gravity: 1,
    // Maximum number of iterations to perform
    numIter: 1000,
    // Initial temperature (maximum node displacement)
    initialTemp: 1000,
    // Cooling factor (how the temperature is reduced between consecutive iterations
    coolingFactor: 0.99,
    // Lower temperature threshold (below this point the layout will end)
    minTemp: 1.0
};
/**
 * @brief       : constructor
 * @arg options : object containing layout options
 */ function CoseLayout(options) {
    this.options = extend({}, defaults$4, options);
    this.options.layout = this;
    // Exclude any edge that has a source or target node that is not in the set of passed-in nodes
    var nodes = this.options.eles.nodes();
    var edges = this.options.eles.edges();
    var notEdges = edges.filter(function(e) {
        var sourceId = e.source().data('id');
        var targetId = e.target().data('id');
        var hasSource = nodes.some(function(n) {
            return n.data('id') === sourceId;
        });
        var hasTarget = nodes.some(function(n) {
            return n.data('id') === targetId;
        });
        return !hasSource || !hasTarget;
    });
    this.options.eles = this.options.eles.not(notEdges);
}
/**
 * @brief : runs the layout
 */ CoseLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var layout = this;
    layout.stopped = false;
    if (options.animate === true || options.animate === false) layout.emit({
        type: 'layoutstart',
        layout: layout
    });
    // Set DEBUG - Global variable
    if (true === options.debug) DEBUG = true;
    else DEBUG = false;
    // Initialize layout info
    var layoutInfo = createLayoutInfo(cy, layout, options);
    // Show LayoutInfo contents if debugging
    if (DEBUG) printLayoutInfo(layoutInfo);
    // If required, randomize node positions
    if (options.randomize) randomizePositions(layoutInfo);
    var startTime = performanceNow();
    var refresh = function refresh() {
        refreshPositions(layoutInfo, cy, options);
        // Fit the graph if necessary
        if (true === options.fit) cy.fit(options.padding);
    };
    var mainLoop = function mainLoop(i) {
        if (layout.stopped || i >= options.numIter) // logDebug("Layout manually stopped. Stopping computation in step " + i);
        return false;
        // Do one step in the phisical simulation
        step(layoutInfo, options);
        // Update temperature
        layoutInfo.temperature = layoutInfo.temperature * options.coolingFactor;
        // logDebug("New temperature: " + layoutInfo.temperature);
        if (layoutInfo.temperature < options.minTemp) // logDebug("Temperature drop below minimum threshold. Stopping computation in step " + i);
        return false;
        return true;
    };
    var done = function done() {
        if (options.animate === true || options.animate === false) {
            refresh();
            // Layout has finished
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        } else {
            var nodes = options.eles.nodes();
            var getScaledPos = getScaleInBoundsFn(layoutInfo, options, nodes);
            nodes.layoutPositions(layout, options, getScaledPos);
        }
    };
    var i = 0;
    var loopRet = true;
    if (options.animate === true) {
        var _frame = function frame() {
            var f = 0;
            while(loopRet && f < options.refresh){
                loopRet = mainLoop(i);
                i++;
                f++;
            }
            if (!loopRet) {
                // it's done
                separateComponents(layoutInfo, options);
                done();
            } else {
                var now = performanceNow();
                if (now - startTime >= options.animationThreshold) refresh();
                requestAnimationFrame(_frame);
            }
        };
        _frame();
    } else {
        while(loopRet){
            loopRet = mainLoop(i);
            i++;
        }
        separateComponents(layoutInfo, options);
        done();
    }
    return this; // chaining
};
/**
 * @brief : called on continuous layouts to stop them before they finish
 */ CoseLayout.prototype.stop = function() {
    this.stopped = true;
    if (this.thread) this.thread.stop();
    this.emit('layoutstop');
    return this; // chaining
};
CoseLayout.prototype.destroy = function() {
    if (this.thread) this.thread.stop();
    return this; // chaining
};
/**
 * @brief     : Creates an object which is contains all the data
 *              used in the layout process
 * @arg cy    : cytoscape.js object
 * @return    : layoutInfo object initialized
 */ var createLayoutInfo = function createLayoutInfo(cy, layout, options) {
    // Shortcut
    var edges = options.eles.edges();
    var nodes = options.eles.nodes();
    var bb = makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var layoutInfo = {
        isCompound: cy.hasCompoundNodes(),
        layoutNodes: [],
        idToIndex: {},
        nodeSize: nodes.size(),
        graphSet: [],
        indexToGraph: [],
        layoutEdges: [],
        edgeSize: edges.size(),
        temperature: options.initialTemp,
        clientWidth: bb.w,
        clientHeight: bb.h,
        boundingBox: bb
    };
    var components = options.eles.components();
    var id2cmptId = {};
    for(var i = 0; i < components.length; i++){
        var component = components[i];
        for(var j = 0; j < component.length; j++){
            var node = component[j];
            id2cmptId[node.id()] = i;
        }
    }
    // Iterate over all nodes, creating layout nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var tempNode = {};
        tempNode.isLocked = n.locked();
        tempNode.id = n.data('id');
        tempNode.parentId = n.data('parent');
        tempNode.cmptId = id2cmptId[n.id()];
        tempNode.children = [];
        tempNode.positionX = n.position('x');
        tempNode.positionY = n.position('y');
        tempNode.offsetX = 0;
        tempNode.offsetY = 0;
        tempNode.height = nbb.w;
        tempNode.width = nbb.h;
        tempNode.maxX = tempNode.positionX + tempNode.width / 2;
        tempNode.minX = tempNode.positionX - tempNode.width / 2;
        tempNode.maxY = tempNode.positionY + tempNode.height / 2;
        tempNode.minY = tempNode.positionY - tempNode.height / 2;
        tempNode.padLeft = parseFloat(n.style('padding'));
        tempNode.padRight = parseFloat(n.style('padding'));
        tempNode.padTop = parseFloat(n.style('padding'));
        tempNode.padBottom = parseFloat(n.style('padding'));
        // forces
        tempNode.nodeRepulsion = fn$6(options.nodeRepulsion) ? options.nodeRepulsion(n) : options.nodeRepulsion;
        // Add new node
        layoutInfo.layoutNodes.push(tempNode);
        // Add entry to id-index map
        layoutInfo.idToIndex[tempNode.id] = i;
    }
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    var tempGraph = [];
    // Second pass to add child information and
    // initialize queue for hierarchical traversal
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        var p_id = n.parentId;
        // Check if node n has a parent node
        if (null != p_id) // Add node Id to parent's list of children
        layoutInfo.layoutNodes[layoutInfo.idToIndex[p_id]].children.push(n.id);
        else {
            // If a node doesn't have a parent, then it's in the root graph
            queue[++end] = n.id;
            tempGraph.push(n.id);
        }
    }
    // Add root graph to graphSet
    layoutInfo.graphSet.push(tempGraph);
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var node_id = queue[start++];
        var node_ix = layoutInfo.idToIndex[node_id];
        var node = layoutInfo.layoutNodes[node_ix];
        var children = node.children;
        if (children.length > 0) {
            // Add children nodes as a new graph to graph set
            layoutInfo.graphSet.push(children);
            // Add children to que queue to be visited
            for(var i = 0; i < children.length; i++)queue[++end] = children[i];
        }
    }
    // Create indexToGraph map
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        for(var j = 0; j < graph.length; j++){
            var index = layoutInfo.idToIndex[graph[j]];
            layoutInfo.indexToGraph[index] = i;
        }
    }
    // Iterate over all edges, creating Layout Edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        var e = edges[i];
        var tempEdge = {};
        tempEdge.id = e.data('id');
        tempEdge.sourceId = e.data('source');
        tempEdge.targetId = e.data('target');
        // Compute ideal length
        var idealLength = fn$6(options.idealEdgeLength) ? options.idealEdgeLength(e) : options.idealEdgeLength;
        var elasticity = fn$6(options.edgeElasticity) ? options.edgeElasticity(e) : options.edgeElasticity;
        // Check if it's an inter graph edge
        var sourceIx = layoutInfo.idToIndex[tempEdge.sourceId];
        var targetIx = layoutInfo.idToIndex[tempEdge.targetId];
        var sourceGraph = layoutInfo.indexToGraph[sourceIx];
        var targetGraph = layoutInfo.indexToGraph[targetIx];
        if (sourceGraph != targetGraph) {
            // Find lowest common graph ancestor
            var lca = findLCA(tempEdge.sourceId, tempEdge.targetId, layoutInfo);
            // Compute sum of node depths, relative to lca graph
            var lcaGraph = layoutInfo.graphSet[lca];
            var depth = 0;
            // Source depth
            var tempNode = layoutInfo.layoutNodes[sourceIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // Target depth
            tempNode = layoutInfo.layoutNodes[targetIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // logDebug('LCA of nodes ' + tempEdge.sourceId + ' and ' + tempEdge.targetId +
            //  ". Index: " + lca + " Contents: " + lcaGraph.toString() +
            //  ". Depth: " + depth);
            // Update idealLength
            idealLength *= depth * options.nestingFactor;
        }
        tempEdge.idealLength = idealLength;
        tempEdge.elasticity = elasticity;
        layoutInfo.layoutEdges.push(tempEdge);
    }
    // Finally, return layoutInfo object
    return layoutInfo;
};
/**
 * @brief : This function finds the index of the lowest common
 *          graph ancestor between 2 nodes in the subtree
 *          (from the graph hierarchy induced tree) whose
 *          root is graphIx
 *
 * @arg node1: node1's ID
 * @arg node2: node2's ID
 * @arg layoutInfo: layoutInfo object
 *
 */ var findLCA = function findLCA(node1, node2, layoutInfo) {
    // Find their common ancester, starting from the root graph
    var res = _findLCA_aux(node1, node2, 0, layoutInfo);
    if (2 > res.count) // If aux function couldn't find the common ancester,
    // then it is the root graph
    return 0;
    else return res.graph;
};
/**
 * @brief          : Auxiliary function used for LCA computation
 *
 * @arg node1      : node1's ID
 * @arg node2      : node2's ID
 * @arg graphIx    : subgraph index
 * @arg layoutInfo : layoutInfo object
 *
 * @return         : object of the form {count: X, graph: Y}, where:
 *                   X is the number of ancestors (max: 2) found in
 *                   graphIx (and it's subgraphs),
 *                   Y is the graph index of the lowest graph containing
 *                   all X nodes
 */ var _findLCA_aux = function findLCA_aux(node1, node2, graphIx, layoutInfo) {
    var graph = layoutInfo.graphSet[graphIx];
    // If both nodes belongs to graphIx
    if (-1 < graph.indexOf(node1) && -1 < graph.indexOf(node2)) return {
        count: 2,
        graph: graphIx
    };
    // Make recursive calls for all subgraphs
    var c = 0;
    for(var i = 0; i < graph.length; i++){
        var nodeId = graph[i];
        var nodeIx = layoutInfo.idToIndex[nodeId];
        var children = layoutInfo.layoutNodes[nodeIx].children;
        // If the node has no child, skip it
        if (0 === children.length) continue;
        var childGraphIx = layoutInfo.indexToGraph[layoutInfo.idToIndex[children[0]]];
        var result = _findLCA_aux(node1, node2, childGraphIx, layoutInfo);
        if (0 === result.count) continue;
        else if (1 === result.count) {
            // One of (node1, node2) is present in this subgraph
            c++;
            if (2 === c) break;
        } else // Both nodes are present in this subgraph
        return result;
    }
    return {
        count: c,
        graph: graphIx
    };
};
/**
 * @brief: printsLayoutInfo into js console
 *         Only used for debbuging
 */ var printLayoutInfo;
/**
 * @brief : Randomizes the position of all nodes
 */ var randomizePositions = function randomizePositions(layoutInfo, cy) {
    var width = layoutInfo.clientWidth;
    var height = layoutInfo.clientHeight;
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        // No need to randomize compound nodes or locked nodes
        if (0 === n.children.length && !n.isLocked) {
            n.positionX = Math.random() * width;
            n.positionY = Math.random() * height;
        }
    }
};
var getScaleInBoundsFn = function getScaleInBoundsFn(layoutInfo, options, nodes) {
    var bb = layoutInfo.boundingBox;
    var coseBB = {
        x1: Infinity,
        x2: -Infinity,
        y1: Infinity,
        y2: -Infinity
    };
    if (options.boundingBox) {
        nodes.forEach(function(node) {
            var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[node.data('id')]];
            coseBB.x1 = Math.min(coseBB.x1, lnode.positionX);
            coseBB.x2 = Math.max(coseBB.x2, lnode.positionX);
            coseBB.y1 = Math.min(coseBB.y1, lnode.positionY);
            coseBB.y2 = Math.max(coseBB.y2, lnode.positionY);
        });
        coseBB.w = coseBB.x2 - coseBB.x1;
        coseBB.h = coseBB.y2 - coseBB.y1;
    }
    return function(ele, i) {
        var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[ele.data('id')]];
        if (options.boundingBox) {
            // then add extra bounding box constraint
            var pctX = (lnode.positionX - coseBB.x1) / coseBB.w;
            var pctY = (lnode.positionY - coseBB.y1) / coseBB.h;
            return {
                x: bb.x1 + pctX * bb.w,
                y: bb.y1 + pctY * bb.h
            };
        } else return {
            x: lnode.positionX,
            y: lnode.positionY
        };
    };
};
/**
 * @brief          : Updates the positions of nodes in the network
 * @arg layoutInfo : LayoutInfo object
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var refreshPositions = function refreshPositions(layoutInfo, cy, options) {
    // var s = 'Refreshing positions';
    // logDebug(s);
    var layout = options.layout;
    var nodes = options.eles.nodes();
    var getScaledPos = getScaleInBoundsFn(layoutInfo, options, nodes);
    nodes.positions(getScaledPos);
    // Trigger layoutReady only on first call
    if (true !== layoutInfo.ready) {
        // s = 'Triggering layoutready';
        // logDebug(s);
        layoutInfo.ready = true;
        layout.one('layoutready', options.ready);
        layout.emit({
            type: 'layoutready',
            layout: this
        });
    }
};
/**
 * @brief : Logs a debug message in JS console, if DEBUG is ON
 */ // var logDebug = function(text) {
//   if (DEBUG) {
//     console.debug(text);
//   }
// };
/**
 * @brief          : Performs one iteration of the physical simulation
 * @arg layoutInfo : LayoutInfo object already initialized
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var step = function step(layoutInfo, options, _step) {
    // var s = "\n\n###############################";
    // s += "\nSTEP: " + step;
    // s += "\n###############################\n";
    // logDebug(s);
    // Calculate node repulsions
    calculateNodeForces(layoutInfo, options);
    // Calculate edge forces
    calculateEdgeForces(layoutInfo);
    // Calculate gravity forces
    calculateGravityForces(layoutInfo, options);
    // Propagate forces from parent to child
    propagateForces(layoutInfo);
    // Update positions based on calculated forces
    updatePositions(layoutInfo);
};
/**
 * @brief : Computes the node repulsion forces
 */ var calculateNodeForces = function calculateNodeForces(layoutInfo, options) {
    // Go through each of the graphs in graphSet
    // Nodes only repel each other if they belong to the same graph
    // var s = 'calculateNodeForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Now get all the pairs of nodes
        // Only get each pair once, (A, B) = (B, A)
        for(var j = 0; j < numNodes; j++){
            var node1 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            for(var k = j + 1; k < numNodes; k++){
                var node2 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[k]]];
                nodeRepulsion(node1, node2, layoutInfo, options);
            }
        }
    }
};
var randomDistance = function randomDistance(max) {
    return -1 + 2 * max * Math.random();
};
/**
 * @brief : Compute the node repulsion forces between a pair of nodes
 */ var nodeRepulsion = function nodeRepulsion(node1, node2, layoutInfo, options) {
    // var s = "Node repulsion. Node1: " + node1.id + " Node2: " + node2.id;
    var cmptId1 = node1.cmptId;
    var cmptId2 = node2.cmptId;
    if (cmptId1 !== cmptId2 && !layoutInfo.isCompound) return;
    // Get direction of line connecting both node centers
    var directionX = node2.positionX - node1.positionX;
    var directionY = node2.positionY - node1.positionY;
    var maxRandDist = 1;
    // s += "\ndirectionX: " + directionX + ", directionY: " + directionY;
    // If both centers are the same, apply a random force
    if (0 === directionX && 0 === directionY) {
        directionX = randomDistance(maxRandDist);
        directionY = randomDistance(maxRandDist);
    }
    var overlap = nodesOverlap(node1, node2, directionX, directionY);
    if (overlap > 0) {
        // s += "\nNodes DO overlap.";
        // s += "\nOverlap: " + overlap;
        // If nodes overlap, repulsion force is proportional
        // to the overlap
        var force = options.nodeOverlap * overlap;
        // Compute the module and components of the force vector
        var distance = Math.sqrt(directionX * directionX + directionY * directionY);
        // s += "\nDistance: " + distance;
        var forceX = force * directionX / distance;
        var forceY = force * directionY / distance;
    } else {
        // s += "\nNodes do NOT overlap.";
        // If there's no overlap, force is inversely proportional
        // to squared distance
        // Get clipping points for both nodes
        var point1 = findClippingPoint(node1, directionX, directionY);
        var point2 = findClippingPoint(node2, -1 * directionX, -1 * directionY);
        // Use clipping points to compute distance
        var distanceX = point2.x - point1.x;
        var distanceY = point2.y - point1.y;
        var distanceSqr = distanceX * distanceX + distanceY * distanceY;
        var distance = Math.sqrt(distanceSqr);
        // s += "\nDistance: " + distance;
        // Compute the module and components of the force vector
        var force = (node1.nodeRepulsion + node2.nodeRepulsion) / distanceSqr;
        var forceX = force * distanceX / distance;
        var forceY = force * distanceY / distance;
    }
    // Apply force
    if (!node1.isLocked) {
        node1.offsetX -= forceX;
        node1.offsetY -= forceY;
    }
    if (!node2.isLocked) {
        node2.offsetX += forceX;
        node2.offsetY += forceY;
    }
    // s += "\nForceX: " + forceX + " ForceY: " + forceY;
    // logDebug(s);
    return;
};
/**
 * @brief  : Determines whether two nodes overlap or not
 * @return : Amount of overlapping (0 => no overlap)
 */ var nodesOverlap = function nodesOverlap(node1, node2, dX, dY) {
    if (dX > 0) var overlapX = node1.maxX - node2.minX;
    else var overlapX = node2.maxX - node1.minX;
    if (dY > 0) var overlapY = node1.maxY - node2.minY;
    else var overlapY = node2.maxY - node1.minY;
    if (overlapX >= 0 && overlapY >= 0) return Math.sqrt(overlapX * overlapX + overlapY * overlapY);
    else return 0;
};
/**
 * @brief : Finds the point in which an edge (direction dX, dY) intersects
 *          the rectangular bounding box of it's source/target node
 */ var findClippingPoint = function findClippingPoint(node, dX, dY) {
    // Shorcuts
    var X = node.positionX;
    var Y = node.positionY;
    var H = node.height || 1;
    var W = node.width || 1;
    var dirSlope = dY / dX;
    var nodeSlope = H / W;
    // var s = 'Computing clipping point of node ' + node.id +
    //   " . Height:  " + H + ", Width: " + W +
    //   "\nDirection " + dX + ", " + dY;
    //
    // Compute intersection
    var res = {};
    // Case: Vertical direction (up)
    if (0 === dX && 0 < dY) {
        res.x = X;
        // s += "\nUp direction";
        res.y = Y + H / 2;
        return res;
    }
    // Case: Vertical direction (down)
    if (0 === dX && 0 > dY) {
        res.x = X;
        res.y = Y + H / 2;
        // s += "\nDown direction";
        return res;
    }
    // Case: Intersects the right border
    if (0 < dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X + W / 2;
        res.y = Y + W * dY / 2 / dX;
        // s += "\nRightborder";
        return res;
    }
    // Case: Intersects the left border
    if (0 > dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X - W / 2;
        res.y = Y - W * dY / 2 / dX;
        // s += "\nLeftborder";
        return res;
    }
    // Case: Intersects the top border
    if (0 < dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X + H * dX / 2 / dY;
        res.y = Y + H / 2;
        // s += "\nTop border";
        return res;
    }
    // Case: Intersects the bottom border
    if (0 > dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X - H * dX / 2 / dY;
        res.y = Y - H / 2;
        // s += "\nBottom border";
        return res;
    }
    // s += "\nClipping point found at " + res.x + ", " + res.y;
    // logDebug(s);
    return res;
};
/**
 * @brief : Calculates all edge forces
 */ var calculateEdgeForces = function calculateEdgeForces(layoutInfo, options) {
    // Iterate over all edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        // Get edge, source & target nodes
        var edge = layoutInfo.layoutEdges[i];
        var sourceIx = layoutInfo.idToIndex[edge.sourceId];
        var source = layoutInfo.layoutNodes[sourceIx];
        var targetIx = layoutInfo.idToIndex[edge.targetId];
        var target = layoutInfo.layoutNodes[targetIx];
        // Get direction of line connecting both node centers
        var directionX = target.positionX - source.positionX;
        var directionY = target.positionY - source.positionY;
        // If both centers are the same, do nothing.
        // A random force has already been applied as node repulsion
        if (0 === directionX && 0 === directionY) continue;
        // Get clipping points for both nodes
        var point1 = findClippingPoint(source, directionX, directionY);
        var point2 = findClippingPoint(target, -1 * directionX, -1 * directionY);
        var lx = point2.x - point1.x;
        var ly = point2.y - point1.y;
        var l = Math.sqrt(lx * lx + ly * ly);
        var force = Math.pow(edge.idealLength - l, 2) / edge.elasticity;
        if (0 !== l) {
            var forceX = force * lx / l;
            var forceY = force * ly / l;
        } else {
            var forceX = 0;
            var forceY = 0;
        }
        // Add this force to target and source nodes
        if (!source.isLocked) {
            source.offsetX += forceX;
            source.offsetY += forceY;
        }
        if (!target.isLocked) {
            target.offsetX -= forceX;
            target.offsetY -= forceY;
        }
    // var s = 'Edge force between nodes ' + source.id + ' and ' + target.id;
    // s += "\nDistance: " + l + " Force: (" + forceX + ", " + forceY + ")";
    // logDebug(s);
    }
};
/**
 * @brief : Computes gravity forces for all nodes
 */ var calculateGravityForces = function calculateGravityForces(layoutInfo, options) {
    if (options.gravity === 0) return;
    var distThreshold = 1;
    // var s = 'calculateGravityForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Compute graph center
        if (0 === i) {
            var centerX = layoutInfo.clientHeight / 2;
            var centerY = layoutInfo.clientWidth / 2;
        } else {
            // Get Parent node for this graph, and use its position as center
            var temp = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[0]]];
            var parent = layoutInfo.layoutNodes[layoutInfo.idToIndex[temp.parentId]];
            var centerX = parent.positionX;
            var centerY = parent.positionY;
        }
        // s = "Center found at: " + centerX + ", " + centerY;
        // logDebug(s);
        // Apply force to all nodes in graph
        for(var j = 0; j < numNodes; j++){
            var node = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            // s = "Node: " + node.id;
            if (node.isLocked) continue;
            var dx = centerX - node.positionX;
            var dy = centerY - node.positionY;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d > distThreshold) {
                var fx = options.gravity * dx / d;
                var fy = options.gravity * dy / d;
                node.offsetX += fx;
                node.offsetY += fy;
            // s += ": Applied force: " + fx + ", " + fy;
            }
        // logDebug(s);
        }
    }
};
/**
 * @brief          : This function propagates the existing offsets from
 *                   parent nodes to its descendents.
 * @arg layoutInfo : layoutInfo Object
 * @arg cy         : cytoscape Object
 * @arg options    : Layout options
 */ var propagateForces = function propagateForces(layoutInfo, options) {
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    // logDebug('propagateForces');
    // Start by visiting the nodes in the root graph
    queue.push.apply(queue, layoutInfo.graphSet[0]);
    end += layoutInfo.graphSet[0].length;
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var nodeId = queue[start++];
        var nodeIndex = layoutInfo.idToIndex[nodeId];
        var node = layoutInfo.layoutNodes[nodeIndex];
        var children = node.children;
        // We only need to process the node if it's compound
        if (0 < children.length && !node.isLocked) {
            var offX = node.offsetX;
            var offY = node.offsetY;
            // var s = "Propagating offset from parent node : " + node.id +
            //   ". OffsetX: " + offX + ". OffsetY: " + offY;
            // s += "\n Children: " + children.toString();
            // logDebug(s);
            for(var i = 0; i < children.length; i++){
                var childNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[children[i]]];
                // Propagate offset
                childNode.offsetX += offX;
                childNode.offsetY += offY;
                // Add children to queue to be visited
                queue[++end] = children[i];
            }
            // Reset parent offsets
            node.offsetX = 0;
            node.offsetY = 0;
        }
    }
};
/**
 * @brief : Updates the layout model positions, based on
 *          the accumulated forces
 */ var updatePositions = function updatePositions(layoutInfo, options) {
    // var s = 'Updating positions';
    // logDebug(s);
    // Reset boundaries for compound nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length) {
            // logDebug("Resetting boundaries of compound node: " + n.id);
            n.maxX = undefined;
            n.minX = undefined;
            n.maxY = undefined;
            n.minY = undefined;
        }
    }
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length || n.isLocked) continue;
        // s = "Node: " + n.id + " Previous position: (" +
        // n.positionX + ", " + n.positionY + ").";
        // Limit displacement in order to improve stability
        var tempForce = limitForce(n.offsetX, n.offsetY, layoutInfo.temperature);
        n.positionX += tempForce.x;
        n.positionY += tempForce.y;
        n.offsetX = 0;
        n.offsetY = 0;
        n.minX = n.positionX - n.width;
        n.maxX = n.positionX + n.width;
        n.minY = n.positionY - n.height;
        n.maxY = n.positionY + n.height;
        // s += " New Position: (" + n.positionX + ", " + n.positionY + ").";
        // logDebug(s);
        // Update ancestry boudaries
        _updateAncestryBoundaries(n, layoutInfo);
    }
    // Update size, position of compund nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length && !n.isLocked) {
            n.positionX = (n.maxX + n.minX) / 2;
            n.positionY = (n.maxY + n.minY) / 2;
            n.width = n.maxX - n.minX;
            n.height = n.maxY - n.minY;
        // s = "Updating position, size of compound node " + n.id;
        // s += "\nPositionX: " + n.positionX + ", PositionY: " + n.positionY;
        // s += "\nWidth: " + n.width + ", Height: " + n.height;
        // logDebug(s);
        }
    }
};
/**
 * @brief : Limits a force (forceX, forceY) to be not
 *          greater (in modulo) than max.
 8          Preserves force direction.
  */ var limitForce = function limitForce(forceX, forceY, max) {
    // var s = "Limiting force: (" + forceX + ", " + forceY + "). Max: " + max;
    var force = Math.sqrt(forceX * forceX + forceY * forceY);
    if (force > max) var res = {
        x: max * forceX / force,
        y: max * forceY / force
    };
    else var res = {
        x: forceX,
        y: forceY
    };
    // s += ".\nResult: (" + res.x + ", " + res.y + ")";
    // logDebug(s);
    return res;
};
/**
 * @brief : Function used for keeping track of compound node
 *          sizes, since they should bound all their subnodes.
 */ var _updateAncestryBoundaries = function updateAncestryBoundaries(node, layoutInfo) {
    // var s = "Propagating new position/size of node " + node.id;
    var parentId = node.parentId;
    if (null == parentId) // If there's no parent, we are done
    // s += ". No parent node.";
    // logDebug(s);
    return;
    // Get Parent Node
    var p = layoutInfo.layoutNodes[layoutInfo.idToIndex[parentId]];
    var flag = false;
    // MaxX
    if (null == p.maxX || node.maxX + p.padRight > p.maxX) {
        p.maxX = node.maxX + p.padRight;
        flag = true;
    // s += "\nNew maxX for parent node " + p.id + ": " + p.maxX;
    }
    // MinX
    if (null == p.minX || node.minX - p.padLeft < p.minX) {
        p.minX = node.minX - p.padLeft;
        flag = true;
    // s += "\nNew minX for parent node " + p.id + ": " + p.minX;
    }
    // MaxY
    if (null == p.maxY || node.maxY + p.padBottom > p.maxY) {
        p.maxY = node.maxY + p.padBottom;
        flag = true;
    // s += "\nNew maxY for parent node " + p.id + ": " + p.maxY;
    }
    // MinY
    if (null == p.minY || node.minY - p.padTop < p.minY) {
        p.minY = node.minY - p.padTop;
        flag = true;
    // s += "\nNew minY for parent node " + p.id + ": " + p.minY;
    }
    // If updated boundaries, propagate changes upward
    if (flag) // logDebug(s);
    return _updateAncestryBoundaries(p, layoutInfo);
    // s += ". No changes in boundaries/position of parent node " + p.id;
    // logDebug(s);
    return;
};
var separateComponents = function separateComponents(layoutInfo, options) {
    var nodes = layoutInfo.layoutNodes;
    var components = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var cid = node.cmptId;
        var component = components[cid] = components[cid] || [];
        component.push(node);
    }
    var totalA = 0;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        c.x1 = Infinity;
        c.x2 = -Infinity;
        c.y1 = Infinity;
        c.y2 = -Infinity;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            c.x1 = Math.min(c.x1, n.positionX - n.width / 2);
            c.x2 = Math.max(c.x2, n.positionX + n.width / 2);
            c.y1 = Math.min(c.y1, n.positionY - n.height / 2);
            c.y2 = Math.max(c.y2, n.positionY + n.height / 2);
        }
        c.w = c.x2 - c.x1;
        c.h = c.y2 - c.y1;
        totalA += c.w * c.h;
    }
    components.sort(function(c1, c2) {
        return c2.w * c2.h - c1.w * c1.h;
    });
    var x = 0;
    var y = 0;
    var usedW = 0;
    var rowH = 0;
    var maxRowW = Math.sqrt(totalA) * layoutInfo.clientWidth / layoutInfo.clientHeight;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            if (!n.isLocked) {
                n.positionX += x - c.x1;
                n.positionY += y - c.y1;
            }
        }
        x += c.w + options.componentSpacing;
        usedW += c.w + options.componentSpacing;
        rowH = Math.max(rowH, c.h);
        if (usedW > maxRowW) {
            y += rowH + options.componentSpacing;
            x = 0;
            usedW = 0;
            rowH = 0;
        }
    }
};
var defaults$3 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // padding used on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    avoidOverlapPadding: 10,
    // extra spacing around nodes when avoidOverlap: true
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    condense: false,
    // uses all available space on false, uses minimal space on true
    rows: undefined,
    // force num of rows in the grid
    cols: undefined,
    // force num of columns in the grid
    position: function position(node) {},
    // returns { row, col } for element
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function GridLayout(options) {
    this.options = extend({}, defaults$3, options);
}
GridLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    if (bb.h === 0 || bb.w === 0) eles.nodes().layoutPositions(this, options, function(ele) {
        return {
            x: bb.x1,
            y: bb.y1
        };
    });
    else {
        // width/height * splits^2 = cells where splits is number of times to split width
        var cells = nodes.size();
        var splits = Math.sqrt(cells * bb.h / bb.w);
        var rows = Math.round(splits);
        var cols = Math.round(bb.w / bb.h * splits);
        var small = function small(val) {
            if (val == null) return Math.min(rows, cols);
            else {
                var min = Math.min(rows, cols);
                if (min == rows) rows = val;
                else cols = val;
            }
        };
        var large = function large(val) {
            if (val == null) return Math.max(rows, cols);
            else {
                var max = Math.max(rows, cols);
                if (max == rows) rows = val;
                else cols = val;
            }
        };
        var oRows = options.rows;
        var oCols = options.cols != null ? options.cols : options.columns;
        // if rows or columns were set in options, use those values
        if (oRows != null && oCols != null) {
            rows = oRows;
            cols = oCols;
        } else if (oRows != null && oCols == null) {
            rows = oRows;
            cols = Math.ceil(cells / rows);
        } else if (oRows == null && oCols != null) {
            cols = oCols;
            rows = Math.ceil(cells / cols);
        } else if (cols * rows > cells) {
            var sm = small();
            var lg = large();
            // reducing the small side takes away the most cells, so try it first
            if ((sm - 1) * lg >= cells) small(sm - 1);
            else if ((lg - 1) * sm >= cells) large(lg - 1);
        } else // if rounding was too low, add rows or columns
        while(cols * rows < cells){
            var _sm = small();
            var _lg = large();
            // try to add to larger side first (adds less in multiplication)
            if ((_lg + 1) * _sm >= cells) large(_lg + 1);
            else small(_sm + 1);
        }
        var cellWidth = bb.w / cols;
        var cellHeight = bb.h / rows;
        if (options.condense) {
            cellWidth = 0;
            cellHeight = 0;
        }
        if (options.avoidOverlap) for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            var pos = node._private.position;
            if (pos.x == null || pos.y == null) {
                // for bb
                pos.x = 0;
                pos.y = 0;
            }
            var nbb = node.layoutDimensions(options);
            var p = options.avoidOverlapPadding;
            var w = nbb.w + p;
            var h = nbb.h + p;
            cellWidth = Math.max(cellWidth, w);
            cellHeight = Math.max(cellHeight, h);
        }
        var cellUsed = {}; // e.g. 'c-0-2' => true
        var used = function used(row, col) {
            return cellUsed['c-' + row + '-' + col] ? true : false;
        };
        var use = function use(row, col) {
            cellUsed['c-' + row + '-' + col] = true;
        };
        // to keep track of current cell position
        var row = 0;
        var col = 0;
        var moveToNextCell = function moveToNextCell() {
            col++;
            if (col >= cols) {
                col = 0;
                row++;
            }
        };
        // get a cache of all the manual positions
        var id2manPos = {};
        for(var _i = 0; _i < nodes.length; _i++){
            var _node = nodes[_i];
            var rcPos = options.position(_node);
            if (rcPos && (rcPos.row !== undefined || rcPos.col !== undefined)) {
                // must have at least row or col def'd
                var _pos = {
                    row: rcPos.row,
                    col: rcPos.col
                };
                if (_pos.col === undefined) {
                    // find unused col
                    _pos.col = 0;
                    while(used(_pos.row, _pos.col))_pos.col++;
                } else if (_pos.row === undefined) {
                    // find unused row
                    _pos.row = 0;
                    while(used(_pos.row, _pos.col))_pos.row++;
                }
                id2manPos[_node.id()] = _pos;
                use(_pos.row, _pos.col);
            }
        }
        var getPos = function getPos(element, i) {
            var x, y;
            if (element.locked() || element.isParent()) return false;
            // see if we have a manual position set
            var rcPos = id2manPos[element.id()];
            if (rcPos) {
                x = rcPos.col * cellWidth + cellWidth / 2 + bb.x1;
                y = rcPos.row * cellHeight + cellHeight / 2 + bb.y1;
            } else {
                // otherwise set automatically
                while(used(row, col))moveToNextCell();
                x = col * cellWidth + cellWidth / 2 + bb.x1;
                y = row * cellHeight + cellHeight / 2 + bb.y1;
                use(row, col);
                moveToNextCell();
            }
            return {
                x: x,
                y: y
            };
        };
        nodes.layoutPositions(this, options, getPos);
    }
    return this; // chaining
};
// default layout options
var defaults$2 = {
    ready: function ready() {},
    // on layoutready
    stop: function stop() {} // on layoutstop
};
// constructor
// options : object containing layout options
function NullLayout(options) {
    this.options = extend({}, defaults$2, options);
}
// runs the layout
NullLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles; // elements to consider in the layout
    var layout = this;
    // cy is automatically populated for us in the constructor
    // (disable eslint for next line as this serves as example layout code to external developers)
    // eslint-disable-next-line no-unused-vars
    options.cy;
    layout.emit('layoutstart');
    // puts all nodes at (0, 0)
    // n.b. most layouts would use layoutPositions(), instead of positions() and manual events
    eles.nodes().positions(function() {
        return {
            x: 0,
            y: 0
        };
    });
    // trigger layoutready when each node has had its position set at least once
    layout.one('layoutready', options.ready);
    layout.emit('layoutready');
    // trigger layoutstop when the layout stops (e.g. finishes)
    layout.one('layoutstop', options.stop);
    layout.emit('layoutstop');
    return this; // chaining
};
// called on continuous layouts to stop them before they finish
NullLayout.prototype.stop = function() {
    return this; // chaining
};
var defaults$1 = {
    positions: undefined,
    // map of (node id) => (position obj); or function(node){ return somPos; }
    zoom: undefined,
    // the zoom level to set (prob want fit = false if set)
    pan: undefined,
    // the pan level to set (prob want fit = false if set)
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // padding on fit
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function PresetLayout(options) {
    this.options = extend({}, defaults$1, options);
}
PresetLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles;
    var nodes = eles.nodes();
    var posIsFn = fn$6(options.positions);
    function getPosition(node) {
        if (options.positions == null) return copyPosition(node.position());
        if (posIsFn) return options.positions(node);
        var pos = options.positions[node._private.data.id];
        if (pos == null) return null;
        return pos;
    }
    nodes.layoutPositions(this, options, function(node, i) {
        var position = getPosition(node);
        if (node.locked() || position == null) return false;
        return position;
    });
    return this; // chaining
};
var defaults = {
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // fit padding
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function RandomLayout(options) {
    this.options = extend({}, defaults, options);
}
RandomLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var bb = makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var getPos = function getPos(node, i) {
        return {
            x: bb.x1 + Math.round(Math.random() * bb.w),
            y: bb.y1 + Math.round(Math.random() * bb.h)
        };
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var layout = [
    {
        name: 'breadthfirst',
        impl: BreadthFirstLayout
    },
    {
        name: 'circle',
        impl: CircleLayout
    },
    {
        name: 'concentric',
        impl: ConcentricLayout
    },
    {
        name: 'cose',
        impl: CoseLayout
    },
    {
        name: 'grid',
        impl: GridLayout
    },
    {
        name: 'null',
        impl: NullLayout
    },
    {
        name: 'preset',
        impl: PresetLayout
    },
    {
        name: 'random',
        impl: RandomLayout
    }
];
function NullRenderer(options) {
    this.options = options;
    this.notifications = 0; // for testing
}
var noop = function noop() {};
var throwImgErr = function throwImgErr() {
    throw new Error('A headless instance can not render images');
};
NullRenderer.prototype = {
    recalculateRenderedStyle: noop,
    notify: function notify() {
        this.notifications++;
    },
    init: noop,
    isHeadless: function isHeadless() {
        return true;
    },
    png: throwImgErr,
    jpg: throwImgErr
};
var BRp$f = {};
BRp$f.arrowShapeWidth = 0.3;
BRp$f.registerArrowShapes = function() {
    var arrowShapes = this.arrowShapes = {};
    var renderer = this;
    // Contract for arrow shapes:
    // 0, 0 is arrow tip
    // (0, 1) is direction towards node
    // (1, 0) is right
    //
    // functional api:
    // collide: check x, y in shape
    // roughCollide: called before collide, no false negatives
    // draw: draw
    // spacing: dist(arrowTip, nodeBoundary)
    // gap: dist(edgeTip, nodeBoundary), edgeTip may != arrowTip
    var bbCollide = function bbCollide(x, y, size, angle, translation, edgeWidth, padding) {
        var x1 = translation.x - size / 2 - padding;
        var x2 = translation.x + size / 2 + padding;
        var y1 = translation.y - size / 2 - padding;
        var y2 = translation.y + size / 2 + padding;
        var inside = x1 <= x && x <= x2 && y1 <= y && y <= y2;
        return inside;
    };
    var transform = function transform(x, y, size, angle, translation) {
        var xRotated = x * Math.cos(angle) - y * Math.sin(angle);
        var yRotated = x * Math.sin(angle) + y * Math.cos(angle);
        var xScaled = xRotated * size;
        var yScaled = yRotated * size;
        var xTranslated = xScaled + translation.x;
        var yTranslated = yScaled + translation.y;
        return {
            x: xTranslated,
            y: yTranslated
        };
    };
    var transformPoints = function transformPoints(pts, size, angle, translation) {
        var retPts = [];
        for(var i = 0; i < pts.length; i += 2){
            var x = pts[i];
            var y = pts[i + 1];
            retPts.push(transform(x, y, size, angle, translation));
        }
        return retPts;
    };
    var pointsToArr = function pointsToArr(pts) {
        var ret = [];
        for(var i = 0; i < pts.length; i++){
            var p = pts[i];
            ret.push(p.x, p.y);
        }
        return ret;
    };
    var standardGap = function standardGap(edge) {
        return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').pfValue * 2;
    };
    var defineArrowShape = function defineArrowShape(name, defn) {
        if (string(defn)) defn = arrowShapes[defn];
        arrowShapes[name] = extend({
            name: name,
            points: [
                -0.15,
                -0.3,
                0.15,
                -0.3,
                0.15,
                0.3,
                -0.15,
                0.3
            ],
            collide: function collide(x, y, size, angle, translation, padding) {
                var points = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
                var inside = pointInsidePolygonPoints(x, y, points);
                return inside;
            },
            roughCollide: bbCollide,
            draw: function draw(context, size, angle, translation) {
                var points = transformPoints(this.points, size, angle, translation);
                renderer.arrowShapeImpl('polygon')(context, points);
            },
            spacing: function spacing(edge) {
                return 0;
            },
            gap: standardGap
        }, defn);
    };
    defineArrowShape('none', {
        collide: falsify,
        roughCollide: falsify,
        draw: noop$1,
        spacing: zeroify,
        gap: zeroify
    });
    defineArrowShape('triangle', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3
        ]
    });
    defineArrowShape('arrow', 'triangle');
    defineArrowShape('triangle-backcurve', {
        points: arrowShapes['triangle'].points,
        controlPoint: [
            0,
            -0.15
        ],
        roughCollide: bbCollide,
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var ptsTrans = transformPoints(this.points, size, angle, translation);
            var ctrlPt = this.controlPoint;
            var ctrlPtTrans = transform(ctrlPt[0], ctrlPt[1], size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, ptsTrans, ctrlPtTrans);
        },
        gap: function gap(edge) {
            return standardGap(edge) * 0.8;
        }
    });
    defineArrowShape('triangle-tee', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        pointsTee: [
            -0.15,
            -0.4,
            -0.15,
            -0.5,
            0.15,
            -0.5,
            0.15,
            -0.4
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.pointsTee, size + 2 * padding, angle, translation));
            var inside = pointInsidePolygonPoints(x, y, triPts) || pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var teePts = transformPoints(this.pointsTee, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, teePts);
        }
    });
    defineArrowShape('circle-triangle', {
        radius: 0.15,
        pointsTr: [
            0,
            -0.15,
            0.15,
            -0.45,
            -0.15,
            -0.45,
            0,
            -0.15
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var circleInside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            return pointInsidePolygonPoints(x, y, triPts) || circleInside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.pointsTr, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('triangle-cross', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        baseCrossLinePts: [
            -0.15,
            -0.4,
            // first half of the rectangle
            -0.15,
            -0.4,
            0.15,
            -0.4,
            // second half of the rectangle
            0.15,
            -0.4
        ],
        crossLinePts: function crossLinePts(size, edgeWidth) {
            // shift points so that the distance between the cross points matches edge width
            var p = this.baseCrossLinePts.slice();
            var shiftFactor = edgeWidth / size;
            var y0 = 3;
            var y1 = 5;
            p[y0] = p[y0] - shiftFactor;
            p[y1] = p[y1] - shiftFactor;
            return p;
        },
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.crossLinePts(size, edgeWidth), size + 2 * padding, angle, translation));
            var inside = pointInsidePolygonPoints(x, y, triPts) || pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var crossLinePts = transformPoints(this.crossLinePts(size, edgeWidth), size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, crossLinePts);
        }
    });
    defineArrowShape('vee', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3,
            0,
            -0.15
        ],
        gap: function gap(edge) {
            return standardGap(edge) * 0.525;
        }
    });
    defineArrowShape('circle', {
        radius: 0.15,
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var inside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            renderer.arrowShapeImpl(this.name)(context, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('tee', {
        points: [
            -0.15,
            0,
            -0.15,
            -0.1,
            0.15,
            -0.1,
            0.15,
            0
        ],
        spacing: function spacing(edge) {
            return 1;
        },
        gap: function gap(edge) {
            return 1;
        }
    });
    defineArrowShape('square', {
        points: [
            -0.15,
            0.00,
            0.15,
            0.00,
            0.15,
            -0.3,
            -0.15,
            -0.3
        ]
    });
    defineArrowShape('diamond', {
        points: [
            -0.15,
            -0.15,
            0,
            -0.3,
            0.15,
            -0.15,
            0,
            0
        ],
        gap: function gap(edge) {
            return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
    defineArrowShape('chevron', {
        points: [
            0,
            0,
            -0.15,
            -0.15,
            -0.1,
            -0.2,
            0,
            -0.1,
            0.1,
            -0.2,
            0.15,
            -0.15
        ],
        gap: function gap(edge) {
            return 0.95 * edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
};
var BRp$e = {};
// Project mouse
BRp$e.projectIntoViewport = function(clientX, clientY) {
    var cy = this.cy;
    var offsets = this.findContainerClientCoords();
    var offsetLeft = offsets[0];
    var offsetTop = offsets[1];
    var scale = offsets[4];
    var pan = cy.pan();
    var zoom = cy.zoom();
    var x = ((clientX - offsetLeft) / scale - pan.x) / zoom;
    var y = ((clientY - offsetTop) / scale - pan.y) / zoom;
    return [
        x,
        y
    ];
};
BRp$e.findContainerClientCoords = function() {
    if (this.containerBB) return this.containerBB;
    var container = this.container;
    var rect = container.getBoundingClientRect();
    var style = this.cy.window().getComputedStyle(container);
    var styleValue = function styleValue(name) {
        return parseFloat(style.getPropertyValue(name));
    };
    var padding = {
        left: styleValue('padding-left'),
        right: styleValue('padding-right'),
        top: styleValue('padding-top'),
        bottom: styleValue('padding-bottom')
    };
    var border = {
        left: styleValue('border-left-width'),
        right: styleValue('border-right-width'),
        top: styleValue('border-top-width'),
        bottom: styleValue('border-bottom-width')
    };
    var clientWidth = container.clientWidth;
    var clientHeight = container.clientHeight;
    var paddingHor = padding.left + padding.right;
    var paddingVer = padding.top + padding.bottom;
    var borderHor = border.left + border.right;
    var scale = rect.width / (clientWidth + borderHor);
    var unscaledW = clientWidth - paddingHor;
    var unscaledH = clientHeight - paddingVer;
    var left = rect.left + padding.left + border.left;
    var top = rect.top + padding.top + border.top;
    return this.containerBB = [
        left,
        top,
        unscaledW,
        unscaledH,
        scale
    ];
};
BRp$e.invalidateContainerClientCoordsCache = function() {
    this.containerBB = null;
};
BRp$e.findNearestElement = function(x, y, interactiveElementsOnly, isTouch) {
    return this.findNearestElements(x, y, interactiveElementsOnly, isTouch)[0];
};
BRp$e.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
    var self1 = this;
    var r = this;
    var eles = r.getCachedZSortedEles();
    var near = []; // 1 node max, 1 edge max
    var zoom = r.cy.zoom();
    var hasCompounds = r.cy.hasCompoundNodes();
    var edgeThreshold = (isTouch ? 24 : 8) / zoom;
    var nodeThreshold = (isTouch ? 8 : 2) / zoom;
    var labelThreshold = (isTouch ? 8 : 2) / zoom;
    var minSqDist = Infinity;
    var nearEdge;
    var nearNode;
    if (interactiveElementsOnly) eles = eles.interactive;
    function addEle(ele, sqDist) {
        if (ele.isNode()) {
            if (nearNode) return; // can't replace node
            else {
                nearNode = ele;
                near.push(ele);
            }
        }
        if (ele.isEdge() && (sqDist == null || sqDist < minSqDist)) {
            if (nearEdge) // then replace existing edge
            // can replace only if same z-index
            {
                if (nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value && nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value) {
                    for(var i = 0; i < near.length; i++)if (near[i].isEdge()) {
                        near[i] = ele;
                        nearEdge = ele;
                        minSqDist = sqDist != null ? sqDist : minSqDist;
                        break;
                    }
                }
            } else {
                near.push(ele);
                nearEdge = ele;
                minSqDist = sqDist != null ? sqDist : minSqDist;
            }
        }
    }
    function checkNode(node) {
        var width = node.outerWidth() + 2 * nodeThreshold;
        var height = node.outerHeight() + 2 * nodeThreshold;
        var hw = width / 2;
        var hh = height / 2;
        var pos = node.position();
        var cornerRadius = node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue;
        var rs = node._private.rscratch;
        if (pos.x - hw <= x && x <= pos.x + hw // bb check x
         && pos.y - hh <= y && y <= pos.y + hh // bb check y
        ) {
            var shape = r.nodeShapes[self1.getNodeShape(node)];
            if (shape.checkPoint(x, y, 0, width, height, pos.x, pos.y, cornerRadius, rs)) {
                addEle(node, 0);
                return true;
            }
        }
    }
    function checkEdge(edge) {
        var _p = edge._private;
        var rs = _p.rscratch;
        var styleWidth = edge.pstyle('width').pfValue;
        var scale = edge.pstyle('arrow-scale').value;
        var width = styleWidth / 2 + edgeThreshold; // more like a distance radius from centre
        var widthSq = width * width;
        var width2 = width * 2;
        var src = _p.source;
        var tgt = _p.target;
        var sqDist;
        if (rs.edgeType === 'segments' || rs.edgeType === 'straight' || rs.edgeType === 'haystack') {
            var pts = rs.allpts;
            for(var i = 0; i + 3 < pts.length; i += 2)if (inLineVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], width2) && widthSq > (sqDist = sqdistToFiniteLine(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3]))) {
                addEle(edge, sqDist);
                return true;
            }
        } else if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
            var pts = rs.allpts;
            for(var i = 0; i + 5 < rs.allpts.length; i += 4)if (inBezierVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5], width2) && widthSq > (sqDist = sqdistToQuadraticBezier(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5]))) {
                addEle(edge, sqDist);
                return true;
            }
        }
        // if we're close to the edge but didn't hit it, maybe we hit its arrows
        var src = src || _p.source;
        var tgt = tgt || _p.target;
        var arSize = self1.getArrowWidth(styleWidth, scale);
        var arrows = [
            {
                name: 'source',
                x: rs.arrowStartX,
                y: rs.arrowStartY,
                angle: rs.srcArrowAngle
            },
            {
                name: 'target',
                x: rs.arrowEndX,
                y: rs.arrowEndY,
                angle: rs.tgtArrowAngle
            },
            {
                name: 'mid-source',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midsrcArrowAngle
            },
            {
                name: 'mid-target',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midtgtArrowAngle
            }
        ];
        for(var i = 0; i < arrows.length; i++){
            var ar = arrows[i];
            var shape = r.arrowShapes[edge.pstyle(ar.name + '-arrow-shape').value];
            var edgeWidth = edge.pstyle('width').pfValue;
            if (shape.roughCollide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold) && shape.collide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold)) {
                addEle(edge);
                return true;
            }
        }
        // for compound graphs, hitting edge may actually want a connected node instead (b/c edge may have greater z-index precedence)
        if (hasCompounds && near.length > 0) {
            checkNode(src);
            checkNode(tgt);
        }
    }
    function preprop(obj, name, pre) {
        return getPrefixedProperty(obj, name, pre);
    }
    function checkLabel(ele, prefix) {
        var _p = ele._private;
        var th = labelThreshold;
        var prefixDash;
        if (prefix) prefixDash = prefix + '-';
        else prefixDash = '';
        ele.boundingBox();
        var bb = _p.labelBounds[prefix || 'main'];
        var text = ele.pstyle(prefixDash + 'label').value;
        var eventsEnabled = ele.pstyle('text-events').strValue === 'yes';
        if (!eventsEnabled || !text) return;
        var lx = preprop(_p.rscratch, 'labelX', prefix);
        var ly = preprop(_p.rscratch, 'labelY', prefix);
        var theta = preprop(_p.rscratch, 'labelAngle', prefix);
        var ox = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var oy = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var lx1 = bb.x1 - th - ox; // (-ox, -oy) as bb already includes margin
        var lx2 = bb.x2 + th - ox; // and rotation is about (lx, ly)
        var ly1 = bb.y1 - th - oy;
        var ly2 = bb.y2 + th - oy;
        if (theta) {
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            var rotate = function rotate(x, y) {
                x = x - lx;
                y = y - ly;
                return {
                    x: x * cos - y * sin + lx,
                    y: x * sin + y * cos + ly
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            var points = [
                // with the margin added after the rotation is applied
                px1y1.x + ox,
                px1y1.y + oy,
                px2y1.x + ox,
                px2y1.y + oy,
                px2y2.x + ox,
                px2y2.y + oy,
                px1y2.x + ox,
                px1y2.y + oy
            ];
            if (pointInsidePolygonPoints(x, y, points)) {
                addEle(ele);
                return true;
            }
        } else // do a cheaper bb check
        if (inBoundingBox(bb, x, y)) {
            addEle(ele);
            return true;
        }
    }
    for(var i = eles.length - 1; i >= 0; i--){
        // reverse order for precedence
        var ele = eles[i];
        if (ele.isNode()) checkNode(ele) || checkLabel(ele);
        else // then edge
        checkEdge(ele) || checkLabel(ele) || checkLabel(ele, 'source') || checkLabel(ele, 'target');
    }
    return near;
};
// 'Give me everything from this box'
BRp$e.getAllInBox = function(x1, y1, x2, y2) {
    var eles = this.getCachedZSortedEles().interactive;
    var box = [];
    var x1c = Math.min(x1, x2);
    var x2c = Math.max(x1, x2);
    var y1c = Math.min(y1, y2);
    var y2c = Math.max(y1, y2);
    x1 = x1c;
    x2 = x2c;
    y1 = y1c;
    y2 = y2c;
    var boxBb = makeBoundingBox({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        if (ele.isNode()) {
            var node = ele;
            var nodeBb = node.boundingBox({
                includeNodes: true,
                includeEdges: false,
                includeLabels: false
            });
            if (boundingBoxesIntersect(boxBb, nodeBb) && !boundingBoxInBoundingBox(nodeBb, boxBb)) box.push(node);
        } else {
            var edge = ele;
            var _p = edge._private;
            var rs = _p.rscratch;
            if (rs.startX != null && rs.startY != null && !inBoundingBox(boxBb, rs.startX, rs.startY)) continue;
            if (rs.endX != null && rs.endY != null && !inBoundingBox(boxBb, rs.endX, rs.endY)) continue;
            if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound' || rs.edgeType === 'segments' || rs.edgeType === 'haystack') {
                var pts = _p.rstyle.bezierPts || _p.rstyle.linePts || _p.rstyle.haystackPts;
                var allInside = true;
                for(var i = 0; i < pts.length; i++)if (!pointInBoundingBox(boxBb, pts[i])) {
                    allInside = false;
                    break;
                }
                if (allInside) box.push(edge);
            } else if (rs.edgeType === 'haystack' || rs.edgeType === 'straight') box.push(edge);
        }
    }
    return box;
};
var BRp$d = {};
BRp$d.calculateArrowAngles = function(edge) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    var isBezier = rs.edgeType === 'bezier';
    var isMultibezier = rs.edgeType === 'multibezier';
    var isSegments = rs.edgeType === 'segments';
    var isCompound = rs.edgeType === 'compound';
    var isSelf = rs.edgeType === 'self';
    // Displacement gives direction for arrowhead orientation
    var dispX, dispY;
    var startX, startY, endX, endY, midX, midY;
    if (isHaystack) {
        startX = rs.haystackPts[0];
        startY = rs.haystackPts[1];
        endX = rs.haystackPts[2];
        endY = rs.haystackPts[3];
    } else {
        startX = rs.arrowStartX;
        startY = rs.arrowStartY;
        endX = rs.arrowEndX;
        endY = rs.arrowEndY;
    }
    midX = rs.midX;
    midY = rs.midY;
    // source
    //
    if (isSegments) {
        dispX = startX - rs.segpts[0];
        dispY = startY - rs.segpts[1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var bX = qbezierAt(pts[0], pts[2], pts[4], 0.1);
        var bY = qbezierAt(pts[1], pts[3], pts[5], 0.1);
        dispX = startX - bX;
        dispY = startY - bY;
    } else {
        dispX = startX - midX;
        dispY = startY - midY;
    }
    rs.srcArrowAngle = getAngleFromDisp(dispX, dispY);
    // mid target
    //
    var midX = rs.midX;
    var midY = rs.midY;
    if (isHaystack) {
        midX = (startX + endX) / 2;
        midY = (startY + endY) / 2;
    }
    dispX = endX - startX;
    dispY = endY - startY;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) {
            var i2 = pts.length / 2;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        } else if (rs.isRound) {
            dispX = rs.midVector[1];
            dispY = -rs.midVector[0];
        } else {
            var i2 = pts.length / 2 - 1;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        }
    } else if (isMultibezier || isCompound || isSelf) {
        var pts = rs.allpts;
        var cpts = rs.ctrlpts;
        var bp0x, bp0y;
        var bp1x, bp1y;
        if (cpts.length / 2 % 2 === 0) {
            var p0 = pts.length / 2 - 1; // startpt
            var ic = p0 + 2;
            var p1 = ic + 2;
            bp0x = qbezierAt(pts[p0], pts[ic], pts[p1], 0.0);
            bp0y = qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0);
            bp1x = qbezierAt(pts[p0], pts[ic], pts[p1], 0.0001);
            bp1y = qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0001);
        } else {
            var ic = pts.length / 2 - 1; // ctrpt
            var p0 = ic - 2; // startpt
            var p1 = ic + 2; // endpt
            bp0x = qbezierAt(pts[p0], pts[ic], pts[p1], 0.4999);
            bp0y = qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.4999);
            bp1x = qbezierAt(pts[p0], pts[ic], pts[p1], 0.5);
            bp1y = qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.5);
        }
        dispX = bp1x - bp0x;
        dispY = bp1y - bp0y;
    }
    rs.midtgtArrowAngle = getAngleFromDisp(dispX, dispY);
    rs.midDispX = dispX;
    rs.midDispY = dispY;
    // mid source
    //
    dispX *= -1;
    dispY *= -1;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) ;
        else if (!rs.isRound) {
            var i2 = pts.length / 2 - 1;
            var i3 = i2 + 2;
            dispX = -(pts[i3] - pts[i2]);
            dispY = -(pts[i3 + 1] - pts[i2 + 1]);
        }
    }
    rs.midsrcArrowAngle = getAngleFromDisp(dispX, dispY);
    // target
    //
    if (isSegments) {
        dispX = endX - rs.segpts[rs.segpts.length - 2];
        dispY = endY - rs.segpts[rs.segpts.length - 1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var l = pts.length;
        var bX = qbezierAt(pts[l - 6], pts[l - 4], pts[l - 2], 0.9);
        var bY = qbezierAt(pts[l - 5], pts[l - 3], pts[l - 1], 0.9);
        dispX = endX - bX;
        dispY = endY - bY;
    } else {
        dispX = endX - midX;
        dispY = endY - midY;
    }
    rs.tgtArrowAngle = getAngleFromDisp(dispX, dispY);
};
BRp$d.getArrowWidth = BRp$d.getArrowHeight = function(edgeWidth, scale) {
    var cache = this.arrowWidthCache = this.arrowWidthCache || {};
    var cachedVal = cache[edgeWidth + ', ' + scale];
    if (cachedVal) return cachedVal;
    cachedVal = Math.max(Math.pow(edgeWidth * 13.37, 0.9), 29) * scale;
    cache[edgeWidth + ', ' + scale] = cachedVal;
    return cachedVal;
};
/**
 * Explained by Blindman67 at https://stackoverflow.com/a/44856925/11028828
 */ // Declare reused variable to avoid reallocating variables every time the function is called
var x, y, v1 = {}, v2 = {}, sinA, sinA90, radDirection, drawDirection, angle, halfAngle, cRadius, lenOut, radius, limit;
var startX, startY, stopX, stopY;
var lastPoint;
// convert 2 points into vector form, polar form, and normalised
var asVec = function asVec(p, pp, v) {
    v.x = pp.x - p.x;
    v.y = pp.y - p.y;
    v.len = Math.sqrt(v.x * v.x + v.y * v.y);
    v.nx = v.x / v.len;
    v.ny = v.y / v.len;
    v.ang = Math.atan2(v.ny, v.nx);
};
var invertVec = function invertVec(originalV, invertedV) {
    invertedV.x = originalV.x * -1;
    invertedV.y = originalV.y * -1;
    invertedV.nx = originalV.nx * -1;
    invertedV.ny = originalV.ny * -1;
    invertedV.ang = originalV.ang > 0 ? -(Math.PI - originalV.ang) : Math.PI + originalV.ang;
};
var calcCornerArc = function calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius) {
    //-----------------------------------------
    // Part 1
    previousPoint !== lastPoint ? asVec(currentPoint, previousPoint, v1) : invertVec(v2, v1); // Avoid recalculating vec if it is the invert of the last one calculated
    asVec(currentPoint, nextPoint, v2);
    sinA = v1.nx * v2.ny - v1.ny * v2.nx;
    sinA90 = v1.nx * v2.nx - v1.ny * -v2.ny;
    angle = Math.asin(Math.max(-1, Math.min(1, sinA)));
    if (Math.abs(angle) < 1e-6) {
        x = currentPoint.x;
        y = currentPoint.y;
        cRadius = radius = 0;
        return;
    }
    //-----------------------------------------
    radDirection = 1;
    drawDirection = false;
    if (sinA90 < 0) {
        if (angle < 0) angle = Math.PI + angle;
        else {
            angle = Math.PI - angle;
            radDirection = -1;
            drawDirection = true;
        }
    } else if (angle > 0) {
        radDirection = -1;
        drawDirection = true;
    }
    if (currentPoint.radius !== undefined) radius = currentPoint.radius;
    else radius = radiusMax;
    //-----------------------------------------
    // Part 2
    halfAngle = angle / 2;
    //-----------------------------------------
    limit = Math.min(v1.len / 2, v2.len / 2);
    if (isArcRadius) {
        //-----------------------------------------
        // Part 3
        lenOut = Math.abs(Math.cos(halfAngle) * radius / Math.sin(halfAngle));
        //-----------------------------------------
        // Special part A
        if (lenOut > limit) {
            lenOut = limit;
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = radius;
    } else {
        lenOut = Math.min(limit, radius);
        cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
    }
    //-----------------------------------------
    //-----------------------------------------
    // Part 4
    stopX = currentPoint.x + v2.nx * lenOut;
    stopY = currentPoint.y + v2.ny * lenOut;
    //-----------------------------------------
    // Part 5
    x = stopX - v2.ny * cRadius * radDirection;
    y = stopY + v2.nx * cRadius * radDirection;
    //-----------------------------------------
    // Additional Part : calculate start point E
    startX = currentPoint.x + v1.nx * lenOut;
    startY = currentPoint.y + v1.ny * lenOut;
    // Save last point to avoid recalculating vector when not needed
    lastPoint = currentPoint;
};
/**
 * Draw corner provided by {@link getRoundCorner}
 *
 * @param ctx :CanvasRenderingContext2D
 * @param roundCorner {{cx:number, cy:number, radius:number, endAngle: number, startAngle: number, counterClockwise: boolean}}
 */ function drawPreparedRoundCorner(ctx, roundCorner) {
    if (roundCorner.radius === 0) ctx.lineTo(roundCorner.cx, roundCorner.cy);
    else ctx.arc(roundCorner.cx, roundCorner.cy, roundCorner.radius, roundCorner.startAngle, roundCorner.endAngle, roundCorner.counterClockwise);
}
/**
 * Get round corner from a point and its previous and next neighbours in a path
 *
 * @param previousPoint {{x: number, y:number, radius: number?}}
 * @param currentPoint {{x: number, y:number, radius: number?}}
 * @param nextPoint {{x: number, y:number, radius: number?}}
 * @param radiusMax :number
 * @param isArcRadius :boolean
 * @return {{
 * cx:number, cy:number, radius:number,
 * startX:number, startY:number,
 * stopX:number, stopY: number,
 * endAngle: number, startAngle: number, counterClockwise: boolean
 * }}
 */ function getRoundCorner(previousPoint, currentPoint, nextPoint, radiusMax) {
    var isArcRadius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    if (radiusMax === 0 || currentPoint.radius === 0) return {
        cx: currentPoint.x,
        cy: currentPoint.y,
        radius: 0,
        startX: currentPoint.x,
        startY: currentPoint.y,
        stopX: currentPoint.x,
        stopY: currentPoint.y,
        startAngle: undefined,
        endAngle: undefined,
        counterClockwise: undefined
    };
    calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius);
    return {
        cx: x,
        cy: y,
        radius: cRadius,
        startX: startX,
        startY: startY,
        stopX: stopX,
        stopY: stopY,
        startAngle: v1.ang + Math.PI / 2 * radDirection,
        endAngle: v2.ang - Math.PI / 2 * radDirection,
        counterClockwise: drawDirection
    };
}
var BRp$c = {};
BRp$c.findMidptPtsEtc = function(edge, pairInfo) {
    var posPts = pairInfo.posPts, intersectionPts = pairInfo.intersectionPts, vectorNormInverse = pairInfo.vectorNormInverse;
    var midptPts;
    // n.b. assumes all edges in bezier bundle have same endpoints specified
    var srcManEndpt = edge.pstyle('source-endpoint');
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var haveManualEndPts = srcManEndpt.units != null && tgtManEndpt.units != null;
    var recalcVectorNormInverse = function recalcVectorNormInverse(x1, y1, x2, y2) {
        var dy = y2 - y1;
        var dx = x2 - x1;
        var l = Math.sqrt(dx * dx + dy * dy);
        return {
            x: -dy / l,
            y: dx / l
        };
    };
    var edgeDistances = edge.pstyle('edge-distances').value;
    switch(edgeDistances){
        case 'node-position':
            midptPts = posPts;
            break;
        case 'intersection':
            midptPts = intersectionPts;
            break;
        case 'endpoints':
            if (haveManualEndPts) {
                var _this$manualEndptToPx = this.manualEndptToPx(edge.source()[0], srcManEndpt), _this$manualEndptToPx2 = _slicedToArray(_this$manualEndptToPx, 2), x1 = _this$manualEndptToPx2[0], y1 = _this$manualEndptToPx2[1];
                var _this$manualEndptToPx3 = this.manualEndptToPx(edge.target()[0], tgtManEndpt), _this$manualEndptToPx4 = _slicedToArray(_this$manualEndptToPx3, 2), x2 = _this$manualEndptToPx4[0], y2 = _this$manualEndptToPx4[1];
                var endPts = {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                };
                vectorNormInverse = recalcVectorNormInverse(x1, y1, x2, y2);
                midptPts = endPts;
            } else {
                warn("Edge ".concat(edge.id(), " has edge-distances:endpoints specified without manual endpoints specified via source-endpoint and target-endpoint.  Falling back on edge-distances:intersection (default)."));
                midptPts = intersectionPts; // back to default
            }
            break;
    }
    return {
        midptPts: midptPts,
        vectorNormInverse: vectorNormInverse
    };
};
BRp$c.findHaystackPoints = function(edges) {
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var rs = _p.rscratch;
        if (!rs.haystack) {
            var angle = Math.random() * 2 * Math.PI;
            rs.source = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
            angle = Math.random() * 2 * Math.PI;
            rs.target = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
        }
        var src = _p.source;
        var tgt = _p.target;
        var srcPos = src.position();
        var tgtPos = tgt.position();
        var srcW = src.width();
        var tgtW = tgt.width();
        var srcH = src.height();
        var tgtH = tgt.height();
        var radius = edge.pstyle('haystack-radius').value;
        var halfRadius = radius / 2; // b/c have to half width/height
        rs.haystackPts = rs.allpts = [
            rs.source.x * srcW * halfRadius + srcPos.x,
            rs.source.y * srcH * halfRadius + srcPos.y,
            rs.target.x * tgtW * halfRadius + tgtPos.x,
            rs.target.y * tgtH * halfRadius + tgtPos.y
        ];
        rs.midX = (rs.allpts[0] + rs.allpts[2]) / 2;
        rs.midY = (rs.allpts[1] + rs.allpts[3]) / 2;
        // always override as haystack in case set to different type previously
        rs.edgeType = 'haystack';
        rs.haystack = true;
        this.storeEdgeProjections(edge);
        this.calculateArrowAngles(edge);
        this.recalculateEdgeLabelProjections(edge);
        this.calculateLabelAngles(edge);
    }
};
BRp$c.findSegmentsPoints = function(edge, pairInfo) {
    // Segments (multiple straight lines)
    var rs = edge._private.rscratch;
    var segmentWs = edge.pstyle('segment-weights');
    var segmentDs = edge.pstyle('segment-distances');
    var segmentRs = edge.pstyle('segment-radii');
    var segmentTs = edge.pstyle('radius-type');
    var segmentsN = Math.min(segmentWs.pfValue.length, segmentDs.pfValue.length);
    var lastRadius = segmentRs.pfValue[segmentRs.pfValue.length - 1];
    var lastRadiusType = segmentTs.pfValue[segmentTs.pfValue.length - 1];
    rs.edgeType = 'segments';
    rs.segpts = [];
    rs.radii = [];
    rs.isArcRadius = [];
    for(var s = 0; s < segmentsN; s++){
        var w = segmentWs.pfValue[s];
        var d = segmentDs.pfValue[s];
        var w1 = 1 - w;
        var w2 = w;
        var _this$findMidptPtsEtc = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc.midptPts, vectorNormInverse = _this$findMidptPtsEtc.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.segpts.push(adjustedMidpt.x + vectorNormInverse.x * d, adjustedMidpt.y + vectorNormInverse.y * d);
        rs.radii.push(segmentRs.pfValue[s] !== undefined ? segmentRs.pfValue[s] : lastRadius);
        rs.isArcRadius.push((segmentTs.pfValue[s] !== undefined ? segmentTs.pfValue[s] : lastRadiusType) === 'arc-radius');
    }
};
BRp$c.findLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Self-edge
    var rs = edge._private.rscratch;
    var dirCounts = pairInfo.dirCounts, srcPos = pairInfo.srcPos;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var loopDir = edge.pstyle('loop-direction').pfValue;
    var loopSwp = edge.pstyle('loop-sweep').pfValue;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    rs.edgeType = 'self';
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopAngle = loopDir - Math.PI / 2;
    var outAngle = loopAngle - loopSwp / 2;
    var inAngle = loopAngle + loopSwp / 2;
    // increase by step size for overlapping loops, keyed on direction and sweep values
    var dc = String(loopDir + '_' + loopSwp);
    j = dirCounts[dc] === undefined ? dirCounts[dc] = 0 : ++dirCounts[dc];
    rs.ctrlpts = [
        srcPos.x + Math.cos(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.x + Math.cos(inAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(inAngle) * 1.4 * loopDist * (j / 3 + 1)
    ];
};
BRp$c.findCompoundLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Compound edge
    var rs = edge._private.rscratch;
    rs.edgeType = 'compound';
    var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopW = 50;
    var loopaPos = {
        x: srcPos.x - srcW / 2,
        y: srcPos.y - srcH / 2
    };
    var loopbPos = {
        x: tgtPos.x - tgtW / 2,
        y: tgtPos.y - tgtH / 2
    };
    var loopPos = {
        x: Math.min(loopaPos.x, loopbPos.x),
        y: Math.min(loopaPos.y, loopbPos.y)
    };
    // avoids cases with impossible beziers
    var minCompoundStretch = 0.5;
    var compoundStretchA = Math.max(minCompoundStretch, Math.log(srcW * 0.01));
    var compoundStretchB = Math.max(minCompoundStretch, Math.log(tgtW * 0.01));
    rs.ctrlpts = [
        loopPos.x,
        loopPos.y - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchA,
        loopPos.x - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchB,
        loopPos.y
    ];
};
BRp$c.findStraightEdgePoints = function(edge) {
    // Straight edge within bundle
    edge._private.rscratch.edgeType = 'straight';
};
BRp$c.findBezierPoints = function(edge, pairInfo, i, edgeIsUnbundled, edgeIsSwapped) {
    var rs = edge._private.rscratch;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptWs = edge.pstyle('control-point-weights');
    var bezierN = ctrlptDists && ctrlptWs ? Math.min(ctrlptDists.value.length, ctrlptWs.value.length) : 1;
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var ctrlptWeight = ctrlptWs.value[0];
    // (Multi)bezier
    var multi = edgeIsUnbundled;
    rs.edgeType = multi ? 'multibezier' : 'bezier';
    rs.ctrlpts = [];
    for(var b = 0; b < bezierN; b++){
        var normctrlptDist = (0.5 - pairInfo.eles.length / 2 + i) * stepSize * (edgeIsSwapped ? -1 : 1);
        var manctrlptDist = undefined;
        var sign = signum(normctrlptDist);
        if (multi) {
            ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[b] : stepSize; // fall back on step size
            ctrlptWeight = ctrlptWs.value[b];
        }
        if (edgeIsUnbundled) // multi or single unbundled
        manctrlptDist = ctrlptDist;
        else manctrlptDist = ctrlptDist !== undefined ? sign * ctrlptDist : undefined;
        var distanceFromMidpoint = manctrlptDist !== undefined ? manctrlptDist : normctrlptDist;
        var w1 = 1 - ctrlptWeight;
        var w2 = ctrlptWeight;
        var _this$findMidptPtsEtc2 = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc2.midptPts, vectorNormInverse = _this$findMidptPtsEtc2.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.ctrlpts.push(adjustedMidpt.x + vectorNormInverse.x * distanceFromMidpoint, adjustedMidpt.y + vectorNormInverse.y * distanceFromMidpoint);
    }
};
BRp$c.findTaxiPoints = function(edge, pairInfo) {
    // Taxicab geometry with two turns maximum
    var rs = edge._private.rscratch;
    rs.edgeType = 'segments';
    var VERTICAL = 'vertical';
    var HORIZONTAL = 'horizontal';
    var LEFTWARD = 'leftward';
    var RIGHTWARD = 'rightward';
    var DOWNWARD = 'downward';
    var UPWARD = 'upward';
    var AUTO = 'auto';
    var posPts = pairInfo.posPts, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var edgeDistances = edge.pstyle('edge-distances').value;
    var dIncludesNodeBody = edgeDistances !== 'node-position';
    var taxiDir = edge.pstyle('taxi-direction').value;
    var rawTaxiDir = taxiDir; // unprocessed value
    var taxiTurn = edge.pstyle('taxi-turn');
    var turnIsPercent = taxiTurn.units === '%';
    var taxiTurnPfVal = taxiTurn.pfValue;
    var turnIsNegative = taxiTurnPfVal < 0; // i.e. from target side
    var minD = edge.pstyle('taxi-turn-min-distance').pfValue;
    var dw = dIncludesNodeBody ? (srcW + tgtW) / 2 : 0;
    var dh = dIncludesNodeBody ? (srcH + tgtH) / 2 : 0;
    var pdx = posPts.x2 - posPts.x1;
    var pdy = posPts.y2 - posPts.y1;
    // take away the effective w/h from the magnitude of the delta value
    var subDWH = function subDWH(dxy, dwh) {
        if (dxy > 0) return Math.max(dxy - dwh, 0);
        else return Math.min(dxy + dwh, 0);
    };
    var dx = subDWH(pdx, dw);
    var dy = subDWH(pdy, dh);
    var isExplicitDir = false;
    if (rawTaxiDir === AUTO) taxiDir = Math.abs(dx) > Math.abs(dy) ? HORIZONTAL : VERTICAL;
    else if (rawTaxiDir === UPWARD || rawTaxiDir === DOWNWARD) {
        taxiDir = VERTICAL;
        isExplicitDir = true;
    } else if (rawTaxiDir === LEFTWARD || rawTaxiDir === RIGHTWARD) {
        taxiDir = HORIZONTAL;
        isExplicitDir = true;
    }
    var isVert = taxiDir === VERTICAL;
    var l = isVert ? dy : dx;
    var pl = isVert ? pdy : pdx;
    var sgnL = signum(pl);
    var forcedDir = false;
    if (!(isExplicitDir && (turnIsPercent || turnIsNegative) // forcing in this case would cause weird growing in the opposite direction
    ) && (rawTaxiDir === DOWNWARD && pl < 0 || rawTaxiDir === UPWARD && pl > 0 || rawTaxiDir === LEFTWARD && pl > 0 || rawTaxiDir === RIGHTWARD && pl < 0)) {
        sgnL *= -1;
        l = sgnL * Math.abs(l);
        forcedDir = true;
    }
    var d;
    if (turnIsPercent) {
        var p = taxiTurnPfVal < 0 ? 1 + taxiTurnPfVal : taxiTurnPfVal;
        d = p * l;
    } else {
        var k = taxiTurnPfVal < 0 ? l : 0;
        d = k + taxiTurnPfVal * sgnL;
    }
    var getIsTooClose = function getIsTooClose(d) {
        return Math.abs(d) < minD || Math.abs(d) >= Math.abs(l);
    };
    var isTooCloseSrc = getIsTooClose(d);
    var isTooCloseTgt = getIsTooClose(Math.abs(l) - Math.abs(d));
    var isTooClose = isTooCloseSrc || isTooCloseTgt;
    if (isTooClose && !forcedDir) {
        // non-ideal routing
        if (isVert) {
            // vertical fallbacks
            var lShapeInsideSrc = Math.abs(pl) <= srcH / 2;
            var lShapeInsideTgt = Math.abs(pdx) <= tgtW / 2;
            if (lShapeInsideSrc) {
                // horizontal Z-shape (direction not respected)
                var x = (posPts.x1 + posPts.x2) / 2;
                var y1 = posPts.y1, y2 = posPts.y2;
                rs.segpts = [
                    x,
                    y1,
                    x,
                    y2
                ];
            } else if (lShapeInsideTgt) {
                // vertical Z-shape (distance not respected)
                var y = (posPts.y1 + posPts.y2) / 2;
                var x1 = posPts.x1, x2 = posPts.x2;
                rs.segpts = [
                    x1,
                    y,
                    x2,
                    y
                ];
            } else // L-shape fallback (turn distance not respected, but works well with tree siblings)
            rs.segpts = [
                posPts.x1,
                posPts.y2
            ];
        } else {
            // horizontal fallbacks
            var _lShapeInsideSrc = Math.abs(pl) <= srcW / 2;
            var _lShapeInsideTgt = Math.abs(pdy) <= tgtH / 2;
            if (_lShapeInsideSrc) {
                // vertical Z-shape (direction not respected)
                var _y = (posPts.y1 + posPts.y2) / 2;
                var _x = posPts.x1, _x2 = posPts.x2;
                rs.segpts = [
                    _x,
                    _y,
                    _x2,
                    _y
                ];
            } else if (_lShapeInsideTgt) {
                // horizontal Z-shape (turn distance not respected)
                var _x3 = (posPts.x1 + posPts.x2) / 2;
                var _y2 = posPts.y1, _y3 = posPts.y2;
                rs.segpts = [
                    _x3,
                    _y2,
                    _x3,
                    _y3
                ];
            } else // L-shape (turn distance not respected, but works well for tree siblings)
            rs.segpts = [
                posPts.x2,
                posPts.y1
            ];
        }
    } else // ideal routing
    if (isVert) {
        var _y4 = posPts.y1 + d + (dIncludesNodeBody ? srcH / 2 * sgnL : 0);
        var _x4 = posPts.x1, _x5 = posPts.x2;
        rs.segpts = [
            _x4,
            _y4,
            _x5,
            _y4
        ];
    } else {
        // horizontal
        var _x6 = posPts.x1 + d + (dIncludesNodeBody ? srcW / 2 * sgnL : 0);
        var _y5 = posPts.y1, _y6 = posPts.y2;
        rs.segpts = [
            _x6,
            _y5,
            _x6,
            _y6
        ];
    }
    if (rs.isRound) {
        var radius = edge.pstyle('taxi-radius').value;
        var isArcRadius = edge.pstyle('radius-type').value[0] === 'arc-radius';
        rs.radii = new Array(rs.segpts.length / 2).fill(radius);
        rs.isArcRadius = new Array(rs.segpts.length / 2).fill(isArcRadius);
    }
};
BRp$c.tryToCorrectInvalidPoints = function(edge, pairInfo) {
    var rs = edge._private.rscratch;
    // can only correct beziers for now...
    if (rs.edgeType === 'bezier') {
        var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH, srcShape = pairInfo.srcShape, tgtShape = pairInfo.tgtShape, srcCornerRadius = pairInfo.srcCornerRadius, tgtCornerRadius = pairInfo.tgtCornerRadius, srcRs = pairInfo.srcRs, tgtRs = pairInfo.tgtRs;
        var badStart = !number$1(rs.startX) || !number$1(rs.startY);
        var badAStart = !number$1(rs.arrowStartX) || !number$1(rs.arrowStartY);
        var badEnd = !number$1(rs.endX) || !number$1(rs.endY);
        var badAEnd = !number$1(rs.arrowEndX) || !number$1(rs.arrowEndY);
        var minCpADistFactor = 3;
        var arrowW = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
        var minCpADist = minCpADistFactor * arrowW;
        var startACpDist = dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.startX,
            y: rs.startY
        });
        var closeStartACp = startACpDist < minCpADist;
        var endACpDist = dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.endX,
            y: rs.endY
        });
        var closeEndACp = endACpDist < minCpADist;
        var overlapping = false;
        if (badStart || badAStart || closeStartACp) {
            overlapping = true;
            // project control point along line from src centre to outside the src shape
            // (otherwise intersection will yield nothing)
            var cpD = {
                // delta
                x: rs.ctrlpts[0] - srcPos.x,
                y: rs.ctrlpts[1] - srcPos.y
            };
            var cpL = Math.sqrt(cpD.x * cpD.x + cpD.y * cpD.y); // length of line
            var cpM = {
                // normalised delta
                x: cpD.x / cpL,
                y: cpD.y / cpL
            };
            var radius = Math.max(srcW, srcH);
            var cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + cpM.x * 2 * radius,
                y: rs.ctrlpts[1] + cpM.y * 2 * radius
            };
            var srcCtrlPtIntn = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, cpProj.x, cpProj.y, 0, srcCornerRadius, srcRs);
            if (closeStartACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + cpM.x * (minCpADist - startACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + cpM.y * (minCpADist - startACpDist);
            } else {
                rs.ctrlpts[0] = srcCtrlPtIntn[0] + cpM.x * minCpADist;
                rs.ctrlpts[1] = srcCtrlPtIntn[1] + cpM.y * minCpADist;
            }
        }
        if (badEnd || badAEnd || closeEndACp) {
            overlapping = true;
            // project control point along line from tgt centre to outside the tgt shape
            // (otherwise intersection will yield nothing)
            var _cpD = {
                // delta
                x: rs.ctrlpts[0] - tgtPos.x,
                y: rs.ctrlpts[1] - tgtPos.y
            };
            var _cpL = Math.sqrt(_cpD.x * _cpD.x + _cpD.y * _cpD.y); // length of line
            var _cpM = {
                // normalised delta
                x: _cpD.x / _cpL,
                y: _cpD.y / _cpL
            };
            var _radius = Math.max(srcW, srcH);
            var _cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + _cpM.x * 2 * _radius,
                y: rs.ctrlpts[1] + _cpM.y * 2 * _radius
            };
            var tgtCtrlPtIntn = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, _cpProj.x, _cpProj.y, 0, tgtCornerRadius, tgtRs);
            if (closeEndACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + _cpM.x * (minCpADist - endACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + _cpM.y * (minCpADist - endACpDist);
            } else {
                rs.ctrlpts[0] = tgtCtrlPtIntn[0] + _cpM.x * minCpADist;
                rs.ctrlpts[1] = tgtCtrlPtIntn[1] + _cpM.y * minCpADist;
            }
        }
        if (overlapping) // recalc endpts
        this.findEndpoints(edge);
    }
};
BRp$c.storeAllpts = function(edge) {
    var rs = edge._private.rscratch;
    if (rs.edgeType === 'multibezier' || rs.edgeType === 'bezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        for(var b = 0; b + 1 < rs.ctrlpts.length; b += 2){
            // ctrl pt itself
            rs.allpts.push(rs.ctrlpts[b], rs.ctrlpts[b + 1]);
            // the midpt between ctrlpts as intermediate destination pts
            if (b + 3 < rs.ctrlpts.length) rs.allpts.push((rs.ctrlpts[b] + rs.ctrlpts[b + 2]) / 2, (rs.ctrlpts[b + 1] + rs.ctrlpts[b + 3]) / 2);
        }
        rs.allpts.push(rs.endX, rs.endY);
        var m1, mt;
        if (rs.ctrlpts.length / 2 % 2 === 0) {
            m1 = rs.allpts.length / 2 - 1;
            rs.midX = rs.allpts[m1];
            rs.midY = rs.allpts[m1 + 1];
        } else {
            m1 = rs.allpts.length / 2 - 3;
            mt = 0.5;
            rs.midX = qbezierAt(rs.allpts[m1], rs.allpts[m1 + 2], rs.allpts[m1 + 4], mt);
            rs.midY = qbezierAt(rs.allpts[m1 + 1], rs.allpts[m1 + 3], rs.allpts[m1 + 5], mt);
        }
    } else if (rs.edgeType === 'straight') {
        // need to calc these after endpts
        rs.allpts = [
            rs.startX,
            rs.startY,
            rs.endX,
            rs.endY
        ];
        // default midpt for labels etc
        rs.midX = (rs.startX + rs.endX + rs.arrowStartX + rs.arrowEndX) / 4;
        rs.midY = (rs.startY + rs.endY + rs.arrowStartY + rs.arrowEndY) / 4;
    } else if (rs.edgeType === 'segments') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        rs.allpts.push.apply(rs.allpts, rs.segpts);
        rs.allpts.push(rs.endX, rs.endY);
        if (rs.isRound) {
            rs.roundCorners = [];
            for(var i = 2; i + 3 < rs.allpts.length; i += 2){
                var radius = rs.radii[i / 2 - 1];
                var isArcRadius = rs.isArcRadius[i / 2 - 1];
                rs.roundCorners.push(getRoundCorner({
                    x: rs.allpts[i - 2],
                    y: rs.allpts[i - 1]
                }, {
                    x: rs.allpts[i],
                    y: rs.allpts[i + 1],
                    radius: radius
                }, {
                    x: rs.allpts[i + 2],
                    y: rs.allpts[i + 3]
                }, radius, isArcRadius));
            }
        }
        if (rs.segpts.length % 4 === 0) {
            var i2 = rs.segpts.length / 2;
            var i1 = i2 - 2;
            rs.midX = (rs.segpts[i1] + rs.segpts[i2]) / 2;
            rs.midY = (rs.segpts[i1 + 1] + rs.segpts[i2 + 1]) / 2;
        } else {
            var _i = rs.segpts.length / 2 - 1;
            if (!rs.isRound) {
                rs.midX = rs.segpts[_i];
                rs.midY = rs.segpts[_i + 1];
            } else {
                var point = {
                    x: rs.segpts[_i],
                    y: rs.segpts[_i + 1]
                };
                var corner = rs.roundCorners[_i / 2];
                if (corner.radius === 0) {
                    // On collinear points
                    var nextPoint = {
                        x: rs.segpts[_i + 2],
                        y: rs.segpts[_i + 3]
                    };
                    rs.midX = point.x;
                    rs.midY = point.y;
                    rs.midVector = [
                        point.y - nextPoint.y,
                        nextPoint.x - point.x
                    ];
                } else {
                    // On rounded points
                    var v = [
                        point.x - corner.cx,
                        point.y - corner.cy
                    ];
                    var factor = corner.radius / Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
                    v = v.map(function(c) {
                        return c * factor;
                    });
                    rs.midX = corner.cx + v[0];
                    rs.midY = corner.cy + v[1];
                    rs.midVector = v;
                }
            }
        }
    }
};
BRp$c.checkForInvalidEdgeWarning = function(edge) {
    var rs = edge[0]._private.rscratch;
    if (rs.nodesOverlap || number$1(rs.startX) && number$1(rs.startY) && number$1(rs.endX) && number$1(rs.endY)) rs.loggedErr = false;
    else if (!rs.loggedErr) {
        rs.loggedErr = true;
        warn('Edge `' + edge.id() + '` has invalid endpoints and so it is impossible to draw.  Adjust your edge style (e.g. control points) accordingly or use an alternative edge type.  This is expected behaviour when the source node and the target node overlap.');
    }
};
BRp$c.findEdgeControlPoints = function(edges) {
    var _this = this;
    if (!edges || edges.length === 0) return;
    var r = this;
    var cy = r.cy;
    var hasCompounds = cy.hasCompoundNodes();
    var hashTable = new Map$1();
    var getKey = function getKey(pairId, edgeIsUnbundled) {
        return [].concat(_toConsumableArray(pairId), [
            edgeIsUnbundled ? 1 : 0
        ]).join('-');
    };
    var pairIds = [];
    var haystackEdges = [];
    // create a table of edge (src, tgt) => list of edges between them
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var curveStyle = edge.pstyle('curve-style').value;
        // ignore edges who are not to be displayed
        // they shouldn't take up space
        if (edge.removed() || !edge.takesUpSpace()) continue;
        if (curveStyle === 'haystack') {
            haystackEdges.push(edge);
            continue;
        }
        var edgeIsUnbundled = curveStyle === 'unbundled-bezier' || curveStyle.endsWith('segments') || curveStyle === 'straight' || curveStyle === 'straight-triangle' || curveStyle.endsWith('taxi');
        var edgeIsBezier = curveStyle === 'unbundled-bezier' || curveStyle === 'bezier';
        var src = _p.source;
        var tgt = _p.target;
        var srcIndex = src.poolIndex();
        var tgtIndex = tgt.poolIndex();
        var pairId = [
            srcIndex,
            tgtIndex
        ].sort();
        var key = getKey(pairId, edgeIsUnbundled);
        var tableEntry = hashTable.get(key);
        if (tableEntry == null) {
            tableEntry = {
                eles: []
            };
            pairIds.push({
                pairId: pairId,
                edgeIsUnbundled: edgeIsUnbundled
            });
            hashTable.set(key, tableEntry);
        }
        tableEntry.eles.push(edge);
        if (edgeIsUnbundled) tableEntry.hasUnbundled = true;
        if (edgeIsBezier) tableEntry.hasBezier = true;
    }
    // for each pair (src, tgt), create the ctrl pts
    // Nested for loop is OK; total number of iterations for both loops = edgeCount
    var _loop = function _loop() {
        var _pairIds$p = pairIds[p], pairId = _pairIds$p.pairId, edgeIsUnbundled = _pairIds$p.edgeIsUnbundled;
        var key = getKey(pairId, edgeIsUnbundled);
        var pairInfo = hashTable.get(key);
        var swappedpairInfo;
        if (!pairInfo.hasUnbundled) {
            var pllEdges = pairInfo.eles[0].parallelEdges().filter(function(e) {
                return e.isBundledBezier();
            });
            clearArray(pairInfo.eles);
            pllEdges.forEach(function(edge) {
                return pairInfo.eles.push(edge);
            });
            // for each pair id, the edges should be sorted by index
            pairInfo.eles.sort(function(edge1, edge2) {
                return edge1.poolIndex() - edge2.poolIndex();
            });
        }
        var firstEdge = pairInfo.eles[0];
        var src = firstEdge.source();
        var tgt = firstEdge.target();
        // make sure src/tgt distinction is consistent w.r.t. pairId
        if (src.poolIndex() > tgt.poolIndex()) {
            var temp = src;
            src = tgt;
            tgt = temp;
        }
        var srcPos = pairInfo.srcPos = src.position();
        var tgtPos = pairInfo.tgtPos = tgt.position();
        var srcW = pairInfo.srcW = src.outerWidth();
        var srcH = pairInfo.srcH = src.outerHeight();
        var tgtW = pairInfo.tgtW = tgt.outerWidth();
        var tgtH = pairInfo.tgtH = tgt.outerHeight();
        var srcShape = pairInfo.srcShape = r.nodeShapes[_this.getNodeShape(src)];
        var tgtShape = pairInfo.tgtShape = r.nodeShapes[_this.getNodeShape(tgt)];
        var srcCornerRadius = pairInfo.srcCornerRadius = src.pstyle('corner-radius').value === 'auto' ? 'auto' : src.pstyle('corner-radius').pfValue;
        var tgtCornerRadius = pairInfo.tgtCornerRadius = tgt.pstyle('corner-radius').value === 'auto' ? 'auto' : tgt.pstyle('corner-radius').pfValue;
        var tgtRs = pairInfo.tgtRs = tgt._private.rscratch;
        var srcRs = pairInfo.srcRs = src._private.rscratch;
        pairInfo.dirCounts = {
            'north': 0,
            'west': 0,
            'south': 0,
            'east': 0,
            'northwest': 0,
            'southwest': 0,
            'northeast': 0,
            'southeast': 0
        };
        for(var _i2 = 0; _i2 < pairInfo.eles.length; _i2++){
            var _edge = pairInfo.eles[_i2];
            var rs = _edge[0]._private.rscratch;
            var _curveStyle = _edge.pstyle('curve-style').value;
            var _edgeIsUnbundled = _curveStyle === 'unbundled-bezier' || _curveStyle.endsWith('segments') || _curveStyle.endsWith('taxi');
            // whether the normalised pair order is the reverse of the edge's src-tgt order
            var edgeIsSwapped = !src.same(_edge.source());
            if (!pairInfo.calculatedIntersection && src !== tgt && (pairInfo.hasBezier || pairInfo.hasUnbundled)) {
                pairInfo.calculatedIntersection = true;
                // pt outside src shape to calc distance/displacement from src to tgt
                var srcOutside = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, tgtPos.x, tgtPos.y, 0, srcCornerRadius, srcRs);
                var srcIntn = pairInfo.srcIntn = srcOutside;
                // pt outside tgt shape to calc distance/displacement from src to tgt
                var tgtOutside = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, srcPos.x, srcPos.y, 0, tgtCornerRadius, tgtRs);
                var tgtIntn = pairInfo.tgtIntn = tgtOutside;
                var intersectionPts = pairInfo.intersectionPts = {
                    x1: srcOutside[0],
                    x2: tgtOutside[0],
                    y1: srcOutside[1],
                    y2: tgtOutside[1]
                };
                var posPts = pairInfo.posPts = {
                    x1: srcPos.x,
                    x2: tgtPos.x,
                    y1: srcPos.y,
                    y2: tgtPos.y
                };
                var dy = tgtOutside[1] - srcOutside[1];
                var dx = tgtOutside[0] - srcOutside[0];
                var l = Math.sqrt(dx * dx + dy * dy);
                var vector = pairInfo.vector = {
                    x: dx,
                    y: dy
                };
                var vectorNorm = pairInfo.vectorNorm = {
                    x: vector.x / l,
                    y: vector.y / l
                };
                var vectorNormInverse = {
                    x: -vectorNorm.y,
                    y: vectorNorm.x
                };
                // if node shapes overlap, then no ctrl pts to draw
                pairInfo.nodesOverlap = !number$1(l) || tgtShape.checkPoint(srcOutside[0], srcOutside[1], 0, tgtW, tgtH, tgtPos.x, tgtPos.y, tgtCornerRadius, tgtRs) || srcShape.checkPoint(tgtOutside[0], tgtOutside[1], 0, srcW, srcH, srcPos.x, srcPos.y, srcCornerRadius, srcRs);
                pairInfo.vectorNormInverse = vectorNormInverse;
                swappedpairInfo = {
                    nodesOverlap: pairInfo.nodesOverlap,
                    dirCounts: pairInfo.dirCounts,
                    calculatedIntersection: true,
                    hasBezier: pairInfo.hasBezier,
                    hasUnbundled: pairInfo.hasUnbundled,
                    eles: pairInfo.eles,
                    srcPos: tgtPos,
                    srcRs: tgtRs,
                    tgtPos: srcPos,
                    tgtRs: srcRs,
                    srcW: tgtW,
                    srcH: tgtH,
                    tgtW: srcW,
                    tgtH: srcH,
                    srcIntn: tgtIntn,
                    tgtIntn: srcIntn,
                    srcShape: tgtShape,
                    tgtShape: srcShape,
                    posPts: {
                        x1: posPts.x2,
                        y1: posPts.y2,
                        x2: posPts.x1,
                        y2: posPts.y1
                    },
                    intersectionPts: {
                        x1: intersectionPts.x2,
                        y1: intersectionPts.y2,
                        x2: intersectionPts.x1,
                        y2: intersectionPts.y1
                    },
                    vector: {
                        x: -vector.x,
                        y: -vector.y
                    },
                    vectorNorm: {
                        x: -vectorNorm.x,
                        y: -vectorNorm.y
                    },
                    vectorNormInverse: {
                        x: -vectorNormInverse.x,
                        y: -vectorNormInverse.y
                    }
                };
            }
            var passedPairInfo = edgeIsSwapped ? swappedpairInfo : pairInfo;
            rs.nodesOverlap = passedPairInfo.nodesOverlap;
            rs.srcIntn = passedPairInfo.srcIntn;
            rs.tgtIntn = passedPairInfo.tgtIntn;
            rs.isRound = _curveStyle.startsWith('round');
            if (hasCompounds && (src.isParent() || src.isChild() || tgt.isParent() || tgt.isChild()) && (src.parents().anySame(tgt) || tgt.parents().anySame(src) || src.same(tgt) && src.isParent())) _this.findCompoundLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (src === tgt) _this.findLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (_curveStyle.endsWith('segments')) _this.findSegmentsPoints(_edge, passedPairInfo);
            else if (_curveStyle.endsWith('taxi')) _this.findTaxiPoints(_edge, passedPairInfo);
            else if (_curveStyle === 'straight' || !_edgeIsUnbundled && pairInfo.eles.length % 2 === 1 && _i2 === Math.floor(pairInfo.eles.length / 2)) _this.findStraightEdgePoints(_edge);
            else _this.findBezierPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled, edgeIsSwapped);
            _this.findEndpoints(_edge);
            _this.tryToCorrectInvalidPoints(_edge, passedPairInfo);
            _this.checkForInvalidEdgeWarning(_edge);
            _this.storeAllpts(_edge);
            _this.storeEdgeProjections(_edge);
            _this.calculateArrowAngles(_edge);
            _this.recalculateEdgeLabelProjections(_edge);
            _this.calculateLabelAngles(_edge);
        } // for pair edges
    };
    for(var p = 0; p < pairIds.length; p++)_loop();
     // for pair ids
    // haystacks avoid the expense of pairInfo stuff (intersections etc.)
    this.findHaystackPoints(haystackEdges);
};
function getPts(pts) {
    var retPts = [];
    if (pts == null) return;
    for(var i = 0; i < pts.length; i += 2){
        var x = pts[i];
        var y = pts[i + 1];
        retPts.push({
            x: x,
            y: y
        });
    }
    return retPts;
}
BRp$c.getSegmentPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'segments') return getPts(rs.segpts);
};
BRp$c.getControlPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'bezier' || type === 'multibezier' || type === 'self' || type === 'compound') return getPts(rs.ctrlpts);
};
BRp$c.getEdgeMidpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    return {
        x: rs.midX,
        y: rs.midY
    };
};
var BRp$b = {};
BRp$b.manualEndptToPx = function(node, prop) {
    var r = this;
    var npos = node.position();
    var w = node.outerWidth();
    var h = node.outerHeight();
    var rs = node._private.rscratch;
    if (prop.value.length === 2) {
        var p = [
            prop.pfValue[0],
            prop.pfValue[1]
        ];
        if (prop.units[0] === '%') p[0] = p[0] * w;
        if (prop.units[1] === '%') p[1] = p[1] * h;
        p[0] += npos.x;
        p[1] += npos.y;
        return p;
    } else {
        var angle = prop.pfValue[0];
        angle = -Math.PI / 2 + angle; // start at 12 o'clock
        var l = 2 * Math.max(w, h);
        var _p = [
            npos.x + Math.cos(angle) * l,
            npos.y + Math.sin(angle) * l
        ];
        return r.nodeShapes[this.getNodeShape(node)].intersectLine(npos.x, npos.y, w, h, _p[0], _p[1], 0, node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue, rs);
    }
};
BRp$b.findEndpoints = function(edge) {
    var r = this;
    var intersect;
    var source = edge.source()[0];
    var target = edge.target()[0];
    var srcPos = source.position();
    var tgtPos = target.position();
    var tgtArShape = edge.pstyle('target-arrow-shape').value;
    var srcArShape = edge.pstyle('source-arrow-shape').value;
    var tgtDist = edge.pstyle('target-distance-from-node').pfValue;
    var srcDist = edge.pstyle('source-distance-from-node').pfValue;
    var srcRs = source._private.rscratch;
    var tgtRs = target._private.rscratch;
    var curveStyle = edge.pstyle('curve-style').value;
    var rs = edge._private.rscratch;
    var et = rs.edgeType;
    var taxi = curveStyle === 'taxi';
    var self1 = et === 'self' || et === 'compound';
    var bezier = et === 'bezier' || et === 'multibezier' || self1;
    var multi = et !== 'bezier';
    var lines = et === 'straight' || et === 'segments';
    var segments = et === 'segments';
    var hasEndpts = bezier || multi || lines;
    var overrideEndpts = self1 || taxi;
    var srcManEndpt = edge.pstyle('source-endpoint');
    var srcManEndptVal = overrideEndpts ? 'outside-to-node' : srcManEndpt.value;
    var srcCornerRadius = source.pstyle('corner-radius').value === 'auto' ? 'auto' : source.pstyle('corner-radius').pfValue;
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var tgtManEndptVal = overrideEndpts ? 'outside-to-node' : tgtManEndpt.value;
    var tgtCornerRadius = target.pstyle('corner-radius').value === 'auto' ? 'auto' : target.pstyle('corner-radius').pfValue;
    rs.srcManEndpt = srcManEndpt;
    rs.tgtManEndpt = tgtManEndpt;
    var p1; // last known point of edge on target side
    var p2; // last known point of edge on source side
    var p1_i; // point to intersect with target shape
    var p2_i; // point to intersect with source shape
    if (bezier) {
        var cpStart = [
            rs.ctrlpts[0],
            rs.ctrlpts[1]
        ];
        var cpEnd = multi ? [
            rs.ctrlpts[rs.ctrlpts.length - 2],
            rs.ctrlpts[rs.ctrlpts.length - 1]
        ] : cpStart;
        p1 = cpEnd;
        p2 = cpStart;
    } else if (lines) {
        var srcArrowFromPt = !segments ? [
            tgtPos.x,
            tgtPos.y
        ] : rs.segpts.slice(0, 2);
        var tgtArrowFromPt = !segments ? [
            srcPos.x,
            srcPos.y
        ] : rs.segpts.slice(rs.segpts.length - 2);
        p1 = tgtArrowFromPt;
        p2 = srcArrowFromPt;
    }
    if (tgtManEndptVal === 'inside-to-node') intersect = [
        tgtPos.x,
        tgtPos.y
    ];
    else if (tgtManEndpt.units) intersect = this.manualEndptToPx(target, tgtManEndpt);
    else if (tgtManEndptVal === 'outside-to-line') intersect = rs.tgtIntn; // use cached value from ctrlpt calc
    else {
        if (tgtManEndptVal === 'outside-to-node' || tgtManEndptVal === 'outside-to-node-or-label') p1_i = p1;
        else if (tgtManEndptVal === 'outside-to-line' || tgtManEndptVal === 'outside-to-line-or-label') p1_i = [
            srcPos.x,
            srcPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(target)].intersectLine(tgtPos.x, tgtPos.y, target.outerWidth(), target.outerHeight(), p1_i[0], p1_i[1], 0, tgtCornerRadius, tgtRs);
        if (tgtManEndptVal === 'outside-to-node-or-label' || tgtManEndptVal === 'outside-to-line-or-label') {
            var trs = target._private.rscratch;
            var lw = trs.labelWidth;
            var lh = trs.labelHeight;
            var lx = trs.labelX;
            var ly = trs.labelY;
            var lw2 = lw / 2;
            var lh2 = lh / 2;
            var va = target.pstyle('text-valign').value;
            if (va === 'top') ly -= lh2;
            else if (va === 'bottom') ly += lh2;
            var ha = target.pstyle('text-halign').value;
            if (ha === 'left') lx -= lw2;
            else if (ha === 'right') lx += lw2;
            var labelIntersect = polygonIntersectLine(p1_i[0], p1_i[1], [
                lx - lw2,
                ly - lh2,
                lx + lw2,
                ly - lh2,
                lx + lw2,
                ly + lh2,
                lx - lw2,
                ly + lh2
            ], tgtPos.x, tgtPos.y);
            if (labelIntersect.length > 0) {
                var refPt = srcPos;
                var intSqdist = sqdist(refPt, array2point(intersect));
                var labIntSqdist = sqdist(refPt, array2point(labelIntersect));
                var minSqDist = intSqdist;
                if (labIntSqdist < intSqdist) {
                    intersect = labelIntersect;
                    minSqDist = labIntSqdist;
                }
                if (labelIntersect.length > 2) {
                    var labInt2SqDist = sqdist(refPt, {
                        x: labelIntersect[2],
                        y: labelIntersect[3]
                    });
                    if (labInt2SqDist < minSqDist) intersect = [
                        labelIntersect[2],
                        labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowEnd = shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].spacing(edge) + tgtDist);
    var edgeEnd = shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].gap(edge) + tgtDist);
    rs.endX = edgeEnd[0];
    rs.endY = edgeEnd[1];
    rs.arrowEndX = arrowEnd[0];
    rs.arrowEndY = arrowEnd[1];
    if (srcManEndptVal === 'inside-to-node') intersect = [
        srcPos.x,
        srcPos.y
    ];
    else if (srcManEndpt.units) intersect = this.manualEndptToPx(source, srcManEndpt);
    else if (srcManEndptVal === 'outside-to-line') intersect = rs.srcIntn; // use cached value from ctrlpt calc
    else {
        if (srcManEndptVal === 'outside-to-node' || srcManEndptVal === 'outside-to-node-or-label') p2_i = p2;
        else if (srcManEndptVal === 'outside-to-line' || srcManEndptVal === 'outside-to-line-or-label') p2_i = [
            tgtPos.x,
            tgtPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(source)].intersectLine(srcPos.x, srcPos.y, source.outerWidth(), source.outerHeight(), p2_i[0], p2_i[1], 0, srcCornerRadius, srcRs);
        if (srcManEndptVal === 'outside-to-node-or-label' || srcManEndptVal === 'outside-to-line-or-label') {
            var srs = source._private.rscratch;
            var _lw = srs.labelWidth;
            var _lh = srs.labelHeight;
            var _lx = srs.labelX;
            var _ly = srs.labelY;
            var _lw2 = _lw / 2;
            var _lh2 = _lh / 2;
            var _va = source.pstyle('text-valign').value;
            if (_va === 'top') _ly -= _lh2;
            else if (_va === 'bottom') _ly += _lh2;
            var _ha = source.pstyle('text-halign').value;
            if (_ha === 'left') _lx -= _lw2;
            else if (_ha === 'right') _lx += _lw2;
            var _labelIntersect = polygonIntersectLine(p2_i[0], p2_i[1], [
                _lx - _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly + _lh2,
                _lx - _lw2,
                _ly + _lh2
            ], srcPos.x, srcPos.y);
            if (_labelIntersect.length > 0) {
                var _refPt = tgtPos;
                var _intSqdist = sqdist(_refPt, array2point(intersect));
                var _labIntSqdist = sqdist(_refPt, array2point(_labelIntersect));
                var _minSqDist = _intSqdist;
                if (_labIntSqdist < _intSqdist) {
                    intersect = [
                        _labelIntersect[0],
                        _labelIntersect[1]
                    ];
                    _minSqDist = _labIntSqdist;
                }
                if (_labelIntersect.length > 2) {
                    var _labInt2SqDist = sqdist(_refPt, {
                        x: _labelIntersect[2],
                        y: _labelIntersect[3]
                    });
                    if (_labInt2SqDist < _minSqDist) intersect = [
                        _labelIntersect[2],
                        _labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowStart = shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].spacing(edge) + srcDist);
    var edgeStart = shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].gap(edge) + srcDist);
    rs.startX = edgeStart[0];
    rs.startY = edgeStart[1];
    rs.arrowStartX = arrowStart[0];
    rs.arrowStartY = arrowStart[1];
    if (hasEndpts) {
        if (!number$1(rs.startX) || !number$1(rs.startY) || !number$1(rs.endX) || !number$1(rs.endY)) rs.badLine = true;
        else rs.badLine = false;
    }
};
BRp$b.getSourceEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[0],
                y: rs.haystackPts[1]
            };
        default:
            return {
                x: rs.arrowStartX,
                y: rs.arrowStartY
            };
    }
};
BRp$b.getTargetEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[2],
                y: rs.haystackPts[3]
            };
        default:
            return {
                x: rs.arrowEndX,
                y: rs.arrowEndY
            };
    }
};
var BRp$a = {};
function pushBezierPts(r, edge, pts) {
    var qbezierAt$1 = function qbezierAt$1(p1, p2, p3, t) {
        return qbezierAt(p1, p2, p3, t);
    };
    var _p = edge._private;
    var bpts = _p.rstyle.bezierPts;
    for(var i = 0; i < r.bezierProjPcts.length; i++){
        var p = r.bezierProjPcts[i];
        bpts.push({
            x: qbezierAt$1(pts[0], pts[2], pts[4], p),
            y: qbezierAt$1(pts[1], pts[3], pts[5], p)
        });
    }
}
BRp$a.storeEdgeProjections = function(edge) {
    var _p = edge._private;
    var rs = _p.rscratch;
    var et = rs.edgeType;
    // clear the cached points state
    _p.rstyle.bezierPts = null;
    _p.rstyle.linePts = null;
    _p.rstyle.haystackPts = null;
    if (et === 'multibezier' || et === 'bezier' || et === 'self' || et === 'compound') {
        _p.rstyle.bezierPts = [];
        for(var i = 0; i + 5 < rs.allpts.length; i += 4)pushBezierPts(this, edge, rs.allpts.slice(i, i + 6));
    } else if (et === 'segments') {
        var lpts = _p.rstyle.linePts = [];
        for(var i = 0; i + 1 < rs.allpts.length; i += 2)lpts.push({
            x: rs.allpts[i],
            y: rs.allpts[i + 1]
        });
    } else if (et === 'haystack') {
        var hpts = rs.haystackPts;
        _p.rstyle.haystackPts = [
            {
                x: hpts[0],
                y: hpts[1]
            },
            {
                x: hpts[2],
                y: hpts[3]
            }
        ];
    }
    _p.rstyle.arrowWidth = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
};
BRp$a.recalculateEdgeProjections = function(edges) {
    this.findEdgeControlPoints(edges);
};
var BRp$9 = {};
BRp$9.recalculateNodeLabelProjection = function(node) {
    var content = node.pstyle('label').strValue;
    if (emptyString(content)) return;
    var textX, textY;
    var _p = node._private;
    var nodeWidth = node.width();
    var nodeHeight = node.height();
    var padding = node.padding();
    var nodePos = node.position();
    var textHalign = node.pstyle('text-halign').strValue;
    var textValign = node.pstyle('text-valign').strValue;
    var rs = _p.rscratch;
    var rstyle = _p.rstyle;
    switch(textHalign){
        case 'left':
            textX = nodePos.x - nodeWidth / 2 - padding;
            break;
        case 'right':
            textX = nodePos.x + nodeWidth / 2 + padding;
            break;
        default:
            // e.g. center
            textX = nodePos.x;
    }
    switch(textValign){
        case 'top':
            textY = nodePos.y - nodeHeight / 2 - padding;
            break;
        case 'bottom':
            textY = nodePos.y + nodeHeight / 2 + padding;
            break;
        default:
            // e.g. middle
            textY = nodePos.y;
    }
    rs.labelX = textX;
    rs.labelY = textY;
    rstyle.labelX = textX;
    rstyle.labelY = textY;
    this.calculateLabelAngles(node);
    this.applyLabelDimensions(node);
};
var lineAngleFromDelta = function lineAngleFromDelta(dx, dy) {
    var angle = Math.atan(dy / dx);
    if (dx === 0 && angle < 0) angle = angle * -1;
    return angle;
};
var lineAngle = function lineAngle(p0, p1) {
    var dx = p1.x - p0.x;
    var dy = p1.y - p0.y;
    return lineAngleFromDelta(dx, dy);
};
var bezierAngle = function bezierAngle(p0, p1, p2, t) {
    var t0 = bound(0, t - 0.001, 1);
    var t1 = bound(0, t + 0.001, 1);
    var lp0 = qbezierPtAt(p0, p1, p2, t0);
    var lp1 = qbezierPtAt(p0, p1, p2, t1);
    return lineAngle(lp0, lp1);
};
BRp$9.recalculateEdgeLabelProjections = function(edge) {
    var p;
    var _p = edge._private;
    var rs = _p.rscratch;
    var r = this;
    var content = {
        mid: edge.pstyle('label').strValue,
        source: edge.pstyle('source-label').strValue,
        target: edge.pstyle('target-label').strValue
    };
    if (content.mid || content.source || content.target) ;
    else return; // no labels => no calcs
    // add center point to style so bounding box calculations can use it
    //
    p = {
        x: rs.midX,
        y: rs.midY
    };
    var setRs = function setRs(propName, prefix, value) {
        setPrefixedProperty(_p.rscratch, propName, prefix, value);
        setPrefixedProperty(_p.rstyle, propName, prefix, value);
    };
    setRs('labelX', null, p.x);
    setRs('labelY', null, p.y);
    var midAngle = lineAngleFromDelta(rs.midDispX, rs.midDispY);
    setRs('labelAutoAngle', null, midAngle);
    var _createControlPointInfo = function createControlPointInfo() {
        if (_createControlPointInfo.cache) return _createControlPointInfo.cache;
         // use cache so only 1x per edge
        var ctrlpts = [];
        // store each ctrlpt info init
        for(var i = 0; i + 5 < rs.allpts.length; i += 4){
            var p0 = {
                x: rs.allpts[i],
                y: rs.allpts[i + 1]
            };
            var p1 = {
                x: rs.allpts[i + 2],
                y: rs.allpts[i + 3]
            }; // ctrlpt
            var p2 = {
                x: rs.allpts[i + 4],
                y: rs.allpts[i + 5]
            };
            ctrlpts.push({
                p0: p0,
                p1: p1,
                p2: p2,
                startDist: 0,
                length: 0,
                segments: []
            });
        }
        var bpts = _p.rstyle.bezierPts;
        var nProjs = r.bezierProjPcts.length;
        function addSegment(cp, p0, p1, t0, t1) {
            var length = dist(p0, p1);
            var prevSegment = cp.segments[cp.segments.length - 1];
            var segment = {
                p0: p0,
                p1: p1,
                t0: t0,
                t1: t1,
                startDist: prevSegment ? prevSegment.startDist + prevSegment.length : 0,
                length: length
            };
            cp.segments.push(segment);
            cp.length += length;
        }
        // update each ctrlpt with segment info
        for(var _i = 0; _i < ctrlpts.length; _i++){
            var cp = ctrlpts[_i];
            var prevCp = ctrlpts[_i - 1];
            if (prevCp) cp.startDist = prevCp.startDist + prevCp.length;
            addSegment(cp, cp.p0, bpts[_i * nProjs], 0, r.bezierProjPcts[0]); // first
            for(var j = 0; j < nProjs - 1; j++)addSegment(cp, bpts[_i * nProjs + j], bpts[_i * nProjs + j + 1], r.bezierProjPcts[j], r.bezierProjPcts[j + 1]);
            addSegment(cp, bpts[_i * nProjs + nProjs - 1], cp.p2, r.bezierProjPcts[nProjs - 1], 1); // last
        }
        return _createControlPointInfo.cache = ctrlpts;
    };
    var calculateEndProjection = function calculateEndProjection(prefix) {
        var angle;
        var isSrc = prefix === 'source';
        if (!content[prefix]) return;
        var offset = edge.pstyle(prefix + '-text-offset').pfValue;
        switch(rs.edgeType){
            case 'self':
            case 'compound':
            case 'bezier':
            case 'multibezier':
                var cps = _createControlPointInfo();
                var selected;
                var startDist = 0;
                var totalDist = 0;
                // find the segment we're on
                for(var i = 0; i < cps.length; i++){
                    var _cp = cps[isSrc ? i : cps.length - 1 - i];
                    for(var j = 0; j < _cp.segments.length; j++){
                        var _seg = _cp.segments[isSrc ? j : _cp.segments.length - 1 - j];
                        var lastSeg = i === cps.length - 1 && j === _cp.segments.length - 1;
                        startDist = totalDist;
                        totalDist += _seg.length;
                        if (totalDist >= offset || lastSeg) {
                            selected = {
                                cp: _cp,
                                segment: _seg
                            };
                            break;
                        }
                    }
                    if (selected) break;
                }
                var cp = selected.cp;
                var seg = selected.segment;
                var tSegment = (offset - startDist) / seg.length;
                var segDt = seg.t1 - seg.t0;
                var t = isSrc ? seg.t0 + segDt * tSegment : seg.t1 - segDt * tSegment;
                t = bound(0, t, 1);
                p = qbezierPtAt(cp.p0, cp.p1, cp.p2, t);
                angle = bezierAngle(cp.p0, cp.p1, cp.p2, t);
                break;
            case 'straight':
            case 'segments':
            case 'haystack':
                var d = 0, di, d0;
                var p0, p1;
                var l = rs.allpts.length;
                for(var _i2 = 0; _i2 + 3 < l; _i2 += 2){
                    if (isSrc) {
                        p0 = {
                            x: rs.allpts[_i2],
                            y: rs.allpts[_i2 + 1]
                        };
                        p1 = {
                            x: rs.allpts[_i2 + 2],
                            y: rs.allpts[_i2 + 3]
                        };
                    } else {
                        p0 = {
                            x: rs.allpts[l - 2 - _i2],
                            y: rs.allpts[l - 1 - _i2]
                        };
                        p1 = {
                            x: rs.allpts[l - 4 - _i2],
                            y: rs.allpts[l - 3 - _i2]
                        };
                    }
                    di = dist(p0, p1);
                    d0 = d;
                    d += di;
                    if (d >= offset) break;
                }
                var pD = offset - d0;
                var _t = pD / di;
                _t = bound(0, _t, 1);
                p = lineAt(p0, p1, _t);
                angle = lineAngle(p0, p1);
                break;
        }
        setRs('labelX', prefix, p.x);
        setRs('labelY', prefix, p.y);
        setRs('labelAutoAngle', prefix, angle);
    };
    calculateEndProjection('source');
    calculateEndProjection('target');
    this.applyLabelDimensions(edge);
};
BRp$9.applyLabelDimensions = function(ele) {
    this.applyPrefixedLabelDimensions(ele);
    if (ele.isEdge()) {
        this.applyPrefixedLabelDimensions(ele, 'source');
        this.applyPrefixedLabelDimensions(ele, 'target');
    }
};
BRp$9.applyPrefixedLabelDimensions = function(ele, prefix) {
    var _p = ele._private;
    var text = this.getLabelText(ele, prefix);
    var labelDims = this.calculateLabelDimensions(ele, text);
    var lineHeight = ele.pstyle('line-height').pfValue;
    var textWrap = ele.pstyle('text-wrap').strValue;
    var lines = getPrefixedProperty(_p.rscratch, 'labelWrapCachedLines', prefix) || [];
    var numLines = textWrap !== 'wrap' ? 1 : Math.max(lines.length, 1);
    var normPerLineHeight = labelDims.height / numLines;
    var labelLineHeight = normPerLineHeight * lineHeight;
    var width = labelDims.width;
    var height = labelDims.height + (numLines - 1) * (lineHeight - 1) * normPerLineHeight;
    setPrefixedProperty(_p.rstyle, 'labelWidth', prefix, width);
    setPrefixedProperty(_p.rscratch, 'labelWidth', prefix, width);
    setPrefixedProperty(_p.rstyle, 'labelHeight', prefix, height);
    setPrefixedProperty(_p.rscratch, 'labelHeight', prefix, height);
    setPrefixedProperty(_p.rscratch, 'labelLineHeight', prefix, labelLineHeight);
};
BRp$9.getLabelText = function(ele, prefix) {
    var _p = ele._private;
    var pfd = prefix ? prefix + '-' : '';
    var text = ele.pstyle(pfd + 'label').strValue;
    var textTransform = ele.pstyle('text-transform').value;
    var rscratch = function rscratch(propName, value) {
        if (value) {
            setPrefixedProperty(_p.rscratch, propName, prefix, value);
            return value;
        } else return getPrefixedProperty(_p.rscratch, propName, prefix);
    };
    // for empty text, skip all processing
    if (!text) return '';
    if (textTransform == 'none') ;
    else if (textTransform == 'uppercase') text = text.toUpperCase();
    else if (textTransform == 'lowercase') text = text.toLowerCase();
    var wrapStyle = ele.pstyle('text-wrap').value;
    if (wrapStyle === 'wrap') {
        var labelKey = rscratch('labelKey');
        // save recalc if the label is the same as before
        if (labelKey != null && rscratch('labelWrapKey') === labelKey) return rscratch('labelWrapCachedText');
        var zwsp = "\u200B";
        var lines = text.split('\n');
        var maxW = ele.pstyle('text-max-width').pfValue;
        var overflow = ele.pstyle('text-overflow-wrap').value;
        var overflowAny = overflow === 'anywhere';
        var wrappedLines = [];
        var separatorRegex = /[\s\u200b]+|$/g; // Include end of string to add last word
        for(var l = 0; l < lines.length; l++){
            var line = lines[l];
            var lineDims = this.calculateLabelDimensions(ele, line);
            var lineW = lineDims.width;
            if (overflowAny) {
                var processedLine = line.split('').join(zwsp);
                line = processedLine;
            }
            if (lineW > maxW) {
                // line is too long
                var separatorMatches = line.matchAll(separatorRegex);
                var subline = '';
                var previousIndex = 0;
                // Add fake match
                var _iterator = _createForOfIteratorHelper(separatorMatches), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var separatorMatch = _step.value;
                        var wordSeparator = separatorMatch[0];
                        var word = line.substring(previousIndex, separatorMatch.index);
                        previousIndex = separatorMatch.index + wordSeparator.length;
                        var testLine = subline.length === 0 ? word : subline + word + wordSeparator;
                        var testDims = this.calculateLabelDimensions(ele, testLine);
                        var testW = testDims.width;
                        if (testW <= maxW) // word fits on current line
                        subline += word + wordSeparator;
                        else {
                            // word starts new line
                            if (subline) wrappedLines.push(subline);
                            subline = word + wordSeparator;
                        }
                    }
                // if there's remaining text, put it in a wrapped line
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (!subline.match(/^[\s\u200b]+$/)) wrappedLines.push(subline);
            } else // line is already short enough
            wrappedLines.push(line);
        } // for
        rscratch('labelWrapCachedLines', wrappedLines);
        text = rscratch('labelWrapCachedText', wrappedLines.join('\n'));
        rscratch('labelWrapKey', labelKey);
    } else if (wrapStyle === 'ellipsis') {
        var _maxW = ele.pstyle('text-max-width').pfValue;
        var ellipsized = '';
        var ellipsis = "\u2026";
        var incLastCh = false;
        if (this.calculateLabelDimensions(ele, text).width < _maxW) // the label already fits
        return text;
        for(var i = 0; i < text.length; i++){
            var widthWithNextCh = this.calculateLabelDimensions(ele, ellipsized + text[i] + ellipsis).width;
            if (widthWithNextCh > _maxW) break;
            ellipsized += text[i];
            if (i === text.length - 1) incLastCh = true;
        }
        if (!incLastCh) ellipsized += ellipsis;
        return ellipsized;
    } // if ellipsize
    return text;
};
BRp$9.getLabelJustification = function(ele) {
    var justification = ele.pstyle('text-justification').strValue;
    var textHalign = ele.pstyle('text-halign').strValue;
    if (justification === 'auto') {
        if (ele.isNode()) switch(textHalign){
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                return 'center';
        }
        else return 'center';
    } else return justification;
};
BRp$9.calculateLabelDimensions = function(ele, text) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    var cacheKey = hashString(text, ele._private.labelDimsKey);
    var cache = r.labelDimCache || (r.labelDimCache = []);
    var existingVal = cache[cacheKey];
    if (existingVal != null) return existingVal;
    var padding = 0; // add padding around text dims, as the measurement isn't that accurate
    var fStyle = ele.pstyle('font-style').strValue;
    var size = ele.pstyle('font-size').pfValue;
    var family = ele.pstyle('font-family').strValue;
    var weight = ele.pstyle('font-weight').strValue;
    var canvas = this.labelCalcCanvas;
    var c2d = this.labelCalcCanvasContext;
    if (!canvas) {
        canvas = this.labelCalcCanvas = document1.createElement('canvas');
        c2d = this.labelCalcCanvasContext = canvas.getContext('2d');
        var ds = canvas.style;
        ds.position = 'absolute';
        ds.left = '-9999px';
        ds.top = '-9999px';
        ds.zIndex = '-1';
        ds.visibility = 'hidden';
        ds.pointerEvents = 'none';
    }
    c2d.font = "".concat(fStyle, " ").concat(weight, " ").concat(size, "px ").concat(family);
    var width = 0;
    var height = 0;
    var lines = text.split('\n');
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        var metrics = c2d.measureText(line);
        var w = Math.ceil(metrics.width);
        var h = size;
        width = Math.max(w, width);
        height += h;
    }
    width += padding;
    height += padding;
    return cache[cacheKey] = {
        width: width,
        height: height
    };
};
BRp$9.calculateLabelAngle = function(ele, prefix) {
    var _p = ele._private;
    var rs = _p.rscratch;
    var isEdge = ele.isEdge();
    var prefixDash = prefix ? prefix + '-' : '';
    var rot = ele.pstyle(prefixDash + 'text-rotation');
    var rotStr = rot.strValue;
    if (rotStr === 'none') return 0;
    else if (isEdge && rotStr === 'autorotate') return rs.labelAutoAngle;
    else if (rotStr === 'autorotate') return 0;
    else return rot.pfValue;
};
BRp$9.calculateLabelAngles = function(ele) {
    var r = this;
    var isEdge = ele.isEdge();
    var _p = ele._private;
    var rs = _p.rscratch;
    rs.labelAngle = r.calculateLabelAngle(ele);
    if (isEdge) {
        rs.sourceLabelAngle = r.calculateLabelAngle(ele, 'source');
        rs.targetLabelAngle = r.calculateLabelAngle(ele, 'target');
    }
};
var BRp$8 = {};
var TOO_SMALL_CUT_RECT = 28;
var warnedCutRect = false;
BRp$8.getNodeShape = function(node) {
    var r = this;
    var shape = node.pstyle('shape').value;
    if (shape === 'cutrectangle' && (node.width() < TOO_SMALL_CUT_RECT || node.height() < TOO_SMALL_CUT_RECT)) {
        if (!warnedCutRect) {
            warn('The `cutrectangle` node shape can not be used at small sizes so `rectangle` is used instead');
            warnedCutRect = true;
        }
        return 'rectangle';
    }
    if (node.isParent()) {
        if (shape === 'rectangle' || shape === 'roundrectangle' || shape === 'round-rectangle' || shape === 'cutrectangle' || shape === 'cut-rectangle' || shape === 'barrel') return shape;
        else return 'rectangle';
    }
    if (shape === 'polygon') {
        var points = node.pstyle('shape-polygon-points').value;
        return r.nodeShapes.makePolygon(points).name;
    }
    return shape;
};
var BRp$7 = {};
BRp$7.registerCalculationListeners = function() {
    var cy = this.cy;
    var elesToUpdate = cy.collection();
    var r = this;
    var enqueue = function enqueue(eles) {
        var dirtyStyleCaches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        elesToUpdate.merge(eles);
        if (dirtyStyleCaches) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var _p = ele._private;
            var rstyle = _p.rstyle;
            rstyle.clean = false;
            rstyle.cleanConnected = false;
        }
    };
    r.binder(cy).on('bounds.* dirty.*', function onDirtyBounds(e) {
        var ele = e.target;
        enqueue(ele);
    }).on('style.* background.*', function onDirtyStyle(e) {
        var ele = e.target;
        enqueue(ele, false);
    });
    var updateEleCalcs = function updateEleCalcs(willDraw) {
        if (willDraw) {
            var fns = r.onUpdateEleCalcsFns;
            // because we need to have up-to-date style (e.g. stylesheet mappers)
            // before calculating rendered style (and pstyle might not be called yet)
            elesToUpdate.cleanStyle();
            for(var i = 0; i < elesToUpdate.length; i++){
                var ele = elesToUpdate[i];
                var rstyle = ele._private.rstyle;
                if (ele.isNode() && !rstyle.cleanConnected) {
                    enqueue(ele.connectedEdges());
                    rstyle.cleanConnected = true;
                }
            }
            if (fns) for(var _i = 0; _i < fns.length; _i++){
                var fn = fns[_i];
                fn(willDraw, elesToUpdate);
            }
            r.recalculateRenderedStyle(elesToUpdate);
            elesToUpdate = cy.collection();
        }
    };
    r.flushRenderedStyleQueue = function() {
        updateEleCalcs(true);
    };
    r.beforeRender(updateEleCalcs, r.beforeRenderPriorities.eleCalcs);
};
BRp$7.onUpdateEleCalcs = function(fn) {
    var fns = this.onUpdateEleCalcsFns = this.onUpdateEleCalcsFns || [];
    fns.push(fn);
};
BRp$7.recalculateRenderedStyle = function(eles, useCache) {
    var isCleanConnected = function isCleanConnected(ele) {
        return ele._private.rstyle.cleanConnected;
    };
    if (eles.length === 0) return;
    var edges = [];
    var nodes = [];
    // the renderer can't be used for calcs when destroyed, e.g. ele.boundingBox()
    if (this.destroyed) return;
    // use cache by default for perf
    if (useCache === undefined) useCache = true;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var _p = ele._private;
        var rstyle = _p.rstyle;
        // an edge may be implicitly dirty b/c of one of its connected nodes
        // (and a request for recalc may come in between frames)
        if (ele.isEdge() && (!isCleanConnected(ele.source()) || !isCleanConnected(ele.target()))) rstyle.clean = false;
        if (ele.isEdge() && ele.isBundledBezier()) {
            if (ele.parallelEdges().some(function(ele) {
                return !ele._private.rstyle.clean && ele.isBundledBezier();
            })) rstyle.clean = false;
        }
        // only update if dirty and in graph
        if (useCache && rstyle.clean || ele.removed()) continue;
        // only update if not display: none
        if (ele.pstyle('display').value === 'none') continue;
        if (_p.group === 'nodes') nodes.push(ele);
        else // edges
        edges.push(ele);
        rstyle.clean = true;
    }
    // update node data from projections
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        var _p2 = _ele._private;
        var _rstyle = _p2.rstyle;
        var pos = _ele.position();
        this.recalculateNodeLabelProjection(_ele);
        _rstyle.nodeX = pos.x;
        _rstyle.nodeY = pos.y;
        _rstyle.nodeW = _ele.pstyle('width').pfValue;
        _rstyle.nodeH = _ele.pstyle('height').pfValue;
    }
    this.recalculateEdgeProjections(edges);
    // update edge data from projections
    for(var _i3 = 0; _i3 < edges.length; _i3++){
        var _ele2 = edges[_i3];
        var _p3 = _ele2._private;
        var _rstyle2 = _p3.rstyle;
        var rs = _p3.rscratch;
        // update rstyle positions
        _rstyle2.srcX = rs.arrowStartX;
        _rstyle2.srcY = rs.arrowStartY;
        _rstyle2.tgtX = rs.arrowEndX;
        _rstyle2.tgtY = rs.arrowEndY;
        _rstyle2.midX = rs.midX;
        _rstyle2.midY = rs.midY;
        _rstyle2.labelAngle = rs.labelAngle;
        _rstyle2.sourceLabelAngle = rs.sourceLabelAngle;
        _rstyle2.targetLabelAngle = rs.targetLabelAngle;
    }
};
var BRp$6 = {};
BRp$6.updateCachedGrabbedEles = function() {
    var eles = this.cachedZSortedEles;
    if (!eles) // just let this be recalculated on the next z sort tick
    return;
    eles.drag = [];
    eles.nondrag = [];
    var grabTargets = [];
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        if (ele.grabbed() && !ele.isParent()) grabTargets.push(ele);
        else if (rs.inDragLayer) eles.drag.push(ele);
        else eles.nondrag.push(ele);
    }
    // put the grab target nodes last so it's on top of its neighbourhood
    for(var i = 0; i < grabTargets.length; i++){
        var ele = grabTargets[i];
        eles.drag.push(ele);
    }
};
BRp$6.invalidateCachedZSortedEles = function() {
    this.cachedZSortedEles = null;
};
BRp$6.getCachedZSortedEles = function(forceRecalc) {
    if (forceRecalc || !this.cachedZSortedEles) {
        var eles = this.cy.mutableElements().toArray();
        eles.sort(zIndexSort);
        eles.interactive = eles.filter(function(ele) {
            return ele.interactive();
        });
        this.cachedZSortedEles = eles;
        this.updateCachedGrabbedEles();
    } else eles = this.cachedZSortedEles;
    return eles;
};
var BRp$5 = {};
[
    BRp$e,
    BRp$d,
    BRp$c,
    BRp$b,
    BRp$a,
    BRp$9,
    BRp$8,
    BRp$7,
    BRp$6
].forEach(function(props) {
    extend(BRp$5, props);
});
var BRp$4 = {};
BRp$4.getCachedImage = function(url, crossOrigin, onLoad) {
    var r = this;
    var imageCache = r.imageCache = r.imageCache || {};
    var cache = imageCache[url];
    if (cache) {
        if (!cache.image.complete) cache.image.addEventListener('load', onLoad);
        return cache.image;
    } else {
        cache = imageCache[url] = imageCache[url] || {};
        var image = cache.image = new Image(); // eslint-disable-line no-undef
        image.addEventListener('load', onLoad);
        image.addEventListener('error', function() {
            image.error = true;
        });
        // #1582 safari doesn't load data uris with crossOrigin properly
        // https://bugs.webkit.org/show_bug.cgi?id=123978
        var dataUriPrefix = 'data:';
        var isDataUri = url.substring(0, dataUriPrefix.length).toLowerCase() === dataUriPrefix;
        if (!isDataUri) {
            // if crossorigin is 'null'(stringified), then manually set it to null 
            crossOrigin = crossOrigin === 'null' ? null : crossOrigin;
            image.crossOrigin = crossOrigin; // prevent tainted canvas
        }
        image.src = url;
        return image;
    }
};
var BRp$3 = {};
/* global document, ResizeObserver, MutationObserver */ BRp$3.registerBinding = function(target, event, handler, useCapture) {
    // eslint-disable-line no-unused-vars
    var args = Array.prototype.slice.apply(arguments, [
        1
    ]); // copy
    if (Array.isArray(target)) {
        var res = [];
        for(var i = 0; i < target.length; i++){
            var t = target[i];
            if (t !== undefined) {
                var b = this.binder(t);
                res.push(b.on.apply(b, args));
            }
        }
        return res;
    }
    var b = this.binder(target);
    return b.on.apply(b, args);
};
BRp$3.binder = function(tgt) {
    var r = this;
    var containerWindow = r.cy.window();
    var tgtIsDom = tgt === containerWindow || tgt === containerWindow.document || tgt === containerWindow.document.body || domElement(tgt);
    if (r.supportsPassiveEvents == null) {
        // from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    supportsPassive = true;
                    return true;
                }
            });
            containerWindow.addEventListener('test', null, opts);
        } catch (err) {
        // not supported
        }
        r.supportsPassiveEvents = supportsPassive;
    }
    var on = function on(event, handler, useCapture) {
        var args = Array.prototype.slice.call(arguments);
        if (tgtIsDom && r.supportsPassiveEvents) // replace useCapture w/ opts obj
        args[2] = {
            capture: useCapture != null ? useCapture : false,
            passive: false,
            once: false
        };
        r.bindings.push({
            target: tgt,
            args: args
        });
        (tgt.addEventListener || tgt.on).apply(tgt, args);
        return this;
    };
    return {
        on: on,
        addEventListener: on,
        addListener: on,
        bind: on
    };
};
BRp$3.nodeIsDraggable = function(node) {
    return node && node.isNode() && !node.locked() && node.grabbable();
};
BRp$3.nodeIsGrabbable = function(node) {
    return this.nodeIsDraggable(node) && node.interactive();
};
BRp$3.load = function() {
    var r = this;
    var containerWindow = r.cy.window();
    var isSelected = function isSelected(ele) {
        return ele.selected();
    };
    var getShadowRoot = function getShadowRoot(element) {
        var rootNode = element.getRootNode();
        // Check if the root node is a shadow root
        if (rootNode && rootNode.nodeType === 11 && rootNode.host !== undefined) return rootNode;
    };
    var triggerEvents = function triggerEvents(target, names, e, position) {
        if (target == null) target = r.cy;
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            target.emit({
                originalEvent: e,
                type: name,
                position: position
            });
        }
    };
    var isMultSelKeyDown = function isMultSelKeyDown(e) {
        return e.shiftKey || e.metaKey || e.ctrlKey; // maybe e.altKey
    };
    var allowPanningPassthrough = function allowPanningPassthrough(down, downs) {
        var allowPassthrough = true;
        if (r.cy.hasCompoundNodes() && down && down.pannable()) // a grabbable compound node below the ele => no passthrough panning
        for(var i = 0; downs && i < downs.length; i++){
            var down = downs[i];
            //if any parent node in event hierarchy isn't pannable, reject passthrough
            if (down.isNode() && down.isParent() && !down.pannable()) {
                allowPassthrough = false;
                break;
            }
        }
        else allowPassthrough = true;
        return allowPassthrough;
    };
    var setGrabbed = function setGrabbed(ele) {
        ele[0]._private.grabbed = true;
    };
    var setFreed = function setFreed(ele) {
        ele[0]._private.grabbed = false;
    };
    var setInDragLayer = function setInDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = true;
    };
    var setOutDragLayer = function setOutDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = false;
    };
    var setGrabTarget = function setGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = true;
    };
    var removeGrabTarget = function removeGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = false;
    };
    var addToDragList = function addToDragList(ele, opts) {
        var list = opts.addToList;
        var listHasEle = list.has(ele);
        if (!listHasEle && ele.grabbable() && !ele.locked()) {
            list.merge(ele);
            setGrabbed(ele);
        }
    };
    // helper function to determine which child nodes and inner edges
    // of a compound node to be dragged as well as the grabbed and selected nodes
    var addDescendantsToDrag = function addDescendantsToDrag(node, opts) {
        if (!node.cy().hasCompoundNodes()) return;
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        var innerNodes = node.descendants();
        if (opts.inDragLayer) {
            innerNodes.forEach(setInDragLayer);
            innerNodes.connectedEdges().forEach(setInDragLayer);
        }
        if (opts.addToList) addToDragList(innerNodes, opts);
    };
    // adds the given nodes and its neighbourhood to the drag layer
    var addNodesToDrag = function addNodesToDrag(nodes, opts) {
        opts = opts || {};
        var hasCompoundNodes = nodes.cy().hasCompoundNodes();
        if (opts.inDragLayer) {
            nodes.forEach(setInDragLayer);
            nodes.neighborhood().stdFilter(function(ele) {
                return !hasCompoundNodes || ele.isEdge();
            }).forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
        addDescendantsToDrag(nodes, opts); // always add to drag
        // also add nodes and edges related to the topmost ancestor
        updateAncestorsInDragLayer(nodes, {
            inDragLayer: opts.inDragLayer
        });
        r.updateCachedGrabbedEles();
    };
    var addNodeToDrag = addNodesToDrag;
    var freeDraggedElements = function freeDraggedElements(grabbedEles) {
        if (!grabbedEles) return;
        // just go over all elements rather than doing a bunch of (possibly expensive) traversals
        r.getCachedZSortedEles().forEach(function(ele) {
            setFreed(ele);
            setOutDragLayer(ele);
            removeGrabTarget(ele);
        });
        r.updateCachedGrabbedEles();
    };
    // helper function to determine which ancestor nodes and edges should go
    // to the drag layer (or should be removed from drag layer).
    var updateAncestorsInDragLayer = function updateAncestorsInDragLayer(node, opts) {
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        if (!node.cy().hasCompoundNodes()) return;
        // find top-level parent
        var parent = node.ancestors().orphans();
        // no parent node: no nodes to add to the drag layer
        if (parent.same(node)) return;
        var nodes = parent.descendants().spawnSelf().merge(parent).unmerge(node).unmerge(node.descendants());
        var edges = nodes.connectedEdges();
        if (opts.inDragLayer) {
            edges.forEach(setInDragLayer);
            nodes.forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
    };
    var blurActiveDomElement = function blurActiveDomElement() {
        if (document.activeElement != null && document.activeElement.blur != null) document.activeElement.blur();
    };
    var haveMutationsApi = typeof MutationObserver !== 'undefined';
    var haveResizeObserverApi = typeof ResizeObserver !== 'undefined';
    // watch for when the cy container is removed from the dom
    if (haveMutationsApi) {
        r.removeObserver = new MutationObserver(function(mutns) {
            // eslint-disable-line no-undef
            for(var i = 0; i < mutns.length; i++){
                var mutn = mutns[i];
                var rNodes = mutn.removedNodes;
                if (rNodes) for(var j = 0; j < rNodes.length; j++){
                    var rNode = rNodes[j];
                    if (rNode === r.container) {
                        r.destroy();
                        break;
                    }
                }
            }
        });
        if (r.container.parentNode) r.removeObserver.observe(r.container.parentNode, {
            childList: true
        });
    } else r.registerBinding(r.container, 'DOMNodeRemoved', function(e) {
        // eslint-disable-line no-unused-vars
        r.destroy();
    });
    var onResize = debounce(function() {
        r.cy.resize();
    }, 100);
    if (haveMutationsApi) {
        r.styleObserver = new MutationObserver(onResize); // eslint-disable-line no-undef
        r.styleObserver.observe(r.container, {
            attributes: true
        });
    }
    // auto resize
    r.registerBinding(containerWindow, 'resize', onResize); // eslint-disable-line no-undef
    if (haveResizeObserverApi) {
        r.resizeObserver = new ResizeObserver(onResize); // eslint-disable-line no-undef
        r.resizeObserver.observe(r.container);
    }
    var forEachUp = function forEachUp(domEle, fn) {
        while(domEle != null){
            fn(domEle);
            domEle = domEle.parentNode;
        }
    };
    var invalidateCoords = function invalidateCoords() {
        r.invalidateContainerClientCoordsCache();
    };
    forEachUp(r.container, function(domEle) {
        r.registerBinding(domEle, 'transitionend', invalidateCoords);
        r.registerBinding(domEle, 'animationend', invalidateCoords);
        r.registerBinding(domEle, 'scroll', invalidateCoords);
    });
    // stop right click menu from appearing on cy
    r.registerBinding(r.container, 'contextmenu', function(e) {
        e.preventDefault();
    });
    var inBoxSelection = function inBoxSelection() {
        return r.selection[4] !== 0;
    };
    var eventInContainer = function eventInContainer(e) {
        // save cycles if mouse events aren't to be captured
        var containerPageCoords = r.findContainerClientCoords();
        var x = containerPageCoords[0];
        var y = containerPageCoords[1];
        var width = containerPageCoords[2];
        var height = containerPageCoords[3];
        var positions = e.touches ? e.touches : [
            e
        ];
        var atLeastOnePosInside = false;
        for(var i = 0; i < positions.length; i++){
            var p = positions[i];
            if (x <= p.clientX && p.clientX <= x + width && y <= p.clientY && p.clientY <= y + height) {
                atLeastOnePosInside = true;
                break;
            }
        }
        if (!atLeastOnePosInside) return false;
        var container = r.container;
        var target = e.target;
        var tParent = target.parentNode;
        var containerIsTarget = false;
        while(tParent){
            if (tParent === container) {
                containerIsTarget = true;
                break;
            }
            tParent = tParent.parentNode;
        }
        if (!containerIsTarget) return false;
         // if target is outisde cy container, then this event is not for us
        return true;
    };
    // Primary key
    r.registerBinding(r.container, 'mousedown', function mousedownHandler(e) {
        if (!eventInContainer(e)) return;
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1) return;
        e.preventDefault();
        blurActiveDomElement();
        r.hoverData.capture = true;
        r.hoverData.which = e.which;
        var cy = r.cy;
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var select = r.selection;
        var nears = r.findNearestElements(pos[0], pos[1], true, false);
        var near = nears[0];
        var draggedElements = r.dragData.possibleDragElements;
        r.hoverData.mdownPos = pos;
        r.hoverData.mdownGPos = gpos;
        var checkForTaphold = function checkForTaphold() {
            r.hoverData.tapholdCancelled = false;
            clearTimeout(r.hoverData.tapholdTimeout);
            r.hoverData.tapholdTimeout = setTimeout(function() {
                if (r.hoverData.tapholdCancelled) return;
                else {
                    var ele = r.hoverData.down;
                    if (ele) ele.emit({
                        originalEvent: e,
                        type: 'taphold',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                    else cy.emit({
                        originalEvent: e,
                        type: 'taphold',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                }
            }, r.tapholdDuration);
        };
        // Right click button
        if (e.which == 3) {
            r.hoverData.cxtStarted = true;
            var cxtEvt = {
                originalEvent: e,
                type: 'cxttapstart',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
            if (near) {
                near.activate();
                near.emit(cxtEvt);
                r.hoverData.down = near;
            } else cy.emit(cxtEvt);
            r.hoverData.downTime = new Date().getTime();
            r.hoverData.cxtDragged = false;
        // Primary button
        } else if (e.which == 1) {
            if (near) near.activate();
            // If something is under the cursor and it is draggable, prepare to grab it
            if (near != null) {
                if (r.nodeIsGrabbable(near)) {
                    var makeEvent = function makeEvent(type) {
                        return {
                            originalEvent: e,
                            type: type,
                            position: {
                                x: pos[0],
                                y: pos[1]
                            }
                        };
                    };
                    var triggerGrab = function triggerGrab(ele) {
                        ele.emit(makeEvent('grab'));
                    };
                    setGrabTarget(near);
                    if (!near.selected()) {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        addNodeToDrag(near, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon')).emit(makeEvent('grab'));
                    } else {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        var selectedNodes = cy.$(function(ele) {
                            return ele.isNode() && ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon'));
                        selectedNodes.forEach(triggerGrab);
                    }
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                }
            }
            r.hoverData.down = near;
            r.hoverData.downs = nears;
            r.hoverData.downTime = new Date().getTime();
            triggerEvents(near, [
                'mousedown',
                'tapstart',
                'vmousedown'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (near == null) {
                select[4] = 1;
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            } else if (near.pannable()) select[4] = 1; // for future pan
            checkForTaphold();
        }
        // Initialize selection box coordinates
        select[0] = select[2] = pos[0];
        select[1] = select[3] = pos[1];
    }, false);
    var shadowRoot = getShadowRoot(r.container);
    r.registerBinding([
        containerWindow,
        shadowRoot
    ], 'mousemove', function mousemoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.hoverData.capture;
        if (!capture && !eventInContainer(e)) return;
        var preventDefault = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var mdownPos = r.hoverData.mdownPos;
        var mdownGPos = r.hoverData.mdownGPos;
        var select = r.selection;
        var near = null;
        if (!r.hoverData.draggingEles && !r.hoverData.dragging && !r.hoverData.selecting) near = r.findNearestElement(pos[0], pos[1], true, false);
        var last = r.hoverData.last;
        var down = r.hoverData.down;
        var disp = [
            pos[0] - select[2],
            pos[1] - select[3]
        ];
        var draggedElements = r.dragData.possibleDragElements;
        var isOverThresholdDrag;
        if (mdownGPos) {
            var dx = gpos[0] - mdownGPos[0];
            var dx2 = dx * dx;
            var dy = gpos[1] - mdownGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            r.hoverData.isOverThresholdDrag = isOverThresholdDrag = dist2 >= r.desktopTapThreshold2;
        }
        var multSelKeyDown = isMultSelKeyDown(e);
        if (isOverThresholdDrag) r.hoverData.tapholdCancelled = true;
        var updateDragDelta = function updateDragDelta() {
            var dragDelta = r.hoverData.dragDelta = r.hoverData.dragDelta || [];
            if (dragDelta.length === 0) {
                dragDelta.push(disp[0]);
                dragDelta.push(disp[1]);
            } else {
                dragDelta[0] += disp[0];
                dragDelta[1] += disp[1];
            }
        };
        preventDefault = true;
        triggerEvents(near, [
            'mousemove',
            'vmousemove',
            'tapdrag'
        ], e, {
            x: pos[0],
            y: pos[1]
        });
        var goIntoBoxMode = function goIntoBoxMode() {
            r.data.bgActivePosistion = undefined;
            if (!r.hoverData.selecting) cy.emit({
                originalEvent: e,
                type: 'boxstart',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            });
            select[4] = 1;
            r.hoverData.selecting = true;
            r.redrawHint('select', true);
            r.redraw();
        };
        // trigger context drag if rmouse down
        if (r.hoverData.which === 3) // but only if over threshold
        {
            if (isOverThresholdDrag) {
                var cxtEvt = {
                    originalEvent: e,
                    type: 'cxtdrag',
                    position: {
                        x: pos[0],
                        y: pos[1]
                    }
                };
                if (down) down.emit(cxtEvt);
                else cy.emit(cxtEvt);
                r.hoverData.cxtDragged = true;
                if (!r.hoverData.cxtOver || near !== r.hoverData.cxtOver) {
                    if (r.hoverData.cxtOver) r.hoverData.cxtOver.emit({
                        originalEvent: e,
                        type: 'cxtdragout',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                    r.hoverData.cxtOver = near;
                    if (near) near.emit({
                        originalEvent: e,
                        type: 'cxtdragover',
                        position: {
                            x: pos[0],
                            y: pos[1]
                        }
                    });
                }
            }
        } else if (r.hoverData.dragging) {
            preventDefault = true;
            if (cy.panningEnabled() && cy.userPanningEnabled()) {
                var deltaP;
                if (r.hoverData.justStartedPan) {
                    var mdPos = r.hoverData.mdownPos;
                    deltaP = {
                        x: (pos[0] - mdPos[0]) * zoom,
                        y: (pos[1] - mdPos[1]) * zoom
                    };
                    r.hoverData.justStartedPan = false;
                } else deltaP = {
                    x: disp[0] * zoom,
                    y: disp[1] * zoom
                };
                cy.panBy(deltaP);
                cy.emit('dragpan');
                r.hoverData.dragged = true;
            }
            // Needs reproject due to pan changing viewport
            pos = r.projectIntoViewport(e.clientX, e.clientY);
        // Checks primary button down & out of time & mouse not moved much
        } else if (select[4] == 1 && (down == null || down.pannable())) {
            if (isOverThresholdDrag) {
                if (!r.hoverData.dragging && cy.boxSelectionEnabled() && (multSelKeyDown || !cy.panningEnabled() || !cy.userPanningEnabled())) goIntoBoxMode();
                else if (!r.hoverData.selecting && cy.panningEnabled() && cy.userPanningEnabled()) {
                    var allowPassthrough = allowPanningPassthrough(down, r.hoverData.downs);
                    if (allowPassthrough) {
                        r.hoverData.dragging = true;
                        r.hoverData.justStartedPan = true;
                        select[4] = 0;
                        r.data.bgActivePosistion = array2point(mdownPos);
                        r.redrawHint('select', true);
                        r.redraw();
                    }
                }
                if (down && down.pannable() && down.active()) down.unactivate();
            }
        } else {
            if (down && down.pannable() && down.active()) down.unactivate();
            if ((!down || !down.grabbed()) && near != last) {
                if (last) triggerEvents(last, [
                    'mouseout',
                    'tapdragout'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                if (near) triggerEvents(near, [
                    'mouseover',
                    'tapdragover'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                r.hoverData.last = near;
            }
            if (down) {
                if (isOverThresholdDrag) {
                    // then we can take action
                    if (cy.boxSelectionEnabled() && multSelKeyDown) {
                        // then selection overrides
                        if (down && down.grabbed()) {
                            freeDraggedElements(draggedElements);
                            down.emit('freeon');
                            draggedElements.emit('free');
                            if (r.dragData.didDrag) {
                                down.emit('dragfreeon');
                                draggedElements.emit('dragfree');
                            }
                        }
                        goIntoBoxMode();
                    } else if (down && down.grabbed() && r.nodeIsDraggable(down)) {
                        // drag node
                        var justStartedDrag = !r.dragData.didDrag;
                        if (justStartedDrag) r.redrawHint('eles', true);
                        r.dragData.didDrag = true; // indicate that we actually did drag the node
                        // now, add the elements to the drag layer if not done already
                        if (!r.hoverData.draggingEles) addNodesToDrag(draggedElements, {
                            inDragLayer: true
                        });
                        var totalShift = {
                            x: 0,
                            y: 0
                        };
                        if (number$1(disp[0]) && number$1(disp[1])) {
                            totalShift.x += disp[0];
                            totalShift.y += disp[1];
                            if (justStartedDrag) {
                                var dragDelta = r.hoverData.dragDelta;
                                if (dragDelta && number$1(dragDelta[0]) && number$1(dragDelta[1])) {
                                    totalShift.x += dragDelta[0];
                                    totalShift.y += dragDelta[1];
                                }
                            }
                        }
                        r.hoverData.draggingEles = true;
                        draggedElements.silentShift(totalShift).emit('position drag');
                        r.redrawHint('drag', true);
                        r.redraw();
                    }
                } else // otherwise save drag delta for when we actually start dragging so the relative grab pos is constant
                updateDragDelta();
            }
            // prevent the dragging from triggering text selection on the page
            preventDefault = true;
        }
        select[2] = pos[0];
        select[3] = pos[1];
        if (preventDefault) {
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            return false;
        }
    }, false);
    var clickTimeout, didDoubleClick, prevClickTimeStamp;
    r.registerBinding(containerWindow, 'mouseup', function mouseupHandler(e) {
        // eslint-disable-line no-undef
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1 && r.hoverData.capture) return;
        var capture = r.hoverData.capture;
        if (!capture) return;
        r.hoverData.capture = false;
        var cy = r.cy;
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var select = r.selection;
        var near = r.findNearestElement(pos[0], pos[1], true, false);
        var draggedElements = r.dragData.possibleDragElements;
        var down = r.hoverData.down;
        var multSelKeyDown = isMultSelKeyDown(e);
        if (r.data.bgActivePosistion) {
            r.redrawHint('select', true);
            r.redraw();
        }
        r.hoverData.tapholdCancelled = true;
        r.data.bgActivePosistion = undefined; // not active bg now
        if (down) down.unactivate();
        if (r.hoverData.which === 3) {
            var cxtEvt = {
                originalEvent: e,
                type: 'cxttapend',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
            if (down) down.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (!r.hoverData.cxtDragged) {
                var cxtTap = {
                    originalEvent: e,
                    type: 'cxttap',
                    position: {
                        x: pos[0],
                        y: pos[1]
                    }
                };
                if (down) down.emit(cxtTap);
                else cy.emit(cxtTap);
            }
            r.hoverData.cxtDragged = false;
            r.hoverData.which = null;
        } else if (r.hoverData.which === 1) {
            triggerEvents(near, [
                'mouseup',
                'tapend',
                'vmouseup'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (!r.dragData.didDrag && // didn't move a node around
            !r.hoverData.dragged && // didn't pan
            !r.hoverData.selecting && // not box selection
            !r.hoverData.isOverThresholdDrag // didn't move too much
            ) {
                triggerEvents(down, [
                    "click",
                    "tap",
                    "vclick"
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                didDoubleClick = false;
                if (e.timeStamp - prevClickTimeStamp <= cy.multiClickDebounceTime()) {
                    clickTimeout && clearTimeout(clickTimeout);
                    didDoubleClick = true;
                    prevClickTimeStamp = null;
                    triggerEvents(down, [
                        "dblclick",
                        "dbltap",
                        "vdblclick"
                    ], e, {
                        x: pos[0],
                        y: pos[1]
                    });
                } else {
                    clickTimeout = setTimeout(function() {
                        if (didDoubleClick) return;
                        triggerEvents(down, [
                            "oneclick",
                            "onetap",
                            "voneclick"
                        ], e, {
                            x: pos[0],
                            y: pos[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevClickTimeStamp = e.timeStamp;
                }
            }
            // Deselect all elements if nothing is currently under the mouse cursor and we aren't dragging something
            if (down == null // not mousedown on node
             && !r.dragData.didDrag // didn't move the node around
             && !r.hoverData.selecting // not box selection
             && !r.hoverData.dragged // didn't pan
             && !isMultSelKeyDown(e)) {
                cy.$(isSelected).unselect([
                    'tapunselect'
                ]);
                if (draggedElements.length > 0) r.redrawHint('eles', true);
                r.dragData.possibleDragElements = draggedElements = cy.collection();
            }
            // Single selection
            if (near == down && !r.dragData.didDrag && !r.hoverData.selecting) {
                if (near != null && near._private.selectable) {
                    if (r.hoverData.dragging) ;
                    else if (cy.selectionType() === 'additive' || multSelKeyDown) {
                        if (near.selected()) near.unselect([
                            'tapunselect'
                        ]);
                        else near.select([
                            'tapselect'
                        ]);
                    } else if (!multSelKeyDown) {
                        cy.$(isSelected).unmerge(near).unselect([
                            'tapunselect'
                        ]);
                        near.select([
                            'tapselect'
                        ]);
                    }
                    r.redrawHint('eles', true);
                }
            }
            if (r.hoverData.selecting) {
                var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
                r.redrawHint('select', true);
                if (box.length > 0) r.redrawHint('eles', true);
                cy.emit({
                    type: 'boxend',
                    originalEvent: e,
                    position: {
                        x: pos[0],
                        y: pos[1]
                    }
                });
                var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                    return ele.selectable() && !ele.selected();
                };
                if (cy.selectionType() === 'additive') box.emit('box').stdFilter(eleWouldBeSelected).select().emit('boxselect');
                else {
                    if (!multSelKeyDown) cy.$(isSelected).unmerge(box).unselect();
                    box.emit('box').stdFilter(eleWouldBeSelected).select().emit('boxselect');
                }
                // always need redraw in case eles unselectable
                r.redraw();
            }
            // Cancel drag pan
            if (r.hoverData.dragging) {
                r.hoverData.dragging = false;
                r.redrawHint('select', true);
                r.redrawHint('eles', true);
                r.redraw();
            }
            if (!select[4]) {
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                var downWasGrabbed = down && down.grabbed();
                freeDraggedElements(draggedElements);
                if (downWasGrabbed) {
                    down.emit('freeon');
                    draggedElements.emit('free');
                    if (r.dragData.didDrag) {
                        down.emit('dragfreeon');
                        draggedElements.emit('dragfree');
                    }
                }
            }
        } // else not right mouse
        select[4] = 0;
        r.hoverData.down = null;
        r.hoverData.cxtStarted = false;
        r.hoverData.draggingEles = false;
        r.hoverData.selecting = false;
        r.hoverData.isOverThresholdDrag = false;
        r.dragData.didDrag = false;
        r.hoverData.dragged = false;
        r.hoverData.dragDelta = [];
        r.hoverData.mdownPos = null;
        r.hoverData.mdownGPos = null;
        r.hoverData.which = null;
    }, false);
    var wheelHandler = function wheelHandler(e) {
        if (r.scrollingPage) return;
         // while scrolling, ignore wheel-to-zoom
        var cy = r.cy;
        var zoom = cy.zoom();
        var pan = cy.pan();
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var rpos = [
            pos[0] * zoom + pan.x,
            pos[1] * zoom + pan.y
        ];
        if (r.hoverData.draggingEles || r.hoverData.dragging || r.hoverData.cxtStarted || inBoxSelection()) {
            // if pan dragging or cxt dragging, wheel movements make no zoom
            e.preventDefault();
            return;
        }
        if (cy.panningEnabled() && cy.userPanningEnabled() && cy.zoomingEnabled() && cy.userZoomingEnabled()) {
            e.preventDefault();
            r.data.wheelZooming = true;
            clearTimeout(r.data.wheelTimeout);
            r.data.wheelTimeout = setTimeout(function() {
                r.data.wheelZooming = false;
                r.redrawHint('eles', true);
                r.redraw();
            }, 150);
            var diff;
            if (e.deltaY != null) diff = e.deltaY / -250;
            else if (e.wheelDeltaY != null) diff = e.wheelDeltaY / 1000;
            else diff = e.wheelDelta / 1000;
            diff = diff * r.wheelSensitivity;
            var needsWheelFix = e.deltaMode === 1;
            if (needsWheelFix) // fixes slow wheel events on ff/linux and ff/windows
            diff *= 33;
            var newZoom = cy.zoom() * Math.pow(10, diff);
            if (e.type === 'gesturechange') newZoom = r.gestureStartZoom * e.scale;
            cy.zoom({
                level: newZoom,
                renderedPosition: {
                    x: rpos[0],
                    y: rpos[1]
                }
            });
            cy.emit(e.type === 'gesturechange' ? 'pinchzoom' : 'scrollzoom');
        }
    };
    // Functions to help with whether mouse wheel should trigger zooming
    // --
    r.registerBinding(r.container, 'wheel', wheelHandler, true);
    // disable nonstandard wheel events
    // r.registerBinding(r.container, 'mousewheel', wheelHandler, true);
    // r.registerBinding(r.container, 'DOMMouseScroll', wheelHandler, true);
    // r.registerBinding(r.container, 'MozMousePixelScroll', wheelHandler, true); // older firefox
    r.registerBinding(containerWindow, 'scroll', function scrollHandler(e) {
        // eslint-disable-line no-unused-vars
        r.scrollingPage = true;
        clearTimeout(r.scrollingPageTimeout);
        r.scrollingPageTimeout = setTimeout(function() {
            r.scrollingPage = false;
        }, 250);
    }, true);
    // desktop safari pinch to zoom start
    r.registerBinding(r.container, 'gesturestart', function gestureStartHandler(e) {
        r.gestureStartZoom = r.cy.zoom();
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        e.preventDefault();
    }, true);
    r.registerBinding(r.container, 'gesturechange', function(e) {
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        wheelHandler(e);
    }, true);
    // Functions to help with handling mouseout/mouseover on the Cytoscape container
    // Handle mouseout on Cytoscape container
    r.registerBinding(r.container, 'mouseout', function mouseOutHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseout',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    r.registerBinding(r.container, 'mouseover', function mouseOverHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseover',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    var f1x1, f1y1, f2x1, f2y1; // starting points for pinch-to-zoom
    var distance1, distance1Sq; // initial distance between finger 1 and finger 2 for pinch-to-zoom
    var center1, modelCenter1; // center point on start pinch to zoom
    var offsetLeft, offsetTop;
    var containerWidth, containerHeight;
    var twoFingersStartInside;
    var distance = function distance(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    };
    var distanceSq = function distanceSq(x1, y1, x2, y2) {
        return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
    };
    var touchstartHandler;
    r.registerBinding(r.container, 'touchstart', touchstartHandler = function touchstartHandler(e) {
        r.hasTouchStarted = true;
        if (!eventInContainer(e)) return;
        blurActiveDomElement();
        r.touchData.capture = true;
        r.data.bgActivePosistion = undefined;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        // record starting points for pinch-to-zoom
        if (e.touches[1]) {
            r.touchData.singleTouchMoved = true;
            freeDraggedElements(r.dragData.touchDragEles);
            var offsets = r.findContainerClientCoords();
            offsetLeft = offsets[0];
            offsetTop = offsets[1];
            containerWidth = offsets[2];
            containerHeight = offsets[3];
            f1x1 = e.touches[0].clientX - offsetLeft;
            f1y1 = e.touches[0].clientY - offsetTop;
            f2x1 = e.touches[1].clientX - offsetLeft;
            f2y1 = e.touches[1].clientY - offsetTop;
            twoFingersStartInside = 0 <= f1x1 && f1x1 <= containerWidth && 0 <= f2x1 && f2x1 <= containerWidth && 0 <= f1y1 && f1y1 <= containerHeight && 0 <= f2y1 && f2y1 <= containerHeight;
            var pan = cy.pan();
            var zoom = cy.zoom();
            distance1 = distance(f1x1, f1y1, f2x1, f2y1);
            distance1Sq = distanceSq(f1x1, f1y1, f2x1, f2y1);
            center1 = [
                (f1x1 + f2x1) / 2,
                (f1y1 + f2y1) / 2
            ];
            modelCenter1 = [
                (center1[0] - pan.x) / zoom,
                (center1[1] - pan.y) / zoom
            ];
            // consider context tap
            var cxtDistThreshold = 200;
            var cxtDistThresholdSq = cxtDistThreshold * cxtDistThreshold;
            if (distance1Sq < cxtDistThresholdSq && !e.touches[2]) {
                var near1 = r.findNearestElement(now[0], now[1], true, true);
                var near2 = r.findNearestElement(now[2], now[3], true, true);
                if (near1 && near1.isNode()) {
                    near1.activate().emit({
                        originalEvent: e,
                        type: 'cxttapstart',
                        position: {
                            x: now[0],
                            y: now[1]
                        }
                    });
                    r.touchData.start = near1;
                } else if (near2 && near2.isNode()) {
                    near2.activate().emit({
                        originalEvent: e,
                        type: 'cxttapstart',
                        position: {
                            x: now[0],
                            y: now[1]
                        }
                    });
                    r.touchData.start = near2;
                } else cy.emit({
                    originalEvent: e,
                    type: 'cxttapstart',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
                if (r.touchData.start) r.touchData.start._private.grabbed = false;
                r.touchData.cxt = true;
                r.touchData.cxtDragged = false;
                r.data.bgActivePosistion = undefined;
                r.redraw();
                return;
            }
        }
        if (e.touches[2]) // ignore
        // safari on ios pans the page otherwise (normally you should be able to preventdefault on touchmove...)
        {
            if (cy.boxSelectionEnabled()) e.preventDefault();
        } else if (e.touches[1]) ;
        else if (e.touches[0]) {
            var nears = r.findNearestElements(now[0], now[1], true, true);
            var near = nears[0];
            if (near != null) {
                near.activate();
                r.touchData.start = near;
                r.touchData.starts = nears;
                if (r.nodeIsGrabbable(near)) {
                    var draggedEles = r.dragData.touchDragEles = cy.collection();
                    var selectedNodes = null;
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                    if (near.selected()) {
                        // reset drag elements, since near will be added again
                        selectedNodes = cy.$(function(ele) {
                            return ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedEles
                        });
                    } else addNodeToDrag(near, {
                        addToList: draggedEles
                    });
                    setGrabTarget(near);
                    var makeEvent = function makeEvent(type) {
                        return {
                            originalEvent: e,
                            type: type,
                            position: {
                                x: now[0],
                                y: now[1]
                            }
                        };
                    };
                    near.emit(makeEvent('grabon'));
                    if (selectedNodes) selectedNodes.forEach(function(n) {
                        n.emit(makeEvent('grab'));
                    });
                    else near.emit(makeEvent('grab'));
                }
            }
            triggerEvents(near, [
                'touchstart',
                'tapstart',
                'vmousedown'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if (near == null) {
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            }
            // Tap, taphold
            // -----
            r.touchData.singleTouchMoved = false;
            r.touchData.singleTouchStartTime = +new Date();
            clearTimeout(r.touchData.tapholdTimeout);
            r.touchData.tapholdTimeout = setTimeout(function() {
                if (r.touchData.singleTouchMoved === false && !r.pinching // if pinching, then taphold unselect shouldn't take effect
                 && !r.touchData.selecting // box selection shouldn't allow taphold through
                ) triggerEvents(r.touchData.start, [
                    'taphold'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }, r.tapholdDuration);
        }
        if (e.touches.length >= 1) {
            var sPos = r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            for(var i = 0; i < now.length; i++)sPos[i] = earlier[i] = now[i];
            var touch0 = e.touches[0];
            r.touchData.startGPosition = [
                touch0.clientX,
                touch0.clientY
            ];
        }
    }, false);
    var touchmoveHandler;
    r.registerBinding(containerWindow, 'touchmove', touchmoveHandler = function touchmoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.touchData.capture;
        if (!capture && !eventInContainer(e)) return;
        var select = r.selection;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        var zoom = cy.zoom();
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var startGPos = r.touchData.startGPosition;
        var isOverThresholdDrag;
        if (capture && e.touches[0] && startGPos) {
            var disp = [];
            for(var j = 0; j < now.length; j++)disp[j] = now[j] - earlier[j];
            var dx = e.touches[0].clientX - startGPos[0];
            var dx2 = dx * dx;
            var dy = e.touches[0].clientY - startGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            isOverThresholdDrag = dist2 >= r.touchTapThreshold2;
        }
        // context swipe cancelling
        if (capture && r.touchData.cxt) {
            e.preventDefault();
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            // var distance2 = distance( f1x2, f1y2, f2x2, f2y2 );
            var distance2Sq = distanceSq(f1x2, f1y2, f2x2, f2y2);
            var factorSq = distance2Sq / distance1Sq;
            var distThreshold = 150;
            var distThresholdSq = distThreshold * distThreshold;
            var factorThreshold = 1.5;
            var factorThresholdSq = factorThreshold * factorThreshold;
            // cancel ctx gestures if the distance b/t the fingers increases
            if (factorSq >= factorThresholdSq || distance2Sq >= distThresholdSq) {
                r.touchData.cxt = false;
                r.data.bgActivePosistion = undefined;
                r.redrawHint('select', true);
                var cxtEvt = {
                    originalEvent: e,
                    type: 'cxttapend',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                };
                if (r.touchData.start) {
                    r.touchData.start.unactivate().emit(cxtEvt);
                    r.touchData.start = null;
                } else cy.emit(cxtEvt);
            }
        }
        // context swipe
        if (capture && r.touchData.cxt) {
            var cxtEvt = {
                originalEvent: e,
                type: 'cxtdrag',
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            if (r.touchData.start) r.touchData.start.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxtDragged = true;
            var near = r.findNearestElement(now[0], now[1], true, true);
            if (!r.touchData.cxtOver || near !== r.touchData.cxtOver) {
                if (r.touchData.cxtOver) r.touchData.cxtOver.emit({
                    originalEvent: e,
                    type: 'cxtdragout',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
                r.touchData.cxtOver = near;
                if (near) near.emit({
                    originalEvent: e,
                    type: 'cxtdragover',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
            }
        // box selection
        } else if (capture && e.touches[2] && cy.boxSelectionEnabled()) {
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            this.lastThreeTouch = +new Date();
            if (!r.touchData.selecting) cy.emit({
                originalEvent: e,
                type: 'boxstart',
                position: {
                    x: now[0],
                    y: now[1]
                }
            });
            r.touchData.selecting = true;
            r.touchData.didSelect = true;
            select[4] = 1;
            if (!select || select.length === 0 || select[0] === undefined) {
                select[0] = (now[0] + now[2] + now[4]) / 3;
                select[1] = (now[1] + now[3] + now[5]) / 3;
                select[2] = (now[0] + now[2] + now[4]) / 3 + 1;
                select[3] = (now[1] + now[3] + now[5]) / 3 + 1;
            } else {
                select[2] = (now[0] + now[2] + now[4]) / 3;
                select[3] = (now[1] + now[3] + now[5]) / 3;
            }
            r.redrawHint('select', true);
            r.redraw();
        // pinch to zoom
        } else if (capture && e.touches[1] && !r.touchData.didSelect // don't allow box selection to degrade to pinch-to-zoom
         && cy.zoomingEnabled() && cy.panningEnabled() && cy.userZoomingEnabled() && cy.userPanningEnabled()) {
            // two fingers => pinch to zoom
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (draggedEles) {
                r.redrawHint('drag', true);
                for(var i = 0; i < draggedEles.length; i++){
                    var de_p = draggedEles[i]._private;
                    de_p.grabbed = false;
                    de_p.rscratch.inDragLayer = false;
                }
            }
            var _start = r.touchData.start;
            // (x2, y2) for fingers 1 and 2
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            var distance2 = distance(f1x2, f1y2, f2x2, f2y2);
            // var distance2Sq = distanceSq( f1x2, f1y2, f2x2, f2y2 );
            // var factor = Math.sqrt( distance2Sq ) / Math.sqrt( distance1Sq );
            var factor = distance2 / distance1;
            if (twoFingersStartInside) {
                // delta finger1
                var df1x = f1x2 - f1x1;
                var df1y = f1y2 - f1y1;
                // delta finger 2
                var df2x = f2x2 - f2x1;
                var df2y = f2y2 - f2y1;
                // translation is the normalised vector of the two fingers movement
                // i.e. so pinching cancels out and moving together pans
                var tx = (df1x + df2x) / 2;
                var ty = (df1y + df2y) / 2;
                // now calculate the zoom
                var zoom1 = cy.zoom();
                var zoom2 = zoom1 * factor;
                var pan1 = cy.pan();
                // the model center point converted to the current rendered pos
                var ctrx = modelCenter1[0] * zoom1 + pan1.x;
                var ctry = modelCenter1[1] * zoom1 + pan1.y;
                var pan2 = {
                    x: -zoom2 / zoom1 * (ctrx - pan1.x - tx) + ctrx,
                    y: -zoom2 / zoom1 * (ctry - pan1.y - ty) + ctry
                };
                // remove dragged eles
                if (_start && _start.active()) {
                    var draggedEles = r.dragData.touchDragEles;
                    freeDraggedElements(draggedEles);
                    r.redrawHint('drag', true);
                    r.redrawHint('eles', true);
                    _start.unactivate().emit('freeon');
                    draggedEles.emit('free');
                    if (r.dragData.didDrag) {
                        _start.emit('dragfreeon');
                        draggedEles.emit('dragfree');
                    }
                }
                cy.viewport({
                    zoom: zoom2,
                    pan: pan2,
                    cancelOnFailedZoom: true
                });
                cy.emit('pinchzoom');
                distance1 = distance2;
                f1x1 = f1x2;
                f1y1 = f1y2;
                f2x1 = f2x2;
                f2y1 = f2y2;
                r.pinching = true;
            }
            // Re-project
            if (e.touches[0]) {
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
            if (e.touches[1]) {
                var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
                now[2] = pos[0];
                now[3] = pos[1];
            }
            if (e.touches[2]) {
                var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
                now[4] = pos[0];
                now[5] = pos[1];
            }
        } else if (e.touches[0] && !r.touchData.didSelect // don't allow box selection to degrade to single finger events like panning
        ) {
            var start = r.touchData.start;
            var last = r.touchData.last;
            var near;
            if (!r.hoverData.draggingEles && !r.swipePanning) near = r.findNearestElement(now[0], now[1], true, true);
            if (capture && start != null) e.preventDefault();
            // dragging nodes
            if (capture && start != null && r.nodeIsDraggable(start)) {
                if (isOverThresholdDrag) {
                    // then dragging can happen
                    var draggedEles = r.dragData.touchDragEles;
                    var justStartedDrag = !r.dragData.didDrag;
                    if (justStartedDrag) addNodesToDrag(draggedEles, {
                        inDragLayer: true
                    });
                    r.dragData.didDrag = true;
                    var totalShift = {
                        x: 0,
                        y: 0
                    };
                    if (number$1(disp[0]) && number$1(disp[1])) {
                        totalShift.x += disp[0];
                        totalShift.y += disp[1];
                        if (justStartedDrag) {
                            r.redrawHint('eles', true);
                            var dragDelta = r.touchData.dragDelta;
                            if (dragDelta && number$1(dragDelta[0]) && number$1(dragDelta[1])) {
                                totalShift.x += dragDelta[0];
                                totalShift.y += dragDelta[1];
                            }
                        }
                    }
                    r.hoverData.draggingEles = true;
                    draggedEles.silentShift(totalShift).emit('position drag');
                    r.redrawHint('drag', true);
                    if (r.touchData.startPosition[0] == earlier[0] && r.touchData.startPosition[1] == earlier[1]) r.redrawHint('eles', true);
                    r.redraw();
                } else {
                    // otherwise keep track of drag delta for later
                    var dragDelta = r.touchData.dragDelta = r.touchData.dragDelta || [];
                    if (dragDelta.length === 0) {
                        dragDelta.push(disp[0]);
                        dragDelta.push(disp[1]);
                    } else {
                        dragDelta[0] += disp[0];
                        dragDelta[1] += disp[1];
                    }
                }
            }
            triggerEvents(start || near, [
                'touchmove',
                'tapdrag',
                'vmousemove'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if ((!start || !start.grabbed()) && near != last) {
                if (last) last.emit({
                    originalEvent: e,
                    type: 'tapdragout',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
                if (near) near.emit({
                    originalEvent: e,
                    type: 'tapdragover',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                });
            }
            r.touchData.last = near;
            // check to cancel taphold
            if (capture) {
                for(var i = 0; i < now.length; i++)if (now[i] && r.touchData.startPosition[i] && isOverThresholdDrag) r.touchData.singleTouchMoved = true;
            }
            // panning
            if (capture && (start == null || start.pannable()) && cy.panningEnabled() && cy.userPanningEnabled()) {
                var allowPassthrough = allowPanningPassthrough(start, r.touchData.starts);
                if (allowPassthrough) {
                    e.preventDefault();
                    if (!r.data.bgActivePosistion) r.data.bgActivePosistion = array2point(r.touchData.startPosition);
                    if (r.swipePanning) {
                        cy.panBy({
                            x: disp[0] * zoom,
                            y: disp[1] * zoom
                        });
                        cy.emit('dragpan');
                    } else if (isOverThresholdDrag) {
                        r.swipePanning = true;
                        cy.panBy({
                            x: dx * zoom,
                            y: dy * zoom
                        });
                        cy.emit('dragpan');
                        if (start) {
                            start.unactivate();
                            r.redrawHint('select', true);
                            r.touchData.start = null;
                        }
                    }
                }
                // Re-project
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        // the active bg indicator should be removed when making a swipe that is neither for dragging nodes or panning
        if (capture && e.touches.length > 0 && !r.hoverData.draggingEles && !r.swipePanning && r.data.bgActivePosistion != null) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            r.redraw();
        }
    }, false);
    var touchcancelHandler;
    r.registerBinding(containerWindow, 'touchcancel', touchcancelHandler = function touchcancelHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        r.touchData.capture = false;
        if (start) start.unactivate();
    });
    var touchendHandler, didDoubleTouch, touchTimeout, prevTouchTimeStamp;
    r.registerBinding(containerWindow, 'touchend', touchendHandler = function touchendHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        var capture = r.touchData.capture;
        if (capture) {
            if (e.touches.length === 0) r.touchData.capture = false;
            e.preventDefault();
        } else return;
        var select = r.selection;
        r.swipePanning = false;
        r.hoverData.draggingEles = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        if (start) start.unactivate();
        var ctxTapend;
        if (r.touchData.cxt) {
            ctxTapend = {
                originalEvent: e,
                type: 'cxttapend',
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
            if (start) start.emit(ctxTapend);
            else cy.emit(ctxTapend);
            if (!r.touchData.cxtDragged) {
                var ctxTap = {
                    originalEvent: e,
                    type: 'cxttap',
                    position: {
                        x: now[0],
                        y: now[1]
                    }
                };
                if (start) start.emit(ctxTap);
                else cy.emit(ctxTap);
            }
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxt = false;
            r.touchData.start = null;
            r.redraw();
            return;
        }
        // no more box selection if we don't have three fingers
        if (!e.touches[2] && cy.boxSelectionEnabled() && r.touchData.selecting) {
            r.touchData.selecting = false;
            var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
            select[0] = undefined;
            select[1] = undefined;
            select[2] = undefined;
            select[3] = undefined;
            select[4] = 0;
            r.redrawHint('select', true);
            cy.emit({
                type: 'boxend',
                originalEvent: e,
                position: {
                    x: now[0],
                    y: now[1]
                }
            });
            var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                return ele.selectable() && !ele.selected();
            };
            box.emit('box').stdFilter(eleWouldBeSelected).select().emit('boxselect');
            if (box.nonempty()) r.redrawHint('eles', true);
            r.redraw();
        }
        if (start != null) start.unactivate();
        if (e.touches[2]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
        } else if (e.touches[1]) ;
        else if (e.touches[0]) ;
        else if (!e.touches[0]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (start != null) {
                var startWasGrabbed = start._private.grabbed;
                freeDraggedElements(draggedEles);
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                if (startWasGrabbed) {
                    start.emit('freeon');
                    draggedEles.emit('free');
                    if (r.dragData.didDrag) {
                        start.emit('dragfreeon');
                        draggedEles.emit('dragfree');
                    }
                }
                triggerEvents(start, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                start.unactivate();
                r.touchData.start = null;
            } else {
                var near = r.findNearestElement(now[0], now[1], true, true);
                triggerEvents(near, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }
            var dx = r.touchData.startPosition[0] - now[0];
            var dx2 = dx * dx;
            var dy = r.touchData.startPosition[1] - now[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            var rdist2 = dist2 * zoom * zoom;
            // Tap event, roughly same as mouse click event for touch
            if (!r.touchData.singleTouchMoved) {
                if (!start) cy.$(':selected').unselect([
                    'tapunselect'
                ]);
                triggerEvents(start, [
                    'tap',
                    'vclick'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                didDoubleTouch = false;
                if (e.timeStamp - prevTouchTimeStamp <= cy.multiClickDebounceTime()) {
                    touchTimeout && clearTimeout(touchTimeout);
                    didDoubleTouch = true;
                    prevTouchTimeStamp = null;
                    triggerEvents(start, [
                        'dbltap',
                        'vdblclick'
                    ], e, {
                        x: now[0],
                        y: now[1]
                    });
                } else {
                    touchTimeout = setTimeout(function() {
                        if (didDoubleTouch) return;
                        triggerEvents(start, [
                            'onetap',
                            'voneclick'
                        ], e, {
                            x: now[0],
                            y: now[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevTouchTimeStamp = e.timeStamp;
                }
            }
            // Prepare to select the currently touched node, only if it hasn't been dragged past a certain distance
            if (start != null && !r.dragData.didDrag // didn't drag nodes around
             && start._private.selectable && rdist2 < r.touchTapThreshold2 && !r.pinching // pinch to zoom should not affect selection
            ) {
                if (cy.selectionType() === 'single') {
                    cy.$(isSelected).unmerge(start).unselect([
                        'tapunselect'
                    ]);
                    start.select([
                        'tapselect'
                    ]);
                } else if (start.selected()) start.unselect([
                    'tapunselect'
                ]);
                else start.select([
                    'tapselect'
                ]);
                r.redrawHint('eles', true);
            }
            r.touchData.singleTouchMoved = true;
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        r.dragData.didDrag = false; // reset for next touchstart
        if (e.touches.length === 0) {
            r.touchData.dragDelta = [];
            r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            r.touchData.startGPosition = null;
            r.touchData.didSelect = false;
        }
        if (e.touches.length < 2) {
            if (e.touches.length === 1) // the old start global pos'n may not be the same finger that remains
            r.touchData.startGPosition = [
                e.touches[0].clientX,
                e.touches[0].clientY
            ];
            r.pinching = false;
            r.redrawHint('eles', true);
            r.redraw();
        }
    //r.redraw();
    }, false);
    // fallback compatibility layer for ms pointer events
    if (typeof TouchEvent === 'undefined') {
        var pointers = [];
        var makeTouch = function makeTouch(e) {
            return {
                clientX: e.clientX,
                clientY: e.clientY,
                force: 1,
                identifier: e.pointerId,
                pageX: e.pageX,
                pageY: e.pageY,
                radiusX: e.width / 2,
                radiusY: e.height / 2,
                screenX: e.screenX,
                screenY: e.screenY,
                target: e.target
            };
        };
        var makePointer = function makePointer(e) {
            return {
                event: e,
                touch: makeTouch(e)
            };
        };
        var addPointer = function addPointer(e) {
            pointers.push(makePointer(e));
        };
        var removePointer = function removePointer(e) {
            for(var i = 0; i < pointers.length; i++){
                var p = pointers[i];
                if (p.event.pointerId === e.pointerId) {
                    pointers.splice(i, 1);
                    return;
                }
            }
        };
        var updatePointer = function updatePointer(e) {
            var p = pointers.filter(function(p) {
                return p.event.pointerId === e.pointerId;
            })[0];
            p.event = e;
            p.touch = makeTouch(e);
        };
        var addTouchesToEvent = function addTouchesToEvent(e) {
            e.touches = pointers.map(function(p) {
                return p.touch;
            });
        };
        var pointerIsMouse = function pointerIsMouse(e) {
            return e.pointerType === 'mouse' || e.pointerType === 4;
        };
        r.registerBinding(r.container, 'pointerdown', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            addPointer(e);
            addTouchesToEvent(e);
            touchstartHandler(e);
        });
        r.registerBinding(r.container, 'pointerup', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchendHandler(e);
        });
        r.registerBinding(r.container, 'pointercancel', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchcancelHandler(e);
        });
        r.registerBinding(r.container, 'pointermove', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            updatePointer(e);
            addTouchesToEvent(e);
            touchmoveHandler(e);
        });
    }
};
var BRp$2 = {};
BRp$2.generatePolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl('polygon', context, centerX, centerY, width, height, this.points);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return polygonIntersectLine(x, y, this.points, nodeX, nodeY, width / 2, height / 2, padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return pointInsidePolygon(x, y, this.points, centerX, centerY, width, height, [
                0,
                -1
            ], padding);
        }
    };
};
BRp$2.generateEllipse = function() {
    return this.nodeShapes['ellipse'] = {
        renderer: this,
        name: 'ellipse',
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return intersectLineEllipse(x, y, nodeX, nodeY, width / 2 + padding, height / 2 + padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return checkInEllipse(x, y, width, height, centerX, centerY, padding);
        }
    };
};
BRp$2.generateRoundPolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        getOrCreateCorners: function getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, field) {
            if (rs[field] !== undefined && rs[field + '-cx'] === centerX && rs[field + '-cy'] === centerY) return rs[field];
            rs[field] = new Array(points.length / 2);
            rs[field + '-cx'] = centerX;
            rs[field + '-cy'] = centerY;
            var halfW = width / 2;
            var halfH = height / 2;
            cornerRadius = cornerRadius === 'auto' ? getRoundPolygonRadius(width, height) : cornerRadius;
            var p = new Array(points.length / 2);
            for(var _i = 0; _i < points.length / 2; _i++)p[_i] = {
                x: centerX + halfW * points[_i * 2],
                y: centerY + halfH * points[_i * 2 + 1]
            };
            var i, p1, p2, p3, len = p.length;
            p1 = p[len - 1];
            // for each point
            for(i = 0; i < len; i++){
                p2 = p[i % len];
                p3 = p[(i + 1) % len];
                rs[field][i] = getRoundCorner(p1, p2, p3, cornerRadius);
                p1 = p2;
                p2 = p3;
            }
            return rs[field];
        },
        draw: function draw(context, centerX, centerY, width, height, cornerRadius, rs) {
            this.renderer.nodeShapeImpl('round-polygon', context, centerX, centerY, width, height, this.points, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'drawCorners'));
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius, rs) {
            return roundPolygonIntersectLine(x, y, this.points, nodeX, nodeY, width, height, padding, this.getOrCreateCorners(nodeX, nodeY, width, height, cornerRadius, rs, 'corners'));
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius, rs) {
            return pointInsideRoundPolygon(x, y, this.points, centerX, centerY, width, height, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'corners'));
        }
    };
};
BRp$2.generateRoundRectangle = function() {
    return this.nodeShapes['round-rectangle'] = this.nodeShapes['roundrectangle'] = {
        renderer: this,
        name: 'round-rectangle',
        points: generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            cornerRadius = cornerRadius === 'auto' ? getRoundRectangleRadius(width, height) : cornerRadius;
            cornerRadius = Math.min(halfWidth, halfHeight, cornerRadius);
            var diam = cornerRadius * 2;
            // Check hBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // Check top left quarter circle
            if (checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check top right quarter circle
            if (checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check bottom right quarter circle
            if (checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if (checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            return false;
        }
    };
};
BRp$2.generateCutRectangle = function() {
    return this.nodeShapes['cut-rectangle'] = this.nodeShapes['cutrectangle'] = {
        renderer: this,
        name: 'cut-rectangle',
        cornerLength: getCutRectangleCornerLength(),
        points: generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, null, cornerRadius);
        },
        generateCutTrianglePts: function generateCutTrianglePts(width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            // points are in clockwise order, inner (imaginary) triangle pt on [4, 5]
            return {
                topLeft: [
                    xBegin,
                    yBegin + cl,
                    xBegin + cl,
                    yBegin,
                    xBegin + cl,
                    yBegin + cl
                ],
                topRight: [
                    xEnd - cl,
                    yBegin,
                    xEnd,
                    yBegin + cl,
                    xEnd - cl,
                    yBegin + cl
                ],
                bottomRight: [
                    xEnd,
                    yEnd - cl,
                    xEnd - cl,
                    yEnd,
                    xEnd - cl,
                    yEnd - cl
                ],
                bottomLeft: [
                    xBegin + cl,
                    yEnd,
                    xBegin,
                    yEnd - cl,
                    xBegin + cl,
                    yEnd - cl
                ]
            };
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var cPts = this.generateCutTrianglePts(width + 2 * padding, height + 2 * padding, nodeX, nodeY, cornerRadius);
            var pts = [].concat.apply([], [
                cPts.topLeft.splice(0, 4),
                cPts.topRight.splice(0, 4),
                cPts.bottomRight.splice(0, 4),
                cPts.bottomLeft.splice(0, 4)
            ]);
            return polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            // Check hBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * cl, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * cl, height, [
                0,
                -1
            ], padding)) return true;
            var cutTrianglePts = this.generateCutTrianglePts(width, height, centerX, centerY);
            return pointInsidePolygonPoints(x, y, cutTrianglePts.topLeft) || pointInsidePolygonPoints(x, y, cutTrianglePts.topRight) || pointInsidePolygonPoints(x, y, cutTrianglePts.bottomRight) || pointInsidePolygonPoints(x, y, cutTrianglePts.bottomLeft);
        }
    };
};
BRp$2.generateBarrel = function() {
    return this.nodeShapes['barrel'] = {
        renderer: this,
        name: 'barrel',
        points: generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            // use two fixed t values for the bezier curve approximation
            var t0 = 0.15;
            var t1 = 0.5;
            var t2 = 0.85;
            var bPts = this.generateBarrelBezierPts(width + 2 * padding, height + 2 * padding, nodeX, nodeY);
            var approximateBarrelCurvePts = function approximateBarrelCurvePts(pts) {
                // approximate curve pts based on the two t values
                var m0 = qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t0);
                var m1 = qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t1);
                var m2 = qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t2);
                return [
                    pts[0],
                    pts[1],
                    m0.x,
                    m0.y,
                    m1.x,
                    m1.y,
                    m2.x,
                    m2.y,
                    pts[4],
                    pts[5]
                ];
            };
            var pts = [].concat(approximateBarrelCurvePts(bPts.topLeft), approximateBarrelCurvePts(bPts.topRight), approximateBarrelCurvePts(bPts.bottomRight), approximateBarrelCurvePts(bPts.bottomLeft));
            return polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        generateBarrelBezierPts: function generateBarrelBezierPts(width, height, centerX, centerY) {
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            var curveConstants = getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            var ctrlPtXOffset = curveConstants.ctrlPtOffsetPct * width;
            // points are in clockwise order, inner (imaginary) control pt on [4, 5]
            var pts = {
                topLeft: [
                    xBegin,
                    yBegin + hOffset,
                    xBegin + ctrlPtXOffset,
                    yBegin,
                    xBegin + wOffset,
                    yBegin
                ],
                topRight: [
                    xEnd - wOffset,
                    yBegin,
                    xEnd - ctrlPtXOffset,
                    yBegin,
                    xEnd,
                    yBegin + hOffset
                ],
                bottomRight: [
                    xEnd,
                    yEnd - hOffset,
                    xEnd - ctrlPtXOffset,
                    yEnd,
                    xEnd - wOffset,
                    yEnd
                ],
                bottomLeft: [
                    xBegin + wOffset,
                    yEnd,
                    xBegin + ctrlPtXOffset,
                    yEnd,
                    xBegin,
                    yEnd - hOffset
                ]
            };
            pts.topLeft.isTop = true;
            pts.topRight.isTop = true;
            pts.bottomLeft.isBottom = true;
            pts.bottomRight.isBottom = true;
            return pts;
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var curveConstants = getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            // Check hBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * hOffset, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * wOffset, height, [
                0,
                -1
            ], padding)) return true;
            var barrelCurvePts = this.generateBarrelBezierPts(width, height, centerX, centerY);
            var getCurveT = function getCurveT(x, y, curvePts) {
                var x0 = curvePts[4];
                var x1 = curvePts[2];
                var x2 = curvePts[0];
                var y0 = curvePts[5];
                // var y1 = curvePts[ 3 ];
                var y2 = curvePts[1];
                var xMin = Math.min(x0, x2);
                var xMax = Math.max(x0, x2);
                var yMin = Math.min(y0, y2);
                var yMax = Math.max(y0, y2);
                if (xMin <= x && x <= xMax && yMin <= y && y <= yMax) {
                    var coeff = bezierPtsToQuadCoeff(x0, x1, x2);
                    var roots = solveQuadratic(coeff[0], coeff[1], coeff[2], x);
                    var validRoots = roots.filter(function(r) {
                        return 0 <= r && r <= 1;
                    });
                    if (validRoots.length > 0) return validRoots[0];
                }
                return null;
            };
            var curveRegions = Object.keys(barrelCurvePts);
            for(var i = 0; i < curveRegions.length; i++){
                var corner = curveRegions[i];
                var cornerPts = barrelCurvePts[corner];
                var t = getCurveT(x, y, cornerPts);
                if (t == null) continue;
                var y0 = cornerPts[5];
                var y1 = cornerPts[3];
                var y2 = cornerPts[1];
                var bezY = qbezierAt(y0, y1, y2, t);
                if (cornerPts.isTop && bezY <= y) return true;
                if (cornerPts.isBottom && y <= bezY) return true;
            }
            return false;
        }
    };
};
BRp$2.generateBottomRoundrectangle = function() {
    return this.nodeShapes['bottom-round-rectangle'] = this.nodeShapes['bottomroundrectangle'] = {
        renderer: this,
        name: 'bottom-round-rectangle',
        points: generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var topStartX = nodeX - (width / 2 + padding);
            var topStartY = nodeY - (height / 2 + padding);
            var topEndY = topStartY;
            var topEndX = nodeX + (width / 2 + padding);
            var topIntersections = finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
            if (topIntersections.length > 0) return topIntersections;
            return roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            cornerRadius = cornerRadius === 'auto' ? getRoundRectangleRadius(width, height) : cornerRadius;
            var diam = 2 * cornerRadius;
            // Check hBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if (pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // check non-rounded top side
            var outerWidth = width / 2 + 2 * padding;
            var outerHeight = height / 2 + 2 * padding;
            var points = [
                centerX - outerWidth,
                centerY - outerHeight,
                centerX - outerWidth,
                centerY,
                centerX + outerWidth,
                centerY,
                centerX + outerWidth,
                centerY - outerHeight
            ];
            if (pointInsidePolygonPoints(x, y, points)) return true;
            // Check bottom right quarter circle
            if (checkInEllipse(x, y, diam, diam, centerX + width / 2 - cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if (checkInEllipse(x, y, diam, diam, centerX - width / 2 + cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            return false;
        }
    };
};
BRp$2.registerNodeShapes = function() {
    var nodeShapes = this.nodeShapes = {};
    var renderer = this;
    this.generateEllipse();
    this.generatePolygon('triangle', generateUnitNgonPointsFitToSquare(3, 0));
    this.generateRoundPolygon('round-triangle', generateUnitNgonPointsFitToSquare(3, 0));
    this.generatePolygon('rectangle', generateUnitNgonPointsFitToSquare(4, 0));
    nodeShapes['square'] = nodeShapes['rectangle'];
    this.generateRoundRectangle();
    this.generateCutRectangle();
    this.generateBarrel();
    this.generateBottomRoundrectangle();
    var diamondPoints = [
        0,
        1,
        1,
        0,
        0,
        -1,
        -1,
        0
    ];
    this.generatePolygon('diamond', diamondPoints);
    this.generateRoundPolygon('round-diamond', diamondPoints);
    this.generatePolygon('pentagon', generateUnitNgonPointsFitToSquare(5, 0));
    this.generateRoundPolygon('round-pentagon', generateUnitNgonPointsFitToSquare(5, 0));
    this.generatePolygon('hexagon', generateUnitNgonPointsFitToSquare(6, 0));
    this.generateRoundPolygon('round-hexagon', generateUnitNgonPointsFitToSquare(6, 0));
    this.generatePolygon('heptagon', generateUnitNgonPointsFitToSquare(7, 0));
    this.generateRoundPolygon('round-heptagon', generateUnitNgonPointsFitToSquare(7, 0));
    this.generatePolygon('octagon', generateUnitNgonPointsFitToSquare(8, 0));
    this.generateRoundPolygon('round-octagon', generateUnitNgonPointsFitToSquare(8, 0));
    var star5Points = new Array(20);
    var outerPoints = generateUnitNgonPoints(5, 0);
    var innerPoints = generateUnitNgonPoints(5, Math.PI / 5);
    // Outer radius is 1; inner radius of star is smaller
    var innerRadius = 0.5 * (3 - Math.sqrt(5));
    innerRadius *= 1.57;
    for(var i = 0; i < innerPoints.length / 2; i++){
        innerPoints[i * 2] *= innerRadius;
        innerPoints[i * 2 + 1] *= innerRadius;
    }
    for(var i = 0; i < 5; i++){
        star5Points[i * 4] = outerPoints[i * 2];
        star5Points[i * 4 + 1] = outerPoints[i * 2 + 1];
        star5Points[i * 4 + 2] = innerPoints[i * 2];
        star5Points[i * 4 + 3] = innerPoints[i * 2 + 1];
    }
    star5Points = fitPolygonToSquare(star5Points);
    this.generatePolygon('star', star5Points);
    this.generatePolygon('vee', [
        -1,
        -1,
        0,
        -0.333,
        1,
        -1,
        0,
        1
    ]);
    this.generatePolygon('rhomboid', [
        -1,
        -1,
        0.333,
        -1,
        1,
        1,
        -0.333,
        1
    ]);
    this.generatePolygon('right-rhomboid', [
        -0.333,
        -1,
        1,
        -1,
        0.333,
        1,
        -1,
        1
    ]);
    this.nodeShapes['concavehexagon'] = this.generatePolygon('concave-hexagon', [
        -1,
        -0.95,
        -0.75,
        0,
        -1,
        0.95,
        1,
        0.95,
        0.75,
        0,
        1,
        -0.95
    ]);
    var tagPoints = [
        -1,
        -1,
        0.25,
        -1,
        1,
        0,
        0.25,
        1,
        -1,
        1
    ];
    this.generatePolygon('tag', tagPoints);
    this.generateRoundPolygon('round-tag', tagPoints);
    nodeShapes.makePolygon = function(points) {
        // use caching on user-specified polygons so they are as fast as native shapes
        var key = points.join('$');
        var name = 'polygon-' + key;
        var shape;
        if (shape = this[name]) // got cached shape
        return shape;
        // create and cache new shape
        return renderer.generatePolygon(name, points);
    };
};
var BRp$1 = {};
BRp$1.timeToRender = function() {
    return this.redrawTotalTime / this.redrawCount;
};
BRp$1.redraw = function(options) {
    options = options || staticEmptyObject();
    var r = this;
    if (r.averageRedrawTime === undefined) r.averageRedrawTime = 0;
    if (r.lastRedrawTime === undefined) r.lastRedrawTime = 0;
    if (r.lastDrawTime === undefined) r.lastDrawTime = 0;
    r.requestedFrame = true;
    r.renderOptions = options;
};
BRp$1.beforeRender = function(fn, priority) {
    // the renderer can't add tick callbacks when destroyed
    if (this.destroyed) return;
    if (priority == null) error('Priority is not optional for beforeRender');
    var cbs = this.beforeRenderCallbacks;
    cbs.push({
        fn: fn,
        priority: priority
    });
    // higher priority callbacks executed first
    cbs.sort(function(a, b) {
        return b.priority - a.priority;
    });
};
var beforeRenderCallbacks = function beforeRenderCallbacks(r, willDraw, startTime) {
    var cbs = r.beforeRenderCallbacks;
    for(var i = 0; i < cbs.length; i++)cbs[i].fn(willDraw, startTime);
};
BRp$1.startRenderLoop = function() {
    var r = this;
    var cy = r.cy;
    if (r.renderLoopStarted) return;
    else r.renderLoopStarted = true;
    var _renderFn = function renderFn(requestTime) {
        if (r.destroyed) return;
        if (cy.batching()) ;
        else if (r.requestedFrame && !r.skipFrame) {
            beforeRenderCallbacks(r, true, requestTime);
            var startTime = performanceNow();
            r.render(r.renderOptions);
            var endTime = r.lastDrawTime = performanceNow();
            if (r.averageRedrawTime === undefined) r.averageRedrawTime = endTime - startTime;
            if (r.redrawCount === undefined) r.redrawCount = 0;
            r.redrawCount++;
            if (r.redrawTotalTime === undefined) r.redrawTotalTime = 0;
            var duration = endTime - startTime;
            r.redrawTotalTime += duration;
            r.lastRedrawTime = duration;
            // use a weighted average with a bias from the previous average so we don't spike so easily
            r.averageRedrawTime = r.averageRedrawTime / 2 + duration / 2;
            r.requestedFrame = false;
        } else beforeRenderCallbacks(r, false, requestTime);
        r.skipFrame = false;
        requestAnimationFrame(_renderFn);
    };
    requestAnimationFrame(_renderFn);
};
var BaseRenderer = function BaseRenderer(options) {
    this.init(options);
};
var BR = BaseRenderer;
var BRp = BR.prototype;
BRp.clientFunctions = [
    'redrawHint',
    'render',
    'renderTo',
    'matchCanvasSize',
    'nodeShapeImpl',
    'arrowShapeImpl'
];
BRp.init = function(options) {
    var r = this;
    r.options = options;
    r.cy = options.cy;
    var ctr = r.container = options.cy.container();
    var containerWindow = r.cy.window();
    // prepend a stylesheet in the head such that
    if (containerWindow) {
        var document1 = containerWindow.document;
        var head = document1.head;
        var stylesheetId = '__________cytoscape_stylesheet';
        var className = '__________cytoscape_container';
        var stylesheetAlreadyExists = document1.getElementById(stylesheetId) != null;
        if (ctr.className.indexOf(className) < 0) ctr.className = (ctr.className || '') + ' ' + className;
        if (!stylesheetAlreadyExists) {
            var stylesheet = document1.createElement('style');
            stylesheet.id = stylesheetId;
            stylesheet.textContent = '.' + className + ' { position: relative; }';
            head.insertBefore(stylesheet, head.children[0]); // first so lowest priority
        }
        var computedStyle = containerWindow.getComputedStyle(ctr);
        var position = computedStyle.getPropertyValue('position');
        if (position === 'static') warn('A Cytoscape container has style position:static and so can not use UI extensions properly');
    }
    r.selection = [
        undefined,
        undefined,
        undefined,
        undefined,
        0
    ]; // Coordinates for selection box, plus enabled flag
    r.bezierProjPcts = [
        0.05,
        0.225,
        0.4,
        0.5,
        0.6,
        0.775,
        0.95
    ];
    //--Pointer-related data
    r.hoverData = {
        down: null,
        last: null,
        downTime: null,
        triggerMode: null,
        dragging: false,
        initialPan: [
            null,
            null
        ],
        capture: false
    };
    r.dragData = {
        possibleDragElements: []
    };
    r.touchData = {
        start: null,
        capture: false,
        // These 3 fields related to tap, taphold events
        startPosition: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        singleTouchStartTime: null,
        singleTouchMoved: true,
        now: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        earlier: [
            null,
            null,
            null,
            null,
            null,
            null
        ]
    };
    r.redraws = 0;
    r.showFps = options.showFps;
    r.debug = options.debug;
    r.webgl = options.webgl;
    r.hideEdgesOnViewport = options.hideEdgesOnViewport;
    r.textureOnViewport = options.textureOnViewport;
    r.wheelSensitivity = options.wheelSensitivity;
    r.motionBlurEnabled = options.motionBlur; // on by default
    r.forcedPixelRatio = number$1(options.pixelRatio) ? options.pixelRatio : null;
    r.motionBlur = options.motionBlur; // for initial kick off
    r.motionBlurOpacity = options.motionBlurOpacity;
    r.motionBlurTransparency = 1 - r.motionBlurOpacity;
    r.motionBlurPxRatio = 1;
    r.mbPxRBlurry = 1; //0.8;
    r.minMbLowQualFrames = 4;
    r.fullQualityMb = false;
    r.clearedForMotionBlur = [];
    r.desktopTapThreshold = options.desktopTapThreshold;
    r.desktopTapThreshold2 = options.desktopTapThreshold * options.desktopTapThreshold;
    r.touchTapThreshold = options.touchTapThreshold;
    r.touchTapThreshold2 = options.touchTapThreshold * options.touchTapThreshold;
    r.tapholdDuration = 500;
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.beforeRenderPriorities = {
        // higher priority execs before lower one
        animations: 400,
        eleCalcs: 300,
        eleTxrDeq: 200,
        lyrTxrDeq: 150,
        lyrTxrSkip: 100
    };
    r.registerNodeShapes();
    r.registerArrowShapes();
    r.registerCalculationListeners();
};
BRp.notify = function(eventName, eles) {
    var r = this;
    var cy = r.cy;
    // the renderer can't be notified after it's destroyed
    if (this.destroyed) return;
    if (eventName === 'init') {
        r.load();
        return;
    }
    if (eventName === 'destroy') {
        r.destroy();
        return;
    }
    if (eventName === 'add' || eventName === 'remove' || eventName === 'move' && cy.hasCompoundNodes() || eventName === 'load' || eventName === 'zorder' || eventName === 'mount') r.invalidateCachedZSortedEles();
    if (eventName === 'viewport') r.redrawHint('select', true);
    if (eventName === 'gc') r.redrawHint('gc', true);
    if (eventName === 'load' || eventName === 'resize' || eventName === 'mount') {
        r.invalidateContainerClientCoordsCache();
        r.matchCanvasSize(r.container);
    }
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    this.startRenderLoop();
    this.redraw();
};
BRp.destroy = function() {
    var r = this;
    r.destroyed = true;
    r.cy.stopAnimationLoop();
    for(var i = 0; i < r.bindings.length; i++){
        var binding = r.bindings[i];
        var b = binding;
        var tgt = b.target;
        (tgt.off || tgt.removeEventListener).apply(tgt, b.args);
    }
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.onUpdateEleCalcsFns = [];
    if (r.removeObserver) r.removeObserver.disconnect();
    if (r.styleObserver) r.styleObserver.disconnect();
    if (r.resizeObserver) r.resizeObserver.disconnect();
    if (r.labelCalcDiv) try {
        document.body.removeChild(r.labelCalcDiv); // eslint-disable-line no-undef
    } catch (e) {
    // ie10 issue #1014
    }
};
BRp.isHeadless = function() {
    return false;
};
[
    BRp$f,
    BRp$5,
    BRp$4,
    BRp$3,
    BRp$2,
    BRp$1
].forEach(function(props) {
    extend(BRp, props);
});
var fullFpsTime = 1000 / 60; // assume 60 frames per second
var defs = {
    setupDequeueing: function setupDequeueing(opts) {
        return function setupDequeueingImpl() {
            var self1 = this;
            var r = this.renderer;
            if (self1.dequeueingSetup) return;
            else self1.dequeueingSetup = true;
            var queueRedraw = debounce(function() {
                r.redrawHint('eles', true);
                r.redrawHint('drag', true);
                r.redraw();
            }, opts.deqRedrawThreshold);
            var dequeue = function dequeue(willDraw, frameStartTime) {
                var startTime = performanceNow();
                var avgRenderTime = r.averageRedrawTime;
                var renderTime = r.lastRedrawTime;
                var deqd = [];
                var extent = r.cy.extent();
                var pixelRatio = r.getPixelRatio();
                // if we aren't in a tick that causes a draw, then the rendered style
                // queue won't automatically be flushed before dequeueing starts
                if (!willDraw) r.flushRenderedStyleQueue();
                while(true){
                    // eslint-disable-line no-constant-condition
                    var now = performanceNow();
                    var duration = now - startTime;
                    var frameDuration = now - frameStartTime;
                    if (renderTime < fullFpsTime) {
                        // if we're rendering faster than the ideal fps, then do dequeueing
                        // during all of the remaining frame time
                        var timeAvailable = fullFpsTime - (willDraw ? avgRenderTime : 0);
                        if (frameDuration >= opts.deqFastCost * timeAvailable) break;
                    } else {
                        if (willDraw) {
                            if (duration >= opts.deqCost * renderTime || duration >= opts.deqAvgCost * avgRenderTime) break;
                        } else if (frameDuration >= opts.deqNoDrawCost * fullFpsTime) break;
                    }
                    var thisDeqd = opts.deq(self1, pixelRatio, extent);
                    if (thisDeqd.length > 0) for(var i = 0; i < thisDeqd.length; i++)deqd.push(thisDeqd[i]);
                    else break;
                }
                // callbacks on dequeue
                if (deqd.length > 0) {
                    opts.onDeqd(self1, deqd);
                    if (!willDraw && opts.shouldRedraw(self1, deqd, pixelRatio, extent)) queueRedraw();
                }
            };
            var priority = opts.priority || noop$1;
            r.beforeRender(dequeue, priority(self1));
        };
    }
};
// Allows lookups for (ele, lvl) => cache.
// Uses keys so elements may share the same cache.
var ElementTextureCacheLookup = /*#__PURE__*/ function() {
    function ElementTextureCacheLookup(getKey) {
        var doesEleInvalidateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : falsify;
        _classCallCheck(this, ElementTextureCacheLookup);
        this.idsByKey = new Map$1();
        this.keyForId = new Map$1();
        this.cachesByLvl = new Map$1();
        this.lvls = [];
        this.getKey = getKey;
        this.doesEleInvalidateKey = doesEleInvalidateKey;
    }
    return _createClass(ElementTextureCacheLookup, [
        {
            key: "getIdsFor",
            value: function getIdsFor(key) {
                if (key == null) error("Can not get id list for null key");
                var idsByKey = this.idsByKey;
                var ids = this.idsByKey.get(key);
                if (!ids) {
                    ids = new Set$1();
                    idsByKey.set(key, ids);
                }
                return ids;
            }
        },
        {
            key: "addIdForKey",
            value: function addIdForKey(key, id) {
                if (key != null) this.getIdsFor(key).add(id);
            }
        },
        {
            key: "deleteIdForKey",
            value: function deleteIdForKey(key, id) {
                if (key != null) this.getIdsFor(key)["delete"](id);
            }
        },
        {
            key: "getNumberOfIdsForKey",
            value: function getNumberOfIdsForKey(key) {
                if (key == null) return 0;
                else return this.getIdsFor(key).size;
            }
        },
        {
            key: "updateKeyMappingFor",
            value: function updateKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var currKey = this.getKey(ele);
                this.deleteIdForKey(prevKey, id);
                this.addIdForKey(currKey, id);
                this.keyForId.set(id, currKey);
            }
        },
        {
            key: "deleteKeyMappingFor",
            value: function deleteKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                this.deleteIdForKey(prevKey, id);
                this.keyForId["delete"](id);
            }
        },
        {
            key: "keyHasChangedFor",
            value: function keyHasChangedFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var newKey = this.getKey(ele);
                return prevKey !== newKey;
            }
        },
        {
            key: "isInvalid",
            value: function isInvalid(ele) {
                return this.keyHasChangedFor(ele) || this.doesEleInvalidateKey(ele);
            }
        },
        {
            key: "getCachesAt",
            value: function getCachesAt(lvl) {
                var cachesByLvl = this.cachesByLvl, lvls = this.lvls;
                var caches = cachesByLvl.get(lvl);
                if (!caches) {
                    caches = new Map$1();
                    cachesByLvl.set(lvl, caches);
                    lvls.push(lvl);
                }
                return caches;
            }
        },
        {
            key: "getCache",
            value: function getCache(key, lvl) {
                return this.getCachesAt(lvl).get(key);
            }
        },
        {
            key: "get",
            value: function get(ele, lvl) {
                var key = this.getKey(ele);
                var cache = this.getCache(key, lvl);
                // getting for an element may need to add to the id list b/c eles can share keys
                if (cache != null) this.updateKeyMappingFor(ele);
                return cache;
            }
        },
        {
            key: "getForCachedKey",
            value: function getForCachedKey(ele, lvl) {
                var key = this.keyForId.get(ele.id()); // n.b. use cached key, not newly computed key
                var cache = this.getCache(key, lvl);
                return cache;
            }
        },
        {
            key: "hasCache",
            value: function hasCache(key, lvl) {
                return this.getCachesAt(lvl).has(key);
            }
        },
        {
            key: "has",
            value: function has(ele, lvl) {
                var key = this.getKey(ele);
                return this.hasCache(key, lvl);
            }
        },
        {
            key: "setCache",
            value: function setCache(key, lvl, cache) {
                cache.key = key;
                this.getCachesAt(lvl).set(key, cache);
            }
        },
        {
            key: "set",
            value: function set(ele, lvl, cache) {
                var key = this.getKey(ele);
                this.setCache(key, lvl, cache);
                this.updateKeyMappingFor(ele);
            }
        },
        {
            key: "deleteCache",
            value: function deleteCache(key, lvl) {
                this.getCachesAt(lvl)["delete"](key);
            }
        },
        {
            key: "delete",
            value: function _delete(ele, lvl) {
                var key = this.getKey(ele);
                this.deleteCache(key, lvl);
            }
        },
        {
            key: "invalidateKey",
            value: function invalidateKey(key) {
                var _this = this;
                this.lvls.forEach(function(lvl) {
                    return _this.deleteCache(key, lvl);
                });
            }
        },
        {
            key: "invalidate",
            value: function invalidate(ele) {
                var id = ele.id();
                var key = this.keyForId.get(id); // n.b. use stored key rather than current (potential key)
                this.deleteKeyMappingFor(ele);
                var entireKeyInvalidated = this.doesEleInvalidateKey(ele);
                if (entireKeyInvalidated) // clear mapping for current key
                this.invalidateKey(key);
                return entireKeyInvalidated || this.getNumberOfIdsForKey(key) === 0;
            }
        }
    ]);
}();
var minTxrH = 25; // the size of the texture cache for small height eles (special case)
var txrStepH = 50; // the min size of the regular cache, and the size it increases with each step up
var minLvl$1 = -4; // when scaling smaller than that we don't need to re-render
var maxLvl$1 = 3; // when larger than this scale just render directly (caching is not helpful)
var maxZoom$1 = 7.99; // beyond this zoom level, layered textures are not used
var eleTxrSpacing = 8; // spacing between elements on textures to avoid blitting overlaps
var defTxrWidth = 1024; // default/minimum texture width
var maxTxrW = 1024; // the maximum width of a texture
var maxTxrH = 1024; // the maximum height of a texture
var minUtility = 0.2; // if usage of texture is less than this, it is retired
var maxFullness = 0.8; // fullness of texture after which queue removal is checked
var maxFullnessChecks = 10; // dequeued after this many checks
var deqCost$1 = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var deqAvgCost$1 = 0.1; // % of add'l rendering cost compared to average overall redraw time
var deqNoDrawCost$1 = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var deqFastCost$1 = 0.9; // % of frame time to be used when >60fps
var deqRedrawThreshold$1 = 100; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var maxDeqSize$1 = 1; // number of eles to dequeue and render at higher texture in each batch
var getTxrReasons = {
    dequeue: 'dequeue',
    downscale: 'downscale',
    highQuality: 'highQuality'
};
var initDefaults = defaults$g({
    getKey: null,
    doesEleInvalidateKey: falsify,
    drawElement: null,
    getBoundingBox: null,
    getRotationPoint: null,
    getRotationOffset: null,
    isVisible: trueify,
    allowEdgeTxrCaching: true,
    allowParentTxrCaching: true
});
var ElementTextureCache = function ElementTextureCache(renderer, initOptions) {
    var self1 = this;
    self1.renderer = renderer;
    self1.onDequeues = [];
    var opts = initDefaults(initOptions);
    extend(self1, opts);
    self1.lookup = new ElementTextureCacheLookup(opts.getKey, opts.doesEleInvalidateKey);
    self1.setupDequeueing();
};
var ETCp = ElementTextureCache.prototype;
ETCp.reasons = getTxrReasons;
// the list of textures in which new subtextures for elements can be placed
ETCp.getTextureQueue = function(txrH) {
    var self1 = this;
    self1.eleImgCaches = self1.eleImgCaches || {};
    return self1.eleImgCaches[txrH] = self1.eleImgCaches[txrH] || [];
};
// the list of usused textures which can be recycled (in use in texture queue)
ETCp.getRetiredTextureQueue = function(txrH) {
    var self1 = this;
    var rtxtrQs = self1.eleImgCaches.retired = self1.eleImgCaches.retired || {};
    var rtxtrQ = rtxtrQs[txrH] = rtxtrQs[txrH] || [];
    return rtxtrQ;
};
// queue of element draw requests at different scale levels
ETCp.getElementQueue = function() {
    var self1 = this;
    var q = self1.eleCacheQueue = self1.eleCacheQueue || new Heap(function(a, b) {
        return b.reqs - a.reqs;
    });
    return q;
};
// queue of element draw requests at different scale levels (element id lookup)
ETCp.getElementKeyToQueue = function() {
    var self1 = this;
    var k2q = self1.eleKeyToCacheQueue = self1.eleKeyToCacheQueue || {};
    return k2q;
};
ETCp.getElement = function(ele, bb, pxRatio, lvl, reason) {
    var self1 = this;
    var r = this.renderer;
    var zoom = r.cy.zoom();
    var lookup = this.lookup;
    if (!bb || bb.w === 0 || bb.h === 0 || isNaN(bb.w) || isNaN(bb.h) || !ele.visible() || ele.removed()) return null;
    if (!self1.allowEdgeTxrCaching && ele.isEdge() || !self1.allowParentTxrCaching && ele.isParent()) return null;
    if (lvl == null) lvl = Math.ceil(log2(zoom * pxRatio));
    if (lvl < minLvl$1) lvl = minLvl$1;
    else if (zoom >= maxZoom$1 || lvl > maxLvl$1) return null;
    var scale = Math.pow(2, lvl);
    var eleScaledH = bb.h * scale;
    var eleScaledW = bb.w * scale;
    var scaledLabelShown = r.eleTextBiggerThanMin(ele, scale);
    if (!this.isVisible(ele, scaledLabelShown)) return null;
    var eleCache = lookup.get(ele, lvl);
    // if this get was on an unused/invalidated cache, then restore the texture usage metric
    if (eleCache && eleCache.invalidated) {
        eleCache.invalidated = false;
        eleCache.texture.invalidatedWidth -= eleCache.width;
    }
    if (eleCache) return eleCache;
    var txrH; // which texture height this ele belongs to
    if (eleScaledH <= minTxrH) txrH = minTxrH;
    else if (eleScaledH <= txrStepH) txrH = txrStepH;
    else txrH = Math.ceil(eleScaledH / txrStepH) * txrStepH;
    if (eleScaledH > maxTxrH || eleScaledW > maxTxrW) return null; // caching large elements is not efficient
    var txrQ = self1.getTextureQueue(txrH);
    // first try the second last one in case it has space at the end
    var txr = txrQ[txrQ.length - 2];
    var addNewTxr = function addNewTxr() {
        return self1.recycleTexture(txrH, eleScaledW) || self1.addTexture(txrH, eleScaledW);
    };
    // try the last one if there is no second last one
    if (!txr) txr = txrQ[txrQ.length - 1];
    // if the last one doesn't exist, we need a first one
    if (!txr) txr = addNewTxr();
    // if there's no room in the current texture, we need a new one
    if (txr.width - txr.usedWidth < eleScaledW) txr = addNewTxr();
    var scalableFrom = function scalableFrom(otherCache) {
        return otherCache && otherCache.scaledLabelShown === scaledLabelShown;
    };
    var deqing = reason && reason === getTxrReasons.dequeue;
    var highQualityReq = reason && reason === getTxrReasons.highQuality;
    var downscaleReq = reason && reason === getTxrReasons.downscale;
    var higherCache; // the nearest cache with a higher level
    for(var l = lvl + 1; l <= maxLvl$1; l++){
        var c = lookup.get(ele, l);
        if (c) {
            higherCache = c;
            break;
        }
    }
    var oneUpCache = higherCache && higherCache.level === lvl + 1 ? higherCache : null;
    var downscale = function downscale() {
        txr.context.drawImage(oneUpCache.texture.canvas, oneUpCache.x, 0, oneUpCache.width, oneUpCache.height, txr.usedWidth, 0, eleScaledW, eleScaledH);
    };
    // reset ele area in texture
    txr.context.setTransform(1, 0, 0, 1, 0, 0);
    txr.context.clearRect(txr.usedWidth, 0, eleScaledW, txrH);
    if (scalableFrom(oneUpCache)) // then we can relatively cheaply rescale the existing image w/o rerendering
    downscale();
    else if (scalableFrom(higherCache)) {
        // then use the higher cache for now and queue the next level down
        // to cheaply scale towards the smaller level
        if (highQualityReq) {
            for(var _l = higherCache.level; _l > lvl; _l--)oneUpCache = self1.getElement(ele, bb, pxRatio, _l, getTxrReasons.downscale);
            downscale();
        } else {
            self1.queueElement(ele, higherCache.level - 1);
            return higherCache;
        }
    } else {
        var lowerCache; // the nearest cache with a lower level
        if (!deqing && !highQualityReq && !downscaleReq) for(var _l2 = lvl - 1; _l2 >= minLvl$1; _l2--){
            var _c = lookup.get(ele, _l2);
            if (_c) {
                lowerCache = _c;
                break;
            }
        }
        if (scalableFrom(lowerCache)) {
            // then use the lower quality cache for now and queue the better one for later
            self1.queueElement(ele, lvl);
            return lowerCache;
        }
        txr.context.translate(txr.usedWidth, 0);
        txr.context.scale(scale, scale);
        this.drawElement(txr.context, ele, bb, scaledLabelShown, false);
        txr.context.scale(1 / scale, 1 / scale);
        txr.context.translate(-txr.usedWidth, 0);
    }
    eleCache = {
        x: txr.usedWidth,
        texture: txr,
        level: lvl,
        scale: scale,
        width: eleScaledW,
        height: eleScaledH,
        scaledLabelShown: scaledLabelShown
    };
    txr.usedWidth += Math.ceil(eleScaledW + eleTxrSpacing);
    txr.eleCaches.push(eleCache);
    lookup.set(ele, lvl, eleCache);
    self1.checkTextureFullness(txr);
    return eleCache;
};
ETCp.invalidateElements = function(eles) {
    for(var i = 0; i < eles.length; i++)this.invalidateElement(eles[i]);
};
ETCp.invalidateElement = function(ele) {
    var self1 = this;
    var lookup = self1.lookup;
    var caches = [];
    var invalid = lookup.isInvalid(ele);
    if (!invalid) return; // override the invalidation request if the element key has not changed
    for(var lvl = minLvl$1; lvl <= maxLvl$1; lvl++){
        var cache = lookup.getForCachedKey(ele, lvl);
        if (cache) caches.push(cache);
    }
    var noOtherElesUseCache = lookup.invalidate(ele);
    if (noOtherElesUseCache) for(var i = 0; i < caches.length; i++){
        var _cache = caches[i];
        var txr = _cache.texture;
        // remove space from the texture it belongs to
        txr.invalidatedWidth += _cache.width;
        // mark the cache as invalidated
        _cache.invalidated = true;
        // retire the texture if its utility is low
        self1.checkTextureUtility(txr);
    }
    // remove from queue since the old req was for the old state
    self1.removeFromQueue(ele);
};
ETCp.checkTextureUtility = function(txr) {
    // invalidate all entries in the cache if the cache size is small
    if (txr.invalidatedWidth >= minUtility * txr.width) this.retireTexture(txr);
};
ETCp.checkTextureFullness = function(txr) {
    // if texture has been mostly filled and passed over several times, remove
    // it from the queue so we don't need to waste time looking at it to put new things
    var self1 = this;
    var txrQ = self1.getTextureQueue(txr.height);
    if (txr.usedWidth / txr.width > maxFullness && txr.fullnessChecks >= maxFullnessChecks) removeFromArray(txrQ, txr);
    else txr.fullnessChecks++;
};
ETCp.retireTexture = function(txr) {
    var self1 = this;
    var txrH = txr.height;
    var txrQ = self1.getTextureQueue(txrH);
    var lookup = this.lookup;
    // retire the texture from the active / searchable queue:
    removeFromArray(txrQ, txr);
    txr.retired = true;
    // remove the refs from the eles to the caches:
    var eleCaches = txr.eleCaches;
    for(var i = 0; i < eleCaches.length; i++){
        var eleCache = eleCaches[i];
        lookup.deleteCache(eleCache.key, eleCache.level);
    }
    clearArray(eleCaches);
    // add the texture to a retired queue so it can be recycled in future:
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    rtxtrQ.push(txr);
};
ETCp.addTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var txr = {};
    txrQ.push(txr);
    txr.eleCaches = [];
    txr.height = txrH;
    txr.width = Math.max(defTxrWidth, minW);
    txr.usedWidth = 0;
    txr.invalidatedWidth = 0;
    txr.fullnessChecks = 0;
    txr.canvas = self1.renderer.makeOffscreenCanvas(txr.width, txr.height);
    txr.context = txr.canvas.getContext('2d');
    return txr;
};
ETCp.recycleTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    for(var i = 0; i < rtxtrQ.length; i++){
        var txr = rtxtrQ[i];
        if (txr.width >= minW) {
            txr.retired = false;
            txr.usedWidth = 0;
            txr.invalidatedWidth = 0;
            txr.fullnessChecks = 0;
            clearArray(txr.eleCaches);
            txr.context.setTransform(1, 0, 0, 1, 0, 0);
            txr.context.clearRect(0, 0, txr.width, txr.height);
            removeFromArray(rtxtrQ, txr);
            txrQ.push(txr);
            return txr;
        }
    }
};
ETCp.queueElement = function(ele, lvl) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var existingReq = k2q[key];
    if (existingReq) {
        // use the max lvl b/c in between lvls are cheap to make
        existingReq.level = Math.max(existingReq.level, lvl);
        existingReq.eles.merge(ele);
        existingReq.reqs++;
        q.updateItem(existingReq);
    } else {
        var req = {
            eles: ele.spawn().merge(ele),
            level: lvl,
            reqs: 1,
            key: key
        };
        q.push(req);
        k2q[key] = req;
    }
};
ETCp.dequeue = function(pxRatio /*, extent*/ ) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var dequeued = [];
    var lookup = self1.lookup;
    for(var i = 0; i < maxDeqSize$1; i++){
        if (q.size() > 0) {
            var req = q.pop();
            var key = req.key;
            var ele = req.eles[0]; // all eles have the same key
            var cacheExists = lookup.hasCache(ele, req.level);
            // clear out the key to req lookup
            k2q[key] = null;
            // dequeueing isn't necessary with an existing cache
            if (cacheExists) continue;
            dequeued.push(req);
            var bb = self1.getBoundingBox(ele);
            self1.getElement(ele, bb, pxRatio, req.level, getTxrReasons.dequeue);
        } else break;
    }
    return dequeued;
};
ETCp.removeFromQueue = function(ele) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var req = k2q[key];
    if (req != null) {
        if (req.eles.length === 1) {
            // remove if last ele in the req
            // bring to front of queue
            req.reqs = MAX_INT$1;
            q.updateItem(req);
            q.pop(); // remove from queue
            k2q[key] = null; // remove from lookup map
        } else // otherwise just remove ele from req
        req.eles.unmerge(ele);
    }
};
ETCp.onDequeue = function(fn) {
    this.onDequeues.push(fn);
};
ETCp.offDequeue = function(fn) {
    removeFromArray(this.onDequeues, fn);
};
ETCp.setupDequeueing = defs.setupDequeueing({
    deqRedrawThreshold: deqRedrawThreshold$1,
    deqCost: deqCost$1,
    deqAvgCost: deqAvgCost$1,
    deqNoDrawCost: deqNoDrawCost$1,
    deqFastCost: deqFastCost$1,
    deq: function deq(self1, pxRatio, extent) {
        return self1.dequeue(pxRatio, extent);
    },
    onDeqd: function onDeqd(self1, deqd) {
        for(var i = 0; i < self1.onDequeues.length; i++){
            var fn = self1.onDequeues[i];
            fn(deqd);
        }
    },
    shouldRedraw: function shouldRedraw(self1, deqd, pxRatio, extent) {
        for(var i = 0; i < deqd.length; i++){
            var eles = deqd[i].eles;
            for(var j = 0; j < eles.length; j++){
                var bb = eles[j].boundingBox();
                if (boundingBoxesIntersect(bb, extent)) return true;
            }
        }
        return false;
    },
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.eleTxrDeq;
    }
});
var defNumLayers = 1; // default number of layers to use
var minLvl = -4; // when scaling smaller than that we don't need to re-render
var maxLvl = 2; // when larger than this scale just render directly (caching is not helpful)
var maxZoom = 3.99; // beyond this zoom level, layered textures are not used
var deqRedrawThreshold = 50; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var refineEleDebounceTime = 50; // time to debounce sharper ele texture updates
var deqCost = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var deqAvgCost = 0.1; // % of add'l rendering cost compared to average overall redraw time
var deqNoDrawCost = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var deqFastCost = 0.9; // % of frame time to be used when >60fps
var maxDeqSize = 1; // number of eles to dequeue and render at higher texture in each batch
var invalidThreshold = 250; // time threshold for disabling b/c of invalidations
var maxLayerArea = 16000000; // layers can't be bigger than this
var maxLayerDim = 32767; // maximum size for the width/height of layer canvases
var useHighQualityEleTxrReqs = true; // whether to use high quality ele txr requests (generally faster and cheaper in the longterm)
// var log = function(){ console.log.apply( console, arguments ); };
var LayeredTextureCache = function LayeredTextureCache(renderer) {
    var self1 = this;
    var r = self1.renderer = renderer;
    var cy = r.cy;
    self1.layersByLevel = {}; // e.g. 2 => [ layer1, layer2, ..., layerN ]
    self1.firstGet = true;
    self1.lastInvalidationTime = performanceNow() - 2 * invalidThreshold;
    self1.skipping = false;
    self1.eleTxrDeqs = cy.collection();
    self1.scheduleElementRefinement = debounce(function() {
        self1.refineElementTextures(self1.eleTxrDeqs);
        self1.eleTxrDeqs.unmerge(self1.eleTxrDeqs);
    }, refineEleDebounceTime);
    r.beforeRender(function(willDraw, now) {
        if (now - self1.lastInvalidationTime <= invalidThreshold) self1.skipping = true;
        else self1.skipping = false;
    }, r.beforeRenderPriorities.lyrTxrSkip);
    var qSort = function qSort(a, b) {
        return b.reqs - a.reqs;
    };
    self1.layersQueue = new Heap(qSort);
    self1.setupDequeueing();
};
var LTCp = LayeredTextureCache.prototype;
var layerIdPool = 0;
var MAX_INT = Math.pow(2, 53) - 1;
LTCp.makeLayer = function(bb, lvl) {
    var scale = Math.pow(2, lvl);
    var w = Math.ceil(bb.w * scale);
    var h = Math.ceil(bb.h * scale);
    var canvas = this.renderer.makeOffscreenCanvas(w, h);
    var layer = {
        id: layerIdPool = ++layerIdPool % MAX_INT,
        bb: bb,
        level: lvl,
        width: w,
        height: h,
        canvas: canvas,
        context: canvas.getContext('2d'),
        eles: [],
        elesQueue: [],
        reqs: 0
    };
    // log('make layer %s with w %s and h %s and lvl %s', layer.id, layer.width, layer.height, layer.level);
    var cxt = layer.context;
    var dx = -layer.bb.x1;
    var dy = -layer.bb.y1;
    // do the transform on creation to save cycles (it's the same for all eles)
    cxt.scale(scale, scale);
    cxt.translate(dx, dy);
    return layer;
};
LTCp.getLayers = function(eles, pxRatio, lvl) {
    var self1 = this;
    var r = self1.renderer;
    var cy = r.cy;
    var zoom = cy.zoom();
    var firstGet = self1.firstGet;
    self1.firstGet = false;
    // log('--\nget layers with %s eles', eles.length);
    //log eles.map(function(ele){ return ele.id() }) );
    if (lvl == null) {
        lvl = Math.ceil(log2(zoom * pxRatio));
        if (lvl < minLvl) lvl = minLvl;
        else if (zoom >= maxZoom || lvl > maxLvl) return null;
    }
    self1.validateLayersElesOrdering(lvl, eles);
    var layersByLvl = self1.layersByLevel;
    var scale = Math.pow(2, lvl);
    var layers = layersByLvl[lvl] = layersByLvl[lvl] || [];
    var bb;
    var lvlComplete = self1.levelIsComplete(lvl, eles);
    var tmpLayers;
    var checkTempLevels = function checkTempLevels() {
        var canUseAsTmpLvl = function canUseAsTmpLvl(l) {
            self1.validateLayersElesOrdering(l, eles);
            if (self1.levelIsComplete(l, eles)) {
                tmpLayers = layersByLvl[l];
                return true;
            }
        };
        var checkLvls = function checkLvls(dir) {
            if (tmpLayers) return;
            for(var l = lvl + dir; minLvl <= l && l <= maxLvl; l += dir){
                if (canUseAsTmpLvl(l)) break;
            }
        };
        checkLvls(1);
        checkLvls(-1);
        // remove the invalid layers; they will be replaced as needed later in this function
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            if (layer.invalid) removeFromArray(layers, layer);
        }
    };
    if (!lvlComplete) // if the current level is incomplete, then use the closest, best quality layerset temporarily
    // and later queue the current layerset so we can get the proper quality level soon
    checkTempLevels();
    else // log('level complete, using existing layers\n--');
    return layers;
    var getBb = function getBb() {
        if (!bb) {
            bb = makeBoundingBox();
            for(var i = 0; i < eles.length; i++)updateBoundingBox(bb, eles[i].boundingBox());
        }
        return bb;
    };
    var makeLayer = function makeLayer(opts) {
        opts = opts || {};
        var after = opts.after;
        getBb();
        var w = Math.ceil(bb.w * scale);
        var h = Math.ceil(bb.h * scale);
        if (w > maxLayerDim || h > maxLayerDim) return null;
        var area = w * h;
        if (area > maxLayerArea) return null;
        var layer = self1.makeLayer(bb, lvl);
        if (after != null) {
            var index = layers.indexOf(after) + 1;
            layers.splice(index, 0, layer);
        } else if (opts.insert === undefined || opts.insert) // no after specified => first layer made so put at start
        layers.unshift(layer);
        // if( tmpLayers ){
        //self.queueLayer( layer );
        // }
        return layer;
    };
    if (self1.skipping && !firstGet) // log('skip layers');
    return null;
    // log('do layers');
    var layer = null;
    var maxElesPerLayer = eles.length / defNumLayers;
    var allowLazyQueueing = !firstGet;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        // log('look at ele', ele.id());
        var existingLayer = caches[lvl];
        if (existingLayer) {
            // reuse layer for later eles
            // log('reuse layer for', ele.id());
            layer = existingLayer;
            continue;
        }
        if (!layer || layer.eles.length >= maxElesPerLayer || !boundingBoxInBoundingBox(layer.bb, ele.boundingBox())) {
            // log('make new layer for ele %s', ele.id());
            layer = makeLayer({
                insert: true,
                after: layer
            });
            // if now layer can be built then we can't use layers at this level
            if (!layer) return null;
        // log('new layer with id %s', layer.id);
        }
        if (tmpLayers || allowLazyQueueing) // log('queue ele %s in layer %s', ele.id(), layer.id);
        self1.queueLayer(layer, ele);
        else // log('draw ele %s in layer %s', ele.id(), layer.id);
        self1.drawEleInLayer(layer, ele, lvl, pxRatio);
        layer.eles.push(ele);
        caches[lvl] = layer;
    }
    // log('--');
    if (tmpLayers) // then we only queued the current layerset and can't draw it yet
    return tmpLayers;
    if (allowLazyQueueing) // log('lazy queue level', lvl);
    return null;
    return layers;
};
// a layer may want to use an ele cache of a higher level to avoid blurriness
// so the layer level might not equal the ele level
LTCp.getEleLevelForLayerLevel = function(lvl, pxRatio) {
    return lvl;
};
LTCp.drawEleInLayer = function(layer, ele, lvl, pxRatio) {
    var self1 = this;
    var r = this.renderer;
    var context = layer.context;
    var bb = ele.boundingBox();
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    lvl = self1.getEleLevelForLayerLevel(lvl, pxRatio);
    r.setImgSmoothing(context, false);
    r.drawCachedElement(context, ele, null, null, lvl, useHighQualityEleTxrReqs);
    r.setImgSmoothing(context, true);
};
LTCp.levelIsComplete = function(lvl, eles) {
    var self1 = this;
    var layers = self1.layersByLevel[lvl];
    if (!layers || layers.length === 0) return false;
    var numElesInLayers = 0;
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        // if there are any eles needed to be drawn yet, the level is not complete
        if (layer.reqs > 0) return false;
        // if the layer is invalid, the level is not complete
        if (layer.invalid) return false;
        numElesInLayers += layer.eles.length;
    }
    // we should have exactly the number of eles passed in to be complete
    if (numElesInLayers !== eles.length) return false;
    return true;
};
LTCp.validateLayersElesOrdering = function(lvl, eles) {
    var layers = this.layersByLevel[lvl];
    if (!layers) return;
    // if in a layer the eles are not in the same order, then the layer is invalid
    // (i.e. there is an ele in between the eles in the layer)
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var offset = -1;
        // find the offset
        for(var j = 0; j < eles.length; j++)if (layer.eles[0] === eles[j]) {
            offset = j;
            break;
        }
        if (offset < 0) {
            // then the layer has nonexistent elements and is invalid
            this.invalidateLayer(layer);
            continue;
        }
        // the eles in the layer must be in the same continuous order, else the layer is invalid
        var o = offset;
        for(var j = 0; j < layer.eles.length; j++)if (layer.eles[j] !== eles[o + j]) {
            // log('invalidate based on ordering', layer.id);
            this.invalidateLayer(layer);
            break;
        }
    }
};
LTCp.updateElementsInLayers = function(eles, update) {
    var self1 = this;
    var isEles = element(eles[0]);
    // collect udpated elements (cascaded from the layers) and update each
    // layer itself along the way
    for(var i = 0; i < eles.length; i++){
        var req = isEles ? null : eles[i];
        var ele = isEles ? eles[i] : eles[i].ele;
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        for(var l = minLvl; l <= maxLvl; l++){
            var layer = caches[l];
            if (!layer) continue;
            // if update is a request from the ele cache, then it affects only
            // the matching level
            if (req && self1.getEleLevelForLayerLevel(layer.level) !== req.level) continue;
            update(layer, ele, req);
        }
    }
};
LTCp.haveLayers = function() {
    var self1 = this;
    var haveLayers = false;
    for(var l = minLvl; l <= maxLvl; l++){
        var layers = self1.layersByLevel[l];
        if (layers && layers.length > 0) {
            haveLayers = true;
            break;
        }
    }
    return haveLayers;
};
LTCp.invalidateElements = function(eles) {
    var self1 = this;
    if (eles.length === 0) return;
    self1.lastInvalidationTime = performanceNow();
    // log('update invalidate layer time from eles');
    if (eles.length === 0 || !self1.haveLayers()) return;
    self1.updateElementsInLayers(eles, function invalAssocLayers(layer, ele, req) {
        self1.invalidateLayer(layer);
    });
};
LTCp.invalidateLayer = function(layer) {
    // log('update invalidate layer time');
    this.lastInvalidationTime = performanceNow();
    if (layer.invalid) return;
     // save cycles
    var lvl = layer.level;
    var eles = layer.eles;
    var layers = this.layersByLevel[lvl];
    // log('invalidate layer', layer.id );
    removeFromArray(layers, layer);
    // layer.eles = [];
    layer.elesQueue = [];
    layer.invalid = true;
    if (layer.replacement) layer.replacement.invalid = true;
    for(var i = 0; i < eles.length; i++){
        var caches = eles[i]._private.rscratch.imgLayerCaches;
        if (caches) caches[lvl] = null;
    }
};
LTCp.refineElementTextures = function(eles) {
    var self1 = this;
    // log('refine', eles.length);
    self1.updateElementsInLayers(eles, function refineEachEle(layer, ele, req) {
        var rLyr = layer.replacement;
        if (!rLyr) {
            rLyr = layer.replacement = self1.makeLayer(layer.bb, layer.level);
            rLyr.replaces = layer;
            rLyr.eles = layer.eles;
        // log('make replacement layer %s for %s with level %s', rLyr.id, layer.id, rLyr.level);
        }
        if (!rLyr.reqs) for(var i = 0; i < rLyr.eles.length; i++)self1.queueLayer(rLyr, rLyr.eles[i]);
    });
};
LTCp.enqueueElementRefinement = function(ele) {
    this.eleTxrDeqs.merge(ele);
    this.scheduleElementRefinement();
};
LTCp.queueLayer = function(layer, ele) {
    var self1 = this;
    var q = self1.layersQueue;
    var elesQ = layer.elesQueue;
    var hasId = elesQ.hasId = elesQ.hasId || {};
    // if a layer is going to be replaced, queuing is a waste of time
    if (layer.replacement) return;
    if (ele) {
        if (hasId[ele.id()]) return;
        elesQ.push(ele);
        hasId[ele.id()] = true;
    }
    if (layer.reqs) {
        layer.reqs++;
        q.updateItem(layer);
    } else {
        layer.reqs = 1;
        q.push(layer);
    }
};
LTCp.dequeue = function(pxRatio) {
    var self1 = this;
    var q = self1.layersQueue;
    var deqd = [];
    var eleDeqs = 0;
    while(eleDeqs < maxDeqSize){
        if (q.size() === 0) break;
        var layer = q.peek();
        // if a layer has been or will be replaced, then don't waste time with it
        if (layer.replacement) {
            // log('layer %s in queue skipped b/c it already has a replacement', layer.id);
            q.pop();
            continue;
        }
        // if this is a replacement layer that has been superceded, then forget it
        if (layer.replaces && layer !== layer.replaces.replacement) {
            // log('layer is no longer the most uptodate replacement; dequeued', layer.id)
            q.pop();
            continue;
        }
        if (layer.invalid) {
            // log('replacement layer %s is invalid; dequeued', layer.id);
            q.pop();
            continue;
        }
        var ele = layer.elesQueue.shift();
        if (ele) {
            // log('dequeue layer %s', layer.id);
            self1.drawEleInLayer(layer, ele, layer.level, pxRatio);
            eleDeqs++;
        }
        if (deqd.length === 0) // we need only one entry in deqd to queue redrawing etc
        deqd.push(true);
        // if the layer has all its eles done, then remove from the queue
        if (layer.elesQueue.length === 0) {
            q.pop();
            layer.reqs = 0;
            // log('dequeue of layer %s complete', layer.id);
            // when a replacement layer is dequeued, it replaces the old layer in the level
            if (layer.replaces) self1.applyLayerReplacement(layer);
            self1.requestRedraw();
        }
    }
    return deqd;
};
LTCp.applyLayerReplacement = function(layer) {
    var self1 = this;
    var layersInLevel = self1.layersByLevel[layer.level];
    var replaced = layer.replaces;
    var index = layersInLevel.indexOf(replaced);
    // if the replaced layer is not in the active list for the level, then replacing
    // refs would be a mistake (i.e. overwriting the true active layer)
    if (index < 0 || replaced.invalid) // log('replacement layer would have no effect', layer.id);
    return;
    layersInLevel[index] = layer; // replace level ref
    // replace refs in eles
    for(var i = 0; i < layer.eles.length; i++){
        var _p = layer.eles[i]._private;
        var cache = _p.imgLayerCaches = _p.imgLayerCaches || {};
        if (cache) cache[layer.level] = layer;
    }
    // log('apply replacement layer %s over %s', layer.id, replaced.id);
    self1.requestRedraw();
};
LTCp.requestRedraw = debounce(function() {
    var r = this.renderer;
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    r.redraw();
}, 100);
LTCp.setupDequeueing = defs.setupDequeueing({
    deqRedrawThreshold: deqRedrawThreshold,
    deqCost: deqCost,
    deqAvgCost: deqAvgCost,
    deqNoDrawCost: deqNoDrawCost,
    deqFastCost: deqFastCost,
    deq: function deq(self1, pxRatio) {
        return self1.dequeue(pxRatio);
    },
    onDeqd: noop$1,
    shouldRedraw: trueify,
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.lyrTxrDeq;
    }
});
var CRp$b = {};
var impl;
function polygon(context, points) {
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        context.lineTo(pt.x, pt.y);
    }
}
function triangleBackcurve(context, points, controlPoint) {
    var firstPt;
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        if (i === 0) firstPt = pt;
        context.lineTo(pt.x, pt.y);
    }
    context.quadraticCurveTo(controlPoint.x, controlPoint.y, firstPt.x, firstPt.y);
}
function triangleTee(context, trianglePoints, teePoints) {
    if (context.beginPath) context.beginPath();
    var triPts = trianglePoints;
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    var teePts = teePoints;
    var firstTeePt = teePoints[0];
    context.moveTo(firstTeePt.x, firstTeePt.y);
    for(var i = 1; i < teePts.length; i++){
        var pt = teePts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function circleTriangle(context, trianglePoints, rx, ry, r) {
    if (context.beginPath) context.beginPath();
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
    var triPts = trianglePoints;
    var firstTrPt = triPts[0];
    context.moveTo(firstTrPt.x, firstTrPt.y);
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function circle(context, rx, ry, r) {
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
}
CRp$b.arrowShapeImpl = function(name) {
    return (impl || (impl = {
        'polygon': polygon,
        'triangle-backcurve': triangleBackcurve,
        'triangle-tee': triangleTee,
        'circle-triangle': circleTriangle,
        'triangle-cross': triangleTee,
        'circle': circle
    }))[name];
};
var CRp$a = {};
CRp$a.drawElement = function(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity) {
    var r = this;
    if (ele.isNode()) r.drawNode(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
    else r.drawEdge(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
};
CRp$a.drawElementOverlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeOverlay(context, ele);
    else r.drawEdgeOverlay(context, ele);
};
CRp$a.drawElementUnderlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeUnderlay(context, ele);
    else r.drawEdgeUnderlay(context, ele);
};
CRp$a.drawCachedElementPortion = function(context, ele, eleTxrCache, pxRatio, lvl, reason, getRotation, getOpacity) {
    var r = this;
    var bb = eleTxrCache.getBoundingBox(ele);
    if (bb.w === 0 || bb.h === 0) return;
     // ignore zero size case
    var eleCache = eleTxrCache.getElement(ele, bb, pxRatio, lvl, reason);
    if (eleCache != null) {
        var opacity = getOpacity(r, ele);
        if (opacity === 0) return;
        var theta = getRotation(r, ele);
        var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h;
        var x, y, sx, sy, smooth;
        if (theta !== 0) {
            var rotPt = eleTxrCache.getRotationPoint(ele);
            sx = rotPt.x;
            sy = rotPt.y;
            context.translate(sx, sy);
            context.rotate(theta);
            smooth = r.getImgSmoothing(context);
            if (!smooth) r.setImgSmoothing(context, true);
            var off = eleTxrCache.getRotationOffset(ele);
            x = off.x;
            y = off.y;
        } else {
            x = x1;
            y = y1;
        }
        var oldGlobalAlpha;
        if (opacity !== 1) {
            oldGlobalAlpha = context.globalAlpha;
            context.globalAlpha = oldGlobalAlpha * opacity;
        }
        context.drawImage(eleCache.texture.canvas, eleCache.x, 0, eleCache.width, eleCache.height, x, y, w, h);
        if (opacity !== 1) context.globalAlpha = oldGlobalAlpha;
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-sx, -sy);
            if (!smooth) r.setImgSmoothing(context, false);
        }
    } else eleTxrCache.drawElement(context, ele); // direct draw fallback
};
var getZeroRotation = function getZeroRotation() {
    return 0;
};
var getLabelRotation = function getLabelRotation(r, ele) {
    return r.getTextAngle(ele, null);
};
var getSourceLabelRotation = function getSourceLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'source');
};
var getTargetLabelRotation = function getTargetLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'target');
};
var getOpacity = function getOpacity(r, ele) {
    return ele.effectiveOpacity();
};
var getTextOpacity = function getTextOpacity(e, ele) {
    return ele.pstyle('text-opacity').pfValue * ele.effectiveOpacity();
};
CRp$a.drawCachedElement = function(context, ele, pxRatio, extent, lvl, requestHighQuality) {
    var r = this;
    var _r$data = r.data, eleTxrCache = _r$data.eleTxrCache, lblTxrCache = _r$data.lblTxrCache, slbTxrCache = _r$data.slbTxrCache, tlbTxrCache = _r$data.tlbTxrCache;
    var bb = ele.boundingBox();
    var reason = requestHighQuality === true ? eleTxrCache.reasons.highQuality : null;
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    if (!extent || boundingBoxesIntersect(bb, extent)) {
        var isEdge = ele.isEdge();
        var badLine = ele.element()._private.rscratch.badLine;
        r.drawElementUnderlay(context, ele);
        r.drawCachedElementPortion(context, ele, eleTxrCache, pxRatio, lvl, reason, getZeroRotation, getOpacity);
        if (!isEdge || !badLine) r.drawCachedElementPortion(context, ele, lblTxrCache, pxRatio, lvl, reason, getLabelRotation, getTextOpacity);
        if (isEdge && !badLine) {
            r.drawCachedElementPortion(context, ele, slbTxrCache, pxRatio, lvl, reason, getSourceLabelRotation, getTextOpacity);
            r.drawCachedElementPortion(context, ele, tlbTxrCache, pxRatio, lvl, reason, getTargetLabelRotation, getTextOpacity);
        }
        r.drawElementOverlay(context, ele);
    }
};
CRp$a.drawElements = function(context, eles) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawElement(context, ele);
    }
};
CRp$a.drawCachedElements = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
CRp$a.drawCachedNodes = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.isNode()) continue;
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
CRp$a.drawLayeredElements = function(context, eles, pxRatio, extent) {
    var r = this;
    var layers = r.data.lyrTxrCache.getLayers(eles, pxRatio);
    if (layers) for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var bb = layer.bb;
        if (bb.w === 0 || bb.h === 0) continue;
        context.drawImage(layer.canvas, bb.x1, bb.y1, bb.w, bb.h);
    }
    else // fall back on plain caching if no layers
    r.drawCachedElements(context, eles, pxRatio, extent);
};
var CRp$9 = {};
CRp$9.drawEdge = function(context, edge, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var rs = edge._private.rscratch;
    if (shouldDrawOpacity && !edge.visible()) return;
    // if bezier ctrl pts can not be calculated, then die
    if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
    return;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    var opacity = shouldDrawOpacity ? edge.pstyle('opacity').value : 1;
    var lineOpacity = shouldDrawOpacity ? edge.pstyle('line-opacity').value : 1;
    var curveStyle = edge.pstyle('curve-style').value;
    var lineStyle = edge.pstyle('line-style').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var lineCap = edge.pstyle('line-cap').value;
    var lineOutlineWidth = edge.pstyle('line-outline-width').value;
    var lineOutlineColor = edge.pstyle('line-outline-color').value;
    var effectiveLineOpacity = opacity * lineOpacity;
    // separate arrow opacity would require arrow-opacity property
    var effectiveArrowOpacity = opacity * lineOpacity;
    var drawLine = function drawLine() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        if (curveStyle === 'straight-triangle') {
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgeTrianglePath(edge, context, rs.allpts);
        } else {
            context.lineWidth = edgeWidth;
            context.lineCap = lineCap;
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawLineOutline = function drawLineOutline() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        context.lineWidth = edgeWidth + lineOutlineWidth;
        context.lineCap = lineCap;
        if (lineOutlineWidth > 0) r.colorStrokeStyle(context, lineOutlineColor[0], lineOutlineColor[1], lineOutlineColor[2], strokeOpacity);
        else {
            // do not draw any lineOutline
            context.lineCap = 'butt'; // reset for other drawing functions
            return;
        }
        if (curveStyle === 'straight-triangle') r.drawEdgeTrianglePath(edge, context, rs.allpts);
        else {
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawOverlay = function drawOverlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeOverlay(context, edge);
    };
    var drawUnderlay = function drawUnderlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeUnderlay(context, edge);
    };
    var drawArrows = function drawArrows() {
        var arrowOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveArrowOpacity;
        r.drawArrowheads(context, edge, arrowOpacity);
    };
    var drawText = function drawText() {
        r.drawElementText(context, edge, null, drawLabel);
    };
    context.lineJoin = 'round';
    var ghost = edge.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = edge.pstyle('ghost-offset-x').pfValue;
        var gy = edge.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = edge.pstyle('ghost-opacity').value;
        var effectiveGhostOpacity = effectiveLineOpacity * ghostOpacity;
        context.translate(gx, gy);
        drawLine(effectiveGhostOpacity);
        drawArrows(effectiveGhostOpacity);
        context.translate(-gx, -gy);
    } else drawLineOutline();
    drawUnderlay();
    drawLine();
    drawArrows();
    drawOverlay();
    drawText();
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var drawEdgeOverlayUnderlay = function drawEdgeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, edge) {
        if (!edge.visible()) return;
        var opacity = edge.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        if (opacity === 0) return;
        var r = this;
        var usePaths = r.usePaths();
        var rs = edge._private.rscratch;
        var padding = edge.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var width = 2 * padding;
        var color = edge.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        context.lineWidth = width;
        if (rs.edgeType === 'self' && !usePaths) context.lineCap = 'butt';
        else context.lineCap = 'round';
        r.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
        r.drawEdgePath(edge, context, rs.allpts, 'solid');
    };
};
CRp$9.drawEdgeOverlay = drawEdgeOverlayUnderlay('overlay');
CRp$9.drawEdgeUnderlay = drawEdgeOverlayUnderlay('underlay');
CRp$9.drawEdgePath = function(edge, context, pts, type) {
    var rs = edge._private.rscratch;
    var canvasCxt = context;
    var path;
    var pathCacheHit = false;
    var usePaths = this.usePaths();
    var lineDashPattern = edge.pstyle('line-dash-pattern').pfValue;
    var lineDashOffset = edge.pstyle('line-dash-offset').pfValue;
    if (usePaths) {
        var pathCacheKey = pts.join('$');
        var keyMatches = rs.pathCacheKey && rs.pathCacheKey === pathCacheKey;
        if (keyMatches) {
            path = context = rs.pathCache;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            rs.pathCacheKey = pathCacheKey;
            rs.pathCache = path;
        }
    }
    if (canvasCxt.setLineDash) // for very outofdate browsers
    switch(type){
        case 'dotted':
            canvasCxt.setLineDash([
                1,
                1
            ]);
            break;
        case 'dashed':
            canvasCxt.setLineDash(lineDashPattern);
            canvasCxt.lineDashOffset = lineDashOffset;
            break;
        case 'solid':
            canvasCxt.setLineDash([]);
            break;
    }
    if (!pathCacheHit && !rs.badLine) {
        if (context.beginPath) context.beginPath();
        context.moveTo(pts[0], pts[1]);
        switch(rs.edgeType){
            case 'bezier':
            case 'self':
            case 'compound':
            case 'multibezier':
                for(var i = 2; i + 3 < pts.length; i += 4)context.quadraticCurveTo(pts[i], pts[i + 1], pts[i + 2], pts[i + 3]);
                break;
            case 'straight':
            case 'haystack':
                for(var _i = 2; _i + 1 < pts.length; _i += 2)context.lineTo(pts[_i], pts[_i + 1]);
                break;
            case 'segments':
                if (rs.isRound) {
                    var _iterator = _createForOfIteratorHelper(rs.roundCorners), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var corner = _step.value;
                            drawPreparedRoundCorner(context, corner);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    context.lineTo(pts[pts.length - 2], pts[pts.length - 1]);
                } else for(var _i2 = 2; _i2 + 1 < pts.length; _i2 += 2)context.lineTo(pts[_i2], pts[_i2 + 1]);
                break;
        }
    }
    context = canvasCxt;
    if (usePaths) context.stroke(path);
    else context.stroke();
    // reset any line dashes
    if (context.setLineDash) // for very outofdate browsers
    context.setLineDash([]);
};
CRp$9.drawEdgeTrianglePath = function(edge, context, pts) {
    // use line stroke style for triangle fill style
    context.fillStyle = context.strokeStyle;
    var edgeWidth = edge.pstyle('width').pfValue;
    for(var i = 0; i + 1 < pts.length; i += 2){
        var vector = [
            pts[i + 2] - pts[i],
            pts[i + 3] - pts[i + 1]
        ];
        var length = Math.sqrt(vector[0] * vector[0] + vector[1] * vector[1]);
        var normal = [
            vector[1] / length,
            -vector[0] / length
        ];
        var triangleHead = [
            normal[0] * edgeWidth / 2,
            normal[1] * edgeWidth / 2
        ];
        context.beginPath();
        context.moveTo(pts[i] - triangleHead[0], pts[i + 1] - triangleHead[1]);
        context.lineTo(pts[i] + triangleHead[0], pts[i + 1] + triangleHead[1]);
        context.lineTo(pts[i + 2], pts[i + 3]);
        context.closePath();
        context.fill();
    }
};
CRp$9.drawArrowheads = function(context, edge, opacity) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    if (!isHaystack) this.drawArrowhead(context, edge, 'source', rs.arrowStartX, rs.arrowStartY, rs.srcArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-target', rs.midX, rs.midY, rs.midtgtArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-source', rs.midX, rs.midY, rs.midsrcArrowAngle, opacity);
    if (!isHaystack) this.drawArrowhead(context, edge, 'target', rs.arrowEndX, rs.arrowEndY, rs.tgtArrowAngle, opacity);
};
CRp$9.drawArrowhead = function(context, edge, prefix, x, y, angle, opacity) {
    if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
    var self1 = this;
    var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
    if (arrowShape === 'none') return;
    var arrowClearFill = edge.pstyle(prefix + '-arrow-fill').value === 'hollow' ? 'both' : 'filled';
    var arrowFill = edge.pstyle(prefix + '-arrow-fill').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var pArrowWidth = edge.pstyle(prefix + '-arrow-width');
    var arrowWidth = pArrowWidth.value === 'match-line' ? edgeWidth : pArrowWidth.pfValue;
    if (pArrowWidth.units === '%') arrowWidth *= edgeWidth;
    var edgeOpacity = edge.pstyle('opacity').value;
    if (opacity === undefined) opacity = edgeOpacity;
    var gco = context.globalCompositeOperation;
    if (opacity !== 1 || arrowFill === 'hollow') {
        // then extra clear is needed
        context.globalCompositeOperation = 'destination-out';
        self1.colorFillStyle(context, 255, 255, 255, 1);
        self1.colorStrokeStyle(context, 255, 255, 255, 1);
        self1.drawArrowShape(edge, context, arrowClearFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
        context.globalCompositeOperation = gco;
    } // otherwise, the opaque arrow clears it for free :)
    var color = edge.pstyle(prefix + '-arrow-color').value;
    self1.colorFillStyle(context, color[0], color[1], color[2], opacity);
    self1.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
    self1.drawArrowShape(edge, context, arrowFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
};
CRp$9.drawArrowShape = function(edge, context, fill, edgeWidth, shape, shapeWidth, x, y, angle) {
    var r = this;
    var usePaths = this.usePaths() && shape !== 'triangle-cross';
    var pathCacheHit = false;
    var path;
    var canvasContext = context;
    var translation = {
        x: x,
        y: y
    };
    var scale = edge.pstyle('arrow-scale').value;
    var size = this.getArrowWidth(edgeWidth, scale);
    var shapeImpl = r.arrowShapes[shape];
    if (usePaths) {
        var cache = r.arrowPathCache = r.arrowPathCache || [];
        var key = hashString(shape);
        var cachedPath = cache[key];
        if (cachedPath != null) {
            path = context = cachedPath;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            cache[key] = path;
        }
    }
    if (!pathCacheHit) {
        if (context.beginPath) context.beginPath();
        if (usePaths) // store in the path cache with values easily manipulated later
        shapeImpl.draw(context, 1, 0, {
            x: 0,
            y: 0
        }, 1);
        else shapeImpl.draw(context, size, angle, translation, edgeWidth);
        if (context.closePath) context.closePath();
    }
    context = canvasContext;
    if (usePaths) {
        // set transform to arrow position/orientation
        context.translate(x, y);
        context.rotate(angle);
        context.scale(size, size);
    }
    if (fill === 'filled' || fill === 'both') {
        if (usePaths) context.fill(path);
        else context.fill();
    }
    if (fill === 'hollow' || fill === 'both') {
        context.lineWidth = shapeWidth / (usePaths ? size : 1);
        context.lineJoin = 'miter';
        if (usePaths) context.stroke(path);
        else context.stroke();
    }
    if (usePaths) {
        // reset transform by applying inverse
        context.scale(1 / size, 1 / size);
        context.rotate(-angle);
        context.translate(-x, -y);
    }
};
var CRp$8 = {};
CRp$8.safeDrawImage = function(context, img, ix, iy, iw, ih, x, y, w, h) {
    // detect problematic cases for old browsers with bad images (cheaper than try-catch)
    if (iw <= 0 || ih <= 0 || w <= 0 || h <= 0) return;
    try {
        context.drawImage(img, ix, iy, iw, ih, x, y, w, h);
    } catch (e) {
        warn(e);
    }
};
CRp$8.drawInscribedImage = function(context, img, node, index, nodeOpacity) {
    var r = this;
    var pos = node.position();
    var nodeX = pos.x;
    var nodeY = pos.y;
    var styleObj = node.cy().style();
    var getIndexedStyle = styleObj.getIndexedStyle.bind(styleObj);
    var fit = getIndexedStyle(node, 'background-fit', 'value', index);
    var repeat = getIndexedStyle(node, 'background-repeat', 'value', index);
    var nodeW = node.width();
    var nodeH = node.height();
    var paddingX2 = node.padding() * 2;
    var nodeTW = nodeW + (getIndexedStyle(node, 'background-width-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var nodeTH = nodeH + (getIndexedStyle(node, 'background-height-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var rs = node._private.rscratch;
    var clip = getIndexedStyle(node, 'background-clip', 'value', index);
    var shouldClip = clip === 'node';
    var imgOpacity = getIndexedStyle(node, 'background-image-opacity', 'value', index) * nodeOpacity;
    var smooth = getIndexedStyle(node, 'background-image-smoothing', 'value', index);
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var imgW = img.width || img.cachedW;
    var imgH = img.height || img.cachedH;
    // workaround for broken browsers like ie
    if (null == imgW || null == imgH) {
        document.body.appendChild(img); // eslint-disable-line no-undef
        imgW = img.cachedW = img.width || img.offsetWidth;
        imgH = img.cachedH = img.height || img.offsetHeight;
        document.body.removeChild(img); // eslint-disable-line no-undef
    }
    var w = imgW;
    var h = imgH;
    if (getIndexedStyle(node, 'background-width', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-width', 'units', index) === '%') w = getIndexedStyle(node, 'background-width', 'pfValue', index) * nodeTW;
        else w = getIndexedStyle(node, 'background-width', 'pfValue', index);
    }
    if (getIndexedStyle(node, 'background-height', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-height', 'units', index) === '%') h = getIndexedStyle(node, 'background-height', 'pfValue', index) * nodeTH;
        else h = getIndexedStyle(node, 'background-height', 'pfValue', index);
    }
    if (w === 0 || h === 0) return; // no point in drawing empty image (and chrome is broken in this case)
    if (fit === 'contain') {
        var scale = Math.min(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    } else if (fit === 'cover') {
        var scale = Math.max(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    }
    var x = nodeX - nodeTW / 2; // left
    var posXUnits = getIndexedStyle(node, 'background-position-x', 'units', index);
    var posXPfVal = getIndexedStyle(node, 'background-position-x', 'pfValue', index);
    if (posXUnits === '%') x += (nodeTW - w) * posXPfVal;
    else x += posXPfVal;
    var offXUnits = getIndexedStyle(node, 'background-offset-x', 'units', index);
    var offXPfVal = getIndexedStyle(node, 'background-offset-x', 'pfValue', index);
    if (offXUnits === '%') x += (nodeTW - w) * offXPfVal;
    else x += offXPfVal;
    var y = nodeY - nodeTH / 2; // top
    var posYUnits = getIndexedStyle(node, 'background-position-y', 'units', index);
    var posYPfVal = getIndexedStyle(node, 'background-position-y', 'pfValue', index);
    if (posYUnits === '%') y += (nodeTH - h) * posYPfVal;
    else y += posYPfVal;
    var offYUnits = getIndexedStyle(node, 'background-offset-y', 'units', index);
    var offYPfVal = getIndexedStyle(node, 'background-offset-y', 'pfValue', index);
    if (offYUnits === '%') y += (nodeTH - h) * offYPfVal;
    else y += offYPfVal;
    if (rs.pathCache) {
        x -= nodeX;
        y -= nodeY;
        nodeX = 0;
        nodeY = 0;
    }
    var gAlpha = context.globalAlpha;
    context.globalAlpha = imgOpacity;
    var smoothingEnabled = r.getImgSmoothing(context);
    var isSmoothingSwitched = false;
    if (smooth === 'no' && smoothingEnabled) {
        r.setImgSmoothing(context, false);
        isSmoothingSwitched = true;
    } else if (smooth === 'yes' && !smoothingEnabled) {
        r.setImgSmoothing(context, true);
        isSmoothingSwitched = true;
    }
    if (repeat === 'no-repeat') {
        if (shouldClip) {
            context.save();
            if (rs.pathCache) context.clip(rs.pathCache);
            else {
                r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
                context.clip();
            }
        }
        r.safeDrawImage(context, img, 0, 0, imgW, imgH, x, y, w, h);
        if (shouldClip) context.restore();
    } else {
        var pattern = context.createPattern(img, repeat);
        context.fillStyle = pattern;
        r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
        context.translate(x, y);
        context.fill();
        context.translate(-x, -y);
    }
    context.globalAlpha = gAlpha;
    if (isSmoothingSwitched) r.setImgSmoothing(context, smoothingEnabled);
};
var CRp$7 = {};
CRp$7.eleTextBiggerThanMin = function(ele, scale) {
    if (!scale) {
        var zoom = ele.cy().zoom();
        var pxRatio = this.getPixelRatio();
        var lvl = Math.ceil(log2(zoom * pxRatio)); // the effective texture level
        scale = Math.pow(2, lvl);
    }
    var computedSize = ele.pstyle('font-size').pfValue * scale;
    var minSize = ele.pstyle('min-zoomed-font-size').pfValue;
    if (computedSize < minSize) return false;
    return true;
};
CRp$7.drawElementText = function(context, ele, shiftToOriginWithBb, force, prefix) {
    var useEleOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    if (force == null) {
        if (useEleOpacity && !r.eleTextBiggerThanMin(ele)) return;
    } else if (force === false) return;
    if (ele.isNode()) {
        var label = ele.pstyle('label');
        if (!label || !label.value) return;
        var justification = r.getLabelJustification(ele);
        context.textAlign = justification;
        context.textBaseline = 'bottom';
    } else {
        var badLine = ele.element()._private.rscratch.badLine;
        var _label = ele.pstyle('label');
        var srcLabel = ele.pstyle('source-label');
        var tgtLabel = ele.pstyle('target-label');
        if (badLine || (!_label || !_label.value) && (!srcLabel || !srcLabel.value) && (!tgtLabel || !tgtLabel.value)) return;
        context.textAlign = 'center';
        context.textBaseline = 'bottom';
    }
    var applyRotation = !shiftToOriginWithBb;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    if (prefix == null) {
        r.drawText(context, ele, null, applyRotation, useEleOpacity);
        if (ele.isEdge()) {
            r.drawText(context, ele, 'source', applyRotation, useEleOpacity);
            r.drawText(context, ele, 'target', applyRotation, useEleOpacity);
        }
    } else r.drawText(context, ele, prefix, applyRotation, useEleOpacity);
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
CRp$7.getFontCache = function(context) {
    var cache;
    this.fontCaches = this.fontCaches || [];
    for(var i = 0; i < this.fontCaches.length; i++){
        cache = this.fontCaches[i];
        if (cache.context === context) return cache;
    }
    cache = {
        context: context
    };
    this.fontCaches.push(cache);
    return cache;
};
// set up canvas context with font
// returns transformed text string
CRp$7.setupTextStyle = function(context, ele) {
    var useEleOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // Font style
    var labelStyle = ele.pstyle('font-style').strValue;
    var labelSize = ele.pstyle('font-size').pfValue + 'px';
    var labelFamily = ele.pstyle('font-family').strValue;
    var labelWeight = ele.pstyle('font-weight').strValue;
    var opacity = useEleOpacity ? ele.effectiveOpacity() * ele.pstyle('text-opacity').value : 1;
    var outlineOpacity = ele.pstyle('text-outline-opacity').value * opacity;
    var color = ele.pstyle('color').value;
    var outlineColor = ele.pstyle('text-outline-color').value;
    context.font = labelStyle + ' ' + labelWeight + ' ' + labelSize + ' ' + labelFamily;
    context.lineJoin = 'round'; // so text outlines aren't jagged
    this.colorFillStyle(context, color[0], color[1], color[2], opacity);
    this.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], outlineOpacity);
};
// TODO ensure re-used
function roundRect(ctx, x, y, width, height) {
    var radius = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5;
    var stroke = arguments.length > 6 ? arguments[6] : undefined;
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
    if (stroke) ctx.stroke();
    else ctx.fill();
}
CRp$7.getTextAngle = function(ele, prefix) {
    var theta;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var pdash = prefix ? prefix + '-' : '';
    var rotation = ele.pstyle(pdash + 'text-rotation');
    if (rotation.strValue === 'autorotate') {
        var textAngle = getPrefixedProperty(rscratch, 'labelAngle', prefix);
        theta = ele.isEdge() ? textAngle : 0;
    } else if (rotation.strValue === 'none') theta = 0;
    else theta = rotation.pfValue;
    return theta;
};
CRp$7.drawText = function(context, ele, prefix) {
    var applyRotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var useEleOpacity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var parentOpacity = useEleOpacity ? ele.effectiveOpacity() : 1;
    if (useEleOpacity && (parentOpacity === 0 || ele.pstyle('text-opacity').value === 0)) return;
    // use 'main' as an alias for the main label (i.e. null prefix)
    if (prefix === 'main') prefix = null;
    var textX = getPrefixedProperty(rscratch, 'labelX', prefix);
    var textY = getPrefixedProperty(rscratch, 'labelY', prefix);
    var orgTextX, orgTextY; // used for rotation
    var text = this.getLabelText(ele, prefix);
    if (text != null && text !== '' && !isNaN(textX) && !isNaN(textY)) {
        this.setupTextStyle(context, ele, useEleOpacity);
        var pdash = prefix ? prefix + '-' : '';
        var textW = getPrefixedProperty(rscratch, 'labelWidth', prefix);
        var textH = getPrefixedProperty(rscratch, 'labelHeight', prefix);
        var marginX = ele.pstyle(pdash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(pdash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var halign = ele.pstyle('text-halign').value;
        var valign = ele.pstyle('text-valign').value;
        if (isEdge) {
            halign = 'center';
            valign = 'center';
        }
        textX += marginX;
        textY += marginY;
        var theta;
        if (!applyRotation) theta = 0;
        else theta = this.getTextAngle(ele, prefix);
        if (theta !== 0) {
            orgTextX = textX;
            orgTextY = textY;
            context.translate(orgTextX, orgTextY);
            context.rotate(theta);
            textX = 0;
            textY = 0;
        }
        switch(valign){
            case 'top':
                break;
            case 'center':
                textY += textH / 2;
                break;
            case 'bottom':
                textY += textH;
                break;
        }
        var backgroundOpacity = ele.pstyle('text-background-opacity').value;
        var borderOpacity = ele.pstyle('text-border-opacity').value;
        var textBorderWidth = ele.pstyle('text-border-width').pfValue;
        var backgroundPadding = ele.pstyle('text-background-padding').pfValue;
        var styleShape = ele.pstyle('text-background-shape').strValue;
        var rounded = styleShape.indexOf('round') === 0;
        var roundRadius = 2;
        if (backgroundOpacity > 0 || textBorderWidth > 0 && borderOpacity > 0) {
            var bgX = textX - backgroundPadding;
            switch(halign){
                case 'left':
                    bgX -= textW;
                    break;
                case 'center':
                    bgX -= textW / 2;
                    break;
            }
            var bgY = textY - textH - backgroundPadding;
            var bgW = textW + 2 * backgroundPadding;
            var bgH = textH + 2 * backgroundPadding;
            if (backgroundOpacity > 0) {
                var textFill = context.fillStyle;
                var textBackgroundColor = ele.pstyle('text-background-color').value;
                context.fillStyle = 'rgba(' + textBackgroundColor[0] + ',' + textBackgroundColor[1] + ',' + textBackgroundColor[2] + ',' + backgroundOpacity * parentOpacity + ')';
                if (rounded) roundRect(context, bgX, bgY, bgW, bgH, roundRadius);
                else context.fillRect(bgX, bgY, bgW, bgH);
                context.fillStyle = textFill;
            }
            if (textBorderWidth > 0 && borderOpacity > 0) {
                var textStroke = context.strokeStyle;
                var textLineWidth = context.lineWidth;
                var textBorderColor = ele.pstyle('text-border-color').value;
                var textBorderStyle = ele.pstyle('text-border-style').value;
                context.strokeStyle = 'rgba(' + textBorderColor[0] + ',' + textBorderColor[1] + ',' + textBorderColor[2] + ',' + borderOpacity * parentOpacity + ')';
                context.lineWidth = textBorderWidth;
                if (context.setLineDash) // for very outofdate browsers
                switch(textBorderStyle){
                    case 'dotted':
                        context.setLineDash([
                            1,
                            1
                        ]);
                        break;
                    case 'dashed':
                        context.setLineDash([
                            4,
                            2
                        ]);
                        break;
                    case 'double':
                        context.lineWidth = textBorderWidth / 4; // 50% reserved for white between the two borders
                        context.setLineDash([]);
                        break;
                    case 'solid':
                        context.setLineDash([]);
                        break;
                }
                if (rounded) roundRect(context, bgX, bgY, bgW, bgH, roundRadius, 'stroke');
                else context.strokeRect(bgX, bgY, bgW, bgH);
                if (textBorderStyle === 'double') {
                    var whiteWidth = textBorderWidth / 2;
                    if (rounded) roundRect(context, bgX + whiteWidth, bgY + whiteWidth, bgW - whiteWidth * 2, bgH - whiteWidth * 2, roundRadius, 'stroke');
                    else context.strokeRect(bgX + whiteWidth, bgY + whiteWidth, bgW - whiteWidth * 2, bgH - whiteWidth * 2);
                }
                if (context.setLineDash) // for very outofdate browsers
                context.setLineDash([]);
                context.lineWidth = textLineWidth;
                context.strokeStyle = textStroke;
            }
        }
        var lineWidth = 2 * ele.pstyle('text-outline-width').pfValue; // *2 b/c the stroke is drawn centred on the middle
        if (lineWidth > 0) context.lineWidth = lineWidth;
        if (ele.pstyle('text-wrap').value === 'wrap') {
            var lines = getPrefixedProperty(rscratch, 'labelWrapCachedLines', prefix);
            var lineHeight = getPrefixedProperty(rscratch, 'labelLineHeight', prefix);
            var halfTextW = textW / 2;
            var justification = this.getLabelJustification(ele);
            if (justification === 'auto') ;
            else if (halign === 'left') {
                // auto justification : right
                if (justification === 'left') textX += -textW;
                else if (justification === 'center') textX += -halfTextW;
                 // else same as auto
            } else if (halign === 'center') {
                // auto justfication : center
                if (justification === 'left') textX += -halfTextW;
                else if (justification === 'right') textX += halfTextW;
                 // else same as auto
            } else if (halign === 'right') {
                // auto justification : left
                if (justification === 'center') textX += halfTextW;
                else if (justification === 'right') textX += textW;
                 // else same as auto
            }
            switch(valign){
                case 'top':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
                case 'center':
                case 'bottom':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
            }
            for(var l = 0; l < lines.length; l++){
                if (lineWidth > 0) context.strokeText(lines[l], textX, textY);
                context.fillText(lines[l], textX, textY);
                textY += lineHeight;
            }
        } else {
            if (lineWidth > 0) context.strokeText(text, textX, textY);
            context.fillText(text, textX, textY);
        }
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-orgTextX, -orgTextY);
        }
    }
};
/* global Path2D */ var CRp$6 = {};
CRp$6.drawNode = function(context, node, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var nodeWidth, nodeHeight;
    var _p = node._private;
    var rs = _p.rscratch;
    var pos = node.position();
    if (!number$1(pos.x) || !number$1(pos.y)) return; // can't draw node with undefined position
    if (shouldDrawOpacity && !node.visible()) return;
    var eleOpacity = shouldDrawOpacity ? node.effectiveOpacity() : 1;
    var usePaths = r.usePaths();
    var path;
    var pathCacheHit = false;
    var padding = node.padding();
    nodeWidth = node.width() + 2 * padding;
    nodeHeight = node.height() + 2 * padding;
    //
    // setup shift
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    //
    // load bg image
    var bgImgProp = node.pstyle('background-image');
    var urls = bgImgProp.value;
    var urlDefined = new Array(urls.length);
    var image = new Array(urls.length);
    var numImages = 0;
    for(var i = 0; i < urls.length; i++){
        var url = urls[i];
        var defd = urlDefined[i] = url != null && url !== 'none';
        if (defd) {
            var bgImgCrossOrigin = node.cy().style().getIndexedStyle(node, 'background-image-crossorigin', 'value', i);
            numImages++;
            // get image, and if not loaded then ask to redraw when later loaded
            image[i] = r.getCachedImage(url, bgImgCrossOrigin, function() {
                _p.backgroundTimestamp = Date.now();
                node.emitAndNotify('background');
            });
        }
    }
    //
    // setup styles
    var darkness = node.pstyle('background-blacken').value;
    var borderWidth = node.pstyle('border-width').pfValue;
    var bgOpacity = node.pstyle('background-opacity').value * eleOpacity;
    var borderColor = node.pstyle('border-color').value;
    var borderStyle = node.pstyle('border-style').value;
    var borderJoin = node.pstyle('border-join').value;
    var borderCap = node.pstyle('border-cap').value;
    var borderPosition = node.pstyle('border-position').value;
    var borderPattern = node.pstyle('border-dash-pattern').pfValue;
    var borderOffset = node.pstyle('border-dash-offset').pfValue;
    var borderOpacity = node.pstyle('border-opacity').value * eleOpacity;
    var outlineWidth = node.pstyle('outline-width').pfValue;
    var outlineColor = node.pstyle('outline-color').value;
    var outlineStyle = node.pstyle('outline-style').value;
    var outlineOpacity = node.pstyle('outline-opacity').value * eleOpacity;
    var outlineOffset = node.pstyle('outline-offset').value;
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var setupShapeColor = function setupShapeColor() {
        var bgOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bgOpacity;
        r.eleFillStyle(context, node, bgOpy);
    };
    var setupBorderColor = function setupBorderColor() {
        var bdrOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : borderOpacity;
        r.colorStrokeStyle(context, borderColor[0], borderColor[1], borderColor[2], bdrOpy);
    };
    var setupOutlineColor = function setupOutlineColor() {
        var otlnOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : outlineOpacity;
        r.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], otlnOpy);
    };
    //
    // setup shape
    var getPath = function getPath(width, height, shape, points) {
        var pathCache = r.nodePathCache = r.nodePathCache || [];
        var key = hashStrings(shape === 'polygon' ? shape + ',' + points.join(',') : shape, '' + height, '' + width, '' + cornerRadius);
        var cachedPath = pathCache[key];
        var path;
        var cacheHit = false;
        if (cachedPath != null) {
            path = cachedPath;
            cacheHit = true;
            rs.pathCache = path;
        } else {
            path = new Path2D();
            pathCache[key] = rs.pathCache = path;
        }
        return {
            path: path,
            cacheHit: cacheHit
        };
    };
    var styleShape = node.pstyle('shape').strValue;
    var shapePts = node.pstyle('shape-polygon-points').pfValue;
    if (usePaths) {
        context.translate(pos.x, pos.y);
        var shapePath = getPath(nodeWidth, nodeHeight, styleShape, shapePts);
        path = shapePath.path;
        pathCacheHit = shapePath.cacheHit;
    }
    var drawShape = function drawShape() {
        if (!pathCacheHit) {
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            r.nodeShapes[r.getNodeShape(node)].draw(path || context, npos.x, npos.y, nodeWidth, nodeHeight, cornerRadius, rs);
        }
        if (usePaths) context.fill(path);
        else context.fill();
    };
    var drawImages = function drawImages() {
        var nodeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var inside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var prevBging = _p.backgrounding;
        var totalCompleted = 0;
        for(var _i = 0; _i < image.length; _i++){
            var bgContainment = node.cy().style().getIndexedStyle(node, 'background-image-containment', 'value', _i);
            if (inside && bgContainment === 'over' || !inside && bgContainment === 'inside') {
                totalCompleted++;
                continue;
            }
            if (urlDefined[_i] && image[_i].complete && !image[_i].error) {
                totalCompleted++;
                r.drawInscribedImage(context, image[_i], node, _i, nodeOpacity);
            }
        }
        _p.backgrounding = !(totalCompleted === numImages);
        if (prevBging !== _p.backgrounding) // update style b/c :backgrounding state changed
        node.updateStyle(false);
    };
    var drawPie = function drawPie() {
        var redrawShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var pieOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eleOpacity;
        if (r.hasPie(node)) {
            r.drawPie(context, node, pieOpacity);
            // redraw/restore path if steps after pie need it
            if (redrawShape) {
                if (!usePaths) r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
            }
        }
    };
    var darken = function darken() {
        var darkenOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var opacity = (darkness > 0 ? darkness : -darkness) * darkenOpacity;
        var c = darkness > 0 ? 0 : 255;
        if (darkness !== 0) {
            r.colorFillStyle(context, c, c, c, opacity);
            if (usePaths) context.fill(path);
            else context.fill();
        }
    };
    var drawBorder = function drawBorder() {
        if (borderWidth > 0) {
            context.lineWidth = borderWidth;
            context.lineCap = borderCap;
            context.lineJoin = borderJoin;
            if (context.setLineDash) // for very outofdate browsers
            switch(borderStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash(borderPattern);
                    context.lineDashOffset = borderOffset;
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            if (borderPosition !== 'center') {
                context.save();
                context.lineWidth *= 2;
                if (borderPosition === 'inside') usePaths ? context.clip(path) : context.clip();
                else {
                    var region = new Path2D();
                    region.rect(-nodeWidth / 2 - borderWidth, -nodeHeight / 2 - borderWidth, nodeWidth + 2 * borderWidth, nodeHeight + 2 * borderWidth);
                    region.addPath(path);
                    context.clip(region, 'evenodd');
                }
                usePaths ? context.stroke(path) : context.stroke();
                context.restore();
            } else usePaths ? context.stroke(path) : context.stroke();
            if (borderStyle === 'double') {
                context.lineWidth = borderWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOutline = function drawOutline() {
        if (outlineWidth > 0) {
            context.lineWidth = outlineWidth;
            context.lineCap = 'butt';
            if (context.setLineDash) // for very outofdate browsers
            switch(outlineStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash([
                        4,
                        2
                    ]);
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            var shape = r.getNodeShape(node);
            var bWidth = borderWidth;
            if (borderPosition === 'inside') bWidth = 0;
            if (borderPosition === 'outside') bWidth *= 2;
            var scaleX = (nodeWidth + bWidth + (outlineWidth + outlineOffset)) / nodeWidth;
            var scaleY = (nodeHeight + bWidth + (outlineWidth + outlineOffset)) / nodeHeight;
            var sWidth = nodeWidth * scaleX;
            var sHeight = nodeHeight * scaleY;
            var points = r.nodeShapes[shape].points;
            var _path;
            if (usePaths) {
                var outlinePath = getPath(sWidth, sHeight, shape, points);
                _path = outlinePath.path;
            }
            // draw the outline path, either by using expanded points or by scaling 
            // the dimensions, depending on shape
            if (shape === "ellipse") r.drawEllipsePath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if ([
                'round-diamond',
                'round-heptagon',
                'round-hexagon',
                'round-octagon',
                'round-pentagon',
                'round-polygon',
                'round-triangle',
                'round-tag'
            ].includes(shape)) {
                var sMult = 0;
                var offsetX = 0;
                var offsetY = 0;
                if (shape === 'round-diamond') sMult = (bWidth + outlineOffset + outlineWidth) * 1.4;
                else if (shape === 'round-heptagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.075;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 35;
                } else if (shape === 'round-hexagon') sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                else if (shape === 'round-pentagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.13;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 15;
                } else if (shape === 'round-tag') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                    offsetX = (bWidth / 2 + outlineWidth + outlineOffset) * .07;
                } else if (shape === 'round-triangle') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * (Math.PI / 2);
                    offsetY = -(bWidth + outlineOffset / 2 + outlineWidth) / Math.PI;
                }
                if (sMult !== 0) {
                    scaleX = (nodeWidth + sMult) / nodeWidth;
                    sWidth = nodeWidth * scaleX;
                    if (![
                        'round-hexagon',
                        'round-tag'
                    ].includes(shape)) {
                        scaleY = (nodeHeight + sMult) / nodeHeight;
                        sHeight = nodeHeight * scaleY;
                    }
                }
                cornerRadius = cornerRadius === 'auto' ? getRoundPolygonRadius(sWidth, sHeight) : cornerRadius;
                var halfW = sWidth / 2;
                var halfH = sHeight / 2;
                var radius = cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2;
                var p = new Array(points.length / 2);
                var corners = new Array(points.length / 2);
                for(var _i2 = 0; _i2 < points.length / 2; _i2++)p[_i2] = {
                    x: npos.x + offsetX + halfW * points[_i2 * 2],
                    y: npos.y + offsetY + halfH * points[_i2 * 2 + 1]
                };
                var _i3, p1, p2, p3, len = p.length;
                p1 = p[len - 1];
                // for each point
                for(_i3 = 0; _i3 < len; _i3++){
                    p2 = p[_i3 % len];
                    p3 = p[(_i3 + 1) % len];
                    corners[_i3] = getRoundCorner(p1, p2, p3, radius);
                    p1 = p2;
                    p2 = p3;
                }
                r.drawRoundPolygonPath(_path || context, npos.x + offsetX, npos.y + offsetY, nodeWidth * scaleX, nodeHeight * scaleY, points, corners);
            } else if ([
                'roundrectangle',
                'round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if ([
                'cutrectangle',
                'cut-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? getCutRectangleCornerLength() : cornerRadius;
                r.drawCutRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, null, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 4);
            } else if ([
                'bottomroundrectangle',
                'bottom-round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawBottomRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if (shape === "barrel") r.drawBarrelPath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if (shape.startsWith("polygon") || [
                'rhomboid',
                'right-rhomboid',
                'round-tag',
                'tag',
                'vee'
            ].includes(shape)) {
                var pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = joinLines(expandPolygon(points, pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            } else {
                var _pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = joinLines(expandPolygon(points, -_pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            }
            if (usePaths) context.stroke(_path);
            else context.stroke();
            if (outlineStyle === 'double') {
                context.lineWidth = bWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(_path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOverlay = function drawOverlay() {
        if (shouldDrawOverlay) r.drawNodeOverlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawUnderlay = function drawUnderlay() {
        if (shouldDrawOverlay) r.drawNodeUnderlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawText = function drawText() {
        r.drawElementText(context, node, null, drawLabel);
    };
    var ghost = node.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = node.pstyle('ghost-offset-x').pfValue;
        var gy = node.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = node.pstyle('ghost-opacity').value;
        var effGhostOpacity = ghostOpacity * eleOpacity;
        context.translate(gx, gy);
        setupOutlineColor();
        drawOutline();
        setupShapeColor(ghostOpacity * bgOpacity);
        drawShape();
        drawImages(effGhostOpacity, true);
        setupBorderColor(ghostOpacity * borderOpacity);
        drawBorder();
        drawPie(darkness !== 0 || borderWidth !== 0);
        drawImages(effGhostOpacity, false);
        darken(effGhostOpacity);
        context.translate(-gx, -gy);
    }
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawUnderlay();
    if (usePaths) context.translate(pos.x, pos.y);
    setupOutlineColor();
    drawOutline();
    setupShapeColor();
    drawShape();
    drawImages(eleOpacity, true);
    setupBorderColor();
    drawBorder();
    drawPie(darkness !== 0 || borderWidth !== 0);
    drawImages(eleOpacity, false);
    darken();
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawText();
    drawOverlay();
    //
    // clean up shift
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var drawNodeOverlayUnderlay = function drawNodeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, node, pos, nodeWidth, nodeHeight) {
        var r = this;
        if (!node.visible()) return;
        var padding = node.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var opacity = node.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        var color = node.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        var shape = node.pstyle("".concat(overlayOrUnderlay, "-shape")).value;
        var radius = node.pstyle("".concat(overlayOrUnderlay, "-corner-radius")).value;
        if (opacity > 0) {
            pos = pos || node.position();
            if (nodeWidth == null || nodeHeight == null) {
                var _padding = node.padding();
                nodeWidth = node.width() + 2 * _padding;
                nodeHeight = node.height() + 2 * _padding;
            }
            r.colorFillStyle(context, color[0], color[1], color[2], opacity);
            r.nodeShapes[shape].draw(context, pos.x, pos.y, nodeWidth + padding * 2, nodeHeight + padding * 2, radius);
            context.fill();
        }
    };
};
CRp$6.drawNodeOverlay = drawNodeOverlayUnderlay('overlay');
CRp$6.drawNodeUnderlay = drawNodeOverlayUnderlay('underlay');
// does the node have at least one pie piece?
CRp$6.hasPie = function(node) {
    node = node[0]; // ensure ele ref
    return node._private.hasPie;
};
CRp$6.drawPie = function(context, node, nodeOpacity, pos) {
    node = node[0]; // ensure ele ref
    pos = pos || node.position();
    var cyStyle = node.cy().style();
    var pieSize = node.pstyle('pie-size');
    var x = pos.x;
    var y = pos.y;
    var nodeW = node.width();
    var nodeH = node.height();
    var radius = Math.min(nodeW, nodeH) / 2; // must fit in node
    var lastPercent = 0; // what % to continue drawing pie slices from on [0, 1]
    var usePaths = this.usePaths();
    if (usePaths) {
        x = 0;
        y = 0;
    }
    if (pieSize.units === '%') radius = radius * pieSize.pfValue;
    else if (pieSize.pfValue !== undefined) radius = pieSize.pfValue / 2;
    for(var i = 1; i <= cyStyle.pieBackgroundN; i++){
        // 1..N
        var size = node.pstyle('pie-' + i + '-background-size').value;
        var color = node.pstyle('pie-' + i + '-background-color').value;
        var opacity = node.pstyle('pie-' + i + '-background-opacity').value * nodeOpacity;
        var percent = size / 100; // map integer range [0, 100] to [0, 1]
        // percent can't push beyond 1
        if (percent + lastPercent > 1) percent = 1 - lastPercent;
        var angleStart = 1.5 * Math.PI + 2 * Math.PI * lastPercent; // start at 12 o'clock and go clockwise
        var angleDelta = 2 * Math.PI * percent;
        var angleEnd = angleStart + angleDelta;
        // ignore if
        // - zero size
        // - we're already beyond the full circle
        // - adding the current slice would go beyond the full circle
        if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) continue;
        context.beginPath();
        context.moveTo(x, y);
        context.arc(x, y, radius, angleStart, angleEnd);
        context.closePath();
        this.colorFillStyle(context, color[0], color[1], color[2], opacity);
        context.fill();
        lastPercent += percent;
    }
};
var CRp$5 = {};
var motionBlurDelay = 100;
// var isFirefox = typeof InstallTrigger !== 'undefined';
CRp$5.getPixelRatio = function() {
    var context = this.data.contexts[0];
    if (this.forcedPixelRatio != null) return this.forcedPixelRatio;
    var containerWindow = this.cy.window();
    var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    return (containerWindow.devicePixelRatio || 1) / backingStore; // eslint-disable-line no-undef
};
CRp$5.paintCache = function(context) {
    var caches = this.paintCaches = this.paintCaches || [];
    var needToCreateCache = true;
    var cache;
    for(var i = 0; i < caches.length; i++){
        cache = caches[i];
        if (cache.context === context) {
            needToCreateCache = false;
            break;
        }
    }
    if (needToCreateCache) {
        cache = {
            context: context
        };
        caches.push(cache);
    }
    return cache;
};
CRp$5.createGradientStyleFor = function(context, shapeStyleName, ele, fill, opacity) {
    var gradientStyle;
    var usePaths = this.usePaths();
    var colors = ele.pstyle(shapeStyleName + '-gradient-stop-colors').value, positions = ele.pstyle(shapeStyleName + '-gradient-stop-positions').pfValue;
    if (fill === 'radial-gradient') {
        if (ele.isEdge()) {
            var start = ele.sourceEndpoint(), end = ele.targetEndpoint(), mid = ele.midpoint();
            var d1 = dist(start, mid);
            var d2 = dist(end, mid);
            gradientStyle = context.createRadialGradient(mid.x, mid.y, 0, mid.x, mid.y, Math.max(d1, d2));
        } else {
            var pos = usePaths ? {
                x: 0,
                y: 0
            } : ele.position(), width = ele.paddedWidth(), height = ele.paddedHeight();
            gradientStyle = context.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, Math.max(width, height));
        }
    } else if (ele.isEdge()) {
        var _start = ele.sourceEndpoint(), _end = ele.targetEndpoint();
        gradientStyle = context.createLinearGradient(_start.x, _start.y, _end.x, _end.y);
    } else {
        var _pos = usePaths ? {
            x: 0,
            y: 0
        } : ele.position(), _width = ele.paddedWidth(), _height = ele.paddedHeight(), halfWidth = _width / 2, halfHeight = _height / 2;
        var direction = ele.pstyle('background-gradient-direction').value;
        switch(direction){
            case 'to-bottom':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y - halfHeight, _pos.x, _pos.y + halfHeight);
                break;
            case 'to-top':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y + halfHeight, _pos.x, _pos.y - halfHeight);
                break;
            case 'to-left':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y, _pos.x - halfWidth, _pos.y);
                break;
            case 'to-right':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y, _pos.x + halfWidth, _pos.y);
                break;
            case 'to-bottom-right':
            case 'to-right-bottom':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y - halfHeight, _pos.x + halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-right':
            case 'to-right-top':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y + halfHeight, _pos.x + halfWidth, _pos.y - halfHeight);
                break;
            case 'to-bottom-left':
            case 'to-left-bottom':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y - halfHeight, _pos.x - halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-left':
            case 'to-left-top':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y + halfHeight, _pos.x - halfWidth, _pos.y - halfHeight);
                break;
        }
    }
    if (!gradientStyle) return null; // invalid gradient style
    var hasPositions = positions.length === colors.length;
    var length = colors.length;
    for(var i = 0; i < length; i++)gradientStyle.addColorStop(hasPositions ? positions[i] : i / (length - 1), 'rgba(' + colors[i][0] + ',' + colors[i][1] + ',' + colors[i][2] + ',' + opacity + ')');
    return gradientStyle;
};
CRp$5.gradientFillStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'background', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.fillStyle = gradientStyle;
};
CRp$5.colorFillStyle = function(context, r, g, b, a) {
    context.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.fillStyle !== fillStyle ){
//   context.fillStyle = cache.fillStyle = fillStyle;
// }
};
CRp$5.eleFillStyle = function(context, ele, opacity) {
    var backgroundFill = ele.pstyle('background-fill').value;
    if (backgroundFill === 'linear-gradient' || backgroundFill === 'radial-gradient') this.gradientFillStyle(context, ele, backgroundFill, opacity);
    else {
        var backgroundColor = ele.pstyle('background-color').value;
        this.colorFillStyle(context, backgroundColor[0], backgroundColor[1], backgroundColor[2], opacity);
    }
};
CRp$5.gradientStrokeStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'line', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.strokeStyle = gradientStyle;
};
CRp$5.colorStrokeStyle = function(context, r, g, b, a) {
    context.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.strokeStyle !== strokeStyle ){
//   context.strokeStyle = cache.strokeStyle = strokeStyle;
// }
};
CRp$5.eleStrokeStyle = function(context, ele, opacity) {
    var lineFill = ele.pstyle('line-fill').value;
    if (lineFill === 'linear-gradient' || lineFill === 'radial-gradient') this.gradientStrokeStyle(context, ele, lineFill, opacity);
    else {
        var lineColor = ele.pstyle('line-color').value;
        this.colorStrokeStyle(context, lineColor[0], lineColor[1], lineColor[2], opacity);
    }
};
// Resize canvas
CRp$5.matchCanvasSize = function(container) {
    var r = this;
    var data = r.data;
    var bb = r.findContainerClientCoords();
    var width = bb[2];
    var height = bb[3];
    var pixelRatio = r.getPixelRatio();
    var mbPxRatio = r.motionBlurPxRatio;
    if (container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE] || container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG]) pixelRatio = mbPxRatio;
    var canvasWidth = width * pixelRatio;
    var canvasHeight = height * pixelRatio;
    var canvas;
    if (canvasWidth === r.canvasWidth && canvasHeight === r.canvasHeight) return; // save cycles if same
    r.fontCaches = null; // resizing resets the style
    var canvasContainer = data.canvasContainer;
    canvasContainer.style.width = width + 'px';
    canvasContainer.style.height = height + 'px';
    for(var i = 0; i < r.CANVAS_LAYERS; i++){
        canvas = data.canvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    for(var i = 0; i < r.BUFFER_COUNT; i++){
        canvas = data.bufferCanvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    r.textureMult = 1;
    if (pixelRatio <= 1) {
        canvas = data.bufferCanvases[r.TEXTURE_BUFFER];
        r.textureMult = 2;
        canvas.width = canvasWidth * r.textureMult;
        canvas.height = canvasHeight * r.textureMult;
    }
    r.canvasWidth = canvasWidth;
    r.canvasHeight = canvasHeight;
    r.pixelRatio = pixelRatio;
};
CRp$5.renderTo = function(cxt, zoom, pan, pxRatio) {
    this.render({
        forcedContext: cxt,
        forcedZoom: zoom,
        forcedPan: pan,
        drawAllLayers: true,
        forcedPxRatio: pxRatio
    });
};
CRp$5.clearCanvas = function() {
    var r = this;
    var data = r.data;
    function clear(context) {
        context.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
    }
    clear(data.contexts[r.NODE]);
    clear(data.contexts[r.DRAG]);
};
CRp$5.render = function(options) {
    var r = this;
    options = options || staticEmptyObject();
    var cy = r.cy;
    var forcedContext = options.forcedContext;
    var drawAllLayers = options.drawAllLayers;
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var forcedZoom = options.forcedZoom;
    var forcedPan = options.forcedPan;
    var pixelRatio = options.forcedPxRatio === undefined ? this.getPixelRatio() : options.forcedPxRatio;
    var data = r.data;
    var needDraw = data.canvasNeedsRedraw;
    var textureDraw = r.textureOnViewport && !forcedContext && (r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming);
    var motionBlur = options.motionBlur !== undefined ? options.motionBlur : r.motionBlur;
    var mbPxRatio = r.motionBlurPxRatio;
    var hasCompoundNodes = cy.hasCompoundNodes();
    var inNodeDragGesture = r.hoverData.draggingEles;
    var inBoxSelection = r.hoverData.selecting || r.touchData.selecting ? true : false;
    motionBlur = motionBlur && !forcedContext && r.motionBlurEnabled && !inBoxSelection;
    var motionBlurFadeEffect = motionBlur;
    if (!forcedContext) {
        if (r.prevPxRatio !== pixelRatio) {
            r.invalidateContainerClientCoordsCache();
            r.matchCanvasSize(r.container);
            r.redrawHint('eles', true);
            r.redrawHint('drag', true);
        }
        r.prevPxRatio = pixelRatio;
    }
    if (!forcedContext && r.motionBlurTimeout) clearTimeout(r.motionBlurTimeout);
    if (motionBlur) {
        if (r.mbFrames == null) r.mbFrames = 0;
        r.mbFrames++;
        if (r.mbFrames < 3) // need several frames before even high quality motionblur
        motionBlurFadeEffect = false;
        // go to lower quality blurry frames when several m/b frames have been rendered (avoids flashing)
        if (r.mbFrames > r.minMbLowQualFrames) //r.fullQualityMb = false;
        r.motionBlurPxRatio = r.mbPxRBlurry;
    }
    if (r.clearingMotionBlur) r.motionBlurPxRatio = 1;
    // b/c drawToContext() may be async w.r.t. redraw(), keep track of last texture frame
    // because a rogue async texture frame would clear needDraw
    if (r.textureDrawLastFrame && !textureDraw) {
        needDraw[r.NODE] = true;
        needDraw[r.SELECT_BOX] = true;
    }
    var style = cy.style();
    var zoom = cy.zoom();
    var effectiveZoom = forcedZoom !== undefined ? forcedZoom : zoom;
    var pan = cy.pan();
    var effectivePan = {
        x: pan.x,
        y: pan.y
    };
    var vp = {
        zoom: zoom,
        pan: {
            x: pan.x,
            y: pan.y
        }
    };
    var prevVp = r.prevViewport;
    var viewportIsDiff = prevVp === undefined || vp.zoom !== prevVp.zoom || vp.pan.x !== prevVp.pan.x || vp.pan.y !== prevVp.pan.y;
    // we want the low quality motionblur only when the viewport is being manipulated etc (where it's not noticed)
    if (!viewportIsDiff && !(inNodeDragGesture && !hasCompoundNodes)) r.motionBlurPxRatio = 1;
    if (forcedPan) effectivePan = forcedPan;
    // apply pixel ratio
    effectiveZoom *= pixelRatio;
    effectivePan.x *= pixelRatio;
    effectivePan.y *= pixelRatio;
    var eles = r.getCachedZSortedEles();
    function mbclear(context, x, y, w, h) {
        var gco = context.globalCompositeOperation;
        context.globalCompositeOperation = 'destination-out';
        r.colorFillStyle(context, 255, 255, 255, r.motionBlurTransparency);
        context.fillRect(x, y, w, h);
        context.globalCompositeOperation = gco;
    }
    function setContextTransform(context, clear) {
        var ePan, eZoom, w, h;
        if (!r.clearingMotionBlur && (context === data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] || context === data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG])) {
            ePan = {
                x: pan.x * mbPxRatio,
                y: pan.y * mbPxRatio
            };
            eZoom = zoom * mbPxRatio;
            w = r.canvasWidth * mbPxRatio;
            h = r.canvasHeight * mbPxRatio;
        } else {
            ePan = effectivePan;
            eZoom = effectiveZoom;
            w = r.canvasWidth;
            h = r.canvasHeight;
        }
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (clear === 'motionBlur') mbclear(context, 0, 0, w, h);
        else if (!forcedContext && (clear === undefined || clear)) context.clearRect(0, 0, w, h);
        if (!drawAllLayers) {
            context.translate(ePan.x, ePan.y);
            context.scale(eZoom, eZoom);
        }
        if (forcedPan) context.translate(forcedPan.x, forcedPan.y);
        if (forcedZoom) context.scale(forcedZoom, forcedZoom);
    }
    if (!textureDraw) r.textureDrawLastFrame = false;
    if (textureDraw) {
        r.textureDrawLastFrame = true;
        if (!r.textureCache) {
            r.textureCache = {};
            r.textureCache.bb = cy.mutableElements().boundingBox();
            r.textureCache.texture = r.data.bufferCanvases[r.TEXTURE_BUFFER];
            var cxt = r.data.bufferContexts[r.TEXTURE_BUFFER];
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            cxt.clearRect(0, 0, r.canvasWidth * r.textureMult, r.canvasHeight * r.textureMult);
            r.render({
                forcedContext: cxt,
                drawOnlyNodeLayer: true,
                forcedPxRatio: pixelRatio * r.textureMult
            });
            var vp = r.textureCache.viewport = {
                zoom: cy.zoom(),
                pan: cy.pan(),
                width: r.canvasWidth,
                height: r.canvasHeight
            };
            vp.mpan = {
                x: (0 - vp.pan.x) / vp.zoom,
                y: (0 - vp.pan.y) / vp.zoom
            };
        }
        needDraw[r.DRAG] = false;
        needDraw[r.NODE] = false;
        var context = data.contexts[r.NODE];
        var texture = r.textureCache.texture;
        var vp = r.textureCache.viewport;
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (motionBlur) mbclear(context, 0, 0, vp.width, vp.height);
        else context.clearRect(0, 0, vp.width, vp.height);
        var outsideBgColor = style.core('outside-texture-bg-color').value;
        var outsideBgOpacity = style.core('outside-texture-bg-opacity').value;
        r.colorFillStyle(context, outsideBgColor[0], outsideBgColor[1], outsideBgColor[2], outsideBgOpacity);
        context.fillRect(0, 0, vp.width, vp.height);
        var zoom = cy.zoom();
        setContextTransform(context, false);
        context.clearRect(vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
        context.drawImage(texture, vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
    } else if (r.textureOnViewport && !forcedContext) // clear the cache since we don't need it
    r.textureCache = null;
    var extent = cy.extent();
    var vpManip = r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming || r.hoverData.draggingEles || r.cy.animated();
    var hideEdges = r.hideEdgesOnViewport && vpManip;
    var needMbClear = [];
    needMbClear[r.NODE] = !needDraw[r.NODE] && motionBlur && !r.clearedForMotionBlur[r.NODE] || r.clearingMotionBlur;
    if (needMbClear[r.NODE]) r.clearedForMotionBlur[r.NODE] = true;
    needMbClear[r.DRAG] = !needDraw[r.DRAG] && motionBlur && !r.clearedForMotionBlur[r.DRAG] || r.clearingMotionBlur;
    if (needMbClear[r.DRAG]) r.clearedForMotionBlur[r.DRAG] = true;
    if (needDraw[r.NODE] || drawAllLayers || drawOnlyNodeLayer || needMbClear[r.NODE]) {
        var useBuffer = motionBlur && !needMbClear[r.NODE] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] : data.contexts[r.NODE]);
        var clear = motionBlur && !useBuffer ? 'motionBlur' : undefined;
        setContextTransform(context, clear);
        if (hideEdges) r.drawCachedNodes(context, eles.nondrag, pixelRatio, extent);
        else r.drawLayeredElements(context, eles.nondrag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.nondrag);
        if (!drawAllLayers && !motionBlur) needDraw[r.NODE] = false;
    }
    if (!drawOnlyNodeLayer && (needDraw[r.DRAG] || drawAllLayers || needMbClear[r.DRAG])) {
        var useBuffer = motionBlur && !needMbClear[r.DRAG] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG] : data.contexts[r.DRAG]);
        setContextTransform(context, motionBlur && !useBuffer ? 'motionBlur' : undefined);
        if (hideEdges) r.drawCachedNodes(context, eles.drag, pixelRatio, extent);
        else r.drawCachedElements(context, eles.drag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.drag);
        if (!drawAllLayers && !motionBlur) needDraw[r.DRAG] = false;
    }
    this.drawSelectionRectangle(options, setContextTransform);
    // motionblur: blit rendered blurry frames
    if (motionBlur && mbPxRatio !== 1) {
        var cxtNode = data.contexts[r.NODE];
        var txtNode = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE];
        var cxtDrag = data.contexts[r.DRAG];
        var txtDrag = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG];
        var drawMotionBlur = function drawMotionBlur(cxt, txt, needClear) {
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            if (needClear || !motionBlurFadeEffect) cxt.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
            else mbclear(cxt, 0, 0, r.canvasWidth, r.canvasHeight);
            var pxr = mbPxRatio;
            cxt.drawImage(txt, // img
            0, 0, // sx, sy
            r.canvasWidth * pxr, r.canvasHeight * pxr, // sw, sh
            0, 0, // x, y
            r.canvasWidth, r.canvasHeight // w, h
            );
        };
        if (needDraw[r.NODE] || needMbClear[r.NODE]) {
            drawMotionBlur(cxtNode, txtNode, needMbClear[r.NODE]);
            needDraw[r.NODE] = false;
        }
        if (needDraw[r.DRAG] || needMbClear[r.DRAG]) {
            drawMotionBlur(cxtDrag, txtDrag, needMbClear[r.DRAG]);
            needDraw[r.DRAG] = false;
        }
    }
    r.prevViewport = vp;
    if (r.clearingMotionBlur) {
        r.clearingMotionBlur = false;
        r.motionBlurCleared = true;
        r.motionBlur = true;
    }
    if (motionBlur) r.motionBlurTimeout = setTimeout(function() {
        r.motionBlurTimeout = null;
        r.clearedForMotionBlur[r.NODE] = false;
        r.clearedForMotionBlur[r.DRAG] = false;
        r.motionBlur = false;
        r.clearingMotionBlur = !textureDraw;
        r.mbFrames = 0;
        needDraw[r.NODE] = true;
        needDraw[r.DRAG] = true;
        r.redraw();
    }, motionBlurDelay);
    if (!forcedContext) cy.emit('render');
};
var fpsHeight;
CRp$5.drawSelectionRectangle = function(options, setContextTransform) {
    var r = this;
    var cy = r.cy;
    var data = r.data;
    var style = cy.style();
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var drawAllLayers = options.drawAllLayers;
    var needDraw = data.canvasNeedsRedraw;
    var forcedContext = options.forcedContext;
    if (r.showFps || !drawOnlyNodeLayer && needDraw[r.SELECT_BOX] && !drawAllLayers) {
        var context = forcedContext || data.contexts[r.SELECT_BOX];
        setContextTransform(context);
        if (r.selection[4] == 1 && (r.hoverData.selecting || r.touchData.selecting)) {
            var zoom = r.cy.zoom();
            var borderWidth = style.core('selection-box-border-width').value / zoom;
            context.lineWidth = borderWidth;
            context.fillStyle = 'rgba(' + style.core('selection-box-color').value[0] + ',' + style.core('selection-box-color').value[1] + ',' + style.core('selection-box-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
            context.fillRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            if (borderWidth > 0) {
                context.strokeStyle = 'rgba(' + style.core('selection-box-border-color').value[0] + ',' + style.core('selection-box-border-color').value[1] + ',' + style.core('selection-box-border-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
                context.strokeRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            }
        }
        if (data.bgActivePosistion && !r.hoverData.selecting) {
            var zoom = r.cy.zoom();
            var pos = data.bgActivePosistion;
            context.fillStyle = 'rgba(' + style.core('active-bg-color').value[0] + ',' + style.core('active-bg-color').value[1] + ',' + style.core('active-bg-color').value[2] + ',' + style.core('active-bg-opacity').value + ')';
            context.beginPath();
            context.arc(pos.x, pos.y, style.core('active-bg-size').pfValue / zoom, 0, 2 * Math.PI);
            context.fill();
        }
        var timeToRender = r.lastRedrawTime;
        if (r.showFps && timeToRender) {
            timeToRender = Math.round(timeToRender);
            var fps = Math.round(1000 / timeToRender);
            var text = '1 frame = ' + timeToRender + ' ms = ' + fps + ' fps';
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.fillStyle = 'rgba(255, 0, 0, 0.75)';
            context.strokeStyle = 'rgba(255, 0, 0, 0.75)';
            // context.lineWidth = 1;
            context.font = '30px Arial';
            if (!fpsHeight) {
                var dims = context.measureText(text);
                fpsHeight = dims.actualBoundingBoxAscent;
            }
            context.fillText(text, 0, fpsHeight);
            var maxFps = 60;
            context.strokeRect(0, fpsHeight + 10, 250, 20);
            context.fillRect(0, fpsHeight + 10, 250 * Math.min(fps / maxFps, 1), 20);
        }
        if (!drawAllLayers) needDraw[r.SELECT_BOX] = false;
    }
};
/**
 * Notes:
 * - All colors have premultiplied alpha. Very important for textues and 
 *   blending to work correctly.
 */ function compileShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
    // console.log(gl.getShaderInfoLog(shader));
    return shader;
}
function createProgram(gl, vertexSource, fragementSource) {
    var vertexShader = compileShader(gl, gl.VERTEX_SHADER, vertexSource);
    var fragmentShader = compileShader(gl, gl.FRAGMENT_SHADER, fragementSource);
    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Could not initialize shaders');
    return program;
}
/**
 * Creates an offscren canvas with a 2D context, for the
 * canvas renderer to use for drawing textures.
 */ function createTextureCanvas(r, width, height) {
    if (height === undefined) height = width;
    var canvas = r.makeOffscreenCanvas(width, height);
    var ctx = canvas.context = canvas.getContext('2d');
    canvas.clear = function() {
        return ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    canvas.clear();
    return canvas;
}
/**
 * Returns the current pan & zoom values, scaled by the pixel ratio.
 */ function getEffectivePanZoom(r) {
    var pixelRatio = r.pixelRatio;
    var zoom = r.cy.zoom();
    var pan = r.cy.pan();
    return {
        zoom: zoom * pixelRatio,
        pan: {
            x: pan.x * pixelRatio,
            y: pan.y * pixelRatio
        }
    };
}
function modelToRenderedPosition(r, pan, zoom, x, y) {
    var rx = x * zoom + pan.x;
    var ry = y * zoom + pan.y;
    ry = Math.round(r.canvasHeight - ry); // adjust for webgl
    return [
        rx,
        ry
    ];
}
/**
 * Takes color & opacity style values and converts them to WebGL format. 
 * Alpha is premultiplied.
 */ function toWebGLColor(color, opacity, outArray) {
    var r = color[0] / 255;
    var g = color[1] / 255;
    var b = color[2] / 255;
    var a = opacity;
    var arr = outArray || new Array(4);
    arr[0] = r * a;
    arr[1] = g * a;
    arr[2] = b * a;
    arr[3] = a;
    return arr;
}
function indexToVec4(index, outArray) {
    var arr = outArray || new Array(4);
    arr[0] = (index >> 0 & 0xFF) / 0xFF;
    arr[1] = (index >> 8 & 0xFF) / 0xFF;
    arr[2] = (index >> 16 & 0xFF) / 0xFF;
    arr[3] = (index >> 24 & 0xFF) / 0xFF;
    return arr;
}
function vec4ToIndex(vec4) {
    return vec4[0] + (vec4[1] << 8) + (vec4[2] << 16) + (vec4[3] << 24);
}
function createTexture(gl, debugID) {
    var texture = gl.createTexture();
    texture.buffer = function(offscreenCanvas) {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
        // very important, this tells webgl to premultiply colors by the alpha channel
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, offscreenCanvas);
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.bindTexture(gl.TEXTURE_2D, null);
    };
    texture.deleteTexture = function() {
        gl.deleteTexture(texture);
    };
    return texture;
}
function getTypeInfo(gl, glslType) {
    switch(glslType){
        case 'float':
            return [
                1,
                gl.FLOAT,
                4
            ];
        case 'vec2':
            return [
                2,
                gl.FLOAT,
                4
            ];
        case 'vec3':
            return [
                3,
                gl.FLOAT,
                4
            ];
        case 'vec4':
            return [
                4,
                gl.FLOAT,
                4
            ];
        case 'int':
            return [
                1,
                gl.INT,
                4
            ];
        case 'ivec2':
            return [
                2,
                gl.INT,
                4
            ];
    }
}
function createTypedArray(gl, glType, dataOrSize) {
    switch(glType){
        case gl.FLOAT:
            return new Float32Array(dataOrSize);
        case gl.INT:
            return new Int32Array(dataOrSize);
    }
}
function createTypedArrayView(gl, glType, array, stride, size, i) {
    switch(glType){
        case gl.FLOAT:
            return new Float32Array(array.buffer, i * stride, size);
        case gl.INT:
            return new Int32Array(array.buffer, i * stride, size);
    }
}
/** @param {WebGLRenderingContext} gl */ function createBufferStaticDraw(gl, type, attributeLoc, dataArray) {
    var _getTypeInfo = getTypeInfo(gl, type), _getTypeInfo2 = _slicedToArray(_getTypeInfo, 2), size = _getTypeInfo2[0], glType = _getTypeInfo2[1];
    var data = createTypedArray(gl, glType, dataArray);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
    if (glType === gl.FLOAT) gl.vertexAttribPointer(attributeLoc, size, glType, false, 0, 0);
    else if (glType === gl.INT) gl.vertexAttribIPointer(attributeLoc, size, glType, 0, 0);
    gl.enableVertexAttribArray(attributeLoc);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return buffer;
}
/** 
 * Creates a float buffer with gl.DYNAMIC_DRAW.
 * The returned buffer object contains functions to easily set instance data and buffer the data before a draw call.
 * @param {WebGLRenderingContext} gl 
 */ function createBufferDynamicDraw(gl, instances, type, attributeLoc) {
    var _getTypeInfo3 = getTypeInfo(gl, type), _getTypeInfo4 = _slicedToArray(_getTypeInfo3, 3), size = _getTypeInfo4[0], glType = _getTypeInfo4[1], bytes = _getTypeInfo4[2];
    var dataArray = createTypedArray(gl, glType, instances * size);
    var stride = size * bytes;
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, instances * stride, gl.DYNAMIC_DRAW);
    gl.enableVertexAttribArray(attributeLoc);
    if (glType === gl.FLOAT) gl.vertexAttribPointer(attributeLoc, size, glType, false, stride, 0);
    else if (glType === gl.INT) gl.vertexAttribIPointer(attributeLoc, size, glType, stride, 0);
    gl.vertexAttribDivisor(attributeLoc, 1);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    // use array views to set values directly into the buffer array
    var views = new Array(instances);
    for(var i = 0; i < instances; i++)views[i] = createTypedArrayView(gl, glType, dataArray, stride, size, i);
    buffer.dataArray = dataArray;
    buffer.stride = stride;
    buffer.size = size;
    buffer.getView = function(i) {
        return views[i];
    };
    buffer.setPoint = function(i, x, y) {
        var view = views[i];
        view[0] = x;
        view[1] = y;
    };
    buffer.bufferSubData = function(count) {
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        if (count) gl.bufferSubData(gl.ARRAY_BUFFER, 0, dataArray, 0, count * size);
        else gl.bufferSubData(gl.ARRAY_BUFFER, 0, dataArray);
    };
    return buffer;
}
/** 
 * Creates a buffer of 3x3 matrix data for use as attribute data.
 * @param {WebGLRenderingContext} gl 
 */ function create3x3MatrixBufferDynamicDraw(gl, instances, attributeLoc) {
    var matrixSize = 9; // 3x3 matrix
    var matrixData = new Float32Array(instances * matrixSize);
    // use matrix views to set values directly into the matrixData array
    var matrixViews = new Array(instances);
    for(var i = 0; i < instances; i++){
        var byteOffset = i * matrixSize * 4; // 4 bytes per float
        matrixViews[i] = new Float32Array(matrixData.buffer, byteOffset, matrixSize); // array view
    }
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, matrixData.byteLength, gl.DYNAMIC_DRAW);
    // each row of the matrix needs to be a separate attribute
    for(var _i = 0; _i < 3; _i++){
        var loc = attributeLoc + _i;
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 3, gl.FLOAT, false, 36, _i * 12);
        gl.vertexAttribDivisor(loc, 1);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    buffer.getMatrixView = function(i) {
        return matrixViews[i];
    };
    // TODO this is too slow, use getMatrixView and pass the view directly to the glmatrix library
    buffer.setData = function(matrix, i) {
        matrixViews[i].set(matrix, 0);
    };
    buffer.bufferSubData = function() {
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferSubData(gl.ARRAY_BUFFER, 0, matrixData);
    };
    return buffer;
}
/** 
 * Creates a Frame Buffer to use for offscreen rendering.
 * @param {WebGLRenderingContext} gl 
 */ function createPickingFrameBuffer(gl) {
    // Create and bind the framebuffer
    var fb = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    // Create a texture to render to
    var targetTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, targetTexture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // attach the texture as the first color attachment
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, targetTexture, 0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    fb.setFramebufferAttachmentSizes = function(width, height) {
        gl.bindTexture(gl.TEXTURE_2D, targetTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    };
    return fb;
}
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};
/**
 * 3x3 Matrix
 * @module mat3
 */ /**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */ function create() {
    var out = new ARRAY_TYPE(9);
    if (ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */ function identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */ function multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */ function translate(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */ function rotate(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/ function scale(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */ function projection(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
var RENDER_TARGET = {
    SCREEN: {
        name: 'screen',
        screen: true
    },
    PICKING: {
        name: 'picking',
        picking: true
    }
};
var atlasCollectionDefaults = defaults$g({
    texRows: 24
});
var renderDefaults = defaults$g({
    collection: 'default',
    getKey: null,
    // since render types (eg node-body, node-overlay) can share an atlas collection, its importeant their style keys don't collide
    drawElement: null,
    getBoundingBox: null,
    getRotation: null,
    getRotationPoint: null,
    getRotationOffset: null,
    isVisible: function isVisible() {
        return true;
    },
    // this is an extra check for visibility in addition to ele.visible()
    getPadding: 0
});
// A "texture atlas" is a big image/canvas, and sections of it are used as textures for nodes/labels.
/**
 * A single square texture atlas (also known as a "sprite sheet").
 */ var Atlas = /*#__PURE__*/ function() {
    function Atlas(r, texSize, texRows, createTextureCanvas) {
        _classCallCheck(this, Atlas);
        this.debugID = Math.floor(Math.random() * 10000);
        this.r = r;
        this.texSize = texSize;
        this.texRows = texRows;
        this.texHeight = Math.floor(texSize / texRows);
        this.enableWrapping = true; // hardcoded for now, can be made an option
        this.locked = false; // once an atlas is locked it can no longer be drawn to
        this.texture = null; // WebGLTexture object
        this.needsBuffer = true;
        // a "location" is an object with a 'row' and 'x' fields
        this.freePointer = {
            x: 0,
            row: 0
        };
        // map from the style key to the row/x where the texture starts
        // if the texture wraps then there's a second location
        this.keyToLocation = new Map(); // styleKey -> [ location, location ]
        this.canvas = createTextureCanvas(r, texSize, texSize);
        this.scratch = createTextureCanvas(r, texSize, this.texHeight, 'scratch');
    }
    return _createClass(Atlas, [
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                return new Set(this.keyToLocation.keys());
            }
        },
        {
            key: "getScale",
            value: function getScale(_ref) {
                var w = _ref.w, h = _ref.h;
                var texHeight = this.texHeight, maxTexWidth = this.texSize;
                // try to fit to the height of a row
                var scale = texHeight / h; // TODO what about pixelRatio?
                var texW = w * scale;
                var texH = h * scale;
                // if the scaled width is too wide then scale to fit max width instead
                if (texW > maxTexWidth) {
                    scale = maxTexWidth / w;
                    texW = w * scale;
                    texH = h * scale;
                }
                return {
                    scale: scale,
                    texW: texW,
                    texH: texH
                };
            }
        },
        {
            key: "draw",
            value: function draw(key, bb, doDrawing) {
                var _this = this;
                if (this.locked) throw new Error('can\'t draw, atlas is locked');
                var texSize = this.texSize, texRows = this.texRows, texHeight = this.texHeight;
                var _this$getScale = this.getScale(bb), scale = _this$getScale.scale, texW = _this$getScale.texW, texH = _this$getScale.texH;
                var locations = [
                    null,
                    null
                ];
                var drawAt = function drawAt(location, canvas) {
                    if (doDrawing && canvas) {
                        var context = canvas.context;
                        var x = location.x, row = location.row;
                        var xOffset = x;
                        var yOffset = texHeight * row;
                        context.save();
                        context.translate(xOffset, yOffset);
                        context.scale(scale, scale);
                        doDrawing(context, bb);
                        context.restore();
                    }
                };
                var drawNormal = function drawNormal() {
                    // don't need to wrap, draw directly on the canvas
                    drawAt(_this.freePointer, _this.canvas);
                    locations[0] = {
                        x: _this.freePointer.x,
                        y: _this.freePointer.row * texHeight,
                        w: texW,
                        h: texH
                    };
                    locations[1] = {
                        // indlude a second location with a width of 0, for convenience
                        x: _this.freePointer.x + texW,
                        y: _this.freePointer.row * texHeight,
                        w: 0,
                        h: texH
                    };
                    // move the pointer to the end of the texture
                    _this.freePointer.x += texW;
                    if (_this.freePointer.x == texSize) {
                        // move to the next row
                        // TODO what if there is no next row???
                        _this.freePointer.x = 0;
                        _this.freePointer.row++;
                    }
                };
                var drawWrapped = function drawWrapped() {
                    var scratch = _this.scratch, canvas = _this.canvas;
                    // Draw to the scratch canvas
                    scratch.clear();
                    drawAt({
                        x: 0,
                        row: 0
                    }, scratch);
                    var firstTexW = texSize - _this.freePointer.x;
                    var secondTexW = texW - firstTexW;
                    var h = texHeight;
                    // copy first part of scratch to the first texture
                    var dx = _this.freePointer.x;
                    var dy = _this.freePointer.row * texHeight;
                    var w = firstTexW;
                    canvas.context.drawImage(scratch, 0, 0, w, h, dx, dy, w, h);
                    locations[0] = {
                        x: dx,
                        y: dy,
                        w: w,
                        h: texH
                    };
                    // copy second part of scratch to the second texture
                    var sx = firstTexW;
                    var _dy = (_this.freePointer.row + 1) * texHeight;
                    var _w = secondTexW;
                    if (canvas) canvas.context.drawImage(scratch, sx, 0, _w, h, 0, _dy, _w, h);
                    locations[1] = {
                        x: 0,
                        y: _dy,
                        w: _w,
                        h: texH
                    };
                    _this.freePointer.x = secondTexW;
                    _this.freePointer.row++;
                };
                var moveToStartOfNextRow = function moveToStartOfNextRow() {
                    _this.freePointer.x = 0;
                    _this.freePointer.row++;
                };
                if (this.freePointer.x + texW <= texSize) // There's enough space in the current row
                drawNormal();
                else if (this.freePointer.row >= texRows - 1) // Need to move to the next row, but there are no more rows, atlas is full.
                return false;
                else if (this.freePointer.x === texSize) {
                    // happen to be right at end of current row
                    moveToStartOfNextRow();
                    drawNormal();
                } else if (this.enableWrapping) // draw part of the texture to the end of the curent row, then wrap to the next row
                drawWrapped();
                else {
                    // move to the start of the next row, then draw normally
                    moveToStartOfNextRow();
                    drawNormal();
                }
                this.keyToLocation.set(key, locations);
                this.needsBuffer = true;
                return locations;
            }
        },
        {
            key: "getOffsets",
            value: function getOffsets(key) {
                return this.keyToLocation.get(key);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.freePointer.x === 0 && this.freePointer.row === 0;
            }
        },
        {
            key: "canFit",
            value: function canFit(bb) {
                if (this.locked) return false;
                var texSize = this.texSize, texRows = this.texRows;
                var _this$getScale2 = this.getScale(bb), texW = _this$getScale2.texW;
                if (this.freePointer.x + texW > texSize) // need to wrap
                return this.freePointer.row < texRows - 1; // return true if there's a row to wrap to
                return true;
            }
        },
        {
            key: "bufferIfNeeded",
            value: function bufferIfNeeded(gl) {
                if (!this.texture) this.texture = createTexture(gl, this.debugID);
                if (this.needsBuffer) {
                    this.texture.buffer(this.canvas);
                    this.needsBuffer = false;
                    if (this.locked) {
                        this.canvas = null;
                        this.scratch = null;
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.texture) {
                    this.texture.deleteTexture();
                    this.texture = null;
                }
                this.canvas = null;
                this.scratch = null;
                this.locked = true;
            }
        }
    ]);
}();
/**
 * A collection of texture atlases, all of the same "render type". 
 * (Node body is an example of a render type.)
 * An AtlasCollection can also be notified when a texture is no longer needed, 
 * and it can garbage collect the unused textures.
 */ var AtlasCollection = /*#__PURE__*/ function() {
    function AtlasCollection(r, texSize, texRows, createTextureCanvas) {
        _classCallCheck(this, AtlasCollection);
        this.r = r;
        this.texSize = texSize;
        this.texRows = texRows;
        this.createTextureCanvas = createTextureCanvas;
        this.atlases = [];
        this.styleKeyToAtlas = new Map();
        this.markedKeys = new Set(); // marked for garbage collection
    }
    return _createClass(AtlasCollection, [
        {
            key: "getKeys",
            value: function getKeys() {
                return new Set(this.styleKeyToAtlas.keys());
            }
        },
        {
            key: "_createAtlas",
            value: function _createAtlas() {
                var r = this.r, texSize = this.texSize, texRows = this.texRows, createTextureCanvas = this.createTextureCanvas;
                return new Atlas(r, texSize, texRows, createTextureCanvas);
            }
        },
        {
            key: "_getScratchCanvas",
            value: function _getScratchCanvas() {
                if (!this.scratch) {
                    var r = this.r, texSize = this.texSize, texRows = this.texRows, createTextureCanvas = this.createTextureCanvas;
                    var texHeight = Math.floor(texSize / texRows);
                    this.scratch = createTextureCanvas(r, texSize, texHeight, 'scratch');
                }
                return this.scratch;
            }
        },
        {
            key: "draw",
            value: function draw(key, bb, doDrawing) {
                var atlas = this.styleKeyToAtlas.get(key);
                if (!atlas) {
                    // check for space at the end of the last atlas
                    atlas = this.atlases[this.atlases.length - 1];
                    if (!atlas || !atlas.canFit(bb)) {
                        if (atlas) atlas.lock();
                        // create a new atlas
                        atlas = this._createAtlas();
                        this.atlases.push(atlas);
                    }
                    atlas.draw(key, bb, doDrawing);
                    this.styleKeyToAtlas.set(key, atlas);
                }
                return atlas;
            }
        },
        {
            key: "getAtlas",
            value: function getAtlas(key) {
                return this.styleKeyToAtlas.get(key);
            }
        },
        {
            key: "hasAtlas",
            value: function hasAtlas(key) {
                return this.styleKeyToAtlas.has(key);
            }
        },
        {
            key: "markKeyForGC",
            value: function markKeyForGC(key) {
                this.markedKeys.add(key);
            }
        },
        {
            key: "gc",
            value: function gc() {
                var _this2 = this;
                var markedKeys = this.markedKeys;
                if (markedKeys.size === 0) {
                    console.log('nothing to garbage collect');
                    return;
                }
                var newAtlases = [];
                var newStyleKeyToAtlas = new Map();
                var newAtlas = null;
                var _iterator = _createForOfIteratorHelper(this.atlases), _step;
                try {
                    var _loop = function _loop() {
                        var atlas = _step.value;
                        var keys = atlas.getKeys();
                        var keysToCollect = intersection(markedKeys, keys);
                        if (keysToCollect.size === 0) {
                            // this atlas can still be used
                            newAtlases.push(atlas);
                            keys.forEach(function(k) {
                                return newStyleKeyToAtlas.set(k, atlas);
                            });
                            return 1; // continue
                        }
                        if (!newAtlas) {
                            newAtlas = _this2._createAtlas();
                            newAtlases.push(newAtlas);
                        }
                        var _iterator2 = _createForOfIteratorHelper(keys), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var key = _step2.value;
                                if (!keysToCollect.has(key)) {
                                    var _atlas$getOffsets = atlas.getOffsets(key), _atlas$getOffsets2 = _slicedToArray(_atlas$getOffsets, 2), s1 = _atlas$getOffsets2[0], s2 = _atlas$getOffsets2[1];
                                    if (!newAtlas.canFit({
                                        w: s1.w + s2.w,
                                        h: s1.h
                                    })) {
                                        newAtlas.lock();
                                        newAtlas = _this2._createAtlas();
                                        newAtlases.push(newAtlas);
                                    }
                                    _this2._copyTextureToNewAtlas(key, atlas, newAtlas);
                                    newStyleKeyToAtlas.set(key, newAtlas);
                                }
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        atlas.dispose();
                    };
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        if (_loop()) continue;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this.atlases = newAtlases;
                this.styleKeyToAtlas = newStyleKeyToAtlas;
                this.markedKeys = new Set();
            }
        },
        {
            key: "_copyTextureToNewAtlas",
            value: function _copyTextureToNewAtlas(key, oldAtlas, newAtlas) {
                var _oldAtlas$getOffsets = oldAtlas.getOffsets(key), _oldAtlas$getOffsets2 = _slicedToArray(_oldAtlas$getOffsets, 2), s1 = _oldAtlas$getOffsets2[0], s2 = _oldAtlas$getOffsets2[1];
                if (s2.w === 0) // the texture does not wrap, draw directly to new atlas
                newAtlas.draw(key, s1, function(context) {
                    context.drawImage(oldAtlas.canvas, s1.x, s1.y, s1.w, s1.h, 0, 0, s1.w, s1.h);
                });
                else {
                    // the texture wraps, first draw both parts to a scratch canvas
                    var scratch = this._getScratchCanvas();
                    scratch.clear();
                    scratch.context.drawImage(oldAtlas.canvas, s1.x, s1.y, s1.w, s1.h, 0, 0, s1.w, s1.h);
                    scratch.context.drawImage(oldAtlas.canvas, s2.x, s2.y, s2.w, s2.h, s1.w, 0, s2.w, s2.h);
                    // now draw the scratch to the new atlas
                    var w = s1.w + s2.w;
                    var h = s1.h;
                    newAtlas.draw(key, {
                        w: w,
                        h: h
                    }, function(context) {
                        context.drawImage(scratch, 0, 0, w, h, 0, 0, w, h // the destination context has already been translated to the correct position
                        );
                    });
                }
            }
        },
        {
            key: "getCounts",
            value: function getCounts() {
                return {
                    keyCount: this.styleKeyToAtlas.size,
                    atlasCount: new Set(this.styleKeyToAtlas.values()).size
                };
            }
        }
    ]);
}();
function intersection(set1, set2) {
    // TODO why no Set.intersection in node 16???
    if (set1.intersection) return set1.intersection(set2);
    else return new Set(_toConsumableArray(set1).filter(function(x) {
        return set2.has(x);
    }));
}
/**
 * Used to manage batches of Atlases for drawing nodes and labels.
 * Supports different types of AtlasCollections for different render types (or 'texture groups'),
 * for example 'node body' and 'node label' would be different render types.
 * Render types are kept separate because they will likely need to be garbage collected
 * separately and its not entierly guaranteed that their style keys won't collide.
 */ var AtlasManager = /*#__PURE__*/ function() {
    function AtlasManager(r, globalOptions) {
        _classCallCheck(this, AtlasManager);
        this.r = r;
        this.globalOptions = globalOptions;
        this.atlasSize = globalOptions.webglTexSize;
        this.maxAtlasesPerBatch = globalOptions.webglTexPerBatch;
        this.renderTypes = new Map(); // renderType:string -> renderTypeOptions
        this.collections = new Map(); // collectionName:string -> AtlasCollection
        this.typeAndIdToKey = new Map(); // [renderType,id] => style key
        this.batchAtlases = [];
    }
    return _createClass(AtlasManager, [
        {
            key: "getAtlasSize",
            value: function getAtlasSize() {
                return this.atlasSize;
            }
        },
        {
            key: "getMaxAtlasesPerBatch",
            value: function getMaxAtlasesPerBatch() {
                return this.maxAtlasesPerBatch;
            }
        },
        {
            key: "addAtlasCollection",
            value: function addAtlasCollection(collectionName, atlasCollectionOptions) {
                var _this$globalOptions = this.globalOptions, webglTexSize = _this$globalOptions.webglTexSize, createTextureCanvas = _this$globalOptions.createTextureCanvas;
                var texRows = atlasCollectionOptions.texRows;
                var cachedCreateTextureCanvas = this._cacheScratchCanvas(createTextureCanvas);
                var atlasCollection = new AtlasCollection(this.r, webglTexSize, texRows, cachedCreateTextureCanvas);
                this.collections.set(collectionName, atlasCollection);
            }
        },
        {
            key: "addRenderType",
            value: function addRenderType(type, renderTypeOptions) {
                var collection = renderTypeOptions.collection;
                if (!this.collections.has(collection)) throw new Error("invalid atlas collection name '".concat(collection, "'"));
                var atlasCollection = this.collections.get(collection);
                var opts = extend({
                    type: type,
                    atlasCollection: atlasCollection
                }, renderTypeOptions);
                this.renderTypes.set(type, opts);
            }
        },
        {
            key: "getRenderTypeOpts",
            value: function getRenderTypeOpts(type) {
                return this.renderTypes.get(type);
            }
        },
        {
            key: "getAtlasCollection",
            value: function getAtlasCollection(name) {
                return this.collections.get(name);
            }
        },
        {
            key: "_cacheScratchCanvas",
            value: function _cacheScratchCanvas(createTextureCanvas) {
                // all scratch canvases for the same render type will have the same width and height (ie webglTexRows option)
                // but we'll keep track of the width and height just to be safe
                var prevW = -1;
                var prevH = -1;
                var scratchCanvas = null;
                return function(r, w, h, scratch) {
                    if (scratch) {
                        if (!scratchCanvas || w != prevW || h != prevH) {
                            prevW = w;
                            prevH = h;
                            scratchCanvas = createTextureCanvas(r, w, h);
                        }
                        return scratchCanvas;
                    } else return createTextureCanvas(r, w, h);
                };
            }
        },
        {
            key: "_key",
            value: function _key(renderType, id) {
                return "".concat(renderType, "-").concat(id); // TODO not very efficient
            }
        },
        {
            key: "invalidate",
            value: function invalidate(eles) {
                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$forceRedraw = _ref2.forceRedraw, forceRedraw = _ref2$forceRedraw === undefined ? false : _ref2$forceRedraw, _ref2$filterEle = _ref2.filterEle, filterEle = _ref2$filterEle === undefined ? function() {
                    return true;
                } : _ref2$filterEle, _ref2$filterType = _ref2.filterType, filterType = _ref2$filterType === undefined ? function() {
                    return true;
                } : _ref2$filterType;
                var needGC = false;
                var runGCNow = false;
                var _iterator3 = _createForOfIteratorHelper(eles), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var ele = _step3.value;
                        if (filterEle(ele)) {
                            var _iterator4 = _createForOfIteratorHelper(this.renderTypes.values()), _step4;
                            try {
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                    var opts = _step4.value;
                                    var renderType = opts.type;
                                    if (filterType(renderType)) {
                                        var styleKey = opts.getKey(ele);
                                        var atlasCollection = this.collections.get(opts.collection);
                                        // when a node's background image finishes loading, the style key doesn't change but still needs to be redrawn
                                        if (forceRedraw) {
                                            atlasCollection.markKeyForGC(styleKey);
                                            runGCNow = true; // run GC to remove the old texture right now, that way we don't need to remember for the next gc 
                                        } else {
                                            var id = opts.getID ? opts.getID(ele) : ele.id();
                                            var mapKey = this._key(renderType, id);
                                            var oldStyleKey = this.typeAndIdToKey.get(mapKey);
                                            if (oldStyleKey !== undefined && oldStyleKey !== styleKey) {
                                                this.typeAndIdToKey["delete"](mapKey);
                                                atlasCollection.markKeyForGC(oldStyleKey);
                                                needGC = true;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                if (runGCNow) {
                    this.gc();
                    needGC = false;
                }
                return needGC;
            }
        },
        {
            key: "gc",
            value: function gc() {
                var _iterator5 = _createForOfIteratorHelper(this.collections.values()), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var collection = _step5.value;
                        collection.gc();
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            }
        },
        {
            key: "getOrCreateAtlas",
            value: function getOrCreateAtlas(ele, type, bb) {
                var opts = this.renderTypes.get(type);
                var styleKey = opts.getKey(ele);
                if (!bb) bb = opts.getBoundingBox(ele);
                var atlasCollection = this.collections.get(opts.collection);
                // draws the texture only if needed
                var drawn = false;
                var atlas = atlasCollection.draw(styleKey, bb, function(context) {
                    opts.drawElement(context, ele, bb, true, true);
                    drawn = true;
                });
                if (drawn) {
                    var id = opts.getID ? opts.getID(ele) : ele.id(); // for testing
                    var mapKey = this._key(type, id);
                    this.typeAndIdToKey.set(mapKey, styleKey);
                }
                return atlas;
            }
        },
        {
            key: "startBatch",
            value: function startBatch() {
                this.batchAtlases = [];
            }
        },
        {
            key: "getAtlasCount",
            value: function getAtlasCount() {
                return this.batchAtlases.length;
            }
        },
        {
            key: "getAtlases",
            value: function getAtlases() {
                return this.batchAtlases;
            }
        },
        {
            key: "canAddToCurrentBatch",
            value: function canAddToCurrentBatch(ele, type) {
                if (this.batchAtlases.length === this.maxAtlasesPerBatch) {
                    // batch is full, is the atlas already part of this batch?
                    var opts = this.renderTypes.get(type);
                    var styleKey = opts.getKey(ele);
                    var atlasCollection = this.collections.get(opts.collection);
                    var atlas = atlasCollection.getAtlas(styleKey);
                    // return true if there is an atlas and it is part of this batch already
                    return Boolean(atlas) && this.batchAtlases.includes(atlas);
                }
                return true; // not full
            }
        },
        {
            key: "getAtlasIndexForBatch",
            value: function getAtlasIndexForBatch(atlas) {
                var atlasID = this.batchAtlases.indexOf(atlas);
                if (atlasID < 0) {
                    if (this.batchAtlases.length === this.maxAtlasesPerBatch) return;
                    this.batchAtlases.push(atlas);
                    atlasID = this.batchAtlases.length - 1;
                }
                return atlasID;
            }
        },
        {
            key: "getIndexArray",
            value: function getIndexArray() {
                return Array.from({
                    length: this.maxAtlasesPerBatch
                }, function(v, i) {
                    return i;
                });
            }
        },
        {
            key: "getAtlasInfo",
            value: function getAtlasInfo(ele, type) {
                var opts = this.renderTypes.get(type);
                var bb = opts.getBoundingBox(ele);
                var atlas = this.getOrCreateAtlas(ele, type, bb);
                var index = this.getAtlasIndexForBatch(atlas);
                if (index === undefined) return undefined; // batch is full
                var styleKey = opts.getKey(ele);
                var _atlas$getOffsets3 = atlas.getOffsets(styleKey), _atlas$getOffsets4 = _slicedToArray(_atlas$getOffsets3, 2), tex1 = _atlas$getOffsets4[0], tex2 = _atlas$getOffsets4[1];
                // This object may be passed back to setTransformMatrix()
                return {
                    index: index,
                    tex1: tex1,
                    tex2: tex2,
                    bb: bb
                };
            }
        },
        {
            key: "setTransformMatrix",
            value: function setTransformMatrix(ele, matrix, type, atlasInfo) {
                var first = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                var opts = this.getRenderTypeOpts(type);
                var padding = opts.getPadding ? opts.getPadding(ele) : 0;
                if (atlasInfo) {
                    // we've already computed the bb and tex bounds for a texture
                    var bb = atlasInfo.bb, tex1 = atlasInfo.tex1, tex2 = atlasInfo.tex2;
                    // wrapped textures need separate matrix for each part
                    var ratio = tex1.w / (tex1.w + tex2.w);
                    if (!first) // first = true means its the first part of the wrapped texture
                    ratio = 1 - ratio;
                    var adjBB = this.getAdjustedBB(bb, padding, first, ratio);
                    this._applyTransformMatrix(matrix, adjBB, opts, ele);
                } else {
                    // we don't have a texture yet, or we want to avoid creating a texture for simple shapes
                    var _bb = opts.getBoundingBox(ele);
                    var _adjBB = this.getAdjustedBB(_bb, padding, true, 1);
                    this._applyTransformMatrix(matrix, _adjBB, opts, ele);
                }
            }
        },
        {
            key: "_applyTransformMatrix",
            value: function _applyTransformMatrix(matrix, adjBB, opts, ele) {
                var x, y;
                identity(matrix);
                var theta = opts.getRotation ? opts.getRotation(ele) : 0;
                if (theta !== 0) {
                    var _opts$getRotationPoin = opts.getRotationPoint(ele), sx = _opts$getRotationPoin.x, sy = _opts$getRotationPoin.y;
                    translate(matrix, matrix, [
                        sx,
                        sy
                    ]);
                    rotate(matrix, matrix, theta);
                    var offset = opts.getRotationOffset(ele);
                    x = offset.x + adjBB.xOffset;
                    y = offset.y;
                } else {
                    x = adjBB.x1;
                    y = adjBB.y1;
                }
                translate(matrix, matrix, [
                    x,
                    y
                ]);
                scale(matrix, matrix, [
                    adjBB.w,
                    adjBB.h
                ]);
            }
        },
        {
            key: "getAdjustedBB",
            value: function getAdjustedBB(bb, padding, first, ratio) {
                var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h;
                if (padding) {
                    x1 -= padding;
                    y1 -= padding;
                    w += 2 * padding;
                    h += 2 * padding;
                }
                var xOffset = 0;
                var adjW = w * ratio;
                if (first && ratio < 1) w = adjW;
                else if (!first && ratio < 1) {
                    xOffset = w - adjW;
                    x1 += xOffset;
                    w = adjW;
                }
                return {
                    x1: x1,
                    y1: y1,
                    w: w,
                    h: h,
                    xOffset: xOffset
                };
            }
        },
        {
            key: "getDebugInfo",
            value: function getDebugInfo() {
                var debugInfo = [];
                var _iterator6 = _createForOfIteratorHelper(this.collections), _step6;
                try {
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                        var _step6$value = _slicedToArray(_step6.value, 2), name = _step6$value[0], collection = _step6$value[1];
                        var _collection$getCounts = collection.getCounts(), keyCount = _collection$getCounts.keyCount, atlasCount = _collection$getCounts.atlasCount;
                        debugInfo.push({
                            type: name,
                            keyCount: keyCount,
                            atlasCount: atlasCount
                        });
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
                return debugInfo;
            }
        }
    ]);
}();
// Vertex types
var TEXTURE = 0;
var EDGE_STRAIGHT = 1;
var EDGE_CURVE_SEGMENT = 2;
var EDGE_ARROW = 3;
var RECTANGLE = 4;
var ElementDrawingWebGL = /*#__PURE__*/ function() {
    /** 
   * @param {WebGLRenderingContext} gl 
   */ function ElementDrawingWebGL(r, gl, opts) {
        _classCallCheck(this, ElementDrawingWebGL);
        this.r = r;
        this.gl = gl;
        this.maxInstances = opts.webglBatchSize;
        this.atlasSize = opts.webglTexSize;
        this.bgColor = opts.bgColor;
        this.debug = opts.webglDebug;
        this.batchDebugInfo = [];
        opts.enableWrapping = true;
        opts.createTextureCanvas = createTextureCanvas; // Unit tests mock this
        this.atlasManager = new AtlasManager(r, opts);
        this.program = this.createShaderProgram(RENDER_TARGET.SCREEN);
        this.pickingProgram = this.createShaderProgram(RENDER_TARGET.PICKING);
        this.vao = this.createVAO();
    }
    return _createClass(ElementDrawingWebGL, [
        {
            key: "addAtlasCollection",
            value: function addAtlasCollection(groupName, opts) {
                this.atlasManager.addAtlasCollection(groupName, opts);
            }
        },
        {
            key: "addAtlasRenderType",
            value: function addAtlasRenderType(typeName, opts) {
                this.atlasManager.addRenderType(typeName, opts);
            }
        },
        {
            key: "invalidate",
            value: function invalidate(eles) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type;
                var atlasManager = this.atlasManager;
                if (type) return atlasManager.invalidate(eles, {
                    filterType: function filterType(t) {
                        return t === type;
                    },
                    forceRedraw: true
                });
                else return atlasManager.invalidate(eles);
            }
        },
        {
            key: "gc",
            value: function gc() {
                this.atlasManager.gc();
            }
        },
        {
            key: "createShaderProgram",
            value: function createShaderProgram(renderTarget) {
                var gl = this.gl;
                // compute texture coordinates in the shader, becase we are using instanced drawing
                var vertexShaderSource = "#version 300 es\n      precision highp float;\n\n      uniform mat3 uPanZoomMatrix;\n      uniform int  uAtlasSize;\n      \n      // instanced\n      in vec2 aPosition; \n\n      in mat3 aTransform;\n\n      // what are we rendering?\n      in int aVertType;\n\n      // for picking\n      in vec4 aIndex;\n      \n      // For textures\n      in int aAtlasId; // which shader unit/atlas to use\n      in vec4 aTex; // x/y/w/h of texture in atlas\n\n      // for edges\n      in vec4 aPointAPointB;\n      in vec4 aPointCPointD;\n      in float aLineWidth;\n      in vec4 aColor;\n\n      out vec2 vTexCoord;\n      out vec4 vColor;\n      flat out int vAtlasId;\n      flat out vec4 vIndex;\n      flat out int vVertType;\n\n      void main(void) {\n        int vid = gl_VertexID;\n        vec2 position = aPosition;\n\n        if(aVertType == ".concat(TEXTURE, ") {\n          float texX = aTex.x;\n          float texY = aTex.y;\n          float texW = aTex.z;\n          float texH = aTex.w;\n\n          int vid = gl_VertexID;\n\n          if(vid == 1 || vid == 2 || vid == 4) {\n            texX += texW;\n          }\n          if(vid == 2 || vid == 4 || vid == 5) {\n            texY += texH;\n          }\n\n          float d = float(uAtlasSize);\n          vTexCoord = vec2(texX / d, texY / d); // tex coords must be between 0 and 1\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n        }\n        else if(aVertType == ").concat(RECTANGLE, ") {\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n          vColor = aColor;\n        }\n        else if(aVertType == ").concat(EDGE_STRAIGHT, ") {\n          vec2 source = aPointAPointB.xy;\n          vec2 target = aPointAPointB.zw;\n\n          // adjust the geometry so that the line is centered on the edge\n          position.y = position.y - 0.5;\n\n          vec2 xBasis = target - source;\n          vec2 yBasis = normalize(vec2(-xBasis.y, xBasis.x));\n          vec2 point = source + xBasis * position.x + yBasis * aLineWidth * position.y;\n\n          gl_Position = vec4(uPanZoomMatrix * vec3(point, 1.0), 1.0);\n          vColor = aColor;\n        } \n        else if(aVertType == ").concat(EDGE_CURVE_SEGMENT, ") {\n          vec2 pointA = aPointAPointB.xy;\n          vec2 pointB = aPointAPointB.zw;\n          vec2 pointC = aPointCPointD.xy;\n          vec2 pointD = aPointCPointD.zw;\n\n          // adjust the geometry so that the line is centered on the edge\n          position.y = position.y - 0.5;\n\n          vec2 p0 = pointA;\n          vec2 p1 = pointB;\n          vec2 p2 = pointC;\n          vec2 pos = position;\n          if(position.x == 1.0) {\n            p0 = pointD;\n            p1 = pointC;\n            p2 = pointB;\n            pos = vec2(0.0, -position.y);\n          }\n\n          vec2 p01 = p1 - p0;\n          vec2 p12 = p2 - p1;\n          vec2 p21 = p1 - p2;\n\n          // Find the normal vector.\n          vec2 tangent = normalize(normalize(p12) + normalize(p01));\n          vec2 normal = vec2(-tangent.y, tangent.x);\n\n          // Find the vector perpendicular to p0 -> p1.\n          vec2 p01Norm = normalize(vec2(-p01.y, p01.x));\n\n          // Determine the bend direction.\n          float sigma = sign(dot(p01 + p21, normal));\n          float width = aLineWidth;\n\n          if(sign(pos.y) == -sigma) {\n            // This is an intersecting vertex. Adjust the position so that there's no overlap.\n            vec2 point = 0.5 * width * normal * -sigma / dot(normal, p01Norm);\n            gl_Position = vec4(uPanZoomMatrix * vec3(p1 + point, 1.0), 1.0);\n          } else {\n            // This is a non-intersecting vertex. Treat it like a mitre join.\n            vec2 point = 0.5 * width * normal * sigma * dot(normal, p01Norm);\n            gl_Position = vec4(uPanZoomMatrix * vec3(p1 + point, 1.0), 1.0);\n          }\n\n          vColor = aColor;\n        } \n        else if(aVertType == ").concat(EDGE_ARROW, " && vid < 3) {\n          // massage the first triangle into an edge arrow\n          if(vid == 0)\n            position = vec2(-0.15, -0.3);\n          if(vid == 1)\n            position = vec2( 0.0,   0.0);\n          if(vid == 2)\n            position = vec2( 0.15, -0.3);\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n          vColor = aColor;\n        }\n        else {\n          gl_Position = vec4(2.0, 0.0, 0.0, 1.0); // discard vertex by putting it outside webgl clip space\n        }\n\n        vAtlasId = aAtlasId;\n        vIndex = aIndex;\n        vVertType = aVertType;\n      }\n    ");
                var idxs = this.atlasManager.getIndexArray();
                var fragmentShaderSource = "#version 300 es\n      precision highp float;\n\n      // define texture unit for each node in the batch\n      ".concat(idxs.map(function(i) {
                    return "uniform sampler2D uTexture".concat(i, ";");
                }).join('\n\t'), "\n\n      uniform vec4 uBGColor;\n\n      in vec2 vTexCoord;\n      in vec4 vColor;\n      flat in int vAtlasId;\n      flat in vec4 vIndex;\n      flat in int vVertType;\n\n      out vec4 outColor;\n\n      void main(void) {\n        if(vVertType == ").concat(TEXTURE, ") {\n          ").concat(idxs.map(function(i) {
                    return "if(vAtlasId == ".concat(i, ") outColor = texture(uTexture").concat(i, ", vTexCoord);");
                }).join('\n\telse '), "\n        } else if(vVertType == ").concat(EDGE_ARROW, ") {\n          // blend arrow color with background (using premultiplied alpha)\n          outColor.rgb = vColor.rgb + (uBGColor.rgb * (1.0 - vColor.a)); \n          outColor.a = 1.0; // make opaque, masks out line under arrow\n        } else {\n          outColor = vColor;\n        }\n\n        ").concat(renderTarget.picking ? "if(outColor.a == 0.0) discard;\n             else outColor = vIndex;" : '', "\n      }\n    ");
                var program = createProgram(gl, vertexShaderSource, fragmentShaderSource);
                // instance geometry
                program.aPosition = gl.getAttribLocation(program, 'aPosition');
                // attributes
                program.aIndex = gl.getAttribLocation(program, 'aIndex');
                program.aVertType = gl.getAttribLocation(program, 'aVertType');
                program.aTransform = gl.getAttribLocation(program, 'aTransform');
                program.aAtlasId = gl.getAttribLocation(program, 'aAtlasId');
                program.aTex = gl.getAttribLocation(program, 'aTex');
                program.aPointAPointB = gl.getAttribLocation(program, 'aPointAPointB');
                program.aPointCPointD = gl.getAttribLocation(program, 'aPointCPointD');
                program.aLineWidth = gl.getAttribLocation(program, 'aLineWidth');
                program.aColor = gl.getAttribLocation(program, 'aColor');
                // uniforms
                program.uPanZoomMatrix = gl.getUniformLocation(program, 'uPanZoomMatrix');
                program.uAtlasSize = gl.getUniformLocation(program, 'uAtlasSize');
                program.uBGColor = gl.getUniformLocation(program, 'uBGColor');
                program.uTextures = [];
                for(var i = 0; i < this.atlasManager.getMaxAtlasesPerBatch(); i++)program.uTextures.push(gl.getUniformLocation(program, "uTexture".concat(i)));
                return program;
            }
        },
        {
            key: "createVAO",
            value: function createVAO() {
                var instanceGeometry = [
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1
                ];
                this.vertexCount = instanceGeometry.length / 2;
                var n = this.maxInstances;
                var gl = this.gl, program = this.program;
                var vao = gl.createVertexArray();
                gl.bindVertexArray(vao);
                createBufferStaticDraw(gl, 'vec2', program.aPosition, instanceGeometry);
                // Create buffers for all the attributes
                this.transformBuffer = create3x3MatrixBufferDynamicDraw(gl, n, program.aTransform);
                this.indexBuffer = createBufferDynamicDraw(gl, n, 'vec4', program.aIndex);
                this.vertTypeBuffer = createBufferDynamicDraw(gl, n, 'int', program.aVertType);
                this.atlasIdBuffer = createBufferDynamicDraw(gl, n, 'int', program.aAtlasId);
                this.texBuffer = createBufferDynamicDraw(gl, n, 'vec4', program.aTex);
                this.pointAPointBBuffer = createBufferDynamicDraw(gl, n, 'vec4', program.aPointAPointB);
                this.pointCPointDBuffer = createBufferDynamicDraw(gl, n, 'vec4', program.aPointCPointD);
                this.lineWidthBuffer = createBufferDynamicDraw(gl, n, 'float', program.aLineWidth);
                this.colorBuffer = createBufferDynamicDraw(gl, n, 'vec4', program.aColor);
                gl.bindVertexArray(null);
                return vao;
            }
        },
        {
            key: "buffers",
            get: function get() {
                var _this = this;
                if (!this._buffers) this._buffers = Object.keys(this).filter(function(k) {
                    return k.endsWith('Buffer');
                }).map(function(k) {
                    return _this[k];
                });
                return this._buffers;
            }
        },
        {
            key: "startFrame",
            value: function startFrame(panZoomMatrix) {
                var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RENDER_TARGET.SCREEN;
                this.panZoomMatrix = panZoomMatrix;
                this.renderTarget = renderTarget;
                this.batchDebugInfo = [];
                this.wrappedCount = 0; // TODO this should be in the AtlasManager
                this.rectangleCount = 0;
                this.startBatch();
            }
        },
        {
            key: "startBatch",
            value: function startBatch() {
                this.instanceCount = 0;
                this.atlasManager.startBatch();
            }
        },
        {
            key: "endFrame",
            value: function endFrame() {
                this.endBatch();
            }
        },
        {
            key: "getTempMatrix",
            value: function getTempMatrix() {
                return this.tempMatrix = this.tempMatrix || create();
            }
        },
        {
            key: "drawTexture",
            value: function drawTexture(ele, eleIndex, type) {
                var atlasManager = this.atlasManager;
                if (!ele.visible()) return;
                if (!atlasManager.getRenderTypeOpts(type).isVisible(ele)) return;
                if (!atlasManager.canAddToCurrentBatch(ele, type)) this.endBatch(); // draws then starts a new batch
                if (this.instanceCount + 1 >= this.maxInstances) this.endBatch(); // make sure there's space for at least two instances, wrapped textures need two instances
                var instance = this.instanceCount;
                this.vertTypeBuffer.getView(instance)[0] = TEXTURE;
                var indexView = this.indexBuffer.getView(instance);
                indexToVec4(eleIndex, indexView);
                var atlasInfo = atlasManager.getAtlasInfo(ele, type);
                var index = atlasInfo.index, tex1 = atlasInfo.tex1, tex2 = atlasInfo.tex2;
                if (tex2.w > 0) this.wrappedCount++;
                var first = true;
                for(var _i = 0, _arr = [
                    tex1,
                    tex2
                ]; _i < _arr.length; _i++){
                    var tex = _arr[_i];
                    if (tex.w != 0) {
                        var _instance = this.instanceCount;
                        this.vertTypeBuffer.getView(_instance)[0] = TEXTURE;
                        var _indexView = this.indexBuffer.getView(_instance);
                        indexToVec4(eleIndex, _indexView);
                        // Set values in the buffers using Typed Array Views for performance.
                        var atlasIdView = this.atlasIdBuffer.getView(_instance);
                        atlasIdView[0] = index;
                        // we have two sets of texture coordinates and transforms because textures can wrap in the atlas
                        var texView = this.texBuffer.getView(_instance);
                        texView[0] = tex.x;
                        texView[1] = tex.y;
                        texView[2] = tex.w;
                        texView[3] = tex.h;
                        var matrixView = this.transformBuffer.getMatrixView(_instance);
                        atlasManager.setTransformMatrix(ele, matrixView, type, atlasInfo, first);
                        this.instanceCount++;
                    }
                    first = false;
                }
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawSimpleRectangle",
            value: function drawSimpleRectangle(ele, eleIndex, type) {
                if (!ele.visible()) return;
                var atlasManager = this.atlasManager;
                var instance = this.instanceCount;
                this.vertTypeBuffer.getView(instance)[0] = RECTANGLE;
                var indexView = this.indexBuffer.getView(instance);
                indexToVec4(eleIndex, indexView);
                var color = ele.pstyle('background-color').value;
                var opacity = ele.pstyle('background-opacity').value;
                var colorView = this.colorBuffer.getView(instance);
                toWebGLColor(color, opacity, colorView);
                var matrixView = this.transformBuffer.getMatrixView(instance);
                atlasManager.setTransformMatrix(ele, matrixView, type);
                this.rectangleCount++;
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawEdgeArrow",
            value: function drawEdgeArrow(edge, eleIndex, prefix) {
                if (!edge.visible()) return;
                // Edge points and arrow angles etc are calculated by the base renderer and cached in the rscratch object.
                var rs = edge._private.rscratch;
                var x, y, angle;
                if (prefix === 'source') {
                    x = rs.arrowStartX;
                    y = rs.arrowStartY;
                    angle = rs.srcArrowAngle;
                } else {
                    x = rs.arrowEndX;
                    y = rs.arrowEndY;
                    angle = rs.tgtArrowAngle;
                }
                // taken from CRp.drawArrowhead
                if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
                // check shape after the x/y check because pstyle() is a bit slow
                var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
                if (arrowShape === 'none') return;
                var color = edge.pstyle(prefix + '-arrow-color').value;
                var baseOpacity = edge.pstyle('opacity').value;
                var lineOpacity = edge.pstyle('line-opacity').value;
                var opacity = baseOpacity * lineOpacity;
                var lineWidth = edge.pstyle('width').pfValue;
                var scale$1 = edge.pstyle('arrow-scale').value;
                var size = this.r.getArrowWidth(lineWidth, scale$1);
                var instance = this.instanceCount;
                var transform = this.transformBuffer.getMatrixView(instance);
                identity(transform);
                translate(transform, transform, [
                    x,
                    y
                ]);
                scale(transform, transform, [
                    size,
                    size
                ]);
                rotate(transform, transform, angle);
                this.vertTypeBuffer.getView(instance)[0] = EDGE_ARROW;
                var indexView = this.indexBuffer.getView(instance);
                indexToVec4(eleIndex, indexView);
                var colorView = this.colorBuffer.getView(instance);
                toWebGLColor(color, opacity, colorView);
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawEdgeLine",
            value: function drawEdgeLine(edge, eleIndex) {
                if (!edge.visible()) return;
                var points = this.getEdgePoints(edge);
                if (!points) return;
                // line style
                var baseOpacity = edge.pstyle('opacity').value;
                var lineOpacity = edge.pstyle('line-opacity').value;
                var width = edge.pstyle('width').pfValue;
                var color = edge.pstyle('line-color').value;
                var opacity = baseOpacity * lineOpacity;
                if (points.length / 2 + this.instanceCount > this.maxInstances) this.endBatch();
                if (points.length == 4) {
                    // straight line
                    var instance = this.instanceCount;
                    this.vertTypeBuffer.getView(instance)[0] = EDGE_STRAIGHT;
                    var indexView = this.indexBuffer.getView(instance);
                    indexToVec4(eleIndex, indexView);
                    var colorView = this.colorBuffer.getView(instance);
                    toWebGLColor(color, opacity, colorView);
                    var lineWidthBuffer = this.lineWidthBuffer.getView(instance);
                    lineWidthBuffer[0] = width;
                    var sourceTargetView = this.pointAPointBBuffer.getView(instance);
                    sourceTargetView[0] = points[0]; // source x
                    sourceTargetView[1] = points[1]; // source y
                    sourceTargetView[2] = points[2]; // target x
                    sourceTargetView[3] = points[3]; // target y
                    this.instanceCount++;
                    if (this.instanceCount >= this.maxInstances) this.endBatch();
                } else // curved line
                for(var i = 0; i < points.length - 2; i += 2){
                    var _instance2 = this.instanceCount;
                    this.vertTypeBuffer.getView(_instance2)[0] = EDGE_CURVE_SEGMENT;
                    var _indexView2 = this.indexBuffer.getView(_instance2);
                    indexToVec4(eleIndex, _indexView2);
                    var _colorView = this.colorBuffer.getView(_instance2);
                    toWebGLColor(color, opacity, _colorView);
                    var _lineWidthBuffer = this.lineWidthBuffer.getView(_instance2);
                    _lineWidthBuffer[0] = width;
                    var pAx = points[i - 2], pAy = points[i - 1];
                    var pBx = points[i], pBy = points[i + 1];
                    var pCx = points[i + 2], pCy = points[i + 3];
                    var pDx = points[i + 4], pDy = points[i + 5];
                    // make phantom points for the first and last segments
                    // TODO adding 0.001 to avoid division by zero in the shader (I think), need a better solution
                    if (i == 0) {
                        pAx = 2 * pBx - pCx + 0.001;
                        pAy = 2 * pBy - pCy + 0.001;
                    }
                    if (i == points.length - 4) {
                        pDx = 2 * pCx - pBx + 0.001;
                        pDy = 2 * pCy - pBy + 0.001;
                    }
                    var pointABView = this.pointAPointBBuffer.getView(_instance2);
                    pointABView[0] = pAx;
                    pointABView[1] = pAy;
                    pointABView[2] = pBx;
                    pointABView[3] = pBy;
                    var pointCDView = this.pointCPointDBuffer.getView(_instance2);
                    pointCDView[0] = pCx;
                    pointCDView[1] = pCy;
                    pointCDView[2] = pDx;
                    pointCDView[3] = pDy;
                    this.instanceCount++;
                    if (this.instanceCount >= this.maxInstances) this.endBatch();
                }
            }
        },
        {
            key: "getEdgePoints",
            value: function getEdgePoints(edge) {
                var rs = edge._private.rscratch;
                // if bezier ctrl pts can not be calculated, then die
                if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
                return;
                var controlPoints = rs.allpts;
                if (controlPoints.length == 4) return controlPoints;
                var numSegments = this.getNumSegments(edge);
                return this.getCurveSegmentPoints(controlPoints, numSegments);
            }
        },
        {
            key: "getNumSegments",
            value: function getNumSegments(edge) {
                // TODO Need a heuristic that decides how many segments to use. Factors to consider:
                // - edge width/length
                // - edge curvature (the more the curvature, the more segments)
                // - zoom level (more segments when zoomed in)
                // - number of visible edges (more segments when there are fewer edges)
                // - performance (fewer segments when performance is a concern)
                // - user configurable option(s)
                // note: number of segments should be less than the max number of instances
                // note: segments don't need to be evenly spaced out, it might make sense to have shorter segments nearer to the control points
                var numSegments = 15;
                return Math.min(Math.max(numSegments, 5), this.maxInstances);
            }
        },
        {
            key: "getCurveSegmentPoints",
            value: function getCurveSegmentPoints(controlPoints, segments) {
                if (controlPoints.length == 4) return controlPoints; // straight line
                var curvePoints = Array((segments + 1) * 2);
                for(var i = 0; i <= segments; i++){
                    // the first and last points are the same as the first and last control points
                    if (i == 0) {
                        curvePoints[0] = controlPoints[0];
                        curvePoints[1] = controlPoints[1];
                    } else if (i == segments) {
                        curvePoints[i * 2] = controlPoints[controlPoints.length - 2];
                        curvePoints[i * 2 + 1] = controlPoints[controlPoints.length - 1];
                    } else {
                        var t = i / segments; // segments have equal length, its not strictly necessary to do it this way
                        // pass in curvePoints to set the values in the array directly
                        this.setCurvePoint(controlPoints, t, curvePoints, i * 2);
                    }
                }
                return curvePoints;
            }
        },
        {
            key: "setCurvePoint",
            value: function setCurvePoint(points, t, curvePoints, cpi) {
                if (points.length <= 2) {
                    curvePoints[cpi] = points[0];
                    curvePoints[cpi + 1] = points[1];
                } else {
                    var newpoints = Array(points.length - 2);
                    for(var i = 0; i < newpoints.length; i += 2){
                        var x = (1 - t) * points[i] + t * points[i + 2];
                        var y = (1 - t) * points[i + 1] + t * points[i + 3];
                        newpoints[i] = x;
                        newpoints[i + 1] = y;
                    }
                    return this.setCurvePoint(newpoints, t, curvePoints, cpi);
                }
            }
        },
        {
            key: "endBatch",
            value: function endBatch() {
                var gl = this.gl, vao = this.vao, vertexCount = this.vertexCount, count = this.instanceCount;
                if (count === 0) return;
                var program = this.renderTarget.picking ? this.pickingProgram : this.program;
                gl.useProgram(program);
                gl.bindVertexArray(vao);
                // buffer the attribute data
                var _iterator = _createForOfIteratorHelper(this.buffers), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var buffer = _step.value;
                        buffer.bufferSubData(count);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var atlases = this.atlasManager.getAtlases();
                // must buffer before activating texture units
                for(var i = 0; i < atlases.length; i++)atlases[i].bufferIfNeeded(gl);
                // Activate all the texture units that we need
                for(var _i2 = 0; _i2 < atlases.length; _i2++){
                    gl.activeTexture(gl.TEXTURE0 + _i2);
                    gl.bindTexture(gl.TEXTURE_2D, atlases[_i2].texture);
                    gl.uniform1i(program.uTextures[_i2], _i2);
                }
                // Set the uniforms
                gl.uniformMatrix3fv(program.uPanZoomMatrix, false, this.panZoomMatrix);
                gl.uniform1i(program.uAtlasSize, this.atlasManager.getAtlasSize());
                // set background color, needed for edge arrow color blending
                var webglBgColor = toWebGLColor(this.bgColor, 1);
                gl.uniform4fv(program.uBGColor, webglBgColor);
                // draw!
                gl.drawArraysInstanced(gl.TRIANGLES, 0, vertexCount, count);
                gl.bindVertexArray(null);
                gl.bindTexture(gl.TEXTURE_2D, null); // TODO is this right when having multiple texture units?
                if (this.debug) this.batchDebugInfo.push({
                    count: count,
                    // instance count
                    atlasCount: atlases.length
                });
                // start the next batch, even if not needed
                this.startBatch();
            }
        },
        {
            key: "getDebugInfo",
            value: function getDebugInfo() {
                var atlasInfo = this.atlasManager.getDebugInfo();
                var totalAtlases = atlasInfo.reduce(function(count, info) {
                    return count + info.atlasCount;
                }, 0);
                var batchInfo = this.batchDebugInfo;
                var totalInstances = batchInfo.reduce(function(count, info) {
                    return count + info.count;
                }, 0);
                return {
                    atlasInfo: atlasInfo,
                    totalAtlases: totalAtlases,
                    wrappedCount: this.wrappedCount,
                    rectangleCount: this.rectangleCount,
                    batchCount: batchInfo.length,
                    batchInfo: batchInfo,
                    totalInstances: totalInstances
                };
            }
        }
    ]);
}();
function fillStyle(color, opacity) {
    return "rgba(".concat(color[0], ", ").concat(color[1], ", ").concat(color[2], ", ").concat(opacity, ")");
}
var OverlayUnderlayRenderer = /*#__PURE__*/ function() {
    function OverlayUnderlayRenderer(r) {
        _classCallCheck(this, OverlayUnderlayRenderer);
        this.r = r;
    }
    return _createClass(OverlayUnderlayRenderer, [
        {
            key: "getStyleKey",
            value: function getStyleKey(type, node) {
                var _this$getStyle = this.getStyle(type, node), shape = _this$getStyle.shape, opacity = _this$getStyle.opacity, color = _this$getStyle.color;
                if (!shape) return null;
                var w = node.width();
                var h = node.height();
                var c = fillStyle(color, opacity);
                return hashString("".concat(shape, "-").concat(w, "-").concat(h, "-").concat(c)); // TODO hack, not very efficient
            }
        },
        {
            key: "isVisible",
            value: function isVisible(type, node) {
                var opacity = node.pstyle("".concat(type, "-opacity")).value;
                return opacity > 0;
            }
        },
        {
            key: "getStyle",
            value: function getStyle(type, node) {
                var opacity = node.pstyle("".concat(type, "-opacity")).value;
                var color = node.pstyle("".concat(type, "-color")).value;
                var shape = node.pstyle("".concat(type, "-shape")).value;
                return {
                    opacity: opacity,
                    color: color,
                    shape: shape
                }; // TODO need to add radius at some point
            }
        },
        {
            key: "getPadding",
            value: function getPadding(type, node) {
                return node.pstyle("".concat(type, "-padding")).pfValue;
            }
        },
        {
            key: "draw",
            value: function draw(type, context, node, bb) {
                if (!this.isVisible(type, node)) return;
                var r = this.r;
                var w = bb.w;
                var h = bb.h;
                var x = w / 2;
                var y = h / 2;
                var _this$getStyle2 = this.getStyle(type, node), shape = _this$getStyle2.shape, color = _this$getStyle2.color, opacity = _this$getStyle2.opacity;
                context.save();
                context.fillStyle = fillStyle(color, opacity);
                if (shape === 'round-rectangle' || shape === 'roundrectangle') r.drawRoundRectanglePath(context, x, y, w, h, 'auto');
                else if (shape === 'ellipse') r.drawEllipsePath(context, x, y, w, h);
                context.fill();
                context.restore();
            }
        }
    ]);
}();
var CRp$4 = {};
CRp$4.initWebgl = function(opts, fns) {
    var r = this;
    var gl = r.data.contexts[r.WEBGL];
    opts.bgColor = getBGColor(r);
    opts.webglTexSize = Math.min(opts.webglTexSize, gl.getParameter(gl.MAX_TEXTURE_SIZE));
    opts.webglTexRows = Math.min(opts.webglTexRows, 54);
    opts.webglTexRowsNodes = Math.min(opts.webglTexRowsNodes, 54);
    opts.webglBatchSize = Math.min(opts.webglBatchSize, 16384);
    opts.webglTexPerBatch = Math.min(opts.webglTexPerBatch, gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
    r.webglDebug = opts.webglDebug;
    r.webglDebugShowAtlases = opts.webglDebugShowAtlases;
    // for offscreen rendering when render target is PICKING
    r.pickingFrameBuffer = createPickingFrameBuffer(gl);
    r.pickingFrameBuffer.needsDraw = true;
    var getLabelRotation = function getLabelRotation(prop) {
        return function(ele) {
            return r.getTextAngle(ele, prop);
        };
    };
    var isLabelVisible = function isLabelVisible(prop) {
        return function(ele) {
            var label = ele.pstyle(prop);
            return label && label.value;
        };
    };
    r.drawing = new ElementDrawingWebGL(r, gl, opts);
    var our = new OverlayUnderlayRenderer(r);
    r.drawing.addAtlasCollection('node', atlasCollectionDefaults({
        texRows: opts.webglTexRowsNodes
    }));
    r.drawing.addAtlasCollection('label', atlasCollectionDefaults({
        texRows: opts.webglTexRows
    }));
    r.drawing.addAtlasRenderType('node-body', renderDefaults({
        collection: 'node',
        getKey: fns.getStyleKey,
        getBoundingBox: fns.getElementBox,
        drawElement: fns.drawElement
    }));
    r.drawing.addAtlasRenderType('label', renderDefaults({
        // node label or edge mid label
        collection: 'label',
        getKey: fns.getLabelKey,
        getBoundingBox: fns.getLabelBox,
        drawElement: fns.drawLabel,
        getRotation: getLabelRotation(null),
        getRotationPoint: fns.getLabelRotationPoint,
        getRotationOffset: fns.getLabelRotationOffset,
        isVisible: isLabelVisible('label')
    }));
    r.drawing.addAtlasRenderType('node-overlay', renderDefaults({
        collection: 'node',
        getBoundingBox: fns.getElementBox,
        getKey: function getKey(ele) {
            return our.getStyleKey('overlay', ele);
        },
        drawElement: function drawElement(ctx, ele, bb) {
            return our.draw('overlay', ctx, ele, bb);
        },
        isVisible: function isVisible(ele) {
            return our.isVisible('overlay', ele);
        },
        getPadding: function getPadding(ele) {
            return our.getPadding('overlay', ele);
        }
    }));
    r.drawing.addAtlasRenderType('node-underlay', renderDefaults({
        collection: 'node',
        getBoundingBox: fns.getElementBox,
        getKey: function getKey(ele) {
            return our.getStyleKey('underlay', ele);
        },
        drawElement: function drawElement(ctx, ele, bb) {
            return our.draw('underlay', ctx, ele, bb);
        },
        isVisible: function isVisible(ele) {
            return our.isVisible('underlay', ele);
        },
        getPadding: function getPadding(ele) {
            return our.getPadding('underlay', ele);
        }
    }));
    r.drawing.addAtlasRenderType('edge-source-label', renderDefaults({
        collection: 'label',
        getKey: fns.getSourceLabelKey,
        getBoundingBox: fns.getSourceLabelBox,
        drawElement: fns.drawSourceLabel,
        getRotation: getLabelRotation('source'),
        getRotationPoint: fns.getSourceLabelRotationPoint,
        getRotationOffset: fns.getSourceLabelRotationOffset,
        isVisible: isLabelVisible('source-label')
    }));
    r.drawing.addAtlasRenderType('edge-target-label', renderDefaults({
        collection: 'label',
        getKey: fns.getTargetLabelKey,
        getBoundingBox: fns.getTargetLabelBox,
        drawElement: fns.drawTargetLabel,
        getRotation: getLabelRotation('target'),
        getRotationPoint: fns.getTargetLabelRotationPoint,
        getRotationOffset: fns.getTargetLabelRotationOffset,
        isVisible: isLabelVisible('target-label')
    }));
    // this is a very simplistic way of triggering garbage collection
    var setGCFlag = debounce(function() {
        console.log('garbage collect flag set');
        r.data.gc = true;
    }, 10000);
    r.onUpdateEleCalcs(function(willDraw, eles) {
        var gcNeeded = false;
        if (eles && eles.length > 0) gcNeeded |= r.drawing.invalidate(eles);
        if (gcNeeded) setGCFlag();
    });
    // "Override" certain functions in canvas and base renderer
    overrideCanvasRendererFunctions(r);
};
function getBGColor(r) {
    var container = r.cy.container();
    var cssColor = container && container.style && container.style.backgroundColor || 'white';
    return color2tuple(cssColor);
}
/**
 * Plug into the canvas renderer to use webgl for rendering.
 */ function overrideCanvasRendererFunctions(r) {
    // Override the render function to call the webgl render function if the zoom level is appropriate
    var renderCanvas = r.render;
    r.render = function(options) {
        options = options || {};
        var cy = r.cy;
        if (r.webgl) {
            // if the zoom level is greater than the max zoom level, then disable webgl
            if (cy.zoom() > maxZoom$1) {
                clearWebgl(r);
                renderCanvas.call(r, options);
            } else {
                clearCanvas(r);
                renderWebgl(r, options, RENDER_TARGET.SCREEN);
            }
        }
    };
    // Override the matchCanvasSize function to update the picking frame buffer size
    var baseFunc = r.matchCanvasSize;
    r.matchCanvasSize = function(container) {
        baseFunc.call(r, container);
        r.pickingFrameBuffer.setFramebufferAttachmentSizes(r.canvasWidth, r.canvasHeight);
        r.pickingFrameBuffer.needsDraw = true;
    };
    // Override function to call the webgl version
    r.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
        // the canvas version of this function is very slow on large graphs
        return findNearestElementsWebgl(r, x, y);
    };
    // need to know when the cached elements have changed so we can invalidate our caches
    var _baseFunc = r.invalidateCachedZSortedEles;
    r.invalidateCachedZSortedEles = function() {
        _baseFunc.call(r);
        r.pickingFrameBuffer.needsDraw = true;
    };
    // need to know when the cached elements have changed so we can invalidate our caches
    var _baseFunc2 = r.notify;
    r.notify = function(eventName, eles) {
        _baseFunc2.call(r, eventName, eles);
        if (eventName === 'viewport' || eventName === 'bounds') r.pickingFrameBuffer.needsDraw = true;
        else if (eventName === 'background') // background image finished loading, need to redraw
        r.drawing.invalidate(eles, {
            type: 'node-body'
        });
    };
}
function clearWebgl(r) {
    var gl = r.data.contexts[r.WEBGL];
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
}
function clearCanvas(r) {
    // the CRp.clearCanvas() function doesn't take the transform into account
    var clear = function clear(context) {
        context.save();
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
        context.restore();
    };
    clear(r.data.contexts[r.NODE]);
    clear(r.data.contexts[r.DRAG]);
}
function createPanZoomMatrix(r) {
    var width = r.canvasWidth;
    var height = r.canvasHeight;
    var _util$getEffectivePan = getEffectivePanZoom(r), pan = _util$getEffectivePan.pan, zoom = _util$getEffectivePan.zoom;
    var transform = create();
    translate(transform, transform, [
        pan.x,
        pan.y
    ]);
    scale(transform, transform, [
        zoom,
        zoom
    ]);
    var projection$1 = create();
    projection(projection$1, width, height);
    var product = create();
    multiply(product, projection$1, transform);
    return product;
}
function setContextTransform(r, context) {
    var width = r.canvasWidth;
    var height = r.canvasHeight;
    var _util$getEffectivePan2 = getEffectivePanZoom(r), pan = _util$getEffectivePan2.pan, zoom = _util$getEffectivePan2.zoom;
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.clearRect(0, 0, width, height);
    context.translate(pan.x, pan.y);
    context.scale(zoom, zoom);
}
function drawSelectionRectangle(r, options) {
    r.drawSelectionRectangle(options, function(context) {
        return setContextTransform(r, context);
    });
}
// eslint-disable-next-line no-unused-vars
function drawAxes(r) {
    // for debgging
    var context = r.data.contexts[r.NODE];
    context.save();
    setContextTransform(r, context);
    context.strokeStyle = 'rgba(0, 0, 0, 0.3)';
    context.beginPath();
    context.moveTo(-1000, 0);
    context.lineTo(1000, 0);
    context.stroke();
    context.beginPath();
    context.moveTo(0, -1000);
    context.lineTo(0, 1000);
    context.stroke();
    context.restore();
}
function drawAtlases(r) {
    // For debugging the atlases
    var draw = function draw(drawing, name, row) {
        var collection = drawing.atlasManager.getAtlasCollection(name);
        var context = r.data.contexts[r.NODE];
        var scale = 0.125;
        var atlases = collection.atlases;
        for(var _i = 0; _i < atlases.length; _i++){
            var atlas = atlases[_i];
            var canvas = atlas.canvas;
            if (canvas) {
                var w = canvas.width;
                var h = canvas.height;
                var x = w * _i;
                var y = canvas.height * row;
                context.save();
                context.scale(scale, scale);
                context.drawImage(canvas, x, y);
                context.strokeStyle = 'black';
                context.rect(x, y, w, h);
                context.stroke();
                context.restore();
            }
        }
    };
    var i = 0;
    draw(r.drawing, 'node', i++);
    draw(r.drawing, 'label', i++);
}
/**
 * Arguments are in model coordinates.
 * (x1, y1) is top left corner
 * (x2, y2) is bottom right corner (optional)
 * Returns a Set of indexes.
 */ function getPickingIndexes(r, mX1, mY1, mX2, mY2) {
    var x, y, w, h;
    var _util$getEffectivePan3 = getEffectivePanZoom(r), pan = _util$getEffectivePan3.pan, zoom = _util$getEffectivePan3.zoom;
    var _util$modelToRendered = modelToRenderedPosition(r, pan, zoom, mX1, mY1), _util$modelToRendered2 = _slicedToArray(_util$modelToRendered, 2), cX1 = _util$modelToRendered2[0], cY1 = _util$modelToRendered2[1];
    var t = 6; // should be even
    x = cX1 - t / 2;
    y = cY1 - t / 2;
    w = t;
    h = t;
    if (w === 0 || h === 0) return [];
    var gl = r.data.contexts[r.WEBGL];
    gl.bindFramebuffer(gl.FRAMEBUFFER, r.pickingFrameBuffer);
    if (r.pickingFrameBuffer.needsDraw) {
        // Draw element z-indexes to the picking framebuffer
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        renderWebgl(r, null, RENDER_TARGET.PICKING);
        r.pickingFrameBuffer.needsDraw = false;
    }
    var n = w * h; // number of pixels to read
    // eslint-disable-next-line no-undef
    var data = new Uint8Array(n * 4); // 4 bytes per pixel
    gl.readPixels(x, y, w, h, gl.RGBA, gl.UNSIGNED_BYTE, data);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    var indexes = new Set();
    for(var i = 0; i < n; i++){
        var pixel = data.slice(i * 4, i * 4 + 4);
        var index = vec4ToIndex(pixel) - 1; // The framebuffer is cleared with 0s, so z-indexes are offset by 1
        if (index >= 0) indexes.add(index);
    }
    return indexes;
}
/**
 * Cy.js: model coordinate y axis goes down
 */ function findNearestElementsWebgl(r, x, y) {
    // model coordinates
    var indexes = getPickingIndexes(r, x, y);
    var eles = r.getCachedZSortedEles();
    var node, edge;
    var _iterator = _createForOfIteratorHelper(indexes), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var index = _step.value;
            var ele = eles[index];
            if (!node && ele.isNode()) node = ele;
            if (!edge && ele.isEdge()) edge = ele;
            if (node && edge) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return [
        node,
        edge
    ].filter(Boolean);
}
// TODO: Is constantly checking this slower than just rendering a texture?
// Maybe this should be cached as a flag on each node.
function isSimpleRectangle(node) {
    return node.pstyle('shape').value === 'rectangle' && node.pstyle('background-fill').value === 'solid' && node.pstyle('border-width').pfValue === 0 && node.pstyle('background-image').strValue === 'none';
}
function drawEle(r, index, ele) {
    var drawing = r.drawing;
    index += 1; // 0 is used to clear the background, need to offset all z-indexes by one
    if (ele.isNode()) {
        drawing.drawTexture(ele, index, 'node-underlay');
        if (isSimpleRectangle(ele)) drawing.drawSimpleRectangle(ele, index, 'node-body');
        else drawing.drawTexture(ele, index, 'node-body');
        drawing.drawTexture(ele, index, 'label');
        drawing.drawTexture(ele, index, 'node-overlay');
    } else {
        drawing.drawEdgeLine(ele, index);
        drawing.drawEdgeArrow(ele, index, 'source');
        drawing.drawEdgeArrow(ele, index, 'target');
        drawing.drawTexture(ele, index, 'label');
        drawing.drawTexture(ele, index, 'edge-source-label');
        drawing.drawTexture(ele, index, 'edge-target-label');
    }
}
function renderWebgl(r, options, renderTarget) {
    var start;
    if (r.webglDebug) start = performance.now(); // eslint-disable-line no-undef
    var drawing = r.drawing;
    var eleCount = 0;
    if (renderTarget.screen) {
        if (r.data.canvasNeedsRedraw[r.SELECT_BOX]) drawSelectionRectangle(r, options);
    }
    // see drawing-elements.js drawCachedElement()
    if (r.data.canvasNeedsRedraw[r.NODE] || renderTarget.picking) {
        var gl = r.data.contexts[r.WEBGL];
        if (renderTarget.screen) {
            gl.clearColor(0, 0, 0, 0); // background color
            gl.enable(gl.BLEND); // enable alpha blending of textures
            gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA); // we are using premultiplied alpha
        } else gl.disable(gl.BLEND);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        var panZoomMatrix = createPanZoomMatrix(r);
        var eles = r.getCachedZSortedEles();
        eleCount = eles.length;
        drawing.startFrame(panZoomMatrix, renderTarget);
        if (renderTarget.screen) {
            for(var i = 0; i < eles.nondrag.length; i++)drawEle(r, i, eles.nondrag[i]);
            for(var _i2 = 0; _i2 < eles.drag.length; _i2++)drawEle(r, _i2, eles.drag[_i2]);
        } else if (renderTarget.picking) for(var _i3 = 0; _i3 < eles.length; _i3++)drawEle(r, _i3, eles[_i3]);
        drawing.endFrame();
        if (renderTarget.screen && r.webglDebugShowAtlases) {
            drawAxes(r);
            drawAtlases(r);
        }
        r.data.canvasNeedsRedraw[r.NODE] = false;
        r.data.canvasNeedsRedraw[r.DRAG] = false;
    }
    if (r.webglDebug) {
        // eslint-disable-next-line no-undef
        var end = performance.now();
        var compact = false;
        var time = Math.ceil(end - start);
        var debugInfo = drawing.getDebugInfo();
        var report = [
            "".concat(eleCount, " elements"),
            "".concat(debugInfo.totalInstances, " instances"),
            "".concat(debugInfo.batchCount, " batches"),
            "".concat(debugInfo.totalAtlases, " atlases"),
            "".concat(debugInfo.wrappedCount, " wrapped textures"),
            "".concat(debugInfo.rectangleCount, " simple rectangles")
        ].join(', ');
        if (compact) console.log("WebGL (".concat(renderTarget.name, ") - time ").concat(time, "ms, ").concat(report));
        else {
            console.log("WebGL (".concat(renderTarget.name, ") - frame time ").concat(time, "ms"));
            console.log('Totals:');
            console.log("  ".concat(report));
            console.log('Texture Atlases Used:');
            var atlasInfo = debugInfo.atlasInfo;
            var _iterator3 = _createForOfIteratorHelper(atlasInfo), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var info = _step3.value;
                    console.log("  ".concat(info.type, ": ").concat(info.keyCount, " keys, ").concat(info.atlasCount, " atlases"));
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            console.log('');
        }
    }
    if (r.data.gc) {
        console.log('Garbage Collect!');
        r.data.gc = false;
        drawing.gc();
    }
}
var CRp$3 = {};
// @O Polygon drawing
CRp$3.drawPolygonPath = function(context, x, y, width, height, points) {
    var halfW = width / 2;
    var halfH = height / 2;
    if (context.beginPath) context.beginPath();
    context.moveTo(x + halfW * points[0], y + halfH * points[1]);
    for(var i = 1; i < points.length / 2; i++)context.lineTo(x + halfW * points[i * 2], y + halfH * points[i * 2 + 1]);
    context.closePath();
};
CRp$3.drawRoundPolygonPath = function(context, x, y, width, height, points, corners) {
    corners.forEach(function(corner) {
        return drawPreparedRoundCorner(context, corner);
    });
    context.closePath();
};
// Round rectangle drawing
CRp$3.drawRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? getRoundRectangleRadius(width, height) : Math.min(radius, halfHeight, halfWidth);
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    // Arc from middle top to right side
    context.arcTo(x + halfWidth, y - halfHeight, x + halfWidth, y, cornerRadius);
    // Arc from right side to bottom
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    // Arc from bottom to left side
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    // Arc from left side to topBorder
    context.arcTo(x - halfWidth, y - halfHeight, x, y - halfHeight, cornerRadius);
    // Join line
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
CRp$3.drawBottomRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? getRoundRectangleRadius(width, height) : radius;
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight);
    context.lineTo(x + halfWidth, y);
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    context.lineTo(x - halfWidth, y - halfHeight);
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
CRp$3.drawCutRectanglePath = function(context, x, y, width, height, points, corners) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerLength = corners === 'auto' ? getCutRectangleCornerLength() : corners;
    if (context.beginPath) context.beginPath();
    context.moveTo(x - halfWidth + cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth - cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight + cornerLength);
    context.lineTo(x + halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x + halfWidth - cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth + cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x - halfWidth, y - halfHeight + cornerLength);
    context.closePath();
};
CRp$3.drawBarrelPath = function(context, x, y, width, height) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var xBegin = x - halfWidth;
    var xEnd = x + halfWidth;
    var yBegin = y - halfHeight;
    var yEnd = y + halfHeight;
    var barrelCurveConstants = getBarrelCurveConstants(width, height);
    var wOffset = barrelCurveConstants.widthOffset;
    var hOffset = barrelCurveConstants.heightOffset;
    var ctrlPtXOffset = barrelCurveConstants.ctrlPtOffsetPct * wOffset;
    if (context.beginPath) context.beginPath();
    context.moveTo(xBegin, yBegin + hOffset);
    context.lineTo(xBegin, yEnd - hOffset);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yEnd, xBegin + wOffset, yEnd);
    context.lineTo(xEnd - wOffset, yEnd);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yEnd, xEnd, yEnd - hOffset);
    context.lineTo(xEnd, yBegin + hOffset);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yBegin, xEnd - wOffset, yBegin);
    context.lineTo(xBegin + wOffset, yBegin);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yBegin, xBegin, yBegin + hOffset);
    context.closePath();
};
var sin0 = Math.sin(0);
var cos0 = Math.cos(0);
var sin = {};
var cos = {};
var ellipseStepSize = Math.PI / 40;
for(var i = 0 * Math.PI; i < 2 * Math.PI; i += ellipseStepSize){
    sin[i] = Math.sin(i);
    cos[i] = Math.cos(i);
}
CRp$3.drawEllipsePath = function(context, centerX, centerY, width, height) {
    if (context.beginPath) context.beginPath();
    if (context.ellipse) context.ellipse(centerX, centerY, width / 2, height / 2, 0, 0, 2 * Math.PI);
    else {
        var xPos, yPos;
        var rw = width / 2;
        var rh = height / 2;
        for(var i = 0 * Math.PI; i < 2 * Math.PI; i += ellipseStepSize){
            xPos = centerX - rw * sin[i] * sin0 + rw * cos[i] * cos0;
            yPos = centerY + rh * cos[i] * sin0 + rh * sin[i] * cos0;
            if (i === 0) context.moveTo(xPos, yPos);
            else context.lineTo(xPos, yPos);
        }
    }
    context.closePath();
};
/* global atob, ArrayBuffer, Uint8Array, Blob */ var CRp$2 = {};
CRp$2.createBuffer = function(w, h) {
    var buffer = document.createElement('canvas'); // eslint-disable-line no-undef
    buffer.width = w;
    buffer.height = h;
    return [
        buffer,
        buffer.getContext('2d')
    ];
};
CRp$2.bufferCanvasImage = function(options) {
    var cy = this.cy;
    var eles = cy.mutableElements();
    var bb = eles.boundingBox();
    var ctrRect = this.findContainerClientCoords();
    var width = options.full ? Math.ceil(bb.w) : ctrRect[2];
    var height = options.full ? Math.ceil(bb.h) : ctrRect[3];
    var specdMaxDims = number$1(options.maxWidth) || number$1(options.maxHeight);
    var pxRatio = this.getPixelRatio();
    var scale = 1;
    if (options.scale !== undefined) {
        width *= options.scale;
        height *= options.scale;
        scale = options.scale;
    } else if (specdMaxDims) {
        var maxScaleW = Infinity;
        var maxScaleH = Infinity;
        if (number$1(options.maxWidth)) maxScaleW = scale * options.maxWidth / width;
        if (number$1(options.maxHeight)) maxScaleH = scale * options.maxHeight / height;
        scale = Math.min(maxScaleW, maxScaleH);
        width *= scale;
        height *= scale;
    }
    if (!specdMaxDims) {
        width *= pxRatio;
        height *= pxRatio;
        scale *= pxRatio;
    }
    var buffCanvas = document.createElement('canvas'); // eslint-disable-line no-undef
    buffCanvas.width = width;
    buffCanvas.height = height;
    buffCanvas.style.width = width + 'px';
    buffCanvas.style.height = height + 'px';
    var buffCxt = buffCanvas.getContext('2d');
    // Rasterize the layers, but only if container has nonzero size
    if (width > 0 && height > 0) {
        buffCxt.clearRect(0, 0, width, height);
        buffCxt.globalCompositeOperation = 'source-over';
        var zsortedEles = this.getCachedZSortedEles();
        if (options.full) {
            // draw the full bounds of the graph
            buffCxt.translate(-bb.x1 * scale, -bb.y1 * scale);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(bb.x1 * scale, bb.y1 * scale);
        } else {
            // draw the current view
            var pan = cy.pan();
            var translation = {
                x: pan.x * scale,
                y: pan.y * scale
            };
            scale *= cy.zoom();
            buffCxt.translate(translation.x, translation.y);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(-translation.x, -translation.y);
        }
        // need to fill bg at end like this in order to fill cleared transparent pixels in jpgs
        if (options.bg) {
            buffCxt.globalCompositeOperation = 'destination-over';
            buffCxt.fillStyle = options.bg;
            buffCxt.rect(0, 0, width, height);
            buffCxt.fill();
        }
    }
    return buffCanvas;
};
function b64ToBlob(b64, mimeType) {
    var bytes = atob(b64);
    var buff = new ArrayBuffer(bytes.length);
    var buffUint8 = new Uint8Array(buff);
    for(var i = 0; i < bytes.length; i++)buffUint8[i] = bytes.charCodeAt(i);
    return new Blob([
        buff
    ], {
        type: mimeType
    });
}
function b64UriToB64(b64uri) {
    var i = b64uri.indexOf(',');
    return b64uri.substr(i + 1);
}
function output(options, canvas, mimeType) {
    var getB64Uri = function getB64Uri() {
        return canvas.toDataURL(mimeType, options.quality);
    };
    switch(options.output){
        case 'blob-promise':
            return new Promise$1(function(resolve, reject) {
                try {
                    canvas.toBlob(function(blob) {
                        if (blob != null) resolve(blob);
                        else reject(new Error('`canvas.toBlob()` sent a null value in its callback'));
                    }, mimeType, options.quality);
                } catch (err) {
                    reject(err);
                }
            });
        case 'blob':
            return b64ToBlob(b64UriToB64(getB64Uri()), mimeType);
        case 'base64':
            return b64UriToB64(getB64Uri());
        case 'base64uri':
        default:
            return getB64Uri();
    }
}
CRp$2.png = function(options) {
    return output(options, this.bufferCanvasImage(options), 'image/png');
};
CRp$2.jpg = function(options) {
    return output(options, this.bufferCanvasImage(options), 'image/jpeg');
};
var CRp$1 = {};
CRp$1.nodeShapeImpl = function(name, context, centerX, centerY, width, height, points, corners) {
    switch(name){
        case 'ellipse':
            return this.drawEllipsePath(context, centerX, centerY, width, height);
        case 'polygon':
            return this.drawPolygonPath(context, centerX, centerY, width, height, points);
        case 'round-polygon':
            return this.drawRoundPolygonPath(context, centerX, centerY, width, height, points, corners);
        case 'roundrectangle':
        case 'round-rectangle':
            return this.drawRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'cutrectangle':
        case 'cut-rectangle':
            return this.drawCutRectanglePath(context, centerX, centerY, width, height, points, corners);
        case 'bottomroundrectangle':
        case 'bottom-round-rectangle':
            return this.drawBottomRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'barrel':
            return this.drawBarrelPath(context, centerX, centerY, width, height);
    }
};
var CR = CanvasRenderer;
var CRp = CanvasRenderer.prototype;
CRp.CANVAS_LAYERS = 3;
//
CRp.SELECT_BOX = 0;
CRp.DRAG = 1;
CRp.NODE = 2;
CRp.WEBGL = 3;
CRp.CANVAS_TYPES = [
    '2d',
    '2d',
    '2d',
    'webgl2'
];
CRp.BUFFER_COUNT = 3;
//
CRp.TEXTURE_BUFFER = 0;
CRp.MOTIONBLUR_BUFFER_NODE = 1;
CRp.MOTIONBLUR_BUFFER_DRAG = 2;
function CanvasRenderer(options) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    if (options.webgl) {
        CRp.CANVAS_LAYERS = r.CANVAS_LAYERS = 4;
        console.log('webgl rendering enabled');
    }
    r.data = {
        canvases: new Array(CRp.CANVAS_LAYERS),
        contexts: new Array(CRp.CANVAS_LAYERS),
        canvasNeedsRedraw: new Array(CRp.CANVAS_LAYERS),
        bufferCanvases: new Array(CRp.BUFFER_COUNT),
        bufferContexts: new Array(CRp.CANVAS_LAYERS)
    };
    var tapHlOffAttr = '-webkit-tap-highlight-color';
    var tapHlOffStyle = 'rgba(0,0,0,0)';
    r.data.canvasContainer = document1.createElement('div'); // eslint-disable-line no-undef
    var containerStyle = r.data.canvasContainer.style;
    r.data.canvasContainer.style[tapHlOffAttr] = tapHlOffStyle;
    containerStyle.position = 'relative';
    containerStyle.zIndex = '0';
    containerStyle.overflow = 'hidden';
    var container = options.cy.container();
    container.appendChild(r.data.canvasContainer);
    container.style[tapHlOffAttr] = tapHlOffStyle;
    var styleMap = {
        '-webkit-user-select': 'none',
        '-moz-user-select': '-moz-none',
        'user-select': 'none',
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        'outline-style': 'none'
    };
    if (ms()) {
        styleMap['-ms-touch-action'] = 'none';
        styleMap['touch-action'] = 'none';
    }
    for(var i = 0; i < CRp.CANVAS_LAYERS; i++){
        var canvas = r.data.canvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        var type = CRp.CANVAS_TYPES[i];
        r.data.contexts[i] = canvas.getContext(type);
        if (!r.data.contexts[i]) error('Could not create canvas of type ' + type);
        Object.keys(styleMap).forEach(function(k) {
            canvas.style[k] = styleMap[k];
        });
        canvas.style.position = 'absolute';
        canvas.setAttribute('data-id', 'layer' + i);
        canvas.style.zIndex = String(CRp.CANVAS_LAYERS - i);
        r.data.canvasContainer.appendChild(canvas);
        r.data.canvasNeedsRedraw[i] = false;
    }
    r.data.topCanvas = r.data.canvases[0];
    r.data.canvases[CRp.NODE].setAttribute('data-id', 'layer' + CRp.NODE + '-node');
    r.data.canvases[CRp.SELECT_BOX].setAttribute('data-id', 'layer' + CRp.SELECT_BOX + '-selectbox');
    r.data.canvases[CRp.DRAG].setAttribute('data-id', 'layer' + CRp.DRAG + '-drag');
    if (r.data.canvases[CRp.WEBGL]) r.data.canvases[CRp.WEBGL].setAttribute('data-id', 'layer' + CRp.WEBGL + '-webgl');
    for(var i = 0; i < CRp.BUFFER_COUNT; i++){
        r.data.bufferCanvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        r.data.bufferContexts[i] = r.data.bufferCanvases[i].getContext('2d');
        r.data.bufferCanvases[i].style.position = 'absolute';
        r.data.bufferCanvases[i].setAttribute('data-id', 'buffer' + i);
        r.data.bufferCanvases[i].style.zIndex = String(-i - 1);
        r.data.bufferCanvases[i].style.visibility = 'hidden';
    //r.data.canvasContainer.appendChild(r.data.bufferCanvases[i]);
    }
    r.pathsEnabled = true;
    var emptyBb = makeBoundingBox();
    var getBoxCenter = function getBoxCenter(bb) {
        return {
            x: (bb.x1 + bb.x2) / 2,
            y: (bb.y1 + bb.y2) / 2
        };
    };
    var getCenterOffset = function getCenterOffset(bb) {
        return {
            x: -bb.w / 2,
            y: -bb.h / 2
        };
    };
    var backgroundTimestampHasChanged = function backgroundTimestampHasChanged(ele) {
        var _p = ele[0]._private;
        var same = _p.oldBackgroundTimestamp === _p.backgroundTimestamp;
        return !same;
    };
    var getStyleKey = function getStyleKey(ele) {
        return ele[0]._private.nodeKey;
    };
    var getLabelKey = function getLabelKey(ele) {
        return ele[0]._private.labelStyleKey;
    };
    var getSourceLabelKey = function getSourceLabelKey(ele) {
        return ele[0]._private.sourceLabelStyleKey;
    };
    var getTargetLabelKey = function getTargetLabelKey(ele) {
        return ele[0]._private.targetLabelStyleKey;
    };
    var drawElement = function drawElement(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElement(context, ele, bb, false, false, useEleOpacity);
    };
    var drawLabel = function drawLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'main', useEleOpacity);
    };
    var drawSourceLabel = function drawSourceLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'source', useEleOpacity);
    };
    var drawTargetLabel = function drawTargetLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'target', useEleOpacity);
    };
    var getElementBox = function getElementBox(ele) {
        ele.boundingBox();
        return ele[0]._private.bodyBounds;
    };
    var getLabelBox = function getLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.main || emptyBb;
    };
    var getSourceLabelBox = function getSourceLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.source || emptyBb;
    };
    var getTargetLabelBox = function getTargetLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.target || emptyBb;
    };
    var isLabelVisibleAtScale = function isLabelVisibleAtScale(ele, scaledLabelShown) {
        return scaledLabelShown;
    };
    var getElementRotationPoint = function getElementRotationPoint(ele) {
        return getBoxCenter(getElementBox(ele));
    };
    var addTextMargin = function addTextMargin(prefix, pt, ele) {
        var pre = prefix ? prefix + '-' : '';
        return {
            x: pt.x + ele.pstyle(pre + 'text-margin-x').pfValue,
            y: pt.y + ele.pstyle(pre + 'text-margin-y').pfValue
        };
    };
    var getRsPt = function getRsPt(ele, x, y) {
        var rs = ele[0]._private.rscratch;
        return {
            x: rs[x],
            y: rs[y]
        };
    };
    var getLabelRotationPoint = function getLabelRotationPoint(ele) {
        return addTextMargin('', getRsPt(ele, 'labelX', 'labelY'), ele);
    };
    var getSourceLabelRotationPoint = function getSourceLabelRotationPoint(ele) {
        return addTextMargin('source', getRsPt(ele, 'sourceLabelX', 'sourceLabelY'), ele);
    };
    var getTargetLabelRotationPoint = function getTargetLabelRotationPoint(ele) {
        return addTextMargin('target', getRsPt(ele, 'targetLabelX', 'targetLabelY'), ele);
    };
    var getElementRotationOffset = function getElementRotationOffset(ele) {
        return getCenterOffset(getElementBox(ele));
    };
    var getSourceLabelRotationOffset = function getSourceLabelRotationOffset(ele) {
        return getCenterOffset(getSourceLabelBox(ele));
    };
    var getTargetLabelRotationOffset = function getTargetLabelRotationOffset(ele) {
        return getCenterOffset(getTargetLabelBox(ele));
    };
    var getLabelRotationOffset = function getLabelRotationOffset(ele) {
        var bb = getLabelBox(ele);
        var p = getCenterOffset(getLabelBox(ele));
        if (ele.isNode()) {
            switch(ele.pstyle('text-halign').value){
                case 'left':
                    p.x = -bb.w - (bb.leftPad || 0);
                    break;
                case 'right':
                    p.x = -(bb.rightPad || 0);
                    break;
            }
            switch(ele.pstyle('text-valign').value){
                case 'top':
                    p.y = -bb.h - (bb.topPad || 0);
                    break;
                case 'bottom':
                    p.y = -(bb.botPad || 0);
                    break;
            }
        }
        return p;
    };
    var eleTxrCache = r.data.eleTxrCache = new ElementTextureCache(r, {
        getKey: getStyleKey,
        doesEleInvalidateKey: backgroundTimestampHasChanged,
        drawElement: drawElement,
        getBoundingBox: getElementBox,
        getRotationPoint: getElementRotationPoint,
        getRotationOffset: getElementRotationOffset,
        allowEdgeTxrCaching: false,
        allowParentTxrCaching: false
    });
    var lblTxrCache = r.data.lblTxrCache = new ElementTextureCache(r, {
        getKey: getLabelKey,
        drawElement: drawLabel,
        getBoundingBox: getLabelBox,
        getRotationPoint: getLabelRotationPoint,
        getRotationOffset: getLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var slbTxrCache = r.data.slbTxrCache = new ElementTextureCache(r, {
        getKey: getSourceLabelKey,
        drawElement: drawSourceLabel,
        getBoundingBox: getSourceLabelBox,
        getRotationPoint: getSourceLabelRotationPoint,
        getRotationOffset: getSourceLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var tlbTxrCache = r.data.tlbTxrCache = new ElementTextureCache(r, {
        getKey: getTargetLabelKey,
        drawElement: drawTargetLabel,
        getBoundingBox: getTargetLabelBox,
        getRotationPoint: getTargetLabelRotationPoint,
        getRotationOffset: getTargetLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var lyrTxrCache = r.data.lyrTxrCache = new LayeredTextureCache(r);
    r.onUpdateEleCalcs(function invalidateTextureCaches(willDraw, eles) {
        // each cache should check for sub-key diff to see that the update affects that cache particularly
        eleTxrCache.invalidateElements(eles);
        lblTxrCache.invalidateElements(eles);
        slbTxrCache.invalidateElements(eles);
        tlbTxrCache.invalidateElements(eles);
        // any change invalidates the layers
        lyrTxrCache.invalidateElements(eles);
        // update the old bg timestamp so diffs can be done in the ele txr caches
        for(var _i = 0; _i < eles.length; _i++){
            var _p = eles[_i]._private;
            _p.oldBackgroundTimestamp = _p.backgroundTimestamp;
        }
    });
    var refineInLayers = function refineInLayers(reqs) {
        for(var i = 0; i < reqs.length; i++)lyrTxrCache.enqueueElementRefinement(reqs[i].ele);
    };
    eleTxrCache.onDequeue(refineInLayers);
    lblTxrCache.onDequeue(refineInLayers);
    slbTxrCache.onDequeue(refineInLayers);
    tlbTxrCache.onDequeue(refineInLayers);
    if (options.webgl) r.initWebgl(options, {
        getStyleKey: getStyleKey,
        getLabelKey: getLabelKey,
        getSourceLabelKey: getSourceLabelKey,
        getTargetLabelKey: getTargetLabelKey,
        drawElement: drawElement,
        drawLabel: drawLabel,
        drawSourceLabel: drawSourceLabel,
        drawTargetLabel: drawTargetLabel,
        getElementBox: getElementBox,
        getLabelBox: getLabelBox,
        getSourceLabelBox: getSourceLabelBox,
        getTargetLabelBox: getTargetLabelBox,
        getElementRotationPoint: getElementRotationPoint,
        getElementRotationOffset: getElementRotationOffset,
        getLabelRotationPoint: getLabelRotationPoint,
        getSourceLabelRotationPoint: getSourceLabelRotationPoint,
        getTargetLabelRotationPoint: getTargetLabelRotationPoint,
        getLabelRotationOffset: getLabelRotationOffset,
        getSourceLabelRotationOffset: getSourceLabelRotationOffset,
        getTargetLabelRotationOffset: getTargetLabelRotationOffset
    });
}
CRp.redrawHint = function(group, bool) {
    var r = this;
    switch(group){
        case 'eles':
            r.data.canvasNeedsRedraw[CRp.NODE] = bool;
            break;
        case 'drag':
            r.data.canvasNeedsRedraw[CRp.DRAG] = bool;
            break;
        case 'select':
            r.data.canvasNeedsRedraw[CRp.SELECT_BOX] = bool;
            break;
        case 'gc':
            r.data.gc = true;
            break;
    }
};
// whether to use Path2D caching for drawing
var pathsImpld = typeof Path2D !== 'undefined';
CRp.path2dEnabled = function(on) {
    if (on === undefined) return this.pathsEnabled;
    this.pathsEnabled = on ? true : false;
};
CRp.usePaths = function() {
    return pathsImpld && this.pathsEnabled;
};
CRp.setImgSmoothing = function(context, bool) {
    if (context.imageSmoothingEnabled != null) context.imageSmoothingEnabled = bool;
    else {
        context.webkitImageSmoothingEnabled = bool;
        context.mozImageSmoothingEnabled = bool;
        context.msImageSmoothingEnabled = bool;
    }
};
CRp.getImgSmoothing = function(context) {
    if (context.imageSmoothingEnabled != null) return context.imageSmoothingEnabled;
    else return context.webkitImageSmoothingEnabled || context.mozImageSmoothingEnabled || context.msImageSmoothingEnabled;
};
CRp.makeOffscreenCanvas = function(width, height) {
    var canvas;
    if ((typeof OffscreenCanvas === "undefined" ? "undefined" : _typeof(OffscreenCanvas)) !== "undefined") canvas = new OffscreenCanvas(width, height);
    else {
        var containerWindow = this.cy.window();
        var document1 = containerWindow.document;
        canvas = document1.createElement('canvas'); // eslint-disable-line no-undef
        canvas.width = width;
        canvas.height = height;
    }
    return canvas;
};
[
    CRp$b,
    CRp$a,
    CRp$9,
    CRp$8,
    CRp$7,
    CRp$6,
    CRp$5,
    CRp$4,
    CRp$3,
    CRp$2,
    CRp$1
].forEach(function(props) {
    extend(CRp, props);
});
var renderer = [
    {
        name: 'null',
        impl: NullRenderer
    },
    {
        name: 'base',
        impl: BR
    },
    {
        name: 'canvas',
        impl: CR
    }
];
var incExts = [
    {
        type: 'layout',
        extensions: layout
    },
    {
        type: 'renderer',
        extensions: renderer
    }
];
// registered extensions to cytoscape, indexed by name
var extensions = {};
// registered modules for extensions, indexed by name
var modules = {};
function setExtension(type, name, registrant) {
    var ext = registrant;
    var overrideErr = function overrideErr(field) {
        warn('Can not register `' + name + '` for `' + type + '` since `' + field + '` already exists in the prototype and can not be overridden');
    };
    if (type === 'core') {
        if (Core.prototype[name]) return overrideErr(name);
        else Core.prototype[name] = registrant;
    } else if (type === 'collection') {
        if (Collection.prototype[name]) return overrideErr(name);
        else Collection.prototype[name] = registrant;
    } else if (type === 'layout') {
        // fill in missing layout functions in the prototype
        var Layout = function Layout(options) {
            this.options = options;
            registrant.call(this, options);
            // make sure layout has _private for use w/ std apis like .on()
            if (!plainObject(this._private)) this._private = {};
            this._private.cy = options.cy;
            this._private.listeners = [];
            this.createEmitter();
        };
        var layoutProto = Layout.prototype = Object.create(registrant.prototype);
        var optLayoutFns = [];
        for(var i = 0; i < optLayoutFns.length; i++){
            var fnName = optLayoutFns[i];
            layoutProto[fnName] = layoutProto[fnName] || function() {
                return this;
            };
        }
        // either .start() or .run() is defined, so autogen the other
        if (layoutProto.start && !layoutProto.run) layoutProto.run = function() {
            this.start();
            return this;
        };
        else if (!layoutProto.start && layoutProto.run) layoutProto.start = function() {
            this.run();
            return this;
        };
        var regStop = registrant.prototype.stop;
        layoutProto.stop = function() {
            var opts = this.options;
            if (opts && opts.animate) {
                var anis = this.animations;
                if (anis) for(var _i = 0; _i < anis.length; _i++)anis[_i].stop();
            }
            if (regStop) regStop.call(this);
            else this.emit('layoutstop');
            return this;
        };
        if (!layoutProto.destroy) layoutProto.destroy = function() {
            return this;
        };
        layoutProto.cy = function() {
            return this._private.cy;
        };
        var getCy = function getCy(layout) {
            return layout._private.cy;
        };
        var emitterOpts = {
            addEventFields: function addEventFields(layout, evt) {
                evt.layout = layout;
                evt.cy = getCy(layout);
                evt.target = layout;
            },
            bubble: function bubble() {
                return true;
            },
            parent: function parent(layout) {
                return getCy(layout);
            }
        };
        extend(layoutProto, {
            createEmitter: function createEmitter() {
                this._private.emitter = new Emitter(emitterOpts, this);
                return this;
            },
            emitter: function emitter() {
                return this._private.emitter;
            },
            on: function on(evt, cb) {
                this.emitter().on(evt, cb);
                return this;
            },
            one: function one(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            once: function once(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            removeListener: function removeListener(evt, cb) {
                this.emitter().removeListener(evt, cb);
                return this;
            },
            removeAllListeners: function removeAllListeners() {
                this.emitter().removeAllListeners();
                return this;
            },
            emit: function emit(evt, params) {
                this.emitter().emit(evt, params);
                return this;
            }
        });
        define.eventAliasesOn(layoutProto);
        ext = Layout; // replace with our wrapped layout
    } else if (type === 'renderer' && name !== 'null' && name !== 'base') {
        // user registered renderers inherit from base
        var BaseRenderer = getExtension('renderer', 'base');
        var bProto = BaseRenderer.prototype;
        var RegistrantRenderer = registrant;
        var rProto = registrant.prototype;
        var Renderer = function Renderer() {
            BaseRenderer.apply(this, arguments);
            RegistrantRenderer.apply(this, arguments);
        };
        var proto = Renderer.prototype;
        for(var pName in bProto){
            var pVal = bProto[pName];
            var existsInR = rProto[pName] != null;
            if (existsInR) return overrideErr(pName);
            proto[pName] = pVal; // take impl from base
        }
        for(var _pName in rProto)proto[_pName] = rProto[_pName]; // take impl from registrant
        bProto.clientFunctions.forEach(function(name) {
            proto[name] = proto[name] || function() {
                error('Renderer does not implement `renderer.' + name + '()` on its prototype');
            };
        });
        ext = Renderer;
    } else if (type === '__proto__' || type === 'constructor' || type === 'prototype') // to avoid potential prototype pollution
    return error(type + ' is an illegal type to be registered, possibly lead to prototype pollutions');
    return setMap({
        map: extensions,
        keys: [
            type,
            name
        ],
        value: ext
    });
}
function getExtension(type, name) {
    return getMap({
        map: extensions,
        keys: [
            type,
            name
        ]
    });
}
function setModule(type, name, moduleType, moduleName, registrant) {
    return setMap({
        map: modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ],
        value: registrant
    });
}
function getModule(type, name, moduleType, moduleName) {
    return getMap({
        map: modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ]
    });
}
var extension = function extension() {
    // e.g. extension('renderer', 'svg')
    if (arguments.length === 2) return getExtension.apply(null, arguments);
    else if (arguments.length === 3) return setExtension.apply(null, arguments);
    else if (arguments.length === 4) return getModule.apply(null, arguments);
    else if (arguments.length === 5) return setModule.apply(null, arguments);
    else error('Invalid extension access syntax');
};
// allows a core instance to access extensions internally
Core.prototype.extension = extension;
// included extensions
incExts.forEach(function(group) {
    group.extensions.forEach(function(ext) {
        setExtension(group.type, ext.name, ext.impl);
    });
});
// a dummy stylesheet object that doesn't need a reference to the core
// (useful for init)
var _Stylesheet = function Stylesheet() {
    if (!(this instanceof _Stylesheet)) return new _Stylesheet();
    this.length = 0;
};
var sheetfn = _Stylesheet.prototype;
sheetfn.instanceString = function() {
    return 'stylesheet';
};
// just store the selector to be parsed later
sheetfn.selector = function(selector) {
    var i = this.length++;
    this[i] = {
        selector: selector,
        properties: []
    };
    return this; // chaining
};
// just store the property to be parsed later
sheetfn.css = function(name, value) {
    var i = this.length - 1;
    if (string(name)) this[i].properties.push({
        name: name,
        value: value
    });
    else if (plainObject(name)) {
        var map = name;
        var propNames = Object.keys(map);
        for(var j = 0; j < propNames.length; j++){
            var key = propNames[j];
            var mapVal = map[key];
            if (mapVal == null) continue;
            var prop = _Style.properties[key] || _Style.properties[dash2camel(key)];
            if (prop == null) continue;
            var _name = prop.name;
            var _value = mapVal;
            this[i].properties.push({
                name: _name,
                value: _value
            });
        }
    }
    return this; // chaining
};
sheetfn.style = sheetfn.css;
// generate a real style object from the dummy stylesheet
sheetfn.generateStyle = function(cy) {
    var style = new _Style(cy);
    return this.appendToStyle(style);
};
// append a dummy stylesheet object on a real style object
sheetfn.appendToStyle = function(style) {
    for(var i = 0; i < this.length; i++){
        var context = this[i];
        var selector = context.selector;
        var props = context.properties;
        style.selector(selector); // apply selector
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            style.css(prop.name, prop.value); // apply property
        }
    }
    return style;
};
var version = "3.31.1";
var cytoscape = function cytoscape(options) {
    // if no options specified, use default
    if (options === undefined) options = {};
    // create instance
    if (plainObject(options)) return new Core(options);
    else if (string(options)) return extension.apply(extension, arguments);
};
// e.g. cytoscape.use( require('cytoscape-foo'), bar )
cytoscape.use = function(ext) {
    var args = Array.prototype.slice.call(arguments, 1); // args to pass to ext
    args.unshift(cytoscape); // cytoscape is first arg to ext
    ext.apply(null, args);
    return this;
};
cytoscape.warnings = function(bool) {
    return warnings(bool);
};
// replaced by build system
cytoscape.version = version;
// expose public apis (mostly for extensions)
cytoscape.stylesheet = cytoscape.Stylesheet = _Stylesheet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"axyKi":[function(require,module,exports,__globalThis) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(this, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _require = __webpack_require__(5), getBoundingBox = _require.getBoundingBox;
            // Create a popper virtual element (aka popper v1 reference object)
            // https://popper.js.org/docs/v2/virtual-elements/
            function getRef(target, opts) {
                //Define popper reference object and cy reference  object
                var refObject = {
                    getBoundingClientRect: function getBoundingClientRect() {
                        return getBoundingBox(target, opts);
                    }
                };
                return refObject;
            }
            module1.exports = {
                getRef: getRef
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Simple, internal Object.assign() polyfill for options objects etc.
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.forEach(function(src) {
                    if (src !== null && src !== undefined) Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _require = __webpack_require__(0), getRef = _require.getRef;
            var _require2 = __webpack_require__(6), getContent = _require2.getContent;
            // Create a new popper object for a core or element target
            function getPopper(target, opts) {
                var refObject = getRef(target, opts);
                var content = getContent(target, opts.content);
                return target.popperFactory(refObject, content, opts.popper);
            }
            module1.exports = {
                getPopper: getPopper
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var assign = __webpack_require__(1);
            var _require = __webpack_require__(2), getPopper = _require.getPopper;
            var _require2 = __webpack_require__(0), getRef = _require2.getRef;
            function popper(opts) {
                checkForWarning(this);
                return getPopper(this[0], createOptionsObject(this[0], opts));
            }
            function popperRef(opts) {
                checkForWarning(this);
                return getRef(this[0], createOptionsObject(this[0], opts));
            }
            function createOptionsObject(target, opts) {
                var renderedDimensions = function renderedDimensions(el) {
                    return el.isNode() ? {
                        w: el.renderedWidth(),
                        h: el.renderedHeight()
                    } : {
                        w: 3,
                        h: 3
                    };
                };
                var renderedPosition = function renderedPosition(el) {
                    return el.isNode() ? getRenderedCenter(el, renderedDimensions) : getRenderedMidpoint(el);
                };
                var popper = {};
                var cy = target.cy();
                var defaults = {
                    renderedDimensions: renderedDimensions,
                    renderedPosition: renderedPosition,
                    popper: popper,
                    cy: cy
                };
                return assign({}, defaults, opts);
            }
            //Get the rendered center
            function getRenderedCenter(target, renderedDimensions) {
                var pos = target.renderedPosition();
                var dimensions = renderedDimensions(target);
                var offsetX = dimensions.w / 2;
                var offsetY = dimensions.h / 2;
                return {
                    x: pos.x - offsetX,
                    y: pos.y - offsetY
                };
            }
            //Get the rendered position of the midpoint
            function getRenderedMidpoint(target) {
                var p = target.midpoint();
                var pan = target.cy().pan();
                var zoom = target.cy().zoom();
                return {
                    x: p.x * zoom + pan.x,
                    y: p.y * zoom + pan.y
                };
            }
            //Warn user about misuse of the plugin
            function checkForWarning(elements) {
                /* eslint-disable no-console */ //Popper.js Should only be used on 1 element
                if (elements.length > 1) {
                    console.warn("Popper.js Extension should only be used on one element.");
                    console.warn("Ignoring all subsequent elements");
                }
            /* eslint-enable */ }
            module1.exports = {
                popper: popper,
                popperRef: popperRef
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var assign = __webpack_require__(1);
            var _require = __webpack_require__(2), getPopper = _require.getPopper;
            var _require2 = __webpack_require__(0), getRef = _require2.getRef;
            function popper(opts) {
                return getPopper(this, createOptionsObject(this, opts));
            }
            function popperRef(opts) {
                return getRef(this, createOptionsObject(this, opts));
            }
            //Create a options object with required default values
            function createOptionsObject(target, opts) {
                var defaults = {
                    boundingBox: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        w: 3,
                        h: 3
                    },
                    renderedDimensions: function renderedDimensions() {
                        return {
                            w: 3,
                            h: 3
                        };
                    },
                    renderedPosition: function renderedPosition() {
                        return {
                            x: 0,
                            y: 0
                        };
                    },
                    popper: {},
                    cy: target
                };
                return assign({}, defaults, opts);
            }
            module1.exports = {
                popper: popper,
                popperRef: popperRef
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function getBoundingBox(target, opts) {
                var renderedPosition = opts.renderedPosition, cy = opts.cy, renderedDimensions = opts.renderedDimensions;
                var offset = cy.container().getBoundingClientRect();
                var dims = renderedDimensions(target);
                var pos = renderedPosition(target);
                return {
                    top: pos.y + offset.top,
                    left: pos.x + offset.left,
                    right: pos.x + dims.w + offset.left,
                    bottom: pos.y + dims.h + offset.top,
                    width: dims.w,
                    height: dims.h
                };
            }
            module1.exports = {
                getBoundingBox: getBoundingBox
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            function getContent(target, content) {
                var contentObject = null;
                if (typeof content === "function") //Execute function if user opted for a dyanamic target
                contentObject = content(target);
                else if (content instanceof HTMLElement) //Target option is an HTML element
                return content;
                else throw new Error("Can not create popper from 'target' with unknown type");
                // Check validity of parsed target
                if (contentObject === null) throw new Error("No 'target' specified to create popper");
                else return contentObject;
            }
            module1.exports = {
                getContent: getContent
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var coreImpl = __webpack_require__(4);
            var collectionImpl = __webpack_require__(3);
            // registers the extension on a cytoscape lib ref
            var registerFactory = function registerFactory(popperFactory) {
                if (typeof popperFactory !== "function") throw new Error('Provide \'popperFactory\' before registering the module');
                return function register(cytoscape) {
                    if (!cytoscape) return;
                     // can't register if cytoscape unspecified
                    // register with cytoscape.js
                    cytoscape('core', 'popperFactory', popperFactory); // Cytoscape Core factory
                    cytoscape('collection', 'popperFactory', popperFactory); //Cytoscape Collections factory
                    cytoscape('core', 'popper', coreImpl.popper); //Cytoscape Core
                    cytoscape('collection', 'popper', collectionImpl.popper); //Cytoscape Collections
                    cytoscape('core', 'popperRef', coreImpl.popperRef); //Cytoscape Core for References
                    cytoscape('collection', 'popperRef', collectionImpl.popperRef); //Cytoscape Collections for References
                };
            };
            module1.exports = registerFactory;
        /***/ }
    ]);
});

},{}],"1ZPto":[function() {},{}],"aZMPq":[function(require,module,exports,__globalThis) {
/**
 * Compare whether sets contain same elements.
 *
 * https://stackoverflow.com/a/31129384/907060
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setsEqual", ()=>setsEqual);
function setsEqual(l, r) {
    if (l.size !== r.size) return false;
    for (const x of l){
        if (!r.has(x)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"pKmVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: Use one tippy and have max height for each pre
parcelHelpers.export(exports, "Popup", ()=>Popup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooksJs = require("../../hooks.js");
var _popupSliceJs = require("./popupSlice.js");
var _indexJs = require("../../components/popup/index.js");
var _popupCss = require("./Popup.css");
var _prettifyJs = require("./utils/prettify.js");
function Popup() {
    const popup = (0, _hooksJs.useAppSelector)((0, _popupSliceJs.popupValueSelector));
    const getReferenceClientRect = _react.useCallback(()=>popup.referenceClientRect, [
        popup?.referenceClientRect
    ]);
    if (popup === null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const makeTippy = (placement, params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJs.Popup), {
            className: "dataflow-popup",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: Object.entries(params).map(([k, v])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "label",
                                children: [
                                    k,
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                    children: v
                                })
                            }, k)
                        ]
                    }, k))
            }),
            getReferenceClientRect: getReferenceClientRect,
            visible: popup !== null,
            interactive: true,
            placement: placement,
            arrow: true,
            maxWidth: "550px",
            appendTo: document.body,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        }, placement);
    if (popup.type === 'edge') // If we want to enable popups on edges again, we can add functionality back
    // here
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const { node, value } = popup;
    if (Object.keys(node.params).length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const paramsTippy = makeTippy('top', node.params);
    if (!value || value.type === 'error') return paramsTippy;
    const valueTippy = makeTippy('bottom', value.type === 'function' ? {
        'Value (function name)': value.functionName
    } : {
        Value: (0, _prettifyJs.prettifyExpression)(JSON.stringify(value.value), 5)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            paramsTippy,
            valueTippy
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../hooks.js":"cg1kA","./popupSlice.js":"eODwE","../../components/popup/index.js":"iYrgc","./Popup.css":"4JvZg","./utils/prettify.js":"1Apxr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4JvZg":[function() {},{}],"gHfW4":[function() {},{}],"ekPAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _appCss = require("./app.css");
class Reset extends _react.PureComponent {
    handleClick() {
        window.localStorage.clear();
        window.location.href = window.location.pathname;
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "reset",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Reset the Vega Editor by clearing the local storage. You can run this if the editor is stuck in a loop or otherwise not functioning correctly. This operation cannot be undone."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: this.handleClick.bind(this),
                    type: "button",
                    children: "Reset Vega Editor"
                })
            ]
        });
    }
}
exports.default = (0, _reactRouterDom.withRouter)(Reset);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"b9X5n","./app.css":"iVDT3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iVDT3":[function() {},{}],"jQ5lq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>configureStore);
var _redux = require("redux");
var _reduxLocalstorage = require("redux-localstorage");
var _reduxLocalstorageDefault = parcelHelpers.interopDefault(_reduxLocalstorage);
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var _indexJs = require("../reducers/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../features/dataflow/index.js");
var _defaultStateJs = require("./../constants/default-state.js");
function configureStore(initialState = (0, _defaultStateJs.DEFAULT_STATE)) {
    // Compose final middleware
    const middleware = (0, _redux.applyMiddleware)((0, _reduxThunkDefault.default));
    // https://github.com/zalmoxisus/redux-devtools-extension#usage
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, _redux.compose);
    // Subset of state to store in localStorage
    const paths = Object.keys((0, _defaultStateJs.DEFAULT_STATE)).filter((e)=>e !== 'editorRef' && e !== 'compiledEditorRef' && e !== 'signals' && e !== 'view' && e !== 'isAuthenticated' && e !== 'errors' && e !== 'error' && e !== 'warns' && e !== 'infos' && e !== 'debugs' && e !== 'view' && !Object.keys((0, _indexJs1.dataflowInitialState)).includes(e));
    const enhancer = composeEnhancers(middleware, (0, _reduxLocalstorageDefault.default)(paths));
    // Create final store
    // TODO: remove as any
    const store = (0, _redux.createStore)((0, _indexJsDefault.default), initialState, enhancer);
    // TODO: enable HMR again
    // if ((import.meta as any).hot) {
    //   (import.meta as any).hot.accept('../reducers', () => {
    //     const nextRootReducer = require('../reducers').default;
    //     store.replaceReducer(nextRootReducer);
    //   });
    // }
    return store;
}

},{"redux":"jTcSr","redux-localstorage":"lbzWL","redux-thunk":"5hWib","../reducers/index.js":"28jYb","../features/dataflow/index.js":"lyRHo","./../constants/default-state.js":"4nviH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lbzWL":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports['default'] = persistState;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var _createSlicerJs = require("b698238a4909981c");
var _createSlicerJs2 = _interopRequireDefault(_createSlicerJs);
var _utilMergeStateJs = require("13496c6e508614f2");
var _utilMergeStateJs2 = _interopRequireDefault(_utilMergeStateJs);
/**
 * @description
 * persistState is a Store Enhancer that syncs (a subset of) store state to localStorage.
 *
 * @param {String|String[]} [paths] Specify keys to sync with localStorage, if left undefined the whole store is persisted
 * @param {Object} [config] Optional config object
 * @param {String} [config.key="redux"] String used as localStorage key
 * @param {Function} [config.slicer] (paths) => (state) => subset. A function that returns a subset
 * of store state that should be persisted to localStorage
 * @param {Function} [config.serialize=JSON.stringify] (subset) => serializedData. Called just before persisting to
 * localStorage. Should transform the subset into a format that can be stored.
 * @param {Function} [config.deserialize=JSON.parse] (persistedData) => subset. Called directly after retrieving
 * persistedState from localStorage. Should transform the data into the format expected by your application
 *
 * @return {Function} An enhanced store
 */ function persistState(paths, config) {
    var cfg = _extends({
        key: 'redux',
        merge: _utilMergeStateJs2['default'],
        slicer: _createSlicerJs2['default'],
        serialize: JSON.stringify,
        deserialize: JSON.parse
    }, config);
    var key = cfg.key;
    var merge = cfg.merge;
    var slicer = cfg.slicer;
    var serialize = cfg.serialize;
    var deserialize = cfg.deserialize;
    return function(next) {
        return function(reducer, initialState, enhancer) {
            if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
                enhancer = initialState;
                initialState = undefined;
            }
            var persistedState = undefined;
            var finalInitialState = undefined;
            try {
                persistedState = deserialize(localStorage.getItem(key));
                finalInitialState = merge(initialState, persistedState);
            } catch (e) {
                console.warn('Failed to retrieve initialize state from localStorage:', e);
            }
            var store = next(reducer, finalInitialState, enhancer);
            var slicerFn = slicer(paths);
            store.subscribe(function() {
                var state = store.getState();
                var subset = slicerFn(state);
                try {
                    localStorage.setItem(key, serialize(subset));
                } catch (e) {
                    console.warn('Unable to persist state to localStorage:', e);
                }
            });
            return store;
        };
    };
}
module.exports = exports['default'];

},{"b698238a4909981c":"dFBRi","13496c6e508614f2":"54TpM"}],"dFBRi":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = createSlicer;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var _getSubsetJs = require("927e72a914d703f5");
var _getSubsetJs2 = _interopRequireDefault(_getSubsetJs);
var _utilTypeOfJs = require("f2ec1a285b6b181d");
var _utilTypeOfJs2 = _interopRequireDefault(_utilTypeOfJs);
/**
 * @description
 * createSlicer inspects the typeof paths and returns an appropriate slicer function.
 *
 * @param {String|String[]} [paths] The paths argument supplied to persistState.
 *
 * @return {Function} A slicer function, which returns the subset to store when called with Redux's store state.
 */ function createSlicer(paths) {
    switch((0, _utilTypeOfJs2['default'])(paths)){
        case 'void':
            return function(state) {
                return state;
            };
        case 'string':
            return function(state) {
                return (0, _getSubsetJs2['default'])(state, [
                    paths
                ]);
            };
        case 'array':
            return function(state) {
                return (0, _getSubsetJs2['default'])(state, paths);
            };
        default:
            return console.error('Invalid paths argument, should be of type String, Array or Void');
    }
}
module.exports = exports['default'];

},{"927e72a914d703f5":"4ZUEL","f2ec1a285b6b181d":"iznug"}],"4ZUEL":[function(require,module,exports,__globalThis) {
/**
 * @description
 * getSubset returns an object with the same structure as the original object passed in,
 * but contains only the specified keys and only if that key has a truth-y value.
 *
 * @param {Object} obj The object from which to create a subset.
 * @param {String[]} paths An array of (top-level) keys that should be included in the subset.
 *
 * @return {Object} An object that contains the specified keys with truth-y values
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getSubset;
function getSubset(obj, paths) {
    var subset = {};
    paths.forEach(function(key) {
        var slice = obj[key];
        if (slice) subset[key] = slice;
    });
    return subset;
}
module.exports = exports["default"];

},{}],"iznug":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = typeOf;
var _isArray = Array.isArray || (Array.isArray = function(a) {
    return '' + a !== a && ({}).toString.call(a) === '[object Array]';
});
/**
 * @description
 * typeof method that
 * 1. groups all false-y & empty values as void
 * 2. distinguishes between object and array
 *
 * @param {*} thing The thing to inspect
 *
 * @return {String} Actionable type classification
 */ function typeOf(thing) {
    if (!thing) return 'void';
    if (_isArray(thing)) {
        if (!thing.length) return 'void';
        return 'array';
    }
    return typeof thing;
}
module.exports = exports['default'];

},{}],"54TpM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports["default"] = mergeState;
function mergeState(initialState, persistedState) {
    return persistedState ? _extends({}, initialState, persistedState) : initialState;
}
module.exports = exports["default"];

},{}],"28jYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonStringifyPrettyCompact = require("json-stringify-pretty-compact");
var _jsonStringifyPrettyCompactDefault = parcelHelpers.interopDefault(_jsonStringifyPrettyCompact);
var _semver = require("semver");
var _vega = require("vega");
var _vegaLite = require("vega-lite");
var _vegaSchemaUrlParser = require("vega-schema-url-parser");
var _vegaSchemaUrlParserDefault = parcelHelpers.interopDefault(_vegaSchemaUrlParser);
var _editorJs = require("../actions/editor.js");
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../features/dataflow/index.js");
var _validateJs = require("../utils/validate.js");
var _editorJs1 = require("./../actions/editor.js");
var _loggerJs = require("./../utils/logger.js");
var _jsoncParser = require("jsonc-parser");
function throwJSONCParseError(error, _offset, _length, startLine, startCharacter) {
    const errorMessage = `${(0, _jsoncParser.printParseErrorCode)(error)} at Ln ${startLine + 1}, Col ${startCharacter + 1}`;
    throw SyntaxError(errorMessage);
}
function parseJSONCOrThrow(spec) {
    (0, _jsoncParser.visit)(spec, {
        onError: throwJSONCParseError
    }, {
        disallowComments: false,
        allowTrailingComma: true
    });
    return (0, _jsoncParser.parse)(spec);
}
function mergeConfigIntoSpec(state) {
    if (state.configEditorString === '{}') return {
        ...state,
        parse: true
    };
    let spec;
    let config;
    try {
        spec = (0, _jsoncParser.parse)(state.editorString);
        config = (0, _jsoncParser.parse)(state.configEditorString);
        if (spec.config) spec.config = _vega.mergeConfig(config, spec.config);
        else spec.config = config;
        return {
            ...state,
            config: {},
            configEditorString: '{}',
            editorString: (0, _jsonStringifyPrettyCompactDefault.default)(spec),
            parse: true,
            themeName: 'custom'
        };
    } catch (e) {
        console.warn(e);
        return {
            ...state,
            parse: true
        };
    }
}
function extractConfig(state) {
    let spec;
    let config;
    try {
        spec = (0, _jsoncParser.parse)(state.editorString);
        config = (0, _jsoncParser.parse)(state.configEditorString);
        if (spec.config) {
            config = _vega.mergeConfig(config, spec.config);
            delete spec.config;
        }
        return {
            ...state,
            configEditorString: (0, _jsonStringifyPrettyCompactDefault.default)(config),
            editorString: (0, _jsonStringifyPrettyCompactDefault.default)(spec),
            parse: true
        };
    } catch (e) {
        console.warn(e);
        return {
            ...state,
            parse: true
        };
    }
}
function parseVega(state, action, extend = {}) {
    const currLogger = new (0, _loggerJs.LocalLogger)();
    currLogger.level(state.logLevel);
    try {
        const spec = parseJSONCOrThrow(action.spec);
        if (spec.$schema) try {
            const parsed = (0, _vegaSchemaUrlParserDefault.default)(spec.$schema);
            if (!(0, _semver.satisfies)(_vega.version, `^${parsed.version.slice(1)}`)) currLogger.warn(`The specification expects Vega ${parsed.version} but the editor uses v${_vega.version}.`);
        } catch (e) {
            throw new Error('Could not parse $schema url.');
        }
        (0, _validateJs.validateVega)(spec, currLogger);
        extend = {
            ...extend,
            vegaSpec: spec
        };
    } catch (e) {
        console.warn(e);
        extend = {
            ...extend,
            error: {
                message: e.message
            }
        };
    }
    return {
        ...state,
        editorString: action.spec,
        error: null,
        gist: null,
        mode: (0, _indexJs.Mode).Vega,
        selectedExample: null,
        errors: [],
        warns: currLogger.warns,
        infos: currLogger.infos,
        debugs: currLogger.debugs,
        // extend with other changes
        ...extend
    };
}
function parseVegaLite(state, action, extend = {}) {
    const currLogger = new (0, _loggerJs.LocalLogger)();
    currLogger.level(state.logLevel);
    let spec;
    let configEditorString;
    try {
        switch(action.type){
            case 0, _editorJs.SET_CONFIG:
                spec = state.editorString;
                configEditorString = action.configEditorString;
                break;
            case 0, _editorJs.SET_VEGA_LITE_EXAMPLE:
            case 0, _editorJs.SET_GIST_VEGA_LITE_SPEC:
            case 0, _editorJs.UPDATE_VEGA_LITE_SPEC:
                spec = action.spec;
                configEditorString = state.configEditorString;
        }
        const vegaLiteSpec = parseJSONCOrThrow(spec);
        const config = parseJSONCOrThrow(configEditorString);
        const options = {
            config,
            logger: currLogger
        };
        if (vegaLiteSpec.$schema) try {
            const parsed = (0, _vegaSchemaUrlParserDefault.default)(vegaLiteSpec.$schema);
            if (!(0, _semver.satisfies)(_vegaLite.version, `^${parsed.version.slice(1)}`)) currLogger.warn(`The specification expects Vega-Lite ${parsed.version} but the editor uses v${_vegaLite.version}.`);
        } catch (e) {
            throw new Error('Could not parse $schema url.');
        }
        (0, _validateJs.validateVegaLite)(vegaLiteSpec, currLogger);
        const compileResult = spec !== '{}' ? _vegaLite.compile(vegaLiteSpec, options) : {
            spec: {},
            normalized: {}
        };
        const vegaSpec = compileResult.spec;
        const normalizedVegaLiteSpec = compileResult.normalized;
        extend = {
            ...extend,
            vegaLiteSpec,
            normalizedVegaLiteSpec,
            vegaSpec
        };
    } catch (e) {
        console.warn(e);
        extend = {
            ...extend,
            error: {
                message: e.message
            }
        };
    }
    return {
        ...state,
        editorString: spec,
        error: null,
        gist: null,
        mode: (0, _indexJs.Mode).VegaLite,
        selectedExample: null,
        errors: [],
        warns: currLogger.warns,
        infos: currLogger.infos,
        debugs: currLogger.debugs,
        // extend with other changes
        ...extend
    };
}
function parseConfig(state, action, extend = {}) {
    let config;
    try {
        config = parseJSONCOrThrow(action.configEditorString);
    } catch (e) {
        console.warn(e);
        extend = {
            ...extend,
            error: {
                message: e.message
            }
        };
    }
    return {
        ...state,
        config,
        error: null,
        errors: [],
        warns: [],
        debugs: [],
        infos: [],
        // extend with other changes
        ...extend
    };
}
exports.default = (state = (0, _indexJs.DEFAULT_STATE), action)=>{
    // Copy all changes to state from dataflow reducer to state
    state = {
        ...state,
        ...(0, _indexJs1.dataflowReducer)(state, action)
    };
    switch(action.type){
        case 0, _editorJs.SET_MODE:
            return {
                ...state,
                baseURL: null,
                compiledVegaSpec: false,
                editorString: '{}',
                export: false,
                gist: null,
                mode: action.mode,
                parse: false,
                selectedExample: null,
                vegaLiteSpec: null,
                vegaSpec: {},
                view: null,
                error: null,
                errors: [],
                warns: [],
                infos: [],
                debugs: [],
                expressionInterpreter: false
            };
        case 0, _editorJs.SET_MODE_ONLY:
            return {
                ...state,
                mode: action.mode
            };
        case 0, _editorJs.SET_SCROLL_POSITION:
            return {
                ...state,
                lastPosition: action.position
            };
        case 0, _editorJs.PARSE_SPEC:
            return {
                ...state,
                parse: action.parse
            };
        case 0, _editorJs.SET_VEGA_EXAMPLE:
            return parseVega(state, action, {
                selectedExample: action.example
            });
        case 0, _editorJs.UPDATE_VEGA_SPEC:
            if (action.config !== undefined) {
                const newState = parseConfig(state, (0, _editorJs.setConfig)(action.config));
                return parseVega(newState, action);
            } else return parseVega(state, action);
        case 0, _editorJs.SET_GIST_VEGA_SPEC:
            return parseVega(state, action, {
                gist: action.gist
            });
        case 0, _editorJs.SET_VEGA_LITE_EXAMPLE:
            return parseVegaLite(state, action, {
                selectedExample: action.example
            });
        case 0, _editorJs.UPDATE_VEGA_LITE_SPEC:
            if (action.config !== undefined) return parseVegaLite(state, action, {
                configEditorString: action.config
            });
            else return parseVegaLite(state, action);
        case 0, _editorJs.SET_GIST_VEGA_LITE_SPEC:
            return parseVegaLite(state, action, {
                gist: action.gist
            });
        case 0, _editorJs.TOGGLE_AUTO_PARSE:
            return {
                ...state,
                manualParse: !state.manualParse,
                parse: state.manualParse
            };
        case 0, _editorJs.TOGGLE_COMPILED_VEGA_SPEC:
            return {
                ...state,
                compiledVegaSpec: !state.compiledVegaSpec
            };
        case 0, _editorJs.TOGGLE_DEBUG_PANE:
            return {
                ...state,
                debugPane: !state.debugPane
            };
        case 0, _editorJs.LOG_ERROR:
            return {
                ...state,
                error: action.error
            };
        case 0, _editorJs.UPDATE_EDITOR_STRING:
            return {
                ...state,
                editorString: action.editorString
            };
        case 0, _editorJs.EXPORT_VEGA:
            return {
                ...state,
                export: action.export
            };
        case 0, _editorJs.SET_RENDERER:
            return {
                ...state,
                renderer: action.renderer
            };
        case 0, _editorJs.SET_BASEURL:
            return {
                ...state,
                baseURL: action.baseURL
            };
        case 0, _editorJs.SET_VIEW:
            return {
                ...state,
                view: action.view
            };
        case 0, _editorJs.SET_DEBUG_PANE_SIZE:
            return {
                ...state,
                debugPaneSize: action.debugPaneSize
            };
        case 0, _editorJs.SHOW_LOGS:
            return {
                ...state,
                logs: action.logs
            };
        case 0, _editorJs.SET_COMPILED_VEGA_PANE_SIZE:
            return {
                ...state,
                compiledVegaPaneSize: action.compiledVegaPaneSize
            };
        case 0, _editorJs.TOGGLE_NAV_BAR:
            return {
                ...state,
                navItem: action.navItem
            };
        case 0, _editorJs1.SET_SETTINGS:
            return {
                ...state,
                settings: action.settings
            };
        case 0, _editorJs.SET_CONFIG:
            return state.mode === (0, _indexJs.Mode).VegaLite ? parseVegaLite(state, action, {
                configEditorString: action.configEditorString
            }) : parseConfig(state, action);
        case 0, _editorJs1.SET_THEME_NAME:
            return {
                ...state,
                themeName: action.themeName
            };
        case 0, _editorJs1.SET_SIDEPANE_ITEM:
            return {
                ...state,
                sidePaneItem: action.sidePaneItem
            };
        case 0, _editorJs.SET_COMPILEDPANE_ITEM:
            return {
                ...state,
                compiledPaneItem: action.compiledPaneItem
            };
        case 0, _editorJs.SET_CONFIG_EDITOR_STRING:
            return {
                ...state,
                configEditorString: action.configEditorString
            };
        case 0, _editorJs.SET_EDITOR_REFERENCE:
            return {
                ...state,
                editorRef: action.editorRef
            };
        case 0, _editorJs1.SET_LOG_LEVEL:
            return {
                ...state,
                logLevel: action.logLevel
            };
        case 0, _editorJs1.SET_HOVER:
            return {
                ...state,
                hoverEnable: action.hoverEnable
            };
        case 0, _editorJs1.SET_TOOLTIP:
            return {
                ...state,
                tooltipEnable: action.tooltipEnable
            };
        case 0, _editorJs.CLEAR_CONFIG:
            return {
                ...state,
                config: {},
                configEditorString: '{}',
                themeName: 'custom'
            };
        case 0, _editorJs1.MERGE_CONFIG_SPEC:
            return mergeConfigIntoSpec(state);
        case 0, _editorJs.EXTRACT_CONFIG_SPEC:
            return extractConfig(state);
        case 0, _editorJs.SET_SIGNALS:
            return {
                ...state,
                signals: action.signals
            };
        case 0, _editorJs.SET_DECORATION:
            return {
                ...state,
                decorations: action.decoration
            };
        case 0, _editorJs.SET_COMPILED_EDITOR_REFERENCE:
            return {
                ...state,
                compiledEditorRef: action.editorRef
            };
        case 0, _editorJs.SET_EDITOR_FOCUS:
            return {
                ...state,
                editorFocus: action.editorFocus
            };
        case 0, _editorJs.SET_EXPRESSION_INTERPRETER:
            return {
                ...state,
                expressionInterpreter: action.expressionInterpreter
            };
        case 0, _editorJs.RECEIVE_CURRENT_USER:
            return {
                ...state,
                handle: action.handle,
                isAuthenticated: action.isAuthenticated,
                name: action.name,
                profilePicUrl: action.profilePicUrl
            };
        case 0, _editorJs.TOGGLE_GIST_PRIVACY:
            return {
                ...state,
                private: state.private === (0, _indexJs.GistPrivacy).PUBLIC ? (0, _indexJs.GistPrivacy).ALL : (0, _indexJs.GistPrivacy).PUBLIC
            };
        case 0, _editorJs.SET_BACKGROUND_COLOR:
            return {
                ...state,
                backgroundColor: action.color
            };
        case 0, _editorJs.ERROR:
            return {
                ...state,
                errors: [
                    ...state.errors,
                    action.error
                ]
            };
        case 0, _editorJs.WARN:
            return {
                ...state,
                warns: [
                    ...state.warns,
                    action.warn
                ]
            };
        case 0, _editorJs.INFO:
            return {
                ...state,
                infos: [
                    ...state.infos,
                    action.info
                ]
            };
        case 0, _editorJs.DEBUG:
            return {
                ...state,
                debugs: [
                    ...state.debugs,
                    action.debug
                ]
            };
        default:
            return state;
    }
};

},{"json-stringify-pretty-compact":"jn76Q","semver":"io5W2","vega":"jxCvh","vega-lite":"eTD5L","vega-schema-url-parser":"k72H2","../actions/editor.js":"wC9No","../constants/index.js":"4z2sr","../features/dataflow/index.js":"lyRHo","../utils/validate.js":"36F7x","./../actions/editor.js":"wC9No","./../utils/logger.js":"2yOzg","jsonc-parser":"81Jm5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"io5W2":[function(require,module,exports,__globalThis) {
// just pre-load all the stuff that index.js lazily exports
const internalRe = require("2ef367e729437dbf");
const constants = require("15796d6f714ec7ac");
const SemVer = require("784948b06600d9b2");
const identifiers = require("70f963db887a798c");
const parse = require("3f445ade66470b21");
const valid = require("f44378b7de87a0b4");
const clean = require("7742c78cf22bae39");
const inc = require("a751dd1df28d6bbb");
const diff = require("e000803318fe9f2f");
const major = require("d290038a9a954b0a");
const minor = require("c5e4bbab325a5aae");
const patch = require("5c0bb8d32de60bb3");
const prerelease = require("323f12e5af5ebd1e");
const compare = require("29cf114a56181e64");
const rcompare = require("827db0815bb2f2cd");
const compareLoose = require("b644f26560ec8124");
const compareBuild = require("606d0e43dd66a24c");
const sort = require("1560ed361cfa42e6");
const rsort = require("f9e1f00918a8cfd7");
const gt = require("3694a9720f15d6ac");
const lt = require("4559dbda8a777185");
const eq = require("14a4b88a0b1fd3a5");
const neq = require("416d9b63c3df2ead");
const gte = require("d39630b19344a843");
const lte = require("3fb74c9a41c1cef6");
const cmp = require("3435ca1bbec7b99");
const coerce = require("d67409238c8fc031");
const Comparator = require("1d07035d00450bca");
const Range = require("b280ab3e26924ac1");
const satisfies = require("ba9d0d2a3e49b569");
const toComparators = require("e6b2802b2233287d");
const maxSatisfying = require("2bfdfb0adcbcb71b");
const minSatisfying = require("264df1ba0d261fad");
const minVersion = require("cd4980125683761f");
const validRange = require("a0319a4a98954087");
const outside = require("fc457e2bda4345b2");
const gtr = require("c885d2b556186a1a");
const ltr = require("58740c779f187b15");
const intersects = require("22421cf146448c92");
const simplifyRange = require("439ddbc649d6486");
const subset = require("f1e57a2c808f532d");
module.exports = {
    parse,
    valid,
    clean,
    inc,
    diff,
    major,
    minor,
    patch,
    prerelease,
    compare,
    rcompare,
    compareLoose,
    compareBuild,
    sort,
    rsort,
    gt,
    lt,
    eq,
    neq,
    gte,
    lte,
    cmp,
    coerce,
    Comparator,
    Range,
    satisfies,
    toComparators,
    maxSatisfying,
    minSatisfying,
    minVersion,
    validRange,
    outside,
    gtr,
    ltr,
    intersects,
    simplifyRange,
    subset,
    SemVer,
    re: internalRe.re,
    src: internalRe.src,
    tokens: internalRe.t,
    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: constants.RELEASE_TYPES,
    compareIdentifiers: identifiers.compareIdentifiers,
    rcompareIdentifiers: identifiers.rcompareIdentifiers
};

},{"2ef367e729437dbf":"drtTl","15796d6f714ec7ac":"fPXjy","784948b06600d9b2":"hxWhj","70f963db887a798c":"574NW","3f445ade66470b21":"4R2kt","f44378b7de87a0b4":"hxr49","7742c78cf22bae39":"5tNU7","a751dd1df28d6bbb":"gOWYu","e000803318fe9f2f":"jKgVr","d290038a9a954b0a":"9lXOV","c5e4bbab325a5aae":"h99SA","5c0bb8d32de60bb3":"8AMb9","323f12e5af5ebd1e":"k4M3c","29cf114a56181e64":"4ah3o","827db0815bb2f2cd":"9blnR","b644f26560ec8124":"f93lx","606d0e43dd66a24c":"kx0jL","1560ed361cfa42e6":"5vPtx","f9e1f00918a8cfd7":"KfqUu","3694a9720f15d6ac":"dqfCo","4559dbda8a777185":"bW91P","14a4b88a0b1fd3a5":"aFEHs","416d9b63c3df2ead":"3wtIC","d39630b19344a843":"lNMSW","3fb74c9a41c1cef6":"lqsb5","3435ca1bbec7b99":"tuIUS","d67409238c8fc031":"2zrYe","1d07035d00450bca":"juSmo","b280ab3e26924ac1":"cXyJs","ba9d0d2a3e49b569":"AWxhu","e6b2802b2233287d":"cGURE","2bfdfb0adcbcb71b":"dYroB","264df1ba0d261fad":"6kZHl","cd4980125683761f":"kDUFK","a0319a4a98954087":"dNpUE","fc457e2bda4345b2":"hZUIE","c885d2b556186a1a":"cdREY","58740c779f187b15":"4vxnA","22421cf146448c92":"6ju83","439ddbc649d6486":"4B6dp","f1e57a2c808f532d":"vy1gv"}],"drtTl":[function(require,module,exports,__globalThis) {
const { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = require("9328c2484f003df4");
const debug = require("9075cfb365332427");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    debug(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

},{"9328c2484f003df4":"fPXjy","9075cfb365332427":"8ev33"}],"fPXjy":[function(require,module,exports,__globalThis) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const SEMVER_SPEC_VERSION = '2.0.0';
const MAX_LENGTH = 256;
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
const RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER,
    RELEASE_TYPES,
    SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

},{}],"8ev33":[function(require,module,exports,__globalThis) {
const debug = ()=>{};
module.exports = debug;

},{}],"hxWhj":[function(require,module,exports,__globalThis) {
const debug = require("595c172e7d863d06");
const { MAX_LENGTH, MAX_SAFE_INTEGER } = require("bd8d57fbca62978a");
const { safeRe: re, safeSrc: src, t } = require("2b364a26e67d9817");
const parseOptions = require("f1a723539d6cc9b5");
const { compareIdentifiers } = require("2451a15946a38fcd");
class SemVer {
    constructor(version, options){
        options = parseOptions(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > MAX_LENGTH) throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
        debug('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        debug('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            debug('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const r = new RegExp(`^${this.options.loose ? src[t.PRERELEASELOOSE] : src[t.PRERELEASE]}$`);
                const match = `-${identifier}`.match(r);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = SemVer;

},{"595c172e7d863d06":"8ev33","bd8d57fbca62978a":"fPXjy","2b364a26e67d9817":"drtTl","f1a723539d6cc9b5":"1kguJ","2451a15946a38fcd":"574NW"}],"1kguJ":[function(require,module,exports,__globalThis) {
// parse out just the options we care about
const looseOption = Object.freeze({
    loose: true
});
const emptyOpts = Object.freeze({});
const parseOptions = (options)=>{
    if (!options) return emptyOpts;
    if (typeof options !== 'object') return looseOption;
    return options;
};
module.exports = parseOptions;

},{}],"574NW":[function(require,module,exports,__globalThis) {
const numeric = /^[0-9]+$/;
const compareIdentifiers = (a, b)=>{
    const anum = numeric.test(a);
    const bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const rcompareIdentifiers = (a, b)=>compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers,
    rcompareIdentifiers
};

},{}],"4R2kt":[function(require,module,exports,__globalThis) {
const SemVer = require("575e97778d3944c0");
const parse = (version, options, throwErrors = false)=>{
    if (version instanceof SemVer) return version;
    try {
        return new SemVer(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = parse;

},{"575e97778d3944c0":"hxWhj"}],"hxr49":[function(require,module,exports,__globalThis) {
const parse = require("6a6e19c11f3ced24");
const valid = (version, options)=>{
    const v = parse(version, options);
    return v ? v.version : null;
};
module.exports = valid;

},{"6a6e19c11f3ced24":"4R2kt"}],"5tNU7":[function(require,module,exports,__globalThis) {
const parse = require("661ff2c6ff41830b");
const clean = (version, options)=>{
    const s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = clean;

},{"661ff2c6ff41830b":"4R2kt"}],"gOWYu":[function(require,module,exports,__globalThis) {
const SemVer = require("9a4ed023da196604");
const inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new SemVer(version instanceof SemVer ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = inc;

},{"9a4ed023da196604":"hxWhj"}],"jKgVr":[function(require,module,exports,__globalThis) {
const parse = require("3b6d0e3ec696b30a");
const diff = (version1, version2)=>{
    const v1 = parse(version1, null, true);
    const v2 = parse(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
module.exports = diff;

},{"3b6d0e3ec696b30a":"4R2kt"}],"9lXOV":[function(require,module,exports,__globalThis) {
const SemVer = require("53a097ab5c27a647");
const major = (a, loose)=>new SemVer(a, loose).major;
module.exports = major;

},{"53a097ab5c27a647":"hxWhj"}],"h99SA":[function(require,module,exports,__globalThis) {
const SemVer = require("f130a90acb01ac10");
const minor = (a, loose)=>new SemVer(a, loose).minor;
module.exports = minor;

},{"f130a90acb01ac10":"hxWhj"}],"8AMb9":[function(require,module,exports,__globalThis) {
const SemVer = require("54b9ac3bbdf83b31");
const patch = (a, loose)=>new SemVer(a, loose).patch;
module.exports = patch;

},{"54b9ac3bbdf83b31":"hxWhj"}],"k4M3c":[function(require,module,exports,__globalThis) {
const parse = require("ff5ab55da1933db3");
const prerelease = (version, options)=>{
    const parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = prerelease;

},{"ff5ab55da1933db3":"4R2kt"}],"4ah3o":[function(require,module,exports,__globalThis) {
const SemVer = require("f16c9f4397244ee0");
const compare = (a, b, loose)=>new SemVer(a, loose).compare(new SemVer(b, loose));
module.exports = compare;

},{"f16c9f4397244ee0":"hxWhj"}],"9blnR":[function(require,module,exports,__globalThis) {
const compare = require("4bfcc14a9711a47b");
const rcompare = (a, b, loose)=>compare(b, a, loose);
module.exports = rcompare;

},{"4bfcc14a9711a47b":"4ah3o"}],"f93lx":[function(require,module,exports,__globalThis) {
const compare = require("95c8404dc369c13b");
const compareLoose = (a, b)=>compare(a, b, true);
module.exports = compareLoose;

},{"95c8404dc369c13b":"4ah3o"}],"kx0jL":[function(require,module,exports,__globalThis) {
const SemVer = require("3659675d95d38f3");
const compareBuild = (a, b, loose)=>{
    const versionA = new SemVer(a, loose);
    const versionB = new SemVer(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = compareBuild;

},{"3659675d95d38f3":"hxWhj"}],"5vPtx":[function(require,module,exports,__globalThis) {
const compareBuild = require("7c22e552e691e157");
const sort = (list, loose)=>list.sort((a, b)=>compareBuild(a, b, loose));
module.exports = sort;

},{"7c22e552e691e157":"kx0jL"}],"KfqUu":[function(require,module,exports,__globalThis) {
const compareBuild = require("468f4992c854a69a");
const rsort = (list, loose)=>list.sort((a, b)=>compareBuild(b, a, loose));
module.exports = rsort;

},{"468f4992c854a69a":"kx0jL"}],"dqfCo":[function(require,module,exports,__globalThis) {
const compare = require("85515ef2889f4f89");
const gt = (a, b, loose)=>compare(a, b, loose) > 0;
module.exports = gt;

},{"85515ef2889f4f89":"4ah3o"}],"bW91P":[function(require,module,exports,__globalThis) {
const compare = require("9d2d7734c37f90e6");
const lt = (a, b, loose)=>compare(a, b, loose) < 0;
module.exports = lt;

},{"9d2d7734c37f90e6":"4ah3o"}],"aFEHs":[function(require,module,exports,__globalThis) {
const compare = require("d6abf8ed12ec38c1");
const eq = (a, b, loose)=>compare(a, b, loose) === 0;
module.exports = eq;

},{"d6abf8ed12ec38c1":"4ah3o"}],"3wtIC":[function(require,module,exports,__globalThis) {
const compare = require("5232df27c4c4faa9");
const neq = (a, b, loose)=>compare(a, b, loose) !== 0;
module.exports = neq;

},{"5232df27c4c4faa9":"4ah3o"}],"lNMSW":[function(require,module,exports,__globalThis) {
const compare = require("9183f7fbecba58ae");
const gte = (a, b, loose)=>compare(a, b, loose) >= 0;
module.exports = gte;

},{"9183f7fbecba58ae":"4ah3o"}],"lqsb5":[function(require,module,exports,__globalThis) {
const compare = require("e55eadc974580af5");
const lte = (a, b, loose)=>compare(a, b, loose) <= 0;
module.exports = lte;

},{"e55eadc974580af5":"4ah3o"}],"tuIUS":[function(require,module,exports,__globalThis) {
const eq = require("bff7f16298b8dbaa");
const neq = require("6a1bb69c2d499261");
const gt = require("dca4b9c05150a919");
const gte = require("7b5dc70556970d6c");
const lt = require("a3a3bcc6e4d6bbdf");
const lte = require("5f1835ee4d0596f3");
const cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = cmp;

},{"bff7f16298b8dbaa":"aFEHs","6a1bb69c2d499261":"3wtIC","dca4b9c05150a919":"dqfCo","7b5dc70556970d6c":"lNMSW","a3a3bcc6e4d6bbdf":"bW91P","5f1835ee4d0596f3":"lqsb5"}],"2zrYe":[function(require,module,exports,__globalThis) {
const SemVer = require("25529d97ade3ccdf");
const parse = require("90724e3140f56906");
const { safeRe: re, t } = require("49971e907f1359e9");
const coerce = (version, options)=>{
    if (version instanceof SemVer) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? re[t.COERCEFULL] : re[t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? re[t.COERCERTLFULL] : re[t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return parse(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
module.exports = coerce;

},{"25529d97ade3ccdf":"hxWhj","90724e3140f56906":"4R2kt","49971e907f1359e9":"drtTl"}],"juSmo":[function(require,module,exports,__globalThis) {
const ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class Comparator {
    static get ANY() {
        return ANY;
    }
    constructor(comp, options){
        options = parseOptions(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        debug('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        debug('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = ANY;
        else this.semver = new SemVer(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        debug('Comparator.test', version, this.options.loose);
        if (this.semver === ANY || version === ANY) return true;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        return cmp(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new Range(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new Range(this.value, options).test(comp.semver);
        }
        options = parseOptions(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if (cmp(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if (cmp(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = Comparator;
const parseOptions = require("b6563e9809bd921f");
const { safeRe: re, t } = require("f844ee6695e23038");
const cmp = require("e62b495d112b67cb");
const debug = require("13b490d953a8241f");
const SemVer = require("f688b7fbae163ad8");
const Range = require("b8839ba12a91a5c9");

},{"b6563e9809bd921f":"1kguJ","f844ee6695e23038":"drtTl","e62b495d112b67cb":"tuIUS","13b490d953a8241f":"8ev33","f688b7fbae163ad8":"hxWhj","b8839ba12a91a5c9":"cXyJs"}],"cXyJs":[function(require,module,exports,__globalThis) {
const SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class Range {
    constructor(range, options){
        options = parseOptions(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof Comparator) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace(SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
        range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
        debug('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
        debug('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
        debug('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace(re[t.CARETTRIM], caretTrimReplace);
        debug('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            debug('loose invalid filter', comp, this.options);
            return !!comp.match(re[t.COMPARATORLOOSE]);
        });
        debug('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new Comparator(comp, this.options));
        for (const comp of comparators){
            if (isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if (testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = Range;
const LRU = require("96f33215aad25ada");
const cache = new LRU();
const parseOptions = require("17bb122b9b0740d9");
const Comparator = require("df9131adcc191f91");
const debug = require("1c7c6c8abfe9bd3b");
const SemVer = require("d77fd978650b507f");
const { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = require("9bd5ca5276add1c4");
const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require("8c8074dc7fc46964");
const isNullSet = (c)=>c.value === '<0.0.0-0';
const isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const parseComparator = (comp, options)=>{
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
};
const isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceTilde(c, options)).join(' ');
};
const replaceTilde = (comp, options)=>{
    const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('tilde', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        debug('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceCaret(c, options)).join(' ');
};
const replaceCaret = (comp, options)=>{
    debug('caret', comp, options);
    const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('caret', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if (isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        debug('caret return', ret);
        return ret;
    });
};
const replaceXRanges = (comp, options)=>{
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>replaceXRange(c, options)).join(' ');
};
const replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = isX(M);
        const xm = xM || isX(m);
        const xp = xm || isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        debug('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const replaceStars = (comp, options)=>{
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(re[t.STAR], '');
};
const replaceGTE0 = (comp, options)=>{
    debug('replaceGTE0', comp, options);
    return comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if (isX(fM)) from = '';
        else if (isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if (isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if (isX(tM)) to = '';
        else if (isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if (isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === Comparator.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

},{"96f33215aad25ada":"fHgxO","17bb122b9b0740d9":"1kguJ","df9131adcc191f91":"juSmo","1c7c6c8abfe9bd3b":"8ev33","d77fd978650b507f":"hxWhj","9bd5ca5276add1c4":"drtTl","8c8074dc7fc46964":"fPXjy"}],"fHgxO":[function(require,module,exports,__globalThis) {
class LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
module.exports = LRUCache;

},{}],"AWxhu":[function(require,module,exports,__globalThis) {
const Range = require("b60a47303a13d107");
const satisfies = (version, range, options)=>{
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = satisfies;

},{"b60a47303a13d107":"cXyJs"}],"cGURE":[function(require,module,exports,__globalThis) {
const Range = require("f497be9904aac7c0");
// Mostly just for testing and legacy API reasons
const toComparators = (range, options)=>new Range(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = toComparators;

},{"f497be9904aac7c0":"cXyJs"}],"dYroB":[function(require,module,exports,__globalThis) {
const SemVer = require("96d622a81d57358d");
const Range = require("f2865e94142488ab");
const maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
};
module.exports = maxSatisfying;

},{"96d622a81d57358d":"hxWhj","f2865e94142488ab":"cXyJs"}],"6kZHl":[function(require,module,exports,__globalThis) {
const SemVer = require("fea3851ba09d8834");
const Range = require("9d2799b098b5c4c7");
const minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
};
module.exports = minSatisfying;

},{"fea3851ba09d8834":"hxWhj","9d2799b098b5c4c7":"cXyJs"}],"kDUFK":[function(require,module,exports,__globalThis) {
const SemVer = require("4c531b1d555da497");
const Range = require("76327127dc36ed58");
const gt = require("a5ac47b45ae8684c");
const minVersion = (range, loose)=>{
    range = new Range(range, loose);
    let minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || gt(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || gt(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = minVersion;

},{"4c531b1d555da497":"hxWhj","76327127dc36ed58":"cXyJs","a5ac47b45ae8684c":"dqfCo"}],"dNpUE":[function(require,module,exports,__globalThis) {
const Range = require("fd2c35053245b1fd");
const validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = validRange;

},{"fd2c35053245b1fd":"cXyJs"}],"hZUIE":[function(require,module,exports,__globalThis) {
const SemVer = require("65977c6c7fab41e0");
const Comparator = require("8b0890ac7a0294ed");
const { ANY } = Comparator;
const Range = require("9baad77301d611e2");
const satisfies = require("1a3d276234841886");
const gt = require("8f784c6ef2cd1972");
const lt = require("3c234e2ddd9db68a");
const lte = require("88893a74cd9f934");
const gte = require("6cccfcce37ef6329");
const outside = (version, range, hilo, options)=>{
    version = new SemVer(version, options);
    range = new Range(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = outside;

},{"65977c6c7fab41e0":"hxWhj","8b0890ac7a0294ed":"juSmo","9baad77301d611e2":"cXyJs","1a3d276234841886":"AWxhu","8f784c6ef2cd1972":"dqfCo","3c234e2ddd9db68a":"bW91P","88893a74cd9f934":"lqsb5","6cccfcce37ef6329":"lNMSW"}],"cdREY":[function(require,module,exports,__globalThis) {
// Determine if version is greater than all the versions possible in the range.
const outside = require("be5e984e16e512b9");
const gtr = (version, range, options)=>outside(version, range, '>', options);
module.exports = gtr;

},{"be5e984e16e512b9":"hZUIE"}],"4vxnA":[function(require,module,exports,__globalThis) {
const outside = require("b7f00e21a32b75a5");
// Determine if version is less than all the versions possible in the range
const ltr = (version, range, options)=>outside(version, range, '<', options);
module.exports = ltr;

},{"b7f00e21a32b75a5":"hZUIE"}],"6ju83":[function(require,module,exports,__globalThis) {
const Range = require("5205f80872e81710");
const intersects = (r1, r2, options)=>{
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2, options);
};
module.exports = intersects;

},{"5205f80872e81710":"cXyJs"}],"4B6dp":[function(require,module,exports,__globalThis) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.
const satisfies = require("e72123f17434788");
const compare = require("3eb9817061c82995");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>compare(a, b, options));
    for (const version of v){
        const included = satisfies(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

},{"e72123f17434788":"AWxhu","3eb9817061c82995":"4ah3o"}],"vy1gv":[function(require,module,exports,__globalThis) {
const Range = require("c141b0432e6ae71b");
const Comparator = require("94bed966a1054073");
const { ANY } = Comparator;
const satisfies = require("acfaf6445a9794b");
const compare = require("d9ed82a69c119cf4");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new Range(sub, options);
    dom = new Range(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const minimumVersionWithPreRelease = [
    new Comparator('>=0.0.0-0')
];
const minimumVersion = [
    new Comparator('>=0.0.0')
];
const simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === ANY) {
        if (dom.length === 1 && dom[0].semver === ANY) return true;
        else if (options.includePrerelease) sub = minimumVersionWithPreRelease;
        else sub = minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === ANY) {
        if (options.includePrerelease) return true;
        else dom = minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = compare(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !satisfies(eq, String(gt), options)) return null;
        if (lt && !satisfies(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!satisfies(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !satisfies(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !satisfies(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = subset;

},{"c141b0432e6ae71b":"cXyJs","94bed966a1054073":"juSmo","acfaf6445a9794b":"AWxhu","d9ed82a69c119cf4":"4ah3o"}],"36F7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateVegaLite", ()=>validateVegaLite);
parcelHelpers.export(exports, "validateVega", ()=>validateVega);
var _ajv = require("ajv");
var _ajvDefault = parcelHelpers.interopDefault(_ajv);
var _ajvFormats = require("ajv-formats");
var _ajvFormatsDefault = parcelHelpers.interopDefault(_ajvFormats);
var _vegaLiteSchemaJson = require("vega-lite/vega-lite-schema.json");
var _vegaLiteSchemaJsonDefault = parcelHelpers.interopDefault(_vegaLiteSchemaJson);
var _vegaSchemaJson = require("vega/vega-schema.json");
var _vegaSchemaJsonDefault = parcelHelpers.interopDefault(_vegaSchemaJson);
var _jsonSchemaDraft06Json = require("ajv/lib/refs/json-schema-draft-06.json");
var _jsonSchemaDraft06JsonDefault = parcelHelpers.interopDefault(_jsonSchemaDraft06Json);
const ajv = new (0, _ajvDefault.default)({
    strict: false
});
(0, _ajvFormatsDefault.default)(ajv);
ajv.addMetaSchema((0, _jsonSchemaDraft06JsonDefault.default));
ajv.addFormat('color-hex', ()=>true);
const vegaValidator = ajv.compile((0, _vegaSchemaJsonDefault.default));
const vegaLiteValidator = ajv.compile((0, _vegaLiteSchemaJsonDefault.default));
function validateVegaLite(spec, logger) {
    const valid = vegaLiteValidator(spec);
    if (!valid) for (const error of vegaLiteValidator.errors)logger.warn(`Validation: ${error.instancePath ?? '/'} ${error.message} of ${error.schemaPath}`);
}
function validateVega(spec, logger) {
    const valid = vegaValidator(spec);
    if (!valid) for (const error of vegaValidator.errors)logger.warn(`Validation: ${error.instancePath ?? '/'} ${error.message} of ${error.schemaPath}`);
}

},{"ajv":"b8fK1","ajv-formats":"lVPyz","vega-lite/vega-lite-schema.json":"ifxp5","vega/vega-schema.json":"sbR1U","ajv/lib/refs/json-schema-draft-06.json":"8tpkM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8fK1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;
const core_1 = require("f64656127e08982d");
const draft7_1 = require("f1543da9385b944c");
const discriminator_1 = require("be8496814b704dbb");
const draft7MetaSchema = require("38bd7a84a0bf1522");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends core_1.default {
    _addVocabularies() {
        super._addVocabularies();
        draft7_1.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword(discriminator_1.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA) : draft7MetaSchema;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;
var validate_1 = require("e0cfa52b6e683bc7");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return validate_1.KeywordCxt;
    }
});
var codegen_1 = require("3d074431b417a468");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return codegen_1._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return codegen_1.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return codegen_1.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return codegen_1.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return codegen_1.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return codegen_1.CodeGen;
    }
});
var validation_error_1 = require("dc5ef56e4c544902");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return validation_error_1.default;
    }
});
var ref_error_1 = require("1f676e068a0a0b03");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return ref_error_1.default;
    }
});

},{"f64656127e08982d":"2d4So","f1543da9385b944c":"jXYLu","be8496814b704dbb":"heR94","38bd7a84a0bf1522":"3MLBr","e0cfa52b6e683bc7":"bkVpi","3d074431b417a468":"irYIY","dc5ef56e4c544902":"fL5Oz","1f676e068a0a0b03":"4SpuV"}],"2d4So":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
var validate_1 = require("8eae9e8df37feb7a");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return validate_1.KeywordCxt;
    }
});
var codegen_1 = require("ffa9e7efa8fd1e4a");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return codegen_1._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return codegen_1.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return codegen_1.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return codegen_1.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return codegen_1.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return codegen_1.CodeGen;
    }
});
const validation_error_1 = require("eaa88e3aaccf251");
const ref_error_1 = require("f63f87f091d36ef7");
const rules_1 = require("5a4bc288296cc41c");
const compile_1 = require("2ea5240ba3b7911d");
const codegen_2 = require("ffa9e7efa8fd1e4a");
const resolve_1 = require("d28de041b2cba4fb");
const dataType_1 = require("53d10d85530b6b99");
const util_1 = require("66ed8b4de95754e9");
const $dataRefSchema = require("420a5d11860e6768");
const uri_1 = require("fe7cd4bb08eb811");
const defaultRegExp = (str, flags)=>new RegExp(str, flags);
defaultRegExp.code = "new RegExp";
const META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : uri_1.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize,
            regExp
        } : {
            optimize,
            regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...requiredOptions(opts)
        };
        const { es5, lines } = this.opts.code;
        this.scope = new codegen_2.ValueScope({
            scope: {},
            prefixes: EXT_SCOPE_NAMES,
            es5,
            lines
        });
        this.logger = getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, rules_1.getRules)();
        checkOptions.call(this, removedOptions, opts, "NOT SUPPORTED");
        checkOptions.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = getMetaSchemaOptions.call(this);
        if (opts.formats) addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data, meta, schemaId } = this.opts;
        let _dataRefSchema = $dataRefSchema;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$dataRefSchema
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta, schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof ref_error_1.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, resolve_1.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId } = this.opts;
            const root = new compile_1.SchemaEnv({
                schema: {},
                schemaId
            });
            sch = compile_1.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, resolve_1.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, util_1.eachItem)(keyword, (kwd)=>addRule.call(this, kwd));
            return this;
        }
        keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, dataType_1.getJSONTypes)(def.type),
            schemaType: (0, dataType_1.getJSONTypes)(def.schemaType)
        };
        (0, util_1.eachItem)(keyword, definition.type.length === 0 ? (k)=>addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator = ", ", dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, resolve_1.normalizeId)(id || baseId);
        const localRefs = resolve_1.getSchemaRefs.call(this, schema, baseId);
        sch = new compile_1.SchemaEnv({
            schema,
            schemaId,
            meta,
            baseId,
            localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else compile_1.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            compile_1.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
Ajv.ValidationError = validation_error_1.default;
Ajv.MissingRefError = ref_error_1.default;
exports.default = Ajv;
function checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function getSchEnv(keyRef) {
    keyRef = (0, resolve_1.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const noLogs = {
    log () {},
    warn () {},
    error () {}
};
function getLogger(logger) {
    if (logger === false) return noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function checkKeyword(keyword, def) {
    const { RULES } = this;
    (0, util_1.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword,
        definition: {
            ...definition,
            type: (0, dataType_1.getJSONTypes)(definition.type),
            schemaType: (0, dataType_1.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function keywordMetaschema(def) {
    let { metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $dataRef
        ]
    };
}

},{"8eae9e8df37feb7a":"bkVpi","ffa9e7efa8fd1e4a":"irYIY","eaa88e3aaccf251":"fL5Oz","f63f87f091d36ef7":"4SpuV","5a4bc288296cc41c":"8PLj3","2ea5240ba3b7911d":"gmEgM","d28de041b2cba4fb":"143RM","53d10d85530b6b99":"a2cIv","66ed8b4de95754e9":"lNHh9","420a5d11860e6768":"ijT43","fe7cd4bb08eb811":"laWPK"}],"bkVpi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getData = exports.KeywordCxt = exports.validateFunctionCode = void 0;
const boolSchema_1 = require("1872624698c52350");
const dataType_1 = require("30e941be85fe7fe1");
const applicability_1 = require("4efae0989d707fc9");
const dataType_2 = require("30e941be85fe7fe1");
const defaults_1 = require("59b5b06ee813874");
const keyword_1 = require("833ade6d8e5d7ac7");
const subschema_1 = require("721d23bc0d70f9c5");
const codegen_1 = require("dd369f53d36c1331");
const names_1 = require("3b360641a0a45156");
const resolve_1 = require("c00dd44166cd9602");
const util_1 = require("b5aac0cdec5ecfd");
const errors_1 = require("eda806e054ff0f41");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function validateFunctionCode(it) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            topSchemaObjCode(it);
            return;
        }
    }
    validateFunction(it, ()=>(0, boolSchema_1.topBoolOrEmptySchema)(it));
}
exports.validateFunctionCode = validateFunctionCode;
function validateFunction({ gen, validateName, schema, schemaEnv, opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, codegen_1._)`${names_1.default.data}, ${names_1.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, codegen_1._)`"use strict"; ${funcSourceUrl(schema, opts)}`);
        destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, codegen_1._)`${names_1.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code(funcSourceUrl(schema, opts)).code(body));
}
function destructureValCxt(opts) {
    return (0, codegen_1._)`{${names_1.default.instancePath}="", ${names_1.default.parentData}, ${names_1.default.parentDataProperty}, ${names_1.default.rootData}=${names_1.default.data}${opts.dynamicRef ? (0, codegen_1._)`, ${names_1.default.dynamicAnchors}={}` : codegen_1.nil}}={}`;
}
function destructureValCxtES5(gen, opts) {
    gen.if(names_1.default.valCxt, ()=>{
        gen.var(names_1.default.instancePath, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.instancePath}`);
        gen.var(names_1.default.parentData, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.parentData}`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.parentDataProperty}`);
        gen.var(names_1.default.rootData, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.rootData}`);
        if (opts.dynamicRef) gen.var(names_1.default.dynamicAnchors, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.dynamicAnchors}`);
    }, ()=>{
        gen.var(names_1.default.instancePath, (0, codegen_1._)`""`);
        gen.var(names_1.default.parentData, (0, codegen_1._)`undefined`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._)`undefined`);
        gen.var(names_1.default.rootData, names_1.default.data);
        if (opts.dynamicRef) gen.var(names_1.default.dynamicAnchors, (0, codegen_1._)`{}`);
    });
}
function topSchemaObjCode(it) {
    const { schema, opts, gen } = it;
    validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) commentKeyword(it);
        checkNoDefault(it);
        gen.let(names_1.default.vErrors, null);
        gen.let(names_1.default.errors, 0);
        if (opts.unevaluated) resetEvaluated(it);
        typeAndKeywords(it);
        returnResults(it);
    });
    return;
}
function resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen, validateName } = it;
    it.evaluated = gen.const("evaluated", (0, codegen_1._)`${validateName}.evaluated`);
    gen.if((0, codegen_1._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, codegen_1._)`${it.evaluated}.props`, (0, codegen_1._)`undefined`));
    gen.if((0, codegen_1._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, codegen_1._)`${it.evaluated}.items`, (0, codegen_1._)`undefined`));
}
function funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, codegen_1._)`/*# sourceURL=${schId} */` : codegen_1.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function subschemaCode(it, valid) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, boolSchema_1.boolOrEmptySchema)(it, valid);
}
function schemaCxtHasRules({ schema, self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function subSchemaObjCode(it, valid) {
    const { schema, gen, opts } = it;
    if (opts.$comment && schema.$comment) commentKeyword(it);
    updateContext(it);
    checkAsyncSchema(it);
    const errsCount = gen.const("_errs", names_1.default.errors);
    typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, codegen_1._)`${errsCount} === ${names_1.default.errors}`);
}
function checkKeywords(it) {
    (0, util_1.checkUnknownRules)(it);
    checkRefsAndKeywords(it);
}
function typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return schemaKeywords(it, [], false, errsCount);
    const types = (0, dataType_1.getSchemaTypes)(it.schema);
    const checkedTypes = (0, dataType_1.coerceAndCheckDataType)(it, types);
    schemaKeywords(it, types, !checkedTypes, errsCount);
}
function checkRefsAndKeywords(it) {
    const { schema, errSchemaPath, opts, self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function checkNoDefault(it) {
    const { schema, opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, util_1.checkStrictMode)(it, "default is ignored in the schema root");
}
function updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, resolve_1.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function commentKeyword({ gen, schemaEnv, schema, errSchemaPath, opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, codegen_1._)`${names_1.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, codegen_1.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, codegen_1._)`${names_1.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function returnResults(it) {
    const { gen, schemaEnv, validateName, ValidationError, opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, codegen_1._)`${names_1.default.errors} === 0`, ()=>gen.return(names_1.default.data), ()=>gen.throw((0, codegen_1._)`new ${ValidationError}(${names_1.default.vErrors})`));
    else {
        gen.assign((0, codegen_1._)`${validateName}.errors`, names_1.default.vErrors);
        if (opts.unevaluated) assignEvaluated(it);
        gen.return((0, codegen_1._)`${names_1.default.errors} === 0`);
    }
}
function assignEvaluated({ gen, evaluated, props, items }) {
    if (props instanceof codegen_1.Name) gen.assign((0, codegen_1._)`${evaluated}.props`, props);
    if (items instanceof codegen_1.Name) gen.assign((0, codegen_1._)`${evaluated}.items`, items);
}
function schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen, schema, data, allErrors, opts, self } = it;
    const { RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, applicability_1.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
            iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, dataType_2.reportTypeError)(it);
            }
            gen.endIf();
        } else iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, codegen_1._)`${names_1.default.errors} === ${errsCount || 0}`);
    }
}
function iterateKeywords(it, group) {
    const { gen, schema, opts: { useDefaults } } = it;
    if (useDefaults) (0, defaults_1.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, applicability_1.shouldUseRule)(schema, rule)) keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) checkMultipleTypes(it, types);
    checkKeywordTypes(it, it.dataTypes);
}
function checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!includesType(it.dataTypes, t)) strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    narrowSchemaTypes(it, types);
}
function checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it.schema, rule)) {
            const { type } = rule.definition;
            if (type.length && !type.some((t)=>hasApplicableType(ts, t))) strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if (includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, util_1.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class KeywordCxt {
    constructor(it, def, keyword){
        (0, keyword_1.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, util_1.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, keyword_1.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", names_1.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, codegen_1.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, codegen_1.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode } = this;
        this.fail((0, codegen_1._)`${schemaCode} !== undefined && (${(0, codegen_1.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = codegen_1.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = codegen_1.nil, $dataValid = codegen_1.nil) {
        if (!this.$data) return;
        const { gen, schemaCode, schemaType, def } = this;
        gen.if((0, codegen_1.or)((0, codegen_1._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== codegen_1.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== codegen_1.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen, schemaCode, schemaType, def, it } = this;
        return (0, codegen_1.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof codegen_1.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, codegen_1._)`${(0, dataType_2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
            }
            return codegen_1.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, codegen_1._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return codegen_1.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, subschema_1.getSubschema)(this.it, appl);
        (0, subschema_1.extendSubschemaData)(subschema, this.it, appl);
        (0, subschema_1.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it, gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = util_1.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = util_1.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it, gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, codegen_1.Name));
            return true;
        }
    }
}
exports.KeywordCxt = KeywordCxt;
function keywordCode(it, keyword, def, ruleType) {
    const cxt = new KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, keyword_1.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, keyword_1.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, keyword_1.funcKeywordCode)(cxt, def);
}
const JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, { dataLevel, dataNames, dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return names_1.default.rootData;
    if ($data[0] === "/") {
        if (!JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = names_1.default.rootData;
    } else {
        const matches = RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)((0, util_1.unescapeJsonPointer)(segment))}`;
        expr = (0, codegen_1._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
exports.getData = getData;

},{"1872624698c52350":"lWR2v","30e941be85fe7fe1":"a2cIv","4efae0989d707fc9":"kThul","59b5b06ee813874":"1v9yn","833ade6d8e5d7ac7":"b4zHR","721d23bc0d70f9c5":"jvnAj","dd369f53d36c1331":"irYIY","3b360641a0a45156":"80kJL","c00dd44166cd9602":"143RM","b5aac0cdec5ecfd":"lNHh9","eda806e054ff0f41":"1u6Rd"}],"lWR2v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.boolOrEmptySchema = exports.topBoolOrEmptySchema = void 0;
const errors_1 = require("7ae78570b5c98751");
const codegen_1 = require("382afaf0f5449a0b");
const names_1 = require("b14bdfeaa9e2911c");
const boolError = {
    message: "boolean schema is false"
};
function topBoolOrEmptySchema(it) {
    const { gen, schema, validateName } = it;
    if (schema === false) falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return(names_1.default.data);
    else {
        gen.assign((0, codegen_1._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
exports.topBoolOrEmptySchema = topBoolOrEmptySchema;
function boolOrEmptySchema(it, valid) {
    const { gen, schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
exports.boolOrEmptySchema = boolOrEmptySchema;
function falseSchemaError(it, overrideAllErrors) {
    const { gen, data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen,
        keyword: "false schema",
        data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it
    };
    (0, errors_1.reportError)(cxt, boolError, undefined, overrideAllErrors);
}

},{"7ae78570b5c98751":"1u6Rd","382afaf0f5449a0b":"irYIY","b14bdfeaa9e2911c":"80kJL"}],"1u6Rd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extendErrors = exports.resetErrorsCount = exports.reportExtraError = exports.reportError = exports.keyword$DataError = exports.keywordError = void 0;
const codegen_1 = require("b0db63a8d522181c");
const util_1 = require("2ba06fec19fee9a0");
const names_1 = require("e68108f0fa66567d");
exports.keywordError = {
    message: ({ keyword })=>(0, codegen_1.str)`must pass "${keyword}" keyword validation`
};
exports.keyword$DataError = {
    message: ({ keyword, schemaType })=>schemaType ? (0, codegen_1.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, codegen_1.str)`"${keyword}" keyword is invalid ($data)`
};
function reportError(cxt, error = exports.keywordError, errorPaths, overrideAllErrors) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) addError(gen, errObj);
    else returnErrors(it, (0, codegen_1._)`[${errObj}]`);
}
exports.reportError = reportError;
function reportExtraError(cxt, error = exports.keywordError, errorPaths) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    addError(gen, errObj);
    if (!(compositeRule || allErrors)) returnErrors(it, names_1.default.vErrors);
}
exports.reportExtraError = reportExtraError;
function resetErrorsCount(gen, errsCount) {
    gen.assign(names_1.default.errors, errsCount);
    gen.if((0, codegen_1._)`${names_1.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, codegen_1._)`${names_1.default.vErrors}.length`, errsCount), ()=>gen.assign(names_1.default.vErrors, null)));
}
exports.resetErrorsCount = resetErrorsCount;
function extendErrors({ gen, keyword, schemaValue, data, errsCount, it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, names_1.default.errors, (i)=>{
        gen.const(err, (0, codegen_1._)`${names_1.default.vErrors}[${i}]`);
        gen.if((0, codegen_1._)`${err}.instancePath === undefined`, ()=>gen.assign((0, codegen_1._)`${err}.instancePath`, (0, codegen_1.strConcat)(names_1.default.instancePath, it.errorPath)));
        gen.assign((0, codegen_1._)`${err}.schemaPath`, (0, codegen_1.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, codegen_1._)`${err}.schema`, schemaValue);
            gen.assign((0, codegen_1._)`${err}.data`, data);
        }
    });
}
exports.extendErrors = extendErrors;
function addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, codegen_1._)`${names_1.default.vErrors} === null`, ()=>gen.assign(names_1.default.vErrors, (0, codegen_1._)`[${err}]`), (0, codegen_1._)`${names_1.default.vErrors}.push(${err})`);
    gen.code((0, codegen_1._)`${names_1.default.errors}++`);
}
function returnErrors(it, errs) {
    const { gen, validateName, schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, codegen_1._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, codegen_1._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const E = {
    keyword: new codegen_1.Name("keyword"),
    schemaPath: new codegen_1.Name("schemaPath"),
    params: new codegen_1.Name("params"),
    propertyName: new codegen_1.Name("propertyName"),
    message: new codegen_1.Name("message"),
    schema: new codegen_1.Name("schema"),
    parentSchema: new codegen_1.Name("parentSchema")
};
function errorObjectCode(cxt, error, errorPaths) {
    const { createErrors } = cxt.it;
    if (createErrors === false) return (0, codegen_1._)`{}`;
    return errorObject(cxt, error, errorPaths);
}
function errorObject(cxt, error, errorPaths = {}) {
    const { gen, it } = cxt;
    const keyValues = [
        errorInstancePath(it, errorPaths),
        errorSchemaPath(cxt, errorPaths)
    ];
    extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function errorInstancePath({ errorPath }, { instancePath }) {
    const instPath = instancePath ? (0, codegen_1.str)`${errorPath}${(0, util_1.getErrorPath)(instancePath, util_1.Type.Str)}` : errorPath;
    return [
        names_1.default.instancePath,
        (0, codegen_1.strConcat)(names_1.default.instancePath, instPath)
    ];
}
function errorSchemaPath({ keyword, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, codegen_1.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, codegen_1.str)`${schPath}${(0, util_1.getErrorPath)(schemaPath, util_1.Type.Str)}`;
    return [
        E.schemaPath,
        schPath
    ];
}
function extraErrorProps(cxt, { params, message }, keyValues) {
    const { keyword, data, schemaValue, it } = cxt;
    const { opts, propertyName, topSchemaRef, schemaPath } = it;
    keyValues.push([
        E.keyword,
        keyword
    ], [
        E.params,
        typeof params == "function" ? params(cxt) : params || (0, codegen_1._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        E.schema,
        schemaValue
    ], [
        E.parentSchema,
        (0, codegen_1._)`${topSchemaRef}${schemaPath}`
    ], [
        names_1.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        E.propertyName,
        propertyName
    ]);
}

},{"b0db63a8d522181c":"irYIY","2ba06fec19fee9a0":"lNHh9","e68108f0fa66567d":"80kJL"}],"irYIY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.or = exports.and = exports.not = exports.CodeGen = exports.operators = exports.varKinds = exports.ValueScopeName = exports.ValueScope = exports.Scope = exports.Name = exports.regexpCode = exports.stringify = exports.getProperty = exports.nil = exports.strConcat = exports.str = exports._ = void 0;
const code_1 = require("3a923f104f0d1cf0");
const scope_1 = require("f2814f3db5f7131a");
var code_2 = require("3a923f104f0d1cf0");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return code_2._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return code_2.str;
    }
});
Object.defineProperty(exports, "strConcat", {
    enumerable: true,
    get: function() {
        return code_2.strConcat;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return code_2.nil;
    }
});
Object.defineProperty(exports, "getProperty", {
    enumerable: true,
    get: function() {
        return code_2.getProperty;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return code_2.stringify;
    }
});
Object.defineProperty(exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return code_2.regexpCode;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return code_2.Name;
    }
});
var scope_2 = require("f2814f3db5f7131a");
Object.defineProperty(exports, "Scope", {
    enumerable: true,
    get: function() {
        return scope_2.Scope;
    }
});
Object.defineProperty(exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return scope_2.ValueScope;
    }
});
Object.defineProperty(exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return scope_2.ValueScopeName;
    }
});
Object.defineProperty(exports, "varKinds", {
    enumerable: true,
    get: function() {
        return scope_2.varKinds;
    }
});
exports.operators = {
    GT: new code_1._Code(">"),
    GTE: new code_1._Code(">="),
    LT: new code_1._Code("<"),
    LTE: new code_1._Code("<="),
    EQ: new code_1._Code("==="),
    NEQ: new code_1._Code("!=="),
    NOT: new code_1._Code("!"),
    OR: new code_1._Code("||"),
    AND: new code_1._Code("&&"),
    ADD: new code_1._Code("+")
};
class Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class Def extends Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5, _n }) {
        const varKind = es5 ? scope_1.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof code_1._CodeOrName ? this.rhs.names : {};
    }
}
class Assign extends Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof code_1.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof code_1.Name ? {} : {
            ...this.lhs.names
        };
        return addExprNames(names, this.rhs);
    }
}
class AssignOp extends Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class Label extends Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        return `${this.label}:` + _n;
    }
}
class Break extends Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class Throw extends Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class AnyCode extends Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof code_1._CodeOrName ? this.code.names : {};
    }
}
class ParentNode extends Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>addNames(names, n.names), {});
    }
}
class BlockNode extends ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class Root extends ParentNode {
}
class Else extends BlockNode {
}
Else.kind = "else";
class If extends BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new If(not(cond), e instanceof If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        addExprNames(names, this.condition);
        if (this.else) addNames(names, this.else.names);
        return names;
    }
}
If.kind = "if";
class For extends BlockNode {
}
For.kind = "for";
class ForLoop extends For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iteration.names);
    }
}
class ForRange extends For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
        const { name, from, to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = addExprNames(super.names, this.from);
        return addExprNames(names, this.to);
    }
}
class ForIter extends For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iterable.names);
    }
}
class Func extends BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
Func.kind = "func";
class Return extends ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
Return.kind = "return";
class Try extends BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) addNames(names, this.catch.names);
        if (this.finally) addNames(names, this.finally.names);
        return names;
    }
}
class Catch extends BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
Catch.kind = "catch";
class Finally extends BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
Finally.kind = "finally";
class CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new scope_1.Scope({
            parent: extScope
        });
        this._nodes = [
            new Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new AssignOp(lhs, exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== code_1.nil) this._leafNode(new AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, code_1.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new code_1._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode(If, Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof code_1.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, code_1._)`${arr}.length`, (i)=>{
                this.var(name, (0, code_1._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, code_1._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode(For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new Break(label));
    }
    // `return` statement
    return(value) {
        const node = new Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode(Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode(Catch, Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = code_1.nil, async, funcBody) {
        this._blockNode(new Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode(Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
exports.CodeGen = CodeGen;
function addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function addExprNames(names, from) {
    return from instanceof code_1._CodeOrName ? addNames(names, from.names) : names;
}
function optimizeExpr(expr, names, constants) {
    if (expr instanceof code_1.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new code_1._Code(expr._items.reduce((items, c)=>{
        if (c instanceof code_1.Name) c = replaceName(c);
        if (c instanceof code_1._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof code_1._Code && e._items.some((c)=>c instanceof code_1.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, code_1._)`!${par(x)}`;
}
exports.not = not;
const andCode = mappend(exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function and(...args) {
    return args.reduce(andCode);
}
exports.and = and;
const orCode = mappend(exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function or(...args) {
    return args.reduce(orCode);
}
exports.or = or;
function mappend(op) {
    return (x, y)=>x === code_1.nil ? y : y === code_1.nil ? x : (0, code_1._)`${par(x)} ${op} ${par(y)}`;
}
function par(x) {
    return x instanceof code_1.Name ? x : (0, code_1._)`(${x})`;
}

},{"3a923f104f0d1cf0":"l7BiE","f2814f3db5f7131a":"cz3rn"}],"l7BiE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.regexpCode = exports.getEsmExportName = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class _CodeOrName {
}
exports._CodeOrName = _CodeOrName;
exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class Name extends _CodeOrName {
    constructor(s){
        super();
        if (!exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
exports.Name = Name;
class _Code extends _CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
exports._Code = _Code;
exports.nil = new _Code("");
function _(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new _Code(code);
}
exports._ = _;
const plus = new _Code("+");
function str(strs, ...args) {
    const expr = [
        safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push(plus);
        addCodeArg(expr, args[i]);
        expr.push(plus, safeStringify(strs[++i]));
    }
    optimize(expr);
    return new _Code(expr);
}
exports.str = str;
function addCodeArg(code, arg) {
    if (arg instanceof _Code) code.push(...arg._items);
    else if (arg instanceof Name) code.push(arg);
    else code.push(interpolate(arg));
}
exports.addCodeArg = addCodeArg;
function optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === plus) {
            const res = mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof Name)) return `"${a}${b.slice(1)}`;
    return;
}
function strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str`${c1}${c2}`;
}
exports.strConcat = strConcat;
// TODO do not allow arrays here
function interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function stringify(x) {
    return new _Code(safeStringify(x));
}
exports.stringify = stringify;
function safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
exports.safeStringify = safeStringify;
function getProperty(key) {
    return typeof key == "string" && exports.IDENTIFIER.test(key) ? new _Code(`.${key}`) : _`[${key}]`;
}
exports.getProperty = getProperty;
//Does best effort to format the name properly
function getEsmExportName(key) {
    if (typeof key == "string" && exports.IDENTIFIER.test(key)) return new _Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
exports.getEsmExportName = getEsmExportName;
function regexpCode(rx) {
    return new _Code(rx.toString());
}
exports.regexpCode = regexpCode;

},{}],"cz3rn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;
const code_1 = require("fe3b9fbcf3b5938");
class ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})(UsedValueState || (exports.UsedValueState = UsedValueState = {}));
exports.varKinds = {
    const: new code_1.Name("const"),
    let: new code_1.Name("let"),
    var: new code_1.Name("var")
};
class Scope {
    constructor({ prefixes, parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new code_1.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix,
            index: 0
        };
    }
}
exports.Scope = Scope;
class ValueScopeName extends code_1.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property, itemIndex }) {
        this.value = value;
        this.scopePath = (0, code_1._)`.${new code_1.Name(property)}[${itemIndex}]`;
    }
}
exports.ValueScopeName = ValueScopeName;
const line = (0, code_1._)`\n`;
class ValueScope extends Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? line : code_1.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, code_1._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = code_1.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
                    code = (0, code_1._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, code_1._)`${code}${c}${this.opts._n}`;
                else throw new ValueError(name);
                nameSet.set(name, UsedValueState.Completed);
            });
        }
        return code;
    }
}
exports.ValueScope = ValueScope;

},{"fe3b9fbcf3b5938":"l7BiE"}],"lNHh9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkStrictMode = exports.getErrorPath = exports.Type = exports.useFunc = exports.setEvaluated = exports.evaluatedPropsToName = exports.mergeEvaluated = exports.eachItem = exports.unescapeJsonPointer = exports.escapeJsonPointer = exports.escapeFragment = exports.unescapeFragment = exports.schemaRefOrVal = exports.schemaHasRulesButRef = exports.schemaHasRules = exports.checkUnknownRules = exports.alwaysValidSchema = exports.toHash = void 0;
const codegen_1 = require("1fed95e2ef43e8be");
const code_1 = require("9f52dff5cd4050ce");
// TODO refactor to use Set
function toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
exports.toHash = toHash;
function alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    checkUnknownRules(it, schema);
    return !schemaHasRules(schema, it.self.RULES.all);
}
exports.alwaysValidSchema = alwaysValidSchema;
function checkUnknownRules(it, schema = it.schema) {
    const { opts, self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) checkStrictMode(it, `unknown keyword: "${key}"`);
}
exports.checkUnknownRules = checkUnknownRules;
function schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
exports.schemaHasRules = schemaHasRules;
function schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
exports.schemaHasRulesButRef = schemaHasRulesButRef;
function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, codegen_1._)`${schema}`;
    }
    return (0, codegen_1._)`${topSchemaRef}${schemaPath}${(0, codegen_1.getProperty)(keyword)}`;
}
exports.schemaRefOrVal = schemaRefOrVal;
function unescapeFragment(str) {
    return unescapeJsonPointer(decodeURIComponent(str));
}
exports.unescapeFragment = unescapeFragment;
function escapeFragment(str) {
    return encodeURIComponent(escapeJsonPointer(str));
}
exports.escapeFragment = escapeFragment;
function escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
exports.escapeJsonPointer = escapeJsonPointer;
function unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
exports.unescapeJsonPointer = unescapeJsonPointer;
function eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
exports.eachItem = eachItem;
function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues, resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof codegen_1.Name ? (from instanceof codegen_1.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof codegen_1.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === codegen_1.Name && !(res instanceof codegen_1.Name) ? resultToName(gen, res) : res;
    };
}
exports.mergeEvaluated = {
    props: makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, codegen_1._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, codegen_1._)`${to} || {}`).code((0, codegen_1._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, codegen_1._)`${to} || {}`);
                    setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: evaluatedPropsToName
    }),
    items: makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, codegen_1._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, codegen_1._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, codegen_1._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, codegen_1._)`{}`);
    if (ps !== undefined) setEvaluated(gen, props, ps);
    return props;
}
exports.evaluatedPropsToName = evaluatedPropsToName;
function setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, codegen_1._)`${props}${(0, codegen_1.getProperty)(p)}`, true));
}
exports.setEvaluated = setEvaluated;
const snippets = {};
function useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: snippets[f.code] || (snippets[f.code] = new code_1._Code(f.code))
    });
}
exports.useFunc = useFunc;
var Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})(Type || (exports.Type = Type = {}));
function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof codegen_1.Name) {
        const isNumber = dataPropType === Type.Num;
        return jsPropertySyntax ? isNumber ? (0, codegen_1._)`"[" + ${dataProp} + "]"` : (0, codegen_1._)`"['" + ${dataProp} + "']"` : isNumber ? (0, codegen_1._)`"/" + ${dataProp}` : (0, codegen_1._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, codegen_1.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
}
exports.getErrorPath = getErrorPath;
function checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
exports.checkStrictMode = checkStrictMode;

},{"1fed95e2ef43e8be":"irYIY","9f52dff5cd4050ce":"l7BiE"}],"80kJL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("39d82176e02d4399");
const names = {
    // validation function arguments
    data: new codegen_1.Name("data"),
    // args passed from referencing schema
    valCxt: new codegen_1.Name("valCxt"),
    instancePath: new codegen_1.Name("instancePath"),
    parentData: new codegen_1.Name("parentData"),
    parentDataProperty: new codegen_1.Name("parentDataProperty"),
    rootData: new codegen_1.Name("rootData"),
    dynamicAnchors: new codegen_1.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new codegen_1.Name("vErrors"),
    errors: new codegen_1.Name("errors"),
    this: new codegen_1.Name("this"),
    // "globals"
    self: new codegen_1.Name("self"),
    scope: new codegen_1.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new codegen_1.Name("json"),
    jsonPos: new codegen_1.Name("jsonPos"),
    jsonLen: new codegen_1.Name("jsonLen"),
    jsonPart: new codegen_1.Name("jsonPart")
};
exports.default = names;

},{"39d82176e02d4399":"irYIY"}],"a2cIv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportTypeError = exports.checkDataTypes = exports.checkDataType = exports.coerceAndCheckDataType = exports.getJSONTypes = exports.getSchemaTypes = exports.DataType = void 0;
const rules_1 = require("4089f5f8b045add0");
const applicability_1 = require("dd5ec382536e9238");
const errors_1 = require("88cdfb931f80e7b5");
const codegen_1 = require("3415e851a7f8c325");
const util_1 = require("7e9cd5ad0634b02b");
var DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})(DataType || (exports.DataType = DataType = {}));
function getSchemaTypes(schema) {
    const types = getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
exports.getSchemaTypes = getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every(rules_1.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
exports.getJSONTypes = getJSONTypes;
function coerceAndCheckDataType(it, types) {
    const { gen, data, opts } = it;
    const coerceTo = coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, applicability_1.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = checkDataTypes(types, data, opts.strictNumbers, DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) coerceData(it, types, coerceTo);
            else reportTypeError(it);
        });
    }
    return checkTypes;
}
exports.coerceAndCheckDataType = coerceAndCheckDataType;
const COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function coerceData(it, types, coerceTo) {
    const { gen, data, opts } = it;
    const dataType = gen.let("dataType", (0, codegen_1._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, codegen_1._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, codegen_1._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, codegen_1._)`${data}[0]`).assign(dataType, (0, codegen_1._)`typeof ${data}`).if(checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, codegen_1._)`${coerced} !== undefined`);
    for (const t of coerceTo)if (COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    reportTypeError(it);
    gen.endIf();
    gen.if((0, codegen_1._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, codegen_1._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, codegen_1._)`"" + ${data}`).elseIf((0, codegen_1._)`${data} === null`).assign(coerced, (0, codegen_1._)`""`);
                return;
            case "number":
                gen.elseIf((0, codegen_1._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, codegen_1._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, codegen_1._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, codegen_1._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, codegen_1._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, codegen_1._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, codegen_1._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, codegen_1._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, codegen_1._)`[${data}]`);
        }
    }
}
function assignParentData({ gen, parentData, parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, codegen_1._)`${parentData} !== undefined`, ()=>gen.assign((0, codegen_1._)`${parentData}[${parentDataProperty}]`, expr));
}
function checkDataType(dataType, data, strictNums, correct = DataType.Correct) {
    const EQ = correct === DataType.Correct ? codegen_1.operators.EQ : codegen_1.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, codegen_1._)`${data} ${EQ} null`;
        case "array":
            cond = (0, codegen_1._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, codegen_1._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, codegen_1._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, codegen_1._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === DataType.Correct ? cond : (0, codegen_1.not)(cond);
    function numCond(_cond = codegen_1.nil) {
        return (0, codegen_1.and)((0, codegen_1._)`typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1._)`isFinite(${data})` : codegen_1.nil);
    }
}
exports.checkDataType = checkDataType;
function checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, util_1.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, codegen_1._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, codegen_1._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = codegen_1.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, codegen_1.and)(cond, checkDataType(t, data, strictNums, correct));
    return cond;
}
exports.checkDataTypes = checkDataTypes;
const typeError = {
    message: ({ schema })=>`must be ${schema}`,
    params: ({ schema, schemaValue })=>typeof schema == "string" ? (0, codegen_1._)`{type: ${schema}}` : (0, codegen_1._)`{type: ${schemaValue}}`
};
function reportTypeError(it) {
    const cxt = getTypeErrorContext(it);
    (0, errors_1.reportError)(cxt, typeError);
}
exports.reportTypeError = reportTypeError;
function getTypeErrorContext(it) {
    const { gen, data, schema } = it;
    const schemaCode = (0, util_1.schemaRefOrVal)(it, schema, "type");
    return {
        gen,
        keyword: "type",
        data,
        schema: schema.type,
        schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it
    };
}

},{"4089f5f8b045add0":"8PLj3","dd5ec382536e9238":"kThul","88cdfb931f80e7b5":"1u6Rd","3415e851a7f8c325":"irYIY","7e9cd5ad0634b02b":"lNHh9"}],"8PLj3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRules = exports.isJSONType = void 0;
const _jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const jsonTypes = new Set(_jsonTypes);
function isJSONType(x) {
    return typeof x == "string" && jsonTypes.has(x);
}
exports.isJSONType = isJSONType;
function getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
exports.getRules = getRules;

},{}],"kThul":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldUseRule = exports.shouldUseGroup = exports.schemaHasRulesForType = void 0;
function schemaHasRulesForType({ schema, self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && shouldUseGroup(schema, group);
}
exports.schemaHasRulesForType = schemaHasRulesForType;
function shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>shouldUseRule(schema, rule));
}
exports.shouldUseGroup = shouldUseGroup;
function shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
exports.shouldUseRule = shouldUseRule;

},{}],"1v9yn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assignDefaults = void 0;
const codegen_1 = require("cc7174703daf515");
const util_1 = require("a2721282ac596cf5");
function assignDefaults(it, ty) {
    const { properties, items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>assignDefault(it, i, sch.default));
}
exports.assignDefaults = assignDefaults;
function assignDefault(it, prop, defaultValue) {
    const { gen, compositeRule, data, opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(prop)}`;
    if (compositeRule) {
        (0, util_1.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, codegen_1._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, codegen_1._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, codegen_1._)`${childData} = ${(0, codegen_1.stringify)(defaultValue)}`);
}

},{"cc7174703daf515":"irYIY","a2721282ac596cf5":"lNHh9"}],"b4zHR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateKeywordUsage = exports.validSchemaType = exports.funcKeywordCode = exports.macroKeywordCode = void 0;
const codegen_1 = require("18e33341eef58f18");
const names_1 = require("e12c11aac04b7418");
const code_1 = require("adc32b068f541871");
const errors_1 = require("bc193073814b6e5f");
function macroKeywordCode(cxt, def) {
    const { gen, keyword, schema, parentSchema, it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: codegen_1.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
exports.macroKeywordCode = macroKeywordCode;
function funcKeywordCode(cxt, def) {
    var _a;
    const { gen, keyword, schema, parentSchema, $data, it } = cxt;
    checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) modifyData(cxt);
            reportErrs(()=>addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, codegen_1._)`await `), (e)=>gen.assign(valid, false).if((0, codegen_1._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, codegen_1._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, codegen_1._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid(codegen_1.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, codegen_1._)`await ` : codegen_1.nil) {
        const passCxt = it.opts.passContext ? names_1.default.this : names_1.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, codegen_1._)`${_await}${(0, code_1.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, codegen_1.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
exports.funcKeywordCode = funcKeywordCode;
function modifyData(cxt) {
    const { gen, data, it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, codegen_1._)`${it.parentData}[${it.parentDataProperty}]`));
}
function addErrs(cxt, errs) {
    const { gen } = cxt;
    gen.if((0, codegen_1._)`Array.isArray(${errs})`, ()=>{
        gen.assign(names_1.default.vErrors, (0, codegen_1._)`${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`).assign(names_1.default.errors, (0, codegen_1._)`${names_1.default.vErrors}.length`);
        (0, errors_1.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function checkAsyncKeyword({ schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, codegen_1.stringify)(result)
    });
}
function validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
exports.validSchemaType = validSchemaType;
function validateKeywordUsage({ schema, opts, self, errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
exports.validateKeywordUsage = validateKeywordUsage;

},{"18e33341eef58f18":"irYIY","e12c11aac04b7418":"80kJL","adc32b068f541871":"451JO","bc193073814b6e5f":"1u6Rd"}],"451JO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateUnion = exports.validateArray = exports.usePattern = exports.callValidateCode = exports.schemaProperties = exports.allSchemaProperties = exports.noPropertyInData = exports.propertyInData = exports.isOwnProperty = exports.hasPropFunc = exports.reportMissingProp = exports.checkMissingProp = exports.checkReportMissingProp = void 0;
const codegen_1 = require("c5b9cfa38882b736");
const util_1 = require("6bd31a3c9b2fd469");
const names_1 = require("875dcb82ae7c724a");
const util_2 = require("6bd31a3c9b2fd469");
function checkReportMissingProp(cxt, prop) {
    const { gen, data, it } = cxt;
    gen.if(noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, codegen_1._)`${prop}`
        }, true);
        cxt.error();
    });
}
exports.checkReportMissingProp = checkReportMissingProp;
function checkMissingProp({ gen, data, it: { opts } }, properties, missing) {
    return (0, codegen_1.or)(...properties.map((prop)=>(0, codegen_1.and)(noPropertyInData(gen, data, prop, opts.ownProperties), (0, codegen_1._)`${missing} = ${prop}`)));
}
exports.checkMissingProp = checkMissingProp;
function reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
exports.reportMissingProp = reportMissingProp;
function hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, codegen_1._)`Object.prototype.hasOwnProperty`
    });
}
exports.hasPropFunc = hasPropFunc;
function isOwnProperty(gen, data, property) {
    return (0, codegen_1._)`${hasPropFunc(gen)}.call(${data}, ${property})`;
}
exports.isOwnProperty = isOwnProperty;
function propertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, codegen_1._)`${cond} && ${isOwnProperty(gen, data, property)}` : cond;
}
exports.propertyInData = propertyInData;
function noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(property)} === undefined`;
    return ownProperties ? (0, codegen_1.or)(cond, (0, codegen_1.not)(isOwnProperty(gen, data, property))) : cond;
}
exports.noPropertyInData = noPropertyInData;
function allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
exports.allSchemaProperties = allSchemaProperties;
function schemaProperties(it, schemaMap) {
    return allSchemaProperties(schemaMap).filter((p)=>!(0, util_1.alwaysValidSchema)(it, schemaMap[p]));
}
exports.schemaProperties = schemaProperties;
function callValidateCode({ schemaCode, data, it: { gen, topSchemaRef, schemaPath, errorPath }, it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, codegen_1._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            names_1.default.instancePath,
            (0, codegen_1.strConcat)(names_1.default.instancePath, errorPath)
        ],
        [
            names_1.default.parentData,
            it.parentData
        ],
        [
            names_1.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            names_1.default.rootData,
            names_1.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        names_1.default.dynamicAnchors,
        names_1.default.dynamicAnchors
    ]);
    const args = (0, codegen_1._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== codegen_1.nil ? (0, codegen_1._)`${func}.call(${context}, ${args})` : (0, codegen_1._)`${func}(${args})`;
}
exports.callValidateCode = callValidateCode;
const newRegExp = (0, codegen_1._)`new RegExp`;
function usePattern({ gen, it: { opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, codegen_1._)`${regExp.code === "new RegExp" ? newRegExp : (0, util_2.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
exports.usePattern = usePattern;
function validateArray(cxt) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, codegen_1._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword,
                dataProp: i,
                dataPropType: util_1.Type.Num
            }, valid);
            gen.if((0, codegen_1.not)(valid), notValid);
        });
    }
}
exports.validateArray = validateArray;
function validateUnion(cxt) {
    const { gen, schema, keyword, it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, util_1.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, codegen_1._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, codegen_1.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
exports.validateUnion = validateUnion;

},{"c5b9cfa38882b736":"irYIY","6bd31a3c9b2fd469":"lNHh9","875dcb82ae7c724a":"80kJL"}],"jvnAj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extendSubschemaMode = exports.extendSubschemaData = exports.getSubschema = void 0;
const codegen_1 = require("aa9b081156c973ca");
const util_1 = require("f65cedb2b5f71713");
function getSubschema(it, { keyword, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, codegen_1._)`${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, codegen_1._)`${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}${(0, codegen_1.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, util_1.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema,
            schemaPath,
            topSchemaRef,
            errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
exports.getSubschema = getSubschema;
function extendSubschemaData(subschema, it, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen } = it;
    if (dataProp !== undefined) {
        const { errorPath, dataPathArr, opts } = it;
        const nextData = gen.let("data", (0, codegen_1._)`${it.data}${(0, codegen_1.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, codegen_1.str)`${errorPath}${(0, util_1.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, codegen_1._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof codegen_1.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
exports.extendSubschemaData = extendSubschemaData;
function extendSubschemaMode(subschema, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
exports.extendSubschemaMode = extendSubschemaMode;

},{"aa9b081156c973ca":"irYIY","f65cedb2b5f71713":"lNHh9"}],"143RM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSchemaRefs = exports.resolveUrl = exports.normalizeId = exports._getFullPath = exports.getFullPath = exports.inlineRef = void 0;
const util_1 = require("272bb8b278b5bdbb");
const equal = require("4cbbead361e56e33");
const traverse = require("7533283b2784ffaa");
// TODO refactor to use keyword definitions
const SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !hasRef(schema);
    if (!limit) return false;
    return countKeys(schema) <= limit;
}
exports.inlineRef = inlineRef;
const REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function hasRef(schema) {
    for(const key in schema){
        if (REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some(hasRef)) return true;
        if (typeof sch == "object" && hasRef(sch)) return true;
    }
    return false;
}
function countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if (SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, util_1.eachItem)(schema[key], (sch)=>count += countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = normalizeId(id);
    const p = resolver.parse(id);
    return _getFullPath(resolver, p);
}
exports.getFullPath = getFullPath;
function _getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
exports._getFullPath = _getFullPath;
const TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
    return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
}
exports.normalizeId = normalizeId;
function resolveUrl(resolver, baseId, id) {
    id = normalizeId(id);
    return resolver.resolve(baseId, id);
}
exports.resolveUrl = resolveUrl;
const ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId, uriResolver } = this.opts;
    const schId = normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    traverse(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !equal(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
exports.getSchemaRefs = getSchemaRefs;

},{"272bb8b278b5bdbb":"lNHh9","4cbbead361e56e33":"cG9xD","7533283b2784ffaa":"eLJKx"}],"cG9xD":[function(require,module,exports,__globalThis) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"eLJKx":[function(require,module,exports,__globalThis) {
'use strict';
var traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    _traverse(opts, pre, post, schema, '', schema);
};
traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in traverse.keywords || opts.allKeys && !(key in traverse.skipKeywords)) _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

},{}],"fL5Oz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
exports.default = ValidationError;

},{}],"4SpuV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const resolve_1 = require("96fb41608b61ab2d");
class MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, resolve_1.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, resolve_1.normalizeId)((0, resolve_1.getFullPath)(resolver, this.missingRef));
    }
}
exports.default = MissingRefError;

},{"96fb41608b61ab2d":"143RM"}],"gmEgM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveSchema = exports.getCompilingSchema = exports.resolveRef = exports.compileSchema = exports.SchemaEnv = void 0;
const codegen_1 = require("6040b29f803efe21");
const validation_error_1 = require("84e7c50527309eb3");
const names_1 = require("bb7dbfc63c27004d");
const resolve_1 = require("cd18dcd881afb39c");
const util_1 = require("6ba7949df35e27ab");
const validate_1 = require("dddb82f3af9e275e");
class SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
exports.SchemaEnv = SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5, lines } = this.opts.code;
    const { ownProperties } = this.opts;
    const gen = new codegen_1.CodeGen(this.scope, {
        es5,
        lines,
        ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: validation_error_1.default,
        code: (0, codegen_1._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen,
        allErrors: this.opts.allErrors,
        data: names_1.default.data,
        parentData: names_1.default.parentData,
        parentDataProperty: names_1.default.parentDataProperty,
        dataNames: [
            names_1.default.data
        ],
        dataPathArr: [
            codegen_1.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, codegen_1.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId,
        baseId: sch.baseId || rootId,
        schemaPath: codegen_1.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, codegen_1._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, validate_1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs(names_1.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${names_1.default.self}`, `${names_1.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName,
            validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props, items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof codegen_1.Name ? undefined : props,
                items: items instanceof codegen_1.Name ? undefined : items,
                dynamicProps: props instanceof codegen_1.Name,
                dynamicItems: items instanceof codegen_1.Name
            };
            if (validate.source) validate.source.evaluated = (0, codegen_1.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
exports.compileSchema = compileSchema;
function resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId } = this.opts;
        if (schema) _sch = new SchemaEnv({
            schema,
            schemaId,
            root,
            baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = inlineOrCompile.call(this, _sch);
}
exports.resolveRef = resolveRef;
function inlineOrCompile(sch) {
    if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if (sameSchemaEnv(sch, schEnv)) return sch;
    }
}
exports.getCompilingSchema = getCompilingSchema;
function sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return getJsonPointer.call(this, p, root);
    const id = (0, resolve_1.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) compileSchema.call(this, schOrRef);
    if (id === (0, resolve_1.normalizeId)(ref)) {
        const { schema } = schOrRef;
        const { schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new SchemaEnv({
            schema,
            schemaId,
            root,
            baseId
        });
    }
    return getJsonPointer.call(this, p, schOrRef);
}
exports.resolveSchema = resolveSchema;
const PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function getJsonPointer(parsedRef, { baseId, schema, root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, util_1.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, util_1.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId } = this.opts;
    env = env || new SchemaEnv({
        schema,
        schemaId,
        root,
        baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

},{"6040b29f803efe21":"irYIY","84e7c50527309eb3":"fL5Oz","bb7dbfc63c27004d":"80kJL","cd18dcd881afb39c":"143RM","6ba7949df35e27ab":"lNHh9","dddb82f3af9e275e":"bkVpi"}],"ijT43":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON AnySchema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

},{}],"laWPK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const uri = require("a04c2a22a0581b84");
uri.code = 'require("ajv/dist/runtime/uri").default';
exports.default = uri;

},{"a04c2a22a0581b84":"7VhbL"}],"7VhbL":[function(require,module,exports,__globalThis) {
'use strict';
const { normalizeIPv6, normalizeIPv4, removeDotSegments, recomposeAuthority, normalizeComponentEncoding } = require("f110d856ee42361b");
const SCHEMES = require("bec2b4c904353aac");
function normalize(uri, options) {
    if (typeof uri === 'string') uri = serialize(parse(uri, options), options);
    else if (typeof uri === 'object') uri = parse(serialize(uri, options), options);
    return uri;
}
function resolve(baseURI, relativeURI, options) {
    const schemelessOptions = Object.assign({
        scheme: 'null'
    }, options);
    const resolved = resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true);
    return serialize(resolved, {
        ...schemelessOptions,
        skipEscape: true
    });
}
function resolveComponents(base, relative, options, skipNormalization) {
    const target = {};
    if (!skipNormalization) {
        base = parse(serialize(base, options), options) // normalize base components
        ;
        relative = parse(serialize(relative, options), options) // normalize relative components
        ;
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        // target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = removeDotSegments(relative.path || '');
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            // target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || '');
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path.charAt(0) === '/') target.path = removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = '/' + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
                    target.path = removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            // target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
function equal(uriA, uriB, options) {
    if (typeof uriA === 'string') {
        uriA = unescape(uriA);
        uriA = serialize(normalizeComponentEncoding(parse(uriA, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriA === 'object') uriA = serialize(normalizeComponentEncoding(uriA, true), {
        ...options,
        skipEscape: true
    });
    if (typeof uriB === 'string') {
        uriB = unescape(uriB);
        uriB = serialize(normalizeComponentEncoding(parse(uriB, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriB === 'object') uriB = serialize(normalizeComponentEncoding(uriB, true), {
        ...options,
        skipEscape: true
    });
    return uriA.toLowerCase() === uriB.toLowerCase();
}
function serialize(cmpts, opts) {
    const components = {
        host: cmpts.host,
        scheme: cmpts.scheme,
        userinfo: cmpts.userinfo,
        port: cmpts.port,
        path: cmpts.path,
        query: cmpts.query,
        nid: cmpts.nid,
        nss: cmpts.nss,
        uuid: cmpts.uuid,
        fragment: cmpts.fragment,
        reference: cmpts.reference,
        resourceName: cmpts.resourceName,
        secure: cmpts.secure,
        error: ''
    };
    const options = Object.assign({}, opts);
    const uriTokens = [];
    // find scheme handler
    const schemeHandler = SCHEMES[(options.scheme || components.scheme || '').toLowerCase()];
    // perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.path !== undefined) {
        if (!options.skipEscape) {
            components.path = escape(components.path);
            if (components.scheme !== undefined) components.path = components.path.split('%3A').join(':');
        } else components.path = unescape(components.path);
    }
    if (options.reference !== 'suffix' && components.scheme) uriTokens.push(components.scheme, ':');
    const authority = recomposeAuthority(components, options);
    if (authority !== undefined) {
        if (options.reference !== 'suffix') uriTokens.push('//');
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== '/') uriTokens.push('/');
    }
    if (components.path !== undefined) {
        let s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
        if (authority === undefined) s = s.replace(/^\/\//u, '/%2F') // don't allow the path to start with "//"
        ;
        uriTokens.push(s);
    }
    if (components.query !== undefined) uriTokens.push('?', components.query);
    if (components.fragment !== undefined) uriTokens.push('#', components.fragment);
    return uriTokens.join('');
}
const hexLookUp = Array.from({
    length: 127
}, (v, k)=>/[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(k)));
function nonSimpleDomain(value) {
    let code = 0;
    for(let i = 0, len = value.length; i < len; ++i){
        code = value.charCodeAt(i);
        if (code > 126 || hexLookUp[code]) return true;
    }
    return false;
}
const URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
function parse(uri, opts) {
    const options = Object.assign({}, opts);
    const parsed = {
        scheme: undefined,
        userinfo: undefined,
        host: '',
        port: undefined,
        path: '',
        query: undefined,
        fragment: undefined
    };
    const gotEncoding = uri.indexOf('%') !== -1;
    let isIP = false;
    if (options.reference === 'suffix') uri = (options.scheme ? options.scheme + ':' : '') + '//' + uri;
    const matches = uri.match(URI_PARSE);
    if (matches) {
        // store each component
        parsed.scheme = matches[1];
        parsed.userinfo = matches[3];
        parsed.host = matches[4];
        parsed.port = parseInt(matches[5], 10);
        parsed.path = matches[6] || '';
        parsed.query = matches[7];
        parsed.fragment = matches[8];
        // fix port number
        if (isNaN(parsed.port)) parsed.port = matches[5];
        if (parsed.host) {
            const ipv4result = normalizeIPv4(parsed.host);
            if (ipv4result.isIPV4 === false) {
                const ipv6result = normalizeIPv6(ipv4result.host, {
                    isIPV4: false
                });
                parsed.host = ipv6result.host.toLowerCase();
                isIP = ipv6result.isIPV6;
            } else {
                parsed.host = ipv4result.host;
                isIP = true;
            }
        }
        if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && !parsed.path && parsed.query === undefined) parsed.reference = 'same-document';
        else if (parsed.scheme === undefined) parsed.reference = 'relative';
        else if (parsed.fragment === undefined) parsed.reference = 'absolute';
        else parsed.reference = 'uri';
        // check for reference errors
        if (options.reference && options.reference !== 'suffix' && options.reference !== parsed.reference) parsed.error = parsed.error || 'URI is not a ' + options.reference + ' reference.';
        // find scheme handler
        const schemeHandler = SCHEMES[(options.scheme || parsed.scheme || '').toLowerCase()];
        // check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            // if host component is a domain name
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && nonSimpleDomain(parsed.host)) // convert Unicode IDN -> ASCII IDN
            try {
                parsed.host = URL.domainToASCII(parsed.host.toLowerCase());
            } catch (e) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
            }
        // convert IRI -> URI
        }
        if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (gotEncoding && parsed.scheme !== undefined) parsed.scheme = unescape(parsed.scheme);
            if (gotEncoding && parsed.host !== undefined) parsed.host = unescape(parsed.host);
            if (parsed.path !== undefined && parsed.path.length) parsed.path = escape(unescape(parsed.path));
            if (parsed.fragment !== undefined && parsed.fragment.length) parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
        }
        // perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) schemeHandler.parse(parsed, options);
    } else parsed.error = parsed.error || 'URI can not be parsed.';
    return parsed;
}
const fastUri = {
    SCHEMES,
    normalize,
    resolve,
    resolveComponents,
    equal,
    serialize,
    parse
};
module.exports = fastUri;
module.exports.default = fastUri;
module.exports.fastUri = fastUri;

},{"f110d856ee42361b":"823LZ","bec2b4c904353aac":"aPINk"}],"823LZ":[function(require,module,exports,__globalThis) {
'use strict';
const { HEX } = require("c03c080a1c48b07a");
function normalizeIPv4(host) {
    if (findToken(host, '.') < 3) return {
        host,
        isIPV4: false
    };
    const matches = host.match(/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/u) || [];
    const [address] = matches;
    if (address) return {
        host: stripLeadingZeros(address, '.'),
        isIPV4: true
    };
    else return {
        host,
        isIPV4: false
    };
}
/**
 * @param {string[]} input
 * @param {boolean} [keepZero=false]
 * @returns {string|undefined}
 */ function stringArrayToHexStripped(input, keepZero = false) {
    let acc = '';
    let strip = true;
    for (const c of input){
        if (HEX[c] === undefined) return undefined;
        if (c !== '0' && strip === true) strip = false;
        if (!strip) acc += c;
    }
    if (keepZero && acc.length === 0) acc = '0';
    return acc;
}
function getIPV6(input) {
    let tokenCount = 0;
    const output = {
        error: false,
        address: '',
        zone: ''
    };
    const address = [];
    const buffer = [];
    let isZone = false;
    let endipv6Encountered = false;
    let endIpv6 = false;
    function consume() {
        if (buffer.length) {
            if (isZone === false) {
                const hex = stringArrayToHexStripped(buffer);
                if (hex !== undefined) address.push(hex);
                else {
                    output.error = true;
                    return false;
                }
            }
            buffer.length = 0;
        }
        return true;
    }
    for(let i = 0; i < input.length; i++){
        const cursor = input[i];
        if (cursor === '[' || cursor === ']') continue;
        if (cursor === ':') {
            if (endipv6Encountered === true) endIpv6 = true;
            if (!consume()) break;
            tokenCount++;
            address.push(':');
            if (tokenCount > 7) {
                // not valid
                output.error = true;
                break;
            }
            if (i - 1 >= 0 && input[i - 1] === ':') endipv6Encountered = true;
            continue;
        } else if (cursor === '%') {
            if (!consume()) break;
            // switch to zone detection
            isZone = true;
        } else {
            buffer.push(cursor);
            continue;
        }
    }
    if (buffer.length) {
        if (isZone) output.zone = buffer.join('');
        else if (endIpv6) address.push(buffer.join(''));
        else address.push(stringArrayToHexStripped(buffer));
    }
    output.address = address.join('');
    return output;
}
function normalizeIPv6(host, opts = {}) {
    if (findToken(host, ':') < 2) return {
        host,
        isIPV6: false
    };
    const ipv6 = getIPV6(host);
    if (!ipv6.error) {
        let newHost = ipv6.address;
        let escapedHost = ipv6.address;
        if (ipv6.zone) {
            newHost += '%' + ipv6.zone;
            escapedHost += '%25' + ipv6.zone;
        }
        return {
            host: newHost,
            escapedHost,
            isIPV6: true
        };
    } else return {
        host,
        isIPV6: false
    };
}
function stripLeadingZeros(str, token) {
    let out = '';
    let skip = true;
    const l = str.length;
    for(let i = 0; i < l; i++){
        const c = str[i];
        if (c === '0' && skip) {
            if (i + 1 <= l && str[i + 1] === token || i + 1 === l) {
                out += c;
                skip = false;
            }
        } else {
            if (c === token) skip = true;
            else skip = false;
            out += c;
        }
    }
    return out;
}
function findToken(str, token) {
    let ind = 0;
    for(let i = 0; i < str.length; i++)if (str[i] === token) ind++;
    return ind;
}
const RDS1 = /^\.\.?\//u;
const RDS2 = /^\/\.(?:\/|$)/u;
const RDS3 = /^\/\.\.(?:\/|$)/u;
const RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/u;
function removeDotSegments(input) {
    const output = [];
    while(input.length){
        if (input.match(RDS1)) input = input.replace(RDS1, '');
        else if (input.match(RDS2)) input = input.replace(RDS2, '/');
        else if (input.match(RDS3)) {
            input = input.replace(RDS3, '/');
            output.pop();
        } else if (input === '.' || input === '..') input = '';
        else {
            const im = input.match(RDS5);
            if (im) {
                const s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else throw new Error('Unexpected dot segment condition');
        }
    }
    return output.join('');
}
function normalizeComponentEncoding(components, esc) {
    const func = esc !== true ? escape : unescape;
    if (components.scheme !== undefined) components.scheme = func(components.scheme);
    if (components.userinfo !== undefined) components.userinfo = func(components.userinfo);
    if (components.host !== undefined) components.host = func(components.host);
    if (components.path !== undefined) components.path = func(components.path);
    if (components.query !== undefined) components.query = func(components.query);
    if (components.fragment !== undefined) components.fragment = func(components.fragment);
    return components;
}
function recomposeAuthority(components, options) {
    const uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push('@');
    }
    if (components.host !== undefined) {
        let host = unescape(components.host);
        const ipV4res = normalizeIPv4(host);
        if (ipV4res.isIPV4) host = ipV4res.host;
        else {
            const ipV6res = normalizeIPv6(ipV4res.host, {
                isIPV4: false
            });
            if (ipV6res.isIPV6 === true) host = `[${ipV6res.escapedHost}]`;
            else host = components.host;
        }
        uriTokens.push(host);
    }
    if (typeof components.port === 'number' || typeof components.port === 'string') {
        uriTokens.push(':');
        uriTokens.push(String(components.port));
    }
    return uriTokens.length ? uriTokens.join('') : undefined;
}
module.exports = {
    recomposeAuthority,
    normalizeComponentEncoding,
    removeDotSegments,
    normalizeIPv4,
    normalizeIPv6,
    stringArrayToHexStripped
};

},{"c03c080a1c48b07a":"f861V"}],"f861V":[function(require,module,exports,__globalThis) {
'use strict';
const HEX = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    A: 10,
    b: 11,
    B: 11,
    c: 12,
    C: 12,
    d: 13,
    D: 13,
    e: 14,
    E: 14,
    f: 15,
    F: 15
};
module.exports = {
    HEX
};

},{}],"aPINk":[function(require,module,exports,__globalThis) {
'use strict';
const UUID_REG = /^[\da-f]{8}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{12}$/iu;
const URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
function isSecure(wsComponents) {
    return typeof wsComponents.secure === 'boolean' ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === 'wss';
}
function httpParse(components) {
    if (!components.host) components.error = components.error || 'HTTP URIs must have a host.';
    return components;
}
function httpSerialize(components) {
    const secure = String(components.scheme).toLowerCase() === 'https';
    // normalize the default port
    if (components.port === (secure ? 443 : 80) || components.port === '') components.port = undefined;
    // normalize the empty path
    if (!components.path) components.path = '/';
    // NOTE: We do not parse query strings for HTTP URIs
    // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
    // and not the HTTP spec.
    return components;
}
function wsParse(wsComponents) {
    // indicate if the secure flag is set
    wsComponents.secure = isSecure(wsComponents);
    // construct resouce name
    wsComponents.resourceName = (wsComponents.path || '/') + (wsComponents.query ? '?' + wsComponents.query : '');
    wsComponents.path = undefined;
    wsComponents.query = undefined;
    return wsComponents;
}
function wsSerialize(wsComponents) {
    // normalize the default port
    if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === '') wsComponents.port = undefined;
    // ensure scheme matches secure flag
    if (typeof wsComponents.secure === 'boolean') {
        wsComponents.scheme = wsComponents.secure ? 'wss' : 'ws';
        wsComponents.secure = undefined;
    }
    // reconstruct path from resource name
    if (wsComponents.resourceName) {
        const [path, query] = wsComponents.resourceName.split('?');
        wsComponents.path = path && path !== '/' ? path : undefined;
        wsComponents.query = query;
        wsComponents.resourceName = undefined;
    }
    // forbid fragment component
    wsComponents.fragment = undefined;
    return wsComponents;
}
function urnParse(urnComponents, options) {
    if (!urnComponents.path) {
        urnComponents.error = 'URN can not be parsed';
        return urnComponents;
    }
    const matches = urnComponents.path.match(URN_REG);
    if (matches) {
        const scheme = options.scheme || urnComponents.scheme || 'urn';
        urnComponents.nid = matches[1].toLowerCase();
        urnComponents.nss = matches[2];
        const urnScheme = `${scheme}:${options.nid || urnComponents.nid}`;
        const schemeHandler = SCHEMES[urnScheme];
        urnComponents.path = undefined;
        if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
    } else urnComponents.error = urnComponents.error || 'URN can not be parsed.';
    return urnComponents;
}
function urnSerialize(urnComponents, options) {
    const scheme = options.scheme || urnComponents.scheme || 'urn';
    const nid = urnComponents.nid.toLowerCase();
    const urnScheme = `${scheme}:${options.nid || nid}`;
    const schemeHandler = SCHEMES[urnScheme];
    if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
    const uriComponents = urnComponents;
    const nss = urnComponents.nss;
    uriComponents.path = `${nid || options.nid}:${nss}`;
    options.skipEscape = true;
    return uriComponents;
}
function urnuuidParse(urnComponents, options) {
    const uuidComponents = urnComponents;
    uuidComponents.uuid = uuidComponents.nss;
    uuidComponents.nss = undefined;
    if (!options.tolerant && (!uuidComponents.uuid || !UUID_REG.test(uuidComponents.uuid))) uuidComponents.error = uuidComponents.error || 'UUID is not valid.';
    return uuidComponents;
}
function urnuuidSerialize(uuidComponents) {
    const urnComponents = uuidComponents;
    // normalize UUID
    urnComponents.nss = (uuidComponents.uuid || '').toLowerCase();
    return urnComponents;
}
const http = {
    scheme: 'http',
    domainHost: true,
    parse: httpParse,
    serialize: httpSerialize
};
const https = {
    scheme: 'https',
    domainHost: http.domainHost,
    parse: httpParse,
    serialize: httpSerialize
};
const ws = {
    scheme: 'ws',
    domainHost: true,
    parse: wsParse,
    serialize: wsSerialize
};
const wss = {
    scheme: 'wss',
    domainHost: ws.domainHost,
    parse: ws.parse,
    serialize: ws.serialize
};
const urn = {
    scheme: 'urn',
    parse: urnParse,
    serialize: urnSerialize,
    skipNormalize: true
};
const urnuuid = {
    scheme: 'urn:uuid',
    parse: urnuuidParse,
    serialize: urnuuidSerialize,
    skipNormalize: true
};
const SCHEMES = {
    http,
    https,
    ws,
    wss,
    urn,
    'urn:uuid': urnuuid
};
module.exports = SCHEMES;

},{}],"jXYLu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const core_1 = require("82be42ec8d7157f1");
const validation_1 = require("cc2ce53aed8875dc");
const applicator_1 = require("577e40ebaf3a827f");
const format_1 = require("c0c18bcb9a1ae0aa");
const metadata_1 = require("aeecf34ae6128131");
const draft7Vocabularies = [
    core_1.default,
    validation_1.default,
    (0, applicator_1.default)(),
    format_1.default,
    metadata_1.metadataVocabulary,
    metadata_1.contentVocabulary
];
exports.default = draft7Vocabularies;

},{"82be42ec8d7157f1":"5d07Y","cc2ce53aed8875dc":"9aoxL","577e40ebaf3a827f":"52uug","c0c18bcb9a1ae0aa":"ftzg8","aeecf34ae6128131":"lWsPQ"}],"5d07Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const id_1 = require("4520fec7a881165e");
const ref_1 = require("4dca9df0743851d");
const core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    id_1.default,
    ref_1.default
];
exports.default = core;

},{"4520fec7a881165e":"kaeQh","4dca9df0743851d":"4a0qb"}],"kaeQh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
exports.default = def;

},{}],"4a0qb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callRef = exports.getValidate = void 0;
const ref_error_1 = require("8f71514fa79201e2");
const code_1 = require("1b8a04b4c06a79cd");
const codegen_1 = require("db023c7b20018a60");
const names_1 = require("63402100a762e61c");
const compile_1 = require("a9b1b3190fc949f5");
const util_1 = require("ba94d65897c2c00f");
const def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen, schema: $ref, it } = cxt;
        const { baseId, schemaEnv: env, validateName, opts, self } = it;
        const { root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = compile_1.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new ref_error_1.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof compile_1.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return callRef(cxt, (0, codegen_1._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = getValidate(cxt, sch);
            callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, codegen_1.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: codegen_1.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function getValidate(cxt, sch) {
    const { gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, codegen_1._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
exports.getValidate = getValidate;
function callRef(cxt, v, sch, $async) {
    const { gen, it } = cxt;
    const { allErrors, schemaEnv: env, opts } = it;
    const passCxt = opts.passContext ? names_1.default.this : codegen_1.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, codegen_1._)`await ${(0, code_1.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, codegen_1._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, code_1.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, codegen_1._)`${source}.errors`;
        gen.assign(names_1.default.vErrors, (0, codegen_1._)`${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign(names_1.default.errors, (0, codegen_1._)`${names_1.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = util_1.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, codegen_1._)`${source}.evaluated.props`);
                it.props = util_1.mergeEvaluated.props(gen, props, it.props, codegen_1.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = util_1.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, codegen_1._)`${source}.evaluated.items`);
                it.items = util_1.mergeEvaluated.items(gen, items, it.items, codegen_1.Name);
            }
        }
    }
}
exports.callRef = callRef;
exports.default = def;

},{"8f71514fa79201e2":"4SpuV","1b8a04b4c06a79cd":"451JO","db023c7b20018a60":"irYIY","63402100a762e61c":"80kJL","a9b1b3190fc949f5":"gmEgM","ba94d65897c2c00f":"lNHh9"}],"9aoxL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const limitNumber_1 = require("e79930f981e2a364");
const multipleOf_1 = require("be0f39f028edf7dc");
const limitLength_1 = require("61dc60dc2ba14401");
const pattern_1 = require("69222616ff1794f6");
const limitProperties_1 = require("8519a67240d2796c");
const required_1 = require("e263f38fd14c2b9b");
const limitItems_1 = require("e21029958ad3c333");
const uniqueItems_1 = require("d0365586fa25458b");
const const_1 = require("8e7e1dc62c0964f3");
const enum_1 = require("89b207411a0537ee");
const validation = [
    // number
    limitNumber_1.default,
    multipleOf_1.default,
    // string
    limitLength_1.default,
    pattern_1.default,
    // object
    limitProperties_1.default,
    required_1.default,
    // array
    limitItems_1.default,
    uniqueItems_1.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    const_1.default,
    enum_1.default
];
exports.default = validation;

},{"e79930f981e2a364":"8xQDC","be0f39f028edf7dc":"1NaTc","61dc60dc2ba14401":"cpY2z","69222616ff1794f6":"k5nnp","8519a67240d2796c":"l57VM","e263f38fd14c2b9b":"2p86o","e21029958ad3c333":"91Zfy","d0365586fa25458b":"fQBDv","8e7e1dc62c0964f3":"bF86y","89b207411a0537ee":"3VGlN"}],"8xQDC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("3648731dfccfca27");
const ops = codegen_1.operators;
const KWDs = {
    maximum: {
        okStr: "<=",
        ok: ops.LTE,
        fail: ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: ops.GTE,
        fail: ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: ops.LT,
        fail: ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: ops.GT,
        fail: ops.LTE
    }
};
const error = {
    message: ({ keyword, schemaCode })=>(0, codegen_1.str)`must be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode })=>(0, codegen_1._)`{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const def = {
    keyword: Object.keys(KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode } = cxt;
        cxt.fail$data((0, codegen_1._)`${data} ${KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
exports.default = def;

},{"3648731dfccfca27":"irYIY"}],"1NaTc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("f398ecd84b20a400");
const error = {
    message: ({ schemaCode })=>(0, codegen_1.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode })=>(0, codegen_1._)`{multipleOf: ${schemaCode}}`
};
const def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, schemaCode, it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, codegen_1._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, codegen_1._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, codegen_1._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
exports.default = def;

},{"f398ecd84b20a400":"irYIY"}],"cpY2z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("4968f787adbf82e3");
const util_1 = require("78694b7562e4dec7");
const ucs2length_1 = require("b64e80003c676177");
const error = {
    message ({ keyword, schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode })=>(0, codegen_1._)`{limit: ${schemaCode}}`
};
const def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode, it } = cxt;
        const op = keyword === "maxLength" ? codegen_1.operators.GT : codegen_1.operators.LT;
        const len = it.opts.unicode === false ? (0, codegen_1._)`${data}.length` : (0, codegen_1._)`${(0, util_1.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
        cxt.fail$data((0, codegen_1._)`${len} ${op} ${schemaCode}`);
    }
};
exports.default = def;

},{"4968f787adbf82e3":"irYIY","78694b7562e4dec7":"lNHh9","b64e80003c676177":"ezjzy"}],"ezjzy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
exports.default = ucs2length;
ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

},{}],"k5nnp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("6423c5f9606c4253");
const codegen_1 = require("c67e4d0ce9d0e145");
const error = {
    message: ({ schemaCode })=>(0, codegen_1.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode })=>(0, codegen_1._)`{pattern: ${schemaCode}}`
};
const def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code (cxt) {
        const { data, $data, schema, schemaCode, it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, codegen_1._)`(new RegExp(${schemaCode}, ${u}))` : (0, code_1.usePattern)(cxt, schema);
        cxt.fail$data((0, codegen_1._)`!${regExp}.test(${data})`);
    }
};
exports.default = def;

},{"6423c5f9606c4253":"451JO","c67e4d0ce9d0e145":"irYIY"}],"l57VM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("717f2905edcd1d4b");
const error = {
    message ({ keyword, schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode })=>(0, codegen_1._)`{limit: ${schemaCode}}`
};
const def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
exports.default = def;

},{"717f2905edcd1d4b":"irYIY"}],"2p86o":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("8116de00ceb2e17c");
const codegen_1 = require("8c79527b91c9aa24");
const util_1 = require("4644f2feebf1f3d7");
const error = {
    message: ({ params: { missingProperty } })=>(0, codegen_1.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty } })=>(0, codegen_1._)`{missingProperty: ${missingProperty}}`
};
const def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error,
    code (cxt) {
        const { gen, schema, schemaCode, data, $data, it } = cxt;
        const { opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, util_1.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data(codegen_1.nil, loopAllRequired);
            else for (const prop of schema)(0, code_1.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, code_1.checkMissingProp)(cxt, schema, missing));
                (0, code_1.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, code_1.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, code_1.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, codegen_1.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, codegen_1.nil);
        }
    }
};
exports.default = def;

},{"8116de00ceb2e17c":"451JO","8c79527b91c9aa24":"irYIY","4644f2feebf1f3d7":"lNHh9"}],"91Zfy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8bf6dd0bbe5ea2bf");
const error = {
    message ({ keyword, schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode })=>(0, codegen_1._)`{limit: ${schemaCode}}`
};
const def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error,
    code (cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxItems" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._)`${data}.length ${op} ${schemaCode}`);
    }
};
exports.default = def;

},{"8bf6dd0bbe5ea2bf":"irYIY"}],"fQBDv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const dataType_1 = require("ed18d6a195747bcd");
const codegen_1 = require("59db147f18482486");
const util_1 = require("498e1140d56af1ce");
const equal_1 = require("4ac1230a4bed5e97");
const error = {
    message: ({ params: { i, j } })=>(0, codegen_1.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i, j } })=>(0, codegen_1._)`{i: ${i}, j: ${j}}`
};
const def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, $data, schema, parentSchema, schemaCode, it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, codegen_1._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, codegen_1._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i,
                j
            });
            gen.assign(valid, true);
            gen.if((0, codegen_1._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, dataType_1.DataType.Wrong);
            const indices = gen.const("indices", (0, codegen_1._)`{}`);
            gen.for((0, codegen_1._)`;${i}--;`, ()=>{
                gen.let(item, (0, codegen_1._)`${data}[${i}]`);
                gen.if(wrongType, (0, codegen_1._)`continue`);
                if (itemTypes.length > 1) gen.if((0, codegen_1._)`typeof ${item} == "string"`, (0, codegen_1._)`${item} += "_"`);
                gen.if((0, codegen_1._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, codegen_1._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, codegen_1._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, util_1.useFunc)(gen, equal_1.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, codegen_1._)`;${i}--;`, ()=>gen.for((0, codegen_1._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, codegen_1._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
exports.default = def;

},{"ed18d6a195747bcd":"a2cIv","59db147f18482486":"irYIY","498e1140d56af1ce":"lNHh9","4ac1230a4bed5e97":"1buQM"}],"1buQM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://github.com/ajv-validator/ajv/issues/889
const equal = require("d2bcd64c511fbbef");
equal.code = 'require("ajv/dist/runtime/equal").default';
exports.default = equal;

},{"d2bcd64c511fbbef":"cG9xD"}],"bF86y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8fa4a24917fa8620");
const util_1 = require("c4ea43af4f833fd0");
const equal_1 = require("4c12131dd960a69d");
const error = {
    message: "must be equal to constant",
    params: ({ schemaCode })=>(0, codegen_1._)`{allowedValue: ${schemaCode}}`
};
const def = {
    keyword: "const",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, $data, schemaCode, schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, codegen_1._)`!${(0, util_1.useFunc)(gen, equal_1.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, codegen_1._)`${schema} !== ${data}`);
    }
};
exports.default = def;

},{"8fa4a24917fa8620":"irYIY","c4ea43af4f833fd0":"lNHh9","4c12131dd960a69d":"1buQM"}],"3VGlN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8ec7518cb324f27e");
const util_1 = require("39b1cf68009dfa22");
const equal_1 = require("10c2bc8aede4ad0d");
const error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode })=>(0, codegen_1._)`{allowedValues: ${schemaCode}}`
};
const def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, util_1.useFunc)(gen, equal_1.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, codegen_1.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, codegen_1._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, codegen_1._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, codegen_1._)`${data} === ${sch}`;
        }
    }
};
exports.default = def;

},{"8ec7518cb324f27e":"irYIY","39b1cf68009dfa22":"lNHh9","10c2bc8aede4ad0d":"1buQM"}],"52uug":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const additionalItems_1 = require("852ecdb59a1c7f37");
const prefixItems_1 = require("df3c3ff1822476c2");
const items_1 = require("f9f856923d6846d7");
const items2020_1 = require("41bc048b170c0123");
const contains_1 = require("4858cbd3be266c5b");
const dependencies_1 = require("e0d2483cbd78911");
const propertyNames_1 = require("5699fcf3532a8e6");
const additionalProperties_1 = require("7d87cea7a44d8ef7");
const properties_1 = require("ce6cdda651f72186");
const patternProperties_1 = require("ead3f0c5b555155e");
const not_1 = require("94b5a3265efdbfcb");
const anyOf_1 = require("563f9088d71dbdc9");
const oneOf_1 = require("c21d69c42fd736c4");
const allOf_1 = require("2ff5e3cd187ba6ce");
const if_1 = require("24b31258da87b1d9");
const thenElse_1 = require("f656ec3d192aed31");
function getApplicator(draft2020 = false) {
    const applicator = [
        // any
        not_1.default,
        anyOf_1.default,
        oneOf_1.default,
        allOf_1.default,
        if_1.default,
        thenElse_1.default,
        // object
        propertyNames_1.default,
        additionalProperties_1.default,
        dependencies_1.default,
        properties_1.default,
        patternProperties_1.default
    ];
    // array
    if (draft2020) applicator.push(prefixItems_1.default, items2020_1.default);
    else applicator.push(additionalItems_1.default, items_1.default);
    applicator.push(contains_1.default);
    return applicator;
}
exports.default = getApplicator;

},{"852ecdb59a1c7f37":"ksdZG","df3c3ff1822476c2":"arOH2","f9f856923d6846d7":"14KiN","41bc048b170c0123":"6n2m8","4858cbd3be266c5b":"Wq03l","e0d2483cbd78911":"jAZ3X","5699fcf3532a8e6":"2OwWF","7d87cea7a44d8ef7":"6lqbI","ce6cdda651f72186":"aZcGU","ead3f0c5b555155e":"d49Zu","94b5a3265efdbfcb":"jLjLp","563f9088d71dbdc9":"8w9Ei","c21d69c42fd736c4":"bKSlU","2ff5e3cd187ba6ce":"eBhcX","24b31258da87b1d9":"bs0mB","f656ec3d192aed31":"aeEXL"}],"ksdZG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateAdditionalItems = void 0;
const codegen_1 = require("eb920d79977d5a0c");
const util_1 = require("1dd12bfced7c65d9");
const error = {
    message: ({ params: { len } })=>(0, codegen_1.str)`must NOT have more than ${len} items`,
    params: ({ params: { len } })=>(0, codegen_1._)`{limit: ${len}}`
};
const def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error,
    code (cxt) {
        const { parentSchema, it } = cxt;
        const { items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, util_1.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        validateAdditionalItems(cxt, items);
    }
};
function validateAdditionalItems(cxt, items) {
    const { gen, schema, data, keyword, it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, codegen_1._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, codegen_1._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, codegen_1._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, codegen_1.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword,
                dataProp: i,
                dataPropType: util_1.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, codegen_1.not)(valid), ()=>gen.break());
        });
    }
}
exports.validateAdditionalItems = validateAdditionalItems;
exports.default = def;

},{"eb920d79977d5a0c":"irYIY","1dd12bfced7c65d9":"lNHh9"}],"arOH2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const items_1 = require("6693fcd262f960ad");
const def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, items_1.validateTuple)(cxt, "items")
};
exports.default = def;

},{"6693fcd262f960ad":"14KiN"}],"14KiN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateTuple = void 0;
const codegen_1 = require("4c4c4ade5ab2262f");
const util_1 = require("892bb718945120f3");
const code_1 = require("31b7fa79ab304a2f");
const def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema, it } = cxt;
        if (Array.isArray(schema)) return validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, code_1.validateArray)(cxt));
    }
};
function validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen, parentSchema, data, keyword, it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = util_1.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, codegen_1._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, util_1.alwaysValidSchema)(it, sch)) return;
        gen.if((0, codegen_1._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts, errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, util_1.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
exports.validateTuple = validateTuple;
exports.default = def;

},{"4c4c4ade5ab2262f":"irYIY","892bb718945120f3":"lNHh9","31b7fa79ab304a2f":"451JO"}],"6n2m8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("5557b85368f11dc8");
const util_1 = require("251bc8960022628");
const code_1 = require("19c76f7b8b158257");
const additionalItems_1 = require("8a1f5b42b3c3a3e8");
const error = {
    message: ({ params: { len } })=>(0, codegen_1.str)`must NOT have more than ${len} items`,
    params: ({ params: { len } })=>(0, codegen_1._)`{limit: ${len}}`
};
const def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error,
    code (cxt) {
        const { schema, parentSchema, it } = cxt;
        const { prefixItems } = parentSchema;
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, additionalItems_1.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, code_1.validateArray)(cxt));
    }
};
exports.default = def;

},{"5557b85368f11dc8":"irYIY","251bc8960022628":"lNHh9","19c76f7b8b158257":"451JO","8a1f5b42b3c3a3e8":"ksdZG"}],"Wq03l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("2321a147ffbf5137");
const util_1 = require("fe1a6ecfd865147e");
const error = {
    message: ({ params: { min, max } })=>max === undefined ? (0, codegen_1.str)`must contain at least ${min} valid item(s)` : (0, codegen_1.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min, max } })=>max === undefined ? (0, codegen_1._)`{minContains: ${min}}` : (0, codegen_1._)`{minContains: ${min}, maxContains: ${max}}`
};
const def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        let min;
        let max;
        const { minContains, maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, codegen_1._)`${data}.length`);
        cxt.setParams({
            min,
            max
        });
        if (max === undefined && min === 0) {
            (0, util_1.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, util_1.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            let cond = (0, codegen_1._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, codegen_1._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, codegen_1._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: util_1.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, codegen_1._)`${count}++`);
            if (max === undefined) gen.if((0, codegen_1._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, codegen_1._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, codegen_1._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
exports.default = def;

},{"2321a147ffbf5137":"irYIY","fe1a6ecfd865147e":"lNHh9"}],"jAZ3X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;
const codegen_1 = require("2c9520ddb7668753");
const util_1 = require("8cb82fc3be8f4c85");
const code_1 = require("294e23f220ec6a41");
exports.error = {
    message: ({ params: { property, depsCount, deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, codegen_1.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property, depsCount, deps, missingProperty } })=>(0, codegen_1._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: exports.error,
    code (cxt) {
        const [propDeps, schDeps] = splitDependencies(cxt);
        validatePropertyDeps(cxt, propDeps);
        validateSchemaDeps(cxt, schDeps);
    }
};
function splitDependencies({ schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen, data, it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, code_1.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, codegen_1._)`${hasProperty} && (${(0, code_1.checkMissingProp)(cxt, deps, missing)})`);
            (0, code_1.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
exports.validatePropertyDeps = validatePropertyDeps;
function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, util_1.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
exports.validateSchemaDeps = validateSchemaDeps;
exports.default = def;

},{"2c9520ddb7668753":"irYIY","8cb82fc3be8f4c85":"lNHh9","294e23f220ec6a41":"451JO"}],"2OwWF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("e22ae7089ab50628");
const util_1 = require("6845a7aec2d16d80");
const error = {
    message: "property name must be valid",
    params: ({ params })=>(0, codegen_1._)`{propertyName: ${params.propertyName}}`
};
const def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error,
    code (cxt) {
        const { gen, schema, data, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, codegen_1.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
exports.default = def;

},{"e22ae7089ab50628":"irYIY","6845a7aec2d16d80":"lNHh9"}],"6lqbI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("8bf946811345dd52");
const codegen_1 = require("94acb9afd0a38d");
const names_1 = require("12d5afb68c79d933");
const util_1 = require("431cae49e29b7ef5");
const error = {
    message: "must NOT have additional properties",
    params: ({ params })=>(0, codegen_1._)`{additionalProperty: ${params.additionalProperty}}`
};
const def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, schema, parentSchema, data, errsCount, it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors, opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, util_1.alwaysValidSchema)(it, schema)) return;
        const props = (0, code_1.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, code_1.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, codegen_1._)`${errsCount} === ${names_1.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, util_1.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, code_1.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, codegen_1.or)(...props.map((p)=>(0, codegen_1._)`${key} === ${p}`));
            else definedProp = codegen_1.nil;
            if (patProps.length) definedProp = (0, codegen_1.or)(definedProp, ...patProps.map((p)=>(0, codegen_1._)`${(0, code_1.usePattern)(cxt, p)}.test(${key})`));
            return (0, codegen_1.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, codegen_1._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, codegen_1.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, codegen_1.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: util_1.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
exports.default = def;

},{"8bf946811345dd52":"451JO","94acb9afd0a38d":"irYIY","12d5afb68c79d933":"80kJL","431cae49e29b7ef5":"lNHh9"}],"aZcGU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const validate_1 = require("ab627bdec169a4e1");
const code_1 = require("275f1f775c313f6b");
const util_1 = require("e244aaf97f728bb4");
const additionalProperties_1 = require("feedf7db6cffec15");
const def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
        const allProps = (0, code_1.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = util_1.mergeEvaluated.props(gen, (0, util_1.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, util_1.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
exports.default = def;

},{"ab627bdec169a4e1":"bkVpi","275f1f775c313f6b":"451JO","e244aaf97f728bb4":"lNHh9","feedf7db6cffec15":"6lqbI"}],"d49Zu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("f8f8e6b0407fdd9d");
const codegen_1 = require("1b967c2cac1b0609");
const util_1 = require("7cbde610b4fe826");
const util_2 = require("7cbde610b4fe826");
const def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen, schema, data, parentSchema, it } = cxt;
        const { opts } = it;
        const patterns = (0, code_1.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, util_1.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof codegen_1.Name)) it.props = (0, util_2.evaluatedPropsToName)(gen, it.props);
        const { props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, util_1.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, codegen_1._)`${(0, code_1.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: util_2.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, codegen_1._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, codegen_1.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
exports.default = def;

},{"f8f8e6b0407fdd9d":"451JO","1b967c2cac1b0609":"irYIY","7cbde610b4fe826":"lNHh9"}],"jLjLp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const util_1 = require("321d2980c88a2039");
const def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen, schema, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
exports.default = def;

},{"321d2980c88a2039":"lNHh9"}],"8w9Ei":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const code_1 = require("5ca71c3dd49a479d");
const def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: code_1.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
exports.default = def;

},{"5ca71c3dd49a479d":"451JO"}],"bKSlU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("a652e853645ba701");
const util_1 = require("29f5768d6c5f5eed");
const error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params })=>(0, codegen_1._)`{passingSchemas: ${params.passing}}`
};
const def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, schema, parentSchema, it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, util_1.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, codegen_1._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, codegen_1._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, codegen_1.Name);
                });
            });
        }
    }
};
exports.default = def;

},{"a652e853645ba701":"irYIY","29f5768d6c5f5eed":"lNHh9"}],"eBhcX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const util_1 = require("4e4e6d6b236c3461");
const def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen, schema, it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, util_1.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
exports.default = def;

},{"4e4e6d6b236c3461":"lNHh9"}],"bs0mB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("1f1df645617c98a4");
const util_1 = require("389e0a8c918cc15");
const error = {
    message: ({ params })=>(0, codegen_1.str)`must match "${params.ifClause}" schema`,
    params: ({ params })=>(0, codegen_1._)`{failingKeyword: ${params.ifClause}}`
};
const def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error,
    code (cxt) {
        const { gen, parentSchema, it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, util_1.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = hasSchema(it, "then");
        const hasElse = hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, codegen_1.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, codegen_1._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, util_1.alwaysValidSchema)(it, schema);
}
exports.default = def;

},{"1f1df645617c98a4":"irYIY","389e0a8c918cc15":"lNHh9"}],"aeEXL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const util_1 = require("52fed7dcddf6df58");
const def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword, parentSchema, it }) {
        if (parentSchema.if === undefined) (0, util_1.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
exports.default = def;

},{"52fed7dcddf6df58":"lNHh9"}],"ftzg8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const format_1 = require("2deff6405afcac83");
const format = [
    format_1.default
];
exports.default = format;

},{"2deff6405afcac83":"gVsfN"}],"gVsfN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("a382a355cf5a78c5");
const error = {
    message: ({ schemaCode })=>(0, codegen_1.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode })=>(0, codegen_1._)`{format: ${schemaCode}}`
};
const def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error,
    code (cxt, ruleType) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        const { opts, errSchemaPath, schemaEnv, self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, codegen_1._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, codegen_1._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, codegen_1._)`${fDef}.type || "string"`).assign(format, (0, codegen_1._)`${fDef}.validate`), ()=>gen.assign(fType, (0, codegen_1._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, codegen_1.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return codegen_1.nil;
                return (0, codegen_1._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, codegen_1._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, codegen_1._)`${format}(${data})`;
                const validData = (0, codegen_1._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, codegen_1._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, codegen_1.regexpCode)(fmtDef) : opts.code.formats ? (0, codegen_1._)`${opts.code.formats}${(0, codegen_1.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, codegen_1._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, codegen_1._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, codegen_1._)`${fmtRef}(${data})` : (0, codegen_1._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
exports.default = def;

},{"a382a355cf5a78c5":"irYIY"}],"lWsPQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contentVocabulary = exports.metadataVocabulary = void 0;
exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

},{}],"heR94":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const codegen_1 = require("8118642cff1383ec");
const types_1 = require("ed348f6ae981731b");
const compile_1 = require("19cbb21371b9e8ba");
const ref_error_1 = require("19e9c6e270af4b01");
const util_1 = require("bbc8b0a18b75a1fa");
const error = {
    message: ({ params: { discrError, tagName } })=>discrError === types_1.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError, tag, tagName } })=>(0, codegen_1._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error,
    code (cxt) {
        const { gen, data, schema, parentSchema, it } = cxt;
        const { oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(tagName)}`);
        gen.if((0, codegen_1._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: types_1.DiscrError.Tag,
                tag,
                tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, codegen_1._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: types_1.DiscrError.Mapping,
                tag,
                tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, codegen_1.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = compile_1.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof compile_1.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new ref_error_1.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
exports.default = def;

},{"8118642cff1383ec":"irYIY","ed348f6ae981731b":"4mTOq","19cbb21371b9e8ba":"gmEgM","19e9c6e270af4b01":"4SpuV","bbc8b0a18b75a1fa":"lNHh9"}],"4mTOq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscrError = void 0;
var DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})(DiscrError || (exports.DiscrError = DiscrError = {}));

},{}],"3MLBr":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

},{}],"lVPyz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const formats_1 = require("8e45a5020f87f10");
const limit_1 = require("986e4a17998057f7");
const codegen_1 = require("6f742ec7ce55ffb3");
const fullName = new codegen_1.Name("fullFormats");
const fastName = new codegen_1.Name("fastFormats");
const formatsPlugin = (ajv, opts = {
    keywords: true
})=>{
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, formats_1.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [
        formats_1.fastFormats,
        fastName
    ] : [
        formats_1.fullFormats,
        fullName
    ];
    const list = opts.formats || formats_1.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) (0, limit_1.default)(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full")=>{
    const formats = mode === "fast" ? formats_1.fastFormats : formats_1.fullFormats;
    const f = formats[name];
    if (!f) throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = (0, codegen_1._)`require("ajv-formats/dist/formats").${exportName}`;
    for (const f of list)ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

},{"8e45a5020f87f10":"1o5CS","986e4a17998057f7":"an4GN","6f742ec7ce55ffb3":"irYIY"}],"1o5CS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
function fmtDef(validate, compare) {
    return {
        validate,
        compare
    };
}
exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: fmtDef(date, compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: fmtDef(getTime(true), compareTime),
    "date-time": fmtDef(getDateTime(true), compareDateTime),
    "iso-time": fmtDef(getTime(), compareIsoTime),
    "iso-date-time": fmtDef(getDateTime(), compareIsoDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
exports.fastFormats = {
    ...exports.fullFormats,
    date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
    time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareTime),
    "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\dt(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
    "iso-time": fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoTime),
    "iso-date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
};
exports.formatNames = Object.keys(exports.fullFormats);
function isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = DATE.exec(str);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]);
}
function compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
const TIME = /^(\d\d):(\d\d):(\d\d(?:\.\d+)?)(z|([+-])(\d\d)(?::?(\d\d))?)?$/i;
function getTime(strictTimeZone) {
    return function time(str) {
        const matches = TIME.exec(str);
        if (!matches) return false;
        const hr = +matches[1];
        const min = +matches[2];
        const sec = +matches[3];
        const tz = matches[4];
        const tzSign = matches[5] === "-" ? -1 : 1;
        const tzH = +(matches[6] || 0);
        const tzM = +(matches[7] || 0);
        if (tzH > 23 || tzM > 59 || strictTimeZone && !tz) return false;
        if (hr <= 23 && min <= 59 && sec < 60) return true;
        // leap second
        const utcMin = min - tzM * tzSign;
        const utcHr = hr - tzH * tzSign - (utcMin < 0 ? 1 : 0);
        return (utcHr === 23 || utcHr === -1) && (utcMin === 59 || utcMin === -1) && sec < 61;
    };
}
function compareTime(s1, s2) {
    if (!(s1 && s2)) return undefined;
    const t1 = new Date("2020-01-01T" + s1).valueOf();
    const t2 = new Date("2020-01-01T" + s2).valueOf();
    if (!(t1 && t2)) return undefined;
    return t1 - t2;
}
function compareIsoTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    const a1 = TIME.exec(t1);
    const a2 = TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3];
    t2 = a2[1] + a2[2] + a2[3];
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
const DATE_TIME_SEPARATOR = /t|\s/i;
function getDateTime(strictTimeZone) {
    const time = getTime(strictTimeZone);
    return function date_time(str) {
        // http://tools.ietf.org/html/rfc3339#section-5.6
        const dateTime = str.split(DATE_TIME_SEPARATOR);
        return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1]);
    };
}
function compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const d1 = new Date(dt1).valueOf();
    const d2 = new Date(dt2).valueOf();
    if (!(d1 && d2)) return undefined;
    return d1 - d2;
}
function compareIsoDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
    const res = compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || compareTime(t1, t2);
}
const NOT_URI_FRAGMENT = /\/|:/;
const URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}
const BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function byte(str) {
    BYTE.lastIndex = 0;
    return BYTE.test(str);
}
const MIN_INT32 = -(2 ** 31);
const MAX_INT32 = 2 ** 31 - 1;
function validateInt32(value) {
    return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
}
function validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function validateNumber() {
    return true;
}
const Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
    if (Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

},{}],"an4GN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatLimitDefinition = void 0;
const ajv_1 = require("edcb7aada7165da4");
const codegen_1 = require("88bf256dbec21ab0");
const ops = codegen_1.operators;
const KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: ops.LTE,
        fail: ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: ops.GTE,
        fail: ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: ops.LT,
        fail: ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: ops.GT,
        fail: ops.LTE
    }
};
const error = {
    message: ({ keyword, schemaCode })=>(0, codegen_1.str)`should be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode })=>(0, codegen_1._)`{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
exports.formatLimitDefinition = {
    keyword: Object.keys(KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code (cxt) {
        const { gen, data, schemaCode, keyword, it } = cxt;
        const { opts, self } = it;
        if (!opts.validateFormats) return;
        const fCxt = new ajv_1.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fmt = gen.const("fmt", (0, codegen_1._)`${fmts}[${fCxt.schemaCode}]`);
            cxt.fail$data((0, codegen_1.or)((0, codegen_1._)`typeof ${fmt} != "object"`, (0, codegen_1._)`${fmt} instanceof RegExp`, (0, codegen_1._)`typeof ${fmt}.compare != "function"`, compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? (0, codegen_1._)`${opts.code.formats}${(0, codegen_1.getProperty)(format)}` : undefined
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return (0, codegen_1._)`${fmt}.compare(${data}, ${schemaCode}) ${KWDs[keyword].fail} 0`;
        }
    },
    dependencies: [
        "format"
    ]
};
const formatLimitPlugin = (ajv)=>{
    ajv.addKeyword(exports.formatLimitDefinition);
    return ajv;
};
exports.default = formatLimitPlugin;

},{"edcb7aada7165da4":"b8fK1","88bf256dbec21ab0":"irYIY"}],"8tpkM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-06/schema#\",\"$id\":\"http://json-schema.org/draft-06/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"examples\":{\"type\":\"array\",\"items\":{}},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":{},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":{}}");

},{}]},["5DEId"], "5DEId", "parcelRequire42f0")

//# sourceMappingURL=editor.fd21efd0.js.map
